// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"imJAt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _suppressDevWarnings = require("./suppressDevWarnings");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactGa = require("react-ga");
var _reactGaDefault = parcelHelpers.interopDefault(_reactGa);
var _reduxBundlerReact = require("redux-bundler-react");
var _client = require("react-dom/client");
var _reduxBundler = require("redux-bundler");
var _moneyClip = require("money-clip");
var _reactDebounceInput = require("react-debounce-input");
var _reactBootstrap = require("react-bootstrap");
var _fi = require("react-icons/fi");
var _bootstrapMinCss = require("bootstrap/dist/css/bootstrap.min.css");
var _grameneSearch = require("gramene-search");
var _siteTour = require("./tour/SiteTour");
var _staticPage = require("./StaticPage");
var _feedback = require("./Feedback");
var _feedbackDefault = parcelHelpers.interopDefault(_feedback);
var _welcome = require("./Welcome");
var _welcomeDefault = parcelHelpers.interopDefault(_welcome);
var _portals = require("./Portals");
var _staticSocialButtons = require("./StaticSocialButtons");
var _staticSocialButtonsDefault = parcelHelpers.interopDefault(_staticSocialButtons);
var _helpModal = require("./HelpModal");
var _helpModalDefault = parcelHelpers.interopDefault(_helpModal);
var _conf = require("../conf");
var _confDefault = parcelHelpers.interopDefault(_conf);
var _uibundle = require("./bundles/UIbundle");
var _uibundleDefault = parcelHelpers.interopDefault(_uibundle);
var _drupal = require("./bundles/Drupal");
var _drupalDefault = parcelHelpers.interopDefault(_drupal);
var _news = require("./bundles/news");
var _newsDefault = parcelHelpers.interopDefault(_news);
var _news1 = require("./News");
var _reactRouterDom = require("react-router-dom");
var _grameneGithubdocs = require("gramene-githubdocs");
var _grameneGithubdocsDefault = parcelHelpers.interopDefault(_grameneGithubdocs);
var _italicizeOryza = require("./italicizeOryza");
var _italicizeOryzaDefault = parcelHelpers.interopDefault(_italicizeOryza);
var _grameneAlerts = require("gramene-alerts");
var _grameneAlertsDefault = parcelHelpers.interopDefault(_grameneAlerts);
var _lodash = require("lodash");
var _oryza19KThemeLess = require("../styles/oryza19k-theme.less");
const subsite = "oryza";
const baseURL = `/`;
// Root for static assets referenced from components. A bare relative path
// ("static/...") breaks on nested routes such as /post/:slug.
const assetBase = baseURL.endsWith('/') ? baseURL : `${baseURL}/`;
// Builds that opt in (oryza19k) split the landing page: "/" is a site-specific
// home, while the generic Gramene portals + gene search move to "/gramene".
// Every other subsite keeps the original combined home at "/".
const splitHome = (0, _confDefault.default).find((s)=>s.id === subsite)?.splitHome === true;
// Selectable colour palettes for the dark oryza19k theme. The active palette is
// persisted in localStorage and applied by ThemedRoot via a `palette-<id>`
// class; the matching CSS variable overrides live in styles/oryza19k-theme.less.
const PALETTES = [
    {
        id: 'paddy',
        label: 'Rice Paddy',
        swatch: '#3f6b2e'
    },
    {
        id: 'midnight',
        label: 'Midnight Blue',
        swatch: '#2f5e94'
    },
    {
        id: 'terracotta',
        label: 'Terracotta',
        swatch: '#b3502a'
    },
    {
        id: 'plum',
        label: 'Plum',
        swatch: '#6a4fb0'
    },
    {
        id: 'slate',
        label: 'Slate',
        swatch: '#2f8f7f'
    }
];
const PALETTE_KEY = 'oryza19k-palette';
const MODE_KEY = 'oryza19k-mode';
const PaletteContext = /*#__PURE__*/ (0, _reactDefault.default).createContext({
    palette: 'paddy',
    setPalette: ()=>{},
    mode: 'dark',
    setMode: ()=>{}
});
const PaletteProvider = ({ children })=>{
    const [palette, setPaletteState] = (0, _reactDefault.default).useState(()=>{
        try {
            return localStorage.getItem(PALETTE_KEY) || 'paddy';
        } catch (e) {
            return 'paddy';
        }
    });
    const [mode, setModeState] = (0, _reactDefault.default).useState(()=>{
        try {
            return localStorage.getItem(MODE_KEY) || 'dark';
        } catch (e) {
            return 'dark';
        }
    });
    const setPalette = (p)=>{
        setPaletteState(p);
        try {
            localStorage.setItem(PALETTE_KEY, p);
        } catch (e) {}
    };
    const setMode = (m)=>{
        setModeState(m);
        try {
            localStorage.setItem(MODE_KEY, m);
        } catch (e) {}
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaletteContext.Provider, {
        value: {
            palette,
            setPalette,
            mode,
            setMode
        },
        children: children
    });
};
// Theme/palette picker for the navbar (top right of the dark oryza19k pages).
const ThemeSelector = ()=>{
    const { palette, setPalette, mode, setMode } = (0, _reactDefault.default).useContext(PaletteContext);
    const current = PALETTES.find((p)=>p.id === palette) || PALETTES[0];
    const swatch = (color)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: "oryza19k-swatch",
            style: {
                backgroundColor: color
            }
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Nav), {
        className: "ms-auto oryza19k-theme-selector align-items-center",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "button",
                className: `o19-mode-switch o19-mode-${mode}`,
                role: "switch",
                "aria-checked": mode === 'dark',
                "aria-label": "Toggle light or dark mode",
                title: mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode',
                onClick: ()=>setMode(mode === 'dark' ? 'light' : 'dark'),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "o19-mode-knob",
                    children: mode === 'dark' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fi.FiMoon), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fi.FiSun), {})
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.NavDropdown), {
                id: "palette-dropdown",
                align: "end",
                title: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        swatch(current.swatch),
                        "Theme"
                    ]
                }),
                children: PALETTES.map((p)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.NavDropdown).Item, {
                        active: p.id === palette,
                        onClick: ()=>setPalette(p.id),
                        children: [
                            swatch(p.swatch),
                            p.label
                        ]
                    }, p.id))
            })
        ]
    });
};
const panSiteIdx = (0, _lodash.keyBy)((0, _confDefault.default), 'id');
const initialState = Object.assign({
    helpIsOn: false,
    linkSet: 'Portals'
}, panSiteIdx[subsite]);
const cache = (0, _moneyClip.getConfiguredCache)({
    maxAge: 360000,
    version: `${initialState.id}_${initialState.version}`
});
const config = {
    name: 'config',
    getReducer: ()=>{
        return (state = initialState, { type, payload })=>{
            let newState;
            switch(type){
                case 'GRAMENE_HELP_TOGGLED':
                    newState = Object.assign({}, state);
                    newState.helpIsOn = !newState.helpIsOn;
                    return newState;
                default:
                    return state;
            }
        };
    },
    doToggleGrameneHelp: ()=>({ dispatch })=>{
            dispatch({
                type: 'GRAMENE_HELP_TOGGLED',
                payload: null
            });
        },
    selectGrameneAPI: (state)=>state.config.grameneData,
    selectEnsemblAPI: (state)=>state.config.ensemblRest,
    selectTargetTaxonId: (state)=>state.config.targetTaxonId,
    selectCuration: (state)=>state.config.curation,
    selectConfiguration: (state)=>state.config
};
const getStore = (0, _reduxBundler.composeBundles)(...(0, _grameneSearch.bundles), ...(0, _drupalDefault.default), ...(0, _newsDefault.default), (0, _uibundleDefault.default), config, (0, _reduxBundler.createCacheBundle)(cache.set));
const AlertCmp = ({ configuration })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "col-md-12 no-padding",
        children: !configuration.hideAlerts && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _grameneAlertsDefault.default), {
            org: "warelab",
            repo: "release-notes",
            path: "alerts",
            site: configuration.id
        })
    });
const Alerter = (0, _reduxBundlerReact.connect)('selectConfiguration', AlertCmp);
const SearchViewsCmp = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "no-margin no-padding search-views-layout",
        style: {
            backgroundColor: "#fff"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "gramene-sidebar",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _grameneSearch.Status), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _grameneSearch.Filters), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _grameneSearch.Facets), {}),
                    props.configuration.showViews && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _grameneSearch.Views), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _grameneSearch.Auth), {})
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "search-views-content",
                style: {
                    paddingBottom: '100px'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _grameneSearch.Results), {})
            })
        ]
    });
const SearchViews = (0, _reduxBundlerReact.connect)('selectConfiguration', SearchViewsCmp);
// Default combined home ("/") for non-split builds: search results when a
// query is active, otherwise the full Welcome (banner + portals + examples).
const MainViewCmp = (props)=>{
    return props.grameneFilters.rightIdx > 1 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(SearchViews, {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _welcomeDefault.default), {});
};
const MainView = (0, _reduxBundlerReact.connect)('selectGrameneFilters', MainViewCmp);
// Home ("/"): oryza19k-specific landing only (hero + at a glance + examples).
const OryzaHome = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _welcomeDefault.default), {
        mode: "home"
    });
// Gramene portal sub-pages (/pansites, /videotutorials) on a split build: render
// just the portal content (no oryza hero), under the light Gramene theme.
const PortalsSubPage = ({ location })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _welcomeDefault.default), {
        mode: "gramene",
        location: location
    });
// "/gramene": the generic Gramene portals + gene search. Shows search results
// once a query is active, otherwise the portals grid. Rendered on a light theme.
const GrameneMainCmp = (props)=>props.grameneFilters.rightIdx > 1 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(SearchViews, {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _welcomeDefault.default), {
        mode: "gramene",
        location: props.location
    });
const GrameneMain = (0, _reduxBundlerReact.connect)('selectGrameneFilters', GrameneMainCmp);
const handleKey = (e, props)=>{
    if (e.key === "Escape") props.doClearSuggestions();
    if (e.key === "Tab") {
        if (props.grameneSuggestionsReady) {
            e.preventDefault();
            document.getElementById('0-0').focus();
        }
    }
};
const SearchBarCmp = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.InputGroup), {
                size: "sm",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDebounceInput.DebounceInput), {
                        minLength: 0,
                        debounceTimeout: 300,
                        onChange: (e)=>props.doChangeSuggestionsQuery(e.target.value),
                        onKeyDown: (e)=>handleKey(e, props),
                        // onKeyUp={e => handleKey(e.key,props)}
                        className: "form-control",
                        value: props.suggestionsQuery || '',
                        placeholder: "Search for genes by id, name, pathway, domain, etc.",
                        id: "search-input",
                        autoComplete: "off",
                        spellCheck: "false",
                        style: {
                            borderBottomRightRadius: 0,
                            borderTopRightRadius: 0
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Button), {
                        size: "sm",
                        variant: "success",
                        style: {
                            borderBottomLeftRadius: 0,
                            borderTopLeftRadius: 0
                        },
                        onClick: props.doToggleGrameneHelp,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                            children: "?"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _helpModalDefault.default), {})
        ]
    });
const SearchBar = (0, _reduxBundlerReact.connect)('selectSuggestionsQuery', 'doChangeSuggestionsQuery', 'doClearSuggestions', 'doToggleGrameneHelp', 'selectGrameneSuggestionsReady', SearchBarCmp);
const SuggestionsCmp = (props)=>props.suggestionsQuery && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "search-suggestions",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _grameneSearch.suggestions), {})
    });
const Suggestions = (0, _reduxBundlerReact.connect)('selectSuggestionsQuery', 'selectGrameneSuggestionsStatus', SuggestionsCmp);
const SearchMenu = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        id: "searchbar-parent",
        className: "navbar-search",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            id: "searchbar",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SearchBar, {})
        })
    });
const NewsCmp = ({ configuration })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _grameneGithubdocsDefault.default), {
        org: "warelab",
        repo: "release-notes",
        path: subsite,
        heading: "News",
        sort: "date",
        date: configuration.date,
        offset: 160
    });
const News = (0, _reduxBundlerReact.connect)('selectConfiguration', NewsCmp);
const GenomesCmp = ({ configuration })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: {
            paddingBottom: '100px'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _grameneGithubdocsDefault.default), {
            org: "warelab",
            repo: "release-notes",
            path: subsite + '-genomes',
            heading: "Genomes",
            sort: "date",
            date: configuration.date
        })
    });
const Genomes = (0, _reduxBundlerReact.connect)('selectConfiguration', GenomesCmp);
const GuidesCmp = ({ configuration })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: {
            paddingBottom: '100px'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _grameneGithubdocsDefault.default), {
            org: "warelab",
            repo: "release-notes",
            path: subsite + '-guides',
            heading: "Guides",
            sort: "date",
            ifEmpty: "A user guide is being developed.",
            date: configuration.date
        })
    });
const Guides = (0, _reduxBundlerReact.connect)('selectConfiguration', GuidesCmp);
// Config-driven sections (e.g. oryza19k's Start here / Platforms / Workflows /
// API / Resources / Cite). Each `sections` entry { label, route, path, repo? }
// is served from a GitHub repo dir via GithubDocs; subdirectories become nav
// levels. Returns a route component for the given section.
const SectionDocs = (section)=>({ location })=>{
        const doc = new URLSearchParams(location && location.search || '').get('doc') || undefined;
        // Expandable sections (e.g. Platforms) are navigated from the navbar's inline
        // links (see SectionMenu), so the GithubDocs sidebar is redundant — render
        // just the selected document with no navigation chrome.
        if (section.expand) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ExpandedSectionDoc, {
            section: section,
            doc: doc
        });
        // Other sections keep the full tree+sidebar browser. Feed the router's ?doc=
        // through so deep links resolve even though react-router keeps this component
        // mounted across query-only changes.
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            style: {
                paddingBottom: '100px'
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _grameneGithubdocsDefault.default), {
                org: "warelab",
                repo: section.repo || 'oryza-19k-rgp',
                path: section.path,
                branch: "main",
                heading: section.label,
                offset: 160,
                doc: doc,
                ifEmpty: `${section.label} content is coming soon.`
            })
        });
    };
// Single-document view for an expandable section: shows the doc named by ?doc=,
// or the first top-level doc by default. Navigation lives in the navbar
// (SectionMenu), so there's no sidebar.
const ExpandedSectionDoc = ({ section, doc })=>{
    const docs = (0, _grameneGithubdocs.useGithubDocList)({
        org: 'warelab',
        repo: section.repo || 'oryza-19k-rgp',
        path: section.path,
        branch: 'main'
    });
    const path = doc || docs[0] && docs[0].fullPath;
    if (!path) return null; // tree not loaded yet
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: {
            paddingBottom: '100px'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _grameneGithubdocs.GithubDoc), {
            org: "warelab",
            repo: section.repo || 'oryza-19k-rgp',
            path: path,
            branch: "main",
            showTitle: true,
            toc: true,
            offset: 100,
            renderTitle: (0, _italicizeOryzaDefault.default)
        })
    });
};
// A navbar section. When the section config has `expand: true`, the label is a
// dropdown toggle ("Platforms") whose menu links to each top-level doc under the
// section's repo path (SNP-Seek v3, GrameneOryza, Oryza CLIMtools, …).
const ExpandedSectionMenu = ({ section })=>{
    const docs = (0, _grameneGithubdocs.useGithubDocList)({
        org: 'warelab',
        repo: section.repo || 'oryza-19k-rgp',
        path: section.path,
        branch: 'main'
    });
    // Not loaded yet (or empty): fall back to a plain link to the section.
    if (docs.length === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
        className: "nav-link",
        to: section.route,
        children: section.label
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.NavDropdown), {
        id: `section-dropdown-${section.route}`,
        title: section.label,
        className: "gramene-section-dropdown",
        children: docs.map((d)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.NavDropdown).Item, {
                as: (0, _reactRouterDom.NavLink),
                to: `${section.route}?doc=${encodeURIComponent(d.fullPath)}`,
                children: (0, _italicizeOryzaDefault.default)(d.title || d.label)
            }, d.fullPath))
    });
};
const SectionMenu = ({ section })=>section.expand ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ExpandedSectionMenu, {
        section: section
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
        className: "nav-link",
        to: section.route,
        children: section.label
    });
// The oryza19k-branded pages (dark theme, "ORYZA 19K-RGP" brand, palette picker,
// no footer): just the home, cite and platforms pages. Every other route on a
// split build is a generic Gramene page (light theme, Gramene logo, footer).
const oryzaRoutes = [
    '/',
    '/cite',
    '/platforms'
];
const isOryzaRoute = (pathname)=>oryzaRoutes.some((r)=>pathname === r || r !== '/' && pathname.startsWith(r + '/'));
const GrameneMenuCmp = ({ configuration })=>{
    const oryzaRoute = isOryzaRoute((0, _reactRouterDom.useLocation)().pathname);
    // oryza19k pages drop the "Gramene" wordmark and show only the site sub-brand
    // ("ORYZA 19K-RGP"); the Gramene pages keep the full Gramene Oryza logo.
    const useSubBrand = configuration.brand && oryzaRoute;
    // On the Gramene pages of a split build, the navbar drops the oryza sections
    // (Platforms / Cite) and instead offers a link back to the oryza19k homepage.
    const gramenePage = splitHome && !oryzaRoute;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Navbar), {
        bg: "light",
        expand: "lg",
        sticky: "top",
        className: "gramene-navbar-outer",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            style: {
                width: '100%',
                borderBottomColor: '#c7c7c7',
                borderBottomStyle: 'solid',
                marginLeft: '15px',
                marginRight: '15px'
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Navbar), {
                className: "gramene-navbar",
                bg: "light",
                expand: "lg",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Navbar).Brand, {
                        className: "gramene-navbar",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: gramenePage ? "/gramene" : "/",
                            children: useSubBrand ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "oryza19k-brand oryza19k-brand--solo",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "oryza19k-brand-sub",
                                    children: (0, _italicizeOryzaDefault.default)(configuration.brand.sub)
                                })
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                src: configuration.logo || `${assetBase}static/images/${subsite}_logo.svg`,
                                height: 80
                            })
                        })
                    }),
                    splitHome ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Switch), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                path: "/gramene",
                                component: SearchMenu
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                render: ()=>null
                            })
                        ]
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Switch), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                exact: true,
                                path: "/",
                                component: SearchMenu
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                                    className: "nav-link",
                                    to: "/",
                                    children: "Home"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Navbar).Toggle, {
                        "aria-controls": "basic-navbar-nav"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Navbar).Collapse, {
                        id: "basic-navbar-nav",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Nav), {
                                className: "mr-auto",
                                children: gramenePage ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                                    className: "nav-link gramene-back-link",
                                    to: "/",
                                    children: (0, _italicizeOryzaDefault.default)('Oryza 19K-RGP')
                                }) : configuration.sections ? configuration.sections.map((s, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(SectionMenu, {
                                        section: s
                                    }, i)) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Nav).Link, {
                                            href: initialState.ensemblSite,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    style: {
                                                        height: '25px',
                                                        verticalAlign: 'bottom'
                                                    },
                                                    src: `${assetBase}static/images/e_bang.png`,
                                                    alt: "ensembl"
                                                }),
                                                "Genome browser"
                                            ]
                                        }),
                                        configuration.showNews && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                                            className: "nav-link",
                                            to: "/news",
                                            children: "News"
                                        }),
                                        configuration.showGuides && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                                            className: "nav-link",
                                            to: "/guides",
                                            children: "Guides"
                                        }),
                                        configuration.tour && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                                            className: "nav-link",
                                            to: "/tour",
                                            children: "Tour"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                                            className: "nav-link",
                                            to: ()=>({
                                                    pathname: '/feedback',
                                                    state: {
                                                        search: document.location.href
                                                    }
                                                }),
                                            children: "Feedback"
                                        })
                                    ]
                                })
                            }),
                            splitHome && oryzaRoute && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ThemeSelector, {})
                        ]
                    })
                ]
            })
        })
    });
};
const GrameneMenu = (0, _reduxBundlerReact.connect)('selectConfiguration', GrameneMenuCmp);
const Footer = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Navbar), {
        fixed: "bottom",
        bg: "light",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            style: {
                width: "100%",
                borderTopColor: "#c7c7c7",
                borderTopStyle: "solid"
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Navbar), {
                bg: "light",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Nav), {
                        className: "mr-auto",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                                className: "nav-link",
                                to: "/cite",
                                children: "Cite"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _portals.PortalsDropdown), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.NavDropdown), {
                                id: "gramene-sites",
                                title: "Gramene Sites",
                                className: "dropup",
                                children: (0, _confDefault.default).filter((site)=>site.id !== subsite && site.showInMenu).map((site, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.NavDropdown).Item, {
                                        href: site.url,
                                        children: site.name
                                    }, idx))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _staticSocialButtonsDefault.default), {})
                ]
            })
        })
    });
// The footer is generic Gramene content, so on a split build it appears only on
// the Gramene pages (/gramene, /pansites, /videotutorials) and is hidden on the
// oryza19k-branded pages.
const RoutedFooter = ()=>{
    const oryzaRoute = isOryzaRoute((0, _reactRouterDom.useLocation)().pathname);
    if (splitHome && oryzaRoute) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Footer, {});
};
// Applies the dark oryza19k theme on the oryza routes (/, /cite, /platforms) and
// the light Gramene styling everywhere else. Only active on themed builds.
const ThemedRoot = ({ children })=>{
    const oryzaRoute = isOryzaRoute((0, _reactRouterDom.useLocation)().pathname);
    const { palette, mode } = (0, _reactDefault.default).useContext(PaletteContext);
    if (initialState.theme === 'dark') {
        const oryzaClass = `oryza19k-theme palette-${palette}${mode === 'light' ? ' mode-light' : ''}`;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: oryzaRoute ? oryzaClass : 'oryza19k-light',
            children: children
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: children
    });
};
const Gramene = (store)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reduxBundlerReact.Provider), {
        store: store,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaletteProvider, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.BrowserRouter), {
                basename: baseURL,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ThemedRoot, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(GrameneMenu, {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(Alerter, {}),
                        splitHome ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "/gramene",
                            component: Suggestions
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            exact: true,
                            path: "/",
                            component: Suggestions
                        }),
                        splitHome ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "/gramene",
                            component: (0, _siteTour.SiteTour)
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            exact: true,
                            path: "/",
                            component: (0, _siteTour.SiteTour)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Switch), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                    path: "/feedback",
                                    component: (0, _feedbackDefault.default)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                    path: "/news",
                                    component: News
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                    path: "/guides",
                                    component: Guides
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                    path: "/tour",
                                    component: (0, _siteTour.TourPage)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                    path: "/posts",
                                    component: (0, _news1.PostsPage)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                    path: "/post/:slug",
                                    component: (0, _news1.PostPage)
                                }),
                                (initialState.sections || []).map((s, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                        path: s.route,
                                        component: SectionDocs(s)
                                    }, i)),
                                splitHome && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                    path: "/gramene",
                                    component: GrameneMain
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                    path: "/pansites",
                                    component: splitHome ? PortalsSubPage : (0, _welcomeDefault.default)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                    path: "/node/:nid",
                                    component: (0, _welcomeDefault.default)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                    path: "/videotutorials",
                                    component: splitHome ? PortalsSubPage : (0, _welcomeDefault.default)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                    path: `/:page(${(0, _staticPage.STATIC_PAGES).join('|')})`,
                                    component: (0, _staticPage.StaticPage)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                    path: "/:stub",
                                    component: (0, _welcomeDefault.default)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                    path: "/",
                                    component: splitHome ? OryzaHome : MainView
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(RoutedFooter, {})
                    ]
                })
            })
        })
    });
cache.getAll().then((initialData)=>{
    if (initialData) {
        if (initialData.hasOwnProperty('searchUI')) initialData.searchUI.suggestions_query = "";
        console.log('starting with locally cached data:', initialData);
    }
    const store = getStore(initialData);
    const config = store.selectConfiguration();
    (0, _reactGaDefault.default).initialize(config.ga);
    if (initialData.hasOwnProperty('grameneMaps')) {
        // check for hidden genomes
        let notHidden = {};
        let haveHidden = false;
        Object.values(initialData.grameneMaps.data).forEach((m)=>{
            if (m.hidden) haveHidden = true;
            else notHidden[m.taxon_id] = true;
        });
        if (haveHidden) store.doInitializeGrameneGenomes(notHidden);
    }
    let element = document.getElementById('gramene');
    if (element) (0, _client.createRoot)(element).render(Gramene(store));
});

},{"react/jsx-runtime":"gonF6","./suppressDevWarnings":"cxT6S","react":"bmhQu","react-ga":"7Qfwj","redux-bundler-react":"a9QVF","react-dom/client":"5eZdG","redux-bundler":"4cGJa","money-clip":"gRAOl","react-debounce-input":"3RsD1","react-bootstrap":[["Button","6Xv8z","default"],["InputGroup","jdRoo","default"],["Nav","axkz0","default"],["Navbar","34dRz","default"],["NavDropdown","918Zj","default"]],"react-icons/fi":"1HOcO","bootstrap/dist/css/bootstrap.min.css":"gO6o5","gramene-search":"kFIFN","./tour/SiteTour":"ca4ti","./StaticPage":"7IP1z","./Feedback":"8Acrq","./Welcome":"5yEIG","./Portals":"59Mf9","./StaticSocialButtons":"i0Q7f","./HelpModal":"acnld","../conf":"fopA6","./bundles/UIbundle":"gZZGi","./bundles/Drupal":"kA5Lw","./bundles/news":"6LZXj","./News":"cLuD4","react-router-dom":[["BrowserRouter","b9X5n"],["NavLink","b9X5n"],["Route","ditZI"],["Switch","ditZI"],["useLocation","ditZI"]],"gramene-githubdocs":"lVWfx","./italicizeOryza":"d9LKy","gramene-alerts":"9Yy4g","lodash":"L2GyB","../styles/oryza19k-theme.less":"2wmgp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gonF6":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"84Frb"}],"84Frb":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var f = require("3fd2a064dc1f3641"), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: n.current
    };
}
exports.Fragment = l;
exports.jsx = q;
exports.jsxs = q;

},{"3fd2a064dc1f3641":"bmhQu"}],"bmhQu":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"7cX1V"}],"7cX1V":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
function A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = z && a[z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, C = Object.assign, D = {};
function E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
E.prototype.isReactComponent = {};
E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {}
F.prototype = E.prototype;
function G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
var H = G.prototype = new F;
H.constructor = G;
C(H, E.prototype);
H.isPureReactComponent = !0;
var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = {
    current: null
}, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: K.current
    };
}
function N(a, b) {
    return {
        $$typeof: l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === l;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g;
function Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case l:
                case n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
        return a;
    })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + Q(k, g);
        h += R(k, b, e, f, c);
    }
    else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var U = {
    current: null
}, V = {
    transition: null
}, W = {
    ReactCurrentDispatcher: U,
    ReactCurrentBatchConfig: V,
    ReactCurrentOwner: K
};
function X() {
    throw Error("act(...) is not supported in production builds of React.");
}
exports.Children = {
    map: S,
    forEach: function(a, b, e) {
        S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
exports.Component = E;
exports.Fragment = p;
exports.Profiler = r;
exports.PureComponent = G;
exports.StrictMode = q;
exports.Suspense = w;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
exports.act = X;
exports.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
exports.createContext = function(a) {
    a = {
        $$typeof: u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: t,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: v,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: T
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.startTransition = function(a) {
    var b = V.transition;
    V.transition = {};
    try {
        a();
    } finally{
        V.transition = b;
    }
};
exports.unstable_act = X;
exports.useCallback = function(a, b) {
    return U.current.useCallback(a, b);
};
exports.useContext = function(a) {
    return U.current.useContext(a);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(a) {
    return U.current.useDeferredValue(a);
};
exports.useEffect = function(a, b) {
    return U.current.useEffect(a, b);
};
exports.useId = function() {
    return U.current.useId();
};
exports.useImperativeHandle = function(a, b, e) {
    return U.current.useImperativeHandle(a, b, e);
};
exports.useInsertionEffect = function(a, b) {
    return U.current.useInsertionEffect(a, b);
};
exports.useLayoutEffect = function(a, b) {
    return U.current.useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return U.current.useMemo(a, b);
};
exports.useReducer = function(a, b, e) {
    return U.current.useReducer(a, b, e);
};
exports.useRef = function(a) {
    return U.current.useRef(a);
};
exports.useState = function(a) {
    return U.current.useState(a);
};
exports.useSyncExternalStore = function(a, b, e) {
    return U.current.useSyncExternalStore(a, b, e);
};
exports.useTransition = function() {
    return U.current.useTransition();
};
exports.version = "18.3.1";

},{}],"cxT6S":[function(require,module,exports,__globalThis) {
// Suppress known-benign console warnings from old deps that React 18 and
// Redux yell about. These are non-fatal but parcel's dev overlay
// (@parcel/error-overlay) treats every console.error as a runtime error
// and paints them as a fullscreen overlay, burying the app.
//
// Imported first in src/gramene.js so the patch is in place before redux
// or React renders the tree.
if (typeof console !== 'undefined' && typeof console.error === 'function') {
    const origError = console.error;
    const patterns = [
        'currently using minified code outside of NODE_ENV',
        'uses the legacy childContextTypes API',
        'uses the legacy contextTypes API',
        'findDOMNode is deprecated'
    ];
    console.error = function(...args) {
        const msg = typeof args[0] === 'string' ? args[0] : '';
        for(let i = 0; i < patterns.length; i++){
            if (msg.indexOf(patterns[i]) !== -1) return;
        }
        return origError.apply(this, args);
    };
}

},{}],"7Qfwj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialize", ()=>initialize);
parcelHelpers.export(exports, "addTrackers", ()=>addTrackers);
parcelHelpers.export(exports, "ga", ()=>ga);
parcelHelpers.export(exports, "set", ()=>set);
parcelHelpers.export(exports, "send", ()=>send);
parcelHelpers.export(exports, "pageview", ()=>pageview);
parcelHelpers.export(exports, "modalview", ()=>modalview);
parcelHelpers.export(exports, "timing", ()=>timing);
parcelHelpers.export(exports, "event", ()=>event);
parcelHelpers.export(exports, "exception", ()=>exception);
parcelHelpers.export(exports, "plugin", ()=>plugin);
parcelHelpers.export(exports, "outboundLink", ()=>outboundLink);
parcelHelpers.export(exports, "testModeAPI", ()=>testModeAPI);
parcelHelpers.export(exports, "OutboundLink", ()=>OutboundLink);
var _outboundLink = require("./components/OutboundLink");
var _outboundLinkDefault = parcelHelpers.interopDefault(_outboundLink);
var _core = require("./core");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var initialize = _core.initialize;
var addTrackers = _core.addTrackers;
var ga = _core.ga;
var set = _core.set;
var send = _core.send;
var pageview = _core.pageview;
var modalview = _core.modalview;
var timing = _core.timing;
var event = _core.event;
var exception = _core.exception;
var plugin = _core.plugin;
var outboundLink = _core.outboundLink;
var testModeAPI = _core.testModeAPI;
(0, _outboundLinkDefault.default).origTrackLink = (0, _outboundLinkDefault.default).trackLink;
(0, _outboundLinkDefault.default).trackLink = _core.outboundLink;
var OutboundLink = (0, _outboundLinkDefault.default);
exports.default = _objectSpread(_objectSpread({}, _core), {}, {
    OutboundLink: OutboundLink
});

},{"./components/OutboundLink":"b3VsK","./core":"9X1pW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b3VsK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>OutboundLink);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _warn = require("../utils/console/warn");
var _warnDefault = parcelHelpers.interopDefault(_warn);
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
var _excluded = [
    "to",
    "target"
];
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var NEWTAB = '_blank';
var MIDDLECLICK = 1;
var OutboundLink = /*#__PURE__*/ function(_Component) {
    _inherits(OutboundLink, _Component);
    var _super = _createSuper(OutboundLink);
    function OutboundLink() {
        var _this;
        _classCallCheck(this, OutboundLink);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "handleClick", function(event) {
            var _this$props = _this.props, target = _this$props.target, eventLabel = _this$props.eventLabel, to = _this$props.to, onClick = _this$props.onClick, trackerNames = _this$props.trackerNames;
            var eventMeta = {
                label: eventLabel
            };
            var sameTarget = target !== NEWTAB;
            var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);
            if (sameTarget && normalClick) {
                event.preventDefault();
                OutboundLink.trackLink(eventMeta, function() {
                    window.location.href = to;
                }, trackerNames);
            } else OutboundLink.trackLink(eventMeta, function() {}, trackerNames);
            if (onClick) onClick(event);
        });
        return _this;
    }
    _createClass(OutboundLink, [
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, href = _this$props2.to, target = _this$props2.target, oldProps = _objectWithoutProperties(_this$props2, _excluded);
                var props = _objectSpread(_objectSpread({}, oldProps), {}, {
                    target: target,
                    href: href,
                    onClick: this.handleClick
                });
                if (target === NEWTAB) props.rel = "".concat(props.rel ? props.rel : '', " noopener noreferrer").trim();
                delete props.eventLabel;
                delete props.trackerNames;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement('a', props);
            }
        }
    ]);
    return OutboundLink;
}((0, _react.Component));
_defineProperty(OutboundLink, "trackLink", function() {
    (0, _warnDefault.default)('ga tracking not enabled');
});
OutboundLink.propTypes = {
    eventLabel: (0, _propTypesDefault.default).string.isRequired,
    target: (0, _propTypesDefault.default).string,
    to: (0, _propTypesDefault.default).string,
    onClick: (0, _propTypesDefault.default).func,
    trackerNames: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)
};
OutboundLink.defaultProps = {
    target: null,
    to: null,
    onClick: null,
    trackerNames: null
};

},{"react":"bmhQu","prop-types":"gLXGb","../utils/console/warn":"g4GcL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gLXGb":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"cW0bY"}],"cW0bY":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"6JNoQ"}],"6JNoQ":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = ReactPropTypesSecret;

},{}],"g4GcL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>warn);
function warn(s) {
    console.warn('[react-ga]', s);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"91HVb":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"9X1pW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addTrackers", ()=>addTrackers);
parcelHelpers.export(exports, "initialize", ()=>initialize);
/**
 * ga:
 * Returns the original GA object.
 */ parcelHelpers.export(exports, "ga", ()=>ga);
/**
 * set:
 * GA tracker set method
 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */ parcelHelpers.export(exports, "set", ()=>set);
/**
 * send:
 * Clone of the low level `ga.send` method
 * WARNING: No validations will be applied to this
 * @param  {Object} fieldObject - field object for tracking different analytics
 * @param  {Array} trackerNames - trackers to send the command to
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */ parcelHelpers.export(exports, "send", ()=>send);
/**
 * pageview:
 * Basic GA pageview tracking
 * @param  {String} path - the current page page e.g. '/about'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 * @param {String} title - (optional) the page title e. g. 'My Website'
 */ parcelHelpers.export(exports, "pageview", ()=>pageview);
/**
 * modalview:
 * a proxy to basic GA pageview tracking to consistently track
 * modal views that are an equivalent UX to a traditional pageview
 * @param  {String} modalName e.g. 'add-or-edit-club'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */ parcelHelpers.export(exports, "modalview", ()=>modalview);
/**
 * timing:
 * GA timing
 * @param args.category {String} required
 * @param args.variable {String} required
 * @param args.value  {Int}  required
 * @param args.label  {String} required
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */ parcelHelpers.export(exports, "timing", ()=>timing);
/**
 * event:
 * GA event tracking
 * @param args.category {String} required
 * @param args.action {String} required
 * @param args.label {String} optional
 * @param args.value {Int} optional
 * @param args.nonInteraction {boolean} optional
 * @param args.transport {string} optional
 * @param {{action: string, category: string}} trackerNames - (optional) a list of extra trackers to run the command on
 */ parcelHelpers.export(exports, "event", ()=>event);
/**
 * exception:
 * GA exception tracking
 * @param args.description {String} optional
 * @param args.fatal {boolean} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */ parcelHelpers.export(exports, "exception", ()=>exception);
parcelHelpers.export(exports, "plugin", ()=>plugin);
/**
 * outboundLink:
 * GA outboundLink tracking
 * @param args.label {String} e.g. url, or 'Create an Account'
 * @param {function} hitCallback - Called after processing a hit.
 */ parcelHelpers.export(exports, "outboundLink", ()=>outboundLink);
parcelHelpers.export(exports, "testModeAPI", ()=>testModeAPI);
/**
 * React Google Analytics Module
 *
 * @package react-ga
 * @author  Adam Lofting <adam@mozillafoundation.org>
 *          Atul Varma <atul@mozillafoundation.org>
 */ /**
 * Utilities
 */ var _format = require("./utils/format");
var _formatDefault = parcelHelpers.interopDefault(_format);
var _removeLeadingSlash = require("./utils/removeLeadingSlash");
var _removeLeadingSlashDefault = parcelHelpers.interopDefault(_removeLeadingSlash);
var _trim = require("./utils/trim");
var _trimDefault = parcelHelpers.interopDefault(_trim);
var _loadGA = require("./utils/loadGA");
var _loadGADefault = parcelHelpers.interopDefault(_loadGA);
var _warn = require("./utils/console/warn");
var _warnDefault = parcelHelpers.interopDefault(_warn);
var _log = require("./utils/console/log");
var _logDefault = parcelHelpers.interopDefault(_log);
var _testModeAPI = require("./utils/testModeAPI");
var _testModeAPIDefault = parcelHelpers.interopDefault(_testModeAPI);
var _excluded = [
    "category",
    "action",
    "label",
    "value",
    "nonInteraction",
    "transport"
];
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var _isNotBrowser = typeof window === 'undefined' || typeof document === 'undefined';
var _debug = false;
var _titleCase = true;
var _testMode = false;
var _alwaysSendToDefaultTracker = true;
var _redactEmail = true;
var internalGa = function internalGa() {
    var _window;
    if (_testMode) return (0, _testModeAPIDefault.default).ga.apply((0, _testModeAPIDefault.default), arguments);
    if (_isNotBrowser) return false;
    if (!window.ga) return (0, _warnDefault.default)('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
    return (_window = window).ga.apply(_window, arguments);
};
function _format1(s) {
    return (0, _formatDefault.default)(s, _titleCase, _redactEmail);
}
function _gaCommand(trackerNames) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var command = args[0];
    if (typeof internalGa === 'function') {
        if (typeof command !== 'string') {
            (0, _warnDefault.default)('ga command must be a string');
            return;
        }
        if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);
        if (Array.isArray(trackerNames)) trackerNames.forEach(function(name) {
            internalGa.apply(void 0, _toConsumableArray([
                "".concat(name, ".").concat(command)
            ].concat(args.slice(1))));
        });
    }
}
function _initialize(gaTrackingID, options) {
    if (!gaTrackingID) {
        (0, _warnDefault.default)('gaTrackingID is required in initialize()');
        return;
    }
    if (options) {
        if (options.debug && options.debug === true) _debug = true;
        if (options.titleCase === false) _titleCase = false;
        if (options.redactEmail === false) _redactEmail = false;
        if (options.useExistingGa) return;
    }
    if (options && options.gaOptions) internalGa('create', gaTrackingID, options.gaOptions);
    else internalGa('create', gaTrackingID, 'auto');
}
function addTrackers(configsOrTrackingId, options) {
    if (Array.isArray(configsOrTrackingId)) configsOrTrackingId.forEach(function(config) {
        if (_typeof(config) !== 'object') {
            (0, _warnDefault.default)('All configs must be an object');
            return;
        }
        _initialize(config.trackingId, config);
    });
    else _initialize(configsOrTrackingId, options);
    return true;
}
function initialize(configsOrTrackingId, options) {
    if (options && options.testMode === true) _testMode = true;
    else {
        if (_isNotBrowser) return;
        if (!options || options.standardImplementation !== true) (0, _loadGADefault.default)(options);
    }
    _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;
    addTrackers(configsOrTrackingId, options);
}
function ga() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (args.length > 0) {
        internalGa.apply(void 0, args);
        if (_debug) {
            (0, _logDefault.default)("called ga('arguments');");
            (0, _logDefault.default)("with arguments: ".concat(JSON.stringify(args)));
        }
    }
    return window.ga;
}
function set(fieldsObject, trackerNames) {
    if (!fieldsObject) {
        (0, _warnDefault.default)('`fieldsObject` is required in .set()');
        return;
    }
    if (_typeof(fieldsObject) !== 'object') {
        (0, _warnDefault.default)('Expected `fieldsObject` arg to be an Object');
        return;
    }
    if (Object.keys(fieldsObject).length === 0) (0, _warnDefault.default)('empty `fieldsObject` given to .set()');
    _gaCommand(trackerNames, 'set', fieldsObject);
    if (_debug) {
        (0, _logDefault.default)("called ga('set', fieldsObject);");
        (0, _logDefault.default)("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
    }
}
function send(fieldObject, trackerNames) {
    _gaCommand(trackerNames, 'send', fieldObject);
    if (_debug) {
        (0, _logDefault.default)("called ga('send', fieldObject);");
        (0, _logDefault.default)("with fieldObject: ".concat(JSON.stringify(fieldObject)));
        (0, _logDefault.default)("with trackers: ".concat(JSON.stringify(trackerNames)));
    }
}
function pageview(rawPath, trackerNames, title) {
    if (!rawPath) {
        (0, _warnDefault.default)('path is required in .pageview()');
        return;
    }
    var path = (0, _trimDefault.default)(rawPath);
    if (path === '') {
        (0, _warnDefault.default)('path cannot be an empty string in .pageview()');
        return;
    }
    var extraFields = {};
    if (title) extraFields.title = title;
    if (typeof ga === 'function') {
        _gaCommand(trackerNames, 'send', _objectSpread({
            hitType: 'pageview',
            page: path
        }, extraFields));
        if (_debug) {
            (0, _logDefault.default)("called ga('send', 'pageview', path);");
            var extraLog = '';
            if (title) extraLog = " and title: ".concat(title);
            (0, _logDefault.default)("with path: ".concat(path).concat(extraLog));
        }
    }
}
function modalview(rawModalName, trackerNames) {
    if (!rawModalName) {
        (0, _warnDefault.default)('modalName is required in .modalview(modalName)');
        return;
    }
    var modalName = (0, _removeLeadingSlashDefault.default)((0, _trimDefault.default)(rawModalName));
    if (modalName === '') {
        (0, _warnDefault.default)('modalName cannot be an empty string or a single / in .modalview()');
        return;
    }
    if (typeof ga === 'function') {
        var path = "/modal/".concat(modalName);
        _gaCommand(trackerNames, 'send', 'pageview', path);
        if (_debug) {
            (0, _logDefault.default)("called ga('send', 'pageview', path);");
            (0, _logDefault.default)("with path: ".concat(path));
        }
    }
}
function timing() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, category = _ref.category, variable = _ref.variable, value = _ref.value, label = _ref.label;
    var trackerNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    if (typeof ga === 'function') {
        if (!category || !variable || typeof value !== 'number') {
            (0, _warnDefault.default)("args.category, args.variable AND args.value are required in timing() AND args.value has to be a number");
            return;
        } // Required Fields
        var fieldObject = {
            hitType: 'timing',
            timingCategory: _format1(category),
            timingVar: _format1(variable),
            timingValue: value
        };
        if (label) fieldObject.timingLabel = _format1(label);
        send(fieldObject, trackerNames);
    }
}
function event() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, category = _ref2.category, action = _ref2.action, label = _ref2.label, value = _ref2.value, nonInteraction = _ref2.nonInteraction, transport = _ref2.transport, args = _objectWithoutProperties(_ref2, _excluded);
    var trackerNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    if (typeof ga === 'function') {
        // Simple Validation
        if (!category || !action) {
            (0, _warnDefault.default)('args.category AND args.action are required in event()');
            return;
        } // Required Fields
        var fieldObject = {
            hitType: 'event',
            eventCategory: _format1(category),
            eventAction: _format1(action)
        }; // Optional Fields
        if (label) fieldObject.eventLabel = _format1(label);
        if (typeof value !== 'undefined') {
            if (typeof value !== 'number') (0, _warnDefault.default)('Expected `args.value` arg to be a Number.');
            else fieldObject.eventValue = value;
        }
        if (typeof nonInteraction !== 'undefined') {
            if (typeof nonInteraction !== 'boolean') (0, _warnDefault.default)('`args.nonInteraction` must be a boolean.');
            else fieldObject.nonInteraction = nonInteraction;
        }
        if (typeof transport !== 'undefined') {
            if (typeof transport !== 'string') (0, _warnDefault.default)('`args.transport` must be a string.');
            else {
                if ([
                    'beacon',
                    'xhr',
                    'image'
                ].indexOf(transport) === -1) (0, _warnDefault.default)('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
                fieldObject.transport = transport;
            }
        }
        Object.keys(args).filter(function(key) {
            return key.substr(0, 9) === 'dimension';
        }).forEach(function(key) {
            fieldObject[key] = args[key];
        });
        Object.keys(args).filter(function(key) {
            return key.substr(0, 6) === 'metric';
        }).forEach(function(key) {
            fieldObject[key] = args[key];
        }); // Send to GA
        send(fieldObject, trackerNames);
    }
}
function exception(_ref3, trackerNames) {
    var description = _ref3.description, fatal = _ref3.fatal;
    if (typeof ga === 'function') {
        // Required Fields
        var fieldObject = {
            hitType: 'exception'
        }; // Optional Fields
        if (description) fieldObject.exDescription = _format1(description);
        if (typeof fatal !== 'undefined') {
            if (typeof fatal !== 'boolean') (0, _warnDefault.default)('`args.fatal` must be a boolean.');
            else fieldObject.exFatal = fatal;
        } // Send to GA
        send(fieldObject, trackerNames);
    }
}
var plugin = {
    /**
   * require:
   * GA requires a plugin
   * @param name {String} e.g. 'ecommerce' or 'myplugin'
   * @param options {Object} optional e.g {path: '/log', debug: true}
   * @param trackerName {String} optional e.g 'trackerName'
   */ require: function require1(rawName, options, trackerName) {
        if (typeof ga === 'function') {
            // Required Fields
            if (!rawName) {
                (0, _warnDefault.default)('`name` is required in .require()');
                return;
            }
            var name = (0, _trimDefault.default)(rawName);
            if (name === '') {
                (0, _warnDefault.default)('`name` cannot be an empty string in .require()');
                return;
            }
            var requireString = trackerName ? "".concat(trackerName, ".require") : 'require'; // Optional Fields
            if (options) {
                if (_typeof(options) !== 'object') {
                    (0, _warnDefault.default)('Expected `options` arg to be an Object');
                    return;
                }
                if (Object.keys(options).length === 0) (0, _warnDefault.default)('Empty `options` given to .require()');
                ga(requireString, name, options);
                if (_debug) (0, _logDefault.default)("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
            } else {
                ga(requireString, name);
                if (_debug) (0, _logDefault.default)("called ga('require', '".concat(name, "');"));
            }
        }
    },
    /**
   * execute:
   * GA execute action for plugin
   * Takes variable number of arguments
   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
   * @param action {String} e.g. 'addItem' or 'myCustomAction'
   * @param actionType {String} optional e.g. 'detail'
   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
   */ execute: function execute(pluginName, action) {
        var payload;
        var actionType;
        for(var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)args[_key3 - 2] = arguments[_key3];
        if (args.length === 1) payload = args[0];
        else {
            actionType = args[0];
            payload = args[1];
        }
        if (typeof ga === 'function') {
            if (typeof pluginName !== 'string') (0, _warnDefault.default)('Expected `pluginName` arg to be a String.');
            else if (typeof action !== 'string') (0, _warnDefault.default)('Expected `action` arg to be a String.');
            else {
                var command = "".concat(pluginName, ":").concat(action);
                payload = payload || null;
                if (actionType && payload) {
                    ga(command, actionType, payload);
                    if (_debug) {
                        (0, _logDefault.default)("called ga('".concat(command, "');"));
                        (0, _logDefault.default)("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
                    }
                } else if (payload) {
                    ga(command, payload);
                    if (_debug) {
                        (0, _logDefault.default)("called ga('".concat(command, "');"));
                        (0, _logDefault.default)("with payload: ".concat(JSON.stringify(payload)));
                    }
                } else {
                    ga(command);
                    if (_debug) (0, _logDefault.default)("called ga('".concat(command, "');"));
                }
            }
        }
    }
};
function outboundLink(args, hitCallback, trackerNames) {
    if (typeof hitCallback !== 'function') {
        (0, _warnDefault.default)('hitCallback function is required');
        return;
    }
    if (typeof ga === 'function') {
        // Simple Validation
        if (!args || !args.label) {
            (0, _warnDefault.default)('args.label is required in outboundLink()');
            return;
        } // Required Fields
        var fieldObject = {
            hitType: 'event',
            eventCategory: 'Outbound',
            eventAction: 'Click',
            eventLabel: _format1(args.label)
        };
        var safetyCallbackCalled = false;
        var safetyCallback = function safetyCallback() {
            // This prevents a delayed response from GA
            // causing hitCallback from being fired twice
            safetyCallbackCalled = true;
            hitCallback();
        }; // Using a timeout to ensure the execution of critical application code
        // in the case when the GA server might be down
        // or an ad blocker prevents sending the data
        // register safety net timeout:
        var t = setTimeout(safetyCallback, 250);
        var clearableCallbackForGA = function clearableCallbackForGA() {
            clearTimeout(t);
            if (!safetyCallbackCalled) hitCallback();
        };
        fieldObject.hitCallback = clearableCallbackForGA; // Send to GA
        send(fieldObject, trackerNames);
    } else // if ga is not defined, return the callback so the application
    // continues to work as expected
    setTimeout(hitCallback, 0);
}
var testModeAPI = (0, _testModeAPIDefault.default);
exports.default = {
    initialize: initialize,
    ga: ga,
    set: set,
    send: send,
    pageview: pageview,
    modalview: modalview,
    timing: timing,
    event: event,
    exception: exception,
    plugin: plugin,
    outboundLink: outboundLink,
    testModeAPI: (0, _testModeAPIDefault.default)
};

},{"./utils/format":"3Ue8Y","./utils/removeLeadingSlash":"kxRHG","./utils/trim":"iWKOW","./utils/loadGA":"5XXe7","./utils/console/warn":"g4GcL","./utils/console/log":"fSNui","./utils/testModeAPI":"jGm7D","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3Ue8Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>format);
var _redactEmail = require("./redactEmail");
var _redactEmailDefault = parcelHelpers.interopDefault(_redactEmail);
var _toTitleCase = require("./toTitleCase");
var _toTitleCaseDefault = parcelHelpers.interopDefault(_toTitleCase);
function format() {
    var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var titleCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var redactingEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var _str = s || '';
    if (titleCase) _str = (0, _toTitleCaseDefault.default)(s);
    if (redactingEmail) _str = (0, _redactEmailDefault.default)(_str);
    return _str;
}

},{"./redactEmail":"dHnf6","./toTitleCase":"3Wjv4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dHnf6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>redactEmail);
var _warn = require("./console/warn");
var _warnDefault = parcelHelpers.interopDefault(_warn);
var _mightBeEmail = require("./mightBeEmail");
var _mightBeEmailDefault = parcelHelpers.interopDefault(_mightBeEmail);
var redacted = 'REDACTED (Potential Email Address)';
function redactEmail(string) {
    if ((0, _mightBeEmailDefault.default)(string)) {
        (0, _warnDefault.default)('This arg looks like an email address, redacting.');
        return redacted;
    }
    return string;
}

},{"./console/warn":"g4GcL","./mightBeEmail":"cBWYX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cBWYX":[function(require,module,exports,__globalThis) {
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mightBeEmail);
function mightBeEmail(s) {
    // There's no point trying to validate rfc822 fully, just look for ...@...
    return typeof s === 'string' && s.indexOf('@') !== -1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3Wjv4":[function(require,module,exports,__globalThis) {
/**
 * To Title Case 2.1 - http://individed.com/code/to-title-case/
 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
 * https://github.com/gouch/to-title-case
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toTitleCase);
var _trim = require("./trim");
var _trimDefault = parcelHelpers.interopDefault(_trim);
var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i; // test
function toTitleCase(string) {
    return (0, _trimDefault.default)(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function(match, index, title) {
        if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) return match.toLowerCase();
        if (match.substr(1).search(/[A-Z]|\../) > -1) return match;
        return match.charAt(0).toUpperCase() + match.substr(1);
    });
}

},{"./trim":"iWKOW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iWKOW":[function(require,module,exports,__globalThis) {
// GA strings need to have leading/trailing whitespace trimmed, and not all
// browsers have String.prototoype.trim().
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>trim);
function trim(s) {
    return s && s.toString().replace(/^\s+|\s+$/g, '');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kxRHG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>removeLeadingSlash);
function removeLeadingSlash(string) {
    if (string.substring(0, 1) === '/') return string.substring(1);
    return string;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5XXe7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(options) {
        if (isLoaded) return;
        isLoaded = true;
        var gaAddress = 'https://www.google-analytics.com/analytics.js';
        if (options && options.gaAddress) gaAddress = options.gaAddress;
        else if (options && options.debug) gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
        var onerror = options && options.onerror; // https://developers.google.com/analytics/devguides/collection/analyticsjs/
        /* eslint-disable */ (function(i, s, o, g, r, a, m) {
            i['GoogleAnalyticsObject'] = r;
            i[r] = i[r] || function() {
                (i[r].q = i[r].q || []).push(arguments);
            }, i[r].l = 1 * new Date();
            a = s.createElement(o), m = s.getElementsByTagName(o)[0];
            a.async = 1;
            a.src = g;
            a.onerror = onerror;
            m.parentNode.insertBefore(a, m);
        })(window, document, 'script', gaAddress, 'ga');
    /* eslint-enable */ });
var isLoaded = false;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fSNui":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>log);
function log(s) {
    console.info('[react-ga]', s);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jGm7D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gaCalls", ()=>gaCalls);
var gaCalls = [];
exports.default = {
    calls: gaCalls,
    ga: function ga() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        gaCalls.push([].concat(args));
    },
    resetCalls: function resetCalls() {
        gaCalls.length = 0;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a9QVF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Provider", ()=>Provider);
parcelHelpers.export(exports, "connect", ()=>connect);
var _react = require("react");
var CONTEXT_TYPES = {
    store: function() {}
};
var Provider = /*@__PURE__*/ function(Component$$1) {
    function Provider() {
        Component$$1.apply(this, arguments);
    }
    if (Component$$1) Provider.__proto__ = Component$$1;
    Provider.prototype = Object.create(Component$$1 && Component$$1.prototype);
    Provider.prototype.constructor = Provider;
    Provider.prototype.getChildContext = function getChildContext() {
        return {
            store: this.props.store
        };
    };
    Provider.prototype.render = function render() {
        return (0, _react.Children).only(this.props.children);
    };
    return Provider;
}((0, _react.Component));
Provider.childContextTypes = CONTEXT_TYPES;
var connect = function() {
    var args = [], len = arguments.length;
    while(len--)args[len] = arguments[len];
    var Comp = args.slice(-1)[0];
    var strings = args.length > 1 ? args.slice(0, -1) : [];
    var actionCreators = [];
    var keysToWatch = [];
    strings.forEach(function(str) {
        if (str.slice(0, 6) === 'select') {
            keysToWatch.push(str);
            return;
        }
        if (str.slice(0, 2) === 'do') {
            actionCreators.push(str);
            return;
        }
        throw Error("CanNotConnect " + str);
    });
    var Connect = /*@__PURE__*/ function(Component$$1) {
        function Connect(props, context) {
            var this$1 = this;
            Component$$1.call(this, props, context);
            var store = context.store;
            this.state = store.select(keysToWatch);
            this.unsubscribe = store.subscribeToSelectors(keysToWatch, this.setState.bind(this));
            this.actionCreators = {};
            actionCreators.forEach(function(name) {
                this$1.actionCreators[name] = function() {
                    var args = [], len = arguments.length;
                    while(len--)args[len] = arguments[len];
                    if (store.action) return store.action(name, args);
                    return store[name].apply(store, args);
                };
            });
        }
        if (Component$$1) Connect.__proto__ = Component$$1;
        Connect.prototype = Object.create(Component$$1 && Component$$1.prototype);
        Connect.prototype.constructor = Connect;
        Connect.prototype.componentWillUnmount = function componentWillUnmount() {
            this.unsubscribe();
        };
        Connect.prototype.render = function render() {
            return (0, _react.createElement)(Comp, Object.assign({}, this.props, this.state, this.actionCreators));
        };
        return Connect;
    }((0, _react.Component));
    Connect.contextTypes = CONTEXT_TYPES;
    Connect.displayName = 'connect(' + (Comp.displayName || Comp.name) + ')';
    return Connect;
};

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5eZdG":[function(require,module,exports,__globalThis) {
'use strict';
var m = require("aaccff5d309d9239");
var i;
exports.createRoot = m.createRoot;
exports.hydrateRoot = m.hydrateRoot;

},{"aaccff5d309d9239":"82aNB"}],"82aNB":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"cfGqX"}],"cfGqX":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';
var aa = require("5393afc8c463ef07"), ca = require("ece50e903283a22f");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = new Set, ea = {};
function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
}
function ha(a, b) {
    ea[a] = b;
    for(a = 0; a < b.length; a++)da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function oa(a) {
    if (ja.call(ma, a)) return !0;
    if (ja.call(la, a)) return !1;
    if (ka.test(a)) return ma[a] = !0;
    la[a] = !0;
    return !1;
}
function pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    z[b] = new v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    z[a] = new v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    z[a] = new v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    z[a] = new v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    z[a] = new v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ra = /[\-:]([a-z])/g;
function sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function ta(a, b, c, d) {
    var e = z.hasOwnProperty(b) ? z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var Ja = Symbol.iterator;
function Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ja && a[Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var A = Object.assign, La;
function Ma(a) {
    if (void 0 === La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        La = b && b[1] || "";
    }
    return "\n" + La + a;
}
var Na = !1;
function Oa(a, b) {
    if (!a || Na) return "";
    Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
}
function Pa(a) {
    switch(a.tag){
        case 5:
            return Ma(a.type);
        case 16:
            return Ma("Lazy");
        case 13:
            return Ma("Suspense");
        case 19:
            return Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Oa(a.type, !1), a;
        case 11:
            return a = Oa(a.type.render, !1), a;
        case 1:
            return a = Oa(a.type, !0), a;
        default:
            return "";
    }
}
function Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ya:
            return "Fragment";
        case wa:
            return "Portal";
        case Aa:
            return "Profiler";
        case za:
            return "StrictMode";
        case Ea:
            return "Suspense";
        case Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case Ca:
            return (a.displayName || "Context") + ".Consumer";
        case Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case Ga:
            return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
        case Ha:
            b = a._payload;
            a = a._init;
            try {
                return Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return Qa(b);
        case 8:
            return b === za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function ab(a, b) {
    b = b.checked;
    null != b && ta(a, "checked", b, !1);
}
function bb(a, b) {
    ab(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function cb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var eb = Array.isArray;
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(p(92));
            if (eb(c)) {
                if (1 < c.length) throw Error(p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var mb, nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        mb = mb || document.createElement("div");
        mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(pb).forEach(function(a) {
    qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        pb[b] = pb[a];
    });
});
function rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
}
function sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var tb = A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function ub(a, b) {
    if (b) {
        if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
    }
}
function vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var wb = null;
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(p(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb() {}
var Ib = !1;
function Jb(a, b, c) {
    if (Ib) return a(b, c);
    Ib = !0;
    try {
        return Gb(a, b, c);
    } finally{
        if (Ib = !1, null !== zb || null !== Ab) Hb(), Fb();
    }
}
function Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
    return c;
}
var Lb = !1;
if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", {
        get: function() {
            Lb = !0;
        }
    });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
} catch (a) {
    Lb = !1;
}
function Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var Ob = !1, Pb = null, Qb = !1, Rb = null, Sb = {
    onError: function(a) {
        Ob = !0;
        Pb = a;
    }
};
function Tb(a, b, c, d, e, f, g, h, k) {
    Ob = !1;
    Pb = null;
    Nb.apply(Sb, arguments);
}
function Ub(a, b, c, d, e, f, g, h, k) {
    Tb.apply(this, arguments);
    if (Ob) {
        if (Ob) {
            var l = Pb;
            Ob = !1;
            Pb = null;
        } else throw Error(p(198));
        Qb || (Qb = !0, Rb = l);
    }
}
function Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function Xb(a) {
    if (Vb(a) !== a) throw Error(p(188));
}
function Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = Vb(a);
        if (null === b) throw Error(p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return Xb(e), a;
                if (f === d) return Xb(e), b;
                f = f.sibling;
            }
            throw Error(p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(p(189));
            }
        }
        if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
}
function Zb(a) {
    a = Yb(a);
    return null !== a ? $b(a) : null;
}
function $b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
function mc(a) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
        lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
function nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
}
var rc = 64, sc = 4194304;
function tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = tc(h) : (f &= g, 0 !== f && (d = tc(f)));
    } else g = c & ~e, 0 !== g ? d = tc(g) : 0 !== f && (d = tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function yc() {
    var a = rc;
    rc <<= 1;
    0 === (rc & 4194240) && (rc = 64);
    return a;
}
function zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - oc(b);
    a[b] = c;
}
function Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var C = 0;
function Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Ec, Fc, Gc, Hc, Ic, Jc = !1, Kc = [], Lc = null, Mc = null, Nc = null, Oc = new Map, Pc = new Map, Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Pc.delete(b.pointerId);
    }
}
function Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return Lc = Tc(Lc, a, b, c, d, e), !0;
        case "dragenter":
            return Mc = Tc(Mc, a, b, c, d, e), !0;
        case "mouseover":
            return Nc = Tc(Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Oc.set(f, Tc(Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Pc.set(f, Tc(Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Vc(a) {
    var b = Wc(a.target);
    if (null !== b) {
        var c = Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = Wb(c), null !== b) {
                    a.blockedOn = b;
                    Ic(a.priority, function() {
                        Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            wb = d;
            c.target.dispatchEvent(d);
            wb = null;
        } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function Zc(a, b, c) {
    Xc(a) && c.delete(b);
}
function $c() {
    Jc = !1;
    null !== Lc && Xc(Lc) && (Lc = null);
    null !== Mc && Xc(Mc) && (Mc = null);
    null !== Nc && Xc(Nc) && (Nc = null);
    Oc.forEach(Zc);
    Pc.forEach(Zc);
}
function ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = !0, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
}
function bd(a) {
    function b(b) {
        return ad(b, a);
    }
    if (0 < Kc.length) {
        ad(Kc[0], a);
        for(var c = 1; c < Kc.length; c++){
            var d = Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Lc && ad(Lc, a);
    null !== Mc && ad(Mc, a);
    null !== Nc && ad(Nc, a);
    Oc.forEach(b);
    Pc.forEach(b);
    for(c = 0; c < Qc.length; c++)d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Qc.length && (c = Qc[0], null === c.blockedOn);)Vc(c), null === c.blockedOn && Qc.shift();
}
var cd = ua.ReactCurrentBatchConfig, dd = !0;
function ed(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 1, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function gd(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 4, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function fd(a, b, c, d) {
    if (dd) {
        var e = Yc(a, b, c, d);
        if (null === e) hd(a, b, d, id, c), Sc(a, d);
        else if (Uc(e, a, b, c, d)) d.stopPropagation();
        else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
            for(; null !== e;){
                var f = Cb(e);
                null !== f && Ec(f);
                f = Yc(a, b, c, d);
                null === f && hd(a, b, d, id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else hd(a, b, d, null, c);
    }
}
var id = null;
function Yc(a, b, c, d) {
    id = null;
    a = xb(d);
    a = Wc(a);
    if (null !== a) {
        if (b = Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    id = a;
    return null;
}
function jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch(ec()){
                case fc:
                    return 1;
                case gc:
                    return 4;
                case hc:
                case ic:
                    return 16;
                case jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = A({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = A({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = A({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = A({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = A({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = A({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = A({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = A({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = A({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = A({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = A({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = ia && "CompositionEvent" in window, be = null;
ia && "documentMode" in document && (be = document.documentMode);
var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (ia) {
    var xe;
    if (ia) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        Jb(re, b);
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge;
function Ie(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!ja.call(b, e) || !He(a[e], b[e])) return !1;
    }
    return !0;
}
function Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Ke(a, b) {
    var c = Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Je(c);
    }
}
function Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Me() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function Oe(a) {
    var b = Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = Ke(c, f);
                var g = Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
function Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var We = {
    animationend: Ve("Animation", "AnimationEnd"),
    animationiteration: Ve("Animation", "AnimationIteration"),
    animationstart: Ve("Animation", "AnimationStart"),
    transitionend: Ve("Transition", "TransitionEnd")
}, Xe = {}, Ye = {};
ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
function Ze(a) {
    if (Xe[a]) return Xe[a];
    if (!We[a]) return a;
    var b = We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
    return a;
}
var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = new Map, ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function ff(a, b) {
    df.set(a, b);
    fa(b, [
        a
    ]);
}
for(var gf = 0; gf < ef.length; gf++){
    var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
    ff(jf, "on" + kf);
}
ff($e, "onAnimationEnd");
ff(af, "onAnimationIteration");
ff(bf, "onAnimationStart");
ff("dblclick", "onDoubleClick");
ff("focusin", "onFocus");
ff("focusout", "onBlur");
ff(cf, "onTransitionEnd");
ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
function nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
        }
    }
    if (Qb) throw a = Rb, Qb = !1, Rb = null, a;
}
function D(a, b) {
    var c = b[of];
    void 0 === c && (c = b[of] = new Set);
    var d = a + "__bubble";
    c.has(d) || (pf(b, a, 2, !1), c.add(d));
}
function qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    pf(c, a, d, b);
}
var rf = "_reactListening" + Math.random().toString(36).slice(2);
function sf(a) {
    if (!a[rf]) {
        a[rf] = !0;
        da.forEach(function(b) {
            "selectionchange" !== b && (mf.has(b) || qf(b, !1, a), qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[rf] || (b[rf] = !0, qf("selectionchange", !1, b));
    }
}
function pf(a, b, c, d) {
    switch(jd(b)){
        case 1:
            var e = ed;
            break;
        case 4:
            e = gd;
            break;
        default:
            e = fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Jb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = df.get(a);
            if (void 0 !== h) {
                var k = td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case $e:
                    case af:
                    case bf:
                        k = Hd;
                        break;
                    case cf:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = Kb(w, x), null != F && t.push(tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== wb && (n = c.relatedTarget || c.fromElement) && (Wc(n) || n[uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? Wc(n) : null, null !== n && (J = Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : ue(k);
                        u = null == n ? h : ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = vf(u))w++;
                            u = 0;
                            for(F = x; F; F = vf(F))u++;
                            for(; 0 < w - u;)t = vf(t), w--;
                            for(; 0 < u - w;)x = vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = vf(t);
                                x = vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && wf(g, h, k, t, !1);
                        null !== n && null !== J && wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = ve;
                else if (me(h)) {
                    if (we) na = Fe;
                    else {
                        na = De;
                        var xa = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = Ee);
                if (na && (na = na(a, d))) {
                    ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && cb(h, "number", h.value);
            }
            xa = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var $a;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), xa = oe(d, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
            if ($a = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        se(g, b);
    });
}
function tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Kb(a, c), null != f && d.unshift(tf(a, f, e)), f = Kb(a, b), null != f && d.push(tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Kb(c, f), null != k && g.unshift(tf(c, k, h))) : e || (k = Kb(c, f), null != k && g.push(tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
function zf(a) {
    return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
}
function Af(a, b, c) {
    b = zf(b);
    if (zf(a) !== b && c) throw Error(p(425));
}
function Bf() {}
var Cf = null, Df = null;
function Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function(a) {
    return Hf.resolve(null).then(a).catch(If);
} : Ff;
function If(a) {
    setTimeout(function() {
        throw a;
    });
}
function Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    bd(b);
}
function Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
function Wc(a) {
    var b = a[Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[uf] || c[Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Mf(a); null !== a;){
                if (c = a[Of]) return c;
                a = Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[Of] || a[uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
}
function Db(a) {
    return a[Pf] || null;
}
var Sf = [], Tf = -1;
function Uf(a) {
    return {
        current: a
    };
}
function E(a) {
    0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
}
function G(a, b) {
    Tf++;
    Sf[Tf] = a.current;
    a.current = b;
}
var Vf = {}, H = Uf(Vf), Wf = Uf(!1), Xf = Vf;
function Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f() {
    E(Wf);
    E(H);
}
function ag(a, b, c) {
    if (H.current !== Vf) throw Error(p(168));
    G(H, b);
    G(Wf, c);
}
function bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
    return A({}, c, d);
}
function cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
    Xf = H.current;
    G(H, a);
    G(Wf, Wf.current);
    return !0;
}
function dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
    G(Wf, c);
}
var eg = null, fg = !1, gg = !1;
function hg(a) {
    null === eg ? eg = [
        a
    ] : eg.push(a);
}
function ig(a) {
    fg = !0;
    hg(a);
}
function jg() {
    if (!gg && null !== eg) {
        gg = !0;
        var a = 0, b = C;
        try {
            var c = eg;
            for(C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            eg = null;
            fg = !1;
        } catch (e) {
            throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
        } finally{
            C = b, gg = !1;
        }
    }
    return null;
}
var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
function tg(a, b) {
    kg[lg++] = ng;
    kg[lg++] = mg;
    mg = a;
    ng = b;
}
function ug(a, b, c) {
    og[pg++] = rg;
    og[pg++] = sg;
    og[pg++] = qg;
    qg = a;
    var d = rg;
    a = sg;
    var e = 32 - oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        rg = 1 << 32 - oc(b) + e | c << e | d;
        sg = f + a;
    } else rg = 1 << f | c << e | d, sg = a;
}
function vg(a) {
    null !== a.return && (tg(a, 1), ug(a, 1, 0));
}
function wg(a) {
    for(; a === mg;)mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
    for(; a === qg;)qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
}
var xg = null, yg = null, I = !1, zg = null;
function Ag(a, b) {
    var c = Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? {
                id: rg,
                overflow: sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, !0) : !1;
        default:
            return !1;
    }
}
function Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function Eg(a) {
    if (I) {
        var b = yg;
        if (b) {
            var c = b;
            if (!Cg(a, b)) {
                if (Dg(a)) throw Error(p(418));
                b = Lf(c.nextSibling);
                var d = xg;
                b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, xg = a);
            }
        } else {
            if (Dg(a)) throw Error(p(418));
            a.flags = a.flags & -4097 | 2;
            I = !1;
            xg = a;
        }
    }
}
function Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    xg = a;
}
function Gg(a) {
    if (a !== xg) return !1;
    if (!I) return Fg(a), I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
    if (b && (b = yg)) {
        if (Dg(a)) throw Hg(), Error(p(418));
        for(; b;)Ag(a, b), b = Lf(b.nextSibling);
    }
    Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            yg = Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            yg = null;
        }
    } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function Hg() {
    for(var a = yg; a;)a = Lf(a.nextSibling);
}
function Ig() {
    yg = xg = null;
    I = !1;
}
function Jg(a) {
    null === zg ? zg = [
        a
    ] : zg.push(a);
}
var Kg = ua.ReactCurrentBatchConfig;
function Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error(p(284));
        if (!c._owner) throw Error(p(290, a));
    }
    return a;
}
function Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === Ha && Ng(f) === b.type)) return d = e(b, c.props), d.ref = Lg(a, b, c), d.return = a, d;
        d = Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case va:
                    return c = Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = Lg(a, null, b), c.return = a, c;
                case wa:
                    return b = Sg(b, a.mode, c), b.return = a, b;
                case Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if (eb(b) || Ka(b)) return b = Tg(b, a.mode, c, null), b.return = a, b;
            Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case va:
                    return c.key === e ? k(a, b, c, d) : null;
                case wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if (eb(c) || Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if (eb(d) || Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), I && tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            I && tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = Ka(h);
        if ("function" !== typeof l) throw Error(p(150));
        h = l.call(h);
        if (null == h) throw Error(p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), I && tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            I && tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === Ha && Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === ya ? (d = Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if (eb(f)) return n(a, d, f, h);
            if (Ka(f)) return t(a, d, f, h);
            Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var Ug = Og(!0), Vg = Og(!1), Wg = Uf(null), Xg = null, Yg = null, Zg = null;
function $g() {
    Zg = Yg = Xg = null;
}
function ah(a) {
    var b = Wg.current;
    E(Wg);
    a._currentValue = b;
}
function bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function ch(a, b) {
    Xg = a;
    Zg = Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (dh = !0), a.firstContext = null);
}
function eh(a) {
    var b = a._currentValue;
    if (Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === Yg) {
            if (null === Xg) throw Error(p(308));
            Yg = a;
            Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else Yg = Yg.next = a;
    }
    return b;
}
var fh = null;
function gh(a) {
    null === fh ? fh = [
        a
    ] : fh.push(a);
}
function hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return ih(a, d);
}
function ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var jh = !1;
function kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== (K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return ih(a, c);
}
function oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
function ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function qh(a, b, c, d) {
    var e = a.updateQueue;
    jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = A({}, q, r);
                            break a;
                        case 2:
                            jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(p(191, e));
            e.call(d);
        }
    }
}
var th = {}, uh = Uf(th), vh = Uf(th), wh = Uf(th);
function xh(a) {
    if (a === th) throw Error(p(174));
    return a;
}
function yh(a, b) {
    G(wh, b);
    G(vh, a);
    G(uh, th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
    }
    E(uh);
    G(uh, b);
}
function zh() {
    E(uh);
    E(vh);
    E(wh);
}
function Ah(a) {
    xh(wh.current);
    var b = xh(uh.current);
    var c = lb(b, a.type);
    b !== c && (G(vh, a), G(uh, c));
}
function Bh(a) {
    vh.current === a && (E(uh), E(vh));
}
var L = Uf(0);
function Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var Dh = [];
function Eh() {
    for(var a = 0; a < Dh.length; a++)Dh[a]._workInProgressVersionPrimary = null;
    Dh.length = 0;
}
var Fh = ua.ReactCurrentDispatcher, Gh = ua.ReactCurrentBatchConfig, Hh = 0, M = null, N = null, O = null, Ih = !1, Jh = !1, Kh = 0, Lh = 0;
function P() {
    throw Error(p(321));
}
function Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Nh(a, b, c, d, e, f) {
    Hh = f;
    M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Fh.current = null === a || null === a.memoizedState ? Oh : Ph;
    a = c(d, e);
    if (Jh) {
        f = 0;
        do {
            Jh = !1;
            Kh = 0;
            if (25 <= f) throw Error(p(301));
            f += 1;
            O = N = null;
            b.updateQueue = null;
            Fh.current = Qh;
            a = c(d, e);
        }while (Jh);
    }
    Fh.current = Rh;
    b = null !== N && null !== N.next;
    Hh = 0;
    O = N = M = null;
    Ih = !1;
    if (b) throw Error(p(300));
    return a;
}
function Sh() {
    var a = 0 !== Kh;
    Kh = 0;
    return a;
}
function Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === O ? M.memoizedState = O = a : O = O.next = a;
    return O;
}
function Uh() {
    if (null === N) {
        var a = M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = N.next;
    var b = null === O ? M.memoizedState : O.next;
    if (null !== b) O = b, N = a;
    else {
        if (null === a) throw Error(p(310));
        N = a;
        a = {
            memoizedState: N.memoizedState,
            baseState: N.baseState,
            baseQueue: N.baseQueue,
            queue: N.queue,
            next: null
        };
        null === O ? M.memoizedState = O = a : O = O.next = a;
    }
    return O;
}
function Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Wh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if ((Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                M.lanes |= m;
                rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        He(d, b.memoizedState) || (dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, M.lanes |= f, rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Xh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Yh() {}
function Zh(a, b) {
    var c = M, d = Uh(), e = b(), f = !He(d.memoizedState, e);
    f && (d.memoizedState = e, dh = !0);
    d = d.queue;
    $h(ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== O && O.memoizedState.tag & 1) {
        c.flags |= 2048;
        bi(9, ci.bind(null, c, d, e, b), void 0, null);
        if (null === Q) throw Error(p(349));
        0 !== (Hh & 30) || di(c, b, e);
    }
    return e;
}
function di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    ei(b) && fi(a);
}
function ai(a, b, c) {
    return c(function() {
        ei(b) && fi(a);
    });
}
function ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !He(a, c);
    } catch (d) {
        return !0;
    }
}
function fi(a) {
    var b = ih(a, 1);
    null !== b && gi(b, a, 1, -1);
}
function hi(a) {
    var b = Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = ii.bind(null, M, a);
    return [
        b.memoizedState,
        a
    ];
}
function bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function ji() {
    return Uh().memoizedState;
}
function ki(a, b, c, d) {
    var e = Th();
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function li(a, b, c, d) {
    var e = Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== N) {
        var g = N.memoizedState;
        f = g.destroy;
        if (null !== d && Mh(d, g.deps)) {
            e.memoizedState = bi(b, c, f, d);
            return;
        }
    }
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, f, d);
}
function mi(a, b) {
    return ki(8390656, 8, a, b);
}
function $h(a, b) {
    return li(2048, 8, a, b);
}
function ni(a, b) {
    return li(4, 2, a, b);
}
function oi(a, b) {
    return li(4, 4, a, b);
}
function pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return li(4, 4, pi.bind(null, b, a), c);
}
function ri() {}
function si(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ti(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ui(a, b, c) {
    if (0 === (Hh & 21)) return a.baseState && (a.baseState = !1, dh = !0), a.memoizedState = c;
    He(c, b) || (c = yc(), M.lanes |= c, rh |= c, a.baseState = !0);
    return b;
}
function vi(a, b) {
    var c = C;
    C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = Gh.transition;
    Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        C = c, Gh.transition = d;
    }
}
function wi() {
    return Uh().memoizedState;
}
function xi(a, b, c) {
    var d = yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, c);
    else if (c = hh(a, b, c, d), null !== c) {
        var e = R();
        gi(c, a, d, e);
        Bi(c, b, d);
    }
}
function ii(a, b, c) {
    var d = yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if (He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = hh(a, b, e, d);
        null !== c && (e = R(), gi(c, a, d, e), Bi(c, b, d));
    }
}
function zi(a) {
    var b = a.alternate;
    return a === M || null !== b && b === M;
}
function Ai(a, b) {
    Jh = Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
var Rh = {
    readContext: eh,
    useCallback: P,
    useContext: P,
    useEffect: P,
    useImperativeHandle: P,
    useInsertionEffect: P,
    useLayoutEffect: P,
    useMemo: P,
    useReducer: P,
    useRef: P,
    useState: P,
    useDebugValue: P,
    useDeferredValue: P,
    useTransition: P,
    useMutableSource: P,
    useSyncExternalStore: P,
    useId: P,
    unstable_isNewReconciler: !1
}, Oh = {
    readContext: eh,
    useCallback: function(a, b) {
        Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: eh,
    useEffect: mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return ki(4194308, 4, pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = xi.bind(null, M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: hi,
    useDebugValue: ri,
    useDeferredValue: function(a) {
        return Th().memoizedState = a;
    },
    useTransition: function() {
        var a = hi(!1), b = a[0];
        a = vi.bind(null, a[1]);
        Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = M, e = Th();
        if (I) {
            if (void 0 === c) throw Error(p(407));
            c = c();
        } else {
            c = b();
            if (null === Q) throw Error(p(349));
            0 !== (Hh & 30) || di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        mi(ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        bi(9, ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = Th(), b = Q.identifierPrefix;
        if (I) {
            var c = sg;
            var d = rg;
            c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, Ph = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Wh,
    useRef: ji,
    useState: function() {
        return Wh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Wh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
}, Qh = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Xh,
    useRef: ji,
    useState: function() {
        return Xh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return null === N ? b.memoizedState = a : ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Xh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
};
function Ci(a, b) {
    if (a && a.defaultProps) {
        b = A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = R(), d = yi(a), e = mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = nh(a, e, d);
        null !== b && (gi(b, a, d, c), oh(b, a, d));
    }
};
function Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f) : !0;
}
function Gi(a, b, c) {
    var d = !1, e = Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = eh(f) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Ei.enqueueReplaceState(b, b.state, null);
}
function Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = eh(f) : (f = Zf(b) ? Xf : H.current, e.context = Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Ei.enqueueReplaceState(e, e.state, null), qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function Ji(a, b) {
    try {
        var c = "", d = b;
        do c += Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Mi = "function" === typeof WeakMap ? WeakMap : Map;
function Ni(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Oi || (Oi = !0, Pi = d);
        Li(a, b);
    };
    return c;
}
function Qi(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        Li(a, b);
        "function" !== typeof d && (null === Ri ? Ri = new Set([
            this
        ]) : Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = Ti.bind(null, a, b, c), b.then(a, a));
}
function Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = mh(-1, 1), b.tag = 2, nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var Wi = ua.ReactCurrentOwner, dh = !1;
function Xi(a, b, c, d) {
    b.child = null === a ? Vg(b, null, c, d) : Ug(b, a.child, c, d);
}
function Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    ch(b, e);
    d = Nh(a, b, c, d, f, e);
    c = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && c && vg(b);
    b.flags |= 1;
    Xi(a, b, d, e);
    return b.child;
}
function $i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, bj(a, b, f, d, e);
        a = Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : Ie;
        if (c(g, d) && a.ref === b.ref) return Zi(a, b, e);
    }
    b.flags |= 1;
    a = Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if (Ie(f, d) && a.ref === b.ref) {
            if (dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (dh = !0);
            else return b.lanes = a.lanes, Zi(a, b, e);
        }
    }
    return cj(a, b, c, d, e);
}
function dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, G(ej, fj), fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, G(ej, fj), fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            G(ej, fj);
            fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, G(ej, fj), fj |= d;
    Xi(a, b, e, c);
    return b.child;
}
function gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function cj(a, b, c, d, e) {
    var f = Zf(c) ? Xf : H.current;
    f = Yf(b, f);
    ch(b, e);
    c = Nh(a, b, c, d, f, e);
    d = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && d && vg(b);
    b.flags |= 1;
    Xi(a, b, c, e);
    return b.child;
}
function hj(a, b, c, d, e) {
    if (Zf(c)) {
        var f = !0;
        cg(b);
    } else f = !1;
    ch(b, e);
    if (null === b.stateNode) ij(a, b), Gi(b, c, d), Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = eh(l) : (l = Zf(c) ? Xf : H.current, l = Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Hi(b, g, d, l);
        jh = !1;
        var r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || Wf.current || jh ? ("function" === typeof m && (Di(b, c, m, d), k = b.memoizedState), (h = jh || Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = eh(k) : (k = Zf(c) ? Xf : H.current, k = Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && Hi(b, g, d, k);
        jh = !1;
        r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || Wf.current || jh ? ("function" === typeof y && (Di(b, c, y, d), n = b.memoizedState), (l = jh || Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return jj(a, b, c, d, f, e);
}
function jj(a, b, c, d, e, f) {
    gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && dg(b, c, !1), Zi(a, b, f);
    d = b.stateNode;
    Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Ug(b, a.child, null, f), b.child = Ug(b, null, h, f)) : Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && dg(b, c, !0);
    return b.child;
}
function kj(a) {
    var b = a.stateNode;
    b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, !1);
    yh(a, b.containerInfo);
}
function lj(a, b, c, d, e) {
    Ig();
    Jg(e);
    b.flags |= 256;
    Xi(a, b, c, d);
    return b.child;
}
var mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function oj(a, b, c) {
    var d = b.pendingProps, e = L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    G(L, e & 1);
    if (null === a) {
        Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = pj(g, d, 0, null), a = Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = nj(c), b.memoizedState = mj, a) : qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = Pg(h, f) : (f = Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function qj(a, b) {
    b = pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function sj(a, b, c, d) {
    null !== d && Jg(d);
    Ug(b, a.child, null, c);
    a = qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = Ki(Error(p(422))), sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && Ug(b, a.child, null, g);
        b.child.memoizedState = nj(g);
        b.memoizedState = mj;
        return f;
    }
    if (0 === (b.mode & 1)) return sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error(p(419));
        d = Ki(f, d, void 0);
        return sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if (dh || h) {
        d = Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, ih(a, e), gi(d, a, e, -1));
        }
        tj();
        d = Ki(Error(p(421)));
        return sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    yg = Lf(e.nextSibling);
    xg = b;
    I = !0;
    zg = null;
    null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
    b = qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    bh(a.return, b, c);
}
function wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    Xi(a, b, d.children, c);
    d = L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && vj(a, c, b);
            else if (19 === a.tag) vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    G(L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            wj(b, !0, c, null, f);
            break;
        case "together":
            wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
        a = b.child;
        c = Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function yj(a, b, c) {
    switch(b.tag){
        case 3:
            kj(b);
            Ig();
            break;
        case 5:
            Ah(b);
            break;
        case 1:
            Zf(b.type) && cg(b);
            break;
        case 4:
            yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            G(Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return G(L, L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return oj(a, b, c);
                G(L, L.current & 1);
                a = Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            G(L, L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            G(L, L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, dj(a, b, c);
    }
    return Zi(a, b, c);
}
var zj, Aj, Bj, Cj;
zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Aj = function() {};
Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        xh(uh.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "select":
                e = A({}, e, {
                    value: void 0
                });
                d = A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
        }
        ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Dj(a, b) {
    if (!I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function Ej(a, b, c) {
    var d = b.pendingProps;
    wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return S(b), null;
        case 1:
            return Zf(b.type) && $f(), S(b), null;
        case 3:
            d = b.stateNode;
            zh();
            E(Wf);
            E(H);
            Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Fj(zg), zg = null));
            Aj(a, b);
            S(b);
            return null;
        case 5:
            Bh(b);
            var e = xh(wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(p(166));
                    S(b);
                    return null;
                }
                a = xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[Of] = b;
                    d[Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            D("cancel", d);
                            D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < lf.length; e++)D(lf[e], d);
                            break;
                        case "source":
                            D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            D("error", d);
                            D("load", d);
                            break;
                        case "details":
                            D("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            D("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), D("invalid", d);
                    }
                    ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            Va(d);
                            db(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[Of] = b;
                    a[Pf] = d;
                    zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = vb(c, d);
                        switch(c){
                            case "dialog":
                                D("cancel", a);
                                D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < lf.length; e++)D(lf[e], a);
                                e = d;
                                break;
                            case "source":
                                D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                D("error", a);
                                D("load", a);
                                e = d;
                                break;
                            case "details":
                                D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                Za(a, d);
                                e = Ya(a, d);
                                D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = A({}, d, {
                                    value: void 0
                                });
                                D("invalid", a);
                                break;
                            case "textarea":
                                hb(a, d);
                                e = gb(a, d);
                                D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && ob(a, k) : "number" === typeof k && ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && D("scroll", a) : null != k && ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                Va(a);
                                db(a, d, !1);
                                break;
                            case "textarea":
                                Va(a);
                                jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
                c = xh(wh.current);
                xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = xg, null !== a) switch(a.tag){
                            case 3:
                                Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
            }
            S(b);
            return null;
        case 13:
            E(L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f = !1;
                else if (f = Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error(p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error(p(317));
                        f[Of] = b;
                    } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    S(b);
                    f = !1;
                } else null !== zg && (Fj(zg), zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (L.current & 1) ? 0 === T && (T = 3) : tj()));
            null !== b.updateQueue && (b.flags |= 4);
            S(b);
            return null;
        case 4:
            return zh(), Aj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
        case 10:
            return ah(b.type._context), S(b), null;
        case 17:
            return Zf(b.type) && $f(), S(b), null;
        case 19:
            E(L);
            f = b.memoizedState;
            if (null === f) return S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) Dj(f, !1);
                else {
                    if (0 !== T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            G(L, L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && B() > Gj && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !I) return S(b), null;
                    } else 2 * B() - f.renderingStartTime > Gj && 1073741824 !== c && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = B(), b.sibling = null, c = L.current, G(L, d ? c & 1 | 2 : c & 1), b;
            S(b);
            return null;
        case 22:
        case 23:
            return Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (fj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error(p(156, b.tag));
}
function Ij(a, b) {
    wg(b);
    switch(b.tag){
        case 1:
            return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return zh(), E(Wf), E(H), Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return Bh(b), null;
        case 13:
            E(L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error(p(340));
                Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return E(L), null;
        case 4:
            return zh(), null;
        case 10:
            return ah(b.type._context), null;
        case 22:
        case 23:
            return Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var Jj = !1, U = !1, Kj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
function Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            W(a, b, d);
        }
        else c.current = null;
    }
}
function Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        W(a, b, d);
    }
}
var Nj = !1;
function Oj(a, b) {
    Cf = dd;
    a = Me();
    if (Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    Df = {
        focusedElem: a,
        selectionRange: c
    };
    dd = !1;
    for(V = b; null !== V;)if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
    else for(; null !== V;){
        b = V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(p(163));
            }
        } catch (F) {
            W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            V = a;
            break;
        }
        V = b.return;
    }
    n = Nj;
    Nj = !1;
    return n;
}
function Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
    else if (4 !== d && (a = a.child, null !== a)) for(Vj(a, b, c), a = a.sibling; null !== a;)Vj(a, b, c), a = a.sibling;
}
function Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Wj(a, b, c), a = a.sibling; null !== a;)Wj(a, b, c), a = a.sibling;
}
var X = null, Xj = !1;
function Yj(a, b, c) {
    for(c = c.child; null !== c;)Zj(a, b, c), c = c.sibling;
}
function Zj(a, b, c) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
        lc.onCommitFiberUnmount(kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            U || Lj(c, b);
        case 6:
            var d = X, e = Xj;
            X = null;
            Yj(a, b, c);
            X = d;
            Xj = e;
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
            break;
        case 18:
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
            break;
        case 4:
            d = X;
            e = Xj;
            X = c.stateNode.containerInfo;
            Xj = !0;
            Yj(a, b, c);
            X = d;
            Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? Mj(c, b, g) : 0 !== (f & 4) && Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            Yj(a, b, c);
            break;
        case 1:
            if (!U && (Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                W(c, b, h);
            }
            Yj(a, b, c);
            break;
        case 21:
            Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Yj(a, b, c), U = d) : Yj(a, b, c);
            break;
        default:
            Yj(a, b, c);
    }
}
function ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Kj);
        b.forEach(function(b) {
            var d = bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        X = h.stateNode;
                        Xj = !1;
                        break a;
                    case 3:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                    case 4:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === X) throw Error(p(160));
            Zj(f, g, e);
            X = null;
            Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)dk(b, a), b = b.sibling;
}
function dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            ck(b, a);
            ek(a);
            if (d & 4) {
                try {
                    Pj(3, a, a.return), Qj(3, a);
                } catch (t) {
                    W(a, a.return, t);
                }
                try {
                    Pj(5, a, a.return);
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 1:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            break;
        case 5:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    ob(e, "");
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && ab(e, f);
                    vb(h, g);
                    var l = vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? sb(e, q) : "dangerouslySetInnerHTML" === m ? nb(e, q) : "children" === m ? ob(e, q) : ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            bb(e, f);
                            break;
                        case "textarea":
                            ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? fb(e, !!f.multiple, f.defaultValue, !0) : fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[Pf] = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 6:
            ck(b, a);
            ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error(p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 3:
            ck(b, a);
            ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                bd(b.containerInfo);
            } catch (t) {
                W(a, a.return, t);
            }
            break;
        case 4:
            ck(b, a);
            ek(a);
            break;
        case 13:
            ck(b, a);
            ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (fk = B()));
            d & 4 && ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? (U = (l = U) || m, ck(b, a), U = l) : ck(b, a);
            ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for(V = a, m = a.child; null !== m;){
                    for(q = V = m; null !== V;){
                        r = V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                Pj(4, r, r.return);
                                break;
                            case 1:
                                Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, V = y) : gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = rb("display", g));
                            } catch (t) {
                                W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            ck(b, a);
            ek(a);
            d & 4 && ak(a);
            break;
        case 21:
            break;
        default:
            ck(b, a), ek(a);
    }
}
function ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if (Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error(p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && (ob(e, ""), d.flags &= -33);
                    var f = Uj(a);
                    Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = Uj(a);
                    Vj(a, h, g);
                    break;
                default:
                    throw Error(p(161));
            }
        } catch (k) {
            W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function hk(a, b, c) {
    V = a;
    ik(a, b, c);
}
function ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== V;){
        var e = V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || U;
                h = Jj;
                var l = U;
                Jj = g;
                if ((U = k) && !l) for(V = e; null !== V;)g = V, k = g.child, 22 === g.tag && null !== g.memoizedState ? jk(e) : null !== k ? (k.return = g, V = k) : jk(e);
                for(; null !== f;)V = f, ik(f, b, c), f = f.sibling;
                V = e;
                Jj = h;
                U = l;
            }
            kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, V = f) : kk(a, b, c);
    }
}
function kk(a) {
    for(; null !== V;){
        var b = V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        U || Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error(p(163));
                }
                U || b.flags & 512 && Rj(b);
            } catch (r) {
                W(b, b.return, r);
            }
        }
        if (b === a) {
            V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function gk(a) {
    for(; null !== V;){
        var b = V;
        if (b === a) {
            V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function jk(a) {
    for(; null !== V;){
        var b = V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        Qj(4, b);
                    } catch (k) {
                        W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, g, k);
                    }
            }
        } catch (k) {
            W(b, b.return, k);
        }
        if (b === a) {
            V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            V = h;
            break;
        }
        V = b.return;
    }
}
var lk = Math.ceil, mk = ua.ReactCurrentDispatcher, nk = ua.ReactCurrentOwner, ok = ua.ReactCurrentBatchConfig, K = 0, Q = null, Y = null, Z = 0, fj = 0, ej = Uf(0), T = 0, pk = null, rh = 0, qk = 0, rk = 0, sk = null, tk = null, fk = 0, Gj = Infinity, uk = null, Oi = !1, Pi = null, Ri = null, vk = !1, wk = null, xk = 0, yk = 0, zk = null, Ak = -1, Bk = 0;
function R() {
    return 0 !== (K & 6) ? B() : -1 !== Ak ? Ak : Ak = B();
}
function yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
    if (null !== Kg.transition) return 0 === Bk && (Bk = yc()), Bk;
    a = C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : jd(a.type);
    return a;
}
function gi(a, b, c, d) {
    if (50 < yk) throw yk = 0, zk = null, Error(p(185));
    Ac(a, c, d);
    if (0 === (K & 2) || a !== Q) a === Q && (0 === (K & 2) && (qk |= c), 4 === T && Ck(a, Z)), Dk(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Gj = B() + 500, fg && jg());
}
function Dk(a, b) {
    var c = a.callbackNode;
    wc(a, b);
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && bc(c);
        if (1 === b) 0 === a.tag ? ig(Ek.bind(null, a)) : hg(Ek.bind(null, a)), Jf(function() {
            0 === (K & 6) && jg();
        }), c = null;
        else {
            switch(Dc(d)){
                case 1:
                    c = fc;
                    break;
                case 4:
                    c = gc;
                    break;
                case 16:
                    c = hc;
                    break;
                case 536870912:
                    c = jc;
                    break;
                default:
                    c = hc;
            }
            c = Fk(c, Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Gk(a, b) {
    Ak = -1;
    Bk = 0;
    if (0 !== (K & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (Hk() && a.callbackNode !== c) return null;
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Ik(a, d);
    else {
        b = d;
        var e = K;
        K |= 2;
        var f = Jk();
        if (Q !== a || Z !== b) uk = null, Gj = B() + 500, Kk(a, b);
        for(;;)try {
            Lk();
            break;
        } catch (h) {
            Mk(a, h);
        }
        $g();
        mk.current = f;
        K = e;
        null !== Y ? b = 0 : (Q = null, Z = 0, b = T);
    }
    if (0 !== b) {
        2 === b && (e = xc(a), 0 !== e && (d = e, b = Nk(a, e)));
        if (1 === b) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
        if (6 === b) Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !Ok(e) && (b = Ik(a, d), 2 === b && (f = xc(a), 0 !== f && (d = f, b = Nk(a, f))), 1 === b)) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error(p(345));
                case 2:
                    Pk(a, tk, uk);
                    break;
                case 3:
                    Ck(a, d);
                    if ((d & 130023424) === d && (b = fk + 500 - B(), 10 < b)) {
                        if (0 !== uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), b);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 4:
                    Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), d);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 5:
                    Pk(a, tk, uk);
                    break;
                default:
                    throw Error(p(329));
            }
        }
    }
    Dk(a, B());
    return a.callbackNode === c ? Gk.bind(null, a) : null;
}
function Nk(a, b) {
    var c = sk;
    a.current.memoizedState.isDehydrated && (Kk(a, b).flags |= 256);
    a = Ik(a, b);
    2 !== a && (b = tk, tk = c, null !== b && Fj(b));
    return a;
}
function Fj(a) {
    null === tk ? tk = a : tk.push.apply(tk, a);
}
function Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function Ck(a, b) {
    b &= ~rk;
    b &= ~qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Ek(a) {
    if (0 !== (K & 6)) throw Error(p(327));
    Hk();
    var b = uc(a, 0);
    if (0 === (b & 1)) return Dk(a, B()), null;
    var c = Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = xc(a);
        0 !== d && (b = d, c = Nk(a, d));
    }
    if (1 === c) throw c = pk, Kk(a, 0), Ck(a, b), Dk(a, B()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Pk(a, tk, uk);
    Dk(a, B());
    return null;
}
function Qk(a, b) {
    var c = K;
    K |= 1;
    try {
        return a(b);
    } finally{
        K = c, 0 === K && (Gj = B() + 500, fg && jg());
    }
}
function Rk(a) {
    null !== wk && 0 === wk.tag && 0 === (K & 6) && Hk();
    var b = K;
    K |= 1;
    var c = ok.transition, d = C;
    try {
        if (ok.transition = null, C = 1, a) return a();
    } finally{
        C = d, ok.transition = c, K = b, 0 === (K & 6) && jg();
    }
}
function Hj() {
    fj = ej.current;
    E(ej);
}
function Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Gf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f();
                break;
            case 3:
                zh();
                E(Wf);
                E(H);
                Eh();
                break;
            case 5:
                Bh(d);
                break;
            case 4:
                zh();
                break;
            case 13:
                E(L);
                break;
            case 19:
                E(L);
                break;
            case 10:
                ah(d.type._context);
                break;
            case 22:
            case 23:
                Hj();
        }
        c = c.return;
    }
    Q = a;
    Y = a = Pg(a.current, null);
    Z = fj = b;
    T = 0;
    pk = null;
    rk = qk = rh = 0;
    tk = sk = null;
    if (null !== fh) {
        for(b = 0; b < fh.length; b++)if (c = fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        fh = null;
    }
    return a;
}
function Mk(a, b) {
    do {
        var c = Y;
        try {
            $g();
            Fh.current = Rh;
            if (Ih) {
                for(var d = M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                Ih = !1;
            }
            Hh = 0;
            O = N = M = null;
            Jh = !1;
            Kh = 0;
            nk.current = null;
            if (null === c || null === c.return) {
                T = 1;
                pk = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        Vi(y, g, h, f, b);
                        y.mode & 1 && Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            Si(f, l, b);
                            tj();
                            break a;
                        }
                        k = Error(p(426));
                    }
                } else if (I && h.mode & 1) {
                    var J = Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        Vi(J, g, h, f, b);
                        Jg(Ji(k, h));
                        break a;
                    }
                }
                f = k = Ji(k, h);
                4 !== T && (T = 2);
                null === sk ? sk = [
                    f
                ] : sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = Ni(f, k, b);
                            ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Ri || !Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = Qi(f, h, b);
                                ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            Sk(c);
        } catch (na) {
            b = na;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Jk() {
    var a = mk.current;
    mk.current = Rh;
    return null === a ? Rh : a;
}
function tj() {
    if (0 === T || 3 === T || 2 === T) T = 4;
    null === Q || 0 === (rh & 268435455) && 0 === (qk & 268435455) || Ck(Q, Z);
}
function Ik(a, b) {
    var c = K;
    K |= 2;
    var d = Jk();
    if (Q !== a || Z !== b) uk = null, Kk(a, b);
    for(;;)try {
        Tk();
        break;
    } catch (e) {
        Mk(a, e);
    }
    $g();
    K = c;
    mk.current = d;
    if (null !== Y) throw Error(p(261));
    Q = null;
    Z = 0;
    return T;
}
function Tk() {
    for(; null !== Y;)Uk(Y);
}
function Lk() {
    for(; null !== Y && !cc();)Uk(Y);
}
function Uk(a) {
    var b = Vk(a.alternate, a, fj);
    a.memoizedProps = a.pendingProps;
    null === b ? Sk(a) : Y = b;
    nk.current = null;
}
function Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = Ej(c, b, fj), null !== c) {
                Y = c;
                return;
            }
        } else {
            c = Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                T = 6;
                Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === T && (T = 5);
}
function Pk(a, b, c) {
    var d = C, e = ok.transition;
    try {
        ok.transition = null, C = 1, Wk(a, b, c, d);
    } finally{
        ok.transition = e, C = d;
    }
    return null;
}
function Wk(a, b, c, d) {
    do Hk();
    while (null !== wk);
    if (0 !== (K & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    Bc(a, f);
    a === Q && (Y = Q = null, Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || vk || (vk = !0, Fk(hc, function() {
        Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = ok.transition;
        ok.transition = null;
        var g = C;
        C = 1;
        var h = K;
        K |= 4;
        nk.current = null;
        Oj(a, c);
        dk(c, a);
        Oe(Df);
        dd = !!Cf;
        Df = Cf = null;
        a.current = c;
        hk(c, a, e);
        dc();
        K = h;
        C = g;
        ok.transition = f;
    } else a.current = c;
    vk && (vk = !1, wk = a, xk = e);
    f = a.pendingLanes;
    0 === f && (Ri = null);
    mc(c.stateNode, d);
    Dk(a, B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if (Oi) throw Oi = !1, a = Pi, Pi = null, a;
    0 !== (xk & 1) && 0 !== a.tag && Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === zk ? yk++ : (yk = 0, zk = a) : yk = 0;
    jg();
    return null;
}
function Hk() {
    if (null !== wk) {
        var a = Dc(xk), b = ok.transition, c = C;
        try {
            ok.transition = null;
            C = 16 > a ? 16 : a;
            if (null === wk) var d = !1;
            else {
                a = wk;
                wk = null;
                xk = 0;
                if (0 !== (K & 6)) throw Error(p(331));
                var e = K;
                K |= 4;
                for(V = a.current; null !== V;){
                    var f = V, g = f.child;
                    if (0 !== (V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for(V = l; null !== V;){
                                    var m = V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, V = q;
                                    else for(; null !== V;){
                                        m = V;
                                        var r = m.sibling, y = m.return;
                                        Sj(m);
                                        if (m === l) {
                                            V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            V = r;
                                            break;
                                        }
                                        V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, V = g;
                    else b: for(; null !== V;){
                        f = V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            V = x;
                            break b;
                        }
                        V = f.return;
                    }
                }
                var w = a.current;
                for(V = w; null !== V;){
                    g = V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, V = u;
                    else b: for(g = w; null !== V;){
                        h = V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Qj(9, h);
                            }
                        } catch (na) {
                            W(h, h.return, na);
                        }
                        if (h === g) {
                            V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            V = F;
                            break b;
                        }
                        V = h.return;
                    }
                }
                K = e;
                jg();
                if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
                    lc.onPostCommitFiberRoot(kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            C = c, ok.transition = b;
        }
    }
    return !1;
}
function Xk(a, b, c) {
    b = Ji(c, b);
    b = Ni(a, b, 1);
    a = nh(a, b, 1);
    b = R();
    null !== a && (Ac(a, 1, b), Dk(a, b));
}
function W(a, b, c) {
    if (3 === a.tag) Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ri || !Ri.has(d))) {
                a = Ji(c, a);
                a = Qi(b, a, 1);
                b = nh(b, a, 1);
                a = R();
                null !== b && (Ac(b, 1, a), Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = R();
    a.pingedLanes |= a.suspendedLanes & c;
    Q === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - fk ? Kk(a, 0) : rk |= c);
    Dk(a, b);
}
function Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
    var c = R();
    a = ih(a, b);
    null !== a && (Ac(a, b, c), Dk(a, c));
}
function uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Yk(a, c);
}
function bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error(p(314));
    }
    null !== d && d.delete(b);
    Yk(a, c);
}
var Vk;
Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || Wf.current) dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return dh = !1, yj(a, b, c);
            dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else dh = !1, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            ij(a, b);
            a = b.pendingProps;
            var e = Yf(b, H.current);
            ch(b, c);
            e = Nh(null, b, d, a, e, c);
            var f = Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f = !0, cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, kh(b), e.updater = Ei, b.stateNode = e, e._reactInternals = b, Ii(b, d, a, c), b = jj(null, b, d, !0, f, c)) : (b.tag = 0, I && f && vg(b), Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = Zk(d);
                a = Ci(d, a);
                switch(e){
                    case 0:
                        b = cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $i(null, b, d, Ci(d.type, a), c);
                        break a;
                }
                throw Error(p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), hj(a, b, d, e, c);
        case 3:
            a: {
                kj(b);
                if (null === a) throw Error(p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                lh(a, b);
                qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Ji(Error(p(423)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Ji(Error(p(424)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else for(yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = !0, zg = null, c = Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    Ig();
                    if (d === e) {
                        b = Zi(a, b, c);
                        break a;
                    }
                    Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return Ah(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ef(d, e) ? g = null : null !== f && Ef(d, f) && (b.flags |= 32), gj(a, b), Xi(a, b, g, c), b.child;
        case 6:
            return null === a && Eg(b), null;
        case 13:
            return oj(a, b, c);
        case 4:
            return yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Ug(b, null, d, c) : Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), Yi(a, b, d, e, c);
        case 7:
            return Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                G(Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if (He(f.value, g)) {
                        if (f.children === e.children && !Wf.current) {
                            b = Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error(p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, ch(b, c), e = eh(e), d = d(e), b.flags |= 1, Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = Ci(d, b.pendingProps), e = Ci(d.type, e), $i(a, b, d, e, c);
        case 15:
            return bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), ij(a, b), b.tag = 1, Zf(d) ? (a = !0, cg(b)) : a = !1, ch(b, c), Gi(b, d, e), Ii(b, d, e, c), jj(null, b, d, !0, a, c);
        case 19:
            return xj(a, b, c);
        case 22:
            return dj(a, b, c);
    }
    throw Error(p(156, b.tag));
};
function Fk(a, b) {
    return ac(a, b);
}
function $k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function Bg(a, b, c, d) {
    return new $k(a, b, c, d);
}
function aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Zk(a) {
    if ("function" === typeof a) return aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Da) return 11;
        if (a === Ga) return 14;
    }
    return 2;
}
function Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ya:
            return Tg(c.children, e, f, b);
        case za:
            g = 8;
            e |= 8;
            break;
        case Aa:
            return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f, a;
        case Ea:
            return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f, a;
        case Fa:
            return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f, a;
        case Ia:
            return pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case Ba:
                    g = 10;
                    break a;
                case Ca:
                    g = 9;
                    break a;
                case Da:
                    g = 11;
                    break a;
                case Ga:
                    g = 14;
                    break a;
                case Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error(p(130, null == a ? a : typeof a, ""));
    }
    b = Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Tg(a, b, c, d) {
    a = Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function pj(a, b, c, d) {
    a = Bg(22, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function Qg(a, b, c) {
    a = Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function Sg(a, b, c) {
    b = Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = zc(0);
    this.expirationTimes = zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function bl(a, b, c, d, e, f, g, h, k) {
    a = new al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    kh(f);
    return a;
}
function cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function dl(a) {
    if (!a) return Vf;
    a = a._reactInternals;
    a: {
        if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if (Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error(p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if (Zf(c)) return bg(a, c, b);
    }
    return b;
}
function el(a, b, c, d, e, f, g, h, k) {
    a = bl(c, d, !0, a, e, f, g, h, k);
    a.context = dl(null);
    c = a.current;
    d = R();
    e = yi(c);
    f = mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    nh(c, f, e);
    a.current.lanes = e;
    Ac(a, e, d);
    Dk(a, d);
    return a;
}
function fl(a, b, c, d) {
    var e = b.current, f = R(), g = yi(e);
    c = dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = nh(e, b, g);
    null !== a && (gi(a, e, g, f), oh(a, e, g));
    return g;
}
function gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function il(a, b) {
    hl(a, b);
    (a = a.alternate) && hl(a, b);
}
function jl() {
    return null;
}
var kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function ll(a) {
    this._internalRoot = a;
}
ml.prototype.render = ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    fl(a, b, null, null);
};
ml.prototype.unmount = ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        Rk(function() {
            fl(null, a, null, null);
        });
        b[uf] = null;
    }
};
function ml(a) {
    this._internalRoot = a;
}
ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++);
        Qc.splice(c, 0, a);
        0 === c && Vc(a);
    }
};
function nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function pl() {}
function ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = gl(g);
                f.call(a);
            };
        }
        var g = el(b, d, a, 0, null, !1, !1, "", pl);
        a._reactRootContainer = g;
        a[uf] = g.current;
        sf(8 === a.nodeType ? a.parentNode : a);
        Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = gl(k);
            h.call(a);
        };
    }
    var k = bl(a, 0, !1, null, null, !1, !1, "", pl);
    a._reactRootContainer = k;
    a[uf] = k.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Rk(function() {
        fl(b, k, c, d);
    });
    return k;
}
function rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = gl(g);
                h.call(a);
            };
        }
        fl(b, g, a, e);
    } else g = ql(c, b, a, e, d);
    return gl(g);
}
Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = tc(b.pendingLanes);
                0 !== c && (Cc(b, c | 1), Dk(b, B()), 0 === (K & 6) && (Gj = B() + 500, jg()));
            }
            break;
        case 13:
            Rk(function() {
                var b = ih(a, 1);
                if (null !== b) {
                    var c = R();
                    gi(b, a, 1, c);
                }
            }), il(a, 1);
    }
};
Fc = function(a) {
    if (13 === a.tag) {
        var b = ih(a, 134217728);
        if (null !== b) {
            var c = R();
            gi(b, a, 134217728, c);
        }
        il(a, 134217728);
    }
};
Gc = function(a) {
    if (13 === a.tag) {
        var b = yi(a), c = ih(a, b);
        if (null !== c) {
            var d = R();
            gi(c, a, b, d);
        }
        il(a, b);
    }
};
Hc = function() {
    return C;
};
Ic = function(a, b) {
    var c = C;
    try {
        return C = a, b();
    } finally{
        C = c;
    }
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(p(90));
                        Wa(d);
                        bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Qk;
Hb = Rk;
var sl = {
    usingClientEntryPoint: !1,
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Qk
    ]
}, tl = {
    findFiberByHostInstance: Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var ul = {
    bundleType: tl.bundleType,
    version: tl.version,
    rendererPackageName: tl.rendererPackageName,
    rendererConfig: tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: tl.findFiberByHostInstance || jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!vl.isDisabled && vl.supportsFiber) try {
        kc = vl.inject(ul), lc = vl;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sl;
exports.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!nl(b)) throw Error(p(200));
    return cl(a, b, null, c);
};
exports.createRoot = function(a, b) {
    if (!nl(a)) throw Error(p(299));
    var c = !1, d = "", e = kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = bl(a, 1, !1, null, null, c, !1, d, e);
    a[uf] = b.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    return new ll(b);
};
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(p(188));
        a = Object.keys(a).join(",");
        throw Error(p(268, a));
    }
    a = Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a) {
    return Rk(a);
};
exports.hydrate = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !0, c);
};
exports.hydrateRoot = function(a, b, c) {
    if (!nl(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[uf] = b.current;
    sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new ml(b);
};
exports.render = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!ol(a)) throw Error(p(40));
    return a._reactRootContainer ? (Rk(function() {
        rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[uf] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Qk;
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!ol(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return rl(a, b, c, !1, d);
};
exports.version = "18.3.1-next-f1338f8080-20240426";

},{"5393afc8c463ef07":"bmhQu","ece50e903283a22f":"awyfd"}],"awyfd":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("62f08acde0c8aa34");

},{"62f08acde0c8aa34":"daSKr"}],"daSKr":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
function f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function h(a) {
    return 0 === a.length ? null : a[0];
}
function k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
var r = [], t = [], u = 1, v = null, y = 3, z = !1, A = !1, B = !1, D = "function" === typeof setTimeout ? setTimeout : null, E = "function" === typeof clearTimeout ? clearTimeout : null, F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function G(a) {
    for(var b = h(t); null !== b;){
        if (null === b.callback) k(t);
        else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);
        else break;
        b = h(t);
    }
}
function H(a) {
    B = !1;
    G(a);
    if (!A) {
        if (null !== h(r)) A = !0, I(J);
        else {
            var b = h(t);
            null !== b && K(H, b.startTime - a);
        }
    }
}
function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;
    try {
        G(b);
        for(v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());){
            var d = v.callback;
            if ("function" === typeof d) {
                v.callback = null;
                y = v.priorityLevel;
                var e = d(v.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? v.callback = e : v === h(r) && k(r);
                G(b);
            } else k(r);
            v = h(r);
        }
        if (null !== v) var w = !0;
        else {
            var m = h(t);
            null !== m && K(H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        v = null, y = c, z = !1;
    }
}
var N = !1, O = null, L = -1, P = 5, Q = -1;
function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
}
function R() {
    if (null !== O) {
        var a = exports.unstable_now();
        Q = a;
        var b = !0;
        try {
            b = O(!0, a);
        } finally{
            b ? S() : (N = !1, O = null);
        }
    } else N = !1;
}
var S;
if ("function" === typeof F) S = function() {
    F(R);
};
else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel, U = T.port2;
    T.port1.onmessage = R;
    S = function() {
        U.postMessage(null);
    };
} else S = function() {
    D(R, 0);
};
function I(a) {
    O = a;
    N || (N = !0, S());
}
function K(a, b) {
    L = D(function() {
        a(exports.unstable_now());
    }, b);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    A || z || (A = !0, I(J));
};
exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return y;
};
exports.unstable_getFirstCallbackNode = function() {
    return h(r);
};
exports.unstable_next = function(a) {
    switch(y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = y;
    }
    var c = y;
    y = b;
    try {
        return a();
    } finally{
        y = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = y;
    y = a;
    try {
        return b();
    } finally{
        y = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
};
exports.unstable_shouldYield = M;
exports.unstable_wrapCallback = function(a) {
    var b = y;
    return function() {
        var c = y;
        y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            y = c;
        }
    };
};

},{}],"4cGJa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
parcelHelpers.export(exports, "appTimeBundle", ()=>appTimeBundle);
parcelHelpers.export(exports, "asyncCountBundle", ()=>asyncCountBundle);
parcelHelpers.export(exports, "createCacheBundle", ()=>createCacheBundle);
parcelHelpers.export(exports, "createRouteBundle", ()=>createRouteBundle);
parcelHelpers.export(exports, "createAsyncResourceBundle", ()=>createAsyncResourceBundle$1);
parcelHelpers.export(exports, "createReactorBundle", ()=>createReactorBundle);
parcelHelpers.export(exports, "getIdleDispatcher", ()=>getIdleDispatcher$1);
parcelHelpers.export(exports, "onlineBundle", ()=>onlineBundle);
parcelHelpers.export(exports, "createUrlBundle", ()=>createUrlBundle);
parcelHelpers.export(exports, "debugBundle", ()=>debugBundle);
parcelHelpers.export(exports, "composeBundlesRaw", ()=>composeBundlesRaw);
parcelHelpers.export(exports, "createGeolocationBundle", ()=>createGeolocationBundle);
parcelHelpers.export(exports, "composeBundles", ()=>composeBundles$1);
parcelHelpers.export(exports, "createSelector", ()=>t);
parcelHelpers.export(exports, "resolveSelectors", ()=>o);
parcelHelpers.export(exports, "HAS_DEBUG_FLAG", ()=>HAS_DEBUG_FLAG);
parcelHelpers.export(exports, "HAS_WINDOW", ()=>HAS_WINDOW);
parcelHelpers.export(exports, "IS_BROWSER", ()=>IS_BROWSER);
parcelHelpers.export(exports, "IS_PROD", ()=>IS_PROD);
parcelHelpers.export(exports, "raf", ()=>raf);
parcelHelpers.export(exports, "ric", ()=>ric);
parcelHelpers.export(exports, "isPassiveSupported", ()=>isPassiveSupported);
parcelHelpers.export(exports, "PASSIVE_EVENTS_SUPPORTED", ()=>PASSIVE_EVENTS_SUPPORTED);
parcelHelpers.export(exports, "startsWith", ()=>startsWith);
parcelHelpers.export(exports, "flattenExtractedToObject", ()=>flattenExtractedToObject);
parcelHelpers.export(exports, "flattenExtractedToArray", ()=>flattenExtractedToArray);
parcelHelpers.export(exports, "addGlobalListener", ()=>addGlobalListener);
parcelHelpers.export(exports, "selectorNameToValueName", ()=>selectorNameToValueName);
parcelHelpers.export(exports, "debounce", ()=>debounce);
parcelHelpers.export(exports, "saveScrollPosition", ()=>saveScrollPosition);
parcelHelpers.export(exports, "restoreScrollPosition", ()=>restoreScrollPosition);
parcelHelpers.export(exports, "initScrollPosition", ()=>initScrollPosition);
parcelHelpers.export(exports, "createStore", ()=>createStore);
parcelHelpers.export(exports, "combineReducers", ()=>combineReducers);
parcelHelpers.export(exports, "bindActionCreators", ()=>bindActionCreators);
parcelHelpers.export(exports, "applyMiddleware", ()=>applyMiddleware);
parcelHelpers.export(exports, "compose", ()=>compose);
var global = arguments[3];
var appTime = {
    name: 'appTime',
    reducer: function() {
        return Date.now();
    },
    selectAppTime: function(state) {
        return state.appTime;
    }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwcC10aW1lLmpzKG9yaWdpbmFsKSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxlQUFlO0lBQ2IsTUFBTSxTQURPLENBQUE7SUFFYixZQUFTLEdBQU0sSUFBQSxDQUFLLEdBQUwsRUFGRixDQUFBO0lBR2IsZUFBZSxLQUFBLElBQVMsS0FBQSxDQUFNOztBQUhoQyIsImZpbGUiOiJhcHAtdGltZS5qcyhvcmlnaW5hbCkiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCB7XG4gIG5hbWU6ICdhcHBUaW1lJyxcbiAgcmVkdWNlcjogKCkgPT4gRGF0ZS5ub3coKSxcbiAgc2VsZWN0QXBwVGltZTogc3RhdGUgPT4gc3RhdGUuYXBwVGltZVxufVxuIl19
var changes = {
    STARTED: 1,
    FINISHED: -1,
    FAILED: -1
};
var re = /_(STARTED|FINISHED|FAILED)$/;
var asyncCount = {
    name: 'asyncCount',
    reducer: function(state, ref) {
        if (state === void 0) state = 0;
        var type = ref.type;
        var result = re.exec(type);
        if (!result) return state;
        return state + changes[result[1]];
    },
    selectAsyncActive: function(state) {
        return state.asyncCount > 0;
    }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFzeW5jLWNvdW50LmpzKG9yaWdpbmFsKSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxLQUFBLENBQU0sVUFBVTtJQUNkLFNBQVMsQ0FESyxDQUFBO0lBRWQsVUFBVSxDQUFDLENBRkcsQ0FBQTtJQUdkLFFBQVEsQ0FBQzs7QUFHWCxLQUFBLENBQU0sS0FBSztBQUVYLGVBQWU7SUFDYixNQUFNLFlBRE8sQ0FBQTtJQUViLFVBQVUsS0FBQSxHQUFRLENBQUcsRUFBQSxDQUFFLE9BQWQsR0FBeUI7UUFDaEMsS0FBQSxDQUFNLFNBQVMsRUFBQSxDQUFHLElBQUgsQ0FBUTtRQUN2QixJQUFJLENBQUM7WUFBUSxPQUFPO1FBQ3BCLE9BQU8sS0FBQSxDQUFBLENBQUEsQ0FBUSxPQUFBLENBQVEsTUFBQSxDQUFPO0lBQ2xDLENBTmUsQ0FBQTtJQU9iLG1CQUFtQixLQUFBLElBQVMsS0FBQSxDQUFNLFVBQU4sQ0FBQSxDQUFBLENBQW1COztBQWZqRCIsImZpbGUiOiJhc3luYy1jb3VudC5qcyhvcmlnaW5hbCkiLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBjaGFuZ2VzID0ge1xuICBTVEFSVEVEOiAxLFxuICBGSU5JU0hFRDogLTEsXG4gIEZBSUxFRDogLTFcbn1cblxuY29uc3QgcmUgPSAvXyhTVEFSVEVEfEZJTklTSEVEfEZBSUxFRCkkL1xuXG5leHBvcnQgZGVmYXVsdCB7XG4gIG5hbWU6ICdhc3luY0NvdW50JyxcbiAgcmVkdWNlcjogKHN0YXRlID0gMCwgeyB0eXBlIH0pID0+IHtcbiAgICBjb25zdCByZXN1bHQgPSByZS5leGVjKHR5cGUpXG4gICAgaWYgKCFyZXN1bHQpIHJldHVybiBzdGF0ZVxuICAgIHJldHVybiBzdGF0ZSArIGNoYW5nZXNbcmVzdWx0WzFdXVxuICB9LFxuICBzZWxlY3RBc3luY0FjdGl2ZTogc3RhdGUgPT4gc3RhdGUuYXN5bmNDb3VudCA+IDBcbn1cbiJdfQ==
function namedActionMiddleware(store) {
    return function(next) {
        return function(action) {
            var actionCreator = action.actionCreator;
            var args = action.args;
            if (actionCreator) {
                var found = store.meta.unboundActionCreators[actionCreator];
                if (!found) throw Error("NoSuchActionCreator: " + actionCreator);
                return next(args ? found.apply(void 0, args) : found());
            }
            return next(action);
        };
    };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm5hbWVkLWFjdGlvbi5qcyhvcmlnaW5hbCkiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsZUFBZSxLQUFBLElBQVMsSUFBQSxJQUFRLE1BQUEsSUFBVTtJQUN4QyxLQUFBLENBQU0sQ0FBRSxlQUFlLFFBQVM7SUFDaEMsSUFBSSxlQUFlO1FBQ2pCLEtBQUEsQ0FBTSxRQUFRLEtBQUEsQ0FBTSxJQUFOLENBQVcscUJBQVgsQ0FBaUM7UUFDL0MsSUFBSSxDQUFDLE9BQU87WUFDVixNQUFNLEtBQUEsQ0FBTSx3QkFBd0IsY0FBeEI7UUFDbEI7UUFDSSxPQUFPLElBQUEsQ0FBSyxJQUFBLEdBQU8sS0FBQSxDQUFNLEdBQUcsUUFBUSxLQUFBO0lBQ3hDO0lBQ0UsT0FBTyxJQUFBLENBQUs7QUFDZDtBQVZBIiwiZmlsZSI6Im5hbWVkLWFjdGlvbi5qcyhvcmlnaW5hbCkiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBzdG9yZSA9PiBuZXh0ID0+IGFjdGlvbiA9PiB7XG4gIGNvbnN0IHsgYWN0aW9uQ3JlYXRvciwgYXJncyB9ID0gYWN0aW9uXG4gIGlmIChhY3Rpb25DcmVhdG9yKSB7XG4gICAgY29uc3QgZm91bmQgPSBzdG9yZS5tZXRhLnVuYm91bmRBY3Rpb25DcmVhdG9yc1thY3Rpb25DcmVhdG9yXVxuICAgIGlmICghZm91bmQpIHtcbiAgICAgIHRocm93IEVycm9yKGBOb1N1Y2hBY3Rpb25DcmVhdG9yOiAke2FjdGlvbkNyZWF0b3J9YClcbiAgICB9XG4gICAgcmV0dXJuIG5leHQoYXJncyA/IGZvdW5kKC4uLmFyZ3MpIDogZm91bmQoKSlcbiAgfVxuICByZXR1cm4gbmV4dChhY3Rpb24pXG59XG4iXX0=
function thunkMiddleware(extraArgCreators) {
    return function(store) {
        var extraArgs = extraArgCreators.reduce(function(result, fn) {
            return Object.assign(result, fn(store));
        }, {});
        return function(next) {
            return function(action) {
                if (typeof action === 'function') {
                    var getState = store.getState;
                    var dispatch = store.dispatch;
                    return action(Object.assign({}, {
                        getState: getState,
                        dispatch: dispatch,
                        store: store
                    }, extraArgs));
                }
                return next(action);
            };
        };
    };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImN1c3RvbS10aHVuay5qcyhvcmlnaW5hbCkiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsZUFBZSxnQkFBQSxJQUFvQixLQUFBLElBQVM7SUFDMUMsS0FBQSxDQUFNLFlBQVksZ0JBQUEsQ0FBaUIsTUFBakIsRUFDZixNQUFRLEVBQUEsSUFBVCxHQUFnQixNQUFBLENBQU8sTUFBUCxDQUFjLFFBQVEsRUFBQSxDQUFHLFNBQ3pDO0lBRUYsT0FBTyxJQUFBLElBQVEsTUFBQSxJQUFVO1FBQ3ZCLElBQUksTUFBQSxDQUFPLE1BQVAsQ0FBQSxHQUFBLENBQWtCLFlBQVk7WUFDaEMsS0FBQSxDQUFNLENBQUUsVUFBVSxZQUFhO1lBQy9CLE9BQU8sTUFBQSxDQUFPLE1BQUEsQ0FBTyxNQUFQLENBQWMsSUFBSTtnQkFBRSxRQUFGLENBQUE7Z0JBQVksUUFBWixDQUFBO2dCQUFzQjtlQUFTO1FBQ3JFO1FBQ0ksT0FBTyxJQUFBLENBQUs7SUFDaEI7QUFDQTtBQVpBIiwiZmlsZSI6ImN1c3RvbS10aHVuay5qcyhvcmlnaW5hbCkiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBleHRyYUFyZ0NyZWF0b3JzID0+IHN0b3JlID0+IHtcbiAgY29uc3QgZXh0cmFBcmdzID0gZXh0cmFBcmdDcmVhdG9ycy5yZWR1Y2UoXG4gICAgKHJlc3VsdCwgZm4pID0+IE9iamVjdC5hc3NpZ24ocmVzdWx0LCBmbihzdG9yZSkpLFxuICAgIHt9XG4gIClcbiAgcmV0dXJuIG5leHQgPT4gYWN0aW9uID0+IHtcbiAgICBpZiAodHlwZW9mIGFjdGlvbiA9PT0gJ2Z1bmN0aW9uJykge1xuICAgICAgY29uc3QgeyBnZXRTdGF0ZSwgZGlzcGF0Y2ggfSA9IHN0b3JlXG4gICAgICByZXR1cm4gYWN0aW9uKE9iamVjdC5hc3NpZ24oe30sIHsgZ2V0U3RhdGUsIGRpc3BhdGNoLCBzdG9yZSB9LCBleHRyYUFyZ3MpKVxuICAgIH1cbiAgICByZXR1cm4gbmV4dChhY3Rpb24pXG4gIH1cbn1cbiJdfQ==
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
var Symbol = root.Symbol;
var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/** Used for built-in method references. */ var objectProto$1 = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString$1 = objectProto$1.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString$1.call(value);
}
var nullTag = '[object Null]';
var undefinedTag = '[object Undefined]';
/** Built-in value references. */ var symToStringTag$1 = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag$1 && symToStringTag$1 in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var getPrototype = overArg(Object.getPrototypeOf, Object);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var objectTag = '[object Object]';
/** Used for built-in method references. */ var funcProto = Function.prototype;
var objectProto$2 = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty$1 = objectProto$2.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty$1.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
function symbolObservablePonyfill(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol('observable');
            Symbol.observable = result;
        }
    } else result = '@@observable';
    return result;
}
/* global window */ var root$2;
if (typeof self !== 'undefined') root$2 = self;
else if (typeof window !== 'undefined') root$2 = window;
else if (typeof global !== 'undefined') root$2 = global;
else root$2 = module;
var result = symbolObservablePonyfill(root$2);
var ActionTypes = {
    INIT: '@@redux/INIT'
};
function createStore(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error('Expected the enhancer to be a function.');
        return enhancer(createStore)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error('Expected the reducer to be a function.');
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error('Expected listener to be a function.');
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!isPlainObject(action)) throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
        if (typeof action.type === 'undefined') throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
        if (isDispatching) throw new Error('Reducers may not dispatch actions.');
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error('Expected the nextReducer to be a function.');
        currentReducer = nextReducer;
        dispatch({
            type: ActionTypes.INIT
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object') throw new TypeError('Expected the observer to be an object.');
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[result] = function() {
            return this;
        }, _ref;
    }
    // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: ActionTypes.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[result] = observable, _ref2;
}
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }
function getUndefinedStateErrorMessage(key, action) {
    var actionType = action && action.type;
    var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
    return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!isPlainObject(inputState)) return 'The ' + argumentName + ' has unexpected type of "' + ({}).toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (unexpectedKeys.length > 0) return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: ActionTypes.INIT
        });
        if (typeof initialState === 'undefined') throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
        var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
        if (typeof reducer(undefined, {
            type: type
        }) === 'undefined') throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function combineReducers(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var unexpectedKeyCache = void 0;
    var shapeAssertionError = void 0;
    try {
        assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var errorMessage = getUndefinedStateErrorMessage(_key, action);
                throw new Error(errorMessage);
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        return hasChanged ? nextState : state;
    };
}
function bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(undefined, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function bindActionCreators(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
    var keys = Object.keys(actionCreators);
    var boundActionCreators = {};
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function compose() {
    for(var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(undefined, arguments));
        };
    });
}
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function applyMiddleware() {
    for(var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function(reducer, preloadedState, enhancer) {
            var store = createStore(reducer, preloadedState, enhancer);
            var _dispatch = store.dispatch;
            var chain = [];
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch(action) {
                    return _dispatch(action);
                }
            };
            chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = compose.apply(undefined, chain)(store.dispatch);
            return _extends({}, store, {
                dispatch: _dispatch
            });
        };
    };
}
function isCrushed() {}
function customApplyMiddleware() {
    var middlewares = [], len = arguments.length;
    while(len--)middlewares[len] = arguments[len];
    return function(createStore$$1) {
        return function(reducer, preloadedState, enhancer) {
            var store = createStore$$1(reducer, preloadedState, enhancer);
            var chain = middlewares.map(function(middleware) {
                return middleware(store);
            });
            store.dispatch = compose.apply(void 0, chain)(store.dispatch);
            return store;
        };
    };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImN1c3RvbS1hcHBseS1taWRkbGV3YXJlLmpzKG9yaWdpbmFsKSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxRQUFTLGNBQWU7QUFFeEIsZ0JBQWdCLEdBQUcsYUFBSixHQUFvQixXQUFBLEtBQ2pDLE9BQ0EsRUFBQSxjQUNBLEVBQUEsVUFIZ0QsR0FJN0M7SUFDSCxLQUFBLENBQU0sUUFBUSxXQUFBLENBQVksU0FBUyxnQkFBZ0I7SUFDbkQsS0FBQSxDQUFNLFFBQVEsV0FBQSxDQUFZLEdBQVosQ0FBZ0IsVUFBQSxJQUFjLFVBQUEsQ0FBVztJQUN2RCxLQUFBLENBQU0sUUFBTixDQUFBLENBQUEsQ0FBaUIsT0FBQSxDQUFRLEdBQUcsTUFBWCxDQUFrQixLQUFBLENBQU07SUFDekMsT0FBTztBQUNUO0FBYkEiLCJmaWxlIjoiY3VzdG9tLWFwcGx5LW1pZGRsZXdhcmUuanMob3JpZ2luYWwpIiwic291cmNlc0NvbnRlbnQiOlsiLy8gTW9kaWZpZWQgdG8gZXhwb3NlIGFsbCBvZiBgc3RvcmVgIHRvIG1pZGRsZXdhcmUgaW5zdGVhZCBvZiBqdXN0XG4vLyBgZ2V0U3RhdGVgIGFuZCBgZGlzcGF0Y2hgXG5pbXBvcnQgeyBjb21wb3NlIH0gZnJvbSAncmVkdXgnXG5cbmV4cG9ydCBkZWZhdWx0ICguLi5taWRkbGV3YXJlcykgPT4gY3JlYXRlU3RvcmUgPT4gKFxuICByZWR1Y2VyLFxuICBwcmVsb2FkZWRTdGF0ZSxcbiAgZW5oYW5jZXJcbikgPT4ge1xuICBjb25zdCBzdG9yZSA9IGNyZWF0ZVN0b3JlKHJlZHVjZXIsIHByZWxvYWRlZFN0YXRlLCBlbmhhbmNlcilcbiAgY29uc3QgY2hhaW4gPSBtaWRkbGV3YXJlcy5tYXAobWlkZGxld2FyZSA9PiBtaWRkbGV3YXJlKHN0b3JlKSlcbiAgc3RvcmUuZGlzcGF0Y2ggPSBjb21wb3NlKC4uLmNoYWluKShzdG9yZS5kaXNwYXRjaClcbiAgcmV0dXJuIHN0b3JlXG59XG4iXX0=
function r(r, n) {
    return r === n;
}
function n(n) {
    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : r, t = null, o = null;
    return function() {
        return function(r, n, e) {
            if (null === n || null === e || n.length !== e.length) return !1;
            for(var t = n.length, o = 0; o < t; o++)if (!r(n[o], e[o])) return !1;
            return !0;
        }(e, t, arguments) || (o = n.apply(null, arguments)), t = arguments, o;
    };
}
var e = function(r) {
    for(var e = arguments.length, t = Array(e > 1 ? e - 1 : 0), o = 1; o < e; o++)t[o - 1] = arguments[o];
    return function() {
        for(var e = arguments.length, o = Array(e), u = 0; u < e; u++)o[u] = arguments[u];
        var i = 0, l = o.pop(), a = function(r) {
            var n = Array.isArray(r[0]) ? r[0] : r;
            if (!n.every(function(r) {
                return "function" == typeof r;
            })) {
                var e = n.map(function(r) {
                    return typeof r;
                }).join(", ");
                throw new Error("Selector creators expect all input-selectors to be functions, instead received the following types: [" + e + "]");
            }
            return n;
        }(o), f = r.apply(void 0, [
            function() {
                return i++, l.apply(null, arguments);
            }
        ].concat(t)), c = n(function() {
            for(var r = [], n = a.length, e = 0; e < n; e++)r.push(a[e].apply(null, arguments));
            return f.apply(null, r);
        });
        return c.resultFunc = l, c.recomputations = function() {
            return i;
        }, c.resetRecomputations = function() {
            return i = 0;
        }, c;
    };
}(n);
var t = function() {
    for(var r = [], n = arguments.length; n--;)r[n] = arguments[n];
    var t = r.slice(-1)[0], o = function(r, n) {
        var o = n.map(function(n) {
            return function(r, n) {
                if ("string" != typeof n) return n;
                var e = r[n];
                if (!e) throw Error("No selector " + n + " found on the obj.");
                return e;
            }(r, n);
        });
        return o.push(t), e.apply(void 0, o);
    };
    return o.deps = r.slice(0, -1), o.resultFunc = t, o;
};
var o = function(r) {
    var n = function(n) {
        return n.call && !n.deps || !r[n].deps;
    }, e = !1, t = function(t) {
        var o = r[t];
        n(t) ? e = !0 : o.deps = o.deps.map(function(n, o) {
            if (n.call) {
                for(var u in r)if (r[u] === n) return u;
                if (!n.deps) return e = !0, n;
            }
            if (r[n]) return n;
            throw Error("The input selector at index " + o + " for '" + t + "' is missing from the object passed to resolveSelectors()");
        });
    };
    for(var o in r)t(o);
    if (!e) throw Error("You must pass at least one real selector. If they're all string references there's no");
    for(var u, i = function() {
        var e = !1;
        for(var t in r){
            var o = r[t];
            n(t) || (e = !0, o.deps.every(n) && (r[t] = o(r, o.deps)));
        }
        return e;
    }; i();){
        if (u || (u = Date.now()), Date.now() - u > 500) throw Error("Could not resolve selector dependencies.");
    }
    return r;
};
//# sourceMappingURL=index.m.js.map
var debug = false;
try {
    debug = !!window.localStorage.debug;
} catch (e) {}
var HAS_DEBUG_FLAG = debug || false;
var HAS_WINDOW = typeof window !== 'undefined';
var IS_BROWSER = HAS_WINDOW || typeof self !== 'undefined';
var IS_PROD = true;
var fallback = function(func) {
    setTimeout(func, 0);
};
var raf = IS_BROWSER && self.requestAnimationFrame ? self.requestAnimationFrame : fallback;
var ric = IS_BROWSER && self.requestIdleCallback ? self.requestIdleCallback : fallback;
var isPassiveSupported = function() {
    var passiveSupported = false;
    try {
        var options = Object.defineProperty({}, 'passive', {
            get: function() {
                passiveSupported = true;
            }
        });
        window.addEventListener('test', options, options);
        window.removeEventListener('test', options, options);
    } catch (err) {
        passiveSupported = false;
    }
    return passiveSupported;
};
var PASSIVE_EVENTS_SUPPORTED = isPassiveSupported();
var startsWith = function(string, searchString) {
    return string.substr(0, searchString.length) === searchString;
};
var flattenExtractedToObject = function(extracted) {
    var result = {};
    for(var appName in extracted)Object.assign(result, extracted[appName]);
    return result;
};
var flattenExtractedToArray = function(extracted) {
    var accum = [];
    for(var appName in extracted)accum.push.apply(accum, extracted[appName]);
    return accum;
};
var addGlobalListener = function(eventName, handler, opts) {
    if (opts === void 0) opts = {
        passive: false
    };
    if (IS_BROWSER) {
        if (opts.passive) {
            if (PASSIVE_EVENTS_SUPPORTED) self.addEventListener(eventName, handler, {
                passive: true
            });
            else self.addEventListener(eventName, debounce(handler, 200), false);
        } else self.addEventListener(eventName, handler);
    }
};
var selectorNameToValueName = function(name) {
    var start = name[0] === 's' ? 6 : 5;
    return name[start].toLowerCase() + name.slice(start + 1);
};
var debounce = function(fn, wait) {
    var timeout;
    var debounced = function() {
        var ctx = this;
        var args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn.apply(ctx, args);
        }, wait);
    };
    debounced.cancel = function() {
        clearTimeout(timeout);
    };
    return debounced;
};
var saveScrollPosition = function() {
    history.replaceState({
        height: document.body.offsetHeight,
        width: document.body.offsetWidth,
        y: document.body.scrollTop,
        x: document.body.scrollLeft
    }, '');
};
var restoreScrollPosition = function() {
    var state = history.state;
    if (state) {
        var newStyle = "height: " + state.height + "px; width: " + state.width + "px;";
        document.body.setAttribute('style', newStyle);
        window.scrollTo(state.x, state.y);
        ric(function() {
            return document.body.removeAttribute('style');
        });
    }
};
var initScrollPosition = function() {
    if (!HAS_WINDOW) return;
    if (history.scrollRestoration) history.scrollRestoration = 'manual';
    addGlobalListener('popstate', restoreScrollPosition);
    addGlobalListener('scroll', debounce(saveScrollPosition, 300), {
        passive: true
    });
    restoreScrollPosition();
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
var obj;
var normalizeBundle = function(bundle) {
    var name = bundle.name;
    if (!name) throw TypeError('bundles must have a "name" property');
    var result = {
        name: name,
        reducer: bundle.reducer || bundle.getReducer && bundle.getReducer() || null,
        init: bundle.init || null,
        extraArgCreators: bundle.getExtraArgs || null,
        middlewareCreators: bundle.getMiddleware,
        actionCreators: null,
        selectors: null,
        reactorNames: null,
        rawBundle: bundle
    };
    Object.keys(bundle).forEach(function(key) {
        if (startsWith(key, 'do')) {
            (result.actionCreators || (result.actionCreators = {}))[key] = bundle[key];
            return;
        }
        var isSelector = startsWith(key, 'select');
        var isReactor = startsWith(key, 'react');
        if (isSelector || isReactor) {
            (result.selectors || (result.selectors = {}))[key] = bundle[key];
            if (isReactor) (result.reactorNames || (result.reactorNames = [])).push(key);
        }
    });
    return result;
};
var createChunk = function(rawBundles) {
    var normalizedBundles = rawBundles.map(normalizeBundle);
    var result = {
        bundleNames: [],
        reducers: {},
        selectors: {},
        actionCreators: {},
        rawBundles: [],
        processedBundles: [],
        initMethods: [],
        middlewareCreators: [],
        extraArgCreators: [],
        reactorNames: []
    };
    normalizedBundles.forEach(function(bundle) {
        result.bundleNames.push(bundle.name);
        Object.assign(result.selectors, bundle.selectors);
        Object.assign(result.actionCreators, bundle.actionCreators);
        if (bundle.reducer) Object.assign(result.reducers, (obj = {}, obj[bundle.name] = bundle.reducer, obj));
        if (bundle.init) result.initMethods.push(bundle.init);
        if (bundle.middlewareCreators) result.middlewareCreators.push(bundle.middlewareCreators);
        if (bundle.extraArgCreators) result.extraArgCreators.push(bundle.extraArgCreators);
        if (bundle.reactorNames) (ref = result.reactorNames).push.apply(ref, bundle.reactorNames);
        result.processedBundles.push(bundle);
        result.rawBundles.push(bundle.rawBundle);
        var ref;
    });
    return result;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
function addBindingMethods(store) {
    store.subscriptions = {
        watchedValues: {}
    };
    var subscriptions = store.subscriptions.set = new Set();
    var watchedSelectors = store.subscriptions.watchedSelectors = {};
    var watch = function(selectorName) {
        watchedSelectors[selectorName] = (watchedSelectors[selectorName] || 0) + 1;
    };
    var unwatch = function(selectorName) {
        var count = watchedSelectors[selectorName] - 1;
        if (count === 0) delete watchedSelectors[selectorName];
        else watchedSelectors[selectorName] = count;
    };
    store.subscribe(function() {
        var newValues = watchedSelectors.all ? store.selectAll() : store.select(Object.keys(watchedSelectors));
        var ref = store.subscriptions;
        var watchedValues = ref.watchedValues;
        var changed = {};
        for(var key in newValues){
            var val = newValues[key];
            if (val !== watchedValues[key]) changed[key] = val;
        }
        store.subscriptions.watchedValues = newValues;
        subscriptions.forEach(function(subscription) {
            var relevantChanges = {};
            var hasChanged = false;
            if (subscription.names === 'all') {
                Object.assign(relevantChanges, changed);
                hasChanged = !!Object.keys(relevantChanges).length;
            } else subscription.names.forEach(function(name) {
                if (changed.hasOwnProperty(name)) {
                    relevantChanges[name] = changed[name];
                    hasChanged = true;
                }
            });
            if (hasChanged) subscription.fn(relevantChanges);
        });
    });
    store.subscribeToAllChanges = function(callback) {
        return store.subscribeToSelectors('all', callback);
    };
    store.subscribeToSelectors = function(keys, callback) {
        var isAll = keys === 'all';
        var subscription = {
            fn: callback,
            names: isAll ? 'all' : keys.map(selectorNameToValueName)
        };
        subscriptions.add(subscription);
        isAll ? watch('all') : keys.forEach(watch);
        Object.assign(store.subscriptions.watchedValues, isAll ? store.selectAll() : store.select(keys));
        return function() {
            subscriptions.delete(subscription);
            isAll ? unwatch('all') : keys.forEach(unwatch);
        };
    };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
var bindSelectorsToStore = function(store, selectors) {
    var loop = function(key) {
        var selector = selectors[key];
        if (!store[key]) store[key] = function() {
            return selector(store.getState());
        };
    };
    for(var key in selectors)loop(key);
};
var decorateStore = function(store, processed) {
    if (!store.meta) store.meta = {
        chunks: [],
        unboundSelectors: {},
        unboundActionCreators: {},
        reactorNames: []
    };
    var meta = store.meta;
    meta.chunks.push(processed);
    var combinedSelectors = Object.assign(meta.unboundSelectors, processed.selectors);
    o(combinedSelectors);
    meta.unboundSelectors = combinedSelectors;
    bindSelectorsToStore(store, combinedSelectors);
    meta.reactorNames = meta.reactorNames.concat(processed.reactorNames);
    Object.assign(meta.unboundActionCreators, processed.actionCreators);
    Object.assign(store, bindActionCreators(processed.actionCreators, store.dispatch));
    processed.initMethods.forEach(function(fn) {
        return fn(store);
    });
};
var enableBatchDispatch = function(reducer) {
    return function(state, action) {
        if (action.type === 'BATCH_ACTIONS') return action.actions.reduce(reducer, state);
        return reducer(state, action);
    };
};
var devTools = function() {
    return HAS_WINDOW && window.__REDUX_DEVTOOLS_EXTENSION__ && (HAS_DEBUG_FLAG || !IS_PROD) ? window.__REDUX_DEVTOOLS_EXTENSION__() : function(a) {
        return a;
    };
};
var composeBundles = function() {
    var bundles = [], len = arguments.length;
    while(len--)bundles[len] = arguments[len];
    var firstChunk = createChunk(bundles);
    return function(data) {
        var store = createStore(enableBatchDispatch(combineReducers(firstChunk.reducers)), data, compose(customApplyMiddleware.apply(void 0, [
            namedActionMiddleware,
            thunkMiddleware(firstChunk.extraArgCreators)
        ].concat(firstChunk.middlewareCreators.map(function(fn) {
            return fn(firstChunk);
        }))), devTools()));
        store.select = function(selectorNames) {
            return selectorNames.reduce(function(obj, name) {
                if (!store[name]) throw Error("SelectorNotFound " + name);
                obj[selectorNameToValueName(name)] = store[name]();
                return obj;
            }, {});
        };
        store.selectAll = function() {
            return store.select(Object.keys(store.meta.unboundSelectors));
        };
        store.action = function(name, args) {
            return store[name].apply(store, args);
        };
        addBindingMethods(store);
        decorateStore(store, firstChunk);
        store.integrateBundles = function() {
            var bundlesToIntegrate = [], len = arguments.length;
            while(len--)bundlesToIntegrate[len] = arguments[len];
            decorateStore(store, createChunk(bundlesToIntegrate));
            var allReducers = store.meta.chunks.reduce(function(accum, chunk) {
                return Object.assign(accum, chunk.reducers);
            }, {});
            store.replaceReducer(enableBatchDispatch(combineReducers(allReducers)));
        };
        return store;
    };
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
// regexes borrowed from backbone
var optionalParam = /\((.*?)\)/g;
var namedParam = /(\(\?)?:\w+/g;
var escapeRegExp = /[\-{}\[\]+?.,\\\^$|#\s]/g;
var splatParam = /\*/g;
// Parses a URL pattern such as `/users/:id`
// and builds and returns a regex that can be used to
// match said pattern. Credit for these
// regexes belongs to Jeremy Ashkenas and the
// other maintainers of Backbone.js
//
// It has been modified for extraction of
// named paramaters from the URL
var parsePattern = function(pattern) {
    var names = [];
    pattern = pattern.replace(escapeRegExp, '\\$&').replace(optionalParam, '(?:$1)?').replace(namedParam, function(match, optional) {
        names.push(match.slice(1));
        return optional ? match : '([^/?]+)';
    }).replace(splatParam, function(match, optional) {
        names.push('path');
        return '([^?]*?)';
    });
    return {
        regExp: new RegExp('^' + pattern + '(?:\\?([\\s\\S]*))?$'),
        namedParams: names
    };
};
var featherRouteMatcher = function(routes, fallback) {
    var keys = Object.keys(routes);
    // loop through each route we're
    // and build the shell of our
    // route cache.
    for(var item in routes)routes[item] = {
        value: routes[item]
    };
    // main result is a function that can be called
    // with the url
    return function(url) {
        var params;
        var route;
        // start looking for matches
        var matchFound = keys.some(function(key) {
            var parsed;
            // fetch the route pattern from the cache
            // there will always be one
            route = routes[key];
            // if the route doesn't already have
            // a regex we never generated one
            // so we do that here lazily.
            // Parse the pattern to generate the
            // regex once, and store the result
            // for next time.
            if (!route.regExp) {
                parsed = parsePattern(key);
                route.regExp = parsed.regExp;
                route.namedParams = parsed.namedParams;
                route.pattern = key;
            }
            // run our cached regex
            var result = route.regExp.exec(url);
            // if null there was no match
            // returning falsy here continues
            // the `Array.prototype.some` loop
            if (!result) return;
            // remove other cruft from result
            result = result.slice(1, -1);
            // reduce our match to an object of named paramaters
            // we've extracted from the url
            params = result.reduce(function(obj, val, index) {
                if (val) obj[route.namedParams[index]] = val;
                return obj;
            }, {});
            // stops the loop
            return true;
        });
        // no routes matched
        if (!matchFound) {
            if (fallback) return {
                page: fallback,
                url: url,
                params: null
            };
            return null;
        }
        return {
            page: route.value,
            params: params,
            url: url,
            pattern: route.pattern
        };
    };
};
var defaults = {
    routeInfoSelector: 'selectPathname'
};
function createRoutingBundle(routes, spec) {
    var opts = Object.assign({}, defaults, spec);
    var routeInfoSelector = opts.routeInfoSelector;
    return {
        name: 'routes',
        selectRouteInfo: t(routeInfoSelector, featherRouteMatcher(routes)),
        selectRouteParams: t('selectRouteInfo', function(ref) {
            var params = ref.params;
            return params;
        }),
        selectRoute: t('selectRouteInfo', function(ref) {
            var page = ref.page;
            return page;
        })
    };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNyZWF0ZS1yb3V0ZS1idW5kbGUuanMob3JpZ2luYWwpIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLFFBQVMscUJBQXNCO0FBQy9CLE9BQU8sd0JBQXdCO0FBRS9CLEtBQUEsQ0FBTSxXQUFXO0lBQ2YsbUJBQW1COztBQUdyQixnQkFBZ0IsTUFBUSxFQUFBLE1BQVQsR0FBa0I7SUFDL0IsS0FBQSxDQUFNLE9BQU8sTUFBQSxDQUFPLE1BQVAsQ0FBYyxJQUFJLFVBQVU7SUFDekMsS0FBQSxDQUFNLENBQUUscUJBQXNCO0lBQzlCLE9BQU87UUFDTCxNQUFNLFFBREQsQ0FBQTtRQUVMLGlCQUFpQixjQUFBLENBQ2YsbUJBQ0Esa0JBQUEsQ0FBbUIsUUFKaEIsQ0FBQTtRQU1MLG1CQUFtQixjQUFBLENBQ2pCLG9CQUNDLENBQUUsU0FBSCxHQUFnQixPQVJiLENBQUE7UUFVTCxhQUFhLGNBQUEsQ0FBZSxvQkFBb0IsQ0FBRSxPQUFILEdBQWM7O0FBRWpFO0FBdEJBIiwiZmlsZSI6ImNyZWF0ZS1yb3V0ZS1idW5kbGUuanMob3JpZ2luYWwpIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3JlYXRlU2VsZWN0b3IgfSBmcm9tICdjcmVhdGUtc2VsZWN0b3InXG5pbXBvcnQgY3JlYXRlUm91dGVNYXRjaGVyIGZyb20gJ2ZlYXRoZXItcm91dGUtbWF0Y2hlcidcblxuY29uc3QgZGVmYXVsdHMgPSB7XG4gIHJvdXRlSW5mb1NlbGVjdG9yOiAnc2VsZWN0UGF0aG5hbWUnXG59XG5cbmV4cG9ydCBkZWZhdWx0IChyb3V0ZXMsIHNwZWMpID0+IHtcbiAgY29uc3Qgb3B0cyA9IE9iamVjdC5hc3NpZ24oe30sIGRlZmF1bHRzLCBzcGVjKVxuICBjb25zdCB7IHJvdXRlSW5mb1NlbGVjdG9yIH0gPSBvcHRzXG4gIHJldHVybiB7XG4gICAgbmFtZTogJ3JvdXRlcycsXG4gICAgc2VsZWN0Um91dGVJbmZvOiBjcmVhdGVTZWxlY3RvcihcbiAgICAgIHJvdXRlSW5mb1NlbGVjdG9yLFxuICAgICAgY3JlYXRlUm91dGVNYXRjaGVyKHJvdXRlcylcbiAgICApLFxuICAgIHNlbGVjdFJvdXRlUGFyYW1zOiBjcmVhdGVTZWxlY3RvcihcbiAgICAgICdzZWxlY3RSb3V0ZUluZm8nLFxuICAgICAgKHsgcGFyYW1zIH0pID0+IHBhcmFtc1xuICAgICksXG4gICAgc2VsZWN0Um91dGU6IGNyZWF0ZVNlbGVjdG9yKCdzZWxlY3RSb3V0ZUluZm8nLCAoeyBwYWdlIH0pID0+IHBhZ2UpXG4gIH1cbn1cbiJdfQ==
var defaultOpts = {
    actionBaseType: null,
    staleAfter: 900000,
    retryAfter: 60000,
    expireAfter: Infinity,
    checkIfOnline: true,
    persist: true
};
function createAsyncResourceBundle(spec) {
    var opts = Object.assign({}, defaultOpts, spec);
    var requiredOptions;
    var name = opts.name;
    var staleAfter = opts.staleAfter;
    var retryAfter = opts.retryAfter;
    var actionBaseType = opts.actionBaseType;
    var checkIfOnline = opts.checkIfOnline;
    var expireAfter = opts.expireAfter;
    var uCaseName = name.charAt(0).toUpperCase() + name.slice(1);
    var baseType = actionBaseType || name.toUpperCase();
    var inputSelector = function(state) {
        return state[name];
    };
    var dataSelector = function(state) {
        return state[name].data;
    };
    var lastSuccessSelector = function(state) {
        return state[name].lastSuccess;
    };
    var isExpiredSelector = function(state) {
        return state[name].isExpired;
    };
    var lastErrorSelector = t(inputSelector, function(resource) {
        return resource.errorTimes.slice(-1)[0] || null;
    });
    var isStaleSelector = t(inputSelector, lastSuccessSelector, 'selectAppTime', function(state, time, appTime) {
        if (state.isOutdated) return true;
        if (!time) return false;
        return appTime - time > staleAfter;
    });
    var isWaitingToRetrySelector = t(lastErrorSelector, 'selectAppTime', function(time, appTime) {
        if (!time) return false;
        return appTime - time < retryAfter;
    });
    var isLoadingSelector = t(inputSelector, function(resourceState) {
        return resourceState.isLoading;
    });
    var failedPermanentlySelector = t(inputSelector, function(resourceState) {
        return resourceState.failedPermanently;
    });
    var shouldUpdateSelector = t(isLoadingSelector, failedPermanentlySelector, isWaitingToRetrySelector, dataSelector, isStaleSelector, 'selectIsOnline', function(isLoading, failedPermanently, isWaitingToRetry, data, isStale, isOnline) {
        if (checkIfOnline && !isOnline || isLoading || failedPermanently || isWaitingToRetry) return false;
        if (!data) return true;
        return isStale;
    });
    var actions = {
        STARTED: baseType + "_FETCH_STARTED",
        FINISHED: baseType + "_FETCH_FINISHED",
        FAILED: baseType + "_FETCH_FAILED",
        CLEARED: baseType + "_CLEARED",
        OUTDATED: baseType + "_OUTDATED",
        EXPIRED: baseType + "_EXPIRED"
    };
    var doFetchError = function(error) {
        return {
            type: actions.FAILED,
            error: error
        };
    };
    var doMarkAsOutdated = function() {
        return {
            type: actions.OUTDATED
        };
    };
    var doClear = function() {
        return {
            type: actions.CLEARED
        };
    };
    var doExpire = function() {
        return {
            type: actions.EXPIRED
        };
    };
    var doFetchSuccess = function(payload) {
        return {
            type: actions.FINISHED,
            payload: payload
        };
    };
    var doFetchData = function() {
        return function(args) {
            var dispatch = args.dispatch;
            dispatch({
                type: actions.STARTED
            });
            return opts.getPromise(args).then(function(payload) {
                dispatch(doFetchSuccess(payload));
            }, function(error) {
                dispatch(doFetchError(error));
            });
        };
    };
    var initialState = {
        data: null,
        errorTimes: [],
        errorType: null,
        lastSuccess: null,
        isOutdated: false,
        isLoading: false,
        isExpired: false,
        failedPermanently: false
    };
    var result = {
        name: name,
        reducer: function(state, ref) {
            if (state === void 0) state = initialState;
            var type = ref.type;
            var payload = ref.payload;
            var error = ref.error;
            var merge = ref.merge;
            if (type === actions.STARTED) return Object.assign({}, state, {
                isLoading: true
            });
            if (type === actions.FINISHED) {
                var updatedData;
                if (merge) updatedData = Object.assign({}, state.data, payload);
                else updatedData = payload;
                return Object.assign({}, state, {
                    isLoading: false,
                    data: updatedData,
                    lastSuccess: Date.now(),
                    errorTimes: [],
                    errorType: null,
                    failedPermanently: false,
                    isOutdated: false,
                    isExpired: false
                });
            }
            if (type === actions.FAILED) {
                var errorMessage = error && error.message || error;
                return Object.assign({}, state, {
                    isLoading: false,
                    errorTimes: state.errorTimes.concat([
                        Date.now()
                    ]),
                    errorType: errorMessage,
                    failedPermanently: !!(error && error.permanent)
                });
            }
            if (type === actions.CLEARED) return initialState;
            if (type === actions.EXPIRED) return Object.assign({}, initialState, {
                isExpired: true,
                errorTimes: state.errorTimes,
                errorType: state.errorType
            });
            if (type === actions.OUTDATED) return Object.assign({}, state, {
                isOutdated: true
            });
            return state;
        }
    };
    result["select" + uCaseName + "Raw"] = inputSelector;
    result["select" + uCaseName] = dataSelector;
    result["select" + uCaseName + "IsStale"] = isStaleSelector;
    result["select" + uCaseName + "IsExpired"] = isExpiredSelector;
    result["select" + uCaseName + "LastError"] = lastErrorSelector;
    result["select" + uCaseName + "IsWaitingToRetry"] = isWaitingToRetrySelector;
    result["select" + uCaseName + "IsLoading"] = isLoadingSelector;
    result["select" + uCaseName + "FailedPermanently"] = failedPermanentlySelector;
    result["select" + uCaseName + "ShouldUpdate"] = shouldUpdateSelector;
    result["doFetch" + uCaseName] = doFetchData;
    result["doMark" + uCaseName + "AsOutdated"] = doMarkAsOutdated;
    result["doClear" + uCaseName] = doClear;
    result["doExpire" + uCaseName] = doExpire;
    if (opts.persist) result.persistActions = [
        actions.FINISHED,
        actions.EXPIRED,
        actions.OUTDATED,
        actions.CLEARED
    ];
    if (expireAfter !== Infinity) result["reactExpire" + uCaseName] = t(lastSuccessSelector, 'selectAppTime', function(time, appTime) {
        if (!time) return false;
        if (appTime - time > expireAfter) return doExpire();
    });
    return result;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
var e$1 = !("undefined" == typeof window && "undefined" == typeof self);
var n$1 = "undefined" == typeof requestIdleCallback ? function(e) {
    return setTimeout(e, 0);
} : requestIdleCallback;
function getPersistMiddleware(t) {
    var u = t.cacheFn, r = t.actionMap, o = t.logger;
    return function(t) {
        var i = t.getState;
        return function(t) {
            return function(a) {
                var f = r[a.type], c = t(a), d = i();
                return e$1 && f && n$1(function() {
                    Promise.all(f.map(function(e) {
                        return u(e, d[e]);
                    })).then(function() {
                        o && o("cached " + f.join(", ") + " due to " + a.type);
                    });
                }, {
                    timeout: 500
                }), c;
            };
        };
    };
}
//# sourceMappingURL=redux-persist-middleware.m.js.map
function caching(cacheFn) {
    return {
        name: 'localCache',
        getMiddleware: function(chunk) {
            var actionMap = {};
            chunk.rawBundles.forEach(function(bundle) {
                if (bundle.persistActions) bundle.persistActions.forEach(function(type) {
                    actionMap[type] || (actionMap[type] = []);
                    actionMap[type].push(bundle.name);
                });
            });
            return getPersistMiddleware({
                actionMap: actionMap,
                cacheFn: cacheFn
            });
        }
    };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNyZWF0ZS1jYWNoZS1idW5kbGUuanMob3JpZ2luYWwpIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sMEJBQTBCO0FBRWpDLGVBQWUsT0FBQSxLQUNOO0lBQ0wsTUFBTSxZQURELENBQUE7SUFFTCxlQUFlLEtBQUEsSUFBUztRQUN0QixLQUFBLENBQU0sWUFBWTtRQUNsQixLQUFBLENBQU0sVUFBTixDQUFpQixPQUFqQixDQUF5QixNQUFBLElBQVU7WUFDakMsSUFBSSxNQUFBLENBQU8sZ0JBQWdCO2dCQUN6QixNQUFBLENBQU8sY0FBUCxDQUFzQixPQUF0QixDQUE4QixJQUFBLElBQVE7b0JBQ3BDLFNBQUEsQ0FBVSxLQUFWLENBQUEsRUFBQSxFQUFvQixTQUFBLENBQVUsS0FBVixDQUFBLENBQUEsQ0FBa0I7b0JBQ3RDLFNBQUEsQ0FBVSxLQUFWLENBQWdCLElBQWhCLENBQXFCLE1BQUEsQ0FBTztnQkFDeEM7WUFDQTtRQUNBO1FBRU0sT0FBTyxvQkFBQSxDQUFxQjtZQUMxQixTQUQwQixDQUFBO1lBRTFCOztJQUVSOztBQXBCQSIsImZpbGUiOiJjcmVhdGUtY2FjaGUtYnVuZGxlLmpzKG9yaWdpbmFsKSIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBnZXRQZXJzaXN0TWlkZGxld2FyZSBmcm9tICdyZWR1eC1wZXJzaXN0LW1pZGRsZXdhcmUnXG5cbmV4cG9ydCBkZWZhdWx0IGNhY2hlRm4gPT4ge1xuICByZXR1cm4ge1xuICAgIG5hbWU6ICdsb2NhbENhY2hlJyxcbiAgICBnZXRNaWRkbGV3YXJlOiBjaHVuayA9PiB7XG4gICAgICBjb25zdCBhY3Rpb25NYXAgPSB7fVxuICAgICAgY2h1bmsucmF3QnVuZGxlcy5mb3JFYWNoKGJ1bmRsZSA9PiB7XG4gICAgICAgIGlmIChidW5kbGUucGVyc2lzdEFjdGlvbnMpIHtcbiAgICAgICAgICBidW5kbGUucGVyc2lzdEFjdGlvbnMuZm9yRWFjaCh0eXBlID0+IHtcbiAgICAgICAgICAgIGFjdGlvbk1hcFt0eXBlXSB8fCAoYWN0aW9uTWFwW3R5cGVdID0gW10pXG4gICAgICAgICAgICBhY3Rpb25NYXBbdHlwZV0ucHVzaChidW5kbGUubmFtZSlcbiAgICAgICAgICB9KVxuICAgICAgICB9XG4gICAgICB9KVxuXG4gICAgICByZXR1cm4gZ2V0UGVyc2lzdE1pZGRsZXdhcmUoe1xuICAgICAgICBhY3Rpb25NYXAsXG4gICAgICAgIGNhY2hlRm5cbiAgICAgIH0pXG4gICAgfVxuICB9XG59XG4iXX0=
var getError = function(message, permanent) {
    if (permanent === void 0) permanent = false;
    var err = new Error(message);
    if (permanent) err.permanent = true;
    return err;
};
var geoErrorArray = [
    'An unknown geolocation error occured',
    'Geolocation permission denied',
    'Geolocation unavailable',
    'Geolocation request timed out'
];
var defaultOpts$1 = {
    timeout: 60000,
    enableHighAccuracy: false,
    persist: true,
    staleAfter: 900000,
    retryAfter: 60000
};
function geolocation(spec) {
    var opts = Object.assign({}, defaultOpts$1, spec);
    return createAsyncResourceBundle({
        name: 'geolocation',
        actionBaseType: 'GEOLOCATION_REQUEST',
        getPromise: function() {
            return new Promise(function(resolve, reject) {
                if (!IS_BROWSER || !navigator.geolocation) reject(getError('Geolocation not supported', true));
                var success = function(position) {
                    var res = {};
                    var coords = position.coords;
                    for(var key in coords)res[key] = coords[key];
                    res.timestamp = position.timestamp;
                    resolve(res);
                };
                var fail = function(ref) {
                    var code = ref.code;
                    reject(getError(geoErrorArray[code], code === 1));
                };
                var geoOpts = {
                    timeout: opts.timeout,
                    enableHighAccuracy: opts.enableHighAccuracy
                };
                navigator.geolocation.getCurrentPosition(success, fail, geoOpts);
            });
        },
        persist: opts.persist,
        staleAfter: opts.staleAfter,
        retryAfter: opts.retryAfter
    });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
var defaults$1 = {
    idleTimeout: 30000,
    idleAction: 'APP_IDLE',
    doneCallback: null,
    stopWhenTabInactive: true
};
var ricOptions = {
    timeout: 500
};
var getIdleDispatcher = function(stopWhenInactive, timeout, fn) {
    return debounce(function() {
        stopWhenInactive ? raf(function() {
            return ric(fn, ricOptions);
        }) : ric(fn, ricOptions);
    }, timeout);
};
function reactors(spec) {
    return {
        name: 'reactors',
        init: function(store) {
            var opts = Object.assign({}, defaults$1, spec);
            var idleAction = opts.idleAction;
            var idleTimeout = opts.idleTimeout;
            var idleDispatcher;
            if (idleTimeout) idleDispatcher = getIdleDispatcher(opts.stopWhenTabInactive, idleTimeout, function() {
                return store.dispatch({
                    type: idleAction
                });
            });
            var cancelIfDone = function() {
                if (!IS_BROWSER && !store.nextReaction && (!store.selectAsyncActive || !store.selectAsyncActive())) {
                    idleDispatcher && idleDispatcher.cancel();
                    opts.doneCallback && opts.doneCallback();
                }
            };
            var dispatchNext = function() {
                if (store.nextReaction) return;
                store.meta.reactorNames.some(function(name) {
                    var result = store[name]();
                    if (result) {
                        store.activeReactor = name;
                        store.nextReaction = result;
                    }
                    return result;
                });
                if (store.nextReaction) ric(function() {
                    var nextReaction = store.nextReaction;
                    store.activeReactor = null;
                    store.nextReaction = null;
                    store.dispatch(nextReaction);
                }, ricOptions);
            };
            var callback = function() {
                dispatchNext();
                if (idleDispatcher) {
                    idleDispatcher();
                    cancelIfDone();
                }
            };
            store.subscribe(callback);
            callback();
        }
    };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
var has = Object.prototype.hasOwnProperty;
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */ function querystring(query) {
    var parser = /([^=?&]+)=?([^&]*)/g, result = {}, part;
    //
    // Little nifty parsing hack, leverage the fact that RegExp.exec increments
    // the lastIndex property so we can continue executing this loop until we've
    // parsed all results.
    //
    for(; part = parser.exec(query); result[decodeURIComponent(part[1])] = decodeURIComponent(part[2]));
    return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */ function querystringify(obj, prefix) {
    prefix = prefix || '';
    var pairs = [];
    //
    // Optionally prefix with a '?' if needed
    //
    if ('string' !== typeof prefix) prefix = '?';
    for(var key in obj)if (has.call(obj, key)) pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
    return pairs.length ? prefix + pairs.join('&') : '';
}
//
// Expose the module.
//
var stringify = querystringify;
var parse = querystring;
var querystringify_1 = {
    stringify: stringify,
    parse: parse
};
var isString = function(obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
};
var isDefined = function(thing) {
    return typeof thing !== 'undefined';
};
var ensureString = function(input) {
    return isString(input) ? input : querystringify_1.stringify(input);
};
var IPRE = /^[0-9.]+$/;
var parseSubdomains = function(hostname, getBareHost) {
    if (IPRE.test(hostname)) return [];
    var parts = hostname.split('.');
    if (getBareHost) return parts.slice(-2).join('.');
    return hostname.split('.').slice(0, -2);
};
var removeLeading = function(char, string) {
    return string.charAt(0) === char ? string.slice(1) : string;
};
var ensureLeading = function(char, string) {
    if (string === char || string === '') return '';
    return string.charAt(0) !== char ? char + string : string;
};
var loc = function() {
    if (!HAS_WINDOW) return {};
    return window.location;
}();
var defaults$2 = {
    name: 'url',
    inert: !HAS_WINDOW,
    actionType: 'URL_UPDATED',
    handleScrollRestoration: true
};
var makeSerializable = function(url) {
    var result = {};
    for(var key in url){
        var val = url[key];
        if (isString(val)) result[key] = val;
    }
    return result;
};
function url(opts) {
    var config = Object.assign({}, defaults$2, opts);
    var actionType = config.actionType;
    var selectUrlRaw = function(state) {
        return state[config.name];
    };
    var selectUrlObject = t(selectUrlRaw, function(urlState) {
        return makeSerializable(new URL(urlState.url));
    });
    var selectQueryObject = t(selectUrlObject, function(urlObj) {
        return querystringify_1.parse(urlObj.search);
    });
    var selectQueryString = t(selectQueryObject, function(queryObj) {
        return querystringify_1.stringify(queryObj);
    });
    var selectPathname = t(selectUrlObject, function(urlObj) {
        return urlObj.pathname;
    });
    var selectHash = t(selectUrlObject, function(urlObj) {
        return removeLeading('#', urlObj.hash);
    });
    var selectHashObject = t(selectHash, function(hash) {
        return querystringify_1.parse(hash);
    });
    var selectHostname = t(selectUrlObject, function(urlObj) {
        return urlObj.hostname;
    });
    var selectSubdomains = t(selectHostname, function(hostname) {
        return parseSubdomains(hostname);
    });
    var doUpdateUrl = function(newState, opts) {
        if (opts === void 0) opts = {
            replace: false
        };
        return function(ref) {
            var dispatch = ref.dispatch;
            var getState = ref.getState;
            var state = newState;
            if (typeof newState === 'string') {
                var parsed = new URL(newState.charAt(0) === '/' ? 'http://example.com' + newState : newState);
                state = {
                    pathname: parsed.pathname,
                    query: parsed.search || '',
                    hash: parsed.hash || ''
                };
            }
            var url = new URL(selectUrlRaw(getState()).url);
            if (isDefined(state.pathname)) url.pathname = state.pathname;
            if (isDefined(state.hash)) url.hash = ensureString(state.hash);
            if (isDefined(state.query)) url.search = ensureString(state.query);
            dispatch({
                type: actionType,
                payload: {
                    url: url.href,
                    replace: opts.replace
                }
            });
        };
    };
    var doReplaceUrl = function(url) {
        return doUpdateUrl(url, {
            replace: true
        });
    };
    var doUpdateQuery = function(query, opts) {
        if (opts === void 0) opts = {
            replace: true
        };
        return doUpdateUrl({
            query: ensureString(query)
        }, opts);
    };
    var doUpdateHash = function(hash, opts) {
        if (opts === void 0) opts = {
            replace: false
        };
        return doUpdateUrl({
            hash: ensureLeading('#', ensureString(hash))
        }, opts);
    };
    return {
        name: config.name,
        init: function(store) {
            if (config.inert) return;
            if (config.handleScrollRestoration) initScrollPosition();
            window.addEventListener('popstate', function() {
                store.doUpdateUrl({
                    pathname: loc.pathname,
                    hash: loc.hash,
                    query: loc.search
                });
            });
            var lastState = store.selectUrlRaw();
            store.subscribe(function() {
                var newState = store.selectUrlRaw();
                var newUrl = newState.url;
                if (lastState !== newState && newUrl !== loc.href) try {
                    window.history[newState.replace ? 'replaceState' : 'pushState']({}, null, newState.url);
                    if (config.handleScrollRestoration) saveScrollPosition();
                    document.body.scrollTop = 0;
                    document.body.scrollLeft = 0;
                } catch (e) {
                    console.error(e);
                }
                lastState = newState;
            });
        },
        getReducer: function() {
            var initialState = {
                url: !config.inert && HAS_WINDOW ? loc.href : '/',
                replace: false
            };
            return function(state, ref) {
                if (state === void 0) state = initialState;
                var type = ref.type;
                var payload = ref.payload;
                if (type === '@@redux/INIT' && typeof state === 'string') return {
                    url: state,
                    replace: false
                };
                if (type === actionType) return Object.assign({
                    url: payload.url || payload,
                    replace: !!payload.replace
                });
                return state;
            };
        },
        doUpdateUrl: doUpdateUrl,
        doReplaceUrl: doReplaceUrl,
        doUpdateQuery: doUpdateQuery,
        doUpdateHash: doUpdateHash,
        selectUrlRaw: selectUrlRaw,
        selectUrlObject: selectUrlObject,
        selectQueryObject: selectQueryObject,
        selectQueryString: selectQueryString,
        selectPathname: selectPathname,
        selectHash: selectHash,
        selectHashObject: selectHashObject,
        selectHostname: selectHostname,
        selectSubdomains: selectSubdomains
    };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
function debugMiddleware(store) {
    return function(next) {
        return function(action) {
            var isDebug = store.getState().debug;
            if (isDebug) {
                console.group(action.type);
                console.info('action:', action);
            }
            var result = next(action);
            if (isDebug) {
                console.debug('state:', store.getState());
                self.logSelectors && self.logSelectors();
                self.logNextReaction && self.logNextReaction();
                console.groupEnd(action.type);
            }
            return result;
        };
    };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImRlYnVnLmpzKG9yaWdpbmFsKSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxlQUFlLEtBQUEsSUFBUyxJQUFBLElBQVEsTUFBQSxJQUFVO0lBQ3hDLEtBQUEsQ0FBTSxVQUFVLEtBQUEsQ0FBTSxRQUFOLEVBQUEsQ0FBaUI7SUFFakMsSUFBSSxTQUFTO1FBQ1gsT0FBQSxDQUFRLEtBQVIsQ0FBYyxNQUFBLENBQU87UUFDckIsT0FBQSxDQUFRLElBQVIsQ0FBYSxXQUFXO0lBQzVCO0lBRUUsS0FBQSxDQUFNLFNBQVMsSUFBQSxDQUFLO0lBRXBCLElBQUksU0FBUztRQUNYLE9BQUEsQ0FBUSxLQUFSLENBQWMsVUFBVSxLQUFBLENBQU0sUUFBTjtRQUN4QixJQUFBLENBQUssWUFBTCxDQUFBLEVBQUEsQ0FBcUIsSUFBQSxDQUFLLFlBQUw7UUFDckIsSUFBQSxDQUFLLGVBQUwsQ0FBQSxFQUFBLENBQXdCLElBQUEsQ0FBSyxlQUFMO1FBQ3hCLE9BQUEsQ0FBUSxRQUFSLENBQWlCLE1BQUEsQ0FBTztJQUM1QjtJQUVFLE9BQU87QUFDVDtBQWxCQSIsImZpbGUiOiJkZWJ1Zy5qcyhvcmlnaW5hbCkiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBzdG9yZSA9PiBuZXh0ID0+IGFjdGlvbiA9PiB7XG4gIGNvbnN0IGlzRGVidWcgPSBzdG9yZS5nZXRTdGF0ZSgpLmRlYnVnXG5cbiAgaWYgKGlzRGVidWcpIHtcbiAgICBjb25zb2xlLmdyb3VwKGFjdGlvbi50eXBlKVxuICAgIGNvbnNvbGUuaW5mbygnYWN0aW9uOicsIGFjdGlvbilcbiAgfVxuXG4gIGNvbnN0IHJlc3VsdCA9IG5leHQoYWN0aW9uKVxuXG4gIGlmIChpc0RlYnVnKSB7XG4gICAgY29uc29sZS5kZWJ1Zygnc3RhdGU6Jywgc3RvcmUuZ2V0U3RhdGUoKSlcbiAgICBzZWxmLmxvZ1NlbGVjdG9ycyAmJiBzZWxmLmxvZ1NlbGVjdG9ycygpXG4gICAgc2VsZi5sb2dOZXh0UmVhY3Rpb24gJiYgc2VsZi5sb2dOZXh0UmVhY3Rpb24oKVxuICAgIGNvbnNvbGUuZ3JvdXBFbmQoYWN0aW9uLnR5cGUpXG4gIH1cblxuICByZXR1cm4gcmVzdWx0XG59XG4iXX0=
var ENABLE = 'DEBUG_ENABLED';
var DISABLE = 'DEBUG_DISABLED';
var debug$1 = {
    name: 'debug',
    reducer: function(state, ref) {
        if (state === void 0) state = HAS_DEBUG_FLAG;
        var type = ref.type;
        if (type === ENABLE) return true;
        if (type === DISABLE) return false;
        return state;
    },
    doEnableDebug: function() {
        return {
            type: ENABLE
        };
    },
    doDisableDebug: function() {
        return {
            type: DISABLE
        };
    },
    selectIsDebug: function(state) {
        return state.debug;
    },
    getMiddleware: function() {
        return debugMiddleware;
    },
    init: function(store) {
        if (store.selectIsDebug()) {
            var names = store.meta.chunks[0].bundleNames;
            self.store = store;
            var actionCreators = [];
            for(var key in store)if (key.indexOf('do') === 0) actionCreators.push(key);
            actionCreators.sort();
            var colorTitle = 'color: #1676D2;';
            var black = 'color: black;';
            var colorGreen = 'color: #4CAF50;';
            var colorOrange = 'color: #F57C00;';
            store.logSelectors = self.logSelectors = function() {
                if (!store.selectAll) return;
                console.log('%cselectors:', colorGreen, store.selectAll());
            };
            store.logBundles = self.logBundles = function() {
                console.log('%cinstalled bundles:\n  %c%s', colorTitle, black, names.join('\n  '));
            };
            store.logActionCreators = self.logActionCreators = function() {
                console.groupCollapsed('%caction creators', colorOrange);
                actionCreators.forEach(function(name) {
                    return console.log(name);
                });
                console.groupEnd();
            };
            store.logReactors = self.logReactors = function() {
                console.groupCollapsed('%creactors', colorOrange);
                var ref = store.meta;
                var reactorNames = ref.reactorNames;
                reactorNames.forEach(function(name) {
                    return console.log(name);
                });
                console.groupEnd();
            };
            store.logNextReaction = self.logNextReaction = function() {
                var nextReaction = store.nextReaction;
                var activeReactor = store.activeReactor;
                if (nextReaction) console.log("%cnext reaction:\n  %c" + activeReactor, colorOrange, black, nextReaction);
            };
            console.groupCollapsed('%credux bundler', colorTitle);
            store.logBundles();
            store.logSelectors();
            store.logReactors();
            console.groupEnd();
            if (store.isReacting) console.log("%cqueuing reaction:", colorOrange);
        }
    }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
var OFFLINE = 'OFFLINE';
var ONLINE = 'ONLINE';
var online = {
    name: 'online',
    selectIsOnline: function(state) {
        return state.online;
    },
    getReducer: function() {
        var initialState = IS_BROWSER ? navigator.onLine : true;
        return function(state, ref) {
            if (state === void 0) state = initialState;
            var type = ref.type;
            if (type === OFFLINE) return false;
            if (type === ONLINE) return true;
            return state;
        };
    },
    init: function(store) {
        addGlobalListener('online', function() {
            return store.dispatch({
                type: ONLINE
            });
        });
        addGlobalListener('offline', function() {
            return store.dispatch({
                type: OFFLINE
            });
        });
    }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm9ubGluZS5qcyhvcmlnaW5hbCkiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsUUFBUyxtQkFBbUIsaUJBQWtCO0FBRTlDLEtBQUEsQ0FBTSxVQUFVO0FBQ2hCLEtBQUEsQ0FBTSxTQUFTO0FBRWYsZUFBZTtJQUNiLE1BQU0sUUFETyxDQUFBO0lBRWIsZ0JBQWdCLEtBQUEsSUFBUyxLQUFBLENBQU0sTUFGbEIsQ0FBQTtJQUdiLGVBQVksR0FBTTtRQUNoQixLQUFBLENBQU0sZUFBZSxVQUFBLEdBQWEsU0FBQSxDQUFVLFNBQVM7UUFDckQsUUFBUSxLQUFBLEdBQVEsWUFBYyxFQUFBLENBQUUsT0FBekIsR0FBb0M7WUFDekMsSUFBSSxJQUFBLENBQUEsR0FBQSxDQUFTO2dCQUFTLE9BQU87WUFDN0IsSUFBSSxJQUFBLENBQUEsR0FBQSxDQUFTO2dCQUFRLE9BQU87WUFDNUIsT0FBTztRQUNiO0lBQ0EsQ0FWZSxDQUFBO0lBV2IsTUFBTSxLQUFBLElBQVM7UUFDYixpQkFBQSxDQUFrQixhQUFVLEdBQU0sS0FBQSxDQUFNLFFBQU4sQ0FBZTtZQUFFLE1BQU07O1FBQ3pELGlCQUFBLENBQWtCLGNBQVcsR0FBTSxLQUFBLENBQU0sUUFBTixDQUFlO1lBQUUsTUFBTTs7SUFDOUQ7O0FBbkJBIiwiZmlsZSI6Im9ubGluZS5qcyhvcmlnaW5hbCkiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBhZGRHbG9iYWxMaXN0ZW5lciwgSVNfQlJPV1NFUiB9IGZyb20gJy4uL3V0aWxzJ1xuXG5jb25zdCBPRkZMSU5FID0gJ09GRkxJTkUnXG5jb25zdCBPTkxJTkUgPSAnT05MSU5FJ1xuXG5leHBvcnQgZGVmYXVsdCB7XG4gIG5hbWU6ICdvbmxpbmUnLFxuICBzZWxlY3RJc09ubGluZTogc3RhdGUgPT4gc3RhdGUub25saW5lLFxuICBnZXRSZWR1Y2VyOiAoKSA9PiB7XG4gICAgY29uc3QgaW5pdGlhbFN0YXRlID0gSVNfQlJPV1NFUiA/IG5hdmlnYXRvci5vbkxpbmUgOiB0cnVlXG4gICAgcmV0dXJuIChzdGF0ZSA9IGluaXRpYWxTdGF0ZSwgeyB0eXBlIH0pID0+IHtcbiAgICAgIGlmICh0eXBlID09PSBPRkZMSU5FKSByZXR1cm4gZmFsc2VcbiAgICAgIGlmICh0eXBlID09PSBPTkxJTkUpIHJldHVybiB0cnVlXG4gICAgICByZXR1cm4gc3RhdGVcbiAgICB9XG4gIH0sXG4gIGluaXQ6IHN0b3JlID0+IHtcbiAgICBhZGRHbG9iYWxMaXN0ZW5lcignb25saW5lJywgKCkgPT4gc3RvcmUuZGlzcGF0Y2goeyB0eXBlOiBPTkxJTkUgfSkpXG4gICAgYWRkR2xvYmFsTGlzdGVuZXIoJ29mZmxpbmUnLCAoKSA9PiBzdG9yZS5kaXNwYXRjaCh7IHR5cGU6IE9GRkxJTkUgfSkpXG4gIH1cbn1cbiJdfQ==
var appTimeBundle = appTime;
var asyncCountBundle = asyncCount;
var createCacheBundle = caching;
var createRouteBundle = createRoutingBundle;
var createAsyncResourceBundle$1 = createAsyncResourceBundle;
var createReactorBundle = reactors;
var getIdleDispatcher$1 = getIdleDispatcher;
var onlineBundle = online;
var createUrlBundle = url;
var debugBundle = debug$1;
var composeBundlesRaw = composeBundles;
var createGeolocationBundle = geolocation;
var composeBundles$1 = function() {
    var userBundles = [], len = arguments.length;
    while(len--)userBundles[len] = arguments[len];
    userBundles || (userBundles = []);
    var bundles = [
        appTime,
        asyncCount,
        online,
        url(),
        reactors(),
        debug$1
    ].concat(userBundles);
    return composeBundles.apply(void 0, bundles);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gRAOl":[function(require,module,exports,__globalThis) {
/**
 * https://bugs.webkit.org/show_bug.cgi?id=226547
 * Safari has a horrible bug where IDB requests can hang while the browser is starting up.
 * The only solution is to keep nudging it until it's awake.
 * This probably creates garbage, but garbage is better than totally failing.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "get", ()=>_get);
parcelHelpers.export(exports, "getAll", ()=>_getAll);
parcelHelpers.export(exports, "getConfiguredCache", ()=>getConfiguredCache);
parcelHelpers.export(exports, "keyValLib", ()=>keyValLib);
parcelHelpers.export(exports, "set", ()=>_set);
function idbReady() {
    const isSafari = !navigator.userAgentData && /Safari\//.test(navigator.userAgent) && !/Chrom(e|ium)\//.test(navigator.userAgent);
    // No point putting other browsers or older versions of Safari through this mess.
    if (!isSafari || !indexedDB.databases) return Promise.resolve();
    let intervalId;
    return new Promise((resolve)=>{
        const tryIdb = ()=>indexedDB.databases().finally(resolve);
        intervalId = setInterval(tryIdb, 100);
        tryIdb();
    }).finally(()=>clearInterval(intervalId));
}
function promisifyRequest(request) {
    return new Promise((resolve, reject)=>{
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
function createStore(dbName, storeName) {
    const dbp = idbReady().then(()=>{
        const request = indexedDB.open(dbName);
        request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
        return promisifyRequest(request);
    });
    return (txMode, callback)=>dbp.then((db)=>callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let defaultGetStoreFunc;
function defaultGetStore() {
    if (!defaultGetStoreFunc) defaultGetStoreFunc = createStore('keyval-store', 'keyval');
    return defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function get(key, customStore = defaultGetStore()) {
    return customStore('readonly', (store)=>promisifyRequest(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function set(key, value, customStore = defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.put(value, key);
        return promisifyRequest(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function setMany(entries, customStore = defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        entries.forEach((entry)=>store.put(entry[1], entry[0]));
        return promisifyRequest(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function getMany(keys, customStore = defaultGetStore()) {
    return customStore('readonly', (store)=>Promise.all(keys.map((key)=>promisifyRequest(store.get(key)))));
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function update(key, updater, customStore = defaultGetStore()) {
    return customStore('readwrite', (store)=>// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise((resolve, reject)=>{
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve(promisifyRequest(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function del(key, customStore = defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.delete(key);
        return promisifyRequest(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function clear(customStore = defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.clear();
        return promisifyRequest(store.transaction);
    });
}
function eachCursor(customStore, callback) {
    return customStore('readonly', (store)=>{
        // This would be store.getAllKeys(), but it isn't supported by Edge or Safari.
        // And openKeyCursor isn't supported by Safari.
        store.openCursor().onsuccess = function() {
            if (!this.result) return;
            callback(this.result);
            this.result.continue();
        };
        return promisifyRequest(store.transaction);
    });
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function keys(customStore = defaultGetStore()) {
    const items = [];
    return eachCursor(customStore, (cursor)=>items.push(cursor.key)).then(()=>items);
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function values(customStore = defaultGetStore()) {
    const items = [];
    return eachCursor(customStore, (cursor)=>items.push(cursor.value)).then(()=>items);
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function entries(customStore = defaultGetStore()) {
    const items = [];
    return eachCursor(customStore, (cursor)=>items.push([
            cursor.key,
            cursor.value
        ])).then(()=>items);
}
var idbKeyVal = {
    __proto__: null,
    clear: clear,
    createStore: createStore,
    del: del,
    entries: entries,
    get: get,
    getMany: getMany,
    keys: keys,
    promisifyRequest: promisifyRequest,
    set: set,
    setMany: setMany,
    update: update,
    values: values
};
var defaultOpts = {
    maxAge: Infinity,
    version: 0,
    lib: idbKeyVal
};
var getOpts = function getOpts(passedOptions) {
    return Object.assign({}, defaultOpts, passedOptions);
};
var keyValLib = idbKeyVal;
var _get = function get(key, opts, store) {
    var _getOpts = getOpts(opts), maxAge = _getOpts.maxAge, version = _getOpts.version, lib = _getOpts.lib;
    return lib.get(key, store).then(JSON.parse).then(function(parsed) {
        var age = Date.now() - parsed.time;
        if (age > maxAge || version !== parsed.version) {
            lib.del(key, store);
            return null;
        }
        return parsed.data;
    })["catch"](function() {
        return null;
    });
};
var _set = function set(key, data, spec, store) {
    var _getOpts2 = getOpts(spec), lib = _getOpts2.lib, version = _getOpts2.version;
    return lib.set(key, JSON.stringify({
        version: version,
        time: Date.now(),
        data: data
    }), store)["catch"](function() {
        return null;
    });
};
var _getAll = function getAll(spec, store) {
    var opts = getOpts(spec);
    var keys;
    return opts.lib.keys(store).then(function(retrievedKeys) {
        keys = retrievedKeys;
        return Promise.all(keys.map(function(key) {
            return _get(key, opts, store);
        }));
    }).then(function(data) {
        return data.reduce(function(acc, bundleData, index) {
            if (bundleData) acc[keys[index]] = bundleData;
            return acc;
        }, {});
    })["catch"](function() {});
};
var getConfiguredCache = function getConfiguredCache(spec) {
    var opts = getOpts(spec);
    var store;
    if (opts.name) store = createStore(opts.name, opts.name);
    return {
        get: function get(key) {
            return _get(key, opts, store);
        },
        set: function set(key, val) {
            return _set(key, val, opts, store);
        },
        getAll: function getAll() {
            return _getAll(opts, store);
        },
        del: function del(key) {
            return opts.lib.del(key, store);
        },
        clear: function clear() {
            return opts.lib.clear(store);
        },
        keys: function keys() {
            return opts.lib.keys(store);
        }
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3RsD1":[function(require,module,exports,__globalThis) {
"use strict";
var _require = require("52c14d9e7e19563a"), DebounceInput = _require.DebounceInput;
DebounceInput.DebounceInput = DebounceInput;
module.exports = DebounceInput;

},{"52c14d9e7e19563a":"4HDlt"}],"4HDlt":[function(require,module,exports,__globalThis) {
"use strict";
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DebounceInput = void 0;
var _react = _interopRequireDefault(require("128a33a7d762642d"));
var _lodash = _interopRequireDefault(require("5f3b0b8c7ce8f44"));
var _excluded = [
    "element",
    "onChange",
    "value",
    "minLength",
    "debounceTimeout",
    "forceNotifyByEnter",
    "forceNotifyOnBlur",
    "onKeyDown",
    "onBlur",
    "inputRef"
];
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var DebounceInput = /*#__PURE__*/ function(_React$PureComponent) {
    _inherits(DebounceInput, _React$PureComponent);
    var _super = _createSuper(DebounceInput);
    function DebounceInput(props) {
        var _this;
        _classCallCheck(this, DebounceInput);
        _this = _super.call(this, props);
        _defineProperty(_assertThisInitialized(_this), "onChange", function(event) {
            event.persist();
            var oldValue = _this.state.value;
            var minLength = _this.props.minLength;
            _this.setState({
                value: event.target.value
            }, function() {
                var value = _this.state.value;
                if (value.length >= minLength) {
                    _this.notify(event);
                    return;
                } // If user hits backspace and goes below minLength consider it cleaning the value
                if (oldValue.length > value.length) _this.notify(_objectSpread(_objectSpread({}, event), {}, {
                    target: _objectSpread(_objectSpread({}, event.target), {}, {
                        value: ''
                    })
                }));
            });
        });
        _defineProperty(_assertThisInitialized(_this), "onKeyDown", function(event) {
            if (event.key === 'Enter') _this.forceNotify(event);
             // Invoke original onKeyDown if present
            var onKeyDown = _this.props.onKeyDown;
            if (onKeyDown) {
                event.persist();
                onKeyDown(event);
            }
        });
        _defineProperty(_assertThisInitialized(_this), "onBlur", function(event) {
            _this.forceNotify(event); // Invoke original onBlur if present
            var onBlur = _this.props.onBlur;
            if (onBlur) {
                event.persist();
                onBlur(event);
            }
        });
        _defineProperty(_assertThisInitialized(_this), "createNotifier", function(debounceTimeout) {
            if (debounceTimeout < 0) _this.notify = function() {
                return null;
            };
            else if (debounceTimeout === 0) _this.notify = _this.doNotify;
            else {
                var debouncedChangeFunc = (0, _lodash["default"])(function(event) {
                    _this.isDebouncing = false;
                    _this.doNotify(event);
                }, debounceTimeout);
                _this.notify = function(event) {
                    _this.isDebouncing = true;
                    debouncedChangeFunc(event);
                };
                _this.flush = function() {
                    return debouncedChangeFunc.flush();
                };
                _this.cancel = function() {
                    _this.isDebouncing = false;
                    debouncedChangeFunc.cancel();
                };
            }
        });
        _defineProperty(_assertThisInitialized(_this), "doNotify", function() {
            var onChange = _this.props.onChange;
            onChange.apply(void 0, arguments);
        });
        _defineProperty(_assertThisInitialized(_this), "forceNotify", function(event) {
            var debounceTimeout = _this.props.debounceTimeout;
            if (!_this.isDebouncing && debounceTimeout > 0) return;
            if (_this.cancel) _this.cancel();
            var value = _this.state.value;
            var minLength = _this.props.minLength;
            if (value.length >= minLength) _this.doNotify(event);
            else _this.doNotify(_objectSpread(_objectSpread({}, event), {}, {
                target: _objectSpread(_objectSpread({}, event.target), {}, {
                    value: value
                })
            }));
        });
        _this.isDebouncing = false;
        _this.state = {
            value: typeof props.value === 'undefined' || props.value === null ? '' : props.value
        };
        var _debounceTimeout2 = _this.props.debounceTimeout;
        _this.createNotifier(_debounceTimeout2);
        return _this;
    }
    _createClass(DebounceInput, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.isDebouncing) return;
                var _this$props = this.props, value = _this$props.value, debounceTimeout = _this$props.debounceTimeout;
                var oldTimeout = prevProps.debounceTimeout, oldValue = prevProps.value;
                var stateValue = this.state.value;
                if (typeof value !== 'undefined' && oldValue !== value && stateValue !== value) // Update state.value if new value passed via props, yep re-render should happen
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    value: value
                });
                if (debounceTimeout !== oldTimeout) this.createNotifier(debounceTimeout);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.flush) this.flush();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, element = _this$props2.element, _onChange = _this$props2.onChange, _value = _this$props2.value, _minLength = _this$props2.minLength, _debounceTimeout = _this$props2.debounceTimeout, forceNotifyByEnter = _this$props2.forceNotifyByEnter, forceNotifyOnBlur = _this$props2.forceNotifyOnBlur, onKeyDown = _this$props2.onKeyDown, onBlur = _this$props2.onBlur, inputRef = _this$props2.inputRef, props = _objectWithoutProperties(_this$props2, _excluded);
                var value = this.state.value;
                var maybeOnKeyDown;
                if (forceNotifyByEnter) maybeOnKeyDown = {
                    onKeyDown: this.onKeyDown
                };
                else if (onKeyDown) maybeOnKeyDown = {
                    onKeyDown: onKeyDown
                };
                else maybeOnKeyDown = {};
                var maybeOnBlur;
                if (forceNotifyOnBlur) maybeOnBlur = {
                    onBlur: this.onBlur
                };
                else if (onBlur) maybeOnBlur = {
                    onBlur: onBlur
                };
                else maybeOnBlur = {};
                var maybeRef = inputRef ? {
                    ref: inputRef
                } : {};
                return /*#__PURE__*/ _react["default"].createElement(element, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, props), {}, {
                    onChange: this.onChange,
                    value: value
                }, maybeOnKeyDown), maybeOnBlur), maybeRef));
            }
        }
    ]);
    return DebounceInput;
}(_react["default"].PureComponent);
exports.DebounceInput = DebounceInput;
_defineProperty(DebounceInput, "defaultProps", {
    element: 'input',
    type: 'text',
    onKeyDown: undefined,
    onBlur: undefined,
    value: undefined,
    minLength: 0,
    debounceTimeout: 100,
    forceNotifyByEnter: true,
    forceNotifyOnBlur: true,
    inputRef: undefined
});

},{"128a33a7d762642d":"bmhQu","5f3b0b8c7ce8f44":"igpZV"}],"igpZV":[function(require,module,exports,__globalThis) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var global = arguments[3];
var FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** `Object#toString` result references. */ var symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var now = function() {
    return root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    wait = toNumber(wait) || 0;
    if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge(now());
    }
    function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == 'number') return value;
    if (isSymbol(value)) return NAN;
    if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace(reTrim, '');
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = debounce;

},{}],"6Xv8z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _button = require("@restart/ui/Button");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Button = /*#__PURE__*/ _react.forwardRef(({ as, bsPrefix, variant = 'primary', size, active = false, disabled = false, className, ...props }, ref)=>{
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'btn');
    const [buttonProps, { tagName }] = (0, _button.useButtonProps)({
        tagName: as,
        disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, _classnamesDefault.default)(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && 'disabled')
    });
});
Button.displayName = 'Button';
exports.default = Button;

},{"classnames":"9HH2M","react":"bmhQu","@restart/ui/Button":"h42rE","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9HH2M":[function(require,module,exports,__globalThis) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

},{}],"h42rE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isTrivialHref", ()=>isTrivialHref);
parcelHelpers.export(exports, "useButtonProps", ()=>useButtonProps);
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "as",
    "disabled"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function isTrivialHref(href) {
    return !href || href.trim() === '#';
}
function useButtonProps({ tagName, disabled, href, target, rel, role, onClick, tabIndex = 0, type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = 'a';
        else tagName = 'button';
    }
    const meta = {
        tagName
    };
    if (tagName === 'button') return [
        {
            type: type || 'button',
            disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === 'a' && isTrivialHref(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === 'a') {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = '#');
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : 'button',
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href,
            target: tagName === 'a' ? target : undefined,
            'aria-disabled': !disabled ? undefined : disabled,
            rel: tagName === 'a' ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const Button = /*#__PURE__*/ _react.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled } = _ref, props = _objectWithoutPropertiesLoose(_ref, _excluded);
    const [buttonProps, { tagName: Component }] = useButtonProps(Object.assign({
        tagName: asProp,
        disabled
    }, props));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
Button.displayName = 'Button';
exports.default = Button;

},{"react":"bmhQu","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aQ1Mj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_BREAKPOINTS", ()=>DEFAULT_BREAKPOINTS);
parcelHelpers.export(exports, "DEFAULT_MIN_BREAKPOINT", ()=>DEFAULT_MIN_BREAKPOINT);
parcelHelpers.export(exports, "useBootstrapPrefix", ()=>useBootstrapPrefix);
parcelHelpers.export(exports, "useBootstrapBreakpoints", ()=>useBootstrapBreakpoints);
parcelHelpers.export(exports, "useBootstrapMinBreakpoint", ()=>useBootstrapMinBreakpoint);
parcelHelpers.export(exports, "useIsRTL", ()=>useIsRTL);
parcelHelpers.export(exports, "createBootstrapComponent", ()=>createBootstrapComponent);
parcelHelpers.export(exports, "ThemeConsumer", ()=>Consumer);
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DEFAULT_BREAKPOINTS = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const DEFAULT_MIN_BREAKPOINT = 'xs';
const ThemeContext = /*#__PURE__*/ _react.createContext({
    prefixes: {},
    breakpoints: DEFAULT_BREAKPOINTS,
    minBreakpoint: DEFAULT_MIN_BREAKPOINT
});
const { Consumer, Provider } = ThemeContext;
function ThemeProvider({ prefixes = {}, breakpoints = DEFAULT_BREAKPOINTS, minBreakpoint = DEFAULT_MIN_BREAKPOINT, dir, children }) {
    const contextValue = (0, _react.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints,
            minBreakpoint,
            dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Provider, {
        value: contextValue,
        children: children
    });
}
function useBootstrapPrefix(prefix, defaultPrefix) {
    const { prefixes } = (0, _react.useContext)(ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function useBootstrapBreakpoints() {
    const { breakpoints } = (0, _react.useContext)(ThemeContext);
    return breakpoints;
}
function useBootstrapMinBreakpoint() {
    const { minBreakpoint } = (0, _react.useContext)(ThemeContext);
    return minBreakpoint;
}
function useIsRTL() {
    const { dir } = (0, _react.useContext)(ThemeContext);
    return dir === 'rtl';
}
function createBootstrapComponent(Component, opts) {
    if (typeof opts === 'string') opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix, forwardRefAs = isClassy ? 'ref' : 'innerRef' } = opts;
    const Wrapped = /*#__PURE__*/ _react.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = useBootstrapPrefix(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
exports.default = ThemeProvider;

},{"react":"bmhQu","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jdRoo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _formCheckInput = require("./FormCheckInput");
var _formCheckInputDefault = parcelHelpers.interopDefault(_formCheckInput);
var _inputGroupContext = require("./InputGroupContext");
var _inputGroupContextDefault = parcelHelpers.interopDefault(_inputGroupContext);
var _inputGroupText = require("./InputGroupText");
var _inputGroupTextDefault = parcelHelpers.interopDefault(_inputGroupText);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const InputGroupCheckbox = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputGroupTextDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formCheckInputDefault.default), {
            type: "checkbox",
            ...props
        })
    });
const InputGroupRadio = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputGroupTextDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formCheckInputDefault.default), {
            type: "radio",
            ...props
        })
    });
const InputGroup = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, size, hasValidation, className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'input-group');
    // Intentionally an empty object. Used in detecting if a dropdown
    // exists under an input group.
    const contextValue = (0, _react.useMemo)(()=>({}), []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputGroupContextDefault.default).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, _classnamesDefault.default)(className, bsPrefix, size && `${bsPrefix}-${size}`, hasValidation && 'has-validation')
        })
    });
});
InputGroup.displayName = 'InputGroup';
exports.default = Object.assign(InputGroup, {
    Text: (0, _inputGroupTextDefault.default),
    Radio: InputGroupRadio,
    Checkbox: InputGroupCheckbox
});

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","./FormCheckInput":"6Bo9v","./InputGroupContext":"kopE8","./InputGroupText":"lbuM5","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6Bo9v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _formContext = require("./FormContext");
var _formContextDefault = parcelHelpers.interopDefault(_formContext);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FormCheckInput = /*#__PURE__*/ _react.forwardRef(({ id, bsPrefix, className, type = 'checkbox', isValid = false, isInvalid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId } = (0, _react.useContext)((0, _formContextDefault.default));
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'form-check-input');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, _classnamesDefault.default)(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
FormCheckInput.displayName = 'FormCheckInput';
exports.default = FormCheckInput;

},{"classnames":"9HH2M","react":"bmhQu","./FormContext":"gJVRs","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gJVRs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
// TODO
const FormContext = /*#__PURE__*/ _react.createContext({});
exports.default = FormContext;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kopE8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
const context = /*#__PURE__*/ _react.createContext(null);
context.displayName = 'InputGroupContext';
exports.default = context;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lbuM5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const InputGroupText = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'input-group-text');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
InputGroupText.displayName = 'InputGroupText';
exports.default = InputGroupText;

},{"react":"bmhQu","classnames":"9HH2M","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"axkz0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _uncontrollable = require("uncontrollable");
var _nav = require("@restart/ui/Nav");
var _navDefault = parcelHelpers.interopDefault(_nav);
var _themeProvider = require("./ThemeProvider");
var _navbarContext = require("./NavbarContext");
var _navbarContextDefault = parcelHelpers.interopDefault(_navbarContext);
var _cardHeaderContext = require("./CardHeaderContext");
var _cardHeaderContextDefault = parcelHelpers.interopDefault(_cardHeaderContext);
var _navItem = require("./NavItem");
var _navItemDefault = parcelHelpers.interopDefault(_navItem);
var _navLink = require("./NavLink");
var _navLinkDefault = parcelHelpers.interopDefault(_navLink);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Nav = /*#__PURE__*/ _react.forwardRef((uncontrolledProps, ref)=>{
    const { as = 'div', bsPrefix: initialBsPrefix, variant, fill = false, justify = false, navbar, navbarScroll, className, activeKey, ...props } = (0, _uncontrollable.useUncontrolled)(uncontrolledProps, {
        activeKey: 'onSelect'
    });
    const bsPrefix = (0, _themeProvider.useBootstrapPrefix)(initialBsPrefix, 'nav');
    let navbarBsPrefix;
    let cardHeaderBsPrefix;
    let isNavbar = false;
    const navbarContext = (0, _react.useContext)((0, _navbarContextDefault.default));
    const cardHeaderContext = (0, _react.useContext)((0, _cardHeaderContextDefault.default));
    if (navbarContext) {
        navbarBsPrefix = navbarContext.bsPrefix;
        isNavbar = navbar == null ? true : navbar;
    } else if (cardHeaderContext) ({ cardHeaderBsPrefix } = cardHeaderContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navDefault.default), {
        as: as,
        ref: ref,
        activeKey: activeKey,
        className: (0, _classnamesDefault.default)(className, {
            [bsPrefix]: !isNavbar,
            [`${navbarBsPrefix}-nav`]: isNavbar,
            [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
            [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
            [`${bsPrefix}-${variant}`]: !!variant,
            [`${bsPrefix}-fill`]: fill,
            [`${bsPrefix}-justified`]: justify
        }),
        ...props
    });
});
Nav.displayName = 'Nav';
exports.default = Object.assign(Nav, {
    Item: (0, _navItemDefault.default),
    Link: (0, _navLinkDefault.default)
});

},{"classnames":"9HH2M","react":"bmhQu","uncontrollable":"1yRhe","@restart/ui/Nav":"hvvF8","./ThemeProvider":"aQ1Mj","./NavbarContext":"e2mN2","./CardHeaderContext":"dlz2Y","./NavItem":"ciiMI","./NavLink":"e3vjD","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1yRhe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useUncontrolled", ()=>(0, _hookDefault.default));
parcelHelpers.export(exports, "useUncontrolledProp", ()=>(0, _hook.useUncontrolledProp));
parcelHelpers.export(exports, "uncontrollable", ()=>(0, _uncontrollableDefault.default));
var _hook = require("./hook");
var _hookDefault = parcelHelpers.interopDefault(_hook);
var _uncontrollable = require("./uncontrollable");
var _uncontrollableDefault = parcelHelpers.interopDefault(_uncontrollable);

},{"./hook":"dYZnO","./uncontrollable":"6mN2t","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dYZnO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useUncontrolledProp", ()=>useUncontrolledProp);
parcelHelpers.export(exports, "default", ()=>useUncontrolled);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _utils = require("./utils");
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function useUncontrolledProp(propValue, defaultValue, handler) {
    var wasPropRef = (0, _react.useRef)(propValue !== undefined);
    var _useState = (0, _react.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, _react.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function useUncontrolled(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[_utils.defaultKey(fieldName)], propsValue = _ref[fieldName], rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
            _utils.defaultKey(fieldName),
            fieldName
        ].map(_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = useUncontrolledProp(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, _extendsDefault.default)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}

},{"@babel/runtime/helpers/esm/extends":"85Hd3","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"ds1mq","react":"bmhQu","./utils":"aQyAu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"85Hd3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ds1mq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectWithoutPropertiesLoose);
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aQyAu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "uncontrolledPropTypes", ()=>uncontrolledPropTypes);
parcelHelpers.export(exports, "isProp", ()=>isProp);
parcelHelpers.export(exports, "defaultKey", ()=>defaultKey);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ parcelHelpers.export(exports, "canAcceptRef", ()=>canAcceptRef);
var _invariant = require("invariant");
var _invariantDefault = parcelHelpers.interopDefault(_invariant);
var noop = function noop() {};
function readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + defaultKey(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function uncontrolledPropTypes(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[defaultKey(prop)] = noop;
        var handler;
    });
    return propTypes;
}
function isProp(props, prop) {
    return props[prop] !== undefined;
}
function defaultKey(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function canAcceptRef(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}

},{"invariant":"3cETI","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3cETI":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = invariant;

},{}],"6mN2t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>uncontrollable);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactLifecyclesCompat = require("react-lifecycles-compat");
var _invariant = require("invariant");
var _invariantDefault = parcelHelpers.interopDefault(_invariant);
var _utils = require("./utils");
var _jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function uncontrollable(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = _utils.canAcceptRef(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map(_utils.defaultKey);
    !(canAcceptRef || !methods.length) && (0, _invariantDefault.default)(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, _inheritsLooseDefault.default)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, _extendsDefault.default)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[_utils.defaultKey(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, _extendsDefault.default)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!_utils.isProp(props, key) && _utils.isProp(prevProps, key)) nextState.values[key] = props[_utils.defaultKey(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, _reactDefault.default).createElement(Component, (0, _extendsDefault.default)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, _reactDefault.default).Component);
    (0, _reactLifecyclesCompat.polyfill)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, _extendsDefault.default)({
        innerRef: function innerRef() {}
    }, _utils.uncontrolledPropTypes(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, _reactDefault.default).forwardRef) {
        WrappedComponent = (0, _reactDefault.default).forwardRef(function(props, ref) {
            return (0, _reactDefault.default).createElement(UncontrolledComponent, (0, _extendsDefault.default)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: _jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return uncontrollable(newComponent, (0, _extendsDefault.default)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"ds1mq","@babel/runtime/helpers/esm/extends":"85Hd3","@babel/runtime/helpers/esm/inheritsLoose":"hJ1FM","react":"bmhQu","react-lifecycles-compat":"itCeo","invariant":"3cETI","./utils":"aQyAu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hJ1FM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inheritsLoose);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, _setPrototypeOfJsDefault.default)(t, o);
}

},{"./setPrototypeOf.js":"9xLGZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9xLGZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_setPrototypeOf);
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"itCeo":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "polyfill", ()=>polyfill);
function componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;
function polyfill(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = componentWillMount;
        prototype.componentWillReceiveProps = componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hvvF8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _querySelectorAll = require("dom-helpers/querySelectorAll");
var _querySelectorAllDefault = parcelHelpers.interopDefault(_querySelectorAll);
var _react = require("react");
var _useForceUpdate = require("@restart/hooks/useForceUpdate");
var _useForceUpdateDefault = parcelHelpers.interopDefault(_useForceUpdate);
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
var _navContext = require("./NavContext");
var _navContextDefault = parcelHelpers.interopDefault(_navContext);
var _selectableContext = require("./SelectableContext");
var _selectableContextDefault = parcelHelpers.interopDefault(_selectableContext);
var _tabContext = require("./TabContext");
var _tabContextDefault = parcelHelpers.interopDefault(_tabContext);
var _dataKey = require("./DataKey");
var _navItem = require("./NavItem");
var _navItemDefault = parcelHelpers.interopDefault(_navItem);
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = ()=>{};
const EVENT_KEY_ATTR = (0, _dataKey.dataAttr)('event-key');
const Nav = /*#__PURE__*/ _react.forwardRef((_ref, ref)=>{
    let { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', onSelect, activeKey, role, onKeyDown } = _ref, props = _objectWithoutPropertiesLoose(_ref, _excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    const forceUpdate = (0, _useForceUpdateDefault.default)();
    const needsRefocusRef = (0, _react.useRef)(false);
    const parentOnSelect = (0, _react.useContext)((0, _selectableContextDefault.default));
    const tabContext = (0, _react.useContext)((0, _tabContextDefault.default));
    let getControlledId, getControllerId;
    if (tabContext) {
        role = role || 'tablist';
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    const listNode = (0, _react.useRef)(null);
    const getNextActiveTab = (offset)=>{
        const currentListNode = listNode.current;
        if (!currentListNode) return null;
        const items = (0, _querySelectorAllDefault.default)(currentListNode, `[${EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
        const activeChild = currentListNode.querySelector('[aria-selected=true]');
        if (!activeChild || activeChild !== document.activeElement) return null;
        const index = items.indexOf(activeChild);
        if (index === -1) return null;
        let nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    const handleSelect = (key, event)=>{
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        let nextActiveChild;
        switch(event.key){
            case 'ArrowLeft':
            case 'ArrowUp':
                nextActiveChild = getNextActiveTab(-1);
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, _dataKey.dataProp)('EventKey')] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, _react.useEffect)(()=>{
        if (listNode.current && needsRefocusRef.current) {
            const activeChild = listNode.current.querySelector(`[${EVENT_KEY_ATTR}][aria-selected=true]`);
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    const mergedRef = (0, _useMergedRefsDefault.default)(ref, listNode);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectableContextDefault.default).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navContextDefault.default).Provider, {
            value: {
                role,
                // used by NavLink to determine it's role
                activeKey: (0, _selectableContext.makeEventKey)(activeKey),
                getControlledId: getControlledId || noop,
                getControllerId: getControllerId || noop
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
Nav.displayName = 'Nav';
exports.default = Object.assign(Nav, {
    Item: (0, _navItemDefault.default)
});

},{"dom-helpers/querySelectorAll":"ctiqR","react":"bmhQu","@restart/hooks/useForceUpdate":"ekHOI","@restart/hooks/useMergedRefs":"hXy8K","./NavContext":"dfejx","./SelectableContext":"e59aX","./TabContext":"1801Q","./DataKey":"g9Cvj","./NavItem":"fiRYi","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ctiqR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>qsa);
var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function qsa(element, selector) {
    return toArray(element.querySelectorAll(selector));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ekHOI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useForceUpdate);
var _react = require("react");
function useForceUpdate() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, _react.useReducer)((revision)=>revision + 1, 0);
    return dispatch;
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hXy8K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeRefs", ()=>mergeRefs);
var _react = require("react");
const toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function mergeRefs(refA, refB) {
    const a = toFnRef(refA);
    const b = toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function useMergedRefs(refA, refB) {
    return (0, _react.useMemo)(()=>mergeRefs(refA, refB), [
        refA,
        refB
    ]);
}
exports.default = useMergedRefs;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dfejx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const NavContext = /*#__PURE__*/ _react.createContext(null);
NavContext.displayName = 'NavContext';
exports.default = NavContext;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e59aX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeEventKey", ()=>makeEventKey);
var _react = require("react");
const SelectableContext = /*#__PURE__*/ _react.createContext(null);
const makeEventKey = (eventKey, href = null)=>{
    if (eventKey != null) return String(eventKey);
    return href || null;
};
exports.default = SelectableContext;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1801Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const TabContext = /*#__PURE__*/ _react.createContext(null);
exports.default = TabContext;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g9Cvj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ATTRIBUTE_PREFIX", ()=>ATTRIBUTE_PREFIX);
parcelHelpers.export(exports, "PROPERTY_PREFIX", ()=>PROPERTY_PREFIX);
parcelHelpers.export(exports, "dataAttr", ()=>dataAttr);
parcelHelpers.export(exports, "dataProp", ()=>dataProp);
const ATTRIBUTE_PREFIX = `data-rr-ui-`;
const PROPERTY_PREFIX = `rrUi`;
function dataAttr(property) {
    return `${ATTRIBUTE_PREFIX}${property}`;
}
function dataProp(property) {
    return `${PROPERTY_PREFIX}${property}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fiRYi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useNavItem", ()=>useNavItem);
var _react = require("react");
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _navContext = require("./NavContext");
var _navContextDefault = parcelHelpers.interopDefault(_navContext);
var _selectableContext = require("./SelectableContext");
var _selectableContextDefault = parcelHelpers.interopDefault(_selectableContext);
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _dataKey = require("./DataKey");
var _tabContext = require("./TabContext");
var _tabContextDefault = parcelHelpers.interopDefault(_tabContext);
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "as",
    "active",
    "eventKey"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function useNavItem({ key, onClick, active, id, role, disabled }) {
    const parentOnSelect = (0, _react.useContext)((0, _selectableContextDefault.default));
    const navContext = (0, _react.useContext)((0, _navContextDefault.default));
    const tabContext = (0, _react.useContext)((0, _tabContextDefault.default));
    let isActive = active;
    const props = {
        role
    };
    if (navContext) {
        if (!role && navContext.role === 'tablist') props.role = 'tab';
        const contextControllerId = navContext.getControllerId(key != null ? key : null);
        const contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, _dataKey.dataAttr)('event-key')] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props['aria-controls'] = contextControlledId;
    }
    if (props.role === 'tab') {
        props['aria-selected'] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props['aria-disabled'] = true;
        }
    }
    props.onClick = (0, _useEventCallbackDefault.default)((e)=>{
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive
        }
    ];
}
const NavItem = /*#__PURE__*/ _react.forwardRef((_ref, ref)=>{
    let { as: Component = (0, _buttonDefault.default), active, eventKey } = _ref, options = _objectWithoutPropertiesLoose(_ref, _excluded);
    const [props, meta] = useNavItem(Object.assign({
        key: (0, _selectableContext.makeEventKey)(eventKey, options.href),
        active
    }, options));
    // @ts-ignore
    props[(0, _dataKey.dataAttr)('active')] = meta.isActive;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
NavItem.displayName = 'NavItem';
exports.default = NavItem;

},{"react":"bmhQu","@restart/hooks/useEventCallback":"j7CsD","./NavContext":"dfejx","./SelectableContext":"e59aX","./Button":"h42rE","./DataKey":"g9Cvj","./TabContext":"1801Q","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j7CsD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useEventCallback);
var _react = require("react");
var _useCommittedRef = require("./useCommittedRef");
var _useCommittedRefDefault = parcelHelpers.interopDefault(_useCommittedRef);
function useEventCallback(fn) {
    const ref = (0, _useCommittedRefDefault.default)(fn);
    return (0, _react.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}

},{"react":"bmhQu","./useCommittedRef":"ihNAy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ihNAy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function useCommittedRef(value) {
    const ref = (0, _react.useRef)(value);
    (0, _react.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
exports.default = useCommittedRef;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e2mN2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
// TODO: check
const context = /*#__PURE__*/ _react.createContext(null);
context.displayName = 'NavbarContext';
exports.default = context;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dlz2Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
const context = /*#__PURE__*/ _react.createContext(null);
context.displayName = 'CardHeaderContext';
exports.default = context;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ciiMI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const NavItem = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'nav-item');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
NavItem.displayName = 'NavItem';
exports.default = NavItem;

},{"react":"bmhQu","classnames":"9HH2M","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e3vjD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _anchor = require("@restart/ui/Anchor");
var _anchorDefault = parcelHelpers.interopDefault(_anchor);
var _navItem = require("@restart/ui/NavItem");
var _selectableContext = require("@restart/ui/SelectableContext");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const NavLink = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, as: Component = (0, _anchorDefault.default), active, eventKey, disabled = false, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'nav-link');
    const [navItemProps, meta] = (0, _navItem.useNavItem)({
        key: (0, _selectableContext.makeEventKey)(eventKey, props.href),
        active,
        disabled,
        ...props
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        ...navItemProps,
        ref: ref,
        disabled: disabled,
        className: (0, _classnamesDefault.default)(className, bsPrefix, disabled && 'disabled', meta.isActive && 'active')
    });
});
NavLink.displayName = 'NavLink';
exports.default = NavLink;

},{"classnames":"9HH2M","react":"bmhQu","@restart/ui/Anchor":"iVIEK","@restart/ui/NavItem":"fiRYi","@restart/ui/SelectableContext":"e59aX","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iVIEK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isTrivialHref", ()=>isTrivialHref);
/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/anchor-has-content */ var _react = require("react");
var _hooks = require("@restart/hooks");
var _button = require("./Button");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "onKeyDown"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function isTrivialHref(href) {
    return !href || href.trim() === '#';
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const Anchor = /*#__PURE__*/ _react.forwardRef((_ref, ref)=>{
    let { onKeyDown } = _ref, props = _objectWithoutPropertiesLoose(_ref, _excluded);
    const [buttonProps] = (0, _button.useButtonProps)(Object.assign({
        tagName: 'a'
    }, props));
    const handleKeyDown = (0, _hooks.useEventCallback)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if (isTrivialHref(props.href) || props.role === 'button') return /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
Anchor.displayName = 'Anchor';
exports.default = Anchor;

},{"react":"bmhQu","@restart/hooks":"1i1cW","./Button":"h42rE","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1i1cW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCallbackRef", ()=>(0, _useCallbackRefDefault.default));
parcelHelpers.export(exports, "useCommittedRef", ()=>(0, _useCommittedRefDefault.default));
parcelHelpers.export(exports, "useEventCallback", ()=>(0, _useEventCallbackDefault.default));
parcelHelpers.export(exports, "useEventListener", ()=>(0, _useEventListenerDefault.default));
parcelHelpers.export(exports, "useGlobalListener", ()=>(0, _useGlobalListenerDefault.default));
parcelHelpers.export(exports, "useInterval", ()=>(0, _useIntervalDefault.default));
parcelHelpers.export(exports, "useRafInterval", ()=>(0, _useRafIntervalDefault.default));
parcelHelpers.export(exports, "useMergeState", ()=>(0, _useMergeStateDefault.default));
parcelHelpers.export(exports, "useMergeStateFromProps", ()=>(0, _useMergeStateFromPropsDefault.default));
parcelHelpers.export(exports, "useMounted", ()=>(0, _useMountedDefault.default));
parcelHelpers.export(exports, "usePrevious", ()=>(0, _usePreviousDefault.default));
parcelHelpers.export(exports, "useImage", ()=>(0, _useImageDefault.default));
parcelHelpers.export(exports, "useResizeObserver", ()=>(0, _useResizeObserverDefault.default));
var _useCallbackRef = require("./useCallbackRef");
var _useCallbackRefDefault = parcelHelpers.interopDefault(_useCallbackRef);
var _useCommittedRef = require("./useCommittedRef");
var _useCommittedRefDefault = parcelHelpers.interopDefault(_useCommittedRef);
var _useEventCallback = require("./useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useEventListener = require("./useEventListener");
var _useEventListenerDefault = parcelHelpers.interopDefault(_useEventListener);
var _useGlobalListener = require("./useGlobalListener");
var _useGlobalListenerDefault = parcelHelpers.interopDefault(_useGlobalListener);
var _useInterval = require("./useInterval");
var _useIntervalDefault = parcelHelpers.interopDefault(_useInterval);
var _useRafInterval = require("./useRafInterval");
var _useRafIntervalDefault = parcelHelpers.interopDefault(_useRafInterval);
var _useMergeState = require("./useMergeState");
var _useMergeStateDefault = parcelHelpers.interopDefault(_useMergeState);
var _useMergeStateFromProps = require("./useMergeStateFromProps");
var _useMergeStateFromPropsDefault = parcelHelpers.interopDefault(_useMergeStateFromProps);
var _useMounted = require("./useMounted");
var _useMountedDefault = parcelHelpers.interopDefault(_useMounted);
var _usePrevious = require("./usePrevious");
var _usePreviousDefault = parcelHelpers.interopDefault(_usePrevious);
var _useImage = require("./useImage");
var _useImageDefault = parcelHelpers.interopDefault(_useImage);
var _useResizeObserver = require("./useResizeObserver");
var _useResizeObserverDefault = parcelHelpers.interopDefault(_useResizeObserver);

},{"./useCallbackRef":"dezJ9","./useCommittedRef":"ihNAy","./useEventCallback":"j7CsD","./useEventListener":"i7vdC","./useGlobalListener":"k09Pk","./useInterval":"ayL6m","./useRafInterval":"gc5FC","./useMergeState":"gKDQR","./useMergeStateFromProps":"i3pBm","./useMounted":"gkvSP","./usePrevious":"6GTFb","./useImage":"6jnh2","./useResizeObserver":"fsvxC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dezJ9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useCallbackRef);
var _react = require("react");
function useCallbackRef() {
    return (0, _react.useState)(null);
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i7vdC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useEventListener);
var _react = require("react");
var _useEventCallback = require("./useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
function useEventListener(eventTarget, event, listener, capture = false) {
    const handler = (0, _useEventCallbackDefault.default)(listener);
    (0, _react.useEffect)(()=>{
        const target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}

},{"react":"bmhQu","./useEventCallback":"j7CsD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k09Pk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useGlobalListener);
var _useEventListener = require("./useEventListener");
var _useEventListenerDefault = parcelHelpers.interopDefault(_useEventListener);
var _react = require("react");
function useGlobalListener(event, handler, capture = false) {
    const documentTarget = (0, _react.useCallback)(()=>document, []);
    return (0, _useEventListenerDefault.default)(documentTarget, event, handler, capture);
}

},{"./useEventListener":"i7vdC","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ayL6m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useCommittedRef = require("./useCommittedRef");
var _useCommittedRefDefault = parcelHelpers.interopDefault(_useCommittedRef);
/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function useInterval(fn, ms, paused = false, runImmediately = false) {
    let handle;
    const fnRef = (0, _useCommittedRefDefault.default)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, _useCommittedRefDefault.default)(paused);
    const tick = ()=>{
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    const schedule = ()=>{
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, _react.useEffect)(()=>{
        if (runImmediately) tick();
        else schedule();
        return ()=>clearTimeout(handle);
    }, [
        paused,
        runImmediately
    ]);
}
exports.default = useInterval;

},{"react":"bmhQu","./useCommittedRef":"ihNAy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gc5FC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useCommittedRef = require("./useCommittedRef");
var _useCommittedRefDefault = parcelHelpers.interopDefault(_useCommittedRef);
function useRafInterval(fn, ms, paused = false) {
    let handle;
    let start = new Date().getTime();
    const fnRef = (0, _useCommittedRefDefault.default)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, _useCommittedRefDefault.default)(paused);
    function loop() {
        const current = new Date().getTime();
        const delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, _react.useEffect)(()=>{
        handle = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(handle);
    }, []);
}
exports.default = useRafInterval;

},{"react":"bmhQu","./useCommittedRef":"ihNAy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gKDQR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useMergeState);
var _react = require("react");
function useMergeState(initialState) {
    const [state, setState] = (0, _react.useState)(initialState);
    const updater = (0, _react.useCallback)((update)=>{
        if (update === null) return;
        if (typeof update === 'function') setState((state)=>{
            const nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState((state)=>Object.assign({}, state, update));
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i3pBm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useMergeStateFromProps);
var _useMergeState = require("./useMergeState");
var _useMergeStateDefault = parcelHelpers.interopDefault(_useMergeState);
function useMergeStateFromProps(props, gDSFP, initialState) {
    const [state, setState] = (0, _useMergeStateDefault.default)(initialState);
    const nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}

},{"./useMergeState":"gKDQR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gkvSP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useMounted);
var _react = require("react");
function useMounted() {
    const mounted = (0, _react.useRef)(true);
    const isMounted = (0, _react.useRef)(()=>mounted.current);
    (0, _react.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6GTFb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePrevious);
var _react = require("react");
function usePrevious(value) {
    const ref = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6jnh2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useImage);
var _react = require("react");
function useImage(imageOrUrl, crossOrigin) {
    const [state, setState] = (0, _react.useState)({
        image: null,
        error: null
    });
    (0, _react.useEffect)(()=>{
        if (!imageOrUrl) return undefined;
        let image;
        if (typeof imageOrUrl === 'string') {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image,
                error
            });
        }
        image.addEventListener('load', onLoad);
        image.addEventListener('error', onError);
        return ()=>{
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fsvxC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useResizeObserver);
var _react = require("react");
var _useIsomorphicEffect = require("./useIsomorphicEffect");
var _useIsomorphicEffectDefault = parcelHelpers.interopDefault(_useIsomorphicEffect);
const targetMap = new WeakMap();
let resizeObserver;
function getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return resizeObserver = resizeObserver || new window.ResizeObserver((entries)=>{
        entries.forEach((entry)=>{
            const handler = targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function useResizeObserver(element) {
    const [rect, setRect] = (0, _react.useState)(null);
    (0, _useIsomorphicEffectDefault.default)(()=>{
        if (!element) return;
        getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        targetMap.set(element, (rect)=>{
            setRect(rect);
        });
        return ()=>{
            targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}

},{"react":"bmhQu","./useIsomorphicEffect":"24dnS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"24dnS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var global = arguments[3];
const isReactNative = typeof global !== 'undefined' && // @ts-ignore
global.navigator && // @ts-ignore
global.navigator.product === 'ReactNative';
const isDOM = typeof document !== 'undefined';
/**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ exports.default = isDOM || isReactNative ? (0, _react.useLayoutEffect) : (0, _react.useEffect);

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"34dRz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _selectableContext = require("@restart/ui/SelectableContext");
var _selectableContextDefault = parcelHelpers.interopDefault(_selectableContext);
var _uncontrollable = require("uncontrollable");
var _navbarBrand = require("./NavbarBrand");
var _navbarBrandDefault = parcelHelpers.interopDefault(_navbarBrand);
var _navbarCollapse = require("./NavbarCollapse");
var _navbarCollapseDefault = parcelHelpers.interopDefault(_navbarCollapse);
var _navbarToggle = require("./NavbarToggle");
var _navbarToggleDefault = parcelHelpers.interopDefault(_navbarToggle);
var _navbarOffcanvas = require("./NavbarOffcanvas");
var _navbarOffcanvasDefault = parcelHelpers.interopDefault(_navbarOffcanvas);
var _themeProvider = require("./ThemeProvider");
var _navbarContext = require("./NavbarContext");
var _navbarContextDefault = parcelHelpers.interopDefault(_navbarContext);
var _navbarText = require("./NavbarText");
var _navbarTextDefault = parcelHelpers.interopDefault(_navbarText);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Navbar = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { bsPrefix: initialBsPrefix, expand = true, variant = 'light', bg, fixed, sticky, className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'nav', expanded, onToggle, onSelect, collapseOnSelect = false, ...controlledProps } = (0, _uncontrollable.useUncontrolled)(props, {
        expanded: 'onToggle'
    });
    const bsPrefix = (0, _themeProvider.useBootstrapPrefix)(initialBsPrefix, 'navbar');
    const handleCollapse = (0, _react.useCallback)((...args)=>{
        onSelect == null || onSelect(...args);
        if (collapseOnSelect && expanded) onToggle == null || onToggle(false);
    }, [
        onSelect,
        collapseOnSelect,
        expanded,
        onToggle
    ]);
    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one
    if (controlledProps.role === undefined && Component !== 'nav') controlledProps.role = 'navigation';
    let expandClass = `${bsPrefix}-expand`;
    if (typeof expand === 'string') expandClass = `${expandClass}-${expand}`;
    const navbarContext = (0, _react.useMemo)(()=>({
            onToggle: ()=>onToggle == null ? void 0 : onToggle(!expanded),
            bsPrefix,
            expanded: !!expanded,
            expand
        }), [
        bsPrefix,
        expanded,
        expand,
        onToggle
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navbarContextDefault.default).Provider, {
        value: navbarContext,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectableContextDefault.default).Provider, {
            value: handleCollapse,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
                ref: ref,
                ...controlledProps,
                className: (0, _classnamesDefault.default)(className, bsPrefix, expand && expandClass, variant && `${bsPrefix}-${variant}`, bg && `bg-${bg}`, sticky && `sticky-${sticky}`, fixed && `fixed-${fixed}`)
            })
        })
    });
});
Navbar.displayName = 'Navbar';
exports.default = Object.assign(Navbar, {
    Brand: (0, _navbarBrandDefault.default),
    Collapse: (0, _navbarCollapseDefault.default),
    Offcanvas: (0, _navbarOffcanvasDefault.default),
    Text: (0, _navbarTextDefault.default),
    Toggle: (0, _navbarToggleDefault.default)
});

},{"classnames":"9HH2M","react":"bmhQu","@restart/ui/SelectableContext":"e59aX","uncontrollable":"1yRhe","./NavbarBrand":"KlMqJ","./NavbarCollapse":"a8aGZ","./NavbarToggle":"kc1gC","./NavbarOffcanvas":"kKQ8O","./ThemeProvider":"aQ1Mj","./NavbarContext":"e2mN2","./NavbarText":"g0Ec4","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"KlMqJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const NavbarBrand = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, as, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'navbar-brand');
    const Component = as || (props.href ? 'a' : 'span');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix)
    });
});
NavbarBrand.displayName = 'NavbarBrand';
exports.default = NavbarBrand;

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a8aGZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _collapse = require("./Collapse");
var _collapseDefault = parcelHelpers.interopDefault(_collapse);
var _themeProvider = require("./ThemeProvider");
var _navbarContext = require("./NavbarContext");
var _navbarContextDefault = parcelHelpers.interopDefault(_navbarContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const NavbarCollapse = /*#__PURE__*/ _react.forwardRef(({ children, bsPrefix, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'navbar-collapse');
    const context = (0, _react.useContext)((0, _navbarContextDefault.default));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapseDefault.default), {
        in: !!(context && context.expanded),
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            ref: ref,
            className: bsPrefix,
            children: children
        })
    });
});
NavbarCollapse.displayName = 'NavbarCollapse';
exports.default = NavbarCollapse;

},{"react":"bmhQu","./Collapse":"fzFC1","./ThemeProvider":"aQ1Mj","./NavbarContext":"e2mN2","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fzFC1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _css = require("dom-helpers/css");
var _cssDefault = parcelHelpers.interopDefault(_css);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _transition = require("react-transition-group/Transition");
var _utils = require("@restart/ui/utils");
var _transitionEndListener = require("./transitionEndListener");
var _transitionEndListenerDefault = parcelHelpers.interopDefault(_transitionEndListener);
var _createChainedFunction = require("./createChainedFunction");
var _createChainedFunctionDefault = parcelHelpers.interopDefault(_createChainedFunction);
var _triggerBrowserReflow = require("./triggerBrowserReflow");
var _triggerBrowserReflowDefault = parcelHelpers.interopDefault(_triggerBrowserReflow);
var _transitionWrapper = require("./TransitionWrapper");
var _transitionWrapperDefault = parcelHelpers.interopDefault(_transitionWrapper);
var _jsxRuntime = require("react/jsx-runtime");
const MARGINS = {
    height: [
        'marginTop',
        'marginBottom'
    ],
    width: [
        'marginLeft',
        'marginRight'
    ]
};
function getDefaultDimensionValue(dimension, elem) {
    const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
    const value = elem[offset];
    const margins = MARGINS[dimension];
    return value + // @ts-expect-error TODO
    parseInt((0, _cssDefault.default)(elem, margins[0]), 10) + // @ts-expect-error TODO
    parseInt((0, _cssDefault.default)(elem, margins[1]), 10);
}
const collapseStyles = {
    [(0, _transition.EXITED)]: 'collapse',
    [(0, _transition.EXITING)]: 'collapsing',
    [(0, _transition.ENTERING)]: 'collapsing',
    [(0, _transition.ENTERED)]: 'collapse show'
};
const Collapse = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(({ onEnter, onEntering, onEntered, onExit, onExiting, className, children, dimension = 'height', in: inProp = false, timeout = 300, mountOnEnter = false, unmountOnExit = false, appear = false, getDimensionValue = getDefaultDimensionValue, ...props }, ref)=>{
    /* Compute dimension */ const computedDimension = typeof dimension === 'function' ? dimension() : dimension;
    /* -- Expanding -- */ const handleEnter = (0, _react.useMemo)(()=>(0, _createChainedFunctionDefault.default)((elem)=>{
            elem.style[computedDimension] = '0';
        }, onEnter), [
        computedDimension,
        onEnter
    ]);
    const handleEntering = (0, _react.useMemo)(()=>(0, _createChainedFunctionDefault.default)((elem)=>{
            const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
            elem.style[computedDimension] = `${elem[scroll]}px`;
        }, onEntering), [
        computedDimension,
        onEntering
    ]);
    const handleEntered = (0, _react.useMemo)(()=>(0, _createChainedFunctionDefault.default)((elem)=>{
            elem.style[computedDimension] = null;
        }, onEntered), [
        computedDimension,
        onEntered
    ]);
    /* -- Collapsing -- */ const handleExit = (0, _react.useMemo)(()=>(0, _createChainedFunctionDefault.default)((elem)=>{
            elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
            (0, _triggerBrowserReflowDefault.default)(elem);
        }, onExit), [
        onExit,
        getDimensionValue,
        computedDimension
    ]);
    const handleExiting = (0, _react.useMemo)(()=>(0, _createChainedFunctionDefault.default)((elem)=>{
            elem.style[computedDimension] = null;
        }, onExiting), [
        computedDimension,
        onExiting
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transitionWrapperDefault.default), {
        ref: ref,
        addEndListener: (0, _transitionEndListenerDefault.default),
        ...props,
        "aria-expanded": props.role ? inProp : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting,
        childRef: (0, _utils.getChildRef)(children),
        in: inProp,
        timeout: timeout,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        children: (state, innerProps)=>/*#__PURE__*/ (0, _reactDefault.default).cloneElement(children, {
                ...innerProps,
                className: (0, _classnamesDefault.default)(className, children.props.className, collapseStyles[state], computedDimension === 'width' && 'collapse-horizontal')
            })
    });
});
Collapse.displayName = 'Collapse';
exports.default = Collapse;

},{"classnames":"9HH2M","dom-helpers/css":"hqAHK","react":"bmhQu","react-transition-group/Transition":"eHQNI","@restart/ui/utils":"8cTwY","./transitionEndListener":"92uND","./createChainedFunction":"jIxkV","./triggerBrowserReflow":"d9hBI","./TransitionWrapper":"3fmIS","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hqAHK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getComputedStyle = require("./getComputedStyle");
var _getComputedStyleDefault = parcelHelpers.interopDefault(_getComputedStyle);
var _hyphenateStyle = require("./hyphenateStyle");
var _hyphenateStyleDefault = parcelHelpers.interopDefault(_hyphenateStyle);
var _isTransform = require("./isTransform");
var _isTransformDefault = parcelHelpers.interopDefault(_isTransform);
function style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, _hyphenateStyleDefault.default)(property)) || (0, _getComputedStyleDefault.default)(node).getPropertyValue((0, _hyphenateStyleDefault.default)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, _hyphenateStyleDefault.default)(key));
        else if ((0, _isTransformDefault.default)(key)) transforms += key + "(" + value + ") ";
        else css += (0, _hyphenateStyleDefault.default)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
exports.default = style;

},{"./getComputedStyle":"7OA33","./hyphenateStyle":"82lBU","./isTransform":"kGkPZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7OA33":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getComputedStyle);
var _ownerWindow = require("./ownerWindow");
var _ownerWindowDefault = parcelHelpers.interopDefault(_ownerWindow);
function getComputedStyle(node, psuedoElement) {
    return (0, _ownerWindowDefault.default)(node).getComputedStyle(node, psuedoElement);
}

},{"./ownerWindow":"1FThQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1FThQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ownerWindow);
var _ownerDocument = require("./ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
function ownerWindow(node) {
    var doc = (0, _ownerDocumentDefault.default)(node);
    return doc && doc.defaultView || window;
}

},{"./ownerDocument":"4O8MX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4O8MX":[function(require,module,exports,__globalThis) {
/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ownerDocument);
function ownerDocument(node) {
    return node && node.ownerDocument || document;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"82lBU":[function(require,module,exports,__globalThis) {
/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hyphenateStyleName);
var _hyphenate = require("./hyphenate");
var _hyphenateDefault = parcelHelpers.interopDefault(_hyphenate);
var msPattern = /^ms-/;
function hyphenateStyleName(string) {
    return (0, _hyphenateDefault.default)(string).replace(msPattern, '-ms-');
}

},{"./hyphenate":"4WVz8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4WVz8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hyphenate);
var rUpper = /([A-Z])/g;
function hyphenate(string) {
    return string.replace(rUpper, '-$1').toLowerCase();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kGkPZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isTransform);
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function isTransform(value) {
    return !!(value && supportedTransforms.test(value));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eHQNI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNMOUNTED", ()=>UNMOUNTED);
parcelHelpers.export(exports, "EXITED", ()=>EXITED);
parcelHelpers.export(exports, "ENTERING", ()=>ENTERING);
parcelHelpers.export(exports, "ENTERED", ()=>ENTERED);
parcelHelpers.export(exports, "EXITING", ()=>EXITING);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _propTypes1 = require("./utils/PropTypes");
var _transitionGroupContext = require("./TransitionGroupContext");
var _transitionGroupContextDefault = parcelHelpers.interopDefault(_transitionGroupContext);
var _reflow = require("./utils/reflow");
var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var Transition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = EXITED;
                _this.appearStatus = ENTERING;
            } else initialStatus = ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = UNMOUNTED;
        else initialStatus = EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === UNMOUNTED) return {
            status: EXITED
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== ENTERING && status !== ENTERED) nextStatus = ENTERING;
            } else if (status === ENTERING || status === ENTERED) nextStatus = EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === ENTERING) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, _reflow.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === EXITED) this.setState({
            status: UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, _reactDomDefault.default).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, _configDefault.default).disabled) {
            this.safeSetState({
                status: ENTERED
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: ENTERING
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: ENTERED
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, _reactDomDefault.default).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, _configDefault.default).disabled) {
            this.safeSetState({
                status: EXITED
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: EXITING
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: EXITED
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, _reactDefault.default).cloneElement((0, _reactDefault.default).Children.only(children), childProps)));
    };
    return Transition;
}((0, _reactDefault.default).Component);
Transition.contextType = (0, _transitionGroupContextDefault.default);
Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function noop() {}
Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: noop,
    onEntering: noop,
    onEntered: noop,
    onExit: noop,
    onExiting: noop,
    onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
exports.default = Transition;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"ds1mq","@babel/runtime/helpers/esm/inheritsLoose":"hJ1FM","prop-types":"gLXGb","react":"bmhQu","react-dom":"82aNB","./config":"i3rjT","./utils/PropTypes":"fRAD4","./TransitionGroupContext":"crDVT","./utils/reflow":"92i8b","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i3rjT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    disabled: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fRAD4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeoutsShape", ()=>timeoutsShape);
parcelHelpers.export(exports, "classNamesShape", ()=>classNamesShape);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var timeoutsShape = null;
var classNamesShape = null;

},{"prop-types":"gLXGb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"crDVT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = (0, _reactDefault.default).createContext(null);

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"92i8b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forceReflow", ()=>forceReflow);
var forceReflow = function forceReflow(node) {
    return node.scrollTop;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8cTwY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEscKey", ()=>isEscKey);
parcelHelpers.export(exports, "getReactVersion", ()=>getReactVersion);
parcelHelpers.export(exports, "getChildRef", ()=>getChildRef);
var _react = require("react");
function isEscKey(e) {
    return e.code === 'Escape' || e.keyCode === 27;
}
function getReactVersion() {
    const parts = _react.version.split('.');
    return {
        major: +parts[0],
        minor: +parts[1],
        patch: +parts[2]
    };
}
function getChildRef(element) {
    if (!element || typeof element === 'function') return null;
    const { major } = getReactVersion();
    const childRef = major >= 19 ? element.props.ref : element.ref;
    return childRef;
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"92uND":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>transitionEndListener);
var _css = require("dom-helpers/css");
var _cssDefault = parcelHelpers.interopDefault(_css);
var _transitionEnd = require("dom-helpers/transitionEnd");
var _transitionEndDefault = parcelHelpers.interopDefault(_transitionEnd);
function parseDuration(node, property) {
    const str = (0, _cssDefault.default)(node, property) || '';
    const mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function transitionEndListener(element, handler) {
    const duration = parseDuration(element, 'transitionDuration');
    const delay = parseDuration(element, 'transitionDelay');
    const remove = (0, _transitionEndDefault.default)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}

},{"dom-helpers/css":"hqAHK","dom-helpers/transitionEnd":"etfsa","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"etfsa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>transitionEnd);
var _css = require("./css");
var _cssDefault = parcelHelpers.interopDefault(_css);
var _listen = require("./listen");
var _listenDefault = parcelHelpers.interopDefault(_listen);
var _triggerEvent = require("./triggerEvent");
var _triggerEventDefault = parcelHelpers.interopDefault(_triggerEvent);
function parseDuration(node) {
    var str = (0, _cssDefault.default)(node, 'transitionDuration') || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, _triggerEventDefault.default)(element, 'transitionend', true);
    }, duration + padding);
    var remove = (0, _listenDefault.default)(element, 'transitionend', function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function transitionEnd(element, handler, duration, padding) {
    if (duration == null) duration = parseDuration(element) || 0;
    var removeEmulate = emulateTransitionEnd(element, duration, padding);
    var remove = (0, _listenDefault.default)(element, 'transitionend', handler);
    return function() {
        removeEmulate();
        remove();
    };
}

},{"./css":"hqAHK","./listen":"diWFU","./triggerEvent":"9UAqo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"diWFU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _addEventListener = require("./addEventListener");
var _addEventListenerDefault = parcelHelpers.interopDefault(_addEventListener);
var _removeEventListener = require("./removeEventListener");
var _removeEventListenerDefault = parcelHelpers.interopDefault(_removeEventListener);
function listen(node, eventName, handler, options) {
    (0, _addEventListenerDefault.default)(node, eventName, handler, options);
    return function() {
        (0, _removeEventListenerDefault.default)(node, eventName, handler, options);
    };
}
exports.default = listen;

},{"./addEventListener":"fjZpG","./removeEventListener":"185GE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fjZpG":[function(require,module,exports,__globalThis) {
/* eslint-disable no-return-assign */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "optionsSupported", ()=>optionsSupported);
parcelHelpers.export(exports, "onceSupported", ()=>onceSupported);
var _canUseDOM = require("./canUseDOM");
var _canUseDOMDefault = parcelHelpers.interopDefault(_canUseDOM);
var optionsSupported = false;
var onceSupported = false;
try {
    var options = {
        get passive () {
            return optionsSupported = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return onceSupported = optionsSupported = true;
        }
    };
    if (0, _canUseDOMDefault.default) {
        window.addEventListener('test', options, options);
        window.removeEventListener('test', options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !onceSupported) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!onceSupported && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, optionsSupported ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
exports.default = addEventListener;

},{"./canUseDOM":"b1d70","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b1d70":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"185GE":[function(require,module,exports,__globalThis) {
/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
exports.default = removeEventListener;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9UAqo":[function(require,module,exports,__globalThis) {
/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>triggerEvent);
function triggerEvent(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jIxkV":[function(require,module,exports,__globalThis) {
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function createChainedFunction(...funcs) {
    return funcs.filter((f)=>f != null).reduce((acc, f)=>{
        if (typeof f !== 'function') throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
        if (acc === null) return f;
        return function chainedFunction(...args) {
            // @ts-expect-error ignore "this" error
            acc.apply(this, args);
            // @ts-expect-error ignore "this" error
            f.apply(this, args);
        };
    }, null);
}
exports.default = createChainedFunction;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d9hBI":[function(require,module,exports,__globalThis) {
// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>triggerBrowserReflow);
function triggerBrowserReflow(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3fmIS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _transition = require("react-transition-group/Transition");
var _transitionDefault = parcelHelpers.interopDefault(_transition);
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
var _safeFindDOMNode = require("./safeFindDOMNode");
var _safeFindDOMNodeDefault = parcelHelpers.interopDefault(_safeFindDOMNode);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
// Normalizes Transition callbacks when nodeRef is used.
const TransitionWrapper = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(({ onEnter, onEntering, onEntered, onExit, onExiting, onExited, addEndListener, children, childRef, ...props }, ref)=>{
    const nodeRef = (0, _react.useRef)(null);
    const mergedRef = (0, _useMergedRefsDefault.default)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, _safeFindDOMNodeDefault.default)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    const handleEnter = (0, _react.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, _react.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, _react.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, _react.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, _react.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, _react.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, _react.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transitionDefault.default), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, _reactDefault.default).cloneElement(children, {
            ref: attachRef
        })
    });
});
TransitionWrapper.displayName = 'TransitionWrapper';
exports.default = TransitionWrapper;

},{"react":"bmhQu","react-transition-group/Transition":"eHQNI","@restart/hooks/useMergedRefs":"ai8mn","./safeFindDOMNode":"4l67l","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ai8mn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeRefs", ()=>mergeRefs);
var _react = require("react");
const toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function mergeRefs(refA, refB) {
    const a = toFnRef(refA);
    const b = toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function useMergedRefs(refA, refB) {
    return (0, _react.useMemo)(()=>mergeRefs(refA, refB), [
        refA,
        refB
    ]);
}
exports.default = useMergedRefs;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4l67l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>safeFindDOMNode);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
function safeFindDOMNode(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) // TODO: Remove in next major.
    // eslint-disable-next-line react/no-find-dom-node
    return (0, _reactDomDefault.default).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}

},{"react-dom":"82aNB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kc1gC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _themeProvider = require("./ThemeProvider");
var _navbarContext = require("./NavbarContext");
var _navbarContextDefault = parcelHelpers.interopDefault(_navbarContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const NavbarToggle = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, children, label = 'Toggle navigation', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'button', onClick, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'navbar-toggler');
    const { onToggle, expanded } = (0, _react.useContext)((0, _navbarContextDefault.default)) || {};
    const handleClick = (0, _useEventCallbackDefault.default)((e)=>{
        if (onClick) onClick(e);
        if (onToggle) onToggle();
    });
    if (Component === 'button') props.type = 'button';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        ref: ref,
        onClick: handleClick,
        "aria-label": label,
        className: (0, _classnamesDefault.default)(className, bsPrefix, !expanded && 'collapsed'),
        children: children || /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: `${bsPrefix}-icon`
        })
    });
});
NavbarToggle.displayName = 'NavbarToggle';
exports.default = NavbarToggle;

},{"classnames":"9HH2M","react":"bmhQu","@restart/hooks/useEventCallback":"8gfnN","./ThemeProvider":"aQ1Mj","./NavbarContext":"e2mN2","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8gfnN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useEventCallback);
var _react = require("react");
var _useCommittedRef = require("./useCommittedRef");
var _useCommittedRefDefault = parcelHelpers.interopDefault(_useCommittedRef);
function useEventCallback(fn) {
    const ref = (0, _useCommittedRefDefault.default)(fn);
    return (0, _react.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}

},{"react":"bmhQu","./useCommittedRef":"3fCg9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3fCg9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function useCommittedRef(value) {
    const ref = (0, _react.useRef)(value);
    (0, _react.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
exports.default = useCommittedRef;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kKQ8O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _offcanvas = require("./Offcanvas");
var _offcanvasDefault = parcelHelpers.interopDefault(_offcanvas);
var _navbarContext = require("./NavbarContext");
var _navbarContextDefault = parcelHelpers.interopDefault(_navbarContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const NavbarOffcanvas = /*#__PURE__*/ _react.forwardRef(({ onHide, ...props }, ref)=>{
    const context = (0, _react.useContext)((0, _navbarContextDefault.default));
    const handleHide = (0, _useEventCallbackDefault.default)(()=>{
        context == null || context.onToggle == null || context.onToggle();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _offcanvasDefault.default), {
        ref: ref,
        show: !!(context != null && context.expanded),
        ...props,
        renderStaticNode: true,
        onHide: handleHide
    });
});
NavbarOffcanvas.displayName = 'NavbarOffcanvas';
exports.default = NavbarOffcanvas;

},{"react":"bmhQu","@restart/hooks/useEventCallback":"8gfnN","./Offcanvas":"d3y7E","./NavbarContext":"e2mN2","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d3y7E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _useBreakpoint = require("@restart/hooks/useBreakpoint");
var _useBreakpointDefault = parcelHelpers.interopDefault(_useBreakpoint);
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _react = require("react");
var _modal = require("@restart/ui/Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _fade = require("./Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _offcanvasBody = require("./OffcanvasBody");
var _offcanvasBodyDefault = parcelHelpers.interopDefault(_offcanvasBody);
var _offcanvasToggling = require("./OffcanvasToggling");
var _offcanvasTogglingDefault = parcelHelpers.interopDefault(_offcanvasToggling);
var _modalContext = require("./ModalContext");
var _modalContextDefault = parcelHelpers.interopDefault(_modalContext);
var _offcanvasHeader = require("./OffcanvasHeader");
var _offcanvasHeaderDefault = parcelHelpers.interopDefault(_offcanvasHeader);
var _offcanvasTitle = require("./OffcanvasTitle");
var _offcanvasTitleDefault = parcelHelpers.interopDefault(_offcanvasTitle);
var _themeProvider = require("./ThemeProvider");
var _bootstrapModalManager = require("./BootstrapModalManager");
var _bootstrapModalManagerDefault = parcelHelpers.interopDefault(_bootstrapModalManager);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function DialogTransition(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _offcanvasTogglingDefault.default), {
        ...props
    });
}
function BackdropTransition(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeDefault.default), {
        ...props
    });
}
const Offcanvas = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, children, 'aria-labelledby': ariaLabelledby, placement = 'start', responsive, /* BaseModal props */ show = false, backdrop = true, keyboard = true, scroll = false, onEscapeKeyDown, onShow, onHide, container, autoFocus = true, enforceFocus = true, restoreFocus = true, restoreFocusOptions, onEntered, onExit, onExiting, onEnter, onEntering, onExited, backdropClassName, manager: propsManager, renderStaticNode = false, ...props }, ref)=>{
    const modalManager = (0, _react.useRef)();
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'offcanvas');
    const [showOffcanvas, setShowOffcanvas] = (0, _react.useState)(false);
    const handleHide = (0, _useEventCallbackDefault.default)(onHide);
    const hideResponsiveOffcanvas = (0, _useBreakpointDefault.default)(responsive || 'xs', 'up');
    (0, _react.useEffect)(()=>{
        // Handles the case where screen is resized while the responsive
        // offcanvas is shown. If `responsive` not provided, just use `show`.
        setShowOffcanvas(responsive ? show && !hideResponsiveOffcanvas : show);
    }, [
        show,
        responsive,
        hideResponsiveOffcanvas
    ]);
    const modalContext = (0, _react.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        if (scroll) {
            // Have to use a different modal manager since the shared
            // one handles overflow.
            if (!modalManager.current) modalManager.current = new (0, _bootstrapModalManagerDefault.default)({
                handleContainerOverflow: false
            });
            return modalManager.current;
        }
        return (0, _bootstrapModalManager.getSharedManager)();
    }
    const handleEnter = (node, ...args)=>{
        if (node) node.style.visibility = 'visible';
        onEnter == null || onEnter(node, ...args);
    };
    const handleExited = (node, ...args)=>{
        if (node) node.style.visibility = '';
        onExited == null || onExited(...args);
    };
    const renderBackdrop = (0, _react.useCallback)((backdropProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            ...backdropProps,
            className: (0, _classnamesDefault.default)(`${bsPrefix}-backdrop`, backdropClassName)
        }), [
        backdropClassName,
        bsPrefix
    ]);
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            ...dialogProps,
            ...props,
            className: (0, _classnamesDefault.default)(className, responsive ? `${bsPrefix}-${responsive}` : bsPrefix, `${bsPrefix}-${placement}`),
            "aria-labelledby": ariaLabelledby,
            children: children
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            !showOffcanvas && (responsive || renderStaticNode) && renderDialog({}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalContextDefault.default).Provider, {
                value: modalContext,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDefault.default), {
                    show: showOffcanvas,
                    ref: ref,
                    backdrop: backdrop,
                    container: container,
                    keyboard: keyboard,
                    autoFocus: autoFocus,
                    enforceFocus: enforceFocus && !scroll,
                    restoreFocus: restoreFocus,
                    restoreFocusOptions: restoreFocusOptions,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onShow: onShow,
                    onHide: handleHide,
                    onEnter: handleEnter,
                    onEntering: onEntering,
                    onEntered: onEntered,
                    onExit: onExit,
                    onExiting: onExiting,
                    onExited: handleExited,
                    manager: getModalManager(),
                    transition: DialogTransition,
                    backdropTransition: BackdropTransition,
                    renderBackdrop: renderBackdrop,
                    renderDialog: renderDialog
                })
            })
        ]
    });
});
Offcanvas.displayName = 'Offcanvas';
exports.default = Object.assign(Offcanvas, {
    Body: (0, _offcanvasBodyDefault.default),
    Header: (0, _offcanvasHeaderDefault.default),
    Title: (0, _offcanvasTitleDefault.default)
});

},{"classnames":"9HH2M","@restart/hooks/useBreakpoint":"1AUxs","@restart/hooks/useEventCallback":"8gfnN","react":"bmhQu","@restart/ui/Modal":"41jvx","./Fade":"iLhiL","./OffcanvasBody":"eCS2w","./OffcanvasToggling":"7BYbG","./ModalContext":"3Poo0","./OffcanvasHeader":"hEhv6","./OffcanvasTitle":"c7ThV","./ThemeProvider":"aQ1Mj","./BootstrapModalManager":"fPmGg","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1AUxs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create a responsive hook we a set of breakpoint names and widths.
 * You can use any valid css units as well as a numbers (for pixels).
 *
 * **NOTE:** The object key order is important! it's assumed to be in order from smallest to largest
 *
 * ```ts
 * const useBreakpoint = createBreakpointHook({
 *  xs: 0,
 *  sm: 576,
 *  md: 768,
 *  lg: 992,
 *  xl: 1200,
 * })
 * ```
 *
 * **Watch out!** using string values will sometimes construct media queries using css `calc()` which
 * is NOT supported in media queries by all browsers at the moment. use numbers for
 * the widest range of browser support.
 *
 * @param breakpointValues A object hash of names to breakpoint dimensions
 */ parcelHelpers.export(exports, "createBreakpointHook", ()=>createBreakpointHook);
var _useMediaQuery = require("./useMediaQuery");
var _useMediaQueryDefault = parcelHelpers.interopDefault(_useMediaQuery);
var _react = require("react");
function createBreakpointHook(breakpointValues) {
    const names = Object.keys(breakpointValues);
    function and(query, next) {
        if (query === next) return next;
        return query ? `${query} and ${next}` : next;
    }
    function getNext(breakpoint) {
        return names[Math.min(names.indexOf(breakpoint) + 1, names.length - 1)];
    }
    function getMaxQuery(breakpoint) {
        const next = getNext(breakpoint);
        let value = breakpointValues[next];
        if (typeof value === 'number') value = `${value - 0.2}px`;
        else value = `calc(${value} - 0.2px)`;
        return `(max-width: ${value})`;
    }
    function getMinQuery(breakpoint) {
        let value = breakpointValues[breakpoint];
        if (typeof value === 'number') value = `${value}px`;
        return `(min-width: ${value})`;
    }
    /**
   * Match a set of breakpoints
   *
   * ```tsx
   * const MidSizeOnly = () => {
   *   const isMid = useBreakpoint({ lg: 'down', sm: 'up' });
   *
   *   if (isMid) return <div>On a Reasonable sized Screen!</div>
   *   return null;
   * }
   * ```
   * @param breakpointMap An object map of breakpoints and directions, queries are constructed using "and" to join
   * breakpoints together
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ /**
   * Match a single breakpoint exactly, up, or down.
   *
   * ```tsx
   * const PhoneOnly = () => {
   *   const isSmall = useBreakpoint('sm', 'down');
   *
   *   if (isSmall) return <div>On a Small Screen!</div>
   *   return null;
   * }
   * ```
   *
   * @param breakpoint The breakpoint key
   * @param direction A direction 'up' for a max, 'down' for min, true to match only the breakpoint
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ function useBreakpoint(breakpointOrMap, direction, window) {
        let breakpointMap;
        if (typeof breakpointOrMap === 'object') {
            breakpointMap = breakpointOrMap;
            window = direction;
            direction = true;
        } else {
            direction = direction || true;
            breakpointMap = {
                [breakpointOrMap]: direction
            };
        }
        let query = (0, _react.useMemo)(()=>Object.entries(breakpointMap).reduce((query, [key, direction])=>{
                if (direction === 'up' || direction === true) query = and(query, getMinQuery(key));
                if (direction === 'down' || direction === true) query = and(query, getMaxQuery(key));
                return query;
            }, ''), [
            JSON.stringify(breakpointMap)
        ]);
        return (0, _useMediaQueryDefault.default)(query, window);
    }
    return useBreakpoint;
}
const useBreakpoint = createBreakpointHook({
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
});
exports.default = useBreakpoint;

},{"./useMediaQuery":"8K50x","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8K50x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useMediaQuery);
var _useIsomorphicEffect = require("./useIsomorphicEffect");
var _useIsomorphicEffectDefault = parcelHelpers.interopDefault(_useIsomorphicEffect);
var _react = require("react");
const matchersByWindow = new WeakMap();
const getMatcher = (query, targetWindow)=>{
    if (!query || !targetWindow) return undefined;
    const matchers = matchersByWindow.get(targetWindow) || new Map();
    matchersByWindow.set(targetWindow, matchers);
    let mql = matchers.get(query);
    if (!mql) {
        mql = targetWindow.matchMedia(query);
        mql.refCount = 0;
        matchers.set(mql.media, mql);
    }
    return mql;
};
function useMediaQuery(query, targetWindow = typeof window === 'undefined' ? undefined : window) {
    const mql = getMatcher(query, targetWindow);
    const [matches, setMatches] = (0, _react.useState)(()=>mql ? mql.matches : false);
    (0, _useIsomorphicEffectDefault.default)(()=>{
        let mql = getMatcher(query, targetWindow);
        if (!mql) return setMatches(false);
        let matchers = matchersByWindow.get(targetWindow);
        const handleChange = ()=>{
            setMatches(mql.matches);
        };
        mql.refCount++;
        mql.addListener(handleChange);
        handleChange();
        return ()=>{
            mql.removeListener(handleChange);
            mql.refCount--;
            if (mql.refCount <= 0) matchers == null || matchers.delete(mql.media);
            mql = undefined;
        };
    }, [
        query
    ]);
    return matches;
}

},{"./useIsomorphicEffect":"gqtk8","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gqtk8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var global = arguments[3];
const isReactNative = typeof global !== 'undefined' && // @ts-ignore
global.navigator && // @ts-ignore
global.navigator.product === 'ReactNative';
const isDOM = typeof document !== 'undefined';
/**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ exports.default = isDOM || isReactNative ? (0, _react.useLayoutEffect) : (0, _react.useEffect);

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"41jvx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/* eslint-disable @typescript-eslint/no-use-before-define, react/prop-types */ var _activeElement = require("dom-helpers/activeElement");
var _activeElementDefault = parcelHelpers.interopDefault(_activeElement);
var _contains = require("dom-helpers/contains");
var _containsDefault = parcelHelpers.interopDefault(_contains);
var _canUseDOM = require("dom-helpers/canUseDOM");
var _canUseDOMDefault = parcelHelpers.interopDefault(_canUseDOM);
var _listen = require("dom-helpers/listen");
var _listenDefault = parcelHelpers.interopDefault(_listen);
var _react = require("react");
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _useMounted = require("@restart/hooks/useMounted");
var _useMountedDefault = parcelHelpers.interopDefault(_useMounted);
var _useWillUnmount = require("@restart/hooks/useWillUnmount");
var _useWillUnmountDefault = parcelHelpers.interopDefault(_useWillUnmount);
var _usePrevious = require("@restart/hooks/usePrevious");
var _usePreviousDefault = parcelHelpers.interopDefault(_usePrevious);
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _modalManager = require("./ModalManager");
var _modalManagerDefault = parcelHelpers.interopDefault(_modalManager);
var _useWaitForDOMRef = require("./useWaitForDOMRef");
var _useWaitForDOMRefDefault = parcelHelpers.interopDefault(_useWaitForDOMRef);
var _useWindow = require("./useWindow");
var _useWindowDefault = parcelHelpers.interopDefault(_useWindow);
var _imperativeTransition = require("./ImperativeTransition");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
let manager;
/*
  Modal props are split into a version with and without index signature so that you can fully use them in another projects
  This is due to Typescript not playing well with index signatures e.g. when using Omit
*/ function getManager(window) {
    if (!manager) manager = new (0, _modalManagerDefault.default)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return manager;
}
function useModalManager(provided) {
    const window = (0, _useWindowDefault.default)();
    const modalManager = provided || getManager(window);
    const modal = (0, _react.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: ()=>modalManager.add(modal.current),
        remove: ()=>modalManager.remove(modal.current),
        isTopModal: ()=>modalManager.isTopModal(modal.current),
        setDialogRef: (0, _react.useCallback)((ref)=>{
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, _react.useCallback)((ref)=>{
            modal.current.backdrop = ref;
        }, [])
    });
}
const Modal = /*#__PURE__*/ (0, _react.forwardRef)((_ref, ref)=>{
    let { show = false, role = 'dialog', className, style, children, backdrop = true, keyboard = true, onBackdropClick, onEscapeKeyDown, transition, runTransition, backdropTransition, runBackdropTransition, autoFocus = true, enforceFocus = true, restoreFocus = true, restoreFocusOptions, renderDialog, renderBackdrop = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", Object.assign({}, props)), manager: providedManager, container: containerRef, onShow, onHide = ()=>{}, onExit, onExited, onExiting, onEnter, onEntering, onEntered } = _ref, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    const ownerWindow = (0, _useWindowDefault.default)();
    const container = (0, _useWaitForDOMRefDefault.default)(containerRef);
    const modal = useModalManager(providedManager);
    const isMounted = (0, _useMountedDefault.default)();
    const prevShow = (0, _usePreviousDefault.default)(show);
    const [exited, setExited] = (0, _react.useState)(!show);
    const lastFocusRef = (0, _react.useRef)(null);
    (0, _react.useImperativeHandle)(ref, ()=>modal, [
        modal
    ]);
    if ((0, _canUseDOMDefault.default) && !prevShow && show) lastFocusRef.current = (0, _activeElementDefault.default)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    const handleShow = (0, _useEventCallbackDefault.default)(()=>{
        modal.add();
        removeKeydownListenerRef.current = (0, _listenDefault.default)(document, 'keydown', handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, _listenDefault.default)(document, 'focus', // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        ()=>setTimeout(handleEnforceFocus), true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            const currentActiveElement = (0, _activeElementDefault.default)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, _containsDefault.default)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    const handleHide = (0, _useEventCallbackDefault.default)(()=>{
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, _react.useEffect)(()=>{
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, _react.useEffect)(()=>{
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, _useWillUnmountDefault.default)(()=>{
        handleHide();
    });
    // --------------------------------
    const handleEnforceFocus = (0, _useEventCallbackDefault.default)(()=>{
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        const currentActiveElement = (0, _activeElementDefault.default)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, _containsDefault.default)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    const handleBackdropClick = (0, _useEventCallbackDefault.default)((e)=>{
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    const handleDocumentKeyDown = (0, _useEventCallbackDefault.default)((e)=>{
        if (keyboard && (0, _utils.isEscKey)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    const removeFocusListenerRef = (0, _react.useRef)();
    const removeKeydownListenerRef = (0, _react.useRef)();
    const handleHidden = (...args)=>{
        setExited(true);
        onExited == null || onExited(...args);
    };
    if (!container) return null;
    const dialogProps = Object.assign({
        role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        'aria-modal': role === 'dialog' ? true : undefined
    }, rest, {
        style,
        className,
        tabIndex: -1
    });
    let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ _react.cloneElement(children, {
            role: 'document'
        })
    }));
    dialog = (0, _imperativeTransition.renderTransition)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit,
        onExiting,
        onExited: handleHidden,
        onEnter,
        onEntering,
        onEntered,
        children: dialog
    });
    let backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, _imperativeTransition.renderTransition)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _reactDomDefault.default).createPortal(/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
Modal.displayName = 'Modal';
exports.default = Object.assign(Modal, {
    Manager: (0, _modalManagerDefault.default)
});

},{"dom-helpers/activeElement":"eZoWm","dom-helpers/contains":"kQPO5","dom-helpers/canUseDOM":"b1d70","dom-helpers/listen":"diWFU","react":"bmhQu","react-dom":"82aNB","@restart/hooks/useMounted":"gkvSP","@restart/hooks/useWillUnmount":"kfdN9","@restart/hooks/usePrevious":"6GTFb","@restart/hooks/useEventCallback":"j7CsD","./ModalManager":"b3RZH","./useWaitForDOMRef":"4agJT","./useWindow":"ikTkv","./ImperativeTransition":"aK0SH","./utils":"8cTwY","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eZoWm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>activeElement);
var _ownerDocument = require("./ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
function activeElement(doc) {
    if (doc === void 0) doc = (0, _ownerDocumentDefault.default)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}

},{"./ownerDocument":"4O8MX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kQPO5":[function(require,module,exports,__globalThis) {
/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>contains);
function contains(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kfdN9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useWillUnmount);
var _useUpdatedRef = require("./useUpdatedRef");
var _useUpdatedRefDefault = parcelHelpers.interopDefault(_useUpdatedRef);
var _react = require("react");
function useWillUnmount(fn) {
    const onUnmount = (0, _useUpdatedRefDefault.default)(fn);
    (0, _react.useEffect)(()=>()=>onUnmount.current(), []);
}

},{"./useUpdatedRef":"acSzG","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"acSzG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useUpdatedRef);
var _react = require("react");
function useUpdatedRef(value) {
    const valueRef = (0, _react.useRef)(value);
    valueRef.current = value;
    return valueRef;
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b3RZH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OPEN_DATA_ATTRIBUTE", ()=>OPEN_DATA_ATTRIBUTE);
var _css = require("dom-helpers/css");
var _cssDefault = parcelHelpers.interopDefault(_css);
var _dataKey = require("./DataKey");
var _getScrollbarWidth = require("./getScrollbarWidth");
var _getScrollbarWidthDefault = parcelHelpers.interopDefault(_getScrollbarWidth);
const OPEN_DATA_ATTRIBUTE = (0, _dataKey.dataAttr)('modal-open');
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ class ModalManager {
    constructor({ ownerDocument, handleContainerOverflow = true, isRTL = false } = {}){
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
    getScrollbarWidth() {
        return (0, _getScrollbarWidthDefault.default)(this.ownerDocument);
    }
    getElement() {
        return (this.ownerDocument || document).body;
    }
    setModalAttributes(_modal) {
    // For overriding
    }
    removeModalAttributes(_modal) {
    // For overriding
    }
    setContainerStyle(containerState) {
        const style = {
            overflow: 'hidden'
        };
        // we are only interested in the actual `style` here
        // because we will override it
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const container = this.getElement();
        containerState.style = {
            overflow: container.style.overflow,
            [paddingProp]: container.style[paddingProp]
        };
        if (containerState.scrollBarWidth) // use computed style, here to get the real padding
        // to add our scrollbar width
        style[paddingProp] = `${parseInt((0, _cssDefault.default)(container, paddingProp) || '0', 10) + containerState.scrollBarWidth}px`;
        container.setAttribute(OPEN_DATA_ATTRIBUTE, '');
        (0, _cssDefault.default)(container, style);
    }
    reset() {
        [
            ...this.modals
        ].forEach((m)=>this.remove(m));
    }
    removeContainerStyle(containerState) {
        const container = this.getElement();
        container.removeAttribute(OPEN_DATA_ATTRIBUTE);
        Object.assign(container.style, containerState.style);
    }
    add(modal) {
        let modalIdx = this.modals.indexOf(modal);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        this.setModalAttributes(modal);
        if (modalIdx !== 0) return modalIdx;
        this.state = {
            scrollBarWidth: this.getScrollbarWidth(),
            style: {}
        };
        if (this.handleContainerOverflow) this.setContainerStyle(this.state);
        return modalIdx;
    }
    remove(modal) {
        const modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
        this.removeModalAttributes(modal);
    }
    isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
}
exports.default = ModalManager;

},{"dom-helpers/css":"hqAHK","./DataKey":"g9Cvj","./getScrollbarWidth":"8Y4cR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8Y4cR":[function(require,module,exports,__globalThis) {
/**
 * Get the width of the vertical window scrollbar if it's visible
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBodyScrollbarWidth);
function getBodyScrollbarWidth(ownerDocument = document) {
    const window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4agJT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveContainerRef", ()=>resolveContainerRef);
parcelHelpers.export(exports, "default", ()=>useWaitForDOMRef);
var _ownerDocument = require("dom-helpers/ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
var _canUseDOM = require("dom-helpers/canUseDOM");
var _canUseDOMDefault = parcelHelpers.interopDefault(_canUseDOM);
var _react = require("react");
var _useWindow = require("./useWindow");
var _useWindowDefault = parcelHelpers.interopDefault(_useWindow);
const resolveContainerRef = (ref, document)=>{
    if (!(0, _canUseDOMDefault.default)) return null;
    if (ref == null) return (document || (0, _ownerDocumentDefault.default)()).body;
    if (typeof ref === 'function') ref = ref();
    if (ref && 'current' in ref) ref = ref.current;
    if (ref && ('nodeType' in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function useWaitForDOMRef(ref, onResolved) {
    const window = (0, _useWindowDefault.default)();
    const [resolvedRef, setRef] = (0, _react.useState)(()=>resolveContainerRef(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = resolveContainerRef(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, _react.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, _react.useEffect)(()=>{
        const nextRef = resolveContainerRef(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}

},{"dom-helpers/ownerDocument":"4O8MX","dom-helpers/canUseDOM":"b1d70","react":"bmhQu","./useWindow":"ikTkv","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ikTkv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WindowProvider", ()=>WindowProvider);
parcelHelpers.export(exports, "default", ()=>useWindow);
var _react = require("react");
var _canUseDOM = require("dom-helpers/canUseDOM");
var _canUseDOMDefault = parcelHelpers.interopDefault(_canUseDOM);
const Context = /*#__PURE__*/ (0, _react.createContext)((0, _canUseDOMDefault.default) ? window : undefined);
const WindowProvider = Context.Provider;
function useWindow() {
    return (0, _react.useContext)(Context);
}

},{"react":"bmhQu","dom-helpers/canUseDOM":"b1d70","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aK0SH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTransition", ()=>useTransition);
parcelHelpers.export(exports, "default", ()=>ImperativeTransition);
parcelHelpers.export(exports, "renderTransition", ()=>renderTransition);
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useIsomorphicEffect = require("@restart/hooks/useIsomorphicEffect");
var _useIsomorphicEffectDefault = parcelHelpers.interopDefault(_useIsomorphicEffect);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _noopTransition = require("./NoopTransition");
var _noopTransitionDefault = parcelHelpers.interopDefault(_noopTransition);
var _rtgtransition = require("./RTGTransition");
var _rtgtransitionDefault = parcelHelpers.interopDefault(_rtgtransition);
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
function useTransition({ in: inProp, onTransition }) {
    const ref = (0, _react.useRef)(null);
    const isInitialRef = (0, _react.useRef)(true);
    const handleTransition = (0, _useEventCallbackDefault.default)(onTransition);
    (0, _useIsomorphicEffectDefault.default)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, _useIsomorphicEffectDefault.default)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function ImperativeTransition({ children, in: inProp, onExited, onEntered, transition }) {
    const [exited, setExited] = (0, _react.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = useTransition({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, _useMergedRefsDefault.default)(ref, (0, _utils.getChildRef)(children));
    return exited && !inProp ? null : /*#__PURE__*/ (0, _react.cloneElement)(children, {
        ref: combinedRef
    });
}
function renderTransition(component, runTransition, props) {
    if (component) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rtgtransitionDefault.default), Object.assign({}, props, {
        component: component
    }));
    if (runTransition) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ImperativeTransition, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noopTransitionDefault.default), Object.assign({}, props));
}

},{"@restart/hooks/useMergedRefs":"hXy8K","@restart/hooks/useEventCallback":"j7CsD","@restart/hooks/useIsomorphicEffect":"24dnS","react":"bmhQu","./NoopTransition":"jO1Qq","./RTGTransition":"jASP2","./utils":"8cTwY","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jO1Qq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
var _react = require("react");
var _utils = require("./utils");
function NoopTransition({ children, in: inProp, onExited, mountOnEnter, unmountOnExit }) {
    const ref = (0, _react.useRef)(null);
    const hasEnteredRef = (0, _react.useRef)(inProp);
    const handleExited = (0, _useEventCallbackDefault.default)(onExited);
    (0, _react.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, _useMergedRefsDefault.default)(ref, (0, _utils.getChildRef)(children));
    const child = /*#__PURE__*/ (0, _react.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
exports.default = NoopTransition;

},{"@restart/hooks/useEventCallback":"j7CsD","@restart/hooks/useMergedRefs":"hXy8K","react":"bmhQu","./utils":"8cTwY","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jASP2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useRTGTransitionProps = require("./useRTGTransitionProps");
var _useRTGTransitionPropsDefault = parcelHelpers.interopDefault(_useRTGTransitionProps);
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "component"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Normalizes Transition callbacks when nodeRef is used.
const RTGTransition = /*#__PURE__*/ _react.forwardRef((_ref, ref)=>{
    let { component: Component } = _ref, props = _objectWithoutPropertiesLoose(_ref, _excluded);
    const transitionProps = (0, _useRTGTransitionPropsDefault.default)(props);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, Object.assign({
        ref: ref
    }, transitionProps));
});
exports.default = RTGTransition;

},{"react":"bmhQu","./useRTGTransitionProps":"bzinM","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bzinM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useRTGTransitionProps);
var _react = require("react");
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
var _utils = require("./utils");
const _excluded = [
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited",
    "addEndListener",
    "children"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function useRTGTransitionProps(_ref) {
    let { onEnter, onEntering, onEntered, onExit, onExiting, onExited, addEndListener, children } = _ref, props = _objectWithoutPropertiesLoose(_ref, _excluded);
    const nodeRef = (0, _react.useRef)(null);
    const mergedRef = (0, _useMergedRefsDefault.default)(nodeRef, (0, _utils.getChildRef)(children));
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, _react.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, _react.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, _react.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, _react.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, _react.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, _react.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, _react.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return Object.assign({}, props, {
        nodeRef
    }, onEnter && {
        onEnter: handleEnter
    }, onEntering && {
        onEntering: handleEntering
    }, onEntered && {
        onEntered: handleEntered
    }, onExit && {
        onExit: handleExit
    }, onExiting && {
        onExiting: handleExiting
    }, onExited && {
        onExited: handleExited
    }, addEndListener && {
        addEndListener: handleAddEndListener
    }, {
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, Object.assign({}, innerProps, {
                ref: mergedRef
            })) : /*#__PURE__*/ (0, _react.cloneElement)(children, {
            ref: mergedRef
        })
    });
}

},{"react":"bmhQu","@restart/hooks/useMergedRefs":"hXy8K","./utils":"8cTwY","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iLhiL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _transition = require("react-transition-group/Transition");
var _utils = require("@restart/ui/utils");
var _transitionEndListener = require("./transitionEndListener");
var _transitionEndListenerDefault = parcelHelpers.interopDefault(_transitionEndListener);
var _triggerBrowserReflow = require("./triggerBrowserReflow");
var _triggerBrowserReflowDefault = parcelHelpers.interopDefault(_triggerBrowserReflow);
var _transitionWrapper = require("./TransitionWrapper");
var _transitionWrapperDefault = parcelHelpers.interopDefault(_transitionWrapper);
var _jsxRuntime = require("react/jsx-runtime");
const fadeStyles = {
    [(0, _transition.ENTERING)]: 'show',
    [(0, _transition.ENTERED)]: 'show'
};
const Fade = /*#__PURE__*/ _react.forwardRef(({ className, children, transitionClasses = {}, onEnter, ...rest }, ref)=>{
    const props = {
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        ...rest
    };
    const handleEnter = (0, _react.useCallback)((node, isAppearing)=>{
        (0, _triggerBrowserReflowDefault.default)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transitionWrapperDefault.default), {
        ref: ref,
        addEndListener: (0, _transitionEndListenerDefault.default),
        ...props,
        onEnter: handleEnter,
        childRef: (0, _utils.getChildRef)(children),
        children: (status, innerProps)=>/*#__PURE__*/ _react.cloneElement(children, {
                ...innerProps,
                className: (0, _classnamesDefault.default)('fade', className, children.props.className, fadeStyles[status], transitionClasses[status])
            })
    });
});
Fade.displayName = 'Fade';
exports.default = Fade;

},{"classnames":"9HH2M","react":"bmhQu","react-transition-group/Transition":"eHQNI","@restart/ui/utils":"8cTwY","./transitionEndListener":"92uND","./triggerBrowserReflow":"d9hBI","./TransitionWrapper":"3fmIS","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eCS2w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const OffcanvasBody = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'offcanvas-body');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
OffcanvasBody.displayName = 'OffcanvasBody';
exports.default = OffcanvasBody;

},{"react":"bmhQu","classnames":"9HH2M","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7BYbG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _transition = require("react-transition-group/Transition");
var _utils = require("@restart/ui/utils");
var _transitionEndListener = require("./transitionEndListener");
var _transitionEndListenerDefault = parcelHelpers.interopDefault(_transitionEndListener);
var _transitionWrapper = require("./TransitionWrapper");
var _transitionWrapperDefault = parcelHelpers.interopDefault(_transitionWrapper);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const transitionStyles = {
    [(0, _transition.ENTERING)]: 'show',
    [(0, _transition.ENTERED)]: 'show'
};
const OffcanvasToggling = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, children, in: inProp = false, mountOnEnter = false, unmountOnExit = false, appear = false, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'offcanvas');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transitionWrapperDefault.default), {
        ref: ref,
        addEndListener: (0, _transitionEndListenerDefault.default),
        in: inProp,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        ...props,
        childRef: (0, _utils.getChildRef)(children),
        children: (status, innerProps)=>/*#__PURE__*/ _react.cloneElement(children, {
                ...innerProps,
                className: (0, _classnamesDefault.default)(className, children.props.className, (status === (0, _transition.ENTERING) || status === (0, _transition.EXITING)) && `${bsPrefix}-toggling`, transitionStyles[status])
            })
    });
});
OffcanvasToggling.displayName = 'OffcanvasToggling';
exports.default = OffcanvasToggling;

},{"classnames":"9HH2M","react":"bmhQu","react-transition-group/Transition":"eHQNI","@restart/ui/utils":"8cTwY","./transitionEndListener":"92uND","./TransitionWrapper":"3fmIS","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3Poo0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
const ModalContext = /*#__PURE__*/ _react.createContext({
    onHide () {}
});
exports.default = ModalContext;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hEhv6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _abstractModalHeader = require("./AbstractModalHeader");
var _abstractModalHeaderDefault = parcelHelpers.interopDefault(_abstractModalHeader);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const OffcanvasHeader = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, closeLabel = 'Close', closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'offcanvas-header');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _abstractModalHeaderDefault.default), {
        ref: ref,
        ...props,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
OffcanvasHeader.displayName = 'OffcanvasHeader';
exports.default = OffcanvasHeader;

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","./AbstractModalHeader":"3ht9b","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3ht9b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _closeButton = require("./CloseButton");
var _closeButtonDefault = parcelHelpers.interopDefault(_closeButton);
var _modalContext = require("./ModalContext");
var _modalContextDefault = parcelHelpers.interopDefault(_modalContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const AbstractModalHeader = /*#__PURE__*/ _react.forwardRef(({ closeLabel = 'Close', closeVariant, closeButton = false, onHide, children, ...props }, ref)=>{
    const context = (0, _react.useContext)((0, _modalContextDefault.default));
    const handleClick = (0, _useEventCallbackDefault.default)(()=>{
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: ref,
        ...props,
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeButtonDefault.default), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    });
});
AbstractModalHeader.displayName = 'AbstractModalHeader';
exports.default = AbstractModalHeader;

},{"react":"bmhQu","@restart/hooks/useEventCallback":"8gfnN","./CloseButton":"7enKR","./ModalContext":"3Poo0","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7enKR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _jsxRuntime = require("react/jsx-runtime");
const propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ 'aria-label': (0, _propTypesDefault.default).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, _propTypesDefault.default).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, _propTypesDefault.default).oneOf([
        'white'
    ])
};
const CloseButton = /*#__PURE__*/ _react.forwardRef(({ className, variant, 'aria-label': ariaLabel = 'Close', ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        ref: ref,
        type: "button",
        className: (0, _classnamesDefault.default)('btn-close', variant && `btn-close-${variant}`, className),
        "aria-label": ariaLabel,
        ...props
    }));
CloseButton.displayName = 'CloseButton';
CloseButton.propTypes = propTypes;
exports.default = CloseButton;

},{"prop-types":"gLXGb","react":"bmhQu","classnames":"9HH2M","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c7ThV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _divWithClassName = require("./divWithClassName");
var _divWithClassNameDefault = parcelHelpers.interopDefault(_divWithClassName);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DivStyledAsH5 = (0, _divWithClassNameDefault.default)('h5');
const OffcanvasTitle = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'offcanvas-title');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
OffcanvasTitle.displayName = 'OffcanvasTitle';
exports.default = OffcanvasTitle;

},{"react":"bmhQu","classnames":"9HH2M","./divWithClassName":"kXtiN","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kXtiN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _jsxRuntime = require("react/jsx-runtime");
exports.default = (className)=>/*#__PURE__*/ // eslint-disable-next-line react/display-name
    _react.forwardRef((p, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            ...p,
            ref: ref,
            className: (0, _classnamesDefault.default)(p.className, className)
        }));

},{"react":"bmhQu","classnames":"9HH2M","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fPmGg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSharedManager", ()=>getSharedManager);
var _addClass = require("dom-helpers/addClass");
var _addClassDefault = parcelHelpers.interopDefault(_addClass);
var _css = require("dom-helpers/css");
var _cssDefault = parcelHelpers.interopDefault(_css);
var _querySelectorAll = require("dom-helpers/querySelectorAll");
var _querySelectorAllDefault = parcelHelpers.interopDefault(_querySelectorAll);
var _removeClass = require("dom-helpers/removeClass");
var _removeClassDefault = parcelHelpers.interopDefault(_removeClass);
var _modalManager = require("@restart/ui/ModalManager");
var _modalManagerDefault = parcelHelpers.interopDefault(_modalManager);
const Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};
class BootstrapModalManager extends (0, _modalManagerDefault.default) {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // @ts-expect-error TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        element.dataset[prop] = actual;
        (0, _cssDefault.default)(element, {
            [prop]: `${parseFloat((0, _cssDefault.default)(element, prop)) + adjust}px`
        });
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            (0, _cssDefault.default)(element, {
                [prop]: value
            });
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        (0, _addClassDefault.default)(container, 'modal-open');
        if (!containerState.scrollBarWidth) return;
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, _querySelectorAllDefault.default)(container, Selector.FIXED_CONTENT).forEach((el)=>this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
        (0, _querySelectorAllDefault.default)(container, Selector.STICKY_CONTENT).forEach((el)=>this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
        (0, _querySelectorAllDefault.default)(container, Selector.NAVBAR_TOGGLER).forEach((el)=>this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        (0, _removeClassDefault.default)(container, 'modal-open');
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, _querySelectorAllDefault.default)(container, Selector.FIXED_CONTENT).forEach((el)=>this.restore(paddingProp, el));
        (0, _querySelectorAllDefault.default)(container, Selector.STICKY_CONTENT).forEach((el)=>this.restore(marginProp, el));
        (0, _querySelectorAllDefault.default)(container, Selector.NAVBAR_TOGGLER).forEach((el)=>this.restore(marginProp, el));
    }
}
let sharedManager;
function getSharedManager(options) {
    if (!sharedManager) sharedManager = new BootstrapModalManager(options);
    return sharedManager;
}
exports.default = BootstrapModalManager;

},{"dom-helpers/addClass":"a5yAf","dom-helpers/css":"hqAHK","dom-helpers/querySelectorAll":"ctiqR","dom-helpers/removeClass":"bbyxy","@restart/ui/ModalManager":"b3RZH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a5yAf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addClass);
var _hasClass = require("./hasClass");
var _hasClassDefault = parcelHelpers.interopDefault(_hasClass);
function addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, _hasClassDefault.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}

},{"./hasClass":"7ZnXu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7ZnXu":[function(require,module,exports,__globalThis) {
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hasClass);
function hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bbyxy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>removeClass);
function replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);
    else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g0Ec4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const NavbarText = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'navbar-text');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
NavbarText.displayName = 'NavbarText';
exports.default = NavbarText;

},{"react":"bmhQu","classnames":"9HH2M","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"918Zj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _dropdown = require("./Dropdown");
var _dropdownDefault = parcelHelpers.interopDefault(_dropdown);
var _navLink = require("./NavLink");
var _navLinkDefault = parcelHelpers.interopDefault(_navLink);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const NavDropdown = /*#__PURE__*/ _react.forwardRef(({ id, title, children, bsPrefix, className, rootCloseEvent, menuRole, disabled, active, renderMenuOnMount, menuVariant, ...props }, ref)=>{
    /* NavItem has no additional logic, it's purely presentational. Can set nav item class here to support "as" */ const navItemPrefix = (0, _themeProvider.useBootstrapPrefix)(undefined, 'nav-item');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dropdownDefault.default), {
        ref: ref,
        ...props,
        className: (0, _classnamesDefault.default)(className, navItemPrefix),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownDefault.default).Toggle, {
                id: id,
                eventKey: null,
                active: active,
                disabled: disabled,
                childBsPrefix: bsPrefix,
                as: (0, _navLinkDefault.default),
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownDefault.default).Menu, {
                role: menuRole,
                renderOnMount: renderMenuOnMount,
                rootCloseEvent: rootCloseEvent,
                variant: menuVariant,
                children: children
            })
        ]
    });
});
NavDropdown.displayName = 'NavDropdown';
exports.default = Object.assign(NavDropdown, {
    Item: (0, _dropdownDefault.default).Item,
    ItemText: (0, _dropdownDefault.default).ItemText,
    Divider: (0, _dropdownDefault.default).Divider,
    Header: (0, _dropdownDefault.default).Header
});

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","./Dropdown":"7uokG","./NavLink":"e3vjD","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7uokG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _dropdown = require("@restart/ui/Dropdown");
var _dropdownDefault = parcelHelpers.interopDefault(_dropdown);
var _uncontrollable = require("uncontrollable");
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _dropdownContext = require("./DropdownContext");
var _dropdownContextDefault = parcelHelpers.interopDefault(_dropdownContext);
var _dropdownDivider = require("./DropdownDivider");
var _dropdownDividerDefault = parcelHelpers.interopDefault(_dropdownDivider);
var _dropdownHeader = require("./DropdownHeader");
var _dropdownHeaderDefault = parcelHelpers.interopDefault(_dropdownHeader);
var _dropdownItem = require("./DropdownItem");
var _dropdownItemDefault = parcelHelpers.interopDefault(_dropdownItem);
var _dropdownItemText = require("./DropdownItemText");
var _dropdownItemTextDefault = parcelHelpers.interopDefault(_dropdownItemText);
var _dropdownMenu = require("./DropdownMenu");
var _dropdownMenuDefault = parcelHelpers.interopDefault(_dropdownMenu);
var _dropdownToggle = require("./DropdownToggle");
var _dropdownToggleDefault = parcelHelpers.interopDefault(_dropdownToggle);
var _inputGroupContext = require("./InputGroupContext");
var _inputGroupContextDefault = parcelHelpers.interopDefault(_inputGroupContext);
var _themeProvider = require("./ThemeProvider");
var _types = require("./types");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Dropdown = /*#__PURE__*/ _react.forwardRef((pProps, ref)=>{
    const { bsPrefix, drop = 'down', show, className, align = 'start', onSelect, onToggle, focusFirstItemOnShow, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', navbar: _4, autoClose = true, ...props } = (0, _uncontrollable.useUncontrolled)(pProps, {
        show: 'onToggle'
    });
    const isInputGroup = (0, _react.useContext)((0, _inputGroupContextDefault.default));
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'dropdown');
    const isRTL = (0, _themeProvider.useIsRTL)();
    const isClosingPermitted = (source)=>{
        // autoClose=false only permits close on button click
        if (autoClose === false) return source === 'click';
        // autoClose=inside doesn't permit close on rootClose
        if (autoClose === 'inside') return source !== 'rootClose';
        // autoClose=outside doesn't permit close on select
        if (autoClose === 'outside') return source !== 'select';
        return true;
    };
    const handleToggle = (0, _useEventCallbackDefault.default)((nextShow, meta)=>{
        var _meta$originalEvent;
        /** Checking if target of event is ToggleButton,
     * if it is then nullify mousedown event
     */ const isToggleButton = (_meta$originalEvent = meta.originalEvent) == null || (_meta$originalEvent = _meta$originalEvent.target) == null ? void 0 : _meta$originalEvent.classList.contains('dropdown-toggle');
        if (isToggleButton && meta.source === 'mousedown') return;
        if (meta.originalEvent.currentTarget === document && (meta.source !== 'keydown' || meta.originalEvent.key === 'Escape')) meta.source = 'rootClose';
        if (isClosingPermitted(meta.source)) onToggle == null || onToggle(nextShow, meta);
    });
    const alignEnd = align === 'end';
    const placement = (0, _dropdownMenu.getDropdownMenuPlacement)(alignEnd, drop, isRTL);
    const contextValue = (0, _react.useMemo)(()=>({
            align,
            drop,
            isRTL
        }), [
        align,
        drop,
        isRTL
    ]);
    const directionClasses = {
        down: prefix,
        'down-centered': `${prefix}-center`,
        up: 'dropup',
        'up-centered': 'dropup-center dropup',
        end: 'dropend',
        start: 'dropstart'
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownContextDefault.default).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownDefault.default), {
            placement: placement,
            show: show,
            onSelect: onSelect,
            onToggle: handleToggle,
            focusFirstItemOnShow: focusFirstItemOnShow,
            itemSelector: `.${prefix}-item:not(.disabled):not(:disabled)`,
            children: isInputGroup ? props.children : /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
                ...props,
                ref: ref,
                className: (0, _classnamesDefault.default)(className, show && 'show', directionClasses[drop])
            })
        })
    });
});
Dropdown.displayName = 'Dropdown';
exports.default = Object.assign(Dropdown, {
    Toggle: (0, _dropdownToggleDefault.default),
    Menu: (0, _dropdownMenuDefault.default),
    Item: (0, _dropdownItemDefault.default),
    ItemText: (0, _dropdownItemTextDefault.default),
    Divider: (0, _dropdownDividerDefault.default),
    Header: (0, _dropdownHeaderDefault.default)
});

},{"classnames":"9HH2M","react":"bmhQu","@restart/ui/Dropdown":"aV5aA","uncontrollable":"1yRhe","@restart/hooks/useEventCallback":"8gfnN","./DropdownContext":"kBBfM","./DropdownDivider":"iQqDM","./DropdownHeader":"3yRHg","./DropdownItem":"8SRt4","./DropdownItemText":"lnX7Z","./DropdownMenu":"6sEFY","./DropdownToggle":"9yXfJ","./InputGroupContext":"kopE8","./ThemeProvider":"aQ1Mj","./types":"bbBUb","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aV5aA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _querySelectorAll = require("dom-helpers/querySelectorAll");
var _querySelectorAllDefault = parcelHelpers.interopDefault(_querySelectorAll);
var _addEventListener = require("dom-helpers/addEventListener");
var _addEventListenerDefault = parcelHelpers.interopDefault(_addEventListener);
var _react = require("react");
var _uncontrollable = require("uncontrollable");
var _usePrevious = require("@restart/hooks/usePrevious");
var _usePreviousDefault = parcelHelpers.interopDefault(_usePrevious);
var _useForceUpdate = require("@restart/hooks/useForceUpdate");
var _useForceUpdateDefault = parcelHelpers.interopDefault(_useForceUpdate);
var _useEventListener = require("@restart/hooks/useEventListener");
var _useEventListenerDefault = parcelHelpers.interopDefault(_useEventListener);
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _dropdownContext = require("./DropdownContext");
var _dropdownContextDefault = parcelHelpers.interopDefault(_dropdownContext);
var _dropdownMenu = require("./DropdownMenu");
var _dropdownMenuDefault = parcelHelpers.interopDefault(_dropdownMenu);
var _dropdownToggle = require("./DropdownToggle");
var _dropdownToggleDefault = parcelHelpers.interopDefault(_dropdownToggle);
var _dropdownItem = require("./DropdownItem");
var _dropdownItemDefault = parcelHelpers.interopDefault(_dropdownItem);
var _selectableContext = require("./SelectableContext");
var _selectableContextDefault = parcelHelpers.interopDefault(_selectableContext);
var _dataKey = require("./DataKey");
var _useWindow = require("./useWindow");
var _useWindowDefault = parcelHelpers.interopDefault(_useWindow);
var _jsxRuntime = require("react/jsx-runtime");
function useRefWithUpdate() {
    const forceUpdate = (0, _useForceUpdateDefault.default)();
    const ref = (0, _react.useRef)(null);
    const attachRef = (0, _react.useCallback)((element)=>{
        ref.current = element;
        // ensure that a menu set triggers an update for consumers
        forceUpdate();
    }, [
        forceUpdate
    ]);
    return [
        ref,
        attachRef
    ];
}
/**
 * @displayName Dropdown
 * @public
 */ function Dropdown({ defaultShow, show: rawShow, onSelect, onToggle: rawOnToggle, itemSelector = `* [${(0, _dataKey.dataAttr)('dropdown-item')}]`, focusFirstItemOnShow, placement = 'bottom-start', children }) {
    const window = (0, _useWindowDefault.default)();
    const [show, onToggle] = (0, _uncontrollable.useUncontrolledProp)(rawShow, defaultShow, rawOnToggle);
    // We use normal refs instead of useCallbackRef in order to populate the
    // the value as quickly as possible, otherwise the effect to focus the element
    // may run before the state value is set
    const [menuRef, setMenu] = useRefWithUpdate();
    const menuElement = menuRef.current;
    const [toggleRef, setToggle] = useRefWithUpdate();
    const toggleElement = toggleRef.current;
    const lastShow = (0, _usePreviousDefault.default)(show);
    const lastSourceEvent = (0, _react.useRef)(null);
    const focusInDropdown = (0, _react.useRef)(false);
    const onSelectCtx = (0, _react.useContext)((0, _selectableContextDefault.default));
    const toggle = (0, _react.useCallback)((nextShow, event, source = event == null ? void 0 : event.type)=>{
        onToggle(nextShow, {
            originalEvent: event,
            source
        });
    }, [
        onToggle
    ]);
    const handleSelect = (0, _useEventCallbackDefault.default)((key, event)=>{
        onSelect == null || onSelect(key, event);
        toggle(false, event, 'select');
        if (!event.isPropagationStopped()) onSelectCtx == null || onSelectCtx(key, event);
    });
    const context = (0, _react.useMemo)(()=>({
            toggle,
            placement,
            show,
            menuElement,
            toggleElement,
            setMenu,
            setToggle
        }), [
        toggle,
        placement,
        show,
        menuElement,
        toggleElement,
        setMenu,
        setToggle
    ]);
    if (menuElement && lastShow && !show) focusInDropdown.current = menuElement.contains(menuElement.ownerDocument.activeElement);
    const focusToggle = (0, _useEventCallbackDefault.default)(()=>{
        if (toggleElement && toggleElement.focus) toggleElement.focus();
    });
    const maybeFocusFirst = (0, _useEventCallbackDefault.default)(()=>{
        const type = lastSourceEvent.current;
        let focusType = focusFirstItemOnShow;
        if (focusType == null) focusType = menuRef.current && (0, _dropdownToggle.isRoleMenu)(menuRef.current) ? 'keyboard' : false;
        if (focusType === false || focusType === 'keyboard' && !/^key.+$/.test(type)) return;
        const first = (0, _querySelectorAllDefault.default)(menuRef.current, itemSelector)[0];
        if (first && first.focus) first.focus();
    });
    (0, _react.useEffect)(()=>{
        if (show) maybeFocusFirst();
        else if (focusInDropdown.current) {
            focusInDropdown.current = false;
            focusToggle();
        }
    // only `show` should be changing
    }, [
        show,
        focusInDropdown,
        focusToggle,
        maybeFocusFirst
    ]);
    (0, _react.useEffect)(()=>{
        lastSourceEvent.current = null;
    });
    const getNextFocusedChild = (current, offset)=>{
        if (!menuRef.current) return null;
        const items = (0, _querySelectorAllDefault.default)(menuRef.current, itemSelector);
        let index = items.indexOf(current) + offset;
        index = Math.max(0, Math.min(index, items.length));
        return items[index];
    };
    (0, _useEventListenerDefault.default)((0, _react.useCallback)(()=>window.document, [
        window
    ]), 'keydown', (event)=>{
        var _menuRef$current, _toggleRef$current;
        const { key } = event;
        const target = event.target;
        const fromMenu = (_menuRef$current = menuRef.current) == null ? void 0 : _menuRef$current.contains(target);
        const fromToggle = (_toggleRef$current = toggleRef.current) == null ? void 0 : _toggleRef$current.contains(target);
        // Second only to https://github.com/twbs/bootstrap/blob/8cfbf6933b8a0146ac3fbc369f19e520bd1ebdac/js/src/dropdown.js#L400
        // in inscrutability
        const isInput = /input|textarea/i.test(target.tagName);
        if (isInput && (key === ' ' || key !== 'Escape' && fromMenu || key === 'Escape' && target.type === 'search')) return;
        if (!fromMenu && !fromToggle) return;
        if (key === 'Tab' && (!menuRef.current || !show)) return;
        lastSourceEvent.current = event.type;
        const meta = {
            originalEvent: event,
            source: event.type
        };
        switch(key){
            case 'ArrowUp':
                {
                    const next = getNextFocusedChild(target, -1);
                    if (next && next.focus) next.focus();
                    event.preventDefault();
                    return;
                }
            case 'ArrowDown':
                event.preventDefault();
                if (!show) onToggle(true, meta);
                else {
                    const next = getNextFocusedChild(target, 1);
                    if (next && next.focus) next.focus();
                }
                return;
            case 'Tab':
                // on keydown the target is the element being tabbed FROM, we need that
                // to know if this event is relevant to this dropdown (e.g. in this menu).
                // On `keyup` the target is the element being tagged TO which we use to check
                // if focus has left the menu
                (0, _addEventListenerDefault.default)(target.ownerDocument, 'keyup', (e)=>{
                    var _menuRef$current2;
                    if (e.key === 'Tab' && !e.target || !((_menuRef$current2 = menuRef.current) != null && _menuRef$current2.contains(e.target))) onToggle(false, meta);
                }, {
                    once: true
                });
                break;
            case 'Escape':
                if (key === 'Escape') {
                    event.preventDefault();
                    event.stopPropagation();
                }
                onToggle(false, meta);
                break;
            default:
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectableContextDefault.default).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownContextDefault.default).Provider, {
            value: context,
            children: children
        })
    });
}
Dropdown.displayName = 'Dropdown';
Dropdown.Menu = (0, _dropdownMenuDefault.default);
Dropdown.Toggle = (0, _dropdownToggleDefault.default);
Dropdown.Item = (0, _dropdownItemDefault.default);
exports.default = Dropdown;

},{"dom-helpers/querySelectorAll":"ctiqR","dom-helpers/addEventListener":"fjZpG","react":"bmhQu","uncontrollable":"2jAIi","@restart/hooks/usePrevious":"6GTFb","@restart/hooks/useForceUpdate":"ekHOI","@restart/hooks/useEventListener":"i7vdC","@restart/hooks/useEventCallback":"j7CsD","./DropdownContext":"03nhu","./DropdownMenu":"7jYkf","./DropdownToggle":"fvcaa","./DropdownItem":"4c7b5","./SelectableContext":"e59aX","./DataKey":"g9Cvj","./useWindow":"ikTkv","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2jAIi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultKey", ()=>defaultKey);
parcelHelpers.export(exports, "useUncontrolledProp", ()=>useUncontrolledProp);
parcelHelpers.export(exports, "useUncontrolled", ()=>useUncontrolled);
var _react = require("react");
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function defaultKey(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function useUncontrolledProp(propValue, defaultValue, handler) {
    const wasPropRef = (0, _react.useRef)(propValue !== undefined);
    const [stateValue, setState] = (0, _react.useState)(defaultValue);
    const isProp = propValue !== undefined;
    const wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, _react.useCallback)((...args)=>{
            const [value, ...rest] = args;
            let returnValue = handler == null ? void 0 : handler(value, ...rest);
            setState(value);
            return returnValue;
        }, [
            handler
        ])
    ];
}
function useUncontrolled(props, config) {
    return Object.keys(config).reduce((result, fieldName)=>{
        const _ref = result, _defaultKey = defaultKey(fieldName), { [_defaultKey]: defaultValue, [fieldName]: propsValue } = _ref, rest = _objectWithoutPropertiesLoose(_ref, [
            _defaultKey,
            fieldName
        ].map(_toPropertyKey));
        const handlerName = config[fieldName];
        const [value, handler] = useUncontrolledProp(propsValue, defaultValue, props[handlerName]);
        return Object.assign({}, rest, {
            [fieldName]: value,
            [handlerName]: handler
        });
    }, props);
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"03nhu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const DropdownContext = /*#__PURE__*/ _react.createContext(null);
exports.default = DropdownContext;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7jYkf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @memberOf Dropdown
 * @param {object}  options
 * @param {boolean} options.flip Automatically adjust the menu `drop` position based on viewport edge detection
 * @param {[number, number]} options.offset Define an offset distance between the Menu and the Toggle
 * @param {boolean} options.show Display the menu manually, ignored in the context of a `Dropdown`
 * @param {boolean} options.usePopper opt in/out of using PopperJS to position menus. When disabled you must position it yourself.
 * @param {string}  options.rootCloseEvent The pointer event to listen for when determining "clicks outside" the menu for triggering a close.
 * @param {object}  options.popperConfig Options passed to the [`usePopper`](/api/usePopper) hook.
 */ parcelHelpers.export(exports, "useDropdownMenu", ()=>useDropdownMenu);
var _react = require("react");
var _useCallbackRef = require("@restart/hooks/useCallbackRef");
var _useCallbackRefDefault = parcelHelpers.interopDefault(_useCallbackRef);
var _dropdownContext = require("./DropdownContext");
var _dropdownContextDefault = parcelHelpers.interopDefault(_dropdownContext);
var _usePopper = require("./usePopper");
var _usePopperDefault = parcelHelpers.interopDefault(_usePopper);
var _useClickOutside = require("./useClickOutside");
var _useClickOutsideDefault = parcelHelpers.interopDefault(_useClickOutside);
var _mergeOptionsWithPopperConfig = require("./mergeOptionsWithPopperConfig");
var _mergeOptionsWithPopperConfigDefault = parcelHelpers.interopDefault(_mergeOptionsWithPopperConfig);
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "children",
    "usePopper"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const noop = ()=>{};
function useDropdownMenu(options = {}) {
    const context = (0, _react.useContext)((0, _dropdownContextDefault.default));
    const [arrowElement, attachArrowRef] = (0, _useCallbackRefDefault.default)();
    const hasShownRef = (0, _react.useRef)(false);
    const { flip, offset, rootCloseEvent, fixed = false, placement: placementOverride, popperConfig = {}, enableEventListeners = true, usePopper: shouldUsePopper = !!context } = options;
    const show = (context == null ? void 0 : context.show) == null ? !!options.show : context.show;
    if (show && !hasShownRef.current) hasShownRef.current = true;
    const handleClose = (e)=>{
        context == null || context.toggle(false, e);
    };
    const { placement, setMenu, menuElement, toggleElement } = context || {};
    const popper = (0, _usePopperDefault.default)(toggleElement, menuElement, (0, _mergeOptionsWithPopperConfigDefault.default)({
        placement: placementOverride || placement || 'bottom-start',
        enabled: shouldUsePopper,
        enableEvents: enableEventListeners == null ? show : enableEventListeners,
        offset,
        flip,
        fixed,
        arrowElement,
        popperConfig
    }));
    const menuProps = Object.assign({
        ref: setMenu || noop,
        'aria-labelledby': toggleElement == null ? void 0 : toggleElement.id
    }, popper.attributes.popper, {
        style: popper.styles.popper
    });
    const metadata = {
        show,
        placement,
        hasShown: hasShownRef.current,
        toggle: context == null ? void 0 : context.toggle,
        popper: shouldUsePopper ? popper : null,
        arrowProps: shouldUsePopper ? Object.assign({
            ref: attachArrowRef
        }, popper.attributes.arrow, {
            style: popper.styles.arrow
        }) : {}
    };
    (0, _useClickOutsideDefault.default)(menuElement, handleClose, {
        clickTrigger: rootCloseEvent,
        disabled: !show
    });
    return [
        menuProps,
        metadata
    ];
}
/**
 * Also exported as `<Dropdown.Menu>` from `Dropdown`.
 *
 * @displayName DropdownMenu
 * @memberOf Dropdown
 */ function DropdownMenu(_ref) {
    let { children, usePopper: usePopperProp = true } = _ref, options = _objectWithoutPropertiesLoose(_ref, _excluded);
    const [props, meta] = useDropdownMenu(Object.assign({}, options, {
        usePopper: usePopperProp
    }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: children(props, meta)
    });
}
DropdownMenu.displayName = 'DropdownMenu';
/** @component */ exports.default = DropdownMenu;

},{"react":"bmhQu","@restart/hooks/useCallbackRef":"dezJ9","./DropdownContext":"03nhu","./usePopper":"3xm4J","./useClickOutside":"uqij7","./mergeOptionsWithPopperConfig":"118Fa","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3xm4J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _dequal = require("dequal");
var _useSafeState = require("@restart/hooks/useSafeState");
var _useSafeStateDefault = parcelHelpers.interopDefault(_useSafeState);
var _popper = require("./popper");
const _excluded = [
    "enabled",
    "placement",
    "strategy",
    "modifiers"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const disabledApplyStylesModifier = {
    name: 'applyStyles',
    enabled: false,
    phase: 'afterWrite',
    fn: ()=>undefined
};
// until docjs supports type exports...
const ariaDescribedByModifier = {
    name: 'ariaDescribedBy',
    enabled: true,
    phase: 'afterWrite',
    effect: ({ state })=>()=>{
            const { reference, popper } = state.elements;
            if ('removeAttribute' in reference) {
                const ids = (reference.getAttribute('aria-describedby') || '').split(',').filter((id)=>id.trim() !== popper.id);
                if (!ids.length) reference.removeAttribute('aria-describedby');
                else reference.setAttribute('aria-describedby', ids.join(','));
            }
        },
    fn: ({ state })=>{
        var _popper$getAttribute;
        const { popper, reference } = state.elements;
        const role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
            const ids = reference.getAttribute('aria-describedby');
            if (ids && ids.split(',').indexOf(popper.id) !== -1) return;
            reference.setAttribute('aria-describedby', ids ? `${ids},${popper.id}` : popper.id);
        }
    }
};
const EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function usePopper(referenceElement, popperElement, _ref = {}) {
    let { enabled = true, placement = 'bottom', strategy = 'absolute', modifiers = EMPTY_MODIFIERS } = _ref, config = _objectWithoutPropertiesLoose(_ref, _excluded);
    const prevModifiers = (0, _react.useRef)(modifiers);
    const popperInstanceRef = (0, _react.useRef)();
    const update = (0, _react.useCallback)(()=>{
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    const forceUpdate = (0, _react.useCallback)(()=>{
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    const [popperState, setState] = (0, _useSafeStateDefault.default)((0, _react.useState)({
        placement,
        update,
        forceUpdate,
        attributes: {},
        styles: {
            popper: {},
            arrow: {}
        }
    }));
    const updateModifier = (0, _react.useMemo)(()=>({
            name: 'updateStateModifier',
            enabled: true,
            phase: 'write',
            requires: [
                'computeStyles'
            ],
            fn: ({ state })=>{
                const styles = {};
                const attributes = {};
                Object.keys(state.elements).forEach((element)=>{
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state,
                    styles,
                    attributes,
                    update,
                    forceUpdate,
                    placement: state.placement
                });
            }
        }), [
        update,
        forceUpdate,
        setState
    ]);
    const nextModifiers = (0, _react.useMemo)(()=>{
        if (!(0, _dequal.dequal)(prevModifiers.current, modifiers)) prevModifiers.current = modifiers;
        return prevModifiers.current;
    }, [
        modifiers
    ]);
    (0, _react.useEffect)(()=>{
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement,
            strategy,
            modifiers: [
                ...nextModifiers,
                updateModifier,
                disabledApplyStylesModifier
            ]
        });
    }, [
        strategy,
        placement,
        updateModifier,
        enabled,
        nextModifiers
    ]);
    (0, _react.useEffect)(()=>{
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, _popper.createPopper)(referenceElement, popperElement, Object.assign({}, config, {
            placement,
            strategy,
            modifiers: [
                ...nextModifiers,
                ariaDescribedByModifier,
                updateModifier
            ]
        }));
        return ()=>{
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState((s)=>Object.assign({}, s, {
                        attributes: {},
                        styles: {
                            popper: {}
                        }
                    }));
            }
        };
    // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
exports.default = usePopper;

},{"react":"bmhQu","dequal":"huNh8","@restart/hooks/useSafeState":"aMuv6","./popper":"9wd0A","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"huNh8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dequal", ()=>dequal);
var has = Object.prototype.hasOwnProperty;
function find(iter, tar, key) {
    for (key of iter.keys()){
        if (dequal(key, tar)) return key;
    }
}
function dequal(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && dequal(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === 'object') {
                    tmp = find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === 'object') {
                    tmp = find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!dequal(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if (has.call(foo, ctor) && ++len && !has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !dequal(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aMuv6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useMounted = require("./useMounted");
var _useMountedDefault = parcelHelpers.interopDefault(_useMounted);
/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function useSafeState(state) {
    const isMounted = (0, _useMountedDefault.default)();
    return [
        state[0],
        (0, _react.useCallback)((nextState)=>{
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
exports.default = useSafeState;

},{"react":"bmhQu","./useMounted":"gkvSP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9wd0A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPopper", ()=>createPopper);
parcelHelpers.export(exports, "placements", ()=>(0, _enums.placements));
var _arrow = require("@popperjs/core/lib/modifiers/arrow");
var _arrowDefault = parcelHelpers.interopDefault(_arrow);
var _computeStyles = require("@popperjs/core/lib/modifiers/computeStyles");
var _computeStylesDefault = parcelHelpers.interopDefault(_computeStyles);
var _eventListeners = require("@popperjs/core/lib/modifiers/eventListeners");
var _eventListenersDefault = parcelHelpers.interopDefault(_eventListeners);
var _flip = require("@popperjs/core/lib/modifiers/flip");
var _flipDefault = parcelHelpers.interopDefault(_flip);
var _hide = require("@popperjs/core/lib/modifiers/hide");
var _hideDefault = parcelHelpers.interopDefault(_hide);
var _offset = require("@popperjs/core/lib/modifiers/offset");
var _offsetDefault = parcelHelpers.interopDefault(_offset);
var _popperOffsets = require("@popperjs/core/lib/modifiers/popperOffsets");
var _popperOffsetsDefault = parcelHelpers.interopDefault(_popperOffsets);
var _preventOverflow = require("@popperjs/core/lib/modifiers/preventOverflow");
var _preventOverflowDefault = parcelHelpers.interopDefault(_preventOverflow);
var _enums = require("@popperjs/core/lib/enums");
var _popperBase = require("@popperjs/core/lib/popper-base");
const createPopper = (0, _popperBase.popperGenerator)({
    defaultModifiers: [
        (0, _hideDefault.default),
        (0, _popperOffsetsDefault.default),
        (0, _computeStylesDefault.default),
        (0, _eventListenersDefault.default),
        (0, _offsetDefault.default),
        (0, _flipDefault.default),
        (0, _preventOverflowDefault.default),
        (0, _arrowDefault.default)
    ]
});

},{"@popperjs/core/lib/modifiers/arrow":"9ix8f","@popperjs/core/lib/modifiers/computeStyles":"01Efw","@popperjs/core/lib/modifiers/eventListeners":"bVIhS","@popperjs/core/lib/modifiers/flip":"cogtI","@popperjs/core/lib/modifiers/hide":"9wu2u","@popperjs/core/lib/modifiers/offset":"3jaKS","@popperjs/core/lib/modifiers/popperOffsets":"2U77E","@popperjs/core/lib/modifiers/preventOverflow":"2yxg5","@popperjs/core/lib/enums":false,"@popperjs/core/lib/popper-base":"lyyyk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9ix8f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _containsJs = require("../dom-utils/contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _withinJs = require("../utils/within.js");
var _mergePaddingObjectJs = require("../utils/mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("../utils/expandToHashMap.js");
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
var toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, _mergePaddingObjectJsDefault.default)(typeof padding !== 'number' ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
};
function arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var axis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var isVertical = [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = toPaddingObject(options.padding, state);
    var arrowRect = (0, _getLayoutRectJsDefault.default)(arrowElement);
    var minProp = axis === 'y' ? (0, _enumsJs.top) : (0, _enumsJs.left);
    var maxProp = axis === 'y' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, _getOffsetParentJsDefault.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, _withinJs.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, _containsJsDefault.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: arrow,
    effect: effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

},{"../utils/getBasePlacement.js":"7BYT3","../dom-utils/getLayoutRect.js":"b8HWl","../dom-utils/contains.js":"7KsA7","../dom-utils/getOffsetParent.js":"8UGZD","../utils/getMainAxisFromPlacement.js":"buXVK","../utils/within.js":"kgqKD","../utils/mergePaddingObject.js":"hDP2R","../utils/expandToHashMap.js":"5s8A5","../enums.js":"9CWfx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7BYT3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBasePlacement);
var _enumsJs = require("../enums.js");
function getBasePlacement(placement) {
    return placement.split('-')[0];
}

},{"../enums.js":"9CWfx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9CWfx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "top", ()=>top);
parcelHelpers.export(exports, "bottom", ()=>bottom);
parcelHelpers.export(exports, "right", ()=>right);
parcelHelpers.export(exports, "left", ()=>left);
parcelHelpers.export(exports, "auto", ()=>auto);
parcelHelpers.export(exports, "basePlacements", ()=>basePlacements);
parcelHelpers.export(exports, "start", ()=>start);
parcelHelpers.export(exports, "end", ()=>end);
parcelHelpers.export(exports, "clippingParents", ()=>clippingParents);
parcelHelpers.export(exports, "viewport", ()=>viewport);
parcelHelpers.export(exports, "popper", ()=>popper);
parcelHelpers.export(exports, "reference", ()=>reference);
parcelHelpers.export(exports, "variationPlacements", ()=>variationPlacements);
parcelHelpers.export(exports, "placements", ()=>placements);
parcelHelpers.export(exports, "beforeRead", ()=>beforeRead);
parcelHelpers.export(exports, "read", ()=>read);
parcelHelpers.export(exports, "afterRead", ()=>afterRead);
parcelHelpers.export(exports, "beforeMain", ()=>beforeMain);
parcelHelpers.export(exports, "main", ()=>main);
parcelHelpers.export(exports, "afterMain", ()=>afterMain);
parcelHelpers.export(exports, "beforeWrite", ()=>beforeWrite);
parcelHelpers.export(exports, "write", ()=>write);
parcelHelpers.export(exports, "afterWrite", ()=>afterWrite);
parcelHelpers.export(exports, "modifierPhases", ()=>modifierPhases);
var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [
    top,
    bottom,
    right,
    left
];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/ basePlacements.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []);
var placements = /*#__PURE__*/ [].concat(basePlacements, [
    auto
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []); // modifiers that need to read the DOM
var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers
var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [
    beforeRead,
    read,
    afterRead,
    beforeMain,
    main,
    afterMain,
    beforeWrite,
    write,
    afterWrite
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b8HWl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getLayoutRect);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js"); // Returns the layout rect of an element relative to its offsetParent. Layout
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
function getLayoutRect(element) {
    var clientRect = (0, _getBoundingClientRectJsDefault.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

},{"./getBoundingClientRect.js":"9Cf34","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9Cf34":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBoundingClientRect);
var _instanceOfJs = require("./instanceOf.js");
var _mathJs = require("../utils/math.js");
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, _instanceOfJs.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, _mathJs.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, _mathJs.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, _instanceOfJs.isElement)(element) ? (0, _getWindowJsDefault.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, _isLayoutViewportJsDefault.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

},{"./instanceOf.js":"4TIRi","../utils/math.js":"1EWdm","./getWindow.js":"8w2sO","./isLayoutViewport.js":"6Av1k","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4TIRi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isShadowRoot", ()=>isShadowRoot);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function isElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, _getWindowJsDefault.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

},{"./getWindow.js":"8w2sO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8w2sO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindow);
function getWindow(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1EWdm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "round", ()=>round);
var max = Math.max;
var min = Math.min;
var round = Math.round;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6Av1k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isLayoutViewport);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function isLayoutViewport() {
    return !/^((?!chrome|android).)*safari/i.test((0, _userAgentJsDefault.default)());
}

},{"../utils/userAgent.js":"6dyvO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6dyvO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUAString);
function getUAString() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7KsA7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>contains);
var _instanceOfJs = require("./instanceOf.js");
function contains(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, _instanceOfJs.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

},{"./instanceOf.js":"4TIRi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8UGZD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOffsetParent);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _isTableElementJs = require("./isTableElement.js");
var _isTableElementJsDefault = parcelHelpers.interopDefault(_isTableElementJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function getTrueOffsetParent(element) {
    if (!(0, _instanceOfJs.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, _getComputedStyleJsDefault.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, _userAgentJsDefault.default)());
    var isIE = /Trident/i.test((0, _userAgentJsDefault.default)());
    if (isIE && (0, _instanceOfJs.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, _getComputedStyleJsDefault.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, _getParentNodeJsDefault.default)(element);
    if ((0, _instanceOfJs.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, _instanceOfJs.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, _getNodeNameJsDefault.default)(currentNode)) < 0){
        var css = (0, _getComputedStyleJsDefault.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function getOffsetParent(element) {
    var window = (0, _getWindowJsDefault.default)(element);
    var offsetParent = getTrueOffsetParent(element);
    while(offsetParent && (0, _isTableElementJsDefault.default)(offsetParent) && (0, _getComputedStyleJsDefault.default)(offsetParent).position === 'static')offsetParent = getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, _getNodeNameJsDefault.default)(offsetParent) === 'html' || (0, _getNodeNameJsDefault.default)(offsetParent) === 'body' && (0, _getComputedStyleJsDefault.default)(offsetParent).position === 'static')) return window;
    return offsetParent || getContainingBlock(element) || window;
}

},{"./getWindow.js":"8w2sO","./getNodeName.js":"7oCwI","./getComputedStyle.js":"jVooW","./instanceOf.js":"4TIRi","./isTableElement.js":"gponE","./getParentNode.js":"lDflw","../utils/userAgent.js":"6dyvO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7oCwI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNodeName);
function getNodeName(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jVooW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getComputedStyle);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getComputedStyle(element) {
    return (0, _getWindowJsDefault.default)(element).getComputedStyle(element);
}

},{"./getWindow.js":"8w2sO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gponE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isTableElement);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
function isTableElement(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, _getNodeNameJsDefault.default)(element)) >= 0;
}

},{"./getNodeName.js":"7oCwI","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lDflw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getParentNode);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _instanceOfJs = require("./instanceOf.js");
function getParentNode(element) {
    if ((0, _getNodeNameJsDefault.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, _instanceOfJs.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, _getDocumentElementJsDefault.default)(element) // fallback
    );
}

},{"./getNodeName.js":"7oCwI","./getDocumentElement.js":"6ADI2","./instanceOf.js":"4TIRi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6ADI2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDocumentElement);
var _instanceOfJs = require("./instanceOf.js");
function getDocumentElement(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, _instanceOfJs.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

},{"./instanceOf.js":"4TIRi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"buXVK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getMainAxisFromPlacement);
function getMainAxisFromPlacement(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kgqKD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "within", ()=>within);
parcelHelpers.export(exports, "withinMaxClamp", ()=>withinMaxClamp);
var _mathJs = require("./math.js");
function within(min, value, max) {
    return (0, _mathJs.max)(min, (0, _mathJs.min)(value, max));
}
function withinMaxClamp(min, value, max) {
    var v = within(min, value, max);
    return v > max ? max : v;
}

},{"./math.js":"1EWdm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hDP2R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergePaddingObject);
var _getFreshSideObjectJs = require("./getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
function mergePaddingObject(paddingObject) {
    return Object.assign({}, (0, _getFreshSideObjectJsDefault.default)(), paddingObject);
}

},{"./getFreshSideObject.js":"kAN9N","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kAN9N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getFreshSideObject);
function getFreshSideObject() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5s8A5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>expandToHashMap);
function expandToHashMap(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"01Efw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapToStyles", ()=>mapToStyles);
var _enumsJs = require("../enums.js");
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getWindowJs = require("../dom-utils/getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("../dom-utils/getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _mathJs = require("../utils/math.js"); // eslint-disable-next-line import/no-unused-modules
var unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, _mathJs.round)(x * dpr) / dpr || 0,
        y: (0, _mathJs.round)(y * dpr) / dpr || 0
    };
}
function mapToStyles(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, _enumsJs.left);
    var sideY = (0, _enumsJs.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, _getOffsetParentJsDefault.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, _getWindowJsDefault.default)(popper)) {
            offsetParent = (0, _getDocumentElementJsDefault.default)(popper);
            if ((0, _getComputedStyleJsDefault.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, _enumsJs.top) || (placement === (0, _enumsJs.left) || placement === (0, _enumsJs.right)) && variation === (0, _enumsJs.end)) {
            sideY = (0, _enumsJs.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, _enumsJs.left) || (placement === (0, _enumsJs.top) || placement === (0, _enumsJs.bottom)) && variation === (0, _enumsJs.end)) {
            sideX = (0, _enumsJs.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && unsetSides);
    var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, _getWindowJsDefault.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, _getBasePlacementJsDefault.default)(state.placement),
        variation: (0, _getVariationJsDefault.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: computeStyles,
    data: {}
};

},{"../enums.js":"9CWfx","../dom-utils/getOffsetParent.js":"8UGZD","../dom-utils/getWindow.js":"8w2sO","../dom-utils/getDocumentElement.js":"6ADI2","../dom-utils/getComputedStyle.js":"jVooW","../utils/getBasePlacement.js":"7BYT3","../utils/getVariation.js":"2Us86","../utils/math.js":"1EWdm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2Us86":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getVariation);
function getVariation(placement) {
    return placement.split('-')[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bVIhS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getWindowJs = require("../dom-utils/getWindow.js"); // eslint-disable-next-line import/no-unused-modules
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var passive = {
    passive: true
};
function effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, _getWindowJsDefault.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, passive);
    });
    if (resize) window.addEventListener('resize', instance.update, passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, passive);
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: effect,
    data: {}
};

},{"../dom-utils/getWindow.js":"8w2sO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cogtI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getOppositePlacementJs = require("../utils/getOppositePlacement.js");
var _getOppositePlacementJsDefault = parcelHelpers.interopDefault(_getOppositePlacementJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getOppositeVariationPlacementJs = require("../utils/getOppositeVariationPlacement.js");
var _getOppositeVariationPlacementJsDefault = parcelHelpers.interopDefault(_getOppositeVariationPlacementJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _computeAutoPlacementJs = require("../utils/computeAutoPlacement.js");
var _computeAutoPlacementJsDefault = parcelHelpers.interopDefault(_computeAutoPlacementJs);
var _enumsJs = require("../enums.js");
var _getVariationJs = require("../utils/getVariation.js"); // eslint-disable-next-line import/no-unused-modules
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
function getExpandedFallbackPlacements(placement) {
    if ((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto)) return [];
    var oppositePlacement = (0, _getOppositePlacementJsDefault.default)(placement);
    return [
        (0, _getOppositeVariationPlacementJsDefault.default)(placement),
        oppositePlacement,
        (0, _getOppositeVariationPlacementJsDefault.default)(oppositePlacement)
    ];
}
function flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, _getOppositePlacementJsDefault.default)(preferredPlacement)
    ] : getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto) ? (0, _computeAutoPlacementJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
        var isStartVariation = (0, _getVariationJsDefault.default)(placement) === (0, _enumsJs.start);
        var isVertical = [
            (0, _enumsJs.top),
            (0, _enumsJs.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, _enumsJs.right) : (0, _enumsJs.left) : isStartVariation ? (0, _enumsJs.bottom) : (0, _enumsJs.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var altVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

},{"../utils/getOppositePlacement.js":"fKKnP","../utils/getBasePlacement.js":"7BYT3","../utils/getOppositeVariationPlacement.js":"76l4A","../utils/detectOverflow.js":"e1TOL","../utils/computeAutoPlacement.js":"hsHYl","../enums.js":"9CWfx","../utils/getVariation.js":"2Us86","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fKKnP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOppositePlacement);
var hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"76l4A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOppositeVariationPlacement);
var hash = {
    start: 'end',
    end: 'start'
};
function getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e1TOL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>detectOverflow);
var _getClippingRectJs = require("../dom-utils/getClippingRect.js");
var _getClippingRectJsDefault = parcelHelpers.interopDefault(_getClippingRectJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getBoundingClientRectJs = require("../dom-utils/getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _computeOffsetsJs = require("./computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
var _rectToClientRectJs = require("./rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _enumsJs = require("../enums.js");
var _instanceOfJs = require("../dom-utils/instanceOf.js");
var _mergePaddingObjectJs = require("./mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("./expandToHashMap.js"); // eslint-disable-next-line import/no-unused-modules
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
function detectOverflow(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, _enumsJs.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, _enumsJs.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, _enumsJs.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, _mergePaddingObjectJsDefault.default)(typeof padding !== 'number' ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
    var altContext = elementContext === (0, _enumsJs.popper) ? (0, _enumsJs.reference) : (0, _enumsJs.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, _getClippingRectJsDefault.default)((0, _instanceOfJs.isElement)(element) ? element : element.contextElement || (0, _getDocumentElementJsDefault.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, _getBoundingClientRectJsDefault.default)(state.elements.reference);
    var popperOffsets = (0, _computeOffsetsJsDefault.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, _rectToClientRectJsDefault.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, _enumsJs.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, _enumsJs.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, _enumsJs.right),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, _enumsJs.top),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

},{"../dom-utils/getClippingRect.js":"csGCt","../dom-utils/getDocumentElement.js":"6ADI2","../dom-utils/getBoundingClientRect.js":"9Cf34","./computeOffsets.js":"5fJUw","./rectToClientRect.js":"aYxjG","../enums.js":"9CWfx","../dom-utils/instanceOf.js":"4TIRi","./mergePaddingObject.js":"hDP2R","./expandToHashMap.js":"5s8A5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"csGCt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getClippingRect);
var _enumsJs = require("../enums.js");
var _getViewportRectJs = require("./getViewportRect.js");
var _getViewportRectJsDefault = parcelHelpers.interopDefault(_getViewportRectJs);
var _getDocumentRectJs = require("./getDocumentRect.js");
var _getDocumentRectJsDefault = parcelHelpers.interopDefault(_getDocumentRectJs);
var _listScrollParentsJs = require("./listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _rectToClientRectJs = require("../utils/rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _mathJs = require("../utils/math.js");
function getInnerBoundingClientRect(element, strategy) {
    var rect = (0, _getBoundingClientRectJsDefault.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, _enumsJs.viewport) ? (0, _rectToClientRectJsDefault.default)((0, _getViewportRectJsDefault.default)(element, strategy)) : (0, _instanceOfJs.isElement)(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : (0, _rectToClientRectJsDefault.default)((0, _getDocumentRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function getClippingParents(element) {
    var clippingParents = (0, _listScrollParentsJsDefault.default)((0, _getParentNodeJsDefault.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, _getComputedStyleJsDefault.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, _instanceOfJs.isHTMLElement)(element) ? (0, _getOffsetParentJsDefault.default)(element) : element;
    if (!(0, _instanceOfJs.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, _instanceOfJs.isElement)(clippingParent) && (0, _containsJsDefault.default)(clippingParent, clipperElement) && (0, _getNodeNameJsDefault.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function getClippingRect(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, _mathJs.max)(rect.top, accRect.top);
        accRect.right = (0, _mathJs.min)(rect.right, accRect.right);
        accRect.bottom = (0, _mathJs.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, _mathJs.max)(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

},{"../enums.js":"9CWfx","./getViewportRect.js":"1uEvb","./getDocumentRect.js":"4xDfl","./listScrollParents.js":"6EVlq","./getOffsetParent.js":"8UGZD","./getDocumentElement.js":"6ADI2","./getComputedStyle.js":"jVooW","./instanceOf.js":"4TIRi","./getBoundingClientRect.js":"9Cf34","./getParentNode.js":"lDflw","./contains.js":"7KsA7","./getNodeName.js":"7oCwI","../utils/rectToClientRect.js":"aYxjG","../utils/math.js":"1EWdm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1uEvb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getViewportRect);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getViewportRect(element, strategy) {
    var win = (0, _getWindowJsDefault.default)(element);
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, _isLayoutViewportJsDefault.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, _getWindowScrollBarXJsDefault.default)(element),
        y: y
    };
}

},{"./getWindow.js":"8w2sO","./getDocumentElement.js":"6ADI2","./getWindowScrollBarX.js":"h4IJk","./isLayoutViewport.js":"6Av1k","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h4IJk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindowScrollBarX);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, _getBoundingClientRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)).left + (0, _getWindowScrollJsDefault.default)(element).scrollLeft;
}

},{"./getBoundingClientRect.js":"9Cf34","./getDocumentElement.js":"6ADI2","./getWindowScroll.js":"7wuKP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7wuKP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindowScroll);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getWindowScroll(node) {
    var win = (0, _getWindowJsDefault.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

},{"./getWindow.js":"8w2sO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4xDfl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDocumentRect);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _mathJs = require("../utils/math.js"); // Gets the entire size of the scrollable document area, even extending outside
function getDocumentRect(element) {
    var _element$ownerDocumen;
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var winScroll = (0, _getWindowScrollJsDefault.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, _mathJs.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, _mathJs.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, _getWindowScrollBarXJsDefault.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, _getComputedStyleJsDefault.default)(body || html).direction === 'rtl') x += (0, _mathJs.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

},{"./getDocumentElement.js":"6ADI2","./getComputedStyle.js":"jVooW","./getWindowScrollBarX.js":"h4IJk","./getWindowScroll.js":"7wuKP","../utils/math.js":"1EWdm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6EVlq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>listScrollParents);
var _getScrollParentJs = require("./getScrollParent.js");
var _getScrollParentJsDefault = parcelHelpers.interopDefault(_getScrollParentJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
function listScrollParents(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, _getScrollParentJsDefault.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, _getWindowJsDefault.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, _isScrollParentJsDefault.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat(listScrollParents((0, _getParentNodeJsDefault.default)(target)));
}

},{"./getScrollParent.js":"fCJLI","./getParentNode.js":"lDflw","./getWindow.js":"8w2sO","./isScrollParent.js":"fupCg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fCJLI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getScrollParent);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
function getScrollParent(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, _getNodeNameJsDefault.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, _instanceOfJs.isHTMLElement)(node) && (0, _isScrollParentJsDefault.default)(node)) return node;
    return getScrollParent((0, _getParentNodeJsDefault.default)(node));
}

},{"./getParentNode.js":"lDflw","./isScrollParent.js":"fupCg","./getNodeName.js":"7oCwI","./instanceOf.js":"4TIRi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fupCg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isScrollParent);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
function isScrollParent(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, _getComputedStyleJsDefault.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

},{"./getComputedStyle.js":"jVooW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aYxjG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rectToClientRect);
function rectToClientRect(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5fJUw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeOffsets);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getMainAxisFromPlacementJs = require("./getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _enumsJs = require("../enums.js");
function computeOffsets(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, _getBasePlacementJsDefault.default)(placement) : null;
    var variation = placement ? (0, _getVariationJsDefault.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, _enumsJs.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, _enumsJs.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, _enumsJs.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, _enumsJs.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, _enumsJs.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, _enumsJs.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

},{"./getBasePlacement.js":"7BYT3","./getVariation.js":"2Us86","./getMainAxisFromPlacement.js":"buXVK","../enums.js":"9CWfx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hsHYl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeAutoPlacement);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("./detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
function computeAutoPlacement(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, _enumsJs.placements) : _options$allowedAutoP;
    var variation = (0, _getVariationJsDefault.default)(placement);
    var placements = variation ? flipVariations ? (0, _enumsJs.variationPlacements) : (0, _enumsJs.variationPlacements).filter(function(placement) {
        return (0, _getVariationJsDefault.default)(placement) === variation;
    }) : (0, _enumsJs.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, _getBasePlacementJsDefault.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

},{"./getVariation.js":"2Us86","../enums.js":"9CWfx","./detectOverflow.js":"e1TOL","./getBasePlacement.js":"7BYT3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9wu2u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
function getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function isAnySideFullyClipped(overflow) {
    return [
        (0, _enumsJs.top),
        (0, _enumsJs.right),
        (0, _enumsJs.bottom),
        (0, _enumsJs.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, _detectOverflowJsDefault.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, _detectOverflowJsDefault.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: hide
};

},{"../enums.js":"9CWfx","../utils/detectOverflow.js":"e1TOL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3jaKS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distanceAndSkiddingToXY", ()=>distanceAndSkiddingToXY);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
function distanceAndSkiddingToXY(placement, rects, offset) {
    var basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
    var invertDistance = [
        (0, _enumsJs.left),
        (0, _enumsJs.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, _enumsJs.placements).reduce(function(acc, placement) {
        acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: offset
};

},{"../utils/getBasePlacement.js":"7BYT3","../enums.js":"9CWfx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2U77E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _computeOffsetsJs = require("../utils/computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
function popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, _computeOffsetsJsDefault.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: popperOffsets,
    data: {}
};

},{"../utils/computeOffsets.js":"5fJUw","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2yxg5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _getAltAxisJs = require("../utils/getAltAxis.js");
var _getAltAxisJsDefault = parcelHelpers.interopDefault(_getAltAxisJs);
var _withinJs = require("../utils/within.js");
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getFreshSideObjectJs = require("../utils/getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
var _mathJs = require("../utils/math.js");
function preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, _detectOverflowJsDefault.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var variation = (0, _getVariationJsDefault.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var altAxis = (0, _getAltAxisJsDefault.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var altSide = mainAxis === 'y' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, _enumsJs.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, _enumsJs.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, _getLayoutRectJsDefault.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, _getFreshSideObjectJsDefault.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, _withinJs.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, _getOffsetParentJsDefault.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, _withinJs.within)(tether ? (0, _mathJs.min)(min, tetherMin) : min, offset, tether ? (0, _mathJs.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var _altSide = mainAxis === 'x' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, _enumsJs.top),
            (0, _enumsJs.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, _withinJs.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, _withinJs.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

},{"../enums.js":"9CWfx","../utils/getBasePlacement.js":"7BYT3","../utils/getMainAxisFromPlacement.js":"buXVK","../utils/getAltAxis.js":"jelFJ","../utils/within.js":"kgqKD","../dom-utils/getLayoutRect.js":"b8HWl","../dom-utils/getOffsetParent.js":"8UGZD","../utils/detectOverflow.js":"e1TOL","../utils/getVariation.js":"2Us86","../utils/getFreshSideObject.js":"kAN9N","../utils/math.js":"1EWdm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jelFJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getAltAxis);
function getAltAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lyyyk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", ()=>popperGenerator);
parcelHelpers.export(exports, "createPopper", ()=>createPopper);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _detectOverflowJsDefault.default));
var _getCompositeRectJs = require("./dom-utils/getCompositeRect.js");
var _getCompositeRectJsDefault = parcelHelpers.interopDefault(_getCompositeRectJs);
var _getLayoutRectJs = require("./dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _listScrollParentsJs = require("./dom-utils/listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _orderModifiersJs = require("./utils/orderModifiers.js");
var _orderModifiersJsDefault = parcelHelpers.interopDefault(_orderModifiersJs);
var _debounceJs = require("./utils/debounce.js");
var _debounceJsDefault = parcelHelpers.interopDefault(_debounceJs);
var _mergeByNameJs = require("./utils/mergeByName.js");
var _mergeByNameJsDefault = parcelHelpers.interopDefault(_mergeByNameJs);
var _detectOverflowJs = require("./utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _instanceOfJs = require("./dom-utils/instanceOf.js");
var DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, _instanceOfJs.isElement)(reference) ? (0, _listScrollParentsJsDefault.default)(reference) : reference.contextElement ? (0, _listScrollParentsJsDefault.default)(reference.contextElement) : [],
                    popper: (0, _listScrollParentsJsDefault.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, _orderModifiersJsDefault.default)((0, _mergeByNameJsDefault.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, _getCompositeRectJsDefault.default)(reference, (0, _getOffsetParentJsDefault.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, _getLayoutRectJsDefault.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, _debounceJsDefault.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var createPopper = /*#__PURE__*/ popperGenerator(); // eslint-disable-next-line import/no-unused-modules

},{"./dom-utils/getCompositeRect.js":"eA0dC","./dom-utils/getLayoutRect.js":"b8HWl","./dom-utils/listScrollParents.js":"6EVlq","./dom-utils/getOffsetParent.js":"8UGZD","./utils/orderModifiers.js":"3cWku","./utils/debounce.js":"1Z8l1","./utils/mergeByName.js":"4SGnj","./utils/detectOverflow.js":false,"./dom-utils/instanceOf.js":"4TIRi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eA0dC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getCompositeRect);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getNodeScrollJs = require("./getNodeScroll.js");
var _getNodeScrollJsDefault = parcelHelpers.interopDefault(_getNodeScrollJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _mathJs = require("../utils/math.js");
function isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, _mathJs.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, _mathJs.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, _instanceOfJs.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, _instanceOfJs.isHTMLElement)(offsetParent) && isElementScaled(offsetParent);
    var documentElement = (0, _getDocumentElementJsDefault.default)(offsetParent);
    var rect = (0, _getBoundingClientRectJsDefault.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _getNodeNameJsDefault.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, _isScrollParentJsDefault.default)(documentElement)) scroll = (0, _getNodeScrollJsDefault.default)(offsetParent);
        if ((0, _instanceOfJs.isHTMLElement)(offsetParent)) {
            offsets = (0, _getBoundingClientRectJsDefault.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, _getWindowScrollBarXJsDefault.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

},{"./getBoundingClientRect.js":"9Cf34","./getNodeScroll.js":"eRLN3","./getNodeName.js":"7oCwI","./instanceOf.js":"4TIRi","./getWindowScrollBarX.js":"h4IJk","./getDocumentElement.js":"6ADI2","./isScrollParent.js":"fupCg","../utils/math.js":"1EWdm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eRLN3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNodeScroll);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _instanceOfJs = require("./instanceOf.js");
var _getHTMLElementScrollJs = require("./getHTMLElementScroll.js");
var _getHTMLElementScrollJsDefault = parcelHelpers.interopDefault(_getHTMLElementScrollJs);
function getNodeScroll(node) {
    if (node === (0, _getWindowJsDefault.default)(node) || !(0, _instanceOfJs.isHTMLElement)(node)) return (0, _getWindowScrollJsDefault.default)(node);
    else return (0, _getHTMLElementScrollJsDefault.default)(node);
}

},{"./getWindowScroll.js":"7wuKP","./getWindow.js":"8w2sO","./instanceOf.js":"4TIRi","./getHTMLElementScroll.js":"4j4AY","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4j4AY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getHTMLElementScroll);
function getHTMLElementScroll(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3cWku":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>orderModifiers);
var _enumsJs = require("../enums.js"); // source: https://stackoverflow.com/questions/49875255
function order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function orderModifiers(modifiers) {
    // order based on dependencies
    var orderedModifiers = order(modifiers); // order based on phase
    return (0, _enumsJs.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

},{"../enums.js":"9CWfx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1Z8l1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>debounce);
function debounce(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4SGnj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeByName);
function mergeByName(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"uqij7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRefTarget", ()=>getRefTarget);
var _contains = require("dom-helpers/contains");
var _containsDefault = parcelHelpers.interopDefault(_contains);
var _listen = require("dom-helpers/listen");
var _listenDefault = parcelHelpers.interopDefault(_listen);
var _ownerDocument = require("dom-helpers/ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
var _react = require("react");
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
const noop = ()=>{};
function isLeftClickEvent(event) {
    return event.button === 0;
}
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
const getRefTarget = (ref)=>ref && ('current' in ref ? ref.current : ref);
const InitialTriggerEvents = {
    click: 'mousedown',
    mouseup: 'mousedown',
    pointerup: 'pointerdown'
};
/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function useClickOutside(ref, onClickOutside = noop, { disabled, clickTrigger = 'click' } = {}) {
    const preventMouseClickOutsideRef = (0, _react.useRef)(false);
    const waitingForTrigger = (0, _react.useRef)(false);
    const handleMouseCapture = (0, _react.useCallback)((e)=>{
        const currentTarget = getRefTarget(ref);
        (0, _warningDefault.default)(!!currentTarget, "ClickOutside captured a close event but does not have a ref to compare it to. useClickOutside(), should be passed a ref that resolves to a DOM node");
        preventMouseClickOutsideRef.current = !currentTarget || isModifiedEvent(e) || !isLeftClickEvent(e) || !!(0, _containsDefault.default)(currentTarget, e.target) || waitingForTrigger.current;
        waitingForTrigger.current = false;
    }, [
        ref
    ]);
    const handleInitialMouse = (0, _useEventCallbackDefault.default)((e)=>{
        const currentTarget = getRefTarget(ref);
        if (currentTarget && (0, _containsDefault.default)(currentTarget, e.target)) waitingForTrigger.current = true;
        else // When clicking on scrollbars within current target, click events are not triggered, so this ref
        // is never reset inside `handleMouseCapture`. This would cause a bug where it requires 2 clicks
        // to close the overlay.
        waitingForTrigger.current = false;
    });
    const handleMouse = (0, _useEventCallbackDefault.default)((e)=>{
        if (!preventMouseClickOutsideRef.current) onClickOutside(e);
    });
    (0, _react.useEffect)(()=>{
        var _ownerWindow$event, _ownerWindow$parent;
        if (disabled || ref == null) return undefined;
        const doc = (0, _ownerDocumentDefault.default)(getRefTarget(ref));
        const ownerWindow = doc.defaultView || window;
        // Store the current event to avoid triggering handlers immediately
        // For things rendered in an iframe, the event might originate on the parent window
        // so we should fall back to that global event if the local one doesn't exist
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
        let removeInitialTriggerListener = null;
        if (InitialTriggerEvents[clickTrigger]) removeInitialTriggerListener = (0, _listenDefault.default)(doc, InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
        // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        const removeMouseCaptureListener = (0, _listenDefault.default)(doc, clickTrigger, handleMouseCapture, true);
        const removeMouseListener = (0, _listenDefault.default)(doc, clickTrigger, (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        let mobileSafariHackListeners = [];
        if ('ontouchstart' in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map((el)=>(0, _listenDefault.default)(el, 'mousemove', noop));
        return ()=>{
            removeInitialTriggerListener == null || removeInitialTriggerListener();
            removeMouseCaptureListener();
            removeMouseListener();
            mobileSafariHackListeners.forEach((remove)=>remove());
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleInitialMouse,
        handleMouse
    ]);
}
exports.default = useClickOutside;

},{"dom-helpers/contains":"kQPO5","dom-helpers/listen":"diWFU","dom-helpers/ownerDocument":"4O8MX","react":"bmhQu","@restart/hooks/useEventCallback":"j7CsD","warning":"aLZMg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aLZMg":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var __DEV__ = false;
var warning = function() {};
if (__DEV__) {
    var printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = warning;

},{}],"118Fa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toModifierMap", ()=>toModifierMap);
parcelHelpers.export(exports, "toModifierArray", ()=>toModifierArray);
parcelHelpers.export(exports, "default", ()=>mergeOptionsWithPopperConfig);
function toModifierMap(modifiers) {
    const result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
    // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach((m)=>{
        result[m.name] = m;
    });
    return result;
}
function toModifierArray(map = {}) {
    if (Array.isArray(map)) return map;
    return Object.keys(map).map((k)=>{
        map[k].name = k;
        return map[k];
    });
}
function mergeOptionsWithPopperConfig({ enabled, enableEvents, placement, flip, offset, fixed, containerPadding, arrowElement, popperConfig = {} }) {
    var _modifiers$eventListe, _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    const modifiers = toModifierMap(popperConfig.modifiers);
    return Object.assign({}, popperConfig, {
        placement,
        enabled,
        strategy: fixed ? 'fixed' : popperConfig.strategy,
        modifiers: toModifierArray(Object.assign({}, modifiers, {
            eventListeners: {
                enabled: enableEvents,
                options: (_modifiers$eventListe = modifiers.eventListeners) == null ? void 0 : _modifiers$eventListe.options
            },
            preventOverflow: Object.assign({}, modifiers.preventOverflow, {
                options: containerPadding ? Object.assign({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: Object.assign({
                    offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: Object.assign({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: Object.assign({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: Object.assign({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fvcaa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isRoleMenu", ()=>isRoleMenu);
/**
 * Wires up Dropdown toggle functionality, returning a set a props to attach
 * to the element that functions as the dropdown toggle (generally a button).
 *
 * @memberOf Dropdown
 */ parcelHelpers.export(exports, "useDropdownToggle", ()=>useDropdownToggle);
var _react = require("react");
var _ssr = require("./ssr");
var _dropdownContext = require("./DropdownContext");
var _dropdownContextDefault = parcelHelpers.interopDefault(_dropdownContext);
var _jsxRuntime = require("react/jsx-runtime");
const isRoleMenu = (el)=>{
    var _el$getAttribute;
    return ((_el$getAttribute = el.getAttribute('role')) == null ? void 0 : _el$getAttribute.toLowerCase()) === 'menu';
};
const noop = ()=>{};
function useDropdownToggle() {
    const id = (0, _ssr.useSSRSafeId)();
    const { show = false, toggle = noop, setToggle, menuElement } = (0, _react.useContext)((0, _dropdownContextDefault.default)) || {};
    const handleClick = (0, _react.useCallback)((e)=>{
        toggle(!show, e);
    }, [
        show,
        toggle
    ]);
    const props = {
        id,
        ref: setToggle || noop,
        onClick: handleClick,
        'aria-expanded': !!show
    };
    // This is maybe better down in an effect, but
    // the component is going to update anyway when the menu element
    // is set so might return new props.
    if (menuElement && isRoleMenu(menuElement)) props['aria-haspopup'] = true;
    return [
        props,
        {
            show,
            toggle
        }
    ];
}
/**
 * Also exported as `<Dropdown.Toggle>` from `Dropdown`.
 *
 * @displayName DropdownToggle
 * @memberOf Dropdown
 */ function DropdownToggle({ children }) {
    const [props, meta] = useDropdownToggle();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: children(props, meta)
    });
}
DropdownToggle.displayName = 'DropdownToggle';
/** @component */ exports.default = DropdownToggle;

},{"react":"bmhQu","./ssr":"j7dFp","./DropdownContext":"03nhu","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j7dFp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SSRProvider", ()=>$85138adc03e1f057$export$9f8ac96af4b1b2ae);
parcelHelpers.export(exports, "useIsSSR", ()=>$85138adc03e1f057$export$535bd6ca7f90a273);
parcelHelpers.export(exports, "useSSRSafeId", ()=>$85138adc03e1f057$export$619500959fc48b26);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rsp-rules/use-layout-effect-rule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $85138adc03e1f057$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $85138adc03e1f057$var$SSRContext = (0, _reactDefault.default).createContext($85138adc03e1f057$var$defaultContext);
const $85138adc03e1f057$var$IsSSRContext = (0, _reactDefault.default).createContext(false);
// This is only used in React < 18.
function $85138adc03e1f057$var$LegacySSRProvider(props) {
    let cur = (0, _react.useContext)($85138adc03e1f057$var$SSRContext);
    let counter = $85138adc03e1f057$var$useCounter(cur === $85138adc03e1f057$var$defaultContext);
    let [isSSR, setIsSSR] = (0, _react.useState)(true);
    let value = (0, _react.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $85138adc03e1f057$var$defaultContext ? '' : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') (0, _react.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, _reactDefault.default).createElement($85138adc03e1f057$var$SSRContext.Provider, {
        value: value
    }, (0, _reactDefault.default).createElement($85138adc03e1f057$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $85138adc03e1f057$var$warnedAboutSSRProvider = false;
function $85138adc03e1f057$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, _reactDefault.default)['useId'] === 'function') return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, props.children);
    return (0, _reactDefault.default).createElement($85138adc03e1f057$var$LegacySSRProvider, props);
}
let $85138adc03e1f057$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $85138adc03e1f057$var$componentIds = new WeakMap();
function $85138adc03e1f057$var$useCounter(isDisabled = false) {
    let ctx = (0, _react.useContext)($85138adc03e1f057$var$SSRContext);
    let ref = (0, _react.useRef)(null);
    // eslint-disable-next-line rsp-rules/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, _reactDefault.default).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $85138adc03e1f057$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $85138adc03e1f057$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $85138adc03e1f057$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rsp-rules/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rsp-rules/pure-render
    return ref.current;
}
function $85138adc03e1f057$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, _react.useContext)($85138adc03e1f057$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    ctx === $85138adc03e1f057$var$defaultContext && $85138adc03e1f057$var$canUseDOM;
    let counter = $85138adc03e1f057$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $85138adc03e1f057$var$useModernSSRSafeId(defaultId) {
    let id = (0, _reactDefault.default).useId();
    let [didSSR] = (0, _react.useState)($85138adc03e1f057$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? 'react-aria' : `react-aria${$85138adc03e1f057$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $85138adc03e1f057$export$619500959fc48b26 = typeof (0, _reactDefault.default)['useId'] === 'function' ? $85138adc03e1f057$var$useModernSSRSafeId : $85138adc03e1f057$var$useLegacySSRSafeId;
function $85138adc03e1f057$var$getSnapshot() {
    return false;
}
function $85138adc03e1f057$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $85138adc03e1f057$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $85138adc03e1f057$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, _reactDefault.default)['useSyncExternalStore'] === 'function') return (0, _reactDefault.default)['useSyncExternalStore']($85138adc03e1f057$var$subscribe, $85138adc03e1f057$var$getSnapshot, $85138adc03e1f057$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, _react.useContext)($85138adc03e1f057$var$IsSSRContext);
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4c7b5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create a dropdown item. Returns a set of props for the dropdown item component
 * including an `onClick` handler that prevents selection when the item is disabled
 */ parcelHelpers.export(exports, "useDropdownItem", ()=>useDropdownItem);
var _react = require("react");
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _selectableContext = require("./SelectableContext");
var _selectableContextDefault = parcelHelpers.interopDefault(_selectableContext);
var _navContext = require("./NavContext");
var _navContextDefault = parcelHelpers.interopDefault(_navContext);
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _dataKey = require("./DataKey");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "eventKey",
    "disabled",
    "onClick",
    "active",
    "as"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function useDropdownItem({ key, href, active, disabled, onClick }) {
    const onSelectCtx = (0, _react.useContext)((0, _selectableContextDefault.default));
    const navContext = (0, _react.useContext)((0, _navContextDefault.default));
    const { activeKey } = navContext || {};
    const eventKey = (0, _selectableContext.makeEventKey)(key, href);
    const isActive = active == null && key != null ? (0, _selectableContext.makeEventKey)(activeKey) === eventKey : active;
    const handleClick = (0, _useEventCallbackDefault.default)((event)=>{
        if (disabled) return;
        onClick == null || onClick(event);
        if (onSelectCtx && !event.isPropagationStopped()) onSelectCtx(eventKey, event);
    });
    return [
        {
            onClick: handleClick,
            'aria-disabled': disabled || undefined,
            'aria-selected': isActive,
            [(0, _dataKey.dataAttr)('dropdown-item')]: ''
        },
        {
            isActive
        }
    ];
}
const DropdownItem = /*#__PURE__*/ _react.forwardRef((_ref, ref)=>{
    let { eventKey, disabled, onClick, active, as: Component = (0, _buttonDefault.default) } = _ref, props = _objectWithoutPropertiesLoose(_ref, _excluded);
    const [dropdownItemProps] = useDropdownItem({
        key: eventKey,
        href: props.href,
        disabled,
        onClick,
        active
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, Object.assign({}, props, {
        ref: ref
    }, dropdownItemProps));
});
DropdownItem.displayName = 'DropdownItem';
exports.default = DropdownItem;

},{"react":"bmhQu","@restart/hooks/useEventCallback":"j7CsD","./SelectableContext":"e59aX","./NavContext":"dfejx","./Button":"h42rE","./DataKey":"g9Cvj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kBBfM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
const DropdownContext = /*#__PURE__*/ _react.createContext({});
DropdownContext.displayName = 'DropdownContext';
exports.default = DropdownContext;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iQqDM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DropdownDivider = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'hr', role = 'separator', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'dropdown-divider');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        role: role,
        ...props
    });
});
DropdownDivider.displayName = 'DropdownDivider';
exports.default = DropdownDivider;

},{"react":"bmhQu","classnames":"9HH2M","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3yRHg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DropdownHeader = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', role = 'heading', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'dropdown-header');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        role: role,
        ...props
    });
});
DropdownHeader.displayName = 'DropdownHeader';
exports.default = DropdownHeader;

},{"react":"bmhQu","classnames":"9HH2M","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8SRt4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _dropdownItem = require("@restart/ui/DropdownItem");
var _anchor = require("@restart/ui/Anchor");
var _anchorDefault = parcelHelpers.interopDefault(_anchor);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DropdownItem = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, eventKey, disabled = false, onClick, active, as: Component = (0, _anchorDefault.default), ...props }, ref)=>{
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'dropdown-item');
    const [dropdownItemProps, meta] = (0, _dropdownItem.useDropdownItem)({
        key: eventKey,
        href: props.href,
        disabled,
        onClick,
        active
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        ...dropdownItemProps,
        ref: ref,
        className: (0, _classnamesDefault.default)(className, prefix, meta.isActive && 'active', disabled && 'disabled')
    });
});
DropdownItem.displayName = 'DropdownItem';
exports.default = DropdownItem;

},{"classnames":"9HH2M","react":"bmhQu","@restart/ui/DropdownItem":"4c7b5","@restart/ui/Anchor":"iVIEK","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lnX7Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DropdownItemText = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'dropdown-item-text');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
DropdownItemText.displayName = 'DropdownItemText';
exports.default = DropdownItemText;

},{"react":"bmhQu","classnames":"9HH2M","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6sEFY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDropdownMenuPlacement", ()=>getDropdownMenuPlacement);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _dropdownMenu = require("@restart/ui/DropdownMenu");
var _useIsomorphicEffect = require("@restart/hooks/useIsomorphicEffect");
var _useIsomorphicEffectDefault = parcelHelpers.interopDefault(_useIsomorphicEffect);
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _dropdownContext = require("./DropdownContext");
var _dropdownContextDefault = parcelHelpers.interopDefault(_dropdownContext);
var _inputGroupContext = require("./InputGroupContext");
var _inputGroupContextDefault = parcelHelpers.interopDefault(_inputGroupContext);
var _navbarContext = require("./NavbarContext");
var _navbarContextDefault = parcelHelpers.interopDefault(_navbarContext);
var _themeProvider = require("./ThemeProvider");
var _useWrappedRefWithWarning = require("./useWrappedRefWithWarning");
var _useWrappedRefWithWarningDefault = parcelHelpers.interopDefault(_useWrappedRefWithWarning);
var _types = require("./types");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function getDropdownMenuPlacement(alignEnd, dropDirection, isRTL) {
    const topStart = isRTL ? 'top-end' : 'top-start';
    const topEnd = isRTL ? 'top-start' : 'top-end';
    const bottomStart = isRTL ? 'bottom-end' : 'bottom-start';
    const bottomEnd = isRTL ? 'bottom-start' : 'bottom-end';
    const leftStart = isRTL ? 'right-start' : 'left-start';
    const leftEnd = isRTL ? 'right-end' : 'left-end';
    const rightStart = isRTL ? 'left-start' : 'right-start';
    const rightEnd = isRTL ? 'left-end' : 'right-end';
    let placement = alignEnd ? bottomEnd : bottomStart;
    if (dropDirection === 'up') placement = alignEnd ? topEnd : topStart;
    else if (dropDirection === 'end') placement = alignEnd ? rightEnd : rightStart;
    else if (dropDirection === 'start') placement = alignEnd ? leftEnd : leftStart;
    else if (dropDirection === 'down-centered') placement = 'bottom';
    else if (dropDirection === 'up-centered') placement = 'top';
    return placement;
}
const DropdownMenu = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, align, rootCloseEvent, flip = true, show: showProps, renderOnMount, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', popperConfig, variant, ...props }, ref)=>{
    let alignEnd = false;
    const isNavbar = (0, _react.useContext)((0, _navbarContextDefault.default));
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'dropdown-menu');
    const { align: contextAlign, drop, isRTL } = (0, _react.useContext)((0, _dropdownContextDefault.default));
    align = align || contextAlign;
    const isInputGroup = (0, _react.useContext)((0, _inputGroupContextDefault.default));
    const alignClasses = [];
    if (align) {
        if (typeof align === 'object') {
            const keys = Object.keys(align);
            if (keys.length) {
                const brkPoint = keys[0];
                const direction = align[brkPoint];
                // .dropdown-menu-end is required for responsively aligning
                // left in addition to align left classes.
                alignEnd = direction === 'start';
                alignClasses.push(`${prefix}-${brkPoint}-${direction}`);
            }
        } else if (align === 'end') alignEnd = true;
    }
    const placement = getDropdownMenuPlacement(alignEnd, drop, isRTL);
    const [menuProps, { hasShown, popper, show, toggle }] = (0, _dropdownMenu.useDropdownMenu)({
        flip,
        rootCloseEvent,
        show: showProps,
        usePopper: !isNavbar && alignClasses.length === 0,
        offset: [
            0,
            2
        ],
        popperConfig,
        placement
    });
    menuProps.ref = (0, _useMergedRefsDefault.default)((0, _useWrappedRefWithWarningDefault.default)(ref, 'DropdownMenu'), menuProps.ref);
    (0, _useIsomorphicEffectDefault.default)(()=>{
        // Popper's initial position for the menu is incorrect when
        // renderOnMount=true. Need to call update() to correct it.
        if (show) popper == null || popper.update();
    }, [
        show
    ]);
    if (!hasShown && !renderOnMount && !isInputGroup) return null;
    // For custom components provide additional, non-DOM, props;
    if (typeof Component !== 'string') {
        menuProps.show = show;
        menuProps.close = ()=>toggle == null ? void 0 : toggle(false);
        menuProps.align = align;
    }
    let style = props.style;
    if (popper != null && popper.placement) {
        // we don't need the default popper style,
        // menus are display: none when not shown.
        style = {
            ...props.style,
            ...menuProps.style
        };
        props['x-placement'] = popper.placement;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        ...menuProps,
        style: style,
        ...(alignClasses.length || isNavbar) && {
            'data-bs-popper': 'static'
        },
        className: (0, _classnamesDefault.default)(className, prefix, show && 'show', alignEnd && `${prefix}-end`, variant && `${prefix}-${variant}`, ...alignClasses)
    });
});
DropdownMenu.displayName = 'DropdownMenu';
exports.default = DropdownMenu;

},{"classnames":"9HH2M","react":"bmhQu","@restart/ui/DropdownMenu":"7jYkf","@restart/hooks/useIsomorphicEffect":"gqtk8","@restart/hooks/useMergedRefs":"ai8mn","warning":"fSSz5","./DropdownContext":"kBBfM","./InputGroupContext":"kopE8","./NavbarContext":"e2mN2","./ThemeProvider":"aQ1Mj","./useWrappedRefWithWarning":"jDYt2","./types":"bbBUb","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fSSz5":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var __DEV__ = false;
var warning = function() {};
if (__DEV__) {
    var printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = warning;

},{}],"jDYt2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useWrappedRefWithWarning);
var _invariant = require("invariant");
var _invariantDefault = parcelHelpers.interopDefault(_invariant);
var _react = require("react");
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
function useWrappedRefWithWarning(ref, componentName) {
    return ref;
}

},{"invariant":"3cETI","react":"bmhQu","@restart/hooks/useMergedRefs":"ai8mn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bbBUb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alignPropType", ()=>alignPropType);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
const alignDirection = (0, _propTypesDefault.default).oneOf([
    'start',
    'end'
]);
const alignPropType = (0, _propTypesDefault.default).oneOfType([
    alignDirection,
    (0, _propTypesDefault.default).shape({
        sm: alignDirection
    }),
    (0, _propTypesDefault.default).shape({
        md: alignDirection
    }),
    (0, _propTypesDefault.default).shape({
        lg: alignDirection
    }),
    (0, _propTypesDefault.default).shape({
        xl: alignDirection
    }),
    (0, _propTypesDefault.default).shape({
        xxl: alignDirection
    }),
    (0, _propTypesDefault.default).object
]);

},{"prop-types":"gLXGb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9yXfJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
var _dropdownContext = require("@restart/ui/DropdownContext");
var _dropdownContextDefault = parcelHelpers.interopDefault(_dropdownContext);
var _dropdownToggle = require("@restart/ui/DropdownToggle");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _themeProvider = require("./ThemeProvider");
var _useWrappedRefWithWarning = require("./useWrappedRefWithWarning");
var _useWrappedRefWithWarningDefault = parcelHelpers.interopDefault(_useWrappedRefWithWarning);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DropdownToggle = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, split, className, childBsPrefix, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = (0, _buttonDefault.default), ...props }, ref)=>{
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'dropdown-toggle');
    const dropdownContext = (0, _react.useContext)((0, _dropdownContextDefault.default));
    if (childBsPrefix !== undefined) props.bsPrefix = childBsPrefix;
    const [toggleProps] = (0, _dropdownToggle.useDropdownToggle)();
    toggleProps.ref = (0, _useMergedRefsDefault.default)(toggleProps.ref, (0, _useWrappedRefWithWarningDefault.default)(ref, 'DropdownToggle'));
    // This intentionally forwards size and variant (if set) to the
    // underlying component, to allow it to render size and style variants.
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        className: (0, _classnamesDefault.default)(className, prefix, split && `${prefix}-split`, (dropdownContext == null ? void 0 : dropdownContext.show) && 'show'),
        ...toggleProps,
        ...props
    });
});
DropdownToggle.displayName = 'DropdownToggle';
exports.default = DropdownToggle;

},{"@restart/hooks/useMergedRefs":"ai8mn","@restart/ui/DropdownContext":"03nhu","@restart/ui/DropdownToggle":"fvcaa","classnames":"9HH2M","react":"bmhQu","./Button":"6Xv8z","./ThemeProvider":"aQ1Mj","./useWrappedRefWithWarning":"jDYt2","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1HOcO":[function(require,module,exports,__globalThis) {
// THIS FILE IS AUTO GENERATED
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FiActivity", ()=>FiActivity);
parcelHelpers.export(exports, "FiAirplay", ()=>FiAirplay);
parcelHelpers.export(exports, "FiAlertCircle", ()=>FiAlertCircle);
parcelHelpers.export(exports, "FiAlertOctagon", ()=>FiAlertOctagon);
parcelHelpers.export(exports, "FiAlertTriangle", ()=>FiAlertTriangle);
parcelHelpers.export(exports, "FiAlignCenter", ()=>FiAlignCenter);
parcelHelpers.export(exports, "FiAlignJustify", ()=>FiAlignJustify);
parcelHelpers.export(exports, "FiAlignLeft", ()=>FiAlignLeft);
parcelHelpers.export(exports, "FiAlignRight", ()=>FiAlignRight);
parcelHelpers.export(exports, "FiAnchor", ()=>FiAnchor);
parcelHelpers.export(exports, "FiAperture", ()=>FiAperture);
parcelHelpers.export(exports, "FiArchive", ()=>FiArchive);
parcelHelpers.export(exports, "FiArrowDownCircle", ()=>FiArrowDownCircle);
parcelHelpers.export(exports, "FiArrowDownLeft", ()=>FiArrowDownLeft);
parcelHelpers.export(exports, "FiArrowDownRight", ()=>FiArrowDownRight);
parcelHelpers.export(exports, "FiArrowDown", ()=>FiArrowDown);
parcelHelpers.export(exports, "FiArrowLeftCircle", ()=>FiArrowLeftCircle);
parcelHelpers.export(exports, "FiArrowLeft", ()=>FiArrowLeft);
parcelHelpers.export(exports, "FiArrowRightCircle", ()=>FiArrowRightCircle);
parcelHelpers.export(exports, "FiArrowRight", ()=>FiArrowRight);
parcelHelpers.export(exports, "FiArrowUpCircle", ()=>FiArrowUpCircle);
parcelHelpers.export(exports, "FiArrowUpLeft", ()=>FiArrowUpLeft);
parcelHelpers.export(exports, "FiArrowUpRight", ()=>FiArrowUpRight);
parcelHelpers.export(exports, "FiArrowUp", ()=>FiArrowUp);
parcelHelpers.export(exports, "FiAtSign", ()=>FiAtSign);
parcelHelpers.export(exports, "FiAward", ()=>FiAward);
parcelHelpers.export(exports, "FiBarChart2", ()=>FiBarChart2);
parcelHelpers.export(exports, "FiBarChart", ()=>FiBarChart);
parcelHelpers.export(exports, "FiBatteryCharging", ()=>FiBatteryCharging);
parcelHelpers.export(exports, "FiBattery", ()=>FiBattery);
parcelHelpers.export(exports, "FiBellOff", ()=>FiBellOff);
parcelHelpers.export(exports, "FiBell", ()=>FiBell);
parcelHelpers.export(exports, "FiBluetooth", ()=>FiBluetooth);
parcelHelpers.export(exports, "FiBold", ()=>FiBold);
parcelHelpers.export(exports, "FiBookOpen", ()=>FiBookOpen);
parcelHelpers.export(exports, "FiBook", ()=>FiBook);
parcelHelpers.export(exports, "FiBookmark", ()=>FiBookmark);
parcelHelpers.export(exports, "FiBox", ()=>FiBox);
parcelHelpers.export(exports, "FiBriefcase", ()=>FiBriefcase);
parcelHelpers.export(exports, "FiCalendar", ()=>FiCalendar);
parcelHelpers.export(exports, "FiCameraOff", ()=>FiCameraOff);
parcelHelpers.export(exports, "FiCamera", ()=>FiCamera);
parcelHelpers.export(exports, "FiCast", ()=>FiCast);
parcelHelpers.export(exports, "FiCheckCircle", ()=>FiCheckCircle);
parcelHelpers.export(exports, "FiCheckSquare", ()=>FiCheckSquare);
parcelHelpers.export(exports, "FiCheck", ()=>FiCheck);
parcelHelpers.export(exports, "FiChevronDown", ()=>FiChevronDown);
parcelHelpers.export(exports, "FiChevronLeft", ()=>FiChevronLeft);
parcelHelpers.export(exports, "FiChevronRight", ()=>FiChevronRight);
parcelHelpers.export(exports, "FiChevronUp", ()=>FiChevronUp);
parcelHelpers.export(exports, "FiChevronsDown", ()=>FiChevronsDown);
parcelHelpers.export(exports, "FiChevronsLeft", ()=>FiChevronsLeft);
parcelHelpers.export(exports, "FiChevronsRight", ()=>FiChevronsRight);
parcelHelpers.export(exports, "FiChevronsUp", ()=>FiChevronsUp);
parcelHelpers.export(exports, "FiChrome", ()=>FiChrome);
parcelHelpers.export(exports, "FiCircle", ()=>FiCircle);
parcelHelpers.export(exports, "FiClipboard", ()=>FiClipboard);
parcelHelpers.export(exports, "FiClock", ()=>FiClock);
parcelHelpers.export(exports, "FiCloudDrizzle", ()=>FiCloudDrizzle);
parcelHelpers.export(exports, "FiCloudLightning", ()=>FiCloudLightning);
parcelHelpers.export(exports, "FiCloudOff", ()=>FiCloudOff);
parcelHelpers.export(exports, "FiCloudRain", ()=>FiCloudRain);
parcelHelpers.export(exports, "FiCloudSnow", ()=>FiCloudSnow);
parcelHelpers.export(exports, "FiCloud", ()=>FiCloud);
parcelHelpers.export(exports, "FiCode", ()=>FiCode);
parcelHelpers.export(exports, "FiCodepen", ()=>FiCodepen);
parcelHelpers.export(exports, "FiCodesandbox", ()=>FiCodesandbox);
parcelHelpers.export(exports, "FiCoffee", ()=>FiCoffee);
parcelHelpers.export(exports, "FiColumns", ()=>FiColumns);
parcelHelpers.export(exports, "FiCommand", ()=>FiCommand);
parcelHelpers.export(exports, "FiCompass", ()=>FiCompass);
parcelHelpers.export(exports, "FiCopy", ()=>FiCopy);
parcelHelpers.export(exports, "FiCornerDownLeft", ()=>FiCornerDownLeft);
parcelHelpers.export(exports, "FiCornerDownRight", ()=>FiCornerDownRight);
parcelHelpers.export(exports, "FiCornerLeftDown", ()=>FiCornerLeftDown);
parcelHelpers.export(exports, "FiCornerLeftUp", ()=>FiCornerLeftUp);
parcelHelpers.export(exports, "FiCornerRightDown", ()=>FiCornerRightDown);
parcelHelpers.export(exports, "FiCornerRightUp", ()=>FiCornerRightUp);
parcelHelpers.export(exports, "FiCornerUpLeft", ()=>FiCornerUpLeft);
parcelHelpers.export(exports, "FiCornerUpRight", ()=>FiCornerUpRight);
parcelHelpers.export(exports, "FiCpu", ()=>FiCpu);
parcelHelpers.export(exports, "FiCreditCard", ()=>FiCreditCard);
parcelHelpers.export(exports, "FiCrop", ()=>FiCrop);
parcelHelpers.export(exports, "FiCrosshair", ()=>FiCrosshair);
parcelHelpers.export(exports, "FiDatabase", ()=>FiDatabase);
parcelHelpers.export(exports, "FiDelete", ()=>FiDelete);
parcelHelpers.export(exports, "FiDisc", ()=>FiDisc);
parcelHelpers.export(exports, "FiDivideCircle", ()=>FiDivideCircle);
parcelHelpers.export(exports, "FiDivideSquare", ()=>FiDivideSquare);
parcelHelpers.export(exports, "FiDivide", ()=>FiDivide);
parcelHelpers.export(exports, "FiDollarSign", ()=>FiDollarSign);
parcelHelpers.export(exports, "FiDownloadCloud", ()=>FiDownloadCloud);
parcelHelpers.export(exports, "FiDownload", ()=>FiDownload);
parcelHelpers.export(exports, "FiDribbble", ()=>FiDribbble);
parcelHelpers.export(exports, "FiDroplet", ()=>FiDroplet);
parcelHelpers.export(exports, "FiEdit2", ()=>FiEdit2);
parcelHelpers.export(exports, "FiEdit3", ()=>FiEdit3);
parcelHelpers.export(exports, "FiEdit", ()=>FiEdit);
parcelHelpers.export(exports, "FiExternalLink", ()=>FiExternalLink);
parcelHelpers.export(exports, "FiEyeOff", ()=>FiEyeOff);
parcelHelpers.export(exports, "FiEye", ()=>FiEye);
parcelHelpers.export(exports, "FiFacebook", ()=>FiFacebook);
parcelHelpers.export(exports, "FiFastForward", ()=>FiFastForward);
parcelHelpers.export(exports, "FiFeather", ()=>FiFeather);
parcelHelpers.export(exports, "FiFigma", ()=>FiFigma);
parcelHelpers.export(exports, "FiFileMinus", ()=>FiFileMinus);
parcelHelpers.export(exports, "FiFilePlus", ()=>FiFilePlus);
parcelHelpers.export(exports, "FiFileText", ()=>FiFileText);
parcelHelpers.export(exports, "FiFile", ()=>FiFile);
parcelHelpers.export(exports, "FiFilm", ()=>FiFilm);
parcelHelpers.export(exports, "FiFilter", ()=>FiFilter);
parcelHelpers.export(exports, "FiFlag", ()=>FiFlag);
parcelHelpers.export(exports, "FiFolderMinus", ()=>FiFolderMinus);
parcelHelpers.export(exports, "FiFolderPlus", ()=>FiFolderPlus);
parcelHelpers.export(exports, "FiFolder", ()=>FiFolder);
parcelHelpers.export(exports, "FiFramer", ()=>FiFramer);
parcelHelpers.export(exports, "FiFrown", ()=>FiFrown);
parcelHelpers.export(exports, "FiGift", ()=>FiGift);
parcelHelpers.export(exports, "FiGitBranch", ()=>FiGitBranch);
parcelHelpers.export(exports, "FiGitCommit", ()=>FiGitCommit);
parcelHelpers.export(exports, "FiGitMerge", ()=>FiGitMerge);
parcelHelpers.export(exports, "FiGitPullRequest", ()=>FiGitPullRequest);
parcelHelpers.export(exports, "FiGithub", ()=>FiGithub);
parcelHelpers.export(exports, "FiGitlab", ()=>FiGitlab);
parcelHelpers.export(exports, "FiGlobe", ()=>FiGlobe);
parcelHelpers.export(exports, "FiGrid", ()=>FiGrid);
parcelHelpers.export(exports, "FiHardDrive", ()=>FiHardDrive);
parcelHelpers.export(exports, "FiHash", ()=>FiHash);
parcelHelpers.export(exports, "FiHeadphones", ()=>FiHeadphones);
parcelHelpers.export(exports, "FiHeart", ()=>FiHeart);
parcelHelpers.export(exports, "FiHelpCircle", ()=>FiHelpCircle);
parcelHelpers.export(exports, "FiHexagon", ()=>FiHexagon);
parcelHelpers.export(exports, "FiHome", ()=>FiHome);
parcelHelpers.export(exports, "FiImage", ()=>FiImage);
parcelHelpers.export(exports, "FiInbox", ()=>FiInbox);
parcelHelpers.export(exports, "FiInfo", ()=>FiInfo);
parcelHelpers.export(exports, "FiInstagram", ()=>FiInstagram);
parcelHelpers.export(exports, "FiItalic", ()=>FiItalic);
parcelHelpers.export(exports, "FiKey", ()=>FiKey);
parcelHelpers.export(exports, "FiLayers", ()=>FiLayers);
parcelHelpers.export(exports, "FiLayout", ()=>FiLayout);
parcelHelpers.export(exports, "FiLifeBuoy", ()=>FiLifeBuoy);
parcelHelpers.export(exports, "FiLink2", ()=>FiLink2);
parcelHelpers.export(exports, "FiLink", ()=>FiLink);
parcelHelpers.export(exports, "FiLinkedin", ()=>FiLinkedin);
parcelHelpers.export(exports, "FiList", ()=>FiList);
parcelHelpers.export(exports, "FiLoader", ()=>FiLoader);
parcelHelpers.export(exports, "FiLock", ()=>FiLock);
parcelHelpers.export(exports, "FiLogIn", ()=>FiLogIn);
parcelHelpers.export(exports, "FiLogOut", ()=>FiLogOut);
parcelHelpers.export(exports, "FiMail", ()=>FiMail);
parcelHelpers.export(exports, "FiMapPin", ()=>FiMapPin);
parcelHelpers.export(exports, "FiMap", ()=>FiMap);
parcelHelpers.export(exports, "FiMaximize2", ()=>FiMaximize2);
parcelHelpers.export(exports, "FiMaximize", ()=>FiMaximize);
parcelHelpers.export(exports, "FiMeh", ()=>FiMeh);
parcelHelpers.export(exports, "FiMenu", ()=>FiMenu);
parcelHelpers.export(exports, "FiMessageCircle", ()=>FiMessageCircle);
parcelHelpers.export(exports, "FiMessageSquare", ()=>FiMessageSquare);
parcelHelpers.export(exports, "FiMicOff", ()=>FiMicOff);
parcelHelpers.export(exports, "FiMic", ()=>FiMic);
parcelHelpers.export(exports, "FiMinimize2", ()=>FiMinimize2);
parcelHelpers.export(exports, "FiMinimize", ()=>FiMinimize);
parcelHelpers.export(exports, "FiMinusCircle", ()=>FiMinusCircle);
parcelHelpers.export(exports, "FiMinusSquare", ()=>FiMinusSquare);
parcelHelpers.export(exports, "FiMinus", ()=>FiMinus);
parcelHelpers.export(exports, "FiMonitor", ()=>FiMonitor);
parcelHelpers.export(exports, "FiMoon", ()=>FiMoon);
parcelHelpers.export(exports, "FiMoreHorizontal", ()=>FiMoreHorizontal);
parcelHelpers.export(exports, "FiMoreVertical", ()=>FiMoreVertical);
parcelHelpers.export(exports, "FiMousePointer", ()=>FiMousePointer);
parcelHelpers.export(exports, "FiMove", ()=>FiMove);
parcelHelpers.export(exports, "FiMusic", ()=>FiMusic);
parcelHelpers.export(exports, "FiNavigation2", ()=>FiNavigation2);
parcelHelpers.export(exports, "FiNavigation", ()=>FiNavigation);
parcelHelpers.export(exports, "FiOctagon", ()=>FiOctagon);
parcelHelpers.export(exports, "FiPackage", ()=>FiPackage);
parcelHelpers.export(exports, "FiPaperclip", ()=>FiPaperclip);
parcelHelpers.export(exports, "FiPauseCircle", ()=>FiPauseCircle);
parcelHelpers.export(exports, "FiPause", ()=>FiPause);
parcelHelpers.export(exports, "FiPenTool", ()=>FiPenTool);
parcelHelpers.export(exports, "FiPercent", ()=>FiPercent);
parcelHelpers.export(exports, "FiPhoneCall", ()=>FiPhoneCall);
parcelHelpers.export(exports, "FiPhoneForwarded", ()=>FiPhoneForwarded);
parcelHelpers.export(exports, "FiPhoneIncoming", ()=>FiPhoneIncoming);
parcelHelpers.export(exports, "FiPhoneMissed", ()=>FiPhoneMissed);
parcelHelpers.export(exports, "FiPhoneOff", ()=>FiPhoneOff);
parcelHelpers.export(exports, "FiPhoneOutgoing", ()=>FiPhoneOutgoing);
parcelHelpers.export(exports, "FiPhone", ()=>FiPhone);
parcelHelpers.export(exports, "FiPieChart", ()=>FiPieChart);
parcelHelpers.export(exports, "FiPlayCircle", ()=>FiPlayCircle);
parcelHelpers.export(exports, "FiPlay", ()=>FiPlay);
parcelHelpers.export(exports, "FiPlusCircle", ()=>FiPlusCircle);
parcelHelpers.export(exports, "FiPlusSquare", ()=>FiPlusSquare);
parcelHelpers.export(exports, "FiPlus", ()=>FiPlus);
parcelHelpers.export(exports, "FiPocket", ()=>FiPocket);
parcelHelpers.export(exports, "FiPower", ()=>FiPower);
parcelHelpers.export(exports, "FiPrinter", ()=>FiPrinter);
parcelHelpers.export(exports, "FiRadio", ()=>FiRadio);
parcelHelpers.export(exports, "FiRefreshCcw", ()=>FiRefreshCcw);
parcelHelpers.export(exports, "FiRefreshCw", ()=>FiRefreshCw);
parcelHelpers.export(exports, "FiRepeat", ()=>FiRepeat);
parcelHelpers.export(exports, "FiRewind", ()=>FiRewind);
parcelHelpers.export(exports, "FiRotateCcw", ()=>FiRotateCcw);
parcelHelpers.export(exports, "FiRotateCw", ()=>FiRotateCw);
parcelHelpers.export(exports, "FiRss", ()=>FiRss);
parcelHelpers.export(exports, "FiSave", ()=>FiSave);
parcelHelpers.export(exports, "FiScissors", ()=>FiScissors);
parcelHelpers.export(exports, "FiSearch", ()=>FiSearch);
parcelHelpers.export(exports, "FiSend", ()=>FiSend);
parcelHelpers.export(exports, "FiServer", ()=>FiServer);
parcelHelpers.export(exports, "FiSettings", ()=>FiSettings);
parcelHelpers.export(exports, "FiShare2", ()=>FiShare2);
parcelHelpers.export(exports, "FiShare", ()=>FiShare);
parcelHelpers.export(exports, "FiShieldOff", ()=>FiShieldOff);
parcelHelpers.export(exports, "FiShield", ()=>FiShield);
parcelHelpers.export(exports, "FiShoppingBag", ()=>FiShoppingBag);
parcelHelpers.export(exports, "FiShoppingCart", ()=>FiShoppingCart);
parcelHelpers.export(exports, "FiShuffle", ()=>FiShuffle);
parcelHelpers.export(exports, "FiSidebar", ()=>FiSidebar);
parcelHelpers.export(exports, "FiSkipBack", ()=>FiSkipBack);
parcelHelpers.export(exports, "FiSkipForward", ()=>FiSkipForward);
parcelHelpers.export(exports, "FiSlack", ()=>FiSlack);
parcelHelpers.export(exports, "FiSlash", ()=>FiSlash);
parcelHelpers.export(exports, "FiSliders", ()=>FiSliders);
parcelHelpers.export(exports, "FiSmartphone", ()=>FiSmartphone);
parcelHelpers.export(exports, "FiSmile", ()=>FiSmile);
parcelHelpers.export(exports, "FiSpeaker", ()=>FiSpeaker);
parcelHelpers.export(exports, "FiSquare", ()=>FiSquare);
parcelHelpers.export(exports, "FiStar", ()=>FiStar);
parcelHelpers.export(exports, "FiStopCircle", ()=>FiStopCircle);
parcelHelpers.export(exports, "FiSun", ()=>FiSun);
parcelHelpers.export(exports, "FiSunrise", ()=>FiSunrise);
parcelHelpers.export(exports, "FiSunset", ()=>FiSunset);
parcelHelpers.export(exports, "FiTable", ()=>FiTable);
parcelHelpers.export(exports, "FiTablet", ()=>FiTablet);
parcelHelpers.export(exports, "FiTag", ()=>FiTag);
parcelHelpers.export(exports, "FiTarget", ()=>FiTarget);
parcelHelpers.export(exports, "FiTerminal", ()=>FiTerminal);
parcelHelpers.export(exports, "FiThermometer", ()=>FiThermometer);
parcelHelpers.export(exports, "FiThumbsDown", ()=>FiThumbsDown);
parcelHelpers.export(exports, "FiThumbsUp", ()=>FiThumbsUp);
parcelHelpers.export(exports, "FiToggleLeft", ()=>FiToggleLeft);
parcelHelpers.export(exports, "FiToggleRight", ()=>FiToggleRight);
parcelHelpers.export(exports, "FiTool", ()=>FiTool);
parcelHelpers.export(exports, "FiTrash2", ()=>FiTrash2);
parcelHelpers.export(exports, "FiTrash", ()=>FiTrash);
parcelHelpers.export(exports, "FiTrello", ()=>FiTrello);
parcelHelpers.export(exports, "FiTrendingDown", ()=>FiTrendingDown);
parcelHelpers.export(exports, "FiTrendingUp", ()=>FiTrendingUp);
parcelHelpers.export(exports, "FiTriangle", ()=>FiTriangle);
parcelHelpers.export(exports, "FiTruck", ()=>FiTruck);
parcelHelpers.export(exports, "FiTv", ()=>FiTv);
parcelHelpers.export(exports, "FiTwitch", ()=>FiTwitch);
parcelHelpers.export(exports, "FiTwitter", ()=>FiTwitter);
parcelHelpers.export(exports, "FiType", ()=>FiType);
parcelHelpers.export(exports, "FiUmbrella", ()=>FiUmbrella);
parcelHelpers.export(exports, "FiUnderline", ()=>FiUnderline);
parcelHelpers.export(exports, "FiUnlock", ()=>FiUnlock);
parcelHelpers.export(exports, "FiUploadCloud", ()=>FiUploadCloud);
parcelHelpers.export(exports, "FiUpload", ()=>FiUpload);
parcelHelpers.export(exports, "FiUserCheck", ()=>FiUserCheck);
parcelHelpers.export(exports, "FiUserMinus", ()=>FiUserMinus);
parcelHelpers.export(exports, "FiUserPlus", ()=>FiUserPlus);
parcelHelpers.export(exports, "FiUserX", ()=>FiUserX);
parcelHelpers.export(exports, "FiUser", ()=>FiUser);
parcelHelpers.export(exports, "FiUsers", ()=>FiUsers);
parcelHelpers.export(exports, "FiVideoOff", ()=>FiVideoOff);
parcelHelpers.export(exports, "FiVideo", ()=>FiVideo);
parcelHelpers.export(exports, "FiVoicemail", ()=>FiVoicemail);
parcelHelpers.export(exports, "FiVolume1", ()=>FiVolume1);
parcelHelpers.export(exports, "FiVolume2", ()=>FiVolume2);
parcelHelpers.export(exports, "FiVolumeX", ()=>FiVolumeX);
parcelHelpers.export(exports, "FiVolume", ()=>FiVolume);
parcelHelpers.export(exports, "FiWatch", ()=>FiWatch);
parcelHelpers.export(exports, "FiWifiOff", ()=>FiWifiOff);
parcelHelpers.export(exports, "FiWifi", ()=>FiWifi);
parcelHelpers.export(exports, "FiWind", ()=>FiWind);
parcelHelpers.export(exports, "FiXCircle", ()=>FiXCircle);
parcelHelpers.export(exports, "FiXOctagon", ()=>FiXOctagon);
parcelHelpers.export(exports, "FiXSquare", ()=>FiXSquare);
parcelHelpers.export(exports, "FiX", ()=>FiX);
parcelHelpers.export(exports, "FiYoutube", ()=>FiYoutube);
parcelHelpers.export(exports, "FiZapOff", ()=>FiZapOff);
parcelHelpers.export(exports, "FiZap", ()=>FiZap);
parcelHelpers.export(exports, "FiZoomIn", ()=>FiZoomIn);
parcelHelpers.export(exports, "FiZoomOut", ()=>FiZoomOut);
var _lib = require("../lib");
function FiActivity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "22 12 18 12 15 21 9 3 6 12 2 12"
                }
            }
        ]
    })(props);
}
function FiAirplay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"
                }
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "12 15 17 21 7 21 12 15"
                }
            }
        ]
    })(props);
}
function FiAlertCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "16",
                    "x2": "12.01",
                    "y2": "16"
                }
            }
        ]
    })(props);
}
function FiAlertOctagon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "16",
                    "x2": "12.01",
                    "y2": "16"
                }
            }
        ]
    })(props);
}
function FiAlertTriangle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "9",
                    "x2": "12",
                    "y2": "13"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "17",
                    "x2": "12.01",
                    "y2": "17"
                }
            }
        ]
    })(props);
}
function FiAlignCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "10",
                    "x2": "6",
                    "y2": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "6",
                    "x2": "3",
                    "y2": "6"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "14",
                    "x2": "3",
                    "y2": "14"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "18",
                    "x2": "6",
                    "y2": "18"
                }
            }
        ]
    })(props);
}
function FiAlignJustify(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "10",
                    "x2": "3",
                    "y2": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "6",
                    "x2": "3",
                    "y2": "6"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "14",
                    "x2": "3",
                    "y2": "14"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "18",
                    "x2": "3",
                    "y2": "18"
                }
            }
        ]
    })(props);
}
function FiAlignLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "10",
                    "x2": "3",
                    "y2": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "6",
                    "x2": "3",
                    "y2": "6"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "14",
                    "x2": "3",
                    "y2": "14"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "18",
                    "x2": "3",
                    "y2": "18"
                }
            }
        ]
    })(props);
}
function FiAlignRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "10",
                    "x2": "7",
                    "y2": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "6",
                    "x2": "3",
                    "y2": "6"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "14",
                    "x2": "3",
                    "y2": "14"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "18",
                    "x2": "7",
                    "y2": "18"
                }
            }
        ]
    })(props);
}
function FiAnchor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "5",
                    "r": "3"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22",
                    "x2": "12",
                    "y2": "8"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12H2a10 10 0 0 0 20 0h-3"
                }
            }
        ]
    })(props);
}
function FiAperture(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14.31",
                    "y1": "8",
                    "x2": "20.05",
                    "y2": "17.94"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9.69",
                    "y1": "8",
                    "x2": "21.17",
                    "y2": "8"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "7.38",
                    "y1": "12",
                    "x2": "13.12",
                    "y2": "2.06"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9.69",
                    "y1": "16",
                    "x2": "3.95",
                    "y2": "6.06"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14.31",
                    "y1": "16",
                    "x2": "2.83",
                    "y2": "16"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16.62",
                    "y1": "12",
                    "x2": "10.88",
                    "y2": "21.94"
                }
            }
        ]
    })(props);
}
function FiArchive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "21 8 21 21 3 21 3 8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "3",
                    "width": "22",
                    "height": "5"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "y1": "12",
                    "x2": "14",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function FiArrowDownCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "8 12 12 16 16 12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "16"
                }
            }
        ]
    })(props);
}
function FiArrowDownLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "7",
                    "x2": "7",
                    "y2": "17"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 17 7 17 7 7"
                }
            }
        ]
    })(props);
}
function FiArrowDownRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "7",
                    "y1": "7",
                    "x2": "17",
                    "y2": "17"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 7 17 17 7 17"
                }
            }
        ]
    })(props);
}
function FiArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "5",
                    "x2": "12",
                    "y2": "19"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "19 12 12 19 5 12"
                }
            }
        ]
    })(props);
}
function FiArrowLeftCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 8 8 12 12 16"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "12",
                    "x2": "8",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function FiArrowLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "19",
                    "y1": "12",
                    "x2": "5",
                    "y2": "12"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 19 5 12 12 5"
                }
            }
        ]
    })(props);
}
function FiArrowRightCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 16 16 12 12 8"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function FiArrowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "5",
                    "y1": "12",
                    "x2": "19",
                    "y2": "12"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 5 19 12 12 19"
                }
            }
        ]
    })(props);
}
function FiArrowUpCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 12 12 8 8 12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "16",
                    "x2": "12",
                    "y2": "8"
                }
            }
        ]
    })(props);
}
function FiArrowUpLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "17",
                    "x2": "7",
                    "y2": "7"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7 17 7 7 17 7"
                }
            }
        ]
    })(props);
}
function FiArrowUpRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "7",
                    "y1": "17",
                    "x2": "17",
                    "y2": "7"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7 7 17 7 17 17"
                }
            }
        ]
    })(props);
}
function FiArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "19",
                    "x2": "12",
                    "y2": "5"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "5 12 12 5 19 12"
                }
            }
        ]
    })(props);
}
function FiAtSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"
                }
            }
        ]
    })(props);
}
function FiAward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "8",
                    "r": "7"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "8.21 13.89 7 23 12 20 17 23 15.79 13.88"
                }
            }
        ]
    })(props);
}
function FiBarChart2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "20",
                    "x2": "18",
                    "y2": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "20",
                    "x2": "12",
                    "y2": "4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "20",
                    "x2": "6",
                    "y2": "14"
                }
            }
        ]
    })(props);
}
function FiBarChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "20",
                    "x2": "12",
                    "y2": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "20",
                    "x2": "18",
                    "y2": "4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "20",
                    "x2": "6",
                    "y2": "16"
                }
            }
        ]
    })(props);
}
function FiBatteryCharging(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.19M15 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.19"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "13",
                    "x2": "23",
                    "y2": "11"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "11 6 7 12 13 12 9 18"
                }
            }
        ]
    })(props);
}
function FiBattery(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "6",
                    "width": "18",
                    "height": "12",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "13",
                    "x2": "23",
                    "y2": "11"
                }
            }
        ]
    })(props);
}
function FiBellOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.73 21a2 2 0 0 1-3.46 0"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.63 13A17.89 17.89 0 0 1 18 8"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.26 6.26A5.86 5.86 0 0 0 6 8c0 7-3 9-3 9h14"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8a6 6 0 0 0-9.33-5"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                }
            }
        ]
    })(props);
}
function FiBell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.73 21a2 2 0 0 1-3.46 0"
                }
            }
        ]
    })(props);
}
function FiBluetooth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "6.5 6.5 17.5 17.5 12 23 12 1 17.5 6.5 6.5 17.5"
                }
            }
        ]
    })(props);
}
function FiBold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"
                }
            }
        ]
    })(props);
}
function FiBookOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"
                }
            }
        ]
    })(props);
}
function FiBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19.5A2.5 2.5 0 0 1 6.5 17H20"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"
                }
            }
        ]
    })(props);
}
function FiBookmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"
                }
            }
        ]
    })(props);
}
function FiBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "3.27 6.96 12 12.01 20.73 6.96"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22.08",
                    "x2": "12",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function FiBriefcase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "7",
                    "width": "20",
                    "height": "14",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"
                }
            }
        ]
    })(props);
}
function FiCalendar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "4",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "2",
                    "x2": "16",
                    "y2": "6"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "2",
                    "x2": "8",
                    "y2": "6"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "10",
                    "x2": "21",
                    "y2": "10"
                }
            }
        ]
    })(props);
}
function FiCameraOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 21H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3m3-3h6l2 3h4a2 2 0 0 1 2 2v9.34m-7.72-2.06a4 4 0 1 1-5.56-5.56"
                }
            }
        ]
    })(props);
}
function FiCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "13",
                    "r": "4"
                }
            }
        ]
    })(props);
}
function FiCast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "y1": "20",
                    "x2": "2.01",
                    "y2": "20"
                }
            }
        ]
    })(props);
}
function FiCheckCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11.08V12a10 10 0 1 1-5.93-9.14"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "22 4 12 14.01 9 11.01"
                }
            }
        ]
    })(props);
}
function FiCheckSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 11 12 14 22 4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"
                }
            }
        ]
    })(props);
}
function FiCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "20 6 9 17 4 12"
                }
            }
        ]
    })(props);
}
function FiChevronDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "6 9 12 15 18 9"
                }
            }
        ]
    })(props);
}
function FiChevronLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "15 18 9 12 15 6"
                }
            }
        ]
    })(props);
}
function FiChevronRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 18 15 12 9 6"
                }
            }
        ]
    })(props);
}
function FiChevronUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "18 15 12 9 6 15"
                }
            }
        ]
    })(props);
}
function FiChevronsDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "7 13 12 18 17 13"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7 6 12 11 17 6"
                }
            }
        ]
    })(props);
}
function FiChevronsLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "11 17 6 12 11 7"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "18 17 13 12 18 7"
                }
            }
        ]
    })(props);
}
function FiChevronsRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "13 17 18 12 13 7"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "6 17 11 12 6 7"
                }
            }
        ]
    })(props);
}
function FiChevronsUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 11 12 6 7 11"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 18 12 13 7 18"
                }
            }
        ]
    })(props);
}
function FiChrome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21.17",
                    "y1": "8",
                    "x2": "12",
                    "y2": "8"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3.95",
                    "y1": "6.06",
                    "x2": "8.54",
                    "y2": "14"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10.88",
                    "y1": "21.94",
                    "x2": "15.46",
                    "y2": "14"
                }
            }
        ]
    })(props);
}
function FiCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            }
        ]
    })(props);
}
function FiClipboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "8",
                    "y": "2",
                    "width": "8",
                    "height": "4",
                    "rx": "1",
                    "ry": "1"
                }
            }
        ]
    })(props);
}
function FiClock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 6 12 12 16 14"
                }
            }
        ]
    })(props);
}
function FiCloudDrizzle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "19",
                    "x2": "8",
                    "y2": "21"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "13",
                    "x2": "8",
                    "y2": "15"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "19",
                    "x2": "16",
                    "y2": "21"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "13",
                    "x2": "16",
                    "y2": "15"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "21",
                    "x2": "12",
                    "y2": "23"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "15",
                    "x2": "12",
                    "y2": "17"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"
                }
            }
        ]
    })(props);
}
function FiCloudLightning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 16.9A5 5 0 0 0 18 7h-1.26a8 8 0 1 0-11.62 9"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "13 11 9 17 15 17 11 23"
                }
            }
        ]
    })(props);
}
function FiCloudOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.61 16.95A5 5 0 0 0 18 10h-1.26a8 8 0 0 0-7.05-6M5 5a8 8 0 0 0 4 15h9a5 5 0 0 0 1.7-.3"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                }
            }
        ]
    })(props);
}
function FiCloudRain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "13",
                    "x2": "16",
                    "y2": "21"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "13",
                    "x2": "8",
                    "y2": "21"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "15",
                    "x2": "12",
                    "y2": "23"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"
                }
            }
        ]
    })(props);
}
function FiCloudSnow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17.58A5 5 0 0 0 18 8h-1.26A8 8 0 1 0 4 16.25"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "16",
                    "x2": "8.01",
                    "y2": "16"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "20",
                    "x2": "8.01",
                    "y2": "20"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "18",
                    "x2": "12.01",
                    "y2": "18"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22",
                    "x2": "12.01",
                    "y2": "22"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "16",
                    "x2": "16.01",
                    "y2": "16"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "20",
                    "x2": "16.01",
                    "y2": "20"
                }
            }
        ]
    })(props);
}
function FiCloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"
                }
            }
        ]
    })(props);
}
function FiCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 18 22 12 16 6"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "8 6 2 12 8 18"
                }
            }
        ]
    })(props);
}
function FiCodepen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22",
                    "x2": "12",
                    "y2": "15.5"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "22 8.5 12 15.5 2 8.5"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "2 15.5 12 8.5 22 15.5"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "2",
                    "x2": "12",
                    "y2": "8.5"
                }
            }
        ]
    })(props);
}
function FiCodesandbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7.5 4.21 12 6.81 16.5 4.21"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7.5 19.79 7.5 14.6 3 12"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "21 12 16.5 14.6 16.5 19.79"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "3.27 6.96 12 12.01 20.73 6.96"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22.08",
                    "x2": "12",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function FiCoffee(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8h1a4 4 0 0 1 0 8h-1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "1",
                    "x2": "6",
                    "y2": "4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "y1": "1",
                    "x2": "10",
                    "y2": "4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14",
                    "y1": "1",
                    "x2": "14",
                    "y2": "4"
                }
            }
        ]
    })(props);
}
function FiColumns(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3h7a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-7m0-18H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7m0-18v18"
                }
            }
        ]
    })(props);
}
function FiCommand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3V6a3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 3 3 0 0 0-3-3z"
                }
            }
        ]
    })(props);
}
function FiCompass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"
                }
            }
        ]
    })(props);
}
function FiCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "9",
                    "y": "9",
                    "width": "13",
                    "height": "13",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
                }
            }
        ]
    })(props);
}
function FiCornerDownLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 10 4 15 9 20"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4v7a4 4 0 0 1-4 4H4"
                }
            }
        ]
    })(props);
}
function FiCornerDownRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "15 10 20 15 15 20"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4v7a4 4 0 0 0 4 4h12"
                }
            }
        ]
    })(props);
}
function FiCornerLeftDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "14 15 9 20 4 15"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4h-7a4 4 0 0 0-4 4v12"
                }
            }
        ]
    })(props);
}
function FiCornerLeftUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "14 9 9 4 4 9"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20h-7a4 4 0 0 1-4-4V4"
                }
            }
        ]
    })(props);
}
function FiCornerRightDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "10 15 15 20 20 15"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4h7a4 4 0 0 1 4 4v12"
                }
            }
        ]
    })(props);
}
function FiCornerRightUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "10 9 15 4 20 9"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 20h7a4 4 0 0 0 4-4V4"
                }
            }
        ]
    })(props);
}
function FiCornerUpLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 14 4 9 9 4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20v-7a4 4 0 0 0-4-4H4"
                }
            }
        ]
    })(props);
}
function FiCornerUpRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "15 14 20 9 15 4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 20v-7a4 4 0 0 1 4-4h12"
                }
            }
        ]
    })(props);
}
function FiCpu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "4",
                    "y": "4",
                    "width": "16",
                    "height": "16",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "9",
                    "y": "9",
                    "width": "6",
                    "height": "6"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "1",
                    "x2": "9",
                    "y2": "4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "1",
                    "x2": "15",
                    "y2": "4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "20",
                    "x2": "9",
                    "y2": "23"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "20",
                    "x2": "15",
                    "y2": "23"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "20",
                    "y1": "9",
                    "x2": "23",
                    "y2": "9"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "20",
                    "y1": "14",
                    "x2": "23",
                    "y2": "14"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "9",
                    "x2": "4",
                    "y2": "9"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "14",
                    "x2": "4",
                    "y2": "14"
                }
            }
        ]
    })(props);
}
function FiCreditCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "4",
                    "width": "22",
                    "height": "16",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "10",
                    "x2": "23",
                    "y2": "10"
                }
            }
        ]
    })(props);
}
function FiCrop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.13 1L6 16a2 2 0 0 0 2 2h15"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 6.13L16 6a2 2 0 0 1 2 2v15"
                }
            }
        ]
    })(props);
}
function FiCrosshair(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "22",
                    "y1": "12",
                    "x2": "18",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "12",
                    "x2": "2",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "6",
                    "x2": "12",
                    "y2": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22",
                    "x2": "12",
                    "y2": "18"
                }
            }
        ]
    })(props);
}
function FiDatabase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "5",
                    "rx": "9",
                    "ry": "3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"
                }
            }
        ]
    })(props);
}
function FiDelete(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "9",
                    "x2": "12",
                    "y2": "15"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "9",
                    "x2": "18",
                    "y2": "15"
                }
            }
        ]
    })(props);
}
function FiDisc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function FiDivideCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "16",
                    "x2": "12",
                    "y2": "16"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "8"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            }
        ]
    })(props);
}
function FiDivideSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "16",
                    "x2": "12",
                    "y2": "16"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "8"
                }
            }
        ]
    })(props);
}
function FiDivide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "6",
                    "r": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "5",
                    "y1": "12",
                    "x2": "19",
                    "y2": "12"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "18",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function FiDollarSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "1",
                    "x2": "12",
                    "y2": "23"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
                }
            }
        ]
    })(props);
}
function FiDownloadCloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "8 17 12 21 16 17"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "12",
                    "x2": "12",
                    "y2": "21"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"
                }
            }
        ]
    })(props);
}
function FiDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7 10 12 15 17 10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "15",
                    "x2": "12",
                    "y2": "3"
                }
            }
        ]
    })(props);
}
function FiDribbble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32"
                }
            }
        ]
    })(props);
}
function FiDroplet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"
                }
            }
        ]
    })(props);
}
function FiEdit2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"
                }
            }
        ]
    })(props);
}
function FiEdit3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20h9"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"
                }
            }
        ]
    })(props);
}
function FiEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
                }
            }
        ]
    })(props);
}
function FiExternalLink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "15 3 21 3 21 9"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "y1": "14",
                    "x2": "21",
                    "y2": "3"
                }
            }
        ]
    })(props);
}
function FiEyeOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                }
            }
        ]
    })(props);
}
function FiEye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function FiFacebook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
                }
            }
        ]
    })(props);
}
function FiFastForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "13 19 22 12 13 5 13 19"
                }
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "2 19 11 12 2 5 2 19"
                }
            }
        ]
    })(props);
}
function FiFeather(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "8",
                    "x2": "2",
                    "y2": "22"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17.5",
                    "y1": "15",
                    "x2": "9",
                    "y2": "15"
                }
            }
        ]
    })(props);
}
function FiFigma(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z"
                }
            }
        ]
    })(props);
}
function FiFileMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "14 2 14 8 20 8"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "15",
                    "x2": "15",
                    "y2": "15"
                }
            }
        ]
    })(props);
}
function FiFilePlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "14 2 14 8 20 8"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "18",
                    "x2": "12",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "15",
                    "x2": "15",
                    "y2": "15"
                }
            }
        ]
    })(props);
}
function FiFileText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "14 2 14 8 20 8"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "13",
                    "x2": "8",
                    "y2": "13"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "17",
                    "x2": "8",
                    "y2": "17"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "10 9 9 9 8 9"
                }
            }
        ]
    })(props);
}
function FiFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "13 2 13 9 20 9"
                }
            }
        ]
    })(props);
}
function FiFilm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "2",
                    "width": "20",
                    "height": "20",
                    "rx": "2.18",
                    "ry": "2.18"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "7",
                    "y1": "2",
                    "x2": "7",
                    "y2": "22"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "2",
                    "x2": "17",
                    "y2": "22"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "y1": "12",
                    "x2": "22",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "y1": "7",
                    "x2": "7",
                    "y2": "7"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "y1": "17",
                    "x2": "7",
                    "y2": "17"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "17",
                    "x2": "22",
                    "y2": "17"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "7",
                    "x2": "22",
                    "y2": "7"
                }
            }
        ]
    })(props);
}
function FiFilter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
                }
            }
        ]
    })(props);
}
function FiFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "22",
                    "x2": "4",
                    "y2": "15"
                }
            }
        ]
    })(props);
}
function FiFolderMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "14",
                    "x2": "15",
                    "y2": "14"
                }
            }
        ]
    })(props);
}
function FiFolderPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "11",
                    "x2": "12",
                    "y2": "17"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "14",
                    "x2": "15",
                    "y2": "14"
                }
            }
        ]
    })(props);
}
function FiFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
                }
            }
        ]
    })(props);
}
function FiFramer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16V9h14V2H5l14 14h-7m-7 0l7 7v-7m-7 0h7"
                }
            }
        ]
    })(props);
}
function FiFrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16s-1.5-2-4-2-4 2-4 2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "9",
                    "x2": "9.01",
                    "y2": "9"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "9",
                    "x2": "15.01",
                    "y2": "9"
                }
            }
        ]
    })(props);
}
function FiGift(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "20 12 20 22 4 22 4 12"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "7",
                    "width": "20",
                    "height": "5"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22",
                    "x2": "12",
                    "y2": "7"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"
                }
            }
        ]
    })(props);
}
function FiGitBranch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "3",
                    "x2": "6",
                    "y2": "15"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "6",
                    "r": "3"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "18",
                    "r": "3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9a9 9 0 0 1-9 9"
                }
            }
        ]
    })(props);
}
function FiGitCommit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1.05",
                    "y1": "12",
                    "x2": "7",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17.01",
                    "y1": "12",
                    "x2": "22.96",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function FiGitMerge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "18",
                    "r": "3"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "6",
                    "r": "3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 21V9a9 9 0 0 0 9 9"
                }
            }
        ]
    })(props);
}
function FiGitPullRequest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "18",
                    "r": "3"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "6",
                    "r": "3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6h3a2 2 0 0 1 2 2v7"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "9",
                    "x2": "6",
                    "y2": "21"
                }
            }
        ]
    })(props);
}
function FiGithub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"
                }
            }
        ]
    })(props);
}
function FiGitlab(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 0 1 4.82 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0 1 18.6 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.51L23 13.45a.84.84 0 0 1-.35.94z"
                }
            }
        ]
    })(props);
}
function FiGlobe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "y1": "12",
                    "x2": "22",
                    "y2": "12"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
                }
            }
        ]
    })(props);
}
function FiGrid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "7",
                    "height": "7"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "3",
                    "width": "7",
                    "height": "7"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "14",
                    "width": "7",
                    "height": "7"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "14",
                    "width": "7",
                    "height": "7"
                }
            }
        ]
    })(props);
}
function FiHardDrive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "22",
                    "y1": "12",
                    "x2": "2",
                    "y2": "12"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "16",
                    "x2": "6.01",
                    "y2": "16"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "y1": "16",
                    "x2": "10.01",
                    "y2": "16"
                }
            }
        ]
    })(props);
}
function FiHash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "9",
                    "x2": "20",
                    "y2": "9"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "15",
                    "x2": "20",
                    "y2": "15"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "y1": "3",
                    "x2": "8",
                    "y2": "21"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "3",
                    "x2": "14",
                    "y2": "21"
                }
            }
        ]
    })(props);
}
function FiHeadphones(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18v-6a9 9 0 0 1 18 0v6"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"
                }
            }
        ]
    })(props);
}
function FiHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
                }
            }
        ]
    })(props);
}
function FiHelpCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "17",
                    "x2": "12.01",
                    "y2": "17"
                }
            }
        ]
    })(props);
}
function FiHexagon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
                }
            }
        ]
    })(props);
}
function FiHome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 22 9 12 15 12 15 22"
                }
            }
        ]
    })(props);
}
function FiImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "8.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "21 15 16 10 5 21"
                }
            }
        ]
    })(props);
}
function FiInbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "22 12 16 12 14 15 10 15 8 12 2 12"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
                }
            }
        ]
    })(props);
}
function FiInfo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "16",
                    "x2": "12",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12.01",
                    "y2": "8"
                }
            }
        ]
    })(props);
}
function FiInstagram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "2",
                    "width": "20",
                    "height": "20",
                    "rx": "5",
                    "ry": "5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17.5",
                    "y1": "6.5",
                    "x2": "17.51",
                    "y2": "6.5"
                }
            }
        ]
    })(props);
}
function FiItalic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "19",
                    "y1": "4",
                    "x2": "10",
                    "y2": "4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14",
                    "y1": "20",
                    "x2": "5",
                    "y2": "20"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "4",
                    "x2": "9",
                    "y2": "20"
                }
            }
        ]
    })(props);
}
function FiKey(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"
                }
            }
        ]
    })(props);
}
function FiLayers(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "12 2 2 7 12 12 22 7 12 2"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "2 17 12 22 22 17"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "2 12 12 17 22 12"
                }
            }
        ]
    })(props);
}
function FiLayout(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "9",
                    "x2": "21",
                    "y2": "9"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "21",
                    "x2": "9",
                    "y2": "9"
                }
            }
        ]
    })(props);
}
function FiLifeBuoy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.93",
                    "y1": "4.93",
                    "x2": "9.17",
                    "y2": "9.17"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14.83",
                    "y1": "14.83",
                    "x2": "19.07",
                    "y2": "19.07"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14.83",
                    "y1": "9.17",
                    "x2": "19.07",
                    "y2": "4.93"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14.83",
                    "y1": "9.17",
                    "x2": "18.36",
                    "y2": "5.64"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.93",
                    "y1": "19.07",
                    "x2": "9.17",
                    "y2": "14.83"
                }
            }
        ]
    })(props);
}
function FiLink2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function FiLink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
                }
            }
        ]
    })(props);
}
function FiLinkedin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "9",
                    "width": "4",
                    "height": "12"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4",
                    "cy": "4",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function FiList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "6",
                    "x2": "21",
                    "y2": "6"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "21",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "18",
                    "x2": "21",
                    "y2": "18"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "6",
                    "x2": "3.01",
                    "y2": "6"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "12",
                    "x2": "3.01",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "18",
                    "x2": "3.01",
                    "y2": "18"
                }
            }
        ]
    })(props);
}
function FiLoader(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "2",
                    "x2": "12",
                    "y2": "6"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "18",
                    "x2": "12",
                    "y2": "22"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.93",
                    "y1": "4.93",
                    "x2": "7.76",
                    "y2": "7.76"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16.24",
                    "y1": "16.24",
                    "x2": "19.07",
                    "y2": "19.07"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "y1": "12",
                    "x2": "6",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "12",
                    "x2": "22",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.93",
                    "y1": "19.07",
                    "x2": "7.76",
                    "y2": "16.24"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16.24",
                    "y1": "7.76",
                    "x2": "19.07",
                    "y2": "4.93"
                }
            }
        ]
    })(props);
}
function FiLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "11",
                    "width": "18",
                    "height": "11",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11V7a5 5 0 0 1 10 0v4"
                }
            }
        ]
    })(props);
}
function FiLogIn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "10 17 15 12 10 7"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "12",
                    "x2": "3",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function FiLogOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 17 21 12 16 7"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "12",
                    "x2": "9",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function FiMail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "22,6 12,13 2,6"
                }
            }
        ]
    })(props);
}
function FiMapPin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "10",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function FiMap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "2",
                    "x2": "8",
                    "y2": "18"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "6",
                    "x2": "16",
                    "y2": "22"
                }
            }
        ]
    })(props);
}
function FiMaximize2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "15 3 21 3 21 9"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 21 3 21 3 15"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "3",
                    "x2": "14",
                    "y2": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "21",
                    "x2": "10",
                    "y2": "14"
                }
            }
        ]
    })(props);
}
function FiMaximize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"
                }
            }
        ]
    })(props);
}
function FiMeh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "15",
                    "x2": "16",
                    "y2": "15"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "9",
                    "x2": "9.01",
                    "y2": "9"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "9",
                    "x2": "15.01",
                    "y2": "9"
                }
            }
        ]
    })(props);
}
function FiMenu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "12",
                    "x2": "21",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "6",
                    "x2": "21",
                    "y2": "6"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "18",
                    "x2": "21",
                    "y2": "18"
                }
            }
        ]
    })(props);
}
function FiMessageCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
                }
            }
        ]
    })(props);
}
function FiMessageSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
                }
            }
        ]
    })(props);
}
function FiMicOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "19",
                    "x2": "12",
                    "y2": "23"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "23",
                    "x2": "16",
                    "y2": "23"
                }
            }
        ]
    })(props);
}
function FiMic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10v2a7 7 0 0 1-14 0v-2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "19",
                    "x2": "12",
                    "y2": "23"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "23",
                    "x2": "16",
                    "y2": "23"
                }
            }
        ]
    })(props);
}
function FiMinimize2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "4 14 10 14 10 20"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "20 10 14 10 14 4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14",
                    "y1": "10",
                    "x2": "21",
                    "y2": "3"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "21",
                    "x2": "10",
                    "y2": "14"
                }
            }
        ]
    })(props);
}
function FiMinimize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"
                }
            }
        ]
    })(props);
}
function FiMinusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function FiMinusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function FiMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "5",
                    "y1": "12",
                    "x2": "19",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function FiMonitor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "3",
                    "width": "20",
                    "height": "14",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "21",
                    "x2": "16",
                    "y2": "21"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "17",
                    "x2": "12",
                    "y2": "21"
                }
            }
        ]
    })(props);
}
function FiMoon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
                }
            }
        ]
    })(props);
}
function FiMoreHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "12",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "12",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function FiMoreVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "5",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "19",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function FiMousePointer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 13l6 6"
                }
            }
        ]
    })(props);
}
function FiMove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "5 9 2 12 5 15"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 5 12 2 15 5"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "15 19 12 22 9 19"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "19 9 22 12 19 15"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "y1": "12",
                    "x2": "22",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "2",
                    "x2": "12",
                    "y2": "22"
                }
            }
        ]
    })(props);
}
function FiMusic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 18V5l12-2v13"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "18",
                    "r": "3"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "16",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function FiNavigation2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "12 2 19 21 12 17 5 21 12 2"
                }
            }
        ]
    })(props);
}
function FiNavigation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "3 11 22 2 13 21 11 13 3 11"
                }
            }
        ]
    })(props);
}
function FiOctagon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
                }
            }
        ]
    })(props);
}
function FiPackage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "16.5",
                    "y1": "9.4",
                    "x2": "7.5",
                    "y2": "4.21"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "3.27 6.96 12 12.01 20.73 6.96"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22.08",
                    "x2": "12",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function FiPaperclip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"
                }
            }
        ]
    })(props);
}
function FiPauseCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "y1": "15",
                    "x2": "10",
                    "y2": "9"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14",
                    "y1": "15",
                    "x2": "14",
                    "y2": "9"
                }
            }
        ]
    })(props);
}
function FiPause(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "6",
                    "y": "4",
                    "width": "4",
                    "height": "16"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "4",
                    "width": "4",
                    "height": "16"
                }
            }
        ]
    })(props);
}
function FiPenTool(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19l7-7 3 3-7 7-3-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2l7.586 7.586"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "11",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function FiPercent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "19",
                    "y1": "5",
                    "x2": "5",
                    "y2": "19"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "6.5",
                    "r": "2.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "17.5",
                    "r": "2.5"
                }
            }
        ]
    })(props);
}
function FiPhoneCall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                }
            }
        ]
    })(props);
}
function FiPhoneForwarded(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "19 1 23 5 19 9"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "5",
                    "x2": "23",
                    "y2": "5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                }
            }
        ]
    })(props);
}
function FiPhoneIncoming(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 2 16 8 22 8"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "1",
                    "x2": "16",
                    "y2": "8"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                }
            }
        ]
    })(props);
}
function FiPhoneMissed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "1",
                    "x2": "17",
                    "y2": "7"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "1",
                    "x2": "23",
                    "y2": "7"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                }
            }
        ]
    })(props);
}
function FiPhoneOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "1",
                    "x2": "1",
                    "y2": "23"
                }
            }
        ]
    })(props);
}
function FiPhoneOutgoing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "23 7 23 1 17 1"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "8",
                    "x2": "23",
                    "y2": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                }
            }
        ]
    })(props);
}
function FiPhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                }
            }
        ]
    })(props);
}
function FiPieChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.21 15.89A10 10 0 1 1 8 2.83"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12A10 10 0 0 0 12 2v10z"
                }
            }
        ]
    })(props);
}
function FiPlayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "10 8 16 12 10 16 10 8"
                }
            }
        ]
    })(props);
}
function FiPlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "5 3 19 12 5 21 5 3"
                }
            }
        ]
    })(props);
}
function FiPlusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "16"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function FiPlusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "16"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function FiPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "5",
                    "x2": "12",
                    "y2": "19"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "5",
                    "y1": "12",
                    "x2": "19",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function FiPocket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "8 10 12 14 16 10"
                }
            }
        ]
    })(props);
}
function FiPower(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.36 6.64a9 9 0 1 1-12.73 0"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "2",
                    "x2": "12",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function FiPrinter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "6 9 6 2 18 2 18 9"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "6",
                    "y": "14",
                    "width": "12",
                    "height": "8"
                }
            }
        ]
    })(props);
}
function FiRadio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14"
                }
            }
        ]
    })(props);
}
function FiRefreshCcw(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "1 4 1 10 7 10"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "23 20 23 14 17 14"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"
                }
            }
        ]
    })(props);
}
function FiRefreshCw(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "23 4 23 10 17 10"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "1 20 1 14 7 14"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
                }
            }
        ]
    })(props);
}
function FiRepeat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 1 21 5 17 9"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11V9a4 4 0 0 1 4-4h14"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7 23 3 19 7 15"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 13v2a4 4 0 0 1-4 4H3"
                }
            }
        ]
    })(props);
}
function FiRewind(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "11 19 2 12 11 5 11 19"
                }
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "22 19 13 12 22 5 22 19"
                }
            }
        ]
    })(props);
}
function FiRotateCcw(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "1 4 1 10 7 10"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.51 15a9 9 0 1 0 2.13-9.36L1 10"
                }
            }
        ]
    })(props);
}
function FiRotateCw(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "23 4 23 10 17 10"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.49 15a9 9 0 1 1-2.12-9.36L23 10"
                }
            }
        ]
    })(props);
}
function FiRss(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11a9 9 0 0 1 9 9"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4a16 16 0 0 1 16 16"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "19",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function FiSave(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 21 17 13 7 13 7 21"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7 3 7 8 15 8"
                }
            }
        ]
    })(props);
}
function FiScissors(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "6",
                    "r": "3"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "18",
                    "r": "3"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "20",
                    "y1": "4",
                    "x2": "8.12",
                    "y2": "15.88"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14.47",
                    "y1": "14.48",
                    "x2": "20",
                    "y2": "20"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8.12",
                    "y1": "8.12",
                    "x2": "12",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function FiSearch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "11",
                    "r": "8"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "21",
                    "x2": "16.65",
                    "y2": "16.65"
                }
            }
        ]
    })(props);
}
function FiSend(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "22",
                    "y1": "2",
                    "x2": "11",
                    "y2": "13"
                }
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "22 2 15 22 11 13 2 9 22 2"
                }
            }
        ]
    })(props);
}
function FiServer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "2",
                    "width": "20",
                    "height": "8",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "14",
                    "width": "20",
                    "height": "8",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "6",
                    "x2": "6.01",
                    "y2": "6"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "18",
                    "x2": "6.01",
                    "y2": "18"
                }
            }
        ]
    })(props);
}
function FiSettings(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
                }
            }
        ]
    })(props);
}
function FiShare2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "5",
                    "r": "3"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "12",
                    "r": "3"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "19",
                    "r": "3"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8.59",
                    "y1": "13.51",
                    "x2": "15.42",
                    "y2": "17.49"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15.41",
                    "y1": "6.51",
                    "x2": "8.59",
                    "y2": "10.49"
                }
            }
        ]
    })(props);
}
function FiShare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 6 12 2 8 6"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "2",
                    "x2": "12",
                    "y2": "15"
                }
            }
        ]
    })(props);
}
function FiShieldOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.69 14a6.9 6.9 0 0 0 .31-2V5l-8-3-3.16 1.18"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.73 4.73L4 5v7c0 6 8 10 8 10a20.29 20.29 0 0 0 5.62-4.38"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                }
            }
        ]
    })(props);
}
function FiShield(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
                }
            }
        ]
    })(props);
}
function FiShoppingBag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "6",
                    "x2": "21",
                    "y2": "6"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10a4 4 0 0 1-8 0"
                }
            }
        ]
    })(props);
}
function FiShoppingCart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "21",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "20",
                    "cy": "21",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"
                }
            }
        ]
    })(props);
}
function FiShuffle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 3 21 3 21 8"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "20",
                    "x2": "21",
                    "y2": "3"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "21 16 21 21 16 21"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "15",
                    "x2": "21",
                    "y2": "21"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "4",
                    "x2": "9",
                    "y2": "9"
                }
            }
        ]
    })(props);
}
function FiSidebar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "3",
                    "x2": "9",
                    "y2": "21"
                }
            }
        ]
    })(props);
}
function FiSkipBack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "19 20 9 12 19 4 19 20"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "5",
                    "y1": "19",
                    "x2": "5",
                    "y2": "5"
                }
            }
        ]
    })(props);
}
function FiSkipForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "5 4 15 12 5 20 5 4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "19",
                    "y1": "5",
                    "x2": "19",
                    "y2": "19"
                }
            }
        ]
    })(props);
}
function FiSlack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 10H19V8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 14c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5S8 21.33 8 20.5v-5c0-.83.67-1.5 1.5-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 14H5v1.5c0 .83-.67 1.5-1.5 1.5S2 16.33 2 15.5 2.67 14 3.5 14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 19H14v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9.5C10 8.67 9.33 8 8.5 8h-5C2.67 8 2 8.67 2 9.5S2.67 11 3.5 11h5c.83 0 1.5-.67 1.5-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 5H10V3.5C10 2.67 9.33 2 8.5 2S7 2.67 7 3.5 7.67 5 8.5 5z"
                }
            }
        ]
    })(props);
}
function FiSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.93",
                    "y1": "4.93",
                    "x2": "19.07",
                    "y2": "19.07"
                }
            }
        ]
    })(props);
}
function FiSliders(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "21",
                    "x2": "4",
                    "y2": "14"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "10",
                    "x2": "4",
                    "y2": "3"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "21",
                    "x2": "12",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "3"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "20",
                    "y1": "21",
                    "x2": "20",
                    "y2": "16"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "20",
                    "y1": "12",
                    "x2": "20",
                    "y2": "3"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "14",
                    "x2": "7",
                    "y2": "14"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "8",
                    "x2": "15",
                    "y2": "8"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "16",
                    "x2": "23",
                    "y2": "16"
                }
            }
        ]
    })(props);
}
function FiSmartphone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "5",
                    "y": "2",
                    "width": "14",
                    "height": "20",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "18",
                    "x2": "12.01",
                    "y2": "18"
                }
            }
        ]
    })(props);
}
function FiSmile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14s1.5 2 4 2 4-2 4-2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "9",
                    "x2": "9.01",
                    "y2": "9"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "9",
                    "x2": "15.01",
                    "y2": "9"
                }
            }
        ]
    })(props);
}
function FiSpeaker(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "4",
                    "y": "2",
                    "width": "16",
                    "height": "20",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "14",
                    "r": "4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "6",
                    "x2": "12.01",
                    "y2": "6"
                }
            }
        ]
    })(props);
}
function FiSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                }
            }
        ]
    })(props);
}
function FiStar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
                }
            }
        ]
    })(props);
}
function FiStopCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "9",
                    "y": "9",
                    "width": "6",
                    "height": "6"
                }
            }
        ]
    })(props);
}
function FiSun(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "5"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "1",
                    "x2": "12",
                    "y2": "3"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "21",
                    "x2": "12",
                    "y2": "23"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.22",
                    "y1": "4.22",
                    "x2": "5.64",
                    "y2": "5.64"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18.36",
                    "y1": "18.36",
                    "x2": "19.78",
                    "y2": "19.78"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "12",
                    "x2": "3",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "12",
                    "x2": "23",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.22",
                    "y1": "19.78",
                    "x2": "5.64",
                    "y2": "18.36"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18.36",
                    "y1": "5.64",
                    "x2": "19.78",
                    "y2": "4.22"
                }
            }
        ]
    })(props);
}
function FiSunrise(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 18a5 5 0 0 0-10 0"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "2",
                    "x2": "12",
                    "y2": "9"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.22",
                    "y1": "10.22",
                    "x2": "5.64",
                    "y2": "11.64"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "18",
                    "x2": "3",
                    "y2": "18"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "18",
                    "x2": "23",
                    "y2": "18"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18.36",
                    "y1": "11.64",
                    "x2": "19.78",
                    "y2": "10.22"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "22",
                    "x2": "1",
                    "y2": "22"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "8 6 12 2 16 6"
                }
            }
        ]
    })(props);
}
function FiSunset(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 18a5 5 0 0 0-10 0"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "9",
                    "x2": "12",
                    "y2": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.22",
                    "y1": "10.22",
                    "x2": "5.64",
                    "y2": "11.64"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "18",
                    "x2": "3",
                    "y2": "18"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "18",
                    "x2": "23",
                    "y2": "18"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18.36",
                    "y1": "11.64",
                    "x2": "19.78",
                    "y2": "10.22"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "22",
                    "x2": "1",
                    "y2": "22"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 5 12 9 8 5"
                }
            }
        ]
    })(props);
}
function FiTable(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"
                }
            }
        ]
    })(props);
}
function FiTablet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "4",
                    "y": "2",
                    "width": "16",
                    "height": "20",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "18",
                    "x2": "12.01",
                    "y2": "18"
                }
            }
        ]
    })(props);
}
function FiTag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "7",
                    "y1": "7",
                    "x2": "7.01",
                    "y2": "7"
                }
            }
        ]
    })(props);
}
function FiTarget(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "6"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function FiTerminal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "4 17 10 11 4 5"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "19",
                    "x2": "20",
                    "y2": "19"
                }
            }
        ]
    })(props);
}
function FiThermometer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z"
                }
            }
        ]
    })(props);
}
function FiThumbsDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"
                }
            }
        ]
    })(props);
}
function FiThumbsUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"
                }
            }
        ]
    })(props);
}
function FiToggleLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "5",
                    "width": "22",
                    "height": "14",
                    "rx": "7",
                    "ry": "7"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "12",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function FiToggleRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "5",
                    "width": "22",
                    "height": "14",
                    "rx": "7",
                    "ry": "7"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "12",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function FiTool(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"
                }
            }
        ]
    })(props);
}
function FiTrash2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "3 6 5 6 21 6"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "y1": "11",
                    "x2": "10",
                    "y2": "17"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14",
                    "y1": "11",
                    "x2": "14",
                    "y2": "17"
                }
            }
        ]
    })(props);
}
function FiTrash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "3 6 5 6 21 6"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                }
            }
        ]
    })(props);
}
function FiTrello(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "7",
                    "width": "3",
                    "height": "9"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "7",
                    "width": "3",
                    "height": "5"
                }
            }
        ]
    })(props);
}
function FiTrendingDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "23 18 13.5 8.5 8.5 13.5 1 6"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 18 23 18 23 12"
                }
            }
        ]
    })(props);
}
function FiTrendingUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "23 6 13.5 15.5 8.5 10.5 1 18"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 6 23 6 23 12"
                }
            }
        ]
    })(props);
}
function FiTriangle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
                }
            }
        ]
    })(props);
}
function FiTruck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "3",
                    "width": "15",
                    "height": "13"
                }
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "16 8 20 8 23 11 23 16 16 16 16 8"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5.5",
                    "cy": "18.5",
                    "r": "2.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18.5",
                    "cy": "18.5",
                    "r": "2.5"
                }
            }
        ]
    })(props);
}
function FiTv(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "7",
                    "width": "20",
                    "height": "15",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 2 12 7 7 2"
                }
            }
        ]
    })(props);
}
function FiTwitch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 2H3v16h5v4l4-4h5l4-4V2zM11 11V7M16 11V7"
                }
            }
        ]
    })(props);
}
function FiTwitter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"
                }
            }
        ]
    })(props);
}
function FiType(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "4 7 4 4 20 4 20 7"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "20",
                    "x2": "15",
                    "y2": "20"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "4",
                    "x2": "12",
                    "y2": "20"
                }
            }
        ]
    })(props);
}
function FiUmbrella(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M23 12a11.05 11.05 0 0 0-22 0zm-5 7a3 3 0 0 1-6 0v-7"
                }
            }
        ]
    })(props);
}
function FiUnderline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "21",
                    "x2": "20",
                    "y2": "21"
                }
            }
        ]
    })(props);
}
function FiUnlock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "11",
                    "width": "18",
                    "height": "11",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11V7a5 5 0 0 1 9.9-1"
                }
            }
        ]
    })(props);
}
function FiUploadCloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 16 12 12 8 16"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "12",
                    "x2": "12",
                    "y2": "21"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 16 12 12 8 16"
                }
            }
        ]
    })(props);
}
function FiUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 8 12 3 7 8"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "3",
                    "x2": "12",
                    "y2": "15"
                }
            }
        ]
    })(props);
}
function FiUserCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "7",
                    "r": "4"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 11 19 13 23 9"
                }
            }
        ]
    })(props);
}
function FiUserMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "7",
                    "r": "4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "11",
                    "x2": "17",
                    "y2": "11"
                }
            }
        ]
    })(props);
}
function FiUserPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "7",
                    "r": "4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "20",
                    "y1": "8",
                    "x2": "20",
                    "y2": "14"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "11",
                    "x2": "17",
                    "y2": "11"
                }
            }
        ]
    })(props);
}
function FiUserX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "7",
                    "r": "4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "8",
                    "x2": "23",
                    "y2": "13"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "8",
                    "x2": "18",
                    "y2": "13"
                }
            }
        ]
    })(props);
}
function FiUser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "7",
                    "r": "4"
                }
            }
        ]
    })(props);
}
function FiUsers(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "7",
                    "r": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 21v-2a4 4 0 0 0-3-3.87"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3.13a4 4 0 0 1 0 7.75"
                }
            }
        ]
    })(props);
}
function FiVideoOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                }
            }
        ]
    })(props);
}
function FiVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "23 7 16 12 23 17 23 7"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "5",
                    "width": "15",
                    "height": "14",
                    "rx": "2",
                    "ry": "2"
                }
            }
        ]
    })(props);
}
function FiVoicemail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "5.5",
                    "cy": "11.5",
                    "r": "4.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18.5",
                    "cy": "11.5",
                    "r": "4.5"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "5.5",
                    "y1": "16",
                    "x2": "18.5",
                    "y2": "16"
                }
            }
        ]
    })(props);
}
function FiVolume1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.54 8.46a5 5 0 0 1 0 7.07"
                }
            }
        ]
    })(props);
}
function FiVolume2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"
                }
            }
        ]
    })(props);
}
function FiVolumeX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "9",
                    "x2": "17",
                    "y2": "15"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "9",
                    "x2": "23",
                    "y2": "15"
                }
            }
        ]
    })(props);
}
function FiVolume(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
                }
            }
        ]
    })(props);
}
function FiWatch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "7"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 9 12 12 13.5 13.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.51 17.35l-.35 3.83a2 2 0 0 1-2 1.82H9.83a2 2 0 0 1-2-1.82l-.35-3.83m.01-10.7l.35-3.83A2 2 0 0 1 9.83 1h4.35a2 2 0 0 1 2 1.82l.35 3.83"
                }
            }
        ]
    })(props);
}
function FiWifiOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.72 11.06A10.94 10.94 0 0 1 19 12.55"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12.55a10.94 10.94 0 0 1 5.17-2.39"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.71 5.05A16 16 0 0 1 22.58 9"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.42 9a15.91 15.91 0 0 1 4.7-2.88"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.53 16.11a6 6 0 0 1 6.95 0"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "20",
                    "x2": "12.01",
                    "y2": "20"
                }
            }
        ]
    })(props);
}
function FiWifi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12.55a11 11 0 0 1 14.08 0"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.42 9a16 16 0 0 1 21.16 0"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.53 16.11a6 6 0 0 1 6.95 0"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "20",
                    "x2": "12.01",
                    "y2": "20"
                }
            }
        ]
    })(props);
}
function FiWind(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 14 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2"
                }
            }
        ]
    })(props);
}
function FiXCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "9",
                    "x2": "9",
                    "y2": "15"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "9",
                    "x2": "15",
                    "y2": "15"
                }
            }
        ]
    })(props);
}
function FiXOctagon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "9",
                    "x2": "9",
                    "y2": "15"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "9",
                    "x2": "15",
                    "y2": "15"
                }
            }
        ]
    })(props);
}
function FiXSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "9",
                    "x2": "15",
                    "y2": "15"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "9",
                    "x2": "9",
                    "y2": "15"
                }
            }
        ]
    })(props);
}
function FiX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "6",
                    "x2": "6",
                    "y2": "18"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "6",
                    "x2": "18",
                    "y2": "18"
                }
            }
        ]
    })(props);
}
function FiYoutube(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"
                }
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"
                }
            }
        ]
    })(props);
}
function FiZapOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "12.41 6.75 13 2 10.57 4.92"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "18.57 12.91 21 10 15.66 10"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "8 8 3 14 12 14 11 22 16 16"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                }
            }
        ]
    })(props);
}
function FiZap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "13 2 3 14 12 14 11 22 21 10 12 10 13 2"
                }
            }
        ]
    })(props);
}
function FiZoomIn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "11",
                    "r": "8"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "21",
                    "x2": "16.65",
                    "y2": "16.65"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "11",
                    "y1": "8",
                    "x2": "11",
                    "y2": "14"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "11",
                    "x2": "14",
                    "y2": "11"
                }
            }
        ]
    })(props);
}
function FiZoomOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "11",
                    "r": "8"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "21",
                    "x2": "16.65",
                    "y2": "16.65"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "11",
                    "x2": "14",
                    "y2": "11"
                }
            }
        ]
    })(props);
}

},{"../lib":"hOIFC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hOIFC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _iconsManifest = require("./iconsManifest");
parcelHelpers.exportAll(_iconsManifest, exports);
var _iconBase = require("./iconBase");
parcelHelpers.exportAll(_iconBase, exports);
var _iconContext = require("./iconContext");
parcelHelpers.exportAll(_iconContext, exports);

},{"./iconsManifest":"e7CIK","./iconBase":"bl3gi","./iconContext":"3s4cv","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e7CIK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconsManifest", ()=>IconsManifest);
var IconsManifest = [
    {
        "id": "ci",
        "name": "Circum Icons",
        "projectUrl": "https://circumicons.com/",
        "license": "MPL-2.0 license",
        "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
    },
    {
        "id": "fa",
        "name": "Font Awesome 5",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "fa6",
        "name": "Font Awesome 6",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "io",
        "name": "Ionicons 4",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "io5",
        "name": "Ionicons 5",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "md",
        "name": "Material Design icons",
        "projectUrl": "http://google.github.io/material-design-icons/",
        "license": "Apache License Version 2.0",
        "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
    },
    {
        "id": "ti",
        "name": "Typicons",
        "projectUrl": "http://s-ings.com/typicons/",
        "license": "CC BY-SA 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
    },
    {
        "id": "go",
        "name": "Github Octicons icons",
        "projectUrl": "https://octicons.github.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
    },
    {
        "id": "fi",
        "name": "Feather",
        "projectUrl": "https://feathericons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
    },
    {
        "id": "lu",
        "name": "Lucide",
        "projectUrl": "https://lucide.dev/",
        "license": "ISC",
        "licenseUrl": "https://github.com/lucide-icons/lucide/blob/main/LICENSE"
    },
    {
        "id": "gi",
        "name": "Game Icons",
        "projectUrl": "https://game-icons.net/",
        "license": "CC BY 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
    },
    {
        "id": "wi",
        "name": "Weather Icons",
        "projectUrl": "https://erikflowers.github.io/weather-icons/",
        "license": "SIL OFL 1.1",
        "licenseUrl": "http://scripts.sil.org/OFL"
    },
    {
        "id": "di",
        "name": "Devicons",
        "projectUrl": "https://vorillaz.github.io/devicons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ai",
        "name": "Ant Design Icons",
        "projectUrl": "https://github.com/ant-design/ant-design-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "bs",
        "name": "Bootstrap Icons",
        "projectUrl": "https://github.com/twbs/icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ri",
        "name": "Remix Icon",
        "projectUrl": "https://github.com/Remix-Design/RemixIcon",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "fc",
        "name": "Flat Color Icons",
        "projectUrl": "https://github.com/icons8/flat-color-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "gr",
        "name": "Grommet-Icons",
        "projectUrl": "https://github.com/grommet/grommet-icons",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "hi",
        "name": "Heroicons",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "hi2",
        "name": "Heroicons 2",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "si",
        "name": "Simple Icons",
        "projectUrl": "https://simpleicons.org/",
        "license": "CC0 1.0 Universal",
        "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
    },
    {
        "id": "sl",
        "name": "Simple Line Icons",
        "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "im",
        "name": "IcoMoon Free",
        "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
    },
    {
        "id": "bi",
        "name": "BoxIcons",
        "projectUrl": "https://github.com/atisawd/boxicons",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
    },
    {
        "id": "cg",
        "name": "css.gg",
        "projectUrl": "https://github.com/astrit/css.gg",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "vsc",
        "name": "VS Code Icons",
        "projectUrl": "https://github.com/microsoft/vscode-codicons",
        "license": "CC BY 4.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "tb",
        "name": "Tabler Icons",
        "projectUrl": "https://github.com/tabler/tabler-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "tfi",
        "name": "Themify Icons",
        "projectUrl": "https://github.com/lykmapipo/themify-icons",
        "license": "MIT",
        "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
    },
    {
        "id": "rx",
        "name": "Radix Icons",
        "projectUrl": "https://icons.radix-ui.com",
        "license": "MIT",
        "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
    },
    {
        "id": "pi",
        "name": "Phosphor Icons",
        "projectUrl": "https://github.com/phosphor-icons/core",
        "license": "MIT",
        "licenseUrl": "https://github.com/phosphor-icons/core/blob/main/LICENSE"
    },
    {
        "id": "lia",
        "name": "Icons8 Line Awesome",
        "projectUrl": "https://icons8.com/line-awesome",
        "license": "MIT",
        "licenseUrl": "https://github.com/icons8/line-awesome/blob/master/LICENSE.md"
    }
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bl3gi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GenIcon", ()=>GenIcon);
parcelHelpers.export(exports, "IconBase", ()=>IconBase);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconContext = require("./iconContext");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function Tree2Element(tree) {
    return tree && tree.map(function(node, i) {
        return (0, _reactDefault.default).createElement(node.tag, __assign({
            key: i
        }, node.attr), Tree2Element(node.child));
    });
}
function GenIcon(data) {
    // eslint-disable-next-line react/display-name
    return function(props) {
        return (0, _reactDefault.default).createElement(IconBase, __assign({
            attr: __assign({}, data.attr)
        }, props), Tree2Element(data.child));
    };
}
function IconBase(props) {
    var elem = function(conf) {
        var attr = props.attr, size = props.size, title = props.title, svgProps = __rest(props, [
            "attr",
            "size",
            "title"
        ]);
        var computedSize = size || conf.size || "1em";
        var className;
        if (conf.className) className = conf.className;
        if (props.className) className = (className ? className + " " : "") + props.className;
        return (0, _reactDefault.default).createElement("svg", __assign({
            stroke: "currentColor",
            fill: "currentColor",
            strokeWidth: "0"
        }, conf.attr, attr, svgProps, {
            className: className,
            style: __assign(__assign({
                color: props.color || conf.color
            }, conf.style), props.style),
            height: computedSize,
            width: computedSize,
            xmlns: "http://www.w3.org/2000/svg"
        }), title && (0, _reactDefault.default).createElement("title", null, title), props.children);
    };
    return (0, _iconContext.IconContext) !== undefined ? (0, _reactDefault.default).createElement((0, _iconContext.IconContext).Consumer, null, function(conf) {
        return elem(conf);
    }) : elem((0, _iconContext.DefaultContext));
}

},{"react":"bmhQu","./iconContext":"3s4cv","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3s4cv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultContext", ()=>DefaultContext);
parcelHelpers.export(exports, "IconContext", ()=>IconContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var DefaultContext = {
    color: undefined,
    size: undefined,
    className: undefined,
    style: undefined,
    attr: undefined
};
var IconContext = (0, _reactDefault.default).createContext && (0, _reactDefault.default).createContext(DefaultContext);

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gO6o5":[function() {},{}],"kFIFN":[function(require,module,exports,__globalThis) {
require("e7d0a292a5bfa0b1");
var $gXNCa$reactjsxruntime = require("c9f03de0ba569521");
var $gXNCa$react = require("e89d20b5872a5a34");
var $gXNCa$reduxbundlerreact = require("978c1038e90119ae");
var $gXNCa$aggridreact = require("1e75c8e4bd80350f");
require("8c670c77c3902b26");
require("fd2565c03c812ea2");
var $gXNCa$reduxbundler = require("ddc0c789689ec264");
var $gXNCa$lodash = require("f23e227c2beb644b");
var $gXNCa$gramenebinsclientsrcbins = require("243990e7f07597f2");
var $gXNCa$gramenetreesclientsrctaxonomy = require("afe997b249302bb6");
var $gXNCa$gramenetaxonomywithgenomes = require("7e37e406131e2b9");
var $gXNCa$reactga4 = require("d05cd4993db952e4");
var $gXNCa$moneyclip = require("98ada56427b39cb7");
var $gXNCa$tbrowsecore = require("c7be13865a2f0df1");
var $gXNCa$reactbootstrap = require("bbfa21ab9725e386");
var $gXNCa$reactswitch = require("d5521c75564d5ef2");
var $gXNCa$reacticonsio5 = require("87384c95eacbeaed");
var $gXNCa$reacticonsbs = require("628fc015b8c107d2");
var $gXNCa$reacticonsgr = require("28ac795b361f60f5");
var $gXNCa$grameneatlasheatmap = require("4b819e34098f2807");
var $gXNCa$gramenegenetreevis = require("99e3139b84c8afee");
var $gXNCa$gramenetreesclientsrcgenetree = require("59e75aa0ecc3095d");
var $gXNCa$tbrowse = require("e3f2a74732da5a10");
var $gXNCa$reactdom = require("58bed9b292821059");
var $gXNCa$lodashkeyBy = require("6877b21f861aabf5");
var $gXNCa$reacticonsbi = require("cd587019a97f11ee");
var $gXNCa$firebaseapp = require("ebdae9af3c3da873");
var $gXNCa$lodashget = require("b09a191fa2cc6513");
var $gXNCa$lodashisEqual = require("94034ba8b5c45889");
var $gXNCa$flattonested = require("70c30999c7df9690");
var $gXNCa$reactsimpletreemenu = require("9b11fb3ef0bc37b4");
require("c4b0ab6bd95f1b3a");
var $gXNCa$gramenedbxrefs = require("6d94f96e8ccee4a");
var $gXNCa$reacticonsai = require("8e26fd7e2a676f75");
var $gXNCa$grameneprimers = require("e193ca30c5e93397");
var $gXNCa$gramenesearchvis = require("33855a8c778c869");
var $gXNCa$numeral = require("b556cdc66608631");
var $gXNCa$firebaseauth = require("e440e8344596123b");
var $gXNCa$d3 = require("30a913ab73bfc419");
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $parcel$global = globalThis;
var $parcel$modules = {};
var $parcel$inits = {};
var parcelRequire = $parcel$global["parcelRequire7a41"];
if (parcelRequire == null) {
    parcelRequire = function(id) {
        if (id in $parcel$modules) return $parcel$modules[id].exports;
        if (id in $parcel$inits) {
            var init = $parcel$inits[id];
            delete $parcel$inits[id];
            var module1 = {
                id: id,
                exports: {}
            };
            $parcel$modules[id] = module1;
            init.call(module1.exports, module1, module1.exports);
            return module1.exports;
        }
        var err = new Error("Cannot find module '" + id + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
    };
    parcelRequire.register = function register(id, init) {
        $parcel$inits[id] = init;
    };
    $parcel$global["parcelRequire7a41"] = parcelRequire;
}
var parcelRegister = parcelRequire.register;
parcelRegister("7zuJ6", function(module1, exports) {
    $parcel$defineInteropFlag(module1.exports);
    $parcel$export(module1.exports, "default", ()=>$5833a2eeefc77457$export$2e2bcd8739ae039);
    const $5833a2eeefc77457$var$metaRenderer = (params)=>{
        if (params.value.ontology) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("a", {
            href: `http://purl.obolibrary.org/obo/${params.value.id.replace(":", "_")}`,
            target: "_blank",
            children: params.value.label
        });
        return params.value.label;
    };
    const $5833a2eeefc77457$var$sampleRenderer = (params)=>{
        const sampleMeta = params.value;
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("label", {
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
                    type: "checkbox",
                    checked: params.desiredSamples.hasOwnProperty(sampleMeta._id),
                    onChange: ()=>params.doToggleExpressionSample(sampleMeta._id)
                }),
                "\xa0",
                sampleMeta.experiment,
                "-",
                sampleMeta.group
            ]
        });
    // return JSON.stringify(sampleMeta,null,2);
    };
    const $5833a2eeefc77457$var$connectedSampleRenderer = (0, $gXNCa$reduxbundlerreact.connect)('selectDesiredSamples', 'doToggleExpressionSample', $5833a2eeefc77457$var$sampleRenderer);
    const $5833a2eeefc77457$var$Study = (props)=>{
        let samples = props.expressionSamples[props.id];
        let sampleMetadata = [];
        let metadataFields = [
            {
                field: "sampleId",
                cellRenderer: $5833a2eeefc77457$var$connectedSampleRenderer
            }
        ];
        let isFactor = {};
        samples.forEach((sample, idx)=>{
            if (idx === 0) {
                let factors = {
                    headerName: 'Experimental Variables',
                    children: []
                };
                sample.factor.forEach((factor)=>{
                    factors.children.push({
                        field: factor.type,
                        cellRenderer: $5833a2eeefc77457$var$metaRenderer
                    });
                    isFactor[factor.type] = true;
                });
                metadataFields.push(factors);
                let characteristics = {
                    headerName: 'Sample Characteristics',
                    children: []
                };
                sample.characteristic.forEach((ch)=>{
                    if (!isFactor[ch.type]) characteristics.children.push({
                        field: ch.type,
                        cellRenderer: $5833a2eeefc77457$var$metaRenderer
                    });
                });
                metadataFields.push(characteristics);
            }
            let s_info = {
                sampleId: sample
            };
            sample.factor.forEach((factor)=>{
                s_info[factor.type] = {
                    label: factor.label
                };
                if (factor.ontology) {
                    s_info[factor.type]['ontology'] = factor.ontology;
                    s_info[factor.type]['id'] = factor.id;
                }
            });
            sample.characteristic.forEach((ch)=>{
                s_info[ch.type] = {
                    label: ch.label
                };
                if (ch.ontology) {
                    s_info[ch.type]['ontology'] = ch.ontology;
                    s_info[ch.type]['id'] = ch.id;
                }
            });
            sampleMetadata.push(s_info);
        });
        const [rowData, setRowData] = (0, $gXNCa$react.useState)(sampleMetadata);
        const [colDefs, setColDefs] = (0, $gXNCa$react.useState)(metadataFields);
        const defaultColDef = (0, $gXNCa$react.useMemo)(()=>{
            return {
                filter: true
            };
        }, []);
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                    className: "ag-theme-quartz",
                    style: {
                        height: `${44 * (samples.length + 2)}px`
                    },
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$aggridreact.AgGridReact, {
                        rowData: rowData,
                        columnDefs: colDefs,
                        defaultColDef: defaultColDef
                    })
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("a", {
                    href: `https://www.ebi.ac.uk/gxa/experiments/${props.id}`,
                    children: [
                        "EBI Atlas Experiment: ",
                        props.id
                    ]
                })
            ]
        });
    };
    var $5833a2eeefc77457$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)('selectExpressionSamples', $5833a2eeefc77457$var$Study);
});
$parcel$export(module.exports, "bundles", ()=>$5df6c55c1bef3469$export$2e2bcd8739ae039);
$parcel$export(module.exports, "resultList", ()=>$2fec4872fbf7ebd2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "resultSummary", ()=>$27617dbc24e7faf0$export$2e2bcd8739ae039);
$parcel$export(module.exports, "suggestions", ()=>$541b8b0d8c5501d2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Status", ()=>$693dd8c7a5607c3a$export$96e9906d6d93a972);
$parcel$export(module.exports, "Filters", ()=>$693dd8c7a5607c3a$export$92a576f896a9bf72);
$parcel$export(module.exports, "Facets", ()=>$7d7b7dad5e71dfd3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Results", ()=>$693dd8c7a5607c3a$export$4a34de49b46a2bfa);
$parcel$export(module.exports, "Views", ()=>$693dd8c7a5607c3a$export$5cb791131c501f6a);
$parcel$export(module.exports, "Auth", ()=>$c5d403787de8b05f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "bootViewFromUrl", ()=>$c69c61828e36a328$export$2e2bcd8739ae039);
// The API the gene Expression tab takes its studies from: configuration
// expressionApi when set, for a site whose own index has no expression studies
// or attributes but shares its genes (by id) with one that does, as Gramene
// Maize (maize_v5) does with Gramene's current release.
const $9d9aeaf9299e61a1$var$expressionApi = (store)=>{
    const cfg = store.selectConfiguration();
    return (cfg && cfg.expressionApi || store.selectGrameneAPI()).replace(/\/$/, '');
};
const $9d9aeaf9299e61a1$var$facets = [
    "{!facet.limit='300' facet.mincount='1' key='taxon_id'}taxon_id",
    // "{!facet.limit='100' facet.mincount='1' key='genetree'}gene_tree",
    // "{!facet.limit='100' facet.mincount='1' key='pathways'}pathways__ancestors",
    // "{!facet.limit='100' facet.mincount='1' key='domains'}domain_roots",
    "{!facet.limit='-1' facet.mincount='1' key='fixed_1000__bin'}fixed_1000__bin"
];
// In the no-filter state the TaxDist histogram is the global "all genes"
// distribution — it never changes for a given data release, so there's no
// point recomputing the bin facet on every page load.
const $9d9aeaf9299e61a1$var$noFilterFacets = [
    $9d9aeaf9299e61a1$var$facets[0]
];
const $9d9aeaf9299e61a1$var$genomesOfInterest = '(taxon_id:2769) OR (taxon_id:3055) OR (taxon_id:3218) OR (taxon_id:3702) OR (taxon_id:3847) OR (taxon_id:4555) OR (taxon_id:4558) OR (taxon_id:4577) OR (taxon_id:13333) OR (taxon_id:15368) OR (taxon_id:29760) OR (taxon_id:39947) OR (taxon_id:55577) OR (taxon_id:88036) OR (taxon_id:214687)';
const $9d9aeaf9299e61a1$var$sites = [
    'main',
    'oryza',
    'maize',
    'sorghum',
    'grapevine'
];
const $9d9aeaf9299e61a1$var$grameneSuggestions = (0, $gXNCa$reduxbundler.createAsyncResourceBundle)({
    name: 'grameneSuggestions',
    actionBaseType: 'GRAMENE_SUGGESTIONS',
    persist: false,
    getPromise: ({ store: store })=>{
        const t = store.selectSuggestionsQuery().replaceAll(':', ' ').trim();
        const g = store.selectGrameneGenomes();
        const q = `/suggest?q={!boost b=relevance}name:${t}^5 ids:${t}^5 ids:${t}*^3 synonym:${t}^3 synonym:${t}*^2 text:${t}*^1`;
        // const promises = sites.map(site => fetch(`https://data.gramene.org/${site}${q}`));
        // return Promise.all(promises)
        return fetch(store.selectGrameneAPI() + q).then((res)=>{
            return res.json();
        }).then((suggestions)=>{
            if (Object.keys(g.active).length > 0) suggestions.grouped.category.groups.forEach((group)=>{
                group.doclist.docs.forEach((sugg)=>{
                    sugg.num_genes = 0;
                    sugg.taxon_id.forEach((id, idx)=>{
                        if (g.active[id] && !g.active[id].hidden) sugg.num_genes += sugg.taxon_freq[idx];
                    });
                });
            });
            return suggestions;
        });
    }
});
$9d9aeaf9299e61a1$var$grameneSuggestions.reactGrameneSuggestions = (0, $gXNCa$reduxbundler.createSelector)('selectGrameneSuggestionsShouldUpdate', 'selectSuggestionsQuery', (shouldUpdate, queryString)=>{
    if (shouldUpdate && queryString) return {
        actionCreator: 'doFetchGrameneSuggestions'
    };
});
$9d9aeaf9299e61a1$var$grameneSuggestions.selectGrameneSuggestionsStatus = (0, $gXNCa$reduxbundler.createSelector)('selectGrameneSuggestionsShouldUpdate', 'selectGrameneSuggestionsIsLoading', 'selectGrameneSuggestionsRaw', 'selectSuggestionsQuery', (shouldUpdate, isLoading, suggestionsRaw, queryString)=>{
    if (!queryString) return '';
    if (shouldUpdate) return 'update needed';
    if (isLoading) return 'loading';
    if (suggestionsRaw.data) return suggestionsRaw.data.grouped.category.matches + ' terms';
    console.error(suggestionsRaw);
    return 'error';
});
$9d9aeaf9299e61a1$var$grameneSuggestions.selectGrameneSuggestionsReady = (0, $gXNCa$reduxbundler.createSelector)('selectGrameneSuggestionsStatus', (status)=>{
    const regex = RegExp('terms$');
    return regex.test(status);
});
$9d9aeaf9299e61a1$var$grameneSuggestions.doFocusFirstGrameneSuggestion = (arg)=>({ dispatch: dispatch, getState: getState })=>{
        console.log('inside doFocusFirstGrameneSuggestion');
    };
function $9d9aeaf9299e61a1$var$compressLongTaxonName(node) {
    const fullName = node.name;
    const removedExtraineousWords = fullName.replace(/( Group$| subsp\.| ssp\.| var\.| strain)/, '');
    let finalVersion;
    if (removedExtraineousWords.length > 20) {
        let words = removedExtraineousWords.split(' ');
        if (words.length === 2) finalVersion = removedExtraineousWords.replace(/^([A-Z])[a-z]+/, '$1.');
        if (words.length > 2) finalVersion = removedExtraineousWords.replace(/^([A-Z])[a-z]+\s([a-z])[a-z]+/, '$1$2.');
    } else finalVersion = removedExtraineousWords;
    node.short_name = finalVersion;
}
const $9d9aeaf9299e61a1$var$grameneTaxonomy = (0, $gXNCa$reduxbundler.createAsyncResourceBundle)({
    name: 'grameneTaxonomy',
    actionBaseType: 'GRAMENE_TAXONOMY',
    persist: true,
    staleAfter: 86400000,
    getPromise: ({ store: store })=>{
        return fetch(`${store.selectGrameneAPI()}/taxonomy?subset=gramene&rows=-1`).then((res)=>$9d9aeaf9299e61a1$var$okJson(res, 'taxonomy')).then((rows)=>$9d9aeaf9299e61a1$var$nonEmptyList(rows, 'taxonomy')).then((taxNodes)=>{
            let taxonomy = $parcel$interopDefault($gXNCa$lodash).keyBy(taxNodes, '_id');
            taxNodes.forEach((t)=>{
                t._id = +t._id; // ensure taxonomy id is a number
                $9d9aeaf9299e61a1$var$compressLongTaxonName(t);
                if (t.hasOwnProperty("is_a")) t.is_a.forEach((p_id)=>{
                    const p = taxonomy[p_id];
                    if (!p.hasOwnProperty('children')) p.children = [];
                    p.children.push(t._id);
                });
            });
            return taxonomy;
        });
    }
});
$9d9aeaf9299e61a1$var$grameneTaxonomy.reactGrameneTaxonomy = (0, $gXNCa$reduxbundler.createSelector)('selectGrameneTaxonomyShouldUpdate', (shouldUpdate)=>{
    if (shouldUpdate) return {
        actionCreator: 'doFetchGrameneTaxonomy'
    };
});
// A proxy hiccup can answer with a non-2xx status, or with 200 and an empty
// list, and `res.json()` happily parses both. createAsyncResourceBundle would
// then record a *success* with empty data and stamp lastSuccess, so with
// staleAfter of 24h the client keeps believing it has genomes/taxonomy for a
// whole day. Downstream that surfaces as "No genome found for {}" and a hard
// "Bin count mismatch!" from gramene-bins-client. Throwing instead lets the
// bundle record an error and retry.
function $9d9aeaf9299e61a1$var$okJson(res, what) {
    if (!res.ok) throw new Error(`${what} failed (${res.status})`);
    return res.json();
}
function $9d9aeaf9299e61a1$var$nonEmptyList(rows, what) {
    if (!Array.isArray(rows) || rows.length === 0) throw new Error(`${what} returned no rows`);
    return rows;
}
const $9d9aeaf9299e61a1$var$grameneMaps = (0, $gXNCa$reduxbundler.createAsyncResourceBundle)({
    name: 'grameneMaps',
    actionBaseType: 'GRAMENE_MAPS',
    persist: true,
    staleAfter: 86400000,
    getPromise: ({ store: store })=>{
        return fetch(`${store.selectGrameneAPI()}/maps?rows=-1`).then((res)=>$9d9aeaf9299e61a1$var$okJson(res, 'maps')).then((rows)=>$9d9aeaf9299e61a1$var$nonEmptyList(rows, 'maps')).then((maps)=>{
            maps.forEach((m)=>{
                m.regionLength = {};
                m.regions.names.forEach((rname, idx)=>{
                    m.regionLength[rname] = m.regions.lengths[idx];
                });
            });
            return $parcel$interopDefault($gXNCa$lodash).keyBy(maps, 'taxon_id');
        });
    }
});
$9d9aeaf9299e61a1$var$grameneMaps.reactGrameneMaps = (0, $gXNCa$reduxbundler.createSelector)('selectGrameneMapsShouldUpdate', (shouldUpdate)=>{
    if (shouldUpdate) return {
        actionCreator: 'doFetchGrameneMaps'
    };
});
/**
 * The site's reference genome, derived from /maps rather than configured per site.
 *
 * `is_anchor` marks the reference genome of a species group and `anchor_taxon_id`
 * is that group's bare species id. Note the two are deliberately different scales:
 * an anchor's own taxon_id is genome-level (4558006) and never equals its
 * anchor_taxon_id (4558), so the anchor is found by group, not by matching ids.
 *
 * A deployment is whichever group it carries the most genomes for — sorghum_v11
 * has 120 of 128 genomes under 4558, whose anchor is 4558006 (Sb bicolor BTx623
 * v3). Deriving it this way keeps every site correct across releases; the value
 * that used to be configured had drifted to 4558001, a non-anchor wild relative
 * (Sb verticilliflorum 353).
 *
 * Returns null in two cases callers must tolerate: before /maps has loaded, and
 * on a release whose /maps carries no anchor fields at all — gramene main is like
 * that today (114 genomes, not one with is_anchor), so that deployment simply has
 * no reference genome rather than a wrong one.
 *
 * Verified across deployments: sorghum 4558006 (Sb bicolor BTx623 v3),
 * oryza 39947013 and maize 4577003 (both Nipponbare / B73 v5). The genome-level
 * id differs per release, which is the reason to resolve it rather than pin it.
 */ $9d9aeaf9299e61a1$var$grameneMaps.selectTargetTaxonId = (0, $gXNCa$reduxbundler.createSelector)('selectGrameneMaps', (grameneMaps)=>{
    if (!grameneMaps) return null;
    const genomes = Object.values(grameneMaps);
    if (!genomes.length) return null;
    const perGroup = {};
    genomes.forEach((g)=>{
        if (!g || g.anchor_taxon_id === undefined || g.anchor_taxon_id === null) return;
        const k = String(g.anchor_taxon_id);
        perGroup[k] = (perGroup[k] || 0) + 1;
    });
    let group = null;
    let best = -1;
    Object.keys(perGroup).forEach((k)=>{
        if (perGroup[k] > best) {
            best = perGroup[k];
            group = k;
        }
    });
    if (group === null) return null;
    const anchor = genomes.find((g)=>g && g.is_anchor && String(g.anchor_taxon_id) === group);
    return anchor ? anchor.taxon_id : null;
});
const $9d9aeaf9299e61a1$var$expressionStudies = (0, $gXNCa$reduxbundler.createAsyncResourceBundle)({
    name: 'expressionStudies',
    actionBaseType: 'EXPRESSION_STUDIES',
    persist: true,
    staleAfter: 86400000,
    getPromise: ({ store: store })=>{
        return fetch(`${$9d9aeaf9299e61a1$var$expressionApi(store)}/experiments?rows=-1`).then((res)=>res.json()).then((res)=>$parcel$interopDefault($gXNCa$lodash).groupBy(res, 'taxon_id'));
    }
});
// Only fetch when a view that consumes expression studies is enabled.
const $9d9aeaf9299e61a1$var$EXPRESSION_VIEWS = [
    'exprViz',
    'expression',
    'export'
];
$9d9aeaf9299e61a1$var$expressionStudies.reactExpressionStudies = (0, $gXNCa$reduxbundler.createSelector)('selectExpressionStudiesShouldUpdate', 'selectGrameneViewsOn', (shouldUpdate, viewsOn)=>{
    if (!shouldUpdate) return;
    if (!viewsOn || !$9d9aeaf9299e61a1$var$EXPRESSION_VIEWS.some((id)=>viewsOn.has(id))) return;
    return {
        actionCreator: 'doFetchExpressionStudies'
    };
});
const $9d9aeaf9299e61a1$var$expressionSamples = (0, $gXNCa$reduxbundler.createAsyncResourceBundle)({
    name: 'expressionSamples',
    actionBaseType: 'EXPRESSION_SAMPLES',
    persist: true,
    staleAfter: 86400000,
    getPromise: ({ store: store })=>{
        return fetch(`${store.selectGrameneAPI()}/assays?rows=-1`).then((res)=>res.json()).then((samples)=>$parcel$interopDefault($gXNCa$lodash).groupBy(samples, 'experiment')).then((studies)=>{
            Object.keys(studies).forEach((study)=>{
                studies[study].forEach((sample)=>{
                    sample.order = +sample.group.replace('g', '');
                });
                studies[study].sort((a, b)=>a.order - b.order);
            });
            return studies;
        });
    }
});
$9d9aeaf9299e61a1$var$expressionSamples.reactExpressionSamples = (0, $gXNCa$reduxbundler.createSelector)('selectExpressionSamplesShouldUpdate', 'selectGrameneViewsOn', (shouldUpdate, viewsOn)=>{
    if (!shouldUpdate) return;
    if (!viewsOn || !$9d9aeaf9299e61a1$var$EXPRESSION_VIEWS.some((id)=>viewsOn.has(id))) return;
    return {
        actionCreator: 'doFetchExpressionSamples'
    };
});
const $9d9aeaf9299e61a1$var$grameneGermplasm = (0, $gXNCa$reduxbundler.createAsyncResourceBundle)({
    name: 'grameneGermplasm',
    actionBaseType: 'GRAMENE_GERMPLASM',
    persist: true,
    staleAfter: 86400000,
    getPromise: ({ store: store })=>{
        return fetch(`${store.selectGrameneAPI()}/germplasm?rows=-1`).then((res)=>res.json()).then((res)=>{
            res.forEach((g)=>{
                if (!g.subpop) g.subpop = "?";
            });
            return $parcel$interopDefault($gXNCa$lodash).groupBy(res, 'ens_id');
        });
    }
});
// Germplasm metadata is consumed by the VEP detail panel inside the gene list.
$9d9aeaf9299e61a1$var$grameneGermplasm.reactGrameneGermplasm = (0, $gXNCa$reduxbundler.createSelector)('selectGrameneGermplasmShouldUpdate', 'selectGrameneViewsOn', (shouldUpdate, viewsOn)=>{
    if (!shouldUpdate) return;
    if (!viewsOn || !viewsOn.has('list')) return;
    return {
        actionCreator: 'doFetchGrameneGermplasm'
    };
});
//
// const grameneExpressionAssays = createAsyncResourceBundle( {
//   name: 'grameneExpressionAssays',
//   actionBaseType: 'GRAMENE_EXPRESSION_ASSAYS',
//   persist: true,
//   getPromise: ({store}) => {
//     return fetch(`${store.selectGrameneAPI()}/assays?rows=-1`)
//       .then(res => res.json())
//       .then(res => {
//         let expr={};
//         res.forEach(assay => {
//           if (!expr.hasOwnProperty(assay.taxon_id)) {
//             expr[assay.taxon_id] = {};
//           }
//           if (!expr[assay.taxon_id].hasOwnProperty(assay.experiment)) {
//             expr[assay.taxon_id][assay.experiment] = [];
//           }
//           assay.order = +assay.group.replace('g','');
//           expr[assay.taxon_id][assay.experiment].push(assay);
//         });
//         // sort each experiment
//         for (const tid in expr) {
//           for (const exp in expr[tid]) {
//             expr[tid][exp].sort((a,b) => a.order - b.order);
//           }
//         }
//         return expr;
//       })
//   }
// });
// grameneExpressionAssays.reactGrameneExpressionAssays = createSelector(
//   'selectGrameneExpressionAssaysShouldUpdate',
//   (shouldUpdate) => {
//     if (shouldUpdate) {
//       return { actionCreator: 'doFetchGrameneExpressionAssays' }
//     }
//   }
// );
const $9d9aeaf9299e61a1$var$MAKERAttribs = [
    'MAKER__AED__attr_f',
    'MAKER__QI1__attr_i',
    'MAKER__QI2__attr_f',
    'MAKER__QI3__attr_f',
    'MAKER__QI4__attr_f',
    'MAKER__QI5__attr_f',
    'MAKER__QI6__attr_f',
    'MAKER__QI7__attr_i',
    'MAKER__QI8__attr_i',
    'MAKER__QI9__attr_i'
];
const $9d9aeaf9299e61a1$var$geneAttribs = {
    "MAKER transcript metrics": [
        {
            name: "AED",
            description: "Annotation Edit Distance",
            dtype: "f",
            fieldName: "MAKER__AED__attr_f"
        },
        {
            name: "QI1",
            description: "Length of the 5' UTR",
            dtype: "i",
            fieldName: "MAKER__QI1__attr_i"
        },
        {
            name: "QI2",
            description: "Fraction of splice sites confirmed by an EST alignment",
            dtype: "f",
            fieldName: "MAKER__QI2__attr_f"
        },
        {
            name: "QI3",
            description: "Fraction of exons that overlap an EST alignment",
            dtype: "f",
            fieldName: "MAKER__QI3__attr_f"
        },
        {
            name: "QI4",
            description: "Fraction of exons that overlap EST or Protein alignments",
            dtype: "f",
            fieldName: "MAKER__QI4__attr_f"
        },
        // { name: "QI5", description: "Fraction of splice sites confirmed by a SNAP prediction", dtype: "f", fieldName: "MAKER__QI5__attr_f" },
        // { name: "QI6", description: "Fraction of exons that overlap a SNAP prediction", dtype: "f", fieldName: "MAKER__QI6__attr_f" },
        {
            name: "QI7",
            description: "Number of exons in the mRNA",
            dtype: "i",
            fieldName: "MAKER__QI7__attr_i"
        },
        {
            name: "QI8",
            description: "Length of the 3' UTR",
            dtype: "i",
            fieldName: "MAKER__QI8__attr_i"
        },
        {
            name: "QI9",
            description: "Length of the protein sequence produced by the mRNA",
            dtype: "i",
            fieldName: "MAKER__QI9__attr_i"
        }
    ]
};
const $9d9aeaf9299e61a1$var$statsFields = $9d9aeaf9299e61a1$var$geneAttribs['MAKER transcript metrics'].map((f)=>`stats.field={!min=true max=true count=true mean=true stddev=true percentiles='10,20,30,40,50,60,70,80,90,99.99'}${f.fieldName}`);
const $9d9aeaf9299e61a1$var$grameneGeneAttribs = (0, $gXNCa$reduxbundler.createAsyncResourceBundle)({
    name: 'grameneGeneAttribs',
    actionBaseType: 'GRAMENE_GENE_ATTRIBS',
    persist: false,
    getPromise: ({ store: store })=>{
        return fetch(`${store.selectGrameneAPI()}/geneAttributes`).then((res)=>$9d9aeaf9299e61a1$var$geneAttribs);
    }
});
$9d9aeaf9299e61a1$var$grameneGeneAttribs.reactGrameneGeneAttribs = (0, $gXNCa$reduxbundler.createSelector)('selectGrameneGeneAttribsShouldUpdate', 'selectGrameneFiltersStatus', 'selectGrameneViewsOn', (shouldUpdate, status, viewsOn)=>{
    if (!shouldUpdate) return;
    if (status !== 'finished' && status !== 'ready') return;
    if (!viewsOn || !viewsOn.has('attribs')) return;
    return {
        actionCreator: 'doFetchGrameneGeneAttribs'
    };
});
const $9d9aeaf9299e61a1$var$grameneSearch = (0, $gXNCa$reduxbundler.createAsyncResourceBundle)({
    name: 'grameneSearch',
    actionBaseType: 'GRAMENE_SEARCH',
    persist: false,
    getPromise: ({ store: store })=>{
        const offset = store.selectGrameneSearchOffset();
        const rows = store.selectGrameneSearchRows();
        const g = store.selectGrameneGenomes();
        const m = store.selectGrameneMaps() || {};
        // Visible (non-hidden) genomes — the universe the user can browse.
        const visibleTaxa = Object.keys(m).filter((tid)=>!m[tid].hidden);
        // What's actually toggled on. `active` is seeded with every map key
        // when maps load, so by default activeVisible === visibleTaxa.
        const activeVisible = Object.keys(g && g.active || {}).filter((tid)=>m[tid] && !m[tid].hidden);
        // Only send fq=taxon_id:(...) when the user has actually subset the
        // genomes. Sending the full visible list would just bloat the URL and
        // fragment the upstream cache per site. Hidden-genome contributions
        // are stripped from the response below instead.
        const userSubsetGenomes = activeVisible.length > 0 && activeVisible.length < visibleTaxa.length;
        const fq = userSubsetGenomes ? `&fq=taxon_id:(${activeVisible.join(' OR ')})` : '';
        const q = store.selectGrameneFiltersQueryString();
        const noFilters = q === '*:*' && !userSubsetGenomes;
        const effectiveRows = noFilters ? 0 : rows;
        const facetField = noFilters ? $9d9aeaf9299e61a1$var$noFilterFacets : $9d9aeaf9299e61a1$var$facets;
        // Set of taxon_ids the UI knows about — keep only these in the response.
        // Anything else (hidden taxa, or taxa that exist in Solr but not in this
        // site's maps collection) is stripped so downstream consumers — notably
        // the TaxDist Vis which throws on unknown tids — see a clean visible-only
        // view. Mirrors the old server-side `fq=taxon_id:(visible)` behavior.
        const visibleTaxaSet = new Set(visibleTaxa);
        // return fetch(`${store.selectGrameneAPI()}/search?q=${q}&facet.field=${facetField}&rows=${effectiveRows}&start=${offset}${fq}&stats=true&${statsFields.join('&')}`)
        return fetch(`${store.selectGrameneAPI()}/search?q=${q}&facet.field=${facetField}&rows=${effectiveRows}&start=${offset}${fq}`).then((res)=>res.json()).then((res)=>{
            if (visibleTaxaSet.size && res.facet_counts && res.facet_counts.facet_fields) {
                const tf = res.facet_counts.facet_fields.taxon_id;
                if (Array.isArray(tf)) {
                    let droppedGeneCount = 0;
                    const kept = [];
                    for(let i = 0; i < tf.length; i += 2)if (visibleTaxaSet.has(String(tf[i]))) kept.push(tf[i], tf[i + 1]);
                    else droppedGeneCount += tf[i + 1];
                    res.facet_counts.facet_fields.taxon_id = kept;
                    if (res.response) {
                        res.response.numFound = Math.max(0, res.response.numFound - droppedGeneCount);
                        if (Array.isArray(res.response.docs)) res.response.docs = res.response.docs.filter((d)=>visibleTaxaSet.has(String(d.taxon_id)));
                    }
                }
            }
            if (res.response && Array.isArray(res.response.docs)) res.response.docs.forEach((d)=>{
                d.can_show = {};
                d.capabilities.forEach((c)=>{
                    d.can_show[c] = true;
                });
            });
            return res;
        });
    }
});
$9d9aeaf9299e61a1$var$grameneSearch.reactGrameneSearch = (0, $gXNCa$reduxbundler.createSelector)('selectGrameneSearchShouldUpdate', 'selectGrameneFiltersStatus', 'selectGrameneGenomes', (shouldUpdate, status, genomes)=>{
    if (shouldUpdate && status === 'search' && genomes) return {
        actionCreator: 'doFetchGrameneSearch'
    };
});
function $9d9aeaf9299e61a1$var$formatFacetCountsForViz(a) {
    let res = {
        count: a.length / 2,
        displayName: "fixed_1000__bin",
        data: {},
        sorted: []
    };
    let counts = [];
    for(let i = 0; i < a.length; i += 2){
        const fc = {
            id: +a[i],
            count: +a[i + 1]
        };
        res.data[a[i]] = fc;
        counts.push(fc);
    }
    res.sorted = counts.sort((a, b)=>a.id - b.id);
    return res;
}
// bundle to prepare data for the TaxDist component
const $9d9aeaf9299e61a1$var$grameneTaxDist = {
    name: 'grameneTaxDist',
    getReducer: ()=>{
        const initialState = {};
        return (state = initialState, { type: type, payload: payload })=>{
            return state;
        };
    },
    selectGrameneTaxDist: (0, $gXNCa$reduxbundler.createSelector)('selectGrameneSearch', 'selectGrameneTaxonomy', 'selectGrameneMaps', (grameneSearch, grameneTaxonomy, grameneMaps)=>{
        // The bin facet can be absent during a saved-view restore (a search is
        // present but its faceted response with `fixed_1000__bin` hasn't landed
        // yet, or a non-faceted search is transiently in state). Bail to null
        // until it's there rather than crashing on `a.length`.
        const binFacet = grameneSearch && grameneSearch.facet_counts && grameneSearch.facet_counts.facet_fields && grameneSearch.facet_counts.facet_fields.fixed_1000__bin;
        // Object.keys guards matter here: an empty {} is truthy, and building the
        // bin mapper from one throws "Bin count mismatch!" and takes the page down.
        if (binFacet && grameneTaxonomy && Object.keys(grameneTaxonomy).length && grameneMaps && Object.keys(grameneMaps).length) {
            $parcel$interopDefault($gXNCa$lodash).forIn(grameneMaps, (map, tid)=>{
                if (grameneTaxonomy[tid]) grameneTaxonomy[tid].name = map.display_name;
            });
            const binnedResults = $9d9aeaf9299e61a1$var$formatFacetCountsForViz(binFacet);
            let speciesTree = $parcel$interopDefault($gXNCa$gramenetreesclientsrctaxonomy).tree(Object.values(grameneTaxonomy));
            let binMapper = $parcel$interopDefault($gXNCa$gramenebinsclientsrcbins)(grameneMaps);
            let taxDist = (0, $gXNCa$gramenetaxonomywithgenomes.build)(binMapper, speciesTree);
            taxDist.setBinType('fixed', 1000);
            taxDist.setResults(binnedResults);
            return taxDist;
        }
        return null;
    })
};
const $9d9aeaf9299e61a1$var$grameneParalogs = {
    name: 'grameneParalogs',
    getReducer: ()=>{
        const initialState = {};
        return (state = initialState, { type: type, payload: payload })=>{
            let newState;
            switch(type){
                case 'GRAMENE_PARALOGS_REQUESTED':
                    if (!state.hasOwnProperty(payload)) {
                        newState = Object.assign({}, state);
                        newState[payload] = [];
                        return newState;
                    }
                    break;
                case 'GRAMENE_PARALOGS_RECEIVED':
                    return Object.assign({}, state, payload);
            }
            return state;
        };
    },
    doRequestParalogs: (geneId, supertree, taxon_id)=>({ dispatch: dispatch, store: store })=>{
            const paralogs = store.selectGrameneParalogs();
            if (!paralogs.hasOwnProperty(geneId)) {
                dispatch({
                    type: 'GRAMENE_PARALOGS_REQUESTED',
                    payload: geneId
                });
                const API = store.selectGrameneAPI();
                const q = supertree ? `supertree_attr_s:${supertree}` : `homology__within_species_paralog:${geneId}`;
                fetch(`${API}/search?q=${q}&rows=1000&fq=taxon_id:${taxon_id}`).then((res)=>res.json()).then((res)=>{
                    let newParalogs = {};
                    newParalogs[geneId] = res.response.numFound > 0 ? res.response.docs.map((d)=>d.id) : [
                        geneId
                    ];
                    dispatch({
                        type: 'GRAMENE_PARALOGS_RECEIVED',
                        payload: newParalogs
                    });
                });
            }
        },
    selectGrameneParalogs: (state)=>state.grameneParalogs
};
// The GXA studies each gene is expressed in (Solr's expressed_in_gxa_attr_ss,
// e.g. ['E-MTAB-3839', 'JGI-SB-2']), keyed by gene id. The search results do
// not carry the field (it is not among /search's default fields), so the
// Expression tab asks for it gene by gene. Each entry is {pending: true} while
// the request is out, then {studies: [...]}, or {studies: null} when the
// request failed (asked again next time) or the gene's doc lacks the field:
// older indexes (e.g. maize_v5) never carry it, so its absence can't be read
// as "in no study". A site with an expressionApi asks that instead.
const $9d9aeaf9299e61a1$var$grameneGeneStudies = {
    name: 'grameneGeneStudies',
    getReducer: ()=>(state = {}, { type: type, payload: payload })=>{
            switch(type){
                case 'GRAMENE_GENE_STUDIES_REQUESTED':
                    return {
                        ...state,
                        [payload]: {
                            pending: true
                        }
                    };
                case 'GRAMENE_GENE_STUDIES_RECEIVED':
                    return {
                        ...state,
                        [payload.geneId]: {
                            studies: payload.studies
                        }
                    };
                case 'GRAMENE_GENE_STUDIES_FAILED':
                    return {
                        ...state,
                        [payload]: {
                            studies: null
                        }
                    };
                default:
                    return state;
            }
        },
    doRequestGeneStudies: (geneId)=>({ dispatch: dispatch, store: store })=>{
            const known = store.selectGrameneGeneStudies()[geneId];
            if (known && (known.pending || known.studies)) return;
            dispatch({
                type: 'GRAMENE_GENE_STUDIES_REQUESTED',
                payload: geneId
            });
            const q = encodeURIComponent(`id:"${geneId}"`);
            fetch(`${$9d9aeaf9299e61a1$var$expressionApi(store)}/search?q=${q}&fl=id,expressed_in_gxa_attr_ss&rows=1`).then((res)=>{
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                return res.json();
            }).then((res)=>{
                const doc = res.response.docs.find((d)=>d.id === geneId);
                const studies = doc && doc.expressed_in_gxa_attr_ss || null;
                dispatch({
                    type: 'GRAMENE_GENE_STUDIES_RECEIVED',
                    payload: {
                        geneId: geneId,
                        studies: studies
                    }
                });
            }).catch(()=>dispatch({
                    type: 'GRAMENE_GENE_STUDIES_FAILED',
                    payload: geneId
                }));
        },
    selectGrameneGeneStudies: (state)=>state.grameneGeneStudies
};
var //   const path = `grameneGenes.data.facet_counts.facet_fields.${field}`;
//   if (_.has(store,path)) {
//     const flat_facets = _.get(store,path);
//     let idList = [];
//     if (isNaN(+flat_facets[0])) {
//       for (let i = 0; i < flat_facets.length; i += 2) {
//         idList.push(flat_facets[i])
//       }
//     }
//     else {
//       for (let i = 0; i < flat_facets.length; i += 2) {
//         idList.push(+flat_facets[i])
//       }
//       if (idList.length === 1) idList.push(0);
//     }
//     return idList;
//   }
// }
//
// grameneGenes.selectDomainFacets = store => selectFacetIDs(store, 'domains');
// grameneGenes.selectPathwayFacets = store => selectFacetIDs(store, 'pathways');
// grameneGenes.selectTaxonomyFacets = store => selectFacetIDs(store, 'taxon_id');
//
// const grameneDomains = createAsyncResourceBundle({
//   name: 'grameneDomains',
//   actionBaseType: 'GRAMENE_DOMAINS',
//   persist: false,
//   getPromise: ({store}) =>
//     fetch(`${store.selectGrameneAPI()}/domains?rows=-1&idList=${store.selectDomainFacets().join(',')}`)
//       .then(res => res.json())
//       .then(docs => {return {domains: docs, numFound: docs.length}})
// });
//
// const gramenePathways = createAsyncResourceBundle({
//   name: 'gramenePathways',
//   actionBaseType: 'GRAMENE_PATHWAYS',
//   persist: false,
//   getPromise: ({store}) =>
//     fetch(`${store.selectGrameneAPI()}/pathways?rows=-1&idList=${store.selectPathwayFacets().join(',')}`)
//       .then(res => res.json())
//       .then(docs => {return {pathways: docs, numFound: docs.length}})
// });
//
// const grameneTaxonomy = createAsyncResourceBundle({
//   name: 'grameneTaxonomy',
//   actionBaseType: 'GRAMENE_TAXONOMY',
//   persist: false,
//   getPromise: ({store}) =>
//     fetch(`${store.selectGrameneAPI()}/taxonomy?rows=-1&idList=${store.selectTaxonomyFacets().join(',')}`)
//       .then(res => res.json())
//       .then(docs => {return {taxonomy: docs, numFound: docs.length}})
// });
$9d9aeaf9299e61a1$export$2e2bcd8739ae039 = [
    $9d9aeaf9299e61a1$var$grameneSuggestions,
    $9d9aeaf9299e61a1$var$grameneSearch,
    $9d9aeaf9299e61a1$var$grameneGeneAttribs,
    $9d9aeaf9299e61a1$var$grameneMaps,
    $9d9aeaf9299e61a1$var$grameneTaxonomy,
    $9d9aeaf9299e61a1$var$grameneTaxDist,
    $9d9aeaf9299e61a1$var$grameneParalogs,
    $9d9aeaf9299e61a1$var$grameneGeneStudies,
    $9d9aeaf9299e61a1$var$grameneGermplasm,
    $9d9aeaf9299e61a1$var$expressionSamples,
    $9d9aeaf9299e61a1$var$expressionStudies
];
const $af4441dd29af05df$var$MAX_IDLIST_LENGTH = 20;
function $af4441dd29af05df$var$findNodeWithLeftIdx(node, idx) {
    if (node.leftIdx === idx) return node;
    let result = null;
    if (node.leftIdx < idx && node.hasOwnProperty('children')) node.children.forEach((child)=>{
        if (child.rightIdx > idx) {
            child.parentIdx = node.leftIdx;
            const res = $af4441dd29af05df$var$findNodeWithLeftIdx(child, idx);
            if (res) result = res;
        }
    });
    return result;
}
function $af4441dd29af05df$var$markSubtree(node, source, invert) {
    node.marked = node.leftIdx >= source.leftIdx && node.rightIdx <= source.rightIdx;
    if (invert) node.marked = !node.marked;
    if (node.hasOwnProperty('children')) node.children.forEach((child)=>{
        $af4441dd29af05df$var$markSubtree(child, source, invert);
    });
}
const $af4441dd29af05df$export$6b95404109a3e2ec = 'Genomic intervals';
function $af4441dd29af05df$export$634f7214da1b780a({ map: map, region: region, start: start, end: end }) {
    return `(map:${map} AND region:${region}` + ` AND start:[* TO ${end}] AND end:[${start} TO *])`;
}
function $af4441dd29af05df$export$535c09441f37845d({ mapLabel: mapLabel, map: map, region: region, start: start, end: end }) {
    return `${mapLabel || map} ${region}:${Number(start).toLocaleString()}-${Number(end).toLocaleString()}`;
}
// Note the field order is inverted relative to the interval: `start` carries the
// interval's END and `end` carries its START, because the pair is an overlap test.
const $af4441dd29af05df$var$INTERVAL_RE = /^\(map:(\S+) AND region:(\S+) AND start:\[\* TO (\d+)\] AND end:\[(\d+) TO \*\]\)$/;
function $af4441dd29af05df$export$67920d3e3cb3f136(fqValue) {
    const m = $af4441dd29af05df$var$INTERVAL_RE.exec(String(fqValue || ''));
    if (!m) return null;
    return {
        map: m[1],
        region: m[2],
        end: Number(m[3]),
        start: Number(m[4])
    };
}
/** `[lo TO hi]`, as produced by the expression brush and the Location tab. */ const $af4441dd29af05df$var$RANGE_RE = /^\[\s*(\S+)\s+TO\s+(\S+)\s*\]$/;
function $af4441dd29af05df$export$9ee0ceaa589fc567(fqValue) {
    const m = $af4441dd29af05df$var$RANGE_RE.exec(String(fqValue || ''));
    return m ? {
        lo: m[1],
        hi: m[2]
    } : null;
}
function $af4441dd29af05df$export$cd9b2ffd001c6d65(lo, hi) {
    return `[${lo} TO ${hi}]`;
}
function $af4441dd29af05df$export$a7f4fa59930e5088(node) {
    if (!node || node.hasOwnProperty('children')) return null;
    if ($af4441dd29af05df$export$67920d3e3cb3f136(node.fq_value)) return 'interval';
    if ($af4441dd29af05df$export$9ee0ceaa589fc567(node.fq_value)) return 'range';
    return 'value';
}
const $af4441dd29af05df$export$da3188ffd2da2525 = {
    orthologs: {
        label: 'orthologs',
        // Edge fields: a seed gene's homology__all_orthologs values are the ids of its
        // orthologs. Same field already queried directly in bundles/api.js.
        from: 'homology__all_orthologs',
        to: 'id'
    },
    paralogs: {
        label: 'paralogs',
        // Within-species, so this stays inside the seed's own genome — a much smaller
        // expansion than orthologs (11 vs 70 for msd2).
        from: 'homology__within_species_paralog',
        to: 'id'
    },
    neighborhood: {
        label: "neighborhood (\xb110)",
        // Same edge pair TBrowse walks for its neighborhood zone (see
        // components/results/details/Homology.js). Unlike the homology fields these are
        // numeric: a gene's compara_neighbors_10 lists the compara_idx values of the 10
        // genes either side, matched against compara_idx_multi on the target. TBrowse
        // omits returnRoot, which Solr defaults to true — the same as every expansion
        // here — so a seed gene expands to 21: itself plus 20 neighbours.
        from: 'compara_neighbors_10',
        to: 'compara_idx_multi'
    }
};
function $af4441dd29af05df$export$a6dc3fef1cecdf28(node) {
    const type = node && node.expand;
    return typeof type === 'string' && type ? type : null;
}
function $af4441dd29af05df$export$c8b6102be216752a(token) {
    return String(token).replace(/[^A-Za-z0-9_-]/g, '-');
}
function $af4441dd29af05df$export$fb4df7b076406c76(subquery) {
    return String(subquery).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
}
function $af4441dd29af05df$export$90cfa1f3fbcb6430(node) {
    const type = $af4441dd29af05df$export$a6dc3fef1cecdf28(node);
    if (!type) return null;
    const spec = $af4441dd29af05df$export$da3188ffd2da2525[type];
    return `EXPAND: ${spec ? spec.label : type}`;
}
function $af4441dd29af05df$var$reindexTree(node, idx) {
    node.leftIdx = idx;
    idx++;
    if (node.hasOwnProperty('children')) node.children.forEach((child)=>{
        idx = $af4441dd29af05df$var$reindexTree(child, idx);
    });
    node.rightIdx = idx;
    idx++;
    return idx;
}
const $af4441dd29af05df$var$grameneFilters = {
    name: 'grameneFilters',
    getReducer: ()=>{
        const initialState = {
            status: 'init',
            operation: 'AND',
            negate: false,
            marked: false,
            leftIdx: 0,
            rightIdx: 1,
            children: [],
            showMarked: false,
            showMenu: false,
            moveCopyMode: '',
            searchOffset: 0,
            rows: 20
        };
        return (state = initialState, { type: type, payload: payload })=>{
            let newState;
            switch(type){
                case 'GRAMENE_FILTERS_CLEARED':
                    newState = Object.assign({}, initialState, {
                        status: 'search',
                        children: []
                    });
                    return newState;
                case 'GRAMENE_FILTER_ADDED':
                    {
                        const idx = state.rightIdx;
                        newState = Object.assign({}, state, {
                            status: 'search',
                            showMarked: true,
                            rightIdx: idx + 2,
                            searchOffset: 0
                        });
                        let child = $parcel$interopDefault($gXNCa$lodash).pick(payload, [
                            'fq_field',
                            'fq_value',
                            'name',
                            'category'
                        ]);
                        child.leftIdx = idx;
                        child.rightIdx = idx + 1;
                        child.negate = false;
                        child.showMenu = false;
                        newState.children.push(child);
                        $af4441dd29af05df$var$markSubtree(newState, child, false);
                        return newState;
                    }
                case 'GRAMENE_FILTER_TREE_ADDED':
                    newState = Object.assign({}, state, {
                        status: 'search',
                        showMarked: true,
                        rightIdx: payload.rightIdx + 1,
                        searchOffset: 0
                    });
                    newState.children.push(payload);
                    $af4441dd29af05df$var$markSubtree(newState, payload, false);
                    return newState;
                case 'GRAMENE_FILTER_SET_ADDED':
                    {
                        // create a filter with the payload.operation and children payload.filters
                        let filter = {
                            leftIdx: state.rightIdx,
                            rightIdx: state.rightIdx + payload.filters.length * 2 + 1,
                            operation: payload.operation,
                            negate: false,
                            showMenu: false,
                            children: payload.filters
                        };
                        if (payload.warning) filter.warning = payload.warning;
                        let nextIdx = filter.leftIdx + 1;
                        payload.filters.forEach((f)=>{
                            f.leftIdx = nextIdx++;
                            f.rightIdx = nextIdx++;
                            f.negate = false;
                            f.showMenu = false;
                        });
                        newState = Object.assign({}, state, {
                            status: 'search',
                            showMarked: true,
                            searchOffset: 0,
                            rightIdx: filter.rightIdx + 1
                        });
                        newState.children.push(filter);
                        $af4441dd29af05df$var$markSubtree(newState, filter, false);
                        return newState;
                    }
                case 'GRAMENE_FILTER_NEGATED':
                    {
                        newState = Object.assign({}, state, {
                            status: 'search',
                            showMarked: true,
                            searchOffset: 0
                        });
                        let node = $af4441dd29af05df$var$findNodeWithLeftIdx(newState, payload.leftIdx);
                        if (node) {
                            node.negate = !node.negate;
                            $af4441dd29af05df$var$markSubtree(newState, node, false);
                            return newState;
                        }
                        break;
                    }
                case 'GRAMENE_FILTER_DELETED':
                    {
                        newState = Object.assign({}, state, {
                            status: 'search',
                            showMarked: true,
                            searchOffset: 0
                        });
                        let node = $af4441dd29af05df$var$findNodeWithLeftIdx(newState, payload.leftIdx);
                        if (node) {
                            let parent = $af4441dd29af05df$var$findNodeWithLeftIdx(newState, node.parentIdx);
                            parent.children = parent.children.filter((child)=>child.leftIdx !== node.leftIdx);
                            $af4441dd29af05df$var$reindexTree(newState, 0);
                            $af4441dd29af05df$var$markSubtree(newState, parent, false);
                            return newState;
                        }
                        break;
                    }
                case 'GRAMENE_FILTER_OPERATION_CHANGED':
                    if (payload.hasOwnProperty('operation')) {
                        newState = Object.assign({}, state, {
                            status: 'search',
                            showMarked: true,
                            searchOffset: 0
                        });
                        let node = $af4441dd29af05df$var$findNodeWithLeftIdx(newState, payload.leftIdx);
                        // Set an explicit operation when one is supplied; otherwise keep the
                        // historical AND<->OR flip for callers that just pass the node.
                        node.operation = payload.newOperation ? payload.newOperation : node.operation === 'AND' ? 'OR' : 'AND';
                        $af4441dd29af05df$var$markSubtree(newState, node, false);
                        return newState;
                    }
                    break;
                case 'GRAMENE_FILTER_INTERVAL_ADDED':
                    {
                        // Intervals accumulate into a single OR group, because ANDing two
                        // disjoint intervals matches nothing — no gene sits in both. The group
                        // is tagged with `category`, one of the keys viewSnapshot keeps, so a
                        // restored view merges into it instead of starting a second group; were
                        // that tag ever lost the worst case is an extra group, never a corrupt
                        // tree.
                        newState = Object.assign({}, state, {
                            status: 'search',
                            showMarked: true,
                            searchOffset: 0
                        });
                        const { map: map, mapLabel: mapLabel, region: region, start: start, end: end } = payload;
                        // One leaf per interval, not four. getQuery has a raw-passthrough branch
                        // for a `location` leaf whose value starts with "(map:" — every other
                        // branch would escape the colons — so the whole clause rides in one node
                        // and the Filters panel shows one readable row per interval.
                        //
                        // Overlap, not containment: start <= interval end AND end >= interval
                        // start, so a gene that merely crosses the boundary still matches.
                        const intervalNode = {
                            fq_field: 'location',
                            fq_value: $af4441dd29af05df$export$634f7214da1b780a({
                                map: map,
                                region: region,
                                start: start,
                                end: end
                            }),
                            name: $af4441dd29af05df$export$535c09441f37845d({
                                mapLabel: mapLabel,
                                map: map,
                                region: region,
                                start: start,
                                end: end
                            }),
                            category: 'Genomic interval',
                            negate: false,
                            showMenu: false
                        };
                        let group = (newState.children || []).find((c)=>c && c.category === $af4441dd29af05df$export$6b95404109a3e2ec && Array.isArray(c.children));
                        if (group) group.children.push(intervalNode);
                        else newState.children.push({
                            operation: 'OR',
                            category: $af4441dd29af05df$export$6b95404109a3e2ec,
                            negate: false,
                            showMenu: false,
                            children: [
                                intervalNode
                            ]
                        });
                        // Inserting a nested subtree invalidates the hand-computed indices the
                        // append actions rely on, so renumber the whole tree.
                        $af4441dd29af05df$var$reindexTree(newState, 0);
                        $af4441dd29af05df$var$markSubtree(newState, newState, false);
                        return newState;
                    }
                case 'GRAMENE_FILTER_EDITED':
                    {
                        // Edits only rewrite a leaf's value and label. The node keeps its place,
                        // its negate flag and any expansion, and the tree shape is untouched — so
                        // unlike an insert there is nothing to reindex.
                        newState = Object.assign({}, state, {
                            status: 'search',
                            showMarked: true,
                            searchOffset: 0
                        });
                        const node = $af4441dd29af05df$var$findNodeWithLeftIdx(newState, payload.leftIdx);
                        if (!node || node.hasOwnProperty('children')) break;
                        node.fq_value = payload.fq_value;
                        if (payload.name !== undefined) node.name = payload.name;
                        node.showMenu = false;
                        $af4441dd29af05df$var$markSubtree(newState, node, false);
                        return newState;
                    }
                case 'GRAMENE_FILTER_EXPANSION_SET':
                    {
                        // Setting or clearing an expansion is just a field on the node — the tree
                        // shape is untouched, so there is nothing to reindex and no special case
                        // for the root. `payload.expand` of null/undefined removes it.
                        newState = Object.assign({}, state, {
                            status: 'search',
                            showMarked: true,
                            searchOffset: 0
                        });
                        let node = $af4441dd29af05df$var$findNodeWithLeftIdx(newState, payload.leftIdx);
                        if (!node) break;
                        // Leave showMenu alone, as GRAMENE_FILTER_NEGATED does. The radios are a
                        // setting rather than a command, so the menu stays open and the selection
                        // updates in place — you can switch type or clear without reopening it.
                        if (payload.expand) node.expand = payload.expand;
                        else delete node.expand;
                        $af4441dd29af05df$var$markSubtree(newState, node, false);
                        return newState;
                    }
                case 'GRAMENE_FILTER_MOVED':
                    {
                        newState = Object.assign({}, state, {
                            status: 'search',
                            showMarked: true,
                            moveCopyMode: '',
                            searchOffset: 0
                        });
                        let source = $af4441dd29af05df$var$findNodeWithLeftIdx(newState, payload.source.leftIdx);
                        let target = $af4441dd29af05df$var$findNodeWithLeftIdx(newState, payload.target.leftIdx);
                        if (source && target) {
                            source.showMenu = false;
                            let parent = $af4441dd29af05df$var$findNodeWithLeftIdx(newState, source.parentIdx);
                            parent.children = parent.children.filter((child)=>child.leftIdx !== source.leftIdx);
                            target.showMenu = false;
                            if (!target.hasOwnProperty('children')) {
                                let targetCopy = Object.assign({}, target);
                                target.children = [
                                    targetCopy
                                ];
                                target.operation = 'OR';
                                target.negate = false;
                                delete target.fq_field;
                                delete target.fq_value;
                                delete target.name;
                                delete target.category;
                            }
                            target.children.push(source);
                            $af4441dd29af05df$var$reindexTree(newState, 0);
                            $af4441dd29af05df$var$markSubtree(newState, target, false);
                            return newState;
                        }
                        break;
                    }
                case 'GRAMENE_FILTER_COPIED':
                    {
                        newState = Object.assign({}, state, {
                            status: 'search',
                            showMarked: true,
                            moveCopyMode: '',
                            searchOffset: 0
                        });
                        let source = $af4441dd29af05df$var$findNodeWithLeftIdx(newState, payload.source.leftIdx);
                        let target = $af4441dd29af05df$var$findNodeWithLeftIdx(newState, payload.target.leftIdx);
                        if (source && target) {
                            source.showMenu = false;
                            if (!target.hasOwnProperty('children')) {
                                let targetCopy = Object.assign({}, target);
                                target.children = [
                                    targetCopy
                                ];
                                target.operation = 'OR';
                                target.negate = false;
                                delete target.fq_field;
                                delete target.fq_value;
                                delete target.name;
                                delete target.category;
                            }
                            let sourceCopy = Object.assign({}, source);
                            target.children.push(sourceCopy);
                            $af4441dd29af05df$var$reindexTree(newState, 0);
                            $af4441dd29af05df$var$markSubtree(newState, target, false);
                            return newState;
                        }
                        break;
                    }
                case 'GRAMENE_FILTER_TARGETS_MARKED':
                    newState = Object.assign({}, state, {
                        showMarked: true,
                        moveCopyMode: payload.mode,
                        moveCopySource: payload.source
                    });
                    $af4441dd29af05df$var$markSubtree(newState, payload.source, true);
                    return newState;
                case 'GRAMENE_FILTER_TARGETS_UNMARKED':
                    newState = Object.assign({}, state, {
                        showMarked: false
                    });
                    return newState;
                case 'GRAMENE_FILTERS_REPLACED':
                    payload.status = 'search';
                    payload.searchOffset = 0;
                    return payload;
                case 'GRAMENE_FILTERS_STATUS_CHANGED':
                    if (!(state.status === 'ready' && payload === 'waiting')) return Object.assign({}, state, {
                        status: payload
                    });
                    break;
                case 'GRAMENE_FILTERS_SET_SHOW_MARKED':
                    return Object.assign({}, state, {
                        showMarked: payload
                    });
                case 'GRAMENE_FILTER_MENU_TOGGLED':
                    payload.showMenu = !payload.showMenu;
                    return Object.assign({}, state);
                case 'GRAMENE_SEARCH_PAGE_REQUESTED':
                    return Object.assign({}, state, {
                        status: 'search',
                        searchOffset: payload * state.rows
                    });
                case 'GRAMENE_SEARCH_FETCH_STARTED':
                    return Object.assign({}, state, {
                        status: 'loading'
                    });
                case 'GRAMENE_SEARCH_FETCH_FINISHED':
                    return Object.assign({}, state, {
                        status: 'finished'
                    });
                case 'GRAMENE_GENOMES_UPDATED':
                    if (state.status === 'ready') return Object.assign({}, state, {
                        status: 'search'
                    });
                case 'URL_UPDATED':
                    if (state.status === 'ready') return Object.assign({}, initialState, {
                        children: []
                    });
                    break;
                case 'APP_IDLE':
                    if (state.showMarked) return Object.assign({}, state, {
                        showMarked: false
                    });
            }
            return state;
        };
    },
    doNegateGrameneFilter: (filter)=>({ dispatch: dispatch, getState: getState })=>{
            dispatch({
                type: 'BATCH_ACTIONS',
                actions: [
                    {
                        type: 'GRAMENE_SEARCH_CLEARED'
                    },
                    {
                        type: 'GRAMENE_FILTER_NEGATED',
                        payload: filter
                    }
                ]
            });
        },
    doDeleteGrameneFilter: (filter)=>({ dispatch: dispatch })=>{
            dispatch({
                type: 'BATCH_ACTIONS',
                actions: [
                    {
                        type: 'GRAMENE_SEARCH_CLEARED'
                    },
                    {
                        type: 'GRAMENE_TAXONOMY_CLEARED'
                    },
                    {
                        type: 'GRAMENE_FILTER_DELETED',
                        payload: filter
                    }
                ]
            });
        },
    doChangeGrameneFilterOperation: (filter)=>({ dispatch: dispatch })=>{
            dispatch({
                type: 'BATCH_ACTIONS',
                actions: [
                    {
                        type: 'GRAMENE_SEARCH_CLEARED'
                    },
                    {
                        type: 'GRAMENE_FILTER_OPERATION_CHANGED',
                        payload: filter
                    }
                ]
            });
        },
    // Expand a node (leaf or group) along a relationship, e.g. "orthologs of this".
    doExpandGrameneFilter: (filter, type)=>({ dispatch: dispatch })=>{
            dispatch({
                type: 'BATCH_ACTIONS',
                actions: [
                    {
                        type: 'GRAMENE_SEARCH_CLEARED'
                    },
                    {
                        type: 'GRAMENE_TAXONOMY_CLEARED'
                    },
                    {
                        type: 'GRAMENE_FILTER_EXPANSION_SET',
                        payload: {
                            leftIdx: filter.leftIdx,
                            expand: type
                        }
                    }
                ]
            });
        },
    // Clear a node's expansion, leaving the node and its filters in place.
    doRemoveGrameneExpansion: (filter)=>({ dispatch: dispatch })=>{
            dispatch({
                type: 'BATCH_ACTIONS',
                actions: [
                    {
                        type: 'GRAMENE_SEARCH_CLEARED'
                    },
                    {
                        type: 'GRAMENE_TAXONOMY_CLEARED'
                    },
                    {
                        type: 'GRAMENE_FILTER_EXPANSION_SET',
                        payload: {
                            leftIdx: filter.leftIdx,
                            expand: null
                        }
                    }
                ]
            });
        },
    doMoveOrCopyGrameneFilter: (target)=>({ dispatch: dispatch, getState: getState })=>{
            const state = getState();
            if (state.grameneFilters.moveCopyMode) {
                const source = state.grameneFilters.moveCopySource;
                dispatch({
                    type: 'BATCH_ACTIONS',
                    actions: [
                        {
                            type: 'GRAMENE_SEARCH_CLEARED'
                        },
                        {
                            type: `GRAMENE_FILTER_${state.grameneFilters.moveCopyMode.toUpperCase()}D`,
                            payload: {
                                source: source,
                                target: target
                            }
                        }
                    ]
                });
            }
        },
    doCopyGrameneFilter: (source, target)=>({ dispatch: dispatch, getState: getState })=>{
            dispatch({
                type: 'BATCH_ACTIONS',
                actions: [
                    {
                        type: 'GRAMENE_SEARCH_CLEARED'
                    },
                    {
                        type: 'GRAMENE_FILTER_COPIED',
                        payload: {
                            source: source,
                            target: target
                        }
                    }
                ]
            });
        },
    doMarkGrameneFilterTargets: (source, mode)=>({ dispatch: dispatch })=>{
            dispatch({
                type: 'GRAMENE_FILTER_TARGETS_MARKED',
                payload: {
                    source: source,
                    mode: mode
                }
            });
        },
    doUnmarkGrameneFilterTargets: ()=>({ dispatch: dispatch })=>{
            dispatch({
                type: 'GRAMENE_FILTER_TARGETS_UNMARKED'
            });
        },
    doAcceptGrameneSuggestion: (suggestion)=>({ dispatch: dispatch, getState: getState })=>{
            if (!suggestion.name) suggestion.name = suggestion.display_name;
            dispatch({
                type: 'BATCH_ACTIONS',
                actions: [
                    {
                        type: 'GRAMENE_SEARCH_CLEARED'
                    },
                    {
                        type: 'GRAMENE_FILTER_ADDED',
                        payload: suggestion
                    }
                ]
            });
        },
    doAddGrameneRangeQuery: (terms)=>({ dispatch: dispatch })=>{
            dispatch({
                type: 'BATCH_ACTIONS',
                actions: [
                    {
                        type: 'GRAMENE_SEARCH_CLEARED'
                    },
                    {
                        type: 'GRAMENE_FILTER_SET_ADDED',
                        payload: {
                            operation: 'AND',
                            filters: terms
                        }
                    }
                ]
            });
        },
    // Add one genomic interval. Accumulates into a single OR group; see the
    // GRAMENE_FILTER_INTERVAL_ADDED reducer for why they cannot be ANDed.
    doAddGrameneInterval: (interval)=>({ dispatch: dispatch })=>{
            dispatch({
                type: 'BATCH_ACTIONS',
                actions: [
                    {
                        type: 'GRAMENE_SEARCH_CLEARED'
                    },
                    {
                        type: 'GRAMENE_TAXONOMY_CLEARED'
                    },
                    {
                        type: 'GRAMENE_FILTER_INTERVAL_ADDED',
                        payload: interval
                    }
                ]
            });
        },
    // Replace one leaf's value in place, keeping its position in the tree.
    doEditGrameneFilter: (filter, fq_value, name)=>({ dispatch: dispatch })=>{
            dispatch({
                type: 'BATCH_ACTIONS',
                actions: [
                    {
                        type: 'GRAMENE_SEARCH_CLEARED'
                    },
                    {
                        type: 'GRAMENE_TAXONOMY_CLEARED'
                    },
                    {
                        type: 'GRAMENE_FILTER_EDITED',
                        payload: {
                            leftIdx: filter.leftIdx,
                            fq_value: fq_value,
                            name: name
                        }
                    }
                ]
            });
        },
    doToggleGrameneFilterMenu: (node)=>({ dispatch: dispatch })=>{
            dispatch({
                type: 'GRAMENE_FILTER_MENU_TOGGLED',
                payload: node
            });
        },
    doRequestResultsPage: (page)=>({ dispatch: dispatch })=>{
            dispatch({
                type: 'BATCH_ACTIONS',
                actions: [
                    {
                        type: 'GRAMENE_SEARCH_CLEARED'
                    },
                    {
                        type: 'GRAMENE_SEARCH_PAGE_REQUESTED',
                        payload: page
                    }
                ]
            });
        },
    doReplaceGrameneFilters: (filters)=>({ dispatch: dispatch })=>{
            dispatch({
                type: 'BATCH_ACTIONS',
                actions: [
                    {
                        type: 'GRAMENE_SEARCH_CLEARED'
                    },
                    {
                        type: 'GRAMENE_FILTERS_REPLACED',
                        payload: filters
                    }
                ]
            });
        },
    doClearGrameneFilters: ()=>({ dispatch: dispatch })=>{
            dispatch({
                type: 'BATCH_ACTIONS',
                actions: [
                    {
                        type: 'GRAMENE_SEARCH_CLEARED'
                    },
                    {
                        type: 'GRAMENE_FILTERS_CLEARED'
                    }
                ]
            });
        },
    selectGrameneFilters: (state)=>state.grameneFilters,
    selectGrameneFiltersStatus: (state)=>state.grameneFilters.status,
    selectGrameneFiltersQueryString: (state)=>{
        const hasSpaces = new RegExp(/^[^\[\(].*\s/);
        const isQuery = new RegExp(/\([a-zA-Z0-9_]+:[a-zA-Z0-9_]+\s/);
        const isRegionQuery = new RegExp(/^\(map:/);
        const idWithColon = new RegExp(/^[a-zA-Z0-9_]+:[a-zA-Z0-9_]+$/);
        // The node's own clause, before negation and before any expansion.
        function ownQuery(node) {
            if (node.hasOwnProperty('children')) {
                // Only AND and OR are valid infix operators. Anything else — a token from a
                // newer client arriving via ?filters= or a saved view — would otherwise be
                // interpolated raw and produce a Solr 400, which surfaces as blank results
                // across every view rather than as an error.
                const op = node.operation === 'AND' || node.operation === 'OR' ? node.operation : 'OR';
                const kids = Array.isArray(node.children) ? node.children : [];
                return `(${kids.map((c)=>getQuery(c)).sort().join(` ${op} `)})`;
            }
            // this node is a suggestion
            if (node.fq_field === 'location' && isRegionQuery.test(node.fq_value)) return `${node.fq_value}`;
            if (isQuery.test(node.fq_value)) return `${node.fq_value.replace(/:/g, '\\:')}`;
            if (hasSpaces.test(node.fq_value)) return `${node.fq_field}:"${node.fq_value}"`;
            else if (idWithColon.test(node.fq_value)) return `${node.fq_field}:${node.fq_value.replace(/:/g, '\\:')}`;
            else return `${node.fq_field}:${node.fq_value}`;
        }
        function getQuery(node) {
            const negate = node.negate ? 'NOT ' : '';
            const clause = ownQuery(node);
            const expType = $af4441dd29af05df$export$a6dc3fef1cecdf28(node);
            // No expansion on this node: unchanged from before.
            if (!expType) return `${negate}${clause}`;
            const spec = $af4441dd29af05df$export$da3188ffd2da2525[expType];
            // Unknown expansion type — e.g. a link shared from a newer client. Degrade to
            // the un-expanded clause rather than emitting something broken.
            if (!spec) return `${negate}${clause}`;
            // An expansion of nothing must match nothing; '*:*' here would turn an empty
            // group into "every gene in the index".
            if (!clause || clause === '()') return `${negate}(*:* AND NOT *:*)`;
            // The braces MUST stay inside a quoted `_query_` value. A bare `{!graph ...}`
            // in `q` is unreliable and fails *silently* — observed returning 0 rows in
            // some shapes and millions in others, always HTTP 200, depending on the seed
            // and the endpoint in front of Solr. Don't factor `graph` out to module scope
            // where it could be used somewhere that isn't wrapped this way.
            const graph = `{!graph from=${spec.from} to=${spec.to} maxDepth=1 returnRoot=true}`;
            // Negation applies to the expanded set: "NOT an ortholog of msd2".
            return `${negate}(_query_:"${graph}${$af4441dd29af05df$export$fb4df7b076406c76(clause)}")`;
        }
        if (state.grameneFilters.rightIdx === 1) return '*:*';
        return `*:* AND (${getQuery(state.grameneFilters)})`;
    },
    selectGrameneSearchOffset: (state)=>state.grameneFilters.searchOffset,
    selectGrameneSearchRows: (state)=>state.grameneFilters.rows
};
const $af4441dd29af05df$var$handleIdList = (queryObject)=>{
    let actions = [
        {
            type: 'GRAMENE_SEARCH_CLEARED'
        }
    ];
    let ids = $parcel$interopDefault($gXNCa$lodash).uniq(queryObject.idList.split(','));
    let warning = null;
    if (ids.length > $af4441dd29af05df$var$MAX_IDLIST_LENGTH) {
        ids = $parcel$interopDefault($gXNCa$lodash).slice(ids, 0, $af4441dd29af05df$var$MAX_IDLIST_LENGTH);
        warning = `The idList query parameter is limited to ${$af4441dd29af05df$var$MAX_IDLIST_LENGTH} genes`;
    }
    let filters = ids.map((id, idx)=>{
        return {
            category: 'Gene',
            name: id,
            fq_field: 'id',
            fq_value: id
        };
    });
    if (filters.length === 1) actions.push({
        type: 'GRAMENE_FILTER_ADDED',
        payload: filters[0]
    });
    else {
        let action = {
            type: 'GRAMENE_FILTER_SET_ADDED',
            payload: {
                operation: 'OR',
                filters: filters
            }
        };
        if (warning) action.payload.warning = warning;
        actions.push(action);
    }
    return {
        type: 'BATCH_ACTIONS',
        actions: actions
    };
};
$af4441dd29af05df$var$grameneFilters.reactGrameneFilters = (0, $gXNCa$reduxbundler.createSelector)('selectQueryObject', 'selectGrameneFilters', 'selectActiveGenomes', 'selectUrlObject', (queryObject, filters, genomes, myUrl)=>{
    if (filters.status === 'init') {
        // A shared-view link (?view=<hash>) is restored asynchronously by
        // bootViewFromUrl once the snapshot (and, for private views, the auth
        // token) has loaded. Do nothing here: clearing filters + running an
        // unfiltered search would race the restore and leave the restored filter
        // in the tree but never applied to the search (the stale unfiltered
        // result stays put). Staying 'init' means the first — and only — search
        // is the one the snapshot triggers, with the filter in place.
        if (queryObject.hasOwnProperty('view')) return;
        if (queryObject.filters) {
            const newFilters = JSON.parse(queryObject.filters);
            let actions = [
                {
                    type: 'GRAMENE_SEARCH_CLEARED'
                },
                {
                    type: 'GRAMENE_FILTERS_REPLACED',
                    payload: newFilters
                }
            ];
            if (queryObject.genomes) {
                let active = {};
                queryObject.genomes.split(',').forEach((t)=>{
                    active[t] = true;
                });
                actions.push({
                    type: 'GRAMENE_GENOMES_UPDATED',
                    payload: active
                });
            }
            return {
                type: 'BATCH_ACTIONS',
                actions: actions
            };
        }
        if (queryObject.hasOwnProperty('sugg')) return {
            type: 'BATCH_ACTIONS',
            actions: [
                {
                    type: 'GRAMENE_SEARCH_CLEARED'
                },
                {
                    type: 'GRAMENE_FILTER_ADDED',
                    payload: JSON.parse(queryObject.sugg)
                }
            ]
        };
        if (queryObject.hasOwnProperty('suggestion')) {
            const url = new URL(myUrl.href);
            url.search = '';
            return {
                type: 'BATCH_ACTIONS',
                actions: [
                    {
                        type: 'URL_UPDATED',
                        payload: {
                            url: url.href,
                            replace: false
                        }
                    },
                    {
                        type: 'GRAMENE_SEARCH_CLEARED'
                    },
                    {
                        type: 'SUGGESTIONS_QUERY_CHANGED',
                        payload: {
                            query: queryObject.suggestion
                        }
                    }
                ]
            };
        }
        if (queryObject.hasOwnProperty('idList')) return $af4441dd29af05df$var$handleIdList(queryObject);
        if (queryObject.hasOwnProperty('fq_field') && queryObject.hasOwnProperty('fq_value') && queryObject.hasOwnProperty('category') && queryObject.hasOwnProperty('name')) return {
            type: 'BATCH_ACTIONS',
            actions: [
                {
                    type: 'GRAMENE_SEARCH_CLEARED'
                },
                {
                    type: 'GRAMENE_FILTER_ADDED',
                    payload: queryObject
                }
            ]
        };
        const url = new URL(myUrl.href);
        if (url.pathname === '/genes') return {
            type: 'GRAMENE_FILTERS_CLEARED'
        };
    }
    if (filters.status === 'finished') {
        const url = new URL(myUrl.href);
        url.search = `filters=${JSON.stringify(Object.assign({}, filters, {
            status: 'init'
        }))}&genomes=${genomes.join(',')}`;
        $parcel$interopDefault($gXNCa$reactga4).event({
            category: "Gene Search",
            action: "filter finished",
            label: url.search
        });
        return {
            type: 'BATCH_ACTIONS',
            actions: [
                {
                    type: 'URL_UPDATED',
                    payload: {
                        url: url.href,
                        replace: false
                    }
                },
                {
                    type: 'GRAMENE_FILTERS_STATUS_CHANGED',
                    payload: 'ready'
                }
            ]
        };
    }
});
var $af4441dd29af05df$export$2e2bcd8739ae039 = $af4441dd29af05df$var$grameneFilters;
const $24971af0a229e0e3$var$grameneViews = {
    name: 'grameneViews',
    getReducer: ()=>{
        const initialState = {
            options: [
                {
                    id: 'help',
                    name: 'Help / Demo',
                    show: 'off',
                    shouldScroll: false
                },
                {
                    id: 'taxonomy',
                    name: 'Taxonomic distribution',
                    show: 'on',
                    shouldScroll: false
                },
                {
                    id: 'taxTree',
                    name: 'Taxonomic distribution',
                    show: 'off',
                    shouldScroll: false
                },
                {
                    id: 'list',
                    name: 'Gene list',
                    show: 'on',
                    shouldScroll: false
                },
                {
                    id: 'exprViz',
                    name: 'Expression visualization',
                    show: 'off',
                    shouldScroll: false
                },
                {
                    id: 'attrTable',
                    name: 'Gene attributes',
                    show: 'off',
                    shouldScroll: false
                },
                {
                    id: 'ontologyEnrichment',
                    name: 'Ontology Enrichment',
                    show: 'off',
                    shouldScroll: false
                },
                {
                    id: 'userLists',
                    name: 'User Gene Lists',
                    show: 'off',
                    shouldScroll: false
                },
                {
                    id: 'export',
                    name: 'Data exporter',
                    show: 'off',
                    shouldScroll: false
                },
                {
                    id: 'expression',
                    name: 'Gene expression',
                    show: 'disabled',
                    shouldScroll: false,
                    desiredSamples: {}
                },
                {
                    id: 'attribs',
                    name: 'Gene attributes',
                    show: 'disabled',
                    shouldScroll: false
                }
            ],
            touched: {}
        };
        return (state = initialState, { type: type, payload: payload })=>{
            let newState;
            switch(type){
                case 'GRAMENE_VIEW_TOGGLED':
                    newState = Object.assign({}, state);
                    newState.touched = {
                        ...state.touched || {},
                        [payload]: true
                    };
                    newState.options.forEach((view)=>{
                        view.shouldScroll = false;
                        if (view.id === payload) {
                            view.show = view.show === 'on' ? 'off' : 'on';
                            view.shouldScroll = view.show === 'on';
                        }
                    });
                    return newState;
                case 'GRAMENE_VIEW_CLICKED':
                    newState = Object.assign({}, state);
                    newState.touched = {
                        ...state.touched || {},
                        [payload]: true
                    };
                    newState.options.forEach((view)=>{
                        view.shouldScroll = false;
                        if (view.id === payload) {
                            view.show = view.show === 'on' ? 'on' : 'on';
                            view.shouldScroll = view.show === 'on';
                        }
                    });
                    return newState;
                case 'GRAMENE_VIEW_SCROLLED':
                    newState = Object.assign({}, state);
                    newState.options.forEach((v)=>v.shouldScroll = false);
                    return newState;
                case 'GRAMENE_VIEWS_REPLACED':
                    {
                        // Snapshot restore. payload: { on: Set|Array<id>, touched: {id: true} }
                        // Sets options[].show directly to 'on' or 'off' based on membership in
                        // `on`. Leaves 'disabled' entries untouched (site config wins).
                        const onSet = payload.on instanceof Set ? payload.on : new Set(payload.on || []);
                        newState = Object.assign({}, state);
                        newState.touched = {
                            ...payload.touched || {}
                        };
                        newState.options = state.options.map((v)=>{
                            if (v.show === 'disabled') return v;
                            return {
                                ...v,
                                show: onSet.has(v.id) ? 'on' : 'off',
                                shouldScroll: false
                            };
                        });
                        return newState;
                    }
                default:
                    return state;
            }
        };
    },
    doToggleGrameneView: (idx)=>({ dispatch: dispatch, getState: getState })=>{
            dispatch({
                type: 'GRAMENE_VIEW_TOGGLED',
                payload: idx
            });
        },
    dontToggleGrameneView: (idx)=>({ dispatch: dispatch, getState: getState })=>{
            dispatch({
                type: 'GRAMENE_VIEW_CLICKED',
                payload: idx
            });
        },
    doCancelShouldScroll: ()=>({ dispatch: dispatch, getState: getState })=>{
            dispatch({
                type: 'GRAMENE_VIEW_SCROLLED',
                payload: null
            });
        },
    // Snapshot restore. `on` is an array of view ids to switch on; everything
    // else (except disabled views) goes off. `touched` is the same map the
    // user-toggled view bundle maintains, so the auto-default logic in
    // selectGrameneViews respects what the user has explicitly set.
    doReplaceGrameneViews: ({ on: on, touched: touched })=>({ dispatch: dispatch })=>{
            dispatch({
                type: 'GRAMENE_VIEWS_REPLACED',
                payload: {
                    on: on,
                    touched: touched
                }
            });
        },
    selectRawGrameneViews: (state)=>state.grameneViews,
    selectGrameneViews: (0, $gXNCa$reduxbundler.createSelector)('selectRawGrameneViews', 'selectConfiguration', 'selectGrameneSearch', 'selectGrameneFilters', (raw, config, search, filters)=>{
        const overrides = config && config.views || null;
        const touched = raw.touched || {};
        const numFound = search && search.response && search.response.numFound || 0;
        const hasFilters = !!(filters && filters.rightIdx > 1);
        // Views whose content depends on a current search: auto-off when no
        // filters are set or no results came back. userLists is deliberately
        // NOT here — it's user-owned and meaningful regardless of search state.
        const resultDependentIds = new Set([
            'taxonomy',
            'taxTree',
            'list',
            'export',
            'exprViz',
            'attrTable',
            'ontologyEnrichment'
        ]);
        const autoDisable = numFound === 0 || !hasFilters;
        const hasFirebase = !!(config && config.firebaseConfig);
        let options = raw.options;
        if (!hasFirebase) options = options.filter((v)=>v.id !== 'userLists');
        if (overrides) options = options.filter((v)=>overrides[v.id] !== 'hidden');
        options = options.map((v)=>{
            if (resultDependentIds.has(v.id) && autoDisable) return {
                ...v,
                show: 'off'
            };
            if (!overrides) return v;
            const o = overrides[v.id];
            if (!o) return v;
            if (o === 'disabled') return {
                ...v,
                show: 'disabled'
            };
            if (touched[v.id]) return v;
            return {
                ...v,
                show: o
            };
        });
        const anyOtherOn = options.some((v)=>v.id !== 'help' && v.show === 'on');
        if (!anyOtherOn) options = options.map((v)=>v.id === 'help' ? {
                ...v,
                show: 'on'
            } : v);
        return {
            ...raw,
            options: options
        };
    }),
    // Set of view ids whose `show` is currently 'on'. Used by data bundles to
    // gate their auto-fetch reactors so we don't pay the cost of loading data
    // for views the user has turned off.
    selectGrameneViewsOn: (0, $gXNCa$reduxbundler.createSelector)('selectGrameneViews', (views)=>{
        const ids = new Set();
        const opts = views && views.options || [];
        for (const v of opts)if (v && v.show === 'on') ids.add(v.id);
        return ids;
    })
};
var $24971af0a229e0e3$export$2e2bcd8739ae039 = $24971af0a229e0e3$var$grameneViews;
// Dedicated IndexedDB store for the full pathway corpus, persisted
// indefinitely (default maxAge of `Infinity`). The pathway set is small
// and stable enough to keep around across sessions, so we bulk-load it
// once with `?rows=-1` and reuse it instead of issuing per-id requests.
// Scoped to the subsite so per-site pathway corpora don't collide.
//
// The corpus is release-specific: each pathway doc carries its hierarchy in
// per-genome `lineage_<taxon_id>` fields, and taxon ids change between data
// releases (sorghum_v10b's 4558001 became sorghum_v11's 4558006). Serving a
// previous release's docs therefore yields no lineage at all for the current
// genomes, which used to leave the pathways tab building diagram ids like
// `R-SBI-undefined`. Versioning the cache by the API URL makes money-clip
// drop and refetch the corpus whenever the site moves to a new release.
let $671312b287158a8a$var$pathwayCache = null;
const $671312b287158a8a$var$getPathwayCache = (api)=>{
    if (!$671312b287158a8a$var$pathwayCache) $671312b287158a8a$var$pathwayCache = (0, $gXNCa$moneyclip.getConfiguredCache)({
        version: `1:${api}`,
        name: `gramene_pathways_${'default'}`
    });
    return $671312b287158a8a$var$pathwayCache;
};
let $671312b287158a8a$var$pathwaysBulkPromise = null;
const $671312b287158a8a$var$grameneDocs = {
    name: 'grameneDocs',
    getReducer: ()=>{
        const initialState = {
            genes: {},
            trees: {},
            domains: {},
            pathways: {},
            expression: {},
            sequences: {},
            rnaSequences: {},
            pepSequences: {},
            studies: {},
            desiredSamples: {},
            consequences: {}
        };
        return (state = initialState, { type: type, payload: payload })=>{
            let newState;
            switch(type){
                case 'GRAMENE_CONSEQUENCES_REQUESTED':
                    if (!state.consequences.hasOwnProperty(payload)) {
                        newState = Object.assign({}, state);
                        newState.consequences[payload] = {};
                        return newState;
                    }
                    break;
                case 'GRAMENE_CONSEQUENCES_RECEIVED':
                    newState = Object.assign({}, state);
                    newState.consequences = Object.assign({}, state.consequences, payload);
                    return newState;
                case 'GRAMENE_GENE_REQUESTED':
                    if (!state.genes.hasOwnProperty(payload)) {
                        newState = Object.assign({}, state);
                        newState.genes[payload] = {};
                        return newState;
                    }
                    break;
                case 'GRAMENE_GENE_RECEIVED':
                    newState = Object.assign({}, state);
                    newState.genes = Object.assign({}, state.genes, payload);
                    return newState;
                case 'GRAMENE_TREE_REQUESTED':
                    if (!state.trees.hasOwnProperty(payload)) {
                        newState = Object.assign({}, state);
                        newState.trees[payload] = {};
                        return newState;
                    }
                    break;
                case 'GRAMENE_TREE_RECEIVED':
                    newState = Object.assign({}, state);
                    newState.trees = Object.assign({}, state.trees, payload);
                    return newState;
                case 'GRAMENE_PATHWAYS_RECEIVED':
                    newState = Object.assign({}, state);
                    newState.pathways = Object.assign({}, state.pathways, payload);
                    return newState;
                case 'ATLAS_STUDIES_RECEIVED':
                    newState = Object.assign({}, state);
                    newState.studies = Object.assign({}, state.studies, payload);
                    return newState;
                case 'ATLAS_SAMPLES_REQUESTED':
                    if (!state.studies.byID[payload].hasOwnProperty('samples')) {
                        newState = Object.assign({}, state);
                        newState.studies.byID[payload].samples = [];
                        return newState;
                    }
                    break;
                case 'ATLAS_SAMPLES_RECEIVED':
                    newState = Object.assign({}, state);
                    newState.studies.byID[payload.id].samples = payload.samples;
                    return newState;
                case 'GENE_SEQUENCE_REQUESTED':
                    if (!state.sequences.hasOwnProperty(payload)) {
                        newState = Object.assign({}, state);
                        newState.sequences[payload] = {};
                        return newState;
                    }
                    break;
                case 'RNA_SEQUENCE_REQUESTED':
                    if (!state.rnaSequences.hasOwnProperty(payload)) {
                        newState = Object.assign({}, state);
                        newState.rnaSequences[payload] = {};
                        return newState;
                    }
                    break;
                case 'PEP_SEQUENCE_REQUESTED':
                    if (!state.rnaSequences.hasOwnProperty(payload)) {
                        newState = Object.assign({}, state);
                        newState.pepSequences[payload] = {};
                        return newState;
                    }
                    break;
                case 'GENE_SEQUENCE_RECEIVED':
                    newState = Object.assign({}, state);
                    newState.sequences = Object.assign({}, state.sequences);
                    newState.sequences[payload.id] = payload.geneSeq;
                    return newState;
                case 'RNA_SEQUENCE_RECEIVED':
                    newState = Object.assign({}, state);
                    newState.rnaSequences = Object.assign({}, state.rnaSequences);
                    newState.rnaSequences[payload.id] = payload.RnaSeq;
                    return newState;
                case 'PEP_SEQUENCE_RECEIVED':
                    newState = Object.assign({}, state);
                    newState.pepSequences = Object.assign({}, state.pepSequences);
                    newState.pepSequences[payload.id] = payload.PepSeq;
                    return newState;
                case 'PARALOG_EXPRESSION_REQUESTED':
                    if (!state.expression.hasOwnProperty(payload)) {
                        newState = Object.assign({}, state);
                        newState.expression[payload] = [];
                        return newState;
                    }
                    break;
                case 'PARALOG_EXPRESSION_RECEIVED':
                    newState = Object.assign({}, state);
                    newState.expression = Object.assign({}, state.expression);
                    newState.expression[payload.id] = payload.paralogs;
                    return newState;
                case 'EXPRESSION_SAMPLE_TOGGLED':
                    newState = Object.assign({}, state);
                    newState.desiredSamples = Object.assign({}, state.desiredSamples);
                    if (newState.desiredSamples.hasOwnProperty(payload)) delete newState.desiredSamples[payload];
                    else newState.desiredSamples[payload] = {
                        status: 'need'
                    };
                    return newState;
            }
            return state;
        };
    },
    doToggleExpressionSample: (id)=>({ dispatch: dispatch })=>{
            dispatch({
                type: 'EXPRESSION_SAMPLE_TOGGLED',
                payload: id
            });
        },
    doRequestVEP: (id)=>({ dispatch: dispatch, store: store })=>{
            const consequences = store.selectGrameneConsequences();
            if (!consequences.hasOwnProperty(id)) {
                dispatch({
                    type: 'GRAMENE_CONSEQUENCES_REQUESTED',
                    payload: id
                });
                fetch(`${store.selectGrameneAPI()}/search?q=id:${id}&fl=id,VEP__*`).then((res)=>res.json()).then((res)=>{
                    let genes = {};
                    res.response.docs.forEach((g)=>{
                        genes[g.id] = g;
                    });
                    dispatch({
                        type: 'GRAMENE_CONSEQUENCES_RECEIVED',
                        payload: genes
                    });
                });
            }
        },
    doRequestGrameneGene: (id)=>({ dispatch: dispatch, store: store })=>{
            const genes = store.selectGrameneGenes();
            if (!genes.hasOwnProperty(id)) {
                dispatch({
                    type: 'GRAMENE_GENE_REQUESTED',
                    payload: id
                });
                fetch(`${store.selectGrameneAPI()}/genes?idList=${id}`).then((res)=>res.json()).then((res)=>{
                    let genes = {};
                    res.forEach((g)=>{
                        genes[g._id] = g;
                    });
                    dispatch({
                        type: 'GRAMENE_GENE_RECEIVED',
                        payload: genes
                    });
                });
            }
        },
    doRequestGrameneTree: (id)=>({ dispatch: dispatch, store: store })=>{
            const trees = store.selectGrameneTrees();
            const maps = store.selectGrameneMaps();
            if (!trees.hasOwnProperty(id)) {
                dispatch({
                    type: 'GRAMENE_TREE_REQUESTED',
                    payload: id
                });
                fetch(`${store.selectGrameneAPI()}/genetrees?idList=${id}`).then((res)=>res.json()).then((res)=>{
                    let trees = {};
                    res.forEach((t)=>{
                        function update_taxon_name(node) {
                            if (maps && maps.hasOwnProperty(node.taxon_id)) node.taxon_name = maps[node.taxon_id].display_name;
                            else if (node.taxon_id === 1100004558) node.taxon_name = "Sorghum bicolor";
                            if (node.taxon_id === 45580023 && node.hasOwnProperty('children')) node.taxon_name = "Sorghum bicolor";
                            if (node.taxon_id === 45770001 && node.hasOwnProperty('children')) node.taxon_name = "Zea mays";
                            if (node.taxon_id === 297600009 && node.hasOwnProperty('children')) node.taxon_name = "Vitis vinifera";
                            if (node.hasOwnProperty('children')) node.children.forEach((c)=>update_taxon_name(c));
                        }
                        update_taxon_name(t);
                        trees[t._id] = t;
                    });
                    dispatch({
                        type: 'GRAMENE_TREE_RECEIVED',
                        payload: trees
                    });
                });
            }
        },
    // Signature kept for backward compatibility; the `ids` argument is
    // ignored. On first call we bulk-load every pathway record from the
    // dedicated IndexedDB cache (or `${api}/pathways?rows=-1` on miss),
    // dispatch a single GRAMENE_PATHWAYS_RECEIVED, and short-circuit all
    // subsequent calls.
    doRequestGramenePathways: (_ids)=>({ dispatch: dispatch, store: store })=>{
            if ($671312b287158a8a$var$pathwaysBulkPromise) return $671312b287158a8a$var$pathwaysBulkPromise;
            const api = store.selectGrameneAPI();
            const cache = $671312b287158a8a$var$getPathwayCache(api);
            $671312b287158a8a$var$pathwaysBulkPromise = cache.get('all').then((cached)=>{
                if (cached) {
                    dispatch({
                        type: 'GRAMENE_PATHWAYS_RECEIVED',
                        payload: cached
                    });
                    return;
                }
                return fetch(`${api}/pathways?rows=-1`).then((res)=>res.json()).then((res)=>{
                    const pathways = {};
                    (res || []).forEach((p)=>{
                        if (p && p._id != null) pathways[p._id] = p;
                    });
                    dispatch({
                        type: 'GRAMENE_PATHWAYS_RECEIVED',
                        payload: pathways
                    });
                    cache.set('all', pathways).catch((e)=>console.warn('Failed to cache pathways', e));
                });
            }).catch((err)=>{
                console.error('Failed to load pathways', err);
                $671312b287158a8a$var$pathwaysBulkPromise = null; // allow retry on next call
            });
            return $671312b287158a8a$var$pathwaysBulkPromise;
        },
    doRequestExpressionStudies: (id)=>({ dispatch: dispatch, store: store })=>{
            fetch(`${store.selectGrameneAPI()}/experiments?rows=-1`).then((res)=>res.json()).then((res)=>{
                let studies = {
                    byID: {},
                    byTaxon: {}
                };
                res.forEach((s)=>{
                    studies.byID[s._id] = s;
                    if (!studies.byTaxon.hasOwnProperty(s.taxon_id)) studies.byTaxon[s.taxon_id] = [];
                    studies.byTaxon[s.taxon_id].push(s._id);
                });
                dispatch({
                    type: 'ATLAS_STUDIES_RECEIVED',
                    payload: studies
                });
            });
        },
    doRequestStudyMetadata: (id)=>({ dispatch: dispatch, store: store })=>{
            const studies = store.selectAtlasStudies();
            if (!studies.byID[id].hasOwnProperty('samples')) {
                dispatch({
                    type: 'ATLAS_SAMPLES_REQUESTED',
                    payload: id
                });
                fetch(`${store.selectGrameneAPI()}/assays?experiment=${id}&rows=-1`).then((res)=>res.json()).then((samples)=>{
                    dispatch({
                        type: 'ATLAS_SAMPLES_RECEIVED',
                        payload: {
                            id: id,
                            samples: samples
                        }
                    });
                });
            }
        },
    doRequestGeneSequence: (gene)=>({ dispatch: dispatch, store: store })=>{
            const maps = store.selectGrameneMaps();
            const seqs = store.selectGeneSequences();
            const id = gene._id;
            const MAX_FLANK = 2000;
            if (!seqs.hasOwnProperty(id)) {
                dispatch({
                    type: 'GENE_SEQUENCE_REQUESTED',
                    payload: id
                });
                const start = gene.location.start > MAX_FLANK ? gene.location.start - MAX_FLANK : 1;
                const dnaLength = maps[gene.taxon_id].regionLength[gene.location.region];
                const end = gene.location.end + MAX_FLANK > dnaLength ? dnaLength : gene.location.end + MAX_FLANK;
                fetch(`${store.selectEnsemblAPI()}/sequence/region/${gene.system_name}/${gene.location.region}:${start}..${end}:${gene.location.strand}?content-type=application/json`).then((res)=>res.json()).then((geneSeq)=>{
                    const x = geneSeq.id.split(':');
                    geneSeq.genome = x[1];
                    geneSeq.start = +x[3];
                    geneSeq.end = +x[4];
                    dispatch({
                        type: 'GENE_SEQUENCE_RECEIVED',
                        payload: {
                            id: id,
                            geneSeq: geneSeq
                        }
                    });
                });
            }
        },
    doRequestRnaSequence: (id, gene)=>({ dispatch: dispatch, store: store })=>{
            const seqs = store.selectRnaSequences();
            if (!seqs.hasOwnProperty(id)) {
                dispatch({
                    type: 'RNA_SEQUENCE_REQUESTED',
                    payload: id
                });
                fetch(`${store.selectEnsemblAPI()}/sequence/id/${id}?species=${gene.system_name}&type=cdna&content-type=application/json`).then((res)=>res.json()).then((RnaSeq)=>{
                    dispatch({
                        type: 'RNA_SEQUENCE_RECEIVED',
                        payload: {
                            id: id,
                            RnaSeq: RnaSeq
                        }
                    });
                });
            }
        },
    doRequestPepSequence: (id, gene)=>({ dispatch: dispatch, store: store })=>{
            const seqs = store.selectPepSequences();
            if (!seqs.hasOwnProperty(id)) {
                dispatch({
                    type: 'PEP_SEQUENCE_REQUESTED',
                    payload: id
                });
                fetch(`${store.selectEnsemblAPI()}/sequence/id/${id}?species=${gene.system_name}&type=protein&content-type=application/json`).then((res)=>res.json()).then((PepSeq)=>{
                    dispatch({
                        type: 'PEP_SEQUENCE_RECEIVED',
                        payload: {
                            id: id,
                            PepSeq: PepSeq
                        }
                    });
                });
            }
        },
    doRequestParalogExpression: (id)=>({ dispatch: dispatch, store: store })=>{
            const expr = store.selectParalogExpression();
            if (!expr.hasOwnProperty(id)) {
                dispatch({
                    type: 'PARALOG_EXPRESSION_REQUESTED',
                    payload: id
                });
                fetch(`${store.selectGrameneAPI()}/search?q=homology__within_species_paralog:${id}&fl=id,atlas_id,name,*__expr&rows=100`).then((res)=>res.json()).then((res)=>{
                    const assay_re = /(.+)_g(\d+)/;
                    const paralogs = res.response.docs.map((d)=>{
                        let p = {
                            id: d.id,
                            name: d.name,
                            experiments: {},
                            min: 1000,
                            max: 0
                        };
                        if (d.atlas_id) {
                            p.atlas_id = d.atlas_id;
                            delete d.atlas_id;
                        }
                        delete d.id;
                        delete d.name;
                        Object.entries(d).forEach((assay)=>{
                            const parsed = assay[0].match(assay_re);
                            const expr = parsed[1].replace('_', '-').replace('-tpms', '');
                            if (!p.experiments.hasOwnProperty(expr)) p.experiments[expr] = [];
                            const g = parsed[2] - 1;
                            const e = d[assay[0]];
                            if (e < p.min) p.min = e;
                            if (e > p.max) p.max = e;
                            p.experiments[expr][g] = e;
                        });
                        return p;
                    }).map((p)=>{
                        for(const expr in p.experiments)p.experiments[expr] = p.experiments[expr].filter((e)=>e >= 0);
                        return p;
                    });
                    dispatch({
                        type: 'PARALOG_EXPRESSION_RECEIVED',
                        payload: {
                            id: id,
                            paralogs: paralogs
                        }
                    });
                });
            }
        },
    selectGrameneGenes: (state)=>state.grameneDocs.genes,
    selectGrameneConsequences: (state)=>state.grameneDocs.consequences,
    selectGrameneTrees: (state)=>state.grameneDocs.trees,
    selectGramenePathways: (state)=>state.grameneDocs.pathways,
    selectParalogExpression: (state)=>state.grameneDocs.expression,
    selectGeneSequences: (state)=>state.grameneDocs.sequences,
    selectRnaSequences: (state)=>state.grameneDocs.rnaSequences,
    selectPepSequences: (state)=>state.grameneDocs.pepSequences,
    selectAtlasStudies: (state)=>state.grameneDocs.studies,
    selectDesiredSamples: (state)=>state.grameneDocs.desiredSamples
};
var $671312b287158a8a$export$2e2bcd8739ae039 = $671312b287158a8a$var$grameneDocs;
const $0d54502f6cafe273$var$grameneGenomes = {
    name: 'grameneGenomes',
    getReducer: ()=>{
        const initialState = {
            show: false,
            active: {}
        };
        return (state = initialState, { type: type, payload: payload })=>{
            let newState;
            switch(type){
                case 'GRAMENE_GENOMES_TOGGLED':
                    newState = Object.assign({}, state);
                    newState.show = !newState.show;
                    return newState;
                case 'GRAMENE_GENOMES_UPDATED':
                    newState = Object.assign({}, state);
                    newState.active = payload;
                    return newState;
                case 'GRAMENE_MAPS_FETCH_FINISHED':
                    newState = Object.assign({}, state);
                    Object.keys(payload).forEach((key)=>{
                        newState.active[key] = true;
                    });
                    return newState;
                default:
                    return state;
            }
        };
    },
    doShowGrameneGenomes: ()=>({ dispatch: dispatch, getState: getState })=>{
            dispatch({
                type: 'GRAMENE_GENOMES_TOGGLED'
            });
        },
    doInitializeGrameneGenomes: (genomes)=>({ dispatch: dispatch, getState: getState })=>{
            dispatch({
                type: 'BATCH_ACTIONS',
                actions: [
                    {
                        type: 'GRAMENE_SEARCH_CLEARED'
                    },
                    {
                        type: 'GRAMENE_GENOMES_UPDATED',
                        payload: genomes
                    }
                ]
            });
        },
    doUpdateGrameneGenomes: (genomes)=>({ dispatch: dispatch, getState: getState })=>{
            dispatch({
                type: 'BATCH_ACTIONS',
                actions: [
                    {
                        type: 'GRAMENE_GENOMES_UPDATED',
                        payload: genomes
                    },
                    {
                        type: 'GRAMENE_GENOMES_TOGGLED'
                    },
                    {
                        type: 'GRAMENE_SEARCH_CLEARED'
                    }
                ]
            });
        },
    doEnsureGrameneGenome: (genome)=>({ dispatch: dispatch, getState: getState })=>{
            const state = getState();
            if (Object.keys(state.grameneGenomes.active).length > 0 && !state.grameneGenomes.active.hasOwnProperty(genome)) {
                let active = Object.assign({}, state.grameneGenomes.active);
                active[genome] = true;
                dispatch({
                    type: 'GRAMENE_GENOMES_UPDATED',
                    payload: active
                });
            }
        },
    selectGrameneGenomes: (state)=>state.grameneGenomes,
    selectActiveGenomes: (state)=>{
        return Object.keys(state.grameneGenomes.active);
    },
    selectActiveGenomeCount: (0, $gXNCa$reduxbundler.createSelector)('selectGrameneMaps', 'selectGrameneGenomes', (maps, genomes)=>{
        if (maps && genomes) return Object.keys(genomes.active).length || Object.keys(maps).length;
        return 0;
    })
};
var $0d54502f6cafe273$export$2e2bcd8739ae039 = $0d54502f6cafe273$var$grameneGenomes;
var $65709bd8598fce20$exports = {};
$65709bd8598fce20$exports = JSON.parse('{"groups":{"core":{"label":"Core identifiers","order":0},"location":{"label":"Genomic location","order":1},"structure":{"label":"Gene structure","order":2},"homology":{"label":"Homology","order":3},"exprattrs":{"label":"Expression attributes","order":3.5},"expression":{"label":"Gene expression","order":4},"differential":{"label":"Differential expression","order":5},"hierarchical":{"label":"Hierarchical annotations","order":6},"pathways":{"label":"Pathways","order":7},"GO":{"label":"Gene Ontology","order":7},"PO":{"label":"Plant Ontology","order":8},"lof":{"label":"Loss of function alleles","order":9},"MAKER":{"label":"MAKER transcript metrics","order":10},"xrefs":{"label":"External references","order":11},"other":{"label":"Other","order":99}},"patterns":[{"id":"homology","match":"^homology__(.+)$","group":"homology","multiValued":true,"labelTemplate":"Homology: $1"},{"id":"pathways","match":"^pathways__(.+)$","group":"pathways","multiValued":true,"labelTemplate":"Pathway: $1"},{"id":"maker","match":"^MAKER__(.+)__attr_([a-z])$","group":"MAKER","labelTemplate":"MAKER: $1"},{"id":"xrefs","match":"^(.+)__xrefs$","group":"xrefs","multiValued":true,"labelTemplate":"$1 (xrefs)"},{"id":"expr","match":"^(E[-_][A-Za-z0-9_-]+?)_g(\\\\d+)__expr$","group":"expression","expression":true,"labelTemplate":"$1 \xb7 g$2"},{"id":"diffexpr","match":"^(E[-_][A-Za-z0-9_-]+?)_g(\\\\d+)_g(\\\\d+)_(pval|l2fc)_attr_([a-z])$","group":"differential","diffExpression":true,"labelTemplate":"$1 \xb7 g$2 vs g$3 \xb7 $4"},{"id":"bins","match":"^(fixed|uniform)_([0-9a-zA-Z]+)__bin$","group":"bins","is_hidden":true,"labelTemplate":"$1 bin ($2)"},{"id":"neighbors","match":".*neighbors_[0-9]+$","group":"neighbors","is_hidden":true,"labelTemplate":"neighbors"},{"id":"vep_merged","match":"^VEP__merged__(NAT|EMS)__attr_ss$","group":"lof","multiValued":true,"labelTemplate":"Merged $1 accessions"},{"id":"vep_detail","match":"^VEP__(.+?)__(homo|het)__(.+?)__(\\\\d+)__attr_ss$","group":"lof","multiValued":true,"labelTemplate":"$1 ($2) $3/$4"},{"id":"generic_attr","match":"^(.+)__attr_([a-z])$","group":"other","labelTemplate":"$1"}],"fields":{"id":{"group":"core","label":"Gene ID","order":1},"name":{"group":"core","label":"Name","order":2},"alt_id":{"group":"core","label":"Alternative identifiers","multiValued":true,"order":3,"description":"Identifiers for this gene from earlier annotation releases"},"synonyms":{"group":"core","label":"Synonyms","multiValued":true,"order":4},"description":{"group":"core","label":"Description","order":5},"summary":{"group":"core","label":"Summary","order":6},"biotype":{"group":"core","label":"Biotype","order":7},"system_name":{"group":"core","label":"System name","order":8},"taxon_id":{"group":"core","label":"Taxon ID","order":9},"db_type":{"group":"core","label":"DB type","order":10},"closest_rep_id":{"group":"homology","label":"Closest representative ID","order":1},"closest_rep_name":{"group":"homology","label":"Closest representative name","order":2},"closest_rep_identity":{"group":"homology","label":"Closest representative identity","order":3},"closest_rep_taxon_id":{"group":"homology","label":"Closest representative taxon","order":4},"closest_rep_description":{"group":"homology","label":"Closest representative description","order":5},"model_rep_id":{"group":"homology","label":"Model representative ID","order":6},"model_rep_name":{"group":"homology","label":"Model representative name","order":7},"model_rep_identity":{"group":"homology","label":"Model representative identity","order":8},"model_rep_taxon_id":{"group":"homology","label":"Model representative taxon","order":9},"model_rep_description":{"group":"homology","label":"Model representative description","order":10},"gene_tree":{"group":"homology","label":"Gene tree ID","order":11},"pan_tree":{"group":"homology","label":"Pan-gene tree ID","order":14},"grassius_homolog__attr_ss":{"group":"homology","label":"Grassius family","multiValued":true,"order":15,"description":"Transcription factor / coregulator family assignment from GRASSIUS"},"expr_class__attr_ss":{"group":"exprattrs","label":"Expression class","multiValued":true,"order":1,"description":"tissue_specific, tissue_enhanced, broadly_expressed, ubiquitous, not_expressed or insufficient_data"},"expr_organ_level__attr_ss":{"group":"exprattrs","label":"Expression level by organ","multiValued":true,"order":2,"description":"organ:level pairs, where level is not_expressed, low, medium, high or very_high"},"expr_specific_to__attr_ss":{"group":"exprattrs","label":"Specific to organ","multiValued":true,"order":3,"description":"Organs this gene is expressed in almost exclusively"},"expr_enhanced_in__attr_ss":{"group":"exprattrs","label":"Enhanced in organ","multiValued":true,"order":4,"description":"Organs with expression notably above this gene\'s average"},"expr_high_in__attr_ss":{"group":"exprattrs","label":"High in organ","multiValued":true,"order":5,"description":"Organs where this gene is highly expressed"},"expr_activated_by__attr_ss":{"group":"exprattrs","label":"Activated by condition","multiValued":true,"order":6,"description":"Stress or treatment conditions that induce this gene"},"expr_repressed_by__attr_ss":{"group":"exprattrs","label":"Repressed by condition","multiValued":true,"order":7,"description":"Stress or treatment conditions that repress this gene"},"expr_tau__attr_f":{"group":"exprattrs","label":"Tissue specificity (tau)","order":8,"description":"0 = broadly expressed, 1 = highly tissue specific"},"expr_max_tpm__attr_f":{"group":"exprattrs","label":"Maximum expression (TPM)","order":9,"description":"Highest expression level observed across organs"},"expr_n_organs_detected__attr_i":{"group":"exprattrs","label":"Organs with detected expression","order":10},"capabilities":{"group":"other","label":"Capabilities","multiValued":true},"map":{"group":"location","label":"Map","order":1},"region":{"group":"location","label":"Region","order":2},"start":{"group":"location","label":"Start","order":3},"end":{"group":"location","label":"End","order":4},"strand":{"group":"location","label":"Strand","order":5},"GO__ancestors":{"group":"hierarchical","label":"GO terms","multiValued":true,"order":1},"PO__ancestors":{"group":"hierarchical","label":"PO terms","multiValued":true,"order":2},"TO__ancestors":{"group":"hierarchical","label":"TO terms","multiValued":true,"order":3},"QTL_TO__ancestors":{"group":"hierarchical","label":"QTL traits (TO)","multiValued":true,"order":7},"domains__ancestors":{"group":"hierarchical","label":"Domains","multiValued":true,"order":4},"taxonomy__ancestors":{"group":"hierarchical","label":"Taxonomy","multiValued":true,"order":6},"supertree_attr_s":{"group":"homology","label":"Supertree","order":13},"gene_tree_root_taxon_id":{"group":"homology","label":"Gene tree root taxon","order":12},"protein__length":{"group":"structure","label":"Protein length"},"transcript__count":{"group":"structure","label":"Transcript count"},"transcript__exons":{"group":"structure","label":"Exon count"},"transcript__length":{"group":"structure","label":"Transcript length"},"expressed_in_gxa_attr_ss":{"group":"expression","label":"Expressed in GXA","multiValued":true},"MAKER__AED__attr_f":{"group":"MAKER","label":"AED","description":"Annotation Edit Distance"},"MAKER__QI1__attr_i":{"group":"MAKER","label":"QI1: Length of the 5\' UTR"},"MAKER__QI2__attr_f":{"group":"MAKER","label":"QI2: Fraction of splice sites confirmed by EST"},"MAKER__QI3__attr_f":{"group":"MAKER","label":"QI3: Fraction of exons overlapping an EST"},"MAKER__QI4__attr_f":{"group":"MAKER","label":"QI4: Fraction of exons overlapping EST or protein"},"MAKER__QI5__attr_f":{"group":"MAKER","label":"QI5: Fraction of splice sites confirmed by SNAP"},"MAKER__QI6__attr_f":{"group":"MAKER","label":"QI6: Fraction of exons overlapping a SNAP"},"MAKER__QI7__attr_i":{"group":"MAKER","label":"QI7: Number of exons in the mRNA"},"MAKER__QI8__attr_i":{"group":"MAKER","label":"QI8: Length of the 3\' UTR"},"MAKER__QI9__attr_i":{"group":"MAKER","label":"QI9: Length of the protein sequence"},"homology__all_orthologs":{"group":"homology","label":"All orthologs","multiValued":true,"order":15},"homology__ortholog_one2one":{"group":"homology","label":"1:1 orthologs","multiValued":true,"order":16},"homology__ortholog_one2many":{"group":"homology","label":"1:many orthologs","multiValued":true,"order":17},"homology__ortholog_many2many":{"group":"homology","label":"Many:many orthologs","multiValued":true,"order":18},"homology__syntenic_ortholog_one2one":{"group":"homology","label":"Syntenic 1:1 orthologs","multiValued":true,"order":19},"homology__within_species_paralog":{"group":"homology","label":"Within-species paralogs","multiValued":true,"order":20},"pathways__ancestors":{"group":"hierarchical","label":"Pathways","multiValued":true,"order":5},"canonical_transcript__attr_s":{"group":"structure","label":"Canonical transcript ID"}},"hidden":["_version_","_terms","score","gene_idx","gene_idx_multi","species_idx","compara_idx","compara_idx_multi","_id","annotations","bins","gene_structure","homology","location","xrefs","domain_roots","familyRoot__ancestors","taxonomy__ancestors","capabilities","saved_search"]}');
const $49d5cbca2ec74b2f$export$428c2f647a2a7545 = {
    'sorghum_bicolor': {
        '1': {
            label: 'Purdue EMS',
            type: 'EMS'
        },
        '2': {
            label: 'USDA Lubbock EMS',
            type: 'EMS'
        },
        '3': {
            label: 'Lozano',
            type: 'NAT'
        },
        '4': {
            label: 'USDA Lubbock EMS',
            type: 'EMS'
        },
        '5': {
            label: 'Boatwright SAP',
            type: 'NAT'
        },
        '7': {
            label: 'Kumar BAP',
            type: 'NAT'
        },
        '8': {
            label: 'Lasky landraces',
            type: 'NAT'
        },
        '9': {
            label: 'Sorghum Genomics Toolbox',
            type: 'NAT'
        }
    },
    'zea_maysb73': {
        '15': {
            label: 'MaizeGDB 2024',
            type: 'NAT'
        }
    },
    'oryza_sativa': {
        '7': {
            label: 'Rice 3K',
            type: 'NAT'
        },
        '20': {
            label: '19K-RGP',
            type: 'NAT'
        },
        '29': {
            label: 'Rice USDA mini core',
            type: 'NAT'
        },
        '38': {
            label: 'RAPDB 2024',
            type: 'NAT'
        }
    },
    'oryza_aus': {
        '20': {
            label: '19K-RGP',
            type: 'NAT'
        }
    },
    'oryza_sativa117425': {
        '20': {
            label: '19K-RGP',
            type: 'NAT'
        }
    },
    'oryza_sativair64rs2': {
        '20': {
            label: '19K-RGP',
            type: 'NAT'
        }
    },
    'oryza_sativamh63': {
        '20': {
            label: '19K-RGP',
            type: 'NAT'
        }
    }
};
// Fields matched by these globs are multi-valued in Solr.
const $0f839422d0d8c772$var$MULTIVALUED_PATTERNS = [
    /__expr$/,
    /__ancestors$/,
    /__xrefs$/,
    /__attr_ss$/,
    /^alt_id$/,
    /^VEP__/,
    /^homology__/
];
function $0f839422d0d8c772$var$parseCsvHeader(text) {
    if (!text) return [];
    const line = text.split(/\r?\n/, 1)[0] || '';
    return line.split(',').map((s)=>s.trim().replace(/^"|"$/g, '')).filter(Boolean);
}
function $0f839422d0d8c772$var$synthesizedValue(name) {
    return $0f839422d0d8c772$var$MULTIVALUED_PATTERNS.some((re)=>re.test(name)) ? [
        0
    ] : 0;
}
function $0f839422d0d8c772$var$applyTemplate(tpl, match) {
    if (!tpl) return null;
    return tpl.replace(/\$(\d+)/g, (_, n)=>match[+n] || '');
}
function $0f839422d0d8c772$var$vepDetailLabel(matchGroups) {
    const [, , system, sid] = matchGroups || [];
    const info = ($49d5cbca2ec74b2f$export$428c2f647a2a7545[system] || {})[sid];
    if (info) return info.label;
    return `${system}/${sid}`;
}
function $0f839422d0d8c772$var$vepDetailTsvHeader(matchGroups) {
    const [conseq, zyg, system, sid] = matchGroups || [];
    const info = ($49d5cbca2ec74b2f$export$428c2f647a2a7545[system] || {})[sid];
    const type = info && info.type || '?';
    const study = info && info.label || `${system}/${sid}`;
    return `${type}\xb7${conseq}\xb7${zyg}\xb7${study}`;
}
function $0f839422d0d8c772$var$vepMergedLabel(matchGroups) {
    const [kind] = matchGroups || [];
    if (kind === 'NAT') return 'Merged natural population accessions';
    if (kind === 'EMS') return 'Merged EMS mutant accessions';
    return `Merged ${kind} accessions`;
}
function $0f839422d0d8c772$var$vepMergedTsvHeader(matchGroups) {
    const [kind] = matchGroups || [];
    return `merged\xb7${kind}`;
}
function $0f839422d0d8c772$var$classifyKey(name, patterns) {
    for (const p of patterns){
        const re = new RegExp(p.match);
        const m = name.match(re);
        if (m) return {
            patternId: p.id,
            group: p.group,
            label: $0f839422d0d8c772$var$applyTemplate(p.labelTemplate, m) || name,
            multiValued: !!p.multiValued,
            expression: !!p.expression,
            isHidden: !!p.is_hidden,
            matchGroups: m.slice(1)
        };
    }
    return null;
}
function $0f839422d0d8c772$var$inferType(value) {
    if (value === null || value === undefined) return 'unknown';
    if (Array.isArray(value)) return 'array<' + (value.length ? $0f839422d0d8c772$var$inferType(value[0]) : 'unknown') + '>';
    return typeof value;
}
function $0f839422d0d8c772$var$buildCatalog(sampleDocs) {
    const hidden = new Set(/*@__PURE__*/ $parcel$interopDefault($65709bd8598fce20$exports).hidden || []);
    const overlayFields = /*@__PURE__*/ $parcel$interopDefault($65709bd8598fce20$exports).fields || {};
    const patterns = /*@__PURE__*/ $parcel$interopDefault($65709bd8598fce20$exports).patterns || [];
    const groupsMeta = /*@__PURE__*/ $parcel$interopDefault($65709bd8598fce20$exports).groups || {};
    // Union keys from overlay.fields (hardcoded catalog entries) and sample docs.
    const keys = new Set(Object.keys(overlayFields));
    const sampleValues = {};
    for (const doc of sampleDocs || [])for (const [k, v] of Object.entries(doc)){
        keys.add(k);
        if (!(k in sampleValues)) sampleValues[k] = v;
    }
    const fields = {};
    for (const name of keys){
        if (hidden.has(name)) continue;
        const overlayEntry = overlayFields[name];
        const classified = overlayEntry ? null : $0f839422d0d8c772$var$classifyKey(name, patterns);
        if (classified && classified.isHidden) continue;
        const sampleVal = sampleValues[name];
        const sampleType = sampleVal !== undefined ? $0f839422d0d8c772$var$inferType(sampleVal) : null;
        const group = overlayEntry && overlayEntry.group || classified && classified.group || 'other';
        let label = overlayEntry && overlayEntry.label || classified && classified.label || name;
        let tsvHeader = null;
        if (classified && classified.patternId === 'vep_detail') {
            label = $0f839422d0d8c772$var$vepDetailLabel(classified.matchGroups);
            tsvHeader = $0f839422d0d8c772$var$vepDetailTsvHeader(classified.matchGroups);
        } else if (classified && classified.patternId === 'vep_merged') {
            label = $0f839422d0d8c772$var$vepMergedLabel(classified.matchGroups);
            tsvHeader = $0f839422d0d8c772$var$vepMergedTsvHeader(classified.matchGroups);
        }
        const multiValued = overlayEntry && overlayEntry.multiValued || classified && classified.multiValued || sampleType && sampleType.startsWith('array<') || false;
        fields[name] = {
            name: name,
            label: label,
            tsvHeader: tsvHeader,
            group: group,
            order: overlayEntry && overlayEntry.order != null ? overlayEntry.order : null,
            description: overlayEntry && overlayEntry.description || '',
            type: sampleType || 'unknown',
            multiValued: multiValued,
            patternId: classified ? classified.patternId : null,
            matchGroups: classified ? classified.matchGroups : null,
            expression: !!(classified && classified.expression),
            source: overlayEntry ? 'overlay' : 'sample'
        };
    }
    // Build groups (explicit overlay.order first, then natural sort by label)
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'base'
    });
    const compareFields = (a, b)=>{
        const ao = a.order, bo = b.order;
        if (ao != null && bo != null && ao !== bo) return ao - bo;
        if (ao != null && bo == null) return -1;
        if (ao == null && bo != null) return 1;
        return collator.compare(a.label, b.label);
    };
    const groupIds = new Set(Object.values(fields).map((f)=>f.group));
    const groups = Array.from(groupIds).map((id)=>({
            id: id,
            label: groupsMeta[id] && groupsMeta[id].label || id,
            order: (groupsMeta[id] && groupsMeta[id].order) != null ? groupsMeta[id].order : 50,
            fields: Object.values(fields).filter((f)=>f.group === id).sort(compareFields).map((f)=>f.name)
        })).sort((a, b)=>a.order - b.order);
    return {
        fetchedAt: Date.now(),
        groups: groups,
        fields: fields
    };
}
const $0f839422d0d8c772$var$grameneFieldCatalog = (0, $gXNCa$reduxbundler.createAsyncResourceBundle)({
    name: 'grameneFieldCatalog',
    actionBaseType: 'GRAMENE_FIELD_CATALOG',
    persist: true,
    staleAfter: 86400000,
    getPromise: ({ store: store })=>{
        const api = store.selectGrameneAPI();
        const url = `${api}/search?q=*:*&rows=0&wt=csv&fl=*`;
        return fetch(url).then((r)=>r.text()).then((text)=>$0f839422d0d8c772$var$parseCsvHeader(text)).catch(()=>null);
    }
});
// Auto-fetch the field catalog only when a view that needs it (exprViz fields
// modal, exporter field tree, attribute-table column picker) is enabled. Other
// views never read it.
const $0f839422d0d8c772$var$FIELD_CATALOG_VIEWS = [
    'exprViz',
    'export',
    'attrTable'
];
$0f839422d0d8c772$var$grameneFieldCatalog.reactGrameneFieldCatalog = (0, $gXNCa$reduxbundler.createSelector)('selectGrameneFieldCatalogShouldUpdate', 'selectGrameneViewsOn', (shouldUpdate, viewsOn)=>{
    if (!shouldUpdate) return;
    if (!viewsOn || !$0f839422d0d8c772$var$FIELD_CATALOG_VIEWS.some((id)=>viewsOn.has(id))) return;
    return {
        actionCreator: 'doFetchGrameneFieldCatalog'
    };
});
function $0f839422d0d8c772$var$assayFactorLabel(assay) {
    if (!assay) return '';
    const factors = Array.isArray(assay.factor) ? assay.factor : [];
    const labels = factors.map((f)=>f && f.label).filter(Boolean);
    if (labels.length) return labels.join('; ');
    const chars = Array.isArray(assay.characteristic) ? assay.characteristic : [];
    const organ = chars.find((c)=>c && c.type === 'organism part');
    return organ && organ.label || '';
}
function $0f839422d0d8c772$var$parseTaxonFacet(grameneSearch, grameneMaps) {
    const arr = grameneSearch && grameneSearch.facet_counts && grameneSearch.facet_counts.facet_fields && grameneSearch.facet_counts.facet_fields.taxon_id;
    if (!Array.isArray(arr) || !arr.length) return null;
    // Search taxon_ids are strain-specific (e.g. 3702001); experiments use
    // species-level NCBI taxon_ids (e.g. 3702). Map via grameneMaps.anchor_taxon_id.
    // If maps aren't loaded yet, skip filtering rather than drop everything.
    if (!grameneMaps || !Object.keys(grameneMaps).length) return null;
    const speciesTaxa = new Set();
    for(let i = 0; i < arr.length; i += 2){
        const tid = arr[i];
        if (arr[i + 1] <= 0) continue;
        const map = grameneMaps[tid];
        const anchor = map && map.anchor_taxon_id;
        speciesTaxa.add(Number(anchor || tid));
    }
    return speciesTaxa.size ? speciesTaxa : null;
}
function $0f839422d0d8c772$var$buildExperimentTaxonIndex(expressionStudies) {
    const index = {};
    if (!expressionStudies) return index;
    for (const [taxon, arr] of Object.entries(expressionStudies)){
        if (!Array.isArray(arr)) continue;
        for (const e of arr)if (e && e._id) index[e._id] = Number(taxon);
    }
    return index;
}
function $0f839422d0d8c772$var$buildExperimentTitleIndex(expressionStudies) {
    const index = {};
    if (!expressionStudies) return index;
    for (const arr of Object.values(expressionStudies)){
        if (!Array.isArray(arr)) continue;
        for (const e of arr)if (e && e._id) index[e._id] = e.description || e.title || '';
    }
    return index;
}
// Label for each species group, used by the expression and differential-expression
// field pickers.
//
// A group can hold many genomes — sorghum_v11 has 120 under 4558 — so which one
// supplies the label matters. This took the first it encountered, and since
// grameneMaps is keyed by taxon_id, Object.values walks integer-like keys in
// ascending numeric order: 4558001 (Sb verticilliflorum 353, a wild relative) beat
// the anchor 4558006 (Sb bicolor BTx623 v3). Searching msd2 then returned a BTx623
// gene while the picker was labelled with a different genome entirely. Every other
// group here holds exactly one genome, which is why only sorghum showed it.
//
// Prefer the group's anchor, falling back to first-seen for releases that carry no
// anchor flags at all (gramene main today).
function $0f839422d0d8c772$var$buildSpeciesNameIndex(grameneMaps) {
    const idx = {};
    if (!grameneMaps) return idx;
    const genomes = Object.values(grameneMaps);
    for (const m of genomes)if (m && m.anchor_taxon_id && m.is_anchor) idx[m.anchor_taxon_id] = m.display_name || String(m.anchor_taxon_id);
    for (const m of genomes)if (m && m.anchor_taxon_id && !idx[m.anchor_taxon_id]) idx[m.anchor_taxon_id] = m.display_name || String(m.anchor_taxon_id);
    return idx;
}
function $0f839422d0d8c772$var$fieldExperimentId(name) {
    let m = name.match(/^(\w+?)_g\d+__expr$/);
    if (m) return m[1].replace(/_/g, '-');
    m = name.match(/^(\w+?)_g\d+_g\d+_(pval|l2fc)_attr_[a-z]$/);
    if (m) return m[1].replace(/_/g, '-');
    return null;
}
const $0f839422d0d8c772$var$STAT_RANK = {
    l2fc: 0,
    pval: 1
};
function $0f839422d0d8c772$var$collapseDiffExprInSubgroups(subgroups, fieldsOut, collator) {
    for (const taxGroup of subgroups)for (const expGroup of taxGroup.subgroups || []){
        const contrastMap = new Map();
        const others = [];
        for (const name of expGroup.fields || []){
            const f = fieldsOut[name];
            if (!f || f.patternId !== 'diffexpr') {
                others.push(name);
                continue;
            }
            const mg = f.matchGroups || [];
            const key = `${mg[1]}|${mg[2]}`;
            let arr = contrastMap.get(key);
            if (!arr) {
                arr = [];
                contrastMap.set(key, arr);
            }
            arr.push(name);
        }
        const newFields = [
            ...others
        ];
        for (const names of contrastMap.values()){
            if (names.length === 1) {
                newFields.push(names[0]);
                continue;
            }
            names.sort((a, b)=>{
                const ra = $0f839422d0d8c772$var$STAT_RANK[(fieldsOut[a].matchGroups || [])[3]] ?? 99;
                const rb = $0f839422d0d8c772$var$STAT_RANK[(fieldsOut[b].matchGroups || [])[3]] ?? 99;
                if (ra !== rb) return ra - rb;
                return collator.compare(a, b);
            });
            const rep = names[0];
            const repEntry = fieldsOut[rep];
            const label = (repEntry.label || rep).replace(/\s+\((?:pval|l2fc)\)/, '');
            fieldsOut[rep] = {
                ...repEntry,
                label: label,
                linkedFields: names.slice()
            };
            newFields.push(rep);
        }
        expGroup.fields = newFields;
    }
}
function $0f839422d0d8c772$var$buildExpressionSubgroups(fieldNames, fieldsOut, experimentTaxa, experimentTitles, speciesNames, collator) {
    const byTaxon = new Map();
    const orphans = [];
    const studiesLoaded = Object.keys(experimentTaxa).length > 0;
    for (const name of fieldNames){
        const expId = $0f839422d0d8c772$var$fieldExperimentId(name);
        if (!expId) {
            orphans.push(name);
            continue;
        }
        const taxon = experimentTaxa[expId];
        if (!taxon) {
            if (studiesLoaded) continue;
            orphans.push(name);
            continue;
        }
        let taxonEntry = byTaxon.get(taxon);
        if (!taxonEntry) {
            taxonEntry = new Map();
            byTaxon.set(taxon, taxonEntry);
        }
        let expEntry = taxonEntry.get(expId);
        if (!expEntry) {
            expEntry = [];
            taxonEntry.set(expId, expEntry);
        }
        expEntry.push(name);
    }
    const taxonGroups = [];
    for (const [taxon, expMap] of byTaxon){
        const experiments = [];
        for (const [expId, names] of expMap){
            names.sort((a, b)=>collator.compare(fieldsOut[a].label, fieldsOut[b].label));
            const title = experimentTitles && experimentTitles[expId];
            experiments.push({
                id: 'exp-' + expId,
                label: title ? `${expId} \u{2014} ${title}` : expId,
                fields: names
            });
        }
        experiments.sort((a, b)=>collator.compare(a.label, b.label));
        taxonGroups.push({
            id: 'tax-' + taxon,
            label: speciesNames[taxon] || `taxon ${taxon}`,
            taxon: taxon,
            subgroups: experiments
        });
    }
    taxonGroups.sort((a, b)=>collator.compare(a.label, b.label));
    return {
        subgroups: taxonGroups,
        orphans: orphans
    };
}
function $0f839422d0d8c772$var$buildVepSubgroups(fieldNames, fieldsOut, collator) {
    const buckets = {
        NAT: {
            merged: [],
            byConseq: new Map()
        },
        EMS: {
            merged: [],
            byConseq: new Map()
        }
    };
    const orphans = [];
    for (const name of fieldNames){
        const f = fieldsOut[name];
        if (!f) {
            orphans.push(name);
            continue;
        }
        if (f.patternId === 'vep_merged') {
            const kind = f.matchGroups && f.matchGroups[0] || '';
            if (buckets[kind]) buckets[kind].merged.push(name);
            else orphans.push(name);
        } else if (f.patternId === 'vep_detail') {
            const mg = f.matchGroups || [];
            const [conseq, zyg, system, sid] = mg;
            const info = ($49d5cbca2ec74b2f$export$428c2f647a2a7545[system] || {})[sid];
            const kind = info && info.type;
            if (!buckets[kind]) {
                orphans.push(name);
                continue;
            }
            let zmap = buckets[kind].byConseq.get(conseq);
            if (!zmap) {
                zmap = new Map();
                buckets[kind].byConseq.set(conseq, zmap);
            }
            let arr = zmap.get(zyg);
            if (!arr) {
                arr = [];
                zmap.set(zyg, arr);
            }
            arr.push(name);
        } else orphans.push(name);
    }
    const kindLabels = {
        NAT: 'Natural populations',
        EMS: 'Mutant populations'
    };
    const subgroups = [];
    for (const kind of [
        'NAT',
        'EMS'
    ]){
        const bucket = buckets[kind];
        if (!bucket.merged.length && bucket.byConseq.size === 0) continue;
        const conseqGroups = [];
        for (const [conseq, zmap] of bucket.byConseq){
            const zygGroups = [];
            for (const [zyg, names] of zmap){
                names.sort((a, b)=>collator.compare(fieldsOut[a].label, fieldsOut[b].label));
                zygGroups.push({
                    id: `lof-${kind}-${conseq}-${zyg}`,
                    label: zyg === 'het' ? 'heterozygous' : 'homozygous',
                    fields: names
                });
            }
            zygGroups.sort((a, b)=>collator.compare(a.label, b.label));
            conseqGroups.push({
                id: `lof-${kind}-${conseq}`,
                label: conseq.replace(/_/g, ' '),
                subgroups: zygGroups
            });
        }
        conseqGroups.sort((a, b)=>collator.compare(a.label, b.label));
        bucket.merged.sort((a, b)=>collator.compare(fieldsOut[a].label, fieldsOut[b].label));
        subgroups.push({
            id: `lof-${kind}`,
            label: kindLabels[kind],
            fields: bucket.merged,
            subgroups: conseqGroups
        });
    }
    return {
        subgroups: subgroups,
        orphans: orphans
    };
}
function $0f839422d0d8c772$var$enrichLabels(catalog, expressionStudies, expressionSamples, grameneSearch, grameneMaps) {
    if (!catalog || !catalog.fields) return catalog;
    if (!expressionSamples) return catalog;
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'base'
    });
    const taxaInResults = $0f839422d0d8c772$var$parseTaxonFacet(grameneSearch, grameneMaps);
    const experimentTaxa = $0f839422d0d8c772$var$buildExperimentTaxonIndex(expressionStudies);
    const experimentTitles = $0f839422d0d8c772$var$buildExperimentTitleIndex(expressionStudies);
    const dropped = new Set();
    const fieldsOut = {};
    for (const [name, f] of Object.entries(catalog.fields)){
        if (f.patternId !== 'expr' && f.patternId !== 'diffexpr') {
            fieldsOut[name] = f;
            continue;
        }
        const mg = f.matchGroups || [];
        const experimentSolr = mg[0];
        if (!experimentSolr) {
            fieldsOut[name] = f;
            continue;
        }
        const experimentId = experimentSolr.replace(/_/g, '-');
        if (taxaInResults) {
            const expTaxon = experimentTaxa[experimentId];
            if (expTaxon && !taxaInResults.has(expTaxon)) {
                dropped.add(name);
                continue;
            }
        }
        const assays = expressionSamples[experimentId] || [];
        let newLabel = f.label;
        if (f.patternId === 'expr') {
            const g = 'g' + mg[1];
            const assay = assays.find((a)=>a && a.group === g);
            const desc = $0f839422d0d8c772$var$assayFactorLabel(assay);
            newLabel = desc ? `${experimentId} ${g}: ${desc}` : `${experimentId} ${g}`;
        } else {
            const gA = 'g' + mg[1];
            const gB = 'g' + mg[2];
            const metric = mg[3];
            const aA = assays.find((a)=>a && a.group === gA);
            const aB = assays.find((a)=>a && a.group === gB);
            const dA = $0f839422d0d8c772$var$assayFactorLabel(aA);
            const dB = $0f839422d0d8c772$var$assayFactorLabel(aB);
            const pair = dA && dB ? `: ${dA} vs ${dB}` : '';
            newLabel = `${experimentId} ${gA} vs ${gB} (${metric})${pair}`;
        }
        fieldsOut[name] = newLabel !== f.label ? {
            ...f,
            label: newLabel
        } : f;
    }
    // Synthesize any expr fields missing from catalog.fields using the complete
    // assays collection. The doc-sample only surfaces expr keys that happened to
    // appear in the sampled genes; assays is authoritative per-experiment.
    const synthesized = [];
    for (const [experimentId, assays] of Object.entries(expressionSamples)){
        if (taxaInResults) {
            const expTaxon = experimentTaxa[experimentId];
            if (expTaxon && !taxaInResults.has(expTaxon)) continue;
        }
        const solrPrefix = experimentId.replace(/-/g, '_');
        for (const assay of assays){
            if (!assay || !assay.group) continue;
            const name = `${solrPrefix}_${assay.group}__expr`;
            if (fieldsOut[name]) continue;
            const desc = $0f839422d0d8c772$var$assayFactorLabel(assay);
            fieldsOut[name] = {
                name: name,
                label: desc ? `${experimentId} ${assay.group}: ${desc}` : `${experimentId} ${assay.group}`,
                group: 'expression',
                description: '',
                type: 'array<float>',
                multiValued: true,
                patternId: 'expr',
                matchGroups: [
                    solrPrefix,
                    assay.group.replace(/^g/, '')
                ],
                expression: true,
                source: 'assays'
            };
            synthesized.push(name);
        }
    }
    const speciesNames = $0f839422d0d8c772$var$buildSpeciesNameIndex(grameneMaps);
    const groups = catalog.groups.map((g)=>{
        let list = dropped.size ? g.fields.filter((n)=>!dropped.has(n)) : g.fields;
        if (g.id === 'expression' && synthesized.length) {
            const existing = new Set(list);
            list = [
                ...list,
                ...synthesized.filter((n)=>!existing.has(n))
            ];
        }
        if (g.id === 'lof') {
            const { subgroups: subgroups, orphans: orphans } = $0f839422d0d8c772$var$buildVepSubgroups(list, fieldsOut, collator);
            orphans.sort((a, b)=>collator.compare(fieldsOut[a].label, fieldsOut[b].label));
            return {
                ...g,
                fields: orphans,
                subgroups: subgroups
            };
        }
        if (g.id !== 'expression' && g.id !== 'differential') return list === g.fields ? g : {
            ...g,
            fields: list
        };
        const { subgroups: subgroups, orphans: orphans } = $0f839422d0d8c772$var$buildExpressionSubgroups(list, fieldsOut, experimentTaxa, experimentTitles, speciesNames, collator);
        if (g.id === 'differential') $0f839422d0d8c772$var$collapseDiffExprInSubgroups(subgroups, fieldsOut, collator);
        orphans.sort((a, b)=>collator.compare(fieldsOut[a].label, fieldsOut[b].label));
        return {
            ...g,
            fields: orphans,
            subgroups: subgroups
        };
    });
    return {
        ...catalog,
        fields: fieldsOut,
        groups: groups
    };
}
function $0f839422d0d8c772$var$filterCatalogByPresentFields(catalog, present) {
    if (!catalog || !catalog.fields || !present) return catalog;
    const filteredFields = {};
    for (const [name, f] of Object.entries(catalog.fields))if (present.has(name)) filteredFields[name] = f;
    const hasContent = (g)=>g.fields && g.fields.length > 0 || g.subgroups && g.subgroups.some(hasContent);
    const filterGroup = (g)=>{
        const fields = (g.fields || []).filter((n)=>present.has(n));
        const subgroups = (g.subgroups || []).map(filterGroup).filter(hasContent);
        return {
            ...g,
            fields: fields,
            subgroups: subgroups
        };
    };
    const groups = (catalog.groups || []).map(filterGroup).filter(hasContent);
    return {
        ...catalog,
        fields: filteredFields,
        groups: groups
    };
}
$0f839422d0d8c772$var$grameneFieldCatalog.selectFieldCatalog = (0, $gXNCa$reduxbundler.createSelector)('selectGrameneFieldCatalog', 'selectExpressionStudies', 'selectExpressionSamples', 'selectGrameneSearch', 'selectGrameneMaps', (fieldNames, studies, samples, search, maps)=>{
    if (!fieldNames || !fieldNames.length) return null;
    const present = new Set(fieldNames);
    // Build a synthetic doc from the discovered field names; values carry the
    // right JS type so inferType picks the correct multiValued/type (arrays
    // for multi-valued fields, scalars otherwise). Derive the pval companion
    // from every l2fc field.
    const doc = {};
    for (const name of present){
        doc[name] = $0f839422d0d8c772$var$synthesizedValue(name);
        if (/_l2fc_attr_f$/.test(name)) doc[name.replace('_l2fc_', '_pval_')] = 0;
    }
    const catalog = $0f839422d0d8c772$var$buildCatalog([
        doc
    ]);
    const enriched = $0f839422d0d8c772$var$enrichLabels(catalog, studies, samples, search, maps);
    return $0f839422d0d8c772$var$filterCatalogByPresentFields(enriched, present);
});
$0f839422d0d8c772$var$grameneFieldCatalog.selectFieldCatalogGroups = (0, $gXNCa$reduxbundler.createSelector)('selectFieldCatalog', (catalog)=>catalog && catalog.groups || []);
$0f839422d0d8c772$var$grameneFieldCatalog.selectFieldCatalogByName = (0, $gXNCa$reduxbundler.createSelector)('selectFieldCatalog', (catalog)=>catalog && catalog.fields || {});
var $0f839422d0d8c772$export$2e2bcd8739ae039 = $0f839422d0d8c772$var$grameneFieldCatalog;
const $6d28e8e62a4d602f$var$EXPR_FIELD_RE = /^(E[-_][A-Za-z0-9_-]+?)_g(\d+)__expr$/;
const $6d28e8e62a4d602f$var$DIFFEXPR_FIELD_RE = /^(E[-_][A-Za-z0-9_-]+?)_g(\d+)_g(\d+)_(pval|l2fc)_attr_([a-z])$/;
const $6d28e8e62a4d602f$export$adbe84e3322ddf23 = [
    'experiment',
    'experiment_name',
    'assay',
    'sample',
    'value'
];
const $6d28e8e62a4d602f$export$576cc3c28e73797f = [
    'diff_experiment',
    'diff_experiment_name',
    'group1_factors',
    'group2_factors',
    'l2fc',
    'pval'
];
function $6d28e8e62a4d602f$export$394b4eedba762a22(name) {
    const m = name.match($6d28e8e62a4d602f$var$EXPR_FIELD_RE);
    if (!m) return null;
    return {
        experimentId: m[1].replace(/_/g, '-'),
        group: 'g' + m[2],
        solrField: name
    };
}
function $6d28e8e62a4d602f$export$7cfc45ad860a43b9(name) {
    const m = name.match($6d28e8e62a4d602f$var$DIFFEXPR_FIELD_RE);
    if (!m) return null;
    return {
        experimentId: m[1].replace(/_/g, '-'),
        group1: 'g' + m[2],
        group2: 'g' + m[3],
        stat: m[4],
        solrField: name
    };
}
function $6d28e8e62a4d602f$export$610263731bc16395(name, catalog) {
    const entry = catalog && catalog.fields && catalog.fields[name];
    if (entry && entry.expression) return true;
    return $6d28e8e62a4d602f$export$394b4eedba762a22(name) !== null;
}
function $6d28e8e62a4d602f$export$7e8e9de1a0db50f6(name, catalog) {
    const entry = catalog && catalog.fields && catalog.fields[name];
    if (entry && entry.diffExpression) return true;
    return $6d28e8e62a4d602f$export$7cfc45ad860a43b9(name) !== null;
}
function $6d28e8e62a4d602f$export$f53c4708f5c8e834(fieldNames, catalog) {
    const expressionFields = [];
    const diffExpressionFields = [];
    const nonExpressionFields = [];
    for (const n of fieldNames){
        if ($6d28e8e62a4d602f$export$7e8e9de1a0db50f6(n, catalog)) diffExpressionFields.push(n);
        else if ($6d28e8e62a4d602f$export$610263731bc16395(n, catalog)) expressionFields.push(n);
        else nonExpressionFields.push(n);
    }
    return {
        expressionFields: expressionFields,
        diffExpressionFields: diffExpressionFields,
        nonExpressionFields: nonExpressionFields
    };
}
function $6d28e8e62a4d602f$var$joinLabels(arr) {
    if (!Array.isArray(arr)) return '';
    return arr.map((f)=>f && f.label).filter(Boolean).join('; ');
}
function $6d28e8e62a4d602f$export$e4d005060518cfb(expressionStudies) {
    const index = {};
    if (!expressionStudies) return index;
    for (const arr of Object.values(expressionStudies)){
        if (!Array.isArray(arr)) continue;
        for (const e of arr)if (e && e._id) index[e._id] = e;
    }
    return index;
}
function $6d28e8e62a4d602f$var$findAssay(expressionSamples, experimentId, group) {
    if (!expressionSamples) return null;
    const arr = expressionSamples[experimentId];
    if (!arr) return null;
    return arr.find((a)=>a.group === group) || null;
}
function $6d28e8e62a4d602f$export$e11f1dd766d5ba07(doc, expressionFields, expressionStudies, expressionSamples, cutoffs) {
    const rows = [];
    const experimentIndex = $6d28e8e62a4d602f$export$e4d005060518cfb(expressionStudies);
    const minTPM = cutoffs && cutoffs.exprMinTPM;
    const minTPMActive = minTPM !== null && minTPM !== undefined && minTPM !== '' && Number.isFinite(+minTPM);
    for (const fieldName of expressionFields){
        const parsed = $6d28e8e62a4d602f$export$394b4eedba762a22(fieldName);
        if (!parsed) continue;
        const val = doc[fieldName];
        if (val === undefined || val === null) continue;
        if (minTPMActive && (!Number.isFinite(+val) || +val < +minTPM)) continue;
        const exp = experimentIndex[parsed.experimentId];
        const assay = $6d28e8e62a4d602f$var$findAssay(expressionSamples, parsed.experimentId, parsed.group);
        rows.push({
            field: fieldName,
            experiment: parsed.experimentId,
            experiment_name: exp ? exp.description || exp.title || exp.name || '' : '',
            assay: parsed.group,
            sample: assay ? $6d28e8e62a4d602f$var$joinLabels(assay.factor) || $6d28e8e62a4d602f$var$joinLabels(assay.characteristic) : '',
            value: val
        });
    }
    return rows;
}
function $6d28e8e62a4d602f$export$ba4cd509d0763838(doc, diffExpressionFields, expressionStudies, expressionSamples, cutoffs) {
    const experimentIndex = $6d28e8e62a4d602f$export$e4d005060518cfb(expressionStudies);
    const byContrast = new Map();
    for (const fieldName of diffExpressionFields){
        const parsed = $6d28e8e62a4d602f$export$7cfc45ad860a43b9(fieldName);
        if (!parsed) continue;
        const val = doc[fieldName];
        if (val === undefined || val === null) continue;
        const key = `${parsed.experimentId}|${parsed.group1}|${parsed.group2}`;
        let entry = byContrast.get(key);
        if (!entry) {
            entry = {
                experimentId: parsed.experimentId,
                group1: parsed.group1,
                group2: parsed.group2,
                pval: '',
                l2fc: ''
            };
            byContrast.set(key, entry);
        }
        if (parsed.stat === 'pval') entry.pval = val;
        else entry.l2fc = val;
    }
    const maxPval = cutoffs && cutoffs.diffMaxPval;
    const maxPvalActive = maxPval !== null && maxPval !== undefined && maxPval !== '' && Number.isFinite(+maxPval);
    const rows = [];
    for (const entry of byContrast.values()){
        if (maxPvalActive) {
            const pv = +entry.pval;
            if (!Number.isFinite(pv) || pv > +maxPval) continue;
        }
        const exp = experimentIndex[entry.experimentId];
        const assay1 = $6d28e8e62a4d602f$var$findAssay(expressionSamples, entry.experimentId, entry.group1);
        const assay2 = $6d28e8e62a4d602f$var$findAssay(expressionSamples, entry.experimentId, entry.group2);
        rows.push({
            diff_experiment: entry.experimentId,
            diff_experiment_name: exp ? exp.description || exp.title || exp.name || '' : '',
            group1_factors: assay1 ? $6d28e8e62a4d602f$var$joinLabels(assay1.factor) || $6d28e8e62a4d602f$var$joinLabels(assay1.characteristic) : entry.group1,
            group2_factors: assay2 ? $6d28e8e62a4d602f$var$joinLabels(assay2.factor) || $6d28e8e62a4d602f$var$joinLabels(assay2.characteristic) : entry.group2,
            l2fc: entry.l2fc,
            pval: entry.pval
        });
    }
    return rows;
}
// Maps gene-doc field name -> ontology key used for resolution.
const $2dcf7b48843b00bc$export$a63736950501bd11 = {
    GO__ancestors: 'GO',
    PO__ancestors: 'PO',
    TO__ancestors: 'TO',
    QTL_TO__ancestors: 'TO',
    domains__ancestors: 'domains',
    pathways__ancestors: 'pathways',
    taxonomy__ancestors: 'taxonomy'
};
const $2dcf7b48843b00bc$export$646f2c3f1db884c4 = {
    GO__ancestors: 'Gene Ontology',
    PO__ancestors: 'Plant Ontology',
    TO__ancestors: 'Trait Ontology',
    QTL_TO__ancestors: 'Trait Ontology',
    domains__ancestors: 'InterPro',
    pathways__ancestors: 'Plant Reactome',
    taxonomy__ancestors: 'Taxonomy'
};
const $2dcf7b48843b00bc$export$37f9358aca2dda70 = [
    'hierarchy',
    'term_id',
    'term_name',
    'term_type'
];
function $2dcf7b48843b00bc$export$bc587a3f4ee444a9(name) {
    return Object.prototype.hasOwnProperty.call($2dcf7b48843b00bc$export$a63736950501bd11, name);
}
function $2dcf7b48843b00bc$export$d19015c8e085afd0(fieldNames) {
    const ancestor = [];
    const plain = [];
    for (const n of fieldNames)if ($2dcf7b48843b00bc$export$bc587a3f4ee444a9(n)) ancestor.push(n);
    else plain.push(n);
    return {
        ancestor: ancestor,
        plain: plain
    };
}
function $2dcf7b48843b00bc$export$6cd55d301c37aeed(docs, fieldNames) {
    const byOnt = {};
    for (const name of fieldNames){
        const ont = $2dcf7b48843b00bc$export$a63736950501bd11[name];
        if (!ont) continue;
        if (!byOnt[ont]) byOnt[ont] = new Set();
        for (const d of docs || []){
            const v = d && d[name];
            if (!Array.isArray(v)) continue;
            for (const id of v)if (id != null) byOnt[ont].add(+id);
        }
    }
    const out = {};
    for (const k of Object.keys(byOnt))out[k] = Array.from(byOnt[k]);
    return out;
}
function $2dcf7b48843b00bc$var$getOntologyRecord(ontKey, id, ctx) {
    if (!ctx) return null;
    const idNum = +id;
    if (ontKey === 'taxonomy') {
        const t = ctx.taxonomy;
        return t && t[idNum] || null;
    }
    if (ontKey === 'pathways') {
        const p = ctx.pathways;
        return p && p[idNum] || null;
    }
    const bucket = ctx.ontologies && ctx.ontologies[ontKey];
    return bucket && bucket[idNum] || null;
}
// Returns list of ancestor ids *excluding* self.
function $2dcf7b48843b00bc$var$ancestorsOfRecord(ontKey, record, docTaxonId, ctx) {
    if (!record) return null;
    if (ontKey === 'taxonomy') {
        const visited = new Set();
        const stack = Array.isArray(record.is_a) ? record.is_a.slice() : [];
        const taxonomy = ctx && ctx.taxonomy || {};
        while(stack.length){
            const pid = +stack.pop();
            if (visited.has(pid)) continue;
            visited.add(pid);
            const parent = taxonomy[pid];
            if (parent && Array.isArray(parent.is_a)) {
                for (const g of parent.is_a)if (!visited.has(+g)) stack.push(g);
            }
        }
        return Array.from(visited);
    }
    if (ontKey === 'pathways') {
        const taxonKey = docTaxonId != null ? `ancestors_${docTaxonId}` : null;
        let arr = taxonKey && record[taxonKey];
        if (!Array.isArray(arr)) {
            const collected = new Set();
            for (const k of Object.keys(record)){
                if (k.startsWith('ancestors_') && Array.isArray(record[k])) for (const a of record[k])collected.add(+a);
            }
            arr = Array.from(collected);
        }
        return arr.filter((x)=>+x !== +record._id);
    }
    // GO / PO / TO / domains — `ancestors` already includes self
    if (Array.isArray(record.ancestors)) return record.ancestors.filter((x)=>+x !== +record._id);
    return [];
}
function $2dcf7b48843b00bc$export$c74ebecccae3f15e(ontKey, ids, docTaxonId, ctx) {
    if (!Array.isArray(ids) || ids.length === 0) return [];
    const ancestorSet = new Set();
    let anyResolved = false;
    for (const id of ids){
        const rec = $2dcf7b48843b00bc$var$getOntologyRecord(ontKey, id, ctx);
        if (!rec || rec.missing) continue;
        anyResolved = true;
        const anc = $2dcf7b48843b00bc$var$ancestorsOfRecord(ontKey, rec, docTaxonId, ctx);
        if (!anc) continue;
        for (const a of anc)ancestorSet.add(+a);
    }
    if (!anyResolved) return ids.slice();
    return ids.filter((id)=>!ancestorSet.has(+id));
}
function $2dcf7b48843b00bc$var$displayIdAndName(ontKey, id, ctx) {
    const rec = $2dcf7b48843b00bc$var$getOntologyRecord(ontKey, id, ctx);
    if (!rec || rec.missing) return {
        id: String(id),
        name: ''
    };
    const displayId = rec.id != null ? String(rec.id) : String(rec._id != null ? rec._id : id);
    let name = rec.name || '';
    if (ontKey === 'taxonomy' && !name) name = rec.display_name || '';
    return {
        id: displayId,
        name: String(name)
    };
}
function $2dcf7b48843b00bc$export$2bf50aee238cef50(ontKey, ids, docTaxonId, ctx) {
    const specific = $2dcf7b48843b00bc$export$c74ebecccae3f15e(ontKey, ids, docTaxonId, ctx);
    return specific.map((id)=>{
        const { id: disp, name: name } = $2dcf7b48843b00bc$var$displayIdAndName(ontKey, id, ctx);
        return name ? `${disp} ${name}` : disp;
    }).join(';');
}
function $2dcf7b48843b00bc$export$13323dc2ab8b2ab(ontKey, ids, docTaxonId, ctx) {
    const specific = $2dcf7b48843b00bc$export$c74ebecccae3f15e(ontKey, ids, docTaxonId, ctx);
    return specific.map((id)=>$2dcf7b48843b00bc$var$displayIdAndName(ontKey, id, ctx));
}
function $2dcf7b48843b00bc$var$termTypeForRecord(ontKey, rec) {
    if (!rec) return '';
    if (ontKey === 'GO') return rec.namespace || rec.type || '';
    if (ontKey === 'taxonomy') return rec.rank || '';
    return rec.type || rec.namespace || '';
}
function $2dcf7b48843b00bc$export$b3f7b43c4be6e7e4(doc, ancestorFields, ctx) {
    const rows = [];
    for (const fieldName of ancestorFields){
        const ontKey = $2dcf7b48843b00bc$export$a63736950501bd11[fieldName];
        if (!ontKey) continue;
        const ids = Array.isArray(doc[fieldName]) ? doc[fieldName] : [];
        if (!ids.length) continue;
        const specific = $2dcf7b48843b00bc$export$c74ebecccae3f15e(ontKey, ids, doc.taxon_id, ctx);
        const hierarchy = $2dcf7b48843b00bc$export$646f2c3f1db884c4[fieldName] || fieldName;
        for (const id of specific){
            const rec = $2dcf7b48843b00bc$var$getOntologyRecord(ontKey, id, ctx);
            const { id: disp, name: name } = $2dcf7b48843b00bc$var$displayIdAndName(ontKey, id, ctx);
            rows.push({
                hierarchy: hierarchy,
                term_id: disp,
                term_name: name,
                term_type: $2dcf7b48843b00bc$var$termTypeForRecord(ontKey, rec)
            });
        }
    }
    return rows;
}
function $11024d65ffe77884$var$scrubTSV(s) {
    return String(s).replace(/[\t\r\n]/g, ' ');
}
function $11024d65ffe77884$var$formatCellTSV(value) {
    if (value === null || value === undefined) return '';
    if (Array.isArray(value)) return value.map($11024d65ffe77884$var$formatCellTSV).join('|');
    if (typeof value === 'object') return JSON.stringify(value);
    return $11024d65ffe77884$var$scrubTSV(value);
}
function $11024d65ffe77884$var$formatDocFieldTSV(doc, name, resolverCtx) {
    if ($2dcf7b48843b00bc$export$bc587a3f4ee444a9(name)) {
        const ontKey = $2dcf7b48843b00bc$export$a63736950501bd11[name];
        const ids = Array.isArray(doc[name]) ? doc[name] : [];
        return $11024d65ffe77884$var$scrubTSV($2dcf7b48843b00bc$export$2bf50aee238cef50(ontKey, ids, doc.taxon_id, resolverCtx));
    }
    return $11024d65ffe77884$var$formatCellTSV(doc[name]);
}
function $11024d65ffe77884$export$cef054c3ef2403e1(fieldNames, catalog) {
    return fieldNames.map((n)=>{
        const f = catalog && catalog.fields && catalog.fields[n];
        if (!f) return n;
        return f.tsvHeader || f.label;
    });
}
function $11024d65ffe77884$export$597116a130f4dffe(doc, fieldNames, resolverCtx) {
    return fieldNames.map((n)=>$11024d65ffe77884$var$formatDocFieldTSV(doc, n, resolverCtx));
}
const $11024d65ffe77884$var$EMPTY_EXPR_ROW = $6d28e8e62a4d602f$export$adbe84e3322ddf23.map(()=>'');
const $11024d65ffe77884$var$EMPTY_DIFF_ROW = $6d28e8e62a4d602f$export$576cc3c28e73797f.map(()=>'');
const $11024d65ffe77884$var$EMPTY_ANC_ROW = $2dcf7b48843b00bc$export$37f9358aca2dda70.map(()=>'');
function $11024d65ffe77884$var$exprRowToCells(er) {
    return [
        $11024d65ffe77884$var$scrubTSV(er.experiment),
        $11024d65ffe77884$var$scrubTSV(er.experiment_name),
        $11024d65ffe77884$var$scrubTSV(er.assay),
        $11024d65ffe77884$var$scrubTSV(er.sample),
        $11024d65ffe77884$var$scrubTSV(er.value)
    ];
}
function $11024d65ffe77884$var$diffRowToCells(dr) {
    return [
        $11024d65ffe77884$var$scrubTSV(dr.diff_experiment),
        $11024d65ffe77884$var$scrubTSV(dr.diff_experiment_name),
        $11024d65ffe77884$var$scrubTSV(dr.group1_factors),
        $11024d65ffe77884$var$scrubTSV(dr.group2_factors),
        $11024d65ffe77884$var$scrubTSV(dr.l2fc),
        $11024d65ffe77884$var$scrubTSV(dr.pval)
    ];
}
function $11024d65ffe77884$var$ancRowToCells(ar) {
    return [
        $11024d65ffe77884$var$scrubTSV(ar.hierarchy),
        $11024d65ffe77884$var$scrubTSV(ar.term_id),
        $11024d65ffe77884$var$scrubTSV(ar.term_name),
        $11024d65ffe77884$var$scrubTSV(ar.term_type)
    ];
}
function $11024d65ffe77884$var$splitPlainAndAncestor(nonExpressionFields) {
    const ancestorFields = [];
    const plainFields = [];
    for (const n of nonExpressionFields)if ($2dcf7b48843b00bc$export$bc587a3f4ee444a9(n)) ancestorFields.push(n);
    else plainFields.push(n);
    return {
        ancestorFields: ancestorFields,
        plainFields: plainFields
    };
}
function $11024d65ffe77884$var$buildExpandedRows(docs, plainFields, ancestorFields, expressionFields, diffExpressionFields, resolverCtx) {
    const expressionStudies = resolverCtx && resolverCtx.expressionStudies;
    const expressionSamples = resolverCtx && resolverCtx.expressionSamples;
    const cutoffs = resolverCtx && resolverCtx.cutoffs;
    const hasExpr = expressionFields.length > 0;
    const hasDiff = diffExpressionFields.length > 0;
    const hasAnc = ancestorFields.length > 0;
    const rows = [];
    for (const doc of docs || []){
        const baseCells = $11024d65ffe77884$export$597116a130f4dffe(doc, plainFields, resolverCtx);
        const ancRows = hasAnc ? $2dcf7b48843b00bc$export$b3f7b43c4be6e7e4(doc, ancestorFields, resolverCtx) : [];
        const exprRows = hasExpr ? $6d28e8e62a4d602f$export$e11f1dd766d5ba07(doc, expressionFields, expressionStudies, expressionSamples, cutoffs) : [];
        const diffRows = hasDiff ? $6d28e8e62a4d602f$export$ba4cd509d0763838(doc, diffExpressionFields, expressionStudies, expressionSamples, cutoffs) : [];
        const ancCells = ancRows.length ? ancRows.map($11024d65ffe77884$var$ancRowToCells) : hasAnc ? [
            $11024d65ffe77884$var$EMPTY_ANC_ROW
        ] : [
            null
        ];
        const exprCells = exprRows.length ? exprRows.map($11024d65ffe77884$var$exprRowToCells) : hasExpr ? [
            $11024d65ffe77884$var$EMPTY_EXPR_ROW
        ] : [
            null
        ];
        const diffCells = diffRows.length ? diffRows.map($11024d65ffe77884$var$diffRowToCells) : hasDiff ? [
            $11024d65ffe77884$var$EMPTY_DIFF_ROW
        ] : [
            null
        ];
        for (const a of ancCells){
            for (const e of exprCells)for (const d of diffCells){
                const out = [
                    ...baseCells
                ];
                if (a) out.push(...a);
                if (e) out.push(...e);
                if (d) out.push(...d);
                rows.push(out);
            }
        }
    }
    return rows;
}
function $11024d65ffe77884$export$dd11def50029a9ee(docs, fieldNames, catalog, resolverCtx) {
    const { expressionFields: expressionFields, diffExpressionFields: diffExpressionFields, nonExpressionFields: nonExpressionFields } = $6d28e8e62a4d602f$export$f53c4708f5c8e834(fieldNames, catalog);
    const { ancestorFields: ancestorFields, plainFields: plainFields } = $11024d65ffe77884$var$splitPlainAndAncestor(nonExpressionFields);
    if (expressionFields.length === 0 && diffExpressionFields.length === 0 && ancestorFields.length === 0) {
        const header = $11024d65ffe77884$export$cef054c3ef2403e1(fieldNames, catalog).join('\t');
        const rows = (docs || []).map((d)=>$11024d65ffe77884$export$597116a130f4dffe(d, fieldNames, resolverCtx).join('\t'));
        return [
            header,
            ...rows
        ].join('\n');
    }
    const header = [
        ...$11024d65ffe77884$export$cef054c3ef2403e1(plainFields, catalog),
        ...ancestorFields.length ? $2dcf7b48843b00bc$export$37f9358aca2dda70 : [],
        ...expressionFields.length ? $6d28e8e62a4d602f$export$adbe84e3322ddf23 : [],
        ...diffExpressionFields.length ? $6d28e8e62a4d602f$export$576cc3c28e73797f : []
    ].join('\t');
    const rows = $11024d65ffe77884$var$buildExpandedRows(docs, plainFields, ancestorFields, expressionFields, diffExpressionFields, resolverCtx);
    return [
        header,
        ...rows.map((r)=>r.join('\t'))
    ].join('\n');
}
function $11024d65ffe77884$export$4600c165c3a455ee(docs, fieldNames, catalog, resolverCtx) {
    const { expressionFields: expressionFields, diffExpressionFields: diffExpressionFields, nonExpressionFields: nonExpressionFields } = $6d28e8e62a4d602f$export$f53c4708f5c8e834(fieldNames, catalog);
    const { ancestorFields: ancestorFields, plainFields: plainFields } = $11024d65ffe77884$var$splitPlainAndAncestor(nonExpressionFields);
    if (expressionFields.length === 0 && diffExpressionFields.length === 0 && ancestorFields.length === 0) return {
        header: $11024d65ffe77884$export$cef054c3ef2403e1(fieldNames, catalog),
        headerKeys: fieldNames.slice(),
        rows: (docs || []).map((d)=>$11024d65ffe77884$export$597116a130f4dffe(d, fieldNames, resolverCtx))
    };
    const header = [
        ...$11024d65ffe77884$export$cef054c3ef2403e1(plainFields, catalog),
        ...ancestorFields.length ? $2dcf7b48843b00bc$export$37f9358aca2dda70 : [],
        ...expressionFields.length ? $6d28e8e62a4d602f$export$adbe84e3322ddf23 : [],
        ...diffExpressionFields.length ? $6d28e8e62a4d602f$export$576cc3c28e73797f : []
    ];
    const headerKeys = [
        ...plainFields,
        ...ancestorFields.length ? $2dcf7b48843b00bc$export$37f9358aca2dda70 : [],
        ...expressionFields.length ? $6d28e8e62a4d602f$export$adbe84e3322ddf23 : [],
        ...diffExpressionFields.length ? $6d28e8e62a4d602f$export$576cc3c28e73797f : []
    ];
    const rows = $11024d65ffe77884$var$buildExpandedRows(docs, plainFields, ancestorFields, expressionFields, diffExpressionFields, resolverCtx);
    return {
        header: header,
        headerKeys: headerKeys,
        rows: rows
    };
}
function $11024d65ffe77884$export$567d5733bcf8665b(docs, fieldNames, resolverCtx) {
    return (docs || []).map((d)=>{
        const row = {};
        for (const n of fieldNames)if ($2dcf7b48843b00bc$export$bc587a3f4ee444a9(n)) {
            const ontKey = $2dcf7b48843b00bc$export$a63736950501bd11[n];
            const ids = Array.isArray(d[n]) ? d[n] : [];
            row[n] = $2dcf7b48843b00bc$export$13323dc2ab8b2ab(ontKey, ids, d.taxon_id, resolverCtx);
        } else row[n] = d[n] !== undefined ? d[n] : null;
        return row;
    });
}
function $11024d65ffe77884$export$54fd2c36b5cc6731(docs, fieldNames, resolverCtx) {
    return JSON.stringify($11024d65ffe77884$export$567d5733bcf8665b(docs, fieldNames, resolverCtx), null, 2);
}
const $5f8c6fd386d887ab$var$PAGE_SIZE = 1000;
function $5f8c6fd386d887ab$var$buildSearchURL(api, q, fl, rows, start, fq) {
    const params = [
        `q=${q}`,
        `rows=${rows}`,
        `start=${start}`,
        'facet=false'
    ];
    if (fl) params.push(`fl=${encodeURIComponent(fl)}`);
    return `${api}/search?${params.join('&')}${fq}`;
}
function $5f8c6fd386d887ab$var$triggerBrowserSave(blob, filename) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(()=>URL.revokeObjectURL(url), 2000);
}
async function $5f8c6fd386d887ab$export$1c5eebb8aaf20316({ dispatch: dispatch, store: store, requestId: requestId, signal: signal, isSuperseded: isSuperseded }) {
    const api = store.selectGrameneAPI();
    const q = store.selectGrameneFiltersQueryString();
    const g = store.selectGrameneGenomes();
    const m = store.selectGrameneMaps() || {};
    const taxa = Object.keys(g.active || {}).filter((tid)=>m[tid] && !m[tid].hidden);
    const fq = taxa.length ? `&fq=taxon_id:(${taxa.join(' OR ')})` : '';
    const fields = store.selectExporterSelectedFields();
    const fl = fields.join(',');
    const format = store.selectExporterFormat();
    const catalog = store.selectFieldCatalog();
    const expressionStudies = store.selectExpressionStudies();
    const expressionSamples = store.selectExpressionSamples();
    const ancestorFields = fields.filter((n)=>$2dcf7b48843b00bc$export$a63736950501bd11[n]);
    const cutoffs = store.selectExporterCutoffs && store.selectExporterCutoffs();
    const buildResolverCtx = ()=>({
            expressionStudies: expressionStudies,
            expressionSamples: expressionSamples,
            taxonomy: store.selectGrameneTaxonomy(),
            pathways: store.selectGramenePathways(),
            ontologies: store.selectOntologies(),
            cutoffs: cutoffs
        });
    const ensureAncestorRecords = async (docs)=>{
        if (ancestorFields.length === 0 || docs.length === 0) return;
        const idsByOnt = $2dcf7b48843b00bc$export$6cd55d301c37aeed(docs, ancestorFields);
        const waits = [];
        for (const [ontKey, ids] of Object.entries(idsByOnt)){
            if (!ids.length) continue;
            if (ontKey === 'taxonomy') continue;
            if (ontKey === 'pathways') {
                const pathwaysCache = store.selectGramenePathways() || {};
                const missing = ids.filter((id)=>!pathwaysCache.hasOwnProperty(id));
                if (missing.length) store.doRequestGramenePathways(missing);
                continue;
            }
            const p = store.doEnsureOntologyRecords(ontKey, ids);
            if (p && typeof p.then === 'function') waits.push(p);
        }
        if (waits.length) await Promise.all(waits);
    };
    const fetchJSON = (url)=>fetch(url, {
            signal: signal
        }).then((r)=>{
            if (!r.ok) throw new Error(`HTTP ${r.status}`);
            return r.json();
        });
    const countUrl = $5f8c6fd386d887ab$var$buildSearchURL(api, q, 'id', 0, 0, fq);
    const countResp = await fetchJSON(countUrl);
    const total = countResp && countResp.response && countResp.response.numFound || 0;
    dispatch({
        type: 'EXPORTER_DOWNLOAD_STARTED',
        payload: {
            requestId: requestId,
            total: total
        }
    });
    if (total === 0) {
        dispatch({
            type: 'EXPORTER_DOWNLOAD_COMPLETED',
            payload: {
                requestId: requestId,
                written: 0
            }
        });
        return;
    }
    const tsvPieces = [];
    const jsonRows = [];
    let progress = 0;
    if (format === 'tsv') {
        const { header: header } = $11024d65ffe77884$export$4600c165c3a455ee([], fields, catalog, buildResolverCtx());
        tsvPieces.push(header.join('\t') + '\n');
    }
    let start = 0;
    while(start < total){
        if (isSuperseded()) {
            dispatch({
                type: 'EXPORTER_DOWNLOAD_CANCELLED',
                payload: {
                    requestId: requestId
                }
            });
            return;
        }
        const url = $5f8c6fd386d887ab$var$buildSearchURL(api, q, fl, $5f8c6fd386d887ab$var$PAGE_SIZE, start, fq);
        const resp = await fetchJSON(url);
        const docs = resp && resp.response && resp.response.docs || [];
        if (docs.length === 0) break;
        await ensureAncestorRecords(docs);
        const resolverCtx = buildResolverCtx();
        if (format === 'tsv') {
            const { rows: rows } = $11024d65ffe77884$export$4600c165c3a455ee(docs, fields, catalog, resolverCtx);
            for (const row of rows)tsvPieces.push(row.join('\t') + '\n');
        } else {
            const rows = $11024d65ffe77884$export$567d5733bcf8665b(docs, fields, resolverCtx);
            for (const r of rows)jsonRows.push(r);
        }
        start += docs.length;
        progress = start;
        dispatch({
            type: 'EXPORTER_DOWNLOAD_PROGRESS',
            payload: {
                requestId: requestId,
                progress: progress
            }
        });
    }
    if (isSuperseded()) {
        dispatch({
            type: 'EXPORTER_DOWNLOAD_CANCELLED',
            payload: {
                requestId: requestId
            }
        });
        return;
    }
    const stamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-');
    let blob;
    let filename;
    if (format === 'tsv') {
        blob = new Blob(tsvPieces, {
            type: 'text/tab-separated-values'
        });
        filename = `gramene-export-${stamp}.tsv`;
    } else {
        blob = new Blob([
            JSON.stringify(jsonRows, null, 2)
        ], {
            type: 'application/json'
        });
        filename = `gramene-export-${stamp}.json`;
    }
    $5f8c6fd386d887ab$var$triggerBrowserSave(blob, filename);
    dispatch({
        type: 'EXPORTER_DOWNLOAD_COMPLETED',
        payload: {
            requestId: requestId,
            written: progress
        }
    });
}
const $1508f5a42be6e7b5$var$DEFAULT_FIELDS = [
    'id',
    'name',
    'system_name',
    'biotype'
];
const $1508f5a42be6e7b5$var$PREVIEW_ROWS = 20;
const $1508f5a42be6e7b5$var$PREVIEW_DEBOUNCE_MS = 250;
function $1508f5a42be6e7b5$var$computePreviewSignature(store) {
    const q = store.selectGrameneFiltersQueryString();
    const g = store.selectGrameneGenomes();
    const m = store.selectGrameneMaps() || {};
    const taxa = Object.keys(g.active || {}).filter((tid)=>m[tid] && !m[tid].hidden);
    return `${q}|${taxa.sort().join(',')}`;
}
let $1508f5a42be6e7b5$var$debounceTimer = null;
let $1508f5a42be6e7b5$var$pendingRequestId = 0;
let $1508f5a42be6e7b5$var$pendingDownloadId = 0;
let $1508f5a42be6e7b5$var$currentDownloadController = null;
const $1508f5a42be6e7b5$var$markStale = (preview)=>({
        ...preview,
        status: 'stale'
    });
const $1508f5a42be6e7b5$var$exporter = {
    name: 'exporter',
    getReducer: ()=>{
        const initialState = {
            selectedFields: $1508f5a42be6e7b5$var$DEFAULT_FIELDS,
            format: 'tsv',
            cutoffs: {
                exprMinTPM: 0.5,
                diffMaxPval: 0.05
            },
            preview: {
                status: 'stale',
                data: null,
                error: null,
                requestId: 0,
                signature: null
            },
            download: {
                status: 'idle',
                progress: 0,
                total: 0,
                error: null,
                requestId: 0
            }
        };
        return (state = initialState, { type: type, payload: payload })=>{
            switch(type){
                case 'EXPORTER_FIELD_TOGGLED':
                    {
                        const idx = state.selectedFields.indexOf(payload);
                        const selectedFields = idx === -1 ? [
                            ...state.selectedFields,
                            payload
                        ] : state.selectedFields.filter((f)=>f !== payload);
                        return {
                            ...state,
                            selectedFields: selectedFields
                        };
                    }
                case 'EXPORTER_FIELDS_REORDERED':
                    return {
                        ...state,
                        selectedFields: payload
                    };
                case 'EXPORTER_FIELDS_BULK_SET':
                    {
                        const { names: names, selected: selected } = payload;
                        if (!Array.isArray(names) || names.length === 0) return state;
                        if (selected) {
                            const existing = new Set(state.selectedFields);
                            const additions = names.filter((n)=>!existing.has(n));
                            if (additions.length === 0) return state;
                            return {
                                ...state,
                                selectedFields: [
                                    ...state.selectedFields,
                                    ...additions
                                ]
                            };
                        }
                        const remove = new Set(names);
                        const next = state.selectedFields.filter((n)=>!remove.has(n));
                        if (next.length === state.selectedFields.length) return state;
                        return {
                            ...state,
                            selectedFields: next
                        };
                    }
                case 'EXPORTER_FORMAT_SET':
                    return {
                        ...state,
                        format: payload
                    };
                case 'EXPORTER_CUTOFFS_SET':
                    return {
                        ...state,
                        cutoffs: {
                            ...state.cutoffs,
                            ...payload || {}
                        }
                    };
                case 'EXPORTER_FIELDS_CLEARED':
                    return {
                        ...state,
                        selectedFields: []
                    };
                case 'EXPORTER_PREVIEW_INVALIDATED':
                    return {
                        ...state,
                        preview: $1508f5a42be6e7b5$var$markStale(state.preview)
                    };
                case 'EXPORTER_PREVIEW_STARTED':
                    return {
                        ...state,
                        preview: {
                            ...state.preview,
                            status: 'loading',
                            requestId: payload.requestId,
                            error: null,
                            signature: payload.signature
                        }
                    };
                case 'EXPORTER_PREVIEW_SUCCEEDED':
                    if (payload.requestId !== state.preview.requestId) return state;
                    return {
                        ...state,
                        preview: {
                            status: 'ready',
                            data: payload.data,
                            error: null,
                            requestId: payload.requestId,
                            signature: state.preview.signature
                        }
                    };
                case 'EXPORTER_PREVIEW_FAILED':
                    if (payload.requestId !== state.preview.requestId) return state;
                    return {
                        ...state,
                        preview: {
                            ...state.preview,
                            status: 'error',
                            error: payload.error
                        }
                    };
                case 'EXPORTER_DOWNLOAD_REQUESTED':
                    return {
                        ...state,
                        download: {
                            status: 'preparing',
                            progress: 0,
                            total: 0,
                            error: null,
                            requestId: payload.requestId
                        }
                    };
                case 'EXPORTER_DOWNLOAD_STARTED':
                    if (payload.requestId !== state.download.requestId) return state;
                    return {
                        ...state,
                        download: {
                            ...state.download,
                            status: 'downloading',
                            total: payload.total
                        }
                    };
                case 'EXPORTER_DOWNLOAD_PROGRESS':
                    if (payload.requestId !== state.download.requestId) return state;
                    return {
                        ...state,
                        download: {
                            ...state.download,
                            progress: payload.progress
                        }
                    };
                case 'EXPORTER_DOWNLOAD_COMPLETED':
                    if (payload.requestId !== state.download.requestId) return state;
                    return {
                        ...state,
                        download: {
                            ...state.download,
                            status: 'done',
                            progress: payload.written || state.download.progress
                        }
                    };
                case 'EXPORTER_DOWNLOAD_CANCELLED':
                    if (payload.requestId !== state.download.requestId) return state;
                    return {
                        ...state,
                        download: {
                            ...state.download,
                            status: 'cancelled'
                        }
                    };
                case 'EXPORTER_DOWNLOAD_FAILED':
                    if (payload.requestId !== state.download.requestId) return state;
                    return {
                        ...state,
                        download: {
                            ...state.download,
                            status: 'error',
                            error: payload.error
                        }
                    };
                case 'EXPORTER_DOWNLOAD_RESET':
                    return {
                        ...state,
                        download: {
                            status: 'idle',
                            progress: 0,
                            total: 0,
                            error: null,
                            requestId: state.download.requestId
                        }
                    };
                default:
                    return state;
            }
        };
    },
    doToggleExporterField: (fieldName)=>({ dispatch: dispatch })=>dispatch({
                type: 'EXPORTER_FIELD_TOGGLED',
                payload: fieldName
            }),
    doReorderExporterFields: (fieldList)=>({ dispatch: dispatch })=>dispatch({
                type: 'EXPORTER_FIELDS_REORDERED',
                payload: fieldList
            }),
    doBulkSetExporterFields: (names, selected)=>({ dispatch: dispatch })=>dispatch({
                type: 'EXPORTER_FIELDS_BULK_SET',
                payload: {
                    names: names,
                    selected: selected
                }
            }),
    doSetExporterFormat: (fmt)=>({ dispatch: dispatch })=>dispatch({
                type: 'EXPORTER_FORMAT_SET',
                payload: fmt
            }),
    doSetExporterCutoffs: (cutoffs)=>({ dispatch: dispatch })=>dispatch({
                type: 'EXPORTER_CUTOFFS_SET',
                payload: cutoffs
            }),
    doClearExporterFields: ()=>({ dispatch: dispatch })=>dispatch({
                type: 'EXPORTER_FIELDS_CLEARED'
            }),
    doFetchExporterPreview: ()=>({ dispatch: dispatch, store: store })=>{
            clearTimeout($1508f5a42be6e7b5$var$debounceTimer);
            const requestId = ++$1508f5a42be6e7b5$var$pendingRequestId;
            const signature = $1508f5a42be6e7b5$var$computePreviewSignature(store);
            dispatch({
                type: 'EXPORTER_PREVIEW_STARTED',
                payload: {
                    requestId: requestId,
                    signature: signature
                }
            });
            $1508f5a42be6e7b5$var$debounceTimer = setTimeout(()=>{
                if (requestId !== $1508f5a42be6e7b5$var$pendingRequestId) return;
                const api = store.selectGrameneAPI();
                const q = store.selectGrameneFiltersQueryString();
                const g = store.selectGrameneGenomes();
                const m = store.selectGrameneMaps() || {};
                const taxa = Object.keys(g.active || {}).filter((tid)=>m[tid] && !m[tid].hidden);
                const fq = taxa.length ? `&fq=taxon_id:(${taxa.join(' OR ')})` : '';
                const url = `${api}/search?q=${q}&fl=*&rows=${$1508f5a42be6e7b5$var$PREVIEW_ROWS}${fq}`;
                fetch(url).then((r)=>r.json()).then((json)=>{
                    const docs = json && json.response && json.response.docs || [];
                    dispatch({
                        type: 'EXPORTER_PREVIEW_SUCCEEDED',
                        payload: {
                            requestId: requestId,
                            data: docs
                        }
                    });
                }).catch((err)=>{
                    dispatch({
                        type: 'EXPORTER_PREVIEW_FAILED',
                        payload: {
                            requestId: requestId,
                            error: String(err)
                        }
                    });
                });
            }, $1508f5a42be6e7b5$var$PREVIEW_DEBOUNCE_MS);
        },
    reactExporterPreview: (0, $gXNCa$reduxbundler.createSelector)('selectExporter', 'selectGrameneFiltersStatus', 'selectGrameneFiltersQueryString', 'selectGrameneGenomes', 'selectGrameneMaps', 'selectGrameneViewsOn', (exp, filtersStatus, q, g, m, viewsOn)=>{
        if (!exp || !exp.preview) return;
        if (filtersStatus === 'init') return;
        if (exp.preview.status === 'loading') return;
        // Don't run the preview query unless the user has the exporter view open.
        if (!viewsOn || !viewsOn.has('export')) return;
        const maps = m || {};
        const taxa = Object.keys(g && g.active || {}).filter((tid)=>maps[tid] && !maps[tid].hidden);
        const sig = `${q}|${taxa.sort().join(',')}`;
        if (exp.preview.signature === sig && exp.preview.status !== 'stale') return;
        return {
            actionCreator: 'doFetchExporterPreview'
        };
    }),
    doStartExporterDownload: ()=>({ dispatch: dispatch, store: store })=>{
            if ($1508f5a42be6e7b5$var$currentDownloadController) $1508f5a42be6e7b5$var$currentDownloadController.abort();
            const requestId = ++$1508f5a42be6e7b5$var$pendingDownloadId;
            const controller = new AbortController();
            $1508f5a42be6e7b5$var$currentDownloadController = controller;
            dispatch({
                type: 'EXPORTER_DOWNLOAD_REQUESTED',
                payload: {
                    requestId: requestId
                }
            });
            const isSuperseded = ()=>requestId !== $1508f5a42be6e7b5$var$pendingDownloadId;
            $5f8c6fd386d887ab$export$1c5eebb8aaf20316({
                dispatch: dispatch,
                store: store,
                requestId: requestId,
                signal: controller.signal,
                isSuperseded: isSuperseded
            }).catch((err)=>{
                if (err && err.name === 'AbortError') dispatch({
                    type: 'EXPORTER_DOWNLOAD_CANCELLED',
                    payload: {
                        requestId: requestId
                    }
                });
                else dispatch({
                    type: 'EXPORTER_DOWNLOAD_FAILED',
                    payload: {
                        requestId: requestId,
                        error: String(err)
                    }
                });
            });
        },
    doCancelExporterDownload: ()=>({ dispatch: dispatch })=>{
            if ($1508f5a42be6e7b5$var$currentDownloadController) {
                $1508f5a42be6e7b5$var$currentDownloadController.abort();
                $1508f5a42be6e7b5$var$currentDownloadController = null;
            }
            $1508f5a42be6e7b5$var$pendingDownloadId++;
        },
    doResetExporterDownload: ()=>({ dispatch: dispatch })=>dispatch({
                type: 'EXPORTER_DOWNLOAD_RESET'
            }),
    selectExporter: (state)=>state.exporter,
    selectExporterSelectedFields: (state)=>state.exporter.selectedFields,
    selectExporterFormat: (state)=>state.exporter.format,
    selectExporterCutoffs: (state)=>state.exporter.cutoffs,
    selectExporterPreview: (state)=>state.exporter.preview,
    selectExporterDownload: (state)=>state.exporter.download
};
var $1508f5a42be6e7b5$export$2e2bcd8739ae039 = $1508f5a42be6e7b5$var$exporter;
const $c921a0d2b34aadb6$var$ONT_KEYS = [
    'GO',
    'PO',
    'TO',
    'domains'
];
// Dedicated IndexedDB store for ontology records. The full term set per
// ontology is stable enough to keep around indefinitely (default maxAge of
// `Infinity`), and we don't want it to share the short TTL of the app-wide
// cache configured in demo.js.
const $c921a0d2b34aadb6$var$cache = (0, $gXNCa$moneyclip.getConfiguredCache)({
    version: 1,
    name: 'gramene_ontologies'
});
const $c921a0d2b34aadb6$var$inflight = {};
const $c921a0d2b34aadb6$var$ontologies = {
    name: 'ontologies',
    getReducer: ()=>{
        const initialState = {
            GO: {},
            PO: {},
            TO: {},
            domains: {},
            loaded: {}
        };
        return (state = initialState, { type: type, payload: payload })=>{
            switch(type){
                case 'ONTOLOGY_BULK_LOADED':
                    return {
                        ...state,
                        [payload.key]: payload.records,
                        loaded: {
                            ...state.loaded,
                            [payload.key]: true
                        }
                    };
                default:
                    return state;
            }
        };
    },
    // Signature kept for backward compatibility — the `ids` argument is
    // ignored. On first call per ontology key we load the full term set
    // (cache hit if available, otherwise `${api}/${key}?rows=-1`) and
    // dispatch a single bulk load. Subsequent calls are no-ops.
    doEnsureOntologyRecords: (key, _ids)=>({ dispatch: dispatch, store: store })=>{
            if (!$c921a0d2b34aadb6$var$ONT_KEYS.includes(key)) return Promise.resolve();
            const state = store.selectOntologies();
            if (state.loaded && state.loaded[key]) return Promise.resolve();
            if ($c921a0d2b34aadb6$var$inflight[key]) return $c921a0d2b34aadb6$var$inflight[key];
            $c921a0d2b34aadb6$var$inflight[key] = $c921a0d2b34aadb6$var$cache.get(key).then((cached)=>{
                if (cached) {
                    dispatch({
                        type: 'ONTOLOGY_BULK_LOADED',
                        payload: {
                            key: key,
                            records: cached
                        }
                    });
                    return;
                }
                const api = store.selectGrameneAPI();
                return fetch(`${api}/${key}?rows=-1`).then((r)=>r.json()).then((docs)=>{
                    const records = {};
                    for (const d of docs || [])if (d && d._id != null) records[d._id] = d;
                    dispatch({
                        type: 'ONTOLOGY_BULK_LOADED',
                        payload: {
                            key: key,
                            records: records
                        }
                    });
                    $c921a0d2b34aadb6$var$cache.set(key, records).catch((e)=>console.warn('Failed to cache ontology', key, e));
                });
            }).catch((err)=>{
                console.error(`Failed to load ontology ${key}`, err);
            }).finally(()=>{
                delete $c921a0d2b34aadb6$var$inflight[key];
            });
            return $c921a0d2b34aadb6$var$inflight[key];
        },
    selectOntologies: (state)=>state.ontologies
};
var $c921a0d2b34aadb6$export$2e2bcd8739ae039 = $c921a0d2b34aadb6$var$ontologies;
// State shape:
// {
//   pivot: { status, signature, data: { [taxon_id]: <gene count> }, error, requestId },
//   activeTaxon: <taxon_id|null>,
//   byTaxon: {
//     [taxon_id]: {
//       selectedFields: [<solr field name>...],   // order = column/axis order
//       fieldsModalOpen: <bool>,
//       vizMode: 'heatmap'|'parallel',            // persisted view config
//       scale: 'linear'|'log',                    // persisted view config
//       brushes: { [field]: [lo, hi] },           // persisted parallel-coords brushes
//       pendingLoad: <bool>,                       // transient: a restored view wants a re-fetch
//       fetch: { status, offset, total, signature, requestId, error },
//       rows: [<doc>...]
//     }
//   }
// }
// Per-taxon study lists are derived in the view layer from expressionStudies.
const $4f15cd8a7d970b18$var$PAGE_SIZE = 200;
let $4f15cd8a7d970b18$var$pivotPendingId = 0;
const $4f15cd8a7d970b18$var$fetchPending = {}; // per-taxon request id
const $4f15cd8a7d970b18$var$attrsPending = {}; // per-taxon request id for available attrs
const $4f15cd8a7d970b18$var$existencePending = {}; // per-taxon request id for field-existence check
function $4f15cd8a7d970b18$var$pivotSignature(store) {
    const q = store.selectGrameneFiltersQueryString();
    const g = store.selectGrameneGenomes();
    const m = store.selectGrameneMaps() || {};
    const taxa = Object.keys(g.active || {}).filter((tid)=>m[tid] && !m[tid].hidden);
    return `${q}|${taxa.sort().join(',')}`;
}
function $4f15cd8a7d970b18$var$fetchSignature(store, taxon) {
    const q = store.selectGrameneFiltersQueryString();
    const ev = store.selectExprViz();
    const sel = ev.byTaxon[taxon] && ev.byTaxon[taxon].selectedFields || [];
    return `${q}|${taxon}|${sel.slice().sort().join(',')}`;
}
const $4f15cd8a7d970b18$var$ALWAYS_FL = [
    'id',
    'name',
    'system_name',
    'taxon_id'
];
const $4f15cd8a7d970b18$var$exprViz = {
    name: 'exprViz',
    getReducer: ()=>{
        const initialState = {
            pivot: {
                status: 'idle',
                signature: null,
                data: {},
                error: null,
                requestId: 0
            },
            activeTaxon: null,
            byTaxon: {}
        };
        function ensureTaxon(state, taxon) {
            if (state.byTaxon[taxon]) return state.byTaxon[taxon];
            return {
                selectedFields: [],
                fieldsModalOpen: false,
                vizMode: 'heatmap',
                scale: 'linear',
                brushes: {},
                pendingLoad: false,
                fetch: {
                    status: 'idle',
                    offset: 0,
                    total: 0,
                    signature: null,
                    requestId: 0,
                    error: null
                },
                rows: [],
                availableAttrs: null,
                attrsSignature: null,
                attrsRequestId: 0,
                fieldExistence: null,
                existenceStatus: 'idle',
                existenceSignature: null,
                existenceRequestId: 0
            };
        }
        return (state = initialState, { type: type, payload: payload })=>{
            switch(type){
                case 'EXPRVIZ_PIVOT_STARTED':
                    return {
                        ...state,
                        pivot: {
                            status: 'loading',
                            signature: payload.signature,
                            data: state.pivot.data,
                            error: null,
                            requestId: payload.requestId
                        }
                    };
                case 'EXPRVIZ_PIVOT_SUCCEEDED':
                    if (payload.requestId !== state.pivot.requestId) return state;
                    return {
                        ...state,
                        pivot: {
                            status: 'ready',
                            signature: state.pivot.signature,
                            data: payload.data,
                            error: null,
                            requestId: payload.requestId
                        }
                    };
                case 'EXPRVIZ_PIVOT_FAILED':
                    if (payload.requestId !== state.pivot.requestId) return state;
                    return {
                        ...state,
                        pivot: {
                            ...state.pivot,
                            status: 'error',
                            error: payload.error
                        }
                    };
                case 'EXPRVIZ_ACTIVE_TAXON_SET':
                    return {
                        ...state,
                        activeTaxon: payload
                    };
                case 'EXPRVIZ_FIELDS_MODAL_TOGGLED':
                    {
                        const t = ensureTaxon(state, payload.taxon);
                        return {
                            ...state,
                            byTaxon: {
                                ...state.byTaxon,
                                [payload.taxon]: {
                                    ...t,
                                    fieldsModalOpen: payload.open
                                }
                            }
                        };
                    }
                case 'EXPRVIZ_FIELDS_SET':
                    {
                        const t = ensureTaxon(state, payload.taxon);
                        return {
                            ...state,
                            byTaxon: {
                                ...state.byTaxon,
                                [payload.taxon]: {
                                    ...t,
                                    selectedFields: payload.fields,
                                    // A new field selection invalidates any prior brushes (they
                                    // reference axes that may no longer exist) and the loaded rows.
                                    brushes: {},
                                    rows: [],
                                    fetch: {
                                        status: 'idle',
                                        offset: 0,
                                        total: 0,
                                        signature: null,
                                        requestId: 0,
                                        error: null
                                    }
                                }
                            }
                        };
                    }
                case 'EXPRVIZ_VIZMODE_SET':
                    {
                        const t = ensureTaxon(state, payload.taxon);
                        return {
                            ...state,
                            byTaxon: {
                                ...state.byTaxon,
                                [payload.taxon]: {
                                    ...t,
                                    vizMode: payload.vizMode
                                }
                            }
                        };
                    }
                case 'EXPRVIZ_SCALE_SET':
                    {
                        const t = ensureTaxon(state, payload.taxon);
                        return {
                            ...state,
                            byTaxon: {
                                ...state.byTaxon,
                                [payload.taxon]: {
                                    ...t,
                                    scale: payload.scale
                                }
                            }
                        };
                    }
                case 'EXPRVIZ_BRUSHES_SET':
                    {
                        const t = ensureTaxon(state, payload.taxon);
                        return {
                            ...state,
                            byTaxon: {
                                ...state.byTaxon,
                                [payload.taxon]: {
                                    ...t,
                                    brushes: payload.brushes || {}
                                }
                            }
                        };
                    }
                case 'EXPRVIZ_RESTORED':
                    {
                        // Re-apply persisted view config from a saved-view snapshot. Async
                        // data (rows) is NOT in the snapshot — instead each taxon with a
                        // field selection is flagged pendingLoad so reactExprVizRestoreLoad
                        // re-fetches it once the search context is ready.
                        const byTaxon = {
                            ...state.byTaxon
                        };
                        const cfg = payload.byTaxon || {};
                        for (const tid of Object.keys(cfg)){
                            const base = ensureTaxon(state, tid);
                            const c = cfg[tid] || {};
                            const selectedFields = Array.isArray(c.selectedFields) ? c.selectedFields : [];
                            byTaxon[tid] = {
                                ...base,
                                selectedFields: selectedFields,
                                vizMode: c.vizMode || 'heatmap',
                                scale: c.scale || 'linear',
                                brushes: c.brushes || {},
                                pendingLoad: selectedFields.length > 0
                            };
                        }
                        return {
                            ...state,
                            activeTaxon: payload.activeTaxon || state.activeTaxon,
                            byTaxon: byTaxon
                        };
                    }
                case 'EXPRVIZ_FIELDS_REORDERED':
                    {
                        const t = state.byTaxon[payload.taxon];
                        if (!t) return state;
                        // Same set of fields — preserve rows; only the column/axis order changes.
                        const setA = new Set(t.selectedFields);
                        const setB = new Set(payload.fields);
                        if (setA.size !== setB.size || ![
                            ...setA
                        ].every((f)=>setB.has(f))) return state;
                        return {
                            ...state,
                            byTaxon: {
                                ...state.byTaxon,
                                [payload.taxon]: {
                                    ...t,
                                    selectedFields: payload.fields
                                }
                            }
                        };
                    }
                case 'EXPRVIZ_FETCH_STARTED':
                    {
                        const t = ensureTaxon(state, payload.taxon);
                        return {
                            ...state,
                            byTaxon: {
                                ...state.byTaxon,
                                [payload.taxon]: {
                                    ...t,
                                    pendingLoad: false,
                                    fetch: {
                                        ...t.fetch,
                                        status: 'loading',
                                        signature: payload.signature,
                                        requestId: payload.requestId,
                                        error: null
                                    }
                                }
                            }
                        };
                    }
                case 'EXPRVIZ_FETCH_BATCH':
                    {
                        const t = state.byTaxon[payload.taxon];
                        if (!t || payload.requestId !== t.fetch.requestId) return state;
                        const rows = t.rows.concat(payload.docs);
                        return {
                            ...state,
                            byTaxon: {
                                ...state.byTaxon,
                                [payload.taxon]: {
                                    ...t,
                                    rows: rows,
                                    fetch: {
                                        ...t.fetch,
                                        offset: rows.length,
                                        total: payload.total,
                                        status: rows.length >= payload.total ? 'done' : 'loading'
                                    }
                                }
                            }
                        };
                    }
                case 'EXPRVIZ_FETCH_FAILED':
                    {
                        const t = state.byTaxon[payload.taxon];
                        if (!t || payload.requestId !== t.fetch.requestId) return state;
                        return {
                            ...state,
                            byTaxon: {
                                ...state.byTaxon,
                                [payload.taxon]: {
                                    ...t,
                                    fetch: {
                                        ...t.fetch,
                                        status: 'error',
                                        error: payload.error
                                    }
                                }
                            }
                        };
                    }
                case 'EXPRVIZ_ATTRS_STARTED':
                    {
                        const t = ensureTaxon(state, payload.taxon);
                        return {
                            ...state,
                            byTaxon: {
                                ...state.byTaxon,
                                [payload.taxon]: {
                                    ...t,
                                    attrsRequestId: payload.requestId,
                                    attrsSignature: payload.signature
                                }
                            }
                        };
                    }
                case 'EXPRVIZ_ATTRS_SUCCEEDED':
                    {
                        const t = state.byTaxon[payload.taxon];
                        if (!t || payload.requestId !== t.attrsRequestId) return state;
                        return {
                            ...state,
                            byTaxon: {
                                ...state.byTaxon,
                                [payload.taxon]: {
                                    ...t,
                                    availableAttrs: payload.attrs
                                }
                            }
                        };
                    }
                case 'EXPRVIZ_EXISTENCE_STARTED':
                    {
                        const t = ensureTaxon(state, payload.taxon);
                        return {
                            ...state,
                            byTaxon: {
                                ...state.byTaxon,
                                [payload.taxon]: {
                                    ...t,
                                    existenceStatus: 'loading',
                                    existenceRequestId: payload.requestId,
                                    existenceSignature: payload.signature
                                }
                            }
                        };
                    }
                case 'EXPRVIZ_EXISTENCE_SUCCEEDED':
                    {
                        const t = state.byTaxon[payload.taxon];
                        if (!t || payload.requestId !== t.existenceRequestId) return state;
                        return {
                            ...state,
                            byTaxon: {
                                ...state.byTaxon,
                                [payload.taxon]: {
                                    ...t,
                                    existenceStatus: 'ready',
                                    fieldExistence: payload.counts
                                }
                            }
                        };
                    }
                case 'GRAMENE_SEARCH_CLEARED':
                    {
                        // Search context changed — invalidate pivot and any loaded rows.
                        // Selected fields are kept so the user can re-run the load.
                        const newByTaxon = {};
                        for (const tid of Object.keys(state.byTaxon))newByTaxon[tid] = {
                            ...state.byTaxon[tid],
                            rows: [],
                            fetch: {
                                status: 'idle',
                                offset: 0,
                                total: 0,
                                signature: null,
                                requestId: 0,
                                error: null
                            },
                            availableAttrs: null,
                            attrsSignature: null,
                            fieldExistence: null,
                            existenceStatus: 'idle',
                            existenceSignature: null
                        };
                        return {
                            ...state,
                            pivot: {
                                status: 'idle',
                                signature: null,
                                data: {},
                                error: null,
                                requestId: 0
                            },
                            byTaxon: newByTaxon
                        };
                    }
                default:
                    return state;
            }
        };
    },
    doFetchExprVizPivot: ()=>({ dispatch: dispatch, store: store })=>{
            const requestId = ++$4f15cd8a7d970b18$var$pivotPendingId;
            const signature = $4f15cd8a7d970b18$var$pivotSignature(store);
            dispatch({
                type: 'EXPRVIZ_PIVOT_STARTED',
                payload: {
                    requestId: requestId,
                    signature: signature
                }
            });
            const api = store.selectGrameneAPI();
            const q = store.selectGrameneFiltersQueryString();
            const g = store.selectGrameneGenomes();
            const m = store.selectGrameneMaps() || {};
            const taxa = Object.keys(g.active || {}).filter((tid)=>m[tid] && !m[tid].hidden);
            const fq = taxa.length ? `&fq=taxon_id:(${taxa.join(' OR ')})` : '';
            const facetField = "{!facet.limit='300' facet.mincount='1' key='taxon_id'}taxon_id";
            const url = `${api}/search?q=${q}${fq}&fq=expressed_in_gxa_attr_ss:*&rows=0&facet=true&facet.field=${facetField}`;
            fetch(url).then((r)=>r.json()).then((json)=>{
                const arr = json && json.facet_counts && json.facet_counts.facet_fields && json.facet_counts.facet_fields.taxon_id || [];
                const data = {};
                for(let i = 0; i < arr.length; i += 2)data[arr[i]] = arr[i + 1];
                if (Object.keys(data).length === 0) console.warn('[exprViz] no taxon_ids found with expression', {
                    url: url,
                    json: json
                });
                dispatch({
                    type: 'EXPRVIZ_PIVOT_SUCCEEDED',
                    payload: {
                        requestId: requestId,
                        data: data
                    }
                });
            }).catch((err)=>{
                dispatch({
                    type: 'EXPRVIZ_PIVOT_FAILED',
                    payload: {
                        requestId: requestId,
                        error: String(err)
                    }
                });
            });
        },
    doSetExprVizActiveTaxon: (tid)=>({ dispatch: dispatch })=>dispatch({
                type: 'EXPRVIZ_ACTIVE_TAXON_SET',
                payload: tid
            }),
    doToggleExprVizFieldsModal: (taxon, open)=>({ dispatch: dispatch, store: store })=>{
            dispatch({
                type: 'EXPRVIZ_FIELDS_MODAL_TOGGLED',
                payload: {
                    taxon: taxon,
                    open: !!open
                }
            });
            if (open) store.doFetchExprVizAvailableAttrs(taxon);
        },
    doFetchExprVizAvailableAttrs: (taxon)=>({ dispatch: dispatch, store: store })=>{
            const q = store.selectGrameneFiltersQueryString();
            const signature = `${q}|${taxon}`;
            const ev = store.selectExprViz();
            const t = ev.byTaxon[taxon];
            if (t && t.availableAttrs && t.attrsSignature === signature) return;
            const requestId = $4f15cd8a7d970b18$var$attrsPending[taxon] = ($4f15cd8a7d970b18$var$attrsPending[taxon] || 0) + 1;
            dispatch({
                type: 'EXPRVIZ_ATTRS_STARTED',
                payload: {
                    taxon: taxon,
                    requestId: requestId,
                    signature: signature
                }
            });
            const api = store.selectGrameneAPI();
            const facetField = "{!facet.limit='2000' facet.mincount='1' key='attrs'}expressed_in_gxa_attr_ss";
            const url = `${api}/search?q=${q}&fq=taxon_id:${taxon}&fq=expressed_in_gxa_attr_ss:*&rows=0&facet=true&facet.field=${facetField}`;
            fetch(url).then((r)=>r.json()).then((json)=>{
                if (requestId !== $4f15cd8a7d970b18$var$attrsPending[taxon]) return;
                const arr = json && json.facet_counts && json.facet_counts.facet_fields && json.facet_counts.facet_fields.attrs || [];
                const attrs = [];
                for(let i = 0; i < arr.length; i += 2)attrs.push(arr[i]);
                dispatch({
                    type: 'EXPRVIZ_ATTRS_SUCCEEDED',
                    payload: {
                        taxon: taxon,
                        requestId: requestId,
                        attrs: attrs
                    }
                });
            }).catch(()=>{});
        },
    doSetExprVizFields: (taxon, fields)=>({ dispatch: dispatch })=>dispatch({
                type: 'EXPRVIZ_FIELDS_SET',
                payload: {
                    taxon: taxon,
                    fields: fields
                }
            }),
    doReorderExprVizFields: (taxon, fields)=>({ dispatch: dispatch })=>dispatch({
                type: 'EXPRVIZ_FIELDS_REORDERED',
                payload: {
                    taxon: taxon,
                    fields: fields
                }
            }),
    doSetExprVizVizMode: (taxon, vizMode)=>({ dispatch: dispatch })=>dispatch({
                type: 'EXPRVIZ_VIZMODE_SET',
                payload: {
                    taxon: taxon,
                    vizMode: vizMode
                }
            }),
    doSetExprVizScale: (taxon, scale)=>({ dispatch: dispatch })=>dispatch({
                type: 'EXPRVIZ_SCALE_SET',
                payload: {
                    taxon: taxon,
                    scale: scale
                }
            }),
    doSetExprVizBrushes: (taxon, brushes)=>({ dispatch: dispatch })=>dispatch({
                type: 'EXPRVIZ_BRUSHES_SET',
                payload: {
                    taxon: taxon,
                    brushes: brushes
                }
            }),
    // Re-apply persisted exprViz view config from a saved-view snapshot. Called
    // by viewSnapshot's doApplyViewSnapshot after filters/views have been
    // restored, so the re-fetch (driven by reactExprVizRestoreLoad) sees the
    // restored query context.
    doApplyExprVizSnapshot: (snap)=>({ dispatch: dispatch })=>{
            if (!snap || typeof snap !== 'object') return;
            dispatch({
                type: 'EXPRVIZ_RESTORED',
                payload: {
                    activeTaxon: snap.activeTaxon || null,
                    byTaxon: snap.byTaxon || {}
                }
            });
        },
    doFetchExprVizData: (taxon)=>({ dispatch: dispatch, store: store })=>{
            const ev = store.selectExprViz();
            const t = ev.byTaxon[taxon];
            if (!t || t.selectedFields.length === 0) return;
            const requestId = $4f15cd8a7d970b18$var$fetchPending[taxon] = ($4f15cd8a7d970b18$var$fetchPending[taxon] || 0) + 1;
            const signature = $4f15cd8a7d970b18$var$fetchSignature(store, taxon);
            dispatch({
                type: 'EXPRVIZ_FETCH_STARTED',
                payload: {
                    taxon: taxon,
                    requestId: requestId,
                    signature: signature
                }
            });
            const api = store.selectGrameneAPI();
            const q = store.selectGrameneFiltersQueryString();
            const fl = [
                ...new Set([
                    ...$4f15cd8a7d970b18$var$ALWAYS_FL,
                    ...t.selectedFields
                ])
            ].join(',');
            const fetchPage = (offset)=>{
                if (requestId !== $4f15cd8a7d970b18$var$fetchPending[taxon]) return; // superseded
                const url = `${api}/search?q=${q}&fq=taxon_id:${taxon}&fl=${fl}&rows=${$4f15cd8a7d970b18$var$PAGE_SIZE}&start=${offset}`;
                fetch(url).then((r)=>r.json()).then((json)=>{
                    if (requestId !== $4f15cd8a7d970b18$var$fetchPending[taxon]) return;
                    const docs = json.response && json.response.docs || [];
                    const total = json.response && json.response.numFound || 0;
                    dispatch({
                        type: 'EXPRVIZ_FETCH_BATCH',
                        payload: {
                            taxon: taxon,
                            requestId: requestId,
                            docs: docs,
                            total: total
                        }
                    });
                    const next = offset + docs.length;
                    if (docs.length > 0 && next < total) fetchPage(next);
                }).catch((err)=>{
                    dispatch({
                        type: 'EXPRVIZ_FETCH_FAILED',
                        payload: {
                            taxon: taxon,
                            requestId: requestId,
                            error: String(err)
                        }
                    });
                });
            };
            fetchPage(0);
        },
    // Per-candidate-field non-null counts under the current q + taxon. Used by
    // FieldsModal to hide fields that have no data in the current result set
    // before the user picks. Uses stats.field (the swagger whitelist drops
    // facet.query) batched across multiple GETs to stay under URL limits.
    doFetchExprVizFieldExistence: (taxon, fields)=>({ dispatch: dispatch, store: store })=>{
            if (!fields || fields.length === 0) return;
            const q = store.selectGrameneFiltersQueryString();
            const fieldsKey = fields.slice().sort().join(',');
            const signature = `${q}|${taxon}|${fieldsKey}`;
            const ev = store.selectExprViz();
            const t = ev.byTaxon[taxon];
            if (t && t.fieldExistence && t.existenceSignature === signature) return;
            const requestId = $4f15cd8a7d970b18$var$existencePending[taxon] = ($4f15cd8a7d970b18$var$existencePending[taxon] || 0) + 1;
            dispatch({
                type: 'EXPRVIZ_EXISTENCE_STARTED',
                payload: {
                    taxon: taxon,
                    requestId: requestId,
                    signature: signature
                }
            });
            const api = store.selectGrameneAPI();
            const BATCH_SIZE = 40;
            const batches = [];
            for(let i = 0; i < fields.length; i += BATCH_SIZE)batches.push(fields.slice(i, i + BATCH_SIZE));
            Promise.all(batches.map((batch)=>{
                const params = new URLSearchParams();
                params.append('q', q);
                params.append('fq', `taxon_id:${taxon}`);
                params.append('rows', '0');
                params.append('stats', 'true');
                batch.forEach((f)=>params.append('stats.field', f));
                return fetch(`${api}/search?${params.toString()}`).then((r)=>r.json()).then((json)=>{
                    const sf = json && json.stats && json.stats.stats_fields || {};
                    const out = {};
                    for (const f of Object.keys(sf)){
                        const s = sf[f];
                        out[f] = s && typeof s.count === 'number' ? s.count : 0;
                    }
                    return out;
                });
            })).then((results)=>{
                if (requestId !== $4f15cd8a7d970b18$var$existencePending[taxon]) return;
                const counts = Object.assign({}, ...results);
                dispatch({
                    type: 'EXPRVIZ_EXISTENCE_SUCCEEDED',
                    payload: {
                        taxon: taxon,
                        requestId: requestId,
                        counts: counts
                    }
                });
            }).catch(()=>{});
        },
    reactExprVizPivot: (0, $gXNCa$reduxbundler.createSelector)('selectExprViz', 'selectGrameneFiltersStatus', 'selectGrameneViews', 'selectGrameneFiltersQueryString', 'selectGrameneGenomes', 'selectGrameneMaps', (ev, filtersStatus, views, q, g, m)=>{
        if (!ev || filtersStatus === 'init') return;
        const onView = views && views.options && views.options.find((v)=>v.id === 'exprViz');
        if (!onView || onView.show !== 'on') return;
        const maps = m || {};
        const taxa = Object.keys(g && g.active || {}).filter((tid)=>maps[tid] && !maps[tid].hidden);
        const sig = `${q}|${taxa.sort().join(',')}`;
        if (ev.pivot.status === 'loading') return;
        if (ev.pivot.signature === sig && ev.pivot.status === 'ready') return;
        return {
            actionCreator: 'doFetchExprVizPivot'
        };
    }),
    // After a saved view is applied, EXPRVIZ_RESTORED flags each taxon that had
    // a field selection with pendingLoad. Once the search context is live (not
    // 'init') and the view is on, re-fetch that taxon's rows. Fires one taxon at
    // a time; EXPRVIZ_FETCH_STARTED clears the flag so this won't loop. Robust to
    // a GRAMENE_SEARCH_CLEARED that wipes rows mid-restore — the flag persists.
    reactExprVizRestoreLoad: (0, $gXNCa$reduxbundler.createSelector)('selectExprViz', 'selectGrameneFiltersStatus', 'selectGrameneViews', (ev, filtersStatus, views)=>{
        if (!ev || filtersStatus === 'init') return;
        const onView = views && views.options && views.options.find((v)=>v.id === 'exprViz');
        if (!onView || onView.show !== 'on') return;
        for (const tid of Object.keys(ev.byTaxon || {})){
            const t = ev.byTaxon[tid];
            if (t && t.pendingLoad && t.selectedFields.length > 0 && t.rows.length === 0 && t.fetch.status !== 'loading') return {
                actionCreator: 'doFetchExprVizData',
                args: [
                    tid
                ]
            };
        }
    }),
    selectExprViz: (state)=>state.exprViz,
    selectExprVizPivot: (state)=>state.exprViz.pivot,
    selectExprVizActiveTaxon: (state)=>state.exprViz.activeTaxon,
    selectExprVizByTaxon: (state)=>state.exprViz.byTaxon
};
var $4f15cd8a7d970b18$export$2e2bcd8739ae039 = $4f15cd8a7d970b18$var$exprViz;
// Shared vocabulary and helpers for the sorghum_v10b per-gene expression
// attributes (`expr_*__attr_*`). Used by both the Homology tbrowse Expression
// zone (results/details/exprAttrsZone.js) and the Attribute table view
// (attrTable/AttrTableView.js) so organ ordering and the ordinal level colors
// stay a single source of truth.
// Canonical anatomical ordering (vegetative → reproductive → seed). Organs not
// listed here are appended alphabetically so nothing is ever dropped.
const $4b8473139e48e77e$export$a59633f9e62f0e07 = [
    'root',
    'shoot',
    'stem',
    'leaf',
    'meristem',
    'vasculature',
    'tuber',
    'cotyledon',
    'inflorescence',
    'flower',
    'anther_pollen',
    'fruit',
    'pericarp',
    'seed',
    'endosperm',
    'embryo'
];
const $4b8473139e48e77e$export$9a0b81895f7233d0 = {
    root: 'rt',
    shoot: 'sht',
    stem: 'stm',
    leaf: 'lf',
    meristem: 'mer',
    vasculature: 'vas',
    tuber: 'tbr',
    cotyledon: 'cot',
    inflorescence: 'inf',
    flower: 'flw',
    anther_pollen: 'ant',
    fruit: 'frt',
    pericarp: 'per',
    seed: 'sd',
    endosperm: 'end',
    embryo: 'emb'
};
const $4b8473139e48e77e$export$f8541c2790c3baeb = (o)=>$4b8473139e48e77e$export$9a0b81895f7233d0[o] || o.slice(0, 3);
const $4b8473139e48e77e$export$50c1f966fd3af83e = (o)=>o.replace(/_/g, ' ');
const $4b8473139e48e77e$export$4bb936dc8856d37a = [
    'not_expressed',
    'low',
    'medium',
    'high',
    'very_high'
];
const $4b8473139e48e77e$export$b352e11f7a2ac9c5 = {
    not_expressed: '#eef2f6',
    low: '#cfe0ee',
    medium: '#8fbbdc',
    high: '#3f86c2',
    very_high: '#0a3d72'
};
const $4b8473139e48e77e$export$433053e2c141d410 = {
    not_expressed: 'not expressed',
    low: 'low',
    medium: 'medium',
    high: 'high',
    very_high: 'very high'
};
const $4b8473139e48e77e$export$a61929d6d484c6d4 = $4b8473139e48e77e$export$4bb936dc8856d37a.reduce((m, l, i)=>{
    m[l] = i;
    return m;
}, {});
const $4b8473139e48e77e$export$c6dbe9be8c8b382e = {
    up: {
        bg: '#eaf2fb',
        fg: '#2e6fae'
    },
    down: {
        bg: '#fdecea',
        fg: '#c0392b'
    }
};
function $4b8473139e48e77e$export$8ca7625ba2054603(tokens) {
    const out = {};
    (tokens || []).forEach((t)=>{
        const i = t.lastIndexOf(':');
        if (i < 0) return;
        out[t.slice(0, i)] = t.slice(i + 1);
    });
    return out;
}
function $4b8473139e48e77e$export$65382efdcdd96f8c(organs) {
    const set = organs instanceof Set ? organs : new Set(organs || []);
    const known = $4b8473139e48e77e$export$a59633f9e62f0e07.filter((o)=>set.has(o));
    const unknown = [
        ...set
    ].filter((o)=>!$4b8473139e48e77e$export$a59633f9e62f0e07.includes(o)).sort();
    return [
        ...known,
        ...unknown
    ];
}
function $4b8473139e48e77e$export$69fb5d19b5db1cfa(doc) {
    const d = doc || {};
    const cls = d.expr_class__attr_ss || [];
    const maxTpm = Number.isFinite(+d.expr_max_tpm__attr_f) ? +d.expr_max_tpm__attr_f : null;
    const tau = Number.isFinite(+d.expr_tau__attr_f) ? +d.expr_tau__attr_f : null;
    return {
        organLevels: $4b8473139e48e77e$export$8ca7625ba2054603(d.expr_organ_level__attr_ss),
        specificTo: new Set(d.expr_specific_to__attr_ss || []),
        enhancedIn: new Set(d.expr_enhanced_in__attr_ss || []),
        highIn: new Set(d.expr_high_in__attr_ss || []),
        cls: cls,
        maxTpm: maxTpm,
        tau: tau,
        nOrgans: Number.isFinite(+d.expr_n_organs_detected__attr_i) ? +d.expr_n_organs_detected__attr_i : null,
        activatedBy: d.expr_activated_by__attr_ss || [],
        repressedBy: d.expr_repressed_by__attr_ss || []
    };
}
function $4b8473139e48e77e$export$fc40d061e6c16645(v, range) {
    if (!Number.isFinite(v)) return null;
    const lo = Math.log10((range && range.min || 0) + 1);
    const hi = Math.log10((range && range.max || 0) + 1);
    if (hi <= lo) return 0.5;
    return Math.max(0, Math.min(1, (Math.log10(v + 1) - lo) / (hi - lo)));
}
function $4b8473139e48e77e$export$4b443417c5259620(v, range) {
    const f = $4b8473139e48e77e$export$fc40d061e6c16645(v, range);
    if (f === null) return 'transparent';
    return `rgba(33, 102, 172, ${(0.1 + 0.65 * f).toFixed(3)})`;
}
function $4b8473139e48e77e$export$8eaa32ef86afdd9c(v) {
    if (!Number.isFinite(v)) return '';
    return v >= 10 ? String(Math.round(v)) : String(Math.round(v * 10) / 10);
}
function $4b8473139e48e77e$export$1f04174626f2ac64(cls) {
    return cls && cls.length ? cls.map((c)=>c.replace(/_/g, ' ')).join(', ') : null;
}
const $4b8473139e48e77e$export$705aff68da3ddba0 = [
    'expr_class__attr_ss',
    'expr_organ_level__attr_ss',
    'expr_specific_to__attr_ss',
    'expr_enhanced_in__attr_ss',
    'expr_high_in__attr_ss',
    'expr_activated_by__attr_ss',
    'expr_repressed_by__attr_ss',
    'expr_tau__attr_f',
    'expr_max_tpm__attr_f',
    'expr_n_organs_detected__attr_i'
];
// Backing store for the "Attribute table" view: the genes in the current search
// result set, fetched in pages and rendered as a gene × attribute table.
//
// Paging mirrors exprViz's doFetchExprVizData: a recursive fetchPage(offset)
// with a request-id guard so a superseded fetch can never write stale rows.
//
// The offered columns are deliberately limited to a few field-catalog groups —
// Core identifiers, Expression attributes and MAKER transcript metrics — and
// *all* of them are fetched up front. That keeps the column picker a pure
// visibility control: toggling a column is instant and never triggers a refetch.
const $12feb7ca48271e17$var$PAGE_SIZE = 1000;
const $12feb7ca48271e17$var$MAX_GENES = 5000;
// The catalog groups whose fields the column picker offers.
const $12feb7ca48271e17$export$53e90de8d659db95 = [
    'core',
    'exprattrs',
    'MAKER'
];
// The 'core' group's fields (bundles/../fieldCatalog.overlay.json).
const $12feb7ca48271e17$export$9d77d82cc773e55e = [
    'id',
    'name',
    'alt_id',
    'synonyms',
    'description',
    'summary',
    'biotype',
    'system_name',
    'taxon_id',
    'db_type'
];
// The 'MAKER' group's fields: MAKER's annotation quality metrics (AED and the
// quality index QI1-QI9). Only some releases have them (e.g. SorghumBase); Solr
// returns nothing for them elsewhere, and the picker then hides the empty group.
const $12feb7ca48271e17$export$3ae897f4a2495276 = [
    'MAKER__AED__attr_f',
    'MAKER__QI1__attr_i',
    'MAKER__QI2__attr_f',
    'MAKER__QI3__attr_f',
    'MAKER__QI4__attr_f',
    'MAKER__QI5__attr_f',
    'MAKER__QI6__attr_f',
    'MAKER__QI7__attr_i',
    'MAKER__QI8__attr_i',
    'MAKER__QI9__attr_i'
];
// Always fetched, so visibility toggles never need the network. taxon_id is
// needed by the genome filter even when its column is hidden.
const $12feb7ca48271e17$var$FETCH_FIELDS = [
    ...new Set([
        ...$12feb7ca48271e17$export$9d77d82cc773e55e,
        ...$4b8473139e48e77e$export$705aff68da3ddba0,
        ...$12feb7ca48271e17$export$3ae897f4a2495276
    ])
];
// Default columns, in display order. The two stress fields are adjacent so the
// view can merge them into a single "Activated/Repressed by condition" column.
const $12feb7ca48271e17$export$e4bc2ac09afbc604 = [
    'id',
    'expr_max_tpm__attr_f',
    'expr_organ_level__attr_ss',
    'expr_class__attr_ss',
    'expr_activated_by__attr_ss',
    'expr_repressed_by__attr_ss'
];
let $12feb7ca48271e17$var$fetchPendingId = 0;
// Only send fq=taxon_id:(...) when the user has actually subset the genomes —
// same rule the main search uses (see bundles/api.js), so the table matches the
// visible result set without bloating the URL.
function $12feb7ca48271e17$var$genomeSubset(g, m) {
    const maps = m || {};
    const visibleTaxa = Object.keys(maps).filter((tid)=>!maps[tid].hidden);
    const activeVisible = Object.keys(g && g.active || {}).filter((tid)=>maps[tid] && !maps[tid].hidden);
    const subset = activeVisible.length > 0 && activeVisible.length < visibleTaxa.length;
    const sorted = activeVisible.slice().sort();
    return {
        fq: subset ? `&fq=taxon_id:(${sorted.join(' OR ')})` : '',
        key: subset ? sorted.join(',') : ''
    };
}
// Visible columns are deliberately NOT part of the signature — they don't
// affect what we fetch.
function $12feb7ca48271e17$var$computeSignature(q, g, m) {
    return `${q}|${$12feb7ca48271e17$var$genomeSubset(g, m).key}`;
}
const $12feb7ca48271e17$var$attrTable = {
    name: 'attrTable',
    getReducer: ()=>{
        const initialState = {
            status: 'idle',
            docs: [],
            total: 0,
            truncated: false,
            signature: null,
            error: null,
            requestId: 0,
            visibleFields: $12feb7ca48271e17$export$e4bc2ac09afbc604.slice()
        };
        return (state = initialState, { type: type, payload: payload })=>{
            switch(type){
                case 'ATTRTABLE_FETCH_STARTED':
                    return {
                        ...state,
                        status: 'loading',
                        docs: [],
                        total: 0,
                        truncated: false,
                        error: null,
                        signature: payload.signature,
                        requestId: payload.requestId
                    };
                case 'ATTRTABLE_FETCH_BATCH':
                    {
                        if (payload.requestId !== state.requestId) return state; // superseded
                        const docs = state.docs.concat(payload.docs);
                        const target = Math.min(payload.total, $12feb7ca48271e17$var$MAX_GENES);
                        return {
                            ...state,
                            docs: docs,
                            total: payload.total,
                            truncated: payload.total > $12feb7ca48271e17$var$MAX_GENES,
                            status: docs.length >= target ? 'ready' : 'loading'
                        };
                    }
                case 'ATTRTABLE_FETCH_FAILED':
                    if (payload.requestId !== state.requestId) return state;
                    return {
                        ...state,
                        status: 'error',
                        error: payload.error
                    };
                case 'ATTRTABLE_FIELD_TOGGLED':
                    {
                        const set = new Set(state.visibleFields);
                        if (set.has(payload)) set.delete(payload);
                        else set.add(payload);
                        return {
                            ...state,
                            visibleFields: [
                                ...set
                            ]
                        };
                    }
                case 'ATTRTABLE_FIELDS_BULK_SET':
                    {
                        const set = new Set(state.visibleFields);
                        (payload.names || []).forEach((n)=>{
                            if (payload.selected) set.add(n);
                            else set.delete(n);
                        });
                        return {
                            ...state,
                            visibleFields: [
                                ...set
                            ]
                        };
                    }
                case 'ATTRTABLE_FIELDS_RESET':
                    return {
                        ...state,
                        visibleFields: $12feb7ca48271e17$export$e4bc2ac09afbc604.slice()
                    };
                case 'GRAMENE_SEARCH_CLEARED':
                    return {
                        ...initialState,
                        visibleFields: state.visibleFields
                    };
                default:
                    return state;
            }
        };
    },
    doFetchAttrTable: ()=>({ dispatch: dispatch, store: store })=>{
            const q = store.selectGrameneFiltersQueryString();
            const { fq: fq } = $12feb7ca48271e17$var$genomeSubset(store.selectGrameneGenomes(), store.selectGrameneMaps());
            const signature = $12feb7ca48271e17$var$computeSignature(q, store.selectGrameneGenomes(), store.selectGrameneMaps());
            const requestId = ++$12feb7ca48271e17$var$fetchPendingId;
            dispatch({
                type: 'ATTRTABLE_FETCH_STARTED',
                payload: {
                    requestId: requestId,
                    signature: signature
                }
            });
            const api = store.selectGrameneAPI();
            // Explicit fl — never fl=*, which would drag in every per-sample __expr column.
            const fl = $12feb7ca48271e17$var$FETCH_FIELDS.join(',');
            const fetchPage = (offset)=>{
                if (requestId !== $12feb7ca48271e17$var$fetchPendingId) return; // superseded
                const rows = Math.min($12feb7ca48271e17$var$PAGE_SIZE, $12feb7ca48271e17$var$MAX_GENES - offset);
                if (rows <= 0) return;
                const url = `${api}/search?q=${q}${fq}&fl=${fl}&rows=${rows}&start=${offset}`;
                fetch(url).then((r)=>r.json()).then((json)=>{
                    if (requestId !== $12feb7ca48271e17$var$fetchPendingId) return;
                    const docs = json.response && json.response.docs || [];
                    const total = json.response && json.response.numFound || 0;
                    dispatch({
                        type: 'ATTRTABLE_FETCH_BATCH',
                        payload: {
                            requestId: requestId,
                            docs: docs,
                            total: total
                        }
                    });
                    const next = offset + docs.length;
                    if (docs.length > 0 && next < Math.min(total, $12feb7ca48271e17$var$MAX_GENES)) fetchPage(next);
                }).catch((err)=>{
                    dispatch({
                        type: 'ATTRTABLE_FETCH_FAILED',
                        payload: {
                            requestId: requestId,
                            error: String(err)
                        }
                    });
                });
            };
            fetchPage(0);
        },
    doToggleAttrTableField: (name)=>({ dispatch: dispatch })=>dispatch({
                type: 'ATTRTABLE_FIELD_TOGGLED',
                payload: name
            }),
    doBulkSetAttrTableFields: (names, selected)=>({ dispatch: dispatch })=>dispatch({
                type: 'ATTRTABLE_FIELDS_BULK_SET',
                payload: {
                    names: names,
                    selected: selected
                }
            }),
    doResetAttrTableFields: ()=>({ dispatch: dispatch })=>dispatch({
                type: 'ATTRTABLE_FIELDS_RESET'
            }),
    selectAttrTable: (state)=>state.attrTable,
    selectAttrTableVisibleFields: (state)=>state.attrTable.visibleFields,
    // Fetch only while the view is on, and only when the query context changes.
    reactAttrTableFetch: (0, $gXNCa$reduxbundler.createSelector)('selectAttrTable', 'selectGrameneFiltersStatus', 'selectGrameneViewsOn', 'selectGrameneFiltersQueryString', 'selectGrameneGenomes', 'selectGrameneMaps', (at, filtersStatus, viewsOn, q, g, m)=>{
        if (!at || filtersStatus === 'init') return;
        if (!viewsOn || !viewsOn.has('attrTable')) return;
        if (at.status === 'loading') return;
        const sig = $12feb7ca48271e17$var$computeSignature(q, g, m);
        if (at.signature === sig && (at.status === 'ready' || at.status === 'error')) return;
        return {
            actionCreator: 'doFetchAttrTable'
        };
    })
};
const $12feb7ca48271e17$export$d00a9fd01497b827 = {
    PAGE_SIZE: $12feb7ca48271e17$var$PAGE_SIZE,
    MAX_GENES: $12feb7ca48271e17$var$MAX_GENES
};
var $12feb7ca48271e17$export$2e2bcd8739ae039 = $12feb7ca48271e17$var$attrTable;
const $6c52be7952d5ec43$export$f3878c70e70de19e = [
    {
        field: 'capabilities',
        heading: 'Available data',
        hide: [
            'expression_attributes',
            'location',
            'taxonomy',
            'xrefs',
            'familyRoot',
            'MAKER',
            'Grassius'
        ],
        // Per-value display overrides (raw value -> label). Anything not listed falls
        // back to underscores->spaces. The raw value is still what gets filtered on.
        labels: {
            expression: 'Expression',
            homology: 'Homology',
            domains: 'Domains',
            grassius_homolog: 'Grassius',
            GO: 'Gene Ontology',
            PO: 'Plant Ontology',
            TO: 'Trait Ontology',
            QTL_TO: 'QTL',
            VEP: 'Loss-of-function variants',
            pubs: 'Curated in literature'
        }
    },
    {
        field: 'expr_class__attr_ss',
        heading: 'Expression class'
    },
    {
        field: 'grassius_homolog__attr_ss',
        heading: 'TF family (GRASSIUS)'
    }
];
const $6c52be7952d5ec43$var$FACET_FIELDS = $6c52be7952d5ec43$export$f3878c70e70de19e.map((g)=>g.field);
// field -> Set of raw values to omit from the rendered group.
const $6c52be7952d5ec43$var$HIDE_BY_FIELD = {};
$6c52be7952d5ec43$export$f3878c70e70de19e.forEach((g)=>{
    if (g.hide && g.hide.length) $6c52be7952d5ec43$var$HIDE_BY_FIELD[g.field] = new Set(g.hide);
});
// The output key of a Solr facet defaults to the field name, so no {!key=...}
// local params are needed — just one facet.field per field.
const $6c52be7952d5ec43$var$FACET_PARAMS = $6c52be7952d5ec43$var$FACET_FIELDS.map((f)=>`facet.field=${f}`).join('&');
let $6c52be7952d5ec43$var$fetchPendingId = 0;
// Same rule the main search uses: only constrain by taxon_id when the user has
// actually subset the visible genomes (see bundles/api.js). Keeps counts in step
// with the visible result set without bloating the URL.
function $6c52be7952d5ec43$var$genomeSubset(g, m) {
    const maps = m || {};
    const visibleTaxa = Object.keys(maps).filter((tid)=>!maps[tid].hidden);
    const activeVisible = Object.keys(g && g.active || {}).filter((tid)=>maps[tid] && !maps[tid].hidden);
    const subset = activeVisible.length > 0 && activeVisible.length < visibleTaxa.length;
    const sorted = activeVisible.slice().sort();
    return {
        fq: subset ? `&fq=taxon_id:(${sorted.join(' OR ')})` : '',
        key: subset ? sorted.join(',') : ''
    };
}
function $6c52be7952d5ec43$var$computeSignature(q, g, m) {
    return `${q}|${$6c52be7952d5ec43$var$genomeSubset(g, m).key}`;
}
const $6c52be7952d5ec43$var$facetCounts = {
    name: 'facetCounts',
    getReducer: ()=>{
        const initialState = {
            status: 'idle',
            signature: null,
            groups: {},
            error: null,
            requestId: 0,
            open: false
        };
        return (state = initialState, { type: type, payload: payload })=>{
            switch(type){
                case 'FACETCOUNTS_TOGGLE_OPEN':
                    return {
                        ...state,
                        open: typeof payload === 'boolean' ? payload : !state.open
                    };
                case 'FACETCOUNTS_FETCH_STARTED':
                    // Keep the previous groups visible during a refetch (smooth update);
                    // they're replaced when the new counts land.
                    return {
                        ...state,
                        status: 'loading',
                        error: null,
                        signature: payload.signature,
                        requestId: payload.requestId
                    };
                case 'FACETCOUNTS_FETCH_DONE':
                    if (payload.requestId !== state.requestId) return state; // superseded
                    return {
                        ...state,
                        status: 'ready',
                        groups: payload.groups
                    };
                case 'FACETCOUNTS_FETCH_FAILED':
                    if (payload.requestId !== state.requestId) return state;
                    return {
                        ...state,
                        status: 'error',
                        error: payload.error
                    };
                default:
                    return state;
            }
        };
    },
    doToggleFacetCounts: (open)=>({ dispatch: dispatch })=>dispatch({
                type: 'FACETCOUNTS_TOGGLE_OPEN',
                payload: open
            }),
    doFetchFacetCounts: ()=>({ dispatch: dispatch, store: store })=>{
            const q = store.selectGrameneFiltersQueryString();
            const { fq: fq } = $6c52be7952d5ec43$var$genomeSubset(store.selectGrameneGenomes(), store.selectGrameneMaps());
            const signature = $6c52be7952d5ec43$var$computeSignature(q, store.selectGrameneGenomes(), store.selectGrameneMaps());
            const requestId = ++$6c52be7952d5ec43$var$fetchPendingId;
            dispatch({
                type: 'FACETCOUNTS_FETCH_STARTED',
                payload: {
                    requestId: requestId,
                    signature: signature
                }
            });
            const api = store.selectGrameneAPI();
            const url = `${api}/search?q=${q}${fq}&rows=0&facet=true&facet.mincount=1&facet.limit=-1&${$6c52be7952d5ec43$var$FACET_PARAMS}`;
            fetch(url).then((r)=>r.json()).then((json)=>{
                if (requestId !== $6c52be7952d5ec43$var$fetchPendingId) return;
                const ff = json.facet_counts && json.facet_counts.facet_fields || {};
                const groups = {};
                $6c52be7952d5ec43$var$FACET_FIELDS.forEach((f)=>{
                    const arr = ff[f] || [];
                    const hidden = $6c52be7952d5ec43$var$HIDE_BY_FIELD[f];
                    const vals = [];
                    for(let i = 0; i < arr.length; i += 2){
                        if (hidden && hidden.has(arr[i])) continue;
                        // facet.mincount=1 already excludes empty buckets; belt and braces so
                        // a zero can never reach the sidebar if that param is ever relaxed.
                        if (!(arr[i + 1] > 0)) continue;
                        vals.push({
                            value: arr[i],
                            count: arr[i + 1]
                        });
                    }
                    groups[f] = vals;
                });
                dispatch({
                    type: 'FACETCOUNTS_FETCH_DONE',
                    payload: {
                        requestId: requestId,
                        groups: groups
                    }
                });
            }).catch((err)=>{
                dispatch({
                    type: 'FACETCOUNTS_FETCH_FAILED',
                    payload: {
                        requestId: requestId,
                        error: String(err)
                    }
                });
            });
        },
    selectFacetCounts: (state)=>state.facetCounts,
    selectFacetCountsOpen: (state)=>state.facetCounts.open,
    selectFacetCountsGroups: (state)=>state.facetCounts.groups,
    // Fetch only while the section is open, once per unique (query, genomes).
    reactFacetCountsFetch: (0, $gXNCa$reduxbundler.createSelector)('selectFacetCounts', 'selectGrameneFiltersStatus', 'selectGrameneFiltersQueryString', 'selectGrameneGenomes', 'selectGrameneMaps', (fc, filtersStatus, q, g, m)=>{
        if (!fc || !fc.open) return;
        if (filtersStatus === 'init') return;
        if (fc.status === 'loading') return;
        const sig = $6c52be7952d5ec43$var$computeSignature(q, g, m);
        if (fc.signature === sig && (fc.status === 'ready' || fc.status === 'error')) return;
        return {
            actionCreator: 'doFetchFacetCounts'
        };
    })
};
var $6c52be7952d5ec43$export$2e2bcd8739ae039 = $6c52be7952d5ec43$var$facetCounts;
// Ontology over-representation analysis (clusterProfiler::enrichGO-style).
//
// For each species tab we run:
//   foreground: q=<filters>&fq=taxon_id:<tid>&rows=0 + facet on six __ancestors fields
//   background: q=taxon_id:<tid>&rows=0           + same facets (cached forever per tid)
//
// For every ontology section we compute a single hypergeometric universe:
//   N = # genes annotated to any term in this ontology section (= largest bg facet count)
//   K = # input genes annotated to any term in this section    (= largest fg facet count)
// and per term:
//   M = bg facet count, count = fg facet count
//   p = P(X >= count), X ~ Hypergeometric(N, M, K)
// p-values are BH-adjusted across the tested terms in the section.
// GO is split into its three sub-ontologies (BP/MF/CC) by namespace so each
// gets its own (N, K) and BH correction, matching enrichGO. Terms with
// fewer than `minGSSize` or more than `maxGSSize` annotated genes are
// dropped before testing (enrichGO defaults: 10 / 500).
const $d365d8c287ab0c94$var$ONTOLOGIES = [
    {
        key: 'GO',
        field: 'GO__ancestors',
        label: 'Gene Ontology',
        bucket: 'GO'
    },
    {
        key: 'PO',
        field: 'PO__ancestors',
        label: 'Plant Ontology',
        bucket: 'PO'
    },
    {
        key: 'TO',
        field: 'TO__ancestors',
        label: 'Trait Ontology',
        bucket: 'TO'
    },
    {
        key: 'QTL_TO',
        field: 'QTL_TO__ancestors',
        label: 'QTL Traits (TO)',
        bucket: 'TO'
    },
    {
        key: 'domains',
        field: 'domains__ancestors',
        label: 'InterPro Domains',
        bucket: 'domains'
    },
    {
        key: 'pathways',
        field: 'pathways__ancestors',
        label: 'Pathways',
        bucket: null
    }
];
const $d365d8c287ab0c94$var$FACET_PARAMS = $d365d8c287ab0c94$var$ONTOLOGIES.map((o)=>`facet.field=${encodeURIComponent(`{!facet.limit=10000 facet.mincount=1 key=${o.key}}${o.field}`)}`).join('&');
const $d365d8c287ab0c94$var$fgPending = {};
const $d365d8c287ab0c94$var$bgPending = {};
function $d365d8c287ab0c94$var$fgSig(q, taxon) {
    return `${q}|${taxon}`;
}
function $d365d8c287ab0c94$var$bgSig(taxon) {
    return `bg|${taxon}`;
}
function $d365d8c287ab0c94$var$parseFacets(json) {
    const out = {};
    const ff = json && json.facet_counts && json.facet_counts.facet_fields || {};
    for (const o of $d365d8c287ab0c94$var$ONTOLOGIES){
        const arr = ff[o.key] || [];
        const map = {};
        for(let i = 0; i < arr.length; i += 2)map[+arr[i]] = +arr[i + 1];
        out[o.key] = map;
    }
    return out;
}
const $d365d8c287ab0c94$var$ontologyEnrichment = {
    name: 'ontologyEnrichment',
    // Background facet counts depend only on the species — they're invariant
    // across filter changes and across sessions, so we persist whenever a bg
    // fetch completes. Foreground state piggybacks on the same write but is
    // self-invalidated by the signature check in the reactor.
    persistActions: [
        'ONTOLOGY_ENRICHMENT_BG_SUCCEEDED'
    ],
    getReducer: ()=>{
        const initialState = {
            activeTaxon: null,
            byTaxon: {},
            ui: {
                pAdjCutoff: 0.05,
                minGSSize: 10,
                maxGSSize: 500,
                mostSpecific: false,
                ontology: 'all',
                search: '',
                // Per-section table sort, keyed by ontology section id (e.g.
                // 'GO:biological_process'): { [sectionKey]: { key, dir } }.
                sort: {}
            }
        };
        function ensureTaxon(state, tid) {
            if (state.byTaxon[tid]) return state;
            return {
                ...state,
                byTaxon: {
                    ...state.byTaxon,
                    [tid]: {
                        fg: {
                            status: 'idle',
                            signature: null,
                            requestId: 0,
                            terms: null,
                            numFound: 0,
                            error: null
                        },
                        bg: {
                            status: 'idle',
                            signature: null,
                            requestId: 0,
                            terms: null,
                            numFound: 0,
                            error: null
                        }
                    }
                }
            };
        }
        return (state = initialState, { type: type, payload: payload })=>{
            switch(type){
                case 'ONTOLOGY_ENRICHMENT_ACTIVE_TAXON_SET':
                    return {
                        ...ensureTaxon(state, payload),
                        activeTaxon: payload
                    };
                case 'ONTOLOGY_ENRICHMENT_UI_SET':
                    return {
                        ...state,
                        ui: {
                            ...state.ui,
                            ...payload || {}
                        }
                    };
                case 'ONTOLOGY_ENRICHMENT_FG_STARTED':
                    {
                        const next = ensureTaxon(state, payload.taxon);
                        const t = next.byTaxon[payload.taxon];
                        return {
                            ...next,
                            byTaxon: {
                                ...next.byTaxon,
                                [payload.taxon]: {
                                    ...t,
                                    fg: {
                                        status: 'loading',
                                        signature: payload.signature,
                                        requestId: payload.requestId,
                                        terms: t.fg.terms,
                                        numFound: t.fg.numFound,
                                        error: null
                                    }
                                }
                            }
                        };
                    }
                case 'ONTOLOGY_ENRICHMENT_FG_SUCCEEDED':
                    {
                        const t = state.byTaxon[payload.taxon];
                        if (!t || payload.requestId !== t.fg.requestId) return state;
                        return {
                            ...state,
                            byTaxon: {
                                ...state.byTaxon,
                                [payload.taxon]: {
                                    ...t,
                                    fg: {
                                        ...t.fg,
                                        status: 'ready',
                                        terms: payload.terms,
                                        numFound: payload.numFound
                                    }
                                }
                            }
                        };
                    }
                case 'ONTOLOGY_ENRICHMENT_FG_FAILED':
                    {
                        const t = state.byTaxon[payload.taxon];
                        if (!t || payload.requestId !== t.fg.requestId) return state;
                        return {
                            ...state,
                            byTaxon: {
                                ...state.byTaxon,
                                [payload.taxon]: {
                                    ...t,
                                    fg: {
                                        ...t.fg,
                                        status: 'error',
                                        error: payload.error
                                    }
                                }
                            }
                        };
                    }
                case 'ONTOLOGY_ENRICHMENT_BG_STARTED':
                    {
                        const next = ensureTaxon(state, payload.taxon);
                        const t = next.byTaxon[payload.taxon];
                        return {
                            ...next,
                            byTaxon: {
                                ...next.byTaxon,
                                [payload.taxon]: {
                                    ...t,
                                    bg: {
                                        status: 'loading',
                                        signature: payload.signature,
                                        requestId: payload.requestId,
                                        terms: t.bg.terms,
                                        numFound: t.bg.numFound,
                                        error: null
                                    }
                                }
                            }
                        };
                    }
                case 'ONTOLOGY_ENRICHMENT_BG_SUCCEEDED':
                    {
                        const t = state.byTaxon[payload.taxon];
                        if (!t || payload.requestId !== t.bg.requestId) return state;
                        return {
                            ...state,
                            byTaxon: {
                                ...state.byTaxon,
                                [payload.taxon]: {
                                    ...t,
                                    bg: {
                                        ...t.bg,
                                        status: 'ready',
                                        terms: payload.terms,
                                        numFound: payload.numFound
                                    }
                                }
                            }
                        };
                    }
                case 'ONTOLOGY_ENRICHMENT_BG_FAILED':
                    {
                        const t = state.byTaxon[payload.taxon];
                        if (!t || payload.requestId !== t.bg.requestId) return state;
                        return {
                            ...state,
                            byTaxon: {
                                ...state.byTaxon,
                                [payload.taxon]: {
                                    ...t,
                                    bg: {
                                        ...t.bg,
                                        status: 'error',
                                        error: payload.error
                                    }
                                }
                            }
                        };
                    }
                case 'GRAMENE_SEARCH_CLEARED':
                    {
                        // Filters changed — invalidate foreground but keep background
                        // (it depends only on taxon).
                        const newByTaxon = {};
                        for (const tid of Object.keys(state.byTaxon)){
                            const t = state.byTaxon[tid];
                            newByTaxon[tid] = {
                                ...t,
                                fg: {
                                    status: 'idle',
                                    signature: null,
                                    requestId: 0,
                                    terms: null,
                                    numFound: 0,
                                    error: null
                                }
                            };
                        }
                        return {
                            ...state,
                            byTaxon: newByTaxon
                        };
                    }
                default:
                    return state;
            }
        };
    },
    doSetOntologyEnrichmentActiveTaxon: (tid)=>({ dispatch: dispatch })=>dispatch({
                type: 'ONTOLOGY_ENRICHMENT_ACTIVE_TAXON_SET',
                payload: tid
            }),
    doSetOntologyEnrichmentUI: (patch)=>({ dispatch: dispatch })=>dispatch({
                type: 'ONTOLOGY_ENRICHMENT_UI_SET',
                payload: patch
            }),
    // Re-apply persisted view config from a saved-view snapshot. Setting the
    // active taxon (last) lets reactOntologyEnrichmentFetch re-fetch the
    // foreground/background facets for the restored filters — no bulk data is
    // carried in the snapshot.
    doApplyOntologyEnrichmentSnapshot: (snap)=>({ dispatch: dispatch })=>{
            if (!snap || typeof snap !== 'object') return;
            if (snap.ui) dispatch({
                type: 'ONTOLOGY_ENRICHMENT_UI_SET',
                payload: snap.ui
            });
            if (snap.activeTaxon) dispatch({
                type: 'ONTOLOGY_ENRICHMENT_ACTIVE_TAXON_SET',
                payload: snap.activeTaxon
            });
        },
    doFetchOntologyEnrichmentForeground: (taxon)=>({ dispatch: dispatch, store: store })=>{
            const q = store.selectGrameneFiltersQueryString();
            const signature = $d365d8c287ab0c94$var$fgSig(q, taxon);
            const state = store.selectOntologyEnrichment();
            const t = state.byTaxon[taxon];
            if (t && t.fg.signature === signature && (t.fg.status === 'loading' || t.fg.status === 'ready')) return;
            const requestId = $d365d8c287ab0c94$var$fgPending[taxon] = ($d365d8c287ab0c94$var$fgPending[taxon] || 0) + 1;
            dispatch({
                type: 'ONTOLOGY_ENRICHMENT_FG_STARTED',
                payload: {
                    taxon: taxon,
                    signature: signature,
                    requestId: requestId
                }
            });
            const api = store.selectGrameneAPI();
            const url = `${api}/search?q=${q}&fq=taxon_id:${taxon}&rows=0&facet=true&${$d365d8c287ab0c94$var$FACET_PARAMS}`;
            fetch(url).then((r)=>r.json()).then((json)=>{
                if (requestId !== $d365d8c287ab0c94$var$fgPending[taxon]) return;
                const terms = $d365d8c287ab0c94$var$parseFacets(json);
                const numFound = json && json.response && json.response.numFound || 0;
                dispatch({
                    type: 'ONTOLOGY_ENRICHMENT_FG_SUCCEEDED',
                    payload: {
                        taxon: taxon,
                        requestId: requestId,
                        terms: terms,
                        numFound: numFound
                    }
                });
                store.doEnsureOntologyEnrichmentTermRecords(taxon);
            }).catch((err)=>{
                if (requestId !== $d365d8c287ab0c94$var$fgPending[taxon]) return;
                dispatch({
                    type: 'ONTOLOGY_ENRICHMENT_FG_FAILED',
                    payload: {
                        taxon: taxon,
                        requestId: requestId,
                        error: String(err)
                    }
                });
            });
        },
    doFetchOntologyEnrichmentBackground: (taxon)=>({ dispatch: dispatch, store: store })=>{
            const signature = $d365d8c287ab0c94$var$bgSig(taxon);
            const state = store.selectOntologyEnrichment();
            const t = state.byTaxon[taxon];
            if (t && t.bg.signature === signature && (t.bg.status === 'loading' || t.bg.status === 'ready')) return;
            const requestId = $d365d8c287ab0c94$var$bgPending[taxon] = ($d365d8c287ab0c94$var$bgPending[taxon] || 0) + 1;
            dispatch({
                type: 'ONTOLOGY_ENRICHMENT_BG_STARTED',
                payload: {
                    taxon: taxon,
                    signature: signature,
                    requestId: requestId
                }
            });
            const api = store.selectGrameneAPI();
            const url = `${api}/search?q=taxon_id:${taxon}&rows=0&facet=true&${$d365d8c287ab0c94$var$FACET_PARAMS}`;
            fetch(url).then((r)=>r.json()).then((json)=>{
                if (requestId !== $d365d8c287ab0c94$var$bgPending[taxon]) return;
                const terms = $d365d8c287ab0c94$var$parseFacets(json);
                const numFound = json && json.response && json.response.numFound || 0;
                dispatch({
                    type: 'ONTOLOGY_ENRICHMENT_BG_SUCCEEDED',
                    payload: {
                        taxon: taxon,
                        requestId: requestId,
                        terms: terms,
                        numFound: numFound
                    }
                });
                store.doEnsureOntologyEnrichmentTermRecords(taxon);
            }).catch((err)=>{
                if (requestId !== $d365d8c287ab0c94$var$bgPending[taxon]) return;
                dispatch({
                    type: 'ONTOLOGY_ENRICHMENT_BG_FAILED',
                    payload: {
                        taxon: taxon,
                        requestId: requestId,
                        error: String(err)
                    }
                });
            });
        },
    doEnsureOntologyEnrichmentTermRecords: (taxon)=>({ store: store })=>{
            const state = store.selectOntologyEnrichment();
            if (!state.byTaxon[taxon]) return;
            // The ontologies and pathways bundles bulk-load + persist on first
            // request; we just need to nudge each one once.
            const buckets = new Set();
            for (const o of $d365d8c287ab0c94$var$ONTOLOGIES)if (o.bucket) buckets.add(o.bucket);
            for (const k of buckets)store.doEnsureOntologyRecords(k);
            if (store.doRequestGramenePathways) store.doRequestGramenePathways();
        },
    reactOntologyEnrichmentFetch: (0, $gXNCa$reduxbundler.createSelector)('selectOntologyEnrichment', 'selectGrameneFiltersStatus', 'selectGrameneFiltersQueryString', 'selectGrameneViewsOn', (gs, fStatus, q, viewsOn)=>{
        if (!viewsOn || !viewsOn.has('ontologyEnrichment')) return;
        if (fStatus === 'init') return;
        const tid = gs.activeTaxon;
        if (!tid) return;
        const t = gs.byTaxon[tid];
        if (!t) return;
        const sig = $d365d8c287ab0c94$var$fgSig(q, tid);
        // A 'loading' status from a rehydrated state with no live request is
        // treated as idle — otherwise we'd deadlock waiting on a fetch that
        // ended when the previous tab closed.
        const fgInFlight = t.fg.status === 'loading' && ($d365d8c287ab0c94$var$fgPending[tid] || 0) === t.fg.requestId && t.fg.requestId > 0;
        if (t.fg.signature !== sig && !fgInFlight) return {
            actionCreator: 'doFetchOntologyEnrichmentForeground',
            args: [
                tid
            ]
        };
        const bgInFlight = t.bg.status === 'loading' && ($d365d8c287ab0c94$var$bgPending[tid] || 0) === t.bg.requestId && t.bg.requestId > 0;
        if (t.bg.status !== 'ready' && !bgInFlight) return {
            actionCreator: 'doFetchOntologyEnrichmentBackground',
            args: [
                tid
            ]
        };
    }),
    selectOntologyEnrichment: (state)=>state.ontologyEnrichment,
    selectOntologyEnrichmentUI: (state)=>state.ontologyEnrichment.ui,
    selectOntologyEnrichmentOntologyDefs: ()=>$d365d8c287ab0c94$var$ONTOLOGIES,
    selectOntologyEnrichmentResults: (0, $gXNCa$reduxbundler.createSelector)('selectOntologyEnrichment', 'selectOntologies', 'selectGramenePathways', (gs, ontoBuckets, pathwayDocs)=>{
        const tid = gs.activeTaxon;
        if (!tid) return null;
        const t = gs.byTaxon[tid];
        if (!t || !t.fg.terms || !t.bg.terms) return null;
        const ui = gs.ui;
        const out = {};
        for (const o of $d365d8c287ab0c94$var$ONTOLOGIES){
            const fg = t.fg.terms[o.key] || {};
            const bg = t.bg.terms[o.key] || {};
            const recs = o.key === 'pathways' ? pathwayDocs || {} : ontoBuckets && ontoBuckets[o.bucket] || {};
            // GO is tested per sub-ontology (BP / MF / CC) so each gets its
            // own universe size and BH correction, matching enrichGO. We can
            // only split once ontology records have arrived and namespaces are
            // known; until then, fall through to a single-section test.
            if (o.key === 'GO' && Object.keys(recs).length > 0) {
                const byNs = {
                    biological_process: {
                        fg: {},
                        bg: {}
                    },
                    molecular_function: {
                        fg: {},
                        bg: {}
                    },
                    cellular_component: {
                        fg: {},
                        bg: {}
                    }
                };
                for (const idStr of Object.keys(bg)){
                    const id = +idStr;
                    const ns = recs[id] && recs[id].namespace;
                    if (!byNs[ns]) continue;
                    byNs[ns].bg[id] = bg[id];
                    if (fg[id] != null) byNs[ns].fg[id] = fg[id];
                }
                for (const idStr of Object.keys(fg)){
                    const id = +idStr;
                    const ns = recs[id] && recs[id].namespace;
                    if (!byNs[ns]) continue;
                    if (byNs[ns].fg[id] == null) byNs[ns].fg[id] = fg[id];
                }
                for (const ns of Object.keys(byNs)){
                    const sectionKey = `GO:${ns}`;
                    const sectionLabel = `GO: ${$d365d8c287ab0c94$var$titleCase(ns)}`;
                    out[sectionKey] = $d365d8c287ab0c94$var$enrichSection(byNs[ns].fg, byNs[ns].bg, recs, ui, o.key, o.field, o.label, sectionKey, sectionLabel);
                }
            } else out[o.key] = $d365d8c287ab0c94$var$enrichSection(fg, bg, recs, ui, o.key, o.field, o.label, o.key, o.label);
        }
        return out;
    })
};
function $d365d8c287ab0c94$var$titleCase(s) {
    return String(s).split('_').map((w)=>w ? w[0].toUpperCase() + w.slice(1) : '').join(' ');
}
// One ORA section: hypergeometric over a single (N, K) universe, BH-adjusted
// across tested terms. Universe sizes come from the largest facet count in
// the section — for an ontology with a synthetic root that's the root's
// gene count (exact), and for forests it's the most populated top-level
// term (a conservative approximation).
function $d365d8c287ab0c94$var$enrichSection(fg, bg, recs, ui, ontKey, ontField, ontLabel, sectionKey, sectionLabel) {
    let N = 0, K = 0;
    for (const idStr of Object.keys(bg)){
        const v = bg[idStr];
        if (v > N) N = v;
    }
    for (const idStr of Object.keys(fg)){
        const v = fg[idStr];
        if (v > K) K = v;
    }
    const empty = {
        ontology: sectionKey,
        label: sectionLabel,
        field: ontField,
        tested: 0,
        passing: 0,
        rows: [],
        universeSize: N,
        deSize: K
    };
    if (N <= 0 || K <= 0) return empty;
    const minGS = Math.max(1, +ui.minGSSize || 1);
    const maxGS = Math.max(minGS, +ui.maxGSSize || N);
    const rows = [];
    for (const idStr of Object.keys(fg)){
        const id = +idStr;
        const count = fg[id];
        const M = bg[id] || 0;
        if (M < count) continue;
        if (M < minGS || M > maxGS) continue;
        const termRec = recs && recs[id];
        if (termRec && (termRec.is_obsolete || termRec.obsolete)) continue;
        if (count > K || M > N) continue;
        const p = $d365d8c287ab0c94$var$fisherUpperTail(count, K, M, N);
        const richFactor = M > 0 ? count / M : 0;
        const foldEnrichment = M > 0 && K > 0 ? count / K / (M / N) : 0;
        const mu = M * K / N;
        const sigma2 = N > 1 ? mu * (N - K) * (N - M) / N / (N - 1) : 0;
        const zScore = sigma2 > 0 ? (count - mu) / Math.sqrt(sigma2) : 0;
        rows.push({
            ontology: ontKey,
            ontology_label: ontLabel,
            term_id: id,
            field: ontField,
            Count: count,
            DESize: K,
            SetSize: M,
            UniverseSize: N,
            GeneRatio: `${count}/${K}`,
            BgRatio: `${M}/${N}`,
            RichFactor: richFactor,
            FoldEnrichment: foldEnrichment,
            zScore: zScore,
            pvalue: p,
            pAdjust: 1
        });
    }
    // BH adjustment across all tested terms in this section.
    rows.sort((a, b)=>a.pvalue - b.pvalue);
    const m = rows.length;
    let prev = 1;
    for(let i = m - 1; i >= 0; i--){
        const adj = Math.min(prev, rows[i].pvalue * m / (i + 1));
        rows[i].pAdjust = adj;
        prev = adj;
    }
    const passing = rows.filter((r)=>r.pAdjust <= ui.pAdjCutoff && r.pvalue <= ui.pAdjCutoff);
    let display = passing;
    if (ui.mostSpecific) display = $d365d8c287ab0c94$var$collapseToMostSpecific(ontKey, passing, recs);
    for (const r of display){
        const rec = recs && recs[r.term_id];
        if (rec) {
            r.term_name = rec.name || rec.display_name || '';
            r.term_namespace = rec.namespace || rec.type || '';
            r.term_display_id = rec.id != null ? String(rec.id) : String(r.term_id);
        } else {
            r.term_name = '';
            r.term_namespace = '';
            r.term_display_id = String(r.term_id);
        }
        r.Description = r.term_name || r.term_display_id;
    }
    display.sort((a, b)=>a.pAdjust - b.pAdjust || b.FoldEnrichment - a.FoldEnrichment);
    return {
        ontology: sectionKey,
        label: sectionLabel,
        field: ontField,
        tested: rows.length,
        passing: passing.length,
        rows: display,
        universeSize: N,
        deSize: K
    };
}
// ---------- math helpers ----------
const $d365d8c287ab0c94$var$LF_CACHE = [
    0,
    0
];
function $d365d8c287ab0c94$var$logFactorial(n) {
    if (n < $d365d8c287ab0c94$var$LF_CACHE.length) return $d365d8c287ab0c94$var$LF_CACHE[n];
    let lf = $d365d8c287ab0c94$var$LF_CACHE[$d365d8c287ab0c94$var$LF_CACHE.length - 1];
    for(let i = $d365d8c287ab0c94$var$LF_CACHE.length; i <= n; i++){
        lf += Math.log(i);
        $d365d8c287ab0c94$var$LF_CACHE.push(lf);
    }
    return $d365d8c287ab0c94$var$LF_CACHE[n];
}
function $d365d8c287ab0c94$var$logChoose(n, k) {
    if (k < 0 || k > n) return -Infinity;
    return $d365d8c287ab0c94$var$logFactorial(n) - $d365d8c287ab0c94$var$logFactorial(k) - $d365d8c287ab0c94$var$logFactorial(n - k);
}
function $d365d8c287ab0c94$var$logHypergeom(x, n, K, N) {
    return $d365d8c287ab0c94$var$logChoose(K, x) + $d365d8c287ab0c94$var$logChoose(N - K, n - x) - $d365d8c287ab0c94$var$logChoose(N, n);
}
function $d365d8c287ab0c94$var$logSumExp(a, b) {
    if (a === -Infinity) return b;
    if (b === -Infinity) return a;
    const m = Math.max(a, b);
    return m + Math.log(Math.exp(a - m) + Math.exp(b - m));
}
function $d365d8c287ab0c94$var$fisherUpperTail(k, n, K, N) {
    const upper = Math.min(n, K);
    let logP = -Infinity;
    for(let x = k; x <= upper; x++)logP = $d365d8c287ab0c94$var$logSumExp(logP, $d365d8c287ab0c94$var$logHypergeom(x, n, K, N));
    const p = Math.exp(logP);
    if (!isFinite(p)) return 1;
    return Math.min(1, Math.max(0, p));
}
// ---------- ontology graph helpers ----------
function $d365d8c287ab0c94$var$ancestorsOf(ontKey, id, recs) {
    const out = new Set();
    const rec = recs && recs[id];
    if (!rec) return out;
    if (ontKey === 'pathways') {
        for (const k of Object.keys(rec))if (k.startsWith('ancestors_') && Array.isArray(rec[k])) {
            for (const a of rec[k])if (+a !== +id) out.add(+a);
        }
        return out;
    }
    if (Array.isArray(rec.ancestors)) {
        for (const a of rec.ancestors)if (+a !== +id) out.add(+a);
        return out;
    }
    if (Array.isArray(rec.is_a)) {
        const stack = rec.is_a.slice();
        while(stack.length){
            const cur = +stack.pop();
            if (out.has(cur)) continue;
            out.add(cur);
            const r = recs[cur];
            if (r && Array.isArray(r.is_a)) for (const p of r.is_a)stack.push(p);
        }
    }
    return out;
}
// Drop any term that is an ancestor of another term in the same passing set.
// Applied AFTER BH so a parent term can survive when none of its children
// pass the p_adj cutoff.
function $d365d8c287ab0c94$var$collapseToMostSpecific(ontKey, rows, recs) {
    if (!rows || rows.length <= 1) return rows;
    const inSet = new Set(rows.map((r)=>+r.term_id));
    const covered = new Set();
    for (const r of rows){
        const ancs = $d365d8c287ab0c94$var$ancestorsOf(ontKey, +r.term_id, recs);
        for (const a of ancs)if (inSet.has(a)) covered.add(a);
    }
    return rows.filter((r)=>!covered.has(+r.term_id));
}
var $d365d8c287ab0c94$export$2e2bcd8739ae039 = $d365d8c287ab0c94$var$ontologyEnrichment;
// Per-gene UI state lifted out of <Gene> and <Homology> class components.
// Keyed by geneId so it survives unmount/remount (e.g. scrolling a row out
// of view and back), and so a snapshot serializer can later round-trip it
// for the shareable-views feature.
//
// What lives here:
//   - expandedDetail: which detail tab is open in the gene-list card
//   - fullscreen: whether the expanded detail is full-screened
//   - homology.viewer: 'treevis' | 'tbrowse'
//   - homology.tree: which of the gene's trees is shown — the homology field
//     holding it ('gene_tree', or a tree set such as 'wheat'); unset = the
//     first (gene_tree when the gene has one)
//   - homology.height: drag-resize height of the homology detail pane
//   - homology.tbrowse: the tbrowse ViewState (collapsedNodeIds, prunedNodeIds,
//     swappedNodeIds, compressedNodeIds, nodeOfInterestId, zones, zoneStates,
//     search, selectedNodeId). Tbrowse is driven in controlled mode from this.
//   - homology.tbrowseCarry: the previous tree's ViewState, held across a tree
//     switch until the new tree is seeded from its configuration (zones, zone
//     settings, row height, font size)
//   - sequences: the Sequences detail's internal state — tab ('dna'|'rna'|'pep'),
//     tid (selected transcript id), upstream/downstream (flanking bp). Driven in
//     controlled mode from this so a saved view restores the chosen sub-tab and
//     isoform.
//   - expression: the Expression detail's internal state — activeTab
//     ('gene' (EBI Studies)|'jgi'|'paralogs'|'eFP'), atlasExperiment (selected
//     GXA experiment id for Paralogs), jgiExperiment (selected JGI study id),
//     jgiAxes ({[jgiExperiment]: {rowFactor, columnFactor}}, the factor grid's
//     axes per JGI study), barStudy (selected eFP/BAR study). Driven in
//     controlled mode from this so a saved view restores the chosen sub-tab,
//     studies and grid axes.
//   - primers: the Primers detail's PrimerDesignerState (gramene-primers), a
//     serializable {v: 1, mode, transcriptId, flankUp, flankDown, region,
//     target, included, excluded, junctionSpanning, avoidRepeats, preset,
//     params, designed, selectedRank, checkedRanks, check: {checks, genomes,
//     params, jobId, submitted}, view}. Replaced wholesale on every change and
//     driven in controlled mode, so a saved view re-runs the design and
//     re-attaches to the check job. A pasted `sequence` is kept here so it
//     survives a detail-tab switch; viewSnapshot drops it from saved views.
//     Design responses and check results are never stored.
//
// What does NOT live here:
//   - derived/computed state like `details` (per-render config from
//     props.config.details + capabilities)
//   - async-fetched data caches in <Homology> (neighborhood, geneStructures)
const $7f865ea0feda21af$var$initialState = {
    byGene: {}
};
const $7f865ea0feda21af$var$ensureGene = (state, geneId)=>{
    if (state.byGene[geneId]) return state;
    return {
        ...state,
        byGene: {
            ...state.byGene,
            [geneId]: {
                homology: {}
            }
        }
    };
};
const $7f865ea0feda21af$var$setGene = (state, geneId, patch)=>{
    const next = $7f865ea0feda21af$var$ensureGene(state, geneId);
    return {
        ...next,
        byGene: {
            ...next.byGene,
            [geneId]: {
                ...next.byGene[geneId],
                ...patch
            }
        }
    };
};
const $7f865ea0feda21af$var$setHomology = (state, geneId, patch)=>{
    const next = $7f865ea0feda21af$var$ensureGene(state, geneId);
    const prev = next.byGene[geneId];
    return {
        ...next,
        byGene: {
            ...next.byGene,
            [geneId]: {
                ...prev,
                homology: {
                    ...prev.homology || {},
                    ...patch
                }
            }
        }
    };
};
const $7f865ea0feda21af$var$setSequences = (state, geneId, patch)=>{
    const next = $7f865ea0feda21af$var$ensureGene(state, geneId);
    const prev = next.byGene[geneId];
    return {
        ...next,
        byGene: {
            ...next.byGene,
            [geneId]: {
                ...prev,
                sequences: {
                    ...prev.sequences || {},
                    ...patch
                }
            }
        }
    };
};
const $7f865ea0feda21af$var$setExpression = (state, geneId, patch)=>{
    const next = $7f865ea0feda21af$var$ensureGene(state, geneId);
    const prev = next.byGene[geneId];
    return {
        ...next,
        byGene: {
            ...next.byGene,
            [geneId]: {
                ...prev,
                expression: {
                    ...prev.expression || {},
                    ...patch
                }
            }
        }
    };
};
const $7f865ea0feda21af$var$uiViewState = {
    name: 'uiViewState',
    getReducer: ()=>(state = $7f865ea0feda21af$var$initialState, { type: type, payload: payload })=>{
            switch(type){
                case 'UI_GENE_DETAIL_EXPANDED':
                    // payload: { geneId, detail }  (detail = null to collapse)
                    return $7f865ea0feda21af$var$setGene(state, payload.geneId, {
                        expandedDetail: payload.detail,
                        // collapsing also exits fullscreen
                        fullscreen: payload.detail === null ? false : state.byGene[payload.geneId]?.fullscreen || false
                    });
                case 'UI_GENE_FULLSCREEN_SET':
                    // payload: { geneId, fullscreen }
                    return $7f865ea0feda21af$var$setGene(state, payload.geneId, {
                        fullscreen: !!payload.fullscreen
                    });
                case 'UI_HOMOLOGY_VIEWER_SET':
                    // payload: { geneId, viewer }
                    return $7f865ea0feda21af$var$setHomology(state, payload.geneId, {
                        viewer: payload.viewer
                    });
                case 'UI_HOMOLOGY_TREE_SET':
                    {
                        // payload: { geneId, tree }. The tbrowse ViewState's node ids belong to
                        // one tree, so a switch drops it and Homology re-seeds the new tree
                        // pivoted on the gene, keeping the old state's configuration (carried
                        // until then; a switch before the seed keeps the earlier carry).
                        const prev = state.byGene[payload.geneId]?.homology || {};
                        return $7f865ea0feda21af$var$setHomology(state, payload.geneId, {
                            tree: payload.tree,
                            tbrowse: undefined,
                            tbrowseCarry: prev.tbrowse || prev.tbrowseCarry
                        });
                    }
                case 'UI_HOMOLOGY_HEIGHT_SET':
                    // payload: { geneId, height }
                    return $7f865ea0feda21af$var$setHomology(state, payload.geneId, {
                        height: payload.height
                    });
                case 'UI_HOMOLOGY_TBROWSE_SET':
                    // payload: { geneId, tbrowse }  -- a full ViewState object
                    return $7f865ea0feda21af$var$setHomology(state, payload.geneId, {
                        tbrowse: payload.tbrowse,
                        tbrowseCarry: undefined
                    });
                case 'UI_SEQUENCES_SET':
                    // payload: { geneId, patch }  -- merges into the sequences slice
                    // (e.g. { tab }, { tid }, { upstream }, { downstream })
                    return $7f865ea0feda21af$var$setSequences(state, payload.geneId, payload.patch);
                case 'UI_EXPRESSION_SET':
                    // payload: { geneId, patch }  -- merges into the expression slice
                    // (e.g. { activeTab }, { atlasExperiment }, { jgiExperiment },
                    // { jgiAxes } (the whole per-study map), { barStudy })
                    return $7f865ea0feda21af$var$setExpression(state, payload.geneId, payload.patch);
                case 'UI_PRIMERS_SET':
                    // payload: { geneId, state }  -- replaces the primers slice with the
                    // full PrimerDesignerState emitted by <PrimerDesigner> (not merged)
                    return $7f865ea0feda21af$var$setGene(state, payload.geneId, {
                        primers: payload.state
                    });
                case 'UI_VIEW_STATE_REPLACED':
                    // payload: { byGene }  -- used by the snapshot loader in a later phase
                    return {
                        byGene: payload.byGene || {}
                    };
                default:
                    return state;
            }
        },
    selectUiViewState: (state)=>state.uiViewState,
    doExpandGeneDetail: ({ geneId: geneId, detail: detail })=>({ dispatch: dispatch })=>{
            dispatch({
                type: 'UI_GENE_DETAIL_EXPANDED',
                payload: {
                    geneId: geneId,
                    detail: detail
                }
            });
        },
    doSetGeneFullscreen: ({ geneId: geneId, fullscreen: fullscreen })=>({ dispatch: dispatch })=>{
            dispatch({
                type: 'UI_GENE_FULLSCREEN_SET',
                payload: {
                    geneId: geneId,
                    fullscreen: fullscreen
                }
            });
        },
    doSetHomologyViewer: ({ geneId: geneId, viewer: viewer })=>({ dispatch: dispatch })=>{
            dispatch({
                type: 'UI_HOMOLOGY_VIEWER_SET',
                payload: {
                    geneId: geneId,
                    viewer: viewer
                }
            });
        },
    doSetHomologyTree: ({ geneId: geneId, tree: tree })=>({ dispatch: dispatch })=>{
            dispatch({
                type: 'UI_HOMOLOGY_TREE_SET',
                payload: {
                    geneId: geneId,
                    tree: tree
                }
            });
        },
    doSetHomologyHeight: ({ geneId: geneId, height: height })=>({ dispatch: dispatch })=>{
            dispatch({
                type: 'UI_HOMOLOGY_HEIGHT_SET',
                payload: {
                    geneId: geneId,
                    height: height
                }
            });
        },
    doSetHomologyTbrowseViewState: ({ geneId: geneId, tbrowse: tbrowse })=>({ dispatch: dispatch })=>{
            dispatch({
                type: 'UI_HOMOLOGY_TBROWSE_SET',
                payload: {
                    geneId: geneId,
                    tbrowse: tbrowse
                }
            });
        },
    doSetSequencesState: ({ geneId: geneId, patch: patch })=>({ dispatch: dispatch })=>{
            dispatch({
                type: 'UI_SEQUENCES_SET',
                payload: {
                    geneId: geneId,
                    patch: patch
                }
            });
        },
    doSetExpressionState: ({ geneId: geneId, patch: patch })=>({ dispatch: dispatch })=>{
            dispatch({
                type: 'UI_EXPRESSION_SET',
                payload: {
                    geneId: geneId,
                    patch: patch
                }
            });
        },
    doSetPrimersState: ({ geneId: geneId, state: state })=>({ dispatch: dispatch })=>{
            dispatch({
                type: 'UI_PRIMERS_SET',
                payload: {
                    geneId: geneId,
                    state: state
                }
            });
        },
    doReplaceUiViewState: (byGene)=>({ dispatch: dispatch })=>{
            dispatch({
                type: 'UI_VIEW_STATE_REPLACED',
                payload: {
                    byGene: byGene
                }
            });
        }
};
var $7f865ea0feda21af$export$2e2bcd8739ae039 = $7f865ea0feda21af$var$uiViewState;
// Redux state for the tbrowse-based Taxonomic-distribution view (taxTree).
// Holds the controlled tbrowse ViewState plus the two host controls
// (collapse-empties / compara-only), so a saved view can round-trip the user's
// tree layout, zone arrangement/sizes/names, collapses, and control choices.
//
// `viewState` is null until the view has been interacted with (or restored);
// the container falls back to its built-in default and computes initial pixel
// widths in that case.
const $6048209b532f201d$var$taxTreeView = {
    name: 'taxTreeView',
    getReducer: ()=>{
        const initialState = {
            viewState: null,
            collapseEmpties: true,
            comparaOnly: true
        };
        return (state = initialState, { type: type, payload: payload })=>{
            switch(type){
                case 'TAXTREE_VIEW_SET':
                    return {
                        ...state,
                        ...payload
                    };
                default:
                    return state;
            }
        };
    },
    doSetTaxTreeView: (patch)=>({ dispatch: dispatch })=>dispatch({
                type: 'TAXTREE_VIEW_SET',
                payload: patch
            }),
    // Re-apply persisted state from a saved-view snapshot. The tbrowse ViewState
    // is run through tbrowse-core's tolerant deserialiser so a blob saved by an
    // older viewer (missing arrays / fields added since) still restores.
    doApplyTaxTreeSnapshot: (snap)=>({ dispatch: dispatch })=>{
            if (!snap || typeof snap !== 'object') return;
            const payload = snap.viewState && typeof snap.viewState === 'object' ? {
                ...snap,
                viewState: (0, $gXNCa$tbrowsecore.normalizeViewState)(snap.viewState)
            } : snap;
            dispatch({
                type: 'TAXTREE_VIEW_SET',
                payload: payload
            });
        },
    selectTaxTreeView: (state)=>state.taxTreeView
};
var $6048209b532f201d$export$2e2bcd8739ae039 = $6048209b532f201d$var$taxTreeView;
// Serializer/deserializer for shareable gene-search views.
//
// `selectViewSnapshot` produces a versioned JSON-safe blob from the current
// store state. `doApplyViewSnapshot` validates a blob and restores it via
// existing action creators. Persistence + UI live in later phases — this
// bundle is the pure state-shape layer they build on.
//
// Snapshot schema, v1:
// {
//   v: 1,
//   capturedAt: <ISO 8601 string>,
//   site: <subsite id>,
//   filters: <grameneFilters tree, stripped of ephemeral UI flags>,
//   views: { on: [id,...], touched: {id: true, ...} },
//   genomeSubset: { taxonId: true, ... } | null,
//   searchPage: { offset: number, rows: number } | null,
//   exprViz: {                                    // Expression-visualization view
//     activeTaxon: <taxon_id|null>,
//     byTaxon: { [taxon_id]: { selectedFields: [field,...], vizMode, scale, brushes } }
//   } | undefined,                                // loaded rows re-fetch on apply
//   ontologyEnrichment: {                         // Ontology Enrichment view
//     activeTaxon: <taxon_id|null>,
//     ui: { pAdjCutoff, minGSSize, maxGSSize, mostSpecific, ontology, search, sort }
//   } | undefined,                                // facets re-fetch on apply
//   taxTree: {                                    // Taxonomic distribution (tree) view
//     collapseEmpties: bool, comparaOnly: bool,
//     viewState: <tbrowse ViewState, prunedNodeIds stripped>
//   } | undefined,                                // prune recomputed on apply
//   expandedDetails: [
//     { geneId,
//       expandedDetail: string|null,
//       fullscreen: boolean,
//       homology: { viewer, tree, height, tbrowse: <ViewState> } | undefined,
//       sequences: { tab, tid, upstream, downstream } | undefined,
//       expression: { activeTab, atlasExperiment, jgiExperiment,
//                     jgiAxes: { [jgiExperiment]: { rowFactor, columnFactor } },
//                     barStudy } | undefined,
//       primers: <gramene-primers PrimerDesignerState, {v: 1, ...}, without
//                 the pasted `sequence`> | undefined
//     }, ...
//   ]
// }
//
// Anything not in this schema is intentionally NOT persisted — async fetch
// caches, search-results, pagination cursors mid-flight, etc. all rehydrate
// from the API once the snapshot is applied.
const $472fe3745b238881$var$SCHEMA_VERSION = 1;
// Keys on a filter node we want to keep. Everything else (showMenu, marked,
// status flags from the root, etc.) is ephemeral UI and not meaningful in a
// shared view.
const $472fe3745b238881$var$FILTER_NODE_KEEP = [
    'leftIdx',
    'rightIdx',
    'operation',
    'negate',
    'expand',
    'fq_field',
    'fq_value',
    'name',
    'category',
    'warning'
];
const $472fe3745b238881$var$FILTER_ROOT_KEEP = [
    'operation',
    'negate',
    'expand',
    'leftIdx',
    'rightIdx',
    'children',
    'searchOffset',
    'rows'
];
const $472fe3745b238881$var$cleanFilterNode = (node)=>{
    const out = {};
    for (const k of $472fe3745b238881$var$FILTER_NODE_KEEP)if (node[k] !== undefined) out[k] = node[k];
    if (Array.isArray(node.children)) out.children = node.children.map($472fe3745b238881$var$cleanFilterNode);
    return out;
};
const $472fe3745b238881$var$cleanFilters = (filters)=>{
    const out = {};
    for (const k of $472fe3745b238881$var$FILTER_ROOT_KEEP)if (filters[k] !== undefined) out[k] = filters[k];
    if (Array.isArray(filters.children)) out.children = filters.children.map($472fe3745b238881$var$cleanFilterNode);
    return out;
};
// Drop bundle entries that hold no meaningful state (e.g. a row the user
// scrolled past but never opened). Otherwise snapshots bloat with empties.
const $472fe3745b238881$var$isMeaningfulGene = (entry)=>{
    if (!entry) return false;
    if (entry.expandedDetail) return true;
    if (entry.fullscreen) return true;
    if (entry.homology && (entry.homology.viewer !== undefined || entry.homology.tree !== undefined || entry.homology.height !== undefined || entry.homology.tbrowse !== undefined)) return true;
    if (entry.sequences && Object.keys(entry.sequences).length) return true;
    if (entry.expression && Object.keys(entry.expression).length) return true;
    if (entry.primers && Object.keys(entry.primers).length) return true;
    return false;
};
// The Primers slice keeps a pasted sequence in memory (so it survives a detail
// tab switch), but a saved view must not carry it: it can be long and is the
// user's own data. A restored sequence-mode design then waits for a new paste
// (gramene-primers does not re-run a design whose inputs are incomplete).
const $472fe3745b238881$var$snapshotPrimers = (primers)=>{
    if (!primers || !Object.keys(primers).length) return undefined;
    const { sequence: sequence, ...rest } = primers;
    return rest;
};
const $472fe3745b238881$var$viewSnapshot = {
    name: 'viewSnapshot',
    // No reducer — this bundle is pure derivation + dispatch orchestration.
    getReducer: ()=>(state = {})=>state,
    selectViewSnapshot: $472fe3745b238881$var$createSnapshotSelector(),
    // Apply a snapshot to the store. Returns an array of unresolved-id warnings
    // so the caller can surface a non-blocking notice. The action creators we
    // delegate to are existing ones; nothing here knows about API/UI/share-link
    // — that's later phases.
    doApplyViewSnapshot: (snapshot)=>({ dispatch: dispatch, store: store })=>{
            const warnings = $472fe3745b238881$var$validateSnapshot(snapshot);
            if (warnings.fatal) {
                console.warn('viewSnapshot: refusing to apply', warnings.fatal);
                return {
                    applied: false,
                    warnings: warnings
                };
            }
            // 1. Filters (also clears search; replays a fresh fetch).
            if (snapshot.filters) dispatch({
                type: 'BATCH_ACTIONS',
                actions: [
                    {
                        type: 'GRAMENE_SEARCH_CLEARED'
                    },
                    {
                        type: 'GRAMENE_FILTERS_REPLACED',
                        payload: $472fe3745b238881$var$cloneForDispatch(snapshot.filters)
                    }
                ]
            });
            // 2. Views.
            if (snapshot.views) dispatch({
                type: 'GRAMENE_VIEWS_REPLACED',
                payload: {
                    on: snapshot.views.on || [],
                    touched: snapshot.views.touched || {}
                }
            });
            // 3. Genome subset, if present.
            if (snapshot.genomeSubset && Object.keys(snapshot.genomeSubset).length) dispatch({
                type: 'GRAMENE_GENOMES_UPDATED',
                payload: {
                    ...snapshot.genomeSubset
                }
            });
            // 4. Per-gene UI state (expandedDetail, fullscreen, homology viewer/
            //    height, tbrowse view state). Replace wholesale via the uiViewState
            //    bundle's bulk action.
            const byGene = {};
            if (Array.isArray(snapshot.expandedDetails)) for (const e of snapshot.expandedDetails){
                if (!e || !e.geneId) continue;
                byGene[e.geneId] = {
                    expandedDetail: e.expandedDetail || null,
                    fullscreen: !!e.fullscreen,
                    homology: e.homology ? {
                        ...e.homology
                    } : {},
                    sequences: e.sequences ? {
                        ...e.sequences
                    } : {},
                    expression: e.expression ? {
                        ...e.expression
                    } : {},
                    primers: e.primers ? {
                        ...e.primers
                    } : {}
                };
            }
            dispatch({
                type: 'UI_VIEW_STATE_REPLACED',
                payload: {
                    byGene: byGene
                }
            });
            // 5. Expression-visualization view config. Delegate to the exprViz bundle,
            //    which flags each taxon for a re-fetch now that the restored filters/
            //    genomes are in place. Done last so the re-fetch sees the live query.
            if (snapshot.exprViz && store.doApplyExprVizSnapshot) store.doApplyExprVizSnapshot(snapshot.exprViz);
            // 6. Ontology Enrichment view config. Setting the active taxon lets that
            //    bundle's fetch reactor re-derive the enrichment for the restored
            //    filters/genomes.
            if (snapshot.ontologyEnrichment && store.doApplyOntologyEnrichmentSnapshot) store.doApplyOntologyEnrichmentSnapshot(snapshot.ontologyEnrichment);
            // 7. Taxonomic-distribution (tree) view state.
            if (snapshot.taxTree && store.doApplyTaxTreeSnapshot) store.doApplyTaxTreeSnapshot(snapshot.taxTree);
            return {
                applied: true,
                warnings: warnings
            };
        },
    // Helper exposed for the bootstrap path that wants to read warnings without
    // dispatching. Returns { fatal: <string|null>, unresolved: { ids/taxa/views/genes lists } }.
    doValidateViewSnapshot: (snapshot)=>()=>$472fe3745b238881$var$validateSnapshot(snapshot)
};
function $472fe3745b238881$var$createSnapshotSelector() {
    // We deliberately don't memoize with createSelector — snapshots are taken
    // on demand (Save button click, link generation) rather than on every
    // store tick, so a fresh build is fine and avoids stale-dep bugs.
    return (state)=>$472fe3745b238881$var$buildSnapshot(state);
}
function $472fe3745b238881$var$buildSnapshot(state) {
    const snap = {
        v: $472fe3745b238881$var$SCHEMA_VERSION,
        capturedAt: new Date().toISOString(),
        site: state.config && state.config.id || null
    };
    if (state.grameneFilters) {
        snap.filters = $472fe3745b238881$var$cleanFilters(state.grameneFilters);
        snap.searchPage = {
            offset: state.grameneFilters.searchOffset || 0,
            rows: state.grameneFilters.rows || 20
        };
    }
    if (state.grameneViews && Array.isArray(state.grameneViews.options)) snap.views = {
        on: state.grameneViews.options.filter((v)=>v && v.show === 'on').map((v)=>v.id),
        touched: {
            ...state.grameneViews.touched || {}
        }
    };
    if (state.grameneGenomes && state.grameneGenomes.active) {
        const keys = Object.keys(state.grameneGenomes.active);
        if (keys.length) {
            snap.genomeSubset = {};
            for (const k of keys)snap.genomeSubset[k] = true;
        } else snap.genomeSubset = null;
    }
    if (state.uiViewState && state.uiViewState.byGene) snap.expandedDetails = Object.entries(state.uiViewState.byGene).filter(([, e])=>$472fe3745b238881$var$isMeaningfulGene(e)).map(([geneId, e])=>({
            geneId: geneId,
            expandedDetail: e.expandedDetail || null,
            fullscreen: !!e.fullscreen,
            homology: e.homology && Object.keys(e.homology).length ? {
                ...e.homology
            } : undefined,
            sequences: e.sequences && Object.keys(e.sequences).length ? {
                ...e.sequences
            } : undefined,
            expression: e.expression && Object.keys(e.expression).length ? {
                ...e.expression
            } : undefined,
            primers: $472fe3745b238881$var$snapshotPrimers(e.primers)
        }));
    else snap.expandedDetails = [];
    // Expression-visualization view config. Capture only the selection/config
    // (active genome tab, per-taxon selected fields + column order, viz mode,
    // scale, brush ranges) — never the bulk fetched rows, which rehydrate via
    // the view's re-fetch on apply.
    if (state.exprViz) {
        const ev = state.exprViz;
        const byTaxon = {};
        for (const tid of Object.keys(ev.byTaxon || {})){
            const t = ev.byTaxon[tid];
            if (!t) continue;
            const selectedFields = Array.isArray(t.selectedFields) ? t.selectedFields : [];
            const brushes = t.brushes && Object.keys(t.brushes).length ? {
                ...t.brushes
            } : undefined;
            const nonDefaultMode = t.vizMode && t.vizMode !== 'heatmap';
            const nonDefaultScale = t.scale && t.scale !== 'linear';
            if (selectedFields.length || brushes || nonDefaultMode || nonDefaultScale) byTaxon[tid] = {
                selectedFields: selectedFields,
                vizMode: t.vizMode || 'heatmap',
                scale: t.scale || 'linear',
                ...brushes ? {
                    brushes: brushes
                } : {}
            };
        }
        if (ev.activeTaxon || Object.keys(byTaxon).length) snap.exprViz = {
            activeTaxon: ev.activeTaxon || null,
            byTaxon: byTaxon
        };
    }
    // Ontology Enrichment view config: active genome + the analysis knobs
    // (significance cutoff, gene-set-size bounds, most-specific, ontology
    // section, term search, per-section sort). The enrichment facets re-fetch
    // on apply, so no bulk term data is carried.
    if (state.ontologyEnrichment) {
        const oe = state.ontologyEnrichment;
        const ui = oe.ui || {};
        const DEF = {
            pAdjCutoff: 0.05,
            minGSSize: 10,
            maxGSSize: 500,
            mostSpecific: false,
            ontology: 'all',
            search: ''
        };
        const hasSort = ui.sort && Object.keys(ui.sort).length;
        const uiChanged = Object.keys(DEF).some((k)=>ui[k] !== DEF[k]) || hasSort;
        if (oe.activeTaxon || uiChanged) snap.ontologyEnrichment = {
            activeTaxon: oe.activeTaxon || null,
            ui: {
                pAdjCutoff: ui.pAdjCutoff != null ? ui.pAdjCutoff : DEF.pAdjCutoff,
                minGSSize: ui.minGSSize != null ? ui.minGSSize : DEF.minGSSize,
                maxGSSize: ui.maxGSSize != null ? ui.maxGSSize : DEF.maxGSSize,
                mostSpecific: !!ui.mostSpecific,
                ontology: ui.ontology || DEF.ontology,
                search: ui.search || DEF.search,
                ...hasSort ? {
                    sort: {
                        ...ui.sort
                    }
                } : {}
            }
        };
    }
    // Taxonomic-distribution (tree) view: the controlled tbrowse ViewState
    // (zones arrangement/sizes/names, tree layout mode, collapses, search) plus
    // the two host controls. prunedNodeIds is control-derived (recomputed on
    // apply from collapse-empties/compara + facet data), so it's stripped to
    // keep the snapshot small.
    if (state.taxTreeView) {
        const tv = state.taxTreeView;
        const hasVS = tv.viewState && typeof tv.viewState === 'object';
        if (hasVS || tv.collapseEmpties !== true || tv.comparaOnly !== true) snap.taxTree = {
            collapseEmpties: tv.collapseEmpties !== false,
            comparaOnly: tv.comparaOnly !== false,
            ...hasVS ? {
                viewState: (0, $gXNCa$tbrowsecore.stripPrunesForSnapshot)(tv.viewState)
            } : {}
        };
    }
    return snap;
}
function $472fe3745b238881$var$validateSnapshot(snapshot) {
    const warnings = {
        fatal: null,
        unresolved: {
            views: [],
            genes: [],
            taxa: []
        }
    };
    if (!snapshot || typeof snapshot !== 'object') {
        warnings.fatal = 'snapshot is not an object';
        return warnings;
    }
    if (snapshot.v !== $472fe3745b238881$var$SCHEMA_VERSION) {
        warnings.fatal = `unsupported snapshot version ${snapshot.v} (expected ${$472fe3745b238881$var$SCHEMA_VERSION})`;
        return warnings;
    }
    // Strict-id checks happen later — they need the store's grameneMaps,
    // grameneTaxonomy, etc. which are async-loaded. The boot path will call
    // doValidateViewSnapshot again after those land. For now we just
    // structurally validate.
    return warnings;
}
// JSON.parse(JSON.stringify(x)) — bundles see a wholly fresh object so
// reducers can't accidentally mutate the snapshot we're holding for retry.
function $472fe3745b238881$var$cloneForDispatch(x) {
    return JSON.parse(JSON.stringify(x));
}
var $472fe3745b238881$export$2e2bcd8739ae039 = $472fe3745b238881$var$viewSnapshot;
// Boot-time hydration of a shared view link.
//
// Entry points call `bootViewFromUrl(store)` once the store is created.
// Public views resolve anonymously. For private views, the initial call
// will 401; the Auth panel then re-invokes with `{user}` once Firebase has
// emitted its first signed-in state, and the fetch retries with a Bearer
// token. On success we apply the snapshot and strip `?view=` from the URL
// so subsequent user actions don't sit under a stale shared-state URL.
//
// All errors are non-fatal — they surface in state.savedViews.fetchError
// for any UI that wants to show them.
const $c69c61828e36a328$var$PARAM = 'view';
function $c69c61828e36a328$export$2e2bcd8739ae039(store, opts = {}) {
    if (typeof window === 'undefined') return Promise.resolve(null);
    const url = new URL(window.location.href);
    const hash = url.searchParams.get($c69c61828e36a328$var$PARAM);
    if (!hash) return Promise.resolve(null);
    const { user: user = null } = opts;
    return store.doFetchView({
        hash: hash,
        user: user
    }).then(({ snapshot: snapshot })=>{
        store.doApplyViewSnapshot(snapshot);
        url.searchParams.delete($c69c61828e36a328$var$PARAM);
        window.history.replaceState({}, '', url.toString());
        return {
            hash: hash,
            applied: true
        };
    }).catch((err)=>{
        // 401 here on the anonymous pass is expected for private views — the
        // Auth panel will retry once it has a user. Other errors (404, 5xx,
        // network) are reported and leave the param so a manual refresh can
        // retry too.
        console.warn('bootViewFromUrl:', err.message || err);
        return {
            hash: hash,
            applied: false,
            error: err.message || String(err)
        };
    });
}
// Client for the saved-views API ({api}/saved_views — see gramene-swagger
// phase 3b). Mirrors the gene_lists pattern: Firebase Bearer ID token,
// hash-based addressing, public vs private scope.
//
// Action creators all return Promises so calling UI (modal, boot path,
// list view) can await them and surface success/error inline.
//
// Dev-mode mock: set `window.__SAVED_VIEWS_MOCK__ = true` in the console
// and saves/fetches go through localStorage instead of the network. Lets us
// drive Phase 4 (UI) without waiting on Phase 3b (server). Production
// builds never touch the mock unless the flag is set at runtime, so this
// is safe to ship.
const $85a9f6732ceb79db$var$STORAGE_PREFIX = 'gramene_saved_view_mock_v1::';
const $85a9f6732ceb79db$var$initialState = {
    saving: false,
    saveError: null,
    lastSavedHash: null,
    fetching: false,
    fetchError: null,
    lastFetched: null,
    privateList: null,
    publicList: null,
    listError: null
};
const $85a9f6732ceb79db$var$savedViews = {
    name: 'savedViews',
    getReducer: ()=>(state = $85a9f6732ceb79db$var$initialState, { type: type, payload: payload })=>{
            switch(type){
                case 'SAVED_VIEW_SAVE_STARTED':
                    return {
                        ...state,
                        saving: true,
                        saveError: null
                    };
                case 'SAVED_VIEW_SAVE_SUCCEEDED':
                    return {
                        ...state,
                        saving: false,
                        lastSavedHash: payload.hash
                    };
                case 'SAVED_VIEW_SAVE_FAILED':
                    return {
                        ...state,
                        saving: false,
                        saveError: payload.error
                    };
                case 'SAVED_VIEW_FETCH_STARTED':
                    return {
                        ...state,
                        fetching: true,
                        fetchError: null
                    };
                case 'SAVED_VIEW_FETCH_SUCCEEDED':
                    return {
                        ...state,
                        fetching: false,
                        lastFetched: payload
                    };
                case 'SAVED_VIEW_FETCH_FAILED':
                    return {
                        ...state,
                        fetching: false,
                        fetchError: payload.error
                    };
                case 'SAVED_VIEW_LIST_RECEIVED':
                    return {
                        ...state,
                        [payload.kind === 'public' ? 'publicList' : 'privateList']: payload.rows,
                        listError: null
                    };
                case 'SAVED_VIEW_LIST_FAILED':
                    return {
                        ...state,
                        listError: payload.error
                    };
                case 'SAVED_VIEW_RESET':
                    return {
                        ...$85a9f6732ceb79db$var$initialState
                    };
                default:
                    return state;
            }
        },
    selectSavedViews: (state)=>state.savedViews,
    // POST a snapshot. Returns Promise<{hash, shareUrl}> on success.
    // `user` is a Firebase user object (must respond to .getIdToken()).
    doSaveView: ({ user: user, label: label, description: description, isPublic: isPublic })=>async ({ dispatch: dispatch, store: store })=>{
            dispatch({
                type: 'SAVED_VIEW_SAVE_STARTED'
            });
            try {
                const snapshot = store.selectViewSnapshot();
                const hash = await $85a9f6732ceb79db$var$computeContentHash(snapshot);
                const site = store.selectConfiguration && store.selectConfiguration().id || '';
                const token = user && user.getIdToken ? await user.getIdToken() : null;
                if (!token) throw new Error('Not signed in');
                const meta = {
                    hash: hash,
                    label: label,
                    site: site,
                    isPublic: !!isPublic,
                    description: description || ''
                };
                if ($85a9f6732ceb79db$var$useMock()) $85a9f6732ceb79db$var$mockSave({
                    ...meta,
                    state: snapshot,
                    uid: user.uid || 'mock',
                    createdAt: new Date().toISOString()
                });
                else {
                    const api = store.selectGrameneAPI();
                    const res = await fetch(`${api}/saved_views`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${token}`
                        },
                        body: JSON.stringify({
                            ...meta,
                            state: snapshot
                        })
                    });
                    if (!res.ok) throw $85a9f6732ceb79db$var$savedViewsError('Save', res.status);
                }
                const shareUrl = $85a9f6732ceb79db$var$buildShareUrl(hash);
                dispatch({
                    type: 'SAVED_VIEW_SAVE_SUCCEEDED',
                    payload: {
                        hash: hash
                    }
                });
                return {
                    hash: hash,
                    shareUrl: shareUrl
                };
            } catch (err) {
                dispatch({
                    type: 'SAVED_VIEW_SAVE_FAILED',
                    payload: {
                        error: err.message || String(err)
                    }
                });
                throw err;
            }
        },
    // GET a snapshot by share hash. Anonymous-OK for public views; token is
    // optional and only sent if the caller provides a user.
    // Returns Promise<{snapshot, meta}>.
    doFetchView: ({ hash: hash, user: user })=>async ({ dispatch: dispatch, store: store })=>{
            dispatch({
                type: 'SAVED_VIEW_FETCH_STARTED'
            });
            try {
                let row;
                if ($85a9f6732ceb79db$var$useMock()) {
                    row = $85a9f6732ceb79db$var$mockFetch(hash);
                    if (!row) throw new Error(`No saved view with hash ${hash}`);
                } else {
                    const api = store.selectGrameneAPI();
                    const headers = {
                        Accept: 'application/json'
                    };
                    if (user && user.getIdToken) try {
                        headers.Authorization = `Bearer ${await user.getIdToken()}`;
                    } catch (_) {}
                    const res = await fetch(`${api}/saved_views?hash=${encodeURIComponent(hash)}`, {
                        headers: headers
                    });
                    if (res.status === 401) throw new Error('Sign in to load this private view.');
                    if (res.status === 404) throw new Error('Saved view not found (it may have been deleted).');
                    if (!res.ok) throw $85a9f6732ceb79db$var$savedViewsError('Fetch', res.status);
                    row = await res.json();
                }
                const out = {
                    hash: hash,
                    snapshot: row.state,
                    meta: {
                        label: row.label,
                        description: row.description || '',
                        site: row.site,
                        isPublic: !!row.isPublic,
                        owner: row.owner || null,
                        createdAt: row.createdAt || null
                    }
                };
                dispatch({
                    type: 'SAVED_VIEW_FETCH_SUCCEEDED',
                    payload: out
                });
                return out;
            } catch (err) {
                dispatch({
                    type: 'SAVED_VIEW_FETCH_FAILED',
                    payload: {
                        error: err.message || String(err)
                    }
                });
                throw err;
            }
        },
    // List views for the current site. `scope` is 'public' (anonymous-OK)
    // or 'private' (requires `user`).
    doListSavedViews: ({ scope: scope, user: user })=>async ({ dispatch: dispatch, store: store })=>{
            try {
                const site = store.selectConfiguration && store.selectConfiguration().id || '';
                let rows;
                if ($85a9f6732ceb79db$var$useMock()) rows = $85a9f6732ceb79db$var$mockList({
                    site: site,
                    scope: scope,
                    uid: user && user.uid
                });
                else {
                    const api = store.selectGrameneAPI();
                    const headers = {
                        Accept: 'application/json'
                    };
                    if (scope === 'private') {
                        if (!user || !user.getIdToken) throw new Error('Not signed in');
                        headers.Authorization = `Bearer ${await user.getIdToken()}`;
                    }
                    const url = `${api}/saved_views?site=${encodeURIComponent(site)}&isPublic=${scope === 'public'}`;
                    const res = await fetch(url, {
                        headers: headers
                    });
                    if (!res.ok) throw $85a9f6732ceb79db$var$savedViewsError('List', res.status);
                    rows = await res.json();
                }
                dispatch({
                    type: 'SAVED_VIEW_LIST_RECEIVED',
                    payload: {
                        kind: scope,
                        rows: rows
                    }
                });
                return rows;
            } catch (err) {
                dispatch({
                    type: 'SAVED_VIEW_LIST_FAILED',
                    payload: {
                        error: err.message || String(err)
                    }
                });
                throw err;
            }
        },
    // PATCH label / isPublic on a view I own. Mirrors updateList.
    doUpdateSavedView: ({ viewId: viewId, user: user, label: label, isPublic: isPublic })=>async ({ store: store })=>{
            const updates = {};
            if (typeof label === 'string') updates.label = label;
            if (typeof isPublic === 'boolean') updates.isPublic = isPublic;
            if (!Object.keys(updates).length) return;
            if ($85a9f6732ceb79db$var$useMock()) {
                $85a9f6732ceb79db$var$mockUpdate(viewId, updates);
                return {
                    viewId: viewId,
                    updates: updates
                };
            }
            const token = await user.getIdToken();
            const api = store.selectGrameneAPI();
            const res = await fetch(`${api}/saved_views?viewId=${encodeURIComponent(viewId)}`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify(updates)
            });
            if (!res.ok) throw $85a9f6732ceb79db$var$savedViewsError('Update', res.status);
            return res.json();
        },
    // DELETE one of my saved views. Mirrors deleteList.
    doDeleteSavedView: ({ viewId: viewId, user: user })=>async ({ store: store })=>{
            if ($85a9f6732ceb79db$var$useMock()) {
                $85a9f6732ceb79db$var$mockDelete(viewId);
                return {
                    viewId: viewId
                };
            }
            const token = await user.getIdToken();
            const api = store.selectGrameneAPI();
            const res = await fetch(`${api}/saved_views?viewId=${encodeURIComponent(viewId)}`, {
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (!res.ok) throw $85a9f6732ceb79db$var$savedViewsError('Delete', res.status);
            return res.json();
        },
    doResetSavedViewState: ()=>({ dispatch: dispatch })=>dispatch({
                type: 'SAVED_VIEW_RESET'
            }),
    // Connect-friendly wrapper around bootViewFromUrl. Auth.js calls this on
    // each auth-state emission, passing the current Firebase user (or null);
    // bootView.js no-ops when ?view= isn't in the URL, so this is cheap to
    // call repeatedly.
    doBootSharedView: ({ user: user } = {})=>({ store: store })=>{
            return $c69c61828e36a328$export$2e2bcd8739ae039(store, {
                user: user
            });
        }
};
// ── helpers ─────────────────────────────────────────────────────────────
// A 405 on any saved_views call means the API route isn't deployed on this
// backend — the request falls through to the read-only /{collection} handler.
// Surface that as a clear, non-alarming message rather than a raw status code.
function $85a9f6732ceb79db$var$savedViewsError(action, status) {
    if (status === 405) return new Error('Saved views are not available on this server yet.');
    return new Error(`${action} failed (${status})`);
}
// Test/dev: either set the runtime-only flag (`window.__SAVED_VIEWS_MOCK__ = true`,
// cleared on reload), or persist via localStorage (`localStorage.setItem(
// '__SAVED_VIEWS_MOCK__', 'true')`, survives reloads — needed for the
// share-link round-trip which navigates).
function $85a9f6732ceb79db$var$useMock() {
    if (typeof window === 'undefined') return false;
    if (window.__SAVED_VIEWS_MOCK__) return true;
    try {
        return typeof localStorage !== 'undefined' && localStorage.getItem('__SAVED_VIEWS_MOCK__') === 'true';
    } catch (_) {
        return false;
    }
}
function $85a9f6732ceb79db$var$buildShareUrl(hash) {
    if (typeof window === 'undefined') return `?view=${hash}`;
    const u = new URL(window.location.href);
    u.search = '';
    u.searchParams.set('view', hash);
    return u.toString();
}
// Content-addressable, ~72-bit short hash. The snapshot's `capturedAt` is
// excluded from the hash input so two saves of the same view by the same
// user produce the same hash (and the server's $setOnInsert preserves the
// original createdAt).
async function $85a9f6732ceb79db$var$computeContentHash(snapshot) {
    const forHash = {
        ...snapshot,
        capturedAt: undefined
    };
    const text = $85a9f6732ceb79db$var$canonicalize(forHash);
    if (typeof crypto !== 'undefined' && crypto.subtle) {
        const buf = new TextEncoder().encode(text);
        const digest = await crypto.subtle.digest('SHA-256', buf);
        const bytes = new Uint8Array(digest);
        let b64 = '';
        for(let i = 0; i < bytes.length; i++)b64 += String.fromCharCode(bytes[i]);
        return btoa(b64).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '').slice(0, 12);
    }
    // Last-resort fallback for environments without WebCrypto.
    let h = 0;
    for(let i = 0; i < text.length; i++)h = (h << 5) - h + text.charCodeAt(i) | 0;
    return ('h' + (h >>> 0).toString(36)).slice(0, 12);
}
// Stable stringify: sort object keys recursively so semantically-equivalent
// snapshots hash identically.
function $85a9f6732ceb79db$var$canonicalize(v) {
    if (v === null || typeof v !== 'object') return JSON.stringify(v);
    if (Array.isArray(v)) return '[' + v.map($85a9f6732ceb79db$var$canonicalize).join(',') + ']';
    const keys = Object.keys(v).filter((k)=>v[k] !== undefined).sort();
    return '{' + keys.map((k)=>JSON.stringify(k) + ':' + $85a9f6732ceb79db$var$canonicalize(v[k])).join(',') + '}';
}
// ── mock backend (localStorage) ─────────────────────────────────────────
function $85a9f6732ceb79db$var$mockSave(row) {
    if (typeof localStorage === 'undefined') return;
    localStorage.setItem($85a9f6732ceb79db$var$STORAGE_PREFIX + row.hash, JSON.stringify({
        ...row,
        _id: row.hash + ' ' + row.uid
    }));
}
function $85a9f6732ceb79db$var$mockFetch(hash) {
    if (typeof localStorage === 'undefined') return null;
    const raw = localStorage.getItem($85a9f6732ceb79db$var$STORAGE_PREFIX + hash);
    return raw ? JSON.parse(raw) : null;
}
function $85a9f6732ceb79db$var$mockList({ site: site, scope: scope, uid: uid }) {
    if (typeof localStorage === 'undefined') return [];
    const out = [];
    for(let i = 0; i < localStorage.length; i++){
        const k = localStorage.key(i);
        if (!k || !k.startsWith($85a9f6732ceb79db$var$STORAGE_PREFIX)) continue;
        const row = JSON.parse(localStorage.getItem(k));
        if (row.site !== site) continue;
        if (scope === 'public' && !row.isPublic) continue;
        if (scope === 'private' && (row.isPublic || row.uid !== uid)) continue;
        out.push(row);
    }
    return out.sort((a, b)=>(b.createdAt || '').localeCompare(a.createdAt || ''));
}
function $85a9f6732ceb79db$var$mockUpdate(viewId, updates) {
    if (typeof localStorage === 'undefined') return;
    for(let i = 0; i < localStorage.length; i++){
        const k = localStorage.key(i);
        if (!k || !k.startsWith($85a9f6732ceb79db$var$STORAGE_PREFIX)) continue;
        const row = JSON.parse(localStorage.getItem(k));
        if (row._id === viewId) {
            localStorage.setItem(k, JSON.stringify({
                ...row,
                ...updates
            }));
            return;
        }
    }
}
function $85a9f6732ceb79db$var$mockDelete(viewId) {
    if (typeof localStorage === 'undefined') return;
    for(let i = 0; i < localStorage.length; i++){
        const k = localStorage.key(i);
        if (!k || !k.startsWith($85a9f6732ceb79db$var$STORAGE_PREFIX)) continue;
        const row = JSON.parse(localStorage.getItem(k));
        if (row._id === viewId) {
            localStorage.removeItem(k);
            return;
        }
    }
}
var $85a9f6732ceb79db$export$2e2bcd8739ae039 = $85a9f6732ceb79db$var$savedViews;
var $5df6c55c1bef3469$export$2e2bcd8739ae039 = [
    ...$9d9aeaf9299e61a1$export$2e2bcd8739ae039,
    $671312b287158a8a$export$2e2bcd8739ae039,
    $af4441dd29af05df$export$2e2bcd8739ae039,
    $24971af0a229e0e3$export$2e2bcd8739ae039,
    $0d54502f6cafe273$export$2e2bcd8739ae039,
    $0f839422d0d8c772$export$2e2bcd8739ae039,
    $1508f5a42be6e7b5$export$2e2bcd8739ae039,
    $c921a0d2b34aadb6$export$2e2bcd8739ae039,
    $4f15cd8a7d970b18$export$2e2bcd8739ae039,
    $12feb7ca48271e17$export$2e2bcd8739ae039,
    $6c52be7952d5ec43$export$2e2bcd8739ae039,
    $d365d8c287ab0c94$export$2e2bcd8739ae039,
    $7f865ea0feda21af$export$2e2bcd8739ae039,
    $6048209b532f201d$export$2e2bcd8739ae039,
    $472fe3745b238881$export$2e2bcd8739ae039,
    $85a9f6732ceb79db$export$2e2bcd8739ae039
];
const $2fec4872fbf7ebd2$var$Gene = ({ gene: gene })=>{
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "row",
        children: gene.id
    });
};
const $2fec4872fbf7ebd2$var$Genes = (results, rows, doChangeQuantity)=>{
    if (results && results.numFound > 0) {
        const moreButton = results.numFound > rows ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
            onClick: (e)=>doChangeQuantity('Genes', 20),
            children: "more"
        }) : '';
        const fewerButton = rows > 20 ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
            onClick: (e)=>doChangeQuantity('Genes', -20),
            children: "fewer"
        }) : '';
        const docsToShow = results.response.docs.slice(0, rows);
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
            id: "Genes",
            className: "container mb40 anchor",
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                    className: "fancy-title mb40",
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h4", {
                        children: "Genes"
                    })
                }),
                docsToShow.map((doc, idx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($2fec4872fbf7ebd2$var$Gene, {
                        gene: doc
                    }, idx)),
                fewerButton,
                moreButton
            ]
        });
    }
};
const $2fec4872fbf7ebd2$var$Pathway = ({ pathway: pathway })=>{
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "row",
        children: pathway.name
    });
};
const $2fec4872fbf7ebd2$var$Pathways = (results)=>{
    if (results && results.numFound > 0) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        id: "Pathways",
        className: "container mb40 anchor",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "fancy-title",
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h4", {
                    children: "Pathways"
                })
            }),
            results.pathways.map((doc, idx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($2fec4872fbf7ebd2$var$Pathway, {
                    pathway: doc
                }, idx))
        ]
    });
};
const $2fec4872fbf7ebd2$var$Domain = ({ domain: domain })=>{
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "row",
        children: domain.id
    });
};
const $2fec4872fbf7ebd2$var$Domains = (results)=>{
    if (results && results.numFound > 0) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        id: "Domains",
        className: "container mb40 anchor",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "fancy-title mb40",
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h4", {
                    children: "Domains"
                })
            }),
            results.domains.map((doc, idx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($2fec4872fbf7ebd2$var$Domain, {
                    domain: doc
                }, idx))
        ]
    });
};
const $2fec4872fbf7ebd2$var$Taxon = ({ taxon: taxon })=>{
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "row",
        children: taxon.id
    });
};
const $2fec4872fbf7ebd2$var$Species = (results)=>{
    if (results && results.numFound > 0) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        id: "Species",
        className: "container mb40 anchor",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "fancy-title mb40",
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h4", {
                    children: "Species"
                })
            }),
            results.taxonomy.map((doc, idx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($2fec4872fbf7ebd2$var$Taxon, {
                    taxon: doc
                }, idx))
        ]
    });
};
const $2fec4872fbf7ebd2$var$ResultList = ({ grameneGenes: grameneGenes, grameneDomains: grameneDomains, gramenePathways: gramenePathways, grameneTaxonomy: grameneTaxonomy, searchUI: searchUI, searchUpdated: searchUpdated, doChangeQuantity: doChangeQuantity })=>{
    if (searchUI.Gramene) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        id: "gramene",
        className: "row",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "fancy-title pt50",
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h3", {
                    children: "Gramene search results"
                })
            }),
            searchUI.Genes && $2fec4872fbf7ebd2$var$Genes(grameneGenes, searchUI.rows.Genes, doChangeQuantity),
            searchUI.Domains && $2fec4872fbf7ebd2$var$Domains(grameneDomains),
            searchUI.Pathways && $2fec4872fbf7ebd2$var$Pathways(gramenePathways),
            searchUI.Species && $2fec4872fbf7ebd2$var$Species(grameneTaxonomy)
        ]
    });
    else return null;
};
var $2fec4872fbf7ebd2$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)('selectGrameneGenes', 'selectGrameneDomains', 'selectGramenePathways', 'selectGrameneTaxonomy', 'selectSearchUI', 'selectSearchUpdated', 'doChangeQuantity', $2fec4872fbf7ebd2$var$ResultList);
const $27617dbc24e7faf0$var$getStatus = (cat, results, isChecked, toggle)=>{
    const tally = results ? results.numFound : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("img", {
        src: "/static/images/dna_spinner.svg"
    });
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("li", {
        className: "category-leaf",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
                type: "checkbox",
                checked: isChecked,
                onChange: (e)=>toggle(cat)
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("a", {
                "data-scroll": true,
                href: `#${cat}`,
                className: "nav-link active",
                children: [
                    cat,
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        style: {
                            float: "right"
                        },
                        children: tally
                    })
                ]
            })
        ]
    });
};
const $27617dbc24e7faf0$var$ResultSummary = ({ grameneGenes: grameneGenes, gramenePathways: gramenePathways, grameneDomains: grameneDomains, grameneTaxonomy: grameneTaxonomy, searchUI: searchUI, searchUpdated: searchUpdated, doToggleCategory: doToggleCategory })=>{
    const status = grameneGenes ? grameneGenes.numFound : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("img", {
        src: "/static/images/dna_spinner.svg"
    });
    if (searchUI.Gramene) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("li", {
        className: "active category-expanded",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("a", {
                onClick: (e)=>doToggleCategory('Gramene'),
                children: [
                    "Gramene Search",
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        style: {
                            float: "right"
                        },
                        children: status
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("ul", {
                className: "list-unstyled",
                children: [
                    $27617dbc24e7faf0$var$getStatus('Genes', grameneGenes, searchUI.Genes, doToggleCategory),
                    $27617dbc24e7faf0$var$getStatus('Domains', grameneDomains, searchUI.Domains, doToggleCategory),
                    $27617dbc24e7faf0$var$getStatus('Pathways', gramenePathways, searchUI.Pathways, doToggleCategory),
                    $27617dbc24e7faf0$var$getStatus('Species', grameneTaxonomy, searchUI.Species, doToggleCategory)
                ]
            })
        ]
    });
    else return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("li", {
        className: "active category-collapsed",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("a", {
            onClick: (e)=>doToggleCategory('Gramene'),
            children: [
                "Gramene Search",
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    style: {
                        float: "right"
                    },
                    children: status
                })
            ]
        })
    });
};
var $27617dbc24e7faf0$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)('selectGrameneGenes', 'selectGramenePathways', 'selectGrameneDomains', 'selectGrameneTaxonomy', 'selectSearchUI', 'selectSearchUpdated', 'doToggleCategory', $27617dbc24e7faf0$var$ResultSummary);
function $541b8b0d8c5501d2$var$showMatches(text, x) {
    let re = new RegExp(`(${x})`, 'ig');
    let match = text.split(re);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
        children: match.map((str, idx)=>{
            if (idx % 2 === 1) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                style: {
                    fontWeight: 'bolder'
                },
                children: str
            }, idx);
            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                children: str
            }, idx);
        })
    });
}
function $541b8b0d8c5501d2$var$logAction(sugg) {
    $parcel$interopDefault($gXNCa$reactga4).event({
        category: 'Search',
        action: 'SetFilter',
        label: sugg.name
    });
}
// The species label under a suggestion. Returns '' rather than throwing when the
// taxonomy can't explain a taxon: this runs during render, so anything thrown here
// takes down the whole suggestions panel and the search box looks broken.
//
// That is not hypothetical. `grameneTaxonomy` is persisted with a 24h staleAfter, so
// after a data release adds genomes — v11 added 4558118/4558119/4558120 — every
// browser still holding the previous release's taxonomy has suggestions referencing
// taxa it has never heard of. Broad queries ("kinase", "sb") hit all three.
function $541b8b0d8c5501d2$var$getLowestCommonAncestorName(tids, taxonomy) {
    if (!Array.isArray(tids) || !taxonomy) return '';
    let lca;
    tids.forEach((tid)=>{
        const node = taxonomy[tid];
        if (!node || !Array.isArray(node.ancestors)) return; // unknown taxon: ignore it
        if (!lca) lca = [
            ...node.ancestors
        ];
        else {
            let ancestors = new Set(node.ancestors);
            // `lca.length &&` matters: with no ancestor in common this shifted an empty
            // array forever, since ancestors.has(undefined) is never true.
            while(lca.length && !ancestors.has(lca[0]))lca.shift();
        }
    });
    if (!lca || !lca.length) return '';
    const root = taxonomy[lca[0]];
    return root ? root.short_name : '';
}
const $541b8b0d8c5501d2$var$TryPan = (props)=>{
    const query = props.query;
    const pan = props.pan;
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "suggestion-panlink",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("a", {
            target: "_blank",
            href: pan.url + "?suggestion=" + query,
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("img", {
                src: pan.svg,
                title: `Search at ${pan.name}`
            })
        })
    });
};
const $541b8b0d8c5501d2$var$TryAnotherSite = (props)=>{
    const query = props.query;
    const config = props.config;
    let sites = Object.keys(config.panSite);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Alert, {
                variant: 'info',
                children: [
                    "Don't see what you're looking for? Search for ",
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                        children: query
                    }),
                    " on one of our sister sites"
                ]
            }),
            sites.map((p, idx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($541b8b0d8c5501d2$var$TryPan, {
                    query: query,
                    pan: config.panSite[p]
                }, idx))
        ]
    });
};
const $541b8b0d8c5501d2$var$Suggestions = (props)=>{
    let suggestions = props.grameneSuggestions;
    if (suggestions && suggestions.grouped) {
        if (suggestions.grouped.category.matches === 0) {
            let sugg1 = {
                fq_field: 'text',
                fq_value: props.suggestionsQuery,
                name: `Genes containing "${props.suggestionsQuery}"`,
                category: 'Gene'
            };
            let sugg2 = {
                fq_field: 'text',
                fq_value: `${props.suggestionsQuery}*`,
                name: `Genes matching "${props.suggestionsQuery}*"`,
                category: 'Gene'
            };
            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                style: {
                    margin: '10px',
                    maxWidth: '820px'
                },
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Alert, {
                        variant: 'info',
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("em", {
                                children: "No suggestions found."
                            }),
                            " You may still attempt a full text search, though it is unlikely to find any genes for you."
                        ]
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                        id: 'word',
                        size: 'sm',
                        variant: 'outline-secondary',
                        onClick: ()=>{
                            $541b8b0d8c5501d2$var$logAction(sugg1);
                            props.doAcceptSuggestion(sugg1);
                            props.doAcceptGrameneSuggestion(sugg1);
                        },
                        children: `All genes that contain the word "${props.suggestionsQuery}"`
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                        id: 'word',
                        size: 'sm',
                        variant: 'outline-secondary',
                        onClick: ()=>{
                            $541b8b0d8c5501d2$var$logAction(sugg2);
                            props.doAcceptSuggestion(sugg2);
                            props.doAcceptGrameneSuggestion(sugg2);
                        },
                        children: `All genes that contain a word that starts with "${props.suggestionsQuery}"`
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($541b8b0d8c5501d2$var$TryAnotherSite, {
                        query: props.suggestionsQuery,
                        config: props.configuration
                    })
                ]
            });
        } else return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
            style: {
                margin: '10px'
            },
            children: [
                suggestions.grouped.category.groups.map((g, idx)=>{
                    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                        id: "gramene-suggestion",
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h4", {
                                className: "mt10",
                                children: g.groupValue
                            }),
                            g.doclist.docs.map((sugg, jdx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Button, {
                                    id: `${idx}-${jdx}`,
                                    disabled: sugg.num_genes === 0,
                                    size: "sm",
                                    variant: "outline-secondary",
                                    onClick: ()=>{
                                        $541b8b0d8c5501d2$var$logAction(sugg);
                                        props.doAcceptSuggestion(sugg);
                                        props.doAcceptGrameneSuggestion(sugg);
                                    },
                                    children: [
                                        $541b8b0d8c5501d2$var$showMatches(sugg.display_name, props.suggestionsQuery),
                                        ' ',
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Badge, {
                                            bg: "secondary",
                                            children: sugg.num_genes
                                        }),
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("i", {
                                            children: [
                                                "\xa0",
                                                $541b8b0d8c5501d2$var$getLowestCommonAncestorName(sugg.taxon_id, props.grameneTaxonomy)
                                            ]
                                        })
                                    ]
                                }, jdx))
                        ]
                    }, idx);
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($541b8b0d8c5501d2$var$TryAnotherSite, {
                    query: props.suggestionsQuery,
                    config: props.configuration
                })
            ]
        });
    } else return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {});
};
var $541b8b0d8c5501d2$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)('selectGrameneSuggestions', 'selectSuggestionsQuery', 'selectGrameneTaxonomy', 'selectConfiguration', 'doAcceptSuggestion', 'doAcceptGrameneSuggestion', $541b8b0d8c5501d2$var$Suggestions);
// eFP Browser embed — was its own package (gramene-efp-browser@1.0.11),
// absorbed here on 2026-05-29 to drop the unmaintained nwb/webpack-4 build
// pipeline and remove a dependency that needed --openssl-legacy-provider.
// All upstream URLs and species-specific id formatters preserved as-is.
const $59a241f3912e631e$var$urls = {
    image: (genome, study, gene)=>`https://bar.utoronto.ca/api/efp_image/efp_${genome}/${study}/Absolute/${gene}`,
    app: (genome, study, gene)=>`https://bar.utoronto.ca/efp_${genome}/cgi-bin/efpWeb.cgi?dataSource=${study}&mode=Absolute&primaryGene=${gene}`,
    studies: (genome)=>`https://bar.utoronto.ca/api/efp_image/get_efp_data_source/${genome}`,
    logo: 'https://bar.utoronto.ca/bbc_logo_small.gif',
    spinner: 'https://www.sorghumbase.org/static/images/dna_spinner.svg'
};
const $59a241f3912e631e$var$zmv4_re = /Zm00001d/;
const $59a241f3912e631e$var$browsers = {
    sorghum_bicolor: {
        formatGene: (gene)=>gene._id.replace('SORBI_3', 'Sobic.'),
        genome: 'sorghum'
    },
    vitis_vinifera: {
        formatGene: (gene)=>gene._id,
        genome: 'grape'
    },
    arabidopsis_thaliana: {
        formatGene: (gene)=>gene._id,
        fixStudies: (studies)=>{
            studies = studies.filter((s)=>s.value !== 'Klepikova_Atlas');
            studies.unshift({
                value: 'Klepikova_Atlas',
                label: 'Klepikova Atlas'
            });
            return studies;
        },
        genome: 'arabidopsis'
    },
    zea_mays: {
        formatGene: (gene)=>{
            let id = gene._id;
            if (gene.synonyms) gene.synonyms.forEach((syn)=>{
                if ($59a241f3912e631e$var$zmv4_re.test(syn)) id = syn;
            });
            return id;
        },
        fixStudies: (studies)=>{
            studies = studies.filter((s)=>s.value !== 'Hoopes_et_al_Atlas' && s.value !== 'Hoopes_et_al_Stress');
            studies.unshift({
                value: 'Hoopes_et_al_Stress',
                label: 'Hoopes et. al., Stress'
            });
            studies.unshift({
                value: 'Hoopes_et_al_Atlas',
                label: 'Hoopes et. al., Atlas'
            });
            return studies;
        },
        genome: 'maize'
    },
    glycine_max: {
        formatGene: (gene)=>gene._id.replace('GLYMA_', 'Glyma.'),
        fixStudies: (studies)=>studies.filter((s)=>s.value !== 'soybean_senescence'),
        genome: 'soybean'
    },
    oryza_sativa: {
        genome: 'rice',
        formatGene: (gene)=>gene.MSU_id,
        fixStudies: (studies)=>{
            studies = studies.filter((s)=>s.value !== 'rice_rma' && s.value !== 'rice_mas');
            studies.unshift({
                value: 'rice_rma',
                label: 'rice rma'
            });
            studies.unshift({
                value: 'rice_mas',
                label: 'rice mas'
            });
            return studies;
        }
    }
};
// Subsites that refer to maize b73 as `zea_maysb73`.
$59a241f3912e631e$var$browsers.zea_maysb73 = $59a241f3912e631e$var$browsers.zea_mays;
const $59a241f3912e631e$var$ImageLoader = ({ url: url })=>{
    const [loading, setLoading] = (0, $gXNCa$react.useState)(true);
    const [error, setError] = (0, $gXNCa$react.useState)(false);
    (0, $gXNCa$react.useEffect)(()=>{
        setLoading(true);
        setError(false);
        const image = new Image();
        image.src = url;
        image.onload = ()=>setLoading(false);
        image.onerror = ()=>{
            setLoading(false);
            setError(true);
        };
    }, [
        url
    ]);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        style: {
            padding: 20
        },
        children: [
            loading && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("img", {
                src: $59a241f3912e631e$var$urls.spinner,
                alt: "Loading\u2026"
            }),
            !loading && !error && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("img", {
                style: {
                    maxWidth: '100%'
                },
                src: url,
                alt: "eFP browser output"
            }),
            error && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("p", {
                children: "Error: Failed to load image"
            })
        ]
    });
};
class $59a241f3912e631e$export$2e2bcd8739ae039 extends $gXNCa$react.Component {
    constructor(props){
        super(props);
        this.state = {
            currentStudy: null
        };
    }
    getStudies(browser) {
        fetch($59a241f3912e631e$var$urls.studies(browser.genome)).then((res)=>res.json()).then((res)=>{
            if (res.wasSuccessful) {
                let studies = res.data.sort().map((v)=>({
                        value: v,
                        label: v.replace(/_/g, ' ')
                    }));
                if (browser.fixStudies) studies = browser.fixStudies(studies);
                this.setState({
                    studies: studies
                });
            }
        }).catch(console.error);
    }
    render() {
        const gene = this.props.gene;
        const browser = $59a241f3912e631e$var$browsers[gene.system_name];
        if (!browser) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("h2", {
                children: [
                    "Can't find eFP browser for ",
                    gene.system_name
                ]
            })
        });
        if (!this.state.studies) {
            this.getStudies(browser);
            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("img", {
                src: $59a241f3912e631e$var$urls.spinner,
                alt: "Loading\u2026"
            });
        }
        const efp_gene = browser.formatGene(gene);
        // `study`/`onStudyChange` let a host drive the selection (so a saved view
        // can restore it); fall back to local state when uncontrolled.
        const study = this.props.study || this.state.currentStudy || this.state.studies[0].value;
        const onSelect = (e)=>{
            if (this.props.onStudyChange) this.props.onStudyChange(e.target.value);
            else this.setState({
                currentStudy: e.target.value
            });
        };
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
            style: {
                paddingTop: 10
            },
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("label", {
                    style: {
                        paddingLeft: 20,
                        paddingRight: 10
                    },
                    children: "Select a study:"
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("select", {
                    value: study,
                    onChange: onSelect,
                    children: this.state.studies.map((s, idx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("option", {
                            value: s.value,
                            children: s.label
                        }, idx))
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("br", {}),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($59a241f3912e631e$var$ImageLoader, {
                    url: $59a241f3912e631e$var$urls.image(browser.genome, study, efp_gene)
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("a", {
                    style: {
                        paddingLeft: 100
                    },
                    href: $59a241f3912e631e$var$urls.app(browser.genome, study, efp_gene),
                    target: "_blank",
                    rel: "noreferrer",
                    children: [
                        "Powered by ",
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("img", {
                            src: $59a241f3912e631e$var$urls.logo,
                            style: {
                                maxWidth: 40
                            },
                            alt: "BBC"
                        }),
                        " Webservices"
                    ]
                })
            ]
        });
    }
}
function $59a241f3912e631e$export$1bc0f3596ef2efe9(gene) {
    return $59a241f3912e631e$var$browsers.hasOwnProperty(gene.system_name);
}
// "EBI Studies" and "Paralogs" draw Expression Atlas heatmaps in the page with
// gramene-atlas-heatmap (warelab's React 18 fork of EBI's atlas-heatmap; the
// anatomogram comes from gramene-anatomogram), and "JGI Studies" draws one JGI
// study at a time as a grid of its factors (ExpressionFactorGrid from the same
// package). configuration.atlasUrl names the gramene-swagger /gxa/ instance to
// query; sites that leave it unset get the instance the old dev.gramene.org
// iframe widget fell back to.
const $9e29a4f60318db7a$var$DEFAULT_ATLAS_URL = 'https://data.sorghumbase.org/auth_testing/gxa/';
const $9e29a4f60318db7a$var$EBI_GXA = 'https://www.ebi.ac.uk/gxa/';
// A link's context names the genes in its query ({gene: 'A B'} or 'A B'), or
// in gene (ExpressionFactorGrid shows one gene).
const $9e29a4f60318db7a$var$genesOf = (context)=>{
    const query = context.query;
    const genes = (typeof query === 'string' ? query : query && query.gene) || context.gene;
    return genes ? genes.split(' ') : [];
};
const $9e29a4f60318db7a$var$isEbiUrl = (url)=>/^https?:\/\/www\.ebi\.ac\.uk\//i.test(url);
const $9e29a4f60318db7a$var$editSearch = (url, edit)=>{
    try {
        const u = new URL(url);
        edit(u.searchParams);
        return u.href;
    } catch (e) {
        return undefined;
    }
};
// gramene-swagger echoes geneQuery back as [null,...], returns relative row uris
// (genes/<id>) that only some instances redirect to EBI, and atlasUrl itself is
// not a browsable page, so point the heatmap's links at EBI's Expression Atlas.
// JGI studies link to Phytozome, which takes no geneQuery. undefined keeps the
// heatmap's own URL, null drops the link. isJgiExperiment(accession) tells the
// JGI studies apart: they have no full data download (their payload's download
// URL is Phytozome's page for the genome), so the Download dialog of a Paralogs
// heatmap drawn from one leaves out "Full experiment data on Expression Atlas".
const $9e29a4f60318db7a$var$isJgiUrl = (url)=>/^https?:\/\/([^/]+\.)?jgi\.doe\.gov\//i.test(url);
const $9e29a4f60318db7a$var$makeResolveUrl = (isJgiExperiment)=>(kind, url, context)=>{
        const genes = $9e29a4f60318db7a$var$genesOf(context);
        const withGenes = (params)=>{
            if (genes.length) params.set('geneQuery', JSON.stringify(genes.map((value)=>({
                    value: value
                }))));
        };
        switch(kind){
            case 'row':
                {
                    const uri = context.row && context.row.uri;
                    return uri && !/^https?:/i.test(uri) ? new URL(uri, $9e29a4f60318db7a$var$EBI_GXA).href : undefined;
                }
            case 'atlas':
                return $9e29a4f60318db7a$var$EBI_GXA;
            case 'experiment':
                return $9e29a4f60318db7a$var$isEbiUrl(url) ? $9e29a4f60318db7a$var$editSearch(url, withGenes) : undefined;
            case 'moreInformation':
                if (context.experiment) return $9e29a4f60318db7a$var$isEbiUrl(url) ? $9e29a4f60318db7a$var$editSearch(url, withGenes) : undefined;
                return genes.length ? `${$9e29a4f60318db7a$var$EBI_GXA}genes/${encodeURIComponent(genes[0])}` : undefined;
            case 'download':
                if (isJgiExperiment(context.experiment) || $9e29a4f60318db7a$var$isJgiUrl(url)) return null;
                return $9e29a4f60318db7a$var$editSearch(url, (params)=>params.delete('geneQuery'));
            default:
                return undefined;
        }
    };
const $9e29a4f60318db7a$var$HEATMAP_OPTIONS = {
    showAnatomogram: true,
    isWidget: true,
    showControlMenu: true,
    linkTarget: '_blank'
};
const $9e29a4f60318db7a$var$studyLabel = (e)=>`${e.type}:${e.description || e._id}`;
const $9e29a4f60318db7a$var$jgiStudyLabel = (e)=>e.description ? `${e.name || e._id}: ${e.description}` : e.name || e._id;
// The JGI studies (source 'JGI', e.g. the Mullet lab's JGI-SB-1..4 in sorghum)
// have their own sub-tab, so the EBI Studies heatmap drops their rows. The GXA
// API names a JGI row by the study's accession, by its name, or — for a study
// split by a second factor — '<study name> - <value>'.
const $9e29a4f60318db7a$var$isJgiStudy = (e)=>e.source === 'JGI';
const $9e29a4f60318db7a$var$isDifferential = (e)=>/differential/i.test(e.type || '');
const $9e29a4f60318db7a$var$makeIsJgiRow = (jgiStudies)=>{
    const accessions = new Set(jgiStudies.map((e)=>e._id));
    const names = jgiStudies.map((e)=>e.name).filter(Boolean);
    const isJgiName = (s)=>typeof s === 'string' && names.some((n)=>s === n || s.startsWith(`${n} - `));
    return (row)=>accessions.has(row.id) || isJgiName(row.id) || isJgiName(row.name);
};
const $9e29a4f60318db7a$var$Detail = (props)=>{
    const geneId = props.searchResult.id;
    const gene = props.geneDocs[geneId];
    // User-selected view state (active sub-tab, chosen GXA experiment, chosen JGI
    // study and its grid axes, chosen eFP study) lives in the uiViewState bundle
    // keyed by geneId, so the shareable-views snapshot can round-trip it.
    const expr = props.uiViewState && props.uiViewState.byGene[geneId] && props.uiViewState.byGene[geneId].expression || {};
    const atlasExperiment = expr.atlasExperiment || null;
    const setExpression = (patch)=>props.doSetExpressionState({
            geneId: geneId,
            patch: patch
        });
    // The expressionStudies resource is otherwise fetched only when a top-level
    // expression view (exprViz/expression/export) is on — but this per-gene
    // Expression detail also needs it (the Paralogs sub-tab's experiment list, the
    // atlasExperiment selection, the JGI Studies tab and the EBI Studies row
    // filter all derive from it). Fetch it here when it is missing or stale: it is
    // persisted, and a browser that cached the list before studies were added to
    // the release would otherwise keep offering the old list.
    (0, $gXNCa$react.useEffect)(()=>{
        if (props.expressionStudiesShouldUpdate && props.doFetchExpressionStudies) props.doFetchExpressionStudies();
    }, [
        props.expressionStudiesShouldUpdate
    ]);
    const studies = props.expressionStudies && props.expressionStudies[Math.floor(gene.taxon_id / 1000)];
    const inGxa = props.searchResult.expressed_in_gxa_attr_ss;
    // The studies the gene is expressed in, which decide the JGI Studies tab and
    // the default sub-tab. The search results leave expressed_in_gxa_attr_ss out,
    // so unless the host's results carry it, it is asked for per gene: undefined
    // until it is in, null if the request failed.
    const geneStudiesEntry = props.grameneGeneStudies && props.grameneGeneStudies[geneId];
    const geneStudyIds = Array.isArray(inGxa) ? inGxa : geneStudiesEntry && !geneStudiesEntry.pending ? geneStudiesEntry.studies : undefined;
    (0, $gXNCa$react.useEffect)(()=>{
        if (!Array.isArray(inGxa)) props.doRequestGeneStudies(geneId);
    }, [
        geneId,
        Array.isArray(inGxa)
    ]);
    const experiments = (0, $gXNCa$react.useMemo)(()=>{
        if (!studies) return [];
        const inGxaSet = inGxa && new Set(inGxa);
        // copy before sorting: the studies array belongs to the expressionStudies bundle
        const list = inGxaSet ? studies.filter((e)=>inGxaSet.has(e._id)) : studies.slice();
        return list.sort((a, b)=>$9e29a4f60318db7a$var$studyLabel(a) < $9e29a4f60318db7a$var$studyLabel(b) ? -1 : 1);
    }, [
        studies,
        inGxa
    ]);
    // Only pick a default experiment when the user (or a restored snapshot)
    // hasn't already chosen one — otherwise we'd clobber a saved selection
    // the moment the studies list loads.
    (0, $gXNCa$react.useEffect)(()=>{
        if (atlasExperiment || experiments.length === 0) return;
        const refExp = experiments.filter((e)=>e.isRef);
        setExpression({
            atlasExperiment: (refExp.length === 1 ? refExp[0] : experiments[0])._id
        });
    }, [
        experiments,
        atlasExperiment
    ]);
    const paralogs = props.grameneParalogs && props.grameneParalogs[gene._id];
    (0, $gXNCa$react.useEffect)(()=>{
        if (!paralogs && gene.homology) props.doRequestParalogs(gene._id, gene.homology.supertree, gene.taxon_id);
    }, [
        gene._id,
        !!paralogs
    ]);
    const atlasUrl = props.configuration && props.configuration.atlasUrl || $9e29a4f60318db7a$var$DEFAULT_ATLAS_URL;
    const geneQuery = gene.atlas_id || gene._id;
    const paralogQuery = paralogs && paralogs.length > 0 ? paralogs.join(' ') : null;
    const allStudiesQuery = (0, $gXNCa$react.useMemo)(()=>({
            gene: geneQuery
        }), [
        geneQuery
    ]);
    const paralogsQuery = (0, $gXNCa$react.useMemo)(()=>({
            gene: paralogQuery
        }), [
        paralogQuery
    ]);
    const knownExperiment = experiments.some((e)=>e._id === atlasExperiment);
    // The Paralogs selector keeps offering every study (as before: the search
    // results' expressed_in_gxa_attr_ss, which they do not carry, would narrow
    // it); the JGI Studies tab lists the JGI studies the gene is expressed in
    // (every JGI study of the taxon if that cannot be looked up). The EBI Studies
    // rows are filtered on every JGI study of the taxon, in case the gene's list
    // is incomplete. The filter is keyed on the studies' ids and names so that its
    // identity (and the heatmap's filtering) only changes when they do.
    const allJgiStudies = studies ? studies.filter($9e29a4f60318db7a$var$isJgiStudy) : [];
    const jgiStudies = (0, $gXNCa$react.useMemo)(()=>{
        if (!studies || geneStudyIds === undefined) return [];
        const mine = geneStudyIds && new Set(geneStudyIds);
        return studies.filter((e)=>$9e29a4f60318db7a$var$isJgiStudy(e) && (!mine || mine.has(e._id))).sort((a, b)=>$9e29a4f60318db7a$var$jgiStudyLabel(a) < $9e29a4f60318db7a$var$jgiStudyLabel(b) ? -1 : 1);
    }, [
        studies,
        geneStudyIds
    ]);
    // Whether the EBI Studies heatmap has anything to show: a study the gene is
    // expressed in that is neither a JGI study nor a differential one (that tab
    // draws baseline experiments).
    const hasEbiBaseline = (0, $gXNCa$react.useMemo)(()=>{
        if (!geneStudyIds || !studies) return true;
        const notEbiBaseline = new Set(studies.filter((e)=>$9e29a4f60318db7a$var$isJgiStudy(e) || $9e29a4f60318db7a$var$isDifferential(e)).map((e)=>e._id));
        return geneStudyIds.some((id)=>!notEbiBaseline.has(id));
    }, [
        studies,
        geneStudyIds
    ]);
    const allJgiKey = JSON.stringify(allJgiStudies.map((e)=>[
            e._id,
            e.name
        ]));
    const filterRows = (0, $gXNCa$react.useMemo)(()=>{
        if (allJgiStudies.length === 0) return undefined;
        const isJgiRow = $9e29a4f60318db7a$var$makeIsJgiRow(allJgiStudies);
        return (row)=>!isJgiRow(row);
    }, [
        allJgiKey
    ]);
    // A new resolveUrl does not redraw a heatmap: it asks the latest one for its links.
    const resolveUrl = (0, $gXNCa$react.useMemo)(()=>{
        const accessions = new Set(allJgiStudies.map((e)=>e._id));
        return $9e29a4f60318db7a$var$makeResolveUrl((accession)=>accessions.has(accession));
    }, [
        allJgiKey
    ]);
    // The EBI Studies heatmap waits for the studies list, which names the JGI
    // studies its filter drops: drawn before the list is in (a first visit; the
    // list is persisted), it would show the JGI rows and then redraw without
    // them. If the list cannot be fetched, the heatmap is drawn unfiltered. It
    // also waits for the gene's studies, which pick the default sub-tab.
    const studiesSettled = (!!props.expressionStudies || !!props.expressionStudiesLastError) && geneStudyIds !== undefined;
    // With no saved sub-tab, a gene expressed in JGI studies only opens on JGI
    // Studies (its EBI Studies heatmap would be all below cutoff). A saved JGI
    // Studies tab falls back to EBI Studies once the studies are in and the gene
    // has none; until then the tab shows that it is loading.
    const defaultTab = studiesSettled && jgiStudies.length > 0 && !hasEbiBaseline ? 'jgi' : 'gene';
    const activeTab = expr.activeTab === 'jgi' && studiesSettled && jgiStudies.length === 0 ? 'gene' : expr.activeTab || defaultTab;
    const jgiExperiment = expr.jgiExperiment || (jgiStudies.length > 0 ? jgiStudies[0]._id : null);
    const knownJgiExperiment = jgiStudies.some((e)=>e._id === jgiExperiment);
    const jgiAxes = expr.jgiAxes || {};
    const jgiAxesOfStudy = jgiExperiment && jgiAxes[jgiExperiment] || {};
    const setJgiAxes = ({ rowFactor: rowFactor, columnFactor: columnFactor })=>setExpression({
            jgiAxes: {
                ...jgiAxes,
                [jgiExperiment]: {
                    rowFactor: rowFactor,
                    columnFactor: columnFactor
                }
            }
        });
    // Only the active sub-tab's heatmap (or factor grid) is mounted; the keys give
    // each query its own fetch, zoom and filters.
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Tabs, {
        activeKey: activeTab,
        onSelect: (k)=>setExpression({
                activeTab: k
            }),
        children: [
            paralogQuery && atlasExperiment && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Tab, {
                tabClassName: "gxa",
                eventKey: "paralogs",
                title: "Paralogs",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Form.Select, {
                        className: "mb-2",
                        "aria-label": "experiment selector",
                        value: atlasExperiment,
                        onChange: (e)=>setExpression({
                                atlasExperiment: e.target.value
                            }),
                        children: [
                            !knownExperiment && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("option", {
                                value: atlasExperiment,
                                children: atlasExperiment
                            }),
                            experiments.map((e)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("option", {
                                    value: e._id,
                                    children: [
                                        e.type,
                                        ": ",
                                        e.description || e._id
                                    ]
                                }, e._id))
                        ]
                    }),
                    activeTab === "paralogs" && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$grameneatlasheatmap.ExpressionAtlasHeatmap, {
                        ...$9e29a4f60318db7a$var$HEATMAP_OPTIONS,
                        resolveUrl: resolveUrl,
                        atlasUrl: atlasUrl,
                        query: paralogsQuery,
                        experiment: atlasExperiment,
                        downloadFileName: `${geneQuery}-paralogs-${atlasExperiment}`
                    }, `${atlasUrl} ${atlasExperiment} ${paralogQuery}`)
                ]
            }, "gxaparalogs"),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Tab, {
                tabClassName: "gxa",
                eventKey: "gene",
                title: "EBI Studies",
                children: [
                    activeTab === "gene" && !studiesSettled && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        className: "text-muted small",
                        role: "status",
                        children: "Loading expression studies\u2026"
                    }),
                    activeTab === "gene" && studiesSettled && !hasEbiBaseline && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                        className: "text-muted small",
                        role: "status",
                        children: [
                            gene.name || gene._id,
                            " is not in any baseline expression study, so there is no heatmap here.",
                            paralogQuery && atlasExperiment && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
                                children: [
                                    ' ',
                                    "To explore the differential expression of this gene and its paralogs, use the",
                                    ' ',
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                                        variant: "link",
                                        size: "sm",
                                        className: "p-0 align-baseline",
                                        onClick: ()=>setExpression({
                                                activeTab: 'paralogs'
                                            }),
                                        children: "Paralogs tab"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    }),
                    activeTab === "gene" && studiesSettled && hasEbiBaseline && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$grameneatlasheatmap.ExpressionAtlasHeatmap, {
                        ...$9e29a4f60318db7a$var$HEATMAP_OPTIONS,
                        resolveUrl: resolveUrl,
                        atlasUrl: atlasUrl,
                        query: allStudiesQuery,
                        experiment: false,
                        filterRows: filterRows,
                        downloadFileName: `${geneQuery}-ebi-studies`
                    }, `${atlasUrl} all ${geneQuery}`)
                ]
            }, "gxa"),
            jgiStudies.length === 0 && activeTab === "jgi" && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Tab, {
                tabClassName: "jgi",
                eventKey: "jgi",
                title: "JGI Studies",
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                    className: "text-muted small",
                    role: "status",
                    children: "Loading expression studies\u2026"
                })
            }, "jgi"),
            jgiStudies.length > 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Tab, {
                tabClassName: "jgi",
                eventKey: "jgi",
                title: "JGI Studies",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Form.Select, {
                        className: "mb-2",
                        "aria-label": "JGI study selector",
                        value: jgiExperiment,
                        onChange: (e)=>setExpression({
                                jgiExperiment: e.target.value
                            }),
                        children: [
                            !knownJgiExperiment && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("option", {
                                value: jgiExperiment,
                                children: jgiExperiment
                            }),
                            jgiStudies.map((e)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("option", {
                                    value: e._id,
                                    children: $9e29a4f60318db7a$var$jgiStudyLabel(e)
                                }, e._id))
                        ]
                    }),
                    activeTab === "jgi" && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$grameneatlasheatmap.ExpressionFactorGrid, {
                        atlasUrl: atlasUrl,
                        experiment: jgiExperiment,
                        gene: geneQuery,
                        rowFactor: jgiAxesOfStudy.rowFactor,
                        columnFactor: jgiAxesOfStudy.columnFactor,
                        onChangeFactors: setJgiAxes,
                        downloadFileName: `${geneQuery}-${jgiExperiment}`,
                        linkTarget: "_blank",
                        resolveUrl: resolveUrl
                    }, `${atlasUrl} ${jgiExperiment} ${geneQuery}`)
                ]
            }, "jgi"),
            $59a241f3912e631e$export$1bc0f3596ef2efe9(gene) && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Tab, {
                tabClassName: "eFP",
                eventKey: "eFP",
                title: "eFP Browser",
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($59a241f3912e631e$export$2e2bcd8739ae039, {
                    gene: gene,
                    study: expr.barStudy,
                    onStudyChange: (v)=>setExpression({
                            barStudy: v
                        })
                })
            }, "bar")
        ]
    });
};
var $9e29a4f60318db7a$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)('selectConfiguration', 'selectGrameneParalogs', 'selectGrameneGeneStudies', 'selectExpressionStudies', 'selectExpressionStudiesShouldUpdate', 'selectExpressionStudiesLastError', 'selectUiViewState', 'doRequestParalogs', 'doRequestGeneStudies', 'doFetchExpressionStudies', 'doSetExpressionState', $9e29a4f60318db7a$var$Detail);
const $5c2c79352d3d7b81$export$ec6b54b688be1708 = ({ fullscreen: fullscreen, onExitFullscreen: onExitFullscreen, title: title, className: className, children: children })=>{
    const [stableNode] = (0, $gXNCa$react.useState)(()=>typeof document !== 'undefined' ? document.createElement('div') : null);
    const inlineRef = (0, $gXNCa$react.useRef)(null);
    const modalRef = (0, $gXNCa$react.useRef)(null);
    (0, $gXNCa$react.useLayoutEffect)(()=>{
        if (!stableNode) return;
        if (className) stableNode.className = className;
        const parent = fullscreen ? modalRef.current : inlineRef.current;
        if (parent && stableNode.parentNode !== parent) parent.appendChild(stableNode);
    });
    (0, $gXNCa$react.useEffect)(()=>{
        // Container width changes when toggling fullscreen. Embedded widgets
        // that listen for window resize (Pathways, etc.) re-measure on this
        // event.
        window.dispatchEvent(new Event('resize'));
    }, [
        fullscreen
    ]);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                ref: inlineRef
            }),
            fullscreen && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Modal, {
                show: true,
                fullscreen: true,
                onHide: onExitFullscreen,
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Modal.Header, {
                        closeButton: true,
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Modal.Title, {
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Modal.Body, {
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                            ref: modalRef
                        })
                    })
                ]
            }),
            stableNode && /*#__PURE__*/ (0, $gXNCa$reactdom.createPortal)(children, stableNode)
        ]
    });
};
const $5c2c79352d3d7b81$export$47eb42ff093406d4 = (props)=>{
    const subComponents = $parcel$interopDefault($gXNCa$lodashkeyBy)(props.children, 'key');
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "detail",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "intro",
                children: [
                    subComponents.title,
                    subComponents.description
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "content-wrapper",
                children: subComponents.content
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "actions",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        className: "action-wrapper",
                        xs: 12,
                        sm: 5,
                        children: subComponents.explore
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        className: "action-wrapper",
                        xs: 12,
                        sm: 7,
                        children: subComponents.links
                    })
                ]
            })
        ]
    });
};
const $5c2c79352d3d7b81$export$f99233281efd08a0 = (props)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h4", {
        children: props.children
    });
const $5c2c79352d3d7b81$export$393edc798c47379d = (props)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("p", {
        className: "description",
        children: props.children
    });
const $5c2c79352d3d7b81$export$7c6e2c02157bb7d2 = (props)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "content",
        children: props.children
    });
const $5c2c79352d3d7b81$var$QueryTerm = (props)=>{
    let category, name, badge;
    name = props.name;
    if (props.category) category = props.category + ' | ';
    if ($parcel$interopDefault($gXNCa$lodash).isNumber(props.count)) badge = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Badge, {
        style: {
            marginLeft: "0.5rem"
        },
        bg: "secondary",
        children: props.count
    });
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Button, {
        variant: "outline-dark",
        onClick: props.handleClick,
        children: [
            category,
            name,
            badge
        ]
    });
};
function $5c2c79352d3d7b81$var$renderExplorations(explorations) {
    return explorations.map((exploration, idx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($5c2c79352d3d7b81$var$QueryTerm, {
            ...exploration
        }, idx));
}
const $5c2c79352d3d7b81$export$900f1bfcd1cb6476 = (props)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "explore",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h5", {
                children: "Search Filters"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                children: $5c2c79352d3d7b81$var$renderExplorations(props.explorations)
            })
        ]
    });
function $5c2c79352d3d7b81$var$renderLinks(links) {
    let external = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("small", {
        title: "This link opens a page from an external site",
        children: [
            " ",
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsbi.BiLinkExternal, {})
        ]
    });
    return links.map((link, idx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("li", {
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("a", {
                href: link.url,
                target: "_blank",
                className: "external-link",
                onClick: ()=>{
                    $parcel$interopDefault($gXNCa$reactga4).event({
                        category: "outbound link",
                        action: "follow",
                        label: link.name
                    });
                },
                children: [
                    link.name,
                    external
                ]
            })
        }, idx));
}
const $5c2c79352d3d7b81$export$b2e089eb3692b073 = (props)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "links",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h5", {
                children: "Links to other resources"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("ul", {
                children: $5c2c79352d3d7b81$var$renderLinks(props.links)
            })
        ]
    });
// Host-defined tbrowse zone for the Homology gene tree, redesigned to compare
// expression across a gene family. Three parts, aligned to the tree leaves:
//   1. a gene × organ heatmap of ordinal expression levels (expr_organ_level),
//      tissue-specific / -enhanced organs are noted in cell tooltips;
//   2. a Max TPM column (expr_max_tpm), log-scaled magnitude;
//   3. a Stress column of ↑activated / ↓repressed condition chips
//      (expr_activated_by / expr_repressed_by).
// Data is threaded in via hostData.exprAttrs (built by buildExprData from the
// tree-scoped /search response), mirroring how the neighborhood / genome zones
// receive their async data. Color/legend conventions follow exprViz/HeatmapPlot.
const $cd8bc494277e92a4$var$ORGAN_CELL_W = 16;
const $cd8bc494277e92a4$var$MAXTPM_W = 46;
const $cd8bc494277e92a4$var$STRESS_MIN = 120;
function $cd8bc494277e92a4$export$965a6b1d7408d496(docs, tree) {
    const hasTree = Boolean(tree && tree.nodes);
    const nodeGene = hasTree ? (0, $gXNCa$tbrowsecore.geneIdByLeafNodeId)(tree) : {}; // leaf nodeId -> gene id (hover readout)
    const byGeneId = {};
    (docs || []).forEach((d)=>{
        if (d && d.id) byGeneId[d.id] = $4b8473139e48e77e$export$69fb5d19b5db1cfa(d);
    });
    // Docs whose gene is not a leaf of this tree are dropped (joinByLeaf's `unmatched`).
    const byNode = hasTree ? (0, $gXNCa$tbrowsecore.joinByLeaf)(tree, byGeneId).byNode : {};
    const organSet = new Set();
    let tpmMin = Infinity;
    let tpmMax = -Infinity;
    Object.values(byNode).forEach((attrs)=>{
        Object.keys(attrs.organLevels).forEach((o)=>organSet.add(o));
        if (attrs.maxTpm !== null) {
            if (attrs.maxTpm < tpmMin) tpmMin = attrs.maxTpm;
            if (attrs.maxTpm > tpmMax) tpmMax = attrs.maxTpm;
        }
    });
    return {
        organs: $4b8473139e48e77e$export$65382efdcdd96f8c(organSet),
        byNode: byNode,
        nodeGene: nodeGene,
        maxTpm: {
            min: tpmMin === Infinity ? 0 : tpmMin,
            max: tpmMax === -Infinity ? 0 : tpmMax
        }
    };
}
const $cd8bc494277e92a4$var$gridBorder = '1px solid var(--tbrowse-grid-line, rgba(0,0,0,0.06))';
const $cd8bc494277e92a4$var$stressWidth = (width, organCount)=>Math.max($cd8bc494277e92a4$var$STRESS_MIN, width - organCount * $cd8bc494277e92a4$var$ORGAN_CELL_W - $cd8bc494277e92a4$var$MAXTPM_W);
// "Expressed only" toggle. Homology applies it: while on (and the zone is
// visible) it prunes every branch with no gene that has expression
// attributes, and turning it on expands the branches that remain.
const $cd8bc494277e92a4$var$ExpressedOnlyToggle = ({ on: on, onChange: onChange })=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("label", {
        title: "Prune branches without expression data and expand the rest",
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 3,
            fontSize: 10,
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            margin: 0
        },
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
                type: "checkbox",
                checked: on,
                onChange: (e)=>onChange(e.target.checked),
                style: {
                    margin: 0
                }
            }),
            "expressed only"
        ]
    });
const $cd8bc494277e92a4$var$ExprHeader = ({ zoneState: zoneState, setZoneState: setZoneState, width: width, data: data, hoveredNodeId: hoveredNodeId })=>{
    const ea = data.hostData && data.hostData.exprAttrs || {};
    const organs = ea.organs || [];
    const gid = hoveredNodeId && ea.nodeGene && ea.nodeGene[hoveredNodeId];
    const gene = hoveredNodeId && ea.byNode && ea.byNode[hoveredNodeId];
    const clsText = gene && $4b8473139e48e77e$export$1f04174626f2ac64(gene.cls);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    padding: '0 4px',
                    fontSize: 12
                },
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$tbrowse.EditableZoneName, {
                        defaultName: "Expression",
                        customName: zoneState?.name,
                        onChange: (next)=>setZoneState((s)=>({
                                    ...s ?? {},
                                    name: next
                                }))
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($cd8bc494277e92a4$var$ExpressedOnlyToggle, {
                        on: !!zoneState?.expressedOnly,
                        onChange: (on)=>setZoneState((s)=>({
                                    ...s ?? {},
                                    expressedOnly: on
                                }))
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            fontSize: 9,
                            opacity: 0.85
                        },
                        title: "expression level",
                        children: $4b8473139e48e77e$export$4bb936dc8856d37a.map((lv)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                title: $4b8473139e48e77e$export$433053e2c141d410[lv],
                                style: {
                                    width: 10,
                                    height: 10,
                                    background: $4b8473139e48e77e$export$b352e11f7a2ac9c5[lv],
                                    border: $cd8bc494277e92a4$var$gridBorder,
                                    display: 'inline-block'
                                }
                            }, lv))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                title: gid ? clsText ? `${gid} \xb7 ${clsText}` : gid : 'hover a node to see its gene and expression class',
                style: {
                    padding: '0 4px 2px',
                    fontSize: 11,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                },
                children: gid ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                            children: gid
                        }),
                        clsText ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                            style: {
                                opacity: 0.7
                            },
                            children: ` \xb7 ${clsText}`
                        }) : null
                    ]
                }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    style: {
                        opacity: 0.5
                    },
                    children: "hover a node\u2026"
                })
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                style: {
                    display: 'flex',
                    width: width
                },
                children: [
                    organs.map((o)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                            title: $4b8473139e48e77e$export$50c1f966fd3af83e(o),
                            style: {
                                width: $cd8bc494277e92a4$var$ORGAN_CELL_W,
                                fontSize: 8,
                                textAlign: 'center',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                borderRight: $cd8bc494277e92a4$var$gridBorder,
                                opacity: 0.8
                            },
                            children: $4b8473139e48e77e$export$f8541c2790c3baeb(o)
                        }, o)),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        style: {
                            width: $cd8bc494277e92a4$var$MAXTPM_W,
                            fontSize: 9,
                            fontWeight: 600,
                            textAlign: 'right',
                            paddingRight: 4,
                            opacity: 0.8
                        },
                        children: "TPM"
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        style: {
                            width: $cd8bc494277e92a4$var$stressWidth(width, organs.length),
                            fontSize: 9,
                            fontWeight: 600,
                            paddingLeft: 4,
                            opacity: 0.8
                        },
                        children: "Stress"
                    })
                ]
            })
        ]
    });
};
const $cd8bc494277e92a4$var$OrganCell = ({ organ: organ, gene: gene })=>{
    const level = gene && gene.organLevels[organ];
    const specific = !!(gene && gene.specificTo.has(organ));
    const enhanced = !!(gene && gene.enhancedIn.has(organ));
    const title = level ? `${$4b8473139e48e77e$export$50c1f966fd3af83e(organ)}: ${$4b8473139e48e77e$export$433053e2c141d410[level] || level}${specific ? " \xb7 specific" : enhanced ? " \xb7 enhanced" : ''}` : `${$4b8473139e48e77e$export$50c1f966fd3af83e(organ)}: not assayed`;
    const style = {
        width: $cd8bc494277e92a4$var$ORGAN_CELL_W,
        height: '100%',
        boxSizing: 'border-box',
        background: level ? $4b8473139e48e77e$export$b352e11f7a2ac9c5[level] || 'transparent' : 'transparent',
        borderRight: $cd8bc494277e92a4$var$gridBorder
    };
    // Tissue-specific / -enhanced organs are reported in the cell's tooltip rather
    // than with a marker, so the grid reads purely as expression level.
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        title: title,
        style: style
    });
};
const $cd8bc494277e92a4$var$StressCell = ({ gene: gene, width: width })=>{
    const up = gene && gene.activatedBy || [];
    const down = gene && gene.repressedBy || [];
    const title = [
        up.length ? `\u{2191} ${up.join(', ')}` : '',
        down.length ? `\u{2193} ${down.join(', ')}` : ''
    ].filter(Boolean).join('   ');
    const chip = (c, dir, key)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
            style: {
                fontSize: 9,
                lineHeight: '14px',
                padding: '0 3px',
                borderRadius: 2,
                whiteSpace: 'nowrap',
                background: $4b8473139e48e77e$export$c6dbe9be8c8b382e[dir].bg,
                color: $4b8473139e48e77e$export$c6dbe9be8c8b382e[dir].fg
            },
            children: (dir === 'up' ? "\u2191" : "\u2193") + c
        }, key);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        title: title,
        style: {
            width: width,
            display: 'flex',
            flexWrap: 'nowrap',
            gap: 2,
            overflow: 'hidden',
            alignItems: 'center',
            paddingLeft: 4,
            boxSizing: 'border-box'
        },
        children: [
            up.map((c, i)=>chip(c, 'up', `u${i}`)),
            down.map((c, i)=>chip(c, 'down', `d${i}`))
        ]
    });
};
const $cd8bc494277e92a4$var$ExprBody = ({ visibleRows: visibleRows, rowRange: rowRange, width: width, data: data, hoveredNodeId: hoveredNodeId, hoveredSubtreeIds: hoveredSubtreeIds, selectedNodeId: selectedNodeId, onHoverNode: onHoverNode, onSelectNode: onSelectNode })=>{
    const ea = data.hostData && data.hostData.exprAttrs || {};
    const organs = ea.organs || [];
    const byNode = ea.byNode || {};
    const tpmRange = ea.maxTpm || {
        min: 0,
        max: 0
    };
    const sW = $cd8bc494277e92a4$var$stressWidth(width, organs.length);
    const totalHeight = (0, $gXNCa$tbrowsecore.rowsTotalHeight)(visibleRows);
    const rows = (0, $gXNCa$tbrowse.rowsWithFlags)(visibleRows, rowRange, {
        hoveredNodeId: hoveredNodeId,
        hoveredSubtreeIds: hoveredSubtreeIds,
        selectedNodeId: selectedNodeId
    });
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        style: {
            position: 'relative',
            width: width,
            height: totalHeight,
            overflow: 'hidden'
        },
        children: rows.map(({ row: r, background: background })=>{
            const gene = byNode[r.nodeId];
            const tpmFrac = gene ? $4b8473139e48e77e$export$fc40d061e6c16645(gene.maxTpm, tpmRange) : null;
            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                onMouseEnter: ()=>onHoverNode(r.nodeId),
                onMouseLeave: ()=>onHoverNode(null),
                onClick: ()=>onSelectNode(r.nodeId),
                style: {
                    position: 'absolute',
                    top: r.y,
                    height: r.height,
                    left: 0,
                    width: width,
                    display: 'flex',
                    boxSizing: 'border-box',
                    background: background,
                    cursor: 'pointer',
                    opacity: r.opacity ?? 1
                },
                children: [
                    organs.map((o)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($cd8bc494277e92a4$var$OrganCell, {
                            organ: o,
                            gene: gene
                        }, o)),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        title: gene && Number.isFinite(gene.maxTpm) ? `max TPM: ${gene.maxTpm}` : '',
                        style: {
                            width: $cd8bc494277e92a4$var$MAXTPM_W,
                            height: '100%',
                            boxSizing: 'border-box',
                            borderRight: $cd8bc494277e92a4$var$gridBorder,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            paddingRight: 4,
                            fontSize: 9,
                            fontVariantNumeric: 'tabular-nums',
                            color: 'var(--tbrowse-text)',
                            background: tpmFrac === null ? 'transparent' : `rgba(33, 102, 172, ${(0.1 + 0.65 * tpmFrac).toFixed(3)})`
                        },
                        children: gene ? $4b8473139e48e77e$export$8eaa32ef86afdd9c(gene.maxTpm) : ''
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($cd8bc494277e92a4$var$StressCell, {
                        gene: gene,
                        width: sW
                    })
                ]
            }, r.nodeId);
        })
    });
};
const $cd8bc494277e92a4$export$44e8c3b1eee47e9e = {
    id: 'expression',
    displayName: 'Expression',
    Header: $cd8bc494277e92a4$var$ExprHeader,
    Body: $cd8bc494277e92a4$var$ExprBody,
    defaultWidth: 70,
    minWidth: 280,
    defaultZoneState: {},
    // Stay hidden until its async data lands; tbrowse's auto-enable effect flips
    // it on once isAvailable() turns true (same lifecycle as neighborhood/genome).
    isAvailable: (data)=>Boolean(data.hostData && data.hostData.exprAttrs && data.hostData.exprAttrs.organs && data.hostData.exprAttrs.organs.length),
    defaultVisible: false,
    // Join tbrowse's built-in 'detail' group (MSA / Neighborhood / Gene
    // structure): only one of these wide per-leaf tracks shows at a time
    // unless the user decouples the group with the `multi` toggle.
    exclusiveGroup: 'detail'
};
const $047461923b1badda$export$54387eca9e368edc = (config)=>{
    if (!config) return null;
    const name = config.projectId || '[DEFAULT]';
    if ((0, $gXNCa$firebaseapp.getApps)().some((a)=>a.name === name)) return (0, $gXNCa$firebaseapp.getApp)(name);
    return (0, $gXNCa$firebaseapp.initializeApp)(config, name);
};
const $047461923b1badda$export$964d88edb00bbcaa = (suggestion)=>{
    return {
        status: 'init',
        rows: 20,
        operation: 'AND',
        negate: false,
        leftIdx: 0,
        rightIdx: 3,
        children: [
            {
                fq_field: suggestion.fq_field,
                fq_value: suggestion.fq_value,
                name: suggestion.name,
                category: suggestion.category,
                leftIdx: 1,
                rightIdx: 2,
                negate: false,
                marked: false
            }
        ]
    };
};
// A gene's trees: the main Compara tree (homology.gene_tree) and/or trees in
// clade-specific tree sets, homology.<tree_set> — e.g. a wheat gene may carry
// gene_tree, homology.wheat = {id: 'EplWheatGT_…'} and homology.barley. Solr
// indexes each tree id under the same name (gene_tree, wheat, barley, …), so
// `field` is also the fq field. gene_tree comes first; empty when the gene
// has homologues but no tree at all.
const $64fad37f770d2bfe$var$NOT_TREE_KEYS = [
    'homologous_genes',
    'supertree'
];
function $64fad37f770d2bfe$var$geneTreeRefs(gene) {
    const h = gene && gene.homology;
    if (!h) return [];
    const isTree = (k)=>!$64fad37f770d2bfe$var$NOT_TREE_KEYS.includes(k) && h[k] && typeof h[k] === 'object' && typeof h[k].id === 'string';
    const keys = Object.keys(h).filter(isTree);
    keys.sort((a, b)=>a === 'gene_tree' ? -1 : b === 'gene_tree' ? 1 : 0);
    return keys.map((field)=>({
            field: field,
            id: h[field].id,
            rootTaxonName: h[field].root_taxon_name
        }));
}
// The tree to show: the one picked in the switcher (`field`), else the first.
function $64fad37f770d2bfe$var$geneTreeRef(gene, field) {
    const refs = $64fad37f770d2bfe$var$geneTreeRefs(gene);
    return refs.find((r)=>r.field === field) || refs[0] || null;
}
// Switcher label: the tree set and the clade the tree is rooted at.
const $64fad37f770d2bfe$var$treeLabel = (ref)=>{
    const set = ref.field === 'gene_tree' ? 'Compara' : ref.field.charAt(0).toUpperCase() + ref.field.slice(1);
    return ref.rootTaxonName ? `${set} \xb7 ${ref.rootTaxonName}` : set;
};
const $64fad37f770d2bfe$var$genomeZone = (0, $gXNCa$tbrowse.createGenomeZone)({
    id: 'genome'
});
// The genome (gene-structure) zone is gated behind the site-config flag
// `enable_tbrowse_genome_zone` (defaults to false) — see getTbrowseZones().
const $64fad37f770d2bfe$var$TBROWSE_BASE_ZONES = [
    $gXNCa$tbrowse.treeZone,
    $gXNCa$tbrowse.labelsZone,
    $gXNCa$tbrowse.msaZone,
    $gXNCa$tbrowse.neighborhoodZone
];
// The expression-attributes zone's data, as a slot on tbrowse-core's Gramene
// gene-tree source: one tree-scoped /search for the expr_*__attr_* fields
// (fetchGrameneExprAttrDocs), shaped by buildExprData and delivered through
// hostData.exprAttrs — the same lifecycle as the built-in neighborhood and
// gene-structure slots. Enabled per site via the ctx flag the component
// derives from `enable_tbrowse_expression_zone`. Scoped by root.meta, which
// carries the Solr field holding the tree id: gene_tree, or a clade tree set
// such as wheat.
const $64fad37f770d2bfe$var$exprAttrsSlot = (0, $gXNCa$tbrowsecore.defineSlot)({
    id: 'exprAttrs',
    enabled: (ctx)=>ctx.expression === true,
    run: async ({ ctx: ctx, fetch: fetch1, signal: signal, tree: tree, root: root })=>$cd8bc494277e92a4$export$965a6b1d7408d496(await (0, $gXNCa$tbrowsecore.fetchGrameneExprAttrDocs)(ctx.base, root.meta.treeId, {
            treeField: root.meta.treeField,
            fetch: fetch1,
            signal: signal
        }), tree),
    toHostData: (v)=>({
            hostData: {
                exprAttrs: v
            }
        })
});
const $64fad37f770d2bfe$var$homologySource = (0, $gXNCa$tbrowsecore.extendSource)($gXNCa$tbrowsecore.grameneGeneTreeSource, {
    id: 'gramene-homology',
    slots: [
        $64fad37f770d2bfe$var$exprAttrsSlot
    ]
});
// Host zone id → the slot(s) feeding it, so the TBrowse toolbar shows the
// per-zone loading / error affordances (TBrowseProps.zoneStatus).
const $64fad37f770d2bfe$var$ZONE_SLOTS = {
    neighborhood: [
        'neighborhood'
    ],
    genome: [
        'geneStructures'
    ],
    expression: [
        'exprAttrs'
    ]
};
// Per-zone settings that point into one tree's rows or alignment columns
// (row flips, per-gap / per-intron overrides, the MSA viewport and expanded
// mask runs, the genome pan), reset when a tree switch carries the rest of
// the zone settings over.
const $64fad37f770d2bfe$var$TREE_SCOPED_ZONE_FIELDS = {
    flippedNodeIds: [],
    gapOverrideKeys: [],
    intronOverrideKeys: [],
    viewportStart: 0,
    viewportEnd: 0,
    panPx: 0
};
function $64fad37f770d2bfe$var$carryViewState(vs) {
    const soft = (0, $gXNCa$tbrowsecore.softResetForNewTree)(vs);
    const zoneStates = $parcel$interopDefault($gXNCa$lodash).mapValues(soft.zoneStates || {}, (zs)=>{
        if (!$parcel$interopDefault($gXNCa$lodash).isPlainObject(zs)) return zs;
        const next = {
            ...zs
        };
        Object.keys($64fad37f770d2bfe$var$TREE_SCOPED_ZONE_FIELDS).forEach((k)=>{
            if (k in next) next[k] = $64fad37f770d2bfe$var$TREE_SCOPED_ZONE_FIELDS[k];
        });
        if (next.mask && next.mask.expandedRuns) next.mask = {
            ...next.mask,
            expandedRuns: []
        };
        return next;
    });
    return {
        ...soft,
        zoneStates: zoneStates
    };
}
class $64fad37f770d2bfe$var$Homology extends $parcel$interopDefault($gXNCa$react).Component {
    constructor(props){
        super(props);
        // The tbrowse data — tree, MSA, domains and junctions adapted from the
        // stored genetree doc, then the neighborhood / gene-structure / expression
        // slots — is loaded by a tbrowse-core loader kept on the instance (one per
        // mount); its snapshot is mirrored into state so renders follow it. The
        // user-controlled view state (viewer toggle, resize height, tbrowse
        // ViewState) is lifted into the uiViewState bundle, keyed by geneId.
        this.loader = (0, $gXNCa$tbrowsecore.createLoader)($64fad37f770d2bfe$var$homologySource, {
            zoneSlots: $64fad37f770d2bfe$var$ZONE_SLOTS
        });
        this.state = {
            snap: this.loader.getSnapshot()
        };
        if (!props.geneDocs.hasOwnProperty(props.searchResult.id)) props.requestGene(props.searchResult.id);
        this.taxonomy = $parcel$interopDefault($gXNCa$gramenetreesclientsrctaxonomy).tree(Object.values(props.grameneTaxonomy));
    }
    // ----- uiViewState accessors (with sensible defaults) -----
    getGeneId() {
        return this.props.searchResult.id;
    }
    getHomologySlice() {
        const slice = this.props.uiViewState && this.props.uiViewState.byGene[this.getGeneId()];
        return slice && slice.homology || {};
    }
    getViewer() {
        return this.getHomologySlice().viewer || 'tbrowse';
    }
    // The gene's selected tree (see the tree switcher in renderViewerToggle).
    selectedTreeRef(gene) {
        return $64fad37f770d2bfe$var$geneTreeRef(gene, this.getHomologySlice().tree);
    }
    // The genome (gene-structure) zone is opt-in per site via
    // `enable_tbrowse_genome_zone` (defaults to false).
    isGenomeZoneEnabled() {
        return !!(this.props.configuration && this.props.configuration.enable_tbrowse_genome_zone);
    }
    // The expression-attributes zone is opt-in per site via
    // `enable_tbrowse_expression_zone` (defaults to false) — the expr_*__attr_*
    // fields are sorghum-specific.
    isExpressionZoneEnabled() {
        return !!(this.props.configuration && this.props.configuration.enable_tbrowse_expression_zone);
    }
    getTbrowseZones() {
        const zones = [
            ...$64fad37f770d2bfe$var$TBROWSE_BASE_ZONES
        ];
        if (this.isGenomeZoneEnabled()) zones.push($64fad37f770d2bfe$var$genomeZone);
        if (this.isExpressionZoneEnabled()) zones.push($cd8bc494277e92a4$export$44e8c3b1eee47e9e);
        return zones;
    }
    getHeight() {
        const h = this.getHomologySlice().height;
        return typeof h === 'number' ? h : 600;
    }
    setTree(field) {
        if (this.treeRef && this.treeRef.field === field) return;
        this.props.doSetHomologyTree({
            geneId: this.getGeneId(),
            tree: field
        });
    }
    setViewer(viewer) {
        this.props.doSetHomologyViewer({
            geneId: this.getGeneId(),
            viewer: viewer
        });
    }
    setHeight(height) {
        this.props.doSetHomologyHeight({
            geneId: this.getGeneId(),
            height: height
        });
    }
    setTbrowseViewState(viewState) {
        this.props.doSetHomologyTbrowseViewState({
            geneId: this.getGeneId(),
            tbrowse: viewState
        });
    }
    // When the user has limited the search to a subset of genomes
    // (grameneGenomes.active), prune the gene tree to genes from those genomes
    // — mirroring the taxon_id filter api.js applies to the search itself, and
    // the genomesOfInterest TreeVis already honours. tbrowse-core's
    // maximalExcludedClades returns the ids of the highest nodes whose entire
    // subtree lies outside the active set (maximal excluded clades), rather
    // than individual leaves: tbrowse then sheds one stub per clade instead of
    // one per leaf, and its single-marker count is meaningful. The gene of
    // interest is always kept so the tree never collapses to nothing. Empty
    // active set means "no limit" → full tree.
    getGenomePrunedIds() {
        const active = this.props.grameneGenomes && this.props.grameneGenomes.active || {};
        const activeIds = Object.keys(active);
        if (activeIds.length === 0) return [];
        const snap = this.state.snap;
        if (!snap.tree) return [];
        const activeSet = new Set(activeIds.map(String));
        const keepGeneId = this.gene && this.gene._id;
        return (0, $gXNCa$tbrowsecore.maximalExcludedClades)(snap.tree, (leaf)=>leaf.taxonomyId != null && activeSet.has(String(leaf.taxonomyId)) || leaf.geneId === keepGeneId);
    }
    // The Expression zone's "expressed only" toggle (zoneStates.expression
    // .expressedOnly): while it is on and the zone is visible, prune the largest
    // branches with no leaf carrying expression attributes. The gene of interest
    // stays, as with the genome prunes, so the root is never pruned.
    getExpressionPrunedIds(vs, hostProps) {
        const zs = vs && vs.zoneStates && vs.zoneStates.expression;
        if (!zs || !zs.expressedOnly) return [];
        if (!(vs.zones || []).some((z)=>z.id === 'expression' && z.visible)) return [];
        const ea = hostProps && hostProps.hostData && hostProps.hostData.exprAttrs;
        if (!ea || !ea.byNode || !hostProps.tree) return [];
        const keepGeneId = this.gene && this.gene._id;
        return (0, $gXNCa$tbrowsecore.maximalExcludedClades)(hostProps.tree, (leaf)=>ea.byNode.hasOwnProperty(leaf.id) || leaf.geneId === keepGeneId);
    }
    // Turning "expressed only" on also expands every branch, so the expressed
    // genes left after pruning are all in view. Done here, in the same update
    // as the toggle, rather than by a second viewer action that would race it.
    expandOnExpressedOnly(prev, next) {
        const was = !!(prev && prev.zoneStates && prev.zoneStates.expression && prev.zoneStates.expression.expressedOnly);
        const is = !!(next && next.zoneStates && next.zoneStates.expression && next.zoneStates.expression.expressedOnly);
        return !was && is ? {
            ...next,
            collapsedNodeIds: []
        } : next;
    }
    // Seed the bundle with a pivot-computed initial tbrowse view state once the
    // loader has the tree and the user is actually looking at the tbrowse
    // viewer, from lifecycle (not render) to avoid dispatching mid-render. The
    // dispatch lands synchronously in the per-gene slice, so the slice check is
    // the dedupe. buildInitialViewState is the same routine the chassis runs in
    // uncontrolled mode (each zone's fr-share, initial visibility, default
    // per-zone state); the pivot is computed for THIS gene — the loader is
    // shared by every gene of the tree, so its own pivot may be another gene's.
    // After a tree switch the seed starts from the previous tree's state instead,
    // minus its node ids, so the zones and display settings stay as they were.
    maybeSeedTbrowseViewState() {
        if (this.getViewer() !== 'tbrowse') return;
        if (this.getHomologySlice().tbrowse) return;
        if (!this.gene) return;
        // The live snapshot, not the mirrored one: right after a tree switch the
        // loader has already restarted but state.snap still holds the old tree.
        const snap = this.loader.getSnapshot();
        const ref = this.selectedTreeRef(this.gene);
        if (!ref || snap.status !== 'ready' || !snap.tree || !snap.root || snap.root.meta.treeId !== ref.id) return;
        const zones = this.getTbrowseZones();
        const carry = this.getHomologySlice().tbrowseCarry;
        const base = carry ? (0, $gXNCa$tbrowsecore.ensureZones)($64fad37f770d2bfe$var$carryViewState(carry), zones) : (0, $gXNCa$tbrowsecore.buildInitialViewState)(zones);
        this.setTbrowseViewState((0, $gXNCa$tbrowsecore.applyPivot)(base, (0, $gXNCa$tbrowsecore.computePivotState)(snap.tree, this.gene._id)));
    }
    componentDidMount() {
        this._unsubscribe = this.loader.subscribe(()=>this.setState({
                snap: this.loader.getSnapshot()
            }));
        this.maybeStartLoader();
        this.maybeSeedTbrowseViewState();
    }
    componentDidUpdate() {
        this.maybeStartLoader();
        this.maybeSeedTbrowseViewState();
    }
    componentWillUnmount() {
        if (this._unsubscribe) this._unsubscribe();
        this.loader.dispose();
    }
    // Start the loader (or restart it when the gene's tree changes) from
    // lifecycle, not render. Gated on the user actually being on the tbrowse
    // viewer + the tree doc being loaded — otherwise we'd pay network cost for
    // genes the user never looks at. The stored genetree doc is handed over as
    // `rawGenetree`, so the source makes no /genes or /genetrees request of its
    // own (docs.js's taxon-name rewrite stays upstream); the neighborhood,
    // gene-structure and expression slots are the only fetches, and the loader
    // retries their transient failures with backoff.
    maybeStartLoader() {
        if (this.getViewer() !== 'tbrowse') return;
        const id = this.getGeneId();
        if (!this.props.geneDocs.hasOwnProperty(id)) return;
        const gene = this.props.geneDocs[id];
        // The selected tree: gene_tree, or a clade tree set (homology.wheat,
        // homology.oat, …); none for genes with homologues but no tree. A switch
        // restarts the loader (new generation, the old slots are aborted).
        const ref = this.selectedTreeRef(gene);
        if (!ref) return;
        const treeId = ref.id;
        const raw = this.props.grameneTrees[treeId];
        if (!raw || !raw.taxon_id) return;
        const key = `${ref.field}:${treeId}`;
        if (this._loaderStartedFor === key) return;
        this._loaderStartedFor = key;
        this.loader.start({
            base: this.props.grameneAPI,
            treeId: treeId,
            treeField: ref.field,
            geneId: gene._id,
            rawGenetree: raw,
            // Only pay for gene-structure data when the genome zone is enabled; the
            // request shape (50 ids per /genes call, no fl) is what this tab has
            // always sent.
            geneStructures: this.isGenomeZoneEnabled(),
            geneStructureChunkSize: 50,
            geneStructureFl: null,
            // Same for the per-gene expression attributes zone.
            expression: this.isExpressionZoneEnabled()
        });
    }
    startResize(e) {
        e.preventDefault();
        const startY = e.clientY;
        const startHeight = this.getHeight();
        const onMouseMove = (moveEvent)=>{
            const newHeight = Math.max(200, startHeight + (moveEvent.clientY - startY));
            this.setHeight(newHeight);
        };
        const onMouseUp = ()=>{
            window.removeEventListener('mousemove', onMouseMove);
            window.removeEventListener('mouseup', onMouseUp);
            window.dispatchEvent(new Event('resize'));
        };
        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', onMouseUp);
    }
    renderResizeHandle() {
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
            className: "details-resize-handle",
            onMouseDown: (e)=>this.startResize(e),
            title: "Drag to resize"
        });
    }
    renderTreeVis() {
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                    className: "gene-genetree",
                    style: {
                        height: this.getHeight(),
                        width: '100%'
                    },
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($parcel$interopDefault($gXNCa$gramenegenetreevis), {
                        genetree: this.tree,
                        initialGeneOfInterest: this.gene,
                        genomesOfInterest: this.props.grameneGenomes.active,
                        taxonomy: this.taxonomy,
                        allowGeneSelection: true,
                        pivotTree: true,
                        enableCuration: false,
                        enablePhyloview: true,
                        numberOfNeighbors: 10,
                        ensemblUrl: this.props.configuration.ensemblURL
                    })
                }),
                this.renderResizeHandle()
            ]
        });
    }
    renderTBrowse() {
        const snap = this.state.snap;
        const hostProps = (0, $gXNCa$tbrowsecore.hostPropsFrom)(snap);
        // Nothing to draw until the loader has adapted the tree (one tick after
        // start(), since the stored doc needs no fetch) and the bundle slice has
        // been seeded by maybeSeedTbrowseViewState (lifecycle, not render).
        const tbrowseVS = this.getHomologySlice().tbrowse;
        // Also wait until the snapshot holds the SELECTED tree, so a switch never
        // draws the previous tree under the new selection.
        const isSelected = snap.root && this.treeRef && snap.root.meta.treeId === this.treeRef.id;
        if (!hostProps || !tbrowseVS || !isSelected) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
            className: "gene-genetree",
            style: {
                height: this.getHeight(),
                width: '100%'
            },
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Spinner, {})
        });
        // Layer the genome-limit and "expressed only" prune sets on top of the
        // user's own prunes for the controlled view state, but persist only the
        // user's prunes (the layer strips the derived ones in onViewStateChange) so
        // the bundle stays free of derived state and re-applies cleanly when the
        // filter or toggle changes.
        const pruneLayer = (0, $gXNCa$tbrowsecore.createDerivedPruneLayer)([
            ...new Set([
                ...this.getGenomePrunedIds(),
                ...this.getExpressionPrunedIds(tbrowseVS, hostProps)
            ])
        ]);
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                    className: "gene-genetree",
                    style: {
                        height: this.getHeight(),
                        width: '100%'
                    },
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$tbrowse.TBrowse, {
                        ...hostProps,
                        zones: this.getTbrowseZones(),
                        nodeOfInterest: this.gene._id,
                        viewState: pruneLayer.effective(tbrowseVS),
                        onViewStateChange: (next)=>this.setTbrowseViewState(this.expandOnExpressedOnly(tbrowseVS, pruneLayer.onChange(next))),
                        densityControls: true,
                        defaultOpenSections: {
                            zones: true,
                            search: true
                        }
                    })
                }),
                this.renderResizeHandle()
            ]
        });
    }
    renderViewerToggle() {
        const viewer = this.getViewer();
        const btn = (id, label)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                type: "button",
                onClick: ()=>this.setViewer(id),
                style: {
                    padding: '4px 10px',
                    marginRight: 4,
                    fontSize: 12,
                    border: '1px solid #ccc',
                    background: viewer === id ? '#2878dc' : '#fff',
                    color: viewer === id ? '#fff' : '#222',
                    cursor: 'pointer',
                    borderRadius: 3
                },
                children: label
            }, id);
        // A second row when the gene sits in more than one tree (e.g. a wheat
        // gene in the Compara, wheat and barley trees).
        const refs = $64fad37f770d2bfe$var$geneTreeRefs(this.gene);
        const treeBtn = (ref)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                type: "button",
                title: ref.id,
                onClick: ()=>this.setTree(ref.field),
                style: {
                    padding: '4px 10px',
                    marginRight: 4,
                    fontSize: 12,
                    border: '1px solid #ccc',
                    background: this.treeRef.field === ref.field ? '#2878dc' : '#fff',
                    color: this.treeRef.field === ref.field ? '#fff' : '#222',
                    cursor: 'pointer',
                    borderRadius: 3
                },
                children: $64fad37f770d2bfe$var$treeLabel(ref)
            }, ref.field);
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
            style: {
                margin: '8px 0'
            },
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                    children: [
                        btn('tbrowse', 'TBrowse'),
                        btn('treevis', 'TreeVis')
                    ]
                }),
                refs.length > 1 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                    className: "homology-tree-switcher",
                    style: {
                        marginTop: 6
                    },
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                            style: {
                                fontSize: 12,
                                marginRight: 6
                            },
                            children: "Gene tree:"
                        }),
                        refs.map(treeBtn)
                    ]
                })
            ]
        });
    }
    filterAllHomologs() {
        this.props.doReplaceGrameneFilters($047461923b1badda$export$964d88edb00bbcaa({
            category: 'Gene Tree',
            fq_field: this.treeRef.field,
            fq_value: this.tree._id,
            name: `Homologs of ${this.gene.name}`
        }));
    }
    filterOrthologs() {
        this.props.doReplaceGrameneFilters($047461923b1badda$export$964d88edb00bbcaa({
            category: 'Gene Tree',
            fq_field: 'homology__all_orthologs',
            fq_value: this.gene._id,
            name: `Orthologs of ${this.gene.name}`
        }));
    }
    filterParalogs() {
        this.props.doReplaceGrameneFilters($047461923b1badda$export$964d88edb00bbcaa({
            category: 'Gene Tree',
            fq_field: 'homology__within_species_paralog',
            fq_value: this.gene._id,
            name: `Paralogs of ${this.gene.name}`
        }));
    }
    searchSupertree() {
        this.props.doReplaceGrameneFilters($047461923b1badda$export$964d88edb00bbcaa({
            category: 'Gene Tree',
            fq_field: 'supertree_attr_s',
            fq_value: this.gene.homology.supertree,
            name: this.gene.homology.supertree
        }));
    }
    orthologList() {
        return this.orthoParaList('ortholog');
    }
    paralogList() {
        return this.orthoParaList('within_species_paralog');
    }
    orthoParaList(type) {
        var homology, thisGeneId;
        homology = $parcel$interopDefault($gXNCa$lodash).get(this.gene, 'homology.homologous_genes');
        thisGeneId = this.gene._id;
        if (homology) {
            var homologs = $parcel$interopDefault($gXNCa$lodash)(homology).pickBy(function filterCategories(thing, name) {
                return name.indexOf(type) === 0;
            }).values().flatten().uniq().value();
            if (!$parcel$interopDefault($gXNCa$lodash).isEmpty(homologs)) {
                if (!homologs.includes(thisGeneId)) {
                    console.log("add to homologs list", thisGeneId);
                    homologs.push(thisGeneId);
                }
                return homologs; // only return something if we have something. We're testing for truthiness later.
            }
        }
    }
    explorations() {
        let x = this.tree ? [
            {
                name: 'Homologs',
                category: 'Gene Tree',
                count: this.tree.geneCount,
                handleClick: this.filterAllHomologs.bind(this)
            }
        ] : [];
        if (this.orthologs) x.push({
            name: 'Orthologs',
            category: 'Gene Tree',
            count: this.orthologs.length,
            handleClick: this.filterOrthologs.bind(this)
        });
        if (this.paralogs) x.push({
            name: 'Paralogs',
            category: 'Gene Tree',
            count: this.paralogs.length,
            handleClick: this.filterParalogs.bind(this)
        });
        if (this.gene.homology.supertree) x.push({
            name: `Supertree`,
            category: `Gene Tree`,
            count: this.gene.homology.supertree,
            handleClick: this.searchSupertree.bind(this)
        });
        return x;
    }
    links() {
        let links = [
            {
                name: 'Ensembl Gene Tree view',
                url: `${this.props.configuration.ensemblURL}/${this.gene.system_name}/Gene/Compara_Tree?g=${this.gene._id}`
            }
        ];
        if (this.props.curation && this.props.curation.taxa.hasOwnProperty(this.gene.taxon_id)) links.push({
            name: 'Curate',
            url: this.props.curation.url + this.gene._id
        });
        return links;
    }
    render() {
        const id = this.props.searchResult.id;
        if (!this.props.geneDocs.hasOwnProperty(id)) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Spinner, {});
        this.gene = this.props.geneDocs[id];
        this.treeRef = this.selectedTreeRef(this.gene);
        // Recomputed below only once the selected tree has loaded, so a switch to
        // a tree still in flight never draws the previous one.
        this.tree = undefined;
        if (!this.treeRef) {
            // Homologues but no tree (some pan-genome assemblies): offer the
            // ortholog/paralog searches instead of a phylogram.
            this.tree = undefined;
            this.orthologs = this.orthologList();
            this.paralogs = this.paralogList();
            const explorations = this.explorations();
            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($5c2c79352d3d7b81$export$47eb42ff093406d4, {
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($5c2c79352d3d7b81$export$393edc798c47379d, {
                        children: "No gene tree is available for this gene."
                    }, "description"),
                    explorations.length > 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($5c2c79352d3d7b81$export$900f1bfcd1cb6476, {
                        explorations: explorations
                    }, "explore"),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($5c2c79352d3d7b81$export$b2e089eb3692b073, {
                        links: this.links()
                    }, "links")
                ]
            });
        }
        const treeId = this.treeRef.id;
        if (!this.props.grameneTrees.hasOwnProperty(treeId)) this.props.doRequestGrameneTree(treeId);
        else {
            const tree = this.props.grameneTrees[treeId];
            if (tree.hasOwnProperty('taxon_id')) {
                this.tree = $parcel$interopDefault($gXNCa$gramenetreesclientsrcgenetree).tree([
                    this.props.grameneTrees[treeId]
                ]);
                this.orthologs = this.orthologList();
                this.paralogs = this.paralogList();
            }
        }
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($5c2c79352d3d7b81$export$47eb42ff093406d4, {
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($5c2c79352d3d7b81$export$393edc798c47379d, {
                    children: "This phylogram shows the relationships between this gene and others similar to it, as determined by Ensembl Compara."
                }, "description"),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($5c2c79352d3d7b81$export$7c6e2c02157bb7d2, {
                    children: [
                        this.renderViewerToggle(),
                        !this.tree ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Spinner, {}) : this.getViewer() === 'tbrowse' ? this.renderTBrowse() : this.renderTreeVis()
                    ]
                }, "content"),
                this.tree && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($5c2c79352d3d7b81$export$900f1bfcd1cb6476, {
                    explorations: this.explorations()
                }, "explore"),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($5c2c79352d3d7b81$export$b2e089eb3692b073, {
                    links: this.links()
                }, "links")
            ]
        });
    }
}
var $64fad37f770d2bfe$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)('selectGrameneTaxonomy', 'selectGrameneTrees', 'selectGrameneGenomes', 'selectGrameneAPI', 'selectConfiguration', 'selectCuration', 'selectUiViewState', 'doRequestGrameneTree', 'doSetHomologyViewer', 'doSetHomologyHeight', 'doSetHomologyTbrowseViewState', 'doSetHomologyTree', 'doAcceptGrameneSuggestion', 'doReplaceGrameneFilters', $64fad37f770d2bfe$var$Homology);
// var ensemblREST = require('../../../../../package.json').gramene.ensemblREST;
//const ensemblREST = 'http://data.gramene.org/ensembl63';
// const ensemblREST = 'https://data.sorghumbase.org/ensembl2';
// const ensemblREST = 'https://data.gramene.org/vitis-ensembl1';
// const ensemblREST = 'https://data.gramene.org/pansite-ensembl';
// calculate this once.
const $569586cb7d303e26$var$PREFIX = '/static/gramene-dalliance/';
class $569586cb7d303e26$export$2e2bcd8739ae039 extends $parcel$interopDefault($gXNCa$react).Component {
    constructor(props){
        super(props);
        this.initialVisibleRange = props.visibleRange;
    }
    shouldComponentUpdate(newProps) {
        // should we reset the view to initial state?
        if ($parcel$interopDefault($gXNCa$lodashisEqual)(newProps.visibleRange, this.initialVisibleRange)) this.browser.setLocation(newProps.visibleRange.chr, newProps.visibleRange.start, newProps.visibleRange.end);
        return false;
    }
    biodallianceElementId() {
        return this.props.gene._id + 'Browser';
    }
    browser() {
        var g, view, start, end, browser;
        g = this.props.gene;
        view = this.props.visibleRange;
        start = view.start;
        end = view.end;
        this.browser = browser = new Browser({
            pageName: this.biodallianceElementId(),
            chr: g.location.region,
            viewStart: start,
            viewEnd: end,
            cookieKey: g._id + 'BrowserCookie',
            prefix: $569586cb7d303e26$var$PREFIX,
            coordSystem: {
                speciesName: g.system_name,
                taxon: g.taxon_id,
                auth: 'Gramene',
                version: '3',
                ucscName: 'IRGSP-1.0'
            },
            sources: [
                {
                    name: 'DNA',
                    ensemblURI: this.props.config.ensemblRest,
                    species: g.system_name,
                    tier_type: 'sequence'
                },
                {
                    name: 'Genes',
                    uri: this.props.config.ensemblRest,
                    tier_type: 'ensembl',
                    species: g.system_name,
                    type: [
                        'gene',
                        'transcript',
                        'exon',
                        'cds'
                    ]
                }
            ],
            // hubs: ['/Track_Hubs/DRP000315/hub.txt'],
            disablePoweredBy: true,
            setDocumentTitle: false,
            noDefaultLabels: true,
            noPersist: true,
            noPersistView: true,
            maxWorkers: 2,
            noTitle: true,
            noLocationField: false,
            noLeapButtons: true,
            noZoomSlider: false,
            noTrackAdder: true,
            noTrackEditor: true,
            noExport: true,
            noOptions: true,
            noHelp: true,
            maxViewWidth: 1000000
        });
        browser.addViewListener(this.props.onViewChange);
    }
    cancel() {
        if (typeof this.timeoutID == "number") {
            window.clearTimeout(this.timeoutID);
            delete this.timeoutID;
        }
    }
    componentDidMount() {
        // this.browser();
        this.cancel();
        var self = this;
        this.timeoutID = window.setTimeout(function() {
            self.browser();
        }, 0);
    }
    componentWillUnmount() {
        this.cancel();
    }
    render() {
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
            id: this.biodallianceElementId()
        });
    }
} // DallianceBrowser.propTypes = {
//   gene: React.PropTypes.object.isRequired,
//   visibleRange: React.PropTypes.object.isRequired,
//   expanded: React.PropTypes.bool,
//   onViewChange: React.PropTypes.func.isRequired
// };
class $c7afec6772421270$export$2e2bcd8739ae039 extends $parcel$interopDefault($gXNCa$react).Component {
    constructor(props){
        super(props);
    }
    render() {
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
            className: "location-browser",
            style: {
                position: 'relative',
                overflow: 'hidden'
            },
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($569586cb7d303e26$export$2e2bcd8739ae039, {
                ...this.props,
                expanded: !!this.props.closeModal
            })
        });
    }
} // Browser.propTypes = {
//   gene: React.PropTypes.object.isRequired,
//   expanded: React.PropTypes.bool,
//   visibleRange: React.PropTypes.object.isRequired,
//   onViewChange: React.PropTypes.func.isRequired
// };
class $264d7db426cab787$var$Location extends $parcel$interopDefault($gXNCa$react).Component {
    constructor(props){
        super(props);
        this.gene = this.props.geneDocs[this.props.searchResult.id];
        this.initRegion();
        this.state = {
            visibleRange: this.initVisibleRange()
        };
    }
    initVisibleRange() {
        var location, span, padding, result;
        location = this.gene.location;
        if (!location) throw new Error(`Could not find the location of the gene in props.`);
        span = location.end - location.start + 1;
        padding = Math.floor(.1 * span);
        result = {
            chr: location.region,
            start: location.start - padding,
            end: location.end + padding
        };
        result.displayName = `${result.chr}:${result.start}-${result.end}`;
        return result;
    }
    initRegion() {
        var region, isChromosome, regionType, regionName;
        region = this.gene.location.region;
        if (region) {
            isChromosome = /^\d+$/.test(region);
            if (isChromosome) {
                regionType = 'chromosome';
                regionName = 'Chromosome ' + region;
            } else {
                regionType = 'scaffold';
                regionName = region;
            }
            this.region = {
                isChromsome: isChromosome,
                name: regionName,
                type: regionType
            };
        }
    }
    handleViewChange(chr, start, end) {
        var visibleRange = {
            chr: chr,
            start: start,
            end: end,
            displayName: `${chr}:${start}-${end}`
        };
        if (!$parcel$interopDefault($gXNCa$lodashisEqual)(visibleRange, this.state.visibleRange)) this.setState({
            visibleRange: visibleRange
        });
    }
    updateQuery(restrictToVisibleRange) {
        var location, geneName, visibleRange, filter, filterDisplayName, fq;
        location = this.gene.location;
        geneName = this.gene.name;
        // category: 'Gene Tree',
        //   fq_field: 'gene_tree',
        //   fq_value: this.tree._id,
        //   name: `Homologs of ${this.gene.name}`
        let terms = [
            {
                category: "Map",
                name: location.map,
                fq_field: 'map',
                fq_value: location.map
            },
            {
                category: "Region",
                name: location.region,
                fq_field: 'region',
                fq_value: location.region
            }
        ];
        fq = `map:${location.map} AND region:${location.region}`;
        if (restrictToVisibleRange) {
            visibleRange = this.state.visibleRange;
            terms.push({
                category: "Interval",
                name: `${visibleRange.start}-${visibleRange.end}`,
                fq_field: 'start',
                fq_value: `[${visibleRange.start} TO ${visibleRange.end}]`
            });
            fq += ` AND (start:[${visibleRange.start} TO ${visibleRange.end}]` + ` OR end:[${visibleRange.start} TO ${visibleRange.end}])`;
            filterDisplayName = visibleRange.displayName;
        } else filterDisplayName = "Shares " + this.region.type + " with " + geneName;
        console.log("User asked to filter by location");
        filter = {
            category: 'Location',
            id: fq,
            fq: fq,
            display_name: filterDisplayName
        };
        // QueryActions.removeAllFilters();
        // QueryActions.setFilter(filter);
        this.props.doAddGrameneRangeQuery(terms);
        if (this.props.closeModal) this.props.closeModal();
    }
    explorations() {
        var visible, result;
        visible = this.state.visibleRange;
        result = [
            {
                name: `All on ${this.region.name}`,
                handleClick: ()=>this.updateQuery(false)
            }
        ];
        if (visible) result.push({
            name: `All within ${$parcel$interopDefault($gXNCa$lodashget)(visible, 'displayName')}`,
            handleClick: ()=>this.updateQuery(true)
        });
        return result;
    }
    links() {
        function jgiify(id) {
            return id.replace('SORBI_3', 'Sobic.').replace(/\.v[0-9]\.[0-9]$/, '');
        }
        var gene = this.gene;
        let links = [
            {
                name: 'Ensembl Browser',
                url: `${this.props.config.ensemblURL}/${gene.system_name}/Gene/Summary?g=${gene._id}`
            }
        ];
        if (gene.annotations.taxonomy.ancestors.includes(4557)) links.push({
            name: 'Phytozome',
            url: `https://phytozome-next.jgi.doe.gov/report/gene/Sbicolor_v5_1/${jgiify(gene._id)}`
        });
        if (gene.taxon_id === 3702) links.push({
            name: 'tair',
            url: `https://www.arabidopsis.org/servlets/TairObject?name=${gene._id}&type=locus`
        }, {
            name: 'ThaleMine',
            url: `https://bar.utoronto.ca/thalemine/keywordSearchResults.do?searchTerm=${gene._id}&searchSubmit=search`
        });
        if (gene.taxon_id === 39947) links.push({
            name: 'RAP-DB',
            url: `https://rapdb.dna.affrc.go.jp/locus/?name=${gene._id}`
        });
        const isMaize = new RegExp(/^Zm[0-9]+/);
        if (isMaize.test(gene._id)) links.push({
            name: 'MaizeGDB',
            url: `http://www.maizegdb.org/gene_center/gene/${gene._id}`
        });
        return links;
    }
    render() {
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($5c2c79352d3d7b81$export$47eb42ff093406d4, {
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($5c2c79352d3d7b81$export$393edc798c47379d, {
                    children: [
                        "Currently viewing: ",
                        this.renderLocation(),
                        "\xa0",
                        this.renderResetButton()
                    ]
                }, "description"),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($5c2c79352d3d7b81$export$7c6e2c02157bb7d2, {
                    children: this.renderBrowser()
                }, "content"),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($5c2c79352d3d7b81$export$900f1bfcd1cb6476, {
                    explorations: this.explorations()
                }, "explore"),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($5c2c79352d3d7b81$export$b2e089eb3692b073, {
                    links: this.links()
                }, "links")
            ]
        });
    }
    renderBrowser() {
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($c7afec6772421270$export$2e2bcd8739ae039, {
            gene: this.gene,
            ...this.props,
            ...this.state,
            onViewChange: this.handleViewChange.bind(this)
        });
    }
    renderGenePosition() {
        var location = this.gene.location;
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
            className: "location",
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    className: "region",
                    children: this.region.name
                }),
                ":",
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    className: "start",
                    children: location.start
                }),
                "-",
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    className: "end",
                    children: location.end
                })
            ]
        });
    }
    renderLocation() {
        var location = this.state.visibleRange;
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
            className: "location",
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    className: "region",
                    children: location.chr
                }),
                ":",
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    className: "start",
                    children: location.start
                }),
                "-",
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    className: "end",
                    children: location.end
                })
            ]
        });
    }
    resetVisibleRange() {
        const { chr: chr, start: start, end: end } = this.initVisibleRange();
        this.handleViewChange(chr, start, end);
    }
    renderResetButton() {
        // let active=isEqual(this.props.visibleRange, this.state.visibleRange);
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
            size: "sm",
            variant: "outline-dark",
            onClick: ()=>this.resetVisibleRange(),
            children: "Reset"
        });
    }
}
var $264d7db426cab787$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)('doAddGrameneRangeQuery', $264d7db426cab787$var$Location);
const $54c74a4689d5a778$var$reactomeURL = "https://plantreactome.gramene.org";
// The Reactome Diagram library is GWT-compiled and uses a single shared
// GWT iframe + window globals — multiple Reactome.Diagram instances on
// the same page step on each other. We work around this by rendering
// each pathway diagram inside its own <iframe>, so each gets its own
// document + window + Reactome global. The iframe communicates with
// the parent through postMessage.
function $54c74a4689d5a778$var$buildIframeSrcDoc() {
    const proxy = JSON.stringify($54c74a4689d5a778$var$reactomeURL);
    return `<!DOCTYPE html>
<html><head>
  <style>html,body{margin:0;padding:0;height:100%;width:100%;overflow:hidden;}</style>
  <script async src="${$54c74a4689d5a778$var$reactomeURL}/DiagramJs/diagram/diagram.nocache.js"><\/script>
</head><body>
  <div id="holder" style="width:100%;height:100%;"></div>
  <script>
  (function(){
    var diagram = null;
    var loadedPathway = null;
    var pendingPathwayId = null;
    var pendingReactionId = null;
    var pendingFlag = null;
    var resizeTimer = null;

    function dimensions() {
      return [
        Math.max(100, document.body.clientWidth),
        Math.max(100, document.body.clientHeight)
      ];
    }

    function whenReady(cb) {
      if (window.Reactome && window.Reactome.Diagram) cb();
      else setTimeout(function(){ whenReady(cb); }, 100);
    }

    function applyLoad() {
      if (!pendingPathwayId) return;
      whenReady(function(){
        if (diagram) {
          try { diagram.detach(); } catch(e) {}
        }
        var dims = dimensions();
        diagram = window.Reactome.Diagram.create({
          proxyPrefix: ${proxy},
          placeHolder: 'holder',
          width: dims[0],
          height: dims[1]
        });
        var pw = pendingPathwayId;
        diagram.loadDiagram(pw);
        diagram.onDiagramLoaded(function(){
          loadedPathway = pw;
          if (pendingFlag) diagram.flagItems(pendingFlag);
          if (pendingReactionId) diagram.selectItem(pendingReactionId);
        });
      });
    }

    window.addEventListener('message', function(e){
      var data = e.data;
      if (!data || typeof data !== 'object') return;
      if (data.type === 'load') {
        pendingPathwayId = data.pathwayId || null;
        pendingReactionId = data.reactionId || null;
        if (data.flag) pendingFlag = data.flag;
        applyLoad();
      } else if (data.type === 'select') {
        pendingReactionId = data.id || null;
        if (diagram && loadedPathway) {
          if (data.id) diagram.selectItem(data.id);
          else diagram.resetSelection();
        }
      }
    });

    window.addEventListener('resize', function(){
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function(){
        if (loadedPathway) applyLoad();
      }, 300);
    });
  })();
  <\/script>
</body></html>`;
}
class $54c74a4689d5a778$var$Pathways extends $parcel$interopDefault($gXNCa$react).Component {
    constructor(props){
        super(props);
        this.taxonomy = $parcel$interopDefault($gXNCa$gramenetreesclientsrctaxonomy).tree(Object.values(props.grameneTaxonomy));
        this.gene = props.geneDocs[props.searchResult.id];
        this.iframeRef = $parcel$interopDefault($gXNCa$react).createRef();
        // srcDoc is constant — the per-instance pathway/reaction state is
        // pushed in via postMessage so changing pathway doesn't reload the
        // GWT script.
        this._iframeSrcDoc = $54c74a4689d5a778$var$buildIframeSrcDoc();
        this._iframeReady = false;
        this.state = {
            treeVisible: true,
            height: 500,
            currentPathwayId: null,
            currentReactionId: null
        };
    }
    postLoad() {
        const win = this.iframeRef.current && this.iframeRef.current.contentWindow;
        if (!win || !this.state.currentPathwayId) return;
        win.postMessage({
            type: 'load',
            pathwayId: this.state.currentPathwayId,
            reactionId: this.state.currentReactionId,
            flag: this.gene._id
        }, '*');
    }
    postSelect() {
        const win = this.iframeRef.current && this.iframeRef.current.contentWindow;
        if (!win) return;
        win.postMessage({
            type: 'select',
            id: this.state.currentReactionId || null
        }, '*');
    }
    handleIframeLoad = ()=>{
        this._iframeReady = true;
        if (this.state.currentPathwayId) this.postLoad();
    };
    startResize(e) {
        e.preventDefault();
        const startY = e.clientY;
        const startHeight = this.state.height;
        const onMouseMove = (moveEvent)=>{
            const newHeight = Math.max(200, startHeight + (moveEvent.clientY - startY));
            this.setState({
                height: newHeight
            });
        };
        const onMouseUp = ()=>{
            window.removeEventListener('mousemove', onMouseMove);
            window.removeEventListener('mouseup', onMouseUp);
        };
        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', onMouseUp);
    }
    toggleTree() {
        this.setState({
            treeVisible: !this.state.treeVisible
        });
    }
    stableId(dbId) {
        if (dbId === undefined || dbId === null) return null;
        let prefix = this.taxonomy.indices.id[this.gene.taxon_id].model.reactomePrefix || 'OSA';
        return `R-${prefix}-${dbId}`;
    }
    loadDiagram(pathwayId, reactionId) {
        this.setState({
            currentPathwayId: pathwayId,
            currentReactionId: reactionId || null
        });
    }
    componentDidMount() {
        // If pathway docs are already cached, build the hierarchy now so the
        // initial render selects a default node (componentDidUpdate would
        // otherwise never run if no redux change follows the mount).
        if (!this.state.hierarchy && !this.state.hierarchyEmpty && this.pathwayIds) {
            const haveDocs = this.pathwayIds.filter((id)=>this.props.gramenePathways.hasOwnProperty(id));
            if (haveDocs.length === this.pathwayIds.length) {
                const docs = this.pathwayIds.map((id)=>this.props.gramenePathways[id]);
                this.getHierarchy(this.makeTaxonSpecific(docs, this.gene.taxon_id));
            }
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.hierarchy && !this.state.selectedNode) {
            let node = this.state.hierarchy[0];
            let path = [
                0
            ];
            while(node.nodes){
                path.push(0);
                node = node.nodes[0];
            }
            this.loadNodes(path);
        }
        if (!this.state.hierarchy && !this.state.hierarchyEmpty && this.pathwayIds) {
            const haveDocs = this.pathwayIds.filter((id)=>this.props.gramenePathways.hasOwnProperty(id));
            if (haveDocs.length === this.pathwayIds.length) {
                const docs = this.pathwayIds.map((id)=>this.props.gramenePathways[id]);
                this.getHierarchy(this.makeTaxonSpecific(docs, this.gene.taxon_id));
            }
        }
        if (this._iframeReady) {
            if (prevState.currentPathwayId !== this.state.currentPathwayId && this.state.currentPathwayId) this.postLoad();
            else if (prevState.currentReactionId !== this.state.currentReactionId && prevState.currentPathwayId === this.state.currentPathwayId) this.postSelect();
        }
    }
    componentWillMount() {
        const pathways = this.gene.annotations.pathways;
        if (!pathways) throw new Error("No pathway annotation present for " + this.gene._id);
        this.pathwayIds = $parcel$interopDefault($gXNCa$lodash).clone(pathways.ancestors);
        pathways.entries.forEach((reaction)=>{
            const [, , id] = reaction.id.split('-');
            this.pathwayIds.push(+id);
        });
        this.props.doRequestGramenePathways(this.pathwayIds);
    }
    makeTaxonSpecific(docs, taxon_id) {
        // Each pathway doc may carry lineage under lineage_<taxon_id> or
        // lineage_<floor(taxon_id/1000)>. Resolve per-doc rather than inferring
        // from docs[0] — when docs is heterogeneous (some species-specific, some
        // generic), inferring from the first entry leaves the rest with undefined
        // lineage and crashes getHierarchy.
        const primaryField = 'lineage_' + taxon_id;
        const fallbackField = 'lineage_' + Math.floor(taxon_id / 1000);
        return docs.map((doc)=>{
            let tsDoc = $parcel$interopDefault($gXNCa$lodash).pick(doc, [
                '_id',
                'name',
                'type'
            ]);
            tsDoc.lineage = doc[primaryField] || doc[fallbackField];
            return tsDoc;
        });
    }
    getHierarchy(docs) {
        const pathways = $parcel$interopDefault($gXNCa$lodash).keyBy(docs, '_id');
        const nodes = [];
        this.pathwayIds.forEach((pwyId)=>{
            if (pathways[pwyId]) {
                const pwy = pathways[pwyId];
                if (!pwy.lineage) return; // no lineage for this species — skip
                pwy.lineage.forEach((line)=>{
                    const parentOffset = line.length - 2;
                    nodes.push({
                        id: pwyId,
                        key: pwyId,
                        label: pwy.name,
                        type: pwy.type,
                        checkbox: false,
                        selected: false,
                        parent: parentOffset >= 0 ? line[parentOffset] : undefined
                    });
                });
            }
        });
        const nested = new ($parcel$interopDefault($gXNCa$flattonested))({
            children: 'nodes'
        }).convert(nodes);
        // An empty node list, or lineages whose top ancestor isn't itself one of
        // the gene's pathways, make flat-to-nested return a root with no id. Walking
        // that root would ask Plant Reactome for `R-<prefix>-undefined`, so treat it
        // as "nothing to show" instead.
        if (nested.id === undefined && !nested.nodes) {
            this.setState({
                hierarchy: undefined,
                hierarchyEmpty: true,
                selectedNode: undefined
            });
            return;
        }
        this.setState({
            hierarchy: [
                nested
            ],
            hierarchyEmpty: false,
            selectedNode: undefined
        });
    }
    possiblyLoadNodes(node) {
        if (!node.selected) {
            let selectedNode = this.state.selectedNode;
            if (selectedNode) selectedNode.selected = false;
            node.selected = true;
            selectedNode = node;
            if (node.type === "Pathway") this.loadDiagram(this.stableId(node.id));
            else {
                const reaction = this.stableId(node.id);
                // node.parent is a slash-delimited ancestor path supplied by
                // react-simple-tree-menu; for a root-level Reaction with no parent
                // pathway in the tree, fall back to loading the reaction directly
                // rather than crashing on undefined.split.
                const parentKey = typeof node.parent === 'string' ? node.parent.split("/").pop() : null;
                if (parentKey) this.loadDiagram(this.stableId(parentKey), reaction);
                else this.loadDiagram(reaction);
            }
            this.setState({
                selectedNode: selectedNode
            });
        }
    }
    loadNodes(nodes) {
        let hierarchy = this.state.hierarchy;
        let selectedNode = this.state.selectedNode;
        let offset = nodes.shift();
        let nodeRef = hierarchy[offset];
        let lineage = [
            nodeRef
        ];
        while(nodeRef.nodes){
            nodeRef = nodeRef.nodes[0];
            lineage.unshift(nodeRef);
        }
        if (lineage[0].id !== undefined && lineage[0].id !== 2894885) {
            let pathway = this.stableId(lineage[0].id);
            let reaction = undefined;
            if (lineage[0].type === "Reaction") {
                reaction = pathway;
                pathway = this.stableId(lineage[1].id);
            }
            if (lineage[0].selected) {
                selectedNode = undefined;
                lineage[0].selected = false;
                this.loadDiagram(pathway);
            } else {
                if (selectedNode) selectedNode.selected = false;
                selectedNode = lineage[0];
                lineage[0].selected = true;
                if (reaction) this.loadDiagram(pathway, reaction);
                else this.loadDiagram(pathway);
            }
            this.setState({
                hierarchy: hierarchy,
                selectedNode: selectedNode
            });
        }
    }
    renderHierarchy() {
        if (this.state.hierarchy) {
            const path = [];
            const allPaths = [];
            let nodes = this.state.hierarchy;
            while(nodes){
                path.push(nodes[0].key);
                allPaths.push(path.join('/'));
                nodes = nodes[0].nodes ? nodes[0].nodes : undefined;
            }
            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($parcel$interopDefault($gXNCa$reactsimpletreemenu), {
                data: this.state.hierarchy,
                hasSearch: false,
                onClickItem: (item)=>this.possiblyLoadNodes(item),
                initialActiveKey: path.join('/'),
                initialOpenNodes: allPaths
            });
        }
        if (this.state.hierarchyEmpty) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
            className: "pathways-tree-empty",
            children: [
                "No pathway hierarchy is available for ",
                this.gene.system_name || 'this genome',
                "."
            ]
        });
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Spinner, {});
    }
    updateQuery() {
        this.props.doAcceptGrameneSuggestion({
            category: 'Plant Reactome',
            fq_field: 'pathways__ancestors',
            fq_value: this.state.selectedNode.id,
            name: this.state.selectedNode.label
        });
    }
    render() {
        let reactomeLink, searchFilter;
        if (this.state.selectedNode) {
            const xrefLUT = $parcel$interopDefault($gXNCa$lodash).keyBy(this.gene.xrefs, 'db');
            const links = [
                {
                    name: 'Plant Reactome ' + this.state.selectedNode.type,
                    url: `${$54c74a4689d5a778$var$reactomeURL}/content/detail/${this.stableId(this.state.selectedNode.id)}`
                }
            ];
            if (xrefLUT.hasOwnProperty('notGramene_Plant_Reactome')) links.push({
                name: 'Plant Reactome Gene',
                url: `${$54c74a4689d5a778$var$reactomeURL}/content/detail/${xrefLUT.notGramene_Plant_Reactome.ids[0]}`
            });
            reactomeLink = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($5c2c79352d3d7b81$export$b2e089eb3692b073, {
                links: links
            }, "links");
            const filters = [
                {
                    name: `All genes in this ${this.state.selectedNode.type}`,
                    handleClick: ()=>this.updateQuery()
                }
            ];
            searchFilter = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($5c2c79352d3d7b81$export$900f1bfcd1cb6476, {
                explorations: filters
            }, "explore");
        }
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
            className: "pathways-container",
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                    className: "pathways-layout",
                    style: {
                        height: this.state.height
                    },
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                            className: "pathways-tree-toggle",
                            onClick: ()=>this.toggleTree(),
                            title: this.state.treeVisible ? 'Hide pathway hierarchy' : 'Show pathway hierarchy',
                            children: this.state.treeVisible ? "\u25C0" : "\u25B6"
                        }),
                        this.state.treeVisible && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                            className: "pathways-tree-panel",
                            children: this.renderHierarchy()
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                            className: "pathways-diagram-panel",
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("iframe", {
                                ref: this.iframeRef,
                                onLoad: this.handleIframeLoad,
                                srcDoc: this._iframeSrcDoc,
                                title: "Pathway diagram",
                                style: {
                                    width: '100%',
                                    height: '100%',
                                    border: 0,
                                    display: 'block'
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                    className: "pathways-resize-handle",
                    onMouseDown: (e)=>this.startResize(e),
                    title: "Drag to resize"
                }),
                searchFilter,
                reactomeLink
            ]
        });
    }
}
var $54c74a4689d5a778$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)('selectGrameneTaxonomy', 'selectGramenePathways', 'doRequestGramenePathways', 'doAcceptGrameneSuggestion', $54c74a4689d5a778$var$Pathways);
// Grid row height. Overrides the ag-theme-quartz default (42px) via the
// `rowHeight` prop, and drives the container height calc below so the two
// can't drift apart.
const $283508ffcf8a47c4$var$ROW_HEIGHT = 36;
// Header allowance in the container height calc (quartz header ≈ 49px).
const $283508ffcf8a47c4$var$HEADER_HEIGHT_ALLOWANCE = 50;
// Compact "Search" button so it sits comfortably inside a ROW_HEIGHT row —
// react-bootstrap's `size="sm"` alone is ~31px, which crowds a 36px row.
// Bump padding/fontSize here if the button should be taller.
const $283508ffcf8a47c4$var$SEARCH_BUTTON_STYLE = {
    whiteSpace: 'nowrap',
    lineHeight: 1.4,
    padding: '1px 8px',
    fontSize: 12
};
const $283508ffcf8a47c4$var$ggURL = {
    xIRRI: 'https://gringlobal.irri.org/gringlobal/accessiondetail?id=',
    IRRI: 'https://www.irri.org/genesys-rice#/a/',
    ARS: 'https://npgsweb.ars-grin.gov/gringlobal/accessiondetail.aspx?id=',
    ICRISAT: 'https://genebank.icrisat.org/IND/PassportSummary?ID=',
    sorbmutdb: 'https://www.depts.ttu.edu/igcast/sorbmutdb.php',
    maizeGDB: 'https://wgs.maizegdb.org/',
    NCBI: 'https://www.ncbi.nlm.nih.gov/biosample/?term='
};
const $283508ffcf8a47c4$var$rice_studies = {
    '1': {
        label: 'Rice 3K',
        type: 'NAT'
    }
};
const $283508ffcf8a47c4$var$AccessionLink = ({ germplasm: germplasm, gene_id: gene_id })=>{
    const genebank = germplasm.stock_center;
    const url = $283508ffcf8a47c4$var$ggURL[genebank];
    if (germplasm.germplasm_dbid) {
        const germ_id = germplasm.germplasm_dbid;
        if (germ_id && url && germ_id !== "0") return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("a", {
            target: "_blank",
            href: `${url}${germ_id}`,
            children: [
                germplasm.pub_id,
                " (",
                genebank,
                ")"
            ]
        });
    }
    if (genebank === "sorbmutdb") return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("form", {
        id: germplasm.pub_id,
        action: url,
        method: "post",
        target: "_blank",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
                type: "hidden",
                name: "search",
                value: gene_id.replace('SORBI_3', 'Sobic.')
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
                type: "hidden",
                name: "submit",
                value: "Search"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                type: "submit",
                className: "button-like-link",
                children: "SorbMutDB"
            })
        ]
    });
    if (germplasm.pop_id === '15' && germplasm.stock_center === 'NOT FOUND') return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("a", {
        target: "_blank",
        href: $283508ffcf8a47c4$var$ggURL['maizeGDB'],
        children: [
            germplasm.pub_id,
            " (SNPVersity)"
        ]
    });
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
        children: germplasm.pub_id
    });
};
function $283508ffcf8a47c4$var$compareGermplasm(a, b) {
    const aSub = a?.germplasm?.subpop ?? '';
    const bSub = b?.germplasm?.subpop ?? '';
    const subCmp = aSub.localeCompare(bSub, 'en', {
        sensitivity: 'accent'
    });
    if (subCmp !== 0) return subCmp;
    const aPub = a?.germplasm?.pub_id ?? '';
    const bPub = b?.germplasm?.pub_id ?? '';
    return aPub.localeCompare(bPub, 'en', {
        sensitivity: 'accent'
    });
}
function $283508ffcf8a47c4$var$group_germplasm(gene, germplasmLUT, vep_obj) {
    let accessionTable = [];
    let missingMetadata = 0;
    Object.entries(vep_obj).forEach(([key, accessions])=>{
        const parts = key.split("__");
        if (parts[0] === "VEP") {
            if (parts[1] !== "merged") {
                const studyForSystem = $49d5cbca2ec74b2f$export$428c2f647a2a7545[parts[3]];
                const pop = studyForSystem && studyForSystem[parts[4]] || {
                    label: `${parts[3]}/${parts[4]}`,
                    type: parts[4]
                };
                const conseq = parts[1].replaceAll("_", " ");
                const status = parts[2] === "het" ? "heterozygous" : "homozygous";
                accessions.forEach((ens_id)=>{
                    let germplasm;
                    if (germplasmLUT && germplasmLUT.hasOwnProperty(ens_id)) germplasm = germplasmLUT[ens_id][0];
                    else {
                        // Fall back to a minimal record so the row is still rendered with
                        // whatever info we have from the VEP fields alone.
                        missingMetadata++;
                        germplasm = {
                            ens_id: ens_id,
                            pub_id: ens_id,
                            subpop: '?',
                            stock_center: null,
                            germplasm_dbid: null,
                            pop_id: null
                        };
                    }
                    accessionTable.push({
                        key: [
                            pop.label,
                            conseq,
                            status
                        ].join('%%%'),
                        germplasm: germplasm,
                        pop: pop
                    });
                });
            }
        }
    });
    // group accessionTable by key field
    const groups = $parcel$interopDefault($gXNCa$lodash).groupBy(accessionTable, 'key');
    let grouped = [];
    let id = 0;
    Object.keys(groups).sort().forEach((group)=>{
        const [pop, conseq, status] = group.split('%%%');
        id++;
        const tally = groups[group].length;
        grouped.push({
            id: id,
            group: group,
            summary: true,
            pop: pop,
            conseq: conseq,
            status: status,
            tally: tally
        });
        groups[group].sort($283508ffcf8a47c4$var$compareGermplasm).forEach((acc)=>{
            id++;
            grouped.push({
                id: id,
                group: group,
                summary: false,
                pop: pop,
                conseq: conseq,
                status: status,
                accession: acc,
                tally: tally
            });
        });
    });
    grouped.missingMetadata = missingMetadata;
    grouped.totalAccessions = accessionTable.length;
    return grouped;
}
const $283508ffcf8a47c4$var$THRESHOLD = 5;
const $283508ffcf8a47c4$var$GridWithGroups = ({ groups: groups, gene_id: gene_id, doGrin: doGrin })=>{
    const [rowData, setRowData] = (0, $gXNCa$react.useState)(groups);
    const initialExpanded = {};
    rowData.forEach((row)=>{
        if (row.summary) initialExpanded[row.group] = row.tally < $283508ffcf8a47c4$var$THRESHOLD;
    });
    const [expandedGroups, setExpandedGroups] = (0, $gXNCa$react.useState)(initialExpanded);
    // Toggle group visibility
    const toggleGroup = (group)=>{
        setExpandedGroups((prevExpandedGroups)=>({
                ...prevExpandedGroups,
                [group]: !prevExpandedGroups[group]
            }));
    };
    // Filter the data to show/hide rows based on the expanded group state
    const getVisibleRowData = ()=>{
        const visibleRows = [];
        rowData.forEach((row)=>{
            if (row.summary) {
                if (row.tally > 1) visibleRows.push(row);
            } else if (expandedGroups[row.group]) visibleRows.push(row); // Show non-summary rows if the group is expanded
        });
        return visibleRows;
    };
    // Define columns with a custom renderer for the summary rows
    const columnDefs = [
        {
            field: 'pop',
            headerName: 'Study/Population',
            flex: 1,
            minWidth: 120,
            cellRenderer: (params)=>{
                if (params.data.summary || params.data.tally === 1) return params.value;
                return null;
            }
        },
        {
            field: 'conseq',
            headerName: 'VEP consequence',
            flex: 1,
            minWidth: 130,
            cellRenderer: (params)=>{
                if (params.data.summary || params.data.tally === 1) return params.value;
                return null;
            }
        },
        {
            field: 'status',
            headerName: 'Allele status',
            flex: 1,
            minWidth: 100,
            cellRenderer: (params)=>{
                if (params.data.summary || params.data.tally === 1) return params.value;
                return null;
            }
        },
        {
            field: 'accession',
            headerName: doGrin ? 'Order Germplasm' : 'Accession',
            flex: 1,
            minWidth: 140,
            headerComponent: (props)=>{
                return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'center'
                    },
                    children: [
                        doGrin && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("i", {
                            className: "fas fa-shopping-cart",
                            children: "\xa0"
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                            children: props.displayName
                        })
                    ]
                });
            },
            cellRenderer: (params)=>{
                if (params.value) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($283508ffcf8a47c4$var$AccessionLink, {
                    germplasm: params.value.germplasm,
                    gene_id: gene_id
                });
                if (params.data.summary) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                    onClick: ()=>toggleGroup(params.data.group),
                    children: [
                        params.data.tally,
                        " Accessions ",
                        expandedGroups[params.data.group] ? "\u25BC" : "\u25B6"
                    ]
                });
                return null;
            }
        },
        {
            field: 'synonym',
            headerName: 'Synonym',
            filter: false,
            sortable: false,
            flex: 1,
            minWidth: 110,
            cellRenderer: (params)=>{
                if (params.data.accession) return params.data.accession.germplasm.ens_id;
                return null;
            }
        },
        {
            field: 'subpop',
            headerName: 'Subpopulation',
            filter: false,
            sortable: false,
            flex: 1,
            minWidth: 110,
            cellRenderer: (params)=>{
                if (params.data.accession && params.data.accession.germplasm.subpop && params.data.accession.germplasm.subpop !== "?") return params.data.accession.germplasm.subpop;
                return null;
            }
        },
        {
            field: 'search',
            headerName: 'All LOF Genes',
            sortable: false,
            filter: false,
            flex: 1,
            minWidth: 100,
            cellRenderer: (params)=>{
                if (params.data.accession) {
                    const currentURL = new URL(window.location.href);
                    const accession = params.data.accession;
                    currentURL.search = '';
                    currentURL.searchParams.set('category', 'Germplasm');
                    currentURL.searchParams.set('fq_field', `VEP__merged__${accession.pop.type}__attr_ss`);
                    currentURL.searchParams.set('fq_value', accession.germplasm.ens_id);
                    currentURL.searchParams.set('name', accession.germplasm.ens_id);
                    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                        size: "sm",
                        style: $283508ffcf8a47c4$var$SEARCH_BUTTON_STYLE,
                        href: currentURL.toString(),
                        children: "Search"
                    });
                }
                return null;
            }
        }
    ];
    const defaultColDef = {
        sortable: true,
        filter: "agTextColumnFilter",
        cellStyle: (params)=>{
            if (params.data.summary) return {
                cursor: 'pointer'
            };
            return null;
        }
    };
    const nVisible = getVisibleRowData().length;
    const tableHeight = $283508ffcf8a47c4$var$HEADER_HEIGHT_ALLOWANCE + Math.min(nVisible, 10) * $283508ffcf8a47c4$var$ROW_HEIGHT;
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        style: {
            overflowX: "auto",
            width: "100%",
            maxWidth: "1200px"
        },
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
            className: "ag-theme-quartz",
            style: {
                height: tableHeight,
                minWidth: "810px",
                width: "100%"
            },
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$aggridreact.AgGridReact, {
                rowData: getVisibleRowData(),
                columnDefs: columnDefs,
                getRowNodeId: (data)=>data.id,
                rowHeight: $283508ffcf8a47c4$var$ROW_HEIGHT,
                defaultColDef: defaultColDef,
                // ag-grid sets `user-select: none` on cells by default, which is why
                // accession / consequence text couldn't be selected and copied.
                // `enableCellTextSelection` restores native selection; `ensureDomOrder`
                // keeps DOM order matching visual order so a multi-row copy comes out
                // as displayed rather than scrambled by row virtualization/sorting.
                //
                // NB: ag-grid's isAnimateRows() returns false whenever ensureDomOrder
                // is set, so `animateRows` was removed rather than left as dead config.
                // Correct copy order matters more here than row-slide animation; drop
                // `ensureDomOrder` and restore `animateRows={true}` to trade back.
                enableCellTextSelection: true,
                ensureDomOrder: true
            })
        })
    });
};
const $283508ffcf8a47c4$var$Detail = (props)=>{
    const gene = props.geneDocs[props.searchResult.id];
    const haveConsequences = props.grameneConsequences && props.grameneConsequences[gene._id];
    (0, $gXNCa$react.useEffect)(()=>{
        if (!haveConsequences) props.doRequestVEP(gene._id);
    }, [
        gene._id,
        haveConsequences
    ]);
    if (!haveConsequences) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("pre", {
        children: "loading"
    });
    // Render even if grameneGermplasm hasn't loaded — we'll fall back to
    // VEP-only rows so the user sees something instead of a silent empty table.
    const germplasmLUT = props.grameneGermplasm || {};
    const groups = $283508ffcf8a47c4$var$group_germplasm(gene, germplasmLUT, props.grameneConsequences[gene._id]);
    const { missingMetadata: missingMetadata, totalAccessions: totalAccessions } = groups;
    let notice = null;
    if (totalAccessions === 0) notice = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "alert alert-warning",
        style: {
            padding: '8px',
            marginTop: '8px'
        },
        children: "VEP results were found for this gene but could not be grouped into accession-level rows."
    });
    else if (missingMetadata > 0) notice = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "alert alert-info",
        style: {
            padding: '8px',
            marginTop: '8px'
        },
        children: [
            "Germplasm metadata could not be found for ",
            missingMetadata,
            " of ",
            totalAccessions,
            " accession",
            totalAccessions === 1 ? '' : 's',
            ". Affected rows show the raw accession id without stock-center links or subpopulation info."
        ]
    });
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h5", {
                children: "Predicted loss-of-function alleles were detected in these germplasm."
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                children: [
                    "Explore other variants within this gene in the ",
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("a", {
                        target: "_blank",
                        href: `${props.configuration.ensemblURL}/${gene.system_name}/Gene/Variation_Gene/Image?db=core;g=${props.searchResult.id}`,
                        children: "Variant image"
                    }),
                    " page in the Ensembl genome browser."
                ]
            }),
            notice,
            totalAccessions > 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($283508ffcf8a47c4$var$GridWithGroups, {
                groups: groups,
                gene_id: gene._id,
                doGrin: !props.configuration.hasOwnProperty('noGRIN')
            })
        ]
    });
};
var $283508ffcf8a47c4$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)('selectConfiguration', 'selectGrameneConsequences', 'selectGrameneGermplasm', 'doRequestVEP', $283508ffcf8a47c4$var$Detail);
const $b7cae39a716ca5a8$var$HOW_MANY_TO_SHOW_BY_DEFAULT = 10;
class $b7cae39a716ca5a8$var$Xref extends $parcel$interopDefault($gXNCa$react).Component {
    constructor(props){
        super(props);
        this.state = {
            showAll: false
        };
    }
    toggleShowAll() {
        this.setState({
            showAll: !this.state.showAll
        });
    }
    possiblyTruncateList(vals) {
        var ellipsis, ellipsisChar, ellipsisTitle;
        if (vals.length > $b7cae39a716ca5a8$var$HOW_MANY_TO_SHOW_BY_DEFAULT) {
            if (this.state.showAll) {
                ellipsisChar = '^ show first ' + $b7cae39a716ca5a8$var$HOW_MANY_TO_SHOW_BY_DEFAULT;
                ellipsisTitle = 'Show less';
            } else {
                ellipsisChar = "\u2026 show all (" + (vals.length - $b7cae39a716ca5a8$var$HOW_MANY_TO_SHOW_BY_DEFAULT) + ' more)';
                ellipsisTitle = 'Show more';
                vals = vals.slice(0, $b7cae39a716ca5a8$var$HOW_MANY_TO_SHOW_BY_DEFAULT);
            }
            ellipsis = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("li", {
                className: "showAll",
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("a", {
                    title: ellipsisTitle,
                    onClick: this.toggleShowAll.bind(this),
                    children: ellipsisChar
                })
            }, "showMore");
            vals.push(ellipsis);
        }
        return vals;
    }
    render() {
        var db = this.props.xref.label;
        var urlfcn = this.props.xref.url;
        var members = this.props.members.sort();
        var vals = members.map(function(item, idx) {
            var url = urlfcn(item), liClass = idx < $b7cae39a716ca5a8$var$HOW_MANY_TO_SHOW_BY_DEFAULT ? "default" : "extra";
            let external = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("small", {
                title: "This link opens a page from an external site",
                children: [
                    " ",
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("i", {
                        className: "fa fa-external-link"
                    })
                ]
            });
            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("li", {
                className: liClass,
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("a", {
                    href: url,
                    target: "_blank",
                    onClick: ()=>{
                        $parcel$interopDefault($gXNCa$reactga4).event({
                            category: "outbound link",
                            action: "follow",
                            label: item
                        });
                    },
                    children: [
                        item,
                        external
                    ]
                })
            }, idx);
        });
        vals = this.possiblyTruncateList(vals);
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                    className: "xref-name-col",
                    children: db
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                    className: "xref-value-col",
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("ol", {
                        className: "xref-id-list",
                        children: vals
                    })
                })
            ]
        });
    }
}
function $b7cae39a716ca5a8$var$formatXrefsForGene(gene) {
    if (!gene || !$parcel$interopDefault($gXNCa$lodash).isArray(gene.xrefs)) throw new Error("No xrefs for " + $parcel$interopDefault($gXNCa$lodash).get(gene._id));
    return gene.xrefs.filter((xr)=>$parcel$interopDefault($gXNCa$gramenedbxrefs).isKnown(xr.db) && xr.db !== "PUBMED").sort().map((xr, idx)=>{
        var xref = $parcel$interopDefault($gXNCa$gramenedbxrefs).fetch(xr.db);
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($b7cae39a716ca5a8$var$Xref, {
            xref: xref,
            members: xr.ids,
            source: xr.source,
            text: xr.text
        }, idx);
    });
}
const $b7cae39a716ca5a8$var$Xrefs = ({ searchResult: searchResult, geneDocs: geneDocs })=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($5c2c79352d3d7b81$export$47eb42ff093406d4, {
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($5c2c79352d3d7b81$export$f99233281efd08a0, {
                children: "Cross-references"
            }, "title"),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($5c2c79352d3d7b81$export$393edc798c47379d, {
                children: "References to this gene in other databases:"
            }, "description"),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($5c2c79352d3d7b81$export$7c6e2c02157bb7d2, {
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("table", {
                    className: "xrefs table",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("th", {
                                        className: "xref-name-col",
                                        children: "Database"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("th", {
                                        className: "xref-value-col",
                                        children: "IDs and links"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("tbody", {
                            children: $b7cae39a716ca5a8$var$formatXrefsForGene(geneDocs[searchResult.id])
                        })
                    ]
                })
            }, "content")
        ]
    });
var $b7cae39a716ca5a8$export$2e2bcd8739ae039 = $b7cae39a716ca5a8$var$Xrefs;
const $830f925242a0b007$var$HOW_MANY_TO_SHOW_BY_DEFAULT = 10;
class $830f925242a0b007$var$Xref extends $parcel$interopDefault($gXNCa$react).Component {
    constructor(props){
        super(props);
        this.state = {
            showAll: false
        };
    }
    toggleShowAll() {
        this.setState({
            showAll: !this.state.showAll
        });
    }
    possiblyTruncateList(vals) {
        var ellipsis, ellipsisChar, ellipsisTitle;
        if (vals.length > $830f925242a0b007$var$HOW_MANY_TO_SHOW_BY_DEFAULT) {
            if (this.state.showAll) {
                ellipsisChar = '^ show first ' + $830f925242a0b007$var$HOW_MANY_TO_SHOW_BY_DEFAULT;
                ellipsisTitle = 'Show less';
            } else {
                ellipsisChar = "\u2026 show all (" + (vals.length - $830f925242a0b007$var$HOW_MANY_TO_SHOW_BY_DEFAULT) + ' more)';
                ellipsisTitle = 'Show more';
                vals = vals.slice(0, $830f925242a0b007$var$HOW_MANY_TO_SHOW_BY_DEFAULT);
            }
            ellipsis = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("li", {
                className: "showAll",
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("a", {
                    title: ellipsisTitle,
                    onClick: this.toggleShowAll.bind(this),
                    children: ellipsisChar
                })
            }, "showMore");
            vals.push(ellipsis);
        }
        return vals;
    }
    render() {
        var db = this.props.xref.label;
        var urlfcn = this.props.xref.url;
        var members = this.props.members.sort();
        var vals = members.map(function(item, idx) {
            var url = urlfcn(item), liClass = idx < $830f925242a0b007$var$HOW_MANY_TO_SHOW_BY_DEFAULT ? "default" : "extra";
            let external = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("small", {
                title: "This link opens a page from an external site",
                children: [
                    " ",
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("i", {
                        className: "fa fa-external-link"
                    })
                ]
            });
            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("li", {
                className: liClass,
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("a", {
                    href: url,
                    target: "_blank",
                    onClick: ()=>{
                        $parcel$interopDefault($gXNCa$reactga4).event({
                            category: "outbound link",
                            action: "follow",
                            label: item
                        });
                    },
                    children: [
                        item,
                        external
                    ]
                })
            }, idx);
        });
        vals = this.possiblyTruncateList(vals);
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                    className: "xref-value-col",
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("ol", {
                        className: "xref-id-list",
                        children: vals
                    })
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                    className: "xref-name-col",
                    children: this.props.source
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                    className: "xref-value-col",
                    children: this.props.text
                })
            ]
        });
    }
}
function $830f925242a0b007$var$formatPubsForGene(gene) {
    if (!gene || !$parcel$interopDefault($gXNCa$lodash).isArray(gene.xrefs)) throw new Error("No xrefs for " + $parcel$interopDefault($gXNCa$lodash).get(gene._id));
    let pubs = gene.xrefs.filter((xr)=>xr.db === "PUBMED");
    if (pubs.length === 0) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("tr", {
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
            colSpan: 3,
            children: "No publications found."
        })
    });
    return pubs.sort((a, b)=>{
        if (a.source) {
            if (b.source) {
                if (a.source < b.source) return -1;
                if (a.source > b.source) return 1;
            } else return -1;
        } else if (b.source) return 1;
        if (a.db < b.db) return -1;
        if (a.db > b.db) return 1;
        return 0;
    }).map((xr, idx)=>{
        var xref = $parcel$interopDefault($gXNCa$gramenedbxrefs).fetch(xr.db);
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($830f925242a0b007$var$Xref, {
            xref: xref,
            members: xr.ids,
            source: xr.source,
            text: xr.text
        }, idx);
    });
}
const $830f925242a0b007$var$formURL = 'https://docs.google.com/forms/d/e/1FAIpQLSey-xPyTysdd9c2phXT6kcbjEDeCppG4dLG7LjZCeLpx_KGog/viewform?usp=pp_url&entry.1266455249=';
const $830f925242a0b007$var$Publications = ({ searchResult: searchResult, geneDocs: geneDocs })=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($5c2c79352d3d7b81$export$47eb42ff093406d4, {
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($5c2c79352d3d7b81$export$f99233281efd08a0, {
                children: "Curated publications"
            }, "title"),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($5c2c79352d3d7b81$export$393edc798c47379d, {
                children: "Functions described in the literature:"
            }, "description"),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($5c2c79352d3d7b81$export$7c6e2c02157bb7d2, {
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("table", {
                    className: "xrefs xrefs-pubs table",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("th", {
                                        className: "xref-10-col",
                                        children: "PubMed link"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("th", {
                                        className: "xref-10-col",
                                        children: "Curation source"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("th", {
                                        className: "xref-80-col",
                                        children: "Title/Description"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("tbody", {
                            children: $830f925242a0b007$var$formatPubsForGene(geneDocs[searchResult.id])
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("tfoot", {
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("th", {
                                    colSpan: 3,
                                    children: [
                                        "Submit a gene function ",
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("a", {
                                            target: "_blank",
                                            href: $830f925242a0b007$var$formURL + searchResult.id,
                                            children: "here"
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }, "content")
        ]
    });
var $830f925242a0b007$export$2e2bcd8739ae039 = $830f925242a0b007$var$Publications;
const $527ebc19dc92444d$var$CodeBlock = (props)=>{
    const plainFasta = `>${props.id}\n${props.seq}`;
    const [showNotification, setShowNotification] = (0, $gXNCa$react.useState)(false);
    const copyCode = ()=>{
        // Use the Clipboard API to write text to the clipboard
        navigator.clipboard.writeText(plainFasta).then(()=>{
            setShowNotification(true);
        }).catch((err)=>{
            console.error('Unable to copy to clipboard', err);
        });
    };
    (0, $gXNCa$react.useEffect)(()=>{
        if (showNotification) {
            const notificationTimeout = setTimeout(()=>{
                setShowNotification(false);
            }, 2000); // Hide the notification after 2 seconds
            return ()=>clearTimeout(notificationTimeout);
        }
    }, [
        showNotification
    ]);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "fasta-container",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("code", {
                className: "fasta",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                        className: "header",
                        children: [
                            ">",
                            props.id
                        ]
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("br", {}),
                    props.blocks.map((block, idx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                            className: block.kind,
                            children: block.seq
                        }, idx))
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("p", {
                className: "fasta-key",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                        children: "Key:"
                    }),
                    "\xa05'UTR\xa0",
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        className: "square-utr5",
                        children: "\xa0\xa0"
                    }),
                    "\xa0CDS\xa0",
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        className: "square-cds",
                        children: "\xa0\xa0"
                    }),
                    "\xa03'UTR\xa0",
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        className: "square-utr3",
                        children: "\xa0\xa0"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                className: "copy-button",
                onClick: copyCode,
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsai.AiOutlineCopy, {})
            }),
            showNotification && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "notification",
                children: "Sequence copied"
            })
        ]
    });
};
const $527ebc19dc92444d$var$decoratePeptide = (seq, transcript)=>{
    let junctions = [];
    if (transcript.exon_junctions) transcript.exon_junctions.forEach((ej, idx)=>{
        if (ej > transcript.cds.start && ej <= transcript.cds.end) junctions.push(Math.floor((ej - transcript.cds.start) / 3));
    });
    if (junctions.length === 0) return [
        {
            kind: 'cds',
            seq: seq
        }
    ];
    let offset = 0;
    let blocks = [];
    junctions.forEach((j, idx)=>{
        let kind = idx % 2 === 0 ? "cds" : "cds-other";
        blocks.push({
            kind: kind,
            seq: seq.substring(offset, j)
        });
        offset = j;
    });
    blocks.push({
        kind: junctions.length % 2 === 0 ? "cds" : "cds-other",
        seq: seq.substring(junctions.pop())
    });
    return blocks;
};
const $527ebc19dc92444d$var$decorateSeq = (geneSeq, gene, up, down, tid, mode)=>{
    // return a list of blocks with kind and seq properties
    let blocks = [];
    const transcript = gene.gene_structure.transcripts.find((tr)=>tr.id === tid);
    const offset = gene.location.strand === 1 ? gene.location.start - geneSeq.start : geneSeq.end - gene.location.end;
    if (up > 0) {
        const TSS = gene.gene_structure.exons.find((exon)=>exon.id === transcript.exons[0]).start;
        blocks.push({
            kind: 'upstream',
            seq: geneSeq.seq.substring(offset - up + TSS - 1, offset + TSS - 1).toLowerCase()
        });
    }
    // add exons and introns based on tid
    let pos_in_transcript = 0;
    let pos_in_gene = 0;
    let blockType = 'utr5';
    let extra = '';
    transcript.exons.forEach((eid, e_idx)=>{
        const exon = gene.gene_structure.exons.find((exon)=>exon.id === eid);
        if (e_idx > 0 && mode === "dna") {
            blocks.push({
                kind: 'intron',
                seq: geneSeq.seq.substring(offset + pos_in_gene, offset + exon.start - 1).toLowerCase()
            });
            pos_in_gene = exon.start - 1;
        }
        if (mode === "rna") extra = e_idx % 2 === 1 ? '-other' : '';
        let exon_length = exon.end - exon.start + 1;
        if (transcript.cds && pos_in_transcript < transcript.cds.start && pos_in_transcript + exon_length >= transcript.cds.start) {
            // CDS starts in this exon
            const utr5_len = transcript.cds.start - pos_in_transcript - 1;
            if (utr5_len > 0) {
                blocks.push({
                    kind: blockType + extra,
                    seq: geneSeq.seq.substring(offset + pos_in_gene, offset + pos_in_gene + utr5_len)
                });
                exon_length -= utr5_len;
                pos_in_gene += utr5_len;
                pos_in_transcript = transcript.cds.start - 1;
            }
            blockType = 'cds';
        }
        if (blockType === 'cds' && pos_in_transcript + exon_length >= transcript.cds.end) {
            // CDS ends in this exon
            const cds_len = transcript.cds.end - pos_in_transcript;
            if (cds_len > 0) {
                blocks.push({
                    kind: blockType + extra,
                    seq: geneSeq.seq.substring(offset + pos_in_gene, offset + pos_in_gene + cds_len)
                });
                exon_length -= cds_len;
                pos_in_gene += cds_len;
                pos_in_transcript = transcript.cds.end;
            }
            blockType = 'utr3';
        }
        if (exon_length > 0) blocks.push({
            kind: blockType + extra,
            seq: geneSeq.seq.substring(offset + pos_in_gene, offset + pos_in_gene + exon_length)
        });
        pos_in_gene = exon.end;
        pos_in_transcript += exon_length;
    });
    // check if there's more to the gene locus after end of transcript?
    // downstream is currently relative to end of transcript but upstream is relative to first TSS
    if (down > 0) blocks.push({
        kind: 'downstream',
        seq: geneSeq.seq.substring(offset + pos_in_gene, offset + pos_in_gene + down).toLowerCase()
    });
    return blocks;
};
const $527ebc19dc92444d$var$buildId = (gene, geneSeq, up, down)=>{
    let gs = gene.location.strand === 1 ? gene.location.start - up : gene.location.start - down;
    let ge = gene.location.strand === 1 ? gene.location.end + down : gene.location.end + up;
    let extras = [];
    if (gene.location.strand === -1) extras.push('reverse');
    if (up > 0) extras.push(`upstream=${up}`);
    if (down > 0) extras.push(`downstream=${down}`);
    return `${geneSeq.genome}|${gene._id}|${gene.location.region}:${gs}..${ge} ${extras.join('|')}`;
};
const $527ebc19dc92444d$var$Detail = (props)=>{
    const geneId = props.searchResult.id;
    const gene = props.geneDocs[geneId];
    // Sub-tab + selected isoform + flanking lengths live in the uiViewState
    // bundle (keyed by geneId) so the shareable-views snapshot can round-trip
    // them. Defaults match the old local-state initial values.
    const slice = props.uiViewState && props.uiViewState.byGene[geneId] && props.uiViewState.byGene[geneId].sequences || {};
    const tab = slice.tab || 'dna';
    const tid = slice.tid || gene.gene_structure.canonical_transcript;
    const upstream = slice.upstream || 0;
    const downstream = slice.downstream || 0;
    const setTab = (k)=>props.doSetSequencesState({
            geneId: geneId,
            patch: {
                tab: k
            }
        });
    const setTid = (v)=>props.doSetSequencesState({
            geneId: geneId,
            patch: {
                tid: v
            }
        });
    const setUpstream = (v)=>props.doSetSequencesState({
            geneId: geneId,
            patch: {
                upstream: +v
            }
        });
    const setDownstream = (v)=>props.doSetSequencesState({
            geneId: geneId,
            patch: {
                downstream: +v
            }
        });
    let geneSeq;
    let rnaSeq;
    let pepSeq;
    // The *_SEQUENCE_REQUESTED reducer inserts a `{}` placeholder before the
    // fetch resolves, so a key-only existence check passes while the body is
    // still empty — leading to `seq.substring` of undefined downstream. Gate
    // on the actual payload field instead.
    if (props.geneSequences && props.geneSequences[gene._id] && props.geneSequences[gene._id].seq) geneSeq = props.geneSequences[gene._id];
    else {
        props.doRequestGeneSequence(gene);
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("pre", {
            children: "loading"
        });
    }
    if (props.rnaSequences && props.rnaSequences[tid] && props.rnaSequences[tid].seq) rnaSeq = props.rnaSequences[tid];
    else {
        props.doRequestRnaSequence(tid, gene);
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("pre", {
            children: "loading"
        });
    }
    const maxUp = gene.location.strand === 1 ? gene.location.start - geneSeq.start : geneSeq.end - gene.location.end;
    const maxDown = gene.location.strand === -1 ? gene.location.start - geneSeq.start : geneSeq.end - gene.location.end;
    const transcript = gene.gene_structure.transcripts.find((tr)=>tr.id === tid);
    let tl_id;
    if (transcript.translation) {
        tl_id = transcript.translation.id;
        if (props.pepSequences && props.pepSequences[tl_id] && props.pepSequences[tl_id].seq) pepSeq = props.pepSequences[tl_id];
        else {
            props.doRequestPepSequence(tl_id, gene);
            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("pre", {
                children: "loading"
            });
        }
    }
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Tabs, {
        activeKey: tab,
        onSelect: (k)=>setTab(k),
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Tab, {
                tabClassName: "dna",
                eventKey: "dna",
                title: "Genomic sequence",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Container, {
                        style: {
                            maxWidth: '100ch',
                            marginLeft: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Row, {
                                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Col, {
                                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("i", {
                                            children: "Show flanking sequence"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                className: "flanking-guide",
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                        className: "flanking-label-left",
                                        children: "Upstream"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                        className: "horizontal-line"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                        className: "flanking-center-label",
                                        children: "Transcript (unspliced)"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                        className: "horizontal-line"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                        className: "flanking-label-right",
                                        children: "Downstream"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                        className: "flanking-value-left",
                                        children: upstream
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Form.Range, {
                                        className: "reverse-slide",
                                        style: {
                                            width: '60px'
                                        },
                                        value: upstream,
                                        onChange: (e)=>setUpstream(e.target.value),
                                        min: 0,
                                        max: maxUp,
                                        step: 10
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {}),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Form.Range, {
                                        style: {
                                            width: '60px'
                                        },
                                        value: downstream,
                                        onChange: (e)=>setDownstream(e.target.value),
                                        min: 0,
                                        max: maxDown,
                                        step: 10
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                        className: "flanking-value-right",
                                        children: downstream
                                    })
                                ]
                            }),
                            gene.gene_structure.transcripts.length > 1 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Row, {
                                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Col, {
                                    children: [
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("i", {
                                                children: "Highlight transcript"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.ButtonGroup, {
                                            children: gene.gene_structure.transcripts.sort((a, b)=>a.id.localeCompare(b.id)).map((tr, idx)=>{
                                                let v = tr.id === gene.gene_structure.canonical_transcript ? 'primary' : 'secondary';
                                                if (tr.id !== tid) v = `outline-${v}`;
                                                return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.ToggleButton, {
                                                    variant: v,
                                                    id: `radio-${idx}`,
                                                    type: "radio",
                                                    name: tr.id,
                                                    value: tr.id,
                                                    checked: tr.id === tid,
                                                    onChange: (e)=>setTid(e.currentTarget.value),
                                                    children: tr.id
                                                }, idx);
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    geneSeq && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($527ebc19dc92444d$var$CodeBlock, {
                        id: $527ebc19dc92444d$var$buildId(gene, geneSeq, +upstream, +downstream),
                        seq: geneSeq.seq.substring(maxUp - +upstream, maxUp + gene.location.end - gene.location.start + 1 + +downstream),
                        blocks: $527ebc19dc92444d$var$decorateSeq(geneSeq, gene, +upstream, +downstream, tid, "dna")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Tab, {
                tabClassName: "rna",
                eventKey: "rna",
                title: "Transcript sequence",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Container, {
                        style: {
                            width: '100ch',
                            marginLeft: 0
                        },
                        children: gene.gene_structure.transcripts.length > 1 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Row, {
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Col, {
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("i", {
                                            children: "Select transcript"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.ButtonGroup, {
                                        children: gene.gene_structure.transcripts.sort((a, b)=>a.id.localeCompare(b.id)).map((tr, idx)=>{
                                            let v = tr.id === gene.gene_structure.canonical_transcript ? 'primary' : 'secondary';
                                            if (tr.id !== tid) v = `outline-${v}`;
                                            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.ToggleButton, {
                                                variant: v,
                                                id: `radio-${idx}`,
                                                type: "radio",
                                                name: tr.id,
                                                value: tr.id,
                                                checked: tr.id === tid,
                                                onChange: (e)=>setTid(e.currentTarget.value),
                                                children: tr.id
                                            }, idx);
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    geneSeq && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($527ebc19dc92444d$var$CodeBlock, {
                        id: tid,
                        seq: rnaSeq.seq,
                        blocks: $527ebc19dc92444d$var$decorateSeq(geneSeq, gene, 0, 0, tid, "rna")
                    })
                ]
            }),
            gene.biotype === "protein_coding" && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Tab, {
                tabClassName: "pep",
                eventKey: "pep",
                title: "Peptide sequence",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Container, {
                        style: {
                            width: '100ch',
                            marginLeft: 0
                        },
                        children: gene.gene_structure.transcripts.length > 1 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Row, {
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Col, {
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("i", {
                                            children: "Select transcript"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.ButtonGroup, {
                                        children: gene.gene_structure.transcripts.sort((a, b)=>a.id.localeCompare(b.id)).map((tr, idx)=>{
                                            let v = tr.id === gene.gene_structure.canonical_transcript ? 'primary' : 'secondary';
                                            if (tr.id !== tid) v = `outline-${v}`;
                                            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.ToggleButton, {
                                                variant: v,
                                                id: `radio-${idx}`,
                                                type: "radio",
                                                name: tr.id,
                                                value: tr.id,
                                                checked: tr.id === tid,
                                                onChange: (e)=>setTid(e.currentTarget.value),
                                                children: tr.id
                                            }, idx);
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    geneSeq && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($527ebc19dc92444d$var$CodeBlock, {
                        id: tl_id,
                        seq: pepSeq.seq,
                        blocks: $527ebc19dc92444d$var$decoratePeptide(pepSeq.seq, transcript)
                    })
                ]
            })
        ]
    });
};
var $527ebc19dc92444d$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)('selectConfiguration', 'selectGeneSequences', 'selectRnaSequences', 'selectPepSequences', 'selectUiViewState', 'doRequestGeneSequence', 'doRequestRnaSequence', 'doRequestPepSequence', 'doSetSequencesState', $527ebc19dc92444d$var$Detail);
/**
 * Gene models for the primer designer's variant browser.
 *
 * `/primers` has no genes-in-region endpoint — it can only fetch a gene by id —
 * so the designer takes this from its host. Ensembl REST's `overlap/region`
 * returns genes, transcripts, exons and CDS for a window in one request, all in
 * genomic coordinates, which is exactly what the browser draws.
 *
 * Read from `config.ensemblRest`, which must be the same Ensembl release the
 * primers API reads variants from (release 115 for sorghum_v11). A different
 * release would draw gene models that do not line up with the variants beside
 * them.
 */ /**
 * Beyond this the response runs to thousands of features and the models would
 * be too small to read, so the track is simply left empty.
 */ const $31284fcdc45a1688$var$MAX_SPAN = 1000000;
function $31284fcdc45a1688$export$3a249e9030170bda(ensemblRest) {
    if (!ensemblRest) return undefined;
    return async ({ system_name: system_name, region: region, start: start, end: end }, options)=>{
        if (!system_name || !region || end - start + 1 > $31284fcdc45a1688$var$MAX_SPAN) return [];
        const signal = options && options.signal;
        const url = `${ensemblRest}/overlap/region/${encodeURIComponent(system_name)}/${encodeURIComponent(region)}:${start}-${end}` + `?feature=gene;feature=transcript;feature=exon;feature=cds;content-type=application/json`;
        const res = await fetch(url, {
            headers: {
                Accept: 'application/json'
            },
            signal: signal
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const features = await res.json();
        if (!Array.isArray(features)) return [];
        const of = (type)=>features.filter((f)=>f && f.feature_type === type);
        const transcripts = of('transcript');
        const exons = of('exon');
        const cds = of('cds');
        return of('gene').map((gene)=>{
            // One transcript per gene: the canonical one when Ensembl marks it.
            const mine = transcripts.filter((t)=>t.Parent === gene.id);
            const transcript = mine.find((t)=>t.is_canonical) || mine[0];
            const myExons = transcript ? exons.filter((e)=>e.Parent === transcript.id) : [];
            const myCds = transcript ? cds.filter((c)=>c.Parent === transcript.id) : [];
            return {
                id: gene.id,
                label: gene.external_name || gene.id,
                start: gene.start,
                end: gene.end,
                strand: gene.strand === -1 ? -1 : 1,
                // Ensembl returns only the exons overlapping the window, which is all
                // the browser can show anyway.
                exons: myExons.map((e)=>({
                        start: e.start,
                        end: e.end
                    })),
                cds: myCds.length ? {
                    start: Math.min(...myCds.map((c)=>c.start)),
                    end: Math.max(...myCds.map((c)=>c.end))
                } : null,
                biotype: gene.biotype
            };
        });
    };
}
/**
 * Reference sequence for the primer designer's CAPS annotation.
 *
 * A variant listing from `/primers` carries coordinates and alleles but no
 * bases, and restriction sites cannot be found without them, so the designer
 * takes sequence from its host. Ensembl REST's `sequence/region` returns the
 * plus strand of a window as `{molecule, seq, id, query}`.
 *
 * Read from `config.ensemblRest`, which must be the same Ensembl release the
 * primers API reads variants from (release 115 for sorghum_v11). This matters
 * more here than it does for the gene track: a gene model from the wrong
 * release is visibly out of place, whereas sequence from the wrong release
 * produces a confident and wrong enzyme call. The designer checks every window
 * against the reference alleles the API reports and shows nothing if they
 * disagree, but the right release is still the actual fix.
 */ /**
 * Beyond this the annotation is not worth the transfer; the variant listing is
 * already capped well below it, so this only guards against a stray query.
 */ const $f49aa8a0cf25aef4$var$MAX_SPAN = 200000;
function $f49aa8a0cf25aef4$export$30e3f6c97d3f3a29(ensemblRest) {
    if (!ensemblRest) return undefined;
    return async ({ system_name: system_name, region: region, start: start, end: end }, options)=>{
        if (!system_name || !region || start < 1 || end < start || end - start + 1 > $f49aa8a0cf25aef4$var$MAX_SPAN) return null;
        const signal = options && options.signal;
        const url = `${ensemblRest}/sequence/region/${encodeURIComponent(system_name)}/${encodeURIComponent(region)}:${start}-${end}` + `?content-type=application/json`;
        const res = await fetch(url, {
            headers: {
                Accept: 'application/json'
            },
            signal: signal
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const body = await res.json();
        // A short or absent read would be indexed with genomic offsets and give
        // wrong answers quietly; the designer discards it, and so does this.
        return body && typeof body.seq === 'string' ? body.seq.toUpperCase() : null;
    };
}
/**
 * Allele frequencies for the primer designer's variant picker.
 *
 * A variant listing from `/primers` says which alleles exist but not how common
 * they are, and how common an allele is decides whether a variant is worth
 * genotyping at all: a marker near fixation in the panel you mean to screen
 * tells you nothing. Ensembl REST's `variation` endpoint carries the figures,
 * and its POST form answers about many ids in one request — ids beyond a couple
 * of hundred are the difference between one call and hundreds.
 *
 * Read from `config.ensemblRest`, which must be the same Ensembl release the
 * primers API reads variants from (release 115 for sorghum_v11), for the same
 * reason the gene track and the sequence must: a frequency read against another
 * release could be attached to the wrong variant entirely.
 *
 * Two things about the upstream shape are dealt with here. The tally is spelled
 * `allele_count`, which is mapped to `count` so a host with some other
 * frequency source is not made to speak Ensembl; and rows arrive repeated, the
 * same population and allele several times over, which the designer collapses.
 */ /** Ids per request. The designer sends batches; this is a guard, not the policy. */ const $24c27aa5d34bb08e$var$MAX_IDS = 500;
function $24c27aa5d34bb08e$export$849a7b5b35ad4649(ensemblRest) {
    if (!ensemblRest) return undefined;
    return async ({ system_name: system_name, ids: ids }, options)=>{
        if (!system_name || !Array.isArray(ids) || !ids.length) return {};
        const signal = options && options.signal;
        const wanted = ids.filter((id)=>typeof id === 'string' && id).slice(0, $24c27aa5d34bb08e$var$MAX_IDS);
        if (!wanted.length) return {};
        const res = await fetch(`${ensemblRest}/variation/${encodeURIComponent(system_name)}?pops=1`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify({
                ids: wanted
            }),
            signal: signal
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const body = await res.json();
        if (!body || typeof body !== 'object') return {};
        const out = {};
        for (const id of wanted){
            const rows = body[id] && body[id].populations;
            if (!Array.isArray(rows)) continue;
            out[id] = rows.filter((r)=>r && typeof r.population === 'string' && typeof r.allele === 'string' && Number.isFinite(Number(r.frequency))).map((r)=>({
                    population: r.population,
                    allele: r.allele,
                    frequency: Number(r.frequency),
                    // Absent is not nought: a missing tally must stay unknown.
                    count: r.allele_count === undefined || r.allele_count === null ? null : Number(r.allele_count)
                }));
        }
        return out;
    };
}
// Primers detail: PCR/qPCR primer design, genome specificity and pan-genome
// coverage checks (gramene-primers <PrimerDesigner>, backed by the
// gramene-swagger /primers endpoints).
//
// Enabled per site by config.details.primers:
//   true                    use the site's grameneData API
//   { apiBase, pangenome }  apiBase: a swagger that serves /primers;
//                           pangenome: false hides the pan-genome check
//
// The designer's serializable state ({v: 1, ...}) lives in the uiViewState
// bundle keyed by geneId (controlled mode), so a saved view restores the
// inputs, re-runs the design and re-attaches to a submitted check (an expired
// job shows "Re-run check"). The store keeps a pasted sequence, so switching
// detail tabs (which unmounts this component) does not lose it; viewSnapshot
// leaves it out of saved views. Styles are injected at runtime by the
// component; no CSS import is needed.
const $88d24ae9beb83d5d$var$MODES = [
    'gene',
    'transcript',
    'region',
    'sequence',
    'genotyping'
];
const $88d24ae9beb83d5d$var$geneHref = (id)=>`?idList=${encodeURIComponent(id)}`;
// Plain left clicks on gene links in check results open a new tab, so the
// design and a running check's job id survive; modified clicks use geneHref.
const $88d24ae9beb83d5d$var$openGene = (id)=>window.open($88d24ae9beb83d5d$var$geneHref(id), '_blank', 'noopener');
const $88d24ae9beb83d5d$var$Primers = (props)=>{
    const geneId = props.searchResult.id;
    const gene = props.geneDocs[geneId] // Gene.ensureGene() guarantees it is loaded
    ;
    const conf = props.config.details.primers // true | { apiBase?, pangenome?, genotyping? }
    ;
    const apiBase = conf && typeof conf === 'object' && conf.apiBase || props.grameneAPI;
    // Gene models for the variant browser come from Ensembl REST, which must be
    // the same release the primers API reads variants from.
    const ensemblRest = props.config && props.config.ensemblRest;
    const genesInRegion = (0, $gXNCa$react.useMemo)(()=>$31284fcdc45a1688$export$3a249e9030170bda(ensemblRest), [
        ensemblRest
    ]);
    const sequenceForRegion = (0, $gXNCa$react.useMemo)(()=>$f49aa8a0cf25aef4$export$30e3f6c97d3f3a29(ensemblRest), [
        ensemblRest
    ]);
    const alleleFrequencies = (0, $gXNCa$react.useMemo)(()=>$24c27aa5d34bb08e$export$849a7b5b35ad4649(ensemblRest), [
        ensemblRest
    ]);
    const byGene = props.uiViewState && props.uiViewState.byGene && props.uiViewState.byGene[geneId];
    const saved = byGene && byGene.primers;
    const { doSetPrimersState: doSetPrimersState } = props;
    const onStateChange = (0, $gXNCa$react.useCallback)((state)=>doSetPrimersState({
            geneId: geneId,
            state: state
        }), [
        geneId,
        doSetPrimersState
    ]);
    if (!conf) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("p", {
        children: "Primer design is not enabled on this site."
    });
    if (!gene) return null;
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$grameneprimers.PrimerDesigner, {
        apiBase: apiBase,
        gene: gene,
        systemName: gene.system_name,
        modes: $88d24ae9beb83d5d$var$MODES,
        genesInRegion: genesInRegion,
        sequenceForRegion: sequenceForRegion,
        alleleFrequencies: alleleFrequencies,
        defaultMode: "gene",
        // an empty slice (never visited, or a snapshot without primers) leaves
        // the designer uncontrolled until its first change is stored
        state: saved && Object.keys(saved).length ? saved : undefined,
        onStateChange: onStateChange,
        features: {
            pangenome: !(conf && conf.pangenome === false),
            genotyping: !(conf && conf.genotyping === false)
        },
        geneHref: $88d24ae9beb83d5d$var$geneHref,
        onGeneClick: $88d24ae9beb83d5d$var$openGene,
        geneLabel: gene.name || gene._id,
        theme: "light"
    }, geneId);
};
var $88d24ae9beb83d5d$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)('selectGrameneAPI', 'selectUiViewState', 'doSetPrimersState', $88d24ae9beb83d5d$var$Primers);
let $6c5c4f90059875bf$var$external = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("small", {
    title: "This link opens a page from an external site",
    children: [
        " ",
        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("i", {
            className: "fa fa-external-link"
        })
    ]
});
let $6c5c4f90059875bf$var$inventory = {
    sequences: $527ebc19dc92444d$export$2e2bcd8739ae039,
    primers: $88d24ae9beb83d5d$export$2e2bcd8739ae039,
    location: $264d7db426cab787$export$2e2bcd8739ae039,
    expression: $9e29a4f60318db7a$export$2e2bcd8739ae039,
    homology: $64fad37f770d2bfe$export$2e2bcd8739ae039,
    pathways: $54c74a4689d5a778$export$2e2bcd8739ae039,
    VEP: $283508ffcf8a47c4$export$2e2bcd8739ae039,
    xrefs: $b7cae39a716ca5a8$export$2e2bcd8739ae039,
    pubs: $830f925242a0b007$export$2e2bcd8739ae039
};
function $6c5c4f90059875bf$var$renderTairSummary(searchResult) {
    const summary = searchResult.summary;
    if (summary && summary !== "NULL" && searchResult.system_name === "arabidopsis_thaliana") return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "gene-summary-tair",
        children: $6c5c4f90059875bf$var$trimSummary(summary)
    });
}
function $6c5c4f90059875bf$var$trimSummary(summary) {
    if (summary.length > 160) {
        const start = summary.substr(0, 150);
        const rest = summary.substr(150);
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("p", {
            children: [
                start,
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    className: "ellipsis",
                    children: "\u2026"
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    className: "rest",
                    children: rest
                })
            ]
        });
    } else return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("p", {
        children: summary
    });
}
const $6c5c4f90059875bf$var$PanLink = (props)=>{
    const gene = props.gene;
    const pan = props.pan;
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "gene-panlink",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("a", {
            target: "_blank",
            href: pan.url + "?idList=" + gene.id,
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("img", {
                src: pan.svg,
                title: `View this gene at ${pan.name}`
            })
        })
    });
};
const $6c5c4f90059875bf$var$ClosestOrthologCmp = (props)=>{
    let id, taxon_id, name, desc, species, className, identity;
    const gene = props.gene;
    if (gene.closest_rep_id) {
        name = gene.closest_rep_name || gene.closest_rep_id;
        desc = gene.closest_rep_description;
        species = gene.closest_rep_species_name;
        id = gene.closest_rep_id;
        taxon_id = gene.closest_rep_taxon_id;
        className = "closest-ortholog";
        identity = gene.closest_rep_identity || 0;
    } else if (gene.model_rep_id) {
        name = gene.model_rep_name || gene.model_rep_id;
        desc = gene.model_rep_description;
        species = gene.model_rep_species_name;
        id = gene.model_rep_id;
        taxon_id = gene.model_rep_taxon_id;
        className = "model-ortholog";
        identity = gene.model_rep_identity || 0;
    }
    var isZm = new RegExp(/^Zm00001e/);
    if (isZm.test(desc)) desc = '';
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: className,
        onClick: ()=>{
            props.doEnsureGrameneGenome(taxon_id);
            props.doReplaceGrameneFilters($047461923b1badda$export$964d88edb00bbcaa({
                category: 'Gene',
                fq_field: 'id',
                fq_value: id,
                name: name
            }));
        },
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "gene-species",
                children: species
            }),
            identity > 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "rep-identity",
                children: Math.round(identity * 100)
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h3", {
                className: "gene-id",
                children: name
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("p", {
                children: desc
            })
        ]
    });
};
const $6c5c4f90059875bf$var$ClosestOrtholog = (0, $gXNCa$reduxbundlerreact.connect)('doReplaceGrameneFilters', 'doEnsureGrameneGenome', $6c5c4f90059875bf$var$ClosestOrthologCmp);
function $6c5c4f90059875bf$var$renderClosestOrtholog(gene) {
    if ($6c5c4f90059875bf$var$shouldShowClosestOrtholog(gene)) // however, that could cause the height of the result to change. Instead we set visibility:hidden
    // so that the renderer takes into account the height of the ortholog even if not shown.
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($6c5c4f90059875bf$var$ClosestOrtholog, {
        gene: gene
    });
}
// show closest ortholog prominently if we have data to show:-
//   a. either there's a closest ortholog (determined by traversing the gene tree until an id or description looks
// curated) b. or there's a model ortholog (traverse tree to find an ortholog in arabidopsis)
function $6c5c4f90059875bf$var$shouldShowClosestOrtholog(searchResult) {
    return searchResult.closest_rep_id || searchResult.model_rep_id && searchResult.model_rep_id !== searchResult.id;
}
const $6c5c4f90059875bf$var$allDetails = [
    {
        id: 'VEP',
        label: 'Germplasm',
        popup: 'Germplasm with protein truncating variants (PTVs)',
        available: false
    },
    {
        id: 'sequences',
        label: 'Sequences',
        popup: 'Gene/cDNA/protein fasta',
        available: true
    },
    {
        id: 'primers',
        label: 'Primers',
        popup: 'Design PCR/qPCR primers; check specificity and pan-genome coverage',
        available: true
    },
    {
        id: 'location',
        label: 'Location',
        popup: 'Genome Browser',
        available: false
    },
    {
        id: 'expression',
        label: 'Expression',
        popup: 'Gene Expression Atlas',
        available: false
    },
    {
        id: 'homology',
        label: 'Homology',
        popup: 'Gene Family Tree',
        available: false
    },
    {
        id: 'pathways',
        label: 'Pathways',
        popup: 'Plant Reactome Pathways',
        available: false
    },
    {
        id: 'pubs',
        label: 'Papers',
        popup: 'Curated Publications',
        available: false
    },
    {
        id: 'xrefs',
        label: 'Xrefs',
        popup: 'Database Cross-references',
        available: false
    }
];
class $6c5c4f90059875bf$var$Gene extends $parcel$interopDefault($gXNCa$react).Component {
    constructor(props){
        super(props);
        // `details` is derived per-render config (which tabs the site enables,
        // crossed with this row's `capabilities`) — keep it local.
        this.state = {
            details: $6c5c4f90059875bf$var$allDetails.map((o)=>({
                    ...o
                })).filter((d)=>props.config.details[d.id])
        };
        let hasData = {};
        props.searchResult.capabilities.forEach((c)=>{
            hasData[c] = true;
            if (c === 'PanOryza') hasData.xrefs = true;
        });
        this.state.details.forEach((d)=>d.available |= hasData.hasOwnProperty(d.id));
    }
    componentDidMount() {
        // Seed the auto-open-homology intent (from GeneList when numFound===1) the
        // first time this row mounts, only if the user hasn't already opened/closed
        // a tab here. Without this, the bundle would have no entry and the prior
        // "auto-expand homology on single-result" behavior would be lost.
        if (this.props.expandedDetail && this.expandedDetail === undefined) this.props.doExpandGeneDetail({
            geneId: this.props.searchResult.id,
            detail: this.props.expandedDetail
        });
    }
    get expandedDetail() {
        const slice = this.props.uiViewState && this.props.uiViewState.byGene[this.props.searchResult.id];
        return slice ? slice.expandedDetail : undefined;
    }
    get fullscreen() {
        const slice = this.props.uiViewState && this.props.uiViewState.byGene[this.props.searchResult.id];
        return !!(slice && slice.fullscreen);
    }
    getDetailStatus(d) {
        if (this.expandedDetail === d.id) return 'expanded';
        if (d.available) return 'closed';
        return d.id === "pubs" ? 'empty' : 'disabled';
    }
    setExpanded(d) {
        if (d.available || d.id === "pubs") {
            const geneId = this.props.searchResult.id;
            if (this.expandedDetail === d.id) this.props.doExpandGeneDetail({
                geneId: geneId,
                detail: null
            });
            else {
                if (!(this.props.geneDocs && this.props.geneDocs.hasOwnProperty(geneId))) this.props.requestGene(geneId);
                $parcel$interopDefault($gXNCa$reactga4).event({
                    category: 'Search',
                    action: 'Details',
                    label: d.label
                });
                this.props.doExpandGeneDetail({
                    geneId: geneId,
                    detail: d.id
                });
            }
        }
    }
    ensureGene(id) {
        if (!(this.props.geneDocs && this.props.geneDocs.hasOwnProperty(id))) {
            this.props.requestGene(id);
            return false;
        }
        return this.props.geneDocs[id].hasOwnProperty('taxon_id');
    }
    renderMetadata() {
        let gene = this.props.searchResult;
        if (gene.model_rep_taxon_id) gene.model_rep_species_name = this.props.taxLut[gene.model_rep_taxon_id].short_name;
        if (gene.closest_rep_taxon_id) gene.closest_rep_species_name = this.props.taxLut[gene.closest_rep_taxon_id].short_name;
        return $6c5c4f90059875bf$var$renderTairSummary(gene) || $6c5c4f90059875bf$var$renderClosestOrtholog(gene);
    }
    render() {
        const panSite = this.props.config.panSite;
        const searchResult = this.props.searchResult;
        const taxName = this.props.taxName;
        const numWordsInDescription = searchResult.description.split(' ').length;
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
            className: "result-gene",
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                    className: "result-gene-summary",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                            className: "result-gene-title-body",
                            children: [
                                panSite.hasOwnProperty(searchResult.system_name) && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($6c5c4f90059875bf$var$PanLink, {
                                    pan: panSite[searchResult.system_name],
                                    gene: searchResult
                                }),
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                    className: "gene-title",
                                    children: [
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                            className: "gene-species",
                                            children: taxName
                                        }),
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("h3", {
                                            className: "gene-name",
                                            children: [
                                                searchResult.name,
                                                searchResult.id !== searchResult.name && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("small", {
                                                    className: "gene-id",
                                                    children: [
                                                        "\xa0",
                                                        searchResult.id
                                                    ]
                                                })
                                            ]
                                        }),
                                        Array.isArray(searchResult.alt_id) && searchResult.alt_id.length > 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                            className: "gene-alt-ids",
                                            children: searchResult.alt_id.join(', ')
                                        })
                                    ]
                                }),
                                searchResult.synonyms && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("small", {
                                    className: "gene-synonyms",
                                    children: searchResult.synonyms.join(', ')
                                }),
                                searchResult.description !== "unknown" && (numWordsInDescription > 1 || searchResult.can_show.pubs) && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("p", {
                                    className: "gene-description",
                                    children: searchResult.description
                                })
                            ]
                        }),
                        this.renderMetadata()
                    ]
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                    className: "gene-detail-tabs",
                    children: this.state.details.map((d, idx)=>{
                        const isExpanded = this.expandedDetail === d.id;
                        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.OverlayTrigger, {
                            placement: 'bottom',
                            overlay: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Tooltip, {
                                id: `tooltip`,
                                children: d.popup
                            }),
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                className: `col-md-1 text-center gene-detail-tab-${this.getDetailStatus(d)}`,
                                style: {
                                    position: 'relative'
                                },
                                onClick: ()=>this.setExpanded(d),
                                children: [
                                    d.label,
                                    isExpanded && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsbs.BsArrowsFullscreen, {
                                        className: "gene-detail-tab-fullscreen",
                                        title: "View full screen",
                                        onClick: (e)=>{
                                            e.stopPropagation();
                                            this.props.doSetGeneFullscreen({
                                                geneId: searchResult.id,
                                                fullscreen: true
                                            });
                                        }
                                    })
                                ]
                            }, idx)
                        }, idx);
                    })
                }),
                this.expandedDetail && this.ensureGene(searchResult.id) && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($5c2c79352d3d7b81$export$ec6b54b688be1708, {
                    className: "visible-detail",
                    fullscreen: this.fullscreen,
                    onExitFullscreen: ()=>this.props.doSetGeneFullscreen({
                            geneId: searchResult.id,
                            fullscreen: false
                        }),
                    title: (this.state.details.find((d)=>d.id === this.expandedDetail) || {}).label,
                    children: $parcel$interopDefault($gXNCa$react).createElement($6c5c4f90059875bf$var$inventory[this.expandedDetail], this.props)
                })
            ]
        });
    }
}
// Wrap Gene so each row gets uiViewState + dispatchers. (We don't pull these
// in at the GeneList level because the slice we care about is per-geneId; the
// component-side getters read by row id.)
const $6c5c4f90059875bf$var$ConnectedGene = (0, $gXNCa$reduxbundlerreact.connect)('selectUiViewState', 'doExpandGeneDetail', 'doSetGeneFullscreen', $6c5c4f90059875bf$var$Gene);
const $6c5c4f90059875bf$var$GeneList = (props)=>{
    if (props.grameneSearch && props.grameneSearch.response && props.grameneTaxonomy) {
        let prev, page, next;
        const numFound = props.grameneSearch.response.numFound;
        if (numFound > props.grameneSearchRows) {
            const pageNum = props.grameneSearchOffset / props.grameneSearchRows;
            page = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                style: {
                    padding: '10px'
                },
                children: [
                    "page ",
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                        children: pageNum + 1
                    }),
                    " of ",
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                        children: Math.ceil(numFound / props.grameneSearchRows)
                    })
                ]
            });
            prev = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsgr.GrHpe, {});
            if (pageNum > 0) prev = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Badge, {
                onClick: ()=>props.doRequestResultsPage(pageNum - 1),
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsgr.GrFormPrevious, {})
            });
            next = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsgr.GrHpe, {});
            if (numFound > props.grameneSearchOffset + props.grameneSearchRows) next = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Badge, {
                onClick: ()=>props.doRequestResultsPage(pageNum + 1),
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsgr.GrFormNext, {})
            });
        }
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                    children: [
                        prev,
                        page,
                        next
                    ]
                }),
                props.grameneSearch.response.docs.map((g, idx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($6c5c4f90059875bf$var$ConnectedGene, {
                        searchResult: g,
                        config: props.configuration,
                        taxName: props.grameneTaxonomy[g.taxon_id].name,
                        geneDocs: props.grameneGenes,
                        requestGene: props.doRequestGrameneGene,
                        taxLut: props.grameneTaxonomy,
                        expandedDetail: props.grameneSearch.response.numFound === 1 && g.can_show.homology ? 'homology' : null
                    }, idx)),
                prev,
                page,
                next
            ]
        });
    }
    return null;
};
var $6c5c4f90059875bf$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)('selectConfiguration', 'selectGrameneSearch', 'selectGrameneTaxonomy', 'selectGrameneGenes', 'selectGrameneSearchOffset', 'selectGrameneSearchRows', 'doRequestGrameneGene', 'doRequestResultsPage', $6c5c4f90059875bf$var$GeneList);
function $e2d7530b31b5433c$var$selectionStats(selections, taxonomy) {
    const selectionData = $e2d7530b31b5433c$var$getSelectionData(selections, taxonomy);
    const totalGeneResults = taxonomy.model.results.count;
    const fq = $e2d7530b31b5433c$var$fqFromSelections(selections);
    return {
        selectedGenes: selectionData.resultsCount,
        totalGeneResults: totalGeneResults,
        fq: fq,
        numSelectedBins: selectionData.binsCount,
        proportionGenesSelected: selectionData.resultsCount / totalGeneResults
    };
}
function $e2d7530b31b5433c$var$getSelectionData(selection, taxonomy) {
    return $parcel$interopDefault($gXNCa$lodash).reduce(selection, (countAcc, sel)=>{
        const bins = taxonomy.getBins(sel.binFrom.idx, sel.binTo.idx);
        countAcc.binsCount += bins.length;
        countAcc.resultsCount += $parcel$interopDefault($gXNCa$lodash).reduce(bins, (acc, bin)=>acc + bin.results.count, 0);
        return countAcc;
    }, {
        resultsCount: 0,
        binsCount: 0
    });
}
const $e2d7530b31b5433c$var$selectionToSolrRange = (sel)=>`[${sel.binFrom.idx} TO ${sel.binTo.idx}]`;
function $e2d7530b31b5433c$var$fqFromSelections(selections) {
    const rangeStrings = selections.map($e2d7530b31b5433c$var$selectionToSolrRange);
    return `fixed_1000__bin:(${rangeStrings.join(' ')})`;
}
const $e2d7530b31b5433c$var$Selections = ({ selections: selections, taxonomy: taxonomy, doAcceptGrameneSuggestion: doAcceptGrameneSuggestion, onFilter: onFilter })=>{
    const stats = $e2d7530b31b5433c$var$selectionStats(selections, taxonomy);
    const setFilter = ()=>{
        doAcceptGrameneSuggestion({
            category: 'Selections',
            fq_field: 'fixed_1000__bin',
            fq_value: `(${selections.map($e2d7530b31b5433c$var$selectionToSolrRange).join(' ')})`,
            name: `${selections.length} region${selections.length === 1 ? '' : 's'}`
        });
        onFilter();
    };
    const formatProportion = (prop)=>'(' + ($parcel$interopDefault($gXNCa$lodash).isFinite(prop) ? $parcel$interopDefault($gXNCa$numeral)(prop).format('0.0%') : undefined) + ')';
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Table, {
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("tbody", {
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("th", {
                            children: "Number of selected genes"
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("td", {
                            children: [
                                stats.selectedGenes,
                                " ",
                                formatProportion(stats.proportionGenesSelected)
                            ]
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Button, {
                                size: "sm",
                                onClick: setFilter,
                                children: [
                                    "selections\xa0|",
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Badge, {
                                        children: stats.selectedGenes
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
var $e2d7530b31b5433c$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)('doAcceptGrameneSuggestion', $e2d7530b31b5433c$var$Selections);
class $a67cad486021eb32$var$TaxDist extends $parcel$interopDefault($gXNCa$react).Component {
    constructor(props){
        super(props);
        this.state = {
            collapseEmpties: true,
            comparaOnly: true,
            showCompara: props.configuration.hasOwnProperty('partialCompara')
        };
    }
    handleSelection(selections) {
        this.setState({
            selections: selections
        });
    }
    handleHighlight(highlight) {
        this.setState({
            highlight: highlight
        });
    }
    handleFilter() {
        this.setState({
            selections: null
        });
    }
    toggleEmpties() {
        this.setState({
            collapseEmpties: !this.state.collapseEmpties
        });
    }
    toggleCompara() {
        this.setState({
            comparaOnly: !this.state.comparaOnly
        });
    }
    render() {
        let selectedTaxa = {};
        if (this.props.grameneSearch) {
            if (this.state.collapseEmpties) this.props.grameneSearch.facet_counts.facet_fields.taxon_id.filter((tid, idx)=>idx % 2 === 0).forEach((tid)=>{
                selectedTaxa[tid] = true;
            });
            else if (Object.keys(this.props.grameneGenomes.active).length === 0 && this.props.grameneMaps) Object.keys(this.props.grameneMaps).forEach((tid)=>selectedTaxa[tid] = true);
            else Object.keys(this.props.grameneGenomes.active).forEach((tid)=>selectedTaxa[tid] = true);
            if (this.state.showCompara && this.state.comparaOnly && this.props.grameneMaps) Object.keys(selectedTaxa).forEach((tid)=>{
                if (!this.props.grameneMaps[tid].in_compara) delete selectedTaxa[tid];
            });
            // Drop any tid the taxonomy tree doesn't know about — gramene-search-vis
            // throws when it encounters one (nodeIndex[tid].getPath() on undefined),
            // which silently leaves every branch expanded.
            if (this.props.grameneTaxDist && this.props.grameneTaxDist.indices && this.props.grameneTaxDist.indices.id) {
                const nodeIndex = this.props.grameneTaxDist.indices.id;
                Object.keys(selectedTaxa).forEach((tid)=>{
                    if (!nodeIndex[tid]) delete selectedTaxa[tid];
                });
            }
        }
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
            className: "results-vis big-vis",
            children: [
                this.props.grameneTaxDist && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("button", {
                            type: "button",
                            className: "btn btn-outline-primary btn-sm",
                            onClick: this.toggleEmpties.bind(this),
                            children: [
                                this.state.collapseEmpties ? 'Expand' : 'Collapse',
                                " empty branches"
                            ]
                        }),
                        this.state.showCompara && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("button", {
                            type: "button",
                            className: "btn btn-outline-success btn-sm",
                            onClick: this.toggleCompara.bind(this),
                            children: [
                                "Show ",
                                this.state.comparaOnly ? 'all genomes' : 'only genomes in gene trees'
                            ]
                        })
                    ]
                }),
                this.props.grameneTaxDist && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($parcel$interopDefault($gXNCa$gramenesearchvis), {
                    taxonomy: this.props.grameneTaxDist,
                    selectedTaxa: selectedTaxa,
                    onSelection: this.handleSelection.bind(this),
                    onHighlight: this.handleHighlight.bind(this)
                }),
                this.renderSelection()
            ]
        });
    }
    renderSelection() {
        if (this.state.selections && this.props.grameneTaxDist) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($e2d7530b31b5433c$export$2e2bcd8739ae039, {
            taxonomy: this.props.grameneTaxDist,
            selectedTaxa: {},
            selections: this.state.selections,
            onFilter: this.handleFilter.bind(this)
        });
    }
}
var $a67cad486021eb32$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)('selectConfiguration', 'selectGrameneTaxDist', 'selectGrameneGenomes', 'selectGrameneSearch', 'selectGrameneMaps', $a67cad486021eb32$var$TaxDist);
const $b36244140732570a$var$examples = [
    {
        subsite: {
            maize: 1,
            sorghum: 1,
            main: 1
        },
        text: "What are the orthologs of Arabidopsis thaliana's PAD4 gene in Andropogoneae?",
        filters: {
            status: 'init',
            rows: 20,
            operation: 'AND',
            negate: false,
            leftIdx: 0,
            rightIdx: 5,
            children: [
                {
                    fq_field: 'homology__all_orthologs',
                    fq_value: 'AT3G52430',
                    name: 'Orthologs of PAD4',
                    category: 'Gene Tree',
                    leftIdx: 1,
                    rightIdx: 2,
                    negate: false,
                    marked: false
                },
                {
                    fq_field: 'taxonomy__ancestors',
                    fq_value: 147429,
                    name: 'Andropogoneae',
                    category: 'Taxonomy',
                    leftIdx: 3,
                    rightIdx: 4,
                    negate: false,
                    marked: false
                }
            ]
        }
    },
    {
        subsite: {
            maize: 1,
            sorghum: 1,
            grapevine: 1,
            rice: 1,
            main: 1
        },
        text: "Which genes are curated in the scientific literature?",
        filters: {
            status: 'init',
            rows: 20,
            operation: 'AND',
            negate: false,
            leftIdx: 0,
            rightIdx: 3,
            children: [
                {
                    fq_field: 'capabilities',
                    fq_value: 'pubs',
                    name: 'publication',
                    category: 'Curated',
                    leftIdx: 1,
                    rightIdx: 2,
                    negate: false,
                    marked: false
                }
            ]
        }
    },
    {
        subsite: {
            grapevine: 1
        },
        text: "What are the orthologs of Arabidopsis thaliana's PAD4 gene in rosids?",
        filters: {
            status: 'init',
            rows: 20,
            operation: 'AND',
            negate: false,
            leftIdx: 0,
            rightIdx: 5,
            children: [
                {
                    fq_field: 'homology__all_orthologs',
                    fq_value: 'AT3G52430',
                    name: 'Orthologs of PAD4',
                    category: 'Gene Tree',
                    leftIdx: 1,
                    rightIdx: 2,
                    negate: false,
                    marked: false
                },
                {
                    fq_field: 'taxonomy__ancestors',
                    fq_value: 71275,
                    name: 'rosids',
                    category: 'Taxonomy',
                    leftIdx: 3,
                    rightIdx: 4,
                    negate: false,
                    marked: false
                }
            ]
        }
    }
];
const $b36244140732570a$var$HelpDemo = ({ configuration: configuration, doReplaceGrameneFilters: doReplaceGrameneFilters })=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Container, {
        fluid: true,
        style: {
            padding: '40px'
        },
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Row, {
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h3", {
                    children: "Search Features"
                })
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Row, {
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.CardGroup, {
                    style: {
                        width: '80%'
                    },
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Card, {
                            style: {
                                'backgroundColor': '#f3f6f5',
                                'borderColor': '#DDE5E3'
                            },
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Card.Body, {
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Card.Title, {
                                        children: "Suggestions"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Card.Text, {
                                        children: "Matching terms are provided as you type:"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                        className: "gene-search-pic-sugg"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Card, {
                            style: {
                                'backgroundColor': '#f3f6f5',
                                'borderColor': '#DDE5E3'
                            },
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Card.Body, {
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Card.Title, {
                                        children: "Visualization"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Card.Text, {
                                        children: "See the distribution of results across all genomes:"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                        className: "gene-search-pic-results"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Card, {
                            style: {
                                'backgroundColor': '#f3f6f5',
                                'borderColor': '#DDE5E3'
                            },
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Card.Body, {
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Card.Title, {
                                        children: "Gene tree view"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Card.Text, {
                                        children: "Explore evolutionary history of a gene family:"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                        className: "gene-search-pic-genetree"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Row, {
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h4", {
                    children: "For Example"
                })
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Row, {
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("small", {
                    children: [
                        "You can ask sophisticated questions about the genes:",
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("br", {}),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("ul", {
                            children: $b36244140732570a$var$examples.filter((e)=>!!e.subsite[configuration.id]).map((e, idx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("a", {
                                        onClick: ()=>doReplaceGrameneFilters(e.filters),
                                        children: e.text
                                    })
                                }, idx))
                        })
                    ]
                })
            })
        ]
    });
var $b36244140732570a$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)('selectConfiguration', 'doReplaceGrameneFilters', $b36244140732570a$var$HelpDemo);
function $dbdedae66c619d9b$export$2e2bcd8739ae039({ groups: groups, stats: stats }) {
    const fields = stats?.stats_fields || {};
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        style: {
            fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
            lineHeight: 1.35
        },
        children: Object.entries(groups).map(([groupName, attrs])=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($dbdedae66c619d9b$var$GroupTable, {
                groupName: groupName,
                attributes: attrs,
                fields: fields
            }, groupName))
    });
}
function $dbdedae66c619d9b$var$GroupTable({ groupName: groupName, attributes: attributes, fields: fields }) {
    const hasAny = attributes?.some((a)=>fields[a.fieldName]);
    const columns = (0, $gXNCa$react.useMemo)(()=>[
            {
                key: "attr",
                label: "Attribute",
                min: 120
            },
            {
                key: "desc",
                label: "Description",
                min: 380,
                flex: true
            },
            {
                key: "mean",
                label: "Mean",
                min: 100
            },
            {
                key: "stddev",
                label: "Std Dev",
                min: 110
            },
            {
                key: "min",
                label: "Min",
                min: 90
            },
            {
                key: "max",
                label: "Max",
                min: 90
            },
            {
                key: "count",
                label: "Count",
                min: 90
            },
            {
                key: "dist",
                label: "Distribution",
                min: 220
            }
        ], []);
    const initial = (0, $gXNCa$react.useMemo)(()=>columns.map((c)=>c.flex ? Math.max(380, c.min) : c.min), [
        columns
    ]);
    const { colWidths: colWidths, startResize: startResize, resizing: resizing } = $dbdedae66c619d9b$var$useResizableColumns({
        initialWidths: initial,
        minWidths: columns.map((c)=>c.min || 60)
    });
    const nfInt = (0, $gXNCa$react.useMemo)(()=>new Intl.NumberFormat("en-US", {
            maximumFractionDigits: 0
        }), []);
    const nfFloat = (0, $gXNCa$react.useMemo)(()=>new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 3
        }), []);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("section", {
        style: {
            marginBottom: 24
        },
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("header", {
                style: {
                    display: "flex",
                    alignItems: "baseline",
                    gap: 12,
                    marginBottom: 8
                },
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h2", {
                        style: {
                            margin: 0,
                            fontSize: 18
                        },
                        children: groupName
                    }),
                    !hasAny && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        style: {
                            fontSize: 12,
                            color: "#666"
                        },
                        children: "No stats available for this group."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                style: {
                    overflowX: "auto",
                    border: "1px solid #eee",
                    borderRadius: 8,
                    boxShadow: "0 1px 2px rgba(0,0,0,0.04)"
                },
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("table", {
                    style: $dbdedae66c619d9b$var$tableStyle,
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("colgroup", {
                            children: colWidths.map((w, i)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("col", {
                                    style: {
                                        width: w
                                    }
                                }, i))
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("tr", {
                                children: columns.map((col, i)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($dbdedae66c619d9b$var$ResizableTh, {
                                        label: col.label,
                                        index: i,
                                        onResizeStart: startResize
                                    }, col.key))
                            })
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("tbody", {
                            children: attributes.map((a)=>{
                                const s = fields[a.fieldName] || {};
                                return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($dbdedae66c619d9b$var$Td, {
                                            mono: true,
                                            title: a.fieldName,
                                            children: a.name
                                        }),
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($dbdedae66c619d9b$var$Td, {
                                            title: a.description,
                                            children: a.description
                                        }),
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($dbdedae66c619d9b$var$Td, {
                                            align: "right",
                                            children: $dbdedae66c619d9b$var$fmtValue(s.mean, a.dtype, true, nfInt, nfFloat)
                                        }),
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($dbdedae66c619d9b$var$Td, {
                                            align: "right",
                                            children: $dbdedae66c619d9b$var$fmtValue(s.stddev, a.dtype, true, nfInt, nfFloat)
                                        }),
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($dbdedae66c619d9b$var$Td, {
                                            align: "right",
                                            children: $dbdedae66c619d9b$var$fmtValue(s.min, a.dtype, false, nfInt, nfFloat)
                                        }),
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($dbdedae66c619d9b$var$Td, {
                                            align: "right",
                                            children: $dbdedae66c619d9b$var$fmtValue(s.max, a.dtype, false, nfInt, nfFloat)
                                        }),
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($dbdedae66c619d9b$var$Td, {
                                            align: "right",
                                            children: $dbdedae66c619d9b$var$fmtCount(s.count, nfInt)
                                        }),
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($dbdedae66c619d9b$var$Td, {
                                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($dbdedae66c619d9b$var$PercentileHeatmapNormalized, {
                                                percentilesArr: s.percentiles,
                                                min: s.min,
                                                max: s.max
                                            })
                                        })
                                    ]
                                }, a.fieldName);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                style: {
                    marginTop: 6,
                    fontSize: 12,
                    color: "#666"
                },
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("em", {
                        children: "Tip:"
                    }),
                    " Drag the divider at the right edge of any header to resize.",
                    resizing && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        style: {
                            marginLeft: 8,
                            color: "#999"
                        },
                        children: "(resizing\u2026)"
                    })
                ]
            })
        ]
    });
}
/* ===================== Percentiles / Heatmap ===================== */ /**
 * Convert alternating array into ordered pairs: [["10.0", v10], ["20.0", v20], ...]
 * - Preserves the exact order provided by Solr
 */ function $dbdedae66c619d9b$var$percentilesArrayToPairs(arr) {
    if (!Array.isArray(arr)) return [];
    const out = [];
    for(let i = 0; i < arr.length - 1; i += 2)out.push([
        String(arr[i]),
        arr[i + 1]
    ]);
    return out;
}
function $dbdedae66c619d9b$var$normalizeBetween(value, min, max) {
    if (!isFinite(min) || !isFinite(max) || max <= min || !isFinite(value)) return null;
    return (value - min) / (max - min);
}
// White -> Blue (0 -> 1)
function $dbdedae66c619d9b$var$rgbWhiteToBlue(vNorm) {
    const t = $dbdedae66c619d9b$var$clamp01(vNorm);
    const rg = Math.round(255 * (1 - t));
    return `rgb(${rg}, ${rg}, 255)`;
}
function $dbdedae66c619d9b$var$clamp01(x) {
    if (typeof x !== "number" || !isFinite(x)) return 0;
    return Math.max(0, Math.min(1, x));
}
function $dbdedae66c619d9b$var$fmtFloat(v) {
    if (v == null || !isFinite(v)) return "n/a";
    return v.toFixed(3);
}
/**
 * PercentileHeatmapNormalized
 * - Infers bins from percentilesArr (order preserved)
 * - Colors normalized by row min/max
 */ function $dbdedae66c619d9b$var$PercentileHeatmapNormalized({ percentilesArr: percentilesArr, min: min, max: max }) {
    const pairs = (0, $gXNCa$react.useMemo)(()=>$dbdedae66c619d9b$var$percentilesArrayToPairs(percentilesArr), [
        percentilesArr
    ]);
    const n = pairs.length || 1; // avoid zero columns
    const validScale = isFinite(min) && isFinite(max) && max > min;
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        style: {
            ...$dbdedae66c619d9b$var$heatRowDynamic,
            gridTemplateColumns: `repeat(${n}, 1fr)`
        },
        children: pairs.map(([pStr, raw], idx)=>{
            const rawNum = typeof raw === "number" && isFinite(raw) ? raw : null;
            const norm = rawNum == null ? null : validScale ? $dbdedae66c619d9b$var$normalizeBetween(rawNum, min, max) : null;
            const bg = norm == null ? "#f2f2f2" : $dbdedae66c619d9b$var$rgbWhiteToBlue(norm);
            const label = `${pStr} \u{2192} raw ${$dbdedae66c619d9b$var$fmtFloat(rawNum)} (norm ${$dbdedae66c619d9b$var$fmtFloat(norm)})`;
            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($dbdedae66c619d9b$var$HeatCell, {
                background: bg,
                label: label
            }, `${pStr}-${idx}`);
        })
    });
}
function $dbdedae66c619d9b$var$HeatCell({ background: background, label: label }) {
    const [hover, setHover] = (0, $gXNCa$react.useState)(false);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        style: {
            ...$dbdedae66c619d9b$var$heatCell,
            background: background
        },
        onMouseEnter: ()=>setHover(true),
        onMouseLeave: ()=>setHover(false),
        title: label,
        children: hover && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
            style: $dbdedae66c619d9b$var$popover,
            children: label
        })
    });
}
/* ===================== Resizable columns ===================== */ function $dbdedae66c619d9b$var$useResizableColumns({ initialWidths: initialWidths, minWidths: minWidths }) {
    const [colWidths, setColWidths] = (0, $gXNCa$react.useState)(initialWidths);
    const [resizing, setResizing] = (0, $gXNCa$react.useState)(false);
    const activeRef = (0, $gXNCa$react.useRef)(null); // { index, startX, startW }
    (0, $gXNCa$react.useEffect)(()=>{
        if (initialWidths?.length) setColWidths(initialWidths);
    }, [
        initialWidths?.length
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const onMouseMove = (e)=>{
        if (!activeRef.current) return;
        const { index: index, startX: startX, startW: startW } = activeRef.current;
        const dx = e.clientX - startX;
        const next = [
            ...colWidths
        ];
        const minW = minWidths?.[index] ?? 60;
        next[index] = Math.max(minW, startW + dx);
        setColWidths(next);
    };
    const endResize = ()=>{
        activeRef.current = null;
        setResizing(false);
        document.body.style.cursor = "";
        document.body.style.userSelect = "";
        window.removeEventListener("mousemove", onMouseMove);
        window.removeEventListener("mouseup", endResize);
    };
    const startResize = (index, ev)=>{
        const startX = ev.clientX;
        const startW = colWidths[index];
        activeRef.current = {
            index: index,
            startX: startX,
            startW: startW
        };
        setResizing(true);
        document.body.style.cursor = "col-resize";
        document.body.style.userSelect = "none";
        window.addEventListener("mousemove", onMouseMove);
        window.addEventListener("mouseup", endResize);
    };
    (0, $gXNCa$react.useEffect)(()=>{
        return ()=>{
            window.removeEventListener("mousemove", onMouseMove);
            window.removeEventListener("mouseup", endResize);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        colWidths: colWidths,
        setColWidths: setColWidths,
        startResize: startResize,
        resizing: resizing
    };
}
function $dbdedae66c619d9b$var$ResizableTh({ label: label, index: index, onResizeStart: onResizeStart }) {
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("th", {
        style: $dbdedae66c619d9b$var$thStyle,
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
            style: {
                position: "relative",
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    children: label
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    onMouseDown: (e)=>onResizeStart(index, e),
                    role: "separator",
                    "aria-orientation": "vertical",
                    title: "Drag to resize column",
                    style: $dbdedae66c619d9b$var$resizerStyle
                })
            ]
        })
    });
}
/* ===================== Formatting helpers ===================== */ function $dbdedae66c619d9b$var$fmtCount(v, nfInt) {
    if (v === null || v === undefined) return "\u2014";
    return nfInt.format(v);
}
function $dbdedae66c619d9b$var$fmtValue(v, dtype = "f", isStat = false, nfInt, nfFloat) {
    if (v === null || v === undefined || Number.isNaN(v)) return "\u2014";
    const isIntType = dtype === "i";
    return isIntType && !isStat ? nfInt.format(v) : nfFloat.format(v);
}
/* ===================== Cells & Styles ===================== */ function $dbdedae66c619d9b$var$Td({ children: children, align: align = "left", mono: mono = false, title: title }) {
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
        title: title,
        style: {
            ...$dbdedae66c619d9b$var$cellBase,
            textAlign: align,
            borderBottom: "1px solid #eee",
            padding: "8px 10px",
            fontFamily: mono ? "ui-monospace, SFMono-Regular, Menlo, monospace" : undefined,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            verticalAlign: "top"
        },
        children: children
    });
}
const $dbdedae66c619d9b$var$tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    tableLayout: "fixed",
    minWidth: 980
};
const $dbdedae66c619d9b$var$cellBase = {
    fontSize: 13,
    lineHeight: 1.35,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
};
const $dbdedae66c619d9b$var$thStyle = {
    ...$dbdedae66c619d9b$var$cellBase,
    textAlign: "left",
    borderBottom: "1px solid #ddd",
    background: "#fafafa",
    fontWeight: 600,
    padding: "10px 10px",
    position: "relative"
};
const $dbdedae66c619d9b$var$resizerStyle = {
    position: "absolute",
    right: -5,
    top: 0,
    height: "100%",
    width: 10,
    cursor: "col-resize",
    boxShadow: "inset -1px 0 0 rgba(0,0,0,0.08)"
};
const $dbdedae66c619d9b$var$heatRowDynamic = {
    display: "grid",
    gap: 2,
    alignItems: "center",
    width: "100%",
    minWidth: 200
};
const $dbdedae66c619d9b$var$heatCell = {
    height: 16,
    borderRadius: 3,
    position: "relative",
    boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.06)"
};
const $dbdedae66c619d9b$var$popover = {
    position: "absolute",
    left: "50%",
    top: -26,
    transform: "translateX(-50%)",
    padding: "2px 6px",
    fontSize: 11,
    background: "rgba(0,0,0,0.8)",
    color: "#fff",
    borderRadius: 4,
    whiteSpace: "nowrap",
    pointerEvents: "none"
};
class $67bf5a43401bffdc$var$GeneAttribs extends $parcel$interopDefault($gXNCa$react).Component {
    constructor(props){
        super(props);
        this.state = {};
    }
    render() {
        if (this.props.grameneGeneAttribs && this.props.grameneSearch) {
            const groups = this.props.grameneGeneAttribs;
            const stats = this.props.grameneSearch.stats;
            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($dbdedae66c619d9b$export$2e2bcd8739ae039, {
                groups: groups,
                stats: stats
            });
        }
        return null;
    }
}
var $67bf5a43401bffdc$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)('selectGrameneSearch', 'selectGrameneGeneAttribs', $67bf5a43401bffdc$var$GeneAttribs);
// name → subtle background colour. Checked against node.name at render time.
const $76e15aea9236bd47$var$CLADE_COLORS = {
    "Chlorophyta": "#e8f5e9",
    "Bryophyta": "#f1f8e9",
    "Liliopsida": "#fff8e1",
    "eudicotyledons": "#fce4ec",
    "Poaceae": "#fff3e0",
    "Fabaceae": "#ede7f6",
    "Brassicaceae": "#e1f5fe",
    "Solanaceae": "#ffebee"
};
function $76e15aea9236bd47$var$findRoots(tax) {
    return Object.values(tax).filter((n)=>!n.is_a || n.is_a.length === 0 || !n.is_a.some((p)=>tax[p]));
}
// Post-order: attach .leafIds (taxon_ids of maps in subtree) and .isLeaf
function $76e15aea9236bd47$var$annotate(node, tax, maps) {
    maps = maps || {};
    const leafIds = [];
    if (maps[node._id]) {
        node.isLeaf = true;
        leafIds.push(node._id);
    }
    (node.children || []).forEach((cid)=>{
        const child = tax[cid];
        if (!child) return;
        $76e15aea9236bd47$var$annotate(child, tax, maps);
        child.leafIds.forEach((id)=>leafIds.push(id));
    });
    node.leafIds = leafIds;
}
// The taxonomy's root nodes, annotated with the genomes (maps) under them. The
// modal is mounted with the search status, so the taxonomy and the maps can
// arrive in either order: missing maps count as no genomes, and the roots are
// rebuilt when either changes.
function $76e15aea9236bd47$var$buildRoots({ grameneMaps: grameneMaps, grameneTaxonomy: grameneTaxonomy }) {
    if (!grameneTaxonomy) return [];
    const roots = $76e15aea9236bd47$var$findRoots(grameneTaxonomy);
    roots.forEach((r)=>$76e15aea9236bd47$var$annotate(r, grameneTaxonomy, grameneMaps || {}));
    return roots;
}
// Walk down the spine through single-child internals until a branch point,
// leaf, or node that is itself a genome.
function $76e15aea9236bd47$var$compressChain(node, tax, maps) {
    maps = maps || {};
    const chain = [
        node
    ];
    let cur = node;
    while(true){
        const kids = (cur.children || []).map((cid)=>tax[cid]).filter((c)=>c && c.leafIds && c.leafIds.length > 0);
        if (kids.length !== 1) break;
        if (maps[cur._id]) break;
        cur = kids[0];
        chain.push(cur);
    }
    return {
        chain: chain,
        terminal: cur
    };
}
// Render a breadcrumb chain. If the chain has more than 3 nodes, collapse the
// middle into a hoverable ellipsis that reveals the hidden names on hover.
const $76e15aea9236bd47$var$CHAIN_DISPLAY_MAX = 3;
function $76e15aea9236bd47$var$renderChain(chain) {
    const nameOf = (n)=>n.short_name || n.name;
    if (chain.length <= $76e15aea9236bd47$var$CHAIN_DISPLAY_MAX) return chain.map((n, i)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($parcel$interopDefault($gXNCa$react).Fragment, {
            children: [
                i > 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    className: "tax-sep",
                    children: " \u203A "
                }),
                nameOf(n)
            ]
        }, n._id));
    const first = chain[0];
    const last = chain[chain.length - 1];
    const middle = chain.slice(1, -1);
    const fullTitle = chain.map(nameOf).join(" \u203A ");
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
        children: [
            nameOf(first),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                className: "tax-sep",
                children: " \u203A "
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                className: "tax-ellipsis",
                title: fullTitle,
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        className: "tax-ellipsis-short",
                        children: "\u2026"
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        className: "tax-ellipsis-full",
                        children: middle.map((n)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($parcel$interopDefault($gXNCa$react).Fragment, {
                                children: [
                                    nameOf(n),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                        className: "tax-sep",
                                        children: " \u203A "
                                    })
                                ]
                            }, n._id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                className: "tax-sep",
                children: " \u203A "
            }),
            nameOf(last)
        ]
    });
}
// Drop a parent when its single child has the same name (e.g. species node
// above a subspecies-less record that repeats the species name). The terminal
// (last element) is always preserved; only redundant ancestors are removed.
function $76e15aea9236bd47$var$dedupAdjacent(chain) {
    const out = [];
    for (const n of chain)if (out.length && out[out.length - 1].name === n.name) out[out.length - 1] = n; // keep the child, drop the parent
    else out.push(n);
    return out;
}
// Use the node's direct `rank` field when it carries a real value.
function $76e15aea9236bd47$var$getRank(node) {
    const r = node && node.rank;
    return r && r !== 'no rank' ? r : null;
}
// Search nodes whose name or a synonym contains the query. Prefix matches rank higher.
function $76e15aea9236bd47$var$searchTaxonomy(query, tax) {
    const q = query.trim().toLowerCase();
    if (!q) return [];
    const out = [];
    Object.values(tax).forEach((n)=>{
        const name = n.name || '';
        const nameLc = name.toLowerCase();
        if (nameLc.includes(q)) {
            out.push({
                node: n,
                matched: name,
                via: 'name',
                prefix: nameLc.startsWith(q)
            });
            return;
        }
        const syns = n.synonym || [];
        for (const s of syns){
            const sLc = s.toLowerCase();
            if (sLc.includes(q)) {
                out.push({
                    node: n,
                    matched: s,
                    via: 'synonym',
                    prefix: sLc.startsWith(q)
                });
                return;
            }
        }
    });
    out.sort((a, b)=>(a.prefix === b.prefix ? 0 : a.prefix ? -1 : 1) || a.node.name.localeCompare(b.node.name));
    return out.slice(0, 20);
}
// Compute the { selected, expanded } pair for a fresh modal opening:
// selection is seeded from active genomes (or everything non-hidden),
// and every ancestor of a selected genome is pre-expanded so the user sees
// all of their current selections without manually drilling in.
function $76e15aea9236bd47$var$computeOpenState(props) {
    const { grameneMaps: grameneMaps, grameneTaxonomy: grameneTaxonomy, grameneGenomes: grameneGenomes } = props;
    const activeKeys = Object.keys(grameneGenomes.active || {});
    const seedAll = activeKeys.length === 0;
    const selected = new Set();
    Object.values(grameneMaps || {}).forEach((m)=>{
        if (m.hidden) return;
        if (seedAll || grameneGenomes.active[m.taxon_id]) selected.add(m.taxon_id);
    });
    const expanded = new Set();
    if (grameneTaxonomy) selected.forEach((tid)=>{
        let cur = grameneTaxonomy[tid];
        const seen = new Set();
        while(cur && !seen.has(cur._id)){
            seen.add(cur._id);
            expanded.add(cur._id);
            const pid = cur.is_a && cur.is_a[0];
            cur = pid ? grameneTaxonomy[pid] : null;
        }
    });
    return {
        selected: selected,
        expanded: expanded
    };
}
class $76e15aea9236bd47$var$TaxonomyModal extends $parcel$interopDefault($gXNCa$react).Component {
    constructor(props){
        super(props);
        const { selected: selected, expanded: expanded } = $76e15aea9236bd47$var$computeOpenState(props);
        this.state = {
            selected: selected,
            expanded: expanded,
            roots: $76e15aea9236bd47$var$buildRoots(props),
            query: '',
            highlightId: null,
            activeIdx: 0
        };
        this.rowRefs = {};
        this._matches = [];
        this._activeHitEl = null;
    }
    handleQueryChange(e) {
        this.setState({
            query: e.target.value,
            activeIdx: 0
        });
    }
    handleSearchKeyDown(e) {
        const n = this._matches.length;
        if (e.key === 'ArrowDown') {
            if (n === 0) return;
            e.preventDefault();
            this.setState({
                activeIdx: Math.min(this.state.activeIdx + 1, n - 1)
            });
        } else if (e.key === 'ArrowUp') {
            if (n === 0) return;
            e.preventDefault();
            this.setState({
                activeIdx: Math.max(this.state.activeIdx - 1, 0)
            });
        } else if (e.key === 'Enter') {
            if (n === 0) return;
            e.preventDefault();
            const hit = this._matches[this.state.activeIdx] || this._matches[0];
            if (hit) this.pickMatch(hit.node);
        } else if (e.key === 'Escape') {
            if (this.state.query) {
                e.preventDefault();
                this.setState({
                    query: '',
                    activeIdx: 0
                });
            }
        }
    }
    componentDidUpdate(prevProps, prevState) {
        // Maps or taxonomy arrived (or changed): rebuild the tree and reseed the
        // selection, which was empty if the modal mounted before the maps loaded.
        if (prevProps.grameneMaps !== this.props.grameneMaps || prevProps.grameneTaxonomy !== this.props.grameneTaxonomy) {
            const { selected: selected, expanded: expanded } = $76e15aea9236bd47$var$computeOpenState(this.props);
            this.setState({
                roots: $76e15aea9236bd47$var$buildRoots(this.props),
                selected: selected,
                expanded: expanded
            });
        }
        // On each hidden→shown transition, reseed selection from current active
        // genomes and expand every ancestor so selected taxa are visible.
        const wasShown = prevProps.grameneGenomes && prevProps.grameneGenomes.show;
        const isShown = this.props.grameneGenomes && this.props.grameneGenomes.show;
        if (!wasShown && isShown) {
            const { selected: selected, expanded: expanded } = $76e15aea9236bd47$var$computeOpenState(this.props);
            this.setState({
                selected: selected,
                expanded: expanded,
                query: '',
                activeIdx: 0,
                highlightId: null
            });
        }
        // Keep the highlighted hit scrolled into view inside the dropdown.
        if (prevState.activeIdx !== this.state.activeIdx && this._activeHitEl) this._activeHitEl.scrollIntoView({
            block: 'nearest'
        });
    }
    pickMatch(node) {
        // Expand every ancestor so the node is visible, then scroll + flash.
        const { grameneTaxonomy: grameneTaxonomy } = this.props;
        const expanded = new Set(this.state.expanded);
        let cur = node;
        const seen = new Set();
        while(cur && !seen.has(cur._id)){
            seen.add(cur._id);
            expanded.add(cur._id);
            const pid = cur.is_a && cur.is_a[0];
            cur = pid ? grameneTaxonomy[pid] : null;
        }
        this.setState({
            expanded: expanded,
            query: '',
            highlightId: node._id
        }, ()=>{
            const el = this.rowRefs[node._id];
            if (el && el.scrollIntoView) el.scrollIntoView({
                block: 'center',
                behavior: 'smooth'
            });
            clearTimeout(this._hlTimer);
            this._hlTimer = setTimeout(()=>this.setState({
                    highlightId: null
                }), 1800);
        });
    }
    toggleExpand(id) {
        const expanded = new Set(this.state.expanded);
        expanded.has(id) ? expanded.delete(id) : expanded.add(id);
        this.setState({
            expanded: expanded
        });
    }
    toggleLeaf(taxonId) {
        const selected = new Set(this.state.selected);
        selected.has(taxonId) ? selected.delete(taxonId) : selected.add(taxonId);
        this.setState({
            selected: selected
        });
    }
    toggleSubtree(terminal) {
        const selected = new Set(this.state.selected);
        const allOn = terminal.leafIds.every((id)=>selected.has(id));
        terminal.leafIds.forEach((id)=>allOn ? selected.delete(id) : selected.add(id));
        this.setState({
            selected: selected
        });
    }
    selectAll() {
        const s = new Set();
        Object.values(this.props.grameneMaps || {}).forEach((m)=>{
            if (!m.hidden) s.add(m.taxon_id);
        });
        this.setState({
            selected: s
        });
    }
    selectNone() {
        this.setState({
            selected: new Set()
        });
    }
    handleClose() {
        const active = {};
        this.state.selected.forEach((id)=>{
            active[id] = true;
        });
        if (Object.keys(active).length === 0) Object.values(this.props.grameneMaps || {}).forEach((m)=>{
            if (!m.hidden) active[m.taxon_id] = true;
        });
        this.props.doUpdateGrameneGenomes(active);
    }
    renderNode(node, depth, inheritedColor) {
        const { grameneTaxonomy: grameneTaxonomy, grameneMaps: grameneMaps } = this.props;
        const { selected: selected, expanded: expanded } = this.state;
        const { chain: rawChain, terminal: terminal } = $76e15aea9236bd47$var$compressChain(node, grameneTaxonomy, grameneMaps);
        const chain = $76e15aea9236bd47$var$dedupAdjacent(rawChain);
        const leafIds = terminal.leafIds;
        if (leafIds.length === 0) return null;
        const selCount = leafIds.reduce((n, id)=>n + (selected.has(id) ? 1 : 0), 0);
        const total = leafIds.length;
        const allOn = selCount === total;
        const someOn = selCount > 0 && !allOn;
        const visibleKids = (terminal.children || []).map((cid)=>grameneTaxonomy[cid]).filter((c)=>c && c.leafIds.length > 0);
        const hasKids = visibleKids.length > 0;
        const terminalIsGenome = !!(grameneMaps && grameneMaps[terminal._id]);
        const isOpen = expanded.has(terminal._id);
        // Deepest clade colour in the chain wins; falls back to inherited.
        const color = chain.reduce((acc, n)=>$76e15aea9236bd47$var$CLADE_COLORS[n.name] || acc, inheritedColor);
        const isHighlighted = rawChain.some((n)=>n._id === this.state.highlightId);
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
            className: "tax-node" + (isHighlighted ? " tax-node-highlight" : ""),
            style: {
                background: color
            },
            ref: (el)=>{
                // Register every traversed node (including dedupped-away parents) so
                // search results targeting any ancestor still scroll to this row.
                rawChain.forEach((n)=>{
                    this.rowRefs[n._id] = el;
                });
            },
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                    className: "tax-row",
                    style: {
                        paddingLeft: depth * 7
                    },
                    children: [
                        hasKids ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                            className: "tax-chevron",
                            onClick: ()=>this.toggleExpand(terminal._id),
                            children: isOpen ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsbs.BsChevronDown, {}) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsbs.BsChevronRight, {})
                        }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                            className: "tax-chevron-spacer"
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
                            type: "checkbox",
                            checked: allOn,
                            ref: (el)=>{
                                if (el) el.indeterminate = someOn;
                            },
                            onChange: ()=>{
                                if (hasKids) this.toggleSubtree(terminal);
                                else if (terminalIsGenome) this.toggleLeaf(terminal._id);
                            }
                        }),
                        ' ',
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                            className: hasKids ? "tax-label tax-label-internal" : "tax-label",
                            children: $76e15aea9236bd47$var$renderChain(chain)
                        }),
                        (hasKids || terminalIsGenome) && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                            className: "tax-count",
                            children: [
                                " (",
                                selCount,
                                " / ",
                                total,
                                ")"
                            ]
                        }),
                        hasKids && terminalIsGenome && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("label", {
                            className: "tax-self-leaf",
                            children: [
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
                                    type: "checkbox",
                                    checked: selected.has(terminal._id),
                                    onChange: ()=>this.toggleLeaf(terminal._id)
                                }),
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("em", {
                                    children: "this genome"
                                })
                            ]
                        })
                    ]
                }),
                hasKids && isOpen && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                    className: "tax-children",
                    children: visibleKids.map((c)=>this.renderNode(c, depth + 1, color))
                })
            ]
        }, terminal._id);
    }
    render() {
        const { roots: roots } = this.state;
        const { grameneTaxonomy: grameneTaxonomy, grameneMaps: grameneMaps } = this.props;
        // Hide the root spine: start rendering at the first real branch point.
        const topLevel = [];
        roots.forEach((r)=>{
            const { terminal: terminal } = $76e15aea9236bd47$var$compressChain(r, grameneTaxonomy || {}, grameneMaps || {});
            (terminal.children || []).forEach((cid)=>{
                const child = grameneTaxonomy && grameneTaxonomy[cid];
                if (child && child.leafIds && child.leafIds.length > 0) topLevel.push(child);
            });
        });
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Modal, {
            show: this.props.grameneGenomes.show,
            onHide: this.handleClose.bind(this),
            size: "lg",
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Modal.Header, {
                    closeButton: true,
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Modal.Title, {
                        children: "Select Genomes of Interest"
                    })
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Modal.Body, {
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                            variant: "outline-secondary",
                            onClick: this.selectAll.bind(this),
                            children: "All"
                        }),
                        ' ',
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                            variant: "outline-secondary",
                            onClick: this.selectNone.bind(this),
                            children: "None"
                        }),
                        (()=>{
                            this._matches = this.state.query ? $76e15aea9236bd47$var$searchTaxonomy(this.state.query, grameneTaxonomy || {}) : [];
                            const matches = this._matches;
                            const activeIdx = Math.min(this.state.activeIdx, Math.max(0, matches.length - 1));
                            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                className: "tax-search",
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
                                        type: "text",
                                        className: "tax-search-input",
                                        placeholder: "Find taxon by name or synonym\u2026",
                                        value: this.state.query,
                                        onChange: this.handleQueryChange.bind(this),
                                        onKeyDown: this.handleSearchKeyDown.bind(this)
                                    }),
                                    this.state.query && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                        className: "tax-search-results",
                                        children: matches.length === 0 ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                            className: "tax-search-empty",
                                            children: "No matches"
                                        }) : matches.map(({ node: node, matched: matched, via: via }, i)=>{
                                            const rank = $76e15aea9236bd47$var$getRank(node);
                                            const count = node.leafIds && node.leafIds.length || 0;
                                            const isLeaf = !!(grameneMaps && grameneMaps[node._id]);
                                            const isActive = i === activeIdx;
                                            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                                ref: (el)=>{
                                                    if (isActive) this._activeHitEl = el;
                                                },
                                                className: "tax-search-hit" + (isActive ? " tax-search-hit-active" : ""),
                                                onMouseDown: (e)=>e.preventDefault(),
                                                onMouseEnter: ()=>this.setState({
                                                        activeIdx: i
                                                    }),
                                                onClick: ()=>this.pickMatch(node),
                                                children: [
                                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                                        className: "tax-search-name",
                                                        children: node.name
                                                    }),
                                                    via === 'synonym' && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                                                        className: "tax-search-syn",
                                                        children: [
                                                            " ",
                                                            matched,
                                                            " ",
                                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("em", {
                                                                children: "syn."
                                                            })
                                                        ]
                                                    }),
                                                    rank && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                                                        className: "tax-search-rank",
                                                        children: [
                                                            " ",
                                                            rank
                                                        ]
                                                    }),
                                                    !isLeaf && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                                                        className: "tax-search-count",
                                                        children: [
                                                            " \xb7 ",
                                                            count,
                                                            " genome",
                                                            count === 1 ? '' : 's'
                                                        ]
                                                    })
                                                ]
                                            }, node._id);
                                        })
                                    })
                                ]
                            });
                        })(),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                            className: "tax-tree",
                            children: topLevel.map((n)=>this.renderNode(n, 0, null))
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                            onClick: this.handleClose.bind(this),
                            children: "Submit"
                        })
                    ]
                })
            ]
        });
    }
}
var $76e15aea9236bd47$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)('selectGrameneGenomes', 'selectGrameneMaps', 'selectGrameneTaxonomy', 'doUpdateGrameneGenomes', $76e15aea9236bd47$var$TaxonomyModal);
var $7zuJ6 = parcelRequire("7zuJ6");
const $261baeb81c4d4d8a$var$LazyStudy = $parcel$interopDefault($gXNCa$react).lazy(()=>Promise.resolve(parcelRequire("7zuJ6")));
const $261baeb81c4d4d8a$var$StudyList = (props)=>{
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Accordion, {
        alwaysOpen: true,
        defaultActiveKey: props.studies.length === 1 ? "study_0" : undefined,
        children: props.studies.map((study, idx)=>{
            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Accordion.Item, {
                eventKey: 'study_' + idx,
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Accordion.Header, {
                        children: study.description
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Accordion.Body, {
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($7zuJ6.default, {
                            id: study._id
                        })
                    })
                ]
            }, idx);
        })
    });
};
const $261baeb81c4d4d8a$var$Expression = (props)=>{
    let searchTaxa = {};
    if (props.grameneSearch) {
        const taxon_id_facet = props.grameneSearch.facet_counts.facet_fields.taxon_id;
        taxon_id_facet.filter((tid, idx)=>idx % 2 === 0).forEach((tid)=>{
            if (tid > 1000000) {
                const tid2 = Math.floor(tid / 1000);
                if (props.expressionStudies[tid2]) searchTaxa[tid2] = tid;
            } else searchTaxa[tid] = tid;
        });
    }
    const availableTaxa = Object.keys(props.expressionStudies).filter((tid)=>searchTaxa[tid]).sort((a, b)=>props.grameneMaps[searchTaxa[a]].left_index - props.grameneMaps[searchTaxa[b]].left_index);
    return availableTaxa && props.grameneTaxonomy && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                children: [
                    "This is where you can launch a component for the selected samples. props.desiredSamples lists them. This component can request the data from the API organize samples by factor metadata? One big table with all the studies?",
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Button, {
                        onClick: console.log(Object.keys(props.desiredSamples)),
                        children: [
                            "Show Samples (",
                            Object.keys(props.desiredSamples).length,
                            " selected)"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Accordion, {
                alwaysOpen: true,
                defaultActiveKey: availableTaxa.length === 1 ? "tax_0" : undefined,
                children: availableTaxa.map((tid, idx)=>{
                    const baselineStudies = props.expressionStudies[tid].filter((study)=>study.type === 'Baseline');
                    const n = baselineStudies.length;
                    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Accordion.Item, {
                        eventKey: 'tax_' + idx,
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Accordion.Header, {
                                children: [
                                    props.grameneTaxonomy[tid].name,
                                    " - ",
                                    n,
                                    " ",
                                    n === 1 ? 'study' : 'studies'
                                ]
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Accordion.Body, {
                                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($261baeb81c4d4d8a$var$StudyList, {
                                    studies: baselineStudies
                                })
                            })
                        ]
                    }, idx);
                })
            })
        ]
    });
};
var $261baeb81c4d4d8a$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)('selectConfiguration', 'selectGrameneSearch', 'selectGrameneTaxonomy', 'selectGrameneMaps', 'selectExpressionStudies', 'selectDesiredSamples', $261baeb81c4d4d8a$var$Expression);
// Conflict rows rendered before the "show N more" cap, mirroring the Refine
// sidebar's INITIAL_VISIBLE. A large paste can produce hundreds of conflicts.
const $3b525b9a0ec89bcb$var$INITIAL_VISIBLE = 25;
// Candidates shown per row before collapsing. Nothing guarantees 15 is the ceiling.
const $3b525b9a0ec89bcb$var$MAX_CANDIDATES = 50;
// Genome bulk buttons offered. More than this and the toolbar is worse than the rows.
const $3b525b9a0ec89bcb$var$MAX_GENOME_ACTIONS = 6;
// A collapsible bucket with a count, following facets/FacetCounts.js FacetGroup.
// An empty bucket renders nothing rather than an empty heading.
const $3b525b9a0ec89bcb$var$Bucket = ({ title: title, count: count, tone: tone, defaultOpen: defaultOpen, actions: actions, children: children })=>{
    const [open, setOpen] = (0, $gXNCa$react.useState)(!!defaultOpen);
    if (!count) return null;
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: `glr-bucket glr-bucket-${tone}`,
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "glr-bucket-header",
                onClick: ()=>setOpen(!open),
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        className: "glr-caret",
                        children: open ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsbs.BsChevronDown, {}) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsbs.BsChevronRight, {})
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        className: "glr-bucket-title",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        className: "glr-bucket-count",
                        children: count.toLocaleString()
                    }),
                    actions && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        className: "glr-bucket-actions",
                        children: actions
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "glr-bucket-body",
                children: children
            })
        ]
    });
};
/** "sorghum_bicolort2tcas" -> "Sorghum bicolort2tcas" */ function $3b525b9a0ec89bcb$var$speciesLabel(systemName) {
    if (!systemName) return null;
    const s = systemName.replace(/_/g, ' ');
    return s.charAt(0).toUpperCase() + s.slice(1);
}
/**
 * Pure resolver for a validation response.
 *
 * `choices` is keyed by INDEX into `ambiguous`, not by the input string: a pasted
 * token can be anything, and `obj['__proto__'] = [...]` on a plain object sets the
 * prototype instead of a key.
 *
 * An index with NO entry keeps *all* of that input's matches — the "nothing is
 * silently dropped" default. An index mapped to `[]` means the user explicitly
 * dropped the row, which is why every read tests `undefined` rather than falsiness.
 */ const $3b525b9a0ec89bcb$var$GeneListResolver = ({ validation: validation, choices: choices, meta: meta, onChange: onChange })=>{
    const [query, setQuery] = (0, $gXNCa$react.useState)('');
    const [showAll, setShowAll] = (0, $gXNCa$react.useState)(false);
    const [expanded, setExpanded] = (0, $gXNCa$react.useState)({});
    const { resolved: resolved, ambiguous: ambiguous, unknown: unknown } = validation;
    const keptFor = (i, a)=>choices[i] === undefined ? a.matches : choices[i];
    const setKept = (i, a, next)=>{
        const c = {
            ...choices
        };
        // Drop back to the default when everything is kept, so "untouched" and
        // "explicitly kept all" stay indistinguishable and the state stays small.
        if (next.length === a.matches.length) delete c[i];
        else c[i] = next;
        onChange(c);
    };
    const toggle = (i, a, id)=>{
        const cur = keptFor(i, a);
        setKept(i, a, cur.indexOf(id) === -1 ? [
            ...cur,
            id
        ] : cur.filter((x)=>x !== id));
    };
    /**
   * Which genomes would actually narrow something.
   *
   * A plain "prefer sorghum" button is useless on this index: 94 of its ~100
   * genomes are sorghum accessions, so a conflict like Sobic.001G000200 — whose
   * candidates are sorghum_bicolor and sorghum_bicolort2tcas — is entirely
   * sorghum on both sides. The useful axis is the individual genome, and only
   * those that would change a row are worth offering.
   */ const genomeActions = (0, $gXNCa$react.useMemo)(()=>{
        const tally = new Map();
        ambiguous.forEach((a)=>{
            const names = new Set();
            a.matches.forEach((id)=>{
                const d = meta[id];
                if (d && d.system_name) names.add(d.system_name);
            });
            names.forEach((sn)=>{
                const kept = a.matches.filter((id)=>meta[id] && meta[id].system_name === sn);
                // Only counts if it narrows: keeping every candidate is a no-op.
                if (kept.length && kept.length < a.matches.length) tally.set(sn, (tally.get(sn) || 0) + 1);
            });
        });
        return [
            ...tally.entries()
        ].sort((x, y)=>y[1] - x[1]).slice(0, $3b525b9a0ec89bcb$var$MAX_GENOME_ACTIONS);
    }, [
        ambiguous,
        meta
    ]);
    const applyGenome = (systemName)=>(e)=>{
            e.stopPropagation();
            const c = {
                ...choices
            };
            ambiguous.forEach((a, i)=>{
                const kept = a.matches.filter((id)=>meta[id] && meta[id].system_name === systemName);
                // Rows with no candidate in this genome are left exactly as they are,
                // rather than emptied.
                if (kept.length && kept.length < a.matches.length) c[i] = kept;
            });
            onChange(c);
        };
    const bulk = (mode)=>(e)=>{
            // These buttons sit inside the clickable header; don't collapse the section.
            e.stopPropagation();
            if (mode === 'all') return onChange({});
            const c = {};
            ambiguous.forEach((a, i)=>{
                if (mode === 'first' && a.matches.length > 1) c[i] = [
                    a.matches[0]
                ];
                if (mode === 'none') c[i] = [];
            });
            onChange(c);
        };
    const filtered = (0, $gXNCa$react.useMemo)(()=>{
        const q = query.trim().toLowerCase();
        const withIndex = ambiguous.map((a, i)=>({
                a: a,
                i: i
            }));
        if (!q) return withIndex;
        return withIndex.filter(({ a: a })=>a.input.toLowerCase().indexOf(q) !== -1 || a.matches.some((id)=>id.toLowerCase().indexOf(q) !== -1));
    }, [
        ambiguous,
        query
    ]);
    const shown = showAll ? filtered : filtered.slice(0, $3b525b9a0ec89bcb$var$INITIAL_VISIBLE);
    const candidate = (i, a, id)=>{
        const doc = meta[id];
        const kept = keptFor(i, a).indexOf(id) !== -1;
        const species = $3b525b9a0ec89bcb$var$speciesLabel(doc && doc.system_name);
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("label", {
            className: `glr-candidate${kept ? ' glr-candidate-kept' : ''}`,
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
                    type: "checkbox",
                    checked: kept,
                    onChange: ()=>toggle(i, a, id)
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    className: "glr-candidate-id",
                    children: id
                }),
                species ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    className: "glr-candidate-species",
                    children: species
                }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    className: "glr-candidate-species glr-muted",
                    children: "\u2026"
                }),
                doc && doc.description && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    className: "glr-candidate-desc",
                    title: doc.description,
                    children: doc.description
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                    type: "button",
                    className: "glr-only",
                    title: "Keep only this one",
                    onClick: ()=>setKept(i, a, [
                            id
                        ]),
                    children: "only"
                })
            ]
        }, id);
    };
    const row = ({ a: a, i: i })=>{
        const kept = keptFor(i, a);
        // Long candidate lists start collapsed so a 15-match row doesn't bury the rest.
        const isOpen = expanded[i] !== undefined ? expanded[i] : a.matches.length <= 3;
        const visible = isOpen ? a.matches.slice(0, $3b525b9a0ec89bcb$var$MAX_CANDIDATES) : [];
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
            className: "glr-row",
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                    className: "glr-input",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                            type: "button",
                            className: "glr-row-toggle",
                            onClick: ()=>setExpanded((s)=>({
                                        ...s,
                                        [i]: !isOpen
                                    })),
                            children: isOpen ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsbs.BsChevronDown, {}) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsbs.BsChevronRight, {})
                        }),
                        a.input,
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Badge, {
                            bg: kept.length === 0 ? 'danger' : 'secondary',
                            className: "glr-input-count",
                            children: [
                                kept.length,
                                "/",
                                a.matches.length
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                    className: "glr-candidates",
                    children: isOpen ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
                        children: [
                            visible.map((id)=>candidate(i, a, id)),
                            a.matches.length > $3b525b9a0ec89bcb$var$MAX_CANDIDATES && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                                className: "glr-hint",
                                children: [
                                    "\u2026 ",
                                    a.matches.length - $3b525b9a0ec89bcb$var$MAX_CANDIDATES,
                                    " more. Search to narrow."
                                ]
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                                className: "glr-row-bulk",
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                                        type: "button",
                                        className: "glr-only",
                                        onClick: ()=>setKept(i, a, a.matches),
                                        children: "all"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                                        type: "button",
                                        className: "glr-only",
                                        onClick: ()=>setKept(i, a, []),
                                        children: "none"
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                        className: "glr-collapsed",
                        children: [
                            a.matches.length,
                            " candidates \u2014 ",
                            kept.length === a.matches.length ? 'all kept' : `${kept.length} kept`
                        ]
                    })
                })
            ]
        }, i);
    };
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "glr",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($3b525b9a0ec89bcb$var$Bucket, {
                title: "Conflicts \u2014 one identifier, several genes",
                count: ambiguous.length,
                tone: "warn",
                defaultOpen: true,
                actions: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                            size: "sm",
                            variant: "outline-secondary",
                            onClick: bulk('first'),
                            children: "Keep first"
                        }),
                        ' ',
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                            size: "sm",
                            variant: "outline-secondary",
                            onClick: bulk('none'),
                            children: "Drop all"
                        }),
                        ' ',
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                            size: "sm",
                            variant: "outline-secondary",
                            onClick: bulk('all'),
                            children: "Reset"
                        })
                    ]
                }),
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("p", {
                        className: "glr-hint",
                        children: [
                            "These identifiers match more than one gene. ",
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("strong", {
                                children: "All matches are kept unless you narrow them"
                            }),
                            " \u2014 untick what you don't want, or use",
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("em", {
                                children: " only"
                            }),
                            " to keep a single gene."
                        ]
                    }),
                    genomeActions.length > 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                        className: "glr-genomes",
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                className: "glr-hint glr-genomes-label",
                                children: "Keep only matches from:"
                            }),
                            genomeActions.map(([sn, n])=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Button, {
                                    size: "sm",
                                    variant: "outline-primary",
                                    className: "glr-genome-btn",
                                    onClick: applyGenome(sn),
                                    children: [
                                        $3b525b9a0ec89bcb$var$speciesLabel(sn),
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Badge, {
                                            bg: "light",
                                            text: "dark",
                                            className: "glr-genome-count",
                                            children: [
                                                "narrows ",
                                                n.toLocaleString()
                                            ]
                                        })
                                    ]
                                }, sn))
                        ]
                    }),
                    ambiguous.length > $3b525b9a0ec89bcb$var$INITIAL_VISIBLE && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Form.Control, {
                        type: "search",
                        size: "sm",
                        className: "glr-search",
                        placeholder: "Search conflicts\u2026",
                        value: query,
                        onChange: (e)=>{
                            setQuery(e.target.value);
                            setShowAll(false);
                        }
                    }),
                    shown.map(row),
                    filtered.length > shown.length && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("button", {
                        type: "button",
                        className: "glr-more",
                        onClick: ()=>setShowAll(true),
                        children: [
                            "show ",
                            (filtered.length - shown.length).toLocaleString(),
                            " more"
                        ]
                    }),
                    query && filtered.length === 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("p", {
                        className: "glr-hint",
                        children: [
                            "No conflicts match \u201C",
                            query,
                            "\u201D."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($3b525b9a0ec89bcb$var$Bucket, {
                title: "Resolved",
                count: resolved.length,
                tone: "ok",
                defaultOpen: false,
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                    className: "glr-resolved",
                    children: resolved.map((r, i)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                            className: "glr-resolved-row",
                            children: [
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                    className: "glr-resolved-input",
                                    children: r.input
                                }),
                                r.input !== r.id && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                            className: "glr-arrow",
                                            children: "\u2192"
                                        }),
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                            className: "glr-resolved-id",
                                            children: r.id
                                        })
                                    ]
                                })
                            ]
                        }, i))
                })
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($3b525b9a0ec89bcb$var$Bucket, {
                title: "Not recognised",
                count: unknown.length,
                tone: "bad",
                defaultOpen: false,
                actions: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                    size: "sm",
                    variant: "outline-secondary",
                    onClick: (e)=>{
                        e.stopPropagation();
                        navigator.clipboard && navigator.clipboard.writeText(unknown.join('\n'));
                    },
                    children: "Copy"
                }),
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("p", {
                        className: "glr-hint",
                        children: "No gene matches these. Matching is case-sensitive for stable IDs, so a lowercased ID may not be found even when the gene exists."
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("pre", {
                        className: "glr-unknown",
                        children: unknown.join('\n')
                    })
                ]
            })
        ]
    });
};
var $3b525b9a0ec89bcb$export$2e2bcd8739ae039 = $3b525b9a0ec89bcb$var$GeneListResolver;
// Client for the gene-lists API ({api}/gene_lists*).
//
// Mirrors the shape of bundles/savedViews.js: Firebase Bearer token, one
// status -> message mapper so every call site reports failures the same way, and
// JSON request bodies. Deliberately a plain module rather than a redux bundle —
// the feature is self-contained in UserGeneLists and shares no state.
// Server-side limits, mirrored so we can say something useful instead of
// surfacing a bare 400.
const $4abf453405c18681$export$7fadd81f3363fc57 = 6000;
const $4abf453405c18681$export$7f2835aa6d834dde = 255;
// Candidate hydration passes ids through the URL. ~500 ids is a 414 (the URL
// crosses ~8.5KB), so batch well under that.
const $4abf453405c18681$var$HYDRATE_BATCH = 150;
function $4abf453405c18681$export$cbb0be6dabd4295(action, status) {
    if (status === 401) return new Error(`${action} failed \u{2014} please sign in again.`);
    if (status === 404) return new Error(`${action} failed \u{2014} that list no longer exists.`);
    if (status === 405) return new Error('Gene lists are not available on this server yet.');
    if (status === 502 || status === 503) return new Error(`${action} failed \u{2014} the gene index is unreachable. Try again shortly.`);
    return new Error(`${action} failed (${status})`);
}
// The API returns {message} on most 4xx; prefer it, since it names the offending
// field (e.g. which limit was exceeded).
async function $4abf453405c18681$var$readError(res, action) {
    try {
        const body = await res.json();
        if (body && body.message) return new Error(body.message);
    } catch (e) {
    // not JSON — fall through to the status mapper
    }
    return $4abf453405c18681$export$cbb0be6dabd4295(action, res.status);
}
async function $4abf453405c18681$export$6c06d9a9d837c44e(api, ids) {
    const res = await fetch(`${api}/gene_lists/validate`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(ids)
    });
    if (!res.ok) throw await $4abf453405c18681$var$readError(res, 'Validation');
    const body = await res.json();
    // Be strict about the contract. A server still returning the old
    // {ids, missing, hash} shape must fail here and say so, rather than quietly
    // validating nothing — which is exactly how the previous client broke.
    if (!body || !Array.isArray(body.resolved)) throw new Error('Unexpected response from the validation service (is the server up to date?).');
    return {
        resolved: body.resolved || [],
        ambiguous: body.ambiguous || [],
        unknown: body.unknown || []
    };
}
async function $4abf453405c18681$export$41928ff990e251ce(api, ids) {
    const unique = [
        ...new Set(ids)
    ].filter(Boolean);
    const out = {};
    for(let i = 0; i < unique.length; i += $4abf453405c18681$var$HYDRATE_BATCH){
        const batch = unique.slice(i, i + $4abf453405c18681$var$HYDRATE_BATCH);
        // {!terms} takes its values literally, so no id needs escaping, and it sits in
        // `fq`, where Solr local params are reliable.
        const fq = encodeURIComponent(`{!terms f=id}${batch.join(',')}`);
        // `rows` is mandatory. Without it the endpoint answers with its default of 20
        // and the rest of the batch silently disappears.
        const url = `${api}/search?q=*:*&fq=${fq}&rows=${batch.length}` + `&fl=id,name,system_name,description`;
        try {
            const res = await fetch(url);
            if (!res.ok) continue;
            const body = await res.json();
            const docs = body && body.response && body.response.docs || [];
            docs.forEach((d)=>{
                if (d && d.id) out[d.id] = d;
            });
        } catch (e) {
        // leave this batch un-hydrated
        }
    }
    return out;
}
async function $4abf453405c18681$export$87f42b3480ee6c49(api, token, { label: label, site: site, isPublic: isPublic, ids: ids }) {
    const res = await fetch(`${api}/gene_lists`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
            label: label,
            site: site,
            isPublic: !!isPublic,
            ids: ids
        })
    });
    if (!res.ok) throw await $4abf453405c18681$var$readError(res, 'Save');
    return res.json();
}
const $0f50f369018a42ef$var$formatDate = (value)=>{
    if (!value) return '';
    const d = new Date(value);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString();
};
const $0f50f369018a42ef$var$applySortFilter = (lists, search, sort)=>{
    const s = search.trim().toLowerCase();
    let result = s ? lists.filter((l)=>(l.label || '').toLowerCase().includes(s)) : lists.slice();
    const { key: key, dir: dir } = sort;
    const mult = dir === 'asc' ? 1 : -1;
    result.sort((a, b)=>{
        let av = a[key], bv = b[key];
        if (key === 'createdAt' || key === 'deletedAt') {
            av = av ? new Date(av).getTime() : 0;
            bv = bv ? new Date(bv).getTime() : 0;
        } else if (key === 'n_genes') {
            av = av || 0;
            bv = bv || 0;
        } else {
            av = (av || '').toString().toLowerCase();
            bv = (bv || '').toString().toLowerCase();
        }
        if (av < bv) return -1 * mult;
        if (av > bv) return 1 * mult;
        return 0;
    });
    return result;
};
const $0f50f369018a42ef$var$SortHeader = ({ label: label, sortKey: sortKey, sort: sort, onToggle: onToggle })=>{
    const active = sort.key === sortKey;
    const indicator = active ? sort.dir === 'asc' ? " \u25B2" : " \u25BC" : '';
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("th", {
        style: {
            cursor: 'pointer',
            userSelect: 'none',
            position: 'sticky',
            top: 0,
            background: '#fff',
            zIndex: 1
        },
        onClick: ()=>onToggle(sortKey),
        children: [
            label,
            indicator
        ]
    });
};
const $0f50f369018a42ef$var$stickyHeaderStyle = {
    position: 'sticky',
    top: 0,
    background: '#fff',
    zIndex: 1
};
const $0f50f369018a42ef$var$GeneListDisplayComponent = (props)=>{
    const [publicGeneLists, setPublicGeneLists] = (0, $gXNCa$react.useState)([]);
    const [privateGeneLists, setPrivateGeneLists] = (0, $gXNCa$react.useState)([]);
    const [error, setError] = (0, $gXNCa$react.useState)(null);
    const [notice, setNotice] = (0, $gXNCa$react.useState)(null);
    const [user, setUser] = (0, $gXNCa$react.useState)({});
    const [viewMode, setViewMode] = (0, $gXNCa$react.useState)('active'); // 'active' | 'trash'
    const [editingId, setEditingId] = (0, $gXNCa$react.useState)(null);
    const [editLabel, setEditLabel] = (0, $gXNCa$react.useState)('');
    const [editIsPublic, setEditIsPublic] = (0, $gXNCa$react.useState)(false);
    const [deleteTarget, setDeleteTarget] = (0, $gXNCa$react.useState)(null); // { list, permanent }
    const [search, setSearch] = (0, $gXNCa$react.useState)('');
    const [sort, setSort] = (0, $gXNCa$react.useState)({
        key: 'createdAt',
        dir: 'desc'
    });
    const auth = props.auth;
    const isTrash = viewMode === 'trash';
    (0, $gXNCa$react.useEffect)(()=>{
        if (!auth) return;
        const unsubscribe = (0, $gXNCa$firebaseauth.onAuthStateChanged)(auth, (u)=>setUser(u));
        return ()=>unsubscribe();
    }, [
        auth
    ]);
    const toggleSort = (key)=>setSort((s)=>s.key === key ? {
                key: key,
                dir: s.dir === 'asc' ? 'desc' : 'asc'
            } : {
                key: key,
                dir: 'asc'
            });
    const currentUid = user && user.uid;
    const mergedLists = (0, $gXNCa$react.useMemo)(()=>{
        const byId = new Map();
        [
            ...publicGeneLists,
            ...privateGeneLists
        ].forEach((l)=>byId.set(l._id, l));
        return Array.from(byId.values());
    }, [
        publicGeneLists,
        privateGeneLists
    ]);
    const displayedLists = (0, $gXNCa$react.useMemo)(()=>$0f50f369018a42ef$var$applySortFilter(mergedLists, search, sort), [
        mergedLists,
        search,
        sort
    ]);
    // includeDeleted: 'active' (default) or 'trash'. Trash is auth-only and holds
    // the caller's own soft-deleted lists (restorable for 30 days).
    const fetchPrivateGeneLists = async (includeDeleted = 'active')=>{
        if (!auth) {
            setPrivateGeneLists([]);
            setError(null);
            setNotice(null);
            return;
        }
        if (!user || typeof user.getIdToken !== 'function') {
            setPrivateGeneLists([]);
            setError(null);
            setNotice(includeDeleted === 'trash' ? 'Log in to view your deleted gene lists.' : 'Log in to create and manage your personal gene lists.');
            return;
        }
        try {
            const token = await user.getIdToken();
            const response = await fetch(`${props.api}/gene_lists?site=${props.site}&isPublic=false&includeDeleted=${includeDeleted}`, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });
            const result = await response.json();
            if (response.ok) {
                setError(null);
                // Keep any restore/delete notice; only clear the "log in" prompt.
                setNotice((n)=>n && /Log in/.test(n) ? null : n);
                setPrivateGeneLists(result);
            } else setError('Error fetching gene lists.');
        } catch (err) {
            setError('Failed to fetch private gene lists. Please try again later.');
        }
    };
    // Public lists are always active (soft-deleted lists are never public-visible;
    // the trash view is caller-scoped).
    const fetchPublicGeneLists = async ()=>{
        try {
            const response = await fetch(`${props.api}/gene_lists?site=${props.site}&isPublic=true`);
            const result = await response.json();
            if (response.ok) setPublicGeneLists(result);
            else setError('Error fetching gene lists.');
        } catch (err) {
            setError('Failed to fetch gene lists. Please try again later.');
        }
    };
    const refresh = ()=>{
        if (isTrash) {
            setPublicGeneLists([]);
            fetchPrivateGeneLists('trash');
        } else {
            fetchPublicGeneLists();
            fetchPrivateGeneLists('active');
        }
    };
    // Fetch when the user, view mode, or an external save (refreshKey) changes.
    (0, $gXNCa$react.useEffect)(()=>{
        refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        user,
        viewMode,
        props.refreshKey
    ]);
    // A logged-out user has no trash; fall back to the active (public) view.
    (0, $gXNCa$react.useEffect)(()=>{
        if (!currentUid && isTrash) setViewMode('active');
    }, [
        currentUid,
        isTrash
    ]);
    const switchView = (mode)=>{
        setViewMode(mode);
        setEditingId(null);
        setSearch('');
        setNotice(null);
        setSort({
            key: mode === 'trash' ? 'deletedAt' : 'createdAt',
            dir: 'desc'
        });
    };
    const viewGeneList = (list)=>{
        props.addFilter({
            category: 'Gene List',
            fq_field: 'saved_search',
            fq_value: list.hash,
            name: list.label
        });
    };
    const startEdit = (list)=>{
        setEditingId(list._id);
        setEditLabel(list.label || '');
        setEditIsPublic(!!list.isPublic);
    };
    const cancelEdit = ()=>{
        setEditingId(null);
        setEditLabel('');
        setEditIsPublic(false);
    };
    const saveEdit = async (listId)=>{
        try {
            const token = await user.getIdToken();
            const response = await fetch(`${props.api}/gene_lists?listId=${encodeURIComponent(listId)}`, {
                method: 'PATCH',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({
                    label: editLabel,
                    isPublic: editIsPublic
                })
            });
            if (response.ok) {
                cancelEdit();
                setError(null);
                refresh();
            } else if (response.status === 401) setError('You must be signed in to edit a gene list.');
            else if (response.status === 404) setError('Gene list not found or you do not own it.');
            else if (response.status === 400) setError("Nothing to update \u2014 please enter a label.");
            else setError('Failed to update gene list.');
        } catch (err) {
            setError('Failed to update gene list.');
        }
    };
    const restoreList = async (list)=>{
        try {
            const token = await user.getIdToken();
            const response = await fetch(`${props.api}/gene_lists/restore?listId=${encodeURIComponent(list._id)}`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });
            if (response.ok) {
                setError(null);
                setNotice(`Restored \u{201C}${list.label}\u{201D}.`);
                refresh();
            } else if (response.status === 404) setError('This list has been purged and can no longer be restored.');
            else if (response.status === 401) setError('You must be signed in to restore a gene list.');
            else setError('Failed to restore gene list.');
        } catch (err) {
            setError('Failed to restore gene list.');
        }
    };
    const requestDelete = (list, permanent)=>setDeleteTarget({
            list: list,
            permanent: !!permanent
        });
    const cancelDelete = ()=>setDeleteTarget(null);
    // Default DELETE is a soft delete (moves to trash, restorable 30 days).
    // `force=true` permanently removes it (offered from the trash view).
    const confirmDelete = async ()=>{
        if (!deleteTarget) return;
        const { list: list, permanent: permanent } = deleteTarget;
        setDeleteTarget(null);
        try {
            const token = await user.getIdToken();
            const url = `${props.api}/gene_lists?listId=${encodeURIComponent(list._id)}${permanent ? '&force=true' : ''}`;
            const response = await fetch(url, {
                method: 'DELETE',
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            if (response.ok) {
                setError(null);
                setNotice(permanent ? `Permanently deleted \u{201C}${list.label}\u{201D}.` : `Moved \u{201C}${list.label}\u{201D} to trash \u{2014} restore within 30 days from the Trash tab.`);
                refresh();
            } else if (response.status === 401) setError('You must be signed in to delete a gene list.');
            else if (response.status === 404) setError('Gene list not found or you do not own it.');
            else setError('Failed to delete gene list.');
        } catch (err) {
            setError('Failed to delete gene list.');
        }
    };
    const dateKey = isTrash ? 'deletedAt' : 'createdAt';
    const dateLabel = isTrash ? 'Deleted' : 'Created';
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "gene-list-display-component",
        children: [
            error && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Alert, {
                variant: "danger",
                onClose: ()=>setError(null),
                dismissible: true,
                children: error
            }),
            notice && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Alert, {
                variant: "info",
                onClose: ()=>setNotice(null),
                dismissible: true,
                children: notice
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "d-flex justify-content-between align-items-center mb-2 mt-4",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.ButtonGroup, {
                        size: "sm",
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                                variant: !isTrash ? 'primary' : 'outline-secondary',
                                onClick: ()=>switchView('active'),
                                children: "Active"
                            }),
                            currentUid && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                                variant: isTrash ? 'primary' : 'outline-secondary',
                                onClick: ()=>switchView('trash'),
                                children: "Trash"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Form.Control, {
                        type: "search",
                        placeholder: "Search...",
                        value: search,
                        onChange: (e)=>setSearch(e.target.value),
                        style: {
                            maxWidth: 220
                        },
                        size: "sm"
                    })
                ]
            }),
            mergedLists.length > 0 ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                style: {
                    maxHeight: 500,
                    overflowY: 'auto',
                    border: '1px solid #dee2e6',
                    borderRadius: 4
                },
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Table, {
                    striped: true,
                    hover: true,
                    className: "mb-0",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($0f50f369018a42ef$var$SortHeader, {
                                        label: "List Name",
                                        sortKey: "label",
                                        sort: sort,
                                        onToggle: toggleSort
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($0f50f369018a42ef$var$SortHeader, {
                                        label: "Owner",
                                        sortKey: "owner",
                                        sort: sort,
                                        onToggle: toggleSort
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($0f50f369018a42ef$var$SortHeader, {
                                        label: "Genes",
                                        sortKey: "n_genes",
                                        sort: sort,
                                        onToggle: toggleSort
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($0f50f369018a42ef$var$SortHeader, {
                                        label: dateLabel,
                                        sortKey: dateKey,
                                        sort: sort,
                                        onToggle: toggleSort
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("th", {
                                        style: $0f50f369018a42ef$var$stickyHeaderStyle,
                                        children: "Actions"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("tbody", {
                            children: displayedLists.map((list, index)=>{
                                const isMine = currentUid && list.uid === currentUid;
                                const ownerLabel = isMine ? 'You' : list.owner || 'Unknown';
                                const dateVal = $0f50f369018a42ef$var$formatDate(isTrash ? list.deletedAt : list.createdAt);
                                return !isTrash && editingId === list._id ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("td", {
                                            children: [
                                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Form.Control, {
                                                    type: "text",
                                                    value: editLabel,
                                                    onChange: (e)=>setEditLabel(e.target.value),
                                                    placeholder: "List name"
                                                }),
                                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Form.Check, {
                                                    type: "switch",
                                                    id: `edit-public-${list._id}`,
                                                    label: "Public",
                                                    checked: editIsPublic,
                                                    onChange: ()=>setEditIsPublic(!editIsPublic),
                                                    className: "mt-2"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                                            children: ownerLabel
                                        }),
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                                            children: list.n_genes || 0
                                        }),
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                                            children: dateVal
                                        }),
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("td", {
                                            children: [
                                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                                                    variant: "primary",
                                                    size: "sm",
                                                    onClick: ()=>saveEdit(list._id),
                                                    children: "Save"
                                                }),
                                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                                                    variant: "outline-secondary",
                                                    size: "sm",
                                                    onClick: cancelEdit,
                                                    className: "ml-2",
                                                    children: "Cancel"
                                                })
                                            ]
                                        })
                                    ]
                                }, index) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("td", {
                                            children: [
                                                list.label,
                                                list.isPublic ? ' (public)' : ''
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                                            children: ownerLabel
                                        }),
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                                            children: list.n_genes || 0
                                        }),
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                                            children: dateVal
                                        }),
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                                            children: isTrash ? isMine && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                                                        variant: "outline-success",
                                                        size: "sm",
                                                        onClick: ()=>restoreList(list),
                                                        children: "Restore"
                                                    }),
                                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                                                        variant: "outline-danger",
                                                        size: "sm",
                                                        onClick: ()=>requestDelete(list, true),
                                                        className: "ml-2",
                                                        children: "Delete forever"
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                                                        variant: "outline-secondary",
                                                        size: "sm",
                                                        onClick: ()=>viewGeneList(list),
                                                        children: "View"
                                                    }),
                                                    isMine && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                                                        variant: "outline-secondary",
                                                        size: "sm",
                                                        onClick: ()=>startEdit(list),
                                                        className: "ml-2",
                                                        children: "Edit"
                                                    }),
                                                    isMine && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                                                        variant: "outline-danger",
                                                        size: "sm",
                                                        onClick: ()=>requestDelete(list, false),
                                                        className: "ml-2",
                                                        children: "Delete"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, index);
                            })
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Alert, {
                variant: "warning",
                className: "mt-2",
                children: isTrash ? 'Trash is empty.' : 'No saved gene lists found.'
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Modal, {
                show: !!deleteTarget,
                onHide: cancelDelete,
                centered: true,
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Modal.Header, {
                        closeButton: true,
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Modal.Title, {
                            children: deleteTarget && deleteTarget.permanent ? 'Permanently delete gene list?' : 'Move gene list to trash?'
                        })
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Modal.Body, {
                        children: deleteTarget && deleteTarget.permanent ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
                            children: [
                                "Permanently delete ",
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("strong", {
                                    children: deleteTarget.list.label
                                }),
                                "? This cannot be undone."
                            ]
                        }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
                            children: [
                                "Move ",
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("strong", {
                                    children: deleteTarget ? deleteTarget.list.label : 'this list'
                                }),
                                " to trash?",
                                ' ',
                                "You can restore it within 30 days from the Trash tab."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Modal.Footer, {
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                                variant: "secondary",
                                onClick: cancelDelete,
                                autoFocus: true,
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                                variant: "danger",
                                onClick: confirmDelete,
                                children: deleteTarget && deleteTarget.permanent ? 'Delete forever' : 'Move to trash'
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $0f50f369018a42ef$var$GeneListComponent = (props)=>{
    const [geneList, setGeneList] = (0, $gXNCa$react.useState)('');
    const [listName, setListName] = (0, $gXNCa$react.useState)('');
    const [listIsPublic, setListIsPublic] = (0, $gXNCa$react.useState)(false);
    // The three-bucket validate response, the user's narrowing decisions, and the
    // hydrated gene docs used to label candidates.
    const [validation, setValidation] = (0, $gXNCa$react.useState)(null);
    const [choices, setChoices] = (0, $gXNCa$react.useState)({});
    const [meta, setMeta] = (0, $gXNCa$react.useState)({});
    const [errorMessage, setErrorMessage] = (0, $gXNCa$react.useState)('');
    const [notice, setNotice] = (0, $gXNCa$react.useState)('');
    const [loading, setLoading] = (0, $gXNCa$react.useState)(false);
    const [saving, setSaving] = (0, $gXNCa$react.useState)(false);
    // null, not {}: the initial value is read to decide whether Save is enabled, and
    // an empty object is truthy, which used to offer Save to a logged-out visitor.
    const [user, setUser] = (0, $gXNCa$react.useState)(null);
    const auth = props.auth;
    (0, $gXNCa$react.useEffect)(()=>{
        if (!auth) return;
        const unsubscribe = (0, $gXNCa$firebaseauth.onAuthStateChanged)(auth, (u)=>setUser(u));
        return ()=>unsubscribe();
    }, [
        auth
    ]);
    // The single source of truth for what gets saved. An ambiguous input the user
    // never touched contributes ALL of its matches, so nothing is silently dropped;
    // narrowing is a choice, not a requirement.
    // `choices[i] === undefined` means untouched -> keep all. `choices[i] === []`
    // means the user explicitly dropped the row, so this must NOT be `|| a.matches`:
    // an empty array is falsy, and that would silently re-add everything they just
    // removed.
    const keptFor = (i, a)=>choices[i] === undefined ? a.matches : choices[i];
    const idsToSave = (0, $gXNCa$react.useMemo)(()=>{
        if (!validation) return [];
        const out = validation.resolved.map((r)=>r.id);
        validation.ambiguous.forEach((a, i)=>out.push(...keptFor(i, a)));
        // Mandatory, not tidiness: the same gene reaches this list twice routinely —
        // two inputs can resolve to one id, and a resolved id can also appear among
        // another input's candidates. Duplicates would inflate n_genes and change the
        // server's content hash, breaking the save endpoint's idempotency.
        return [
            ...new Set(out)
        ];
    }, [
        validation,
        choices
    ]);
    // How much of the total came from conflicts, for the summary line — with
    // keep-all-by-default a single identifier can contribute 15 genes.
    const fromConflicts = (0, $gXNCa$react.useMemo)(()=>{
        if (!validation) return 0;
        return validation.ambiguous.reduce((n, a, i)=>n + keptFor(i, a).length, 0);
    }, [
        validation,
        choices
    ]);
    // Function to handle gene list input
    const handleGeneListChange = (event)=>{
        setGeneList(event.target.value);
    };
    // Function to handle drag and drop of gene list
    const handleDrop = (event)=>{
        event.preventDefault();
        const geneData = event.dataTransfer.getData('text');
        setGeneList(geneData);
    };
    // Function to handle drag over (needed for drop)
    const handleDragOver = (event)=>{
        event.preventDefault();
    };
    // Function to submit gene list for validation
    const handleSubmit = async ()=>{
        // The server only drops blanks and duplicates; splitting and trimming is ours
        // to do. Accept commas, tabs and semicolons as well as newlines.
        const geneArray = [
            ...new Set(geneList.split(/[\s,;]+/).map((s)=>s.trim()).filter(Boolean))
        ];
        if (geneArray.length === 0) {
            setErrorMessage('Paste at least one gene identifier.');
            return;
        }
        if (geneArray.length > $4abf453405c18681$export$7fadd81f3363fc57) {
            setErrorMessage(`That is ${geneArray.length.toLocaleString()} identifiers; the limit is ${$4abf453405c18681$export$7fadd81f3363fc57.toLocaleString()}.`);
            return;
        }
        setErrorMessage('');
        setNotice('');
        setLoading(true);
        try {
            const result = await $4abf453405c18681$export$6c06d9a9d837c44e(props.api, geneArray);
            setValidation(result);
            setChoices({});
            // Candidates are only choosable if the user can see what they are, so pull
            // species/description for every candidate id. Best-effort and non-blocking:
            // the resolver renders bare ids until this lands.
            const candidateIds = result.ambiguous.reduce((acc, a)=>acc.concat(a.matches), []);
            if (candidateIds.length) $4abf453405c18681$export$41928ff990e251ce(props.api, candidateIds).then(setMeta).catch(()=>{});
            else setMeta({});
        } catch (error) {
            setValidation(null);
            setErrorMessage(error.message || 'There was an error with the validation service.');
        } finally{
            setLoading(false);
        }
    };
    // Function to save the validated gene list
    const handleSaveList = async ()=>{
        setErrorMessage('');
        setNotice('');
        setSaving(true);
        try {
            // Inside the try: getIdToken() rejects when the session has expired, and
            // that used to escape as an unhandled rejection with no UI feedback.
            const token = await user.getIdToken();
            const result = await $4abf453405c18681$export$87f42b3480ee6c49(props.api, token, {
                label: listName,
                site: props.site,
                isPublic: listIsPublic,
                ids: idsToSave
            });
            setGeneList('');
            setValidation(null);
            setChoices({});
            setMeta({});
            setListName('');
            setListIsPublic(false);
            setNotice(`Saved \u{201C}${listName}\u{201D} \u{2014} ${(result.n_genes || idsToSave.length).toLocaleString()} genes.`);
            if (props.onListSaved) props.onListSaved();
        } catch (error) {
            setErrorMessage(error.message || 'Failed to save the gene list.');
        } finally{
            setSaving(false);
        }
    };
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "gene-list-component",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Form, {
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Form.Group, {
                        controlId: "geneList",
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Form.Label, {
                                children: "Paste or drop your gene list here:"
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Form.Control, {
                                as: "textarea",
                                rows: 10,
                                value: geneList,
                                onChange: handleGeneListChange,
                                placeholder: `Paste or drop your gene list here (Maximum: ${$4abf453405c18681$export$7fadd81f3363fc57} IDs)`,
                                onDrop: handleDrop,
                                onDragOver: handleDragOver
                            })
                        ]
                    }),
                    errorMessage && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Alert, {
                        variant: "danger",
                        dismissible: true,
                        onClose: ()=>setErrorMessage(''),
                        children: errorMessage
                    }),
                    notice && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Alert, {
                        variant: "success",
                        dismissible: true,
                        onClose: ()=>setNotice(''),
                        children: notice
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                        variant: "primary",
                        onClick: handleSubmit,
                        children: "Validate Gene List"
                    })
                ]
            }),
            loading && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "validation-summary mt-4",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("h3", {
                        children: "Validation in Progress..."
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Spinner, {
                        animation: "border",
                        role: "status",
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                            className: "sr-only",
                            children: "Validating..."
                        })
                    })
                ]
            }),
            !loading && validation && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($3b525b9a0ec89bcb$export$2e2bcd8739ae039, {
                        validation: validation,
                        choices: choices,
                        meta: meta,
                        onChange: setChoices
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                        className: "glr-summary",
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                className: "glr-summary-total",
                                children: idsToSave.length.toLocaleString()
                            }),
                            ' ',
                            "gene",
                            idsToSave.length === 1 ? '' : 's',
                            " will be saved",
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                className: "glr-summary-detail",
                                children: [
                                    validation.resolved.length.toLocaleString(),
                                    " identifier",
                                    validation.resolved.length === 1 ? '' : 's',
                                    " matched exactly one gene",
                                    validation.ambiguous.length > 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
                                        children: [
                                            '; ',
                                            validation.ambiguous.length.toLocaleString(),
                                            " conflicting identifier",
                                            validation.ambiguous.length === 1 ? '' : 's',
                                            " contributing",
                                            ' ',
                                            fromConflicts.toLocaleString(),
                                            " candidate",
                                            fromConflicts === 1 ? '' : 's',
                                            Object.keys(choices).length > 0 && ` (${Object.keys(choices).length.toLocaleString()} narrowed)`
                                        ]
                                    }),
                                    '. ',
                                    "Genes matched more than once are counted once."
                                ]
                            })
                        ]
                    })
                ]
            }),
            !loading && idsToSave.length > 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "save-list mt-4",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Form.Group, {
                        controlId: "listName",
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Form.Label, {
                                children: "Save Validated Gene List"
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Form.Control, {
                                type: "text",
                                value: listName,
                                onChange: (e)=>setListName(e.target.value),
                                placeholder: "Enter list name"
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Form.Check, {
                                type: "switch",
                                id: "listIsPublic",
                                label: "Public",
                                checked: listIsPublic,
                                onChange: (e)=>setListIsPublic(!listIsPublic)
                            })
                        ]
                    }),
                    user ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                        variant: "primary",
                        onClick: handleSaveList,
                        disabled: saving || !listName.trim(),
                        children: saving ? "Saving\u2026" : 'Save Gene List'
                    }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                        variant: "secondary",
                        disabled: true,
                        children: "Login Required"
                    })
                ]
            })
        ]
    });
};
const $0f50f369018a42ef$var$UserGeneListsComponent = (props)=>{
    const [refreshKey, setRefreshKey] = (0, $gXNCa$react.useState)(0);
    const handleListSaved = ()=>setRefreshKey((k)=>k + 1);
    const firebaseConfig = props.configuration && props.configuration.firebaseConfig;
    const auth = (0, $gXNCa$react.useMemo)(()=>{
        const app = $047461923b1badda$export$54387eca9e368edc(firebaseConfig);
        return app ? (0, $gXNCa$firebaseauth.getAuth)(app) : null;
    }, [
        firebaseConfig
    ]);
    if (!auth) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Alert, {
        variant: "info",
        children: "User gene lists are not available on this site."
    });
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Container, {
        fluid: true,
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Row, {
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Col, {
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($0f50f369018a42ef$var$GeneListComponent, {
                        api: props.configuration.grameneData,
                        site: props.configuration.id,
                        auth: auth,
                        onListSaved: handleListSaved
                    })
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Col, {
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($0f50f369018a42ef$var$GeneListDisplayComponent, {
                        api: props.configuration.grameneData,
                        site: props.configuration.id,
                        auth: auth,
                        addFilter: props.doAcceptGrameneSuggestion,
                        refreshKey: refreshKey
                    })
                })
            ]
        })
    });
};
var $0f50f369018a42ef$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)('selectConfiguration', 'doAcceptGrameneSuggestion', $0f50f369018a42ef$var$UserGeneListsComponent);
const $08e62a9eec4f328f$var$MAX_VISIBLE_PER_GROUP = 200;
function $08e62a9eec4f328f$var$collectFieldNames(group) {
    const names = [
        ...group.fields || []
    ];
    for (const s of group.subgroups || [])names.push(...$08e62a9eec4f328f$var$collectFieldNames(s));
    return names;
}
function $08e62a9eec4f328f$var$collectMatchingFieldNames(group) {
    const names = [
        ...group.matchingFields || []
    ];
    for (const s of group.subgroups || [])names.push(...$08e62a9eec4f328f$var$collectMatchingFieldNames(s));
    return names;
}
function $08e62a9eec4f328f$var$filterGroup(group, q, catalog) {
    const matchingFields = (group.fields || []).filter((name)=>{
        if (!q) return true;
        const f = catalog.fields[name];
        return name.toLowerCase().includes(q) || f && f.label.toLowerCase().includes(q);
    });
    const groupLabelMatches = q && group.label && group.label.toLowerCase().includes(q);
    const subgroups = (group.subgroups || []).map((s)=>$08e62a9eec4f328f$var$filterGroup(s, groupLabelMatches ? '' : q, catalog)).filter((s)=>s);
    if (!q) return {
        ...group,
        matchingFields: matchingFields,
        subgroups: subgroups
    };
    if (groupLabelMatches) return {
        ...group,
        matchingFields: group.fields || [],
        subgroups: (group.subgroups || []).map((s)=>$08e62a9eec4f328f$var$filterGroup(s, '', catalog))
    };
    if (matchingFields.length === 0 && subgroups.length === 0) return null;
    return {
        ...group,
        matchingFields: matchingFields,
        subgroups: subgroups
    };
}
const $08e62a9eec4f328f$var$FieldRow = ({ name: name, catalog: catalog, selectedSet: selectedSet, onToggle: onToggle })=>{
    const f = catalog.fields[name];
    if (!f) return null;
    const linked = f.linkedFields;
    const checked = linked ? linked.every((n)=>selectedSet.has(n)) : selectedSet.has(name);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("li", {
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("label", {
            title: name + (f.description ? '\n' + f.description : ''),
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
                    type: "checkbox",
                    checked: checked,
                    onChange: ()=>onToggle(name)
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    className: "exporter-field-label",
                    children: f.label
                }),
                f.multiValued && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    className: "exporter-field-badge",
                    children: "[]"
                })
            ]
        })
    });
};
const $08e62a9eec4f328f$var$GroupNode = ({ group: group, depth: depth, catalog: catalog, selectedSet: selectedSet, onToggle: onToggle, onBulkSet: onBulkSet, openMap: openMap, setOpen: setOpen, forceOpen: forceOpen })=>{
    const matchingNames = $08e62a9eec4f328f$var$collectMatchingFieldNames(group);
    const total = matchingNames.length;
    const isAllLinkedSelected = (name)=>{
        const f = catalog.fields[name];
        const linked = f && f.linkedFields;
        if (linked) return linked.every((n)=>selectedSet.has(n));
        return selectedSet.has(name);
    };
    const selectedCount = matchingNames.reduce((n, name)=>n + (isAllLinkedSelected(name) ? 1 : 0), 0);
    const allSelected = total > 0 && selectedCount === total;
    const noneSelected = selectedCount === 0;
    const isOpen = forceOpen || openMap[group.id] || false;
    const visible = (group.matchingFields || []).slice(0, $08e62a9eec4f328f$var$MAX_VISIBLE_PER_GROUP);
    const truncated = (group.matchingFields || []).length - visible.length;
    const expandLinked = (names)=>{
        const out = [];
        for (const n of names){
            const f = catalog.fields[n];
            if (f && f.linkedFields) out.push(...f.linkedFields);
            else out.push(n);
        }
        return out;
    };
    const handleBulk = (e, selected)=>{
        e.stopPropagation();
        if (matchingNames.length === 0) return;
        onBulkSet(expandLinked(matchingNames), selected);
    };
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "exporter-group",
        style: {
            marginLeft: depth > 0 ? '0.75rem' : 0
        },
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "exporter-group-header",
                onClick: ()=>setOpen(group.id, !isOpen),
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        className: "exporter-group-chevron",
                        children: isOpen ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsbs.BsChevronDown, {}) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsbs.BsChevronRight, {})
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                        children: group.label
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                        className: "exporter-group-actions",
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                                type: "button",
                                className: "exporter-group-action",
                                disabled: allSelected || total === 0,
                                onClick: (e)=>handleBulk(e, true),
                                title: "Select all fields in this group",
                                children: "All"
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                                type: "button",
                                className: "exporter-group-action",
                                disabled: noneSelected,
                                onClick: (e)=>handleBulk(e, false),
                                title: "Deselect all fields in this group",
                                children: "None"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                        className: "exporter-group-count",
                        children: [
                            selectedCount,
                            "/",
                            total
                        ]
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
                children: [
                    (group.subgroups || []).map((sub)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($08e62a9eec4f328f$var$GroupNode, {
                            group: sub,
                            depth: depth + 1,
                            catalog: catalog,
                            selectedSet: selectedSet,
                            onToggle: onToggle,
                            onBulkSet: onBulkSet,
                            openMap: openMap,
                            setOpen: setOpen,
                            forceOpen: forceOpen
                        }, sub.id)),
                    visible.length > 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("ul", {
                        className: "exporter-group-fields",
                        children: [
                            visible.map((name)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($08e62a9eec4f328f$var$FieldRow, {
                                    name: name,
                                    catalog: catalog,
                                    selectedSet: selectedSet,
                                    onToggle: onToggle
                                }, name)),
                            truncated > 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("li", {
                                className: "exporter-group-truncated",
                                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("em", {
                                    children: [
                                        "\u2026 ",
                                        truncated,
                                        " more. Refine search to see."
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $08e62a9eec4f328f$export$8af8343a8541cf1f = ({ catalog: catalog, selectedFields: selectedFields, onToggle: onToggle, onBulkSet: onBulkSet, query: query = '' })=>{
    const [openMap, setOpenMap] = (0, $gXNCa$react.useState)({});
    const selectedSet = (0, $gXNCa$react.useMemo)(()=>new Set(selectedFields), [
        selectedFields
    ]);
    const handleToggle = (name)=>{
        const f = catalog && catalog.fields && catalog.fields[name];
        const linked = f && f.linkedFields;
        if (linked) {
            const allSelected = linked.every((n)=>selectedSet.has(n));
            onBulkSet(linked, !allSelected);
        } else onToggle(name);
    };
    const q = query.trim().toLowerCase();
    const filtered = (0, $gXNCa$react.useMemo)(()=>{
        if (!catalog || !catalog.groups) return [];
        return catalog.groups.map((g)=>$08e62a9eec4f328f$var$filterGroup(g, q, catalog)).filter((g)=>g && (g.matchingFields && g.matchingFields.length || g.subgroups && g.subgroups.length));
    }, [
        catalog,
        q
    ]);
    if (!catalog || !catalog.groups) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "exporter-panel-empty",
        children: "Loading field catalog\u2026"
    });
    const setOpen = (id, val)=>setOpenMap((s)=>({
                ...s,
                [id]: val
            }));
    const forceOpen = !!q;
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "exporter-field-tree",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
            className: "exporter-field-tree-body",
            children: [
                filtered.map((group)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($08e62a9eec4f328f$var$GroupNode, {
                        group: group,
                        depth: 0,
                        catalog: catalog,
                        selectedSet: selectedSet,
                        onToggle: handleToggle,
                        onBulkSet: onBulkSet,
                        openMap: openMap,
                        setOpen: setOpen,
                        forceOpen: forceOpen
                    }, group.id)),
                filtered.length === 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                    className: "exporter-panel-empty",
                    children: [
                        'No fields match "',
                        query,
                        '".'
                    ]
                })
            ]
        })
    });
};
// Exporter-bound wrapper — preserves the existing default-export usage.
const $08e62a9eec4f328f$var$FieldTreeCmp = (props)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($08e62a9eec4f328f$export$8af8343a8541cf1f, {
        catalog: props.fieldCatalog,
        selectedFields: props.exporterSelectedFields,
        onToggle: props.doToggleExporterField,
        onBulkSet: props.doBulkSetExporterFields,
        query: props.query
    });
var $08e62a9eec4f328f$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)('selectFieldCatalog', 'selectExporterSelectedFields', 'doToggleExporterField', 'doBulkSetExporterFields', $08e62a9eec4f328f$var$FieldTreeCmp);
const $265a8fce42af439c$var$parseNumberOrNull = (v)=>{
    if (v === '' || v === null || v === undefined) return null;
    const n = +v;
    return Number.isFinite(n) ? n : null;
};
const $265a8fce42af439c$var$CutoffsModal = ({ cutoffs: cutoffs, onApply: onApply, onClose: onClose })=>{
    const [exprMinTPM, setExprMinTPM] = (0, $gXNCa$react.useState)(cutoffs && cutoffs.exprMinTPM != null ? String(cutoffs.exprMinTPM) : '');
    const [diffMaxPval, setDiffMaxPval] = (0, $gXNCa$react.useState)(cutoffs && cutoffs.diffMaxPval != null ? String(cutoffs.diffMaxPval) : '');
    (0, $gXNCa$react.useEffect)(()=>{
        const onKey = (e)=>{
            if (e.key === 'Escape') onClose();
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    }, [
        onClose
    ]);
    const apply = ()=>{
        onApply({
            exprMinTPM: $265a8fce42af439c$var$parseNumberOrNull(exprMinTPM),
            diffMaxPval: $265a8fce42af439c$var$parseNumberOrNull(diffMaxPval)
        });
        onClose();
    };
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "exporter-modal-backdrop",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
            className: "exporter-modal",
            onClick: (e)=>e.stopPropagation(),
            role: "dialog",
            "aria-modal": "true",
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                    className: "exporter-modal-header",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                            children: "Expression cutoffs"
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                            type: "button",
                            className: "exporter-modal-close",
                            onClick: onClose,
                            "aria-label": "Close",
                            children: "\xd7"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                    className: "exporter-modal-body",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                            className: "exporter-modal-field",
                            children: [
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("label", {
                                    children: [
                                        "Minimum TPM (gene expression)",
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
                                            type: "number",
                                            step: "0.1",
                                            min: "0",
                                            value: exprMinTPM,
                                            onChange: (e)=>setExprMinTPM(e.target.value),
                                            placeholder: "no minimum"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("small", {
                                    children: "Exclude expression rows with TPM below this value. Blank disables the cutoff."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                            className: "exporter-modal-field",
                            children: [
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("label", {
                                    children: [
                                        "Maximum p-value (differential expression)",
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
                                            type: "number",
                                            step: "0.001",
                                            min: "0",
                                            max: "1",
                                            value: diffMaxPval,
                                            onChange: (e)=>setDiffMaxPval(e.target.value),
                                            placeholder: "no maximum"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("small", {
                                    children: "Exclude diff-expression contrasts with p-value above this. Blank disables the cutoff."
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                    className: "exporter-modal-footer",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                            type: "button",
                            className: "btn btn-sm btn-link",
                            onClick: onClose,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                            type: "button",
                            className: "btn btn-sm btn-primary",
                            onClick: apply,
                            children: "Apply"
                        })
                    ]
                })
            ]
        })
    });
};
var $265a8fce42af439c$export$2e2bcd8739ae039 = $265a8fce42af439c$var$CutoffsModal;
const $b07037ce9e6c6d78$var$PreviewCmp = (props)=>{
    const { fieldCatalog: catalog, exporterSelectedFields: fields, exporterFormat: format, exporterPreview: preview, expressionStudies: expressionStudies, expressionSamples: expressionSamples, grameneTaxonomy: grameneTaxonomy, gramenePathways: gramenePathways, ontologies: ontologies, exporterCutoffs: exporterCutoffs, doSetExporterFormat: doSetExporterFormat, doReorderExporterFields: doReorderExporterFields, doClearExporterFields: doClearExporterFields, doSetExporterCutoffs: doSetExporterCutoffs, doEnsureOntologyRecords: doEnsureOntologyRecords, doRequestGramenePathways: doRequestGramenePathways } = props;
    const [showCutoffs, setShowCutoffs] = (0, $gXNCa$react.useState)(false);
    const docs = preview.data || [];
    const ancestorFieldsSelected = (0, $gXNCa$react.useMemo)(()=>fields.filter((n)=>$2dcf7b48843b00bc$export$a63736950501bd11[n]), [
        fields
    ]);
    (0, $gXNCa$react.useEffect)(()=>{
        if (ancestorFieldsSelected.length === 0 || docs.length === 0) return;
        const idsByOnt = $2dcf7b48843b00bc$export$6cd55d301c37aeed(docs, ancestorFieldsSelected);
        for (const [ontKey, ids] of Object.entries(idsByOnt)){
            if (!ids.length) continue;
            if (ontKey === 'taxonomy') continue; // already cached globally
            if (ontKey === 'pathways') {
                if (doRequestGramenePathways) doRequestGramenePathways(ids);
                continue;
            }
            if (doEnsureOntologyRecords) doEnsureOntologyRecords(ontKey, ids);
        }
    }, [
        docs,
        ancestorFieldsSelected,
        doEnsureOntologyRecords,
        doRequestGramenePathways
    ]);
    if (fields.length === 0) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "exporter-preview-empty",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("em", {
            children: "Select at least one field to preview."
        })
    });
    const renderStatus = ()=>{
        if (preview.status === 'loading') return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("small", {
            className: "exporter-preview-status",
            children: "Loading\u2026"
        });
        if (preview.status === 'error') return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("small", {
            className: "exporter-preview-status error",
            children: [
                "Error: ",
                preview.error
            ]
        });
        if (preview.status === 'stale') return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("small", {
            className: "exporter-preview-status",
            children: "Refreshing\u2026"
        });
        if (preview.status === 'idle') return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("small", {
            className: "exporter-preview-status",
            children: "Idle"
        });
        return null;
    };
    const resolverCtx = {
        expressionStudies: expressionStudies,
        expressionSamples: expressionSamples,
        taxonomy: grameneTaxonomy,
        pathways: gramenePathways,
        ontologies: ontologies,
        cutoffs: exporterCutoffs
    };
    const moveField = (name, delta)=>{
        const idx = fields.indexOf(name);
        if (idx === -1) return;
        const target = idx + delta;
        if (target < 0 || target >= fields.length) return;
        const next = [
            ...fields
        ];
        [next[idx], next[target]] = [
            next[target],
            next[idx]
        ];
        doReorderExporterFields(next);
    };
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "exporter-preview",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "exporter-preview-toolbar",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                        className: "exporter-preview-title",
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                                children: "Preview"
                            }),
                            " (first 20 genes)"
                        ]
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                        className: "exporter-preview-fields-count",
                        children: [
                            fields.length,
                            " field",
                            fields.length === 1 ? '' : 's',
                            fields.length > 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                                className: "btn btn-sm btn-link exporter-clear-btn",
                                onClick: doClearExporterFields,
                                children: "clear"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                        className: "exporter-preview-format",
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("label", {
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
                                        type: "radio",
                                        name: "exporter-format",
                                        value: "tsv",
                                        checked: format === 'tsv',
                                        onChange: ()=>doSetExporterFormat('tsv')
                                    }),
                                    " TSV"
                                ]
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("label", {
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
                                        type: "radio",
                                        name: "exporter-format",
                                        value: "json",
                                        checked: format === 'json',
                                        onChange: ()=>doSetExporterFormat('json')
                                    }),
                                    " JSON"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("button", {
                        type: "button",
                        className: "btn btn-sm btn-light exporter-cutoffs-btn",
                        onClick: ()=>setShowCutoffs(true),
                        title: "Expression cutoffs",
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsbs.BsSliders, {}),
                            " Cutoffs"
                        ]
                    }),
                    renderStatus()
                ]
            }),
            showCutoffs && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($265a8fce42af439c$export$2e2bcd8739ae039, {
                cutoffs: exporterCutoffs,
                onApply: doSetExporterCutoffs,
                onClose: ()=>setShowCutoffs(false)
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "exporter-preview-body",
                children: format === 'tsv' ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($b07037ce9e6c6d78$var$TSVTable, {
                    docs: docs,
                    fields: fields,
                    catalog: catalog,
                    resolverCtx: resolverCtx,
                    onMoveField: moveField
                }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("pre", {
                    className: "exporter-preview-json",
                    children: $11024d65ffe77884$export$54fd2c36b5cc6731(docs, fields, resolverCtx)
                })
            })
        ]
    });
};
const $b07037ce9e6c6d78$var$MIN_COL_WIDTH = 40;
const $b07037ce9e6c6d78$var$TSVTable = ({ docs: docs, fields: fields, catalog: catalog, resolverCtx: resolverCtx, onMoveField: onMoveField })=>{
    const { header: header, headerKeys: headerKeys, rows: rows } = $11024d65ffe77884$export$4600c165c3a455ee(docs, fields, catalog, resolverCtx);
    const reorderableCount = fields.length;
    const [colWidths, setColWidths] = (0, $gXNCa$react.useState)({});
    const thRefs = (0, $gXNCa$react.useRef)({});
    const startResize = (key)=>(e)=>{
            e.preventDefault();
            e.stopPropagation();
            const th = thRefs.current[key];
            const startWidth = th && th.getBoundingClientRect().width || 100;
            const startX = e.clientX;
            const onMove = (ev)=>{
                const delta = ev.clientX - startX;
                const next = Math.max($b07037ce9e6c6d78$var$MIN_COL_WIDTH, startWidth + delta);
                setColWidths((prev)=>({
                        ...prev,
                        [key]: next
                    }));
            };
            const onUp = ()=>{
                window.removeEventListener('pointermove', onMove);
                window.removeEventListener('pointerup', onUp);
                window.removeEventListener('pointercancel', onUp);
                document.body.style.userSelect = '';
            };
            document.body.style.userSelect = 'none';
            window.addEventListener('pointermove', onMove);
            window.addEventListener('pointerup', onUp);
            window.addEventListener('pointercancel', onUp);
        };
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "exporter-preview-tsv-scroll",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("table", {
            className: "exporter-preview-tsv",
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("tr", {
                        children: header.map((h, i)=>{
                            const key = headerKeys[i];
                            const fieldIdx = fields.indexOf(key);
                            const reorderable = fieldIdx !== -1;
                            const w = colWidths[key];
                            const thStyle = w ? {
                                width: `${w}px`,
                                maxWidth: `${w}px`,
                                minWidth: `${w}px`
                            } : undefined;
                            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("th", {
                                title: key,
                                style: thStyle,
                                ref: (el)=>{
                                    thRefs.current[key] = el;
                                },
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                        className: "exporter-preview-th-inner",
                                        children: [
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                                                type: "button",
                                                className: "exporter-preview-reorder-btn",
                                                disabled: !reorderable || fieldIdx === 0,
                                                onClick: ()=>onMoveField(key, -1),
                                                title: "Move left",
                                                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsbs.BsArrowLeftShort, {})
                                            }),
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                                className: "exporter-preview-th-label",
                                                children: h
                                            }),
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                                                type: "button",
                                                className: "exporter-preview-reorder-btn",
                                                disabled: !reorderable || fieldIdx === reorderableCount - 1,
                                                onClick: ()=>onMoveField(key, 1),
                                                title: "Move right",
                                                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsbs.BsArrowRightShort, {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                        className: "exporter-preview-col-resizer",
                                        onPointerDown: startResize(key),
                                        onDoubleClick: ()=>setColWidths((prev)=>{
                                                const n = {
                                                    ...prev
                                                };
                                                delete n[key];
                                                return n;
                                            }),
                                        title: "Drag to resize \xb7 double-click to reset"
                                    })
                                ]
                            }, key);
                        })
                    })
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("tbody", {
                    children: [
                        rows.map((row, r)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("tr", {
                                children: row.map((c, i)=>{
                                    const key = headerKeys[i];
                                    const w = colWidths[key];
                                    const tdStyle = w ? {
                                        width: `${w}px`,
                                        maxWidth: `${w}px`,
                                        minWidth: `${w}px`
                                    } : undefined;
                                    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                                        title: c,
                                        style: tdStyle,
                                        children: c
                                    }, key);
                                })
                            }, r)),
                        rows.length === 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("tr", {
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                                colSpan: header.length,
                                className: "exporter-preview-empty-row",
                                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("em", {
                                    children: "No rows."
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $b07037ce9e6c6d78$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)('selectFieldCatalog', 'selectExporterSelectedFields', 'selectExporterFormat', 'selectExporterPreview', 'selectExpressionStudies', 'selectExpressionSamples', 'selectGrameneTaxonomy', 'selectGramenePathways', 'selectOntologies', 'selectExporterCutoffs', 'doSetExporterFormat', 'doReorderExporterFields', 'doClearExporterFields', 'doSetExporterCutoffs', 'doEnsureOntologyRecords', 'doRequestGramenePathways', $b07037ce9e6c6d78$var$PreviewCmp);
const $76f7f9e488184bf9$var$ExportFooterCmp = (props)=>{
    const { exporterSelectedFields: exporterSelectedFields, exporterFormat: exporterFormat, exporterDownload: dl, doStartExporterDownload: doStartExporterDownload, doCancelExporterDownload: doCancelExporterDownload, doResetExporterDownload: doResetExporterDownload } = props;
    const inFlight = dl.status === 'preparing' || dl.status === 'downloading';
    const pct = dl.total > 0 ? Math.min(100, Math.round(dl.progress / dl.total * 100)) : 0;
    const canStart = !inFlight && exporterSelectedFields.length > 0;
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "exporter-footer",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        className: "exporter-footer-summary",
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("small", {
                            children: [
                                exporterSelectedFields.length,
                                " field",
                                exporterSelectedFields.length === 1 ? '' : 's',
                                " selected \xb7 format: ",
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                                    children: exporterFormat.toUpperCase()
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Button, {
                        variant: "primary",
                        size: "sm",
                        disabled: !canStart,
                        onClick: doStartExporterDownload,
                        children: [
                            "Download ",
                            exporterFormat.toUpperCase()
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Modal, {
                show: dl.status !== 'idle',
                onHide: doResetExporterDownload,
                centered: true,
                backdrop: "static",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Modal.Header, {
                        closeButton: !inFlight,
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Modal.Title, {
                            children: [
                                dl.status === 'preparing' && "Preparing export\u2026",
                                dl.status === 'downloading' && "Exporting\u2026",
                                dl.status === 'done' && 'Export complete',
                                dl.status === 'cancelled' && 'Export cancelled',
                                dl.status === 'error' && 'Export failed'
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Modal.Body, {
                        children: [
                            inFlight && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.ProgressBar, {
                                        now: pct,
                                        label: dl.total > 0 ? `${dl.progress.toLocaleString()} / ${dl.total.toLocaleString()}` : "Counting\u2026",
                                        striped: true,
                                        animated: true
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                        style: {
                                            marginTop: '0.5rem',
                                            fontSize: '0.85rem',
                                            color: '#666'
                                        },
                                        children: "Fetching genes in pages of 1000. This may take a while for large result sets."
                                    })
                                ]
                            }),
                            dl.status === 'done' && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                children: [
                                    "Wrote ",
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                                        children: dl.progress.toLocaleString()
                                    }),
                                    " genes to disk."
                                ]
                            }),
                            dl.status === 'cancelled' && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                children: [
                                    "Stopped at ",
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                                        children: dl.progress.toLocaleString()
                                    }),
                                    " / ",
                                    dl.total.toLocaleString(),
                                    " genes. No file was saved."
                                ]
                            }),
                            dl.status === 'error' && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                className: "text-danger",
                                children: dl.error
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Modal.Footer, {
                        children: inFlight ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                            variant: "outline-secondary",
                            size: "sm",
                            onClick: doCancelExporterDownload,
                            children: "Cancel"
                        }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                            variant: "secondary",
                            size: "sm",
                            onClick: doResetExporterDownload,
                            children: "Close"
                        })
                    })
                ]
            })
        ]
    });
};
var $76f7f9e488184bf9$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)('selectExporterSelectedFields', 'selectExporterFormat', 'selectExporterDownload', 'doStartExporterDownload', 'doCancelExporterDownload', 'doResetExporterDownload', $76f7f9e488184bf9$var$ExportFooterCmp);
const $37b3bb0145d266b0$var$MIN_LEFT_PCT = 15;
const $37b3bb0145d266b0$var$MAX_LEFT_PCT = 85;
const $37b3bb0145d266b0$var$ExporterViewCmp = (props)=>{
    const { fieldCatalog: catalog, grameneFieldCatalogIsLoading: isLoading, grameneFieldCatalogRaw: raw, grameneFieldCatalogShouldUpdate: shouldUpdate, doFetchGrameneFieldCatalog: doFetchGrameneFieldCatalog } = props;
    const [fieldQuery, setFieldQuery] = (0, $gXNCa$react.useState)('');
    const [leftPct, setLeftPct] = (0, $gXNCa$react.useState)(50);
    const [dragging, setDragging] = (0, $gXNCa$react.useState)(false);
    const containerRef = (0, $gXNCa$react.useRef)(null);
    (0, $gXNCa$react.useEffect)(()=>{
        if (shouldUpdate) doFetchGrameneFieldCatalog();
    }, [
        shouldUpdate,
        doFetchGrameneFieldCatalog
    ]);
    const onPointerMove = (0, $gXNCa$react.useCallback)((e)=>{
        const el = containerRef.current;
        if (!el) return;
        const rect = el.getBoundingClientRect();
        const pct = (e.clientX - rect.left) / rect.width * 100;
        if (!Number.isFinite(pct)) return;
        setLeftPct(Math.max($37b3bb0145d266b0$var$MIN_LEFT_PCT, Math.min($37b3bb0145d266b0$var$MAX_LEFT_PCT, pct)));
    }, []);
    (0, $gXNCa$react.useEffect)(()=>{
        if (!dragging) return;
        const onUp = ()=>setDragging(false);
        window.addEventListener('pointermove', onPointerMove);
        window.addEventListener('pointerup', onUp);
        window.addEventListener('pointercancel', onUp);
        const prev = document.body.style.userSelect;
        document.body.style.userSelect = 'none';
        return ()=>{
            window.removeEventListener('pointermove', onPointerMove);
            window.removeEventListener('pointerup', onUp);
            window.removeEventListener('pointercancel', onUp);
            document.body.style.userSelect = prev;
        };
    }, [
        dragging,
        onPointerMove
    ]);
    if (!catalog || !catalog.groups) {
        const msg = isLoading ? "Loading\u2026" : raw && raw.error ? `error: ${String(raw.error)}` : 'init';
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
            className: "exporter-view",
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("em", {
                style: {
                    padding: '1rem'
                },
                children: [
                    "Loading field catalog\u2026 (",
                    msg,
                    ")"
                ]
            })
        });
    }
    const gridStyle = {
        gridTemplateColumns: `${leftPct}% 8px ${100 - leftPct}%`
    };
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "exporter-view",
        ref: containerRef,
        style: gridStyle,
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "exporter-pane",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                        className: "exporter-pane-header exporter-pane-header-row",
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                                children: "Available fields"
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("small", {
                                style: {
                                    color: '#888',
                                    marginLeft: '0.5rem'
                                },
                                children: [
                                    Object.keys(catalog.fields).length,
                                    " total"
                                ]
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
                                type: "search",
                                className: "form-control exporter-field-search exporter-field-search-inline",
                                placeholder: "Search fields\u2026",
                                value: fieldQuery,
                                onChange: (e)=>setFieldQuery(e.target.value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        className: "exporter-pane-body",
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($08e62a9eec4f328f$export$2e2bcd8739ae039, {
                            query: fieldQuery
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: 'exporter-divider' + (dragging ? ' dragging' : ''),
                onPointerDown: (e)=>{
                    e.preventDefault();
                    setDragging(true);
                },
                onDoubleClick: ()=>setLeftPct(50),
                role: "separator",
                "aria-orientation": "vertical",
                title: "Drag to resize \xb7 double-click to reset"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "exporter-pane exporter-right-pane",
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                    className: "exporter-right-split",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                            className: "exporter-preview-section",
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($b07037ce9e6c6d78$export$2e2bcd8739ae039, {})
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($76f7f9e488184bf9$export$2e2bcd8739ae039, {})
                    ]
                })
            })
        ]
    });
};
var $37b3bb0145d266b0$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)('selectFieldCatalog', 'selectGrameneFieldCatalogIsLoading', 'selectGrameneFieldCatalogRaw', 'selectGrameneFieldCatalogShouldUpdate', 'doFetchGrameneFieldCatalog', $37b3bb0145d266b0$var$ExporterViewCmp);
function $4d0c2e01f58b53b1$var$speciesTaxonId(tid) {
    const n = +tid;
    return n > 1000000 ? Math.floor(n / 1000) : n;
}
const $4d0c2e01f58b53b1$var$EXPERIMENT_KEYS = [
    {
        key: 'exp:study',
        label: 'Study'
    },
    {
        key: 'exp:type',
        label: 'Study type'
    },
    {
        key: 'exp:organism',
        label: 'Organism'
    }
];
// One record per expression field (one sample group within one study).
// `props` is a flat map of property-key → value used for filtering and display.
function $4d0c2e01f58b53b1$var$buildFieldRecords(taxon, studyIds, expressionStudies, expressionSamples, fieldCatalog, grameneMaps) {
    const records = [];
    const factorTypes = new Set();
    const charTypes = new Set();
    if (!expressionSamples || !expressionStudies) return {
        records: records,
        factorTypes: [],
        charTypes: []
    };
    const studyById = {};
    const list = expressionStudies[taxon] || expressionStudies[$4d0c2e01f58b53b1$var$speciesTaxonId(taxon)] || [];
    list.forEach((s)=>{
        studyById[s._id] = s;
    });
    for (const studyId of studyIds){
        const study = studyById[studyId];
        if (!study) continue;
        const samples = expressionSamples[studyId];
        if (!samples) continue;
        const byGroup = {};
        for (const s of samples)if (!byGroup[s.group]) byGroup[s.group] = s;
        for (const group of Object.keys(byGroup)){
            const sample = byGroup[group];
            const fieldName = `${studyId.replace(/-/g, '_')}_${group}__expr`;
            if (fieldCatalog && fieldCatalog.fields && !fieldCatalog.fields[fieldName]) continue;
            const props = {};
            props['exp:study'] = study.description || studyId;
            props['exp:type'] = study.type || '(unknown)';
            const taxon_id = study.taxon_id;
            const taxName = grameneMaps && (grameneMaps[taxon_id] || grameneMaps[$4d0c2e01f58b53b1$var$speciesTaxonId(taxon_id)]);
            props['exp:organism'] = taxName && taxName.display_name || String(taxon_id);
            const usedFactorTypes = new Set();
            (sample.factor || []).forEach((f)=>{
                props[`fac:${f.type}`] = f.label;
                factorTypes.add(f.type);
                usedFactorTypes.add(f.type);
            });
            (sample.characteristic || []).forEach((c)=>{
                if (usedFactorTypes.has(c.type)) return; // factor takes precedence
                props[`char:${c.type}`] = c.label;
                charTypes.add(c.type);
            });
            records.push({
                fieldName: fieldName,
                studyId: studyId,
                group: group,
                props: props
            });
        }
    }
    return {
        records: records,
        factorTypes: Array.from(factorTypes).sort(),
        charTypes: Array.from(charTypes).sort()
    };
}
function $4d0c2e01f58b53b1$var$fieldMatches(field, selections, excludeKey) {
    for (const key of Object.keys(selections)){
        if (key === excludeKey) continue;
        const values = selections[key];
        if (!values || values.size === 0) continue;
        const v = field.props[key];
        if (v == null || !values.has(v)) return false;
    }
    return true;
}
function $4d0c2e01f58b53b1$var$valueCounts(records, key, selections) {
    const counts = new Map();
    for (const f of records){
        if (!$4d0c2e01f58b53b1$var$fieldMatches(f, selections, key)) continue;
        const v = f.props[key];
        if (v == null) continue;
        counts.set(v, (counts.get(v) || 0) + 1);
    }
    return counts;
}
function $4d0c2e01f58b53b1$var$labelForKey(key, tree) {
    for (const grp of tree){
        for (const t of grp.types)if (t.key === key) return t.label;
    }
    return key;
}
const $4d0c2e01f58b53b1$var$FieldsModalCmp = (props)=>{
    const { fieldCatalog: fieldCatalog, exprViz: exprViz, expressionStudies: expressionStudies, expressionSamples: expressionSamples, grameneMaps: grameneMaps, doToggleExprVizFieldsModal: doToggleExprVizFieldsModal, doSetExprVizFields: doSetExprVizFields, doFetchExprVizFieldExistence: doFetchExprVizFieldExistence } = props;
    const taxon = Object.keys(exprViz.byTaxon).find((t)=>exprViz.byTaxon[t].fieldsModalOpen);
    const open = !!taxon;
    const availableAttrs = taxon && exprViz.byTaxon[taxon] && exprViz.byTaxon[taxon].availableAttrs;
    const studyIds = (0, $gXNCa$react.useMemo)(()=>{
        if (!taxon || !expressionStudies) return [];
        const list = expressionStudies[taxon] || expressionStudies[$4d0c2e01f58b53b1$var$speciesTaxonId(taxon)] || [];
        let ids = list.map((s)=>s._id);
        if (availableAttrs) {
            const allow = new Set(availableAttrs);
            ids = ids.filter((id)=>allow.has(id));
        }
        return ids;
    }, [
        taxon,
        expressionStudies,
        availableAttrs
    ]);
    const allRecords = (0, $gXNCa$react.useMemo)(()=>$4d0c2e01f58b53b1$var$buildFieldRecords(taxon, studyIds, expressionStudies, expressionSamples, fieldCatalog, grameneMaps), [
        taxon,
        studyIds,
        expressionStudies,
        expressionSamples,
        fieldCatalog,
        grameneMaps
    ]);
    const candidateFields = (0, $gXNCa$react.useMemo)(()=>allRecords.records.map((r)=>r.fieldName), [
        allRecords
    ]);
    // Trigger the field-existence facet check whenever the modal is open and
    // the candidate field list is known. The bundle caches per (q, taxon, fields).
    (0, $gXNCa$react.useEffect)(()=>{
        if (open && taxon && candidateFields.length > 0) doFetchExprVizFieldExistence(taxon, candidateFields);
    }, [
        open,
        taxon,
        candidateFields,
        doFetchExprVizFieldExistence
    ]);
    const fieldExistence = taxon && exprViz.byTaxon[taxon] && exprViz.byTaxon[taxon].fieldExistence;
    const existenceStatus = taxon && exprViz.byTaxon[taxon] && exprViz.byTaxon[taxon].existenceStatus;
    // Once existence counts are loaded, drop fields with no data in the current
    // result set. Until then, render with the full candidate set so the modal
    // doesn't flash empty during the precheck.
    const { records: records, factorTypes: factorTypes, charTypes: charTypes } = (0, $gXNCa$react.useMemo)(()=>{
        if (!fieldExistence) return allRecords;
        const live = new Set(Object.keys(fieldExistence).filter((f)=>fieldExistence[f] > 0));
        const filtered = allRecords.records.filter((r)=>live.has(r.fieldName));
        const factorTypes = new Set();
        const charTypes = new Set();
        for (const r of filtered)for (const k of Object.keys(r.props)){
            if (k.startsWith('fac:')) factorTypes.add(k.slice(4));
            else if (k.startsWith('char:')) charTypes.add(k.slice(5));
        }
        return {
            records: filtered,
            factorTypes: Array.from(factorTypes).sort(),
            charTypes: Array.from(charTypes).sort()
        };
    }, [
        allRecords,
        fieldExistence
    ]);
    const propTree = (0, $gXNCa$react.useMemo)(()=>[
            {
                group: 'experiment',
                label: 'Experiment',
                types: $4d0c2e01f58b53b1$var$EXPERIMENT_KEYS
            },
            {
                group: 'factors',
                label: 'Factors',
                types: factorTypes.map((t)=>({
                        key: `fac:${t}`,
                        label: t
                    }))
            },
            {
                group: 'characteristics',
                label: 'Characteristics',
                types: charTypes.map((t)=>({
                        key: `char:${t}`,
                        label: t
                    }))
            }
        ], [
        factorTypes,
        charTypes
    ]);
    const [selections, setSelections] = (0, $gXNCa$react.useState)({});
    const [expandedKey, setExpandedKey] = (0, $gXNCa$react.useState)(null);
    const [collapsedGroups, setCollapsedGroups] = (0, $gXNCa$react.useState)({});
    const [valueSort, setValueSort] = (0, $gXNCa$react.useState)('count');
    const [orderedSelectedKeys, setOrderedSelectedKeys] = (0, $gXNCa$react.useState)([]);
    const [searchQuery, setSearchQuery] = (0, $gXNCa$react.useState)('');
    const searchLc = searchQuery.trim().toLowerCase();
    const isSearching = searchLc.length > 0;
    // Distinct values per property type, ignoring the type's own selection but
    // applying every other selected type. Counts shown next to a property type
    // reflect "how many distinct values exist among the fields currently
    // matching the rest of the filter."
    const valueSetByKey = (0, $gXNCa$react.useMemo)(()=>{
        const allKeys = new Set();
        for (const r of records)for (const k of Object.keys(r.props))allKeys.add(k);
        const m = {};
        for (const key of allKeys){
            const set = new Set();
            for (const r of records){
                if (!$4d0c2e01f58b53b1$var$fieldMatches(r, selections, key)) continue;
                const v = r.props[key];
                if (v != null) set.add(v);
            }
            m[key] = set;
        }
        return m;
    }, [
        records,
        selections
    ]);
    // Distinct values per property type across the unfiltered candidate set.
    // A type with a single value across every record can't discriminate (e.g.
    // "Organism" when every field belongs to the same species), so we hide it
    // from the property tree.
    const totalValueCountByKey = (0, $gXNCa$react.useMemo)(()=>{
        const m = {};
        for (const r of records)for (const [k, v] of Object.entries(r.props)){
            if (v == null) continue;
            if (!m[k]) m[k] = new Set();
            m[k].add(v);
        }
        return m;
    }, [
        records
    ]);
    // Reset state when modal (re)opens for a taxon.
    (0, $gXNCa$react.useEffect)(()=>{
        if (open && taxon) {
            setSelections({});
            setExpandedKey(null);
            setCollapsedGroups({});
            setOrderedSelectedKeys([]);
            setSearchQuery('');
        }
    }, [
        open,
        taxon
    ]);
    // Keep orderedSelectedKeys in sync with selections (preserves the order in
    // which the user first selected each property type).
    (0, $gXNCa$react.useEffect)(()=>{
        setOrderedSelectedKeys((prev)=>{
            const active = Object.keys(selections);
            const activeSet = new Set(active);
            const kept = prev.filter((k)=>activeSet.has(k));
            const newOnes = active.filter((k)=>!prev.includes(k));
            return [
                ...kept,
                ...newOnes
            ];
        });
    }, [
        selections
    ]);
    const matchingFields = (0, $gXNCa$react.useMemo)(()=>records.filter((r)=>$4d0c2e01f58b53b1$var$fieldMatches(r, selections, null)), [
        records,
        selections
    ]);
    if (!open) return null;
    const toggleValue = (key, value)=>{
        setSelections((prev)=>{
            const next = {
                ...prev
            };
            const set = new Set(next[key] || []);
            if (set.has(value)) set.delete(value);
            else set.add(value);
            if (set.size === 0) delete next[key];
            else next[key] = set;
            return next;
        });
    };
    const clearTypeSelection = (key)=>{
        setSelections((prev)=>{
            if (!prev[key]) return prev;
            const next = {
                ...prev
            };
            delete next[key];
            return next;
        });
    };
    const toggleGroup = (g)=>setCollapsedGroups((prev)=>({
                ...prev,
                [g]: !prev[g]
            }));
    const renderValues = (key, typeLabelMatches)=>{
        const counts = $4d0c2e01f58b53b1$var$valueCounts(records, key, selections);
        let entries = Array.from(counts.entries());
        if (isSearching && !typeLabelMatches) entries = entries.filter(([v])=>String(v).toLowerCase().includes(searchLc));
        if (valueSort === 'name') entries.sort((a, b)=>String(a[0]).localeCompare(String(b[0])));
        else entries.sort((a, b)=>b[1] - a[1] || String(a[0]).localeCompare(String(b[0])));
        const sel = selections[key] || new Set();
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
            className: "exprviz-tree-values",
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                    className: "exprviz-values-toolbar",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.ToggleButtonGroup, {
                            type: "radio",
                            name: `exprviz-vsort-${key}`,
                            size: "sm",
                            value: valueSort,
                            onChange: setValueSort,
                            children: [
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.ToggleButton, {
                                    id: `exprviz-vsort-name-${key}`,
                                    value: "name",
                                    variant: "outline-secondary",
                                    children: "Name"
                                }),
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.ToggleButton, {
                                    id: `exprviz-vsort-count-${key}`,
                                    value: "count",
                                    variant: "outline-secondary",
                                    children: "Count"
                                })
                            ]
                        }),
                        sel.size > 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                            size: "sm",
                            variant: "link",
                            onClick: ()=>clearTypeSelection(key),
                            children: "clear"
                        })
                    ]
                }),
                entries.map(([v, c])=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("label", {
                        className: "exprviz-tree-value",
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
                                type: "checkbox",
                                checked: sel.has(v),
                                onChange: ()=>toggleValue(key, v)
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                className: "exprviz-tree-value-label",
                                title: v,
                                children: v
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                className: "exprviz-tree-value-count",
                                children: c
                            })
                        ]
                    }, v)),
                entries.length === 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("em", {
                    className: "exprviz-tree-empty",
                    children: "No values"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Modal, {
        show: open,
        onHide: ()=>doToggleExprVizFieldsModal(taxon, false),
        size: "xl",
        scrollable: true,
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Modal.Header, {
                closeButton: true,
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Modal.Title, {
                    children: [
                        "Filter expression fields (",
                        matchingFields.length,
                        " of ",
                        records.length,
                        " match)",
                        existenceStatus === 'loading' && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                            className: "exprviz-modal-loading",
                            children: " \xb7 checking field availability\u2026"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Modal.Body, {
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                    className: "exprviz-fields-layout",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                            className: "exprviz-tree",
                            children: [
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
                                    type: "text",
                                    className: "exprviz-tree-search",
                                    placeholder: "Search property types and values\u2026",
                                    value: searchQuery,
                                    onChange: (e)=>setSearchQuery(e.target.value)
                                }),
                                propTree.map((grp)=>{
                                    const typeRows = grp.types.map((t)=>{
                                        // Hide property types that can't discriminate among the
                                        // candidates: zero values, or a single value shared by every
                                        // record. The selection-aware count (valueSetByKey) is what
                                        // we display; the unfiltered count gates visibility so a type
                                        // doesn't pop in/out as the user clicks values.
                                        const totalDistinct = totalValueCountByKey[t.key] && totalValueCountByKey[t.key].size || 0;
                                        if (totalDistinct < 2) return null;
                                        const numValues = valueSetByKey[t.key] && valueSetByKey[t.key].size || 0;
                                        if (numValues === 0) return null;
                                        const typeLabelMatches = isSearching && t.label.toLowerCase().includes(searchLc);
                                        let matchingValueCount = numValues;
                                        if (isSearching && !typeLabelMatches) {
                                            const vset = valueSetByKey[t.key] || new Set();
                                            matchingValueCount = 0;
                                            for (const v of vset)if (String(v).toLowerCase().includes(searchLc)) matchingValueCount++;
                                            if (matchingValueCount === 0) return null;
                                        }
                                        const sel = selections[t.key];
                                        const selCount = sel ? sel.size : 0;
                                        const isExpanded = isSearching ? !typeLabelMatches : expandedKey === t.key;
                                        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                            className: `exprviz-tree-type${selCount > 0 ? ' is-active' : ''}`,
                                            children: [
                                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                                    className: "exprviz-tree-type-header",
                                                    onClick: ()=>setExpandedKey(isExpanded ? null : t.key),
                                                    children: [
                                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                                            className: "exprviz-tree-caret",
                                                            children: isExpanded ? "\u25BE" : "\u25B8"
                                                        }),
                                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                                            className: "exprviz-tree-type-label",
                                                            children: t.label
                                                        }),
                                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                                            className: "exprviz-tree-type-count",
                                                            children: selCount > 0 ? `${selCount}/${numValues}` : numValues
                                                        })
                                                    ]
                                                }),
                                                isExpanded && renderValues(t.key, typeLabelMatches)
                                            ]
                                        }, t.key);
                                    }).filter(Boolean);
                                    if (isSearching && typeRows.length === 0) return null;
                                    const groupCollapsed = !isSearching && collapsedGroups[grp.group];
                                    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                        className: "exprviz-tree-group",
                                        children: [
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                                className: "exprviz-tree-group-header",
                                                onClick: ()=>toggleGroup(grp.group),
                                                children: [
                                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                                        className: "exprviz-tree-caret",
                                                        children: groupCollapsed ? "\u25B6" : "\u25BC"
                                                    }),
                                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("strong", {
                                                        children: grp.label
                                                    })
                                                ]
                                            }),
                                            !groupCollapsed && grp.types.length === 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                                className: "exprviz-tree-empty",
                                                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("em", {
                                                    children: "(none)"
                                                })
                                            }),
                                            !groupCollapsed && typeRows
                                        ]
                                    }, grp.group);
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                            className: "exprviz-fields-preview",
                            children: orderedSelectedKeys.length === 0 ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                className: "exprviz-fields-placeholder",
                                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("em", {
                                    children: "Select a property type to preview the property values for each matching field."
                                })
                            }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("table", {
                                className: "exprviz-fields-table",
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("tr", {
                                            children: orderedSelectedKeys.map((k)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("th", {
                                                    children: $4d0c2e01f58b53b1$var$labelForKey(k, propTree)
                                                }, k))
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("tbody", {
                                        children: [
                                            matchingFields.map((f)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("tr", {
                                                    title: f.fieldName,
                                                    children: orderedSelectedKeys.map((k)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                                                            children: f.props[k] || ''
                                                        }, k))
                                                }, f.fieldName)),
                                            matchingFields.length === 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("tr", {
                                                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                                                    colSpan: orderedSelectedKeys.length,
                                                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("em", {
                                                        children: "No matching fields"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Modal.Footer, {
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                        variant: "secondary",
                        onClick: ()=>doToggleExprVizFieldsModal(taxon, false),
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Button, {
                        variant: "primary",
                        disabled: matchingFields.length === 0,
                        onClick: ()=>{
                            doSetExprVizFields(taxon, matchingFields.map((f)=>f.fieldName));
                            doToggleExprVizFieldsModal(taxon, false);
                        },
                        children: [
                            "Apply (",
                            matchingFields.length,
                            " fields)"
                        ]
                    })
                ]
            })
        ]
    });
};
var $4d0c2e01f58b53b1$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)('selectFieldCatalog', 'selectExprViz', 'selectExpressionStudies', 'selectExpressionSamples', 'selectGrameneMaps', 'doToggleExprVizFieldsModal', 'doSetExprVizFields', 'doFetchExprVizFieldExistence', $4d0c2e01f58b53b1$var$FieldsModalCmp);
const $4ab64e76c1caef59$var$baseColDefs = [
    {
        field: 'id',
        headerName: 'Gene ID',
        pinned: 'left',
        width: 160,
        suppressMovable: true
    },
    {
        field: 'name',
        headerName: 'Name',
        pinned: 'left',
        width: 140,
        suppressMovable: true
    }
];
// Hoisted so the reference is stable across renders. ag-grid otherwise sees a
// "new" defaultColDef on every parent re-render (e.g. when hovering a row
// triggers setHoveredId in the parent) and re-applies column state, which
// snaps any user-resized columns back to their original widths.
const $4ab64e76c1caef59$var$DEFAULT_COL_DEF = {
    resizable: true,
    sortable: true,
    filter: false,
    suppressMenu: true,
    // Click cycle: input order → descending → ascending → input order. The
    // ag-grid default is asc → desc → null; for expression data the
    // top-of-column user usually wants is "highest first," so we hit that on
    // the first click.
    sortingOrder: [
        'desc',
        'asc',
        null
    ]
};
function $4ab64e76c1caef59$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++)if (a[i] !== b[i]) return false;
    return true;
}
function $4ab64e76c1caef59$export$7b242440eb2c300d(fields, studies, expressionSamples) {
    const info = {};
    if (!fields || !studies || !expressionSamples) return info;
    const wanted = new Set(fields);
    for (const study of studies){
        const studyId = study._id;
        const samples = expressionSamples[studyId];
        if (!samples) continue;
        const byGroup = {};
        for (const s of samples)if (!byGroup[s.group]) byGroup[s.group] = s;
        for (const group of Object.keys(byGroup)){
            const fieldName = `${studyId.replace(/-/g, '_')}_${group}__expr`;
            if (!wanted.has(fieldName)) continue;
            const sample = byGroup[group];
            const factors = {};
            (sample.factor || []).forEach((f)=>{
                factors[f.type] = f.label;
            });
            const characteristics = {};
            (sample.characteristic || []).forEach((c)=>{
                if (factors[c.type] != null) return;
                characteristics[c.type] = c.label;
            });
            info[fieldName] = {
                studyId: studyId,
                studyDescription: study.description || studyId,
                group: group,
                replicates: samples.filter((s)=>s.group === group).length,
                factors: factors,
                characteristics: characteristics
            };
        }
    }
    return info;
}
// Plain right-aligned label cell for the metadata header rows above the
// Gene ID / Name columns. Rendered as a React component (instead of
// relying on ag-grid's default group label) so the alignment is controlled
// by our own DOM and isn't fighting the quartz theme's CSS.
const $4ab64e76c1caef59$var$LabelHeaderGroup = (props)=>{
    const { displayName: displayName } = props;
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "exprviz-label-header",
        children: displayName
    });
};
// Same idea, but for the cells that toggle a section between expanded and
// collapsed. The caret + label sit at the right edge.
const $4ab64e76c1caef59$var$ToggleHeaderGroup = (props)=>{
    const { displayName: displayName, onToggle: onToggle, expanded: expanded, suffix: suffix } = props;
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "exprviz-toggle-header",
        onClick: onToggle,
        role: "button",
        tabIndex: 0,
        onKeyDown: (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onToggle && onToggle();
            }
        },
        title: expanded ? 'Click to collapse' : 'Click to expand',
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                className: "exprviz-toggle-caret",
                children: expanded ? "\u25BC" : "\u25B6"
            }),
            ' ',
            displayName,
            suffix ? ` ${suffix}` : ''
        ]
    });
};
function $4ab64e76c1caef59$var$exprValueFormatter(p) {
    const v = p.value;
    if (v == null) return '';
    if (Array.isArray(v)) return v.join(', ');
    if (typeof v === 'object') return JSON.stringify(v);
    return String(v);
}
// Discover every distinct factor and characteristic type across the loaded
// fields. Each becomes one header row (with adjacent equal-value cells
// merged). Order is alphabetical for stability across reloads.
function $4ab64e76c1caef59$var$collectMetadataTypes(fields, fieldInfo) {
    const factorTypes = new Set();
    const charTypes = new Set();
    for (const f of fields || []){
        const info = fieldInfo[f];
        if (!info) continue;
        Object.keys(info.factors || {}).forEach((t)=>factorTypes.add(t));
        Object.keys(info.characteristics || {}).forEach((t)=>charTypes.add(t));
    }
    return {
        factorTypes: Array.from(factorTypes).sort(),
        charTypes: Array.from(charTypes).sort()
    };
}
// Wrap a leaf column in N nested column groups so it participates at every
// header row, with a custom label per level. Lets the Gene ID / Name columns
// carry the row labels ("Study"/"Factor"/"Characteristic" and the type name).
function $4ab64e76c1caef59$var$wrapLeafWithLabels(leaf, labels) {
    let wrapped = leaf;
    for(let i = labels.length - 1; i >= 0; i--){
        const label = labels[i];
        const cls = label.headerClass ? `${label.headerClass} exprviz-hg-labels` : 'exprviz-hg-labels';
        wrapped = {
            headerName: label.headerName,
            headerClass: cls,
            // Always render through one of our components so the alignment and
            // spacing are controlled by our own DOM, not ag-grid's defaults.
            headerGroupComponent: label.headerGroupComponent || $4ab64e76c1caef59$var$LabelHeaderGroup,
            headerGroupComponentParams: label.headerGroupComponentParams,
            children: [
                wrapped
            ]
        };
    }
    return wrapped;
}
// Build the column tree:
//   row 1            — Study           |  Title           |  <study description>…
//   row 2..(2+F-1)   — Factor          |  <factor type>   |  <value or blank>…
//   row 2+F..end-1   — Characteristic  |  <char type>     |  <value or blank>…
//   leaf row         — Gene ID         |  Name            |  g3, g4, …
// Adjacent expression cells sharing the same value at a given level merge
// (because they're children of one group definition). Blank values for a
// type that's defined only in other studies render as empty cells, and
// adjacent blanks under the same parent merge automatically.
function $4ab64e76c1caef59$var$buildColumnDefs(fields, fieldInfo, expanded, toggles) {
    if (!fields || fields.length === 0) return $4ab64e76c1caef59$var$baseColDefs;
    const { factorTypes: factorTypes, charTypes: charTypes } = $4ab64e76c1caef59$var$collectMetadataTypes(fields, fieldInfo);
    const levels = [
        {
            kind: 'study',
            getValue: (info)=>info && info.studyDescription || ''
        }
    ];
    if (expanded.factors) for (const t of factorTypes)levels.push({
        kind: 'factor',
        type: t,
        getValue: (info)=>info && info.factors && info.factors[t] || '',
        headerClass: 'exprviz-hg-factors'
    });
    else if (factorTypes.length > 0) levels.push({
        kind: 'factors-collapsed',
        getValue: ()=>'',
        headerClass: 'exprviz-hg-factors exprviz-hg-collapsed'
    });
    if (expanded.chars) for (const t of charTypes)levels.push({
        kind: 'char',
        type: t,
        getValue: (info)=>info && info.characteristics && info.characteristics[t] || '',
        headerClass: 'exprviz-hg-chars'
    });
    else if (charTypes.length > 0) levels.push({
        kind: 'chars-collapsed',
        getValue: ()=>'',
        headerClass: 'exprviz-hg-chars exprviz-hg-collapsed'
    });
    // Walk fields, opening a new group at level i (and resetting all levels
    // below) the first time the value at level i differs from the previous
    // field's. Same value → same parent group → ag-grid merges the cells.
    const exprTopGroups = [];
    const currentGroups = new Array(levels.length).fill(null);
    const currentKeys = new Array(levels.length).fill(undefined);
    for (const f of fields){
        const info = fieldInfo[f] || {};
        let firstChange = levels.length;
        for(let i = 0; i < levels.length; i++){
            const key = levels[i].getValue(info);
            if (currentGroups[i] === null || currentKeys[i] !== key) {
                firstChange = i;
                break;
            }
        }
        for(let i = firstChange; i < levels.length; i++){
            const key = levels[i].getValue(info);
            const group = {
                headerName: key,
                headerClass: levels[i].headerClass,
                children: []
            };
            currentGroups[i] = group;
            currentKeys[i] = key;
            if (i === 0) exprTopGroups.push(group);
            else currentGroups[i - 1].children.push(group);
        }
        const leaf = {
            field: f,
            headerName: info.group || f.replace(/__expr$/, ''),
            width: 160,
            suppressMovable: false,
            valueFormatter: $4ab64e76c1caef59$var$exprValueFormatter
        };
        currentGroups[levels.length - 1].children.push(leaf);
    }
    // Labels for the two pinned columns. The leftmost column carries the row
    // category ("Study" / "Factor" / "Characteristic"); the next column shows
    // the specific row name (the literal "Title" for the study row, then each
    // factor/characteristic type name). The first row of each
    // factor/characteristic section gets a clickable caret that toggles the
    // section between expanded (one row per type) and collapsed (one
    // placeholder row).
    const studyLabels = [
        {
            headerName: 'Study'
        }
    ];
    const titleLabels = [
        {
            headerName: 'Title'
        }
    ];
    if (expanded.factors) factorTypes.forEach((t, i)=>{
        studyLabels.push({
            headerName: 'Factor',
            headerClass: 'exprviz-hg-factors',
            ...i === 0 ? {
                headerGroupComponent: $4ab64e76c1caef59$var$ToggleHeaderGroup,
                headerGroupComponentParams: {
                    onToggle: toggles.toggleFactors,
                    expanded: true
                }
            } : {}
        });
        titleLabels.push({
            headerName: t,
            headerClass: 'exprviz-hg-factors'
        });
    });
    else if (factorTypes.length > 0) {
        studyLabels.push({
            headerName: 'Factors',
            headerClass: 'exprviz-hg-factors exprviz-hg-collapsed',
            headerGroupComponent: $4ab64e76c1caef59$var$ToggleHeaderGroup,
            headerGroupComponentParams: {
                onToggle: toggles.toggleFactors,
                expanded: false,
                suffix: `(${factorTypes.length})`
            }
        });
        titleLabels.push({
            headerName: '',
            headerClass: 'exprviz-hg-factors exprviz-hg-collapsed'
        });
    }
    if (expanded.chars) charTypes.forEach((t, i)=>{
        studyLabels.push({
            headerName: 'Characteristic',
            headerClass: 'exprviz-hg-chars',
            ...i === 0 ? {
                headerGroupComponent: $4ab64e76c1caef59$var$ToggleHeaderGroup,
                headerGroupComponentParams: {
                    onToggle: toggles.toggleChars,
                    expanded: true
                }
            } : {}
        });
        titleLabels.push({
            headerName: t,
            headerClass: 'exprviz-hg-chars'
        });
    });
    else if (charTypes.length > 0) {
        studyLabels.push({
            headerName: 'Characteristics',
            headerClass: 'exprviz-hg-chars exprviz-hg-collapsed',
            headerGroupComponent: $4ab64e76c1caef59$var$ToggleHeaderGroup,
            headerGroupComponentParams: {
                onToggle: toggles.toggleChars,
                expanded: false,
                suffix: `(${charTypes.length})`
            }
        });
        titleLabels.push({
            headerName: '',
            headerClass: 'exprviz-hg-chars exprviz-hg-collapsed'
        });
    }
    const idCol = $4ab64e76c1caef59$var$wrapLeafWithLabels($4ab64e76c1caef59$var$baseColDefs[0], studyLabels);
    const nameCol = $4ab64e76c1caef59$var$wrapLeafWithLabels($4ab64e76c1caef59$var$baseColDefs[1], titleLabels);
    return [
        idCol,
        nameCol,
        ...exprTopGroups
    ];
}
const $4ab64e76c1caef59$var$ExprTable = ({ rows: rows, fields: fields, onReorder: onReorder, studies: studies, expressionSamples: expressionSamples, onHoverRow: onHoverRow, onDisplayedOrderChange: onDisplayedOrderChange })=>{
    const fieldInfo = (0, $gXNCa$react.useMemo)(()=>$4ab64e76c1caef59$export$7b242440eb2c300d(fields, studies, expressionSamples), [
        fields,
        studies,
        expressionSamples
    ]);
    // Default: factor rows expanded, characteristic rows collapsed (per spec).
    const [expanded, setExpanded] = (0, $gXNCa$react.useState)({
        factors: true,
        chars: false
    });
    const toggleFactors = (0, $gXNCa$react.useCallback)(()=>setExpanded((e)=>({
                ...e,
                factors: !e.factors
            })), []);
    const toggleChars = (0, $gXNCa$react.useCallback)(()=>setExpanded((e)=>({
                ...e,
                chars: !e.chars
            })), []);
    const columnDefs = (0, $gXNCa$react.useMemo)(()=>$4ab64e76c1caef59$var$buildColumnDefs(fields, fieldInfo, expanded, {
            toggleFactors: toggleFactors,
            toggleChars: toggleChars
        }), [
        fields,
        fieldInfo,
        expanded,
        toggleFactors,
        toggleChars
    ]);
    // ag-grid emits modelUpdated after the rowData/sort/filter pipeline runs,
    // so this single hook covers user-driven sort changes AND the auto-resort
    // that ag-grid performs whenever the rowData prop is replaced (e.g. when
    // the parallel-coords brush narrows filteredRows). Walking
    // forEachNodeAfterFilterAndSort gives us the rows in their current
    // displayed order; we pass that up so the heatmap can mirror the table.
    const handleModelUpdated = (0, $gXNCa$react.useCallback)((e)=>{
        if (!onDisplayedOrderChange || !e.api) return;
        const out = [];
        e.api.forEachNodeAfterFilterAndSort((node)=>{
            if (node.data) out.push(node.data);
        });
        onDisplayedOrderChange(out);
    }, [
        onDisplayedOrderChange
    ]);
    const onColumnMoved = (e)=>{
        if (!onReorder || !e.finished) return;
        const allCols = e.api.getAllGridColumns ? e.api.getAllGridColumns() : e.columnApi && e.columnApi.getAllGridColumns && e.columnApi.getAllGridColumns();
        if (!allCols) return;
        const next = allCols.map((c)=>c.getColId()).filter((id)=>fields.includes(id));
        if (!$4ab64e76c1caef59$var$arraysEqual(next, fields)) onReorder(next);
    };
    if (!rows || rows.length === 0) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "exprviz-table-empty",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("em", {
            children: "No data loaded."
        })
    });
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "ag-theme-quartz exprviz-aggrid",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$aggridreact.AgGridReact, {
            rowData: rows,
            columnDefs: columnDefs,
            defaultColDef: $4ab64e76c1caef59$var$DEFAULT_COL_DEF,
            animateRows: false,
            suppressFieldDotNotation: true,
            suppressDragLeaveHidesColumns: true,
            suppressColumnVirtualisation: true,
            groupHeaderHeight: 24,
            onColumnMoved: onColumnMoved,
            onModelUpdated: handleModelUpdated,
            onCellMouseOver: (e)=>onHoverRow && onHoverRow(e.data && e.data.id),
            onCellMouseOut: ()=>onHoverRow && onHoverRow(null)
        })
    });
};
var $4ab64e76c1caef59$export$2e2bcd8739ae039 = $4ab64e76c1caef59$var$ExprTable;
// Parallel-coordinates plot with per-axis brushing and drag-to-reorder axes.
// - Axis labels are draggable horizontally; on drop, onReorder(newOrder) fires.
// - Brushes on axes intersect (AND): a row is "in" only when every active brush contains it.
// - Numeric fields use a linear or symlog scale; non-numeric values are skipped.
const $caf32827df861c4e$var$MARGIN = {
    top: 100,
    right: 24,
    bottom: 24,
    left: 32
};
const $caf32827df861c4e$var$LABEL_ROTATION = -40;
const $caf32827df861c4e$var$BRUSH_WIDTH = 16;
function $caf32827df861c4e$var$isNumeric(v) {
    if (v == null) return false;
    if (Array.isArray(v)) return false;
    const n = +v;
    return Number.isFinite(n);
}
function $caf32827df861c4e$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++)if (a[i] !== b[i]) return false;
    return true;
}
// Powers-of-10 tick values spanning [lo, hi]; includes 0 if the range crosses zero.
// Clamped to |v| >= 0.1 to keep low-magnitude tick labels from overlapping near 0.
const $caf32827df861c4e$var$MIN_LOG_TICK = 0.1;
function $caf32827df861c4e$var$logTickValues([lo, hi]) {
    const ticks = new Set();
    if (lo <= 0 && hi >= 0) ticks.add(0);
    if (hi >= $caf32827df861c4e$var$MIN_LOG_TICK) {
        const start = Math.max(-1, Math.floor(Math.log10(lo > 0 ? lo : $caf32827df861c4e$var$MIN_LOG_TICK)));
        const end = Math.ceil(Math.log10(hi));
        for(let p = start; p <= end; p++){
            const v = Math.pow(10, p);
            if (v >= $caf32827df861c4e$var$MIN_LOG_TICK && v <= hi) ticks.add(v);
        }
    }
    if (lo <= -$caf32827df861c4e$var$MIN_LOG_TICK) {
        const start = Math.max(-1, Math.floor(Math.log10(hi < 0 ? -hi : $caf32827df861c4e$var$MIN_LOG_TICK)));
        const end = Math.ceil(Math.log10(-lo));
        for(let p = start; p <= end; p++){
            const v = -Math.pow(10, p);
            if (-v >= $caf32827df861c4e$var$MIN_LOG_TICK && v >= lo) ticks.add(v);
        }
    }
    return Array.from(ticks).sort((a, b)=>a - b);
}
function $caf32827df861c4e$var$logTickFormat(v) {
    if (v === 0) return '0';
    const a = Math.abs(v);
    if (a >= 0.01 && a < 10000) return $gXNCa$d3.format('~g')(v);
    return $gXNCa$d3.format('.0e')(v);
}
const $caf32827df861c4e$var$ParallelCoordsPlot = ({ rows: rows, fields: fields, scale: scale = 'linear', initialSelections: initialSelections = null, onBrushChange: onBrushChange, onReorder: onReorder, clearVersion: clearVersion = 0, hoveredId: hoveredId = null, axisLabels: axisLabels = null })=>{
    const svgRef = (0, $gXNCa$react.useRef)(null);
    const containerRef = (0, $gXNCa$react.useRef)(null);
    // selections in data domain: { [field]: [lo, hi] }
    const selectionsRef = (0, $gXNCa$react.useRef)({});
    const lastClearRef = (0, $gXNCa$react.useRef)(0);
    // Seed brushes from a restored saved view exactly once (the first render
    // where `initialSelections` is non-empty). Read via a ref so a change to the
    // prop — which happens on every brush as it round-trips through the store —
    // doesn't force an SVG rebuild; the deps below already rerun on data changes.
    const initialSelectionsRef = (0, $gXNCa$react.useRef)(initialSelections);
    initialSelectionsRef.current = initialSelections;
    const seededRef = (0, $gXNCa$react.useRef)(false);
    // Track container size so the d3 render reruns when the user drags the
    // pane resizer (or when the window is resized). The values themselves
    // aren't read inside the effect — the effect always reads clientWidth/
    // clientHeight — but listing them in the deps array is what triggers it.
    const [size, setSize] = (0, $gXNCa$react.useState)({
        w: 0,
        h: 0
    });
    // Custom HTML tooltip for axis labels — gives us bold labels and structured
    // sections, which the native SVG <title> can't do.
    const [tooltip, setTooltip] = (0, $gXNCa$react.useState)(null);
    (0, $gXNCa$react.useEffect)(()=>{
        const el = containerRef.current;
        if (!el || typeof ResizeObserver === 'undefined') return;
        const ro = new ResizeObserver((entries)=>{
            for (const entry of entries){
                const { width: width, height: height } = entry.contentRect;
                setSize((prev)=>{
                    if (Math.abs(prev.w - width) < 1 && Math.abs(prev.h - height) < 1) return prev;
                    return {
                        w: width,
                        h: height
                    };
                });
            }
        });
        ro.observe(el);
        return ()=>ro.disconnect();
    }, []);
    (0, $gXNCa$react.useEffect)(()=>{
        if (!seededRef.current) {
            const init = initialSelectionsRef.current;
            if (init && Object.keys(init).length) {
                selectionsRef.current = {
                    ...init
                };
                seededRef.current = true;
            }
        }
        if (clearVersion !== lastClearRef.current) {
            selectionsRef.current = {};
            lastClearRef.current = clearVersion;
            if (onBrushChange) onBrushChange({});
        }
        Object.keys(selectionsRef.current).forEach((f)=>{
            if (!fields || !fields.includes(f)) delete selectionsRef.current[f];
        });
        const svg = $gXNCa$d3.select(svgRef.current);
        svg.selectAll('*').remove();
        if (!fields || fields.length === 0 || !rows || rows.length === 0) return;
        const el = containerRef.current;
        const width = el && el.clientWidth || 600;
        const height = el && el.clientHeight || 300;
        const innerW = width - $caf32827df861c4e$var$MARGIN.left - $caf32827df861c4e$var$MARGIN.right;
        const innerH = height - $caf32827df861c4e$var$MARGIN.top - $caf32827df861c4e$var$MARGIN.bottom;
        svg.attr('viewBox', `0 0 ${width} ${height}`);
        const g = svg.append('g').attr('transform', `translate(${$caf32827df861c4e$var$MARGIN.left},${$caf32827df861c4e$var$MARGIN.top})`);
        // Mutable order during drag — starts as a copy of fields.
        let order = fields.slice();
        const x = $gXNCa$d3.scalePoint().range([
            0,
            innerW
        ]).padding(0.5).domain(order);
        const yByField = {};
        let globalExt = null;
        if (scale === 'log') {
            const all = [];
            fields.forEach((f)=>{
                rows.forEach((r)=>{
                    const v = r[f];
                    if ($caf32827df861c4e$var$isNumeric(v)) all.push(+v);
                });
            });
            globalExt = all.length ? $gXNCa$d3.extent(all) : [
                0,
                1
            ];
        }
        fields.forEach((f)=>{
            if (scale === 'log') yByField[f] = $gXNCa$d3.scaleSymlog().domain(globalExt).range([
                innerH,
                0
            ]).nice();
            else {
                const vals = rows.map((r)=>r[f]).filter($caf32827df861c4e$var$isNumeric).map(Number);
                const ext = vals.length ? $gXNCa$d3.extent(vals) : [
                    0,
                    1
                ];
                yByField[f] = $gXNCa$d3.scaleLinear().domain(ext).range([
                    innerH,
                    0
                ]).nice();
            }
        });
        function pathForRow(row, posOf) {
            const pts = order.map((f)=>{
                const v = row[f];
                if (!$caf32827df861c4e$var$isNumeric(v)) return null;
                return [
                    posOf(f),
                    yByField[f](Number(v))
                ];
            });
            return line(pts);
        }
        const line = $gXNCa$d3.line().defined((d)=>d != null && Number.isFinite(d[1])).x((d)=>d[0]).y((d)=>d[1]);
        const linesG = g.append('g').attr('class', 'exprviz-pc-lines');
        const paths = linesG.selectAll('path').data(rows).enter().append('path').attr('fill', 'none').attr('stroke', 'steelblue').attr('stroke-width', 1).attr('data-id', (d)=>d && d.id != null ? String(d.id) : null).attr('d', (row)=>pathForRow(row, (f)=>x(f)));
        function isBrushedIn(row) {
            for (const f of order){
                const sel = selectionsRef.current[f];
                if (!sel) continue;
                const v = row[f];
                if (!$caf32827df861c4e$var$isNumeric(v)) return false;
                const n = Number(v);
                const [lo, hi] = sel;
                if (n < lo || n > hi) return false;
            }
            return true;
        }
        function applyBrushStyles() {
            const anyActive = Object.keys(selectionsRef.current).length > 0;
            paths.classed('exprviz-pc-line-in', (d)=>!anyActive || isBrushedIn(d)).classed('exprviz-pc-line-out', (d)=>anyActive && !isBrushedIn(d));
        }
        applyBrushStyles();
        // axis groups, keyed by field name so D3 can match them across reorders
        const axisG = g.selectAll('.exprviz-pc-axis').data(order, (d)=>d).enter().append('g').attr('class', 'exprviz-pc-axis').attr('transform', (d)=>`translate(${x(d)},0)`);
        axisG.each(function(f) {
            const ax = $gXNCa$d3.select(this);
            const axisGen = $gXNCa$d3.axisLeft(yByField[f]);
            if (scale === 'log') axisGen.tickValues($caf32827df861c4e$var$logTickValues(yByField[f].domain())).tickFormat($caf32827df861c4e$var$logTickFormat);
            else axisGen.ticks(5);
            ax.call(axisGen);
            // Compact axis label. Hovering the label or its drag-handle rect shows
            // a custom HTML tooltip (rendered outside the SVG by React) that can
            // include bold labels and section headings.
            const labelInfo = axisLabels && axisLabels[f] || {
                short: f.replace(/__expr$/, ''),
                structured: {
                    studyTitle: f,
                    group: '',
                    factors: [],
                    characteristics: []
                }
            };
            const showTip = (event)=>setTooltip({
                    x: event.clientX,
                    y: event.clientY,
                    info: labelInfo.structured
                });
            const moveTip = (event)=>setTooltip((t)=>t ? {
                        ...t,
                        x: event.clientX,
                        y: event.clientY
                    } : null);
            const hideTip = ()=>setTooltip(null);
            ax.append('text').attr('class', 'exprviz-pc-axis-label').attr('x', 4).attr('y', -4).attr('text-anchor', 'start').attr('transform', `rotate(${$caf32827df861c4e$var$LABEL_ROTATION}, 0, -4)`).attr('fill', '#333').style('font-size', '10px').style('cursor', 'grab').text(labelInfo.short).on('mouseenter', showTip).on('mousemove', moveTip).on('mouseleave', hideTip);
            // hit area for grabbing — sits along the rotated label
            ax.append('rect').attr('class', 'exprviz-pc-axis-handle').attr('x', 0).attr('y', -11).attr('width', 140).attr('height', 14).attr('transform', `rotate(${$caf32827df861c4e$var$LABEL_ROTATION}, 0, -4)`).attr('fill', 'transparent').style('cursor', 'grab').on('mouseenter', showTip).on('mousemove', moveTip).on('mouseleave', hideTip);
            const brush = $gXNCa$d3.brushY().extent([
                [
                    -$caf32827df861c4e$var$BRUSH_WIDTH / 2,
                    0
                ],
                [
                    $caf32827df861c4e$var$BRUSH_WIDTH / 2,
                    innerH
                ]
            ]).on('brush end', (event)=>{
                const s = event.selection;
                if (!s) delete selectionsRef.current[f];
                else {
                    const y = yByField[f];
                    const a = y.invert(s[0]);
                    const b = y.invert(s[1]);
                    selectionsRef.current[f] = [
                        Math.min(a, b),
                        Math.max(a, b)
                    ];
                }
                applyBrushStyles();
                // event.sourceEvent is null when brush.move is called programmatically
                // (e.g. when this effect re-runs and we restore prior selections).
                // Skipping that case avoids a re-render loop with the parent.
                if (event.type === 'end' && event.sourceEvent && onBrushChange) onBrushChange({
                    ...selectionsRef.current
                });
            });
            const brushG = ax.append('g').attr('class', 'exprviz-pc-brush').call(brush);
            const prior = selectionsRef.current[f];
            if (prior) {
                const y = yByField[f];
                const py0 = y(prior[1]);
                const py1 = y(prior[0]);
                if (Number.isFinite(py0) && Number.isFinite(py1)) brushG.call(brush.move, [
                    py0,
                    py1
                ]);
            }
        });
        // Drag-to-reorder: while dragging, only the dragged axis moves and the
        // line segments connecting to it are recomputed. Other axes stay put.
        // The new order is computed once at drag end and emitted via onReorder.
        const drag = $gXNCa$d3.drag().container(function() {
            return g.node();
        }).subject(function(event, d) {
            return {
                x: x(d),
                y: 0
            };
        }).on('start', function(event, d) {
            const axNode = this.parentNode;
            $gXNCa$d3.select(axNode).raise().classed('exprviz-pc-axis-dragging', true);
            $gXNCa$d3.select(axNode).select('.exprviz-pc-axis-label').style('cursor', 'grabbing');
            linesG.classed('exprviz-pc-lines-dragging', true);
        }).on('drag', function(event, d) {
            const axNode = this.parentNode;
            const newX = Math.max(0, Math.min(innerW, event.x));
            $gXNCa$d3.select(axNode).attr('transform', `translate(${newX},0)`);
            paths.attr('d', (row)=>pathForRow(row, (f)=>f === d ? newX : x(f)));
        }).on('end', function(event, d) {
            const axNode = this.parentNode;
            const newX = Math.max(0, Math.min(innerW, event.x));
            $gXNCa$d3.select(axNode).classed('exprviz-pc-axis-dragging', false);
            $gXNCa$d3.select(axNode).select('.exprviz-pc-axis-label').style('cursor', 'grab');
            linesG.classed('exprviz-pc-lines-dragging', false);
            const newOrder = order.slice().sort((a, b)=>{
                const xa = a === d ? newX : x(a);
                const xb = b === d ? newX : x(b);
                return xa - xb;
            });
            if (onReorder && !$caf32827df861c4e$var$arraysEqual(newOrder, fields)) {
                // Snap the dragged axis to its target slot for the brief moment
                // before the parent re-renders with the new order.
                x.domain(newOrder);
                $gXNCa$d3.select(axNode).attr('transform', `translate(${x(d)},0)`);
                paths.attr('d', (row)=>pathForRow(row, (f)=>x(f)));
                onReorder(newOrder);
            } else {
                // No order change — restore the dragged axis to its original slot.
                $gXNCa$d3.select(axNode).attr('transform', `translate(${x(d)},0)`);
                paths.attr('d', (row)=>pathForRow(row, (f)=>x(f)));
            }
        });
        axisG.selectAll('.exprviz-pc-axis-label, .exprviz-pc-axis-handle').call(drag);
    }, [
        rows,
        fields,
        scale,
        onBrushChange,
        onReorder,
        clearVersion,
        axisLabels,
        size.w,
        size.h
    ]);
    // Highlight the polyline matching the hovered row id without rebuilding the
    // SVG. Raises the highlighted path so it draws above its neighbors.
    (0, $gXNCa$react.useEffect)(()=>{
        const svg = $gXNCa$d3.select(svgRef.current);
        if (svg.empty()) return;
        const paths = svg.selectAll('.exprviz-pc-lines path');
        paths.classed('exprviz-pc-line-hover', false);
        if (hoveredId == null) return;
        const target = paths.filter(function() {
            return this.getAttribute('data-id') === String(hoveredId);
        });
        target.classed('exprviz-pc-line-hover', true).raise();
    }, [
        hoveredId,
        rows,
        fields,
        scale
    ]);
    if (!fields || fields.length === 0) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "exprviz-plot-empty",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("em", {
            children: "Select fields to plot."
        })
    });
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        ref: containerRef,
        className: "exprviz-pc-container",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("svg", {
                ref: svgRef,
                width: "100%",
                height: "100%",
                preserveAspectRatio: "none"
            }),
            tooltip && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($caf32827df861c4e$var$AxisTooltip, {
                x: tooltip.x,
                y: tooltip.y,
                info: tooltip.info
            })
        ]
    });
};
// Position-fixed so it can escape the plot pane's clipping. Offset slightly
// from the cursor and clamped to the viewport so it never spills off-screen.
const $caf32827df861c4e$var$AxisTooltip = ({ x: x, y: y, info: info })=>{
    const ref = (0, $gXNCa$react.useRef)(null);
    const [pos, setPos] = (0, $gXNCa$react.useState)({
        left: x + 12,
        top: y + 12
    });
    (0, $gXNCa$react.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const w = el.offsetWidth;
        const h = el.offsetHeight;
        const vw = window.innerWidth;
        const vh = window.innerHeight;
        let left = x + 12;
        let top = y + 12;
        if (left + w > vw - 4) left = Math.max(4, x - 12 - w);
        if (top + h > vh - 4) top = Math.max(4, y - 12 - h);
        setPos({
            left: left,
            top: top
        });
    }, [
        x,
        y,
        info
    ]);
    const { studyTitle: studyTitle, group: group, factors: factors, characteristics: characteristics } = info;
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        ref: ref,
        className: "exprviz-pc-tooltip",
        style: pos,
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        className: "exprviz-pc-tip-key",
                        children: "Study:"
                    }),
                    " ",
                    studyTitle,
                    group ? ` (${group})` : ''
                ]
            }),
            factors.length > 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        className: "exprviz-pc-tip-section",
                        children: "Factors"
                    }),
                    factors.map((p, i)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                            className: "exprviz-pc-tip-row",
                            children: [
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                                    className: "exprviz-pc-tip-key",
                                    children: [
                                        p.name,
                                        ":"
                                    ]
                                }),
                                " ",
                                p.value
                            ]
                        }, `f-${i}`))
                ]
            }),
            characteristics.length > 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        className: "exprviz-pc-tip-section",
                        children: "Characteristics"
                    }),
                    characteristics.map((p, i)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                            className: "exprviz-pc-tip-row",
                            children: [
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                                    className: "exprviz-pc-tip-key",
                                    children: [
                                        p.name,
                                        ":"
                                    ]
                                }),
                                " ",
                                p.value
                            ]
                        }, `c-${i}`))
                ]
            })
        ]
    });
};
var $caf32827df861c4e$export$2e2bcd8739ae039 = $caf32827df861c4e$var$ParallelCoordsPlot;
// Heatmap of (gene × sample) expression values. A compact, color-mapped
// stand-in for the data table; columns line up with the table's column order
// so switching modes preserves the user's mental model.
//
// Scale: discrete threshold-based color bins (5 levels, configurable below)
// going from pale blue (low) to dark blue (high). The bin cutoffs are
// global — they don't adapt to the data — so colors are comparable across
// different gene sets and tabs. Edit BIN_CUTOFFS / BIN_COLORS to retune.
// 4 cutoffs → 5 bins → 5 colors. A value v gets BIN_COLORS[i] where i is
// the largest index such that v >= BIN_CUTOFFS[i-1] (with i=0 below all).
// Defaults assume TPM-like expression magnitudes; adjust for FPKM / counts.
const $689e70d25e86be5c$var$BIN_CUTOFFS = [
    1,
    10,
    100,
    1000
];
const $689e70d25e86be5c$var$BIN_COLORS = [
    '#e8f1f8',
    '#b8d3e6',
    '#6da6cf',
    '#2e6fae',
    '#0a3d72' // dark blue — above last cutoff
];
const $689e70d25e86be5c$var$MIN_CELL_H = 20;
const $689e70d25e86be5c$var$MIN_CELL_W = 20;
const $689e70d25e86be5c$var$CELL_GAP = 1;
const $689e70d25e86be5c$var$HEADER_LABEL_ROTATION = -40;
const $689e70d25e86be5c$var$LABEL_FONT_SIZE = 11;
// Reasonable bounds for label-fit margins so a single huge label can't
// monopolize the visualization space.
const $689e70d25e86be5c$var$LEFT_MARGIN_MIN = 36;
const $689e70d25e86be5c$var$LEFT_MARGIN_MAX = 220;
const $689e70d25e86be5c$var$HEADER_HEIGHT_MIN = 60;
const $689e70d25e86be5c$var$HEADER_HEIGHT_MAX = 200;
const $689e70d25e86be5c$var$RIGHT_MARGIN = 16;
const $689e70d25e86be5c$var$BODY_BOTTOM = 12;
function $689e70d25e86be5c$var$isNumeric(v) {
    if (v == null || Array.isArray(v)) return false;
    return Number.isFinite(+v);
}
function $689e70d25e86be5c$var$fmt(n) {
    if (!Number.isFinite(n)) return String(n);
    const a = Math.abs(n);
    if (a !== 0 && (a < 0.001 || a >= 1e6)) return n.toExponential(3);
    return Number(n.toFixed(4)).toString();
}
function $689e70d25e86be5c$var$studyIdOfField(field) {
    const m = field && field.match(/^(.+?)_g\d+__expr$/);
    return m ? m[1] : field;
}
// One shared canvas context for label measurement — avoids re-creating it
// per render and keeps the math accurate (font metrics depend on the
// browser's actual font rendering).
let $689e70d25e86be5c$var$_measureCtx = null;
function $689e70d25e86be5c$var$measureText(s, fontSize = $689e70d25e86be5c$var$LABEL_FONT_SIZE) {
    if (!s) return 0;
    if (!$689e70d25e86be5c$var$_measureCtx) {
        if (typeof document === 'undefined') return s.length * 6.5;
        $689e70d25e86be5c$var$_measureCtx = document.createElement('canvas').getContext('2d');
    }
    $689e70d25e86be5c$var$_measureCtx.font = `${fontSize}px sans-serif`;
    return $689e70d25e86be5c$var$_measureCtx.measureText(String(s)).width;
}
const $689e70d25e86be5c$var$HeatmapPlot = ({ rows: rows, fields: fields, axisLabels: axisLabels = null, fieldInfo: fieldInfo = null, onHoverRow: onHoverRow = null })=>{
    const containerRef = (0, $gXNCa$react.useRef)(null);
    const innerRef = (0, $gXNCa$react.useRef)(null);
    const headerSvgRef = (0, $gXNCa$react.useRef)(null);
    const bodySvgRef = (0, $gXNCa$react.useRef)(null);
    const bodyScrollRef = (0, $gXNCa$react.useRef)(null);
    const [size, setSize] = (0, $gXNCa$react.useState)({
        w: 0,
        h: 0
    });
    const [tooltip, setTooltip] = (0, $gXNCa$react.useState)(null);
    (0, $gXNCa$react.useEffect)(()=>{
        const el = containerRef.current;
        if (!el || typeof ResizeObserver === 'undefined') return;
        const ro = new ResizeObserver((entries)=>{
            for (const entry of entries){
                const { width: width, height: height } = entry.contentRect;
                setSize((prev)=>{
                    if (Math.abs(prev.w - width) < 1 && Math.abs(prev.h - height) < 1) return prev;
                    return {
                        w: width,
                        h: height
                    };
                });
            }
        });
        ro.observe(el);
        return ()=>ro.disconnect();
    }, []);
    const colorOfValue = (0, $gXNCa$react.useMemo)(()=>{
        const scale = $gXNCa$d3.scaleThreshold().domain($689e70d25e86be5c$var$BIN_CUTOFFS).range($689e70d25e86be5c$var$BIN_COLORS);
        return (v)=>$689e70d25e86be5c$var$isNumeric(v) ? scale(+v) : '#f2f2f2';
    }, []);
    // Pre-compute label-fit dimensions so the d3 effect can lay things out
    // and the React legend can use the same numbers.
    const layout = (0, $gXNCa$react.useMemo)(()=>{
        const containerW = size.w || 600;
        const containerH = size.h || 300;
        // Left margin: enough to fit the longest gene name / id, capped.
        let maxRowLabel = 0;
        for (const r of rows || []){
            const w = $689e70d25e86be5c$var$measureText(r.name || r.id || '');
            if (w > maxRowLabel) maxRowLabel = w;
        }
        const leftMargin = Math.max($689e70d25e86be5c$var$LEFT_MARGIN_MIN, Math.min($689e70d25e86be5c$var$LEFT_MARGIN_MAX, Math.ceil(maxRowLabel) + 12));
        // Header height: the rotated column label takes up labelWidth*sin(40°)
        // vertical pixels. Cap to keep things sane on pathologically long names.
        let maxColLabel = 0;
        for (const f of fields || []){
            const lab = axisLabels && axisLabels[f] && axisLabels[f].short || f;
            const w = $689e70d25e86be5c$var$measureText(lab);
            if (w > maxColLabel) maxColLabel = w;
        }
        const sinR = Math.sin(Math.abs($689e70d25e86be5c$var$HEADER_LABEL_ROTATION) * Math.PI / 180);
        const headerH = Math.max($689e70d25e86be5c$var$HEADER_HEIGHT_MIN, Math.min($689e70d25e86be5c$var$HEADER_HEIGHT_MAX, Math.ceil(maxColLabel * sinR) + 18));
        const availPlotW = Math.max(0, containerW - leftMargin - $689e70d25e86be5c$var$RIGHT_MARGIN);
        const availPlotH = Math.max(0, containerH - headerH - $689e70d25e86be5c$var$BODY_BOTTOM);
        const nFields = fields && fields.length || 0;
        const nRows = rows && rows.length || 0;
        const fitCellW = nFields > 0 ? availPlotW / nFields : $689e70d25e86be5c$var$MIN_CELL_W;
        const fitCellH = nRows > 0 ? availPlotH / nRows : $689e70d25e86be5c$var$MIN_CELL_H;
        const cellW = Math.max($689e70d25e86be5c$var$MIN_CELL_W, fitCellW);
        const cellH = Math.max($689e70d25e86be5c$var$MIN_CELL_H, fitCellH);
        const innerW = cellW * nFields;
        const innerH = cellH * nRows;
        // Total width of the inner block (header + body share this width so the
        // outer container's horizontal scroll moves them together).
        const totalW = leftMargin + innerW + $689e70d25e86be5c$var$RIGHT_MARGIN;
        return {
            leftMargin: leftMargin,
            headerH: headerH,
            cellW: cellW,
            cellH: cellH,
            innerW: innerW,
            innerH: innerH,
            totalW: totalW,
            containerW: containerW,
            containerH: containerH
        };
    }, [
        rows,
        fields,
        axisLabels,
        size.w,
        size.h
    ]);
    (0, $gXNCa$react.useEffect)(()=>{
        const headerSvg = $gXNCa$d3.select(headerSvgRef.current);
        const bodySvg = $gXNCa$d3.select(bodySvgRef.current);
        headerSvg.selectAll('*').remove();
        bodySvg.selectAll('*').remove();
        if (!fields || fields.length === 0 || !rows || rows.length === 0) return;
        const { leftMargin: leftMargin, headerH: headerH, cellW: cellW, cellH: cellH, innerW: innerW, innerH: innerH, totalW: totalW } = layout;
        // ---- header SVG: rotated column labels, study separator ticks ----
        headerSvg.attr('width', totalW).attr('height', headerH);
        const hg = headerSvg.append('g').attr('transform', `translate(${leftMargin},${headerH})`);
        const labelGroup = hg.append('g').attr('class', 'exprviz-hm-collabels');
        let prevStudy = null;
        fields.forEach((f, i)=>{
            const cx = i * cellW + cellW / 2;
            const label = axisLabels && axisLabels[f] && axisLabels[f].short || f;
            const t = labelGroup.append('text').attr('class', 'exprviz-hm-collabel').attr('transform', `translate(${cx},-6) rotate(${$689e70d25e86be5c$var$HEADER_LABEL_ROTATION})`).attr('text-anchor', 'start').attr('font-size', $689e70d25e86be5c$var$LABEL_FONT_SIZE).text(label);
            const struct = axisLabels && axisLabels[f] && axisLabels[f].structured;
            if (struct) {
                const titleParts = [
                    struct.studyTitle
                ];
                if (struct.group) titleParts.push(`Group: ${struct.group}`);
                struct.factors && struct.factors.forEach((p)=>titleParts.push(`${p.name}: ${p.value}`));
                struct.characteristics && struct.characteristics.forEach((p)=>titleParts.push(`${p.name}: ${p.value}`));
                t.append('title').text(titleParts.join('\n'));
            }
            // Tick marks at study boundaries inside the header so groupings stay
            // visible even after a horizontal scroll.
            const sid = $689e70d25e86be5c$var$studyIdOfField(f);
            if (i > 0 && sid !== prevStudy) hg.append('line').attr('x1', i * cellW).attr('x2', i * cellW).attr('y1', -4).attr('y2', 0).attr('stroke', '#666').attr('stroke-width', 1);
            prevStudy = sid;
        });
        // ---- body SVG ----
        const bodyH = innerH + $689e70d25e86be5c$var$BODY_BOTTOM;
        bodySvg.attr('width', totalW).attr('height', bodyH);
        const g = bodySvg.append('g').attr('transform', `translate(${leftMargin},0)`);
        // Vertical separators between studies — full height.
        prevStudy = null;
        fields.forEach((f, i)=>{
            const sid = $689e70d25e86be5c$var$studyIdOfField(f);
            if (i > 0 && sid !== prevStudy) g.append('line').attr('class', 'exprviz-hm-study-sep').attr('x1', i * cellW).attr('x2', i * cellW).attr('y1', 0).attr('y2', innerH).attr('stroke', '#fff').attr('stroke-width', 2);
            prevStudy = sid;
        });
        // ---- cells ----
        const cellsGroup = g.append('g').attr('class', 'exprviz-hm-cells');
        // Hover outline lives in its own <g> so cell event handlers can update
        // it imperatively without re-running this effect.
        const overlayGroup = g.append('g').attr('class', 'exprviz-hm-overlay');
        const showHover = (row, field, mx, my, value)=>{
            const ax = axisLabels && axisLabels[field] && axisLabels[field].structured;
            const info = fieldInfo && fieldInfo[field];
            setTooltip({
                x: mx + 12,
                y: my + 12,
                gene: {
                    id: row.id,
                    name: row.name
                },
                value: value,
                study: ax && ax.studyTitle || info && info.studyDescription || '',
                group: ax && ax.group || info && info.group || '',
                replicates: info && info.replicates,
                factors: ax && ax.factors || (info && info.factors ? Object.entries(info.factors).map(([name, value])=>({
                        name: name,
                        value: value
                    })) : []),
                characteristics: ax && ax.characteristics || (info && info.characteristics ? Object.entries(info.characteristics).map(([name, value])=>({
                        name: name,
                        value: value
                    })) : [])
            });
            if (onHoverRow) onHoverRow(row.id);
        };
        const clearHover = ()=>{
            overlayGroup.selectAll('*').remove();
            setTooltip(null);
            if (onHoverRow) onHoverRow(null);
        };
        const cellInnerW = Math.max(0.5, cellW - $689e70d25e86be5c$var$CELL_GAP);
        const cellInnerH = Math.max(0.5, cellH - $689e70d25e86be5c$var$CELL_GAP);
        rows.forEach((row, ri)=>{
            const rg = cellsGroup.append('g').attr('class', 'exprviz-hm-row').attr('data-id', row.id).attr('transform', `translate(0, ${ri * cellH})`);
            fields.forEach((f, ci)=>{
                const v = row[f];
                const numeric = $689e70d25e86be5c$var$isNumeric(v);
                const fill = colorOfValue(v);
                const rect = rg.append('rect').attr('x', ci * cellW).attr('y', 0).attr('width', cellInnerW).attr('height', cellInnerH).attr('fill', fill).attr('stroke', 'none');
                rect.on('pointerenter pointermove', (event)=>{
                    overlayGroup.selectAll('*').remove();
                    overlayGroup.append('rect').attr('x', ci * cellW).attr('y', ri * cellH).attr('width', cellInnerW).attr('height', cellInnerH).attr('fill', 'none').attr('stroke', '#d62728').attr('stroke-width', 1.5).attr('pointer-events', 'none');
                    showHover(row, f, event.clientX, event.clientY, numeric ? +v : null);
                });
                rect.on('pointerleave', clearHover);
            });
        });
        // ---- row labels (always rendered: cellH >= MIN_CELL_H = 20) ----
        const labels = g.append('g').attr('class', 'exprviz-hm-rowlabels');
        rows.forEach((row, ri)=>{
            labels.append('text').attr('x', -6).attr('y', ri * cellH + cellH / 2).attr('text-anchor', 'end').attr('dominant-baseline', 'middle').attr('font-size', Math.min($689e70d25e86be5c$var$LABEL_FONT_SIZE, cellH - 2)).text(row.name || row.id);
        });
    }, [
        rows,
        fields,
        axisLabels,
        fieldInfo,
        layout,
        colorOfValue,
        onHoverRow
    ]);
    // Inner block width matches the SVG width so when content is wider than
    // the container, the outer container scrolls horizontally and both
    // header + body translate together (col labels stay aligned with cells).
    const innerStyle = {
        width: layout.totalW || '100%'
    };
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "exprviz-hm-container",
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "exprviz-hm-inner",
                ref: innerRef,
                style: innerStyle,
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        className: "exprviz-hm-header",
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("svg", {
                            ref: headerSvgRef
                        })
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        className: "exprviz-hm-body",
                        ref: bodyScrollRef,
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("svg", {
                            ref: bodySvgRef
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($689e70d25e86be5c$var$Legend, {}),
            tooltip && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "exprviz-pc-tooltip",
                style: {
                    left: tooltip.x,
                    top: tooltip.y
                },
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                className: "exprviz-pc-tip-key",
                                children: tooltip.gene.id
                            }),
                            tooltip.gene.name ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
                                children: [
                                    " \xb7 ",
                                    tooltip.gene.name
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                className: "exprviz-pc-tip-key",
                                children: "Value:"
                            }),
                            " ",
                            tooltip.value == null ? "\u2014" : $689e70d25e86be5c$var$fmt(tooltip.value)
                        ]
                    }),
                    tooltip.study && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                className: "exprviz-pc-tip-section",
                                children: "Study"
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                className: "exprviz-pc-tip-row",
                                children: tooltip.study
                            }),
                            tooltip.group && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                className: "exprviz-pc-tip-row",
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                        className: "exprviz-pc-tip-key",
                                        children: "Group:"
                                    }),
                                    " ",
                                    tooltip.group,
                                    tooltip.replicates ? ` (${tooltip.replicates} rep${tooltip.replicates === 1 ? '' : 's'})` : ''
                                ]
                            })
                        ]
                    }),
                    tooltip.factors && tooltip.factors.length > 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                className: "exprviz-pc-tip-section",
                                children: "Factors"
                            }),
                            tooltip.factors.map((p, i)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                    className: "exprviz-pc-tip-row",
                                    children: [
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                                            className: "exprviz-pc-tip-key",
                                            children: [
                                                p.name,
                                                ":"
                                            ]
                                        }),
                                        " ",
                                        p.value
                                    ]
                                }, `f${i}`))
                        ]
                    }),
                    tooltip.characteristics && tooltip.characteristics.length > 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                className: "exprviz-pc-tip-section",
                                children: "Characteristics"
                            }),
                            tooltip.characteristics.map((p, i)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                    className: "exprviz-pc-tip-row",
                                    children: [
                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                                            className: "exprviz-pc-tip-key",
                                            children: [
                                                p.name,
                                                ":"
                                            ]
                                        }),
                                        " ",
                                        p.value
                                    ]
                                }, `c${i}`))
                        ]
                    })
                ]
            })
        ]
    });
};
// 5-bin discrete legend, positioned in the top-right of the heatmap pane.
// Lives outside the scroll container so it's always visible regardless of
// where the user has scrolled.
const $689e70d25e86be5c$var$Legend = ()=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "exprviz-hm-legend",
        title: "Expression bins. Edit BIN_CUTOFFS / BIN_COLORS in HeatmapPlot.js to retune.",
        children: $689e70d25e86be5c$var$BIN_COLORS.map((color, i)=>{
            const lo = i === 0 ? null : $689e70d25e86be5c$var$BIN_CUTOFFS[i - 1];
            const hi = i === $689e70d25e86be5c$var$BIN_CUTOFFS.length ? null : $689e70d25e86be5c$var$BIN_CUTOFFS[i];
            let label;
            if (lo == null) label = `< ${hi}`;
            else if (hi == null) label = `\u{2265} ${lo}`;
            else label = `${lo}\u{2013}${hi}`;
            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "exprviz-hm-legend-bin",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        className: "exprviz-hm-legend-swatch",
                        style: {
                            background: color
                        }
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        className: "exprviz-hm-legend-label",
                        children: label
                    })
                ]
            }, i);
        })
    });
var $689e70d25e86be5c$export$2e2bcd8739ae039 = $689e70d25e86be5c$var$HeatmapPlot;
function $1fd2507769d5bd00$var$speciesTaxonId(tid) {
    const n = +tid;
    return n > 1000000 ? Math.floor(n / 1000) : n;
}
function $1fd2507769d5bd00$var$genomeName(grameneMaps, tid) {
    if (!grameneMaps) return tid;
    const direct = grameneMaps[tid];
    if (direct && direct.display_name) return direct.display_name;
    const sp = grameneMaps[$1fd2507769d5bd00$var$speciesTaxonId(tid)];
    if (sp && sp.display_name) return sp.display_name;
    return tid;
}
const $1fd2507769d5bd00$var$ExprVizViewCmp = (props)=>{
    const { exprVizPivot: pivot, exprViz: exprViz, exprVizActiveTaxon: activeTaxon, grameneMaps: grameneMaps, expressionStudies: expressionStudies, expressionSamples: expressionSamples, doSetExprVizActiveTaxon: doSetExprVizActiveTaxon, doToggleExprVizFieldsModal: doToggleExprVizFieldsModal, doFetchExprVizData: doFetchExprVizData } = props;
    const studiesFor = (tid)=>{
        if (!expressionStudies) return [];
        return expressionStudies[tid] || expressionStudies[$1fd2507769d5bd00$var$speciesTaxonId(tid)] || [];
    };
    const taxa = (0, $gXNCa$react.useMemo)(()=>{
        const ids = Object.keys(pivot.data || {});
        if (!grameneMaps) return ids;
        return ids.sort((a, b)=>{
            const ma = grameneMaps[a] || grameneMaps[$1fd2507769d5bd00$var$speciesTaxonId(a)];
            const mb = grameneMaps[b] || grameneMaps[$1fd2507769d5bd00$var$speciesTaxonId(b)];
            return (ma && ma.left_index || 0) - (mb && mb.left_index || 0);
        });
    }, [
        pivot.data,
        grameneMaps
    ]);
    (0, $gXNCa$react.useEffect)(()=>{
        if (taxa.length === 0) return;
        if (!activeTaxon || !taxa.includes(String(activeTaxon))) doSetExprVizActiveTaxon(taxa[0]);
    }, [
        taxa,
        activeTaxon,
        doSetExprVizActiveTaxon
    ]);
    if (pivot.status === 'loading') return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "exprviz-view",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("em", {
            children: "Loading studies\u2026"
        })
    });
    if (pivot.status === 'error') return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "exprviz-view",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("em", {
            children: [
                "Error: ",
                pivot.error
            ]
        })
    });
    if (taxa.length === 0) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "exprviz-view",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("em", {
            children: "No expression studies for current results."
        })
    });
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "exprviz-view",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Tabs, {
                activeKey: activeTaxon || taxa[0],
                onSelect: (k)=>doSetExprVizActiveTaxon(k),
                className: "exprviz-tabs",
                children: taxa.map((tid)=>{
                    const studies = studiesFor(tid);
                    const taxName = $1fd2507769d5bd00$var$genomeName(grameneMaps, tid);
                    const geneCount = pivot.data[tid] || 0;
                    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Tab, {
                        eventKey: tid,
                        title: `${taxName} (${studies.length} studies \xb7 ${geneCount} genes)`,
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($1fd2507769d5bd00$var$TaxonPanel, {
                            taxon: tid,
                            studies: studies,
                            expressionSamples: expressionSamples,
                            tabState: exprViz.byTaxon[tid],
                            onOpenFields: ()=>doToggleExprVizFieldsModal(tid, true),
                            onLoad: ()=>doFetchExprVizData(tid),
                            onReorder: (next)=>props.doReorderExprVizFields(tid, next),
                            onAddRangeQuery: props.doAddGrameneRangeQuery,
                            onSetVizMode: (m)=>props.doSetExprVizVizMode(tid, m),
                            onSetScale: (s)=>props.doSetExprVizScale(tid, s),
                            onSetBrushes: (b)=>props.doSetExprVizBrushes(tid, b)
                        })
                    }, tid);
                })
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($4d0c2e01f58b53b1$export$2e2bcd8739ae039, {})
        ]
    });
};
// Compact axis labels for the parallel-coords plot. The raw Solr field name
// (e.g. "E_CURD_148_g5__expr") is uninformative; we prefer the assay's
// factor labels, falling back to "organism part" then to the group id.
// `full` is exposed via an SVG <title> so the user can hover to see study,
// group, and every factor/characteristic.
const $1fd2507769d5bd00$var$AXIS_LABEL_MAX = 22;
function $1fd2507769d5bd00$var$truncateLabel(s, n) {
    if (!s) return '';
    return s.length > n ? s.slice(0, n - 1) + "\u2026" : s;
}
function $1fd2507769d5bd00$var$compactAssayLabel(assay, group) {
    if (!assay) return group || '';
    const factorVals = (assay.factor || []).map((f)=>f && f.label).filter(Boolean);
    if (factorVals.length) return factorVals.join('; ');
    const chars = assay.characteristic || [];
    const organ = chars.find((c)=>c && c.type === 'organism part');
    if (organ && organ.label) return organ.label;
    const firstChar = chars.find((c)=>c && c.label);
    if (firstChar) return firstChar.label;
    return group || '';
}
function $1fd2507769d5bd00$var$assayPairs(list) {
    return (list || []).filter((x)=>x && x.label).map((x)=>({
            name: x.type || '',
            value: x.label
        }));
}
function $1fd2507769d5bd00$var$buildAxisLabels(fields, studies, expressionSamples) {
    const labels = {};
    if (!fields) return labels;
    const studyById = {};
    (studies || []).forEach((s)=>{
        if (s && s._id) studyById[s._id] = s;
    });
    const findAssay = (studyId, group)=>{
        const arr = expressionSamples && expressionSamples[studyId];
        return arr ? arr.find((a)=>a.group === group) : null;
    };
    for (const f of fields){
        const m = f.match(/^(.+?)_g(\d+)__expr$/);
        if (!m) {
            labels[f] = {
                short: $1fd2507769d5bd00$var$truncateLabel(f.replace(/__expr$/, ''), $1fd2507769d5bd00$var$AXIS_LABEL_MAX),
                structured: {
                    studyTitle: f,
                    group: '',
                    factors: [],
                    characteristics: []
                }
            };
            continue;
        }
        const expId = m[1].replace(/_/g, '-');
        const group = 'g' + m[2];
        const assay = findAssay(expId, group);
        const study = studyById[expId];
        const studyName = study && study.description || expId;
        labels[f] = {
            short: $1fd2507769d5bd00$var$truncateLabel($1fd2507769d5bd00$var$compactAssayLabel(assay, group), $1fd2507769d5bd00$var$AXIS_LABEL_MAX),
            structured: {
                studyTitle: studyName,
                group: group,
                factors: $1fd2507769d5bd00$var$assayPairs(assay && assay.factor),
                characteristics: $1fd2507769d5bd00$var$assayPairs(assay && assay.characteristic)
            }
        };
    }
    return labels;
}
function $1fd2507769d5bd00$var$rowMatchesSelections(row, selections) {
    for (const f of Object.keys(selections)){
        const v = row[f];
        if (v == null || Array.isArray(v)) return false;
        const n = +v;
        if (!Number.isFinite(n)) return false;
        const [lo, hi] = selections[f];
        if (n < lo || n > hi) return false;
    }
    return true;
}
function $1fd2507769d5bd00$var$fmt(n) {
    if (!Number.isFinite(n)) return String(n);
    const a = Math.abs(n);
    if (a !== 0 && (a < 0.001 || a >= 1e6)) return n.toExponential(3);
    return Number(n.toFixed(4)).toString();
}
function $1fd2507769d5bd00$var$tsvCell(v) {
    if (v == null) return '';
    if (Array.isArray(v)) return v.join(',');
    const s = typeof v === 'object' ? JSON.stringify(v) : String(v);
    return s.replace(/[\t\r\n]+/g, ' ');
}
// Mirror the on-screen table header in the TSV: one row per metadata level
// the table is showing (Study, then one row per distinct factor type, then
// one row per distinct characteristic type), followed by the leaf header
// (Gene ID / Name / per-sample group). The first two columns are repurposed
// to carry the row category and the row's specific name, matching the
// pinned-column labels in ExprTable.
function $1fd2507769d5bd00$var$downloadTsv(filename, rows, fields, studies, expressionSamples) {
    const cols = [
        'id',
        'name',
        ...fields
    ];
    const fieldInfo = $4ab64e76c1caef59$export$7b242440eb2c300d(fields, studies, expressionSamples);
    const factorTypes = new Set();
    const charTypes = new Set();
    for (const f of fields){
        const info = fieldInfo[f];
        if (!info) continue;
        Object.keys(info.factors || {}).forEach((t)=>factorTypes.add(t));
        Object.keys(info.characteristics || {}).forEach((t)=>charTypes.add(t));
    }
    const factorTypeList = Array.from(factorTypes).sort();
    const charTypeList = Array.from(charTypes).sort();
    const metaRow = (cat, label, getValue)=>{
        const cells = [
            cat,
            label
        ];
        for (const f of fields)cells.push($1fd2507769d5bd00$var$tsvCell(getValue(fieldInfo[f] || {})));
        return cells.join('\t');
    };
    const lines = [];
    lines.push(metaRow('Study', 'Title', (info)=>info.studyDescription || ''));
    for (const t of factorTypeList)lines.push(metaRow('Factor', t, (info)=>info.factors && info.factors[t] || ''));
    for (const t of charTypeList)lines.push(metaRow('Characteristic', t, (info)=>info.characteristics && info.characteristics[t] || ''));
    // Leaf header — column ids for the data rows.
    lines.push([
        'Gene ID',
        'Name',
        ...fields.map((f)=>{
            const info = fieldInfo[f];
            return info && info.group || f.replace(/__expr$/, '');
        })
    ].join('\t'));
    for (const r of rows)lines.push(cols.map((c)=>$1fd2507769d5bd00$var$tsvCell(r[c])).join('\t'));
    const blob = new Blob([
        lines.join('\n') + '\n'
    ], {
        type: 'text/tab-separated-values'
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
const $1fd2507769d5bd00$var$TaxonPanel = ({ taxon: taxon, studies: studies, expressionSamples: expressionSamples, tabState: tabState, onOpenFields: onOpenFields, onLoad: onLoad, onReorder: onReorder, onAddRangeQuery: onAddRangeQuery, onSetVizMode: onSetVizMode, onSetScale: onSetScale, onSetBrushes: onSetBrushes })=>{
    const selected = tabState && tabState.selectedFields || [];
    const rows = tabState && tabState.rows || [];
    const fetchInfo = tabState && tabState.fetch || {
        status: 'idle',
        total: 0
    };
    // View config (sub-tab, scale, brushes) is persisted in the exprViz bundle
    // per taxon so a saved view can round-trip it. Driven controlled from here.
    const scale = tabState && tabState.scale || 'linear';
    const vizMode = tabState && tabState.vizMode || 'heatmap'; // 'parallel' | 'heatmap'
    const selections = tabState && tabState.brushes || {};
    const setScale = (s)=>onSetScale && onSetScale(s);
    const setVizMode = (m)=>onSetVizMode && onSetVizMode(m);
    const setSelections = (b)=>onSetBrushes && onSetBrushes(b);
    const [clearVersion, setClearVersion] = (0, $gXNCa$react.useState)(0);
    const [hoveredId, setHoveredId] = (0, $gXNCa$react.useState)(null);
    const [plotHeight, setPlotHeight] = (0, $gXNCa$react.useState)(320);
    // Mirror of the table's currently displayed (post-sort, post-filter) rows.
    // When the user clicks a column header to sort, ag-grid resorts and emits
    // modelUpdated; we capture that order here so the heatmap below renders
    // in the same order. Null until the table has emitted at least once.
    const [tableOrder, setTableOrder] = (0, $gXNCa$react.useState)(null);
    const resizeStateRef = (0, $gXNCa$react.useRef)(null);
    // Drag the horizontal separator between the plot and the table to retune
    // their relative sizes. Bounded so neither pane disappears entirely.
    const startResize = (e)=>{
        e.preventDefault();
        resizeStateRef.current = {
            startY: e.clientY,
            startHeight: plotHeight
        };
        const onMove = (ev)=>{
            const s = resizeStateRef.current;
            if (!s) return;
            const next = Math.max(120, Math.min(1200, s.startHeight + (ev.clientY - s.startY)));
            setPlotHeight(next);
        };
        const onUp = ()=>{
            resizeStateRef.current = null;
            document.removeEventListener('mousemove', onMove);
            document.removeEventListener('mouseup', onUp);
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
        };
        document.body.style.cursor = 'row-resize';
        document.body.style.userSelect = 'none';
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
    };
    const hasBrush = Object.keys(selections).length > 0;
    const filteredRows = (0, $gXNCa$react.useMemo)(()=>{
        if (!hasBrush) return rows;
        return rows.filter((r)=>$1fd2507769d5bd00$var$rowMatchesSelections(r, selections));
    }, [
        rows,
        selections,
        hasBrush
    ]);
    // Drop fields with no numeric data in the loaded rows so empty axes/columns
    // don't clutter the visualization. Selected-but-empty fields stay in the
    // underlying selection so a future load can repopulate them.
    const visibleFields = (0, $gXNCa$react.useMemo)(()=>{
        if (rows.length === 0 || selected.length === 0) return selected;
        return selected.filter((f)=>rows.some((r)=>{
                const v = r[f];
                return v != null && !Array.isArray(v) && Number.isFinite(+v);
            }));
    }, [
        rows,
        selected
    ]);
    const handleReorder = onReorder ? (newVisibleOrder)=>{
        const visibleSet = new Set(newVisibleOrder);
        const hidden = selected.filter((f)=>!visibleSet.has(f));
        onReorder([
            ...newVisibleOrder,
            ...hidden
        ]);
    } : undefined;
    const axisLabels = (0, $gXNCa$react.useMemo)(()=>$1fd2507769d5bd00$var$buildAxisLabels(visibleFields, studies, expressionSamples), [
        visibleFields,
        studies,
        expressionSamples
    ]);
    const fieldInfo = (0, $gXNCa$react.useMemo)(()=>$4ab64e76c1caef59$export$7b242440eb2c300d(visibleFields, studies, expressionSamples), [
        visibleFields,
        studies,
        expressionSamples
    ]);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "exprviz-tab-panel",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "exprviz-toolbar",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Button, {
                        size: "sm",
                        onClick: onOpenFields,
                        children: [
                            "Select fields (",
                            selected.length,
                            " selected, ",
                            studies.length,
                            " studies)"
                        ]
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                        size: "sm",
                        variant: "primary",
                        disabled: selected.length === 0 || fetchInfo.status === 'loading',
                        onClick: onLoad,
                        children: fetchInfo.status === 'loading' ? "Loading\u2026" : 'Load data'
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.ToggleButtonGroup, {
                        type: "radio",
                        name: `exprviz-viz-${taxon}`,
                        size: "sm",
                        value: vizMode,
                        onChange: setVizMode,
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.ToggleButton, {
                                id: `exprviz-viz-${taxon}-hm`,
                                value: "heatmap",
                                variant: "outline-secondary",
                                title: "Heatmap: cell color encodes expression level; hover for sample metadata",
                                children: "Heatmap"
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.ToggleButton, {
                                id: `exprviz-viz-${taxon}-pc`,
                                value: "parallel",
                                variant: "outline-secondary",
                                title: "Parallel coordinates: one polyline per gene with brushable axes",
                                children: "Parallel"
                            })
                        ]
                    }),
                    vizMode === 'parallel' && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.ToggleButtonGroup, {
                                type: "radio",
                                name: `exprviz-scale-${taxon}`,
                                size: "sm",
                                value: scale,
                                onChange: setScale,
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.ToggleButton, {
                                        id: `exprviz-scale-${taxon}-lin`,
                                        value: "linear",
                                        variant: "outline-secondary",
                                        children: "Linear"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.ToggleButton, {
                                        id: `exprviz-scale-${taxon}-log`,
                                        value: "log",
                                        variant: "outline-secondary",
                                        children: "Log"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                                size: "sm",
                                variant: "outline-secondary",
                                disabled: !hasBrush,
                                onClick: ()=>{
                                    setClearVersion((v)=>v + 1);
                                    setSelections({});
                                },
                                children: "Clear brushes"
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                                size: "sm",
                                variant: "success",
                                disabled: !hasBrush || !onAddRangeQuery,
                                onClick: ()=>{
                                    const terms = Object.keys(selections).map((field)=>{
                                        const [lo, hi] = selections[field];
                                        return {
                                            category: 'Expression',
                                            name: `${field}: ${$1fd2507769d5bd00$var$fmt(lo)}\u{2013}${$1fd2507769d5bd00$var$fmt(hi)}`,
                                            fq_field: field,
                                            fq_value: `[${lo} TO ${hi}]`
                                        };
                                    });
                                    onAddRangeQuery(terms);
                                },
                                title: "Add brush ranges as an AND-conjunction filter on the search",
                                children: "Apply as filter"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                        size: "sm",
                        variant: "outline-secondary",
                        disabled: filteredRows.length === 0 || visibleFields.length === 0,
                        onClick: ()=>$1fd2507769d5bd00$var$downloadTsv(`expression_${taxon}.tsv`, filteredRows, visibleFields, studies, expressionSamples),
                        title: "Download the visible rows and columns as tab-delimited text",
                        children: "Download TSV"
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                        className: "exprviz-status",
                        children: [
                            hasBrush ? `${filteredRows.length} of ${rows.length}` : rows.length,
                            fetchInfo.total ? ` / ${fetchInfo.total}` : '',
                            " genes",
                            hasBrush ? ' (brushed)' : ' loaded'
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "exprviz-body",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        className: "exprviz-plot",
                        style: {
                            height: plotHeight
                        },
                        children: vizMode === 'heatmap' ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($689e70d25e86be5c$export$2e2bcd8739ae039, {
                            rows: tableOrder || filteredRows,
                            fields: visibleFields,
                            scale: scale,
                            axisLabels: axisLabels,
                            fieldInfo: fieldInfo,
                            hoveredId: hoveredId,
                            onHoverRow: setHoveredId
                        }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($caf32827df861c4e$export$2e2bcd8739ae039, {
                            rows: rows,
                            fields: visibleFields,
                            scale: scale,
                            initialSelections: selections,
                            onBrushChange: setSelections,
                            onReorder: handleReorder,
                            clearVersion: clearVersion,
                            hoveredId: hoveredId,
                            axisLabels: axisLabels
                        })
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        className: "exprviz-resizer",
                        role: "separator",
                        "aria-orientation": "horizontal",
                        "aria-label": "Resize plot",
                        onMouseDown: startResize,
                        title: "Drag to resize"
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        className: "exprviz-table",
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($4ab64e76c1caef59$export$2e2bcd8739ae039, {
                            rows: filteredRows,
                            fields: visibleFields,
                            onReorder: handleReorder,
                            studies: studies,
                            expressionSamples: expressionSamples,
                            onHoverRow: setHoveredId,
                            onDisplayedOrderChange: setTableOrder
                        })
                    })
                ]
            })
        ]
    });
};
var $1fd2507769d5bd00$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)('selectExprViz', 'selectExprVizPivot', 'selectExprVizActiveTaxon', 'selectGrameneMaps', 'selectExpressionStudies', 'selectExpressionSamples', 'doSetExprVizActiveTaxon', 'doToggleExprVizFieldsModal', 'doFetchExprVizData', 'doReorderExprVizFields', 'doSetExprVizVizMode', 'doSetExprVizScale', 'doSetExprVizBrushes', 'doAddGrameneRangeQuery', $1fd2507769d5bd00$var$ExprVizViewCmp);
const { MAX_GENES: $8f8e530286a37ce9$var$MAX_GENES } = $12feb7ca48271e17$export$d00a9fd01497b827;
// expr_organ_level expands into one column per organ (the heatmap block).
const $8f8e530286a37ce9$var$ORGAN_FIELD = 'expr_organ_level__attr_ss';
// The two stress fields render as a single merged column.
const $8f8e530286a37ce9$var$STRESS_UP = 'expr_activated_by__attr_ss';
const $8f8e530286a37ce9$var$STRESS_DOWN = 'expr_repressed_by__attr_ss';
const $8f8e530286a37ce9$var$STRESS_COL = 'stress';
const $8f8e530286a37ce9$var$DEFAULT_COL_DEF = {
    resizable: true,
    sortable: true,
    filter: false,
    suppressHeaderMenuButton: true
};
const $8f8e530286a37ce9$var$WIDTHS = {
    id: 190,
    name: 130,
    system_name: 150,
    biotype: 120,
    taxon_id: 100,
    db_type: 100,
    alt_id: 180,
    synonyms: 160,
    description: 260,
    summary: 260,
    expr_class__attr_ss: 150,
    expr_tau__attr_f: 80,
    expr_max_tpm__attr_f: 100,
    expr_n_organs_detected__attr_i: 90,
    expr_specific_to__attr_ss: 150,
    expr_enhanced_in__attr_ss: 150,
    expr_high_in__attr_ss: 150
};
// MAKER annotation metrics: AED and the QI fractions are 0-1 (2 decimals); the
// other QIs are lengths or counts (integers).
const $8f8e530286a37ce9$var$MAKER_SET = new Set($12feb7ca48271e17$export$3ae897f4a2495276);
const $8f8e530286a37ce9$var$fmtMaker = (f, v)=>{
    if (v == null || v === '' || !Number.isFinite(+v)) return '';
    return f.endsWith('__attr_f') ? (+v).toFixed(2) : String(Math.round(+v));
};
const $8f8e530286a37ce9$var$makerShortName = (f)=>f.replace(/^MAKER__/, '').replace(/__attr_[a-z]$/, '');
// AED gets an explanation; the QIs their catalog label, e.g. "QI1: Length of the 5' UTR".
const $8f8e530286a37ce9$var$makerTooltip = (f, label)=>f === 'MAKER__AED__attr_f' ? 'MAKER Annotation Edit Distance: 0 = fully supported by evidence, 1 = no support' : label;
// Summary-statistics rows, pinned above the genes. The header row collapses the
// rest; stats cover every loaded gene, for each visible column whose values are
// all numbers (taxon_id is an identifier, not a measurement).
const $8f8e530286a37ce9$var$STAT_ROWS = [
    {
        key: 'n',
        label: 'N'
    },
    {
        key: 'min',
        label: 'Min'
    },
    {
        key: 'max',
        label: 'Max'
    },
    {
        key: 'median',
        label: 'Median'
    },
    {
        key: 'mean',
        label: 'Mean'
    },
    {
        key: 'sd',
        label: 'Std dev'
    }
];
const $8f8e530286a37ce9$var$NOT_MEASUREMENTS = new Set([
    'taxon_id'
]);
const $8f8e530286a37ce9$var$numericFieldsOf = (rows, fields)=>fields.filter((f)=>{
        if ($8f8e530286a37ce9$var$NOT_MEASUREMENTS.has(f)) return false;
        let numbers = 0;
        for (const r of rows){
            const v = r[f];
            if (v == null || v === '') continue;
            if (typeof v !== 'number' || !Number.isFinite(v)) return false;
            numbers++;
        }
        return numbers > 0;
    });
const $8f8e530286a37ce9$var$statsOf = (values)=>{
    const n = values.length;
    if (!n) return {
        n: 0
    };
    const sorted = values.slice().sort((a, b)=>a - b);
    const mean = values.reduce((a, b)=>a + b, 0) / n;
    const median = n % 2 ? sorted[(n - 1) / 2] : (sorted[n / 2 - 1] + sorted[n / 2]) / 2;
    const sd = n > 1 ? Math.sqrt(values.reduce((a, v)=>a + (v - mean) * (v - mean), 0) / (n - 1)) : null;
    return {
        n: n,
        min: sorted[0],
        max: sorted[n - 1],
        median: median,
        mean: mean,
        sd: sd
    };
};
// Mean and std dev of a whole-number column still need decimals.
const $8f8e530286a37ce9$var$fmtDecimal = (v)=>{
    if (v == null || !Number.isFinite(v)) return '';
    const a = Math.abs(v);
    return a !== 0 && (a < 0.01 || a >= 1e6) ? v.toPrecision(3) : v.toFixed(2);
};
const $8f8e530286a37ce9$var$isIntegerField = (f, rows)=>f.endsWith('__attr_i') || rows.every((r)=>r[f] == null || Number.isInteger(r[f]));
const $8f8e530286a37ce9$var$joinValues = (p)=>Array.isArray(p.value) ? p.value.map((v)=>String(v).replace(/_/g, ' ')).join(', ') : p.value ?? '';
const $8f8e530286a37ce9$var$StressChip = ({ c: c, dir: dir })=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
        style: {
            fontSize: 10,
            lineHeight: '16px',
            padding: '0 4px',
            borderRadius: 2,
            marginRight: 3,
            whiteSpace: 'nowrap',
            background: $4b8473139e48e77e$export$c6dbe9be8c8b382e[dir].bg,
            color: $4b8473139e48e77e$export$c6dbe9be8c8b382e[dir].fg
        },
        children: (dir === 'up' ? "\u2191" : "\u2193") + c
    });
// Merged ↑activated / ↓repressed renderer; the two directions are shown per the
// picker (a column exists if either field is selected).
const $8f8e530286a37ce9$var$stressRenderer = (showUp, showDown)=>({ data: data })=>{
        const up = showUp && Array.isArray(data && data[$8f8e530286a37ce9$var$STRESS_UP]) ? data[$8f8e530286a37ce9$var$STRESS_UP] : [];
        const down = showDown && Array.isArray(data && data[$8f8e530286a37ce9$var$STRESS_DOWN]) ? data[$8f8e530286a37ce9$var$STRESS_DOWN] : [];
        if (!up.length && !down.length) return null;
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
            children: [
                up.map((c, i)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($8f8e530286a37ce9$var$StressChip, {
                        c: c,
                        dir: "up"
                    }, `u${i}`)),
                down.map((c, i)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($8f8e530286a37ce9$var$StressChip, {
                        c: c,
                        dir: "down"
                    }, `d${i}`))
            ]
        });
    };
// Vertical header for the narrow organ columns, so full tissue names stay
// legible without widening the heatmap. Clicking still sorts the column, and a
// rotated sort arrow is drawn before the label (the default ag-grid sort UI is
// replaced by this custom header, so we render our own indicator). The arrow
// sits in the -90°-rotated span, so a → (asc) renders pointing up and a
// ← (desc) pointing down.
const $8f8e530286a37ce9$var$RotatedHeader = (props)=>{
    const [sort, setSort] = (0, $gXNCa$react.useState)(props.column.getSort ? props.column.getSort() : null);
    (0, $gXNCa$react.useEffect)(()=>{
        const col = props.column;
        const onSort = ()=>setSort(col.getSort ? col.getSort() : null);
        col.addEventListener('sortChanged', onSort);
        onSort();
        return ()=>col.removeEventListener('sortChanged', onSort);
    }, [
        props.column
    ]);
    const onClick = (e)=>props.progressSort && props.progressSort(e.shiftKey);
    const arrow = sort === 'asc' ? "\u2192 " : sort === 'desc' ? "\u2190 " : '';
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "attrtable-rot-header",
        title: props.displayName,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
            children: [
                arrow,
                props.displayName
            ]
        })
    });
};
const $8f8e530286a37ce9$var$AttrTableViewCmp = (props)=>{
    const { attrTable: attrTable, fieldCatalog: fieldCatalog, fieldCatalogByName: fieldCatalogByName, doToggleAttrTableField: doToggleAttrTableField, doBulkSetAttrTableFields: doBulkSetAttrTableFields, doResetAttrTableFields: doResetAttrTableFields, doAcceptGrameneSuggestion: doAcceptGrameneSuggestion } = props;
    const [showColumns, setShowColumns] = (0, $gXNCa$react.useState)(false);
    const [fieldQuery, setFieldQuery] = (0, $gXNCa$react.useState)('');
    const [popover, setPopover] = (0, $gXNCa$react.useState)(null);
    const popRef = (0, $gXNCa$react.useRef)(null);
    const [statsOpen, setStatsOpen] = (0, $gXNCa$react.useState)(true);
    const { docs: docs, total: total, truncated: truncated, status: status, error: error, visibleFields: visibleFields } = attrTable;
    const visibleSet = (0, $gXNCa$react.useMemo)(()=>new Set(visibleFields), [
        visibleFields
    ]);
    // Rows + the organ union and TPM range the heatmap needs.
    const { rows: rows, organs: organs, tpmRange: tpmRange } = (0, $gXNCa$react.useMemo)(()=>{
        const organSet = new Set();
        let tpmMin = Infinity;
        let tpmMax = -Infinity;
        const out = (docs || []).map((d)=>{
            const a = $4b8473139e48e77e$export$69fb5d19b5db1cfa(d);
            Object.keys(a.organLevels).forEach((o)=>organSet.add(o));
            if (a.maxTpm !== null) {
                if (a.maxTpm < tpmMin) tpmMin = a.maxTpm;
                if (a.maxTpm > tpmMax) tpmMax = a.maxTpm;
            }
            return {
                ...d,
                _organ: a.organLevels,
                _specific: a.specificTo,
                _enhanced: a.enhancedIn
            };
        });
        return {
            rows: out,
            organs: $4b8473139e48e77e$export$65382efdcdd96f8c(organSet),
            tpmRange: {
                min: tpmMin === Infinity ? 0 : tpmMin,
                max: tpmMax === -Infinity ? 0 : tpmMax
            }
        };
    }, [
        docs
    ]);
    // Only the groups the bundle fetches are offered (Core identifiers, Expression
    // attributes, MAKER transcript metrics); the catalog drops groups a site lacks.
    const pickerCatalog = (0, $gXNCa$react.useMemo)(()=>{
        if (!fieldCatalog || !fieldCatalog.groups) return null;
        return {
            ...fieldCatalog,
            groups: fieldCatalog.groups.filter((g)=>$12feb7ca48271e17$export$53e90de8d659db95.includes(g.id))
        };
    }, [
        fieldCatalog
    ]);
    const labelOf = (f)=>fieldCatalogByName && fieldCatalogByName[f] && fieldCatalogByName[f].label || f;
    // Columns follow the selected-field order (so the default order is honoured),
    // expanding organ_level into the heatmap block and merging the two stress
    // fields into one column.
    const columnDefs = (0, $gXNCa$react.useMemo)(()=>{
        const cols = [];
        let stressDone = false;
        visibleFields.forEach((f)=>{
            if (f === $8f8e530286a37ce9$var$ORGAN_FIELD) {
                organs.forEach((o, i)=>{
                    const last = i === organs.length - 1 ? ' attrtable-organ-last' : '';
                    cols.push({
                        // No ':' in colId — ag-grid uses colId in internal CSS selectors,
                        // where a colon is a metacharacter and silently breaks the column.
                        colId: `organ_${o}`,
                        headerName: $4b8473139e48e77e$export$50c1f966fd3af83e(o),
                        headerComponent: $8f8e530286a37ce9$var$RotatedHeader,
                        headerClass: `attrtable-organ-header${last}`,
                        cellClass: `attrtable-organ-cell${last}`,
                        headerTooltip: $4b8473139e48e77e$export$50c1f966fd3af83e(o),
                        width: 22,
                        minWidth: 18,
                        valueGetter: (p)=>p.data && p.data._organ && p.data._organ[o] || '',
                        valueFormatter: ()=>'',
                        tooltipValueGetter: (p)=>{
                            if (p.node && p.node.rowPinned) return undefined;
                            const lvl = p.data && p.data._organ && p.data._organ[o];
                            if (!lvl) return `${$4b8473139e48e77e$export$50c1f966fd3af83e(o)}: not assayed`;
                            const sp = p.data._specific.has(o) ? " \xb7 specific" : p.data._enhanced.has(o) ? " \xb7 enhanced" : '';
                            return `${$4b8473139e48e77e$export$50c1f966fd3af83e(o)}: ${$4b8473139e48e77e$export$433053e2c141d410[lvl] || lvl}${sp}`;
                        },
                        comparator: (a, b)=>($4b8473139e48e77e$export$a61929d6d484c6d4[a] ?? -1) - ($4b8473139e48e77e$export$a61929d6d484c6d4[b] ?? -1),
                        // Specific / enhanced are reported in the tooltip above rather than
                        // with an outline, so the grid reads purely as expression level.
                        cellStyle: (p)=>({
                                background: p.value ? $4b8473139e48e77e$export$b352e11f7a2ac9c5[p.value] || 'transparent' : 'transparent'
                            })
                    });
                });
                return;
            }
            if (f === $8f8e530286a37ce9$var$STRESS_UP || f === $8f8e530286a37ce9$var$STRESS_DOWN) {
                if (stressDone) return;
                stressDone = true;
                cols.push({
                    colId: $8f8e530286a37ce9$var$STRESS_COL,
                    headerName: 'Activated/Repressed by condition',
                    width: 240,
                    sortable: false,
                    valueGetter: ()=>'',
                    cellRenderer: $8f8e530286a37ce9$var$stressRenderer(visibleSet.has($8f8e530286a37ce9$var$STRESS_UP), visibleSet.has($8f8e530286a37ce9$var$STRESS_DOWN))
                });
                return;
            }
            if (f === 'expr_max_tpm__attr_f') {
                cols.push({
                    colId: f,
                    field: f,
                    headerName: labelOf(f),
                    width: $8f8e530286a37ce9$var$WIDTHS[f] || 100,
                    type: 'numericColumn',
                    valueFormatter: (p)=>$4b8473139e48e77e$export$8eaa32ef86afdd9c(p.value),
                    cellStyle: (p)=>({
                            background: $4b8473139e48e77e$export$4b443417c5259620(p.value, tpmRange)
                        })
                });
                return;
            }
            if (f === 'expr_tau__attr_f') {
                cols.push({
                    colId: f,
                    field: f,
                    headerName: labelOf(f),
                    width: $8f8e530286a37ce9$var$WIDTHS[f] || 80,
                    type: 'numericColumn',
                    valueFormatter: (p)=>Number.isFinite(p.value) ? p.value.toFixed(3) : ''
                });
                return;
            }
            if ($8f8e530286a37ce9$var$MAKER_SET.has(f)) {
                cols.push({
                    colId: f,
                    field: f,
                    headerName: labelOf(f),
                    headerTooltip: $8f8e530286a37ce9$var$makerTooltip(f, labelOf(f)),
                    width: 110,
                    type: 'numericColumn',
                    valueFormatter: (p)=>$8f8e530286a37ce9$var$fmtMaker(f, p.value)
                });
                return;
            }
            cols.push({
                colId: f,
                field: f,
                headerName: labelOf(f),
                headerTooltip: f,
                width: $8f8e530286a37ce9$var$WIDTHS[f] || 150,
                pinned: f === 'id' || f === 'name' ? 'left' : undefined,
                valueFormatter: $8f8e530286a37ce9$var$joinValues
            });
        });
        return cols;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        visibleFields,
        visibleSet,
        organs,
        tpmRange,
        fieldCatalogByName
    ]);
    // Visible columns whose values are all numbers get summary statistics.
    const numericFields = (0, $gXNCa$react.useMemo)(()=>{
        const fields = columnDefs.filter((c)=>c.field).map((c)=>c.field);
        return new Set($8f8e530286a37ce9$var$numericFieldsOf(rows, fields));
    }, [
        columnDefs,
        rows
    ]);
    const stats = (0, $gXNCa$react.useMemo)(()=>{
        const out = {};
        numericFields.forEach((f)=>{
            out[f] = $8f8e530286a37ce9$var$statsOf(rows.map((r)=>r[f]).filter((v)=>typeof v === 'number' && Number.isFinite(v)));
        });
        return out;
    }, [
        numericFields,
        rows
    ]);
    const pinnedTopRows = (0, $gXNCa$react.useMemo)(()=>{
        if (!numericFields.size || !rows.length) return [];
        const header = {
            _stat: 'header'
        };
        if (!statsOpen) return [
            header
        ];
        return [
            header,
            ...$8f8e530286a37ce9$var$STAT_ROWS.map(({ key: key, label: label })=>{
                const row = {
                    _stat: key,
                    _statLabel: label
                };
                numericFields.forEach((f)=>{
                    row[f] = stats[f][key];
                });
                return row;
            })
        ];
    }, [
        numericFields,
        stats,
        statsOpen,
        rows.length
    ]);
    // The first column carries the stats rows' labels; numeric columns show their
    // statistics, formatted like the column (N as a count, mean/sd with decimals).
    const gridColumnDefs = (0, $gXNCa$react.useMemo)(()=>columnDefs.map((col, i)=>{
            const first = i === 0;
            const numeric = !!col.field && numericFields.has(col.field);
            if (!first && !numeric) return col;
            const intField = numeric && $8f8e530286a37ce9$var$isIntegerField(col.field, rows);
            const statText = (p)=>{
                const v = p.value;
                if (v == null || v === '') return '';
                const k = p.data._stat;
                if (k === 'n') return Number(v).toLocaleString();
                if (k === 'mean' || k === 'sd' || k === 'median' && intField && !Number.isInteger(v)) return col.field === 'expr_max_tpm__attr_f' ? $4b8473139e48e77e$export$8eaa32ef86afdd9c(v) : $8f8e530286a37ce9$var$fmtDecimal(v);
                return col.valueFormatter ? col.valueFormatter({
                    ...p,
                    value: v
                }) : String(v);
            };
            return {
                ...col,
                valueFormatter: (p)=>{
                    if (!(p.node && p.node.rowPinned)) return col.valueFormatter ? col.valueFormatter(p) : p.value;
                    return numeric ? statText(p) : '';
                },
                cellStyle: (p)=>p.node && p.node.rowPinned ? null : typeof col.cellStyle === 'function' ? col.cellStyle(p) : col.cellStyle,
                cellRenderer: (p)=>{
                    if (p.node && p.node.rowPinned) {
                        const k = p.data._stat;
                        if (first && k === 'header') return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                            className: "attrtable-stats-toggle",
                            title: statsOpen ? 'Hide summary statistics' : 'Show summary statistics',
                            children: [
                                statsOpen ? "\u25BE" : "\u25B8",
                                " Summary statistics (",
                                rows.length.toLocaleString(),
                                " genes)"
                            ]
                        });
                        if (first) {
                            const value = numeric ? statText(p) : '';
                            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                                className: "attrtable-stats-label",
                                children: [
                                    p.data._statLabel,
                                    value ? `: ${value}` : ''
                                ]
                            });
                        }
                        return k === 'header' ? '' : p.valueFormatted;
                    }
                    return col.cellRenderer ? $parcel$interopDefault($gXNCa$react).createElement(col.cellRenderer, p) : p.valueFormatted ?? p.value;
                }
            };
        }), [
        columnDefs,
        numericFields,
        rows,
        statsOpen
    ]);
    // Build the click-popover for a cell: a title (the column meaning) and one
    // filterable item per value. Each item carries the fq_field / fq_value the
    // "add filter" button hands to doAcceptGrameneSuggestion.
    const buildCellPopover = (colId, data)=>{
        if (!data) return null;
        const mk = (text, fqField, fqValue, category, name)=>({
                text: text,
                fqField: fqField,
                fqValue: fqValue,
                category: category,
                name: name || text
            });
        if (colId === 'id') return {
            title: 'Gene ID',
            items: [
                mk(data.id, 'id', data.id, 'Gene', data.id)
            ]
        };
        if (colId === $8f8e530286a37ce9$var$STRESS_COL) {
            const items = [];
            (data[$8f8e530286a37ce9$var$STRESS_UP] || []).forEach((c)=>items.push(mk("\u2191 " + c, $8f8e530286a37ce9$var$STRESS_UP, c, 'Activated by', 'activated by ' + c)));
            (data[$8f8e530286a37ce9$var$STRESS_DOWN] || []).forEach((c)=>items.push(mk("\u2193 " + c, $8f8e530286a37ce9$var$STRESS_DOWN, c, 'Repressed by', 'repressed by ' + c)));
            return {
                title: 'Activated/Repressed by condition',
                items: items
            };
        }
        if (colId.startsWith('organ_')) {
            const organ = colId.slice(6);
            const lvl = data._organ && data._organ[organ];
            if (!lvl) return {
                title: 'Expression level by organ',
                items: []
            };
            const label = `${$4b8473139e48e77e$export$50c1f966fd3af83e(organ)}: ${$4b8473139e48e77e$export$433053e2c141d410[lvl] || lvl}`;
            return {
                title: 'Expression level by organ',
                items: [
                    mk(label, $8f8e530286a37ce9$var$ORGAN_FIELD, `${organ}:${lvl}`, 'Expression', label)
                ]
            };
        }
        if (colId === 'expr_max_tpm__attr_f') {
            const v = data.expr_max_tpm__attr_f;
            if (!Number.isFinite(+v)) return {
                title: labelOf(colId),
                items: []
            };
            return {
                title: labelOf(colId),
                items: [
                    mk(`\u{2265} ${$4b8473139e48e77e$export$8eaa32ef86afdd9c(+v)} TPM`, colId, `[${v} TO *]`, 'Max TPM', `Max TPM \u{2265} ${$4b8473139e48e77e$export$8eaa32ef86afdd9c(+v)}`)
                ]
            };
        }
        if (colId === 'expr_tau__attr_f') {
            const v = data.expr_tau__attr_f;
            if (!Number.isFinite(+v)) return {
                title: labelOf(colId),
                items: []
            };
            return {
                title: labelOf(colId),
                items: [
                    mk(`\u{2265} ${(+v).toFixed(3)}`, colId, `[${v} TO *]`, 'Tau', `tau \u{2265} ${(+v).toFixed(3)}`)
                ]
            };
        }
        if ($8f8e530286a37ce9$var$MAKER_SET.has(colId)) {
            // AED: lower is better supported, so offer "at most"; the QI metrics "at least".
            const v = data[colId];
            if (!Number.isFinite(+v)) return {
                title: labelOf(colId),
                items: []
            };
            const shown = $8f8e530286a37ce9$var$fmtMaker(colId, +v);
            const short = $8f8e530286a37ce9$var$makerShortName(colId);
            return colId === 'MAKER__AED__attr_f' ? {
                title: labelOf(colId),
                items: [
                    mk(`\u{2264} ${shown}`, colId, `[* TO ${v}]`, 'MAKER', `${short} \u{2264} ${shown}`)
                ]
            } : {
                title: labelOf(colId),
                items: [
                    mk(`\u{2265} ${shown}`, colId, `[${v} TO *]`, 'MAKER', `${short} \u{2265} ${shown}`)
                ]
            };
        }
        // Generic (Expression class, and any core / added attribute).
        const label = labelOf(colId);
        const raw = data[colId];
        const vals = Array.isArray(raw) ? raw : raw != null && raw !== '' ? [
            raw
        ] : [];
        return {
            title: label,
            items: vals.map((v)=>mk(String(v).replace(/_/g, ' '), colId, v, label, String(v).replace(/_/g, ' ')))
        };
    };
    const onCellClicked = (e)=>{
        if (e.node && e.node.rowPinned) {
            if (e.data && e.data._stat === 'header') setStatsOpen((v)=>!v);
            setPopover(null);
            return;
        }
        const desc = buildCellPopover(e.column.getColId(), e.data);
        if (!desc || !desc.items.length) {
            setPopover(null);
            return;
        }
        const ev = e.event || {};
        setPopover({
            x: ev.clientX || 0,
            y: ev.clientY || 0,
            title: desc.title,
            items: desc.items
        });
    };
    const addFilter = (it)=>{
        doAcceptGrameneSuggestion({
            fq_field: it.fqField,
            fq_value: it.fqValue,
            name: it.name,
            category: it.category
        });
        setPopover(null);
    };
    // Close the popover on outside-click or Escape. Registered after the opening
    // click, so that click can't immediately dismiss it.
    (0, $gXNCa$react.useEffect)(()=>{
        if (!popover) return;
        const onDown = (e)=>{
            if (popRef.current && !popRef.current.contains(e.target)) setPopover(null);
        };
        const onKey = (e)=>{
            if (e.key === 'Escape') setPopover(null);
        };
        document.addEventListener('mousedown', onDown, true);
        document.addEventListener('keydown', onKey);
        return ()=>{
            document.removeEventListener('mousedown', onDown, true);
            document.removeEventListener('keydown', onKey);
        };
    }, [
        popover
    ]);
    const shown = rows.length;
    const loading = status === 'loading';
    const organShown = visibleSet.has($8f8e530286a37ce9$var$ORGAN_FIELD);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "attrtable-view",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "attrtable-toolbar",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                        className: "attrtable-status",
                        children: [
                            loading && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Spinner, {
                                animation: "border",
                                size: "sm",
                                className: "mr-2"
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("strong", {
                                children: shown.toLocaleString()
                            }),
                            " gene",
                            shown === 1 ? '' : 's',
                            total > 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
                                children: [
                                    " of ",
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("strong", {
                                        children: total.toLocaleString()
                                    })
                                ]
                            }),
                            loading && " \u2014 loading\u2026"
                        ]
                    }),
                    organShown && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        className: "attrtable-legend",
                        title: "expression level",
                        children: $4b8473139e48e77e$export$4bb936dc8856d37a.map((lv)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                title: $4b8473139e48e77e$export$433053e2c141d410[lv],
                                style: {
                                    background: $4b8473139e48e77e$export$b352e11f7a2ac9c5[lv]
                                }
                            }, lv))
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Button, {
                        size: "sm",
                        variant: showColumns ? 'primary' : 'outline-secondary',
                        onClick: ()=>setShowColumns((v)=>!v),
                        children: [
                            "Columns (",
                            columnDefs.length,
                            ")"
                        ]
                    })
                ]
            }),
            truncated && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Alert, {
                variant: "info",
                className: "attrtable-notice",
                children: [
                    "Showing the first ",
                    $8f8e530286a37ce9$var$MAX_GENES.toLocaleString(),
                    " of ",
                    total.toLocaleString(),
                    " genes. Narrow your search to see the rest."
                ]
            }),
            error && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Alert, {
                variant: "danger",
                className: "attrtable-notice",
                children: [
                    "Failed to load genes: ",
                    error
                ]
            }),
            showColumns && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "attrtable-columns-panel",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                        className: "attrtable-columns-head",
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
                                type: "search",
                                className: "form-control form-control-sm attrtable-field-search",
                                placeholder: "Search fields\u2026",
                                value: fieldQuery,
                                onChange: (e)=>setFieldQuery(e.target.value)
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                                size: "sm",
                                variant: "link",
                                onClick: doResetAttrTableFields,
                                children: "Reset"
                            })
                        ]
                    }),
                    pickerCatalog ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($08e62a9eec4f328f$export$8af8343a8541cf1f, {
                        catalog: pickerCatalog,
                        selectedFields: visibleFields,
                        onToggle: doToggleAttrTableField,
                        onBulkSet: doBulkSetAttrTableFields,
                        query: fieldQuery
                    }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        className: "exporter-panel-empty",
                        children: "Loading field catalog\u2026"
                    })
                ]
            }),
            rows.length === 0 && !loading ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "attrtable-empty",
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("em", {
                    children: "No genes to show."
                })
            }) : columnDefs.length === 0 ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "attrtable-empty",
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("em", {
                    children: "No columns selected \u2014 pick some under \u201CColumns\u201D."
                })
            }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: `ag-theme-quartz attrtable-aggrid${organShown ? ' attrtable-tall-header' : ''}`,
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$aggridreact.AgGridReact, {
                    rowData: rows,
                    columnDefs: gridColumnDefs,
                    pinnedTopRowData: pinnedTopRows,
                    getRowClass: (p)=>p.node.rowPinned ? p.data._stat === 'header' ? 'attrtable-stats-header' : 'attrtable-stats-row' : undefined,
                    defaultColDef: $8f8e530286a37ce9$var$DEFAULT_COL_DEF,
                    animateRows: false,
                    suppressFieldDotNotation: true,
                    suppressDragLeaveHidesColumns: true,
                    tooltipShowDelay: 300,
                    rowHeight: 22,
                    headerHeight: organShown ? 92 : 28,
                    onCellClicked: onCellClicked
                })
            }),
            popover && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                ref: popRef,
                className: "attrtable-popover",
                style: {
                    left: Math.min(popover.x, window.innerWidth - 280),
                    top: Math.min(popover.y, window.innerHeight - 32 - popover.items.length * 30)
                },
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        className: "attrtable-popover-title",
                        children: popover.title
                    }),
                    popover.items.map((it, i)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                            className: "attrtable-popover-row",
                            children: [
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                    className: "attrtable-popover-val",
                                    children: it.text
                                }),
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                                    type: "button",
                                    className: "btn btn-sm btn-outline-primary attrtable-popover-btn",
                                    onClick: ()=>addFilter(it),
                                    children: "add filter"
                                })
                            ]
                        }, i))
                ]
            })
        ]
    });
};
var $8f8e530286a37ce9$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)('selectAttrTable', 'selectFieldCatalog', 'selectFieldCatalogByName', 'doToggleAttrTableField', 'doBulkSetAttrTableFields', 'doResetAttrTableFields', 'doAcceptGrameneSuggestion', $8f8e530286a37ce9$var$AttrTableViewCmp);
function $597fe213417ee6ca$var$speciesTaxonId(tid) {
    const n = +tid;
    return n > 1000000 ? Math.floor(n / 1000) : n;
}
function $597fe213417ee6ca$var$genomeName(grameneMaps, tid) {
    if (!grameneMaps) return String(tid);
    const direct = grameneMaps[tid];
    if (direct && direct.display_name) return direct.display_name;
    const sp = grameneMaps[$597fe213417ee6ca$var$speciesTaxonId(tid)];
    if (sp && sp.display_name) return sp.display_name;
    return String(tid);
}
function $597fe213417ee6ca$var$fmtP(p) {
    if (p == null) return '';
    if (p === 0) return '0';
    if (p < 1e-4) return p.toExponential(2);
    return p.toPrecision(3);
}
function $597fe213417ee6ca$var$fmtFold(f) {
    if (!isFinite(f)) return '';
    if (f >= 100) return f.toFixed(0);
    return f.toFixed(2);
}
// ---------- species tree helpers ----------
function $597fe213417ee6ca$var$findRoots(tax) {
    return Object.values(tax).filter((n)=>!n.is_a || n.is_a.length === 0 || !n.is_a.some((p)=>tax[p]));
}
// Place each facet tid onto a taxonomy node id (fall back to species level
// when the exact subspecies tid isn't in grameneTaxonomy).
function $597fe213417ee6ca$var$placeTaxa(taxonomy, taxa) {
    const placement = {};
    const byPlace = {};
    for (const { tid: tid, count: count } of taxa){
        const place = taxonomy[tid] ? +tid : $597fe213417ee6ca$var$speciesTaxonId(tid);
        placement[tid] = place;
        if (!byPlace[place]) byPlace[place] = [];
        byPlace[place].push({
            tid: tid,
            count: count
        });
    }
    return {
        placement: placement,
        byPlace: byPlace
    };
}
// Set of taxonomy node ids on the path from any placed leaf back to its root.
function $597fe213417ee6ca$var$relevantNodeIds(taxonomy, byPlace) {
    const out = new Set();
    for (const placeId of Object.keys(byPlace)){
        let cur = taxonomy[placeId];
        const seen = new Set();
        while(cur && !seen.has(+cur._id)){
            seen.add(+cur._id);
            out.add(+cur._id);
            const pid = cur.is_a && cur.is_a[0];
            cur = pid ? taxonomy[pid] : null;
        }
    }
    return out;
}
function $597fe213417ee6ca$var$relevantChildren(node, taxonomy, relevant) {
    return (node.children || []).map((cid)=>taxonomy[cid]).filter((c)=>c && relevant.has(+c._id));
}
// Walk down through single-relevant-child internal nodes to a branch / leaf.
function $597fe213417ee6ca$var$compressChain(node, taxonomy, relevant, byPlace) {
    const chain = [
        node
    ];
    let cur = node;
    while(true){
        if (byPlace[cur._id]) break; // node itself is a placed leaf
        const kids = $597fe213417ee6ca$var$relevantChildren(cur, taxonomy, relevant);
        if (kids.length !== 1) break;
        cur = kids[0];
        chain.push(cur);
    }
    return {
        chain: chain,
        terminal: cur
    };
}
const $597fe213417ee6ca$var$CHAIN_DISPLAY_MAX = 3;
function $597fe213417ee6ca$var$renderChain(chain) {
    const nameOf = (n)=>n.short_name || n.name || String(n._id);
    if (chain.length <= $597fe213417ee6ca$var$CHAIN_DISPLAY_MAX) return chain.map((n, i)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($parcel$interopDefault($gXNCa$react).Fragment, {
            children: [
                i > 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    className: "tax-sep",
                    children: " \u203A "
                }),
                nameOf(n)
            ]
        }, n._id));
    const first = chain[0];
    const last = chain[chain.length - 1];
    const middle = chain.slice(1, -1);
    const fullTitle = chain.map(nameOf).join(" \u203A ");
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
        children: [
            nameOf(first),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                className: "tax-sep",
                children: " \u203A "
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                className: "tax-ellipsis",
                title: fullTitle,
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        className: "tax-ellipsis-short",
                        children: "\u2026"
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        className: "tax-ellipsis-full",
                        children: middle.map((n)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($parcel$interopDefault($gXNCa$react).Fragment, {
                                children: [
                                    nameOf(n),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                        className: "tax-sep",
                                        children: " \u203A "
                                    })
                                ]
                            }, n._id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                className: "tax-sep",
                children: " \u203A "
            }),
            nameOf(last)
        ]
    });
}
function $597fe213417ee6ca$var$dedupAdjacent(chain) {
    const out = [];
    for (const n of chain)if (out.length && out[out.length - 1].name === n.name) out[out.length - 1] = n;
    else out.push(n);
    return out;
}
const $597fe213417ee6ca$var$SpeciesTreeNode = ({ node: node, depth: depth, taxonomy: taxonomy, relevant: relevant, byPlace: byPlace, grameneMaps: grameneMaps, expanded: expanded, onToggleExpand: onToggleExpand, activeTaxon: activeTaxon, onSelect: onSelect })=>{
    const { chain: rawChain, terminal: terminal } = $597fe213417ee6ca$var$compressChain(node, taxonomy, relevant, byPlace);
    const chain = $597fe213417ee6ca$var$dedupAdjacent(rawChain);
    const placed = byPlace[terminal._id] || [];
    const kids = $597fe213417ee6ca$var$relevantChildren(terminal, taxonomy, relevant);
    const hasKids = kids.length > 0;
    const isOpen = expanded.has(+terminal._id);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "tax-node oe-tree-node",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "tax-row",
                style: {
                    paddingLeft: depth * 7
                },
                children: [
                    hasKids ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        className: "tax-chevron",
                        onClick: ()=>onToggleExpand(+terminal._id),
                        children: isOpen ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsbs.BsChevronDown, {}) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsbs.BsChevronRight, {})
                    }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        className: "tax-chevron-spacer"
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        className: hasKids ? 'tax-label tax-label-internal' : 'tax-label',
                        children: $597fe213417ee6ca$var$renderChain(chain)
                    })
                ]
            }),
            placed.map(({ tid: tid, count: count })=>{
                const isActive = String(activeTaxon) === String(tid);
                return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                    className: 'oe-tree-leaf' + (isActive ? ' oe-tree-leaf-active' : ''),
                    style: {
                        paddingLeft: (depth + 1) * 7 + 18
                    },
                    onClick: ()=>onSelect(tid),
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
                            type: "radio",
                            readOnly: true,
                            checked: isActive,
                            onChange: ()=>onSelect(tid)
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                            className: "oe-tree-leaf-name",
                            children: $597fe213417ee6ca$var$genomeName(grameneMaps, tid)
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                            className: "oe-tree-leaf-count",
                            children: count.toLocaleString()
                        })
                    ]
                }, tid);
            }),
            hasKids && isOpen && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "tax-children",
                children: kids.map((c)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($597fe213417ee6ca$var$SpeciesTreeNode, {
                        node: c,
                        depth: depth + 1,
                        taxonomy: taxonomy,
                        relevant: relevant,
                        byPlace: byPlace,
                        grameneMaps: grameneMaps,
                        expanded: expanded,
                        onToggleExpand: onToggleExpand,
                        activeTaxon: activeTaxon,
                        onSelect: onSelect
                    }, c._id))
            })
        ]
    });
};
const $597fe213417ee6ca$var$SpeciesTree = ({ taxonomy: taxonomy, grameneMaps: grameneMaps, taxa: taxa, activeTaxon: activeTaxon, onSelect: onSelect })=>{
    const { placement: placement, byPlace: byPlace } = (0, $gXNCa$react.useMemo)(()=>$597fe213417ee6ca$var$placeTaxa(taxonomy, taxa), [
        taxonomy,
        taxa
    ]);
    const relevant = (0, $gXNCa$react.useMemo)(()=>$597fe213417ee6ca$var$relevantNodeIds(taxonomy, byPlace), [
        taxonomy,
        byPlace
    ]);
    const roots = (0, $gXNCa$react.useMemo)(()=>$597fe213417ee6ca$var$findRoots(taxonomy).filter((r)=>relevant.has(+r._id)), [
        taxonomy,
        relevant
    ]);
    // Default: every relevant internal node expanded so the user sees the
    // full pruned tree on first paint.
    const [expanded, setExpanded] = (0, $gXNCa$react.useState)(()=>new Set(relevant));
    (0, $gXNCa$react.useEffect)(()=>{
        setExpanded(new Set(relevant));
    }, [
        relevant
    ]);
    const handleToggle = (id)=>{
        setExpanded((prev)=>{
            const next = new Set(prev);
            next.has(id) ? next.delete(id) : next.add(id);
            return next;
        });
    };
    // Skip the root spine: if a root has only one relevant child and isn't
    // itself a placed leaf, render from its child instead.
    const topLevel = [];
    for (const r of roots){
        const { terminal: terminal } = $597fe213417ee6ca$var$compressChain(r, taxonomy, relevant, byPlace);
        if (byPlace[terminal._id]) topLevel.push(r);
        else {
            const kids = $597fe213417ee6ca$var$relevantChildren(terminal, taxonomy, relevant);
            kids.forEach((k)=>topLevel.push(k));
        }
    }
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "oe-tree",
        children: topLevel.map((n)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($597fe213417ee6ca$var$SpeciesTreeNode, {
                node: n,
                depth: 0,
                taxonomy: taxonomy,
                relevant: relevant,
                byPlace: byPlace,
                grameneMaps: grameneMaps,
                expanded: expanded,
                onToggleExpand: handleToggle,
                activeTaxon: activeTaxon,
                onSelect: onSelect
            }, n._id))
    });
};
// ---------- enrichment panel ----------
const $597fe213417ee6ca$var$HelpIcon = ({ text: text })=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.OverlayTrigger, {
        placement: "top",
        overlay: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Tooltip, {
            children: text
        }),
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
            className: "oe-help",
            tabIndex: 0,
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsbs.BsInfoCircle, {})
        })
    });
const $597fe213417ee6ca$var$LabeledHelp = ({ label: label, help: help })=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Form.Label, {
        children: [
            label,
            " ",
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($597fe213417ee6ca$var$HelpIcon, {
                text: help
            })
        ]
    });
const $597fe213417ee6ca$var$ControlsBar = ({ ui: ui, onChange: onChange })=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "oe-controls",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Form.Group, {
                className: "oe-control",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($597fe213417ee6ca$var$LabeledHelp, {
                        label: "p.adjust \u2264",
                        help: "Adjusted p-value cutoff (Benjamini\u2013Hochberg). Terms with p.adjust above this are not reported as significant."
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Form.Control, {
                        type: "number",
                        step: "0.01",
                        min: "0",
                        max: "1",
                        value: ui.pAdjCutoff,
                        onChange: (e)=>onChange({
                                pAdjCutoff: +e.target.value
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Form.Group, {
                className: "oe-control",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($597fe213417ee6ca$var$LabeledHelp, {
                        label: "minGSSize",
                        help: "Minimum gene set size: a term must have at least this many annotated genes in the universe to be tested. Filters out terms too small to give reliable enrichment statistics. clusterProfiler default: 10."
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Form.Control, {
                        type: "number",
                        step: "1",
                        min: "1",
                        value: ui.minGSSize,
                        onChange: (e)=>onChange({
                                minGSSize: Math.max(1, +e.target.value)
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Form.Group, {
                className: "oe-control",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($597fe213417ee6ca$var$LabeledHelp, {
                        label: "maxGSSize",
                        help: "Maximum gene set size: terms with more than this many annotated genes are excluded. Drops the very general top-level terms (e.g. GO root) which carry little biological signal. clusterProfiler default: 500."
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Form.Control, {
                        type: "number",
                        step: "1",
                        min: "1",
                        value: ui.maxGSSize,
                        onChange: (e)=>onChange({
                                maxGSSize: Math.max(1, +e.target.value)
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "oe-control oe-switch",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Form.Check, {
                        type: "switch",
                        id: "oe-most-specific",
                        label: "Drop ancestor terms",
                        checked: !!ui.mostSpecific,
                        onChange: (e)=>onChange({
                                mostSpecific: e.target.checked
                            })
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($597fe213417ee6ca$var$HelpIcon, {
                        text: "If a passing term has a more specific descendant that also passes, hide the ancestor \u2014 keeps only the most-specific significant term in each branch. Applied after BH correction. Analogous to clusterProfiler's simplify() (off by default in enrichGO)."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Form.Group, {
                className: "oe-control oe-control-grow",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($597fe213417ee6ca$var$LabeledHelp, {
                        label: "Filter terms",
                        help: "Live text filter on the result table \u2014 matches term ID or name."
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Form.Control, {
                        type: "text",
                        placeholder: "term id or name\u2026",
                        value: ui.search || '',
                        onChange: (e)=>onChange({
                                search: e.target.value
                            })
                    })
                ]
            })
        ]
    });
const $597fe213417ee6ca$var$TermRow = ({ row: row, showType: showType, onAddFilter: onAddFilter })=>{
    const handleClick = ()=>onAddFilter && onAddFilter(row);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("tr", {
        onClick: handleClick,
        title: "Click to add as a filter",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                className: "oe-term-id",
                children: row.term_display_id
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                className: "oe-term-name",
                children: row.term_name || /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("em", {
                    children: "(loading\u2026)"
                })
            }),
            showType && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                className: "oe-term-type",
                children: row.term_namespace || ''
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                className: "oe-num",
                children: row.GeneRatio
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                className: "oe-num",
                children: row.BgRatio
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                className: "oe-num",
                children: $597fe213417ee6ca$var$fmtFold(row.FoldEnrichment)
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                className: "oe-num",
                children: $597fe213417ee6ca$var$fmtP(row.pvalue)
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("td", {
                className: "oe-num",
                children: $597fe213417ee6ca$var$fmtP(row.pAdjust)
            })
        ]
    });
};
// InterPro entry types and pathway types are useful per-row context
// (e.g. Domain vs Family vs Repeat for InterPro), and aren't reflected in
// the section title the way GO namespaces are. Show a Type column for
// those two ontologies only.
const $597fe213417ee6ca$var$ONTS_WITH_TYPE_COLUMN = new Set([
    'domains',
    'pathways'
]);
const $597fe213417ee6ca$var$SORT_ACCESSORS = {
    term: (r)=>r.term_display_id || '',
    name: (r)=>(r.term_name || '').toLowerCase(),
    type: (r)=>(r.term_namespace || '').toLowerCase(),
    count: (r)=>r.Count,
    setSize: (r)=>r.SetSize,
    fold: (r)=>r.FoldEnrichment,
    p: (r)=>r.pvalue,
    pAdj: (r)=>r.pAdjust
};
// Defaults chosen so a single click does what the user usually wants:
// numeric "more interesting" columns descend; p-values and text columns ascend.
const $597fe213417ee6ca$var$SORT_DEFAULT_DIR = {
    term: 'asc',
    name: 'asc',
    type: 'asc',
    count: 'desc',
    setSize: 'desc',
    fold: 'desc',
    p: 'asc',
    pAdj: 'asc'
};
const $597fe213417ee6ca$var$SortableTh = ({ label: label, sortKey: sortKey, activeKey: activeKey, activeDir: activeDir, onSort: onSort, numeric: numeric, help: help })=>{
    const active = activeKey === sortKey;
    const arrow = active ? activeDir === 'asc' ? " \u25B2" : " \u25BC" : '';
    const cls = 'oe-sort-th' + (active ? ' oe-sort-th-active' : '') + (numeric ? ' oe-num' : '');
    const inner = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
        className: "oe-th-inner",
        children: [
            label,
            arrow
        ]
    });
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("th", {
        className: cls,
        onClick: ()=>onSort(sortKey),
        children: help ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.OverlayTrigger, {
            placement: "top",
            overlay: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Tooltip, {
                children: help
            }),
            children: inner
        }) : inner
    });
};
const $597fe213417ee6ca$var$OntologySection = ({ block: block, search: search, sort: sort, onSortChange: onSortChange, onAddFilter: onAddFilter })=>{
    const filtered = (0, $gXNCa$react.useMemo)(()=>{
        if (!search) return block.rows;
        const needle = search.toLowerCase();
        return block.rows.filter((r)=>r.term_display_id && r.term_display_id.toLowerCase().includes(needle) || r.term_name && r.term_name.toLowerCase().includes(needle));
    }, [
        block.rows,
        search
    ]);
    const showType = $597fe213417ee6ca$var$ONTS_WITH_TYPE_COLUMN.has(block.ontology);
    // Sort state is persisted per section in the bundle ui so a saved view
    // restores it. Defaults match the historical local-state initials.
    const sortKey = sort && sort.key || 'pAdj';
    const sortDir = sort && sort.dir || 'asc';
    const handleSort = (key)=>{
        if (key === sortKey) onSortChange(block.ontology, sortKey, sortDir === 'asc' ? 'desc' : 'asc');
        else onSortChange(block.ontology, key, $597fe213417ee6ca$var$SORT_DEFAULT_DIR[key] || 'asc');
    };
    const sorted = (0, $gXNCa$react.useMemo)(()=>{
        const accessor = $597fe213417ee6ca$var$SORT_ACCESSORS[sortKey];
        if (!accessor) return filtered;
        const sign = sortDir === 'desc' ? -1 : 1;
        const arr = filtered.slice();
        arr.sort((a, b)=>{
            const va = accessor(a);
            const vb = accessor(b);
            if (typeof va === 'number' && typeof vb === 'number') {
                if (va === vb) return 0;
                return (va - vb) * sign;
            }
            return String(va).localeCompare(String(vb)) * sign;
        });
        return arr;
    }, [
        filtered,
        sortKey,
        sortDir
    ]);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Accordion.Item, {
        eventKey: block.ontology,
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Accordion.Header, {
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        className: "oe-ont-title",
                        children: block.label
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Badge, {
                        bg: "secondary",
                        className: "oe-ont-badge",
                        children: [
                            block.passing,
                            " significant / ",
                            block.tested,
                            " tested"
                        ]
                    }),
                    block.universeSize > 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Badge, {
                        bg: "light",
                        text: "dark",
                        className: "oe-ont-badge",
                        children: [
                            "input ",
                            block.deSize,
                            " / universe ",
                            block.universeSize.toLocaleString()
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Accordion.Body, {
                children: sorted.length === 0 ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("em", {
                    children: "No terms pass the current cutoffs."
                }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("table", {
                    className: "oe-table",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($597fe213417ee6ca$var$SortableTh, {
                                        label: "Term",
                                        sortKey: "term",
                                        activeKey: sortKey,
                                        activeDir: sortDir,
                                        onSort: handleSort,
                                        help: "Ontology term identifier (e.g. GO:0008150). Click a row to add the term as a filter."
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($597fe213417ee6ca$var$SortableTh, {
                                        label: "Description",
                                        sortKey: "name",
                                        activeKey: sortKey,
                                        activeDir: sortDir,
                                        onSort: handleSort,
                                        help: "Human-readable name of the term."
                                    }),
                                    showType && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($597fe213417ee6ca$var$SortableTh, {
                                        label: "Type",
                                        sortKey: "type",
                                        activeKey: sortKey,
                                        activeDir: sortDir,
                                        onSort: handleSort,
                                        help: "Sub-classification within the ontology (e.g. Domain / Family / Repeat for InterPro)."
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($597fe213417ee6ca$var$SortableTh, {
                                        label: "GeneRatio",
                                        sortKey: "count",
                                        activeKey: sortKey,
                                        activeDir: sortDir,
                                        onSort: handleSort,
                                        numeric: true,
                                        help: "Count / DESize: how many of the input genes are annotated to this term, over the total input genes that have any annotation in this ontology."
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($597fe213417ee6ca$var$SortableTh, {
                                        label: "BgRatio",
                                        sortKey: "setSize",
                                        activeKey: sortKey,
                                        activeDir: sortDir,
                                        onSort: handleSort,
                                        numeric: true,
                                        help: "SetSize / UniverseSize: how many genes in the species are annotated to this term, over the total genes annotated anywhere in this ontology (the universe)."
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($597fe213417ee6ca$var$SortableTh, {
                                        label: "FoldEnrichment",
                                        sortKey: "fold",
                                        activeKey: sortKey,
                                        activeDir: sortDir,
                                        onSort: handleSort,
                                        numeric: true,
                                        help: "(Count/DESize) / (SetSize/UniverseSize). Ratio of observed to expected overlap. Values > 1 mean the term is over-represented in the input."
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($597fe213417ee6ca$var$SortableTh, {
                                        label: "pvalue",
                                        sortKey: "p",
                                        activeKey: sortKey,
                                        activeDir: sortDir,
                                        onSort: handleSort,
                                        numeric: true,
                                        help: "Raw upper-tail hypergeometric p-value: P(overlap \u2265 observed) under the null that the input is a random sample from the universe."
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($597fe213417ee6ca$var$SortableTh, {
                                        label: "p.adjust",
                                        sortKey: "pAdj",
                                        activeKey: sortKey,
                                        activeDir: sortDir,
                                        onSort: handleSort,
                                        numeric: true,
                                        help: "Benjamini\u2013Hochberg adjusted p-value, computed across all terms tested in this ontology section. Use this (not the raw p-value) for significance."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("tbody", {
                            children: sorted.map((r)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($597fe213417ee6ca$var$TermRow, {
                                    row: r,
                                    showType: showType,
                                    onAddFilter: onAddFilter
                                }, `${r.ontology}:${r.term_id}`))
                        })
                    ]
                })
            })
        ]
    });
};
const $597fe213417ee6ca$var$TaxonPanel = ({ taxon: taxon, ontologyEnrichment: ontologyEnrichment, results: results, ui: ui, onUiChange: onUiChange, onAddFilter: onAddFilter })=>{
    if (!taxon) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "oe-panel",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("em", {
            children: "Select a species on the left."
        })
    });
    const t = ontologyEnrichment.byTaxon[taxon];
    if (!t) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "oe-panel",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("em", {
            children: "Initializing\u2026"
        })
    });
    if (t.fg.status === 'loading' || t.bg.status === 'loading' || t.fg.status === 'idle' || t.bg.status === 'idle') return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "oe-panel oe-loading",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("em", {
            children: "Loading enrichment\u2026"
        })
    });
    if (t.fg.status === 'error') return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "oe-panel",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("em", {
            children: [
                "Foreground error: ",
                t.fg.error
            ]
        })
    });
    if (t.bg.status === 'error') return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "oe-panel",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("em", {
            children: [
                "Background error: ",
                t.bg.error
            ]
        })
    });
    if (!results) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "oe-panel",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("em", {
            children: "No data."
        })
    });
    const allBlocks = ui.ontology === 'all' ? Object.values(results) : results[ui.ontology] ? [
        results[ui.ontology]
    ] : [];
    // Hide ontologies that aren't used in this species at all.
    const blocks = allBlocks.filter((b)=>b.tested > 0);
    const handleSortChange = (sectionKey, key, dir)=>{
        onUiChange({
            sort: {
                ...ui.sort || {},
                [sectionKey]: {
                    key: key,
                    dir: dir
                }
            }
        });
    };
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "oe-panel",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "oe-summary",
                children: [
                    "Foreground: ",
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                        children: t.fg.numFound.toLocaleString()
                    }),
                    " genes \xb7 Background: ",
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                        children: t.bg.numFound.toLocaleString()
                    }),
                    " genes"
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($597fe213417ee6ca$var$ControlsBar, {
                ui: ui,
                onChange: onUiChange
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Accordion, {
                alwaysOpen: true,
                defaultActiveKey: blocks.length === 1 ? blocks[0].ontology : undefined,
                children: blocks.map((b)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($597fe213417ee6ca$var$OntologySection, {
                        block: b,
                        search: ui.search,
                        sort: ui.sort && ui.sort[b.ontology],
                        onSortChange: handleSortChange,
                        onAddFilter: onAddFilter
                    }, b.ontology))
            })
        ]
    });
};
const $597fe213417ee6ca$var$OntologyEnrichmentViewCmp = (props)=>{
    const { grameneSearch: grameneSearch, grameneMaps: grameneMaps, grameneTaxonomy: grameneTaxonomy, ontologyEnrichment: ontologyEnrichment, ontologyEnrichmentUI: ui, ontologyEnrichmentResults: results, doSetOntologyEnrichmentActiveTaxon: doSetOntologyEnrichmentActiveTaxon, doSetOntologyEnrichmentUI: doSetOntologyEnrichmentUI, doFetchOntologyEnrichmentForeground: doFetchOntologyEnrichmentForeground, doFetchOntologyEnrichmentBackground: doFetchOntologyEnrichmentBackground, doAcceptGrameneSuggestion: doAcceptGrameneSuggestion } = props;
    const taxa = (0, $gXNCa$react.useMemo)(()=>{
        if (!grameneSearch || !grameneSearch.facet_counts) return [];
        const arr = grameneSearch.facet_counts.facet_fields.taxon_id || [];
        const ids = [];
        const counts = {};
        for(let i = 0; i < arr.length; i += 2){
            ids.push(arr[i]);
            counts[arr[i]] = +arr[i + 1];
        }
        if (grameneMaps) ids.sort((a, b)=>{
            const ma = grameneMaps[a] || grameneMaps[$597fe213417ee6ca$var$speciesTaxonId(a)];
            const mb = grameneMaps[b] || grameneMaps[$597fe213417ee6ca$var$speciesTaxonId(b)];
            return (ma && ma.left_index || 0) - (mb && mb.left_index || 0);
        });
        return ids.map((tid)=>({
                tid: tid,
                count: counts[tid]
            }));
    }, [
        grameneSearch,
        grameneMaps
    ]);
    const activeTaxon = ontologyEnrichment.activeTaxon;
    const [treeWidth, setTreeWidth] = (0, $gXNCa$react.useState)(280);
    const beginResize = (e)=>{
        e.preventDefault();
        const startX = e.clientX;
        const startWidth = treeWidth;
        const onMove = (ev)=>{
            const next = Math.max(150, Math.min(800, startWidth + (ev.clientX - startX)));
            setTreeWidth(next);
        };
        const onUp = ()=>{
            document.removeEventListener('mousemove', onMove);
            document.removeEventListener('mouseup', onUp);
            document.body.style.userSelect = '';
            document.body.style.cursor = '';
        };
        document.body.style.userSelect = 'none';
        document.body.style.cursor = 'col-resize';
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
    };
    (0, $gXNCa$react.useEffect)(()=>{
        if (taxa.length === 0) return;
        if (!activeTaxon || !taxa.find((t)=>String(t.tid) === String(activeTaxon))) doSetOntologyEnrichmentActiveTaxon(taxa[0].tid);
    }, [
        taxa,
        activeTaxon,
        doSetOntologyEnrichmentActiveTaxon
    ]);
    (0, $gXNCa$react.useEffect)(()=>{
        if (!activeTaxon) return;
        const t = ontologyEnrichment.byTaxon[activeTaxon];
        if (!t) return;
        if (t.fg.status === 'idle') doFetchOntologyEnrichmentForeground(activeTaxon);
        if (t.bg.status === 'idle') doFetchOntologyEnrichmentBackground(activeTaxon);
    }, [
        activeTaxon,
        ontologyEnrichment,
        doFetchOntologyEnrichmentForeground,
        doFetchOntologyEnrichmentBackground
    ]);
    if (taxa.length === 0) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "oe-view",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("em", {
            children: "No species in the current results."
        })
    });
    if (!grameneTaxonomy) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "oe-view",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("em", {
            children: "Loading taxonomy\u2026"
        })
    });
    const handleAddFilter = (row)=>{
        if (!doAcceptGrameneSuggestion) return;
        const label = row.term_name ? `${row.term_display_id} ${row.term_name}` : row.term_display_id;
        doAcceptGrameneSuggestion({
            fq_field: row.field,
            fq_value: String(row.term_id),
            name: label,
            category: row.ontology_label
        });
    };
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "oe-view oe-layout",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "oe-layout-tree",
                style: {
                    flex: `0 0 ${treeWidth}px`
                },
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($597fe213417ee6ca$var$SpeciesTree, {
                    taxonomy: grameneTaxonomy,
                    grameneMaps: grameneMaps,
                    taxa: taxa,
                    activeTaxon: activeTaxon,
                    onSelect: (tid)=>doSetOntologyEnrichmentActiveTaxon(String(tid))
                })
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "oe-splitter",
                onMouseDown: beginResize,
                title: "Drag to resize"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "oe-layout-panel",
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($597fe213417ee6ca$var$TaxonPanel, {
                    taxon: activeTaxon ? String(activeTaxon) : null,
                    ontologyEnrichment: ontologyEnrichment,
                    results: results,
                    ui: ui,
                    onUiChange: doSetOntologyEnrichmentUI,
                    onAddFilter: handleAddFilter
                })
            })
        ]
    });
};
var $597fe213417ee6ca$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)('selectGrameneSearch', 'selectGrameneMaps', 'selectGrameneTaxonomy', 'selectOntologyEnrichment', 'selectOntologyEnrichmentUI', 'selectOntologyEnrichmentResults', 'doSetOntologyEnrichmentActiveTaxon', 'doSetOntologyEnrichmentUI', 'doFetchOntologyEnrichmentForeground', 'doFetchOntologyEnrichmentBackground', 'doAcceptGrameneSuggestion', $597fe213417ee6ca$var$OntologyEnrichmentViewCmp);
// Adapter: gramene taxonomy-with-genomes tree  →  tbrowse `Tree` + `Taxonomy`.
//
// `grameneTaxDist` (from the grameneTaxDist bundle's selectGrameneTaxDist) is
// the root node of a gramene-taxonomy-with-genomes (tree-model) tree. The
// conversion itself — node ids = String(NCBI taxon id), uniform branch lengths
// (the tree zone runs in 'cladogram' mode for this view), `model.name` exposed
// as both scientific and common name, duplicate-id guard — is
// tbrowse-core's `fromTreeModel`, which was lifted from this file.
function $dc4f9c952681c07f$export$5fb520c9ccc6bdef(taxDist) {
    if (!taxDist || !taxDist.model) return null;
    return (0, $gXNCa$tbrowsecore.fromTreeModel)(taxDist, {
        taxonomyIdAs: 'string'
    });
}
// Host-defined tbrowse zone: per-genome genome-wide distribution of search
// hits, binned into `fixed_1000__bin` bins. One horizontal strip per leaf
// (genome) row, drawn on a canvas (1000 bins × N genomes is far too many DOM
// rects for SVG). Region segmentation + per-pixel weighted scoring +
// categorical region colours are ported from gramene-search-vis
// (taxogenomic/canvas/Genome.js + util/colors.js) so the look matches the
// legacy Taxonomic-distribution view.
//
// Data arrives via tbrowse's opaque `hostData` channel as
//   data.hostData.bins = { genomesByTaxon: { [taxonId]: genome }, maxScore }
// where `genome` is a gramene-bins-client genome (fullGenomeSize,
// _regionsArray, region.bin(i)/binCount()/size/name, bin.results.count).
//
// Pan/zoom: a single shared horizontal transform { scale, leftFrac } (fraction
// space, so it's width-independent and aligns every genome to the same relative
// window) lives in the ephemeral binsUI store. The header toggles between two
// interaction modes: 'select' (drag selects a region to count/filter genes,
// the original gesture) and 'panzoom' (drag pans, wheel zooms toward the
// cursor). All hit-testing/coordinates are in genome-fraction [0,1] so
// hovers/selections stay anchored to the genome as you pan and zoom.
// ── colour model (ported from gramene-search-vis util/colors.js) ──────────
// schemeCategory10, kept as RGB triples so we need no d3 dependency here.
const $bfd29d54a0f0e853$var$REGION_RGB = [
    [
        31,
        119,
        180
    ],
    [
        255,
        127,
        14
    ],
    [
        44,
        160,
        44
    ],
    [
        214,
        39,
        40
    ],
    [
        148,
        103,
        189
    ],
    [
        140,
        86,
        75
    ],
    [
        227,
        119,
        194
    ],
    [
        127,
        127,
        127
    ],
    [
        188,
        189,
        34
    ],
    [
        23,
        190,
        207
    ]
];
const $bfd29d54a0f0e853$var$UNANCHORED = 'rgb(211,211,211)';
const $bfd29d54a0f0e853$var$WHITE = [
    255,
    255,
    255
];
const $bfd29d54a0f0e853$var$lerp = (a, b, t)=>[
        Math.round(a[0] + (b[0] - a[0]) * t),
        Math.round(a[1] + (b[1] - a[1]) * t),
        Math.round(a[2] + (b[2] - a[2]) * t)
    ];
// Light tint → base colour, with a pow(0.4) ramp on the score so low counts
// stay visible — matches binColorScales in the legacy colors.js.
function $bfd29d54a0f0e853$var$binColor(regionIdx, score, unanchored) {
    if (unanchored) return $bfd29d54a0f0e853$var$UNANCHORED;
    const base = $bfd29d54a0f0e853$var$REGION_RGB[regionIdx % $bfd29d54a0f0e853$var$REGION_RGB.length];
    const tint = $bfd29d54a0f0e853$var$lerp($bfd29d54a0f0e853$var$WHITE, base, 0.15);
    const t = Math.pow(Math.max(0, Math.min(1, score)), 0.4);
    const [r, g, b] = $bfd29d54a0f0e853$var$lerp(tint, base, t);
    return `rgb(${r},${g},${b})`;
}
function $bfd29d54a0f0e853$var$updateScore(currentScore, baseCount, binScore, binBasesUsed) {
    if (typeof currentScore === 'number') return (currentScore * baseCount + binScore * binBasesUsed) / (binBasesUsed + baseCount);
    return binScore;
}
const $bfd29d54a0f0e853$var$clamp = (v, lo, hi)=>Math.max(lo, Math.min(hi, v));
const $bfd29d54a0f0e853$var$MAX_SCALE = 1000; // zoom far enough to isolate a single bin
// Locate the region/bin cursor at a target base offset, so a zoomed draw can
// start partway into the genome without iterating skipped pixels. Returns null
// past the end of the genome.
function $bfd29d54a0f0e853$var$seekCursor(regions, targetBase) {
    let acc = 0;
    for(let regionIdx = 0; regionIdx < regions.length; regionIdx++){
        const region = regions[regionIdx];
        const n = region.binCount();
        for(let binIdx = 0; binIdx < n; binIdx++){
            const bin = region.bin(binIdx);
            const size = bin.end - bin.start + 1;
            if (acc + size > targetBase) return {
                regionIdx: regionIdx,
                binIdx: binIdx,
                basesInBinUsedAlready: Math.max(0, targetBase - acc)
            };
            acc += size;
        }
    }
    return null;
}
// Draw one genome's distribution into the visible [0, widthPx) strip at
// vertical [y, y+height), under the shared { scale, leftFrac } transform. Only
// the visible pixels are drawn (the cursor is fast-forwarded to the window's
// left edge); consecutive equal-colour columns are batched into one fillRect,
// which makes zoomed-in draws (where each bin spans many px) cheap. Ported from
// drawGenome() in gramene-search-vis, generalised for pan/zoom.
function $bfd29d54a0f0e853$var$drawGenomeRow(ctx, genome, y, widthPx, height, maxScore, scale, leftFrac) {
    const regions = genome && genome._regionsArray;
    const full = genome && genome.fullGenomeSize;
    if (!regions || regions.length === 0 || !full) return;
    const virtualWidth = widthPx * scale; // full genome spans this many px when zoomed
    const basesPerPx = full / virtualWidth;
    if (!(basesPerPx > 0)) return;
    const cursor = $bfd29d54a0f0e853$var$seekCursor(regions, leftFrac * full);
    if (!cursor) return;
    let { regionIdx: regionIdx, binIdx: binIdx, basesInBinUsedAlready: basesInBinUsedAlready } = cursor;
    let region = regions[regionIdx];
    let regionUnanchored = region.name === 'UNANCHORED';
    let runColor = null;
    let runStart = 0;
    const flush = (endExclusive)=>{
        if (runColor !== null && endExclusive > runStart) {
            ctx.fillStyle = runColor;
            ctx.fillRect(runStart, y, endExclusive - runStart, height);
        }
    };
    let px = 0;
    for(; px < widthPx; px++){
        let baseCount = 0;
        let score;
        let ended = false;
        while(baseCount < basesPerPx){
            const basesNeededByThisPixel = basesPerPx - baseCount;
            const bin = region.bin(binIdx);
            const binSize = bin.end - bin.start + 1;
            const binScore = maxScore ? (bin.results ? bin.results.count : 0) / maxScore : 0;
            const basesAvailableInBin = binSize - basesInBinUsedAlready;
            let binBasesUsed;
            if (basesAvailableInBin <= basesNeededByThisPixel) {
                binIdx++;
                basesInBinUsedAlready = 0;
                binBasesUsed = basesAvailableInBin;
            } else {
                basesInBinUsedAlready += basesNeededByThisPixel;
                binBasesUsed = basesNeededByThisPixel;
            }
            score = $bfd29d54a0f0e853$var$updateScore(score, baseCount, binScore, binBasesUsed);
            baseCount += binBasesUsed;
            if (binIdx === region.binCount()) {
                binIdx = 0;
                regionIdx++;
                if (regionIdx === regions.length) {
                    ended = true;
                    break;
                }
                region = regions[regionIdx];
                regionUnanchored = region.name === 'UNANCHORED';
            }
        }
        const idxForColor = regionIdx >= regions.length ? regions.length - 1 : regionIdx;
        const color = $bfd29d54a0f0e853$var$binColor(idxForColor, score || 0, regionUnanchored);
        if (runColor === null) {
            runColor = color;
            runStart = px;
        } else if (color !== runColor) {
            flush(px);
            runColor = color;
            runStart = px;
        }
        if (ended) {
            px++;
            break;
        }
    }
    flush(px);
}
function $bfd29d54a0f0e853$export$390e10a52782f018(taxDist) {
    if (!taxDist || typeof taxDist.leafNodes !== 'function') return null;
    const genomesByTaxon = {};
    taxDist.leafNodes().forEach((node)=>{
        if (node && node.model && node.model.genome) genomesByTaxon[String(node.model.id)] = node.model.genome;
    });
    let maxScore = 0;
    try {
        const stats = taxDist.globalResultSetStats();
        maxScore = stats && stats.bins && stats.bins.max || 0;
    } catch (_) {}
    return {
        genomesByTaxon: genomesByTaxon,
        maxScore: maxScore
    };
}
// ── interaction store (shared between Header and Body via hostData) ──────────
// A tiny pub/sub kept OUT of the controlled tbrowse viewState so per-mousemove
// hover/drag/pan/zoom updates don't churn the whole tree. Holds the hovered
// chromosome, the in-progress select-drag, the committed drag-selections, and
// the shared horizontal pan/zoom transform.
const $bfd29d54a0f0e853$var$DEFAULT_TRANSFORM = {
    scale: 1,
    leftFrac: 0
};
const $bfd29d54a0f0e853$var$EMPTY_UI = {
    hovered: null,
    inProgress: null,
    selections: [],
    transform: $bfd29d54a0f0e853$var$DEFAULT_TRANSFORM
};
const $bfd29d54a0f0e853$var$NOOP_SUB = ()=>()=>{};
const $bfd29d54a0f0e853$var$NOOP_GET = ()=>$bfd29d54a0f0e853$var$EMPTY_UI;
function $bfd29d54a0f0e853$export$f06340802363875a() {
    let state = $bfd29d54a0f0e853$var$EMPTY_UI;
    const listeners = new Set();
    const emit = ()=>listeners.forEach((l)=>l());
    return {
        getState: ()=>state,
        subscribe: (l)=>{
            listeners.add(l);
            return ()=>listeners.delete(l);
        },
        setHovered: (h)=>{
            state = {
                ...state,
                hovered: h
            };
            emit();
        },
        setInProgress: (p)=>{
            state = {
                ...state,
                inProgress: p
            };
            emit();
        },
        setTransform: (t)=>{
            state = {
                ...state,
                transform: t
            };
            emit();
        },
        resetTransform: ()=>{
            state = {
                ...state,
                transform: $bfd29d54a0f0e853$var$DEFAULT_TRANSFORM
            };
            emit();
        },
        // Add a selection, merging it with any existing selection on the SAME
        // genome whose fraction range overlaps — so overlapping drags become one
        // region and shared bins aren't double-counted. Bins are unioned by their
        // global index.
        addSelection: (sel)=>{
            let merged = sel;
            const rest = [];
            for (const s of state.selections)if (s.taxonId === merged.taxonId && s.f0 <= merged.f1 && s.f1 >= merged.f0) {
                const byIdx = new Map();
                for (const b of s.bins)byIdx.set(b.idx, b.count);
                for (const b of merged.bins)byIdx.set(b.idx, b.count);
                merged = {
                    taxonId: merged.taxonId,
                    f0: Math.min(s.f0, merged.f0),
                    f1: Math.max(s.f1, merged.f1),
                    bins: [
                        ...byIdx
                    ].map(([idx, count])=>({
                            idx: idx,
                            count: count
                        }))
                };
            } else rest.push(s);
            state = {
                ...state,
                selections: [
                    ...rest,
                    merged
                ]
            };
            emit();
        },
        // Clear hover/selections but keep the current zoom/pan transform — clearing
        // selections shouldn't yank the user back out of their zoom.
        clear: ()=>{
            state = {
                ...$bfd29d54a0f0e853$var$EMPTY_UI,
                transform: state.transform
            };
            emit();
        },
        // Full reset (new result set): drop everything including the transform.
        reset: ()=>{
            state = $bfd29d54a0f0e853$var$EMPTY_UI;
            emit();
        }
    };
}
function $bfd29d54a0f0e853$export$cf7300886d7d9e1e(selections) {
    const byIdx = new Map();
    for (const s of selections)for (const b of s.bins || [])byIdx.set(b.idx, b.count);
    let total = 0;
    for (const c of byIdx.values())total += c;
    return total;
}
function $bfd29d54a0f0e853$export$861100744513cc3(selections) {
    const set = new Set();
    for (const s of selections)for (const b of s.bins || [])set.add(b.idx);
    return [
        ...set
    ];
}
// Per-genome layout in genome-fraction space [0,1]: region spans (for
// chromosome hit-testing) and bin spans with gene counts (for summing a
// drag-selected range). Width/zoom-independent — the transform maps fractions
// to screen pixels at render time.
function $bfd29d54a0f0e853$var$buildGenomeLayout(genome) {
    const out = {
        regions: []
    };
    const regions = genome && genome._regionsArray;
    const full = genome && genome.fullGenomeSize;
    if (!regions || !full) return out;
    let base = 0;
    for (const region of regions){
        const f0 = base / full;
        const binsArr = [];
        const n = region.binCount();
        for(let i = 0; i < n; i++){
            const bin = region.bin(i);
            const size = bin.end - bin.start + 1;
            const bf0 = base / full;
            base += size;
            binsArr.push({
                f0: bf0,
                f1: base / full,
                count: bin.results && bin.results.count || 0,
                idx: bin.idx
            });
        }
        out.regions.push({
            name: region.name,
            f0: f0,
            f1: base / full,
            bins: binsArr
        });
    }
    return out;
}
function $bfd29d54a0f0e853$var$regionAtFrac(layout, f) {
    for (const r of layout.regions)if (f >= r.f0 && f < r.f1) return r;
    return null;
}
// Non-empty bins overlapping a fraction range, as {idx, count}. Empty bins are
// excluded by design (the selection / filter only covers bins with genes).
function $bfd29d54a0f0e853$var$selectedBinsInFracRange(layout, a, b) {
    const lo = Math.min(a, b);
    const hi = Math.max(a, b);
    const bins = [];
    for (const r of layout.regions){
        if (r.f1 < lo || r.f0 > hi) continue;
        for (const bin of r.bins)if (bin.f1 > lo && bin.f0 < hi && bin.count > 0) bins.push({
            idx: bin.idx,
            count: bin.count
        });
    }
    return bins;
}
// ── zone components ─────────────────────────────────────────────────────────
const $bfd29d54a0f0e853$var$HEADER_BTN = {
    fontSize: 11,
    lineHeight: 1,
    padding: '1px 6px',
    cursor: 'pointer'
};
function $bfd29d54a0f0e853$var$ModeToggle({ mode: mode, setMode: setMode }) {
    const seg = (id, label)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
            type: "button",
            onClick: ()=>setMode(id),
            title: id === 'select' ? 'Drag to select a region' : 'Drag to pan, scroll to zoom',
            style: {
                fontSize: 11,
                lineHeight: 1,
                padding: '2px 7px',
                cursor: 'pointer',
                border: 'none',
                background: mode === id ? 'var(--tbrowse-accent, #2878dc)' : 'transparent',
                color: mode === id ? '#fff' : 'var(--tbrowse-text-muted)'
            },
            children: label
        });
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        style: {
            display: 'inline-flex',
            border: '1px solid var(--tbrowse-border-soft)',
            borderRadius: 4,
            overflow: 'hidden'
        },
        children: [
            seg('select', 'Select'),
            seg('panzoom', 'Pan/Zoom')
        ]
    });
}
const $bfd29d54a0f0e853$var$BinsHeader = ({ data: data, zoneState: zoneState, setZoneState: setZoneState })=>{
    const store = data.hostData && data.hostData.binsUI;
    const snap = (0, $gXNCa$react.useSyncExternalStore)(store ? store.subscribe : $bfd29d54a0f0e853$var$NOOP_SUB, store ? store.getState : $bfd29d54a0f0e853$var$NOOP_GET);
    const total = $bfd29d54a0f0e853$export$cf7300886d7d9e1e(snap.selections);
    const hovered = snap.hovered;
    const scale = snap.transform ? snap.transform.scale : 1;
    const mode = zoneState && zoneState.mode || 'select';
    const setMode = (m)=>setZoneState((s)=>({
                ...s ?? {},
                mode: m
            }));
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            gap: 2,
            padding: '0 10px',
            fontSize: 13,
            color: 'var(--tbrowse-text)'
        },
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    minHeight: 0,
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$tbrowse.EditableZoneName, {
                        defaultName: "Genome distribution",
                        customName: zoneState?.name,
                        onChange: (next)=>setZoneState((s)=>({
                                    ...s ?? {},
                                    name: next
                                }))
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($bfd29d54a0f0e853$var$ModeToggle, {
                        mode: mode,
                        setMode: setMode
                    }),
                    scale > 1.0001 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                                style: {
                                    color: 'var(--tbrowse-text-muted)',
                                    fontSize: 11,
                                    whiteSpace: 'nowrap'
                                },
                                children: [
                                    scale.toFixed(scale < 10 ? 1 : 0),
                                    "\xd7"
                                ]
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                                type: "button",
                                style: $bfd29d54a0f0e853$var$HEADER_BTN,
                                title: "Reset zoom",
                                onClick: ()=>store && store.resetTransform(),
                                children: "reset zoom"
                            })
                        ]
                    }),
                    snap.selections.length > 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                                style: {
                                    color: 'var(--tbrowse-text-muted)',
                                    fontSize: 12,
                                    whiteSpace: 'nowrap'
                                },
                                children: [
                                    total.toLocaleString(),
                                    " gene",
                                    total === 1 ? '' : 's',
                                    " selected"
                                ]
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                                type: "button",
                                style: $bfd29d54a0f0e853$var$HEADER_BTN,
                                title: "Clear selections",
                                onClick: ()=>store && store.clear(),
                                children: "clear selections"
                            }),
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                                type: "button",
                                style: $bfd29d54a0f0e853$var$HEADER_BTN,
                                title: "Add the selected bins (those with genes) as a search filter",
                                onClick: ()=>{
                                    const apply = data.hostData && data.hostData.onApplyBinsFilter;
                                    if (apply) apply(snap.selections);
                                },
                                children: "apply as filter"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                style: {
                    fontSize: 11,
                    color: 'var(--tbrowse-text-muted)',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                },
                children: hovered ? `${hovered.genomeName} : ${hovered.regionName} : ${(hovered.geneCount || 0).toLocaleString()} gene${hovered.geneCount === 1 ? '' : 's'}` : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    style: {
                        color: 'var(--tbrowse-text-subtle)'
                    },
                    children: "hover a chromosome\u2026"
                })
            })
        ]
    });
};
// Vertical inset for the drawn bins. Leaving a few px of the row un-painted
// lets the row-highlight background (rendered in the layer beneath the canvas)
// show as bands above/below the strip on hover/select.
const $bfd29d54a0f0e853$var$ROW_PAD_Y = 2;
const $bfd29d54a0f0e853$var$BinsBody = (props)=>{
    const { visibleRows: visibleRows, rowRange: rowRange, width: width, data: data, zoneState: zoneState, hoveredNodeId: hoveredNodeId, hoveredSubtreeIds: hoveredSubtreeIds, selectedNodeId: selectedNodeId, onHoverNode: onHoverNode, onSelectNode: onSelectNode } = props;
    const canvasRef = (0, $gXNCa$react.useRef)(null);
    const containerRef = (0, $gXNCa$react.useRef)(null);
    const dragRef = (0, $gXNCa$react.useRef)(null);
    // A drag ends with a synthetic `click` after `pointerup` (dragRef is already
    // cleared by then), which would otherwise select the row's node and pop the
    // tree tooltip. Set on a moved drag and consumed by the row's onClick.
    const suppressClickRef = (0, $gXNCa$react.useRef)(false);
    const store = data.hostData && data.hostData.binsUI;
    const snap = (0, $gXNCa$react.useSyncExternalStore)(store ? store.subscribe : $bfd29d54a0f0e853$var$NOOP_SUB, store ? store.getState : $bfd29d54a0f0e853$var$NOOP_GET);
    const transform = snap.transform || $bfd29d54a0f0e853$var$DEFAULT_TRANSFORM;
    const mode = zoneState && zoneState.mode || 'select';
    const totalHeight = (0, $gXNCa$tbrowsecore.rowsTotalHeight)(visibleRows);
    const bins = data.hostData && data.hostData.bins;
    const rows = visibleRows.slice(rowRange.startIndex, rowRange.endIndex);
    const w = Math.max(1, Math.floor(width));
    // Fraction-space layout per visible genome row (regions + bins), for
    // hit-testing. Independent of width/zoom, so it only rebuilds when the row
    // set changes.
    const layouts = (0, $gXNCa$react.useMemo)(()=>{
        const m = {};
        if (bins) for (const r of rows){
            if (r.kind !== 'leaf') continue;
            const g = bins.genomesByTaxon[r.nodeId];
            if (g) m[r.nodeId] = $bfd29d54a0f0e853$var$buildGenomeLayout(g);
        }
        return m;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        bins,
        rowRange.startIndex,
        rowRange.endIndex,
        visibleRows
    ]);
    // Fraction <-> screen-pixel helpers under the current transform.
    const fracToScreen = (f)=>(f - transform.leftFrac) * transform.scale * w;
    const screenToFrac = (px)=>transform.leftFrac + px / w / transform.scale;
    (0, $gXNCa$react.useEffect)(()=>{
        const canvas = canvasRef.current;
        if (!canvas || !bins) return;
        const dpr = window.devicePixelRatio || 1;
        const h = Math.max(1, Math.floor(totalHeight));
        canvas.width = w * dpr;
        canvas.height = h * dpr;
        const ctx = canvas.getContext('2d');
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.clearRect(0, 0, w, h);
        for (const r of rows){
            if (r.kind !== 'leaf') continue; // collapsed summaries: no single genome
            const genome = bins.genomesByTaxon[r.nodeId];
            if (!genome) continue;
            const innerH = Math.max(1, r.height - 2 * $bfd29d54a0f0e853$var$ROW_PAD_Y);
            $bfd29d54a0f0e853$var$drawGenomeRow(ctx, genome, r.y + $bfd29d54a0f0e853$var$ROW_PAD_Y, w, innerH, bins.maxScore, transform.scale, transform.leftFrac);
        }
    }, [
        visibleRows,
        rowRange.startIndex,
        rowRange.endIndex,
        w,
        totalHeight,
        bins,
        transform.scale,
        transform.leftFrac
    ]);
    const pxFromEvent = (e)=>{
        const el = containerRef.current;
        if (!el) return 0;
        const rect = el.getBoundingClientRect();
        return $bfd29d54a0f0e853$var$clamp(e.clientX - rect.left, 0, w);
    };
    // Wheel-to-zoom (panzoom mode only), centred on the cursor. Native non-passive
    // listener so we can preventDefault the page scroll; re-attached when mode/
    // width change. Transform is read live from the store to avoid stale closures.
    (0, $gXNCa$react.useEffect)(()=>{
        const el = containerRef.current;
        if (!el || !store) return undefined;
        const onWheel = (e)=>{
            if (mode !== 'panzoom') return; // let the page scroll normally
            e.preventDefault();
            const t = store.getState().transform || $bfd29d54a0f0e853$var$DEFAULT_TRANSFORM;
            const rect = el.getBoundingClientRect();
            const cursorPx = $bfd29d54a0f0e853$var$clamp(e.clientX - rect.left, 0, w);
            const fracAtCursor = t.leftFrac + cursorPx / w / t.scale;
            const factor = Math.exp(-e.deltaY * 0.0015);
            const newScale = $bfd29d54a0f0e853$var$clamp(t.scale * factor, 1, $bfd29d54a0f0e853$var$MAX_SCALE);
            const newLeft = $bfd29d54a0f0e853$var$clamp(fracAtCursor - cursorPx / w / newScale, 0, 1 - 1 / newScale);
            store.setTransform({
                scale: newScale,
                leftFrac: newLeft
            });
        };
        el.addEventListener('wheel', onWheel, {
            passive: false
        });
        return ()=>el.removeEventListener('wheel', onWheel);
    }, [
        store,
        w,
        mode
    ]);
    const genomeName = (taxonId)=>{
        const tax = data.taxonomy && data.taxonomy[taxonId];
        return tax && (tax.commonName || tax.scientificName) || String(taxonId);
    };
    const onRowMouseMove = (e, r)=>{
        if (!store || dragRef.current || !layouts[r.nodeId]) return;
        const reg = $bfd29d54a0f0e853$var$regionAtFrac(layouts[r.nodeId], screenToFrac(pxFromEvent(e)));
        if (!reg) {
            store.setHovered(null);
            return;
        }
        const geneCount = reg.bins.reduce((a, b)=>a + b.count, 0);
        store.setHovered({
            taxonId: r.nodeId,
            genomeName: genomeName(r.nodeId),
            regionName: reg.name,
            geneCount: geneCount,
            f0: reg.f0,
            f1: reg.f1
        });
    };
    // Pan drag (panzoom mode): translate leftFrac by the cursor delta, scaled by
    // the current zoom. Shared transform → every genome row pans together.
    const startPan = (e)=>{
        e.preventDefault();
        const startPx = pxFromEvent(e);
        const t0 = store.getState().transform || $bfd29d54a0f0e853$var$DEFAULT_TRANSFORM;
        let moved = false;
        const onMove = (ev)=>{
            const dx = pxFromEvent(ev) - startPx;
            if (Math.abs(dx) > 2) moved = true;
            const t = store.getState().transform || $bfd29d54a0f0e853$var$DEFAULT_TRANSFORM;
            const newLeft = $bfd29d54a0f0e853$var$clamp(t0.leftFrac - dx / w / t.scale, 0, 1 - 1 / t.scale);
            store.setTransform({
                scale: t.scale,
                leftFrac: newLeft
            });
        };
        const onUp = ()=>{
            document.removeEventListener('pointermove', onMove);
            document.removeEventListener('pointerup', onUp);
            if (moved) suppressClickRef.current = true;
        };
        document.addEventListener('pointermove', onMove);
        document.addEventListener('pointerup', onUp);
    };
    // Select drag (select mode): brush a fraction range and add the non-empty
    // bins under it as a committed selection.
    const startSelect = (e, r)=>{
        if (!layouts[r.nodeId]) return;
        e.preventDefault();
        const startFrac = screenToFrac(pxFromEvent(e));
        dragRef.current = {
            taxonId: r.nodeId,
            startFrac: startFrac,
            moved: false
        };
        store.setInProgress({
            taxonId: r.nodeId,
            f0: startFrac,
            f1: startFrac
        });
        const onMove = (ev)=>{
            const d = dragRef.current;
            if (!d) return;
            const cur = screenToFrac(pxFromEvent(ev));
            if (Math.abs(cur - d.startFrac) * w * transform.scale > 2) d.moved = true;
            store.setInProgress({
                taxonId: d.taxonId,
                f0: Math.min(d.startFrac, cur),
                f1: Math.max(d.startFrac, cur)
            });
        };
        const onUp = (ev)=>{
            const d = dragRef.current;
            dragRef.current = null;
            document.removeEventListener('pointermove', onMove);
            document.removeEventListener('pointerup', onUp);
            store.setInProgress(null);
            if (d && d.moved) {
                suppressClickRef.current = true; // swallow the click that follows a drag
                const cur = screenToFrac(pxFromEvent(ev));
                const f0 = Math.min(d.startFrac, cur);
                const f1 = Math.max(d.startFrac, cur);
                const lay = layouts[d.taxonId];
                if (lay) {
                    const selBins = $bfd29d54a0f0e853$var$selectedBinsInFracRange(lay, f0, f1);
                    if (selBins.length) store.addSelection({
                        taxonId: d.taxonId,
                        f0: f0,
                        f1: f1,
                        bins: selBins
                    });
                }
            }
        };
        document.addEventListener('pointermove', onMove);
        document.addEventListener('pointerup', onUp);
    };
    const onRowPointerDown = (e, r)=>{
        if (!store) return;
        if (mode === 'panzoom') {
            startPan(e);
            return;
        }
        startSelect(e, r);
    };
    const rowByTaxon = new Map(rows.map((r)=>[
            r.nodeId,
            r
        ]));
    // Outline rectangles (drawn above the canvas; pointer-events:none). Stored in
    // fraction space and projected to screen px under the transform, clipped to
    // the visible strip. The y comes from the current row so they track scroll.
    const outline = (key, taxonId, f0, f1, color, dashed)=>{
        const r = rowByTaxon.get(taxonId);
        if (!r) return null;
        let x0 = fracToScreen(f0);
        let x1 = fracToScreen(f1);
        if (x1 <= 0 || x0 >= w) return null; // fully outside the visible window
        x0 = Math.max(0, x0);
        x1 = Math.min(w, x1);
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
            style: {
                position: 'absolute',
                top: r.y + 1,
                left: x0,
                width: Math.max(1, x1 - x0),
                height: Math.max(1, r.height - 2),
                border: `1px ${dashed ? 'dashed' : 'solid'} ${color}`,
                boxSizing: 'border-box',
                pointerEvents: 'none'
            }
        }, key);
    };
    const rowCursor = mode === 'panzoom' ? 'grab' : 'crosshair';
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        ref: containerRef,
        style: {
            position: 'relative',
            width: width,
            height: totalHeight
        },
        children: [
            rows.map((r)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                    onMouseEnter: ()=>onHoverNode(r.nodeId),
                    onMouseLeave: ()=>{
                        onHoverNode(null);
                        if (store && !dragRef.current) store.setHovered(null);
                    },
                    onMouseMove: (e)=>onRowMouseMove(e, r),
                    onPointerDown: (e)=>onRowPointerDown(e, r),
                    onClick: ()=>{
                        if (suppressClickRef.current) {
                            suppressClickRef.current = false;
                            return;
                        }
                        onSelectNode(r.nodeId);
                    },
                    style: {
                        position: 'absolute',
                        top: r.y,
                        left: 0,
                        right: 0,
                        height: r.height,
                        background: (0, $gXNCa$tbrowse.rowHighlightBackground)((0, $gXNCa$tbrowsecore.rowFlags)(r, {
                            hoveredNodeId: hoveredNodeId,
                            hoveredSubtreeIds: hoveredSubtreeIds,
                            selectedNodeId: selectedNodeId
                        })),
                        cursor: rowCursor,
                        opacity: r.opacity ?? 1
                    }
                }, r.nodeId)),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("canvas", {
                ref: canvasRef,
                style: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: width,
                    height: totalHeight,
                    pointerEvents: 'none'
                }
            }),
            snap.hovered && !snap.inProgress && outline('hover', snap.hovered.taxonId, snap.hovered.f0, snap.hovered.f1, 'var(--tbrowse-accent, #2878dc)', false),
            snap.selections.map((s, i)=>outline(`sel-${i}`, s.taxonId, s.f0, s.f1, '#d62728', false)),
            snap.inProgress && outline('drag', snap.inProgress.taxonId, snap.inProgress.f0, snap.inProgress.f1, '#d62728', true)
        ]
    });
};
const $bfd29d54a0f0e853$export$d85d069f2280460c = {
    id: 'bins',
    displayName: 'Genome distribution',
    Header: $bfd29d54a0f0e853$var$BinsHeader,
    Body: $bfd29d54a0f0e853$var$BinsBody,
    defaultWidth: 60,
    minWidth: 200,
    defaultZoneState: {
        mode: 'select'
    },
    isAvailable: (data)=>Boolean(data.hostData && data.hostData.bins && data.hostData.bins.genomesByTaxon && Object.keys(data.hostData.bins.genomesByTaxon).length > 0),
    defaultVisible: true
};
// Host-defined tbrowse zone: a narrow, right-justified text column showing the
// number of matching genes per leaf (genome) — or, for a collapsed clade, the
// summed count over its subtree. Counts come from the taxon_id facet; the
// per-node sums are computed by tbrowse-core's `countsFromFacet` in the
// container and handed in via hostData.geneCounts = { [nodeId]: number }.
const $15275c4f5939e11d$var$CountsHeader = ({ zoneState: zoneState, setZoneState: setZoneState })=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        style: {
            padding: '0 10px',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            fontSize: 13
        },
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$tbrowse.EditableZoneName, {
            defaultName: "Genes",
            customName: zoneState?.name,
            onChange: (next)=>setZoneState((s)=>({
                        ...s ?? {},
                        name: next
                    }))
        })
    });
const $15275c4f5939e11d$var$CountsBody = ({ visibleRows: visibleRows, rowRange: rowRange, width: width, data: data, hoveredNodeId: hoveredNodeId, hoveredSubtreeIds: hoveredSubtreeIds, selectedNodeId: selectedNodeId, onHoverNode: onHoverNode, onSelectNode: onSelectNode })=>{
    const totalHeight = (0, $gXNCa$tbrowsecore.rowsTotalHeight)(visibleRows);
    const counts = data.hostData && data.hostData.geneCounts || {};
    // Rows in the virtualised range with the shared hover/select background, so
    // hovering any zone lights up the same row across all of them.
    const rows = (0, $gXNCa$tbrowse.rowsWithFlags)(visibleRows, rowRange, {
        hoveredNodeId: hoveredNodeId,
        hoveredSubtreeIds: hoveredSubtreeIds,
        selectedNodeId: selectedNodeId
    });
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        style: {
            position: 'relative',
            width: width,
            height: totalHeight
        },
        children: rows.map(({ row: r, background: background })=>{
            const n = counts[r.nodeId];
            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                onMouseEnter: ()=>onHoverNode(r.nodeId),
                onMouseLeave: ()=>onHoverNode(null),
                onClick: ()=>onSelectNode(r.nodeId),
                style: {
                    position: 'absolute',
                    top: r.y,
                    height: r.height,
                    left: 0,
                    right: 0,
                    paddingRight: 8,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    boxSizing: 'border-box',
                    fontSize: 'var(--tbrowse-font-size, 12px)',
                    fontVariantNumeric: 'tabular-nums',
                    color: 'var(--tbrowse-text)',
                    background: background,
                    cursor: 'pointer',
                    opacity: r.opacity ?? 1
                },
                children: typeof n === 'number' ? n.toLocaleString() : ''
            }, r.nodeId);
        })
    });
};
const $15275c4f5939e11d$export$797dd5b929b7ce18 = {
    id: 'counts',
    displayName: 'Genes',
    Header: $15275c4f5939e11d$var$CountsHeader,
    Body: $15275c4f5939e11d$var$CountsBody,
    defaultWidth: 12,
    minWidth: 64,
    defaultZoneState: {},
    isAvailable: (data)=>Boolean(data.hostData && data.hostData.geneCounts),
    defaultVisible: true
};
// tbrowse-based reimplementation of the Taxonomic-distribution view: the
// species tree becomes a tbrowse tree (cladogram, tips aligned) and the
// per-genome bin distribution becomes a tbrowse zone. Shipped behind the
// `taxTree` view id alongside the legacy `taxonomy` view.
const $15504f5eba8e73bd$var$ZONES = [
    $gXNCa$tbrowse.treeZone,
    $gXNCa$tbrowse.labelsZone,
    $15275c4f5939e11d$export$797dd5b929b7ce18,
    $bfd29d54a0f0e853$export$d85d069f2280460c
];
// Compress a set of global bin indices into a Solr disjunction, collapsing runs
// of consecutive indices into `[a TO b]` ranges: e.g. {5,6,7,12} →
// "[5 TO 7] OR 12". The explicit `OR` matters: a bare space-separated list
// `(5 6 12)` is evaluated under the index's default operator (AND here), which
// can never match a single-valued field, so it must be an explicit disjunction.
function $15504f5eba8e73bd$var$binIdxsToSolr(idxs) {
    const sorted = [
        ...new Set(idxs)
    ].sort((a, b)=>a - b);
    const parts = [];
    let i = 0;
    while(i < sorted.length){
        let j = i;
        while(j + 1 < sorted.length && sorted[j + 1] === sorted[j] + 1)j++;
        parts.push(sorted[i] === sorted[j] ? `${sorted[i]}` : `[${sorted[i]} TO ${sorted[j]}]`);
        i = j + 1;
    }
    return parts.join(' OR ');
}
// The initial controlled ViewState: tbrowse-core's buildInitialViewState over
// this view's zone list with the view's own fr-shares, and — passed through
// `overrides` so they replace the seeded defaults verbatim — the per-zone states
// exactly as this view has always persisted them. The tree zone tolerates a
// partial state (reads with `?? default`); the labels zone reads `visibleFields`
// directly, so it must be present. Drive the tree as a cladogram (taxonomy has
// no branch lengths) and show the genome/species name in the labels column.
function $15504f5eba8e73bd$var$baseViewState() {
    return (0, $gXNCa$tbrowsecore.buildInitialViewState)($15504f5eba8e73bd$var$ZONES, {
        widths: {
            tree: 30,
            labels: 22,
            counts: 10,
            bins: 60
        },
        overrides: {
            zoneStates: {
                tree: {
                    layoutMode: 'cladogram',
                    showLeafExtensions: false
                },
                labels: {
                    visibleFields: [
                        'taxonomy.commonName'
                    ]
                },
                counts: {},
                bins: {}
            }
        }
    });
}
// The set of taxa to SHOW, mirroring the legacy TaxDist.js logic.
function $15504f5eba8e73bd$var$computeSelectedTaxa({ grameneSearch: grameneSearch, grameneGenomes: grameneGenomes, grameneMaps: grameneMaps }, treeNodes, collapseEmpties, comparaOnly, showCompara) {
    const selected = {};
    if (!grameneSearch) return selected;
    if (collapseEmpties) {
        const tids = grameneSearch.facet_counts && grameneSearch.facet_counts.facet_fields && grameneSearch.facet_counts.facet_fields.taxon_id;
        if (tids) for(let i = 0; i < tids.length; i += 2)selected[tids[i]] = true;
    } else {
        const active = grameneGenomes && grameneGenomes.active || {};
        if (Object.keys(active).length === 0 && grameneMaps) Object.keys(grameneMaps).forEach((tid)=>{
            selected[tid] = true;
        });
        else Object.keys(active).forEach((tid)=>{
            selected[tid] = true;
        });
    }
    if (showCompara && comparaOnly && grameneMaps) Object.keys(selected).forEach((tid)=>{
        if (!grameneMaps[tid] || !grameneMaps[tid].in_compara) delete selected[tid];
    });
    // Drop ids the tree doesn't know about.
    Object.keys(selected).forEach((tid)=>{
        if (!treeNodes[tid]) delete selected[tid];
    });
    return selected;
}
const $15504f5eba8e73bd$var$TaxDistTbrowse = (props)=>{
    const { grameneTaxDist: grameneTaxDist, configuration: configuration } = props;
    const adapter = (0, $gXNCa$react.useMemo)(()=>$dc4f9c952681c07f$export$5fb520c9ccc6bdef(grameneTaxDist), [
        grameneTaxDist
    ]);
    // Bins-zone interaction store (hover chromosome / drag-select gene counts),
    // shared between the bins Header and Body via hostData. Kept in a ref so it's
    // stable across renders; cleared when the result set changes (counts stale).
    const binsUiRef = (0, $gXNCa$react.useRef)(null);
    if (!binsUiRef.current) binsUiRef.current = $bfd29d54a0f0e853$export$f06340802363875a();
    (0, $gXNCa$react.useEffect)(()=>{
        binsUiRef.current.reset();
    }, [
        grameneTaxDist
    ]);
    // "Apply as filter": turn the drag-selections' non-empty bins into a
    // fixed_1000__bin range filter on the search.
    const doAcceptGrameneSuggestion = props.doAcceptGrameneSuggestion;
    const onApplyBinsFilter = (0, $gXNCa$react.useCallback)((selections)=>{
        if (!selections || !selections.length || !doAcceptGrameneSuggestion) return;
        const idxs = $bfd29d54a0f0e853$export$861100744513cc3(selections);
        if (!idxs.length) return;
        const total = $bfd29d54a0f0e853$export$cf7300886d7d9e1e(selections);
        doAcceptGrameneSuggestion({
            category: 'Selections',
            fq_field: 'fixed_1000__bin',
            fq_value: `(${$15504f5eba8e73bd$var$binIdxsToSolr(idxs)})`,
            name: `${selections.length} region${selections.length === 1 ? '' : 's'} (${total.toLocaleString()} genes)`
        });
        binsUiRef.current.clear();
    }, [
        doAcceptGrameneSuggestion
    ]);
    // Node-tooltip "Filter on" button: restrict the search to the clicked
    // taxon (taxonomy__ancestors covers every genome beneath it). Node ids are
    // the taxDist model ids (NCBI taxon ids, the Solr doc's _id), so look the
    // model up for its name and rank.
    const modelById = (0, $gXNCa$react.useMemo)(()=>{
        const byId = {};
        const walk = (n)=>{
            if (!n || !n.model) return;
            byId[String(n.model.id)] = n.model;
            (n.children || []).forEach(walk);
        };
        walk(grameneTaxDist);
        return byId;
    }, [
        grameneTaxDist
    ]);
    const nodeActions = (0, $gXNCa$react.useCallback)((treeNode)=>{
        const node = modelById[treeNode.id];
        if (!node || !doAcceptGrameneSuggestion) return [];
        const name = `${node.name} (${node.rank})`;
        return [
            {
                label: 'Add search filter',
                title: `Filter results to ${name}`,
                onClick: ()=>doAcceptGrameneSuggestion({
                        category: 'Taxonomy',
                        fq_field: 'taxonomy__ancestors',
                        fq_value: `${node.id}`,
                        name: name
                    })
            }
        ];
    }, [
        modelById,
        doAcceptGrameneSuggestion
    ]);
    const hostData = (0, $gXNCa$react.useMemo)(()=>{
        const facet = props.grameneSearch && props.grameneSearch.facet_counts && props.grameneSearch.facet_counts.facet_fields && props.grameneSearch.facet_counts.facet_fields.taxon_id;
        return {
            bins: $bfd29d54a0f0e853$export$390e10a52782f018(grameneTaxDist),
            geneCounts: adapter ? (0, $gXNCa$tbrowsecore.countsFromFacet)(adapter.tree, facet, 'nodeId') : null,
            binsUI: binsUiRef.current,
            onApplyBinsFilter: onApplyBinsFilter
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        grameneTaxDist,
        adapter,
        props.grameneSearch,
        onApplyBinsFilter
    ]);
    const showCompara = !!(configuration && configuration.hasOwnProperty('partialCompara'));
    // View state (tbrowse ViewState + the two controls) lives in the taxTreeView
    // bundle so a saved view round-trips it. Falls back to the built-in default
    // until the view is interacted with or restored.
    const { viewState: storedViewState, collapseEmpties: collapseEmpties = true, comparaOnly: comparaOnly = true } = props.taxTreeView || {};
    const setTaxTreeView = props.doSetTaxTreeView || (()=>{});
    const viewState = (0, $gXNCa$react.useMemo)(()=>storedViewState || $15504f5eba8e73bd$var$baseViewState(), [
        storedViewState
    ]);
    // Control-derived prune set: hide every leaf (genome) that isn't selected.
    // Pruning just the leaves is enough — internal nodes with no visible
    // descendants contribute no rows.
    const prunedNodeIds = (0, $gXNCa$react.useMemo)(()=>{
        if (!adapter) return [];
        const selected = $15504f5eba8e73bd$var$computeSelectedTaxa(props, adapter.tree.nodes, collapseEmpties, comparaOnly, showCompara);
        return (0, $gXNCa$tbrowsecore.leavesFailing)(adapter.tree, (leaf)=>Boolean(selected[String(leaf.taxonomyId)]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        adapter,
        collapseEmpties,
        comparaOnly,
        showCompara,
        props.grameneSearch,
        props.grameneGenomes,
        props.grameneMaps
    ]);
    // Effective (controlled) view state = user interactions + control-driven
    // pruning. The derived set REPLACES prunedNodeIds (this view has no user
    // prunes of its own; the snapshot strips the field for the same reason).
    // Memoised so the reference is stable across unrelated renders.
    const effectiveViewState = (0, $gXNCa$react.useMemo)(()=>({
            ...viewState,
            prunedNodeIds: prunedNodeIds
        }), [
        viewState,
        prunedNodeIds
    ]);
    // Initial pixel widths for the text columns (wide screens only). tbrowse
    // zone widths are fr-shares: rendered px = width / Σwidths × viewport. If we
    // make Σwidths equal the available width, 1fr ≈ 1px, so these fr values land
    // at the requested pixels while the bins zone flexes for the remainder. Set
    // once at mount; the zones stay resizable afterward.
    const wrapperRef = (0, $gXNCa$react.useRef)(null);
    const sizedRef = (0, $gXNCa$react.useRef)(false);
    (0, $gXNCa$react.useLayoutEffect)(()=>{
        // Skip when a stored/restored viewState already exists — its widths win.
        if (sizedRef.current || !adapter || storedViewState) return;
        const el = wrapperRef.current;
        if (!el || el.clientWidth <= 0 || window.innerWidth < 800) return;
        sizedRef.current = true;
        const widths = (0, $gXNCa$tbrowsecore.pixelWidthsToFr)({
            tree: 270,
            labels: 200,
            counts: 64
        }, el.clientWidth, 'bins', 160);
        const base = $15504f5eba8e73bd$var$baseViewState();
        setTaxTreeView({
            viewState: {
                ...base,
                zones: base.zones.map((z)=>({
                        ...z,
                        width: widths[z.id] ?? z.width
                    }))
            }
        });
    }, [
        adapter,
        storedViewState,
        setTaxTreeView
    ]);
    if (!adapter) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "results-vis",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("em", {
            children: "Loading taxonomy\u2026"
        })
    });
    // Compact, single-line buttons so they sit cleanly in the 32px tbrowse
    // toolbar row instead of wrapping and overflowing onto the zone headers.
    const actionBtnStyle = {
        whiteSpace: 'nowrap',
        lineHeight: 1.1,
        padding: '1px 8px',
        fontSize: 12
    };
    const headerActions = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("button", {
                type: "button",
                className: "btn btn-outline-primary btn-sm",
                style: actionBtnStyle,
                onClick: ()=>setTaxTreeView({
                        collapseEmpties: !collapseEmpties
                    }),
                children: [
                    collapseEmpties ? 'Expand' : 'Collapse',
                    " empty branches"
                ]
            }),
            showCompara && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("button", {
                type: "button",
                className: "btn btn-outline-success btn-sm",
                style: actionBtnStyle,
                onClick: ()=>setTaxTreeView({
                        comparaOnly: !comparaOnly
                    }),
                children: [
                    "Show ",
                    comparaOnly ? 'all genomes' : 'only genomes in gene trees'
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: "results-vis big-vis",
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
            ref: wrapperRef,
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$tbrowse.TBrowse, {
                tree: adapter.tree,
                taxonomy: adapter.taxonomy,
                hostData: hostData,
                zones: $15504f5eba8e73bd$var$ZONES,
                showHeader: true,
                rowHeight: 14,
                fontSize: 10,
                densityControls: true,
                autoHeight: true,
                defaultOpenSections: {
                    search: true,
                    zones: true
                },
                headerActions: headerActions,
                nodeActions: nodeActions,
                viewState: effectiveViewState,
                onViewStateChange: (next)=>setTaxTreeView({
                        viewState: next
                    })
            })
        })
    });
};
var $15504f5eba8e73bd$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)('selectConfiguration', 'selectGrameneTaxDist', 'selectGrameneGenomes', 'selectGrameneSearch', 'selectGrameneMaps', 'selectTaxTreeView', 'doAcceptGrameneSuggestion', 'doSetTaxTreeView', $15504f5eba8e73bd$var$TaxDistTbrowse);
// How many values to show per group before a "show N more" toggle. GRASSIUS has
// ~90 TF families, so an uncapped list would swamp the sidebar.
const $7d7b7dad5e71dfd3$var$INITIAL_VISIBLE = 12;
// Display label for a raw facet value: a per-group override (group.labels) if
// present, else underscores -> spaces. The raw value is still what gets filtered.
const $7d7b7dad5e71dfd3$var$labelFor = (group, value)=>group.labels && group.labels[value] || String(value).replace(/_/g, ' ');
// One collapsible group = one facet field. Values arrive pre-sorted by count
// (Solr default facet.sort). Clicking a count adds the filter.
const $7d7b7dad5e71dfd3$var$FacetGroup = ({ group: group, values: values, onAdd: onAdd })=>{
    const [open, setOpen] = (0, $gXNCa$react.useState)(true);
    const [showAll, setShowAll] = (0, $gXNCa$react.useState)(false);
    const shown = showAll ? values : values.slice(0, $7d7b7dad5e71dfd3$var$INITIAL_VISIBLE);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "facet-group",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "facet-group-header",
                onClick: ()=>setOpen(!open),
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        className: "facet-group-caret",
                        children: open ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsbs.BsChevronDown, {}) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsbs.BsChevronRight, {})
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        className: "facet-group-title",
                        children: group.heading
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        className: "facet-group-nvals",
                        children: values.length
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "facet-group-body",
                children: [
                    shown.map(({ value: value, count: count })=>{
                        const label = $7d7b7dad5e71dfd3$var$labelFor(group, value);
                        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                            className: "facet-row",
                            children: [
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                    className: "facet-val",
                                    title: label,
                                    children: label
                                }),
                                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                                    type: "button",
                                    className: "facet-count",
                                    title: `Add filter: ${group.heading} = ${label}`,
                                    onClick: ()=>onAdd(group.field, group.heading, value, label),
                                    children: count.toLocaleString()
                                })
                            ]
                        }, value);
                    }),
                    values.length > $7d7b7dad5e71dfd3$var$INITIAL_VISIBLE && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("button", {
                        type: "button",
                        className: "facet-more",
                        onClick: ()=>setShowAll(!showAll),
                        children: showAll ? 'show less' : `show ${values.length - $7d7b7dad5e71dfd3$var$INITIAL_VISIBLE} more`
                    })
                ]
            })
        ]
    });
};
const $7d7b7dad5e71dfd3$var$FacetsCmp = (props)=>{
    const { facetCounts: facetCounts, configuration: configuration, doToggleFacetCounts: doToggleFacetCounts, doAcceptGrameneSuggestion: doAcceptGrameneSuggestion } = props;
    const open = facetCounts.open;
    const status = facetCounts.status;
    const groups = facetCounts.groups || {};
    const containerClass = configuration && configuration.id === 'sorghum' ? 'sorghumbase-facet-container' : 'gramene-facet-container';
    const hasData = $6c52be7952d5ec43$export$f3878c70e70de19e.some((g)=>(groups[g.field] || []).length > 0);
    const onAdd = (field, heading, value, label)=>{
        doAcceptGrameneSuggestion({
            fq_field: field,
            fq_value: value,
            category: heading,
            name: label
        });
    };
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: containerClass,
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
            className: "sidebar-section",
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                    className: "sidebar-section-header",
                    onClick: ()=>doToggleFacetCounts(!open),
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                            children: "Refine"
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                            className: "sidebar-section-actions",
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                className: "sidebar-section-toggle",
                                children: open ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsbs.BsChevronDown, {}) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsbs.BsChevronRight, {})
                            })
                        })
                    ]
                }),
                open && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                    className: "sidebar-section-body",
                    children: [
                        !hasData && status === 'error' && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                            className: "facet-status",
                            children: "counts unavailable"
                        }),
                        !hasData && status !== 'error' && status !== 'ready' && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                            className: "facet-status",
                            children: "counting\u2026"
                        }),
                        !hasData && status === 'ready' && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                            className: "facet-status",
                            children: "no categories for this result set"
                        }),
                        hasData && $6c52be7952d5ec43$export$f3878c70e70de19e.map((g)=>{
                            // A field with nothing in this result set is dropped rather than
                            // rendered as an empty group — an all-zero heading is noise.
                            const values = groups[g.field] || [];
                            if (values.length === 0) return null;
                            return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($7d7b7dad5e71dfd3$var$FacetGroup, {
                                group: g,
                                values: values,
                                onAdd: onAdd
                            }, g.field);
                        })
                    ]
                })
            ]
        })
    });
};
const $7d7b7dad5e71dfd3$var$Facets = (0, $gXNCa$reduxbundlerreact.connect)('selectFacetCounts', 'selectConfiguration', 'doToggleFacetCounts', 'doAcceptGrameneSuggestion', $7d7b7dad5e71dfd3$var$FacetsCmp);
var $7d7b7dad5e71dfd3$export$2e2bcd8739ae039 = $7d7b7dad5e71dfd3$var$Facets;
// Sequences that aren't a placed chromosome. Excluded from the dropdown because
// an interval on them is not something a user can reason about positionally.
// Organelles (C, M, Mt, Pt, mitochondrion_genome) are deliberately kept — they
// are real, coordinate-addressable sequences.
const $909272efb41be16f$var$UNPLACED = /^(unanchored|u)$/i;
function $909272efb41be16f$export$ac97d17982e0cb21(grameneMaps, targetTaxonId) {
    const genomes = Object.values(grameneMaps || {}).filter((m)=>m && m._id && m.regions);
    const byLabel = (a, b)=>String(a.display_name || '').localeCompare(String(b.display_name || ''));
    const reference = genomes.filter((m)=>String(m.taxon_id) === String(targetTaxonId));
    const refIds = new Set(reference.map((m)=>m.taxon_id));
    const anchors = genomes.filter((m)=>m.is_anchor && !refIds.has(m.taxon_id)).sort(byLabel);
    const anchorIds = new Set(anchors.map((m)=>m.taxon_id));
    const rest = genomes.filter((m)=>!refIds.has(m.taxon_id) && !anchorIds.has(m.taxon_id)).sort(byLabel);
    return {
        reference: reference,
        anchors: anchors,
        rest: rest
    };
}
function $909272efb41be16f$export$94955a075dcb14b2(genome) {
    const regions = genome && genome.regions || {};
    const names = regions.names || [];
    const lengths = regions.lengths || [];
    return names.map((name, i)=>({
            name: name,
            length: lengths[i]
        })).filter((r)=>!$909272efb41be16f$var$UNPLACED.test(String(r.name)));
}
const $909272efb41be16f$export$4fa3dba3103266ea = ({ grameneMaps: grameneMaps, targetTaxonId: targetTaxonId, initial: initial, submitLabel: submitLabel, onSubmit: onSubmit, onCancel: onCancel })=>{
    const [taxonId, setTaxonId] = (0, $gXNCa$react.useState)('');
    const [region, setRegion] = (0, $gXNCa$react.useState)(initial ? String(initial.region) : '');
    const [start, setStart] = (0, $gXNCa$react.useState)(initial ? String(initial.start) : '');
    const [end, setEnd] = (0, $gXNCa$react.useState)(initial ? String(initial.end) : '');
    const { reference: reference, anchors: anchors, rest: rest } = (0, $gXNCa$react.useMemo)(()=>$909272efb41be16f$export$ac97d17982e0cb21(grameneMaps, targetTaxonId), [
        grameneMaps,
        targetTaxonId
    ]);
    // An edit starts on the filter's own genome; a new interval starts on the
    // site's reference. `initial.map` is an assembly accession, so find its genome.
    const initialTaxon = (0, $gXNCa$react.useMemo)(()=>{
        if (!initial) return '';
        const hit = Object.values(grameneMaps || {}).find((m)=>m && m._id === initial.map);
        return hit ? String(hit.taxon_id) : '';
    }, [
        initial,
        grameneMaps
    ]);
    const effectiveTaxon = taxonId || initialTaxon || reference[0] && String(reference[0].taxon_id) || '';
    const genome = effectiveTaxon ? (grameneMaps || {})[effectiveTaxon] : null;
    const chromosomes = (0, $gXNCa$react.useMemo)(()=>$909272efb41be16f$export$94955a075dcb14b2(genome), [
        genome
    ]);
    const effectiveRegion = region || chromosomes[0] && chromosomes[0].name || '';
    const chrLength = (chromosomes.find((c)=>String(c.name) === String(effectiveRegion)) || {}).length;
    const s = start === '' ? null : Number(start);
    const e = end === '' ? null : Number(end);
    // Validated against the assembly's own region lengths, so the message can name
    // the actual limit rather than just refusing.
    const error = (()=>{
        if (!genome || s === null || e === null) return null;
        if (!Number.isFinite(s) || !Number.isFinite(e)) return 'Positions must be numbers.';
        if (s < 1 || e < 1) return 'Positions start at 1.';
        if (s > e) return 'Start must not be greater than end.';
        if (chrLength && e > chrLength) return `${effectiveRegion} is ${chrLength.toLocaleString()} bp; end is beyond it.`;
        return null;
    })();
    const ready = !!genome && !!effectiveRegion && s !== null && e !== null && !error;
    const submit = ()=>{
        if (!ready) return;
        onSubmit({
            map: genome._id,
            mapLabel: genome.display_name || genome._id,
            region: effectiveRegion,
            start: s,
            end: e
        });
        if (!initial) {
            setStart('');
            setEnd('');
        }
    };
    const genomeOption = (m)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("option", {
            value: m.taxon_id,
            children: m.display_name || m.system_name
        }, m.taxon_id);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "gramene-interval-form",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Form.Select, {
                size: "sm",
                className: "mb-1",
                value: effectiveTaxon,
                onChange: (ev)=>{
                    setTaxonId(ev.target.value);
                    setRegion('');
                },
                children: [
                    reference.map(genomeOption),
                    anchors.length > 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("optgroup", {
                        label: "Reference genomes",
                        children: anchors.map(genomeOption)
                    }),
                    rest.length > 0 && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("optgroup", {
                        label: "Other genomes",
                        children: rest.map(genomeOption)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Form.Select, {
                size: "sm",
                className: "mb-1",
                value: effectiveRegion,
                onChange: (ev)=>setRegion(ev.target.value),
                children: chromosomes.map((c)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("option", {
                        value: c.name,
                        children: [
                            c.name,
                            c.length ? ` (${Math.round(c.length / 1e6)} Mb)` : ''
                        ]
                    }, c.name))
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "gramene-interval-range",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Form.Control, {
                        size: "sm",
                        type: "number",
                        min: "1",
                        placeholder: "start",
                        value: start,
                        onChange: (ev)=>setStart(ev.target.value)
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        className: "gramene-interval-dash",
                        children: "\u2013"
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Form.Control, {
                        size: "sm",
                        type: "number",
                        min: "1",
                        placeholder: "end",
                        value: end,
                        onChange: (ev)=>setEnd(ev.target.value),
                        onKeyDown: (ev)=>{
                            if (ev.key === 'Enter') submit();
                        }
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "gramene-interval-error",
                children: error
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "gramene-interval-actions",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                        size: "sm",
                        variant: "primary",
                        className: "gramene-interval-submit",
                        disabled: !ready,
                        onClick: submit,
                        children: submitLabel || 'Add interval'
                    }),
                    onCancel && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                        size: "sm",
                        variant: "link",
                        className: "gramene-interval-cancel",
                        onClick: onCancel,
                        children: "cancel"
                    })
                ]
            })
        ]
    });
};
/** The collapsible "Add genomic interval" entry at the foot of the Filters panel. */ const $909272efb41be16f$var$GenomicIntervalForm = ({ grameneMaps: grameneMaps, targetTaxonId: targetTaxonId, onAdd: onAdd })=>{
    const [open, setOpen] = (0, $gXNCa$react.useState)(false);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "gramene-interval",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "gramene-interval-toggle",
                onClick: ()=>setOpen(!open),
                children: [
                    open ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsbs.BsChevronDown, {}) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsbs.BsChevronRight, {}),
                    " Add genomic interval"
                ]
            }),
            open && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($909272efb41be16f$export$4fa3dba3103266ea, {
                grameneMaps: grameneMaps,
                targetTaxonId: targetTaxonId,
                onSubmit: onAdd
            })
        ]
    });
};
var $909272efb41be16f$export$2e2bcd8739ae039 = $909272efb41be16f$var$GenomicIntervalForm;
/**
 * Edit one filter leaf in place, with a form shaped to what that leaf actually is:
 * a genomic interval gets the genome/chromosome/start/end fields, a `[lo TO hi]`
 * range gets two number boxes, anything else gets its raw value.
 *
 * Groups are not editable — their only parameter is the operator, which the menu
 * already exposes as "convert to".
 *
 * The plain-value case is honest but limited: many leaves carry an opaque id (a
 * pathway number, an ontology term, a saved-search hash) whose replacement a user
 * has no way to know. It is offered because a typo in a gene name or a term is
 * worth fixing without deleting and starting over.
 */ const $91efc9c46e3775e3$var$FilterEditor = ({ node: node, grameneMaps: grameneMaps, targetTaxonId: targetTaxonId, onSave: onSave, onCancel: onCancel })=>{
    const kind = $af4441dd29af05df$export$a7f4fa59930e5088(node);
    const range = kind === 'range' ? $af4441dd29af05df$export$9ee0ceaa589fc567(node.fq_value) : null;
    const [lo, setLo] = (0, $gXNCa$react.useState)(range ? range.lo : '');
    const [hi, setHi] = (0, $gXNCa$react.useState)(range ? range.hi : '');
    const [value, setValue] = (0, $gXNCa$react.useState)(kind === 'value' ? String(node.fq_value ?? '') : '');
    if (!kind) return null;
    if (kind === 'interval') {
        const initial = $af4441dd29af05df$export$67920d3e3cb3f136(node.fq_value);
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
            className: "gramene-filter-editor",
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($909272efb41be16f$export$4fa3dba3103266ea, {
                grameneMaps: grameneMaps,
                targetTaxonId: targetTaxonId,
                initial: initial,
                submitLabel: "Save",
                onCancel: onCancel,
                onSubmit: (iv)=>onSave($af4441dd29af05df$export$634f7214da1b780a(iv), $af4441dd29af05df$export$535c09441f37845d(iv))
            })
        });
    }
    if (kind === 'range') {
        const ok = lo !== '' && hi !== '';
        const save = ()=>{
            if (ok) onSave($af4441dd29af05df$export$cd9b2ffd001c6d65(lo, hi), `${lo}-${hi}`);
        };
        return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
            className: "gramene-filter-editor",
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                    className: "gramene-interval-range",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Form.Control, {
                            size: "sm",
                            value: lo,
                            onChange: (e)=>setLo(e.target.value),
                            placeholder: "from"
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                            className: "gramene-interval-dash",
                            children: "\u2013"
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Form.Control, {
                            size: "sm",
                            value: hi,
                            onChange: (e)=>setHi(e.target.value),
                            placeholder: "to",
                            onKeyDown: (e)=>{
                                if (e.key === 'Enter') save();
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                    className: "gramene-interval-actions",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                            size: "sm",
                            variant: "primary",
                            className: "gramene-interval-submit",
                            disabled: !ok,
                            onClick: save,
                            children: "Save"
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                            size: "sm",
                            variant: "link",
                            className: "gramene-interval-cancel",
                            onClick: onCancel,
                            children: "cancel"
                        })
                    ]
                })
            ]
        });
    }
    const ok = String(value).trim() !== '';
    // Keep the node's own label in step with its value, unless the label was
    // something other than the value to begin with (a suggestion's display name),
    // in which case leave it alone rather than overwriting it with a raw id.
    const save = ()=>{
        if (!ok) return;
        const v = String(value).trim();
        const nameFollowedValue = String(node.name ?? '') === String(node.fq_value ?? '');
        onSave(v, nameFollowedValue ? v : undefined);
    };
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "gramene-filter-editor",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Form.Control, {
                size: "sm",
                value: value,
                onChange: (e)=>setValue(e.target.value),
                onKeyDown: (e)=>{
                    if (e.key === 'Enter') save();
                }
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "gramene-interval-actions",
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                        size: "sm",
                        variant: "primary",
                        className: "gramene-interval-submit",
                        disabled: !ok,
                        onClick: save,
                        children: "Save"
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                        size: "sm",
                        variant: "link",
                        className: "gramene-interval-cancel",
                        onClick: onCancel,
                        children: "cancel"
                    })
                ]
            })
        ]
    });
};
var $91efc9c46e3775e3$export$2e2bcd8739ae039 = $91efc9c46e3775e3$var$FilterEditor;
// "Save this view" UI — sits inside the Auth sidebar panel.
//
// Sign-in-gated by Auth.js (we only mount this when `user` is truthy). Opens
// a modal with label + description + visibility toggle; on save, swaps to a
// post-save state that shows the shareable URL with a copy button.
//
// Talks to the savedViews bundle. The snapshot itself is built inside
// doSaveView via selectViewSnapshot — this component doesn't know or care
// what the snapshot looks like.
const $e63a3bee79bd1c7a$var$SaveViewButtonCmp = ({ user: user, savedViews: savedViews, doSaveView: doSaveView, doResetSavedViewState: doResetSavedViewState })=>{
    const [showModal, setShowModal] = (0, $gXNCa$react.useState)(false);
    const [label, setLabel] = (0, $gXNCa$react.useState)('');
    const [description, setDescription] = (0, $gXNCa$react.useState)('');
    const [isPublic, setIsPublic] = (0, $gXNCa$react.useState)(false);
    const [shareUrl, setShareUrl] = (0, $gXNCa$react.useState)(null);
    const [copied, setCopied] = (0, $gXNCa$react.useState)(false);
    const reset = (0, $gXNCa$react.useCallback)(()=>{
        setLabel('');
        setDescription('');
        setIsPublic(false);
        setShareUrl(null);
        setCopied(false);
        doResetSavedViewState();
    }, [
        doResetSavedViewState
    ]);
    const handleOpen = ()=>{
        reset();
        setShowModal(true);
    };
    const handleClose = ()=>{
        setShowModal(false);
        reset();
    };
    const handleSave = async (e)=>{
        e.preventDefault();
        if (!label.trim()) return;
        try {
            const { shareUrl: shareUrl } = await doSaveView({
                user: user,
                label: label.trim(),
                description: description.trim(),
                isPublic: isPublic
            });
            setShareUrl(shareUrl);
        } catch (_) {
        // savedViews.saveError is already set; modal renders it
        }
    };
    const handleCopy = async ()=>{
        if (!shareUrl) return;
        try {
            await navigator.clipboard.writeText(shareUrl);
            setCopied(true);
            setTimeout(()=>setCopied(false), 1500);
        } catch (_) {}
    };
    const saving = savedViews && savedViews.saving;
    const saveError = savedViews && savedViews.saveError;
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                size: "sm",
                variant: "outline-primary",
                style: {
                    marginTop: 8
                },
                onClick: handleOpen,
                title: "Save the current filters, views, and detail tabs as a shareable link",
                children: "Save this view"
            }),
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Modal, {
                show: showModal,
                onHide: handleClose,
                centered: true,
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Modal.Header, {
                        closeButton: true,
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Modal.Title, {
                            children: shareUrl ? 'View saved' : 'Save this view'
                        })
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Modal.Body, {
                        children: [
                            !shareUrl && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Form, {
                                onSubmit: handleSave,
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Form.Group, {
                                        className: "mb-3",
                                        children: [
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Form.Label, {
                                                children: "Name"
                                            }),
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Form.Control, {
                                                autoFocus: true,
                                                type: "text",
                                                placeholder: "e.g. TAIR loci with TF binding sites",
                                                value: label,
                                                onChange: (e)=>setLabel(e.target.value),
                                                disabled: saving,
                                                required: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Form.Group, {
                                        className: "mb-3",
                                        children: [
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Form.Label, {
                                                children: "Description (optional)"
                                            }),
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Form.Control, {
                                                as: "textarea",
                                                rows: 2,
                                                value: description,
                                                onChange: (e)=>setDescription(e.target.value),
                                                disabled: saving
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Form.Group, {
                                        className: "mb-3",
                                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Form.Check, {
                                            type: "switch",
                                            id: "save-view-public",
                                            label: "Make this view public (visible to anyone with the link)",
                                            checked: isPublic,
                                            onChange: (e)=>setIsPublic(e.target.checked),
                                            disabled: saving
                                        })
                                    }),
                                    saveError && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Alert, {
                                        variant: "danger",
                                        children: saveError
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                                        className: "d-flex justify-content-end gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                                                variant: "secondary",
                                                onClick: handleClose,
                                                disabled: saving,
                                                children: "Cancel"
                                            }),
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                                                type: "submit",
                                                variant: "primary",
                                                disabled: saving || !label.trim(),
                                                children: saving ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Spinner, {
                                                            as: "span",
                                                            size: "sm",
                                                            animation: "border"
                                                        }),
                                                        " Saving\u2026"
                                                    ]
                                                }) : 'Save'
                                            })
                                        ]
                                    })
                                ]
                            }),
                            shareUrl && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("p", {
                                        children: "Share this link to let others open the same search and detail state:"
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.InputGroup, {
                                        children: [
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Form.Control, {
                                                type: "text",
                                                value: shareUrl,
                                                readOnly: true,
                                                onFocus: (e)=>e.target.select()
                                            }),
                                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                                                variant: copied ? 'success' : 'outline-secondary',
                                                onClick: handleCopy,
                                                children: copied ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsbs.BsCheck2, {}),
                                                        " Copied"
                                                    ]
                                                }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsbs.BsClipboard, {}),
                                                        " Copy"
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                                        className: "mt-3 d-flex justify-content-end",
                                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                                            variant: "primary",
                                            onClick: handleClose,
                                            children: "Done"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $e63a3bee79bd1c7a$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)('selectSavedViews', 'doSaveView', 'doResetSavedViewState', $e63a3bee79bd1c7a$var$SaveViewButtonCmp);
const $c5d403787de8b05f$var$provider = new $gXNCa$firebaseauth.GoogleAuthProvider();
const $c5d403787de8b05f$var$Auth = (props)=>{
    const firebaseConfig = props.configuration && props.configuration.firebaseConfig;
    const auth = (0, $gXNCa$react.useMemo)(()=>{
        const app = $047461923b1badda$export$54387eca9e368edc(firebaseConfig);
        return app ? (0, $gXNCa$firebaseauth.getAuth)(app) : null;
    }, [
        firebaseConfig
    ]);
    const [user, setUser] = (0, $gXNCa$react.useState)(null);
    const [open, setOpen] = (0, $gXNCa$react.useState)(true);
    // Subscribe once, unsubscribe on unmount. On each auth-state emission,
    // also poke the shared-view boot path so a `?view=<hash>` for a private
    // view gets retried with the now-available Bearer token. bootViewFromUrl
    // no-ops when the param isn't present, so this is cheap.
    (0, $gXNCa$react.useEffect)(()=>{
        if (!auth) return undefined;
        const unsub = (0, $gXNCa$firebaseauth.onAuthStateChanged)(auth, (u)=>{
            setUser(u);
            props.doBootSharedView({
                user: u
            });
        });
        return unsub;
    }, [
        auth
    ]);
    if (!auth) return null;
    function handleLogin() {
        (0, $gXNCa$firebaseauth.signInWithPopup)(auth, $c5d403787de8b05f$var$provider).then((result)=>{
            setUser(result.user);
        }).catch((err)=>{
            console.log(err);
        });
    }
    function handleLogout() {
        (0, $gXNCa$firebaseauth.signOut)(auth).then(()=>{
            setUser(null);
        }).catch((err)=>{
            console.log(err);
        });
    }
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: props.configuration.id === 'sorghum' ? 'sorghumbase-auth-container' : 'gramene-auth-container',
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
            className: "sidebar-section",
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                    className: "sidebar-section-header",
                    onClick: ()=>setOpen(!open),
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                            children: "Account"
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                            className: "sidebar-section-actions",
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                className: "sidebar-section-toggle",
                                children: open ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsbs.BsChevronDown, {}) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsbs.BsChevronRight, {})
                            })
                        })
                    ]
                }),
                open && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                    className: "sidebar-section-body",
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                            children: user ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                                size: "sm",
                                variant: "success",
                                onClick: handleLogout,
                                children: user.displayName
                            }) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Button, {
                                size: "sm",
                                variant: "success",
                                onClick: handleLogin,
                                children: "Login"
                            })
                        }),
                        user && user.uid && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($e63a3bee79bd1c7a$export$2e2bcd8739ae039, {
                                user: user
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $c5d403787de8b05f$export$2e2bcd8739ae039 = (0, $gXNCa$reduxbundlerreact.connect)('selectConfiguration', 'doBootSharedView', $c5d403787de8b05f$var$Auth);
const $693dd8c7a5607c3a$var$CollapsibleSection = ({ title: title, defaultOpen: defaultOpen = true, extra: extra, children: children })=>{
    const [open, setOpen] = (0, $gXNCa$react.useState)(defaultOpen);
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: "sidebar-section",
        children: [
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                className: "sidebar-section-header",
                onClick: ()=>setOpen(!open),
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                        className: "sidebar-section-actions",
                        children: [
                            extra,
                            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                                className: "sidebar-section-toggle",
                                children: open ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsbs.BsChevronDown, {}) : /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsbs.BsChevronRight, {})
                            })
                        ]
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                className: "sidebar-section-body",
                children: children
            })
        ]
    });
};
const $693dd8c7a5607c3a$var$inventory = {
    help: $b36244140732570a$export$2e2bcd8739ae039,
    list: $6c5c4f90059875bf$export$2e2bcd8739ae039,
    taxonomy: $a67cad486021eb32$export$2e2bcd8739ae039,
    taxTree: $15504f5eba8e73bd$export$2e2bcd8739ae039,
    attribs: $67bf5a43401bffdc$export$2e2bcd8739ae039,
    expression: $261baeb81c4d4d8a$export$2e2bcd8739ae039,
    exprViz: $1fd2507769d5bd00$export$2e2bcd8739ae039,
    attrTable: $8f8e530286a37ce9$export$2e2bcd8739ae039,
    ontologyEnrichment: $597fe213417ee6ca$export$2e2bcd8739ae039,
    userLists: $0f50f369018a42ef$export$2e2bcd8739ae039,
    export: $37b3bb0145d266b0$export$2e2bcd8739ae039
};
const $693dd8c7a5607c3a$var$StatusCmp = (props)=>{
    let content = props.grameneFiltersStatus;
    // if (props.grameneFiltersStatus === 'init') {
    //   props.doClearGrameneFilters();
    // }
    if (props.grameneFiltersStatus === 'ready') {
        let tally = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
            children: "Ready"
        });
        if (props.grameneSearch) {
            let genes = props.grameneSearch.response.numFound;
            let genomes = props.grameneSearch.facet_counts.facet_fields.taxon_id.length / 2;
            tally = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                        children: genes
                    }),
                    " genes in ",
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("b", {
                        children: genomes
                    }),
                    " genomes"
                ]
            });
        }
        const popover = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Popover, {
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Popover.Header, {
                    as: "h3",
                    children: "Genomes Filter"
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Popover.Body, {
                    children: [
                        "Searching ",
                        props.activeGenomeCount,
                        " genomes"
                    ]
                })
            ]
        });
        content = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
            children: [
                tally,
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.OverlayTrigger, {
                    placement: "auto",
                    overlay: popover,
                    children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                        style: {
                            float: 'right',
                            cursor: 'pointer'
                        },
                        onClick: props.doShowGrameneGenomes,
                        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsbs.BsGearFill, {})
                    })
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($76e15aea9236bd47$export$2e2bcd8739ae039, {})
            ]
        });
    }
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        style: {
            padding: '5px',
            color: 'cornsilk',
            fontSize: 'small'
        },
        children: content
    });
};
const $693dd8c7a5607c3a$export$96e9906d6d93a972 = (0, $gXNCa$reduxbundlerreact.connect)('selectGrameneSearch', 'selectGrameneFiltersStatus', 'selectActiveGenomeCount', 'doShowGrameneGenomes', 'doClearGrameneFilters', $693dd8c7a5607c3a$var$StatusCmp);
const $693dd8c7a5607c3a$var$handleClick = (e, moveCopyMode, showMarked, node, actions)=>{
    if (!e) e = window.event;
    e.cancelBubble = true;
    if (e.stopPropagation) e.stopPropagation();
    if (showMarked && moveCopyMode) {
        if (node.marked) actions.selectTarget(node);
        else actions.unmarkTargets();
    }
    console.log(node, showMarked);
};
function $693dd8c7a5607c3a$var$logAction(action) {
    $parcel$interopDefault($gXNCa$reactga4).event({
        category: 'Search',
        action: action
    });
}
const $693dd8c7a5607c3a$var$Filter = ({ node: node, moveCopyMode: moveCopyMode, showMarked: showMarked, actions: actions })=>{
    const [editing, setEditing] = (0, $gXNCa$react.useState)(false);
    let classes = 'gramene-filter gramene-filter';
    if (node.operation) classes = `${classes}-${$af4441dd29af05df$export$c8b6102be216752a(node.operation)}`;
    // An expansion decorates whatever node it sits on, leaf or group — same as negate.
    const expType = $af4441dd29af05df$export$a6dc3fef1cecdf28(node);
    if (expType) classes = `${classes} gramene-filter-EXPAND gramene-filter-EXPAND-${$af4441dd29af05df$export$c8b6102be216752a(expType)}`;
    if (node.negate) classes = `${classes} gramene-filter-NOT`;
    if (showMarked && node.marked) classes = `${classes} gramene-filter-marked`;
    let content = '';
    let menu = '';
    let children = [];
    if (node.showMenu) {
        let key = 1;
        let menuItems = [];
        if (node.hasOwnProperty('operation')) menuItems.push(/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("li", {
            onClick: ()=>{
                $693dd8c7a5607c3a$var$logAction(`Change to ${node.operation}`);
                actions.changeOperation(node);
            },
            children: [
                "convert to ",
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("i", {
                    children: node.operation === 'AND' ? 'OR' : 'AND'
                })
            ]
        }, key++));
        // A node carries at most one expansion, so the types are radios rather than
        // separate commands. Any node can carry one, leaf or group — attaching it to a
        // group means "expand whatever this group matches".
        menuItems.push(/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("li", {
            className: "gramene-filter-menu-label",
            children: "expand search"
        }, key++));
        Object.keys($af4441dd29af05df$export$da3188ffd2da2525).forEach((type)=>{
            const checked = expType === type;
            menuItems.push(/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("li", {
                className: "gramene-filter-menu-radio",
                onClick: ()=>{
                    // Re-picking the active type clears it — the only way to remove an
                    // expansion from the root, which has no `delete`.
                    if (checked) {
                        $693dd8c7a5607c3a$var$logAction(`Remove expansion`);
                        actions.removeExpansion(node);
                    } else {
                        $693dd8c7a5607c3a$var$logAction(`Expand by ${type}`);
                        actions.expand(node, type);
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("input", {
                        type: "radio",
                        readOnly: true,
                        checked: checked,
                        onChange: ()=>{},
                        name: `gramene-expand-${node.leftIdx}`
                    }),
                    $af4441dd29af05df$export$da3188ffd2da2525[type].label
                ]
            }, key++));
        });
        if ($af4441dd29af05df$export$a7f4fa59930e5088(node)) menuItems.push(/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("li", {
            onClick: ()=>{
                $693dd8c7a5607c3a$var$logAction(`Edit filter`);
                actions.toggleMenu(node);
                setEditing(true);
            },
            children: "edit"
        }, key++));
        if (node.leftIdx > 0) {
            menuItems.push(/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("li", {
                onClick: ()=>{
                    $693dd8c7a5607c3a$var$logAction(`Delete filter`);
                    actions.deleteNode(node);
                },
                children: "delete"
            }, key++));
            menuItems.push(/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("li", {
                onClick: ()=>{
                    $693dd8c7a5607c3a$var$logAction(`Move filter`);
                    actions.markTargets(node, 'move');
                },
                children: [
                    "move",
                    node.isSource && ' select destination'
                ]
            }, key++));
            menuItems.push(/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("li", {
                onClick: ()=>{
                    $693dd8c7a5607c3a$var$logAction(`Copy filter`);
                    actions.markTargets(node, 'copy');
                },
                children: [
                    "copy",
                    node.isSource && ' select destination'
                ]
            }, key++));
        }
        menuItems.push(/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("li", {
            onClick: ()=>{
                $693dd8c7a5607c3a$var$logAction(`Negate filter`);
                actions.negate(node);
            },
            children: "negate"
        }, key++));
        menu = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
            className: "gramene-filter-menu",
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("ul", {
                children: menuItems
            })
        });
    }
    let warning;
    if (node.warning) {
        const popover = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactbootstrap.Popover, {
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Popover.Header, {
                    as: "h3",
                    children: "Warning"
                }),
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.Popover.Body, {
                    children: node.warning
                })
            ]
        });
        warning = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reactbootstrap.OverlayTrigger, {
            placement: "auto",
            overlay: popover,
            children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                style: {
                    float: 'right',
                    color: 'red',
                    cursor: 'pointer'
                },
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsio5.IoAlertCircle, {})
            })
        });
    }
    // Shown above the node's own label, since the expansion applies to whatever that
    // node resolves to rather than replacing it.
    const expBadge = expType ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
        className: "gramene-filter-expansion",
        onClick: ()=>actions.toggleMenu(node),
        children: $af4441dd29af05df$export$90cfa1f3fbcb6430(node)
    }) : null;
    if (node.operation) {
        children = node.children.map((child, idx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($693dd8c7a5607c3a$var$Filter, {
                moveCopyMode: moveCopyMode,
                node: child,
                showMarked: showMarked,
                actions: actions
            }, idx));
        content = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
            children: [
                expBadge,
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                    className: "gramene-filter-operation",
                    onClick: ()=>actions.toggleMenu(node),
                    children: node.operation
                }),
                warning
            ]
        });
    } else content = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($gXNCa$reactjsxruntime.Fragment, {
        children: [
            expBadge,
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("span", {
                className: "gramene-filter-text",
                onClick: ()=>actions.toggleMenu(node),
                children: [
                    node.category,
                    " |\xa0",
                    node.name
                ]
            })
        ]
    });
    const editor = editing ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($91efc9c46e3775e3$export$2e2bcd8739ae039, {
        node: node,
        grameneMaps: actions.grameneMaps,
        targetTaxonId: actions.targetTaxonId,
        onCancel: ()=>setEditing(false),
        onSave: (fq_value, name)=>{
            setEditing(false);
            actions.editNode(node, fq_value, name);
        }
    }) : null;
    return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
        className: classes,
        onClick: (e)=>$693dd8c7a5607c3a$var$handleClick(e, moveCopyMode, showMarked, node, actions),
        children: [
            content,
            menu,
            editor,
            children
        ]
    }, node.leftIdx);
};
const $693dd8c7a5607c3a$var$FiltersCmp = (props)=>{
    const actions = {
        negate: props.doNegateGrameneFilter,
        deleteNode: props.doDeleteGrameneFilter,
        changeOperation: props.doChangeGrameneFilterOperation,
        expand: props.doExpandGrameneFilter,
        removeExpansion: props.doRemoveGrameneExpansion,
        selectTarget: props.doMoveOrCopyGrameneFilter,
        markTargets: props.doMarkGrameneFilterTargets,
        unmarkTargets: props.doUnmarkGrameneFilterTargets,
        toggleMenu: props.doToggleGrameneFilterMenu,
        editNode: props.doEditGrameneFilter,
        // Carried alongside the actions so every nested Filter can reach them without
        // threading two more props through the recursion.
        grameneMaps: props.grameneMaps,
        targetTaxonId: props.targetTaxonId
    };
    const intervalForm = /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($909272efb41be16f$export$2e2bcd8739ae039, {
        grameneMaps: props.grameneMaps,
        targetTaxonId: props.targetTaxonId,
        onAdd: props.doAddGrameneInterval
    });
    const containerClass = props.configuration.id === 'sorghum' ? 'sorghumbase-filter-container' : 'gramene-filter-container';
    if (props.grameneFilters.rightIdx > 1) return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: containerClass,
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($693dd8c7a5607c3a$var$CollapsibleSection, {
            title: "Filters",
            extra: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                style: {
                    cursor: 'pointer',
                    marginRight: '0.5rem'
                },
                onClick: (e)=>{
                    e.stopPropagation();
                    props.doClearGrameneFilters();
                },
                children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($gXNCa$reacticonsbs.BsTrash, {})
            }),
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($693dd8c7a5607c3a$var$Filter, {
                    node: props.grameneFilters,
                    moveCopyMode: props.grameneFilters.moveCopyMode,
                    showMarked: props.grameneFilters.showMarked,
                    actions: actions
                }),
                intervalForm
            ]
        })
    });
    else return /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: containerClass,
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)($693dd8c7a5607c3a$var$CollapsibleSection, {
            title: "Filters",
            children: [
                /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                    className: "gramene-filter gramene-filter-AND",
                    children: "No filters defined"
                }),
                intervalForm
            ]
        })
    });
};
const $693dd8c7a5607c3a$export$92a576f896a9bf72 = (0, $gXNCa$reduxbundlerreact.connect)('selectGrameneFilters', 'selectConfiguration', 'doNegateGrameneFilter', 'doDeleteGrameneFilter', 'doChangeGrameneFilterOperation', 'doExpandGrameneFilter', 'doRemoveGrameneExpansion', 'doMoveOrCopyGrameneFilter', 'doMarkGrameneFilterTargets', 'doUnmarkGrameneFilterTargets', 'doToggleGrameneFilterMenu', 'selectGrameneMaps', 'selectTargetTaxonId', 'doAddGrameneInterval', 'doEditGrameneFilter', 'doClearGrameneFilters', $693dd8c7a5607c3a$var$FiltersCmp);
const $693dd8c7a5607c3a$var$ResultsCmp = (props)=>{
    let activeViews = props.grameneViews.options;
    return props.grameneFilters.rightIdx > 0 ? /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        children: activeViews.map((v, idx)=>{
            let p = Object.assign({}, props);
            const divRef = (0, $gXNCa$react.useRef)(null);
            (0, $gXNCa$react.useEffect)(()=>{
                if (v.shouldScroll) {
                    const el = divRef.current;
                    if (el) {
                        // Scroll ONLY the results' own scroll container to this view. The
                        // sidebar and results scroll independently in the sorghumbase app
                        // shell, and el.scrollIntoView can walk every scrollable ancestor
                        // (nudging the sidebar too), so instead find the results pane and
                        // scroll just that. Fall back to the window when the results
                        // aren't in a dedicated scroll pane (other layouts / mobile).
                        let pane = el.parentElement;
                        while(pane){
                            const oy = window.getComputedStyle(pane).overflowY;
                            if ((oy === 'auto' || oy === 'scroll') && pane.scrollHeight > pane.clientHeight) break;
                            pane = pane.parentElement;
                        }
                        if (pane) {
                            const top = el.getBoundingClientRect().top - pane.getBoundingClientRect().top + pane.scrollTop;
                            pane.scrollTo({
                                top: top,
                                behavior: 'smooth'
                            });
                        } else window.scrollTo({
                            top: el.getBoundingClientRect().top + window.scrollY,
                            behavior: 'smooth'
                        });
                    }
                    props.doCancelShouldScroll();
                }
            }, [
                v.shouldScroll
            ]);
            return(// results column without relying on its position or header text —
            // e.g. to anchor a product tour, or mount extra content into a view.
            /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                ref: divRef,
                "data-tour-view": v.id,
                children: [
                    v.show === 'on' && /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
                        style: {
                            borderTopWidth: 'medium'
                        },
                        className: "gramene-view-header",
                        children: v.name
                    }),
                    v.show === 'on' && $parcel$interopDefault($gXNCa$react).createElement($693dd8c7a5607c3a$var$inventory[v.id], p)
                ]
            }, idx));
        })
    }) : null;
};
const $693dd8c7a5607c3a$export$4a34de49b46a2bfa = (0, $gXNCa$reduxbundlerreact.connect)('selectGrameneFilters', 'selectGrameneViews', 'doCancelShouldScroll', $693dd8c7a5607c3a$var$ResultsCmp);
const $693dd8c7a5607c3a$var$ViewsCmp = (props)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("div", {
        className: 'gramene-view-container',
        children: /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($693dd8c7a5607c3a$var$CollapsibleSection, {
            title: "Views",
            children: props.grameneViews.options.filter((view)=>view.show !== 'disabled').map((view, idx)=>/*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsxs)("div", {
                    style: {
                        textWrap: 'nowrap'
                    },
                    children: [
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)($parcel$interopDefault($gXNCa$reactswitch), {
                            onChange: ()=>props.doToggleGrameneView(view.id),
                            checked: view.show === 'on',
                            height: 18,
                            width: 30,
                            handleDiameter: 16,
                            checkedIcon: false,
                            uncheckedIcon: false
                        }),
                        /*#__PURE__*/ (0, $gXNCa$reactjsxruntime.jsx)("span", {
                            className: `gramene-view-span-${view.show}`,
                            onClick: (e)=>{
                                props.dontToggleGrameneView(view.id);
                            },
                            children: view.name
                        })
                    ]
                }, idx))
        })
    });
const $693dd8c7a5607c3a$export$5cb791131c501f6a = (0, $gXNCa$reduxbundlerreact.connect)('selectGrameneViews', 'doToggleGrameneView', 'dontToggleGrameneView', $693dd8c7a5607c3a$var$ViewsCmp);

},{"e7d0a292a5bfa0b1":"9d205","c9f03de0ba569521":"gonF6","e89d20b5872a5a34":"bmhQu","978c1038e90119ae":"a9QVF","1e75c8e4bd80350f":"27rAe","8c670c77c3902b26":"dWbzV","fd2565c03c812ea2":"cSUeE","ddc0c789689ec264":"bm77J","f23e227c2beb644b":"L2GyB","243990e7f07597f2":"cVAov","afe997b249302bb6":"eBvDB","7e37e406131e2b9":"fZjTS","d05cd4993db952e4":"6nfNA","98ada56427b39cb7":"gRAOl","c7be13865a2f0df1":"cl12L","bbfa21ab9725e386":"jBmZO","d5521c75564d5ef2":"13dwh","87384c95eacbeaed":"68aAv","628fc015b8c107d2":"fL51W","28ac795b361f60f5":"3QrVY","4b819e34098f2807":"7CN5B","99e3139b84c8afee":"3x9TR","59e75aa0ecc3095d":"bWOsi","e3f2a74732da5a10":"304K0","58bed9b292821059":"82aNB","6877b21f861aabf5":"dnkT0","cd587019a97f11ee":"ahx5Y","ebdae9af3c3da873":"4uLxM","b09a191fa2cc6513":"joon0","94034ba8b5c45889":"kv7CP","70c30999c7df9690":"03Rza","9b11fb3ef0bc37b4":"RY1q0","c4b0ab6bd95f1b3a":"lbntV","6d94f96e8ccee4a":"3pd0L","8e26fd7e2a676f75":"ac31b","e193ca30c5e93397":"dXOCa","33855a8c778c869":"ffqsH","b556cdc66608631":"g2Na9","e440e8344596123b":"dZ6yw","30a913ab73bfc419":"84aZA"}],"9d205":[function() {},{}],"27rAe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AgGridReact", ()=>AgGridReact);
parcelHelpers.export(exports, "ChangeDetectionStrategyType", ()=>ChangeDetectionStrategyType);
parcelHelpers.export(exports, "getInstance", ()=>getInstance);
parcelHelpers.export(exports, "useGridCellEditor", ()=>useGridCellEditor);
parcelHelpers.export(exports, "useGridDate", ()=>useGridDate);
parcelHelpers.export(exports, "useGridFilter", ()=>useGridFilter);
parcelHelpers.export(exports, "useGridFloatingFilter", ()=>useGridFloatingFilter);
parcelHelpers.export(exports, "useGridMenuItem", ()=>useGridMenuItem);
parcelHelpers.export(exports, "warnReactiveCustomComponents", ()=>warnReactiveCustomComponents);
// packages/ag-grid-react/src/agGridReact.tsx
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// packages/ag-grid-react/src/reactUi/agGridReactUi.tsx
var _agGridCommunity = require("ag-grid-community");
// packages/ag-grid-react/src/shared/reactComponent.ts
var _reactDom = require("react-dom");
var _server = require("react-dom/server");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var __spreadProps = (a, b)=>__defProps(a, __getOwnPropDescs(b));
var CustomContext = (0, _react.createContext)({
    setMethods: ()=>{}
});
// packages/ag-grid-react/src/reactUi/customComp/customWrapperComp.tsx
var CustomWrapperComp = (params)=>{
    const { initialProps, addUpdateCallback, CustomComponentClass, setMethods } = params;
    const [props, setProps] = (0, _react.useState)(initialProps);
    (0, _react.useEffect)(()=>{
        addUpdateCallback((newProps)=>setProps(newProps));
    }, []);
    return /* @__PURE__ */ (0, _reactDefault.default).createElement(CustomContext.Provider, {
        value: {
            setMethods
        }
    }, /* @__PURE__ */ (0, _reactDefault.default).createElement(CustomComponentClass, __spreadValues({}, props)));
};
var customWrapperComp_default = (0, _react.memo)(CustomWrapperComp);
// packages/ag-grid-react/src/shared/keyGenerator.ts
var counter = 0;
function generateNewKey() {
    return `agPortalKey_${++counter}`;
}
var ReactComponent = class {
    constructor(reactComponent, portalManager, componentType, suppressFallbackMethods){
        this.portal = null;
        this.oldPortal = null;
        this.reactComponent = reactComponent;
        this.portalManager = portalManager;
        this.componentType = componentType;
        this.suppressFallbackMethods = !!suppressFallbackMethods;
        this.statelessComponent = this.isStateless(this.reactComponent);
        this.key = generateNewKey();
        this.portalKey = generateNewKey();
        this.instanceCreated = this.isStatelessComponent() ? (0, _agGridCommunity.AgPromise).resolve(false) : new (0, _agGridCommunity.AgPromise)((resolve)=>{
            this.resolveInstanceCreated = resolve;
        });
    }
    getGui() {
        return this.eParentElement;
    }
    /** `getGui()` returns the parent element. This returns the actual root element. */ getRootElement() {
        const firstChild = this.eParentElement.firstChild;
        return firstChild;
    }
    destroy() {
        if (this.componentInstance && typeof this.componentInstance.destroy == "function") this.componentInstance.destroy();
        return this.portalManager.destroyPortal(this.portal);
    }
    createParentElement(params) {
        const componentWrappingElement = this.portalManager.getComponentWrappingElement();
        const eParentElement = document.createElement(componentWrappingElement || "div");
        eParentElement.classList.add("ag-react-container");
        params.reactContainer = eParentElement;
        return eParentElement;
    }
    addParentContainerStyleAndClasses() {
        if (!this.componentInstance) return;
        if (this.componentInstance.getReactContainerStyle && this.componentInstance.getReactContainerStyle()) {
            (0, _agGridCommunity._).warnOnce('Since v31.1 "getReactContainerStyle" is deprecated. Apply styling directly to ".ag-react-container" if needed.');
            Object.assign(this.eParentElement.style, this.componentInstance.getReactContainerStyle());
        }
        if (this.componentInstance.getReactContainerClasses && this.componentInstance.getReactContainerClasses()) {
            (0, _agGridCommunity._).warnOnce('Since v31.1 "getReactContainerClasses" is deprecated. Apply styling directly to ".ag-react-container" if needed.');
            const parentContainerClasses = this.componentInstance.getReactContainerClasses();
            parentContainerClasses.forEach((className)=>this.eParentElement.classList.add(className));
        }
    }
    statelessComponentRendered() {
        return this.eParentElement.childElementCount > 0 || this.eParentElement.childNodes.length > 0;
    }
    getFrameworkComponentInstance() {
        return this.componentInstance;
    }
    isStatelessComponent() {
        return this.statelessComponent;
    }
    getReactComponentName() {
        return this.reactComponent.name;
    }
    getMemoType() {
        return this.hasSymbol() ? Symbol.for("react.memo") : 60115;
    }
    hasSymbol() {
        return typeof Symbol === "function" && Symbol.for;
    }
    isStateless(Component3) {
        return typeof Component3 === "function" && !(Component3.prototype && Component3.prototype.isReactComponent) || typeof Component3 === "object" && Component3.$$typeof === this.getMemoType();
    }
    hasMethod(name) {
        const frameworkComponentInstance = this.getFrameworkComponentInstance();
        return !!frameworkComponentInstance && frameworkComponentInstance[name] != null || this.fallbackMethodAvailable(name);
    }
    callMethod(name, args) {
        const frameworkComponentInstance = this.getFrameworkComponentInstance();
        if (this.isStatelessComponent()) return this.fallbackMethod(name, !!args && args[0] ? args[0] : {});
        else if (!!!frameworkComponentInstance) {
            setTimeout(()=>this.callMethod(name, args));
            return;
        }
        const method = frameworkComponentInstance[name];
        if (!!method) return method.apply(frameworkComponentInstance, args);
        if (this.fallbackMethodAvailable(name)) return this.fallbackMethod(name, !!args && args[0] ? args[0] : {});
    }
    addMethod(name, callback) {
        this[name] = callback;
    }
    init(params) {
        this.eParentElement = this.createParentElement(params);
        this.params = params;
        this.createOrUpdatePortal(params);
        return new (0, _agGridCommunity.AgPromise)((resolve)=>this.createReactComponent(resolve));
    }
    createOrUpdatePortal(params) {
        if (!this.isStatelessComponent()) {
            this.ref = (element)=>{
                var _a;
                this.componentInstance = element;
                this.addParentContainerStyleAndClasses();
                (_a = this.resolveInstanceCreated) == null || _a.call(this, true);
                this.resolveInstanceCreated = void 0;
            };
            params.ref = this.ref;
        }
        this.reactElement = this.createElement(this.reactComponent, __spreadProps(__spreadValues({}, params), {
            key: this.key
        }));
        this.portal = (0, _reactDom.createPortal)(this.reactElement, this.eParentElement, this.portalKey);
    }
    createElement(reactComponent, props) {
        return (0, _react.createElement)(reactComponent, props);
    }
    createReactComponent(resolve) {
        this.portalManager.mountReactPortal(this.portal, this, (value)=>{
            resolve(value);
        });
    }
    isNullValue() {
        return this.valueRenderedIsNull(this.params);
    }
    rendered() {
        return this.isStatelessComponent() && this.statelessComponentRendered() || !!(!this.isStatelessComponent() && this.getFrameworkComponentInstance());
    }
    valueRenderedIsNull(params) {
        if (!this.componentType.cellRenderer) return false;
        const originalConsoleError = console.error;
        try {
            console.error = ()=>{};
            const staticMarkup = (0, _server.renderToStaticMarkup)((0, _react.createElement)(this.reactComponent, params));
            return staticMarkup === "";
        } catch (ignore) {} finally{
            console.error = originalConsoleError;
        }
        return false;
    }
    /*
  * fallback methods - these will be invoked if a corresponding instance method is not present
  * for example if refresh is called and is not available on the component instance, then refreshComponent on this
  * class will be invoked instead
  *
  * Currently only refresh is supported
  */ refreshComponent(args) {
        this.oldPortal = this.portal;
        this.createOrUpdatePortal(args);
        this.portalManager.updateReactPortal(this.oldPortal, this.portal);
    }
    fallbackMethod(name, params) {
        const method = this[`${name}Component`];
        if (!this.suppressFallbackMethods && !!method) return method.bind(this)(params);
    }
    fallbackMethodAvailable(name) {
        if (this.suppressFallbackMethods) return false;
        const method = this[`${name}Component`];
        return !!method;
    }
};
// packages/ag-grid-react/src/shared/customComp/customComponentWrapper.ts
function addOptionalMethods(optionalMethodNames, providedMethods, component) {
    optionalMethodNames.forEach((methodName)=>{
        const providedMethod = providedMethods[methodName];
        if (providedMethod) component[methodName] = providedMethod;
    });
}
var CustomComponentWrapper = class extends ReactComponent {
    constructor(){
        super(...arguments);
        this.awaitUpdateCallback = new (0, _agGridCommunity.AgPromise)((resolve)=>{
            this.resolveUpdateCallback = resolve;
        });
        this.wrapperComponent = customWrapperComp_default;
    }
    init(params) {
        this.sourceParams = params;
        return super.init(this.getProps());
    }
    addMethod() {}
    getInstance() {
        return this.instanceCreated.then(()=>this.componentInstance);
    }
    getFrameworkComponentInstance() {
        return this;
    }
    createElement(reactComponent, props) {
        return super.createElement(this.wrapperComponent, {
            initialProps: props,
            CustomComponentClass: reactComponent,
            setMethods: (methods)=>this.setMethods(methods),
            addUpdateCallback: (callback)=>{
                this.updateCallback = ()=>{
                    callback(this.getProps());
                    return new (0, _agGridCommunity.AgPromise)((resolve)=>{
                        setTimeout(()=>{
                            resolve();
                        });
                    });
                };
                this.resolveUpdateCallback();
            }
        });
    }
    setMethods(methods) {
        this.providedMethods = methods;
        addOptionalMethods(this.getOptionalMethods(), this.providedMethods, this);
    }
    getOptionalMethods() {
        return [];
    }
    getProps() {
        return __spreadProps(__spreadValues({}, this.sourceParams), {
            key: this.key,
            ref: this.ref
        });
    }
    refreshProps() {
        if (this.updateCallback) return this.updateCallback();
        return new (0, _agGridCommunity.AgPromise)((resolve)=>this.awaitUpdateCallback.then(()=>{
                this.updateCallback().then(()=>resolve());
            }));
    }
};
// packages/ag-grid-react/src/shared/customComp/dateComponentWrapper.ts
var DateComponentWrapper = class extends CustomComponentWrapper {
    constructor(){
        super(...arguments);
        this.date = null;
        this.onDateChange = (date)=>this.updateDate(date);
    }
    getDate() {
        return this.date;
    }
    setDate(date) {
        this.date = date;
        this.refreshProps();
    }
    refresh(params) {
        this.sourceParams = params;
        this.refreshProps();
    }
    getOptionalMethods() {
        return [
            "afterGuiAttached",
            "setInputPlaceholder",
            "setInputAriaLabel",
            "setDisabled"
        ];
    }
    updateDate(date) {
        this.setDate(date);
        this.sourceParams.onDateChanged();
    }
    getProps() {
        const props = super.getProps();
        props.date = this.date;
        props.onDateChange = this.onDateChange;
        delete props.onDateChanged;
        return props;
    }
};
// packages/ag-grid-react/src/shared/customComp/filterComponentWrapper.ts
var FilterComponentWrapper = class extends CustomComponentWrapper {
    constructor(){
        super(...arguments);
        this.model = null;
        this.onModelChange = (model)=>this.updateModel(model);
        this.onUiChange = ()=>this.sourceParams.filterChangedCallback();
    }
    isFilterActive() {
        return this.model != null;
    }
    doesFilterPass(params) {
        return this.providedMethods.doesFilterPass(params);
    }
    getModel() {
        return this.model;
    }
    setModel(model) {
        this.model = model;
        return this.refreshProps();
    }
    refresh(newParams) {
        this.sourceParams = newParams;
        this.refreshProps();
        return true;
    }
    getOptionalMethods() {
        return [
            "afterGuiAttached",
            "afterGuiDetached",
            "onNewRowsLoaded",
            "getModelAsString",
            "onAnyFilterChanged"
        ];
    }
    updateModel(model) {
        this.setModel(model).then(()=>this.sourceParams.filterChangedCallback());
    }
    getProps() {
        const props = super.getProps();
        props.model = this.model;
        props.onModelChange = this.onModelChange;
        props.onUiChange = this.onUiChange;
        delete props.filterChangedCallback;
        delete props.filterModifiedCallback;
        delete props.valueGetter;
        return props;
    }
};
function updateFloatingFilterParent(params, model) {
    params.parentFilterInstance((instance)=>{
        (instance.setModel(model) || (0, _agGridCommunity.AgPromise).resolve()).then(()=>{
            params.filterParams.filterChangedCallback();
        });
    });
}
var FloatingFilterComponentProxy = class {
    constructor(floatingFilterParams, refreshProps){
        this.floatingFilterParams = floatingFilterParams;
        this.refreshProps = refreshProps;
        this.model = null;
        this.onModelChange = (model)=>this.updateModel(model);
    }
    getProps() {
        return __spreadProps(__spreadValues({}, this.floatingFilterParams), {
            model: this.model,
            onModelChange: this.onModelChange
        });
    }
    onParentModelChanged(parentModel) {
        this.model = parentModel;
        this.refreshProps();
    }
    refresh(params) {
        this.floatingFilterParams = params;
        this.refreshProps();
    }
    setMethods(methods) {
        addOptionalMethods(this.getOptionalMethods(), methods, this);
    }
    getOptionalMethods() {
        return [
            "afterGuiAttached"
        ];
    }
    updateModel(model) {
        this.model = model;
        this.refreshProps();
        updateFloatingFilterParent(this.floatingFilterParams, model);
    }
};
// packages/ag-grid-react/src/shared/customComp/floatingFilterComponentWrapper.ts
var FloatingFilterComponentWrapper = class extends CustomComponentWrapper {
    constructor(){
        super(...arguments);
        this.model = null;
        this.onModelChange = (model)=>this.updateModel(model);
    }
    onParentModelChanged(parentModel) {
        this.model = parentModel;
        this.refreshProps();
    }
    refresh(newParams) {
        this.sourceParams = newParams;
        this.refreshProps();
    }
    getOptionalMethods() {
        return [
            "afterGuiAttached"
        ];
    }
    updateModel(model) {
        this.model = model;
        this.refreshProps();
        updateFloatingFilterParent(this.sourceParams, model);
    }
    getProps() {
        const props = super.getProps();
        props.model = this.model;
        props.onModelChange = this.onModelChange;
        return props;
    }
};
// packages/ag-grid-react/src/shared/customComp/loadingOverlayComponentWrapper.ts
var LoadingOverlayComponentWrapper = class extends CustomComponentWrapper {
    refresh(params) {
        this.sourceParams = params;
        this.refreshProps();
    }
};
// packages/ag-grid-react/src/shared/customComp/menuItemComponentWrapper.ts
var MenuItemComponentWrapper = class extends CustomComponentWrapper {
    constructor(){
        super(...arguments);
        this.active = false;
        this.expanded = false;
        this.onActiveChange = (active)=>this.updateActive(active);
    }
    setActive(active) {
        this.awaitSetActive(active);
    }
    setExpanded(expanded) {
        this.expanded = expanded;
        this.refreshProps();
    }
    getOptionalMethods() {
        return [
            "select",
            "configureDefaults"
        ];
    }
    awaitSetActive(active) {
        this.active = active;
        return this.refreshProps();
    }
    updateActive(active) {
        const result = this.awaitSetActive(active);
        if (active) result.then(()=>this.sourceParams.onItemActivated());
    }
    getProps() {
        const props = super.getProps();
        props.active = this.active;
        props.expanded = this.expanded;
        props.onActiveChange = this.onActiveChange;
        delete props.onItemActivated;
        return props;
    }
};
// packages/ag-grid-react/src/shared/customComp/noRowsOverlayComponentWrapper.ts
var NoRowsOverlayComponentWrapper = class extends CustomComponentWrapper {
    refresh(params) {
        this.sourceParams = params;
        this.refreshProps();
    }
};
// packages/ag-grid-react/src/shared/customComp/statusPanelComponentWrapper.ts
var StatusPanelComponentWrapper = class extends CustomComponentWrapper {
    refresh(params) {
        this.sourceParams = params;
        this.refreshProps();
        return true;
    }
};
// packages/ag-grid-react/src/shared/customComp/toolPanelComponentWrapper.ts
var ToolPanelComponentWrapper = class extends CustomComponentWrapper {
    constructor(){
        super(...arguments);
        this.onStateChange = (state)=>this.updateState(state);
    }
    refresh(params) {
        this.sourceParams = params;
        this.refreshProps();
        return true;
    }
    getState() {
        return this.state;
    }
    updateState(state) {
        this.state = state;
        this.refreshProps();
        this.sourceParams.onStateUpdated();
    }
    getProps() {
        const props = super.getProps();
        props.state = this.state;
        props.onStateChange = this.onStateChange;
        return props;
    }
};
// packages/ag-grid-react/src/shared/portalManager.ts
var _PortalManager = class _PortalManager {
    constructor(refresher, wrappingElement, maxComponentCreationTimeMs){
        this.destroyed = false;
        this.portals = [];
        this.hasPendingPortalUpdate = false;
        this.wrappingElement = wrappingElement ? wrappingElement : "div";
        this.refresher = refresher;
        this.maxComponentCreationTimeMs = maxComponentCreationTimeMs ? maxComponentCreationTimeMs : _PortalManager.MAX_COMPONENT_CREATION_TIME_IN_MS;
    }
    getPortals() {
        return this.portals;
    }
    destroy() {
        this.destroyed = true;
    }
    destroyPortal(portal) {
        this.portals = this.portals.filter((curPortal)=>curPortal !== portal);
        this.batchUpdate();
    }
    getComponentWrappingElement() {
        return this.wrappingElement;
    }
    mountReactPortal(portal, reactComponent, resolve) {
        this.portals = [
            ...this.portals,
            portal
        ];
        this.waitForInstance(reactComponent, resolve);
        this.batchUpdate();
    }
    updateReactPortal(oldPortal, newPortal) {
        this.portals[this.portals.indexOf(oldPortal)] = newPortal;
        this.batchUpdate();
    }
    batchUpdate() {
        if (this.hasPendingPortalUpdate) return;
        setTimeout(()=>{
            if (!this.destroyed) {
                this.refresher();
                this.hasPendingPortalUpdate = false;
            }
        });
        this.hasPendingPortalUpdate = true;
    }
    waitForInstance(reactComponent, resolve, startTime = Date.now()) {
        if (this.destroyed) {
            resolve(null);
            return;
        }
        if (reactComponent.rendered()) resolve(reactComponent);
        else {
            if (Date.now() - startTime >= this.maxComponentCreationTimeMs && !this.hasPendingPortalUpdate) {
                if (reactComponent.isNullValue()) {
                    resolve(reactComponent);
                    return;
                }
                console.error(`AG Grid: React Component '${reactComponent.getReactComponentName()}' not created within ${this.maxComponentCreationTimeMs}ms.`);
                console.error("    If the component is using `forwardRef` but not `useImperativeHandle`, add the following: `useImperativeHandle(ref, () => ({}));`");
                return;
            }
            window.setTimeout(()=>{
                this.waitForInstance(reactComponent, resolve, startTime);
            });
        }
    }
};
_PortalManager.MAX_COMPONENT_CREATION_TIME_IN_MS = 1e3;
var PortalManager = _PortalManager;
var BeansContext = (0, _reactDefault.default).createContext({});
var classesList = (...list)=>{
    const filtered = list.filter((s)=>s != null && s !== "");
    return filtered.join(" ");
};
var CssClasses = class _CssClasses {
    constructor(...initialClasses){
        this.classesMap = {};
        initialClasses.forEach((className)=>{
            this.classesMap[className] = true;
        });
    }
    setClass(className, on) {
        const nothingHasChanged = !!this.classesMap[className] == on;
        if (nothingHasChanged) return this;
        const res = new _CssClasses();
        res.classesMap = __spreadValues({}, this.classesMap);
        res.classesMap[className] = on;
        return res;
    }
    toString() {
        const res = Object.keys(this.classesMap).filter((key)=>this.classesMap[key]).join(" ");
        return res;
    }
};
var isComponentStateless = (Component3)=>{
    const hasSymbol = ()=>typeof Symbol === "function" && Symbol.for;
    const getMemoType = ()=>hasSymbol() ? Symbol.for("react.memo") : 60115;
    return typeof Component3 === "function" && !(Component3.prototype && Component3.prototype.isReactComponent) || typeof Component3 === "object" && Component3.$$typeof === getMemoType();
};
var createRootAndFlushSyncAvailable = (0, _reactDomDefault.default).createRoot != null && (0, _reactDomDefault.default).flushSync != null;
var disableFlushSync = false;
function runWithoutFlushSync(func) {
    if (!disableFlushSync) setTimeout(()=>disableFlushSync = false, 0);
    disableFlushSync = true;
    return func();
}
var agFlushSync = (useFlushSync, fn)=>{
    if (createRootAndFlushSyncAvailable && useFlushSync && !disableFlushSync) (0, _reactDomDefault.default).flushSync(fn);
    else fn();
};
function getNextValueIfDifferent(prev, next, maintainOrder) {
    if (next == null || prev == null) return next;
    if (prev === next || next.length === 0 && prev.length === 0) return prev;
    if (maintainOrder || prev.length === 0 && next.length > 0 || prev.length > 0 && next.length === 0) return next;
    const oldValues = [];
    const newValues = [];
    const prevMap = /* @__PURE__ */ new Map();
    const nextMap = /* @__PURE__ */ new Map();
    for(let i = 0; i < next.length; i++){
        const c = next[i];
        nextMap.set(c.getInstanceId(), c);
    }
    for(let i = 0; i < prev.length; i++){
        const c = prev[i];
        prevMap.set(c.getInstanceId(), c);
        if (nextMap.has(c.getInstanceId())) oldValues.push(c);
    }
    for(let i = 0; i < next.length; i++){
        const c = next[i];
        const instanceId = c.getInstanceId();
        if (!prevMap.has(instanceId)) newValues.push(c);
    }
    if (oldValues.length === prev.length && newValues.length === 0) return prev;
    if (oldValues.length === 0 && newValues.length === next.length) return next;
    if (oldValues.length === 0) return newValues;
    if (newValues.length === 0) return oldValues;
    return [
        ...oldValues,
        ...newValues
    ];
}
// packages/ag-grid-react/src/reactUi/jsComp.tsx
var showJsComp = (compDetails, context, eParent, ref)=>{
    const doNothing = !compDetails || compDetails.componentFromFramework || context.isDestroyed();
    if (doNothing) return;
    const promise = compDetails.newAgStackInstance();
    if (!promise) return;
    let comp;
    let compGui;
    let destroyed = false;
    promise.then((c)=>{
        if (destroyed) {
            context.destroyBean(c);
            return;
        }
        comp = c;
        compGui = comp.getGui();
        eParent.appendChild(compGui);
        setRef(ref, comp);
    });
    return ()=>{
        destroyed = true;
        if (!comp) return;
        if (compGui && compGui.parentElement) compGui.parentElement.removeChild(compGui);
        context.destroyBean(comp);
        if (ref) setRef(ref, void 0);
    };
};
var setRef = (ref, value)=>{
    if (!ref) return;
    if (ref instanceof Function) {
        const refCallback = ref;
        refCallback(value);
    } else {
        const refObj = ref;
        refObj.current = value;
    }
};
var createSyncJsComp = (compDetails)=>{
    const promise = compDetails.newAgStackInstance();
    if (!promise) return;
    return promise.resolveNow(null, (x)=>x);
};
// packages/ag-grid-react/src/reactUi/cellRenderer/groupCellRenderer.tsx
var GroupCellRenderer = (0, _react.forwardRef)((props, ref)=>{
    var _a;
    const context = (0, _react.useContext)(BeansContext).context;
    const eGui = (0, _react.useRef)(null);
    const eValueRef = (0, _react.useRef)(null);
    const eCheckboxRef = (0, _react.useRef)(null);
    const eExpandedRef = (0, _react.useRef)(null);
    const eContractedRef = (0, _react.useRef)(null);
    const ctrlRef = (0, _react.useRef)();
    const [innerCompDetails, setInnerCompDetails] = (0, _react.useState)();
    const [childCount, setChildCount] = (0, _react.useState)();
    const [value, setValue] = (0, _react.useState)();
    const [cssClasses, setCssClasses] = (0, _react.useState)(()=>new CssClasses());
    const [expandedCssClasses, setExpandedCssClasses] = (0, _react.useState)(()=>new CssClasses("ag-hidden"));
    const [contractedCssClasses, setContractedCssClasses] = (0, _react.useState)(()=>new CssClasses("ag-hidden"));
    const [checkboxCssClasses, setCheckboxCssClasses] = (0, _react.useState)(()=>new CssClasses("ag-invisible"));
    (0, _react.useImperativeHandle)(ref, ()=>{
        return {
            // force new instance when grid tries to refresh
            refresh () {
                return false;
            }
        };
    });
    (0, _react.useLayoutEffect)(()=>{
        return showJsComp(innerCompDetails, context, eValueRef.current);
    }, [
        innerCompDetails
    ]);
    const setRef2 = (0, _react.useCallback)((ref2)=>{
        eGui.current = ref2;
        if (!eGui.current) {
            context.destroyBean(ctrlRef.current);
            ctrlRef.current = null;
            return;
        }
        const compProxy = {
            setInnerRenderer: (details, valueToDisplay)=>{
                setInnerCompDetails(details);
                setValue(valueToDisplay);
            },
            setChildCount: (count)=>setChildCount(count),
            addOrRemoveCssClass: (name, on)=>setCssClasses((prev)=>prev.setClass(name, on)),
            setContractedDisplayed: (displayed)=>setContractedCssClasses((prev)=>prev.setClass("ag-hidden", !displayed)),
            setExpandedDisplayed: (displayed)=>setExpandedCssClasses((prev)=>prev.setClass("ag-hidden", !displayed)),
            setCheckboxVisible: (visible)=>setCheckboxCssClasses((prev)=>prev.setClass("ag-invisible", !visible))
        };
        ctrlRef.current = context.createBean(new (0, _agGridCommunity.GroupCellRendererCtrl)());
        ctrlRef.current.init(compProxy, eGui.current, eCheckboxRef.current, eExpandedRef.current, eContractedRef.current, GroupCellRenderer, props);
    }, []);
    const className = (0, _react.useMemo)(()=>`ag-cell-wrapper ${cssClasses.toString()}`, [
        cssClasses
    ]);
    const expandedClassName = (0, _react.useMemo)(()=>`ag-group-expanded ${expandedCssClasses.toString()}`, [
        expandedCssClasses
    ]);
    const contractedClassName = (0, _react.useMemo)(()=>`ag-group-contracted ${contractedCssClasses.toString()}`, [
        contractedCssClasses
    ]);
    const checkboxClassName = (0, _react.useMemo)(()=>`ag-group-checkbox ${checkboxCssClasses.toString()}`, [
        checkboxCssClasses
    ]);
    const useFwRenderer = innerCompDetails && innerCompDetails.componentFromFramework;
    const FwRenderer = useFwRenderer ? innerCompDetails.componentClass : void 0;
    const useValue = innerCompDetails == null && value != null;
    const escapedValue = (0, _agGridCommunity._).escapeString(value, true);
    return /* @__PURE__ */ (0, _reactDefault.default).createElement("span", __spreadValues({
        className,
        ref: setRef2
    }, !props.colDef ? {
        role: (_a = ctrlRef.current) == null ? void 0 : _a.getCellAriaRole()
    } : {}), /* @__PURE__ */ (0, _reactDefault.default).createElement("span", {
        className: expandedClassName,
        ref: eExpandedRef
    }), /* @__PURE__ */ (0, _reactDefault.default).createElement("span", {
        className: contractedClassName,
        ref: eContractedRef
    }), /* @__PURE__ */ (0, _reactDefault.default).createElement("span", {
        className: checkboxClassName,
        ref: eCheckboxRef
    }), /* @__PURE__ */ (0, _reactDefault.default).createElement("span", {
        className: "ag-group-value",
        ref: eValueRef
    }, useValue && /* @__PURE__ */ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, escapedValue), useFwRenderer && /* @__PURE__ */ (0, _reactDefault.default).createElement(FwRenderer, __spreadValues({}, innerCompDetails.params))), /* @__PURE__ */ (0, _reactDefault.default).createElement("span", {
        className: "ag-group-child-count"
    }, childCount));
});
var groupCellRenderer_default = GroupCellRenderer;
var HeaderCellComp = (props)=>{
    const { ctrl } = props;
    const isAlive = ctrl.isAlive();
    const { context } = (0, _react.useContext)(BeansContext);
    const colId = isAlive ? ctrl.getColId() : void 0;
    const [userCompDetails, setUserCompDetails] = (0, _react.useState)();
    const eGui = (0, _react.useRef)(null);
    const eResize = (0, _react.useRef)(null);
    const eHeaderCompWrapper = (0, _react.useRef)(null);
    const userCompRef = (0, _react.useRef)();
    let cssClassManager = (0, _react.useRef)();
    if (isAlive && !cssClassManager.current) cssClassManager.current = new (0, _agGridCommunity.CssClassManager)(()=>eGui.current);
    const setRef2 = (0, _react.useCallback)((e)=>{
        var _a;
        eGui.current = e;
        if (!eGui.current || !isAlive) return;
        const compProxy = {
            setWidth: (width)=>{
                if (eGui.current) eGui.current.style.width = width;
            },
            addOrRemoveCssClass: (name, on)=>cssClassManager.current.addOrRemoveCssClass(name, on),
            setAriaSort: (sort)=>{
                if (eGui.current) sort ? (0, _agGridCommunity._).setAriaSort(eGui.current, sort) : (0, _agGridCommunity._).removeAriaSort(eGui.current);
            },
            setUserCompDetails: (compDetails)=>setUserCompDetails(compDetails),
            getUserCompInstance: ()=>userCompRef.current || void 0
        };
        ctrl.setComp(compProxy, eGui.current, eResize.current, eHeaderCompWrapper.current);
        const selectAllGui = ctrl.getSelectAllGui();
        (_a = eResize.current) == null || _a.insertAdjacentElement("afterend", selectAllGui);
    }, []);
    (0, _react.useLayoutEffect)(()=>showJsComp(userCompDetails, context, eHeaderCompWrapper.current, userCompRef), [
        userCompDetails
    ]);
    (0, _react.useEffect)(()=>{
        ctrl.setDragSource(eGui.current);
    }, [
        userCompDetails
    ]);
    const userCompStateless = (0, _react.useMemo)(()=>{
        const res = (userCompDetails == null ? void 0 : userCompDetails.componentFromFramework) && isComponentStateless(userCompDetails.componentClass);
        return !!res;
    }, [
        userCompDetails
    ]);
    const reactUserComp = userCompDetails && userCompDetails.componentFromFramework;
    const UserCompClass = userCompDetails && userCompDetails.componentClass;
    return /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        ref: setRef2,
        className: "ag-header-cell",
        "col-id": colId,
        role: "columnheader"
    }, /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        ref: eResize,
        className: "ag-header-cell-resize",
        role: "presentation"
    }), /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        ref: eHeaderCompWrapper,
        className: "ag-header-cell-comp-wrapper",
        role: "presentation"
    }, reactUserComp && userCompStateless && /* @__PURE__ */ (0, _reactDefault.default).createElement(UserCompClass, __spreadValues({}, userCompDetails.params)), reactUserComp && !userCompStateless && /* @__PURE__ */ (0, _reactDefault.default).createElement(UserCompClass, __spreadProps(__spreadValues({}, userCompDetails.params), {
        ref: userCompRef
    }))));
};
var headerCellComp_default = (0, _react.memo)(HeaderCellComp);
var HeaderGroupCellComp = (props)=>{
    const { context } = (0, _react.useContext)(BeansContext);
    const { ctrl } = props;
    const [cssClasses, setCssClasses] = (0, _react.useState)(()=>new CssClasses());
    const [cssResizableClasses, setResizableCssClasses] = (0, _react.useState)(()=>new CssClasses());
    const [resizableAriaHidden, setResizableAriaHidden] = (0, _react.useState)("false");
    const [ariaExpanded, setAriaExpanded] = (0, _react.useState)();
    const [userCompDetails, setUserCompDetails] = (0, _react.useState)();
    const colId = (0, _react.useMemo)(()=>ctrl.getColId(), []);
    const eGui = (0, _react.useRef)(null);
    const eResize = (0, _react.useRef)(null);
    const userCompRef = (0, _react.useRef)();
    const setRef2 = (0, _react.useCallback)((e)=>{
        eGui.current = e;
        if (!eGui.current) return;
        const compProxy = {
            setWidth: (width)=>{
                if (eGui.current) eGui.current.style.width = width;
            },
            addOrRemoveCssClass: (name, on)=>setCssClasses((prev)=>prev.setClass(name, on)),
            setUserCompDetails: (compDetails)=>setUserCompDetails(compDetails),
            setResizableDisplayed: (displayed)=>{
                setResizableCssClasses((prev)=>prev.setClass("ag-hidden", !displayed));
                setResizableAriaHidden(!displayed ? "true" : "false");
            },
            setAriaExpanded: (expanded)=>setAriaExpanded(expanded),
            getUserCompInstance: ()=>userCompRef.current || void 0
        };
        ctrl.setComp(compProxy, eGui.current, eResize.current);
    }, []);
    (0, _react.useLayoutEffect)(()=>showJsComp(userCompDetails, context, eGui.current), [
        userCompDetails
    ]);
    (0, _react.useEffect)(()=>{
        if (eGui.current) ctrl.setDragSource(eGui.current);
    }, [
        userCompDetails
    ]);
    const userCompStateless = (0, _react.useMemo)(()=>{
        const res = (userCompDetails == null ? void 0 : userCompDetails.componentFromFramework) && isComponentStateless(userCompDetails.componentClass);
        return !!res;
    }, [
        userCompDetails
    ]);
    const className = (0, _react.useMemo)(()=>"ag-header-group-cell " + cssClasses.toString(), [
        cssClasses
    ]);
    const resizableClassName = (0, _react.useMemo)(()=>"ag-header-cell-resize " + cssResizableClasses.toString(), [
        cssResizableClasses
    ]);
    const reactUserComp = userCompDetails && userCompDetails.componentFromFramework;
    const UserCompClass = userCompDetails && userCompDetails.componentClass;
    return /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        ref: setRef2,
        className,
        "col-id": colId,
        role: "columnheader",
        "aria-expanded": ariaExpanded
    }, reactUserComp && userCompStateless && /* @__PURE__ */ (0, _reactDefault.default).createElement(UserCompClass, __spreadValues({}, userCompDetails.params)), reactUserComp && !userCompStateless && /* @__PURE__ */ (0, _reactDefault.default).createElement(UserCompClass, __spreadProps(__spreadValues({}, userCompDetails.params), {
        ref: userCompRef
    })), /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        ref: eResize,
        "aria-hidden": resizableAriaHidden,
        className: resizableClassName
    }));
};
var headerGroupCellComp_default = (0, _react.memo)(HeaderGroupCellComp);
function getInstance(wrapperComponent, callback) {
    var _a, _b;
    const promise = (_b = (_a = wrapperComponent == null ? void 0 : wrapperComponent.getInstance) == null ? void 0 : _a.call(wrapperComponent)) != null ? _b : (0, _agGridCommunity.AgPromise).resolve(void 0);
    promise.then((comp)=>callback(comp));
}
function warnReactiveCustomComponents() {
    (0, _agGridCommunity._).warnOnce("Using custom components without `reactiveCustomComponents = true` is deprecated.");
}
// packages/ag-grid-react/src/reactUi/header/headerFilterCellComp.tsx
var HeaderFilterCellComp = (props)=>{
    const { context, gos } = (0, _react.useContext)(BeansContext);
    const [cssClasses, setCssClasses] = (0, _react.useState)(()=>new CssClasses("ag-header-cell", "ag-floating-filter"));
    const [cssBodyClasses, setBodyCssClasses] = (0, _react.useState)(()=>new CssClasses());
    const [cssButtonWrapperClasses, setButtonWrapperCssClasses] = (0, _react.useState)(()=>new CssClasses("ag-floating-filter-button", "ag-hidden"));
    const [buttonWrapperAriaHidden, setButtonWrapperAriaHidden] = (0, _react.useState)("false");
    const [userCompDetails, setUserCompDetails] = (0, _react.useState)();
    const [renderKey, setRenderKey] = (0, _react.useState)(1);
    const eGui = (0, _react.useRef)(null);
    const eFloatingFilterBody = (0, _react.useRef)(null);
    const eButtonWrapper = (0, _react.useRef)(null);
    const eButtonShowMainFilter = (0, _react.useRef)(null);
    const userCompResolve = (0, _react.useRef)();
    const userCompPromise = (0, _react.useRef)();
    const userCompRef = (value)=>{
        if (value == null) return;
        userCompResolve.current && userCompResolve.current(value);
    };
    const { ctrl } = props;
    const setRef2 = (0, _react.useCallback)((e)=>{
        eGui.current = e;
        if (!eGui.current) return;
        userCompPromise.current = new (0, _agGridCommunity.AgPromise)((resolve)=>{
            userCompResolve.current = resolve;
        });
        const compProxy = {
            addOrRemoveCssClass: (name, on)=>setCssClasses((prev)=>prev.setClass(name, on)),
            addOrRemoveBodyCssClass: (name, on)=>setBodyCssClasses((prev)=>prev.setClass(name, on)),
            setButtonWrapperDisplayed: (displayed)=>{
                setButtonWrapperCssClasses((prev)=>prev.setClass("ag-hidden", !displayed));
                setButtonWrapperAriaHidden(!displayed ? "true" : "false");
            },
            setWidth: (width)=>{
                if (eGui.current) eGui.current.style.width = width;
            },
            setCompDetails: (compDetails)=>setUserCompDetails(compDetails),
            getFloatingFilterComp: ()=>userCompPromise.current ? userCompPromise.current : null,
            setMenuIcon: (eIcon)=>{
                var _a;
                return (_a = eButtonShowMainFilter.current) == null ? void 0 : _a.appendChild(eIcon);
            }
        };
        ctrl.setComp(compProxy, eGui.current, eButtonShowMainFilter.current, eFloatingFilterBody.current);
    }, []);
    (0, _react.useLayoutEffect)(()=>showJsComp(userCompDetails, context, eFloatingFilterBody.current, userCompRef), [
        userCompDetails
    ]);
    const className = (0, _react.useMemo)(()=>cssClasses.toString(), [
        cssClasses
    ]);
    const bodyClassName = (0, _react.useMemo)(()=>cssBodyClasses.toString(), [
        cssBodyClasses
    ]);
    const buttonWrapperClassName = (0, _react.useMemo)(()=>cssButtonWrapperClasses.toString(), [
        cssButtonWrapperClasses
    ]);
    const userCompStateless = (0, _react.useMemo)(()=>{
        const res = userCompDetails && userCompDetails.componentFromFramework && isComponentStateless(userCompDetails.componentClass);
        return !!res;
    }, [
        userCompDetails
    ]);
    const reactiveCustomComponents = (0, _react.useMemo)(()=>gos.get("reactiveCustomComponents"), []);
    const floatingFilterCompProxy = (0, _react.useMemo)(()=>{
        if (userCompDetails) {
            if (reactiveCustomComponents) {
                const compProxy = new FloatingFilterComponentProxy(userCompDetails.params, ()=>setRenderKey((prev)=>prev + 1));
                userCompRef(compProxy);
                return compProxy;
            } else if (userCompDetails.componentFromFramework) warnReactiveCustomComponents();
        }
        return void 0;
    }, [
        userCompDetails
    ]);
    const floatingFilterProps = floatingFilterCompProxy == null ? void 0 : floatingFilterCompProxy.getProps();
    const reactUserComp = userCompDetails && userCompDetails.componentFromFramework;
    const UserCompClass = userCompDetails && userCompDetails.componentClass;
    return /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        ref: setRef2,
        className,
        role: "gridcell"
    }, /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        ref: eFloatingFilterBody,
        className: bodyClassName,
        role: "presentation"
    }, reactUserComp && !reactiveCustomComponents && /* @__PURE__ */ (0, _reactDefault.default).createElement(UserCompClass, __spreadProps(__spreadValues({}, userCompDetails.params), {
        ref: userCompStateless ? ()=>{} : userCompRef
    })), reactUserComp && reactiveCustomComponents && /* @__PURE__ */ (0, _reactDefault.default).createElement(CustomContext.Provider, {
        value: {
            setMethods: (methods)=>floatingFilterCompProxy.setMethods(methods)
        }
    }, /* @__PURE__ */ (0, _reactDefault.default).createElement(UserCompClass, __spreadValues({}, floatingFilterProps)))), /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        ref: eButtonWrapper,
        "aria-hidden": buttonWrapperAriaHidden,
        className: buttonWrapperClassName,
        role: "presentation"
    }, /* @__PURE__ */ (0, _reactDefault.default).createElement("button", {
        ref: eButtonShowMainFilter,
        type: "button",
        className: "ag-button ag-floating-filter-button-button",
        tabIndex: -1
    })));
};
var headerFilterCellComp_default = (0, _react.memo)(HeaderFilterCellComp);
// packages/ag-grid-react/src/reactUi/header/headerRowComp.tsx
var HeaderRowComp = (props)=>{
    const { ctrl } = props;
    const { topOffset, rowHeight } = (0, _react.useMemo)(()=>ctrl.getTopAndHeight(), []);
    const ariaRowIndex = ctrl.getAriaRowIndex();
    const className = ctrl.getHeaderRowClass();
    const [height, setHeight] = (0, _react.useState)(()=>rowHeight + "px");
    const [top, setTop] = (0, _react.useState)(()=>topOffset + "px");
    const cellCtrlsRef = (0, _react.useRef)(null);
    const prevCellCtrlsRef = (0, _react.useRef)(null);
    const [cellCtrls, setCellCtrls] = (0, _react.useState)(()=>ctrl.getHeaderCtrls());
    const eGui = (0, _react.useRef)(null);
    const setRef2 = (0, _react.useCallback)((e)=>{
        eGui.current = e;
        if (!e) return;
        const compProxy = {
            setHeight: (height2)=>setHeight(height2),
            setTop: (top2)=>setTop(top2),
            setHeaderCtrls: (ctrls, forceOrder, afterScroll)=>{
                prevCellCtrlsRef.current = cellCtrlsRef.current;
                cellCtrlsRef.current = ctrls;
                const next = getNextValueIfDifferent(prevCellCtrlsRef.current, ctrls, forceOrder);
                if (next !== prevCellCtrlsRef.current) agFlushSync(afterScroll, ()=>setCellCtrls(next));
            },
            setWidth: (width)=>{
                if (eGui.current) eGui.current.style.width = width;
            }
        };
        ctrl.setComp(compProxy, false);
    }, []);
    const style = (0, _react.useMemo)(()=>({
            height,
            top
        }), [
        height,
        top
    ]);
    const createCellJsx = (0, _react.useCallback)((cellCtrl)=>{
        switch(ctrl.getType()){
            case (0, _agGridCommunity.HeaderRowType).COLUMN_GROUP:
                return /* @__PURE__ */ (0, _reactDefault.default).createElement(headerGroupCellComp_default, {
                    ctrl: cellCtrl,
                    key: cellCtrl.getInstanceId()
                });
            case (0, _agGridCommunity.HeaderRowType).FLOATING_FILTER:
                return /* @__PURE__ */ (0, _reactDefault.default).createElement(headerFilterCellComp_default, {
                    ctrl: cellCtrl,
                    key: cellCtrl.getInstanceId()
                });
            default:
                return /* @__PURE__ */ (0, _reactDefault.default).createElement(headerCellComp_default, {
                    ctrl: cellCtrl,
                    key: cellCtrl.getInstanceId()
                });
        }
    }, []);
    return /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        ref: setRef2,
        className,
        role: "row",
        style,
        "aria-rowindex": ariaRowIndex
    }, cellCtrls.map(createCellJsx));
};
var headerRowComp_default = (0, _react.memo)(HeaderRowComp);
// packages/ag-grid-react/src/reactUi/header/headerRowContainerComp.tsx
var HeaderRowContainerComp = (props)=>{
    const [displayed, setDisplayed] = (0, _react.useState)(true);
    const [headerRowCtrls, setHeaderRowCtrls] = (0, _react.useState)([]);
    const { context } = (0, _react.useContext)(BeansContext);
    const eGui = (0, _react.useRef)(null);
    const eCenterContainer = (0, _react.useRef)(null);
    const headerRowCtrlRef = (0, _react.useRef)(null);
    const pinnedLeft = props.pinned === "left";
    const pinnedRight = props.pinned === "right";
    const centre = !pinnedLeft && !pinnedRight;
    const setRef2 = (0, _react.useCallback)((e)=>{
        eGui.current = e;
        if (!eGui.current) {
            context.destroyBean(headerRowCtrlRef.current);
            headerRowCtrlRef.current = null;
            return;
        }
        const compProxy = {
            setDisplayed,
            setCtrls: (ctrls)=>setHeaderRowCtrls(ctrls),
            // centre only
            setCenterWidth: (width)=>{
                if (eCenterContainer.current) eCenterContainer.current.style.width = width;
            },
            setViewportScrollLeft: (left)=>{
                if (eGui.current) eGui.current.scrollLeft = left;
            },
            // pinned only
            setPinnedContainerWidth: (width)=>{
                if (eGui.current) {
                    eGui.current.style.width = width;
                    eGui.current.style.minWidth = width;
                    eGui.current.style.maxWidth = width;
                }
            }
        };
        headerRowCtrlRef.current = context.createBean(new (0, _agGridCommunity.HeaderRowContainerCtrl)(props.pinned));
        headerRowCtrlRef.current.setComp(compProxy, eGui.current);
    }, []);
    const className = !displayed ? "ag-hidden" : "";
    const insertRowsJsx = ()=>headerRowCtrls.map((ctrl)=>/* @__PURE__ */ (0, _reactDefault.default).createElement(headerRowComp_default, {
                ctrl,
                key: ctrl.getInstanceId()
            }));
    return /* @__PURE__ */ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, pinnedLeft && /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        ref: setRef2,
        className: "ag-pinned-left-header " + className,
        "aria-hidden": !displayed,
        role: "rowgroup"
    }, insertRowsJsx()), pinnedRight && /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        ref: setRef2,
        className: "ag-pinned-right-header " + className,
        "aria-hidden": !displayed,
        role: "rowgroup"
    }, insertRowsJsx()), centre && /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        ref: setRef2,
        className: "ag-header-viewport " + className,
        role: "presentation"
    }, /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        ref: eCenterContainer,
        className: "ag-header-container",
        role: "rowgroup"
    }, insertRowsJsx())));
};
var headerRowContainerComp_default = (0, _react.memo)(HeaderRowContainerComp);
// packages/ag-grid-react/src/reactUi/header/gridHeaderComp.tsx
var GridHeaderComp = ()=>{
    const [cssClasses, setCssClasses] = (0, _react.useState)(()=>new CssClasses());
    const [height, setHeight] = (0, _react.useState)();
    const { context } = (0, _react.useContext)(BeansContext);
    const eGui = (0, _react.useRef)(null);
    const gridCtrlRef = (0, _react.useRef)(null);
    const setRef2 = (0, _react.useCallback)((e)=>{
        eGui.current = e;
        if (!e) {
            context.destroyBean(gridCtrlRef.current);
            gridCtrlRef.current = null;
            return;
        }
        const compProxy = {
            addOrRemoveCssClass: (name, on)=>setCssClasses((prev)=>prev.setClass(name, on)),
            setHeightAndMinHeight: (height2)=>setHeight(height2)
        };
        gridCtrlRef.current = context.createBean(new (0, _agGridCommunity.GridHeaderCtrl)());
        gridCtrlRef.current.setComp(compProxy, eGui.current, eGui.current);
    }, []);
    const className = (0, _react.useMemo)(()=>{
        let res = cssClasses.toString();
        return "ag-header " + res;
    }, [
        cssClasses
    ]);
    const style = (0, _react.useMemo)(()=>({
            height,
            minHeight: height
        }), [
        height
    ]);
    return /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        ref: setRef2,
        className,
        style,
        role: "presentation"
    }, /* @__PURE__ */ (0, _reactDefault.default).createElement(headerRowContainerComp_default, {
        pinned: "left"
    }), /* @__PURE__ */ (0, _reactDefault.default).createElement(headerRowContainerComp_default, {
        pinned: null
    }), /* @__PURE__ */ (0, _reactDefault.default).createElement(headerRowContainerComp_default, {
        pinned: "right"
    }));
};
var gridHeaderComp_default = (0, _react.memo)(GridHeaderComp);
var useReactCommentEffect = (comment, eForCommentRef)=>{
    (0, _react.useEffect)(()=>{
        const eForComment = eForCommentRef.current;
        if (eForComment) {
            const eParent = eForComment.parentElement;
            if (eParent) {
                const eComment = document.createComment(comment);
                eParent.insertBefore(eComment, eForComment);
                return ()=>{
                    eParent.removeChild(eComment);
                };
            }
        }
    }, [
        comment
    ]);
};
var reactComment_default = useReactCommentEffect;
var useEffectOnce = (effect)=>{
    const effectFn = (0, _react.useRef)(effect);
    const destroyFn = (0, _react.useRef)();
    const effectCalled = (0, _react.useRef)(false);
    const rendered = (0, _react.useRef)(false);
    const [, setVal] = (0, _react.useState)(0);
    if (effectCalled.current) rendered.current = true;
    (0, _react.useEffect)(()=>{
        if (!effectCalled.current) {
            destroyFn.current = effectFn.current();
            effectCalled.current = true;
        }
        setVal((val)=>val + 1);
        return ()=>{
            if (!rendered.current) return;
            if (destroyFn.current) destroyFn.current();
        };
    }, []);
};
// packages/ag-grid-react/src/reactUi/cells/popupEditorComp.tsx
var PopupEditorComp = (props)=>{
    const [popupEditorWrapper, setPopupEditorWrapper] = (0, _react.useState)();
    const { context, popupService, localeService, gos } = (0, _react.useContext)(BeansContext);
    useEffectOnce(()=>{
        const { editDetails, cellCtrl, eParentCell } = props;
        const { compDetails } = editDetails;
        const useModelPopup = gos.get("stopEditingWhenCellsLoseFocus");
        const wrapper = context.createBean(new (0, _agGridCommunity.PopupEditorWrapper)(compDetails.params));
        const ePopupGui = wrapper.getGui();
        if (props.jsChildComp) {
            const eChildGui = props.jsChildComp.getGui();
            if (eChildGui) ePopupGui.appendChild(eChildGui);
        }
        const positionParams = {
            column: cellCtrl.getColumn(),
            rowNode: cellCtrl.getRowNode(),
            type: "popupCellEditor",
            eventSource: eParentCell,
            ePopup: ePopupGui,
            position: editDetails.popupPosition,
            keepWithinBounds: true
        };
        const positionCallback = popupService.positionPopupByComponent.bind(popupService, positionParams);
        const translate = localeService.getLocaleTextFunc();
        const addPopupRes = popupService.addPopup({
            modal: useModelPopup,
            eChild: ePopupGui,
            closeOnEsc: true,
            closedCallback: ()=>{
                cellCtrl.onPopupEditorClosed();
            },
            anchorToElement: eParentCell,
            positionCallback,
            ariaLabel: translate("ariaLabelCellEditor", "Cell Editor")
        });
        const hideEditorPopup = addPopupRes ? addPopupRes.hideFunc : void 0;
        setPopupEditorWrapper(wrapper);
        props.jsChildComp && props.jsChildComp.afterGuiAttached && props.jsChildComp.afterGuiAttached();
        return ()=>{
            if (hideEditorPopup != null) hideEditorPopup();
            context.destroyBean(wrapper);
        };
    });
    return /* @__PURE__ */ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, popupEditorWrapper && props.wrappedContent && (0, _reactDom.createPortal)(props.wrappedContent, popupEditorWrapper.getGui()));
};
var popupEditorComp_default = (0, _react.memo)(PopupEditorComp);
var useJsCellRenderer = (showDetails, showTools, eCellValue, cellValueVersion, jsCellRendererRef, eGui)=>{
    const { context } = (0, _react.useContext)(BeansContext);
    const destroyCellRenderer = (0, _react.useCallback)(()=>{
        const comp = jsCellRendererRef.current;
        if (!comp) return;
        const compGui = comp.getGui();
        if (compGui && compGui.parentElement) compGui.parentElement.removeChild(compGui);
        context.destroyBean(comp);
        jsCellRendererRef.current = void 0;
    }, []);
    (0, _react.useEffect)(()=>{
        const showValue = showDetails != null;
        const jsCompDetails = showDetails && showDetails.compDetails && !showDetails.compDetails.componentFromFramework;
        const waitingForToolsSetup = showTools && eCellValue == null;
        const showComp = showValue && jsCompDetails && !waitingForToolsSetup;
        if (!showComp) {
            destroyCellRenderer();
            return;
        }
        const compDetails = showDetails.compDetails;
        if (jsCellRendererRef.current) {
            const comp2 = jsCellRendererRef.current;
            const attemptRefresh = comp2.refresh != null && showDetails.force == false;
            const refreshResult = attemptRefresh ? comp2.refresh(compDetails.params) : false;
            const refreshWorked = refreshResult === true || refreshResult === void 0;
            if (refreshWorked) return;
            destroyCellRenderer();
        }
        const promise = compDetails.newAgStackInstance();
        if (!promise) return;
        const comp = promise.resolveNow(null, (x)=>x);
        if (!comp) return;
        const compGui = comp.getGui();
        if (!compGui) return;
        const parent = showTools ? eCellValue : eGui.current;
        parent.appendChild(compGui);
        jsCellRendererRef.current = comp;
    }, [
        showDetails,
        showTools,
        cellValueVersion
    ]);
    (0, _react.useEffect)(()=>{
        return destroyCellRenderer;
    }, []);
};
var showJsRenderer_default = useJsCellRenderer;
var CellEditorComponentProxy = class {
    constructor(cellEditorParams, refreshProps){
        this.cellEditorParams = cellEditorParams;
        this.refreshProps = refreshProps;
        this.instanceCreated = new (0, _agGridCommunity.AgPromise)((resolve)=>{
            this.resolveInstanceCreated = resolve;
        });
        this.onValueChange = (value)=>this.updateValue(value);
        this.value = cellEditorParams.value;
    }
    getProps() {
        return __spreadProps(__spreadValues({}, this.cellEditorParams), {
            initialValue: this.cellEditorParams.value,
            value: this.value,
            onValueChange: this.onValueChange
        });
    }
    getValue() {
        return this.value;
    }
    refresh(params) {
        this.cellEditorParams = params;
        this.refreshProps();
    }
    setMethods(methods) {
        addOptionalMethods(this.getOptionalMethods(), methods, this);
    }
    getInstance() {
        return this.instanceCreated.then(()=>this.componentInstance);
    }
    setRef(componentInstance) {
        var _a;
        this.componentInstance = componentInstance;
        (_a = this.resolveInstanceCreated) == null || _a.call(this);
        this.resolveInstanceCreated = void 0;
    }
    getOptionalMethods() {
        return [
            "isPopup",
            "isCancelBeforeStart",
            "isCancelAfterEnd",
            "getPopupPosition",
            "focusIn",
            "focusOut",
            "afterGuiAttached"
        ];
    }
    updateValue(value) {
        this.value = value;
        this.refreshProps();
    }
};
// packages/ag-grid-react/src/reactUi/cells/cellComp.tsx
var checkCellEditorDeprecations = (popup, cellEditor, cellCtrl)=>{
    const col = cellCtrl.getColumn();
    if (!popup && cellEditor.isPopup && cellEditor.isPopup()) {
        const msg = `AG Grid: Found an issue in column ${col.getColId()}. If using React, specify an editor is a popup using colDef.cellEditorPopup=true. AG Grid React cannot depend on the editor component specifying if it's in a popup (via the isPopup() method on the editor), as React needs to know this information BEFORE the component is created.`;
        (0, _agGridCommunity._).doOnce(()=>console.warn(msg), "jsEditorComp-isPopup-" + cellCtrl.getColumn().getColId());
    }
    if (popup && cellEditor.getPopupPosition && cellEditor.getPopupPosition() != null) {
        const msg = `AG Grid: Found an issue in column ${col.getColId()}. If using React, specify an editor popup position using colDef.cellEditorPopupPosition=true. AG Grid React cannot depend on the editor component specifying it's position (via the getPopupPosition() method on the editor), as React needs to know this information BEFORE the component is created.`;
        (0, _agGridCommunity._).doOnce(()=>console.warn(msg), "jsEditorComp-getPopupPosition-" + cellCtrl.getColumn().getColId());
    }
};
var jsxEditorProxy = (editDetails, CellEditorClass, setRef2)=>{
    const { compProxy } = editDetails;
    setRef2(compProxy);
    const props = compProxy.getProps();
    const isStateless = isComponentStateless(CellEditorClass);
    return /* @__PURE__ */ (0, _reactDefault.default).createElement(CustomContext.Provider, {
        value: {
            setMethods: (methods)=>compProxy.setMethods(methods)
        }
    }, isStateless && /* @__PURE__ */ (0, _reactDefault.default).createElement(CellEditorClass, __spreadValues({}, props)), !isStateless && /* @__PURE__ */ (0, _reactDefault.default).createElement(CellEditorClass, __spreadProps(__spreadValues({}, props), {
        ref: (ref)=>compProxy.setRef(ref)
    })));
};
var jsxEditor = (editDetails, CellEditorClass, setRef2)=>{
    const newFormat = editDetails.compProxy;
    return /* @__PURE__ */ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, !newFormat && /* @__PURE__ */ (0, _reactDefault.default).createElement(CellEditorClass, __spreadProps(__spreadValues({}, editDetails.compDetails.params), {
        ref: setRef2
    })), newFormat && jsxEditorProxy(editDetails, CellEditorClass, setRef2));
};
var jsxEditValue = (editDetails, setInlineCellEditorRef, setPopupCellEditorRef, eGui, cellCtrl, jsEditorComp)=>{
    const compDetails = editDetails.compDetails;
    const CellEditorClass = compDetails.componentClass;
    const reactInlineEditor = compDetails.componentFromFramework && !editDetails.popup;
    const reactPopupEditor = compDetails.componentFromFramework && editDetails.popup;
    const jsPopupEditor = !compDetails.componentFromFramework && editDetails.popup;
    return /* @__PURE__ */ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, reactInlineEditor && jsxEditor(editDetails, CellEditorClass, setInlineCellEditorRef), reactPopupEditor && /* @__PURE__ */ (0, _reactDefault.default).createElement(popupEditorComp_default, {
        editDetails,
        cellCtrl,
        eParentCell: eGui,
        wrappedContent: jsxEditor(editDetails, CellEditorClass, setPopupCellEditorRef)
    }), jsPopupEditor && jsEditorComp && /* @__PURE__ */ (0, _reactDefault.default).createElement(popupEditorComp_default, {
        editDetails,
        cellCtrl,
        eParentCell: eGui,
        jsChildComp: jsEditorComp
    }));
};
var jsxShowValue = (showDetails, key, parentId, cellRendererRef, showCellWrapper, reactCellRendererStateless, setECellValue)=>{
    const { compDetails, value } = showDetails;
    const noCellRenderer = !compDetails;
    const reactCellRenderer = compDetails && compDetails.componentFromFramework;
    const CellRendererClass = compDetails && compDetails.componentClass;
    const valueForNoCellRenderer = (value == null ? void 0 : value.toString) ? value.toString() : value;
    const bodyJsxFunc = ()=>/* @__PURE__ */ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, noCellRenderer && /* @__PURE__ */ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, valueForNoCellRenderer), reactCellRenderer && !reactCellRendererStateless && /* @__PURE__ */ (0, _reactDefault.default).createElement(CellRendererClass, __spreadProps(__spreadValues({}, compDetails.params), {
            key,
            ref: cellRendererRef
        })), reactCellRenderer && reactCellRendererStateless && /* @__PURE__ */ (0, _reactDefault.default).createElement(CellRendererClass, __spreadProps(__spreadValues({}, compDetails.params), {
            key
        })));
    return /* @__PURE__ */ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, showCellWrapper ? /* @__PURE__ */ (0, _reactDefault.default).createElement("span", {
        role: "presentation",
        id: `cell-${parentId}`,
        className: "ag-cell-value",
        ref: setECellValue
    }, bodyJsxFunc()) : bodyJsxFunc());
};
var CellComp = (props)=>{
    const { context } = (0, _react.useContext)(BeansContext);
    const { cellCtrl, printLayout, editingRow } = props;
    const tabIndex = cellCtrl.getTabIndex();
    const colId = cellCtrl.getColumnIdSanitised();
    const cellInstanceId = cellCtrl.getInstanceId();
    const [renderDetails, setRenderDetails] = (0, _react.useState)(()=>cellCtrl.isCellRenderer() ? void 0 : {
            compDetails: void 0,
            value: cellCtrl.getValueToDisplay(),
            force: false
        });
    const [editDetails, setEditDetails] = (0, _react.useState)();
    const [renderKey, setRenderKey] = (0, _react.useState)(1);
    const [userStyles, setUserStyles] = (0, _react.useState)();
    const [includeSelection, setIncludeSelection] = (0, _react.useState)(false);
    const [includeRowDrag, setIncludeRowDrag] = (0, _react.useState)(false);
    const [includeDndSource, setIncludeDndSource] = (0, _react.useState)(false);
    const [jsEditorComp, setJsEditorComp] = (0, _react.useState)();
    const forceWrapper = (0, _react.useMemo)(()=>cellCtrl.isForceWrapper(), [
        cellCtrl
    ]);
    const cellAriaRole = (0, _react.useMemo)(()=>cellCtrl.getCellAriaRole(), [
        cellCtrl
    ]);
    const eGui = (0, _react.useRef)(null);
    const cellRendererRef = (0, _react.useRef)(null);
    const jsCellRendererRef = (0, _react.useRef)();
    const cellEditorRef = (0, _react.useRef)();
    const eCellWrapper = (0, _react.useRef)();
    const cellWrapperDestroyFuncs = (0, _react.useRef)([]);
    const eCellValue = (0, _react.useRef)();
    const [cellValueVersion, setCellValueVersion] = (0, _react.useState)(0);
    const setCellValueRef = (0, _react.useCallback)((ref)=>{
        eCellValue.current = ref;
        setCellValueVersion((v)=>v + 1);
    }, []);
    const showTools = renderDetails != null && (includeSelection || includeDndSource || includeRowDrag);
    const showCellWrapper = forceWrapper || showTools;
    const setCellEditorRef = (0, _react.useCallback)((popup, cellEditor)=>{
        cellEditorRef.current = cellEditor;
        if (cellEditor) {
            checkCellEditorDeprecations(popup, cellEditor, cellCtrl);
            const editingCancelledByUserComp = cellEditor.isCancelBeforeStart && cellEditor.isCancelBeforeStart();
            if (editingCancelledByUserComp) setTimeout(()=>{
                cellCtrl.stopEditing(true);
                cellCtrl.focusCell(true);
            });
        }
    }, [
        cellCtrl
    ]);
    const setPopupCellEditorRef = (0, _react.useCallback)((cellRenderer)=>setCellEditorRef(true, cellRenderer), [
        setCellEditorRef
    ]);
    const setInlineCellEditorRef = (0, _react.useCallback)((cellRenderer)=>setCellEditorRef(false, cellRenderer), [
        setCellEditorRef
    ]);
    let cssClassManager = (0, _react.useRef)();
    if (!cssClassManager.current) cssClassManager.current = new (0, _agGridCommunity.CssClassManager)(()=>eGui.current);
    showJsRenderer_default(renderDetails, showCellWrapper, eCellValue.current, cellValueVersion, jsCellRendererRef, eGui);
    const lastRenderDetails = (0, _react.useRef)();
    (0, _react.useLayoutEffect)(()=>{
        const oldDetails = lastRenderDetails.current;
        const newDetails = renderDetails;
        lastRenderDetails.current = renderDetails;
        if (oldDetails == null || oldDetails.compDetails == null || newDetails == null || newDetails.compDetails == null) return;
        const oldCompDetails = oldDetails.compDetails;
        const newCompDetails = newDetails.compDetails;
        if (oldCompDetails.componentClass != newCompDetails.componentClass) return;
        if (cellRendererRef.current == null || cellRendererRef.current.refresh == null) return;
        const result = cellRendererRef.current.refresh(newCompDetails.params);
        if (result != true) setRenderKey((prev)=>prev + 1);
    }, [
        renderDetails
    ]);
    (0, _react.useLayoutEffect)(()=>{
        const doingJsEditor = editDetails && !editDetails.compDetails.componentFromFramework;
        if (!doingJsEditor) return;
        const compDetails = editDetails.compDetails;
        const isPopup = editDetails.popup === true;
        const cellEditor = createSyncJsComp(compDetails);
        if (!cellEditor) return;
        const compGui = cellEditor.getGui();
        setCellEditorRef(isPopup, cellEditor);
        if (!isPopup) {
            const parentEl = (forceWrapper ? eCellWrapper : eGui).current;
            parentEl == null || parentEl.appendChild(compGui);
            cellEditor.afterGuiAttached && cellEditor.afterGuiAttached();
        }
        setJsEditorComp(cellEditor);
        return ()=>{
            context.destroyBean(cellEditor);
            setCellEditorRef(isPopup, void 0);
            setJsEditorComp(void 0);
            if (compGui && compGui.parentElement) compGui.parentElement.removeChild(compGui);
        };
    }, [
        editDetails
    ]);
    const setCellWrapperRef = (0, _react.useCallback)((ref)=>{
        eCellWrapper.current = ref;
        if (!eCellWrapper.current) {
            cellWrapperDestroyFuncs.current.forEach((f)=>f());
            cellWrapperDestroyFuncs.current = [];
            return;
        }
        const addComp = (comp)=>{
            var _a;
            if (comp) {
                const eGui2 = comp.getGui();
                (_a = eCellWrapper.current) == null || _a.insertAdjacentElement("afterbegin", eGui2);
                cellWrapperDestroyFuncs.current.push(()=>{
                    context.destroyBean(comp);
                    (0, _agGridCommunity._).removeFromParent(eGui2);
                });
            }
            return comp;
        };
        if (includeSelection) {
            const checkboxSelectionComp = cellCtrl.createSelectionCheckbox();
            addComp(checkboxSelectionComp);
        }
        if (includeDndSource) addComp(cellCtrl.createDndSource());
        if (includeRowDrag) addComp(cellCtrl.createRowDragComp());
    }, [
        cellCtrl,
        context,
        includeDndSource,
        includeRowDrag,
        includeSelection
    ]);
    const setRef2 = (0, _react.useCallback)((ref)=>{
        eGui.current = ref;
        if (!eGui.current) return;
        if (!cellCtrl) return;
        const compProxy = {
            addOrRemoveCssClass: (name, on)=>cssClassManager.current.addOrRemoveCssClass(name, on),
            setUserStyles: (styles)=>setUserStyles(styles),
            getFocusableElement: ()=>eGui.current,
            setIncludeSelection: (include)=>setIncludeSelection(include),
            setIncludeRowDrag: (include)=>setIncludeRowDrag(include),
            setIncludeDndSource: (include)=>setIncludeDndSource(include),
            getCellEditor: ()=>cellEditorRef.current || null,
            getCellRenderer: ()=>cellRendererRef.current ? cellRendererRef.current : jsCellRendererRef.current,
            getParentOfValue: ()=>eCellValue.current ? eCellValue.current : eCellWrapper.current ? eCellWrapper.current : eGui.current,
            setRenderDetails: (compDetails, value, force)=>{
                setRenderDetails((prev)=>{
                    if ((prev == null ? void 0 : prev.compDetails) !== compDetails || (prev == null ? void 0 : prev.value) !== value || (prev == null ? void 0 : prev.force) !== force) return {
                        value,
                        compDetails,
                        force
                    };
                    else return prev;
                });
            },
            setEditDetails: (compDetails, popup, popupPosition, reactiveCustomComponents)=>{
                if (compDetails) {
                    let compProxy2 = void 0;
                    if (reactiveCustomComponents) compProxy2 = new CellEditorComponentProxy(compDetails.params, ()=>setRenderKey((prev)=>prev + 1));
                    else if (compDetails.componentFromFramework) warnReactiveCustomComponents();
                    setEditDetails({
                        compDetails,
                        popup,
                        popupPosition,
                        compProxy: compProxy2
                    });
                    if (!popup) setRenderDetails(void 0);
                } else setEditDetails((editDetails2)=>{
                    if (editDetails2 == null ? void 0 : editDetails2.compProxy) cellEditorRef.current = void 0;
                    return void 0;
                });
            }
        };
        const cellWrapperOrUndefined = eCellWrapper.current || void 0;
        cellCtrl.setComp(compProxy, eGui.current, cellWrapperOrUndefined, printLayout, editingRow);
    }, []);
    const reactCellRendererStateless = (0, _react.useMemo)(()=>{
        const res = renderDetails && renderDetails.compDetails && renderDetails.compDetails.componentFromFramework && isComponentStateless(renderDetails.compDetails.componentClass);
        return !!res;
    }, [
        renderDetails
    ]);
    (0, _react.useLayoutEffect)(()=>{
        var _a;
        if (!eGui.current) return;
        cssClassManager.current.addOrRemoveCssClass("ag-cell-value", !showCellWrapper);
        cssClassManager.current.addOrRemoveCssClass("ag-cell-inline-editing", !!editDetails && !editDetails.popup);
        cssClassManager.current.addOrRemoveCssClass("ag-cell-popup-editing", !!editDetails && !!editDetails.popup);
        cssClassManager.current.addOrRemoveCssClass("ag-cell-not-inline-editing", !editDetails || !!editDetails.popup);
        (_a = cellCtrl.getRowCtrl()) == null || _a.setInlineEditingCss(!!editDetails);
        if (cellCtrl.shouldRestoreFocus() && !cellCtrl.isEditing()) eGui.current.focus({
            preventScroll: true
        });
    });
    const showContents = ()=>/* @__PURE__ */ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, renderDetails != null && jsxShowValue(renderDetails, renderKey, cellInstanceId, cellRendererRef, showCellWrapper, reactCellRendererStateless, setCellValueRef), editDetails != null && jsxEditValue(editDetails, setInlineCellEditorRef, setPopupCellEditorRef, eGui.current, cellCtrl, jsEditorComp));
    return /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        ref: setRef2,
        style: userStyles,
        tabIndex,
        role: cellAriaRole,
        "col-id": colId
    }, showCellWrapper ? /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        className: "ag-cell-wrapper",
        role: "presentation",
        ref: setCellWrapperRef
    }, showContents()) : showContents());
};
var cellComp_default = (0, _react.memo)(CellComp);
// packages/ag-grid-react/src/reactUi/rows/rowComp.tsx
var RowComp = (params)=>{
    const { context, gos } = (0, _react.useContext)(BeansContext);
    const { rowCtrl, containerType } = params;
    const tabIndex = rowCtrl.getTabIndex();
    const domOrderRef = (0, _react.useRef)(rowCtrl.getDomOrder());
    const isFullWidth = rowCtrl.isFullWidth();
    const isDisplayed = rowCtrl.getRowNode().displayed;
    const [rowIndex, setRowIndex] = (0, _react.useState)(()=>isDisplayed ? rowCtrl.getRowIndex() : null);
    const [rowId, setRowId] = (0, _react.useState)(()=>rowCtrl.getRowId());
    const [rowBusinessKey, setRowBusinessKey] = (0, _react.useState)(()=>rowCtrl.getBusinessKey());
    const [userStyles, setUserStyles] = (0, _react.useState)(()=>rowCtrl.getRowStyles());
    const cellCtrlsRef = (0, _react.useRef)(null);
    const prevCellCtrlsRef = (0, _react.useRef)(null);
    const [cellCtrls, setCellCtrls] = (0, _react.useState)(()=>null);
    const [fullWidthCompDetails, setFullWidthCompDetails] = (0, _react.useState)();
    const [top, setTop] = (0, _react.useState)(()=>isDisplayed ? rowCtrl.getInitialRowTop(containerType) : void 0);
    const [transform, setTransform] = (0, _react.useState)(()=>isDisplayed ? rowCtrl.getInitialTransform(containerType) : void 0);
    const eGui = (0, _react.useRef)(null);
    const fullWidthCompRef = (0, _react.useRef)();
    const autoHeightSetup = (0, _react.useRef)(false);
    const [autoHeightSetupAttempt, setAutoHeightSetupAttempt] = (0, _react.useState)(0);
    (0, _react.useEffect)(()=>{
        var _a;
        if (autoHeightSetup.current) return;
        if (!fullWidthCompDetails) return;
        if (autoHeightSetupAttempt > 10) return;
        const eChild = (_a = eGui.current) == null ? void 0 : _a.firstChild;
        if (eChild) {
            rowCtrl.setupDetailRowAutoHeight(eChild);
            autoHeightSetup.current = true;
        } else setAutoHeightSetupAttempt((prev)=>prev + 1);
    }, [
        fullWidthCompDetails,
        autoHeightSetupAttempt
    ]);
    let cssClassManager = (0, _react.useRef)();
    if (!cssClassManager.current) cssClassManager.current = new (0, _agGridCommunity.CssClassManager)(()=>eGui.current);
    const setRef2 = (0, _react.useCallback)((e)=>{
        eGui.current = e;
        if (!eGui.current) {
            rowCtrl.unsetComp(containerType);
            return;
        }
        if (!rowCtrl.isAlive()) return;
        const compProxy = {
            // the rowTop is managed by state, instead of direct style manipulation by rowCtrl (like all the other styles)
            // as we need to have an initial value when it's placed into he DOM for the first time, for animation to work.
            setTop,
            setTransform,
            // i found using React for managing classes at the row level was to slow, as modifying classes caused a lot of
            // React code to execute, so avoiding React for managing CSS Classes made the grid go much faster.
            addOrRemoveCssClass: (name, on)=>cssClassManager.current.addOrRemoveCssClass(name, on),
            setDomOrder: (domOrder)=>domOrderRef.current = domOrder,
            setRowIndex,
            setRowId,
            setRowBusinessKey,
            setUserStyles,
            // if we don't maintain the order, then cols will be ripped out and into the dom
            // when cols reordered, which would stop the CSS transitions from working
            setCellCtrls: (next, useFlushSync)=>{
                prevCellCtrlsRef.current = cellCtrlsRef.current;
                cellCtrlsRef.current = next;
                const nextCells = getNextValueIfDifferent(prevCellCtrlsRef.current, next, domOrderRef.current);
                if (nextCells !== prevCellCtrlsRef.current) agFlushSync(useFlushSync, ()=>setCellCtrls(nextCells));
            },
            showFullWidth: (compDetails)=>setFullWidthCompDetails(compDetails),
            getFullWidthCellRenderer: ()=>fullWidthCompRef.current,
            refreshFullWidth: (getUpdatedParams)=>{
                if (canRefreshFullWidthRef.current) {
                    setFullWidthCompDetails((prevFullWidthCompDetails)=>__spreadProps(__spreadValues({}, prevFullWidthCompDetails), {
                            params: getUpdatedParams()
                        }));
                    return true;
                } else {
                    if (!fullWidthCompRef.current || !fullWidthCompRef.current.refresh) return false;
                    return fullWidthCompRef.current.refresh(getUpdatedParams());
                }
            }
        };
        rowCtrl.setComp(compProxy, eGui.current, containerType);
    }, []);
    (0, _react.useLayoutEffect)(()=>showJsComp(fullWidthCompDetails, context, eGui.current, fullWidthCompRef), [
        fullWidthCompDetails
    ]);
    const rowStyles = (0, _react.useMemo)(()=>{
        const res = {
            top,
            transform
        };
        Object.assign(res, userStyles);
        return res;
    }, [
        top,
        transform,
        userStyles
    ]);
    const showFullWidthFramework = isFullWidth && fullWidthCompDetails && fullWidthCompDetails.componentFromFramework;
    const showCells = !isFullWidth && cellCtrls != null;
    const reactFullWidthCellRendererStateless = (0, _react.useMemo)(()=>{
        const res = (fullWidthCompDetails == null ? void 0 : fullWidthCompDetails.componentFromFramework) && isComponentStateless(fullWidthCompDetails.componentClass);
        return !!res;
    }, [
        fullWidthCompDetails
    ]);
    const canRefreshFullWidthRef = (0, _react.useRef)(false);
    (0, _react.useEffect)(()=>{
        canRefreshFullWidthRef.current = reactFullWidthCellRendererStateless && !!fullWidthCompDetails && !!gos.get("reactiveCustomComponents");
    }, [
        reactFullWidthCellRendererStateless,
        fullWidthCompDetails
    ]);
    const showCellsJsx = ()=>cellCtrls == null ? void 0 : cellCtrls.map((cellCtrl)=>/* @__PURE__ */ (0, _reactDefault.default).createElement(cellComp_default, {
                cellCtrl,
                editingRow: rowCtrl.isEditing(),
                printLayout: rowCtrl.isPrintLayout(),
                key: cellCtrl.getInstanceId()
            }));
    const showFullWidthFrameworkJsx = ()=>{
        const FullWidthComp = fullWidthCompDetails.componentClass;
        return /* @__PURE__ */ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, reactFullWidthCellRendererStateless && /* @__PURE__ */ (0, _reactDefault.default).createElement(FullWidthComp, __spreadValues({}, fullWidthCompDetails.params)), !reactFullWidthCellRendererStateless && /* @__PURE__ */ (0, _reactDefault.default).createElement(FullWidthComp, __spreadProps(__spreadValues({}, fullWidthCompDetails.params), {
            ref: fullWidthCompRef
        })));
    };
    return /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        ref: setRef2,
        role: "row",
        style: rowStyles,
        "row-index": rowIndex,
        "row-id": rowId,
        "row-business-key": rowBusinessKey,
        tabIndex
    }, showCells && showCellsJsx(), showFullWidthFramework && showFullWidthFrameworkJsx());
};
var rowComp_default = (0, _react.memo)(RowComp);
// packages/ag-grid-react/src/reactUi/rows/rowContainerComp.tsx
var RowContainerComp = (params)=>{
    const { context } = (0, _react.useContext)(BeansContext);
    const { name } = params;
    const containerType = (0, _react.useMemo)(()=>(0, _agGridCommunity.getRowContainerTypeForName)(name), [
        name
    ]);
    const eViewport = (0, _react.useRef)(null);
    const eContainer = (0, _react.useRef)(null);
    const rowCtrlsRef = (0, _react.useRef)([]);
    const prevRowCtrlsRef = (0, _react.useRef)([]);
    const [rowCtrlsOrdered, setRowCtrlsOrdered] = (0, _react.useState)(()=>[]);
    const domOrderRef = (0, _react.useRef)(false);
    const rowContainerCtrlRef = (0, _react.useRef)();
    const cssClasses = (0, _react.useMemo)(()=>(0, _agGridCommunity.RowContainerCtrl).getRowContainerCssClasses(name), [
        name
    ]);
    const viewportClasses = (0, _react.useMemo)(()=>classesList(cssClasses.viewport), [
        cssClasses
    ]);
    const containerClasses = (0, _react.useMemo)(()=>classesList(cssClasses.container), [
        cssClasses
    ]);
    const centerTemplate = name === (0, _agGridCommunity.RowContainerName).CENTER || name === (0, _agGridCommunity.RowContainerName).TOP_CENTER || name === (0, _agGridCommunity.RowContainerName).BOTTOM_CENTER || name === (0, _agGridCommunity.RowContainerName).STICKY_TOP_CENTER || name === (0, _agGridCommunity.RowContainerName).STICKY_BOTTOM_CENTER;
    const topLevelRef = centerTemplate ? eViewport : eContainer;
    reactComment_default(" AG Row Container " + name + " ", topLevelRef);
    const areElementsReady = (0, _react.useCallback)(()=>{
        if (centerTemplate) return eViewport.current != null && eContainer.current != null;
        return eContainer.current != null;
    }, []);
    const areElementsRemoved = (0, _react.useCallback)(()=>{
        if (centerTemplate) return eViewport.current == null && eContainer.current == null;
        return eContainer.current == null;
    }, []);
    const setRef2 = (0, _react.useCallback)(()=>{
        if (areElementsRemoved()) {
            context.destroyBean(rowContainerCtrlRef.current);
            rowContainerCtrlRef.current = null;
        }
        if (areElementsReady()) {
            const updateRowCtrlsOrdered = (useFlushSync)=>{
                const next = getNextValueIfDifferent(prevRowCtrlsRef.current, rowCtrlsRef.current, domOrderRef.current);
                if (next !== prevRowCtrlsRef.current) {
                    prevRowCtrlsRef.current = next;
                    agFlushSync(useFlushSync, ()=>setRowCtrlsOrdered(next));
                }
            };
            const compProxy = {
                setViewportHeight: (height)=>{
                    if (eViewport.current) eViewport.current.style.height = height;
                },
                setRowCtrls: ({ rowCtrls, useFlushSync })=>{
                    const useFlush = !!useFlushSync && rowCtrlsRef.current.length > 0 && rowCtrls.length > 0;
                    rowCtrlsRef.current = rowCtrls;
                    updateRowCtrlsOrdered(useFlush);
                },
                setDomOrder: (domOrder)=>{
                    if (domOrderRef.current != domOrder) {
                        domOrderRef.current = domOrder;
                        updateRowCtrlsOrdered(false);
                    }
                },
                setContainerWidth: (width)=>{
                    if (eContainer.current) eContainer.current.style.width = width;
                }
            };
            rowContainerCtrlRef.current = context.createBean(new (0, _agGridCommunity.RowContainerCtrl)(name));
            rowContainerCtrlRef.current.setComp(compProxy, eContainer.current, eViewport.current);
        }
    }, [
        areElementsReady,
        areElementsRemoved
    ]);
    const setContainerRef = (0, _react.useCallback)((e)=>{
        eContainer.current = e;
        setRef2();
    }, [
        setRef2
    ]);
    const setViewportRef = (0, _react.useCallback)((e)=>{
        eViewport.current = e;
        setRef2();
    }, [
        setRef2
    ]);
    const buildContainer = ()=>/* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
            className: containerClasses,
            ref: setContainerRef,
            role: "rowgroup"
        }, rowCtrlsOrdered.map((rowCtrl)=>/* @__PURE__ */ (0, _reactDefault.default).createElement(rowComp_default, {
                rowCtrl,
                containerType,
                key: rowCtrl.getInstanceId()
            })));
    return /* @__PURE__ */ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, centerTemplate ? /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        className: viewportClasses,
        ref: setViewportRef,
        role: "presentation"
    }, buildContainer()) : buildContainer());
};
var rowContainerComp_default = (0, _react.memo)(RowContainerComp);
// packages/ag-grid-react/src/reactUi/gridBodyComp.tsx
var GridBodyComp = ()=>{
    const { context, agStackComponentsRegistry, resizeObserverService } = (0, _react.useContext)(BeansContext);
    const [rowAnimationClass, setRowAnimationClass] = (0, _react.useState)("");
    const [topHeight, setTopHeight] = (0, _react.useState)(0);
    const [bottomHeight, setBottomHeight] = (0, _react.useState)(0);
    const [stickyTopHeight, setStickyTopHeight] = (0, _react.useState)("0px");
    const [stickyTopTop, setStickyTopTop] = (0, _react.useState)("0px");
    const [stickyTopWidth, setStickyTopWidth] = (0, _react.useState)("100%");
    const [stickyBottomHeight, setStickyBottomHeight] = (0, _react.useState)("0px");
    const [stickyBottomBottom, setStickyBottomBottom] = (0, _react.useState)("0px");
    const [stickyBottomWidth, setStickyBottomWidth] = (0, _react.useState)("100%");
    const [topDisplay, setTopDisplay] = (0, _react.useState)("");
    const [bottomDisplay, setBottomDisplay] = (0, _react.useState)("");
    const [forceVerticalScrollClass, setForceVerticalScrollClass] = (0, _react.useState)(null);
    const [topAndBottomOverflowY, setTopAndBottomOverflowY] = (0, _react.useState)("");
    const [cellSelectableCss, setCellSelectableCss] = (0, _react.useState)(null);
    const [layoutClass, setLayoutClass] = (0, _react.useState)("ag-layout-normal");
    let cssClassManager = (0, _react.useRef)();
    if (!cssClassManager.current) cssClassManager.current = new (0, _agGridCommunity.CssClassManager)(()=>eRoot.current);
    const eRoot = (0, _react.useRef)(null);
    const eTop = (0, _react.useRef)(null);
    const eStickyTop = (0, _react.useRef)(null);
    const eStickyBottom = (0, _react.useRef)(null);
    const eBody = (0, _react.useRef)(null);
    const eBodyViewport = (0, _react.useRef)(null);
    const eBottom = (0, _react.useRef)(null);
    const beansToDestroy = (0, _react.useRef)([]);
    const destroyFuncs = (0, _react.useRef)([]);
    reactComment_default(" AG Grid Body ", eRoot);
    reactComment_default(" AG Pinned Top ", eTop);
    reactComment_default(" AG Sticky Top ", eStickyTop);
    reactComment_default(" AG Middle ", eBodyViewport);
    reactComment_default(" AG Pinned Bottom ", eBottom);
    const setRef2 = (0, _react.useCallback)((e)=>{
        eRoot.current = e;
        if (!eRoot.current) {
            context.destroyBeans(beansToDestroy.current);
            destroyFuncs.current.forEach((f)=>f());
            beansToDestroy.current = [];
            destroyFuncs.current = [];
            return;
        }
        if (!context) return;
        const newComp = (tag)=>{
            const CompClass = agStackComponentsRegistry.getComponentClass(tag);
            const comp = context.createBean(new CompClass());
            beansToDestroy.current.push(comp);
            return comp;
        };
        const attachToDom = (eParent, eChild)=>{
            eParent.appendChild(eChild);
            destroyFuncs.current.push(()=>eParent.removeChild(eChild));
        };
        attachToDom(eRoot.current, document.createComment(" AG Fake Horizontal Scroll "));
        attachToDom(eRoot.current, newComp("AG-FAKE-HORIZONTAL-SCROLL").getGui());
        attachToDom(eRoot.current, document.createComment(" AG Overlay Wrapper "));
        attachToDom(eRoot.current, newComp("AG-OVERLAY-WRAPPER").getGui());
        if (eBody.current) {
            attachToDom(eBody.current, document.createComment(" AG Fake Vertical Scroll "));
            attachToDom(eBody.current, newComp("AG-FAKE-VERTICAL-SCROLL").getGui());
        }
        const compProxy = {
            setRowAnimationCssOnBodyViewport: setRowAnimationClass,
            setColumnCount: (count)=>{
                if (eRoot.current) (0, _agGridCommunity._).setAriaColCount(eRoot.current, count);
            },
            setRowCount: (count)=>{
                if (eRoot.current) (0, _agGridCommunity._).setAriaRowCount(eRoot.current, count);
            },
            setTopHeight,
            setBottomHeight,
            setStickyTopHeight,
            setStickyTopTop,
            setStickyTopWidth,
            setTopDisplay,
            setBottomDisplay,
            setColumnMovingCss: (cssClass, flag)=>cssClassManager.current.addOrRemoveCssClass(cssClass, flag),
            updateLayoutClasses: setLayoutClass,
            setAlwaysVerticalScrollClass: setForceVerticalScrollClass,
            setPinnedTopBottomOverflowY: setTopAndBottomOverflowY,
            setCellSelectableCss: (cssClass, flag)=>setCellSelectableCss(flag ? cssClass : null),
            setBodyViewportWidth: (width)=>{
                if (eBodyViewport.current) eBodyViewport.current.style.width = width;
            },
            registerBodyViewportResizeListener: (listener)=>{
                if (eBodyViewport.current) {
                    const unsubscribeFromResize = resizeObserverService.observeResize(eBodyViewport.current, listener);
                    destroyFuncs.current.push(()=>unsubscribeFromResize());
                }
            },
            setStickyBottomHeight,
            setStickyBottomBottom,
            setStickyBottomWidth
        };
        const ctrl = context.createBean(new (0, _agGridCommunity.GridBodyCtrl)());
        beansToDestroy.current.push(ctrl);
        ctrl.setComp(compProxy, eRoot.current, eBodyViewport.current, eTop.current, eBottom.current, eStickyTop.current, eStickyBottom.current);
    }, []);
    const rootClasses = (0, _react.useMemo)(()=>classesList("ag-root", "ag-unselectable", layoutClass), [
        layoutClass
    ]);
    const bodyViewportClasses = (0, _react.useMemo)(()=>classesList("ag-body-viewport", rowAnimationClass, layoutClass, forceVerticalScrollClass, cellSelectableCss), [
        rowAnimationClass,
        layoutClass,
        forceVerticalScrollClass,
        cellSelectableCss
    ]);
    const bodyClasses = (0, _react.useMemo)(()=>classesList("ag-body", layoutClass), [
        layoutClass
    ]);
    const topClasses = (0, _react.useMemo)(()=>classesList("ag-floating-top", cellSelectableCss), [
        cellSelectableCss
    ]);
    const stickyTopClasses = (0, _react.useMemo)(()=>classesList("ag-sticky-top", cellSelectableCss), [
        cellSelectableCss
    ]);
    const stickyBottomClasses = (0, _react.useMemo)(()=>classesList("ag-sticky-bottom", cellSelectableCss), [
        cellSelectableCss
    ]);
    const bottomClasses = (0, _react.useMemo)(()=>classesList("ag-floating-bottom", cellSelectableCss), [
        cellSelectableCss
    ]);
    const topStyle = (0, _react.useMemo)(()=>({
            height: topHeight,
            minHeight: topHeight,
            display: topDisplay,
            overflowY: topAndBottomOverflowY
        }), [
        topHeight,
        topDisplay,
        topAndBottomOverflowY
    ]);
    const stickyTopStyle = (0, _react.useMemo)(()=>({
            height: stickyTopHeight,
            top: stickyTopTop,
            width: stickyTopWidth
        }), [
        stickyTopHeight,
        stickyTopTop,
        stickyTopWidth
    ]);
    const stickyBottomStyle = (0, _react.useMemo)(()=>({
            height: stickyBottomHeight,
            bottom: stickyBottomBottom,
            width: stickyBottomWidth
        }), [
        stickyBottomHeight,
        stickyBottomBottom,
        stickyBottomWidth
    ]);
    const bottomStyle = (0, _react.useMemo)(()=>({
            height: bottomHeight,
            minHeight: bottomHeight,
            display: bottomDisplay,
            overflowY: topAndBottomOverflowY
        }), [
        bottomHeight,
        bottomDisplay,
        topAndBottomOverflowY
    ]);
    const createRowContainer = (container)=>/* @__PURE__ */ (0, _reactDefault.default).createElement(rowContainerComp_default, {
            name: container,
            key: `${container}-container`
        });
    const createSection = ({ section, children, className, style })=>/* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
            ref: section,
            className,
            role: "presentation",
            style
        }, children.map(createRowContainer));
    return /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        ref: setRef2,
        className: rootClasses,
        role: "treegrid"
    }, /* @__PURE__ */ (0, _reactDefault.default).createElement(gridHeaderComp_default, null), createSection({
        section: eTop,
        className: topClasses,
        style: topStyle,
        children: [
            (0, _agGridCommunity.RowContainerName).TOP_LEFT,
            (0, _agGridCommunity.RowContainerName).TOP_CENTER,
            (0, _agGridCommunity.RowContainerName).TOP_RIGHT,
            (0, _agGridCommunity.RowContainerName).TOP_FULL_WIDTH
        ]
    }), /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        className: bodyClasses,
        ref: eBody,
        role: "presentation"
    }, createSection({
        section: eBodyViewport,
        className: bodyViewportClasses,
        children: [
            (0, _agGridCommunity.RowContainerName).LEFT,
            (0, _agGridCommunity.RowContainerName).CENTER,
            (0, _agGridCommunity.RowContainerName).RIGHT,
            (0, _agGridCommunity.RowContainerName).FULL_WIDTH
        ]
    })), createSection({
        section: eStickyTop,
        className: stickyTopClasses,
        style: stickyTopStyle,
        children: [
            (0, _agGridCommunity.RowContainerName).STICKY_TOP_LEFT,
            (0, _agGridCommunity.RowContainerName).STICKY_TOP_CENTER,
            (0, _agGridCommunity.RowContainerName).STICKY_TOP_RIGHT,
            (0, _agGridCommunity.RowContainerName).STICKY_TOP_FULL_WIDTH
        ]
    }), createSection({
        section: eStickyBottom,
        className: stickyBottomClasses,
        style: stickyBottomStyle,
        children: [
            (0, _agGridCommunity.RowContainerName).STICKY_BOTTOM_LEFT,
            (0, _agGridCommunity.RowContainerName).STICKY_BOTTOM_CENTER,
            (0, _agGridCommunity.RowContainerName).STICKY_BOTTOM_RIGHT,
            (0, _agGridCommunity.RowContainerName).STICKY_BOTTOM_FULL_WIDTH
        ]
    }), createSection({
        section: eBottom,
        className: bottomClasses,
        style: bottomStyle,
        children: [
            (0, _agGridCommunity.RowContainerName).BOTTOM_LEFT,
            (0, _agGridCommunity.RowContainerName).BOTTOM_CENTER,
            (0, _agGridCommunity.RowContainerName).BOTTOM_RIGHT,
            (0, _agGridCommunity.RowContainerName).BOTTOM_FULL_WIDTH
        ]
    }));
};
var gridBodyComp_default = (0, _react.memo)(GridBodyComp);
var TabGuardCompRef = (props, forwardRef4)=>{
    const { children, eFocusableElement, onTabKeyDown, gridCtrl, forceFocusOutWhenTabGuardsAreEmpty } = props;
    const { context } = (0, _react.useContext)(BeansContext);
    const topTabGuardRef = (0, _react.useRef)(null);
    const bottomTabGuardRef = (0, _react.useRef)(null);
    const tabGuardCtrlRef = (0, _react.useRef)();
    const setTabIndex = (value)=>{
        const processedValue = value == null ? void 0 : parseInt(value, 10).toString();
        [
            topTabGuardRef,
            bottomTabGuardRef
        ].forEach((tabGuard)=>{
            var _a, _b;
            if (processedValue === void 0) (_a = tabGuard.current) == null || _a.removeAttribute("tabindex");
            else (_b = tabGuard.current) == null || _b.setAttribute("tabindex", processedValue);
        });
    };
    (0, _react.useImperativeHandle)(forwardRef4, ()=>({
            forceFocusOutOfContainer (up) {
                var _a;
                (_a = tabGuardCtrlRef.current) == null || _a.forceFocusOutOfContainer(up);
            }
        }));
    const setupCtrl = (0, _react.useCallback)(()=>{
        if (!topTabGuardRef.current && !bottomTabGuardRef.current) {
            context.destroyBean(tabGuardCtrlRef.current);
            tabGuardCtrlRef.current = null;
            return;
        }
        if (topTabGuardRef.current && bottomTabGuardRef.current) {
            const compProxy = {
                setTabIndex
            };
            tabGuardCtrlRef.current = context.createBean(new (0, _agGridCommunity.TabGuardCtrl)({
                comp: compProxy,
                eTopGuard: topTabGuardRef.current,
                eBottomGuard: bottomTabGuardRef.current,
                eFocusableElement,
                onTabKeyDown,
                forceFocusOutWhenTabGuardsAreEmpty,
                focusInnerElement: (fromBottom)=>gridCtrl.focusInnerElement(fromBottom)
            }));
        }
    }, []);
    const setTopRef = (0, _react.useCallback)((e)=>{
        topTabGuardRef.current = e;
        setupCtrl();
    }, [
        setupCtrl
    ]);
    const setBottomRef = (0, _react.useCallback)((e)=>{
        bottomTabGuardRef.current = e;
        setupCtrl();
    }, [
        setupCtrl
    ]);
    const createTabGuard = (side)=>{
        const className = side === "top" ? (0, _agGridCommunity.TabGuardClassNames).TAB_GUARD_TOP : (0, _agGridCommunity.TabGuardClassNames).TAB_GUARD_BOTTOM;
        return /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
            className: `${(0, _agGridCommunity.TabGuardClassNames).TAB_GUARD} ${className}`,
            role: "presentation",
            ref: side === "top" ? setTopRef : setBottomRef
        });
    };
    return /* @__PURE__ */ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, createTabGuard("top"), children, createTabGuard("bottom"));
};
var TabGuardComp = (0, _react.forwardRef)(TabGuardCompRef);
var tabGuardComp_default = (0, _react.memo)(TabGuardComp);
// packages/ag-grid-react/src/reactUi/gridComp.tsx
var GridComp = ({ context })=>{
    const [rtlClass, setRtlClass] = (0, _react.useState)("");
    const [keyboardFocusClass, setKeyboardFocusClass] = (0, _react.useState)("");
    const [layoutClass, setLayoutClass] = (0, _react.useState)("");
    const [cursor, setCursor] = (0, _react.useState)(null);
    const [userSelect, setUserSelect] = (0, _react.useState)(null);
    const [initialised, setInitialised] = (0, _react.useState)(false);
    const [tabGuardReady, setTabGuardReady] = (0, _react.useState)();
    const gridCtrlRef = (0, _react.useRef)(null);
    const eRootWrapperRef = (0, _react.useRef)(null);
    const tabGuardRef = (0, _react.useRef)();
    const [eGridBodyParent, setGridBodyParent] = (0, _react.useState)(null);
    const focusInnerElementRef = (0, _react.useRef)(()=>void 0);
    const onTabKeyDown = (0, _react.useCallback)(()=>void 0, []);
    const beans = (0, _react.useMemo)(()=>{
        if (context.isDestroyed()) return null;
        return context.getBean("beans");
    }, [
        context
    ]);
    reactComment_default(" AG Grid ", eRootWrapperRef);
    const setRef2 = (0, _react.useCallback)((e)=>{
        eRootWrapperRef.current = e;
        if (!eRootWrapperRef.current) {
            context.destroyBean(gridCtrlRef.current);
            gridCtrlRef.current = null;
            return;
        }
        if (context.isDestroyed()) return;
        gridCtrlRef.current = context.createBean(new (0, _agGridCommunity.GridCtrl)());
        const gridCtrl = gridCtrlRef.current;
        focusInnerElementRef.current = gridCtrl.focusInnerElement.bind(gridCtrl);
        const compProxy = {
            destroyGridUi: ()=>{},
            // do nothing, as framework users destroy grid by removing the comp
            setRtlClass,
            forceFocusOutOfContainer: (up)=>{
                var _a;
                (_a = tabGuardRef.current) == null || _a.forceFocusOutOfContainer(up);
            },
            updateLayoutClasses: setLayoutClass,
            getFocusableContainers: ()=>{
                var _a, _b;
                const els = [];
                const gridBodyCompEl = (_a = eRootWrapperRef.current) == null ? void 0 : _a.querySelector(".ag-root");
                const sideBarEl = (_b = eRootWrapperRef.current) == null ? void 0 : _b.querySelector(".ag-side-bar:not(.ag-hidden)");
                if (gridBodyCompEl) els.push(gridBodyCompEl);
                if (sideBarEl) els.push(sideBarEl);
                return els;
            },
            setCursor,
            setUserSelect
        };
        gridCtrl.setComp(compProxy, eRootWrapperRef.current, eRootWrapperRef.current);
        setInitialised(true);
    }, []);
    (0, _react.useEffect)(()=>{
        if (!tabGuardReady || !beans || !gridCtrlRef.current || !eGridBodyParent || !eRootWrapperRef.current) return;
        const gridCtrl = gridCtrlRef.current;
        const beansToDestroy = [];
        const { agStackComponentsRegistry } = beans;
        const HeaderDropZonesClass = agStackComponentsRegistry.getComponentClass("AG-GRID-HEADER-DROP-ZONES");
        const SideBarClass = agStackComponentsRegistry.getComponentClass("AG-SIDE-BAR");
        const StatusBarClass = agStackComponentsRegistry.getComponentClass("AG-STATUS-BAR");
        const WatermarkClass = agStackComponentsRegistry.getComponentClass("AG-WATERMARK");
        const PaginationClass = agStackComponentsRegistry.getComponentClass("AG-PAGINATION");
        const additionalEls = [];
        const eRootWrapper = eRootWrapperRef.current;
        if (gridCtrl.showDropZones() && HeaderDropZonesClass) {
            const headerDropZonesComp = context.createBean(new HeaderDropZonesClass());
            const eGui = headerDropZonesComp.getGui();
            eRootWrapper.insertAdjacentElement("afterbegin", eGui);
            additionalEls.push(eGui);
            beansToDestroy.push(headerDropZonesComp);
        }
        if (gridCtrl.showSideBar() && SideBarClass) {
            const sideBarComp = context.createBean(new SideBarClass());
            const eGui = sideBarComp.getGui();
            const bottomTabGuard = eGridBodyParent.querySelector(".ag-tab-guard-bottom");
            if (bottomTabGuard) {
                bottomTabGuard.insertAdjacentElement("beforebegin", eGui);
                additionalEls.push(eGui);
            }
            beansToDestroy.push(sideBarComp);
        }
        if (gridCtrl.showStatusBar() && StatusBarClass) {
            const statusBarComp = context.createBean(new StatusBarClass());
            const eGui = statusBarComp.getGui();
            eRootWrapper.insertAdjacentElement("beforeend", eGui);
            additionalEls.push(eGui);
            beansToDestroy.push(statusBarComp);
        }
        if (PaginationClass) {
            const paginationComp = context.createBean(new PaginationClass());
            const eGui = paginationComp.getGui();
            eRootWrapper.insertAdjacentElement("beforeend", eGui);
            additionalEls.push(eGui);
            beansToDestroy.push(paginationComp);
        }
        if (gridCtrl.showWatermark() && WatermarkClass) {
            const watermarkComp = context.createBean(new WatermarkClass());
            const eGui = watermarkComp.getGui();
            eRootWrapper.insertAdjacentElement("beforeend", eGui);
            additionalEls.push(eGui);
            beansToDestroy.push(watermarkComp);
        }
        return ()=>{
            context.destroyBeans(beansToDestroy);
            additionalEls.forEach((el)=>{
                if (el.parentElement) el.parentElement.removeChild(el);
            });
        };
    }, [
        tabGuardReady,
        eGridBodyParent,
        beans
    ]);
    const rootWrapperClasses = (0, _react.useMemo)(()=>classesList("ag-root-wrapper", rtlClass, keyboardFocusClass, layoutClass), [
        rtlClass,
        keyboardFocusClass,
        layoutClass
    ]);
    const rootWrapperBodyClasses = (0, _react.useMemo)(()=>classesList("ag-root-wrapper-body", "ag-focus-managed", layoutClass), [
        layoutClass
    ]);
    const topStyle = (0, _react.useMemo)(()=>({
            userSelect: userSelect != null ? userSelect : "",
            WebkitUserSelect: userSelect != null ? userSelect : "",
            cursor: cursor != null ? cursor : ""
        }), [
        userSelect,
        cursor
    ]);
    const setTabGuardCompRef = (0, _react.useCallback)((ref)=>{
        tabGuardRef.current = ref;
        setTabGuardReady(ref !== null);
    }, []);
    return /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        ref: setRef2,
        className: rootWrapperClasses,
        style: topStyle,
        role: "presentation"
    }, /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        className: rootWrapperBodyClasses,
        ref: setGridBodyParent,
        role: "presentation"
    }, initialised && eGridBodyParent && beans && /* @__PURE__ */ (0, _reactDefault.default).createElement(BeansContext.Provider, {
        value: beans
    }, /* @__PURE__ */ (0, _reactDefault.default).createElement(tabGuardComp_default, {
        ref: setTabGuardCompRef,
        eFocusableElement: eGridBodyParent,
        onTabKeyDown,
        gridCtrl: gridCtrlRef.current,
        forceFocusOutWhenTabGuardsAreEmpty: true
    }, // we wait for initialised before rending the children, so GridComp has created and registered with it's
    // GridCtrl before we create the child GridBodyComp. Otherwise the GridBodyComp would initialise first,
    // before we have set the the Layout CSS classes, causing the GridBodyComp to render rows to a grid that
    // doesn't have it's height specified, which would result if all the rows getting rendered (and if many rows,
    // hangs the UI)
    /* @__PURE__ */ (0, _reactDefault.default).createElement(gridBodyComp_default, null)))));
};
var gridComp_default = (0, _react.memo)(GridComp);
// packages/ag-grid-react/src/reactUi/agGridReactUi.tsx
var AgGridReactUi = (props)=>{
    var _a, _b;
    const apiRef = (0, _react.useRef)();
    const eGui = (0, _react.useRef)(null);
    const portalManager = (0, _react.useRef)(null);
    const destroyFuncs = (0, _react.useRef)([]);
    const whenReadyFuncs = (0, _react.useRef)([]);
    const prevProps = (0, _react.useRef)(props);
    const ready = (0, _react.useRef)(false);
    const [context, setContext] = (0, _react.useState)(void 0);
    const [, setPortalRefresher] = (0, _react.useState)(0);
    const setRef2 = (0, _react.useCallback)((e)=>{
        eGui.current = e;
        if (!eGui.current) {
            destroyFuncs.current.forEach((f)=>f());
            destroyFuncs.current.length = 0;
            return;
        }
        const modules = props.modules || [];
        if (!portalManager.current) {
            portalManager.current = new PortalManager(()=>setPortalRefresher((prev)=>prev + 1), props.componentWrappingElement, props.maxComponentCreationTimeMs);
            destroyFuncs.current.push(()=>{
                var _a2;
                (_a2 = portalManager.current) == null || _a2.destroy();
                portalManager.current = null;
            });
        }
        const mergedGridOps = (0, _agGridCommunity.ComponentUtil).combineAttributesAndGridOptions(props.gridOptions, props);
        const gridParams = {
            providedBeanInstances: {
                frameworkComponentWrapper: new ReactFrameworkComponentWrapper(portalManager.current, !!mergedGridOps.reactiveCustomComponents)
            },
            modules,
            frameworkOverrides: new ReactFrameworkOverrides()
        };
        const createUiCallback = (context2)=>{
            setContext(context2);
            destroyFuncs.current.push(()=>{
                context2.destroy();
            });
            const ctrlsService = context2.getBean((0, _agGridCommunity.CtrlsService).NAME);
            ctrlsService.whenReady(()=>{
                if (context2.isDestroyed()) return;
                const api = apiRef.current;
                if (api) {
                    if (props.setGridApi) props.setGridApi(api, new (0, _agGridCommunity.ColumnApi)(api));
                }
            });
        };
        const acceptChangesCallback = (context2)=>{
            const ctrlsService = context2.getBean((0, _agGridCommunity.CtrlsService).NAME);
            ctrlsService.whenReady(()=>{
                whenReadyFuncs.current.forEach((f)=>f());
                whenReadyFuncs.current.length = 0;
                ready.current = true;
            });
        };
        const gridCoreCreator = new (0, _agGridCommunity.GridCoreCreator)();
        apiRef.current = gridCoreCreator.create(eGui.current, mergedGridOps, createUiCallback, acceptChangesCallback, gridParams);
    }, []);
    const style = (0, _react.useMemo)(()=>{
        return __spreadValues({
            height: "100%"
        }, props.containerStyle || {});
    }, [
        props.containerStyle
    ]);
    const processWhenReady = (0, _react.useCallback)((func)=>{
        if (ready.current) func();
        else whenReadyFuncs.current.push(func);
    }, []);
    (0, _react.useEffect)(()=>{
        const changes = extractGridPropertyChanges(prevProps.current, props);
        prevProps.current = props;
        processWhenReady(()=>{
            if (apiRef.current) (0, _agGridCommunity.ComponentUtil).processOnChange(changes, apiRef.current);
        });
    }, [
        props
    ]);
    return /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        style,
        className: props.className,
        ref: setRef2
    }, context && !context.isDestroyed() ? /* @__PURE__ */ (0, _reactDefault.default).createElement(gridComp_default, {
        context
    }) : null, (_b = (_a = portalManager.current) == null ? void 0 : _a.getPortals()) != null ? _b : null);
};
function extractGridPropertyChanges(prevProps, nextProps) {
    const changes = {};
    Object.keys(nextProps).forEach((propKey)=>{
        const propValue = nextProps[propKey];
        if (prevProps[propKey] !== propValue) changes[propKey] = propValue;
    });
    return changes;
}
var ReactFrameworkComponentWrapper = class extends (0, _agGridCommunity.BaseComponentWrapper) {
    constructor(parent, reactiveCustomComponents){
        super();
        this.parent = parent;
        this.reactiveCustomComponents = reactiveCustomComponents;
    }
    createWrapper(UserReactComponent, componentType) {
        if (this.reactiveCustomComponents) {
            const getComponentClass = (propertyName)=>{
                switch(propertyName){
                    case "filter":
                        return FilterComponentWrapper;
                    case "floatingFilterComponent":
                        return FloatingFilterComponentWrapper;
                    case "dateComponent":
                        return DateComponentWrapper;
                    case "loadingOverlayComponent":
                        return LoadingOverlayComponentWrapper;
                    case "noRowsOverlayComponent":
                        return NoRowsOverlayComponentWrapper;
                    case "statusPanel":
                        return StatusPanelComponentWrapper;
                    case "toolPanel":
                        return ToolPanelComponentWrapper;
                    case "menuItem":
                        return MenuItemComponentWrapper;
                }
            };
            const ComponentClass = getComponentClass(componentType.propertyName);
            if (ComponentClass) return new ComponentClass(UserReactComponent, this.parent, componentType);
        } else switch(componentType.propertyName){
            case "filter":
            case "floatingFilterComponent":
            case "dateComponent":
            case "loadingOverlayComponent":
            case "noRowsOverlayComponent":
            case "statusPanel":
            case "toolPanel":
            case "menuItem":
                warnReactiveCustomComponents();
                break;
        }
        const suppressFallbackMethods = !componentType.cellRenderer && componentType.propertyName !== "toolPanel";
        return new ReactComponent(UserReactComponent, this.parent, componentType, suppressFallbackMethods);
    }
};
var DetailCellRenderer = (0, _react.forwardRef)((props, ref)=>{
    const { ctrlsFactory, context, gos, resizeObserverService, clientSideRowModel, serverSideRowModel } = (0, _react.useContext)(BeansContext);
    const [cssClasses, setCssClasses] = (0, _react.useState)(()=>new CssClasses());
    const [gridCssClasses, setGridCssClasses] = (0, _react.useState)(()=>new CssClasses());
    const [detailGridOptions, setDetailGridOptions] = (0, _react.useState)();
    const [detailRowData, setDetailRowData] = (0, _react.useState)();
    const ctrlRef = (0, _react.useRef)();
    const eGuiRef = (0, _react.useRef)(null);
    const resizeObserverDestroyFunc = (0, _react.useRef)();
    const parentModules = (0, _react.useMemo)(()=>(0, _agGridCommunity.ModuleRegistry).__getGridRegisteredModules(props.api.getGridId()), [
        props
    ]);
    const topClassName = (0, _react.useMemo)(()=>cssClasses.toString() + " ag-details-row", [
        cssClasses
    ]);
    const gridClassName = (0, _react.useMemo)(()=>gridCssClasses.toString() + " ag-details-grid", [
        gridCssClasses
    ]);
    if (ref) (0, _react.useImperativeHandle)(ref, ()=>({
            refresh () {
                var _a, _b;
                return (_b = (_a = ctrlRef.current) == null ? void 0 : _a.refresh()) != null ? _b : false;
            }
        }));
    if (props.template) (0, _agGridCommunity._).warnOnce("detailCellRendererParams.template is not supported by AG Grid React. To change the template, provide a Custom Detail Cell Renderer. See https://ag-grid.com/react-data-grid/master-detail-custom-detail/");
    const setRef2 = (0, _react.useCallback)((e)=>{
        eGuiRef.current = e;
        if (!eGuiRef.current) {
            context.destroyBean(ctrlRef.current);
            if (resizeObserverDestroyFunc.current) resizeObserverDestroyFunc.current();
            return;
        }
        const compProxy = {
            addOrRemoveCssClass: (name, on)=>setCssClasses((prev)=>prev.setClass(name, on)),
            addOrRemoveDetailGridCssClass: (name, on)=>setGridCssClasses((prev)=>prev.setClass(name, on)),
            setDetailGrid: (gridOptions)=>setDetailGridOptions(gridOptions),
            setRowData: (rowData)=>setDetailRowData(rowData),
            getGui: ()=>eGuiRef.current
        };
        const ctrl = ctrlsFactory.getInstance("detailCellRenderer");
        if (!ctrl) return;
        context.createBean(ctrl);
        ctrl.init(compProxy, props);
        ctrlRef.current = ctrl;
        if (gos.get("detailRowAutoHeight")) {
            const checkRowSizeFunc = ()=>{
                if (eGuiRef.current == null) return;
                const clientHeight = eGuiRef.current.clientHeight;
                if (clientHeight != null && clientHeight > 0) {
                    const updateRowHeightFunc = ()=>{
                        props.node.setRowHeight(clientHeight);
                        if (clientSideRowModel) clientSideRowModel.onRowHeightChanged();
                        else if (serverSideRowModel) serverSideRowModel.onRowHeightChanged();
                    };
                    setTimeout(updateRowHeightFunc, 0);
                }
            };
            resizeObserverDestroyFunc.current = resizeObserverService.observeResize(eGuiRef.current, checkRowSizeFunc);
            checkRowSizeFunc();
        }
    }, []);
    const setGridApi = (0, _react.useCallback)((api, columnApi)=>{
        var _a;
        (_a = ctrlRef.current) == null || _a.registerDetailWithMaster(api, columnApi);
    }, []);
    return /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        className: topClassName,
        ref: setRef2
    }, detailGridOptions && /* @__PURE__ */ (0, _reactDefault.default).createElement(AgGridReactUi, __spreadProps(__spreadValues({
        className: gridClassName
    }, detailGridOptions), {
        modules: parentModules,
        rowData: detailRowData,
        setGridApi
    })));
});
var ReactFrameworkOverrides = class extends (0, _agGridCommunity.VanillaFrameworkOverrides) {
    constructor(){
        super("react");
        this.frameworkComponents = {
            agGroupCellRenderer: groupCellRenderer_default,
            agGroupRowRenderer: groupCellRenderer_default,
            agDetailCellRenderer: DetailCellRenderer
        };
        this.wrapIncoming = (callback, source)=>{
            if (source === "ensureVisible") return runWithoutFlushSync(callback);
            return callback();
        };
        this.renderingEngine = "react";
    }
    frameworkComponent(name) {
        return this.frameworkComponents[name];
    }
    isFrameworkComponent(comp) {
        if (!comp) return false;
        const prototype = comp.prototype;
        const isJsComp = prototype && "getGui" in prototype;
        return !isJsComp;
    }
};
// packages/ag-grid-react/src/agGridReact.tsx
var AgGridReact = class extends (0, _react.Component) {
    constructor(){
        super(...arguments);
        this.apiListeners = [];
        this.setGridApi = (api, columnApi)=>{
            this.api = api;
            this.columnApi = columnApi;
            this.apiListeners.forEach((listener)=>listener(api));
        };
    }
    registerApiListener(listener) {
        this.apiListeners.push(listener);
    }
    componentWillUnmount() {
        this.apiListeners.length = 0;
    }
    render() {
        return /* @__PURE__ */ (0, _reactDefault.default).createElement(AgGridReactUi, __spreadProps(__spreadValues({}, this.props), {
            setGridApi: this.setGridApi
        }));
    }
};
// packages/ag-grid-react/src/shared/interfaces.ts
var ChangeDetectionStrategyType = /* @__PURE__ */ ((ChangeDetectionStrategyType2)=>{
    ChangeDetectionStrategyType2["IdentityCheck"] = "IdentityCheck";
    ChangeDetectionStrategyType2["DeepValueCheck"] = "DeepValueCheck";
    ChangeDetectionStrategyType2["NoCheck"] = "NoCheck";
    return ChangeDetectionStrategyType2;
})(ChangeDetectionStrategyType || {});
function useGridCustomComponent(methods) {
    const { setMethods } = (0, _react.useContext)(CustomContext);
    setMethods(methods);
}
function useGridCellEditor(callbacks) {
    useGridCustomComponent(callbacks);
}
function useGridDate(callbacks) {
    return useGridCustomComponent(callbacks);
}
function useGridFilter(callbacks) {
    return useGridCustomComponent(callbacks);
}
function useGridFloatingFilter(callbacks) {
    useGridCustomComponent(callbacks);
}
function useGridMenuItem(callbacks) {
    useGridCustomComponent(callbacks);
}

},{"react":"bmhQu","ag-grid-community":"5DcWL","react-dom":"82aNB","react-dom/server":"hRNim","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5DcWL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALWAYS_SYNC_GLOBAL_EVENTS", ()=>ALWAYS_SYNC_GLOBAL_EVENTS);
parcelHelpers.export(exports, "AbstractHeaderCellCtrl", ()=>AbstractHeaderCellCtrl);
parcelHelpers.export(exports, "AgAbstractField", ()=>AgAbstractField);
parcelHelpers.export(exports, "AgAbstractLabel", ()=>AgAbstractLabel);
parcelHelpers.export(exports, "AgAutocomplete", ()=>AgAutocomplete);
parcelHelpers.export(exports, "AgCheckbox", ()=>AgCheckbox);
parcelHelpers.export(exports, "AgDialog", ()=>AgDialog);
parcelHelpers.export(exports, "AgGroupComponent", ()=>AgGroupComponent);
parcelHelpers.export(exports, "AgInputDateField", ()=>AgInputDateField);
parcelHelpers.export(exports, "AgInputNumberField", ()=>AgInputNumberField);
parcelHelpers.export(exports, "AgInputRange", ()=>AgInputRange);
parcelHelpers.export(exports, "AgInputTextArea", ()=>AgInputTextArea);
parcelHelpers.export(exports, "AgInputTextField", ()=>AgInputTextField);
parcelHelpers.export(exports, "AgMenuItemComponent", ()=>AgMenuItemComponent);
parcelHelpers.export(exports, "AgMenuItemRenderer", ()=>AgMenuItemRenderer);
parcelHelpers.export(exports, "AgMenuList", ()=>AgMenuList);
parcelHelpers.export(exports, "AgMenuPanel", ()=>AgMenuPanel);
parcelHelpers.export(exports, "AgPanel", ()=>AgPanel);
parcelHelpers.export(exports, "AgPickerField", ()=>AgPickerField);
parcelHelpers.export(exports, "AgPromise", ()=>AgPromise);
parcelHelpers.export(exports, "AgPromiseStatus", ()=>AgPromiseStatus);
parcelHelpers.export(exports, "AgRadioButton", ()=>AgRadioButton);
parcelHelpers.export(exports, "AgRichSelect", ()=>AgRichSelect);
parcelHelpers.export(exports, "AgSelect", ()=>AgSelect);
parcelHelpers.export(exports, "AgSlider", ()=>AgSlider);
parcelHelpers.export(exports, "AgStackComponentsRegistry", ()=>AgStackComponentsRegistry);
parcelHelpers.export(exports, "AgToggleButton", ()=>AgToggleButton);
parcelHelpers.export(exports, "AlignedGridsService", ()=>AlignedGridsService);
parcelHelpers.export(exports, "AnimateShowChangeCellRenderer", ()=>AnimateShowChangeCellRenderer);
parcelHelpers.export(exports, "AnimateSlideCellRenderer", ()=>AnimateSlideCellRenderer);
parcelHelpers.export(exports, "AnimationFrameService", ()=>AnimationFrameService);
parcelHelpers.export(exports, "AutoScrollService", ()=>AutoScrollService);
parcelHelpers.export(exports, "AutoWidthCalculator", ()=>AutoWidthCalculator);
parcelHelpers.export(exports, "Autowired", ()=>Autowired);
parcelHelpers.export(exports, "BarColumnLabelPlacement", ()=>BarColumnLabelPlacement);
parcelHelpers.export(exports, "BaseComponentWrapper", ()=>BaseComponentWrapper);
parcelHelpers.export(exports, "BaseCreator", ()=>BaseCreator);
parcelHelpers.export(exports, "BaseGridSerializingSession", ()=>BaseGridSerializingSession);
parcelHelpers.export(exports, "Bean", ()=>Bean);
parcelHelpers.export(exports, "BeanStub", ()=>BeanStub);
parcelHelpers.export(exports, "Beans", ()=>Beans);
parcelHelpers.export(exports, "BodyDropPivotTarget", ()=>BodyDropPivotTarget);
parcelHelpers.export(exports, "BodyDropTarget", ()=>BodyDropTarget);
parcelHelpers.export(exports, "CellComp", ()=>CellComp);
parcelHelpers.export(exports, "CellCtrl", ()=>CellCtrl);
parcelHelpers.export(exports, "CellNavigationService", ()=>CellNavigationService);
parcelHelpers.export(exports, "CellPositionUtils", ()=>CellPositionUtils);
parcelHelpers.export(exports, "CellRangeType", ()=>CellRangeType);
parcelHelpers.export(exports, "ChangedPath", ()=>ChangedPath);
parcelHelpers.export(exports, "ChartMappings", ()=>ChartMappings);
parcelHelpers.export(exports, "CheckboxCellEditor", ()=>CheckboxCellEditor);
parcelHelpers.export(exports, "CheckboxCellRenderer", ()=>CheckboxCellRenderer);
parcelHelpers.export(exports, "CheckboxSelectionComponent", ()=>CheckboxSelectionComponent);
parcelHelpers.export(exports, "ClientSideRowModelModule", ()=>ClientSideRowModelModule);
parcelHelpers.export(exports, "ClientSideRowModelSteps", ()=>ClientSideRowModelSteps);
parcelHelpers.export(exports, "Column", ()=>Column);
parcelHelpers.export(exports, "ColumnApi", ()=>ColumnApi);
parcelHelpers.export(exports, "ColumnFactory", ()=>ColumnFactory);
parcelHelpers.export(exports, "ColumnGroup", ()=>ColumnGroup);
parcelHelpers.export(exports, "ColumnKeyCreator", ()=>ColumnKeyCreator);
parcelHelpers.export(exports, "ColumnModel", ()=>ColumnModel);
parcelHelpers.export(exports, "Component", ()=>Component);
parcelHelpers.export(exports, "ComponentUtil", ()=>ComponentUtil);
parcelHelpers.export(exports, "Context", ()=>Context);
parcelHelpers.export(exports, "CssClassApplier", ()=>CssClassApplier);
parcelHelpers.export(exports, "CssClassManager", ()=>CssClassManager);
parcelHelpers.export(exports, "CsvCreator", ()=>CsvCreator);
parcelHelpers.export(exports, "CsvExportModule", ()=>CsvExportModule);
parcelHelpers.export(exports, "CtrlsService", ()=>CtrlsService);
parcelHelpers.export(exports, "DataTypeService", ()=>DataTypeService);
parcelHelpers.export(exports, "DateCellEditor", ()=>DateCellEditor);
parcelHelpers.export(exports, "DateFilter", ()=>DateFilter);
parcelHelpers.export(exports, "DateStringCellEditor", ()=>DateStringCellEditor);
parcelHelpers.export(exports, "DisplayedGroupCreator", ()=>DisplayedGroupCreator);
parcelHelpers.export(exports, "Downloader", ()=>Downloader);
parcelHelpers.export(exports, "DragAndDropService", ()=>DragAndDropService);
parcelHelpers.export(exports, "DragService", ()=>DragService);
parcelHelpers.export(exports, "DragSourceType", ()=>DragSourceType);
parcelHelpers.export(exports, "Environment", ()=>Environment);
parcelHelpers.export(exports, "EventService", ()=>EventService);
parcelHelpers.export(exports, "Events", ()=>Events);
parcelHelpers.export(exports, "ExcelFactoryMode", ()=>ExcelFactoryMode);
parcelHelpers.export(exports, "ExpansionService", ()=>ExpansionService);
parcelHelpers.export(exports, "ExpressionService", ()=>ExpressionService);
parcelHelpers.export(exports, "FilterManager", ()=>FilterManager);
parcelHelpers.export(exports, "FilterWrapperComp", ()=>FilterWrapperComp);
parcelHelpers.export(exports, "FloatingFilterMapper", ()=>FloatingFilterMapper);
parcelHelpers.export(exports, "FocusService", ()=>FocusService);
parcelHelpers.export(exports, "GROUP_AUTO_COLUMN_ID", ()=>GROUP_AUTO_COLUMN_ID);
parcelHelpers.export(exports, "Grid", ()=>Grid);
parcelHelpers.export(exports, "GridApi", ()=>GridApi);
parcelHelpers.export(exports, "GridBodyComp", ()=>GridBodyComp);
parcelHelpers.export(exports, "GridBodyCtrl", ()=>GridBodyCtrl);
parcelHelpers.export(exports, "GridComp", ()=>GridComp);
parcelHelpers.export(exports, "GridCoreCreator", ()=>GridCoreCreator);
parcelHelpers.export(exports, "GridCtrl", ()=>GridCtrl);
parcelHelpers.export(exports, "GridHeaderComp", ()=>GridHeaderComp);
parcelHelpers.export(exports, "GridHeaderCtrl", ()=>GridHeaderCtrl);
parcelHelpers.export(exports, "GridOptionsService", ()=>GridOptionsService);
parcelHelpers.export(exports, "GridSerializer", ()=>GridSerializer);
parcelHelpers.export(exports, "GroupCellRenderer", ()=>GroupCellRenderer);
parcelHelpers.export(exports, "GroupCellRendererCtrl", ()=>GroupCellRendererCtrl);
parcelHelpers.export(exports, "GroupInstanceIdCreator", ()=>GroupInstanceIdCreator);
parcelHelpers.export(exports, "HeaderCellCtrl", ()=>HeaderCellCtrl);
parcelHelpers.export(exports, "HeaderFilterCellComp", ()=>HeaderFilterCellComp);
parcelHelpers.export(exports, "HeaderFilterCellCtrl", ()=>HeaderFilterCellCtrl);
parcelHelpers.export(exports, "HeaderGroupCellCtrl", ()=>HeaderGroupCellCtrl);
parcelHelpers.export(exports, "HeaderNavigationDirection", ()=>HeaderNavigationDirection);
parcelHelpers.export(exports, "HeaderNavigationService", ()=>HeaderNavigationService);
parcelHelpers.export(exports, "HeaderPositionUtils", ()=>HeaderPositionUtils);
parcelHelpers.export(exports, "HeaderRowComp", ()=>HeaderRowComp);
parcelHelpers.export(exports, "HeaderRowContainerComp", ()=>HeaderRowContainerComp);
parcelHelpers.export(exports, "HeaderRowContainerCtrl", ()=>HeaderRowContainerCtrl);
parcelHelpers.export(exports, "HeaderRowCtrl", ()=>HeaderRowCtrl);
parcelHelpers.export(exports, "HeaderRowType", ()=>HeaderRowType);
parcelHelpers.export(exports, "HorizontalDirection", ()=>HorizontalDirection);
parcelHelpers.export(exports, "HorizontalResizeService", ()=>HorizontalResizeService);
parcelHelpers.export(exports, "InfiniteRowModelModule", ()=>InfiniteRowModelModule);
parcelHelpers.export(exports, "KeyCode", ()=>KeyCode);
parcelHelpers.export(exports, "LargeTextCellEditor", ()=>LargeTextCellEditor);
parcelHelpers.export(exports, "LayoutCssClasses", ()=>LayoutCssClasses);
parcelHelpers.export(exports, "LocaleService", ()=>LocaleService);
parcelHelpers.export(exports, "Logger", ()=>Logger);
parcelHelpers.export(exports, "LoggerFactory", ()=>LoggerFactory);
parcelHelpers.export(exports, "ManagedFocusFeature", ()=>ManagedFocusFeature);
parcelHelpers.export(exports, "MenuService", ()=>MenuService);
parcelHelpers.export(exports, "ModuleNames", ()=>ModuleNames);
parcelHelpers.export(exports, "ModuleRegistry", ()=>ModuleRegistry);
parcelHelpers.export(exports, "MouseEventService", ()=>MouseEventService);
parcelHelpers.export(exports, "MoveColumnFeature", ()=>MoveColumnFeature);
parcelHelpers.export(exports, "NavigationService", ()=>NavigationService);
parcelHelpers.export(exports, "NumberCellEditor", ()=>NumberCellEditor);
parcelHelpers.export(exports, "NumberFilter", ()=>NumberFilter);
parcelHelpers.export(exports, "NumberSequence", ()=>NumberSequence);
parcelHelpers.export(exports, "Optional", ()=>Optional);
parcelHelpers.export(exports, "PaginationProxy", ()=>PaginationProxy);
parcelHelpers.export(exports, "PillDragComp", ()=>PillDragComp);
parcelHelpers.export(exports, "PillDropZonePanel", ()=>PillDropZonePanel);
parcelHelpers.export(exports, "PinnedRowModel", ()=>PinnedRowModel);
parcelHelpers.export(exports, "PopupComponent", ()=>PopupComponent);
parcelHelpers.export(exports, "PopupEditorWrapper", ()=>PopupEditorWrapper);
parcelHelpers.export(exports, "PopupService", ()=>PopupService);
parcelHelpers.export(exports, "PositionableFeature", ()=>PositionableFeature);
parcelHelpers.export(exports, "PostConstruct", ()=>PostConstruct);
parcelHelpers.export(exports, "PreConstruct", ()=>PreConstruct);
parcelHelpers.export(exports, "PreDestroy", ()=>PreDestroy);
parcelHelpers.export(exports, "PropertyKeys", ()=>PropertyKeys);
parcelHelpers.export(exports, "ProvidedColumnGroup", ()=>ProvidedColumnGroup);
parcelHelpers.export(exports, "ProvidedFilter", ()=>ProvidedFilter);
parcelHelpers.export(exports, "Qualifier", ()=>Qualifier);
parcelHelpers.export(exports, "QuerySelector", ()=>QuerySelector);
parcelHelpers.export(exports, "RefSelector", ()=>RefSelector);
parcelHelpers.export(exports, "ResizeObserverService", ()=>ResizeObserverService);
parcelHelpers.export(exports, "RowAnimationCssClasses", ()=>RowAnimationCssClasses);
parcelHelpers.export(exports, "RowContainerComp", ()=>RowContainerComp);
parcelHelpers.export(exports, "RowContainerCtrl", ()=>RowContainerCtrl);
parcelHelpers.export(exports, "RowContainerName", ()=>RowContainerName);
parcelHelpers.export(exports, "RowContainerType", ()=>RowContainerType);
parcelHelpers.export(exports, "RowCtrl", ()=>RowCtrl);
parcelHelpers.export(exports, "RowHighlightPosition", ()=>RowHighlightPosition);
parcelHelpers.export(exports, "RowNode", ()=>RowNode);
parcelHelpers.export(exports, "RowNodeBlock", ()=>RowNodeBlock);
parcelHelpers.export(exports, "RowNodeBlockLoader", ()=>RowNodeBlockLoader);
parcelHelpers.export(exports, "RowNodeSorter", ()=>RowNodeSorter);
parcelHelpers.export(exports, "RowPositionUtils", ()=>RowPositionUtils);
parcelHelpers.export(exports, "RowRenderer", ()=>RowRenderer);
parcelHelpers.export(exports, "RowType", ()=>RowType);
parcelHelpers.export(exports, "ScalarFilter", ()=>ScalarFilter);
parcelHelpers.export(exports, "ScrollVisibleService", ()=>ScrollVisibleService);
parcelHelpers.export(exports, "SelectCellEditor", ()=>SelectCellEditor);
parcelHelpers.export(exports, "SelectableService", ()=>SelectableService);
parcelHelpers.export(exports, "SelectionHandleType", ()=>SelectionHandleType);
parcelHelpers.export(exports, "ServerSideTransactionResultStatus", ()=>ServerSideTransactionResultStatus);
parcelHelpers.export(exports, "SetLeftFeature", ()=>SetLeftFeature);
parcelHelpers.export(exports, "SimpleFilter", ()=>SimpleFilter);
parcelHelpers.export(exports, "SortController", ()=>SortController);
parcelHelpers.export(exports, "SortIndicatorComp", ()=>SortIndicatorComp);
parcelHelpers.export(exports, "StandardMenuFactory", ()=>StandardMenuFactory);
parcelHelpers.export(exports, "StylingService", ()=>StylingService);
parcelHelpers.export(exports, "TabGuardClassNames", ()=>TabGuardClassNames);
parcelHelpers.export(exports, "TabGuardComp", ()=>TabGuardComp);
parcelHelpers.export(exports, "TabGuardCtrl", ()=>TabGuardCtrl);
parcelHelpers.export(exports, "TabbedLayout", ()=>TabbedLayout);
parcelHelpers.export(exports, "TextCellEditor", ()=>TextCellEditor);
parcelHelpers.export(exports, "TextFilter", ()=>TextFilter);
parcelHelpers.export(exports, "TextFloatingFilter", ()=>TextFloatingFilter);
parcelHelpers.export(exports, "Timer", ()=>Timer);
parcelHelpers.export(exports, "TooltipFeature", ()=>TooltipFeature);
parcelHelpers.export(exports, "TooltipStateManager", ()=>TooltipStateManager);
parcelHelpers.export(exports, "TouchListener", ()=>TouchListener);
parcelHelpers.export(exports, "UserComponentFactory", ()=>UserComponentFactory);
parcelHelpers.export(exports, "UserComponentRegistry", ()=>UserComponentRegistry);
parcelHelpers.export(exports, "ValueCache", ()=>ValueCache);
parcelHelpers.export(exports, "ValueService", ()=>ValueService);
parcelHelpers.export(exports, "VanillaFrameworkOverrides", ()=>VanillaFrameworkOverrides);
parcelHelpers.export(exports, "VerticalDirection", ()=>VerticalDirection);
parcelHelpers.export(exports, "VirtualList", ()=>VirtualList);
parcelHelpers.export(exports, "VirtualListDragFeature", ()=>VirtualListDragFeature);
parcelHelpers.export(exports, "XmlFactory", ()=>XmlFactory);
parcelHelpers.export(exports, "ZipContainer", ()=>ZipContainer);
parcelHelpers.export(exports, "_", ()=>_);
parcelHelpers.export(exports, "createGrid", ()=>createGrid);
parcelHelpers.export(exports, "getRowContainerTypeForName", ()=>getRowContainerTypeForName);
parcelHelpers.export(exports, "provideGlobalGridOptions", ()=>provideGlobalGridOptions);
var global = arguments[3];
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var __spreadProps = (a, b)=>__defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var __export = (target, all)=>{
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __decorateClass = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) __defProp(target, key, result);
    return result;
};
var __decorateParam = (index, decorator)=>(target, key)=>decorator(target, key, index);
// community-modules/core/src/utils/generic.ts
var generic_exports = {};
__export(generic_exports, {
    attrToBoolean: ()=>attrToBoolean,
    attrToNumber: ()=>attrToNumber,
    attrToString: ()=>attrToString,
    defaultComparator: ()=>defaultComparator,
    exists: ()=>exists,
    jsonEquals: ()=>jsonEquals,
    makeNull: ()=>makeNull,
    missing: ()=>missing,
    missingOrEmpty: ()=>missingOrEmpty,
    toStringOrNull: ()=>toStringOrNull,
    values: ()=>values
});
function makeNull(value) {
    if (value == null || value === "") return null;
    return value;
}
function exists(value, allowEmptyString = false) {
    return value != null && (value !== "" || allowEmptyString);
}
function missing(value) {
    return !exists(value);
}
function missingOrEmpty(value) {
    return value == null || value.length === 0;
}
function toStringOrNull(value) {
    return value != null && typeof value.toString === "function" ? value.toString() : null;
}
function attrToNumber(value) {
    if (value === void 0) return;
    if (value === null || value === "") return null;
    if (typeof value === "number") return isNaN(value) ? void 0 : value;
    const valueParsed = parseInt(value, 10);
    return isNaN(valueParsed) ? void 0 : valueParsed;
}
function attrToBoolean(value) {
    if (value === void 0) return;
    if (value === null || value === "") return false;
    if (typeof value === "boolean") return value;
    return /true/i.test(value);
}
function attrToString(value) {
    if (value == null || value === "") return;
    return value;
}
function jsonEquals(val1, val2) {
    const val1Json = val1 ? JSON.stringify(val1) : null;
    const val2Json = val2 ? JSON.stringify(val2) : null;
    return val1Json === val2Json;
}
function defaultComparator(valueA, valueB, accentedCompare = false) {
    const valueAMissing = valueA == null;
    const valueBMissing = valueB == null;
    if (valueA && valueA.toNumber) valueA = valueA.toNumber();
    if (valueB && valueB.toNumber) valueB = valueB.toNumber();
    if (valueAMissing && valueBMissing) return 0;
    if (valueAMissing) return -1;
    if (valueBMissing) return 1;
    function doQuickCompare(a, b) {
        return a > b ? 1 : a < b ? -1 : 0;
    }
    if (typeof valueA !== "string") return doQuickCompare(valueA, valueB);
    if (!accentedCompare) return doQuickCompare(valueA, valueB);
    try {
        return valueA.localeCompare(valueB);
    } catch (e) {
        return doQuickCompare(valueA, valueB);
    }
}
function values(object) {
    if (object instanceof Set || object instanceof Map) {
        const arr = [];
        object.forEach((value)=>arr.push(value));
        return arr;
    }
    return Object.values(object);
}
// community-modules/core/src/columns/columnKeyCreator.ts
var ColumnKeyCreator = class {
    constructor(){
        this.existingKeys = {};
    }
    addExistingKeys(keys2) {
        for(let i = 0; i < keys2.length; i++)this.existingKeys[keys2[i]] = true;
    }
    getUniqueKey(colId, colField) {
        colId = toStringOrNull(colId);
        let count = 0;
        while(true){
            let idToTry;
            if (colId) {
                idToTry = colId;
                if (count !== 0) idToTry += "_" + count;
            } else if (colField) {
                idToTry = colField;
                if (count !== 0) idToTry += "_" + count;
            } else idToTry = count;
            if (!this.existingKeys[idToTry]) {
                this.existingKeys[idToTry] = true;
                return String(idToTry);
            }
            count++;
        }
    }
};
// community-modules/core/src/utils/object.ts
var object_exports = {};
__export(object_exports, {
    SKIP_JS_BUILTINS: ()=>SKIP_JS_BUILTINS,
    cloneObject: ()=>cloneObject,
    deepCloneDefinition: ()=>deepCloneDefinition,
    getAllValuesInObject: ()=>getAllValuesInObject,
    getValueUsingField: ()=>getValueUsingField,
    isNonNullObject: ()=>isNonNullObject,
    iterateObject: ()=>iterateObject,
    mergeDeep: ()=>mergeDeep,
    removeAllReferences: ()=>removeAllReferences
});
var SKIP_JS_BUILTINS = /* @__PURE__ */ new Set([
    "__proto__",
    "constructor",
    "prototype"
]);
function iterateObject(object, callback) {
    if (object == null) return;
    if (Array.isArray(object)) {
        for(let i = 0; i < object.length; i++)callback(i.toString(), object[i]);
        return;
    }
    for (const [key, value] of Object.entries(object))callback(key, value);
}
function cloneObject(object) {
    const copy = {};
    const keys2 = Object.keys(object);
    for(let i = 0; i < keys2.length; i++){
        if (SKIP_JS_BUILTINS.has(keys2[i])) continue;
        const key = keys2[i];
        const value = object[key];
        copy[key] = value;
    }
    return copy;
}
function deepCloneDefinition(object, keysToSkip) {
    if (!object) return;
    const obj = object;
    const res = {};
    Object.keys(obj).forEach((key)=>{
        if (keysToSkip && keysToSkip.indexOf(key) >= 0 || SKIP_JS_BUILTINS.has(key)) return;
        const value = obj[key];
        const sourceIsSimpleObject = isNonNullObject(value) && value.constructor === Object;
        if (sourceIsSimpleObject) res[key] = deepCloneDefinition(value);
        else res[key] = value;
    });
    return res;
}
function getAllValuesInObject(obj) {
    if (!obj) return [];
    const anyObject = Object;
    if (typeof anyObject.values === "function") return anyObject.values(obj);
    const ret = [];
    for(const key in obj)if (obj.hasOwnProperty(key) && obj.propertyIsEnumerable(key)) ret.push(obj[key]);
    return ret;
}
function mergeDeep(dest, source, copyUndefined = true, makeCopyOfSimpleObjects = false) {
    if (!exists(source)) return;
    iterateObject(source, (key, sourceValue)=>{
        if (SKIP_JS_BUILTINS.has(key)) return;
        let destValue = dest[key];
        if (destValue === sourceValue) return;
        if (makeCopyOfSimpleObjects) {
            const objectIsDueToBeCopied = destValue == null && sourceValue != null;
            if (objectIsDueToBeCopied) {
                const sourceIsSimpleObject = typeof sourceValue === "object" && sourceValue.constructor === Object;
                const dontCopy = sourceIsSimpleObject;
                if (dontCopy) {
                    destValue = {};
                    dest[key] = destValue;
                }
            }
        }
        if (isNonNullObject(sourceValue) && isNonNullObject(destValue) && !Array.isArray(destValue)) mergeDeep(destValue, sourceValue, copyUndefined, makeCopyOfSimpleObjects);
        else if (copyUndefined || sourceValue !== void 0) dest[key] = sourceValue;
    });
}
function getValueUsingField(data, field, fieldContainsDots) {
    if (!field || !data) return;
    if (!fieldContainsDots) return data[field];
    const fields = field.split(".");
    let currentObject = data;
    for(let i = 0; i < fields.length; i++){
        if (currentObject == null) return void 0;
        currentObject = currentObject[fields[i]];
    }
    return currentObject;
}
function removeAllReferences(obj, preserveKeys = [], preDestroyLink) {
    Object.keys(obj).forEach((key)=>{
        const value = obj[key];
        if (typeof value === "object" && !preserveKeys.includes(key)) obj[key] = void 0;
    });
    const proto = Object.getPrototypeOf(obj);
    const properties = {};
    const msgFunc = (key)=>`AG Grid: Grid API function ${key}() cannot be called as the grid has been destroyed.
    It is recommended to remove local references to the grid api. Alternatively, check gridApi.isDestroyed() to avoid calling methods against a destroyed grid.
    To run logic when the grid is about to be destroyed use the gridPreDestroy event. See: ${preDestroyLink}`;
    Object.getOwnPropertyNames(proto).forEach((key)=>{
        const value = proto[key];
        if (typeof value === "function" && !preserveKeys.includes(key)) {
            const func = ()=>{
                console.warn(msgFunc(key));
            };
            properties[key] = {
                value: func,
                writable: true
            };
        }
    });
    Object.defineProperties(obj, properties);
}
function isNonNullObject(value) {
    return typeof value === "object" && value !== null;
}
// community-modules/core/src/utils/function.ts
var function_exports = {};
__export(function_exports, {
    compose: ()=>compose,
    debounce: ()=>debounce,
    doOnce: ()=>doOnce,
    errorOnce: ()=>errorOnce,
    executeAfter: ()=>executeAfter,
    executeInAWhile: ()=>executeInAWhile,
    executeNextVMTurn: ()=>executeNextVMTurn,
    getFunctionName: ()=>getFunctionName,
    isFunction: ()=>isFunction,
    noop: ()=>noop,
    throttle: ()=>throttle,
    waitUntil: ()=>waitUntil,
    warnOnce: ()=>warnOnce
});
var doOnceFlags = {};
function doOnce(func, key) {
    if (doOnceFlags[key]) return;
    func();
    doOnceFlags[key] = true;
}
function warnOnce(msg) {
    doOnce(()=>console.warn("AG Grid: " + msg), msg);
}
function errorOnce(msg) {
    doOnce(()=>console.error("AG Grid: " + msg), msg);
}
function getFunctionName(funcConstructor) {
    if (funcConstructor.name) return funcConstructor.name;
    const matches = /function\s+([^\(]+)/.exec(funcConstructor.toString());
    return matches && matches.length === 2 ? matches[1].trim() : null;
}
function isFunction(val) {
    return !!(val && val.constructor && val.call && val.apply);
}
function executeInAWhile(funcs) {
    executeAfter(funcs, 400);
}
var executeNextVMTurnFuncs = [];
var executeNextVMTurnPending = false;
function executeNextVMTurn(func) {
    executeNextVMTurnFuncs.push(func);
    if (executeNextVMTurnPending) return;
    executeNextVMTurnPending = true;
    window.setTimeout(()=>{
        const funcsCopy = executeNextVMTurnFuncs.slice();
        executeNextVMTurnFuncs.length = 0;
        executeNextVMTurnPending = false;
        funcsCopy.forEach((func2)=>func2());
    }, 0);
}
function executeAfter(funcs, milliseconds = 0) {
    if (funcs.length > 0) window.setTimeout(()=>funcs.forEach((func)=>func()), milliseconds);
}
function debounce(func, delay) {
    let timeout;
    return function(...args) {
        const context = this;
        window.clearTimeout(timeout);
        timeout = window.setTimeout(function() {
            func.apply(context, args);
        }, delay);
    };
}
function throttle(func, wait) {
    let previousCall = 0;
    return function(...args) {
        const context = this;
        const currentCall = /* @__PURE__ */ new Date().getTime();
        if (currentCall - previousCall < wait) return;
        previousCall = currentCall;
        func.apply(context, args);
    };
}
function waitUntil(condition, callback, timeout = 100, timeoutMessage) {
    const timeStamp = /* @__PURE__ */ new Date().getTime();
    let interval = null;
    let executed = false;
    const internalCallback = ()=>{
        const reachedTimeout = /* @__PURE__ */ new Date().getTime() - timeStamp > timeout;
        if (condition() || reachedTimeout) {
            callback();
            executed = true;
            if (interval != null) {
                window.clearInterval(interval);
                interval = null;
            }
            if (reachedTimeout && timeoutMessage) console.warn(timeoutMessage);
        }
    };
    internalCallback();
    if (!executed) interval = window.setInterval(internalCallback, 10);
}
function compose(...fns) {
    return (arg)=>fns.reduce((composed, f)=>f(composed), arg);
}
var noop = ()=>{
    return;
};
// community-modules/core/src/modules/moduleNames.ts
var ModuleNames = /* @__PURE__ */ ((ModuleNames2)=>{
    ModuleNames2["CommunityCoreModule"] = "@ag-grid-community/core";
    ModuleNames2["InfiniteRowModelModule"] = "@ag-grid-community/infinite-row-model";
    ModuleNames2["ClientSideRowModelModule"] = "@ag-grid-community/client-side-row-model";
    ModuleNames2["CsvExportModule"] = "@ag-grid-community/csv-export";
    ModuleNames2["EnterpriseCoreModule"] = "@ag-grid-enterprise/core";
    ModuleNames2["RowGroupingModule"] = "@ag-grid-enterprise/row-grouping";
    ModuleNames2["ColumnsToolPanelModule"] = "@ag-grid-enterprise/column-tool-panel";
    ModuleNames2["FiltersToolPanelModule"] = "@ag-grid-enterprise/filter-tool-panel";
    ModuleNames2["MenuModule"] = "@ag-grid-enterprise/menu";
    ModuleNames2["SetFilterModule"] = "@ag-grid-enterprise/set-filter";
    ModuleNames2["MultiFilterModule"] = "@ag-grid-enterprise/multi-filter";
    ModuleNames2["StatusBarModule"] = "@ag-grid-enterprise/status-bar";
    ModuleNames2["SideBarModule"] = "@ag-grid-enterprise/side-bar";
    ModuleNames2["RangeSelectionModule"] = "@ag-grid-enterprise/range-selection";
    ModuleNames2["MasterDetailModule"] = "@ag-grid-enterprise/master-detail";
    ModuleNames2["RichSelectModule"] = "@ag-grid-enterprise/rich-select";
    ModuleNames2["GridChartsModule"] = "@ag-grid-enterprise/charts";
    ModuleNames2["ViewportRowModelModule"] = "@ag-grid-enterprise/viewport-row-model";
    ModuleNames2["ServerSideRowModelModule"] = "@ag-grid-enterprise/server-side-row-model";
    ModuleNames2["ExcelExportModule"] = "@ag-grid-enterprise/excel-export";
    ModuleNames2["ClipboardModule"] = "@ag-grid-enterprise/clipboard";
    ModuleNames2["SparklinesModule"] = "@ag-grid-enterprise/sparklines";
    ModuleNames2["AdvancedFilterModule"] = "@ag-grid-enterprise/advanced-filter";
    ModuleNames2["AngularModule"] = "@ag-grid-community/angular";
    ModuleNames2["ReactModule"] = "@ag-grid-community/react";
    ModuleNames2["VueModule"] = "@ag-grid-community/vue";
    return ModuleNames2;
})(ModuleNames || {});
// community-modules/core/src/modules/moduleRegistry.ts
var _ModuleRegistry = class _ModuleRegistry {
    /**
   * Globally register the given module for all grids.
   * @param module - module to register
   */ static register(module) {
        _ModuleRegistry.__register(module, true, void 0);
    }
    /**
   * Globally register the given modules for all grids.
   * @param modules - modules to register
   */ static registerModules(modules) {
        _ModuleRegistry.__registerModules(modules, true, void 0);
    }
    /** AG GRID INTERNAL - Module registration helper. */ static __register(module, moduleBased, gridId) {
        _ModuleRegistry.runVersionChecks(module);
        if (gridId !== void 0) {
            _ModuleRegistry.areGridScopedModules = true;
            if (_ModuleRegistry.gridModulesMap[gridId] === void 0) _ModuleRegistry.gridModulesMap[gridId] = {};
            _ModuleRegistry.gridModulesMap[gridId][module.moduleName] = module;
        } else _ModuleRegistry.globalModulesMap[module.moduleName] = module;
        _ModuleRegistry.setModuleBased(moduleBased);
    }
    /** AG GRID INTERNAL - Unregister grid scoped module. */ static __unRegisterGridModules(gridId) {
        delete _ModuleRegistry.gridModulesMap[gridId];
    }
    /** AG GRID INTERNAL - Module registration helper. */ static __registerModules(modules, moduleBased, gridId) {
        _ModuleRegistry.setModuleBased(moduleBased);
        if (!modules) return;
        modules.forEach((module)=>_ModuleRegistry.__register(module, moduleBased, gridId));
    }
    static isValidModuleVersion(module) {
        const [moduleMajor, moduleMinor] = module.version.split(".") || [];
        const [currentModuleMajor, currentModuleMinor] = _ModuleRegistry.currentModuleVersion.split(".") || [];
        return moduleMajor === currentModuleMajor && moduleMinor === currentModuleMinor;
    }
    static runVersionChecks(module) {
        if (!_ModuleRegistry.currentModuleVersion) _ModuleRegistry.currentModuleVersion = module.version;
        if (!module.version) console.error(`AG Grid: You are using incompatible versions of AG Grid modules. Major and minor versions should always match across modules. '${module.moduleName}' is incompatible. Please update all modules to the same version.`);
        else if (!_ModuleRegistry.isValidModuleVersion(module)) console.error(`AG Grid: You are using incompatible versions of AG Grid modules. Major and minor versions should always match across modules. '${module.moduleName}' is version ${module.version} but the other modules are version ${this.currentModuleVersion}. Please update all modules to the same version.`);
        if (module.validate) {
            const result = module.validate();
            if (!result.isValid) {
                const errorResult = result;
                console.error(`AG Grid: ${errorResult.message}`);
            }
        }
    }
    static setModuleBased(moduleBased) {
        if (_ModuleRegistry.moduleBased === void 0) _ModuleRegistry.moduleBased = moduleBased;
        else if (_ModuleRegistry.moduleBased !== moduleBased) doOnce(()=>{
            console.warn(`AG Grid: You are mixing modules (i.e. @ag-grid-community/core) and packages (ag-grid-community) - you can only use one or the other of these mechanisms.`);
            console.warn("Please see https://www.ag-grid.com/javascript-grid/modules/ for more information.");
        }, "ModulePackageCheck");
    }
    /**
   * AG GRID INTERNAL - Set if files are being served from a single UMD bundle to provide accurate enterprise upgrade steps.
   */ static __setIsBundled() {
        _ModuleRegistry.isBundled = true;
    }
    /** AG GRID INTERNAL - Assert a given module has been register, globally or individually with this grid. */ static __assertRegistered(moduleName, reason, gridId) {
        var _a;
        if (this.__isRegistered(moduleName, gridId)) return true;
        const warningKey = reason + moduleName;
        let warningMessage;
        if (_ModuleRegistry.isBundled) warningMessage = `AG Grid: unable to use ${reason} as 'ag-grid-enterprise' has not been loaded. Check you are using the Enterprise bundle:
        
        <script src="https://cdn.jsdelivr.net/npm/ag-grid-enterprise@AG_GRID_VERSION/dist/ag-grid-enterprise.min.js"><\/script>
        
For more info see: https://ag-grid.com/javascript-data-grid/getting-started/#getting-started-with-ag-grid-enterprise`;
        else if (_ModuleRegistry.moduleBased || _ModuleRegistry.moduleBased === void 0) {
            let modName = (_a = Object.entries(ModuleNames).find(([k, v])=>v === moduleName)) == null ? void 0 : _a[0];
            warningMessage = `AG Grid: unable to use ${reason} as the ${modName} is not registered${_ModuleRegistry.areGridScopedModules ? ` for gridId: ${gridId}` : ""}. Check if you have registered the module:
           
    import { ModuleRegistry } from '@ag-grid-community/core';
    import { ${modName} } from '${moduleName}';
    
    ModuleRegistry.registerModules([ ${modName} ]);

For more info see: https://www.ag-grid.com/javascript-grid/modules/`;
        } else warningMessage = `AG Grid: unable to use ${reason} as package 'ag-grid-enterprise' has not been imported. Check that you have imported the package:
            
    import 'ag-grid-enterprise';`;
        doOnce(()=>{
            console.warn(warningMessage);
        }, warningKey);
        return false;
    }
    /** AG GRID INTERNAL - Is the given module registered, globally or individually with this grid. */ static __isRegistered(moduleName, gridId) {
        var _a;
        return !!_ModuleRegistry.globalModulesMap[moduleName] || !!((_a = _ModuleRegistry.gridModulesMap[gridId]) == null ? void 0 : _a[moduleName]);
    }
    /** AG GRID INTERNAL - Get all registered modules globally / individually for this grid. */ static __getRegisteredModules(gridId) {
        return [
            ...values(_ModuleRegistry.globalModulesMap),
            ...values(_ModuleRegistry.gridModulesMap[gridId] || {})
        ];
    }
    /** AG GRID INTERNAL - Get the list of modules registered individually for this grid. */ static __getGridRegisteredModules(gridId) {
        var _a;
        return values((_a = _ModuleRegistry.gridModulesMap[gridId]) != null ? _a : {}) || [];
    }
    /** INTERNAL */ static __isPackageBased() {
        return !_ModuleRegistry.moduleBased;
    }
};
// having in a map a) removes duplicates and b) allows fast lookup
_ModuleRegistry.globalModulesMap = {};
_ModuleRegistry.gridModulesMap = {};
_ModuleRegistry.areGridScopedModules = false;
var ModuleRegistry = _ModuleRegistry;
// community-modules/core/src/context/context.ts
var Context = class {
    constructor(params, logger){
        this.beanWrappers = {};
        this.destroyed = false;
        if (!params || !params.beanClasses) return;
        this.contextParams = params;
        this.logger = logger;
        this.logger.log(">> creating ag-Application Context");
        this.createBeans();
        const beanInstances = this.getBeanInstances();
        this.wireBeans(beanInstances);
        this.logger.log(">> ag-Application Context ready - component is alive");
    }
    getBeanInstances() {
        return values(this.beanWrappers).map((beanEntry)=>beanEntry.beanInstance);
    }
    createBean(bean, afterPreCreateCallback) {
        if (!bean) throw Error(`Can't wire to bean since it is null`);
        this.wireBeans([
            bean
        ], afterPreCreateCallback);
        return bean;
    }
    wireBeans(beanInstances, afterPreCreateCallback) {
        this.autoWireBeans(beanInstances);
        this.methodWireBeans(beanInstances);
        this.callLifeCycleMethods(beanInstances, "preConstructMethods");
        if (exists(afterPreCreateCallback)) beanInstances.forEach(afterPreCreateCallback);
        this.callLifeCycleMethods(beanInstances, "postConstructMethods");
    }
    createBeans() {
        this.contextParams.beanClasses.forEach(this.createBeanWrapper.bind(this));
        iterateObject(this.beanWrappers, (key, beanEntry)=>{
            let constructorParamsMeta;
            if (beanEntry.bean.__agBeanMetaData && beanEntry.bean.__agBeanMetaData.autowireMethods && beanEntry.bean.__agBeanMetaData.autowireMethods.agConstructor) constructorParamsMeta = beanEntry.bean.__agBeanMetaData.autowireMethods.agConstructor;
            const constructorParams = this.getBeansForParameters(constructorParamsMeta, beanEntry.bean.name);
            const newInstance = new (beanEntry.bean.bind.apply(beanEntry.bean, [
                null,
                ...constructorParams
            ]))();
            beanEntry.beanInstance = newInstance;
        });
        const createdBeanNames = Object.keys(this.beanWrappers).join(", ");
        this.logger.log(`created beans: ${createdBeanNames}`);
    }
    // tslint:disable-next-line
    createBeanWrapper(BeanClass) {
        const metaData = BeanClass.__agBeanMetaData;
        if (!metaData) {
            let beanName;
            if (BeanClass.prototype.constructor) beanName = getFunctionName(BeanClass.prototype.constructor);
            else beanName = "" + BeanClass;
            console.error(`Context item ${beanName} is not a bean`);
            return;
        }
        const beanEntry = {
            bean: BeanClass,
            beanInstance: null,
            beanName: metaData.beanName
        };
        this.beanWrappers[metaData.beanName] = beanEntry;
    }
    autoWireBeans(beanInstances) {
        beanInstances.forEach((beanInstance)=>{
            this.forEachMetaDataInHierarchy(beanInstance, (metaData, beanName)=>{
                const attributes = metaData.agClassAttributes;
                if (!attributes) return;
                attributes.forEach((attribute)=>{
                    const otherBean = this.lookupBeanInstance(beanName, attribute.beanName, attribute.optional);
                    beanInstance[attribute.attributeName] = otherBean;
                });
            });
        });
    }
    methodWireBeans(beanInstances) {
        beanInstances.forEach((beanInstance)=>{
            this.forEachMetaDataInHierarchy(beanInstance, (metaData, beanName)=>{
                iterateObject(metaData.autowireMethods, (methodName, wireParams)=>{
                    if (methodName === "agConstructor") return;
                    const initParams = this.getBeansForParameters(wireParams, beanName);
                    beanInstance[methodName].apply(beanInstance, initParams);
                });
            });
        });
    }
    forEachMetaDataInHierarchy(beanInstance, callback) {
        let prototype = Object.getPrototypeOf(beanInstance);
        while(prototype != null){
            const constructor = prototype.constructor;
            if (constructor.hasOwnProperty("__agBeanMetaData")) {
                const metaData = constructor.__agBeanMetaData;
                const beanName = this.getBeanName(constructor);
                callback(metaData, beanName);
            }
            prototype = Object.getPrototypeOf(prototype);
        }
    }
    getBeanName(constructor) {
        if (constructor.__agBeanMetaData && constructor.__agBeanMetaData.beanName) return constructor.__agBeanMetaData.beanName;
        const constructorString = constructor.toString();
        const beanName = constructorString.substring(9, constructorString.indexOf("("));
        return beanName;
    }
    getBeansForParameters(parameters, beanName) {
        const beansList = [];
        if (parameters) iterateObject(parameters, (paramIndex, otherBeanName)=>{
            const otherBean = this.lookupBeanInstance(beanName, otherBeanName);
            beansList[Number(paramIndex)] = otherBean;
        });
        return beansList;
    }
    lookupBeanInstance(wiringBean, beanName, optional = false) {
        if (this.destroyed) {
            this.logger.log(`AG Grid: bean reference ${beanName} is used after the grid is destroyed!`);
            return null;
        }
        if (beanName === "context") return this;
        if (this.contextParams.providedBeanInstances && this.contextParams.providedBeanInstances.hasOwnProperty(beanName)) return this.contextParams.providedBeanInstances[beanName];
        const beanEntry = this.beanWrappers[beanName];
        if (beanEntry) return beanEntry.beanInstance;
        if (!optional) console.error(`AG Grid: unable to find bean reference ${beanName} while initialising ${wiringBean}`);
        return null;
    }
    callLifeCycleMethods(beanInstances, lifeCycleMethod) {
        beanInstances.forEach((beanInstance)=>this.callLifeCycleMethodsOnBean(beanInstance, lifeCycleMethod));
    }
    callLifeCycleMethodsOnBean(beanInstance, lifeCycleMethod, methodToIgnore) {
        const allMethods = {};
        this.forEachMetaDataInHierarchy(beanInstance, (metaData)=>{
            const methods = metaData[lifeCycleMethod];
            if (methods) methods.forEach((methodName)=>{
                if (methodName != methodToIgnore) allMethods[methodName] = true;
            });
        });
        const allMethodsList = Object.keys(allMethods);
        allMethodsList.forEach((methodName)=>beanInstance[methodName]());
    }
    getBean(name) {
        return this.lookupBeanInstance("getBean", name, true);
    }
    destroy() {
        if (this.destroyed) return;
        this.destroyed = true;
        this.logger.log(">> Shutting down ag-Application Context");
        const beanInstances = this.getBeanInstances();
        this.destroyBeans(beanInstances);
        this.contextParams.providedBeanInstances = null;
        ModuleRegistry.__unRegisterGridModules(this.contextParams.gridId);
        this.logger.log(">> ag-Application Context shut down - component is dead");
    }
    destroyBean(bean) {
        if (!bean) return;
        this.destroyBeans([
            bean
        ]);
    }
    destroyBeans(beans) {
        if (!beans) return [];
        beans.forEach((bean)=>{
            this.callLifeCycleMethodsOnBean(bean, "preDestroyMethods", "destroy");
            const beanAny = bean;
            if (typeof beanAny.destroy === "function") beanAny.destroy();
        });
        return [];
    }
    isDestroyed() {
        return this.destroyed;
    }
    getGridId() {
        return this.contextParams.gridId;
    }
};
function PreConstruct(target, methodName, descriptor) {
    const props = getOrCreateProps(target.constructor);
    if (!props.preConstructMethods) props.preConstructMethods = [];
    props.preConstructMethods.push(methodName);
}
function PostConstruct(target, methodName, descriptor) {
    const props = getOrCreateProps(target.constructor);
    if (!props.postConstructMethods) props.postConstructMethods = [];
    props.postConstructMethods.push(methodName);
}
function PreDestroy(target, methodName, descriptor) {
    const props = getOrCreateProps(target.constructor);
    if (!props.preDestroyMethods) props.preDestroyMethods = [];
    props.preDestroyMethods.push(methodName);
}
function Bean(beanName) {
    return (classConstructor)=>{
        const props = getOrCreateProps(classConstructor);
        props.beanName = beanName;
    };
}
function Autowired(name) {
    return (target, propertyKey, descriptor)=>{
        autowiredFunc(target, name, false, target, propertyKey, null);
    };
}
function Optional(name) {
    return (target, propertyKey, descriptor)=>{
        autowiredFunc(target, name, true, target, propertyKey, null);
    };
}
function autowiredFunc(target, name, optional, classPrototype, methodOrAttributeName, index) {
    if (name === null) {
        console.error("AG Grid: Autowired name should not be null");
        return;
    }
    if (typeof index === "number") {
        console.error("AG Grid: Autowired should be on an attribute");
        return;
    }
    const props = getOrCreateProps(target.constructor);
    if (!props.agClassAttributes) props.agClassAttributes = [];
    props.agClassAttributes.push({
        attributeName: methodOrAttributeName,
        beanName: name,
        optional
    });
}
function Qualifier(name) {
    return (classPrototype, methodOrAttributeName, index)=>{
        const constructor = typeof classPrototype == "function" ? classPrototype : classPrototype.constructor;
        let props;
        if (typeof index === "number") {
            let methodName;
            if (methodOrAttributeName) {
                props = getOrCreateProps(constructor);
                methodName = methodOrAttributeName;
            } else {
                props = getOrCreateProps(constructor);
                methodName = "agConstructor";
            }
            if (!props.autowireMethods) props.autowireMethods = {};
            if (!props.autowireMethods[methodName]) props.autowireMethods[methodName] = {};
            props.autowireMethods[methodName][index] = name;
        }
    };
}
function getOrCreateProps(target) {
    if (!target.hasOwnProperty("__agBeanMetaData")) target.__agBeanMetaData = {};
    return target.__agBeanMetaData;
}
// community-modules/core/src/eventService.ts
var EventService = class {
    constructor(){
        this.allSyncListeners = /* @__PURE__ */ new Map();
        this.allAsyncListeners = /* @__PURE__ */ new Map();
        this.globalSyncListeners = /* @__PURE__ */ new Set();
        this.globalAsyncListeners = /* @__PURE__ */ new Set();
        this.asyncFunctionsQueue = [];
        this.scheduled = false;
        // using an object performs better than a Set for the number of different events we have
        this.firedEvents = {};
    }
    // because this class is used both inside the context and outside the context, we do not
    // use autowired attributes, as that would be confusing, as sometimes the attributes
    // would be wired, and sometimes not.
    //
    // the global event servers used by AG Grid is autowired by the context once, and this
    // setBeans method gets called once.
    //
    // the times when this class is used outside of the context (eg RowNode has an instance of this
    // class) then it is not a bean, and this setBeans method is not called.
    setBeans(gos, frameworkOverrides, globalEventListener = null, globalSyncEventListener = null) {
        this.frameworkOverrides = frameworkOverrides;
        this.gos = gos;
        if (globalEventListener) {
            const async = gos.useAsyncEvents();
            this.addGlobalListener(globalEventListener, async);
        }
        if (globalSyncEventListener) this.addGlobalListener(globalSyncEventListener, false);
    }
    setFrameworkOverrides(frameworkOverrides) {
        this.frameworkOverrides = frameworkOverrides;
    }
    getListeners(eventType, async, autoCreateListenerCollection) {
        const listenerMap = async ? this.allAsyncListeners : this.allSyncListeners;
        let listeners = listenerMap.get(eventType);
        if (!listeners && autoCreateListenerCollection) {
            listeners = /* @__PURE__ */ new Set();
            listenerMap.set(eventType, listeners);
        }
        return listeners;
    }
    noRegisteredListenersExist() {
        return this.allSyncListeners.size === 0 && this.allAsyncListeners.size === 0 && this.globalSyncListeners.size === 0 && this.globalAsyncListeners.size === 0;
    }
    addEventListener(eventType, listener, async = false) {
        this.getListeners(eventType, async, true).add(listener);
    }
    removeEventListener(eventType, listener, async = false) {
        const listeners = this.getListeners(eventType, async, false);
        if (!listeners) return;
        listeners.delete(listener);
        if (listeners.size === 0) {
            const listenerMap = async ? this.allAsyncListeners : this.allSyncListeners;
            listenerMap.delete(eventType);
        }
    }
    addGlobalListener(listener, async = false) {
        (async ? this.globalAsyncListeners : this.globalSyncListeners).add(listener);
    }
    removeGlobalListener(listener, async = false) {
        (async ? this.globalAsyncListeners : this.globalSyncListeners).delete(listener);
    }
    dispatchEvent(event) {
        let agEvent = event;
        if (this.gos) this.gos.addGridCommonParams(agEvent);
        this.dispatchToListeners(agEvent, true);
        this.dispatchToListeners(agEvent, false);
        this.firedEvents[agEvent.type] = true;
    }
    dispatchEventOnce(event) {
        if (!this.firedEvents[event.type]) this.dispatchEvent(event);
    }
    dispatchToListeners(event, async) {
        var _a;
        const eventType = event.type;
        if (async && "event" in event) {
            const browserEvent = event.event;
            if (browserEvent instanceof Event) event.eventPath = browserEvent.composedPath();
        }
        const processEventListeners = (listeners2, originalListeners2)=>listeners2.forEach((listener)=>{
                if (!originalListeners2.has(listener)) return;
                const callback = this.frameworkOverrides ? ()=>this.frameworkOverrides.wrapIncoming(()=>listener(event)) : ()=>listener(event);
                if (async) this.dispatchAsync(callback);
                else callback();
            });
        const originalListeners = (_a = this.getListeners(eventType, async, false)) != null ? _a : /* @__PURE__ */ new Set();
        const listeners = new Set(originalListeners);
        if (listeners.size > 0) processEventListeners(listeners, originalListeners);
        const globalListeners = new Set(async ? this.globalAsyncListeners : this.globalSyncListeners);
        globalListeners.forEach((listener)=>{
            const callback = this.frameworkOverrides ? ()=>this.frameworkOverrides.wrapIncoming(()=>listener(eventType, event)) : ()=>listener(eventType, event);
            if (async) this.dispatchAsync(callback);
            else callback();
        });
    }
    // this gets called inside the grid's thread, for each event that it
    // wants to set async. the grid then batches the events into one setTimeout()
    // because setTimeout() is an expensive operation. ideally we would have
    // each event in it's own setTimeout(), but we batch for performance.
    dispatchAsync(func) {
        this.asyncFunctionsQueue.push(func);
        if (!this.scheduled) {
            this.frameworkOverrides.wrapIncoming(()=>{
                window.setTimeout(this.flushAsyncQueue.bind(this), 0);
            });
            this.scheduled = true;
        }
    }
    // this happens in the next VM turn only, and empties the queue of events
    flushAsyncQueue() {
        this.scheduled = false;
        const queueCopy = this.asyncFunctionsQueue.slice();
        this.asyncFunctionsQueue = [];
        queueCopy.forEach((func)=>func());
    }
};
__decorateClass([
    __decorateParam(0, Qualifier("gridOptionsService")),
    __decorateParam(1, Qualifier("frameworkOverrides")),
    __decorateParam(2, Qualifier("globalEventListener")),
    __decorateParam(3, Qualifier("globalSyncEventListener"))
], EventService.prototype, "setBeans", 1);
EventService = __decorateClass([
    Bean("eventService")
], EventService);
// community-modules/core/src/misc/frameworkEventListenerService.ts
var FrameworkEventListenerService = class {
    constructor(frameworkOverrides){
        this.frameworkOverrides = frameworkOverrides;
        // Map from user listener to wrapped listener so we can remove listener provided by user
        this.wrappedListeners = /* @__PURE__ */ new Map();
        this.wrappedGlobalListeners = /* @__PURE__ */ new Map();
    }
    wrap(userListener) {
        let listener = userListener;
        if (this.frameworkOverrides.shouldWrapOutgoing) {
            listener = (event)=>{
                this.frameworkOverrides.wrapOutgoing(()=>userListener(event));
            };
            this.wrappedListeners.set(userListener, listener);
        }
        return listener;
    }
    wrapGlobal(userListener) {
        let listener = userListener;
        if (this.frameworkOverrides.shouldWrapOutgoing) {
            listener = (eventType, event)=>{
                this.frameworkOverrides.wrapOutgoing(()=>userListener(eventType, event));
            };
            this.wrappedGlobalListeners.set(userListener, listener);
        }
        return listener;
    }
    unwrap(userListener) {
        var _a;
        return (_a = this.wrappedListeners.get(userListener)) != null ? _a : userListener;
    }
    unwrapGlobal(userListener) {
        var _a;
        return (_a = this.wrappedGlobalListeners.get(userListener)) != null ? _a : userListener;
    }
};
// community-modules/core/src/entities/column.ts
var COL_DEF_DEFAULTS = {
    resizable: true,
    sortable: true
};
var instanceIdSequence = 0;
function getNextColInstanceId() {
    return instanceIdSequence++;
}
var _Column = class _Column {
    constructor(colDef, userProvidedColDef, colId, primary){
        // used by React (and possibly other frameworks) as key for rendering. also used to
        // identify old vs new columns for destroying cols when no longer used.
        this.instanceId = getNextColInstanceId();
        // The measured height of this column's header when autoHeaderHeight is enabled
        this.autoHeaderHeight = null;
        this.moving = false;
        this.menuVisible = false;
        this.lastLeftPinned = false;
        this.firstRightPinned = false;
        this.filterActive = false;
        this.eventService = new EventService();
        this.tooltipEnabled = false;
        this.rowGroupActive = false;
        this.pivotActive = false;
        this.aggregationActive = false;
        this.colDef = colDef;
        this.userProvidedColDef = userProvidedColDef;
        this.colId = colId;
        this.primary = primary;
        this.setState(colDef);
    }
    getInstanceId() {
        return this.instanceId;
    }
    setState(colDef) {
        if (colDef.sort !== void 0) {
            if (colDef.sort === "asc" || colDef.sort === "desc") this.sort = colDef.sort;
        } else if (colDef.initialSort === "asc" || colDef.initialSort === "desc") this.sort = colDef.initialSort;
        const sortIndex = colDef.sortIndex;
        const initialSortIndex = colDef.initialSortIndex;
        if (sortIndex !== void 0) {
            if (sortIndex !== null) this.sortIndex = sortIndex;
        } else if (initialSortIndex !== null) this.sortIndex = initialSortIndex;
        const hide = colDef.hide;
        const initialHide = colDef.initialHide;
        if (hide !== void 0) this.visible = !hide;
        else this.visible = !initialHide;
        if (colDef.pinned !== void 0) this.setPinned(colDef.pinned);
        else this.setPinned(colDef.initialPinned);
        const flex = colDef.flex;
        const initialFlex = colDef.initialFlex;
        if (flex !== void 0) this.flex = flex;
        else if (initialFlex !== void 0) this.flex = initialFlex;
    }
    // gets called when user provides an alternative colDef, eg
    setColDef(colDef, userProvidedColDef, source) {
        this.colDef = colDef;
        this.userProvidedColDef = userProvidedColDef;
        this.initMinAndMaxWidths();
        this.initDotNotation();
        this.initTooltip();
        this.eventService.dispatchEvent(this.createColumnEvent("colDefChanged", source));
    }
    /**
   * Returns the column definition provided by the application.
   * This may not be correct, as items can be superseded by default column options.
   * However it's useful for comparison, eg to know which application column definition matches that column.
   */ getUserProvidedColDef() {
        return this.userProvidedColDef;
    }
    setParent(parent) {
        this.parent = parent;
    }
    /** Returns the parent column group, if column grouping is active. */ getParent() {
        return this.parent;
    }
    setOriginalParent(originalParent) {
        this.originalParent = originalParent;
    }
    /**
   * Used for marryChildren, helps with comparing when duplicate groups have been created to manage split groups.
   * 
   * Parent may contain a duplicate but not identical group when the group is split.
   */ getOriginalParent() {
        return this.originalParent;
    }
    initialise() {
        this.initMinAndMaxWidths();
        this.resetActualWidth("gridInitializing");
        this.initDotNotation();
        this.initTooltip();
    }
    initDotNotation() {
        const suppressDotNotation = this.gos.get("suppressFieldDotNotation");
        this.fieldContainsDots = exists(this.colDef.field) && this.colDef.field.indexOf(".") >= 0 && !suppressDotNotation;
        this.tooltipFieldContainsDots = exists(this.colDef.tooltipField) && this.colDef.tooltipField.indexOf(".") >= 0 && !suppressDotNotation;
    }
    initMinAndMaxWidths() {
        var _a, _b;
        const colDef = this.colDef;
        this.minWidth = (_a = colDef.minWidth) != null ? _a : this.environment.getMinColWidth();
        this.maxWidth = (_b = colDef.maxWidth) != null ? _b : Number.MAX_SAFE_INTEGER;
    }
    initTooltip() {
        this.tooltipEnabled = exists(this.colDef.tooltipField) || exists(this.colDef.tooltipValueGetter) || exists(this.colDef.tooltipComponent);
    }
    resetActualWidth(source) {
        const initialWidth = this.calculateColInitialWidth(this.colDef);
        this.setActualWidth(initialWidth, source, true);
    }
    calculateColInitialWidth(colDef) {
        var _a, _b;
        const minColWidth = (_a = colDef.minWidth) != null ? _a : this.environment.getMinColWidth();
        const maxColWidth = (_b = colDef.maxWidth) != null ? _b : Number.MAX_SAFE_INTEGER;
        let width;
        const colDefWidth = attrToNumber(colDef.width);
        const colDefInitialWidth = attrToNumber(colDef.initialWidth);
        if (colDefWidth != null) width = colDefWidth;
        else if (colDefInitialWidth != null) width = colDefInitialWidth;
        else width = 200;
        return Math.max(Math.min(width, maxColWidth), minColWidth);
    }
    isEmptyGroup() {
        return false;
    }
    isRowGroupDisplayed(colId) {
        if (missing(this.colDef) || missing(this.colDef.showRowGroup)) return false;
        const showingAllGroups = this.colDef.showRowGroup === true;
        const showingThisGroup = this.colDef.showRowGroup === colId;
        return showingAllGroups || showingThisGroup;
    }
    /** Returns `true` if column is a primary column, `false` if secondary. Secondary columns are used for pivoting. */ isPrimary() {
        return this.primary;
    }
    /** Returns `true` if column filtering is allowed. */ isFilterAllowed() {
        const filterDefined = !!this.colDef.filter;
        return filterDefined;
    }
    isFieldContainsDots() {
        return this.fieldContainsDots;
    }
    isTooltipEnabled() {
        return this.tooltipEnabled;
    }
    isTooltipFieldContainsDots() {
        return this.tooltipFieldContainsDots;
    }
    /** Add an event listener to the column. */ addEventListener(eventType, userListener) {
        var _a, _b;
        if (this.frameworkOverrides.shouldWrapOutgoing && !this.frameworkEventListenerService) {
            this.eventService.setFrameworkOverrides(this.frameworkOverrides);
            this.frameworkEventListenerService = new FrameworkEventListenerService(this.frameworkOverrides);
        }
        const listener = (_b = (_a = this.frameworkEventListenerService) == null ? void 0 : _a.wrap(userListener)) != null ? _b : userListener;
        this.eventService.addEventListener(eventType, listener);
    }
    /** Remove event listener from the column. */ removeEventListener(eventType, userListener) {
        var _a, _b;
        const listener = (_b = (_a = this.frameworkEventListenerService) == null ? void 0 : _a.unwrap(userListener)) != null ? _b : userListener;
        this.eventService.removeEventListener(eventType, listener);
    }
    createColumnFunctionCallbackParams(rowNode) {
        return this.gos.addGridCommonParams({
            node: rowNode,
            data: rowNode.data,
            column: this,
            colDef: this.colDef
        });
    }
    isSuppressNavigable(rowNode) {
        if (typeof this.colDef.suppressNavigable === "boolean") return this.colDef.suppressNavigable;
        if (typeof this.colDef.suppressNavigable === "function") {
            const params = this.createColumnFunctionCallbackParams(rowNode);
            const userFunc = this.colDef.suppressNavigable;
            return userFunc(params);
        }
        return false;
    }
    /**
   * Returns `true` if the cell for this column is editable for the given `rowNode`, otherwise `false`.
   */ isCellEditable(rowNode) {
        if (rowNode.group && !this.gos.get("enableGroupEdit")) return false;
        return this.isColumnFunc(rowNode, this.colDef.editable);
    }
    isSuppressFillHandle() {
        return !!this.colDef.suppressFillHandle;
    }
    isAutoHeight() {
        return !!this.colDef.autoHeight;
    }
    isAutoHeaderHeight() {
        return !!this.colDef.autoHeaderHeight;
    }
    isRowDrag(rowNode) {
        return this.isColumnFunc(rowNode, this.colDef.rowDrag);
    }
    isDndSource(rowNode) {
        return this.isColumnFunc(rowNode, this.colDef.dndSource);
    }
    isCellCheckboxSelection(rowNode) {
        return this.isColumnFunc(rowNode, this.colDef.checkboxSelection);
    }
    isSuppressPaste(rowNode) {
        return this.isColumnFunc(rowNode, this.colDef ? this.colDef.suppressPaste : null);
    }
    isResizable() {
        return !!this.getColDefValue("resizable");
    }
    /** Get value from ColDef or default if it exists. */ getColDefValue(key) {
        var _a;
        return (_a = this.colDef[key]) != null ? _a : COL_DEF_DEFAULTS[key];
    }
    isColumnFunc(rowNode, value) {
        if (typeof value === "boolean") return value;
        if (typeof value === "function") {
            const params = this.createColumnFunctionCallbackParams(rowNode);
            const editableFunc = value;
            return editableFunc(params);
        }
        return false;
    }
    setMoving(moving, source) {
        this.moving = moving;
        this.eventService.dispatchEvent(this.createColumnEvent("movingChanged", source));
    }
    createColumnEvent(type, source) {
        return this.gos.addGridCommonParams({
            type,
            column: this,
            columns: [
                this
            ],
            source
        });
    }
    isMoving() {
        return this.moving;
    }
    /** If sorting is active, returns the sort direction e.g. `'asc'` or `'desc'`. */ getSort() {
        return this.sort;
    }
    setSort(sort, source) {
        if (this.sort !== sort) {
            this.sort = sort;
            this.eventService.dispatchEvent(this.createColumnEvent("sortChanged", source));
        }
        this.dispatchStateUpdatedEvent("sort");
    }
    setMenuVisible(visible, source) {
        if (this.menuVisible !== visible) {
            this.menuVisible = visible;
            this.eventService.dispatchEvent(this.createColumnEvent("menuVisibleChanged", source));
        }
    }
    isMenuVisible() {
        return this.menuVisible;
    }
    isSortable() {
        return !!this.getColDefValue("sortable");
    }
    isSortAscending() {
        return this.sort === "asc";
    }
    isSortDescending() {
        return this.sort === "desc";
    }
    isSortNone() {
        return missing(this.sort);
    }
    isSorting() {
        return exists(this.sort);
    }
    getSortIndex() {
        return this.sortIndex;
    }
    setSortIndex(sortOrder) {
        this.sortIndex = sortOrder;
        this.dispatchStateUpdatedEvent("sortIndex");
    }
    setAggFunc(aggFunc) {
        this.aggFunc = aggFunc;
        this.dispatchStateUpdatedEvent("aggFunc");
    }
    /** If aggregation is set for the column, returns the aggregation function. */ getAggFunc() {
        return this.aggFunc;
    }
    getLeft() {
        return this.left;
    }
    getOldLeft() {
        return this.oldLeft;
    }
    getRight() {
        return this.left + this.actualWidth;
    }
    setLeft(left, source) {
        this.oldLeft = this.left;
        if (this.left !== left) {
            this.left = left;
            this.eventService.dispatchEvent(this.createColumnEvent("leftChanged", source));
        }
    }
    /** Returns `true` if filter is active on the column. */ isFilterActive() {
        return this.filterActive;
    }
    // additionalEventAttributes is used by provided simple floating filter, so it can add 'floatingFilter=true' to the event
    setFilterActive(active, source, additionalEventAttributes) {
        if (this.filterActive !== active) {
            this.filterActive = active;
            this.eventService.dispatchEvent(this.createColumnEvent("filterActiveChanged", source));
        }
        const filterChangedEvent = this.createColumnEvent("filterChanged", source);
        if (additionalEventAttributes) mergeDeep(filterChangedEvent, additionalEventAttributes);
        this.eventService.dispatchEvent(filterChangedEvent);
    }
    /** Returns `true` when this `Column` is hovered, otherwise `false` */ isHovered() {
        return this.columnHoverService.isHovered(this);
    }
    setPinned(pinned) {
        if (pinned === true || pinned === "left") this.pinned = "left";
        else if (pinned === "right") this.pinned = "right";
        else this.pinned = null;
        this.dispatchStateUpdatedEvent("pinned");
    }
    setFirstRightPinned(firstRightPinned, source) {
        if (this.firstRightPinned !== firstRightPinned) {
            this.firstRightPinned = firstRightPinned;
            this.eventService.dispatchEvent(this.createColumnEvent("firstRightPinnedChanged", source));
        }
    }
    setLastLeftPinned(lastLeftPinned, source) {
        if (this.lastLeftPinned !== lastLeftPinned) {
            this.lastLeftPinned = lastLeftPinned;
            this.eventService.dispatchEvent(this.createColumnEvent("lastLeftPinnedChanged", source));
        }
    }
    isFirstRightPinned() {
        return this.firstRightPinned;
    }
    isLastLeftPinned() {
        return this.lastLeftPinned;
    }
    isPinned() {
        return this.pinned === "left" || this.pinned === "right";
    }
    isPinnedLeft() {
        return this.pinned === "left";
    }
    isPinnedRight() {
        return this.pinned === "right";
    }
    getPinned() {
        return this.pinned;
    }
    setVisible(visible, source) {
        const newValue = visible === true;
        if (this.visible !== newValue) {
            this.visible = newValue;
            this.eventService.dispatchEvent(this.createColumnEvent("visibleChanged", source));
        }
        this.dispatchStateUpdatedEvent("hide");
    }
    isVisible() {
        return this.visible;
    }
    isSpanHeaderHeight() {
        const colDef = this.getColDef();
        return !colDef.suppressSpanHeaderHeight && !colDef.autoHeaderHeight;
    }
    getColumnGroupPaddingInfo() {
        let parent = this.getParent();
        if (!parent || !parent.isPadding()) return {
            numberOfParents: 0,
            isSpanningTotal: false
        };
        const numberOfParents = parent.getPaddingLevel() + 1;
        let isSpanningTotal = true;
        while(parent){
            if (!parent.isPadding()) {
                isSpanningTotal = false;
                break;
            }
            parent = parent.getParent();
        }
        return {
            numberOfParents,
            isSpanningTotal
        };
    }
    /** Returns the column definition for this column.
   * The column definition will be the result of merging the application provided column definition with any provided defaults
   * (e.g. `defaultColDef` grid option, or column types.
   *
   * Equivalent: `getDefinition` */ getColDef() {
        return this.colDef;
    }
    getColumnGroupShow() {
        return this.colDef.columnGroupShow;
    }
    /**
   * Returns the unique ID for the column.
   *
   * Equivalent: `getId`, `getUniqueId` */ getColId() {
        return this.colId;
    }
    /**
   * Returns the unique ID for the column.
   *
   * Equivalent: `getColId`, `getUniqueId` */ getId() {
        return this.colId;
    }
    /**
   * Returns the unique ID for the column.
   *
   * Equivalent: `getColId`, `getId` */ getUniqueId() {
        return this.colId;
    }
    getDefinition() {
        return this.colDef;
    }
    /** Returns the current width of the column. If the column is resized, the actual width is the new size. */ getActualWidth() {
        return this.actualWidth;
    }
    getAutoHeaderHeight() {
        return this.autoHeaderHeight;
    }
    /** Returns true if the header height has changed */ setAutoHeaderHeight(height) {
        const changed = height !== this.autoHeaderHeight;
        this.autoHeaderHeight = height;
        return changed;
    }
    createBaseColDefParams(rowNode) {
        const params = this.gos.addGridCommonParams({
            node: rowNode,
            data: rowNode.data,
            colDef: this.colDef,
            column: this
        });
        return params;
    }
    getColSpan(rowNode) {
        if (missing(this.colDef.colSpan)) return 1;
        const params = this.createBaseColDefParams(rowNode);
        const colSpan = this.colDef.colSpan(params);
        return Math.max(colSpan, 1);
    }
    getRowSpan(rowNode) {
        if (missing(this.colDef.rowSpan)) return 1;
        const params = this.createBaseColDefParams(rowNode);
        const rowSpan = this.colDef.rowSpan(params);
        return Math.max(rowSpan, 1);
    }
    setActualWidth(actualWidth, source, silent = false) {
        if (this.minWidth != null) actualWidth = Math.max(actualWidth, this.minWidth);
        if (this.maxWidth != null) actualWidth = Math.min(actualWidth, this.maxWidth);
        if (this.actualWidth !== actualWidth) {
            this.actualWidth = actualWidth;
            if (this.flex && source !== "flex" && source !== "gridInitializing") this.flex = null;
            if (!silent) this.fireColumnWidthChangedEvent(source);
        }
        this.dispatchStateUpdatedEvent("width");
    }
    fireColumnWidthChangedEvent(source) {
        this.eventService.dispatchEvent(this.createColumnEvent("widthChanged", source));
    }
    isGreaterThanMax(width) {
        if (this.maxWidth != null) return width > this.maxWidth;
        return false;
    }
    getMinWidth() {
        return this.minWidth;
    }
    getMaxWidth() {
        return this.maxWidth;
    }
    getFlex() {
        return this.flex || 0;
    }
    // this method should only be used by the columnModel to
    // change flex when required by the applyColumnState method.
    setFlex(flex) {
        if (this.flex !== flex) this.flex = flex;
        this.dispatchStateUpdatedEvent("flex");
    }
    setMinimum(source) {
        if (exists(this.minWidth)) this.setActualWidth(this.minWidth, source);
    }
    setRowGroupActive(rowGroup, source) {
        if (this.rowGroupActive !== rowGroup) {
            this.rowGroupActive = rowGroup;
            this.eventService.dispatchEvent(this.createColumnEvent("columnRowGroupChanged", source));
        }
        this.dispatchStateUpdatedEvent("rowGroup");
    }
    /** Returns `true` if row group is currently active for this column. */ isRowGroupActive() {
        return this.rowGroupActive;
    }
    setPivotActive(pivot, source) {
        if (this.pivotActive !== pivot) {
            this.pivotActive = pivot;
            this.eventService.dispatchEvent(this.createColumnEvent("columnPivotChanged", source));
        }
        this.dispatchStateUpdatedEvent("pivot");
    }
    /** Returns `true` if pivot is currently active for this column. */ isPivotActive() {
        return this.pivotActive;
    }
    isAnyFunctionActive() {
        return this.isPivotActive() || this.isRowGroupActive() || this.isValueActive();
    }
    isAnyFunctionAllowed() {
        return this.isAllowPivot() || this.isAllowRowGroup() || this.isAllowValue();
    }
    setValueActive(value, source) {
        if (this.aggregationActive !== value) {
            this.aggregationActive = value;
            this.eventService.dispatchEvent(this.createColumnEvent("columnValueChanged", source));
        }
    }
    /** Returns `true` if value (aggregation) is currently active for this column. */ isValueActive() {
        return this.aggregationActive;
    }
    isAllowPivot() {
        return this.colDef.enablePivot === true;
    }
    isAllowValue() {
        return this.colDef.enableValue === true;
    }
    isAllowRowGroup() {
        return this.colDef.enableRowGroup === true;
    }
    /**
   * @deprecated v31.1 Use `getColDef().menuTabs ?? defaultValues` instead.
   */ getMenuTabs(defaultValues) {
        warnOnce(`As of v31.1, 'getMenuTabs' is deprecated. Use 'getColDef().menuTabs ?? defaultValues' instead.`);
        let menuTabs = this.getColDef().menuTabs;
        if (menuTabs == null) menuTabs = defaultValues;
        return menuTabs;
    }
    dispatchStateUpdatedEvent(key) {
        this.eventService.dispatchEvent({
            type: _Column.EVENT_STATE_UPDATED,
            key
        });
    }
};
// + renderedHeaderCell - for making header cell transparent when moving
_Column.EVENT_MOVING_CHANGED = "movingChanged";
// + renderedCell - changing left position
_Column.EVENT_LEFT_CHANGED = "leftChanged";
// + renderedCell - changing width
_Column.EVENT_WIDTH_CHANGED = "widthChanged";
// + renderedCell - for changing pinned classes
_Column.EVENT_LAST_LEFT_PINNED_CHANGED = "lastLeftPinnedChanged";
_Column.EVENT_FIRST_RIGHT_PINNED_CHANGED = "firstRightPinnedChanged";
// + renderedColumn - for changing visibility icon
_Column.EVENT_VISIBLE_CHANGED = "visibleChanged";
// + every time the filter changes, used in the floating filters
_Column.EVENT_FILTER_CHANGED = "filterChanged";
// + renderedHeaderCell - marks the header with filter icon
_Column.EVENT_FILTER_ACTIVE_CHANGED = "filterActiveChanged";
// + renderedHeaderCell - marks the header with sort icon
_Column.EVENT_SORT_CHANGED = "sortChanged";
// + renderedHeaderCell - marks the header with sort icon
_Column.EVENT_COL_DEF_CHANGED = "colDefChanged";
_Column.EVENT_MENU_VISIBLE_CHANGED = "menuVisibleChanged";
// + toolpanel, for gui updates
_Column.EVENT_ROW_GROUP_CHANGED = "columnRowGroupChanged";
// + toolpanel, for gui updates
_Column.EVENT_PIVOT_CHANGED = "columnPivotChanged";
// + toolpanel, for gui updates
_Column.EVENT_VALUE_CHANGED = "columnValueChanged";
// + dataTypeService - when waiting to infer cell data types
_Column.EVENT_STATE_UPDATED = "columnStateUpdated";
__decorateClass([
    Autowired("gridOptionsService")
], _Column.prototype, "gos", 2);
__decorateClass([
    Autowired("environment")
], _Column.prototype, "environment", 2);
__decorateClass([
    Autowired("columnHoverService")
], _Column.prototype, "columnHoverService", 2);
__decorateClass([
    Autowired("frameworkOverrides")
], _Column.prototype, "frameworkOverrides", 2);
__decorateClass([
    PostConstruct
], _Column.prototype, "initialise", 1);
var Column = _Column;
// community-modules/core/src/entities/providedColumnGroup.ts
var _ProvidedColumnGroup = class _ProvidedColumnGroup {
    constructor(colGroupDef, groupId, padding, level){
        this.localEventService = new EventService();
        this.expandable = false;
        // used by React (and possibly other frameworks) as key for rendering. also used to
        // identify old vs new columns for destroying cols when no longer used.
        this.instanceId = getNextColInstanceId();
        this.expandableListenerRemoveCallback = null;
        this.colGroupDef = colGroupDef;
        this.groupId = groupId;
        this.expanded = !!colGroupDef && !!colGroupDef.openByDefault;
        this.padding = padding;
        this.level = level;
    }
    destroy() {
        if (this.expandableListenerRemoveCallback) this.reset(null, void 0);
    }
    reset(colGroupDef, level) {
        this.colGroupDef = colGroupDef;
        this.level = level;
        this.originalParent = null;
        if (this.expandableListenerRemoveCallback) this.expandableListenerRemoveCallback();
        this.children = void 0;
        this.expandable = void 0;
    }
    getInstanceId() {
        return this.instanceId;
    }
    setOriginalParent(originalParent) {
        this.originalParent = originalParent;
    }
    getOriginalParent() {
        return this.originalParent;
    }
    getLevel() {
        return this.level;
    }
    isVisible() {
        if (this.children) return this.children.some((child)=>child.isVisible());
        return false;
    }
    isPadding() {
        return this.padding;
    }
    setExpanded(expanded) {
        this.expanded = expanded === void 0 ? false : expanded;
        const event = {
            type: _ProvidedColumnGroup.EVENT_EXPANDED_CHANGED
        };
        this.localEventService.dispatchEvent(event);
    }
    isExpandable() {
        return this.expandable;
    }
    isExpanded() {
        return this.expanded;
    }
    getGroupId() {
        return this.groupId;
    }
    getId() {
        return this.getGroupId();
    }
    setChildren(children) {
        this.children = children;
    }
    getChildren() {
        return this.children;
    }
    getColGroupDef() {
        return this.colGroupDef;
    }
    getLeafColumns() {
        const result = [];
        this.addLeafColumns(result);
        return result;
    }
    addLeafColumns(leafColumns) {
        if (!this.children) return;
        this.children.forEach((child)=>{
            if (child instanceof Column) leafColumns.push(child);
            else if (child instanceof _ProvidedColumnGroup) child.addLeafColumns(leafColumns);
        });
    }
    getColumnGroupShow() {
        const colGroupDef = this.colGroupDef;
        if (!colGroupDef) return;
        return colGroupDef.columnGroupShow;
    }
    // need to check that this group has at least one col showing when both expanded and contracted.
    // if not, then we don't allow expanding and contracting on this group
    setupExpandable() {
        this.setExpandable();
        if (this.expandableListenerRemoveCallback) this.expandableListenerRemoveCallback();
        const listener = this.onColumnVisibilityChanged.bind(this);
        this.getLeafColumns().forEach((col)=>col.addEventListener("visibleChanged", listener));
        this.expandableListenerRemoveCallback = ()=>{
            this.getLeafColumns().forEach((col)=>col.removeEventListener("visibleChanged", listener));
            this.expandableListenerRemoveCallback = null;
        };
    }
    setExpandable() {
        if (this.isPadding()) return;
        let atLeastOneShowingWhenOpen = false;
        let atLeastOneShowingWhenClosed = false;
        let atLeastOneChangeable = false;
        const children = this.findChildrenRemovingPadding();
        for(let i = 0, j = children.length; i < j; i++){
            const abstractColumn = children[i];
            if (!abstractColumn.isVisible()) continue;
            const headerGroupShow = abstractColumn.getColumnGroupShow();
            if (headerGroupShow === "open") {
                atLeastOneShowingWhenOpen = true;
                atLeastOneChangeable = true;
            } else if (headerGroupShow === "closed") {
                atLeastOneShowingWhenClosed = true;
                atLeastOneChangeable = true;
            } else {
                atLeastOneShowingWhenOpen = true;
                atLeastOneShowingWhenClosed = true;
            }
        }
        const expandable = atLeastOneShowingWhenOpen && atLeastOneShowingWhenClosed && atLeastOneChangeable;
        if (this.expandable !== expandable) {
            this.expandable = expandable;
            const event = {
                type: _ProvidedColumnGroup.EVENT_EXPANDABLE_CHANGED
            };
            this.localEventService.dispatchEvent(event);
        }
    }
    findChildrenRemovingPadding() {
        const res = [];
        const process = (items)=>{
            items.forEach((item)=>{
                const skipBecausePadding = item instanceof _ProvidedColumnGroup && item.isPadding();
                if (skipBecausePadding) process(item.children);
                else res.push(item);
            });
        };
        process(this.children);
        return res;
    }
    onColumnVisibilityChanged() {
        this.setExpandable();
    }
    addEventListener(eventType, listener) {
        this.localEventService.addEventListener(eventType, listener);
    }
    removeEventListener(eventType, listener) {
        this.localEventService.removeEventListener(eventType, listener);
    }
};
_ProvidedColumnGroup.EVENT_EXPANDED_CHANGED = "expandedChanged";
_ProvidedColumnGroup.EVENT_EXPANDABLE_CHANGED = "expandableChanged";
__decorateClass([
    PreDestroy
], _ProvidedColumnGroup.prototype, "destroy", 1);
var ProvidedColumnGroup = _ProvidedColumnGroup;
// community-modules/core/src/entities/defaultColumnTypes.ts
var DefaultColumnTypes = {
    numericColumn: {
        headerClass: "ag-right-aligned-header",
        cellClass: "ag-right-aligned-cell"
    },
    rightAligned: {
        headerClass: "ag-right-aligned-header",
        cellClass: "ag-right-aligned-cell"
    }
};
// community-modules/core/src/utils/event.ts
var event_exports = {};
__export(event_exports, {
    addSafePassiveEventListener: ()=>addSafePassiveEventListener,
    createEventPath: ()=>createEventPath,
    getCtrlForEventTarget: ()=>getCtrlForEventTarget,
    getEventPath: ()=>getEventPath,
    isElementInEventPath: ()=>isElementInEventPath,
    isEventSupported: ()=>isEventSupported,
    isStopPropagationForAgGrid: ()=>isStopPropagationForAgGrid,
    stopPropagationForAgGrid: ()=>stopPropagationForAgGrid
});
// community-modules/core/src/utils/array.ts
var array_exports = {};
__export(array_exports, {
    areEqual: ()=>areEqual,
    existsAndNotEmpty: ()=>existsAndNotEmpty,
    flatten: ()=>flatten,
    forEachReverse: ()=>forEachReverse,
    includes: ()=>includes,
    insertArrayIntoArray: ()=>insertArrayIntoArray,
    insertIntoArray: ()=>insertIntoArray,
    last: ()=>last,
    moveInArray: ()=>moveInArray,
    pushAll: ()=>pushAll,
    removeAllFromArray: ()=>removeAllFromArray,
    removeAllFromUnorderedArray: ()=>removeAllFromUnorderedArray,
    removeFromArray: ()=>removeFromArray,
    removeFromUnorderedArray: ()=>removeFromUnorderedArray,
    removeRepeatsFromArray: ()=>removeRepeatsFromArray,
    shallowCompare: ()=>shallowCompare,
    sortNumerically: ()=>sortNumerically,
    toStrings: ()=>toStrings
});
function existsAndNotEmpty(value) {
    return value != null && value.length > 0;
}
function last(arr) {
    if (!arr || !arr.length) return;
    return arr[arr.length - 1];
}
function areEqual(a, b, comparator) {
    if (a == null && b == null) return true;
    return a != null && b != null && a.length === b.length && a.every((value, index)=>comparator ? comparator(value, b[index]) : b[index] === value);
}
function shallowCompare(arr1, arr2) {
    return areEqual(arr1, arr2);
}
function sortNumerically(array) {
    return array.sort((a, b)=>a - b);
}
function removeRepeatsFromArray(array, object) {
    if (!array) return;
    for(let index = array.length - 2; index >= 0; index--){
        const thisOneMatches = array[index] === object;
        const nextOneMatches = array[index + 1] === object;
        if (thisOneMatches && nextOneMatches) array.splice(index + 1, 1);
    }
}
function removeFromUnorderedArray(array, object) {
    const index = array.indexOf(object);
    if (index >= 0) {
        array[index] = array[array.length - 1];
        array.pop();
    }
}
function removeFromArray(array, object) {
    const index = array.indexOf(object);
    if (index >= 0) array.splice(index, 1);
}
function removeAllFromUnorderedArray(array, toRemove) {
    for(let i = 0; i < toRemove.length; i++)removeFromUnorderedArray(array, toRemove[i]);
}
function removeAllFromArray(array, toRemove) {
    for(let i = 0; i < toRemove.length; i++)removeFromArray(array, toRemove[i]);
}
function insertIntoArray(array, object, toIndex) {
    array.splice(toIndex, 0, object);
}
function insertArrayIntoArray(dest, src, toIndex) {
    if (dest == null || src == null) return;
    for(let i = src.length - 1; i >= 0; i--){
        const item = src[i];
        insertIntoArray(dest, item, toIndex);
    }
}
function moveInArray(array, objectsToMove, toIndex) {
    removeAllFromArray(array, objectsToMove);
    objectsToMove.slice().reverse().forEach((obj)=>insertIntoArray(array, obj, toIndex));
}
function includes(array, value) {
    return array.indexOf(value) > -1;
}
function flatten(arrayOfArrays) {
    return [].concat.apply([], arrayOfArrays);
}
function pushAll(target, source) {
    if (source == null || target == null) return;
    source.forEach((value)=>target.push(value));
}
function toStrings(array) {
    return array.map(toStringOrNull);
}
function forEachReverse(list, action) {
    if (list == null) return;
    for(let i = list.length - 1; i >= 0; i--)action(list[i], i);
}
// community-modules/core/src/utils/event.ts
var AG_GRID_STOP_PROPAGATION = "__ag_Grid_Stop_Propagation";
var PASSIVE_EVENTS = [
    "touchstart",
    "touchend",
    "touchmove",
    "touchcancel",
    "scroll"
];
var supports = {};
function stopPropagationForAgGrid(event) {
    event[AG_GRID_STOP_PROPAGATION] = true;
}
function isStopPropagationForAgGrid(event) {
    return event[AG_GRID_STOP_PROPAGATION] === true;
}
var isEventSupported = /* @__PURE__ */ (()=>{
    const tags = {
        select: "input",
        change: "input",
        submit: "form",
        reset: "form",
        error: "img",
        load: "img",
        abort: "img"
    };
    const eventChecker = (eventName)=>{
        if (typeof supports[eventName] === "boolean") return supports[eventName];
        const el = document.createElement(tags[eventName] || "div");
        eventName = "on" + eventName;
        return supports[eventName] = eventName in el;
    };
    return eventChecker;
})();
function getCtrlForEventTarget(gos, eventTarget, type) {
    let sourceElement = eventTarget;
    while(sourceElement){
        const renderedComp = gos.getDomData(sourceElement, type);
        if (renderedComp) return renderedComp;
        sourceElement = sourceElement.parentElement;
    }
    return null;
}
function isElementInEventPath(element, event) {
    if (!event || !element) return false;
    return getEventPath(event).indexOf(element) >= 0;
}
function createEventPath(event) {
    const res = [];
    let pointer = event.target;
    while(pointer){
        res.push(pointer);
        pointer = pointer.parentElement;
    }
    return res;
}
function getEventPath(event) {
    const eventNoType = event;
    if (eventNoType.path) return eventNoType.path;
    if (eventNoType.composedPath) return eventNoType.composedPath();
    return createEventPath(eventNoType);
}
function addSafePassiveEventListener(frameworkOverrides, eElement, event, listener) {
    const isPassive = includes(PASSIVE_EVENTS, event);
    const options = isPassive ? {
        passive: true
    } : void 0;
    if (frameworkOverrides && frameworkOverrides.addEventListener) frameworkOverrides.addEventListener(eElement, event, listener, options);
}
// community-modules/core/src/context/beanStub.ts
var _BeanStub = class _BeanStub {
    constructor(){
        this.destroyFunctions = [];
        this.destroyed = false;
        // for vue 3 - prevents Vue from trying to make this (and obviously any sub classes) from being reactive
        // prevents vue from creating proxies for created objects and prevents identity related issues
        this.__v_skip = true;
        // this was a test constructor niall built, when active, it prints after 5 seconds all beans/components that are
        // not destroyed. to use, create a new grid, then api.destroy() before 5 seconds. then anything that gets printed
        // points to a bean or component that was not properly disposed of.
        // constructor() {
        //     setTimeout(()=> {
        //         if (this.isAlive()) {
        //             let prototype: any = Object.getPrototypeOf(this);
        //             const constructor: any = prototype.constructor;
        //             const constructorString = constructor.toString();
        //             const beanName = constructorString.substring(9, constructorString.indexOf("("));
        //             console.log('is alive ' + beanName);
        //         }
        //     }, 5000);
        // }
        // Enable multiple grid properties to be updated together by the user but only trigger shared logic once.
        // Closely related to logic in ComponentUtil.ts
        this.lastChangeSetIdLookup = {};
        this.propertyListenerId = 0;
        this.isAlive = ()=>!this.destroyed;
    }
    // CellComp and GridComp and override this because they get the FrameworkOverrides from the Beans bean
    getFrameworkOverrides() {
        return this.frameworkOverrides;
    }
    getContext() {
        return this.context;
    }
    destroy() {
        for(let i = 0; i < this.destroyFunctions.length; i++)this.destroyFunctions[i]();
        this.destroyFunctions.length = 0;
        this.destroyed = true;
        this.dispatchEvent({
            type: _BeanStub.EVENT_DESTROYED
        });
    }
    addEventListener(eventType, listener) {
        if (!this.localEventService) this.localEventService = new EventService();
        this.localEventService.addEventListener(eventType, listener);
    }
    removeEventListener(eventType, listener) {
        if (this.localEventService) this.localEventService.removeEventListener(eventType, listener);
    }
    dispatchEvent(event) {
        if (this.localEventService) this.localEventService.dispatchEvent(event);
    }
    addManagedListener(object, event, listener) {
        if (this.destroyed) return;
        if (object instanceof HTMLElement) addSafePassiveEventListener(this.getFrameworkOverrides(), object, event, listener);
        else object.addEventListener(event, listener);
        const destroyFunc = ()=>{
            object.removeEventListener(event, listener);
            return null;
        };
        this.destroyFunctions.push(destroyFunc);
        return ()=>{
            destroyFunc();
            this.destroyFunctions = this.destroyFunctions.filter((fn)=>fn !== destroyFunc);
            return null;
        };
    }
    setupGridOptionListener(event, listener) {
        this.gos.addEventListener(event, listener);
        const destroyFunc = ()=>{
            this.gos.removeEventListener(event, listener);
            return null;
        };
        this.destroyFunctions.push(destroyFunc);
        return ()=>{
            destroyFunc();
            this.destroyFunctions = this.destroyFunctions.filter((fn)=>fn !== destroyFunc);
            return null;
        };
    }
    /**
   * Setup a managed property listener for the given GridOption property.
   * @param event GridOption property to listen to changes for.
   * @param listener Listener to run when property value changes
   */ addManagedPropertyListener(event, listener) {
        if (this.destroyed) return ()=>null;
        return this.setupGridOptionListener(event, listener);
    }
    /**
   * Setup managed property listeners for the given set of GridOption properties.
   * The listener will be run if any of the property changes but will only run once if
   * multiple of the properties change within the same framework lifecycle event.
   * Works on the basis that GridOptionsService updates all properties *before* any property change events are fired.
   * @param events Array of GridOption properties to listen for changes too.
   * @param listener Shared listener to run if any of the properties change
   */ addManagedPropertyListeners(events, listener) {
        if (this.destroyed) return;
        const eventsKey = events.join("-") + this.propertyListenerId++;
        const wrappedListener = (event)=>{
            if (event.changeSet) {
                if (event.changeSet && event.changeSet.id === this.lastChangeSetIdLookup[eventsKey]) return;
                this.lastChangeSetIdLookup[eventsKey] = event.changeSet.id;
            }
            const propertiesChangeEvent = {
                type: "gridPropertyChanged",
                changeSet: event.changeSet,
                source: event.source
            };
            listener(propertiesChangeEvent);
        };
        events.forEach((event)=>this.setupGridOptionListener(event, wrappedListener));
    }
    addDestroyFunc(func) {
        if (this.isAlive()) this.destroyFunctions.push(func);
        else func();
    }
    createManagedBean(bean, context) {
        const res = this.createBean(bean, context);
        this.addDestroyFunc(this.destroyBean.bind(this, bean, context));
        return res;
    }
    createBean(bean, context, afterPreCreateCallback) {
        return (context || this.getContext()).createBean(bean, afterPreCreateCallback);
    }
    destroyBean(bean, context) {
        return (context || this.getContext()).destroyBean(bean);
    }
    destroyBeans(beans, context) {
        if (beans) for(let i = 0; i < beans.length; i++)this.destroyBean(beans[i], context);
        return [];
    }
};
_BeanStub.EVENT_DESTROYED = "destroyed";
__decorateClass([
    Autowired("frameworkOverrides")
], _BeanStub.prototype, "frameworkOverrides", 2);
__decorateClass([
    Autowired("context")
], _BeanStub.prototype, "context", 2);
__decorateClass([
    Autowired("eventService")
], _BeanStub.prototype, "eventService", 2);
__decorateClass([
    Autowired("gridOptionsService")
], _BeanStub.prototype, "gos", 2);
__decorateClass([
    Autowired("localeService")
], _BeanStub.prototype, "localeService", 2);
__decorateClass([
    Autowired("environment")
], _BeanStub.prototype, "environment", 2);
__decorateClass([
    PreDestroy
], _BeanStub.prototype, "destroy", 1);
var BeanStub = _BeanStub;
// community-modules/core/src/columns/columnFactory.ts
var ColumnFactory = class extends BeanStub {
    setBeans(loggerFactory) {
        this.logger = loggerFactory.create("ColumnFactory");
    }
    createColumnTree(defs, primaryColumns, existingTree, source) {
        const columnKeyCreator = new ColumnKeyCreator();
        const { existingCols, existingGroups, existingColKeys } = this.extractExistingTreeData(existingTree);
        columnKeyCreator.addExistingKeys(existingColKeys);
        const unbalancedTree = this.recursivelyCreateColumns(defs, 0, primaryColumns, existingCols, columnKeyCreator, existingGroups, source);
        const treeDept = this.findMaxDept(unbalancedTree, 0);
        this.logger.log("Number of levels for grouped columns is " + treeDept);
        const columnTree = this.balanceColumnTree(unbalancedTree, 0, treeDept, columnKeyCreator);
        const deptFirstCallback = (child, parent)=>{
            if (child instanceof ProvidedColumnGroup) child.setupExpandable();
            child.setOriginalParent(parent);
        };
        depthFirstOriginalTreeSearch(null, columnTree, deptFirstCallback);
        return {
            columnTree,
            treeDept
        };
    }
    extractExistingTreeData(existingTree) {
        const existingCols = [];
        const existingGroups = [];
        const existingColKeys = [];
        if (existingTree) depthFirstOriginalTreeSearch(null, existingTree, (item)=>{
            if (item instanceof ProvidedColumnGroup) {
                const group = item;
                existingGroups.push(group);
            } else {
                const col = item;
                existingColKeys.push(col.getId());
                existingCols.push(col);
            }
        });
        return {
            existingCols,
            existingGroups,
            existingColKeys
        };
    }
    createForAutoGroups(autoGroupCols, gridBalancedTree) {
        return autoGroupCols.map((col)=>this.createAutoGroupTreeItem(gridBalancedTree, col));
    }
    createAutoGroupTreeItem(balancedColumnTree, column) {
        const dept = this.findDepth(balancedColumnTree);
        let nextChild = column;
        for(let i = dept - 1; i >= 0; i--){
            const autoGroup = new ProvidedColumnGroup(null, `FAKE_PATH_${column.getId()}}_${i}`, true, i);
            this.createBean(autoGroup);
            autoGroup.setChildren([
                nextChild
            ]);
            nextChild.setOriginalParent(autoGroup);
            nextChild = autoGroup;
        }
        if (dept === 0) column.setOriginalParent(null);
        return nextChild;
    }
    findDepth(balancedColumnTree) {
        let dept = 0;
        let pointer = balancedColumnTree;
        while(pointer && pointer[0] && pointer[0] instanceof ProvidedColumnGroup){
            dept++;
            pointer = pointer[0].getChildren();
        }
        return dept;
    }
    balanceColumnTree(unbalancedTree, currentDept, columnDept, columnKeyCreator) {
        const result = [];
        for(let i = 0; i < unbalancedTree.length; i++){
            const child = unbalancedTree[i];
            if (child instanceof ProvidedColumnGroup) {
                const originalGroup = child;
                const newChildren = this.balanceColumnTree(originalGroup.getChildren(), currentDept + 1, columnDept, columnKeyCreator);
                originalGroup.setChildren(newChildren);
                result.push(originalGroup);
            } else {
                let firstPaddedGroup;
                let currentPaddedGroup;
                for(let j = columnDept - 1; j >= currentDept; j--){
                    const newColId = columnKeyCreator.getUniqueKey(null, null);
                    const colGroupDefMerged = this.createMergedColGroupDef(null);
                    const paddedGroup = new ProvidedColumnGroup(colGroupDefMerged, newColId, true, currentDept);
                    this.createBean(paddedGroup);
                    if (currentPaddedGroup) currentPaddedGroup.setChildren([
                        paddedGroup
                    ]);
                    currentPaddedGroup = paddedGroup;
                    if (!firstPaddedGroup) firstPaddedGroup = currentPaddedGroup;
                }
                if (firstPaddedGroup && currentPaddedGroup) {
                    result.push(firstPaddedGroup);
                    const hasGroups = unbalancedTree.some((leaf)=>leaf instanceof ProvidedColumnGroup);
                    if (hasGroups) {
                        currentPaddedGroup.setChildren([
                            child
                        ]);
                        continue;
                    } else {
                        currentPaddedGroup.setChildren(unbalancedTree);
                        break;
                    }
                }
                result.push(child);
            }
        }
        return result;
    }
    findMaxDept(treeChildren, dept) {
        let maxDeptThisLevel = dept;
        for(let i = 0; i < treeChildren.length; i++){
            const abstractColumn = treeChildren[i];
            if (abstractColumn instanceof ProvidedColumnGroup) {
                const originalGroup = abstractColumn;
                const newDept = this.findMaxDept(originalGroup.getChildren(), dept + 1);
                if (maxDeptThisLevel < newDept) maxDeptThisLevel = newDept;
            }
        }
        return maxDeptThisLevel;
    }
    recursivelyCreateColumns(defs, level, primaryColumns, existingColsCopy, columnKeyCreator, existingGroups, source) {
        if (!defs) return [];
        const result = new Array(defs.length);
        for(let i = 0; i < result.length; i++){
            const def = defs[i];
            if (this.isColumnGroup(def)) result[i] = this.createColumnGroup(primaryColumns, def, level, existingColsCopy, columnKeyCreator, existingGroups, source);
            else result[i] = this.createColumn(primaryColumns, def, existingColsCopy, columnKeyCreator, source);
        }
        return result;
    }
    createColumnGroup(primaryColumns, colGroupDef, level, existingColumns, columnKeyCreator, existingGroups, source) {
        const colGroupDefMerged = this.createMergedColGroupDef(colGroupDef);
        const groupId = columnKeyCreator.getUniqueKey(colGroupDefMerged.groupId || null, null);
        const providedGroup = new ProvidedColumnGroup(colGroupDefMerged, groupId, false, level);
        this.createBean(providedGroup);
        const existingGroupAndIndex = this.findExistingGroup(colGroupDef, existingGroups);
        if (existingGroupAndIndex) existingGroups.splice(existingGroupAndIndex.idx, 1);
        let existingGroup = existingGroupAndIndex == null ? void 0 : existingGroupAndIndex.group;
        if (existingGroup) providedGroup.setExpanded(existingGroup.isExpanded());
        const children = this.recursivelyCreateColumns(colGroupDefMerged.children, level + 1, primaryColumns, existingColumns, columnKeyCreator, existingGroups, source);
        providedGroup.setChildren(children);
        return providedGroup;
    }
    createMergedColGroupDef(colGroupDef) {
        const colGroupDefMerged = {};
        Object.assign(colGroupDefMerged, this.gos.get("defaultColGroupDef"));
        Object.assign(colGroupDefMerged, colGroupDef);
        return colGroupDefMerged;
    }
    createColumn(primaryColumns, colDef, existingColsCopy, columnKeyCreator, source) {
        const existingColAndIndex = this.findExistingColumn(colDef, existingColsCopy);
        if (existingColAndIndex) existingColsCopy == null || existingColsCopy.splice(existingColAndIndex.idx, 1);
        let column = existingColAndIndex == null ? void 0 : existingColAndIndex.column;
        if (!column) {
            const colId = columnKeyCreator.getUniqueKey(colDef.colId, colDef.field);
            const colDefMerged = this.addColumnDefaultAndTypes(colDef, colId);
            column = new Column(colDefMerged, colDef, colId, primaryColumns);
            this.context.createBean(column);
        } else {
            const colDefMerged = this.addColumnDefaultAndTypes(colDef, column.getColId());
            column.setColDef(colDefMerged, colDef, source);
            this.applyColumnState(column, colDefMerged, source);
        }
        this.dataTypeService.addColumnListeners(column);
        return column;
    }
    applyColumnState(column, colDef, source) {
        const flex = attrToNumber(colDef.flex);
        if (flex !== void 0) column.setFlex(flex);
        const noFlexThisCol = column.getFlex() <= 0;
        if (noFlexThisCol) {
            const width = attrToNumber(colDef.width);
            if (width != null) column.setActualWidth(width, source);
            else {
                const widthBeforeUpdate = column.getActualWidth();
                column.setActualWidth(widthBeforeUpdate, source);
            }
        }
        if (colDef.sort !== void 0) {
            if (colDef.sort == "asc" || colDef.sort == "desc") column.setSort(colDef.sort, source);
            else column.setSort(void 0, source);
        }
        const sortIndex = attrToNumber(colDef.sortIndex);
        if (sortIndex !== void 0) column.setSortIndex(sortIndex);
        const hide = attrToBoolean(colDef.hide);
        if (hide !== void 0) column.setVisible(!hide, source);
        if (colDef.pinned !== void 0) column.setPinned(colDef.pinned);
    }
    findExistingColumn(newColDef, existingColsCopy) {
        if (!existingColsCopy) return void 0;
        for(let i = 0; i < existingColsCopy.length; i++){
            const def = existingColsCopy[i].getUserProvidedColDef();
            if (!def) continue;
            const newHasId = newColDef.colId != null;
            if (newHasId) {
                if (existingColsCopy[i].getId() === newColDef.colId) return {
                    idx: i,
                    column: existingColsCopy[i]
                };
                continue;
            }
            const newHasField = newColDef.field != null;
            if (newHasField) {
                if (def.field === newColDef.field) return {
                    idx: i,
                    column: existingColsCopy[i]
                };
                continue;
            }
            if (def === newColDef) return {
                idx: i,
                column: existingColsCopy[i]
            };
        }
        return void 0;
    }
    findExistingGroup(newGroupDef, existingGroups) {
        const newHasId = newGroupDef.groupId != null;
        if (!newHasId) return void 0;
        for(let i = 0; i < existingGroups.length; i++){
            const existingGroup = existingGroups[i];
            const existingDef = existingGroup.getColGroupDef();
            if (!existingDef) continue;
            if (existingGroup.getId() === newGroupDef.groupId) return {
                idx: i,
                group: existingGroup
            };
        }
        return void 0;
    }
    addColumnDefaultAndTypes(colDef, colId) {
        const res = {};
        const defaultColDef = this.gos.get("defaultColDef");
        mergeDeep(res, defaultColDef, false, true);
        const columnType = this.dataTypeService.updateColDefAndGetColumnType(res, colDef, colId);
        if (columnType) this.assignColumnTypes(columnType, res);
        mergeDeep(res, colDef, false, true);
        const autoGroupColDef = this.gos.get("autoGroupColumnDef");
        const isSortingCoupled = this.gos.isColumnsSortingCoupledToGroup();
        if (colDef.rowGroup && autoGroupColDef && isSortingCoupled) mergeDeep(res, {
            sort: autoGroupColDef.sort,
            initialSort: autoGroupColDef.initialSort
        }, false, true);
        this.dataTypeService.validateColDef(res);
        return res;
    }
    assignColumnTypes(typeKeys, colDefMerged) {
        if (!typeKeys.length) return;
        const allColumnTypes = Object.assign({}, DefaultColumnTypes);
        const userTypes = this.gos.get("columnTypes") || {};
        iterateObject(userTypes, (key, value)=>{
            if (key in allColumnTypes) console.warn(`AG Grid: the column type '${key}' is a default column type and cannot be overridden.`);
            else {
                const colType = value;
                if (colType.type) warnOnce(`Column type definitions 'columnTypes' with a 'type' attribute are not supported because a column type cannot refer to another column type. Only column definitions 'columnDefs' can use the 'type' attribute to refer to a column type.`);
                allColumnTypes[key] = value;
            }
        });
        typeKeys.forEach((t)=>{
            const typeColDef = allColumnTypes[t.trim()];
            if (typeColDef) mergeDeep(colDefMerged, typeColDef, false, true);
            else console.warn("AG Grid: colDef.type '" + t + "' does not correspond to defined gridOptions.columnTypes");
        });
    }
    // if object has children, we assume it's a group
    isColumnGroup(abstractColDef) {
        return abstractColDef.children !== void 0;
    }
};
__decorateClass([
    Autowired("dataTypeService")
], ColumnFactory.prototype, "dataTypeService", 2);
__decorateClass([
    __decorateParam(0, Qualifier("loggerFactory"))
], ColumnFactory.prototype, "setBeans", 1);
ColumnFactory = __decorateClass([
    Bean("columnFactory")
], ColumnFactory);
function depthFirstOriginalTreeSearch(parent, tree, callback) {
    if (!tree) return;
    for(let i = 0; i < tree.length; i++){
        const child = tree[i];
        if (child instanceof ProvidedColumnGroup) depthFirstOriginalTreeSearch(child, child.getChildren(), callback);
        callback(child, parent);
    }
}
// community-modules/core/src/entities/columnGroup.ts
var _ColumnGroup = class _ColumnGroup {
    constructor(providedColumnGroup, groupId, partId, pinned){
        // depends on the open/closed state of the group, only displaying columns are stored here
        this.displayedChildren = [];
        this.localEventService = new EventService();
        this.groupId = groupId;
        this.partId = partId;
        this.providedColumnGroup = providedColumnGroup;
        this.pinned = pinned;
    }
    // this is static, a it is used outside of this class
    static createUniqueId(groupId, instanceId) {
        return groupId + "_" + instanceId;
    }
    // as the user is adding and removing columns, the groups are recalculated.
    // this reset clears out all children, ready for children to be added again
    reset() {
        this.parent = null;
        this.children = null;
        this.displayedChildren = null;
    }
    getParent() {
        return this.parent;
    }
    setParent(parent) {
        this.parent = parent;
    }
    getUniqueId() {
        return _ColumnGroup.createUniqueId(this.groupId, this.partId);
    }
    isEmptyGroup() {
        return this.displayedChildren.length === 0;
    }
    isMoving() {
        const allLeafColumns = this.getProvidedColumnGroup().getLeafColumns();
        if (!allLeafColumns || allLeafColumns.length === 0) return false;
        return allLeafColumns.every((col)=>col.isMoving());
    }
    checkLeft() {
        this.displayedChildren.forEach((child)=>{
            if (child instanceof _ColumnGroup) child.checkLeft();
        });
        if (this.displayedChildren.length > 0) {
            if (this.gos.get("enableRtl")) {
                const lastChild = last(this.displayedChildren);
                const lastChildLeft = lastChild.getLeft();
                this.setLeft(lastChildLeft);
            } else {
                const firstChildLeft = this.displayedChildren[0].getLeft();
                this.setLeft(firstChildLeft);
            }
        } else this.setLeft(null);
    }
    getLeft() {
        return this.left;
    }
    getOldLeft() {
        return this.oldLeft;
    }
    setLeft(left) {
        this.oldLeft = this.left;
        if (this.left !== left) {
            this.left = left;
            this.localEventService.dispatchEvent(this.createAgEvent(_ColumnGroup.EVENT_LEFT_CHANGED));
        }
    }
    getPinned() {
        return this.pinned;
    }
    createAgEvent(type) {
        return {
            type
        };
    }
    addEventListener(eventType, listener) {
        this.localEventService.addEventListener(eventType, listener);
    }
    removeEventListener(eventType, listener) {
        this.localEventService.removeEventListener(eventType, listener);
    }
    getGroupId() {
        return this.groupId;
    }
    getPartId() {
        return this.partId;
    }
    isChildInThisGroupDeepSearch(wantedChild) {
        let result = false;
        this.children.forEach((foundChild)=>{
            if (wantedChild === foundChild) result = true;
            if (foundChild instanceof _ColumnGroup) {
                if (foundChild.isChildInThisGroupDeepSearch(wantedChild)) result = true;
            }
        });
        return result;
    }
    getActualWidth() {
        let groupActualWidth = 0;
        if (this.displayedChildren) this.displayedChildren.forEach((child)=>{
            groupActualWidth += child.getActualWidth();
        });
        return groupActualWidth;
    }
    isResizable() {
        if (!this.displayedChildren) return false;
        let result = false;
        this.displayedChildren.forEach((child)=>{
            if (child.isResizable()) result = true;
        });
        return result;
    }
    getMinWidth() {
        let result = 0;
        this.displayedChildren.forEach((groupChild)=>{
            result += groupChild.getMinWidth() || 0;
        });
        return result;
    }
    addChild(child) {
        if (!this.children) this.children = [];
        this.children.push(child);
    }
    getDisplayedChildren() {
        return this.displayedChildren;
    }
    getLeafColumns() {
        const result = [];
        this.addLeafColumns(result);
        return result;
    }
    getDisplayedLeafColumns() {
        const result = [];
        this.addDisplayedLeafColumns(result);
        return result;
    }
    getDefinition() {
        return this.providedColumnGroup.getColGroupDef();
    }
    getColGroupDef() {
        return this.providedColumnGroup.getColGroupDef();
    }
    isPadding() {
        return this.providedColumnGroup.isPadding();
    }
    isExpandable() {
        return this.providedColumnGroup.isExpandable();
    }
    isExpanded() {
        return this.providedColumnGroup.isExpanded();
    }
    setExpanded(expanded) {
        this.providedColumnGroup.setExpanded(expanded);
    }
    addDisplayedLeafColumns(leafColumns) {
        this.displayedChildren.forEach((child)=>{
            if (child instanceof Column) leafColumns.push(child);
            else if (child instanceof _ColumnGroup) child.addDisplayedLeafColumns(leafColumns);
        });
    }
    addLeafColumns(leafColumns) {
        this.children.forEach((child)=>{
            if (child instanceof Column) leafColumns.push(child);
            else if (child instanceof _ColumnGroup) child.addLeafColumns(leafColumns);
        });
    }
    getChildren() {
        return this.children;
    }
    getColumnGroupShow() {
        return this.providedColumnGroup.getColumnGroupShow();
    }
    getProvidedColumnGroup() {
        return this.providedColumnGroup;
    }
    getPaddingLevel() {
        const parent = this.getParent();
        if (!this.isPadding() || !parent || !parent.isPadding()) return 0;
        return 1 + parent.getPaddingLevel();
    }
    calculateDisplayedColumns() {
        this.displayedChildren = [];
        let parentWithExpansion = this;
        while(parentWithExpansion != null && parentWithExpansion.isPadding())parentWithExpansion = parentWithExpansion.getParent();
        const isExpandable = parentWithExpansion ? parentWithExpansion.providedColumnGroup.isExpandable() : false;
        if (!isExpandable) {
            this.displayedChildren = this.children;
            this.localEventService.dispatchEvent(this.createAgEvent(_ColumnGroup.EVENT_DISPLAYED_CHILDREN_CHANGED));
            return;
        }
        this.children.forEach((child)=>{
            const emptyGroup = child instanceof _ColumnGroup && (!child.displayedChildren || !child.displayedChildren.length);
            if (emptyGroup) return;
            const headerGroupShow = child.getColumnGroupShow();
            switch(headerGroupShow){
                case "open":
                    if (parentWithExpansion.providedColumnGroup.isExpanded()) this.displayedChildren.push(child);
                    break;
                case "closed":
                    if (!parentWithExpansion.providedColumnGroup.isExpanded()) this.displayedChildren.push(child);
                    break;
                default:
                    this.displayedChildren.push(child);
                    break;
            }
        });
        this.localEventService.dispatchEvent(this.createAgEvent(_ColumnGroup.EVENT_DISPLAYED_CHILDREN_CHANGED));
    }
};
_ColumnGroup.EVENT_LEFT_CHANGED = "leftChanged";
_ColumnGroup.EVENT_DISPLAYED_CHILDREN_CHANGED = "displayedChildrenChanged";
__decorateClass([
    Autowired("gridOptionsService")
], _ColumnGroup.prototype, "gos", 2);
var ColumnGroup = _ColumnGroup;
// community-modules/core/src/eventKeys.ts
var Events = class {
};
/** Everything has changed with the columns. Either complete new set of columns set, or user called applyColumnState() */ /** @deprecated - grid no longer uses this, and setSate() also fires individual events */ Events.EVENT_COLUMN_EVERYTHING_CHANGED = "columnEverythingChanged";
/** User has set in new columns. */ Events.EVENT_NEW_COLUMNS_LOADED = "newColumnsLoaded";
/** The pivot mode flag was changed */ Events.EVENT_COLUMN_PIVOT_MODE_CHANGED = "columnPivotModeChanged";
/** Exceeded the pivot limit when generating columns */ Events.EVENT_PIVOT_MAX_COLUMNS_EXCEEDED = "pivotMaxColumnsExceeded";
/** A row group column was added, removed or order changed. */ Events.EVENT_COLUMN_ROW_GROUP_CHANGED = "columnRowGroupChanged";
/** expandAll / collapseAll was called from the api. */ Events.EVENT_EXPAND_COLLAPSE_ALL = "expandOrCollapseAll";
/** A pivot column was added, removed or order changed. */ Events.EVENT_COLUMN_PIVOT_CHANGED = "columnPivotChanged";
/** The list of grid columns has changed. */ Events.EVENT_GRID_COLUMNS_CHANGED = "gridColumnsChanged";
/** A value column was added, removed or agg function was changed. */ Events.EVENT_COLUMN_VALUE_CHANGED = "columnValueChanged";
/** A column was moved */ Events.EVENT_COLUMN_MOVED = "columnMoved";
/** One or more columns was shown / hidden */ Events.EVENT_COLUMN_VISIBLE = "columnVisible";
/** One or more columns was pinned / unpinned*/ Events.EVENT_COLUMN_PINNED = "columnPinned";
/** A column group was opened / closed */ Events.EVENT_COLUMN_GROUP_OPENED = "columnGroupOpened";
/** One or more columns was resized. If just one, the column in the event is set. */ Events.EVENT_COLUMN_RESIZED = "columnResized";
/** The list of displayed columns has changed, can result from columns open / close, column move, pivot, group, etc */ Events.EVENT_DISPLAYED_COLUMNS_CHANGED = "displayedColumnsChanged";
/** The grid option related to suppressing movable columns has changed */ Events.EVENT_SUPPRESS_COLUMN_MOVE_CHANGED = "suppressMovableColumns";
/** The grid option related to suppressing column group selection has changed */ Events.EVENT_SUPPRESS_MENU_HIDE_CHANGED = "suppressMenuHide";
/** The grid option related to suppressing movable columns has changed */ Events.EVENT_SUPPRESS_FIELD_DOT_NOTATION = "suppressFieldDotNotation";
/** The list of virtual columns has changed, results from viewport changing */ Events.EVENT_VIRTUAL_COLUMNS_CHANGED = "virtualColumnsChanged";
/** Column header mouse over */ Events.EVENT_COLUMN_HEADER_MOUSE_OVER = "columnHeaderMouseOver";
/** Column header mouse leave */ Events.EVENT_COLUMN_HEADER_MOUSE_LEAVE = "columnHeaderMouseLeave";
/** Column header clicked */ Events.EVENT_COLUMN_HEADER_CLICKED = "columnHeaderClicked";
/** Column header context menu event, such as right-click or context menu key press */ Events.EVENT_COLUMN_HEADER_CONTEXT_MENU = "columnHeaderContextMenu";
/** Async Transactions Executed */ Events.EVENT_ASYNC_TRANSACTIONS_FLUSHED = "asyncTransactionsFlushed";
/** A row group was opened / closed */ Events.EVENT_ROW_GROUP_OPENED = "rowGroupOpened";
/** Client-Side Row Model only. The client has updated data for the grid */ Events.EVENT_ROW_DATA_UPDATED = "rowDataUpdated";
/** The client has set new floating data into the grid */ Events.EVENT_PINNED_ROW_DATA_CHANGED = "pinnedRowDataChanged";
/** Range selection has changed */ Events.EVENT_RANGE_SELECTION_CHANGED = "rangeSelectionChanged";
/** Chart was created */ Events.EVENT_CHART_CREATED = "chartCreated";
/** Chart Range selection has changed */ Events.EVENT_CHART_RANGE_SELECTION_CHANGED = "chartRangeSelectionChanged";
/** Chart Options have changed */ Events.EVENT_CHART_OPTIONS_CHANGED = "chartOptionsChanged";
/** Chart was destroyed */ Events.EVENT_CHART_DESTROYED = "chartDestroyed";
/** For when the tool panel is shown / hidden */ Events.EVENT_TOOL_PANEL_VISIBLE_CHANGED = "toolPanelVisibleChanged";
Events.EVENT_TOOL_PANEL_SIZE_CHANGED = "toolPanelSizeChanged";
Events.EVENT_COLUMN_PANEL_ITEM_DRAG_START = "columnPanelItemDragStart";
Events.EVENT_COLUMN_PANEL_ITEM_DRAG_END = "columnPanelItemDragEnd";
/** Model was updated - grid updates the drawn rows when this happens */ Events.EVENT_MODEL_UPDATED = "modelUpdated";
Events.EVENT_CUT_START = "cutStart";
Events.EVENT_CUT_END = "cutEnd";
Events.EVENT_PASTE_START = "pasteStart";
Events.EVENT_PASTE_END = "pasteEnd";
Events.EVENT_FILL_START = "fillStart";
Events.EVENT_FILL_END = "fillEnd";
Events.EVENT_RANGE_DELETE_START = "rangeDeleteStart";
Events.EVENT_RANGE_DELETE_END = "rangeDeleteEnd";
/** Undo operation has started. */ Events.EVENT_UNDO_STARTED = "undoStarted";
/** Undo operation has ended. */ Events.EVENT_UNDO_ENDED = "undoEnded";
/** Redo operation has started. */ Events.EVENT_REDO_STARTED = "redoStarted";
/** Redo operation has ended. */ Events.EVENT_REDO_ENDED = "redoEnded";
Events.EVENT_KEY_SHORTCUT_CHANGED_CELL_START = "keyShortcutChangedCellStart";
Events.EVENT_KEY_SHORTCUT_CHANGED_CELL_END = "keyShortcutChangedCellEnd";
Events.EVENT_CELL_CLICKED = "cellClicked";
Events.EVENT_CELL_DOUBLE_CLICKED = "cellDoubleClicked";
Events.EVENT_CELL_MOUSE_DOWN = "cellMouseDown";
Events.EVENT_CELL_CONTEXT_MENU = "cellContextMenu";
Events.EVENT_CELL_VALUE_CHANGED = "cellValueChanged";
Events.EVENT_CELL_EDIT_REQUEST = "cellEditRequest";
Events.EVENT_ROW_VALUE_CHANGED = "rowValueChanged";
Events.EVENT_CELL_FOCUSED = "cellFocused";
Events.EVENT_CELL_FOCUS_CLEARED = "cellFocusCleared";
Events.EVENT_FULL_WIDTH_ROW_FOCUSED = "fullWidthRowFocused";
Events.EVENT_ROW_SELECTED = "rowSelected";
Events.EVENT_SELECTION_CHANGED = "selectionChanged";
Events.EVENT_TOOLTIP_SHOW = "tooltipShow";
Events.EVENT_TOOLTIP_HIDE = "tooltipHide";
Events.EVENT_CELL_KEY_DOWN = "cellKeyDown";
Events.EVENT_CELL_MOUSE_OVER = "cellMouseOver";
Events.EVENT_CELL_MOUSE_OUT = "cellMouseOut";
/** 2 events for filtering. The grid LISTENS for filterChanged and afterFilterChanged */ Events.EVENT_FILTER_CHANGED = "filterChanged";
/** Filter was change but not applied. Only useful if apply buttons are used in filters. */ Events.EVENT_FILTER_MODIFIED = "filterModified";
Events.EVENT_FILTER_OPENED = "filterOpened";
Events.EVENT_ADVANCED_FILTER_BUILDER_VISIBLE_CHANGED = "advancedFilterBuilderVisibleChanged";
Events.EVENT_SORT_CHANGED = "sortChanged";
/** A row was removed from the dom, for any reason. Use to clean up resources (if any) used by the row. */ Events.EVENT_VIRTUAL_ROW_REMOVED = "virtualRowRemoved";
Events.EVENT_ROW_CLICKED = "rowClicked";
Events.EVENT_ROW_DOUBLE_CLICKED = "rowDoubleClicked";
/** Gets called once after the grid has finished initialising. */ Events.EVENT_GRID_READY = "gridReady";
/** Called once when the grid is about to get destroyed. */ Events.EVENT_GRID_PRE_DESTROYED = "gridPreDestroyed";
/** Width of height of the main grid div has changed. Grid listens for this and does layout of grid if it's
 * changed, so always filling the space it was given. */ Events.EVENT_GRID_SIZE_CHANGED = "gridSizeChanged";
/** The indexes of the rows rendered has changed, eg user has scrolled to a new vertical position. */ Events.EVENT_VIEWPORT_CHANGED = "viewportChanged";
/* The width of the scrollbar has been calculated */ Events.EVENT_SCROLLBAR_WIDTH_CHANGED = "scrollbarWidthChanged";
/** Rows were rendered for the first time (ie on async data load). */ Events.EVENT_FIRST_DATA_RENDERED = "firstDataRendered";
/** A column drag has started, either resizing a column or moving a column. */ Events.EVENT_DRAG_STARTED = "dragStarted";
/** A column drag has stopped */ Events.EVENT_DRAG_STOPPED = "dragStopped";
Events.EVENT_CHECKBOX_CHANGED = "checkboxChanged";
Events.EVENT_ROW_EDITING_STARTED = "rowEditingStarted";
Events.EVENT_ROW_EDITING_STOPPED = "rowEditingStopped";
Events.EVENT_CELL_EDITING_STARTED = "cellEditingStarted";
Events.EVENT_CELL_EDITING_STOPPED = "cellEditingStopped";
/** Main body of grid has scrolled, either horizontally or vertically */ Events.EVENT_BODY_SCROLL = "bodyScroll";
/** Main body of the grid has stopped scrolling, either horizontally or vertically */ Events.EVENT_BODY_SCROLL_END = "bodyScrollEnd";
Events.EVENT_HEIGHT_SCALE_CHANGED = "heightScaleChanged";
/** The displayed page for pagination has changed. For example the data was filtered or sorted,
 * or the user has moved to a different page. */ Events.EVENT_PAGINATION_CHANGED = "paginationChanged";
/** Only used by React, Angular, Web Components and VueJS AG Grid components
 * (not used if doing plain JavaScript). If the grid receives changes due
 * to bound properties, this event fires after the grid has finished processing the change. */ Events.EVENT_COMPONENT_STATE_CHANGED = "componentStateChanged";
/** Only used by the SSRM, called when the grid has no more rows to refresh */ Events.EVENT_STORE_REFRESHED = "storeRefreshed";
Events.EVENT_STATE_UPDATED = "stateUpdated";
/** The visibility of the column menu has changed. */ Events.EVENT_COLUMN_MENU_VISIBLE_CHANGED = "columnMenuVisibleChanged";
/** The visibility of the context menu has changed. */ Events.EVENT_CONTEXT_MENU_VISIBLE_CHANGED = "contextMenuVisibleChanged";
/*****************************  INTERNAL EVENTS: START ******************************************* */ /** Please remember to add to ComponentUtil.EXCLUDED_INTERNAL_EVENTS to not have these events exposed to framework components. */ /** All items from here down are used internally by the grid, not intended for external use. */ // not documented, either experimental, or we just don't want users using an depending on them
Events.EVENT_BODY_HEIGHT_CHANGED = "bodyHeightChanged";
Events.EVENT_COLUMN_CONTAINER_WIDTH_CHANGED = "columnContainerWidthChanged";
Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED = "displayedColumnsWidthChanged";
Events.EVENT_SCROLL_VISIBILITY_CHANGED = "scrollVisibilityChanged";
Events.EVENT_COLUMN_HOVER_CHANGED = "columnHoverChanged";
Events.EVENT_FLASH_CELLS = "flashCells";
Events.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED = "paginationPixelOffsetChanged";
Events.EVENT_DISPLAYED_ROWS_CHANGED = "displayedRowsChanged";
Events.EVENT_LEFT_PINNED_WIDTH_CHANGED = "leftPinnedWidthChanged";
Events.EVENT_RIGHT_PINNED_WIDTH_CHANGED = "rightPinnedWidthChanged";
Events.EVENT_ROW_CONTAINER_HEIGHT_CHANGED = "rowContainerHeightChanged";
Events.EVENT_HEADER_HEIGHT_CHANGED = "headerHeightChanged";
Events.EVENT_COLUMN_HEADER_HEIGHT_CHANGED = "columnHeaderHeightChanged";
Events.EVENT_ROW_DRAG_ENTER = "rowDragEnter";
Events.EVENT_ROW_DRAG_MOVE = "rowDragMove";
Events.EVENT_ROW_DRAG_LEAVE = "rowDragLeave";
Events.EVENT_ROW_DRAG_END = "rowDragEnd";
// environment
Events.EVENT_GRID_STYLES_CHANGED = "gridStylesChanged";
// these are used for server side group and agg - only used by CS with Viewport Row Model - intention is
// to design these better around server side functions and then release to general public when fully working with
// all the row models.
Events.EVENT_COLUMN_ROW_GROUP_CHANGE_REQUEST = "columnRowGroupChangeRequest";
Events.EVENT_COLUMN_PIVOT_CHANGE_REQUEST = "columnPivotChangeRequest";
Events.EVENT_COLUMN_VALUE_CHANGE_REQUEST = "columnValueChangeRequest";
Events.EVENT_COLUMN_AGG_FUNC_CHANGE_REQUEST = "columnAggFuncChangeRequest";
Events.EVENT_STORE_UPDATED = "storeUpdated";
Events.EVENT_FILTER_DESTROYED = "filterDestroyed";
Events.EVENT_ROW_DATA_UPDATE_STARTED = "rowDataUpdateStarted";
Events.EVENT_ROW_COUNT_READY = "rowCountReady";
// Advanced Filters
Events.EVENT_ADVANCED_FILTER_ENABLED_CHANGED = "advancedFilterEnabledChanged";
Events.EVENT_DATA_TYPES_INFERRED = "dataTypesInferred";
// Widgets
Events.EVENT_FIELD_VALUE_CHANGED = "fieldValueChanged";
Events.EVENT_FIELD_PICKER_VALUE_SELECTED = "fieldPickerValueSelected";
Events.EVENT_SIDE_BAR_UPDATED = "sideBarUpdated";
// community-modules/core/src/events.ts
var ALWAYS_SYNC_GLOBAL_EVENTS = /* @__PURE__ */ new Set([
    Events.EVENT_GRID_PRE_DESTROYED,
    Events.EVENT_FILL_START
]);
// community-modules/core/src/columns/groupInstanceIdCreator.ts
var GroupInstanceIdCreator = class {
    constructor(){
        // this map contains keys to numbers, so we remember what the last call was
        this.existingIds = {};
    }
    getInstanceIdForKey(key) {
        const lastResult = this.existingIds[key];
        let result;
        if (typeof lastResult !== "number") result = 0;
        else result = lastResult + 1;
        this.existingIds[key] = result;
        return result;
    }
};
// community-modules/core/src/columns/autoGroupColService.ts
var GROUP_AUTO_COLUMN_ID = "ag-Grid-AutoColumn";
var AutoGroupColService = class extends BeanStub {
    createAutoGroupColumns(rowGroupColumns) {
        const groupAutoColumns = [];
        const doingTreeData = this.gos.get("treeData");
        let doingMultiAutoColumn = this.gos.isGroupMultiAutoColumn();
        if (doingTreeData && doingMultiAutoColumn) {
            console.warn('AG Grid: you cannot mix groupDisplayType = "multipleColumns" with treeData, only one column can be used to display groups when doing tree data');
            doingMultiAutoColumn = false;
        }
        if (doingMultiAutoColumn) rowGroupColumns.forEach((rowGroupCol, index)=>{
            groupAutoColumns.push(this.createOneAutoGroupColumn(rowGroupCol, index));
        });
        else groupAutoColumns.push(this.createOneAutoGroupColumn());
        return groupAutoColumns;
    }
    updateAutoGroupColumns(autoGroupColumns, source) {
        autoGroupColumns.forEach((column, index)=>this.updateOneAutoGroupColumn(column, index, source));
    }
    // rowGroupCol and index are missing if groupDisplayType != "multipleColumns"
    createOneAutoGroupColumn(rowGroupCol, index) {
        let colId;
        if (rowGroupCol) colId = `${GROUP_AUTO_COLUMN_ID}-${rowGroupCol.getId()}`;
        else colId = GROUP_AUTO_COLUMN_ID;
        const colDef = this.createAutoGroupColDef(colId, rowGroupCol, index);
        colDef.colId = colId;
        const newCol = new Column(colDef, null, colId, true);
        this.context.createBean(newCol);
        return newCol;
    }
    /**
   * Refreshes an auto group col to load changes from defaultColDef or autoGroupColDef
   */ updateOneAutoGroupColumn(colToUpdate, index, source) {
        const oldColDef = colToUpdate.getColDef();
        const underlyingColId = typeof oldColDef.showRowGroup == "string" ? oldColDef.showRowGroup : void 0;
        const underlyingColumn = underlyingColId != null ? this.columnModel.getPrimaryColumn(underlyingColId) : void 0;
        const colDef = this.createAutoGroupColDef(colToUpdate.getId(), underlyingColumn != null ? underlyingColumn : void 0, index);
        colToUpdate.setColDef(colDef, null, source);
        this.columnFactory.applyColumnState(colToUpdate, colDef, source);
    }
    createAutoGroupColDef(colId, underlyingColumn, index) {
        let res = this.createBaseColDef(underlyingColumn);
        const autoGroupColumnDef = this.gos.get("autoGroupColumnDef");
        mergeDeep(res, autoGroupColumnDef);
        res = this.columnFactory.addColumnDefaultAndTypes(res, colId);
        if (!this.gos.get("treeData")) {
            const noFieldOrValueGetter = missing(res.field) && missing(res.valueGetter) && missing(res.filterValueGetter) && res.filter !== "agGroupColumnFilter";
            if (noFieldOrValueGetter) res.filter = false;
        }
        if (index && index > 0) res.headerCheckboxSelection = false;
        const isSortingCoupled = this.gos.isColumnsSortingCoupledToGroup();
        const hasOwnData = res.valueGetter || res.field != null;
        if (isSortingCoupled && !hasOwnData) {
            res.sortIndex = void 0;
            res.initialSort = void 0;
        }
        return res;
    }
    createBaseColDef(rowGroupCol) {
        const userDef = this.gos.get("autoGroupColumnDef");
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        const res = {
            headerName: localeTextFunc("group", "Group")
        };
        const userHasProvidedGroupCellRenderer = userDef && (userDef.cellRenderer || userDef.cellRendererSelector);
        if (!userHasProvidedGroupCellRenderer) res.cellRenderer = "agGroupCellRenderer";
        if (rowGroupCol) {
            const colDef = rowGroupCol.getColDef();
            Object.assign(res, {
                // cellRendererParams.groupKey: colDefToCopy.field;
                headerName: this.columnModel.getDisplayNameForColumn(rowGroupCol, "header"),
                headerValueGetter: colDef.headerValueGetter
            });
            if (colDef.cellRenderer) Object.assign(res, {
                cellRendererParams: {
                    innerRenderer: colDef.cellRenderer,
                    innerRendererParams: colDef.cellRendererParams
                }
            });
            res.showRowGroup = rowGroupCol.getColId();
        } else res.showRowGroup = true;
        return res;
    }
};
__decorateClass([
    Autowired("columnModel")
], AutoGroupColService.prototype, "columnModel", 2);
__decorateClass([
    Autowired("columnFactory")
], AutoGroupColService.prototype, "columnFactory", 2);
AutoGroupColService = __decorateClass([
    Bean("autoGroupColService")
], AutoGroupColService);
// community-modules/core/src/utils/string.ts
var string_exports = {};
__export(string_exports, {
    camelCaseToHumanText: ()=>camelCaseToHumanText,
    camelCaseToHyphenated: ()=>camelCaseToHyphenated,
    capitalise: ()=>capitalise,
    escapeString: ()=>escapeString,
    utf8_encode: ()=>utf8_encode
});
var reUnescapedHtml = /[&<>"']/g;
var HTML_ESCAPES = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
};
function utf8_encode(s) {
    const stringFromCharCode = String.fromCharCode;
    function ucs2decode(string) {
        const output = [];
        if (!string) return [];
        const len = string.length;
        let counter = 0;
        let value;
        let extra;
        while(counter < len){
            value = string.charCodeAt(counter++);
            if (value >= 55296 && value <= 56319 && counter < len) {
                extra = string.charCodeAt(counter++);
                if ((extra & 64512) == 56320) output.push(((value & 1023) << 10) + (extra & 1023) + 65536);
                else {
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    function checkScalarValue(point) {
        if (point >= 55296 && point <= 57343) throw Error("Lone surrogate U+" + point.toString(16).toUpperCase() + " is not a scalar value");
    }
    function createByte(point, shift) {
        return stringFromCharCode(point >> shift & 63 | 128);
    }
    function encodeCodePoint(point) {
        if (point >= 0 && point <= 31 && point !== 10) {
            const convertedCode = point.toString(16).toUpperCase();
            const paddedCode = convertedCode.padStart(4, "0");
            return `_x${paddedCode}_`;
        }
        if ((point & 4294967168) == 0) return stringFromCharCode(point);
        let symbol = "";
        if ((point & 4294965248) == 0) symbol = stringFromCharCode(point >> 6 & 31 | 192);
        else if ((point & 4294901760) == 0) {
            checkScalarValue(point);
            symbol = stringFromCharCode(point >> 12 & 15 | 224);
            symbol += createByte(point, 6);
        } else if ((point & 4292870144) == 0) {
            symbol = stringFromCharCode(point >> 18 & 7 | 240);
            symbol += createByte(point, 12);
            symbol += createByte(point, 6);
        }
        symbol += stringFromCharCode(point & 63 | 128);
        return symbol;
    }
    const codePoints = ucs2decode(s);
    const length = codePoints.length;
    let index = -1;
    let codePoint;
    let byteString = "";
    while(++index < length){
        codePoint = codePoints[index];
        byteString += encodeCodePoint(codePoint);
    }
    return byteString;
}
function capitalise(str) {
    return str[0].toUpperCase() + str.substring(1).toLowerCase();
}
function escapeString(toEscape, skipEscapingHtmlChars) {
    if (toEscape == null) return null;
    const stringResult = toEscape.toString().toString();
    if (skipEscapingHtmlChars) return stringResult;
    return stringResult.replace(reUnescapedHtml, (chr)=>HTML_ESCAPES[chr]);
}
function camelCaseToHumanText(camelCase) {
    if (!camelCase || camelCase == null) return null;
    const rex = /([a-z])([A-Z])/g;
    const rexCaps = /([A-Z]+)([A-Z])([a-z])/g;
    const words = camelCase.replace(rex, "$1 $2").replace(rexCaps, "$1 $2$3").replace(/\./g, " ").split(" ");
    return words.map((word)=>word.substring(0, 1).toUpperCase() + (word.length > 1 ? word.substring(1, word.length) : "")).join(" ");
}
function camelCaseToHyphenated(camelCase) {
    return camelCase.replace(/[A-Z]/g, (s)=>`-${s.toLocaleLowerCase()}`);
}
// community-modules/core/src/utils/map.ts
var map_exports = {};
__export(map_exports, {
    convertToMap: ()=>convertToMap,
    keys: ()=>keys,
    mapById: ()=>mapById
});
function convertToMap(arr) {
    const map = /* @__PURE__ */ new Map();
    arr.forEach((pair)=>map.set(pair[0], pair[1]));
    return map;
}
function mapById(arr, callback) {
    const map = /* @__PURE__ */ new Map();
    arr.forEach((item)=>map.set(callback(item), item));
    return map;
}
function keys(map) {
    const arr = [];
    map.forEach((_2, key)=>arr.push(key));
    return arr;
}
// community-modules/core/src/columns/columnModel.ts
var ColumnModel = class extends BeanStub {
    constructor(){
        super(...arguments);
        // header row count, based on user provided columns
        this.primaryHeaderRowCount = 0;
        this.secondaryHeaderRowCount = 0;
        // header row count, either above, or based on pivoting if we are pivoting
        this.gridHeaderRowCount = 0;
        // leave level columns of the displayed trees
        this.displayedColumnsLeft = [];
        this.displayedColumnsRight = [];
        this.displayedColumnsCenter = [];
        // all three lists above combined
        this.displayedColumns = [];
        // for fast lookup, to see if a column or group is still displayed
        this.displayedColumnsAndGroupsMap = {};
        // all columns to be rendered
        this.viewportColumns = [];
        // A hash key to keep track of changes in viewport columns
        this.viewportColumnsHash = "";
        // same as viewportColumns, except we always include columns with headerAutoHeight
        this.headerViewportColumns = [];
        // all columns to be rendered in the centre
        this.viewportColumnsCenter = [];
        // same as viewportColumnsCenter, except we always include columns with headerAutoHeight
        this.headerViewportColumnsCenter = [];
        // all columns & groups to be rendered, index by row. used by header rows to get all items
        // to render for that row.
        this.viewportRowLeft = {};
        this.viewportRowRight = {};
        this.viewportRowCenter = {};
        this.autoHeightActiveAtLeastOnce = false;
        this.rowGroupColumns = [];
        this.valueColumns = [];
        this.pivotColumns = [];
        this.ready = false;
        this.changeEventsDispatching = false;
        this.autoGroupsNeedBuilding = false;
        this.forceRecreateAutoGroups = false;
        this.pivotMode = false;
        this.bodyWidth = 0;
        this.leftWidth = 0;
        this.rightWidth = 0;
        this.bodyWidthDirty = true;
        // when we're waiting for cell data types to be inferred, we need to defer column resizing
        this.shouldQueueResizeOperations = false;
        this.resizeOperationQueue = [];
    }
    init() {
        this.suppressColumnVirtualisation = this.gos.get("suppressColumnVirtualisation");
        const pivotMode = this.gos.get("pivotMode");
        if (this.isPivotSettingAllowed(pivotMode)) this.pivotMode = pivotMode;
        this.addManagedPropertyListeners([
            "groupDisplayType",
            "treeData",
            "treeDataDisplayType",
            "groupHideOpenParents"
        ], (event)=>this.buildAutoGroupColumns(convertSourceType(event.source)));
        this.addManagedPropertyListener("autoGroupColumnDef", (event)=>this.onAutoGroupColumnDefChanged(convertSourceType(event.source)));
        this.addManagedPropertyListeners([
            "defaultColDef",
            "columnTypes",
            "suppressFieldDotNotation"
        ], (event)=>this.onSharedColDefChanged(convertSourceType(event.source)));
        this.addManagedPropertyListener("pivotMode", (event)=>this.setPivotMode(this.gos.get("pivotMode"), convertSourceType(event.source)));
        this.addManagedListener(this.eventService, Events.EVENT_FIRST_DATA_RENDERED, ()=>this.onFirstDataRendered());
    }
    buildAutoGroupColumns(source) {
        if (!this.columnDefs) return;
        this.autoGroupsNeedBuilding = true;
        this.forceRecreateAutoGroups = true;
        this.updateGridColumns();
        this.updateDisplayedColumns(source);
    }
    onAutoGroupColumnDefChanged(source) {
        if (this.groupAutoColumns) this.autoGroupColService.updateAutoGroupColumns(this.groupAutoColumns, source);
    }
    onSharedColDefChanged(source) {
        if (!this.gridColumns) return;
        if (this.groupAutoColumns) this.autoGroupColService.updateAutoGroupColumns(this.groupAutoColumns, source);
        this.createColumnsFromColumnDefs(true, source);
    }
    setColumnDefs(columnDefs, source) {
        const colsPreviouslyExisted = !!this.columnDefs;
        this.columnDefs = columnDefs;
        this.createColumnsFromColumnDefs(colsPreviouslyExisted, source);
    }
    recreateColumnDefs(source) {
        this.onSharedColDefChanged(source);
    }
    destroyOldColumns(oldTree, newTree) {
        const oldObjectsById = {};
        if (!oldTree) return;
        depthFirstOriginalTreeSearch(null, oldTree, (child)=>{
            oldObjectsById[child.getInstanceId()] = child;
        });
        if (newTree) depthFirstOriginalTreeSearch(null, newTree, (child)=>{
            oldObjectsById[child.getInstanceId()] = null;
        });
        const colsToDestroy = Object.values(oldObjectsById).filter((item)=>item != null);
        this.destroyBeans(colsToDestroy);
    }
    destroyColumns() {
        this.destroyOldColumns(this.primaryColumnTree);
        this.destroyOldColumns(this.secondaryBalancedTree);
        this.destroyOldColumns(this.groupAutoColsBalancedTree);
    }
    createColumnsFromColumnDefs(colsPreviouslyExisted, source) {
        const dispatchEventsFunc = colsPreviouslyExisted ? this.compareColumnStatesAndDispatchEvents(source) : void 0;
        this.valueCache.expire();
        this.autoGroupsNeedBuilding = true;
        const oldPrimaryColumns = this.primaryColumns;
        const oldPrimaryTree = this.primaryColumnTree;
        const balancedTreeResult = this.columnFactory.createColumnTree(this.columnDefs, true, oldPrimaryTree, source);
        this.destroyOldColumns(this.primaryColumnTree, balancedTreeResult.columnTree);
        this.primaryColumnTree = balancedTreeResult.columnTree;
        this.primaryHeaderRowCount = balancedTreeResult.treeDept + 1;
        this.primaryColumns = this.getColumnsFromTree(this.primaryColumnTree);
        this.primaryColumnsMap = {};
        this.primaryColumns.forEach((col)=>this.primaryColumnsMap[col.getId()] = col);
        this.extractRowGroupColumns(source, oldPrimaryColumns);
        this.extractPivotColumns(source, oldPrimaryColumns);
        this.extractValueColumns(source, oldPrimaryColumns);
        this.ready = true;
        const gridColsNotProcessed = this.gridColsArePrimary === void 0;
        const processGridCols = this.gridColsArePrimary || gridColsNotProcessed || this.autoGroupsNeedBuilding;
        if (processGridCols) {
            this.updateGridColumns();
            if (colsPreviouslyExisted && this.gridColsArePrimary && !this.gos.get("maintainColumnOrder")) this.orderGridColumnsLikePrimary();
            this.updateDisplayedColumns(source);
            this.checkViewportColumns();
        }
        this.dispatchEverythingChanged(source);
        this.changeEventsDispatching = true;
        if (dispatchEventsFunc) dispatchEventsFunc();
        this.changeEventsDispatching = false;
        this.dispatchNewColumnsLoaded(source);
    }
    shouldRowModelIgnoreRefresh() {
        return this.changeEventsDispatching;
    }
    dispatchNewColumnsLoaded(source) {
        const newColumnsLoadedEvent = {
            type: Events.EVENT_NEW_COLUMNS_LOADED,
            source
        };
        this.eventService.dispatchEvent(newColumnsLoadedEvent);
        if (source === "gridInitializing") this.onColumnsReady();
    }
    // this event is legacy, no grid code listens to it. instead the grid listens to New Columns Loaded
    dispatchEverythingChanged(source) {
        const eventEverythingChanged = {
            type: Events.EVENT_COLUMN_EVERYTHING_CHANGED,
            source
        };
        this.eventService.dispatchEvent(eventEverythingChanged);
    }
    orderGridColumnsLikePrimary() {
        const primaryColumns = this.primaryColumns;
        if (!primaryColumns) return;
        const primaryColsOrdered = primaryColumns.filter((col)=>this.gridColumns.indexOf(col) >= 0);
        const otherCols = this.gridColumns.filter((col)=>primaryColsOrdered.indexOf(col) < 0);
        this.gridColumns = [
            ...otherCols,
            ...primaryColsOrdered
        ];
        this.gridColumns = this.placeLockedColumns(this.gridColumns);
    }
    getAllDisplayedAutoHeightCols() {
        return this.displayedAutoHeightCols;
    }
    setViewport() {
        if (this.gos.get("enableRtl")) {
            this.viewportLeft = this.bodyWidth - this.scrollPosition - this.scrollWidth;
            this.viewportRight = this.bodyWidth - this.scrollPosition;
        } else {
            this.viewportLeft = this.scrollPosition;
            this.viewportRight = this.scrollWidth + this.scrollPosition;
        }
    }
    // checks what columns are currently displayed due to column virtualisation. dispatches an event
    // if the list of columns has changed.
    // + setColumnWidth(), setViewportPosition(), setColumnDefs(), sizeColumnsToFit()
    checkViewportColumns(afterScroll = false) {
        if (this.displayedColumnsCenter == null) return;
        const viewportColumnsChanged = this.extractViewport();
        if (!viewportColumnsChanged) return;
        const event = {
            type: Events.EVENT_VIRTUAL_COLUMNS_CHANGED,
            afterScroll
        };
        this.eventService.dispatchEvent(event);
    }
    setViewportPosition(scrollWidth, scrollPosition, afterScroll = false) {
        if (scrollWidth !== this.scrollWidth || scrollPosition !== this.scrollPosition || this.bodyWidthDirty) {
            this.scrollWidth = scrollWidth;
            this.scrollPosition = scrollPosition;
            this.bodyWidthDirty = true;
            this.setViewport();
            if (this.ready) this.checkViewportColumns(afterScroll);
        }
    }
    isPivotMode() {
        return this.pivotMode;
    }
    isPivotSettingAllowed(pivot) {
        if (pivot && this.gos.get("treeData")) {
            warnOnce("Pivot mode not available with treeData.");
            return false;
        }
        return true;
    }
    setPivotMode(pivotMode, source) {
        if (pivotMode === this.pivotMode || !this.isPivotSettingAllowed(this.pivotMode)) return;
        this.pivotMode = pivotMode;
        if (!this.gridColumns) return;
        this.autoGroupsNeedBuilding = true;
        this.updateGridColumns();
        this.updateDisplayedColumns(source);
        const event = {
            type: Events.EVENT_COLUMN_PIVOT_MODE_CHANGED
        };
        this.eventService.dispatchEvent(event);
    }
    getSecondaryPivotColumn(pivotKeys, valueColKey) {
        if (missing(this.secondaryColumns)) return null;
        const valueColumnToFind = this.getPrimaryColumn(valueColKey);
        let foundColumn = null;
        this.secondaryColumns.forEach((column)=>{
            const thisPivotKeys = column.getColDef().pivotKeys;
            const pivotValueColumn = column.getColDef().pivotValueColumn;
            const pivotKeyMatches = areEqual(thisPivotKeys, pivotKeys);
            const pivotValueMatches = pivotValueColumn === valueColumnToFind;
            if (pivotKeyMatches && pivotValueMatches) foundColumn = column;
        });
        return foundColumn;
    }
    setBeans(loggerFactory) {
        this.logger = loggerFactory.create("columnModel");
    }
    setFirstRightAndLastLeftPinned(source) {
        let lastLeft;
        let firstRight;
        if (this.gos.get("enableRtl")) {
            lastLeft = this.displayedColumnsLeft ? this.displayedColumnsLeft[0] : null;
            firstRight = this.displayedColumnsRight ? last(this.displayedColumnsRight) : null;
        } else {
            lastLeft = this.displayedColumnsLeft ? last(this.displayedColumnsLeft) : null;
            firstRight = this.displayedColumnsRight ? this.displayedColumnsRight[0] : null;
        }
        this.gridColumns.forEach((column)=>{
            column.setLastLeftPinned(column === lastLeft, source);
            column.setFirstRightPinned(column === firstRight, source);
        });
    }
    autoSizeColumns(params) {
        if (this.shouldQueueResizeOperations) {
            this.resizeOperationQueue.push(()=>this.autoSizeColumns(params));
            return;
        }
        const { columns, skipHeader, skipHeaderGroups, stopAtGroup, source = "api" } = params;
        this.animationFrameService.flushAllFrames();
        const columnsAutosized = [];
        let changesThisTimeAround = -1;
        const shouldSkipHeader = skipHeader != null ? skipHeader : this.gos.get("skipHeaderOnAutoSize");
        const shouldSkipHeaderGroups = skipHeaderGroups != null ? skipHeaderGroups : shouldSkipHeader;
        while(changesThisTimeAround !== 0){
            changesThisTimeAround = 0;
            this.actionOnGridColumns(columns, (column)=>{
                if (columnsAutosized.indexOf(column) >= 0) return false;
                const preferredWidth = this.autoWidthCalculator.getPreferredWidthForColumn(column, shouldSkipHeader);
                if (preferredWidth > 0) {
                    const newWidth = this.normaliseColumnWidth(column, preferredWidth);
                    column.setActualWidth(newWidth, source);
                    columnsAutosized.push(column);
                    changesThisTimeAround++;
                }
                return true;
            }, source);
        }
        if (!shouldSkipHeaderGroups) this.autoSizeColumnGroupsByColumns(columns, source, stopAtGroup);
        this.dispatchColumnResizedEvent(columnsAutosized, true, "autosizeColumns");
    }
    dispatchColumnResizedEvent(columns, finished, source, flexColumns = null) {
        if (columns && columns.length) {
            const event = {
                type: Events.EVENT_COLUMN_RESIZED,
                columns,
                column: columns.length === 1 ? columns[0] : null,
                flexColumns,
                finished,
                source
            };
            this.eventService.dispatchEvent(event);
        }
    }
    dispatchColumnChangedEvent(type, columns, source) {
        const event = {
            type,
            columns,
            column: columns && columns.length == 1 ? columns[0] : null,
            source
        };
        this.eventService.dispatchEvent(event);
    }
    dispatchColumnMovedEvent(params) {
        const { movedColumns, source, toIndex, finished } = params;
        const event = {
            type: Events.EVENT_COLUMN_MOVED,
            columns: movedColumns,
            column: movedColumns && movedColumns.length === 1 ? movedColumns[0] : null,
            toIndex,
            finished,
            source
        };
        this.eventService.dispatchEvent(event);
    }
    dispatchColumnPinnedEvent(changedColumns, source) {
        if (!changedColumns.length) return;
        const column = changedColumns.length === 1 ? changedColumns[0] : null;
        const pinned = this.getCommonValue(changedColumns, (col)=>col.getPinned());
        const event = {
            type: Events.EVENT_COLUMN_PINNED,
            // mistake in typing, 'undefined' should be allowed, as 'null' means 'not pinned'
            pinned: pinned != null ? pinned : null,
            columns: changedColumns,
            column,
            source
        };
        this.eventService.dispatchEvent(event);
    }
    dispatchColumnVisibleEvent(changedColumns, source) {
        if (!changedColumns.length) return;
        const column = changedColumns.length === 1 ? changedColumns[0] : null;
        const visible = this.getCommonValue(changedColumns, (col)=>col.isVisible());
        const event = {
            type: Events.EVENT_COLUMN_VISIBLE,
            visible,
            columns: changedColumns,
            column,
            source
        };
        this.eventService.dispatchEvent(event);
    }
    autoSizeColumn(key, source, skipHeader) {
        if (key) this.autoSizeColumns({
            columns: [
                key
            ],
            skipHeader,
            skipHeaderGroups: true,
            source
        });
    }
    autoSizeColumnGroupsByColumns(keys2, source, stopAtGroup) {
        const columnGroups = /* @__PURE__ */ new Set();
        const columns = this.getGridColumns(keys2);
        columns.forEach((col)=>{
            let parent = col.getParent();
            while(parent && parent != stopAtGroup){
                if (!parent.isPadding()) columnGroups.add(parent);
                parent = parent.getParent();
            }
        });
        let headerGroupCtrl;
        const resizedColumns = [];
        for (const columnGroup of columnGroups){
            for (const headerContainerCtrl of this.ctrlsService.getHeaderRowContainerCtrls()){
                headerGroupCtrl = headerContainerCtrl.getHeaderCtrlForColumn(columnGroup);
                if (headerGroupCtrl) break;
            }
            if (headerGroupCtrl) headerGroupCtrl.resizeLeafColumnsToFit(source);
        }
        return resizedColumns;
    }
    autoSizeAllColumns(source, skipHeader) {
        if (this.shouldQueueResizeOperations) {
            this.resizeOperationQueue.push(()=>this.autoSizeAllColumns(source, skipHeader));
            return;
        }
        const allDisplayedColumns = this.getAllDisplayedColumns();
        this.autoSizeColumns({
            columns: allDisplayedColumns,
            skipHeader,
            source
        });
    }
    // Possible candidate for reuse (alot of recursive traversal duplication)
    getColumnsFromTree(rootColumns) {
        const result = [];
        const recursiveFindColumns = (childColumns)=>{
            for(let i = 0; i < childColumns.length; i++){
                const child = childColumns[i];
                if (child instanceof Column) result.push(child);
                else if (child instanceof ProvidedColumnGroup) recursiveFindColumns(child.getChildren());
            }
        };
        recursiveFindColumns(rootColumns);
        return result;
    }
    getAllDisplayedTrees() {
        if (this.displayedTreeLeft && this.displayedTreeRight && this.displayedTreeCentre) return this.displayedTreeLeft.concat(this.displayedTreeCentre).concat(this.displayedTreeRight);
        return null;
    }
    // + columnSelectPanel
    getPrimaryColumnTree() {
        return this.primaryColumnTree;
    }
    // + gridPanel -> for resizing the body and setting top margin
    getHeaderRowCount() {
        return this.gridHeaderRowCount;
    }
    // + headerRenderer -> setting pinned body width
    getDisplayedTreeLeft() {
        return this.displayedTreeLeft;
    }
    // + headerRenderer -> setting pinned body width
    getDisplayedTreeRight() {
        return this.displayedTreeRight;
    }
    // + headerRenderer -> setting pinned body width
    getDisplayedTreeCentre() {
        return this.displayedTreeCentre;
    }
    // gridPanel -> ensureColumnVisible
    isColumnDisplayed(column) {
        return this.getAllDisplayedColumns().indexOf(column) >= 0;
    }
    // + csvCreator
    getAllDisplayedColumns() {
        return this.displayedColumns;
    }
    getViewportColumns() {
        return this.viewportColumns;
    }
    getDisplayedLeftColumnsForRow(rowNode) {
        if (!this.colSpanActive) return this.displayedColumnsLeft;
        return this.getDisplayedColumnsForRow(rowNode, this.displayedColumnsLeft);
    }
    getDisplayedRightColumnsForRow(rowNode) {
        if (!this.colSpanActive) return this.displayedColumnsRight;
        return this.getDisplayedColumnsForRow(rowNode, this.displayedColumnsRight);
    }
    isColSpanActive() {
        return this.colSpanActive;
    }
    getDisplayedColumnsForRow(rowNode, displayedColumns, filterCallback, emptySpaceBeforeColumn) {
        const result = [];
        let lastConsideredCol = null;
        for(let i = 0; i < displayedColumns.length; i++){
            const col = displayedColumns[i];
            const maxAllowedColSpan = displayedColumns.length - i;
            const colSpan = Math.min(col.getColSpan(rowNode), maxAllowedColSpan);
            const columnsToCheckFilter = [
                col
            ];
            if (colSpan > 1) {
                const colsToRemove = colSpan - 1;
                for(let j = 1; j <= colsToRemove; j++)columnsToCheckFilter.push(displayedColumns[i + j]);
                i += colsToRemove;
            }
            let filterPasses;
            if (filterCallback) {
                filterPasses = false;
                columnsToCheckFilter.forEach((colForFilter)=>{
                    if (filterCallback(colForFilter)) filterPasses = true;
                });
            } else filterPasses = true;
            if (filterPasses) {
                if (result.length === 0 && lastConsideredCol) {
                    const gapBeforeColumn = emptySpaceBeforeColumn ? emptySpaceBeforeColumn(col) : false;
                    if (gapBeforeColumn) result.push(lastConsideredCol);
                }
                result.push(col);
            }
            lastConsideredCol = col;
        }
        return result;
    }
    // + rowRenderer
    // if we are not column spanning, this just returns back the virtual centre columns,
    // however if we are column spanning, then different rows can have different virtual
    // columns, so we have to work out the list for each individual row.
    getViewportCenterColumnsForRow(rowNode) {
        if (!this.colSpanActive) return this.viewportColumnsCenter;
        const emptySpaceBeforeColumn = (col)=>{
            const left = col.getLeft();
            return exists(left) && left > this.viewportLeft;
        };
        const filterCallback = this.isColumnVirtualisationSuppressed() ? null : this.isColumnInRowViewport.bind(this);
        return this.getDisplayedColumnsForRow(rowNode, this.displayedColumnsCenter, filterCallback, emptySpaceBeforeColumn);
    }
    isColumnAtEdge(col, edge) {
        const allColumns = this.getAllDisplayedColumns();
        if (!allColumns.length) return false;
        const isFirst = edge === "first";
        let columnToCompare;
        if (col instanceof ColumnGroup) {
            const leafColumns = col.getDisplayedLeafColumns();
            if (!leafColumns.length) return false;
            columnToCompare = isFirst ? leafColumns[0] : last(leafColumns);
        } else columnToCompare = col;
        return (isFirst ? allColumns[0] : last(allColumns)) === columnToCompare;
    }
    getAriaColumnIndex(col) {
        let targetColumn;
        if (col instanceof ColumnGroup) targetColumn = col.getLeafColumns()[0];
        else targetColumn = col;
        return this.ariaOrderColumns.indexOf(targetColumn) + 1;
    }
    isColumnInHeaderViewport(col) {
        if (col.isAutoHeaderHeight()) return true;
        return this.isColumnInRowViewport(col);
    }
    isColumnInRowViewport(col) {
        if (col.isAutoHeight()) return true;
        const columnLeft = col.getLeft() || 0;
        const columnRight = columnLeft + col.getActualWidth();
        const leftBounds = this.viewportLeft - 200;
        const rightBounds = this.viewportRight + 200;
        const columnToMuchLeft = columnLeft < leftBounds && columnRight < leftBounds;
        const columnToMuchRight = columnLeft > rightBounds && columnRight > rightBounds;
        return !columnToMuchLeft && !columnToMuchRight;
    }
    // used by:
    // + angularGrid -> setting pinned body width
    // note: this should be cached
    getDisplayedColumnsLeftWidth() {
        return this.getWidthOfColsInList(this.displayedColumnsLeft);
    }
    // note: this should be cached
    getDisplayedColumnsRightWidth() {
        return this.getWidthOfColsInList(this.displayedColumnsRight);
    }
    updatePrimaryColumnList(keys2, masterList, actionIsAdd, columnCallback, eventType, source) {
        if (!keys2 || missingOrEmpty(keys2)) return;
        let atLeastOne = false;
        keys2.forEach((key)=>{
            if (!key) return;
            const columnToAdd = this.getPrimaryColumn(key);
            if (!columnToAdd) return;
            if (actionIsAdd) {
                if (masterList.indexOf(columnToAdd) >= 0) return;
                masterList.push(columnToAdd);
            } else {
                if (masterList.indexOf(columnToAdd) < 0) return;
                removeFromArray(masterList, columnToAdd);
            }
            columnCallback(columnToAdd);
            atLeastOne = true;
        });
        if (!atLeastOne) return;
        if (this.autoGroupsNeedBuilding) this.updateGridColumns();
        this.updateDisplayedColumns(source);
        const event = {
            type: eventType,
            columns: masterList,
            column: masterList.length === 1 ? masterList[0] : null,
            source
        };
        this.eventService.dispatchEvent(event);
    }
    setRowGroupColumns(colKeys, source) {
        this.autoGroupsNeedBuilding = true;
        this.setPrimaryColumnList(colKeys, this.rowGroupColumns, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, true, this.setRowGroupActive.bind(this), source);
    }
    setRowGroupActive(active, column, source) {
        if (active === column.isRowGroupActive()) return;
        column.setRowGroupActive(active, source);
        if (active && !this.gos.get("suppressRowGroupHidesColumns")) this.setColumnsVisible([
            column
        ], false, source);
        if (!active && !this.gos.get("suppressMakeColumnVisibleAfterUnGroup")) this.setColumnsVisible([
            column
        ], true, source);
    }
    addRowGroupColumns(keys2, source) {
        this.autoGroupsNeedBuilding = true;
        this.updatePrimaryColumnList(keys2, this.rowGroupColumns, true, this.setRowGroupActive.bind(this, true), Events.EVENT_COLUMN_ROW_GROUP_CHANGED, source);
    }
    removeRowGroupColumns(keys2, source) {
        this.autoGroupsNeedBuilding = true;
        this.updatePrimaryColumnList(keys2, this.rowGroupColumns, false, this.setRowGroupActive.bind(this, false), Events.EVENT_COLUMN_ROW_GROUP_CHANGED, source);
    }
    addPivotColumns(keys2, source) {
        this.updatePrimaryColumnList(keys2, this.pivotColumns, true, (column)=>column.setPivotActive(true, source), Events.EVENT_COLUMN_PIVOT_CHANGED, source);
    }
    setPivotColumns(colKeys, source) {
        this.setPrimaryColumnList(colKeys, this.pivotColumns, Events.EVENT_COLUMN_PIVOT_CHANGED, true, (added, column)=>{
            column.setPivotActive(added, source);
        }, source);
    }
    removePivotColumns(keys2, source) {
        this.updatePrimaryColumnList(keys2, this.pivotColumns, false, (column)=>column.setPivotActive(false, source), Events.EVENT_COLUMN_PIVOT_CHANGED, source);
    }
    setPrimaryColumnList(colKeys, masterList, eventName, detectOrderChange, columnCallback, source) {
        if (!this.gridColumns) return;
        const changes = /* @__PURE__ */ new Map();
        masterList.forEach((col, idx)=>changes.set(col, idx));
        masterList.length = 0;
        if (exists(colKeys)) colKeys.forEach((key)=>{
            const column = this.getPrimaryColumn(key);
            if (column) masterList.push(column);
        });
        masterList.forEach((col, idx)=>{
            const oldIndex = changes.get(col);
            if (oldIndex === void 0) {
                changes.set(col, 0);
                return;
            }
            if (detectOrderChange && oldIndex !== idx) return;
            changes.delete(col);
        });
        (this.primaryColumns || []).forEach((column)=>{
            const added = masterList.indexOf(column) >= 0;
            columnCallback(added, column);
        });
        if (this.autoGroupsNeedBuilding) this.updateGridColumns();
        this.updateDisplayedColumns(source);
        this.dispatchColumnChangedEvent(eventName, [
            ...changes.keys()
        ], source);
    }
    setValueColumns(colKeys, source) {
        this.setPrimaryColumnList(colKeys, this.valueColumns, Events.EVENT_COLUMN_VALUE_CHANGED, false, this.setValueActive.bind(this), source);
    }
    setValueActive(active, column, source) {
        if (active === column.isValueActive()) return;
        column.setValueActive(active, source);
        if (active && !column.getAggFunc() && this.aggFuncService) {
            const initialAggFunc = this.aggFuncService.getDefaultAggFunc(column);
            column.setAggFunc(initialAggFunc);
        }
    }
    addValueColumns(keys2, source) {
        this.updatePrimaryColumnList(keys2, this.valueColumns, true, this.setValueActive.bind(this, true), Events.EVENT_COLUMN_VALUE_CHANGED, source);
    }
    removeValueColumns(keys2, source) {
        this.updatePrimaryColumnList(keys2, this.valueColumns, false, this.setValueActive.bind(this, false), Events.EVENT_COLUMN_VALUE_CHANGED, source);
    }
    // returns the width we can set to this col, taking into consideration min and max widths
    normaliseColumnWidth(column, newWidth) {
        const minWidth = column.getMinWidth();
        if (exists(minWidth) && newWidth < minWidth) newWidth = minWidth;
        const maxWidth = column.getMaxWidth();
        if (exists(maxWidth) && column.isGreaterThanMax(newWidth)) newWidth = maxWidth;
        return newWidth;
    }
    getPrimaryOrGridColumn(key) {
        const column = this.getPrimaryColumn(key);
        return column || this.getGridColumn(key);
    }
    setColumnWidths(columnWidths, shiftKey, finished, source) {
        const sets = [];
        columnWidths.forEach((columnWidth)=>{
            const col = this.getPrimaryOrGridColumn(columnWidth.key);
            if (!col) return;
            sets.push({
                width: columnWidth.newWidth,
                ratios: [
                    1
                ],
                columns: [
                    col
                ]
            });
            const defaultIsShift = this.gos.get("colResizeDefault") === "shift";
            if (defaultIsShift) shiftKey = !shiftKey;
            if (shiftKey) {
                const otherCol = this.getDisplayedColAfter(col);
                if (!otherCol) return;
                const widthDiff = col.getActualWidth() - columnWidth.newWidth;
                const otherColWidth = otherCol.getActualWidth() + widthDiff;
                sets.push({
                    width: otherColWidth,
                    ratios: [
                        1
                    ],
                    columns: [
                        otherCol
                    ]
                });
            }
        });
        if (sets.length === 0) return;
        this.resizeColumnSets({
            resizeSets: sets,
            finished,
            source
        });
    }
    checkMinAndMaxWidthsForSet(columnResizeSet) {
        const { columns, width } = columnResizeSet;
        let minWidthAccumulated = 0;
        let maxWidthAccumulated = 0;
        let maxWidthActive = true;
        columns.forEach((col)=>{
            const minWidth = col.getMinWidth();
            minWidthAccumulated += minWidth || 0;
            const maxWidth = col.getMaxWidth();
            if (exists(maxWidth) && maxWidth > 0) maxWidthAccumulated += maxWidth;
            else maxWidthActive = false;
        });
        const minWidthPasses = width >= minWidthAccumulated;
        const maxWidthPasses = !maxWidthActive || width <= maxWidthAccumulated;
        return minWidthPasses && maxWidthPasses;
    }
    // method takes sets of columns and resizes them. either all sets will be resized, or nothing
    // be resized. this is used for example when user tries to resize a group and holds shift key,
    // then both the current group (grows), and the adjacent group (shrinks), will get resized,
    // so that's two sets for this method.
    resizeColumnSets(params) {
        const { resizeSets, finished, source } = params;
        const passMinMaxCheck = !resizeSets || resizeSets.every((columnResizeSet)=>this.checkMinAndMaxWidthsForSet(columnResizeSet));
        if (!passMinMaxCheck) {
            if (finished) {
                const columns = resizeSets && resizeSets.length > 0 ? resizeSets[0].columns : null;
                this.dispatchColumnResizedEvent(columns, finished, source);
            }
            return;
        }
        const changedCols = [];
        const allResizedCols = [];
        resizeSets.forEach((set)=>{
            const { width, columns, ratios } = set;
            const newWidths = {};
            const finishedCols = {};
            columns.forEach((col)=>allResizedCols.push(col));
            let finishedColsGrew = true;
            let loopCount = 0;
            while(finishedColsGrew){
                loopCount++;
                if (loopCount > 1e3) {
                    console.error("AG Grid: infinite loop in resizeColumnSets");
                    break;
                }
                finishedColsGrew = false;
                const subsetCols = [];
                let subsetRatioTotal = 0;
                let pixelsToDistribute = width;
                columns.forEach((col, index)=>{
                    const thisColFinished = finishedCols[col.getId()];
                    if (thisColFinished) pixelsToDistribute -= newWidths[col.getId()];
                    else {
                        subsetCols.push(col);
                        const ratioThisCol = ratios[index];
                        subsetRatioTotal += ratioThisCol;
                    }
                });
                const ratioScale = 1 / subsetRatioTotal;
                subsetCols.forEach((col, index)=>{
                    const lastCol = index === subsetCols.length - 1;
                    let colNewWidth;
                    if (lastCol) colNewWidth = pixelsToDistribute;
                    else {
                        colNewWidth = Math.round(ratios[index] * width * ratioScale);
                        pixelsToDistribute -= colNewWidth;
                    }
                    const minWidth = col.getMinWidth();
                    const maxWidth = col.getMaxWidth();
                    if (exists(minWidth) && colNewWidth < minWidth) {
                        colNewWidth = minWidth;
                        finishedCols[col.getId()] = true;
                        finishedColsGrew = true;
                    } else if (exists(maxWidth) && maxWidth > 0 && colNewWidth > maxWidth) {
                        colNewWidth = maxWidth;
                        finishedCols[col.getId()] = true;
                        finishedColsGrew = true;
                    }
                    newWidths[col.getId()] = colNewWidth;
                });
            }
            columns.forEach((col)=>{
                const newWidth = newWidths[col.getId()];
                const actualWidth = col.getActualWidth();
                if (actualWidth !== newWidth) {
                    col.setActualWidth(newWidth, source);
                    changedCols.push(col);
                }
            });
        });
        const atLeastOneColChanged = changedCols.length > 0;
        let flexedCols = [];
        if (atLeastOneColChanged) {
            flexedCols = this.refreshFlexedColumns({
                resizingCols: allResizedCols,
                skipSetLeft: true
            });
            this.setLeftValues(source);
            this.updateBodyWidths();
            this.checkViewportColumns();
        }
        const colsForEvent = allResizedCols.concat(flexedCols);
        if (atLeastOneColChanged || finished) this.dispatchColumnResizedEvent(colsForEvent, finished, source, flexedCols);
    }
    setColumnAggFunc(key, aggFunc, source) {
        if (!key) return;
        const column = this.getPrimaryColumn(key);
        if (!column) return;
        column.setAggFunc(aggFunc);
        this.dispatchColumnChangedEvent(Events.EVENT_COLUMN_VALUE_CHANGED, [
            column
        ], source);
    }
    moveRowGroupColumn(fromIndex, toIndex, source) {
        if (this.isRowGroupEmpty()) return;
        const column = this.rowGroupColumns[fromIndex];
        const impactedColumns = this.rowGroupColumns.slice(fromIndex, toIndex);
        this.rowGroupColumns.splice(fromIndex, 1);
        this.rowGroupColumns.splice(toIndex, 0, column);
        const event = {
            type: Events.EVENT_COLUMN_ROW_GROUP_CHANGED,
            columns: impactedColumns,
            column: impactedColumns.length === 1 ? impactedColumns[0] : null,
            source
        };
        this.eventService.dispatchEvent(event);
    }
    moveColumns(columnsToMoveKeys, toIndex, source, finished = true) {
        if (!this.gridColumns) return;
        this.columnAnimationService.start();
        if (toIndex > this.gridColumns.length - columnsToMoveKeys.length) {
            console.warn("AG Grid: tried to insert columns in invalid location, toIndex = " + toIndex);
            console.warn("AG Grid: remember that you should not count the moving columns when calculating the new index");
            return;
        }
        const movedColumns = this.getGridColumns(columnsToMoveKeys);
        const failedRules = !this.doesMovePassRules(movedColumns, toIndex);
        if (failedRules) return;
        moveInArray(this.gridColumns, movedColumns, toIndex);
        this.updateDisplayedColumns(source);
        this.dispatchColumnMovedEvent({
            movedColumns,
            source,
            toIndex,
            finished
        });
        this.columnAnimationService.finish();
    }
    doesMovePassRules(columnsToMove, toIndex) {
        const proposedColumnOrder = this.getProposedColumnOrder(columnsToMove, toIndex);
        return this.doesOrderPassRules(proposedColumnOrder);
    }
    doesOrderPassRules(gridOrder) {
        if (!this.doesMovePassMarryChildren(gridOrder)) return false;
        if (!this.doesMovePassLockedPositions(gridOrder)) return false;
        return true;
    }
    getProposedColumnOrder(columnsToMove, toIndex) {
        const proposedColumnOrder = this.gridColumns.slice();
        moveInArray(proposedColumnOrder, columnsToMove, toIndex);
        return proposedColumnOrder;
    }
    // returns the provided cols sorted in same order as they appear in grid columns. eg if grid columns
    // contains [a,b,c,d,e] and col passed is [e,a] then the passed cols are sorted into [a,e]
    sortColumnsLikeGridColumns(cols) {
        if (!cols || cols.length <= 1) return;
        const notAllColsInGridColumns = cols.filter((c)=>this.gridColumns.indexOf(c) < 0).length > 0;
        if (notAllColsInGridColumns) return;
        cols.sort((a, b)=>{
            const indexA = this.gridColumns.indexOf(a);
            const indexB = this.gridColumns.indexOf(b);
            return indexA - indexB;
        });
    }
    doesMovePassLockedPositions(proposedColumnOrder) {
        let lastPlacement = 0;
        let rulePassed = true;
        const lockPositionToPlacement = (position)=>{
            if (!position) return 1;
            if (position === true) return 0;
            return position === "left" ? 0 : 2;
        };
        proposedColumnOrder.forEach((col)=>{
            const placement = lockPositionToPlacement(col.getColDef().lockPosition);
            if (placement < lastPlacement) rulePassed = false;
            lastPlacement = placement;
        });
        return rulePassed;
    }
    doesMovePassMarryChildren(allColumnsCopy) {
        let rulePassed = true;
        depthFirstOriginalTreeSearch(null, this.gridBalancedTree, (child)=>{
            if (!(child instanceof ProvidedColumnGroup)) return;
            const columnGroup = child;
            const colGroupDef = columnGroup.getColGroupDef();
            const marryChildren = colGroupDef && colGroupDef.marryChildren;
            if (!marryChildren) return;
            const newIndexes = [];
            columnGroup.getLeafColumns().forEach((col)=>{
                const newColIndex = allColumnsCopy.indexOf(col);
                newIndexes.push(newColIndex);
            });
            const maxIndex = Math.max.apply(Math, newIndexes);
            const minIndex = Math.min.apply(Math, newIndexes);
            const spread = maxIndex - minIndex;
            const maxSpread = columnGroup.getLeafColumns().length - 1;
            if (spread > maxSpread) rulePassed = false;
        });
        return rulePassed;
    }
    moveColumnByIndex(fromIndex, toIndex, source) {
        if (!this.gridColumns) return;
        const column = this.gridColumns[fromIndex];
        this.moveColumns([
            column
        ], toIndex, source);
    }
    getColumnDefs() {
        if (!this.primaryColumns) return;
        const cols = this.primaryColumns.slice();
        if (this.gridColsArePrimary) cols.sort((a, b)=>this.gridColumns.indexOf(a) - this.gridColumns.indexOf(b));
        else if (this.lastPrimaryOrder) cols.sort((a, b)=>this.lastPrimaryOrder.indexOf(a) - this.lastPrimaryOrder.indexOf(b));
        return this.columnDefFactory.buildColumnDefs(cols, this.rowGroupColumns, this.pivotColumns);
    }
    // used by:
    // + angularGrid -> for setting body width
    // + rowController -> setting main row widths (when inserting and resizing)
    // need to cache this
    getBodyContainerWidth() {
        return this.bodyWidth;
    }
    getContainerWidth(pinned) {
        switch(pinned){
            case "left":
                return this.leftWidth;
            case "right":
                return this.rightWidth;
            default:
                return this.bodyWidth;
        }
    }
    // after setColumnWidth or updateGroupsAndDisplayedColumns
    updateBodyWidths() {
        const newBodyWidth = this.getWidthOfColsInList(this.displayedColumnsCenter);
        const newLeftWidth = this.getWidthOfColsInList(this.displayedColumnsLeft);
        const newRightWidth = this.getWidthOfColsInList(this.displayedColumnsRight);
        this.bodyWidthDirty = this.bodyWidth !== newBodyWidth;
        const atLeastOneChanged = this.bodyWidth !== newBodyWidth || this.leftWidth !== newLeftWidth || this.rightWidth !== newRightWidth;
        if (atLeastOneChanged) {
            this.bodyWidth = newBodyWidth;
            this.leftWidth = newLeftWidth;
            this.rightWidth = newRightWidth;
            const evt = {
                type: Events.EVENT_COLUMN_CONTAINER_WIDTH_CHANGED
            };
            this.eventService.dispatchEvent(evt);
            const event = {
                type: Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED
            };
            this.eventService.dispatchEvent(event);
        }
    }
    // + rowController
    getValueColumns() {
        return this.valueColumns ? this.valueColumns : [];
    }
    // + rowController
    getPivotColumns() {
        return this.pivotColumns ? this.pivotColumns : [];
    }
    // + clientSideRowModel
    isPivotActive() {
        return this.pivotColumns && this.pivotColumns.length > 0 && this.pivotMode;
    }
    // + toolPanel
    getRowGroupColumns() {
        return this.rowGroupColumns ? this.rowGroupColumns : [];
    }
    // + rowController -> while inserting rows
    getDisplayedCenterColumns() {
        return this.displayedColumnsCenter;
    }
    // + rowController -> while inserting rows
    getDisplayedLeftColumns() {
        return this.displayedColumnsLeft;
    }
    getDisplayedRightColumns() {
        return this.displayedColumnsRight;
    }
    // used by:
    // + clientSideRowController -> sorting, building quick filter text
    // + headerRenderer -> sorting (clearing icon)
    getAllPrimaryColumns() {
        return this.primaryColumns ? this.primaryColumns : null;
    }
    getSecondaryColumns() {
        return this.secondaryColumns ? this.secondaryColumns : null;
    }
    getAllColumnsForQuickFilter() {
        return this.columnsForQuickFilter;
    }
    // + moveColumnController
    getAllGridColumns() {
        var _a;
        return (_a = this.gridColumns) != null ? _a : [];
    }
    isRowGroupEmpty() {
        return missingOrEmpty(this.rowGroupColumns);
    }
    setColumnsVisible(keys2, visible = false, source) {
        this.applyColumnState({
            state: keys2.map((key)=>({
                    colId: typeof key === "string" ? key : key.getColId(),
                    hide: !visible
                }))
        }, source);
    }
    setColumnsPinned(keys2, pinned, source) {
        if (!this.gridColumns) return;
        if (this.gos.isDomLayout("print")) {
            console.warn(`AG Grid: Changing the column pinning status is not allowed with domLayout='print'`);
            return;
        }
        this.columnAnimationService.start();
        let actualPinned;
        if (pinned === true || pinned === "left") actualPinned = "left";
        else if (pinned === "right") actualPinned = "right";
        else actualPinned = null;
        this.actionOnGridColumns(keys2, (col)=>{
            if (col.getPinned() !== actualPinned) {
                col.setPinned(actualPinned);
                return true;
            }
            return false;
        }, source, ()=>{
            const event = {
                type: Events.EVENT_COLUMN_PINNED,
                pinned: actualPinned,
                column: null,
                columns: null,
                source
            };
            return event;
        });
        this.columnAnimationService.finish();
    }
    // does an action on a set of columns. provides common functionality for looking up the
    // columns based on key, getting a list of effected columns, and then updated the event
    // with either one column (if it was just one col) or a list of columns
    // used by: autoResize, setVisible, setPinned
    actionOnGridColumns(keys2, action, source, createEvent) {
        if (missingOrEmpty(keys2)) return;
        const updatedColumns = [];
        keys2.forEach((key)=>{
            if (!key) return;
            const column = this.getGridColumn(key);
            if (!column) return;
            const resultOfAction = action(column);
            if (resultOfAction !== false) updatedColumns.push(column);
        });
        if (!updatedColumns.length) return;
        this.updateDisplayedColumns(source);
        if (exists(createEvent) && createEvent) {
            const event = createEvent();
            event.columns = updatedColumns;
            event.column = updatedColumns.length === 1 ? updatedColumns[0] : null;
            this.eventService.dispatchEvent(event);
        }
    }
    getDisplayedColBefore(col) {
        const allDisplayedColumns = this.getAllDisplayedColumns();
        const oldIndex = allDisplayedColumns.indexOf(col);
        if (oldIndex > 0) return allDisplayedColumns[oldIndex - 1];
        return null;
    }
    // used by:
    // + rowRenderer -> for navigation
    getDisplayedColAfter(col) {
        const allDisplayedColumns = this.getAllDisplayedColumns();
        const oldIndex = allDisplayedColumns.indexOf(col);
        if (oldIndex < allDisplayedColumns.length - 1) return allDisplayedColumns[oldIndex + 1];
        return null;
    }
    getDisplayedGroupAtDirection(columnGroup, direction) {
        const requiredLevel = columnGroup.getProvidedColumnGroup().getLevel() + columnGroup.getPaddingLevel();
        const colGroupLeafColumns = columnGroup.getDisplayedLeafColumns();
        const col = direction === "After" ? last(colGroupLeafColumns) : colGroupLeafColumns[0];
        const getDisplayColMethod = `getDisplayedCol${direction}`;
        while(true){
            const column = this[getDisplayColMethod](col);
            if (!column) return null;
            const groupPointer = this.getColumnGroupAtLevel(column, requiredLevel);
            if (groupPointer !== columnGroup) return groupPointer;
        }
    }
    getColumnGroupAtLevel(column, level) {
        let groupPointer = column.getParent();
        let originalGroupLevel;
        let groupPointerLevel;
        while(true){
            const groupPointerProvidedColumnGroup = groupPointer.getProvidedColumnGroup();
            originalGroupLevel = groupPointerProvidedColumnGroup.getLevel();
            groupPointerLevel = groupPointer.getPaddingLevel();
            if (originalGroupLevel + groupPointerLevel <= level) break;
            groupPointer = groupPointer.getParent();
        }
        return groupPointer;
    }
    isPinningLeft() {
        return this.displayedColumnsLeft.length > 0;
    }
    isPinningRight() {
        return this.displayedColumnsRight.length > 0;
    }
    getPrimaryAndSecondaryAndAutoColumns() {
        return [].concat(...[
            this.primaryColumns || [],
            this.groupAutoColumns || [],
            this.secondaryColumns || []
        ]);
    }
    createStateItemFromColumn(column) {
        const rowGroupIndex = column.isRowGroupActive() ? this.rowGroupColumns.indexOf(column) : null;
        const pivotIndex = column.isPivotActive() ? this.pivotColumns.indexOf(column) : null;
        const aggFunc = column.isValueActive() ? column.getAggFunc() : null;
        const sort = column.getSort() != null ? column.getSort() : null;
        const sortIndex = column.getSortIndex() != null ? column.getSortIndex() : null;
        const flex = column.getFlex() != null && column.getFlex() > 0 ? column.getFlex() : null;
        const res = {
            colId: column.getColId(),
            width: column.getActualWidth(),
            hide: !column.isVisible(),
            pinned: column.getPinned(),
            sort,
            sortIndex,
            aggFunc,
            rowGroup: column.isRowGroupActive(),
            rowGroupIndex,
            pivot: column.isPivotActive(),
            pivotIndex,
            flex
        };
        return res;
    }
    getColumnState() {
        if (missing(this.primaryColumns) || !this.isAlive()) return [];
        const colsForState = this.getPrimaryAndSecondaryAndAutoColumns();
        const res = colsForState.map(this.createStateItemFromColumn.bind(this));
        this.orderColumnStateList(res);
        return res;
    }
    orderColumnStateList(columnStateList) {
        const colIdToGridIndexMap = convertToMap(this.gridColumns.map((col, index)=>[
                col.getColId(),
                index
            ]));
        columnStateList.sort((itemA, itemB)=>{
            const posA = colIdToGridIndexMap.has(itemA.colId) ? colIdToGridIndexMap.get(itemA.colId) : -1;
            const posB = colIdToGridIndexMap.has(itemB.colId) ? colIdToGridIndexMap.get(itemB.colId) : -1;
            return posA - posB;
        });
    }
    resetColumnState(source) {
        if (missingOrEmpty(this.primaryColumns)) return;
        const primaryColumns = this.getColumnsFromTree(this.primaryColumnTree);
        const columnStates = [];
        let letRowGroupIndex = 1e3;
        let letPivotIndex = 1e3;
        let colsToProcess = [];
        if (this.groupAutoColumns) colsToProcess = colsToProcess.concat(this.groupAutoColumns);
        if (primaryColumns) colsToProcess = colsToProcess.concat(primaryColumns);
        colsToProcess.forEach((column)=>{
            const stateItem = this.getColumnStateFromColDef(column);
            if (missing(stateItem.rowGroupIndex) && stateItem.rowGroup) stateItem.rowGroupIndex = letRowGroupIndex++;
            if (missing(stateItem.pivotIndex) && stateItem.pivot) stateItem.pivotIndex = letPivotIndex++;
            columnStates.push(stateItem);
        });
        this.applyColumnState({
            state: columnStates,
            applyOrder: true
        }, source);
    }
    getColumnStateFromColDef(column) {
        const getValueOrNull = (a, b)=>a != null ? a : b != null ? b : null;
        const colDef = column.getColDef();
        const sort = getValueOrNull(colDef.sort, colDef.initialSort);
        const sortIndex = getValueOrNull(colDef.sortIndex, colDef.initialSortIndex);
        const hide = getValueOrNull(colDef.hide, colDef.initialHide);
        const pinned = getValueOrNull(colDef.pinned, colDef.initialPinned);
        const width = getValueOrNull(colDef.width, colDef.initialWidth);
        const flex = getValueOrNull(colDef.flex, colDef.initialFlex);
        let rowGroupIndex = getValueOrNull(colDef.rowGroupIndex, colDef.initialRowGroupIndex);
        let rowGroup = getValueOrNull(colDef.rowGroup, colDef.initialRowGroup);
        if (rowGroupIndex == null && (rowGroup == null || rowGroup == false)) {
            rowGroupIndex = null;
            rowGroup = null;
        }
        let pivotIndex = getValueOrNull(colDef.pivotIndex, colDef.initialPivotIndex);
        let pivot = getValueOrNull(colDef.pivot, colDef.initialPivot);
        if (pivotIndex == null && (pivot == null || pivot == false)) {
            pivotIndex = null;
            pivot = null;
        }
        const aggFunc = getValueOrNull(colDef.aggFunc, colDef.initialAggFunc);
        return {
            colId: column.getColId(),
            sort,
            sortIndex,
            hide,
            pinned,
            width,
            flex,
            rowGroup,
            rowGroupIndex,
            pivot,
            pivotIndex,
            aggFunc
        };
    }
    applyColumnState(params, source) {
        if (missingOrEmpty(this.primaryColumns)) return false;
        if (params && params.state && !params.state.forEach) {
            console.warn("AG Grid: applyColumnState() - the state attribute should be an array, however an array was not found. Please provide an array of items (one for each col you want to change) for state.");
            return false;
        }
        const applyStates = (states, existingColumns, getById)=>{
            const dispatchEventsFunc = this.compareColumnStatesAndDispatchEvents(source);
            this.autoGroupsNeedBuilding = true;
            const columnsWithNoState = existingColumns.slice();
            const rowGroupIndexes = {};
            const pivotIndexes = {};
            const autoGroupColumnStates = [];
            const unmatchedAndAutoStates2 = [];
            let unmatchedCount2 = 0;
            const previousRowGroupCols = this.rowGroupColumns.slice();
            const previousPivotCols = this.pivotColumns.slice();
            states.forEach((state)=>{
                const colId = state.colId || "";
                const isAutoGroupColumn = colId.startsWith(GROUP_AUTO_COLUMN_ID);
                if (isAutoGroupColumn) {
                    autoGroupColumnStates.push(state);
                    unmatchedAndAutoStates2.push(state);
                    return;
                }
                const column = getById(colId);
                if (!column) {
                    unmatchedAndAutoStates2.push(state);
                    unmatchedCount2 += 1;
                } else {
                    this.syncColumnWithStateItem(column, state, params.defaultState, rowGroupIndexes, pivotIndexes, false, source);
                    removeFromArray(columnsWithNoState, column);
                }
            });
            const applyDefaultsFunc = (col)=>this.syncColumnWithStateItem(col, null, params.defaultState, rowGroupIndexes, pivotIndexes, false, source);
            columnsWithNoState.forEach(applyDefaultsFunc);
            const comparator = (indexes, oldList, colA, colB)=>{
                const indexA = indexes[colA.getId()];
                const indexB = indexes[colB.getId()];
                const aHasIndex = indexA != null;
                const bHasIndex = indexB != null;
                if (aHasIndex && bHasIndex) return indexA - indexB;
                if (aHasIndex) return -1;
                if (bHasIndex) return 1;
                const oldIndexA = oldList.indexOf(colA);
                const oldIndexB = oldList.indexOf(colB);
                const aHasOldIndex = oldIndexA >= 0;
                const bHasOldIndex = oldIndexB >= 0;
                if (aHasOldIndex && bHasOldIndex) return oldIndexA - oldIndexB;
                if (aHasOldIndex) return -1;
                return 1;
            };
            this.rowGroupColumns.sort(comparator.bind(this, rowGroupIndexes, previousRowGroupCols));
            this.pivotColumns.sort(comparator.bind(this, pivotIndexes, previousPivotCols));
            this.updateGridColumns();
            const autoGroupColsCopy = this.groupAutoColumns ? this.groupAutoColumns.slice() : [];
            autoGroupColumnStates.forEach((stateItem)=>{
                const autoCol = this.getAutoColumn(stateItem.colId);
                removeFromArray(autoGroupColsCopy, autoCol);
                this.syncColumnWithStateItem(autoCol, stateItem, params.defaultState, null, null, true, source);
            });
            autoGroupColsCopy.forEach(applyDefaultsFunc);
            this.applyOrderAfterApplyState(params);
            this.updateDisplayedColumns(source);
            this.dispatchEverythingChanged(source);
            dispatchEventsFunc();
            return {
                unmatchedAndAutoStates: unmatchedAndAutoStates2,
                unmatchedCount: unmatchedCount2
            };
        };
        this.columnAnimationService.start();
        let { unmatchedAndAutoStates, unmatchedCount } = applyStates(params.state || [], this.primaryColumns || [], (id)=>this.getPrimaryColumn(id));
        if (unmatchedAndAutoStates.length > 0 || exists(params.defaultState)) unmatchedCount = applyStates(unmatchedAndAutoStates, this.secondaryColumns || [], (id)=>this.getSecondaryColumn(id)).unmatchedCount;
        this.columnAnimationService.finish();
        return unmatchedCount === 0;
    }
    applyOrderAfterApplyState(params) {
        if (!params.applyOrder || !params.state) return;
        let newOrder = [];
        const processedColIds = {};
        params.state.forEach((item)=>{
            if (!item.colId || processedColIds[item.colId]) return;
            const col = this.gridColumnsMap[item.colId];
            if (col) {
                newOrder.push(col);
                processedColIds[item.colId] = true;
            }
        });
        let autoGroupInsertIndex = 0;
        this.gridColumns.forEach((col)=>{
            const colId = col.getColId();
            const alreadyProcessed = processedColIds[colId] != null;
            if (alreadyProcessed) return;
            const isAutoGroupCol = colId.startsWith(GROUP_AUTO_COLUMN_ID);
            if (isAutoGroupCol) insertIntoArray(newOrder, col, autoGroupInsertIndex++);
            else newOrder.push(col);
        });
        newOrder = this.placeLockedColumns(newOrder);
        if (!this.doesMovePassMarryChildren(newOrder)) {
            console.warn("AG Grid: Applying column order broke a group where columns should be married together. Applying new order has been discarded.");
            return;
        }
        this.gridColumns = newOrder;
    }
    compareColumnStatesAndDispatchEvents(source) {
        const startState = {
            rowGroupColumns: this.rowGroupColumns.slice(),
            pivotColumns: this.pivotColumns.slice(),
            valueColumns: this.valueColumns.slice()
        };
        const columnStateBefore = this.getColumnState();
        const columnStateBeforeMap = {};
        columnStateBefore.forEach((col)=>{
            columnStateBeforeMap[col.colId] = col;
        });
        return ()=>{
            const colsForState = this.getPrimaryAndSecondaryAndAutoColumns();
            const dispatchWhenListsDifferent = (eventType, colsBefore, colsAfter, idMapper)=>{
                const beforeList = colsBefore.map(idMapper);
                const afterList = colsAfter.map(idMapper);
                const unchanged = areEqual(beforeList, afterList);
                if (unchanged) return;
                const changes = new Set(colsBefore);
                colsAfter.forEach((id)=>{
                    if (!changes.delete(id)) changes.add(id);
                });
                const changesArr = [
                    ...changes
                ];
                const event = {
                    type: eventType,
                    columns: changesArr,
                    column: changesArr.length === 1 ? changesArr[0] : null,
                    source
                };
                this.eventService.dispatchEvent(event);
            };
            const getChangedColumns = (changedPredicate)=>{
                const changedColumns2 = [];
                colsForState.forEach((column)=>{
                    const colStateBefore = columnStateBeforeMap[column.getColId()];
                    if (colStateBefore && changedPredicate(colStateBefore, column)) changedColumns2.push(column);
                });
                return changedColumns2;
            };
            const columnIdMapper = (c)=>c.getColId();
            dispatchWhenListsDifferent(Events.EVENT_COLUMN_ROW_GROUP_CHANGED, startState.rowGroupColumns, this.rowGroupColumns, columnIdMapper);
            dispatchWhenListsDifferent(Events.EVENT_COLUMN_PIVOT_CHANGED, startState.pivotColumns, this.pivotColumns, columnIdMapper);
            const valueChangePredicate = (cs, c)=>{
                const oldActive = cs.aggFunc != null;
                const activeChanged = oldActive != c.isValueActive();
                const aggFuncChanged = oldActive && cs.aggFunc != c.getAggFunc();
                return activeChanged || aggFuncChanged;
            };
            const changedValues = getChangedColumns(valueChangePredicate);
            if (changedValues.length > 0) this.dispatchColumnChangedEvent(Events.EVENT_COLUMN_VALUE_CHANGED, changedValues, source);
            const resizeChangePredicate = (cs, c)=>cs.width != c.getActualWidth();
            this.dispatchColumnResizedEvent(getChangedColumns(resizeChangePredicate), true, source);
            const pinnedChangePredicate = (cs, c)=>cs.pinned != c.getPinned();
            this.dispatchColumnPinnedEvent(getChangedColumns(pinnedChangePredicate), source);
            const visibilityChangePredicate = (cs, c)=>cs.hide == c.isVisible();
            this.dispatchColumnVisibleEvent(getChangedColumns(visibilityChangePredicate), source);
            const sortChangePredicate = (cs, c)=>cs.sort != c.getSort() || cs.sortIndex != c.getSortIndex();
            const changedColumns = getChangedColumns(sortChangePredicate);
            if (changedColumns.length > 0) this.sortController.dispatchSortChangedEvents(source, changedColumns);
            this.normaliseColumnMovedEventForColumnState(columnStateBefore, source);
        };
    }
    getCommonValue(cols, valueGetter) {
        if (!cols || cols.length == 0) return void 0;
        const firstValue = valueGetter(cols[0]);
        for(let i = 1; i < cols.length; i++){
            if (firstValue !== valueGetter(cols[i])) return void 0;
        }
        return firstValue;
    }
    normaliseColumnMovedEventForColumnState(colStateBefore, source) {
        const colStateAfter = this.getColumnState();
        const colStateAfterMapped = {};
        colStateAfter.forEach((s)=>colStateAfterMapped[s.colId] = s);
        const colsIntersectIds = {};
        colStateBefore.forEach((s)=>{
            if (colStateAfterMapped[s.colId]) colsIntersectIds[s.colId] = true;
        });
        const beforeFiltered = colStateBefore.filter((c)=>colsIntersectIds[c.colId]);
        const afterFiltered = colStateAfter.filter((c)=>colsIntersectIds[c.colId]);
        const movedColumns = [];
        afterFiltered.forEach((csAfter, index)=>{
            const csBefore = beforeFiltered && beforeFiltered[index];
            if (csBefore && csBefore.colId !== csAfter.colId) {
                const gridCol = this.getGridColumn(csBefore.colId);
                if (gridCol) movedColumns.push(gridCol);
            }
        });
        if (!movedColumns.length) return;
        this.dispatchColumnMovedEvent({
            movedColumns,
            source,
            finished: true
        });
    }
    syncColumnWithStateItem(column, stateItem, defaultState, rowGroupIndexes, pivotIndexes, autoCol, source) {
        var _a;
        if (!column) return;
        const getValue = (key1, key2)=>{
            const obj = {
                value1: void 0,
                value2: void 0
            };
            let calculated = false;
            if (stateItem) {
                if (stateItem[key1] !== void 0) {
                    obj.value1 = stateItem[key1];
                    calculated = true;
                }
                if (exists(key2) && stateItem[key2] !== void 0) {
                    obj.value2 = stateItem[key2];
                    calculated = true;
                }
            }
            if (!calculated && defaultState) {
                if (defaultState[key1] !== void 0) obj.value1 = defaultState[key1];
                if (exists(key2) && defaultState[key2] !== void 0) obj.value2 = defaultState[key2];
            }
            return obj;
        };
        const hide = getValue("hide").value1;
        if (hide !== void 0) column.setVisible(!hide, source);
        const pinned = getValue("pinned").value1;
        if (pinned !== void 0) column.setPinned(pinned);
        const minColWidth = (_a = column.getColDef().minWidth) != null ? _a : this.environment.getMinColWidth();
        const flex = getValue("flex").value1;
        if (flex !== void 0) column.setFlex(flex);
        if (flex == null) {
            const width = getValue("width").value1;
            if (width != null) {
                if (minColWidth != null && width >= minColWidth) column.setActualWidth(width, source);
            }
        }
        const sort = getValue("sort").value1;
        if (sort !== void 0) {
            if (sort === "desc" || sort === "asc") column.setSort(sort, source);
            else column.setSort(void 0, source);
        }
        const sortIndex = getValue("sortIndex").value1;
        if (sortIndex !== void 0) column.setSortIndex(sortIndex);
        if (autoCol || !column.isPrimary()) return;
        const aggFunc = getValue("aggFunc").value1;
        if (aggFunc !== void 0) {
            if (typeof aggFunc === "string") {
                column.setAggFunc(aggFunc);
                if (!column.isValueActive()) {
                    column.setValueActive(true, source);
                    this.valueColumns.push(column);
                }
            } else {
                if (exists(aggFunc)) console.warn("AG Grid: stateItem.aggFunc must be a string. if using your own aggregation functions, register the functions first before using them in get/set state. This is because it is intended for the column state to be stored and retrieved as simple JSON.");
                if (column.isValueActive()) {
                    column.setValueActive(false, source);
                    removeFromArray(this.valueColumns, column);
                }
            }
        }
        const { value1: rowGroup, value2: rowGroupIndex } = getValue("rowGroup", "rowGroupIndex");
        if (rowGroup !== void 0 || rowGroupIndex !== void 0) {
            if (typeof rowGroupIndex === "number" || rowGroup) {
                if (!column.isRowGroupActive()) {
                    column.setRowGroupActive(true, source);
                    this.rowGroupColumns.push(column);
                }
                if (rowGroupIndexes && typeof rowGroupIndex === "number") rowGroupIndexes[column.getId()] = rowGroupIndex;
            } else if (column.isRowGroupActive()) {
                column.setRowGroupActive(false, source);
                removeFromArray(this.rowGroupColumns, column);
            }
        }
        const { value1: pivot, value2: pivotIndex } = getValue("pivot", "pivotIndex");
        if (pivot !== void 0 || pivotIndex !== void 0) {
            if (typeof pivotIndex === "number" || pivot) {
                if (!column.isPivotActive()) {
                    column.setPivotActive(true, source);
                    this.pivotColumns.push(column);
                }
                if (pivotIndexes && typeof pivotIndex === "number") pivotIndexes[column.getId()] = pivotIndex;
            } else if (column.isPivotActive()) {
                column.setPivotActive(false, source);
                removeFromArray(this.pivotColumns, column);
            }
        }
    }
    getGridColumns(keys2) {
        return this.getColumns(keys2, this.getGridColumn.bind(this));
    }
    getColumns(keys2, columnLookupCallback) {
        const foundColumns = [];
        if (keys2) keys2.forEach((key)=>{
            const column = columnLookupCallback(key);
            if (column) foundColumns.push(column);
        });
        return foundColumns;
    }
    // used by growGroupPanel
    getColumnWithValidation(key) {
        if (key == null) return null;
        const column = this.getGridColumn(key);
        if (!column) console.warn("AG Grid: could not find column " + key);
        return column;
    }
    getPrimaryColumn(key) {
        if (!this.primaryColumns) return null;
        return this.getColumn(key, this.primaryColumns, this.primaryColumnsMap);
    }
    getGridColumn(key) {
        return this.getColumn(key, this.gridColumns, this.gridColumnsMap);
    }
    lookupGridColumn(key) {
        return this.gridColumnsMap[key];
    }
    getSecondaryColumn(key) {
        if (!this.secondaryColumns) return null;
        return this.getColumn(key, this.secondaryColumns, this.secondaryColumnsMap);
    }
    getColumn(key, columnList, columnMap) {
        if (!key || !columnMap) return null;
        if (typeof key == "string" && columnMap[key]) return columnMap[key];
        for(let i = 0; i < columnList.length; i++){
            if (this.columnsMatch(columnList[i], key)) return columnList[i];
        }
        return this.getAutoColumn(key);
    }
    getSourceColumnsForGroupColumn(groupCol) {
        const sourceColumnId = groupCol.getColDef().showRowGroup;
        if (!sourceColumnId) return null;
        if (sourceColumnId === true) return this.rowGroupColumns.slice(0);
        const column = this.getPrimaryColumn(sourceColumnId);
        return column ? [
            column
        ] : null;
    }
    getAutoColumn(key) {
        if (!this.groupAutoColumns || !exists(this.groupAutoColumns) || missing(this.groupAutoColumns)) return null;
        return this.groupAutoColumns.find((groupCol)=>this.columnsMatch(groupCol, key)) || null;
    }
    columnsMatch(column, key) {
        const columnMatches = column === key;
        const colDefMatches = column.getColDef() === key;
        const idMatches = column.getColId() == key;
        return columnMatches || colDefMatches || idMatches;
    }
    getDisplayNameForColumn(column, location, includeAggFunc = false) {
        if (!column) return null;
        const headerName = this.getHeaderName(column.getColDef(), column, null, null, location);
        if (includeAggFunc) return this.wrapHeaderNameWithAggFunc(column, headerName);
        return headerName;
    }
    getDisplayNameForProvidedColumnGroup(columnGroup, providedColumnGroup, location) {
        const colGroupDef = providedColumnGroup ? providedColumnGroup.getColGroupDef() : null;
        if (colGroupDef) return this.getHeaderName(colGroupDef, null, columnGroup, providedColumnGroup, location);
        return null;
    }
    getDisplayNameForColumnGroup(columnGroup, location) {
        return this.getDisplayNameForProvidedColumnGroup(columnGroup, columnGroup.getProvidedColumnGroup(), location);
    }
    // location is where the column is going to appear, ie who is calling us
    getHeaderName(colDef, column, columnGroup, providedColumnGroup, location) {
        const headerValueGetter = colDef.headerValueGetter;
        if (headerValueGetter) {
            const params = this.gos.addGridCommonParams({
                colDef,
                column,
                columnGroup,
                providedColumnGroup,
                location
            });
            if (typeof headerValueGetter === "function") return headerValueGetter(params);
            else if (typeof headerValueGetter === "string") return this.expressionService.evaluate(headerValueGetter, params);
            console.warn("AG Grid: headerValueGetter must be a function or a string");
            return "";
        } else if (colDef.headerName != null) return colDef.headerName;
        else if (colDef.field) return camelCaseToHumanText(colDef.field);
        return "";
    }
    wrapHeaderNameWithAggFunc(column, headerName) {
        if (this.gos.get("suppressAggFuncInHeader")) return headerName;
        const pivotValueColumn = column.getColDef().pivotValueColumn;
        const pivotActiveOnThisColumn = exists(pivotValueColumn);
        let aggFunc = null;
        let aggFuncFound;
        if (pivotActiveOnThisColumn) {
            const isCollapsedHeaderEnabled = this.gos.get("removePivotHeaderRowWhenSingleValueColumn") && this.valueColumns.length === 1;
            const isTotalColumn = column.getColDef().pivotTotalColumnIds !== void 0;
            if (isCollapsedHeaderEnabled && !isTotalColumn) return headerName;
            aggFunc = pivotValueColumn ? pivotValueColumn.getAggFunc() : null;
            aggFuncFound = true;
        } else {
            const measureActive = column.isValueActive();
            const aggregationPresent = this.pivotMode || !this.isRowGroupEmpty();
            if (measureActive && aggregationPresent) {
                aggFunc = column.getAggFunc();
                aggFuncFound = true;
            } else aggFuncFound = false;
        }
        if (aggFuncFound) {
            const aggFuncString = typeof aggFunc === "string" ? aggFunc : "func";
            const localeTextFunc = this.localeService.getLocaleTextFunc();
            const aggFuncStringTranslated = localeTextFunc(aggFuncString, aggFuncString);
            return `${aggFuncStringTranslated}(${headerName})`;
        }
        return headerName;
    }
    // returns the group with matching colId and instanceId. If instanceId is missing,
    // matches only on the colId.
    getColumnGroup(colId, partId) {
        if (!colId) return null;
        if (colId instanceof ColumnGroup) return colId;
        const allColumnGroups = this.getAllDisplayedTrees();
        const checkPartId = typeof partId === "number";
        let result = null;
        depthFirstAllColumnTreeSearch(allColumnGroups, false, (child)=>{
            if (child instanceof ColumnGroup) {
                const columnGroup = child;
                let matched;
                if (checkPartId) matched = colId === columnGroup.getGroupId() && partId === columnGroup.getPartId();
                else matched = colId === columnGroup.getGroupId();
                if (matched) result = columnGroup;
            }
        });
        return result;
    }
    isReady() {
        return this.ready;
    }
    extractValueColumns(source, oldPrimaryColumns) {
        this.valueColumns = this.extractColumns(oldPrimaryColumns, this.valueColumns, (col, flag)=>col.setValueActive(flag, source), // aggFunc doesn't have index variant, cos order of value cols doesn't matter, so always return null
        ()=>void 0, ()=>void 0, // aggFunc is a string, so return it's existence
        (colDef)=>{
            const aggFunc = colDef.aggFunc;
            if (aggFunc === null || aggFunc === "") return null;
            if (aggFunc === void 0) return;
            return !!aggFunc;
        }, (colDef)=>{
            return colDef.initialAggFunc != null && colDef.initialAggFunc != "";
        });
        this.valueColumns.forEach((col)=>{
            const colDef = col.getColDef();
            if (colDef.aggFunc != null && colDef.aggFunc != "") col.setAggFunc(colDef.aggFunc);
            else if (!col.getAggFunc()) col.setAggFunc(colDef.initialAggFunc);
        });
    }
    extractRowGroupColumns(source, oldPrimaryColumns) {
        this.rowGroupColumns = this.extractColumns(oldPrimaryColumns, this.rowGroupColumns, (col, flag)=>col.setRowGroupActive(flag, source), (colDef)=>colDef.rowGroupIndex, (colDef)=>colDef.initialRowGroupIndex, (colDef)=>colDef.rowGroup, (colDef)=>colDef.initialRowGroup);
    }
    extractColumns(oldPrimaryColumns = [], previousCols = [], setFlagFunc, getIndexFunc, getInitialIndexFunc, getValueFunc, getInitialValueFunc) {
        const colsWithIndex = [];
        const colsWithValue = [];
        (this.primaryColumns || []).forEach((col)=>{
            const colIsNew = oldPrimaryColumns.indexOf(col) < 0;
            const colDef = col.getColDef();
            const value = attrToBoolean(getValueFunc(colDef));
            const initialValue = attrToBoolean(getInitialValueFunc(colDef));
            const index = attrToNumber(getIndexFunc(colDef));
            const initialIndex = attrToNumber(getInitialIndexFunc(colDef));
            let include;
            const valuePresent = value !== void 0;
            const indexPresent = index !== void 0;
            const initialValuePresent = initialValue !== void 0;
            const initialIndexPresent = initialIndex !== void 0;
            if (valuePresent) include = value;
            else if (indexPresent) {
                if (index === null) include = false;
                else include = index >= 0;
            } else if (colIsNew) {
                if (initialValuePresent) include = initialValue;
                else if (initialIndexPresent) include = initialIndex != null && initialIndex >= 0;
                else include = false;
            } else include = previousCols.indexOf(col) >= 0;
            if (include) {
                const useIndex = colIsNew ? index != null || initialIndex != null : index != null;
                useIndex ? colsWithIndex.push(col) : colsWithValue.push(col);
            }
        });
        const getIndexForCol = (col)=>{
            const index = getIndexFunc(col.getColDef());
            const defaultIndex = getInitialIndexFunc(col.getColDef());
            return index != null ? index : defaultIndex;
        };
        colsWithIndex.sort((colA, colB)=>{
            const indexA = getIndexForCol(colA);
            const indexB = getIndexForCol(colB);
            if (indexA === indexB) return 0;
            if (indexA < indexB) return -1;
            return 1;
        });
        const res = [].concat(colsWithIndex);
        previousCols.forEach((col)=>{
            if (colsWithValue.indexOf(col) >= 0) res.push(col);
        });
        colsWithValue.forEach((col)=>{
            if (res.indexOf(col) < 0) res.push(col);
        });
        previousCols.forEach((col)=>{
            if (res.indexOf(col) < 0) setFlagFunc(col, false);
        });
        res.forEach((col)=>{
            if (previousCols.indexOf(col) < 0) setFlagFunc(col, true);
        });
        return res;
    }
    extractPivotColumns(source, oldPrimaryColumns) {
        this.pivotColumns = this.extractColumns(oldPrimaryColumns, this.pivotColumns, (col, flag)=>col.setPivotActive(flag, source), (colDef)=>colDef.pivotIndex, (colDef)=>colDef.initialPivotIndex, (colDef)=>colDef.pivot, (colDef)=>colDef.initialPivot);
    }
    resetColumnGroupState(source) {
        if (!this.primaryColumnTree) return;
        const stateItems = [];
        depthFirstOriginalTreeSearch(null, this.primaryColumnTree, (child)=>{
            if (child instanceof ProvidedColumnGroup) {
                const colGroupDef = child.getColGroupDef();
                const groupState = {
                    groupId: child.getGroupId(),
                    open: !colGroupDef ? void 0 : colGroupDef.openByDefault
                };
                stateItems.push(groupState);
            }
        });
        this.setColumnGroupState(stateItems, source);
    }
    getColumnGroupState() {
        const columnGroupState = [];
        depthFirstOriginalTreeSearch(null, this.gridBalancedTree, (node)=>{
            if (node instanceof ProvidedColumnGroup) columnGroupState.push({
                groupId: node.getGroupId(),
                open: node.isExpanded()
            });
        });
        return columnGroupState;
    }
    setColumnGroupState(stateItems, source) {
        if (!this.gridBalancedTree) return;
        this.columnAnimationService.start();
        const impactedGroups = [];
        stateItems.forEach((stateItem)=>{
            const groupKey = stateItem.groupId;
            const newValue = stateItem.open;
            const providedColumnGroup = this.getProvidedColumnGroup(groupKey);
            if (!providedColumnGroup) return;
            if (providedColumnGroup.isExpanded() === newValue) return;
            this.logger.log("columnGroupOpened(" + providedColumnGroup.getGroupId() + "," + newValue + ")");
            providedColumnGroup.setExpanded(newValue);
            impactedGroups.push(providedColumnGroup);
        });
        this.updateGroupsAndDisplayedColumns(source);
        this.setFirstRightAndLastLeftPinned(source);
        if (impactedGroups.length) {
            const event = {
                type: Events.EVENT_COLUMN_GROUP_OPENED,
                columnGroup: ProvidedColumnGroup.length === 1 ? impactedGroups[0] : void 0,
                columnGroups: impactedGroups
            };
            this.eventService.dispatchEvent(event);
        }
        this.columnAnimationService.finish();
    }
    // called by headerRenderer - when a header is opened or closed
    setColumnGroupOpened(key, newValue, source) {
        let keyAsString;
        if (key instanceof ProvidedColumnGroup) keyAsString = key.getId();
        else keyAsString = key || "";
        this.setColumnGroupState([
            {
                groupId: keyAsString,
                open: newValue
            }
        ], source);
    }
    getProvidedColumnGroup(key) {
        if (typeof key !== "string") console.error("AG Grid: group key must be a string");
        let res = null;
        depthFirstOriginalTreeSearch(null, this.gridBalancedTree, (node)=>{
            if (node instanceof ProvidedColumnGroup) {
                if (node.getId() === key) res = node;
            }
        });
        return res;
    }
    calculateColumnsForDisplay() {
        let columnsForDisplay;
        if (this.pivotMode && missing(this.secondaryColumns)) columnsForDisplay = this.gridColumns.filter((column)=>{
            const isAutoGroupCol = this.groupAutoColumns && includes(this.groupAutoColumns, column);
            const isValueCol = this.valueColumns && includes(this.valueColumns, column);
            return isAutoGroupCol || isValueCol;
        });
        else columnsForDisplay = this.gridColumns.filter((column)=>{
            const isAutoGroupCol = this.groupAutoColumns && includes(this.groupAutoColumns, column);
            return isAutoGroupCol || column.isVisible();
        });
        return columnsForDisplay;
    }
    checkColSpanActiveInCols(columns) {
        let result = false;
        columns.forEach((col)=>{
            if (exists(col.getColDef().colSpan)) result = true;
        });
        return result;
    }
    calculateColumnsForGroupDisplay() {
        this.groupDisplayColumns = [];
        this.groupDisplayColumnsMap = {};
        const checkFunc = (col)=>{
            const colDef = col.getColDef();
            const underlyingColumn = colDef.showRowGroup;
            if (colDef && exists(underlyingColumn)) {
                this.groupDisplayColumns.push(col);
                if (typeof underlyingColumn === "string") this.groupDisplayColumnsMap[underlyingColumn] = col;
                else if (underlyingColumn === true) this.getRowGroupColumns().forEach((rowGroupCol)=>{
                    this.groupDisplayColumnsMap[rowGroupCol.getId()] = col;
                });
            }
        };
        this.gridColumns.forEach(checkFunc);
    }
    getGroupDisplayColumns() {
        return this.groupDisplayColumns;
    }
    getGroupDisplayColumnForGroup(rowGroupColumnId) {
        return this.groupDisplayColumnsMap[rowGroupColumnId];
    }
    updateDisplayedColumns(source) {
        const columnsForDisplay = this.calculateColumnsForDisplay();
        this.buildDisplayedTrees(columnsForDisplay);
        this.updateGroupsAndDisplayedColumns(source);
        this.setFirstRightAndLastLeftPinned(source);
    }
    isSecondaryColumnsPresent() {
        return exists(this.secondaryColumns);
    }
    setSecondaryColumns(colDefs, source) {
        if (!this.gridColumns) return;
        const newColsPresent = colDefs;
        if (!newColsPresent && missing(this.secondaryColumns)) return;
        if (newColsPresent) {
            this.processSecondaryColumnDefinitions(colDefs);
            const balancedTreeResult = this.columnFactory.createColumnTree(colDefs, false, this.secondaryBalancedTree || this.previousSecondaryColumns || void 0, source);
            this.destroyOldColumns(this.secondaryBalancedTree, balancedTreeResult.columnTree);
            this.secondaryBalancedTree = balancedTreeResult.columnTree;
            this.secondaryHeaderRowCount = balancedTreeResult.treeDept + 1;
            this.secondaryColumns = this.getColumnsFromTree(this.secondaryBalancedTree);
            this.secondaryColumnsMap = {};
            this.secondaryColumns.forEach((col)=>this.secondaryColumnsMap[col.getId()] = col);
            this.previousSecondaryColumns = null;
        } else {
            this.previousSecondaryColumns = this.secondaryBalancedTree;
            this.secondaryBalancedTree = null;
            this.secondaryHeaderRowCount = -1;
            this.secondaryColumns = null;
            this.secondaryColumnsMap = {};
        }
        this.updateGridColumns();
        this.updateDisplayedColumns(source);
    }
    processSecondaryColumnDefinitions(colDefs) {
        const columnCallback = this.gos.get("processPivotResultColDef");
        const groupCallback = this.gos.get("processPivotResultColGroupDef");
        if (!columnCallback && !groupCallback) return void 0;
        const searchForColDefs = (colDefs2)=>{
            colDefs2.forEach((abstractColDef)=>{
                const isGroup = exists(abstractColDef.children);
                if (isGroup) {
                    const colGroupDef = abstractColDef;
                    if (groupCallback) groupCallback(colGroupDef);
                    searchForColDefs(colGroupDef.children);
                } else {
                    const colDef = abstractColDef;
                    if (columnCallback) columnCallback(colDef);
                }
            });
        };
        if (colDefs) searchForColDefs(colDefs);
    }
    // called from: applyColumnState, setColumnDefs, setSecondaryColumns
    updateGridColumns() {
        const prevGridCols = this.gridBalancedTree;
        if (this.gridColsArePrimary) this.lastPrimaryOrder = this.gridColumns;
        else this.lastSecondaryOrder = this.gridColumns;
        const areAutoColsChanged = this.createGroupAutoColumnsIfNeeded();
        if (areAutoColsChanged) {
            const groupAutoColsMap = convertToMap(this.groupAutoColumns.map((col)=>[
                    col,
                    true
                ]));
            if (this.lastPrimaryOrder) {
                this.lastPrimaryOrder = this.lastPrimaryOrder.filter((col)=>!groupAutoColsMap.has(col));
                this.lastPrimaryOrder = [
                    ...this.groupAutoColumns,
                    ...this.lastPrimaryOrder
                ];
            }
            if (this.lastSecondaryOrder) {
                this.lastSecondaryOrder = this.lastSecondaryOrder.filter((col)=>!groupAutoColsMap.has(col));
                this.lastSecondaryOrder = [
                    ...this.groupAutoColumns,
                    ...this.lastSecondaryOrder
                ];
            }
        }
        let sortOrderToRecover;
        if (this.secondaryColumns && this.secondaryBalancedTree) {
            const hasSameColumns = this.secondaryColumns.some((col)=>{
                return this.gridColumnsMap[col.getColId()] !== void 0;
            });
            this.gridBalancedTree = this.secondaryBalancedTree.slice();
            this.gridHeaderRowCount = this.secondaryHeaderRowCount;
            this.gridColumns = this.secondaryColumns.slice();
            this.gridColsArePrimary = false;
            if (hasSameColumns) sortOrderToRecover = this.lastSecondaryOrder;
        } else if (this.primaryColumns) {
            this.gridBalancedTree = this.primaryColumnTree.slice();
            this.gridHeaderRowCount = this.primaryHeaderRowCount;
            this.gridColumns = this.primaryColumns.slice();
            this.gridColsArePrimary = true;
            sortOrderToRecover = this.lastPrimaryOrder;
        }
        this.addAutoGroupToGridColumns();
        this.orderGridColsLike(sortOrderToRecover);
        this.gridColumns = this.placeLockedColumns(this.gridColumns);
        this.calculateColumnsForGroupDisplay();
        this.refreshQuickFilterColumns();
        this.clearDisplayedAndViewportColumns();
        this.colSpanActive = this.checkColSpanActiveInCols(this.gridColumns);
        this.gridColumnsMap = {};
        this.gridColumns.forEach((col)=>this.gridColumnsMap[col.getId()] = col);
        this.setAutoHeightActive();
        if (!areEqual(prevGridCols, this.gridBalancedTree)) {
            const event = {
                type: Events.EVENT_GRID_COLUMNS_CHANGED
            };
            this.eventService.dispatchEvent(event);
        }
    }
    setAutoHeightActive() {
        this.autoHeightActive = this.gridColumns.filter((col)=>col.isAutoHeight()).length > 0;
        if (this.autoHeightActive) {
            this.autoHeightActiveAtLeastOnce = true;
            const supportedRowModel = this.gos.isRowModelType("clientSide") || this.gos.isRowModelType("serverSide");
            if (!supportedRowModel) warnOnce("autoHeight columns only work with Client Side Row Model and Server Side Row Model.");
        }
    }
    orderGridColsLike(colsOrder) {
        if (missing(colsOrder)) return;
        const lastOrderMapped = convertToMap(colsOrder.map((col, index)=>[
                col,
                index
            ]));
        let noColsFound = true;
        this.gridColumns.forEach((col)=>{
            if (lastOrderMapped.has(col)) noColsFound = false;
        });
        if (noColsFound) return;
        const gridColsMap = convertToMap(this.gridColumns.map((col)=>[
                col,
                true
            ]));
        const oldColsOrdered = colsOrder.filter((col)=>gridColsMap.has(col));
        const oldColsMap = convertToMap(oldColsOrdered.map((col)=>[
                col,
                true
            ]));
        const newColsOrdered = this.gridColumns.filter((col)=>!oldColsMap.has(col));
        const newGridColumns = oldColsOrdered.slice();
        newColsOrdered.forEach((newCol)=>{
            let parent = newCol.getOriginalParent();
            if (!parent) {
                newGridColumns.push(newCol);
                return;
            }
            const siblings = [];
            while(!siblings.length && parent){
                const leafCols = parent.getLeafColumns();
                leafCols.forEach((leafCol)=>{
                    const presentInNewGriColumns = newGridColumns.indexOf(leafCol) >= 0;
                    const noYetInSiblings = siblings.indexOf(leafCol) < 0;
                    if (presentInNewGriColumns && noYetInSiblings) siblings.push(leafCol);
                });
                parent = parent.getOriginalParent();
            }
            if (!siblings.length) {
                newGridColumns.push(newCol);
                return;
            }
            const indexes = siblings.map((col)=>newGridColumns.indexOf(col));
            const lastIndex = Math.max(...indexes);
            insertIntoArray(newGridColumns, newCol, lastIndex + 1);
        });
        this.gridColumns = newGridColumns;
    }
    isPrimaryColumnGroupsPresent() {
        return this.primaryHeaderRowCount > 1;
    }
    // if we are using autoGroupCols, then they should be included for quick filter. this covers the
    // following scenarios:
    // a) user provides 'field' into autoGroupCol of normal grid, so now because a valid col to filter leafs on
    // b) using tree data and user depends on autoGroupCol for first col, and we also want to filter on this
    //    (tree data is a bit different, as parent rows can be filtered on, unlike row grouping)
    refreshQuickFilterColumns() {
        var _a;
        let columnsForQuickFilter = (_a = this.isPivotMode() && !this.gos.get("applyQuickFilterBeforePivotOrAgg") ? this.secondaryColumns : this.primaryColumns) != null ? _a : [];
        if (this.groupAutoColumns) columnsForQuickFilter = columnsForQuickFilter.concat(this.groupAutoColumns);
        this.columnsForQuickFilter = this.gos.get("includeHiddenColumnsInQuickFilter") ? columnsForQuickFilter : columnsForQuickFilter.filter((col)=>col.isVisible() || col.isRowGroupActive());
    }
    placeLockedColumns(cols) {
        const left = [];
        const normal = [];
        const right = [];
        cols.forEach((col)=>{
            const position = col.getColDef().lockPosition;
            if (position === "right") right.push(col);
            else if (position === "left" || position === true) left.push(col);
            else normal.push(col);
        });
        return [
            ...left,
            ...normal,
            ...right
        ];
    }
    addAutoGroupToGridColumns() {
        if (missing(this.groupAutoColumns)) {
            this.destroyOldColumns(this.groupAutoColsBalancedTree);
            this.groupAutoColsBalancedTree = null;
            return;
        }
        this.gridColumns = this.groupAutoColumns ? this.groupAutoColumns.concat(this.gridColumns) : this.gridColumns;
        const newAutoColsTree = this.columnFactory.createForAutoGroups(this.groupAutoColumns, this.gridBalancedTree);
        this.destroyOldColumns(this.groupAutoColsBalancedTree, newAutoColsTree);
        this.groupAutoColsBalancedTree = newAutoColsTree;
        this.gridBalancedTree = newAutoColsTree.concat(this.gridBalancedTree);
    }
    // gets called after we copy down grid columns, to make sure any part of the gui
    // that tries to draw, eg the header, it will get empty lists of columns rather
    // than stale columns. for example, the header will received gridColumnsChanged
    // event, so will try and draw, but it will draw successfully when it acts on the
    // virtualColumnsChanged event
    clearDisplayedAndViewportColumns() {
        this.viewportRowLeft = {};
        this.viewportRowRight = {};
        this.viewportRowCenter = {};
        this.displayedColumnsLeft = [];
        this.displayedColumnsRight = [];
        this.displayedColumnsCenter = [];
        this.displayedColumns = [];
        this.ariaOrderColumns = [];
        this.viewportColumns = [];
        this.headerViewportColumns = [];
        this.viewportColumnsHash = "";
    }
    updateGroupsAndDisplayedColumns(source) {
        this.updateOpenClosedVisibilityInColumnGroups();
        this.deriveDisplayedColumns(source);
        this.refreshFlexedColumns();
        this.extractViewport();
        this.updateBodyWidths();
        const event = {
            type: Events.EVENT_DISPLAYED_COLUMNS_CHANGED
        };
        this.eventService.dispatchEvent(event);
    }
    deriveDisplayedColumns(source) {
        this.derivedDisplayedColumnsFromDisplayedTree(this.displayedTreeLeft, this.displayedColumnsLeft);
        this.derivedDisplayedColumnsFromDisplayedTree(this.displayedTreeCentre, this.displayedColumnsCenter);
        this.derivedDisplayedColumnsFromDisplayedTree(this.displayedTreeRight, this.displayedColumnsRight);
        this.joinColumnsAriaOrder();
        this.joinDisplayedColumns();
        this.setLeftValues(source);
        this.displayedAutoHeightCols = this.displayedColumns.filter((col)=>col.isAutoHeight());
    }
    isAutoRowHeightActive() {
        return this.autoHeightActive;
    }
    wasAutoRowHeightEverActive() {
        return this.autoHeightActiveAtLeastOnce;
    }
    joinColumnsAriaOrder() {
        const allColumns = this.getAllGridColumns();
        const pinnedLeft = [];
        const center = [];
        const pinnedRight = [];
        for (const col of allColumns){
            const pinned = col.getPinned();
            if (!pinned) center.push(col);
            else if (pinned === true || pinned === "left") pinnedLeft.push(col);
            else pinnedRight.push(col);
        }
        this.ariaOrderColumns = pinnedLeft.concat(center).concat(pinnedRight);
    }
    joinDisplayedColumns() {
        if (this.gos.get("enableRtl")) this.displayedColumns = this.displayedColumnsRight.concat(this.displayedColumnsCenter).concat(this.displayedColumnsLeft);
        else this.displayedColumns = this.displayedColumnsLeft.concat(this.displayedColumnsCenter).concat(this.displayedColumnsRight);
    }
    // sets the left pixel position of each column
    setLeftValues(source) {
        this.setLeftValuesOfColumns(source);
        this.setLeftValuesOfGroups();
    }
    setLeftValuesOfColumns(source) {
        if (!this.primaryColumns) return;
        const allColumns = this.getPrimaryAndSecondaryAndAutoColumns().slice(0);
        const doingRtl = this.gos.get("enableRtl");
        [
            this.displayedColumnsLeft,
            this.displayedColumnsRight,
            this.displayedColumnsCenter
        ].forEach((columns)=>{
            if (doingRtl) {
                let left = this.getWidthOfColsInList(columns);
                columns.forEach((column)=>{
                    left -= column.getActualWidth();
                    column.setLeft(left, source);
                });
            } else {
                let left = 0;
                columns.forEach((column)=>{
                    column.setLeft(left, source);
                    left += column.getActualWidth();
                });
            }
            removeAllFromUnorderedArray(allColumns, columns);
        });
        allColumns.forEach((column)=>{
            column.setLeft(null, source);
        });
    }
    setLeftValuesOfGroups() {
        [
            this.displayedTreeLeft,
            this.displayedTreeRight,
            this.displayedTreeCentre
        ].forEach((columns)=>{
            columns.forEach((column)=>{
                if (column instanceof ColumnGroup) {
                    const columnGroup = column;
                    columnGroup.checkLeft();
                }
            });
        });
    }
    derivedDisplayedColumnsFromDisplayedTree(tree, columns) {
        columns.length = 0;
        depthFirstAllColumnTreeSearch(tree, true, (child)=>{
            if (child instanceof Column) columns.push(child);
        });
    }
    isColumnVirtualisationSuppressed() {
        return this.suppressColumnVirtualisation || this.viewportRight === 0;
    }
    extractViewportColumns() {
        if (this.isColumnVirtualisationSuppressed()) {
            this.viewportColumnsCenter = this.displayedColumnsCenter;
            this.headerViewportColumnsCenter = this.displayedColumnsCenter;
        } else {
            this.viewportColumnsCenter = this.displayedColumnsCenter.filter(this.isColumnInRowViewport.bind(this));
            this.headerViewportColumnsCenter = this.displayedColumnsCenter.filter(this.isColumnInHeaderViewport.bind(this));
        }
        this.viewportColumns = this.viewportColumnsCenter.concat(this.displayedColumnsLeft).concat(this.displayedColumnsRight);
        this.headerViewportColumns = this.headerViewportColumnsCenter.concat(this.displayedColumnsLeft).concat(this.displayedColumnsRight);
    }
    getVirtualHeaderGroupRow(type, dept) {
        let result;
        switch(type){
            case "left":
                result = this.viewportRowLeft[dept];
                break;
            case "right":
                result = this.viewportRowRight[dept];
                break;
            default:
                result = this.viewportRowCenter[dept];
                break;
        }
        if (missing(result)) result = [];
        return result;
    }
    calculateHeaderRows() {
        this.viewportRowLeft = {};
        this.viewportRowRight = {};
        this.viewportRowCenter = {};
        const virtualColIds = {};
        this.headerViewportColumns.forEach((col)=>virtualColIds[col.getId()] = true);
        const testGroup = (children, result, dept)=>{
            let returnValue = false;
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                let addThisItem = false;
                if (child instanceof Column) addThisItem = virtualColIds[child.getId()] === true;
                else {
                    const columnGroup = child;
                    const displayedChildren = columnGroup.getDisplayedChildren();
                    if (displayedChildren) addThisItem = testGroup(displayedChildren, result, dept + 1);
                }
                if (addThisItem) {
                    returnValue = true;
                    if (!result[dept]) result[dept] = [];
                    result[dept].push(child);
                }
            }
            return returnValue;
        };
        testGroup(this.displayedTreeLeft, this.viewportRowLeft, 0);
        testGroup(this.displayedTreeRight, this.viewportRowRight, 0);
        testGroup(this.displayedTreeCentre, this.viewportRowCenter, 0);
    }
    extractViewport() {
        const hashColumn = (c)=>`${c.getId()}-${c.getPinned() || "normal"}`;
        this.extractViewportColumns();
        const newHash = this.viewportColumns.map(hashColumn).join("#");
        const changed = this.viewportColumnsHash !== newHash;
        if (changed) {
            this.viewportColumnsHash = newHash;
            this.calculateHeaderRows();
        }
        return changed;
    }
    refreshFlexedColumns(params = {}) {
        var _a;
        const source = params.source ? params.source : "flex";
        if (params.viewportWidth != null) this.flexViewportWidth = params.viewportWidth;
        if (!this.flexViewportWidth) return [];
        let flexAfterDisplayIndex = -1;
        if (params.resizingCols) {
            const allResizingCols = new Set(params.resizingCols);
            let displayedCols = this.displayedColumnsCenter;
            for(let i = displayedCols.length - 1; i >= 0; i--)if (allResizingCols.has(displayedCols[i])) {
                flexAfterDisplayIndex = i;
                break;
            }
        }
        let knownColumnsWidth = 0;
        let flexingColumns = [];
        let minimumFlexedWidth = 0;
        let totalFlex = 0;
        for(let i = 0; i < this.displayedColumnsCenter.length; i++){
            const isFlex = this.displayedColumnsCenter[i].getFlex() && i > flexAfterDisplayIndex;
            if (isFlex) {
                flexingColumns.push(this.displayedColumnsCenter[i]);
                totalFlex += this.displayedColumnsCenter[i].getFlex();
                minimumFlexedWidth += (_a = this.displayedColumnsCenter[i].getMinWidth()) != null ? _a : 0;
            } else knownColumnsWidth += this.displayedColumnsCenter[i].getActualWidth();
        }
        if (!flexingColumns.length) return [];
        let changedColumns = [];
        if (knownColumnsWidth + minimumFlexedWidth > this.flexViewportWidth) {
            flexingColumns.forEach((col)=>{
                var _a2;
                return col.setActualWidth((_a2 = col.getMinWidth()) != null ? _a2 : 0, source);
            });
            changedColumns = flexingColumns;
            flexingColumns = [];
        }
        const flexingColumnSizes = [];
        let spaceForFlexingColumns;
        outer: while(true){
            spaceForFlexingColumns = this.flexViewportWidth - knownColumnsWidth;
            const spacePerFlex = spaceForFlexingColumns / totalFlex;
            for(let i = 0; i < flexingColumns.length; i++){
                const col = flexingColumns[i];
                const widthByFlexRule = spacePerFlex * col.getFlex();
                let constrainedWidth = 0;
                const minWidth = col.getMinWidth();
                const maxWidth = col.getMaxWidth();
                if (exists(minWidth) && widthByFlexRule < minWidth) constrainedWidth = minWidth;
                else if (exists(maxWidth) && widthByFlexRule > maxWidth) constrainedWidth = maxWidth;
                if (constrainedWidth) {
                    col.setActualWidth(constrainedWidth, source);
                    removeFromUnorderedArray(flexingColumns, col);
                    totalFlex -= col.getFlex();
                    changedColumns.push(col);
                    knownColumnsWidth += col.getActualWidth();
                    continue outer;
                }
                flexingColumnSizes[i] = Math.round(widthByFlexRule);
            }
            break;
        }
        let remainingSpace = spaceForFlexingColumns;
        flexingColumns.forEach((col, i)=>{
            col.setActualWidth(Math.min(flexingColumnSizes[i], remainingSpace), source);
            changedColumns.push(col);
            remainingSpace -= flexingColumnSizes[i];
        });
        if (!params.skipSetLeft) this.setLeftValues(source);
        if (params.updateBodyWidths) this.updateBodyWidths();
        if (params.fireResizedEvent) this.dispatchColumnResizedEvent(changedColumns, true, source, flexingColumns);
        return flexingColumns;
    }
    // called from api
    sizeColumnsToFit(gridWidth, source = "sizeColumnsToFit", silent, params) {
        var _c, _d, _e, _f, _g;
        if (this.shouldQueueResizeOperations) {
            this.resizeOperationQueue.push(()=>this.sizeColumnsToFit(gridWidth, source, silent, params));
            return;
        }
        const limitsMap = {};
        if (params) (_c = params == null ? void 0 : params.columnLimits) == null || _c.forEach((_a)=>{
            var _b = _a, { key } = _b, dimensions = __objRest(_b, [
                "key"
            ]);
            limitsMap[typeof key === "string" ? key : key.getColId()] = dimensions;
        });
        const allDisplayedColumns = this.getAllDisplayedColumns();
        const doColumnsAlreadyFit = gridWidth === this.getWidthOfColsInList(allDisplayedColumns);
        if (gridWidth <= 0 || !allDisplayedColumns.length || doColumnsAlreadyFit) return;
        const colsToSpread = [];
        const colsToNotSpread = [];
        allDisplayedColumns.forEach((column)=>{
            if (column.getColDef().suppressSizeToFit === true) colsToNotSpread.push(column);
            else colsToSpread.push(column);
        });
        const colsToDispatchEventFor = colsToSpread.slice(0);
        let finishedResizing = false;
        const moveToNotSpread = (column)=>{
            removeFromArray(colsToSpread, column);
            colsToNotSpread.push(column);
        };
        colsToSpread.forEach((column)=>{
            var _a, _b;
            column.resetActualWidth(source);
            const widthOverride = limitsMap == null ? void 0 : limitsMap[column.getId()];
            const minOverride = (_a = widthOverride == null ? void 0 : widthOverride.minWidth) != null ? _a : params == null ? void 0 : params.defaultMinWidth;
            const maxOverride = (_b = widthOverride == null ? void 0 : widthOverride.maxWidth) != null ? _b : params == null ? void 0 : params.defaultMaxWidth;
            const colWidth = column.getActualWidth();
            if (typeof minOverride === "number" && colWidth < minOverride) column.setActualWidth(minOverride, source, true);
            else if (typeof maxOverride === "number" && colWidth > maxOverride) column.setActualWidth(maxOverride, source, true);
        });
        while(!finishedResizing){
            finishedResizing = true;
            const availablePixels = gridWidth - this.getWidthOfColsInList(colsToNotSpread);
            if (availablePixels <= 0) colsToSpread.forEach((column)=>{
                var _a, _b;
                const widthOverride = (_b = (_a = limitsMap == null ? void 0 : limitsMap[column.getId()]) == null ? void 0 : _a.minWidth) != null ? _b : params == null ? void 0 : params.defaultMinWidth;
                if (typeof widthOverride === "number") {
                    column.setActualWidth(widthOverride, source, true);
                    return;
                }
                column.setMinimum(source);
            });
            else {
                const scale = availablePixels / this.getWidthOfColsInList(colsToSpread);
                let pixelsForLastCol = availablePixels;
                for(let i = colsToSpread.length - 1; i >= 0; i--){
                    const column = colsToSpread[i];
                    const widthOverride = limitsMap == null ? void 0 : limitsMap[column.getId()];
                    const minOverride = (_d = widthOverride == null ? void 0 : widthOverride.minWidth) != null ? _d : params == null ? void 0 : params.defaultMinWidth;
                    const maxOverride = (_e = widthOverride == null ? void 0 : widthOverride.maxWidth) != null ? _e : params == null ? void 0 : params.defaultMaxWidth;
                    const colMinWidth = (_f = column.getMinWidth()) != null ? _f : 0;
                    const colMaxWidth = (_g = column.getMaxWidth()) != null ? _g : Number.MAX_VALUE;
                    const minWidth = typeof minOverride === "number" && minOverride > colMinWidth ? minOverride : column.getMinWidth();
                    const maxWidth = typeof maxOverride === "number" && maxOverride < colMaxWidth ? maxOverride : column.getMaxWidth();
                    let newWidth = Math.round(column.getActualWidth() * scale);
                    if (exists(minWidth) && newWidth < minWidth) {
                        newWidth = minWidth;
                        moveToNotSpread(column);
                        finishedResizing = false;
                    } else if (exists(maxWidth) && newWidth > maxWidth) {
                        newWidth = maxWidth;
                        moveToNotSpread(column);
                        finishedResizing = false;
                    } else if (i === 0) newWidth = pixelsForLastCol;
                    column.setActualWidth(newWidth, source, true);
                    pixelsForLastCol -= newWidth;
                }
            }
        }
        colsToDispatchEventFor.forEach((col)=>{
            col.fireColumnWidthChangedEvent(source);
        });
        this.setLeftValues(source);
        this.updateBodyWidths();
        if (silent) return;
        this.dispatchColumnResizedEvent(colsToDispatchEventFor, true, source);
    }
    buildDisplayedTrees(visibleColumns) {
        const leftVisibleColumns = [];
        const rightVisibleColumns = [];
        const centerVisibleColumns = [];
        visibleColumns.forEach((column)=>{
            switch(column.getPinned()){
                case "left":
                    leftVisibleColumns.push(column);
                    break;
                case "right":
                    rightVisibleColumns.push(column);
                    break;
                default:
                    centerVisibleColumns.push(column);
                    break;
            }
        });
        const groupInstanceIdCreator = new GroupInstanceIdCreator();
        this.displayedTreeLeft = this.displayedGroupCreator.createDisplayedGroups(leftVisibleColumns, groupInstanceIdCreator, "left", this.displayedTreeLeft);
        this.displayedTreeRight = this.displayedGroupCreator.createDisplayedGroups(rightVisibleColumns, groupInstanceIdCreator, "right", this.displayedTreeRight);
        this.displayedTreeCentre = this.displayedGroupCreator.createDisplayedGroups(centerVisibleColumns, groupInstanceIdCreator, null, this.displayedTreeCentre);
        this.updateDisplayedMap();
    }
    updateDisplayedMap() {
        this.displayedColumnsAndGroupsMap = {};
        const func = (child)=>{
            this.displayedColumnsAndGroupsMap[child.getUniqueId()] = child;
        };
        depthFirstAllColumnTreeSearch(this.displayedTreeCentre, false, func);
        depthFirstAllColumnTreeSearch(this.displayedTreeLeft, false, func);
        depthFirstAllColumnTreeSearch(this.displayedTreeRight, false, func);
    }
    isDisplayed(item) {
        const fromMap = this.displayedColumnsAndGroupsMap[item.getUniqueId()];
        return fromMap === item;
    }
    updateOpenClosedVisibilityInColumnGroups() {
        const allColumnGroups = this.getAllDisplayedTrees();
        depthFirstAllColumnTreeSearch(allColumnGroups, false, (child)=>{
            if (child instanceof ColumnGroup) child.calculateDisplayedColumns();
        });
    }
    getGroupAutoColumns() {
        return this.groupAutoColumns;
    }
    /**
   * Creates new auto group columns if required
   * @returns whether auto cols have changed
   */ createGroupAutoColumnsIfNeeded() {
        const forceRecreateAutoGroups = this.forceRecreateAutoGroups;
        this.forceRecreateAutoGroups = false;
        if (!this.autoGroupsNeedBuilding) return false;
        this.autoGroupsNeedBuilding = false;
        const groupFullWidthRow = this.gos.isGroupUseEntireRow(this.pivotMode);
        const suppressAutoColumn = this.pivotMode ? this.gos.get("pivotSuppressAutoColumn") : this.isGroupSuppressAutoColumn();
        const groupingActive = this.rowGroupColumns.length > 0 || this.gos.get("treeData");
        const needAutoColumns = groupingActive && !suppressAutoColumn && !groupFullWidthRow;
        if (needAutoColumns) {
            const newAutoGroupCols = this.autoGroupColService.createAutoGroupColumns(this.rowGroupColumns);
            const autoColsDifferent = !this.autoColsEqual(newAutoGroupCols, this.groupAutoColumns);
            if (autoColsDifferent || forceRecreateAutoGroups) {
                this.groupAutoColumns = newAutoGroupCols;
                return true;
            }
        } else this.groupAutoColumns = null;
        return false;
    }
    isGroupSuppressAutoColumn() {
        const groupDisplayType = this.gos.get("groupDisplayType");
        const isCustomRowGroups = groupDisplayType === "custom";
        if (isCustomRowGroups) return true;
        const treeDataDisplayType = this.gos.get("treeDataDisplayType");
        return treeDataDisplayType === "custom";
    }
    autoColsEqual(colsA, colsB) {
        return areEqual(colsA, colsB, (a, b)=>a.getColId() === b.getColId());
    }
    getWidthOfColsInList(columnList) {
        return columnList.reduce((width, col)=>width + col.getActualWidth(), 0);
    }
    getFirstDisplayedColumn() {
        const isRtl = this.gos.get("enableRtl");
        const queryOrder = [
            "getDisplayedLeftColumns",
            "getDisplayedCenterColumns",
            "getDisplayedRightColumns"
        ];
        if (isRtl) queryOrder.reverse();
        for(let i = 0; i < queryOrder.length; i++){
            const container = this[queryOrder[i]]();
            if (container.length) return isRtl ? last(container) : container[0];
        }
        return null;
    }
    setColumnHeaderHeight(col, height) {
        const changed = col.setAutoHeaderHeight(height);
        if (changed) {
            const event = {
                type: Events.EVENT_COLUMN_HEADER_HEIGHT_CHANGED,
                column: col,
                columns: [
                    col
                ],
                source: "autosizeColumnHeaderHeight"
            };
            this.eventService.dispatchEvent(event);
        }
    }
    getColumnGroupHeaderRowHeight() {
        if (this.isPivotMode()) return this.getPivotGroupHeaderHeight();
        return this.getGroupHeaderHeight();
    }
    getColumnHeaderRowHeight() {
        const defaultHeight = this.isPivotMode() ? this.getPivotHeaderHeight() : this.getHeaderHeight();
        const displayedHeights = this.getAllDisplayedColumns().filter((col)=>col.isAutoHeaderHeight()).map((col)=>col.getAutoHeaderHeight() || 0);
        return Math.max(defaultHeight, ...displayedHeights);
    }
    getHeaderHeight() {
        var _a;
        return (_a = this.gos.get("headerHeight")) != null ? _a : this.environment.getFromTheme(25, "headerHeight");
    }
    getFloatingFiltersHeight() {
        var _a;
        return (_a = this.gos.get("floatingFiltersHeight")) != null ? _a : this.getHeaderHeight();
    }
    getGroupHeaderHeight() {
        var _a;
        return (_a = this.gos.get("groupHeaderHeight")) != null ? _a : this.getHeaderHeight();
    }
    getPivotHeaderHeight() {
        var _a;
        return (_a = this.gos.get("pivotHeaderHeight")) != null ? _a : this.getHeaderHeight();
    }
    getPivotGroupHeaderHeight() {
        var _a;
        return (_a = this.gos.get("pivotGroupHeaderHeight")) != null ? _a : this.getGroupHeaderHeight();
    }
    queueResizeOperations() {
        this.shouldQueueResizeOperations = true;
    }
    processResizeOperations() {
        this.shouldQueueResizeOperations = false;
        this.resizeOperationQueue.forEach((resizeOperation)=>resizeOperation());
        this.resizeOperationQueue = [];
    }
    resetColumnDefIntoColumn(column, source) {
        const userColDef = column.getUserProvidedColDef();
        if (!userColDef) return false;
        const newColDef = this.columnFactory.addColumnDefaultAndTypes(userColDef, column.getColId());
        column.setColDef(newColDef, userColDef, source);
        return true;
    }
    isColumnGroupingLocked(column) {
        const groupLockGroupColumns = this.gos.get("groupLockGroupColumns");
        if (!column.isRowGroupActive() || groupLockGroupColumns === 0) return false;
        if (groupLockGroupColumns === -1) return true;
        const colIndex = this.rowGroupColumns.findIndex((groupCol)=>groupCol.getColId() === column.getColId());
        return groupLockGroupColumns > colIndex;
    }
    generateColumnStateForRowGroupAndPivotIndexes(updatedRowGroupColumnState, updatedPivotColumnState) {
        let existingColumnStateUpdates = {};
        const orderColumns = (updatedColumnState, colList, enableProp, initialEnableProp, indexProp, initialIndexProp)=>{
            if (!colList.length || !this.primaryColumns) return [];
            const updatedColIdArray = Object.keys(updatedColumnState);
            const updatedColIds = new Set(updatedColIdArray);
            const newColIds = new Set(updatedColIdArray);
            const allColIds = new Set(colList.map((column)=>{
                const colId = column.getColId();
                newColIds.delete(colId);
                return colId;
            }).concat(updatedColIdArray));
            const colIdsInOriginalOrder = [];
            const originalOrderMap = {};
            let orderIndex = 0;
            for(let i = 0; i < this.primaryColumns.length; i++){
                const colId = this.primaryColumns[i].getColId();
                if (allColIds.has(colId)) {
                    colIdsInOriginalOrder.push(colId);
                    originalOrderMap[colId] = orderIndex++;
                }
            }
            let index = 1e3;
            let hasAddedNewCols = false;
            let lastIndex = 0;
            const processPrecedingNewCols = (colId)=>{
                const originalOrderIndex = originalOrderMap[colId];
                for(let i = lastIndex; i < originalOrderIndex; i++){
                    const newColId = colIdsInOriginalOrder[i];
                    if (newColIds.has(newColId)) {
                        updatedColumnState[newColId][indexProp] = index++;
                        newColIds.delete(newColId);
                    }
                }
                lastIndex = originalOrderIndex;
            };
            colList.forEach((column)=>{
                const colId = column.getColId();
                if (updatedColIds.has(colId)) {
                    processPrecedingNewCols(colId);
                    updatedColumnState[colId][indexProp] = index++;
                } else {
                    const colDef = column.getColDef();
                    const missingIndex = colDef[indexProp] === null || colDef[indexProp] === void 0 && colDef[initialIndexProp] == null;
                    if (missingIndex) {
                        if (!hasAddedNewCols) {
                            const propEnabled = colDef[enableProp] || colDef[enableProp] === void 0 && colDef[initialEnableProp];
                            if (propEnabled) processPrecedingNewCols(colId);
                            else {
                                newColIds.forEach((newColId)=>{
                                    updatedColumnState[newColId][indexProp] = index + originalOrderMap[newColId];
                                });
                                index += colIdsInOriginalOrder.length;
                                hasAddedNewCols = true;
                            }
                        }
                        if (!existingColumnStateUpdates[colId]) existingColumnStateUpdates[colId] = {
                            colId
                        };
                        existingColumnStateUpdates[colId][indexProp] = index++;
                    }
                }
            });
        };
        orderColumns(updatedRowGroupColumnState, this.rowGroupColumns, "rowGroup", "initialRowGroup", "rowGroupIndex", "initialRowGroupIndex");
        orderColumns(updatedPivotColumnState, this.pivotColumns, "pivot", "initialPivot", "pivotIndex", "initialPivotIndex");
        return Object.values(existingColumnStateUpdates);
    }
    onColumnsReady() {
        const autoSizeStrategy = this.gos.get("autoSizeStrategy");
        if (!autoSizeStrategy) return;
        const { type } = autoSizeStrategy;
        setTimeout(()=>{
            if (type === "fitGridWidth") {
                const { columnLimits: propColumnLimits, defaultMinWidth, defaultMaxWidth } = autoSizeStrategy;
                const columnLimits = propColumnLimits == null ? void 0 : propColumnLimits.map(({ colId: key, minWidth, maxWidth })=>({
                        key,
                        minWidth,
                        maxWidth
                    }));
                this.ctrlsService.getGridBodyCtrl().sizeColumnsToFit({
                    defaultMinWidth,
                    defaultMaxWidth,
                    columnLimits
                });
            } else if (type === "fitProvidedWidth") this.sizeColumnsToFit(autoSizeStrategy.width, "sizeColumnsToFit");
        });
    }
    onFirstDataRendered() {
        const autoSizeStrategy = this.gos.get("autoSizeStrategy");
        if ((autoSizeStrategy == null ? void 0 : autoSizeStrategy.type) !== "fitCellContents") return;
        const { colIds: columns, skipHeader } = autoSizeStrategy;
        setTimeout(()=>{
            if (columns) this.autoSizeColumns({
                columns,
                skipHeader,
                source: "autosizeColumns"
            });
            else this.autoSizeAllColumns("autosizeColumns", skipHeader);
        });
    }
};
__decorateClass([
    Autowired("expressionService")
], ColumnModel.prototype, "expressionService", 2);
__decorateClass([
    Autowired("columnFactory")
], ColumnModel.prototype, "columnFactory", 2);
__decorateClass([
    Autowired("displayedGroupCreator")
], ColumnModel.prototype, "displayedGroupCreator", 2);
__decorateClass([
    Autowired("ctrlsService")
], ColumnModel.prototype, "ctrlsService", 2);
__decorateClass([
    Autowired("autoWidthCalculator")
], ColumnModel.prototype, "autoWidthCalculator", 2);
__decorateClass([
    Autowired("columnAnimationService")
], ColumnModel.prototype, "columnAnimationService", 2);
__decorateClass([
    Autowired("autoGroupColService")
], ColumnModel.prototype, "autoGroupColService", 2);
__decorateClass([
    Autowired("valueCache")
], ColumnModel.prototype, "valueCache", 2);
__decorateClass([
    Autowired("animationFrameService")
], ColumnModel.prototype, "animationFrameService", 2);
__decorateClass([
    Autowired("sortController")
], ColumnModel.prototype, "sortController", 2);
__decorateClass([
    Autowired("columnDefFactory")
], ColumnModel.prototype, "columnDefFactory", 2);
__decorateClass([
    Optional("aggFuncService")
], ColumnModel.prototype, "aggFuncService", 2);
__decorateClass([
    PostConstruct
], ColumnModel.prototype, "init", 1);
__decorateClass([
    PreDestroy
], ColumnModel.prototype, "destroyColumns", 1);
__decorateClass([
    __decorateParam(0, Qualifier("loggerFactory"))
], ColumnModel.prototype, "setBeans", 1);
ColumnModel = __decorateClass([
    Bean("columnModel")
], ColumnModel);
function convertSourceType(source) {
    return source === "gridOptionsUpdated" ? "gridOptionsChanged" : source;
}
function depthFirstAllColumnTreeSearch(tree, useDisplayedChildren, callback) {
    if (!tree) return;
    for(let i = 0; i < tree.length; i++){
        const child = tree[i];
        if (child instanceof ColumnGroup) {
            const childTree = useDisplayedChildren ? child.getDisplayedChildren() : child.getChildren();
            depthFirstAllColumnTreeSearch(childTree, useDisplayedChildren, callback);
        }
        callback(child);
    }
}
// community-modules/core/src/columns/displayedGroupCreator.ts
var DisplayedGroupCreator = class extends BeanStub {
    createDisplayedGroups(sortedVisibleColumns, groupInstanceIdCreator, pinned, oldDisplayedGroups) {
        const oldColumnsMapped = this.mapOldGroupsById(oldDisplayedGroups);
        const topLevelResultCols = [];
        let groupsOrColsAtCurrentLevel = sortedVisibleColumns;
        while(groupsOrColsAtCurrentLevel.length){
            const currentlyIterating = groupsOrColsAtCurrentLevel;
            groupsOrColsAtCurrentLevel = [];
            let lastGroupedColIdx = 0;
            const createGroupToIndex = (to)=>{
                const from = lastGroupedColIdx;
                lastGroupedColIdx = to;
                const previousNode = currentlyIterating[from];
                const previousNodeProvided = previousNode instanceof ColumnGroup ? previousNode.getProvidedColumnGroup() : previousNode;
                const previousNodeParent = previousNodeProvided.getOriginalParent();
                if (previousNodeParent == null) {
                    for(let i = from; i < to; i++)topLevelResultCols.push(currentlyIterating[i]);
                    return;
                }
                const newGroup = this.createColumnGroup(previousNodeParent, groupInstanceIdCreator, oldColumnsMapped, pinned);
                for(let i = from; i < to; i++)newGroup.addChild(currentlyIterating[i]);
                groupsOrColsAtCurrentLevel.push(newGroup);
            };
            for(let i = 1; i < currentlyIterating.length; i++){
                const thisNode = currentlyIterating[i];
                const thisNodeProvided = thisNode instanceof ColumnGroup ? thisNode.getProvidedColumnGroup() : thisNode;
                const thisNodeParent = thisNodeProvided.getOriginalParent();
                const previousNode = currentlyIterating[lastGroupedColIdx];
                const previousNodeProvided = previousNode instanceof ColumnGroup ? previousNode.getProvidedColumnGroup() : previousNode;
                const previousNodeParent = previousNodeProvided.getOriginalParent();
                if (thisNodeParent !== previousNodeParent) createGroupToIndex(i);
            }
            if (lastGroupedColIdx < currentlyIterating.length) createGroupToIndex(currentlyIterating.length);
        }
        this.setupParentsIntoColumns(topLevelResultCols, null);
        return topLevelResultCols;
    }
    createColumnGroup(providedGroup, groupInstanceIdCreator, oldColumnsMapped, pinned) {
        const groupId = providedGroup.getGroupId();
        const instanceId = groupInstanceIdCreator.getInstanceIdForKey(groupId);
        const uniqueId = ColumnGroup.createUniqueId(groupId, instanceId);
        let columnGroup = oldColumnsMapped[uniqueId];
        if (columnGroup && columnGroup.getProvidedColumnGroup() !== providedGroup) columnGroup = null;
        if (exists(columnGroup)) columnGroup.reset();
        else {
            columnGroup = new ColumnGroup(providedGroup, groupId, instanceId, pinned);
            this.context.createBean(columnGroup);
        }
        return columnGroup;
    }
    // returns back a 2d map of ColumnGroup as follows: groupId -> instanceId -> ColumnGroup
    mapOldGroupsById(displayedGroups) {
        const result = {};
        const recursive = (columnsOrGroups)=>{
            columnsOrGroups.forEach((columnOrGroup)=>{
                if (columnOrGroup instanceof ColumnGroup) {
                    const columnGroup = columnOrGroup;
                    result[columnOrGroup.getUniqueId()] = columnGroup;
                    recursive(columnGroup.getChildren());
                }
            });
        };
        if (displayedGroups) recursive(displayedGroups);
        return result;
    }
    setupParentsIntoColumns(columnsOrGroups, parent) {
        columnsOrGroups.forEach((columnsOrGroup)=>{
            columnsOrGroup.setParent(parent);
            if (columnsOrGroup instanceof ColumnGroup) {
                const columnGroup = columnsOrGroup;
                this.setupParentsIntoColumns(columnGroup.getChildren(), columnGroup);
            }
        });
    }
};
DisplayedGroupCreator = __decorateClass([
    Bean("displayedGroupCreator")
], DisplayedGroupCreator);
// community-modules/core/src/propertyKeys.ts
var INITIAL_GRID_OPTION_KEYS = {
    enableBrowserTooltips: true,
    tooltipTrigger: true,
    tooltipMouseTrack: true,
    tooltipShowMode: true,
    tooltipInteraction: true,
    defaultColGroupDef: true,
    suppressAutoSize: true,
    skipHeaderOnAutoSize: true,
    autoSizeStrategy: true,
    components: true,
    stopEditingWhenCellsLoseFocus: true,
    undoRedoCellEditing: true,
    undoRedoCellEditingLimit: true,
    excelStyles: true,
    cacheQuickFilter: true,
    excludeHiddenColumnsFromQuickFilter: true,
    advancedFilterModel: true,
    customChartThemes: true,
    chartThemeOverrides: true,
    enableChartToolPanelsButton: true,
    suppressChartToolPanelsButton: true,
    chartToolPanelsDef: true,
    loadingCellRendererSelector: true,
    localeText: true,
    keepDetailRows: true,
    keepDetailRowsCount: true,
    detailRowHeight: true,
    detailRowAutoHeight: true,
    tabIndex: true,
    valueCache: true,
    valueCacheNeverExpires: true,
    enableCellExpressions: true,
    suppressParentsInRowNodes: true,
    suppressTouch: true,
    suppressAsyncEvents: true,
    suppressBrowserResizeObserver: true,
    suppressPropertyNamesCheck: true,
    debug: true,
    loadingOverlayComponent: true,
    suppressLoadingOverlay: true,
    noRowsOverlayComponent: true,
    paginationPageSizeSelector: true,
    paginateChildRows: true,
    pivotPanelShow: true,
    pivotSuppressAutoColumn: true,
    suppressExpandablePivotGroups: true,
    aggFuncs: true,
    suppressAggFuncInHeader: true,
    suppressAggAtRootLevel: true,
    removePivotHeaderRowWhenSingleValueColumn: true,
    allowShowChangeAfterFilter: true,
    ensureDomOrder: true,
    enableRtl: true,
    suppressColumnVirtualisation: true,
    suppressMaxRenderedRowRestriction: true,
    suppressRowVirtualisation: true,
    rowDragText: true,
    suppressGroupMaintainValueType: true,
    groupLockGroupColumns: true,
    rowGroupPanelSuppressSort: true,
    suppressGroupRowsSticky: true,
    rowModelType: true,
    cacheOverflowSize: true,
    infiniteInitialRowCount: true,
    serverSideInitialRowCount: true,
    suppressServerSideInfiniteScroll: true,
    maxBlocksInCache: true,
    maxConcurrentDatasourceRequests: true,
    blockLoadDebounceMillis: true,
    serverSideOnlyRefreshFilteredGroups: true,
    serverSidePivotResultFieldSeparator: true,
    viewportRowModelPageSize: true,
    viewportRowModelBufferSize: true,
    debounceVerticalScrollbar: true,
    suppressAnimationFrame: true,
    suppressPreventDefaultOnMouseWheel: true,
    scrollbarWidth: true,
    icons: true,
    suppressRowTransform: true,
    gridId: true,
    functionsPassive: true,
    enableGroupEdit: true,
    initialState: true,
    processUnpinnedColumns: true,
    createChartContainer: true,
    getLocaleText: true,
    getRowId: true,
    reactiveCustomComponents: true,
    columnMenu: true
};
var _PropertyKeys = class _PropertyKeys {
};
_PropertyKeys.STRING_PROPERTIES = [
    "rowSelection",
    "overlayLoadingTemplate",
    "overlayNoRowsTemplate",
    "gridId",
    "quickFilterText",
    "rowModelType",
    "editType",
    "domLayout",
    "clipboardDelimiter",
    "rowGroupPanelShow",
    "multiSortKey",
    "pivotColumnGroupTotals",
    "pivotRowTotals",
    "pivotPanelShow",
    "fillHandleDirection",
    "groupDisplayType",
    "treeDataDisplayType",
    "colResizeDefault",
    "tooltipTrigger",
    "serverSidePivotResultFieldSeparator",
    "columnMenu",
    "tooltipShowMode",
    "grandTotalRow"
];
_PropertyKeys.OBJECT_PROPERTIES = [
    "components",
    "rowStyle",
    "context",
    "autoGroupColumnDef",
    "localeText",
    "icons",
    "datasource",
    "serverSideDatasource",
    "viewportDatasource",
    "groupRowRendererParams",
    "aggFuncs",
    "fullWidthCellRendererParams",
    "defaultColGroupDef",
    "defaultColDef",
    "defaultCsvExportParams",
    "defaultExcelExportParams",
    "columnTypes",
    "rowClassRules",
    "detailCellRendererParams",
    "loadingCellRendererParams",
    "loadingOverlayComponentParams",
    "noRowsOverlayComponentParams",
    "popupParent",
    "statusBar",
    "sideBar",
    "chartThemeOverrides",
    "customChartThemes",
    "chartToolPanelsDef",
    "dataTypeDefinitions",
    "advancedFilterModel",
    "advancedFilterParent",
    "advancedFilterBuilderParams",
    "initialState",
    "autoSizeStrategy"
];
_PropertyKeys.ARRAY_PROPERTIES = [
    "sortingOrder",
    "alignedGrids",
    "rowData",
    "columnDefs",
    "excelStyles",
    "pinnedTopRowData",
    "pinnedBottomRowData",
    "chartThemes",
    "rowClass",
    "paginationPageSizeSelector"
];
// These properties are coerced at runtime, do not do union types
_PropertyKeys.NUMBER_PROPERTIES = [
    "rowHeight",
    "detailRowHeight",
    "rowBuffer",
    "headerHeight",
    "groupHeaderHeight",
    "groupLockGroupColumns",
    "floatingFiltersHeight",
    "pivotHeaderHeight",
    "pivotGroupHeaderHeight",
    "groupDefaultExpanded",
    "pivotDefaultExpanded",
    "viewportRowModelPageSize",
    "viewportRowModelBufferSize",
    "autoSizePadding",
    "maxBlocksInCache",
    "maxConcurrentDatasourceRequests",
    "tooltipShowDelay",
    "tooltipHideDelay",
    "cacheOverflowSize",
    "paginationPageSize",
    "cacheBlockSize",
    "infiniteInitialRowCount",
    "serverSideInitialRowCount",
    "scrollbarWidth",
    "asyncTransactionWaitMillis",
    "blockLoadDebounceMillis",
    "keepDetailRowsCount",
    "undoRedoCellEditingLimit",
    "cellFlashDelay",
    "cellFadeDelay",
    "cellFlashDuration",
    "cellFadeDuration",
    "tabIndex",
    "pivotMaxGeneratedColumns"
];
// These properties are coerced at runtime, do not do union types
_PropertyKeys.BOOLEAN_PROPERTIES = [
    "suppressMakeColumnVisibleAfterUnGroup",
    "suppressRowClickSelection",
    "suppressCellFocus",
    "suppressHeaderFocus",
    "suppressHorizontalScroll",
    "groupSelectsChildren",
    "alwaysShowHorizontalScroll",
    "alwaysShowVerticalScroll",
    "debug",
    "enableBrowserTooltips",
    "enableCellExpressions",
    "groupIncludeTotalFooter",
    "groupSuppressBlankHeader",
    "suppressMenuHide",
    "suppressRowDeselection",
    "unSortIcon",
    "suppressMultiSort",
    "alwaysMultiSort",
    "singleClickEdit",
    "suppressLoadingOverlay",
    "suppressNoRowsOverlay",
    "suppressAutoSize",
    "skipHeaderOnAutoSize",
    "suppressParentsInRowNodes",
    "suppressColumnMoveAnimation",
    "suppressMovableColumns",
    "suppressFieldDotNotation",
    "enableRangeSelection",
    "enableRangeHandle",
    "enableFillHandle",
    "suppressClearOnFillReduction",
    "deltaSort",
    "suppressTouch",
    "suppressAsyncEvents",
    "allowContextMenuWithControlKey",
    "suppressContextMenu",
    "enableCellChangeFlash",
    "suppressDragLeaveHidesColumns",
    "suppressRowGroupHidesColumns",
    "suppressMiddleClickScrolls",
    "suppressPreventDefaultOnMouseWheel",
    "suppressCopyRowsToClipboard",
    "copyHeadersToClipboard",
    "copyGroupHeadersToClipboard",
    "pivotMode",
    "suppressAggFuncInHeader",
    "suppressColumnVirtualisation",
    "alwaysAggregateAtRootLevel",
    "suppressAggAtRootLevel",
    "suppressFocusAfterRefresh",
    "functionsPassive",
    "functionsReadOnly",
    "animateRows",
    "groupSelectsFiltered",
    "groupRemoveSingleChildren",
    "groupRemoveLowestSingleChildren",
    "enableRtl",
    "suppressClickEdit",
    "rowDragEntireRow",
    "rowDragManaged",
    "suppressRowDrag",
    "suppressMoveWhenRowDragging",
    "rowDragMultiRow",
    "enableGroupEdit",
    "embedFullWidthRows",
    "suppressPaginationPanel",
    "groupHideOpenParents",
    "groupAllowUnbalanced",
    "pagination",
    "paginationAutoPageSize",
    "suppressScrollOnNewData",
    "suppressScrollWhenPopupsAreOpen",
    "purgeClosedRowNodes",
    "cacheQuickFilter",
    "includeHiddenColumnsInQuickFilter",
    "excludeHiddenColumnsFromQuickFilter",
    "ensureDomOrder",
    "accentedSort",
    "suppressChangeDetection",
    "valueCache",
    "valueCacheNeverExpires",
    "aggregateOnlyChangedColumns",
    "suppressAnimationFrame",
    "suppressExcelExport",
    "suppressCsvExport",
    "includeHiddenColumnsInAdvancedFilter",
    "suppressMultiRangeSelection",
    "enterMovesDown",
    "enterMovesDownAfterEdit",
    "enterNavigatesVerticallyAfterEdit",
    "enterNavigatesVertically",
    "suppressPropertyNamesCheck",
    "rowMultiSelectWithClick",
    "suppressRowHoverHighlight",
    "suppressRowTransform",
    "suppressClipboardPaste",
    "suppressLastEmptyLineOnPaste",
    "enableCharts",
    "enableChartToolPanelsButton",
    "suppressChartToolPanelsButton",
    "suppressMaintainUnsortedOrder",
    "enableCellTextSelection",
    "suppressBrowserResizeObserver",
    "suppressMaxRenderedRowRestriction",
    "excludeChildrenWhenTreeDataFiltering",
    "tooltipMouseTrack",
    "tooltipInteraction",
    "keepDetailRows",
    "paginateChildRows",
    "preventDefaultOnContextMenu",
    "undoRedoCellEditing",
    "allowDragFromColumnsToolPanel",
    "pivotSuppressAutoColumn",
    "suppressExpandablePivotGroups",
    "debounceVerticalScrollbar",
    "detailRowAutoHeight",
    "serverSideFilterAllLevels",
    "serverSideSortAllLevels",
    "serverSideEnableClientSideSort",
    "serverSideOnlyRefreshFilteredGroups",
    "serverSideSortOnServer",
    "serverSideFilterOnServer",
    "suppressAggFilteredOnly",
    "showOpenedGroup",
    "suppressClipboardApi",
    "suppressModelUpdateAfterUpdateTransaction",
    "stopEditingWhenCellsLoseFocus",
    "maintainColumnOrder",
    "groupMaintainOrder",
    "columnHoverHighlight",
    "readOnlyEdit",
    "suppressRowVirtualisation",
    "enableCellEditingOnBackspace",
    "resetRowDataOnUpdate",
    "removePivotHeaderRowWhenSingleValueColumn",
    "suppressCopySingleCellRanges",
    "suppressGroupRowsSticky",
    "suppressCutToClipboard",
    "suppressServerSideInfiniteScroll",
    "rowGroupPanelSuppressSort",
    "allowShowChangeAfterFilter",
    "enableAdvancedFilter",
    "masterDetail",
    "treeData",
    "suppressGroupMaintainValueType",
    "reactiveCustomComponents",
    "applyQuickFilterBeforePivotOrAgg",
    "suppressServerSideFullWidthLoadingRow",
    "suppressAdvancedFilterEval"
];
// If property does not fit above, i.e union that should not be coerced.
_PropertyKeys.OTHER_PROPERTIES = [
    "suppressStickyTotalRow"
];
/** You do not need to include event callbacks in this list, as they are generated automatically. */ _PropertyKeys.FUNCTIONAL_PROPERTIES = [
    "doesExternalFilterPass",
    "processPivotResultColDef",
    "processPivotResultColGroupDef",
    "getBusinessKeyForNode",
    "isRowSelectable",
    "rowDragText",
    "groupRowRenderer",
    "fullWidthCellRenderer",
    "loadingCellRenderer",
    "loadingOverlayComponent",
    "noRowsOverlayComponent",
    "detailCellRenderer",
    "quickFilterParser",
    "quickFilterMatcher"
];
/** These callbacks extend AgGridCommon interface */ _PropertyKeys.CALLBACK_PROPERTIES = [
    "getLocaleText",
    "isExternalFilterPresent",
    "getRowHeight",
    "getRowClass",
    "getRowStyle",
    "getContextMenuItems",
    "getMainMenuItems",
    "processRowPostCreate",
    "processCellForClipboard",
    "getGroupRowAgg",
    "isFullWidthRow",
    "sendToClipboard",
    "navigateToNextHeader",
    "tabToNextHeader",
    "navigateToNextCell",
    "tabToNextCell",
    "processCellFromClipboard",
    "getDocument",
    "postProcessPopup",
    "getChildCount",
    "getDataPath",
    "isRowMaster",
    "postSortRows",
    "processHeaderForClipboard",
    "processUnpinnedColumns",
    "processGroupHeaderForClipboard",
    "paginationNumberFormatter",
    "processDataFromClipboard",
    "getServerSideGroupKey",
    "isServerSideGroup",
    "createChartContainer",
    "getChartToolbarItems",
    "fillOperation",
    "isApplyServerSideTransaction",
    "getServerSideGroupLevelParams",
    "isServerSideGroupOpenByDefault",
    "isGroupOpenByDefault",
    "initialGroupOrderComparator",
    "groupIncludeFooter",
    "loadingCellRendererSelector",
    "getRowId",
    "groupAggFiltering",
    "chartMenuItems",
    "groupTotalRow"
];
_PropertyKeys.FUNCTION_PROPERTIES = [
    ..._PropertyKeys.FUNCTIONAL_PROPERTIES,
    ..._PropertyKeys.CALLBACK_PROPERTIES
];
_PropertyKeys.ALL_PROPERTIES = [
    ..._PropertyKeys.ARRAY_PROPERTIES,
    ..._PropertyKeys.OBJECT_PROPERTIES,
    ..._PropertyKeys.STRING_PROPERTIES,
    ..._PropertyKeys.NUMBER_PROPERTIES,
    ..._PropertyKeys.FUNCTION_PROPERTIES,
    ..._PropertyKeys.BOOLEAN_PROPERTIES,
    ..._PropertyKeys.OTHER_PROPERTIES
];
var PropertyKeys = _PropertyKeys;
// community-modules/core/src/components/componentUtil.ts
var _ComponentUtil = class _ComponentUtil {
    static getCallbackForEvent(eventName) {
        if (!eventName || eventName.length < 2) return eventName;
        return "on" + eventName[0].toUpperCase() + eventName.substring(1);
    }
    static getGridOptionKeys() {
        return this.ALL_PROPERTIES_AND_CALLBACKS;
    }
    /** Combines component props / attributes with the provided gridOptions returning a new combined gridOptions object */ static combineAttributesAndGridOptions(gridOptions, component) {
        if (typeof gridOptions !== "object") gridOptions = {};
        const mergedOptions = __spreadValues({}, gridOptions);
        const keys2 = _ComponentUtil.getGridOptionKeys();
        keys2.forEach((key)=>{
            const value = component[key];
            if (typeof value !== "undefined" && value !== _ComponentUtil.VUE_OMITTED_PROPERTY) mergedOptions[key] = value;
        });
        return mergedOptions;
    }
    static processOnChange(changes, api, isVue) {
        if (!changes) return;
        const gridChanges = {};
        let hasChanges = false;
        Object.keys(changes).filter((key)=>_ComponentUtil.ALL_PROPERTIES_AND_CALLBACKS_SET.has(key)).forEach((key)=>{
            gridChanges[key] = changes[key];
            hasChanges = true;
        });
        if (!hasChanges) return;
        api.__internalUpdateGridOptions(gridChanges, true);
        const event = {
            type: Events.EVENT_COMPONENT_STATE_CHANGED
        };
        iterateObject(gridChanges, (key, value)=>{
            event[key] = value;
        });
        api.dispatchEvent(event);
    }
};
// all events
_ComponentUtil.EVENTS = values(Events);
_ComponentUtil.VUE_OMITTED_PROPERTY = "AG-VUE-OMITTED-PROPERTY";
// events that are internal to AG Grid and should not be exposed to users via documentation or generated framework components
/** Exclude the following internal events from code generation to prevent exposing these events via framework components */ _ComponentUtil.EXCLUDED_INTERNAL_EVENTS = [
    Events.EVENT_SCROLLBAR_WIDTH_CHANGED,
    Events.EVENT_CHECKBOX_CHANGED,
    Events.EVENT_HEIGHT_SCALE_CHANGED,
    Events.EVENT_BODY_HEIGHT_CHANGED,
    Events.EVENT_COLUMN_CONTAINER_WIDTH_CHANGED,
    Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED,
    Events.EVENT_SCROLL_VISIBILITY_CHANGED,
    Events.EVENT_COLUMN_HOVER_CHANGED,
    Events.EVENT_FLASH_CELLS,
    Events.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED,
    Events.EVENT_DISPLAYED_ROWS_CHANGED,
    Events.EVENT_LEFT_PINNED_WIDTH_CHANGED,
    Events.EVENT_RIGHT_PINNED_WIDTH_CHANGED,
    Events.EVENT_ROW_CONTAINER_HEIGHT_CHANGED,
    Events.EVENT_STORE_UPDATED,
    Events.EVENT_COLUMN_PANEL_ITEM_DRAG_START,
    Events.EVENT_COLUMN_PANEL_ITEM_DRAG_END,
    Events.EVENT_KEY_SHORTCUT_CHANGED_CELL_START,
    Events.EVENT_KEY_SHORTCUT_CHANGED_CELL_END,
    Events.EVENT_FULL_WIDTH_ROW_FOCUSED,
    Events.EVENT_HEADER_HEIGHT_CHANGED,
    Events.EVENT_COLUMN_HEADER_HEIGHT_CHANGED,
    Events.EVENT_CELL_FOCUS_CLEARED,
    Events.EVENT_GRID_STYLES_CHANGED,
    Events.EVENT_FILTER_DESTROYED,
    Events.EVENT_ROW_DATA_UPDATE_STARTED,
    Events.EVENT_ADVANCED_FILTER_ENABLED_CHANGED,
    Events.EVENT_DATA_TYPES_INFERRED,
    Events.EVENT_FIELD_VALUE_CHANGED,
    Events.EVENT_FIELD_PICKER_VALUE_SELECTED,
    Events.EVENT_SUPPRESS_COLUMN_MOVE_CHANGED,
    Events.EVENT_SUPPRESS_MENU_HIDE_CHANGED,
    Events.EVENT_SUPPRESS_FIELD_DOT_NOTATION,
    Events.EVENT_ROW_COUNT_READY,
    Events.EVENT_SIDE_BAR_UPDATED
];
// events that are available for use by users of AG Grid and so should be documented
/** EVENTS that should be exposed via code generation for the framework components.  */ _ComponentUtil.PUBLIC_EVENTS = _ComponentUtil.EVENTS.filter((e)=>!includes(_ComponentUtil.EXCLUDED_INTERNAL_EVENTS, e));
// onXXX methods, based on the above events
_ComponentUtil.EVENT_CALLBACKS = _ComponentUtil.EVENTS.map((event)=>_ComponentUtil.getCallbackForEvent(event));
_ComponentUtil.BOOLEAN_PROPERTIES = PropertyKeys.BOOLEAN_PROPERTIES;
_ComponentUtil.ALL_PROPERTIES = PropertyKeys.ALL_PROPERTIES;
_ComponentUtil.ALL_PROPERTIES_AND_CALLBACKS = [
    ..._ComponentUtil.ALL_PROPERTIES,
    ..._ComponentUtil.EVENT_CALLBACKS
];
_ComponentUtil.ALL_PROPERTIES_AND_CALLBACKS_SET = new Set(_ComponentUtil.ALL_PROPERTIES_AND_CALLBACKS);
var ComponentUtil = _ComponentUtil;
// community-modules/core/src/components/agStackComponentsRegistry.ts
var AgStackComponentsRegistry = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.componentsMappedByName = {};
    }
    setupComponents(components) {
        if (components) components.forEach((componentMeta)=>this.addComponent(componentMeta));
    }
    addComponent(componentMeta) {
        const classEscaped = componentMeta.componentName.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
        const classUpperCase = classEscaped.toUpperCase();
        this.componentsMappedByName[classUpperCase] = componentMeta.componentClass;
    }
    getComponentClass(htmlTag) {
        return this.componentsMappedByName[htmlTag];
    }
};
AgStackComponentsRegistry = __decorateClass([
    Bean("agStackComponentsRegistry")
], AgStackComponentsRegistry);
// community-modules/core/src/utils/aria.ts
var aria_exports = {};
__export(aria_exports, {
    getAriaCheckboxStateName: ()=>getAriaCheckboxStateName,
    getAriaLabel: ()=>getAriaLabel,
    getAriaLevel: ()=>getAriaLevel,
    getAriaPosInSet: ()=>getAriaPosInSet,
    getAriaSortState: ()=>getAriaSortState,
    removeAriaExpanded: ()=>removeAriaExpanded,
    removeAriaSort: ()=>removeAriaSort,
    setAriaActiveDescendant: ()=>setAriaActiveDescendant,
    setAriaAtomic: ()=>setAriaAtomic,
    setAriaChecked: ()=>setAriaChecked,
    setAriaColCount: ()=>setAriaColCount,
    setAriaColIndex: ()=>setAriaColIndex,
    setAriaColSpan: ()=>setAriaColSpan,
    setAriaControls: ()=>setAriaControls,
    setAriaDescribedBy: ()=>setAriaDescribedBy,
    setAriaDisabled: ()=>setAriaDisabled,
    setAriaExpanded: ()=>setAriaExpanded,
    setAriaHidden: ()=>setAriaHidden,
    setAriaLabel: ()=>setAriaLabel,
    setAriaLabelledBy: ()=>setAriaLabelledBy,
    setAriaLevel: ()=>setAriaLevel,
    setAriaLive: ()=>setAriaLive,
    setAriaMultiSelectable: ()=>setAriaMultiSelectable,
    setAriaPosInSet: ()=>setAriaPosInSet,
    setAriaRelevant: ()=>setAriaRelevant,
    setAriaRole: ()=>setAriaRole,
    setAriaRowCount: ()=>setAriaRowCount,
    setAriaRowIndex: ()=>setAriaRowIndex,
    setAriaSelected: ()=>setAriaSelected,
    setAriaSetSize: ()=>setAriaSetSize,
    setAriaSort: ()=>setAriaSort
});
function toggleAriaAttribute(element, attribute, value) {
    if (value == null || typeof value === "string" && value == "") removeAriaAttribute(element, attribute);
    else setAriaAttribute(element, attribute, value);
}
function setAriaAttribute(element, attribute, value) {
    element.setAttribute(ariaAttributeName(attribute), value.toString());
}
function removeAriaAttribute(element, attribute) {
    element.removeAttribute(ariaAttributeName(attribute));
}
function ariaAttributeName(attribute) {
    return `aria-${attribute}`;
}
function setAriaRole(element, role) {
    if (role) element.setAttribute("role", role);
    else element.removeAttribute("role");
}
function getAriaSortState(sortDirection) {
    let sort;
    if (sortDirection === "asc") sort = "ascending";
    else if (sortDirection === "desc") sort = "descending";
    else if (sortDirection === "mixed") sort = "other";
    else sort = "none";
    return sort;
}
function getAriaLevel(element) {
    return parseInt(element.getAttribute("aria-level"), 10);
}
function getAriaPosInSet(element) {
    return parseInt(element.getAttribute("aria-posinset"), 10);
}
function getAriaLabel(element) {
    return element.getAttribute("aria-label");
}
function setAriaLabel(element, label) {
    toggleAriaAttribute(element, "label", label);
}
function setAriaLabelledBy(element, labelledBy) {
    toggleAriaAttribute(element, "labelledby", labelledBy);
}
function setAriaDescribedBy(element, describedby) {
    toggleAriaAttribute(element, "describedby", describedby);
}
function setAriaLive(element, live) {
    toggleAriaAttribute(element, "live", live);
}
function setAriaAtomic(element, atomic) {
    toggleAriaAttribute(element, "atomic", atomic);
}
function setAriaRelevant(element, relevant) {
    toggleAriaAttribute(element, "relevant", relevant);
}
function setAriaLevel(element, level) {
    toggleAriaAttribute(element, "level", level);
}
function setAriaDisabled(element, disabled) {
    toggleAriaAttribute(element, "disabled", disabled);
}
function setAriaHidden(element, hidden) {
    toggleAriaAttribute(element, "hidden", hidden);
}
function setAriaActiveDescendant(element, descendantId) {
    toggleAriaAttribute(element, "activedescendant", descendantId);
}
function setAriaExpanded(element, expanded) {
    setAriaAttribute(element, "expanded", expanded);
}
function removeAriaExpanded(element) {
    removeAriaAttribute(element, "expanded");
}
function setAriaSetSize(element, setsize) {
    setAriaAttribute(element, "setsize", setsize);
}
function setAriaPosInSet(element, position) {
    setAriaAttribute(element, "posinset", position);
}
function setAriaMultiSelectable(element, multiSelectable) {
    setAriaAttribute(element, "multiselectable", multiSelectable);
}
function setAriaRowCount(element, rowCount) {
    setAriaAttribute(element, "rowcount", rowCount);
}
function setAriaRowIndex(element, rowIndex) {
    setAriaAttribute(element, "rowindex", rowIndex);
}
function setAriaColCount(element, colCount) {
    setAriaAttribute(element, "colcount", colCount);
}
function setAriaColIndex(element, colIndex) {
    setAriaAttribute(element, "colindex", colIndex);
}
function setAriaColSpan(element, colSpan) {
    setAriaAttribute(element, "colspan", colSpan);
}
function setAriaSort(element, sort) {
    setAriaAttribute(element, "sort", sort);
}
function removeAriaSort(element) {
    removeAriaAttribute(element, "sort");
}
function setAriaSelected(element, selected) {
    toggleAriaAttribute(element, "selected", selected);
}
function setAriaChecked(element, checked) {
    setAriaAttribute(element, "checked", checked === void 0 ? "mixed" : checked);
}
function setAriaControls(controllerElement, controlledElement) {
    toggleAriaAttribute(controllerElement, "controls", controlledElement.id);
    setAriaLabelledBy(controlledElement, controllerElement.id);
}
function getAriaCheckboxStateName(translate, state) {
    return state === void 0 ? translate("ariaIndeterminate", "indeterminate") : state === true ? translate("ariaChecked", "checked") : translate("ariaUnchecked", "unchecked");
}
// community-modules/core/src/utils/browser.ts
var browser_exports = {};
__export(browser_exports, {
    browserSupportsPreventScroll: ()=>browserSupportsPreventScroll,
    getBodyHeight: ()=>getBodyHeight,
    getBodyWidth: ()=>getBodyWidth,
    getMaxDivHeight: ()=>getMaxDivHeight,
    getSafariVersion: ()=>getSafariVersion,
    getScrollbarWidth: ()=>getScrollbarWidth,
    getTabIndex: ()=>getTabIndex,
    isBrowserChrome: ()=>isBrowserChrome,
    isBrowserFirefox: ()=>isBrowserFirefox,
    isBrowserSafari: ()=>isBrowserSafari,
    isIOSUserAgent: ()=>isIOSUserAgent,
    isInvisibleScrollbar: ()=>isInvisibleScrollbar,
    isMacOsUserAgent: ()=>isMacOsUserAgent
});
var isSafari;
var safariVersion;
var isChrome;
var isFirefox;
var isMacOs;
var isIOS;
var invisibleScrollbar;
var browserScrollbarWidth;
function isBrowserSafari() {
    if (isSafari === void 0) isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    return isSafari;
}
function getSafariVersion() {
    if (safariVersion === void 0) {
        if (isBrowserSafari()) {
            const versionMatch = navigator.userAgent.match(/version\/(\d+)/i);
            if (versionMatch) safariVersion = versionMatch[1] != null ? parseFloat(versionMatch[1]) : 0;
        } else safariVersion = 0;
    }
    return safariVersion;
}
function isBrowserChrome() {
    if (isChrome === void 0) {
        const win = window;
        isChrome = !!win.chrome && (!!win.chrome.webstore || !!win.chrome.runtime) || /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    }
    return isChrome;
}
function isBrowserFirefox() {
    if (isFirefox === void 0) isFirefox = /(firefox)/i.test(navigator.userAgent);
    return isFirefox;
}
function isMacOsUserAgent() {
    if (isMacOs === void 0) isMacOs = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
    return isMacOs;
}
function isIOSUserAgent() {
    if (isIOS === void 0) isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || // eslint-disable-next-line
    navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
    return isIOS;
}
function browserSupportsPreventScroll() {
    return !isBrowserSafari() || getSafariVersion() >= 15;
}
function getTabIndex(el) {
    if (!el) return null;
    const numberTabIndex = el.tabIndex;
    const tabIndex = el.getAttribute("tabIndex");
    if (numberTabIndex === -1 && (tabIndex === null || tabIndex === "" && !isBrowserFirefox())) return null;
    return numberTabIndex.toString();
}
function getMaxDivHeight() {
    if (!document.body) return -1;
    let res = 1e6;
    const testUpTo = navigator.userAgent.toLowerCase().match(/firefox/) ? 6e6 : 1e9;
    const div = document.createElement("div");
    document.body.appendChild(div);
    while(true){
        const test = res * 2;
        div.style.height = test + "px";
        if (test > testUpTo || div.clientHeight !== test) break;
        else res = test;
    }
    document.body.removeChild(div);
    return res;
}
function getBodyWidth() {
    var _a, _b, _c;
    return (_c = (_a = document.body) == null ? void 0 : _a.clientWidth) != null ? _c : window.innerHeight || ((_b = document.documentElement) == null ? void 0 : _b.clientWidth) || -1;
}
function getBodyHeight() {
    var _a, _b, _c;
    return (_c = (_a = document.body) == null ? void 0 : _a.clientHeight) != null ? _c : window.innerHeight || ((_b = document.documentElement) == null ? void 0 : _b.clientHeight) || -1;
}
function getScrollbarWidth() {
    if (browserScrollbarWidth == null) initScrollbarWidthAndVisibility();
    return browserScrollbarWidth;
}
function initScrollbarWidthAndVisibility() {
    const body = document.body;
    const div = document.createElement("div");
    div.style.width = div.style.height = "100px";
    div.style.opacity = "0";
    div.style.overflow = "scroll";
    div.style.msOverflowStyle = "scrollbar";
    div.style.position = "absolute";
    body.appendChild(div);
    let width = div.offsetWidth - div.clientWidth;
    if (width === 0 && div.clientWidth === 0) width = null;
    if (div.parentNode) div.parentNode.removeChild(div);
    if (width != null) {
        browserScrollbarWidth = width;
        invisibleScrollbar = width === 0;
    }
}
function isInvisibleScrollbar() {
    if (invisibleScrollbar == null) initScrollbarWidthAndVisibility();
    return invisibleScrollbar;
}
// community-modules/core/src/utils/date.ts
var date_exports = {};
__export(date_exports, {
    dateToFormattedString: ()=>dateToFormattedString,
    parseDateTimeFromString: ()=>parseDateTimeFromString,
    serialiseDate: ()=>serialiseDate
});
// community-modules/core/src/utils/number.ts
var number_exports = {};
__export(number_exports, {
    cleanNumber: ()=>cleanNumber,
    createArrayOfNumbers: ()=>createArrayOfNumbers,
    decToHex: ()=>decToHex,
    formatNumberCommas: ()=>formatNumberCommas,
    formatNumberTwoDecimalPlacesAndCommas: ()=>formatNumberTwoDecimalPlacesAndCommas,
    padStartWidthZeros: ()=>padStartWidthZeros,
    sum: ()=>sum
});
function padStartWidthZeros(value, totalStringSize) {
    return value.toString().padStart(totalStringSize, "0");
}
function createArrayOfNumbers(first, last2) {
    const result = [];
    for(let i = first; i <= last2; i++)result.push(i);
    return result;
}
function cleanNumber(value) {
    if (typeof value === "string") value = parseInt(value, 10);
    if (typeof value === "number") return Math.floor(value);
    return null;
}
function decToHex(number, bytes) {
    let hex = "";
    for(let i = 0; i < bytes; i++){
        hex += String.fromCharCode(number & 255);
        number >>>= 8;
    }
    return hex;
}
function formatNumberTwoDecimalPlacesAndCommas(value, thousandSeparator, decimalSeparator) {
    if (typeof value !== "number") return "";
    return formatNumberCommas(Math.round(value * 100) / 100, thousandSeparator, decimalSeparator);
}
function formatNumberCommas(value, thousandSeparator, decimalSeparator) {
    if (typeof value !== "number") return "";
    return value.toString().replace(".", decimalSeparator).replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousandSeparator}`);
}
function sum(values2) {
    return values2 == null ? null : values2.reduce((total, value)=>total + value, 0);
}
// community-modules/core/src/utils/date.ts
function serialiseDate(date, includeTime = true, separator = "-") {
    if (!date) return null;
    let serialised = [
        date.getFullYear(),
        date.getMonth() + 1,
        date.getDate()
    ].map((part)=>padStartWidthZeros(part, 2)).join(separator);
    if (includeTime) serialised += " " + [
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
    ].map((part)=>padStartWidthZeros(part, 2)).join(":");
    return serialised;
}
var calculateOrdinal = (value)=>{
    if (value > 3 && value < 21) return "th";
    const remainder = value % 10;
    switch(remainder){
        case 1:
            return "st";
        case 2:
            return "nd";
        case 3:
            return "rd";
    }
    return "th";
};
function dateToFormattedString(date, format = "YYYY-MM-DD") {
    const fullYear = padStartWidthZeros(date.getFullYear(), 4);
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ];
    const replace = {
        YYYY: ()=>fullYear.slice(fullYear.length - 4, fullYear.length),
        YY: ()=>fullYear.slice(fullYear.length - 2, fullYear.length),
        Y: ()=>`${date.getFullYear()}`,
        MMMM: ()=>months[date.getMonth()],
        MMM: ()=>months[date.getMonth()].slice(0, 3),
        MM: ()=>padStartWidthZeros(date.getMonth() + 1, 2),
        Mo: ()=>`${date.getMonth() + 1}${calculateOrdinal(date.getMonth() + 1)}`,
        M: ()=>`${date.getMonth() + 1}`,
        Do: ()=>`${date.getDate()}${calculateOrdinal(date.getDate())}`,
        DD: ()=>padStartWidthZeros(date.getDate(), 2),
        D: ()=>`${date.getDate()}`,
        dddd: ()=>days[date.getDay()],
        ddd: ()=>days[date.getDay()].slice(0, 3),
        dd: ()=>days[date.getDay()].slice(0, 2),
        do: ()=>`${date.getDay()}${calculateOrdinal(date.getDay())}`,
        d: ()=>`${date.getDay()}`
    };
    const regexp = new RegExp(Object.keys(replace).join("|"), "g");
    return format.replace(regexp, (match)=>{
        if (match in replace) return replace[match]();
        return match;
    });
}
function parseDateTimeFromString(value) {
    if (!value) return null;
    const [dateStr, timeStr] = value.split(" ");
    if (!dateStr) return null;
    const fields = dateStr.split("-").map((f)=>parseInt(f, 10));
    if (fields.filter((f)=>!isNaN(f)).length !== 3) return null;
    const [year, month, day] = fields;
    const date = new Date(year, month - 1, day);
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return null;
    if (!timeStr || timeStr === "00:00:00") return date;
    const [hours, minutes, seconds] = timeStr.split(":").map((part)=>parseInt(part, 10));
    if (hours >= 0 && hours < 24) date.setHours(hours);
    if (minutes >= 0 && minutes < 60) date.setMinutes(minutes);
    if (seconds >= 0 && seconds < 60) date.setSeconds(seconds);
    return date;
}
// community-modules/core/src/utils/dom.ts
var dom_exports = {};
__export(dom_exports, {
    FOCUSABLE_EXCLUDE: ()=>FOCUSABLE_EXCLUDE,
    FOCUSABLE_SELECTOR: ()=>FOCUSABLE_SELECTOR,
    addOrRemoveAttribute: ()=>addOrRemoveAttribute,
    addStylesToElement: ()=>addStylesToElement,
    bindCellRendererToHtmlElement: ()=>bindCellRendererToHtmlElement,
    clearElement: ()=>clearElement,
    copyNodeList: ()=>copyNodeList,
    ensureDomOrder: ()=>ensureDomOrder,
    formatSize: ()=>formatSize,
    getAbsoluteHeight: ()=>getAbsoluteHeight,
    getAbsoluteWidth: ()=>getAbsoluteWidth,
    getElementRectWithOffset: ()=>getElementRectWithOffset,
    getElementSize: ()=>getElementSize,
    getInnerHeight: ()=>getInnerHeight,
    getInnerWidth: ()=>getInnerWidth,
    getScrollLeft: ()=>getScrollLeft,
    insertWithDomOrder: ()=>insertWithDomOrder,
    isElementChildOfClass: ()=>isElementChildOfClass,
    isFocusableFormField: ()=>isFocusableFormField,
    isHorizontalScrollShowing: ()=>isHorizontalScrollShowing,
    isInDOM: ()=>isInDOM,
    isNodeOrElement: ()=>isNodeOrElement,
    isRtlNegativeScroll: ()=>isRtlNegativeScroll,
    isVerticalScrollShowing: ()=>isVerticalScrollShowing,
    isVisible: ()=>isVisible,
    iterateNamedNodeMap: ()=>iterateNamedNodeMap,
    loadTemplate: ()=>loadTemplate,
    nodeListForEach: ()=>nodeListForEach,
    radioCssClass: ()=>radioCssClass,
    removeFromParent: ()=>removeFromParent,
    setDisabled: ()=>setDisabled,
    setDisplayed: ()=>setDisplayed,
    setDomChildOrder: ()=>setDomChildOrder,
    setElementHeight: ()=>setElementHeight,
    setElementWidth: ()=>setElementWidth,
    setFixedHeight: ()=>setFixedHeight,
    setFixedWidth: ()=>setFixedWidth,
    setScrollLeft: ()=>setScrollLeft,
    setVisible: ()=>setVisible
});
var rtlNegativeScroll;
function radioCssClass(element, elementClass, otherElementClass) {
    const parent = element.parentElement;
    let sibling = parent && parent.firstChild;
    while(sibling){
        if (elementClass) sibling.classList.toggle(elementClass, sibling === element);
        if (otherElementClass) sibling.classList.toggle(otherElementClass, sibling !== element);
        sibling = sibling.nextSibling;
    }
}
var FOCUSABLE_SELECTOR = "[tabindex], input, select, button, textarea, [href]";
var FOCUSABLE_EXCLUDE = "[disabled], .ag-disabled:not(.ag-button), .ag-disabled *";
function isFocusableFormField(element) {
    const matches = Element.prototype.matches || Element.prototype.msMatchesSelector;
    const inputSelector = "input, select, button, textarea";
    const isFocusable = matches.call(element, inputSelector);
    const isNotFocusable = matches.call(element, FOCUSABLE_EXCLUDE);
    const isElementVisible = isVisible(element);
    const focusable = isFocusable && !isNotFocusable && isElementVisible;
    return focusable;
}
function setDisplayed(element, displayed, options = {}) {
    const { skipAriaHidden } = options;
    element.classList.toggle("ag-hidden", !displayed);
    if (!skipAriaHidden) setAriaHidden(element, !displayed);
}
function setVisible(element, visible, options = {}) {
    const { skipAriaHidden } = options;
    element.classList.toggle("ag-invisible", !visible);
    if (!skipAriaHidden) setAriaHidden(element, !visible);
}
function setDisabled(element, disabled) {
    const attributeName = "disabled";
    const addOrRemoveDisabledAttribute = disabled ? (e)=>e.setAttribute(attributeName, "") : (e)=>e.removeAttribute(attributeName);
    addOrRemoveDisabledAttribute(element);
    nodeListForEach(element.querySelectorAll("input"), (input)=>addOrRemoveDisabledAttribute(input));
}
function isElementChildOfClass(element, cls, maxNest) {
    let counter = 0;
    while(element){
        if (element.classList.contains(cls)) return true;
        element = element.parentElement;
        if (typeof maxNest == "number") {
            if (++counter > maxNest) break;
        } else if (element === maxNest) break;
    }
    return false;
}
function getElementSize(el) {
    const { height, width, borderTopWidth, borderRightWidth, borderBottomWidth, borderLeftWidth, paddingTop, paddingRight, paddingBottom, paddingLeft, marginTop, marginRight, marginBottom, marginLeft, boxSizing } = window.getComputedStyle(el);
    return {
        height: parseFloat(height || "0"),
        width: parseFloat(width || "0"),
        borderTopWidth: parseFloat(borderTopWidth || "0"),
        borderRightWidth: parseFloat(borderRightWidth || "0"),
        borderBottomWidth: parseFloat(borderBottomWidth || "0"),
        borderLeftWidth: parseFloat(borderLeftWidth || "0"),
        paddingTop: parseFloat(paddingTop || "0"),
        paddingRight: parseFloat(paddingRight || "0"),
        paddingBottom: parseFloat(paddingBottom || "0"),
        paddingLeft: parseFloat(paddingLeft || "0"),
        marginTop: parseFloat(marginTop || "0"),
        marginRight: parseFloat(marginRight || "0"),
        marginBottom: parseFloat(marginBottom || "0"),
        marginLeft: parseFloat(marginLeft || "0"),
        boxSizing
    };
}
function getInnerHeight(el) {
    const size = getElementSize(el);
    if (size.boxSizing === "border-box") return size.height - size.paddingTop - size.paddingBottom;
    return size.height;
}
function getInnerWidth(el) {
    const size = getElementSize(el);
    if (size.boxSizing === "border-box") return size.width - size.paddingLeft - size.paddingRight;
    return size.width;
}
function getAbsoluteHeight(el) {
    const size = getElementSize(el);
    const marginRight = size.marginBottom + size.marginTop;
    return Math.ceil(el.offsetHeight + marginRight);
}
function getAbsoluteWidth(el) {
    const size = getElementSize(el);
    const marginWidth = size.marginLeft + size.marginRight;
    return Math.ceil(el.offsetWidth + marginWidth);
}
function getElementRectWithOffset(el) {
    const offsetElementRect = el.getBoundingClientRect();
    const { borderTopWidth, borderLeftWidth, borderRightWidth, borderBottomWidth } = getElementSize(el);
    return {
        top: offsetElementRect.top + (borderTopWidth || 0),
        left: offsetElementRect.left + (borderLeftWidth || 0),
        right: offsetElementRect.right + (borderRightWidth || 0),
        bottom: offsetElementRect.bottom + (borderBottomWidth || 0)
    };
}
function isRtlNegativeScroll() {
    if (typeof rtlNegativeScroll === "boolean") return rtlNegativeScroll;
    const template = document.createElement("div");
    template.style.direction = "rtl";
    template.style.width = "1px";
    template.style.height = "1px";
    template.style.position = "fixed";
    template.style.top = "0px";
    template.style.overflow = "hidden";
    template.dir = "rtl";
    template.innerHTML = /* html */ `<div style="width: 2px">
            <span style="display: inline-block; width: 1px"></span>
            <span style="display: inline-block; width: 1px"></span>
        </div>`;
    document.body.appendChild(template);
    template.scrollLeft = 1;
    rtlNegativeScroll = Math.floor(template.scrollLeft) === 0;
    document.body.removeChild(template);
    return rtlNegativeScroll;
}
function getScrollLeft(element, rtl) {
    let scrollLeft = element.scrollLeft;
    if (rtl) {
        scrollLeft = Math.abs(scrollLeft);
        if (isBrowserChrome() && !isRtlNegativeScroll()) scrollLeft = element.scrollWidth - element.clientWidth - scrollLeft;
    }
    return scrollLeft;
}
function setScrollLeft(element, value, rtl) {
    if (rtl) {
        if (isRtlNegativeScroll()) value *= -1;
        else if (isBrowserSafari() || isBrowserChrome()) value = element.scrollWidth - element.clientWidth - value;
    }
    element.scrollLeft = value;
}
function clearElement(el) {
    while(el && el.firstChild)el.removeChild(el.firstChild);
}
function removeFromParent(node) {
    if (node && node.parentNode) node.parentNode.removeChild(node);
}
function isInDOM(element) {
    return !!element.offsetParent;
}
function isVisible(element) {
    const el = element;
    if (el.checkVisibility) return el.checkVisibility({
        checkVisibilityCSS: true
    });
    const isHidden = !isInDOM(element) || window.getComputedStyle(element).visibility !== "visible";
    return !isHidden;
}
function loadTemplate(template) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = (template || "").trim();
    return tempDiv.firstChild;
}
function ensureDomOrder(eContainer, eChild, eChildBefore) {
    if (eChildBefore && eChildBefore.nextSibling === eChild) return;
    if (eChildBefore) {
        if (eChildBefore.nextSibling) eContainer.insertBefore(eChild, eChildBefore.nextSibling);
        else eContainer.appendChild(eChild);
    } else if (eContainer.firstChild && eContainer.firstChild !== eChild) eContainer.insertAdjacentElement("afterbegin", eChild);
}
function setDomChildOrder(eContainer, orderedChildren) {
    for(let i = 0; i < orderedChildren.length; i++){
        const correctCellAtIndex = orderedChildren[i];
        const actualCellAtIndex = eContainer.children[i];
        if (actualCellAtIndex !== correctCellAtIndex) eContainer.insertBefore(correctCellAtIndex, actualCellAtIndex);
    }
}
function insertWithDomOrder(eContainer, eToInsert, eChildBefore) {
    if (eChildBefore) eChildBefore.insertAdjacentElement("afterend", eToInsert);
    else if (eContainer.firstChild) eContainer.insertAdjacentElement("afterbegin", eToInsert);
    else eContainer.appendChild(eToInsert);
}
function addStylesToElement(eElement, styles) {
    if (!styles) return;
    for (const [key, value] of Object.entries(styles)){
        if (!key || !key.length || value == null) continue;
        const parsedKey = camelCaseToHyphenated(key);
        const valueAsString = value.toString();
        const parsedValue = valueAsString.replace(/\s*!important/g, "");
        const priority = parsedValue.length != valueAsString.length ? "important" : void 0;
        eElement.style.setProperty(parsedKey, parsedValue, priority);
    }
}
function isHorizontalScrollShowing(element) {
    return element.clientWidth < element.scrollWidth;
}
function isVerticalScrollShowing(element) {
    return element.clientHeight < element.scrollHeight;
}
function setElementWidth(element, width) {
    if (width === "flex") {
        element.style.removeProperty("width");
        element.style.removeProperty("minWidth");
        element.style.removeProperty("maxWidth");
        element.style.flex = "1 1 auto";
    } else setFixedWidth(element, width);
}
function setFixedWidth(element, width) {
    width = formatSize(width);
    element.style.width = width.toString();
    element.style.maxWidth = width.toString();
    element.style.minWidth = width.toString();
}
function setElementHeight(element, height) {
    if (height === "flex") {
        element.style.removeProperty("height");
        element.style.removeProperty("minHeight");
        element.style.removeProperty("maxHeight");
        element.style.flex = "1 1 auto";
    } else setFixedHeight(element, height);
}
function setFixedHeight(element, height) {
    height = formatSize(height);
    element.style.height = height.toString();
    element.style.maxHeight = height.toString();
    element.style.minHeight = height.toString();
}
function formatSize(size) {
    if (typeof size === "number") return `${size}px`;
    return size;
}
function isNodeOrElement(o) {
    return o instanceof Node || o instanceof HTMLElement;
}
function copyNodeList(nodeList) {
    if (nodeList == null) return [];
    const result = [];
    nodeListForEach(nodeList, (node)=>result.push(node));
    return result;
}
function iterateNamedNodeMap(map, callback) {
    if (!map) return;
    for(let i = 0; i < map.length; i++){
        const attr = map[i];
        callback(attr.name, attr.value);
    }
}
function addOrRemoveAttribute(element, name, value) {
    if (value == null) element.removeAttribute(name);
    else element.setAttribute(name, value.toString());
}
function nodeListForEach(nodeList, action) {
    if (nodeList == null) return;
    for(let i = 0; i < nodeList.length; i++)action(nodeList[i]);
}
function bindCellRendererToHtmlElement(cellRendererPromise, eTarget) {
    cellRendererPromise.then((cellRenderer)=>{
        const gui = cellRenderer.getGui();
        if (gui != null) {
            if (typeof gui === "object") eTarget.appendChild(gui);
            else eTarget.innerHTML = gui;
        }
    });
}
// community-modules/core/src/utils/fuzzyMatch.ts
var fuzzyMatch_exports = {};
__export(fuzzyMatch_exports, {
    fuzzyCheckStrings: ()=>fuzzyCheckStrings,
    fuzzySuggestions: ()=>fuzzySuggestions
});
function fuzzyCheckStrings(inputValues, validValues, allSuggestions) {
    const fuzzyMatches = {};
    const invalidInputs = inputValues.filter((inputValue)=>!validValues.some((validValue)=>validValue === inputValue));
    if (invalidInputs.length > 0) invalidInputs.forEach((invalidInput)=>fuzzyMatches[invalidInput] = fuzzySuggestions(invalidInput, allSuggestions).values);
    return fuzzyMatches;
}
function fuzzySuggestions(inputValue, allSuggestions, hideIrrelevant, filterByPercentageOfBestMatch) {
    let thisSuggestions = allSuggestions.map((text, idx)=>({
            value: text,
            relevance: stringWeightedDistances(inputValue.toLowerCase(), text.toLocaleLowerCase()),
            idx
        }));
    thisSuggestions.sort((a, b)=>b.relevance - a.relevance);
    if (hideIrrelevant) thisSuggestions = thisSuggestions.filter((suggestion)=>suggestion.relevance !== 0);
    if (thisSuggestions.length > 0 && filterByPercentageOfBestMatch && filterByPercentageOfBestMatch > 0) {
        const bestMatch = thisSuggestions[0].relevance;
        const limit = bestMatch * filterByPercentageOfBestMatch;
        thisSuggestions = thisSuggestions.filter((suggestion)=>limit - suggestion.relevance < 0);
    }
    const values2 = [];
    const indices = [];
    for (const suggestion of thisSuggestions){
        values2.push(suggestion.value);
        indices.push(suggestion.idx);
    }
    return {
        values: values2,
        indices
    };
}
function stringWeightedDistances(str1, str2) {
    const a = str1.replace(/\s/g, "");
    const b = str2.replace(/\s/g, "");
    let weight = 0;
    let lastIndex = -1;
    for(let i = 0; i < a.length; i++){
        const idx = b.indexOf(a[i], lastIndex + 1);
        if (idx === -1) continue;
        lastIndex = idx;
        weight += 100 - lastIndex * 100 / 1e4 * 100;
    }
    return weight;
}
// community-modules/core/src/utils/icon.ts
var icon_exports = {};
__export(icon_exports, {
    createIcon: ()=>createIcon,
    createIconNoSpan: ()=>createIconNoSpan,
    iconNameClassMap: ()=>iconNameClassMap
});
var iconNameClassMap = {
    // header column group shown when expanded (click to contract)
    columnGroupOpened: "expanded",
    // header column group shown when contracted (click to expand)
    columnGroupClosed: "contracted",
    // tool panel column group contracted (click to expand)
    columnSelectClosed: "tree-closed",
    // tool panel column group expanded (click to contract)
    columnSelectOpen: "tree-open",
    // column tool panel header expand/collapse all button, shown when some children are expanded and
    //     others are collapsed
    columnSelectIndeterminate: "tree-indeterminate",
    // shown on ghost icon while dragging column to the side of the grid to pin
    columnMovePin: "pin",
    // shown on ghost icon while dragging over part of the page that is not a drop zone
    columnMoveHide: "eye-slash",
    // shown on ghost icon while dragging columns to reorder
    columnMoveMove: "arrows",
    // animating icon shown when dragging a column to the right of the grid causes horizontal scrolling
    columnMoveLeft: "left",
    // animating icon shown when dragging a column to the left of the grid causes horizontal scrolling
    columnMoveRight: "right",
    // shown on ghost icon while dragging over Row Groups drop zone
    columnMoveGroup: "group",
    // shown on ghost icon while dragging over Values drop zone
    columnMoveValue: "aggregation",
    // shown on ghost icon while dragging over pivot drop zone
    columnMovePivot: "pivot",
    // shown on ghost icon while dragging over drop zone that doesn't support it, e.g.
    //     string column over aggregation drop zone
    dropNotAllowed: "not-allowed",
    // shown on row group when contracted (click to expand)
    groupContracted: "tree-closed",
    // shown on row group when expanded (click to contract)
    groupExpanded: "tree-open",
    // set filter tree list group contracted (click to expand)
    setFilterGroupClosed: "tree-closed",
    // set filter tree list group expanded (click to contract)
    setFilterGroupOpen: "tree-open",
    // set filter tree list expand/collapse all button, shown when some children are expanded and
    //     others are collapsed
    setFilterGroupIndeterminate: "tree-indeterminate",
    // context menu chart item
    chart: "chart",
    // chart window title bar
    close: "cross",
    // X (remove) on column 'pill' after adding it to a drop zone list
    cancel: "cancel",
    // indicates the currently active pin state in the "Pin column" sub-menu of the column menu
    check: "tick",
    // "go to first" button in pagination controls
    first: "first",
    // "go to previous" button in pagination controls
    previous: "previous",
    // "go to next" button in pagination controls
    next: "next",
    // "go to last" button in pagination controls
    last: "last",
    // shown on top right of chart when chart is linked to range data (click to unlink)
    linked: "linked",
    // shown on top right of chart when chart is not linked to range data (click to link)
    unlinked: "unlinked",
    // "Choose colour" button on chart settings tab
    colorPicker: "color-picker",
    // rotating spinner shown by the loading cell renderer
    groupLoading: "loading",
    // button to launch enterprise column menu
    menu: "menu",
    menuAlt: "menu-alt",
    // filter tool panel tab
    filter: "filter",
    // column tool panel tab
    columns: "columns",
    // button in chart regular size window title bar (click to maximise)
    maximize: "maximize",
    // button in chart maximised window title bar (click to make regular size)
    minimize: "minimize",
    // "Pin column" item in column header menu
    menuPin: "pin",
    // "Value aggregation" column menu item (shown on numeric columns when grouping is active)"
    menuValue: "aggregation",
    // "Group by {column-name}" item in column header menu
    menuAddRowGroup: "group",
    // "Un-Group by {column-name}" item in column header menu
    menuRemoveRowGroup: "group",
    // context menu copy item
    clipboardCopy: "copy",
    // context menu cut item
    clipboardCut: "cut",
    // context menu paste item
    clipboardPaste: "paste",
    // identifies the pivot drop zone
    pivotPanel: "pivot",
    // "Row groups" drop zone in column tool panel
    rowGroupPanel: "group",
    // columns tool panel Values drop zone
    valuePanel: "aggregation",
    // drag handle used to pick up draggable columns
    columnDrag: "grip",
    // drag handle used to pick up draggable rows
    rowDrag: "grip",
    // context menu export item
    save: "save",
    // csv export
    csvExport: "csv",
    // excel export,
    excelExport: "excel",
    // icon on dropdown editors
    smallDown: "small-down",
    // version of small-right used in RTL mode
    smallLeft: "small-left",
    // separater between column 'pills' when you add multiple columns to the header drop zone
    smallRight: "small-right",
    smallUp: "small-up",
    // show on column header when column is sorted ascending
    sortAscending: "asc",
    // show on column header when column is sorted descending
    sortDescending: "desc",
    // show on column header when column has no sort, only when enabled with gridOptions.unSortIcon=true
    sortUnSort: "none",
    // Builder button in Advanced Filter
    advancedFilterBuilder: "group",
    // drag handle used to pick up Advanced Filter Builder rows
    advancedFilterBuilderDrag: "grip",
    // Advanced Filter Builder row validation error
    advancedFilterBuilderInvalid: "not-allowed",
    // shown on Advanced Filter Builder rows to move them up
    advancedFilterBuilderMoveUp: "up",
    // shown on Advanced Filter Builder rows to move them down
    advancedFilterBuilderMoveDown: "down",
    // shown on Advanced Filter Builder rows to add new rows
    advancedFilterBuilderAdd: "plus",
    // shown on Advanced Filter Builder rows to remove row
    advancedFilterBuilderRemove: "minus",
    // Edit Chart menu item shown in Integrated Charts menu
    chartsMenuEdit: "chart",
    // Advanced Settings menu item shown in Integrated Charts menu
    chartsMenuAdvancedSettings: "settings",
    // shown in Integrated Charts menu add fields
    chartsMenuAdd: "plus"
};
function createIcon(iconName, gos, column) {
    const iconContents = createIconNoSpan(iconName, gos, column);
    if (iconContents) {
        const { className } = iconContents;
        if (typeof className === "string" && className.indexOf("ag-icon") > -1 || typeof className === "object" && className["ag-icon"]) return iconContents;
    }
    const eResult = document.createElement("span");
    eResult.appendChild(iconContents);
    return eResult;
}
function createIconNoSpan(iconName, gos, column, forceCreate) {
    let userProvidedIcon = null;
    const icons = column && column.getColDef().icons;
    if (icons) userProvidedIcon = icons[iconName];
    if (gos && !userProvidedIcon) {
        const optionsIcons = gos.get("icons");
        if (optionsIcons) userProvidedIcon = optionsIcons[iconName];
    }
    if (userProvidedIcon) {
        let rendererResult;
        if (typeof userProvidedIcon === "function") rendererResult = userProvidedIcon();
        else if (typeof userProvidedIcon === "string") rendererResult = userProvidedIcon;
        else throw new Error("icon from grid options needs to be a string or a function");
        if (typeof rendererResult === "string") return loadTemplate(rendererResult);
        if (isNodeOrElement(rendererResult)) return rendererResult;
        console.warn("AG Grid: iconRenderer should return back a string or a dom object");
    } else {
        const span = document.createElement("span");
        let cssClass = iconNameClassMap[iconName];
        if (!cssClass) {
            if (!forceCreate) {
                console.warn(`AG Grid: Did not find icon ${iconName}`);
                cssClass = "";
            } else cssClass = iconName;
        }
        span.setAttribute("class", `ag-icon ag-icon-${cssClass}`);
        span.setAttribute("unselectable", "on");
        setAriaRole(span, "presentation");
        return span;
    }
}
// community-modules/core/src/utils/keyboard.ts
var keyboard_exports = {};
__export(keyboard_exports, {
    isDeleteKey: ()=>isDeleteKey,
    isEventFromPrintableCharacter: ()=>isEventFromPrintableCharacter,
    isUserSuppressingHeaderKeyboardEvent: ()=>isUserSuppressingHeaderKeyboardEvent,
    isUserSuppressingKeyboardEvent: ()=>isUserSuppressingKeyboardEvent,
    normaliseQwertyAzerty: ()=>normaliseQwertyAzerty
});
// community-modules/core/src/constants/keyCode.ts
var KeyCode = class {
};
KeyCode.BACKSPACE = "Backspace";
KeyCode.TAB = "Tab";
KeyCode.ENTER = "Enter";
KeyCode.ESCAPE = "Escape";
KeyCode.SPACE = " ";
KeyCode.LEFT = "ArrowLeft";
KeyCode.UP = "ArrowUp";
KeyCode.RIGHT = "ArrowRight";
KeyCode.DOWN = "ArrowDown";
KeyCode.DELETE = "Delete";
KeyCode.F2 = "F2";
KeyCode.PAGE_UP = "PageUp";
KeyCode.PAGE_DOWN = "PageDown";
KeyCode.PAGE_HOME = "Home";
KeyCode.PAGE_END = "End";
// these should be used with `event.code` instead of `event.key`
// as `event.key` changes when non-latin keyboards are used
KeyCode.A = "KeyA";
KeyCode.C = "KeyC";
KeyCode.D = "KeyD";
KeyCode.V = "KeyV";
KeyCode.X = "KeyX";
KeyCode.Y = "KeyY";
KeyCode.Z = "KeyZ";
// community-modules/core/src/utils/keyboard.ts
var A_KEYCODE = 65;
var C_KEYCODE = 67;
var V_KEYCODE = 86;
var D_KEYCODE = 68;
var Z_KEYCODE = 90;
var Y_KEYCODE = 89;
function isEventFromPrintableCharacter(event) {
    if (event.altKey || event.ctrlKey || event.metaKey) return false;
    const printableCharacter = event.key.length === 1;
    return printableCharacter;
}
function isUserSuppressingKeyboardEvent(gos, keyboardEvent, rowNode, column, editing) {
    const colDefFunc = column ? column.getColDef().suppressKeyboardEvent : void 0;
    if (!colDefFunc) return false;
    const params = gos.addGridCommonParams({
        event: keyboardEvent,
        editing,
        column,
        node: rowNode,
        data: rowNode.data,
        colDef: column.getColDef()
    });
    if (colDefFunc) {
        const colDefFuncResult = colDefFunc(params);
        if (colDefFuncResult) return true;
    }
    return false;
}
function isUserSuppressingHeaderKeyboardEvent(gos, keyboardEvent, headerRowIndex, column) {
    const colDef = column.getDefinition();
    const colDefFunc = colDef && colDef.suppressHeaderKeyboardEvent;
    if (!exists(colDefFunc)) return false;
    const params = gos.addGridCommonParams({
        colDef,
        column,
        headerRowIndex,
        event: keyboardEvent
    });
    return !!colDefFunc(params);
}
function normaliseQwertyAzerty(keyboardEvent) {
    const { keyCode } = keyboardEvent;
    let code;
    switch(keyCode){
        case A_KEYCODE:
            code = KeyCode.A;
            break;
        case C_KEYCODE:
            code = KeyCode.C;
            break;
        case V_KEYCODE:
            code = KeyCode.V;
            break;
        case D_KEYCODE:
            code = KeyCode.D;
            break;
        case Z_KEYCODE:
            code = KeyCode.Z;
            break;
        case Y_KEYCODE:
            code = KeyCode.Y;
            break;
        default:
            code = keyboardEvent.code;
    }
    return code;
}
function isDeleteKey(key, alwaysReturnFalseOnBackspace = false) {
    if (key === KeyCode.DELETE) return true;
    if (!alwaysReturnFalseOnBackspace && key === KeyCode.BACKSPACE) return isMacOsUserAgent();
    return false;
}
// community-modules/core/src/utils/mouse.ts
var mouse_exports = {};
__export(mouse_exports, {
    areEventsNear: ()=>areEventsNear
});
function areEventsNear(e1, e2, pixelCount) {
    if (pixelCount === 0) return false;
    const diffX = Math.abs(e1.clientX - e2.clientX);
    const diffY = Math.abs(e1.clientY - e2.clientY);
    return Math.max(diffX, diffY) <= pixelCount;
}
// community-modules/core/src/utils/rowNode.ts
var rowNode_exports = {};
__export(rowNode_exports, {
    sortRowNodesByOrder: ()=>sortRowNodesByOrder
});
function sortRowNodesByOrder(rowNodes, rowNodeOrder) {
    if (!rowNodes) return false;
    const comparator = (nodeA, nodeB)=>{
        const positionA = rowNodeOrder[nodeA.id];
        const positionB = rowNodeOrder[nodeB.id];
        const aHasIndex = positionA !== void 0;
        const bHasIndex = positionB !== void 0;
        const bothNodesAreUserNodes = aHasIndex && bHasIndex;
        const bothNodesAreFillerNodes = !aHasIndex && !bHasIndex;
        if (bothNodesAreUserNodes) return positionA - positionB;
        if (bothNodesAreFillerNodes) return nodeA.__objectId - nodeB.__objectId;
        if (aHasIndex) return 1;
        return -1;
    };
    let rowNodeA;
    let rowNodeB;
    let atLeastOneOutOfOrder = false;
    for(let i = 0; i < rowNodes.length - 1; i++){
        rowNodeA = rowNodes[i];
        rowNodeB = rowNodes[i + 1];
        if (comparator(rowNodeA, rowNodeB) > 0) {
            atLeastOneOutOfOrder = true;
            break;
        }
    }
    if (atLeastOneOutOfOrder) {
        rowNodes.sort(comparator);
        return true;
    }
    return false;
}
// community-modules/core/src/utils/set.ts
var set_exports = {};
__export(set_exports, {
    convertToSet: ()=>convertToSet
});
function convertToSet(list) {
    const set = /* @__PURE__ */ new Set();
    list.forEach((x)=>set.add(x));
    return set;
}
// community-modules/core/src/utils/utils.ts
var utils = __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, aria_exports), array_exports), browser_exports), date_exports), dom_exports), event_exports), function_exports), fuzzyMatch_exports), generic_exports), icon_exports), keyboard_exports), map_exports), mouse_exports), number_exports), object_exports), rowNode_exports), set_exports), string_exports);
var _ = utils;
// community-modules/core/src/utils/numberSequence.ts
var NumberSequence = class {
    constructor(initValue = 0, step = 1){
        this.nextValue = initValue;
        this.step = step;
    }
    next() {
        const valToReturn = this.nextValue;
        this.nextValue += this.step;
        return valToReturn;
    }
    peek() {
        return this.nextValue;
    }
    skip(count) {
        this.nextValue += count;
    }
};
// community-modules/core/src/utils/promise.ts
var AgPromiseStatus = /* @__PURE__ */ ((AgPromiseStatus2)=>{
    AgPromiseStatus2[AgPromiseStatus2["IN_PROGRESS"] = 0] = "IN_PROGRESS";
    AgPromiseStatus2[AgPromiseStatus2["RESOLVED"] = 1] = "RESOLVED";
    return AgPromiseStatus2;
})(AgPromiseStatus || {});
var AgPromise = class _AgPromise {
    constructor(callback){
        this.status = 0 /* IN_PROGRESS */ ;
        this.resolution = null;
        this.waiters = [];
        callback((value)=>this.onDone(value), (params)=>this.onReject(params));
    }
    static all(promises) {
        return new _AgPromise((resolve)=>{
            let remainingToResolve = promises.length;
            const combinedValues = new Array(remainingToResolve);
            promises.forEach((promise, index)=>{
                promise.then((value)=>{
                    combinedValues[index] = value;
                    remainingToResolve--;
                    if (remainingToResolve === 0) resolve(combinedValues);
                });
            });
        });
    }
    static resolve(value = null) {
        return new _AgPromise((resolve)=>resolve(value));
    }
    then(func) {
        return new _AgPromise((resolve)=>{
            if (this.status === 1 /* RESOLVED */ ) resolve(func(this.resolution));
            else this.waiters.push((value)=>resolve(func(value)));
        });
    }
    resolveNow(ifNotResolvedValue, ifResolved) {
        return this.status === 1 /* RESOLVED */  ? ifResolved(this.resolution) : ifNotResolvedValue;
    }
    onDone(value) {
        this.status = 1 /* RESOLVED */ ;
        this.resolution = value;
        this.waiters.forEach((waiter)=>waiter(value));
    }
    onReject(params) {
        console.warn("TBI");
    }
};
// community-modules/core/src/utils/timer.ts
var Timer = class {
    constructor(){
        this.timestamp = /* @__PURE__ */ new Date().getTime();
    }
    print(msg) {
        const duration = /* @__PURE__ */ new Date().getTime() - this.timestamp;
        console.info(`${msg} = ${duration}`);
        this.timestamp = /* @__PURE__ */ new Date().getTime();
    }
};
// community-modules/core/src/rendering/cssClassManager.ts
var CssClassManager = class {
    constructor(getGui){
        // to minimise DOM hits, we only apply CSS classes if they have changed. as adding a CSS class that is already
        // there, or removing one that wasn't present, all takes CPU.
        this.cssClassStates = {};
        this.getGui = getGui;
    }
    addCssClass(className) {
        const list = (className || "").split(" ");
        if (list.length > 1) {
            list.forEach((cls)=>this.addCssClass(cls));
            return;
        }
        const updateNeeded = this.cssClassStates[className] !== true;
        if (updateNeeded && className.length) {
            const eGui = this.getGui();
            if (eGui) eGui.classList.add(className);
            this.cssClassStates[className] = true;
        }
    }
    removeCssClass(className) {
        const list = (className || "").split(" ");
        if (list.length > 1) {
            list.forEach((cls)=>this.removeCssClass(cls));
            return;
        }
        const updateNeeded = this.cssClassStates[className] !== false;
        if (updateNeeded && className.length) {
            const eGui = this.getGui();
            if (eGui) eGui.classList.remove(className);
            this.cssClassStates[className] = false;
        }
    }
    containsCssClass(className) {
        const eGui = this.getGui();
        if (!eGui) return false;
        return eGui.classList.contains(className);
    }
    addOrRemoveCssClass(className, addOrRemove) {
        if (!className) return;
        if (className.indexOf(" ") >= 0) {
            const list = (className || "").split(" ");
            if (list.length > 1) {
                list.forEach((cls)=>this.addOrRemoveCssClass(cls, addOrRemove));
                return;
            }
        }
        const updateNeeded = this.cssClassStates[className] !== addOrRemove;
        if (updateNeeded && className.length) {
            const eGui = this.getGui();
            if (eGui) eGui.classList.toggle(className, addOrRemove);
            this.cssClassStates[className] = addOrRemove;
        }
    }
};
// community-modules/core/src/widgets/tooltipStateManager.ts
var _TooltipStateManager = class _TooltipStateManager extends BeanStub {
    constructor(parentComp, tooltipShowDelayOverride, tooltipHideDelayOverride, shouldDisplayTooltip){
        super();
        this.parentComp = parentComp;
        this.tooltipShowDelayOverride = tooltipShowDelayOverride;
        this.tooltipHideDelayOverride = tooltipHideDelayOverride;
        this.shouldDisplayTooltip = shouldDisplayTooltip;
        this.SHOW_QUICK_TOOLTIP_DIFF = 1e3;
        this.FADE_OUT_TOOLTIP_TIMEOUT = 1e3;
        this.INTERACTIVE_HIDE_DELAY = 100;
        this.interactionEnabled = false;
        this.isInteractingWithTooltip = false;
        this.state = 0 /* NOTHING */ ;
        // when showing the tooltip, we need to make sure it's the most recent instance we request, as due to
        // async we could request two tooltips before the first instance returns, in which case we should
        // disregard the second instance.
        this.tooltipInstanceCount = 0;
        this.tooltipMouseTrack = false;
    }
    postConstruct() {
        if (this.gos.get("tooltipInteraction")) this.interactionEnabled = true;
        this.tooltipTrigger = this.getTooltipTrigger();
        this.tooltipMouseTrack = this.gos.get("tooltipMouseTrack");
        const el = this.parentComp.getGui();
        if (this.tooltipTrigger === 0 /* HOVER */ ) {
            this.addManagedListener(el, "mouseenter", this.onMouseEnter.bind(this));
            this.addManagedListener(el, "mouseleave", this.onMouseLeave.bind(this));
        }
        if (this.tooltipTrigger === 1 /* FOCUS */ ) {
            this.addManagedListener(el, "focusin", this.onFocusIn.bind(this));
            this.addManagedListener(el, "focusout", this.onFocusOut.bind(this));
        }
        this.addManagedListener(el, "mousemove", this.onMouseMove.bind(this));
        if (!this.interactionEnabled) {
            this.addManagedListener(el, "mousedown", this.onMouseDown.bind(this));
            this.addManagedListener(el, "keydown", this.onKeyDown.bind(this));
        }
    }
    getGridOptionsTooltipDelay(delayOption) {
        const delay = this.gos.get(delayOption);
        if (delay < 0) warnOnce(`${delayOption} should not be lower than 0`);
        return Math.max(200, delay);
    }
    getTooltipDelay(type) {
        var _a, _b;
        if (type === "show") return (_a = this.tooltipShowDelayOverride) != null ? _a : this.getGridOptionsTooltipDelay("tooltipShowDelay");
        return (_b = this.tooltipHideDelayOverride) != null ? _b : this.getGridOptionsTooltipDelay("tooltipHideDelay");
    }
    destroy() {
        this.setToDoNothing();
        super.destroy();
    }
    getTooltipTrigger() {
        const trigger = this.gos.get("tooltipTrigger");
        if (!trigger || trigger === "hover") return 0 /* HOVER */ ;
        return 1 /* FOCUS */ ;
    }
    onMouseEnter(e) {
        if (this.interactionEnabled && this.interactiveTooltipTimeoutId) {
            this.unlockService();
            this.startHideTimeout();
        }
        if (isIOSUserAgent()) return;
        if (_TooltipStateManager.isLocked) this.showTooltipTimeoutId = window.setTimeout(()=>{
            this.prepareToShowTooltip(e);
        }, this.INTERACTIVE_HIDE_DELAY);
        else this.prepareToShowTooltip(e);
    }
    onMouseMove(e) {
        if (this.lastMouseEvent) this.lastMouseEvent = e;
        if (this.tooltipMouseTrack && this.state === 2 /* SHOWING */  && this.tooltipComp) this.positionTooltip();
    }
    onMouseDown() {
        this.setToDoNothing();
    }
    onMouseLeave() {
        if (this.interactionEnabled) this.lockService();
        else this.setToDoNothing();
    }
    onFocusIn() {
        this.prepareToShowTooltip();
    }
    onFocusOut(e) {
        var _a;
        const relatedTarget = e.relatedTarget;
        const parentCompGui = this.parentComp.getGui();
        const tooltipGui = (_a = this.tooltipComp) == null ? void 0 : _a.getGui();
        if (this.isInteractingWithTooltip || parentCompGui.contains(relatedTarget) || this.interactionEnabled && (tooltipGui == null ? void 0 : tooltipGui.contains(relatedTarget))) return;
        this.setToDoNothing();
    }
    onKeyDown() {
        this.setToDoNothing();
    }
    prepareToShowTooltip(mouseEvent) {
        if (this.state != 0 /* NOTHING */  || _TooltipStateManager.isLocked) return;
        let delay = 0;
        if (mouseEvent) delay = this.isLastTooltipHiddenRecently() ? 200 : this.getTooltipDelay("show");
        this.lastMouseEvent = mouseEvent || null;
        this.showTooltipTimeoutId = window.setTimeout(this.showTooltip.bind(this), delay);
        this.state = 1 /* WAITING_TO_SHOW */ ;
    }
    isLastTooltipHiddenRecently() {
        const now = /* @__PURE__ */ new Date().getTime();
        const then = _TooltipStateManager.lastTooltipHideTime;
        return now - then < this.SHOW_QUICK_TOOLTIP_DIFF;
    }
    setToDoNothing() {
        if (this.state === 2 /* SHOWING */ ) this.hideTooltip();
        if (this.onBodyScrollEventCallback) {
            this.onBodyScrollEventCallback();
            this.onBodyScrollEventCallback = void 0;
        }
        if (this.onColumnMovedEventCallback) {
            this.onColumnMovedEventCallback();
            this.onColumnMovedEventCallback = void 0;
        }
        this.clearTimeouts();
        this.state = 0 /* NOTHING */ ;
        this.lastMouseEvent = null;
    }
    showTooltip() {
        const params = __spreadValues({}, this.parentComp.getTooltipParams());
        if (!exists(params.value) || this.shouldDisplayTooltip && !this.shouldDisplayTooltip()) {
            this.setToDoNothing();
            return;
        }
        this.state = 2 /* SHOWING */ ;
        this.tooltipInstanceCount++;
        const callback = this.newTooltipComponentCallback.bind(this, this.tooltipInstanceCount);
        const userDetails = this.userComponentFactory.getTooltipCompDetails(params);
        userDetails.newAgStackInstance().then(callback);
    }
    hideTooltip(forceHide) {
        if (!forceHide && this.isInteractingWithTooltip) return;
        if (this.tooltipComp) {
            this.destroyTooltipComp();
            _TooltipStateManager.lastTooltipHideTime = /* @__PURE__ */ new Date().getTime();
        }
        const event = {
            type: Events.EVENT_TOOLTIP_HIDE,
            parentGui: this.parentComp.getGui()
        };
        this.eventService.dispatchEvent(event);
        this.state = 0 /* NOTHING */ ;
    }
    newTooltipComponentCallback(tooltipInstanceCopy, tooltipComp) {
        const compNoLongerNeeded = this.state !== 2 /* SHOWING */  || this.tooltipInstanceCount !== tooltipInstanceCopy;
        if (compNoLongerNeeded) {
            this.getContext().destroyBean(tooltipComp);
            return;
        }
        const eGui = tooltipComp.getGui();
        this.tooltipComp = tooltipComp;
        if (!eGui.classList.contains("ag-tooltip")) eGui.classList.add("ag-tooltip-custom");
        if (this.tooltipTrigger === 0 /* HOVER */ ) eGui.classList.add("ag-tooltip-animate");
        if (this.interactionEnabled) eGui.classList.add("ag-tooltip-interactive");
        const translate = this.localeService.getLocaleTextFunc();
        const addPopupRes = this.popupService.addPopup({
            eChild: eGui,
            ariaLabel: translate("ariaLabelTooltip", "Tooltip")
        });
        if (addPopupRes) this.tooltipPopupDestroyFunc = addPopupRes.hideFunc;
        this.positionTooltip();
        if (this.tooltipTrigger === 1 /* FOCUS */ ) {
            this.onBodyScrollEventCallback = this.addManagedListener(this.eventService, Events.EVENT_BODY_SCROLL, this.setToDoNothing.bind(this));
            this.onColumnMovedEventCallback = this.addManagedListener(this.eventService, Events.EVENT_COLUMN_MOVED, this.setToDoNothing.bind(this));
        }
        if (this.interactionEnabled) {
            if (this.tooltipTrigger === 0 /* HOVER */ ) {
                this.tooltipMouseEnterListener = this.addManagedListener(eGui, "mouseenter", this.onTooltipMouseEnter.bind(this)) || null;
                this.tooltipMouseLeaveListener = this.addManagedListener(eGui, "mouseleave", this.onTooltipMouseLeave.bind(this)) || null;
            } else {
                this.tooltipFocusInListener = this.addManagedListener(eGui, "focusin", this.onTooltipFocusIn.bind(this)) || null;
                this.tooltipFocusOutListener = this.addManagedListener(eGui, "focusout", this.onTooltipFocusOut.bind(this)) || null;
            }
        }
        const event = {
            type: Events.EVENT_TOOLTIP_SHOW,
            tooltipGui: eGui,
            parentGui: this.parentComp.getGui()
        };
        this.eventService.dispatchEvent(event);
        this.startHideTimeout();
    }
    onTooltipMouseEnter() {
        this.isInteractingWithTooltip = true;
        this.unlockService();
    }
    onTooltipMouseLeave() {
        this.isInteractingWithTooltip = false;
        this.lockService();
    }
    onTooltipFocusIn() {
        this.isInteractingWithTooltip = true;
    }
    onTooltipFocusOut(e) {
        var _a;
        const parentGui = this.parentComp.getGui();
        const tooltipGui = (_a = this.tooltipComp) == null ? void 0 : _a.getGui();
        const relatedTarget = e.relatedTarget;
        if (tooltipGui == null ? void 0 : tooltipGui.contains(relatedTarget)) return;
        this.isInteractingWithTooltip = false;
        if (parentGui.contains(relatedTarget)) this.startHideTimeout();
        else this.hideTooltip();
    }
    positionTooltip() {
        const params = {
            type: "tooltip",
            ePopup: this.tooltipComp.getGui(),
            nudgeY: 18,
            skipObserver: this.tooltipMouseTrack
        };
        if (this.lastMouseEvent) this.popupService.positionPopupUnderMouseEvent(__spreadProps(__spreadValues({}, params), {
            mouseEvent: this.lastMouseEvent
        }));
        else this.popupService.positionPopupByComponent(__spreadProps(__spreadValues({}, params), {
            eventSource: this.parentComp.getGui(),
            position: "under",
            keepWithinBounds: true,
            nudgeY: 5
        }));
    }
    destroyTooltipComp() {
        this.tooltipComp.getGui().classList.add("ag-tooltip-hiding");
        const tooltipPopupDestroyFunc = this.tooltipPopupDestroyFunc;
        const tooltipComp = this.tooltipComp;
        const delay = this.tooltipTrigger === 0 /* HOVER */  ? this.FADE_OUT_TOOLTIP_TIMEOUT : 0;
        window.setTimeout(()=>{
            tooltipPopupDestroyFunc();
            this.getContext().destroyBean(tooltipComp);
        }, delay);
        this.clearTooltipListeners();
        this.tooltipPopupDestroyFunc = void 0;
        this.tooltipComp = void 0;
    }
    clearTooltipListeners() {
        [
            this.tooltipMouseEnterListener,
            this.tooltipMouseLeaveListener,
            this.tooltipFocusInListener,
            this.tooltipFocusOutListener
        ].forEach((listener)=>{
            if (listener) listener();
        });
        this.tooltipMouseEnterListener = this.tooltipMouseLeaveListener = this.tooltipFocusInListener = this.tooltipFocusOutListener = null;
    }
    lockService() {
        _TooltipStateManager.isLocked = true;
        this.interactiveTooltipTimeoutId = window.setTimeout(()=>{
            this.unlockService();
            this.setToDoNothing();
        }, this.INTERACTIVE_HIDE_DELAY);
    }
    unlockService() {
        _TooltipStateManager.isLocked = false;
        this.clearInteractiveTimeout();
    }
    startHideTimeout() {
        this.clearHideTimeout();
        this.hideTooltipTimeoutId = window.setTimeout(this.hideTooltip.bind(this), this.getTooltipDelay("hide"));
    }
    clearShowTimeout() {
        if (!this.showTooltipTimeoutId) return;
        window.clearTimeout(this.showTooltipTimeoutId);
        this.showTooltipTimeoutId = void 0;
    }
    clearHideTimeout() {
        if (!this.hideTooltipTimeoutId) return;
        window.clearTimeout(this.hideTooltipTimeoutId);
        this.hideTooltipTimeoutId = void 0;
    }
    clearInteractiveTimeout() {
        if (!this.interactiveTooltipTimeoutId) return;
        window.clearTimeout(this.interactiveTooltipTimeoutId);
        this.interactiveTooltipTimeoutId = void 0;
    }
    clearTimeouts() {
        this.clearShowTimeout();
        this.clearHideTimeout();
        this.clearInteractiveTimeout();
    }
};
_TooltipStateManager.isLocked = false;
__decorateClass([
    Autowired("popupService")
], _TooltipStateManager.prototype, "popupService", 2);
__decorateClass([
    Autowired("userComponentFactory")
], _TooltipStateManager.prototype, "userComponentFactory", 2);
__decorateClass([
    PostConstruct
], _TooltipStateManager.prototype, "postConstruct", 1);
var TooltipStateManager = _TooltipStateManager;
// community-modules/core/src/widgets/tooltipFeature.ts
var TooltipFeature = class extends BeanStub {
    constructor(ctrl, beans){
        super();
        this.ctrl = ctrl;
        if (beans) this.beans = beans;
    }
    postConstruct() {
        this.refreshToolTip();
    }
    setBrowserTooltip(tooltip) {
        const name = "title";
        const eGui = this.ctrl.getGui();
        if (!eGui) return;
        if (tooltip != null && tooltip != "") eGui.setAttribute(name, tooltip);
        else eGui.removeAttribute(name);
    }
    updateTooltipText() {
        this.tooltip = this.ctrl.getTooltipValue();
    }
    createTooltipFeatureIfNeeded() {
        var _a, _b, _c, _d;
        if (this.tooltipManager != null) return;
        const parent = {
            getTooltipParams: ()=>this.getTooltipParams(),
            getGui: ()=>this.ctrl.getGui()
        };
        this.tooltipManager = this.createBean(new TooltipStateManager(parent, (_b = (_a = this.ctrl).getTooltipShowDelayOverride) == null ? void 0 : _b.call(_a), (_d = (_c = this.ctrl).getTooltipHideDelayOverride) == null ? void 0 : _d.call(_c), this.ctrl.shouldDisplayTooltip), this.beans.context);
    }
    refreshToolTip() {
        this.browserTooltips = this.beans.gos.get("enableBrowserTooltips");
        this.updateTooltipText();
        if (this.browserTooltips) {
            this.setBrowserTooltip(this.tooltip);
            if (this.tooltipManager) this.tooltipManager = this.destroyBean(this.tooltipManager, this.beans.context);
        } else {
            this.setBrowserTooltip(null);
            this.createTooltipFeatureIfNeeded();
        }
    }
    getTooltipParams() {
        const ctrl = this.ctrl;
        const column = ctrl.getColumn ? ctrl.getColumn() : void 0;
        const colDef = ctrl.getColDef ? ctrl.getColDef() : void 0;
        const rowNode = ctrl.getRowNode ? ctrl.getRowNode() : void 0;
        return {
            location: ctrl.getLocation(),
            //'cell',
            colDef,
            column,
            rowIndex: ctrl.getRowIndex ? ctrl.getRowIndex() : void 0,
            node: rowNode,
            data: rowNode ? rowNode.data : void 0,
            value: this.getTooltipText(),
            valueFormatted: ctrl.getValueFormatted ? ctrl.getValueFormatted() : void 0,
            hideTooltipCallback: ()=>{
                var _a;
                return (_a = this.tooltipManager) == null ? void 0 : _a.hideTooltip(true);
            }
        };
    }
    getTooltipText() {
        return this.tooltip;
    }
    // overriding to make public, as we don't dispose this bean via context
    destroy() {
        if (this.tooltipManager) this.tooltipManager = this.destroyBean(this.tooltipManager, this.beans.context);
        super.destroy();
    }
};
__decorateClass([
    Autowired("beans")
], TooltipFeature.prototype, "beans", 2);
__decorateClass([
    PostConstruct
], TooltipFeature.prototype, "postConstruct", 1);
// community-modules/core/src/widgets/component.ts
var compIdSequence = new NumberSequence();
var _Component = class _Component extends BeanStub {
    constructor(template){
        super();
        // if false, then CSS class "ag-hidden" is applied, which sets "display: none"
        this.displayed = true;
        // if false, then CSS class "ag-invisible" is applied, which sets "visibility: hidden"
        this.visible = true;
        // unique id for this row component. this is used for getting a reference to the HTML dom.
        // we cannot use the RowNode id as this is not unique (due to animation, old rows can be lying
        // around as we create a new rowComp instance for the same row node).
        this.compId = compIdSequence.next();
        this.cssClassManager = new CssClassManager(()=>this.eGui);
        if (template) this.setTemplate(template);
    }
    preConstructOnComponent() {
        this.usingBrowserTooltips = this.gos.get("enableBrowserTooltips");
    }
    getCompId() {
        return this.compId;
    }
    getTooltipParams() {
        return {
            value: this.tooltipText,
            location: "UNKNOWN"
        };
    }
    setTooltip(params) {
        const { newTooltipText, showDelayOverride, hideDelayOverride, location, shouldDisplayTooltip } = params || {};
        if (this.tooltipFeature) this.tooltipFeature = this.destroyBean(this.tooltipFeature);
        if (this.tooltipText !== newTooltipText) this.tooltipText = newTooltipText;
        const getTooltipValue = ()=>this.tooltipText;
        if (newTooltipText != null) this.tooltipFeature = this.createBean(new TooltipFeature({
            getTooltipValue,
            getGui: ()=>this.getGui(),
            getLocation: ()=>location != null ? location : "UNKNOWN",
            getColDef: params == null ? void 0 : params.getColDef,
            getColumn: params == null ? void 0 : params.getColumn,
            getTooltipShowDelayOverride: showDelayOverride != null ? ()=>showDelayOverride : void 0,
            getTooltipHideDelayOverride: hideDelayOverride != null ? ()=>hideDelayOverride : void 0,
            shouldDisplayTooltip
        }));
    }
    // for registered components only, eg creates AgCheckbox instance from ag-checkbox HTML tag
    createChildComponentsFromTags(parentNode, paramsMap) {
        const childNodeList = copyNodeList(parentNode.childNodes);
        childNodeList.forEach((childNode)=>{
            if (!(childNode instanceof HTMLElement)) return;
            const childComp = this.createComponentFromElement(childNode, (childComp2)=>{
                const childGui = childComp2.getGui();
                if (childGui) this.copyAttributesFromNode(childNode, childComp2.getGui());
            }, paramsMap);
            if (childComp) {
                if (childComp.addItems && childNode.children.length) {
                    this.createChildComponentsFromTags(childNode, paramsMap);
                    const items = Array.prototype.slice.call(childNode.children);
                    childComp.addItems(items);
                }
                this.swapComponentForNode(childComp, parentNode, childNode);
            } else if (childNode.childNodes) this.createChildComponentsFromTags(childNode, paramsMap);
        });
    }
    createComponentFromElement(element, afterPreCreateCallback, paramsMap) {
        const key = element.nodeName;
        const componentParams = paramsMap ? paramsMap[element.getAttribute("ref")] : void 0;
        const ComponentClass = this.agStackComponentsRegistry.getComponentClass(key);
        if (ComponentClass) {
            _Component.elementGettingCreated = element;
            const newComponent = new ComponentClass(componentParams);
            newComponent.setParentComponent(this);
            this.createBean(newComponent, null, afterPreCreateCallback);
            return newComponent;
        }
        return null;
    }
    copyAttributesFromNode(source, dest) {
        iterateNamedNodeMap(source.attributes, (name, value)=>dest.setAttribute(name, value));
    }
    swapComponentForNode(newComponent, parentNode, childNode) {
        const eComponent = newComponent.getGui();
        parentNode.replaceChild(eComponent, childNode);
        parentNode.insertBefore(document.createComment(childNode.nodeName), eComponent);
        this.addDestroyFunc(this.destroyBean.bind(this, newComponent));
        this.swapInComponentForQuerySelectors(newComponent, childNode);
    }
    swapInComponentForQuerySelectors(newComponent, childNode) {
        const thisNoType = this;
        this.iterateOverQuerySelectors((querySelector)=>{
            if (thisNoType[querySelector.attributeName] === childNode) thisNoType[querySelector.attributeName] = newComponent;
        });
    }
    iterateOverQuerySelectors(action) {
        let thisPrototype = Object.getPrototypeOf(this);
        while(thisPrototype != null){
            const metaData = thisPrototype.__agComponentMetaData;
            const currentProtoName = getFunctionName(thisPrototype.constructor);
            if (metaData && metaData[currentProtoName] && metaData[currentProtoName].querySelectors) metaData[currentProtoName].querySelectors.forEach((querySelector)=>action(querySelector));
            thisPrototype = Object.getPrototypeOf(thisPrototype);
        }
    }
    activateTabIndex(elements) {
        const tabIndex = this.gos.get("tabIndex");
        if (!elements) elements = [];
        if (!elements.length) elements.push(this.getGui());
        elements.forEach((el)=>el.setAttribute("tabindex", tabIndex.toString()));
    }
    setTemplate(template, paramsMap) {
        const eGui = loadTemplate(template);
        this.setTemplateFromElement(eGui, paramsMap);
    }
    setTemplateFromElement(element, paramsMap) {
        this.eGui = element;
        this.eGui.__agComponent = this;
        this.wireQuerySelectors();
        if (!!this.getContext()) this.createChildComponentsFromTags(this.getGui(), paramsMap);
    }
    createChildComponentsPreConstruct() {
        if (!!this.getGui()) this.createChildComponentsFromTags(this.getGui());
    }
    wireQuerySelectors() {
        if (!this.eGui) return;
        const thisNoType = this;
        this.iterateOverQuerySelectors((querySelector)=>{
            const setResult = (result)=>thisNoType[querySelector.attributeName] = result;
            const topLevelRefMatch = querySelector.refSelector && this.getAttribute("ref") === querySelector.refSelector;
            if (topLevelRefMatch) setResult(this.eGui);
            else {
                const resultOfQuery = this.eGui.querySelector(querySelector.querySelector);
                if (resultOfQuery) setResult(resultOfQuery.__agComponent || resultOfQuery);
            }
        });
    }
    getGui() {
        return this.eGui;
    }
    getFocusableElement() {
        return this.eGui;
    }
    getAriaElement() {
        return this.getFocusableElement();
    }
    setParentComponent(component) {
        this.parentComponent = component;
    }
    getParentComponent() {
        return this.parentComponent;
    }
    // this method is for older code, that wants to provide the gui element,
    // it is not intended for this to be in ag-Stack
    setGui(eGui) {
        this.eGui = eGui;
    }
    queryForHtmlElement(cssSelector) {
        return this.eGui.querySelector(cssSelector);
    }
    queryForHtmlInputElement(cssSelector) {
        return this.eGui.querySelector(cssSelector);
    }
    appendChild(newChild, container) {
        if (newChild == null) return;
        if (!container) container = this.eGui;
        if (isNodeOrElement(newChild)) container.appendChild(newChild);
        else {
            const childComponent = newChild;
            container.appendChild(childComponent.getGui());
        }
    }
    isDisplayed() {
        return this.displayed;
    }
    setVisible(visible, options = {}) {
        if (visible !== this.visible) {
            this.visible = visible;
            const { skipAriaHidden } = options;
            setVisible(this.eGui, visible, {
                skipAriaHidden
            });
        }
    }
    setDisplayed(displayed, options = {}) {
        if (displayed !== this.displayed) {
            this.displayed = displayed;
            const { skipAriaHidden } = options;
            setDisplayed(this.eGui, displayed, {
                skipAriaHidden
            });
            const event = {
                type: _Component.EVENT_DISPLAYED_CHANGED,
                visible: this.displayed
            };
            this.dispatchEvent(event);
        }
    }
    destroy() {
        if (this.parentComponent) this.parentComponent = void 0;
        if (this.tooltipFeature) this.tooltipFeature = this.destroyBean(this.tooltipFeature);
        const eGui = this.eGui;
        if (eGui && eGui.__agComponent) eGui.__agComponent = void 0;
        super.destroy();
    }
    addGuiEventListener(event, listener, options) {
        this.eGui.addEventListener(event, listener, options);
        this.addDestroyFunc(()=>this.eGui.removeEventListener(event, listener));
    }
    addCssClass(className) {
        this.cssClassManager.addCssClass(className);
    }
    removeCssClass(className) {
        this.cssClassManager.removeCssClass(className);
    }
    containsCssClass(className) {
        return this.cssClassManager.containsCssClass(className);
    }
    addOrRemoveCssClass(className, addOrRemove) {
        this.cssClassManager.addOrRemoveCssClass(className, addOrRemove);
    }
    getAttribute(key) {
        const { eGui } = this;
        return eGui ? eGui.getAttribute(key) : null;
    }
    getRefElement(refName) {
        return this.queryForHtmlElement(`[ref="${refName}"]`);
    }
};
_Component.EVENT_DISPLAYED_CHANGED = "displayedChanged";
__decorateClass([
    Autowired("agStackComponentsRegistry")
], _Component.prototype, "agStackComponentsRegistry", 2);
__decorateClass([
    PreConstruct
], _Component.prototype, "preConstructOnComponent", 1);
__decorateClass([
    PreConstruct
], _Component.prototype, "createChildComponentsPreConstruct", 1);
var Component = _Component;
// community-modules/core/src/widgets/componentAnnotations.ts
function QuerySelector(selector) {
    return querySelectorFunc.bind(this, selector, void 0);
}
function RefSelector(ref) {
    return querySelectorFunc.bind(this, `[ref=${ref}]`, ref);
}
function querySelectorFunc(selector, refSelector, classPrototype, methodOrAttributeName, index) {
    if (selector === null) {
        console.error("AG Grid: QuerySelector selector should not be null");
        return;
    }
    if (typeof index === "number") {
        console.error("AG Grid: QuerySelector should be on an attribute");
        return;
    }
    addToObjectProps(classPrototype, "querySelectors", {
        attributeName: methodOrAttributeName,
        querySelector: selector,
        refSelector
    });
}
function addToObjectProps(target, key, value) {
    const props = getOrCreateProps2(target, getFunctionName(target.constructor));
    if (!props[key]) props[key] = [];
    props[key].push(value);
}
function getOrCreateProps2(target, instanceName) {
    if (!target.__agComponentMetaData) target.__agComponentMetaData = {};
    if (!target.__agComponentMetaData[instanceName]) target.__agComponentMetaData[instanceName] = {};
    return target.__agComponentMetaData[instanceName];
}
// community-modules/core/src/filter/floating/provided/readOnlyFloatingFilter.ts
var ReadOnlyFloatingFilter = class extends Component {
    constructor(){
        super(/* html */ `
            <div class="ag-floating-filter-input" role="presentation">
                <ag-input-text-field ref="eFloatingFilterText"></ag-input-text-field>
            </div>`);
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    destroy() {
        super.destroy();
    }
    init(params) {
        this.params = params;
        const displayName = this.columnModel.getDisplayNameForColumn(params.column, "header", true);
        const translate = this.localeService.getLocaleTextFunc();
        this.eFloatingFilterText.setDisabled(true).setInputAriaLabel(`${displayName} ${translate("ariaFilterInput", "Filter Input")}`);
    }
    onParentModelChanged(parentModel) {
        if (parentModel == null) {
            this.eFloatingFilterText.setValue("");
            return;
        }
        this.params.parentFilterInstance((filterInstance)=>{
            if (filterInstance.getModelAsString) {
                const modelAsString = filterInstance.getModelAsString(parentModel);
                this.eFloatingFilterText.setValue(modelAsString);
            }
        });
    }
    onParamsUpdated(params) {
        this.refresh(params);
    }
    refresh(params) {
        this.init(params);
    }
};
__decorateClass([
    RefSelector("eFloatingFilterText")
], ReadOnlyFloatingFilter.prototype, "eFloatingFilterText", 2);
__decorateClass([
    Autowired("columnModel")
], ReadOnlyFloatingFilter.prototype, "columnModel", 2);
// community-modules/core/src/filter/provided/date/dateCompWrapper.ts
var DateCompWrapper = class {
    constructor(context, userComponentFactory, dateComponentParams, eParent, onReady){
        this.alive = true;
        this.context = context;
        this.eParent = eParent;
        const compDetails = userComponentFactory.getDateCompDetails(dateComponentParams);
        const promise = compDetails.newAgStackInstance();
        promise.then((dateComp)=>{
            if (!this.alive) {
                context.destroyBean(dateComp);
                return;
            }
            this.dateComp = dateComp;
            if (!dateComp) return;
            eParent.appendChild(dateComp.getGui());
            if (dateComp.afterGuiAttached) dateComp.afterGuiAttached();
            if (this.tempValue) dateComp.setDate(this.tempValue);
            if (this.disabled != null) this.setDateCompDisabled(this.disabled);
            onReady == null || onReady(this);
        });
    }
    destroy() {
        this.alive = false;
        this.dateComp = this.context.destroyBean(this.dateComp);
    }
    getDate() {
        return this.dateComp ? this.dateComp.getDate() : this.tempValue;
    }
    setDate(value) {
        if (this.dateComp) this.dateComp.setDate(value);
        else this.tempValue = value;
    }
    setDisabled(disabled) {
        if (this.dateComp) this.setDateCompDisabled(disabled);
        else this.disabled = disabled;
    }
    setDisplayed(displayed) {
        setDisplayed(this.eParent, displayed);
    }
    setInputPlaceholder(placeholder) {
        if (this.dateComp && this.dateComp.setInputPlaceholder) this.dateComp.setInputPlaceholder(placeholder);
    }
    setInputAriaLabel(label) {
        if (this.dateComp && this.dateComp.setInputAriaLabel) this.dateComp.setInputAriaLabel(label);
    }
    afterGuiAttached(params) {
        if (this.dateComp && typeof this.dateComp.afterGuiAttached === "function") this.dateComp.afterGuiAttached(params);
    }
    updateParams(params) {
        var _a, _b;
        let hasRefreshed = false;
        if (((_a = this.dateComp) == null ? void 0 : _a.refresh) && typeof this.dateComp.refresh === "function") {
            const result = this.dateComp.refresh(params);
            if (result !== null) hasRefreshed = true;
        }
        if (!hasRefreshed && ((_b = this.dateComp) == null ? void 0 : _b.onParamsUpdated) && typeof this.dateComp.onParamsUpdated === "function") {
            const result = this.dateComp.onParamsUpdated(params);
            if (result !== null) warnOnce(`Custom date component method 'onParamsUpdated' is deprecated. Use 'refresh' instead.`);
        }
    }
    setDateCompDisabled(disabled) {
        if (this.dateComp == null) return;
        if (this.dateComp.setDisabled == null) return;
        this.dateComp.setDisabled(disabled);
    }
};
// community-modules/core/src/filter/provided/optionsFactory.ts
var OptionsFactory = class {
    constructor(){
        this.customFilterOptions = {};
    }
    init(params, defaultOptions) {
        this.filterOptions = params.filterOptions || defaultOptions;
        this.mapCustomOptions();
        this.selectDefaultItem(params);
    }
    getFilterOptions() {
        return this.filterOptions;
    }
    mapCustomOptions() {
        if (!this.filterOptions) return;
        this.filterOptions.forEach((filterOption)=>{
            if (typeof filterOption === "string") return;
            const requiredProperties = [
                [
                    "displayKey"
                ],
                [
                    "displayName"
                ],
                [
                    "predicate",
                    "test"
                ]
            ];
            const propertyCheck = (keys2)=>{
                if (!keys2.some((key)=>filterOption[key] != null)) {
                    console.warn(`AG Grid: ignoring FilterOptionDef as it doesn't contain one of '${keys2}'`);
                    return false;
                }
                return true;
            };
            if (!requiredProperties.every(propertyCheck)) {
                this.filterOptions = this.filterOptions.filter((v)=>v === filterOption) || [];
                return;
            }
            this.customFilterOptions[filterOption.displayKey] = filterOption;
        });
    }
    selectDefaultItem(params) {
        if (params.defaultOption) this.defaultOption = params.defaultOption;
        else if (this.filterOptions.length >= 1) {
            const firstFilterOption = this.filterOptions[0];
            if (typeof firstFilterOption === "string") this.defaultOption = firstFilterOption;
            else if (firstFilterOption.displayKey) this.defaultOption = firstFilterOption.displayKey;
            else console.warn(`AG Grid: invalid FilterOptionDef supplied as it doesn't contain a 'displayKey'`);
        } else console.warn("AG Grid: no filter options for filter");
    }
    getDefaultOption() {
        return this.defaultOption;
    }
    getCustomOption(name) {
        return this.customFilterOptions[name];
    }
};
// community-modules/core/src/filter/filterLocaleText.ts
var FILTER_LOCALE_TEXT = {
    applyFilter: "Apply",
    clearFilter: "Clear",
    resetFilter: "Reset",
    cancelFilter: "Cancel",
    textFilter: "Text Filter",
    numberFilter: "Number Filter",
    dateFilter: "Date Filter",
    setFilter: "Set Filter",
    filterOoo: "Filter...",
    empty: "Choose one",
    equals: "Equals",
    notEqual: "Does not equal",
    lessThan: "Less than",
    greaterThan: "Greater than",
    inRange: "Between",
    inRangeStart: "From",
    inRangeEnd: "To",
    lessThanOrEqual: "Less than or equal to",
    greaterThanOrEqual: "Greater than or equal to",
    contains: "Contains",
    notContains: "Does not contain",
    startsWith: "Begins with",
    endsWith: "Ends with",
    blank: "Blank",
    notBlank: "Not blank",
    before: "Before",
    after: "After",
    andCondition: "AND",
    orCondition: "OR",
    dateFormatOoo: "yyyy-mm-dd"
};
// community-modules/core/src/widgets/managedFocusFeature.ts
var _ManagedFocusFeature = class _ManagedFocusFeature extends BeanStub {
    constructor(eFocusableElement, callbacks = {}){
        super();
        this.eFocusableElement = eFocusableElement;
        this.callbacks = callbacks;
        this.callbacks = __spreadValues({
            shouldStopEventPropagation: ()=>false,
            onTabKeyDown: (e)=>{
                if (e.defaultPrevented) return;
                const nextRoot = this.focusService.findNextFocusableElement(this.eFocusableElement, false, e.shiftKey);
                if (!nextRoot) return;
                nextRoot.focus();
                e.preventDefault();
            }
        }, callbacks);
    }
    postConstruct() {
        this.eFocusableElement.classList.add(_ManagedFocusFeature.FOCUS_MANAGED_CLASS);
        this.addKeyDownListeners(this.eFocusableElement);
        if (this.callbacks.onFocusIn) this.addManagedListener(this.eFocusableElement, "focusin", this.callbacks.onFocusIn);
        if (this.callbacks.onFocusOut) this.addManagedListener(this.eFocusableElement, "focusout", this.callbacks.onFocusOut);
    }
    addKeyDownListeners(eGui) {
        this.addManagedListener(eGui, "keydown", (e)=>{
            if (e.defaultPrevented || isStopPropagationForAgGrid(e)) return;
            if (this.callbacks.shouldStopEventPropagation(e)) {
                stopPropagationForAgGrid(e);
                return;
            }
            if (e.key === KeyCode.TAB) this.callbacks.onTabKeyDown(e);
            else if (this.callbacks.handleKeyDown) this.callbacks.handleKeyDown(e);
        });
    }
};
_ManagedFocusFeature.FOCUS_MANAGED_CLASS = "ag-focus-managed";
__decorateClass([
    Autowired("focusService")
], _ManagedFocusFeature.prototype, "focusService", 2);
__decorateClass([
    PostConstruct
], _ManagedFocusFeature.prototype, "postConstruct", 1);
var ManagedFocusFeature = _ManagedFocusFeature;
// community-modules/core/src/rendering/features/positionableFeature.ts
var RESIZE_CONTAINER_STYLE = "ag-resizer-wrapper";
var RESIZE_TEMPLATE = /* html */ `<div class="${RESIZE_CONTAINER_STYLE}">
        <div ref="eTopLeftResizer" class="ag-resizer ag-resizer-topLeft"></div>
        <div ref="eTopResizer" class="ag-resizer ag-resizer-top"></div>
        <div ref="eTopRightResizer" class="ag-resizer ag-resizer-topRight"></div>
        <div ref="eRightResizer" class="ag-resizer ag-resizer-right"></div>
        <div ref="eBottomRightResizer" class="ag-resizer ag-resizer-bottomRight"></div>
        <div ref="eBottomResizer" class="ag-resizer ag-resizer-bottom"></div>
        <div ref="eBottomLeftResizer" class="ag-resizer ag-resizer-bottomLeft"></div>
        <div ref="eLeftResizer" class="ag-resizer ag-resizer-left"></div>
    </div>`;
var PositionableFeature = class extends BeanStub {
    constructor(element, config){
        super();
        this.element = element;
        this.dragStartPosition = {
            x: 0,
            y: 0
        };
        this.position = {
            x: 0,
            y: 0
        };
        this.lastSize = {
            width: -1,
            height: -1
        };
        this.positioned = false;
        this.resizersAdded = false;
        this.resizeListeners = [];
        this.boundaryEl = null;
        this.isResizing = false;
        this.isMoving = false;
        this.resizable = {};
        this.movable = false;
        this.currentResizer = null;
        this.config = Object.assign({}, {
            popup: false
        }, config);
    }
    center() {
        const { clientHeight, clientWidth } = this.offsetParent;
        const x = clientWidth / 2 - this.getWidth() / 2;
        const y = clientHeight / 2 - this.getHeight() / 2;
        this.offsetElement(x, y);
    }
    initialisePosition() {
        if (this.positioned) return;
        const { centered, forcePopupParentAsOffsetParent, minWidth, width, minHeight, height, x, y } = this.config;
        if (!this.offsetParent) this.setOffsetParent();
        let computedMinHeight = 0;
        let computedMinWidth = 0;
        const isElementVisible = isVisible(this.element);
        if (isElementVisible) {
            const boundaryEl = this.findBoundaryElement();
            const offsetParentComputedStyles = window.getComputedStyle(boundaryEl);
            if (offsetParentComputedStyles.minWidth != null) {
                const paddingWidth = boundaryEl.offsetWidth - this.element.offsetWidth;
                computedMinWidth = parseInt(offsetParentComputedStyles.minWidth, 10) - paddingWidth;
            }
            if (offsetParentComputedStyles.minHeight != null) {
                const paddingHeight = boundaryEl.offsetHeight - this.element.offsetHeight;
                computedMinHeight = parseInt(offsetParentComputedStyles.minHeight, 10) - paddingHeight;
            }
        }
        this.minHeight = minHeight || computedMinHeight;
        this.minWidth = minWidth || computedMinWidth;
        if (width) this.setWidth(width);
        if (height) this.setHeight(height);
        if (!width || !height) this.refreshSize();
        if (centered) this.center();
        else if (x || y) this.offsetElement(x, y);
        else if (isElementVisible && forcePopupParentAsOffsetParent) {
            let boundaryEl = this.boundaryEl;
            let initialisedDuringPositioning = true;
            if (!boundaryEl) {
                boundaryEl = this.findBoundaryElement();
                initialisedDuringPositioning = false;
            }
            if (boundaryEl) {
                const top = parseFloat(boundaryEl.style.top);
                const left = parseFloat(boundaryEl.style.left);
                if (initialisedDuringPositioning) this.offsetElement(isNaN(left) ? 0 : left, isNaN(top) ? 0 : top);
                else this.setPosition(left, top);
            }
        }
        this.positioned = !!this.offsetParent;
    }
    isPositioned() {
        return this.positioned;
    }
    getPosition() {
        return this.position;
    }
    setMovable(movable, moveElement) {
        if (!this.config.popup || movable === this.movable) return;
        this.movable = movable;
        const params = this.moveElementDragListener || {
            eElement: moveElement,
            onDragStart: this.onMoveStart.bind(this),
            onDragging: this.onMove.bind(this),
            onDragStop: this.onMoveEnd.bind(this)
        };
        if (movable) {
            this.dragService.addDragSource(params);
            this.moveElementDragListener = params;
        } else {
            this.dragService.removeDragSource(params);
            this.moveElementDragListener = void 0;
        }
    }
    setResizable(resizable) {
        this.clearResizeListeners();
        if (resizable) this.addResizers();
        else this.removeResizers();
        if (typeof resizable === "boolean") {
            if (resizable === false) return;
            resizable = {
                topLeft: resizable,
                top: resizable,
                topRight: resizable,
                right: resizable,
                bottomRight: resizable,
                bottom: resizable,
                bottomLeft: resizable,
                left: resizable
            };
        }
        Object.keys(resizable).forEach((side)=>{
            const resizableStructure = resizable;
            const isSideResizable = !!resizableStructure[side];
            const resizerEl = this.getResizerElement(side);
            const params = {
                dragStartPixels: 0,
                eElement: resizerEl,
                onDragStart: (e)=>this.onResizeStart(e, side),
                onDragging: this.onResize.bind(this),
                onDragStop: (e)=>this.onResizeEnd(e, side)
            };
            if (isSideResizable || !this.isAlive() && !isSideResizable) {
                if (isSideResizable) {
                    this.dragService.addDragSource(params);
                    this.resizeListeners.push(params);
                    resizerEl.style.pointerEvents = "all";
                } else resizerEl.style.pointerEvents = "none";
                this.resizable[side] = isSideResizable;
            }
        });
    }
    removeSizeFromEl() {
        this.element.style.removeProperty("height");
        this.element.style.removeProperty("width");
        this.element.style.removeProperty("flex");
    }
    restoreLastSize() {
        this.element.style.flex = "0 0 auto";
        const { height, width } = this.lastSize;
        if (width !== -1) this.element.style.width = `${width}px`;
        if (height !== -1) this.element.style.height = `${height}px`;
    }
    getHeight() {
        return this.element.offsetHeight;
    }
    setHeight(height) {
        const { popup } = this.config;
        const eGui = this.element;
        let isPercent = false;
        if (typeof height === "string" && height.indexOf("%") !== -1) {
            setFixedHeight(eGui, height);
            height = getAbsoluteHeight(eGui);
            isPercent = true;
        } else {
            height = Math.max(this.minHeight, height);
            if (this.positioned) {
                const availableHeight = this.getAvailableHeight();
                if (availableHeight && height > availableHeight) height = availableHeight;
            }
        }
        if (this.getHeight() === height) return;
        if (!isPercent) {
            if (popup) setFixedHeight(eGui, height);
            else {
                eGui.style.height = `${height}px`;
                eGui.style.flex = "0 0 auto";
                this.lastSize.height = typeof height === "number" ? height : parseFloat(height);
            }
        } else {
            eGui.style.maxHeight = "unset";
            eGui.style.minHeight = "unset";
        }
    }
    getAvailableHeight() {
        const { popup, forcePopupParentAsOffsetParent } = this.config;
        if (!this.positioned) this.initialisePosition();
        const { clientHeight } = this.offsetParent;
        if (!clientHeight) return null;
        const elRect = this.element.getBoundingClientRect();
        const offsetParentRect = this.offsetParent.getBoundingClientRect();
        const yPosition = popup ? this.position.y : elRect.top;
        const parentTop = popup ? 0 : offsetParentRect.top;
        let additionalHeight = 0;
        if (forcePopupParentAsOffsetParent) {
            const parentEl = this.element.parentElement;
            if (parentEl) {
                const { bottom } = parentEl.getBoundingClientRect();
                additionalHeight = bottom - elRect.bottom;
            }
        }
        const availableHeight = clientHeight + parentTop - yPosition - additionalHeight;
        return availableHeight;
    }
    getWidth() {
        return this.element.offsetWidth;
    }
    setWidth(width) {
        const eGui = this.element;
        const { popup } = this.config;
        let isPercent = false;
        if (typeof width === "string" && width.indexOf("%") !== -1) {
            setFixedWidth(eGui, width);
            width = getAbsoluteWidth(eGui);
            isPercent = true;
        } else if (this.positioned) {
            width = Math.max(this.minWidth, width);
            const { clientWidth } = this.offsetParent;
            const xPosition = popup ? this.position.x : this.element.getBoundingClientRect().left;
            if (clientWidth && width + xPosition > clientWidth) width = clientWidth - xPosition;
        }
        if (this.getWidth() === width) return;
        if (!isPercent) {
            if (this.config.popup) setFixedWidth(eGui, width);
            else {
                eGui.style.width = `${width}px`;
                eGui.style.flex = " unset";
                this.lastSize.width = typeof width === "number" ? width : parseFloat(width);
            }
        } else {
            eGui.style.maxWidth = "unset";
            eGui.style.minWidth = "unset";
        }
    }
    offsetElement(x = 0, y = 0) {
        const { forcePopupParentAsOffsetParent } = this.config;
        const ePopup = forcePopupParentAsOffsetParent ? this.boundaryEl : this.element;
        if (!ePopup) return;
        this.popupService.positionPopup({
            ePopup,
            keepWithinBounds: true,
            skipObserver: this.movable || this.isResizable(),
            updatePosition: ()=>({
                    x,
                    y
                })
        });
        this.setPosition(parseFloat(ePopup.style.left), parseFloat(ePopup.style.top));
    }
    constrainSizeToAvailableHeight(constrain) {
        if (!this.config.forcePopupParentAsOffsetParent) return;
        const applyMaxHeightToElement = ()=>{
            const availableHeight = this.getAvailableHeight();
            this.element.style.setProperty("max-height", `${availableHeight}px`);
        };
        if (constrain) this.resizeObserverSubscriber = this.resizeObserverService.observeResize(this.popupService.getPopupParent(), applyMaxHeightToElement);
        else {
            this.element.style.removeProperty("max-height");
            if (this.resizeObserverSubscriber) {
                this.resizeObserverSubscriber();
                this.resizeObserverSubscriber = void 0;
            }
        }
    }
    setPosition(x, y) {
        this.position.x = x;
        this.position.y = y;
    }
    updateDragStartPosition(x, y) {
        this.dragStartPosition = {
            x,
            y
        };
    }
    calculateMouseMovement(params) {
        const { e, isLeft, isTop, anywhereWithin, topBuffer } = params;
        const xDiff = e.clientX - this.dragStartPosition.x;
        const yDiff = e.clientY - this.dragStartPosition.y;
        const movementX = this.shouldSkipX(e, !!isLeft, !!anywhereWithin, xDiff) ? 0 : xDiff;
        const movementY = this.shouldSkipY(e, !!isTop, topBuffer, yDiff) ? 0 : yDiff;
        return {
            movementX,
            movementY
        };
    }
    shouldSkipX(e, isLeft, anywhereWithin, diff) {
        const elRect = this.element.getBoundingClientRect();
        const parentRect = this.offsetParent.getBoundingClientRect();
        const boundaryElRect = this.boundaryEl.getBoundingClientRect();
        const xPosition = this.config.popup ? this.position.x : elRect.left;
        let skipX = xPosition <= 0 && parentRect.left >= e.clientX || parentRect.right <= e.clientX && parentRect.right <= boundaryElRect.right;
        if (skipX) return true;
        if (isLeft) skipX = // is positioned to the right of the left side anchor
        diff < 0 && e.clientX > xPosition + parentRect.left || // skip if we are moving to the right and the cursor
        // is positioned to the left of the dialog
        diff > 0 && e.clientX < xPosition + parentRect.left;
        else if (anywhereWithin) skipX = diff < 0 && e.clientX > boundaryElRect.right || diff > 0 && e.clientX < xPosition + parentRect.left;
        else skipX = // we skip if we are moving to the left and the cursor
        // is to the right of the dialog
        diff < 0 && e.clientX > boundaryElRect.right || // or skip if we are moving to the right and the cursor
        // is to the left of the right side anchor
        diff > 0 && e.clientX < boundaryElRect.right;
        return skipX;
    }
    shouldSkipY(e, isTop, topBuffer = 0, diff) {
        const elRect = this.element.getBoundingClientRect();
        const parentRect = this.offsetParent.getBoundingClientRect();
        const boundaryElRect = this.boundaryEl.getBoundingClientRect();
        const yPosition = this.config.popup ? this.position.y : elRect.top;
        let skipY = yPosition <= 0 && parentRect.top >= e.clientY || parentRect.bottom <= e.clientY && parentRect.bottom <= boundaryElRect.bottom;
        if (skipY) return true;
        if (isTop) skipY = // below the top anchor + topBuffer
        // note: topBuffer is used when moving the dialog using the title bar
        diff < 0 && e.clientY > yPosition + parentRect.top + topBuffer || // skip if we are moving to the bottom and the cursor is
        // above the top anchor
        diff > 0 && e.clientY < yPosition + parentRect.top;
        else skipY = // is below the bottom anchor
        diff < 0 && e.clientY > boundaryElRect.bottom || // skip if we are moving towards the bottom and the cursor
        // is above the bottom anchor
        diff > 0 && e.clientY < boundaryElRect.bottom;
        return skipY;
    }
    createResizeMap() {
        const eGui = this.element;
        this.resizerMap = {
            topLeft: {
                element: eGui.querySelector("[ref=eTopLeftResizer]")
            },
            top: {
                element: eGui.querySelector("[ref=eTopResizer]")
            },
            topRight: {
                element: eGui.querySelector("[ref=eTopRightResizer]")
            },
            right: {
                element: eGui.querySelector("[ref=eRightResizer]")
            },
            bottomRight: {
                element: eGui.querySelector("[ref=eBottomRightResizer]")
            },
            bottom: {
                element: eGui.querySelector("[ref=eBottomResizer]")
            },
            bottomLeft: {
                element: eGui.querySelector("[ref=eBottomLeftResizer]")
            },
            left: {
                element: eGui.querySelector("[ref=eLeftResizer]")
            }
        };
    }
    addResizers() {
        if (this.resizersAdded) return;
        const eGui = this.element;
        if (!eGui) return;
        const parser = new DOMParser();
        const resizers = parser.parseFromString(RESIZE_TEMPLATE, "text/html").body;
        eGui.appendChild(resizers.firstChild);
        this.createResizeMap();
        this.resizersAdded = true;
    }
    removeResizers() {
        this.resizerMap = void 0;
        const resizerEl = this.element.querySelector(`.${RESIZE_CONTAINER_STYLE}`);
        if (resizerEl) this.element.removeChild(resizerEl);
        this.resizersAdded = false;
    }
    getResizerElement(side) {
        return this.resizerMap[side].element;
    }
    onResizeStart(e, side) {
        this.boundaryEl = this.findBoundaryElement();
        if (!this.positioned) this.initialisePosition();
        this.currentResizer = {
            isTop: !!side.match(/top/i),
            isRight: !!side.match(/right/i),
            isBottom: !!side.match(/bottom/i),
            isLeft: !!side.match(/left/i)
        };
        this.element.classList.add("ag-resizing");
        this.resizerMap[side].element.classList.add("ag-active");
        const { popup, forcePopupParentAsOffsetParent } = this.config;
        if (!popup && !forcePopupParentAsOffsetParent) this.applySizeToSiblings(this.currentResizer.isBottom || this.currentResizer.isTop);
        this.isResizing = true;
        this.updateDragStartPosition(e.clientX, e.clientY);
    }
    getSiblings() {
        const element = this.element;
        const parent = element.parentElement;
        if (!parent) return null;
        return Array.prototype.slice.call(parent.children).filter((el)=>!el.classList.contains("ag-hidden"));
    }
    getMinSizeOfSiblings() {
        const siblings = this.getSiblings() || [];
        let height = 0;
        let width = 0;
        for(let i = 0; i < siblings.length; i++){
            const currentEl = siblings[i];
            const isFlex = !!currentEl.style.flex && currentEl.style.flex !== "0 0 auto";
            if (currentEl === this.element) continue;
            let nextHeight = this.minHeight || 0;
            let nextWidth = this.minWidth || 0;
            if (isFlex) {
                const computedStyle = window.getComputedStyle(currentEl);
                if (computedStyle.minHeight) nextHeight = parseInt(computedStyle.minHeight, 10);
                if (computedStyle.minWidth) nextWidth = parseInt(computedStyle.minWidth, 10);
            } else {
                nextHeight = currentEl.offsetHeight;
                nextWidth = currentEl.offsetWidth;
            }
            height += nextHeight;
            width += nextWidth;
        }
        return {
            height,
            width
        };
    }
    applySizeToSiblings(vertical) {
        let containerToFlex = null;
        const siblings = this.getSiblings();
        if (!siblings) return;
        for(let i = 0; i < siblings.length; i++){
            const el = siblings[i];
            if (el === containerToFlex) continue;
            if (vertical) el.style.height = `${el.offsetHeight}px`;
            else el.style.width = `${el.offsetWidth}px`;
            el.style.flex = "0 0 auto";
            if (el === this.element) containerToFlex = siblings[i + 1];
        }
        if (containerToFlex) {
            containerToFlex.style.removeProperty("height");
            containerToFlex.style.removeProperty("min-height");
            containerToFlex.style.removeProperty("max-height");
            containerToFlex.style.flex = "1 1 auto";
        }
    }
    isResizable() {
        return Object.values(this.resizable).some((value)=>value);
    }
    onResize(e) {
        if (!this.isResizing || !this.currentResizer) return;
        const { popup, forcePopupParentAsOffsetParent } = this.config;
        const { isTop, isRight, isBottom, isLeft } = this.currentResizer;
        const isHorizontal = isRight || isLeft;
        const isVertical = isBottom || isTop;
        const { movementX, movementY } = this.calculateMouseMovement({
            e,
            isLeft,
            isTop
        });
        const xPosition = this.position.x;
        const yPosition = this.position.y;
        let offsetLeft = 0;
        let offsetTop = 0;
        if (isHorizontal && movementX) {
            const direction = isLeft ? -1 : 1;
            const oldWidth = this.getWidth();
            const newWidth = oldWidth + movementX * direction;
            let skipWidth = false;
            if (isLeft) {
                offsetLeft = oldWidth - newWidth;
                if (xPosition + offsetLeft <= 0 || newWidth <= this.minWidth) {
                    skipWidth = true;
                    offsetLeft = 0;
                }
            }
            if (!skipWidth) this.setWidth(newWidth);
        }
        if (isVertical && movementY) {
            const direction = isTop ? -1 : 1;
            const oldHeight = this.getHeight();
            const newHeight = oldHeight + movementY * direction;
            let skipHeight = false;
            if (isTop) {
                offsetTop = oldHeight - newHeight;
                if (yPosition + offsetTop <= 0 || newHeight <= this.minHeight) {
                    skipHeight = true;
                    offsetTop = 0;
                }
            } else if (!this.config.popup && !this.config.forcePopupParentAsOffsetParent && oldHeight < newHeight && this.getMinSizeOfSiblings().height + newHeight > this.element.parentElement.offsetHeight) skipHeight = true;
            if (!skipHeight) this.setHeight(newHeight);
        }
        this.updateDragStartPosition(e.clientX, e.clientY);
        if ((popup || forcePopupParentAsOffsetParent) && offsetLeft || offsetTop) this.offsetElement(xPosition + offsetLeft, yPosition + offsetTop);
    }
    onResizeEnd(e, side) {
        this.isResizing = false;
        this.currentResizer = null;
        this.boundaryEl = null;
        const params = {
            type: "resize"
        };
        this.element.classList.remove("ag-resizing");
        this.resizerMap[side].element.classList.remove("ag-active");
        this.dispatchEvent(params);
    }
    refreshSize() {
        const eGui = this.element;
        if (this.config.popup) {
            if (!this.config.width) this.setWidth(eGui.offsetWidth);
            if (!this.config.height) this.setHeight(eGui.offsetHeight);
        }
    }
    onMoveStart(e) {
        this.boundaryEl = this.findBoundaryElement();
        if (!this.positioned) this.initialisePosition();
        this.isMoving = true;
        this.element.classList.add("ag-moving");
        this.updateDragStartPosition(e.clientX, e.clientY);
    }
    onMove(e) {
        if (!this.isMoving) return;
        const { x, y } = this.position;
        let topBuffer;
        if (this.config.calculateTopBuffer) topBuffer = this.config.calculateTopBuffer();
        const { movementX, movementY } = this.calculateMouseMovement({
            e,
            isTop: true,
            anywhereWithin: true,
            topBuffer
        });
        this.offsetElement(x + movementX, y + movementY);
        this.updateDragStartPosition(e.clientX, e.clientY);
    }
    onMoveEnd() {
        this.isMoving = false;
        this.boundaryEl = null;
        this.element.classList.remove("ag-moving");
    }
    setOffsetParent() {
        if (this.config.forcePopupParentAsOffsetParent) this.offsetParent = this.popupService.getPopupParent();
        else this.offsetParent = this.element.offsetParent;
    }
    findBoundaryElement() {
        let el = this.element;
        while(el){
            if (window.getComputedStyle(el).position !== "static") return el;
            el = el.parentElement;
        }
        return this.element;
    }
    clearResizeListeners() {
        while(this.resizeListeners.length){
            const params = this.resizeListeners.pop();
            this.dragService.removeDragSource(params);
        }
    }
    destroy() {
        super.destroy();
        if (this.moveElementDragListener) this.dragService.removeDragSource(this.moveElementDragListener);
        this.constrainSizeToAvailableHeight(false);
        this.clearResizeListeners();
        this.removeResizers();
    }
};
__decorateClass([
    Autowired("popupService")
], PositionableFeature.prototype, "popupService", 2);
__decorateClass([
    Autowired("resizeObserverService")
], PositionableFeature.prototype, "resizeObserverService", 2);
__decorateClass([
    Autowired("dragService")
], PositionableFeature.prototype, "dragService", 2);
// community-modules/core/src/filter/provided/providedFilter.ts
var _ProvidedFilter = class _ProvidedFilter extends Component {
    constructor(filterNameKey){
        super();
        this.filterNameKey = filterNameKey;
        this.applyActive = false;
        this.hidePopup = null;
        this.debouncePending = false;
        // after the user hits 'apply' the model gets copied to here. this is then the model that we use for
        // all filtering. so if user changes UI but doesn't hit apply, then the UI will be out of sync with this model.
        // this is what we want, as the UI should only become the 'active' filter once it's applied. when apply is
        // inactive, this model will be in sync (following the debounce ms). if the UI is not a valid filter
        // (eg the value is missing so nothing to filter on, or for set filter all checkboxes are checked so filter
        // not active) then this appliedModel will be null/undefined.
        this.appliedModel = null;
        this.buttonListeners = [];
    }
    postConstruct() {
        this.resetTemplate();
        this.createManagedBean(new ManagedFocusFeature(this.getFocusableElement(), {
            handleKeyDown: this.handleKeyDown.bind(this)
        }));
        this.positionableFeature = new PositionableFeature(this.getPositionableElement(), {
            forcePopupParentAsOffsetParent: true
        });
        this.createBean(this.positionableFeature);
    }
    // override
    handleKeyDown(e) {}
    getFilterTitle() {
        return this.translate(this.filterNameKey);
    }
    isFilterActive() {
        return !!this.appliedModel;
    }
    resetTemplate(paramsMap) {
        let eGui = this.getGui();
        if (eGui) eGui.removeEventListener("submit", this.onFormSubmit);
        const templateString = /* html */ `
            <form class="ag-filter-wrapper">
                <div class="ag-filter-body-wrapper ag-${this.getCssIdentifier()}-body-wrapper" ref="eFilterBody">
                    ${this.createBodyTemplate()}
                </div>
            </form>`;
        this.setTemplate(templateString, paramsMap);
        eGui = this.getGui();
        if (eGui) eGui.addEventListener("submit", this.onFormSubmit);
    }
    isReadOnly() {
        return !!this.providedFilterParams.readOnly;
    }
    init(params) {
        this.setParams(params);
        this.resetUiToDefaults(true).then(()=>{
            this.updateUiVisibility();
            this.setupOnBtApplyDebounce();
        });
    }
    setParams(params) {
        this.providedFilterParams = params;
        this.applyActive = _ProvidedFilter.isUseApplyButton(params);
        this.resetButtonsPanel();
    }
    updateParams(params) {
        this.providedFilterParams = params;
        this.applyActive = _ProvidedFilter.isUseApplyButton(params);
        this.resetUiToActiveModel(this.getModel(), ()=>{
            this.updateUiVisibility();
            this.setupOnBtApplyDebounce();
        });
    }
    resetButtonsPanel() {
        const { buttons } = this.providedFilterParams;
        const hasButtons = buttons && buttons.length > 0 && !this.isReadOnly();
        if (!this.eButtonsPanel) {
            if (hasButtons) {
                this.eButtonsPanel = document.createElement("div");
                this.eButtonsPanel.classList.add("ag-filter-apply-panel");
            }
        } else {
            clearElement(this.eButtonsPanel);
            this.buttonListeners.forEach((destroyFunc)=>destroyFunc == null ? void 0 : destroyFunc());
            this.buttonListeners = [];
        }
        if (!hasButtons) {
            if (this.eButtonsPanel) removeFromParent(this.eButtonsPanel);
            return;
        }
        const fragment = document.createDocumentFragment();
        const addButton = (type)=>{
            let text;
            let clickListener;
            switch(type){
                case "apply":
                    text = this.translate("applyFilter");
                    clickListener = (e)=>this.onBtApply(false, false, e);
                    break;
                case "clear":
                    text = this.translate("clearFilter");
                    clickListener = ()=>this.onBtClear();
                    break;
                case "reset":
                    text = this.translate("resetFilter");
                    clickListener = ()=>this.onBtReset();
                    break;
                case "cancel":
                    text = this.translate("cancelFilter");
                    clickListener = (e)=>{
                        this.onBtCancel(e);
                    };
                    break;
                default:
                    console.warn("AG Grid: Unknown button type specified");
                    return;
            }
            const buttonType = type === "apply" ? "submit" : "button";
            const button = loadTemplate(/* html */ `<button
                    type="${buttonType}"
                    ref="${type}FilterButton"
                    class="ag-button ag-standard-button ag-filter-apply-panel-button"
                >${text}
                </button>`);
            this.buttonListeners.push(this.addManagedListener(button, "click", clickListener));
            fragment.append(button);
        };
        convertToSet(buttons).forEach((type)=>addButton(type));
        this.eButtonsPanel.append(fragment);
        this.getGui().appendChild(this.eButtonsPanel);
    }
    // subclasses can override this to provide alternative debounce defaults
    getDefaultDebounceMs() {
        return 0;
    }
    setupOnBtApplyDebounce() {
        const debounceMs = _ProvidedFilter.getDebounceMs(this.providedFilterParams, this.getDefaultDebounceMs());
        const debounceFunc = debounce(this.checkApplyDebounce.bind(this), debounceMs);
        this.onBtApplyDebounce = ()=>{
            this.debouncePending = true;
            debounceFunc();
        };
    }
    checkApplyDebounce() {
        if (this.debouncePending) {
            this.debouncePending = false;
            this.onBtApply();
        }
    }
    getModel() {
        return this.appliedModel ? this.appliedModel : null;
    }
    setModel(model) {
        const promise = model != null ? this.setModelIntoUi(model) : this.resetUiToDefaults();
        return promise.then(()=>{
            this.updateUiVisibility();
            this.applyModel("api");
        });
    }
    onBtCancel(e) {
        this.resetUiToActiveModel(this.getModel(), ()=>{
            this.handleCancelEnd(e);
        });
    }
    handleCancelEnd(e) {
        if (this.providedFilterParams.closeOnApply) this.close(e);
    }
    resetUiToActiveModel(currentModel, afterUiUpdatedFunc) {
        const afterAppliedFunc = ()=>{
            this.onUiChanged(false, "prevent");
            afterUiUpdatedFunc == null || afterUiUpdatedFunc();
        };
        if (currentModel != null) this.setModelIntoUi(currentModel).then(afterAppliedFunc);
        else this.resetUiToDefaults().then(afterAppliedFunc);
    }
    onBtClear() {
        this.resetUiToDefaults().then(()=>this.onUiChanged());
    }
    onBtReset() {
        this.onBtClear();
        this.onBtApply();
    }
    /**
   * Applies changes made in the UI to the filter, and returns true if the model has changed.
   */ applyModel(source = "api") {
        const newModel = this.getModelFromUi();
        if (!this.isModelValid(newModel)) return false;
        const previousModel = this.appliedModel;
        this.appliedModel = newModel;
        return !this.areModelsEqual(previousModel, newModel);
    }
    isModelValid(model) {
        return true;
    }
    onFormSubmit(e) {
        e.preventDefault();
    }
    onBtApply(afterFloatingFilter = false, afterDataChange = false, e) {
        if (e) e.preventDefault();
        if (this.applyModel(afterDataChange ? "rowDataUpdated" : "ui")) {
            const source = "columnFilter";
            this.providedFilterParams.filterChangedCallback({
                afterFloatingFilter,
                afterDataChange,
                source
            });
        }
        const { closeOnApply } = this.providedFilterParams;
        if (closeOnApply && this.applyActive && !afterFloatingFilter && !afterDataChange) this.close(e);
    }
    onNewRowsLoaded() {}
    close(e) {
        if (!this.hidePopup) return;
        const keyboardEvent = e;
        const key = keyboardEvent && keyboardEvent.key;
        let params;
        if (key === "Enter" || key === "Space") params = {
            keyboardEvent
        };
        this.hidePopup(params);
        this.hidePopup = null;
    }
    /**
   * By default, if the change came from a floating filter it will be applied immediately, otherwise if there is no
   * apply button it will be applied after a debounce, otherwise it will not be applied at all. This behaviour can
   * be adjusted by using the apply parameter.
   */ onUiChanged(fromFloatingFilter = false, apply) {
        this.updateUiVisibility();
        this.providedFilterParams.filterModifiedCallback();
        if (this.applyActive && !this.isReadOnly()) {
            const isValid = this.isModelValid(this.getModelFromUi());
            const applyFilterButton = this.getRefElement("applyFilterButton");
            if (applyFilterButton) setDisabled(applyFilterButton, !isValid);
        }
        if (fromFloatingFilter && !apply || apply === "immediately") this.onBtApply(fromFloatingFilter);
        else if (!this.applyActive && !apply || apply === "debounce") this.onBtApplyDebounce();
    }
    afterGuiAttached(params) {
        if (params) this.hidePopup = params.hidePopup;
        this.refreshFilterResizer(params == null ? void 0 : params.container);
    }
    refreshFilterResizer(containerType) {
        if (!this.positionableFeature || containerType === "toolPanel") return;
        const isResizable = containerType === "floatingFilter" || containerType === "columnFilter";
        const { positionableFeature, gos } = this;
        if (isResizable) {
            positionableFeature.restoreLastSize();
            positionableFeature.setResizable(gos.get("enableRtl") ? {
                bottom: true,
                bottomLeft: true,
                left: true
            } : {
                bottom: true,
                bottomRight: true,
                right: true
            });
        } else {
            this.positionableFeature.removeSizeFromEl();
            this.positionableFeature.setResizable(false);
        }
        this.positionableFeature.constrainSizeToAvailableHeight(true);
    }
    afterGuiDetached() {
        this.checkApplyDebounce();
        if (this.positionableFeature) this.positionableFeature.constrainSizeToAvailableHeight(false);
    }
    // static, as used by floating filter also
    static getDebounceMs(params, debounceDefault) {
        if (_ProvidedFilter.isUseApplyButton(params)) {
            if (params.debounceMs != null) console.warn("AG Grid: debounceMs is ignored when apply button is present");
            return 0;
        }
        return params.debounceMs != null ? params.debounceMs : debounceDefault;
    }
    // static, as used by floating filter also
    static isUseApplyButton(params) {
        return !!params.buttons && params.buttons.indexOf("apply") >= 0;
    }
    refresh(newParams) {
        this.providedFilterParams = newParams;
        return true;
    }
    destroy() {
        const eGui = this.getGui();
        if (eGui) eGui.removeEventListener("submit", this.onFormSubmit);
        this.hidePopup = null;
        if (this.positionableFeature) this.positionableFeature = this.destroyBean(this.positionableFeature);
        this.appliedModel = null;
        super.destroy();
    }
    translate(key) {
        const translate = this.localeService.getLocaleTextFunc();
        return translate(key, FILTER_LOCALE_TEXT[key]);
    }
    getCellValue(rowNode) {
        return this.providedFilterParams.getValue(rowNode);
    }
    // override to control positionable feature
    getPositionableElement() {
        return this.eFilterBody;
    }
};
__decorateClass([
    Autowired("rowModel")
], _ProvidedFilter.prototype, "rowModel", 2);
__decorateClass([
    RefSelector("eFilterBody")
], _ProvidedFilter.prototype, "eFilterBody", 2);
__decorateClass([
    PostConstruct
], _ProvidedFilter.prototype, "postConstruct", 1);
var ProvidedFilter = _ProvidedFilter;
// community-modules/core/src/widgets/agAbstractLabel.ts
var AgAbstractLabel = class extends Component {
    constructor(config, template){
        super(template);
        this.labelSeparator = "";
        this.labelAlignment = "left";
        this.disabled = false;
        this.label = "";
        this.config = config || {};
    }
    postConstruct() {
        this.addCssClass("ag-labeled");
        this.eLabel.classList.add("ag-label");
        const { labelSeparator, label, labelWidth, labelAlignment, disabled } = this.config;
        if (disabled != null) this.setDisabled(disabled);
        if (labelSeparator != null) this.setLabelSeparator(labelSeparator);
        if (label != null) this.setLabel(label);
        if (labelWidth != null) this.setLabelWidth(labelWidth);
        this.setLabelAlignment(labelAlignment || this.labelAlignment);
        this.refreshLabel();
    }
    refreshLabel() {
        clearElement(this.eLabel);
        if (typeof this.label === "string") this.eLabel.innerText = this.label + this.labelSeparator;
        else if (this.label) this.eLabel.appendChild(this.label);
        if (this.label === "") {
            setDisplayed(this.eLabel, false);
            setAriaRole(this.eLabel, "presentation");
        } else {
            setDisplayed(this.eLabel, true);
            setAriaRole(this.eLabel, null);
        }
    }
    setLabelSeparator(labelSeparator) {
        if (this.labelSeparator === labelSeparator) return this;
        this.labelSeparator = labelSeparator;
        if (this.label != null) this.refreshLabel();
        return this;
    }
    getLabelId() {
        this.eLabel.id = this.eLabel.id || `ag-${this.getCompId()}-label`;
        return this.eLabel.id;
    }
    getLabel() {
        return this.label;
    }
    setLabel(label) {
        if (this.label === label) return this;
        this.label = label;
        this.refreshLabel();
        return this;
    }
    setLabelAlignment(alignment) {
        const eGui = this.getGui();
        const eGuiClassList = eGui.classList;
        eGuiClassList.toggle("ag-label-align-left", alignment === "left");
        eGuiClassList.toggle("ag-label-align-right", alignment === "right");
        eGuiClassList.toggle("ag-label-align-top", alignment === "top");
        return this;
    }
    setLabelEllipsis(hasEllipsis) {
        this.eLabel.classList.toggle("ag-label-ellipsis", hasEllipsis);
        return this;
    }
    setLabelWidth(width) {
        if (this.label == null) return this;
        setElementWidth(this.eLabel, width);
        return this;
    }
    setDisabled(disabled) {
        disabled = !!disabled;
        const element = this.getGui();
        setDisabled(element, disabled);
        element.classList.toggle("ag-disabled", disabled);
        this.disabled = disabled;
        return this;
    }
    isDisabled() {
        return !!this.disabled;
    }
};
__decorateClass([
    PostConstruct
], AgAbstractLabel.prototype, "postConstruct", 1);
// community-modules/core/src/widgets/agAbstractField.ts
var AgAbstractField = class extends AgAbstractLabel {
    constructor(config, template, className){
        super(config, template);
        this.className = className;
    }
    postConstruct() {
        super.postConstruct();
        const { width, value, onValueChange } = this.config;
        if (width != null) this.setWidth(width);
        if (value != null) this.setValue(value);
        if (onValueChange != null) this.onValueChange(onValueChange);
        if (this.className) this.addCssClass(this.className);
        this.refreshAriaLabelledBy();
    }
    refreshAriaLabelledBy() {
        const ariaEl = this.getAriaElement();
        const labelId = this.getLabelId();
        if (getAriaLabel(ariaEl) !== null) setAriaLabelledBy(ariaEl, "");
        else setAriaLabelledBy(ariaEl, labelId != null ? labelId : "");
    }
    setAriaLabel(label) {
        setAriaLabel(this.getAriaElement(), label);
        this.refreshAriaLabelledBy();
        return this;
    }
    onValueChange(callbackFn) {
        this.addManagedListener(this, Events.EVENT_FIELD_VALUE_CHANGED, ()=>callbackFn(this.getValue()));
        return this;
    }
    getWidth() {
        return this.getGui().clientWidth;
    }
    setWidth(width) {
        setFixedWidth(this.getGui(), width);
        return this;
    }
    getPreviousValue() {
        return this.previousValue;
    }
    getValue() {
        return this.value;
    }
    setValue(value, silent) {
        if (this.value === value) return this;
        this.previousValue = this.value;
        this.value = value;
        if (!silent) this.dispatchEvent({
            type: Events.EVENT_FIELD_VALUE_CHANGED
        });
        return this;
    }
};
// community-modules/core/src/widgets/agPickerField.ts
var TEMPLATE = /* html */ `
    <div class="ag-picker-field" role="presentation">
        <div ref="eLabel"></div>
            <div ref="eWrapper" class="ag-wrapper ag-picker-field-wrapper ag-picker-collapsed">
            <div ref="eDisplayField" class="ag-picker-field-display"></div>
            <div ref="eIcon" class="ag-picker-field-icon" aria-hidden="true"></div>
        </div>
    </div>`;
var AgPickerField = class extends AgAbstractField {
    constructor(config){
        super(config, (config == null ? void 0 : config.template) || TEMPLATE, config == null ? void 0 : config.className);
        this.isPickerDisplayed = false;
        this.skipClick = false;
        this.pickerGap = 4;
        this.hideCurrentPicker = null;
        this.ariaRole = config == null ? void 0 : config.ariaRole;
        this.onPickerFocusIn = this.onPickerFocusIn.bind(this);
        this.onPickerFocusOut = this.onPickerFocusOut.bind(this);
        if (!config) return;
        const { pickerGap, maxPickerHeight, variableWidth, minPickerWidth, maxPickerWidth } = config;
        if (pickerGap != null) this.pickerGap = pickerGap;
        this.variableWidth = !!variableWidth;
        if (maxPickerHeight != null) this.setPickerMaxHeight(maxPickerHeight);
        if (minPickerWidth != null) this.setPickerMinWidth(minPickerWidth);
        if (maxPickerWidth != null) this.setPickerMaxWidth(maxPickerWidth);
    }
    postConstruct() {
        super.postConstruct();
        this.setupAria();
        const displayId = `ag-${this.getCompId()}-display`;
        this.eDisplayField.setAttribute("id", displayId);
        const ariaEl = this.getAriaElement();
        this.addManagedListener(ariaEl, "keydown", this.onKeyDown.bind(this));
        this.addManagedListener(this.eLabel, "mousedown", this.onLabelOrWrapperMouseDown.bind(this));
        this.addManagedListener(this.eWrapper, "mousedown", this.onLabelOrWrapperMouseDown.bind(this));
        const { pickerIcon, inputWidth } = this.config;
        if (pickerIcon) {
            const icon = createIconNoSpan(pickerIcon, this.gos);
            if (icon) this.eIcon.appendChild(icon);
        }
        if (inputWidth != null) this.setInputWidth(inputWidth);
    }
    setupAria() {
        const ariaEl = this.getAriaElement();
        ariaEl.setAttribute("tabindex", this.gos.get("tabIndex").toString());
        setAriaExpanded(ariaEl, false);
        if (this.ariaRole) setAriaRole(ariaEl, this.ariaRole);
    }
    onLabelOrWrapperMouseDown(e) {
        if (e) {
            const focusableEl = this.getFocusableElement();
            if (focusableEl !== this.eWrapper && (e == null ? void 0 : e.target) === focusableEl) return;
            e.preventDefault();
            this.getFocusableElement().focus();
        }
        if (this.skipClick) {
            this.skipClick = false;
            return;
        }
        if (this.isDisabled()) return;
        if (this.isPickerDisplayed) this.hidePicker();
        else this.showPicker();
    }
    onKeyDown(e) {
        switch(e.key){
            case KeyCode.UP:
            case KeyCode.DOWN:
            case KeyCode.ENTER:
            case KeyCode.SPACE:
                e.preventDefault();
                this.onLabelOrWrapperMouseDown();
                break;
            case KeyCode.ESCAPE:
                if (this.isPickerDisplayed) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (this.hideCurrentPicker) this.hideCurrentPicker();
                }
                break;
        }
    }
    showPicker() {
        this.isPickerDisplayed = true;
        if (!this.pickerComponent) this.pickerComponent = this.createPickerComponent();
        const pickerGui = this.pickerComponent.getGui();
        pickerGui.addEventListener("focusin", this.onPickerFocusIn);
        pickerGui.addEventListener("focusout", this.onPickerFocusOut);
        this.hideCurrentPicker = this.renderAndPositionPicker();
        this.toggleExpandedStyles(true);
    }
    renderAndPositionPicker() {
        const eDocument = this.gos.getDocument();
        const ePicker = this.pickerComponent.getGui();
        if (!this.gos.get("suppressScrollWhenPopupsAreOpen")) this.destroyMouseWheelFunc = this.addManagedListener(this.eventService, Events.EVENT_BODY_SCROLL, ()=>{
            this.hidePicker();
        });
        const translate = this.localeService.getLocaleTextFunc();
        const { pickerAriaLabelKey, pickerAriaLabelValue, modalPicker = true } = this.config;
        const popupParams = {
            modal: modalPicker,
            eChild: ePicker,
            closeOnEsc: true,
            closedCallback: ()=>{
                const activeEl = this.gos.getActiveDomElement();
                const shouldRestoreFocus = !activeEl || activeEl === eDocument.body;
                this.beforeHidePicker();
                if (shouldRestoreFocus && this.isAlive()) this.getFocusableElement().focus();
            },
            ariaLabel: translate(pickerAriaLabelKey, pickerAriaLabelValue)
        };
        const addPopupRes = this.popupService.addPopup(popupParams);
        const { maxPickerHeight, minPickerWidth, maxPickerWidth, variableWidth } = this;
        if (variableWidth) {
            if (minPickerWidth) ePicker.style.minWidth = minPickerWidth;
            ePicker.style.width = formatSize(getAbsoluteWidth(this.eWrapper));
            if (maxPickerWidth) ePicker.style.maxWidth = maxPickerWidth;
        } else setElementWidth(ePicker, maxPickerWidth != null ? maxPickerWidth : getAbsoluteWidth(this.eWrapper));
        const maxHeight = maxPickerHeight != null ? maxPickerHeight : `${getInnerHeight(this.popupService.getPopupParent())}px`;
        ePicker.style.setProperty("max-height", maxHeight);
        ePicker.style.position = "absolute";
        this.alignPickerToComponent();
        return addPopupRes.hideFunc;
    }
    alignPickerToComponent() {
        if (!this.pickerComponent) return;
        const { pickerType } = this.config;
        const { pickerGap } = this;
        const alignSide = this.gos.get("enableRtl") ? "right" : "left";
        this.popupService.positionPopupByComponent({
            type: pickerType,
            eventSource: this.eWrapper,
            ePopup: this.pickerComponent.getGui(),
            position: "under",
            alignSide,
            keepWithinBounds: true,
            nudgeY: pickerGap
        });
    }
    beforeHidePicker() {
        if (this.destroyMouseWheelFunc) {
            this.destroyMouseWheelFunc();
            this.destroyMouseWheelFunc = void 0;
        }
        this.toggleExpandedStyles(false);
        const pickerGui = this.pickerComponent.getGui();
        pickerGui.removeEventListener("focusin", this.onPickerFocusIn);
        pickerGui.removeEventListener("focusout", this.onPickerFocusOut);
        this.isPickerDisplayed = false;
        this.pickerComponent = void 0;
        this.hideCurrentPicker = null;
    }
    toggleExpandedStyles(expanded) {
        if (!this.isAlive()) return;
        const ariaEl = this.getAriaElement();
        setAriaExpanded(ariaEl, expanded);
        this.eWrapper.classList.toggle("ag-picker-expanded", expanded);
        this.eWrapper.classList.toggle("ag-picker-collapsed", !expanded);
    }
    onPickerFocusIn() {
        this.togglePickerHasFocus(true);
    }
    onPickerFocusOut(e) {
        var _a;
        if (!((_a = this.pickerComponent) == null ? void 0 : _a.getGui().contains(e.relatedTarget))) this.togglePickerHasFocus(false);
    }
    togglePickerHasFocus(focused) {
        if (!this.pickerComponent) return;
        this.eWrapper.classList.toggle("ag-picker-has-focus", focused);
    }
    hidePicker() {
        if (this.hideCurrentPicker) this.hideCurrentPicker();
    }
    setInputWidth(width) {
        setElementWidth(this.eWrapper, width);
        return this;
    }
    getFocusableElement() {
        return this.eWrapper;
    }
    setPickerGap(gap) {
        this.pickerGap = gap;
        return this;
    }
    setPickerMinWidth(width) {
        if (typeof width === "number") width = `${width}px`;
        this.minPickerWidth = width == null ? void 0 : width;
        return this;
    }
    setPickerMaxWidth(width) {
        if (typeof width === "number") width = `${width}px`;
        this.maxPickerWidth = width == null ? void 0 : width;
        return this;
    }
    setPickerMaxHeight(height) {
        if (typeof height === "number") height = `${height}px`;
        this.maxPickerHeight = height == null ? void 0 : height;
        return this;
    }
    destroy() {
        this.hidePicker();
        super.destroy();
    }
};
__decorateClass([
    Autowired("popupService")
], AgPickerField.prototype, "popupService", 2);
__decorateClass([
    RefSelector("eLabel")
], AgPickerField.prototype, "eLabel", 2);
__decorateClass([
    RefSelector("eWrapper")
], AgPickerField.prototype, "eWrapper", 2);
__decorateClass([
    RefSelector("eDisplayField")
], AgPickerField.prototype, "eDisplayField", 2);
__decorateClass([
    RefSelector("eIcon")
], AgPickerField.prototype, "eIcon", 2);
// community-modules/core/src/widgets/agList.ts
var _AgList = class _AgList extends Component {
    constructor(cssIdentifier = "default", unFocusable = false){
        super(/* html */ `<div class="ag-list ag-${cssIdentifier}-list" role="listbox"></div>`);
        this.cssIdentifier = cssIdentifier;
        this.unFocusable = unFocusable;
        this.options = [];
        this.itemEls = [];
    }
    init() {
        const eGui = this.getGui();
        this.addManagedListener(eGui, "mouseleave", ()=>this.clearHighlighted());
        if (this.unFocusable) return;
        this.addManagedListener(eGui, "keydown", this.handleKeyDown.bind(this));
    }
    handleKeyDown(e) {
        const key = e.key;
        switch(key){
            case KeyCode.ENTER:
                if (!this.highlightedEl) this.setValue(this.getValue());
                else {
                    const pos = this.itemEls.indexOf(this.highlightedEl);
                    this.setValueByIndex(pos);
                }
                break;
            case KeyCode.DOWN:
            case KeyCode.UP:
                e.preventDefault();
                this.navigate(key);
                break;
            case KeyCode.PAGE_DOWN:
            case KeyCode.PAGE_UP:
            case KeyCode.PAGE_HOME:
            case KeyCode.PAGE_END:
                e.preventDefault();
                this.navigateToPage(key);
                break;
        }
    }
    navigate(key) {
        const isDown = key === KeyCode.DOWN;
        let itemToHighlight;
        if (!this.highlightedEl) itemToHighlight = this.itemEls[isDown ? 0 : this.itemEls.length - 1];
        else {
            const currentIdx = this.itemEls.indexOf(this.highlightedEl);
            let nextPos = currentIdx + (isDown ? 1 : -1);
            nextPos = Math.min(Math.max(nextPos, 0), this.itemEls.length - 1);
            itemToHighlight = this.itemEls[nextPos];
        }
        this.highlightItem(itemToHighlight);
    }
    navigateToPage(key) {
        if (!this.highlightedEl || this.itemEls.length === 0) return;
        const currentIdx = this.itemEls.indexOf(this.highlightedEl);
        const rowCount = this.options.length - 1;
        const itemHeight = this.itemEls[0].clientHeight;
        const pageSize = Math.floor(this.getGui().clientHeight / itemHeight);
        let newIndex = -1;
        if (key === KeyCode.PAGE_HOME) newIndex = 0;
        else if (key === KeyCode.PAGE_END) newIndex = rowCount;
        else if (key === KeyCode.PAGE_DOWN) newIndex = Math.min(currentIdx + pageSize, rowCount);
        else if (key === KeyCode.PAGE_UP) newIndex = Math.max(currentIdx - pageSize, 0);
        if (newIndex === -1) return;
        this.highlightItem(this.itemEls[newIndex]);
    }
    addOptions(listOptions) {
        listOptions.forEach((listOption)=>this.addOption(listOption));
        return this;
    }
    addOption(listOption) {
        const { value, text } = listOption;
        const valueToRender = text || value;
        this.options.push({
            value,
            text: valueToRender
        });
        this.renderOption(value, valueToRender);
        this.updateIndices();
        return this;
    }
    clearOptions() {
        this.options = [];
        this.reset(true);
        this.itemEls.forEach((itemEl)=>{
            removeFromParent(itemEl);
        });
        this.itemEls = [];
    }
    updateIndices() {
        const options = this.getGui().querySelectorAll(".ag-list-item");
        options.forEach((option, idx)=>{
            setAriaPosInSet(option, idx + 1);
            setAriaSetSize(option, options.length);
        });
    }
    renderOption(value, text) {
        const eDocument = this.gos.getDocument();
        const itemEl = eDocument.createElement("div");
        setAriaRole(itemEl, "option");
        itemEl.classList.add("ag-list-item", `ag-${this.cssIdentifier}-list-item`);
        const span = eDocument.createElement("span");
        itemEl.appendChild(span);
        span.textContent = text;
        if (!this.unFocusable) itemEl.tabIndex = -1;
        this.itemEls.push(itemEl);
        this.addManagedListener(itemEl, "mousemove", ()=>this.highlightItem(itemEl));
        this.addManagedListener(itemEl, "mousedown", (e)=>{
            e.preventDefault();
            this.setValue(value);
        });
        this.createManagedBean(new TooltipFeature({
            getTooltipValue: ()=>text,
            getGui: ()=>itemEl,
            getLocation: ()=>"UNKNOWN",
            // only show tooltips for items where the text cannot be fully displayed
            shouldDisplayTooltip: ()=>span.scrollWidth > span.clientWidth
        }));
        this.getGui().appendChild(itemEl);
    }
    setValue(value, silent) {
        if (this.value === value) {
            this.fireItemSelected();
            return this;
        }
        if (value == null) {
            this.reset(silent);
            return this;
        }
        const idx = this.options.findIndex((option)=>option.value === value);
        if (idx !== -1) {
            const option = this.options[idx];
            this.value = option.value;
            this.displayValue = option.text;
            this.highlightItem(this.itemEls[idx]);
            if (!silent) this.fireChangeEvent();
        }
        return this;
    }
    setValueByIndex(idx) {
        return this.setValue(this.options[idx].value);
    }
    getValue() {
        return this.value;
    }
    getDisplayValue() {
        return this.displayValue;
    }
    refreshHighlighted() {
        this.clearHighlighted();
        const idx = this.options.findIndex((option)=>option.value === this.value);
        if (idx !== -1) this.highlightItem(this.itemEls[idx]);
    }
    reset(silent) {
        this.value = null;
        this.displayValue = null;
        this.clearHighlighted();
        if (!silent) this.fireChangeEvent();
    }
    highlightItem(el) {
        if (!isVisible(el)) return;
        this.clearHighlighted();
        this.highlightedEl = el;
        this.highlightedEl.classList.add(_AgList.ACTIVE_CLASS);
        setAriaSelected(this.highlightedEl, true);
        const eGui = this.getGui();
        const { scrollTop, clientHeight } = eGui;
        const { offsetTop, offsetHeight } = el;
        if (offsetTop + offsetHeight > scrollTop + clientHeight || offsetTop < scrollTop) this.highlightedEl.scrollIntoView({
            block: "nearest"
        });
        if (!this.unFocusable) this.highlightedEl.focus();
    }
    clearHighlighted() {
        if (!this.highlightedEl || !isVisible(this.highlightedEl)) return;
        this.highlightedEl.classList.remove(_AgList.ACTIVE_CLASS);
        setAriaSelected(this.highlightedEl, false);
        this.highlightedEl = null;
    }
    fireChangeEvent() {
        this.dispatchEvent({
            type: Events.EVENT_FIELD_VALUE_CHANGED
        });
        this.fireItemSelected();
    }
    fireItemSelected() {
        this.dispatchEvent({
            type: _AgList.EVENT_ITEM_SELECTED
        });
    }
};
_AgList.EVENT_ITEM_SELECTED = "selectedItem";
_AgList.ACTIVE_CLASS = "ag-active-item";
__decorateClass([
    PostConstruct
], _AgList.prototype, "init", 1);
var AgList = _AgList;
// community-modules/core/src/widgets/agSelect.ts
var _AgSelect = class _AgSelect extends AgPickerField {
    constructor(config){
        super(__spreadValues({
            pickerAriaLabelKey: "ariaLabelSelectField",
            pickerAriaLabelValue: "Select Field",
            pickerType: "ag-list",
            className: "ag-select",
            pickerIcon: "smallDown",
            ariaRole: "combobox"
        }, config));
    }
    postConstruct() {
        super.postConstruct();
        this.createListComponent();
        this.eWrapper.tabIndex = this.gos.get("tabIndex");
        const { options, value, placeholder } = this.config;
        if (options != null) this.addOptions(options);
        if (value != null) this.setValue(value, true);
        if (placeholder && value == null) this.eDisplayField.textContent = placeholder;
        this.addManagedListener(this.eWrapper, "focusout", this.onWrapperFocusOut.bind(this));
    }
    onWrapperFocusOut(e) {
        if (!this.eWrapper.contains(e.relatedTarget)) this.hidePicker();
    }
    createListComponent() {
        this.listComponent = this.createBean(new AgList("select", true));
        this.listComponent.setParentComponent(this);
        const eListAriaEl = this.listComponent.getAriaElement();
        const listId = `ag-select-list-${this.listComponent.getCompId()}`;
        eListAriaEl.setAttribute("id", listId);
        setAriaControls(this.getAriaElement(), eListAriaEl);
        this.listComponent.addManagedListener(this.listComponent, AgList.EVENT_ITEM_SELECTED, ()=>{
            this.hidePicker();
            this.dispatchEvent({
                type: _AgSelect.EVENT_ITEM_SELECTED
            });
        });
        this.listComponent.addManagedListener(this.listComponent, Events.EVENT_FIELD_VALUE_CHANGED, ()=>{
            if (!this.listComponent) return;
            this.setValue(this.listComponent.getValue(), false, true);
            this.hidePicker();
        });
    }
    createPickerComponent() {
        return this.listComponent;
    }
    onKeyDown(e) {
        var _a;
        const { key } = e;
        if (key === KeyCode.TAB) this.hidePicker();
        switch(key){
            case KeyCode.ENTER:
            case KeyCode.UP:
            case KeyCode.DOWN:
            case KeyCode.PAGE_UP:
            case KeyCode.PAGE_DOWN:
            case KeyCode.PAGE_HOME:
            case KeyCode.PAGE_END:
                e.preventDefault();
                if (this.isPickerDisplayed) (_a = this.listComponent) == null || _a.handleKeyDown(e);
                else super.onKeyDown(e);
                break;
            case KeyCode.ESCAPE:
                super.onKeyDown(e);
                break;
        }
    }
    showPicker() {
        if (!this.listComponent) return;
        super.showPicker();
        this.listComponent.refreshHighlighted();
    }
    addOptions(options) {
        options.forEach((option)=>this.addOption(option));
        return this;
    }
    addOption(option) {
        this.listComponent.addOption(option);
        return this;
    }
    clearOptions() {
        var _a;
        (_a = this.listComponent) == null || _a.clearOptions();
        return this;
    }
    setValue(value, silent, fromPicker) {
        if (this.value === value || !this.listComponent) return this;
        if (!fromPicker) this.listComponent.setValue(value, true);
        const newValue = this.listComponent.getValue();
        if (newValue === this.getValue()) return this;
        let displayValue = this.listComponent.getDisplayValue();
        if (displayValue == null && this.config.placeholder) displayValue = this.config.placeholder;
        this.eDisplayField.textContent = displayValue;
        this.setTooltip({
            newTooltipText: displayValue != null ? displayValue : null,
            shouldDisplayTooltip: ()=>this.eDisplayField.scrollWidth > this.eDisplayField.clientWidth
        });
        return super.setValue(value, silent);
    }
    destroy() {
        if (this.listComponent) {
            this.destroyBean(this.listComponent);
            this.listComponent = void 0;
        }
        super.destroy();
    }
};
_AgSelect.EVENT_ITEM_SELECTED = "selectedItem";
var AgSelect = _AgSelect;
// community-modules/core/src/widgets/agAbstractInputField.ts
var AgAbstractInputField = class extends AgAbstractField {
    constructor(config, className, inputType = "text", displayFieldTag = "input"){
        super(config, /* html */ `
            <div role="presentation">
                <div ref="eLabel" class="ag-input-field-label"></div>
                <div ref="eWrapper" class="ag-wrapper ag-input-wrapper" role="presentation">
                    <${displayFieldTag} ref="eInput" class="ag-input-field-input"></${displayFieldTag}>
                </div>
            </div>`, className);
        this.inputType = inputType;
        this.displayFieldTag = displayFieldTag;
    }
    postConstruct() {
        super.postConstruct();
        this.setInputType();
        this.eLabel.classList.add(`${this.className}-label`);
        this.eWrapper.classList.add(`${this.className}-input-wrapper`);
        this.eInput.classList.add(`${this.className}-input`);
        this.addCssClass("ag-input-field");
        this.eInput.id = this.eInput.id || `ag-${this.getCompId()}-input`;
        const { inputName, inputWidth } = this.config;
        if (inputName != null) this.setInputName(inputName);
        if (inputWidth != null) this.setInputWidth(inputWidth);
        this.addInputListeners();
        this.activateTabIndex([
            this.eInput
        ]);
    }
    addInputListeners() {
        this.addManagedListener(this.eInput, "input", (e)=>this.setValue(e.target.value));
    }
    setInputType() {
        if (this.displayFieldTag === "input") this.eInput.setAttribute("type", this.inputType);
    }
    getInputElement() {
        return this.eInput;
    }
    setInputWidth(width) {
        setElementWidth(this.eWrapper, width);
        return this;
    }
    setInputName(name) {
        this.getInputElement().setAttribute("name", name);
        return this;
    }
    getFocusableElement() {
        return this.eInput;
    }
    setMaxLength(length) {
        const eInput = this.eInput;
        eInput.maxLength = length;
        return this;
    }
    setInputPlaceholder(placeholder) {
        addOrRemoveAttribute(this.eInput, "placeholder", placeholder);
        return this;
    }
    setInputAriaLabel(label) {
        setAriaLabel(this.eInput, label);
        this.refreshAriaLabelledBy();
        return this;
    }
    setDisabled(disabled) {
        setDisabled(this.eInput, disabled);
        return super.setDisabled(disabled);
    }
    setAutoComplete(value) {
        if (value === true) addOrRemoveAttribute(this.eInput, "autocomplete", null);
        else {
            const autoCompleteValue = typeof value === "string" ? value : "off";
            addOrRemoveAttribute(this.eInput, "autocomplete", autoCompleteValue);
        }
        return this;
    }
};
__decorateClass([
    RefSelector("eLabel")
], AgAbstractInputField.prototype, "eLabel", 2);
__decorateClass([
    RefSelector("eWrapper")
], AgAbstractInputField.prototype, "eWrapper", 2);
__decorateClass([
    RefSelector("eInput")
], AgAbstractInputField.prototype, "eInput", 2);
// community-modules/core/src/widgets/agCheckbox.ts
var AgCheckbox = class extends AgAbstractInputField {
    constructor(config, className = "ag-checkbox", inputType = "checkbox"){
        super(config, className, inputType);
        this.labelAlignment = "right";
        this.selected = false;
        this.readOnly = false;
        this.passive = false;
    }
    postConstruct() {
        super.postConstruct();
        const { readOnly, passive } = this.config;
        if (typeof readOnly === "boolean") this.setReadOnly(readOnly);
        if (typeof passive === "boolean") this.setPassive(passive);
    }
    addInputListeners() {
        this.addManagedListener(this.eInput, "click", this.onCheckboxClick.bind(this));
        this.addManagedListener(this.eLabel, "click", this.toggle.bind(this));
    }
    getNextValue() {
        return this.selected === void 0 ? true : !this.selected;
    }
    setPassive(passive) {
        this.passive = passive;
    }
    isReadOnly() {
        return this.readOnly;
    }
    setReadOnly(readOnly) {
        this.eWrapper.classList.toggle("ag-disabled", readOnly);
        this.eInput.disabled = readOnly;
        this.readOnly = readOnly;
    }
    setDisabled(disabled) {
        this.eWrapper.classList.toggle("ag-disabled", disabled);
        return super.setDisabled(disabled);
    }
    toggle() {
        if (this.eInput.disabled) return;
        const previousValue = this.isSelected();
        const nextValue = this.getNextValue();
        if (this.passive) this.dispatchChange(nextValue, previousValue);
        else this.setValue(nextValue);
    }
    getValue() {
        return this.isSelected();
    }
    setValue(value, silent) {
        this.refreshSelectedClass(value);
        this.setSelected(value, silent);
        return this;
    }
    setName(name) {
        const input = this.getInputElement();
        input.name = name;
        return this;
    }
    isSelected() {
        return this.selected;
    }
    setSelected(selected, silent) {
        if (this.isSelected() === selected) return;
        this.previousValue = this.isSelected();
        selected = this.selected = typeof selected === "boolean" ? selected : void 0;
        this.eInput.checked = selected;
        this.eInput.indeterminate = selected === void 0;
        if (!silent) this.dispatchChange(this.selected, this.previousValue);
    }
    dispatchChange(selected, previousValue, event) {
        this.dispatchEvent({
            type: Events.EVENT_FIELD_VALUE_CHANGED,
            selected,
            previousValue,
            event
        });
        const input = this.getInputElement();
        const checkboxChangedEvent = {
            type: Events.EVENT_CHECKBOX_CHANGED,
            id: input.id,
            name: input.name,
            selected,
            previousValue
        };
        this.eventService.dispatchEvent(checkboxChangedEvent);
    }
    onCheckboxClick(e) {
        if (this.passive || this.eInput.disabled) return;
        const previousValue = this.isSelected();
        const selected = this.selected = e.target.checked;
        this.refreshSelectedClass(selected);
        this.dispatchChange(selected, previousValue, e);
    }
    refreshSelectedClass(value) {
        this.eWrapper.classList.toggle("ag-checked", value === true);
        this.eWrapper.classList.toggle("ag-indeterminate", value == null);
    }
};
// community-modules/core/src/widgets/agRadioButton.ts
var AgRadioButton = class extends AgCheckbox {
    constructor(config){
        super(config, "ag-radio-button", "radio");
    }
    isSelected() {
        return this.eInput.checked;
    }
    toggle() {
        if (this.eInput.disabled) return;
        if (!this.isSelected()) this.setValue(true);
    }
    addInputListeners() {
        super.addInputListeners();
        this.addManagedListener(this.eventService, Events.EVENT_CHECKBOX_CHANGED, this.onChange.bind(this));
    }
    /**
   * This ensures that if another radio button in the same named group is selected, we deselect this radio button.
   * By default the browser does this for you, but we are managing classes ourselves in order to ensure input
   * elements are styled correctly in IE11, and the DOM 'changed' event is only fired when a button is selected,
   * not deselected, so we need to use our own event.
   */ onChange(event) {
        if (event.selected && event.name && this.eInput.name && this.eInput.name === event.name && event.id && this.eInput.id !== event.id) this.setValue(false, true);
    }
};
// community-modules/core/src/filter/provided/simpleFilter.ts
var SimpleFilterModelFormatter = class {
    constructor(localeService, optionsFactory, valueFormatter){
        this.localeService = localeService;
        this.optionsFactory = optionsFactory;
        this.valueFormatter = valueFormatter;
    }
    // used by:
    // 1) NumberFloatingFilter & TextFloatingFilter: Always, for both when editable and read only.
    // 2) DateFloatingFilter: Only when read only (as we show text rather than a date picker when read only)
    getModelAsString(model) {
        if (!model) return null;
        const isCombined = model.operator != null;
        const translate = this.localeService.getLocaleTextFunc();
        if (isCombined) {
            const combinedModel = model;
            let { conditions } = combinedModel;
            if (!conditions) {
                const { condition1, condition2 } = combinedModel;
                conditions = [
                    condition1,
                    condition2
                ];
            }
            const customOptions = conditions.map((condition)=>this.getModelAsString(condition));
            const joinOperatorTranslateKey = combinedModel.operator === "AND" ? "andCondition" : "orCondition";
            return customOptions.join(` ${translate(joinOperatorTranslateKey, FILTER_LOCALE_TEXT[joinOperatorTranslateKey])} `);
        } else if (model.type === SimpleFilter.BLANK || model.type === SimpleFilter.NOT_BLANK) return translate(model.type, model.type);
        else {
            const condition = model;
            const customOption = this.optionsFactory.getCustomOption(condition.type);
            const { displayKey, displayName, numberOfInputs } = customOption || {};
            if (displayKey && displayName && numberOfInputs === 0) {
                translate(displayKey, displayName);
                return displayName;
            }
            return this.conditionToString(condition, customOption);
        }
    }
    updateParams(params) {
        this.optionsFactory = params.optionsFactory;
    }
    formatValue(value) {
        var _a;
        return this.valueFormatter ? (_a = this.valueFormatter(value != null ? value : null)) != null ? _a : "" : String(value);
    }
};
var _SimpleFilter = class _SimpleFilter extends ProvidedFilter {
    constructor(){
        super(...arguments);
        this.eTypes = [];
        this.eJoinOperatorPanels = [];
        this.eJoinOperatorsAnd = [];
        this.eJoinOperatorsOr = [];
        this.eConditionBodies = [];
        this.listener = ()=>this.onUiChanged();
        this.lastUiCompletePosition = null;
        this.joinOperatorId = 0;
    }
    getNumberOfInputs(type) {
        const customOpts = this.optionsFactory.getCustomOption(type);
        if (customOpts) {
            const { numberOfInputs } = customOpts;
            return numberOfInputs != null ? numberOfInputs : 1;
        }
        const zeroInputTypes = [
            _SimpleFilter.EMPTY,
            _SimpleFilter.NOT_BLANK,
            _SimpleFilter.BLANK
        ];
        if (type && zeroInputTypes.indexOf(type) >= 0) return 0;
        else if (type === _SimpleFilter.IN_RANGE) return 2;
        return 1;
    }
    // floating filter calls this when user applies filter from floating filter
    onFloatingFilterChanged(type, value) {
        this.setTypeFromFloatingFilter(type);
        this.setValueFromFloatingFilter(value);
        this.onUiChanged(true);
    }
    setTypeFromFloatingFilter(type) {
        this.eTypes.forEach((eType, position)=>{
            if (position === 0) eType.setValue(type, true);
            else eType.setValue(this.optionsFactory.getDefaultOption(), true);
        });
    }
    getModelFromUi() {
        const conditions = this.getUiCompleteConditions();
        if (conditions.length === 0) return null;
        if (this.maxNumConditions > 1 && conditions.length > 1) return {
            filterType: this.getFilterType(),
            operator: this.getJoinOperator(),
            condition1: conditions[0],
            condition2: conditions[1],
            conditions
        };
        return conditions[0];
    }
    getConditionTypes() {
        return this.eTypes.map((eType)=>eType.getValue());
    }
    getConditionType(position) {
        return this.eTypes[position].getValue();
    }
    getJoinOperator() {
        if (this.eJoinOperatorsOr.length === 0) return this.defaultJoinOperator;
        return this.eJoinOperatorsOr[0].getValue() === true ? "OR" : "AND";
    }
    areModelsEqual(a, b) {
        if (!a && !b) return true;
        if (!a && b || a && !b) return false;
        const aIsSimple = !a.operator;
        const bIsSimple = !b.operator;
        const oneSimpleOneCombined = !aIsSimple && bIsSimple || aIsSimple && !bIsSimple;
        if (oneSimpleOneCombined) return false;
        let res;
        if (aIsSimple) {
            const aSimple = a;
            const bSimple = b;
            res = this.areSimpleModelsEqual(aSimple, bSimple);
        } else {
            const aCombined = a;
            const bCombined = b;
            res = aCombined.operator === bCombined.operator && areEqual(aCombined.conditions, bCombined.conditions, (aModel, bModel)=>this.areSimpleModelsEqual(aModel, bModel));
        }
        return res;
    }
    shouldRefresh(newParams) {
        var _a, _b, _c;
        const model = this.getModel();
        const conditions = model ? (_a = model.conditions) != null ? _a : [
            model
        ] : null;
        const newOptionsList = (_c = (_b = newParams.filterOptions) == null ? void 0 : _b.map((option)=>typeof option === "string" ? option : option.displayKey)) != null ? _c : this.getDefaultFilterOptions();
        const allConditionsExistInNewOptionsList = !conditions || conditions.every((condition)=>newOptionsList.find((option)=>option === condition.type) !== void 0);
        if (!allConditionsExistInNewOptionsList) return false;
        if (typeof newParams.maxNumConditions === "number" && conditions && conditions.length > newParams.maxNumConditions) return false;
        return true;
    }
    refresh(newParams) {
        if (!this.shouldRefresh(newParams)) return false;
        const parentRefreshed = super.refresh(newParams);
        if (!parentRefreshed) return false;
        this.setParams(newParams);
        this.removeConditionsAndOperators(0);
        this.createOption();
        this.setModel(this.getModel());
        return true;
    }
    setModelIntoUi(model) {
        const isCombined = model.operator;
        if (isCombined) {
            let combinedModel = model;
            if (!combinedModel.conditions) combinedModel.conditions = [
                combinedModel.condition1,
                combinedModel.condition2
            ];
            const numConditions = this.validateAndUpdateConditions(combinedModel.conditions);
            const numPrevConditions = this.getNumConditions();
            if (numConditions < numPrevConditions) this.removeConditionsAndOperators(numConditions);
            else if (numConditions > numPrevConditions) for(let i = numPrevConditions; i < numConditions; i++){
                this.createJoinOperatorPanel();
                this.createOption();
            }
            const orChecked = combinedModel.operator === "OR";
            this.eJoinOperatorsAnd.forEach((eJoinOperatorAnd)=>eJoinOperatorAnd.setValue(!orChecked, true));
            this.eJoinOperatorsOr.forEach((eJoinOperatorOr)=>eJoinOperatorOr.setValue(orChecked, true));
            combinedModel.conditions.forEach((condition, position)=>{
                this.eTypes[position].setValue(condition.type, true);
                this.setConditionIntoUi(condition, position);
            });
        } else {
            const simpleModel = model;
            if (this.getNumConditions() > 1) this.removeConditionsAndOperators(1);
            this.eTypes[0].setValue(simpleModel.type, true);
            this.setConditionIntoUi(simpleModel, 0);
        }
        this.lastUiCompletePosition = this.getNumConditions() - 1;
        this.createMissingConditionsAndOperators();
        this.onUiChanged();
        return AgPromise.resolve();
    }
    validateAndUpdateConditions(conditions) {
        let numConditions = conditions.length;
        if (numConditions > this.maxNumConditions) {
            conditions.splice(this.maxNumConditions);
            warnOnce('Filter Model contains more conditions than "filterParams.maxNumConditions". Additional conditions have been ignored.');
            numConditions = this.maxNumConditions;
        }
        return numConditions;
    }
    doesFilterPass(params) {
        var _a;
        const model = this.getModel();
        if (model == null) return true;
        const { operator } = model;
        const models = [];
        if (operator) {
            const combinedModel = model;
            models.push(...(_a = combinedModel.conditions) != null ? _a : []);
        } else models.push(model);
        const combineFunction = operator && operator === "OR" ? "some" : "every";
        return models[combineFunction]((m)=>this.individualConditionPasses(params, m));
    }
    setParams(params) {
        super.setParams(params);
        this.setNumConditions(params);
        this.defaultJoinOperator = this.getDefaultJoinOperator(params.defaultJoinOperator);
        this.filterPlaceholder = params.filterPlaceholder;
        this.optionsFactory = new OptionsFactory();
        this.optionsFactory.init(params, this.getDefaultFilterOptions());
        this.createFilterListOptions();
        this.createOption();
        this.createMissingConditionsAndOperators();
        if (this.isReadOnly()) this.eFilterBody.setAttribute("tabindex", "-1");
    }
    setNumConditions(params) {
        var _a, _b;
        if (params.suppressAndOrCondition != null) warnOnce('Since v29.2 "filterParams.suppressAndOrCondition" is deprecated. Use "filterParams.maxNumConditions = 1" instead.');
        if (params.alwaysShowBothConditions != null) warnOnce('Since v29.2 "filterParams.alwaysShowBothConditions" is deprecated. Use "filterParams.numAlwaysVisibleConditions = 2" instead.');
        this.maxNumConditions = (_a = params.maxNumConditions) != null ? _a : params.suppressAndOrCondition ? 1 : 2;
        if (this.maxNumConditions < 1) {
            warnOnce('"filterParams.maxNumConditions" must be greater than or equal to zero.');
            this.maxNumConditions = 1;
        }
        this.numAlwaysVisibleConditions = (_b = params.numAlwaysVisibleConditions) != null ? _b : params.alwaysShowBothConditions ? 2 : 1;
        if (this.numAlwaysVisibleConditions < 1) {
            warnOnce('"filterParams.numAlwaysVisibleConditions" must be greater than or equal to zero.');
            this.numAlwaysVisibleConditions = 1;
        }
        if (this.numAlwaysVisibleConditions > this.maxNumConditions) {
            warnOnce('"filterParams.numAlwaysVisibleConditions" cannot be greater than "filterParams.maxNumConditions".');
            this.numAlwaysVisibleConditions = this.maxNumConditions;
        }
    }
    createOption() {
        const eType = this.createManagedBean(new AgSelect());
        this.eTypes.push(eType);
        eType.addCssClass("ag-filter-select");
        this.eFilterBody.appendChild(eType.getGui());
        const eConditionBody = this.createValueElement();
        this.eConditionBodies.push(eConditionBody);
        this.eFilterBody.appendChild(eConditionBody);
        this.putOptionsIntoDropdown(eType);
        this.resetType(eType);
        const position = this.getNumConditions() - 1;
        this.forEachPositionInput(position, (element)=>this.resetInput(element));
        this.addChangedListeners(eType, position);
    }
    createJoinOperatorPanel() {
        const eJoinOperatorPanel = document.createElement("div");
        this.eJoinOperatorPanels.push(eJoinOperatorPanel);
        eJoinOperatorPanel.classList.add("ag-filter-condition");
        const eJoinOperatorAnd = this.createJoinOperator(this.eJoinOperatorsAnd, eJoinOperatorPanel, "and");
        const eJoinOperatorOr = this.createJoinOperator(this.eJoinOperatorsOr, eJoinOperatorPanel, "or");
        this.eFilterBody.appendChild(eJoinOperatorPanel);
        const index = this.eJoinOperatorPanels.length - 1;
        const uniqueGroupId = this.joinOperatorId++;
        this.resetJoinOperatorAnd(eJoinOperatorAnd, index, uniqueGroupId);
        this.resetJoinOperatorOr(eJoinOperatorOr, index, uniqueGroupId);
        if (!this.isReadOnly()) {
            eJoinOperatorAnd.onValueChange(this.listener);
            eJoinOperatorOr.onValueChange(this.listener);
        }
    }
    createJoinOperator(eJoinOperators, eJoinOperatorPanel, andOr) {
        const eJoinOperator = this.createManagedBean(new AgRadioButton());
        eJoinOperators.push(eJoinOperator);
        eJoinOperator.addCssClass("ag-filter-condition-operator");
        eJoinOperator.addCssClass(`ag-filter-condition-operator-${andOr}`);
        eJoinOperatorPanel.appendChild(eJoinOperator.getGui());
        return eJoinOperator;
    }
    getDefaultJoinOperator(defaultJoinOperator) {
        return defaultJoinOperator === "AND" || defaultJoinOperator === "OR" ? defaultJoinOperator : "AND";
    }
    createFilterListOptions() {
        const filterOptions = this.optionsFactory.getFilterOptions();
        this.filterListOptions = filterOptions.map((option)=>typeof option === "string" ? this.createBoilerplateListOption(option) : this.createCustomListOption(option));
    }
    putOptionsIntoDropdown(eType) {
        this.filterListOptions.forEach((listOption)=>{
            eType.addOption(listOption);
        });
        eType.setDisabled(this.filterListOptions.length <= 1);
    }
    createBoilerplateListOption(option) {
        return {
            value: option,
            text: this.translate(option)
        };
    }
    createCustomListOption(option) {
        const { displayKey } = option;
        const customOption = this.optionsFactory.getCustomOption(option.displayKey);
        return {
            value: displayKey,
            text: customOption ? this.localeService.getLocaleTextFunc()(customOption.displayKey, customOption.displayName) : this.translate(displayKey)
        };
    }
    /**
   * @deprecated As of v29.2 filters can have more than two conditions. Check `colDef.filterParams.maxNumConditions` instead.
   */ isAllowTwoConditions() {
        return this.maxNumConditions >= 2;
    }
    createBodyTemplate() {
        return "";
    }
    getCssIdentifier() {
        return "simple-filter";
    }
    updateUiVisibility() {
        const joinOperator = this.getJoinOperator();
        this.updateNumConditions();
        this.updateConditionStatusesAndValues(this.lastUiCompletePosition, joinOperator);
    }
    updateNumConditions() {
        var _a;
        let lastUiCompletePosition = -1;
        let areAllConditionsUiComplete = true;
        for(let position = 0; position < this.getNumConditions(); position++)if (this.isConditionUiComplete(position)) lastUiCompletePosition = position;
        else areAllConditionsUiComplete = false;
        if (this.shouldAddNewConditionAtEnd(areAllConditionsUiComplete)) {
            this.createJoinOperatorPanel();
            this.createOption();
        } else {
            const activePosition = (_a = this.lastUiCompletePosition) != null ? _a : this.getNumConditions() - 2;
            if (lastUiCompletePosition < activePosition) {
                this.removeConditionsAndOperators(activePosition + 1);
                const removeStartPosition = lastUiCompletePosition + 1;
                const numConditionsToRemove = activePosition - removeStartPosition;
                if (numConditionsToRemove > 0) this.removeConditionsAndOperators(removeStartPosition, numConditionsToRemove);
                this.createMissingConditionsAndOperators();
            }
        }
        this.lastUiCompletePosition = lastUiCompletePosition;
    }
    updateConditionStatusesAndValues(lastUiCompletePosition, joinOperator) {
        this.eTypes.forEach((eType, position)=>{
            const disabled = this.isConditionDisabled(position, lastUiCompletePosition);
            eType.setDisabled(disabled || this.filterListOptions.length <= 1);
            if (position === 1) {
                setDisabled(this.eJoinOperatorPanels[0], disabled);
                this.eJoinOperatorsAnd[0].setDisabled(disabled);
                this.eJoinOperatorsOr[0].setDisabled(disabled);
            }
        });
        this.eConditionBodies.forEach((element, index)=>{
            setDisplayed(element, this.isConditionBodyVisible(index));
        });
        const orChecked = (joinOperator != null ? joinOperator : this.getJoinOperator()) === "OR";
        this.eJoinOperatorsAnd.forEach((eJoinOperatorAnd, index)=>{
            eJoinOperatorAnd.setValue(!orChecked, true);
        });
        this.eJoinOperatorsOr.forEach((eJoinOperatorOr, index)=>{
            eJoinOperatorOr.setValue(orChecked, true);
        });
        this.forEachInput((element, index, position, numberOfInputs)=>{
            this.setElementDisplayed(element, index < numberOfInputs);
            this.setElementDisabled(element, this.isConditionDisabled(position, lastUiCompletePosition));
        });
        this.resetPlaceholder();
    }
    shouldAddNewConditionAtEnd(areAllConditionsUiComplete) {
        return areAllConditionsUiComplete && this.getNumConditions() < this.maxNumConditions && !this.isReadOnly();
    }
    removeConditionsAndOperators(startPosition, deleteCount) {
        if (startPosition >= this.getNumConditions()) return;
        this.removeComponents(this.eTypes, startPosition, deleteCount);
        this.removeElements(this.eConditionBodies, startPosition, deleteCount);
        this.removeValueElements(startPosition, deleteCount);
        const joinOperatorIndex = Math.max(startPosition - 1, 0);
        this.removeElements(this.eJoinOperatorPanels, joinOperatorIndex, deleteCount);
        this.removeComponents(this.eJoinOperatorsAnd, joinOperatorIndex, deleteCount);
        this.removeComponents(this.eJoinOperatorsOr, joinOperatorIndex, deleteCount);
    }
    removeElements(elements, startPosition, deleteCount) {
        const removedElements = this.removeItems(elements, startPosition, deleteCount);
        removedElements.forEach((element)=>removeFromParent(element));
    }
    removeComponents(components, startPosition, deleteCount) {
        const removedComponents = this.removeItems(components, startPosition, deleteCount);
        removedComponents.forEach((comp)=>{
            removeFromParent(comp.getGui());
            this.destroyBean(comp);
        });
    }
    removeItems(items, startPosition, deleteCount) {
        return deleteCount == null ? items.splice(startPosition) : items.splice(startPosition, deleteCount);
    }
    afterGuiAttached(params) {
        super.afterGuiAttached(params);
        this.resetPlaceholder();
        if (!(params == null ? void 0 : params.suppressFocus)) {
            if (this.isReadOnly()) this.eFilterBody.focus();
            else {
                const firstInput = this.getInputs(0)[0];
                if (!firstInput) return;
                if (firstInput instanceof AgAbstractInputField) firstInput.getInputElement().focus();
            }
        }
    }
    afterGuiDetached() {
        super.afterGuiDetached();
        const appliedModel = this.getModel();
        this.resetUiToActiveModel(appliedModel);
        let lastUiCompletePosition = -1;
        let updatedLastUiCompletePosition = -1;
        let conditionsRemoved = false;
        const joinOperator = this.getJoinOperator();
        for(let position = this.getNumConditions() - 1; position >= 0; position--){
            if (this.isConditionUiComplete(position)) {
                if (lastUiCompletePosition === -1) {
                    lastUiCompletePosition = position;
                    updatedLastUiCompletePosition = position;
                }
            } else {
                const shouldRemovePositionAtEnd = position >= this.numAlwaysVisibleConditions && !this.isConditionUiComplete(position - 1);
                const positionBeforeLastUiCompletePosition = position < lastUiCompletePosition;
                if (shouldRemovePositionAtEnd || positionBeforeLastUiCompletePosition) {
                    this.removeConditionsAndOperators(position, 1);
                    conditionsRemoved = true;
                    if (positionBeforeLastUiCompletePosition) updatedLastUiCompletePosition--;
                }
            }
        }
        let shouldUpdateConditionStatusesAndValues = false;
        if (this.getNumConditions() < this.numAlwaysVisibleConditions) {
            this.createMissingConditionsAndOperators();
            shouldUpdateConditionStatusesAndValues = true;
        }
        if (this.shouldAddNewConditionAtEnd(updatedLastUiCompletePosition === this.getNumConditions() - 1)) {
            this.createJoinOperatorPanel();
            this.createOption();
            shouldUpdateConditionStatusesAndValues = true;
        }
        if (shouldUpdateConditionStatusesAndValues) this.updateConditionStatusesAndValues(updatedLastUiCompletePosition, joinOperator);
        if (conditionsRemoved) this.updateJoinOperatorsDisabled();
        this.lastUiCompletePosition = updatedLastUiCompletePosition;
    }
    getPlaceholderText(defaultPlaceholder, position) {
        let placeholder = this.translate(defaultPlaceholder);
        if (isFunction(this.filterPlaceholder)) {
            const filterPlaceholderFn = this.filterPlaceholder;
            const filterOptionKey = this.eTypes[position].getValue();
            const filterOption = this.translate(filterOptionKey);
            placeholder = filterPlaceholderFn({
                filterOptionKey,
                filterOption,
                placeholder
            });
        } else if (typeof this.filterPlaceholder === "string") placeholder = this.filterPlaceholder;
        return placeholder;
    }
    // allow sub-classes to reset HTML placeholders after UI update.
    resetPlaceholder() {
        const globalTranslate = this.localeService.getLocaleTextFunc();
        this.forEachInput((element, index, position, numberOfInputs)=>{
            if (!(element instanceof AgAbstractInputField)) return;
            const placeholder = index === 0 && numberOfInputs > 1 ? "inRangeStart" : index === 0 ? "filterOoo" : "inRangeEnd";
            const ariaLabel = index === 0 && numberOfInputs > 1 ? globalTranslate("ariaFilterFromValue", "Filter from value") : index === 0 ? globalTranslate("ariaFilterValue", "Filter Value") : globalTranslate("ariaFilterToValue", "Filter to Value");
            element.setInputPlaceholder(this.getPlaceholderText(placeholder, position));
            element.setInputAriaLabel(ariaLabel);
        });
    }
    setElementValue(element, value, fromFloatingFilter) {
        if (element instanceof AgAbstractInputField) element.setValue(value != null ? String(value) : null, true);
    }
    setElementDisplayed(element, displayed) {
        if (element instanceof Component) setDisplayed(element.getGui(), displayed);
    }
    setElementDisabled(element, disabled) {
        if (element instanceof Component) setDisabled(element.getGui(), disabled);
    }
    attachElementOnChange(element, listener) {
        if (element instanceof AgAbstractInputField) element.onValueChange(listener);
    }
    forEachInput(cb) {
        this.getConditionTypes().forEach((type, position)=>{
            this.forEachPositionTypeInput(position, type, cb);
        });
    }
    forEachPositionInput(position, cb) {
        const type = this.getConditionType(position);
        this.forEachPositionTypeInput(position, type, cb);
    }
    forEachPositionTypeInput(position, type, cb) {
        const numberOfInputs = this.getNumberOfInputs(type);
        const inputs = this.getInputs(position);
        for(let index = 0; index < inputs.length; index++){
            const input = inputs[index];
            if (input != null) cb(input, index, position, numberOfInputs);
        }
    }
    isConditionDisabled(position, lastUiCompletePosition) {
        if (this.isReadOnly()) return true;
        if (position === 0) return false;
        return position > lastUiCompletePosition + 1;
    }
    isConditionBodyVisible(position) {
        const type = this.getConditionType(position);
        const numberOfInputs = this.getNumberOfInputs(type);
        return numberOfInputs > 0;
    }
    // returns true if the UI represents a working filter, eg all parts are filled out.
    // eg if text filter and textfield blank then returns false.
    isConditionUiComplete(position) {
        if (position >= this.getNumConditions()) return false;
        const type = this.getConditionType(position);
        if (type === _SimpleFilter.EMPTY) return false;
        if (this.getValues(position).some((v)=>v == null)) return false;
        return true;
    }
    getNumConditions() {
        return this.eTypes.length;
    }
    getUiCompleteConditions() {
        const conditions = [];
        for(let position = 0; position < this.getNumConditions(); position++)if (this.isConditionUiComplete(position)) conditions.push(this.createCondition(position));
        return conditions;
    }
    createMissingConditionsAndOperators() {
        if (this.isReadOnly()) return;
        for(let i = this.getNumConditions(); i < this.numAlwaysVisibleConditions; i++){
            this.createJoinOperatorPanel();
            this.createOption();
        }
    }
    resetUiToDefaults(silent) {
        this.removeConditionsAndOperators(this.isReadOnly() ? 1 : this.numAlwaysVisibleConditions);
        this.eTypes.forEach((eType)=>this.resetType(eType));
        this.eJoinOperatorsAnd.forEach((eJoinOperatorAnd, index)=>this.resetJoinOperatorAnd(eJoinOperatorAnd, index, this.joinOperatorId + index));
        this.eJoinOperatorsOr.forEach((eJoinOperatorOr, index)=>this.resetJoinOperatorOr(eJoinOperatorOr, index, this.joinOperatorId + index));
        this.joinOperatorId++;
        this.forEachInput((element)=>this.resetInput(element));
        this.resetPlaceholder();
        this.createMissingConditionsAndOperators();
        this.lastUiCompletePosition = null;
        if (!silent) this.onUiChanged();
        return AgPromise.resolve();
    }
    resetType(eType) {
        const translate = this.localeService.getLocaleTextFunc();
        const filteringLabel = translate("ariaFilteringOperator", "Filtering operator");
        eType.setValue(this.optionsFactory.getDefaultOption(), true).setAriaLabel(filteringLabel).setDisabled(this.isReadOnly() || this.filterListOptions.length <= 1);
    }
    resetJoinOperatorAnd(eJoinOperatorAnd, index, uniqueGroupId) {
        this.resetJoinOperator(eJoinOperatorAnd, index, this.isDefaultOperator("AND"), this.translate("andCondition"), uniqueGroupId);
    }
    resetJoinOperatorOr(eJoinOperatorOr, index, uniqueGroupId) {
        this.resetJoinOperator(eJoinOperatorOr, index, this.isDefaultOperator("OR"), this.translate("orCondition"), uniqueGroupId);
    }
    resetJoinOperator(eJoinOperator, index, value, label, uniqueGroupId) {
        this.updateJoinOperatorDisabled(eJoinOperator.setValue(value, true).setName(`ag-simple-filter-and-or-${this.getCompId()}-${uniqueGroupId}`).setLabel(label), index);
    }
    updateJoinOperatorsDisabled() {
        this.eJoinOperatorsAnd.forEach((eJoinOperator, index)=>this.updateJoinOperatorDisabled(eJoinOperator, index));
        this.eJoinOperatorsOr.forEach((eJoinOperator, index)=>this.updateJoinOperatorDisabled(eJoinOperator, index));
    }
    updateJoinOperatorDisabled(eJoinOperator, index) {
        eJoinOperator.setDisabled(this.isReadOnly() || index > 0);
    }
    resetInput(element) {
        this.setElementValue(element, null);
        this.setElementDisabled(element, this.isReadOnly());
    }
    // puts model values into the UI
    setConditionIntoUi(model, position) {
        const values2 = this.mapValuesFromModel(model);
        this.forEachInput((element, index, elPosition, _2)=>{
            if (elPosition !== position) return;
            this.setElementValue(element, values2[index] != null ? values2[index] : null);
        });
    }
    // after floating filter changes, this sets the 'value' section. this is implemented by the base class
    // (as that's where value is controlled), the 'type' part from the floating filter is dealt with in this class.
    setValueFromFloatingFilter(value) {
        this.forEachInput((element, index, position, _2)=>{
            this.setElementValue(element, index === 0 && position === 0 ? value : null, true);
        });
    }
    isDefaultOperator(operator) {
        return operator === this.defaultJoinOperator;
    }
    addChangedListeners(eType, position) {
        if (this.isReadOnly()) return;
        eType.onValueChange(this.listener);
        this.forEachPositionInput(position, (element)=>{
            this.attachElementOnChange(element, this.listener);
        });
    }
    /** returns true if the row passes the said condition */ individualConditionPasses(params, filterModel) {
        const cellValue = this.getCellValue(params.node);
        const values2 = this.mapValuesFromModel(filterModel);
        const customFilterOption = this.optionsFactory.getCustomOption(filterModel.type);
        const customFilterResult = this.evaluateCustomFilter(customFilterOption, values2, cellValue);
        if (customFilterResult != null) return customFilterResult;
        if (cellValue == null) return this.evaluateNullValue(filterModel.type);
        return this.evaluateNonNullValue(values2, cellValue, filterModel, params);
    }
    evaluateCustomFilter(customFilterOption, values2, cellValue) {
        if (customFilterOption == null) return;
        const { predicate } = customFilterOption;
        if (predicate != null && !values2.some((v)=>v == null)) return predicate(values2, cellValue);
        return;
    }
    isBlank(cellValue) {
        return cellValue == null || typeof cellValue === "string" && cellValue.trim().length === 0;
    }
    hasInvalidInputs() {
        return false;
    }
};
_SimpleFilter.EMPTY = "empty";
_SimpleFilter.BLANK = "blank";
_SimpleFilter.NOT_BLANK = "notBlank";
_SimpleFilter.EQUALS = "equals";
_SimpleFilter.NOT_EQUAL = "notEqual";
_SimpleFilter.LESS_THAN = "lessThan";
_SimpleFilter.LESS_THAN_OR_EQUAL = "lessThanOrEqual";
_SimpleFilter.GREATER_THAN = "greaterThan";
_SimpleFilter.GREATER_THAN_OR_EQUAL = "greaterThanOrEqual";
_SimpleFilter.IN_RANGE = "inRange";
_SimpleFilter.CONTAINS = "contains";
_SimpleFilter.NOT_CONTAINS = "notContains";
_SimpleFilter.STARTS_WITH = "startsWith";
_SimpleFilter.ENDS_WITH = "endsWith";
var SimpleFilter = _SimpleFilter;
// community-modules/core/src/filter/provided/scalarFilter.ts
var ScalarFilter = class _ScalarFilter extends SimpleFilter {
    setParams(params) {
        super.setParams(params);
        this.scalarFilterParams = params;
    }
    evaluateNullValue(filterType) {
        switch(filterType){
            case _ScalarFilter.EQUALS:
            case _ScalarFilter.NOT_EQUAL:
                if (this.scalarFilterParams.includeBlanksInEquals) return true;
                break;
            case _ScalarFilter.GREATER_THAN:
            case _ScalarFilter.GREATER_THAN_OR_EQUAL:
                if (this.scalarFilterParams.includeBlanksInGreaterThan) return true;
                break;
            case _ScalarFilter.LESS_THAN:
            case _ScalarFilter.LESS_THAN_OR_EQUAL:
                if (this.scalarFilterParams.includeBlanksInLessThan) return true;
                break;
            case _ScalarFilter.IN_RANGE:
                if (this.scalarFilterParams.includeBlanksInRange) return true;
                break;
            case _ScalarFilter.BLANK:
                return true;
            case _ScalarFilter.NOT_BLANK:
                return false;
        }
        return false;
    }
    evaluateNonNullValue(values2, cellValue, filterModel) {
        const comparator = this.comparator();
        const compareResult = values2[0] != null ? comparator(values2[0], cellValue) : 0;
        switch(filterModel.type){
            case _ScalarFilter.EQUALS:
                return compareResult === 0;
            case _ScalarFilter.NOT_EQUAL:
                return compareResult !== 0;
            case _ScalarFilter.GREATER_THAN:
                return compareResult > 0;
            case _ScalarFilter.GREATER_THAN_OR_EQUAL:
                return compareResult >= 0;
            case _ScalarFilter.LESS_THAN:
                return compareResult < 0;
            case _ScalarFilter.LESS_THAN_OR_EQUAL:
                return compareResult <= 0;
            case _ScalarFilter.IN_RANGE:
                {
                    const compareToResult = comparator(values2[1], cellValue);
                    return this.scalarFilterParams.inRangeInclusive ? compareResult >= 0 && compareToResult <= 0 : compareResult > 0 && compareToResult < 0;
                }
            case _ScalarFilter.BLANK:
                return this.isBlank(cellValue);
            case _ScalarFilter.NOT_BLANK:
                return !this.isBlank(cellValue);
            default:
                console.warn('AG Grid: Unexpected type of filter "' + filterModel.type + '", it looks like the filter was configured with incorrect Filter Options');
                return true;
        }
    }
};
// community-modules/core/src/filter/provided/date/dateFilter.ts
var DEFAULT_MIN_YEAR = 1e3;
var DEFAULT_MAX_YEAR = Infinity;
var DateFilterModelFormatter = class extends SimpleFilterModelFormatter {
    constructor(dateFilterParams, localeService, optionsFactory){
        super(localeService, optionsFactory);
        this.dateFilterParams = dateFilterParams;
    }
    conditionToString(condition, options) {
        const { type } = condition;
        const { numberOfInputs } = options || {};
        const isRange = type == SimpleFilter.IN_RANGE || numberOfInputs === 2;
        const dateFrom = parseDateTimeFromString(condition.dateFrom);
        const dateTo = parseDateTimeFromString(condition.dateTo);
        const format = this.dateFilterParams.inRangeFloatingFilterDateFormat;
        if (isRange) {
            const formattedFrom = dateFrom !== null ? dateToFormattedString(dateFrom, format) : "null";
            const formattedTo = dateTo !== null ? dateToFormattedString(dateTo, format) : "null";
            return `${formattedFrom}-${formattedTo}`;
        }
        if (dateFrom != null) return dateToFormattedString(dateFrom, format);
        return `${type}`;
    }
    updateParams(params) {
        super.updateParams(params);
        this.dateFilterParams = params.dateFilterParams;
    }
};
var _DateFilter = class _DateFilter extends ScalarFilter {
    constructor(){
        super("dateFilter");
        this.eConditionPanelsFrom = [];
        this.eConditionPanelsTo = [];
        this.dateConditionFromComps = [];
        this.dateConditionToComps = [];
        this.minValidYear = DEFAULT_MIN_YEAR;
        this.maxValidYear = DEFAULT_MAX_YEAR;
        this.minValidDate = null;
        this.maxValidDate = null;
    }
    afterGuiAttached(params) {
        super.afterGuiAttached(params);
        this.dateConditionFromComps[0].afterGuiAttached(params);
    }
    mapValuesFromModel(filterModel) {
        const { dateFrom, dateTo, type } = filterModel || {};
        return [
            dateFrom && parseDateTimeFromString(dateFrom) || null,
            dateTo && parseDateTimeFromString(dateTo) || null
        ].slice(0, this.getNumberOfInputs(type));
    }
    comparator() {
        return this.dateFilterParams.comparator ? this.dateFilterParams.comparator : this.defaultComparator.bind(this);
    }
    defaultComparator(filterDate, cellValue) {
        const cellAsDate = cellValue;
        if (cellValue == null || cellAsDate < filterDate) return -1;
        if (cellAsDate > filterDate) return 1;
        return 0;
    }
    setParams(params) {
        this.dateFilterParams = params;
        super.setParams(params);
        const yearParser = (param, fallback)=>{
            if (params[param] != null) {
                if (!isNaN(params[param])) return params[param] == null ? fallback : Number(params[param]);
                else console.warn(`AG Grid: DateFilter ${param} is not a number`);
            }
            return fallback;
        };
        this.minValidYear = yearParser("minValidYear", DEFAULT_MIN_YEAR);
        this.maxValidYear = yearParser("maxValidYear", DEFAULT_MAX_YEAR);
        if (this.minValidYear > this.maxValidYear) console.warn(`AG Grid: DateFilter minValidYear should be <= maxValidYear`);
        if (params.minValidDate) this.minValidDate = params.minValidDate instanceof Date ? params.minValidDate : parseDateTimeFromString(params.minValidDate);
        else this.minValidDate = null;
        if (params.maxValidDate) this.maxValidDate = params.maxValidDate instanceof Date ? params.maxValidDate : parseDateTimeFromString(params.maxValidDate);
        else this.maxValidDate = null;
        if (this.minValidDate && this.maxValidDate && this.minValidDate > this.maxValidDate) console.warn(`AG Grid: DateFilter minValidDate should be <= maxValidDate`);
        this.filterModelFormatter = new DateFilterModelFormatter(this.dateFilterParams, this.localeService, this.optionsFactory);
    }
    createDateCompWrapper(element) {
        const dateCompWrapper = new DateCompWrapper(this.getContext(), this.userComponentFactory, {
            onDateChanged: ()=>this.onUiChanged(),
            filterParams: this.dateFilterParams
        }, element);
        this.addDestroyFunc(()=>dateCompWrapper.destroy());
        return dateCompWrapper;
    }
    setElementValue(element, value) {
        element.setDate(value);
    }
    setElementDisplayed(element, displayed) {
        element.setDisplayed(displayed);
    }
    setElementDisabled(element, disabled) {
        element.setDisabled(disabled);
    }
    getDefaultFilterOptions() {
        return _DateFilter.DEFAULT_FILTER_OPTIONS;
    }
    createValueElement() {
        const eDocument = this.gos.getDocument();
        const eCondition = eDocument.createElement("div");
        eCondition.classList.add("ag-filter-body");
        this.createFromToElement(eCondition, this.eConditionPanelsFrom, this.dateConditionFromComps, "from");
        this.createFromToElement(eCondition, this.eConditionPanelsTo, this.dateConditionToComps, "to");
        return eCondition;
    }
    createFromToElement(eCondition, eConditionPanels, dateConditionComps, fromTo) {
        const eDocument = this.gos.getDocument();
        const eConditionPanel = eDocument.createElement("div");
        eConditionPanel.classList.add(`ag-filter-${fromTo}`);
        eConditionPanel.classList.add(`ag-filter-date-${fromTo}`);
        eConditionPanels.push(eConditionPanel);
        eCondition.appendChild(eConditionPanel);
        dateConditionComps.push(this.createDateCompWrapper(eConditionPanel));
    }
    removeValueElements(startPosition, deleteCount) {
        this.removeDateComps(this.dateConditionFromComps, startPosition, deleteCount);
        this.removeDateComps(this.dateConditionToComps, startPosition, deleteCount);
        this.removeItems(this.eConditionPanelsFrom, startPosition, deleteCount);
        this.removeItems(this.eConditionPanelsTo, startPosition, deleteCount);
    }
    removeDateComps(components, startPosition, deleteCount) {
        const removedComponents = this.removeItems(components, startPosition, deleteCount);
        removedComponents.forEach((comp)=>comp.destroy());
    }
    isValidDateValue(value) {
        if (value === null) return false;
        if (this.minValidDate) {
            if (value < this.minValidDate) return false;
        } else {
            if (value.getUTCFullYear() < this.minValidYear) return false;
        }
        if (this.maxValidDate) {
            if (value > this.maxValidDate) return false;
        } else {
            if (value.getUTCFullYear() > this.maxValidYear) return false;
        }
        return true;
    }
    isConditionUiComplete(position) {
        if (!super.isConditionUiComplete(position)) return false;
        let valid = true;
        this.forEachInput((element, index, elPosition, numberOfInputs)=>{
            if (elPosition !== position || !valid || index >= numberOfInputs) return;
            valid = valid && this.isValidDateValue(element.getDate());
        });
        return valid;
    }
    areSimpleModelsEqual(aSimple, bSimple) {
        return aSimple.dateFrom === bSimple.dateFrom && aSimple.dateTo === bSimple.dateTo && aSimple.type === bSimple.type;
    }
    getFilterType() {
        return "date";
    }
    createCondition(position) {
        const type = this.getConditionType(position);
        const model = {};
        const values2 = this.getValues(position);
        if (values2.length > 0) model.dateFrom = serialiseDate(values2[0]);
        if (values2.length > 1) model.dateTo = serialiseDate(values2[1]);
        return __spreadValues({
            dateFrom: null,
            dateTo: null,
            filterType: this.getFilterType(),
            type
        }, model);
    }
    resetPlaceholder() {
        const globalTranslate = this.localeService.getLocaleTextFunc();
        const placeholder = this.translate("dateFormatOoo");
        const ariaLabel = globalTranslate("ariaFilterValue", "Filter Value");
        this.forEachInput((element)=>{
            element.setInputPlaceholder(placeholder);
            element.setInputAriaLabel(ariaLabel);
        });
    }
    getInputs(position) {
        if (position >= this.dateConditionFromComps.length) return [
            null,
            null
        ];
        return [
            this.dateConditionFromComps[position],
            this.dateConditionToComps[position]
        ];
    }
    getValues(position) {
        const result = [];
        this.forEachPositionInput(position, (element, index, _elPosition, numberOfInputs)=>{
            if (index < numberOfInputs) result.push(element.getDate());
        });
        return result;
    }
    translate(key) {
        if (key === ScalarFilter.LESS_THAN) return super.translate("before");
        if (key === ScalarFilter.GREATER_THAN) return super.translate("after");
        return super.translate(key);
    }
    getModelAsString(model) {
        var _a;
        return (_a = this.filterModelFormatter.getModelAsString(model)) != null ? _a : "";
    }
};
_DateFilter.DEFAULT_FILTER_OPTIONS = [
    ScalarFilter.EQUALS,
    ScalarFilter.NOT_EQUAL,
    ScalarFilter.LESS_THAN,
    ScalarFilter.GREATER_THAN,
    ScalarFilter.IN_RANGE,
    ScalarFilter.BLANK,
    ScalarFilter.NOT_BLANK
];
__decorateClass([
    Autowired("userComponentFactory")
], _DateFilter.prototype, "userComponentFactory", 2);
var DateFilter = _DateFilter;
// community-modules/core/src/filter/floating/provided/simpleFloatingFilter.ts
var SimpleFloatingFilter = class extends Component {
    getDefaultDebounceMs() {
        return 0;
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    destroy() {
        super.destroy();
    }
    isEventFromFloatingFilter(event) {
        return event && event.afterFloatingFilter;
    }
    isEventFromDataChange(event) {
        return event == null ? void 0 : event.afterDataChange;
    }
    getLastType() {
        return this.lastType;
    }
    isReadOnly() {
        return this.readOnly;
    }
    setLastTypeFromModel(model) {
        if (!model) {
            this.lastType = this.optionsFactory.getDefaultOption();
            return;
        }
        const isCombined = model.operator;
        let condition;
        if (isCombined) {
            const combinedModel = model;
            condition = combinedModel.conditions[0];
        } else condition = model;
        this.lastType = condition.type;
    }
    canWeEditAfterModelFromParentFilter(model) {
        if (!model) return this.isTypeEditable(this.lastType);
        const isCombined = model.operator;
        if (isCombined) return false;
        const simpleModel = model;
        return this.isTypeEditable(simpleModel.type);
    }
    init(params) {
        this.setSimpleParams(params, false);
    }
    setSimpleParams(params, update = true) {
        this.optionsFactory = new OptionsFactory();
        this.optionsFactory.init(params.filterParams, this.getDefaultFilterOptions());
        if (!update) this.lastType = this.optionsFactory.getDefaultOption();
        this.readOnly = !!params.filterParams.readOnly;
        const editable = this.isTypeEditable(this.optionsFactory.getDefaultOption());
        this.setEditable(editable);
    }
    onParamsUpdated(params) {
        this.refresh(params);
    }
    refresh(params) {
        this.setSimpleParams(params);
    }
    doesFilterHaveSingleInput(filterType) {
        const customFilterOption = this.optionsFactory.getCustomOption(filterType);
        const { numberOfInputs } = customFilterOption || {};
        return numberOfInputs == null || numberOfInputs == 1;
    }
    isTypeEditable(type) {
        const uneditableTypes = [
            SimpleFilter.IN_RANGE,
            SimpleFilter.EMPTY,
            SimpleFilter.BLANK,
            SimpleFilter.NOT_BLANK
        ];
        return !!type && !this.isReadOnly() && this.doesFilterHaveSingleInput(type) && uneditableTypes.indexOf(type) < 0;
    }
    getAriaLabel(params) {
        const displayName = this.columnModel.getDisplayNameForColumn(params.column, "header", true);
        const translate = this.localeService.getLocaleTextFunc();
        return `${displayName} ${translate("ariaFilterInput", "Filter Input")}`;
    }
};
__decorateClass([
    Autowired("columnModel")
], SimpleFloatingFilter.prototype, "columnModel", 2);
// community-modules/core/src/filter/provided/date/dateFloatingFilter.ts
var DateFloatingFilter = class extends SimpleFloatingFilter {
    constructor(){
        super(/* html */ `
            <div class="ag-floating-filter-input" role="presentation">
                <ag-input-text-field ref="eReadOnlyText"></ag-input-text-field>
                <div ref="eDateWrapper" style="display: flex;"></div>
            </div>`);
    }
    getDefaultFilterOptions() {
        return DateFilter.DEFAULT_FILTER_OPTIONS;
    }
    init(params) {
        super.init(params);
        this.params = params;
        this.filterParams = params.filterParams;
        this.createDateComponent();
        this.filterModelFormatter = new DateFilterModelFormatter(this.filterParams, this.localeService, this.optionsFactory);
        const translate = this.localeService.getLocaleTextFunc();
        this.eReadOnlyText.setDisabled(true).setInputAriaLabel(translate("ariaDateFilterInput", "Date Filter Input"));
    }
    onParamsUpdated(params) {
        this.refresh(params);
    }
    refresh(params) {
        super.refresh(params);
        this.params = params;
        this.filterParams = params.filterParams;
        this.updateDateComponent();
        this.filterModelFormatter.updateParams({
            optionsFactory: this.optionsFactory,
            dateFilterParams: this.filterParams
        });
        this.updateCompOnModelChange(params.currentParentModel());
    }
    updateCompOnModelChange(model) {
        const allowEditing = !this.isReadOnly() && this.canWeEditAfterModelFromParentFilter(model);
        this.setEditable(allowEditing);
        if (allowEditing) {
            if (model) {
                const dateModel = model;
                this.dateComp.setDate(parseDateTimeFromString(dateModel.dateFrom));
            } else this.dateComp.setDate(null);
            this.eReadOnlyText.setValue("");
        } else {
            this.eReadOnlyText.setValue(this.filterModelFormatter.getModelAsString(model));
            this.dateComp.setDate(null);
        }
    }
    setEditable(editable) {
        setDisplayed(this.eDateWrapper, editable);
        setDisplayed(this.eReadOnlyText.getGui(), !editable);
    }
    onParentModelChanged(model, event) {
        if (this.isEventFromFloatingFilter(event) || this.isEventFromDataChange(event)) return;
        super.setLastTypeFromModel(model);
        this.updateCompOnModelChange(model);
    }
    onDateChanged() {
        const filterValueDate = this.dateComp.getDate();
        const filterValueText = serialiseDate(filterValueDate);
        this.params.parentFilterInstance((filterInstance)=>{
            if (filterInstance) {
                const date = parseDateTimeFromString(filterValueText);
                filterInstance.onFloatingFilterChanged(this.getLastType() || null, date);
            }
        });
    }
    getDateComponentParams() {
        const debounceMs = ProvidedFilter.getDebounceMs(this.params.filterParams, this.getDefaultDebounceMs());
        return {
            onDateChanged: debounce(this.onDateChanged.bind(this), debounceMs),
            filterParams: this.params.column.getColDef().filterParams
        };
    }
    createDateComponent() {
        this.dateComp = new DateCompWrapper(this.getContext(), this.userComponentFactory, this.getDateComponentParams(), this.eDateWrapper, (dateComp)=>{
            dateComp.setInputAriaLabel(this.getAriaLabel(this.params));
        });
        this.addDestroyFunc(()=>this.dateComp.destroy());
    }
    updateDateComponent() {
        const params = this.gos.addGridCommonParams(this.getDateComponentParams());
        this.dateComp.updateParams(params);
    }
    getFilterModelFormatter() {
        return this.filterModelFormatter;
    }
};
__decorateClass([
    Autowired("userComponentFactory")
], DateFloatingFilter.prototype, "userComponentFactory", 2);
__decorateClass([
    RefSelector("eReadOnlyText")
], DateFloatingFilter.prototype, "eReadOnlyText", 2);
__decorateClass([
    RefSelector("eDateWrapper")
], DateFloatingFilter.prototype, "eDateWrapper", 2);
// community-modules/core/src/filter/provided/date/defaultDateComponent.ts
var DefaultDateComponent = class extends Component {
    constructor(){
        super(/* html */ `
            <div class="ag-filter-filter">
                <ag-input-text-field class="ag-date-filter" ref="eDateInput"></ag-input-text-field>
            </div>`);
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    destroy() {
        super.destroy();
    }
    init(params) {
        this.params = params;
        this.setParams(params);
        const inputElement = this.eDateInput.getInputElement();
        this.addManagedListener(inputElement, "mousedown", ()=>{
            if (this.eDateInput.isDisabled() || this.usingSafariDatePicker) return;
            inputElement.focus();
        });
        this.addManagedListener(inputElement, "input", (e)=>{
            if (e.target !== this.gos.getActiveDomElement()) return;
            if (this.eDateInput.isDisabled()) return;
            this.params.onDateChanged();
        });
    }
    setParams(params) {
        const inputElement = this.eDateInput.getInputElement();
        const shouldUseBrowserDatePicker = this.shouldUseBrowserDatePicker(params);
        this.usingSafariDatePicker = shouldUseBrowserDatePicker && isBrowserSafari();
        inputElement.type = shouldUseBrowserDatePicker ? "date" : "text";
        const { minValidYear, maxValidYear, minValidDate, maxValidDate } = params.filterParams || {};
        if (minValidDate && minValidYear) warnOnce("DateFilter should not have both minValidDate and minValidYear parameters set at the same time! minValidYear will be ignored.");
        if (maxValidDate && maxValidYear) warnOnce("DateFilter should not have both maxValidDate and maxValidYear parameters set at the same time! maxValidYear will be ignored.");
        if (minValidDate && maxValidDate) {
            const [parsedMinValidDate, parsedMaxValidDate] = [
                minValidDate,
                maxValidDate
            ].map((v)=>v instanceof Date ? v : parseDateTimeFromString(v));
            if (parsedMinValidDate && parsedMaxValidDate && parsedMinValidDate.getTime() > parsedMaxValidDate.getTime()) warnOnce("DateFilter parameter minValidDate should always be lower than or equal to parameter maxValidDate.");
        }
        if (minValidDate) {
            if (minValidDate instanceof Date) inputElement.min = dateToFormattedString(minValidDate);
            else inputElement.min = minValidDate;
        } else if (minValidYear) inputElement.min = `${minValidYear}-01-01`;
        if (maxValidDate) {
            if (maxValidDate instanceof Date) inputElement.max = dateToFormattedString(maxValidDate);
            else inputElement.max = maxValidDate;
        } else if (maxValidYear) inputElement.max = `${maxValidYear}-12-31`;
    }
    onParamsUpdated(params) {
        this.refresh(params);
    }
    refresh(params) {
        this.params = params;
        this.setParams(params);
    }
    getDate() {
        return parseDateTimeFromString(this.eDateInput.getValue());
    }
    setDate(date) {
        this.eDateInput.setValue(serialiseDate(date, false));
    }
    setInputPlaceholder(placeholder) {
        this.eDateInput.setInputPlaceholder(placeholder);
    }
    setInputAriaLabel(ariaLabel) {
        this.eDateInput.setAriaLabel(ariaLabel);
    }
    setDisabled(disabled) {
        this.eDateInput.setDisabled(disabled);
    }
    afterGuiAttached(params) {
        if (!params || !params.suppressFocus) this.eDateInput.getInputElement().focus();
    }
    shouldUseBrowserDatePicker(params) {
        if (params.filterParams && params.filterParams.browserDatePicker != null) return params.filterParams.browserDatePicker;
        return isBrowserChrome() || isBrowserFirefox() || isBrowserSafari() && getSafariVersion() >= 14.1;
    }
};
__decorateClass([
    RefSelector("eDateInput")
], DefaultDateComponent.prototype, "eDateInput", 2);
// community-modules/core/src/widgets/agInputTextField.ts
var AgInputTextField = class extends AgAbstractInputField {
    constructor(config, className = "ag-text-field", inputType = "text"){
        super(config, className, inputType);
    }
    postConstruct() {
        super.postConstruct();
        if (this.config.allowedCharPattern) this.preventDisallowedCharacters();
    }
    setValue(value, silent) {
        if (this.eInput.value !== value) this.eInput.value = exists(value) ? value : "";
        return super.setValue(value, silent);
    }
    /** Used to set an initial value into the input without necessarily setting `this.value` or triggering events (e.g. to set an invalid value) */ setStartValue(value) {
        this.setValue(value, true);
    }
    preventDisallowedCharacters() {
        const pattern = new RegExp(`[${this.config.allowedCharPattern}]`);
        const preventCharacters = (event)=>{
            if (!isEventFromPrintableCharacter(event)) return;
            if (event.key && !pattern.test(event.key)) event.preventDefault();
        };
        this.addManagedListener(this.eInput, "keydown", preventCharacters);
        this.addManagedListener(this.eInput, "paste", (e)=>{
            var _a;
            const text = (_a = e.clipboardData) == null ? void 0 : _a.getData("text");
            if (text && text.split("").some((c)=>!pattern.test(c))) e.preventDefault();
        });
    }
};
// community-modules/core/src/widgets/agInputNumberField.ts
var AgInputNumberField = class extends AgInputTextField {
    constructor(config){
        super(config, "ag-number-field", "number");
    }
    postConstruct() {
        super.postConstruct();
        this.addManagedListener(this.eInput, "blur", ()=>{
            const floatedValue = parseFloat(this.eInput.value);
            const value = isNaN(floatedValue) ? "" : this.normalizeValue(floatedValue.toString());
            if (this.value !== value) this.setValue(value);
        });
        this.addManagedListener(this.eInput, "wheel", this.onWheel.bind(this));
        this.eInput.step = "any";
        const { precision, min, max, step } = this.config;
        if (typeof precision === "number") this.setPrecision(precision);
        if (typeof min === "number") this.setMin(min);
        if (typeof max === "number") this.setMax(max);
        if (typeof step === "number") this.setStep(step);
    }
    onWheel(e) {
        if (this.gos.getActiveDomElement() === this.eInput) e.preventDefault();
    }
    normalizeValue(value) {
        if (value === "") return "";
        if (this.precision != null) value = this.adjustPrecision(value);
        const val = parseFloat(value);
        if (this.min != null && val < this.min) value = this.min.toString();
        else if (this.max != null && val > this.max) value = this.max.toString();
        return value;
    }
    adjustPrecision(value, isScientificNotation) {
        if (this.precision == null) return value;
        if (isScientificNotation) {
            const floatString = parseFloat(value).toFixed(this.precision);
            return parseFloat(floatString).toString();
        }
        const parts = String(value).split(".");
        if (parts.length > 1) {
            if (parts[1].length <= this.precision) return value;
            else if (this.precision > 0) return `${parts[0]}.${parts[1].slice(0, this.precision)}`;
        }
        return parts[0];
    }
    setMin(min) {
        if (this.min === min) return this;
        this.min = min;
        addOrRemoveAttribute(this.eInput, "min", min);
        return this;
    }
    setMax(max) {
        if (this.max === max) return this;
        this.max = max;
        addOrRemoveAttribute(this.eInput, "max", max);
        return this;
    }
    setPrecision(precision) {
        this.precision = precision;
        return this;
    }
    setStep(step) {
        if (this.step === step) return this;
        this.step = step;
        addOrRemoveAttribute(this.eInput, "step", step);
        return this;
    }
    setValue(value, silent) {
        return this.setValueOrInputValue((v)=>super.setValue(v, silent), ()=>this, value);
    }
    setStartValue(value) {
        return this.setValueOrInputValue((v)=>super.setValue(v, true), (v)=>{
            this.eInput.value = v;
        }, value);
    }
    setValueOrInputValue(setValueFunc, setInputValueOnlyFunc, value) {
        if (exists(value)) {
            let setInputValueOnly = this.isScientificNotation(value);
            if (setInputValueOnly && this.eInput.validity.valid) return setValueFunc(value);
            if (!setInputValueOnly) {
                value = this.adjustPrecision(value);
                const normalizedValue = this.normalizeValue(value);
                setInputValueOnly = value != normalizedValue;
            }
            if (setInputValueOnly) return setInputValueOnlyFunc(value);
        }
        return setValueFunc(value);
    }
    getValue() {
        if (!this.eInput.validity.valid) return void 0;
        const inputValue = this.eInput.value;
        if (this.isScientificNotation(inputValue)) return this.adjustPrecision(inputValue, true);
        return super.getValue();
    }
    isScientificNotation(value) {
        return typeof value === "string" && value.includes("e");
    }
};
// community-modules/core/src/filter/provided/number/numberFilter.ts
var NumberFilterModelFormatter = class extends SimpleFilterModelFormatter {
    conditionToString(condition, options) {
        const { numberOfInputs } = options || {};
        const isRange = condition.type == SimpleFilter.IN_RANGE || numberOfInputs === 2;
        if (isRange) return `${this.formatValue(condition.filter)}-${this.formatValue(condition.filterTo)}`;
        if (condition.filter != null) return this.formatValue(condition.filter);
        return `${condition.type}`;
    }
};
function getAllowedCharPattern(filterParams) {
    const { allowedCharPattern } = filterParams != null ? filterParams : {};
    return allowedCharPattern != null ? allowedCharPattern : null;
}
var _NumberFilter = class _NumberFilter extends ScalarFilter {
    constructor(){
        super("numberFilter");
        this.eValuesFrom = [];
        this.eValuesTo = [];
    }
    refresh(params) {
        if (this.numberFilterParams.allowedCharPattern !== params.allowedCharPattern) return false;
        return super.refresh(params);
    }
    mapValuesFromModel(filterModel) {
        const { filter, filterTo, type } = filterModel || {};
        return [
            this.processValue(filter),
            this.processValue(filterTo)
        ].slice(0, this.getNumberOfInputs(type));
    }
    getDefaultDebounceMs() {
        return 500;
    }
    comparator() {
        return (left, right)=>{
            if (left === right) return 0;
            return left < right ? 1 : -1;
        };
    }
    setParams(params) {
        this.numberFilterParams = params;
        super.setParams(params);
        this.filterModelFormatter = new NumberFilterModelFormatter(this.localeService, this.optionsFactory, this.numberFilterParams.numberFormatter);
    }
    getDefaultFilterOptions() {
        return _NumberFilter.DEFAULT_FILTER_OPTIONS;
    }
    setElementValue(element, value, fromFloatingFilter) {
        const valueToSet = !fromFloatingFilter && this.numberFilterParams.numberFormatter ? this.numberFilterParams.numberFormatter(value != null ? value : null) : value;
        super.setElementValue(element, valueToSet);
    }
    createValueElement() {
        const allowedCharPattern = getAllowedCharPattern(this.numberFilterParams);
        const eCondition = document.createElement("div");
        eCondition.classList.add("ag-filter-body");
        setAriaRole(eCondition, "presentation");
        this.createFromToElement(eCondition, this.eValuesFrom, "from", allowedCharPattern);
        this.createFromToElement(eCondition, this.eValuesTo, "to", allowedCharPattern);
        return eCondition;
    }
    createFromToElement(eCondition, eValues, fromTo, allowedCharPattern) {
        const eValue = this.createManagedBean(allowedCharPattern ? new AgInputTextField({
            allowedCharPattern
        }) : new AgInputNumberField());
        eValue.addCssClass(`ag-filter-${fromTo}`);
        eValue.addCssClass("ag-filter-filter");
        eValues.push(eValue);
        eCondition.appendChild(eValue.getGui());
    }
    removeValueElements(startPosition, deleteCount) {
        this.removeComponents(this.eValuesFrom, startPosition, deleteCount);
        this.removeComponents(this.eValuesTo, startPosition, deleteCount);
    }
    getValues(position) {
        const result = [];
        this.forEachPositionInput(position, (element, index, _elPosition, numberOfInputs)=>{
            if (index < numberOfInputs) result.push(this.processValue(this.stringToFloat(element.getValue())));
        });
        return result;
    }
    areSimpleModelsEqual(aSimple, bSimple) {
        return aSimple.filter === bSimple.filter && aSimple.filterTo === bSimple.filterTo && aSimple.type === bSimple.type;
    }
    getFilterType() {
        return "number";
    }
    processValue(value) {
        if (value == null) return null;
        return isNaN(value) ? null : value;
    }
    stringToFloat(value) {
        if (typeof value === "number") return value;
        let filterText = makeNull(value);
        if (filterText != null && filterText.trim() === "") filterText = null;
        if (this.numberFilterParams.numberParser) return this.numberFilterParams.numberParser(filterText);
        return filterText == null || filterText.trim() === "-" ? null : parseFloat(filterText);
    }
    createCondition(position) {
        const type = this.getConditionType(position);
        const model = {
            filterType: this.getFilterType(),
            type
        };
        const values2 = this.getValues(position);
        if (values2.length > 0) model.filter = values2[0];
        if (values2.length > 1) model.filterTo = values2[1];
        return model;
    }
    getInputs(position) {
        if (position >= this.eValuesFrom.length) return [
            null,
            null
        ];
        return [
            this.eValuesFrom[position],
            this.eValuesTo[position]
        ];
    }
    getModelAsString(model) {
        var _a;
        return (_a = this.filterModelFormatter.getModelAsString(model)) != null ? _a : "";
    }
    hasInvalidInputs() {
        let invalidInputs = false;
        this.forEachInput((element)=>{
            if (!element.getInputElement().validity.valid) {
                invalidInputs = true;
                return;
            }
        });
        return invalidInputs;
    }
};
_NumberFilter.DEFAULT_FILTER_OPTIONS = [
    ScalarFilter.EQUALS,
    ScalarFilter.NOT_EQUAL,
    ScalarFilter.GREATER_THAN,
    ScalarFilter.GREATER_THAN_OR_EQUAL,
    ScalarFilter.LESS_THAN,
    ScalarFilter.LESS_THAN_OR_EQUAL,
    ScalarFilter.IN_RANGE,
    ScalarFilter.BLANK,
    ScalarFilter.NOT_BLANK
];
var NumberFilter = _NumberFilter;
// community-modules/core/src/filter/provided/text/textFilter.ts
var TextFilterModelFormatter = class extends SimpleFilterModelFormatter {
    conditionToString(condition, options) {
        const { numberOfInputs } = options || {};
        const isRange = condition.type == SimpleFilter.IN_RANGE || numberOfInputs === 2;
        if (isRange) return `${condition.filter}-${condition.filterTo}`;
        if (condition.filter != null) return `${condition.filter}`;
        return `${condition.type}`;
    }
};
var _TextFilter = class _TextFilter extends SimpleFilter {
    constructor(){
        super("textFilter");
        this.eValuesFrom = [];
        this.eValuesTo = [];
    }
    static trimInput(value) {
        const trimmedInput = value && value.trim();
        return trimmedInput === "" ? value : trimmedInput;
    }
    getDefaultDebounceMs() {
        return 500;
    }
    setParams(params) {
        this.textFilterParams = params;
        super.setParams(params);
        this.matcher = this.getTextMatcher();
        this.formatter = this.textFilterParams.textFormatter || (this.textFilterParams.caseSensitive ? _TextFilter.DEFAULT_FORMATTER : _TextFilter.DEFAULT_LOWERCASE_FORMATTER);
        this.filterModelFormatter = new TextFilterModelFormatter(this.localeService, this.optionsFactory);
    }
    getTextMatcher() {
        const legacyComparator = this.textFilterParams.textCustomComparator;
        if (legacyComparator) {
            _.warnOnce("textCustomComparator is deprecated, use textMatcher instead.");
            return ({ filterOption, value, filterText })=>legacyComparator(filterOption, value, filterText);
        }
        return this.textFilterParams.textMatcher || _TextFilter.DEFAULT_MATCHER;
    }
    createCondition(position) {
        const type = this.getConditionType(position);
        const model = {
            filterType: this.getFilterType(),
            type
        };
        const values2 = this.getValuesWithSideEffects(position, true);
        if (values2.length > 0) model.filter = values2[0];
        if (values2.length > 1) model.filterTo = values2[1];
        return model;
    }
    getFilterType() {
        return "text";
    }
    areSimpleModelsEqual(aSimple, bSimple) {
        return aSimple.filter === bSimple.filter && aSimple.filterTo === bSimple.filterTo && aSimple.type === bSimple.type;
    }
    getInputs(position) {
        if (position >= this.eValuesFrom.length) return [
            null,
            null
        ];
        return [
            this.eValuesFrom[position],
            this.eValuesTo[position]
        ];
    }
    getValues(position) {
        return this.getValuesWithSideEffects(position, false);
    }
    getValuesWithSideEffects(position, applySideEffects) {
        const result = [];
        this.forEachPositionInput(position, (element, index, _elPosition, numberOfInputs)=>{
            var _a;
            if (index < numberOfInputs) {
                let value = makeNull(element.getValue());
                if (applySideEffects && this.textFilterParams.trimInput) {
                    value = (_a = _TextFilter.trimInput(value)) != null ? _a : null;
                    element.setValue(value, true);
                }
                result.push(value);
            }
        });
        return result;
    }
    getDefaultFilterOptions() {
        return _TextFilter.DEFAULT_FILTER_OPTIONS;
    }
    createValueElement() {
        const eCondition = document.createElement("div");
        eCondition.classList.add("ag-filter-body");
        setAriaRole(eCondition, "presentation");
        this.createFromToElement(eCondition, this.eValuesFrom, "from");
        this.createFromToElement(eCondition, this.eValuesTo, "to");
        return eCondition;
    }
    createFromToElement(eCondition, eValues, fromTo) {
        const eValue = this.createManagedBean(new AgInputTextField());
        eValue.addCssClass(`ag-filter-${fromTo}`);
        eValue.addCssClass("ag-filter-filter");
        eValues.push(eValue);
        eCondition.appendChild(eValue.getGui());
    }
    removeValueElements(startPosition, deleteCount) {
        this.removeComponents(this.eValuesFrom, startPosition, deleteCount);
        this.removeComponents(this.eValuesTo, startPosition, deleteCount);
    }
    mapValuesFromModel(filterModel) {
        const { filter, filterTo, type } = filterModel || {};
        return [
            filter || null,
            filterTo || null
        ].slice(0, this.getNumberOfInputs(type));
    }
    evaluateNullValue(filterType) {
        const filterTypesAllowNulls = [
            SimpleFilter.NOT_EQUAL,
            SimpleFilter.NOT_CONTAINS,
            SimpleFilter.BLANK
        ];
        return filterType ? filterTypesAllowNulls.indexOf(filterType) >= 0 : false;
    }
    evaluateNonNullValue(values2, cellValue, filterModel, params) {
        const formattedValues = values2.map((v)=>this.formatter(v)) || [];
        const cellValueFormatted = this.formatter(cellValue);
        const { api, colDef, column, columnApi, context, textFormatter } = this.textFilterParams;
        if (filterModel.type === SimpleFilter.BLANK) return this.isBlank(cellValue);
        else if (filterModel.type === SimpleFilter.NOT_BLANK) return !this.isBlank(cellValue);
        const matcherParams = {
            api,
            colDef,
            column,
            columnApi,
            context,
            node: params.node,
            data: params.data,
            filterOption: filterModel.type,
            value: cellValueFormatted,
            textFormatter
        };
        return formattedValues.some((v)=>this.matcher(__spreadProps(__spreadValues({}, matcherParams), {
                filterText: v
            })));
    }
    getModelAsString(model) {
        var _a;
        return (_a = this.filterModelFormatter.getModelAsString(model)) != null ? _a : "";
    }
};
_TextFilter.DEFAULT_FILTER_OPTIONS = [
    SimpleFilter.CONTAINS,
    SimpleFilter.NOT_CONTAINS,
    SimpleFilter.EQUALS,
    SimpleFilter.NOT_EQUAL,
    SimpleFilter.STARTS_WITH,
    SimpleFilter.ENDS_WITH,
    SimpleFilter.BLANK,
    SimpleFilter.NOT_BLANK
];
_TextFilter.DEFAULT_FORMATTER = (from)=>from;
_TextFilter.DEFAULT_LOWERCASE_FORMATTER = (from)=>from == null ? null : from.toString().toLowerCase();
_TextFilter.DEFAULT_MATCHER = ({ filterOption, value, filterText })=>{
    if (filterText == null) return false;
    switch(filterOption){
        case _TextFilter.CONTAINS:
            return value.indexOf(filterText) >= 0;
        case _TextFilter.NOT_CONTAINS:
            return value.indexOf(filterText) < 0;
        case _TextFilter.EQUALS:
            return value === filterText;
        case _TextFilter.NOT_EQUAL:
            return value != filterText;
        case _TextFilter.STARTS_WITH:
            return value.indexOf(filterText) === 0;
        case _TextFilter.ENDS_WITH:
            const index = value.lastIndexOf(filterText);
            return index >= 0 && index === value.length - filterText.length;
        default:
            return false;
    }
};
var TextFilter = _TextFilter;
// community-modules/core/src/filter/floating/provided/textInputFloatingFilter.ts
var FloatingFilterTextInputService = class extends BeanStub {
    constructor(params){
        super();
        this.params = params;
        this.valueChangedListener = ()=>{};
    }
    setupGui(parentElement) {
        var _a;
        this.eFloatingFilterTextInput = this.createManagedBean(new AgInputTextField((_a = this.params) == null ? void 0 : _a.config));
        const eInput = this.eFloatingFilterTextInput.getGui();
        parentElement.appendChild(eInput);
        this.addManagedListener(eInput, "input", (e)=>this.valueChangedListener(e));
        this.addManagedListener(eInput, "keydown", (e)=>this.valueChangedListener(e));
    }
    setEditable(editable) {
        this.eFloatingFilterTextInput.setDisabled(!editable);
    }
    setAutoComplete(autoComplete) {
        this.eFloatingFilterTextInput.setAutoComplete(autoComplete);
    }
    getValue() {
        return this.eFloatingFilterTextInput.getValue();
    }
    setValue(value, silent) {
        this.eFloatingFilterTextInput.setValue(value, silent);
    }
    setValueChangedListener(listener) {
        this.valueChangedListener = listener;
    }
    setParams(params) {
        this.setAriaLabel(params.ariaLabel);
        if (params.autoComplete !== void 0) this.setAutoComplete(params.autoComplete);
    }
    setAriaLabel(ariaLabel) {
        this.eFloatingFilterTextInput.setInputAriaLabel(ariaLabel);
    }
};
var TextInputFloatingFilter = class extends SimpleFloatingFilter {
    postConstruct() {
        this.setTemplate(/* html */ `
            <div class="ag-floating-filter-input" role="presentation" ref="eFloatingFilterInputContainer"></div>
        `);
    }
    getDefaultDebounceMs() {
        return 500;
    }
    onParentModelChanged(model, event) {
        if (this.isEventFromFloatingFilter(event) || this.isEventFromDataChange(event)) return;
        this.setLastTypeFromModel(model);
        this.setEditable(this.canWeEditAfterModelFromParentFilter(model));
        this.floatingFilterInputService.setValue(this.getFilterModelFormatter().getModelAsString(model));
    }
    init(params) {
        this.setupFloatingFilterInputService(params);
        super.init(params);
        this.setTextInputParams(params);
    }
    setupFloatingFilterInputService(params) {
        this.floatingFilterInputService = this.createFloatingFilterInputService(params);
        this.floatingFilterInputService.setupGui(this.eFloatingFilterInputContainer);
    }
    setTextInputParams(params) {
        var _a;
        this.params = params;
        const autoComplete = (_a = params.browserAutoComplete) != null ? _a : false;
        this.floatingFilterInputService.setParams({
            ariaLabel: this.getAriaLabel(params),
            autoComplete
        });
        this.applyActive = ProvidedFilter.isUseApplyButton(this.params.filterParams);
        if (!this.isReadOnly()) {
            const debounceMs = ProvidedFilter.getDebounceMs(this.params.filterParams, this.getDefaultDebounceMs());
            const toDebounce = debounce(this.syncUpWithParentFilter.bind(this), debounceMs);
            this.floatingFilterInputService.setValueChangedListener(toDebounce);
        }
    }
    onParamsUpdated(params) {
        this.refresh(params);
    }
    refresh(params) {
        super.refresh(params);
        this.setTextInputParams(params);
    }
    recreateFloatingFilterInputService(params) {
        const value = this.floatingFilterInputService.getValue();
        clearElement(this.eFloatingFilterInputContainer);
        this.destroyBean(this.floatingFilterInputService);
        this.setupFloatingFilterInputService(params);
        this.floatingFilterInputService.setValue(value, true);
    }
    syncUpWithParentFilter(e) {
        const isEnterKey = e.key === KeyCode.ENTER;
        if (this.applyActive && !isEnterKey) return;
        let value = this.floatingFilterInputService.getValue();
        if (this.params.filterParams.trimInput) {
            value = TextFilter.trimInput(value);
            this.floatingFilterInputService.setValue(value, true);
        }
        this.params.parentFilterInstance((filterInstance)=>{
            if (filterInstance) filterInstance.onFloatingFilterChanged(this.getLastType() || null, value || null);
        });
    }
    setEditable(editable) {
        this.floatingFilterInputService.setEditable(editable);
    }
};
__decorateClass([
    RefSelector("eFloatingFilterInputContainer")
], TextInputFloatingFilter.prototype, "eFloatingFilterInputContainer", 2);
__decorateClass([
    PostConstruct
], TextInputFloatingFilter.prototype, "postConstruct", 1);
// community-modules/core/src/filter/provided/number/numberFloatingFilter.ts
var FloatingFilterNumberInputService = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.valueChangedListener = ()=>{};
        this.numberInputActive = true;
    }
    setupGui(parentElement) {
        this.eFloatingFilterNumberInput = this.createManagedBean(new AgInputNumberField());
        this.eFloatingFilterTextInput = this.createManagedBean(new AgInputTextField());
        this.eFloatingFilterTextInput.setDisabled(true);
        const eNumberInput = this.eFloatingFilterNumberInput.getGui();
        const eTextInput = this.eFloatingFilterTextInput.getGui();
        parentElement.appendChild(eNumberInput);
        parentElement.appendChild(eTextInput);
        this.setupListeners(eNumberInput, (e)=>this.valueChangedListener(e));
        this.setupListeners(eTextInput, (e)=>this.valueChangedListener(e));
    }
    setEditable(editable) {
        this.numberInputActive = editable;
        this.eFloatingFilterNumberInput.setDisplayed(this.numberInputActive);
        this.eFloatingFilterTextInput.setDisplayed(!this.numberInputActive);
    }
    setAutoComplete(autoComplete) {
        this.eFloatingFilterNumberInput.setAutoComplete(autoComplete);
        this.eFloatingFilterTextInput.setAutoComplete(autoComplete);
    }
    getValue() {
        return this.getActiveInputElement().getValue();
    }
    setValue(value, silent) {
        this.getActiveInputElement().setValue(value, silent);
    }
    getActiveInputElement() {
        return this.numberInputActive ? this.eFloatingFilterNumberInput : this.eFloatingFilterTextInput;
    }
    setValueChangedListener(listener) {
        this.valueChangedListener = listener;
    }
    setupListeners(element, listener) {
        this.addManagedListener(element, "input", listener);
        this.addManagedListener(element, "keydown", listener);
    }
    setParams(params) {
        this.setAriaLabel(params.ariaLabel);
        if (params.autoComplete !== void 0) this.setAutoComplete(params.autoComplete);
    }
    setAriaLabel(ariaLabel) {
        this.eFloatingFilterNumberInput.setInputAriaLabel(ariaLabel);
        this.eFloatingFilterTextInput.setInputAriaLabel(ariaLabel);
    }
};
var NumberFloatingFilter = class extends TextInputFloatingFilter {
    init(params) {
        var _a;
        super.init(params);
        this.filterModelFormatter = new NumberFilterModelFormatter(this.localeService, this.optionsFactory, (_a = params.filterParams) == null ? void 0 : _a.numberFormatter);
    }
    onParamsUpdated(params) {
        this.refresh(params);
    }
    refresh(params) {
        const allowedCharPattern = getAllowedCharPattern(params.filterParams);
        if (allowedCharPattern !== this.allowedCharPattern) this.recreateFloatingFilterInputService(params);
        super.refresh(params);
        this.filterModelFormatter.updateParams({
            optionsFactory: this.optionsFactory
        });
    }
    getDefaultFilterOptions() {
        return NumberFilter.DEFAULT_FILTER_OPTIONS;
    }
    getFilterModelFormatter() {
        return this.filterModelFormatter;
    }
    createFloatingFilterInputService(params) {
        this.allowedCharPattern = getAllowedCharPattern(params.filterParams);
        if (this.allowedCharPattern) return this.createManagedBean(new FloatingFilterTextInputService({
            config: {
                allowedCharPattern: this.allowedCharPattern
            }
        }));
        return this.createManagedBean(new FloatingFilterNumberInputService());
    }
};
// community-modules/core/src/filter/provided/text/textFloatingFilter.ts
var TextFloatingFilter = class extends TextInputFloatingFilter {
    init(params) {
        super.init(params);
        this.filterModelFormatter = new TextFilterModelFormatter(this.localeService, this.optionsFactory);
    }
    onParamsUpdated(params) {
        this.refresh(params);
    }
    refresh(params) {
        super.refresh(params);
        this.filterModelFormatter.updateParams({
            optionsFactory: this.optionsFactory
        });
    }
    getDefaultFilterOptions() {
        return TextFilter.DEFAULT_FILTER_OPTIONS;
    }
    getFilterModelFormatter() {
        return this.filterModelFormatter;
    }
    createFloatingFilterInputService() {
        return this.createManagedBean(new FloatingFilterTextInputService());
    }
};
// community-modules/core/src/widgets/touchListener.ts
var _TouchListener = class _TouchListener {
    constructor(eElement, preventMouseClick = false){
        this.destroyFuncs = [];
        this.touching = false;
        this.eventService = new EventService();
        this.eElement = eElement;
        this.preventMouseClick = preventMouseClick;
        const startListener = this.onTouchStart.bind(this);
        const moveListener = this.onTouchMove.bind(this);
        const endListener = this.onTouchEnd.bind(this);
        this.eElement.addEventListener("touchstart", startListener, {
            passive: true
        });
        this.eElement.addEventListener("touchmove", moveListener, {
            passive: true
        });
        this.eElement.addEventListener("touchend", endListener, {
            passive: false
        });
        this.destroyFuncs.push(()=>{
            this.eElement.removeEventListener("touchstart", startListener, {
                passive: true
            });
            this.eElement.removeEventListener("touchmove", moveListener, {
                passive: true
            });
            this.eElement.removeEventListener("touchend", endListener, {
                passive: false
            });
        });
    }
    getActiveTouch(touchList) {
        for(let i = 0; i < touchList.length; i++){
            const matches = touchList[i].identifier === this.touchStart.identifier;
            if (matches) return touchList[i];
        }
        return null;
    }
    addEventListener(eventType, listener) {
        this.eventService.addEventListener(eventType, listener);
    }
    removeEventListener(eventType, listener) {
        this.eventService.removeEventListener(eventType, listener);
    }
    onTouchStart(touchEvent) {
        if (this.touching) return;
        this.touchStart = touchEvent.touches[0];
        this.touching = true;
        this.moved = false;
        const touchStartCopy = this.touchStart;
        window.setTimeout(()=>{
            const touchesMatch = this.touchStart === touchStartCopy;
            if (this.touching && touchesMatch && !this.moved) {
                this.moved = true;
                const event = {
                    type: _TouchListener.EVENT_LONG_TAP,
                    touchStart: this.touchStart,
                    touchEvent
                };
                this.eventService.dispatchEvent(event);
            }
        }, 500);
    }
    onTouchMove(touchEvent) {
        if (!this.touching) return;
        const touch = this.getActiveTouch(touchEvent.touches);
        if (!touch) return;
        const eventIsFarAway = !areEventsNear(touch, this.touchStart, 4);
        if (eventIsFarAway) this.moved = true;
    }
    onTouchEnd(touchEvent) {
        if (!this.touching) return;
        if (!this.moved) {
            const event = {
                type: _TouchListener.EVENT_TAP,
                touchStart: this.touchStart
            };
            this.eventService.dispatchEvent(event);
            this.checkForDoubleTap();
        }
        if (this.preventMouseClick && touchEvent.cancelable) touchEvent.preventDefault();
        this.touching = false;
    }
    checkForDoubleTap() {
        const now = /* @__PURE__ */ new Date().getTime();
        if (this.lastTapTime && this.lastTapTime > 0) {
            const interval = now - this.lastTapTime;
            if (interval > _TouchListener.DOUBLE_TAP_MILLIS) {
                const event = {
                    type: _TouchListener.EVENT_DOUBLE_TAP,
                    touchStart: this.touchStart
                };
                this.eventService.dispatchEvent(event);
                this.lastTapTime = null;
            } else this.lastTapTime = now;
        } else this.lastTapTime = now;
    }
    destroy() {
        this.destroyFuncs.forEach((func)=>func());
    }
};
_TouchListener.EVENT_TAP = "tap";
_TouchListener.EVENT_DOUBLE_TAP = "doubleTap";
_TouchListener.EVENT_LONG_TAP = "longTap";
_TouchListener.DOUBLE_TAP_MILLIS = 500;
var TouchListener = _TouchListener;
// community-modules/core/src/headerRendering/cells/column/sortIndicatorComp.ts
var _SortIndicatorComp = class _SortIndicatorComp extends Component {
    constructor(skipTemplate){
        super();
        if (!skipTemplate) this.setTemplate(_SortIndicatorComp.TEMPLATE);
    }
    attachCustomElements(eSortOrder, eSortAsc, eSortDesc, eSortMixed, eSortNone) {
        this.eSortOrder = eSortOrder;
        this.eSortAsc = eSortAsc;
        this.eSortDesc = eSortDesc;
        this.eSortMixed = eSortMixed;
        this.eSortNone = eSortNone;
    }
    setupSort(column, suppressOrder = false) {
        this.column = column;
        this.suppressOrder = suppressOrder;
        this.setupMultiSortIndicator();
        if (!this.column.isSortable() && !this.column.getColDef().showRowGroup) return;
        this.addInIcon("sortAscending", this.eSortAsc, column);
        this.addInIcon("sortDescending", this.eSortDesc, column);
        this.addInIcon("sortUnSort", this.eSortNone, column);
        this.addManagedPropertyListener("unSortIcon", ()=>this.updateIcons());
        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, ()=>this.updateIcons());
        this.addManagedListener(this.eventService, Events.EVENT_SORT_CHANGED, ()=>this.onSortChanged());
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, ()=>this.onSortChanged());
        this.onSortChanged();
    }
    addInIcon(iconName, eParent, column) {
        if (eParent == null) return;
        const eIcon = createIconNoSpan(iconName, this.gos, column);
        if (eIcon) eParent.appendChild(eIcon);
    }
    onSortChanged() {
        this.updateIcons();
        if (!this.suppressOrder) this.updateSortOrder();
    }
    updateIcons() {
        const sortDirection = this.sortController.getDisplaySortForColumn(this.column);
        if (this.eSortAsc) {
            const isAscending = sortDirection === "asc";
            setDisplayed(this.eSortAsc, isAscending, {
                skipAriaHidden: true
            });
        }
        if (this.eSortDesc) {
            const isDescending = sortDirection === "desc";
            setDisplayed(this.eSortDesc, isDescending, {
                skipAriaHidden: true
            });
        }
        if (this.eSortNone) {
            const alwaysHideNoSort = !this.column.getColDef().unSortIcon && !this.gos.get("unSortIcon");
            const isNone = sortDirection === null || sortDirection === void 0;
            setDisplayed(this.eSortNone, !alwaysHideNoSort && isNone, {
                skipAriaHidden: true
            });
        }
    }
    setupMultiSortIndicator() {
        this.addInIcon("sortUnSort", this.eSortMixed, this.column);
        const isColumnShowingRowGroup = this.column.getColDef().showRowGroup;
        const areGroupsCoupled = this.gos.isColumnsSortingCoupledToGroup();
        if (areGroupsCoupled && isColumnShowingRowGroup) {
            this.addManagedListener(this.eventService, Events.EVENT_SORT_CHANGED, ()=>this.updateMultiSortIndicator());
            this.addManagedListener(this.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, ()=>this.updateMultiSortIndicator());
            this.updateMultiSortIndicator();
        }
    }
    updateMultiSortIndicator() {
        if (this.eSortMixed) {
            const isMixedSort = this.sortController.getDisplaySortForColumn(this.column) === "mixed";
            setDisplayed(this.eSortMixed, isMixedSort, {
                skipAriaHidden: true
            });
        }
    }
    // we listen here for global sort events, NOT column sort events, as we want to do this
    // when sorting has been set on all column (if we listened just for our col (where we
    // set the asc / desc icons) then it's possible other cols are yet to get their sorting state.
    updateSortOrder() {
        var _a;
        if (!this.eSortOrder) return;
        const allColumnsWithSorting = this.sortController.getColumnsWithSortingOrdered();
        const indexThisCol = (_a = this.sortController.getDisplaySortIndexForColumn(this.column)) != null ? _a : -1;
        const moreThanOneColSorting = allColumnsWithSorting.some((col)=>{
            var _a2;
            return (_a2 = this.sortController.getDisplaySortIndexForColumn(col)) != null ? _a2 : false;
        });
        const showIndex = indexThisCol >= 0 && moreThanOneColSorting;
        setDisplayed(this.eSortOrder, showIndex, {
            skipAriaHidden: true
        });
        if (indexThisCol >= 0) this.eSortOrder.textContent = (indexThisCol + 1).toString();
        else clearElement(this.eSortOrder);
    }
};
_SortIndicatorComp.TEMPLATE = /* html */ `<span class="ag-sort-indicator-container">
            <span ref="eSortOrder" class="ag-sort-indicator-icon ag-sort-order ag-hidden" aria-hidden="true"></span>
            <span ref="eSortAsc" class="ag-sort-indicator-icon ag-sort-ascending-icon ag-hidden" aria-hidden="true"></span>
            <span ref="eSortDesc" class="ag-sort-indicator-icon ag-sort-descending-icon ag-hidden" aria-hidden="true"></span>
            <span ref="eSortMixed" class="ag-sort-indicator-icon ag-sort-mixed-icon ag-hidden" aria-hidden="true"></span>
            <span ref="eSortNone" class="ag-sort-indicator-icon ag-sort-none-icon ag-hidden" aria-hidden="true"></span>
        </span>`;
__decorateClass([
    RefSelector("eSortOrder")
], _SortIndicatorComp.prototype, "eSortOrder", 2);
__decorateClass([
    RefSelector("eSortAsc")
], _SortIndicatorComp.prototype, "eSortAsc", 2);
__decorateClass([
    RefSelector("eSortDesc")
], _SortIndicatorComp.prototype, "eSortDesc", 2);
__decorateClass([
    RefSelector("eSortMixed")
], _SortIndicatorComp.prototype, "eSortMixed", 2);
__decorateClass([
    RefSelector("eSortNone")
], _SortIndicatorComp.prototype, "eSortNone", 2);
__decorateClass([
    Autowired("columnModel")
], _SortIndicatorComp.prototype, "columnModel", 2);
__decorateClass([
    Autowired("sortController")
], _SortIndicatorComp.prototype, "sortController", 2);
var SortIndicatorComp = _SortIndicatorComp;
// community-modules/core/src/headerRendering/cells/column/headerComp.ts
var _HeaderComp = class _HeaderComp extends Component {
    constructor(){
        super(...arguments);
        this.lastMovingChanged = 0;
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    destroy() {
        super.destroy();
    }
    refresh(params) {
        const oldParams = this.params;
        this.params = params;
        if (this.workOutTemplate() != this.currentTemplate || this.workOutShowMenu() != this.currentShowMenu || this.workOutSort() != this.currentSort || this.shouldSuppressMenuHide() != this.currentSuppressMenuHide || oldParams.enableFilterButton != params.enableFilterButton || oldParams.enableFilterIcon != params.enableFilterIcon) return false;
        this.setDisplayName(params);
        return true;
    }
    workOutTemplate() {
        var _a;
        let template = (_a = this.params.template) != null ? _a : _HeaderComp.TEMPLATE;
        template = template && template.trim ? template.trim() : template;
        return template;
    }
    init(params) {
        this.params = params;
        this.currentTemplate = this.workOutTemplate();
        this.setTemplate(this.currentTemplate);
        this.setupTap();
        this.setMenu();
        this.setupSort();
        this.setupFilterIcon();
        this.setupFilterButton();
        this.setDisplayName(params);
    }
    setDisplayName(params) {
        if (this.currentDisplayName != params.displayName) {
            this.currentDisplayName = params.displayName;
            const displayNameSanitised = escapeString(this.currentDisplayName, true);
            if (this.eText) this.eText.textContent = displayNameSanitised;
        }
    }
    addInIcon(iconName, eParent, column) {
        if (eParent == null) return;
        const eIcon = createIconNoSpan(iconName, this.gos, column);
        if (eIcon) eParent.appendChild(eIcon);
    }
    setupTap() {
        const { gos } = this;
        if (gos.get("suppressTouch")) return;
        const touchListener = new TouchListener(this.getGui(), true);
        const suppressMenuHide = this.shouldSuppressMenuHide();
        const tapMenuButton = suppressMenuHide && exists(this.eMenu);
        const menuTouchListener = tapMenuButton ? new TouchListener(this.eMenu, true) : touchListener;
        if (this.params.enableMenu) {
            const eventType = tapMenuButton ? "EVENT_TAP" : "EVENT_LONG_TAP";
            const showMenuFn = (event)=>this.params.showColumnMenuAfterMouseClick(event.touchStart);
            this.addManagedListener(menuTouchListener, TouchListener[eventType], showMenuFn);
        }
        if (this.params.enableSorting) {
            const tapListener = (event)=>{
                var _a, _b;
                const target = event.touchStart.target;
                if (suppressMenuHide && (((_a = this.eMenu) == null ? void 0 : _a.contains(target)) || ((_b = this.eFilterButton) == null ? void 0 : _b.contains(target)))) return;
                this.sortController.progressSort(this.params.column, false, "uiColumnSorted");
            };
            this.addManagedListener(touchListener, TouchListener.EVENT_TAP, tapListener);
        }
        if (this.params.enableFilterButton) {
            const filterButtonTouchListener = new TouchListener(this.eFilterButton, true);
            this.addManagedListener(filterButtonTouchListener, "tap", ()=>this.params.showFilter(this.eFilterButton));
            this.addDestroyFunc(()=>filterButtonTouchListener.destroy());
        }
        this.addDestroyFunc(()=>touchListener.destroy());
        if (tapMenuButton) this.addDestroyFunc(()=>menuTouchListener.destroy());
    }
    workOutShowMenu() {
        return this.params.enableMenu && this.menuService.isHeaderMenuButtonEnabled();
    }
    shouldSuppressMenuHide() {
        return this.menuService.isHeaderMenuButtonAlwaysShowEnabled();
    }
    setMenu() {
        if (!this.eMenu) return;
        this.currentShowMenu = this.workOutShowMenu();
        if (!this.currentShowMenu) {
            removeFromParent(this.eMenu);
            this.eMenu = void 0;
            return;
        }
        const isLegacyMenu = this.menuService.isLegacyMenuEnabled();
        this.addInIcon(isLegacyMenu ? "menu" : "menuAlt", this.eMenu, this.params.column);
        this.eMenu.classList.toggle("ag-header-menu-icon", !isLegacyMenu);
        this.currentSuppressMenuHide = this.shouldSuppressMenuHide();
        this.addManagedListener(this.eMenu, "click", ()=>this.params.showColumnMenu(this.eMenu));
        this.eMenu.classList.toggle("ag-header-menu-always-show", this.currentSuppressMenuHide);
    }
    onMenuKeyboardShortcut(isFilterShortcut) {
        var _a, _b, _c, _d;
        const { column } = this.params;
        const isLegacyMenuEnabled = this.menuService.isLegacyMenuEnabled();
        if (isFilterShortcut && !isLegacyMenuEnabled) {
            if (this.menuService.isFilterMenuInHeaderEnabled(column)) {
                this.params.showFilter((_b = (_a = this.eFilterButton) != null ? _a : this.eMenu) != null ? _b : this.getGui());
                return true;
            }
        } else if (this.params.enableMenu) {
            this.params.showColumnMenu((_d = (_c = this.eMenu) != null ? _c : this.eFilterButton) != null ? _d : this.getGui());
            return true;
        }
        return false;
    }
    workOutSort() {
        return this.params.enableSorting;
    }
    setupSort() {
        this.currentSort = this.params.enableSorting;
        if (!this.eSortIndicator) {
            this.eSortIndicator = this.context.createBean(new SortIndicatorComp(true));
            this.eSortIndicator.attachCustomElements(this.eSortOrder, this.eSortAsc, this.eSortDesc, this.eSortMixed, this.eSortNone);
        }
        this.eSortIndicator.setupSort(this.params.column);
        if (!this.currentSort) return;
        this.addManagedListener(this.params.column, Column.EVENT_MOVING_CHANGED, ()=>{
            this.lastMovingChanged = /* @__PURE__ */ new Date().getTime();
        });
        if (this.eLabel) this.addManagedListener(this.eLabel, "click", (event)=>{
            const moving = this.params.column.isMoving();
            const nowTime = /* @__PURE__ */ new Date().getTime();
            const movedRecently = nowTime - this.lastMovingChanged < 50;
            const columnMoving = moving || movedRecently;
            if (!columnMoving) {
                const sortUsingCtrl = this.gos.get("multiSortKey") === "ctrl";
                const multiSort = sortUsingCtrl ? event.ctrlKey || event.metaKey : event.shiftKey;
                this.params.progressSort(multiSort);
            }
        });
        const onSortingChanged = ()=>{
            this.addOrRemoveCssClass("ag-header-cell-sorted-asc", this.params.column.isSortAscending());
            this.addOrRemoveCssClass("ag-header-cell-sorted-desc", this.params.column.isSortDescending());
            this.addOrRemoveCssClass("ag-header-cell-sorted-none", this.params.column.isSortNone());
            if (this.params.column.getColDef().showRowGroup) {
                const sourceColumns = this.columnModel.getSourceColumnsForGroupColumn(this.params.column);
                const sortDirectionsMatch = sourceColumns == null ? void 0 : sourceColumns.every((sourceCol)=>this.params.column.getSort() == sourceCol.getSort());
                const isMultiSorting = !sortDirectionsMatch;
                this.addOrRemoveCssClass("ag-header-cell-sorted-mixed", isMultiSorting);
            }
        };
        this.addManagedListener(this.eventService, Events.EVENT_SORT_CHANGED, onSortingChanged);
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, onSortingChanged);
    }
    setupFilterIcon() {
        if (!this.eFilter) return;
        this.configureFilter(this.params.enableFilterIcon, this.eFilter, this.onFilterChangedIcon.bind(this));
    }
    setupFilterButton() {
        if (!this.eFilterButton) return;
        const configured = this.configureFilter(this.params.enableFilterButton, this.eFilterButton, this.onFilterChangedButton.bind(this));
        if (configured) this.addManagedListener(this.eFilterButton, "click", ()=>this.params.showFilter(this.eFilterButton));
        else this.eFilterButton = void 0;
    }
    configureFilter(enabled, element, filterChangedCallback) {
        if (!enabled) {
            removeFromParent(element);
            return false;
        }
        const { column } = this.params;
        this.addInIcon("filter", element, column);
        this.addManagedListener(column, Column.EVENT_FILTER_CHANGED, filterChangedCallback);
        filterChangedCallback();
        return true;
    }
    onFilterChangedIcon() {
        const filterPresent = this.params.column.isFilterActive();
        setDisplayed(this.eFilter, filterPresent, {
            skipAriaHidden: true
        });
    }
    onFilterChangedButton() {
        const filterPresent = this.params.column.isFilterActive();
        this.eFilterButton.classList.toggle("ag-filter-active", filterPresent);
    }
    getAnchorElementForMenu(isFilter) {
        var _a, _b, _c, _d;
        if (isFilter) return (_b = (_a = this.eFilterButton) != null ? _a : this.eMenu) != null ? _b : this.getGui();
        return (_d = (_c = this.eMenu) != null ? _c : this.eFilterButton) != null ? _d : this.getGui();
    }
};
_HeaderComp.TEMPLATE = /* html */ `<div class="ag-cell-label-container" role="presentation">
            <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>
            <span ref="eFilterButton" class="ag-header-icon ag-header-cell-filter-button" aria-hidden="true"></span>
            <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                <span ref="eText" class="ag-header-cell-text"></span>
                <span ref="eFilter" class="ag-header-icon ag-header-label-icon ag-filter-icon" aria-hidden="true"></span>
                <ag-sort-indicator ref="eSortIndicator"></ag-sort-indicator>
            </div>
        </div>`;
__decorateClass([
    Autowired("sortController")
], _HeaderComp.prototype, "sortController", 2);
__decorateClass([
    Autowired("menuService")
], _HeaderComp.prototype, "menuService", 2);
__decorateClass([
    Autowired("columnModel")
], _HeaderComp.prototype, "columnModel", 2);
__decorateClass([
    RefSelector("eFilter")
], _HeaderComp.prototype, "eFilter", 2);
__decorateClass([
    RefSelector("eFilterButton")
], _HeaderComp.prototype, "eFilterButton", 2);
__decorateClass([
    RefSelector("eSortIndicator")
], _HeaderComp.prototype, "eSortIndicator", 2);
__decorateClass([
    RefSelector("eMenu")
], _HeaderComp.prototype, "eMenu", 2);
__decorateClass([
    RefSelector("eLabel")
], _HeaderComp.prototype, "eLabel", 2);
__decorateClass([
    RefSelector("eText")
], _HeaderComp.prototype, "eText", 2);
__decorateClass([
    RefSelector("eSortOrder")
], _HeaderComp.prototype, "eSortOrder", 2);
__decorateClass([
    RefSelector("eSortAsc")
], _HeaderComp.prototype, "eSortAsc", 2);
__decorateClass([
    RefSelector("eSortDesc")
], _HeaderComp.prototype, "eSortDesc", 2);
__decorateClass([
    RefSelector("eSortMixed")
], _HeaderComp.prototype, "eSortMixed", 2);
__decorateClass([
    RefSelector("eSortNone")
], _HeaderComp.prototype, "eSortNone", 2);
var HeaderComp = _HeaderComp;
// community-modules/core/src/headerRendering/cells/columnGroup/headerGroupComp.ts
var _HeaderGroupComp = class _HeaderGroupComp extends Component {
    constructor(){
        super(_HeaderGroupComp.TEMPLATE);
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    destroy() {
        super.destroy();
    }
    init(params) {
        this.params = params;
        this.checkWarnings();
        this.setupLabel();
        this.addGroupExpandIcon();
        this.setupExpandIcons();
    }
    checkWarnings() {
        const paramsAny = this.params;
        if (paramsAny.template) warnOnce(`A template was provided for Header Group Comp - templates are only supported for Header Comps (not groups)`);
    }
    setupExpandIcons() {
        this.addInIcon("columnGroupOpened", "agOpened");
        this.addInIcon("columnGroupClosed", "agClosed");
        const expandAction = (event)=>{
            if (isStopPropagationForAgGrid(event)) return;
            const newExpandedValue = !this.params.columnGroup.isExpanded();
            this.columnModel.setColumnGroupOpened(this.params.columnGroup.getProvidedColumnGroup(), newExpandedValue, "uiColumnExpanded");
        };
        this.addTouchAndClickListeners(this.eCloseIcon, expandAction);
        this.addTouchAndClickListeners(this.eOpenIcon, expandAction);
        const stopPropagationAction = (event)=>{
            stopPropagationForAgGrid(event);
        };
        this.addManagedListener(this.eCloseIcon, "dblclick", stopPropagationAction);
        this.addManagedListener(this.eOpenIcon, "dblclick", stopPropagationAction);
        this.addManagedListener(this.getGui(), "dblclick", expandAction);
        this.updateIconVisibility();
        const providedColumnGroup = this.params.columnGroup.getProvidedColumnGroup();
        this.addManagedListener(providedColumnGroup, ProvidedColumnGroup.EVENT_EXPANDED_CHANGED, this.updateIconVisibility.bind(this));
        this.addManagedListener(providedColumnGroup, ProvidedColumnGroup.EVENT_EXPANDABLE_CHANGED, this.updateIconVisibility.bind(this));
    }
    addTouchAndClickListeners(eElement, action) {
        const touchListener = new TouchListener(eElement, true);
        this.addManagedListener(touchListener, TouchListener.EVENT_TAP, action);
        this.addDestroyFunc(()=>touchListener.destroy());
        this.addManagedListener(eElement, "click", action);
    }
    updateIconVisibility() {
        const columnGroup = this.params.columnGroup;
        if (columnGroup.isExpandable()) {
            const expanded = this.params.columnGroup.isExpanded();
            setDisplayed(this.eOpenIcon, expanded);
            setDisplayed(this.eCloseIcon, !expanded);
        } else {
            setDisplayed(this.eOpenIcon, false);
            setDisplayed(this.eCloseIcon, false);
        }
    }
    addInIcon(iconName, refName) {
        const eIcon = createIconNoSpan(iconName, this.gos, null);
        if (eIcon) this.getRefElement(refName).appendChild(eIcon);
    }
    addGroupExpandIcon() {
        if (!this.params.columnGroup.isExpandable()) {
            setDisplayed(this.eOpenIcon, false);
            setDisplayed(this.eCloseIcon, false);
            return;
        }
    }
    setupLabel() {
        var _a;
        const { displayName, columnGroup } = this.params;
        if (exists(displayName)) {
            const displayNameSanitised = escapeString(displayName, true);
            this.getRefElement("agLabel").textContent = displayNameSanitised;
        }
        this.addOrRemoveCssClass("ag-sticky-label", !((_a = columnGroup.getColGroupDef()) == null ? void 0 : _a.suppressStickyLabel));
    }
};
_HeaderGroupComp.TEMPLATE = /* html */ `<div class="ag-header-group-cell-label" ref="agContainer" role="presentation">
            <span ref="agLabel" class="ag-header-group-text" role="presentation"></span>
            <span ref="agOpened" class="ag-header-icon ag-header-expand-icon ag-header-expand-icon-expanded"></span>
            <span ref="agClosed" class="ag-header-icon ag-header-expand-icon ag-header-expand-icon-collapsed"></span>
        </div>`;
__decorateClass([
    Autowired("columnModel")
], _HeaderGroupComp.prototype, "columnModel", 2);
__decorateClass([
    RefSelector("agOpened")
], _HeaderGroupComp.prototype, "eOpenIcon", 2);
__decorateClass([
    RefSelector("agClosed")
], _HeaderGroupComp.prototype, "eCloseIcon", 2);
var HeaderGroupComp = _HeaderGroupComp;
// community-modules/core/src/widgets/popupComponent.ts
var PopupComponent = class extends Component {
    isPopup() {
        return true;
    }
    setParentComponent(container) {
        container.addCssClass("ag-has-popup");
        super.setParentComponent(container);
    }
    destroy() {
        const parentComp = this.parentComponent;
        const hasParent = parentComp && parentComp.isAlive();
        if (hasParent) parentComp.getGui().classList.remove("ag-has-popup");
        super.destroy();
    }
};
// community-modules/core/src/rendering/cellEditors/largeTextCellEditor.ts
var _LargeTextCellEditor = class _LargeTextCellEditor extends PopupComponent {
    constructor(){
        super(_LargeTextCellEditor.TEMPLATE);
    }
    init(params) {
        this.params = params;
        this.focusAfterAttached = params.cellStartedEdit;
        this.eTextArea.setMaxLength(params.maxLength || 200).setCols(params.cols || 60).setRows(params.rows || 10);
        if (exists(params.value, true)) this.eTextArea.setValue(params.value.toString(), true);
        this.addGuiEventListener("keydown", this.onKeyDown.bind(this));
        this.activateTabIndex();
    }
    onKeyDown(event) {
        const key = event.key;
        if (key === KeyCode.LEFT || key === KeyCode.UP || key === KeyCode.RIGHT || key === KeyCode.DOWN || event.shiftKey && key === KeyCode.ENTER) event.stopPropagation();
    }
    afterGuiAttached() {
        const translate = this.localeService.getLocaleTextFunc();
        this.eTextArea.setInputAriaLabel(translate("ariaInputEditor", "Input Editor"));
        if (this.focusAfterAttached) this.eTextArea.getFocusableElement().focus();
    }
    getValue() {
        const value = this.eTextArea.getValue();
        if (!exists(value) && !exists(this.params.value)) return this.params.value;
        return this.params.parseValue(value);
    }
};
_LargeTextCellEditor.TEMPLATE = /* html */ `<div class="ag-large-text">
            <ag-input-text-area ref="eTextArea" class="ag-large-text-input"></ag-input-text-area>
        </div>`;
__decorateClass([
    RefSelector("eTextArea")
], _LargeTextCellEditor.prototype, "eTextArea", 2);
var LargeTextCellEditor = _LargeTextCellEditor;
// community-modules/core/src/rendering/cellEditors/selectCellEditor.ts
var SelectCellEditor = class extends PopupComponent {
    constructor(){
        super(/* html */ `<div class="ag-cell-edit-wrapper">
                <ag-select class="ag-cell-editor" ref="eSelect"></ag-select>
            </div>`);
        this.startedByEnter = false;
    }
    init(params) {
        this.focusAfterAttached = params.cellStartedEdit;
        const { eSelect, valueService, gos } = this;
        const { values: values2, value, eventKey } = params;
        if (missing(values2)) {
            console.warn("AG Grid: no values found for select cellEditor");
            return;
        }
        this.startedByEnter = eventKey != null ? eventKey === KeyCode.ENTER : false;
        let hasValue = false;
        values2.forEach((currentValue)=>{
            const option = {
                value: currentValue
            };
            const valueFormatted = valueService.formatValue(params.column, null, currentValue);
            const valueFormattedExits = valueFormatted !== null && valueFormatted !== void 0;
            option.text = valueFormattedExits ? valueFormatted : currentValue;
            eSelect.addOption(option);
            hasValue = hasValue || value === currentValue;
        });
        if (hasValue) eSelect.setValue(params.value, true);
        else if (params.values.length) eSelect.setValue(params.values[0], true);
        const { valueListGap, valueListMaxWidth, valueListMaxHeight } = params;
        if (valueListGap != null) eSelect.setPickerGap(valueListGap);
        if (valueListMaxHeight != null) eSelect.setPickerMaxHeight(valueListMaxHeight);
        if (valueListMaxWidth != null) eSelect.setPickerMaxWidth(valueListMaxWidth);
        if (gos.get("editType") !== "fullRow") this.addManagedListener(this.eSelect, AgSelect.EVENT_ITEM_SELECTED, ()=>params.stopEditing());
    }
    afterGuiAttached() {
        if (this.focusAfterAttached) this.eSelect.getFocusableElement().focus();
        if (this.startedByEnter) setTimeout(()=>{
            if (this.isAlive()) this.eSelect.showPicker();
        });
    }
    focusIn() {
        this.eSelect.getFocusableElement().focus();
    }
    getValue() {
        return this.eSelect.getValue();
    }
    isPopup() {
        return false;
    }
};
__decorateClass([
    Autowired("valueService")
], SelectCellEditor.prototype, "valueService", 2);
__decorateClass([
    RefSelector("eSelect")
], SelectCellEditor.prototype, "eSelect", 2);
// community-modules/core/src/rendering/cellEditors/simpleCellEditor.ts
var SimpleCellEditor = class extends PopupComponent {
    constructor(cellEditorInput){
        super(/* html */ `
            <div class="ag-cell-edit-wrapper">
                ${cellEditorInput.getTemplate()}
            </div>`);
        this.cellEditorInput = cellEditorInput;
    }
    init(params) {
        this.params = params;
        const eInput = this.eInput;
        this.cellEditorInput.init(eInput, params);
        let startValue;
        if (params.cellStartedEdit) {
            this.focusAfterAttached = true;
            const eventKey = params.eventKey;
            if (eventKey === KeyCode.BACKSPACE || params.eventKey === KeyCode.DELETE) startValue = "";
            else if (eventKey && eventKey.length === 1) startValue = eventKey;
            else {
                startValue = this.cellEditorInput.getStartValue();
                if (eventKey !== KeyCode.F2) this.highlightAllOnFocus = true;
            }
        } else {
            this.focusAfterAttached = false;
            startValue = this.cellEditorInput.getStartValue();
        }
        if (startValue != null) eInput.setStartValue(startValue);
        this.addManagedListener(eInput.getGui(), "keydown", (event)=>{
            const { key } = event;
            if (key === KeyCode.PAGE_UP || key === KeyCode.PAGE_DOWN) event.preventDefault();
        });
    }
    afterGuiAttached() {
        var _a, _b;
        const translate = this.localeService.getLocaleTextFunc();
        const eInput = this.eInput;
        eInput.setInputAriaLabel(translate("ariaInputEditor", "Input Editor"));
        if (!this.focusAfterAttached) return;
        if (!isBrowserSafari()) eInput.getFocusableElement().focus();
        const inputEl = eInput.getInputElement();
        if (this.highlightAllOnFocus) inputEl.select();
        else (_b = (_a = this.cellEditorInput).setCaret) == null || _b.call(_a);
    }
    // gets called when tabbing through cells and in full row edit mode
    focusIn() {
        const eInput = this.eInput;
        const focusEl = eInput.getFocusableElement();
        const inputEl = eInput.getInputElement();
        focusEl.focus();
        inputEl.select();
    }
    getValue() {
        return this.cellEditorInput.getValue();
    }
    isPopup() {
        return false;
    }
};
__decorateClass([
    RefSelector("eInput")
], SimpleCellEditor.prototype, "eInput", 2);
// community-modules/core/src/rendering/cellEditors/textCellEditor.ts
var TextCellEditorInput = class {
    getTemplate() {
        return /* html */ `<ag-input-text-field class="ag-cell-editor" ref="eInput"></ag-input-text-field>`;
    }
    init(eInput, params) {
        this.eInput = eInput;
        this.params = params;
        if (params.maxLength != null) eInput.setMaxLength(params.maxLength);
    }
    getValue() {
        const value = this.eInput.getValue();
        if (!exists(value) && !exists(this.params.value)) return this.params.value;
        return this.params.parseValue(value);
    }
    getStartValue() {
        const formatValue = this.params.useFormatter || this.params.column.getColDef().refData;
        return formatValue ? this.params.formatValue(this.params.value) : this.params.value;
    }
    setCaret() {
        const value = this.eInput.getValue();
        const len = exists(value) && value.length || 0;
        if (len) this.eInput.getInputElement().setSelectionRange(len, len);
    }
};
var TextCellEditor = class extends SimpleCellEditor {
    constructor(){
        super(new TextCellEditorInput());
    }
};
// community-modules/core/src/rendering/cellRenderers/animateShowChangeCellRenderer.ts
var ARROW_UP = "\u2191";
var ARROW_DOWN = "\u2193";
var AnimateShowChangeCellRenderer = class extends Component {
    constructor(){
        super();
        this.refreshCount = 0;
        const template = document.createElement("span");
        const delta = document.createElement("span");
        delta.setAttribute("class", "ag-value-change-delta");
        const value = document.createElement("span");
        value.setAttribute("class", "ag-value-change-value");
        template.appendChild(delta);
        template.appendChild(value);
        this.setTemplateFromElement(template);
    }
    init(params) {
        this.eValue = this.queryForHtmlElement(".ag-value-change-value");
        this.eDelta = this.queryForHtmlElement(".ag-value-change-delta");
        this.refresh(params, true);
    }
    showDelta(params, delta) {
        const absDelta = Math.abs(delta);
        const valueFormatted = params.formatValue(absDelta);
        const valueToUse = exists(valueFormatted) ? valueFormatted : absDelta;
        const deltaUp = delta >= 0;
        if (deltaUp) this.eDelta.textContent = ARROW_UP + valueToUse;
        else this.eDelta.textContent = ARROW_DOWN + valueToUse;
        this.eDelta.classList.toggle("ag-value-change-delta-up", deltaUp);
        this.eDelta.classList.toggle("ag-value-change-delta-down", !deltaUp);
    }
    setTimerToRemoveDelta() {
        this.refreshCount++;
        const refreshCountCopy = this.refreshCount;
        this.getFrameworkOverrides().wrapIncoming(()=>{
            window.setTimeout(()=>{
                if (refreshCountCopy === this.refreshCount) this.hideDeltaValue();
            }, 2e3);
        });
    }
    hideDeltaValue() {
        this.eValue.classList.remove("ag-value-change-value-highlight");
        clearElement(this.eDelta);
    }
    refresh(params, isInitialRender = false) {
        const value = params.value;
        if (value === this.lastValue) return false;
        if (exists(params.valueFormatted)) this.eValue.textContent = params.valueFormatted;
        else if (exists(params.value)) this.eValue.textContent = value;
        else clearElement(this.eValue);
        if (this.filterManager.isSuppressFlashingCellsBecauseFiltering()) return false;
        if (typeof value === "number" && typeof this.lastValue === "number") {
            const delta = value - this.lastValue;
            this.showDelta(params, delta);
        }
        if (this.lastValue) this.eValue.classList.add("ag-value-change-value-highlight");
        if (!isInitialRender) this.setTimerToRemoveDelta();
        this.lastValue = value;
        return true;
    }
};
__decorateClass([
    Autowired("filterManager")
], AnimateShowChangeCellRenderer.prototype, "filterManager", 2);
// community-modules/core/src/rendering/cellRenderers/animateSlideCellRenderer.ts
var AnimateSlideCellRenderer = class extends Component {
    constructor(){
        super();
        this.refreshCount = 0;
        const template = document.createElement("span");
        const slide = document.createElement("span");
        slide.setAttribute("class", "ag-value-slide-current");
        template.appendChild(slide);
        this.setTemplateFromElement(template);
        this.eCurrent = this.queryForHtmlElement(".ag-value-slide-current");
    }
    init(params) {
        this.refresh(params, true);
    }
    addSlideAnimation() {
        this.refreshCount++;
        const refreshCountCopy = this.refreshCount;
        if (this.ePrevious) this.getGui().removeChild(this.ePrevious);
        const prevElement = document.createElement("span");
        prevElement.setAttribute("class", "ag-value-slide-previous ag-value-slide-out");
        this.ePrevious = prevElement;
        this.ePrevious.textContent = this.eCurrent.textContent;
        this.getGui().insertBefore(this.ePrevious, this.eCurrent);
        this.getFrameworkOverrides().wrapIncoming(()=>{
            window.setTimeout(()=>{
                if (refreshCountCopy !== this.refreshCount) return;
                this.ePrevious.classList.add("ag-value-slide-out-end");
            }, 50);
            window.setTimeout(()=>{
                if (refreshCountCopy !== this.refreshCount) return;
                this.getGui().removeChild(this.ePrevious);
                this.ePrevious = null;
            }, 3e3);
        });
    }
    refresh(params, isInitialRender = false) {
        let value = params.value;
        if (missing(value)) value = "";
        if (value === this.lastValue) return false;
        if (this.filterManager.isSuppressFlashingCellsBecauseFiltering()) return false;
        if (!isInitialRender) this.addSlideAnimation();
        this.lastValue = value;
        if (exists(params.valueFormatted)) this.eCurrent.textContent = params.valueFormatted;
        else if (exists(params.value)) this.eCurrent.textContent = value;
        else clearElement(this.eCurrent);
        return true;
    }
};
__decorateClass([
    Autowired("filterManager")
], AnimateSlideCellRenderer.prototype, "filterManager", 2);
// community-modules/core/src/entities/rowNode.ts
var _RowNode = class _RowNode {
    constructor(beans){
        /** The current row index. If the row is filtered out or in a collapsed group, this value will be `null`. */ this.rowIndex = null;
        /** The key for the group eg Ireland, UK, USA */ this.key = null;
        /** Children mapped by the pivot columns. */ this.childrenMapped = {};
        /**
     * This will be `true` if it has a rowIndex assigned, otherwise `false`.
     */ this.displayed = false;
        /** The row top position in pixels. */ this.rowTop = null;
        /** The top pixel for this row last time, makes sense if data set was ordered or filtered,
     * it is used so new rows can animate in from their old position. */ this.oldRowTop = null;
        /** `true` by default - can be overridden via gridOptions.isRowSelectable(rowNode) */ this.selectable = true;
        /** Used by sorting service - to give deterministic sort to groups. Previously we
     * just id for this, however id is a string and had slower sorting compared to numbers. */ this.__objectId = _RowNode.OBJECT_ID_SEQUENCE++;
        /** When one or more Columns are using autoHeight, this keeps track of height of each autoHeight Cell,
     * indexed by the Column ID. */ this.__autoHeights = {};
        /** `true` when nodes with the same id are being removed and added as part of the same batch transaction */ this.alreadyRendered = false;
        this.highlighted = null;
        this.hovered = false;
        this.selected = false;
        this.beans = beans;
    }
    /**
   * Replaces the data on the `rowNode`. When this method is called, the grid will refresh the entire rendered row if it is displayed.
   */ setData(data) {
        this.setDataCommon(data, false);
    }
    // similar to setRowData, however it is expected that the data is the same data item. this
    // is intended to be used with Redux type stores, where the whole data can be changed. we are
    // guaranteed that the data is the same entity (so grid doesn't need to worry about the id of the
    // underlying data changing, hence doesn't need to worry about selection). the grid, upon receiving
    // dataChanged event, will refresh the cells rather than rip them all out (so user can show transitions).
    /**
   * Updates the data on the `rowNode`. When this method is called, the grid will refresh the entire rendered row if it is displayed.
   */ updateData(data) {
        this.setDataCommon(data, true);
    }
    setDataCommon(data, update) {
        const oldData = this.data;
        this.data = data;
        this.beans.valueCache.onDataChanged();
        this.updateDataOnDetailNode();
        this.checkRowSelectable();
        this.resetQuickFilterAggregateText();
        const event = this.createDataChangedEvent(data, oldData, update);
        this.dispatchLocalEvent(event);
    }
    // when we are doing master / detail, the detail node is lazy created, but then kept around.
    // so if we show / hide the detail, the same detail rowNode is used. so we need to keep the data
    // in sync, otherwise expand/collapse of the detail would still show the old values.
    updateDataOnDetailNode() {
        if (this.detailNode) this.detailNode.data = this.data;
    }
    createDataChangedEvent(newData, oldData, update) {
        return {
            type: _RowNode.EVENT_DATA_CHANGED,
            node: this,
            oldData,
            newData,
            update
        };
    }
    createLocalRowEvent(type) {
        return {
            type,
            node: this
        };
    }
    getRowIndexString() {
        if (this.rowPinned === "top") return "t-" + this.rowIndex;
        if (this.rowPinned === "bottom") return "b-" + this.rowIndex;
        return this.rowIndex.toString();
    }
    createDaemonNode() {
        const oldNode = new _RowNode(this.beans);
        oldNode.id = this.id;
        oldNode.data = this.data;
        oldNode.__daemon = true;
        oldNode.selected = this.selected;
        oldNode.level = this.level;
        return oldNode;
    }
    setDataAndId(data, id) {
        const oldNode = exists(this.id) ? this.createDaemonNode() : null;
        const oldData = this.data;
        this.data = data;
        this.updateDataOnDetailNode();
        this.setId(id);
        this.checkRowSelectable();
        this.beans.selectionService.syncInRowNode(this, oldNode);
        const event = this.createDataChangedEvent(data, oldData, false);
        this.dispatchLocalEvent(event);
    }
    checkRowSelectable() {
        const isRowSelectableFunc = this.beans.gos.get("isRowSelectable");
        this.setRowSelectable(isRowSelectableFunc ? isRowSelectableFunc(this) : true);
    }
    setRowSelectable(newVal, suppressSelectionUpdate) {
        if (this.selectable !== newVal) {
            this.selectable = newVal;
            if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_SELECTABLE_CHANGED));
            if (suppressSelectionUpdate) return;
            const isGroupSelectsChildren = this.beans.gos.get("groupSelectsChildren");
            if (isGroupSelectsChildren) {
                const selected = this.calculateSelectedFromChildren();
                this.setSelectedParams({
                    newValue: selected != null ? selected : false,
                    source: "selectableChanged"
                });
                return;
            }
            if (this.isSelected() && !this.selectable) this.setSelectedParams({
                newValue: false,
                source: "selectableChanged"
            });
        }
    }
    setId(id) {
        const getRowIdFunc = this.beans.gos.getCallback("getRowId");
        if (getRowIdFunc) {
            if (this.data) {
                const parentKeys = this.getGroupKeys(true);
                this.id = getRowIdFunc({
                    data: this.data,
                    parentKeys: parentKeys.length > 0 ? parentKeys : void 0,
                    level: this.level
                });
                if (this.id !== null && typeof this.id === "string" && this.id.startsWith(_RowNode.ID_PREFIX_ROW_GROUP)) console.error(`AG Grid: Row IDs cannot start with ${_RowNode.ID_PREFIX_ROW_GROUP}, this is a reserved prefix for AG Grid's row grouping feature.`);
                if (this.id !== null && typeof this.id !== "string") this.id = "" + this.id;
            } else this.id = void 0;
        } else this.id = id;
    }
    getGroupKeys(excludeSelf = false) {
        const keys2 = [];
        let pointer = this;
        if (excludeSelf) pointer = pointer.parent;
        while(pointer && pointer.level >= 0){
            keys2.push(pointer.key);
            pointer = pointer.parent;
        }
        keys2.reverse();
        return keys2;
    }
    isPixelInRange(pixel) {
        if (!exists(this.rowTop) || !exists(this.rowHeight)) return false;
        return pixel >= this.rowTop && pixel < this.rowTop + this.rowHeight;
    }
    setFirstChild(firstChild) {
        if (this.firstChild === firstChild) return;
        this.firstChild = firstChild;
        if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_FIRST_CHILD_CHANGED));
    }
    setLastChild(lastChild) {
        if (this.lastChild === lastChild) return;
        this.lastChild = lastChild;
        if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_LAST_CHILD_CHANGED));
    }
    setChildIndex(childIndex) {
        if (this.childIndex === childIndex) return;
        this.childIndex = childIndex;
        if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_CHILD_INDEX_CHANGED));
    }
    setRowTop(rowTop) {
        this.oldRowTop = this.rowTop;
        if (this.rowTop === rowTop) return;
        this.rowTop = rowTop;
        if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_TOP_CHANGED));
        this.setDisplayed(rowTop !== null);
    }
    clearRowTopAndRowIndex() {
        this.oldRowTop = null;
        this.setRowTop(null);
        this.setRowIndex(null);
    }
    setDisplayed(displayed) {
        if (this.displayed === displayed) return;
        this.displayed = displayed;
        if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_DISPLAYED_CHANGED));
    }
    setDragging(dragging) {
        if (this.dragging === dragging) return;
        this.dragging = dragging;
        if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_DRAGGING_CHANGED));
    }
    setHighlighted(highlighted) {
        if (highlighted === this.highlighted) return;
        this.highlighted = highlighted;
        if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_HIGHLIGHT_CHANGED));
    }
    setHovered(hovered) {
        if (this.hovered === hovered) return;
        this.hovered = hovered;
    }
    isHovered() {
        return this.hovered;
    }
    setAllChildrenCount(allChildrenCount) {
        if (this.allChildrenCount === allChildrenCount) return;
        this.allChildrenCount = allChildrenCount;
        if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_ALL_CHILDREN_COUNT_CHANGED));
    }
    setMaster(master) {
        if (this.master === master) return;
        if (this.master && !master) this.expanded = false;
        this.master = master;
        if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_MASTER_CHANGED));
    }
    setGroup(group) {
        if (this.group === group) return;
        if (this.group && !group) this.expanded = false;
        this.group = group;
        this.updateHasChildren();
        if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_GROUP_CHANGED));
    }
    /**
   * Sets the row height.
   * Call if you want to change the height initially assigned to the row.
   * After calling, you must call `api.onRowHeightChanged()` so the grid knows it needs to work out the placement of the rows. */ setRowHeight(rowHeight, estimated = false) {
        this.rowHeight = rowHeight;
        this.rowHeightEstimated = estimated;
        if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_HEIGHT_CHANGED));
    }
    setRowAutoHeight(cellHeight, column) {
        if (!this.__autoHeights) this.__autoHeights = {};
        this.__autoHeights[column.getId()] = cellHeight;
        if (cellHeight != null) {
            if (this.checkAutoHeightsDebounced == null) this.checkAutoHeightsDebounced = debounce(this.checkAutoHeights.bind(this), 1);
            this.checkAutoHeightsDebounced();
        }
    }
    checkAutoHeights() {
        let notAllPresent = false;
        let nonePresent = true;
        let newRowHeight = 0;
        const autoHeights = this.__autoHeights;
        if (autoHeights == null) return;
        const displayedAutoHeightCols = this.beans.columnModel.getAllDisplayedAutoHeightCols();
        displayedAutoHeightCols.forEach((col)=>{
            let cellHeight = autoHeights[col.getId()];
            if (cellHeight == null) {
                if (this.beans.columnModel.isColSpanActive()) {
                    let activeColsForRow = [];
                    switch(col.getPinned()){
                        case "left":
                            activeColsForRow = this.beans.columnModel.getDisplayedLeftColumnsForRow(this);
                            break;
                        case "right":
                            activeColsForRow = this.beans.columnModel.getDisplayedRightColumnsForRow(this);
                            break;
                        case null:
                            activeColsForRow = this.beans.columnModel.getViewportCenterColumnsForRow(this);
                            break;
                    }
                    if (activeColsForRow.includes(col)) {
                        notAllPresent = true;
                        return;
                    }
                    cellHeight = -1;
                } else {
                    notAllPresent = true;
                    return;
                }
            } else nonePresent = false;
            if (cellHeight > newRowHeight) newRowHeight = cellHeight;
        });
        if (notAllPresent) return;
        if (nonePresent || newRowHeight < 10) newRowHeight = this.beans.gos.getRowHeightForNode(this).height;
        if (newRowHeight == this.rowHeight) return;
        this.setRowHeight(newRowHeight);
        const rowModel = this.beans.rowModel;
        if (rowModel.onRowHeightChangedDebounced) rowModel.onRowHeightChangedDebounced();
    }
    setRowIndex(rowIndex) {
        if (this.rowIndex === rowIndex) return;
        this.rowIndex = rowIndex;
        if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_ROW_INDEX_CHANGED));
    }
    setUiLevel(uiLevel) {
        if (this.uiLevel === uiLevel) return;
        this.uiLevel = uiLevel;
        if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_UI_LEVEL_CHANGED));
    }
    /**
   * Set the expanded state of this rowNode. Pass `true` to expand and `false` to collapse.
   */ setExpanded(expanded, e, forceSync) {
        if (this.expanded === expanded) return;
        this.expanded = expanded;
        if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_EXPANDED_CHANGED));
        const event = Object.assign({}, this.createGlobalRowEvent(Events.EVENT_ROW_GROUP_OPENED), {
            expanded,
            event: e || null
        });
        this.beans.rowNodeEventThrottle.dispatchExpanded(event, forceSync);
        this.beans.rowRenderer.refreshCells({
            rowNodes: [
                this
            ]
        });
    }
    createGlobalRowEvent(type) {
        return this.beans.gos.addGridCommonParams({
            type,
            node: this,
            data: this.data,
            rowIndex: this.rowIndex,
            rowPinned: this.rowPinned
        });
    }
    dispatchLocalEvent(event) {
        if (this.eventService) this.eventService.dispatchEvent(event);
    }
    /**
   * Replaces the value on the `rowNode` for the specified column. When complete,
   * the grid will refresh the rendered cell on the required row only.
   * **Note**: This method only fires `onCellEditRequest` when the Grid is in **Read Only** mode.
   *
   * @param colKey The column where the value should be updated
   * @param newValue The new value
   * @param eventSource The source of the event
   * @returns `true` if the value was changed, otherwise `false`.
   */ setDataValue(colKey, newValue, eventSource) {
        const getColumnFromKey = ()=>{
            var _a;
            if (typeof colKey !== "string") return colKey;
            return (_a = this.beans.columnModel.getGridColumn(colKey)) != null ? _a : this.beans.columnModel.getPrimaryColumn(colKey);
        };
        const column = getColumnFromKey();
        const oldValue = this.getValueFromValueService(column);
        if (this.beans.gos.get("readOnlyEdit")) {
            this.dispatchEventForSaveValueReadOnly(column, oldValue, newValue, eventSource);
            return false;
        }
        const valueChanged = this.beans.valueService.setValue(this, column, newValue, eventSource);
        this.dispatchCellChangedEvent(column, newValue, oldValue);
        this.checkRowSelectable();
        return valueChanged;
    }
    getValueFromValueService(column) {
        var _a, _b;
        const lockedClosedGroup = this.leafGroup && this.beans.columnModel.isPivotMode();
        const isOpenGroup = this.group && this.expanded && !this.footer && !lockedClosedGroup;
        let includeFooter = false;
        const groupIncludeFooterOpt = (_a = this.beans.gos.get("groupTotalRow")) != null ? _a : this.beans.gos.get("groupIncludeFooter");
        if (typeof groupIncludeFooterOpt !== "function") includeFooter = !!groupIncludeFooterOpt;
        else {
            const groupIncludeFooterCb = (_b = this.beans.gos.getCallback("groupTotalRow")) != null ? _b : this.beans.gos.getCallback("groupIncludeFooter");
            includeFooter = !!groupIncludeFooterCb({
                node: this
            });
        }
        const groupAlwaysShowAggData = this.beans.gos.get("groupSuppressBlankHeader");
        const ignoreAggData = isOpenGroup && includeFooter && !groupAlwaysShowAggData;
        const value = this.beans.valueService.getValue(column, this, false, ignoreAggData);
        return value;
    }
    dispatchEventForSaveValueReadOnly(column, oldValue, newValue, eventSource) {
        const event = this.beans.gos.addGridCommonParams({
            type: Events.EVENT_CELL_EDIT_REQUEST,
            event: null,
            rowIndex: this.rowIndex,
            rowPinned: this.rowPinned,
            column,
            colDef: column.getColDef(),
            data: this.data,
            node: this,
            oldValue,
            newValue,
            value: newValue,
            source: eventSource
        });
        this.beans.eventService.dispatchEvent(event);
    }
    setGroupValue(colKey, newValue) {
        const column = this.beans.columnModel.getGridColumn(colKey);
        if (missing(this.groupData)) this.groupData = {};
        const columnId = column.getColId();
        const oldValue = this.groupData[columnId];
        if (oldValue === newValue) return;
        this.groupData[columnId] = newValue;
        this.dispatchCellChangedEvent(column, newValue, oldValue);
    }
    // sets the data for an aggregation
    setAggData(newAggData) {
        const oldAggData = this.aggData;
        this.aggData = newAggData;
        if (this.eventService) {
            const eventFunc = (colId)=>{
                const value = this.aggData ? this.aggData[colId] : void 0;
                const oldValue = oldAggData ? oldAggData[colId] : void 0;
                if (value === oldValue) return;
                const column = this.beans.columnModel.lookupGridColumn(colId);
                if (!column) return;
                this.dispatchCellChangedEvent(column, value, oldValue);
            };
            for(const key in this.aggData)eventFunc(key);
            for(const key in newAggData){
                if (key in this.aggData) continue;
                eventFunc(key);
            }
        }
    }
    updateHasChildren() {
        let newValue = this.group && !this.footer || this.childrenAfterGroup && this.childrenAfterGroup.length > 0;
        const isSsrm = this.beans.gos.isRowModelType("serverSide");
        if (isSsrm) {
            const isTreeData = this.beans.gos.get("treeData");
            const isGroupFunc = this.beans.gos.get("isServerSideGroup");
            newValue = !this.stub && !this.footer && (isTreeData ? !!isGroupFunc && isGroupFunc(this.data) : !!this.group);
        }
        if (newValue !== this.__hasChildren) {
            this.__hasChildren = !!newValue;
            if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_HAS_CHILDREN_CHANGED));
        }
    }
    hasChildren() {
        if (this.__hasChildren == null) this.updateHasChildren();
        return this.__hasChildren;
    }
    isEmptyRowGroupNode() {
        return this.group && missingOrEmpty(this.childrenAfterGroup);
    }
    dispatchCellChangedEvent(column, newValue, oldValue) {
        const cellChangedEvent = {
            type: _RowNode.EVENT_CELL_CHANGED,
            node: this,
            column,
            newValue,
            oldValue
        };
        this.dispatchLocalEvent(cellChangedEvent);
    }
    /**
   * The first time `quickFilter` runs, the grid creates a one-off string representation of the row.
   * This string is then used for the quick filter instead of hitting each column separately.
   * When you edit, using grid editing, this string gets cleared down.
   * However if you edit without using grid editing, you will need to clear this string down for the row to be updated with the new values.
   * Otherwise new values will not work with the `quickFilter`. */ resetQuickFilterAggregateText() {
        this.quickFilterAggregateText = null;
    }
    /** Returns:
  * - `true` if the node can be expanded, i.e it is a group or master row.
  * - `false` if the node cannot be expanded
  */ isExpandable() {
        if (this.footer) return false;
        if (this.beans.columnModel.isPivotMode()) return this.hasChildren() && !this.leafGroup;
        return this.hasChildren() || !!this.master;
    }
    /** Returns:
   * - `true` if node is selected,
   * - `false` if the node isn't selected
   * - `undefined` if it's partially selected (group where not all children are selected). */ isSelected() {
        if (this.footer) return this.sibling.isSelected();
        return this.selected;
    }
    /** Perform a depth-first search of this node and its children. */ depthFirstSearch(callback) {
        if (this.childrenAfterGroup) this.childrenAfterGroup.forEach((child)=>child.depthFirstSearch(callback));
        callback(this);
    }
    // + selectionController.calculatedSelectedForAllGroupNodes()
    calculateSelectedFromChildren() {
        var _a;
        let atLeastOneSelected = false;
        let atLeastOneDeSelected = false;
        let atLeastOneMixed = false;
        if (!((_a = this.childrenAfterGroup) == null ? void 0 : _a.length)) return this.selectable ? this.selected : null;
        for(let i = 0; i < this.childrenAfterGroup.length; i++){
            const child = this.childrenAfterGroup[i];
            let childState = child.isSelected();
            if (!child.selectable) {
                const selectable = child.calculateSelectedFromChildren();
                if (selectable === null) continue;
                childState = selectable;
            }
            switch(childState){
                case true:
                    atLeastOneSelected = true;
                    break;
                case false:
                    atLeastOneDeSelected = true;
                    break;
                default:
                    atLeastOneMixed = true;
                    break;
            }
        }
        if (atLeastOneMixed || atLeastOneSelected && atLeastOneDeSelected) return void 0;
        if (atLeastOneSelected) return true;
        if (atLeastOneDeSelected) return false;
        if (!this.selectable) return null;
        return this.selected;
    }
    setSelectedInitialValue(selected) {
        this.selected = selected;
    }
    selectThisNode(newValue, e, source = "api") {
        const selectionNotAllowed = !this.selectable && newValue;
        const selectionNotChanged = this.selected === newValue;
        if (selectionNotAllowed || selectionNotChanged) return false;
        this.selected = newValue;
        if (this.eventService) this.dispatchLocalEvent(this.createLocalRowEvent(_RowNode.EVENT_ROW_SELECTED));
        const sibling = this.sibling;
        if (sibling && sibling.footer && sibling.eventService) sibling.dispatchLocalEvent(sibling.createLocalRowEvent(_RowNode.EVENT_ROW_SELECTED));
        const event = __spreadProps(__spreadValues({}, this.createGlobalRowEvent(Events.EVENT_ROW_SELECTED)), {
            event: e || null,
            source
        });
        this.beans.eventService.dispatchEvent(event);
        return true;
    }
    /**
   * Select (or deselect) the node.
   * @param newValue -`true` for selection, `false` for deselection.
   * @param clearSelection - If selecting, then passing `true` will select the node exclusively (i.e. NOT do multi select). If doing deselection, `clearSelection` has no impact.
   * @param source - Source property that will appear in the `selectionChanged` event.
   */ setSelected(newValue, clearSelection = false, source = "api") {
        if (typeof source === "boolean") {
            console.warn("AG Grid: since version v30, rowNode.setSelected() property `suppressFinishActions` has been removed, please use `gridApi.setNodesSelected()` for bulk actions, and the event `source` property for ignoring events instead.");
            return;
        }
        this.setSelectedParams({
            newValue,
            clearSelection,
            rangeSelect: false,
            source
        });
    }
    // this is for internal use only. To make calling code more readable, this is the same method as setSelected except it takes names parameters
    setSelectedParams(params) {
        if (this.rowPinned) {
            console.warn("AG Grid: cannot select pinned rows");
            return 0;
        }
        if (this.id === void 0) {
            console.warn("AG Grid: cannot select node until id for node is known");
            return 0;
        }
        return this.beans.selectionService.setNodesSelected(__spreadProps(__spreadValues({}, params), {
            nodes: [
                this.footer ? this.sibling : this
            ]
        }));
    }
    /**
   * Returns:
   * - `true` if node is either pinned to the `top` or `bottom`
   * - `false` if the node isn't pinned
   */ isRowPinned() {
        return this.rowPinned === "top" || this.rowPinned === "bottom";
    }
    isParentOfNode(potentialParent) {
        let parentNode = this.parent;
        while(parentNode){
            if (parentNode === potentialParent) return true;
            parentNode = parentNode.parent;
        }
        return false;
    }
    /** Add an event listener. */ addEventListener(eventType, userListener) {
        var _a, _b;
        if (!this.eventService) this.eventService = new EventService();
        if (this.beans.frameworkOverrides.shouldWrapOutgoing && !this.frameworkEventListenerService) {
            this.eventService.setFrameworkOverrides(this.beans.frameworkOverrides);
            this.frameworkEventListenerService = new FrameworkEventListenerService(this.beans.frameworkOverrides);
        }
        const listener = (_b = (_a = this.frameworkEventListenerService) == null ? void 0 : _a.wrap(userListener)) != null ? _b : userListener;
        this.eventService.addEventListener(eventType, listener);
    }
    /** Remove event listener. */ removeEventListener(eventType, userListener) {
        var _a, _b;
        if (!this.eventService) return;
        const listener = (_b = (_a = this.frameworkEventListenerService) == null ? void 0 : _a.unwrap(userListener)) != null ? _b : userListener;
        this.eventService.removeEventListener(eventType, listener);
        if (this.eventService.noRegisteredListenersExist()) this.eventService = null;
    }
    onMouseEnter() {
        this.dispatchLocalEvent(this.createLocalRowEvent(_RowNode.EVENT_MOUSE_ENTER));
    }
    onMouseLeave() {
        this.dispatchLocalEvent(this.createLocalRowEvent(_RowNode.EVENT_MOUSE_LEAVE));
    }
    getFirstChildOfFirstChild(rowGroupColumn) {
        let currentRowNode = this;
        let isCandidate = true;
        let foundFirstChildPath = false;
        let nodeToSwapIn = null;
        while(isCandidate && !foundFirstChildPath){
            const parentRowNode = currentRowNode.parent;
            const firstChild = exists(parentRowNode) && currentRowNode.firstChild;
            if (firstChild) {
                if (parentRowNode.rowGroupColumn === rowGroupColumn) {
                    foundFirstChildPath = true;
                    nodeToSwapIn = parentRowNode;
                }
            } else isCandidate = false;
            currentRowNode = parentRowNode;
        }
        return foundFirstChildPath ? nodeToSwapIn : null;
    }
    /**
   * Returns:
   * - `true` if the node is a full width cell
   * - `false` if the node is not a full width cell
   */ isFullWidthCell() {
        if (this.detail) return true;
        const isFullWidthCellFunc = this.beans.gos.getCallback("isFullWidthRow");
        return isFullWidthCellFunc ? isFullWidthCellFunc({
            rowNode: this
        }) : false;
    }
    /**
   * Returns the route of the row node. If the Row Node is a group, it returns the route to that Row Node.
   * If the Row Node is not a group, it returns `undefined`.
   */ getRoute() {
        if (this.key == null) return;
        const res = [];
        let pointer = this;
        while(pointer.key != null){
            res.push(pointer.key);
            pointer = pointer.parent;
        }
        return res.reverse();
    }
    createFooter() {
        if (this.sibling) return;
        const ignoredProperties = /* @__PURE__ */ new Set([
            "eventService",
            "__objectId",
            "sticky"
        ]);
        const footerNode = new _RowNode(this.beans);
        Object.keys(this).forEach((key)=>{
            if (ignoredProperties.has(key)) return;
            footerNode[key] = this[key];
        });
        footerNode.footer = true;
        footerNode.setRowTop(null);
        footerNode.setRowIndex(null);
        footerNode.oldRowTop = null;
        footerNode.id = "rowGroupFooter_" + this.id;
        footerNode.sibling = this;
        this.sibling = footerNode;
    }
    // Only used by SSRM. In CSRM this is never used as footers should always be present for
    // the purpose of exporting collapsed groups. In SSRM it is not possible to export collapsed
    // groups anyway, so can destroy footers.
    destroyFooter() {
        if (!this.sibling) return;
        this.sibling.setRowTop(null);
        this.sibling.setRowIndex(null);
        this.sibling = void 0;
    }
};
_RowNode.ID_PREFIX_ROW_GROUP = "row-group-";
_RowNode.ID_PREFIX_TOP_PINNED = "t-";
_RowNode.ID_PREFIX_BOTTOM_PINNED = "b-";
_RowNode.OBJECT_ID_SEQUENCE = 0;
_RowNode.EVENT_ROW_SELECTED = "rowSelected";
_RowNode.EVENT_DATA_CHANGED = "dataChanged";
_RowNode.EVENT_CELL_CHANGED = "cellChanged";
_RowNode.EVENT_ALL_CHILDREN_COUNT_CHANGED = "allChildrenCountChanged";
_RowNode.EVENT_MASTER_CHANGED = "masterChanged";
_RowNode.EVENT_GROUP_CHANGED = "groupChanged";
_RowNode.EVENT_MOUSE_ENTER = "mouseEnter";
_RowNode.EVENT_MOUSE_LEAVE = "mouseLeave";
_RowNode.EVENT_HEIGHT_CHANGED = "heightChanged";
_RowNode.EVENT_TOP_CHANGED = "topChanged";
_RowNode.EVENT_DISPLAYED_CHANGED = "displayedChanged";
_RowNode.EVENT_FIRST_CHILD_CHANGED = "firstChildChanged";
_RowNode.EVENT_LAST_CHILD_CHANGED = "lastChildChanged";
_RowNode.EVENT_CHILD_INDEX_CHANGED = "childIndexChanged";
_RowNode.EVENT_ROW_INDEX_CHANGED = "rowIndexChanged";
_RowNode.EVENT_EXPANDED_CHANGED = "expandedChanged";
_RowNode.EVENT_HAS_CHILDREN_CHANGED = "hasChildrenChanged";
_RowNode.EVENT_SELECTABLE_CHANGED = "selectableChanged";
_RowNode.EVENT_UI_LEVEL_CHANGED = "uiLevelChanged";
_RowNode.EVENT_HIGHLIGHT_CHANGED = "rowHighlightChanged";
_RowNode.EVENT_DRAGGING_CHANGED = "draggingChanged";
var RowNode = _RowNode;
// community-modules/core/src/rendering/checkboxSelectionComponent.ts
var CheckboxSelectionComponent = class extends Component {
    constructor(){
        super(/* html*/ `
            <div class="ag-selection-checkbox" role="presentation">
                <ag-checkbox role="presentation" ref="eCheckbox"></ag-checkbox>
            </div>`);
    }
    postConstruct() {
        this.eCheckbox.setPassive(true);
    }
    getCheckboxId() {
        return this.eCheckbox.getInputElement().id;
    }
    onDataChanged() {
        this.onSelectionChanged();
    }
    onSelectableChanged() {
        this.showOrHideSelect();
    }
    onSelectionChanged() {
        const translate = this.localeService.getLocaleTextFunc();
        const state = this.rowNode.isSelected();
        const stateName = getAriaCheckboxStateName(translate, state);
        const [ariaKey, ariaLabel] = this.rowNode.selectable ? [
            "ariaRowToggleSelection",
            "Press Space to toggle row selection"
        ] : [
            "ariaRowSelectionDisabled",
            "Row Selection is disabled for this row"
        ];
        const translatedLabel = translate(ariaKey, ariaLabel);
        this.eCheckbox.setValue(state, true);
        this.eCheckbox.setInputAriaLabel(`${translatedLabel} (${stateName})`);
    }
    onClicked(newValue, groupSelectsFiltered, event) {
        return this.rowNode.setSelectedParams({
            newValue,
            rangeSelect: event.shiftKey,
            groupSelectsFiltered,
            event,
            source: "checkboxSelected"
        });
    }
    init(params) {
        this.rowNode = params.rowNode;
        this.column = params.column;
        this.overrides = params.overrides;
        this.onSelectionChanged();
        this.addManagedListener(this.eCheckbox.getInputElement(), "dblclick", (event)=>{
            stopPropagationForAgGrid(event);
        });
        this.addManagedListener(this.eCheckbox.getInputElement(), "click", (event)=>{
            stopPropagationForAgGrid(event);
            const groupSelectsFiltered = this.gos.get("groupSelectsFiltered");
            const isSelected = this.eCheckbox.getValue();
            if (this.shouldHandleIndeterminateState(isSelected, groupSelectsFiltered)) {
                const result = this.onClicked(true, groupSelectsFiltered, event || {});
                if (result === 0) this.onClicked(false, groupSelectsFiltered, event);
            } else if (isSelected) this.onClicked(false, groupSelectsFiltered, event);
            else this.onClicked(true, groupSelectsFiltered, event || {});
        });
        this.addManagedListener(this.rowNode, RowNode.EVENT_ROW_SELECTED, this.onSelectionChanged.bind(this));
        this.addManagedListener(this.rowNode, RowNode.EVENT_DATA_CHANGED, this.onDataChanged.bind(this));
        this.addManagedListener(this.rowNode, RowNode.EVENT_SELECTABLE_CHANGED, this.onSelectableChanged.bind(this));
        const isRowSelectableFunc = this.gos.get("isRowSelectable");
        const checkboxVisibleIsDynamic = isRowSelectableFunc || typeof this.getIsVisible() === "function";
        if (checkboxVisibleIsDynamic) {
            const showOrHideSelectListener = this.showOrHideSelect.bind(this);
            this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, showOrHideSelectListener);
            this.addManagedListener(this.rowNode, RowNode.EVENT_DATA_CHANGED, showOrHideSelectListener);
            this.addManagedListener(this.rowNode, RowNode.EVENT_CELL_CHANGED, showOrHideSelectListener);
            this.showOrHideSelect();
        }
        this.eCheckbox.getInputElement().setAttribute("tabindex", "-1");
    }
    shouldHandleIndeterminateState(isSelected, groupSelectsFiltered) {
        return groupSelectsFiltered && (this.eCheckbox.getPreviousValue() === void 0 || isSelected === void 0) && this.gos.isRowModelType("clientSide");
    }
    showOrHideSelect() {
        var _a, _b, _c;
        let selectable = this.rowNode.selectable;
        const isVisible2 = this.getIsVisible();
        if (selectable) {
            if (typeof isVisible2 === "function") {
                const extraParams = (_a = this.overrides) == null ? void 0 : _a.callbackParams;
                if (!this.column) selectable = isVisible2(__spreadProps(__spreadValues({}, extraParams), {
                    node: this.rowNode,
                    data: this.rowNode.data
                }));
                else {
                    const params = this.column.createColumnFunctionCallbackParams(this.rowNode);
                    selectable = isVisible2(__spreadValues(__spreadValues({}, extraParams), params));
                }
            } else selectable = isVisible2 != null ? isVisible2 : false;
        }
        const disableInsteadOfHide = (_b = this.column) == null ? void 0 : _b.getColDef().showDisabledCheckboxes;
        if (disableInsteadOfHide) {
            this.eCheckbox.setDisabled(!selectable);
            this.setVisible(true);
            this.setDisplayed(true);
            return;
        }
        if ((_c = this.overrides) == null ? void 0 : _c.removeHidden) {
            this.setDisplayed(selectable);
            return;
        }
        this.setVisible(selectable);
    }
    getIsVisible() {
        var _a, _b;
        if (this.overrides) return this.overrides.isVisible;
        return (_b = (_a = this.column) == null ? void 0 : _a.getColDef()) == null ? void 0 : _b.checkboxSelection;
    }
};
__decorateClass([
    RefSelector("eCheckbox")
], CheckboxSelectionComponent.prototype, "eCheckbox", 2);
__decorateClass([
    PostConstruct
], CheckboxSelectionComponent.prototype, "postConstruct", 1);
// community-modules/core/src/constants/direction.ts
var VerticalDirection = /* @__PURE__ */ ((VerticalDirection2)=>{
    VerticalDirection2[VerticalDirection2["Up"] = 0] = "Up";
    VerticalDirection2[VerticalDirection2["Down"] = 1] = "Down";
    return VerticalDirection2;
})(VerticalDirection || {});
var HorizontalDirection = /* @__PURE__ */ ((HorizontalDirection2)=>{
    HorizontalDirection2[HorizontalDirection2["Left"] = 0] = "Left";
    HorizontalDirection2[HorizontalDirection2["Right"] = 1] = "Right";
    return HorizontalDirection2;
})(HorizontalDirection || {});
// community-modules/core/src/dragAndDrop/dragAndDropService.ts
var DragSourceType = /* @__PURE__ */ ((DragSourceType4)=>{
    DragSourceType4[DragSourceType4["ToolPanel"] = 0] = "ToolPanel";
    DragSourceType4[DragSourceType4["HeaderCell"] = 1] = "HeaderCell";
    DragSourceType4[DragSourceType4["RowDrag"] = 2] = "RowDrag";
    DragSourceType4[DragSourceType4["ChartPanel"] = 3] = "ChartPanel";
    DragSourceType4[DragSourceType4["AdvancedFilterBuilder"] = 4] = "AdvancedFilterBuilder";
    return DragSourceType4;
})(DragSourceType || {});
var DragAndDropService = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.dragSourceAndParamsList = [];
        this.dropTargets = [];
    }
    init() {
        this.ePinnedIcon = createIcon("columnMovePin", this.gos, null);
        this.eHideIcon = createIcon("columnMoveHide", this.gos, null);
        this.eMoveIcon = createIcon("columnMoveMove", this.gos, null);
        this.eLeftIcon = createIcon("columnMoveLeft", this.gos, null);
        this.eRightIcon = createIcon("columnMoveRight", this.gos, null);
        this.eGroupIcon = createIcon("columnMoveGroup", this.gos, null);
        this.eAggregateIcon = createIcon("columnMoveValue", this.gos, null);
        this.ePivotIcon = createIcon("columnMovePivot", this.gos, null);
        this.eDropNotAllowedIcon = createIcon("dropNotAllowed", this.gos, null);
    }
    addDragSource(dragSource, allowTouch = false) {
        const params = {
            eElement: dragSource.eElement,
            dragStartPixels: dragSource.dragStartPixels,
            onDragStart: this.onDragStart.bind(this, dragSource),
            onDragStop: this.onDragStop.bind(this),
            onDragging: this.onDragging.bind(this),
            includeTouch: allowTouch
        };
        this.dragSourceAndParamsList.push({
            params,
            dragSource
        });
        this.dragService.addDragSource(params);
    }
    removeDragSource(dragSource) {
        const sourceAndParams = this.dragSourceAndParamsList.find((item)=>item.dragSource === dragSource);
        if (sourceAndParams) {
            this.dragService.removeDragSource(sourceAndParams.params);
            removeFromArray(this.dragSourceAndParamsList, sourceAndParams);
        }
    }
    clearDragSourceParamsList() {
        this.dragSourceAndParamsList.forEach((sourceAndParams)=>this.dragService.removeDragSource(sourceAndParams.params));
        this.dragSourceAndParamsList.length = 0;
        this.dropTargets.length = 0;
    }
    nudge() {
        if (this.dragging) this.onDragging(this.eventLastTime, true);
    }
    onDragStart(dragSource, mouseEvent) {
        this.dragging = true;
        this.dragSource = dragSource;
        this.eventLastTime = mouseEvent;
        this.dragItem = this.dragSource.getDragItem();
        this.lastDropTarget = void 0;
        if (this.dragSource.onDragStarted) this.dragSource.onDragStarted();
        this.createGhost();
    }
    onDragStop(mouseEvent) {
        this.eventLastTime = null;
        this.dragging = false;
        if (this.dragSource.onDragStopped) this.dragSource.onDragStopped();
        if (this.lastDropTarget && this.lastDropTarget.onDragStop) {
            const draggingEvent = this.createDropTargetEvent(this.lastDropTarget, mouseEvent, null, null, false);
            this.lastDropTarget.onDragStop(draggingEvent);
        }
        this.lastDropTarget = null;
        this.dragItem = null;
        this.removeGhost();
    }
    onDragging(mouseEvent, fromNudge) {
        var _a, _b, _c, _d;
        const hDirection = this.getHorizontalDirection(mouseEvent);
        const vDirection = this.getVerticalDirection(mouseEvent);
        this.eventLastTime = mouseEvent;
        this.positionGhost(mouseEvent);
        const validDropTargets = this.dropTargets.filter((target)=>this.isMouseOnDropTarget(mouseEvent, target));
        const dropTarget = this.findCurrentDropTarget(mouseEvent, validDropTargets);
        if (dropTarget !== this.lastDropTarget) {
            this.leaveLastTargetIfExists(mouseEvent, hDirection, vDirection, fromNudge);
            if (this.lastDropTarget !== null && dropTarget === null) (_b = (_a = this.dragSource).onGridExit) == null || _b.call(_a, this.dragItem);
            if (this.lastDropTarget === null && dropTarget !== null) (_d = (_c = this.dragSource).onGridEnter) == null || _d.call(_c, this.dragItem);
            this.enterDragTargetIfExists(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
            this.lastDropTarget = dropTarget;
        } else if (dropTarget && dropTarget.onDragging) {
            const draggingEvent = this.createDropTargetEvent(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
            dropTarget.onDragging(draggingEvent);
        }
    }
    getAllContainersFromDropTarget(dropTarget) {
        const secondaryContainers = dropTarget.getSecondaryContainers ? dropTarget.getSecondaryContainers() : null;
        const containers = [
            [
                dropTarget.getContainer()
            ]
        ];
        return secondaryContainers ? containers.concat(secondaryContainers) : containers;
    }
    allContainersIntersect(mouseEvent, containers) {
        for (const container of containers){
            const rect = container.getBoundingClientRect();
            if (rect.width === 0 || rect.height === 0) return false;
            const horizontalFit = mouseEvent.clientX >= rect.left && mouseEvent.clientX < rect.right;
            const verticalFit = mouseEvent.clientY >= rect.top && mouseEvent.clientY < rect.bottom;
            if (!horizontalFit || !verticalFit) return false;
        }
        return true;
    }
    // checks if the mouse is on the drop target. it checks eContainer and eSecondaryContainers
    isMouseOnDropTarget(mouseEvent, dropTarget) {
        const allContainersFromDropTarget = this.getAllContainersFromDropTarget(dropTarget);
        let mouseOverTarget = false;
        for (const currentContainers of allContainersFromDropTarget)if (this.allContainersIntersect(mouseEvent, currentContainers)) {
            mouseOverTarget = true;
            break;
        }
        if (dropTarget.targetContainsSource && !dropTarget.getContainer().contains(this.dragSource.eElement)) return false;
        return mouseOverTarget && dropTarget.isInterestedIn(this.dragSource.type, this.dragSource.eElement);
    }
    findCurrentDropTarget(mouseEvent, validDropTargets) {
        const len = validDropTargets.length;
        if (len === 0) return null;
        if (len === 1) return validDropTargets[0];
        const rootNode = this.gos.getRootNode();
        const elementStack = rootNode.elementsFromPoint(mouseEvent.clientX, mouseEvent.clientY);
        for (const el of elementStack)for (const dropTarget of validDropTargets){
            const containers = flatten(this.getAllContainersFromDropTarget(dropTarget));
            if (containers.indexOf(el) !== -1) return dropTarget;
        }
        return null;
    }
    enterDragTargetIfExists(dropTarget, mouseEvent, hDirection, vDirection, fromNudge) {
        if (!dropTarget) return;
        if (dropTarget.onDragEnter) {
            const dragEnterEvent = this.createDropTargetEvent(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
            dropTarget.onDragEnter(dragEnterEvent);
        }
        this.setGhostIcon(dropTarget.getIconName ? dropTarget.getIconName() : null);
    }
    leaveLastTargetIfExists(mouseEvent, hDirection, vDirection, fromNudge) {
        if (!this.lastDropTarget) return;
        if (this.lastDropTarget.onDragLeave) {
            const dragLeaveEvent = this.createDropTargetEvent(this.lastDropTarget, mouseEvent, hDirection, vDirection, fromNudge);
            this.lastDropTarget.onDragLeave(dragLeaveEvent);
        }
        this.setGhostIcon(null);
    }
    addDropTarget(dropTarget) {
        this.dropTargets.push(dropTarget);
    }
    removeDropTarget(dropTarget) {
        this.dropTargets = this.dropTargets.filter((target)=>target.getContainer() !== dropTarget.getContainer());
    }
    hasExternalDropZones() {
        return this.dropTargets.some((zones)=>zones.external);
    }
    findExternalZone(params) {
        const externalTargets = this.dropTargets.filter((target)=>target.external);
        return externalTargets.find((zone)=>zone.getContainer() === params.getContainer()) || null;
    }
    getHorizontalDirection(event) {
        const clientX = this.eventLastTime && this.eventLastTime.clientX;
        const eClientX = event.clientX;
        if (clientX === eClientX) return null;
        return clientX > eClientX ? 0 /* Left */  : 1 /* Right */ ;
    }
    getVerticalDirection(event) {
        const clientY = this.eventLastTime && this.eventLastTime.clientY;
        const eClientY = event.clientY;
        if (clientY === eClientY) return null;
        return clientY > eClientY ? 0 /* Up */  : 1 /* Down */ ;
    }
    createDropTargetEvent(dropTarget, event, hDirection, vDirection, fromNudge) {
        const dropZoneTarget = dropTarget.getContainer();
        const rect = dropZoneTarget.getBoundingClientRect();
        const { gridApi: api, columnApi, dragItem, dragSource } = this;
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;
        return {
            event,
            x,
            y,
            vDirection,
            hDirection,
            dragSource,
            fromNudge,
            dragItem,
            api,
            columnApi,
            dropZoneTarget
        };
    }
    positionGhost(event) {
        const ghost = this.eGhost;
        if (!ghost) return;
        const ghostRect = ghost.getBoundingClientRect();
        const ghostHeight = ghostRect.height;
        const browserWidth = getBodyWidth() - 2;
        const browserHeight = getBodyHeight() - 2;
        const offsetParentSize = getElementRectWithOffset(ghost.offsetParent);
        const { clientY, clientX } = event;
        let top = clientY - offsetParentSize.top - ghostHeight / 2;
        let left = clientX - offsetParentSize.left - 10;
        const eDocument = this.gos.getDocument();
        const win = eDocument.defaultView || window;
        const windowScrollY = win.pageYOffset || eDocument.documentElement.scrollTop;
        const windowScrollX = win.pageXOffset || eDocument.documentElement.scrollLeft;
        if (browserWidth > 0 && left + ghost.clientWidth > browserWidth + windowScrollX) left = browserWidth + windowScrollX - ghost.clientWidth;
        if (left < 0) left = 0;
        if (browserHeight > 0 && top + ghost.clientHeight > browserHeight + windowScrollY) top = browserHeight + windowScrollY - ghost.clientHeight;
        if (top < 0) top = 0;
        ghost.style.left = `${left}px`;
        ghost.style.top = `${top}px`;
    }
    removeGhost() {
        if (this.eGhost && this.eGhostParent) this.eGhostParent.removeChild(this.eGhost);
        this.eGhost = null;
    }
    createGhost() {
        this.eGhost = loadTemplate(DragAndDropService.GHOST_TEMPLATE);
        this.mouseEventService.stampTopLevelGridCompWithGridInstance(this.eGhost);
        const { theme } = this.environment.getTheme();
        if (theme) this.eGhost.classList.add(theme);
        this.eGhostIcon = this.eGhost.querySelector(".ag-dnd-ghost-icon");
        this.setGhostIcon(null);
        const eText = this.eGhost.querySelector(".ag-dnd-ghost-label");
        let dragItemName = this.dragSource.dragItemName;
        if (isFunction(dragItemName)) dragItemName = dragItemName();
        eText.innerHTML = escapeString(dragItemName) || "";
        this.eGhost.style.height = "25px";
        this.eGhost.style.top = "20px";
        this.eGhost.style.left = "20px";
        const eDocument = this.gos.getDocument();
        let rootNode = null;
        let targetEl = null;
        try {
            rootNode = eDocument.fullscreenElement;
        } catch (e) {} finally{
            if (!rootNode) rootNode = this.gos.getRootNode();
            const body = rootNode.querySelector("body");
            if (body) targetEl = body;
            else if (rootNode instanceof ShadowRoot) targetEl = rootNode;
            else if (rootNode instanceof Document) targetEl = rootNode == null ? void 0 : rootNode.documentElement;
            else targetEl = rootNode;
        }
        this.eGhostParent = targetEl;
        if (!this.eGhostParent) console.warn("AG Grid: could not find document body, it is needed for dragging columns");
        else this.eGhostParent.appendChild(this.eGhost);
    }
    setGhostIcon(iconName, shake = false) {
        clearElement(this.eGhostIcon);
        let eIcon = null;
        if (!iconName) iconName = this.dragSource.getDefaultIconName ? this.dragSource.getDefaultIconName() : DragAndDropService.ICON_NOT_ALLOWED;
        switch(iconName){
            case DragAndDropService.ICON_PINNED:
                eIcon = this.ePinnedIcon;
                break;
            case DragAndDropService.ICON_MOVE:
                eIcon = this.eMoveIcon;
                break;
            case DragAndDropService.ICON_LEFT:
                eIcon = this.eLeftIcon;
                break;
            case DragAndDropService.ICON_RIGHT:
                eIcon = this.eRightIcon;
                break;
            case DragAndDropService.ICON_GROUP:
                eIcon = this.eGroupIcon;
                break;
            case DragAndDropService.ICON_AGGREGATE:
                eIcon = this.eAggregateIcon;
                break;
            case DragAndDropService.ICON_PIVOT:
                eIcon = this.ePivotIcon;
                break;
            case DragAndDropService.ICON_NOT_ALLOWED:
                eIcon = this.eDropNotAllowedIcon;
                break;
            case DragAndDropService.ICON_HIDE:
                eIcon = this.eHideIcon;
                break;
        }
        this.eGhostIcon.classList.toggle("ag-shake-left-to-right", shake);
        if (eIcon === this.eHideIcon && this.gos.get("suppressDragLeaveHidesColumns")) return;
        if (eIcon) this.eGhostIcon.appendChild(eIcon);
    }
};
DragAndDropService.ICON_PINNED = "pinned";
DragAndDropService.ICON_MOVE = "move";
DragAndDropService.ICON_LEFT = "left";
DragAndDropService.ICON_RIGHT = "right";
DragAndDropService.ICON_GROUP = "group";
DragAndDropService.ICON_AGGREGATE = "aggregate";
DragAndDropService.ICON_PIVOT = "pivot";
DragAndDropService.ICON_NOT_ALLOWED = "notAllowed";
DragAndDropService.ICON_HIDE = "hide";
DragAndDropService.GHOST_TEMPLATE = /* html */ `<div class="ag-dnd-ghost ag-unselectable">
            <span class="ag-dnd-ghost-icon ag-shake-left-to-right"></span>
            <div class="ag-dnd-ghost-label"></div>
        </div>`;
__decorateClass([
    Autowired("dragService")
], DragAndDropService.prototype, "dragService", 2);
__decorateClass([
    Autowired("mouseEventService")
], DragAndDropService.prototype, "mouseEventService", 2);
__decorateClass([
    Autowired("columnApi")
], DragAndDropService.prototype, "columnApi", 2);
__decorateClass([
    Autowired("gridApi")
], DragAndDropService.prototype, "gridApi", 2);
__decorateClass([
    PostConstruct
], DragAndDropService.prototype, "init", 1);
__decorateClass([
    PreDestroy
], DragAndDropService.prototype, "clearDragSourceParamsList", 1);
DragAndDropService = __decorateClass([
    Bean("dragAndDropService")
], DragAndDropService);
// community-modules/core/src/rendering/row/rowDragComp.ts
var RowDragComp = class extends Component {
    constructor(cellValueFn, rowNode, column, customGui, dragStartPixels, suppressVisibilityChange){
        super();
        this.cellValueFn = cellValueFn;
        this.rowNode = rowNode;
        this.column = column;
        this.customGui = customGui;
        this.dragStartPixels = dragStartPixels;
        this.suppressVisibilityChange = suppressVisibilityChange;
        this.dragSource = null;
    }
    isCustomGui() {
        return this.customGui != null;
    }
    postConstruct() {
        if (!this.customGui) {
            this.setTemplate(/* html */ `<div class="ag-drag-handle ag-row-drag" aria-hidden="true"></div>`);
            this.getGui().appendChild(createIconNoSpan("rowDrag", this.gos, null));
            this.addDragSource();
        } else this.setDragElement(this.customGui, this.dragStartPixels);
        this.checkCompatibility();
        if (!this.suppressVisibilityChange) {
            const strategy = this.gos.get("rowDragManaged") ? new ManagedVisibilityStrategy(this, this.beans, this.rowNode, this.column) : new NonManagedVisibilityStrategy(this, this.beans, this.rowNode, this.column);
            this.createManagedBean(strategy, this.beans.context);
        }
    }
    setDragElement(dragElement, dragStartPixels) {
        this.setTemplateFromElement(dragElement);
        this.addDragSource(dragStartPixels);
    }
    getSelectedNodes() {
        const isRowDragMultiRow = this.gos.get("rowDragMultiRow");
        if (!isRowDragMultiRow) return [
            this.rowNode
        ];
        const selection = this.beans.selectionService.getSelectedNodes();
        return selection.indexOf(this.rowNode) !== -1 ? selection : [
            this.rowNode
        ];
    }
    // returns true if all compatibility items work out
    checkCompatibility() {
        const managed = this.gos.get("rowDragManaged");
        const treeData = this.gos.get("treeData");
        if (treeData && managed) warnOnce("If using row drag with tree data, you cannot have rowDragManaged=true");
    }
    getDragItem() {
        return {
            rowNode: this.rowNode,
            rowNodes: this.getSelectedNodes(),
            columns: this.column ? [
                this.column
            ] : void 0,
            defaultTextValue: this.cellValueFn()
        };
    }
    getRowDragText(column) {
        if (column) {
            const colDef = column.getColDef();
            if (colDef.rowDragText) return colDef.rowDragText;
        }
        return this.gos.get("rowDragText");
    }
    addDragSource(dragStartPixels = 4) {
        if (this.dragSource) this.removeDragSource();
        const translate = this.localeService.getLocaleTextFunc();
        this.dragSource = {
            type: 2 /* RowDrag */ ,
            eElement: this.getGui(),
            dragItemName: ()=>{
                var _a;
                const dragItem = this.getDragItem();
                const dragItemCount = ((_a = dragItem.rowNodes) == null ? void 0 : _a.length) || 1;
                const rowDragText = this.getRowDragText(this.column);
                if (rowDragText) return rowDragText(dragItem, dragItemCount);
                return dragItemCount === 1 ? this.cellValueFn() : `${dragItemCount} ${translate("rowDragRows", "rows")}`;
            },
            getDragItem: ()=>this.getDragItem(),
            dragStartPixels,
            dragSourceDomDataKey: this.gos.getDomDataKey()
        };
        this.beans.dragAndDropService.addDragSource(this.dragSource, true);
    }
    removeDragSource() {
        if (this.dragSource) this.beans.dragAndDropService.removeDragSource(this.dragSource);
        this.dragSource = null;
    }
};
__decorateClass([
    Autowired("beans")
], RowDragComp.prototype, "beans", 2);
__decorateClass([
    PostConstruct
], RowDragComp.prototype, "postConstruct", 1);
__decorateClass([
    PreDestroy
], RowDragComp.prototype, "removeDragSource", 1);
var VisibilityStrategy = class extends BeanStub {
    constructor(parent, rowNode, column){
        super();
        this.parent = parent;
        this.rowNode = rowNode;
        this.column = column;
    }
    setDisplayedOrVisible(neverDisplayed) {
        const displayedOptions = {
            skipAriaHidden: true
        };
        if (neverDisplayed) this.parent.setDisplayed(false, displayedOptions);
        else {
            let shown = true;
            let isShownSometimes = false;
            if (this.column) {
                shown = this.column.isRowDrag(this.rowNode) || this.parent.isCustomGui();
                isShownSometimes = isFunction(this.column.getColDef().rowDrag);
            }
            if (isShownSometimes) {
                this.parent.setDisplayed(true, displayedOptions);
                this.parent.setVisible(shown, displayedOptions);
            } else {
                this.parent.setDisplayed(shown, displayedOptions);
                this.parent.setVisible(true, displayedOptions);
            }
        }
    }
};
var NonManagedVisibilityStrategy = class extends VisibilityStrategy {
    constructor(parent, beans, rowNode, column){
        super(parent, rowNode, column);
        this.beans = beans;
    }
    postConstruct() {
        this.addManagedPropertyListener("suppressRowDrag", this.onSuppressRowDrag.bind(this));
        this.addManagedListener(this.rowNode, RowNode.EVENT_DATA_CHANGED, this.workOutVisibility.bind(this));
        this.addManagedListener(this.rowNode, RowNode.EVENT_CELL_CHANGED, this.workOutVisibility.bind(this));
        this.addManagedListener(this.rowNode, RowNode.EVENT_CELL_CHANGED, this.workOutVisibility.bind(this));
        this.addManagedListener(this.beans.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.workOutVisibility.bind(this));
        this.workOutVisibility();
    }
    onSuppressRowDrag() {
        this.workOutVisibility();
    }
    workOutVisibility() {
        const neverDisplayed = this.gos.get("suppressRowDrag");
        this.setDisplayedOrVisible(neverDisplayed);
    }
};
__decorateClass([
    PostConstruct
], NonManagedVisibilityStrategy.prototype, "postConstruct", 1);
var ManagedVisibilityStrategy = class extends VisibilityStrategy {
    constructor(parent, beans, rowNode, column){
        super(parent, rowNode, column);
        this.beans = beans;
    }
    postConstruct() {
        this.addManagedListener(this.beans.eventService, Events.EVENT_SORT_CHANGED, this.workOutVisibility.bind(this));
        this.addManagedListener(this.beans.eventService, Events.EVENT_FILTER_CHANGED, this.workOutVisibility.bind(this));
        this.addManagedListener(this.beans.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.workOutVisibility.bind(this));
        this.addManagedListener(this.beans.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.workOutVisibility.bind(this));
        this.addManagedListener(this.rowNode, RowNode.EVENT_DATA_CHANGED, this.workOutVisibility.bind(this));
        this.addManagedListener(this.rowNode, RowNode.EVENT_CELL_CHANGED, this.workOutVisibility.bind(this));
        this.addManagedPropertyListener("suppressRowDrag", this.onSuppressRowDrag.bind(this));
        this.workOutVisibility();
    }
    onSuppressRowDrag() {
        this.workOutVisibility();
    }
    workOutVisibility() {
        const gridBodyCon = this.beans.ctrlsService.getGridBodyCtrl();
        const rowDragFeature = gridBodyCon.getRowDragFeature();
        const shouldPreventRowMove = rowDragFeature && rowDragFeature.shouldPreventRowMove();
        const suppressRowDrag = this.gos.get("suppressRowDrag");
        const hasExternalDropZones = this.beans.dragAndDropService.hasExternalDropZones();
        const neverDisplayed = shouldPreventRowMove && !hasExternalDropZones || suppressRowDrag;
        this.setDisplayedOrVisible(neverDisplayed);
    }
};
__decorateClass([
    PostConstruct
], ManagedVisibilityStrategy.prototype, "postConstruct", 1);
// community-modules/core/src/rendering/cellRenderers/groupCellRendererCtrl.ts
var GroupCellRendererCtrl = class extends BeanStub {
    init(comp, eGui, eCheckbox, eExpanded, eContracted, compClass, params) {
        var _a, _b, _c, _d;
        this.params = params;
        this.eGui = eGui;
        this.eCheckbox = eCheckbox;
        this.eExpanded = eExpanded;
        this.eContracted = eContracted;
        this.comp = comp;
        this.compClass = compClass;
        const { node, value, colDef } = params;
        const topLevelFooter = this.isTopLevelFooter();
        if (!topLevelFooter) {
            const embeddedRowMismatch = this.isEmbeddedRowMismatch();
            if (embeddedRowMismatch) return;
            if (node.footer && this.gos.get("groupHideOpenParents")) {
                const showRowGroup = colDef && colDef.showRowGroup;
                const rowGroupColumnId = node.rowGroupColumn && node.rowGroupColumn.getColId();
                if (showRowGroup !== rowGroupColumnId) return;
            }
        }
        this.setupShowingValueForOpenedParent();
        this.findDisplayedGroupNode();
        if (!topLevelFooter) {
            const showingFooterTotal = params.node.footer && params.node.rowGroupIndex === this.columnModel.getRowGroupColumns().findIndex((c)=>{
                var _a2;
                return c.getColId() === ((_a2 = params.colDef) == null ? void 0 : _a2.showRowGroup);
            });
            const isAlwaysShowing = this.gos.get("groupDisplayType") != "multipleColumns" || this.gos.get("treeData");
            const showOpenGroupValue = isAlwaysShowing || this.gos.get("showOpenedGroup") && !params.node.footer && (!params.node.group || params.node.rowGroupIndex != null && params.node.rowGroupIndex > this.columnModel.getRowGroupColumns().findIndex((c)=>{
                var _a2;
                return c.getColId() === ((_a2 = params.colDef) == null ? void 0 : _a2.showRowGroup);
            }));
            const leafWithValues = !node.group && (((_a = this.params.colDef) == null ? void 0 : _a.field) || ((_b = this.params.colDef) == null ? void 0 : _b.valueGetter));
            const isExpandable = this.isExpandable();
            const showPivotModeLeafValue = this.columnModel.isPivotMode() && node.leafGroup && ((_c = node.rowGroupColumn) == null ? void 0 : _c.getColId()) === ((_d = params.column) == null ? void 0 : _d.getColDef().showRowGroup);
            const canSkipRenderingCell = !this.showingValueForOpenedParent && !isExpandable && !leafWithValues && !showOpenGroupValue && !showingFooterTotal && !showPivotModeLeafValue;
            if (canSkipRenderingCell) return;
        }
        this.addExpandAndContract();
        this.addFullWidthRowDraggerIfNeeded();
        this.addCheckboxIfNeeded();
        this.addValueElement();
        this.setupIndent();
        this.refreshAriaExpanded();
    }
    getCellAriaRole() {
        var _a, _b;
        const colDefAriaRole = (_a = this.params.colDef) == null ? void 0 : _a.cellAriaRole;
        const columnColDefAriaRole = (_b = this.params.column) == null ? void 0 : _b.getColDef().cellAriaRole;
        return colDefAriaRole || columnColDefAriaRole || "gridcell";
    }
    destroy() {
        super.destroy();
        this.expandListener = null;
    }
    refreshAriaExpanded() {
        const { node, eGridCell } = this.params;
        if (this.expandListener) this.expandListener = this.expandListener();
        if (!this.isExpandable()) {
            removeAriaExpanded(eGridCell);
            return;
        }
        const listener = ()=>{
            setAriaExpanded(eGridCell, !!node.expanded);
        };
        this.expandListener = this.addManagedListener(node, RowNode.EVENT_EXPANDED_CHANGED, listener) || null;
        listener();
    }
    isTopLevelFooter() {
        const totalRow = this.gos.getGrandTotalRow();
        if (!totalRow) return false;
        if (this.params.value != null || this.params.node.level != -1) return false;
        const colDef = this.params.colDef;
        const doingFullWidth = colDef == null;
        if (doingFullWidth) return true;
        if (colDef.showRowGroup === true) return true;
        const rowGroupCols = this.columnModel.getRowGroupColumns();
        if (!rowGroupCols || rowGroupCols.length === 0) return true;
        const firstRowGroupCol = rowGroupCols[0];
        return firstRowGroupCol.getId() === colDef.showRowGroup;
    }
    // if we are doing embedded full width rows, we only show the renderer when
    // in the body, or if pinning in the pinned section, or if pinning and RTL,
    // in the right section. otherwise we would have the cell repeated in each section.
    isEmbeddedRowMismatch() {
        if (!this.params.fullWidth || !this.gos.get("embedFullWidthRows")) return false;
        const pinnedLeftCell = this.params.pinned === "left";
        const pinnedRightCell = this.params.pinned === "right";
        const bodyCell = !pinnedLeftCell && !pinnedRightCell;
        if (this.gos.get("enableRtl")) {
            if (this.columnModel.isPinningLeft()) return !pinnedRightCell;
            return !bodyCell;
        }
        if (this.columnModel.isPinningLeft()) return !pinnedLeftCell;
        return !bodyCell;
    }
    findDisplayedGroupNode() {
        const column = this.params.column;
        const rowNode = this.params.node;
        if (this.showingValueForOpenedParent) {
            let pointer = rowNode.parent;
            while(pointer != null){
                if (pointer.rowGroupColumn && column.isRowGroupDisplayed(pointer.rowGroupColumn.getId())) {
                    this.displayedGroupNode = pointer;
                    break;
                }
                pointer = pointer.parent;
            }
        }
        if (missing(this.displayedGroupNode)) this.displayedGroupNode = rowNode;
    }
    setupShowingValueForOpenedParent() {
        const rowNode = this.params.node;
        const column = this.params.column;
        if (!this.gos.get("groupHideOpenParents")) {
            this.showingValueForOpenedParent = false;
            return;
        }
        if (!rowNode.groupData) {
            this.showingValueForOpenedParent = false;
            return;
        }
        const showingGroupNode = rowNode.rowGroupColumn != null;
        if (showingGroupNode) {
            const keyOfGroupingColumn = rowNode.rowGroupColumn.getId();
            const configuredToShowThisGroupLevel = column.isRowGroupDisplayed(keyOfGroupingColumn);
            if (configuredToShowThisGroupLevel) {
                this.showingValueForOpenedParent = false;
                return;
            }
        }
        const valPresent = rowNode.groupData[column.getId()] != null;
        this.showingValueForOpenedParent = valPresent;
    }
    addValueElement() {
        if (this.displayedGroupNode.footer) this.addFooterValue();
        else {
            this.addGroupValue();
            this.addChildCount();
        }
    }
    addGroupValue() {
        var _a;
        const paramsAdjusted = this.adjustParamsWithDetailsFromRelatedColumn();
        const innerCompDetails = this.getInnerCompDetails(paramsAdjusted);
        const { valueFormatted, value } = paramsAdjusted;
        let valueWhenNoRenderer = valueFormatted;
        if (valueWhenNoRenderer == null) {
            const isGroupColForNode = this.displayedGroupNode.rowGroupColumn && ((_a = this.params.column) == null ? void 0 : _a.isRowGroupDisplayed(this.displayedGroupNode.rowGroupColumn.getId()));
            if (this.displayedGroupNode.key === "" && this.displayedGroupNode.group && isGroupColForNode) {
                const localeTextFunc = this.localeService.getLocaleTextFunc();
                valueWhenNoRenderer = localeTextFunc("blanks", "(Blanks)");
            } else valueWhenNoRenderer = value != null ? value : null;
        }
        this.comp.setInnerRenderer(innerCompDetails, valueWhenNoRenderer);
    }
    adjustParamsWithDetailsFromRelatedColumn() {
        const relatedColumn = this.displayedGroupNode.rowGroupColumn;
        const column = this.params.column;
        if (!relatedColumn) return this.params;
        const notFullWidth = column != null;
        if (notFullWidth) {
            const showingThisRowGroup = column.isRowGroupDisplayed(relatedColumn.getId());
            if (!showingThisRowGroup) return this.params;
        }
        const params = this.params;
        const { value, node } = this.params;
        const valueFormatted = this.valueService.formatValue(relatedColumn, node, value);
        const paramsAdjusted = __spreadProps(__spreadValues({}, params), {
            valueFormatted
        });
        return paramsAdjusted;
    }
    addFooterValue() {
        let footerValueGetter = this.params.totalValueGetter;
        if (!footerValueGetter) {
            const legacyGetter = this.params.footerValueGetter;
            if (legacyGetter) {
                footerValueGetter = legacyGetter;
                warnOnce("As of v31.3, footerValueGetter is deprecated. Use `totalValueGetter` instead.");
            }
        }
        let footerValue = "";
        if (footerValueGetter) {
            const paramsClone = cloneObject(this.params);
            paramsClone.value = this.params.value;
            if (typeof footerValueGetter === "function") footerValue = footerValueGetter(paramsClone);
            else if (typeof footerValueGetter === "string") footerValue = this.expressionService.evaluate(footerValueGetter, paramsClone);
            else console.warn("AG Grid: footerValueGetter should be either a function or a string (expression)");
        } else {
            const localeTextFunc = this.localeService.getLocaleTextFunc();
            const footerTotalPrefix = localeTextFunc("footerTotal", "Total");
            footerValue = footerTotalPrefix + " " + (this.params.value != null ? this.params.value : "");
        }
        const innerCompDetails = this.getInnerCompDetails(this.params);
        this.comp.setInnerRenderer(innerCompDetails, footerValue);
    }
    getInnerCompDetails(params) {
        if (params.fullWidth) return this.userComponentFactory.getFullWidthGroupRowInnerCellRenderer(this.gos.get("groupRowRendererParams"), params);
        const innerCompDetails = this.userComponentFactory.getInnerRendererDetails(params, params);
        const isGroupRowRenderer = (details)=>details && details.componentClass == this.compClass;
        if (innerCompDetails && !isGroupRowRenderer(innerCompDetails)) return innerCompDetails;
        const relatedColumn = this.displayedGroupNode.rowGroupColumn;
        const relatedColDef = relatedColumn ? relatedColumn.getColDef() : void 0;
        if (!relatedColDef) return;
        const relatedCompDetails = this.userComponentFactory.getCellRendererDetails(relatedColDef, params);
        if (relatedCompDetails && !isGroupRowRenderer(relatedCompDetails)) return relatedCompDetails;
        if (isGroupRowRenderer(relatedCompDetails) && relatedColDef.cellRendererParams && relatedColDef.cellRendererParams.innerRenderer) {
            const res = this.userComponentFactory.getInnerRendererDetails(relatedColDef.cellRendererParams, params);
            return res;
        }
    }
    addChildCount() {
        if (this.params.suppressCount) return;
        this.addManagedListener(this.displayedGroupNode, RowNode.EVENT_ALL_CHILDREN_COUNT_CHANGED, this.updateChildCount.bind(this));
        this.updateChildCount();
    }
    updateChildCount() {
        const allChildrenCount = this.displayedGroupNode.allChildrenCount;
        const showingGroupForThisNode = this.isShowRowGroupForThisRow();
        const showCount = showingGroupForThisNode && allChildrenCount != null && allChildrenCount >= 0;
        const countString = showCount ? `(${allChildrenCount})` : ``;
        this.comp.setChildCount(countString);
    }
    isShowRowGroupForThisRow() {
        if (this.gos.get("treeData")) return true;
        const rowGroupColumn = this.displayedGroupNode.rowGroupColumn;
        if (!rowGroupColumn) return false;
        const column = this.params.column;
        const thisColumnIsInterested = column == null || column.isRowGroupDisplayed(rowGroupColumn.getId());
        return thisColumnIsInterested;
    }
    addExpandAndContract() {
        var _a;
        const params = this.params;
        const eExpandedIcon = createIconNoSpan("groupExpanded", this.gos, null);
        const eContractedIcon = createIconNoSpan("groupContracted", this.gos, null);
        if (eExpandedIcon) this.eExpanded.appendChild(eExpandedIcon);
        if (eContractedIcon) this.eContracted.appendChild(eContractedIcon);
        const eGroupCell = params.eGridCell;
        const isDoubleClickEdit = ((_a = this.params.column) == null ? void 0 : _a.isCellEditable(params.node)) && this.gos.get("enableGroupEdit");
        if (!isDoubleClickEdit && this.isExpandable() && !params.suppressDoubleClickExpand) this.addManagedListener(eGroupCell, "dblclick", this.onCellDblClicked.bind(this));
        this.addManagedListener(this.eExpanded, "click", this.onExpandClicked.bind(this));
        this.addManagedListener(this.eContracted, "click", this.onExpandClicked.bind(this));
        this.addManagedListener(eGroupCell, "keydown", this.onKeyDown.bind(this));
        this.addManagedListener(params.node, RowNode.EVENT_EXPANDED_CHANGED, this.showExpandAndContractIcons.bind(this));
        this.showExpandAndContractIcons();
        const expandableChangedListener = this.onRowNodeIsExpandableChanged.bind(this);
        this.addManagedListener(this.displayedGroupNode, RowNode.EVENT_ALL_CHILDREN_COUNT_CHANGED, expandableChangedListener);
        this.addManagedListener(this.displayedGroupNode, RowNode.EVENT_MASTER_CHANGED, expandableChangedListener);
        this.addManagedListener(this.displayedGroupNode, RowNode.EVENT_GROUP_CHANGED, expandableChangedListener);
        this.addManagedListener(this.displayedGroupNode, RowNode.EVENT_HAS_CHILDREN_CHANGED, expandableChangedListener);
    }
    onExpandClicked(mouseEvent) {
        if (isStopPropagationForAgGrid(mouseEvent)) return;
        stopPropagationForAgGrid(mouseEvent);
        this.onExpandOrContract(mouseEvent);
    }
    onExpandOrContract(e) {
        const rowNode = this.displayedGroupNode;
        const nextExpandState = !rowNode.expanded;
        if (!nextExpandState && rowNode.sticky) this.scrollToStickyNode(rowNode);
        rowNode.setExpanded(nextExpandState, e);
    }
    scrollToStickyNode(rowNode) {
        const gridBodyCtrl = this.ctrlsService.getGridBodyCtrl();
        const scrollFeature = gridBodyCtrl.getScrollFeature();
        scrollFeature.setVerticalScrollPosition(rowNode.rowTop - rowNode.stickyRowTop);
    }
    isExpandable() {
        if (this.showingValueForOpenedParent) return true;
        const rowNode = this.displayedGroupNode;
        const reducedLeafNode = this.columnModel.isPivotMode() && rowNode.leafGroup;
        const expandableGroup = rowNode.isExpandable() && !rowNode.footer && !reducedLeafNode;
        if (!expandableGroup) return false;
        const column = this.params.column;
        const displayingForOneColumnOnly = column != null && typeof column.getColDef().showRowGroup === "string";
        if (displayingForOneColumnOnly) {
            const showing = this.isShowRowGroupForThisRow();
            return showing;
        }
        return true;
    }
    showExpandAndContractIcons() {
        const { params, displayedGroupNode: displayedGroup, columnModel } = this;
        const { node } = params;
        const isExpandable = this.isExpandable();
        if (isExpandable) {
            const expanded = this.showingValueForOpenedParent ? true : node.expanded;
            this.comp.setExpandedDisplayed(expanded);
            this.comp.setContractedDisplayed(!expanded);
        } else {
            this.comp.setExpandedDisplayed(false);
            this.comp.setContractedDisplayed(false);
        }
        const pivotMode = columnModel.isPivotMode();
        const pivotModeAndLeafGroup = pivotMode && displayedGroup.leafGroup;
        const addExpandableCss = isExpandable && !pivotModeAndLeafGroup;
        const isTotalFooterNode = node.footer && node.level === -1;
        this.comp.addOrRemoveCssClass("ag-cell-expandable", addExpandableCss);
        this.comp.addOrRemoveCssClass("ag-row-group", addExpandableCss);
        if (pivotMode) this.comp.addOrRemoveCssClass("ag-pivot-leaf-group", pivotModeAndLeafGroup);
        else if (!isTotalFooterNode) this.comp.addOrRemoveCssClass("ag-row-group-leaf-indent", !addExpandableCss);
    }
    onRowNodeIsExpandableChanged() {
        this.showExpandAndContractIcons();
        this.setIndent();
        this.refreshAriaExpanded();
    }
    setupIndent() {
        const node = this.params.node;
        const suppressPadding = this.params.suppressPadding;
        if (!suppressPadding) {
            this.addManagedListener(node, RowNode.EVENT_UI_LEVEL_CHANGED, this.setIndent.bind(this));
            this.setIndent();
        }
    }
    setIndent() {
        if (this.gos.get("groupHideOpenParents")) return;
        const params = this.params;
        const rowNode = params.node;
        const fullWithRow = !!params.colDef;
        const treeData = this.gos.get("treeData");
        const manyDimensionThisColumn = !fullWithRow || treeData || params.colDef.showRowGroup === true;
        const paddingCount = manyDimensionThisColumn ? rowNode.uiLevel : 0;
        if (this.indentClass) this.comp.addOrRemoveCssClass(this.indentClass, false);
        this.indentClass = "ag-row-group-indent-" + paddingCount;
        this.comp.addOrRemoveCssClass(this.indentClass, true);
    }
    addFullWidthRowDraggerIfNeeded() {
        if (!this.params.fullWidth || !this.params.rowDrag) return;
        const rowDragComp = new RowDragComp(()=>this.params.value, this.params.node);
        this.createManagedBean(rowDragComp, this.context);
        this.eGui.insertAdjacentElement("afterbegin", rowDragComp.getGui());
    }
    isUserWantsSelected() {
        const paramsCheckbox = this.params.checkbox;
        return typeof paramsCheckbox === "function" || paramsCheckbox === true;
    }
    addCheckboxIfNeeded() {
        const rowNode = this.displayedGroupNode;
        const checkboxNeeded = this.isUserWantsSelected() && // footers cannot be selected
        !rowNode.footer && // pinned rows cannot be selected
        !rowNode.rowPinned && // details cannot be selected
        !rowNode.detail;
        if (checkboxNeeded) {
            const cbSelectionComponent = new CheckboxSelectionComponent();
            this.getContext().createBean(cbSelectionComponent);
            cbSelectionComponent.init({
                rowNode: this.params.node,
                // when groupHideOpenParents = true and group expanded, we want the checkbox to refer to leaf node state (not group node state)
                column: this.params.column,
                overrides: {
                    isVisible: this.params.checkbox,
                    callbackParams: this.params,
                    removeHidden: true
                }
            });
            this.eCheckbox.appendChild(cbSelectionComponent.getGui());
            this.addDestroyFunc(()=>this.getContext().destroyBean(cbSelectionComponent));
        }
        this.comp.setCheckboxVisible(checkboxNeeded);
    }
    onKeyDown(event) {
        const isEnterKey = event.key === KeyCode.ENTER;
        if (!isEnterKey || this.params.suppressEnterExpand) return;
        const cellEditable = this.params.column && this.params.column.isCellEditable(this.params.node);
        if (cellEditable) return;
        this.onExpandOrContract(event);
    }
    onCellDblClicked(mouseEvent) {
        if (isStopPropagationForAgGrid(mouseEvent)) return;
        const targetIsExpandIcon = isElementInEventPath(this.eExpanded, mouseEvent) || isElementInEventPath(this.eContracted, mouseEvent);
        if (!targetIsExpandIcon) this.onExpandOrContract(mouseEvent);
    }
};
__decorateClass([
    Autowired("expressionService")
], GroupCellRendererCtrl.prototype, "expressionService", 2);
__decorateClass([
    Autowired("valueService")
], GroupCellRendererCtrl.prototype, "valueService", 2);
__decorateClass([
    Autowired("columnModel")
], GroupCellRendererCtrl.prototype, "columnModel", 2);
__decorateClass([
    Autowired("userComponentFactory")
], GroupCellRendererCtrl.prototype, "userComponentFactory", 2);
__decorateClass([
    Autowired("ctrlsService")
], GroupCellRendererCtrl.prototype, "ctrlsService", 2);
// community-modules/core/src/rendering/cellRenderers/groupCellRenderer.ts
var _GroupCellRenderer = class _GroupCellRenderer extends Component {
    constructor(){
        super(_GroupCellRenderer.TEMPLATE);
    }
    init(params) {
        const compProxy = {
            setInnerRenderer: (compDetails, valueToDisplay)=>this.setRenderDetails(compDetails, valueToDisplay),
            setChildCount: (count)=>this.eChildCount.textContent = count,
            addOrRemoveCssClass: (cssClass, value)=>this.addOrRemoveCssClass(cssClass, value),
            setContractedDisplayed: (expanded)=>setDisplayed(this.eContracted, expanded),
            setExpandedDisplayed: (expanded)=>setDisplayed(this.eExpanded, expanded),
            setCheckboxVisible: (visible)=>this.eCheckbox.classList.toggle("ag-invisible", !visible)
        };
        const ctrl = this.createManagedBean(new GroupCellRendererCtrl());
        const fullWidth = !params.colDef;
        const eGui = this.getGui();
        ctrl.init(compProxy, eGui, this.eCheckbox, this.eExpanded, this.eContracted, this.constructor, params);
        if (fullWidth) setAriaRole(eGui, ctrl.getCellAriaRole());
    }
    setRenderDetails(compDetails, valueToDisplay) {
        if (compDetails) {
            const componentPromise = compDetails.newAgStackInstance();
            if (!componentPromise) return;
            componentPromise.then((comp)=>{
                if (!comp) return;
                const destroyComp = ()=>this.context.destroyBean(comp);
                if (this.isAlive()) {
                    this.eValue.appendChild(comp.getGui());
                    this.addDestroyFunc(destroyComp);
                } else destroyComp();
            });
        } else this.eValue.innerText = valueToDisplay;
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to have public here instead of private or protected
    destroy() {
        this.getContext().destroyBean(this.innerCellRenderer);
        super.destroy();
    }
    refresh() {
        return false;
    }
};
_GroupCellRenderer.TEMPLATE = /* html */ `<span class="ag-cell-wrapper">
            <span class="ag-group-expanded" ref="eExpanded"></span>
            <span class="ag-group-contracted" ref="eContracted"></span>
            <span class="ag-group-checkbox ag-invisible" ref="eCheckbox"></span>
            <span class="ag-group-value" ref="eValue"></span>
            <span class="ag-group-child-count" ref="eChildCount"></span>
        </span>`;
__decorateClass([
    RefSelector("eExpanded")
], _GroupCellRenderer.prototype, "eExpanded", 2);
__decorateClass([
    RefSelector("eContracted")
], _GroupCellRenderer.prototype, "eContracted", 2);
__decorateClass([
    RefSelector("eCheckbox")
], _GroupCellRenderer.prototype, "eCheckbox", 2);
__decorateClass([
    RefSelector("eValue")
], _GroupCellRenderer.prototype, "eValue", 2);
__decorateClass([
    RefSelector("eChildCount")
], _GroupCellRenderer.prototype, "eChildCount", 2);
var GroupCellRenderer = _GroupCellRenderer;
// community-modules/core/src/rendering/cellRenderers/loadingCellRenderer.ts
var _LoadingCellRenderer = class _LoadingCellRenderer extends Component {
    constructor(){
        super(_LoadingCellRenderer.TEMPLATE);
    }
    init(params) {
        params.node.failedLoad ? this.setupFailed() : this.setupLoading();
    }
    setupFailed() {
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        this.eLoadingText.innerText = localeTextFunc("loadingError", "ERR");
    }
    setupLoading() {
        const eLoadingIcon = createIconNoSpan("groupLoading", this.gos, null);
        if (eLoadingIcon) this.eLoadingIcon.appendChild(eLoadingIcon);
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        this.eLoadingText.innerText = localeTextFunc("loadingOoo", "Loading");
    }
    refresh(params) {
        return false;
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    destroy() {
        super.destroy();
    }
};
_LoadingCellRenderer.TEMPLATE = `<div class="ag-loading">
            <span class="ag-loading-icon" ref="eLoadingIcon"></span>
            <span class="ag-loading-text" ref="eLoadingText"></span>
        </div>`;
__decorateClass([
    RefSelector("eLoadingIcon")
], _LoadingCellRenderer.prototype, "eLoadingIcon", 2);
__decorateClass([
    RefSelector("eLoadingText")
], _LoadingCellRenderer.prototype, "eLoadingText", 2);
var LoadingCellRenderer = _LoadingCellRenderer;
// community-modules/core/src/rendering/cellRenderers/skeletonCellRenderer.ts
var _SkeletonCellRenderer = class _SkeletonCellRenderer extends Component {
    constructor(){
        super(_SkeletonCellRenderer.TEMPLATE);
    }
    init(params) {
        const id = `ag-cell-skeleton-renderer-${this.getCompId()}`;
        this.getGui().setAttribute("id", id);
        this.addDestroyFunc(()=>setAriaLabelledBy(params.eParentOfValue));
        setAriaLabelledBy(params.eParentOfValue, id);
        params.node.failedLoad ? this.setupFailed() : this.setupLoading();
    }
    setupFailed() {
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        this.getGui().innerText = localeTextFunc("loadingError", "ERR");
        const ariaFailed = localeTextFunc("ariaSkeletonCellLoadingFailed", "Row failed to load");
        setAriaLabel(this.getGui(), ariaFailed);
    }
    setupLoading() {
        const eDocument = this.gos.getDocument();
        const skeletonEffect = eDocument.createElement("div");
        skeletonEffect.classList.add("ag-skeleton-effect");
        this.getGui().appendChild(skeletonEffect);
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        const ariaLoading = localeTextFunc("ariaSkeletonCellLoading", "Row data is loading");
        setAriaLabel(this.getGui(), ariaLoading);
    }
    refresh(params) {
        return false;
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    destroy() {
        super.destroy();
    }
};
_SkeletonCellRenderer.TEMPLATE = `<div class="ag-skeleton-container"></div>`;
var SkeletonCellRenderer = _SkeletonCellRenderer;
// community-modules/core/src/rendering/overlays/loadingOverlayComponent.ts
var _LoadingOverlayComponent = class _LoadingOverlayComponent extends Component {
    constructor(){
        super();
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    destroy() {
        super.destroy();
    }
    init(params) {
        const customTemplate = this.gos.get("overlayLoadingTemplate");
        this.setTemplate(customTemplate != null ? customTemplate : _LoadingOverlayComponent.DEFAULT_LOADING_OVERLAY_TEMPLATE);
        if (!customTemplate) {
            const localeTextFunc = this.localeService.getLocaleTextFunc();
            setTimeout(()=>{
                this.getGui().textContent = localeTextFunc("loadingOoo", "Loading...");
            });
        }
    }
};
_LoadingOverlayComponent.DEFAULT_LOADING_OVERLAY_TEMPLATE = /* html */ `<span aria-live="polite" aria-atomic="true" class="ag-overlay-loading-center"></span>`;
var LoadingOverlayComponent = _LoadingOverlayComponent;
// community-modules/core/src/rendering/overlays/noRowsOverlayComponent.ts
var _NoRowsOverlayComponent = class _NoRowsOverlayComponent extends Component {
    constructor(){
        super();
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    destroy() {
        super.destroy();
    }
    init(params) {
        const customTemplate = this.gos.get("overlayNoRowsTemplate");
        this.setTemplate(customTemplate != null ? customTemplate : _NoRowsOverlayComponent.DEFAULT_NO_ROWS_TEMPLATE);
        if (!customTemplate) {
            const localeTextFunc = this.localeService.getLocaleTextFunc();
            setTimeout(()=>{
                this.getGui().textContent = localeTextFunc("noRowsToShow", "No Rows To Show");
            });
        }
    }
};
_NoRowsOverlayComponent.DEFAULT_NO_ROWS_TEMPLATE = /* html */ `<span class="ag-overlay-no-rows-center"></span>`;
var NoRowsOverlayComponent = _NoRowsOverlayComponent;
// community-modules/core/src/rendering/tooltipComponent.ts
var TooltipComponent = class extends PopupComponent {
    constructor(){
        super(/* html */ `<div class="ag-tooltip"></div>`);
    }
    // will need to type params
    init(params) {
        const { value } = params;
        this.getGui().textContent = escapeString(value, true);
    }
};
// community-modules/core/src/rendering/cellEditors/numberCellEditor.ts
var NumberCellEditorInput = class {
    getTemplate() {
        return /* html */ `<ag-input-number-field class="ag-cell-editor" ref="eInput"></ag-input-number-field>`;
    }
    init(eInput, params) {
        this.eInput = eInput;
        this.params = params;
        if (params.max != null) eInput.setMax(params.max);
        if (params.min != null) eInput.setMin(params.min);
        if (params.precision != null) eInput.setPrecision(params.precision);
        if (params.step != null) eInput.setStep(params.step);
        const inputEl = eInput.getInputElement();
        if (params.preventStepping) eInput.addManagedListener(inputEl, "keydown", this.preventStepping);
        else if (params.showStepperButtons) inputEl.classList.add("ag-number-field-input-stepper");
    }
    preventStepping(e) {
        if (e.key === KeyCode.UP || e.key === KeyCode.DOWN) e.preventDefault();
    }
    getValue() {
        const value = this.eInput.getValue();
        if (!exists(value) && !exists(this.params.value)) return this.params.value;
        let parsedValue = this.params.parseValue(value);
        if (parsedValue == null) return parsedValue;
        if (typeof parsedValue === "string") {
            if (parsedValue === "") return null;
            parsedValue = Number(parsedValue);
        }
        return isNaN(parsedValue) ? null : parsedValue;
    }
    getStartValue() {
        return this.params.value;
    }
};
var NumberCellEditor = class extends SimpleCellEditor {
    constructor(){
        super(new NumberCellEditorInput());
    }
};
// community-modules/core/src/rendering/cellEditors/dateCellEditor.ts
var DateCellEditorInput = class {
    getTemplate() {
        return /* html */ `<ag-input-date-field class="ag-cell-editor" ref="eInput"></ag-input-date-field>`;
    }
    init(eInput, params) {
        this.eInput = eInput;
        this.params = params;
        if (params.min != null) eInput.setMin(params.min);
        if (params.max != null) eInput.setMax(params.max);
        if (params.step != null) eInput.setStep(params.step);
    }
    getValue() {
        const value = this.eInput.getDate();
        if (!exists(value) && !exists(this.params.value)) return this.params.value;
        return value != null ? value : null;
    }
    getStartValue() {
        const { value } = this.params;
        if (!(value instanceof Date)) return void 0;
        return serialiseDate(value, false);
    }
};
var DateCellEditor = class extends SimpleCellEditor {
    constructor(){
        super(new DateCellEditorInput());
    }
};
// community-modules/core/src/rendering/cellEditors/dateStringCellEditor.ts
var DateStringCellEditorInput = class {
    constructor(getDataTypeService){
        this.getDataTypeService = getDataTypeService;
    }
    getTemplate() {
        return /* html */ `<ag-input-date-field class="ag-cell-editor" ref="eInput"></ag-input-date-field>`;
    }
    init(eInput, params) {
        this.eInput = eInput;
        this.params = params;
        if (params.min != null) eInput.setMin(params.min);
        if (params.max != null) eInput.setMax(params.max);
        if (params.step != null) eInput.setStep(params.step);
    }
    getValue() {
        const value = this.formatDate(this.eInput.getDate());
        if (!exists(value) && !exists(this.params.value)) return this.params.value;
        return this.params.parseValue(value != null ? value : "");
    }
    getStartValue() {
        var _a, _b;
        return serialiseDate((_b = this.parseDate((_a = this.params.value) != null ? _a : void 0)) != null ? _b : null, false);
    }
    parseDate(value) {
        return this.getDataTypeService().getDateParserFunction(this.params.column)(value);
    }
    formatDate(value) {
        return this.getDataTypeService().getDateFormatterFunction(this.params.column)(value);
    }
};
var DateStringCellEditor = class extends SimpleCellEditor {
    constructor(){
        super(new DateStringCellEditorInput(()=>this.dataTypeService));
    }
};
__decorateClass([
    Autowired("dataTypeService")
], DateStringCellEditor.prototype, "dataTypeService", 2);
// community-modules/core/src/rendering/cellRenderers/checkboxCellRenderer.ts
var _CheckboxCellRenderer = class _CheckboxCellRenderer extends Component {
    constructor(){
        super(_CheckboxCellRenderer.TEMPLATE);
    }
    init(params) {
        this.params = params;
        this.updateCheckbox(params);
        const inputEl = this.eCheckbox.getInputElement();
        inputEl.setAttribute("tabindex", "-1");
        setAriaLive(inputEl, "polite");
        this.addManagedListener(inputEl, "click", (event)=>{
            stopPropagationForAgGrid(event);
            if (this.eCheckbox.isDisabled()) return;
            const isSelected = this.eCheckbox.getValue();
            this.onCheckboxChanged(isSelected);
        });
        this.addManagedListener(inputEl, "dblclick", (event)=>{
            stopPropagationForAgGrid(event);
        });
        this.addManagedListener(this.params.eGridCell, "keydown", (event)=>{
            if (event.key === KeyCode.SPACE && !this.eCheckbox.isDisabled()) {
                if (this.params.eGridCell === this.gos.getActiveDomElement()) this.eCheckbox.toggle();
                const isSelected = this.eCheckbox.getValue();
                this.onCheckboxChanged(isSelected);
                event.preventDefault();
            }
        });
    }
    refresh(params) {
        this.params = params;
        this.updateCheckbox(params);
        return true;
    }
    updateCheckbox(params) {
        var _a, _b, _c;
        let isSelected;
        let displayed = true;
        if (params.node.group && params.column) {
            const colId = params.column.getColId();
            if (colId.startsWith(GROUP_AUTO_COLUMN_ID)) isSelected = params.value == null || params.value === "" ? void 0 : params.value === "true";
            else if (params.node.aggData && params.node.aggData[colId] !== void 0) isSelected = (_a = params.value) != null ? _a : void 0;
            else displayed = false;
        } else isSelected = (_b = params.value) != null ? _b : void 0;
        if (!displayed) {
            this.eCheckbox.setDisplayed(false);
            return;
        }
        this.eCheckbox.setValue(isSelected);
        const disabled = params.disabled != null ? params.disabled : !((_c = params.column) == null ? void 0 : _c.isCellEditable(params.node));
        this.eCheckbox.setDisabled(disabled);
        const translate = this.localeService.getLocaleTextFunc();
        const stateName = getAriaCheckboxStateName(translate, isSelected);
        const ariaLabel = disabled ? stateName : `${translate("ariaToggleCellValue", "Press SPACE to toggle cell value")} (${stateName})`;
        this.eCheckbox.setInputAriaLabel(ariaLabel);
    }
    onCheckboxChanged(isSelected) {
        const { column, node, rowIndex, value } = this.params;
        const eventStarted = {
            type: Events.EVENT_CELL_EDITING_STARTED,
            column,
            colDef: column == null ? void 0 : column.getColDef(),
            data: node.data,
            node,
            rowIndex,
            rowPinned: node.rowPinned,
            value
        };
        this.eventService.dispatchEvent(eventStarted);
        const valueChanged = this.params.node.setDataValue(this.params.column, isSelected, "edit");
        const eventStopped = {
            type: Events.EVENT_CELL_EDITING_STOPPED,
            column,
            colDef: column == null ? void 0 : column.getColDef(),
            data: node.data,
            node,
            rowIndex,
            rowPinned: node.rowPinned,
            value,
            oldValue: value,
            newValue: isSelected,
            valueChanged
        };
        this.eventService.dispatchEvent(eventStopped);
    }
};
_CheckboxCellRenderer.TEMPLATE = /* html*/ `
        <div class="ag-cell-wrapper ag-checkbox-cell" role="presentation">
            <ag-checkbox role="presentation" ref="eCheckbox"></ag-checkbox>
        </div>`;
__decorateClass([
    RefSelector("eCheckbox")
], _CheckboxCellRenderer.prototype, "eCheckbox", 2);
var CheckboxCellRenderer = _CheckboxCellRenderer;
// community-modules/core/src/rendering/cellEditors/checkboxCellEditor.ts
var CheckboxCellEditor = class extends PopupComponent {
    constructor(){
        super(/* html */ `
            <div class="ag-cell-wrapper ag-cell-edit-wrapper ag-checkbox-edit">
                <ag-checkbox role="presentation" ref="eCheckbox"></ag-checkbox>
            </div>`);
    }
    init(params) {
        var _a;
        this.params = params;
        const isSelected = (_a = params.value) != null ? _a : void 0;
        this.eCheckbox.setValue(isSelected);
        const inputEl = this.eCheckbox.getInputElement();
        inputEl.setAttribute("tabindex", "-1");
        this.setAriaLabel(isSelected);
        this.addManagedListener(this.eCheckbox, Events.EVENT_FIELD_VALUE_CHANGED, (event)=>this.setAriaLabel(event.selected));
    }
    getValue() {
        return this.eCheckbox.getValue();
    }
    focusIn() {
        this.eCheckbox.getFocusableElement().focus();
    }
    afterGuiAttached() {
        if (this.params.cellStartedEdit) this.focusIn();
    }
    isPopup() {
        return false;
    }
    setAriaLabel(isSelected) {
        const translate = this.localeService.getLocaleTextFunc();
        const stateName = getAriaCheckboxStateName(translate, isSelected);
        const ariaLabel = translate("ariaToggleCellValue", "Press SPACE to toggle cell value");
        this.eCheckbox.setInputAriaLabel(`${ariaLabel} (${stateName})`);
    }
};
__decorateClass([
    RefSelector("eCheckbox")
], CheckboxCellEditor.prototype, "eCheckbox", 2);
// community-modules/core/src/widgets/agMenuItemRenderer.ts
var AgMenuItemRenderer = class extends Component {
    constructor(){
        super();
        this.setTemplate(/* html */ `<div></div>`);
    }
    init(params) {
        var _a;
        this.params = params;
        this.cssClassPrefix = (_a = this.params.cssClassPrefix) != null ? _a : "ag-menu-option";
        this.addIcon();
        this.addName();
        this.addShortcut();
        this.addSubMenu();
    }
    configureDefaults() {
        return true;
    }
    addIcon() {
        if (this.params.isCompact) return;
        const icon = loadTemplate(/* html */ `<span ref="eIcon" class="${this.getClassName("part")} ${this.getClassName("icon")}" role="presentation"></span>`);
        if (this.params.checked) icon.appendChild(createIconNoSpan("check", this.gos));
        else if (this.params.icon) {
            if (isNodeOrElement(this.params.icon)) icon.appendChild(this.params.icon);
            else if (typeof this.params.icon === "string") icon.innerHTML = this.params.icon;
            else console.warn("AG Grid: menu item icon must be DOM node or string");
        }
        this.getGui().appendChild(icon);
    }
    addName() {
        const name = loadTemplate(/* html */ `<span ref="eName" class="${this.getClassName("part")} ${this.getClassName("text")}">${this.params.name || ""}</span>`);
        this.getGui().appendChild(name);
    }
    addShortcut() {
        if (this.params.isCompact) return;
        const shortcut = loadTemplate(/* html */ `<span ref="eShortcut" class="${this.getClassName("part")} ${this.getClassName("shortcut")}">${this.params.shortcut || ""}</span>`);
        this.getGui().appendChild(shortcut);
    }
    addSubMenu() {
        const pointer = loadTemplate(/* html */ `<span ref="ePopupPointer" class="${this.getClassName("part")} ${this.getClassName("popup-pointer")}"></span>`);
        const eGui = this.getGui();
        if (this.params.subMenu) {
            const iconName = this.gos.get("enableRtl") ? "smallLeft" : "smallRight";
            setAriaExpanded(eGui, false);
            pointer.appendChild(createIconNoSpan(iconName, this.gos));
        }
        eGui.appendChild(pointer);
    }
    getClassName(suffix) {
        return `${this.cssClassPrefix}-${suffix}`;
    }
    destroy() {
        super.destroy();
    }
};
// community-modules/core/src/components/framework/userComponentRegistry.ts
var UserComponentRegistry = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.agGridDefaults = {
            //date
            agDateInput: DefaultDateComponent,
            //header
            agColumnHeader: HeaderComp,
            agColumnGroupHeader: HeaderGroupComp,
            agSortIndicator: SortIndicatorComp,
            //floating filters
            agTextColumnFloatingFilter: TextFloatingFilter,
            agNumberColumnFloatingFilter: NumberFloatingFilter,
            agDateColumnFloatingFilter: DateFloatingFilter,
            agReadOnlyFloatingFilter: ReadOnlyFloatingFilter,
            // renderers
            agAnimateShowChangeCellRenderer: AnimateShowChangeCellRenderer,
            agAnimateSlideCellRenderer: AnimateSlideCellRenderer,
            agGroupCellRenderer: GroupCellRenderer,
            agGroupRowRenderer: GroupCellRenderer,
            agLoadingCellRenderer: LoadingCellRenderer,
            agSkeletonCellRenderer: SkeletonCellRenderer,
            agCheckboxCellRenderer: CheckboxCellRenderer,
            //editors
            agCellEditor: TextCellEditor,
            agTextCellEditor: TextCellEditor,
            agNumberCellEditor: NumberCellEditor,
            agDateCellEditor: DateCellEditor,
            agDateStringCellEditor: DateStringCellEditor,
            agSelectCellEditor: SelectCellEditor,
            agLargeTextCellEditor: LargeTextCellEditor,
            agCheckboxCellEditor: CheckboxCellEditor,
            //filter
            agTextColumnFilter: TextFilter,
            agNumberColumnFilter: NumberFilter,
            agDateColumnFilter: DateFilter,
            //overlays
            agLoadingOverlay: LoadingOverlayComponent,
            agNoRowsOverlay: NoRowsOverlayComponent,
            // tooltips
            agTooltipComponent: TooltipComponent,
            // menu item
            agMenuItem: AgMenuItemRenderer
        };
        /** Used to provide useful error messages if a user is trying to use an enterprise component without loading the module. */ this.enterpriseAgDefaultCompsModule = {
            agSetColumnFilter: "@ag-grid-enterprise/set-filter" /* SetFilterModule */ ,
            agSetColumnFloatingFilter: "@ag-grid-enterprise/set-filter" /* SetFilterModule */ ,
            agMultiColumnFilter: "@ag-grid-enterprise/multi-filter" /* MultiFilterModule */ ,
            agMultiColumnFloatingFilter: "@ag-grid-enterprise/multi-filter" /* MultiFilterModule */ ,
            agGroupColumnFilter: "@ag-grid-enterprise/row-grouping" /* RowGroupingModule */ ,
            agGroupColumnFloatingFilter: "@ag-grid-enterprise/row-grouping" /* RowGroupingModule */ ,
            agRichSelect: "@ag-grid-enterprise/rich-select" /* RichSelectModule */ ,
            agRichSelectCellEditor: "@ag-grid-enterprise/rich-select" /* RichSelectModule */ ,
            agDetailCellRenderer: "@ag-grid-enterprise/master-detail" /* MasterDetailModule */ ,
            agSparklineCellRenderer: "@ag-grid-enterprise/sparklines" /* SparklinesModule */ 
        };
        this.jsComps = {};
    }
    init() {
        const comps = this.gos.get("components");
        if (comps != null) iterateObject(comps, (key, component)=>this.registerJsComponent(key, component));
    }
    registerDefaultComponent(name, component) {
        if (this.agGridDefaults[name]) {
            console.error(`Trying to overwrite a default component. You should call registerComponent`);
            return;
        }
        this.agGridDefaults[name] = component;
    }
    registerJsComponent(name, component) {
        this.jsComps[name] = component;
    }
    retrieve(propertyName, name) {
        const createResult = (component, componentFromFramework)=>({
                componentFromFramework,
                component
            });
        const registeredViaFrameworkComp = this.getFrameworkOverrides().frameworkComponent(name, this.gos.get("components"));
        if (registeredViaFrameworkComp != null) return createResult(registeredViaFrameworkComp, true);
        const jsComponent = this.jsComps[name];
        if (jsComponent) {
            const isFwkComp = this.getFrameworkOverrides().isFrameworkComponent(jsComponent);
            return createResult(jsComponent, isFwkComp);
        }
        const defaultComponent = this.agGridDefaults[name];
        if (defaultComponent) return createResult(defaultComponent, false);
        const moduleForComponent = this.enterpriseAgDefaultCompsModule[name];
        if (moduleForComponent) ModuleRegistry.__assertRegistered(moduleForComponent, `AG Grid '${propertyName}' component: ${name}`, this.context.getGridId());
        else doOnce(()=>{
            this.warnAboutMissingComponent(propertyName, name);
        }, "MissingComp" + name);
        return null;
    }
    warnAboutMissingComponent(propertyName, componentName) {
        const validComponents = [
            // Don't include the old names / internals in potential suggestions
            ...Object.keys(this.agGridDefaults).filter((k)=>![
                    "agCellEditor",
                    "agGroupRowRenderer",
                    "agSortIndicator"
                ].includes(k)),
            ...Object.keys(this.jsComps)
        ];
        const suggestions = fuzzySuggestions(componentName, validComponents, true, 0.8).values;
        console.warn(`AG Grid: Could not find '${componentName}' component. It was configured as "${propertyName}: '${componentName}'" but it wasn't found in the list of registered components.`);
        if (suggestions.length > 0) console.warn(`         Did you mean: [${suggestions.slice(0, 3)}]?`);
        console.warn(`If using a custom component check it has been registered as described in: ${this.getFrameworkOverrides().getDocLink("components/")}`);
    }
};
__decorateClass([
    PostConstruct
], UserComponentRegistry.prototype, "init", 1);
UserComponentRegistry = __decorateClass([
    Bean("userComponentRegistry")
], UserComponentRegistry);
// community-modules/core/src/components/framework/componentTypes.ts
var DateComponent = {
    propertyName: "dateComponent",
    cellRenderer: false
};
var HeaderComponent = {
    propertyName: "headerComponent",
    cellRenderer: false
};
var HeaderGroupComponent = {
    propertyName: "headerGroupComponent",
    cellRenderer: false
};
var CellRendererComponent = {
    propertyName: "cellRenderer",
    cellRenderer: true
};
var LoadingCellRendererComponent = {
    propertyName: "loadingCellRenderer",
    cellRenderer: true
};
var CellEditorComponent = {
    propertyName: "cellEditor",
    cellRenderer: false
};
var InnerRendererComponent = {
    propertyName: "innerRenderer",
    cellRenderer: true
};
var LoadingOverlayComponent2 = {
    propertyName: "loadingOverlayComponent",
    cellRenderer: false
};
var NoRowsOverlayComponent2 = {
    propertyName: "noRowsOverlayComponent",
    cellRenderer: false
};
var TooltipComponent2 = {
    propertyName: "tooltipComponent",
    cellRenderer: false
};
var FilterComponent = {
    propertyName: "filter",
    cellRenderer: false
};
var FloatingFilterComponent = {
    propertyName: "floatingFilterComponent",
    cellRenderer: false
};
var ToolPanelComponent = {
    propertyName: "toolPanel",
    cellRenderer: false
};
var StatusPanelComponent = {
    propertyName: "statusPanel",
    cellRenderer: false
};
var FullWidth = {
    propertyName: "fullWidthCellRenderer",
    cellRenderer: true
};
var FullWidthLoading = {
    propertyName: "loadingCellRenderer",
    cellRenderer: true
};
var FullWidthGroup = {
    propertyName: "groupRowRenderer",
    cellRenderer: true
};
var FullWidthDetail = {
    propertyName: "detailCellRenderer",
    cellRenderer: true
};
var MenuItemComponent = {
    propertyName: "menuItem",
    cellRenderer: false
};
// community-modules/core/src/filter/floating/floatingFilterMapper.ts
var FloatingFilterMapper = class {
    static getFloatingFilterType(filterType) {
        return this.filterToFloatingFilterMapping[filterType];
    }
};
FloatingFilterMapper.filterToFloatingFilterMapping = {
    set: "agSetColumnFloatingFilter",
    agSetColumnFilter: "agSetColumnFloatingFilter",
    multi: "agMultiColumnFloatingFilter",
    agMultiColumnFilter: "agMultiColumnFloatingFilter",
    group: "agGroupColumnFloatingFilter",
    agGroupColumnFilter: "agGroupColumnFloatingFilter",
    number: "agNumberColumnFloatingFilter",
    agNumberColumnFilter: "agNumberColumnFloatingFilter",
    date: "agDateColumnFloatingFilter",
    agDateColumnFilter: "agDateColumnFloatingFilter",
    text: "agTextColumnFloatingFilter",
    agTextColumnFilter: "agTextColumnFloatingFilter"
};
// community-modules/core/src/components/framework/userComponentFactory.ts
var UserComponentFactory = class extends BeanStub {
    getHeaderCompDetails(colDef, params) {
        return this.getCompDetails(colDef, HeaderComponent, "agColumnHeader", params);
    }
    getHeaderGroupCompDetails(params) {
        const colGroupDef = params.columnGroup.getColGroupDef();
        return this.getCompDetails(colGroupDef, HeaderGroupComponent, "agColumnGroupHeader", params);
    }
    // this one is unusual, as it can be LoadingCellRenderer, DetailCellRenderer, FullWidthCellRenderer or GroupRowRenderer.
    // so we have to pass the type in.
    getFullWidthCellRendererDetails(params) {
        return this.getCompDetails(this.gridOptions, FullWidth, null, params, true);
    }
    getFullWidthLoadingCellRendererDetails(params) {
        return this.getCompDetails(this.gridOptions, FullWidthLoading, "agLoadingCellRenderer", params, true);
    }
    getFullWidthGroupCellRendererDetails(params) {
        return this.getCompDetails(this.gridOptions, FullWidthGroup, "agGroupRowRenderer", params, true);
    }
    getFullWidthDetailCellRendererDetails(params) {
        return this.getCompDetails(this.gridOptions, FullWidthDetail, "agDetailCellRenderer", params, true);
    }
    // CELL RENDERER
    getInnerRendererDetails(def, params) {
        return this.getCompDetails(def, InnerRendererComponent, null, params);
    }
    getFullWidthGroupRowInnerCellRenderer(def, params) {
        return this.getCompDetails(def, InnerRendererComponent, null, params);
    }
    getCellRendererDetails(def, params) {
        return this.getCompDetails(def, CellRendererComponent, null, params);
    }
    getLoadingCellRendererDetails(def, params) {
        return this.getCompDetails(def, LoadingCellRendererComponent, "agSkeletonCellRenderer", params, true);
    }
    // CELL EDITOR
    getCellEditorDetails(def, params) {
        return this.getCompDetails(def, CellEditorComponent, "agCellEditor", params, true);
    }
    // FILTER
    getFilterDetails(def, params, defaultFilter) {
        return this.getCompDetails(def, FilterComponent, defaultFilter, params, true);
    }
    getDateCompDetails(params) {
        return this.getCompDetails(this.gridOptions, DateComponent, "agDateInput", params, true);
    }
    getLoadingOverlayCompDetails(params) {
        return this.getCompDetails(this.gridOptions, LoadingOverlayComponent2, "agLoadingOverlay", params, true);
    }
    getNoRowsOverlayCompDetails(params) {
        return this.getCompDetails(this.gridOptions, NoRowsOverlayComponent2, "agNoRowsOverlay", params, true);
    }
    getTooltipCompDetails(params) {
        return this.getCompDetails(params.colDef, TooltipComponent2, "agTooltipComponent", params, true);
    }
    getSetFilterCellRendererDetails(def, params) {
        return this.getCompDetails(def, CellRendererComponent, null, params);
    }
    getFloatingFilterCompDetails(def, params, defaultFloatingFilter) {
        return this.getCompDetails(def, FloatingFilterComponent, defaultFloatingFilter, params);
    }
    getToolPanelCompDetails(toolPanelDef, params) {
        return this.getCompDetails(toolPanelDef, ToolPanelComponent, null, params, true);
    }
    getStatusPanelCompDetails(def, params) {
        return this.getCompDetails(def, StatusPanelComponent, null, params, true);
    }
    getMenuItemCompDetails(def, params) {
        return this.getCompDetails(def, MenuItemComponent, "agMenuItem", params, true);
    }
    getCompDetails(defObject, type, defaultName, params, mandatory = false) {
        const { propertyName, cellRenderer } = type;
        let { compName, jsComp, fwComp, paramsFromSelector, popupFromSelector, popupPositionFromSelector } = this.getCompKeys(defObject, type, params);
        const lookupFromRegistry = (key)=>{
            const item = this.userComponentRegistry.retrieve(propertyName, key);
            if (item) {
                jsComp = !item.componentFromFramework ? item.component : void 0;
                fwComp = item.componentFromFramework ? item.component : void 0;
            }
        };
        if (compName != null) lookupFromRegistry(compName);
        if (jsComp == null && fwComp == null && defaultName != null) lookupFromRegistry(defaultName);
        if (jsComp && cellRenderer && !this.agComponentUtils.doesImplementIComponent(jsComp)) jsComp = this.agComponentUtils.adaptFunction(propertyName, jsComp);
        if (!jsComp && !fwComp) {
            if (mandatory) console.error(`AG Grid: Could not find component ${compName}, did you forget to configure this component?`);
            return;
        }
        const paramsMerged = this.mergeParamsWithApplicationProvidedParams(defObject, type, params, paramsFromSelector);
        const componentFromFramework = jsComp == null;
        const componentClass = jsComp ? jsComp : fwComp;
        return {
            componentFromFramework,
            componentClass,
            params: paramsMerged,
            type,
            popupFromSelector,
            popupPositionFromSelector,
            newAgStackInstance: ()=>this.newAgStackInstance(componentClass, componentFromFramework, paramsMerged, type)
        };
    }
    getCompKeys(defObject, type, params) {
        const { propertyName } = type;
        let compName;
        let jsComp;
        let fwComp;
        let paramsFromSelector;
        let popupFromSelector;
        let popupPositionFromSelector;
        if (defObject) {
            const defObjectAny = defObject;
            const selectorFunc = defObjectAny[propertyName + "Selector"];
            const selectorRes = selectorFunc ? selectorFunc(params) : null;
            const assignComp = (providedJsComp)=>{
                if (typeof providedJsComp === "string") compName = providedJsComp;
                else if (providedJsComp != null && providedJsComp !== true) {
                    const isFwkComp = this.getFrameworkOverrides().isFrameworkComponent(providedJsComp);
                    if (isFwkComp) fwComp = providedJsComp;
                    else jsComp = providedJsComp;
                }
            };
            if (selectorRes) {
                assignComp(selectorRes.component);
                paramsFromSelector = selectorRes.params;
                popupFromSelector = selectorRes.popup;
                popupPositionFromSelector = selectorRes.popupPosition;
            } else assignComp(defObjectAny[propertyName]);
        }
        return {
            compName,
            jsComp,
            fwComp,
            paramsFromSelector,
            popupFromSelector,
            popupPositionFromSelector
        };
    }
    newAgStackInstance(ComponentClass, componentFromFramework, params, type) {
        const propertyName = type.propertyName;
        const jsComponent = !componentFromFramework;
        let instance;
        if (jsComponent) instance = new ComponentClass();
        else {
            const thisComponentConfig = this.componentMetadataProvider.retrieve(propertyName);
            instance = this.frameworkComponentWrapper.wrap(ComponentClass, thisComponentConfig.mandatoryMethodList, thisComponentConfig.optionalMethodList, type);
        }
        const deferredInit = this.initComponent(instance, params);
        if (deferredInit == null) return AgPromise.resolve(instance);
        return deferredInit.then(()=>instance);
    }
    // used by Floating Filter
    mergeParamsWithApplicationProvidedParams(defObject, type, paramsFromGrid, paramsFromSelector = null) {
        const params = this.gos.getGridCommonParams();
        mergeDeep(params, paramsFromGrid);
        const defObjectAny = defObject;
        const userParams = defObjectAny && defObjectAny[type.propertyName + "Params"];
        if (typeof userParams === "function") {
            const userParamsFromFunc = userParams(paramsFromGrid);
            mergeDeep(params, userParamsFromFunc);
        } else if (typeof userParams === "object") mergeDeep(params, userParams);
        mergeDeep(params, paramsFromSelector);
        return params;
    }
    initComponent(component, params) {
        this.context.createBean(component);
        if (component.init == null) return;
        return component.init(params);
    }
    getDefaultFloatingFilterType(def, getFromDefault) {
        if (def == null) return null;
        let defaultFloatingFilterType = null;
        let { compName, jsComp, fwComp } = this.getCompKeys(def, FilterComponent);
        if (compName) defaultFloatingFilterType = FloatingFilterMapper.getFloatingFilterType(compName);
        else {
            const usingDefaultFilter = jsComp == null && fwComp == null && def.filter === true;
            if (usingDefaultFilter) defaultFloatingFilterType = getFromDefault();
        }
        return defaultFloatingFilterType;
    }
};
__decorateClass([
    Autowired("gridOptions")
], UserComponentFactory.prototype, "gridOptions", 2);
__decorateClass([
    Autowired("agComponentUtils")
], UserComponentFactory.prototype, "agComponentUtils", 2);
__decorateClass([
    Autowired("componentMetadataProvider")
], UserComponentFactory.prototype, "componentMetadataProvider", 2);
__decorateClass([
    Autowired("userComponentRegistry")
], UserComponentFactory.prototype, "userComponentRegistry", 2);
__decorateClass([
    Optional("frameworkComponentWrapper")
], UserComponentFactory.prototype, "frameworkComponentWrapper", 2);
UserComponentFactory = __decorateClass([
    Bean("userComponentFactory")
], UserComponentFactory);
// community-modules/core/src/interfaces/iExcelCreator.ts
var ExcelFactoryMode = /* @__PURE__ */ ((ExcelFactoryMode2)=>{
    ExcelFactoryMode2[ExcelFactoryMode2["SINGLE_SHEET"] = 0] = "SINGLE_SHEET";
    ExcelFactoryMode2[ExcelFactoryMode2["MULTI_SHEET"] = 1] = "MULTI_SHEET";
    return ExcelFactoryMode2;
})(ExcelFactoryMode || {});
// community-modules/core/src/interfaces/iRowNode.ts
var RowHighlightPosition = /* @__PURE__ */ ((RowHighlightPosition2)=>{
    RowHighlightPosition2[RowHighlightPosition2["Above"] = 0] = "Above";
    RowHighlightPosition2[RowHighlightPosition2["Below"] = 1] = "Below";
    return RowHighlightPosition2;
})(RowHighlightPosition || {});
// community-modules/core/src/autoScrollService.ts
var AutoScrollService = class {
    constructor(params){
        this.tickingInterval = null;
        this.onScrollCallback = null;
        this.scrollContainer = params.scrollContainer;
        this.scrollHorizontally = params.scrollAxis.indexOf("x") !== -1;
        this.scrollVertically = params.scrollAxis.indexOf("y") !== -1;
        this.scrollByTick = params.scrollByTick != null ? params.scrollByTick : 20;
        if (params.onScrollCallback) this.onScrollCallback = params.onScrollCallback;
        if (this.scrollVertically) {
            this.getVerticalPosition = params.getVerticalPosition;
            this.setVerticalPosition = params.setVerticalPosition;
        }
        if (this.scrollHorizontally) {
            this.getHorizontalPosition = params.getHorizontalPosition;
            this.setHorizontalPosition = params.setHorizontalPosition;
        }
        this.shouldSkipVerticalScroll = params.shouldSkipVerticalScroll || (()=>false);
        this.shouldSkipHorizontalScroll = params.shouldSkipHorizontalScroll || (()=>false);
    }
    check(mouseEvent, forceSkipVerticalScroll = false) {
        const skipVerticalScroll = forceSkipVerticalScroll || this.shouldSkipVerticalScroll();
        if (skipVerticalScroll && this.shouldSkipHorizontalScroll()) return;
        const rect = this.scrollContainer.getBoundingClientRect();
        const scrollTick = this.scrollByTick;
        this.tickLeft = mouseEvent.clientX < rect.left + scrollTick;
        this.tickRight = mouseEvent.clientX > rect.right - scrollTick;
        this.tickUp = mouseEvent.clientY < rect.top + scrollTick && !skipVerticalScroll;
        this.tickDown = mouseEvent.clientY > rect.bottom - scrollTick && !skipVerticalScroll;
        if (this.tickLeft || this.tickRight || this.tickUp || this.tickDown) this.ensureTickingStarted();
        else this.ensureCleared();
    }
    ensureTickingStarted() {
        if (this.tickingInterval === null) {
            this.tickingInterval = window.setInterval(this.doTick.bind(this), 100);
            this.tickCount = 0;
        }
    }
    doTick() {
        this.tickCount++;
        let tickAmount;
        tickAmount = this.tickCount > 20 ? 200 : this.tickCount > 10 ? 80 : 40;
        if (this.scrollVertically) {
            const vScrollPosition = this.getVerticalPosition();
            if (this.tickUp) this.setVerticalPosition(vScrollPosition - tickAmount);
            if (this.tickDown) this.setVerticalPosition(vScrollPosition + tickAmount);
        }
        if (this.scrollHorizontally) {
            const hScrollPosition = this.getHorizontalPosition();
            if (this.tickLeft) this.setHorizontalPosition(hScrollPosition - tickAmount);
            if (this.tickRight) this.setHorizontalPosition(hScrollPosition + tickAmount);
        }
        if (this.onScrollCallback) this.onScrollCallback();
    }
    ensureCleared() {
        if (this.tickingInterval) {
            window.clearInterval(this.tickingInterval);
            this.tickingInterval = null;
        }
    }
};
// community-modules/core/src/gridBodyComp/rowDragFeature.ts
var RowDragFeature = class extends BeanStub {
    constructor(eContainer){
        super();
        this.eContainer = eContainer;
    }
    postConstruct() {
        if (this.gos.isRowModelType("clientSide")) this.clientSideRowModel = this.rowModel;
        this.ctrlsService.whenReady((p)=>{
            const gridBodyCon = p.gridBodyCtrl;
            this.autoScrollService = new AutoScrollService({
                scrollContainer: gridBodyCon.getBodyViewportElement(),
                scrollAxis: "y",
                getVerticalPosition: ()=>gridBodyCon.getScrollFeature().getVScrollPosition().top,
                setVerticalPosition: (position)=>gridBodyCon.getScrollFeature().setVerticalScrollPosition(position),
                onScrollCallback: ()=>{
                    this.onDragging(this.lastDraggingEvent);
                }
            });
        });
    }
    getContainer() {
        return this.eContainer;
    }
    isInterestedIn(type) {
        return type === 2 /* RowDrag */ ;
    }
    getIconName() {
        const managedDrag = this.gos.get("rowDragManaged");
        if (managedDrag && this.shouldPreventRowMove()) return DragAndDropService.ICON_NOT_ALLOWED;
        return DragAndDropService.ICON_MOVE;
    }
    shouldPreventRowMove() {
        const rowGroupCols = this.columnModel.getRowGroupColumns();
        if (rowGroupCols.length) return true;
        const isFilterPresent = this.filterManager.isAnyFilterPresent();
        if (isFilterPresent) return true;
        const isSortActive = this.sortController.isSortActive();
        if (isSortActive) return true;
        return false;
    }
    getRowNodes(draggingEvent) {
        if (!this.isFromThisGrid(draggingEvent)) return draggingEvent.dragItem.rowNodes || [];
        const currentNode = draggingEvent.dragItem.rowNode;
        const isRowDragMultiRow = this.gos.get("rowDragMultiRow");
        if (isRowDragMultiRow) {
            const selectedNodes = [
                ...this.selectionService.getSelectedNodes()
            ].sort((a, b)=>{
                if (a.rowIndex == null || b.rowIndex == null) return 0;
                return this.getRowIndexNumber(a) - this.getRowIndexNumber(b);
            });
            if (selectedNodes.indexOf(currentNode) !== -1) return selectedNodes;
        }
        return [
            currentNode
        ];
    }
    onDragEnter(draggingEvent) {
        draggingEvent.dragItem.rowNodes = this.getRowNodes(draggingEvent);
        this.dispatchGridEvent(Events.EVENT_ROW_DRAG_ENTER, draggingEvent);
        this.getRowNodes(draggingEvent).forEach((rowNode)=>{
            rowNode.setDragging(true);
        });
        this.onEnterOrDragging(draggingEvent);
    }
    onDragging(draggingEvent) {
        this.onEnterOrDragging(draggingEvent);
    }
    isFromThisGrid(draggingEvent) {
        const { dragSourceDomDataKey } = draggingEvent.dragSource;
        return dragSourceDomDataKey === this.gos.getDomDataKey();
    }
    isDropZoneWithinThisGrid(draggingEvent) {
        const gridBodyCon = this.ctrlsService.getGridBodyCtrl();
        const gridGui = gridBodyCon.getGui();
        const { dropZoneTarget } = draggingEvent;
        return !gridGui.contains(dropZoneTarget);
    }
    onEnterOrDragging(draggingEvent) {
        this.dispatchGridEvent(Events.EVENT_ROW_DRAG_MOVE, draggingEvent);
        this.lastDraggingEvent = draggingEvent;
        const pixel = this.mouseEventService.getNormalisedPosition(draggingEvent).y;
        const managedDrag = this.gos.get("rowDragManaged");
        if (managedDrag) this.doManagedDrag(draggingEvent, pixel);
        this.autoScrollService.check(draggingEvent.event);
    }
    doManagedDrag(draggingEvent, pixel) {
        const isFromThisGrid = this.isFromThisGrid(draggingEvent);
        const managedDrag = this.gos.get("rowDragManaged");
        const rowNodes = draggingEvent.dragItem.rowNodes;
        if (managedDrag && this.shouldPreventRowMove()) return;
        if (this.gos.get("suppressMoveWhenRowDragging") || !isFromThisGrid) {
            if (!this.isDropZoneWithinThisGrid(draggingEvent)) this.clientSideRowModel.highlightRowAtPixel(rowNodes[0], pixel);
        } else this.moveRows(rowNodes, pixel);
    }
    getRowIndexNumber(rowNode) {
        return parseInt(last(rowNode.getRowIndexString().split("-")), 10);
    }
    moveRowAndClearHighlight(draggingEvent) {
        const lastHighlightedRowNode = this.clientSideRowModel.getLastHighlightedRowNode();
        const isBelow = lastHighlightedRowNode && lastHighlightedRowNode.highlighted === 1 /* Below */ ;
        const pixel = this.mouseEventService.getNormalisedPosition(draggingEvent).y;
        const rowNodes = draggingEvent.dragItem.rowNodes;
        let increment = isBelow ? 1 : 0;
        if (this.isFromThisGrid(draggingEvent)) {
            rowNodes.forEach((rowNode)=>{
                if (rowNode.rowTop < pixel) increment -= 1;
            });
            this.moveRows(rowNodes, pixel, increment);
        } else {
            const getRowIdFunc = this.gos.getCallback("getRowId");
            let addIndex = this.clientSideRowModel.getRowIndexAtPixel(pixel) + 1;
            if (this.clientSideRowModel.getHighlightPosition(pixel) === 0 /* Above */ ) addIndex--;
            this.clientSideRowModel.updateRowData({
                add: rowNodes.map((node)=>node.data).filter((data)=>!this.clientSideRowModel.getRowNode(getRowIdFunc ? getRowIdFunc({
                        data,
                        level: 0
                    }) : data.id)),
                addIndex
            });
        }
        this.clearRowHighlight();
    }
    clearRowHighlight() {
        this.clientSideRowModel.highlightRowAtPixel(null);
    }
    moveRows(rowNodes, pixel, increment = 0) {
        var _a;
        const rowWasMoved = this.clientSideRowModel.ensureRowsAtPixel(rowNodes, pixel, increment);
        if (rowWasMoved) {
            this.focusService.clearFocusedCell();
            (_a = this.rangeService) == null || _a.removeAllCellRanges();
        }
    }
    addRowDropZone(params) {
        if (!params.getContainer()) {
            warnOnce("addRowDropZone - A container target needs to be provided");
            return;
        }
        if (this.dragAndDropService.findExternalZone(params)) {
            console.warn("AG Grid: addRowDropZone - target already exists in the list of DropZones. Use `removeRowDropZone` before adding it again.");
            return;
        }
        let processedParams = {
            getContainer: params.getContainer
        };
        if (params.fromGrid) processedParams = params;
        else {
            if (params.onDragEnter) processedParams.onDragEnter = (e)=>{
                params.onDragEnter(this.draggingToRowDragEvent(Events.EVENT_ROW_DRAG_ENTER, e));
            };
            if (params.onDragLeave) processedParams.onDragLeave = (e)=>{
                params.onDragLeave(this.draggingToRowDragEvent(Events.EVENT_ROW_DRAG_LEAVE, e));
            };
            if (params.onDragging) processedParams.onDragging = (e)=>{
                params.onDragging(this.draggingToRowDragEvent(Events.EVENT_ROW_DRAG_MOVE, e));
            };
            if (params.onDragStop) processedParams.onDragStop = (e)=>{
                params.onDragStop(this.draggingToRowDragEvent(Events.EVENT_ROW_DRAG_END, e));
            };
        }
        this.dragAndDropService.addDropTarget(__spreadValues({
            isInterestedIn: (type)=>type === 2 /* RowDrag */ ,
            getIconName: ()=>DragAndDropService.ICON_MOVE,
            external: true
        }, processedParams));
    }
    getRowDropZone(events) {
        const getContainer = this.getContainer.bind(this);
        const onDragEnter = this.onDragEnter.bind(this);
        const onDragLeave = this.onDragLeave.bind(this);
        const onDragging = this.onDragging.bind(this);
        const onDragStop = this.onDragStop.bind(this);
        if (!events) return {
            getContainer,
            onDragEnter,
            onDragLeave,
            onDragging,
            onDragStop,
            /* @private */ fromGrid: true
        };
        return {
            getContainer,
            onDragEnter: events.onDragEnter ? (e)=>{
                onDragEnter(e);
                events.onDragEnter(this.draggingToRowDragEvent(Events.EVENT_ROW_DRAG_ENTER, e));
            } : onDragEnter,
            onDragLeave: events.onDragLeave ? (e)=>{
                onDragLeave(e);
                events.onDragLeave(this.draggingToRowDragEvent(Events.EVENT_ROW_DRAG_LEAVE, e));
            } : onDragLeave,
            onDragging: events.onDragging ? (e)=>{
                onDragging(e);
                events.onDragging(this.draggingToRowDragEvent(Events.EVENT_ROW_DRAG_MOVE, e));
            } : onDragging,
            onDragStop: events.onDragStop ? (e)=>{
                onDragStop(e);
                events.onDragStop(this.draggingToRowDragEvent(Events.EVENT_ROW_DRAG_END, e));
            } : onDragStop,
            fromGrid: true
        };
    }
    draggingToRowDragEvent(type, draggingEvent) {
        const yNormalised = this.mouseEventService.getNormalisedPosition(draggingEvent).y;
        const mouseIsPastLastRow = yNormalised > this.paginationProxy.getCurrentPageHeight();
        let overIndex = -1;
        let overNode;
        if (!mouseIsPastLastRow) {
            overIndex = this.rowModel.getRowIndexAtPixel(yNormalised);
            overNode = this.rowModel.getRow(overIndex);
        }
        let vDirectionString;
        switch(draggingEvent.vDirection){
            case 1 /* Down */ :
                vDirectionString = "down";
                break;
            case 0 /* Up */ :
                vDirectionString = "up";
                break;
            default:
                vDirectionString = null;
                break;
        }
        const event = this.gos.addGridCommonParams({
            type,
            event: draggingEvent.event,
            node: draggingEvent.dragItem.rowNode,
            nodes: draggingEvent.dragItem.rowNodes,
            overIndex,
            overNode,
            y: yNormalised,
            vDirection: vDirectionString
        });
        return event;
    }
    dispatchGridEvent(type, draggingEvent) {
        const event = this.draggingToRowDragEvent(type, draggingEvent);
        this.eventService.dispatchEvent(event);
    }
    onDragLeave(draggingEvent) {
        this.dispatchGridEvent(Events.EVENT_ROW_DRAG_LEAVE, draggingEvent);
        this.stopDragging(draggingEvent);
        if (this.gos.get("rowDragManaged")) this.clearRowHighlight();
    }
    onDragStop(draggingEvent) {
        this.dispatchGridEvent(Events.EVENT_ROW_DRAG_END, draggingEvent);
        this.stopDragging(draggingEvent);
        if (this.gos.get("rowDragManaged") && (this.gos.get("suppressMoveWhenRowDragging") || !this.isFromThisGrid(draggingEvent)) && !this.isDropZoneWithinThisGrid(draggingEvent)) this.moveRowAndClearHighlight(draggingEvent);
    }
    stopDragging(draggingEvent) {
        this.autoScrollService.ensureCleared();
        this.getRowNodes(draggingEvent).forEach((rowNode)=>{
            rowNode.setDragging(false);
        });
    }
};
__decorateClass([
    Autowired("dragAndDropService")
], RowDragFeature.prototype, "dragAndDropService", 2);
__decorateClass([
    Autowired("rowModel")
], RowDragFeature.prototype, "rowModel", 2);
__decorateClass([
    Autowired("paginationProxy")
], RowDragFeature.prototype, "paginationProxy", 2);
__decorateClass([
    Autowired("columnModel")
], RowDragFeature.prototype, "columnModel", 2);
__decorateClass([
    Autowired("focusService")
], RowDragFeature.prototype, "focusService", 2);
__decorateClass([
    Autowired("sortController")
], RowDragFeature.prototype, "sortController", 2);
__decorateClass([
    Autowired("filterManager")
], RowDragFeature.prototype, "filterManager", 2);
__decorateClass([
    Autowired("selectionService")
], RowDragFeature.prototype, "selectionService", 2);
__decorateClass([
    Autowired("mouseEventService")
], RowDragFeature.prototype, "mouseEventService", 2);
__decorateClass([
    Autowired("ctrlsService")
], RowDragFeature.prototype, "ctrlsService", 2);
__decorateClass([
    Optional("rangeService")
], RowDragFeature.prototype, "rangeService", 2);
__decorateClass([
    PostConstruct
], RowDragFeature.prototype, "postConstruct", 1);
// community-modules/core/src/dragAndDrop/dragService.ts
var DragService = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.dragEndFunctions = [];
        this.dragSources = [];
    }
    removeAllListeners() {
        this.dragSources.forEach(this.removeListener.bind(this));
        this.dragSources.length = 0;
    }
    removeListener(dragSourceAndListener) {
        const element = dragSourceAndListener.dragSource.eElement;
        const mouseDownListener = dragSourceAndListener.mouseDownListener;
        element.removeEventListener("mousedown", mouseDownListener);
        if (dragSourceAndListener.touchEnabled) {
            const touchStartListener = dragSourceAndListener.touchStartListener;
            element.removeEventListener("touchstart", touchStartListener, {
                passive: true
            });
        }
    }
    removeDragSource(params) {
        const dragSourceAndListener = this.dragSources.find((item)=>item.dragSource === params);
        if (!dragSourceAndListener) return;
        this.removeListener(dragSourceAndListener);
        removeFromArray(this.dragSources, dragSourceAndListener);
    }
    isDragging() {
        return this.dragging;
    }
    addDragSource(params) {
        const mouseListener = this.onMouseDown.bind(this, params);
        const { eElement, includeTouch, stopPropagationForTouch } = params;
        eElement.addEventListener("mousedown", mouseListener);
        let touchListener = null;
        const suppressTouch = this.gos.get("suppressTouch");
        if (includeTouch && !suppressTouch) {
            touchListener = (touchEvent)=>{
                if (isFocusableFormField(touchEvent.target)) return;
                if (touchEvent.cancelable) {
                    touchEvent.preventDefault();
                    if (stopPropagationForTouch) touchEvent.stopPropagation();
                }
                this.onTouchStart(params, touchEvent);
            };
            eElement.addEventListener("touchstart", touchListener, {
                passive: false
            });
        }
        this.dragSources.push({
            dragSource: params,
            mouseDownListener: mouseListener,
            touchStartListener: touchListener,
            touchEnabled: !!includeTouch
        });
    }
    getStartTarget() {
        return this.startTarget;
    }
    // gets called whenever mouse down on any drag source
    onTouchStart(params, touchEvent) {
        this.currentDragParams = params;
        this.dragging = false;
        const touch = touchEvent.touches[0];
        this.touchLastTime = touch;
        this.touchStart = touch;
        const touchMoveEvent = (e)=>this.onTouchMove(e, params.eElement);
        const touchEndEvent = (e)=>this.onTouchUp(e, params.eElement);
        const documentTouchMove = (e)=>{
            if (e.cancelable) e.preventDefault();
        };
        const target = touchEvent.target;
        const events = [
            // Prevents the page document from moving while we are dragging items around.
            // preventDefault needs to be called in the touchmove listener and never inside the
            // touchstart, because using touchstart causes the click event to be cancelled on touch devices.
            {
                target: this.gos.getRootNode(),
                type: "touchmove",
                listener: documentTouchMove,
                options: {
                    passive: false
                }
            },
            {
                target,
                type: "touchmove",
                listener: touchMoveEvent,
                options: {
                    passive: true
                }
            },
            {
                target,
                type: "touchend",
                listener: touchEndEvent,
                options: {
                    passive: true
                }
            },
            {
                target,
                type: "touchcancel",
                listener: touchEndEvent,
                options: {
                    passive: true
                }
            }
        ];
        this.addTemporaryEvents(events);
        if (params.dragStartPixels === 0) this.onCommonMove(touch, this.touchStart, params.eElement);
    }
    // gets called whenever mouse down on any drag source
    onMouseDown(params, mouseEvent) {
        const e = mouseEvent;
        if (params.skipMouseEvent && params.skipMouseEvent(mouseEvent)) return;
        if (e._alreadyProcessedByDragService) return;
        e._alreadyProcessedByDragService = true;
        if (mouseEvent.button !== 0) return;
        if (this.shouldPreventMouseEvent(mouseEvent)) mouseEvent.preventDefault();
        this.currentDragParams = params;
        this.dragging = false;
        this.mouseStartEvent = mouseEvent;
        this.startTarget = mouseEvent.target;
        const mouseMoveEvent = (event)=>this.onMouseMove(event, params.eElement);
        const mouseUpEvent = (event)=>this.onMouseUp(event, params.eElement);
        const contextEvent = (event)=>event.preventDefault();
        const target = this.gos.getRootNode();
        const events = [
            {
                target,
                type: "mousemove",
                listener: mouseMoveEvent
            },
            {
                target,
                type: "mouseup",
                listener: mouseUpEvent
            },
            {
                target,
                type: "contextmenu",
                listener: contextEvent
            }
        ];
        this.addTemporaryEvents(events);
        if (params.dragStartPixels === 0) this.onMouseMove(mouseEvent, params.eElement);
    }
    addTemporaryEvents(events) {
        events.forEach((currentEvent)=>{
            const { target, type, listener, options } = currentEvent;
            target.addEventListener(type, listener, options);
        });
        this.dragEndFunctions.push(()=>{
            events.forEach((currentEvent)=>{
                const { target, type, listener, options } = currentEvent;
                target.removeEventListener(type, listener, options);
            });
        });
    }
    // returns true if the event is close to the original event by X pixels either vertically or horizontally.
    // we only start dragging after X pixels so this allows us to know if we should start dragging yet.
    isEventNearStartEvent(currentEvent, startEvent) {
        const { dragStartPixels } = this.currentDragParams;
        const requiredPixelDiff = exists(dragStartPixels) ? dragStartPixels : 4;
        return areEventsNear(currentEvent, startEvent, requiredPixelDiff);
    }
    getFirstActiveTouch(touchList) {
        for(let i = 0; i < touchList.length; i++){
            if (touchList[i].identifier === this.touchStart.identifier) return touchList[i];
        }
        return null;
    }
    onCommonMove(currentEvent, startEvent, el) {
        if (!this.dragging) {
            if (!this.dragging && this.isEventNearStartEvent(currentEvent, startEvent)) return;
            this.dragging = true;
            const event = {
                type: Events.EVENT_DRAG_STARTED,
                target: el
            };
            this.eventService.dispatchEvent(event);
            this.currentDragParams.onDragStart(startEvent);
            this.currentDragParams.onDragging(startEvent);
        }
        this.currentDragParams.onDragging(currentEvent);
    }
    onTouchMove(touchEvent, el) {
        const touch = this.getFirstActiveTouch(touchEvent.touches);
        if (!touch) return;
        this.onCommonMove(touch, this.touchStart, el);
    }
    // only gets called after a mouse down - as this is only added after mouseDown
    // and is removed when mouseUp happens
    onMouseMove(mouseEvent, el) {
        var _a;
        if (isBrowserSafari()) {
            const eDocument = this.gos.getDocument();
            (_a = eDocument.getSelection()) == null || _a.removeAllRanges();
        }
        if (this.shouldPreventMouseEvent(mouseEvent)) mouseEvent.preventDefault();
        this.onCommonMove(mouseEvent, this.mouseStartEvent, el);
    }
    shouldPreventMouseEvent(mouseEvent) {
        const isEnableCellTextSelect = this.gos.get("enableCellTextSelection");
        const isMouseMove = mouseEvent.type === "mousemove";
        return(// when `isEnableCellTextSelect` is `true`, we need to preventDefault on mouseMove
        // to avoid the grid text being selected while dragging components.
        isEnableCellTextSelect && isMouseMove && mouseEvent.cancelable && this.mouseEventService.isEventFromThisGrid(mouseEvent) && !this.isOverFormFieldElement(mouseEvent));
    }
    isOverFormFieldElement(mouseEvent) {
        const el = mouseEvent.target;
        const tagName = el == null ? void 0 : el.tagName.toLocaleLowerCase();
        return !!(tagName == null ? void 0 : tagName.match("^a$|textarea|input|select|button"));
    }
    onTouchUp(touchEvent, el) {
        let touch = this.getFirstActiveTouch(touchEvent.changedTouches);
        if (!touch) touch = this.touchLastTime;
        this.onUpCommon(touch, el);
    }
    onMouseUp(mouseEvent, el) {
        this.onUpCommon(mouseEvent, el);
    }
    onUpCommon(eventOrTouch, el) {
        if (this.dragging) {
            this.dragging = false;
            this.currentDragParams.onDragStop(eventOrTouch);
            const event = {
                type: Events.EVENT_DRAG_STOPPED,
                target: el
            };
            this.eventService.dispatchEvent(event);
        }
        this.mouseStartEvent = null;
        this.startTarget = null;
        this.touchStart = null;
        this.touchLastTime = null;
        this.currentDragParams = null;
        this.dragEndFunctions.forEach((func)=>func());
        this.dragEndFunctions.length = 0;
    }
};
__decorateClass([
    Autowired("mouseEventService")
], DragService.prototype, "mouseEventService", 2);
__decorateClass([
    PreDestroy
], DragService.prototype, "removeAllListeners", 1);
DragService = __decorateClass([
    Bean("dragService")
], DragService);
// community-modules/core/src/dragAndDrop/virtualListDragFeature.ts
var LIST_ITEM_HOVERED = "ag-list-item-hovered";
var VirtualListDragFeature = class extends BeanStub {
    constructor(comp, virtualList, params){
        super();
        this.comp = comp;
        this.virtualList = virtualList;
        this.params = params;
        this.currentDragValue = null;
        this.lastHoveredListItem = null;
    }
    postConstruct() {
        this.addManagedListener(this.params.eventSource, this.params.listItemDragStartEvent, this.listItemDragStart.bind(this));
        this.addManagedListener(this.params.eventSource, this.params.listItemDragEndEvent, this.listItemDragEnd.bind(this));
        this.createDropTarget();
        this.createAutoScrollService();
    }
    listItemDragStart(event) {
        this.currentDragValue = this.params.getCurrentDragValue(event);
        this.moveBlocked = this.params.isMoveBlocked(this.currentDragValue);
    }
    listItemDragEnd() {
        window.setTimeout(()=>{
            this.currentDragValue = null;
            this.moveBlocked = false;
        }, 10);
    }
    createDropTarget() {
        const dropTarget = {
            isInterestedIn: (type)=>type === this.params.dragSourceType,
            getIconName: ()=>this.moveBlocked ? DragAndDropService.ICON_PINNED : DragAndDropService.ICON_MOVE,
            getContainer: ()=>this.comp.getGui(),
            onDragging: (e)=>this.onDragging(e),
            onDragStop: ()=>this.onDragStop(),
            onDragLeave: ()=>this.onDragLeave()
        };
        this.dragAndDropService.addDropTarget(dropTarget);
    }
    createAutoScrollService() {
        const virtualListGui = this.virtualList.getGui();
        this.autoScrollService = new AutoScrollService({
            scrollContainer: virtualListGui,
            scrollAxis: "y",
            getVerticalPosition: ()=>virtualListGui.scrollTop,
            setVerticalPosition: (position)=>virtualListGui.scrollTop = position
        });
    }
    onDragging(e) {
        if (!this.currentDragValue || this.moveBlocked) return;
        const hoveredListItem = this.getListDragItem(e);
        const comp = this.virtualList.getComponentAt(hoveredListItem.rowIndex);
        if (!comp) return;
        const el = comp.getGui().parentElement;
        if (this.lastHoveredListItem && this.lastHoveredListItem.rowIndex === hoveredListItem.rowIndex && this.lastHoveredListItem.position === hoveredListItem.position) return;
        this.autoScrollService.check(e.event);
        this.clearHoveredItems();
        this.lastHoveredListItem = hoveredListItem;
        radioCssClass(el, LIST_ITEM_HOVERED);
        radioCssClass(el, `ag-item-highlight-${hoveredListItem.position}`);
    }
    getListDragItem(e) {
        const virtualListGui = this.virtualList.getGui();
        const paddingTop = parseFloat(window.getComputedStyle(virtualListGui).paddingTop);
        const rowHeight = this.virtualList.getRowHeight();
        const scrollTop = this.virtualList.getScrollTop();
        const rowIndex = Math.max(0, (e.y - paddingTop + scrollTop) / rowHeight);
        const maxLen = this.params.getNumRows(this.comp) - 1;
        const normalizedRowIndex = Math.min(maxLen, rowIndex) | 0;
        return {
            rowIndex: normalizedRowIndex,
            position: Math.round(rowIndex) > rowIndex || rowIndex > maxLen ? "bottom" : "top",
            component: this.virtualList.getComponentAt(normalizedRowIndex)
        };
    }
    onDragStop() {
        if (this.moveBlocked) return;
        this.params.moveItem(this.currentDragValue, this.lastHoveredListItem);
        this.clearHoveredItems();
        this.autoScrollService.ensureCleared();
    }
    onDragLeave() {
        this.clearHoveredItems();
        this.autoScrollService.ensureCleared();
    }
    clearHoveredItems() {
        const virtualListGui = this.virtualList.getGui();
        virtualListGui.querySelectorAll(`.${LIST_ITEM_HOVERED}`).forEach((el)=>{
            [
                LIST_ITEM_HOVERED,
                "ag-item-highlight-top",
                "ag-item-highlight-bottom"
            ].forEach((cls)=>{
                el.classList.remove(cls);
            });
        });
        this.lastHoveredListItem = null;
    }
};
__decorateClass([
    Autowired("dragAndDropService")
], VirtualListDragFeature.prototype, "dragAndDropService", 2);
__decorateClass([
    PostConstruct
], VirtualListDragFeature.prototype, "postConstruct", 1);
// community-modules/core/src/gridApi.ts
function unwrapUserComp(comp) {
    const compAsAny = comp;
    const isProxy = compAsAny != null && compAsAny.getFrameworkComponentInstance != null;
    return isProxy ? compAsAny.getFrameworkComponentInstance() : comp;
}
var GridApi = class {
    constructor(){
        this.detailGridInfoMap = {};
        this.destroyCalled = false;
    }
    init() {
        switch(this.rowModel.getType()){
            case "clientSide":
                this.clientSideRowModel = this.rowModel;
                break;
            case "infinite":
                this.infiniteRowModel = this.rowModel;
                break;
            case "serverSide":
                this.serverSideRowModel = this.rowModel;
                break;
        }
        this.ctrlsService.whenReady((p)=>{
            this.gridBodyCtrl = p.gridBodyCtrl;
        });
    }
    /** Used internally by grid. Not intended to be used by the client. Interface may change between releases. */ __getAlignedGridService() {
        return this.alignedGridsService;
    }
    /** Returns the `gridId` for the current grid as specified via the gridOptions property `gridId` or the auto assigned grid id if none was provided. */ getGridId() {
        return this.context.getGridId();
    }
    /** Register a detail grid with the master grid when it is created. */ addDetailGridInfo(id, gridInfo) {
        this.detailGridInfoMap[id] = gridInfo;
    }
    /** Unregister a detail grid from the master grid when it is destroyed. */ removeDetailGridInfo(id) {
        delete this.detailGridInfoMap[id];
    }
    /** Returns the `DetailGridInfo` corresponding to the supplied `detailGridId`. */ getDetailGridInfo(id) {
        return this.detailGridInfoMap[id];
    }
    /** Iterates through each `DetailGridInfo` in the grid and calls the supplied callback on each. */ forEachDetailGridInfo(callback) {
        let index = 0;
        iterateObject(this.detailGridInfoMap, (id, gridInfo)=>{
            if (exists(gridInfo)) {
                callback(gridInfo, index);
                index++;
            }
        });
    }
    /** Similar to `exportDataAsCsv`, except returns the result as a string rather than download it. */ getDataAsCsv(params) {
        if (ModuleRegistry.__assertRegistered("@ag-grid-community/csv-export" /* CsvExportModule */ , "api.getDataAsCsv", this.context.getGridId())) return this.csvCreator.getDataAsCsv(params);
    }
    /** Downloads a CSV export of the grid's data. */ exportDataAsCsv(params) {
        if (ModuleRegistry.__assertRegistered("@ag-grid-community/csv-export" /* CsvExportModule */ , "api.exportDataAsCsv", this.context.getGridId())) this.csvCreator.exportDataAsCsv(params);
    }
    assertNotExcelMultiSheet(method, params) {
        if (!ModuleRegistry.__assertRegistered("@ag-grid-enterprise/excel-export" /* ExcelExportModule */ , "api." + method, this.context.getGridId())) return false;
        if (this.excelCreator.getFactoryMode() === 1 /* MULTI_SHEET */ ) {
            console.warn("AG Grid: The Excel Exporter is currently on Multi Sheet mode. End that operation by calling 'api.getMultipleSheetAsExcel()' or 'api.exportMultipleSheetsAsExcel()'");
            return false;
        }
        return true;
    }
    /** Similar to `exportDataAsExcel`, except instead of downloading a file, it will return a [Blob](https://developer.mozilla.org/en-US/docs/Web/API/Blob) to be processed by the user. */ getDataAsExcel(params) {
        if (this.assertNotExcelMultiSheet("getDataAsExcel", params)) return this.excelCreator.getDataAsExcel(params);
    }
    /** Downloads an Excel export of the grid's data. */ exportDataAsExcel(params) {
        if (this.assertNotExcelMultiSheet("exportDataAsExcel", params)) this.excelCreator.exportDataAsExcel(params);
    }
    /** This is method to be used to get the grid's data as a sheet, that will later be exported either by `getMultipleSheetsAsExcel()` or `exportMultipleSheetsAsExcel()`. */ getSheetDataForExcel(params) {
        if (!ModuleRegistry.__assertRegistered("@ag-grid-enterprise/excel-export" /* ExcelExportModule */ , "api.getSheetDataForExcel", this.context.getGridId())) return;
        this.excelCreator.setFactoryMode(1 /* MULTI_SHEET */ );
        return this.excelCreator.getSheetDataForExcel(params);
    }
    /** Similar to `exportMultipleSheetsAsExcel`, except instead of downloading a file, it will return a [Blob](https://developer.mozilla.org/en-US/docs/Web/API/Blob) to be processed by the user. */ getMultipleSheetsAsExcel(params) {
        if (ModuleRegistry.__assertRegistered("@ag-grid-enterprise/excel-export" /* ExcelExportModule */ , "api.getMultipleSheetsAsExcel", this.context.getGridId())) return this.excelCreator.getMultipleSheetsAsExcel(params);
    }
    /** Downloads an Excel export of multiple sheets in one file. */ exportMultipleSheetsAsExcel(params) {
        if (ModuleRegistry.__assertRegistered("@ag-grid-enterprise/excel-export" /* ExcelExportModule */ , "api.exportMultipleSheetsAsExcel", this.context.getGridId())) this.excelCreator.exportMultipleSheetsAsExcel(params);
    }
    /**
   * Sets an ARIA property in the grid panel (element with `role=\"grid\"`), and removes an ARIA property when the value is null.
   *
   * Example: `api.setGridAriaProperty('label', 'my grid')` will set `aria-label=\"my grid\"`.
   *
   * `api.setGridAriaProperty('label', null)` will remove the `aria-label` attribute from the grid element.
   */ setGridAriaProperty(property, value) {
        if (!property) return;
        const eGrid = this.ctrlsService.getGridBodyCtrl().getGui();
        const ariaProperty = `aria-${property}`;
        if (value === null) eGrid.removeAttribute(ariaProperty);
        else eGrid.setAttribute(ariaProperty, value);
    }
    logMissingRowModel(apiMethod, ...requiredRowModels) {
        console.error(`AG Grid: api.${apiMethod} can only be called when gridOptions.rowModelType is ${requiredRowModels.join(" or ")}`);
    }
    logDeprecation(version, apiMethod, replacement, message) {
        warnOnce(`Since ${version} api.${apiMethod} is deprecated. Please use ${replacement} instead. ${message != null ? message : ""}`);
    }
    /** Gets the number of top pinned rows. */ getPinnedTopRowCount() {
        return this.pinnedRowModel.getPinnedTopRowCount();
    }
    /** Gets the number of bottom pinned rows. */ getPinnedBottomRowCount() {
        return this.pinnedRowModel.getPinnedBottomRowCount();
    }
    /** Gets the top pinned row with the specified index. */ getPinnedTopRow(index) {
        return this.pinnedRowModel.getPinnedTopRow(index);
    }
    /** Gets the bottom pinned row with the specified index. */ getPinnedBottomRow(index) {
        return this.pinnedRowModel.getPinnedBottomRow(index);
    }
    expireValueCache() {
        this.valueCache.expire();
    }
    /**
   * Returns an object with two properties:
   *  - `top`: The top pixel position of the current scroll in the grid
   *  - `bottom`: The bottom pixel position of the current scroll in the grid
   */ getVerticalPixelRange() {
        return this.gridBodyCtrl.getScrollFeature().getVScrollPosition();
    }
    /**
   * Returns an object with two properties:
   * - `left`: The left pixel position of the current scroll in the grid
   * - `right`: The right pixel position of the current scroll in the grid
   */ getHorizontalPixelRange() {
        return this.gridBodyCtrl.getScrollFeature().getHScrollPosition();
    }
    /** Performs change detection on all cells, refreshing cells where required. */ refreshCells(params = {}) {
        this.frameworkOverrides.wrapIncoming(()=>this.rowRenderer.refreshCells(params));
    }
    /** Flash rows, columns or individual cells. */ flashCells(params = {}) {
        const warning = (prop)=>warnOnce(`Since v31.1 api.flashCells parameter '${prop}Delay' is deprecated. Please use '${prop}Duration' instead.`);
        if (exists(params.fadeDelay)) warning("fade");
        if (exists(params.flashDelay)) warning("flash");
        this.frameworkOverrides.wrapIncoming(()=>this.rowRenderer.flashCells(params));
    }
    /** Remove row(s) from the DOM and recreate them again from scratch. */ redrawRows(params = {}) {
        const rowNodes = params ? params.rowNodes : void 0;
        this.frameworkOverrides.wrapIncoming(()=>this.rowRenderer.redrawRows(rowNodes));
    }
    /** Redraws the header. Useful if a column name changes, or something else that changes how the column header is displayed. */ refreshHeader() {
        this.frameworkOverrides.wrapIncoming(()=>this.ctrlsService.getHeaderRowContainerCtrls().forEach((c)=>c.refresh()));
    }
    /** Returns `true` if any filter is set. This includes quick filter, column filter, external filter or advanced filter. */ isAnyFilterPresent() {
        return this.filterManager.isAnyFilterPresent();
    }
    /** Returns `true` if any column filter is set, otherwise `false`. */ isColumnFilterPresent() {
        return this.filterManager.isColumnFilterPresent() || this.filterManager.isAggregateFilterPresent();
    }
    /** Returns `true` if the Quick Filter is set, otherwise `false`. */ isQuickFilterPresent() {
        return this.filterManager.isQuickFilterPresent();
    }
    /**
   * Returns the row model inside the table.
   * From here you can see the original rows, rows after filter has been applied,
   * rows after aggregation has been applied, and the final set of 'to be displayed' rows.
   *
   * @deprecated As of v31.1, getModel() is deprecated and will not be available in future versions.
   * Please use the appropriate grid API methods instead
   */ getModel() {
        warnOnce("Since v31.1 getModel() is deprecated. Please use the appropriate grid API methods instead.");
        return this.rowModel;
    }
    /** 
   * Expand or collapse a specific row node, optionally expanding/collapsing all of its parent nodes.
   * By default rows are expanded asynchronously for best performance. Set forceSync: `true` if you need to interact with the expanded row immediately after this function.
   */ setRowNodeExpanded(rowNode, expanded, expandParents, forceSync) {
        this.expansionService.setRowNodeExpanded(rowNode, expanded, expandParents, forceSync);
    }
    /**
   * Informs the grid that row group expanded state has changed and it needs to rerender the group nodes.
   * Typically called after updating the row node expanded state explicitly, i.e `rowNode.expanded = false`,
   * across multiple groups and you want to update the grid view in a single rerender instead of on every group change.
   */ onGroupExpandedOrCollapsed() {
        if (missing(this.clientSideRowModel)) {
            this.logMissingRowModel("onGroupExpandedOrCollapsed", "clientSide");
            return;
        }
        this.expansionService.onGroupExpandedOrCollapsed();
    }
    /**
   * Refresh the Client-Side Row Model, executing the grouping, filtering and sorting again.
   * Optionally provide the step you wish the refresh to apply from. Defaults to `everything`.
   */ refreshClientSideRowModel(step) {
        if (missing(this.clientSideRowModel)) {
            this.logMissingRowModel("refreshClientSideRowModel", "clientSide");
            return;
        }
        this.clientSideRowModel.refreshModel(step);
    }
    /** Returns `true` when there are no more animation frames left to process. */ isAnimationFrameQueueEmpty() {
        return this.animationFrameService.isQueueEmpty();
    }
    flushAllAnimationFrames() {
        this.animationFrameService.flushAllFrames();
    }
    /**
   * Returns the row node with the given ID.
   * The row node ID is the one you provide from the callback `getRowId(params)`,
   * otherwise the ID is a number (cast as string) auto-generated by the grid when
   * the row data is set.
   */ getRowNode(id) {
        return this.rowModel.getRowNode(id);
    }
    /**
   * Gets the sizes that various UI elements will be rendered at with the current theme.
   * If you override the row or header height using `gridOptions`, the override value you provided will be returned.
   */ getSizesForCurrentTheme() {
        return {
            rowHeight: this.gos.getRowHeightAsNumber(),
            headerHeight: this.columnModel.getHeaderHeight()
        };
    }
    /** Expand all groups. */ expandAll() {
        if (this.clientSideRowModel || this.serverSideRowModel) this.expansionService.expandAll(true);
        else this.logMissingRowModel("expandAll", "clientSide", "serverSide");
    }
    /** Collapse all groups. */ collapseAll() {
        if (this.clientSideRowModel || this.serverSideRowModel) this.expansionService.expandAll(false);
        else this.logMissingRowModel("collapseAll", "clientSide", "serverSide");
    }
    /**
   * Registers a callback to a virtual row.
   * A virtual row is a row that is visually rendered on the screen (rows that are not visible because of the scroll position are not rendered).
   * Unlike normal events, you do not need to unregister rendered row listeners.
   * When the rendered row is removed from the grid, all associated rendered row listeners will also be removed.
   * listen for this event if your `cellRenderer` needs to do cleanup when the row no longer exists.
   */ addRenderedRowListener(eventName, rowIndex, callback) {
        this.rowRenderer.addRenderedRowListener(eventName, rowIndex, callback);
    }
    /** Get the current Quick Filter text from the grid, or `undefined` if none is set. */ getQuickFilter() {
        return this.gos.get("quickFilterText");
    }
    /** Get the state of the Advanced Filter. Used for saving Advanced Filter state */ getAdvancedFilterModel() {
        if (ModuleRegistry.__assertRegistered("@ag-grid-enterprise/advanced-filter" /* AdvancedFilterModule */ , "api.getAdvancedFilterModel", this.context.getGridId())) return this.filterManager.getAdvancedFilterModel();
        return null;
    }
    /** Set the state of the Advanced Filter. Used for restoring Advanced Filter state */ setAdvancedFilterModel(advancedFilterModel) {
        this.filterManager.setAdvancedFilterModel(advancedFilterModel);
    }
    /** Open the Advanced Filter Builder dialog (if enabled). */ showAdvancedFilterBuilder() {
        if (ModuleRegistry.__assertRegistered("@ag-grid-enterprise/advanced-filter" /* AdvancedFilterModule */ , "api.setAdvancedFilterModel", this.context.getGridId())) this.filterManager.showAdvancedFilterBuilder("api");
    }
    /**
   * Set all of the provided nodes selection state to the provided value.
   */ setNodesSelected(params) {
        const allNodesValid = params.nodes.every((node)=>{
            if (node.rowPinned) {
                console.warn("AG Grid: cannot select pinned rows");
                return false;
            }
            if (node.id === void 0) {
                console.warn("AG Grid: cannot select node until id for node is known");
                return false;
            }
            return true;
        });
        if (!allNodesValid) return;
        const { nodes, source, newValue } = params;
        const nodesAsRowNode = nodes;
        this.selectionService.setNodesSelected({
            nodes: nodesAsRowNode,
            source: source != null ? source : "api",
            newValue
        });
    }
    /**
   * Select all rows, regardless of filtering and rows that are not visible due to grouping being enabled and their groups not expanded.
   * @param source Source property that will appear in the `selectionChanged` event, defaults to `'apiSelectAll'`
   */ selectAll(source = "apiSelectAll") {
        this.selectionService.selectAllRowNodes({
            source
        });
    }
    /**
   * Clear all row selections, regardless of filtering.
   * @param source Source property that will appear in the `selectionChanged` event, defaults to `'apiSelectAll'`
   */ deselectAll(source = "apiSelectAll") {
        this.selectionService.deselectAllRowNodes({
            source
        });
    }
    /**
   * Select all filtered rows.
   * @param source Source property that will appear in the `selectionChanged` event, defaults to `'apiSelectAllFiltered'`
   */ selectAllFiltered(source = "apiSelectAllFiltered") {
        this.selectionService.selectAllRowNodes({
            source,
            justFiltered: true
        });
    }
    /**
   * Clear all filtered selections.
   * @param source Source property that will appear in the `selectionChanged` event, defaults to `'apiSelectAllFiltered'`
   */ deselectAllFiltered(source = "apiSelectAllFiltered") {
        this.selectionService.deselectAllRowNodes({
            source,
            justFiltered: true
        });
    }
    /**
   * Returns an object containing rules matching the selected rows in the SSRM.
   * 
   * If `groupSelectsChildren=false` the returned object will be flat, and will conform to IServerSideSelectionState.
   * If `groupSelectsChildren=true` the returned object will be hierarchical, and will conform to IServerSideGroupSelectionState.
   */ getServerSideSelectionState() {
        if (missing(this.serverSideRowModel)) {
            this.logMissingRowModel("getServerSideSelectionState", "serverSide");
            return null;
        }
        return this.selectionService.getSelectionState();
    }
    /**
   * Set the rules matching the selected rows in the SSRM.
   * 
   * If `groupSelectsChildren=false` the param will be flat, and should conform to IServerSideSelectionState.
   * If `groupSelectsChildren=true` the param will be hierarchical, and should conform to IServerSideGroupSelectionState.
   */ setServerSideSelectionState(state) {
        if (missing(this.serverSideRowModel)) {
            this.logMissingRowModel("setServerSideSelectionState", "serverSide");
            return;
        }
        this.selectionService.setSelectionState(state, "api");
    }
    /**
   * Select all rows on the current page.
   * @param source Source property that will appear in the `selectionChanged` event, defaults to `'apiSelectAllCurrentPage'`
   */ selectAllOnCurrentPage(source = "apiSelectAllCurrentPage") {
        this.selectionService.selectAllRowNodes({
            source,
            justCurrentPage: true
        });
    }
    /**
   * Clear all filtered on the current page.
   * @param source Source property that will appear in the `selectionChanged` event, defaults to `'apiSelectAllCurrentPage'`
   */ deselectAllOnCurrentPage(source = "apiSelectAllCurrentPage") {
        this.selectionService.deselectAllRowNodes({
            source,
            justCurrentPage: true
        });
    }
    /** Show the 'loading' overlay. */ showLoadingOverlay() {
        this.overlayService.showLoadingOverlay();
    }
    /** Show the 'no rows' overlay. */ showNoRowsOverlay() {
        this.overlayService.showNoRowsOverlay();
    }
    /** Hides the overlay if showing. */ hideOverlay() {
        this.overlayService.hideOverlay();
    }
    /**
   * Returns an unsorted list of selected nodes.
   * Getting the underlying node (rather than the data) is useful when working with tree / aggregated data,
   * as the node can be traversed.
   */ getSelectedNodes() {
        return this.selectionService.getSelectedNodes();
    }
    /** Returns an unsorted list of selected rows (i.e. row data that you provided). */ getSelectedRows() {
        return this.selectionService.getSelectedRows();
    }
    /**
   * Returns a list of all selected nodes at 'best cost', a feature to be used with groups / trees.
   * If a group has all its children selected, then the group appears in the result, but not the children.
   * Designed for use with `'children'` as the group selection type, where groups don't actually appear in the selection normally.
   */ getBestCostNodeSelection() {
        if (missing(this.clientSideRowModel)) {
            this.logMissingRowModel("getBestCostNodeSelection", "clientSide");
            return;
        }
        return this.selectionService.getBestCostNodeSelection();
    }
    /** Retrieve rendered nodes. Due to virtualisation this will contain only the current visible rows and those in the buffer. */ getRenderedNodes() {
        return this.rowRenderer.getRenderedNodes();
    }
    /**
   *  Ensures the column is visible by scrolling the table if needed.
   *
   * This will have no effect before the firstDataRendered event has fired.
   *
   * @param key - The column to ensure visible
   * @param position - Where the column will be positioned.
   * - `auto` - Scrolls the minimum amount to make sure the column is visible.
   * - `start` - Scrolls the column to the start of the viewport.
   * - `middle` - Scrolls the column to the middle of the viewport.
   * - `end` - Scrolls the column to the end of the viewport.
  */ ensureColumnVisible(key, position = "auto") {
        this.frameworkOverrides.wrapIncoming(()=>this.gridBodyCtrl.getScrollFeature().ensureColumnVisible(key, position), "ensureVisible");
    }
    /**
   * Vertically scrolls the grid until the provided row index is inside the visible viewport.
   * If a position is provided, the grid will attempt to scroll until the row is at the given position within the viewport.
   * This will have no effect before the firstDataRendered event has fired.
   */ ensureIndexVisible(index, position) {
        this.frameworkOverrides.wrapIncoming(()=>this.gridBodyCtrl.getScrollFeature().ensureIndexVisible(index, position), "ensureVisible");
    }
    /**
   * Vertically scrolls the grid until the provided row (or a row matching the provided comparator) is inside the visible viewport.
   * If a position is provided, the grid will attempt to scroll until the row is at the given position within the viewport.
   * This will have no effect before the firstDataRendered event has fired.
   */ ensureNodeVisible(nodeSelector, position = null) {
        this.frameworkOverrides.wrapIncoming(()=>this.gridBodyCtrl.getScrollFeature().ensureNodeVisible(nodeSelector, position), "ensureVisible");
    }
    /**
   * Similar to `forEachNode`, except lists all the leaf nodes.
   * This effectively goes through all the data that you provided to the grid before the grid performed any grouping.
   * If using tree data, goes through all the nodes for the data you provided, including nodes that have children,
   * but excluding groups the grid created where gaps were missing in the hierarchy.
   */ forEachLeafNode(callback) {
        if (missing(this.clientSideRowModel)) {
            this.logMissingRowModel("forEachLeafNode", "clientSide");
            return;
        }
        this.clientSideRowModel.forEachLeafNode(callback);
    }
    /**
   * Iterates through each node (row) in the grid and calls the callback for each node.
   * This works similar to the `forEach` method on a JavaScript array.
   * This is called for every node, ignoring any filtering or sorting applied within the grid.
   * If using the Infinite Row Model, then this gets called for each page loaded in the page cache.
   */ forEachNode(callback, includeFooterNodes) {
        this.rowModel.forEachNode(callback, includeFooterNodes);
    }
    /** Similar to `forEachNode`, except skips any filtered out data. */ forEachNodeAfterFilter(callback) {
        if (missing(this.clientSideRowModel)) {
            this.logMissingRowModel("forEachNodeAfterFilter", "clientSide");
            return;
        }
        this.clientSideRowModel.forEachNodeAfterFilter(callback);
    }
    /** Similar to `forEachNodeAfterFilter`, except the callbacks are called in the order the rows are displayed in the grid. */ forEachNodeAfterFilterAndSort(callback) {
        if (missing(this.clientSideRowModel)) {
            this.logMissingRowModel("forEachNodeAfterFilterAndSort", "clientSide");
            return;
        }
        this.clientSideRowModel.forEachNodeAfterFilterAndSort(callback);
    }
    /**
   * @deprecated v31.1 To get/set individual filter models, use `getColumnFilterModel` or `setColumnFilterModel` instead.
   * To get hold of the filter instance, use `getColumnFilterInstance` which returns the instance asynchronously.
   */ getFilterInstance(key, callback) {
        warnOnce(`'getFilterInstance' is deprecated. To get/set individual filter models, use 'getColumnFilterModel' or 'setColumnFilterModel' instead. To get hold of the filter instance, use 'getColumnFilterInstance' which returns the instance asynchronously.`);
        return this.filterManager.getFilterInstance(key, callback);
    }
    /**
   * Returns the filter component instance for a column.
   * For getting/setting models for individual column filters, use `getColumnFilterModel` and `setColumnFilterModel` instead of this.
   * `key` can be a column ID or a `Column` object.
   */ getColumnFilterInstance(key) {
        return this.filterManager.getColumnFilterInstance(key);
    }
    /** Destroys a filter. Useful to force a particular filter to be created from scratch again. */ destroyFilter(key) {
        const column = this.columnModel.getPrimaryColumn(key);
        if (column) return this.filterManager.destroyFilter(column, "api");
    }
    /** Gets the status panel instance corresponding to the supplied `id`. */ getStatusPanel(key) {
        if (!ModuleRegistry.__assertRegistered("@ag-grid-enterprise/status-bar" /* StatusBarModule */ , "api.getStatusPanel", this.context.getGridId())) return;
        const comp = this.statusBarService.getStatusPanel(key);
        return unwrapUserComp(comp);
    }
    getColumnDef(key) {
        const column = this.columnModel.getPrimaryColumn(key);
        if (column) return column.getColDef();
        return null;
    }
    /**
   * Returns the current column definitions.
  */ getColumnDefs() {
        return this.columnModel.getColumnDefs();
    }
    /**
   * Informs the grid that a filter has changed. This is typically called after a filter change through one of the filter APIs.
   * @param source The source of the filter change event. If not specified defaults to `'api'`.
   */ onFilterChanged(source = "api") {
        this.filterManager.onFilterChanged({
            source
        });
    }
    /**
   * Gets the grid to act as if the sort was changed.
   * Useful if you update some values and want to get the grid to reorder them according to the new values.
   */ onSortChanged() {
        this.sortController.onSortChanged("api");
    }
    /**
   * Sets the state of all the column filters. Provide it with what you get from `getFilterModel()` to restore filter state.
   * If inferring cell data types, and row data is provided asynchronously and is yet to be set,
   * the filter model will be applied asynchronously after row data is added.
   * To always perform this synchronously, set `cellDataType = false` on the default column definition,
   * or provide cell data types for every column.
   */ setFilterModel(model) {
        this.frameworkOverrides.wrapIncoming(()=>this.filterManager.setFilterModel(model));
    }
    /** Gets the current state of all the column filters. Used for saving filter state. */ getFilterModel() {
        return this.filterManager.getFilterModel();
    }
    /**
   * Gets the current filter model for the specified column.
   * Will return `null` if no active filter.
   */ getColumnFilterModel(column) {
        return this.filterManager.getColumnFilterModel(column);
    }
    /**
   * Sets the filter model for the specified column.
   * Setting a `model` of `null` will reset the filter (make inactive).
   * Must wait on the response before calling `api.onFilterChanged()`.
   */ setColumnFilterModel(column, model) {
        return this.filterManager.setColumnFilterModel(column, model);
    }
    /** Returns the focused cell (or the last focused cell if the grid lost focus). */ getFocusedCell() {
        return this.focusService.getFocusedCell();
    }
    /** Clears the focused cell. */ clearFocusedCell() {
        return this.focusService.clearFocusedCell();
    }
    /** Sets the focus to the specified cell. `rowPinned` can be either 'top', 'bottom' or null (for not pinned). */ setFocusedCell(rowIndex, colKey, rowPinned) {
        this.focusService.setFocusedCell({
            rowIndex,
            column: colKey,
            rowPinned,
            forceBrowserFocus: true
        });
    }
    /** Adds a drop zone outside of the grid where rows can be dropped. */ addRowDropZone(params) {
        this.gridBodyCtrl.getRowDragFeature().addRowDropZone(params);
    }
    /** Removes an external drop zone added by `addRowDropZone`. */ removeRowDropZone(params) {
        const activeDropTarget = this.dragAndDropService.findExternalZone(params);
        if (activeDropTarget) this.dragAndDropService.removeDropTarget(activeDropTarget);
    }
    /** Returns the `RowDropZoneParams` to be used by another grid's `addRowDropZone` method. */ getRowDropZoneParams(events) {
        return this.gridBodyCtrl.getRowDragFeature().getRowDropZone(events);
    }
    assertSideBarLoaded(apiMethod) {
        return ModuleRegistry.__assertRegistered("@ag-grid-enterprise/side-bar" /* SideBarModule */ , "api." + apiMethod, this.context.getGridId());
    }
    /** Returns `true` if the side bar is visible. */ isSideBarVisible() {
        return this.assertSideBarLoaded("isSideBarVisible") && this.sideBarService.getSideBarComp().isDisplayed();
    }
    /** Show/hide the entire side bar, including any visible panel and the tab buttons. */ setSideBarVisible(show) {
        if (this.assertSideBarLoaded("setSideBarVisible")) this.sideBarService.getSideBarComp().setDisplayed(show);
    }
    /** Sets the side bar position relative to the grid. Possible values are `'left'` or `'right'`. */ setSideBarPosition(position) {
        if (this.assertSideBarLoaded("setSideBarPosition")) this.sideBarService.getSideBarComp().setSideBarPosition(position);
    }
    /** Opens a particular tool panel. Provide the ID of the tool panel to open. */ openToolPanel(key) {
        if (this.assertSideBarLoaded("openToolPanel")) this.sideBarService.getSideBarComp().openToolPanel(key, "api");
    }
    /** Closes the currently open tool panel (if any). */ closeToolPanel() {
        if (this.assertSideBarLoaded("closeToolPanel")) this.sideBarService.getSideBarComp().close("api");
    }
    /** Returns the ID of the currently shown tool panel if any, otherwise `null`. */ getOpenedToolPanel() {
        if (this.assertSideBarLoaded("getOpenedToolPanel")) return this.sideBarService.getSideBarComp().openedItem();
        return null;
    }
    /** Force refresh all tool panels by calling their `refresh` method. */ refreshToolPanel() {
        if (this.assertSideBarLoaded("refreshToolPanel")) this.sideBarService.getSideBarComp().refresh();
    }
    /** Returns `true` if the tool panel is showing, otherwise `false`. */ isToolPanelShowing() {
        return this.assertSideBarLoaded("isToolPanelShowing") && this.sideBarService.getSideBarComp().isToolPanelShowing();
    }
    /** Gets the tool panel instance corresponding to the supplied `id`. */ getToolPanelInstance(id) {
        if (this.assertSideBarLoaded("getToolPanelInstance")) {
            const comp = this.sideBarService.getSideBarComp().getToolPanelInstance(id);
            return unwrapUserComp(comp);
        }
    }
    /** Returns the current side bar configuration. If a shortcut was used, returns the detailed long form. */ getSideBar() {
        if (this.assertSideBarLoaded("getSideBar")) return this.sideBarService.getSideBarComp().getDef();
        return void 0;
    }
    /** Tells the grid to recalculate the row heights. */ resetRowHeights() {
        if (exists(this.clientSideRowModel)) {
            if (this.columnModel.isAutoRowHeightActive()) {
                console.warn("AG Grid: calling gridApi.resetRowHeights() makes no sense when using Auto Row Height.");
                return;
            }
            this.clientSideRowModel.resetRowHeights();
        }
    }
    /**
   * Sets the `rowCount` and `maxRowFound` properties.
   * The second parameter, `maxRowFound`, is optional and if left out, only `rowCount` is set.
   * Set `rowCount` to adjust the height of the vertical scroll.
   * Set `maxRowFound` to enable / disable searching for more rows.
   * Use this method if you add or remove rows into the dataset and need to reset the number of rows or instruct the grid that the entire row count is no longer known.
   */ setRowCount(rowCount, maxRowFound) {
        if (this.serverSideRowModel) {
            if (this.columnModel.isRowGroupEmpty()) {
                this.serverSideRowModel.setRowCount(rowCount, maxRowFound);
                return;
            }
            console.error("AG Grid: setRowCount cannot be used while using row grouping.");
            return;
        }
        if (this.infiniteRowModel) {
            this.infiniteRowModel.setRowCount(rowCount, maxRowFound);
            return;
        }
        this.logMissingRowModel("setRowCount", "infinite", "serverSide");
    }
    /** Tells the grid a row height has changed. To be used after calling `rowNode.setRowHeight(newHeight)`. */ onRowHeightChanged() {
        if (this.clientSideRowModel) this.clientSideRowModel.onRowHeightChanged();
        else if (this.serverSideRowModel) this.serverSideRowModel.onRowHeightChanged();
    }
    /**
   * @deprecated v31.3 Use `getCellValue` instead.
   */ getValue(colKey, rowNode) {
        this.logDeprecation("31.3", "getValue", "getCellValue");
        return this.getCellValue({
            colKey,
            rowNode
        });
    }
    getCellValue(params) {
        var _a;
        const { colKey, rowNode, useFormatter } = params;
        let column = (_a = this.columnModel.getPrimaryColumn(colKey)) != null ? _a : this.columnModel.getGridColumn(colKey);
        if (missing(column)) return null;
        const value = this.valueService.getValue(column, rowNode);
        if (useFormatter) {
            const formattedValue = this.valueService.formatValue(column, rowNode, value);
            return formattedValue != null ? formattedValue : escapeString(value, true);
        }
        return value;
    }
    /**
   * Add an event listener for the specified `eventType`.
   * Works similar to `addEventListener` for a browser DOM element.
   * Listeners will be automatically removed when the grid is destroyed.
   */ addEventListener(eventType, listener) {
        this.apiEventService.addEventListener(eventType, listener);
    }
    /**
   * Add an event listener for all event types coming from the grid.
   * Listeners will be automatically removed when the grid is destroyed.
   */ addGlobalListener(listener) {
        this.apiEventService.addGlobalListener(listener);
    }
    /** Remove an event listener. */ removeEventListener(eventType, listener) {
        this.apiEventService.removeEventListener(eventType, listener);
    }
    /** Remove a global event listener. */ removeGlobalListener(listener) {
        this.apiEventService.removeGlobalListener(listener);
    }
    dispatchEvent(event) {
        this.eventService.dispatchEvent(event);
    }
    /** Will destroy the grid and release resources. If you are using a framework you do not need to call this, as the grid links in with the framework lifecycle. However if you are using Web Components or native JavaScript, you do need to call this, to avoid a memory leak in your application. */ destroy() {
        var _a;
        const preDestroyLink = `See ${this.frameworkOverrides.getDocLink("grid-lifecycle/#grid-pre-destroyed")}`;
        if (this.destroyCalled) return;
        const event = {
            type: Events.EVENT_GRID_PRE_DESTROYED,
            state: this.getState()
        };
        this.dispatchEvent(event);
        this.destroyCalled = true;
        (_a = this.ctrlsService.get("gridCtrl")) == null || _a.destroyGridUi();
        this.context.destroy();
        this.detailGridInfoMap = {};
        removeAllReferences(this, [
            "isDestroyed"
        ], preDestroyLink);
    }
    /** Returns `true` if the grid has been destroyed. */ isDestroyed() {
        return this.destroyCalled;
    }
    /** Reset the Quick Filter cache text on every rowNode. */ resetQuickFilter() {
        this.filterManager.resetQuickFilterCache();
    }
    /** Returns the list of selected cell ranges. */ getCellRanges() {
        if (this.rangeService) return this.rangeService.getCellRanges();
        ModuleRegistry.__assertRegistered("@ag-grid-enterprise/range-selection" /* RangeSelectionModule */ , "api.getCellRanges", this.context.getGridId());
        return null;
    }
    /** Adds the provided cell range to the selected ranges. */ addCellRange(params) {
        if (this.rangeService) {
            this.rangeService.addCellRange(params);
            return;
        }
        ModuleRegistry.__assertRegistered("@ag-grid-enterprise/range-selection" /* RangeSelectionModule */ , "api.addCellRange", this.context.getGridId());
    }
    /** Clears the selected ranges. */ clearRangeSelection() {
        if (this.rangeService) this.rangeService.removeAllCellRanges();
        ModuleRegistry.__assertRegistered("@ag-grid-enterprise/range-selection" /* RangeSelectionModule */ , "gridApi.clearRangeSelection", this.context.getGridId());
    }
    /** Reverts the last cell edit. */ undoCellEditing() {
        this.undoRedoService.undo("api");
    }
    /** Re-applies the most recently undone cell edit. */ redoCellEditing() {
        this.undoRedoService.redo("api");
    }
    /** Returns current number of available cell edit undo operations. */ getCurrentUndoSize() {
        return this.undoRedoService.getCurrentUndoStackSize();
    }
    /** Returns current number of available cell edit redo operations. */ getCurrentRedoSize() {
        return this.undoRedoService.getCurrentRedoStackSize();
    }
    assertChart(methodName, func) {
        if (ModuleRegistry.__assertRegistered("@ag-grid-enterprise/charts" /* GridChartsModule */ , "api." + methodName, this.context.getGridId())) return this.frameworkOverrides.wrapIncoming(()=>func());
    }
    /** Returns a list of models with information about the charts that are currently rendered from the grid. */ getChartModels() {
        return this.assertChart("getChartModels", ()=>this.chartService.getChartModels());
    }
    /** Returns the `ChartRef` using the supplied `chartId`. */ getChartRef(chartId) {
        return this.assertChart("getChartRef", ()=>this.chartService.getChartRef(chartId));
    }
    /** Returns a base64-encoded image data URL for the referenced chartId. */ getChartImageDataURL(params) {
        return this.assertChart("getChartImageDataURL", ()=>this.chartService.getChartImageDataURL(params));
    }
    /** Starts a browser-based image download for the referenced chartId. */ downloadChart(params) {
        return this.assertChart("downloadChart", ()=>this.chartService.downloadChart(params));
    }
    /** Open the Chart Tool Panel. */ openChartToolPanel(params) {
        return this.assertChart("openChartToolPanel", ()=>this.chartService.openChartToolPanel(params));
    }
    /** Close the Chart Tool Panel. */ closeChartToolPanel(params) {
        return this.assertChart("closeChartToolPanel", ()=>this.chartService.closeChartToolPanel(params.chartId));
    }
    /** Used to programmatically create charts from a range. */ createRangeChart(params) {
        return this.assertChart("createRangeChart", ()=>this.chartService.createRangeChart(params));
    }
    /** Used to programmatically create pivot charts from a grid. */ createPivotChart(params) {
        return this.assertChart("createPivotChart", ()=>this.chartService.createPivotChart(params));
    }
    /** Used to programmatically create cross filter charts from a range. */ createCrossFilterChart(params) {
        return this.assertChart("createCrossFilterChart", ()=>this.chartService.createCrossFilterChart(params));
    }
    /** Used to programmatically update a chart. */ updateChart(params) {
        return this.assertChart("updateChart", ()=>this.chartService.updateChart(params));
    }
    /** Restores a chart using the `ChartModel` that was previously obtained from `getChartModels()`. */ restoreChart(chartModel, chartContainer) {
        return this.assertChart("restoreChart", ()=>this.chartService.restoreChart(chartModel, chartContainer));
    }
    assertClipboard(methodName, func) {
        if (ModuleRegistry.__assertRegistered("@ag-grid-enterprise/clipboard" /* ClipboardModule */ , "api" + methodName, this.context.getGridId())) func();
    }
    /** Copies data to clipboard by following the same rules as pressing Ctrl+C. */ copyToClipboard(params) {
        this.assertClipboard("copyToClipboard", ()=>this.clipboardService.copyToClipboard(params));
    }
    /** Cuts data to clipboard by following the same rules as pressing Ctrl+X. */ cutToClipboard(params) {
        this.assertClipboard("cutToClipboard", ()=>this.clipboardService.cutToClipboard(params));
    }
    /** Copies the selected rows to the clipboard. */ copySelectedRowsToClipboard(params) {
        this.assertClipboard("copySelectedRowsToClipboard", ()=>this.clipboardService.copySelectedRowsToClipboard(params));
    }
    /** Copies the selected ranges to the clipboard. */ copySelectedRangeToClipboard(params) {
        this.assertClipboard("copySelectedRangeToClipboard", ()=>this.clipboardService.copySelectedRangeToClipboard(params));
    }
    /** Copies the selected range down, similar to `Ctrl + D` in Excel. */ copySelectedRangeDown() {
        this.assertClipboard("copySelectedRangeDown", ()=>this.clipboardService.copyRangeDown());
    }
    /** Pastes the data from the Clipboard into the focused cell of the grid. If no grid cell is focused, calling this method has no effect. */ pasteFromClipboard() {
        this.assertClipboard("pasteFromClipboard", ()=>this.clipboardService.pasteFromClipboard());
    }
    /** @deprecated v31.1 Use `IHeaderParams.showColumnMenu` within a header component, or `api.showColumnMenu` elsewhere. */ showColumnMenuAfterButtonClick(colKey, buttonElement) {
        warnOnce(`'showColumnMenuAfterButtonClick' is deprecated. Use 'IHeaderParams.showColumnMenu' within a header component, or 'api.showColumnMenu' elsewhere.`);
        const column = this.columnModel.getGridColumn(colKey);
        this.menuService.showColumnMenu({
            column,
            buttonElement,
            positionBy: "button"
        });
    }
    /** @deprecated v31.1 Use `IHeaderParams.showColumnMenuAfterMouseClick` within a header component, or `api.showColumnMenu` elsewhere. */ showColumnMenuAfterMouseClick(colKey, mouseEvent) {
        warnOnce(`'showColumnMenuAfterMouseClick' is deprecated. Use 'IHeaderParams.showColumnMenuAfterMouseClick' within a header component, or 'api.showColumnMenu' elsewhere.`);
        let column = this.columnModel.getGridColumn(colKey);
        if (!column) column = this.columnModel.getPrimaryColumn(colKey);
        if (!column) {
            console.error(`AG Grid: column '${colKey}' not found`);
            return;
        }
        this.menuService.showColumnMenu({
            column,
            mouseEvent,
            positionBy: "mouse"
        });
    }
    /**
   * Displays the AG Grid context menu
   */ showContextMenu(params) {
        const { rowNode, column, value, x, y } = params || {};
        let { x: clientX, y: clientY } = this.menuService.getContextMenuPosition(rowNode, column);
        if (x != null) clientX = x;
        if (y != null) clientY = y;
        this.menuService.showContextMenu({
            mouseEvent: new MouseEvent("mousedown", {
                clientX,
                clientY
            }),
            rowNode,
            column,
            value
        });
    }
    /** Show the column chooser. */ showColumnChooser(params) {
        this.menuService.showColumnChooser({
            chooserParams: params
        });
    }
    /** Show the filter for the provided column. */ showColumnFilter(colKey) {
        const column = this.columnModel.getGridColumn(colKey);
        if (!column) {
            console.error(`AG Grid: column '${colKey}' not found`);
            return;
        }
        this.menuService.showFilterMenu({
            column,
            containerType: "columnFilter",
            positionBy: "auto"
        });
    }
    /** Show the column menu for the provided column. */ showColumnMenu(colKey) {
        const column = this.columnModel.getGridColumn(colKey);
        if (!column) {
            console.error(`AG Grid: column '${colKey}' not found`);
            return;
        }
        this.menuService.showColumnMenu({
            column,
            positionBy: "auto"
        });
    }
    /** Hides any visible context menu or column menu. */ hidePopupMenu() {
        this.menuService.hidePopupMenu();
    }
    /** Hide the column chooser if visible. */ hideColumnChooser() {
        this.menuService.hideColumnChooser();
    }
    /** Navigates the grid focus to the next cell, as if tabbing. */ tabToNextCell(event) {
        return this.navigationService.tabToNextCell(false, event);
    }
    /** Navigates the grid focus to the previous cell, as if shift-tabbing. */ tabToPreviousCell(event) {
        return this.navigationService.tabToNextCell(true, event);
    }
    /** Returns the list of active cell renderer instances. */ getCellRendererInstances(params = {}) {
        const res = this.rowRenderer.getCellRendererInstances(params);
        const unwrapped = res.map(unwrapUserComp);
        return unwrapped;
    }
    /** Returns the list of active cell editor instances. Optionally provide parameters to restrict to certain columns / row nodes. */ getCellEditorInstances(params = {}) {
        const res = this.rowRenderer.getCellEditorInstances(params);
        const unwrapped = res.map(unwrapUserComp);
        return unwrapped;
    }
    /** If the grid is editing, returns back details of the editing cell(s). */ getEditingCells() {
        return this.rowRenderer.getEditingCells();
    }
    /** If a cell is editing, it stops the editing. Pass `true` if you want to cancel the editing (i.e. don't accept changes). */ stopEditing(cancel = false) {
        this.rowRenderer.stopEditing(cancel);
    }
    /** Start editing the provided cell. If another cell is editing, the editing will be stopped in that other cell. */ startEditingCell(params) {
        const column = this.columnModel.getGridColumn(params.colKey);
        if (!column) {
            console.warn(`AG Grid: no column found for ${params.colKey}`);
            return;
        }
        const cellPosition = {
            rowIndex: params.rowIndex,
            rowPinned: params.rowPinned || null,
            column
        };
        const notPinned = params.rowPinned == null;
        if (notPinned) this.ensureIndexVisible(params.rowIndex);
        this.ensureColumnVisible(params.colKey);
        const cell = this.navigationService.getCellByPosition(cellPosition);
        if (!cell) return;
        if (!this.focusService.isCellFocused(cellPosition)) this.focusService.setFocusedCell(cellPosition);
        cell.startRowOrCellEdit(params.key);
    }
    /** @deprecated v31.1 addAggFunc(key, func) is  deprecated, please use addAggFuncs({ key: func }) instead. */ addAggFunc(key, aggFunc) {
        this.logDeprecation("v31.1", "addAggFunc(key, func)", "addAggFuncs({ key: func })");
        if (this.aggFuncService) this.aggFuncService.addAggFuncs({
            key: aggFunc
        });
    }
    /** Add aggregations function with the specified keys. */ addAggFuncs(aggFuncs) {
        if (this.aggFuncService) this.aggFuncService.addAggFuncs(aggFuncs);
    }
    /** Clears all aggregation functions (including those provided by the grid). */ clearAggFuncs() {
        if (this.aggFuncService) this.aggFuncService.clear();
    }
    /** Apply transactions to the server side row model. */ applyServerSideTransaction(transaction) {
        if (!this.serverSideTransactionManager) {
            this.logMissingRowModel("applyServerSideTransaction", "serverSide");
            return;
        }
        return this.serverSideTransactionManager.applyTransaction(transaction);
    }
    /** Batch apply transactions to the server side row model. */ applyServerSideTransactionAsync(transaction, callback) {
        if (!this.serverSideTransactionManager) {
            this.logMissingRowModel("applyServerSideTransactionAsync", "serverSide");
            return;
        }
        return this.serverSideTransactionManager.applyTransactionAsync(transaction, callback);
    }
    /**
   * Applies row data to a server side store.
   * New rows will overwrite rows at the same index in the same way as if provided by a datasource success callback.
  */ applyServerSideRowData(params) {
        var _a, _b;
        const startRow = (_a = params.startRow) != null ? _a : 0;
        const route = (_b = params.route) != null ? _b : [];
        if (startRow < 0) {
            console.warn(`AG Grid: invalid value ${params.startRow} for startRow, the value should be >= 0`);
            return;
        }
        if (this.serverSideRowModel) this.serverSideRowModel.applyRowData(params.successParams, startRow, route);
        else this.logMissingRowModel("setServerSideDatasource", "serverSide");
    }
    /** Gets all failed server side loads to retry. */ retryServerSideLoads() {
        if (!this.serverSideRowModel) {
            this.logMissingRowModel("retryServerSideLoads", "serverSide");
            return;
        }
        this.serverSideRowModel.retryLoads();
    }
    flushServerSideAsyncTransactions() {
        if (!this.serverSideTransactionManager) {
            this.logMissingRowModel("flushServerSideAsyncTransactions", "serverSide");
            return;
        }
        return this.serverSideTransactionManager.flushAsyncTransactions();
    }
    /** Update row data. Pass a transaction object with lists for `add`, `remove` and `update`. */ applyTransaction(rowDataTransaction) {
        if (!this.clientSideRowModel) {
            this.logMissingRowModel("applyTransaction", "clientSide");
            return;
        }
        return this.frameworkOverrides.wrapIncoming(()=>this.clientSideRowModel.updateRowData(rowDataTransaction));
    }
    /** Same as `applyTransaction` except executes asynchronously for efficiency. */ applyTransactionAsync(rowDataTransaction, callback) {
        if (!this.clientSideRowModel) {
            this.logMissingRowModel("applyTransactionAsync", "clientSide");
            return;
        }
        this.frameworkOverrides.wrapIncoming(()=>this.clientSideRowModel.batchUpdateRowData(rowDataTransaction, callback));
    }
    /** Executes any remaining asynchronous grid transactions, if any are waiting to be executed. */ flushAsyncTransactions() {
        if (!this.clientSideRowModel) {
            this.logMissingRowModel("flushAsyncTransactions", "clientSide");
            return;
        }
        this.frameworkOverrides.wrapIncoming(()=>this.clientSideRowModel.flushAsyncTransactions());
    }
    /**
   * Marks all the currently loaded blocks in the cache for reload.
   * If you have 10 blocks in the cache, all 10 will be marked for reload.
   * The old data will continue to be displayed until the new data is loaded.
   */ refreshInfiniteCache() {
        if (this.infiniteRowModel) this.infiniteRowModel.refreshCache();
        else this.logMissingRowModel("refreshInfiniteCache", "infinite");
    }
    /**
   * Purges the cache.
   * The grid is then told to refresh. Only the blocks required to display the current data on screen are fetched (typically no more than 2).
   * The grid will display nothing while the new blocks are loaded.
   * Use this to immediately remove the old data from the user.
   */ purgeInfiniteCache() {
        if (this.infiniteRowModel) this.infiniteRowModel.purgeCache();
        else this.logMissingRowModel("purgeInfiniteCache", "infinite");
    }
    /**
   * Refresh a server-side store level.
   * If you pass no parameters, then the top level store is refreshed.
   * To refresh a child level, pass in the string of keys to get to the desired level.
   * Once the store refresh is complete, the storeRefreshed event is fired.
   */ refreshServerSide(params) {
        if (!this.serverSideRowModel) {
            this.logMissingRowModel("refreshServerSide", "serverSide");
            return;
        }
        this.serverSideRowModel.refreshStore(params);
    }
    /** Returns info on all server side group levels. */ getServerSideGroupLevelState() {
        if (!this.serverSideRowModel) {
            this.logMissingRowModel("getServerSideGroupLevelState", "serverSide");
            return [];
        }
        return this.serverSideRowModel.getStoreState();
    }
    /** The row count defines how many rows the grid allows scrolling to. */ getInfiniteRowCount() {
        if (this.infiniteRowModel) return this.infiniteRowModel.getRowCount();
        else this.logMissingRowModel("getInfiniteRowCount", "infinite");
    }
    /** Returns `true` if grid allows for scrolling past the last row to load more rows, thus providing infinite scroll. */ isLastRowIndexKnown() {
        if (this.infiniteRowModel) return this.infiniteRowModel.isLastRowIndexKnown();
        else this.logMissingRowModel("isLastRowIndexKnown", "infinite");
    }
    /**
   * Returns an object representing the state of the cache. This is useful for debugging and understanding how the cache is working.
   */ getCacheBlockState() {
        return this.rowNodeBlockLoader.getBlockState();
    }
    /** @deprecated v31.1 `getFirstDisplayedRow` is deprecated. Please use `getFirstDisplayedRowIndex` instead. */ getFirstDisplayedRow() {
        this.logDeprecation("v31.1", "getFirstDisplayedRow", "getFirstDisplayedRowIndex");
        return this.getFirstDisplayedRowIndex();
    }
    /** Get the index of the first displayed row due to scrolling (includes invisible rendered rows in the buffer). */ getFirstDisplayedRowIndex() {
        return this.rowRenderer.getFirstVirtualRenderedRow();
    }
    /** @deprecated v31.1 `getLastDisplayedRow` is deprecated. Please use `getLastDisplayedRowIndex` instead. */ getLastDisplayedRow() {
        this.logDeprecation("v31.1", "getLastDisplayedRow", "getLastDisplayedRowIndex");
        return this.getLastDisplayedRowIndex();
    }
    /** Get the index of the last displayed row due to scrolling (includes invisible rendered rows in the buffer). */ getLastDisplayedRowIndex() {
        return this.rowRenderer.getLastVirtualRenderedRow();
    }
    /** Returns the displayed `RowNode` at the given `index`. */ getDisplayedRowAtIndex(index) {
        return this.rowModel.getRow(index);
    }
    /** Returns the total number of displayed rows. */ getDisplayedRowCount() {
        return this.rowModel.getRowCount();
    }
    /**
   * Returns `true` when the last page is known.
   * This will always be `true` if you are using the Client-Side Row Model for pagination.
   * Returns `false` when the last page is not known; this only happens when using Infinite Row Model.
   */ paginationIsLastPageFound() {
        return this.paginationProxy.isLastPageFound();
    }
    /** Returns how many rows are being shown per page. */ paginationGetPageSize() {
        return this.paginationProxy.getPageSize();
    }
    /** Returns the 0-based index of the page which is showing. */ paginationGetCurrentPage() {
        return this.paginationProxy.getCurrentPage();
    }
    /** Returns the total number of pages. Returns `null` if `paginationIsLastPageFound() === false`. */ paginationGetTotalPages() {
        return this.paginationProxy.getTotalPages();
    }
    /** The total number of rows. Returns `null` if `paginationIsLastPageFound() === false`. */ paginationGetRowCount() {
        return this.paginationProxy.getMasterRowCount();
    }
    /** Navigates to the next page. */ paginationGoToNextPage() {
        this.paginationProxy.goToNextPage();
    }
    /** Navigates to the previous page. */ paginationGoToPreviousPage() {
        this.paginationProxy.goToPreviousPage();
    }
    /** Navigates to the first page. */ paginationGoToFirstPage() {
        this.paginationProxy.goToFirstPage();
    }
    /** Navigates to the last page. */ paginationGoToLastPage() {
        this.paginationProxy.goToLastPage();
    }
    /** Goes to the specified page. If the page requested doesn't exist, it will go to the last page. */ paginationGoToPage(page) {
        this.paginationProxy.goToPage(page);
    }
    // Methods migrated from old ColumnApi
    /**
   * Adjusts the size of columns to fit the available horizontal space.
   *
   * Note: it is not recommended to call this method rapidly e.g. in response
   * to window resize events or as the container size is animated. This can
   * cause the scrollbar to flicker. Use column flex for smoother results.
   * 
   * If inferring cell data types with custom column types
   * and row data is provided asynchronously, the column sizing will happen asynchronously when row data is added.
   * To always perform this synchronously, set `cellDataType = false` on the default column definition.
   **/ sizeColumnsToFit(paramsOrGridWidth) {
        if (typeof paramsOrGridWidth === "number") this.columnModel.sizeColumnsToFit(paramsOrGridWidth, "api");
        else this.gridBodyCtrl.sizeColumnsToFit(paramsOrGridWidth);
    }
    /** Call this if you want to open or close a column group. */ setColumnGroupOpened(group, newValue) {
        this.columnModel.setColumnGroupOpened(group, newValue, "api");
    }
    /** Returns the column group with the given name. */ getColumnGroup(name, instanceId) {
        return this.columnModel.getColumnGroup(name, instanceId);
    }
    /** Returns the provided column group with the given name. */ getProvidedColumnGroup(name) {
        return this.columnModel.getProvidedColumnGroup(name);
    }
    /** Returns the display name for a column. Useful if you are doing your own header rendering and want the grid to work out if `headerValueGetter` is used, or if you are doing your own column management GUI, to know what to show as the column name. */ getDisplayNameForColumn(column, location) {
        return this.columnModel.getDisplayNameForColumn(column, location) || "";
    }
    /** Returns the display name for a column group (when grouping columns). */ getDisplayNameForColumnGroup(columnGroup, location) {
        return this.columnModel.getDisplayNameForColumnGroup(columnGroup, location) || "";
    }
    /** Returns the column with the given `colKey`, which can either be the `colId` (a string) or the `colDef` (an object). */ getColumn(key) {
        return this.columnModel.getPrimaryColumn(key);
    }
    /** Returns all the columns, regardless of visible or not. */ getColumns() {
        return this.columnModel.getAllPrimaryColumns();
    }
    /** Applies the state of the columns from a previous state. Returns `false` if one or more columns could not be found. */ applyColumnState(params) {
        return this.columnModel.applyColumnState(params, "api");
    }
    /** Gets the state of the columns. Typically used when saving column state. */ getColumnState() {
        return this.columnModel.getColumnState();
    }
    /** Sets the state back to match the originally provided column definitions. */ resetColumnState() {
        this.columnModel.resetColumnState("api");
    }
    /** Gets the state of the column groups. Typically used when saving column group state. */ getColumnGroupState() {
        return this.columnModel.getColumnGroupState();
    }
    /** Sets the state of the column group state from a previous state. */ setColumnGroupState(stateItems) {
        this.columnModel.setColumnGroupState(stateItems, "api");
    }
    /** Sets the state back to match the originally provided column definitions. */ resetColumnGroupState() {
        this.columnModel.resetColumnGroupState("api");
    }
    /** Returns `true` if pinning left or right, otherwise `false`. */ isPinning() {
        return this.columnModel.isPinningLeft() || this.columnModel.isPinningRight();
    }
    /** Returns `true` if pinning left, otherwise `false`. */ isPinningLeft() {
        return this.columnModel.isPinningLeft();
    }
    /** Returns `true` if pinning right, otherwise `false`. */ isPinningRight() {
        return this.columnModel.isPinningRight();
    }
    /** Returns the column to the right of the provided column, taking into consideration open / closed column groups and visible columns. This is useful if you need to know what column is beside yours e.g. if implementing your own cell navigation. */ getDisplayedColAfter(col) {
        return this.columnModel.getDisplayedColAfter(col);
    }
    /** Same as `getVisibleColAfter` except gives column to the left. */ getDisplayedColBefore(col) {
        return this.columnModel.getDisplayedColBefore(col);
    }
    /** @deprecated v31.1 setColumnVisible(key, visible) deprecated, please use setColumnsVisible([key], visible) instead. */ setColumnVisible(key, visible) {
        this.logDeprecation("v31.1", "setColumnVisible(key,visible)", "setColumnsVisible([key],visible)");
        this.columnModel.setColumnsVisible([
            key
        ], visible, "api");
    }
    /** Sets the visibility of columns. Key can be the column ID or `Column` object. */ setColumnsVisible(keys2, visible) {
        this.columnModel.setColumnsVisible(keys2, visible, "api");
    }
    /** @deprecated v31.1 setColumnPinned(key, pinned) deprecated, please use setColumnsPinned([key], pinned) instead. */ setColumnPinned(key, pinned) {
        this.logDeprecation("v31.1", "setColumnPinned(key,pinned)", "setColumnsPinned([key],pinned)");
        this.columnModel.setColumnsPinned([
            key
        ], pinned, "api");
    }
    /** Set a column's pinned / unpinned state. Key can be the column ID, field, `ColDef` object or `Column` object. */ setColumnsPinned(keys2, pinned) {
        this.columnModel.setColumnsPinned(keys2, pinned, "api");
    }
    /**
   * Returns all the grid columns, same as `getColumns()`, except
   *
   *  a) it has the order of the columns that are presented in the grid
   *
   *  b) it's after the 'pivot' step, so if pivoting, has the value columns for the pivot.
   */ getAllGridColumns() {
        return this.columnModel.getAllGridColumns();
    }
    /** Same as `getAllDisplayedColumns` but just for the pinned left portion of the grid. */ getDisplayedLeftColumns() {
        return this.columnModel.getDisplayedLeftColumns();
    }
    /** Same as `getAllDisplayedColumns` but just for the center portion of the grid. */ getDisplayedCenterColumns() {
        return this.columnModel.getDisplayedCenterColumns();
    }
    /** Same as `getAllDisplayedColumns` but just for the pinned right portion of the grid. */ getDisplayedRightColumns() {
        return this.columnModel.getDisplayedRightColumns();
    }
    /** Returns all columns currently displayed (e.g. are visible and if in a group, the group is showing the columns) for the pinned left, centre and pinned right portions of the grid. */ getAllDisplayedColumns() {
        return this.columnModel.getAllDisplayedColumns();
    }
    /** Same as `getAllGridColumns()`, except only returns rendered columns, i.e. columns that are not within the viewport and therefore not rendered, due to column virtualisation, are not displayed. */ getAllDisplayedVirtualColumns() {
        return this.columnModel.getViewportColumns();
    }
    /** @deprecated v31.1 moveColumn(key, toIndex) deprecated, please use moveColumns([key], toIndex) instead. */ moveColumn(key, toIndex) {
        this.logDeprecation("v31.1", "moveColumn(key, toIndex)", "moveColumns([key], toIndex)");
        this.columnModel.moveColumns([
            key
        ], toIndex, "api");
    }
    /** Moves the column at `fromIdex` to `toIndex`. The column is first removed, then added at the `toIndex` location, thus index locations will change to the right of the column after the removal. */ moveColumnByIndex(fromIndex, toIndex) {
        this.columnModel.moveColumnByIndex(fromIndex, toIndex, "api");
    }
    /** Moves columns to `toIndex`. The columns are first removed, then added at the `toIndex` location, thus index locations will change to the right of the column after the removal. */ moveColumns(columnsToMoveKeys, toIndex) {
        this.columnModel.moveColumns(columnsToMoveKeys, toIndex, "api");
    }
    /** Move the column to a new position in the row grouping order. */ moveRowGroupColumn(fromIndex, toIndex) {
        this.columnModel.moveRowGroupColumn(fromIndex, toIndex, "api");
    }
    /** Sets the agg function for a column. `aggFunc` can be one of the built-in aggregations or a custom aggregation by name or direct function. */ setColumnAggFunc(key, aggFunc) {
        this.columnModel.setColumnAggFunc(key, aggFunc, "api");
    }
    /** @deprecated v31.1 setColumnWidths(key, newWidth) deprecated, please use setColumnWidths( [{key: newWidth}] ) instead. */ setColumnWidth(key, newWidth, finished = true, source = "api") {
        this.logDeprecation("v31.1", "setColumnWidth(col, width)", "setColumnWidths([{key: col, newWidth: width}])");
        this.columnModel.setColumnWidths([
            {
                key,
                newWidth
            }
        ], false, finished, source);
    }
    /** Sets the column widths of the columns provided. The finished flag gets included in the resulting event and not used internally by the grid. The finished flag is intended for dragging, where a dragging action will produce many `columnWidth` events, so the consumer of events knows when it receives the last event in a stream. The finished parameter is optional, and defaults to `true`. */ setColumnWidths(columnWidths, finished = true, source = "api") {
        this.columnModel.setColumnWidths(columnWidths, false, finished, source);
    }
    /** Get the pivot mode. */ isPivotMode() {
        return this.columnModel.isPivotMode();
    }
    /** Returns the pivot result column for the given `pivotKeys` and `valueColId`. Useful to then call operations on the pivot column. */ getPivotResultColumn(pivotKeys, valueColKey) {
        return this.columnModel.getSecondaryPivotColumn(pivotKeys, valueColKey);
    }
    /** Set the value columns to the provided list of columns. */ setValueColumns(colKeys) {
        this.columnModel.setValueColumns(colKeys, "api");
    }
    /** Get a list of the existing value columns. */ getValueColumns() {
        return this.columnModel.getValueColumns();
    }
    /** @deprecated v31.1 removeValueColumn(colKey) deprecated, please use removeValueColumns([colKey]) instead. */ removeValueColumn(colKey) {
        this.logDeprecation("v31.1", "removeValueColumn(colKey)", "removeValueColumns([colKey])");
        this.columnModel.removeValueColumns([
            colKey
        ], "api");
    }
    /** Remove the given list of columns from the existing set of value columns. */ removeValueColumns(colKeys) {
        this.columnModel.removeValueColumns(colKeys, "api");
    }
    /** @deprecated v31.1 addValueColumn(colKey) deprecated, please use addValueColumns([colKey]) instead. */ addValueColumn(colKey) {
        this.logDeprecation("v31.1", "addValueColumn(colKey)", "addValueColumns([colKey])");
        this.columnModel.addValueColumns([
            colKey
        ], "api");
    }
    /** Add the given list of columns to the existing set of value columns. */ addValueColumns(colKeys) {
        this.columnModel.addValueColumns(colKeys, "api");
    }
    /** Set the row group columns. */ setRowGroupColumns(colKeys) {
        this.columnModel.setRowGroupColumns(colKeys, "api");
    }
    /** @deprecated v31.1 removeRowGroupColumn(colKey) deprecated, please use removeRowGroupColumns([colKey]) instead. */ removeRowGroupColumn(colKey) {
        this.logDeprecation("v31.1", "removeRowGroupColumn(colKey)", "removeRowGroupColumns([colKey])");
        this.columnModel.removeRowGroupColumns([
            colKey
        ], "api");
    }
    /** Remove columns from the row groups. */ removeRowGroupColumns(colKeys) {
        this.columnModel.removeRowGroupColumns(colKeys, "api");
    }
    /** @deprecated v31.1 addRowGroupColumn(colKey) deprecated, please use addRowGroupColumns([colKey]) instead. */ addRowGroupColumn(colKey) {
        this.logDeprecation("v31.1", "addRowGroupColumn(colKey)", "addRowGroupColumns([colKey])");
        this.columnModel.addRowGroupColumns([
            colKey
        ], "api");
    }
    /** Add columns to the row groups. */ addRowGroupColumns(colKeys) {
        this.columnModel.addRowGroupColumns(colKeys, "api");
    }
    /** Get row group columns. */ getRowGroupColumns() {
        return this.columnModel.getRowGroupColumns();
    }
    /** Set the pivot columns. */ setPivotColumns(colKeys) {
        this.columnModel.setPivotColumns(colKeys, "api");
    }
    /** @deprecated v31.1 removePivotColumn(colKey) deprecated, please use removePivotColumns([colKey]) instead. */ removePivotColumn(colKey) {
        this.logDeprecation("v31.1", "removePivotColumn(colKey)", "removePivotColumns([colKey])");
        this.columnModel.removePivotColumns([
            colKey
        ], "api");
    }
    /** Remove pivot columns. */ removePivotColumns(colKeys) {
        this.columnModel.removePivotColumns(colKeys, "api");
    }
    /** @deprecated v31.1 addPivotColumn(colKey) deprecated, please use addPivotColumns([colKey]) instead. */ addPivotColumn(colKey) {
        this.logDeprecation("v31.1", "addPivotColumn(colKey)", "addPivotColumns([colKey])");
        this.columnModel.addPivotColumns([
            colKey
        ], "api");
    }
    /** Add pivot columns. */ addPivotColumns(colKeys) {
        this.columnModel.addPivotColumns(colKeys, "api");
    }
    /** Get the pivot columns. */ getPivotColumns() {
        return this.columnModel.getPivotColumns();
    }
    /** Same as `getAllDisplayedColumnGroups` but just for the pinned left portion of the grid. */ getLeftDisplayedColumnGroups() {
        return this.columnModel.getDisplayedTreeLeft();
    }
    /** Same as `getAllDisplayedColumnGroups` but just for the center portion of the grid. */ getCenterDisplayedColumnGroups() {
        return this.columnModel.getDisplayedTreeCentre();
    }
    /** Same as `getAllDisplayedColumnGroups` but just for the pinned right portion of the grid. */ getRightDisplayedColumnGroups() {
        return this.columnModel.getDisplayedTreeRight();
    }
    /** Returns all 'root' column headers. If you are not grouping columns, these return the columns. If you are grouping, these return the top level groups - you can navigate down through each one to get the other lower level headers and finally the columns at the bottom. */ getAllDisplayedColumnGroups() {
        return this.columnModel.getAllDisplayedTrees();
    }
    /** @deprecated v31.1 autoSizeColumn(key) deprecated, please use autoSizeColumns([colKey]) instead. */ autoSizeColumn(key, skipHeader) {
        this.logDeprecation("v31.1", "autoSizeColumn(key, skipHeader)", "autoSizeColumns([key], skipHeader)");
        return this.columnModel.autoSizeColumns({
            columns: [
                key
            ],
            skipHeader,
            source: "api"
        });
    }
    /**
   * Auto-sizes columns based on their contents. If inferring cell data types with custom column types
   * and row data is provided asynchronously, the column sizing will happen asynchronously when row data is added.
   * To always perform this synchronously, set `cellDataType = false` on the default column definition.
   */ autoSizeColumns(keys2, skipHeader) {
        this.columnModel.autoSizeColumns({
            columns: keys2,
            skipHeader,
            source: "api"
        });
    }
    /**
   * Calls `autoSizeColumns` on all displayed columns. If inferring cell data types with custom column types
   * and row data is provided asynchronously, the column sizing will happen asynchronously when row data is added.
   * To always perform this synchronously, set `cellDataType = false` on the default column definition.
   */ autoSizeAllColumns(skipHeader) {
        this.columnModel.autoSizeAllColumns("api", skipHeader);
    }
    /** Set the pivot result columns. */ setPivotResultColumns(colDefs) {
        this.columnModel.setSecondaryColumns(colDefs, "api");
    }
    /** Returns the grid's pivot result columns. */ getPivotResultColumns() {
        return this.columnModel.getSecondaryColumns();
    }
    /** Get the current state of the grid. Can be used in conjunction with the `initialState` grid option to save and restore grid state. */ getState() {
        return this.stateService.getState();
    }
    /**
   * Returns the grid option value for a provided key.
   */ getGridOption(key) {
        return this.gos.get(key);
    }
    /**
   * Updates a single gridOption to the new value provided. (Cannot be used on `Initial` properties.)
   * If updating multiple options, it is recommended to instead use `api.updateGridOptions()` which batches update logic.
   */ setGridOption(key, value) {
        this.updateGridOptions({
            [key]: value
        });
    }
    /**
   * Updates the provided subset of gridOptions with the provided values. (Cannot be used on `Initial` properties.)
   */ updateGridOptions(options) {
        this.gos.updateGridOptions({
            options
        });
    }
    /** Used internally by grid. Not intended to be used by the client. Interface may change between releases. */ __internalUpdateGridOptions(options, force) {
        this.gos.updateGridOptions({
            options,
            force,
            source: "gridOptionsUpdated"
        });
    }
    deprecatedUpdateGridOption(key, value) {
        warnOnce(`set${key.charAt(0).toUpperCase()}${key.slice(1, key.length)} is deprecated. Please use 'api.setGridOption('${key}', newValue)' or 'api.updateGridOptions({ ${key}: newValue })' instead.`);
        this.setGridOption(key, value);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Set the top pinned rows. Call with no rows / undefined to clear top pinned rows. 
   **/ setPivotMode(pivotMode) {
        this.deprecatedUpdateGridOption("pivotMode", pivotMode);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Set the top pinned rows. Call with no rows / undefined to clear top pinned rows. 
   **/ setPinnedTopRowData(rows) {
        this.deprecatedUpdateGridOption("pinnedTopRowData", rows);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Set the bottom pinned rows. Call with no rows / undefined to clear bottom pinned rows.
   * */ setPinnedBottomRowData(rows) {
        this.deprecatedUpdateGridOption("pinnedBottomRowData", rows);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * DOM element to use as the popup parent for grid popups (context menu, column menu etc).
   * */ setPopupParent(ePopupParent) {
        this.deprecatedUpdateGridOption("popupParent", ePopupParent);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   */ setSuppressModelUpdateAfterUpdateTransaction(value) {
        this.deprecatedUpdateGridOption("suppressModelUpdateAfterUpdateTransaction", value);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Resets the data type definitions. This will update the columns in the grid.
   * */ setDataTypeDefinitions(dataTypeDefinitions) {
        this.deprecatedUpdateGridOption("dataTypeDefinitions", dataTypeDefinitions);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Set whether the grid paginates the data or not.
   *  - `true` to enable pagination
   *  - `false` to disable pagination
   */ setPagination(value) {
        this.deprecatedUpdateGridOption("pagination", value);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the `paginationPageSize`, then re-paginates the grid so the changes are applied immediately.
   * */ paginationSetPageSize(size) {
        this.deprecatedUpdateGridOption("paginationPageSize", size);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Resets the side bar to the provided configuration. The parameter is the same as the sideBar grid property. The side bar is re-created from scratch with the new config.
   * */ setSideBar(def) {
        this.deprecatedUpdateGridOption("sideBar", def);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   */ setSuppressClipboardPaste(value) {
        this.deprecatedUpdateGridOption("suppressClipboardPaste", value);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   */ setGroupRemoveSingleChildren(value) {
        this.deprecatedUpdateGridOption("groupRemoveSingleChildren", value);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   */ setGroupRemoveLowestSingleChildren(value) {
        this.deprecatedUpdateGridOption("groupRemoveLowestSingleChildren", value);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   */ setGroupDisplayType(value) {
        this.deprecatedUpdateGridOption("groupDisplayType", value);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the `groupIncludeFooter` property
   */ setGroupIncludeFooter(value) {
        this.deprecatedUpdateGridOption("groupIncludeFooter", value);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the `groupIncludeTotalFooter` property
   */ setGroupIncludeTotalFooter(value) {
        this.deprecatedUpdateGridOption("groupIncludeTotalFooter", value);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   */ setRowClass(className) {
        this.deprecatedUpdateGridOption("rowClass", className);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the `deltaSort` property
   * */ setDeltaSort(enable) {
        this.deprecatedUpdateGridOption("deltaSort", enable);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the `suppressRowDrag` property.
   * */ setSuppressRowDrag(value) {
        this.deprecatedUpdateGridOption("suppressRowDrag", value);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the `suppressMoveWhenRowDragging` property.
   * */ setSuppressMoveWhenRowDragging(value) {
        this.deprecatedUpdateGridOption("suppressMoveWhenRowDragging", value);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the `suppressRowClickSelection` property.
   * */ setSuppressRowClickSelection(value) {
        this.deprecatedUpdateGridOption("suppressRowClickSelection", value);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Enable/disable the Advanced Filter
   * */ setEnableAdvancedFilter(enabled) {
        this.deprecatedUpdateGridOption("enableAdvancedFilter", enabled);
    }
    /** 
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Updates the `includeHiddenColumnsInAdvancedFilter` grid option.
   * By default hidden columns are excluded from the Advanced Filter.
   * Set to `true` to include them.
   */ setIncludeHiddenColumnsInAdvancedFilter(value) {
        this.deprecatedUpdateGridOption("includeHiddenColumnsInAdvancedFilter", value);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * DOM element to use as the parent for the Advanced Filter, to allow it to appear outside of the grid.
   * Set to `null` to appear inside the grid.
   */ setAdvancedFilterParent(advancedFilterParent) {
        this.deprecatedUpdateGridOption("advancedFilterParent", advancedFilterParent);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Updates the Advanced Filter Builder parameters.
   * */ setAdvancedFilterBuilderParams(params) {
        this.deprecatedUpdateGridOption("advancedFilterBuilderParams", params);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Pass a Quick Filter text into the grid for filtering.
   * */ setQuickFilter(newFilter) {
        warnOnce(`setQuickFilter is deprecated. Please use 'api.setGridOption('quickFilterText', newValue)' or 'api.updateGridOptions({ quickFilterText: newValue })' instead.`);
        this.gos.updateGridOptions({
            options: {
                quickFilterText: newFilter
            }
        });
    }
    /** 
   * @deprecated As of v30, hidden columns are excluded from the Quick Filter by default. To include hidden columns, use `setIncludeHiddenColumnsInQuickFilter` instead.
   */ setExcludeHiddenColumnsFromQuickFilter(value) {
        this.deprecatedUpdateGridOption("includeHiddenColumnsInQuickFilter", !value);
    }
    /** 
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Updates the `includeHiddenColumnsInQuickFilter` grid option.
   * By default hidden columns are excluded from the Quick Filter.
   * Set to `true` to include them.
   */ setIncludeHiddenColumnsInQuickFilter(value) {
        this.deprecatedUpdateGridOption("includeHiddenColumnsInQuickFilter", value);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Updates the `quickFilterParser` grid option,
   * which changes how the Quick Filter splits the Quick Filter text into search terms.
   */ setQuickFilterParser(quickFilterParser) {
        this.deprecatedUpdateGridOption("quickFilterParser", quickFilterParser);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Updates the `quickFilterMatcher` grid option,
   * which changes the matching logic for whether a row passes the Quick Filter.
   */ setQuickFilterMatcher(quickFilterMatcher) {
        this.deprecatedUpdateGridOption("quickFilterMatcher", quickFilterMatcher);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * If `true`, the horizontal scrollbar will always be present, even if not required. Otherwise, it will only be displayed when necessary.
   * */ setAlwaysShowHorizontalScroll(show) {
        this.deprecatedUpdateGridOption("alwaysShowHorizontalScroll", show);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * If `true`, the vertical scrollbar will always be present, even if not required. Otherwise it will only be displayed when necessary.
   * */ setAlwaysShowVerticalScroll(show) {
        this.deprecatedUpdateGridOption("alwaysShowVerticalScroll", show);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   */ setFunctionsReadOnly(readOnly) {
        this.deprecatedUpdateGridOption("functionsReadOnly", readOnly);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Call to set new column definitions. The grid will redraw all the column headers, and then redraw all of the rows.
   */ setColumnDefs(colDefs, source = "api") {
        warnOnce(`setColumnDefs is deprecated. Please use 'api.setGridOption('columnDefs', newValue)' or 'api.updateGridOptions({ columnDefs: newValue })' instead.`);
        this.gos.updateGridOptions({
            options: {
                columnDefs: colDefs
            },
            source
        });
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Call to set new auto group column definition. The grid will recreate any auto-group columns if present.
   * */ setAutoGroupColumnDef(colDef, source = "api") {
        warnOnce(`setAutoGroupColumnDef is deprecated. Please use 'api.setGridOption('autoGroupColumnDef', newValue)' or 'api.updateGridOptions({ autoGroupColumnDef: newValue })' instead.`);
        this.gos.updateGridOptions({
            options: {
                autoGroupColumnDef: colDef
            },
            source
        });
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Call to set new Default Column Definition.
   * */ setDefaultColDef(colDef, source = "api") {
        warnOnce(`setDefaultColDef is deprecated. Please use 'api.setGridOption('defaultColDef', newValue)' or 'api.updateGridOptions({ defaultColDef: newValue })' instead.`);
        this.gos.updateGridOptions({
            options: {
                defaultColDef: colDef
            },
            source
        });
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Call to set new Column Types.
   * */ setColumnTypes(columnTypes, source = "api") {
        warnOnce(`setColumnTypes is deprecated. Please use 'api.setGridOption('columnTypes', newValue)' or 'api.updateGridOptions({ columnTypes: newValue })' instead.`);
        this.gos.updateGridOptions({
            options: {
                columnTypes
            },
            source
        });
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the `treeData` property.
   * */ setTreeData(newTreeData) {
        this.deprecatedUpdateGridOption("treeData", newTreeData);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Set new datasource for Server-Side Row Model.
   * */ setServerSideDatasource(datasource) {
        this.deprecatedUpdateGridOption("serverSideDatasource", datasource);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * 
   * Note this purges all the cached data and reloads all the rows of the grid.
   * */ setCacheBlockSize(blockSize) {
        this.deprecatedUpdateGridOption("cacheBlockSize", blockSize);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Set new datasource for Infinite Row Model.
   * */ setDatasource(datasource) {
        this.deprecatedUpdateGridOption("datasource", datasource);
    }
    /** 
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Set new datasource for Viewport Row Model.
   * */ setViewportDatasource(viewportDatasource) {
        this.deprecatedUpdateGridOption("viewportDatasource", viewportDatasource);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Set the row data.
   * */ setRowData(rowData) {
        this.deprecatedUpdateGridOption("rowData", rowData);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the `enableCellTextSelection` property.
   * */ setEnableCellTextSelection(selectable) {
        this.deprecatedUpdateGridOption("enableCellTextSelection", selectable);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the height in pixels for the row containing the column label header.
   * */ setHeaderHeight(headerHeight) {
        this.deprecatedUpdateGridOption("headerHeight", headerHeight);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Switch between layout options: `normal`, `autoHeight`, `print`.
   * Defaults to `normal` if no domLayout provided.
   */ setDomLayout(domLayout) {
        this.deprecatedUpdateGridOption("domLayout", domLayout);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the preferred direction for the selection fill handle.
   * */ setFillHandleDirection(direction) {
        this.deprecatedUpdateGridOption("fillHandleDirection", direction);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the height in pixels for the rows containing header column groups.
   * */ setGroupHeaderHeight(headerHeight) {
        this.deprecatedUpdateGridOption("groupHeaderHeight", headerHeight);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the height in pixels for the row containing the floating filters.
   * */ setFloatingFiltersHeight(headerHeight) {
        this.deprecatedUpdateGridOption("floatingFiltersHeight", headerHeight);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the height in pixels for the row containing the columns when in pivot mode.
   * */ setPivotHeaderHeight(headerHeight) {
        this.deprecatedUpdateGridOption("pivotHeaderHeight", headerHeight);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the height in pixels for the row containing header column groups when in pivot mode.
   * */ setPivotGroupHeaderHeight(headerHeight) {
        this.deprecatedUpdateGridOption("pivotGroupHeaderHeight", headerHeight);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setAnimateRows(animateRows) {
        this.deprecatedUpdateGridOption("animateRows", animateRows);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setIsExternalFilterPresent(isExternalFilterPresentFunc) {
        this.deprecatedUpdateGridOption("isExternalFilterPresent", isExternalFilterPresentFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setDoesExternalFilterPass(doesExternalFilterPassFunc) {
        this.deprecatedUpdateGridOption("doesExternalFilterPass", doesExternalFilterPassFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setNavigateToNextCell(navigateToNextCellFunc) {
        this.deprecatedUpdateGridOption("navigateToNextCell", navigateToNextCellFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setTabToNextCell(tabToNextCellFunc) {
        this.deprecatedUpdateGridOption("tabToNextCell", tabToNextCellFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setTabToNextHeader(tabToNextHeaderFunc) {
        this.deprecatedUpdateGridOption("tabToNextHeader", tabToNextHeaderFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setNavigateToNextHeader(navigateToNextHeaderFunc) {
        this.deprecatedUpdateGridOption("navigateToNextHeader", navigateToNextHeaderFunc);
    }
    setRowGroupPanelShow(rowGroupPanelShow) {
        this.deprecatedUpdateGridOption("rowGroupPanelShow", rowGroupPanelShow);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setGetGroupRowAgg(getGroupRowAggFunc) {
        this.deprecatedUpdateGridOption("getGroupRowAgg", getGroupRowAggFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setGetBusinessKeyForNode(getBusinessKeyForNodeFunc) {
        this.deprecatedUpdateGridOption("getBusinessKeyForNode", getBusinessKeyForNodeFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setGetChildCount(getChildCountFunc) {
        this.deprecatedUpdateGridOption("getChildCount", getChildCountFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setProcessRowPostCreate(processRowPostCreateFunc) {
        this.deprecatedUpdateGridOption("processRowPostCreate", processRowPostCreateFunc);
    }
    /**
   * @deprecated v31 `getRowId` is a static property and cannot be updated.
   *  */ setGetRowId(getRowIdFunc) {
        warnOnce(`getRowId is a static property and can no longer be updated.`);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setGetRowClass(rowClassFunc) {
        this.deprecatedUpdateGridOption("getRowClass", rowClassFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setIsFullWidthRow(isFullWidthRowFunc) {
        this.deprecatedUpdateGridOption("isFullWidthRow", isFullWidthRowFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setIsRowSelectable(isRowSelectableFunc) {
        this.deprecatedUpdateGridOption("isRowSelectable", isRowSelectableFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setIsRowMaster(isRowMasterFunc) {
        this.deprecatedUpdateGridOption("isRowMaster", isRowMasterFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setPostSortRows(postSortRowsFunc) {
        this.deprecatedUpdateGridOption("postSortRows", postSortRowsFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setGetDocument(getDocumentFunc) {
        this.deprecatedUpdateGridOption("getDocument", getDocumentFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setGetContextMenuItems(getContextMenuItemsFunc) {
        this.deprecatedUpdateGridOption("getContextMenuItems", getContextMenuItemsFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setGetMainMenuItems(getMainMenuItemsFunc) {
        this.deprecatedUpdateGridOption("getMainMenuItems", getMainMenuItemsFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setProcessCellForClipboard(processCellForClipboardFunc) {
        this.deprecatedUpdateGridOption("processCellForClipboard", processCellForClipboardFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setSendToClipboard(sendToClipboardFunc) {
        this.deprecatedUpdateGridOption("sendToClipboard", sendToClipboardFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setProcessCellFromClipboard(processCellFromClipboardFunc) {
        this.deprecatedUpdateGridOption("processCellFromClipboard", processCellFromClipboardFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setProcessPivotResultColDef(processPivotResultColDefFunc) {
        this.deprecatedUpdateGridOption("processPivotResultColDef", processPivotResultColDefFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setProcessPivotResultColGroupDef(processPivotResultColGroupDefFunc) {
        this.deprecatedUpdateGridOption("processPivotResultColGroupDef", processPivotResultColGroupDefFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setPostProcessPopup(postProcessPopupFunc) {
        this.deprecatedUpdateGridOption("postProcessPopup", postProcessPopupFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setInitialGroupOrderComparator(initialGroupOrderComparatorFunc) {
        this.deprecatedUpdateGridOption("initialGroupOrderComparator", initialGroupOrderComparatorFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setGetChartToolbarItems(getChartToolbarItemsFunc) {
        this.deprecatedUpdateGridOption("getChartToolbarItems", getChartToolbarItemsFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setPaginationNumberFormatter(paginationNumberFormatterFunc) {
        this.deprecatedUpdateGridOption("paginationNumberFormatter", paginationNumberFormatterFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setGetServerSideGroupLevelParams(getServerSideGroupLevelParamsFunc) {
        this.deprecatedUpdateGridOption("getServerSideGroupLevelParams", getServerSideGroupLevelParamsFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setIsServerSideGroupOpenByDefault(isServerSideGroupOpenByDefaultFunc) {
        this.deprecatedUpdateGridOption("isServerSideGroupOpenByDefault", isServerSideGroupOpenByDefaultFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setIsApplyServerSideTransaction(isApplyServerSideTransactionFunc) {
        this.deprecatedUpdateGridOption("isApplyServerSideTransaction", isApplyServerSideTransactionFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setIsServerSideGroup(isServerSideGroupFunc) {
        this.deprecatedUpdateGridOption("isServerSideGroup", isServerSideGroupFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setGetServerSideGroupKey(getServerSideGroupKeyFunc) {
        this.deprecatedUpdateGridOption("getServerSideGroupKey", getServerSideGroupKeyFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setGetRowStyle(rowStyleFunc) {
        this.deprecatedUpdateGridOption("getRowStyle", rowStyleFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setGetRowHeight(rowHeightFunc) {
        this.deprecatedUpdateGridOption("getRowHeight", rowHeightFunc);
    }
};
__decorateClass([
    Autowired("rowRenderer")
], GridApi.prototype, "rowRenderer", 2);
__decorateClass([
    Autowired("navigationService")
], GridApi.prototype, "navigationService", 2);
__decorateClass([
    Autowired("filterManager")
], GridApi.prototype, "filterManager", 2);
__decorateClass([
    Autowired("columnModel")
], GridApi.prototype, "columnModel", 2);
__decorateClass([
    Autowired("selectionService")
], GridApi.prototype, "selectionService", 2);
__decorateClass([
    Autowired("gridOptionsService")
], GridApi.prototype, "gos", 2);
__decorateClass([
    Autowired("valueService")
], GridApi.prototype, "valueService", 2);
__decorateClass([
    Autowired("alignedGridsService")
], GridApi.prototype, "alignedGridsService", 2);
__decorateClass([
    Autowired("eventService")
], GridApi.prototype, "eventService", 2);
__decorateClass([
    Autowired("pinnedRowModel")
], GridApi.prototype, "pinnedRowModel", 2);
__decorateClass([
    Autowired("context")
], GridApi.prototype, "context", 2);
__decorateClass([
    Autowired("rowModel")
], GridApi.prototype, "rowModel", 2);
__decorateClass([
    Autowired("sortController")
], GridApi.prototype, "sortController", 2);
__decorateClass([
    Autowired("paginationProxy")
], GridApi.prototype, "paginationProxy", 2);
__decorateClass([
    Autowired("focusService")
], GridApi.prototype, "focusService", 2);
__decorateClass([
    Autowired("dragAndDropService")
], GridApi.prototype, "dragAndDropService", 2);
__decorateClass([
    Autowired("menuService")
], GridApi.prototype, "menuService", 2);
__decorateClass([
    Autowired("valueCache")
], GridApi.prototype, "valueCache", 2);
__decorateClass([
    Autowired("animationFrameService")
], GridApi.prototype, "animationFrameService", 2);
__decorateClass([
    Autowired("ctrlsService")
], GridApi.prototype, "ctrlsService", 2);
__decorateClass([
    Autowired("overlayService")
], GridApi.prototype, "overlayService", 2);
__decorateClass([
    Autowired("stateService")
], GridApi.prototype, "stateService", 2);
__decorateClass([
    Autowired("expansionService")
], GridApi.prototype, "expansionService", 2);
__decorateClass([
    Autowired("apiEventService")
], GridApi.prototype, "apiEventService", 2);
__decorateClass([
    Autowired("frameworkOverrides")
], GridApi.prototype, "frameworkOverrides", 2);
__decorateClass([
    Autowired("undoRedoService")
], GridApi.prototype, "undoRedoService", 2);
__decorateClass([
    Autowired("rowNodeBlockLoader")
], GridApi.prototype, "rowNodeBlockLoader", 2);
__decorateClass([
    Optional("csvCreator")
], GridApi.prototype, "csvCreator", 2);
__decorateClass([
    Optional("excelCreator")
], GridApi.prototype, "excelCreator", 2);
__decorateClass([
    Optional("rangeService")
], GridApi.prototype, "rangeService", 2);
__decorateClass([
    Optional("clipboardService")
], GridApi.prototype, "clipboardService", 2);
__decorateClass([
    Optional("aggFuncService")
], GridApi.prototype, "aggFuncService", 2);
__decorateClass([
    Optional("statusBarService")
], GridApi.prototype, "statusBarService", 2);
__decorateClass([
    Optional("chartService")
], GridApi.prototype, "chartService", 2);
__decorateClass([
    Optional("ssrmTransactionManager")
], GridApi.prototype, "serverSideTransactionManager", 2);
__decorateClass([
    Optional("sideBarService")
], GridApi.prototype, "sideBarService", 2);
__decorateClass([
    PostConstruct
], GridApi.prototype, "init", 1);
GridApi = __decorateClass([
    Bean("gridApi")
], GridApi);
// community-modules/core/src/filter/quickFilterService.ts
var QuickFilterService = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.quickFilter = null;
        this.quickFilterParts = null;
    }
    postConstruct() {
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, ()=>this.resetQuickFilterCache());
        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, ()=>this.resetQuickFilterCache());
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, ()=>this.resetQuickFilterCache());
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_VISIBLE, ()=>{
            if (!this.gos.get("includeHiddenColumnsInQuickFilter")) this.resetQuickFilterCache();
        });
        this.addManagedPropertyListener("quickFilterText", (e)=>this.setQuickFilter(e.currentValue));
        this.addManagedPropertyListeners([
            "includeHiddenColumnsInQuickFilter",
            "applyQuickFilterBeforePivotOrAgg"
        ], ()=>this.onQuickFilterColumnConfigChanged());
        this.quickFilter = this.parseQuickFilter(this.gos.get("quickFilterText"));
        this.parser = this.gos.get("quickFilterParser");
        this.matcher = this.gos.get("quickFilterMatcher");
        this.setQuickFilterParts();
        this.addManagedPropertyListeners([
            "quickFilterMatcher",
            "quickFilterParser"
        ], ()=>this.setQuickFilterParserAndMatcher());
    }
    isQuickFilterPresent() {
        return this.quickFilter !== null;
    }
    doesRowPassQuickFilter(node) {
        const usingCache = this.gos.get("cacheQuickFilter");
        if (this.matcher) return this.doesRowPassQuickFilterMatcher(usingCache, node);
        return this.quickFilterParts.every((part)=>usingCache ? this.doesRowPassQuickFilterCache(node, part) : this.doesRowPassQuickFilterNoCache(node, part));
    }
    resetQuickFilterCache() {
        this.rowModel.forEachNode((node)=>node.quickFilterAggregateText = null);
    }
    setQuickFilterParts() {
        const { quickFilter, parser } = this;
        if (quickFilter) this.quickFilterParts = parser ? parser(quickFilter) : quickFilter.split(" ");
        else this.quickFilterParts = null;
    }
    parseQuickFilter(newFilter) {
        if (!exists(newFilter)) return null;
        if (!this.gos.isRowModelType("clientSide")) {
            console.warn("AG Grid - Quick filtering only works with the Client-Side Row Model");
            return null;
        }
        return newFilter.toUpperCase();
    }
    setQuickFilter(newFilter) {
        if (newFilter != null && typeof newFilter !== "string") {
            console.warn(`AG Grid - Grid option quickFilterText only supports string inputs, received: ${typeof newFilter}`);
            return;
        }
        const parsedFilter = this.parseQuickFilter(newFilter);
        if (this.quickFilter !== parsedFilter) {
            this.quickFilter = parsedFilter;
            this.setQuickFilterParts();
            this.dispatchEvent({
                type: QuickFilterService.EVENT_QUICK_FILTER_CHANGED
            });
        }
    }
    setQuickFilterParserAndMatcher() {
        const parser = this.gos.get("quickFilterParser");
        const matcher = this.gos.get("quickFilterMatcher");
        const hasChanged = parser !== this.parser || matcher !== this.matcher;
        this.parser = parser;
        this.matcher = matcher;
        if (hasChanged) {
            this.setQuickFilterParts();
            this.dispatchEvent({
                type: QuickFilterService.EVENT_QUICK_FILTER_CHANGED
            });
        }
    }
    onQuickFilterColumnConfigChanged() {
        this.columnModel.refreshQuickFilterColumns();
        this.resetQuickFilterCache();
        if (this.isQuickFilterPresent()) this.dispatchEvent({
            type: QuickFilterService.EVENT_QUICK_FILTER_CHANGED
        });
    }
    doesRowPassQuickFilterNoCache(node, filterPart) {
        const columns = this.columnModel.getAllColumnsForQuickFilter();
        return columns.some((column)=>{
            const part = this.getQuickFilterTextForColumn(column, node);
            return exists(part) && part.indexOf(filterPart) >= 0;
        });
    }
    doesRowPassQuickFilterCache(node, filterPart) {
        this.checkGenerateQuickFilterAggregateText(node);
        return node.quickFilterAggregateText.indexOf(filterPart) >= 0;
    }
    doesRowPassQuickFilterMatcher(usingCache, node) {
        let quickFilterAggregateText;
        if (usingCache) {
            this.checkGenerateQuickFilterAggregateText(node);
            quickFilterAggregateText = node.quickFilterAggregateText;
        } else quickFilterAggregateText = this.getQuickFilterAggregateText(node);
        const { quickFilterParts, matcher } = this;
        return matcher(quickFilterParts, quickFilterAggregateText);
    }
    checkGenerateQuickFilterAggregateText(node) {
        if (!node.quickFilterAggregateText) node.quickFilterAggregateText = this.getQuickFilterAggregateText(node);
    }
    getQuickFilterTextForColumn(column, node) {
        let value = this.valueService.getValue(column, node, true);
        const colDef = column.getColDef();
        if (colDef.getQuickFilterText) {
            const params = this.gos.addGridCommonParams({
                value,
                node,
                data: node.data,
                column,
                colDef
            });
            value = colDef.getQuickFilterText(params);
        }
        return exists(value) ? value.toString().toUpperCase() : null;
    }
    getQuickFilterAggregateText(node) {
        const stringParts = [];
        const columns = this.columnModel.getAllColumnsForQuickFilter();
        columns.forEach((column)=>{
            const part = this.getQuickFilterTextForColumn(column, node);
            if (exists(part)) stringParts.push(part);
        });
        return stringParts.join(QuickFilterService.QUICK_FILTER_SEPARATOR);
    }
};
QuickFilterService.EVENT_QUICK_FILTER_CHANGED = "quickFilterChanged";
QuickFilterService.QUICK_FILTER_SEPARATOR = "\n";
__decorateClass([
    Autowired("valueService")
], QuickFilterService.prototype, "valueService", 2);
__decorateClass([
    Autowired("columnModel")
], QuickFilterService.prototype, "columnModel", 2);
__decorateClass([
    Autowired("rowModel")
], QuickFilterService.prototype, "rowModel", 2);
__decorateClass([
    PostConstruct
], QuickFilterService.prototype, "postConstruct", 1);
QuickFilterService = __decorateClass([
    Bean("quickFilterService")
], QuickFilterService);
// community-modules/core/src/filter/filterManager.ts
var FilterManager = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.allColumnFilters = /* @__PURE__ */ new Map();
        this.allColumnListeners = /* @__PURE__ */ new Map();
        this.activeAggregateFilters = [];
        this.activeColumnFilters = [];
        // this is true when the grid is processing the filter change. this is used by the cell comps, so that they
        // don't flash when data changes due to filter changes. there is no need to flash when filter changes as the
        // user is in control, so doesn't make sense to show flashing changes. for example, go to main demo where
        // this feature is turned off (hack code to always return false for isSuppressFlashingCellsBecauseFiltering(), put in)
        // 100,000 rows and group by country. then do some filtering. all the cells flash, which is silly.
        this.processingFilterChange = false;
        // when we're waiting for cell data types to be inferred, we need to defer filter model updates
        this.filterModelUpdateQueue = [];
        this.columnFilterModelUpdateQueue = [];
        this.advancedFilterModelUpdateQueue = [];
    }
    init() {
        var _a, _b, _c;
        this.addManagedListener(this.eventService, Events.EVENT_GRID_COLUMNS_CHANGED, ()=>this.onColumnsChanged());
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_VALUE_CHANGED, ()=>this.refreshFiltersForAggregations());
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_CHANGED, ()=>this.refreshFiltersForAggregations());
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, ()=>this.refreshFiltersForAggregations());
        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, ()=>this.updateAdvancedFilterColumns());
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_VISIBLE, ()=>this.updateAdvancedFilterColumns());
        this.addManagedListener(this.eventService, Events.EVENT_ROW_DATA_UPDATED, ()=>this.onNewRowsLoaded("rowDataUpdated"));
        this.externalFilterPresent = this.isExternalFilterPresentCallback();
        this.addManagedPropertyListeners([
            "isExternalFilterPresent",
            "doesExternalFilterPass"
        ], ()=>{
            this.onFilterChanged({
                source: "api"
            });
        });
        this.updateAggFiltering();
        this.addManagedPropertyListener("groupAggFiltering", ()=>{
            this.updateAggFiltering();
            this.onFilterChanged();
        });
        this.addManagedPropertyListener("advancedFilterModel", (event)=>this.setAdvancedFilterModel(event.currentValue));
        this.addManagedListener(this.eventService, Events.EVENT_ADVANCED_FILTER_ENABLED_CHANGED, ({ enabled })=>this.onAdvancedFilterEnabledChanged(enabled));
        this.addManagedListener(this.eventService, Events.EVENT_DATA_TYPES_INFERRED, ()=>this.processFilterModelUpdateQueue());
        this.addManagedListener(this.quickFilterService, QuickFilterService.EVENT_QUICK_FILTER_CHANGED, ()=>this.onFilterChanged({
                source: "quickFilter"
            }));
        this.initialFilterModel = __spreadValues({}, (_c = (_b = (_a = this.gos.get("initialState")) == null ? void 0 : _a.filter) == null ? void 0 : _b.filterModel) != null ? _c : {});
    }
    isExternalFilterPresentCallback() {
        const isFilterPresent = this.gos.getCallback("isExternalFilterPresent");
        if (typeof isFilterPresent === "function") return isFilterPresent({});
        return false;
    }
    doesExternalFilterPass(node) {
        const doesFilterPass = this.gos.get("doesExternalFilterPass");
        if (typeof doesFilterPass === "function") return doesFilterPass(node);
        return false;
    }
    setFilterModel(model, source = "api") {
        if (this.isAdvancedFilterEnabled()) {
            this.warnAdvancedFilters();
            return;
        }
        if (this.dataTypeService.isPendingInference()) {
            this.filterModelUpdateQueue.push({
                model,
                source
            });
            return;
        }
        const allPromises = [];
        const previousModel = this.getFilterModel();
        if (model) {
            const modelKeys = convertToSet(Object.keys(model));
            this.allColumnFilters.forEach((filterWrapper, colId)=>{
                const newModel = model[colId];
                allPromises.push(this.setModelOnFilterWrapper(filterWrapper.filterPromise, newModel));
                modelKeys.delete(colId);
            });
            modelKeys.forEach((colId)=>{
                const column = this.columnModel.getPrimaryColumn(colId) || this.columnModel.getGridColumn(colId);
                if (!column) {
                    console.warn("AG Grid: setFilterModel() - no column found for colId: " + colId);
                    return;
                }
                if (!column.isFilterAllowed()) {
                    console.warn("AG Grid: setFilterModel() - unable to fully apply model, filtering disabled for colId: " + colId);
                    return;
                }
                const filterWrapper = this.getOrCreateFilterWrapper(column, "NO_UI");
                if (!filterWrapper) {
                    console.warn("AG-Grid: setFilterModel() - unable to fully apply model, unable to create filter for colId: " + colId);
                    return;
                }
                allPromises.push(this.setModelOnFilterWrapper(filterWrapper.filterPromise, model[colId]));
            });
        } else this.allColumnFilters.forEach((filterWrapper)=>{
            allPromises.push(this.setModelOnFilterWrapper(filterWrapper.filterPromise, null));
        });
        AgPromise.all(allPromises).then(()=>{
            const currentModel = this.getFilterModel();
            const columns = [];
            this.allColumnFilters.forEach((filterWrapper, colId)=>{
                const before = previousModel ? previousModel[colId] : null;
                const after = currentModel ? currentModel[colId] : null;
                if (!_.jsonEquals(before, after)) columns.push(filterWrapper.column);
            });
            if (columns.length > 0) this.onFilterChanged({
                columns,
                source
            });
        });
    }
    setModelOnFilterWrapper(filterPromise, newModel) {
        return new AgPromise((resolve)=>{
            filterPromise.then((filter)=>{
                if (typeof filter.setModel !== "function") {
                    console.warn("AG Grid: filter missing setModel method, which is needed for setFilterModel");
                    resolve();
                }
                (filter.setModel(newModel) || AgPromise.resolve()).then(()=>resolve());
            });
        });
    }
    getFilterModel() {
        const result = {};
        this.allColumnFilters.forEach((filterWrapper, key)=>{
            const model = this.getModelFromFilterWrapper(filterWrapper);
            if (exists(model)) result[key] = model;
        });
        return result;
    }
    getModelFromFilterWrapper(filterWrapper) {
        var _a;
        const filterPromise = filterWrapper.filterPromise;
        const filter = filterPromise.resolveNow(null, (promiseFilter)=>promiseFilter);
        if (filter == null) return (_a = this.initialFilterModel[filterWrapper.column.getColId()]) != null ? _a : null;
        if (typeof filter.getModel !== "function") {
            console.warn("AG Grid: filter API missing getModel method, which is needed for getFilterModel");
            return null;
        }
        return filter.getModel();
    }
    isColumnFilterPresent() {
        return this.activeColumnFilters.length > 0;
    }
    isAggregateFilterPresent() {
        return !!this.activeAggregateFilters.length;
    }
    isExternalFilterPresent() {
        return this.externalFilterPresent;
    }
    isChildFilterPresent() {
        return this.isColumnFilterPresent() || this.isQuickFilterPresent() || this.isExternalFilterPresent() || this.isAdvancedFilterPresent();
    }
    isAdvancedFilterPresent() {
        return this.isAdvancedFilterEnabled() && this.advancedFilterService.isFilterPresent();
    }
    onAdvancedFilterEnabledChanged(enabled) {
        var _a;
        if (enabled) {
            if (this.allColumnFilters.size) {
                this.allColumnFilters.forEach((filterWrapper)=>this.disposeFilterWrapper(filterWrapper, "advancedFilterEnabled"));
                this.onFilterChanged({
                    source: "advancedFilter"
                });
            }
        } else if ((_a = this.advancedFilterService) == null ? void 0 : _a.isFilterPresent()) {
            this.advancedFilterService.setModel(null);
            this.onFilterChanged({
                source: "advancedFilter"
            });
        }
    }
    isAdvancedFilterEnabled() {
        var _a;
        return !!((_a = this.advancedFilterService) == null ? void 0 : _a.isEnabled());
    }
    isAdvancedFilterHeaderActive() {
        return this.isAdvancedFilterEnabled() && this.advancedFilterService.isHeaderActive();
    }
    doAggregateFiltersPass(node, filterToSkip) {
        return this.doColumnFiltersPass(node, filterToSkip, true);
    }
    // called by:
    // 1) onFilterChanged()
    // 2) onNewRowsLoaded()
    updateActiveFilters() {
        this.activeColumnFilters.length = 0;
        this.activeAggregateFilters.length = 0;
        const isFilterActive = (filter)=>{
            if (!filter) return false;
            if (!filter.isFilterActive) {
                console.warn("AG Grid: Filter is missing isFilterActive() method");
                return false;
            }
            return filter.isFilterActive();
        };
        const groupFilterEnabled = !!this.gos.getGroupAggFiltering();
        const isAggFilter = (column)=>{
            const isSecondary = !column.isPrimary();
            if (isSecondary) return true;
            const isShowingPrimaryColumns = !this.columnModel.isPivotActive();
            const isValueActive = column.isValueActive();
            if (!isValueActive || !isShowingPrimaryColumns) return false;
            if (this.columnModel.isPivotMode()) return true;
            return groupFilterEnabled;
        };
        this.allColumnFilters.forEach((filterWrapper)=>{
            if (filterWrapper.filterPromise.resolveNow(false, isFilterActive)) {
                const filterComp = filterWrapper.filterPromise.resolveNow(null, (filter)=>filter);
                if (isAggFilter(filterWrapper.column)) this.activeAggregateFilters.push(filterComp);
                else this.activeColumnFilters.push(filterComp);
            }
        });
    }
    updateFilterFlagInColumns(source, additionalEventAttributes) {
        this.allColumnFilters.forEach((filterWrapper)=>{
            const isFilterActive = filterWrapper.filterPromise.resolveNow(false, (filter)=>filter.isFilterActive());
            filterWrapper.column.setFilterActive(isFilterActive, source, additionalEventAttributes);
        });
    }
    isAnyFilterPresent() {
        return this.isQuickFilterPresent() || this.isColumnFilterPresent() || this.isAggregateFilterPresent() || this.isExternalFilterPresent() || this.isAdvancedFilterPresent();
    }
    doColumnFiltersPass(node, filterToSkip, targetAggregates) {
        const { data, aggData } = node;
        const targetedFilters = targetAggregates ? this.activeAggregateFilters : this.activeColumnFilters;
        const targetedData = targetAggregates ? aggData : data;
        for(let i = 0; i < targetedFilters.length; i++){
            const filter = targetedFilters[i];
            if (filter == null || filter === filterToSkip) continue;
            if (typeof filter.doesFilterPass !== "function") throw new Error("Filter is missing method doesFilterPass");
            if (!filter.doesFilterPass({
                node,
                data: targetedData
            })) return false;
        }
        return true;
    }
    resetQuickFilterCache() {
        this.quickFilterService.resetQuickFilterCache();
    }
    refreshFiltersForAggregations() {
        const isAggFiltering = this.gos.getGroupAggFiltering();
        if (isAggFiltering) this.onFilterChanged();
    }
    // sometimes (especially in React) the filter can call onFilterChanged when we are in the middle
    // of a render cycle. this would be bad, so we wait for render cycle to complete when this happens.
    // this happens in react when we change React State in the grid (eg setting RowCtrl's in RowContainer)
    // which results in React State getting applied in the main application, triggering a useEffect() to
    // be kicked off adn then the application calling the grid's API. in AG-6554, the custom filter was
    // getting it's useEffect() triggered in this way.
    callOnFilterChangedOutsideRenderCycle(params) {
        const action = ()=>this.onFilterChanged(params);
        if (this.rowRenderer.isRefreshInProgress()) setTimeout(action, 0);
        else action();
    }
    onFilterChanged(params = {}) {
        const { source, filterInstance, additionalEventAttributes, columns } = params;
        this.updateDependantFilters();
        this.updateActiveFilters();
        this.updateFilterFlagInColumns("filterChanged", additionalEventAttributes);
        this.externalFilterPresent = this.isExternalFilterPresentCallback();
        this.allColumnFilters.forEach((filterWrapper)=>{
            if (!filterWrapper.filterPromise) return;
            filterWrapper.filterPromise.then((filter)=>{
                if (filter && filter !== filterInstance && filter.onAnyFilterChanged) filter.onAnyFilterChanged();
            });
        });
        const filterChangedEvent = {
            source,
            type: Events.EVENT_FILTER_CHANGED,
            columns: columns || []
        };
        if (additionalEventAttributes) mergeDeep(filterChangedEvent, additionalEventAttributes);
        this.processingFilterChange = true;
        this.eventService.dispatchEvent(filterChangedEvent);
        this.processingFilterChange = false;
    }
    isSuppressFlashingCellsBecauseFiltering() {
        var _a;
        const allowShowChangeAfterFilter = (_a = this.gos.get("allowShowChangeAfterFilter")) != null ? _a : false;
        return !allowShowChangeAfterFilter && this.processingFilterChange;
    }
    isQuickFilterPresent() {
        return this.quickFilterService.isQuickFilterPresent();
    }
    updateAggFiltering() {
        this.aggFiltering = !!this.gos.getGroupAggFiltering();
    }
    isAggregateQuickFilterPresent() {
        return this.isQuickFilterPresent() && this.shouldApplyQuickFilterAfterAgg();
    }
    isNonAggregateQuickFilterPresent() {
        return this.isQuickFilterPresent() && !this.shouldApplyQuickFilterAfterAgg();
    }
    shouldApplyQuickFilterAfterAgg() {
        return (this.aggFiltering || this.columnModel.isPivotMode()) && !this.gos.get("applyQuickFilterBeforePivotOrAgg");
    }
    doesRowPassOtherFilters(filterToSkip, node) {
        return this.doesRowPassFilter({
            rowNode: node,
            filterInstanceToSkip: filterToSkip
        });
    }
    doesRowPassAggregateFilters(params) {
        if (this.isAggregateQuickFilterPresent() && !this.quickFilterService.doesRowPassQuickFilter(params.rowNode)) return false;
        if (this.isAggregateFilterPresent() && !this.doAggregateFiltersPass(params.rowNode, params.filterInstanceToSkip)) return false;
        return true;
    }
    doesRowPassFilter(params) {
        if (this.isNonAggregateQuickFilterPresent() && !this.quickFilterService.doesRowPassQuickFilter(params.rowNode)) return false;
        if (this.isExternalFilterPresent() && !this.doesExternalFilterPass(params.rowNode)) return false;
        if (this.isColumnFilterPresent() && !this.doColumnFiltersPass(params.rowNode, params.filterInstanceToSkip)) return false;
        if (this.isAdvancedFilterPresent() && !this.advancedFilterService.doesFilterPass(params.rowNode)) return false;
        return true;
    }
    onNewRowsLoaded(source) {
        this.allColumnFilters.forEach((filterWrapper)=>{
            filterWrapper.filterPromise.then((filter)=>{
                if (filter.onNewRowsLoaded) filter.onNewRowsLoaded();
            });
        });
        this.updateFilterFlagInColumns(source, {
            afterDataChange: true
        });
        this.updateActiveFilters();
    }
    createValueGetter(column) {
        return ({ node })=>this.valueService.getValue(column, node, true);
    }
    createGetValue(filterColumn) {
        return (rowNode, column)=>{
            const columnToUse = column ? this.columnModel.getGridColumn(column) : filterColumn;
            return columnToUse ? this.valueService.getValue(columnToUse, rowNode, true) : void 0;
        };
    }
    getFilterComponent(column, source, createIfDoesNotExist = true) {
        var _a;
        if (createIfDoesNotExist) return ((_a = this.getOrCreateFilterWrapper(column, source)) == null ? void 0 : _a.filterPromise) || null;
        const filterWrapper = this.cachedFilter(column);
        return filterWrapper ? filterWrapper.filterPromise : null;
    }
    isFilterActive(column) {
        const filterWrapper = this.cachedFilter(column);
        return !!filterWrapper && filterWrapper.filterPromise.resolveNow(false, (filter)=>filter.isFilterActive());
    }
    getOrCreateFilterWrapper(column, source) {
        if (!column.isFilterAllowed()) return null;
        let filterWrapper = this.cachedFilter(column);
        if (!filterWrapper) {
            filterWrapper = this.createFilterWrapper(column, source);
            this.setColumnFilterWrapper(column, filterWrapper);
        }
        return filterWrapper;
    }
    cachedFilter(column) {
        return this.allColumnFilters.get(column.getColId());
    }
    getDefaultFilter(column) {
        let defaultFilter;
        if (ModuleRegistry.__isRegistered("@ag-grid-enterprise/set-filter" /* SetFilterModule */ , this.context.getGridId())) defaultFilter = "agSetColumnFilter";
        else {
            const cellDataType = this.dataTypeService.getBaseDataType(column);
            if (cellDataType === "number") defaultFilter = "agNumberColumnFilter";
            else if (cellDataType === "date" || cellDataType === "dateString") defaultFilter = "agDateColumnFilter";
            else defaultFilter = "agTextColumnFilter";
        }
        return defaultFilter;
    }
    getDefaultFloatingFilter(column) {
        let defaultFloatingFilterType;
        if (ModuleRegistry.__isRegistered("@ag-grid-enterprise/set-filter" /* SetFilterModule */ , this.context.getGridId())) defaultFloatingFilterType = "agSetColumnFloatingFilter";
        else {
            const cellDataType = this.dataTypeService.getBaseDataType(column);
            if (cellDataType === "number") defaultFloatingFilterType = "agNumberColumnFloatingFilter";
            else if (cellDataType === "date" || cellDataType === "dateString") defaultFloatingFilterType = "agDateColumnFloatingFilter";
            else defaultFloatingFilterType = "agTextColumnFloatingFilter";
        }
        return defaultFloatingFilterType;
    }
    createFilterInstance(column) {
        const defaultFilter = this.getDefaultFilter(column);
        const colDef = column.getColDef();
        let filterInstance;
        const params = __spreadProps(__spreadValues({}, this.createFilterParams(column, colDef)), {
            filterModifiedCallback: ()=>this.filterModifiedCallbackFactory(filterInstance, column)(),
            filterChangedCallback: (additionalEventAttributes)=>this.filterChangedCallbackFactory(filterInstance, column)(additionalEventAttributes),
            doesRowPassOtherFilter: (node)=>this.doesRowPassOtherFilters(filterInstance, node)
        });
        const compDetails = this.userComponentFactory.getFilterDetails(colDef, params, defaultFilter);
        if (!compDetails) return {
            filterPromise: null,
            compDetails: null
        };
        return {
            filterPromise: ()=>{
                const filterPromise = compDetails.newAgStackInstance();
                if (filterPromise) filterPromise.then((r)=>filterInstance = r);
                return filterPromise;
            },
            compDetails
        };
    }
    createFilterParams(column, colDef) {
        const params = this.gos.addGridCommonParams({
            column,
            colDef: cloneObject(colDef),
            rowModel: this.rowModel,
            filterChangedCallback: ()=>{},
            filterModifiedCallback: ()=>{},
            valueGetter: this.createValueGetter(column),
            getValue: this.createGetValue(column),
            doesRowPassOtherFilter: ()=>true
        });
        return params;
    }
    createFilterWrapper(column, source) {
        var _a;
        const filterWrapper = {
            column,
            filterPromise: null,
            compiledElement: null,
            compDetails: null
        };
        const { filterPromise, compDetails } = this.createFilterInstance(column);
        filterWrapper.filterPromise = (_a = filterPromise == null ? void 0 : filterPromise()) != null ? _a : null;
        filterWrapper.compDetails = compDetails;
        return filterWrapper;
    }
    onColumnsChanged() {
        const columns = [];
        this.allColumnFilters.forEach((wrapper, colId)=>{
            let currentColumn;
            if (wrapper.column.isPrimary()) currentColumn = this.columnModel.getPrimaryColumn(colId);
            else currentColumn = this.columnModel.getGridColumn(colId);
            if (currentColumn && currentColumn === wrapper.column) return;
            columns.push(wrapper.column);
            this.disposeFilterWrapper(wrapper, "columnChanged");
            this.disposeColumnListener(colId);
        });
        if (columns.length > 0) this.onFilterChanged({
            columns,
            source: "api"
        });
        else this.updateDependantFilters();
    }
    updateDependantFilters() {
        const groupColumns = this.columnModel.getGroupAutoColumns();
        groupColumns == null || groupColumns.forEach((groupColumn)=>{
            if (groupColumn.getColDef().filter === "agGroupColumnFilter") this.getOrCreateFilterWrapper(groupColumn, "NO_UI");
        });
    }
    // for group filters, can change dynamically whether they are allowed or not
    isFilterAllowed(column) {
        var _a, _b;
        if (this.isAdvancedFilterEnabled()) return false;
        const isFilterAllowed = column.isFilterAllowed();
        if (!isFilterAllowed) return false;
        const filterWrapper = this.allColumnFilters.get(column.getColId());
        return (_b = (_a = filterWrapper == null ? void 0 : filterWrapper.filterPromise) == null ? void 0 : _a.resolveNow(true, // defer to filter component isFilterAllowed if it exists
        (filter)=>typeof (filter == null ? void 0 : filter.isFilterAllowed) === "function" ? filter == null ? void 0 : filter.isFilterAllowed() : true)) != null ? _b : true;
    }
    getFloatingFilterCompDetails(column, showParentFilter) {
        const parentFilterInstance = (callback)=>{
            const filterComponent = this.getFilterComponent(column, "NO_UI");
            if (filterComponent == null) return;
            filterComponent.then((instance)=>{
                callback(unwrapUserComp(instance));
            });
        };
        const colDef = column.getColDef();
        const filterParams = __spreadProps(__spreadValues({}, this.createFilterParams(column, colDef)), {
            filterChangedCallback: ()=>parentFilterInstance((filterInstance)=>this.filterChangedCallbackFactory(filterInstance, column)())
        });
        const finalFilterParams = this.userComponentFactory.mergeParamsWithApplicationProvidedParams(colDef, FilterComponent, filterParams);
        let defaultFloatingFilterType = this.userComponentFactory.getDefaultFloatingFilterType(colDef, ()=>this.getDefaultFloatingFilter(column));
        if (defaultFloatingFilterType == null) defaultFloatingFilterType = "agReadOnlyFloatingFilter";
        const params = {
            column,
            filterParams: finalFilterParams,
            currentParentModel: ()=>this.getCurrentFloatingFilterParentModel(column),
            parentFilterInstance,
            showParentFilter,
            suppressFilterButton: false
        };
        return this.userComponentFactory.getFloatingFilterCompDetails(colDef, params, defaultFloatingFilterType);
    }
    getCurrentFloatingFilterParentModel(column) {
        const filterComponent = this.getFilterComponent(column, "NO_UI", false);
        return filterComponent ? filterComponent.resolveNow(null, (filter)=>filter && filter.getModel()) : null;
    }
    // destroys the filter, so it no longer takes part
    destroyFilter(column, source = "api") {
        const colId = column.getColId();
        const filterWrapper = this.allColumnFilters.get(colId);
        this.disposeColumnListener(colId);
        delete this.initialFilterModel[colId];
        if (filterWrapper) {
            this.disposeFilterWrapper(filterWrapper, source);
            this.onFilterChanged({
                columns: [
                    column
                ],
                source: "api"
            });
        }
    }
    disposeColumnListener(colId) {
        const columnListener = this.allColumnListeners.get(colId);
        if (columnListener) {
            this.allColumnListeners.delete(colId);
            columnListener();
        }
    }
    disposeFilterWrapper(filterWrapper, source) {
        filterWrapper.filterPromise.then((filter)=>{
            this.getContext().destroyBean(filter);
            filterWrapper.column.setFilterActive(false, "filterDestroyed");
            this.allColumnFilters.delete(filterWrapper.column.getColId());
            const event = {
                type: Events.EVENT_FILTER_DESTROYED,
                source,
                column: filterWrapper.column
            };
            this.eventService.dispatchEvent(event);
        });
    }
    filterModifiedCallbackFactory(filter, column) {
        return ()=>{
            const event = {
                type: Events.EVENT_FILTER_MODIFIED,
                column,
                filterInstance: filter
            };
            this.eventService.dispatchEvent(event);
        };
    }
    filterChangedCallbackFactory(filter, column) {
        return (additionalEventAttributes)=>{
            var _a;
            const source = (_a = additionalEventAttributes == null ? void 0 : additionalEventAttributes.source) != null ? _a : "api";
            const params = {
                filter,
                additionalEventAttributes,
                columns: [
                    column
                ],
                source
            };
            this.callOnFilterChangedOutsideRenderCycle(params);
        };
    }
    checkDestroyFilter(colId) {
        const filterWrapper = this.allColumnFilters.get(colId);
        if (!filterWrapper) return;
        const column = filterWrapper.column;
        const { compDetails } = column.isFilterAllowed() ? this.createFilterInstance(column) : {
            compDetails: null
        };
        if (this.areFilterCompsDifferent(filterWrapper.compDetails, compDetails)) {
            this.destroyFilter(column, "paramsUpdated");
            return;
        }
        const newFilterParams = column.getColDef().filterParams;
        if (!filterWrapper.filterPromise) {
            this.destroyFilter(column, "paramsUpdated");
            return;
        }
        filterWrapper.filterPromise.then((filter)=>{
            const shouldRefreshFilter = (filter == null ? void 0 : filter.refresh) ? filter.refresh(__spreadValues(__spreadProps(__spreadValues({}, this.createFilterParams(column, column.getColDef())), {
                filterModifiedCallback: this.filterModifiedCallbackFactory(filter, column),
                filterChangedCallback: this.filterChangedCallbackFactory(filter, column),
                doesRowPassOtherFilter: (node)=>this.doesRowPassOtherFilters(filter, node)
            }), newFilterParams)) : true;
            if (shouldRefreshFilter === false) this.destroyFilter(column, "paramsUpdated");
        });
    }
    setColumnFilterWrapper(column, filterWrapper) {
        const colId = column.getColId();
        this.allColumnFilters.set(colId, filterWrapper);
        this.allColumnListeners.set(colId, this.addManagedListener(column, Column.EVENT_COL_DEF_CHANGED, ()=>this.checkDestroyFilter(colId)));
    }
    areFilterCompsDifferent(oldCompDetails, newCompDetails) {
        if (!newCompDetails || !oldCompDetails) return true;
        const { componentClass: oldComponentClass } = oldCompDetails;
        const { componentClass: newComponentClass } = newCompDetails;
        const isSameComponentClass = oldComponentClass === newComponentClass || // react hooks returns new wrappers, so check nested render method
        (oldComponentClass == null ? void 0 : oldComponentClass.render) && (newComponentClass == null ? void 0 : newComponentClass.render) && oldComponentClass.render === newComponentClass.render;
        return !isSameComponentClass;
    }
    getAdvancedFilterModel() {
        return this.isAdvancedFilterEnabled() ? this.advancedFilterService.getModel() : null;
    }
    setAdvancedFilterModel(expression) {
        if (!this.isAdvancedFilterEnabled()) return;
        if (this.dataTypeService.isPendingInference()) {
            this.advancedFilterModelUpdateQueue.push(expression);
            return;
        }
        this.advancedFilterService.setModel(expression != null ? expression : null);
        this.onFilterChanged({
            source: "advancedFilter"
        });
    }
    showAdvancedFilterBuilder(source) {
        if (!this.isAdvancedFilterEnabled()) return;
        this.advancedFilterService.getCtrl().toggleFilterBuilder(source, true);
    }
    updateAdvancedFilterColumns() {
        if (!this.isAdvancedFilterEnabled()) return;
        if (this.advancedFilterService.updateValidity()) this.onFilterChanged({
            source: "advancedFilter"
        });
    }
    hasFloatingFilters() {
        if (this.isAdvancedFilterEnabled()) return false;
        const gridColumns = this.columnModel.getAllGridColumns();
        return gridColumns.some((col)=>col.getColDef().floatingFilter);
    }
    getFilterInstance(key, callback) {
        if (this.isAdvancedFilterEnabled()) {
            this.warnAdvancedFilters();
            return void 0;
        }
        const res = this.getFilterInstanceImpl(key, (instance)=>{
            if (!callback) return;
            const unwrapped2 = unwrapUserComp(instance);
            callback(unwrapped2);
        });
        const unwrapped = unwrapUserComp(res);
        return unwrapped;
    }
    getColumnFilterInstance(key) {
        return new Promise((resolve)=>{
            this.getFilterInstance(key, (filter)=>{
                resolve(filter);
            });
        });
    }
    getFilterInstanceImpl(key, callback) {
        const column = this.columnModel.getPrimaryColumn(key);
        if (!column) return void 0;
        const filterPromise = this.getFilterComponent(column, "NO_UI");
        const currentValue = filterPromise && filterPromise.resolveNow(null, (filterComp)=>filterComp);
        if (currentValue) setTimeout(callback, 0, currentValue);
        else if (filterPromise) filterPromise.then((comp)=>{
            callback(comp);
        });
        return currentValue;
    }
    warnAdvancedFilters() {
        warnOnce("Column Filter API methods have been disabled as Advanced Filters are enabled.");
    }
    setupAdvancedFilterHeaderComp(eCompToInsertBefore) {
        var _a;
        (_a = this.advancedFilterService) == null || _a.getCtrl().setupHeaderComp(eCompToInsertBefore);
    }
    getHeaderRowCount() {
        return this.isAdvancedFilterHeaderActive() ? 1 : 0;
    }
    getHeaderHeight() {
        return this.isAdvancedFilterHeaderActive() ? this.advancedFilterService.getCtrl().getHeaderHeight() : 0;
    }
    processFilterModelUpdateQueue() {
        this.filterModelUpdateQueue.forEach(({ model, source })=>this.setFilterModel(model, source));
        this.filterModelUpdateQueue = [];
        this.columnFilterModelUpdateQueue.forEach(({ key, model, resolve })=>{
            this.setColumnFilterModel(key, model).then(()=>resolve());
        });
        this.columnFilterModelUpdateQueue = [];
        this.advancedFilterModelUpdateQueue.forEach((model)=>this.setAdvancedFilterModel(model));
        this.advancedFilterModelUpdateQueue = [];
    }
    getColumnFilterModel(key) {
        const filterWrapper = this.getFilterWrapper(key);
        return filterWrapper ? this.getModelFromFilterWrapper(filterWrapper) : null;
    }
    setColumnFilterModel(key, model) {
        if (this.isAdvancedFilterEnabled()) {
            this.warnAdvancedFilters();
            return Promise.resolve();
        }
        if (this.dataTypeService.isPendingInference()) {
            let resolve = ()=>{};
            const promise = new Promise((res)=>{
                resolve = res;
            });
            this.columnFilterModelUpdateQueue.push({
                key,
                model,
                resolve
            });
            return promise;
        }
        const column = this.columnModel.getPrimaryColumn(key);
        const filterWrapper = column ? this.getOrCreateFilterWrapper(column, "NO_UI") : null;
        const convertPromise = (promise)=>{
            return new Promise((resolve)=>{
                promise.then((result)=>resolve(result));
            });
        };
        return filterWrapper ? convertPromise(this.setModelOnFilterWrapper(filterWrapper.filterPromise, model)) : Promise.resolve();
    }
    getFilterWrapper(key) {
        var _a;
        const column = this.columnModel.getPrimaryColumn(key);
        return column ? (_a = this.cachedFilter(column)) != null ? _a : null : null;
    }
    destroy() {
        super.destroy();
        this.allColumnFilters.forEach((filterWrapper)=>this.disposeFilterWrapper(filterWrapper, "gridDestroyed"));
        this.allColumnListeners.clear();
    }
};
__decorateClass([
    Autowired("valueService")
], FilterManager.prototype, "valueService", 2);
__decorateClass([
    Autowired("columnModel")
], FilterManager.prototype, "columnModel", 2);
__decorateClass([
    Autowired("rowModel")
], FilterManager.prototype, "rowModel", 2);
__decorateClass([
    Autowired("userComponentFactory")
], FilterManager.prototype, "userComponentFactory", 2);
__decorateClass([
    Autowired("rowRenderer")
], FilterManager.prototype, "rowRenderer", 2);
__decorateClass([
    Autowired("dataTypeService")
], FilterManager.prototype, "dataTypeService", 2);
__decorateClass([
    Autowired("quickFilterService")
], FilterManager.prototype, "quickFilterService", 2);
__decorateClass([
    Optional("advancedFilterService")
], FilterManager.prototype, "advancedFilterService", 2);
__decorateClass([
    PostConstruct
], FilterManager.prototype, "init", 1);
FilterManager = __decorateClass([
    Bean("filterManager")
], FilterManager);
// community-modules/core/src/filter/filterWrapperComp.ts
var FilterWrapperComp = class extends Component {
    constructor(column, source){
        super(/* html */ `<div class="ag-filter"></div>`);
        this.column = column;
        this.source = source;
        this.filterWrapper = null;
    }
    postConstruct() {
        this.createFilter(true);
        this.addManagedListener(this.eventService, Events.EVENT_FILTER_DESTROYED, this.onFilterDestroyed.bind(this));
    }
    hasFilter() {
        return !!this.filterWrapper;
    }
    getFilter() {
        var _a, _b;
        return (_b = (_a = this.filterWrapper) == null ? void 0 : _a.filterPromise) != null ? _b : null;
    }
    afterInit() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.filterWrapper) == null ? void 0 : _a.filterPromise) == null ? void 0 : _b.then(()=>{})) != null ? _c : AgPromise.resolve();
    }
    afterGuiAttached(params) {
        var _a, _b;
        (_b = (_a = this.filterWrapper) == null ? void 0 : _a.filterPromise) == null || _b.then((filter)=>{
            var _a2;
            (_a2 = filter == null ? void 0 : filter.afterGuiAttached) == null || _a2.call(filter, params);
        });
    }
    afterGuiDetached() {
        var _a, _b;
        (_b = (_a = this.filterWrapper) == null ? void 0 : _a.filterPromise) == null || _b.then((filter)=>{
            var _a2;
            (_a2 = filter == null ? void 0 : filter.afterGuiDetached) == null || _a2.call(filter);
        });
    }
    createFilter(init) {
        var _a;
        const { column, source } = this;
        this.filterWrapper = this.filterManager.getOrCreateFilterWrapper(column, source);
        if (!((_a = this.filterWrapper) == null ? void 0 : _a.filterPromise)) return;
        this.filterWrapper.filterPromise.then((filter)=>{
            let guiFromFilter = filter.getGui();
            if (!exists(guiFromFilter)) console.warn(`AG Grid: getGui method from filter returned ${guiFromFilter}, it should be a DOM element or an HTML template string.`);
            if (typeof guiFromFilter === "string") guiFromFilter = loadTemplate(guiFromFilter);
            this.appendChild(guiFromFilter);
            if (init) {
                const event = {
                    type: Events.EVENT_FILTER_OPENED,
                    column,
                    source,
                    eGui: this.getGui()
                };
                this.eventService.dispatchEvent(event);
            }
        });
    }
    onFilterDestroyed(event) {
        if ((event.source === "api" || event.source === "paramsUpdated") && event.column.getId() === this.column.getId() && this.columnModel.getPrimaryColumn(this.column)) {
            clearElement(this.getGui());
            this.createFilter();
        }
    }
    destroy() {
        this.filterWrapper = null;
        super.destroy();
    }
};
__decorateClass([
    Autowired("filterManager")
], FilterWrapperComp.prototype, "filterManager", 2);
__decorateClass([
    Autowired("columnModel")
], FilterWrapperComp.prototype, "columnModel", 2);
__decorateClass([
    PostConstruct
], FilterWrapperComp.prototype, "postConstruct", 1);
// community-modules/core/src/headerRendering/cells/abstractCell/abstractHeaderCellComp.ts
var AbstractHeaderCellComp = class extends Component {
    constructor(template, ctrl){
        super(template);
        this.ctrl = ctrl;
    }
    getCtrl() {
        return this.ctrl;
    }
};
// community-modules/core/src/headerRendering/cells/floatingFilter/headerFilterCellComp.ts
var _HeaderFilterCellComp = class _HeaderFilterCellComp extends AbstractHeaderCellComp {
    constructor(ctrl){
        super(_HeaderFilterCellComp.TEMPLATE, ctrl);
    }
    postConstruct() {
        const eGui = this.getGui();
        const compProxy = {
            addOrRemoveCssClass: (cssClassName, on)=>this.addOrRemoveCssClass(cssClassName, on),
            addOrRemoveBodyCssClass: (cssClassName, on)=>this.eFloatingFilterBody.classList.toggle(cssClassName, on),
            setButtonWrapperDisplayed: (displayed)=>setDisplayed(this.eButtonWrapper, displayed),
            setCompDetails: (compDetails)=>this.setCompDetails(compDetails),
            getFloatingFilterComp: ()=>this.compPromise,
            setWidth: (width)=>eGui.style.width = width,
            setMenuIcon: (eIcon)=>this.eButtonShowMainFilter.appendChild(eIcon)
        };
        this.ctrl.setComp(compProxy, eGui, this.eButtonShowMainFilter, this.eFloatingFilterBody);
    }
    setCompDetails(compDetails) {
        if (!compDetails) {
            this.destroyFloatingFilterComp();
            this.compPromise = null;
            return;
        }
        this.compPromise = compDetails.newAgStackInstance();
        this.compPromise.then((comp)=>this.afterCompCreated(comp));
    }
    destroyFloatingFilterComp() {
        if (this.floatingFilterComp) {
            this.eFloatingFilterBody.removeChild(this.floatingFilterComp.getGui());
            this.floatingFilterComp = this.destroyBean(this.floatingFilterComp);
        }
    }
    afterCompCreated(comp) {
        if (!comp) return;
        if (!this.isAlive()) {
            this.destroyBean(comp);
            return;
        }
        this.destroyFloatingFilterComp();
        this.floatingFilterComp = comp;
        this.eFloatingFilterBody.appendChild(comp.getGui());
        if (comp.afterGuiAttached) comp.afterGuiAttached();
    }
};
_HeaderFilterCellComp.TEMPLATE = /* html */ `<div class="ag-header-cell ag-floating-filter" role="gridcell">
            <div ref="eFloatingFilterBody" role="presentation"></div>
            <div class="ag-floating-filter-button ag-hidden" ref="eButtonWrapper" role="presentation">
                <button type="button" class="ag-button ag-floating-filter-button-button" ref="eButtonShowMainFilter" tabindex="-1"></button>
            </div>
        </div>`;
__decorateClass([
    RefSelector("eFloatingFilterBody")
], _HeaderFilterCellComp.prototype, "eFloatingFilterBody", 2);
__decorateClass([
    RefSelector("eButtonWrapper")
], _HeaderFilterCellComp.prototype, "eButtonWrapper", 2);
__decorateClass([
    RefSelector("eButtonShowMainFilter")
], _HeaderFilterCellComp.prototype, "eButtonShowMainFilter", 2);
__decorateClass([
    PostConstruct
], _HeaderFilterCellComp.prototype, "postConstruct", 1);
__decorateClass([
    PreDestroy
], _HeaderFilterCellComp.prototype, "destroyFloatingFilterComp", 1);
var HeaderFilterCellComp = _HeaderFilterCellComp;
// community-modules/core/src/styling/layoutFeature.ts
var LayoutCssClasses = /* @__PURE__ */ ((LayoutCssClasses2)=>{
    LayoutCssClasses2["AUTO_HEIGHT"] = "ag-layout-auto-height";
    LayoutCssClasses2["NORMAL"] = "ag-layout-normal";
    LayoutCssClasses2["PRINT"] = "ag-layout-print";
    return LayoutCssClasses2;
})(LayoutCssClasses || {});
var LayoutFeature = class extends BeanStub {
    constructor(view){
        super();
        this.view = view;
    }
    postConstruct() {
        this.addManagedPropertyListener("domLayout", this.updateLayoutClasses.bind(this));
        this.updateLayoutClasses();
    }
    updateLayoutClasses() {
        const domLayout = this.getDomLayout();
        const params = {
            autoHeight: domLayout === "autoHeight",
            normal: domLayout === "normal",
            print: domLayout === "print"
        };
        const cssClass = params.autoHeight ? "ag-layout-auto-height" /* AUTO_HEIGHT */  : params.print ? "ag-layout-print" /* PRINT */  : "ag-layout-normal" /* NORMAL */ ;
        this.view.updateLayoutClasses(cssClass, params);
    }
    // returns either 'print', 'autoHeight' or 'normal' (normal is the default)
    getDomLayout() {
        var _a;
        const domLayout = (_a = this.gos.get("domLayout")) != null ? _a : "normal";
        const validLayouts = [
            "normal",
            "print",
            "autoHeight"
        ];
        if (validLayouts.indexOf(domLayout) === -1) {
            warnOnce(`${domLayout} is not valid for DOM Layout, valid values are 'normal', 'autoHeight', 'print'.`);
            return "normal";
        }
        return domLayout;
    }
};
__decorateClass([
    PostConstruct
], LayoutFeature.prototype, "postConstruct", 1);
// community-modules/core/src/gridBodyComp/gridBodyScrollFeature.ts
var GridBodyScrollFeature = class extends BeanStub {
    constructor(eBodyViewport){
        super();
        this.lastScrollSource = [
            null,
            null
        ];
        this.scrollLeft = -1;
        this.nextScrollTop = -1;
        this.scrollTop = -1;
        // Used to provide approximate values of scrollTop and offsetHeight
        // without forcing the browser to recalculate styles.
        this.lastOffsetHeight = -1;
        this.lastScrollTop = -1;
        this.eBodyViewport = eBodyViewport;
        this.resetLastHScrollDebounced = debounce(()=>this.lastScrollSource[1 /* Horizontal */ ] = null, 500);
        this.resetLastVScrollDebounced = debounce(()=>this.lastScrollSource[0 /* Vertical */ ] = null, 500);
    }
    postConstruct() {
        this.enableRtl = this.gos.get("enableRtl");
        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onDisplayedColumnsWidthChanged.bind(this));
        this.ctrlsService.whenReady((p)=>{
            this.centerRowsCtrl = p.center;
            this.onDisplayedColumnsWidthChanged();
            this.addScrollListener();
        });
    }
    addScrollListener() {
        const { fakeHScrollComp, fakeVScrollComp } = this.ctrlsService.getParams();
        this.addManagedListener(this.centerRowsCtrl.getViewportElement(), "scroll", this.onHScroll.bind(this));
        fakeHScrollComp.onScrollCallback(this.onFakeHScroll.bind(this));
        const isDebounce = this.gos.get("debounceVerticalScrollbar");
        const onVScroll = isDebounce ? debounce(this.onVScroll.bind(this), 100) : this.onVScroll.bind(this);
        const onFakeVScroll = isDebounce ? debounce(this.onFakeVScroll.bind(this), 100) : this.onFakeVScroll.bind(this);
        this.addManagedListener(this.eBodyViewport, "scroll", onVScroll);
        fakeVScrollComp.onScrollCallback(onFakeVScroll);
    }
    onDisplayedColumnsWidthChanged() {
        if (this.enableRtl) this.horizontallyScrollHeaderCenterAndFloatingCenter();
    }
    horizontallyScrollHeaderCenterAndFloatingCenter(scrollLeft) {
        const notYetInitialised = this.centerRowsCtrl == null;
        if (notYetInitialised) return;
        if (scrollLeft === void 0) scrollLeft = this.centerRowsCtrl.getCenterViewportScrollLeft();
        const offset = this.enableRtl ? scrollLeft : -scrollLeft;
        const { topCenter, stickyTopCenter, stickyBottomCenter, centerHeader, bottomCenter, fakeHScrollComp } = this.ctrlsService.getParams();
        centerHeader.setHorizontalScroll(-offset);
        bottomCenter.setContainerTranslateX(offset);
        topCenter.setContainerTranslateX(offset);
        stickyTopCenter.setContainerTranslateX(offset);
        stickyBottomCenter.setContainerTranslateX(offset);
        const centerViewport = this.centerRowsCtrl.getViewportElement();
        const isCenterViewportLastHorizontal = this.lastScrollSource[1 /* Horizontal */ ] === 0 /* Container */ ;
        scrollLeft = Math.abs(scrollLeft);
        if (isCenterViewportLastHorizontal) fakeHScrollComp.setScrollPosition(scrollLeft);
        else setScrollLeft(centerViewport, scrollLeft, this.enableRtl);
    }
    isControllingScroll(source, direction) {
        if (this.lastScrollSource[direction] == null) {
            this.lastScrollSource[direction] = source;
            return true;
        }
        return this.lastScrollSource[direction] === source;
    }
    onFakeHScroll() {
        if (!this.isControllingScroll(1 /* FakeContainer */ , 1 /* Horizontal */ )) return;
        this.onHScrollCommon(1 /* FakeContainer */ );
    }
    onHScroll() {
        if (!this.isControllingScroll(0 /* Container */ , 1 /* Horizontal */ )) return;
        this.onHScrollCommon(0 /* Container */ );
    }
    onHScrollCommon(source) {
        const centerContainerViewport = this.centerRowsCtrl.getViewportElement();
        const { scrollLeft } = centerContainerViewport;
        if (this.shouldBlockScrollUpdate(1 /* Horizontal */ , scrollLeft, true)) return;
        let newScrollLeft;
        if (source === 0 /* Container */ ) newScrollLeft = getScrollLeft(centerContainerViewport, this.enableRtl);
        else newScrollLeft = this.ctrlsService.get("fakeHScrollComp").getScrollPosition();
        this.doHorizontalScroll(Math.round(newScrollLeft));
        this.resetLastHScrollDebounced();
    }
    onFakeVScroll() {
        if (!this.isControllingScroll(1 /* FakeContainer */ , 0 /* Vertical */ )) return;
        this.onVScrollCommon(1 /* FakeContainer */ );
    }
    onVScroll() {
        if (!this.isControllingScroll(0 /* Container */ , 0 /* Vertical */ )) return;
        this.onVScrollCommon(0 /* Container */ );
    }
    onVScrollCommon(source) {
        let scrollTop;
        if (source === 0 /* Container */ ) scrollTop = this.eBodyViewport.scrollTop;
        else scrollTop = this.ctrlsService.get("fakeVScrollComp").getScrollPosition();
        if (this.shouldBlockScrollUpdate(0 /* Vertical */ , scrollTop, true)) return;
        this.animationFrameService.setScrollTop(scrollTop);
        this.nextScrollTop = scrollTop;
        if (source === 0 /* Container */ ) this.ctrlsService.get("fakeVScrollComp").setScrollPosition(scrollTop);
        else this.eBodyViewport.scrollTop = scrollTop;
        if (this.gos.get("suppressAnimationFrame")) this.scrollGridIfNeeded();
        else this.animationFrameService.schedule();
        this.resetLastVScrollDebounced();
    }
    doHorizontalScroll(scrollLeft) {
        const fakeScrollLeft = this.ctrlsService.get("fakeHScrollComp").getScrollPosition();
        if (this.scrollLeft === scrollLeft && scrollLeft === fakeScrollLeft) return;
        this.scrollLeft = scrollLeft;
        this.fireScrollEvent(1 /* Horizontal */ );
        this.horizontallyScrollHeaderCenterAndFloatingCenter(scrollLeft);
        this.centerRowsCtrl.onHorizontalViewportChanged(true);
    }
    fireScrollEvent(direction) {
        const bodyScrollEvent = {
            type: Events.EVENT_BODY_SCROLL,
            direction: direction === 1 /* Horizontal */  ? "horizontal" : "vertical",
            left: this.scrollLeft,
            top: this.scrollTop
        };
        this.eventService.dispatchEvent(bodyScrollEvent);
        window.clearTimeout(this.scrollTimer);
        this.scrollTimer = void 0;
        this.scrollTimer = window.setTimeout(()=>{
            const bodyScrollEndEvent = __spreadProps(__spreadValues({}, bodyScrollEvent), {
                type: Events.EVENT_BODY_SCROLL_END
            });
            this.eventService.dispatchEvent(bodyScrollEndEvent);
        }, 100);
    }
    shouldBlockScrollUpdate(direction, scrollTo, touchOnly = false) {
        if (touchOnly && !isIOSUserAgent()) return false;
        if (direction === 0 /* Vertical */ ) return this.shouldBlockVerticalScroll(scrollTo);
        return this.shouldBlockHorizontalScroll(scrollTo);
    }
    shouldBlockVerticalScroll(scrollTo) {
        const clientHeight = getInnerHeight(this.eBodyViewport);
        const { scrollHeight } = this.eBodyViewport;
        if (scrollTo < 0 || scrollTo + clientHeight > scrollHeight) return true;
        return false;
    }
    shouldBlockHorizontalScroll(scrollTo) {
        const clientWidth = this.centerRowsCtrl.getCenterWidth();
        const { scrollWidth } = this.centerRowsCtrl.getViewportElement();
        if (this.enableRtl && isRtlNegativeScroll()) {
            if (scrollTo > 0) return true;
        } else if (scrollTo < 0) return true;
        if (Math.abs(scrollTo) + clientWidth > scrollWidth) return true;
        return false;
    }
    redrawRowsAfterScroll() {
        this.fireScrollEvent(0 /* Vertical */ );
    }
    // this is to cater for AG-3274, where grid is removed from the dom and then inserted back in again.
    // (which happens with some implementations of tabbing). this can result in horizontal scroll getting
    // reset back to the left, however no scroll event is fired. so we need to get header to also scroll
    // back to the left to be kept in sync.
    // adding and removing the grid from the DOM both resets the scroll position and
    // triggers a resize event, so notify listeners if the scroll position has changed
    checkScrollLeft() {
        if (this.scrollLeft !== this.centerRowsCtrl.getCenterViewportScrollLeft()) this.onHScrollCommon(0 /* Container */ );
    }
    scrollGridIfNeeded() {
        const frameNeeded = this.scrollTop != this.nextScrollTop;
        if (frameNeeded) {
            this.scrollTop = this.nextScrollTop;
            this.redrawRowsAfterScroll();
        }
        return frameNeeded;
    }
    // called by scrollHorizontally method and alignedGridsService
    setHorizontalScrollPosition(hScrollPosition, fromAlignedGridsService = false) {
        const minScrollLeft = 0;
        const maxScrollLeft = this.centerRowsCtrl.getViewportElement().scrollWidth - this.centerRowsCtrl.getCenterWidth();
        if (!fromAlignedGridsService && this.shouldBlockScrollUpdate(1 /* Horizontal */ , hScrollPosition)) {
            if (this.enableRtl && isRtlNegativeScroll()) hScrollPosition = hScrollPosition > 0 ? 0 : maxScrollLeft;
            else hScrollPosition = Math.min(Math.max(hScrollPosition, minScrollLeft), maxScrollLeft);
        }
        setScrollLeft(this.centerRowsCtrl.getViewportElement(), Math.abs(hScrollPosition), this.enableRtl);
        this.doHorizontalScroll(hScrollPosition);
    }
    setVerticalScrollPosition(vScrollPosition) {
        this.eBodyViewport.scrollTop = vScrollPosition;
    }
    getVScrollPosition() {
        this.lastScrollTop = this.eBodyViewport.scrollTop;
        this.lastOffsetHeight = this.eBodyViewport.offsetHeight;
        const result = {
            top: this.lastScrollTop,
            bottom: this.lastScrollTop + this.lastOffsetHeight
        };
        return result;
    }
    /** Get an approximate scroll position that returns the last real value read.
   * This is useful for avoiding repeated DOM reads that force the browser to recalculate styles.
   * This can have big performance improvements but may not be 100% accurate so only use if this is acceptable.
   */ getApproximateVScollPosition() {
        if (this.lastScrollTop >= 0 && this.lastOffsetHeight >= 0) return {
            top: this.scrollTop,
            bottom: this.scrollTop + this.lastOffsetHeight
        };
        return this.getVScrollPosition();
    }
    getHScrollPosition() {
        return this.centerRowsCtrl.getHScrollPosition();
    }
    isHorizontalScrollShowing() {
        return this.centerRowsCtrl.isHorizontalScrollShowing();
    }
    // called by the headerRootComp and moveColumnController
    scrollHorizontally(pixels) {
        const oldScrollPosition = this.centerRowsCtrl.getViewportElement().scrollLeft;
        this.setHorizontalScrollPosition(oldScrollPosition + pixels);
        return this.centerRowsCtrl.getViewportElement().scrollLeft - oldScrollPosition;
    }
    // gets called by rowRenderer when new data loaded, as it will want to scroll to the top
    scrollToTop() {
        this.eBodyViewport.scrollTop = 0;
    }
    // Valid values for position are bottom, middle and top
    ensureNodeVisible(comparator, position = null) {
        const rowCount = this.rowModel.getRowCount();
        let indexToSelect = -1;
        for(let i = 0; i < rowCount; i++){
            const node = this.rowModel.getRow(i);
            if (typeof comparator === "function") {
                const predicate = comparator;
                if (node && predicate(node)) {
                    indexToSelect = i;
                    break;
                }
            } else if (comparator === node || comparator === node.data) {
                indexToSelect = i;
                break;
            }
        }
        if (indexToSelect >= 0) this.ensureIndexVisible(indexToSelect, position);
    }
    // Valid values for position are bottom, middle and top
    // position should be {'top','middle','bottom', or undefined/null}.
    // if undefined/null, then the grid will to the minimal amount of scrolling,
    // eg if grid needs to scroll up, it scrolls until row is on top,
    //    if grid needs to scroll down, it scrolls until row is on bottom,
    //    if row is already in view, grid does not scroll
    ensureIndexVisible(index, position) {
        if (this.gos.isDomLayout("print")) return;
        const rowCount = this.paginationProxy.getRowCount();
        if (typeof index !== "number" || index < 0 || index >= rowCount) {
            console.warn("AG Grid: Invalid row index for ensureIndexVisible: " + index);
            return;
        }
        const isPaging = this.gos.get("pagination");
        const paginationPanelEnabled = isPaging && !this.gos.get("suppressPaginationPanel");
        this.getFrameworkOverrides().wrapIncoming(()=>{
            if (!paginationPanelEnabled) this.paginationProxy.goToPageWithIndex(index);
            const gridBodyCtrl = this.ctrlsService.getGridBodyCtrl();
            const stickyTopHeight = gridBodyCtrl.getStickyTopHeight();
            const stickyBottomHeight = gridBodyCtrl.getStickyBottomHeight();
            const rowNode = this.paginationProxy.getRow(index);
            let rowGotShiftedDuringOperation;
            do {
                const startingRowTop = rowNode.rowTop;
                const startingRowHeight = rowNode.rowHeight;
                const paginationOffset = this.paginationProxy.getPixelOffset();
                const rowTopPixel = rowNode.rowTop - paginationOffset;
                const rowBottomPixel = rowTopPixel + rowNode.rowHeight;
                const scrollPosition = this.getVScrollPosition();
                const heightOffset = this.heightScaler.getDivStretchOffset();
                const vScrollTop = scrollPosition.top + heightOffset;
                const vScrollBottom = scrollPosition.bottom + heightOffset;
                const viewportHeight = vScrollBottom - vScrollTop;
                const pxTop = this.heightScaler.getScrollPositionForPixel(rowTopPixel);
                const pxBottom = this.heightScaler.getScrollPositionForPixel(rowBottomPixel - viewportHeight);
                const pxMiddle = Math.min((pxTop + pxBottom) / 2, rowTopPixel);
                const rowAboveViewport = vScrollTop + stickyTopHeight > rowTopPixel;
                const rowBelowViewport = vScrollBottom - stickyBottomHeight < rowBottomPixel;
                let newScrollPosition = null;
                if (position === "top") newScrollPosition = pxTop;
                else if (position === "bottom") newScrollPosition = pxBottom;
                else if (position === "middle") newScrollPosition = pxMiddle;
                else if (rowAboveViewport) newScrollPosition = pxTop - stickyTopHeight;
                else if (rowBelowViewport) newScrollPosition = pxBottom + stickyBottomHeight;
                if (newScrollPosition !== null) {
                    this.setVerticalScrollPosition(newScrollPosition);
                    this.rowRenderer.redraw({
                        afterScroll: true
                    });
                }
                rowGotShiftedDuringOperation = startingRowTop !== rowNode.rowTop || startingRowHeight !== rowNode.rowHeight;
            }while (rowGotShiftedDuringOperation);
            this.animationFrameService.flushAllFrames();
        });
    }
    ensureColumnVisible(key, position = "auto") {
        const column = this.columnModel.getGridColumn(key);
        if (!column) return;
        if (column.isPinned()) return;
        if (!this.columnModel.isColumnDisplayed(column)) return;
        const newHorizontalScroll = this.getPositionedHorizontalScroll(column, position);
        this.getFrameworkOverrides().wrapIncoming(()=>{
            if (newHorizontalScroll !== null) this.centerRowsCtrl.setCenterViewportScrollLeft(newHorizontalScroll);
            this.centerRowsCtrl.onHorizontalViewportChanged();
            this.animationFrameService.flushAllFrames();
        });
    }
    setScrollPosition(top, left) {
        this.getFrameworkOverrides().wrapIncoming(()=>{
            this.centerRowsCtrl.setCenterViewportScrollLeft(left);
            this.setVerticalScrollPosition(top);
            this.rowRenderer.redraw({
                afterScroll: true
            });
            this.animationFrameService.flushAllFrames();
        });
    }
    getPositionedHorizontalScroll(column, position) {
        const { columnBeforeStart, columnAfterEnd } = this.isColumnOutsideViewport(column);
        const viewportTooSmallForColumn = this.centerRowsCtrl.getCenterWidth() < column.getActualWidth();
        const viewportWidth = this.centerRowsCtrl.getCenterWidth();
        const isRtl = this.enableRtl;
        let alignColToStart = (isRtl ? columnBeforeStart : columnAfterEnd) || viewportTooSmallForColumn;
        let alignColToEnd = isRtl ? columnAfterEnd : columnBeforeStart;
        if (position !== "auto") {
            alignColToStart = position === "start";
            alignColToEnd = position === "end";
        }
        const isMiddle = position === "middle";
        if (alignColToStart || alignColToEnd || isMiddle) {
            const { colLeft, colMiddle, colRight } = this.getColumnBounds(column);
            if (isMiddle) return colMiddle - viewportWidth / 2;
            if (alignColToStart) return isRtl ? colRight : colLeft;
            return isRtl ? colLeft - viewportWidth : colRight - viewportWidth;
        }
        return null;
    }
    isColumnOutsideViewport(column) {
        const { start: viewportStart, end: viewportEnd } = this.getViewportBounds();
        const { colLeft, colRight } = this.getColumnBounds(column);
        const isRtl = this.enableRtl;
        const columnBeforeStart = isRtl ? viewportStart > colRight : viewportEnd < colRight;
        const columnAfterEnd = isRtl ? viewportEnd < colLeft : viewportStart > colLeft;
        return {
            columnBeforeStart,
            columnAfterEnd
        };
    }
    getColumnBounds(column) {
        const isRtl = this.enableRtl;
        const bodyWidth = this.columnModel.getBodyContainerWidth();
        const colWidth = column.getActualWidth();
        const colLeft = column.getLeft();
        const multiplier = isRtl ? -1 : 1;
        const colLeftPixel = isRtl ? bodyWidth - colLeft : colLeft;
        const colRightPixel = colLeftPixel + colWidth * multiplier;
        const colMidPixel = colLeftPixel + colWidth / 2 * multiplier;
        return {
            colLeft: colLeftPixel,
            colMiddle: colMidPixel,
            colRight: colRightPixel
        };
    }
    getViewportBounds() {
        const viewportWidth = this.centerRowsCtrl.getCenterWidth();
        const scrollPosition = this.centerRowsCtrl.getCenterViewportScrollLeft();
        const viewportStartPixel = scrollPosition;
        const viewportEndPixel = viewportWidth + scrollPosition;
        return {
            start: viewportStartPixel,
            end: viewportEndPixel,
            width: viewportWidth
        };
    }
};
__decorateClass([
    Autowired("ctrlsService")
], GridBodyScrollFeature.prototype, "ctrlsService", 2);
__decorateClass([
    Autowired("animationFrameService")
], GridBodyScrollFeature.prototype, "animationFrameService", 2);
__decorateClass([
    Autowired("paginationProxy")
], GridBodyScrollFeature.prototype, "paginationProxy", 2);
__decorateClass([
    Autowired("rowModel")
], GridBodyScrollFeature.prototype, "rowModel", 2);
__decorateClass([
    Autowired("rowContainerHeightService")
], GridBodyScrollFeature.prototype, "heightScaler", 2);
__decorateClass([
    Autowired("rowRenderer")
], GridBodyScrollFeature.prototype, "rowRenderer", 2);
__decorateClass([
    Autowired("columnModel")
], GridBodyScrollFeature.prototype, "columnModel", 2);
__decorateClass([
    PostConstruct
], GridBodyScrollFeature.prototype, "postConstruct", 1);
// community-modules/core/src/gridBodyComp/gridBodyCtrl.ts
var RowAnimationCssClasses = /* @__PURE__ */ ((RowAnimationCssClasses2)=>{
    RowAnimationCssClasses2["ANIMATION_ON"] = "ag-row-animation";
    RowAnimationCssClasses2["ANIMATION_OFF"] = "ag-row-no-animation";
    return RowAnimationCssClasses2;
})(RowAnimationCssClasses || {});
var CSS_CLASS_FORCE_VERTICAL_SCROLL = "ag-force-vertical-scroll";
var CSS_CLASS_CELL_SELECTABLE = "ag-selectable";
var CSS_CLASS_COLUMN_MOVING = "ag-column-moving";
var GridBodyCtrl = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.stickyTopHeight = 0;
        this.stickyBottomHeight = 0;
    }
    getScrollFeature() {
        return this.bodyScrollFeature;
    }
    getBodyViewportElement() {
        return this.eBodyViewport;
    }
    setComp(comp, eGridBody, eBodyViewport, eTop, eBottom, eStickyTop, eStickyBottom) {
        this.comp = comp;
        this.eGridBody = eGridBody;
        this.eBodyViewport = eBodyViewport;
        this.eTop = eTop;
        this.eBottom = eBottom;
        this.eStickyTop = eStickyTop;
        this.eStickyBottom = eStickyBottom;
        this.setCellTextSelection(this.gos.get("enableCellTextSelection"));
        this.addManagedPropertyListener("enableCellTextSelection", (props)=>this.setCellTextSelection(props.currentValue));
        this.createManagedBean(new LayoutFeature(this.comp));
        this.bodyScrollFeature = this.createManagedBean(new GridBodyScrollFeature(this.eBodyViewport));
        this.addRowDragListener();
        this.setupRowAnimationCssClass();
        this.addEventListeners();
        this.addFocusListeners([
            eTop,
            eBodyViewport,
            eBottom,
            eStickyTop,
            eStickyBottom
        ]);
        this.onGridColumnsChanged();
        this.addBodyViewportListener();
        this.setFloatingHeights();
        this.disableBrowserDragging();
        this.addStopEditingWhenGridLosesFocus();
        this.filterManager.setupAdvancedFilterHeaderComp(eTop);
        this.ctrlsService.register("gridBodyCtrl", this);
    }
    getComp() {
        return this.comp;
    }
    addEventListeners() {
        this.addManagedListener(this.eventService, Events.EVENT_GRID_COLUMNS_CHANGED, this.onGridColumnsChanged.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_SCROLL_VISIBILITY_CHANGED, this.onScrollVisibilityChanged.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_PINNED_ROW_DATA_CHANGED, this.onPinnedRowDataChanged.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_HEADER_HEIGHT_CHANGED, this.onHeaderHeightChanged.bind(this));
    }
    addFocusListeners(elements) {
        elements.forEach((element)=>{
            this.addManagedListener(element, "focusin", (e)=>{
                const { target } = e;
                const isFocusedElementNested = isElementChildOfClass(target, "ag-root", element);
                element.classList.toggle("ag-has-focus", !isFocusedElementNested);
            });
            this.addManagedListener(element, "focusout", (e)=>{
                const { target, relatedTarget } = e;
                const gridContainRelatedTarget = element.contains(relatedTarget);
                const isNestedRelatedTarget = isElementChildOfClass(relatedTarget, "ag-root", element);
                const isNestedTarget = isElementChildOfClass(target, "ag-root", element);
                if (isNestedTarget) return;
                if (!gridContainRelatedTarget || isNestedRelatedTarget) element.classList.remove("ag-has-focus");
            });
        });
    }
    // used by ColumnAnimationService
    setColumnMovingCss(moving) {
        this.comp.setColumnMovingCss(CSS_CLASS_COLUMN_MOVING, moving);
    }
    setCellTextSelection(selectable = false) {
        this.comp.setCellSelectableCss(CSS_CLASS_CELL_SELECTABLE, selectable);
    }
    onScrollVisibilityChanged() {
        const visible = this.scrollVisibleService.isVerticalScrollShowing();
        this.setVerticalScrollPaddingVisible(visible);
        this.setStickyWidth(visible);
        this.setStickyBottomOffsetBottom();
        const scrollbarWidth = visible ? this.gos.getScrollbarWidth() || 0 : 0;
        const pad = isInvisibleScrollbar() ? 16 : 0;
        const width = `calc(100% + ${scrollbarWidth + pad}px)`;
        this.animationFrameService.requestAnimationFrame(()=>this.comp.setBodyViewportWidth(width));
    }
    onGridColumnsChanged() {
        const columns = this.columnModel.getAllGridColumns();
        this.comp.setColumnCount(columns.length);
    }
    // if we do not do this, then the user can select a pic in the grid (eg an image in a custom cell renderer)
    // and then that will start the browser native drag n' drop, which messes up with our own drag and drop.
    disableBrowserDragging() {
        this.addManagedListener(this.eGridBody, "dragstart", (event)=>{
            if (event.target instanceof HTMLImageElement) {
                event.preventDefault();
                return false;
            }
        });
    }
    addStopEditingWhenGridLosesFocus() {
        if (!this.gos.get("stopEditingWhenCellsLoseFocus")) return;
        const focusOutListener = (event)=>{
            const elementWithFocus = event.relatedTarget;
            if (getTabIndex(elementWithFocus) === null) {
                this.rowRenderer.stopEditing();
                return;
            }
            let clickInsideGrid = // see if click came from inside the viewports
            viewports.some((viewport)=>viewport.contains(elementWithFocus)) && this.mouseEventService.isElementInThisGrid(elementWithFocus);
            if (!clickInsideGrid) {
                const popupService = this.popupService;
                clickInsideGrid = popupService.getActivePopups().some((popup)=>popup.contains(elementWithFocus)) || popupService.isElementWithinCustomPopup(elementWithFocus);
            }
            if (!clickInsideGrid) this.rowRenderer.stopEditing();
        };
        const viewports = [
            this.eBodyViewport,
            this.eBottom,
            this.eTop,
            this.eStickyTop,
            this.eStickyBottom
        ];
        viewports.forEach((viewport)=>this.addManagedListener(viewport, "focusout", focusOutListener));
    }
    updateRowCount() {
        const headerCount = this.headerNavigationService.getHeaderRowCount() + this.filterManager.getHeaderRowCount();
        const rowCount = this.rowModel.isLastRowIndexKnown() ? this.rowModel.getRowCount() : -1;
        const total = rowCount === -1 ? -1 : headerCount + rowCount;
        this.comp.setRowCount(total);
    }
    registerBodyViewportResizeListener(listener) {
        this.comp.registerBodyViewportResizeListener(listener);
    }
    setVerticalScrollPaddingVisible(visible) {
        const overflowY = visible ? "scroll" : "hidden";
        this.comp.setPinnedTopBottomOverflowY(overflowY);
    }
    isVerticalScrollShowing() {
        const show = this.gos.get("alwaysShowVerticalScroll");
        const cssClass = show ? CSS_CLASS_FORCE_VERTICAL_SCROLL : null;
        const allowVerticalScroll = this.gos.isDomLayout("normal");
        this.comp.setAlwaysVerticalScrollClass(cssClass, show);
        return show || allowVerticalScroll && isVerticalScrollShowing(this.eBodyViewport);
    }
    setupRowAnimationCssClass() {
        const listener = ()=>{
            const animateRows = this.gos.isAnimateRows() && !this.rowContainerHeightService.isStretching();
            const animateRowsCssClass = animateRows ? "ag-row-animation" /* ANIMATION_ON */  : "ag-row-no-animation" /* ANIMATION_OFF */ ;
            this.comp.setRowAnimationCssOnBodyViewport(animateRowsCssClass, animateRows);
        };
        listener();
        this.addManagedListener(this.eventService, Events.EVENT_HEIGHT_SCALE_CHANGED, listener);
        this.addManagedPropertyListener("animateRows", listener);
    }
    getGridBodyElement() {
        return this.eGridBody;
    }
    addBodyViewportListener() {
        const listener = this.onBodyViewportContextMenu.bind(this);
        this.addManagedListener(this.eBodyViewport, "contextmenu", listener);
        this.mockContextMenuForIPad(listener);
        this.addManagedListener(this.eBodyViewport, "wheel", this.onBodyViewportWheel.bind(this));
        this.addManagedListener(this.eStickyTop, "wheel", this.onStickyWheel.bind(this));
        this.addManagedListener(this.eStickyBottom, "wheel", this.onStickyWheel.bind(this));
        this.addFullWidthContainerWheelListener();
    }
    addFullWidthContainerWheelListener() {
        const fullWidthContainer = this.eBodyViewport.querySelector(".ag-full-width-container");
        const eCenterColsViewport = this.eBodyViewport.querySelector(".ag-center-cols-viewport");
        if (fullWidthContainer && eCenterColsViewport) this.addManagedListener(fullWidthContainer, "wheel", (e)=>this.onFullWidthContainerWheel(e, eCenterColsViewport));
    }
    onFullWidthContainerWheel(e, eCenterColsViewport) {
        if (!e.deltaX || Math.abs(e.deltaY) > Math.abs(e.deltaX) || !this.mouseEventService.isEventFromThisGrid(e)) return;
        e.preventDefault();
        eCenterColsViewport.scrollBy({
            left: e.deltaX
        });
    }
    onBodyViewportContextMenu(mouseEvent, touch, touchEvent) {
        if (!mouseEvent && !touchEvent) return;
        if (this.gos.get("preventDefaultOnContextMenu")) {
            const event = mouseEvent || touchEvent;
            event.preventDefault();
        }
        const { target } = mouseEvent || touch;
        if (target === this.eBodyViewport || target === this.ctrlsService.get("center").getViewportElement()) this.menuService.showContextMenu({
            mouseEvent,
            touchEvent,
            value: null,
            anchorToElement: this.eGridBody
        });
    }
    mockContextMenuForIPad(listener) {
        if (!isIOSUserAgent()) return;
        const touchListener = new TouchListener(this.eBodyViewport);
        const longTapListener = (event)=>{
            listener(void 0, event.touchStart, event.touchEvent);
        };
        this.addManagedListener(touchListener, TouchListener.EVENT_LONG_TAP, longTapListener);
        this.addDestroyFunc(()=>touchListener.destroy());
    }
    onBodyViewportWheel(e) {
        if (!this.gos.get("suppressScrollWhenPopupsAreOpen")) return;
        if (this.popupService.hasAnchoredPopup()) e.preventDefault();
    }
    onStickyWheel(e) {
        e.preventDefault();
        if (e.offsetY) this.scrollVertically(e.deltaY);
    }
    getGui() {
        return this.eGridBody;
    }
    // called by rowDragFeature
    scrollVertically(pixels) {
        const oldScrollPosition = this.eBodyViewport.scrollTop;
        this.bodyScrollFeature.setVerticalScrollPosition(oldScrollPosition + pixels);
        return this.eBodyViewport.scrollTop - oldScrollPosition;
    }
    addRowDragListener() {
        this.rowDragFeature = this.createManagedBean(new RowDragFeature(this.eBodyViewport));
        this.dragAndDropService.addDropTarget(this.rowDragFeature);
    }
    getRowDragFeature() {
        return this.rowDragFeature;
    }
    onPinnedRowDataChanged() {
        this.setFloatingHeights();
    }
    setFloatingHeights() {
        const { pinnedRowModel } = this;
        let floatingTopHeight = pinnedRowModel.getPinnedTopTotalHeight();
        let floatingBottomHeight = pinnedRowModel.getPinnedBottomTotalHeight();
        this.comp.setTopHeight(floatingTopHeight);
        this.comp.setBottomHeight(floatingBottomHeight);
        this.comp.setTopDisplay(floatingTopHeight ? "inherit" : "none");
        this.comp.setBottomDisplay(floatingBottomHeight ? "inherit" : "none");
        this.setStickyTopOffsetTop();
        this.setStickyBottomOffsetBottom();
    }
    setStickyTopHeight(height = 0) {
        this.comp.setStickyTopHeight(`${height}px`);
        this.stickyTopHeight = height;
    }
    getStickyTopHeight() {
        return this.stickyTopHeight;
    }
    setStickyBottomHeight(height = 0) {
        this.comp.setStickyBottomHeight(`${height}px`);
        this.stickyBottomHeight = height;
    }
    getStickyBottomHeight() {
        return this.stickyBottomHeight;
    }
    setStickyWidth(vScrollVisible) {
        if (!vScrollVisible) {
            this.comp.setStickyTopWidth("100%");
            this.comp.setStickyBottomWidth("100%");
        } else {
            const scrollbarWidth = this.gos.getScrollbarWidth();
            this.comp.setStickyTopWidth(`calc(100% - ${scrollbarWidth}px)`);
            this.comp.setStickyBottomWidth(`calc(100% - ${scrollbarWidth}px)`);
        }
    }
    onHeaderHeightChanged() {
        this.setStickyTopOffsetTop();
    }
    setStickyTopOffsetTop() {
        const headerCtrl = this.ctrlsService.get("gridHeaderCtrl");
        const headerHeight = headerCtrl.getHeaderHeight() + this.filterManager.getHeaderHeight();
        const pinnedTopHeight = this.pinnedRowModel.getPinnedTopTotalHeight();
        let height = 0;
        if (headerHeight > 0) height += headerHeight;
        if (pinnedTopHeight > 0) height += pinnedTopHeight;
        if (height > 0) height += 1;
        this.comp.setStickyTopTop(`${height}px`);
    }
    setStickyBottomOffsetBottom() {
        const pinnedBottomHeight = this.pinnedRowModel.getPinnedBottomTotalHeight();
        const hScrollShowing = this.scrollVisibleService.isHorizontalScrollShowing();
        const scrollbarWidth = hScrollShowing ? this.gos.getScrollbarWidth() || 0 : 0;
        const height = pinnedBottomHeight + scrollbarWidth;
        this.comp.setStickyBottomBottom(`${height}px`);
    }
    // method will call itself if no available width. this covers if the grid
    // isn't visible, but is just about to be visible.
    sizeColumnsToFit(params, nextTimeout) {
        const removeScrollWidth = this.isVerticalScrollShowing();
        const scrollWidthToRemove = removeScrollWidth ? this.gos.getScrollbarWidth() : 0;
        const bodyViewportWidth = getInnerWidth(this.eGridBody);
        const availableWidth = bodyViewportWidth - scrollWidthToRemove;
        if (availableWidth > 0) {
            this.columnModel.sizeColumnsToFit(availableWidth, "sizeColumnsToFit", false, params);
            return;
        }
        if (nextTimeout === void 0) window.setTimeout(()=>{
            this.sizeColumnsToFit(params, 100);
        }, 0);
        else if (nextTimeout === 100) window.setTimeout(()=>{
            this.sizeColumnsToFit(params, 500);
        }, 100);
        else if (nextTimeout === 500) window.setTimeout(()=>{
            this.sizeColumnsToFit(params, -1);
        }, 500);
        else console.warn("AG Grid: tried to call sizeColumnsToFit() but the grid is coming back with zero width, maybe the grid is not visible yet on the screen?");
    }
    // + rangeService
    addScrollEventListener(listener) {
        this.eBodyViewport.addEventListener("scroll", listener, {
            passive: true
        });
    }
    // + focusService
    removeScrollEventListener(listener) {
        this.eBodyViewport.removeEventListener("scroll", listener);
    }
};
__decorateClass([
    Autowired("animationFrameService")
], GridBodyCtrl.prototype, "animationFrameService", 2);
__decorateClass([
    Autowired("rowContainerHeightService")
], GridBodyCtrl.prototype, "rowContainerHeightService", 2);
__decorateClass([
    Autowired("ctrlsService")
], GridBodyCtrl.prototype, "ctrlsService", 2);
__decorateClass([
    Autowired("columnModel")
], GridBodyCtrl.prototype, "columnModel", 2);
__decorateClass([
    Autowired("scrollVisibleService")
], GridBodyCtrl.prototype, "scrollVisibleService", 2);
__decorateClass([
    Autowired("menuService")
], GridBodyCtrl.prototype, "menuService", 2);
__decorateClass([
    Autowired("headerNavigationService")
], GridBodyCtrl.prototype, "headerNavigationService", 2);
__decorateClass([
    Autowired("dragAndDropService")
], GridBodyCtrl.prototype, "dragAndDropService", 2);
__decorateClass([
    Autowired("pinnedRowModel")
], GridBodyCtrl.prototype, "pinnedRowModel", 2);
__decorateClass([
    Autowired("rowRenderer")
], GridBodyCtrl.prototype, "rowRenderer", 2);
__decorateClass([
    Autowired("popupService")
], GridBodyCtrl.prototype, "popupService", 2);
__decorateClass([
    Autowired("mouseEventService")
], GridBodyCtrl.prototype, "mouseEventService", 2);
__decorateClass([
    Autowired("rowModel")
], GridBodyCtrl.prototype, "rowModel", 2);
__decorateClass([
    Autowired("filterManager")
], GridBodyCtrl.prototype, "filterManager", 2);
// community-modules/core/src/interfaces/IRangeService.ts
var SelectionHandleType = /* @__PURE__ */ ((SelectionHandleType2)=>{
    SelectionHandleType2[SelectionHandleType2["FILL"] = 0] = "FILL";
    SelectionHandleType2[SelectionHandleType2["RANGE"] = 1] = "RANGE";
    return SelectionHandleType2;
})(SelectionHandleType || {});
var CellRangeType = /* @__PURE__ */ ((CellRangeType2)=>{
    CellRangeType2[CellRangeType2["VALUE"] = 0] = "VALUE";
    CellRangeType2[CellRangeType2["DIMENSION"] = 1] = "DIMENSION";
    return CellRangeType2;
})(CellRangeType || {});
// community-modules/core/src/rendering/cell/cellRangeFeature.ts
var CSS_CELL_RANGE_SELECTED = "ag-cell-range-selected";
var CSS_CELL_RANGE_CHART = "ag-cell-range-chart";
var CSS_CELL_RANGE_SINGLE_CELL = "ag-cell-range-single-cell";
var CSS_CELL_RANGE_CHART_CATEGORY = "ag-cell-range-chart-category";
var CSS_CELL_RANGE_HANDLE = "ag-cell-range-handle";
var CSS_CELL_RANGE_TOP = "ag-cell-range-top";
var CSS_CELL_RANGE_RIGHT = "ag-cell-range-right";
var CSS_CELL_RANGE_BOTTOM = "ag-cell-range-bottom";
var CSS_CELL_RANGE_LEFT = "ag-cell-range-left";
var CellRangeFeature = class {
    constructor(beans, ctrl){
        this.beans = beans;
        this.rangeService = beans.rangeService;
        this.selectionHandleFactory = beans.selectionHandleFactory;
        this.cellCtrl = ctrl;
    }
    setComp(cellComp, eGui) {
        this.cellComp = cellComp;
        this.eGui = eGui;
        this.onRangeSelectionChanged();
    }
    onRangeSelectionChanged() {
        if (!this.cellComp) return;
        this.rangeCount = this.rangeService.getCellRangeCount(this.cellCtrl.getCellPosition());
        this.hasChartRange = this.getHasChartRange();
        this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_SELECTED, this.rangeCount !== 0);
        this.cellComp.addOrRemoveCssClass(`${CSS_CELL_RANGE_SELECTED}-1`, this.rangeCount === 1);
        this.cellComp.addOrRemoveCssClass(`${CSS_CELL_RANGE_SELECTED}-2`, this.rangeCount === 2);
        this.cellComp.addOrRemoveCssClass(`${CSS_CELL_RANGE_SELECTED}-3`, this.rangeCount === 3);
        this.cellComp.addOrRemoveCssClass(`${CSS_CELL_RANGE_SELECTED}-4`, this.rangeCount >= 4);
        this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_CHART, this.hasChartRange);
        setAriaSelected(this.eGui, this.rangeCount > 0 ? true : void 0);
        this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_SINGLE_CELL, this.isSingleCell());
        this.updateRangeBorders();
        this.refreshHandle();
    }
    updateRangeBorders() {
        const rangeBorders = this.getRangeBorders();
        const isSingleCell = this.isSingleCell();
        const isTop = !isSingleCell && rangeBorders.top;
        const isRight = !isSingleCell && rangeBorders.right;
        const isBottom = !isSingleCell && rangeBorders.bottom;
        const isLeft = !isSingleCell && rangeBorders.left;
        this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_TOP, isTop);
        this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_RIGHT, isRight);
        this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_BOTTOM, isBottom);
        this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_LEFT, isLeft);
    }
    isSingleCell() {
        const { rangeService } = this.beans;
        return this.rangeCount === 1 && !!rangeService && !rangeService.isMoreThanOneCell();
    }
    getHasChartRange() {
        const { rangeService } = this.beans;
        if (!this.rangeCount || !rangeService) return false;
        const cellRanges = rangeService.getCellRanges();
        return cellRanges.length > 0 && cellRanges.every((range)=>includes([
                1 /* DIMENSION */ ,
                0 /* VALUE */ 
            ], range.type));
    }
    updateRangeBordersIfRangeCount() {
        if (this.rangeCount > 0) {
            this.updateRangeBorders();
            this.refreshHandle();
        }
    }
    getRangeBorders() {
        const isRtl = this.beans.gos.get("enableRtl");
        let top = false;
        let right = false;
        let bottom = false;
        let left = false;
        const thisCol = this.cellCtrl.getCellPosition().column;
        const columnModel = this.beans.columnModel;
        let leftCol;
        let rightCol;
        if (isRtl) {
            leftCol = columnModel.getDisplayedColAfter(thisCol);
            rightCol = columnModel.getDisplayedColBefore(thisCol);
        } else {
            leftCol = columnModel.getDisplayedColBefore(thisCol);
            rightCol = columnModel.getDisplayedColAfter(thisCol);
        }
        const ranges = this.rangeService.getCellRanges().filter((range)=>this.rangeService.isCellInSpecificRange(this.cellCtrl.getCellPosition(), range));
        if (!leftCol) left = true;
        if (!rightCol) right = true;
        for(let i = 0; i < ranges.length; i++){
            if (top && right && bottom && left) break;
            const range = ranges[i];
            const startRow = this.rangeService.getRangeStartRow(range);
            const endRow = this.rangeService.getRangeEndRow(range);
            if (!top && this.beans.rowPositionUtils.sameRow(startRow, this.cellCtrl.getCellPosition())) top = true;
            if (!bottom && this.beans.rowPositionUtils.sameRow(endRow, this.cellCtrl.getCellPosition())) bottom = true;
            if (!left && leftCol && range.columns.indexOf(leftCol) < 0) left = true;
            if (!right && rightCol && range.columns.indexOf(rightCol) < 0) right = true;
        }
        return {
            top,
            right,
            bottom,
            left
        };
    }
    refreshHandle() {
        if (this.beans.context.isDestroyed()) return;
        const shouldHaveSelectionHandle = this.shouldHaveSelectionHandle();
        if (this.selectionHandle && !shouldHaveSelectionHandle) this.selectionHandle = this.beans.context.destroyBean(this.selectionHandle);
        if (shouldHaveSelectionHandle) this.addSelectionHandle();
        this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_HANDLE, !!this.selectionHandle);
    }
    shouldHaveSelectionHandle() {
        const gos = this.beans.gos;
        const cellRanges = this.rangeService.getCellRanges();
        const rangesLen = cellRanges.length;
        if (this.rangeCount < 1 || rangesLen < 1) return false;
        const cellRange = last(cellRanges);
        const cellPosition = this.cellCtrl.getCellPosition();
        const isFillHandleAvailable = gos.get("enableFillHandle") && !this.cellCtrl.isSuppressFillHandle();
        const isRangeHandleAvailable = gos.get("enableRangeHandle");
        let handleIsAvailable = rangesLen === 1 && !this.cellCtrl.isEditing() && (isFillHandleAvailable || isRangeHandleAvailable);
        if (this.hasChartRange) {
            const hasCategoryRange = cellRanges[0].type === 1 /* DIMENSION */ ;
            const isCategoryCell = hasCategoryRange && this.rangeService.isCellInSpecificRange(cellPosition, cellRanges[0]);
            this.cellComp.addOrRemoveCssClass(CSS_CELL_RANGE_CHART_CATEGORY, isCategoryCell);
            handleIsAvailable = cellRange.type === 0 /* VALUE */ ;
        }
        return handleIsAvailable && cellRange.endRow != null && this.rangeService.isContiguousRange(cellRange) && this.rangeService.isBottomRightCell(cellRange, cellPosition);
    }
    addSelectionHandle() {
        const gos = this.beans.gos;
        const cellRangeType = last(this.rangeService.getCellRanges()).type;
        const selectionHandleFill = gos.get("enableFillHandle") && missing(cellRangeType);
        const type = selectionHandleFill ? 0 /* FILL */  : 1 /* RANGE */ ;
        if (this.selectionHandle && this.selectionHandle.getType() !== type) this.selectionHandle = this.beans.context.destroyBean(this.selectionHandle);
        if (!this.selectionHandle) this.selectionHandle = this.selectionHandleFactory.createSelectionHandle(type);
        this.selectionHandle.refresh(this.cellCtrl);
    }
    destroy() {
        this.beans.context.destroyBean(this.selectionHandle);
    }
};
// community-modules/core/src/rendering/cell/cellPositionFeature.ts
var CellPositionFeature = class extends BeanStub {
    constructor(ctrl, beans){
        super();
        this.cellCtrl = ctrl;
        this.beans = beans;
        this.column = ctrl.getColumn();
        this.rowNode = ctrl.getRowNode();
    }
    setupRowSpan() {
        this.rowSpan = this.column.getRowSpan(this.rowNode);
        this.addManagedListener(this.beans.eventService, Events.EVENT_NEW_COLUMNS_LOADED, ()=>this.onNewColumnsLoaded());
    }
    setComp(eGui) {
        this.eGui = eGui;
        this.setupColSpan();
        this.setupRowSpan();
        this.onLeftChanged();
        this.onWidthChanged();
        this.applyRowSpan();
    }
    onNewColumnsLoaded() {
        const rowSpan = this.column.getRowSpan(this.rowNode);
        if (this.rowSpan === rowSpan) return;
        this.rowSpan = rowSpan;
        this.applyRowSpan(true);
    }
    onDisplayColumnsChanged() {
        const colsSpanning = this.getColSpanningList();
        if (!areEqual(this.colsSpanning, colsSpanning)) {
            this.colsSpanning = colsSpanning;
            this.onWidthChanged();
            this.onLeftChanged();
        }
    }
    setupColSpan() {
        if (this.column.getColDef().colSpan == null) return;
        this.colsSpanning = this.getColSpanningList();
        this.addManagedListener(this.beans.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayColumnsChanged.bind(this));
        this.addManagedListener(this.beans.eventService, Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onWidthChanged.bind(this));
    }
    onWidthChanged() {
        if (!this.eGui) return;
        const width = this.getCellWidth();
        this.eGui.style.width = `${width}px`;
    }
    getCellWidth() {
        if (!this.colsSpanning) return this.column.getActualWidth();
        return this.colsSpanning.reduce((width, col)=>width + col.getActualWidth(), 0);
    }
    getColSpanningList() {
        const colSpan = this.column.getColSpan(this.rowNode);
        const colsSpanning = [];
        if (colSpan === 1) colsSpanning.push(this.column);
        else {
            let pointer = this.column;
            const pinned = this.column.getPinned();
            for(let i = 0; pointer && i < colSpan; i++){
                colsSpanning.push(pointer);
                pointer = this.beans.columnModel.getDisplayedColAfter(pointer);
                if (!pointer || missing(pointer)) break;
                if (pinned !== pointer.getPinned()) break;
            }
        }
        return colsSpanning;
    }
    onLeftChanged() {
        if (!this.eGui) return;
        const left = this.modifyLeftForPrintLayout(this.getCellLeft());
        this.eGui.style.left = left + "px";
    }
    getCellLeft() {
        let mostLeftCol;
        if (this.beans.gos.get("enableRtl") && this.colsSpanning) mostLeftCol = last(this.colsSpanning);
        else mostLeftCol = this.column;
        return mostLeftCol.getLeft();
    }
    modifyLeftForPrintLayout(leftPosition) {
        if (!this.cellCtrl.isPrintLayout() || this.column.getPinned() === "left") return leftPosition;
        const leftWidth = this.beans.columnModel.getDisplayedColumnsLeftWidth();
        if (this.column.getPinned() === "right") {
            const bodyWidth = this.beans.columnModel.getBodyContainerWidth();
            return leftWidth + bodyWidth + (leftPosition || 0);
        }
        return leftWidth + (leftPosition || 0);
    }
    applyRowSpan(force) {
        if (this.rowSpan === 1 && !force) return;
        const singleRowHeight = this.beans.gos.getRowHeightAsNumber();
        const totalRowHeight = singleRowHeight * this.rowSpan;
        this.eGui.style.height = `${totalRowHeight}px`;
        this.eGui.style.zIndex = "1";
    }
    // overriding to make public, as we don't dispose this bean via context
    destroy() {
        super.destroy();
    }
};
// community-modules/core/src/rendering/cell/cellCustomStyleFeature.ts
var CellCustomStyleFeature = class extends BeanStub {
    constructor(ctrl, beans){
        super();
        this.staticClasses = [];
        this.cellCtrl = ctrl;
        this.beans = beans;
        this.column = ctrl.getColumn();
        this.rowNode = ctrl.getRowNode();
    }
    setComp(comp) {
        this.cellComp = comp;
        this.applyUserStyles();
        this.applyCellClassRules();
        this.applyClassesFromColDef();
    }
    applyCellClassRules() {
        const colDef = this.column.getColDef();
        const { cellClassRules } = colDef;
        const cellClassParams = this.beans.gos.addGridCommonParams({
            value: this.cellCtrl.getValue(),
            data: this.rowNode.data,
            node: this.rowNode,
            colDef,
            column: this.column,
            rowIndex: this.rowNode.rowIndex
        });
        this.beans.stylingService.processClassRules(// if current was previous, skip
        cellClassRules === this.cellClassRules ? void 0 : this.cellClassRules, cellClassRules, cellClassParams, (className)=>this.cellComp.addOrRemoveCssClass(className, true), (className)=>this.cellComp.addOrRemoveCssClass(className, false));
        this.cellClassRules = cellClassRules;
    }
    applyUserStyles() {
        const colDef = this.column.getColDef();
        if (!colDef.cellStyle) return;
        let styles;
        if (typeof colDef.cellStyle === "function") {
            const cellStyleParams = this.beans.gos.addGridCommonParams({
                column: this.column,
                value: this.cellCtrl.getValue(),
                colDef,
                data: this.rowNode.data,
                node: this.rowNode,
                rowIndex: this.rowNode.rowIndex
            });
            const cellStyleFunc = colDef.cellStyle;
            styles = cellStyleFunc(cellStyleParams);
        } else styles = colDef.cellStyle;
        if (styles) this.cellComp.setUserStyles(styles);
    }
    applyClassesFromColDef() {
        const colDef = this.column.getColDef();
        const cellClassParams = this.beans.gos.addGridCommonParams({
            value: this.cellCtrl.getValue(),
            data: this.rowNode.data,
            node: this.rowNode,
            column: this.column,
            colDef,
            rowIndex: this.rowNode.rowIndex
        });
        if (this.staticClasses.length) this.staticClasses.forEach((className)=>this.cellComp.addOrRemoveCssClass(className, false));
        this.staticClasses = this.beans.stylingService.getStaticCellClasses(colDef, cellClassParams);
        if (this.staticClasses.length) this.staticClasses.forEach((className)=>this.cellComp.addOrRemoveCssClass(className, true));
    }
    // overriding to make public, as we don't dispose this bean via context
    destroy() {
        super.destroy();
    }
};
// community-modules/core/src/rendering/beans.ts
var Beans = class {
    postConstruct() {
        if (this.gos.isRowModelType("clientSide")) this.clientSideRowModel = this.rowModel;
        if (this.gos.isRowModelType("serverSide")) this.serverSideRowModel = this.rowModel;
    }
};
__decorateClass([
    Autowired("resizeObserverService")
], Beans.prototype, "resizeObserverService", 2);
__decorateClass([
    Autowired("paginationProxy")
], Beans.prototype, "paginationProxy", 2);
__decorateClass([
    Autowired("context")
], Beans.prototype, "context", 2);
__decorateClass([
    Autowired("gridOptionsService")
], Beans.prototype, "gos", 2);
__decorateClass([
    Autowired("environment")
], Beans.prototype, "environment", 2);
__decorateClass([
    Autowired("rowRenderer")
], Beans.prototype, "rowRenderer", 2);
__decorateClass([
    Autowired("valueService")
], Beans.prototype, "valueService", 2);
__decorateClass([
    Autowired("eventService")
], Beans.prototype, "eventService", 2);
__decorateClass([
    Autowired("columnModel")
], Beans.prototype, "columnModel", 2);
__decorateClass([
    Autowired("headerNavigationService")
], Beans.prototype, "headerNavigationService", 2);
__decorateClass([
    Autowired("navigationService")
], Beans.prototype, "navigationService", 2);
__decorateClass([
    Autowired("columnAnimationService")
], Beans.prototype, "columnAnimationService", 2);
__decorateClass([
    Autowired("focusService")
], Beans.prototype, "focusService", 2);
__decorateClass([
    Autowired("popupService")
], Beans.prototype, "popupService", 2);
__decorateClass([
    Autowired("stylingService")
], Beans.prototype, "stylingService", 2);
__decorateClass([
    Autowired("columnHoverService")
], Beans.prototype, "columnHoverService", 2);
__decorateClass([
    Autowired("userComponentFactory")
], Beans.prototype, "userComponentFactory", 2);
__decorateClass([
    Autowired("userComponentRegistry")
], Beans.prototype, "userComponentRegistry", 2);
__decorateClass([
    Autowired("animationFrameService")
], Beans.prototype, "animationFrameService", 2);
__decorateClass([
    Autowired("dragService")
], Beans.prototype, "dragService", 2);
__decorateClass([
    Autowired("dragAndDropService")
], Beans.prototype, "dragAndDropService", 2);
__decorateClass([
    Autowired("sortController")
], Beans.prototype, "sortController", 2);
__decorateClass([
    Autowired("filterManager")
], Beans.prototype, "filterManager", 2);
__decorateClass([
    Autowired("rowContainerHeightService")
], Beans.prototype, "rowContainerHeightService", 2);
__decorateClass([
    Autowired("frameworkOverrides")
], Beans.prototype, "frameworkOverrides", 2);
__decorateClass([
    Autowired("cellPositionUtils")
], Beans.prototype, "cellPositionUtils", 2);
__decorateClass([
    Autowired("rowPositionUtils")
], Beans.prototype, "rowPositionUtils", 2);
__decorateClass([
    Autowired("selectionService")
], Beans.prototype, "selectionService", 2);
__decorateClass([
    Autowired("rowCssClassCalculator")
], Beans.prototype, "rowCssClassCalculator", 2);
__decorateClass([
    Autowired("rowModel")
], Beans.prototype, "rowModel", 2);
__decorateClass([
    Autowired("ctrlsService")
], Beans.prototype, "ctrlsService", 2);
__decorateClass([
    Autowired("ctrlsFactory")
], Beans.prototype, "ctrlsFactory", 2);
__decorateClass([
    Autowired("agStackComponentsRegistry")
], Beans.prototype, "agStackComponentsRegistry", 2);
__decorateClass([
    Autowired("valueCache")
], Beans.prototype, "valueCache", 2);
__decorateClass([
    Autowired("rowNodeEventThrottle")
], Beans.prototype, "rowNodeEventThrottle", 2);
__decorateClass([
    Autowired("localeService")
], Beans.prototype, "localeService", 2);
__decorateClass([
    Autowired("syncService")
], Beans.prototype, "syncService", 2);
__decorateClass([
    Autowired("ariaAnnouncementService")
], Beans.prototype, "ariaAnnouncementService", 2);
__decorateClass([
    Optional("rangeService")
], Beans.prototype, "rangeService", 2);
__decorateClass([
    Optional("selectionHandleFactory")
], Beans.prototype, "selectionHandleFactory", 2);
__decorateClass([
    PostConstruct
], Beans.prototype, "postConstruct", 1);
Beans = __decorateClass([
    Bean("beans")
], Beans);
// community-modules/core/src/rendering/cell/cellMouseListenerFeature.ts
var CellMouseListenerFeature = class extends Beans {
    constructor(ctrl, beans, column){
        super();
        this.cellCtrl = ctrl;
        this.beans = beans;
        this.column = column;
    }
    onMouseEvent(eventName, mouseEvent) {
        if (isStopPropagationForAgGrid(mouseEvent)) return;
        switch(eventName){
            case "click":
                this.onCellClicked(mouseEvent);
                break;
            case "mousedown":
            case "touchstart":
                this.onMouseDown(mouseEvent);
                break;
            case "dblclick":
                this.onCellDoubleClicked(mouseEvent);
                break;
            case "mouseout":
                this.onMouseOut(mouseEvent);
                break;
            case "mouseover":
                this.onMouseOver(mouseEvent);
                break;
        }
    }
    onCellClicked(mouseEvent) {
        if (this.isDoubleClickOnIPad()) {
            this.onCellDoubleClicked(mouseEvent);
            mouseEvent.preventDefault();
            return;
        }
        const { eventService, rangeService, gos } = this.beans;
        const isMultiKey = mouseEvent.ctrlKey || mouseEvent.metaKey;
        if (rangeService && isMultiKey) {
            if (rangeService.getCellRangeCount(this.cellCtrl.getCellPosition()) > 1) rangeService.intersectLastRange(true);
        }
        const cellClickedEvent = this.cellCtrl.createEvent(mouseEvent, Events.EVENT_CELL_CLICKED);
        eventService.dispatchEvent(cellClickedEvent);
        const colDef = this.column.getColDef();
        if (colDef.onCellClicked) window.setTimeout(()=>{
            this.beans.frameworkOverrides.wrapOutgoing(()=>{
                colDef.onCellClicked(cellClickedEvent);
            });
        }, 0);
        const editOnSingleClick = (gos.get("singleClickEdit") || colDef.singleClickEdit) && !gos.get("suppressClickEdit");
        if (editOnSingleClick && !(mouseEvent.shiftKey && (rangeService == null ? void 0 : rangeService.getCellRanges().length) != 0)) this.cellCtrl.startRowOrCellEdit();
    }
    // returns true if on iPad and this is second 'click' event in 200ms
    isDoubleClickOnIPad() {
        if (!isIOSUserAgent() || isEventSupported("dblclick")) return false;
        const nowMillis = /* @__PURE__ */ new Date().getTime();
        const res = nowMillis - this.lastIPadMouseClickEvent < 200;
        this.lastIPadMouseClickEvent = nowMillis;
        return res;
    }
    onCellDoubleClicked(mouseEvent) {
        const colDef = this.column.getColDef();
        const cellDoubleClickedEvent = this.cellCtrl.createEvent(mouseEvent, Events.EVENT_CELL_DOUBLE_CLICKED);
        this.beans.eventService.dispatchEvent(cellDoubleClickedEvent);
        if (typeof colDef.onCellDoubleClicked === "function") window.setTimeout(()=>{
            this.beans.frameworkOverrides.wrapOutgoing(()=>{
                colDef.onCellDoubleClicked(cellDoubleClickedEvent);
            });
        }, 0);
        const editOnDoubleClick = !this.beans.gos.get("singleClickEdit") && !this.beans.gos.get("suppressClickEdit");
        if (editOnDoubleClick) this.cellCtrl.startRowOrCellEdit(null, mouseEvent);
    }
    onMouseDown(mouseEvent) {
        const { ctrlKey, metaKey, shiftKey } = mouseEvent;
        const target = mouseEvent.target;
        const { cellCtrl, beans } = this;
        const { eventService, rangeService, focusService } = beans;
        if (this.isRightClickInExistingRange(mouseEvent)) return;
        const ranges = rangeService && rangeService.getCellRanges().length != 0;
        if (!shiftKey || !ranges) {
            const forceBrowserFocus = isBrowserSafari() && !cellCtrl.isEditing() && !isFocusableFormField(target);
            cellCtrl.focusCell(forceBrowserFocus);
        }
        if (shiftKey && ranges && !focusService.isCellFocused(cellCtrl.getCellPosition())) {
            mouseEvent.preventDefault();
            const focusedCellPosition = focusService.getFocusedCell();
            if (focusedCellPosition) {
                const { column, rowIndex, rowPinned } = focusedCellPosition;
                const focusedRowCtrl = beans.rowRenderer.getRowByPosition({
                    rowIndex,
                    rowPinned
                });
                const focusedCellCtrl = focusedRowCtrl == null ? void 0 : focusedRowCtrl.getCellCtrl(column);
                if (focusedCellCtrl == null ? void 0 : focusedCellCtrl.isEditing()) focusedCellCtrl.stopEditing();
                focusService.setFocusedCell({
                    column,
                    rowIndex,
                    rowPinned,
                    forceBrowserFocus: true,
                    preventScrollOnBrowserFocus: true
                });
            }
        }
        if (this.containsWidget(target)) return;
        if (rangeService) {
            const thisCell = this.cellCtrl.getCellPosition();
            if (shiftKey) rangeService.extendLatestRangeToCell(thisCell);
            else {
                const isMultiKey = ctrlKey || metaKey;
                rangeService.setRangeToCell(thisCell, isMultiKey);
            }
        }
        eventService.dispatchEvent(this.cellCtrl.createEvent(mouseEvent, Events.EVENT_CELL_MOUSE_DOWN));
    }
    isRightClickInExistingRange(mouseEvent) {
        const { rangeService } = this.beans;
        if (rangeService) {
            const cellInRange = rangeService.isCellInAnyRange(this.cellCtrl.getCellPosition());
            const isRightClick = mouseEvent.button === 2 || mouseEvent.ctrlKey && this.beans.gos.get("allowContextMenuWithControlKey");
            if (cellInRange && isRightClick) return true;
        }
        return false;
    }
    containsWidget(target) {
        return isElementChildOfClass(target, "ag-selection-checkbox", 3);
    }
    onMouseOut(mouseEvent) {
        if (this.mouseStayingInsideCell(mouseEvent)) return;
        const cellMouseOutEvent = this.cellCtrl.createEvent(mouseEvent, Events.EVENT_CELL_MOUSE_OUT);
        this.beans.eventService.dispatchEvent(cellMouseOutEvent);
        this.beans.columnHoverService.clearMouseOver();
    }
    onMouseOver(mouseEvent) {
        if (this.mouseStayingInsideCell(mouseEvent)) return;
        const cellMouseOverEvent = this.cellCtrl.createEvent(mouseEvent, Events.EVENT_CELL_MOUSE_OVER);
        this.beans.eventService.dispatchEvent(cellMouseOverEvent);
        this.beans.columnHoverService.setMouseOver([
            this.column
        ]);
    }
    mouseStayingInsideCell(e) {
        if (!e.target || !e.relatedTarget) return false;
        const eGui = this.cellCtrl.getGui();
        const cellContainsTarget = eGui.contains(e.target);
        const cellContainsRelatedTarget = eGui.contains(e.relatedTarget);
        return cellContainsTarget && cellContainsRelatedTarget;
    }
    destroy() {}
};
// community-modules/core/src/rendering/cell/cellKeyboardListenerFeature.ts
var CellKeyboardListenerFeature = class extends BeanStub {
    constructor(ctrl, beans, column, rowNode, rowCtrl){
        super();
        this.cellCtrl = ctrl;
        this.beans = beans;
        this.rowNode = rowNode;
        this.rowCtrl = rowCtrl;
    }
    setComp(eGui) {
        this.eGui = eGui;
    }
    onKeyDown(event) {
        const key = event.key;
        switch(key){
            case KeyCode.ENTER:
                this.onEnterKeyDown(event);
                break;
            case KeyCode.F2:
                this.onF2KeyDown(event);
                break;
            case KeyCode.ESCAPE:
                this.onEscapeKeyDown(event);
                break;
            case KeyCode.TAB:
                this.onTabKeyDown(event);
                break;
            case KeyCode.BACKSPACE:
            case KeyCode.DELETE:
                this.onBackspaceOrDeleteKeyDown(key, event);
                break;
            case KeyCode.DOWN:
            case KeyCode.UP:
            case KeyCode.RIGHT:
            case KeyCode.LEFT:
                this.onNavigationKeyDown(event, key);
                break;
        }
    }
    onNavigationKeyDown(event, key) {
        if (this.cellCtrl.isEditing()) return;
        if (event.shiftKey && this.cellCtrl.isRangeSelectionEnabled()) this.onShiftRangeSelect(event);
        else this.beans.navigationService.navigateToNextCell(event, key, this.cellCtrl.getCellPosition(), true);
        event.preventDefault();
    }
    onShiftRangeSelect(event) {
        if (!this.beans.rangeService) return;
        const endCell = this.beans.rangeService.extendLatestRangeInDirection(event);
        if (endCell) this.beans.navigationService.ensureCellVisible(endCell);
    }
    onTabKeyDown(event) {
        this.beans.navigationService.onTabKeyDown(this.cellCtrl, event);
    }
    onBackspaceOrDeleteKeyDown(key, event) {
        var _a;
        const { cellCtrl, beans, rowNode } = this;
        const { gos, rangeService, eventService } = beans;
        if (cellCtrl.isEditing()) return;
        eventService.dispatchEvent({
            type: Events.EVENT_KEY_SHORTCUT_CHANGED_CELL_START
        });
        if (isDeleteKey(key, gos.get("enableCellEditingOnBackspace"))) {
            if (rangeService && gos.get("enableRangeSelection")) rangeService.clearCellRangeCellValues({
                dispatchWrapperEvents: true,
                wrapperEventSource: "deleteKey"
            });
            else if (cellCtrl.isCellEditable()) {
                const column = cellCtrl.getColumn();
                const emptyValue = (_a = this.beans.valueService.parseValue(column, rowNode, "", rowNode.getValueFromValueService(column))) != null ? _a : null;
                rowNode.setDataValue(column, emptyValue, "cellClear");
            }
        } else cellCtrl.startRowOrCellEdit(key, event);
        eventService.dispatchEvent({
            type: Events.EVENT_KEY_SHORTCUT_CHANGED_CELL_END
        });
    }
    onEnterKeyDown(e) {
        if (this.cellCtrl.isEditing() || this.rowCtrl.isEditing()) this.cellCtrl.stopEditingAndFocus(false, e.shiftKey);
        else if (this.beans.gos.get("enterNavigatesVertically")) {
            const key = e.shiftKey ? KeyCode.UP : KeyCode.DOWN;
            this.beans.navigationService.navigateToNextCell(null, key, this.cellCtrl.getCellPosition(), false);
        } else {
            this.cellCtrl.startRowOrCellEdit(KeyCode.ENTER, e);
            if (this.cellCtrl.isEditing()) e.preventDefault();
        }
    }
    onF2KeyDown(event) {
        if (!this.cellCtrl.isEditing()) this.cellCtrl.startRowOrCellEdit(KeyCode.F2, event);
    }
    onEscapeKeyDown(event) {
        if (this.cellCtrl.isEditing()) {
            this.cellCtrl.stopRowOrCellEdit(true);
            this.cellCtrl.focusCell(true);
        }
    }
    processCharacter(event) {
        const eventTarget = event.target;
        const eventOnChildComponent = eventTarget !== this.eGui;
        if (eventOnChildComponent || this.cellCtrl.isEditing()) return;
        const key = event.key;
        if (key === " ") this.onSpaceKeyDown(event);
        else {
            this.cellCtrl.startRowOrCellEdit(key, event);
            event.preventDefault();
        }
    }
    onSpaceKeyDown(event) {
        const { gos } = this.beans;
        if (!this.cellCtrl.isEditing() && gos.isRowSelection()) {
            const currentSelection = this.rowNode.isSelected();
            const newSelection = !currentSelection;
            if (newSelection || !gos.get("suppressRowDeselection")) {
                const groupSelectsFiltered = this.beans.gos.get("groupSelectsFiltered");
                const updatedCount = this.rowNode.setSelectedParams({
                    newValue: newSelection,
                    rangeSelect: event.shiftKey,
                    groupSelectsFiltered,
                    event,
                    source: "spaceKey"
                });
                if (currentSelection === void 0 && updatedCount === 0) this.rowNode.setSelectedParams({
                    newValue: false,
                    rangeSelect: event.shiftKey,
                    groupSelectsFiltered,
                    event,
                    source: "spaceKey"
                });
            }
        }
        event.preventDefault();
    }
    destroy() {
        super.destroy();
    }
};
// community-modules/core/src/rendering/dndSourceComp.ts
var DndSourceComp = class extends Component {
    constructor(rowNode, column, eCell){
        super(/* html */ `<div class="ag-drag-handle ag-row-drag" draggable="true"></div>`);
        this.rowNode = rowNode;
        this.column = column;
        this.eCell = eCell;
    }
    postConstruct() {
        const eGui = this.getGui();
        eGui.appendChild(createIconNoSpan("rowDrag", this.gos, null));
        this.addGuiEventListener("mousedown", (e)=>{
            e.stopPropagation();
        });
        this.addDragSource();
        this.checkVisibility();
    }
    addDragSource() {
        this.addGuiEventListener("dragstart", this.onDragStart.bind(this));
    }
    onDragStart(dragEvent) {
        const providedOnRowDrag = this.column.getColDef().dndSourceOnRowDrag;
        dragEvent.dataTransfer.setDragImage(this.eCell, 0, 0);
        const defaultOnRowDrag = ()=>{
            try {
                const jsonData = JSON.stringify(this.rowNode.data);
                dragEvent.dataTransfer.setData("application/json", jsonData);
                dragEvent.dataTransfer.setData("text/plain", jsonData);
            } catch (e) {}
        };
        if (providedOnRowDrag) {
            const params = this.gos.addGridCommonParams({
                rowNode: this.rowNode,
                dragEvent
            });
            providedOnRowDrag(params);
        } else defaultOnRowDrag();
    }
    checkVisibility() {
        const visible = this.column.isDndSource(this.rowNode);
        this.setDisplayed(visible);
    }
};
__decorateClass([
    PostConstruct
], DndSourceComp.prototype, "postConstruct", 1);
// community-modules/core/src/headerRendering/cells/cssClassApplier.ts
var CSS_FIRST_COLUMN = "ag-column-first";
var CSS_LAST_COLUMN = "ag-column-last";
var CssClassApplier = class {
    static getHeaderClassesFromColDef(abstractColDef, gos, column, columnGroup) {
        if (missing(abstractColDef)) return [];
        return this.getColumnClassesFromCollDef(abstractColDef.headerClass, abstractColDef, gos, column, columnGroup);
    }
    static getToolPanelClassesFromColDef(abstractColDef, gos, column, columnGroup) {
        if (missing(abstractColDef)) return [];
        return this.getColumnClassesFromCollDef(abstractColDef.toolPanelClass, abstractColDef, gos, column, columnGroup);
    }
    static refreshFirstAndLastStyles(comp, column, columnModel) {
        comp.addOrRemoveCssClass(CSS_FIRST_COLUMN, columnModel.isColumnAtEdge(column, "first"));
        comp.addOrRemoveCssClass(CSS_LAST_COLUMN, columnModel.isColumnAtEdge(column, "last"));
    }
    static getClassParams(abstractColDef, gos, column, columnGroup) {
        return gos.addGridCommonParams({
            // bad naming, as colDef here can be a group or a column,
            // however most people won't appreciate the difference,
            // so keeping it as colDef to avoid confusion.
            colDef: abstractColDef,
            column,
            columnGroup
        });
    }
    static getColumnClassesFromCollDef(classesOrFunc, abstractColDef, gos, column, columnGroup) {
        if (missing(classesOrFunc)) return [];
        let classToUse;
        if (typeof classesOrFunc === "function") {
            const params = this.getClassParams(abstractColDef, gos, column, columnGroup);
            classToUse = classesOrFunc(params);
        } else classToUse = classesOrFunc;
        if (typeof classToUse === "string") return [
            classToUse
        ];
        if (Array.isArray(classToUse)) return [
            ...classToUse
        ];
        return [];
    }
};
// community-modules/core/src/rendering/cell/cellCtrl.ts
var CSS_CELL = "ag-cell";
var CSS_AUTO_HEIGHT = "ag-cell-auto-height";
var CSS_NORMAL_HEIGHT = "ag-cell-normal-height";
var CSS_CELL_FOCUS = "ag-cell-focus";
var CSS_CELL_FIRST_RIGHT_PINNED = "ag-cell-first-right-pinned";
var CSS_CELL_LAST_LEFT_PINNED = "ag-cell-last-left-pinned";
var CSS_CELL_NOT_INLINE_EDITING = "ag-cell-not-inline-editing";
var CSS_COLUMN_HOVER = "ag-column-hover";
var CSS_CELL_WRAP_TEXT = "ag-cell-wrap-text";
var instanceIdSequence2 = 0;
var _CellCtrl = class _CellCtrl extends BeanStub {
    constructor(column, rowNode, beans, rowCtrl){
        super();
        this.cellRangeFeature = null;
        this.cellPositionFeature = null;
        this.cellCustomStyleFeature = null;
        this.tooltipFeature = null;
        this.cellMouseListenerFeature = null;
        this.cellKeyboardListenerFeature = null;
        this.suppressRefreshCell = false;
        this.onCellCompAttachedFuncs = [];
        this.column = column;
        this.rowNode = rowNode;
        this.beans = beans;
        this.rowCtrl = rowCtrl;
        this.instanceId = column.getId() + "-" + instanceIdSequence2++;
        this.colIdSanitised = escapeString(this.column.getId());
        if (!beans.gos.get("suppressCellFocus")) this.tabIndex = -1;
        this.createCellPosition();
        this.addFeatures();
        this.updateAndFormatValue(false);
    }
    shouldRestoreFocus() {
        return this.beans.focusService.shouldRestoreFocus(this.cellPosition);
    }
    addFeatures() {
        this.cellPositionFeature = new CellPositionFeature(this, this.beans);
        this.addDestroyFunc(()=>{
            var _a;
            (_a = this.cellPositionFeature) == null || _a.destroy();
            this.cellPositionFeature = null;
        });
        this.cellCustomStyleFeature = new CellCustomStyleFeature(this, this.beans);
        this.addDestroyFunc(()=>{
            var _a;
            (_a = this.cellCustomStyleFeature) == null || _a.destroy();
            this.cellCustomStyleFeature = null;
        });
        this.cellMouseListenerFeature = new CellMouseListenerFeature(this, this.beans, this.column);
        this.addDestroyFunc(()=>{
            var _a;
            (_a = this.cellMouseListenerFeature) == null || _a.destroy();
            this.cellMouseListenerFeature = null;
        });
        this.cellKeyboardListenerFeature = new CellKeyboardListenerFeature(this, this.beans, this.column, this.rowNode, this.rowCtrl);
        this.addDestroyFunc(()=>{
            var _a;
            (_a = this.cellKeyboardListenerFeature) == null || _a.destroy();
            this.cellKeyboardListenerFeature = null;
        });
        if (this.column.isTooltipEnabled()) {
            this.enableTooltipFeature();
            this.addDestroyFunc(()=>{
                this.disableTooltipFeature();
            });
        }
        const rangeSelectionEnabled = this.beans.rangeService && this.beans.gos.get("enableRangeSelection");
        if (rangeSelectionEnabled) {
            this.cellRangeFeature = new CellRangeFeature(this.beans, this);
            this.addDestroyFunc(()=>{
                var _a;
                (_a = this.cellRangeFeature) == null || _a.destroy();
                this.cellRangeFeature = null;
            });
        }
    }
    enableTooltipFeature(value, shouldDisplayTooltip) {
        const getTooltipValue = ()=>{
            const colDef = this.column.getColDef();
            const data = this.rowNode.data;
            if (colDef.tooltipField && exists(data)) return getValueUsingField(data, colDef.tooltipField, this.column.isTooltipFieldContainsDots());
            const valueGetter = colDef.tooltipValueGetter;
            if (valueGetter) return valueGetter(this.beans.gos.addGridCommonParams({
                location: "cell",
                colDef: this.column.getColDef(),
                column: this.column,
                rowIndex: this.cellPosition.rowIndex,
                node: this.rowNode,
                data: this.rowNode.data,
                value: this.value,
                valueFormatted: this.valueFormatted
            }));
            return null;
        };
        const isTooltipWhenTruncated = this.beans.gos.get("tooltipShowMode") === "whenTruncated";
        if (!shouldDisplayTooltip && isTooltipWhenTruncated && !this.isCellRenderer()) shouldDisplayTooltip = ()=>{
            const eGui = this.getGui();
            const textEl = eGui.children.length === 0 ? eGui : eGui.querySelector(".ag-cell-value");
            if (!textEl) return true;
            return textEl.scrollWidth > textEl.clientWidth;
        };
        const tooltipCtrl = {
            getColumn: ()=>this.column,
            getColDef: ()=>this.column.getColDef(),
            getRowIndex: ()=>this.cellPosition.rowIndex,
            getRowNode: ()=>this.rowNode,
            getGui: ()=>this.getGui(),
            getLocation: ()=>"cell",
            getTooltipValue: value != null ? ()=>value : getTooltipValue,
            // this makes no sense, why is the cell formatted value passed to the tooltip???
            getValueFormatted: ()=>this.valueFormatted,
            shouldDisplayTooltip
        };
        this.tooltipFeature = new TooltipFeature(tooltipCtrl, this.beans);
    }
    disableTooltipFeature() {
        if (!this.tooltipFeature) return;
        this.tooltipFeature.destroy();
        this.tooltipFeature = null;
    }
    setComp(comp, eGui, eCellWrapper, printLayout, startEditing) {
        var _a, _b, _c, _d;
        this.cellComp = comp;
        this.eGui = eGui;
        this.printLayout = printLayout;
        this.addDomData();
        this.onCellFocused(this.focusEventToRestore);
        this.applyStaticCssClasses();
        this.setWrapText();
        this.onFirstRightPinnedChanged();
        this.onLastLeftPinnedChanged();
        this.onColumnHover();
        this.setupControlComps();
        this.setupAutoHeight(eCellWrapper);
        this.refreshFirstAndLastStyles();
        this.refreshAriaColIndex();
        (_a = this.cellPositionFeature) == null || _a.setComp(eGui);
        (_b = this.cellCustomStyleFeature) == null || _b.setComp(comp);
        (_c = this.tooltipFeature) == null || _c.refreshToolTip();
        (_d = this.cellKeyboardListenerFeature) == null || _d.setComp(this.eGui);
        if (this.cellRangeFeature) this.cellRangeFeature.setComp(comp, eGui);
        if (startEditing && this.isCellEditable()) this.startEditing();
        else this.showValue();
        if (this.onCellCompAttachedFuncs.length) {
            this.onCellCompAttachedFuncs.forEach((func)=>func());
            this.onCellCompAttachedFuncs = [];
        }
    }
    setupAutoHeight(eCellWrapper) {
        this.isAutoHeight = this.column.isAutoHeight();
        if (!this.isAutoHeight || !eCellWrapper) return;
        const eParentCell = eCellWrapper.parentElement;
        const minRowHeight = this.beans.gos.getRowHeightForNode(this.rowNode).height;
        const measureHeight = (timesCalled)=>{
            if (this.editing) return;
            if (!this.isAlive()) return;
            const { paddingTop, paddingBottom, borderBottomWidth, borderTopWidth } = getElementSize(eParentCell);
            const extraHeight = paddingTop + paddingBottom + borderBottomWidth + borderTopWidth;
            const wrapperHeight = eCellWrapper.offsetHeight;
            const autoHeight = wrapperHeight + extraHeight;
            if (timesCalled < 5) {
                const doc = this.beans.gos.getDocument();
                const notYetInDom = !doc || !doc.contains(eCellWrapper);
                const possiblyNoContentYet = autoHeight == 0;
                if (notYetInDom || possiblyNoContentYet) {
                    window.setTimeout(()=>measureHeight(timesCalled + 1), 0);
                    return;
                }
            }
            const newHeight = Math.max(autoHeight, minRowHeight);
            this.rowNode.setRowAutoHeight(newHeight, this.column);
        };
        const listener = ()=>measureHeight(0);
        listener();
        const destroyResizeObserver = this.beans.resizeObserverService.observeResize(eCellWrapper, listener);
        this.addDestroyFunc(()=>{
            destroyResizeObserver();
            this.rowNode.setRowAutoHeight(void 0, this.column);
        });
    }
    getCellAriaRole() {
        var _a;
        return (_a = this.column.getColDef().cellAriaRole) != null ? _a : "gridcell";
    }
    getInstanceId() {
        return this.instanceId;
    }
    getColumnIdSanitised() {
        return this.colIdSanitised;
    }
    getTabIndex() {
        return this.tabIndex;
    }
    isCellRenderer() {
        const colDef = this.column.getColDef();
        return colDef.cellRenderer != null || colDef.cellRendererSelector != null;
    }
    getValueToDisplay() {
        var _a;
        return (_a = this.valueFormatted) != null ? _a : this.value;
    }
    showValue(forceNewCellRendererInstance = false) {
        var _a;
        const valueToDisplay = this.getValueToDisplay();
        let compDetails;
        if (this.rowNode.stub) {
            const params = this.createCellRendererParams();
            compDetails = this.beans.userComponentFactory.getLoadingCellRendererDetails(this.column.getColDef(), params);
        } else if (this.isCellRenderer()) {
            const params = this.createCellRendererParams();
            compDetails = this.beans.userComponentFactory.getCellRendererDetails(this.column.getColDef(), params);
        }
        this.cellComp.setRenderDetails(compDetails, valueToDisplay, forceNewCellRendererInstance);
        (_a = this.cellRangeFeature) == null || _a.refreshHandle();
    }
    setupControlComps() {
        const colDef = this.column.getColDef();
        this.includeSelection = this.isIncludeControl(colDef.checkboxSelection);
        this.includeRowDrag = this.isIncludeControl(colDef.rowDrag);
        this.includeDndSource = this.isIncludeControl(colDef.dndSource);
        this.cellComp.setIncludeSelection(this.includeSelection);
        this.cellComp.setIncludeDndSource(this.includeDndSource);
        this.cellComp.setIncludeRowDrag(this.includeRowDrag);
    }
    isForceWrapper() {
        const forceWrapper = this.beans.gos.get("enableCellTextSelection") || this.column.isAutoHeight();
        return forceWrapper;
    }
    isIncludeControl(value) {
        const rowNodePinned = this.rowNode.rowPinned != null;
        const isFunc = typeof value === "function";
        const res = rowNodePinned ? false : isFunc || value === true;
        return res;
    }
    refreshShouldDestroy() {
        const colDef = this.column.getColDef();
        const selectionChanged = this.includeSelection != this.isIncludeControl(colDef.checkboxSelection);
        const rowDragChanged = this.includeRowDrag != this.isIncludeControl(colDef.rowDrag);
        const dndSourceChanged = this.includeDndSource != this.isIncludeControl(colDef.dndSource);
        const autoHeightChanged = this.isAutoHeight != this.column.isAutoHeight();
        return selectionChanged || rowDragChanged || dndSourceChanged || autoHeightChanged;
    }
    // either called internally if single cell editing, or called by rowRenderer if row editing
    startEditing(key = null, cellStartedEdit = false, event = null) {
        if (!this.isCellEditable() || this.editing) return;
        if (!this.cellComp) {
            this.onCellCompAttachedFuncs.push(()=>{
                this.startEditing(key, cellStartedEdit, event);
            });
            return;
        }
        const editorParams = this.createCellEditorParams(key, cellStartedEdit);
        const colDef = this.column.getColDef();
        const compDetails = this.beans.userComponentFactory.getCellEditorDetails(colDef, editorParams);
        this.editCompDetails = compDetails;
        const popup = (compDetails == null ? void 0 : compDetails.popupFromSelector) != null ? compDetails.popupFromSelector : !!colDef.cellEditorPopup;
        const position = (compDetails == null ? void 0 : compDetails.popupPositionFromSelector) != null ? compDetails.popupPositionFromSelector : colDef.cellEditorPopupPosition;
        this.setEditing(true);
        this.cellComp.setEditDetails(compDetails, popup, position, this.beans.gos.get("reactiveCustomComponents"));
        const e = this.createEvent(event, Events.EVENT_CELL_EDITING_STARTED);
        this.beans.eventService.dispatchEvent(e);
    }
    setEditing(editing) {
        var _a;
        if (this.editing === editing) return;
        this.editing = editing;
        (_a = this.cellRangeFeature) == null || _a.refreshHandle();
    }
    // pass in 'true' to cancel the editing.
    stopRowOrCellEdit(cancel = false) {
        if (this.beans.gos.get("editType") === "fullRow") this.rowCtrl.stopEditing(cancel);
        else this.stopEditing(cancel);
    }
    onPopupEditorClosed() {
        if (!this.isEditing()) return;
        this.stopEditingAndFocus();
    }
    takeValueFromCellEditor(cancel) {
        const noValueResult = {
            newValueExists: false
        };
        if (cancel) return noValueResult;
        const cellEditor = this.cellComp.getCellEditor();
        if (!cellEditor) return noValueResult;
        const userWantsToCancel = cellEditor.isCancelAfterEnd && cellEditor.isCancelAfterEnd();
        if (userWantsToCancel) return noValueResult;
        const newValue = cellEditor.getValue();
        return {
            newValue,
            newValueExists: true
        };
    }
    /**
   * @returns `True` if the value changes, otherwise `False`.
   */ saveNewValue(oldValue, newValue) {
        if (newValue === oldValue) return false;
        this.suppressRefreshCell = true;
        const valueChanged = this.rowNode.setDataValue(this.column, newValue, "edit");
        this.suppressRefreshCell = false;
        return valueChanged;
    }
    /**
   * Ends the Cell Editing
   * @param cancel `True` if the edit process is being canceled.
   * @returns `True` if the value of the `GridCell` has been updated, otherwise `False`.
   */ stopEditing(cancel = false) {
        if (!this.editing) return false;
        const { newValue, newValueExists } = this.takeValueFromCellEditor(cancel);
        const oldValue = this.rowNode.getValueFromValueService(this.column);
        let valueChanged = false;
        if (newValueExists) valueChanged = this.saveNewValue(oldValue, newValue);
        this.setEditing(false);
        this.cellComp.setEditDetails();
        this.editCompDetails = void 0;
        this.updateAndFormatValue(false);
        this.refreshCell({
            forceRefresh: true,
            suppressFlash: true
        });
        this.dispatchEditingStoppedEvent(oldValue, newValue, !cancel && !!valueChanged);
        return valueChanged;
    }
    dispatchEditingStoppedEvent(oldValue, newValue, valueChanged) {
        const editingStoppedEvent = __spreadProps(__spreadValues({}, this.createEvent(null, Events.EVENT_CELL_EDITING_STOPPED)), {
            oldValue,
            newValue,
            valueChanged
        });
        this.beans.eventService.dispatchEvent(editingStoppedEvent);
    }
    createCellEditorParams(key, cellStartedEdit) {
        return this.beans.gos.addGridCommonParams({
            value: this.rowNode.getValueFromValueService(this.column),
            eventKey: key,
            column: this.column,
            colDef: this.column.getColDef(),
            rowIndex: this.getCellPosition().rowIndex,
            node: this.rowNode,
            data: this.rowNode.data,
            cellStartedEdit,
            onKeyDown: this.onKeyDown.bind(this),
            stopEditing: this.stopEditingAndFocus.bind(this),
            eGridCell: this.getGui(),
            parseValue: this.parseValue.bind(this),
            formatValue: this.formatValue.bind(this)
        });
    }
    createCellRendererParams() {
        const res = this.beans.gos.addGridCommonParams({
            value: this.value,
            valueFormatted: this.valueFormatted,
            getValue: ()=>this.rowNode.getValueFromValueService(this.column),
            setValue: (value)=>this.beans.valueService.setValue(this.rowNode, this.column, value),
            formatValue: this.formatValue.bind(this),
            data: this.rowNode.data,
            node: this.rowNode,
            pinned: this.column.getPinned(),
            colDef: this.column.getColDef(),
            column: this.column,
            rowIndex: this.getCellPosition().rowIndex,
            refreshCell: this.refreshCell.bind(this),
            eGridCell: this.getGui(),
            eParentOfValue: this.cellComp.getParentOfValue(),
            registerRowDragger: (rowDraggerElement, dragStartPixels, value, suppressVisibilityChange)=>this.registerRowDragger(rowDraggerElement, dragStartPixels, suppressVisibilityChange),
            setTooltip: (value, shouldDisplayTooltip)=>{
                var _a;
                if (this.tooltipFeature) this.disableTooltipFeature();
                this.enableTooltipFeature(value, shouldDisplayTooltip);
                (_a = this.tooltipFeature) == null || _a.refreshToolTip();
            }
        });
        return res;
    }
    parseValue(newValue) {
        return this.beans.valueService.parseValue(this.column, this.rowNode, newValue, this.getValue());
    }
    setFocusOutOnEditor() {
        if (!this.editing) return;
        const cellEditor = this.cellComp.getCellEditor();
        if (cellEditor && cellEditor.focusOut) cellEditor.focusOut();
    }
    setFocusInOnEditor() {
        if (!this.editing) return;
        const cellEditor = this.cellComp.getCellEditor();
        if (cellEditor && cellEditor.focusIn) cellEditor.focusIn();
        else this.focusCell(true);
    }
    onCellChanged(event) {
        const eventImpactsThisCell = event.column === this.column;
        if (eventImpactsThisCell) this.refreshCell({});
    }
    refreshOrDestroyCell(params) {
        var _a;
        if (this.refreshShouldDestroy()) (_a = this.rowCtrl) == null || _a.recreateCell(this);
        else this.refreshCell(params);
    }
    // + stop editing {forceRefresh: true, suppressFlash: true}
    // + event cellChanged {}
    // + cellRenderer.params.refresh() {} -> method passes 'as is' to the cellRenderer, so params could be anything
    // + rowCtrl: event dataChanged {suppressFlash: !update, newData: !update}
    // + rowCtrl: api refreshCells() {animate: true/false}
    // + rowRenderer: api softRefreshView() {}
    refreshCell(params) {
        var _a, _b, _c, _d;
        if (this.suppressRefreshCell || this.editing) return;
        const colDef = this.column.getColDef();
        const newData = params != null && !!params.newData;
        const suppressFlash = params != null && !!params.suppressFlash || !!colDef.suppressCellFlash;
        const noValueProvided = colDef.field == null && colDef.valueGetter == null && colDef.showRowGroup == null;
        const forceRefresh = params && params.forceRefresh || noValueProvided || newData;
        const isCellCompReady = !!this.cellComp;
        const valuesDifferent = this.updateAndFormatValue(isCellCompReady);
        const dataNeedsUpdating = forceRefresh || valuesDifferent;
        if (!isCellCompReady) return;
        if (dataNeedsUpdating) {
            this.showValue(newData);
            const processingFilterChange = this.beans.filterManager.isSuppressFlashingCellsBecauseFiltering();
            const flashCell = !suppressFlash && !processingFilterChange && (this.beans.gos.get("enableCellChangeFlash") || colDef.enableCellChangeFlash);
            if (flashCell) this.flashCell();
            (_a = this.cellCustomStyleFeature) == null || _a.applyUserStyles();
            (_b = this.cellCustomStyleFeature) == null || _b.applyClassesFromColDef();
        }
        (_c = this.tooltipFeature) == null || _c.refreshToolTip();
        (_d = this.cellCustomStyleFeature) == null || _d.applyCellClassRules();
    }
    // cell editors call this, when they want to stop for reasons other
    // than what we pick up on. eg selecting from a dropdown ends editing.
    stopEditingAndFocus(suppressNavigateAfterEdit = false, shiftKey = false) {
        this.stopRowOrCellEdit();
        this.focusCell(true);
        if (!suppressNavigateAfterEdit) this.navigateAfterEdit(shiftKey);
    }
    navigateAfterEdit(shiftKey) {
        const enterNavigatesVerticallyAfterEdit = this.beans.gos.get("enterNavigatesVerticallyAfterEdit");
        if (enterNavigatesVerticallyAfterEdit) {
            const key = shiftKey ? KeyCode.UP : KeyCode.DOWN;
            this.beans.navigationService.navigateToNextCell(null, key, this.getCellPosition(), false);
        }
    }
    // user can also call this via API
    flashCell(delays) {
        var _a, _b;
        const flashDuration = (_a = delays == null ? void 0 : delays.flashDuration) != null ? _a : delays == null ? void 0 : delays.flashDelay;
        const fadeDuration = (_b = delays == null ? void 0 : delays.fadeDuration) != null ? _b : delays == null ? void 0 : delays.fadeDelay;
        this.animateCell("data-changed", flashDuration, fadeDuration);
    }
    animateCell(cssName, flashDuration, fadeDuration) {
        if (!this.cellComp) return;
        const fullName = `ag-cell-${cssName}`;
        const animationFullName = `ag-cell-${cssName}-animation`;
        const { gos } = this.beans;
        if (!flashDuration) flashDuration = gos.get("cellFlashDuration");
        if (!exists(fadeDuration)) fadeDuration = gos.get("cellFadeDuration");
        this.cellComp.addOrRemoveCssClass(fullName, true);
        this.cellComp.addOrRemoveCssClass(animationFullName, false);
        this.beans.frameworkOverrides.wrapIncoming(()=>{
            window.setTimeout(()=>{
                if (!this.isAlive()) return;
                this.cellComp.addOrRemoveCssClass(fullName, false);
                this.cellComp.addOrRemoveCssClass(animationFullName, true);
                this.eGui.style.transition = `background-color ${fadeDuration}ms`;
                window.setTimeout(()=>{
                    if (!this.isAlive()) return;
                    this.cellComp.addOrRemoveCssClass(animationFullName, false);
                    this.eGui.style.transition = "";
                }, fadeDuration);
            }, flashDuration);
        });
    }
    onFlashCells(event) {
        if (!this.cellComp) return;
        const cellId = this.beans.cellPositionUtils.createId(this.getCellPosition());
        const shouldFlash = event.cells[cellId];
        if (shouldFlash) this.animateCell("highlight");
    }
    isCellEditable() {
        return this.column.isCellEditable(this.rowNode);
    }
    isSuppressFillHandle() {
        return this.column.isSuppressFillHandle();
    }
    formatValue(value) {
        var _a;
        return (_a = this.callValueFormatter(value)) != null ? _a : value;
    }
    callValueFormatter(value) {
        return this.beans.valueService.formatValue(this.column, this.rowNode, value);
    }
    updateAndFormatValue(compareValues) {
        const oldValue = this.value;
        const oldValueFormatted = this.valueFormatted;
        this.value = this.rowNode.getValueFromValueService(this.column);
        this.valueFormatted = this.callValueFormatter(this.value);
        if (compareValues) return !this.valuesAreEqual(oldValue, this.value) || this.valueFormatted != oldValueFormatted;
        return true;
    }
    valuesAreEqual(val1, val2) {
        const colDef = this.column.getColDef();
        return colDef.equals ? colDef.equals(val1, val2) : val1 === val2;
    }
    getComp() {
        return this.cellComp;
    }
    getValue() {
        return this.value;
    }
    addDomData() {
        const element = this.getGui();
        this.beans.gos.setDomData(element, _CellCtrl.DOM_DATA_KEY_CELL_CTRL, this);
        this.addDestroyFunc(()=>this.beans.gos.setDomData(element, _CellCtrl.DOM_DATA_KEY_CELL_CTRL, null));
    }
    createEvent(domEvent, eventType) {
        const event = this.beans.gos.addGridCommonParams({
            type: eventType,
            node: this.rowNode,
            data: this.rowNode.data,
            value: this.value,
            column: this.column,
            colDef: this.column.getColDef(),
            rowPinned: this.rowNode.rowPinned,
            event: domEvent,
            rowIndex: this.rowNode.rowIndex
        });
        return event;
    }
    processCharacter(event) {
        var _a;
        (_a = this.cellKeyboardListenerFeature) == null || _a.processCharacter(event);
    }
    onKeyDown(event) {
        var _a;
        (_a = this.cellKeyboardListenerFeature) == null || _a.onKeyDown(event);
    }
    onMouseEvent(eventName, mouseEvent) {
        var _a;
        (_a = this.cellMouseListenerFeature) == null || _a.onMouseEvent(eventName, mouseEvent);
    }
    getGui() {
        return this.eGui;
    }
    getColSpanningList() {
        return this.cellPositionFeature.getColSpanningList();
    }
    onLeftChanged() {
        var _a;
        if (!this.cellComp) return;
        (_a = this.cellPositionFeature) == null || _a.onLeftChanged();
    }
    onDisplayedColumnsChanged() {
        if (!this.eGui) return;
        this.refreshAriaColIndex();
        this.refreshFirstAndLastStyles();
    }
    refreshFirstAndLastStyles() {
        const { cellComp, column, beans } = this;
        CssClassApplier.refreshFirstAndLastStyles(cellComp, column, beans.columnModel);
    }
    refreshAriaColIndex() {
        const colIdx = this.beans.columnModel.getAriaColumnIndex(this.column);
        setAriaColIndex(this.getGui(), colIdx);
    }
    isSuppressNavigable() {
        return this.column.isSuppressNavigable(this.rowNode);
    }
    onWidthChanged() {
        var _a;
        return (_a = this.cellPositionFeature) == null ? void 0 : _a.onWidthChanged();
    }
    getColumn() {
        return this.column;
    }
    getRowNode() {
        return this.rowNode;
    }
    isPrintLayout() {
        return this.printLayout;
    }
    getCellPosition() {
        return this.cellPosition;
    }
    isEditing() {
        return this.editing;
    }
    // called by rowRenderer when user navigates via tab key
    startRowOrCellEdit(key, event = null) {
        if (!this.cellComp) {
            this.onCellCompAttachedFuncs.push(()=>{
                this.startRowOrCellEdit(key, event);
            });
            return;
        }
        if (this.beans.gos.get("editType") === "fullRow") this.rowCtrl.startRowEditing(key, this);
        else this.startEditing(key, true, event);
    }
    getRowCtrl() {
        return this.rowCtrl;
    }
    getRowPosition() {
        return {
            rowIndex: this.cellPosition.rowIndex,
            rowPinned: this.cellPosition.rowPinned
        };
    }
    updateRangeBordersIfRangeCount() {
        if (!this.cellComp) return;
        if (this.cellRangeFeature) this.cellRangeFeature.updateRangeBordersIfRangeCount();
    }
    onRangeSelectionChanged() {
        if (!this.cellComp) return;
        if (this.cellRangeFeature) this.cellRangeFeature.onRangeSelectionChanged();
    }
    isRangeSelectionEnabled() {
        return this.cellRangeFeature != null;
    }
    focusCell(forceBrowserFocus = false) {
        this.beans.focusService.setFocusedCell({
            rowIndex: this.getCellPosition().rowIndex,
            column: this.column,
            rowPinned: this.rowNode.rowPinned,
            forceBrowserFocus
        });
    }
    onRowIndexChanged() {
        this.createCellPosition();
        this.onCellFocused();
        if (this.cellRangeFeature) this.cellRangeFeature.onRangeSelectionChanged();
    }
    onFirstRightPinnedChanged() {
        if (!this.cellComp) return;
        const firstRightPinned = this.column.isFirstRightPinned();
        this.cellComp.addOrRemoveCssClass(CSS_CELL_FIRST_RIGHT_PINNED, firstRightPinned);
    }
    onLastLeftPinnedChanged() {
        if (!this.cellComp) return;
        const lastLeftPinned = this.column.isLastLeftPinned();
        this.cellComp.addOrRemoveCssClass(CSS_CELL_LAST_LEFT_PINNED, lastLeftPinned);
    }
    onCellFocused(event) {
        if (this.beans.gos.get("suppressCellFocus")) return;
        const cellFocused = this.beans.focusService.isCellFocused(this.cellPosition);
        if (!this.cellComp) {
            if (cellFocused && (event == null ? void 0 : event.forceBrowserFocus)) this.focusEventToRestore = event;
            return;
        }
        this.focusEventToRestore = void 0;
        this.cellComp.addOrRemoveCssClass(CSS_CELL_FOCUS, cellFocused);
        if (cellFocused && event && event.forceBrowserFocus) {
            const focusEl = this.cellComp.getFocusableElement();
            focusEl.focus({
                preventScroll: !!event.preventScrollOnBrowserFocus
            });
        }
        const fullRowEdit = this.beans.gos.get("editType") === "fullRow";
        if (!cellFocused && !fullRowEdit && this.editing) this.stopRowOrCellEdit();
        if (cellFocused) this.rowCtrl.announceDescription();
    }
    createCellPosition() {
        this.cellPosition = {
            rowIndex: this.rowNode.rowIndex,
            rowPinned: makeNull(this.rowNode.rowPinned),
            column: this.column
        };
    }
    // CSS Classes that only get applied once, they never change
    applyStaticCssClasses() {
        this.cellComp.addOrRemoveCssClass(CSS_CELL, true);
        this.cellComp.addOrRemoveCssClass(CSS_CELL_NOT_INLINE_EDITING, true);
        const autoHeight = this.column.isAutoHeight() == true;
        this.cellComp.addOrRemoveCssClass(CSS_AUTO_HEIGHT, autoHeight);
        this.cellComp.addOrRemoveCssClass(CSS_NORMAL_HEIGHT, !autoHeight);
    }
    onColumnHover() {
        if (!this.cellComp) return;
        if (!this.beans.gos.get("columnHoverHighlight")) return;
        const isHovered = this.beans.columnHoverService.isHovered(this.column);
        this.cellComp.addOrRemoveCssClass(CSS_COLUMN_HOVER, isHovered);
    }
    onColDefChanged() {
        if (!this.cellComp) return;
        const isTooltipEnabled = this.column.isTooltipEnabled();
        if (isTooltipEnabled) {
            this.disableTooltipFeature();
            this.enableTooltipFeature();
        } else this.disableTooltipFeature();
        this.setWrapText();
        if (!this.editing) this.refreshOrDestroyCell({
            forceRefresh: true,
            suppressFlash: true
        });
        else {
            const cellEditor = this.getCellEditor();
            if (cellEditor == null ? void 0 : cellEditor.refresh) {
                const { eventKey, cellStartedEdit } = this.editCompDetails.params;
                const editorParams = this.createCellEditorParams(eventKey, cellStartedEdit);
                const colDef = this.column.getColDef();
                const compDetails = this.beans.userComponentFactory.getCellEditorDetails(colDef, editorParams);
                cellEditor.refresh(compDetails.params);
            }
        }
    }
    setWrapText() {
        const value = this.column.getColDef().wrapText == true;
        this.cellComp.addOrRemoveCssClass(CSS_CELL_WRAP_TEXT, value);
    }
    dispatchCellContextMenuEvent(event) {
        const colDef = this.column.getColDef();
        const cellContextMenuEvent = this.createEvent(event, Events.EVENT_CELL_CONTEXT_MENU);
        this.beans.eventService.dispatchEvent(cellContextMenuEvent);
        if (colDef.onCellContextMenu) window.setTimeout(()=>{
            this.beans.frameworkOverrides.wrapOutgoing(()=>{
                colDef.onCellContextMenu(cellContextMenuEvent);
            });
        }, 0);
    }
    getCellRenderer() {
        return this.cellComp ? this.cellComp.getCellRenderer() : null;
    }
    getCellEditor() {
        return this.cellComp ? this.cellComp.getCellEditor() : null;
    }
    destroy() {
        this.onCellCompAttachedFuncs = [];
        super.destroy();
    }
    createSelectionCheckbox() {
        const cbSelectionComponent = new CheckboxSelectionComponent();
        this.beans.context.createBean(cbSelectionComponent);
        cbSelectionComponent.init({
            rowNode: this.rowNode,
            column: this.column
        });
        return cbSelectionComponent;
    }
    createDndSource() {
        const dndSourceComp = new DndSourceComp(this.rowNode, this.column, this.eGui);
        this.beans.context.createBean(dndSourceComp);
        return dndSourceComp;
    }
    registerRowDragger(customElement, dragStartPixels, suppressVisibilityChange) {
        if (this.customRowDragComp) {
            this.customRowDragComp.setDragElement(customElement, dragStartPixels);
            return;
        }
        const newComp = this.createRowDragComp(customElement, dragStartPixels, suppressVisibilityChange);
        if (newComp) {
            this.customRowDragComp = newComp;
            this.addDestroyFunc(()=>{
                this.beans.context.destroyBean(newComp);
                this.customRowDragComp = null;
            });
        }
    }
    createRowDragComp(customElement, dragStartPixels, suppressVisibilityChange) {
        const pagination = this.beans.gos.get("pagination");
        const rowDragManaged = this.beans.gos.get("rowDragManaged");
        const clientSideRowModelActive = this.beans.gos.isRowModelType("clientSide");
        if (rowDragManaged) {
            if (!clientSideRowModelActive) {
                warnOnce("managed row dragging is only allowed in the Client Side Row Model");
                return;
            }
            if (pagination) {
                warnOnce("managed row dragging is not possible when doing pagination");
                return;
            }
        }
        const rowDragComp = new RowDragComp(()=>this.value, this.rowNode, this.column, customElement, dragStartPixels, suppressVisibilityChange);
        this.beans.context.createBean(rowDragComp);
        return rowDragComp;
    }
};
_CellCtrl.DOM_DATA_KEY_CELL_CTRL = "cellCtrl";
var CellCtrl = _CellCtrl;
// community-modules/core/src/rendering/row/rowCtrl.ts
var instanceIdSequence3 = 0;
var _RowCtrl = class _RowCtrl extends BeanStub {
    constructor(rowNode, beans, animateIn, useAnimationFrameForCreate, printLayout){
        super();
        this.allRowGuis = [];
        this.active = true;
        this.centerCellCtrls = {
            list: [],
            map: {}
        };
        this.leftCellCtrls = {
            list: [],
            map: {}
        };
        this.rightCellCtrls = {
            list: [],
            map: {}
        };
        this.slideInAnimation = {
            left: false,
            center: false,
            right: false,
            fullWidth: false
        };
        this.fadeInAnimation = {
            left: false,
            center: false,
            right: false,
            fullWidth: false
        };
        this.rowDragComps = [];
        this.lastMouseDownOnDragger = false;
        this.emptyStyle = {};
        this.updateColumnListsPending = false;
        this.rowId = null;
        this.businessKeySanitised = null;
        this.beans = beans;
        this.gos = beans.gos;
        this.rowNode = rowNode;
        this.paginationPage = beans.paginationProxy.getCurrentPage();
        this.useAnimationFrameForCreate = useAnimationFrameForCreate;
        this.printLayout = printLayout;
        this.suppressRowTransform = this.gos.get("suppressRowTransform");
        this.instanceId = rowNode.id + "-" + instanceIdSequence3++;
        this.rowId = escapeString(rowNode.id);
        this.initRowBusinessKey();
        this.rowFocused = beans.focusService.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned);
        this.rowLevel = beans.rowCssClassCalculator.calculateRowLevel(this.rowNode);
        this.setRowType();
        this.setAnimateFlags(animateIn);
        this.rowStyles = this.processStylesFromGridOptions();
        if (this.isFullWidth() && !this.gos.get("suppressCellFocus")) this.tabIndex = -1;
        this.addListeners();
    }
    initRowBusinessKey() {
        this.businessKeyForNodeFunc = this.gos.get("getBusinessKeyForNode");
        this.updateRowBusinessKey();
    }
    updateRowBusinessKey() {
        if (typeof this.businessKeyForNodeFunc !== "function") return;
        const businessKey = this.businessKeyForNodeFunc(this.rowNode);
        this.businessKeySanitised = escapeString(businessKey);
    }
    getRowId() {
        return this.rowId;
    }
    getRowStyles() {
        return this.rowStyles;
    }
    getTabIndex() {
        return this.tabIndex;
    }
    isSticky() {
        return this.rowNode.sticky;
    }
    getInstanceId() {
        return this.instanceId;
    }
    setComp(rowComp, element, containerType) {
        const gui = {
            rowComp,
            element,
            containerType
        };
        this.allRowGuis.push(gui);
        if (containerType === "left" /* LEFT */ ) this.leftGui = gui;
        else if (containerType === "right" /* RIGHT */ ) this.rightGui = gui;
        else if (containerType === "fullWidth" /* FULL_WIDTH */ ) this.fullWidthGui = gui;
        else this.centerGui = gui;
        this.initialiseRowComp(gui);
        if (this.rowType !== "FullWidthLoading" && !this.rowNode.rowPinned) this.beans.rowRenderer.dispatchFirstDataRenderedEvent();
    }
    unsetComp(containerType) {
        this.allRowGuis = this.allRowGuis.filter((rowGui)=>rowGui.containerType !== containerType);
        switch(containerType){
            case "left" /* LEFT */ :
                this.leftGui = void 0;
                break;
            case "right" /* RIGHT */ :
                this.rightGui = void 0;
                break;
            case "fullWidth" /* FULL_WIDTH */ :
                this.fullWidthGui = void 0;
                break;
            case "center" /* CENTER */ :
                this.centerGui = void 0;
                break;
            default:
        }
    }
    isCacheable() {
        return this.rowType === "FullWidthDetail" /* FullWidthDetail */  && this.gos.get("keepDetailRows");
    }
    setCached(cached) {
        const displayValue = cached ? "none" : "";
        this.allRowGuis.forEach((rg)=>rg.element.style.display = displayValue);
    }
    initialiseRowComp(gui) {
        const gos = this.gos;
        this.listenOnDomOrder(gui);
        if (this.beans.columnModel.wasAutoRowHeightEverActive()) this.rowNode.checkAutoHeights();
        this.onRowHeightChanged(gui);
        this.updateRowIndexes(gui);
        this.setFocusedClasses(gui);
        this.setStylesFromGridOptions(false, gui);
        if (gos.isRowSelection() && this.rowNode.selectable) this.onRowSelected(gui);
        this.updateColumnLists(!this.useAnimationFrameForCreate);
        const comp = gui.rowComp;
        const initialRowClasses = this.getInitialRowClasses(gui.containerType);
        initialRowClasses.forEach((name)=>comp.addOrRemoveCssClass(name, true));
        this.executeSlideAndFadeAnimations(gui);
        if (this.rowNode.group) setAriaExpanded(gui.element, this.rowNode.expanded == true);
        this.setRowCompRowId(comp);
        this.setRowCompRowBusinessKey(comp);
        gos.setDomData(gui.element, _RowCtrl.DOM_DATA_KEY_ROW_CTRL, this);
        this.addDestroyFunc(()=>gos.setDomData(gui.element, _RowCtrl.DOM_DATA_KEY_ROW_CTRL, null));
        if (this.useAnimationFrameForCreate) this.beans.animationFrameService.createTask(this.addHoverFunctionality.bind(this, gui.element), this.rowNode.rowIndex, "createTasksP2");
        else this.addHoverFunctionality(gui.element);
        if (this.isFullWidth()) this.setupFullWidth(gui);
        if (gos.get("rowDragEntireRow")) this.addRowDraggerToRow(gui);
        if (this.useAnimationFrameForCreate) this.beans.animationFrameService.addDestroyTask(()=>{
            if (!this.isAlive()) return;
            gui.rowComp.addOrRemoveCssClass("ag-after-created", true);
        });
        this.executeProcessRowPostCreateFunc();
    }
    setRowCompRowBusinessKey(comp) {
        if (this.businessKeySanitised == null) return;
        comp.setRowBusinessKey(this.businessKeySanitised);
    }
    getBusinessKey() {
        return this.businessKeySanitised;
    }
    setRowCompRowId(comp) {
        this.rowId = escapeString(this.rowNode.id);
        if (this.rowId == null) return;
        comp.setRowId(this.rowId);
    }
    executeSlideAndFadeAnimations(gui) {
        const { containerType } = gui;
        const shouldSlide = this.slideInAnimation[containerType];
        if (shouldSlide) {
            executeNextVMTurn(()=>{
                this.onTopChanged();
            });
            this.slideInAnimation[containerType] = false;
        }
        const shouldFade = this.fadeInAnimation[containerType];
        if (shouldFade) {
            executeNextVMTurn(()=>{
                gui.rowComp.addOrRemoveCssClass("ag-opacity-zero", false);
            });
            this.fadeInAnimation[containerType] = false;
        }
    }
    addRowDraggerToRow(gui) {
        if (this.gos.get("enableRangeSelection")) {
            warnOnce("Setting `rowDragEntireRow: true` in the gridOptions doesn't work with `enableRangeSelection: true`");
            return;
        }
        const translate = this.beans.localeService.getLocaleTextFunc();
        const rowDragComp = new RowDragComp(()=>`1 ${translate("rowDragRow", "row")}`, this.rowNode, void 0, gui.element, void 0, true);
        const rowDragBean = this.createBean(rowDragComp, this.beans.context);
        this.rowDragComps.push(rowDragBean);
    }
    setupFullWidth(gui) {
        const pinned = this.getPinnedForContainer(gui.containerType);
        if (this.rowType == "FullWidthDetail" /* FullWidthDetail */ ) {
            if (!ModuleRegistry.__assertRegistered("@ag-grid-enterprise/master-detail" /* MasterDetailModule */ , "cell renderer 'agDetailCellRenderer' (for master detail)", this.beans.context.getGridId())) return;
        }
        const compDetails = this.createFullWidthCompDetails(gui.element, pinned);
        gui.rowComp.showFullWidth(compDetails);
    }
    isPrintLayout() {
        return this.printLayout;
    }
    getFullWidthCellRenderers() {
        var _a, _b;
        if (this.gos.get("embedFullWidthRows")) return this.allRowGuis.map((gui)=>{
            var _a2;
            return (_a2 = gui == null ? void 0 : gui.rowComp) == null ? void 0 : _a2.getFullWidthCellRenderer();
        });
        return [
            (_b = (_a = this.fullWidthGui) == null ? void 0 : _a.rowComp) == null ? void 0 : _b.getFullWidthCellRenderer()
        ];
    }
    // use by autoWidthCalculator, as it clones the elements
    getCellElement(column) {
        const cellCtrl = this.getCellCtrl(column);
        return cellCtrl ? cellCtrl.getGui() : null;
    }
    executeProcessRowPostCreateFunc() {
        const func = this.gos.getCallback("processRowPostCreate");
        if (!func || !this.areAllContainersReady()) return;
        const params = {
            // areAllContainersReady asserts that centerGui is not null
            eRow: this.centerGui.element,
            ePinnedLeftRow: this.leftGui ? this.leftGui.element : void 0,
            ePinnedRightRow: this.rightGui ? this.rightGui.element : void 0,
            node: this.rowNode,
            rowIndex: this.rowNode.rowIndex,
            addRenderedRowListener: this.addEventListener.bind(this)
        };
        func(params);
    }
    areAllContainersReady() {
        const isLeftReady = !!this.leftGui || !this.beans.columnModel.isPinningLeft();
        const isCenterReady = !!this.centerGui;
        const isRightReady = !!this.rightGui || !this.beans.columnModel.isPinningRight();
        return isLeftReady && isCenterReady && isRightReady;
    }
    setRowType() {
        const isStub = this.rowNode.stub && !this.gos.get("suppressServerSideFullWidthLoadingRow");
        const isFullWidthCell = this.rowNode.isFullWidthCell();
        const isDetailCell = this.gos.get("masterDetail") && this.rowNode.detail;
        const pivotMode = this.beans.columnModel.isPivotMode();
        const isGroupRow = !!this.rowNode.group && !this.rowNode.footer;
        const isFullWidthGroup = isGroupRow && this.gos.isGroupUseEntireRow(pivotMode);
        if (isStub) this.rowType = "FullWidthLoading" /* FullWidthLoading */ ;
        else if (isDetailCell) this.rowType = "FullWidthDetail" /* FullWidthDetail */ ;
        else if (isFullWidthCell) this.rowType = "FullWidth" /* FullWidth */ ;
        else if (isFullWidthGroup) this.rowType = "FullWidthGroup" /* FullWidthGroup */ ;
        else this.rowType = "Normal" /* Normal */ ;
    }
    updateColumnLists(suppressAnimationFrame = false, useFlushSync = false) {
        if (this.isFullWidth()) return;
        const noAnimation = suppressAnimationFrame || this.gos.get("suppressAnimationFrame") || this.printLayout;
        if (noAnimation) {
            this.updateColumnListsImpl(useFlushSync);
            return;
        }
        if (this.updateColumnListsPending) return;
        this.beans.animationFrameService.createTask(()=>{
            if (!this.active) return;
            this.updateColumnListsImpl(true);
        }, this.rowNode.rowIndex, "createTasksP1");
        this.updateColumnListsPending = true;
    }
    createCellCtrls(prev, cols, pinned = null) {
        const res = {
            list: [],
            map: {}
        };
        const addCell = (colInstanceId, cellCtrl)=>{
            res.list.push(cellCtrl);
            res.map[colInstanceId] = cellCtrl;
        };
        cols.forEach((col)=>{
            const colInstanceId = col.getInstanceId();
            let cellCtrl = prev.map[colInstanceId];
            if (!cellCtrl) cellCtrl = new CellCtrl(col, this.rowNode, this.beans, this);
            addCell(colInstanceId, cellCtrl);
        });
        prev.list.forEach((prevCellCtrl)=>{
            const cellInResult = res.map[prevCellCtrl.getColumn().getInstanceId()] != null;
            if (cellInResult) return;
            const keepCell = !this.isCellEligibleToBeRemoved(prevCellCtrl, pinned);
            if (keepCell) {
                addCell(prevCellCtrl.getColumn().getInstanceId(), prevCellCtrl);
                return;
            }
            prevCellCtrl.destroy();
        });
        return res;
    }
    updateColumnListsImpl(useFlushSync) {
        this.updateColumnListsPending = false;
        this.createAllCellCtrls();
        this.setCellCtrls(useFlushSync);
    }
    setCellCtrls(useFlushSync) {
        this.allRowGuis.forEach((item)=>{
            const cellControls = this.getCellCtrlsForContainer(item.containerType);
            item.rowComp.setCellCtrls(cellControls, useFlushSync);
        });
    }
    getCellCtrlsForContainer(containerType) {
        switch(containerType){
            case "left" /* LEFT */ :
                return this.leftCellCtrls.list;
            case "right" /* RIGHT */ :
                return this.rightCellCtrls.list;
            case "fullWidth" /* FULL_WIDTH */ :
                return [];
            case "center" /* CENTER */ :
                return this.centerCellCtrls.list;
            default:
                const exhaustiveCheck = containerType;
                throw new Error(`Unhandled case: ${exhaustiveCheck}`);
        }
    }
    createAllCellCtrls() {
        const columnModel = this.beans.columnModel;
        if (this.printLayout) {
            this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, columnModel.getAllDisplayedColumns());
            this.leftCellCtrls = {
                list: [],
                map: {}
            };
            this.rightCellCtrls = {
                list: [],
                map: {}
            };
        } else {
            const centerCols = columnModel.getViewportCenterColumnsForRow(this.rowNode);
            this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, centerCols);
            const leftCols = columnModel.getDisplayedLeftColumnsForRow(this.rowNode);
            this.leftCellCtrls = this.createCellCtrls(this.leftCellCtrls, leftCols, "left");
            const rightCols = columnModel.getDisplayedRightColumnsForRow(this.rowNode);
            this.rightCellCtrls = this.createCellCtrls(this.rightCellCtrls, rightCols, "right");
        }
    }
    isCellEligibleToBeRemoved(cellCtrl, nextContainerPinned) {
        const REMOVE_CELL = true;
        const KEEP_CELL = false;
        const column = cellCtrl.getColumn();
        if (column.getPinned() != nextContainerPinned) return REMOVE_CELL;
        const editing = cellCtrl.isEditing();
        const focused = this.beans.focusService.isCellFocused(cellCtrl.getCellPosition());
        const mightWantToKeepCell = editing || focused;
        if (mightWantToKeepCell) {
            const column2 = cellCtrl.getColumn();
            const displayedColumns = this.beans.columnModel.getAllDisplayedColumns();
            const cellStillDisplayed = displayedColumns.indexOf(column2) >= 0;
            return cellStillDisplayed ? KEEP_CELL : REMOVE_CELL;
        }
        return REMOVE_CELL;
    }
    getDomOrder() {
        const isEnsureDomOrder = this.gos.get("ensureDomOrder");
        return isEnsureDomOrder || this.gos.isDomLayout("print");
    }
    listenOnDomOrder(gui) {
        const listener = ()=>{
            gui.rowComp.setDomOrder(this.getDomOrder());
        };
        this.addManagedPropertyListener("domLayout", listener);
        this.addManagedPropertyListener("ensureDomOrder", listener);
    }
    setAnimateFlags(animateIn) {
        if (this.isSticky() || !animateIn) return;
        const oldRowTopExists = exists(this.rowNode.oldRowTop);
        const pinningLeft = this.beans.columnModel.isPinningLeft();
        const pinningRight = this.beans.columnModel.isPinningRight();
        if (oldRowTopExists) {
            if (this.isFullWidth() && !this.gos.get("embedFullWidthRows")) {
                this.slideInAnimation.fullWidth = true;
                return;
            }
            this.slideInAnimation.center = true;
            this.slideInAnimation.left = pinningLeft;
            this.slideInAnimation.right = pinningRight;
        } else {
            if (this.isFullWidth() && !this.gos.get("embedFullWidthRows")) {
                this.fadeInAnimation.fullWidth = true;
                return;
            }
            this.fadeInAnimation.center = true;
            this.fadeInAnimation.left = pinningLeft;
            this.fadeInAnimation.right = pinningRight;
        }
    }
    isEditing() {
        return this.editingRow;
    }
    isFullWidth() {
        return this.rowType !== "Normal" /* Normal */ ;
    }
    refreshFullWidth() {
        const tryRefresh = (gui, pinned)=>{
            if (!gui) return true;
            return gui.rowComp.refreshFullWidth(()=>{
                const compDetails = this.createFullWidthCompDetails(gui.element, pinned);
                return compDetails.params;
            });
        };
        const fullWidthSuccess = tryRefresh(this.fullWidthGui, null);
        const centerSuccess = tryRefresh(this.centerGui, null);
        const leftSuccess = tryRefresh(this.leftGui, "left");
        const rightSuccess = tryRefresh(this.rightGui, "right");
        const allFullWidthRowsRefreshed = fullWidthSuccess && centerSuccess && leftSuccess && rightSuccess;
        return allFullWidthRowsRefreshed;
    }
    addListeners() {
        this.addManagedListener(this.rowNode, RowNode.EVENT_HEIGHT_CHANGED, ()=>this.onRowHeightChanged());
        this.addManagedListener(this.rowNode, RowNode.EVENT_ROW_SELECTED, ()=>this.onRowSelected());
        this.addManagedListener(this.rowNode, RowNode.EVENT_ROW_INDEX_CHANGED, this.onRowIndexChanged.bind(this));
        this.addManagedListener(this.rowNode, RowNode.EVENT_TOP_CHANGED, this.onTopChanged.bind(this));
        this.addManagedListener(this.rowNode, RowNode.EVENT_EXPANDED_CHANGED, this.updateExpandedCss.bind(this));
        this.addManagedListener(this.rowNode, RowNode.EVENT_HAS_CHILDREN_CHANGED, this.updateExpandedCss.bind(this));
        if (this.rowNode.detail) this.addManagedListener(this.rowNode.parent, RowNode.EVENT_DATA_CHANGED, this.onRowNodeDataChanged.bind(this));
        this.addManagedListener(this.rowNode, RowNode.EVENT_DATA_CHANGED, this.onRowNodeDataChanged.bind(this));
        this.addManagedListener(this.rowNode, RowNode.EVENT_CELL_CHANGED, this.postProcessCss.bind(this));
        this.addManagedListener(this.rowNode, RowNode.EVENT_HIGHLIGHT_CHANGED, this.onRowNodeHighlightChanged.bind(this));
        this.addManagedListener(this.rowNode, RowNode.EVENT_DRAGGING_CHANGED, this.postProcessRowDragging.bind(this));
        this.addManagedListener(this.rowNode, RowNode.EVENT_UI_LEVEL_CHANGED, this.onUiLevelChanged.bind(this));
        const eventService = this.beans.eventService;
        this.addManagedListener(eventService, Events.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED, this.onPaginationPixelOffsetChanged.bind(this));
        this.addManagedListener(eventService, Events.EVENT_HEIGHT_SCALE_CHANGED, this.onTopChanged.bind(this));
        this.addManagedListener(eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
        this.addManagedListener(eventService, Events.EVENT_VIRTUAL_COLUMNS_CHANGED, this.onVirtualColumnsChanged.bind(this));
        this.addManagedListener(eventService, Events.EVENT_CELL_FOCUSED, this.onCellFocusChanged.bind(this));
        this.addManagedListener(eventService, Events.EVENT_CELL_FOCUS_CLEARED, this.onCellFocusChanged.bind(this));
        this.addManagedListener(eventService, Events.EVENT_PAGINATION_CHANGED, this.onPaginationChanged.bind(this));
        this.addManagedListener(eventService, Events.EVENT_MODEL_UPDATED, this.refreshFirstAndLastRowStyles.bind(this));
        this.addManagedListener(eventService, Events.EVENT_COLUMN_MOVED, this.updateColumnLists.bind(this));
        this.addDestroyFunc(()=>{
            this.destroyBeans(this.rowDragComps, this.beans.context);
            if (this.tooltipFeature) this.tooltipFeature = this.destroyBean(this.tooltipFeature, this.beans.context);
        });
        this.addManagedPropertyListeners([
            "rowDragEntireRow"
        ], ()=>{
            const useRowDragEntireRow = this.gos.get("rowDragEntireRow");
            if (useRowDragEntireRow) {
                this.allRowGuis.forEach((gui)=>{
                    this.addRowDraggerToRow(gui);
                });
                return;
            }
            this.destroyBeans(this.rowDragComps, this.beans.context);
            this.rowDragComps = [];
        });
        this.addListenersForCellComps();
    }
    addListenersForCellComps() {
        this.addManagedListener(this.rowNode, RowNode.EVENT_ROW_INDEX_CHANGED, ()=>{
            this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onRowIndexChanged());
        });
        this.addManagedListener(this.rowNode, RowNode.EVENT_CELL_CHANGED, (event)=>{
            this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onCellChanged(event));
        });
    }
    onRowNodeDataChanged(event) {
        const fullWidthChanged = this.isFullWidth() !== !!this.rowNode.isFullWidthCell();
        if (fullWidthChanged) {
            this.beans.rowRenderer.redrawRow(this.rowNode);
            return;
        }
        if (this.isFullWidth()) {
            const refresh = this.refreshFullWidth();
            if (!refresh) this.beans.rowRenderer.redrawRow(this.rowNode);
            return;
        }
        this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.refreshCell({
                suppressFlash: !event.update,
                newData: !event.update
            }));
        this.allRowGuis.forEach((gui)=>{
            this.setRowCompRowId(gui.rowComp);
            this.updateRowBusinessKey();
            this.setRowCompRowBusinessKey(gui.rowComp);
        });
        this.onRowSelected();
        this.postProcessCss();
    }
    postProcessCss() {
        this.setStylesFromGridOptions(true);
        this.postProcessClassesFromGridOptions();
        this.postProcessRowClassRules();
        this.postProcessRowDragging();
    }
    onRowNodeHighlightChanged() {
        const highlighted = this.rowNode.highlighted;
        this.allRowGuis.forEach((gui)=>{
            const aboveOn = highlighted === 0 /* Above */ ;
            const belowOn = highlighted === 1 /* Below */ ;
            gui.rowComp.addOrRemoveCssClass("ag-row-highlight-above", aboveOn);
            gui.rowComp.addOrRemoveCssClass("ag-row-highlight-below", belowOn);
        });
    }
    postProcessRowDragging() {
        const dragging = this.rowNode.dragging;
        this.allRowGuis.forEach((gui)=>gui.rowComp.addOrRemoveCssClass("ag-row-dragging", dragging));
    }
    updateExpandedCss() {
        const expandable = this.rowNode.isExpandable();
        const expanded = this.rowNode.expanded == true;
        this.allRowGuis.forEach((gui)=>{
            gui.rowComp.addOrRemoveCssClass("ag-row-group", expandable);
            gui.rowComp.addOrRemoveCssClass("ag-row-group-expanded", expandable && expanded);
            gui.rowComp.addOrRemoveCssClass("ag-row-group-contracted", expandable && !expanded);
            setAriaExpanded(gui.element, expandable && expanded);
        });
    }
    onDisplayedColumnsChanged() {
        this.updateColumnLists(true);
        if (this.beans.columnModel.wasAutoRowHeightEverActive()) this.rowNode.checkAutoHeights();
    }
    onVirtualColumnsChanged() {
        this.updateColumnLists(false, true);
    }
    getRowPosition() {
        return {
            rowPinned: makeNull(this.rowNode.rowPinned),
            rowIndex: this.rowNode.rowIndex
        };
    }
    onKeyboardNavigate(keyboardEvent) {
        const currentFullWidthComp = this.allRowGuis.find((c)=>c.element.contains(keyboardEvent.target));
        const currentFullWidthContainer = currentFullWidthComp ? currentFullWidthComp.element : null;
        const isFullWidthContainerFocused = currentFullWidthContainer === keyboardEvent.target;
        if (!isFullWidthContainerFocused) return;
        const node = this.rowNode;
        const lastFocusedCell = this.beans.focusService.getFocusedCell();
        const cellPosition = {
            rowIndex: node.rowIndex,
            rowPinned: node.rowPinned,
            column: lastFocusedCell && lastFocusedCell.column
        };
        this.beans.navigationService.navigateToNextCell(keyboardEvent, keyboardEvent.key, cellPosition, true);
        keyboardEvent.preventDefault();
    }
    onTabKeyDown(keyboardEvent) {
        if (keyboardEvent.defaultPrevented || isStopPropagationForAgGrid(keyboardEvent)) return;
        const currentFullWidthComp = this.allRowGuis.find((c)=>c.element.contains(keyboardEvent.target));
        const currentFullWidthContainer = currentFullWidthComp ? currentFullWidthComp.element : null;
        const isFullWidthContainerFocused = currentFullWidthContainer === keyboardEvent.target;
        let nextEl = null;
        if (!isFullWidthContainerFocused) nextEl = this.beans.focusService.findNextFocusableElement(currentFullWidthContainer, false, keyboardEvent.shiftKey);
        if (this.isFullWidth() && isFullWidthContainerFocused || !nextEl) this.beans.navigationService.onTabKeyDown(this, keyboardEvent);
    }
    getFullWidthElement() {
        if (this.fullWidthGui) return this.fullWidthGui.element;
        return null;
    }
    getRowYPosition() {
        var _a;
        const displayedEl = (_a = this.allRowGuis.find((el)=>isVisible(el.element))) == null ? void 0 : _a.element;
        if (displayedEl) return displayedEl.getBoundingClientRect().top;
        return 0;
    }
    onFullWidthRowFocused(event) {
        var _a;
        const node = this.rowNode;
        const isFocused = !event ? false : this.isFullWidth() && event.rowIndex === node.rowIndex && event.rowPinned == node.rowPinned;
        const element = this.fullWidthGui ? this.fullWidthGui.element : (_a = this.centerGui) == null ? void 0 : _a.element;
        if (!element) return;
        element.classList.toggle("ag-full-width-focus", isFocused);
        if (isFocused) element.focus({
            preventScroll: true
        });
    }
    recreateCell(cellCtrl) {
        this.centerCellCtrls = this.removeCellCtrl(this.centerCellCtrls, cellCtrl);
        this.leftCellCtrls = this.removeCellCtrl(this.leftCellCtrls, cellCtrl);
        this.rightCellCtrls = this.removeCellCtrl(this.rightCellCtrls, cellCtrl);
        cellCtrl.destroy();
        this.updateColumnLists();
    }
    removeCellCtrl(prev, cellCtrlToRemove) {
        const res = {
            list: [],
            map: {}
        };
        prev.list.forEach((cellCtrl)=>{
            if (cellCtrl === cellCtrlToRemove) return;
            res.list.push(cellCtrl);
            res.map[cellCtrl.getColumn().getInstanceId()] = cellCtrl;
        });
        return res;
    }
    onMouseEvent(eventName, mouseEvent) {
        switch(eventName){
            case "dblclick":
                this.onRowDblClick(mouseEvent);
                break;
            case "click":
                this.onRowClick(mouseEvent);
                break;
            case "touchstart":
            case "mousedown":
                this.onRowMouseDown(mouseEvent);
                break;
        }
    }
    createRowEvent(type, domEvent) {
        return this.gos.addGridCommonParams({
            type,
            node: this.rowNode,
            data: this.rowNode.data,
            rowIndex: this.rowNode.rowIndex,
            rowPinned: this.rowNode.rowPinned,
            event: domEvent
        });
    }
    createRowEventWithSource(type, domEvent) {
        const event = this.createRowEvent(type, domEvent);
        event.source = this;
        return event;
    }
    onRowDblClick(mouseEvent) {
        if (isStopPropagationForAgGrid(mouseEvent)) return;
        const agEvent = this.createRowEventWithSource(Events.EVENT_ROW_DOUBLE_CLICKED, mouseEvent);
        this.beans.eventService.dispatchEvent(agEvent);
    }
    onRowMouseDown(mouseEvent) {
        this.lastMouseDownOnDragger = isElementChildOfClass(mouseEvent.target, "ag-row-drag", 3);
        if (!this.isFullWidth()) return;
        const node = this.rowNode;
        const columnModel = this.beans.columnModel;
        if (this.beans.rangeService) this.beans.rangeService.removeAllCellRanges();
        this.beans.focusService.setFocusedCell({
            rowIndex: node.rowIndex,
            column: columnModel.getAllDisplayedColumns()[0],
            rowPinned: node.rowPinned,
            forceBrowserFocus: true
        });
    }
    onRowClick(mouseEvent) {
        const stop = isStopPropagationForAgGrid(mouseEvent) || this.lastMouseDownOnDragger;
        if (stop) return;
        const agEvent = this.createRowEventWithSource(Events.EVENT_ROW_CLICKED, mouseEvent);
        this.beans.eventService.dispatchEvent(agEvent);
        const isMultiKey = mouseEvent.ctrlKey || mouseEvent.metaKey;
        const isShiftKey = mouseEvent.shiftKey;
        const groupSelectsChildren = this.gos.get("groupSelectsChildren");
        if (// we do not allow selecting groups by clicking (as the click here expands the group), or if it's a detail row,
        // so return if it's a group row
        groupSelectsChildren && this.rowNode.group || this.isRowSelectionBlocked() || // if click selection suppressed, do nothing
        this.gos.get("suppressRowClickSelection")) return;
        const multiSelectOnClick = this.gos.get("rowMultiSelectWithClick");
        const rowDeselectionWithCtrl = !this.gos.get("suppressRowDeselection");
        const source = "rowClicked";
        if (this.rowNode.isSelected()) {
            if (multiSelectOnClick) this.rowNode.setSelectedParams({
                newValue: false,
                event: mouseEvent,
                source
            });
            else if (isMultiKey) {
                if (rowDeselectionWithCtrl) this.rowNode.setSelectedParams({
                    newValue: false,
                    event: mouseEvent,
                    source
                });
            } else this.rowNode.setSelectedParams({
                newValue: true,
                clearSelection: !isShiftKey,
                rangeSelect: isShiftKey,
                event: mouseEvent,
                source
            });
        } else {
            const clearSelection = multiSelectOnClick ? false : !isMultiKey;
            this.rowNode.setSelectedParams({
                newValue: true,
                clearSelection,
                rangeSelect: isShiftKey,
                event: mouseEvent,
                source
            });
        }
    }
    isRowSelectionBlocked() {
        return !this.rowNode.selectable || !!this.rowNode.rowPinned || !this.gos.isRowSelection();
    }
    setupDetailRowAutoHeight(eDetailGui) {
        if (this.rowType !== "FullWidthDetail" /* FullWidthDetail */ ) return;
        if (!this.gos.get("detailRowAutoHeight")) return;
        const checkRowSizeFunc = ()=>{
            const clientHeight = eDetailGui.clientHeight;
            if (clientHeight != null && clientHeight > 0) {
                const updateRowHeightFunc = ()=>{
                    this.rowNode.setRowHeight(clientHeight);
                    if (this.beans.clientSideRowModel) this.beans.clientSideRowModel.onRowHeightChanged();
                    else if (this.beans.serverSideRowModel) this.beans.serverSideRowModel.onRowHeightChanged();
                };
                window.setTimeout(updateRowHeightFunc, 0);
            }
        };
        const resizeObserverDestroyFunc = this.beans.resizeObserverService.observeResize(eDetailGui, checkRowSizeFunc);
        this.addDestroyFunc(resizeObserverDestroyFunc);
        checkRowSizeFunc();
    }
    createFullWidthCompDetails(eRow, pinned) {
        const params = this.gos.addGridCommonParams({
            fullWidth: true,
            data: this.rowNode.data,
            node: this.rowNode,
            value: this.rowNode.key,
            valueFormatted: this.rowNode.key,
            rowIndex: this.rowNode.rowIndex,
            // these need to be taken out, as part of 'afterAttached' now
            eGridCell: eRow,
            eParentOfValue: eRow,
            pinned,
            addRenderedRowListener: this.addEventListener.bind(this),
            registerRowDragger: (rowDraggerElement, dragStartPixels, value, suppressVisibilityChange)=>this.addFullWidthRowDragging(rowDraggerElement, dragStartPixels, value, suppressVisibilityChange),
            setTooltip: (value, shouldDisplayTooltip)=>this.refreshRowTooltip(value, shouldDisplayTooltip)
        });
        switch(this.rowType){
            case "FullWidthDetail" /* FullWidthDetail */ :
                return this.beans.userComponentFactory.getFullWidthDetailCellRendererDetails(params);
            case "FullWidthGroup" /* FullWidthGroup */ :
                return this.beans.userComponentFactory.getFullWidthGroupCellRendererDetails(params);
            case "FullWidthLoading" /* FullWidthLoading */ :
                return this.beans.userComponentFactory.getFullWidthLoadingCellRendererDetails(params);
            default:
                return this.beans.userComponentFactory.getFullWidthCellRendererDetails(params);
        }
    }
    refreshRowTooltip(value, shouldDisplayTooltip) {
        if (!this.fullWidthGui) return;
        const tooltipParams = {
            getGui: ()=>this.fullWidthGui.element,
            getTooltipValue: ()=>value,
            getLocation: ()=>"fullWidthRow",
            shouldDisplayTooltip
        };
        if (this.tooltipFeature) this.destroyBean(this.tooltipFeature, this.beans.context);
        this.tooltipFeature = this.createBean(new TooltipFeature(tooltipParams, this.beans));
    }
    addFullWidthRowDragging(rowDraggerElement, dragStartPixels, value = "", suppressVisibilityChange) {
        if (!this.isFullWidth()) return;
        const rowDragComp = new RowDragComp(()=>value, this.rowNode, void 0, rowDraggerElement, dragStartPixels, suppressVisibilityChange);
        this.createBean(rowDragComp, this.beans.context);
        this.addDestroyFunc(()=>{
            this.destroyBean(rowDragComp, this.beans.context);
        });
    }
    onUiLevelChanged() {
        const newLevel = this.beans.rowCssClassCalculator.calculateRowLevel(this.rowNode);
        if (this.rowLevel != newLevel) {
            const classToAdd = "ag-row-level-" + newLevel;
            const classToRemove = "ag-row-level-" + this.rowLevel;
            this.allRowGuis.forEach((gui)=>{
                gui.rowComp.addOrRemoveCssClass(classToAdd, true);
                gui.rowComp.addOrRemoveCssClass(classToRemove, false);
            });
        }
        this.rowLevel = newLevel;
    }
    isFirstRowOnPage() {
        return this.rowNode.rowIndex === this.beans.paginationProxy.getPageFirstRow();
    }
    isLastRowOnPage() {
        return this.rowNode.rowIndex === this.beans.paginationProxy.getPageLastRow();
    }
    refreshFirstAndLastRowStyles() {
        const newFirst = this.isFirstRowOnPage();
        const newLast = this.isLastRowOnPage();
        if (this.firstRowOnPage !== newFirst) {
            this.firstRowOnPage = newFirst;
            this.allRowGuis.forEach((gui)=>gui.rowComp.addOrRemoveCssClass("ag-row-first", newFirst));
        }
        if (this.lastRowOnPage !== newLast) {
            this.lastRowOnPage = newLast;
            this.allRowGuis.forEach((gui)=>gui.rowComp.addOrRemoveCssClass("ag-row-last", newLast));
        }
    }
    stopEditing(cancel = false) {
        if (this.stoppingRowEdit) return;
        const cellControls = this.getAllCellCtrls();
        const isRowEdit = this.editingRow;
        this.stoppingRowEdit = true;
        let fireRowEditEvent = false;
        for (const ctrl of cellControls){
            const valueChanged = ctrl.stopEditing(cancel);
            if (isRowEdit && !cancel && !fireRowEditEvent && valueChanged) fireRowEditEvent = true;
        }
        if (fireRowEditEvent) {
            const event = this.createRowEvent(Events.EVENT_ROW_VALUE_CHANGED);
            this.beans.eventService.dispatchEvent(event);
        }
        if (isRowEdit) this.setEditingRow(false);
        this.stoppingRowEdit = false;
    }
    setInlineEditingCss(editing) {
        this.allRowGuis.forEach((gui)=>{
            gui.rowComp.addOrRemoveCssClass("ag-row-inline-editing", editing);
            gui.rowComp.addOrRemoveCssClass("ag-row-not-inline-editing", !editing);
        });
    }
    setEditingRow(value) {
        this.editingRow = value;
        this.allRowGuis.forEach((gui)=>gui.rowComp.addOrRemoveCssClass("ag-row-editing", value));
        const event = value ? this.createRowEvent(Events.EVENT_ROW_EDITING_STARTED) : this.createRowEvent(Events.EVENT_ROW_EDITING_STOPPED);
        this.beans.eventService.dispatchEvent(event);
    }
    startRowEditing(key = null, sourceRenderedCell = null, event = null) {
        if (this.editingRow) return;
        const atLeastOneEditing = this.getAllCellCtrls().reduce((prev, cellCtrl)=>{
            const cellStartedEdit = cellCtrl === sourceRenderedCell;
            if (cellStartedEdit) cellCtrl.startEditing(key, cellStartedEdit, event);
            else cellCtrl.startEditing(null, cellStartedEdit, event);
            if (prev) return true;
            return cellCtrl.isEditing();
        }, false);
        if (atLeastOneEditing) this.setEditingRow(true);
    }
    getAllCellCtrls() {
        if (this.leftCellCtrls.list.length === 0 && this.rightCellCtrls.list.length === 0) return this.centerCellCtrls.list;
        const res = [
            ...this.centerCellCtrls.list,
            ...this.leftCellCtrls.list,
            ...this.rightCellCtrls.list
        ];
        return res;
    }
    postProcessClassesFromGridOptions() {
        const cssClasses = this.beans.rowCssClassCalculator.processClassesFromGridOptions(this.rowNode);
        if (!cssClasses || !cssClasses.length) return;
        cssClasses.forEach((classStr)=>{
            this.allRowGuis.forEach((c)=>c.rowComp.addOrRemoveCssClass(classStr, true));
        });
    }
    postProcessRowClassRules() {
        this.beans.rowCssClassCalculator.processRowClassRules(this.rowNode, (className)=>{
            this.allRowGuis.forEach((gui)=>gui.rowComp.addOrRemoveCssClass(className, true));
        }, (className)=>{
            this.allRowGuis.forEach((gui)=>gui.rowComp.addOrRemoveCssClass(className, false));
        });
    }
    setStylesFromGridOptions(updateStyles, gui) {
        if (updateStyles) this.rowStyles = this.processStylesFromGridOptions();
        this.forEachGui(gui, (gui2)=>gui2.rowComp.setUserStyles(this.rowStyles));
    }
    getPinnedForContainer(rowContainerType) {
        const pinned = rowContainerType === "left" /* LEFT */  ? "left" : rowContainerType === "right" /* RIGHT */  ? "right" : null;
        return pinned;
    }
    getInitialRowClasses(rowContainerType) {
        const pinned = this.getPinnedForContainer(rowContainerType);
        const params = {
            rowNode: this.rowNode,
            rowFocused: this.rowFocused,
            fadeRowIn: this.fadeInAnimation[rowContainerType],
            rowIsEven: this.rowNode.rowIndex % 2 === 0,
            rowLevel: this.rowLevel,
            fullWidthRow: this.isFullWidth(),
            firstRowOnPage: this.isFirstRowOnPage(),
            lastRowOnPage: this.isLastRowOnPage(),
            printLayout: this.printLayout,
            expandable: this.rowNode.isExpandable(),
            pinned
        };
        return this.beans.rowCssClassCalculator.getInitialRowClasses(params);
    }
    processStylesFromGridOptions() {
        const rowStyle = this.gos.get("rowStyle");
        if (rowStyle && typeof rowStyle === "function") {
            console.warn("AG Grid: rowStyle should be an object of key/value styles, not be a function, use getRowStyle() instead");
            return;
        }
        const rowStyleFunc = this.gos.getCallback("getRowStyle");
        let rowStyleFuncResult;
        if (rowStyleFunc) {
            const params = {
                data: this.rowNode.data,
                node: this.rowNode,
                rowIndex: this.rowNode.rowIndex
            };
            rowStyleFuncResult = rowStyleFunc(params);
        }
        if (rowStyleFuncResult || rowStyle) return Object.assign({}, rowStyle, rowStyleFuncResult);
        return this.emptyStyle;
    }
    onRowSelected(gui) {
        const selected = !!this.rowNode.isSelected();
        this.forEachGui(gui, (gui2)=>{
            gui2.rowComp.addOrRemoveCssClass("ag-row-selected", selected);
            setAriaSelected(gui2.element, selected);
            const hasFocus = gui2.element.contains(this.beans.gos.getActiveDomElement());
            if (hasFocus && (gui2 === this.centerGui || gui2 === this.fullWidthGui)) this.announceDescription();
        });
    }
    announceDescription() {
        if (this.isRowSelectionBlocked()) return;
        const selected = this.rowNode.isSelected();
        if (selected && this.beans.gos.get("suppressRowDeselection")) return;
        const translate = this.beans.localeService.getLocaleTextFunc();
        const label = translate(selected ? "ariaRowDeselect" : "ariaRowSelect", `Press SPACE to ${selected ? "deselect" : "select"} this row.`);
        this.beans.ariaAnnouncementService.announceValue(label);
    }
    addHoverFunctionality(eRow) {
        if (!this.active) return;
        this.addManagedListener(eRow, "mouseenter", ()=>this.rowNode.onMouseEnter());
        this.addManagedListener(eRow, "mouseleave", ()=>this.rowNode.onMouseLeave());
        this.addManagedListener(this.rowNode, RowNode.EVENT_MOUSE_ENTER, ()=>{
            if (!this.beans.dragService.isDragging() && !this.gos.get("suppressRowHoverHighlight")) {
                eRow.classList.add("ag-row-hover");
                this.rowNode.setHovered(true);
            }
        });
        this.addManagedListener(this.rowNode, RowNode.EVENT_MOUSE_LEAVE, ()=>{
            eRow.classList.remove("ag-row-hover");
            this.rowNode.setHovered(false);
        });
    }
    // for animation, we don't want to animate entry or exit to a very far away pixel,
    // otherwise the row would move so fast, it would appear to disappear. so this method
    // moves the row closer to the viewport if it is far away, so the row slide in / out
    // at a speed the user can see.
    roundRowTopToBounds(rowTop) {
        const range = this.beans.ctrlsService.getGridBodyCtrl().getScrollFeature().getApproximateVScollPosition();
        const minPixel = this.applyPaginationOffset(range.top, true) - 100;
        const maxPixel = this.applyPaginationOffset(range.bottom, true) + 100;
        return Math.min(Math.max(minPixel, rowTop), maxPixel);
    }
    getFrameworkOverrides() {
        return this.beans.frameworkOverrides;
    }
    forEachGui(gui, callback) {
        if (gui) callback(gui);
        else this.allRowGuis.forEach(callback);
    }
    onRowHeightChanged(gui) {
        if (this.rowNode.rowHeight == null) return;
        const rowHeight = this.rowNode.rowHeight;
        const defaultRowHeight = this.beans.environment.getDefaultRowHeight();
        const isHeightFromFunc = this.gos.isGetRowHeightFunction();
        const heightFromFunc = isHeightFromFunc ? this.gos.getRowHeightForNode(this.rowNode).height : void 0;
        const lineHeight = heightFromFunc ? `${Math.min(defaultRowHeight, heightFromFunc) - 2}px` : void 0;
        this.forEachGui(gui, (gui2)=>{
            gui2.element.style.height = `${rowHeight}px`;
            if (lineHeight) gui2.element.style.setProperty("--ag-line-height", lineHeight);
        });
    }
    addEventListener(eventType, listener) {
        super.addEventListener(eventType, listener);
    }
    removeEventListener(eventType, listener) {
        super.removeEventListener(eventType, listener);
    }
    // note - this is NOT called by context, as we don't wire / unwire the CellComp for performance reasons.
    destroyFirstPass(suppressAnimation = false) {
        this.active = false;
        if (!suppressAnimation && this.gos.isAnimateRows() && !this.isSticky()) {
            const rowStillVisibleJustNotInViewport = this.rowNode.rowTop != null;
            if (rowStillVisibleJustNotInViewport) {
                const rowTop = this.roundRowTopToBounds(this.rowNode.rowTop);
                this.setRowTop(rowTop);
            } else this.allRowGuis.forEach((gui)=>gui.rowComp.addOrRemoveCssClass("ag-opacity-zero", true));
        }
        this.rowNode.setHovered(false);
        const event = this.createRowEvent(Events.EVENT_VIRTUAL_ROW_REMOVED);
        this.dispatchEvent(event);
        this.beans.eventService.dispatchEvent(event);
        super.destroy();
    }
    destroySecondPass() {
        this.allRowGuis.length = 0;
        this.stopEditing();
        const destroyCellCtrls = (ctrls)=>{
            ctrls.list.forEach((c)=>c.destroy());
            return {
                list: [],
                map: {}
            };
        };
        this.centerCellCtrls = destroyCellCtrls(this.centerCellCtrls);
        this.leftCellCtrls = destroyCellCtrls(this.leftCellCtrls);
        this.rightCellCtrls = destroyCellCtrls(this.rightCellCtrls);
    }
    setFocusedClasses(gui) {
        this.forEachGui(gui, (gui2)=>{
            gui2.rowComp.addOrRemoveCssClass("ag-row-focus", this.rowFocused);
            gui2.rowComp.addOrRemoveCssClass("ag-row-no-focus", !this.rowFocused);
        });
    }
    onCellFocusChanged() {
        const rowFocused = this.beans.focusService.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned);
        if (rowFocused !== this.rowFocused) {
            this.rowFocused = rowFocused;
            this.setFocusedClasses();
        }
        if (!rowFocused && this.editingRow) this.stopEditing(false);
    }
    onPaginationChanged() {
        const currentPage = this.beans.paginationProxy.getCurrentPage();
        if (this.paginationPage !== currentPage) {
            this.paginationPage = currentPage;
            this.onTopChanged();
        }
        this.refreshFirstAndLastRowStyles();
    }
    onTopChanged() {
        this.setRowTop(this.rowNode.rowTop);
    }
    onPaginationPixelOffsetChanged() {
        this.onTopChanged();
    }
    // applies pagination offset, eg if on second page, and page height is 500px, then removes
    // 500px from the top position, so a row with rowTop 600px is displayed at location 100px.
    // reverse will take the offset away rather than add.
    applyPaginationOffset(topPx, reverse = false) {
        if (this.rowNode.isRowPinned() || this.rowNode.sticky) return topPx;
        const pixelOffset = this.beans.paginationProxy.getPixelOffset();
        const multiplier = reverse ? 1 : -1;
        return topPx + pixelOffset * multiplier;
    }
    setRowTop(pixels) {
        if (this.printLayout) return;
        if (exists(pixels)) {
            const afterPaginationPixels = this.applyPaginationOffset(pixels);
            const skipScaling = this.rowNode.isRowPinned() || this.rowNode.sticky;
            const afterScalingPixels = skipScaling ? afterPaginationPixels : this.beans.rowContainerHeightService.getRealPixelPosition(afterPaginationPixels);
            const topPx = `${afterScalingPixels}px`;
            this.setRowTopStyle(topPx);
        }
    }
    // the top needs to be set into the DOM element when the element is created, not updated afterwards.
    // otherwise the transition would not work, as it would be transitioning from zero (the unset value).
    // for example, suppose a row that is outside the viewport, then user does a filter to remove other rows
    // and this row now appears in the viewport, and the row moves up (ie it was under the viewport and not rendered,
    // but now is in the viewport) then a new RowComp is created, however it should have it's position initialised
    // to below the viewport, so the row will appear to animate up. if we didn't set the initial position at creation
    // time, the row would animate down (ie from position zero).
    getInitialRowTop(rowContainerType) {
        return this.suppressRowTransform ? this.getInitialRowTopShared(rowContainerType) : void 0;
    }
    getInitialTransform(rowContainerType) {
        return this.suppressRowTransform ? void 0 : `translateY(${this.getInitialRowTopShared(rowContainerType)})`;
    }
    getInitialRowTopShared(rowContainerType) {
        if (this.printLayout) return "";
        let rowTop;
        if (this.isSticky()) rowTop = this.rowNode.stickyRowTop;
        else {
            const pixels = this.slideInAnimation[rowContainerType] ? this.roundRowTopToBounds(this.rowNode.oldRowTop) : this.rowNode.rowTop;
            const afterPaginationPixels = this.applyPaginationOffset(pixels);
            rowTop = this.rowNode.isRowPinned() ? afterPaginationPixels : this.beans.rowContainerHeightService.getRealPixelPosition(afterPaginationPixels);
        }
        return rowTop + "px";
    }
    setRowTopStyle(topPx) {
        this.allRowGuis.forEach((gui)=>this.suppressRowTransform ? gui.rowComp.setTop(topPx) : gui.rowComp.setTransform(`translateY(${topPx})`));
    }
    getRowNode() {
        return this.rowNode;
    }
    getCellCtrl(column) {
        let res = null;
        this.getAllCellCtrls().forEach((cellCtrl)=>{
            if (cellCtrl.getColumn() == column) res = cellCtrl;
        });
        if (res != null) return res;
        this.getAllCellCtrls().forEach((cellCtrl)=>{
            if (cellCtrl.getColSpanningList().indexOf(column) >= 0) res = cellCtrl;
        });
        return res;
    }
    onRowIndexChanged() {
        if (this.rowNode.rowIndex != null) {
            this.onCellFocusChanged();
            this.updateRowIndexes();
            this.postProcessCss();
        }
    }
    getRowIndex() {
        return this.rowNode.getRowIndexString();
    }
    updateRowIndexes(gui) {
        const rowIndexStr = this.rowNode.getRowIndexString();
        const headerRowCount = this.beans.headerNavigationService.getHeaderRowCount() + this.beans.filterManager.getHeaderRowCount();
        const rowIsEven = this.rowNode.rowIndex % 2 === 0;
        const ariaRowIndex = headerRowCount + this.rowNode.rowIndex + 1;
        this.forEachGui(gui, (c)=>{
            c.rowComp.setRowIndex(rowIndexStr);
            c.rowComp.addOrRemoveCssClass("ag-row-even", rowIsEven);
            c.rowComp.addOrRemoveCssClass("ag-row-odd", !rowIsEven);
            setAriaRowIndex(c.element, ariaRowIndex);
        });
    }
};
_RowCtrl.DOM_DATA_KEY_ROW_CTRL = "renderedRow";
var RowCtrl = _RowCtrl;
// community-modules/core/src/gridBodyComp/rowContainer/rowContainerEventsFeature.ts
var RowContainerEventsFeature = class extends BeanStub {
    constructor(element){
        super();
        this.element = element;
    }
    postConstruct() {
        this.addKeyboardListeners();
        this.addMouseListeners();
        this.mockContextMenuForIPad();
    }
    addKeyboardListeners() {
        const eventName = "keydown";
        const listener = this.processKeyboardEvent.bind(this, eventName);
        this.addManagedListener(this.element, eventName, listener);
    }
    addMouseListeners() {
        const mouseDownEvent = isEventSupported("touchstart") ? "touchstart" : "mousedown";
        const eventNames = [
            "dblclick",
            "contextmenu",
            "mouseover",
            "mouseout",
            "click",
            mouseDownEvent
        ];
        eventNames.forEach((eventName)=>{
            const listener = this.processMouseEvent.bind(this, eventName);
            this.addManagedListener(this.element, eventName, listener);
        });
    }
    processMouseEvent(eventName, mouseEvent) {
        if (!this.mouseEventService.isEventFromThisGrid(mouseEvent) || isStopPropagationForAgGrid(mouseEvent)) return;
        const rowComp = this.getRowForEvent(mouseEvent);
        const cellCtrl = this.mouseEventService.getRenderedCellForEvent(mouseEvent);
        if (eventName === "contextmenu") this.handleContextMenuMouseEvent(mouseEvent, void 0, rowComp, cellCtrl);
        else {
            if (cellCtrl) cellCtrl.onMouseEvent(eventName, mouseEvent);
            if (rowComp) rowComp.onMouseEvent(eventName, mouseEvent);
        }
    }
    mockContextMenuForIPad() {
        if (!isIOSUserAgent()) return;
        const touchListener = new TouchListener(this.element);
        const longTapListener = (event)=>{
            const rowComp = this.getRowForEvent(event.touchEvent);
            const cellComp = this.mouseEventService.getRenderedCellForEvent(event.touchEvent);
            this.handleContextMenuMouseEvent(void 0, event.touchEvent, rowComp, cellComp);
        };
        this.addManagedListener(touchListener, TouchListener.EVENT_LONG_TAP, longTapListener);
        this.addDestroyFunc(()=>touchListener.destroy());
    }
    getRowForEvent(event) {
        let sourceElement = event.target;
        while(sourceElement){
            const rowCon = this.gos.getDomData(sourceElement, RowCtrl.DOM_DATA_KEY_ROW_CTRL);
            if (rowCon) return rowCon;
            sourceElement = sourceElement.parentElement;
        }
        return null;
    }
    handleContextMenuMouseEvent(mouseEvent, touchEvent, rowComp, cellCtrl) {
        const rowNode = rowComp ? rowComp.getRowNode() : null;
        const column = cellCtrl ? cellCtrl.getColumn() : null;
        let value = null;
        if (column) {
            const event = mouseEvent ? mouseEvent : touchEvent;
            cellCtrl.dispatchCellContextMenuEvent(event != null ? event : null);
            value = this.valueService.getValue(column, rowNode);
        }
        const gridBodyCon = this.ctrlsService.getGridBodyCtrl();
        const anchorToElement = cellCtrl ? cellCtrl.getGui() : gridBodyCon.getGridBodyElement();
        this.menuService.showContextMenu({
            mouseEvent,
            touchEvent,
            rowNode,
            column,
            value,
            anchorToElement
        });
    }
    getControlsForEventTarget(target) {
        return {
            cellCtrl: getCtrlForEventTarget(this.gos, target, CellCtrl.DOM_DATA_KEY_CELL_CTRL),
            rowCtrl: getCtrlForEventTarget(this.gos, target, RowCtrl.DOM_DATA_KEY_ROW_CTRL)
        };
    }
    processKeyboardEvent(eventName, keyboardEvent) {
        const { cellCtrl, rowCtrl } = this.getControlsForEventTarget(keyboardEvent.target);
        if (keyboardEvent.defaultPrevented) return;
        if (cellCtrl) this.processCellKeyboardEvent(cellCtrl, eventName, keyboardEvent);
        else if (rowCtrl && rowCtrl.isFullWidth()) this.processFullWidthRowKeyboardEvent(rowCtrl, eventName, keyboardEvent);
    }
    processCellKeyboardEvent(cellCtrl, eventName, keyboardEvent) {
        const rowNode = cellCtrl.getRowNode();
        const column = cellCtrl.getColumn();
        const editing = cellCtrl.isEditing();
        const gridProcessingAllowed = !isUserSuppressingKeyboardEvent(this.gos, keyboardEvent, rowNode, column, editing);
        if (gridProcessingAllowed) {
            if (eventName === "keydown") {
                const wasScrollKey = !editing && this.navigationService.handlePageScrollingKey(keyboardEvent);
                if (!wasScrollKey) cellCtrl.onKeyDown(keyboardEvent);
                this.doGridOperations(keyboardEvent, cellCtrl.isEditing());
                if (isEventFromPrintableCharacter(keyboardEvent)) cellCtrl.processCharacter(keyboardEvent);
            }
        }
        if (eventName === "keydown") {
            const cellKeyDownEvent = cellCtrl.createEvent(keyboardEvent, Events.EVENT_CELL_KEY_DOWN);
            this.eventService.dispatchEvent(cellKeyDownEvent);
        }
    }
    processFullWidthRowKeyboardEvent(rowComp, eventName, keyboardEvent) {
        const rowNode = rowComp.getRowNode();
        const focusedCell = this.focusService.getFocusedCell();
        const column = focusedCell && focusedCell.column;
        const gridProcessingAllowed = !isUserSuppressingKeyboardEvent(this.gos, keyboardEvent, rowNode, column, false);
        if (gridProcessingAllowed) {
            const key = keyboardEvent.key;
            if (eventName === "keydown") switch(key){
                case KeyCode.PAGE_HOME:
                case KeyCode.PAGE_END:
                case KeyCode.PAGE_UP:
                case KeyCode.PAGE_DOWN:
                    this.navigationService.handlePageScrollingKey(keyboardEvent, true);
                    break;
                case KeyCode.UP:
                case KeyCode.DOWN:
                    rowComp.onKeyboardNavigate(keyboardEvent);
                    break;
                case KeyCode.TAB:
                    rowComp.onTabKeyDown(keyboardEvent);
                    break;
                default:
            }
        }
        if (eventName === "keydown") {
            const cellKeyDownEvent = rowComp.createRowEvent(Events.EVENT_CELL_KEY_DOWN, keyboardEvent);
            this.eventService.dispatchEvent(cellKeyDownEvent);
        }
    }
    doGridOperations(keyboardEvent, editing) {
        if (!keyboardEvent.ctrlKey && !keyboardEvent.metaKey) return;
        if (editing) return;
        if (!this.mouseEventService.isEventFromThisGrid(keyboardEvent)) return;
        const keyCode = normaliseQwertyAzerty(keyboardEvent);
        if (keyCode === KeyCode.A) return this.onCtrlAndA(keyboardEvent);
        if (keyCode === KeyCode.C) return this.onCtrlAndC(keyboardEvent);
        if (keyCode === KeyCode.D) return this.onCtrlAndD(keyboardEvent);
        if (keyCode === KeyCode.V) return this.onCtrlAndV(keyboardEvent);
        if (keyCode === KeyCode.X) return this.onCtrlAndX(keyboardEvent);
        if (keyCode === KeyCode.Y) return this.onCtrlAndY();
        if (keyCode === KeyCode.Z) return this.onCtrlAndZ(keyboardEvent);
    }
    onCtrlAndA(event) {
        const { pinnedRowModel, paginationProxy, rangeService } = this;
        if (rangeService && paginationProxy.isRowsToRender()) {
            const [isEmptyPinnedTop, isEmptyPinnedBottom] = [
                pinnedRowModel.isEmpty("top"),
                pinnedRowModel.isEmpty("bottom")
            ];
            const floatingStart = isEmptyPinnedTop ? null : "top";
            let floatingEnd;
            let rowEnd;
            if (isEmptyPinnedBottom) {
                floatingEnd = null;
                rowEnd = this.paginationProxy.getRowCount() - 1;
            } else {
                floatingEnd = "bottom";
                rowEnd = pinnedRowModel.getPinnedBottomRowData().length - 1;
            }
            const allDisplayedColumns = this.columnModel.getAllDisplayedColumns();
            if (missingOrEmpty(allDisplayedColumns)) return;
            rangeService.setCellRange({
                rowStartIndex: 0,
                rowStartPinned: floatingStart,
                rowEndIndex: rowEnd,
                rowEndPinned: floatingEnd,
                columnStart: allDisplayedColumns[0],
                columnEnd: last(allDisplayedColumns)
            });
        }
        event.preventDefault();
    }
    onCtrlAndC(event) {
        if (!this.clipboardService || this.gos.get("enableCellTextSelection")) return;
        const { cellCtrl, rowCtrl } = this.getControlsForEventTarget(event.target);
        if ((cellCtrl == null ? void 0 : cellCtrl.isEditing()) || (rowCtrl == null ? void 0 : rowCtrl.isEditing())) return;
        event.preventDefault();
        this.clipboardService.copyToClipboard();
    }
    onCtrlAndX(event) {
        if (!this.clipboardService || this.gos.get("enableCellTextSelection") || this.gos.get("suppressCutToClipboard")) return;
        const { cellCtrl, rowCtrl } = this.getControlsForEventTarget(event.target);
        if ((cellCtrl == null ? void 0 : cellCtrl.isEditing()) || (rowCtrl == null ? void 0 : rowCtrl.isEditing())) return;
        event.preventDefault();
        this.clipboardService.cutToClipboard(void 0, "ui");
    }
    onCtrlAndV(event) {
        const { cellCtrl, rowCtrl } = this.getControlsForEventTarget(event.target);
        if ((cellCtrl == null ? void 0 : cellCtrl.isEditing()) || (rowCtrl == null ? void 0 : rowCtrl.isEditing())) return;
        if (this.clipboardService && !this.gos.get("suppressClipboardPaste")) this.clipboardService.pasteFromClipboard();
    }
    onCtrlAndD(event) {
        if (this.clipboardService && !this.gos.get("suppressClipboardPaste")) this.clipboardService.copyRangeDown();
        event.preventDefault();
    }
    onCtrlAndZ(event) {
        if (!this.gos.get("undoRedoCellEditing")) return;
        event.preventDefault();
        if (event.shiftKey) this.undoRedoService.redo("ui");
        else this.undoRedoService.undo("ui");
    }
    onCtrlAndY() {
        this.undoRedoService.redo("ui");
    }
};
__decorateClass([
    Autowired("mouseEventService")
], RowContainerEventsFeature.prototype, "mouseEventService", 2);
__decorateClass([
    Autowired("valueService")
], RowContainerEventsFeature.prototype, "valueService", 2);
__decorateClass([
    Autowired("menuService")
], RowContainerEventsFeature.prototype, "menuService", 2);
__decorateClass([
    Autowired("ctrlsService")
], RowContainerEventsFeature.prototype, "ctrlsService", 2);
__decorateClass([
    Autowired("navigationService")
], RowContainerEventsFeature.prototype, "navigationService", 2);
__decorateClass([
    Autowired("focusService")
], RowContainerEventsFeature.prototype, "focusService", 2);
__decorateClass([
    Autowired("undoRedoService")
], RowContainerEventsFeature.prototype, "undoRedoService", 2);
__decorateClass([
    Autowired("columnModel")
], RowContainerEventsFeature.prototype, "columnModel", 2);
__decorateClass([
    Autowired("paginationProxy")
], RowContainerEventsFeature.prototype, "paginationProxy", 2);
__decorateClass([
    Autowired("pinnedRowModel")
], RowContainerEventsFeature.prototype, "pinnedRowModel", 2);
__decorateClass([
    Optional("rangeService")
], RowContainerEventsFeature.prototype, "rangeService", 2);
__decorateClass([
    Optional("clipboardService")
], RowContainerEventsFeature.prototype, "clipboardService", 2);
__decorateClass([
    PostConstruct
], RowContainerEventsFeature.prototype, "postConstruct", 1);
// community-modules/core/src/gridBodyComp/viewportSizeFeature.ts
var ViewportSizeFeature = class extends BeanStub {
    constructor(centerContainerCtrl){
        super();
        this.centerContainerCtrl = centerContainerCtrl;
    }
    postConstruct() {
        this.ctrlsService.whenReady((p)=>{
            this.gridBodyCtrl = p.gridBodyCtrl;
            this.listenForResize();
        });
        this.addManagedListener(this.eventService, Events.EVENT_SCROLLBAR_WIDTH_CHANGED, this.onScrollbarWidthChanged.bind(this));
        this.addManagedPropertyListeners([
            "alwaysShowHorizontalScroll",
            "alwaysShowVerticalScroll"
        ], ()=>{
            this.checkViewportAndScrolls();
        });
    }
    listenForResize() {
        const listener = ()=>this.onCenterViewportResized();
        this.centerContainerCtrl.registerViewportResizeListener(listener);
        this.gridBodyCtrl.registerBodyViewportResizeListener(listener);
    }
    onScrollbarWidthChanged() {
        this.checkViewportAndScrolls();
    }
    onCenterViewportResized() {
        if (this.centerContainerCtrl.isViewportInTheDOMTree()) {
            this.keepPinnedColumnsNarrowerThanViewport();
            this.checkViewportAndScrolls();
            const newWidth = this.centerContainerCtrl.getCenterWidth();
            if (newWidth !== this.centerWidth) {
                this.centerWidth = newWidth;
                this.columnModel.refreshFlexedColumns({
                    viewportWidth: this.centerWidth,
                    updateBodyWidths: true,
                    fireResizedEvent: true
                });
            }
        } else this.bodyHeight = 0;
    }
    keepPinnedColumnsNarrowerThanViewport() {
        const eBodyViewport = this.gridBodyCtrl.getBodyViewportElement();
        const bodyWidth = getInnerWidth(eBodyViewport);
        if (bodyWidth <= 50) return;
        let columnsToRemove = this.getPinnedColumnsOverflowingViewport(bodyWidth - 50);
        const processUnpinnedColumns = this.gos.getCallback("processUnpinnedColumns");
        if (!columnsToRemove.length) return;
        if (processUnpinnedColumns) {
            const params = {
                columns: columnsToRemove,
                viewportWidth: bodyWidth
            };
            columnsToRemove = processUnpinnedColumns(params);
        }
        this.columnModel.setColumnsPinned(columnsToRemove, null, "viewportSizeFeature");
    }
    getPinnedColumnsOverflowingViewport(viewportWidth) {
        const pinnedRightWidth = this.pinnedWidthService.getPinnedRightWidth();
        const pinnedLeftWidth = this.pinnedWidthService.getPinnedLeftWidth();
        const totalPinnedWidth = pinnedRightWidth + pinnedLeftWidth;
        if (totalPinnedWidth < viewportWidth) return [];
        const pinnedLeftColumns = [
            ...this.columnModel.getDisplayedLeftColumns()
        ];
        const pinnedRightColumns = [
            ...this.columnModel.getDisplayedRightColumns()
        ];
        let indexRight = 0;
        let indexLeft = 0;
        let totalWidthRemoved = 0;
        const columnsToRemove = [];
        let spaceNecessary = totalPinnedWidth - totalWidthRemoved - viewportWidth;
        while((indexLeft < pinnedLeftColumns.length || indexRight < pinnedRightColumns.length) && spaceNecessary > 0){
            if (indexRight < pinnedRightColumns.length) {
                const currentColumn = pinnedRightColumns[indexRight++];
                spaceNecessary -= currentColumn.getActualWidth();
                columnsToRemove.push(currentColumn);
            }
            if (indexLeft < pinnedLeftColumns.length && spaceNecessary > 0) {
                const currentColumn = pinnedLeftColumns[indexLeft++];
                spaceNecessary -= currentColumn.getActualWidth();
                columnsToRemove.push(currentColumn);
            }
        }
        return columnsToRemove;
    }
    // gets called every time the viewport size changes. we use this to check visibility of scrollbars
    // in the grid panel, and also to check size and position of viewport for row and column virtualisation.
    checkViewportAndScrolls() {
        this.updateScrollVisibleService();
        this.checkBodyHeight();
        this.onHorizontalViewportChanged();
        this.gridBodyCtrl.getScrollFeature().checkScrollLeft();
    }
    getBodyHeight() {
        return this.bodyHeight;
    }
    checkBodyHeight() {
        const eBodyViewport = this.gridBodyCtrl.getBodyViewportElement();
        const bodyHeight = getInnerHeight(eBodyViewport);
        if (this.bodyHeight !== bodyHeight) {
            this.bodyHeight = bodyHeight;
            const event = {
                type: Events.EVENT_BODY_HEIGHT_CHANGED
            };
            this.eventService.dispatchEvent(event);
        }
    }
    updateScrollVisibleService() {
        this.updateScrollVisibleServiceImpl();
        setTimeout(this.updateScrollVisibleServiceImpl.bind(this), 500);
    }
    updateScrollVisibleServiceImpl() {
        const params = {
            horizontalScrollShowing: this.isHorizontalScrollShowing(),
            verticalScrollShowing: this.gridBodyCtrl.isVerticalScrollShowing()
        };
        this.scrollVisibleService.setScrollsVisible(params);
    }
    isHorizontalScrollShowing() {
        return this.centerContainerCtrl.isHorizontalScrollShowing();
    }
    // this gets called whenever a change in the viewport, so we can inform column controller it has to work
    // out the virtual columns again. gets called from following locations:
    // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged
    onHorizontalViewportChanged() {
        const scrollWidth = this.centerContainerCtrl.getCenterWidth();
        const scrollPosition = this.centerContainerCtrl.getViewportScrollLeft();
        this.columnModel.setViewportPosition(scrollWidth, scrollPosition);
    }
};
__decorateClass([
    Autowired("ctrlsService")
], ViewportSizeFeature.prototype, "ctrlsService", 2);
__decorateClass([
    Autowired("pinnedWidthService")
], ViewportSizeFeature.prototype, "pinnedWidthService", 2);
__decorateClass([
    Autowired("columnModel")
], ViewportSizeFeature.prototype, "columnModel", 2);
__decorateClass([
    Autowired("scrollVisibleService")
], ViewportSizeFeature.prototype, "scrollVisibleService", 2);
__decorateClass([
    PostConstruct
], ViewportSizeFeature.prototype, "postConstruct", 1);
// community-modules/core/src/gridBodyComp/rowContainer/setPinnedLeftWidthFeature.ts
var SetPinnedLeftWidthFeature = class extends BeanStub {
    constructor(element){
        super();
        this.element = element;
    }
    postConstruct() {
        this.addManagedListener(this.eventService, Events.EVENT_LEFT_PINNED_WIDTH_CHANGED, this.onPinnedLeftWidthChanged.bind(this));
    }
    onPinnedLeftWidthChanged() {
        const leftWidth = this.pinnedWidthService.getPinnedLeftWidth();
        const displayed = leftWidth > 0;
        setDisplayed(this.element, displayed);
        setFixedWidth(this.element, leftWidth);
    }
    getWidth() {
        return this.pinnedWidthService.getPinnedLeftWidth();
    }
};
__decorateClass([
    Autowired("pinnedWidthService")
], SetPinnedLeftWidthFeature.prototype, "pinnedWidthService", 2);
__decorateClass([
    PostConstruct
], SetPinnedLeftWidthFeature.prototype, "postConstruct", 1);
// community-modules/core/src/gridBodyComp/rowContainer/setPinnedRightWidthFeature.ts
var SetPinnedRightWidthFeature = class extends BeanStub {
    constructor(element){
        super();
        this.element = element;
    }
    postConstruct() {
        this.addManagedListener(this.eventService, Events.EVENT_RIGHT_PINNED_WIDTH_CHANGED, this.onPinnedRightWidthChanged.bind(this));
    }
    onPinnedRightWidthChanged() {
        const rightWidth = this.pinnedWidthService.getPinnedRightWidth();
        const displayed = rightWidth > 0;
        setDisplayed(this.element, displayed);
        setFixedWidth(this.element, rightWidth);
    }
    getWidth() {
        return this.pinnedWidthService.getPinnedRightWidth();
    }
};
__decorateClass([
    Autowired("pinnedWidthService")
], SetPinnedRightWidthFeature.prototype, "pinnedWidthService", 2);
__decorateClass([
    PostConstruct
], SetPinnedRightWidthFeature.prototype, "postConstruct", 1);
// community-modules/core/src/gridBodyComp/rowContainer/setHeightFeature.ts
var SetHeightFeature = class extends BeanStub {
    constructor(eContainer, eViewport){
        super();
        this.eContainer = eContainer;
        this.eViewport = eViewport;
    }
    postConstruct() {
        this.addManagedListener(this.eventService, Events.EVENT_ROW_CONTAINER_HEIGHT_CHANGED, this.onHeightChanged.bind(this));
    }
    onHeightChanged() {
        const height = this.maxDivHeightScaler.getUiContainerHeight();
        const heightString = height != null ? `${height}px` : ``;
        this.eContainer.style.height = heightString;
        if (this.eViewport) this.eViewport.style.height = heightString;
    }
};
__decorateClass([
    Autowired("rowContainerHeightService")
], SetHeightFeature.prototype, "maxDivHeightScaler", 2);
__decorateClass([
    PostConstruct
], SetHeightFeature.prototype, "postConstruct", 1);
// community-modules/core/src/gridBodyComp/rowContainer/dragListenerFeature.ts
var DragListenerFeature = class extends BeanStub {
    constructor(eContainer){
        super();
        this.eContainer = eContainer;
    }
    postConstruct() {
        if (!this.rangeService) return;
        this.params = {
            eElement: this.eContainer,
            onDragStart: this.rangeService.onDragStart.bind(this.rangeService),
            onDragStop: this.rangeService.onDragStop.bind(this.rangeService),
            onDragging: this.rangeService.onDragging.bind(this.rangeService)
        };
        this.addManagedPropertyListener("enableRangeSelection", (props)=>{
            const isEnabled = props.currentValue;
            if (isEnabled) {
                this.enableFeature();
                return;
            }
            this.disableFeature();
        });
        this.addDestroyFunc(()=>this.disableFeature());
        const isRangeSelection = this.gos.get("enableRangeSelection");
        if (isRangeSelection) this.enableFeature();
    }
    enableFeature() {
        this.dragService.addDragSource(this.params);
    }
    disableFeature() {
        this.dragService.removeDragSource(this.params);
    }
};
__decorateClass([
    Autowired("dragService")
], DragListenerFeature.prototype, "dragService", 2);
__decorateClass([
    Optional("rangeService")
], DragListenerFeature.prototype, "rangeService", 2);
__decorateClass([
    PostConstruct
], DragListenerFeature.prototype, "postConstruct", 1);
// community-modules/core/src/gridBodyComp/centerWidthFeature.ts
var CenterWidthFeature = class extends BeanStub {
    constructor(callback, addSpacer = false){
        super();
        this.callback = callback;
        this.addSpacer = addSpacer;
    }
    postConstruct() {
        const listener = this.setWidth.bind(this);
        this.addManagedPropertyListener("domLayout", listener);
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_CONTAINER_WIDTH_CHANGED, listener);
        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, listener);
        this.addManagedListener(this.eventService, Events.EVENT_LEFT_PINNED_WIDTH_CHANGED, listener);
        if (this.addSpacer) {
            this.addManagedListener(this.eventService, Events.EVENT_RIGHT_PINNED_WIDTH_CHANGED, listener);
            this.addManagedListener(this.eventService, Events.EVENT_SCROLL_VISIBILITY_CHANGED, listener);
            this.addManagedListener(this.eventService, Events.EVENT_SCROLLBAR_WIDTH_CHANGED, listener);
        }
        this.setWidth();
    }
    setWidth() {
        const { columnModel } = this;
        const printLayout = this.gos.isDomLayout("print");
        const centerWidth = columnModel.getBodyContainerWidth();
        const leftWidth = columnModel.getDisplayedColumnsLeftWidth();
        const rightWidth = columnModel.getDisplayedColumnsRightWidth();
        let totalWidth;
        if (printLayout) totalWidth = centerWidth + leftWidth + rightWidth;
        else {
            totalWidth = centerWidth;
            if (this.addSpacer) {
                const relevantWidth = this.gos.get("enableRtl") ? leftWidth : rightWidth;
                if (relevantWidth === 0 && this.scrollVisibleService.isVerticalScrollShowing()) totalWidth += this.gos.getScrollbarWidth();
            }
        }
        this.callback(totalWidth);
    }
};
__decorateClass([
    Autowired("columnModel")
], CenterWidthFeature.prototype, "columnModel", 2);
__decorateClass([
    Autowired("scrollVisibleService")
], CenterWidthFeature.prototype, "scrollVisibleService", 2);
__decorateClass([
    PostConstruct
], CenterWidthFeature.prototype, "postConstruct", 1);
// community-modules/core/src/gridBodyComp/rowContainer/rowContainerCtrl.ts
var RowContainerName = /* @__PURE__ */ ((RowContainerName2)=>{
    RowContainerName2["LEFT"] = "left";
    RowContainerName2["RIGHT"] = "right";
    RowContainerName2["CENTER"] = "center";
    RowContainerName2["FULL_WIDTH"] = "fullWidth";
    RowContainerName2["TOP_LEFT"] = "topLeft";
    RowContainerName2["TOP_RIGHT"] = "topRight";
    RowContainerName2["TOP_CENTER"] = "topCenter";
    RowContainerName2["TOP_FULL_WIDTH"] = "topFullWidth";
    RowContainerName2["STICKY_TOP_LEFT"] = "stickyTopLeft";
    RowContainerName2["STICKY_TOP_RIGHT"] = "stickyTopRight";
    RowContainerName2["STICKY_TOP_CENTER"] = "stickyTopCenter";
    RowContainerName2["STICKY_TOP_FULL_WIDTH"] = "stickyTopFullWidth";
    RowContainerName2["STICKY_BOTTOM_LEFT"] = "stickyBottomLeft";
    RowContainerName2["STICKY_BOTTOM_RIGHT"] = "stickyBottomRight";
    RowContainerName2["STICKY_BOTTOM_CENTER"] = "stickyBottomCenter";
    RowContainerName2["STICKY_BOTTOM_FULL_WIDTH"] = "stickyBottomFullWidth";
    RowContainerName2["BOTTOM_LEFT"] = "bottomLeft";
    RowContainerName2["BOTTOM_RIGHT"] = "bottomRight";
    RowContainerName2["BOTTOM_CENTER"] = "bottomCenter";
    RowContainerName2["BOTTOM_FULL_WIDTH"] = "bottomFullWidth";
    return RowContainerName2;
})(RowContainerName || {});
var RowContainerType = /* @__PURE__ */ ((RowContainerType3)=>{
    RowContainerType3["LEFT"] = "left";
    RowContainerType3["RIGHT"] = "right";
    RowContainerType3["CENTER"] = "center";
    RowContainerType3["FULL_WIDTH"] = "fullWidth";
    return RowContainerType3;
})(RowContainerType || {});
function getRowContainerTypeForName(name) {
    switch(name){
        case "center" /* CENTER */ :
        case "topCenter" /* TOP_CENTER */ :
        case "stickyTopCenter" /* STICKY_TOP_CENTER */ :
        case "bottomCenter" /* BOTTOM_CENTER */ :
        case "stickyBottomCenter" /* STICKY_BOTTOM_CENTER */ :
            return "center" /* CENTER */ ;
        case "left" /* LEFT */ :
        case "topLeft" /* TOP_LEFT */ :
        case "stickyTopLeft" /* STICKY_TOP_LEFT */ :
        case "bottomLeft" /* BOTTOM_LEFT */ :
        case "stickyBottomLeft" /* STICKY_BOTTOM_LEFT */ :
            return "left" /* LEFT */ ;
        case "right" /* RIGHT */ :
        case "topRight" /* TOP_RIGHT */ :
        case "stickyTopRight" /* STICKY_TOP_RIGHT */ :
        case "bottomRight" /* BOTTOM_RIGHT */ :
        case "stickyBottomRight" /* STICKY_BOTTOM_RIGHT */ :
            return "right" /* RIGHT */ ;
        case "fullWidth" /* FULL_WIDTH */ :
        case "topFullWidth" /* TOP_FULL_WIDTH */ :
        case "stickyTopFullWidth" /* STICKY_TOP_FULL_WIDTH */ :
        case "bottomFullWidth" /* BOTTOM_FULL_WIDTH */ :
        case "stickyBottomFullWidth" /* STICKY_BOTTOM_FULL_WIDTH */ :
            return "fullWidth" /* FULL_WIDTH */ ;
        default:
            throw Error("Invalid Row Container Type");
    }
}
var ContainerCssClasses = convertToMap([
    [
        "center" /* CENTER */ ,
        "ag-center-cols-container"
    ],
    [
        "left" /* LEFT */ ,
        "ag-pinned-left-cols-container"
    ],
    [
        "right" /* RIGHT */ ,
        "ag-pinned-right-cols-container"
    ],
    [
        "fullWidth" /* FULL_WIDTH */ ,
        "ag-full-width-container"
    ],
    [
        "topCenter" /* TOP_CENTER */ ,
        "ag-floating-top-container"
    ],
    [
        "topLeft" /* TOP_LEFT */ ,
        "ag-pinned-left-floating-top"
    ],
    [
        "topRight" /* TOP_RIGHT */ ,
        "ag-pinned-right-floating-top"
    ],
    [
        "topFullWidth" /* TOP_FULL_WIDTH */ ,
        "ag-floating-top-full-width-container"
    ],
    [
        "stickyTopCenter" /* STICKY_TOP_CENTER */ ,
        "ag-sticky-top-container"
    ],
    [
        "stickyTopLeft" /* STICKY_TOP_LEFT */ ,
        "ag-pinned-left-sticky-top"
    ],
    [
        "stickyTopRight" /* STICKY_TOP_RIGHT */ ,
        "ag-pinned-right-sticky-top"
    ],
    [
        "stickyTopFullWidth" /* STICKY_TOP_FULL_WIDTH */ ,
        "ag-sticky-top-full-width-container"
    ],
    [
        "stickyBottomCenter" /* STICKY_BOTTOM_CENTER */ ,
        "ag-sticky-bottom-container"
    ],
    [
        "stickyBottomLeft" /* STICKY_BOTTOM_LEFT */ ,
        "ag-pinned-left-sticky-bottom"
    ],
    [
        "stickyBottomRight" /* STICKY_BOTTOM_RIGHT */ ,
        "ag-pinned-right-sticky-bottom"
    ],
    [
        "stickyBottomFullWidth" /* STICKY_BOTTOM_FULL_WIDTH */ ,
        "ag-sticky-bottom-full-width-container"
    ],
    [
        "bottomCenter" /* BOTTOM_CENTER */ ,
        "ag-floating-bottom-container"
    ],
    [
        "bottomLeft" /* BOTTOM_LEFT */ ,
        "ag-pinned-left-floating-bottom"
    ],
    [
        "bottomRight" /* BOTTOM_RIGHT */ ,
        "ag-pinned-right-floating-bottom"
    ],
    [
        "bottomFullWidth" /* BOTTOM_FULL_WIDTH */ ,
        "ag-floating-bottom-full-width-container"
    ]
]);
var ViewportCssClasses = convertToMap([
    [
        "center" /* CENTER */ ,
        "ag-center-cols-viewport"
    ],
    [
        "topCenter" /* TOP_CENTER */ ,
        "ag-floating-top-viewport"
    ],
    [
        "stickyTopCenter" /* STICKY_TOP_CENTER */ ,
        "ag-sticky-top-viewport"
    ],
    [
        "bottomCenter" /* BOTTOM_CENTER */ ,
        "ag-floating-bottom-viewport"
    ],
    [
        "stickyBottomCenter" /* STICKY_BOTTOM_CENTER */ ,
        "ag-sticky-bottom-viewport"
    ]
]);
var _RowContainerCtrl = class _RowContainerCtrl extends BeanStub {
    constructor(name){
        super();
        this.visible = true;
        // Maintaining a constant reference enables optimization in React.
        this.EMPTY_CTRLS = [];
        this.name = name;
        this.isFullWithContainer = this.name === "topFullWidth" /* TOP_FULL_WIDTH */  || this.name === "stickyTopFullWidth" /* STICKY_TOP_FULL_WIDTH */  || this.name === "stickyBottomFullWidth" /* STICKY_BOTTOM_FULL_WIDTH */  || this.name === "bottomFullWidth" /* BOTTOM_FULL_WIDTH */  || this.name === "fullWidth" /* FULL_WIDTH */ ;
    }
    static getRowContainerCssClasses(name) {
        const containerClass = ContainerCssClasses.get(name);
        const viewportClass = ViewportCssClasses.get(name);
        return {
            container: containerClass,
            viewport: viewportClass
        };
    }
    static getPinned(name) {
        switch(name){
            case "bottomLeft" /* BOTTOM_LEFT */ :
            case "topLeft" /* TOP_LEFT */ :
            case "stickyTopLeft" /* STICKY_TOP_LEFT */ :
            case "stickyBottomLeft" /* STICKY_BOTTOM_LEFT */ :
            case "left" /* LEFT */ :
                return "left";
            case "bottomRight" /* BOTTOM_RIGHT */ :
            case "topRight" /* TOP_RIGHT */ :
            case "stickyTopRight" /* STICKY_TOP_RIGHT */ :
            case "stickyBottomRight" /* STICKY_BOTTOM_RIGHT */ :
            case "right" /* RIGHT */ :
                return "right";
            default:
                return null;
        }
    }
    postConstruct() {
        this.enableRtl = this.gos.get("enableRtl");
        this.forContainers([
            "center" /* CENTER */ 
        ], ()=>this.viewportSizeFeature = this.createManagedBean(new ViewportSizeFeature(this)));
    }
    registerWithCtrlsService() {
        switch(this.name){
            case "fullWidth" /* FULL_WIDTH */ :
            case "topFullWidth" /* TOP_FULL_WIDTH */ :
            case "stickyTopFullWidth" /* STICKY_TOP_FULL_WIDTH */ :
            case "bottomFullWidth" /* BOTTOM_FULL_WIDTH */ :
            case "stickyBottomFullWidth" /* STICKY_BOTTOM_FULL_WIDTH */ :
                return;
            default:
                this.ctrlsService.register(this.name, this);
        }
    }
    forContainers(names, callback) {
        if (names.indexOf(this.name) >= 0) callback();
    }
    getContainerElement() {
        return this.eContainer;
    }
    getViewportSizeFeature() {
        return this.viewportSizeFeature;
    }
    setComp(view, eContainer, eViewport) {
        this.comp = view;
        this.eContainer = eContainer;
        this.eViewport = eViewport;
        this.createManagedBean(new RowContainerEventsFeature(this.eContainer));
        this.addPreventScrollWhileDragging();
        this.listenOnDomOrder();
        this.stopHScrollOnPinnedRows();
        const allTopNoFW = [
            "topCenter" /* TOP_CENTER */ ,
            "topLeft" /* TOP_LEFT */ ,
            "topRight" /* TOP_RIGHT */ 
        ];
        const allStickyTopNoFW = [
            "stickyTopCenter" /* STICKY_TOP_CENTER */ ,
            "stickyTopLeft" /* STICKY_TOP_LEFT */ ,
            "stickyTopRight" /* STICKY_TOP_RIGHT */ 
        ];
        const allStickyBottomNoFW = [
            "stickyBottomCenter" /* STICKY_BOTTOM_CENTER */ ,
            "stickyBottomLeft" /* STICKY_BOTTOM_LEFT */ ,
            "stickyBottomRight" /* STICKY_BOTTOM_RIGHT */ 
        ];
        const allBottomNoFW = [
            "bottomCenter" /* BOTTOM_CENTER */ ,
            "bottomLeft" /* BOTTOM_LEFT */ ,
            "bottomRight" /* BOTTOM_RIGHT */ 
        ];
        const allMiddleNoFW = [
            "center" /* CENTER */ ,
            "left" /* LEFT */ ,
            "right" /* RIGHT */ 
        ];
        const allNoFW = [
            ...allTopNoFW,
            ...allBottomNoFW,
            ...allMiddleNoFW,
            ...allStickyTopNoFW,
            ...allStickyBottomNoFW
        ];
        const allMiddle = [
            "center" /* CENTER */ ,
            "left" /* LEFT */ ,
            "right" /* RIGHT */ ,
            "fullWidth" /* FULL_WIDTH */ 
        ];
        const allCenter = [
            "center" /* CENTER */ ,
            "topCenter" /* TOP_CENTER */ ,
            "stickyTopCenter" /* STICKY_TOP_CENTER */ ,
            "bottomCenter" /* BOTTOM_CENTER */ ,
            "stickyBottomCenter" /* STICKY_BOTTOM_CENTER */ 
        ];
        const allLeft = [
            "left" /* LEFT */ ,
            "bottomLeft" /* BOTTOM_LEFT */ ,
            "topLeft" /* TOP_LEFT */ ,
            "stickyTopLeft" /* STICKY_TOP_LEFT */ ,
            "stickyBottomLeft" /* STICKY_BOTTOM_LEFT */ 
        ];
        const allRight = [
            "right" /* RIGHT */ ,
            "bottomRight" /* BOTTOM_RIGHT */ ,
            "topRight" /* TOP_RIGHT */ ,
            "stickyTopRight" /* STICKY_TOP_RIGHT */ ,
            "stickyBottomRight" /* STICKY_BOTTOM_RIGHT */ 
        ];
        this.forContainers(allLeft, ()=>{
            this.pinnedWidthFeature = this.createManagedBean(new SetPinnedLeftWidthFeature(this.eContainer));
            this.addManagedListener(this.eventService, Events.EVENT_LEFT_PINNED_WIDTH_CHANGED, ()=>this.onPinnedWidthChanged());
        });
        this.forContainers(allRight, ()=>{
            this.pinnedWidthFeature = this.createManagedBean(new SetPinnedRightWidthFeature(this.eContainer));
            this.addManagedListener(this.eventService, Events.EVENT_RIGHT_PINNED_WIDTH_CHANGED, ()=>this.onPinnedWidthChanged());
        });
        this.forContainers(allMiddle, ()=>this.createManagedBean(new SetHeightFeature(this.eContainer, this.name === "center" /* CENTER */  ? eViewport : void 0)));
        this.forContainers(allNoFW, ()=>this.createManagedBean(new DragListenerFeature(this.eContainer)));
        this.forContainers(allCenter, ()=>this.createManagedBean(new CenterWidthFeature((width)=>this.comp.setContainerWidth(`${width}px`))));
        this.addListeners();
        this.registerWithCtrlsService();
    }
    addListeners() {
        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, ()=>this.onDisplayedColumnsChanged());
        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, ()=>this.onDisplayedColumnsWidthChanged());
        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_ROWS_CHANGED, (params)=>this.onDisplayedRowsChanged(params.afterScroll));
        this.onDisplayedColumnsChanged();
        this.onDisplayedColumnsWidthChanged();
        this.onDisplayedRowsChanged();
    }
    listenOnDomOrder() {
        const allStickyContainers = [
            "stickyTopCenter" /* STICKY_TOP_CENTER */ ,
            "stickyTopLeft" /* STICKY_TOP_LEFT */ ,
            "stickyTopRight" /* STICKY_TOP_RIGHT */ ,
            "stickyTopFullWidth" /* STICKY_TOP_FULL_WIDTH */ ,
            "stickyBottomCenter" /* STICKY_BOTTOM_CENTER */ ,
            "stickyBottomLeft" /* STICKY_BOTTOM_LEFT */ ,
            "stickyBottomRight" /* STICKY_BOTTOM_RIGHT */ ,
            "stickyBottomFullWidth" /* STICKY_BOTTOM_FULL_WIDTH */ 
        ];
        const isStickContainer = allStickyContainers.indexOf(this.name) >= 0;
        if (isStickContainer) {
            this.comp.setDomOrder(true);
            return;
        }
        const listener = ()=>{
            const isEnsureDomOrder = this.gos.get("ensureDomOrder");
            const isPrintLayout = this.gos.isDomLayout("print");
            this.comp.setDomOrder(isEnsureDomOrder || isPrintLayout);
        };
        this.addManagedPropertyListener("domLayout", listener);
        listener();
    }
    // when editing a pinned row, if the cell is half outside the scrollable area, the browser can
    // scroll the column into view. we do not want this, the pinned sections should never scroll.
    // so we listen to scrolls on these containers and reset the scroll if we find one.
    stopHScrollOnPinnedRows() {
        this.forContainers([
            "topCenter" /* TOP_CENTER */ ,
            "stickyTopCenter" /* STICKY_TOP_CENTER */ ,
            "bottomCenter" /* BOTTOM_CENTER */ ,
            "stickyBottomCenter" /* STICKY_BOTTOM_CENTER */ 
        ], ()=>{
            const resetScrollLeft = ()=>this.eViewport.scrollLeft = 0;
            this.addManagedListener(this.eViewport, "scroll", resetScrollLeft);
        });
    }
    onDisplayedColumnsChanged() {
        this.forContainers([
            "center" /* CENTER */ 
        ], ()=>this.onHorizontalViewportChanged());
    }
    onDisplayedColumnsWidthChanged() {
        this.forContainers([
            "center" /* CENTER */ 
        ], ()=>this.onHorizontalViewportChanged());
    }
    // this methods prevents the grid views from being scrolled while the dragService is being used
    // eg. the view should not scroll up and down while dragging rows using the rowDragComp.
    addPreventScrollWhileDragging() {
        const preventScroll = (e)=>{
            if (this.dragService.isDragging()) {
                if (e.cancelable) e.preventDefault();
            }
        };
        this.eContainer.addEventListener("touchmove", preventScroll, {
            passive: false
        });
        this.addDestroyFunc(()=>this.eContainer.removeEventListener("touchmove", preventScroll));
    }
    // this gets called whenever a change in the viewport, so we can inform column controller it has to work
    // out the virtual columns again. gets called from following locations:
    // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged
    onHorizontalViewportChanged(afterScroll = false) {
        const scrollWidth = this.getCenterWidth();
        const scrollPosition = this.getCenterViewportScrollLeft();
        this.columnModel.setViewportPosition(scrollWidth, scrollPosition, afterScroll);
    }
    getCenterWidth() {
        return getInnerWidth(this.eViewport);
    }
    getCenterViewportScrollLeft() {
        return getScrollLeft(this.eViewport, this.enableRtl);
    }
    registerViewportResizeListener(listener) {
        const unsubscribeFromResize = this.resizeObserverService.observeResize(this.eViewport, listener);
        this.addDestroyFunc(()=>unsubscribeFromResize());
    }
    isViewportInTheDOMTree() {
        return isInDOM(this.eViewport);
    }
    getViewportScrollLeft() {
        return getScrollLeft(this.eViewport, this.enableRtl);
    }
    isHorizontalScrollShowing() {
        const isAlwaysShowHorizontalScroll = this.gos.get("alwaysShowHorizontalScroll");
        return isAlwaysShowHorizontalScroll || isHorizontalScrollShowing(this.eViewport);
    }
    getViewportElement() {
        return this.eViewport;
    }
    setContainerTranslateX(amount) {
        this.eContainer.style.transform = `translateX(${amount}px)`;
    }
    getHScrollPosition() {
        const res = {
            left: this.eViewport.scrollLeft,
            right: this.eViewport.scrollLeft + this.eViewport.offsetWidth
        };
        return res;
    }
    setCenterViewportScrollLeft(value) {
        setScrollLeft(this.eViewport, value, this.enableRtl);
    }
    isContainerVisible() {
        const pinned = _RowContainerCtrl.getPinned(this.name);
        return !pinned || !!this.pinnedWidthFeature && this.pinnedWidthFeature.getWidth() > 0;
    }
    onPinnedWidthChanged() {
        const visible = this.isContainerVisible();
        if (this.visible != visible) {
            this.visible = visible;
            this.onDisplayedRowsChanged();
        }
    }
    onDisplayedRowsChanged(afterScroll = false) {
        const rows = this.getRowCtrls();
        if (!this.visible || rows.length === 0) {
            this.comp.setRowCtrls({
                rowCtrls: this.EMPTY_CTRLS
            });
            return;
        }
        const printLayout = this.gos.isDomLayout("print");
        const embedFullWidthRows = this.gos.get("embedFullWidthRows");
        const embedFW = embedFullWidthRows || printLayout;
        const rowsThisContainer = rows.filter((rowCtrl)=>{
            const fullWidthRow = rowCtrl.isFullWidth();
            const match = this.isFullWithContainer ? !embedFW && fullWidthRow : embedFW || !fullWidthRow;
            return match;
        });
        this.comp.setRowCtrls({
            rowCtrls: rowsThisContainer,
            useFlushSync: afterScroll
        });
    }
    getRowCtrls() {
        switch(this.name){
            case "topCenter" /* TOP_CENTER */ :
            case "topLeft" /* TOP_LEFT */ :
            case "topRight" /* TOP_RIGHT */ :
            case "topFullWidth" /* TOP_FULL_WIDTH */ :
                return this.rowRenderer.getTopRowCtrls();
            case "stickyTopCenter" /* STICKY_TOP_CENTER */ :
            case "stickyTopLeft" /* STICKY_TOP_LEFT */ :
            case "stickyTopRight" /* STICKY_TOP_RIGHT */ :
            case "stickyTopFullWidth" /* STICKY_TOP_FULL_WIDTH */ :
                return this.rowRenderer.getStickyTopRowCtrls();
            case "stickyBottomCenter" /* STICKY_BOTTOM_CENTER */ :
            case "stickyBottomLeft" /* STICKY_BOTTOM_LEFT */ :
            case "stickyBottomRight" /* STICKY_BOTTOM_RIGHT */ :
            case "stickyBottomFullWidth" /* STICKY_BOTTOM_FULL_WIDTH */ :
                return this.rowRenderer.getStickyBottomRowCtrls();
            case "bottomCenter" /* BOTTOM_CENTER */ :
            case "bottomLeft" /* BOTTOM_LEFT */ :
            case "bottomRight" /* BOTTOM_RIGHT */ :
            case "bottomFullWidth" /* BOTTOM_FULL_WIDTH */ :
                return this.rowRenderer.getBottomRowCtrls();
            default:
                return this.rowRenderer.getCentreRowCtrls();
        }
    }
};
__decorateClass([
    Autowired("dragService")
], _RowContainerCtrl.prototype, "dragService", 2);
__decorateClass([
    Autowired("ctrlsService")
], _RowContainerCtrl.prototype, "ctrlsService", 2);
__decorateClass([
    Autowired("columnModel")
], _RowContainerCtrl.prototype, "columnModel", 2);
__decorateClass([
    Autowired("resizeObserverService")
], _RowContainerCtrl.prototype, "resizeObserverService", 2);
__decorateClass([
    Autowired("rowRenderer")
], _RowContainerCtrl.prototype, "rowRenderer", 2);
__decorateClass([
    PostConstruct
], _RowContainerCtrl.prototype, "postConstruct", 1);
var RowContainerCtrl = _RowContainerCtrl;
// community-modules/core/src/gridBodyComp/gridBodyComp.ts
var GRID_BODY_TEMPLATE = /* html */ `<div class="ag-root ag-unselectable" role="treegrid">
        <ag-header-root ref="gridHeader"></ag-header-root>
        <div class="ag-floating-top" ref="eTop" role="presentation">
            <ag-row-container ref="topLeftContainer" name="${"topLeft" /* TOP_LEFT */ }"></ag-row-container>
            <ag-row-container ref="topCenterContainer" name="${"topCenter" /* TOP_CENTER */ }"></ag-row-container>
            <ag-row-container ref="topRightContainer" name="${"topRight" /* TOP_RIGHT */ }"></ag-row-container>
            <ag-row-container ref="topFullWidthContainer" name="${"topFullWidth" /* TOP_FULL_WIDTH */ }"></ag-row-container>
        </div>
        <div class="ag-body" ref="eBody" role="presentation">
            <div class="ag-body-viewport" ref="eBodyViewport" role="presentation">
                <ag-row-container ref="leftContainer" name="${"left" /* LEFT */ }"></ag-row-container>
                <ag-row-container ref="centerContainer" name="${"center" /* CENTER */ }"></ag-row-container>
                <ag-row-container ref="rightContainer" name="${"right" /* RIGHT */ }"></ag-row-container>
                <ag-row-container ref="fullWidthContainer" name="${"fullWidth" /* FULL_WIDTH */ }"></ag-row-container>
            </div>
            <ag-fake-vertical-scroll></ag-fake-vertical-scroll>
        </div>
        <div class="ag-sticky-top" ref="eStickyTop" role="presentation">
            <ag-row-container ref="stickyTopLeftContainer" name="${"stickyTopLeft" /* STICKY_TOP_LEFT */ }"></ag-row-container>
            <ag-row-container ref="stickyTopCenterContainer" name="${"stickyTopCenter" /* STICKY_TOP_CENTER */ }"></ag-row-container>
            <ag-row-container ref="stickyTopRightContainer" name="${"stickyTopRight" /* STICKY_TOP_RIGHT */ }"></ag-row-container>
            <ag-row-container ref="stickyTopFullWidthContainer" name="${"stickyTopFullWidth" /* STICKY_TOP_FULL_WIDTH */ }"></ag-row-container>
        </div>
        <div class="ag-sticky-bottom" ref="eStickyBottom" role="presentation">
            <ag-row-container ref="stickyBottomLeftContainer" name="${"stickyBottomLeft" /* STICKY_BOTTOM_LEFT */ }"></ag-row-container>
            <ag-row-container ref="stickyBottomCenterContainer" name="${"stickyBottomCenter" /* STICKY_BOTTOM_CENTER */ }"></ag-row-container>
            <ag-row-container ref="stickyBottomRightContainer" name="${"stickyBottomRight" /* STICKY_BOTTOM_RIGHT */ }"></ag-row-container>
            <ag-row-container ref="stickyBottomFullWidthContainer" name="${"stickyBottomFullWidth" /* STICKY_BOTTOM_FULL_WIDTH */ }"></ag-row-container>
        </div>
        <div class="ag-floating-bottom" ref="eBottom" role="presentation">
            <ag-row-container ref="bottomLeftContainer" name="${"bottomLeft" /* BOTTOM_LEFT */ }"></ag-row-container>
            <ag-row-container ref="bottomCenterContainer" name="${"bottomCenter" /* BOTTOM_CENTER */ }"></ag-row-container>
            <ag-row-container ref="bottomRightContainer" name="${"bottomRight" /* BOTTOM_RIGHT */ }"></ag-row-container>
            <ag-row-container ref="bottomFullWidthContainer" name="${"bottomFullWidth" /* BOTTOM_FULL_WIDTH */ }"></ag-row-container>
        </div>
        <ag-fake-horizontal-scroll></ag-fake-horizontal-scroll>
        <ag-overlay-wrapper></ag-overlay-wrapper>
    </div>`;
var GridBodyComp = class extends Component {
    constructor(){
        super(GRID_BODY_TEMPLATE);
    }
    init() {
        const setHeight = (height, element)=>{
            const heightString = `${height}px`;
            element.style.minHeight = heightString;
            element.style.height = heightString;
        };
        const compProxy = {
            setRowAnimationCssOnBodyViewport: (cssClass, animate)=>this.setRowAnimationCssOnBodyViewport(cssClass, animate),
            setColumnCount: (count)=>setAriaColCount(this.getGui(), count),
            setRowCount: (count)=>setAriaRowCount(this.getGui(), count),
            setTopHeight: (height)=>setHeight(height, this.eTop),
            setBottomHeight: (height)=>setHeight(height, this.eBottom),
            setTopDisplay: (display)=>this.eTop.style.display = display,
            setBottomDisplay: (display)=>this.eBottom.style.display = display,
            setStickyTopHeight: (height)=>this.eStickyTop.style.height = height,
            setStickyTopTop: (top)=>this.eStickyTop.style.top = top,
            setStickyTopWidth: (width)=>this.eStickyTop.style.width = width,
            setStickyBottomHeight: (height)=>this.eStickyBottom.style.height = height,
            setStickyBottomBottom: (bottom)=>this.eStickyBottom.style.bottom = bottom,
            setStickyBottomWidth: (width)=>this.eStickyBottom.style.width = width,
            setColumnMovingCss: (cssClass, flag)=>this.addOrRemoveCssClass(cssClass, flag),
            updateLayoutClasses: (cssClass, params)=>{
                const classLists = [
                    this.eBodyViewport.classList,
                    this.eBody.classList
                ];
                classLists.forEach((classList)=>{
                    classList.toggle("ag-layout-auto-height" /* AUTO_HEIGHT */ , params.autoHeight);
                    classList.toggle("ag-layout-normal" /* NORMAL */ , params.normal);
                    classList.toggle("ag-layout-print" /* PRINT */ , params.print);
                });
                this.addOrRemoveCssClass("ag-layout-auto-height" /* AUTO_HEIGHT */ , params.autoHeight);
                this.addOrRemoveCssClass("ag-layout-normal" /* NORMAL */ , params.normal);
                this.addOrRemoveCssClass("ag-layout-print" /* PRINT */ , params.print);
            },
            setAlwaysVerticalScrollClass: (cssClass, on)=>this.eBodyViewport.classList.toggle(CSS_CLASS_FORCE_VERTICAL_SCROLL, on),
            registerBodyViewportResizeListener: (listener)=>{
                const unsubscribeFromResize = this.resizeObserverService.observeResize(this.eBodyViewport, listener);
                this.addDestroyFunc(()=>unsubscribeFromResize());
            },
            setPinnedTopBottomOverflowY: (overflow)=>this.eTop.style.overflowY = this.eBottom.style.overflowY = overflow,
            setCellSelectableCss: (cssClass, selectable)=>{
                [
                    this.eTop,
                    this.eBodyViewport,
                    this.eBottom
                ].forEach((ct)=>ct.classList.toggle(cssClass, selectable));
            },
            setBodyViewportWidth: (width)=>this.eBodyViewport.style.width = width
        };
        this.ctrl = this.createManagedBean(new GridBodyCtrl());
        this.ctrl.setComp(compProxy, this.getGui(), this.eBodyViewport, this.eTop, this.eBottom, this.eStickyTop, this.eStickyBottom);
        if (this.rangeService && this.gos.get("enableRangeSelection") || this.gos.get("rowSelection") === "multiple") setAriaMultiSelectable(this.getGui(), true);
    }
    setRowAnimationCssOnBodyViewport(cssClass, animateRows) {
        const bodyViewportClassList = this.eBodyViewport.classList;
        bodyViewportClassList.toggle("ag-row-animation" /* ANIMATION_ON */ , animateRows);
        bodyViewportClassList.toggle("ag-row-no-animation" /* ANIMATION_OFF */ , !animateRows);
    }
    getFloatingTopBottom() {
        return [
            this.eTop,
            this.eBottom
        ];
    }
};
__decorateClass([
    Autowired("resizeObserverService")
], GridBodyComp.prototype, "resizeObserverService", 2);
__decorateClass([
    Optional("rangeService")
], GridBodyComp.prototype, "rangeService", 2);
__decorateClass([
    RefSelector("eBodyViewport")
], GridBodyComp.prototype, "eBodyViewport", 2);
__decorateClass([
    RefSelector("eStickyTop")
], GridBodyComp.prototype, "eStickyTop", 2);
__decorateClass([
    RefSelector("eStickyBottom")
], GridBodyComp.prototype, "eStickyBottom", 2);
__decorateClass([
    RefSelector("eTop")
], GridBodyComp.prototype, "eTop", 2);
__decorateClass([
    RefSelector("eBottom")
], GridBodyComp.prototype, "eBottom", 2);
__decorateClass([
    RefSelector("gridHeader")
], GridBodyComp.prototype, "headerRootComp", 2);
__decorateClass([
    RefSelector("eBody")
], GridBodyComp.prototype, "eBody", 2);
__decorateClass([
    PostConstruct
], GridBodyComp.prototype, "init", 1);
// community-modules/core/src/gridBodyComp/scrollVisibleService.ts
var ScrollVisibleService = class extends BeanStub {
    postConstruct() {
        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onDisplayedColumnsWidthChanged.bind(this));
    }
    onDisplayedColumnsChanged() {
        this.update();
    }
    onDisplayedColumnsWidthChanged() {
        this.update();
    }
    update() {
        if (this.columnAnimationService.isActive()) this.columnAnimationService.executeLaterVMTurn(()=>{
            this.columnAnimationService.executeLaterVMTurn(()=>this.updateImpl());
        });
        else this.updateImpl();
    }
    updateImpl() {
        const centerRowCtrl = this.ctrlsService.get("center");
        if (!centerRowCtrl || this.columnAnimationService.isActive()) return;
        const params = {
            horizontalScrollShowing: centerRowCtrl.isHorizontalScrollShowing(),
            verticalScrollShowing: this.isVerticalScrollShowing()
        };
        this.setScrollsVisible(params);
    }
    setScrollsVisible(params) {
        const atLeastOneDifferent = this.horizontalScrollShowing !== params.horizontalScrollShowing || this.verticalScrollShowing !== params.verticalScrollShowing;
        if (atLeastOneDifferent) {
            this.horizontalScrollShowing = params.horizontalScrollShowing;
            this.verticalScrollShowing = params.verticalScrollShowing;
            const event = {
                type: Events.EVENT_SCROLL_VISIBILITY_CHANGED
            };
            this.eventService.dispatchEvent(event);
        }
    }
    // used by pagination service - to know page height
    isHorizontalScrollShowing() {
        return this.horizontalScrollShowing;
    }
    // used by header container
    isVerticalScrollShowing() {
        return this.verticalScrollShowing;
    }
};
__decorateClass([
    Autowired("ctrlsService")
], ScrollVisibleService.prototype, "ctrlsService", 2);
__decorateClass([
    Autowired("columnAnimationService")
], ScrollVisibleService.prototype, "columnAnimationService", 2);
__decorateClass([
    PostConstruct
], ScrollVisibleService.prototype, "postConstruct", 1);
ScrollVisibleService = __decorateClass([
    Bean("scrollVisibleService")
], ScrollVisibleService);
// community-modules/core/src/gridBodyComp/mouseEventService.ts
var MouseEventService = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.gridInstanceId = MouseEventService.gridInstanceSequence.next();
    }
    // we put the instance id onto the main DOM element. this is used for events, when grids are inside grids,
    // so the grid can work out if the even came from this grid or a grid inside this one. see the ctrl+v logic
    // for where this is used.
    stampTopLevelGridCompWithGridInstance(eGridDiv) {
        eGridDiv[MouseEventService.GRID_DOM_KEY] = this.gridInstanceId;
    }
    getRenderedCellForEvent(event) {
        return getCtrlForEventTarget(this.gos, event.target, CellCtrl.DOM_DATA_KEY_CELL_CTRL);
    }
    // walks the path of the event, and returns true if this grid is the first one that it finds. if doing
    // master / detail grids, and a child grid is found, then it returns false. this stops things like copy/paste
    // getting executed on many grids at the same time.
    isEventFromThisGrid(event) {
        const res = this.isElementInThisGrid(event.target);
        return res;
    }
    isElementInThisGrid(element) {
        let pointer = element;
        while(pointer){
            const instanceId = pointer[MouseEventService.GRID_DOM_KEY];
            if (exists(instanceId)) {
                const eventFromThisGrid = instanceId === this.gridInstanceId;
                return eventFromThisGrid;
            }
            pointer = pointer.parentElement;
        }
        return false;
    }
    getCellPositionForEvent(event) {
        const cellComp = this.getRenderedCellForEvent(event);
        return cellComp ? cellComp.getCellPosition() : null;
    }
    getNormalisedPosition(event) {
        const gridPanelHasScrolls = this.gos.isDomLayout("normal");
        const e = event;
        let x;
        let y;
        if (e.clientX != null || e.clientY != null) {
            x = e.clientX;
            y = e.clientY;
        } else {
            x = e.x;
            y = e.y;
        }
        if (gridPanelHasScrolls) {
            const gridBodyCon = this.ctrlsService.getGridBodyCtrl();
            const vRange = gridBodyCon.getScrollFeature().getVScrollPosition();
            const hRange = gridBodyCon.getScrollFeature().getHScrollPosition();
            x += hRange.left;
            y += vRange.top;
        }
        return {
            x,
            y
        };
    }
};
MouseEventService.gridInstanceSequence = new NumberSequence();
MouseEventService.GRID_DOM_KEY = "__ag_grid_instance";
__decorateClass([
    Autowired("ctrlsService")
], MouseEventService.prototype, "ctrlsService", 2);
MouseEventService = __decorateClass([
    Bean("mouseEventService")
], MouseEventService);
// community-modules/core/src/gridBodyComp/navigationService.ts
var NavigationService = class extends BeanStub {
    constructor(){
        super();
        this.onPageDown = throttle(this.onPageDown, 100);
        this.onPageUp = throttle(this.onPageUp, 100);
    }
    postConstruct() {
        this.ctrlsService.whenReady((p)=>{
            this.gridBodyCon = p.gridBodyCtrl;
        });
    }
    handlePageScrollingKey(event, fromFullWidth = false) {
        const key = event.key;
        const alt = event.altKey;
        const ctrl = event.ctrlKey || event.metaKey;
        const rangeServiceShouldHandleShift = !!this.rangeService && event.shiftKey;
        const currentCell = this.mouseEventService.getCellPositionForEvent(event);
        let processed = false;
        switch(key){
            case KeyCode.PAGE_HOME:
            case KeyCode.PAGE_END:
                if (!ctrl && !alt) {
                    this.onHomeOrEndKey(key);
                    processed = true;
                }
                break;
            case KeyCode.LEFT:
            case KeyCode.RIGHT:
            case KeyCode.UP:
            case KeyCode.DOWN:
                if (!currentCell) return false;
                if (ctrl && !alt && !rangeServiceShouldHandleShift) {
                    this.onCtrlUpDownLeftRight(key, currentCell);
                    processed = true;
                }
                break;
            case KeyCode.PAGE_DOWN:
            case KeyCode.PAGE_UP:
                if (!ctrl && !alt) processed = this.handlePageUpDown(key, currentCell, fromFullWidth);
                break;
        }
        if (processed) event.preventDefault();
        return processed;
    }
    handlePageUpDown(key, currentCell, fromFullWidth) {
        if (fromFullWidth) currentCell = this.focusService.getFocusedCell();
        if (!currentCell) return false;
        if (key === KeyCode.PAGE_UP) this.onPageUp(currentCell);
        else this.onPageDown(currentCell);
        return true;
    }
    navigateTo(navigateParams) {
        var _a;
        const { scrollIndex, scrollType, scrollColumn, focusIndex, focusColumn } = navigateParams;
        if (exists(scrollColumn) && !scrollColumn.isPinned()) this.gridBodyCon.getScrollFeature().ensureColumnVisible(scrollColumn);
        if (exists(scrollIndex)) this.gridBodyCon.getScrollFeature().ensureIndexVisible(scrollIndex, scrollType);
        if (!navigateParams.isAsync) this.gridBodyCon.getScrollFeature().ensureIndexVisible(focusIndex);
        this.focusService.setFocusedCell({
            rowIndex: focusIndex,
            column: focusColumn,
            rowPinned: null,
            forceBrowserFocus: true
        });
        (_a = this.rangeService) == null || _a.setRangeToCell({
            rowIndex: focusIndex,
            rowPinned: null,
            column: focusColumn
        });
    }
    // this method is throttled, see the `constructor`
    onPageDown(gridCell) {
        const gridBodyCon = this.ctrlsService.getGridBodyCtrl();
        const scrollPosition = gridBodyCon.getScrollFeature().getVScrollPosition();
        const pixelsInOnePage = this.getViewportHeight();
        const pagingPixelOffset = this.paginationProxy.getPixelOffset();
        const currentPageBottomPixel = scrollPosition.top + pixelsInOnePage;
        const currentPageBottomRow = this.paginationProxy.getRowIndexAtPixel(currentPageBottomPixel + pagingPixelOffset);
        if (this.columnModel.isAutoRowHeightActive()) this.navigateToNextPageWithAutoHeight(gridCell, currentPageBottomRow);
        else this.navigateToNextPage(gridCell, currentPageBottomRow);
    }
    // this method is throttled, see the `constructor`
    onPageUp(gridCell) {
        const gridBodyCon = this.ctrlsService.getGridBodyCtrl();
        const scrollPosition = gridBodyCon.getScrollFeature().getVScrollPosition();
        const pagingPixelOffset = this.paginationProxy.getPixelOffset();
        const currentPageTopPixel = scrollPosition.top;
        const currentPageTopRow = this.paginationProxy.getRowIndexAtPixel(currentPageTopPixel + pagingPixelOffset);
        if (this.columnModel.isAutoRowHeightActive()) this.navigateToNextPageWithAutoHeight(gridCell, currentPageTopRow, true);
        else this.navigateToNextPage(gridCell, currentPageTopRow, true);
    }
    navigateToNextPage(gridCell, scrollIndex, up = false) {
        const pixelsInOnePage = this.getViewportHeight();
        const firstRow = this.paginationProxy.getPageFirstRow();
        const lastRow = this.paginationProxy.getPageLastRow();
        const pagingPixelOffset = this.paginationProxy.getPixelOffset();
        const currentRowNode = this.paginationProxy.getRow(gridCell.rowIndex);
        const rowPixelDiff = up ? (currentRowNode == null ? void 0 : currentRowNode.rowHeight) - pixelsInOnePage - pagingPixelOffset : pixelsInOnePage - pagingPixelOffset;
        const nextCellPixel = (currentRowNode == null ? void 0 : currentRowNode.rowTop) + rowPixelDiff;
        let focusIndex = this.paginationProxy.getRowIndexAtPixel(nextCellPixel + pagingPixelOffset);
        if (focusIndex === gridCell.rowIndex) {
            const diff = up ? -1 : 1;
            scrollIndex = focusIndex = gridCell.rowIndex + diff;
        }
        let scrollType;
        if (up) {
            scrollType = "bottom";
            if (focusIndex < firstRow) focusIndex = firstRow;
            if (scrollIndex < firstRow) scrollIndex = firstRow;
        } else {
            scrollType = "top";
            if (focusIndex > lastRow) focusIndex = lastRow;
            if (scrollIndex > lastRow) scrollIndex = lastRow;
        }
        if (this.isRowTallerThanView(focusIndex)) {
            scrollIndex = focusIndex;
            scrollType = "top";
        }
        this.navigateTo({
            scrollIndex,
            scrollType,
            scrollColumn: null,
            focusIndex,
            focusColumn: gridCell.column
        });
    }
    navigateToNextPageWithAutoHeight(gridCell, scrollIndex, up = false) {
        this.navigateTo({
            scrollIndex,
            scrollType: up ? "bottom" : "top",
            scrollColumn: null,
            focusIndex: scrollIndex,
            focusColumn: gridCell.column
        });
        setTimeout(()=>{
            const focusIndex = this.getNextFocusIndexForAutoHeight(gridCell, up);
            this.navigateTo({
                scrollIndex,
                scrollType: up ? "bottom" : "top",
                scrollColumn: null,
                focusIndex,
                focusColumn: gridCell.column,
                isAsync: true
            });
        }, 50);
    }
    getNextFocusIndexForAutoHeight(gridCell, up = false) {
        var _a;
        const step = up ? -1 : 1;
        const pixelsInOnePage = this.getViewportHeight();
        const lastRowIndex = this.paginationProxy.getPageLastRow();
        let pixelSum = 0;
        let currentIndex = gridCell.rowIndex;
        while(currentIndex >= 0 && currentIndex <= lastRowIndex){
            const currentCell = this.paginationProxy.getRow(currentIndex);
            if (currentCell) {
                const currentCellHeight = (_a = currentCell.rowHeight) != null ? _a : 0;
                if (pixelSum + currentCellHeight > pixelsInOnePage) break;
                pixelSum += currentCellHeight;
            }
            currentIndex += step;
        }
        return Math.max(0, Math.min(currentIndex, lastRowIndex));
    }
    getViewportHeight() {
        const { gridBodyCtrl, center } = this.ctrlsService.getParams();
        const scrollPosition = gridBodyCtrl.getScrollFeature().getVScrollPosition();
        const scrollbarWidth = this.gos.getScrollbarWidth();
        let pixelsInOnePage = scrollPosition.bottom - scrollPosition.top;
        if (center.isHorizontalScrollShowing()) pixelsInOnePage -= scrollbarWidth;
        return pixelsInOnePage;
    }
    isRowTallerThanView(rowIndex) {
        const rowNode = this.paginationProxy.getRow(rowIndex);
        if (!rowNode) return false;
        const rowHeight = rowNode.rowHeight;
        if (typeof rowHeight !== "number") return false;
        return rowHeight > this.getViewportHeight();
    }
    onCtrlUpDownLeftRight(key, gridCell) {
        const cellToFocus = this.cellNavigationService.getNextCellToFocus(key, gridCell, true);
        const { rowIndex, column } = cellToFocus;
        this.navigateTo({
            scrollIndex: rowIndex,
            scrollType: null,
            scrollColumn: column,
            focusIndex: rowIndex,
            focusColumn: column
        });
    }
    // home brings focus to top left cell, end brings focus to bottom right, grid scrolled to bring
    // same cell into view (which means either scroll all the way up, or all the way down).
    onHomeOrEndKey(key) {
        const homeKey = key === KeyCode.PAGE_HOME;
        const allColumns = this.columnModel.getAllDisplayedColumns();
        const columnToSelect = homeKey ? allColumns[0] : last(allColumns);
        const scrollIndex = homeKey ? this.paginationProxy.getPageFirstRow() : this.paginationProxy.getPageLastRow();
        this.navigateTo({
            scrollIndex,
            scrollType: null,
            scrollColumn: columnToSelect,
            focusIndex: scrollIndex,
            focusColumn: columnToSelect
        });
    }
    // result of keyboard event
    onTabKeyDown(previous, keyboardEvent) {
        const backwards = keyboardEvent.shiftKey;
        const movedToNextCell = this.tabToNextCellCommon(previous, backwards, keyboardEvent);
        if (movedToNextCell !== false) {
            if (movedToNextCell) keyboardEvent.preventDefault();
            return;
        }
        if (backwards) {
            const { rowIndex, rowPinned } = previous.getRowPosition();
            const firstRow = rowPinned ? rowIndex === 0 : rowIndex === this.paginationProxy.getPageFirstRow();
            if (firstRow) {
                if (this.gos.get("headerHeight") === 0 || this.gos.get("suppressHeaderFocus")) this.focusService.focusNextGridCoreContainer(true, true);
                else {
                    keyboardEvent.preventDefault();
                    this.focusService.focusPreviousFromFirstCell(keyboardEvent);
                }
            }
        } else {
            if (previous instanceof CellCtrl) previous.focusCell(true);
            if (this.focusService.focusNextGridCoreContainer(backwards)) keyboardEvent.preventDefault();
        }
    }
    // comes from API
    tabToNextCell(backwards, event) {
        const focusedCell = this.focusService.getFocusedCell();
        if (!focusedCell) return false;
        let cellOrRow = this.getCellByPosition(focusedCell);
        if (!cellOrRow) {
            cellOrRow = this.rowRenderer.getRowByPosition(focusedCell);
            if (!cellOrRow || !cellOrRow.isFullWidth()) return false;
        }
        return !!this.tabToNextCellCommon(cellOrRow, backwards, event);
    }
    tabToNextCellCommon(previous, backwards, event) {
        let editing = previous.isEditing();
        if (!editing && previous instanceof CellCtrl) {
            const cell = previous;
            const row = cell.getRowCtrl();
            if (row) editing = row.isEditing();
        }
        let res;
        if (editing) {
            if (this.gos.get("editType") === "fullRow") res = this.moveToNextEditingRow(previous, backwards, event);
            else res = this.moveToNextEditingCell(previous, backwards, event);
        } else res = this.moveToNextCellNotEditing(previous, backwards);
        if (res === null) return res;
        return res || !!this.focusService.getFocusedHeader();
    }
    // returns null if no navigation should be performed
    moveToNextEditingCell(previousCell, backwards, event = null) {
        const previousPos = previousCell.getCellPosition();
        previousCell.getGui().focus();
        previousCell.stopEditing();
        const nextCell = this.findNextCellToFocusOn(previousPos, backwards, true);
        if (nextCell === false) return null;
        if (nextCell == null) return false;
        nextCell.startEditing(null, true, event);
        nextCell.focusCell(false);
        return true;
    }
    // returns null if no navigation should be performed
    moveToNextEditingRow(previousCell, backwards, event = null) {
        const previousPos = previousCell.getCellPosition();
        const nextCell = this.findNextCellToFocusOn(previousPos, backwards, true);
        if (nextCell === false) return null;
        if (nextCell == null) return false;
        const nextPos = nextCell.getCellPosition();
        const previousEditable = this.isCellEditable(previousPos);
        const nextEditable = this.isCellEditable(nextPos);
        const rowsMatch = nextPos && previousPos.rowIndex === nextPos.rowIndex && previousPos.rowPinned === nextPos.rowPinned;
        if (previousEditable) previousCell.setFocusOutOnEditor();
        if (!rowsMatch) {
            const pRow = previousCell.getRowCtrl();
            pRow.stopEditing();
            const nRow = nextCell.getRowCtrl();
            nRow.startRowEditing(void 0, void 0, event);
        }
        if (nextEditable) {
            nextCell.setFocusInOnEditor();
            nextCell.focusCell();
        } else nextCell.focusCell(true);
        return true;
    }
    // returns null if no navigation should be performed
    moveToNextCellNotEditing(previousCell, backwards) {
        const displayedColumns = this.columnModel.getAllDisplayedColumns();
        let cellPos;
        if (previousCell instanceof RowCtrl) cellPos = __spreadProps(__spreadValues({}, previousCell.getRowPosition()), {
            column: backwards ? displayedColumns[0] : last(displayedColumns)
        });
        else cellPos = previousCell.getCellPosition();
        const nextCell = this.findNextCellToFocusOn(cellPos, backwards, false);
        if (nextCell === false) return null;
        if (nextCell instanceof CellCtrl) nextCell.focusCell(true);
        else if (nextCell) return this.tryToFocusFullWidthRow(nextCell.getRowPosition(), backwards);
        return exists(nextCell);
    }
    /**
   * called by the cell, when tab is pressed while editing.
   * @return: RenderedCell when navigation successful, false if navigation should not be performed, otherwise null
   */ findNextCellToFocusOn(previousPosition, backwards, startEditing) {
        var _a;
        let nextPosition = previousPosition;
        while(true){
            if (previousPosition !== nextPosition) previousPosition = nextPosition;
            if (!backwards) nextPosition = this.getLastCellOfColSpan(nextPosition);
            nextPosition = this.cellNavigationService.getNextTabbedCell(nextPosition, backwards);
            const userFunc = this.gos.getCallback("tabToNextCell");
            if (exists(userFunc)) {
                const params = {
                    backwards,
                    editing: startEditing,
                    previousCellPosition: previousPosition,
                    nextCellPosition: nextPosition ? nextPosition : null
                };
                const userResult = userFunc(params);
                if (userResult === true || userResult === null) {
                    if (userResult === null) warnOnce("Returning `null` from tabToNextCell is deprecated. Return `true` to stay on the current cell, or `false` to let the browser handle the tab behaviour.");
                    nextPosition = previousPosition;
                } else if (userResult === false) return false;
                else {
                    if (userResult.floating) {
                        warnOnce(`tabToNextCellFunc return type should have attributes: rowIndex, rowPinned, column. However you had 'floating', maybe you meant 'rowPinned'?`);
                        userResult.rowPinned = userResult.floating;
                    }
                    nextPosition = {
                        rowIndex: userResult.rowIndex,
                        column: userResult.column,
                        rowPinned: userResult.rowPinned
                    };
                }
            }
            if (!nextPosition) return null;
            if (nextPosition.rowIndex < 0) {
                const headerLen = this.headerNavigationService.getHeaderRowCount();
                this.focusService.focusHeaderPosition({
                    headerPosition: {
                        headerRowIndex: headerLen + nextPosition.rowIndex,
                        column: nextPosition.column
                    },
                    fromCell: true
                });
                return null;
            }
            const fullRowEdit = this.gos.get("editType") === "fullRow";
            if (startEditing && !fullRowEdit) {
                const cellIsEditable = this.isCellEditable(nextPosition);
                if (!cellIsEditable) continue;
            }
            this.ensureCellVisible(nextPosition);
            const nextCell = this.getCellByPosition(nextPosition);
            if (!nextCell) {
                const row = this.rowRenderer.getRowByPosition(nextPosition);
                if (!row || !row.isFullWidth() || startEditing) continue;
                return row;
            }
            if (nextCell.isSuppressNavigable()) continue;
            (_a = this.rangeService) == null || _a.setRangeToCell(nextPosition);
            return nextCell;
        }
    }
    isCellEditable(cell) {
        const rowNode = this.lookupRowNodeForCell(cell);
        if (rowNode) return cell.column.isCellEditable(rowNode);
        return false;
    }
    getCellByPosition(cellPosition) {
        const rowCtrl = this.rowRenderer.getRowByPosition(cellPosition);
        if (!rowCtrl) return null;
        return rowCtrl.getCellCtrl(cellPosition.column);
    }
    lookupRowNodeForCell(cell) {
        if (cell.rowPinned === "top") return this.pinnedRowModel.getPinnedTopRow(cell.rowIndex);
        if (cell.rowPinned === "bottom") return this.pinnedRowModel.getPinnedBottomRow(cell.rowIndex);
        return this.paginationProxy.getRow(cell.rowIndex);
    }
    // we use index for rows, but column object for columns, as the next column (by index) might not
    // be visible (header grouping) so it's not reliable, so using the column object instead.
    navigateToNextCell(event, key, currentCell, allowUserOverride) {
        let nextCell = currentCell;
        let hitEdgeOfGrid = false;
        while(nextCell && (nextCell === currentCell || !this.isValidNavigateCell(nextCell))){
            if (this.gos.get("enableRtl")) {
                if (key === KeyCode.LEFT) nextCell = this.getLastCellOfColSpan(nextCell);
            } else if (key === KeyCode.RIGHT) nextCell = this.getLastCellOfColSpan(nextCell);
            nextCell = this.cellNavigationService.getNextCellToFocus(key, nextCell);
            hitEdgeOfGrid = missing(nextCell);
        }
        if (hitEdgeOfGrid && event && event.key === KeyCode.UP) nextCell = {
            rowIndex: -1,
            rowPinned: null,
            column: currentCell.column
        };
        if (allowUserOverride) {
            const userFunc = this.gos.getCallback("navigateToNextCell");
            if (exists(userFunc)) {
                const params = {
                    key,
                    previousCellPosition: currentCell,
                    nextCellPosition: nextCell ? nextCell : null,
                    event
                };
                const userCell = userFunc(params);
                if (exists(userCell)) {
                    if (userCell.floating) {
                        warnOnce(`tabToNextCellFunc return type should have attributes: rowIndex, rowPinned, column. However you had 'floating', maybe you meant 'rowPinned'?`);
                        userCell.rowPinned = userCell.floating;
                    }
                    nextCell = {
                        rowPinned: userCell.rowPinned,
                        rowIndex: userCell.rowIndex,
                        column: userCell.column
                    };
                } else nextCell = null;
            }
        }
        if (!nextCell) return;
        if (nextCell.rowIndex < 0) {
            const headerLen = this.headerNavigationService.getHeaderRowCount();
            this.focusService.focusHeaderPosition({
                headerPosition: {
                    headerRowIndex: headerLen + nextCell.rowIndex,
                    column: currentCell.column
                },
                event: event || void 0,
                fromCell: true
            });
            return;
        }
        const normalisedPosition = this.getNormalisedPosition(nextCell);
        if (normalisedPosition) this.focusPosition(normalisedPosition);
        else this.tryToFocusFullWidthRow(nextCell);
    }
    getNormalisedPosition(cellPosition) {
        this.ensureCellVisible(cellPosition);
        const cellCtrl = this.getCellByPosition(cellPosition);
        if (!cellCtrl) return null;
        cellPosition = cellCtrl.getCellPosition();
        this.ensureCellVisible(cellPosition);
        return cellPosition;
    }
    tryToFocusFullWidthRow(position, backwards = false) {
        const displayedColumns = this.columnModel.getAllDisplayedColumns();
        const rowComp = this.rowRenderer.getRowByPosition(position);
        if (!rowComp || !rowComp.isFullWidth()) return false;
        const currentCellFocused = this.focusService.getFocusedCell();
        const cellPosition = {
            rowIndex: position.rowIndex,
            rowPinned: position.rowPinned,
            column: position.column || (backwards ? last(displayedColumns) : displayedColumns[0])
        };
        this.focusPosition(cellPosition);
        const fromBelow = currentCellFocused != null ? this.rowPositionUtils.before(cellPosition, currentCellFocused) : false;
        const focusEvent = {
            type: Events.EVENT_FULL_WIDTH_ROW_FOCUSED,
            rowIndex: cellPosition.rowIndex,
            rowPinned: cellPosition.rowPinned,
            column: cellPosition.column,
            isFullWidthCell: true,
            floating: cellPosition.rowPinned,
            fromBelow
        };
        this.eventService.dispatchEvent(focusEvent);
        return true;
    }
    focusPosition(cellPosition) {
        var _a;
        this.focusService.setFocusedCell({
            rowIndex: cellPosition.rowIndex,
            column: cellPosition.column,
            rowPinned: cellPosition.rowPinned,
            forceBrowserFocus: true
        });
        (_a = this.rangeService) == null || _a.setRangeToCell(cellPosition);
    }
    isValidNavigateCell(cell) {
        const rowNode = this.rowPositionUtils.getRowNode(cell);
        return !!rowNode;
    }
    getLastCellOfColSpan(cell) {
        const cellCtrl = this.getCellByPosition(cell);
        if (!cellCtrl) return cell;
        const colSpanningList = cellCtrl.getColSpanningList();
        if (colSpanningList.length === 1) return cell;
        return {
            rowIndex: cell.rowIndex,
            column: last(colSpanningList),
            rowPinned: cell.rowPinned
        };
    }
    ensureCellVisible(gridCell) {
        const isGroupStickyEnabled = this.gos.isGroupRowsSticky();
        const rowNode = this.rowModel.getRow(gridCell.rowIndex);
        const skipScrollToRow = isGroupStickyEnabled && (rowNode == null ? void 0 : rowNode.sticky);
        if (!skipScrollToRow && missing(gridCell.rowPinned)) this.gridBodyCon.getScrollFeature().ensureIndexVisible(gridCell.rowIndex);
        if (!gridCell.column.isPinned()) this.gridBodyCon.getScrollFeature().ensureColumnVisible(gridCell.column);
    }
};
__decorateClass([
    Autowired("mouseEventService")
], NavigationService.prototype, "mouseEventService", 2);
__decorateClass([
    Autowired("paginationProxy")
], NavigationService.prototype, "paginationProxy", 2);
__decorateClass([
    Autowired("focusService")
], NavigationService.prototype, "focusService", 2);
__decorateClass([
    Autowired("columnModel")
], NavigationService.prototype, "columnModel", 2);
__decorateClass([
    Autowired("rowModel")
], NavigationService.prototype, "rowModel", 2);
__decorateClass([
    Autowired("ctrlsService")
], NavigationService.prototype, "ctrlsService", 2);
__decorateClass([
    Autowired("rowRenderer")
], NavigationService.prototype, "rowRenderer", 2);
__decorateClass([
    Autowired("headerNavigationService")
], NavigationService.prototype, "headerNavigationService", 2);
__decorateClass([
    Autowired("rowPositionUtils")
], NavigationService.prototype, "rowPositionUtils", 2);
__decorateClass([
    Autowired("cellNavigationService")
], NavigationService.prototype, "cellNavigationService", 2);
__decorateClass([
    Autowired("pinnedRowModel")
], NavigationService.prototype, "pinnedRowModel", 2);
__decorateClass([
    Optional("rangeService")
], NavigationService.prototype, "rangeService", 2);
__decorateClass([
    PostConstruct
], NavigationService.prototype, "postConstruct", 1);
NavigationService = __decorateClass([
    Bean("navigationService")
], NavigationService);
// community-modules/core/src/rendering/cellEditors/popupEditorWrapper.ts
var _PopupEditorWrapper = class _PopupEditorWrapper extends PopupComponent {
    constructor(params){
        super(/* html */ `<div class="ag-popup-editor" tabindex="-1"/>`);
        this.params = params;
    }
    postConstruct() {
        this.gos.setDomData(this.getGui(), _PopupEditorWrapper.DOM_KEY_POPUP_EDITOR_WRAPPER, true);
        this.addKeyDownListener();
    }
    addKeyDownListener() {
        const eGui = this.getGui();
        const params = this.params;
        const listener = (event)=>{
            if (!isUserSuppressingKeyboardEvent(this.gos, event, params.node, params.column, true)) params.onKeyDown(event);
        };
        this.addManagedListener(eGui, "keydown", listener);
    }
};
_PopupEditorWrapper.DOM_KEY_POPUP_EDITOR_WRAPPER = "popupEditorWrapper";
__decorateClass([
    PostConstruct
], _PopupEditorWrapper.prototype, "postConstruct", 1);
var PopupEditorWrapper = _PopupEditorWrapper;
// community-modules/core/src/rendering/cell/cellComp.ts
var CellComp = class extends Component {
    constructor(beans, cellCtrl, printLayout, eRow, editingRow){
        super();
        // every time we go into edit mode, or back again, this gets incremented.
        // it's the components way of dealing with the async nature of framework components,
        // so if a framework component takes a while to be created, we know if the object
        // is still relevant when creating is finished. eg we could click edit / un-edit 20
        // times before the first React edit component comes back - we should discard
        // the first 19.
        this.rendererVersion = 0;
        this.editorVersion = 0;
        this.beans = beans;
        this.column = cellCtrl.getColumn();
        this.rowNode = cellCtrl.getRowNode();
        this.rowCtrl = cellCtrl.getRowCtrl();
        this.eRow = eRow;
        this.cellCtrl = cellCtrl;
        const cellDiv = document.createElement("div");
        cellDiv.setAttribute("comp-id", `${this.getCompId()}`);
        this.setTemplateFromElement(cellDiv);
        const eGui = this.getGui();
        this.forceWrapper = cellCtrl.isForceWrapper();
        this.refreshWrapper(false);
        const setAttribute = (name, value)=>{
            if (value != null && value != "") eGui.setAttribute(name, value);
            else eGui.removeAttribute(name);
        };
        setAriaRole(eGui, cellCtrl.getCellAriaRole());
        setAttribute("col-id", cellCtrl.getColumnIdSanitised());
        const tabIndex = cellCtrl.getTabIndex();
        if (tabIndex !== void 0) setAttribute("tabindex", tabIndex.toString());
        const compProxy = {
            addOrRemoveCssClass: (cssClassName, on)=>this.addOrRemoveCssClass(cssClassName, on),
            setUserStyles: (styles)=>addStylesToElement(eGui, styles),
            getFocusableElement: ()=>this.getFocusableElement(),
            setIncludeSelection: (include)=>this.includeSelection = include,
            setIncludeRowDrag: (include)=>this.includeRowDrag = include,
            setIncludeDndSource: (include)=>this.includeDndSource = include,
            setRenderDetails: (compDetails, valueToDisplay, force)=>this.setRenderDetails(compDetails, valueToDisplay, force),
            setEditDetails: (compDetails, popup, position)=>this.setEditDetails(compDetails, popup, position),
            getCellEditor: ()=>this.cellEditor || null,
            getCellRenderer: ()=>this.cellRenderer || null,
            getParentOfValue: ()=>this.getParentOfValue()
        };
        cellCtrl.setComp(compProxy, this.getGui(), this.eCellWrapper, printLayout, editingRow);
    }
    getParentOfValue() {
        if (this.eCellValue) return this.eCellValue;
        if (this.eCellWrapper) return this.eCellWrapper;
        return this.getGui();
    }
    setRenderDetails(compDetails, valueToDisplay, forceNewCellRendererInstance) {
        const isInlineEditing = this.cellEditor && !this.cellEditorPopupWrapper;
        if (isInlineEditing) return;
        this.firstRender = this.firstRender == null;
        const controlWrapperChanged = this.refreshWrapper(false);
        this.refreshEditStyles(false);
        if (compDetails) {
            const neverRefresh = forceNewCellRendererInstance || controlWrapperChanged;
            const cellRendererRefreshSuccessful = neverRefresh ? false : this.refreshCellRenderer(compDetails);
            if (!cellRendererRefreshSuccessful) {
                this.destroyRenderer();
                this.createCellRendererInstance(compDetails);
            }
        } else {
            this.destroyRenderer();
            this.insertValueWithoutCellRenderer(valueToDisplay);
        }
    }
    setEditDetails(compDetails, popup, position) {
        if (compDetails) this.createCellEditorInstance(compDetails, popup, position);
        else this.destroyEditor();
    }
    removeControls() {
        this.checkboxSelectionComp = this.beans.context.destroyBean(this.checkboxSelectionComp);
        this.dndSourceComp = this.beans.context.destroyBean(this.dndSourceComp);
        this.rowDraggingComp = this.beans.context.destroyBean(this.rowDraggingComp);
    }
    // returns true if wrapper was changed
    refreshWrapper(editing) {
        const providingControls = this.includeRowDrag || this.includeDndSource || this.includeSelection;
        const usingWrapper = providingControls || this.forceWrapper;
        const putWrapperIn = usingWrapper && this.eCellWrapper == null;
        if (putWrapperIn) {
            const wrapperDiv = document.createElement("div");
            wrapperDiv.setAttribute("role", "presentation");
            wrapperDiv.setAttribute("class", "ag-cell-wrapper");
            this.eCellWrapper = wrapperDiv;
            this.getGui().appendChild(this.eCellWrapper);
        }
        const takeWrapperOut = !usingWrapper && this.eCellWrapper != null;
        if (takeWrapperOut) {
            removeFromParent(this.eCellWrapper);
            this.eCellWrapper = void 0;
        }
        this.addOrRemoveCssClass("ag-cell-value", !usingWrapper);
        const usingCellValue = !editing && usingWrapper;
        const putCellValueIn = usingCellValue && this.eCellValue == null;
        if (putCellValueIn) {
            const cellSpan = document.createElement("span");
            cellSpan.setAttribute("role", "presentation");
            cellSpan.setAttribute("class", "ag-cell-value");
            this.eCellValue = cellSpan;
            this.eCellWrapper.appendChild(this.eCellValue);
        }
        const takeCellValueOut = !usingCellValue && this.eCellValue != null;
        if (takeCellValueOut) {
            removeFromParent(this.eCellValue);
            this.eCellValue = void 0;
        }
        const templateChanged = putWrapperIn || takeWrapperOut || putCellValueIn || takeCellValueOut;
        if (templateChanged) this.removeControls();
        if (!editing) {
            if (providingControls) this.addControls();
        }
        return templateChanged;
    }
    addControls() {
        if (this.includeRowDrag) {
            if (this.rowDraggingComp == null) {
                this.rowDraggingComp = this.cellCtrl.createRowDragComp();
                if (this.rowDraggingComp) this.eCellWrapper.insertBefore(this.rowDraggingComp.getGui(), this.eCellValue);
            }
        }
        if (this.includeDndSource) {
            if (this.dndSourceComp == null) {
                this.dndSourceComp = this.cellCtrl.createDndSource();
                this.eCellWrapper.insertBefore(this.dndSourceComp.getGui(), this.eCellValue);
            }
        }
        if (this.includeSelection) {
            if (this.checkboxSelectionComp == null) {
                this.checkboxSelectionComp = this.cellCtrl.createSelectionCheckbox();
                this.eCellWrapper.insertBefore(this.checkboxSelectionComp.getGui(), this.eCellValue);
            }
        }
    }
    createCellEditorInstance(compDetails, popup, position) {
        const versionCopy = this.editorVersion;
        const cellEditorPromise = compDetails.newAgStackInstance();
        if (!cellEditorPromise) return;
        const { params } = compDetails;
        cellEditorPromise.then((c)=>this.afterCellEditorCreated(versionCopy, c, params, popup, position));
        const cellEditorAsync = missing(this.cellEditor);
        if (cellEditorAsync && params.cellStartedEdit) this.cellCtrl.focusCell(true);
    }
    insertValueWithoutCellRenderer(valueToDisplay) {
        const eParent = this.getParentOfValue();
        clearElement(eParent);
        const escapedValue = valueToDisplay != null ? escapeString(valueToDisplay, true) : null;
        if (escapedValue != null) eParent.textContent = escapedValue;
    }
    destroyEditorAndRenderer() {
        this.destroyRenderer();
        this.destroyEditor();
    }
    destroyRenderer() {
        const { context } = this.beans;
        this.cellRenderer = context.destroyBean(this.cellRenderer);
        removeFromParent(this.cellRendererGui);
        this.cellRendererGui = null;
        this.rendererVersion++;
    }
    destroyEditor() {
        const { context } = this.beans;
        if (this.hideEditorPopup) this.hideEditorPopup();
        this.hideEditorPopup = void 0;
        this.cellEditor = context.destroyBean(this.cellEditor);
        this.cellEditorPopupWrapper = context.destroyBean(this.cellEditorPopupWrapper);
        removeFromParent(this.cellEditorGui);
        this.cellEditorGui = null;
        this.editorVersion++;
    }
    refreshCellRenderer(compClassAndParams) {
        if (this.cellRenderer == null || this.cellRenderer.refresh == null) return false;
        if (this.cellRendererClass !== compClassAndParams.componentClass) return false;
        const result = this.cellRenderer.refresh(compClassAndParams.params);
        return result === true || result === void 0;
    }
    createCellRendererInstance(compDetails) {
        const suppressAnimationFrame = this.beans.gos.get("suppressAnimationFrame");
        const useTaskService = !suppressAnimationFrame;
        const displayComponentVersionCopy = this.rendererVersion;
        const { componentClass } = compDetails;
        const createCellRendererFunc = ()=>{
            const staleTask = this.rendererVersion !== displayComponentVersionCopy || !this.isAlive();
            if (staleTask) return;
            const componentPromise = compDetails.newAgStackInstance();
            const callback = this.afterCellRendererCreated.bind(this, displayComponentVersionCopy, componentClass);
            if (componentPromise) componentPromise.then(callback);
        };
        if (useTaskService && this.firstRender) this.beans.animationFrameService.createTask(createCellRendererFunc, this.rowNode.rowIndex, "createTasksP2");
        else createCellRendererFunc();
    }
    getCtrl() {
        return this.cellCtrl;
    }
    getRowCtrl() {
        return this.rowCtrl;
    }
    getCellRenderer() {
        return this.cellRenderer;
    }
    getCellEditor() {
        return this.cellEditor;
    }
    afterCellRendererCreated(cellRendererVersion, cellRendererClass, cellRenderer) {
        const staleTask = !this.isAlive() || cellRendererVersion !== this.rendererVersion;
        if (staleTask) {
            this.beans.context.destroyBean(cellRenderer);
            return;
        }
        this.cellRenderer = cellRenderer;
        this.cellRendererClass = cellRendererClass;
        this.cellRendererGui = this.cellRenderer.getGui();
        if (this.cellRendererGui != null) {
            const eParent = this.getParentOfValue();
            clearElement(eParent);
            eParent.appendChild(this.cellRendererGui);
        }
    }
    afterCellEditorCreated(requestVersion, cellEditor, params, popup, position) {
        const staleComp = requestVersion !== this.editorVersion;
        if (staleComp) {
            this.beans.context.destroyBean(cellEditor);
            return;
        }
        const editingCancelledByUserComp = cellEditor.isCancelBeforeStart && cellEditor.isCancelBeforeStart();
        if (editingCancelledByUserComp) {
            this.beans.context.destroyBean(cellEditor);
            this.cellCtrl.stopEditing(true);
            return;
        }
        if (!cellEditor.getGui) {
            console.warn(`AG Grid: cellEditor for column ${this.column.getId()} is missing getGui() method`);
            this.beans.context.destroyBean(cellEditor);
            return;
        }
        this.cellEditor = cellEditor;
        this.cellEditorGui = cellEditor.getGui();
        const cellEditorInPopup = popup || cellEditor.isPopup !== void 0 && cellEditor.isPopup();
        if (cellEditorInPopup) this.addPopupCellEditor(params, position);
        else this.addInCellEditor();
        this.refreshEditStyles(true, cellEditorInPopup);
        if (cellEditor.afterGuiAttached) cellEditor.afterGuiAttached();
    }
    refreshEditStyles(editing, isPopup) {
        var _a;
        this.addOrRemoveCssClass("ag-cell-inline-editing", editing && !isPopup);
        this.addOrRemoveCssClass("ag-cell-popup-editing", editing && !!isPopup);
        this.addOrRemoveCssClass("ag-cell-not-inline-editing", !editing || !!isPopup);
        (_a = this.rowCtrl) == null || _a.setInlineEditingCss(editing);
    }
    addInCellEditor() {
        const eGui = this.getGui();
        if (eGui.contains(this.beans.gos.getActiveDomElement())) eGui.focus();
        this.destroyRenderer();
        this.refreshWrapper(true);
        this.clearParentOfValue();
        if (this.cellEditorGui) {
            const eParent = this.getParentOfValue();
            eParent.appendChild(this.cellEditorGui);
        }
    }
    addPopupCellEditor(params, position) {
        if (this.beans.gos.get("editType") === "fullRow") console.warn("AG Grid: popup cellEditor does not work with fullRowEdit - you cannot use them both - either turn off fullRowEdit, or stop using popup editors.");
        const cellEditor = this.cellEditor;
        this.cellEditorPopupWrapper = this.beans.context.createBean(new PopupEditorWrapper(params));
        const ePopupGui = this.cellEditorPopupWrapper.getGui();
        if (this.cellEditorGui) ePopupGui.appendChild(this.cellEditorGui);
        const popupService = this.beans.popupService;
        const useModelPopup = this.beans.gos.get("stopEditingWhenCellsLoseFocus");
        const positionToUse = position != null ? position : cellEditor.getPopupPosition ? cellEditor.getPopupPosition() : "over";
        const isRtl = this.beans.gos.get("enableRtl");
        const positionParams = {
            ePopup: ePopupGui,
            column: this.column,
            rowNode: this.rowNode,
            type: "popupCellEditor",
            eventSource: this.getGui(),
            position: positionToUse,
            alignSide: isRtl ? "right" : "left",
            keepWithinBounds: true
        };
        const positionCallback = popupService.positionPopupByComponent.bind(popupService, positionParams);
        const translate = this.beans.localeService.getLocaleTextFunc();
        const addPopupRes = popupService.addPopup({
            modal: useModelPopup,
            eChild: ePopupGui,
            closeOnEsc: true,
            closedCallback: ()=>{
                this.cellCtrl.onPopupEditorClosed();
            },
            anchorToElement: this.getGui(),
            positionCallback,
            ariaLabel: translate("ariaLabelCellEditor", "Cell Editor")
        });
        if (addPopupRes) this.hideEditorPopup = addPopupRes.hideFunc;
    }
    detach() {
        this.eRow.removeChild(this.getGui());
    }
    // if the row is also getting destroyed, then we don't need to remove from dom,
    // as the row will also get removed, so no need to take out the cells from the row
    // if the row is going (removing is an expensive operation, so only need to remove
    // the top part)
    //
    // note - this is NOT called by context, as we don't wire / unwire the CellComp for performance reasons.
    destroy() {
        this.cellCtrl.stopEditing();
        this.destroyEditorAndRenderer();
        this.removeControls();
        super.destroy();
    }
    clearParentOfValue() {
        const eGui = this.getGui();
        if (eGui.contains(this.beans.gos.getActiveDomElement()) && browserSupportsPreventScroll()) eGui.focus({
            preventScroll: true
        });
        clearElement(this.getParentOfValue());
    }
};
// community-modules/core/src/rendering/row/rowComp.ts
var RowComp = class extends Component {
    constructor(ctrl, beans, containerType){
        super();
        this.cellComps = {};
        this.beans = beans;
        this.rowCtrl = ctrl;
        const rowDiv = document.createElement("div");
        rowDiv.setAttribute("comp-id", `${this.getCompId()}`);
        rowDiv.setAttribute("style", this.getInitialStyle(containerType));
        this.setTemplateFromElement(rowDiv);
        const eGui = this.getGui();
        const style = eGui.style;
        this.domOrder = this.rowCtrl.getDomOrder();
        setAriaRole(eGui, "row");
        const tabIndex = this.rowCtrl.getTabIndex();
        if (tabIndex != null) eGui.setAttribute("tabindex", tabIndex.toString());
        const compProxy = {
            setDomOrder: (domOrder)=>this.domOrder = domOrder,
            setCellCtrls: (cellCtrls)=>this.setCellCtrls(cellCtrls),
            showFullWidth: (compDetails)=>this.showFullWidth(compDetails),
            getFullWidthCellRenderer: ()=>this.getFullWidthCellRenderer(),
            addOrRemoveCssClass: (name, on)=>this.addOrRemoveCssClass(name, on),
            setUserStyles: (styles)=>addStylesToElement(eGui, styles),
            setTop: (top)=>style.top = top,
            setTransform: (transform)=>style.transform = transform,
            setRowIndex: (rowIndex)=>eGui.setAttribute("row-index", rowIndex),
            setRowId: (rowId)=>eGui.setAttribute("row-id", rowId),
            setRowBusinessKey: (businessKey)=>eGui.setAttribute("row-business-key", businessKey),
            refreshFullWidth: (getUpdatedParams)=>this.refreshFullWidth(getUpdatedParams)
        };
        ctrl.setComp(compProxy, this.getGui(), containerType);
        this.addDestroyFunc(()=>{
            ctrl.unsetComp(containerType);
        });
    }
    getInitialStyle(containerType) {
        const transform = this.rowCtrl.getInitialTransform(containerType);
        return transform ? `transform: ${transform}` : `top: ${this.rowCtrl.getInitialRowTop(containerType)}`;
    }
    showFullWidth(compDetails) {
        const callback = (cellRenderer)=>{
            if (this.isAlive()) {
                const eGui = cellRenderer.getGui();
                this.getGui().appendChild(eGui);
                this.rowCtrl.setupDetailRowAutoHeight(eGui);
                this.setFullWidthRowComp(cellRenderer);
            } else this.beans.context.destroyBean(cellRenderer);
        };
        const res = compDetails.newAgStackInstance();
        if (!res) return;
        res.then(callback);
    }
    setCellCtrls(cellCtrls) {
        const cellsToRemove = Object.assign({}, this.cellComps);
        cellCtrls.forEach((cellCtrl)=>{
            const key = cellCtrl.getInstanceId();
            const existingCellComp = this.cellComps[key];
            if (existingCellComp == null) this.newCellComp(cellCtrl);
            else cellsToRemove[key] = null;
        });
        const cellCompsToRemove = getAllValuesInObject(cellsToRemove).filter((cellComp)=>cellComp != null);
        this.destroyCells(cellCompsToRemove);
        this.ensureDomOrder(cellCtrls);
    }
    ensureDomOrder(cellCtrls) {
        if (!this.domOrder) return;
        const elementsInOrder = [];
        cellCtrls.forEach((cellCtrl)=>{
            const cellComp = this.cellComps[cellCtrl.getInstanceId()];
            if (cellComp) elementsInOrder.push(cellComp.getGui());
        });
        setDomChildOrder(this.getGui(), elementsInOrder);
    }
    newCellComp(cellCtrl) {
        const cellComp = new CellComp(this.beans, cellCtrl, this.rowCtrl.isPrintLayout(), this.getGui(), this.rowCtrl.isEditing());
        this.cellComps[cellCtrl.getInstanceId()] = cellComp;
        this.getGui().appendChild(cellComp.getGui());
    }
    destroy() {
        super.destroy();
        this.destroyAllCells();
    }
    destroyAllCells() {
        const cellsToDestroy = getAllValuesInObject(this.cellComps).filter((cp)=>cp != null);
        this.destroyCells(cellsToDestroy);
    }
    setFullWidthRowComp(fullWidthRowComponent) {
        if (this.fullWidthCellRenderer) console.error("AG Grid - should not be setting fullWidthRowComponent twice");
        this.fullWidthCellRenderer = fullWidthRowComponent;
        this.addDestroyFunc(()=>{
            this.fullWidthCellRenderer = this.beans.context.destroyBean(this.fullWidthCellRenderer);
        });
    }
    getFullWidthCellRenderer() {
        return this.fullWidthCellRenderer;
    }
    destroyCells(cellComps) {
        cellComps.forEach((cellComp)=>{
            if (!cellComp) return;
            const instanceId = cellComp.getCtrl().getInstanceId();
            if (this.cellComps[instanceId] !== cellComp) return;
            cellComp.detach();
            cellComp.destroy();
            this.cellComps[instanceId] = null;
        });
    }
    refreshFullWidth(getUpdatedParams) {
        const { fullWidthCellRenderer } = this;
        if (!fullWidthCellRenderer || !fullWidthCellRenderer.refresh) return false;
        const params = getUpdatedParams();
        return fullWidthCellRenderer.refresh(params);
    }
};
// community-modules/core/src/gridBodyComp/rowContainer/rowContainerComp.ts
function templateFactory() {
    const name = Component.elementGettingCreated.getAttribute("name");
    const cssClasses = RowContainerCtrl.getRowContainerCssClasses(name);
    let res;
    const centerTemplate = name === "center" /* CENTER */  || name === "topCenter" /* TOP_CENTER */  || name === "stickyTopCenter" /* STICKY_TOP_CENTER */  || name === "bottomCenter" /* BOTTOM_CENTER */  || name === "stickyBottomCenter" /* STICKY_BOTTOM_CENTER */ ;
    if (centerTemplate) res = /* html */ `<div class="${cssClasses.viewport}" ref="eViewport" role="presentation">
                <div class="${cssClasses.container}" ref="eContainer"></div>
            </div>`;
    else res = /* html */ `<div class="${cssClasses.container}" ref="eContainer"></div>`;
    return res;
}
var RowContainerComp = class extends Component {
    constructor(){
        super(templateFactory());
        this.rowComps = {};
        this.name = Component.elementGettingCreated.getAttribute("name");
        this.type = getRowContainerTypeForName(this.name);
    }
    postConstruct() {
        const compProxy = {
            setViewportHeight: (height)=>this.eViewport.style.height = height,
            setRowCtrls: ({ rowCtrls })=>this.setRowCtrls(rowCtrls),
            setDomOrder: (domOrder)=>{
                this.domOrder = domOrder;
            },
            setContainerWidth: (width)=>this.eContainer.style.width = width
        };
        const ctrl = this.createManagedBean(new RowContainerCtrl(this.name));
        ctrl.setComp(compProxy, this.eContainer, this.eViewport);
    }
    preDestroy() {
        this.setRowCtrls([]);
    }
    setRowCtrls(rowCtrls) {
        const oldRows = __spreadValues({}, this.rowComps);
        this.rowComps = {};
        this.lastPlacedElement = null;
        const processRow = (rowCon)=>{
            const instanceId = rowCon.getInstanceId();
            const existingRowComp = oldRows[instanceId];
            if (existingRowComp) {
                this.rowComps[instanceId] = existingRowComp;
                delete oldRows[instanceId];
                this.ensureDomOrder(existingRowComp.getGui());
            } else {
                if (!rowCon.getRowNode().displayed) return;
                const rowComp = new RowComp(rowCon, this.beans, this.type);
                this.rowComps[instanceId] = rowComp;
                this.appendRow(rowComp.getGui());
            }
        };
        rowCtrls.forEach(processRow);
        getAllValuesInObject(oldRows).forEach((oldRowComp)=>{
            this.eContainer.removeChild(oldRowComp.getGui());
            oldRowComp.destroy();
        });
        setAriaRole(this.eContainer, "rowgroup");
    }
    appendRow(element) {
        if (this.domOrder) insertWithDomOrder(this.eContainer, element, this.lastPlacedElement);
        else this.eContainer.appendChild(element);
        this.lastPlacedElement = element;
    }
    ensureDomOrder(eRow) {
        if (this.domOrder) {
            ensureDomOrder(this.eContainer, eRow, this.lastPlacedElement);
            this.lastPlacedElement = eRow;
        }
    }
};
__decorateClass([
    Autowired("beans")
], RowContainerComp.prototype, "beans", 2);
__decorateClass([
    RefSelector("eViewport")
], RowContainerComp.prototype, "eViewport", 2);
__decorateClass([
    RefSelector("eContainer")
], RowContainerComp.prototype, "eContainer", 2);
__decorateClass([
    PostConstruct
], RowContainerComp.prototype, "postConstruct", 1);
__decorateClass([
    PreDestroy
], RowContainerComp.prototype, "preDestroy", 1);
// community-modules/core/src/headerRendering/columnDrag/bodyDropPivotTarget.ts
var BodyDropPivotTarget = class {
    constructor(pinned){
        this.columnsToAggregate = [];
        this.columnsToGroup = [];
        this.columnsToPivot = [];
        this.pinned = pinned;
    }
    /** Callback for when drag enters */ onDragEnter(draggingEvent) {
        this.clearColumnsList();
        if (this.gos.get("functionsReadOnly")) return;
        const dragColumns = draggingEvent.dragItem.columns;
        if (!dragColumns) return;
        dragColumns.forEach((column)=>{
            if (!column.isPrimary()) return;
            if (column.isAnyFunctionActive()) return;
            if (column.isAllowValue()) this.columnsToAggregate.push(column);
            else if (column.isAllowRowGroup()) this.columnsToGroup.push(column);
            else if (column.isAllowPivot()) this.columnsToPivot.push(column);
        });
    }
    getIconName() {
        const totalColumns = this.columnsToAggregate.length + this.columnsToGroup.length + this.columnsToPivot.length;
        if (totalColumns > 0) return this.pinned ? DragAndDropService.ICON_PINNED : DragAndDropService.ICON_MOVE;
        return null;
    }
    /** Callback for when drag leaves */ onDragLeave(draggingEvent) {
        this.clearColumnsList();
    }
    clearColumnsList() {
        this.columnsToAggregate.length = 0;
        this.columnsToGroup.length = 0;
        this.columnsToPivot.length = 0;
    }
    /** Callback for when dragging */ onDragging(draggingEvent) {}
    /** Callback for when drag stops */ onDragStop(draggingEvent) {
        if (this.columnsToAggregate.length > 0) this.columnModel.addValueColumns(this.columnsToAggregate, "toolPanelDragAndDrop");
        if (this.columnsToGroup.length > 0) this.columnModel.addRowGroupColumns(this.columnsToGroup, "toolPanelDragAndDrop");
        if (this.columnsToPivot.length > 0) this.columnModel.addPivotColumns(this.columnsToPivot, "toolPanelDragAndDrop");
    }
};
__decorateClass([
    Autowired("columnModel")
], BodyDropPivotTarget.prototype, "columnModel", 2);
__decorateClass([
    Autowired("gridOptionsService")
], BodyDropPivotTarget.prototype, "gos", 2);
// community-modules/core/src/headerRendering/columnMoveHelper.ts
var ColumnMoveHelper = class {
    static attemptMoveColumns(params) {
        const { isFromHeader, hDirection, xPosition, fromEnter, fakeEvent, pinned, gos, columnModel } = params;
        const draggingLeft = hDirection === 0 /* Left */ ;
        const draggingRight = hDirection === 1 /* Right */ ;
        let { allMovingColumns } = params;
        if (isFromHeader) {
            let newCols = [];
            allMovingColumns.forEach((col)=>{
                var _a;
                let movingGroup = null;
                let parent = col.getParent();
                while(parent != null && parent.getDisplayedLeafColumns().length === 1){
                    movingGroup = parent;
                    parent = parent.getParent();
                }
                if (movingGroup != null) {
                    const isMarryChildren = !!((_a = movingGroup.getColGroupDef()) == null ? void 0 : _a.marryChildren);
                    const columnsToMove = isMarryChildren ? movingGroup.getProvidedColumnGroup().getLeafColumns() : movingGroup.getLeafColumns();
                    columnsToMove.forEach((newCol)=>{
                        if (!newCols.includes(newCol)) newCols.push(newCol);
                    });
                } else if (!newCols.includes(col)) newCols.push(col);
            });
            allMovingColumns = newCols;
        }
        const allMovingColumnsOrdered = allMovingColumns.slice();
        columnModel.sortColumnsLikeGridColumns(allMovingColumnsOrdered);
        const validMoves = this.calculateValidMoves({
            movingCols: allMovingColumnsOrdered,
            draggingRight,
            xPosition,
            pinned,
            gos,
            columnModel
        });
        const oldIndex = this.calculateOldIndex(allMovingColumnsOrdered, columnModel);
        if (validMoves.length === 0) return;
        const firstValidMove = validMoves[0];
        let constrainDirection = oldIndex !== null && !fromEnter;
        if (isFromHeader) constrainDirection = oldIndex !== null;
        if (constrainDirection && !fakeEvent) {
            if (draggingLeft && firstValidMove >= oldIndex) return;
            if (draggingRight && firstValidMove <= oldIndex) return;
        }
        const displayedCols = columnModel.getAllDisplayedColumns();
        let potentialMoves = [];
        let targetOrder = null;
        for(let i = 0; i < validMoves.length; i++){
            const move = validMoves[i];
            const order = columnModel.getProposedColumnOrder(allMovingColumnsOrdered, move);
            if (!columnModel.doesOrderPassRules(order)) continue;
            const displayedOrder = order.filter((col)=>displayedCols.includes(col));
            if (targetOrder === null) targetOrder = displayedOrder;
            else if (!areEqual(displayedOrder, targetOrder)) break;
            const fragCount = this.groupFragCount(order);
            potentialMoves.push({
                move,
                fragCount
            });
        }
        if (potentialMoves.length === 0) return;
        potentialMoves.sort((a, b)=>a.fragCount - b.fragCount);
        return this.moveColumns(allMovingColumns, potentialMoves[0].move, "uiColumnMoved", false, columnModel);
    }
    static moveColumns(columns, toIndex, source, finished, columnModel) {
        columnModel.moveColumns(columns, toIndex, source, finished);
        return finished ? null : {
            columns,
            toIndex
        };
    }
    // returns the index of the first column in the list ONLY if the cols are all beside
    // each other. if the cols are not beside each other, then returns null
    static calculateOldIndex(movingCols, columnModel) {
        const gridCols = columnModel.getAllGridColumns();
        const indexes = sortNumerically(movingCols.map((col)=>gridCols.indexOf(col)));
        const firstIndex = indexes[0];
        const lastIndex = last(indexes);
        const spread = lastIndex - firstIndex;
        const gapsExist = spread !== indexes.length - 1;
        return gapsExist ? null : firstIndex;
    }
    // A measure of how fragmented in terms of groups an order of columns is
    static groupFragCount(columns) {
        function parents(col) {
            let result = [];
            let parent = col.getOriginalParent();
            while(parent != null){
                result.push(parent);
                parent = parent.getOriginalParent();
            }
            return result;
        }
        let count = 0;
        for(let i = 0; i < columns.length - 1; i++){
            let a = parents(columns[i]);
            let b = parents(columns[i + 1]);
            [a, b] = a.length > b.length ? [
                a,
                b
            ] : [
                b,
                a
            ];
            a.forEach((parent)=>{
                if (b.indexOf(parent) === -1) count++;
            });
        }
        return count;
    }
    static getDisplayedColumns(columnModel, type) {
        switch(type){
            case "left":
                return columnModel.getDisplayedLeftColumns();
            case "right":
                return columnModel.getDisplayedRightColumns();
            default:
                return columnModel.getDisplayedCenterColumns();
        }
    }
    static calculateValidMoves(params) {
        const { movingCols, draggingRight, xPosition, pinned, gos, columnModel } = params;
        const isMoveBlocked = gos.get("suppressMovableColumns") || movingCols.some((col)=>col.getColDef().suppressMovable);
        if (isMoveBlocked) return [];
        const allDisplayedCols = this.getDisplayedColumns(columnModel, pinned);
        const allGridCols = columnModel.getAllGridColumns();
        const movingDisplayedCols = allDisplayedCols.filter((col)=>includes(movingCols, col));
        const otherDisplayedCols = allDisplayedCols.filter((col)=>!includes(movingCols, col));
        const otherGridCols = allGridCols.filter((col)=>!includes(movingCols, col));
        let displayIndex = 0;
        let availableWidth = xPosition;
        if (draggingRight) {
            let widthOfMovingDisplayedCols = 0;
            movingDisplayedCols.forEach((col)=>widthOfMovingDisplayedCols += col.getActualWidth());
            availableWidth -= widthOfMovingDisplayedCols;
        }
        if (availableWidth > 0) {
            for(let i = 0; i < otherDisplayedCols.length; i++){
                const col = otherDisplayedCols[i];
                availableWidth -= col.getActualWidth();
                if (availableWidth < 0) break;
                displayIndex++;
            }
            if (draggingRight) displayIndex++;
        }
        let firstValidMove;
        if (displayIndex > 0) {
            const leftColumn = otherDisplayedCols[displayIndex - 1];
            firstValidMove = otherGridCols.indexOf(leftColumn) + 1;
        } else {
            firstValidMove = otherGridCols.indexOf(otherDisplayedCols[0]);
            if (firstValidMove === -1) firstValidMove = 0;
        }
        const validMoves = [
            firstValidMove
        ];
        const numberComparator = (a, b)=>a - b;
        if (draggingRight) {
            let pointer = firstValidMove + 1;
            const lastIndex = allGridCols.length - 1;
            while(pointer <= lastIndex){
                validMoves.push(pointer);
                pointer++;
            }
            validMoves.sort(numberComparator);
        } else {
            let pointer = firstValidMove;
            const lastIndex = allGridCols.length - 1;
            let displacedCol = allGridCols[pointer];
            while(pointer <= lastIndex && allDisplayedCols.indexOf(displacedCol) < 0){
                pointer++;
                validMoves.push(pointer);
                displacedCol = allGridCols[pointer];
            }
            pointer = firstValidMove - 1;
            const firstDisplayIndex = 0;
            while(pointer >= firstDisplayIndex){
                validMoves.push(pointer);
                pointer--;
            }
            validMoves.sort(numberComparator).reverse();
        }
        return validMoves;
    }
    static normaliseX(x, pinned, fromKeyboard, gos, ctrlsService) {
        const eViewport = ctrlsService.getHeaderRowContainerCtrl(pinned).getViewport();
        if (fromKeyboard) x -= eViewport.getBoundingClientRect().left;
        if (gos.get("enableRtl")) {
            const clientWidth = eViewport.clientWidth;
            x = clientWidth - x;
        }
        if (pinned == null) x += ctrlsService.get("center").getCenterViewportScrollLeft();
        return x;
    }
};
// community-modules/core/src/headerRendering/columnDrag/moveColumnFeature.ts
var MoveColumnFeature = class {
    constructor(pinned){
        this.needToMoveLeft = false;
        this.needToMoveRight = false;
        this.lastMovedInfo = null;
        this.pinned = pinned;
        this.isCenterContainer = !exists(pinned);
    }
    init() {
        this.ctrlsService.whenReady((p)=>{
            this.gridBodyCon = p.gridBodyCtrl;
        });
    }
    getIconName() {
        return this.pinned ? DragAndDropService.ICON_PINNED : DragAndDropService.ICON_MOVE;
    }
    onDragEnter(draggingEvent) {
        const columns = draggingEvent.dragItem.columns;
        const dragCameFromToolPanel = draggingEvent.dragSource.type === 0 /* ToolPanel */ ;
        if (dragCameFromToolPanel) this.setColumnsVisible(columns, true, "uiColumnDragged");
        else {
            const visibleState = draggingEvent.dragItem.visibleState;
            const visibleColumns = (columns || []).filter((column)=>visibleState[column.getId()]);
            this.setColumnsVisible(visibleColumns, true, "uiColumnDragged");
        }
        this.setColumnsPinned(columns, this.pinned, "uiColumnDragged");
        this.onDragging(draggingEvent, true, true);
    }
    onDragLeave() {
        this.ensureIntervalCleared();
        this.lastMovedInfo = null;
    }
    setColumnsVisible(columns, visible, source) {
        if (columns) {
            const allowedCols = columns.filter((c)=>!c.getColDef().lockVisible);
            this.columnModel.setColumnsVisible(allowedCols, visible, source);
        }
    }
    setColumnsPinned(columns, pinned, source) {
        if (columns) {
            const allowedCols = columns.filter((c)=>!c.getColDef().lockPinned);
            this.columnModel.setColumnsPinned(allowedCols, pinned, source);
        }
    }
    onDragStop() {
        this.onDragging(this.lastDraggingEvent, false, true, true);
        this.ensureIntervalCleared();
        this.lastMovedInfo = null;
    }
    checkCenterForScrolling(xAdjustedForScroll) {
        if (this.isCenterContainer) {
            const centerCtrl = this.ctrlsService.get("center");
            const firstVisiblePixel = centerCtrl.getCenterViewportScrollLeft();
            const lastVisiblePixel = firstVisiblePixel + centerCtrl.getCenterWidth();
            if (this.gos.get("enableRtl")) {
                this.needToMoveRight = xAdjustedForScroll < firstVisiblePixel + 50;
                this.needToMoveLeft = xAdjustedForScroll > lastVisiblePixel - 50;
            } else {
                this.needToMoveLeft = xAdjustedForScroll < firstVisiblePixel + 50;
                this.needToMoveRight = xAdjustedForScroll > lastVisiblePixel - 50;
            }
            if (this.needToMoveLeft || this.needToMoveRight) this.ensureIntervalStarted();
            else this.ensureIntervalCleared();
        }
    }
    onDragging(draggingEvent = this.lastDraggingEvent, fromEnter = false, fakeEvent = false, finished = false) {
        var _a;
        if (finished) {
            if (this.lastMovedInfo) {
                const { columns, toIndex } = this.lastMovedInfo;
                ColumnMoveHelper.moveColumns(columns, toIndex, "uiColumnMoved", true, this.columnModel);
            }
            return;
        }
        this.lastDraggingEvent = draggingEvent;
        if (missing(draggingEvent.hDirection)) return;
        const mouseX = ColumnMoveHelper.normaliseX(draggingEvent.x, this.pinned, false, this.gos, this.ctrlsService);
        if (!fromEnter) this.checkCenterForScrolling(mouseX);
        const hDirection = this.normaliseDirection(draggingEvent.hDirection);
        const dragSourceType = draggingEvent.dragSource.type;
        const allMovingColumns = ((_a = draggingEvent.dragSource.getDragItem().columns) == null ? void 0 : _a.filter((col)=>{
            if (col.getColDef().lockPinned) return col.getPinned() == this.pinned;
            return true;
        })) || [];
        const lastMovedInfo = ColumnMoveHelper.attemptMoveColumns({
            allMovingColumns,
            isFromHeader: dragSourceType === 1 /* HeaderCell */ ,
            hDirection,
            xPosition: mouseX,
            pinned: this.pinned,
            fromEnter,
            fakeEvent,
            gos: this.gos,
            columnModel: this.columnModel
        });
        if (lastMovedInfo) this.lastMovedInfo = lastMovedInfo;
    }
    normaliseDirection(hDirection) {
        if (this.gos.get("enableRtl")) switch(hDirection){
            case 0 /* Left */ :
                return 1 /* Right */ ;
            case 1 /* Right */ :
                return 0 /* Left */ ;
            default:
                console.error(`AG Grid: Unknown direction ${hDirection}`);
        }
        else return hDirection;
    }
    ensureIntervalStarted() {
        if (!this.movingIntervalId) {
            this.intervalCount = 0;
            this.failedMoveAttempts = 0;
            this.movingIntervalId = window.setInterval(this.moveInterval.bind(this), 100);
            if (this.needToMoveLeft) this.dragAndDropService.setGhostIcon(DragAndDropService.ICON_LEFT, true);
            else this.dragAndDropService.setGhostIcon(DragAndDropService.ICON_RIGHT, true);
        }
    }
    ensureIntervalCleared() {
        if (this.movingIntervalId) {
            window.clearInterval(this.movingIntervalId);
            this.movingIntervalId = null;
            this.dragAndDropService.setGhostIcon(DragAndDropService.ICON_MOVE);
        }
    }
    moveInterval() {
        let pixelsToMove;
        this.intervalCount++;
        pixelsToMove = 10 + this.intervalCount * 5;
        if (pixelsToMove > 100) pixelsToMove = 100;
        let pixelsMoved = null;
        const scrollFeature = this.gridBodyCon.getScrollFeature();
        if (this.needToMoveLeft) pixelsMoved = scrollFeature.scrollHorizontally(-pixelsToMove);
        else if (this.needToMoveRight) pixelsMoved = scrollFeature.scrollHorizontally(pixelsToMove);
        if (pixelsMoved !== 0) {
            this.onDragging(this.lastDraggingEvent);
            this.failedMoveAttempts = 0;
        } else {
            this.failedMoveAttempts++;
            const columns = this.lastDraggingEvent.dragItem.columns;
            const columnsThatCanPin = columns.filter((c)=>!c.getColDef().lockPinned);
            if (columnsThatCanPin.length > 0) {
                this.dragAndDropService.setGhostIcon(DragAndDropService.ICON_PINNED);
                if (this.failedMoveAttempts > 7) {
                    const pinType = this.needToMoveLeft ? "left" : "right";
                    this.setColumnsPinned(columnsThatCanPin, pinType, "uiColumnDragged");
                    this.dragAndDropService.nudge();
                }
            }
        }
    }
};
__decorateClass([
    Autowired("columnModel")
], MoveColumnFeature.prototype, "columnModel", 2);
__decorateClass([
    Autowired("dragAndDropService")
], MoveColumnFeature.prototype, "dragAndDropService", 2);
__decorateClass([
    Autowired("gridOptionsService")
], MoveColumnFeature.prototype, "gos", 2);
__decorateClass([
    Autowired("ctrlsService")
], MoveColumnFeature.prototype, "ctrlsService", 2);
__decorateClass([
    PostConstruct
], MoveColumnFeature.prototype, "init", 1);
// community-modules/core/src/headerRendering/columnDrag/bodyDropTarget.ts
var BodyDropTarget = class extends BeanStub {
    constructor(pinned, eContainer){
        super();
        this.pinned = pinned;
        this.eContainer = eContainer;
    }
    postConstruct() {
        this.ctrlsService.whenReady((p)=>{
            switch(this.pinned){
                case "left":
                    this.eSecondaryContainers = [
                        [
                            p.gridBodyCtrl.getBodyViewportElement(),
                            p.left.getContainerElement()
                        ],
                        [
                            p.bottomLeft.getContainerElement()
                        ],
                        [
                            p.topLeft.getContainerElement()
                        ]
                    ];
                    break;
                case "right":
                    this.eSecondaryContainers = [
                        [
                            p.gridBodyCtrl.getBodyViewportElement(),
                            p.right.getContainerElement()
                        ],
                        [
                            p.bottomRight.getContainerElement()
                        ],
                        [
                            p.topRight.getContainerElement()
                        ]
                    ];
                    break;
                default:
                    this.eSecondaryContainers = [
                        [
                            p.gridBodyCtrl.getBodyViewportElement(),
                            p.center.getViewportElement()
                        ],
                        [
                            p.bottomCenter.getViewportElement()
                        ],
                        [
                            p.topCenter.getViewportElement()
                        ]
                    ];
                    break;
            }
        });
    }
    isInterestedIn(type) {
        return type === 1 /* HeaderCell */  || type === 0 /* ToolPanel */  && this.gos.get("allowDragFromColumnsToolPanel");
    }
    getSecondaryContainers() {
        return this.eSecondaryContainers;
    }
    getContainer() {
        return this.eContainer;
    }
    init() {
        this.moveColumnFeature = this.createManagedBean(new MoveColumnFeature(this.pinned));
        this.bodyDropPivotTarget = this.createManagedBean(new BodyDropPivotTarget(this.pinned));
        this.dragAndDropService.addDropTarget(this);
    }
    getIconName() {
        return this.currentDropListener.getIconName();
    }
    // we want to use the bodyPivotTarget if the user is dragging columns in from the toolPanel
    // and we are in pivot mode, as it has to logic to set pivot/value/group on the columns when
    // dropped into the grid's body.
    isDropColumnInPivotMode(draggingEvent) {
        return this.columnModel.isPivotMode() && draggingEvent.dragSource.type === 0 /* ToolPanel */ ;
    }
    onDragEnter(draggingEvent) {
        this.currentDropListener = this.isDropColumnInPivotMode(draggingEvent) ? this.bodyDropPivotTarget : this.moveColumnFeature;
        this.currentDropListener.onDragEnter(draggingEvent);
    }
    onDragLeave(params) {
        this.currentDropListener.onDragLeave(params);
    }
    onDragging(params) {
        this.currentDropListener.onDragging(params);
    }
    onDragStop(params) {
        this.currentDropListener.onDragStop(params);
    }
};
__decorateClass([
    Autowired("dragAndDropService")
], BodyDropTarget.prototype, "dragAndDropService", 2);
__decorateClass([
    Autowired("columnModel")
], BodyDropTarget.prototype, "columnModel", 2);
__decorateClass([
    Autowired("ctrlsService")
], BodyDropTarget.prototype, "ctrlsService", 2);
__decorateClass([
    PostConstruct
], BodyDropTarget.prototype, "postConstruct", 1);
__decorateClass([
    PostConstruct
], BodyDropTarget.prototype, "init", 1);
// community-modules/core/src/headerRendering/cells/column/headerCellComp.ts
var _HeaderCellComp = class _HeaderCellComp extends AbstractHeaderCellComp {
    constructor(ctrl){
        super(_HeaderCellComp.TEMPLATE, ctrl);
        this.headerCompVersion = 0;
        this.column = ctrl.getColumnGroupChild();
        this.pinned = ctrl.getPinned();
    }
    postConstruct() {
        const eGui = this.getGui();
        const setAttribute = (name, value)=>{
            if (value != null && value != "") eGui.setAttribute(name, value);
            else eGui.removeAttribute(name);
        };
        setAttribute("col-id", this.column.getColId());
        const compProxy = {
            setWidth: (width)=>eGui.style.width = width,
            addOrRemoveCssClass: (cssClassName, on)=>this.addOrRemoveCssClass(cssClassName, on),
            setAriaSort: (sort)=>sort ? setAriaSort(eGui, sort) : removeAriaSort(eGui),
            setUserCompDetails: (compDetails)=>this.setUserCompDetails(compDetails),
            getUserCompInstance: ()=>this.headerComp
        };
        this.ctrl.setComp(compProxy, this.getGui(), this.eResize, this.eHeaderCompWrapper);
        const selectAllGui = this.ctrl.getSelectAllGui();
        this.eResize.insertAdjacentElement("afterend", selectAllGui);
    }
    destroyHeaderComp() {
        if (this.headerComp) {
            this.eHeaderCompWrapper.removeChild(this.headerCompGui);
            this.headerComp = this.destroyBean(this.headerComp);
            this.headerCompGui = void 0;
        }
    }
    setUserCompDetails(compDetails) {
        this.headerCompVersion++;
        const versionCopy = this.headerCompVersion;
        compDetails.newAgStackInstance().then((comp)=>this.afterCompCreated(versionCopy, comp));
    }
    afterCompCreated(version, headerComp) {
        if (version != this.headerCompVersion || !this.isAlive()) {
            this.destroyBean(headerComp);
            return;
        }
        this.destroyHeaderComp();
        this.headerComp = headerComp;
        this.headerCompGui = headerComp.getGui();
        this.eHeaderCompWrapper.appendChild(this.headerCompGui);
        this.ctrl.setDragSource(this.getGui());
    }
};
_HeaderCellComp.TEMPLATE = /* html */ `<div class="ag-header-cell" role="columnheader">
            <div ref="eResize" class="ag-header-cell-resize" role="presentation"></div>
            <div ref="eHeaderCompWrapper" class="ag-header-cell-comp-wrapper" role="presentation"></div>
        </div>`;
__decorateClass([
    RefSelector("eResize")
], _HeaderCellComp.prototype, "eResize", 2);
__decorateClass([
    RefSelector("eHeaderCompWrapper")
], _HeaderCellComp.prototype, "eHeaderCompWrapper", 2);
__decorateClass([
    PostConstruct
], _HeaderCellComp.prototype, "postConstruct", 1);
__decorateClass([
    PreDestroy
], _HeaderCellComp.prototype, "destroyHeaderComp", 1);
var HeaderCellComp = _HeaderCellComp;
// community-modules/core/src/headerRendering/cells/columnGroup/headerGroupCellComp.ts
var _HeaderGroupCellComp = class _HeaderGroupCellComp extends AbstractHeaderCellComp {
    constructor(ctrl){
        super(_HeaderGroupCellComp.TEMPLATE, ctrl);
    }
    postConstruct() {
        const eGui = this.getGui();
        const setAttribute = (key, value)=>value != void 0 ? eGui.setAttribute(key, value) : eGui.removeAttribute(key);
        eGui.setAttribute("col-id", this.ctrl.getColId());
        const compProxy = {
            addOrRemoveCssClass: (cssClassName, on)=>this.addOrRemoveCssClass(cssClassName, on),
            setResizableDisplayed: (displayed)=>setDisplayed(this.eResize, displayed),
            setWidth: (width)=>eGui.style.width = width,
            setAriaExpanded: (expanded)=>setAttribute("aria-expanded", expanded),
            setUserCompDetails: (details)=>this.setUserCompDetails(details),
            getUserCompInstance: ()=>this.headerGroupComp
        };
        this.ctrl.setComp(compProxy, eGui, this.eResize);
    }
    setUserCompDetails(details) {
        details.newAgStackInstance().then((comp)=>this.afterHeaderCompCreated(comp));
    }
    afterHeaderCompCreated(headerGroupComp) {
        const destroyFunc = ()=>this.destroyBean(headerGroupComp);
        if (!this.isAlive()) {
            destroyFunc();
            return;
        }
        const eGui = this.getGui();
        const eHeaderGroupGui = headerGroupComp.getGui();
        eGui.appendChild(eHeaderGroupGui);
        this.addDestroyFunc(destroyFunc);
        this.headerGroupComp = headerGroupComp;
        this.ctrl.setDragSource(eGui);
    }
};
_HeaderGroupCellComp.TEMPLATE = /* html */ `<div class="ag-header-group-cell" role="columnheader">
            <div ref="eResize" class="ag-header-cell-resize" role="presentation"></div>
        </div>`;
__decorateClass([
    RefSelector("eResize")
], _HeaderGroupCellComp.prototype, "eResize", 2);
__decorateClass([
    PostConstruct
], _HeaderGroupCellComp.prototype, "postConstruct", 1);
var HeaderGroupCellComp = _HeaderGroupCellComp;
// community-modules/core/src/headerRendering/row/headerRowComp.ts
var HeaderRowType = /* @__PURE__ */ ((HeaderRowType2)=>{
    HeaderRowType2["COLUMN_GROUP"] = "group";
    HeaderRowType2["COLUMN"] = "column";
    HeaderRowType2["FLOATING_FILTER"] = "filter";
    return HeaderRowType2;
})(HeaderRowType || {});
var HeaderRowComp = class extends Component {
    constructor(ctrl){
        super();
        this.headerComps = {};
        this.ctrl = ctrl;
        this.setTemplate(/* html */ `<div class="${this.ctrl.getHeaderRowClass()}" role="row"></div>`);
    }
    init() {
        setAriaRowIndex(this.getGui(), this.ctrl.getAriaRowIndex());
        const compProxy = {
            setHeight: (height)=>this.getGui().style.height = height,
            setTop: (top)=>this.getGui().style.top = top,
            setHeaderCtrls: (ctrls, forceOrder)=>this.setHeaderCtrls(ctrls, forceOrder),
            setWidth: (width)=>this.getGui().style.width = width
        };
        this.ctrl.setComp(compProxy);
    }
    destroyHeaderCtrls() {
        this.setHeaderCtrls([], false);
    }
    setHeaderCtrls(ctrls, forceOrder) {
        if (!this.isAlive()) return;
        const oldComps = this.headerComps;
        this.headerComps = {};
        ctrls.forEach((ctrl)=>{
            const id = ctrl.getInstanceId();
            let comp = oldComps[id];
            delete oldComps[id];
            if (comp == null) {
                comp = this.createHeaderComp(ctrl);
                this.getGui().appendChild(comp.getGui());
            }
            this.headerComps[id] = comp;
        });
        iterateObject(oldComps, (id, comp)=>{
            this.getGui().removeChild(comp.getGui());
            this.destroyBean(comp);
        });
        if (forceOrder) {
            const comps = getAllValuesInObject(this.headerComps);
            comps.sort((a, b)=>{
                const leftA = a.getCtrl().getColumnGroupChild().getLeft();
                const leftB = b.getCtrl().getColumnGroupChild().getLeft();
                return leftA - leftB;
            });
            const elementsInOrder = comps.map((c)=>c.getGui());
            setDomChildOrder(this.getGui(), elementsInOrder);
        }
    }
    createHeaderComp(headerCtrl) {
        let result;
        switch(this.ctrl.getType()){
            case "group" /* COLUMN_GROUP */ :
                result = new HeaderGroupCellComp(headerCtrl);
                break;
            case "filter" /* FLOATING_FILTER */ :
                result = new HeaderFilterCellComp(headerCtrl);
                break;
            default:
                result = new HeaderCellComp(headerCtrl);
                break;
        }
        this.createBean(result);
        result.setParentComponent(this);
        return result;
    }
};
__decorateClass([
    PostConstruct
], HeaderRowComp.prototype, "init", 1);
__decorateClass([
    PreDestroy
], HeaderRowComp.prototype, "destroyHeaderCtrls", 1);
// community-modules/core/src/headerRendering/cells/abstractCell/abstractHeaderCellCtrl.ts
var instanceIdSequence4 = 0;
var _AbstractHeaderCellCtrl = class _AbstractHeaderCellCtrl extends BeanStub {
    constructor(columnGroupChild, beans, parentRowCtrl){
        super();
        this.resizeToggleTimeout = 0;
        this.resizeMultiplier = 1;
        this.resizeFeature = null;
        this.lastFocusEvent = null;
        this.dragSource = null;
        this.columnGroupChild = columnGroupChild;
        this.parentRowCtrl = parentRowCtrl;
        this.beans = beans;
        this.instanceId = columnGroupChild.getUniqueId() + "-" + instanceIdSequence4++;
    }
    postConstruct() {
        this.addManagedPropertyListeners([
            "suppressHeaderFocus"
        ], ()=>this.refreshTabIndex());
    }
    shouldStopEventPropagation(e) {
        const { headerRowIndex, column } = this.focusService.getFocusedHeader();
        return isUserSuppressingHeaderKeyboardEvent(this.gos, e, headerRowIndex, column);
    }
    getWrapperHasFocus() {
        const activeEl = this.gos.getActiveDomElement();
        return activeEl === this.eGui;
    }
    setGui(eGui) {
        this.eGui = eGui;
        this.addDomData();
        this.addManagedListener(this.beans.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
        this.onDisplayedColumnsChanged();
        this.refreshTabIndex();
    }
    onDisplayedColumnsChanged() {
        if (!this.comp || !this.column) return;
        this.refreshFirstAndLastStyles();
        this.refreshAriaColIndex();
    }
    refreshFirstAndLastStyles() {
        const { comp, column, beans } = this;
        CssClassApplier.refreshFirstAndLastStyles(comp, column, beans.columnModel);
    }
    refreshAriaColIndex() {
        const { beans, column } = this;
        const colIdx = beans.columnModel.getAriaColumnIndex(column);
        setAriaColIndex(this.eGui, colIdx);
    }
    addResizeAndMoveKeyboardListeners() {
        if (!this.resizeFeature) return;
        this.addManagedListener(this.eGui, "keydown", this.onGuiKeyDown.bind(this));
        this.addManagedListener(this.eGui, "keyup", this.onGuiKeyUp.bind(this));
    }
    refreshTabIndex() {
        const suppressHeaderFocus = this.gos.get("suppressHeaderFocus");
        if (suppressHeaderFocus) this.eGui.removeAttribute("tabindex");
        else this.eGui.setAttribute("tabindex", "-1");
    }
    onGuiKeyDown(e) {
        var _a;
        const activeEl = this.gos.getActiveDomElement();
        const isLeftOrRight = e.key === KeyCode.LEFT || e.key === KeyCode.RIGHT;
        if (this.isResizing) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
        if (// if elements within the header are focused, we don't process the event
        activeEl !== this.eGui || // if shiftKey and altKey are not pressed, it's cell navigation so we don't process the event
        !e.shiftKey && !e.altKey) return;
        if (this.isResizing || isLeftOrRight) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
        if (!isLeftOrRight) return;
        const isLeft = e.key === KeyCode.LEFT !== this.gos.get("enableRtl");
        const direction = HorizontalDirection[isLeft ? "Left" : "Right"];
        if (e.altKey) {
            this.isResizing = true;
            this.resizeMultiplier += 1;
            const diff = this.getViewportAdjustedResizeDiff(e);
            this.resizeHeader(diff, e.shiftKey);
            (_a = this.resizeFeature) == null || _a.toggleColumnResizing(true);
        } else this.moveHeader(direction);
    }
    getViewportAdjustedResizeDiff(e) {
        let diff = this.getResizeDiff(e);
        const pinned = this.column.getPinned();
        if (pinned) {
            const leftWidth = this.pinnedWidthService.getPinnedLeftWidth();
            const rightWidth = this.pinnedWidthService.getPinnedRightWidth();
            const bodyWidth = getInnerWidth(this.ctrlsService.getGridBodyCtrl().getBodyViewportElement()) - 50;
            if (leftWidth + rightWidth + diff > bodyWidth) {
                if (bodyWidth > leftWidth + rightWidth) diff = bodyWidth - leftWidth - rightWidth;
                else return 0;
            }
        }
        return diff;
    }
    getResizeDiff(e) {
        let isLeft = e.key === KeyCode.LEFT !== this.gos.get("enableRtl");
        const pinned = this.column.getPinned();
        const isRtl = this.gos.get("enableRtl");
        if (pinned) {
            if (isRtl !== (pinned === "right")) isLeft = !isLeft;
        }
        return (isLeft ? -1 : 1) * this.resizeMultiplier;
    }
    onGuiKeyUp() {
        if (!this.isResizing) return;
        if (this.resizeToggleTimeout) {
            window.clearTimeout(this.resizeToggleTimeout);
            this.resizeToggleTimeout = 0;
        }
        this.isResizing = false;
        this.resizeMultiplier = 1;
        this.resizeToggleTimeout = setTimeout(()=>{
            var _a;
            (_a = this.resizeFeature) == null || _a.toggleColumnResizing(false);
        }, 150);
    }
    handleKeyDown(e) {
        const wrapperHasFocus = this.getWrapperHasFocus();
        switch(e.key){
            case KeyCode.PAGE_DOWN:
            case KeyCode.PAGE_UP:
            case KeyCode.PAGE_HOME:
            case KeyCode.PAGE_END:
                if (wrapperHasFocus) e.preventDefault();
        }
    }
    addDomData() {
        const key = _AbstractHeaderCellCtrl.DOM_DATA_KEY_HEADER_CTRL;
        this.gos.setDomData(this.eGui, key, this);
        this.addDestroyFunc(()=>this.gos.setDomData(this.eGui, key, null));
    }
    getGui() {
        return this.eGui;
    }
    focus(event) {
        if (!this.eGui) return false;
        this.lastFocusEvent = event || null;
        this.eGui.focus();
        return true;
    }
    getRowIndex() {
        return this.parentRowCtrl.getRowIndex();
    }
    getParentRowCtrl() {
        return this.parentRowCtrl;
    }
    getPinned() {
        return this.parentRowCtrl.getPinned();
    }
    getInstanceId() {
        return this.instanceId;
    }
    getColumnGroupChild() {
        return this.columnGroupChild;
    }
    removeDragSource() {
        if (this.dragSource) {
            this.dragAndDropService.removeDragSource(this.dragSource);
            this.dragSource = null;
        }
    }
    handleContextMenuMouseEvent(mouseEvent, touchEvent, column) {
        const event = mouseEvent != null ? mouseEvent : touchEvent;
        if (this.gos.get("preventDefaultOnContextMenu")) event.preventDefault();
        const columnToUse = column instanceof Column ? column : void 0;
        if (this.menuService.isHeaderContextMenuEnabled(columnToUse)) this.menuService.showHeaderContextMenu(columnToUse, mouseEvent, touchEvent);
        this.dispatchColumnMouseEvent(Events.EVENT_COLUMN_HEADER_CONTEXT_MENU, column);
    }
    dispatchColumnMouseEvent(eventType, column) {
        const event = {
            type: eventType,
            column
        };
        this.eventService.dispatchEvent(event);
    }
    destroy() {
        super.destroy();
        this.removeDragSource();
        this.comp = null;
        this.column = null;
        this.resizeFeature = null;
        this.lastFocusEvent = null;
        this.columnGroupChild = null;
        this.parentRowCtrl = null;
        this.eGui = null;
    }
};
_AbstractHeaderCellCtrl.DOM_DATA_KEY_HEADER_CTRL = "headerCtrl";
__decorateClass([
    Autowired("pinnedWidthService")
], _AbstractHeaderCellCtrl.prototype, "pinnedWidthService", 2);
__decorateClass([
    Autowired("focusService")
], _AbstractHeaderCellCtrl.prototype, "focusService", 2);
__decorateClass([
    Autowired("userComponentFactory")
], _AbstractHeaderCellCtrl.prototype, "userComponentFactory", 2);
__decorateClass([
    Autowired("ctrlsService")
], _AbstractHeaderCellCtrl.prototype, "ctrlsService", 2);
__decorateClass([
    Autowired("dragAndDropService")
], _AbstractHeaderCellCtrl.prototype, "dragAndDropService", 2);
__decorateClass([
    Autowired("menuService")
], _AbstractHeaderCellCtrl.prototype, "menuService", 2);
__decorateClass([
    PostConstruct
], _AbstractHeaderCellCtrl.prototype, "postConstruct", 1);
var AbstractHeaderCellCtrl = _AbstractHeaderCellCtrl;
// community-modules/core/src/rendering/features/setLeftFeature.ts
var SetLeftFeature = class extends BeanStub {
    constructor(columnOrGroup, eCell, beans, colsSpanning){
        super();
        this.columnOrGroup = columnOrGroup;
        this.eCell = eCell;
        this.ariaEl = this.eCell.querySelector("[role=columnheader]") || this.eCell;
        this.colsSpanning = colsSpanning;
        this.beans = beans;
    }
    setColsSpanning(colsSpanning) {
        this.colsSpanning = colsSpanning;
        this.onLeftChanged();
    }
    getColumnOrGroup() {
        if (this.beans.gos.get("enableRtl") && this.colsSpanning) return last(this.colsSpanning);
        return this.columnOrGroup;
    }
    postConstruct() {
        this.addManagedListener(this.columnOrGroup, Column.EVENT_LEFT_CHANGED, this.onLeftChanged.bind(this));
        this.setLeftFirstTime();
        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onLeftChanged.bind(this));
        this.addManagedPropertyListener("domLayout", this.onLeftChanged.bind(this));
    }
    setLeftFirstTime() {
        const suppressMoveAnimation = this.beans.gos.get("suppressColumnMoveAnimation");
        const oldLeftExists = exists(this.columnOrGroup.getOldLeft());
        const animateColumnMove = this.beans.columnAnimationService.isActive() && oldLeftExists && !suppressMoveAnimation;
        if (animateColumnMove) this.animateInLeft();
        else this.onLeftChanged();
    }
    animateInLeft() {
        const colOrGroup = this.getColumnOrGroup();
        const left = colOrGroup.getLeft();
        const oldLeft = colOrGroup.getOldLeft();
        const oldActualLeft = this.modifyLeftForPrintLayout(colOrGroup, oldLeft);
        const actualLeft = this.modifyLeftForPrintLayout(colOrGroup, left);
        this.setLeft(oldActualLeft);
        this.actualLeft = actualLeft;
        this.beans.columnAnimationService.executeNextVMTurn(()=>{
            if (this.actualLeft === actualLeft) this.setLeft(actualLeft);
        });
    }
    onLeftChanged() {
        const colOrGroup = this.getColumnOrGroup();
        const left = colOrGroup.getLeft();
        this.actualLeft = this.modifyLeftForPrintLayout(colOrGroup, left);
        this.setLeft(this.actualLeft);
    }
    modifyLeftForPrintLayout(colOrGroup, leftPosition) {
        const printLayout = this.beans.gos.isDomLayout("print");
        if (!printLayout) return leftPosition;
        if (colOrGroup.getPinned() === "left") return leftPosition;
        const leftWidth = this.beans.columnModel.getDisplayedColumnsLeftWidth();
        if (colOrGroup.getPinned() === "right") {
            const bodyWidth = this.beans.columnModel.getBodyContainerWidth();
            return leftWidth + bodyWidth + leftPosition;
        }
        return leftWidth + leftPosition;
    }
    setLeft(value) {
        if (exists(value)) this.eCell.style.left = `${value}px`;
        let indexColumn;
        if (this.columnOrGroup instanceof Column) indexColumn = this.columnOrGroup;
        else {
            const columnGroup = this.columnOrGroup;
            const children = columnGroup.getLeafColumns();
            if (!children.length) return;
            if (children.length > 1) setAriaColSpan(this.ariaEl, children.length);
            indexColumn = children[0];
        }
    }
};
__decorateClass([
    PostConstruct
], SetLeftFeature.prototype, "postConstruct", 1);
// community-modules/core/src/headerRendering/cells/hoverFeature.ts
var HoverFeature = class extends BeanStub {
    constructor(columns, element){
        super();
        this.columns = columns;
        this.element = element;
    }
    postConstruct() {
        if (this.gos.get("columnHoverHighlight")) this.addMouseHoverListeners();
    }
    addMouseHoverListeners() {
        this.addManagedListener(this.element, "mouseout", this.onMouseOut.bind(this));
        this.addManagedListener(this.element, "mouseover", this.onMouseOver.bind(this));
    }
    onMouseOut() {
        this.columnHoverService.clearMouseOver();
    }
    onMouseOver() {
        this.columnHoverService.setMouseOver(this.columns);
    }
};
__decorateClass([
    Autowired("columnHoverService")
], HoverFeature.prototype, "columnHoverService", 2);
__decorateClass([
    PostConstruct
], HoverFeature.prototype, "postConstruct", 1);
// community-modules/core/src/headerRendering/cells/floatingFilter/headerFilterCellCtrl.ts
var HeaderFilterCellCtrl = class extends AbstractHeaderCellCtrl {
    constructor(column, beans, parentRowCtrl){
        super(column, beans, parentRowCtrl);
        this.iconCreated = false;
        this.column = column;
    }
    setComp(comp, eGui, eButtonShowMainFilter, eFloatingFilterBody) {
        this.comp = comp;
        this.eButtonShowMainFilter = eButtonShowMainFilter;
        this.eFloatingFilterBody = eFloatingFilterBody;
        this.setGui(eGui);
        this.setupActive();
        this.setupWidth();
        this.setupLeft();
        this.setupHover();
        this.setupFocus();
        this.setupAria();
        this.setupFilterButton();
        this.setupUserComp();
        this.setupSyncWithFilter();
        this.setupUi();
        this.addManagedListener(this.eButtonShowMainFilter, "click", this.showParentFilter.bind(this));
        this.setupFilterChangedListener();
        this.addManagedListener(this.column, Column.EVENT_COL_DEF_CHANGED, this.onColDefChanged.bind(this));
    }
    // empty abstract method
    resizeHeader() {}
    // empty abstract method
    moveHeader() {}
    setupActive() {
        const colDef = this.column.getColDef();
        const filterExists = !!colDef.filter;
        const floatingFilterExists = !!colDef.floatingFilter;
        this.active = filterExists && floatingFilterExists;
    }
    setupUi() {
        this.comp.setButtonWrapperDisplayed(!this.suppressFilterButton && this.active);
        this.comp.addOrRemoveBodyCssClass("ag-floating-filter-full-body", this.suppressFilterButton);
        this.comp.addOrRemoveBodyCssClass("ag-floating-filter-body", !this.suppressFilterButton);
        if (!this.active || this.iconCreated) return;
        const eMenuIcon = createIconNoSpan("filter", this.gos, this.column);
        if (eMenuIcon) {
            this.iconCreated = true;
            this.eButtonShowMainFilter.appendChild(eMenuIcon);
        }
    }
    setupFocus() {
        this.createManagedBean(new ManagedFocusFeature(this.eGui, {
            shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this),
            onTabKeyDown: this.onTabKeyDown.bind(this),
            handleKeyDown: this.handleKeyDown.bind(this),
            onFocusIn: this.onFocusIn.bind(this)
        }));
    }
    setupAria() {
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        setAriaLabel(this.eButtonShowMainFilter, localeTextFunc("ariaFilterMenuOpen", "Open Filter Menu"));
    }
    onTabKeyDown(e) {
        const activeEl = this.gos.getActiveDomElement();
        const wrapperHasFocus = activeEl === this.eGui;
        if (wrapperHasFocus) return;
        const nextFocusableEl = this.focusService.findNextFocusableElement(this.eGui, null, e.shiftKey);
        if (nextFocusableEl) {
            this.beans.headerNavigationService.scrollToColumn(this.column);
            e.preventDefault();
            nextFocusableEl.focus();
            return;
        }
        const nextFocusableColumn = this.findNextColumnWithFloatingFilter(e.shiftKey);
        if (!nextFocusableColumn) return;
        if (this.focusService.focusHeaderPosition({
            headerPosition: {
                headerRowIndex: this.getParentRowCtrl().getRowIndex(),
                column: nextFocusableColumn
            },
            event: e
        })) e.preventDefault();
    }
    findNextColumnWithFloatingFilter(backwards) {
        const columnModel = this.beans.columnModel;
        let nextCol = this.column;
        do {
            nextCol = backwards ? columnModel.getDisplayedColBefore(nextCol) : columnModel.getDisplayedColAfter(nextCol);
            if (!nextCol) break;
        }while (!nextCol.getColDef().filter || !nextCol.getColDef().floatingFilter);
        return nextCol;
    }
    handleKeyDown(e) {
        super.handleKeyDown(e);
        const wrapperHasFocus = this.getWrapperHasFocus();
        switch(e.key){
            case KeyCode.UP:
            case KeyCode.DOWN:
                if (!wrapperHasFocus) e.preventDefault();
            case KeyCode.LEFT:
            case KeyCode.RIGHT:
                if (wrapperHasFocus) return;
                e.stopPropagation();
            case KeyCode.ENTER:
                if (wrapperHasFocus) {
                    if (this.focusService.focusInto(this.eGui)) e.preventDefault();
                }
                break;
            case KeyCode.ESCAPE:
                if (!wrapperHasFocus) this.eGui.focus();
        }
    }
    onFocusIn(e) {
        const isRelatedWithin = this.eGui.contains(e.relatedTarget);
        if (isRelatedWithin) return;
        const notFromHeaderWrapper = !!e.relatedTarget && !e.relatedTarget.classList.contains("ag-floating-filter");
        const fromWithinHeader = !!e.relatedTarget && isElementChildOfClass(e.relatedTarget, "ag-floating-filter");
        if (notFromHeaderWrapper && fromWithinHeader && e.target === this.eGui) {
            const lastFocusEvent = this.lastFocusEvent;
            const fromTab = !!(lastFocusEvent && lastFocusEvent.key === KeyCode.TAB);
            if (lastFocusEvent && fromTab) {
                const shouldFocusLast = lastFocusEvent.shiftKey;
                this.focusService.focusInto(this.eGui, shouldFocusLast);
            }
        }
        const rowIndex = this.getRowIndex();
        this.beans.focusService.setFocusedHeader(rowIndex, this.column);
    }
    setupHover() {
        this.createManagedBean(new HoverFeature([
            this.column
        ], this.eGui));
        const listener = ()=>{
            if (!this.gos.get("columnHoverHighlight")) return;
            const hovered = this.beans.columnHoverService.isHovered(this.column);
            this.comp.addOrRemoveCssClass("ag-column-hover", hovered);
        };
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_HOVER_CHANGED, listener);
        listener();
    }
    setupLeft() {
        const setLeftFeature = new SetLeftFeature(this.column, this.eGui, this.beans);
        this.createManagedBean(setLeftFeature);
    }
    setupFilterButton() {
        this.suppressFilterButton = !this.menuService.isFloatingFilterButtonEnabled(this.column);
        this.highlightFilterButtonWhenActive = !this.menuService.isLegacyMenuEnabled();
    }
    setupUserComp() {
        if (!this.active) return;
        const compDetails = this.beans.filterManager.getFloatingFilterCompDetails(this.column, ()=>this.showParentFilter());
        if (compDetails) this.setCompDetails(compDetails);
    }
    setCompDetails(compDetails) {
        this.userCompDetails = compDetails;
        this.comp.setCompDetails(compDetails);
    }
    showParentFilter() {
        const eventSource = this.suppressFilterButton ? this.eFloatingFilterBody : this.eButtonShowMainFilter;
        this.menuService.showFilterMenu({
            column: this.column,
            buttonElement: eventSource,
            containerType: "floatingFilter",
            positionBy: "button"
        });
    }
    setupSyncWithFilter() {
        if (!this.active) return;
        const { filterManager } = this.beans;
        const syncWithFilter = (event)=>{
            if ((event == null ? void 0 : event.source) === "filterDestroyed" && this.context.isDestroyed()) return;
            const compPromise = this.comp.getFloatingFilterComp();
            if (!compPromise) return;
            compPromise.then((comp)=>{
                var _a;
                if (comp) {
                    const parentModel = filterManager.getCurrentFloatingFilterParentModel(this.column);
                    comp.onParentModelChanged(parentModel, event ? this.gos.addGridCommonParams({
                        columns: (_a = event.columns) != null ? _a : [],
                        type: Events.EVENT_FILTER_CHANGED,
                        source: event.source === "api" ? "api" : "columnFilter"
                    }) : null);
                }
            });
        };
        this.destroySyncListener = this.addManagedListener(this.column, Column.EVENT_FILTER_CHANGED, syncWithFilter);
        if (filterManager.isFilterActive(this.column)) syncWithFilter(null);
    }
    setupWidth() {
        const listener = ()=>{
            const width = `${this.column.getActualWidth()}px`;
            this.comp.setWidth(width);
        };
        this.addManagedListener(this.column, Column.EVENT_WIDTH_CHANGED, listener);
        listener();
    }
    setupFilterChangedListener() {
        if (this.active) {
            this.destroyFilterChangedListener = this.addManagedListener(this.column, Column.EVENT_FILTER_CHANGED, this.updateFilterButton.bind(this));
            this.updateFilterButton();
        }
    }
    updateFilterButton() {
        if (!this.suppressFilterButton && this.comp) {
            const isFilterAllowed = this.beans.filterManager.isFilterAllowed(this.column);
            this.comp.setButtonWrapperDisplayed(isFilterAllowed);
            if (this.highlightFilterButtonWhenActive && isFilterAllowed) this.eButtonShowMainFilter.classList.toggle("ag-filter-active", this.column.isFilterActive());
        }
    }
    onColDefChanged() {
        var _a, _b;
        const wasActive = this.active;
        this.setupActive();
        const becomeActive = !wasActive && this.active;
        if (wasActive && !this.active) {
            (_a = this.destroySyncListener) == null || _a.call(this);
            (_b = this.destroyFilterChangedListener) == null || _b.call(this);
        }
        const newCompDetails = this.active ? this.beans.filterManager.getFloatingFilterCompDetails(this.column, ()=>this.showParentFilter()) : null;
        const compPromise = this.comp.getFloatingFilterComp();
        if (!compPromise || !newCompDetails) this.updateCompDetails(newCompDetails, becomeActive);
        else compPromise.then((compInstance)=>{
            var _a2;
            if (!compInstance || this.beans.filterManager.areFilterCompsDifferent((_a2 = this.userCompDetails) != null ? _a2 : null, newCompDetails)) this.updateCompDetails(newCompDetails, becomeActive);
            else this.updateFloatingFilterParams(newCompDetails);
        });
    }
    updateCompDetails(compDetails, becomeActive) {
        if (!this.isAlive()) return;
        this.setCompDetails(compDetails);
        this.setupFilterButton();
        this.setupUi();
        if (becomeActive) {
            this.setupSyncWithFilter();
            this.setupFilterChangedListener();
        }
    }
    updateFloatingFilterParams(userCompDetails) {
        var _a;
        if (!userCompDetails) return;
        const params = userCompDetails.params;
        (_a = this.comp.getFloatingFilterComp()) == null || _a.then((floatingFilter)=>{
            let hasRefreshed = false;
            if ((floatingFilter == null ? void 0 : floatingFilter.refresh) && typeof floatingFilter.refresh === "function") {
                const result = floatingFilter.refresh(params);
                if (result !== null) hasRefreshed = true;
            }
            if (!hasRefreshed && (floatingFilter == null ? void 0 : floatingFilter.onParamsUpdated) && typeof floatingFilter.onParamsUpdated === "function") {
                const result = floatingFilter.onParamsUpdated(params);
                if (result !== null) warnOnce(`Custom floating filter method 'onParamsUpdated' is deprecated. Use 'refresh' instead.`);
            }
        });
    }
    destroy() {
        super.destroy();
        this.eButtonShowMainFilter = null;
        this.eFloatingFilterBody = null;
        this.userCompDetails = null;
        this.destroySyncListener = null;
        this.destroyFilterChangedListener = null;
    }
};
// community-modules/core/src/headerRendering/cells/column/resizeFeature.ts
var ResizeFeature = class extends BeanStub {
    constructor(pinned, column, eResize, comp, ctrl){
        super();
        this.pinned = pinned;
        this.column = column;
        this.eResize = eResize;
        this.comp = comp;
        this.ctrl = ctrl;
    }
    postConstruct() {
        const destroyResizeFuncs = [];
        let canResize;
        let canAutosize;
        const addResize = ()=>{
            setDisplayed(this.eResize, canResize);
            if (!canResize) return;
            const finishedWithResizeFunc = this.horizontalResizeService.addResizeBar({
                eResizeBar: this.eResize,
                onResizeStart: this.onResizeStart.bind(this),
                onResizing: this.onResizing.bind(this, false),
                onResizeEnd: this.onResizing.bind(this, true)
            });
            destroyResizeFuncs.push(finishedWithResizeFunc);
            if (canAutosize) {
                const skipHeaderOnAutoSize = this.gos.get("skipHeaderOnAutoSize");
                const autoSizeColListener = ()=>{
                    this.columnModel.autoSizeColumn(this.column, "uiColumnResized", skipHeaderOnAutoSize);
                };
                this.eResize.addEventListener("dblclick", autoSizeColListener);
                const touchListener = new TouchListener(this.eResize);
                touchListener.addEventListener(TouchListener.EVENT_DOUBLE_TAP, autoSizeColListener);
                destroyResizeFuncs.push(()=>{
                    this.eResize.removeEventListener("dblclick", autoSizeColListener);
                    touchListener.removeEventListener(TouchListener.EVENT_DOUBLE_TAP, autoSizeColListener);
                    touchListener.destroy();
                });
            }
        };
        const removeResize = ()=>{
            destroyResizeFuncs.forEach((f)=>f());
            destroyResizeFuncs.length = 0;
        };
        const refresh = ()=>{
            const resize = this.column.isResizable();
            const autoSize = !this.gos.get("suppressAutoSize") && !this.column.getColDef().suppressAutoSize;
            const propertyChange = resize !== canResize || autoSize !== canAutosize;
            if (propertyChange) {
                canResize = resize;
                canAutosize = autoSize;
                removeResize();
                addResize();
            }
        };
        refresh();
        this.addDestroyFunc(removeResize);
        this.ctrl.addRefreshFunction(refresh);
    }
    onResizing(finished, resizeAmount) {
        const { column: key, lastResizeAmount, resizeStartWidth } = this;
        const resizeAmountNormalised = this.normaliseResizeAmount(resizeAmount);
        const newWidth = resizeStartWidth + resizeAmountNormalised;
        const columnWidths = [
            {
                key,
                newWidth
            }
        ];
        if (this.column.getPinned()) {
            const leftWidth = this.pinnedWidthService.getPinnedLeftWidth();
            const rightWidth = this.pinnedWidthService.getPinnedRightWidth();
            const bodyWidth = getInnerWidth(this.ctrlsService.getGridBodyCtrl().getBodyViewportElement()) - 50;
            if (leftWidth + rightWidth + (resizeAmountNormalised - lastResizeAmount) > bodyWidth) return;
        }
        this.lastResizeAmount = resizeAmountNormalised;
        this.columnModel.setColumnWidths(columnWidths, this.resizeWithShiftKey, finished, "uiColumnResized");
        if (finished) this.toggleColumnResizing(false);
    }
    onResizeStart(shiftKey) {
        this.resizeStartWidth = this.column.getActualWidth();
        this.lastResizeAmount = 0;
        this.resizeWithShiftKey = shiftKey;
        this.toggleColumnResizing(true);
    }
    toggleColumnResizing(resizing) {
        this.comp.addOrRemoveCssClass("ag-column-resizing", resizing);
    }
    // optionally inverts the drag, depending on pinned and RTL
    // note - this method is duplicated in RenderedHeaderGroupCell - should refactor out?
    normaliseResizeAmount(dragChange) {
        let result = dragChange;
        const notPinningLeft = this.pinned !== "left";
        const pinningRight = this.pinned === "right";
        if (this.gos.get("enableRtl")) {
            if (notPinningLeft) result *= -1;
        } else if (pinningRight) result *= -1;
        return result;
    }
};
__decorateClass([
    Autowired("horizontalResizeService")
], ResizeFeature.prototype, "horizontalResizeService", 2);
__decorateClass([
    Autowired("pinnedWidthService")
], ResizeFeature.prototype, "pinnedWidthService", 2);
__decorateClass([
    Autowired("ctrlsService")
], ResizeFeature.prototype, "ctrlsService", 2);
__decorateClass([
    Autowired("columnModel")
], ResizeFeature.prototype, "columnModel", 2);
__decorateClass([
    PostConstruct
], ResizeFeature.prototype, "postConstruct", 1);
// community-modules/core/src/headerRendering/cells/column/selectAllFeature.ts
var SelectAllFeature = class extends BeanStub {
    constructor(column){
        super();
        this.cbSelectAllVisible = false;
        this.processingEventFromCheckbox = false;
        this.column = column;
    }
    onSpaceKeyDown(e) {
        const checkbox = this.cbSelectAll;
        if (checkbox.isDisplayed() && !checkbox.getGui().contains(this.gos.getActiveDomElement())) {
            e.preventDefault();
            checkbox.setValue(!checkbox.getValue());
        }
    }
    getCheckboxGui() {
        return this.cbSelectAll.getGui();
    }
    setComp(ctrl) {
        this.headerCellCtrl = ctrl;
        this.cbSelectAll = this.createManagedBean(new AgCheckbox());
        this.cbSelectAll.addCssClass("ag-header-select-all");
        setAriaRole(this.cbSelectAll.getGui(), "presentation");
        this.showOrHideSelectAll();
        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.onNewColumnsLoaded.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_SELECTION_CHANGED, this.onSelectionChanged.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_PAGINATION_CHANGED, this.onSelectionChanged.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_MODEL_UPDATED, this.onModelChanged.bind(this));
        this.addManagedListener(this.cbSelectAll, Events.EVENT_FIELD_VALUE_CHANGED, this.onCbSelectAll.bind(this));
        setAriaHidden(this.cbSelectAll.getGui(), true);
        this.cbSelectAll.getInputElement().setAttribute("tabindex", "-1");
        this.refreshSelectAllLabel();
    }
    onNewColumnsLoaded() {
        this.showOrHideSelectAll();
    }
    onDisplayedColumnsChanged() {
        if (!this.isAlive()) return;
        this.showOrHideSelectAll();
    }
    showOrHideSelectAll() {
        this.cbSelectAllVisible = this.isCheckboxSelection();
        this.cbSelectAll.setDisplayed(this.cbSelectAllVisible, {
            skipAriaHidden: true
        });
        if (this.cbSelectAllVisible) {
            this.checkRightRowModelType("selectAllCheckbox");
            this.checkSelectionType("selectAllCheckbox");
            this.updateStateOfCheckbox();
        }
        this.refreshSelectAllLabel();
    }
    onModelChanged() {
        if (!this.cbSelectAllVisible) return;
        this.updateStateOfCheckbox();
    }
    onSelectionChanged() {
        if (!this.cbSelectAllVisible) return;
        this.updateStateOfCheckbox();
    }
    updateStateOfCheckbox() {
        if (this.processingEventFromCheckbox) return;
        this.processingEventFromCheckbox = true;
        const allSelected = this.selectionService.getSelectAllState(this.isFilteredOnly(), this.isCurrentPageOnly());
        this.cbSelectAll.setValue(allSelected);
        const hasNodesToSelect = this.selectionService.hasNodesToSelect(this.isFilteredOnly(), this.isCurrentPageOnly());
        this.cbSelectAll.setDisabled(!hasNodesToSelect);
        this.refreshSelectAllLabel();
        this.processingEventFromCheckbox = false;
    }
    refreshSelectAllLabel() {
        const translate = this.localeService.getLocaleTextFunc();
        const checked = this.cbSelectAll.getValue();
        const ariaStatus = checked ? translate("ariaChecked", "checked") : translate("ariaUnchecked", "unchecked");
        const ariaLabel = translate("ariaRowSelectAll", "Press Space to toggle all rows selection");
        if (!this.cbSelectAllVisible) this.headerCellCtrl.setAriaDescriptionProperty("selectAll", null);
        else this.headerCellCtrl.setAriaDescriptionProperty("selectAll", `${ariaLabel} (${ariaStatus})`);
        this.cbSelectAll.setInputAriaLabel(`${ariaLabel} (${ariaStatus})`);
        this.headerCellCtrl.announceAriaDescription();
    }
    checkSelectionType(feature) {
        const isMultiSelect = this.gos.get("rowSelection") === "multiple";
        if (!isMultiSelect) {
            console.warn(`AG Grid: ${feature} is only available if using 'multiple' rowSelection.`);
            return false;
        }
        return true;
    }
    checkRightRowModelType(feature) {
        const rowModelType = this.rowModel.getType();
        const rowModelMatches = rowModelType === "clientSide" || rowModelType === "serverSide";
        if (!rowModelMatches) {
            console.warn(`AG Grid: ${feature} is only available if using 'clientSide' or 'serverSide' rowModelType, you are using ${rowModelType}.`);
            return false;
        }
        return true;
    }
    onCbSelectAll() {
        if (this.processingEventFromCheckbox) return;
        if (!this.cbSelectAllVisible) return;
        const value = this.cbSelectAll.getValue();
        const justFiltered = this.isFilteredOnly();
        const justCurrentPage = this.isCurrentPageOnly();
        let source = "uiSelectAll";
        if (justCurrentPage) source = "uiSelectAllCurrentPage";
        else if (justFiltered) source = "uiSelectAllFiltered";
        const params = {
            source,
            justFiltered,
            justCurrentPage
        };
        if (value) this.selectionService.selectAllRowNodes(params);
        else this.selectionService.deselectAllRowNodes(params);
    }
    isCheckboxSelection() {
        let result = this.column.getColDef().headerCheckboxSelection;
        if (typeof result === "function") {
            const func = result;
            const params = this.gos.addGridCommonParams({
                column: this.column,
                colDef: this.column.getColDef()
            });
            result = func(params);
        }
        if (result) return this.checkRightRowModelType("headerCheckboxSelection") && this.checkSelectionType("headerCheckboxSelection");
        return false;
    }
    isFilteredOnly() {
        return !!this.column.getColDef().headerCheckboxSelectionFilteredOnly;
    }
    isCurrentPageOnly() {
        return !!this.column.getColDef().headerCheckboxSelectionCurrentPageOnly;
    }
};
__decorateClass([
    Autowired("rowModel")
], SelectAllFeature.prototype, "rowModel", 2);
__decorateClass([
    Autowired("selectionService")
], SelectAllFeature.prototype, "selectionService", 2);
// community-modules/core/src/headerRendering/cells/column/headerCellCtrl.ts
var HeaderCellCtrl = class extends AbstractHeaderCellCtrl {
    constructor(column, beans, parentRowCtrl){
        super(column, beans, parentRowCtrl);
        this.refreshFunctions = [];
        this.userHeaderClasses = /* @__PURE__ */ new Set();
        this.ariaDescriptionProperties = /* @__PURE__ */ new Map();
        this.column = column;
    }
    setComp(comp, eGui, eResize, eHeaderCompWrapper) {
        this.comp = comp;
        this.setGui(eGui);
        this.updateState();
        this.setupWidth();
        this.setupMovingCss();
        this.setupMenuClass();
        this.setupSortableClass();
        this.setupWrapTextClass();
        this.refreshSpanHeaderHeight();
        this.setupAutoHeight(eHeaderCompWrapper);
        this.addColumnHoverListener();
        this.setupFilterClass();
        this.setupClassesFromColDef();
        this.setupTooltip();
        this.addActiveHeaderMouseListeners();
        this.setupSelectAll();
        this.setupUserComp();
        this.refreshAria();
        this.resizeFeature = this.createManagedBean(new ResizeFeature(this.getPinned(), this.column, eResize, comp, this));
        this.createManagedBean(new HoverFeature([
            this.column
        ], eGui));
        this.createManagedBean(new SetLeftFeature(this.column, eGui, this.beans));
        this.createManagedBean(new ManagedFocusFeature(eGui, {
            shouldStopEventPropagation: (e)=>this.shouldStopEventPropagation(e),
            onTabKeyDown: ()=>null,
            handleKeyDown: this.handleKeyDown.bind(this),
            onFocusIn: this.onFocusIn.bind(this),
            onFocusOut: this.onFocusOut.bind(this)
        }));
        this.addResizeAndMoveKeyboardListeners();
        this.addManagedPropertyListeners([
            "suppressMovableColumns",
            "suppressMenuHide",
            "suppressAggFuncInHeader"
        ], this.refresh.bind(this));
        this.addManagedListener(this.column, Column.EVENT_COL_DEF_CHANGED, this.refresh.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_VALUE_CHANGED, this.onColumnValueChanged.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.onColumnRowGroupChanged.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_CHANGED, this.onColumnPivotChanged.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_HEADER_HEIGHT_CHANGED, this.onHeaderHeightChanged.bind(this));
    }
    resizeHeader(delta, shiftKey) {
        var _a, _b;
        if (!this.column.isResizable()) return;
        const actualWidth = this.column.getActualWidth();
        const minWidth = (_a = this.column.getMinWidth()) != null ? _a : 0;
        const maxWidth = (_b = this.column.getMaxWidth()) != null ? _b : Number.MAX_SAFE_INTEGER;
        const newWidth = Math.min(Math.max(actualWidth + delta, minWidth), maxWidth);
        this.beans.columnModel.setColumnWidths([
            {
                key: this.column,
                newWidth
            }
        ], shiftKey, true, "uiColumnResized");
    }
    moveHeader(hDirection) {
        const { eGui, column, gos, ctrlsService } = this;
        const pinned = this.getPinned();
        const left = eGui.getBoundingClientRect().left;
        const width = column.getActualWidth();
        const isRtl = gos.get("enableRtl");
        const isLeft = hDirection === 0 /* Left */  !== isRtl;
        const xPosition = ColumnMoveHelper.normaliseX(isLeft ? left - 20 : left + width + 20, pinned, true, gos, ctrlsService);
        ColumnMoveHelper.attemptMoveColumns({
            allMovingColumns: [
                column
            ],
            isFromHeader: true,
            hDirection,
            xPosition,
            pinned,
            fromEnter: false,
            fakeEvent: false,
            gos,
            columnModel: this.beans.columnModel
        });
        ctrlsService.getGridBodyCtrl().getScrollFeature().ensureColumnVisible(column, "auto");
    }
    setupUserComp() {
        const compDetails = this.lookupUserCompDetails();
        this.setCompDetails(compDetails);
    }
    setCompDetails(compDetails) {
        this.userCompDetails = compDetails;
        this.comp.setUserCompDetails(compDetails);
    }
    lookupUserCompDetails() {
        const params = this.createParams();
        const colDef = this.column.getColDef();
        return this.userComponentFactory.getHeaderCompDetails(colDef, params);
    }
    createParams() {
        const params = this.gos.addGridCommonParams({
            column: this.column,
            displayName: this.displayName,
            enableSorting: this.column.isSortable(),
            enableMenu: this.menuEnabled,
            enableFilterButton: this.openFilterEnabled && this.menuService.isHeaderFilterButtonEnabled(this.column),
            enableFilterIcon: !this.openFilterEnabled || this.menuService.isLegacyMenuEnabled(),
            showColumnMenu: (buttonElement)=>{
                this.menuService.showColumnMenu({
                    column: this.column,
                    buttonElement,
                    positionBy: "button"
                });
            },
            showColumnMenuAfterMouseClick: (mouseEvent)=>{
                this.menuService.showColumnMenu({
                    column: this.column,
                    mouseEvent,
                    positionBy: "mouse"
                });
            },
            showFilter: (buttonElement)=>{
                this.menuService.showFilterMenu({
                    column: this.column,
                    buttonElement,
                    containerType: "columnFilter",
                    positionBy: "button"
                });
            },
            progressSort: (multiSort)=>{
                this.beans.sortController.progressSort(this.column, !!multiSort, "uiColumnSorted");
            },
            setSort: (sort, multiSort)=>{
                this.beans.sortController.setSortForColumn(this.column, sort, !!multiSort, "uiColumnSorted");
            },
            eGridHeader: this.getGui(),
            setTooltip: (value, shouldDisplayTooltip)=>{
                this.setupTooltip(value, shouldDisplayTooltip);
            }
        });
        return params;
    }
    setupSelectAll() {
        this.selectAllFeature = this.createManagedBean(new SelectAllFeature(this.column));
        this.selectAllFeature.setComp(this);
    }
    getSelectAllGui() {
        return this.selectAllFeature.getCheckboxGui();
    }
    handleKeyDown(e) {
        super.handleKeyDown(e);
        if (e.key === KeyCode.SPACE) this.selectAllFeature.onSpaceKeyDown(e);
        if (e.key === KeyCode.ENTER) this.onEnterKeyDown(e);
        if (e.key === KeyCode.DOWN && e.altKey) this.showMenuOnKeyPress(e, false);
    }
    onEnterKeyDown(e) {
        if (e.ctrlKey || e.metaKey) this.showMenuOnKeyPress(e, true);
        else if (this.sortable) {
            const multiSort = e.shiftKey;
            this.beans.sortController.progressSort(this.column, multiSort, "uiColumnSorted");
        }
    }
    showMenuOnKeyPress(e, isFilterShortcut) {
        const headerComp = this.comp.getUserCompInstance();
        if (!headerComp || !(headerComp instanceof HeaderComp)) return;
        if (headerComp.onMenuKeyboardShortcut(isFilterShortcut)) e.preventDefault();
    }
    onFocusIn(e) {
        if (!this.getGui().contains(e.relatedTarget)) {
            const rowIndex = this.getRowIndex();
            this.focusService.setFocusedHeader(rowIndex, this.column);
            this.announceAriaDescription();
        }
        if (this.focusService.isKeyboardMode()) this.setActiveHeader(true);
    }
    onFocusOut(e) {
        if (this.getGui().contains(e.relatedTarget)) return;
        this.setActiveHeader(false);
    }
    setupTooltip(value, shouldDisplayTooltip) {
        if (this.tooltipFeature) this.tooltipFeature = this.destroyBean(this.tooltipFeature);
        const isTooltipWhenTruncated = this.gos.get("tooltipShowMode") === "whenTruncated";
        const eGui = this.eGui;
        const colDef = this.column.getColDef();
        if (!shouldDisplayTooltip && isTooltipWhenTruncated && !colDef.headerComponent) shouldDisplayTooltip = ()=>{
            const textEl = eGui.querySelector(".ag-header-cell-text");
            if (!textEl) return true;
            return textEl.scrollWidth > textEl.clientWidth;
        };
        const tooltipCtrl = {
            getColumn: ()=>this.column,
            getColDef: ()=>this.column.getColDef(),
            getGui: ()=>eGui,
            getLocation: ()=>"header",
            getTooltipValue: ()=>{
                if (value != null) return value;
                const res = this.column.getColDef().headerTooltip;
                return res;
            },
            shouldDisplayTooltip
        };
        const tooltipFeature = this.createManagedBean(new TooltipFeature(tooltipCtrl));
        this.refreshFunctions.push(()=>tooltipFeature.refreshToolTip());
    }
    setupClassesFromColDef() {
        const refreshHeaderClasses = ()=>{
            const colDef = this.column.getColDef();
            const classes = CssClassApplier.getHeaderClassesFromColDef(colDef, this.gos, this.column, null);
            const oldClasses = this.userHeaderClasses;
            this.userHeaderClasses = new Set(classes);
            classes.forEach((c)=>{
                if (oldClasses.has(c)) oldClasses.delete(c);
                else this.comp.addOrRemoveCssClass(c, true);
            });
            oldClasses.forEach((c)=>this.comp.addOrRemoveCssClass(c, false));
        };
        this.refreshFunctions.push(refreshHeaderClasses);
        refreshHeaderClasses();
    }
    setDragSource(eSource) {
        this.dragSourceElement = eSource;
        this.removeDragSource();
        if (!eSource || !this.draggable) return;
        const { column, beans, displayName, dragAndDropService, gos } = this;
        const { columnModel } = beans;
        let hideColumnOnExit = !this.gos.get("suppressDragLeaveHidesColumns");
        const dragSource = this.dragSource = {
            type: 1 /* HeaderCell */ ,
            eElement: eSource,
            getDefaultIconName: ()=>hideColumnOnExit ? DragAndDropService.ICON_HIDE : DragAndDropService.ICON_NOT_ALLOWED,
            getDragItem: ()=>this.createDragItem(column),
            dragItemName: displayName,
            onDragStarted: ()=>{
                hideColumnOnExit = !gos.get("suppressDragLeaveHidesColumns");
                column.setMoving(true, "uiColumnMoved");
            },
            onDragStopped: ()=>column.setMoving(false, "uiColumnMoved"),
            onGridEnter: (dragItem)=>{
                var _a;
                if (hideColumnOnExit) {
                    const unlockedColumns = ((_a = dragItem == null ? void 0 : dragItem.columns) == null ? void 0 : _a.filter((col)=>!col.getColDef().lockVisible)) || [];
                    columnModel.setColumnsVisible(unlockedColumns, true, "uiColumnMoved");
                }
            },
            onGridExit: (dragItem)=>{
                var _a;
                if (hideColumnOnExit) {
                    const unlockedColumns = ((_a = dragItem == null ? void 0 : dragItem.columns) == null ? void 0 : _a.filter((col)=>!col.getColDef().lockVisible)) || [];
                    columnModel.setColumnsVisible(unlockedColumns, false, "uiColumnMoved");
                }
            }
        };
        dragAndDropService.addDragSource(dragSource, true);
    }
    createDragItem(column) {
        const visibleState = {};
        visibleState[column.getId()] = column.isVisible();
        return {
            columns: [
                column
            ],
            visibleState
        };
    }
    updateState() {
        this.menuEnabled = this.menuService.isColumnMenuInHeaderEnabled(this.column);
        this.openFilterEnabled = this.menuService.isFilterMenuInHeaderEnabled(this.column);
        this.sortable = this.column.isSortable();
        this.displayName = this.calculateDisplayName();
        this.draggable = this.workOutDraggable();
    }
    addRefreshFunction(func) {
        this.refreshFunctions.push(func);
    }
    refresh() {
        this.updateState();
        this.refreshHeaderComp();
        this.refreshAria();
        this.refreshFunctions.forEach((f)=>f());
    }
    refreshHeaderComp() {
        const newCompDetails = this.lookupUserCompDetails();
        const compInstance = this.comp.getUserCompInstance();
        const attemptRefresh = compInstance != null && this.userCompDetails.componentClass == newCompDetails.componentClass;
        const headerCompRefreshed = attemptRefresh ? this.attemptHeaderCompRefresh(newCompDetails.params) : false;
        if (headerCompRefreshed) this.setDragSource(this.dragSourceElement);
        else this.setCompDetails(newCompDetails);
    }
    attemptHeaderCompRefresh(params) {
        const headerComp = this.comp.getUserCompInstance();
        if (!headerComp) return false;
        if (!headerComp.refresh) return false;
        const res = headerComp.refresh(params);
        return res;
    }
    calculateDisplayName() {
        return this.beans.columnModel.getDisplayNameForColumn(this.column, "header", true);
    }
    checkDisplayName() {
        if (this.displayName !== this.calculateDisplayName()) this.refresh();
    }
    workOutDraggable() {
        const colDef = this.column.getColDef();
        const isSuppressMovableColumns = this.gos.get("suppressMovableColumns");
        const colCanMove = !isSuppressMovableColumns && !colDef.suppressMovable && !colDef.lockPosition;
        return !!colCanMove || !!colDef.enableRowGroup || !!colDef.enablePivot;
    }
    onColumnRowGroupChanged() {
        this.checkDisplayName();
    }
    onColumnPivotChanged() {
        this.checkDisplayName();
    }
    onColumnValueChanged() {
        this.checkDisplayName();
    }
    setupWidth() {
        const listener = ()=>{
            const columnWidth = this.column.getActualWidth();
            this.comp.setWidth(`${columnWidth}px`);
        };
        this.addManagedListener(this.column, Column.EVENT_WIDTH_CHANGED, listener);
        listener();
    }
    setupMovingCss() {
        const listener = ()=>{
            this.comp.addOrRemoveCssClass("ag-header-cell-moving", this.column.isMoving());
        };
        this.addManagedListener(this.column, Column.EVENT_MOVING_CHANGED, listener);
        listener();
    }
    setupMenuClass() {
        const listener = ()=>{
            this.comp.addOrRemoveCssClass("ag-column-menu-visible", this.column.isMenuVisible());
        };
        this.addManagedListener(this.column, Column.EVENT_MENU_VISIBLE_CHANGED, listener);
        listener();
    }
    setupSortableClass() {
        const updateSortableCssClass = ()=>{
            this.comp.addOrRemoveCssClass("ag-header-cell-sortable", !!this.sortable);
        };
        updateSortableCssClass();
        this.addRefreshFunction(updateSortableCssClass);
        this.addManagedListener(this.eventService, Column.EVENT_SORT_CHANGED, this.refreshAriaSort.bind(this));
    }
    setupFilterClass() {
        const listener = ()=>{
            const isFilterActive = this.column.isFilterActive();
            this.comp.addOrRemoveCssClass("ag-header-cell-filtered", isFilterActive);
            this.refreshAria();
        };
        this.addManagedListener(this.column, Column.EVENT_FILTER_ACTIVE_CHANGED, listener);
        listener();
    }
    setupWrapTextClass() {
        const listener = ()=>{
            const wrapText = !!this.column.getColDef().wrapHeaderText;
            this.comp.addOrRemoveCssClass("ag-header-cell-wrap-text", wrapText);
        };
        listener();
        this.addRefreshFunction(listener);
    }
    onDisplayedColumnsChanged() {
        super.onDisplayedColumnsChanged();
        if (!this.isAlive()) return;
        this.onHeaderHeightChanged();
    }
    onHeaderHeightChanged() {
        this.refreshSpanHeaderHeight();
    }
    refreshSpanHeaderHeight() {
        const { eGui, column, comp, beans } = this;
        if (!column.isSpanHeaderHeight()) {
            eGui.style.removeProperty("top");
            eGui.style.removeProperty("height");
            comp.addOrRemoveCssClass("ag-header-span-height", false);
            comp.addOrRemoveCssClass("ag-header-span-total", false);
            return;
        }
        const { numberOfParents, isSpanningTotal } = this.column.getColumnGroupPaddingInfo();
        comp.addOrRemoveCssClass("ag-header-span-height", numberOfParents > 0);
        const { columnModel } = beans;
        const headerHeight = columnModel.getColumnHeaderRowHeight();
        if (numberOfParents === 0) {
            comp.addOrRemoveCssClass("ag-header-span-total", false);
            eGui.style.setProperty("top", `0px`);
            eGui.style.setProperty("height", `${headerHeight}px`);
            return;
        }
        comp.addOrRemoveCssClass("ag-header-span-total", isSpanningTotal);
        const pivotMode = columnModel.isPivotMode();
        const groupHeaderHeight = pivotMode ? columnModel.getPivotGroupHeaderHeight() : columnModel.getGroupHeaderHeight();
        const extraHeight = numberOfParents * groupHeaderHeight;
        eGui.style.setProperty("top", `${-extraHeight}px`);
        eGui.style.setProperty("height", `${headerHeight + extraHeight}px`);
    }
    setupAutoHeight(wrapperElement) {
        const { columnModel, resizeObserverService } = this.beans;
        const measureHeight = (timesCalled)=>{
            if (!this.isAlive()) return;
            const { paddingTop, paddingBottom, borderBottomWidth, borderTopWidth } = getElementSize(this.getGui());
            const extraHeight = paddingTop + paddingBottom + borderBottomWidth + borderTopWidth;
            const wrapperHeight = wrapperElement.offsetHeight;
            const autoHeight = wrapperHeight + extraHeight;
            if (timesCalled < 5) {
                const doc = this.beans.gos.getDocument();
                const notYetInDom = !doc || !doc.contains(wrapperElement);
                const possiblyNoContentYet = autoHeight == 0;
                if (notYetInDom || possiblyNoContentYet) {
                    window.setTimeout(()=>measureHeight(timesCalled + 1), 0);
                    return;
                }
            }
            columnModel.setColumnHeaderHeight(this.column, autoHeight);
        };
        let isMeasuring = false;
        let stopResizeObserver;
        const checkMeasuring = ()=>{
            const newValue = this.column.isAutoHeaderHeight();
            if (newValue && !isMeasuring) startMeasuring();
            if (!newValue && isMeasuring) stopMeasuring();
        };
        const startMeasuring = ()=>{
            isMeasuring = true;
            measureHeight(0);
            this.comp.addOrRemoveCssClass("ag-header-cell-auto-height", true);
            stopResizeObserver = resizeObserverService.observeResize(wrapperElement, ()=>measureHeight(0));
        };
        const stopMeasuring = ()=>{
            isMeasuring = false;
            if (stopResizeObserver) stopResizeObserver();
            this.comp.addOrRemoveCssClass("ag-header-cell-auto-height", false);
            stopResizeObserver = void 0;
        };
        checkMeasuring();
        this.addDestroyFunc(()=>stopMeasuring());
        this.addManagedListener(this.column, Column.EVENT_WIDTH_CHANGED, ()=>isMeasuring && measureHeight(0));
        this.addManagedListener(this.eventService, Column.EVENT_SORT_CHANGED, ()=>{
            if (isMeasuring) window.setTimeout(()=>measureHeight(0));
        });
        this.addRefreshFunction(checkMeasuring);
    }
    refreshAriaSort() {
        if (this.sortable) {
            const translate = this.localeService.getLocaleTextFunc();
            const sort = this.beans.sortController.getDisplaySortForColumn(this.column) || null;
            this.comp.setAriaSort(getAriaSortState(sort));
            this.setAriaDescriptionProperty("sort", translate("ariaSortableColumn", "Press ENTER to sort"));
        } else {
            this.comp.setAriaSort();
            this.setAriaDescriptionProperty("sort", null);
        }
    }
    refreshAriaMenu() {
        if (this.menuEnabled) {
            const translate = this.localeService.getLocaleTextFunc();
            this.setAriaDescriptionProperty("menu", translate("ariaMenuColumn", "Press ALT DOWN to open column menu"));
        } else this.setAriaDescriptionProperty("menu", null);
    }
    refreshAriaFilterButton() {
        if (this.openFilterEnabled && !this.menuService.isLegacyMenuEnabled()) {
            const translate = this.localeService.getLocaleTextFunc();
            this.setAriaDescriptionProperty("filterButton", translate("ariaFilterColumn", "Press CTRL ENTER to open filter"));
        } else this.setAriaDescriptionProperty("filterButton", null);
    }
    refreshAriaFiltered() {
        const translate = this.localeService.getLocaleTextFunc();
        const isFilterActive = this.column.isFilterActive();
        if (isFilterActive) this.setAriaDescriptionProperty("filter", translate("ariaColumnFiltered", "Column Filtered"));
        else this.setAriaDescriptionProperty("filter", null);
    }
    setAriaDescriptionProperty(property, value) {
        if (value != null) this.ariaDescriptionProperties.set(property, value);
        else this.ariaDescriptionProperties.delete(property);
    }
    announceAriaDescription() {
        if (!this.eGui.contains(this.beans.gos.getActiveDomElement())) return;
        const ariaDescription = Array.from(this.ariaDescriptionProperties.keys()).sort((a, b)=>a === "filter" ? -1 : b.charCodeAt(0) - a.charCodeAt(0)).map((key)=>this.ariaDescriptionProperties.get(key)).join(". ");
        this.beans.ariaAnnouncementService.announceValue(ariaDescription);
    }
    refreshAria() {
        this.refreshAriaSort();
        this.refreshAriaMenu();
        this.refreshAriaFilterButton();
        this.refreshAriaFiltered();
    }
    addColumnHoverListener() {
        const listener = ()=>{
            if (!this.gos.get("columnHoverHighlight")) return;
            const isHovered = this.beans.columnHoverService.isHovered(this.column);
            this.comp.addOrRemoveCssClass("ag-column-hover", isHovered);
        };
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_HOVER_CHANGED, listener);
        listener();
    }
    getColId() {
        return this.column.getColId();
    }
    addActiveHeaderMouseListeners() {
        const listener = (e)=>this.handleMouseOverChange(e.type === "mouseenter");
        const clickListener = ()=>this.dispatchColumnMouseEvent(Events.EVENT_COLUMN_HEADER_CLICKED, this.column);
        const contextMenuListener = (event)=>this.handleContextMenuMouseEvent(event, void 0, this.column);
        this.addManagedListener(this.getGui(), "mouseenter", listener);
        this.addManagedListener(this.getGui(), "mouseleave", listener);
        this.addManagedListener(this.getGui(), "click", clickListener);
        this.addManagedListener(this.getGui(), "contextmenu", contextMenuListener);
    }
    handleMouseOverChange(isMouseOver) {
        this.setActiveHeader(isMouseOver);
        const eventType = isMouseOver ? Events.EVENT_COLUMN_HEADER_MOUSE_OVER : Events.EVENT_COLUMN_HEADER_MOUSE_LEAVE;
        const event = {
            type: eventType,
            column: this.column
        };
        this.eventService.dispatchEvent(event);
    }
    setActiveHeader(active) {
        this.comp.addOrRemoveCssClass("ag-header-active", active);
    }
    getAnchorElementForMenu(isFilter) {
        const headerComp = this.comp.getUserCompInstance();
        if (headerComp instanceof HeaderComp) return headerComp.getAnchorElementForMenu(isFilter);
        return this.getGui();
    }
    destroy() {
        super.destroy();
        this.refreshFunctions = null;
        this.selectAllFeature = null;
        this.dragSourceElement = null;
        this.userCompDetails = null;
        this.userHeaderClasses = null;
        this.ariaDescriptionProperties = null;
    }
};
// community-modules/core/src/headerRendering/cells/columnGroup/groupResizeFeature.ts
var GroupResizeFeature = class extends BeanStub {
    constructor(comp, eResize, pinned, columnGroup){
        super();
        this.eResize = eResize;
        this.comp = comp;
        this.pinned = pinned;
        this.columnGroup = columnGroup;
    }
    postConstruct() {
        if (!this.columnGroup.isResizable()) {
            this.comp.setResizableDisplayed(false);
            return;
        }
        const finishedWithResizeFunc = this.horizontalResizeService.addResizeBar({
            eResizeBar: this.eResize,
            onResizeStart: this.onResizeStart.bind(this),
            onResizing: this.onResizing.bind(this, false),
            onResizeEnd: this.onResizing.bind(this, true)
        });
        this.addDestroyFunc(finishedWithResizeFunc);
        if (!this.gos.get("suppressAutoSize")) {
            const skipHeaderOnAutoSize = this.gos.get("skipHeaderOnAutoSize");
            this.eResize.addEventListener("dblclick", ()=>{
                const keys2 = [];
                const leafCols = this.columnGroup.getDisplayedLeafColumns();
                leafCols.forEach((column)=>{
                    if (!column.getColDef().suppressAutoSize) keys2.push(column.getColId());
                });
                if (keys2.length > 0) this.columnModel.autoSizeColumns({
                    columns: keys2,
                    skipHeader: skipHeaderOnAutoSize,
                    stopAtGroup: this.columnGroup,
                    source: "uiColumnResized"
                });
                this.resizeLeafColumnsToFit("uiColumnResized");
            });
        }
    }
    onResizeStart(shiftKey) {
        const initialValues = this.getInitialValues(shiftKey);
        this.storeLocalValues(initialValues);
        this.toggleColumnResizing(true);
    }
    onResizing(finished, resizeAmount, source = "uiColumnResized") {
        const resizeAmountNormalised = this.normaliseDragChange(resizeAmount);
        const width = this.resizeStartWidth + resizeAmountNormalised;
        this.resizeColumnsFromLocalValues(width, source, finished);
    }
    getInitialValues(shiftKey) {
        const columnsToResize = this.getColumnsToResize();
        const resizeStartWidth = this.getInitialSizeOfColumns(columnsToResize);
        const resizeRatios = this.getSizeRatiosOfColumns(columnsToResize, resizeStartWidth);
        const columnSizeAndRatios = {
            columnsToResize,
            resizeStartWidth,
            resizeRatios
        };
        let groupAfter = null;
        if (shiftKey) groupAfter = this.columnModel.getDisplayedGroupAtDirection(this.columnGroup, "After");
        if (groupAfter) {
            const takeFromLeafCols = groupAfter.getDisplayedLeafColumns();
            const groupAfterColumns = columnSizeAndRatios.groupAfterColumns = takeFromLeafCols.filter((col)=>col.isResizable());
            const groupAfterStartWidth = columnSizeAndRatios.groupAfterStartWidth = this.getInitialSizeOfColumns(groupAfterColumns);
            columnSizeAndRatios.groupAfterRatios = this.getSizeRatiosOfColumns(groupAfterColumns, groupAfterStartWidth);
        } else {
            columnSizeAndRatios.groupAfterColumns = void 0;
            columnSizeAndRatios.groupAfterStartWidth = void 0;
            columnSizeAndRatios.groupAfterRatios = void 0;
        }
        return columnSizeAndRatios;
    }
    storeLocalValues(initialValues) {
        const { columnsToResize, resizeStartWidth, resizeRatios, groupAfterColumns, groupAfterStartWidth, groupAfterRatios } = initialValues;
        this.resizeCols = columnsToResize;
        this.resizeStartWidth = resizeStartWidth;
        this.resizeRatios = resizeRatios;
        this.resizeTakeFromCols = groupAfterColumns;
        this.resizeTakeFromStartWidth = groupAfterStartWidth;
        this.resizeTakeFromRatios = groupAfterRatios;
    }
    clearLocalValues() {
        this.resizeCols = void 0;
        this.resizeRatios = void 0;
        this.resizeTakeFromCols = void 0;
        this.resizeTakeFromRatios = void 0;
    }
    resizeLeafColumnsToFit(source) {
        const preferredSize = this.autoWidthCalculator.getPreferredWidthForColumnGroup(this.columnGroup);
        const initialValues = this.getInitialValues();
        if (preferredSize > initialValues.resizeStartWidth) this.resizeColumns(initialValues, preferredSize, source, true);
    }
    resizeColumnsFromLocalValues(totalWidth, source, finished = true) {
        var _a, _b, _c;
        if (!this.resizeCols || !this.resizeRatios) return;
        const initialValues = {
            columnsToResize: this.resizeCols,
            resizeStartWidth: this.resizeStartWidth,
            resizeRatios: this.resizeRatios,
            groupAfterColumns: (_a = this.resizeTakeFromCols) != null ? _a : void 0,
            groupAfterStartWidth: (_b = this.resizeTakeFromStartWidth) != null ? _b : void 0,
            groupAfterRatios: (_c = this.resizeTakeFromRatios) != null ? _c : void 0
        };
        this.resizeColumns(initialValues, totalWidth, source, finished);
    }
    resizeColumns(initialValues, totalWidth, source, finished = true) {
        const { columnsToResize, resizeStartWidth, resizeRatios, groupAfterColumns, groupAfterStartWidth, groupAfterRatios } = initialValues;
        const resizeSets = [];
        resizeSets.push({
            columns: columnsToResize,
            ratios: resizeRatios,
            width: totalWidth
        });
        if (groupAfterColumns) {
            const diff = totalWidth - resizeStartWidth;
            resizeSets.push({
                columns: groupAfterColumns,
                ratios: groupAfterRatios,
                width: groupAfterStartWidth - diff
            });
        }
        this.columnModel.resizeColumnSets({
            resizeSets,
            finished,
            source
        });
        if (finished) this.toggleColumnResizing(false);
    }
    toggleColumnResizing(resizing) {
        this.comp.addOrRemoveCssClass("ag-column-resizing", resizing);
    }
    getColumnsToResize() {
        const leafCols = this.columnGroup.getDisplayedLeafColumns();
        return leafCols.filter((col)=>col.isResizable());
    }
    getInitialSizeOfColumns(columns) {
        return columns.reduce((totalWidth, column)=>totalWidth + column.getActualWidth(), 0);
    }
    getSizeRatiosOfColumns(columns, initialSizeOfColumns) {
        return columns.map((column)=>column.getActualWidth() / initialSizeOfColumns);
    }
    // optionally inverts the drag, depending on pinned and RTL
    // note - this method is duplicated in RenderedHeaderCell - should refactor out?
    normaliseDragChange(dragChange) {
        let result = dragChange;
        if (this.gos.get("enableRtl")) {
            if (this.pinned !== "left") result *= -1;
        } else if (this.pinned === "right") result *= -1;
        return result;
    }
    destroy() {
        super.destroy();
        this.clearLocalValues();
    }
};
__decorateClass([
    Autowired("horizontalResizeService")
], GroupResizeFeature.prototype, "horizontalResizeService", 2);
__decorateClass([
    Autowired("autoWidthCalculator")
], GroupResizeFeature.prototype, "autoWidthCalculator", 2);
__decorateClass([
    Autowired("columnModel")
], GroupResizeFeature.prototype, "columnModel", 2);
__decorateClass([
    PostConstruct
], GroupResizeFeature.prototype, "postConstruct", 1);
// community-modules/core/src/headerRendering/cells/columnGroup/groupWidthFeature.ts
var GroupWidthFeature = class extends BeanStub {
    constructor(comp, columnGroup){
        super();
        // the children can change, we keep destroy functions related to listening to the children here
        this.removeChildListenersFuncs = [];
        this.columnGroup = columnGroup;
        this.comp = comp;
    }
    postConstruct() {
        this.addListenersToChildrenColumns();
        this.addManagedListener(this.columnGroup, ColumnGroup.EVENT_DISPLAYED_CHILDREN_CHANGED, this.onDisplayedChildrenChanged.bind(this));
        this.onWidthChanged();
        this.addDestroyFunc(this.removeListenersOnChildrenColumns.bind(this));
    }
    addListenersToChildrenColumns() {
        this.removeListenersOnChildrenColumns();
        const widthChangedListener = this.onWidthChanged.bind(this);
        this.columnGroup.getLeafColumns().forEach((column)=>{
            column.addEventListener("widthChanged", widthChangedListener);
            column.addEventListener("visibleChanged", widthChangedListener);
            this.removeChildListenersFuncs.push(()=>{
                column.removeEventListener("widthChanged", widthChangedListener);
                column.removeEventListener("visibleChanged", widthChangedListener);
            });
        });
    }
    removeListenersOnChildrenColumns() {
        this.removeChildListenersFuncs.forEach((func)=>func());
        this.removeChildListenersFuncs = [];
    }
    onDisplayedChildrenChanged() {
        this.addListenersToChildrenColumns();
        this.onWidthChanged();
    }
    onWidthChanged() {
        const columnWidth = this.columnGroup.getActualWidth();
        this.comp.setWidth(`${columnWidth}px`);
        this.comp.addOrRemoveCssClass("ag-hidden", columnWidth === 0);
    }
};
__decorateClass([
    PostConstruct
], GroupWidthFeature.prototype, "postConstruct", 1);
// community-modules/core/src/headerRendering/cells/columnGroup/headerGroupCellCtrl.ts
var HeaderGroupCellCtrl = class extends AbstractHeaderCellCtrl {
    constructor(columnGroup, beans, parentRowCtrl){
        super(columnGroup, beans, parentRowCtrl);
        this.onSuppressColMoveChange = ()=>{
            if (!this.isAlive() || this.isSuppressMoving()) this.removeDragSource();
            else if (!this.dragSource) {
                const eGui = this.getGui();
                this.setDragSource(eGui);
            }
        };
        this.column = columnGroup;
    }
    setComp(comp, eGui, eResize) {
        this.comp = comp;
        this.setGui(eGui);
        this.displayName = this.beans.columnModel.getDisplayNameForColumnGroup(this.column, "header");
        this.addClasses();
        this.setupMovingCss();
        this.setupExpandable();
        this.setupTooltip();
        this.addDestroyFunc(()=>{
            if (this.tooltipFeature) this.tooltipFeature = this.destroyBean(this.tooltipFeature);
        });
        this.setupUserComp();
        this.addHeaderMouseListeners();
        const pinned = this.getParentRowCtrl().getPinned();
        const leafCols = this.column.getProvidedColumnGroup().getLeafColumns();
        this.createManagedBean(new HoverFeature(leafCols, eGui));
        this.createManagedBean(new SetLeftFeature(this.column, eGui, this.beans));
        this.createManagedBean(new GroupWidthFeature(comp, this.column));
        this.resizeFeature = this.createManagedBean(new GroupResizeFeature(comp, eResize, pinned, this.column));
        this.createManagedBean(new ManagedFocusFeature(eGui, {
            shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this),
            onTabKeyDown: ()=>void 0,
            handleKeyDown: this.handleKeyDown.bind(this),
            onFocusIn: this.onFocusIn.bind(this)
        }));
        this.addManagedPropertyListener(Events.EVENT_SUPPRESS_COLUMN_MOVE_CHANGED, this.onSuppressColMoveChange);
        this.addResizeAndMoveKeyboardListeners();
    }
    resizeHeader(delta, shiftKey) {
        if (!this.resizeFeature) return;
        const initialValues = this.resizeFeature.getInitialValues(shiftKey);
        this.resizeFeature.resizeColumns(initialValues, initialValues.resizeStartWidth + delta, "uiColumnResized", true);
    }
    moveHeader(hDirection) {
        const { beans, eGui, column, gos, ctrlsService } = this;
        const isRtl = gos.get("enableRtl");
        const isLeft = hDirection === 0 /* Left */ ;
        const pinned = this.getPinned();
        const rect = eGui.getBoundingClientRect();
        const left = rect.left;
        const width = rect.width;
        const xPosition = ColumnMoveHelper.normaliseX(isLeft !== isRtl ? left - 20 : left + width + 20, pinned, true, gos, ctrlsService);
        const id = column.getGroupId();
        const headerPosition = this.focusService.getFocusedHeader();
        ColumnMoveHelper.attemptMoveColumns({
            allMovingColumns: this.column.getLeafColumns(),
            isFromHeader: true,
            hDirection,
            xPosition,
            pinned,
            fromEnter: false,
            fakeEvent: false,
            gos,
            columnModel: beans.columnModel
        });
        const displayedLeafColumns = column.getDisplayedLeafColumns();
        const targetColumn = isLeft ? displayedLeafColumns[0] : last(displayedLeafColumns);
        this.ctrlsService.getGridBodyCtrl().getScrollFeature().ensureColumnVisible(targetColumn, "auto");
        if (!this.isAlive() && headerPosition) this.restoreFocus(id, column, headerPosition);
    }
    restoreFocus(groupId, previousColumnGroup, previousPosition) {
        const leafCols = previousColumnGroup.getLeafColumns();
        if (!leafCols.length) return;
        const parent = leafCols[0].getParent();
        if (!parent) return;
        const newColumnGroup = this.findGroupWidthId(parent, groupId);
        if (newColumnGroup) this.focusService.focusHeaderPosition({
            headerPosition: __spreadProps(__spreadValues({}, previousPosition), {
                column: newColumnGroup
            })
        });
    }
    findGroupWidthId(columnGroup, id) {
        while(columnGroup){
            if (columnGroup.getGroupId() === id) return columnGroup;
            columnGroup = columnGroup.getParent();
        }
        return null;
    }
    resizeLeafColumnsToFit(source) {
        if (!this.resizeFeature) return;
        this.resizeFeature.resizeLeafColumnsToFit(source);
    }
    setupUserComp() {
        const params = this.gos.addGridCommonParams({
            displayName: this.displayName,
            columnGroup: this.column,
            setExpanded: (expanded)=>{
                this.beans.columnModel.setColumnGroupOpened(this.column.getProvidedColumnGroup(), expanded, "gridInitializing");
            },
            setTooltip: (value, shouldDisplayTooltip)=>{
                this.setupTooltip(value, shouldDisplayTooltip);
            }
        });
        const compDetails = this.userComponentFactory.getHeaderGroupCompDetails(params);
        this.comp.setUserCompDetails(compDetails);
    }
    addHeaderMouseListeners() {
        const listener = (e)=>this.handleMouseOverChange(e.type === "mouseenter");
        const clickListener = ()=>this.dispatchColumnMouseEvent(Events.EVENT_COLUMN_HEADER_CLICKED, this.column.getProvidedColumnGroup());
        const contextMenuListener = (event)=>this.handleContextMenuMouseEvent(event, void 0, this.column.getProvidedColumnGroup());
        this.addManagedListener(this.getGui(), "mouseenter", listener);
        this.addManagedListener(this.getGui(), "mouseleave", listener);
        this.addManagedListener(this.getGui(), "click", clickListener);
        this.addManagedListener(this.getGui(), "contextmenu", contextMenuListener);
    }
    handleMouseOverChange(isMouseOver) {
        const eventType = isMouseOver ? Events.EVENT_COLUMN_HEADER_MOUSE_OVER : Events.EVENT_COLUMN_HEADER_MOUSE_LEAVE;
        const event = {
            type: eventType,
            column: this.column.getProvidedColumnGroup()
        };
        this.eventService.dispatchEvent(event);
    }
    setupTooltip(value, shouldDisplayTooltip) {
        if (this.tooltipFeature) this.tooltipFeature = this.destroyBean(this.tooltipFeature);
        const colGroupDef = this.column.getColGroupDef();
        const isTooltipWhenTruncated = this.gos.get("tooltipShowMode") === "whenTruncated";
        const eGui = this.eGui;
        if (!shouldDisplayTooltip && isTooltipWhenTruncated && !(colGroupDef == null ? void 0 : colGroupDef.headerGroupComponent)) shouldDisplayTooltip = ()=>{
            const textEl = eGui.querySelector(".ag-header-group-text");
            if (!textEl) return true;
            return textEl.scrollWidth > textEl.clientWidth;
        };
        const tooltipCtrl = {
            getColumn: ()=>this.column,
            getGui: ()=>eGui,
            getLocation: ()=>"headerGroup",
            getTooltipValue: ()=>value != null ? value : colGroupDef && colGroupDef.headerTooltip,
            shouldDisplayTooltip
        };
        if (colGroupDef) tooltipCtrl.getColDef = ()=>colGroupDef;
        this.createBean(new TooltipFeature(tooltipCtrl));
    }
    setupExpandable() {
        const providedColGroup = this.column.getProvidedColumnGroup();
        this.refreshExpanded();
        this.addManagedListener(providedColGroup, ProvidedColumnGroup.EVENT_EXPANDABLE_CHANGED, this.refreshExpanded.bind(this));
        this.addManagedListener(providedColGroup, ProvidedColumnGroup.EVENT_EXPANDED_CHANGED, this.refreshExpanded.bind(this));
    }
    refreshExpanded() {
        const column = this.column;
        this.expandable = column.isExpandable();
        const expanded = column.isExpanded();
        if (this.expandable) this.comp.setAriaExpanded(expanded ? "true" : "false");
        else this.comp.setAriaExpanded(void 0);
    }
    getColId() {
        return this.column.getUniqueId();
    }
    addClasses() {
        const colGroupDef = this.column.getColGroupDef();
        const classes = CssClassApplier.getHeaderClassesFromColDef(colGroupDef, this.gos, null, this.column);
        if (this.column.isPadding()) {
            classes.push("ag-header-group-cell-no-group");
            const leafCols = this.column.getLeafColumns();
            if (leafCols.every((col)=>col.isSpanHeaderHeight())) classes.push("ag-header-span-height");
        } else classes.push("ag-header-group-cell-with-group");
        classes.forEach((c)=>this.comp.addOrRemoveCssClass(c, true));
    }
    setupMovingCss() {
        const providedColumnGroup = this.column.getProvidedColumnGroup();
        const leafColumns = providedColumnGroup.getLeafColumns();
        const listener = ()=>this.comp.addOrRemoveCssClass("ag-header-cell-moving", this.column.isMoving());
        leafColumns.forEach((col)=>{
            this.addManagedListener(col, Column.EVENT_MOVING_CHANGED, listener);
        });
        listener();
    }
    onFocusIn(e) {
        if (!this.eGui.contains(e.relatedTarget)) {
            const rowIndex = this.getRowIndex();
            this.beans.focusService.setFocusedHeader(rowIndex, this.column);
        }
    }
    handleKeyDown(e) {
        super.handleKeyDown(e);
        const wrapperHasFocus = this.getWrapperHasFocus();
        if (!this.expandable || !wrapperHasFocus) return;
        if (e.key === KeyCode.ENTER) {
            const column = this.column;
            const newExpandedValue = !column.isExpanded();
            this.beans.columnModel.setColumnGroupOpened(column.getProvidedColumnGroup(), newExpandedValue, "uiColumnExpanded");
        }
    }
    // unlike columns, this will only get called once, as we don't react on props on column groups
    // (we will always destroy and recreate this comp if something changes)
    setDragSource(eHeaderGroup) {
        if (!this.isAlive() || this.isSuppressMoving()) return;
        this.removeDragSource();
        if (!eHeaderGroup) return;
        const { beans, column, displayName, gos, dragAndDropService } = this;
        const { columnModel } = beans;
        const allLeafColumns = column.getProvidedColumnGroup().getLeafColumns();
        let hideColumnOnExit = !gos.get("suppressDragLeaveHidesColumns");
        const dragSource = this.dragSource = {
            type: 1 /* HeaderCell */ ,
            eElement: eHeaderGroup,
            getDefaultIconName: ()=>hideColumnOnExit ? DragAndDropService.ICON_HIDE : DragAndDropService.ICON_NOT_ALLOWED,
            dragItemName: displayName,
            // we add in the original group leaf columns, so we move both visible and non-visible items
            getDragItem: ()=>this.getDragItemForGroup(column),
            onDragStarted: ()=>{
                hideColumnOnExit = !gos.get("suppressDragLeaveHidesColumns");
                allLeafColumns.forEach((col)=>col.setMoving(true, "uiColumnDragged"));
            },
            onDragStopped: ()=>allLeafColumns.forEach((col)=>col.setMoving(false, "uiColumnDragged")),
            onGridEnter: (dragItem)=>{
                var _a;
                if (hideColumnOnExit) {
                    const unlockedColumns = ((_a = dragItem == null ? void 0 : dragItem.columns) == null ? void 0 : _a.filter((col)=>!col.getColDef().lockVisible)) || [];
                    columnModel.setColumnsVisible(unlockedColumns, true, "uiColumnMoved");
                }
            },
            onGridExit: (dragItem)=>{
                var _a;
                if (hideColumnOnExit) {
                    const unlockedColumns = ((_a = dragItem == null ? void 0 : dragItem.columns) == null ? void 0 : _a.filter((col)=>!col.getColDef().lockVisible)) || [];
                    columnModel.setColumnsVisible(unlockedColumns, false, "uiColumnMoved");
                }
            }
        };
        dragAndDropService.addDragSource(dragSource, true);
    }
    // when moving the columns, we want to move all the columns (contained within the DragItem) in this group in one go,
    // and in the order they are currently in the screen.
    getDragItemForGroup(columnGroup) {
        const allColumnsOriginalOrder = columnGroup.getProvidedColumnGroup().getLeafColumns();
        const visibleState = {};
        allColumnsOriginalOrder.forEach((column)=>visibleState[column.getId()] = column.isVisible());
        const allColumnsCurrentOrder = [];
        this.beans.columnModel.getAllDisplayedColumns().forEach((column)=>{
            if (allColumnsOriginalOrder.indexOf(column) >= 0) {
                allColumnsCurrentOrder.push(column);
                removeFromArray(allColumnsOriginalOrder, column);
            }
        });
        allColumnsOriginalOrder.forEach((column)=>allColumnsCurrentOrder.push(column));
        return {
            columns: allColumnsCurrentOrder,
            visibleState
        };
    }
    isSuppressMoving() {
        let childSuppressesMoving = false;
        this.column.getLeafColumns().forEach((column)=>{
            if (column.getColDef().suppressMovable || column.getColDef().lockPosition) childSuppressesMoving = true;
        });
        const result = childSuppressesMoving || this.gos.get("suppressMovableColumns");
        return result;
    }
};
// community-modules/core/src/headerRendering/row/headerRowCtrl.ts
var instanceIdSequence5 = 0;
var HeaderRowCtrl = class extends BeanStub {
    constructor(rowIndex, pinned, type){
        super();
        this.instanceId = instanceIdSequence5++;
        this.rowIndex = rowIndex;
        this.pinned = pinned;
        this.type = type;
        const typeClass = type == "group" /* COLUMN_GROUP */  ? `ag-header-row-column-group` : type == "filter" /* FLOATING_FILTER */  ? `ag-header-row-column-filter` : `ag-header-row-column`;
        this.headerRowClass = `ag-header-row ${typeClass}`;
    }
    postConstruct() {
        this.isPrintLayout = this.gos.isDomLayout("print");
        this.isEnsureDomOrder = this.gos.get("ensureDomOrder");
    }
    getInstanceId() {
        return this.instanceId;
    }
    /**
   * 
   * @param comp Proxy to the actual component
   * @param initCompState Should the component be initialised with the current state of the controller. Default: true
   */ setComp(comp, initCompState = true) {
        this.comp = comp;
        if (initCompState) {
            this.onRowHeightChanged();
            this.onVirtualColumnsChanged();
        }
        this.setWidth();
        this.addEventListeners();
    }
    getHeaderRowClass() {
        return this.headerRowClass;
    }
    getAriaRowIndex() {
        return this.rowIndex + 1;
    }
    addEventListeners() {
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_RESIZED, this.onColumnResized.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_VIRTUAL_COLUMNS_CHANGED, (params)=>this.onVirtualColumnsChanged(params.afterScroll));
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_HEADER_HEIGHT_CHANGED, this.onRowHeightChanged.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_GRID_STYLES_CHANGED, this.onRowHeightChanged.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_ADVANCED_FILTER_ENABLED_CHANGED, this.onRowHeightChanged.bind(this));
        this.addManagedPropertyListener("domLayout", this.onDisplayedColumnsChanged.bind(this));
        this.addManagedPropertyListener("ensureDomOrder", (e)=>this.isEnsureDomOrder = e.currentValue);
        this.addManagedPropertyListener("headerHeight", this.onRowHeightChanged.bind(this));
        this.addManagedPropertyListener("pivotHeaderHeight", this.onRowHeightChanged.bind(this));
        this.addManagedPropertyListener("groupHeaderHeight", this.onRowHeightChanged.bind(this));
        this.addManagedPropertyListener("pivotGroupHeaderHeight", this.onRowHeightChanged.bind(this));
        this.addManagedPropertyListener("floatingFiltersHeight", this.onRowHeightChanged.bind(this));
    }
    getHeaderCellCtrl(column) {
        if (!this.headerCellCtrls) return;
        return values(this.headerCellCtrls).find((cellCtrl)=>cellCtrl.getColumnGroupChild() === column);
    }
    onDisplayedColumnsChanged() {
        this.isPrintLayout = this.gos.isDomLayout("print");
        this.onVirtualColumnsChanged();
        this.setWidth();
        this.onRowHeightChanged();
    }
    getType() {
        return this.type;
    }
    onColumnResized() {
        this.setWidth();
    }
    setWidth() {
        const width = this.getWidthForRow();
        this.comp.setWidth(`${width}px`);
    }
    getWidthForRow() {
        const { columnModel } = this.beans;
        if (this.isPrintLayout) {
            const pinned = this.pinned != null;
            if (pinned) return 0;
            return columnModel.getContainerWidth("right") + columnModel.getContainerWidth("left") + columnModel.getContainerWidth(null);
        }
        return columnModel.getContainerWidth(this.pinned);
    }
    onRowHeightChanged() {
        var { topOffset, rowHeight } = this.getTopAndHeight();
        this.comp.setTop(topOffset + "px");
        this.comp.setHeight(rowHeight + "px");
    }
    getTopAndHeight() {
        const { columnModel, filterManager } = this.beans;
        let headerRowCount = columnModel.getHeaderRowCount();
        const sizes = [];
        let numberOfFloating = 0;
        if (filterManager.hasFloatingFilters()) {
            headerRowCount++;
            numberOfFloating = 1;
        }
        const groupHeight = columnModel.getColumnGroupHeaderRowHeight();
        const headerHeight = columnModel.getColumnHeaderRowHeight();
        const numberOfNonGroups = 1 + numberOfFloating;
        const numberOfGroups = headerRowCount - numberOfNonGroups;
        for(let i = 0; i < numberOfGroups; i++)sizes.push(groupHeight);
        sizes.push(headerHeight);
        for(let i = 0; i < numberOfFloating; i++)sizes.push(columnModel.getFloatingFiltersHeight());
        let topOffset = 0;
        for(let i = 0; i < this.rowIndex; i++)topOffset += sizes[i];
        const rowHeight = sizes[this.rowIndex];
        return {
            topOffset,
            rowHeight
        };
    }
    getPinned() {
        return this.pinned;
    }
    getRowIndex() {
        return this.rowIndex;
    }
    onVirtualColumnsChanged(afterScroll = false) {
        const ctrlsToDisplay = this.getHeaderCtrls();
        const forceOrder = this.isEnsureDomOrder || this.isPrintLayout;
        this.comp.setHeaderCtrls(ctrlsToDisplay, forceOrder, afterScroll);
    }
    getHeaderCtrls() {
        const oldCtrls = this.headerCellCtrls;
        this.headerCellCtrls = /* @__PURE__ */ new Map();
        const columns = this.getColumnsInViewport();
        for (const child of columns)this.recycleAndCreateHeaderCtrls(child, oldCtrls);
        const isFocusedAndDisplayed = (ctrl)=>{
            const { focusService, columnModel } = this.beans;
            const isFocused = focusService.isHeaderWrapperFocused(ctrl);
            if (!isFocused) return false;
            const isDisplayed = columnModel.isDisplayed(ctrl.getColumnGroupChild());
            return isDisplayed;
        };
        if (oldCtrls) for (const [id, oldCtrl] of oldCtrls){
            const keepCtrl = isFocusedAndDisplayed(oldCtrl);
            if (keepCtrl) this.headerCellCtrls.set(id, oldCtrl);
            else this.destroyBean(oldCtrl);
        }
        const ctrlsToDisplay = Array.from(this.headerCellCtrls.values());
        return ctrlsToDisplay;
    }
    recycleAndCreateHeaderCtrls(headerColumn, oldCtrls) {
        if (!this.headerCellCtrls) return;
        if (headerColumn.isEmptyGroup()) return;
        const idOfChild = headerColumn.getUniqueId();
        let headerCtrl;
        if (oldCtrls) {
            headerCtrl = oldCtrls.get(idOfChild);
            oldCtrls.delete(idOfChild);
        }
        const forOldColumn = headerCtrl && headerCtrl.getColumnGroupChild() != headerColumn;
        if (forOldColumn) {
            this.destroyBean(headerCtrl);
            headerCtrl = void 0;
        }
        if (headerCtrl == null) switch(this.type){
            case "filter" /* FLOATING_FILTER */ :
                headerCtrl = this.createBean(new HeaderFilterCellCtrl(headerColumn, this.beans, this));
                break;
            case "group" /* COLUMN_GROUP */ :
                headerCtrl = this.createBean(new HeaderGroupCellCtrl(headerColumn, this.beans, this));
                break;
            default:
                headerCtrl = this.createBean(new HeaderCellCtrl(headerColumn, this.beans, this));
                break;
        }
        this.headerCellCtrls.set(idOfChild, headerCtrl);
    }
    getColumnsInViewport() {
        return this.isPrintLayout ? this.getColumnsInViewportPrintLayout() : this.getColumnsInViewportNormalLayout();
    }
    getColumnsInViewportPrintLayout() {
        if (this.pinned != null) return [];
        let viewportColumns = [];
        const actualDepth = this.getActualDepth();
        const { columnModel } = this.beans;
        [
            "left",
            null,
            "right"
        ].forEach((pinned)=>{
            const items = columnModel.getVirtualHeaderGroupRow(pinned, actualDepth);
            viewportColumns = viewportColumns.concat(items);
        });
        return viewportColumns;
    }
    getActualDepth() {
        return this.type == "filter" /* FLOATING_FILTER */  ? this.rowIndex - 1 : this.rowIndex;
    }
    getColumnsInViewportNormalLayout() {
        return this.beans.columnModel.getVirtualHeaderGroupRow(this.pinned, this.getActualDepth());
    }
    focusHeader(column, event) {
        if (!this.headerCellCtrls) return false;
        const allCtrls = Array.from(this.headerCellCtrls.values());
        const ctrl = allCtrls.find((ctrl2)=>ctrl2.getColumnGroupChild() == column);
        if (!ctrl) return false;
        return ctrl.focus(event);
    }
    destroy() {
        if (this.headerCellCtrls) this.headerCellCtrls.forEach((ctrl)=>{
            this.destroyBean(ctrl);
        });
        this.headerCellCtrls = void 0;
        super.destroy();
    }
};
__decorateClass([
    Autowired("beans")
], HeaderRowCtrl.prototype, "beans", 2);
__decorateClass([
    PostConstruct
], HeaderRowCtrl.prototype, "postConstruct", 1);
// community-modules/core/src/headerRendering/rowContainer/headerRowContainerCtrl.ts
var HeaderRowContainerCtrl = class extends BeanStub {
    constructor(pinned){
        super();
        this.hidden = false;
        this.includeFloatingFilter = false;
        this.groupsRowCtrls = [];
        this.pinned = pinned;
    }
    setComp(comp, eGui) {
        this.comp = comp;
        this.eViewport = eGui;
        this.setupCenterWidth();
        this.setupPinnedWidth();
        this.setupDragAndDrop(this.eViewport);
        this.addManagedListener(this.eventService, Events.EVENT_GRID_COLUMNS_CHANGED, this.onGridColumnsChanged.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_ADVANCED_FILTER_ENABLED_CHANGED, this.onDisplayedColumnsChanged.bind(this));
        this.ctrlsService.registerHeaderContainer(this, this.pinned);
        if (this.columnModel.isReady()) this.refresh();
    }
    setupDragAndDrop(dropContainer) {
        const bodyDropTarget = new BodyDropTarget(this.pinned, dropContainer);
        this.createManagedBean(bodyDropTarget);
    }
    refresh(keepColumns = false) {
        const sequence = new NumberSequence();
        const focusedHeaderPosition = this.focusService.getFocusHeaderToUseAfterRefresh();
        const refreshColumnGroups = ()=>{
            const groupRowCount = this.columnModel.getHeaderRowCount() - 1;
            this.groupsRowCtrls = this.destroyBeans(this.groupsRowCtrls);
            for(let i = 0; i < groupRowCount; i++){
                const ctrl = this.createBean(new HeaderRowCtrl(sequence.next(), this.pinned, "group" /* COLUMN_GROUP */ ));
                this.groupsRowCtrls.push(ctrl);
            }
        };
        const refreshColumns = ()=>{
            const rowIndex = sequence.next();
            const needNewInstance = !this.hidden && (this.columnsRowCtrl == null || !keepColumns || this.columnsRowCtrl.getRowIndex() !== rowIndex);
            const shouldDestroyInstance = needNewInstance || this.hidden;
            if (shouldDestroyInstance) this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl);
            if (needNewInstance) this.columnsRowCtrl = this.createBean(new HeaderRowCtrl(rowIndex, this.pinned, "column" /* COLUMN */ ));
        };
        const refreshFilters = ()=>{
            this.includeFloatingFilter = this.filterManager.hasFloatingFilters() && !this.hidden;
            const destroyPreviousComp = ()=>{
                this.filtersRowCtrl = this.destroyBean(this.filtersRowCtrl);
            };
            if (!this.includeFloatingFilter) {
                destroyPreviousComp();
                return;
            }
            const rowIndex = sequence.next();
            if (this.filtersRowCtrl) {
                const rowIndexMismatch = this.filtersRowCtrl.getRowIndex() !== rowIndex;
                if (!keepColumns || rowIndexMismatch) destroyPreviousComp();
            }
            if (!this.filtersRowCtrl) this.filtersRowCtrl = this.createBean(new HeaderRowCtrl(rowIndex, this.pinned, "filter" /* FLOATING_FILTER */ ));
        };
        refreshColumnGroups();
        refreshColumns();
        refreshFilters();
        const allCtrls = this.getAllCtrls();
        this.comp.setCtrls(allCtrls);
        this.restoreFocusOnHeader(focusedHeaderPosition);
    }
    restoreFocusOnHeader(position) {
        if (position == null || position.column.getPinned() != this.pinned) return;
        this.focusService.focusHeaderPosition({
            headerPosition: position
        });
    }
    getAllCtrls() {
        const res = [
            ...this.groupsRowCtrls
        ];
        if (this.columnsRowCtrl) res.push(this.columnsRowCtrl);
        if (this.filtersRowCtrl) res.push(this.filtersRowCtrl);
        return res;
    }
    // grid cols have changed - this also means the number of rows in the header can have
    // changed. so we remove all the old rows and insert new ones for a complete refresh
    onGridColumnsChanged() {
        this.refresh(true);
    }
    onDisplayedColumnsChanged() {
        const includeFloatingFilter = this.filterManager.hasFloatingFilters() && !this.hidden;
        if (this.includeFloatingFilter !== includeFloatingFilter) this.refresh(true);
    }
    setupCenterWidth() {
        if (this.pinned != null) return;
        this.createManagedBean(new CenterWidthFeature((width)=>this.comp.setCenterWidth(`${width}px`), true));
    }
    setHorizontalScroll(offset) {
        this.comp.setViewportScrollLeft(offset);
    }
    setupPinnedWidth() {
        if (this.pinned == null) return;
        const pinningLeft = this.pinned === "left";
        const pinningRight = this.pinned === "right";
        this.hidden = true;
        const listener = ()=>{
            const width = pinningLeft ? this.pinnedWidthService.getPinnedLeftWidth() : this.pinnedWidthService.getPinnedRightWidth();
            if (width == null) return;
            const hidden = width == 0;
            const hiddenChanged = this.hidden !== hidden;
            const isRtl = this.gos.get("enableRtl");
            const scrollbarWidth = this.gos.getScrollbarWidth();
            const addPaddingForScrollbar = this.scrollVisibleService.isVerticalScrollShowing() && (isRtl && pinningLeft || !isRtl && pinningRight);
            const widthWithPadding = addPaddingForScrollbar ? width + scrollbarWidth : width;
            this.comp.setPinnedContainerWidth(`${widthWithPadding}px`);
            this.comp.setDisplayed(!hidden);
            if (hiddenChanged) {
                this.hidden = hidden;
                this.refresh();
            }
        };
        this.addManagedListener(this.eventService, Events.EVENT_LEFT_PINNED_WIDTH_CHANGED, listener);
        this.addManagedListener(this.eventService, Events.EVENT_RIGHT_PINNED_WIDTH_CHANGED, listener);
        this.addManagedListener(this.eventService, Events.EVENT_SCROLL_VISIBILITY_CHANGED, listener);
        this.addManagedListener(this.eventService, Events.EVENT_SCROLLBAR_WIDTH_CHANGED, listener);
    }
    getHeaderCtrlForColumn(column) {
        if (column instanceof Column) {
            if (!this.columnsRowCtrl) return;
            return this.columnsRowCtrl.getHeaderCellCtrl(column);
        }
        if (this.groupsRowCtrls.length === 0) return;
        for(let i = 0; i < this.groupsRowCtrls.length; i++){
            const ctrl = this.groupsRowCtrls[i].getHeaderCellCtrl(column);
            if (ctrl) return ctrl;
        }
    }
    getHtmlElementForColumnHeader(column) {
        const cellCtrl = this.getHeaderCtrlForColumn(column);
        if (!cellCtrl) return null;
        return cellCtrl.getGui();
    }
    getRowType(rowIndex) {
        const allCtrls = this.getAllCtrls();
        const ctrl = allCtrls[rowIndex];
        return ctrl ? ctrl.getType() : void 0;
    }
    focusHeader(rowIndex, column, event) {
        const allCtrls = this.getAllCtrls();
        const ctrl = allCtrls[rowIndex];
        if (!ctrl) return false;
        return ctrl.focusHeader(column, event);
    }
    getViewport() {
        return this.eViewport;
    }
    getRowCount() {
        return this.groupsRowCtrls.length + (this.columnsRowCtrl ? 1 : 0) + (this.filtersRowCtrl ? 1 : 0);
    }
    destroy() {
        if (this.filtersRowCtrl) this.filtersRowCtrl = this.destroyBean(this.filtersRowCtrl);
        if (this.columnsRowCtrl) this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl);
        if (this.groupsRowCtrls && this.groupsRowCtrls.length) this.groupsRowCtrls = this.destroyBeans(this.groupsRowCtrls);
        super.destroy();
    }
};
__decorateClass([
    Autowired("ctrlsService")
], HeaderRowContainerCtrl.prototype, "ctrlsService", 2);
__decorateClass([
    Autowired("scrollVisibleService")
], HeaderRowContainerCtrl.prototype, "scrollVisibleService", 2);
__decorateClass([
    Autowired("pinnedWidthService")
], HeaderRowContainerCtrl.prototype, "pinnedWidthService", 2);
__decorateClass([
    Autowired("columnModel")
], HeaderRowContainerCtrl.prototype, "columnModel", 2);
__decorateClass([
    Autowired("focusService")
], HeaderRowContainerCtrl.prototype, "focusService", 2);
__decorateClass([
    Autowired("filterManager")
], HeaderRowContainerCtrl.prototype, "filterManager", 2);
// community-modules/core/src/headerRendering/rowContainer/headerRowContainerComp.ts
var _HeaderRowContainerComp = class _HeaderRowContainerComp extends Component {
    constructor(pinned){
        super();
        this.headerRowComps = {};
        this.rowCompsList = [];
        this.pinned = pinned;
    }
    init() {
        this.selectAndSetTemplate();
        const compProxy = {
            setDisplayed: (displayed)=>this.setDisplayed(displayed),
            setCtrls: (ctrls)=>this.setCtrls(ctrls),
            // only gets called for center section
            setCenterWidth: (width)=>this.eCenterContainer.style.width = width,
            setViewportScrollLeft: (left)=>this.getGui().scrollLeft = left,
            // only gets called for pinned sections
            setPinnedContainerWidth: (width)=>{
                const eGui = this.getGui();
                eGui.style.width = width;
                eGui.style.maxWidth = width;
                eGui.style.minWidth = width;
            }
        };
        const ctrl = this.createManagedBean(new HeaderRowContainerCtrl(this.pinned));
        ctrl.setComp(compProxy, this.getGui());
    }
    selectAndSetTemplate() {
        const pinnedLeft = this.pinned == "left";
        const pinnedRight = this.pinned == "right";
        const template = pinnedLeft ? _HeaderRowContainerComp.PINNED_LEFT_TEMPLATE : pinnedRight ? _HeaderRowContainerComp.PINNED_RIGHT_TEMPLATE : _HeaderRowContainerComp.CENTER_TEMPLATE;
        this.setTemplate(template);
        this.eRowContainer = this.eCenterContainer ? this.eCenterContainer : this.getGui();
    }
    destroyRowComps() {
        this.setCtrls([]);
    }
    destroyRowComp(rowComp) {
        this.destroyBean(rowComp);
        this.eRowContainer.removeChild(rowComp.getGui());
    }
    setCtrls(ctrls) {
        const oldRowComps = this.headerRowComps;
        this.headerRowComps = {};
        this.rowCompsList = [];
        let prevGui;
        const appendEnsuringDomOrder = (rowComp)=>{
            const eGui = rowComp.getGui();
            const notAlreadyIn = eGui.parentElement != this.eRowContainer;
            if (notAlreadyIn) this.eRowContainer.appendChild(eGui);
            if (prevGui) ensureDomOrder(this.eRowContainer, eGui, prevGui);
            prevGui = eGui;
        };
        ctrls.forEach((ctrl)=>{
            const ctrlId = ctrl.getInstanceId();
            const existingComp = oldRowComps[ctrlId];
            delete oldRowComps[ctrlId];
            const rowComp = existingComp ? existingComp : this.createBean(new HeaderRowComp(ctrl));
            this.headerRowComps[ctrlId] = rowComp;
            this.rowCompsList.push(rowComp);
            appendEnsuringDomOrder(rowComp);
        });
        getAllValuesInObject(oldRowComps).forEach((c)=>this.destroyRowComp(c));
    }
};
_HeaderRowContainerComp.PINNED_LEFT_TEMPLATE = /* html */ `<div class="ag-pinned-left-header" role="rowgroup"></div>`;
_HeaderRowContainerComp.PINNED_RIGHT_TEMPLATE = /* html */ `<div class="ag-pinned-right-header" role="rowgroup"></div>`;
_HeaderRowContainerComp.CENTER_TEMPLATE = /* html */ `<div class="ag-header-viewport" role="presentation">
            <div class="ag-header-container" ref="eCenterContainer" role="rowgroup"></div>
        </div>`;
__decorateClass([
    RefSelector("eCenterContainer")
], _HeaderRowContainerComp.prototype, "eCenterContainer", 2);
__decorateClass([
    PostConstruct
], _HeaderRowContainerComp.prototype, "init", 1);
__decorateClass([
    PreDestroy
], _HeaderRowContainerComp.prototype, "destroyRowComps", 1);
var HeaderRowContainerComp = _HeaderRowContainerComp;
// community-modules/core/src/headerRendering/common/headerNavigationService.ts
var HeaderNavigationDirection = /* @__PURE__ */ ((HeaderNavigationDirection2)=>{
    HeaderNavigationDirection2[HeaderNavigationDirection2["UP"] = 0] = "UP";
    HeaderNavigationDirection2[HeaderNavigationDirection2["DOWN"] = 1] = "DOWN";
    HeaderNavigationDirection2[HeaderNavigationDirection2["LEFT"] = 2] = "LEFT";
    HeaderNavigationDirection2[HeaderNavigationDirection2["RIGHT"] = 3] = "RIGHT";
    return HeaderNavigationDirection2;
})(HeaderNavigationDirection || {});
var HeaderNavigationService = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.currentHeaderRowWithoutSpan = -1;
    }
    postConstruct() {
        this.ctrlsService.whenReady((p)=>{
            this.gridBodyCon = p.gridBodyCtrl;
        });
        const eDocument = this.gos.getDocument();
        this.addManagedListener(eDocument, "mousedown", ()=>this.setCurrentHeaderRowWithoutSpan(-1));
    }
    getHeaderRowCount() {
        const centerHeaderContainer = this.ctrlsService.getHeaderRowContainerCtrl();
        return centerHeaderContainer ? centerHeaderContainer.getRowCount() : 0;
    }
    /*
   * This method navigates grid header vertically
   * @return {boolean} true to preventDefault on the event that caused this navigation.
   */ navigateVertically(direction, fromHeader, event) {
        if (!fromHeader) fromHeader = this.focusService.getFocusedHeader();
        if (!fromHeader) return false;
        const { headerRowIndex, column } = fromHeader;
        const rowLen = this.getHeaderRowCount();
        const isUp = direction === 0 /* UP */ ;
        let { headerRowIndex: nextRow, column: nextFocusColumn, headerRowIndexWithoutSpan } = isUp ? this.headerPositionUtils.getColumnVisibleParent(column, headerRowIndex) : this.headerPositionUtils.getColumnVisibleChild(column, headerRowIndex);
        let skipColumn = false;
        if (nextRow < 0) {
            nextRow = 0;
            nextFocusColumn = column;
            skipColumn = true;
        }
        if (nextRow >= rowLen) {
            nextRow = -1;
            this.setCurrentHeaderRowWithoutSpan(-1);
        } else if (headerRowIndexWithoutSpan !== void 0) this.currentHeaderRowWithoutSpan = headerRowIndexWithoutSpan;
        if (!skipColumn && !nextFocusColumn) return false;
        return this.focusService.focusHeaderPosition({
            headerPosition: {
                headerRowIndex: nextRow,
                column: nextFocusColumn
            },
            allowUserOverride: true,
            event
        });
    }
    setCurrentHeaderRowWithoutSpan(row) {
        this.currentHeaderRowWithoutSpan = row;
    }
    /*
   * This method navigates grid header horizontally
   * @return {boolean} true to preventDefault on the event that caused this navigation.
   */ navigateHorizontally(direction, fromTab = false, event) {
        const focusedHeader = this.focusService.getFocusedHeader();
        const isLeft = direction === 2 /* LEFT */ ;
        const isRtl = this.gos.get("enableRtl");
        let nextHeader;
        let normalisedDirection;
        if (this.currentHeaderRowWithoutSpan !== -1) focusedHeader.headerRowIndex = this.currentHeaderRowWithoutSpan;
        else this.currentHeaderRowWithoutSpan = focusedHeader.headerRowIndex;
        if (isLeft !== isRtl) {
            normalisedDirection = "Before";
            nextHeader = this.headerPositionUtils.findHeader(focusedHeader, normalisedDirection);
        } else {
            normalisedDirection = "After";
            nextHeader = this.headerPositionUtils.findHeader(focusedHeader, normalisedDirection);
        }
        if (nextHeader || !fromTab) return this.focusService.focusHeaderPosition({
            headerPosition: nextHeader,
            direction: normalisedDirection,
            fromTab,
            allowUserOverride: true,
            event
        });
        else if (fromTab) {
            const userFunc = this.gos.getCallback("tabToNextHeader");
            if (userFunc) return this.focusService.focusHeaderPositionFromUserFunc({
                userFunc,
                headerPosition: nextHeader,
                direction: normalisedDirection
            });
        }
        return this.focusNextHeaderRow(focusedHeader, normalisedDirection, event);
    }
    focusNextHeaderRow(focusedHeader, direction, event) {
        const currentIndex = focusedHeader.headerRowIndex;
        let nextPosition = null;
        let nextRowIndex;
        if (direction === "Before") {
            if (currentIndex > 0) {
                nextRowIndex = currentIndex - 1;
                this.currentHeaderRowWithoutSpan -= 1;
                nextPosition = this.headerPositionUtils.findColAtEdgeForHeaderRow(nextRowIndex, "end");
            }
        } else {
            nextRowIndex = currentIndex + 1;
            if (this.currentHeaderRowWithoutSpan < this.getHeaderRowCount()) this.currentHeaderRowWithoutSpan += 1;
            else this.setCurrentHeaderRowWithoutSpan(-1);
            nextPosition = this.headerPositionUtils.findColAtEdgeForHeaderRow(nextRowIndex, "start");
        }
        if (!nextPosition) return false;
        const { column, headerRowIndex } = this.headerPositionUtils.getHeaderIndexToFocus(nextPosition.column, nextPosition == null ? void 0 : nextPosition.headerRowIndex);
        return this.focusService.focusHeaderPosition({
            headerPosition: {
                column,
                headerRowIndex
            },
            direction,
            fromTab: true,
            allowUserOverride: true,
            event
        });
    }
    scrollToColumn(column, direction = "After") {
        if (column.getPinned()) return;
        let columnToScrollTo;
        if (column instanceof ColumnGroup) {
            const columns = column.getDisplayedLeafColumns();
            columnToScrollTo = direction === "Before" ? last(columns) : columns[0];
        } else columnToScrollTo = column;
        this.gridBodyCon.getScrollFeature().ensureColumnVisible(columnToScrollTo);
    }
};
__decorateClass([
    Autowired("focusService")
], HeaderNavigationService.prototype, "focusService", 2);
__decorateClass([
    Autowired("headerPositionUtils")
], HeaderNavigationService.prototype, "headerPositionUtils", 2);
__decorateClass([
    Autowired("ctrlsService")
], HeaderNavigationService.prototype, "ctrlsService", 2);
__decorateClass([
    PostConstruct
], HeaderNavigationService.prototype, "postConstruct", 1);
HeaderNavigationService = __decorateClass([
    Bean("headerNavigationService")
], HeaderNavigationService);
// community-modules/core/src/headerRendering/gridHeaderCtrl.ts
var GridHeaderCtrl = class extends BeanStub {
    setComp(comp, eGui, eFocusableElement) {
        this.comp = comp;
        this.eGui = eGui;
        this.createManagedBean(new ManagedFocusFeature(eFocusableElement, {
            onTabKeyDown: this.onTabKeyDown.bind(this),
            handleKeyDown: this.handleKeyDown.bind(this),
            onFocusOut: this.onFocusOut.bind(this)
        }));
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.onPivotModeChanged.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
        this.onPivotModeChanged();
        this.setupHeaderHeight();
        const listener = this.onHeaderContextMenu.bind(this);
        this.addManagedListener(this.eGui, "contextmenu", listener);
        this.mockContextMenuForIPad(listener);
        this.ctrlsService.register("gridHeaderCtrl", this);
    }
    setupHeaderHeight() {
        const listener = this.setHeaderHeight.bind(this);
        listener();
        this.addManagedPropertyListener("headerHeight", listener);
        this.addManagedPropertyListener("pivotHeaderHeight", listener);
        this.addManagedPropertyListener("groupHeaderHeight", listener);
        this.addManagedPropertyListener("pivotGroupHeaderHeight", listener);
        this.addManagedPropertyListener("floatingFiltersHeight", listener);
        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, listener);
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_HEADER_HEIGHT_CHANGED, listener);
        this.addManagedListener(this.eventService, Events.EVENT_GRID_STYLES_CHANGED, listener);
        this.addManagedListener(this.eventService, Events.EVENT_ADVANCED_FILTER_ENABLED_CHANGED, listener);
    }
    getHeaderHeight() {
        return this.headerHeight;
    }
    setHeaderHeight() {
        const { columnModel } = this;
        let numberOfFloating = 0;
        let headerRowCount = columnModel.getHeaderRowCount();
        let totalHeaderHeight;
        const hasFloatingFilters = this.filterManager.hasFloatingFilters();
        if (hasFloatingFilters) {
            headerRowCount++;
            numberOfFloating = 1;
        }
        const groupHeight = this.columnModel.getColumnGroupHeaderRowHeight();
        const headerHeight = this.columnModel.getColumnHeaderRowHeight();
        const numberOfNonGroups = 1 + numberOfFloating;
        const numberOfGroups = headerRowCount - numberOfNonGroups;
        totalHeaderHeight = numberOfFloating * columnModel.getFloatingFiltersHeight();
        totalHeaderHeight += numberOfGroups * groupHeight;
        totalHeaderHeight += headerHeight;
        if (this.headerHeight === totalHeaderHeight) return;
        this.headerHeight = totalHeaderHeight;
        const px = `${totalHeaderHeight + 1}px`;
        this.comp.setHeightAndMinHeight(px);
        this.eventService.dispatchEvent({
            type: Events.EVENT_HEADER_HEIGHT_CHANGED
        });
    }
    onPivotModeChanged() {
        const pivotMode = this.columnModel.isPivotMode();
        this.comp.addOrRemoveCssClass("ag-pivot-on", pivotMode);
        this.comp.addOrRemoveCssClass("ag-pivot-off", !pivotMode);
    }
    onDisplayedColumnsChanged() {
        const columns = this.columnModel.getAllDisplayedColumns();
        const shouldAllowOverflow = columns.some((col)=>col.isSpanHeaderHeight());
        this.comp.addOrRemoveCssClass("ag-header-allow-overflow", shouldAllowOverflow);
    }
    onTabKeyDown(e) {
        const isRtl = this.gos.get("enableRtl");
        const direction = e.shiftKey !== isRtl ? 2 /* LEFT */  : 3 /* RIGHT */ ;
        if (this.headerNavigationService.navigateHorizontally(direction, true, e) || this.focusService.focusNextGridCoreContainer(e.shiftKey)) e.preventDefault();
    }
    handleKeyDown(e) {
        let direction = null;
        switch(e.key){
            case KeyCode.LEFT:
                direction = 2 /* LEFT */ ;
            case KeyCode.RIGHT:
                if (!exists(direction)) direction = 3 /* RIGHT */ ;
                this.headerNavigationService.navigateHorizontally(direction, false, e);
                break;
            case KeyCode.UP:
                direction = 0 /* UP */ ;
            case KeyCode.DOWN:
                if (!exists(direction)) direction = 1 /* DOWN */ ;
                if (this.headerNavigationService.navigateVertically(direction, null, e)) e.preventDefault();
                break;
            default:
                return;
        }
    }
    onFocusOut(e) {
        const { relatedTarget } = e;
        if (!relatedTarget && this.eGui.contains(this.gos.getActiveDomElement())) return;
        if (!this.eGui.contains(relatedTarget)) this.focusService.clearFocusedHeader();
    }
    onHeaderContextMenu(mouseEvent, touch, touchEvent) {
        if (!mouseEvent && !touchEvent || !this.menuService.isHeaderContextMenuEnabled()) return;
        const { target } = mouseEvent != null ? mouseEvent : touch;
        if (target === this.eGui || target === this.ctrlsService.getHeaderRowContainerCtrl().getViewport()) this.menuService.showHeaderContextMenu(void 0, mouseEvent, touchEvent);
    }
    mockContextMenuForIPad(listener) {
        if (!isIOSUserAgent()) return;
        const touchListener = new TouchListener(this.eGui);
        const longTapListener = (event)=>{
            listener(void 0, event.touchStart, event.touchEvent);
        };
        this.addManagedListener(touchListener, TouchListener.EVENT_LONG_TAP, longTapListener);
        this.addDestroyFunc(()=>touchListener.destroy());
    }
};
__decorateClass([
    Autowired("headerNavigationService")
], GridHeaderCtrl.prototype, "headerNavigationService", 2);
__decorateClass([
    Autowired("focusService")
], GridHeaderCtrl.prototype, "focusService", 2);
__decorateClass([
    Autowired("columnModel")
], GridHeaderCtrl.prototype, "columnModel", 2);
__decorateClass([
    Autowired("ctrlsService")
], GridHeaderCtrl.prototype, "ctrlsService", 2);
__decorateClass([
    Autowired("filterManager")
], GridHeaderCtrl.prototype, "filterManager", 2);
__decorateClass([
    Autowired("menuService")
], GridHeaderCtrl.prototype, "menuService", 2);
// community-modules/core/src/headerRendering/gridHeaderComp.ts
var _GridHeaderComp = class _GridHeaderComp extends Component {
    constructor(){
        super(_GridHeaderComp.TEMPLATE);
    }
    postConstruct() {
        const compProxy = {
            addOrRemoveCssClass: (cssClassName, on)=>this.addOrRemoveCssClass(cssClassName, on),
            setHeightAndMinHeight: (height)=>{
                this.getGui().style.height = height;
                this.getGui().style.minHeight = height;
            }
        };
        const ctrl = this.createManagedBean(new GridHeaderCtrl());
        ctrl.setComp(compProxy, this.getGui(), this.getFocusableElement());
        const addContainer = (container)=>{
            this.createManagedBean(container);
            this.appendChild(container);
        };
        addContainer(new HeaderRowContainerComp("left"));
        addContainer(new HeaderRowContainerComp(null));
        addContainer(new HeaderRowContainerComp("right"));
    }
};
_GridHeaderComp.TEMPLATE = /* html */ `<div class="ag-header" role="presentation"/>`;
__decorateClass([
    PostConstruct
], _GridHeaderComp.prototype, "postConstruct", 1);
var GridHeaderComp = _GridHeaderComp;
// community-modules/core/src/headerRendering/common/horizontalResizeService.ts
var HorizontalResizeService = class extends BeanStub {
    addResizeBar(params) {
        const dragSource = {
            dragStartPixels: params.dragStartPixels || 0,
            eElement: params.eResizeBar,
            onDragStart: this.onDragStart.bind(this, params),
            onDragStop: this.onDragStop.bind(this, params),
            onDragging: this.onDragging.bind(this, params),
            includeTouch: true,
            stopPropagationForTouch: true
        };
        this.dragService.addDragSource(dragSource);
        const finishedWithResizeFunc = ()=>this.dragService.removeDragSource(dragSource);
        return finishedWithResizeFunc;
    }
    onDragStart(params, mouseEvent) {
        this.dragStartX = mouseEvent.clientX;
        this.setResizeIcons();
        const shiftKey = mouseEvent instanceof MouseEvent && mouseEvent.shiftKey === true;
        params.onResizeStart(shiftKey);
    }
    setResizeIcons() {
        const ctrl = this.ctrlsService.get("gridCtrl");
        ctrl.setResizeCursor(true);
        ctrl.disableUserSelect(true);
    }
    onDragStop(params, mouseEvent) {
        params.onResizeEnd(this.resizeAmount);
        this.resetIcons();
    }
    resetIcons() {
        const ctrl = this.ctrlsService.get("gridCtrl");
        ctrl.setResizeCursor(false);
        ctrl.disableUserSelect(false);
    }
    onDragging(params, mouseEvent) {
        this.resizeAmount = mouseEvent.clientX - this.dragStartX;
        params.onResizing(this.resizeAmount);
    }
};
__decorateClass([
    Autowired("dragService")
], HorizontalResizeService.prototype, "dragService", 2);
__decorateClass([
    Autowired("ctrlsService")
], HorizontalResizeService.prototype, "ctrlsService", 2);
HorizontalResizeService = __decorateClass([
    Bean("horizontalResizeService")
], HorizontalResizeService);
// community-modules/core/src/headerRendering/cells/column/standardMenu.ts
var StandardMenuFactory = class extends BeanStub {
    hideActiveMenu() {
        if (this.hidePopup) this.hidePopup();
    }
    showMenuAfterMouseEvent(column, mouseEvent, containerType) {
        this.showPopup(column, (eMenu)=>{
            this.popupService.positionPopupUnderMouseEvent({
                column,
                type: containerType,
                mouseEvent,
                ePopup: eMenu
            });
        }, containerType, mouseEvent.target, this.menuService.isLegacyMenuEnabled());
    }
    showMenuAfterButtonClick(column, eventSource, containerType) {
        let multiplier = -1;
        let alignSide = "left";
        const isLegacyMenuEnabled = this.menuService.isLegacyMenuEnabled();
        if (!isLegacyMenuEnabled && this.gos.get("enableRtl")) {
            multiplier = 1;
            alignSide = "right";
        }
        let nudgeX = isLegacyMenuEnabled ? void 0 : 4 * multiplier;
        let nudgeY = isLegacyMenuEnabled ? void 0 : 4;
        this.showPopup(column, (eMenu)=>{
            this.popupService.positionPopupByComponent({
                type: containerType,
                eventSource,
                ePopup: eMenu,
                nudgeX,
                nudgeY,
                alignSide,
                keepWithinBounds: true,
                position: "under",
                column
            });
        }, containerType, eventSource, isLegacyMenuEnabled);
    }
    showPopup(column, positionCallback, containerType, eventSource, isLegacyMenuEnabled) {
        const comp = column ? this.createBean(new FilterWrapperComp(column, "COLUMN_MENU")) : void 0;
        this.activeMenu = comp;
        if (!(comp == null ? void 0 : comp.hasFilter()) || !column) throw new Error("AG Grid - unable to show popup filter, filter instantiation failed");
        const eMenu = document.createElement("div");
        setAriaRole(eMenu, "presentation");
        eMenu.classList.add("ag-menu");
        if (!isLegacyMenuEnabled) eMenu.classList.add("ag-filter-menu");
        this.tabListener = this.addManagedListener(eMenu, "keydown", (e)=>this.trapFocusWithin(e, eMenu));
        eMenu.appendChild(comp == null ? void 0 : comp.getGui());
        let hidePopup;
        const afterGuiDetached = ()=>comp == null ? void 0 : comp.afterGuiDetached();
        const anchorToElement = this.menuService.isColumnMenuAnchoringEnabled() ? eventSource != null ? eventSource : this.ctrlsService.getGridBodyCtrl().getGui() : void 0;
        const closedCallback = (e)=>{
            column.setMenuVisible(false, "contextMenu");
            const isKeyboardEvent = e instanceof KeyboardEvent;
            if (this.tabListener) this.tabListener = this.tabListener();
            if (isKeyboardEvent && eventSource && isVisible(eventSource)) {
                const focusableEl = this.focusService.findTabbableParent(eventSource);
                if (focusableEl) focusableEl.focus();
            }
            afterGuiDetached();
            this.destroyBean(this.activeMenu);
            this.dispatchVisibleChangedEvent(false, containerType, column);
        };
        const translate = this.localeService.getLocaleTextFunc();
        const ariaLabel = isLegacyMenuEnabled && containerType !== "columnFilter" ? translate("ariaLabelColumnMenu", "Column Menu") : translate("ariaLabelColumnFilter", "Column Filter");
        const addPopupRes = this.popupService.addPopup({
            modal: true,
            eChild: eMenu,
            closeOnEsc: true,
            closedCallback,
            positionCallback: ()=>positionCallback(eMenu),
            anchorToElement,
            ariaLabel
        });
        if (addPopupRes) this.hidePopup = hidePopup = addPopupRes.hideFunc;
        comp.afterInit().then(()=>{
            positionCallback(eMenu);
            comp.afterGuiAttached({
                container: containerType,
                hidePopup
            });
        });
        column.setMenuVisible(true, "contextMenu");
        this.dispatchVisibleChangedEvent(true, containerType, column);
    }
    trapFocusWithin(e, menu) {
        if (e.key !== KeyCode.TAB || e.defaultPrevented || this.focusService.findNextFocusableElement(menu, false, e.shiftKey)) return;
        e.preventDefault();
        this.focusService.focusInto(menu, e.shiftKey);
    }
    dispatchVisibleChangedEvent(visible, containerType, column) {
        const displayedEvent = {
            type: Events.EVENT_COLUMN_MENU_VISIBLE_CHANGED,
            visible,
            switchingTab: false,
            key: containerType,
            column: column != null ? column : null
        };
        this.eventService.dispatchEvent(displayedEvent);
    }
    isMenuEnabled(column) {
        var _a;
        return column.isFilterAllowed() && ((_a = column.getColDef().menuTabs) != null ? _a : [
            "filterMenuTab"
        ]).includes("filterMenuTab");
    }
    showMenuAfterContextMenuEvent() {}
    destroy() {
        this.destroyBean(this.activeMenu);
        super.destroy();
    }
};
__decorateClass([
    Autowired("filterManager")
], StandardMenuFactory.prototype, "filterManager", 2);
__decorateClass([
    Autowired("popupService")
], StandardMenuFactory.prototype, "popupService", 2);
__decorateClass([
    Autowired("focusService")
], StandardMenuFactory.prototype, "focusService", 2);
__decorateClass([
    Autowired("ctrlsService")
], StandardMenuFactory.prototype, "ctrlsService", 2);
__decorateClass([
    Autowired("menuService")
], StandardMenuFactory.prototype, "menuService", 2);
StandardMenuFactory = __decorateClass([
    Bean("filterMenuFactory")
], StandardMenuFactory);
// community-modules/core/src/widgets/tabGuardCtrl.ts
var TabGuardClassNames = /* @__PURE__ */ ((TabGuardClassNames2)=>{
    TabGuardClassNames2["TAB_GUARD"] = "ag-tab-guard";
    TabGuardClassNames2["TAB_GUARD_TOP"] = "ag-tab-guard-top";
    TabGuardClassNames2["TAB_GUARD_BOTTOM"] = "ag-tab-guard-bottom";
    return TabGuardClassNames2;
})(TabGuardClassNames || {});
var TabGuardCtrl = class extends BeanStub {
    constructor(params){
        super();
        this.skipTabGuardFocus = false;
        this.forcingFocusOut = false;
        const { comp, eTopGuard, eBottomGuard, focusTrapActive, forceFocusOutWhenTabGuardsAreEmpty, focusInnerElement, onFocusIn, onFocusOut, shouldStopEventPropagation, onTabKeyDown, handleKeyDown, eFocusableElement } = params;
        this.comp = comp;
        this.eTopGuard = eTopGuard;
        this.eBottomGuard = eBottomGuard;
        this.providedFocusInnerElement = focusInnerElement;
        this.eFocusableElement = eFocusableElement;
        this.focusTrapActive = !!focusTrapActive;
        this.forceFocusOutWhenTabGuardsAreEmpty = !!forceFocusOutWhenTabGuardsAreEmpty;
        this.providedFocusIn = onFocusIn;
        this.providedFocusOut = onFocusOut;
        this.providedShouldStopEventPropagation = shouldStopEventPropagation;
        this.providedOnTabKeyDown = onTabKeyDown;
        this.providedHandleKeyDown = handleKeyDown;
    }
    postConstruct() {
        this.createManagedBean(new ManagedFocusFeature(this.eFocusableElement, {
            shouldStopEventPropagation: ()=>this.shouldStopEventPropagation(),
            onTabKeyDown: (e)=>this.onTabKeyDown(e),
            handleKeyDown: (e)=>this.handleKeyDown(e),
            onFocusIn: (e)=>this.onFocusIn(e),
            onFocusOut: (e)=>this.onFocusOut(e)
        }));
        this.activateTabGuards();
        [
            this.eTopGuard,
            this.eBottomGuard
        ].forEach((guard)=>this.addManagedListener(guard, "focus", this.onFocus.bind(this)));
    }
    handleKeyDown(e) {
        if (this.providedHandleKeyDown) this.providedHandleKeyDown(e);
    }
    tabGuardsAreActive() {
        return !!this.eTopGuard && this.eTopGuard.hasAttribute("tabIndex");
    }
    shouldStopEventPropagation() {
        if (this.providedShouldStopEventPropagation) return this.providedShouldStopEventPropagation();
        return false;
    }
    activateTabGuards() {
        if (this.forcingFocusOut) return;
        const tabIndex = this.gos.get("tabIndex");
        this.comp.setTabIndex(tabIndex.toString());
    }
    deactivateTabGuards() {
        this.comp.setTabIndex();
    }
    onFocus(e) {
        if (this.skipTabGuardFocus) {
            this.skipTabGuardFocus = false;
            return;
        }
        if (this.forceFocusOutWhenTabGuardsAreEmpty) {
            const isEmpty = this.focusService.findFocusableElements(this.eFocusableElement, ".ag-tab-guard").length === 0;
            if (isEmpty) {
                this.findNextElementOutsideAndFocus(e.target === this.eBottomGuard);
                return;
            }
        }
        const fromBottom = e.target === this.eBottomGuard;
        if (this.providedFocusInnerElement) this.providedFocusInnerElement(fromBottom);
        else this.focusInnerElement(fromBottom);
    }
    findNextElementOutsideAndFocus(up) {
        const eDocument = this.gos.getDocument();
        const focusableEls = this.focusService.findFocusableElements(eDocument.body, null, true);
        const index = focusableEls.indexOf(up ? this.eTopGuard : this.eBottomGuard);
        if (index === -1) return;
        let start;
        let end;
        if (up) {
            start = 0;
            end = index;
        } else {
            start = index + 1;
            end = focusableEls.length;
        }
        const focusableRange = focusableEls.slice(start, end);
        const targetTabIndex = this.gos.get("tabIndex");
        focusableRange.sort((a, b)=>{
            const indexA = parseInt(a.getAttribute("tabindex") || "0");
            const indexB = parseInt(b.getAttribute("tabindex") || "0");
            if (indexB === targetTabIndex) return 1;
            if (indexA === targetTabIndex) return -1;
            if (indexA === 0) return 1;
            if (indexB === 0) return -1;
            return indexA - indexB;
        });
        focusableRange[up ? focusableRange.length - 1 : 0].focus();
    }
    onFocusIn(e) {
        if (this.focusTrapActive) return;
        if (this.providedFocusIn) this.providedFocusIn(e);
        this.deactivateTabGuards();
    }
    onFocusOut(e) {
        if (this.focusTrapActive) return;
        if (this.providedFocusOut) this.providedFocusOut(e);
        if (!this.eFocusableElement.contains(e.relatedTarget)) this.activateTabGuards();
    }
    onTabKeyDown(e) {
        if (this.providedOnTabKeyDown) {
            this.providedOnTabKeyDown(e);
            return;
        }
        if (this.focusTrapActive) return;
        if (e.defaultPrevented) return;
        const tabGuardsAreActive = this.tabGuardsAreActive();
        if (tabGuardsAreActive) this.deactivateTabGuards();
        const nextRoot = this.getNextFocusableElement(e.shiftKey);
        if (tabGuardsAreActive) setTimeout(()=>this.activateTabGuards(), 0);
        if (!nextRoot) return;
        nextRoot.focus();
        e.preventDefault();
    }
    focusInnerElement(fromBottom = false) {
        const focusable = this.focusService.findFocusableElements(this.eFocusableElement);
        if (this.tabGuardsAreActive()) {
            focusable.splice(0, 1);
            focusable.splice(focusable.length - 1, 1);
        }
        if (!focusable.length) return;
        focusable[fromBottom ? focusable.length - 1 : 0].focus({
            preventScroll: true
        });
    }
    getNextFocusableElement(backwards) {
        return this.focusService.findNextFocusableElement(this.eFocusableElement, false, backwards);
    }
    forceFocusOutOfContainer(up = false) {
        if (this.forcingFocusOut) return;
        const tabGuardToFocus = up ? this.eTopGuard : this.eBottomGuard;
        this.activateTabGuards();
        this.skipTabGuardFocus = true;
        this.forcingFocusOut = true;
        tabGuardToFocus.focus();
        window.setTimeout(()=>{
            this.forcingFocusOut = false;
            this.activateTabGuards();
        });
    }
    isTabGuard(element) {
        return element === this.eTopGuard || element === this.eBottomGuard;
    }
};
__decorateClass([
    Autowired("focusService")
], TabGuardCtrl.prototype, "focusService", 2);
__decorateClass([
    PostConstruct
], TabGuardCtrl.prototype, "postConstruct", 1);
// community-modules/core/src/widgets/tabGuardComp.ts
var TabGuardComp = class extends Component {
    initialiseTabGuard(params) {
        this.eTopGuard = this.createTabGuard("top");
        this.eBottomGuard = this.createTabGuard("bottom");
        this.eFocusableElement = this.getFocusableElement();
        const tabGuards = [
            this.eTopGuard,
            this.eBottomGuard
        ];
        const compProxy = {
            setTabIndex: (tabIndex)=>{
                tabGuards.forEach((tabGuard)=>tabIndex != null ? tabGuard.setAttribute("tabindex", tabIndex) : tabGuard.removeAttribute("tabindex"));
            }
        };
        this.addTabGuards(this.eTopGuard, this.eBottomGuard);
        this.tabGuardCtrl = this.createManagedBean(new TabGuardCtrl({
            comp: compProxy,
            focusTrapActive: !!params.focusTrapActive,
            eTopGuard: this.eTopGuard,
            eBottomGuard: this.eBottomGuard,
            eFocusableElement: this.eFocusableElement,
            onFocusIn: params.onFocusIn,
            onFocusOut: params.onFocusOut,
            focusInnerElement: params.focusInnerElement,
            handleKeyDown: params.handleKeyDown,
            onTabKeyDown: params.onTabKeyDown,
            shouldStopEventPropagation: params.shouldStopEventPropagation,
            forceFocusOutWhenTabGuardsAreEmpty: params.forceFocusOutWhenTabGuardsAreEmpty
        }));
    }
    createTabGuard(side) {
        const tabGuard = document.createElement("div");
        const cls = side === "top" ? "ag-tab-guard-top" /* TAB_GUARD_TOP */  : "ag-tab-guard-bottom" /* TAB_GUARD_BOTTOM */ ;
        tabGuard.classList.add("ag-tab-guard" /* TAB_GUARD */ , cls);
        setAriaRole(tabGuard, "presentation");
        return tabGuard;
    }
    addTabGuards(topTabGuard, bottomTabGuard) {
        this.eFocusableElement.insertAdjacentElement("afterbegin", topTabGuard);
        this.eFocusableElement.insertAdjacentElement("beforeend", bottomTabGuard);
    }
    removeAllChildrenExceptTabGuards() {
        const tabGuards = [
            this.eTopGuard,
            this.eBottomGuard
        ];
        clearElement(this.getFocusableElement());
        this.addTabGuards(...tabGuards);
    }
    forceFocusOutOfContainer(up = false) {
        this.tabGuardCtrl.forceFocusOutOfContainer(up);
    }
    appendChild(newChild, container) {
        if (!isNodeOrElement(newChild)) newChild = newChild.getGui();
        const { eBottomGuard: bottomTabGuard } = this;
        if (bottomTabGuard) bottomTabGuard.insertAdjacentElement("beforebegin", newChild);
        else super.appendChild(newChild, container);
    }
};
// community-modules/core/src/layout/tabbedLayout.ts
var _TabbedLayout = class _TabbedLayout extends TabGuardComp {
    constructor(params){
        super(_TabbedLayout.getTemplate(params.cssClass));
        this.items = [];
        this.tabbedItemScrollMap = /* @__PURE__ */ new Map();
        this.params = params;
    }
    postConstruct() {
        this.setupHeader();
        if (this.params.items) this.params.items.forEach((item)=>this.addItem(item));
        this.initialiseTabGuard({
            onTabKeyDown: this.onTabKeyDown.bind(this),
            handleKeyDown: this.handleKeyDown.bind(this),
            focusInnerElement: this.focusInnerElement.bind(this),
            focusTrapActive: true
        });
        this.addDestroyFunc(()=>{
            var _a, _b, _c;
            return (_c = (_b = (_a = this.activeItem) == null ? void 0 : _a.tabbedItem) == null ? void 0 : _b.afterDetachedCallback) == null ? void 0 : _c.call(_b);
        });
    }
    static getTemplate(cssClass) {
        return /* html */ `<div class="ag-tabs ${cssClass}">
            <div ref="eHeader"></div>
            <div ref="eBody" role="presentation" class="ag-tabs-body ${cssClass ? `${cssClass}-body` : ""}"></div>
        </div>`;
    }
    setupHeader() {
        const { enableCloseButton, cssClass } = this.params;
        const addCssClasses = (el, suffix)=>{
            el.classList.add(`ag-tabs-${suffix}`);
            if (cssClass) el.classList.add(`${cssClass}-${suffix}`);
        };
        if (enableCloseButton) {
            this.setupCloseButton(addCssClasses);
            this.eTabHeader = this.gos.getDocument().createElement("div");
            addCssClasses(this.eHeader, "header-wrapper");
            setAriaRole(this.eHeader, "presentation");
            this.eHeader.appendChild(this.eTabHeader);
        } else this.eTabHeader = this.eHeader;
        setAriaRole(this.eTabHeader, "tablist");
        addCssClasses(this.eTabHeader, "header");
    }
    setupCloseButton(addCssClasses) {
        const eDocument = this.gos.getDocument();
        const eCloseButton = eDocument.createElement("button");
        addCssClasses(eCloseButton, "close-button");
        const eIcon = createIconNoSpan("close", this.gos, void 0, true);
        setAriaLabel(eCloseButton, this.params.closeButtonAriaLabel);
        eCloseButton.appendChild(eIcon);
        this.addManagedListener(eCloseButton, "click", ()=>{
            var _a, _b;
            return (_b = (_a = this.params).onCloseClicked) == null ? void 0 : _b.call(_a);
        });
        const eCloseButtonWrapper = eDocument.createElement("div");
        addCssClasses(eCloseButtonWrapper, "close-button-wrapper");
        setAriaRole(eCloseButtonWrapper, "presentation");
        eCloseButtonWrapper.appendChild(eCloseButton);
        this.eHeader.appendChild(eCloseButtonWrapper);
        this.eCloseButton = eCloseButton;
    }
    handleKeyDown(e) {
        switch(e.key){
            case KeyCode.RIGHT:
            case KeyCode.LEFT:
                if (!this.eTabHeader.contains(this.gos.getActiveDomElement())) return;
                const isRightKey = e.key === KeyCode.RIGHT;
                const isRtl = this.gos.get("enableRtl");
                const currentPosition = this.items.indexOf(this.activeItem);
                const nextPosition = isRightKey !== isRtl ? Math.min(currentPosition + 1, this.items.length - 1) : Math.max(currentPosition - 1, 0);
                if (currentPosition === nextPosition) return;
                e.preventDefault();
                const nextItem = this.items[nextPosition];
                this.showItemWrapper(nextItem);
                nextItem.eHeaderButton.focus();
                break;
            case KeyCode.UP:
            case KeyCode.DOWN:
                e.stopPropagation();
                break;
        }
    }
    onTabKeyDown(e) {
        var _a, _b, _c, _d;
        if (e.defaultPrevented) return;
        const { focusService, eHeader, eBody, activeItem, params } = this;
        const { suppressTrapFocus, enableCloseButton } = params;
        const activeElement = this.gos.getActiveDomElement();
        const target = e.target;
        const backwards = e.shiftKey;
        if (eHeader.contains(activeElement)) {
            e.preventDefault();
            if (enableCloseButton && backwards && !((_a = this.eCloseButton) == null ? void 0 : _a.contains(activeElement))) (_b = this.eCloseButton) == null || _b.focus();
            else if (suppressTrapFocus && backwards) (_c = this.focusService.findFocusableElementBeforeTabGuard(this.gos.getDocument().body, target)) == null || _c.focus();
            else this.focusBody(e.shiftKey);
            return;
        }
        let nextEl = null;
        if (focusService.isTargetUnderManagedComponent(eBody, target)) {
            if (backwards) nextEl = this.focusService.findFocusableElementBeforeTabGuard(eBody, target);
            if (!nextEl && !suppressTrapFocus) nextEl = activeItem.eHeaderButton;
        }
        if (!nextEl && eBody.contains(activeElement)) {
            nextEl = focusService.findNextFocusableElement(eBody, false, backwards);
            if (!nextEl) {
                e.preventDefault();
                if (suppressTrapFocus && !backwards) this.forceFocusOutOfContainer(backwards);
                else if (enableCloseButton && !backwards) (_d = this.eCloseButton) == null || _d.focus();
                else this.focusHeader();
                return;
            }
        }
        if (nextEl) {
            e.preventDefault();
            nextEl.focus();
        }
    }
    focusInnerElement(fromBottom) {
        if (fromBottom) this.focusHeader();
        else this.focusBody(true);
    }
    focusHeader(preventScroll) {
        this.activeItem.eHeaderButton.focus({
            preventScroll
        });
    }
    focusBody(fromBottom) {
        this.focusService.focusInto(this.eBody, fromBottom);
    }
    setAfterAttachedParams(params) {
        this.afterAttachedParams = params;
    }
    showFirstItem() {
        if (this.items.length > 0) this.showItemWrapper(this.items[0]);
    }
    addItem(item) {
        const eHeaderButton = document.createElement("span");
        setAriaRole(eHeaderButton, "tab");
        eHeaderButton.setAttribute("tabindex", "-1");
        eHeaderButton.appendChild(item.title);
        eHeaderButton.classList.add("ag-tab");
        this.eTabHeader.appendChild(eHeaderButton);
        setAriaLabel(eHeaderButton, item.titleLabel);
        const wrapper = {
            tabbedItem: item,
            eHeaderButton
        };
        this.items.push(wrapper);
        eHeaderButton.addEventListener("click", this.showItemWrapper.bind(this, wrapper));
    }
    showItem(tabbedItem) {
        const itemWrapper = this.items.find((wrapper)=>wrapper.tabbedItem === tabbedItem);
        if (itemWrapper) this.showItemWrapper(itemWrapper);
    }
    showItemWrapper(wrapper) {
        var _a, _b, _c, _d, _e, _f;
        const { tabbedItem, eHeaderButton } = wrapper;
        (_b = (_a = this.params).onItemClicked) == null || _b.call(_a, {
            item: tabbedItem
        });
        if (this.activeItem === wrapper) {
            (_d = (_c = this.params).onActiveItemClicked) == null || _d.call(_c);
            return;
        }
        if (this.lastScrollListener) this.lastScrollListener = this.lastScrollListener();
        clearElement(this.eBody);
        tabbedItem.bodyPromise.then((body)=>{
            this.eBody.appendChild(body);
            const onlyUnmanaged = !this.focusService.isKeyboardMode();
            if (!this.params.suppressFocusBodyOnOpen) this.focusService.focusInto(this.eBody, false, onlyUnmanaged);
            if (tabbedItem.afterAttachedCallback) tabbedItem.afterAttachedCallback(this.afterAttachedParams);
            if (this.params.keepScrollPosition) {
                const scrollableContainer = tabbedItem.getScrollableContainer && tabbedItem.getScrollableContainer() || body;
                this.lastScrollListener = this.addManagedListener(scrollableContainer, "scroll", ()=>{
                    this.tabbedItemScrollMap.set(tabbedItem.name, scrollableContainer.scrollTop);
                });
                const scrollPosition = this.tabbedItemScrollMap.get(tabbedItem.name);
                if (scrollPosition !== void 0) setTimeout(()=>{
                    scrollableContainer.scrollTop = scrollPosition;
                }, 0);
            }
        });
        if (this.activeItem) {
            this.activeItem.eHeaderButton.classList.remove("ag-tab-selected");
            (_f = (_e = this.activeItem.tabbedItem).afterDetachedCallback) == null || _f.call(_e);
        }
        eHeaderButton.classList.add("ag-tab-selected");
        this.activeItem = wrapper;
    }
};
__decorateClass([
    Autowired("focusService")
], _TabbedLayout.prototype, "focusService", 2);
__decorateClass([
    RefSelector("eHeader")
], _TabbedLayout.prototype, "eHeader", 2);
__decorateClass([
    RefSelector("eBody")
], _TabbedLayout.prototype, "eBody", 2);
__decorateClass([
    PostConstruct
], _TabbedLayout.prototype, "postConstruct", 1);
var TabbedLayout = _TabbedLayout;
// community-modules/core/src/misc/resizeObserverService.ts
var DEBOUNCE_DELAY = 50;
var ResizeObserverService = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.polyfillFunctions = [];
    }
    observeResize(element, callback) {
        const win = this.gos.getWindow();
        const useBrowserResizeObserver = ()=>{
            const resizeObserver = new win.ResizeObserver(callback);
            resizeObserver.observe(element);
            return ()=>resizeObserver.disconnect();
        };
        const usePolyfill = ()=>{
            var _a, _b;
            let widthLastTime = (_a = element == null ? void 0 : element.clientWidth) != null ? _a : 0;
            let heightLastTime = (_b = element == null ? void 0 : element.clientHeight) != null ? _b : 0;
            let running = true;
            const periodicallyCheckWidthAndHeight = ()=>{
                var _a2, _b2;
                if (running) {
                    const newWidth = (_a2 = element == null ? void 0 : element.clientWidth) != null ? _a2 : 0;
                    const newHeight = (_b2 = element == null ? void 0 : element.clientHeight) != null ? _b2 : 0;
                    const changed = newWidth !== widthLastTime || newHeight !== heightLastTime;
                    if (changed) {
                        widthLastTime = newWidth;
                        heightLastTime = newHeight;
                        callback();
                    }
                    this.doNextPolyfillTurn(periodicallyCheckWidthAndHeight);
                }
            };
            periodicallyCheckWidthAndHeight();
            return ()=>running = false;
        };
        const suppressResize = this.gos.get("suppressBrowserResizeObserver");
        const resizeObserverExists = !!win.ResizeObserver;
        if (resizeObserverExists && !suppressResize) return useBrowserResizeObserver();
        return this.getFrameworkOverrides().wrapIncoming(()=>usePolyfill(), "resize-observer");
    }
    doNextPolyfillTurn(func) {
        this.polyfillFunctions.push(func);
        this.schedulePolyfill();
    }
    schedulePolyfill() {
        if (this.polyfillScheduled) return;
        const executeAllFuncs = ()=>{
            const funcs = this.polyfillFunctions;
            this.polyfillScheduled = false;
            this.polyfillFunctions = [];
            funcs.forEach((f)=>f());
        };
        this.polyfillScheduled = true;
        window.setTimeout(executeAllFuncs, DEBOUNCE_DELAY);
    }
};
ResizeObserverService = __decorateClass([
    Bean("resizeObserverService")
], ResizeObserverService);
// community-modules/core/src/misc/animationFrameService.ts
var AnimationFrameService = class extends BeanStub {
    constructor(){
        super(...arguments);
        // p1 and p2 are create tasks are to do with row and cell creation.
        // for them we want to execute according to row order, so we use
        // TaskItem so we know what index the item is for.
        this.createTasksP1 = {
            list: [],
            sorted: false
        };
        // eg drawing back-ground of rows
        this.createTasksP2 = {
            list: [],
            sorted: false
        };
        // eg cell renderers, adding hover functionality
        // destroy tasks are to do with row removal. they are done after row creation as the user will need to see new
        // rows first (as blank is scrolled into view), when we remove the old rows (no longer in view) is not as
        // important.
        this.destroyTasks = [];
        this.ticking = false;
        // we need to know direction of scroll, to build up rows in the direction of
        // the scroll. eg if user scrolls down, we extend the rows by building down.
        this.scrollGoingDown = true;
        this.lastPage = 0;
        this.lastScrollTop = 0;
        this.taskCount = 0;
        this.cancelledTasks = /* @__PURE__ */ new Set();
    }
    setScrollTop(scrollTop) {
        const isPaginationActive = this.gos.get("pagination");
        this.scrollGoingDown = scrollTop >= this.lastScrollTop;
        if (isPaginationActive && scrollTop === 0) {
            const currentPage = this.paginationProxy.getCurrentPage();
            if (currentPage !== this.lastPage) {
                this.lastPage = currentPage;
                this.scrollGoingDown = true;
            }
        }
        this.lastScrollTop = scrollTop;
    }
    init() {
        this.useAnimationFrame = !this.gos.get("suppressAnimationFrame");
    }
    isOn() {
        return this.useAnimationFrame;
    }
    // this method is for our AG Grid sanity only - if animation frames are turned off,
    // then no place in the code should be looking to add any work to be done in animation
    // frames. this stops bugs - where some code is asking for a frame to be executed
    // when it should not.
    verifyAnimationFrameOn(methodName) {
        if (this.useAnimationFrame === false) console.warn(`AG Grid: AnimationFrameService.${methodName} called but animation frames are off`);
    }
    createTask(task, index, list) {
        this.verifyAnimationFrameOn(list);
        const taskItem = {
            task,
            index,
            createOrder: ++this.taskCount
        };
        this.addTaskToList(this[list], taskItem);
        this.schedule();
    }
    cancelTask(task) {
        this.cancelledTasks.add(task);
    }
    addTaskToList(taskList, task) {
        taskList.list.push(task);
        taskList.sorted = false;
    }
    sortTaskList(taskList) {
        if (taskList.sorted) return;
        const sortDirection = this.scrollGoingDown ? 1 : -1;
        taskList.list.sort((a, b)=>a.index !== b.index ? sortDirection * (b.index - a.index) : b.createOrder - a.createOrder);
        taskList.sorted = true;
    }
    addDestroyTask(task) {
        this.verifyAnimationFrameOn("createTasksP3");
        this.destroyTasks.push(task);
        this.schedule();
    }
    executeFrame(millis) {
        this.verifyAnimationFrameOn("executeFrame");
        const p1TaskList = this.createTasksP1;
        const p1Tasks = p1TaskList.list;
        const p2TaskList = this.createTasksP2;
        const p2Tasks = p2TaskList.list;
        const destroyTasks = this.destroyTasks;
        const frameStart = /* @__PURE__ */ new Date().getTime();
        let duration = /* @__PURE__ */ new Date().getTime() - frameStart;
        const noMaxMillis = millis <= 0;
        const gridBodyCon = this.ctrlsService.getGridBodyCtrl();
        while(noMaxMillis || duration < millis){
            const gridBodyDidSomething = gridBodyCon.getScrollFeature().scrollGridIfNeeded();
            if (!gridBodyDidSomething) {
                let task;
                if (p1Tasks.length) {
                    this.sortTaskList(p1TaskList);
                    task = p1Tasks.pop().task;
                } else if (p2Tasks.length) {
                    this.sortTaskList(p2TaskList);
                    task = p2Tasks.pop().task;
                } else if (destroyTasks.length) task = destroyTasks.pop();
                else {
                    this.cancelledTasks.clear();
                    break;
                }
                if (!this.cancelledTasks.has(task)) task();
            }
            duration = /* @__PURE__ */ new Date().getTime() - frameStart;
        }
        if (p1Tasks.length || p2Tasks.length || destroyTasks.length) this.requestFrame();
        else this.stopTicking();
    }
    stopTicking() {
        this.ticking = false;
    }
    flushAllFrames() {
        if (!this.useAnimationFrame) return;
        this.executeFrame(-1);
    }
    schedule() {
        if (!this.useAnimationFrame) return;
        if (!this.ticking) {
            this.ticking = true;
            this.requestFrame();
        }
    }
    requestFrame() {
        const callback = this.executeFrame.bind(this, 60);
        this.requestAnimationFrame(callback);
    }
    requestAnimationFrame(callback) {
        const win = this.gos.getWindow();
        if (win.requestAnimationFrame) win.requestAnimationFrame(callback);
        else if (win.webkitRequestAnimationFrame) win.webkitRequestAnimationFrame(callback);
        else win.setTimeout(callback, 0);
    }
    isQueueEmpty() {
        return !this.ticking;
    }
    // a debounce utility used for parts of the app involved with rendering.
    // the advantage over normal debounce is the client can call flushAllFrames()
    // to make sure all rendering is complete. we don't wait any milliseconds,
    // as this is intended to batch calls in one VM turn.
    debounce(func) {
        let pending = false;
        return ()=>{
            if (!this.isOn()) {
                window.setTimeout(func, 0);
                return;
            }
            if (pending) return;
            pending = true;
            this.addDestroyTask(()=>{
                pending = false;
                func();
            });
        };
    }
};
__decorateClass([
    Autowired("ctrlsService")
], AnimationFrameService.prototype, "ctrlsService", 2);
__decorateClass([
    Autowired("paginationProxy")
], AnimationFrameService.prototype, "paginationProxy", 2);
__decorateClass([
    PostConstruct
], AnimationFrameService.prototype, "init", 1);
AnimationFrameService = __decorateClass([
    Bean("animationFrameService")
], AnimationFrameService);
// community-modules/core/src/interfaces/iClientSideRowModel.ts
var ClientSideRowModelSteps = /* @__PURE__ */ ((ClientSideRowModelSteps2)=>{
    ClientSideRowModelSteps2["EVERYTHING"] = "group";
    ClientSideRowModelSteps2["FILTER"] = "filter";
    ClientSideRowModelSteps2["SORT"] = "sort";
    ClientSideRowModelSteps2["MAP"] = "map";
    ClientSideRowModelSteps2["AGGREGATE"] = "aggregate";
    ClientSideRowModelSteps2["FILTER_AGGREGATES"] = "filter_aggregates";
    ClientSideRowModelSteps2["PIVOT"] = "pivot";
    ClientSideRowModelSteps2["NOTHING"] = "nothing";
    return ClientSideRowModelSteps2;
})(ClientSideRowModelSteps || {});
// community-modules/core/src/misc/expansionService.ts
var ExpansionService = class extends BeanStub {
    postConstruct() {
        this.isClientSideRowModel = this.rowModel.getType() === "clientSide";
    }
    expandRows(rowIds) {
        if (!this.isClientSideRowModel) return;
        const rowIdSet = new Set(rowIds);
        this.rowModel.forEachNode((node)=>{
            if (node.id && rowIdSet.has(node.id)) node.expanded = true;
        });
        this.onGroupExpandedOrCollapsed();
    }
    getExpandedRows() {
        const expandedRows = [];
        this.rowModel.forEachNode(({ expanded, id })=>{
            if (expanded && id) expandedRows.push(id);
        });
        return expandedRows;
    }
    expandAll(value) {
        if (!this.isClientSideRowModel) return;
        this.rowModel.expandOrCollapseAll(value);
    }
    setRowNodeExpanded(rowNode, expanded, expandParents, forceSync) {
        if (rowNode) {
            if (expandParents && rowNode.parent && rowNode.parent.level !== -1) this.setRowNodeExpanded(rowNode.parent, expanded, expandParents, forceSync);
            rowNode.setExpanded(expanded, void 0, forceSync);
        }
    }
    onGroupExpandedOrCollapsed() {
        if (!this.isClientSideRowModel) return;
        this.rowModel.refreshModel({
            step: "map" /* MAP */ 
        });
    }
};
__decorateClass([
    Autowired("rowModel")
], ExpansionService.prototype, "rowModel", 2);
__decorateClass([
    PostConstruct
], ExpansionService.prototype, "postConstruct", 1);
ExpansionService = __decorateClass([
    Bean("expansionService")
], ExpansionService);
// community-modules/core/src/misc/menuService.ts
var MenuService = class extends BeanStub {
    postConstruct() {
        var _a;
        this.activeMenuFactory = (_a = this.enterpriseMenuFactory) != null ? _a : this.filterMenuFactory;
    }
    showColumnMenu(params) {
        this.showColumnMenuCommon(this.activeMenuFactory, params, "columnMenu");
    }
    showFilterMenu(params) {
        const menuFactory = this.enterpriseMenuFactory && this.isLegacyMenuEnabled() ? this.enterpriseMenuFactory : this.filterMenuFactory;
        this.showColumnMenuCommon(menuFactory, params, params.containerType, true);
    }
    showHeaderContextMenu(column, mouseEvent, touchEvent) {
        this.activeMenuFactory.showMenuAfterContextMenuEvent(column, mouseEvent, touchEvent);
    }
    getContextMenuPosition(rowNode, column) {
        const rowCtrl = this.getRowCtrl(rowNode);
        const eGui = this.getCellGui(rowCtrl, column);
        if (!eGui) {
            if (rowCtrl) return {
                x: 0,
                y: rowCtrl.getRowYPosition()
            };
            return {
                x: 0,
                y: 0
            };
        }
        const rect = eGui.getBoundingClientRect();
        return {
            x: rect.x + rect.width / 2,
            y: rect.y + rect.height / 2
        };
    }
    showContextMenu(params) {
        var _a, _b, _c;
        const { column, rowNode } = params;
        let { anchorToElement, value } = params;
        if (rowNode && column && value == null) value = rowNode.getValueFromValueService(column);
        if (anchorToElement == null) anchorToElement = this.getContextMenuAnchorElement(rowNode, column);
        (_c = this.contextMenuFactory) == null || _c.onContextMenu((_a = params.mouseEvent) != null ? _a : null, (_b = params.touchEvent) != null ? _b : null, rowNode != null ? rowNode : null, column != null ? column : null, value, anchorToElement);
    }
    showColumnChooser(params) {
        var _a;
        (_a = this.columnChooserFactory) == null || _a.showColumnChooser(params);
    }
    hidePopupMenu() {
        var _a;
        (_a = this.contextMenuFactory) == null || _a.hideActiveMenu();
        this.activeMenuFactory.hideActiveMenu();
    }
    hideColumnChooser() {
        var _a;
        (_a = this.columnChooserFactory) == null || _a.hideActiveColumnChooser();
    }
    isColumnMenuInHeaderEnabled(column) {
        const { suppressMenu, suppressHeaderMenuButton } = column.getColDef();
        const isSuppressMenuButton = suppressHeaderMenuButton != null ? suppressHeaderMenuButton : suppressMenu;
        return !isSuppressMenuButton && this.activeMenuFactory.isMenuEnabled(column) && (this.isLegacyMenuEnabled() || !!this.enterpriseMenuFactory);
    }
    isFilterMenuInHeaderEnabled(column) {
        return !column.getColDef().suppressHeaderFilterButton && this.filterManager.isFilterAllowed(column);
    }
    isHeaderContextMenuEnabled(column) {
        return !(column == null ? void 0 : column.getColDef().suppressHeaderContextMenu) && this.getColumnMenuType() === "new";
    }
    isHeaderMenuButtonAlwaysShowEnabled() {
        return this.isSuppressMenuHide();
    }
    isHeaderMenuButtonEnabled() {
        const menuHides = !this.isSuppressMenuHide();
        const onIpadAndMenuHides = isIOSUserAgent() && menuHides;
        return !onIpadAndMenuHides;
    }
    isHeaderFilterButtonEnabled(column) {
        return this.isFilterMenuInHeaderEnabled(column) && !this.isLegacyMenuEnabled() && !this.isFloatingFilterButtonDisplayed(column);
    }
    isFilterMenuItemEnabled(column) {
        return this.filterManager.isFilterAllowed(column) && !this.isLegacyMenuEnabled() && !this.isFilterMenuInHeaderEnabled(column) && !this.isFloatingFilterButtonDisplayed(column);
    }
    isColumnMenuAnchoringEnabled() {
        return !this.isLegacyMenuEnabled();
    }
    areAdditionalColumnMenuItemsEnabled() {
        return this.getColumnMenuType() === "new";
    }
    isLegacyMenuEnabled() {
        return this.getColumnMenuType() === "legacy";
    }
    isFloatingFilterButtonEnabled(column) {
        var _a;
        const colDef = column.getColDef();
        const legacySuppressFilterButton = (_a = colDef.floatingFilterComponentParams) == null ? void 0 : _a.suppressFilterButton;
        if (legacySuppressFilterButton != null) warnOnce(`As of v31.1, 'colDef.floatingFilterComponentParams.suppressFilterButton' is deprecated. Use 'colDef.suppressFloatingFilterButton' instead.`);
        return colDef.suppressFloatingFilterButton == null ? !legacySuppressFilterButton : !colDef.suppressFloatingFilterButton;
    }
    getColumnMenuType() {
        var _a;
        return (_a = this.gos.get("columnMenu")) != null ? _a : "legacy";
    }
    isFloatingFilterButtonDisplayed(column) {
        return !!column.getColDef().floatingFilter && this.isFloatingFilterButtonEnabled(column);
    }
    isSuppressMenuHide() {
        const suppressMenuHide = this.gos.get("suppressMenuHide");
        if (this.isLegacyMenuEnabled()) return suppressMenuHide;
        else return this.gos.exists("suppressMenuHide") ? suppressMenuHide : true;
    }
    showColumnMenuCommon(menuFactory, params, containerType, filtersOnly) {
        const { column, positionBy } = params;
        if (positionBy === "button") {
            const { buttonElement } = params;
            menuFactory.showMenuAfterButtonClick(column, buttonElement, containerType, filtersOnly);
        } else if (positionBy === "mouse") {
            const { mouseEvent } = params;
            menuFactory.showMenuAfterMouseEvent(column, mouseEvent, containerType, filtersOnly);
        } else if (column) {
            this.ctrlsService.getGridBodyCtrl().getScrollFeature().ensureColumnVisible(column, "auto");
            this.animationFrameService.requestAnimationFrame(()=>{
                const headerCellCtrl = this.ctrlsService.getHeaderRowContainerCtrl(column.getPinned()).getHeaderCtrlForColumn(column);
                menuFactory.showMenuAfterButtonClick(column, headerCellCtrl.getAnchorElementForMenu(filtersOnly), containerType, true);
            });
        }
    }
    getRowCtrl(rowNode) {
        const { rowIndex, rowPinned } = rowNode || {};
        if (rowIndex == null) return;
        return this.rowRenderer.getRowByPosition({
            rowIndex,
            rowPinned
        }) || void 0;
    }
    getCellGui(rowCtrl, column) {
        if (!rowCtrl || !column) return;
        const cellCtrl = rowCtrl.getCellCtrl(column);
        return (cellCtrl == null ? void 0 : cellCtrl.getGui()) || void 0;
    }
    getContextMenuAnchorElement(rowNode, column) {
        const gridBodyEl = this.ctrlsService.getGridBodyCtrl().getGridBodyElement();
        const rowCtrl = this.getRowCtrl(rowNode);
        if (!rowCtrl) return gridBodyEl;
        const cellGui = this.getCellGui(rowCtrl, column);
        if (cellGui) return cellGui;
        if (rowCtrl.isFullWidth()) return rowCtrl.getFullWidthElement();
        return gridBodyEl;
    }
};
__decorateClass([
    Autowired("filterMenuFactory")
], MenuService.prototype, "filterMenuFactory", 2);
__decorateClass([
    Autowired("ctrlsService")
], MenuService.prototype, "ctrlsService", 2);
__decorateClass([
    Autowired("animationFrameService")
], MenuService.prototype, "animationFrameService", 2);
__decorateClass([
    Autowired("filterManager")
], MenuService.prototype, "filterManager", 2);
__decorateClass([
    Autowired("rowRenderer")
], MenuService.prototype, "rowRenderer", 2);
__decorateClass([
    Optional("columnChooserFactory")
], MenuService.prototype, "columnChooserFactory", 2);
__decorateClass([
    Optional("contextMenuFactory")
], MenuService.prototype, "contextMenuFactory", 2);
__decorateClass([
    Optional("enterpriseMenuFactory")
], MenuService.prototype, "enterpriseMenuFactory", 2);
__decorateClass([
    PostConstruct
], MenuService.prototype, "postConstruct", 1);
MenuService = __decorateClass([
    Bean("menuService")
], MenuService);
// community-modules/core/src/rendering/autoWidthCalculator.ts
var AutoWidthCalculator = class extends BeanStub {
    postConstruct() {
        this.ctrlsService.whenReady((p)=>{
            this.centerRowContainerCtrl = p.center;
        });
    }
    // this is the trick: we create a dummy container and clone all the cells
    // into the dummy, then check the dummy's width. then destroy the dummy
    // as we don't need it any more.
    // drawback: only the cells visible on the screen are considered
    getPreferredWidthForColumn(column, skipHeader) {
        const eHeaderCell = this.getHeaderCellForColumn(column);
        if (!eHeaderCell) return -1;
        const elements = this.rowRenderer.getAllCellsForColumn(column);
        if (!skipHeader) elements.push(eHeaderCell);
        return this.addElementsToContainerAndGetWidth(elements);
    }
    getPreferredWidthForColumnGroup(columnGroup) {
        const eHeaderCell = this.getHeaderCellForColumn(columnGroup);
        if (!eHeaderCell) return -1;
        return this.addElementsToContainerAndGetWidth([
            eHeaderCell
        ]);
    }
    addElementsToContainerAndGetWidth(elements) {
        const eDummyContainer = document.createElement("form");
        eDummyContainer.style.position = "fixed";
        const eBodyContainer = this.centerRowContainerCtrl.getContainerElement();
        elements.forEach((el)=>this.cloneItemIntoDummy(el, eDummyContainer));
        eBodyContainer.appendChild(eDummyContainer);
        const dummyContainerWidth = eDummyContainer.offsetWidth;
        eBodyContainer.removeChild(eDummyContainer);
        const autoSizePadding = this.getAutoSizePadding();
        return dummyContainerWidth + autoSizePadding;
    }
    getAutoSizePadding() {
        return this.gos.get("autoSizePadding");
    }
    getHeaderCellForColumn(column) {
        let element = null;
        this.ctrlsService.getHeaderRowContainerCtrls().forEach((container)=>{
            const res = container.getHtmlElementForColumnHeader(column);
            if (res != null) element = res;
        });
        return element;
    }
    cloneItemIntoDummy(eCell, eDummyContainer) {
        const eCellClone = eCell.cloneNode(true);
        eCellClone.style.width = "";
        eCellClone.style.position = "static";
        eCellClone.style.left = "";
        const eCloneParent = document.createElement("div");
        const eCloneParentClassList = eCloneParent.classList;
        const isHeader = [
            "ag-header-cell",
            "ag-header-group-cell"
        ].some((cls)=>eCellClone.classList.contains(cls));
        if (isHeader) {
            eCloneParentClassList.add("ag-header", "ag-header-row");
            eCloneParent.style.position = "static";
        } else eCloneParentClassList.add("ag-row");
        let pointer = eCell.parentElement;
        while(pointer){
            const isRow = [
                "ag-header-row",
                "ag-row"
            ].some((cls)=>pointer.classList.contains(cls));
            if (isRow) {
                for(let i = 0; i < pointer.classList.length; i++){
                    const item = pointer.classList[i];
                    if (item != "ag-row-position-absolute") eCloneParentClassList.add(item);
                }
                break;
            }
            pointer = pointer.parentElement;
        }
        eCloneParent.appendChild(eCellClone);
        eDummyContainer.appendChild(eCloneParent);
    }
};
__decorateClass([
    Autowired("rowRenderer")
], AutoWidthCalculator.prototype, "rowRenderer", 2);
__decorateClass([
    Autowired("ctrlsService")
], AutoWidthCalculator.prototype, "ctrlsService", 2);
__decorateClass([
    Autowired("rowCssClassCalculator")
], AutoWidthCalculator.prototype, "rowCssClassCalculator", 2);
__decorateClass([
    PostConstruct
], AutoWidthCalculator.prototype, "postConstruct", 1);
AutoWidthCalculator = __decorateClass([
    Bean("autoWidthCalculator")
], AutoWidthCalculator);
// community-modules/core/src/rendering/features/stickyRowFeature.ts
var StickyRowFeature = class extends BeanStub {
    constructor(createRowCon, destroyRowCtrls){
        super();
        this.createRowCon = createRowCon;
        this.destroyRowCtrls = destroyRowCtrls;
        this.stickyTopRowCtrls = [];
        this.stickyBottomRowCtrls = [];
        this.topContainerHeight = 0;
        this.bottomContainerHeight = 0;
    }
    postConstruct() {
        this.isClientSide = this.rowModel.getType() === "clientSide";
        this.ctrlsService.whenReady((params)=>{
            this.gridBodyCtrl = params.gridBodyCtrl;
        });
    }
    getStickyTopRowCtrls() {
        return this.stickyTopRowCtrls;
    }
    getStickyBottomRowCtrls() {
        return this.stickyBottomRowCtrls;
    }
    /**
   * Get the last pixel of the group, this pixel is used to push the sticky node up out of the viewport.
   */ getLastPixelOfGroup(row) {
        return this.isClientSide ? this.getClientSideLastPixelOfGroup(row) : this.getServerSideLastPixelOfGroup(row);
    }
    /**
   * Get the first pixel of the group, this pixel is used to push the sticky node down out of the viewport
   */ getFirstPixelOfGroup(row) {
        if (row.footer) return row.sibling.rowTop + row.sibling.rowHeight - 1;
        if (row.hasChildren()) return row.rowTop - 1;
        return 0;
    }
    getServerSideLastPixelOfGroup(row) {
        var _a, _b, _c, _d;
        if (this.isClientSide) throw new Error("This func should only be called in server side row model.");
        if (row.isExpandable() || row.footer) {
            if (row.master) return row.detailNode.rowTop + row.detailNode.rowHeight;
            const noOrContiguousSiblings = !row.sibling || Math.abs(row.sibling.rowIndex - row.rowIndex) === 1;
            if (noOrContiguousSiblings) {
                let storeBounds = (_a = row.childStore) == null ? void 0 : _a.getStoreBounds();
                if (row.footer) storeBounds = (_b = row.sibling.childStore) == null ? void 0 : _b.getStoreBounds();
                return ((_c = storeBounds == null ? void 0 : storeBounds.heightPx) != null ? _c : 0) + ((_d = storeBounds == null ? void 0 : storeBounds.topPx) != null ? _d : 0);
            }
            if (row.footer) return row.rowTop + row.rowHeight;
            return row.sibling.rowTop + row.sibling.rowHeight;
        }
        return Number.MAX_SAFE_INTEGER;
    }
    getClientSideLastPixelOfGroup(row) {
        if (!this.isClientSide) throw new Error("This func should only be called in client side row model.");
        if (row.isExpandable() || row.footer) {
            const grandTotalAtTop = row.footer && row.rowIndex === 0;
            const noOrContiguousSiblings = !row.sibling || Math.abs(row.sibling.rowIndex - row.rowIndex) === 1;
            if (grandTotalAtTop || noOrContiguousSiblings) {
                let lastAncestor = row.footer ? row.sibling : row;
                while(lastAncestor.isExpandable() && lastAncestor.expanded){
                    if (lastAncestor.master) lastAncestor = lastAncestor.detailNode;
                    else if (lastAncestor.childrenAfterSort) {
                        if (lastAncestor.childrenAfterSort.length === 0) break;
                        lastAncestor = last(lastAncestor.childrenAfterSort);
                    }
                }
                return lastAncestor.rowTop + lastAncestor.rowHeight;
            }
            if (row.footer) return row.rowTop + row.rowHeight;
            return row.sibling.rowTop + row.sibling.rowHeight;
        }
        return Number.MAX_SAFE_INTEGER;
    }
    updateStickyRows(container) {
        const isTop = container === "top";
        let newStickyContainerHeight = 0;
        if (!this.canRowsBeSticky()) return this.refreshNodesAndContainerHeight(container, /* @__PURE__ */ new Set(), newStickyContainerHeight);
        const pixelAtContainerBoundary = isTop ? this.rowRenderer.getFirstVisibleVerticalPixel() : this.rowRenderer.getLastVisibleVerticalPixel();
        const newStickyRows = /* @__PURE__ */ new Set();
        const addStickyRow = (stickyRow)=>{
            newStickyRows.add(stickyRow);
            if (isTop) {
                const lastChildBottom = this.getLastPixelOfGroup(stickyRow);
                const stickRowBottom = pixelAtContainerBoundary + newStickyContainerHeight + stickyRow.rowHeight;
                if (lastChildBottom < stickRowBottom) stickyRow.stickyRowTop = newStickyContainerHeight + (lastChildBottom - stickRowBottom);
                else stickyRow.stickyRowTop = newStickyContainerHeight;
            } else {
                const lastChildBottom = this.getFirstPixelOfGroup(stickyRow);
                const stickRowTop = pixelAtContainerBoundary - (newStickyContainerHeight + stickyRow.rowHeight);
                if (lastChildBottom > stickRowTop) stickyRow.stickyRowTop = newStickyContainerHeight - (lastChildBottom - stickRowTop);
                else stickyRow.stickyRowTop = newStickyContainerHeight;
            }
            newStickyContainerHeight = 0;
            newStickyRows.forEach((rowNode)=>{
                const thisRowLastPx = rowNode.stickyRowTop + rowNode.rowHeight;
                if (newStickyContainerHeight < thisRowLastPx) newStickyContainerHeight = thisRowLastPx;
            });
        };
        const suppressFootersSticky = this.areFooterRowsStickySuppressed();
        const suppressGroupsSticky = this.gos.get("suppressGroupRowsSticky");
        const isRowSticky = (row)=>{
            if (!row.displayed) return false;
            if (row.footer) {
                if (suppressFootersSticky === true) return false;
                if (suppressFootersSticky === "grand" && row.level === -1) return false;
                if (suppressFootersSticky === "group" && row.level > -1) return false;
                const alreadySticking = newStickyRows.has(row);
                return !alreadySticking;
            }
            if (row.isExpandable()) {
                if (suppressGroupsSticky === true) return false;
                const alreadySticking = newStickyRows.has(row);
                return !alreadySticking && row.expanded;
            }
            return false;
        };
        for(let i = 0; i < 100; i++){
            let firstPixelAfterStickyRows = pixelAtContainerBoundary + newStickyContainerHeight;
            if (!isTop) firstPixelAfterStickyRows = pixelAtContainerBoundary - newStickyContainerHeight;
            const firstIndex = this.rowModel.getRowIndexAtPixel(firstPixelAfterStickyRows);
            const firstRow = this.rowModel.getRow(firstIndex);
            if (firstRow == null) break;
            const ancestors = this.getStickyAncestors(firstRow);
            const firstMissingParent = ancestors.find((parent)=>(isTop ? parent.rowIndex < firstIndex : parent.rowIndex > firstIndex) && isRowSticky(parent));
            if (firstMissingParent) {
                addStickyRow(firstMissingParent);
                continue;
            }
            const isFirstRowOutsideViewport = isTop ? firstRow.rowTop < firstPixelAfterStickyRows : firstRow.rowTop + firstRow.rowHeight > firstPixelAfterStickyRows;
            if (isFirstRowOutsideViewport && isRowSticky(firstRow)) {
                addStickyRow(firstRow);
                continue;
            }
            break;
        }
        if (!isTop) newStickyRows.forEach((rowNode)=>{
            rowNode.stickyRowTop = newStickyContainerHeight - (rowNode.stickyRowTop + rowNode.rowHeight);
        });
        return this.refreshNodesAndContainerHeight(container, newStickyRows, newStickyContainerHeight);
    }
    areFooterRowsStickySuppressed() {
        const suppressFootersSticky = this.gos.get("suppressStickyTotalRow");
        if (suppressFootersSticky === true) return true;
        const suppressGroupRows = !!this.gos.get("groupIncludeFooter") || suppressFootersSticky === "group";
        const suppressGrandRows = !!this.gos.get("groupIncludeTotalFooter") || suppressFootersSticky === "grand";
        if (suppressGroupRows && suppressGrandRows) return true;
        if (suppressGrandRows) return "grand";
        if (suppressGroupRows) return "group";
        return false;
    }
    canRowsBeSticky() {
        const isStickyEnabled = this.gos.isGroupRowsSticky();
        const suppressFootersSticky = this.areFooterRowsStickySuppressed();
        const suppressGroupsSticky = this.gos.get("suppressGroupRowsSticky");
        return isStickyEnabled && (!suppressFootersSticky || !suppressGroupsSticky);
    }
    getStickyAncestors(rowNode) {
        const ancestors = [];
        let p = rowNode.footer ? rowNode.sibling : rowNode.parent;
        while(p){
            if (p.sibling) ancestors.push(p.sibling);
            ancestors.push(p);
            p = p.parent;
        }
        return ancestors.reverse();
    }
    checkStickyRows() {
        const hasTopUpdated = this.updateStickyRows("top");
        const hasBottomUpdated = this.updateStickyRows("bottom");
        return hasTopUpdated || hasBottomUpdated;
    }
    destroyStickyCtrls() {
        this.refreshNodesAndContainerHeight("top", /* @__PURE__ */ new Set(), 0);
        this.refreshNodesAndContainerHeight("bottom", /* @__PURE__ */ new Set(), 0);
    }
    refreshStickyNode(stickRowNode) {
        const allStickyNodes = /* @__PURE__ */ new Set();
        if (this.stickyTopRowCtrls.some((ctrl)=>ctrl.getRowNode() === stickRowNode)) {
            for(let i = 0; i < this.stickyTopRowCtrls.length; i++){
                const currentNode = this.stickyTopRowCtrls[i].getRowNode();
                if (currentNode !== stickRowNode) allStickyNodes.add(currentNode);
            }
            if (this.refreshNodesAndContainerHeight("top", allStickyNodes, this.topContainerHeight)) this.checkStickyRows();
            return;
        }
        for(let i = 0; i < this.stickyBottomRowCtrls.length; i++){
            const currentNode = this.stickyBottomRowCtrls[i].getRowNode();
            if (currentNode !== stickRowNode) allStickyNodes.add(currentNode);
        }
        if (this.refreshNodesAndContainerHeight("bottom", allStickyNodes, this.bottomContainerHeight)) this.checkStickyRows();
    }
    /**
   * Destroy old ctrls and create new ctrls where necessary.
   */ refreshNodesAndContainerHeight(container, newStickyNodes, height) {
        const isTop = container === "top";
        const previousCtrls = isTop ? this.stickyTopRowCtrls : this.stickyBottomRowCtrls;
        const removedCtrlsMap = {};
        const remainingCtrls = [];
        for(let i = 0; i < previousCtrls.length; i++){
            const node = previousCtrls[i].getRowNode();
            const hasBeenRemoved = !newStickyNodes.has(node);
            if (hasBeenRemoved) {
                removedCtrlsMap[node.id] = previousCtrls[i];
                node.sticky = false;
                continue;
            }
            remainingCtrls.push(previousCtrls[i]);
        }
        const existingNodes = /* @__PURE__ */ new Set();
        for(let i = 0; i < remainingCtrls.length; i++)existingNodes.add(remainingCtrls[i].getRowNode());
        const newCtrls = [];
        newStickyNodes.forEach((node)=>{
            if (existingNodes.has(node)) return;
            node.sticky = true;
            newCtrls.push(this.createRowCon(node, false, false));
        });
        let hasSomethingChanged = !!newCtrls.length || remainingCtrls.length !== previousCtrls.length;
        if (isTop) {
            if (this.topContainerHeight !== height) {
                this.topContainerHeight = height;
                this.gridBodyCtrl.setStickyTopHeight(height);
                hasSomethingChanged = true;
            }
        } else if (this.bottomContainerHeight !== height) {
            this.bottomContainerHeight = height;
            this.gridBodyCtrl.setStickyBottomHeight(height);
            hasSomethingChanged = true;
        }
        this.destroyRowCtrls(removedCtrlsMap, false);
        const newCtrlsList = [
            ...remainingCtrls,
            ...newCtrls
        ];
        newCtrlsList.sort((a, b)=>b.getRowNode().rowIndex - a.getRowNode().rowIndex);
        if (!isTop) newCtrlsList.reverse();
        newCtrlsList.forEach((ctrl)=>ctrl.setRowTop(ctrl.getRowNode().stickyRowTop));
        if (!hasSomethingChanged) return false;
        if (isTop) this.stickyTopRowCtrls = newCtrlsList;
        else this.stickyBottomRowCtrls = newCtrlsList;
        return true;
    }
};
__decorateClass([
    Autowired("rowModel")
], StickyRowFeature.prototype, "rowModel", 2);
__decorateClass([
    Autowired("rowRenderer")
], StickyRowFeature.prototype, "rowRenderer", 2);
__decorateClass([
    Autowired("ctrlsService")
], StickyRowFeature.prototype, "ctrlsService", 2);
__decorateClass([
    PostConstruct
], StickyRowFeature.prototype, "postConstruct", 1);
// community-modules/core/src/rendering/rowRenderer.ts
var RowRenderer = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.destroyFuncsForColumnListeners = [];
        // map of row ids to row objects. keeps track of which elements
        // are rendered for which rows in the dom.
        this.rowCtrlsByRowIndex = {};
        this.zombieRowCtrls = {};
        this.allRowCtrls = [];
        this.topRowCtrls = [];
        this.bottomRowCtrls = [];
        // we only allow one refresh at a time, otherwise the internal memory structure here
        // will get messed up. this can happen if the user has a cellRenderer, and inside the
        // renderer they call an API method that results in another pass of the refresh,
        // then it will be trying to draw rows in the middle of a refresh.
        this.refreshInProgress = false;
        this.dataFirstRenderedFired = false;
        this.setupRangeSelectionListeners = ()=>{
            const onRangeSelectionChanged = ()=>{
                this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onRangeSelectionChanged());
            };
            const onColumnMovedPinnedVisible = ()=>{
                this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.updateRangeBordersIfRangeCount());
            };
            const addRangeSelectionListeners = ()=>{
                this.eventService.addEventListener(Events.EVENT_RANGE_SELECTION_CHANGED, onRangeSelectionChanged);
                this.eventService.addEventListener(Events.EVENT_COLUMN_MOVED, onColumnMovedPinnedVisible);
                this.eventService.addEventListener(Events.EVENT_COLUMN_PINNED, onColumnMovedPinnedVisible);
                this.eventService.addEventListener(Events.EVENT_COLUMN_VISIBLE, onColumnMovedPinnedVisible);
            };
            const removeRangeSelectionListeners = ()=>{
                this.eventService.removeEventListener(Events.EVENT_RANGE_SELECTION_CHANGED, onRangeSelectionChanged);
                this.eventService.removeEventListener(Events.EVENT_COLUMN_MOVED, onColumnMovedPinnedVisible);
                this.eventService.removeEventListener(Events.EVENT_COLUMN_PINNED, onColumnMovedPinnedVisible);
                this.eventService.removeEventListener(Events.EVENT_COLUMN_VISIBLE, onColumnMovedPinnedVisible);
            };
            this.addDestroyFunc(()=>removeRangeSelectionListeners());
            this.addManagedPropertyListener("enableRangeSelection", (params)=>{
                const isEnabled = params.currentValue;
                if (isEnabled) addRangeSelectionListeners();
                else removeRangeSelectionListeners();
            });
            const rangeSelectionEnabled = this.gos.get("enableRangeSelection");
            if (rangeSelectionEnabled) addRangeSelectionListeners();
        };
    }
    postConstruct() {
        this.ctrlsService.whenReady((p)=>{
            this.gridBodyCtrl = p.gridBodyCtrl;
            this.initialise();
        });
    }
    initialise() {
        this.addManagedListener(this.eventService, Events.EVENT_PAGINATION_CHANGED, this.onPageLoaded.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_PINNED_ROW_DATA_CHANGED, this.onPinnedRowDataChanged.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_BODY_SCROLL, this.onBodyScroll.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_BODY_HEIGHT_CHANGED, this.redraw.bind(this));
        this.addManagedPropertyListeners([
            "domLayout",
            "embedFullWidthRows"
        ], ()=>this.onDomLayoutChanged());
        this.addManagedPropertyListeners([
            "suppressMaxRenderedRowRestriction",
            "rowBuffer"
        ], ()=>this.redraw());
        this.addManagedPropertyListeners([
            "suppressCellFocus",
            "getBusinessKeyForNode",
            "fullWidthCellRenderer",
            "fullWidthCellRendererParams",
            "rowStyle",
            "getRowStyle",
            "rowClass",
            "getRowClass",
            "rowClassRules",
            "suppressStickyTotalRow",
            "groupRowRenderer",
            "groupRowRendererParams",
            // maybe only needs to refresh FW rows...
            "loadingCellRenderer",
            "loadingCellRendererParams",
            "detailCellRenderer",
            "detailCellRendererParams",
            "enableRangeSelection",
            "enableCellTextSelection"
        ], ()=>this.redrawRows());
        if (this.gos.isGroupRowsSticky()) {
            const rowModelType = this.rowModel.getType();
            if (rowModelType === "clientSide" || rowModelType === "serverSide") this.stickyRowFeature = this.createManagedBean(new StickyRowFeature(this.createRowCon.bind(this), this.destroyRowCtrls.bind(this)));
        }
        this.registerCellEventListeners();
        this.initialiseCache();
        this.printLayout = this.gos.isDomLayout("print");
        this.embedFullWidthRows = this.printLayout || this.gos.get("embedFullWidthRows");
        this.redrawAfterModelUpdate();
    }
    initialiseCache() {
        if (this.gos.get("keepDetailRows")) {
            const countProp = this.getKeepDetailRowsCount();
            const count = countProp != null ? countProp : 3;
            this.cachedRowCtrls = new RowCtrlCache(count);
        }
    }
    getKeepDetailRowsCount() {
        return this.gos.get("keepDetailRowsCount");
    }
    getStickyTopRowCtrls() {
        if (!this.stickyRowFeature) return [];
        return this.stickyRowFeature.getStickyTopRowCtrls();
    }
    getStickyBottomRowCtrls() {
        if (!this.stickyRowFeature) return [];
        return this.stickyRowFeature.getStickyBottomRowCtrls();
    }
    updateAllRowCtrls() {
        const liveList = getAllValuesInObject(this.rowCtrlsByRowIndex);
        const zombieList = getAllValuesInObject(this.zombieRowCtrls);
        const cachedList = this.cachedRowCtrls ? this.cachedRowCtrls.getEntries() : [];
        if (zombieList.length > 0 || cachedList.length > 0) this.allRowCtrls = [
            ...liveList,
            ...zombieList,
            ...cachedList
        ];
        else this.allRowCtrls = liveList;
    }
    onCellFocusChanged(event) {
        this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onCellFocused(event));
        this.getFullWidthRowCtrls().forEach((rowCtrl)=>rowCtrl.onFullWidthRowFocused(event));
    }
    // in a clean design, each cell would register for each of these events. however when scrolling, all the cells
    // registering and de-registering for events is a performance bottleneck. so we register here once and inform
    // all active cells.
    registerCellEventListeners() {
        this.addManagedListener(this.eventService, Events.EVENT_CELL_FOCUSED, (event)=>{
            this.onCellFocusChanged(event);
        });
        this.addManagedListener(this.eventService, Events.EVENT_CELL_FOCUS_CLEARED, ()=>{
            this.onCellFocusChanged();
        });
        this.addManagedListener(this.eventService, Events.EVENT_FLASH_CELLS, (event)=>{
            this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onFlashCells(event));
        });
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_HOVER_CHANGED, ()=>{
            this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onColumnHover());
        });
        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, ()=>{
            this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onDisplayedColumnsChanged());
        });
        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, ()=>{
            if (this.printLayout) this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onLeftChanged());
        });
        this.setupRangeSelectionListeners();
        this.refreshListenersToColumnsForCellComps();
        this.addManagedListener(this.eventService, Events.EVENT_GRID_COLUMNS_CHANGED, this.refreshListenersToColumnsForCellComps.bind(this));
        this.addDestroyFunc(this.removeGridColumnListeners.bind(this));
    }
    // executes all functions in destroyFuncsForColumnListeners and then clears the list
    removeGridColumnListeners() {
        this.destroyFuncsForColumnListeners.forEach((func)=>func());
        this.destroyFuncsForColumnListeners.length = 0;
    }
    // this function adds listeners onto all the grid columns, which are the column that we could have cellComps for.
    // when the grid columns change, we add listeners again. in an ideal design, each CellComp would just register to
    // the column it belongs to on creation, however this was a bottleneck with the number of cells, so do it here
    // once instead.
    refreshListenersToColumnsForCellComps() {
        this.removeGridColumnListeners();
        const cols = this.columnModel.getAllGridColumns();
        cols.forEach((col)=>{
            const forEachCellWithThisCol = (callback)=>{
                this.getAllCellCtrls().forEach((cellCtrl)=>{
                    if (cellCtrl.getColumn() === col) callback(cellCtrl);
                });
            };
            const leftChangedListener = ()=>{
                forEachCellWithThisCol((cellCtrl)=>cellCtrl.onLeftChanged());
            };
            const widthChangedListener = ()=>{
                forEachCellWithThisCol((cellCtrl)=>cellCtrl.onWidthChanged());
            };
            const firstRightPinnedChangedListener = ()=>{
                forEachCellWithThisCol((cellCtrl)=>cellCtrl.onFirstRightPinnedChanged());
            };
            const lastLeftPinnedChangedListener = ()=>{
                forEachCellWithThisCol((cellCtrl)=>cellCtrl.onLastLeftPinnedChanged());
            };
            const colDefChangedListener = ()=>{
                forEachCellWithThisCol((cellCtrl)=>cellCtrl.onColDefChanged());
            };
            col.addEventListener("leftChanged", leftChangedListener);
            col.addEventListener("widthChanged", widthChangedListener);
            col.addEventListener("firstRightPinnedChanged", firstRightPinnedChangedListener);
            col.addEventListener("lastLeftPinnedChanged", lastLeftPinnedChangedListener);
            col.addEventListener("colDefChanged", colDefChangedListener);
            this.destroyFuncsForColumnListeners.push(()=>{
                col.removeEventListener("leftChanged", leftChangedListener);
                col.removeEventListener("widthChanged", widthChangedListener);
                col.removeEventListener("firstRightPinnedChanged", firstRightPinnedChangedListener);
                col.removeEventListener("lastLeftPinnedChanged", lastLeftPinnedChangedListener);
                col.removeEventListener("colDefChanged", colDefChangedListener);
            });
        });
    }
    onDomLayoutChanged() {
        const printLayout = this.gos.isDomLayout("print");
        const embedFullWidthRows = printLayout || this.gos.get("embedFullWidthRows");
        const destroyRows = embedFullWidthRows !== this.embedFullWidthRows || this.printLayout !== printLayout;
        this.printLayout = printLayout;
        this.embedFullWidthRows = embedFullWidthRows;
        if (destroyRows) this.redrawAfterModelUpdate({
            domLayoutChanged: true
        });
    }
    // for row models that have datasources, when we update the datasource, we need to force the rowRenderer
    // to redraw all rows. otherwise the old rows from the old datasource will stay displayed.
    datasourceChanged() {
        this.firstRenderedRow = 0;
        this.lastRenderedRow = -1;
        const rowIndexesToRemove = Object.keys(this.rowCtrlsByRowIndex);
        this.removeRowCtrls(rowIndexesToRemove);
    }
    onPageLoaded(event) {
        const params = {
            recycleRows: event.keepRenderedRows,
            animate: event.animate,
            newData: event.newData,
            newPage: event.newPage,
            // because this is a model updated event (not pinned rows), we
            // can skip updating the pinned rows. this is needed so that if user
            // is doing transaction updates, the pinned rows are not getting constantly
            // trashed - or editing cells in pinned rows are not refreshed and put into read mode
            onlyBody: true
        };
        this.redrawAfterModelUpdate(params);
    }
    getAllCellsForColumn(column) {
        const res = [];
        this.getAllRowCtrls().forEach((rowCtrl)=>{
            const eCell = rowCtrl.getCellElement(column);
            if (eCell) res.push(eCell);
        });
        return res;
    }
    refreshFloatingRowComps() {
        this.refreshFloatingRows(this.topRowCtrls, this.pinnedRowModel.getPinnedTopRowData());
        this.refreshFloatingRows(this.bottomRowCtrls, this.pinnedRowModel.getPinnedBottomRowData());
    }
    getTopRowCtrls() {
        return this.topRowCtrls;
    }
    getCentreRowCtrls() {
        return this.allRowCtrls;
    }
    getBottomRowCtrls() {
        return this.bottomRowCtrls;
    }
    refreshFloatingRows(rowComps, rowNodes) {
        rowComps.forEach((row)=>{
            row.destroyFirstPass();
            row.destroySecondPass();
        });
        rowComps.length = 0;
        if (!rowNodes) return;
        rowNodes.forEach((rowNode)=>{
            const rowCtrl = new RowCtrl(rowNode, this.beans, false, false, this.printLayout);
            rowComps.push(rowCtrl);
        });
    }
    onPinnedRowDataChanged() {
        const params = {
            recycleRows: true
        };
        this.redrawAfterModelUpdate(params);
    }
    redrawRow(rowNode, suppressEvent = false) {
        var _a;
        if (rowNode.sticky) this.stickyRowFeature.refreshStickyNode(rowNode);
        else if ((_a = this.cachedRowCtrls) == null ? void 0 : _a.has(rowNode)) {
            this.cachedRowCtrls.removeRow(rowNode);
            return;
        } else {
            const destroyAndRecreateCtrl = (dataStruct)=>{
                const ctrl = dataStruct[rowNode.rowIndex];
                if (!ctrl) return;
                if (ctrl.getRowNode() !== rowNode) return;
                ctrl.destroyFirstPass();
                ctrl.destroySecondPass();
                dataStruct[rowNode.rowIndex] = this.createRowCon(rowNode, false, false);
            };
            switch(rowNode.rowPinned){
                case "top":
                    destroyAndRecreateCtrl(this.topRowCtrls);
                    break;
                case "bottom":
                    destroyAndRecreateCtrl(this.bottomRowCtrls);
                    break;
                default:
                    destroyAndRecreateCtrl(this.rowCtrlsByRowIndex);
                    this.updateAllRowCtrls();
            }
        }
        if (!suppressEvent) this.dispatchDisplayedRowsChanged(false);
    }
    redrawRows(rowNodes) {
        const partialRefresh = rowNodes != null;
        if (partialRefresh) {
            rowNodes == null || rowNodes.forEach((node)=>this.redrawRow(node, true));
            this.dispatchDisplayedRowsChanged(false);
            return;
        }
        this.redrawAfterModelUpdate();
    }
    getCellToRestoreFocusToAfterRefresh(params) {
        const focusedCell = (params == null ? void 0 : params.suppressKeepFocus) ? null : this.focusService.getFocusCellToUseAfterRefresh();
        if (focusedCell == null) return null;
        const activeElement = this.gos.getActiveDomElement();
        const cellDomData = this.gos.getDomData(activeElement, CellCtrl.DOM_DATA_KEY_CELL_CTRL);
        const rowDomData = this.gos.getDomData(activeElement, RowCtrl.DOM_DATA_KEY_ROW_CTRL);
        const gridElementFocused = cellDomData || rowDomData;
        return gridElementFocused ? focusedCell : null;
    }
    // gets called from:
    // +) initialisation (in registerGridComp) params = null
    // +) onDomLayoutChanged, params = null
    // +) onPageLoaded, recycleRows, animate, newData, newPage from event, onlyBody=true
    // +) onPinnedRowDataChanged, recycleRows = true
    // +) redrawRows (from Grid API), recycleRows = true/false
    redrawAfterModelUpdate(params = {}) {
        this.getLockOnRefresh();
        const focusedCell = this.getCellToRestoreFocusToAfterRefresh(params);
        this.updateContainerHeights();
        this.scrollToTopIfNewData(params);
        const recycleRows = !params.domLayoutChanged && !!params.recycleRows;
        const animate = params.animate && this.gos.isAnimateRows();
        const rowsToRecycle = recycleRows ? this.getRowsToRecycle() : null;
        if (!recycleRows) this.removeAllRowComps();
        this.workOutFirstAndLastRowsToRender();
        if (this.stickyRowFeature) this.stickyRowFeature.checkStickyRows();
        this.recycleRows(rowsToRecycle, animate);
        this.gridBodyCtrl.updateRowCount();
        if (!params.onlyBody) this.refreshFloatingRowComps();
        this.dispatchDisplayedRowsChanged();
        if (focusedCell != null) this.restoreFocusedCell(focusedCell);
        this.releaseLockOnRefresh();
    }
    scrollToTopIfNewData(params) {
        const scrollToTop = params.newData || params.newPage;
        const suppressScrollToTop = this.gos.get("suppressScrollOnNewData");
        if (scrollToTop && !suppressScrollToTop) this.gridBodyCtrl.getScrollFeature().scrollToTop();
    }
    updateContainerHeights() {
        if (this.printLayout) {
            this.rowContainerHeightService.setModelHeight(null);
            return;
        }
        let containerHeight = this.paginationProxy.getCurrentPageHeight();
        if (containerHeight === 0) containerHeight = 1;
        this.rowContainerHeightService.setModelHeight(containerHeight);
    }
    getLockOnRefresh() {
        if (this.refreshInProgress) throw new Error("AG Grid: cannot get grid to draw rows when it is in the middle of drawing rows. Your code probably called a grid API method while the grid was in the render stage. To overcome this, put the API call into a timeout, e.g. instead of api.redrawRows(), call setTimeout(function() { api.redrawRows(); }, 0). To see what part of your code that caused the refresh check this stacktrace.");
        this.refreshInProgress = true;
    }
    releaseLockOnRefresh() {
        this.refreshInProgress = false;
    }
    isRefreshInProgress() {
        return this.refreshInProgress;
    }
    // sets the focus to the provided cell, if the cell is provided. this way, the user can call refresh without
    // worry about the focus been lost. this is important when the user is using keyboard navigation to do edits
    // and the cellEditor is calling 'refresh' to get other cells to update (as other cells might depend on the
    // edited cell).
    restoreFocusedCell(cellPosition) {
        if (cellPosition) {
            this.focusService.setRestoreFocusedCell(cellPosition);
            this.onCellFocusChanged(this.beans.gos.addGridCommonParams({
                rowIndex: cellPosition.rowIndex,
                column: cellPosition.column,
                rowPinned: cellPosition.rowPinned,
                forceBrowserFocus: true,
                preventScrollOnBrowserFocus: true,
                type: "mock"
            }));
        }
    }
    stopEditing(cancel = false) {
        this.getAllRowCtrls().forEach((rowCtrl)=>{
            rowCtrl.stopEditing(cancel);
        });
    }
    getAllCellCtrls() {
        const res = [];
        const rowCtrls = this.getAllRowCtrls();
        const rowCtrlsLength = rowCtrls.length;
        for(let i = 0; i < rowCtrlsLength; i++){
            const cellCtrls = rowCtrls[i].getAllCellCtrls();
            const cellCtrlsLength = cellCtrls.length;
            for(let j = 0; j < cellCtrlsLength; j++)res.push(cellCtrls[j]);
        }
        return res;
    }
    getAllRowCtrls() {
        const stickyTopRowCtrls = this.stickyRowFeature && this.stickyRowFeature.getStickyTopRowCtrls() || [];
        const stickyBottomRowCtrls = this.stickyRowFeature && this.stickyRowFeature.getStickyBottomRowCtrls() || [];
        const res = [
            ...this.topRowCtrls,
            ...this.bottomRowCtrls,
            ...stickyTopRowCtrls,
            ...stickyBottomRowCtrls
        ];
        for(const key in this.rowCtrlsByRowIndex)res.push(this.rowCtrlsByRowIndex[key]);
        return res;
    }
    addRenderedRowListener(eventName, rowIndex, callback) {
        const rowComp = this.rowCtrlsByRowIndex[rowIndex];
        if (rowComp) rowComp.addEventListener(eventName, callback);
    }
    flashCells(params = {}) {
        this.getCellCtrls(params.rowNodes, params.columns).forEach((cellCtrl)=>cellCtrl.flashCell(params));
    }
    refreshCells(params = {}) {
        const refreshCellParams = {
            forceRefresh: params.force,
            newData: false,
            suppressFlash: params.suppressFlash
        };
        this.getCellCtrls(params.rowNodes, params.columns).forEach((cellCtrl)=>cellCtrl.refreshOrDestroyCell(refreshCellParams));
        if (params.rowNodes) {
            this.getRowCtrls(params.rowNodes).forEach((rowCtrl)=>{
                if (!rowCtrl.isFullWidth()) return;
                const refreshed = rowCtrl.refreshFullWidth();
                if (!refreshed) this.redrawRow(rowCtrl.getRowNode(), true);
            });
            this.dispatchDisplayedRowsChanged(false);
        }
    }
    getCellRendererInstances(params) {
        var _a;
        const cellRenderers = this.getCellCtrls(params.rowNodes, params.columns).map((cellCtrl)=>cellCtrl.getCellRenderer()).filter((renderer)=>renderer != null);
        if ((_a = params.columns) == null ? void 0 : _a.length) return cellRenderers;
        const fullWidthRenderers = [];
        const rowIdMap = this.mapRowNodes(params.rowNodes);
        this.getAllRowCtrls().forEach((rowCtrl)=>{
            if (rowIdMap && !this.isRowInMap(rowCtrl.getRowNode(), rowIdMap)) return;
            if (!rowCtrl.isFullWidth()) return;
            const renderers = rowCtrl.getFullWidthCellRenderers();
            for(let i = 0; i < renderers.length; i++){
                const renderer = renderers[i];
                if (renderer != null) fullWidthRenderers.push(renderer);
            }
        });
        return [
            ...fullWidthRenderers,
            ...cellRenderers
        ];
    }
    getCellEditorInstances(params) {
        const res = [];
        this.getCellCtrls(params.rowNodes, params.columns).forEach((cellCtrl)=>{
            const cellEditor = cellCtrl.getCellEditor();
            if (cellEditor) res.push(cellEditor);
        });
        return res;
    }
    getEditingCells() {
        const res = [];
        this.getAllCellCtrls().forEach((cellCtrl)=>{
            if (cellCtrl.isEditing()) {
                const cellPosition = cellCtrl.getCellPosition();
                res.push(cellPosition);
            }
        });
        return res;
    }
    mapRowNodes(rowNodes) {
        if (!rowNodes) return;
        const res = {
            top: {},
            bottom: {},
            normal: {}
        };
        rowNodes.forEach((rowNode)=>{
            const id = rowNode.id;
            switch(rowNode.rowPinned){
                case "top":
                    res.top[id] = rowNode;
                    break;
                case "bottom":
                    res.bottom[id] = rowNode;
                    break;
                default:
                    res.normal[id] = rowNode;
                    break;
            }
        });
        return res;
    }
    isRowInMap(rowNode, rowIdsMap) {
        const id = rowNode.id;
        const floating = rowNode.rowPinned;
        switch(floating){
            case "top":
                return rowIdsMap.top[id] != null;
            case "bottom":
                return rowIdsMap.bottom[id] != null;
            default:
                return rowIdsMap.normal[id] != null;
        }
    }
    /**
   * @param rowNodes if provided, returns the RowCtrls for the provided rowNodes. otherwise returns all RowCtrls.
   */ getRowCtrls(rowNodes) {
        const rowIdsMap = this.mapRowNodes(rowNodes);
        const allRowCtrls = this.getAllRowCtrls();
        if (!rowNodes || !rowIdsMap) return allRowCtrls;
        return allRowCtrls.filter((rowCtrl)=>{
            const rowNode = rowCtrl.getRowNode();
            return this.isRowInMap(rowNode, rowIdsMap);
        });
    }
    // returns CellCtrl's that match the provided rowNodes and columns. eg if one row node
    // and two columns provided, that identifies 4 cells, so 4 CellCtrl's returned.
    getCellCtrls(rowNodes, columns) {
        let colIdsMap;
        if (exists(columns)) {
            colIdsMap = {};
            columns.forEach((colKey)=>{
                const column = this.columnModel.getGridColumn(colKey);
                if (exists(column)) colIdsMap[column.getId()] = true;
            });
        }
        const res = [];
        this.getRowCtrls(rowNodes).forEach((rowCtrl)=>{
            rowCtrl.getAllCellCtrls().forEach((cellCtrl)=>{
                const colId = cellCtrl.getColumn().getId();
                const excludeColFromRefresh = colIdsMap && !colIdsMap[colId];
                if (excludeColFromRefresh) return;
                res.push(cellCtrl);
            });
        });
        return res;
    }
    destroy() {
        this.removeAllRowComps();
        super.destroy();
    }
    removeAllRowComps() {
        const rowIndexesToRemove = Object.keys(this.rowCtrlsByRowIndex);
        this.removeRowCtrls(rowIndexesToRemove);
        if (this.stickyRowFeature) this.stickyRowFeature.destroyStickyCtrls();
    }
    getRowsToRecycle() {
        const stubNodeIndexes = [];
        iterateObject(this.rowCtrlsByRowIndex, (index, rowCtrl)=>{
            const stubNode = rowCtrl.getRowNode().id == null;
            if (stubNode) stubNodeIndexes.push(index);
        });
        this.removeRowCtrls(stubNodeIndexes);
        const ctrlsByIdMap = {};
        iterateObject(this.rowCtrlsByRowIndex, (index, rowCtrl)=>{
            const rowNode = rowCtrl.getRowNode();
            ctrlsByIdMap[rowNode.id] = rowCtrl;
        });
        this.rowCtrlsByRowIndex = {};
        return ctrlsByIdMap;
    }
    // takes array of row indexes
    removeRowCtrls(rowsToRemove, suppressAnimation = false) {
        rowsToRemove.forEach((indexToRemove)=>{
            const rowCtrl = this.rowCtrlsByRowIndex[indexToRemove];
            if (rowCtrl) {
                rowCtrl.destroyFirstPass(suppressAnimation);
                rowCtrl.destroySecondPass();
            }
            delete this.rowCtrlsByRowIndex[indexToRemove];
        });
    }
    onBodyScroll(e) {
        if (e.direction !== "vertical") return;
        this.redraw({
            afterScroll: true
        });
    }
    // gets called when rows don't change, but viewport does, so after:
    // 1) height of grid body changes, ie number of displayed rows has changed
    // 2) grid scrolled to new position
    // 3) ensure index visible (which is a scroll)
    redraw(params = {}) {
        const { afterScroll } = params;
        let cellFocused;
        if (this.stickyRowFeature && browserSupportsPreventScroll()) cellFocused = this.getCellToRestoreFocusToAfterRefresh() || void 0;
        const oldFirstRow = this.firstRenderedRow;
        const oldLastRow = this.lastRenderedRow;
        this.workOutFirstAndLastRowsToRender();
        let hasStickyRowChanges = false;
        if (this.stickyRowFeature) hasStickyRowChanges = this.stickyRowFeature.checkStickyRows();
        const rangeChanged = this.firstRenderedRow !== oldFirstRow || this.lastRenderedRow !== oldLastRow;
        if (afterScroll && !hasStickyRowChanges && !rangeChanged) return;
        this.getLockOnRefresh();
        this.recycleRows(null, false, afterScroll);
        this.releaseLockOnRefresh();
        this.dispatchDisplayedRowsChanged(afterScroll && !hasStickyRowChanges);
        if (cellFocused != null) {
            const newFocusedCell = this.getCellToRestoreFocusToAfterRefresh();
            if (cellFocused != null && newFocusedCell == null) {
                this.animationFrameService.flushAllFrames();
                this.restoreFocusedCell(cellFocused);
            }
        }
    }
    removeRowCompsNotToDraw(indexesToDraw, suppressAnimation) {
        const indexesToDrawMap = {};
        indexesToDraw.forEach((index)=>indexesToDrawMap[index] = true);
        const existingIndexes = Object.keys(this.rowCtrlsByRowIndex);
        const indexesNotToDraw = existingIndexes.filter((index)=>!indexesToDrawMap[index]);
        this.removeRowCtrls(indexesNotToDraw, suppressAnimation);
    }
    calculateIndexesToDraw(rowsToRecycle) {
        let indexesToDraw = createArrayOfNumbers(this.firstRenderedRow, this.lastRenderedRow);
        const checkRowToDraw = (indexStr, rowComp)=>{
            const index = rowComp.getRowNode().rowIndex;
            if (index == null) return;
            if (index < this.firstRenderedRow || index > this.lastRenderedRow) {
                if (this.doNotUnVirtualiseRow(rowComp)) indexesToDraw.push(index);
            }
        };
        iterateObject(this.rowCtrlsByRowIndex, checkRowToDraw);
        iterateObject(rowsToRecycle, checkRowToDraw);
        indexesToDraw.sort((a, b)=>a - b);
        const ret = [];
        for(let i = 0; i < indexesToDraw.length; i++){
            const currRow = indexesToDraw[i];
            const rowNode = this.paginationProxy.getRow(currRow);
            if (rowNode && !rowNode.sticky) ret.push(currRow);
        }
        return ret;
    }
    recycleRows(rowsToRecycle, animate = false, afterScroll = false) {
        const indexesToDraw = this.calculateIndexesToDraw(rowsToRecycle);
        if (this.printLayout || afterScroll) animate = false;
        this.removeRowCompsNotToDraw(indexesToDraw, !animate);
        const rowCtrls = [];
        indexesToDraw.forEach((rowIndex)=>{
            const rowCtrl = this.createOrUpdateRowCtrl(rowIndex, rowsToRecycle, animate, afterScroll);
            if (exists(rowCtrl)) rowCtrls.push(rowCtrl);
        });
        if (rowsToRecycle) {
            const useAnimationFrame = afterScroll && !this.gos.get("suppressAnimationFrame") && !this.printLayout;
            if (useAnimationFrame) this.beans.animationFrameService.addDestroyTask(()=>{
                this.destroyRowCtrls(rowsToRecycle, animate);
                this.updateAllRowCtrls();
                this.dispatchDisplayedRowsChanged();
            });
            else this.destroyRowCtrls(rowsToRecycle, animate);
        }
        this.updateAllRowCtrls();
    }
    dispatchDisplayedRowsChanged(afterScroll = false) {
        const event = {
            type: Events.EVENT_DISPLAYED_ROWS_CHANGED,
            afterScroll
        };
        this.eventService.dispatchEvent(event);
    }
    onDisplayedColumnsChanged() {
        const pinningLeft = this.columnModel.isPinningLeft();
        const pinningRight = this.columnModel.isPinningRight();
        const atLeastOneChanged = this.pinningLeft !== pinningLeft || pinningRight !== this.pinningRight;
        if (atLeastOneChanged) {
            this.pinningLeft = pinningLeft;
            this.pinningRight = pinningRight;
            if (this.embedFullWidthRows) this.redrawFullWidthEmbeddedRows();
        }
    }
    // when embedding, what gets showed in each section depends on what is pinned. eg if embedding group expand / collapse,
    // then it should go into the pinned left area if pinning left, or the center area if not pinning.
    redrawFullWidthEmbeddedRows() {
        const rowsToRemove = [];
        this.getFullWidthRowCtrls().forEach((fullWidthCtrl)=>{
            const rowIndex = fullWidthCtrl.getRowNode().rowIndex;
            rowsToRemove.push(rowIndex.toString());
        });
        this.refreshFloatingRowComps();
        this.removeRowCtrls(rowsToRemove);
        this.redraw({
            afterScroll: true
        });
    }
    getFullWidthRowCtrls(rowNodes) {
        const rowNodesMap = this.mapRowNodes(rowNodes);
        return this.getAllRowCtrls().filter((rowCtrl)=>{
            if (!rowCtrl.isFullWidth()) return false;
            const rowNode = rowCtrl.getRowNode();
            if (rowNodesMap != null && !this.isRowInMap(rowNode, rowNodesMap)) return false;
            return true;
        });
    }
    createOrUpdateRowCtrl(rowIndex, rowsToRecycle, animate, afterScroll) {
        let rowNode;
        let rowCtrl = this.rowCtrlsByRowIndex[rowIndex];
        if (!rowCtrl) {
            rowNode = this.paginationProxy.getRow(rowIndex);
            if (exists(rowNode) && exists(rowsToRecycle) && rowsToRecycle[rowNode.id] && rowNode.alreadyRendered) {
                rowCtrl = rowsToRecycle[rowNode.id];
                rowsToRecycle[rowNode.id] = null;
            }
        }
        const creatingNewRowCtrl = !rowCtrl;
        if (creatingNewRowCtrl) {
            if (!rowNode) rowNode = this.paginationProxy.getRow(rowIndex);
            if (exists(rowNode)) rowCtrl = this.createRowCon(rowNode, animate, afterScroll);
            else return;
        }
        if (rowNode) rowNode.alreadyRendered = true;
        this.rowCtrlsByRowIndex[rowIndex] = rowCtrl;
        return rowCtrl;
    }
    destroyRowCtrls(rowCtrlsMap, animate) {
        const executeInAWhileFuncs = [];
        iterateObject(rowCtrlsMap, (nodeId, rowCtrl)=>{
            if (!rowCtrl) return;
            if (this.cachedRowCtrls && rowCtrl.isCacheable()) {
                this.cachedRowCtrls.addRow(rowCtrl);
                return;
            }
            rowCtrl.destroyFirstPass(!animate);
            if (animate) {
                this.zombieRowCtrls[rowCtrl.getInstanceId()] = rowCtrl;
                executeInAWhileFuncs.push(()=>{
                    rowCtrl.destroySecondPass();
                    delete this.zombieRowCtrls[rowCtrl.getInstanceId()];
                });
            } else rowCtrl.destroySecondPass();
        });
        if (animate) {
            executeInAWhileFuncs.push(()=>{
                this.updateAllRowCtrls();
                this.dispatchDisplayedRowsChanged();
            });
            executeInAWhile(executeInAWhileFuncs);
        }
    }
    getRowBuffer() {
        return this.gos.get("rowBuffer");
    }
    getRowBufferInPixels() {
        const rowsToBuffer = this.getRowBuffer();
        const defaultRowHeight = this.gos.getRowHeightAsNumber();
        return rowsToBuffer * defaultRowHeight;
    }
    workOutFirstAndLastRowsToRender() {
        this.rowContainerHeightService.updateOffset();
        let newFirst;
        let newLast;
        if (!this.paginationProxy.isRowsToRender()) {
            newFirst = 0;
            newLast = -1;
        } else if (this.printLayout) {
            this.environment.refreshRowHeightVariable();
            newFirst = this.paginationProxy.getPageFirstRow();
            newLast = this.paginationProxy.getPageLastRow();
        } else {
            const bufferPixels = this.getRowBufferInPixels();
            const gridBodyCtrl = this.ctrlsService.getGridBodyCtrl();
            const suppressRowVirtualisation = this.gos.get("suppressRowVirtualisation");
            let rowHeightsChanged = false;
            let firstPixel;
            let lastPixel;
            do {
                const paginationOffset = this.paginationProxy.getPixelOffset();
                const { pageFirstPixel, pageLastPixel } = this.paginationProxy.getCurrentPagePixelRange();
                const divStretchOffset = this.rowContainerHeightService.getDivStretchOffset();
                const bodyVRange = gridBodyCtrl.getScrollFeature().getVScrollPosition();
                const bodyTopPixel = bodyVRange.top;
                const bodyBottomPixel = bodyVRange.bottom;
                if (suppressRowVirtualisation) {
                    firstPixel = pageFirstPixel + divStretchOffset;
                    lastPixel = pageLastPixel + divStretchOffset;
                } else {
                    firstPixel = Math.max(bodyTopPixel + paginationOffset - bufferPixels, pageFirstPixel) + divStretchOffset;
                    lastPixel = Math.min(bodyBottomPixel + paginationOffset + bufferPixels, pageLastPixel) + divStretchOffset;
                }
                this.firstVisibleVPixel = Math.max(bodyTopPixel + paginationOffset, pageFirstPixel) + divStretchOffset;
                this.lastVisibleVPixel = Math.min(bodyBottomPixel + paginationOffset, pageLastPixel) + divStretchOffset;
                rowHeightsChanged = this.ensureAllRowsInRangeHaveHeightsCalculated(firstPixel, lastPixel);
            }while (rowHeightsChanged);
            let firstRowIndex = this.paginationProxy.getRowIndexAtPixel(firstPixel);
            let lastRowIndex = this.paginationProxy.getRowIndexAtPixel(lastPixel);
            const pageFirstRow = this.paginationProxy.getPageFirstRow();
            const pageLastRow = this.paginationProxy.getPageLastRow();
            if (firstRowIndex < pageFirstRow) firstRowIndex = pageFirstRow;
            if (lastRowIndex > pageLastRow) lastRowIndex = pageLastRow;
            newFirst = firstRowIndex;
            newLast = lastRowIndex;
        }
        const rowLayoutNormal = this.gos.isDomLayout("normal");
        const suppressRowCountRestriction = this.gos.get("suppressMaxRenderedRowRestriction");
        const rowBufferMaxSize = Math.max(this.getRowBuffer(), 500);
        if (rowLayoutNormal && !suppressRowCountRestriction) {
            if (newLast - newFirst > rowBufferMaxSize) newLast = newFirst + rowBufferMaxSize;
        }
        const firstDiffers = newFirst !== this.firstRenderedRow;
        const lastDiffers = newLast !== this.lastRenderedRow;
        if (firstDiffers || lastDiffers) {
            this.firstRenderedRow = newFirst;
            this.lastRenderedRow = newLast;
            const event = {
                type: Events.EVENT_VIEWPORT_CHANGED,
                firstRow: newFirst,
                lastRow: newLast
            };
            this.eventService.dispatchEvent(event);
        }
    }
    /**
   * This event will only be fired once, and is queued until after the browser next renders.
   * This allows us to fire an event during the start of the render cycle, when we first see data being rendered
   * but not execute the event until all of the data has finished being rendered to the dom.
   */ dispatchFirstDataRenderedEvent() {
        if (this.dataFirstRenderedFired) return;
        this.dataFirstRenderedFired = true;
        const event = {
            type: Events.EVENT_FIRST_DATA_RENDERED,
            firstRow: this.firstRenderedRow,
            lastRow: this.lastRenderedRow
        };
        window.requestAnimationFrame(()=>{
            this.beans.eventService.dispatchEvent(event);
        });
    }
    ensureAllRowsInRangeHaveHeightsCalculated(topPixel, bottomPixel) {
        const res = this.paginationProxy.ensureRowHeightsValid(topPixel, bottomPixel, -1, -1);
        if (res) this.updateContainerHeights();
        return res;
    }
    getFirstVisibleVerticalPixel() {
        return this.firstVisibleVPixel;
    }
    getLastVisibleVerticalPixel() {
        return this.lastVisibleVPixel;
    }
    getFirstVirtualRenderedRow() {
        return this.firstRenderedRow;
    }
    getLastVirtualRenderedRow() {
        return this.lastRenderedRow;
    }
    // check that none of the rows to remove are editing or focused as:
    // a) if editing, we want to keep them, otherwise the user will loose the context of the edit,
    //    eg user starts editing, enters some text, then scrolls down and then up, next time row rendered
    //    the edit is reset - so we want to keep it rendered.
    // b) if focused, we want ot keep keyboard focus, so if user ctrl+c, it goes to clipboard,
    //    otherwise the user can range select and drag (with focus cell going out of the viewport)
    //    and then ctrl+c, nothing will happen if cell is removed from dom.
    // c) if detail record of master detail, as users complained that the context of detail rows
    //    was getting lost when detail row out of view. eg user expands to show detail row,
    //    then manipulates the detail panel (eg sorts the detail grid), then context is lost
    //    after detail panel is scrolled out of / into view.
    doNotUnVirtualiseRow(rowComp) {
        const REMOVE_ROW = false;
        const KEEP_ROW = true;
        const rowNode = rowComp.getRowNode();
        const rowHasFocus = this.focusService.isRowNodeFocused(rowNode);
        const rowIsEditing = rowComp.isEditing();
        const rowIsDetail = rowNode.detail;
        const mightWantToKeepRow = rowHasFocus || rowIsEditing || rowIsDetail;
        if (!mightWantToKeepRow) return REMOVE_ROW;
        const rowNodePresent = this.paginationProxy.isRowPresent(rowNode);
        return rowNodePresent ? KEEP_ROW : REMOVE_ROW;
    }
    createRowCon(rowNode, animate, afterScroll) {
        const rowCtrlFromCache = this.cachedRowCtrls ? this.cachedRowCtrls.getRow(rowNode) : null;
        if (rowCtrlFromCache) return rowCtrlFromCache;
        const suppressAnimationFrame = this.gos.get("suppressAnimationFrame");
        const useAnimationFrameForCreate = afterScroll && !suppressAnimationFrame && !this.printLayout;
        const res = new RowCtrl(rowNode, this.beans, animate, useAnimationFrameForCreate, this.printLayout);
        return res;
    }
    getRenderedNodes() {
        const renderedRows = this.rowCtrlsByRowIndex;
        return Object.values(renderedRows).map((rowCtrl)=>rowCtrl.getRowNode());
    }
    getRowByPosition(rowPosition) {
        let rowCtrl;
        const { rowIndex } = rowPosition;
        switch(rowPosition.rowPinned){
            case "top":
                rowCtrl = this.topRowCtrls[rowIndex];
                break;
            case "bottom":
                rowCtrl = this.bottomRowCtrls[rowIndex];
                break;
            default:
                rowCtrl = this.rowCtrlsByRowIndex[rowIndex];
                if (!rowCtrl) {
                    rowCtrl = this.getStickyTopRowCtrls().find((ctrl)=>ctrl.getRowNode().rowIndex === rowIndex) || null;
                    if (!rowCtrl) rowCtrl = this.getStickyBottomRowCtrls().find((ctrl)=>ctrl.getRowNode().rowIndex === rowIndex) || null;
                }
                break;
        }
        return rowCtrl;
    }
    // returns true if any row between startIndex and endIndex is rendered. used by
    // SSRM or IRM, as they don't want to purge visible blocks from cache.
    isRangeInRenderedViewport(startIndex, endIndex) {
        const parentClosed = startIndex == null || endIndex == null;
        if (parentClosed) return false;
        const blockAfterViewport = startIndex > this.lastRenderedRow;
        const blockBeforeViewport = endIndex < this.firstRenderedRow;
        const blockInsideViewport = !blockBeforeViewport && !blockAfterViewport;
        return blockInsideViewport;
    }
};
__decorateClass([
    Autowired("animationFrameService")
], RowRenderer.prototype, "animationFrameService", 2);
__decorateClass([
    Autowired("paginationProxy")
], RowRenderer.prototype, "paginationProxy", 2);
__decorateClass([
    Autowired("columnModel")
], RowRenderer.prototype, "columnModel", 2);
__decorateClass([
    Autowired("pinnedRowModel")
], RowRenderer.prototype, "pinnedRowModel", 2);
__decorateClass([
    Autowired("rowModel")
], RowRenderer.prototype, "rowModel", 2);
__decorateClass([
    Autowired("focusService")
], RowRenderer.prototype, "focusService", 2);
__decorateClass([
    Autowired("beans")
], RowRenderer.prototype, "beans", 2);
__decorateClass([
    Autowired("rowContainerHeightService")
], RowRenderer.prototype, "rowContainerHeightService", 2);
__decorateClass([
    Autowired("ctrlsService")
], RowRenderer.prototype, "ctrlsService", 2);
__decorateClass([
    PostConstruct
], RowRenderer.prototype, "postConstruct", 1);
RowRenderer = __decorateClass([
    Bean("rowRenderer")
], RowRenderer);
var RowCtrlCache = class {
    constructor(maxCount){
        // map for fast access
        this.entriesMap = {};
        // list for keeping order
        this.entriesList = [];
        this.maxCount = maxCount;
    }
    addRow(rowCtrl) {
        this.entriesMap[rowCtrl.getRowNode().id] = rowCtrl;
        this.entriesList.push(rowCtrl);
        rowCtrl.setCached(true);
        if (this.entriesList.length > this.maxCount) {
            const rowCtrlToDestroy = this.entriesList[0];
            rowCtrlToDestroy.destroyFirstPass();
            rowCtrlToDestroy.destroySecondPass();
            this.removeFromCache(rowCtrlToDestroy);
        }
    }
    getRow(rowNode) {
        if (rowNode == null || rowNode.id == null) return null;
        const res = this.entriesMap[rowNode.id];
        if (!res) return null;
        this.removeFromCache(res);
        res.setCached(false);
        const rowNodeMismatch = res.getRowNode() != rowNode;
        return rowNodeMismatch ? null : res;
    }
    has(rowNode) {
        return this.entriesMap[rowNode.id] != null;
    }
    removeRow(rowNode) {
        const rowNodeId = rowNode.id;
        const ctrl = this.entriesMap[rowNodeId];
        delete this.entriesMap[rowNodeId];
        removeFromArray(this.entriesList, ctrl);
    }
    removeFromCache(rowCtrl) {
        const rowNodeId = rowCtrl.getRowNode().id;
        delete this.entriesMap[rowNodeId];
        removeFromArray(this.entriesList, rowCtrl);
    }
    getEntries() {
        return this.entriesList;
    }
};
// community-modules/core/src/pinnedRowModel/pinnedRowModel.ts
var PinnedRowModel = class extends BeanStub {
    init() {
        this.setPinnedTopRowData();
        this.setPinnedBottomRowData();
        this.addManagedPropertyListener("pinnedTopRowData", ()=>this.setPinnedTopRowData());
        this.addManagedPropertyListener("pinnedBottomRowData", ()=>this.setPinnedBottomRowData());
    }
    isEmpty(floating) {
        const rows = floating === "top" ? this.pinnedTopRows : this.pinnedBottomRows;
        return missingOrEmpty(rows);
    }
    isRowsToRender(floating) {
        return !this.isEmpty(floating);
    }
    getRowAtPixel(pixel, floating) {
        const rows = floating === "top" ? this.pinnedTopRows : this.pinnedBottomRows;
        if (missingOrEmpty(rows)) return 0;
        for(let i = 0; i < rows.length; i++){
            const rowNode = rows[i];
            const rowTopPixel = rowNode.rowTop + rowNode.rowHeight - 1;
            if (rowTopPixel >= pixel) return i;
        }
        return rows.length - 1;
    }
    setPinnedTopRowData() {
        const rowData = this.gos.get("pinnedTopRowData");
        this.pinnedTopRows = this.createNodesFromData(rowData, true);
        const event = {
            type: Events.EVENT_PINNED_ROW_DATA_CHANGED
        };
        this.eventService.dispatchEvent(event);
    }
    setPinnedBottomRowData() {
        const rowData = this.gos.get("pinnedBottomRowData");
        this.pinnedBottomRows = this.createNodesFromData(rowData, false);
        const event = {
            type: Events.EVENT_PINNED_ROW_DATA_CHANGED
        };
        this.eventService.dispatchEvent(event);
    }
    createNodesFromData(allData, isTop) {
        const rowNodes = [];
        if (allData) {
            let nextRowTop = 0;
            allData.forEach((dataItem, index)=>{
                const rowNode = new RowNode(this.beans);
                rowNode.data = dataItem;
                const idPrefix = isTop ? RowNode.ID_PREFIX_TOP_PINNED : RowNode.ID_PREFIX_BOTTOM_PINNED;
                rowNode.id = idPrefix + index;
                rowNode.rowPinned = isTop ? "top" : "bottom";
                rowNode.setRowTop(nextRowTop);
                rowNode.setRowHeight(this.gos.getRowHeightForNode(rowNode).height);
                rowNode.setRowIndex(index);
                nextRowTop += rowNode.rowHeight;
                rowNodes.push(rowNode);
            });
        }
        return rowNodes;
    }
    getPinnedTopRowData() {
        return this.pinnedTopRows;
    }
    getPinnedBottomRowData() {
        return this.pinnedBottomRows;
    }
    getPinnedTopTotalHeight() {
        return this.getTotalHeight(this.pinnedTopRows);
    }
    getPinnedTopRowCount() {
        return this.pinnedTopRows ? this.pinnedTopRows.length : 0;
    }
    getPinnedBottomRowCount() {
        return this.pinnedBottomRows ? this.pinnedBottomRows.length : 0;
    }
    getPinnedTopRow(index) {
        return this.pinnedTopRows[index];
    }
    getPinnedBottomRow(index) {
        return this.pinnedBottomRows[index];
    }
    forEachPinnedTopRow(callback) {
        if (missingOrEmpty(this.pinnedTopRows)) return;
        this.pinnedTopRows.forEach(callback);
    }
    forEachPinnedBottomRow(callback) {
        if (missingOrEmpty(this.pinnedBottomRows)) return;
        this.pinnedBottomRows.forEach(callback);
    }
    getPinnedBottomTotalHeight() {
        return this.getTotalHeight(this.pinnedBottomRows);
    }
    getTotalHeight(rowNodes) {
        if (!rowNodes || rowNodes.length === 0) return 0;
        const lastNode = last(rowNodes);
        return lastNode.rowTop + lastNode.rowHeight;
    }
};
__decorateClass([
    Autowired("beans")
], PinnedRowModel.prototype, "beans", 2);
__decorateClass([
    PostConstruct
], PinnedRowModel.prototype, "init", 1);
PinnedRowModel = __decorateClass([
    Bean("pinnedRowModel")
], PinnedRowModel);
// community-modules/core/src/interfaces/serverSideTransaction.ts
var ServerSideTransactionResultStatus = /* @__PURE__ */ ((ServerSideTransactionResultStatus2)=>{
    ServerSideTransactionResultStatus2["Applied"] = "Applied";
    ServerSideTransactionResultStatus2["StoreNotFound"] = "StoreNotFound";
    ServerSideTransactionResultStatus2["StoreLoading"] = "StoreLoading";
    ServerSideTransactionResultStatus2["StoreWaitingToLoad"] = "StoreWaitingToLoad";
    ServerSideTransactionResultStatus2["StoreLoadingFailed"] = "StoreLoadingFailed";
    ServerSideTransactionResultStatus2["StoreWrongType"] = "StoreWrongType";
    ServerSideTransactionResultStatus2["Cancelled"] = "Cancelled";
    ServerSideTransactionResultStatus2["StoreNotStarted"] = "StoreNotStarted";
    return ServerSideTransactionResultStatus2;
})(ServerSideTransactionResultStatus || {});
// community-modules/core/src/utils/changedPath.ts
var ChangedPath = class {
    constructor(keepingColumns, rootNode){
        // whether changed path is active of not. it is active when a) doing
        // a transaction update or b) doing change detection. if we are doing
        // a CSRM refresh for other reasons (after sort or filter, or user calling
        // setRowData() without delta mode) then we are not active. we are also
        // marked as not active if secondary columns change in pivot (as this impacts
        // aggregations)
        this.active = true;
        // for each node in the change path, we also store which columns need
        // to be re-aggregated.
        this.nodeIdsToColumns = {};
        // for quick lookup, all items in the change path are mapped by nodeId
        this.mapToItems = {};
        this.keepingColumns = keepingColumns;
        this.pathRoot = {
            rowNode: rootNode,
            children: null
        };
        this.mapToItems[rootNode.id] = this.pathRoot;
    }
    // can be set inactive by:
    // a) ClientSideRowModel, if no transactions or
    // b) PivotService, if secondary columns changed
    setInactive() {
        this.active = false;
    }
    isActive() {
        return this.active;
    }
    depthFirstSearchChangedPath(pathItem, callback) {
        if (pathItem.children) for(let i = 0; i < pathItem.children.length; i++)this.depthFirstSearchChangedPath(pathItem.children[i], callback);
        callback(pathItem.rowNode);
    }
    depthFirstSearchEverything(rowNode, callback, traverseEverything) {
        if (rowNode.childrenAfterGroup) for(let i = 0; i < rowNode.childrenAfterGroup.length; i++){
            const childNode = rowNode.childrenAfterGroup[i];
            if (childNode.childrenAfterGroup) this.depthFirstSearchEverything(rowNode.childrenAfterGroup[i], callback, traverseEverything);
            else if (traverseEverything) callback(childNode);
        }
        callback(rowNode);
    }
    // traverseLeafNodes -> used when NOT doing changed path, ie traversing everything. the callback
    // will be called for child nodes in addition to parent nodes.
    forEachChangedNodeDepthFirst(callback, traverseLeafNodes = false, includeUnchangedNodes = false) {
        if (this.active && !includeUnchangedNodes) this.depthFirstSearchChangedPath(this.pathRoot, callback);
        else this.depthFirstSearchEverything(this.pathRoot.rowNode, callback, traverseLeafNodes);
    }
    executeFromRootNode(callback) {
        callback(this.pathRoot.rowNode);
    }
    createPathItems(rowNode) {
        let pointer = rowNode;
        let newEntryCount = 0;
        while(!this.mapToItems[pointer.id]){
            const newEntry = {
                rowNode: pointer,
                children: null
            };
            this.mapToItems[pointer.id] = newEntry;
            newEntryCount++;
            pointer = pointer.parent;
        }
        return newEntryCount;
    }
    populateColumnsMap(rowNode, columns) {
        if (!this.keepingColumns || !columns) return;
        let pointer = rowNode;
        while(pointer){
            if (!this.nodeIdsToColumns[pointer.id]) this.nodeIdsToColumns[pointer.id] = {};
            columns.forEach((col)=>this.nodeIdsToColumns[pointer.id][col.getId()] = true);
            pointer = pointer.parent;
        }
    }
    linkPathItems(rowNode, newEntryCount) {
        let pointer = rowNode;
        for(let i = 0; i < newEntryCount; i++){
            const thisItem = this.mapToItems[pointer.id];
            const parentItem = this.mapToItems[pointer.parent.id];
            if (!parentItem.children) parentItem.children = [];
            parentItem.children.push(thisItem);
            pointer = pointer.parent;
        }
    }
    // called by
    // 1) change detection (provides cols) and
    // 2) groupStage if doing transaction update (doesn't provide cols)
    addParentNode(rowNode, columns) {
        if (!rowNode || rowNode.isRowPinned()) return;
        const newEntryCount = this.createPathItems(rowNode);
        this.linkPathItems(rowNode, newEntryCount);
        this.populateColumnsMap(rowNode, columns);
    }
    canSkip(rowNode) {
        return this.active && !this.mapToItems[rowNode.id];
    }
    getValueColumnsForNode(rowNode, valueColumns) {
        if (!this.keepingColumns) return valueColumns;
        const colsForThisNode = this.nodeIdsToColumns[rowNode.id];
        const result = valueColumns.filter((col)=>colsForThisNode[col.getId()]);
        return result;
    }
    getNotValueColumnsForNode(rowNode, valueColumns) {
        if (!this.keepingColumns) return null;
        const colsForThisNode = this.nodeIdsToColumns[rowNode.id];
        const result = valueColumns.filter((col)=>!colsForThisNode[col.getId()]);
        return result;
    }
};
// community-modules/core/src/rowNodeCache/rowNodeBlock.ts
var _RowNodeBlock = class _RowNodeBlock extends BeanStub {
    constructor(id){
        super();
        this.state = _RowNodeBlock.STATE_WAITING_TO_LOAD;
        this.version = 0;
        this.id = id;
    }
    getId() {
        return this.id;
    }
    load() {
        this.state = _RowNodeBlock.STATE_LOADING;
        this.loadFromDatasource();
    }
    getVersion() {
        return this.version;
    }
    setStateWaitingToLoad() {
        this.version++;
        this.state = _RowNodeBlock.STATE_WAITING_TO_LOAD;
    }
    getState() {
        return this.state;
    }
    pageLoadFailed(version) {
        const requestMostRecentAndLive = this.isRequestMostRecentAndLive(version);
        if (requestMostRecentAndLive) {
            this.state = _RowNodeBlock.STATE_FAILED;
            this.processServerFail();
        }
        this.dispatchLoadCompleted(false);
    }
    success(version, params) {
        this.successCommon(version, params);
    }
    pageLoaded(version, rows, lastRow) {
        this.successCommon(version, {
            rowData: rows,
            rowCount: lastRow
        });
    }
    isRequestMostRecentAndLive(version) {
        const thisIsMostRecentRequest = version === this.version;
        const weAreNotDestroyed = this.isAlive();
        return thisIsMostRecentRequest && weAreNotDestroyed;
    }
    successCommon(version, params) {
        this.dispatchLoadCompleted();
        const requestMostRecentAndLive = this.isRequestMostRecentAndLive(version);
        if (requestMostRecentAndLive) {
            this.state = _RowNodeBlock.STATE_LOADED;
            this.processServerResult(params);
        }
    }
    dispatchLoadCompleted(success = true) {
        const event = {
            type: _RowNodeBlock.EVENT_LOAD_COMPLETE,
            success,
            block: this
        };
        this.dispatchEvent(event);
    }
};
_RowNodeBlock.EVENT_LOAD_COMPLETE = "loadComplete";
_RowNodeBlock.STATE_WAITING_TO_LOAD = "needsLoading";
_RowNodeBlock.STATE_LOADING = "loading";
_RowNodeBlock.STATE_LOADED = "loaded";
_RowNodeBlock.STATE_FAILED = "failed";
var RowNodeBlock = _RowNodeBlock;
// community-modules/core/src/rowNodeCache/rowNodeBlockLoader.ts
var RowNodeBlockLoader = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.activeBlockLoadsCount = 0;
        this.blocks = [];
        this.active = true;
    }
    postConstruct() {
        this.maxConcurrentRequests = this.getMaxConcurrentDatasourceRequests();
        const blockLoadDebounceMillis = this.gos.get("blockLoadDebounceMillis");
        if (blockLoadDebounceMillis && blockLoadDebounceMillis > 0) this.checkBlockToLoadDebounce = _.debounce(this.performCheckBlocksToLoad.bind(this), blockLoadDebounceMillis);
    }
    setBeans(loggerFactory) {
        this.logger = loggerFactory.create("RowNodeBlockLoader");
    }
    getMaxConcurrentDatasourceRequests() {
        const res = this.gos.get("maxConcurrentDatasourceRequests");
        if (res == null) return 2;
        if (res <= 0) return;
        return res;
    }
    addBlock(block) {
        this.blocks.push(block);
        block.addEventListener(RowNodeBlock.EVENT_LOAD_COMPLETE, this.loadComplete.bind(this));
        this.checkBlockToLoad();
    }
    removeBlock(block) {
        _.removeFromArray(this.blocks, block);
    }
    destroy() {
        super.destroy();
        this.active = false;
    }
    loadComplete() {
        this.activeBlockLoadsCount--;
        this.checkBlockToLoad();
        this.dispatchEvent({
            type: RowNodeBlockLoader.BLOCK_LOADED_EVENT
        });
        if (this.activeBlockLoadsCount == 0) this.dispatchEvent({
            type: RowNodeBlockLoader.BLOCK_LOADER_FINISHED_EVENT
        });
    }
    checkBlockToLoad() {
        if (this.checkBlockToLoadDebounce) this.checkBlockToLoadDebounce();
        else this.performCheckBlocksToLoad();
    }
    performCheckBlocksToLoad() {
        if (!this.active) return;
        this.printCacheStatus();
        if (this.maxConcurrentRequests != null && this.activeBlockLoadsCount >= this.maxConcurrentRequests) {
            this.logger.log(`checkBlockToLoad: max loads exceeded`);
            return;
        }
        const loadAvailability = this.getAvailableLoadingCount();
        const blocksToLoad = this.blocks.filter((block)=>block.getState() === RowNodeBlock.STATE_WAITING_TO_LOAD).slice(0, loadAvailability);
        this.registerLoads(blocksToLoad.length);
        blocksToLoad.forEach((block)=>block.load());
        this.printCacheStatus();
    }
    getBlockState() {
        if (this.gos.isRowModelType("serverSide")) {
            const ssrm = this.rowModel;
            return ssrm.getBlockStates();
        }
        const result = {};
        this.blocks.forEach((block)=>{
            const { id, state } = block.getBlockStateJson();
            result[id] = state;
        });
        return result;
    }
    printCacheStatus() {
        if (this.logger.isLogging()) this.logger.log(`printCacheStatus: activePageLoadsCount = ${this.activeBlockLoadsCount}, blocks = ${JSON.stringify(this.getBlockState())}`);
    }
    isLoading() {
        return this.activeBlockLoadsCount > 0;
    }
    registerLoads(count) {
        this.activeBlockLoadsCount += count;
    }
    getAvailableLoadingCount() {
        return this.maxConcurrentRequests !== void 0 ? this.maxConcurrentRequests - this.activeBlockLoadsCount : void 0;
    }
};
RowNodeBlockLoader.BLOCK_LOADED_EVENT = "blockLoaded";
RowNodeBlockLoader.BLOCK_LOADER_FINISHED_EVENT = "blockLoaderFinished";
__decorateClass([
    Autowired("rowModel")
], RowNodeBlockLoader.prototype, "rowModel", 2);
__decorateClass([
    PostConstruct
], RowNodeBlockLoader.prototype, "postConstruct", 1);
__decorateClass([
    __decorateParam(0, Qualifier("loggerFactory"))
], RowNodeBlockLoader.prototype, "setBeans", 1);
RowNodeBlockLoader = __decorateClass([
    Bean("rowNodeBlockLoader")
], RowNodeBlockLoader);
// community-modules/core/src/pagination/paginationProxy.ts
var PaginationProxy = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.currentPage = 0;
        this.topDisplayedRowIndex = 0;
        this.bottomDisplayedRowIndex = 0;
        this.pixelOffset = 0;
        this.masterRowCount = 0;
    }
    postConstruct() {
        this.active = this.gos.get("pagination");
        this.pageSizeFromGridOptions = this.gos.get("paginationPageSize");
        this.paginateChildRows = this.isPaginateChildRows();
        this.addManagedListener(this.eventService, Events.EVENT_MODEL_UPDATED, this.onModelUpdated.bind(this));
        this.addManagedPropertyListener("pagination", this.onPaginationGridOptionChanged.bind(this));
        this.addManagedPropertyListener("paginationPageSize", this.onPageSizeGridOptionChanged.bind(this));
        this.onModelUpdated();
    }
    ensureRowHeightsValid(startPixel, endPixel, startLimitIndex, endLimitIndex) {
        const res = this.rowModel.ensureRowHeightsValid(startPixel, endPixel, this.getPageFirstRow(), this.getPageLastRow());
        if (res) this.calculatePages();
        return res;
    }
    isPaginateChildRows() {
        const shouldPaginate = this.gos.get("groupRemoveSingleChildren") || this.gos.get("groupRemoveLowestSingleChildren");
        if (shouldPaginate) return true;
        return this.gos.get("paginateChildRows");
    }
    onModelUpdated(modelUpdatedEvent) {
        this.calculatePages();
        const paginationChangedEvent = {
            type: Events.EVENT_PAGINATION_CHANGED,
            animate: modelUpdatedEvent ? modelUpdatedEvent.animate : false,
            newData: modelUpdatedEvent ? modelUpdatedEvent.newData : false,
            newPage: modelUpdatedEvent ? modelUpdatedEvent.newPage : false,
            newPageSize: modelUpdatedEvent ? modelUpdatedEvent.newPageSize : false,
            keepRenderedRows: modelUpdatedEvent ? modelUpdatedEvent.keepRenderedRows : false
        };
        this.eventService.dispatchEvent(paginationChangedEvent);
    }
    onPaginationGridOptionChanged() {
        this.active = this.gos.get("pagination");
        this.calculatePages();
        const paginationChangedEvent = {
            type: Events.EVENT_PAGINATION_CHANGED,
            animate: false,
            newData: false,
            newPage: false,
            newPageSize: false,
            // important to keep rendered rows, otherwise every time grid is resized,
            // we would destroy all the rows.
            keepRenderedRows: true
        };
        this.eventService.dispatchEvent(paginationChangedEvent);
    }
    onPageSizeGridOptionChanged() {
        this.setPageSize(this.gos.get("paginationPageSize"), "gridOptions");
    }
    goToPage(page) {
        if (!this.active || this.currentPage === page || typeof this.currentPage !== "number") return;
        this.currentPage = page;
        this.calculatePages();
        const paginationChangedEvent = {
            type: Events.EVENT_PAGINATION_CHANGED,
            animate: false,
            newData: false,
            newPage: true,
            newPageSize: false,
            keepRenderedRows: false
        };
        this.eventService.dispatchEvent(paginationChangedEvent);
    }
    getPixelOffset() {
        return this.pixelOffset;
    }
    getRow(index) {
        return this.rowModel.getRow(index);
    }
    getRowNode(id) {
        return this.rowModel.getRowNode(id);
    }
    getRowIndexAtPixel(pixel) {
        return this.rowModel.getRowIndexAtPixel(pixel);
    }
    getCurrentPageHeight() {
        if (missing(this.topRowBounds) || missing(this.bottomRowBounds)) return 0;
        return Math.max(this.bottomRowBounds.rowTop + this.bottomRowBounds.rowHeight - this.topRowBounds.rowTop, 0);
    }
    getCurrentPagePixelRange() {
        const pageFirstPixel = this.topRowBounds ? this.topRowBounds.rowTop : 0;
        const pageLastPixel = this.bottomRowBounds ? this.bottomRowBounds.rowTop + this.bottomRowBounds.rowHeight : 0;
        return {
            pageFirstPixel,
            pageLastPixel
        };
    }
    isRowPresent(rowNode) {
        if (!this.rowModel.isRowPresent(rowNode)) return false;
        const nodeIsInPage = rowNode.rowIndex >= this.topDisplayedRowIndex && rowNode.rowIndex <= this.bottomDisplayedRowIndex;
        return nodeIsInPage;
    }
    isEmpty() {
        return this.rowModel.isEmpty();
    }
    isRowsToRender() {
        return this.rowModel.isRowsToRender();
    }
    forEachNode(callback) {
        return this.rowModel.forEachNode(callback);
    }
    forEachNodeOnPage(callback) {
        const firstRow = this.getPageFirstRow();
        const lastRow = this.getPageLastRow();
        for(let i = firstRow; i <= lastRow; i++){
            const node = this.getRow(i);
            if (node) callback(node);
        }
    }
    getType() {
        return this.rowModel.getType();
    }
    getRowBounds(index) {
        const res = this.rowModel.getRowBounds(index);
        res.rowIndex = index;
        return res;
    }
    getPageFirstRow() {
        return this.topRowBounds ? this.topRowBounds.rowIndex : -1;
    }
    getPageLastRow() {
        return this.bottomRowBounds ? this.bottomRowBounds.rowIndex : -1;
    }
    getRowCount() {
        return this.rowModel.getRowCount();
    }
    getPageForIndex(index) {
        return Math.floor(index / this.pageSize);
    }
    goToPageWithIndex(index) {
        if (!this.active) return;
        const pageNumber = this.getPageForIndex(index);
        this.goToPage(pageNumber);
    }
    isRowInPage(row) {
        if (!this.active) return true;
        const rowPage = this.getPageForIndex(row.rowIndex);
        return rowPage === this.currentPage;
    }
    isLastPageFound() {
        return this.rowModel.isLastRowIndexKnown();
    }
    getCurrentPage() {
        return this.currentPage;
    }
    goToNextPage() {
        this.goToPage(this.currentPage + 1);
    }
    goToPreviousPage() {
        this.goToPage(this.currentPage - 1);
    }
    goToFirstPage() {
        this.goToPage(0);
    }
    goToLastPage() {
        const rowCount = this.rowModel.getRowCount();
        const lastPage = Math.floor(rowCount / this.pageSize);
        this.goToPage(lastPage);
    }
    getPageSize() {
        return this.pageSize;
    }
    getTotalPages() {
        return this.totalPages;
    }
    /** This is only for state setting before data has been loaded */ setPage(page) {
        this.currentPage = page;
    }
    get pageSize() {
        if (exists(this.pageSizeAutoCalculated)) return this.pageSizeAutoCalculated;
        if (exists(this.pageSizeFromPageSizeSelector)) return this.pageSizeFromPageSizeSelector;
        if (exists(this.pageSizeFromInitialState)) return this.pageSizeFromInitialState;
        if (exists(this.pageSizeFromGridOptions)) return this.pageSizeFromGridOptions;
        return this.defaultPageSize;
    }
    unsetAutoCalculatedPageSize() {
        if (this.pageSizeAutoCalculated === void 0) return;
        const oldPageSize = this.pageSizeAutoCalculated;
        this.pageSizeAutoCalculated = void 0;
        if (this.pageSize === oldPageSize) return;
        this.calculatePages();
        const paginationChangedEvent = {
            type: Events.EVENT_PAGINATION_CHANGED,
            animate: false,
            newData: false,
            newPage: false,
            newPageSize: true,
            keepRenderedRows: false
        };
        this.eventService.dispatchEvent(paginationChangedEvent);
    }
    setPageSize(size, source) {
        const currentSize = this.pageSize;
        switch(source){
            case "autoCalculated":
                this.pageSizeAutoCalculated = size;
                break;
            case "pageSizeSelector":
                this.pageSizeFromPageSizeSelector = size;
                if (this.currentPage !== 0) this.goToFirstPage();
                break;
            case "initialState":
                this.pageSizeFromInitialState = size;
                break;
            case "gridOptions":
                this.pageSizeFromGridOptions = size;
                this.pageSizeFromInitialState = void 0;
                this.pageSizeFromPageSizeSelector = void 0;
                if (this.currentPage !== 0) this.goToFirstPage();
                break;
        }
        if (currentSize !== this.pageSize) {
            this.calculatePages();
            const paginationChangedEvent = {
                type: Events.EVENT_PAGINATION_CHANGED,
                animate: false,
                newData: false,
                newPage: false,
                newPageSize: true,
                keepRenderedRows: true
            };
            this.eventService.dispatchEvent(paginationChangedEvent);
        }
    }
    calculatePages() {
        if (this.active) {
            if (this.paginateChildRows) this.calculatePagesAllRows();
            else this.calculatePagesMasterRowsOnly();
        } else this.calculatedPagesNotActive();
        this.topRowBounds = this.rowModel.getRowBounds(this.topDisplayedRowIndex);
        if (this.topRowBounds) this.topRowBounds.rowIndex = this.topDisplayedRowIndex;
        this.bottomRowBounds = this.rowModel.getRowBounds(this.bottomDisplayedRowIndex);
        if (this.bottomRowBounds) this.bottomRowBounds.rowIndex = this.bottomDisplayedRowIndex;
        this.setPixelOffset(exists(this.topRowBounds) ? this.topRowBounds.rowTop : 0);
    }
    setPixelOffset(value) {
        if (this.pixelOffset === value) return;
        this.pixelOffset = value;
        this.eventService.dispatchEvent({
            type: Events.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED
        });
    }
    setZeroRows() {
        this.masterRowCount = 0;
        this.topDisplayedRowIndex = 0;
        this.bottomDisplayedRowIndex = -1;
        this.currentPage = 0;
        this.totalPages = 0;
    }
    adjustCurrentPageIfInvalid() {
        if (this.currentPage >= this.totalPages) this.currentPage = this.totalPages - 1;
        if (!isFinite(this.currentPage) || isNaN(this.currentPage) || this.currentPage < 0) this.currentPage = 0;
    }
    calculatePagesMasterRowsOnly() {
        this.masterRowCount = this.rowModel.getTopLevelRowCount();
        if (this.masterRowCount <= 0) {
            this.setZeroRows();
            return;
        }
        const masterLastRowIndex = this.masterRowCount - 1;
        this.totalPages = Math.floor(masterLastRowIndex / this.pageSize) + 1;
        this.adjustCurrentPageIfInvalid();
        const masterPageStartIndex = this.pageSize * this.currentPage;
        let masterPageEndIndex = this.pageSize * (this.currentPage + 1) - 1;
        if (masterPageEndIndex > masterLastRowIndex) masterPageEndIndex = masterLastRowIndex;
        this.topDisplayedRowIndex = this.rowModel.getTopLevelRowDisplayedIndex(masterPageStartIndex);
        if (masterPageEndIndex === masterLastRowIndex) this.bottomDisplayedRowIndex = this.rowModel.getRowCount() - 1;
        else {
            const firstIndexNotToShow = this.rowModel.getTopLevelRowDisplayedIndex(masterPageEndIndex + 1);
            this.bottomDisplayedRowIndex = firstIndexNotToShow - 1;
        }
    }
    getMasterRowCount() {
        return this.masterRowCount;
    }
    calculatePagesAllRows() {
        this.masterRowCount = this.rowModel.getRowCount();
        if (this.masterRowCount === 0) {
            this.setZeroRows();
            return;
        }
        const maxRowIndex = this.masterRowCount - 1;
        this.totalPages = Math.floor(maxRowIndex / this.pageSize) + 1;
        this.adjustCurrentPageIfInvalid();
        this.topDisplayedRowIndex = this.pageSize * this.currentPage;
        this.bottomDisplayedRowIndex = this.pageSize * (this.currentPage + 1) - 1;
        if (this.bottomDisplayedRowIndex > maxRowIndex) this.bottomDisplayedRowIndex = maxRowIndex;
    }
    calculatedPagesNotActive() {
        this.setPageSize(void 0, "autoCalculated");
        this.totalPages = 1;
        this.currentPage = 0;
        this.topDisplayedRowIndex = 0;
        this.bottomDisplayedRowIndex = this.rowModel.getRowCount() - 1;
    }
};
__decorateClass([
    Autowired("rowModel")
], PaginationProxy.prototype, "rowModel", 2);
__decorateClass([
    PostConstruct
], PaginationProxy.prototype, "postConstruct", 1);
PaginationProxy = __decorateClass([
    Bean("paginationProxy")
], PaginationProxy);
// community-modules/core/src/styling/stylingService.ts
var StylingService = class extends BeanStub {
    processAllCellClasses(colDef, params, onApplicableClass, onNotApplicableClass) {
        this.processClassRules(void 0, colDef.cellClassRules, params, onApplicableClass, onNotApplicableClass);
        this.processStaticCellClasses(colDef, params, onApplicableClass);
    }
    processClassRules(previousClassRules, classRules, params, onApplicableClass, onNotApplicableClass) {
        if (classRules == null && previousClassRules == null) return;
        const classesToApply = {};
        const classesToRemove = {};
        const forEachSingleClass = (className, callback)=>{
            className.split(" ").forEach((singleClass)=>{
                if (singleClass.trim() == "") return;
                callback(singleClass);
            });
        };
        if (classRules) {
            const classNames = Object.keys(classRules);
            for(let i = 0; i < classNames.length; i++){
                const className = classNames[i];
                const rule = classRules[className];
                let resultOfRule;
                if (typeof rule === "string") resultOfRule = this.expressionService.evaluate(rule, params);
                else if (typeof rule === "function") resultOfRule = rule(params);
                forEachSingleClass(className, (singleClass)=>{
                    resultOfRule ? classesToApply[singleClass] = true : classesToRemove[singleClass] = true;
                });
            }
        }
        if (previousClassRules && onNotApplicableClass) Object.keys(previousClassRules).forEach((className)=>forEachSingleClass(className, (singleClass)=>{
                if (!classesToApply[singleClass]) classesToRemove[singleClass] = true;
            }));
        if (onNotApplicableClass) Object.keys(classesToRemove).forEach(onNotApplicableClass);
        Object.keys(classesToApply).forEach(onApplicableClass);
    }
    getStaticCellClasses(colDef, params) {
        const { cellClass } = colDef;
        if (!cellClass) return [];
        let classOrClasses;
        if (typeof cellClass === "function") {
            const cellClassFunc = cellClass;
            classOrClasses = cellClassFunc(params);
        } else classOrClasses = cellClass;
        if (typeof classOrClasses === "string") classOrClasses = [
            classOrClasses
        ];
        return classOrClasses || [];
    }
    processStaticCellClasses(colDef, params, onApplicableClass) {
        const classOrClasses = this.getStaticCellClasses(colDef, params);
        classOrClasses.forEach((cssClassItem)=>{
            onApplicableClass(cssClassItem);
        });
    }
};
__decorateClass([
    Autowired("expressionService")
], StylingService.prototype, "expressionService", 2);
StylingService = __decorateClass([
    Bean("stylingService")
], StylingService);
// community-modules/core/src/widgets/agToggleButton.ts
var AgToggleButton = class extends AgCheckbox {
    constructor(config){
        super(config, "ag-toggle-button");
    }
    setValue(value, silent) {
        super.setValue(value, silent);
        this.addOrRemoveCssClass("ag-selected", this.getValue());
        return this;
    }
};
// community-modules/core/src/widgets/agInputTextArea.ts
var AgInputTextArea = class extends AgAbstractInputField {
    constructor(config){
        super(config, "ag-text-area", null, "textarea");
    }
    setValue(value, silent) {
        const ret = super.setValue(value, silent);
        this.eInput.value = value;
        return ret;
    }
    setCols(cols) {
        this.eInput.cols = cols;
        return this;
    }
    setRows(rows) {
        this.eInput.rows = rows;
        return this;
    }
};
// community-modules/core/src/widgets/agInputDateField.ts
var AgInputDateField = class extends AgInputTextField {
    constructor(config){
        super(config, "ag-date-field", "date");
    }
    postConstruct() {
        super.postConstruct();
        this.addManagedListener(this.eInput, "wheel", this.onWheel.bind(this));
        const usingSafari = isBrowserSafari();
        this.addManagedListener(this.eInput, "mousedown", ()=>{
            if (this.isDisabled() || usingSafari) return;
            this.eInput.focus();
        });
        this.eInput.step = "any";
    }
    onWheel(e) {
        if (this.gos.getActiveDomElement() === this.eInput) e.preventDefault();
    }
    setMin(minDate) {
        var _a;
        const min = minDate instanceof Date ? (_a = serialiseDate(minDate != null ? minDate : null, false)) != null ? _a : void 0 : minDate;
        if (this.min === min) return this;
        this.min = min;
        addOrRemoveAttribute(this.eInput, "min", min);
        return this;
    }
    setMax(maxDate) {
        var _a;
        const max = maxDate instanceof Date ? (_a = serialiseDate(maxDate != null ? maxDate : null, false)) != null ? _a : void 0 : maxDate;
        if (this.max === max) return this;
        this.max = max;
        addOrRemoveAttribute(this.eInput, "max", max);
        return this;
    }
    setStep(step) {
        if (this.step === step) return this;
        this.step = step;
        addOrRemoveAttribute(this.eInput, "step", step);
        return this;
    }
    getDate() {
        var _a;
        if (!this.eInput.validity.valid) return void 0;
        return (_a = parseDateTimeFromString(this.getValue())) != null ? _a : void 0;
    }
    setDate(date, silent) {
        this.setValue(serialiseDate(date != null ? date : null, false), silent);
    }
};
// community-modules/core/src/widgets/agInputRange.ts
var AgInputRange = class extends AgAbstractInputField {
    constructor(config){
        super(config, "ag-range-field", "range");
    }
    postConstruct() {
        super.postConstruct();
        const { min, max, step } = this.config;
        if (min != null) this.setMinValue(min);
        if (max != null) this.setMaxValue(max);
        this.setStep(step || 1);
    }
    addInputListeners() {
        this.addManagedListener(this.eInput, "input", (e)=>{
            const value = e.target.value;
            this.setValue(value);
        });
    }
    setMinValue(value) {
        this.min = value;
        this.eInput.setAttribute("min", value.toString());
        return this;
    }
    setMaxValue(value) {
        this.max = value;
        this.eInput.setAttribute("max", value.toString());
        return this;
    }
    setStep(value) {
        this.eInput.setAttribute("step", value.toString());
        return this;
    }
    setValue(value, silent) {
        if (this.min != null) value = Math.max(parseFloat(value), this.min).toString();
        if (this.max != null) value = Math.min(parseFloat(value), this.max).toString();
        const ret = super.setValue(value, silent);
        this.eInput.value = value;
        return ret;
    }
};
// community-modules/core/src/widgets/agRichSelectRow.ts
var RichSelectRow = class extends Component {
    constructor(params, wrapperEl){
        super(/* html */ `<div class="ag-rich-select-row" role="presentation"></div>`);
        this.params = params;
        this.wrapperEl = wrapperEl;
    }
    postConstruct() {
        this.addManagedListener(this.getGui(), "click", this.onClick.bind(this));
    }
    setState(value) {
        let formattedValue = "";
        if (this.params.valueFormatter) formattedValue = this.params.valueFormatter(value);
        const rendererSuccessful = this.populateWithRenderer(value, formattedValue);
        if (!rendererSuccessful) this.populateWithoutRenderer(value, formattedValue);
        this.value = value;
    }
    highlightString(matchString) {
        const { parsedValue } = this;
        if (this.params.cellRenderer || !exists(parsedValue)) return;
        let hasMatch = exists(matchString);
        if (hasMatch) {
            const index = parsedValue == null ? void 0 : parsedValue.toLocaleLowerCase().indexOf(matchString.toLocaleLowerCase());
            if (index >= 0) {
                const highlightEndIndex = index + matchString.length;
                const startPart = escapeString(parsedValue.slice(0, index), true);
                const highlightedPart = escapeString(parsedValue.slice(index, highlightEndIndex), true);
                const endPart = escapeString(parsedValue.slice(highlightEndIndex));
                this.renderValueWithoutRenderer(`${startPart}<span class="ag-rich-select-row-text-highlight">${highlightedPart}</span>${endPart}`);
            } else hasMatch = false;
        }
        if (!hasMatch) this.renderValueWithoutRenderer(parsedValue);
    }
    updateHighlighted(highlighted) {
        var _a;
        const eGui = this.getGui();
        const parentId = `ag-rich-select-row-${this.getCompId()}`;
        (_a = eGui.parentElement) == null || _a.setAttribute("id", parentId);
        if (highlighted) {
            const parentAriaEl = this.getParentComponent().getAriaElement();
            setAriaActiveDescendant(parentAriaEl, parentId);
            this.wrapperEl.setAttribute("data-active-option", parentId);
        }
        setAriaSelected(eGui.parentElement, highlighted);
        this.addOrRemoveCssClass("ag-rich-select-row-selected", highlighted);
    }
    populateWithoutRenderer(value, valueFormatted) {
        const eDocument = this.gos.getDocument();
        const eGui = this.getGui();
        const span = eDocument.createElement("span");
        span.style.overflow = "hidden";
        span.style.textOverflow = "ellipsis";
        const parsedValue = escapeString(exists(valueFormatted) ? valueFormatted : value, true);
        this.parsedValue = exists(parsedValue) ? parsedValue : null;
        eGui.appendChild(span);
        this.renderValueWithoutRenderer(parsedValue);
        this.setTooltip({
            newTooltipText: this.parsedValue,
            shouldDisplayTooltip: ()=>span.scrollWidth > span.clientWidth
        });
    }
    renderValueWithoutRenderer(value) {
        const span = this.getGui().querySelector("span");
        if (!span) return;
        span.innerHTML = exists(value) ? value : "&nbsp;";
    }
    populateWithRenderer(value, valueFormatted) {
        let cellRendererPromise;
        let userCompDetails;
        if (this.params.cellRenderer) userCompDetails = this.userComponentFactory.getCellRendererDetails(this.params, {
            value,
            valueFormatted,
            setTooltip: (value2, shouldDisplayTooltip)=>{
                this.setTooltip({
                    newTooltipText: value2,
                    shouldDisplayTooltip
                });
            }
        });
        if (userCompDetails) cellRendererPromise = userCompDetails.newAgStackInstance();
        if (cellRendererPromise) bindCellRendererToHtmlElement(cellRendererPromise, this.getGui());
        if (cellRendererPromise) {
            cellRendererPromise.then((childComponent)=>{
                this.addDestroyFunc(()=>{
                    this.getContext().destroyBean(childComponent);
                });
            });
            return true;
        }
        return false;
    }
    onClick() {
        const parent = this.getParentComponent();
        const event = {
            type: Events.EVENT_FIELD_PICKER_VALUE_SELECTED,
            fromEnterKey: false,
            value: this.value
        };
        parent == null || parent.dispatchEvent(event);
    }
};
__decorateClass([
    Autowired("userComponentFactory")
], RichSelectRow.prototype, "userComponentFactory", 2);
__decorateClass([
    PostConstruct
], RichSelectRow.prototype, "postConstruct", 1);
// community-modules/core/src/widgets/virtualList.ts
var _VirtualList = class _VirtualList extends TabGuardComp {
    constructor(params){
        super(_VirtualList.getTemplate((params == null ? void 0 : params.cssIdentifier) || "default"));
        this.renderedRows = /* @__PURE__ */ new Map();
        this.rowHeight = 20;
        this.pageSize = -1;
        this.isScrolling = false;
        this.isHeightFromTheme = true;
        const { cssIdentifier = "default", ariaRole = "listbox", listName } = params || {};
        this.cssIdentifier = cssIdentifier;
        this.ariaRole = ariaRole;
        this.listName = listName;
    }
    postConstruct() {
        this.addScrollListener();
        this.rowHeight = this.getItemHeight();
        this.addResizeObserver();
        this.initialiseTabGuard({
            onFocusIn: (e)=>this.onFocusIn(e),
            onFocusOut: (e)=>this.onFocusOut(e),
            focusInnerElement: (fromBottom)=>this.focusInnerElement(fromBottom),
            onTabKeyDown: (e)=>this.onTabKeyDown(e),
            handleKeyDown: (e)=>this.handleKeyDown(e)
        });
        this.setAriaProperties();
        this.addManagedListener(this.eventService, Events.EVENT_GRID_STYLES_CHANGED, this.onGridStylesChanged.bind(this));
    }
    onGridStylesChanged() {
        this.rowHeight = this.getItemHeight();
        this.refresh();
    }
    setAriaProperties() {
        const translate = this.localeService.getLocaleTextFunc();
        const listName = translate("ariaDefaultListName", this.listName || "List");
        const ariaEl = this.eContainer;
        setAriaRole(ariaEl, this.ariaRole);
        setAriaLabel(ariaEl, listName);
    }
    addResizeObserver() {
        const listener = ()=>this.animationFrameService.requestAnimationFrame(()=>this.drawVirtualRows());
        const destroyObserver = this.resizeObserverService.observeResize(this.getGui(), listener);
        this.addDestroyFunc(destroyObserver);
    }
    focusInnerElement(fromBottom) {
        this.focusRow(fromBottom ? this.model.getRowCount() - 1 : 0);
    }
    onFocusIn(e) {
        const target = e.target;
        if (target.classList.contains("ag-virtual-list-item")) this.lastFocusedRowIndex = getAriaPosInSet(target) - 1;
    }
    onFocusOut(e) {
        if (!this.getFocusableElement().contains(e.relatedTarget)) this.lastFocusedRowIndex = null;
    }
    handleKeyDown(e) {
        switch(e.key){
            case KeyCode.UP:
            case KeyCode.DOWN:
                if (this.navigate(e.key === KeyCode.UP)) e.preventDefault();
                break;
            case KeyCode.PAGE_HOME:
            case KeyCode.PAGE_END:
            case KeyCode.PAGE_UP:
            case KeyCode.PAGE_DOWN:
                if (this.navigateToPage(e.key) !== null) e.preventDefault();
                break;
        }
    }
    onTabKeyDown(e) {
        if (this.navigate(e.shiftKey)) e.preventDefault();
        else {
            stopPropagationForAgGrid(e);
            this.forceFocusOutOfContainer(e.shiftKey);
        }
    }
    navigate(up) {
        if (this.lastFocusedRowIndex == null) return false;
        const nextRow = this.lastFocusedRowIndex + (up ? -1 : 1);
        if (nextRow < 0 || nextRow >= this.model.getRowCount()) return false;
        this.focusRow(nextRow);
        return true;
    }
    navigateToPage(key, fromItem = "focused") {
        let hasFocus = false;
        if (fromItem === "focused") {
            fromItem = this.getLastFocusedRow();
            hasFocus = true;
        }
        const rowCount = this.model.getRowCount() - 1;
        let newIndex = -1;
        if (key === KeyCode.PAGE_HOME) newIndex = 0;
        else if (key === KeyCode.PAGE_END) newIndex = rowCount;
        else if (key === KeyCode.PAGE_DOWN) newIndex = Math.min(fromItem + this.pageSize, rowCount);
        else if (key === KeyCode.PAGE_UP) newIndex = Math.max(fromItem - this.pageSize, 0);
        if (newIndex === -1) return null;
        if (hasFocus) this.focusRow(newIndex);
        else this.ensureIndexVisible(newIndex);
        return newIndex;
    }
    getLastFocusedRow() {
        return this.lastFocusedRowIndex;
    }
    focusRow(rowNumber) {
        if (this.isScrolling) return;
        this.isScrolling = true;
        this.ensureIndexVisible(rowNumber);
        this.animationFrameService.requestAnimationFrame(()=>{
            this.isScrolling = false;
            if (!this.isAlive()) return;
            const renderedRow = this.renderedRows.get(rowNumber);
            if (renderedRow) renderedRow.eDiv.focus();
        });
    }
    getComponentAt(rowIndex) {
        const comp = this.renderedRows.get(rowIndex);
        return comp && comp.rowComponent;
    }
    forEachRenderedRow(func) {
        this.renderedRows.forEach((value, key)=>func(value.rowComponent, key));
    }
    static getTemplate(cssIdentifier) {
        return /* html */ `<div class="ag-virtual-list-viewport ag-${cssIdentifier}-virtual-list-viewport" role="presentation">
                <div class="ag-virtual-list-container ag-${cssIdentifier}-virtual-list-container" ref="eContainer"></div>
            </div>`;
    }
    getItemHeight() {
        if (!this.isHeightFromTheme) return this.rowHeight;
        return this.environment.getListItemHeight();
    }
    /**
   * Returns true if the view had to be scrolled, otherwise, false.
   */ ensureIndexVisible(index, scrollPartialIntoView = true) {
        const lastRow = this.model.getRowCount();
        if (typeof index !== "number" || index < 0 || index >= lastRow) {
            console.warn("AG Grid: invalid row index for ensureIndexVisible: " + index);
            return false;
        }
        const rowTopPixel = index * this.rowHeight;
        const rowBottomPixel = rowTopPixel + this.rowHeight;
        const eGui = this.getGui();
        const viewportTopPixel = eGui.scrollTop;
        const viewportHeight = eGui.offsetHeight;
        const viewportBottomPixel = viewportTopPixel + viewportHeight;
        const diff = scrollPartialIntoView ? 0 : this.rowHeight;
        const viewportScrolledPastRow = viewportTopPixel > rowTopPixel + diff;
        const viewportScrolledBeforeRow = viewportBottomPixel < rowBottomPixel - diff;
        if (viewportScrolledPastRow) {
            eGui.scrollTop = rowTopPixel;
            return true;
        }
        if (viewportScrolledBeforeRow) {
            const newScrollPosition = rowBottomPixel - viewportHeight;
            eGui.scrollTop = newScrollPosition;
            return true;
        }
        return false;
    }
    setComponentCreator(componentCreator) {
        this.componentCreator = componentCreator;
    }
    setComponentUpdater(componentUpdater) {
        this.componentUpdater = componentUpdater;
    }
    getRowHeight() {
        return this.rowHeight;
    }
    getScrollTop() {
        return this.getGui().scrollTop;
    }
    setRowHeight(rowHeight) {
        this.isHeightFromTheme = false;
        this.rowHeight = rowHeight;
        this.refresh();
    }
    refresh(softRefresh) {
        if (this.model == null || !this.isAlive()) return;
        const rowCount = this.model.getRowCount();
        this.eContainer.style.height = `${rowCount * this.rowHeight}px`;
        waitUntil(()=>this.eContainer.clientHeight >= rowCount * this.rowHeight, ()=>{
            if (!this.isAlive()) return;
            if (this.canSoftRefresh(softRefresh)) this.drawVirtualRows(true);
            else {
                this.clearVirtualRows();
                this.drawVirtualRows();
            }
        });
    }
    canSoftRefresh(softRefresh) {
        return !!(softRefresh && this.renderedRows.size && typeof this.model.areRowsEqual === "function" && this.componentUpdater);
    }
    clearVirtualRows() {
        this.renderedRows.forEach((_2, rowIndex)=>this.removeRow(rowIndex));
    }
    drawVirtualRows(softRefresh) {
        if (!this.isAlive() || !this.model) return;
        const gui = this.getGui();
        const topPixel = gui.scrollTop;
        const bottomPixel = topPixel + gui.offsetHeight;
        const firstRow = Math.floor(topPixel / this.rowHeight);
        const lastRow = Math.floor(bottomPixel / this.rowHeight);
        this.pageSize = Math.floor((bottomPixel - topPixel) / this.rowHeight);
        this.ensureRowsRendered(firstRow, lastRow, softRefresh);
    }
    ensureRowsRendered(start, finish, softRefresh) {
        this.renderedRows.forEach((_2, rowIndex)=>{
            if ((rowIndex < start || rowIndex > finish) && rowIndex !== this.lastFocusedRowIndex) this.removeRow(rowIndex);
        });
        if (softRefresh) this.refreshRows();
        for(let rowIndex = start; rowIndex <= finish; rowIndex++){
            if (this.renderedRows.has(rowIndex)) continue;
            if (rowIndex < this.model.getRowCount()) this.insertRow(rowIndex);
        }
    }
    insertRow(rowIndex) {
        const value = this.model.getRow(rowIndex);
        const eDiv = document.createElement("div");
        eDiv.classList.add("ag-virtual-list-item", `ag-${this.cssIdentifier}-virtual-list-item`);
        setAriaRole(eDiv, this.ariaRole === "tree" ? "treeitem" : "option");
        setAriaSetSize(eDiv, this.model.getRowCount());
        setAriaPosInSet(eDiv, rowIndex + 1);
        eDiv.setAttribute("tabindex", "-1");
        eDiv.style.height = `${this.rowHeight}px`;
        eDiv.style.top = `${this.rowHeight * rowIndex}px`;
        const rowComponent = this.componentCreator(value, eDiv);
        rowComponent.addGuiEventListener("focusin", ()=>this.lastFocusedRowIndex = rowIndex);
        eDiv.appendChild(rowComponent.getGui());
        if (this.renderedRows.has(rowIndex - 1)) this.renderedRows.get(rowIndex - 1).eDiv.insertAdjacentElement("afterend", eDiv);
        else if (this.renderedRows.has(rowIndex + 1)) this.renderedRows.get(rowIndex + 1).eDiv.insertAdjacentElement("beforebegin", eDiv);
        else this.eContainer.appendChild(eDiv);
        this.renderedRows.set(rowIndex, {
            rowComponent,
            eDiv,
            value
        });
    }
    removeRow(rowIndex) {
        const component = this.renderedRows.get(rowIndex);
        this.eContainer.removeChild(component.eDiv);
        this.destroyBean(component.rowComponent);
        this.renderedRows.delete(rowIndex);
    }
    refreshRows() {
        const rowCount = this.model.getRowCount();
        this.renderedRows.forEach((row, rowIndex)=>{
            var _a, _b;
            if (rowIndex >= rowCount) this.removeRow(rowIndex);
            else {
                const newValue = this.model.getRow(rowIndex);
                if ((_b = (_a = this.model).areRowsEqual) == null ? void 0 : _b.call(_a, row.value, newValue)) this.componentUpdater(newValue, row.rowComponent);
                else this.removeRow(rowIndex);
            }
        });
    }
    addScrollListener() {
        this.addGuiEventListener("scroll", ()=>this.drawVirtualRows(), {
            passive: true
        });
    }
    setModel(model) {
        this.model = model;
    }
    getAriaElement() {
        return this.eContainer;
    }
    destroy() {
        if (!this.isAlive()) return;
        this.clearVirtualRows();
        super.destroy();
    }
};
__decorateClass([
    Autowired("resizeObserverService")
], _VirtualList.prototype, "resizeObserverService", 2);
__decorateClass([
    Autowired("animationFrameService")
], _VirtualList.prototype, "animationFrameService", 2);
__decorateClass([
    RefSelector("eContainer")
], _VirtualList.prototype, "eContainer", 2);
__decorateClass([
    PostConstruct
], _VirtualList.prototype, "postConstruct", 1);
var VirtualList = _VirtualList;
// community-modules/core/src/widgets/agRichSelect.ts
var TEMPLATE2 = /* html */ `
    <div class="ag-picker-field" role="presentation">
        <div ref="eLabel"></div>
            <div ref="eWrapper" class="ag-wrapper ag-picker-field-wrapper ag-rich-select-value ag-picker-collapsed">
            <div ref="eDisplayField" class="ag-picker-field-display"></div>
            <ag-input-text-field ref="eInput" class="ag-rich-select-field-input"></ag-input-text-field>
            <div ref="eIcon" class="ag-picker-field-icon" aria-hidden="true"></div>
        </div>
    </div>`;
var AgRichSelect = class extends AgPickerField {
    constructor(config){
        var _a, _b;
        super(__spreadProps(__spreadValues({
            pickerAriaLabelKey: "ariaLabelRichSelectField",
            pickerAriaLabelValue: "Rich Select Field",
            pickerType: "ag-list",
            className: "ag-rich-select",
            pickerIcon: "smallDown",
            ariaRole: "combobox",
            template: (_a = config == null ? void 0 : config.template) != null ? _a : TEMPLATE2,
            modalPicker: false
        }, config), {
            // maxPickerHeight needs to be set after expanding `config`
            maxPickerHeight: (_b = config == null ? void 0 : config.maxPickerHeight) != null ? _b : "calc(var(--ag-row-height) * 6.5)"
        }));
        this.searchString = "";
        this.highlightedItem = -1;
        this.lastRowHovered = -1;
        this.searchStringCreator = null;
        const { cellRowHeight, value, valueList, searchStringCreator } = config || {};
        if (cellRowHeight != null) this.cellRowHeight = cellRowHeight;
        if (value !== void 0) this.value = value;
        if (valueList != null) this.values = valueList;
        if (searchStringCreator) this.searchStringCreator = searchStringCreator;
    }
    postConstruct() {
        super.postConstruct();
        this.createLoadingElement();
        this.createListComponent();
        const { allowTyping, placeholder } = this.config;
        if (allowTyping) {
            this.eInput.setAutoComplete(false).setInputPlaceholder(placeholder);
            this.eDisplayField.classList.add("ag-hidden");
        } else this.eInput.setDisplayed(false);
        this.eWrapper.tabIndex = this.gos.get("tabIndex");
        const { searchDebounceDelay = 300 } = this.config;
        this.clearSearchString = debounce(this.clearSearchString, searchDebounceDelay);
        this.renderSelectedValue();
        if (allowTyping) {
            this.eInput.onValueChange((value)=>this.searchTextFromString(value));
            this.addManagedListener(this.eWrapper, "focus", this.onWrapperFocus.bind(this));
        }
        this.addManagedListener(this.eWrapper, "focusout", this.onWrapperFocusOut.bind(this));
    }
    createLoadingElement() {
        const eDocument = this.gos.getDocument();
        const translate = this.localeService.getLocaleTextFunc();
        const el = eDocument.createElement("div");
        el.classList.add("ag-loading-text");
        el.innerText = translate("loadingOoo", "Loading...");
        this.eLoading = el;
    }
    createListComponent() {
        this.listComponent = this.createBean(new VirtualList({
            cssIdentifier: "rich-select"
        }));
        this.listComponent.setComponentCreator(this.createRowComponent.bind(this));
        const componentUpdater = (item, component)=>{};
        this.listComponent.setComponentUpdater(componentUpdater);
        this.listComponent.setParentComponent(this);
        this.addManagedListener(this.listComponent, Events.EVENT_FIELD_PICKER_VALUE_SELECTED, (e)=>{
            this.onListValueSelected(e.value, e.fromEnterKey);
        });
        const { cellRowHeight } = this;
        if (cellRowHeight) this.listComponent.setRowHeight(cellRowHeight);
        const eListGui = this.listComponent.getGui();
        const eListAriaEl = this.listComponent.getAriaElement();
        this.addManagedListener(eListGui, "mousemove", this.onPickerMouseMove.bind(this));
        this.addManagedListener(eListGui, "mousedown", (e)=>e.preventDefault());
        eListGui.classList.add("ag-rich-select-list");
        const listId = `ag-rich-select-list-${this.listComponent.getCompId()}`;
        eListAriaEl.setAttribute("id", listId);
        const translate = this.localeService.getLocaleTextFunc();
        const ariaLabel = translate(this.config.pickerAriaLabelKey, this.config.pickerAriaLabelValue);
        setAriaLabel(eListAriaEl, ariaLabel);
        setAriaControls(this.eWrapper, eListAriaEl);
    }
    renderSelectedValue() {
        const { value, eDisplayField, config } = this;
        const { allowTyping, initialInputValue } = this.config;
        const valueFormatted = this.config.valueFormatter ? this.config.valueFormatter(value) : value;
        if (allowTyping) {
            this.eInput.setValue(initialInputValue != null ? initialInputValue : valueFormatted);
            return;
        }
        let userCompDetails;
        if (config.cellRenderer) userCompDetails = this.userComponentFactory.getCellRendererDetails(this.config, {
            value,
            valueFormatted
        });
        let userCompDetailsPromise;
        if (userCompDetails) userCompDetailsPromise = userCompDetails.newAgStackInstance();
        if (userCompDetailsPromise) {
            clearElement(eDisplayField);
            bindCellRendererToHtmlElement(userCompDetailsPromise, eDisplayField);
            userCompDetailsPromise.then((renderer)=>{
                this.addDestroyFunc(()=>this.getContext().destroyBean(renderer));
            });
        } else {
            if (exists(this.value)) {
                eDisplayField.innerText = valueFormatted;
                eDisplayField.classList.remove("ag-display-as-placeholder");
            } else {
                const { placeholder } = config;
                if (exists(placeholder)) {
                    eDisplayField.innerHTML = `${escapeString(placeholder)}`;
                    eDisplayField.classList.add("ag-display-as-placeholder");
                } else clearElement(eDisplayField);
            }
            this.setTooltip({
                newTooltipText: valueFormatted != null ? valueFormatted : null,
                shouldDisplayTooltip: ()=>this.eDisplayField.scrollWidth > this.eDisplayField.clientWidth
            });
        }
    }
    getCurrentValueIndex() {
        const { currentList, value } = this;
        if (value == null || !currentList) return -1;
        for(let i = 0; i < currentList.length; i++){
            if (currentList[i] === value) return i;
        }
        return -1;
    }
    highlightFilterMatch() {
        var _a;
        (_a = this.listComponent) == null || _a.forEachRenderedRow((cmp, idx)=>{
            cmp.highlightString(this.searchString);
        });
    }
    highlightSelectedValue(index) {
        var _a;
        if (index == null) index = this.getCurrentValueIndex();
        this.highlightedItem = index;
        (_a = this.listComponent) == null || _a.forEachRenderedRow((cmp, idx)=>{
            const highlighted = index === -1 ? false : this.highlightedItem === idx;
            cmp.updateHighlighted(highlighted);
        });
    }
    setRowHeight(height) {
        if (height !== this.cellRowHeight) this.cellRowHeight = height;
        if (this.listComponent) this.listComponent.setRowHeight(height);
    }
    createPickerComponent() {
        const { values: values2 } = this;
        if (values2) this.setValueList({
            valueList: values2
        });
        return this.listComponent;
    }
    setSearchStringCreator(searchStringFn) {
        this.searchStringCreator = searchStringFn;
    }
    setValueList(params) {
        const { valueList, refresh } = params;
        if (!this.listComponent) return;
        if (this.currentList === valueList) return;
        this.currentList = valueList;
        this.listComponent.setModel({
            getRowCount: ()=>valueList.length,
            getRow: (index)=>valueList[index],
            areRowsEqual: (oldRow, newRow)=>oldRow === newRow
        });
        if (refresh) {
            if (!this.values) {
                this.values = valueList;
                if (this.isPickerDisplayed) this.showCurrentValueInPicker();
            } else this.listComponent.refresh(true);
        }
    }
    showPicker() {
        super.showPicker();
        this.showCurrentValueInPicker();
        this.displayOrHidePicker();
    }
    showCurrentValueInPicker() {
        var _a, _b;
        if (!this.listComponent) return;
        if (!this.currentList) {
            if (this.isPickerDisplayed && this.eLoading) this.listComponent.appendChild(this.eLoading);
            return;
        }
        if ((_a = this.eLoading) == null ? void 0 : _a.offsetParent) (_b = this.eLoading.parentElement) == null || _b.removeChild(this.eLoading);
        const currentValueIndex = this.getCurrentValueIndex();
        if (currentValueIndex !== -1) {
            this.listComponent.refresh();
            this.listComponent.ensureIndexVisible(currentValueIndex);
            this.listComponent.refresh(true);
            this.highlightSelectedValue(currentValueIndex);
        } else this.listComponent.refresh();
    }
    beforeHidePicker() {
        this.highlightedItem = -1;
        super.beforeHidePicker();
    }
    onWrapperFocus() {
        if (!this.eInput) return;
        const focusableEl = this.eInput.getFocusableElement();
        focusableEl.focus();
        focusableEl.select();
    }
    onWrapperFocusOut(e) {
        if (!this.eWrapper.contains(e.relatedTarget)) this.hidePicker();
    }
    buildSearchStringFromKeyboardEvent(searchKey) {
        let { key } = searchKey;
        if (key === KeyCode.BACKSPACE) {
            this.searchString = this.searchString.slice(0, -1);
            key = "";
        } else if (!isEventFromPrintableCharacter(searchKey)) return;
        searchKey.preventDefault();
        this.searchTextFromCharacter(key);
    }
    searchTextFromCharacter(char) {
        this.searchString += char;
        this.runSearch();
        this.clearSearchString();
    }
    searchTextFromString(str) {
        if (str == null) str = "";
        this.searchString = str;
        this.runSearch();
    }
    buildSearchStrings(values2) {
        const { valueFormatter = (value)=>value } = this.config;
        let searchStrings;
        if (typeof values2[0] === "number" || typeof values2[0] === "string") searchStrings = values2.map((v)=>valueFormatter(v));
        else if (typeof values2[0] === "object" && this.searchStringCreator) searchStrings = this.searchStringCreator(values2);
        return searchStrings;
    }
    getSuggestionsAndFilteredValues(searchValue, valueList) {
        let suggestions = [];
        let filteredValues = [];
        if (!searchValue.length) return {
            suggestions,
            filteredValues
        };
        const { searchType = "fuzzy", filterList } = this.config;
        if (searchType === "fuzzy") {
            const fuzzySearchResult = fuzzySuggestions(this.searchString, valueList, true);
            suggestions = fuzzySearchResult.values;
            const indices = fuzzySearchResult.indices;
            if (filterList && indices.length) for(let i = 0; i < indices.length; i++)filteredValues.push(this.values[indices[i]]);
        } else suggestions = valueList.filter((val, idx)=>{
            const currentValue = val.toLocaleLowerCase();
            const valueToMatch = this.searchString.toLocaleLowerCase();
            const isMatch = searchType === "match" ? currentValue.startsWith(valueToMatch) : currentValue.indexOf(valueToMatch) !== -1;
            if (filterList && isMatch) filteredValues.push(this.values[idx]);
            return isMatch;
        });
        return {
            suggestions,
            filteredValues
        };
    }
    filterListModel(filteredValues) {
        const { filterList } = this.config;
        if (!filterList) return;
        this.setValueList({
            valueList: filteredValues,
            refresh: true
        });
        this.alignPickerToComponent();
    }
    runSearch() {
        var _a, _b;
        const { values: values2 } = this;
        const searchStrings = this.buildSearchStrings(values2);
        if (!searchStrings) {
            this.highlightSelectedValue(-1);
            return;
        }
        const { suggestions, filteredValues } = this.getSuggestionsAndFilteredValues(this.searchString, searchStrings);
        const { filterList, highlightMatch, searchType = "fuzzy" } = this.config;
        const filterValueLen = filteredValues.length;
        const shouldFilter = !!(filterList && this.searchString !== "");
        this.filterListModel(shouldFilter ? filteredValues : values2);
        if (suggestions.length) {
            const topSuggestionIndex = shouldFilter ? 0 : searchStrings.indexOf(suggestions[0]);
            this.selectListItem(topSuggestionIndex);
        } else {
            this.highlightSelectedValue(-1);
            if (!shouldFilter || filterValueLen) (_a = this.listComponent) == null || _a.ensureIndexVisible(0);
            else if (shouldFilter) {
                this.getAriaElement().removeAttribute("data-active-option");
                const eListAriaEl = (_b = this.listComponent) == null ? void 0 : _b.getAriaElement();
                if (eListAriaEl) setAriaActiveDescendant(eListAriaEl, null);
            }
        }
        if (highlightMatch && searchType !== "fuzzy") this.highlightFilterMatch();
        this.displayOrHidePicker();
    }
    displayOrHidePicker() {
        var _a;
        const eListGui = (_a = this.listComponent) == null ? void 0 : _a.getGui();
        const toggleValue = this.currentList ? this.currentList.length === 0 : false;
        eListGui == null || eListGui.classList.toggle("ag-hidden", toggleValue);
    }
    clearSearchString() {
        this.searchString = "";
    }
    selectListItem(index, preventUnnecessaryScroll) {
        if (!this.isPickerDisplayed || !this.currentList || !this.listComponent || index < 0 || index >= this.currentList.length) return;
        const wasScrolled = this.listComponent.ensureIndexVisible(index, !preventUnnecessaryScroll);
        if (wasScrolled && !preventUnnecessaryScroll) this.listComponent.refresh(true);
        this.highlightSelectedValue(index);
    }
    setValue(value, silent, fromPicker) {
        const index = this.currentList ? this.currentList.indexOf(value) : -1;
        if (index === -1) return this;
        this.value = value;
        if (!fromPicker) this.selectListItem(index);
        this.renderSelectedValue();
        return super.setValue(value, silent);
    }
    createRowComponent(value) {
        const row = new RichSelectRow(this.config, this.eWrapper);
        row.setParentComponent(this.listComponent);
        this.getContext().createBean(row);
        row.setState(value);
        const { highlightMatch, searchType = "fuzzy" } = this.config;
        if (highlightMatch && searchType !== "fuzzy") row.highlightString(this.searchString);
        return row;
    }
    getRowForMouseEvent(e) {
        const { listComponent } = this;
        if (!listComponent) return -1;
        const eGui = listComponent == null ? void 0 : listComponent.getGui();
        const rect = eGui.getBoundingClientRect();
        const scrollTop = listComponent.getScrollTop();
        const mouseY = e.clientY - rect.top + scrollTop;
        return Math.floor(mouseY / listComponent.getRowHeight());
    }
    onPickerMouseMove(e) {
        if (!this.listComponent) return;
        const row = this.getRowForMouseEvent(e);
        if (row !== -1 && row != this.lastRowHovered) {
            this.lastRowHovered = row;
            this.selectListItem(row, true);
        }
    }
    onNavigationKeyDown(event, key) {
        event.preventDefault();
        const isDown = key === KeyCode.DOWN;
        if (!this.isPickerDisplayed && isDown) {
            this.showPicker();
            return;
        }
        const oldIndex = this.highlightedItem;
        const diff = isDown ? 1 : -1;
        const newIndex = oldIndex === -1 ? 0 : oldIndex + diff;
        this.selectListItem(newIndex);
    }
    onPageNavigation(key) {
        var _a;
        if (!this.isPickerDisplayed) return;
        const newIndex = (_a = this.listComponent) == null ? void 0 : _a.navigateToPage(key, this.highlightedItem);
        if (newIndex != null) this.animationFrameService.requestAnimationFrame(()=>{
            if (!this.isAlive()) return null;
            this.highlightSelectedValue(newIndex);
        });
    }
    onEnterKeyDown(e) {
        if (!this.isPickerDisplayed) return;
        e.preventDefault();
        if (this.currentList) this.onListValueSelected(this.currentList[this.highlightedItem], true);
    }
    onTabKeyDown() {
        if (!this.isPickerDisplayed || !this.currentList) return;
        this.setValue(this.currentList[this.highlightedItem], false, true);
    }
    onListValueSelected(value, fromEnterKey) {
        this.setValue(value, false, true);
        this.dispatchPickerEvent(value, fromEnterKey);
        this.hidePicker();
    }
    dispatchPickerEvent(value, fromEnterKey) {
        const event = {
            type: Events.EVENT_FIELD_PICKER_VALUE_SELECTED,
            fromEnterKey,
            value
        };
        this.dispatchEvent(event);
    }
    getFocusableElement() {
        const { allowTyping } = this.config;
        if (allowTyping) return this.eInput.getFocusableElement();
        return super.getFocusableElement();
    }
    onKeyDown(event) {
        const key = event.key;
        const { allowTyping } = this.config;
        switch(key){
            case KeyCode.LEFT:
            case KeyCode.RIGHT:
                if (!allowTyping) event.preventDefault();
                break;
            case KeyCode.PAGE_HOME:
            case KeyCode.PAGE_END:
                if (allowTyping) {
                    event.preventDefault();
                    const inputEl = this.eInput.getInputElement();
                    const target = key === KeyCode.PAGE_HOME ? 0 : inputEl.value.length;
                    inputEl.setSelectionRange(target, target);
                    break;
                }
            case KeyCode.PAGE_UP:
            case KeyCode.PAGE_DOWN:
                event.preventDefault();
                this.onPageNavigation(key);
                break;
            case KeyCode.DOWN:
            case KeyCode.UP:
                this.onNavigationKeyDown(event, key);
                break;
            case KeyCode.ESCAPE:
                if (this.isPickerDisplayed) {
                    if (isVisible(this.listComponent.getGui())) {
                        event.preventDefault();
                        stopPropagationForAgGrid(event);
                    }
                    this.hidePicker();
                }
                break;
            case KeyCode.ENTER:
                this.onEnterKeyDown(event);
                break;
            case KeyCode.TAB:
                this.onTabKeyDown();
                break;
            default:
                if (!allowTyping) this.buildSearchStringFromKeyboardEvent(event);
        }
    }
    destroy() {
        if (this.listComponent) {
            this.destroyBean(this.listComponent);
            this.listComponent = void 0;
        }
        this.eLoading = void 0;
        super.destroy();
    }
};
__decorateClass([
    Autowired("userComponentFactory")
], AgRichSelect.prototype, "userComponentFactory", 2);
__decorateClass([
    Autowired("animationFrameService")
], AgRichSelect.prototype, "animationFrameService", 2);
__decorateClass([
    RefSelector("eInput")
], AgRichSelect.prototype, "eInput", 2);
// community-modules/core/src/widgets/agSlider.ts
var _AgSlider = class _AgSlider extends AgAbstractLabel {
    constructor(config){
        super(config, _AgSlider.TEMPLATE);
        this.labelAlignment = "top";
    }
    init() {
        this.eSlider.addCssClass("ag-slider-field");
        const { minValue, maxValue, textFieldWidth, step, value, onValueChange } = this.config;
        if (minValue != null) this.setMinValue(minValue);
        if (maxValue != null) this.setMaxValue(maxValue);
        if (textFieldWidth != null) this.setTextFieldWidth(textFieldWidth);
        if (step != null) this.setStep(step);
        if (value != null) this.setValue(value);
        if (onValueChange != null) this.onValueChange(onValueChange);
    }
    onValueChange(callbackFn) {
        const eventChanged = Events.EVENT_FIELD_VALUE_CHANGED;
        this.addManagedListener(this.eText, eventChanged, ()=>{
            const textValue = parseFloat(this.eText.getValue());
            this.eSlider.setValue(textValue.toString(), true);
            callbackFn(textValue || 0);
        });
        this.addManagedListener(this.eSlider, eventChanged, ()=>{
            const sliderValue = this.eSlider.getValue();
            this.eText.setValue(sliderValue, true);
            callbackFn(parseFloat(sliderValue));
        });
        return this;
    }
    setSliderWidth(width) {
        this.eSlider.setWidth(width);
        return this;
    }
    setTextFieldWidth(width) {
        this.eText.setWidth(width);
        return this;
    }
    setMinValue(minValue) {
        this.eSlider.setMinValue(minValue);
        this.eText.setMin(minValue);
        return this;
    }
    setMaxValue(maxValue) {
        this.eSlider.setMaxValue(maxValue);
        this.eText.setMax(maxValue);
        return this;
    }
    getValue() {
        return this.eText.getValue();
    }
    setValue(value, silent) {
        if (this.getValue() === value) return this;
        this.eText.setValue(value, true);
        this.eSlider.setValue(value, true);
        if (!silent) this.dispatchEvent({
            type: Events.EVENT_FIELD_VALUE_CHANGED
        });
        return this;
    }
    setStep(step) {
        this.eSlider.setStep(step);
        this.eText.setStep(step);
        return this;
    }
};
_AgSlider.TEMPLATE = /* html */ `<div class="ag-slider">
            <label ref="eLabel"></label>
            <div class="ag-wrapper ag-slider-wrapper">
                <ag-input-range ref="eSlider"></ag-input-range>
                <ag-input-number-field ref="eText"></ag-input-number-field>
            </div>
        </div>`;
__decorateClass([
    RefSelector("eLabel")
], _AgSlider.prototype, "eLabel", 2);
__decorateClass([
    RefSelector("eSlider")
], _AgSlider.prototype, "eSlider", 2);
__decorateClass([
    RefSelector("eText")
], _AgSlider.prototype, "eText", 2);
__decorateClass([
    PostConstruct
], _AgSlider.prototype, "init", 1);
var AgSlider = _AgSlider;
// community-modules/core/src/widgets/agGroupComponent.ts
var _AgGroupComponent = class _AgGroupComponent extends Component {
    constructor(params = {}){
        super(_AgGroupComponent.getTemplate(params));
        this.params = params;
        this.suppressEnabledCheckbox = true;
        this.suppressToggleExpandOnEnableChange = false;
        const { enabled, items, suppressEnabledCheckbox, expanded, suppressToggleExpandOnEnableChange, useToggle: toggleMode } = params;
        this.cssIdentifier = params.cssIdentifier || "default";
        this.enabled = enabled != null ? enabled : true;
        this.items = items || [];
        this.useToggle = toggleMode != null ? toggleMode : false;
        this.alignItems = params.alignItems || "center";
        this.expanded = expanded == null ? true : expanded;
        if (suppressEnabledCheckbox != null) this.suppressEnabledCheckbox = suppressEnabledCheckbox;
        if (suppressToggleExpandOnEnableChange != null) this.suppressToggleExpandOnEnableChange = suppressToggleExpandOnEnableChange;
    }
    static getTemplate(params) {
        const cssIdentifier = params.cssIdentifier || "default";
        const direction = params.direction || "vertical";
        return /* html */ `
            <div class="ag-group ag-${cssIdentifier}-group" role="presentation">
                <div ref="eToolbar" class="ag-group-toolbar ag-${cssIdentifier}-group-toolbar">
                    <ag-checkbox ref="cbGroupEnabled"></ag-checkbox>
                </div>
                <div ref="eContainer" class="ag-group-container ag-group-container-${direction} ag-${cssIdentifier}-group-container"></div>
            </div>
        `;
    }
    postConstruct() {
        this.setupTitleBar();
        if (this.items.length) {
            const initialItems = this.items;
            this.items = [];
            this.addItems(initialItems);
        }
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        this.cbGroupEnabled.setLabel(localeTextFunc("enabled", "Enabled"));
        if (this.enabled) this.setEnabled(this.enabled, void 0, true);
        this.setAlignItems(this.alignItems);
        const { onEnableChange, suppressOpenCloseIcons } = this.params;
        this.hideEnabledCheckbox(this.suppressEnabledCheckbox);
        this.hideOpenCloseIcons(suppressOpenCloseIcons != null ? suppressOpenCloseIcons : false);
        this.refreshChildDisplay();
        setDisplayed(this.eContainer, this.expanded);
        this.cbGroupEnabled.onValueChange((newSelection)=>{
            this.setEnabled(newSelection, true, this.suppressToggleExpandOnEnableChange);
            this.dispatchEnableChangeEvent(newSelection);
        });
        if (onEnableChange != null) this.onEnableChange(onEnableChange);
    }
    refreshChildDisplay() {
        var _a;
        setDisplayed(this.eToolbar, this.expanded && !this.suppressEnabledCheckbox);
        (_a = this.eTitleBar) == null || _a.refreshOnExpand(this.expanded);
    }
    isExpanded() {
        return this.expanded;
    }
    setAlignItems(alignment) {
        if (this.alignItems !== alignment) this.removeCssClass(`ag-group-item-alignment-${this.alignItems}`);
        this.alignItems = alignment;
        const newCls = `ag-group-item-alignment-${this.alignItems}`;
        this.addCssClass(newCls);
        return this;
    }
    toggleGroupExpand(expanded) {
        var _a;
        let silent = false;
        if (((_a = this.eTitleBar) == null ? void 0 : _a.isSuppressCollapse()) && !this.useToggle) {
            expanded = true;
            silent = true;
        } else {
            expanded = expanded != null ? expanded : !this.expanded;
            if (this.expanded === expanded) return this;
        }
        this.expanded = expanded;
        this.refreshChildDisplay();
        setDisplayed(this.eContainer, expanded);
        if (!silent) this.dispatchEvent({
            type: expanded ? _AgGroupComponent.EVENT_EXPANDED : _AgGroupComponent.EVENT_COLLAPSED
        });
        return this;
    }
    addItems(items) {
        items.forEach((item)=>this.addItem(item));
    }
    prependItem(item) {
        this.insertItem(item, true);
    }
    addItem(item) {
        this.insertItem(item, false);
    }
    insertItem(item, prepend) {
        const container = this.eContainer;
        const el = item instanceof Component ? item.getGui() : item;
        el.classList.add("ag-group-item", `ag-${this.cssIdentifier}-group-item`);
        if (prepend) {
            container.insertAdjacentElement("afterbegin", el);
            this.items.unshift(el);
        } else {
            container.appendChild(el);
            this.items.push(el);
        }
    }
    hideItem(hide, index) {
        const itemToHide = this.items[index];
        setDisplayed(itemToHide, !hide);
    }
    getItemIndex(item) {
        const el = item instanceof Component ? item.getGui() : item;
        return this.items.indexOf(el);
    }
    setTitle(title) {
        var _a;
        (_a = this.eTitleBar) == null || _a.setTitle(title);
        return this;
    }
    addTitleBarWidget(el) {
        var _a;
        (_a = this.eTitleBar) == null || _a.addWidget(el);
        return this;
    }
    addCssClassToTitleBar(cssClass) {
        var _a;
        (_a = this.eTitleBar) == null || _a.addCssClass(cssClass);
    }
    dispatchEnableChangeEvent(enabled) {
        const event = {
            type: _AgGroupComponent.EVENT_ENABLE_CHANGE,
            enabled
        };
        this.dispatchEvent(event);
    }
    setEnabled(enabled, skipToggle, skipExpand) {
        var _a;
        this.enabled = enabled;
        this.refreshDisabledStyles();
        if (!skipExpand) this.toggleGroupExpand(enabled);
        if (!skipToggle) {
            this.cbGroupEnabled.setValue(enabled);
            (_a = this.eToggle) == null || _a.setValue(enabled);
        }
        return this;
    }
    isEnabled() {
        return this.enabled;
    }
    onEnableChange(callbackFn) {
        this.addManagedListener(this, _AgGroupComponent.EVENT_ENABLE_CHANGE, (event)=>callbackFn(event.enabled));
        return this;
    }
    hideEnabledCheckbox(hide) {
        this.suppressEnabledCheckbox = hide;
        this.refreshChildDisplay();
        this.refreshDisabledStyles();
        return this;
    }
    hideOpenCloseIcons(hide) {
        var _a;
        (_a = this.eTitleBar) == null || _a.hideOpenCloseIcons(hide);
        return this;
    }
    refreshDisabledStyles() {
        var _a;
        const disabled = !this.enabled;
        this.eContainer.classList.toggle("ag-disabled", disabled);
        (_a = this.eTitleBar) == null || _a.refreshDisabledStyles(this.suppressEnabledCheckbox && disabled);
        this.eContainer.classList.toggle("ag-disabled-group-container", disabled);
    }
    setupTitleBar() {
        const titleBar = this.useToggle ? this.createToggleTitleBar() : this.createDefaultTitleBar();
        this.eToolbar.insertAdjacentElement("beforebegin", titleBar.getGui());
    }
    createDefaultTitleBar() {
        const titleBar = this.createManagedBean(new DefaultTitleBar(this.params));
        this.eTitleBar = titleBar;
        titleBar.refreshOnExpand(this.expanded);
        this.addManagedListener(titleBar, DefaultTitleBar.EVENT_EXPAND_CHANGED, (event)=>this.toggleGroupExpand(event.expanded));
        return titleBar;
    }
    createToggleTitleBar() {
        var _a;
        const eToggle = this.createManagedBean(new AgToggleButton({
            value: this.enabled,
            label: this.params.title,
            labelAlignment: "left",
            labelWidth: "flex",
            onValueChange: (enabled)=>{
                this.setEnabled(enabled, true);
                this.dispatchEnableChangeEvent(enabled);
            }
        }));
        eToggle.addCssClass("ag-group-title-bar");
        eToggle.addCssClass(`ag-${(_a = this.params.cssIdentifier) != null ? _a : "default"}-group-title-bar ag-unselectable`);
        this.eToggle = eToggle;
        this.toggleGroupExpand(this.enabled);
        return eToggle;
    }
};
_AgGroupComponent.EVENT_EXPANDED = "expanded";
_AgGroupComponent.EVENT_COLLAPSED = "collapsed";
_AgGroupComponent.EVENT_ENABLE_CHANGE = "enableChange";
__decorateClass([
    RefSelector("eToolbar")
], _AgGroupComponent.prototype, "eToolbar", 2);
__decorateClass([
    RefSelector("cbGroupEnabled")
], _AgGroupComponent.prototype, "cbGroupEnabled", 2);
__decorateClass([
    RefSelector("eContainer")
], _AgGroupComponent.prototype, "eContainer", 2);
__decorateClass([
    PostConstruct
], _AgGroupComponent.prototype, "postConstruct", 1);
var AgGroupComponent = _AgGroupComponent;
var TITLE_BAR_DISABLED_CLASS = "ag-disabled-group-title-bar";
var _DefaultTitleBar = class _DefaultTitleBar extends Component {
    constructor(params = {}){
        super(_DefaultTitleBar.getTemplate(params));
        this.suppressOpenCloseIcons = false;
        const { title, suppressOpenCloseIcons } = params;
        if (!!title && title.length > 0) this.title = title;
        if (suppressOpenCloseIcons != null) this.suppressOpenCloseIcons = suppressOpenCloseIcons;
    }
    static getTemplate(params) {
        var _a;
        const cssIdentifier = (_a = params.cssIdentifier) != null ? _a : "default";
        return /* html */ `
            <div class="ag-group-title-bar ag-${cssIdentifier}-group-title-bar ag-unselectable" role="button">
                <span class="ag-group-title-bar-icon ag-${cssIdentifier}-group-title-bar-icon" ref="eGroupOpenedIcon" role="presentation"></span>
                <span class="ag-group-title-bar-icon ag-${cssIdentifier}-group-title-bar-icon" ref="eGroupClosedIcon" role="presentation"></span>
                <span ref="eTitle" class="ag-group-title ag-${cssIdentifier}-group-title"></span>
            </div>
        `;
    }
    postConstruct() {
        this.setTitle(this.title);
        this.hideOpenCloseIcons(this.suppressOpenCloseIcons);
        this.setupExpandContract();
    }
    setupExpandContract() {
        this.eGroupClosedIcon.appendChild(createIcon("columnSelectClosed", this.gos, null));
        this.eGroupOpenedIcon.appendChild(createIcon("columnSelectOpen", this.gos, null));
        this.addManagedListener(this.getGui(), "click", ()=>this.dispatchExpandChanged());
        this.addManagedListener(this.getGui(), "keydown", (e)=>{
            switch(e.key){
                case KeyCode.ENTER:
                case KeyCode.SPACE:
                    e.preventDefault();
                    this.dispatchExpandChanged();
                    break;
                case KeyCode.RIGHT:
                case KeyCode.LEFT:
                    e.preventDefault();
                    this.dispatchExpandChanged(e.key === KeyCode.RIGHT);
                    break;
            }
        });
    }
    refreshOnExpand(expanded) {
        this.refreshAriaStatus(expanded);
        this.refreshOpenCloseIcons(expanded);
    }
    refreshAriaStatus(expanded) {
        if (!this.suppressOpenCloseIcons) setAriaExpanded(this.getGui(), expanded);
    }
    refreshOpenCloseIcons(expanded) {
        const showIcon = !this.suppressOpenCloseIcons;
        setDisplayed(this.eGroupOpenedIcon, showIcon && expanded);
        setDisplayed(this.eGroupClosedIcon, showIcon && !expanded);
    }
    isSuppressCollapse() {
        return this.suppressOpenCloseIcons;
    }
    dispatchExpandChanged(expanded) {
        const event = {
            type: _DefaultTitleBar.EVENT_EXPAND_CHANGED,
            expanded
        };
        this.dispatchEvent(event);
    }
    setTitle(title) {
        const eGui = this.getGui();
        const hasTitle = !!title && title.length > 0;
        title = hasTitle ? title : void 0;
        this.eTitle.textContent = title != null ? title : "";
        setDisplayed(eGui, hasTitle);
        if (title !== this.title) this.title = title;
        const disabled = eGui.classList.contains(TITLE_BAR_DISABLED_CLASS);
        this.refreshDisabledStyles(disabled);
        return this;
    }
    addWidget(el) {
        this.getGui().appendChild(el);
        return this;
    }
    hideOpenCloseIcons(hide) {
        this.suppressOpenCloseIcons = hide;
        if (hide) this.dispatchExpandChanged(true);
        return this;
    }
    refreshDisabledStyles(disabled) {
        const eGui = this.getGui();
        if (disabled) {
            eGui.classList.add(TITLE_BAR_DISABLED_CLASS);
            eGui.removeAttribute("tabindex");
        } else {
            eGui.classList.remove(TITLE_BAR_DISABLED_CLASS);
            if (typeof this.title === "string") eGui.setAttribute("tabindex", "0");
            else eGui.removeAttribute("tabindex");
        }
    }
};
_DefaultTitleBar.EVENT_EXPAND_CHANGED = "expandedChanged";
__decorateClass([
    RefSelector("eGroupOpenedIcon")
], _DefaultTitleBar.prototype, "eGroupOpenedIcon", 2);
__decorateClass([
    RefSelector("eGroupClosedIcon")
], _DefaultTitleBar.prototype, "eGroupClosedIcon", 2);
__decorateClass([
    RefSelector("eTitle")
], _DefaultTitleBar.prototype, "eTitle", 2);
__decorateClass([
    PostConstruct
], _DefaultTitleBar.prototype, "postConstruct", 1);
var DefaultTitleBar = _DefaultTitleBar;
// community-modules/core/src/widgets/agMenuList.ts
var AgMenuList = class extends TabGuardComp {
    constructor(level = 0, params){
        super(/* html */ `<div class="ag-menu-list" role="tree"></div>`);
        this.level = level;
        this.menuItems = [];
        this.params = params != null ? params : {
            column: null,
            node: null,
            value: null
        };
    }
    postConstruct() {
        this.initialiseTabGuard({
            onTabKeyDown: (e)=>this.onTabKeyDown(e),
            handleKeyDown: (e)=>this.handleKeyDown(e),
            onFocusIn: (e)=>this.handleFocusIn(e),
            onFocusOut: (e)=>this.handleFocusOut(e)
        });
    }
    onTabKeyDown(e) {
        const parent = this.getParentComponent();
        const parentGui = parent && parent.getGui();
        const isManaged = parentGui && parentGui.classList.contains("ag-focus-managed");
        if (!isManaged) e.preventDefault();
        if (e.shiftKey) this.closeIfIsChild(e);
    }
    handleKeyDown(e) {
        switch(e.key){
            case KeyCode.UP:
            case KeyCode.RIGHT:
            case KeyCode.DOWN:
            case KeyCode.LEFT:
                e.preventDefault();
                this.handleNavKey(e.key);
                break;
            case KeyCode.ESCAPE:
                if (this.closeIfIsChild()) stopPropagationForAgGrid(e);
                break;
        }
    }
    handleFocusIn(e) {
        var _a, _b;
        const oldFocusedElement = e.relatedTarget;
        if (!this.tabGuardCtrl.isTabGuard(oldFocusedElement) && (this.getGui().contains(oldFocusedElement) || ((_b = (_a = this.activeMenuItem) == null ? void 0 : _a.getSubMenuGui()) == null ? void 0 : _b.contains(oldFocusedElement)))) return;
        if (this.activeMenuItem) this.activeMenuItem.activate();
        else this.activateFirstItem();
    }
    handleFocusOut(e) {
        var _a;
        const newFocusedElement = e.relatedTarget;
        if (!this.activeMenuItem || this.getGui().contains(newFocusedElement) || ((_a = this.activeMenuItem.getSubMenuGui()) == null ? void 0 : _a.contains(newFocusedElement))) return;
        if (!this.activeMenuItem.isSubMenuOpening()) this.activeMenuItem.deactivate();
    }
    clearActiveItem() {
        if (this.activeMenuItem) {
            this.activeMenuItem.deactivate();
            this.activeMenuItem = null;
        }
    }
    addMenuItems(menuItems) {
        if (menuItems == null) return;
        AgPromise.all(menuItems.map((menuItemOrString)=>{
            if (menuItemOrString === "separator") return AgPromise.resolve({
                eGui: this.createSeparator()
            });
            else if (typeof menuItemOrString === "string") {
                console.warn(`AG Grid: unrecognised menu item ${menuItemOrString}`);
                return AgPromise.resolve({
                    eGui: null
                });
            } else return this.addItem(menuItemOrString);
        })).then((elements)=>{
            elements.forEach((element)=>{
                if (element == null ? void 0 : element.eGui) {
                    this.appendChild(element.eGui);
                    if (element.comp) this.menuItems.push(element.comp);
                }
            });
        });
    }
    addItem(menuItemDef) {
        const menuItem = this.createManagedBean(new AgMenuItemComponent());
        return menuItem.init({
            menuItemDef,
            isAnotherSubMenuOpen: ()=>this.menuItems.some((m)=>m.isSubMenuOpen()),
            level: this.level,
            contextParams: this.params
        }).then(()=>{
            menuItem.setParentComponent(this);
            this.addManagedListener(menuItem, AgMenuItemComponent.EVENT_CLOSE_MENU, (event)=>{
                this.dispatchEvent(event);
            });
            this.addManagedListener(menuItem, AgMenuItemComponent.EVENT_MENU_ITEM_ACTIVATED, (event)=>{
                if (this.activeMenuItem && this.activeMenuItem !== event.menuItem) this.activeMenuItem.deactivate();
                this.activeMenuItem = event.menuItem;
            });
            return {
                comp: menuItem,
                eGui: menuItem.getGui()
            };
        });
    }
    activateFirstItem() {
        const item = this.menuItems.filter((currentItem)=>!currentItem.isDisabled())[0];
        if (!item) return;
        item.activate();
    }
    createSeparator() {
        const separatorHtml = /* html */ `
            <div class="ag-menu-separator" aria-hidden="true">
                <div class="ag-menu-separator-part"></div>
                <div class="ag-menu-separator-part"></div>
                <div class="ag-menu-separator-part"></div>
                <div class="ag-menu-separator-part"></div>
            </div>`;
        return loadTemplate(separatorHtml);
    }
    handleNavKey(key) {
        switch(key){
            case KeyCode.UP:
            case KeyCode.DOWN:
                const nextItem = this.findNextItem(key === KeyCode.UP);
                if (nextItem && nextItem !== this.activeMenuItem) nextItem.activate();
                return;
        }
        const left = this.gos.get("enableRtl") ? KeyCode.RIGHT : KeyCode.LEFT;
        if (key === left) this.closeIfIsChild();
        else this.openChild();
    }
    closeIfIsChild(e) {
        const parentItem = this.getParentComponent();
        if (parentItem && parentItem instanceof AgMenuItemComponent) {
            if (e) e.preventDefault();
            parentItem.closeSubMenu();
            parentItem.getGui().focus();
            return true;
        }
        return false;
    }
    openChild() {
        if (this.activeMenuItem) this.activeMenuItem.openSubMenu(true);
    }
    findNextItem(up) {
        const items = this.menuItems.filter((item)=>!item.isDisabled());
        if (!items.length) return;
        if (!this.activeMenuItem) return up ? last(items) : items[0];
        if (up) items.reverse();
        let nextItem;
        let foundCurrent = false;
        for(let i = 0; i < items.length; i++){
            const item = items[i];
            if (!foundCurrent) {
                if (item === this.activeMenuItem) foundCurrent = true;
                continue;
            }
            nextItem = item;
            break;
        }
        if (foundCurrent && !nextItem) return items[0];
        return nextItem || this.activeMenuItem;
    }
    destroy() {
        this.clearActiveItem();
        super.destroy();
    }
};
__decorateClass([
    Autowired("focusService")
], AgMenuList.prototype, "focusService", 2);
__decorateClass([
    PostConstruct
], AgMenuList.prototype, "postConstruct", 1);
// community-modules/core/src/widgets/agMenuPanel.ts
var AgMenuPanel = class extends TabGuardComp {
    constructor(wrappedComponent){
        super();
        this.wrappedComponent = wrappedComponent;
        this.setTemplateFromElement(wrappedComponent.getGui());
    }
    postConstruct() {
        this.initialiseTabGuard({
            onTabKeyDown: (e)=>this.onTabKeyDown(e),
            handleKeyDown: (e)=>this.handleKeyDown(e)
        });
    }
    handleKeyDown(e) {
        if (e.key === KeyCode.ESCAPE) this.closePanel();
    }
    onTabKeyDown(e) {
        if (e.defaultPrevented) return;
        this.closePanel();
        e.preventDefault();
    }
    closePanel() {
        const menuItem = this.parentComponent;
        menuItem.closeSubMenu();
        setTimeout(()=>menuItem.getGui().focus(), 0);
    }
};
__decorateClass([
    PostConstruct
], AgMenuPanel.prototype, "postConstruct", 1);
// community-modules/core/src/widgets/agMenuItemComponent.ts
var _AgMenuItemComponent = class _AgMenuItemComponent extends BeanStub {
    constructor(){
        super(...arguments);
        this.isActive = false;
        this.subMenuIsOpen = false;
        this.subMenuIsOpening = false;
        this.suppressRootStyles = true;
        this.suppressAria = true;
        this.suppressFocus = true;
    }
    init(params) {
        var _a, _b;
        const { menuItemDef, isAnotherSubMenuOpen, level, childComponent, contextParams } = params;
        this.params = params.menuItemDef;
        this.level = level;
        this.isAnotherSubMenuOpen = isAnotherSubMenuOpen;
        this.childComponent = childComponent;
        this.contextParams = contextParams;
        this.cssClassPrefix = (_b = (_a = this.params.menuItemParams) == null ? void 0 : _a.cssClassPrefix) != null ? _b : "ag-menu-option";
        const compDetails = this.userComponentFactory.getMenuItemCompDetails(this.params, __spreadProps(__spreadValues({}, menuItemDef), {
            level,
            isAnotherSubMenuOpen,
            openSubMenu: (activateFirstItem)=>this.openSubMenu(activateFirstItem),
            closeSubMenu: ()=>this.closeSubMenu(),
            closeMenu: (event)=>this.closeMenu(event),
            updateTooltip: (tooltip, shouldDisplayTooltip)=>this.refreshTooltip(tooltip, shouldDisplayTooltip),
            onItemActivated: ()=>this.onItemActivated()
        }));
        return compDetails.newAgStackInstance().then((comp)=>{
            var _a2;
            this.menuItemComp = comp;
            const configureDefaults = (_a2 = comp.configureDefaults) == null ? void 0 : _a2.call(comp);
            if (configureDefaults) this.configureDefaults(configureDefaults === true ? void 0 : configureDefaults);
        });
    }
    addListeners(eGui, params) {
        if (!(params == null ? void 0 : params.suppressClick)) this.addManagedListener(eGui, "click", (e)=>this.onItemSelected(e));
        if (!(params == null ? void 0 : params.suppressKeyboardSelect)) this.addManagedListener(eGui, "keydown", (e)=>{
            if (e.key === KeyCode.ENTER || e.key === KeyCode.SPACE) {
                e.preventDefault();
                this.onItemSelected(e);
            }
        });
        if (!(params == null ? void 0 : params.suppressMouseDown)) this.addManagedListener(eGui, "mousedown", (e)=>{
            e.stopPropagation();
            e.preventDefault();
        });
        if (!(params == null ? void 0 : params.suppressMouseOver)) {
            this.addManagedListener(eGui, "mouseenter", ()=>this.onMouseEnter());
            this.addManagedListener(eGui, "mouseleave", ()=>this.onMouseLeave());
        }
    }
    isDisabled() {
        return !!this.params.disabled;
    }
    openSubMenu(activateFirstItem = false) {
        var _a, _b;
        this.closeSubMenu();
        if (!this.params.subMenu) return;
        this.subMenuIsOpening = true;
        const ePopup = loadTemplate(/* html */ `<div class="ag-menu" role="presentation"></div>`);
        this.eSubMenuGui = ePopup;
        let destroySubMenu;
        let afterGuiAttached = ()=>{
            this.subMenuIsOpening = false;
        };
        if (this.childComponent) {
            const menuPanel = this.createBean(new AgMenuPanel(this.childComponent));
            menuPanel.setParentComponent(this);
            const subMenuGui = menuPanel.getGui();
            const mouseEvent = "mouseenter";
            const mouseEnterListener = ()=>this.cancelDeactivate();
            subMenuGui.addEventListener(mouseEvent, mouseEnterListener);
            destroySubMenu = ()=>subMenuGui.removeEventListener(mouseEvent, mouseEnterListener);
            ePopup.appendChild(subMenuGui);
            if (this.childComponent.afterGuiAttached) afterGuiAttached = ()=>{
                this.childComponent.afterGuiAttached();
                this.subMenuIsOpening = false;
            };
        } else if (this.params.subMenu) {
            const childMenu = this.createBean(new AgMenuList(this.level + 1, this.contextParams));
            childMenu.setParentComponent(this);
            childMenu.addMenuItems(this.params.subMenu);
            ePopup.appendChild(childMenu.getGui());
            this.addManagedListener(childMenu, _AgMenuItemComponent.EVENT_CLOSE_MENU, (e)=>this.dispatchEvent(e));
            childMenu.addGuiEventListener("mouseenter", ()=>this.cancelDeactivate());
            destroySubMenu = ()=>this.destroyBean(childMenu);
            if (activateFirstItem) afterGuiAttached = ()=>{
                childMenu.activateFirstItem();
                this.subMenuIsOpening = false;
            };
        }
        const positionCallback = this.popupService.positionPopupForMenu.bind(this.popupService, {
            eventSource: this.eGui,
            ePopup
        });
        const translate = this.localeService.getLocaleTextFunc();
        const addPopupRes = this.popupService.addPopup({
            modal: true,
            eChild: ePopup,
            positionCallback,
            anchorToElement: this.eGui,
            ariaLabel: translate("ariaLabelSubMenu", "SubMenu"),
            afterGuiAttached
        });
        this.subMenuIsOpen = true;
        this.setAriaExpanded(true);
        this.hideSubMenu = ()=>{
            var _a2, _b2;
            if (addPopupRes) addPopupRes.hideFunc();
            this.subMenuIsOpen = false;
            this.setAriaExpanded(false);
            destroySubMenu();
            (_b2 = (_a2 = this.menuItemComp).setExpanded) == null || _b2.call(_a2, false);
            this.eSubMenuGui = void 0;
        };
        (_b = (_a = this.menuItemComp).setExpanded) == null || _b.call(_a, true);
    }
    setAriaExpanded(expanded) {
        if (!this.suppressAria) setAriaExpanded(this.eGui, expanded);
    }
    closeSubMenu() {
        if (!this.hideSubMenu) return;
        this.hideSubMenu();
        this.hideSubMenu = null;
        this.setAriaExpanded(false);
    }
    isSubMenuOpen() {
        return this.subMenuIsOpen;
    }
    isSubMenuOpening() {
        return this.subMenuIsOpening;
    }
    activate(openSubMenu) {
        var _a, _b;
        this.cancelActivate();
        if (this.params.disabled) return;
        this.isActive = true;
        if (!this.suppressRootStyles) this.eGui.classList.add(`${this.cssClassPrefix}-active`);
        (_b = (_a = this.menuItemComp).setActive) == null || _b.call(_a, true);
        if (!this.suppressFocus) this.eGui.focus({
            preventScroll: true
        });
        if (openSubMenu && this.params.subMenu) window.setTimeout(()=>{
            if (this.isAlive() && this.isActive) this.openSubMenu();
        }, 300);
        this.onItemActivated();
    }
    deactivate() {
        var _a, _b;
        this.cancelDeactivate();
        if (!this.suppressRootStyles) this.eGui.classList.remove(`${this.cssClassPrefix}-active`);
        (_b = (_a = this.menuItemComp).setActive) == null || _b.call(_a, false);
        this.isActive = false;
        if (this.subMenuIsOpen) this.hideSubMenu();
    }
    getGui() {
        return this.menuItemComp.getGui();
    }
    getParentComponent() {
        return this.parentComponent;
    }
    setParentComponent(component) {
        this.parentComponent = component;
    }
    getSubMenuGui() {
        return this.eSubMenuGui;
    }
    onItemSelected(event) {
        var _a, _b;
        (_b = (_a = this.menuItemComp).select) == null || _b.call(_a);
        if (this.params.action) this.getFrameworkOverrides().wrapOutgoing(()=>this.params.action(this.gos.addGridCommonParams(__spreadValues({}, this.contextParams))));
        else this.openSubMenu(event && event.type === "keydown");
        if (this.params.subMenu && !this.params.action || this.params.suppressCloseOnSelect) return;
        this.closeMenu(event);
    }
    closeMenu(event) {
        const e = {
            type: _AgMenuItemComponent.EVENT_CLOSE_MENU
        };
        if (event) {
            if (event instanceof MouseEvent) e.mouseEvent = event;
            else e.keyboardEvent = event;
        }
        this.dispatchEvent(e);
    }
    onItemActivated() {
        const event = {
            type: _AgMenuItemComponent.EVENT_MENU_ITEM_ACTIVATED,
            menuItem: this
        };
        this.dispatchEvent(event);
    }
    cancelActivate() {
        if (this.activateTimeoutId) {
            window.clearTimeout(this.activateTimeoutId);
            this.activateTimeoutId = 0;
        }
    }
    cancelDeactivate() {
        if (this.deactivateTimeoutId) {
            window.clearTimeout(this.deactivateTimeoutId);
            this.deactivateTimeoutId = 0;
        }
    }
    onMouseEnter() {
        this.cancelDeactivate();
        if (this.isAnotherSubMenuOpen()) this.activateTimeoutId = window.setTimeout(()=>this.activate(true), _AgMenuItemComponent.ACTIVATION_DELAY);
        else this.activate(true);
    }
    onMouseLeave() {
        this.cancelActivate();
        if (this.isSubMenuOpen()) this.deactivateTimeoutId = window.setTimeout(()=>this.deactivate(), _AgMenuItemComponent.ACTIVATION_DELAY);
        else this.deactivate();
    }
    configureDefaults(params) {
        var _a, _b, _c;
        if (!this.menuItemComp) {
            setTimeout(()=>this.configureDefaults(params));
            return;
        }
        let eGui = this.menuItemComp.getGui();
        const rootElement = (_b = (_a = this.menuItemComp).getRootElement) == null ? void 0 : _b.call(_a);
        if (rootElement) {
            if (!(params == null ? void 0 : params.suppressRootStyles)) eGui.classList.add("ag-menu-option-custom");
            eGui = rootElement;
        }
        this.eGui = eGui;
        this.suppressRootStyles = !!(params == null ? void 0 : params.suppressRootStyles);
        if (!this.suppressRootStyles) {
            eGui.classList.add(this.cssClassPrefix);
            (_c = this.params.cssClasses) == null || _c.forEach((it)=>eGui.classList.add(it));
            if (this.params.disabled) eGui.classList.add(`${this.cssClassPrefix}-disabled`);
        }
        if (!(params == null ? void 0 : params.suppressTooltip)) this.refreshTooltip(this.params.tooltip);
        this.suppressAria = !!(params == null ? void 0 : params.suppressAria);
        if (!this.suppressAria) {
            setAriaRole(eGui, "treeitem");
            setAriaLevel(eGui, this.level + 1);
            if (this.params.disabled) setAriaDisabled(eGui, true);
        }
        if (!(params == null ? void 0 : params.suppressTabIndex)) eGui.setAttribute("tabindex", "-1");
        if (!this.params.disabled) this.addListeners(eGui, params);
        this.suppressFocus = !!(params == null ? void 0 : params.suppressFocus);
    }
    refreshTooltip(tooltip, shouldDisplayTooltip) {
        this.tooltip = tooltip;
        if (this.tooltipFeature) this.tooltipFeature = this.destroyBean(this.tooltipFeature);
        if (!tooltip || !this.menuItemComp) return;
        this.tooltipFeature = this.createBean(new TooltipFeature({
            getGui: ()=>this.getGui(),
            getTooltipValue: ()=>this.tooltip,
            getLocation: ()=>"menu",
            shouldDisplayTooltip
        }));
    }
    destroy() {
        if (this.tooltipFeature) this.tooltipFeature = this.destroyBean(this.tooltipFeature);
        super.destroy();
    }
};
_AgMenuItemComponent.EVENT_CLOSE_MENU = "closeMenu";
_AgMenuItemComponent.EVENT_MENU_ITEM_ACTIVATED = "menuItemActivated";
_AgMenuItemComponent.ACTIVATION_DELAY = 80;
__decorateClass([
    Autowired("popupService")
], _AgMenuItemComponent.prototype, "popupService", 2);
__decorateClass([
    Autowired("userComponentFactory")
], _AgMenuItemComponent.prototype, "userComponentFactory", 2);
var AgMenuItemComponent = _AgMenuItemComponent;
// community-modules/core/src/widgets/agPanel.ts
var _AgPanel = class _AgPanel extends Component {
    constructor(config){
        super(_AgPanel.getTemplate(config));
        this.config = config;
        this.closable = true;
    }
    static getTemplate(config) {
        const cssIdentifier = config.cssIdentifier || "default";
        return /* html */ `<div class="ag-panel ag-${cssIdentifier}-panel" tabindex="-1">
            <div ref="eTitleBar" class="ag-panel-title-bar ag-${cssIdentifier}-panel-title-bar ag-unselectable">
                <span ref="eTitle" class="ag-panel-title-bar-title ag-${cssIdentifier}-panel-title-bar-title"></span>
                <div ref="eTitleBarButtons" class="ag-panel-title-bar-buttons ag-${cssIdentifier}-panel-title-bar-buttons"></div>
            </div>
            <div ref="eContentWrapper" class="ag-panel-content-wrapper ag-${cssIdentifier}-panel-content-wrapper"></div>
        </div>`;
    }
    postConstruct() {
        const { component, closable, hideTitleBar, title, minWidth = 250, width, minHeight = 250, height, centered, popup, x, y } = this.config;
        this.positionableFeature = new PositionableFeature(this.getGui(), {
            minWidth,
            width,
            minHeight,
            height,
            centered,
            x,
            y,
            popup,
            calculateTopBuffer: ()=>this.positionableFeature.getHeight() - this.getBodyHeight()
        });
        this.createManagedBean(this.positionableFeature);
        const eGui = this.getGui();
        if (component) this.setBodyComponent(component);
        if (!hideTitleBar) {
            if (title) this.setTitle(title);
            this.setClosable(closable != null ? closable : this.closable);
        } else setDisplayed(this.eTitleBar, false);
        this.addManagedListener(this.eTitleBar, "mousedown", (e)=>{
            if (eGui.contains(e.relatedTarget) || eGui.contains(this.gos.getActiveDomElement()) || this.eTitleBarButtons.contains(e.target)) {
                e.preventDefault();
                return;
            }
            const focusEl = this.eContentWrapper.querySelector("button, [href], input, select, textarea, [tabindex]");
            if (focusEl) focusEl.focus();
        });
        if (popup && this.positionableFeature.isPositioned()) return;
        if (this.renderComponent) this.renderComponent();
        this.positionableFeature.initialisePosition();
        this.eContentWrapper.style.height = "0";
    }
    renderComponent() {
        const eGui = this.getGui();
        eGui.focus();
        this.close = ()=>{
            eGui.parentElement.removeChild(eGui);
            this.destroy();
        };
    }
    getHeight() {
        return this.positionableFeature.getHeight();
    }
    setHeight(height) {
        this.positionableFeature.setHeight(height);
    }
    getWidth() {
        return this.positionableFeature.getWidth();
    }
    setWidth(width) {
        this.positionableFeature.setWidth(width);
    }
    setClosable(closable) {
        if (closable !== this.closable) this.closable = closable;
        if (closable) {
            const closeButtonComp = this.closeButtonComp = new Component(_AgPanel.CLOSE_BTN_TEMPLATE);
            this.getContext().createBean(closeButtonComp);
            const eGui = closeButtonComp.getGui();
            const child = createIconNoSpan("close", this.gos);
            child.classList.add("ag-panel-title-bar-button-icon");
            eGui.appendChild(child);
            this.addTitleBarButton(closeButtonComp);
            closeButtonComp.addManagedListener(eGui, "click", this.onBtClose.bind(this));
        } else if (this.closeButtonComp) {
            const eGui = this.closeButtonComp.getGui();
            eGui.parentElement.removeChild(eGui);
            this.closeButtonComp = this.destroyBean(this.closeButtonComp);
        }
    }
    setBodyComponent(bodyComponent) {
        bodyComponent.setParentComponent(this);
        this.eContentWrapper.appendChild(bodyComponent.getGui());
    }
    addTitleBarButton(button, position) {
        const eTitleBarButtons = this.eTitleBarButtons;
        const buttons = eTitleBarButtons.children;
        const len = buttons.length;
        if (position == null) position = len;
        position = Math.max(0, Math.min(position, len));
        button.addCssClass("ag-panel-title-bar-button");
        const eGui = button.getGui();
        if (position === 0) eTitleBarButtons.insertAdjacentElement("afterbegin", eGui);
        else if (position === len) eTitleBarButtons.insertAdjacentElement("beforeend", eGui);
        else buttons[position - 1].insertAdjacentElement("afterend", eGui);
        button.setParentComponent(this);
    }
    getBodyHeight() {
        return getInnerHeight(this.eContentWrapper);
    }
    getBodyWidth() {
        return getInnerWidth(this.eContentWrapper);
    }
    setTitle(title) {
        this.eTitle.innerText = title;
    }
    // called when user hits the 'x' in the top right
    onBtClose() {
        this.close();
    }
    destroy() {
        if (this.closeButtonComp) this.closeButtonComp = this.destroyBean(this.closeButtonComp);
        const eGui = this.getGui();
        if (eGui && isVisible(eGui)) this.close();
        super.destroy();
    }
};
_AgPanel.CLOSE_BTN_TEMPLATE = /* html */ `<div class="ag-button"></div>`;
__decorateClass([
    RefSelector("eContentWrapper")
], _AgPanel.prototype, "eContentWrapper", 2);
__decorateClass([
    RefSelector("eTitleBar")
], _AgPanel.prototype, "eTitleBar", 2);
__decorateClass([
    RefSelector("eTitleBarButtons")
], _AgPanel.prototype, "eTitleBarButtons", 2);
__decorateClass([
    RefSelector("eTitle")
], _AgPanel.prototype, "eTitle", 2);
__decorateClass([
    PostConstruct
], _AgPanel.prototype, "postConstruct", 1);
var AgPanel = _AgPanel;
// community-modules/core/src/widgets/agDialog.ts
var AgDialog = class extends AgPanel {
    constructor(config){
        super(__spreadProps(__spreadValues({}, config), {
            popup: true
        }));
        this.isMaximizable = false;
        this.isMaximized = false;
        this.maximizeListeners = [];
        this.resizeListenerDestroy = null;
        this.lastPosition = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    }
    postConstruct() {
        const eGui = this.getGui();
        const { movable, resizable, maximizable } = this.config;
        this.addCssClass("ag-dialog");
        super.postConstruct();
        this.addManagedListener(eGui, "focusin", (e)=>{
            this.popupService.bringPopupToFront(eGui);
        });
        if (movable) this.setMovable(movable);
        if (maximizable) this.setMaximizable(maximizable);
        if (resizable) this.setResizable(resizable);
    }
    renderComponent() {
        const eGui = this.getGui();
        const { alwaysOnTop, modal, title, afterGuiAttached } = this.config;
        const translate = this.localeService.getLocaleTextFunc();
        const addPopupRes = this.popupService.addPopup({
            modal,
            eChild: eGui,
            closeOnEsc: true,
            closedCallback: this.onClosed.bind(this),
            alwaysOnTop,
            ariaLabel: title || translate("ariaLabelDialog", "Dialog"),
            afterGuiAttached
        });
        if (addPopupRes) this.close = addPopupRes.hideFunc;
    }
    onClosed(event) {
        var _a, _b;
        this.destroy();
        (_b = (_a = this.config).closedCallback) == null || _b.call(_a, event);
    }
    toggleMaximize() {
        const position = this.positionableFeature.getPosition();
        if (this.isMaximized) {
            const { x, y, width, height } = this.lastPosition;
            this.setWidth(width);
            this.setHeight(height);
            this.positionableFeature.offsetElement(x, y);
        } else {
            this.lastPosition.width = this.getWidth();
            this.lastPosition.height = this.getHeight();
            this.lastPosition.x = position.x;
            this.lastPosition.y = position.y;
            this.positionableFeature.offsetElement(0, 0);
            this.setHeight("100%");
            this.setWidth("100%");
        }
        this.isMaximized = !this.isMaximized;
        this.refreshMaximizeIcon();
    }
    refreshMaximizeIcon() {
        setDisplayed(this.maximizeIcon, !this.isMaximized);
        setDisplayed(this.minimizeIcon, this.isMaximized);
    }
    clearMaximizebleListeners() {
        if (this.maximizeListeners.length) {
            this.maximizeListeners.forEach((destroyListener)=>destroyListener());
            this.maximizeListeners.length = 0;
        }
        if (this.resizeListenerDestroy) {
            this.resizeListenerDestroy();
            this.resizeListenerDestroy = null;
        }
    }
    destroy() {
        this.maximizeButtonComp = this.destroyBean(this.maximizeButtonComp);
        this.clearMaximizebleListeners();
        super.destroy();
    }
    setResizable(resizable) {
        this.positionableFeature.setResizable(resizable);
    }
    setMovable(movable) {
        this.positionableFeature.setMovable(movable, this.eTitleBar);
    }
    setMaximizable(maximizable) {
        if (!maximizable) {
            this.clearMaximizebleListeners();
            if (this.maximizeButtonComp) {
                this.destroyBean(this.maximizeButtonComp);
                this.maximizeButtonComp = this.maximizeIcon = this.minimizeIcon = void 0;
            }
            return;
        }
        const eTitleBar = this.eTitleBar;
        if (!eTitleBar || maximizable === this.isMaximizable) return;
        const maximizeButtonComp = this.buildMaximizeAndMinimizeElements();
        this.refreshMaximizeIcon();
        maximizeButtonComp.addManagedListener(maximizeButtonComp.getGui(), "click", this.toggleMaximize.bind(this));
        this.addTitleBarButton(maximizeButtonComp, 0);
        this.maximizeListeners.push(this.addManagedListener(eTitleBar, "dblclick", this.toggleMaximize.bind(this)));
        this.resizeListenerDestroy = this.addManagedListener(this, "resize", ()=>{
            this.isMaximized = false;
            this.refreshMaximizeIcon();
        });
    }
    buildMaximizeAndMinimizeElements() {
        const maximizeButtonComp = this.maximizeButtonComp = this.createBean(new Component(/* html */ `<div class="ag-dialog-button"></span>`));
        const eGui = maximizeButtonComp.getGui();
        this.maximizeIcon = createIconNoSpan("maximize", this.gos);
        eGui.appendChild(this.maximizeIcon);
        this.maximizeIcon.classList.add("ag-panel-title-bar-button-icon");
        this.minimizeIcon = createIconNoSpan("minimize", this.gos);
        eGui.appendChild(this.minimizeIcon);
        this.minimizeIcon.classList.add("ag-panel-title-bar-button-icon");
        return maximizeButtonComp;
    }
};
__decorateClass([
    Autowired("popupService")
], AgDialog.prototype, "popupService", 2);
// community-modules/core/src/widgets/popupService.ts
var instanceIdSeq = 0;
var PopupService = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.popupList = [];
    }
    postConstruct() {
        this.ctrlsService.whenReady((p)=>{
            this.gridCtrl = p.gridCtrl;
        });
        this.addManagedListener(this.eventService, Events.EVENT_GRID_STYLES_CHANGED, this.handleThemeChange.bind(this));
    }
    getPopupParent() {
        const ePopupParent = this.gos.get("popupParent");
        if (ePopupParent) return ePopupParent;
        return this.gridCtrl.getGui();
    }
    positionPopupForMenu(params) {
        const { eventSource, ePopup } = params;
        const popupIdx = this.getPopupIndex(ePopup);
        if (popupIdx !== -1) {
            const popup = this.popupList[popupIdx];
            popup.alignedToElement = eventSource;
        }
        const sourceRect = eventSource.getBoundingClientRect();
        const parentRect = this.getParentRect();
        const y = this.keepXYWithinBounds(ePopup, sourceRect.top - parentRect.top, 0 /* vertical */ );
        const minWidth = ePopup.clientWidth > 0 ? ePopup.clientWidth : 200;
        ePopup.style.minWidth = `${minWidth}px`;
        const widthOfParent = parentRect.right - parentRect.left;
        const maxX = widthOfParent - minWidth;
        let x;
        if (this.gos.get("enableRtl")) {
            x = xLeftPosition();
            if (x < 0) {
                x = xRightPosition();
                this.setAlignedStyles(ePopup, "left");
            }
            if (x > maxX) {
                x = 0;
                this.setAlignedStyles(ePopup, "right");
            }
        } else {
            x = xRightPosition();
            if (x > maxX) {
                x = xLeftPosition();
                this.setAlignedStyles(ePopup, "right");
            }
            if (x < 0) {
                x = 0;
                this.setAlignedStyles(ePopup, "left");
            }
        }
        ePopup.style.left = `${x}px`;
        ePopup.style.top = `${y}px`;
        function xRightPosition() {
            return sourceRect.right - parentRect.left - 2;
        }
        function xLeftPosition() {
            return sourceRect.left - parentRect.left - minWidth;
        }
    }
    positionPopupUnderMouseEvent(params) {
        const { ePopup, nudgeX, nudgeY, skipObserver } = params;
        this.positionPopup({
            ePopup,
            nudgeX,
            nudgeY,
            keepWithinBounds: true,
            skipObserver,
            updatePosition: ()=>this.calculatePointerAlign(params.mouseEvent),
            postProcessCallback: ()=>this.callPostProcessPopup(params.type, params.ePopup, null, params.mouseEvent, params.column, params.rowNode)
        });
    }
    calculatePointerAlign(e) {
        const parentRect = this.getParentRect();
        return {
            x: e.clientX - parentRect.left,
            y: e.clientY - parentRect.top
        };
    }
    positionPopupByComponent(params) {
        const { ePopup, nudgeX, nudgeY, keepWithinBounds, eventSource, alignSide = "left", position = "over", column, rowNode, type } = params;
        const sourceRect = eventSource.getBoundingClientRect();
        const parentRect = this.getParentRect();
        const popupIdx = this.getPopupIndex(ePopup);
        if (popupIdx !== -1) {
            const popup = this.popupList[popupIdx];
            popup.alignedToElement = eventSource;
        }
        const updatePosition = ()=>{
            let x = sourceRect.left - parentRect.left;
            if (alignSide === "right") x -= ePopup.offsetWidth - sourceRect.width;
            let y;
            if (position === "over") {
                y = sourceRect.top - parentRect.top;
                this.setAlignedStyles(ePopup, "over");
            } else {
                this.setAlignedStyles(ePopup, "under");
                const alignSide2 = this.shouldRenderUnderOrAbove(ePopup, sourceRect, parentRect, params.nudgeY || 0);
                if (alignSide2 === "under") y = sourceRect.top - parentRect.top + sourceRect.height;
                else y = sourceRect.top - ePopup.offsetHeight - (nudgeY || 0) * 2 - parentRect.top;
            }
            return {
                x,
                y
            };
        };
        this.positionPopup({
            ePopup,
            nudgeX,
            nudgeY,
            keepWithinBounds,
            updatePosition,
            postProcessCallback: ()=>this.callPostProcessPopup(type, ePopup, eventSource, null, column, rowNode)
        });
    }
    shouldRenderUnderOrAbove(ePopup, targetCompRect, parentRect, nudgeY) {
        const spaceAvailableUnder = parentRect.bottom - targetCompRect.bottom;
        const spaceAvailableAbove = targetCompRect.top - parentRect.top;
        const spaceRequired = ePopup.offsetHeight + nudgeY;
        if (spaceAvailableUnder > spaceRequired) return "under";
        if (spaceAvailableAbove > spaceRequired || spaceAvailableAbove > spaceAvailableUnder) return "above";
        return "under";
    }
    setAlignedStyles(ePopup, positioned) {
        const popupIdx = this.getPopupIndex(ePopup);
        if (popupIdx === -1) return;
        const popup = this.popupList[popupIdx];
        const { alignedToElement } = popup;
        if (!alignedToElement) return;
        const positions = [
            "right",
            "left",
            "over",
            "above",
            "under"
        ];
        positions.forEach((position)=>{
            alignedToElement.classList.remove(`ag-has-popup-positioned-${position}`);
            ePopup.classList.remove(`ag-popup-positioned-${position}`);
        });
        if (!positioned) return;
        alignedToElement.classList.add(`ag-has-popup-positioned-${positioned}`);
        ePopup.classList.add(`ag-popup-positioned-${positioned}`);
    }
    callPostProcessPopup(type, ePopup, eventSource, mouseEvent, column, rowNode) {
        const callback = this.gos.getCallback("postProcessPopup");
        if (callback) {
            const params = {
                column,
                rowNode,
                ePopup,
                type,
                eventSource,
                mouseEvent
            };
            callback(params);
        }
    }
    positionPopup(params) {
        const { ePopup, keepWithinBounds, nudgeX, nudgeY, skipObserver, updatePosition } = params;
        const lastSize = {
            width: 0,
            height: 0
        };
        const updatePopupPosition = (fromResizeObserver = false)=>{
            let { x, y } = updatePosition();
            if (fromResizeObserver && ePopup.clientWidth === lastSize.width && ePopup.clientHeight === lastSize.height) return;
            lastSize.width = ePopup.clientWidth;
            lastSize.height = ePopup.clientHeight;
            if (nudgeX) x += nudgeX;
            if (nudgeY) y += nudgeY;
            if (keepWithinBounds) {
                x = this.keepXYWithinBounds(ePopup, x, 1 /* horizontal */ );
                y = this.keepXYWithinBounds(ePopup, y, 0 /* vertical */ );
            }
            ePopup.style.left = `${x}px`;
            ePopup.style.top = `${y}px`;
            if (params.postProcessCallback) params.postProcessCallback();
        };
        updatePopupPosition();
        if (!skipObserver) {
            const resizeObserverDestroyFunc = this.resizeObserverService.observeResize(ePopup, ()=>updatePopupPosition(true));
            setTimeout(()=>resizeObserverDestroyFunc(), PopupService.WAIT_FOR_POPUP_CONTENT_RESIZE);
        }
    }
    getActivePopups() {
        return this.popupList.map((popup)=>popup.element);
    }
    getPopupList() {
        return this.popupList;
    }
    getParentRect() {
        const eDocument = this.gos.getDocument();
        let popupParent = this.getPopupParent();
        if (popupParent === eDocument.body) popupParent = eDocument.documentElement;
        else if (getComputedStyle(popupParent).position === "static") popupParent = popupParent.offsetParent;
        return getElementRectWithOffset(popupParent);
    }
    keepXYWithinBounds(ePopup, position, direction) {
        const isVertical = direction === 0 /* vertical */ ;
        const sizeProperty = isVertical ? "clientHeight" : "clientWidth";
        const anchorProperty = isVertical ? "top" : "left";
        const offsetProperty = isVertical ? "offsetHeight" : "offsetWidth";
        const scrollPositionProperty = isVertical ? "scrollTop" : "scrollLeft";
        const eDocument = this.gos.getDocument();
        const docElement = eDocument.documentElement;
        const popupParent = this.getPopupParent();
        const parentRect = popupParent.getBoundingClientRect();
        const documentRect = eDocument.documentElement.getBoundingClientRect();
        const isBody = popupParent === eDocument.body;
        const offsetSize = ePopup[offsetProperty];
        const getSize = isVertical ? getAbsoluteHeight : getAbsoluteWidth;
        let sizeOfParent = isBody ? getSize(docElement) + docElement[scrollPositionProperty] : popupParent[sizeProperty];
        if (isBody) sizeOfParent -= Math.abs(documentRect[anchorProperty] - parentRect[anchorProperty]);
        const max = sizeOfParent - offsetSize;
        return Math.min(Math.max(position, 0), Math.abs(max));
    }
    addPopup(params) {
        const eDocument = this.gos.getDocument();
        const { eChild, ariaLabel, alwaysOnTop, positionCallback, anchorToElement } = params;
        if (!eDocument) {
            console.warn("AG Grid: could not find the document, document is empty");
            return {
                hideFunc: ()=>{}
            };
        }
        const pos = this.getPopupIndex(eChild);
        if (pos !== -1) {
            const popup = this.popupList[pos];
            return {
                hideFunc: popup.hideFunc
            };
        }
        this.initialisePopupPosition(eChild);
        const wrapperEl = this.createPopupWrapper(eChild, ariaLabel, !!alwaysOnTop);
        const removeListeners = this.addEventListenersToPopup(__spreadProps(__spreadValues({}, params), {
            wrapperEl
        }));
        if (positionCallback) positionCallback();
        this.addPopupToPopupList(eChild, wrapperEl, removeListeners, anchorToElement);
        return {
            hideFunc: removeListeners
        };
    }
    initialisePopupPosition(element) {
        const ePopupParent = this.getPopupParent();
        const ePopupParentRect = ePopupParent.getBoundingClientRect();
        if (!exists(element.style.top)) element.style.top = `${ePopupParentRect.top * -1}px`;
        if (!exists(element.style.left)) element.style.left = `${ePopupParentRect.left * -1}px`;
    }
    createPopupWrapper(element, ariaLabel, alwaysOnTop) {
        const ePopupParent = this.getPopupParent();
        const eWrapper = document.createElement("div");
        const { allThemes } = this.environment.getTheme();
        if (allThemes.length) eWrapper.classList.add(...allThemes);
        eWrapper.classList.add("ag-popup");
        element.classList.add(this.gos.get("enableRtl") ? "ag-rtl" : "ag-ltr", "ag-popup-child");
        if (!element.hasAttribute("role")) setAriaRole(element, "dialog");
        setAriaLabel(element, ariaLabel);
        eWrapper.appendChild(element);
        ePopupParent.appendChild(eWrapper);
        if (alwaysOnTop) this.setAlwaysOnTop(element, true);
        else this.bringPopupToFront(element);
        return eWrapper;
    }
    handleThemeChange() {
        const { allThemes } = this.environment.getTheme();
        for (const popup of this.popupList){
            for (const className of Array.from(popup.wrapper.classList))if (className.startsWith("ag-theme-")) popup.wrapper.classList.remove(className);
            if (allThemes.length) popup.wrapper.classList.add(...allThemes);
        }
    }
    addEventListenersToPopup(params) {
        const eDocument = this.gos.getDocument();
        const ePopupParent = this.getPopupParent();
        const { wrapperEl, eChild: popupEl, closedCallback, afterGuiAttached, closeOnEsc, modal } = params;
        let popupHidden = false;
        const hidePopupOnKeyboardEvent = (event)=>{
            if (!wrapperEl.contains(this.gos.getActiveDomElement())) return;
            const key = event.key;
            if (key === KeyCode.ESCAPE && !isStopPropagationForAgGrid(event)) removeListeners({
                keyboardEvent: event
            });
        };
        const hidePopupOnMouseEvent = (event)=>removeListeners({
                mouseEvent: event
            });
        const hidePopupOnTouchEvent = (event)=>removeListeners({
                touchEvent: event
            });
        const removeListeners = (popupParams = {})=>{
            const { mouseEvent, touchEvent, keyboardEvent, forceHide } = popupParams;
            if (!forceHide && // we don't hide popup if the event was on the child, or any
            // children of this child
            (this.isEventFromCurrentPopup({
                mouseEvent,
                touchEvent
            }, popupEl) || // this method should only be called once. the client can have different
            // paths, each one wanting to close, so this method may be called multiple times.
            popupHidden)) return;
            popupHidden = true;
            ePopupParent.removeChild(wrapperEl);
            eDocument.removeEventListener("keydown", hidePopupOnKeyboardEvent);
            eDocument.removeEventListener("mousedown", hidePopupOnMouseEvent);
            eDocument.removeEventListener("touchstart", hidePopupOnTouchEvent);
            eDocument.removeEventListener("contextmenu", hidePopupOnMouseEvent);
            this.eventService.removeEventListener(Events.EVENT_DRAG_STARTED, hidePopupOnMouseEvent);
            if (closedCallback) closedCallback(mouseEvent || touchEvent || keyboardEvent);
            this.removePopupFromPopupList(popupEl);
        };
        if (afterGuiAttached) afterGuiAttached({
            hidePopup: removeListeners
        });
        window.setTimeout(()=>{
            if (closeOnEsc) eDocument.addEventListener("keydown", hidePopupOnKeyboardEvent);
            if (modal) {
                eDocument.addEventListener("mousedown", hidePopupOnMouseEvent);
                this.eventService.addEventListener(Events.EVENT_DRAG_STARTED, hidePopupOnMouseEvent);
                eDocument.addEventListener("touchstart", hidePopupOnTouchEvent);
                eDocument.addEventListener("contextmenu", hidePopupOnMouseEvent);
            }
        }, 0);
        return removeListeners;
    }
    addPopupToPopupList(element, wrapperEl, removeListeners, anchorToElement) {
        this.popupList.push({
            element,
            wrapper: wrapperEl,
            hideFunc: removeListeners,
            instanceId: instanceIdSeq++,
            isAnchored: !!anchorToElement
        });
        if (anchorToElement) this.setPopupPositionRelatedToElement(element, anchorToElement);
    }
    getPopupIndex(el) {
        return this.popupList.findIndex((p)=>p.element === el);
    }
    setPopupPositionRelatedToElement(popupEl, relativeElement) {
        const popupIndex = this.getPopupIndex(popupEl);
        if (popupIndex === -1) return;
        const popup = this.popupList[popupIndex];
        if (popup.stopAnchoringPromise) popup.stopAnchoringPromise.then((destroyFunc)=>destroyFunc && destroyFunc());
        popup.stopAnchoringPromise = void 0;
        popup.isAnchored = false;
        if (!relativeElement) return;
        const destroyPositionTracker = this.keepPopupPositionedRelativeTo({
            element: relativeElement,
            ePopup: popupEl,
            hidePopup: popup.hideFunc
        });
        popup.stopAnchoringPromise = destroyPositionTracker;
        popup.isAnchored = true;
        return destroyPositionTracker;
    }
    removePopupFromPopupList(element) {
        this.setAlignedStyles(element, null);
        this.setPopupPositionRelatedToElement(element, null);
        this.popupList = this.popupList.filter((p)=>p.element !== element);
    }
    keepPopupPositionedRelativeTo(params) {
        const eParent = this.getPopupParent();
        const parentRect = eParent.getBoundingClientRect();
        const { element, ePopup } = params;
        const sourceRect = element.getBoundingClientRect();
        const initialDiffTop = parentRect.top - sourceRect.top;
        const initialDiffLeft = parentRect.left - sourceRect.left;
        let lastDiffTop = initialDiffTop;
        let lastDiffLeft = initialDiffLeft;
        const topPx = ePopup.style.top;
        const top = parseInt(topPx.substring(0, topPx.length - 1), 10);
        const leftPx = ePopup.style.left;
        const left = parseInt(leftPx.substring(0, leftPx.length - 1), 10);
        return new AgPromise((resolve)=>{
            this.getFrameworkOverrides().setInterval(()=>{
                const pRect = eParent.getBoundingClientRect();
                const sRect = element.getBoundingClientRect();
                const elementNotInDom = sRect.top == 0 && sRect.left == 0 && sRect.height == 0 && sRect.width == 0;
                if (elementNotInDom) {
                    params.hidePopup();
                    return;
                }
                const currentDiffTop = pRect.top - sRect.top;
                if (currentDiffTop != lastDiffTop) {
                    const newTop = this.keepXYWithinBounds(ePopup, top + initialDiffTop - currentDiffTop, 0 /* vertical */ );
                    ePopup.style.top = `${newTop}px`;
                }
                lastDiffTop = currentDiffTop;
                const currentDiffLeft = pRect.left - sRect.left;
                if (currentDiffLeft != lastDiffLeft) {
                    const newLeft = this.keepXYWithinBounds(ePopup, left + initialDiffLeft - currentDiffLeft, 1 /* horizontal */ );
                    ePopup.style.left = `${newLeft}px`;
                }
                lastDiffLeft = currentDiffLeft;
            }, 200).then((intervalId)=>{
                const result = ()=>{
                    if (intervalId != null) window.clearInterval(intervalId);
                };
                resolve(result);
            });
        });
    }
    hasAnchoredPopup() {
        return this.popupList.some((popup)=>popup.isAnchored);
    }
    isEventFromCurrentPopup(params, target) {
        const { mouseEvent, touchEvent } = params;
        const event = mouseEvent ? mouseEvent : touchEvent;
        if (!event) return false;
        const indexOfThisChild = this.getPopupIndex(target);
        if (indexOfThisChild === -1) return false;
        for(let i = indexOfThisChild; i < this.popupList.length; i++){
            const popup = this.popupList[i];
            if (isElementInEventPath(popup.element, event)) return true;
        }
        return this.isElementWithinCustomPopup(event.target);
    }
    isElementWithinCustomPopup(el) {
        const eDocument = this.gos.getDocument();
        while(el && el !== eDocument.body){
            if (el.classList.contains("ag-custom-component-popup") || el.parentElement === null) return true;
            el = el.parentElement;
        }
        return false;
    }
    getWrapper(ePopup) {
        while(!ePopup.classList.contains("ag-popup") && ePopup.parentElement)ePopup = ePopup.parentElement;
        return ePopup.classList.contains("ag-popup") ? ePopup : null;
    }
    setAlwaysOnTop(ePopup, alwaysOnTop) {
        const eWrapper = this.getWrapper(ePopup);
        if (!eWrapper) return;
        eWrapper.classList.toggle("ag-always-on-top", !!alwaysOnTop);
        if (alwaysOnTop) this.bringPopupToFront(eWrapper);
    }
    bringPopupToFront(ePopup) {
        const parent = this.getPopupParent();
        const popupList = Array.prototype.slice.call(parent.querySelectorAll(".ag-popup"));
        const popupLen = popupList.length;
        const alwaysOnTopList = Array.prototype.slice.call(parent.querySelectorAll(".ag-popup.ag-always-on-top"));
        const onTopLength = alwaysOnTopList.length;
        const eWrapper = this.getWrapper(ePopup);
        if (!eWrapper || popupLen <= 1 || !parent.contains(ePopup)) return;
        const pos = popupList.indexOf(eWrapper);
        const innerEls = eWrapper.querySelectorAll("div");
        const innerElsScrollMap = [];
        innerEls.forEach((el)=>{
            if (el.scrollTop !== 0) innerElsScrollMap.push([
                el,
                el.scrollTop
            ]);
        });
        if (onTopLength) {
            const isPopupAlwaysOnTop = eWrapper.classList.contains("ag-always-on-top");
            if (isPopupAlwaysOnTop) {
                if (pos !== popupLen - 1) last(alwaysOnTopList).insertAdjacentElement("afterend", eWrapper);
            } else if (pos !== popupLen - onTopLength - 1) alwaysOnTopList[0].insertAdjacentElement("beforebegin", eWrapper);
        } else if (pos !== popupLen - 1) last(popupList).insertAdjacentElement("afterend", eWrapper);
        while(innerElsScrollMap.length){
            const currentEl = innerElsScrollMap.pop();
            currentEl[0].scrollTop = currentEl[1];
        }
    }
};
PopupService.WAIT_FOR_POPUP_CONTENT_RESIZE = 200;
__decorateClass([
    Autowired("focusService")
], PopupService.prototype, "focusService", 2);
__decorateClass([
    Autowired("ctrlsService")
], PopupService.prototype, "ctrlsService", 2);
__decorateClass([
    Autowired("resizeObserverService")
], PopupService.prototype, "resizeObserverService", 2);
__decorateClass([
    PostConstruct
], PopupService.prototype, "postConstruct", 1);
PopupService = __decorateClass([
    Bean("popupService")
], PopupService);
// community-modules/core/src/widgets/agAutocompleteRow.ts
var AgAutocompleteRow = class extends Component {
    constructor(){
        super(/* html */ `
        <div class="ag-autocomplete-row" role="presentation">
            <div class="ag-autocomplete-row-label"></div>
        </div>`);
        this.hasHighlighting = false;
    }
    setState(value, selected) {
        this.value = value;
        this.render();
        this.updateSelected(selected);
    }
    updateSelected(selected) {
        this.addOrRemoveCssClass("ag-autocomplete-row-selected", selected);
    }
    setSearchString(searchString) {
        var _a;
        let keepHighlighting = false;
        if (exists(searchString)) {
            const index = (_a = this.value) == null ? void 0 : _a.toLocaleLowerCase().indexOf(searchString.toLocaleLowerCase());
            if (index >= 0) {
                keepHighlighting = true;
                this.hasHighlighting = true;
                const highlightEndIndex = index + searchString.length;
                const startPart = escapeString(this.value.slice(0, index));
                const highlightedPart = escapeString(this.value.slice(index, highlightEndIndex));
                const endPart = escapeString(this.value.slice(highlightEndIndex));
                this.getGui().lastElementChild.innerHTML = `${startPart}<b>${highlightedPart}</b>${endPart}`;
            }
        }
        if (!keepHighlighting && this.hasHighlighting) {
            this.hasHighlighting = false;
            this.render();
        }
    }
    render() {
        var _a;
        this.getGui().lastElementChild.innerHTML = (_a = escapeString(this.value)) != null ? _a : "&nbsp;";
    }
};
// community-modules/core/src/widgets/agAutocompleteList.ts
var _AgAutocompleteList = class _AgAutocompleteList extends PopupComponent {
    constructor(params){
        super(_AgAutocompleteList.TEMPLATE);
        this.params = params;
        this.searchString = "";
    }
    destroy() {
        super.destroy();
    }
    init() {
        this.autocompleteEntries = this.params.autocompleteEntries;
        this.virtualList = this.createManagedBean(new VirtualList({
            cssIdentifier: "autocomplete"
        }));
        this.virtualList.setComponentCreator(this.createRowComponent.bind(this));
        this.eList.appendChild(this.virtualList.getGui());
        this.virtualList.setModel({
            getRowCount: ()=>this.autocompleteEntries.length,
            getRow: (index)=>this.autocompleteEntries[index]
        });
        const virtualListGui = this.virtualList.getGui();
        this.addManagedListener(virtualListGui, "click", ()=>this.params.onConfirmed());
        this.addManagedListener(virtualListGui, "mousemove", this.onMouseMove.bind(this));
        this.addManagedListener(virtualListGui, "mousedown", (e)=>e.preventDefault());
        this.setSelectedValue(0);
    }
    onNavigationKeyDown(event, key) {
        event.preventDefault();
        const oldIndex = this.autocompleteEntries.indexOf(this.selectedValue);
        const newIndex = key === KeyCode.UP ? oldIndex - 1 : oldIndex + 1;
        this.checkSetSelectedValue(newIndex);
    }
    setSearch(searchString) {
        this.searchString = searchString;
        if (exists(searchString)) this.runSearch();
        else {
            this.autocompleteEntries = this.params.autocompleteEntries;
            this.virtualList.refresh();
            this.checkSetSelectedValue(0);
        }
        this.updateSearchInList();
    }
    runContainsSearch(searchString, searchStrings) {
        let topMatch;
        let topMatchStartsWithSearchString = false;
        const lowerCaseSearchString = searchString.toLocaleLowerCase();
        const allMatches = searchStrings.filter((string)=>{
            const lowerCaseString = string.toLocaleLowerCase();
            const index = lowerCaseString.indexOf(lowerCaseSearchString);
            const startsWithSearchString = index === 0;
            const isMatch = index >= 0;
            if (isMatch && (!topMatch || !topMatchStartsWithSearchString && startsWithSearchString || topMatchStartsWithSearchString === startsWithSearchString && string.length < topMatch.length)) {
                topMatch = string;
                topMatchStartsWithSearchString = startsWithSearchString;
            }
            return isMatch;
        });
        if (!topMatch && allMatches.length) topMatch = allMatches[0];
        return {
            topMatch,
            allMatches
        };
    }
    runSearch() {
        var _a, _b;
        const { autocompleteEntries } = this.params;
        const searchStrings = autocompleteEntries.map((v)=>{
            var _a2;
            return (_a2 = v.displayValue) != null ? _a2 : v.key;
        });
        let matchingStrings;
        let topSuggestion;
        if (this.params.useFuzzySearch) {
            matchingStrings = fuzzySuggestions(this.searchString, searchStrings, true).values;
            topSuggestion = matchingStrings.length ? matchingStrings[0] : void 0;
        } else {
            const containsMatches = this.runContainsSearch(this.searchString, searchStrings);
            matchingStrings = containsMatches.allMatches;
            topSuggestion = containsMatches.topMatch;
        }
        let filteredEntries = autocompleteEntries.filter(({ key, displayValue })=>matchingStrings.includes(displayValue != null ? displayValue : key));
        if (!filteredEntries.length && this.selectedValue && ((_b = (_a = this.params) == null ? void 0 : _a.forceLastSelection) == null ? void 0 : _b.call(_a, this.selectedValue, this.searchString))) filteredEntries = [
            this.selectedValue
        ];
        this.autocompleteEntries = filteredEntries;
        this.virtualList.refresh();
        if (!topSuggestion) return;
        const topSuggestionIndex = matchingStrings.indexOf(topSuggestion);
        this.checkSetSelectedValue(topSuggestionIndex);
    }
    updateSearchInList() {
        this.virtualList.forEachRenderedRow((row)=>row.setSearchString(this.searchString));
    }
    checkSetSelectedValue(index) {
        if (index >= 0 && index < this.autocompleteEntries.length) this.setSelectedValue(index);
    }
    setSelectedValue(index) {
        const value = this.autocompleteEntries[index];
        if (this.selectedValue === value) return;
        this.selectedValue = value;
        this.virtualList.ensureIndexVisible(index);
        this.virtualList.forEachRenderedRow((cmp, idx)=>{
            cmp.updateSelected(index === idx);
        });
    }
    createRowComponent(value) {
        var _a;
        const row = new AgAutocompleteRow();
        this.getContext().createBean(row);
        row.setState((_a = value.displayValue) != null ? _a : value.key, value === this.selectedValue);
        return row;
    }
    onMouseMove(mouseEvent) {
        const rect = this.virtualList.getGui().getBoundingClientRect();
        const scrollTop = this.virtualList.getScrollTop();
        const mouseY = mouseEvent.clientY - rect.top + scrollTop;
        const row = Math.floor(mouseY / this.virtualList.getRowHeight());
        this.checkSetSelectedValue(row);
    }
    afterGuiAttached() {
        this.virtualList.refresh();
    }
    getSelectedValue() {
        var _a;
        if (!this.autocompleteEntries.length) return null;
        return (_a = this.selectedValue) != null ? _a : null;
    }
};
_AgAutocompleteList.TEMPLATE = /* html */ `<div class="ag-autocomplete-list-popup">
            <div ref="eList" class="ag-autocomplete-list"></div>
        <div>`;
__decorateClass([
    RefSelector("eList")
], _AgAutocompleteList.prototype, "eList", 2);
__decorateClass([
    PostConstruct
], _AgAutocompleteList.prototype, "init", 1);
var AgAutocompleteList = _AgAutocompleteList;
// community-modules/core/src/widgets/agAutocomplete.ts
var _AgAutocomplete = class _AgAutocomplete extends Component {
    constructor(){
        super(/* html */ `
            <div class="ag-autocomplete" role="presentation">
                <ag-input-text-field ref="eAutocompleteInput"></ag-input-text-field>
            </div>`);
        this.isListOpen = false;
        this.lastPosition = 0;
        this.valid = true;
    }
    postConstruct() {
        this.eAutocompleteInput.onValueChange((value)=>this.onValueChanged(value));
        this.eAutocompleteInput.getInputElement().setAttribute("autocomplete", "off");
        this.addGuiEventListener("keydown", this.onKeyDown.bind(this));
        this.addGuiEventListener("click", this.updatePositionAndList.bind(this));
        this.addDestroyFunc(()=>{
            this.destroyBean(this.autocompleteList);
        });
        this.addGuiEventListener("focusout", ()=>this.onFocusOut());
    }
    onValueChanged(value) {
        const parsedValue = makeNull(value);
        this.updateValue(parsedValue);
        this.updateAutocompleteList(parsedValue);
    }
    updateValue(value) {
        this.updateLastPosition();
        this.dispatchEvent({
            type: _AgAutocomplete.EVENT_VALUE_CHANGED,
            value
        });
        this.validate(value);
    }
    updateAutocompleteList(value) {
        var _a, _b, _c, _d;
        const autocompleteListParams = (_b = (_a = this.listGenerator) == null ? void 0 : _a.call(this, value, this.lastPosition)) != null ? _b : {
            enabled: false
        };
        if (!autocompleteListParams.type || autocompleteListParams.type !== ((_c = this.autocompleteListParams) == null ? void 0 : _c.type)) {
            if (this.isListOpen) this.closeList();
        }
        this.autocompleteListParams = autocompleteListParams;
        if ((_d = this.autocompleteListParams) == null ? void 0 : _d.enabled) {
            if (!this.isListOpen) this.openList();
            const { searchString } = this.autocompleteListParams;
            this.autocompleteList.setSearch(searchString != null ? searchString : "");
        } else if (this.isListOpen) this.closeList();
    }
    onKeyDown(event) {
        const key = event.key;
        this.updateLastPosition();
        switch(key){
            case KeyCode.ENTER:
                this.onEnterKeyDown(event);
                break;
            case KeyCode.TAB:
                this.onTabKeyDown(event);
                break;
            case KeyCode.DOWN:
            case KeyCode.UP:
                this.onUpDownKeyDown(event, key);
                break;
            case KeyCode.LEFT:
            case KeyCode.RIGHT:
            case KeyCode.PAGE_HOME:
            case KeyCode.PAGE_END:
                setTimeout(()=>{
                    this.updatePositionAndList();
                });
                break;
            case KeyCode.ESCAPE:
                this.onEscapeKeyDown(event);
                break;
            case KeyCode.SPACE:
                if (event.ctrlKey && !this.isListOpen) {
                    event.preventDefault();
                    this.forceOpenList();
                }
                break;
        }
    }
    confirmSelection() {
        var _a;
        const selectedValue = (_a = this.autocompleteList) == null ? void 0 : _a.getSelectedValue();
        if (selectedValue) {
            this.closeList();
            this.dispatchEvent({
                type: _AgAutocomplete.EVENT_OPTION_SELECTED,
                value: this.getValue(),
                position: this.lastPosition,
                updateEntry: selectedValue,
                autocompleteType: this.autocompleteListParams.type
            });
        }
    }
    onTabKeyDown(event) {
        if (this.isListOpen) {
            event.preventDefault();
            event.stopPropagation();
            this.confirmSelection();
        }
    }
    onEnterKeyDown(event) {
        event.preventDefault();
        if (this.isListOpen) this.confirmSelection();
        else this.onCompleted();
    }
    onUpDownKeyDown(event, key) {
        var _a;
        event.preventDefault();
        if (!this.isListOpen) this.forceOpenList();
        else (_a = this.autocompleteList) == null || _a.onNavigationKeyDown(event, key);
    }
    onEscapeKeyDown(event) {
        if (this.isListOpen) {
            event.preventDefault();
            event.stopPropagation();
            this.closeList();
            this.setCaret(this.lastPosition, true);
        }
    }
    onFocusOut() {
        if (this.isListOpen) this.closeList();
    }
    updatePositionAndList() {
        var _a;
        this.updateLastPosition();
        this.updateAutocompleteList((_a = this.eAutocompleteInput.getValue()) != null ? _a : null);
    }
    setCaret(position, setFocus) {
        const eDocument = this.gos.getDocument();
        const activeEl = this.gos.getActiveDomElement();
        if (setFocus && (!activeEl || activeEl === eDocument.body)) this.eAutocompleteInput.getFocusableElement().focus();
        const eInput = this.eAutocompleteInput.getInputElement();
        eInput.setSelectionRange(position, position);
        if (position === eInput.value.length) eInput.scrollLeft = eInput.scrollWidth;
    }
    forceOpenList() {
        this.onValueChanged(this.eAutocompleteInput.getValue());
    }
    updateLastPosition() {
        var _a;
        this.lastPosition = (_a = this.eAutocompleteInput.getInputElement().selectionStart) != null ? _a : 0;
    }
    validate(value) {
        var _a;
        if (!this.validator) return;
        this.validationMessage = this.validator(value);
        this.eAutocompleteInput.getInputElement().setCustomValidity((_a = this.validationMessage) != null ? _a : "");
        this.valid = !this.validationMessage;
        this.dispatchEvent({
            type: _AgAutocomplete.EVENT_VALID_CHANGED,
            isValid: this.valid,
            validationMessage: this.validationMessage
        });
    }
    openList() {
        this.isListOpen = true;
        this.autocompleteList = this.createBean(new AgAutocompleteList({
            autocompleteEntries: this.autocompleteListParams.entries,
            onConfirmed: ()=>this.confirmSelection(),
            forceLastSelection: this.forceLastSelection
        }));
        const ePopupGui = this.autocompleteList.getGui();
        const positionParams = {
            ePopup: ePopupGui,
            type: "autocomplete",
            eventSource: this.getGui(),
            position: "under",
            alignSide: this.gos.get("enableRtl") ? "right" : "left",
            keepWithinBounds: true
        };
        const addPopupRes = this.popupService.addPopup({
            eChild: ePopupGui,
            anchorToElement: this.getGui(),
            positionCallback: ()=>this.popupService.positionPopupByComponent(positionParams),
            ariaLabel: this.listAriaLabel
        });
        this.hidePopup = addPopupRes.hideFunc;
        this.autocompleteList.afterGuiAttached();
    }
    closeList() {
        this.isListOpen = false;
        this.hidePopup();
        this.destroyBean(this.autocompleteList);
        this.autocompleteList = null;
    }
    onCompleted() {
        if (this.isListOpen) this.closeList();
        this.dispatchEvent({
            type: _AgAutocomplete.EVENT_VALUE_CONFIRMED,
            value: this.getValue(),
            isValid: this.isValid()
        });
    }
    getValue() {
        return makeNull(this.eAutocompleteInput.getValue());
    }
    setInputPlaceholder(placeholder) {
        this.eAutocompleteInput.setInputPlaceholder(placeholder);
        return this;
    }
    setInputAriaLabel(label) {
        this.eAutocompleteInput.setInputAriaLabel(label);
        return this;
    }
    setListAriaLabel(label) {
        this.listAriaLabel = label;
        return this;
    }
    setListGenerator(listGenerator) {
        this.listGenerator = listGenerator;
        return this;
    }
    setValidator(validator) {
        this.validator = validator;
        return this;
    }
    isValid() {
        return this.valid;
    }
    setValue(params) {
        const { value, position, silent, updateListOnlyIfOpen, restoreFocus } = params;
        this.eAutocompleteInput.setValue(value, true);
        this.setCaret(position != null ? position : this.lastPosition, restoreFocus);
        if (!silent) this.updateValue(value);
        if (!updateListOnlyIfOpen || this.isListOpen) this.updateAutocompleteList(value);
    }
    setForceLastSelection(forceLastSelection) {
        this.forceLastSelection = forceLastSelection;
        return this;
    }
    setInputDisabled(disabled) {
        this.eAutocompleteInput.setDisabled(disabled);
        return this;
    }
};
_AgAutocomplete.EVENT_VALUE_CHANGED = "eventValueChanged";
_AgAutocomplete.EVENT_VALUE_CONFIRMED = "eventValueConfirmed";
_AgAutocomplete.EVENT_OPTION_SELECTED = "eventOptionSelected";
_AgAutocomplete.EVENT_VALID_CHANGED = "eventValidChanged";
__decorateClass([
    Autowired("popupService")
], _AgAutocomplete.prototype, "popupService", 2);
__decorateClass([
    RefSelector("eAutocompleteInput")
], _AgAutocomplete.prototype, "eAutocompleteInput", 2);
__decorateClass([
    PostConstruct
], _AgAutocomplete.prototype, "postConstruct", 1);
var AgAutocomplete = _AgAutocomplete;
// community-modules/core/src/widgets/pillDragComp.ts
var _PillDragComp = class _PillDragComp extends Component {
    constructor(dragSourceDropTarget, ghost, horizontal, template){
        super();
        this.dragSourceDropTarget = dragSourceDropTarget;
        this.ghost = ghost;
        this.horizontal = horizontal;
        this.template = template;
    }
    init() {
        var _a;
        this.setTemplate((_a = this.template) != null ? _a : _PillDragComp.TEMPLATE);
        const eGui = this.getGui();
        this.addElementClasses(eGui);
        this.addElementClasses(this.eDragHandle, "drag-handle");
        this.addElementClasses(this.eText, "text");
        this.addElementClasses(this.eButton, "button");
        this.eDragHandle.appendChild(createIconNoSpan("columnDrag", this.gos));
        this.eButton.appendChild(createIconNoSpan("cancel", this.gos));
        this.setupComponents();
        if (!this.ghost && this.isDraggable()) this.addDragSource();
        this.setupAria();
        this.setupTooltip();
        this.activateTabIndex();
        this.refreshDraggable();
    }
    isDraggable() {
        return true;
    }
    refreshDraggable() {
        this.eDragHandle.classList.toggle("ag-column-select-column-readonly", !this.isDraggable());
    }
    setupAria() {
        const translate = this.localeService.getLocaleTextFunc();
        const ariaInstructions = [
            this.getAriaDisplayName()
        ];
        this.addAdditionalAriaInstructions(ariaInstructions, translate);
        setAriaLabel(this.getGui(), ariaInstructions.join(". "));
    }
    addAdditionalAriaInstructions(ariaInstructions, translate) {
        if (this.isRemovable()) {
            const deleteAria = translate("ariaDropZoneColumnComponentDescription", "Press DELETE to remove");
            ariaInstructions.push(deleteAria);
        }
    }
    setupTooltip() {
        const refresh = ()=>{
            const newTooltipText = this.getTooltip();
            this.setTooltip({
                newTooltipText
            });
        };
        refresh();
        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, refresh);
    }
    getDragSourceId() {
        return void 0;
    }
    getDefaultIconName() {
        return DragAndDropService.ICON_NOT_ALLOWED;
    }
    addDragSource() {
        const { dragAndDropService, eDragHandle } = this;
        const getDragItem = this.createGetDragItem();
        const defaultIconName = this.getDefaultIconName();
        const dragSource = {
            type: this.getDragSourceType(),
            sourceId: this.getDragSourceId(),
            eElement: eDragHandle,
            getDefaultIconName: ()=>defaultIconName,
            getDragItem,
            dragItemName: this.getDisplayName()
        };
        dragAndDropService.addDragSource(dragSource, true);
        this.addDestroyFunc(()=>dragAndDropService.removeDragSource(dragSource));
    }
    setupComponents() {
        this.setTextValue();
        this.setupRemove();
        if (this.ghost) this.addCssClass("ag-column-drop-cell-ghost");
    }
    isRemovable() {
        return true;
    }
    refreshRemove() {
        setDisplayed(this.eButton, this.isRemovable());
    }
    setupRemove() {
        this.refreshRemove();
        const agEvent = {
            type: _PillDragComp.EVENT_COLUMN_REMOVE
        };
        this.addGuiEventListener("keydown", (e)=>this.onKeyDown(e));
        this.addManagedListener(this.eButton, "click", (mouseEvent)=>{
            this.dispatchEvent(agEvent);
            mouseEvent.stopPropagation();
        });
        const touchListener = new TouchListener(this.eButton);
        this.addManagedListener(touchListener, TouchListener.EVENT_TAP, ()=>{
            this.dispatchEvent(agEvent);
        });
        this.addDestroyFunc(touchListener.destroy.bind(touchListener));
    }
    onKeyDown(e) {
        const isDelete = e.key === KeyCode.DELETE;
        if (isDelete) {
            if (this.isRemovable()) {
                e.preventDefault();
                this.dispatchEvent({
                    type: _PillDragComp.EVENT_COLUMN_REMOVE
                });
            }
        }
    }
    getDisplayValue() {
        return this.getDisplayName();
    }
    setTextValue() {
        const displayValue = this.getDisplayValue();
        const displayValueSanitised = escapeString(displayValue);
        this.eText.innerHTML = displayValueSanitised;
    }
    addElementClasses(el, suffix) {
        suffix = suffix ? `-${suffix}` : "";
        const direction = this.horizontal ? "horizontal" : "vertical";
        el.classList.add(`ag-column-drop-cell${suffix}`, `ag-column-drop-${direction}-cell${suffix}`);
    }
    destroy() {
        super.destroy();
        this.dragSourceDropTarget = null;
    }
};
_PillDragComp.EVENT_COLUMN_REMOVE = "columnRemove";
_PillDragComp.TEMPLATE = /* html */ `<span role="option">
          <span ref="eDragHandle" class="ag-drag-handle ag-column-drop-cell-drag-handle" role="presentation"></span>
          <span ref="eText" class="ag-column-drop-cell-text" aria-hidden="true"></span>
          <span ref="eButton" class="ag-column-drop-cell-button" role="presentation"></span>
        </span>`;
__decorateClass([
    Autowired("dragAndDropService")
], _PillDragComp.prototype, "dragAndDropService", 2);
__decorateClass([
    RefSelector("eText")
], _PillDragComp.prototype, "eText", 2);
__decorateClass([
    RefSelector("eDragHandle")
], _PillDragComp.prototype, "eDragHandle", 2);
__decorateClass([
    RefSelector("eButton")
], _PillDragComp.prototype, "eButton", 2);
__decorateClass([
    PostConstruct
], _PillDragComp.prototype, "init", 1);
var PillDragComp = _PillDragComp;
// community-modules/core/src/widgets/pillDropZonePanel.ts
var _PillDropZonePanel = class _PillDropZonePanel extends Component {
    constructor(horizontal){
        super(/* html */ `<div class="ag-unselectable" role="presentation"></div>`);
        this.horizontal = horizontal;
        this.state = _PillDropZonePanel.STATE_NOT_DRAGGING;
        this.guiDestroyFunctions = [];
        this.childPillComponents = [];
        this.resizeEnabled = false;
        this.addElementClasses(this.getGui());
        this.ePillDropList = document.createElement("div");
        this.addElementClasses(this.ePillDropList, "list");
        setAriaRole(this.ePillDropList, "listbox");
    }
    isHorizontal() {
        return this.horizontal;
    }
    toggleResizable(resizable) {
        this.positionableFeature.setResizable(resizable ? {
            bottom: true
        } : false);
        this.resizeEnabled = resizable;
    }
    isSourceEventFromTarget(draggingEvent) {
        const { dropZoneTarget, dragSource } = draggingEvent;
        return dropZoneTarget.contains(dragSource.eElement);
    }
    destroy() {
        this.destroyGui();
        super.destroy();
    }
    destroyGui() {
        this.guiDestroyFunctions.forEach((func)=>func());
        this.guiDestroyFunctions.length = 0;
        this.childPillComponents.length = 0;
        clearElement(this.getGui());
        clearElement(this.ePillDropList);
    }
    init(params) {
        this.params = params != null ? params : {};
        this.createManagedBean(new ManagedFocusFeature(this.getFocusableElement(), {
            handleKeyDown: this.handleKeyDown.bind(this)
        }));
        this.setupDropTarget();
        this.positionableFeature = new PositionableFeature(this.getGui(), {
            minHeight: 100
        });
        this.createManagedBean(this.positionableFeature);
        this.refreshGui();
        setAriaLabel(this.ePillDropList, this.getAriaLabel());
    }
    handleKeyDown(e) {
        const isVertical = !this.horizontal;
        let isNext = e.key === KeyCode.DOWN;
        let isPrevious = e.key === KeyCode.UP;
        if (!isVertical) {
            const isRtl = this.gos.get("enableRtl");
            isNext = !isRtl && e.key === KeyCode.RIGHT || isRtl && e.key === KeyCode.LEFT;
            isPrevious = !isRtl && e.key === KeyCode.LEFT || isRtl && e.key === KeyCode.RIGHT;
        }
        if (!isNext && !isPrevious) return;
        const el = this.focusService.findNextFocusableElement(this.getFocusableElement(), false, isPrevious);
        if (el) {
            e.preventDefault();
            el.focus();
        }
    }
    addElementClasses(el, suffix) {
        suffix = suffix ? `-${suffix}` : "";
        const direction = this.horizontal ? "horizontal" : "vertical";
        el.classList.add(`ag-column-drop${suffix}`, `ag-column-drop-${direction}${suffix}`);
    }
    setupDropTarget() {
        this.dropTarget = {
            getContainer: this.getGui.bind(this),
            getIconName: this.getIconName.bind(this),
            onDragging: this.onDragging.bind(this),
            onDragEnter: this.onDragEnter.bind(this),
            onDragLeave: this.onDragLeave.bind(this),
            onDragStop: this.onDragStop.bind(this),
            isInterestedIn: this.isInterestedIn.bind(this)
        };
        this.dragAndDropService.addDropTarget(this.dropTarget);
    }
    minimumAllowedNewInsertIndex() {
        return 0;
    }
    checkInsertIndex(draggingEvent) {
        const newIndex = this.getNewInsertIndex(draggingEvent);
        if (newIndex < 0) return false;
        const minimumAllowedIndex = this.minimumAllowedNewInsertIndex();
        const newAdjustedIndex = Math.max(minimumAllowedIndex, newIndex);
        const changed = newAdjustedIndex !== this.insertIndex;
        if (changed) this.insertIndex = newAdjustedIndex;
        return changed;
    }
    getNewInsertIndex(draggingEvent) {
        const mouseEvent = draggingEvent.event;
        const mouseLocation = this.horizontal ? mouseEvent.clientX : mouseEvent.clientY;
        const boundsList = this.childPillComponents.map((comp)=>comp.getGui().getBoundingClientRect());
        const hoveredIndex = boundsList.findIndex((rect)=>this.horizontal ? rect.right > mouseLocation && rect.left < mouseLocation : rect.top < mouseLocation && rect.bottom > mouseLocation);
        if (hoveredIndex === -1) {
            const enableRtl = this.gos.get("enableRtl");
            const isLast = boundsList.every((rect)=>mouseLocation > (this.horizontal ? rect.right : rect.bottom));
            if (isLast) return enableRtl && this.horizontal ? 0 : this.childPillComponents.length;
            const isFirst = boundsList.every((rect)=>mouseLocation < (this.horizontal ? rect.left : rect.top));
            if (isFirst) return enableRtl && this.horizontal ? this.childPillComponents.length : 0;
            return this.insertIndex;
        }
        if (this.insertIndex <= hoveredIndex) return hoveredIndex + 1;
        return hoveredIndex;
    }
    checkDragStartedBySelf(draggingEvent) {
        if (this.state !== _PillDropZonePanel.STATE_NOT_DRAGGING) return;
        this.state = _PillDropZonePanel.STATE_REARRANGE_ITEMS;
        this.potentialDndItems = this.getItems(draggingEvent.dragSource.getDragItem());
        this.refreshGui();
        this.checkInsertIndex(draggingEvent);
        this.refreshGui();
    }
    onDragging(draggingEvent) {
        this.checkDragStartedBySelf(draggingEvent);
        if (this.checkInsertIndex(draggingEvent)) this.refreshGui();
    }
    handleDragEnterEnd(draggingEvent) {}
    onDragEnter(draggingEvent) {
        const dragItems = this.getItems(draggingEvent.dragSource.getDragItem());
        this.state = _PillDropZonePanel.STATE_NEW_ITEMS_IN;
        const goodDragItems = dragItems.filter((item)=>this.isItemDroppable(item, draggingEvent));
        const alreadyPresent = goodDragItems.every((item)=>this.childPillComponents.map((cmp)=>cmp.getItem()).indexOf(item) !== -1);
        if (goodDragItems.length === 0) return;
        this.potentialDndItems = goodDragItems;
        if (alreadyPresent) {
            this.state = _PillDropZonePanel.STATE_NOT_DRAGGING;
            return;
        }
        this.handleDragEnterEnd(draggingEvent);
        this.checkInsertIndex(draggingEvent);
        this.refreshGui();
    }
    isPotentialDndItems() {
        return existsAndNotEmpty(this.potentialDndItems);
    }
    handleDragLeaveEnd(draggingEvent) {}
    onDragLeave(draggingEvent) {
        if (this.state === _PillDropZonePanel.STATE_REARRANGE_ITEMS) {
            const items = this.getItems(draggingEvent.dragSource.getDragItem());
            this.removeItems(items);
        }
        if (this.isPotentialDndItems()) {
            this.handleDragLeaveEnd(draggingEvent);
            this.potentialDndItems = [];
            this.refreshGui();
        }
        this.state = _PillDropZonePanel.STATE_NOT_DRAGGING;
    }
    refreshOnDragStop() {
        return true;
    }
    onDragStop() {
        if (this.isPotentialDndItems()) {
            let success = false;
            if (this.state === _PillDropZonePanel.STATE_NEW_ITEMS_IN) {
                this.addItems(this.potentialDndItems);
                success = true;
            } else success = this.rearrangeItems(this.potentialDndItems);
            this.potentialDndItems = [];
            if (this.refreshOnDragStop() || !success) this.refreshGui();
        }
        this.state = _PillDropZonePanel.STATE_NOT_DRAGGING;
    }
    removeItems(itemsToRemove) {
        const newItemList = this.getExistingItems().filter((item)=>!includes(itemsToRemove, item));
        this.updateItems(newItemList);
    }
    addItems(itemsToAdd) {
        if (!itemsToAdd) return;
        const newItemList = this.getExistingItems().slice();
        const itemsToAddNoDuplicates = itemsToAdd.filter((item)=>newItemList.indexOf(item) < 0);
        insertArrayIntoArray(newItemList, itemsToAddNoDuplicates, this.insertIndex);
        this.updateItems(newItemList);
    }
    addItem(item) {
        this.insertIndex = this.getExistingItems().length;
        this.addItems([
            item
        ]);
        this.refreshGui();
    }
    rearrangeItems(itemsToAdd) {
        const newItemList = this.getNonGhostItems().slice();
        insertArrayIntoArray(newItemList, itemsToAdd, this.insertIndex);
        if (areEqual(newItemList, this.getExistingItems())) return false;
        this.updateItems(newItemList);
        return true;
    }
    refreshGui() {
        const scrollTop = this.ePillDropList.scrollTop;
        const resizeEnabled = this.resizeEnabled;
        const focusedIndex = this.getFocusedItem();
        let alternateElement = this.focusService.findNextFocusableElement();
        if (!alternateElement) alternateElement = this.focusService.findNextFocusableElement(void 0, false, true);
        this.toggleResizable(false);
        this.destroyGui();
        this.addIconAndTitleToGui();
        this.addEmptyMessageToGui();
        this.addItemsToGui();
        if (!this.isHorizontal()) this.ePillDropList.scrollTop = scrollTop;
        if (resizeEnabled) this.toggleResizable(resizeEnabled);
        if (this.focusService.isKeyboardMode()) this.restoreFocus(focusedIndex, alternateElement);
    }
    getFocusedItem() {
        const eGui = this.getGui();
        const activeElement = this.gos.getActiveDomElement();
        if (!eGui.contains(activeElement)) return -1;
        const items = Array.from(eGui.querySelectorAll(".ag-column-drop-cell"));
        return items.indexOf(activeElement);
    }
    restoreFocus(index, alternateElement) {
        const eGui = this.getGui();
        const items = Array.from(eGui.querySelectorAll(".ag-column-drop-cell"));
        if (index === -1) return;
        if (items.length === 0) alternateElement.focus();
        const indexToFocus = Math.min(items.length - 1, index);
        const el = items[indexToFocus];
        if (el) el.focus();
    }
    focusList(fromBottom) {
        const index = fromBottom ? this.childPillComponents.length - 1 : 0;
        this.restoreFocus(index, this.getFocusableElement());
    }
    getNonGhostItems() {
        const existingItems = this.getExistingItems();
        if (this.isPotentialDndItems()) return existingItems.filter((item)=>!includes(this.potentialDndItems, item));
        return existingItems;
    }
    addItemsToGui() {
        const nonGhostItems = this.getNonGhostItems();
        const itemsToAddToGui = nonGhostItems.map((item)=>this.createItemComponent(item, false));
        if (this.isPotentialDndItems()) {
            const dndItems = this.potentialDndItems.map((item)=>this.createItemComponent(item, true));
            if (this.insertIndex >= itemsToAddToGui.length) itemsToAddToGui.push(...dndItems);
            else itemsToAddToGui.splice(this.insertIndex, 0, ...dndItems);
        }
        this.appendChild(this.ePillDropList);
        itemsToAddToGui.forEach((itemComponent, index)=>{
            if (index > 0) this.addArrow(this.ePillDropList);
            this.ePillDropList.appendChild(itemComponent.getGui());
        });
        this.addAriaLabelsToComponents();
    }
    addAriaLabelsToComponents() {
        this.childPillComponents.forEach((comp, idx)=>{
            const eGui = comp.getGui();
            setAriaPosInSet(eGui, idx + 1);
            setAriaSetSize(eGui, this.childPillComponents.length);
        });
    }
    createItemComponent(item, ghost) {
        const itemComponent = this.createPillComponent(item, this.dropTarget, ghost, this.horizontal);
        itemComponent.addEventListener(PillDragComp.EVENT_COLUMN_REMOVE, this.removeItems.bind(this, [
            item
        ]));
        this.context.createBean(itemComponent);
        this.guiDestroyFunctions.push(()=>this.destroyBean(itemComponent));
        if (!ghost) this.childPillComponents.push(itemComponent);
        return itemComponent;
    }
    addIconAndTitleToGui() {
        const { title, icon: eGroupIcon } = this.params;
        if (!title || !eGroupIcon) return;
        const eTitleBar = document.createElement("div");
        setAriaHidden(eTitleBar, true);
        this.addElementClasses(eTitleBar, "title-bar");
        this.addElementClasses(eGroupIcon, "icon");
        this.addOrRemoveCssClass("ag-column-drop-empty", this.isExistingItemsEmpty());
        eTitleBar.appendChild(eGroupIcon);
        if (!this.horizontal) {
            const eTitle = document.createElement("span");
            this.addElementClasses(eTitle, "title");
            eTitle.innerHTML = title;
            eTitleBar.appendChild(eTitle);
        }
        this.appendChild(eTitleBar);
    }
    isExistingItemsEmpty() {
        return this.getExistingItems().length === 0;
    }
    addEmptyMessageToGui() {
        const { emptyMessage } = this.params;
        if (!emptyMessage || !this.isExistingItemsEmpty() || this.isPotentialDndItems()) return;
        const eMessage = document.createElement("span");
        eMessage.innerHTML = emptyMessage;
        this.addElementClasses(eMessage, "empty-message");
        this.ePillDropList.appendChild(eMessage);
    }
    addArrow(eParent) {
        if (this.horizontal) {
            const enableRtl = this.gos.get("enableRtl");
            const icon = createIconNoSpan(enableRtl ? "smallLeft" : "smallRight", this.gos);
            this.addElementClasses(icon, "cell-separator");
            eParent.appendChild(icon);
        }
    }
};
_PillDropZonePanel.STATE_NOT_DRAGGING = "notDragging";
_PillDropZonePanel.STATE_NEW_ITEMS_IN = "newItemsIn";
_PillDropZonePanel.STATE_REARRANGE_ITEMS = "rearrangeItems";
__decorateClass([
    Autowired("focusService")
], _PillDropZonePanel.prototype, "focusService", 2);
__decorateClass([
    Autowired("dragAndDropService")
], _PillDropZonePanel.prototype, "dragAndDropService", 2);
var PillDropZonePanel = _PillDropZonePanel;
// community-modules/core/src/vanillaFrameworkOverrides.ts
var PASSIVE_EVENTS2 = [
    "touchstart",
    "touchend",
    "touchmove",
    "touchcancel"
];
var VanillaFrameworkOverrides = class {
    constructor(frameworkName = "javascript"){
        this.frameworkName = frameworkName;
        this.renderingEngine = "vanilla";
        this.wrapIncoming = (callback)=>callback();
        this.wrapOutgoing = (callback)=>callback();
    }
    setInterval(action, timeout) {
        return new AgPromise((resolve)=>{
            resolve(window.setInterval(action, timeout));
        });
    }
    // for Vanilla JS, we just add the event to the element
    addEventListener(element, type, listener, useCapture) {
        const isPassive = includes(PASSIVE_EVENTS2, type);
        element.addEventListener(type, listener, {
            capture: !!useCapture,
            passive: isPassive
        });
    }
    get shouldWrapOutgoing() {
        return false;
    }
    frameworkComponent(name) {
        return null;
    }
    isFrameworkComponent(comp) {
        return false;
    }
    getDocLink(path) {
        const framework = this.frameworkName === "solid" ? "react" : this.frameworkName;
        return `https://www.ag-grid.com/${framework}-data-grid${path ? `/${path}` : ""}`;
    }
};
// community-modules/core/src/cellNavigationService.ts
var CellNavigationService = class extends BeanStub {
    // returns null if no cell to focus on, ie at the end of the grid
    getNextCellToFocus(key, focusedCell, ctrlPressed = false) {
        if (ctrlPressed) return this.getNextCellToFocusWithCtrlPressed(key, focusedCell);
        return this.getNextCellToFocusWithoutCtrlPressed(key, focusedCell);
    }
    getNextCellToFocusWithCtrlPressed(key, focusedCell) {
        const upKey = key === KeyCode.UP;
        const downKey = key === KeyCode.DOWN;
        const leftKey = key === KeyCode.LEFT;
        let column;
        let rowIndex;
        if (upKey || downKey) {
            rowIndex = upKey ? this.paginationProxy.getPageFirstRow() : this.paginationProxy.getPageLastRow();
            column = focusedCell.column;
        } else {
            const allColumns = this.columnModel.getAllDisplayedColumns();
            const isRtl = this.gos.get("enableRtl");
            rowIndex = focusedCell.rowIndex;
            column = leftKey !== isRtl ? allColumns[0] : last(allColumns);
        }
        return {
            rowIndex,
            rowPinned: null,
            column
        };
    }
    getNextCellToFocusWithoutCtrlPressed(key, focusedCell) {
        let pointer = focusedCell;
        let finished = false;
        while(!finished){
            switch(key){
                case KeyCode.UP:
                    pointer = this.getCellAbove(pointer);
                    break;
                case KeyCode.DOWN:
                    pointer = this.getCellBelow(pointer);
                    break;
                case KeyCode.RIGHT:
                    if (this.gos.get("enableRtl")) pointer = this.getCellToLeft(pointer);
                    else pointer = this.getCellToRight(pointer);
                    break;
                case KeyCode.LEFT:
                    if (this.gos.get("enableRtl")) pointer = this.getCellToRight(pointer);
                    else pointer = this.getCellToLeft(pointer);
                    break;
                default:
                    pointer = null;
                    console.warn("AG Grid: unknown key for navigation " + key);
                    break;
            }
            if (pointer) finished = this.isCellGoodToFocusOn(pointer);
            else finished = true;
        }
        return pointer;
    }
    isCellGoodToFocusOn(gridCell) {
        const column = gridCell.column;
        let rowNode;
        switch(gridCell.rowPinned){
            case "top":
                rowNode = this.pinnedRowModel.getPinnedTopRow(gridCell.rowIndex);
                break;
            case "bottom":
                rowNode = this.pinnedRowModel.getPinnedBottomRow(gridCell.rowIndex);
                break;
            default:
                rowNode = this.rowModel.getRow(gridCell.rowIndex);
                break;
        }
        if (!rowNode) return false;
        const suppressNavigable = column.isSuppressNavigable(rowNode);
        return !suppressNavigable;
    }
    getCellToLeft(lastCell) {
        if (!lastCell) return null;
        const colToLeft = this.columnModel.getDisplayedColBefore(lastCell.column);
        if (!colToLeft) return null;
        return {
            rowIndex: lastCell.rowIndex,
            column: colToLeft,
            rowPinned: lastCell.rowPinned
        };
    }
    getCellToRight(lastCell) {
        if (!lastCell) return null;
        const colToRight = this.columnModel.getDisplayedColAfter(lastCell.column);
        if (!colToRight) return null;
        return {
            rowIndex: lastCell.rowIndex,
            column: colToRight,
            rowPinned: lastCell.rowPinned
        };
    }
    getRowBelow(rowPosition) {
        const index = rowPosition.rowIndex;
        const pinned = rowPosition.rowPinned;
        if (this.isLastRowInContainer(rowPosition)) switch(pinned){
            case "bottom":
                return null;
            case "top":
                if (this.rowModel.isRowsToRender()) return {
                    rowIndex: this.paginationProxy.getPageFirstRow(),
                    rowPinned: null
                };
                if (this.pinnedRowModel.isRowsToRender("bottom")) return {
                    rowIndex: 0,
                    rowPinned: "bottom"
                };
                return null;
            default:
                if (this.pinnedRowModel.isRowsToRender("bottom")) return {
                    rowIndex: 0,
                    rowPinned: "bottom"
                };
                return null;
        }
        const rowNode = this.rowModel.getRow(rowPosition.rowIndex);
        const nextStickyPosition = this.getNextStickyPosition(rowNode);
        if (nextStickyPosition) return nextStickyPosition;
        return {
            rowIndex: index + 1,
            rowPinned: pinned
        };
    }
    getNextStickyPosition(rowNode, up) {
        if (!this.gos.isGroupRowsSticky() || !rowNode || !rowNode.sticky) return;
        const isTopCtrls = this.rowRenderer.getStickyTopRowCtrls().some((ctrl)=>ctrl.getRowNode().rowIndex === rowNode.rowIndex);
        let stickyRowCtrls = [];
        if (isTopCtrls) stickyRowCtrls = [
            ...this.rowRenderer.getStickyTopRowCtrls()
        ].sort((a, b)=>a.getRowNode().rowIndex - b.getRowNode().rowIndex);
        else stickyRowCtrls = [
            ...this.rowRenderer.getStickyBottomRowCtrls()
        ].sort((a, b)=>b.getRowNode().rowIndex - a.getRowNode().rowIndex);
        const diff = up ? -1 : 1;
        const idx = stickyRowCtrls.findIndex((ctrl)=>ctrl.getRowNode().rowIndex === rowNode.rowIndex);
        const nextCtrl = stickyRowCtrls[idx + diff];
        if (nextCtrl) return {
            rowIndex: nextCtrl.getRowNode().rowIndex,
            rowPinned: null
        };
    }
    getCellBelow(lastCell) {
        if (!lastCell) return null;
        const rowBelow = this.getRowBelow(lastCell);
        if (rowBelow) return {
            rowIndex: rowBelow.rowIndex,
            column: lastCell.column,
            rowPinned: rowBelow.rowPinned
        };
        return null;
    }
    isLastRowInContainer(rowPosition) {
        const pinned = rowPosition.rowPinned;
        const index = rowPosition.rowIndex;
        if (pinned === "top") {
            const lastTopIndex = this.pinnedRowModel.getPinnedTopRowData().length - 1;
            return lastTopIndex <= index;
        }
        if (pinned === "bottom") {
            const lastBottomIndex = this.pinnedRowModel.getPinnedBottomRowData().length - 1;
            return lastBottomIndex <= index;
        }
        const lastBodyIndex = this.paginationProxy.getPageLastRow();
        return lastBodyIndex <= index;
    }
    getRowAbove(rowPosition) {
        const index = rowPosition.rowIndex;
        const pinned = rowPosition.rowPinned;
        const isFirstRow = pinned ? index === 0 : index === this.paginationProxy.getPageFirstRow();
        if (isFirstRow) {
            if (pinned === "top") return null;
            if (!pinned) {
                if (this.pinnedRowModel.isRowsToRender("top")) return this.getLastFloatingTopRow();
                return null;
            }
            if (this.rowModel.isRowsToRender()) return this.getLastBodyCell();
            if (this.pinnedRowModel.isRowsToRender("top")) return this.getLastFloatingTopRow();
            return null;
        }
        const rowNode = this.rowModel.getRow(rowPosition.rowIndex);
        const nextStickyPosition = this.getNextStickyPosition(rowNode, true);
        if (nextStickyPosition) return nextStickyPosition;
        return {
            rowIndex: index - 1,
            rowPinned: pinned
        };
    }
    getCellAbove(lastCell) {
        if (!lastCell) return null;
        const rowAbove = this.getRowAbove({
            rowIndex: lastCell.rowIndex,
            rowPinned: lastCell.rowPinned
        });
        if (rowAbove) return {
            rowIndex: rowAbove.rowIndex,
            column: lastCell.column,
            rowPinned: rowAbove.rowPinned
        };
        return null;
    }
    getLastBodyCell() {
        const lastBodyRow = this.paginationProxy.getPageLastRow();
        return {
            rowIndex: lastBodyRow,
            rowPinned: null
        };
    }
    getLastFloatingTopRow() {
        const lastFloatingRow = this.pinnedRowModel.getPinnedTopRowData().length - 1;
        return {
            rowIndex: lastFloatingRow,
            rowPinned: "top"
        };
    }
    getNextTabbedCell(gridCell, backwards) {
        if (backwards) return this.getNextTabbedCellBackwards(gridCell);
        return this.getNextTabbedCellForwards(gridCell);
    }
    getNextTabbedCellForwards(gridCell) {
        const displayedColumns = this.columnModel.getAllDisplayedColumns();
        let newRowIndex = gridCell.rowIndex;
        let newFloating = gridCell.rowPinned;
        let newColumn = this.columnModel.getDisplayedColAfter(gridCell.column);
        if (!newColumn) {
            newColumn = displayedColumns[0];
            const rowBelow = this.getRowBelow(gridCell);
            if (missing(rowBelow)) return null;
            if (!rowBelow.rowPinned && !this.paginationProxy.isRowInPage(rowBelow)) return null;
            newRowIndex = rowBelow ? rowBelow.rowIndex : null;
            newFloating = rowBelow ? rowBelow.rowPinned : null;
        }
        return {
            rowIndex: newRowIndex,
            column: newColumn,
            rowPinned: newFloating
        };
    }
    getNextTabbedCellBackwards(gridCell) {
        const displayedColumns = this.columnModel.getAllDisplayedColumns();
        let newRowIndex = gridCell.rowIndex;
        let newFloating = gridCell.rowPinned;
        let newColumn = this.columnModel.getDisplayedColBefore(gridCell.column);
        if (!newColumn) {
            newColumn = last(displayedColumns);
            const rowAbove = this.getRowAbove({
                rowIndex: gridCell.rowIndex,
                rowPinned: gridCell.rowPinned
            });
            if (missing(rowAbove)) return null;
            if (!rowAbove.rowPinned && !this.paginationProxy.isRowInPage(rowAbove)) return null;
            newRowIndex = rowAbove ? rowAbove.rowIndex : null;
            newFloating = rowAbove ? rowAbove.rowPinned : null;
        }
        return {
            rowIndex: newRowIndex,
            column: newColumn,
            rowPinned: newFloating
        };
    }
};
__decorateClass([
    Autowired("columnModel")
], CellNavigationService.prototype, "columnModel", 2);
__decorateClass([
    Autowired("rowModel")
], CellNavigationService.prototype, "rowModel", 2);
__decorateClass([
    Autowired("rowRenderer")
], CellNavigationService.prototype, "rowRenderer", 2);
__decorateClass([
    Autowired("pinnedRowModel")
], CellNavigationService.prototype, "pinnedRowModel", 2);
__decorateClass([
    Autowired("paginationProxy")
], CellNavigationService.prototype, "paginationProxy", 2);
CellNavigationService = __decorateClass([
    Bean("cellNavigationService")
], CellNavigationService);
// community-modules/core/src/alignedGridsService.ts
var AlignedGridsService = class extends BeanStub {
    constructor(){
        super(...arguments);
        // flag to mark if we are consuming. to avoid cyclic events (ie other grid firing back to master
        // while processing a master event) we mark this if consuming an event, and if we are, then
        // we don't fire back any events.
        this.consuming = false;
    }
    setBeans(loggerFactory) {
        this.logger = loggerFactory.create("AlignedGridsService");
    }
    getAlignedGridApis() {
        var _a;
        let alignedGrids = (_a = this.gos.get("alignedGrids")) != null ? _a : [];
        const isCallbackConfig = typeof alignedGrids === "function";
        if (typeof alignedGrids === "function") alignedGrids = alignedGrids();
        const seeUrl = ()=>`See ${this.getFrameworkOverrides().getDocLink("aligned-grids")}`;
        const apis = alignedGrids.map((alignedGrid)=>{
            var _a2;
            if (!alignedGrid) {
                errorOnce(`alignedGrids contains an undefined option.`);
                if (!isCallbackConfig) errorOnce(`You may want to configure via a callback to avoid setup race conditions:
                     "alignedGrids: () => [linkedGrid]"`);
                errorOnce(seeUrl());
                return;
            }
            if (alignedGrid instanceof GridApi) return alignedGrid;
            const refOrComp = alignedGrid;
            if ("current" in refOrComp) return (_a2 = refOrComp.current) == null ? void 0 : _a2.api;
            else {
                if (!refOrComp.api) errorOnce(`alignedGrids - No api found on the linked grid. If you are passing gridOptions to alignedGrids since v31 this is no longer valid. ${seeUrl()}`);
                return refOrComp.api;
            }
        }).filter((api)=>!!api && !api.isDestroyed());
        return apis;
    }
    init() {
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_MOVED, this.fireColumnEvent.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_VISIBLE, this.fireColumnEvent.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PINNED, this.fireColumnEvent.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_GROUP_OPENED, this.fireColumnEvent.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_RESIZED, this.fireColumnEvent.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_BODY_SCROLL, this.fireScrollEvent.bind(this));
    }
    // common logic across all the fire methods
    fireEvent(callback) {
        if (this.consuming) return;
        this.getAlignedGridApis().forEach((api)=>{
            if (api.isDestroyed()) return;
            const alignedGridService = api.__getAlignedGridService();
            callback(alignedGridService);
        });
    }
    // common logic across all consume methods. very little common logic, however extracting
    // guarantees consistency across the methods.
    onEvent(callback) {
        this.consuming = true;
        callback();
        this.consuming = false;
    }
    fireColumnEvent(event) {
        this.fireEvent((alignedGridsService)=>{
            alignedGridsService.onColumnEvent(event);
        });
    }
    fireScrollEvent(event) {
        if (event.direction !== "horizontal") return;
        this.fireEvent((alignedGridsService)=>{
            alignedGridsService.onScrollEvent(event);
        });
    }
    onScrollEvent(event) {
        this.onEvent(()=>{
            const gridBodyCon = this.ctrlsService.getGridBodyCtrl();
            gridBodyCon.getScrollFeature().setHorizontalScrollPosition(event.left, true);
        });
    }
    getMasterColumns(event) {
        const result = [];
        if (event.columns) event.columns.forEach((column)=>{
            result.push(column);
        });
        else if (event.column) result.push(event.column);
        return result;
    }
    getColumnIds(event) {
        const result = [];
        if (event.columns) event.columns.forEach((column)=>{
            result.push(column.getColId());
        });
        else if (event.column) result.push(event.column.getColId());
        return result;
    }
    onColumnEvent(event) {
        this.onEvent(()=>{
            switch(event.type){
                case Events.EVENT_COLUMN_MOVED:
                case Events.EVENT_COLUMN_VISIBLE:
                case Events.EVENT_COLUMN_PINNED:
                case Events.EVENT_COLUMN_RESIZED:
                    const colEvent = event;
                    this.processColumnEvent(colEvent);
                    break;
                case Events.EVENT_COLUMN_GROUP_OPENED:
                    const groupOpenedEvent = event;
                    this.processGroupOpenedEvent(groupOpenedEvent);
                    break;
                case Events.EVENT_COLUMN_PIVOT_CHANGED:
                    console.warn("AG Grid: pivoting is not supported with aligned grids. You can only use one of these features at a time in a grid.");
                    break;
            }
        });
    }
    processGroupOpenedEvent(groupOpenedEvent) {
        groupOpenedEvent.columnGroups.forEach((masterGroup)=>{
            let otherColumnGroup = null;
            if (masterGroup) {
                const groupId = masterGroup.getGroupId();
                otherColumnGroup = this.columnModel.getProvidedColumnGroup(groupId);
            }
            if (masterGroup && !otherColumnGroup) return;
            this.logger.log("onColumnEvent-> processing " + groupOpenedEvent + " expanded = " + masterGroup.isExpanded());
            this.columnModel.setColumnGroupOpened(otherColumnGroup, masterGroup.isExpanded(), "alignedGridChanged");
        });
    }
    processColumnEvent(colEvent) {
        var _a;
        const masterColumn = colEvent.column;
        let otherColumn = null;
        if (masterColumn) otherColumn = this.columnModel.getPrimaryColumn(masterColumn.getColId());
        if (masterColumn && !otherColumn) return;
        const masterColumns = this.getMasterColumns(colEvent);
        switch(colEvent.type){
            case Events.EVENT_COLUMN_MOVED:
                {
                    const movedEvent = colEvent;
                    const srcColState = colEvent.api.getColumnState();
                    const destColState = srcColState.map((s)=>({
                            colId: s.colId
                        }));
                    this.columnModel.applyColumnState({
                        state: destColState,
                        applyOrder: true
                    }, "alignedGridChanged");
                    this.logger.log(`onColumnEvent-> processing ${colEvent.type} toIndex = ${movedEvent.toIndex}`);
                }
                break;
            case Events.EVENT_COLUMN_VISIBLE:
                {
                    const visibleEvent = colEvent;
                    const srcColState = colEvent.api.getColumnState();
                    const destColState = srcColState.map((s)=>({
                            colId: s.colId,
                            hide: s.hide
                        }));
                    this.columnModel.applyColumnState({
                        state: destColState
                    }, "alignedGridChanged");
                    this.logger.log(`onColumnEvent-> processing ${colEvent.type} visible = ${visibleEvent.visible}`);
                }
                break;
            case Events.EVENT_COLUMN_PINNED:
                {
                    const pinnedEvent = colEvent;
                    const srcColState = colEvent.api.getColumnState();
                    const destColState = srcColState.map((s)=>({
                            colId: s.colId,
                            pinned: s.pinned
                        }));
                    this.columnModel.applyColumnState({
                        state: destColState
                    }, "alignedGridChanged");
                    this.logger.log(`onColumnEvent-> processing ${colEvent.type} pinned = ${pinnedEvent.pinned}`);
                }
                break;
            case Events.EVENT_COLUMN_RESIZED:
                const resizedEvent = colEvent;
                const columnWidths = {};
                masterColumns.forEach((column)=>{
                    this.logger.log(`onColumnEvent-> processing ${colEvent.type} actualWidth = ${column.getActualWidth()}`);
                    columnWidths[column.getId()] = {
                        key: column.getColId(),
                        newWidth: column.getActualWidth()
                    };
                });
                (_a = resizedEvent.flexColumns) == null || _a.forEach((col)=>{
                    if (columnWidths[col.getId()]) delete columnWidths[col.getId()];
                });
                this.columnModel.setColumnWidths(Object.values(columnWidths), false, resizedEvent.finished, "alignedGridChanged");
                break;
        }
        const gridBodyCon = this.ctrlsService.getGridBodyCtrl();
        const isVerticalScrollShowing2 = gridBodyCon.isVerticalScrollShowing();
        this.getAlignedGridApis().forEach((api)=>{
            api.setGridOption("alwaysShowVerticalScroll", isVerticalScrollShowing2);
        });
    }
};
__decorateClass([
    Autowired("columnModel")
], AlignedGridsService.prototype, "columnModel", 2);
__decorateClass([
    Autowired("ctrlsService")
], AlignedGridsService.prototype, "ctrlsService", 2);
__decorateClass([
    __decorateParam(0, Qualifier("loggerFactory"))
], AlignedGridsService.prototype, "setBeans", 1);
__decorateClass([
    PostConstruct
], AlignedGridsService.prototype, "init", 1);
AlignedGridsService = __decorateClass([
    Bean("alignedGridsService")
], AlignedGridsService);
// community-modules/core/src/selectionService.ts
var SelectionService = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.selectedNodes = /* @__PURE__ */ new Map();
        this.lastRowNode = null;
    }
    init() {
        this.rowSelection = this.gos.get("rowSelection");
        this.groupSelectsChildren = this.gos.get("groupSelectsChildren");
        this.addManagedPropertyListeners([
            "groupSelectsChildren",
            "rowSelection"
        ], ()=>{
            this.groupSelectsChildren = this.gos.get("groupSelectsChildren");
            this.rowSelection = this.gos.get("rowSelection");
            this.deselectAllRowNodes({
                source: "api"
            });
        });
        this.addManagedListener(this.eventService, Events.EVENT_ROW_SELECTED, this.onRowSelected.bind(this));
    }
    destroy() {
        super.destroy();
        this.resetNodes();
        this.lastRowNode = null;
    }
    isMultiselect() {
        return this.rowSelection === "multiple";
    }
    setNodesSelected(params) {
        var _a;
        const { newValue, clearSelection, suppressFinishActions, rangeSelect, nodes, event, source = "api" } = params;
        if (nodes.length === 0) return 0;
        if (nodes.length > 1 && !this.isMultiselect()) {
            console.warn(`AG Grid: cannot multi select while rowSelection='single'`);
            return 0;
        }
        const groupSelectsFiltered = this.groupSelectsChildren && params.groupSelectsFiltered === true;
        const filteredNodes = nodes.map((node)=>node.footer ? node.sibling : node);
        if (rangeSelect) {
            if (nodes.length > 1) {
                console.warn("AG Grid: cannot range select while selecting multiple rows");
                return 0;
            }
            let toNode = null;
            if (source === "checkboxSelected" && newValue === false && this.lastRowNode) {
                if (this.lastRowNode.id) toNode = this.lastRowNode;
                else this.lastRowNode = null;
            }
            if (toNode == null) toNode = this.getLastSelectedNode();
            if (toNode) {
                const fromNode = filteredNodes[0];
                const newRowClicked = fromNode !== toNode;
                if (newRowClicked && this.isMultiselect()) return this.selectRange(fromNode, toNode, newValue, source);
            }
        }
        this.lastRowNode = newValue ? null : filteredNodes[0];
        let updatedCount = 0;
        for(let i = 0; i < filteredNodes.length; i++){
            const node = filteredNodes[i];
            const skipThisNode = groupSelectsFiltered && node.group;
            if (!skipThisNode) {
                const thisNodeWasSelected = node.selectThisNode(newValue, event, source);
                if (thisNodeWasSelected) updatedCount++;
            }
            if (this.groupSelectsChildren && ((_a = node.childrenAfterGroup) == null ? void 0 : _a.length)) updatedCount += this.selectChildren(node, newValue, groupSelectsFiltered, source);
        }
        if (!suppressFinishActions) {
            const clearOtherNodes = newValue && (clearSelection || !this.isMultiselect());
            if (clearOtherNodes) updatedCount += this.clearOtherNodes(filteredNodes[0], source);
            if (updatedCount > 0) {
                this.updateGroupsFromChildrenSelections(source);
                const event2 = {
                    type: Events.EVENT_SELECTION_CHANGED,
                    source
                };
                this.eventService.dispatchEvent(event2);
            }
        }
        return updatedCount;
    }
    // selects all rows between this node and the last selected node (or the top if this is the first selection).
    // not to be mixed up with 'cell range selection' where you drag the mouse, this is row range selection, by
    // holding down 'shift'.
    selectRange(fromNode, toNode, value = true, source) {
        const nodesToSelect = this.rowModel.getNodesInRangeForSelection(fromNode, toNode);
        let updatedCount = 0;
        nodesToSelect.forEach((rowNode)=>{
            if (rowNode.group && this.groupSelectsChildren) return;
            const nodeWasSelected = rowNode.selectThisNode(value, void 0, source);
            if (nodeWasSelected) updatedCount++;
        });
        this.updateGroupsFromChildrenSelections(source);
        const event = {
            type: Events.EVENT_SELECTION_CHANGED,
            source
        };
        this.eventService.dispatchEvent(event);
        return updatedCount;
    }
    selectChildren(node, newValue, groupSelectsFiltered, source) {
        const children = groupSelectsFiltered ? node.childrenAfterAggFilter : node.childrenAfterGroup;
        if (missing(children)) return 0;
        return this.setNodesSelected({
            newValue,
            clearSelection: false,
            suppressFinishActions: true,
            groupSelectsFiltered,
            source,
            nodes: children
        });
    }
    getLastSelectedNode() {
        const selectedKeys = Array.from(this.selectedNodes.keys());
        if (selectedKeys.length == 0) return null;
        const node = this.selectedNodes.get(last(selectedKeys));
        if (node) return node;
        return null;
    }
    getSelectedNodes() {
        const selectedNodes = [];
        this.selectedNodes.forEach((rowNode)=>{
            if (rowNode) selectedNodes.push(rowNode);
        });
        return selectedNodes;
    }
    getSelectedRows() {
        const selectedRows = [];
        this.selectedNodes.forEach((rowNode)=>{
            if (rowNode && rowNode.data) selectedRows.push(rowNode.data);
        });
        return selectedRows;
    }
    getSelectionCount() {
        return this.selectedNodes.size;
    }
    /**
   * This method is used by the CSRM to remove groups which are being disposed of,
   * events do not need fired in this case
   */ filterFromSelection(predicate) {
        const newSelectedNodes = /* @__PURE__ */ new Map();
        this.selectedNodes.forEach((rowNode, key)=>{
            const passesPredicate = rowNode && predicate(rowNode);
            if (passesPredicate) newSelectedNodes.set(key, rowNode);
        });
        this.selectedNodes = newSelectedNodes;
    }
    // should only be called if groupSelectsChildren=true
    updateGroupsFromChildrenSelections(source, changedPath) {
        if (!this.groupSelectsChildren) return false;
        if (this.rowModel.getType() !== "clientSide") return false;
        const clientSideRowModel = this.rowModel;
        const rootNode = clientSideRowModel.getRootNode();
        if (!changedPath) {
            changedPath = new ChangedPath(true, rootNode);
            changedPath.setInactive();
        }
        let selectionChanged = false;
        changedPath.forEachChangedNodeDepthFirst((rowNode)=>{
            if (rowNode !== rootNode) {
                const selected = rowNode.calculateSelectedFromChildren();
                selectionChanged = rowNode.selectThisNode(selected === null ? false : selected, void 0, source) || selectionChanged;
            }
        });
        return selectionChanged;
    }
    clearOtherNodes(rowNodeToKeepSelected, source) {
        const groupsToRefresh = /* @__PURE__ */ new Map();
        let updatedCount = 0;
        this.selectedNodes.forEach((otherRowNode)=>{
            if (otherRowNode && otherRowNode.id !== rowNodeToKeepSelected.id) {
                const rowNode = this.selectedNodes.get(otherRowNode.id);
                updatedCount += rowNode.setSelectedParams({
                    newValue: false,
                    clearSelection: false,
                    suppressFinishActions: true,
                    source
                });
                if (this.groupSelectsChildren && otherRowNode.parent) groupsToRefresh.set(otherRowNode.parent.id, otherRowNode.parent);
            }
        });
        groupsToRefresh.forEach((group)=>{
            const selected = group.calculateSelectedFromChildren();
            group.selectThisNode(selected === null ? false : selected, void 0, source);
        });
        return updatedCount;
    }
    onRowSelected(event) {
        const rowNode = event.node;
        if (this.groupSelectsChildren && rowNode.group) return;
        if (rowNode.isSelected()) this.selectedNodes.set(rowNode.id, rowNode);
        else this.selectedNodes.delete(rowNode.id);
    }
    syncInRowNode(rowNode, oldNode) {
        this.syncInOldRowNode(rowNode, oldNode);
        this.syncInNewRowNode(rowNode);
    }
    // if the id has changed for the node, then this means the rowNode
    // is getting used for a different data item, which breaks
    // our selectedNodes, as the node now is mapped by the old id
    // which is inconsistent. so to keep the old node as selected,
    // we swap in the clone (with the old id and old data). this means
    // the oldNode is effectively a daemon we keep a reference to,
    // so if client calls api.getSelectedNodes(), it gets the daemon
    // in the result. when the client un-selects, the reference to the
    // daemon is removed. the daemon, because it's an oldNode, is not
    // used by the grid for rendering, it's a copy of what the node used
    // to be like before the id was changed.
    syncInOldRowNode(rowNode, oldNode) {
        const oldNodeHasDifferentId = exists(oldNode) && rowNode.id !== oldNode.id;
        if (oldNodeHasDifferentId && oldNode) {
            const id = oldNode.id;
            const oldNodeSelected = this.selectedNodes.get(id) == rowNode;
            if (oldNodeSelected) this.selectedNodes.set(oldNode.id, oldNode);
        }
    }
    syncInNewRowNode(rowNode) {
        if (this.selectedNodes.has(rowNode.id)) {
            rowNode.setSelectedInitialValue(true);
            this.selectedNodes.set(rowNode.id, rowNode);
        } else rowNode.setSelectedInitialValue(false);
    }
    reset(source) {
        const selectionCount = this.getSelectionCount();
        this.resetNodes();
        if (selectionCount) {
            const event = {
                type: Events.EVENT_SELECTION_CHANGED,
                source
            };
            this.eventService.dispatchEvent(event);
        }
    }
    resetNodes() {
        var _a;
        (_a = this.selectedNodes) == null || _a.clear();
    }
    // returns a list of all nodes at 'best cost' - a feature to be used
    // with groups / trees. if a group has all it's children selected,
    // then the group appears in the result, but not the children.
    // Designed for use with 'children' as the group selection type,
    // where groups don't actually appear in the selection normally.
    getBestCostNodeSelection() {
        if (this.rowModel.getType() !== "clientSide") return;
        const clientSideRowModel = this.rowModel;
        const topLevelNodes = clientSideRowModel.getTopLevelNodes();
        if (topLevelNodes === null) return;
        const result = [];
        function traverse(nodes) {
            for(let i = 0, l = nodes.length; i < l; i++){
                const node = nodes[i];
                if (node.isSelected()) result.push(node);
                else {
                    const maybeGroup = node;
                    if (maybeGroup.group && maybeGroup.children) traverse(maybeGroup.children);
                }
            }
        }
        traverse(topLevelNodes);
        return result;
    }
    isEmpty() {
        let count = 0;
        this.selectedNodes.forEach((rowNode)=>{
            if (rowNode) count++;
        });
        return count === 0;
    }
    deselectAllRowNodes(params) {
        const callback = (rowNode)=>rowNode.selectThisNode(false, void 0, source);
        const rowModelClientSide = this.rowModel.getType() === "clientSide";
        const { source, justFiltered, justCurrentPage } = params;
        if (justCurrentPage || justFiltered) {
            if (!rowModelClientSide) {
                console.error("AG Grid: selecting just filtered only works when gridOptions.rowModelType='clientSide'");
                return;
            }
            this.getNodesToSelect(justFiltered, justCurrentPage).forEach(callback);
        } else {
            this.selectedNodes.forEach((rowNode)=>{
                if (rowNode) callback(rowNode);
            });
            this.reset(source);
        }
        if (rowModelClientSide && this.groupSelectsChildren) this.updateGroupsFromChildrenSelections(source);
        const event = {
            type: Events.EVENT_SELECTION_CHANGED,
            source
        };
        this.eventService.dispatchEvent(event);
    }
    getSelectedCounts(justFiltered, justCurrentPage) {
        let selectedCount = 0;
        let notSelectedCount = 0;
        const callback = (node)=>{
            if (this.groupSelectsChildren && node.group) return;
            if (node.isSelected()) selectedCount++;
            else if (!node.selectable) ;
            else notSelectedCount++;
        };
        this.getNodesToSelect(justFiltered, justCurrentPage).forEach(callback);
        return {
            selectedCount,
            notSelectedCount
        };
    }
    getSelectAllState(justFiltered, justCurrentPage) {
        const { selectedCount, notSelectedCount } = this.getSelectedCounts(justFiltered, justCurrentPage);
        if (selectedCount === 0 && notSelectedCount === 0) return false;
        if (selectedCount > 0 && notSelectedCount > 0) return null;
        return selectedCount > 0;
    }
    hasNodesToSelect(justFiltered = false, justCurrentPage = false) {
        return this.getNodesToSelect(justFiltered, justCurrentPage).filter((node)=>node.selectable).length > 0;
    }
    /**
   * @param justFiltered whether to just include nodes which have passed the filter
   * @param justCurrentPage whether to just include nodes on the current page
   * @returns all nodes including unselectable nodes which are the target of this selection attempt
   */ getNodesToSelect(justFiltered = false, justCurrentPage = false) {
        if (this.rowModel.getType() !== "clientSide") throw new Error(`selectAll only available when rowModelType='clientSide', ie not ${this.rowModel.getType()}`);
        const nodes = [];
        if (justCurrentPage) {
            this.paginationProxy.forEachNodeOnPage((node)=>{
                if (!node.group) {
                    nodes.push(node);
                    return;
                }
                if (!node.expanded) {
                    const recursivelyAddChildren = (child)=>{
                        var _a;
                        nodes.push(child);
                        if ((_a = child.childrenAfterFilter) == null ? void 0 : _a.length) child.childrenAfterFilter.forEach(recursivelyAddChildren);
                    };
                    recursivelyAddChildren(node);
                    return;
                }
                if (!this.groupSelectsChildren) nodes.push(node);
            });
            return nodes;
        }
        const clientSideRowModel = this.rowModel;
        if (justFiltered) {
            clientSideRowModel.forEachNodeAfterFilter((node)=>{
                nodes.push(node);
            });
            return nodes;
        }
        clientSideRowModel.forEachNode((node)=>{
            nodes.push(node);
        });
        return nodes;
    }
    selectAllRowNodes(params) {
        if (this.rowModel.getType() !== "clientSide") throw new Error(`selectAll only available when rowModelType='clientSide', ie not ${this.rowModel.getType()}`);
        const { source, justFiltered, justCurrentPage } = params;
        const callback = (rowNode)=>rowNode.selectThisNode(true, void 0, source);
        this.getNodesToSelect(justFiltered, justCurrentPage).forEach(callback);
        if (this.rowModel.getType() === "clientSide" && this.groupSelectsChildren) this.updateGroupsFromChildrenSelections(source);
        const event = {
            type: Events.EVENT_SELECTION_CHANGED,
            source
        };
        this.eventService.dispatchEvent(event);
    }
    getSelectionState() {
        const selectedIds = [];
        this.selectedNodes.forEach((node)=>{
            if (node == null ? void 0 : node.id) selectedIds.push(node.id);
        });
        return selectedIds.length ? selectedIds : null;
    }
    setSelectionState(state, source) {
        if (!Array.isArray(state)) return;
        const rowIds = new Set(state);
        const nodes = [];
        this.rowModel.forEachNode((node)=>{
            if (rowIds.has(node.id)) nodes.push(node);
        });
        this.setNodesSelected({
            newValue: true,
            nodes,
            source
        });
    }
};
__decorateClass([
    Autowired("rowModel")
], SelectionService.prototype, "rowModel", 2);
__decorateClass([
    Autowired("paginationProxy")
], SelectionService.prototype, "paginationProxy", 2);
__decorateClass([
    PostConstruct
], SelectionService.prototype, "init", 1);
SelectionService = __decorateClass([
    Bean("selectionService")
], SelectionService);
// community-modules/core/src/columns/columnApi.ts
var ColumnApi = class {
    constructor(gridAp){
        this.viaApi = (funcName, ...args)=>{
            warnOnce(`Since v31, 'columnApi.${funcName}' is deprecated and moved to 'api.${funcName}'.`);
            return this.api[funcName](...args);
        };
        this.api = gridAp;
    }
    /** @deprecated v31 use `api.sizeColumnsToFit()` instead.   */ sizeColumnsToFit(gridWidth) {
        this.viaApi("sizeColumnsToFit", gridWidth);
    }
    /** @deprecated v31 use `api.setColumnGroupOpened() instead. */ setColumnGroupOpened(group, newValue) {
        this.viaApi("setColumnGroupOpened", group, newValue);
    }
    /** @deprecated v31 use `api.getColumnGroup() instead. */ getColumnGroup(name, instanceId) {
        return this.viaApi("getColumnGroup", name, instanceId);
    }
    /** @deprecated v31 use `api.getProvidedColumnGroup() instead. */ getProvidedColumnGroup(name) {
        return this.viaApi("getProvidedColumnGroup", name);
    }
    /** @deprecated v31 use `api.getDisplayNameForColumn() instead. */ getDisplayNameForColumn(column, location) {
        return this.viaApi("getDisplayNameForColumn", column, location);
    }
    /** @deprecated v31 use `api.getDisplayNameForColumnGroup() instead. */ getDisplayNameForColumnGroup(columnGroup, location) {
        return this.viaApi("getDisplayNameForColumnGroup", columnGroup, location);
    }
    /** @deprecated v31 use `api.getColumn() instead. */ getColumn(key) {
        return this.viaApi("getColumn", key);
    }
    /** @deprecated v31 use `api.getColumns() instead. */ getColumns() {
        return this.viaApi("getColumns");
    }
    /** @deprecated v31 use `api.applyColumnState() instead. */ applyColumnState(params) {
        return this.viaApi("applyColumnState", params);
    }
    /** @deprecated v31 use `api.getColumnState() instead. */ getColumnState() {
        return this.viaApi("getColumnState");
    }
    /** @deprecated v31 use `api.resetColumnState() instead. */ resetColumnState() {
        this.viaApi("resetColumnState");
    }
    /** @deprecated v31 use `api.getColumnGroupState() instead. */ getColumnGroupState() {
        return this.viaApi("getColumnGroupState");
    }
    /** @deprecated v31 use `api.setColumnGroupState() instead. */ setColumnGroupState(stateItems) {
        this.viaApi("setColumnGroupState", stateItems);
    }
    /** @deprecated v31 use `api.resetColumnGroupState() instead. */ resetColumnGroupState() {
        this.viaApi("resetColumnGroupState");
    }
    /** @deprecated v31 use `api.isPinning() instead. */ isPinning() {
        return this.viaApi("isPinning");
    }
    /** @deprecated v31 use `api.isPinningLeft() instead. */ isPinningLeft() {
        return this.viaApi("isPinningLeft");
    }
    /** @deprecated v31 use `api.isPinningRight() instead. */ isPinningRight() {
        return this.viaApi("isPinningRight");
    }
    /** @deprecated v31 use `api.getDisplayedColAfter() instead. */ getDisplayedColAfter(col) {
        return this.viaApi("getDisplayedColAfter", col);
    }
    /** @deprecated v31 use `api.getDisplayedColBefore() instead. */ getDisplayedColBefore(col) {
        return this.viaApi("getDisplayedColBefore", col);
    }
    /** @deprecated v31 use `api.setColumnVisible() instead. */ setColumnVisible(key, visible) {
        this.viaApi("setColumnVisible", key, visible);
    }
    /** @deprecated v31 use `api.setColumnsVisible() instead. */ setColumnsVisible(keys2, visible) {
        this.viaApi("setColumnsVisible", keys2, visible);
    }
    /** @deprecated v31 use `api.setColumnPinned() instead. */ setColumnPinned(key, pinned) {
        this.viaApi("setColumnPinned", key, pinned);
    }
    /** @deprecated v31 use `api.setColumnsPinned() instead. */ setColumnsPinned(keys2, pinned) {
        this.viaApi("setColumnsPinned", keys2, pinned);
    }
    /** @deprecated v31 use `api.getAllGridColumns() instead. */ getAllGridColumns() {
        return this.viaApi("getAllGridColumns");
    }
    /** @deprecated v31 use `api.getDisplayedLeftColumns() instead. */ getDisplayedLeftColumns() {
        return this.viaApi("getDisplayedLeftColumns");
    }
    /** @deprecated v31 use `api.getDisplayedCenterColumns() instead. */ getDisplayedCenterColumns() {
        return this.viaApi("getDisplayedCenterColumns");
    }
    /** @deprecated v31 use `api.getDisplayedRightColumns() instead. */ getDisplayedRightColumns() {
        return this.viaApi("getDisplayedRightColumns");
    }
    /** @deprecated v31 use `api.getAllDisplayedColumns() instead. */ getAllDisplayedColumns() {
        return this.viaApi("getAllDisplayedColumns");
    }
    /** @deprecated v31 use `api.getAllDisplayedVirtualColumns() instead. */ getAllDisplayedVirtualColumns() {
        return this.viaApi("getAllDisplayedVirtualColumns");
    }
    /** @deprecated v31 use `api.moveColumn() instead. */ moveColumn(key, toIndex) {
        this.viaApi("moveColumn", key, toIndex);
    }
    /** @deprecated v31 use `api.moveColumnByIndex() instead. */ moveColumnByIndex(fromIndex, toIndex) {
        this.viaApi("moveColumnByIndex", fromIndex, toIndex);
    }
    /** @deprecated v31 use `api.moveColumns() instead. */ moveColumns(columnsToMoveKeys, toIndex) {
        this.viaApi("moveColumns", columnsToMoveKeys, toIndex);
    }
    /** @deprecated v31 use `api.moveRowGroupColumn() instead. */ moveRowGroupColumn(fromIndex, toIndex) {
        this.viaApi("moveRowGroupColumn", fromIndex, toIndex);
    }
    /** @deprecated v31 use `api.setColumnAggFunc() instead. */ setColumnAggFunc(key, aggFunc) {
        this.viaApi("setColumnAggFunc", key, aggFunc);
    }
    /** @deprecated v31 use `api.setColumnWidth() instead. */ setColumnWidth(key, newWidth, finished = true, source) {
        this.viaApi("setColumnWidth", key, newWidth, finished, source);
    }
    /** @deprecated v31 use `api.setColumnWidths() instead. */ setColumnWidths(columnWidths, finished = true, source) {
        this.viaApi("setColumnWidths", columnWidths, finished, source);
    }
    /** @deprecated v31 use `api.setPivotMode() instead. */ setPivotMode(pivotMode) {
        this.viaApi("setPivotMode", pivotMode);
    }
    /** @deprecated v31 use `api.isPivotMode() instead. */ isPivotMode() {
        return this.viaApi("isPivotMode");
    }
    /** @deprecated v31 use `api.getPivotResultColumn() instead. */ getPivotResultColumn(pivotKeys, valueColKey) {
        return this.viaApi("getPivotResultColumn", pivotKeys, valueColKey);
    }
    /** @deprecated v31 use `api.setValueColumns() instead. */ setValueColumns(colKeys) {
        this.viaApi("setValueColumns", colKeys);
    }
    /** @deprecated v31 use `api.getValueColumns() instead. */ getValueColumns() {
        return this.viaApi("getValueColumns");
    }
    /** @deprecated v31 use `api.removeValueColumn() instead. */ removeValueColumn(colKey) {
        this.viaApi("removeValueColumn", colKey);
    }
    /** @deprecated v31 use `api.removeValueColumns() instead. */ removeValueColumns(colKeys) {
        this.viaApi("removeValueColumns", colKeys);
    }
    /** @deprecated v31 use `api.addValueColumn() instead. */ addValueColumn(colKey) {
        this.viaApi("addValueColumn", colKey);
    }
    /** @deprecated v31 use `api.addValueColumns() instead. */ addValueColumns(colKeys) {
        this.viaApi("addValueColumns", colKeys);
    }
    /** @deprecated v31 use `api.setRowGroupColumns() instead. */ setRowGroupColumns(colKeys) {
        this.viaApi("setRowGroupColumns", colKeys);
    }
    /** @deprecated v31 use `api.removeRowGroupColumn() instead. */ removeRowGroupColumn(colKey) {
        this.viaApi("removeRowGroupColumn", colKey);
    }
    /** @deprecated v31 use `api.removeRowGroupColumns() instead. */ removeRowGroupColumns(colKeys) {
        this.viaApi("removeRowGroupColumns", colKeys);
    }
    /** @deprecated v31 use `api.addRowGroupColumn() instead. */ addRowGroupColumn(colKey) {
        this.viaApi("addRowGroupColumn", colKey);
    }
    /** @deprecated v31 use `api.addRowGroupColumns() instead. */ addRowGroupColumns(colKeys) {
        this.viaApi("addRowGroupColumns", colKeys);
    }
    /** @deprecated v31 use `api.getRowGroupColumns() instead. */ getRowGroupColumns() {
        return this.viaApi("getRowGroupColumns");
    }
    /** @deprecated v31 use `api.setPivotColumns() instead. */ setPivotColumns(colKeys) {
        this.viaApi("setPivotColumns", colKeys);
    }
    /** @deprecated v31 use `api.removePivotColumn() instead. */ removePivotColumn(colKey) {
        this.viaApi("removePivotColumn", colKey);
    }
    /** @deprecated v31 use `api.removePivotColumns() instead. */ removePivotColumns(colKeys) {
        this.viaApi("removePivotColumns", colKeys);
    }
    /** @deprecated v31 use `api.addPivotColumn() instead. */ addPivotColumn(colKey) {
        this.viaApi("addPivotColumn", colKey);
    }
    /** @deprecated v31 use `api.addPivotColumns() instead. */ addPivotColumns(colKeys) {
        this.viaApi("addPivotColumns", colKeys);
    }
    /** @deprecated v31 use `api.getPivotColumns() instead. */ getPivotColumns() {
        return this.viaApi("getPivotColumns");
    }
    /** @deprecated v31 use `api.getLeftDisplayedColumnGroups() instead. */ getLeftDisplayedColumnGroups() {
        return this.viaApi("getLeftDisplayedColumnGroups");
    }
    /** @deprecated v31 use `api.getCenterDisplayedColumnGroups() instead. */ getCenterDisplayedColumnGroups() {
        return this.viaApi("getCenterDisplayedColumnGroups");
    }
    /** @deprecated v31 use `api.getRightDisplayedColumnGroups() instead. */ getRightDisplayedColumnGroups() {
        return this.viaApi("getRightDisplayedColumnGroups");
    }
    /** @deprecated v31 use `api.getAllDisplayedColumnGroups() instead. */ getAllDisplayedColumnGroups() {
        return this.viaApi("getAllDisplayedColumnGroups");
    }
    /** @deprecated v31 use `api.autoSizeColumn() instead. */ autoSizeColumn(key, skipHeader) {
        return this.viaApi("autoSizeColumn", key, skipHeader);
    }
    /** @deprecated v31 use `api.autoSizeColumns() instead. */ autoSizeColumns(keys2, skipHeader) {
        this.viaApi("autoSizeColumns", keys2, skipHeader);
    }
    /** @deprecated v31 use `api.autoSizeAllColumns() instead. */ autoSizeAllColumns(skipHeader) {
        this.viaApi("autoSizeAllColumns", skipHeader);
    }
    /** @deprecated v31 use `api.setPivotResultColumns() instead. */ setPivotResultColumns(colDefs) {
        this.viaApi("setPivotResultColumns", colDefs);
    }
    /** @deprecated v31 use `api.getPivotResultColumns() instead. */ getPivotResultColumns() {
        return this.viaApi("getPivotResultColumns");
    }
};
__decorateClass([
    Autowired("gridApi")
], ColumnApi.prototype, "api", 2);
ColumnApi = __decorateClass([
    Bean("columnApi")
], ColumnApi);
// community-modules/core/src/valueService/valueService.ts
var ValueService = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.initialised = false;
        this.isSsrm = false;
    }
    init() {
        this.isSsrm = this.gos.isRowModelType("serverSide");
        this.cellExpressions = this.gos.get("enableCellExpressions");
        this.isTreeData = this.gos.get("treeData");
        this.initialised = true;
        const listener = (event)=>this.callColumnCellValueChangedHandler(event);
        const async = this.gos.useAsyncEvents();
        this.eventService.addEventListener(Events.EVENT_CELL_VALUE_CHANGED, listener, async);
        this.addDestroyFunc(()=>this.eventService.removeEventListener(Events.EVENT_CELL_VALUE_CHANGED, listener, async));
        this.addManagedPropertyListener("treeData", (propChange)=>this.isTreeData = propChange.currentValue);
    }
    getValue(column, rowNode, forFilter = false, ignoreAggData = false) {
        if (!this.initialised) this.init();
        if (!rowNode) return;
        const colDef = column.getColDef();
        const field = colDef.field;
        const colId = column.getColId();
        const data = rowNode.data;
        let result;
        const groupDataExists = rowNode.groupData && rowNode.groupData[colId] !== void 0;
        const aggDataExists = !ignoreAggData && rowNode.aggData && rowNode.aggData[colId] !== void 0;
        const ignoreSsrmAggData = this.isSsrm && ignoreAggData && !!column.getColDef().aggFunc;
        const ssrmFooterGroupCol = this.isSsrm && rowNode.footer && rowNode.field && (column.getColDef().showRowGroup === true || column.getColDef().showRowGroup === rowNode.field);
        if (forFilter && colDef.filterValueGetter) result = this.executeFilterValueGetter(colDef.filterValueGetter, data, column, rowNode);
        else if (this.isTreeData && aggDataExists) result = rowNode.aggData[colId];
        else if (this.isTreeData && colDef.valueGetter) result = this.executeValueGetter(colDef.valueGetter, data, column, rowNode);
        else if (this.isTreeData && field && data) result = getValueUsingField(data, field, column.isFieldContainsDots());
        else if (groupDataExists) result = rowNode.groupData[colId];
        else if (aggDataExists) result = rowNode.aggData[colId];
        else if (colDef.valueGetter) result = this.executeValueGetter(colDef.valueGetter, data, column, rowNode);
        else if (ssrmFooterGroupCol) result = getValueUsingField(data, rowNode.field, column.isFieldContainsDots());
        else if (field && data && !ignoreSsrmAggData) result = getValueUsingField(data, field, column.isFieldContainsDots());
        if (this.cellExpressions && typeof result === "string" && result.indexOf("=") === 0) {
            const cellValueGetter = result.substring(1);
            result = this.executeValueGetter(cellValueGetter, data, column, rowNode);
        }
        if (result == null) {
            const openedGroup = this.getOpenedGroup(rowNode, column);
            if (openedGroup != null) return openedGroup;
        }
        return result;
    }
    parseValue(column, rowNode, newValue, oldValue) {
        const colDef = column.getColDef();
        const params = this.gos.addGridCommonParams({
            node: rowNode,
            data: rowNode == null ? void 0 : rowNode.data,
            oldValue,
            newValue,
            colDef,
            column
        });
        const valueParser = colDef.valueParser;
        if (exists(valueParser)) {
            if (typeof valueParser === "function") return valueParser(params);
            return this.expressionService.evaluate(valueParser, params);
        }
        return newValue;
    }
    formatValue(column, node, value, suppliedFormatter, useFormatterFromColumn = true) {
        let result = null;
        let formatter;
        const colDef = column.getColDef();
        if (suppliedFormatter) formatter = suppliedFormatter;
        else if (useFormatterFromColumn) formatter = colDef.valueFormatter;
        if (formatter) {
            const params = this.gos.addGridCommonParams({
                value,
                node,
                data: node ? node.data : null,
                colDef,
                column
            });
            if (typeof formatter === "function") result = formatter(params);
            else result = this.expressionService.evaluate(formatter, params);
        } else if (colDef.refData) return colDef.refData[value] || "";
        if (result == null && Array.isArray(value)) result = value.join(", ");
        return result;
    }
    getOpenedGroup(rowNode, column) {
        if (!this.gos.get("showOpenedGroup")) return;
        const colDef = column.getColDef();
        if (!colDef.showRowGroup) return;
        const showRowGroup = column.getColDef().showRowGroup;
        let pointer = rowNode.parent;
        while(pointer != null){
            if (pointer.rowGroupColumn && (showRowGroup === true || showRowGroup === pointer.rowGroupColumn.getColId())) return pointer.key;
            pointer = pointer.parent;
        }
        return void 0;
    }
    /**
   * Sets the value of a GridCell
   * @param rowNode The `RowNode` to be updated
   * @param colKey The `Column` to be updated
   * @param newValue The new value to be set
   * @param eventSource The event source
   * @returns `True` if the value has been updated, otherwise`False`.
   */ setValue(rowNode, colKey, newValue, eventSource) {
        const column = this.columnModel.getPrimaryColumn(colKey);
        if (!rowNode || !column) return false;
        if (missing(rowNode.data)) rowNode.data = {};
        const { field, valueSetter } = column.getColDef();
        if (missing(field) && missing(valueSetter)) {
            console.warn(`AG Grid: you need either field or valueSetter set on colDef for editing to work`);
            return false;
        }
        if (!this.dataTypeService.checkType(column, newValue)) {
            console.warn(`AG Grid: Data type of the new value does not match the cell data type of the column`);
            return false;
        }
        const params = this.gos.addGridCommonParams({
            node: rowNode,
            data: rowNode.data,
            oldValue: this.getValue(column, rowNode),
            newValue,
            colDef: column.getColDef(),
            column
        });
        params.newValue = newValue;
        let valueWasDifferent;
        if (exists(valueSetter)) {
            if (typeof valueSetter === "function") valueWasDifferent = valueSetter(params);
            else valueWasDifferent = this.expressionService.evaluate(valueSetter, params);
        } else valueWasDifferent = this.setValueUsingField(rowNode.data, field, newValue, column.isFieldContainsDots());
        if (valueWasDifferent === void 0) valueWasDifferent = true;
        if (!valueWasDifferent) return false;
        rowNode.resetQuickFilterAggregateText();
        this.valueCache.onDataChanged();
        params.newValue = this.getValue(column, rowNode);
        const event = {
            type: Events.EVENT_CELL_VALUE_CHANGED,
            event: null,
            rowIndex: rowNode.rowIndex,
            rowPinned: rowNode.rowPinned,
            column: params.column,
            api: params.api,
            columnApi: params.columnApi,
            colDef: params.colDef,
            context: params.context,
            data: rowNode.data,
            node: rowNode,
            oldValue: params.oldValue,
            newValue: params.newValue,
            value: params.newValue,
            source: eventSource
        };
        this.eventService.dispatchEvent(event);
        return true;
    }
    callColumnCellValueChangedHandler(event) {
        const onCellValueChanged = event.colDef.onCellValueChanged;
        if (typeof onCellValueChanged === "function") this.getFrameworkOverrides().wrapOutgoing(()=>{
            onCellValueChanged({
                node: event.node,
                data: event.data,
                oldValue: event.oldValue,
                newValue: event.newValue,
                colDef: event.colDef,
                column: event.column,
                api: event.api,
                columnApi: event.columnApi,
                context: event.context
            });
        });
    }
    setValueUsingField(data, field, newValue, isFieldContainsDots) {
        if (!field) return false;
        let valuesAreSame = false;
        if (!isFieldContainsDots) {
            valuesAreSame = data[field] === newValue;
            if (!valuesAreSame) data[field] = newValue;
        } else {
            const fieldPieces = field.split(".");
            let currentObject = data;
            while(fieldPieces.length > 0 && currentObject){
                const fieldPiece = fieldPieces.shift();
                if (fieldPieces.length === 0) {
                    valuesAreSame = currentObject[fieldPiece] === newValue;
                    if (!valuesAreSame) currentObject[fieldPiece] = newValue;
                } else currentObject = currentObject[fieldPiece];
            }
        }
        return !valuesAreSame;
    }
    executeFilterValueGetter(valueGetter, data, column, rowNode) {
        const params = this.gos.addGridCommonParams({
            data,
            node: rowNode,
            column,
            colDef: column.getColDef(),
            getValue: this.getValueCallback.bind(this, rowNode)
        });
        if (typeof valueGetter === "function") return valueGetter(params);
        return this.expressionService.evaluate(valueGetter, params);
    }
    executeValueGetter(valueGetter, data, column, rowNode) {
        const colId = column.getColId();
        const valueFromCache = this.valueCache.getValue(rowNode, colId);
        if (valueFromCache !== void 0) return valueFromCache;
        const params = this.gos.addGridCommonParams({
            data,
            node: rowNode,
            column,
            colDef: column.getColDef(),
            getValue: this.getValueCallback.bind(this, rowNode)
        });
        let result;
        if (typeof valueGetter === "function") result = valueGetter(params);
        else result = this.expressionService.evaluate(valueGetter, params);
        this.valueCache.setValue(rowNode, colId, result);
        return result;
    }
    getValueCallback(node, field) {
        const otherColumn = this.columnModel.getPrimaryColumn(field);
        if (otherColumn) return this.getValue(otherColumn, node);
        return null;
    }
    // used by row grouping and pivot, to get key for a row. col can be a pivot col or a row grouping col
    getKeyForNode(col, rowNode) {
        const value = this.getValue(col, rowNode);
        const keyCreator = col.getColDef().keyCreator;
        let result = value;
        if (keyCreator) {
            const keyParams = this.gos.addGridCommonParams({
                value,
                colDef: col.getColDef(),
                column: col,
                node: rowNode,
                data: rowNode.data
            });
            result = keyCreator(keyParams);
        }
        if (typeof result === "string" || result == null) return result;
        result = String(result);
        if (result === "[object Object]") warnOnce("a column you are grouping or pivoting by has objects as values. If you want to group by complex objects then either a) use a colDef.keyCreator (se AG Grid docs) or b) to toString() on the object to return a key");
        return result;
    }
};
__decorateClass([
    Autowired("expressionService")
], ValueService.prototype, "expressionService", 2);
__decorateClass([
    Autowired("columnModel")
], ValueService.prototype, "columnModel", 2);
__decorateClass([
    Autowired("valueCache")
], ValueService.prototype, "valueCache", 2);
__decorateClass([
    Autowired("dataTypeService")
], ValueService.prototype, "dataTypeService", 2);
__decorateClass([
    PostConstruct
], ValueService.prototype, "init", 1);
ValueService = __decorateClass([
    Bean("valueService")
], ValueService);
// community-modules/core/src/valueService/expressionService.ts
var ExpressionService = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.expressionToFunctionCache = {};
    }
    setBeans(loggerFactory) {
        this.logger = loggerFactory.create("ExpressionService");
    }
    evaluate(expression, params) {
        if (typeof expression === "string") return this.evaluateExpression(expression, params);
        else console.error("AG Grid: value should be either a string or a function", expression);
    }
    evaluateExpression(expression, params) {
        try {
            const javaScriptFunction = this.createExpressionFunction(expression);
            const result = javaScriptFunction(params.value, params.context, params.oldValue, params.newValue, params.value, params.node, params.data, params.colDef, params.rowIndex, params.api, params.columnApi, params.getValue, params.column, params.columnGroup);
            return result;
        } catch (e) {
            console.log("Processing of the expression failed");
            console.log("Expression = " + expression);
            console.log("Params =", params);
            console.log("Exception = " + e);
            return null;
        }
    }
    createExpressionFunction(expression) {
        if (this.expressionToFunctionCache[expression]) return this.expressionToFunctionCache[expression];
        const functionBody = this.createFunctionBody(expression);
        const theFunction = new Function("x, ctx, oldValue, newValue, value, node, data, colDef, rowIndex, api, columnApi, getValue, column, columnGroup", functionBody);
        this.expressionToFunctionCache[expression] = theFunction;
        return theFunction;
    }
    createFunctionBody(expression) {
        if (expression.indexOf("return") >= 0) return expression;
        else return "return " + expression + ";";
    }
};
__decorateClass([
    __decorateParam(0, Qualifier("loggerFactory"))
], ExpressionService.prototype, "setBeans", 1);
ExpressionService = __decorateClass([
    Bean("expressionService")
], ExpressionService);
// community-modules/core/src/logger.ts
var LoggerFactory = class extends BeanStub {
    setBeans(gos) {
        this.logging = gos.get("debug");
    }
    create(name) {
        return new Logger(name, this.isLogging.bind(this));
    }
    isLogging() {
        return this.logging;
    }
};
__decorateClass([
    __decorateParam(0, Qualifier("gridOptionsService"))
], LoggerFactory.prototype, "setBeans", 1);
LoggerFactory = __decorateClass([
    Bean("loggerFactory")
], LoggerFactory);
var Logger = class {
    constructor(name, isLoggingFunc){
        this.name = name;
        this.isLoggingFunc = isLoggingFunc;
    }
    isLogging() {
        return this.isLoggingFunc();
    }
    log(message) {
        if (this.isLoggingFunc()) console.log("AG Grid." + this.name + ": " + message);
    }
};
// community-modules/core/src/gridComp/gridCtrl.ts
var GridCtrl = class extends BeanStub {
    setComp(view, eGridDiv, eGui) {
        this.view = view;
        this.eGridHostDiv = eGridDiv;
        this.eGui = eGui;
        this.eGui.setAttribute("grid-id", this.context.getGridId());
        this.dragAndDropService.addDropTarget({
            getContainer: ()=>this.eGui,
            isInterestedIn: (type)=>type === 1 /* HeaderCell */  || type === 0 /* ToolPanel */ ,
            getIconName: ()=>DragAndDropService.ICON_NOT_ALLOWED
        });
        this.mouseEventService.stampTopLevelGridCompWithGridInstance(eGridDiv);
        this.createManagedBean(new LayoutFeature(this.view));
        this.addRtlSupport();
        const unsubscribeFromResize = this.resizeObserverService.observeResize(this.eGridHostDiv, this.onGridSizeChanged.bind(this));
        this.addDestroyFunc(()=>unsubscribeFromResize());
        this.ctrlsService.register("gridCtrl", this);
    }
    isDetailGrid() {
        var _a;
        const el = this.focusService.findTabbableParent(this.getGui());
        return ((_a = el == null ? void 0 : el.getAttribute("row-id")) == null ? void 0 : _a.startsWith("detail")) || false;
    }
    showDropZones() {
        return ModuleRegistry.__isRegistered("@ag-grid-enterprise/row-grouping" /* RowGroupingModule */ , this.context.getGridId());
    }
    showSideBar() {
        return ModuleRegistry.__isRegistered("@ag-grid-enterprise/side-bar" /* SideBarModule */ , this.context.getGridId());
    }
    showStatusBar() {
        return ModuleRegistry.__isRegistered("@ag-grid-enterprise/status-bar" /* StatusBarModule */ , this.context.getGridId());
    }
    showWatermark() {
        return ModuleRegistry.__isRegistered("@ag-grid-enterprise/core" /* EnterpriseCoreModule */ , this.context.getGridId());
    }
    onGridSizeChanged() {
        const event = {
            type: Events.EVENT_GRID_SIZE_CHANGED,
            clientWidth: this.eGridHostDiv.clientWidth,
            clientHeight: this.eGridHostDiv.clientHeight
        };
        this.eventService.dispatchEvent(event);
    }
    addRtlSupport() {
        const cssClass = this.gos.get("enableRtl") ? "ag-rtl" : "ag-ltr";
        this.view.setRtlClass(cssClass);
    }
    destroyGridUi() {
        this.view.destroyGridUi();
    }
    getGui() {
        return this.eGui;
    }
    setResizeCursor(on) {
        this.view.setCursor(on ? "ew-resize" : null);
    }
    disableUserSelect(on) {
        this.view.setUserSelect(on ? "none" : null);
    }
    focusNextInnerContainer(backwards) {
        const focusableContainers = this.view.getFocusableContainers();
        const activeEl = this.gos.getActiveDomElement();
        const idxWithFocus = focusableContainers.findIndex((container)=>container.contains(activeEl));
        const nextIdx = idxWithFocus + (backwards ? -1 : 1);
        if (nextIdx <= 0 || nextIdx >= focusableContainers.length) return false;
        return this.focusService.focusInto(focusableContainers[nextIdx]);
    }
    focusInnerElement(fromBottom) {
        const focusableContainers = this.view.getFocusableContainers();
        const allColumns = this.columnModel.getAllDisplayedColumns();
        if (fromBottom) {
            if (focusableContainers.length > 1) return this.focusService.focusInto(last(focusableContainers), true);
            const lastColumn = last(allColumns);
            if (this.focusService.focusGridView(lastColumn, true)) return true;
        }
        if (this.gos.get("headerHeight") === 0 || this.gos.get("suppressHeaderFocus")) {
            if (this.focusService.focusGridView(allColumns[0])) return true;
            for(let i = 1; i < focusableContainers.length; i++){
                if (this.focusService.focusInto(focusableContainers[i])) return true;
            }
            return false;
        }
        return this.focusService.focusFirstHeader();
    }
    forceFocusOutOfContainer(up = false) {
        this.view.forceFocusOutOfContainer(up);
    }
};
__decorateClass([
    Autowired("focusService")
], GridCtrl.prototype, "focusService", 2);
__decorateClass([
    Autowired("resizeObserverService")
], GridCtrl.prototype, "resizeObserverService", 2);
__decorateClass([
    Autowired("columnModel")
], GridCtrl.prototype, "columnModel", 2);
__decorateClass([
    Autowired("ctrlsService")
], GridCtrl.prototype, "ctrlsService", 2);
__decorateClass([
    Autowired("mouseEventService")
], GridCtrl.prototype, "mouseEventService", 2);
__decorateClass([
    Autowired("dragAndDropService")
], GridCtrl.prototype, "dragAndDropService", 2);
// community-modules/core/src/gridComp/gridComp.ts
var GridComp = class extends TabGuardComp {
    constructor(eGridDiv){
        super();
        this.eGridDiv = eGridDiv;
    }
    postConstruct() {
        this.logger = this.loggerFactory.create("GridComp");
        const compProxy = {
            destroyGridUi: ()=>this.destroyBean(this),
            setRtlClass: (cssClass)=>this.addCssClass(cssClass),
            forceFocusOutOfContainer: this.forceFocusOutOfContainer.bind(this),
            updateLayoutClasses: this.updateLayoutClasses.bind(this),
            getFocusableContainers: this.getFocusableContainers.bind(this),
            setUserSelect: (value)=>{
                this.getGui().style.userSelect = value != null ? value : "";
                this.getGui().style.webkitUserSelect = value != null ? value : "";
            },
            setCursor: (value)=>{
                this.getGui().style.cursor = value != null ? value : "";
            }
        };
        this.ctrl = this.createManagedBean(new GridCtrl());
        const template = this.createTemplate();
        this.setTemplate(template);
        this.ctrl.setComp(compProxy, this.eGridDiv, this.getGui());
        this.insertGridIntoDom();
        this.initialiseTabGuard({
            // we want to override the default behaviour to do nothing for onTabKeyDown
            onTabKeyDown: ()=>void 0,
            focusInnerElement: (fromBottom)=>this.ctrl.focusInnerElement(fromBottom),
            forceFocusOutWhenTabGuardsAreEmpty: true
        });
    }
    insertGridIntoDom() {
        const eGui = this.getGui();
        this.eGridDiv.appendChild(eGui);
        this.addDestroyFunc(()=>{
            this.eGridDiv.removeChild(eGui);
            this.logger.log("Grid removed from DOM");
        });
    }
    updateLayoutClasses(cssClass, params) {
        const eRootWrapperBodyClassList = this.eRootWrapperBody.classList;
        eRootWrapperBodyClassList.toggle("ag-layout-auto-height" /* AUTO_HEIGHT */ , params.autoHeight);
        eRootWrapperBodyClassList.toggle("ag-layout-normal" /* NORMAL */ , params.normal);
        eRootWrapperBodyClassList.toggle("ag-layout-print" /* PRINT */ , params.print);
        this.addOrRemoveCssClass("ag-layout-auto-height" /* AUTO_HEIGHT */ , params.autoHeight);
        this.addOrRemoveCssClass("ag-layout-normal" /* NORMAL */ , params.normal);
        this.addOrRemoveCssClass("ag-layout-print" /* PRINT */ , params.print);
    }
    createTemplate() {
        const dropZones = this.ctrl.showDropZones() ? "<ag-grid-header-drop-zones></ag-grid-header-drop-zones>" : "";
        const sideBar = this.ctrl.showSideBar() ? '<ag-side-bar ref="sideBar"></ag-side-bar>' : "";
        const statusBar = this.ctrl.showStatusBar() ? '<ag-status-bar ref="statusBar"></ag-status-bar>' : "";
        const watermark = this.ctrl.showWatermark() ? "<ag-watermark></ag-watermark>" : "";
        const template = /* html */ `<div class="ag-root-wrapper" role="presentation">
                ${dropZones}
                <div class="ag-root-wrapper-body" ref="rootWrapperBody" role="presentation">
                    <ag-grid-body ref="gridBody"></ag-grid-body>
                    ${sideBar}
                </div>
                ${statusBar}
                <ag-pagination></ag-pagination>
                ${watermark}
            </div>`;
        return template;
    }
    getFocusableElement() {
        return this.eRootWrapperBody;
    }
    getFocusableContainers() {
        const focusableContainers = [
            this.gridBodyComp.getGui()
        ];
        if (this.sideBarComp) focusableContainers.push(this.sideBarComp.getGui());
        return focusableContainers.filter((el)=>isVisible(el));
    }
};
__decorateClass([
    Autowired("loggerFactory")
], GridComp.prototype, "loggerFactory", 2);
__decorateClass([
    RefSelector("gridBody")
], GridComp.prototype, "gridBodyComp", 2);
__decorateClass([
    RefSelector("sideBar")
], GridComp.prototype, "sideBarComp", 2);
__decorateClass([
    RefSelector("rootWrapperBody")
], GridComp.prototype, "eRootWrapperBody", 2);
__decorateClass([
    PostConstruct
], GridComp.prototype, "postConstruct", 1);
// community-modules/core/src/sortController.ts
var SortController = class extends BeanStub {
    progressSort(column, multiSort, source) {
        const nextDirection = this.getNextSortDirection(column);
        this.setSortForColumn(column, nextDirection, multiSort, source);
    }
    setSortForColumn(column, sort, multiSort, source) {
        if (sort !== "asc" && sort !== "desc") sort = null;
        const isColumnsSortingCoupledToGroup = this.gos.isColumnsSortingCoupledToGroup();
        let columnsToUpdate = [
            column
        ];
        if (isColumnsSortingCoupledToGroup) {
            if (column.getColDef().showRowGroup) {
                const rowGroupColumns = this.columnModel.getSourceColumnsForGroupColumn(column);
                const sortableRowGroupColumns = rowGroupColumns == null ? void 0 : rowGroupColumns.filter((col)=>col.isSortable());
                if (sortableRowGroupColumns) columnsToUpdate = [
                    column,
                    ...sortableRowGroupColumns
                ];
            }
        }
        columnsToUpdate.forEach((col)=>col.setSort(sort, source));
        const doingMultiSort = (multiSort || this.gos.get("alwaysMultiSort")) && !this.gos.get("suppressMultiSort");
        const updatedColumns = [];
        if (!doingMultiSort) {
            const clearedColumns = this.clearSortBarTheseColumns(columnsToUpdate, source);
            updatedColumns.push(...clearedColumns);
        }
        this.updateSortIndex(column);
        updatedColumns.push(...columnsToUpdate);
        this.dispatchSortChangedEvents(source, updatedColumns);
    }
    updateSortIndex(lastColToChange) {
        const isCoupled = this.gos.isColumnsSortingCoupledToGroup();
        const groupParent = this.columnModel.getGroupDisplayColumnForGroup(lastColToChange.getId());
        const lastSortIndexCol = isCoupled ? groupParent || lastColToChange : lastColToChange;
        const allSortedCols = this.getColumnsWithSortingOrdered();
        this.columnModel.getPrimaryAndSecondaryAndAutoColumns().forEach((col)=>col.setSortIndex(null));
        const allSortedColsWithoutChangesOrGroups = allSortedCols.filter((col)=>{
            if (isCoupled && col.getColDef().showRowGroup) return false;
            return col !== lastSortIndexCol;
        });
        const sortedColsWithIndices = !!lastSortIndexCol.getSort() ? [
            ...allSortedColsWithoutChangesOrGroups,
            lastSortIndexCol
        ] : allSortedColsWithoutChangesOrGroups;
        sortedColsWithIndices.forEach((col, idx)=>{
            col.setSortIndex(idx);
        });
    }
    // gets called by API, so if data changes, use can call this, which will end up
    // working out the sort order again of the rows.
    onSortChanged(source, columns) {
        this.dispatchSortChangedEvents(source, columns);
    }
    isSortActive() {
        const allCols = this.columnModel.getPrimaryAndSecondaryAndAutoColumns();
        const sortedCols = allCols.filter((column)=>!!column.getSort());
        return sortedCols && sortedCols.length > 0;
    }
    dispatchSortChangedEvents(source, columns) {
        const event = {
            type: Events.EVENT_SORT_CHANGED,
            source
        };
        if (columns) event.columns = columns;
        this.eventService.dispatchEvent(event);
    }
    clearSortBarTheseColumns(columnsToSkip, source) {
        const clearedColumns = [];
        this.columnModel.getPrimaryAndSecondaryAndAutoColumns().forEach((columnToClear)=>{
            if (!columnsToSkip.includes(columnToClear)) {
                if (!!columnToClear.getSort()) clearedColumns.push(columnToClear);
                columnToClear.setSort(void 0, source);
            }
        });
        return clearedColumns;
    }
    getNextSortDirection(column) {
        let sortingOrder;
        if (column.getColDef().sortingOrder) sortingOrder = column.getColDef().sortingOrder;
        else if (this.gos.get("sortingOrder")) sortingOrder = this.gos.get("sortingOrder");
        else sortingOrder = SortController.DEFAULT_SORTING_ORDER;
        if (!Array.isArray(sortingOrder) || sortingOrder.length <= 0) {
            console.warn(`AG Grid: sortingOrder must be an array with at least one element, currently it's ${sortingOrder}`);
            return null;
        }
        const currentIndex = sortingOrder.indexOf(column.getSort());
        const notInArray = currentIndex < 0;
        const lastItemInArray = currentIndex == sortingOrder.length - 1;
        let result;
        if (notInArray || lastItemInArray) result = sortingOrder[0];
        else result = sortingOrder[currentIndex + 1];
        if (SortController.DEFAULT_SORTING_ORDER.indexOf(result) < 0) {
            console.warn("AG Grid: invalid sort type " + result);
            return null;
        }
        return result;
    }
    /**
   * @returns a map of sort indexes for every sorted column, if groups sort primaries then they will have equivalent indices
   */ getIndexedSortMap() {
        let allSortedCols = this.columnModel.getPrimaryAndSecondaryAndAutoColumns().filter((col)=>!!col.getSort());
        if (this.columnModel.isPivotMode()) {
            const isSortingLinked = this.gos.isColumnsSortingCoupledToGroup();
            allSortedCols = allSortedCols.filter((col)=>{
                const isAggregated = !!col.getAggFunc();
                const isSecondary = !col.isPrimary();
                const isGroup = isSortingLinked ? this.columnModel.getGroupDisplayColumnForGroup(col.getId()) : col.getColDef().showRowGroup;
                return isAggregated || isSecondary || isGroup;
            });
        }
        const sortedRowGroupCols = this.columnModel.getRowGroupColumns().filter((col)=>!!col.getSort());
        const allColsIndexes = {};
        allSortedCols.forEach((col, index)=>allColsIndexes[col.getId()] = index);
        allSortedCols.sort((a, b)=>{
            const iA = a.getSortIndex();
            const iB = b.getSortIndex();
            if (iA != null && iB != null) return iA - iB;
            else if (iA == null && iB == null) {
                const posA = allColsIndexes[a.getId()];
                const posB = allColsIndexes[b.getId()];
                return posA > posB ? 1 : -1;
            } else if (iB == null) return -1;
            else return 1;
        });
        const isSortLinked = this.gos.isColumnsSortingCoupledToGroup() && !!sortedRowGroupCols.length;
        if (isSortLinked) allSortedCols = [
            ...new Set(// if linked sorting, replace all columns with the display group column for index purposes, and ensure uniqueness
            allSortedCols.map((col)=>{
                var _a;
                return (_a = this.columnModel.getGroupDisplayColumnForGroup(col.getId())) != null ? _a : col;
            }))
        ];
        const indexMap = /* @__PURE__ */ new Map();
        allSortedCols.forEach((col, idx)=>indexMap.set(col, idx));
        if (isSortLinked) sortedRowGroupCols.forEach((col)=>{
            const groupDisplayCol = this.columnModel.getGroupDisplayColumnForGroup(col.getId());
            indexMap.set(col, indexMap.get(groupDisplayCol));
        });
        return indexMap;
    }
    getColumnsWithSortingOrdered() {
        return [
            ...this.getIndexedSortMap().entries()
        ].sort(([col1, idx1], [col2, idx2])=>idx1 - idx2).map(([col])=>col);
    }
    // used by server side row models, to sent sort to server
    getSortModel() {
        return this.getColumnsWithSortingOrdered().filter((column)=>column.getSort()).map((column)=>({
                sort: column.getSort(),
                colId: column.getId()
            }));
    }
    getSortOptions() {
        return this.getColumnsWithSortingOrdered().filter((column)=>column.getSort()).map((column)=>({
                sort: column.getSort(),
                column
            }));
    }
    canColumnDisplayMixedSort(column) {
        const isColumnSortCouplingActive = this.gos.isColumnsSortingCoupledToGroup();
        const isGroupDisplayColumn = !!column.getColDef().showRowGroup;
        return isColumnSortCouplingActive && isGroupDisplayColumn;
    }
    getDisplaySortForColumn(column) {
        const linkedColumns = this.columnModel.getSourceColumnsForGroupColumn(column);
        if (!this.canColumnDisplayMixedSort(column) || !(linkedColumns == null ? void 0 : linkedColumns.length)) return column.getSort();
        const columnHasUniqueData = column.getColDef().field != null || !!column.getColDef().valueGetter;
        const sortableColumns = columnHasUniqueData ? [
            column,
            ...linkedColumns
        ] : linkedColumns;
        const firstSort = sortableColumns[0].getSort();
        const allMatch = sortableColumns.every((col)=>col.getSort() == firstSort);
        if (!allMatch) return "mixed";
        return firstSort;
    }
    getDisplaySortIndexForColumn(column) {
        return this.getIndexedSortMap().get(column);
    }
};
SortController.DEFAULT_SORTING_ORDER = [
    "asc",
    "desc",
    null
];
__decorateClass([
    Autowired("columnModel")
], SortController.prototype, "columnModel", 2);
SortController = __decorateClass([
    Bean("sortController")
], SortController);
// community-modules/core/src/focusService.ts
var FocusService = class extends BeanStub {
    static addKeyboardModeEvents(doc) {
        if (this.instanceCount > 0) return;
        doc.addEventListener("keydown", FocusService.toggleKeyboardMode);
        doc.addEventListener("mousedown", FocusService.toggleKeyboardMode);
    }
    static removeKeyboardModeEvents(doc) {
        if (this.instanceCount > 0) return;
        doc.addEventListener("keydown", FocusService.toggleKeyboardMode);
        doc.addEventListener("mousedown", FocusService.toggleKeyboardMode);
    }
    static toggleKeyboardMode(event) {
        const isKeyboardActive = FocusService.keyboardModeActive;
        const isKeyboardEvent = event.type === "keydown";
        if (isKeyboardEvent) {
            if (event.ctrlKey || event.metaKey || event.altKey) return;
        }
        if (isKeyboardActive === isKeyboardEvent) return;
        FocusService.keyboardModeActive = isKeyboardEvent;
    }
    static unregisterGridCompController(doc) {
        FocusService.removeKeyboardModeEvents(doc);
    }
    init() {
        const clearFocusedCellListener = this.clearFocusedCell.bind(this);
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, clearFocusedCellListener);
        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.onColumnEverythingChanged.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_GROUP_OPENED, clearFocusedCellListener);
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, clearFocusedCellListener);
        this.registerKeyboardFocusEvents();
        this.ctrlsService.whenReady((p)=>{
            this.gridCtrl = p.gridCtrl;
        });
    }
    registerKeyboardFocusEvents() {
        const eDocument = this.gos.getDocument();
        FocusService.addKeyboardModeEvents(eDocument);
        FocusService.instanceCount++;
        this.addDestroyFunc(()=>{
            FocusService.instanceCount--;
            FocusService.unregisterGridCompController(eDocument);
        });
    }
    onColumnEverythingChanged() {
        if (!this.focusedCellPosition) return;
        const col = this.focusedCellPosition.column;
        const colFromColumnModel = this.columnModel.getGridColumn(col.getId());
        if (col !== colFromColumnModel) this.clearFocusedCell();
    }
    isKeyboardMode() {
        return FocusService.keyboardModeActive;
    }
    // we check if the browser is focusing something, and if it is, and
    // it's the cell we think is focused, then return the cell. so this
    // methods returns the cell if a) we think it has focus and b) the
    // browser thinks it has focus. this then returns nothing if we
    // first focus a cell, then second click outside the grid, as then the
    // grid cell will still be focused as far as the grid is concerned,
    // however the browser focus will have moved somewhere else.
    getFocusCellToUseAfterRefresh() {
        if (this.gos.get("suppressFocusAfterRefresh") || !this.focusedCellPosition) return null;
        if (this.isDomDataMissingInHierarchy(this.gos.getActiveDomElement(), RowCtrl.DOM_DATA_KEY_ROW_CTRL)) return null;
        return this.focusedCellPosition;
    }
    getFocusHeaderToUseAfterRefresh() {
        if (this.gos.get("suppressFocusAfterRefresh") || !this.focusedHeaderPosition) return null;
        if (this.isDomDataMissingInHierarchy(this.gos.getActiveDomElement(), AbstractHeaderCellCtrl.DOM_DATA_KEY_HEADER_CTRL)) return null;
        return this.focusedHeaderPosition;
    }
    isDomDataMissingInHierarchy(eBrowserCell, key) {
        let ePointer = eBrowserCell;
        while(ePointer){
            const data = this.gos.getDomData(ePointer, key);
            if (data) return false;
            ePointer = ePointer.parentNode;
        }
        return true;
    }
    getFocusedCell() {
        return this.focusedCellPosition;
    }
    shouldRestoreFocus(cell) {
        if (this.isCellRestoreFocused(cell)) {
            setTimeout(()=>{
                this.restoredFocusedCellPosition = null;
            }, 0);
            return true;
        }
        return false;
    }
    isCellRestoreFocused(cellPosition) {
        if (this.restoredFocusedCellPosition == null) return false;
        return this.cellPositionUtils.equals(cellPosition, this.restoredFocusedCellPosition);
    }
    setRestoreFocusedCell(cellPosition) {
        if (this.getFrameworkOverrides().renderingEngine === "react") this.restoredFocusedCellPosition = cellPosition;
    }
    getFocusEventParams() {
        const { rowIndex, rowPinned, column } = this.focusedCellPosition;
        const params = {
            rowIndex,
            rowPinned,
            column,
            isFullWidthCell: false
        };
        const rowCtrl = this.rowRenderer.getRowByPosition({
            rowIndex,
            rowPinned
        });
        if (rowCtrl) params.isFullWidthCell = rowCtrl.isFullWidth();
        return params;
    }
    clearFocusedCell() {
        this.restoredFocusedCellPosition = null;
        if (this.focusedCellPosition == null) return;
        const event = __spreadValues({
            type: Events.EVENT_CELL_FOCUS_CLEARED
        }, this.getFocusEventParams());
        this.focusedCellPosition = null;
        this.eventService.dispatchEvent(event);
    }
    setFocusedCell(params) {
        const { column, rowIndex, rowPinned, forceBrowserFocus = false, preventScrollOnBrowserFocus = false } = params;
        const gridColumn = this.columnModel.getGridColumn(column);
        if (!gridColumn) {
            this.focusedCellPosition = null;
            return;
        }
        this.focusedCellPosition = gridColumn ? {
            rowIndex,
            rowPinned: makeNull(rowPinned),
            column: gridColumn
        } : null;
        const event = __spreadProps(__spreadValues({
            type: Events.EVENT_CELL_FOCUSED
        }, this.getFocusEventParams()), {
            forceBrowserFocus,
            preventScrollOnBrowserFocus,
            floating: null
        });
        this.eventService.dispatchEvent(event);
    }
    isCellFocused(cellPosition) {
        if (this.focusedCellPosition == null) return false;
        return this.cellPositionUtils.equals(cellPosition, this.focusedCellPosition);
    }
    isRowNodeFocused(rowNode) {
        return this.isRowFocused(rowNode.rowIndex, rowNode.rowPinned);
    }
    isHeaderWrapperFocused(headerCtrl) {
        if (this.focusedHeaderPosition == null) return false;
        const column = headerCtrl.getColumnGroupChild();
        const headerRowIndex = headerCtrl.getRowIndex();
        const pinned = headerCtrl.getPinned();
        const { column: focusedColumn, headerRowIndex: focusedHeaderRowIndex } = this.focusedHeaderPosition;
        return column === focusedColumn && headerRowIndex === focusedHeaderRowIndex && pinned == focusedColumn.getPinned();
    }
    clearFocusedHeader() {
        this.focusedHeaderPosition = null;
    }
    getFocusedHeader() {
        return this.focusedHeaderPosition;
    }
    setFocusedHeader(headerRowIndex, column) {
        this.focusedHeaderPosition = {
            headerRowIndex,
            column
        };
    }
    focusHeaderPosition(params) {
        if (this.gos.get("suppressHeaderFocus")) return false;
        const { direction, fromTab, allowUserOverride, event, fromCell, rowWithoutSpanValue } = params;
        let { headerPosition } = params;
        if (fromCell && this.filterManager.isAdvancedFilterHeaderActive()) return this.focusAdvancedFilter(headerPosition);
        if (allowUserOverride) {
            const currentPosition = this.getFocusedHeader();
            const headerRowCount = this.headerNavigationService.getHeaderRowCount();
            if (fromTab) {
                const userFunc = this.gos.getCallback("tabToNextHeader");
                if (userFunc) headerPosition = this.getHeaderPositionFromUserFunc({
                    userFunc,
                    direction,
                    currentPosition,
                    headerPosition,
                    headerRowCount
                });
            } else {
                const userFunc = this.gos.getCallback("navigateToNextHeader");
                if (userFunc && event) {
                    const params2 = {
                        key: event.key,
                        previousHeaderPosition: currentPosition,
                        nextHeaderPosition: headerPosition,
                        headerRowCount,
                        event
                    };
                    headerPosition = userFunc(params2);
                }
            }
        }
        if (!headerPosition) return false;
        return this.focusProvidedHeaderPosition({
            headerPosition,
            direction,
            event,
            fromCell,
            rowWithoutSpanValue
        });
    }
    focusHeaderPositionFromUserFunc(params) {
        if (this.gos.get("suppressHeaderFocus")) return false;
        const { userFunc, headerPosition, direction, event } = params;
        const currentPosition = this.getFocusedHeader();
        const headerRowCount = this.headerNavigationService.getHeaderRowCount();
        const newHeaderPosition = this.getHeaderPositionFromUserFunc({
            userFunc,
            direction,
            currentPosition,
            headerPosition,
            headerRowCount
        });
        return !!newHeaderPosition && this.focusProvidedHeaderPosition({
            headerPosition: newHeaderPosition,
            direction,
            event
        });
    }
    getHeaderPositionFromUserFunc(params) {
        const { userFunc, direction, currentPosition, headerPosition, headerRowCount } = params;
        const userFuncParams = {
            backwards: direction === "Before",
            previousHeaderPosition: currentPosition,
            nextHeaderPosition: headerPosition,
            headerRowCount
        };
        const userResult = userFunc(userFuncParams);
        if (userResult === true || userResult === null) {
            if (userResult === null) warnOnce("Returning `null` from tabToNextHeader is deprecated. Return `true` to stay on the current header, or `false` to let the browser handle the tab behaviour.");
            return currentPosition;
        }
        if (userResult === false) return null;
        return userResult;
    }
    focusProvidedHeaderPosition(params) {
        const { headerPosition, direction, fromCell, rowWithoutSpanValue, event } = params;
        if (headerPosition.headerRowIndex === -1) {
            if (this.filterManager.isAdvancedFilterHeaderActive()) return this.focusAdvancedFilter(headerPosition);
            return this.focusGridView(headerPosition.column);
        }
        this.headerNavigationService.scrollToColumn(headerPosition.column, direction);
        const headerRowContainerCtrl = this.ctrlsService.getHeaderRowContainerCtrl(headerPosition.column.getPinned());
        const focusSuccess = headerRowContainerCtrl.focusHeader(headerPosition.headerRowIndex, headerPosition.column, event);
        if (focusSuccess && (rowWithoutSpanValue != null || fromCell)) this.headerNavigationService.setCurrentHeaderRowWithoutSpan(rowWithoutSpanValue != null ? rowWithoutSpanValue : -1);
        return focusSuccess;
    }
    focusFirstHeader() {
        let firstColumn = this.columnModel.getAllDisplayedColumns()[0];
        if (!firstColumn) return false;
        if (firstColumn.getParent()) firstColumn = this.columnModel.getColumnGroupAtLevel(firstColumn, 0);
        const headerPosition = this.headerPositionUtils.getHeaderIndexToFocus(firstColumn, 0);
        return this.focusHeaderPosition({
            headerPosition,
            rowWithoutSpanValue: 0
        });
    }
    focusLastHeader(event) {
        const headerRowIndex = this.headerNavigationService.getHeaderRowCount() - 1;
        const column = last(this.columnModel.getAllDisplayedColumns());
        return this.focusHeaderPosition({
            headerPosition: {
                headerRowIndex,
                column
            },
            rowWithoutSpanValue: -1,
            event
        });
    }
    focusPreviousFromFirstCell(event) {
        if (this.filterManager.isAdvancedFilterHeaderActive()) return this.focusAdvancedFilter(null);
        return this.focusLastHeader(event);
    }
    isAnyCellFocused() {
        return !!this.focusedCellPosition;
    }
    isRowFocused(rowIndex, floating) {
        if (this.focusedCellPosition == null) return false;
        return this.focusedCellPosition.rowIndex === rowIndex && this.focusedCellPosition.rowPinned === makeNull(floating);
    }
    findFocusableElements(rootNode, exclude, onlyUnmanaged = false) {
        const focusableString = FOCUSABLE_SELECTOR;
        let excludeString = FOCUSABLE_EXCLUDE;
        if (exclude) excludeString += ", " + exclude;
        if (onlyUnmanaged) excludeString += ', [tabindex="-1"]';
        const nodes = Array.prototype.slice.apply(rootNode.querySelectorAll(focusableString)).filter((node)=>{
            return isVisible(node);
        });
        const excludeNodes = Array.prototype.slice.apply(rootNode.querySelectorAll(excludeString));
        if (!excludeNodes.length) return nodes;
        const diff = (a, b)=>a.filter((element)=>b.indexOf(element) === -1);
        return diff(nodes, excludeNodes);
    }
    focusInto(rootNode, up = false, onlyUnmanaged = false) {
        const focusableElements = this.findFocusableElements(rootNode, null, onlyUnmanaged);
        const toFocus = up ? last(focusableElements) : focusableElements[0];
        if (toFocus) {
            toFocus.focus({
                preventScroll: true
            });
            return true;
        }
        return false;
    }
    findFocusableElementBeforeTabGuard(rootNode, referenceElement) {
        if (!referenceElement) return null;
        const focusableElements = this.findFocusableElements(rootNode);
        const referenceIndex = focusableElements.indexOf(referenceElement);
        if (referenceIndex === -1) return null;
        let lastTabGuardIndex = -1;
        for(let i = referenceIndex - 1; i >= 0; i--)if (focusableElements[i].classList.contains("ag-tab-guard-top" /* TAB_GUARD_TOP */ )) {
            lastTabGuardIndex = i;
            break;
        }
        if (lastTabGuardIndex <= 0) return null;
        return focusableElements[lastTabGuardIndex - 1];
    }
    findNextFocusableElement(rootNode = this.eGridDiv, onlyManaged, backwards) {
        const focusable = this.findFocusableElements(rootNode, onlyManaged ? ':not([tabindex="-1"])' : null);
        const activeEl = this.gos.getActiveDomElement();
        let currentIndex;
        if (onlyManaged) currentIndex = focusable.findIndex((el)=>el.contains(activeEl));
        else currentIndex = focusable.indexOf(activeEl);
        const nextIndex = currentIndex + (backwards ? -1 : 1);
        if (nextIndex < 0 || nextIndex >= focusable.length) return null;
        return focusable[nextIndex];
    }
    isTargetUnderManagedComponent(rootNode, target) {
        if (!target) return false;
        const managedContainers = rootNode.querySelectorAll(`.${ManagedFocusFeature.FOCUS_MANAGED_CLASS}`);
        if (!managedContainers.length) return false;
        for(let i = 0; i < managedContainers.length; i++){
            if (managedContainers[i].contains(target)) return true;
        }
        return false;
    }
    findTabbableParent(node, limit = 5) {
        let counter = 0;
        while(node && getTabIndex(node) === null && ++counter <= limit)node = node.parentElement;
        if (getTabIndex(node) === null) return null;
        return node;
    }
    focusGridView(column, backwards) {
        var _a;
        if (this.gos.get("suppressCellFocus")) {
            if (backwards) {
                if (!this.gos.get("suppressHeaderFocus")) return this.focusLastHeader();
                return this.focusNextGridCoreContainer(true, true);
            }
            return this.focusNextGridCoreContainer(false);
        }
        const nextRow = backwards ? this.rowPositionUtils.getLastRow() : this.rowPositionUtils.getFirstRow();
        if (!nextRow) return false;
        const { rowIndex, rowPinned } = nextRow;
        const focusedHeader = this.getFocusedHeader();
        if (!column && focusedHeader) column = focusedHeader.column;
        if (rowIndex == null || !column) return false;
        this.navigationService.ensureCellVisible({
            rowIndex,
            column,
            rowPinned
        });
        this.setFocusedCell({
            rowIndex,
            column,
            rowPinned: makeNull(rowPinned),
            forceBrowserFocus: true
        });
        (_a = this.rangeService) == null || _a.setRangeToCell({
            rowIndex,
            rowPinned,
            column
        });
        return true;
    }
    focusNextGridCoreContainer(backwards, forceOut = false) {
        if (!forceOut && this.gridCtrl.focusNextInnerContainer(backwards)) return true;
        if (forceOut || !backwards && !this.gridCtrl.isDetailGrid()) this.gridCtrl.forceFocusOutOfContainer(backwards);
        return false;
    }
    focusAdvancedFilter(position) {
        var _a, _b;
        this.advancedFilterFocusColumn = position == null ? void 0 : position.column;
        return (_b = (_a = this.advancedFilterService) == null ? void 0 : _a.getCtrl().focusHeaderComp()) != null ? _b : false;
    }
    focusNextFromAdvancedFilter(backwards, forceFirstColumn) {
        var _a, _b;
        const column = (_b = forceFirstColumn ? void 0 : this.advancedFilterFocusColumn) != null ? _b : (_a = this.columnModel.getAllDisplayedColumns()) == null ? void 0 : _a[0];
        if (backwards) return this.focusHeaderPosition({
            headerPosition: {
                column,
                headerRowIndex: this.headerNavigationService.getHeaderRowCount() - 1
            }
        });
        else return this.focusGridView(column);
    }
    clearAdvancedFilterColumn() {
        this.advancedFilterFocusColumn = void 0;
    }
};
FocusService.keyboardModeActive = false;
FocusService.instanceCount = 0;
__decorateClass([
    Autowired("eGridDiv")
], FocusService.prototype, "eGridDiv", 2);
__decorateClass([
    Autowired("columnModel")
], FocusService.prototype, "columnModel", 2);
__decorateClass([
    Autowired("headerNavigationService")
], FocusService.prototype, "headerNavigationService", 2);
__decorateClass([
    Autowired("headerPositionUtils")
], FocusService.prototype, "headerPositionUtils", 2);
__decorateClass([
    Autowired("rowRenderer")
], FocusService.prototype, "rowRenderer", 2);
__decorateClass([
    Autowired("rowPositionUtils")
], FocusService.prototype, "rowPositionUtils", 2);
__decorateClass([
    Autowired("cellPositionUtils")
], FocusService.prototype, "cellPositionUtils", 2);
__decorateClass([
    Autowired("navigationService")
], FocusService.prototype, "navigationService", 2);
__decorateClass([
    Autowired("ctrlsService")
], FocusService.prototype, "ctrlsService", 2);
__decorateClass([
    Autowired("filterManager")
], FocusService.prototype, "filterManager", 2);
__decorateClass([
    Optional("rangeService")
], FocusService.prototype, "rangeService", 2);
__decorateClass([
    Optional("advancedFilterService")
], FocusService.prototype, "advancedFilterService", 2);
__decorateClass([
    PostConstruct
], FocusService.prototype, "init", 1);
FocusService = __decorateClass([
    Bean("focusService")
], FocusService);
// community-modules/core/src/rendering/columnHoverService.ts
var ColumnHoverService = class extends BeanStub {
    setMouseOver(columns) {
        this.selectedColumns = columns;
        const event = {
            type: Events.EVENT_COLUMN_HOVER_CHANGED
        };
        this.eventService.dispatchEvent(event);
    }
    clearMouseOver() {
        this.selectedColumns = null;
        const event = {
            type: Events.EVENT_COLUMN_HOVER_CHANGED
        };
        this.eventService.dispatchEvent(event);
    }
    isHovered(column) {
        return !!this.selectedColumns && this.selectedColumns.indexOf(column) >= 0;
    }
};
ColumnHoverService = __decorateClass([
    Bean("columnHoverService")
], ColumnHoverService);
// community-modules/core/src/rendering/columnAnimationService.ts
var ColumnAnimationService = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.executeNextFuncs = [];
        this.executeLaterFuncs = [];
        this.active = false;
        this.suppressAnimation = false;
        this.animationThreadCount = 0;
    }
    postConstruct() {
        this.ctrlsService.whenReady((p)=>this.gridBodyCtrl = p.gridBodyCtrl);
    }
    isActive() {
        return this.active && !this.suppressAnimation;
    }
    setSuppressAnimation(suppress) {
        this.suppressAnimation = suppress;
    }
    start() {
        if (this.active) return;
        if (this.gos.get("suppressColumnMoveAnimation")) return;
        if (this.gos.get("enableRtl")) return;
        this.ensureAnimationCssClassPresent();
        this.active = true;
    }
    finish() {
        if (!this.active) return;
        this.flush(()=>{
            this.active = false;
        });
    }
    executeNextVMTurn(func) {
        if (this.active) this.executeNextFuncs.push(func);
        else func();
    }
    executeLaterVMTurn(func) {
        if (this.active) this.executeLaterFuncs.push(func);
        else func();
    }
    ensureAnimationCssClassPresent() {
        this.animationThreadCount++;
        const animationThreadCountCopy = this.animationThreadCount;
        this.gridBodyCtrl.setColumnMovingCss(true);
        this.executeLaterFuncs.push(()=>{
            if (this.animationThreadCount === animationThreadCountCopy) this.gridBodyCtrl.setColumnMovingCss(false);
        });
    }
    flush(callback) {
        if (this.executeNextFuncs.length === 0 && this.executeLaterFuncs.length === 0) {
            callback();
            return;
        }
        const runFuncs = (queue)=>{
            while(queue.length){
                const func = queue.pop();
                if (func) func();
            }
        };
        this.getFrameworkOverrides().wrapIncoming(()=>{
            window.setTimeout(()=>runFuncs(this.executeNextFuncs), 0);
            window.setTimeout(()=>{
                callback();
                runFuncs(this.executeLaterFuncs);
            }, 200);
        });
    }
};
__decorateClass([
    Autowired("ctrlsService")
], ColumnAnimationService.prototype, "ctrlsService", 2);
__decorateClass([
    PostConstruct
], ColumnAnimationService.prototype, "postConstruct", 1);
ColumnAnimationService = __decorateClass([
    Bean("columnAnimationService")
], ColumnAnimationService);
// community-modules/core/src/pagination/paginationAutoPageSizeService.ts
var PaginationAutoPageSizeService = class extends BeanStub {
    postConstruct() {
        this.ctrlsService.whenReady((p)=>{
            this.centerRowsCtrl = p.center;
            this.addManagedListener(this.eventService, Events.EVENT_BODY_HEIGHT_CHANGED, this.checkPageSize.bind(this));
            this.addManagedListener(this.eventService, Events.EVENT_SCROLL_VISIBILITY_CHANGED, this.checkPageSize.bind(this));
            this.addManagedPropertyListener("paginationAutoPageSize", this.onPaginationAutoSizeChanged.bind(this));
            this.checkPageSize();
        });
    }
    notActive() {
        return !this.gos.get("paginationAutoPageSize") || this.centerRowsCtrl == null;
    }
    onPaginationAutoSizeChanged() {
        if (this.notActive()) this.paginationProxy.unsetAutoCalculatedPageSize();
        else this.checkPageSize();
    }
    checkPageSize() {
        if (this.notActive()) return;
        const bodyHeight = this.centerRowsCtrl.getViewportSizeFeature().getBodyHeight();
        if (bodyHeight > 0) {
            const update = ()=>{
                const rowHeight = this.gos.getRowHeightAsNumber();
                const newPageSize = Math.floor(bodyHeight / rowHeight);
                this.paginationProxy.setPageSize(newPageSize, "autoCalculated");
            };
            if (!this.isBodyRendered) {
                update();
                this.isBodyRendered = true;
            } else debounce(()=>update(), 50)();
        } else this.isBodyRendered = false;
    }
};
__decorateClass([
    Autowired("ctrlsService")
], PaginationAutoPageSizeService.prototype, "ctrlsService", 2);
__decorateClass([
    Autowired("paginationProxy")
], PaginationAutoPageSizeService.prototype, "paginationProxy", 2);
__decorateClass([
    PostConstruct
], PaginationAutoPageSizeService.prototype, "postConstruct", 1);
PaginationAutoPageSizeService = __decorateClass([
    Bean("paginationAutoPageSizeService")
], PaginationAutoPageSizeService);
// community-modules/core/src/valueService/valueCache.ts
var ValueCache = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.cacheVersion = 0;
    }
    init() {
        this.active = this.gos.get("valueCache");
        this.neverExpires = this.gos.get("valueCacheNeverExpires");
    }
    onDataChanged() {
        if (this.neverExpires) return;
        this.expire();
    }
    expire() {
        this.cacheVersion++;
    }
    setValue(rowNode, colId, value) {
        if (this.active) {
            if (rowNode.__cacheVersion !== this.cacheVersion) {
                rowNode.__cacheVersion = this.cacheVersion;
                rowNode.__cacheData = {};
            }
            rowNode.__cacheData[colId] = value;
        }
    }
    getValue(rowNode, colId) {
        if (!this.active || rowNode.__cacheVersion !== this.cacheVersion) return void 0;
        return rowNode.__cacheData[colId];
    }
};
__decorateClass([
    PostConstruct
], ValueCache.prototype, "init", 1);
ValueCache = __decorateClass([
    Bean("valueCache")
], ValueCache);
// community-modules/core/src/valueService/changeDetectionService.ts
var SOURCE_PASTE = "paste";
var ChangeDetectionService = class extends BeanStub {
    init() {
        if (this.rowModel.getType() === "clientSide") this.clientSideRowModel = this.rowModel;
        this.addManagedListener(this.eventService, Events.EVENT_CELL_VALUE_CHANGED, this.onCellValueChanged.bind(this));
    }
    onCellValueChanged(event) {
        if (event.source === SOURCE_PASTE) return;
        this.doChangeDetection(event.node, event.column);
    }
    doChangeDetection(rowNode, column) {
        if (this.gos.get("suppressChangeDetection")) return;
        const nodesToRefresh = [
            rowNode
        ];
        if (this.clientSideRowModel && !rowNode.isRowPinned()) {
            const onlyChangedColumns = this.gos.get("aggregateOnlyChangedColumns");
            const changedPath = new ChangedPath(onlyChangedColumns, this.clientSideRowModel.getRootNode());
            changedPath.addParentNode(rowNode.parent, [
                column
            ]);
            this.clientSideRowModel.doAggregate(changedPath);
            changedPath.forEachChangedNodeDepthFirst((rowNode2)=>{
                nodesToRefresh.push(rowNode2);
            });
        }
        this.rowRenderer.refreshCells({
            rowNodes: nodesToRefresh
        });
    }
};
__decorateClass([
    Autowired("rowModel")
], ChangeDetectionService.prototype, "rowModel", 2);
__decorateClass([
    Autowired("rowRenderer")
], ChangeDetectionService.prototype, "rowRenderer", 2);
__decorateClass([
    PostConstruct
], ChangeDetectionService.prototype, "init", 1);
ChangeDetectionService = __decorateClass([
    Bean("changeDetectionService")
], ChangeDetectionService);
// community-modules/core/src/components/framework/agComponentUtils.ts
var AgComponentUtils = class extends BeanStub {
    adaptFunction(propertyName, jsCompFunc) {
        const metadata = this.componentMetadataProvider.retrieve(propertyName);
        if (metadata && metadata.functionAdapter) return metadata.functionAdapter(jsCompFunc);
        return null;
    }
    adaptCellRendererFunction(callback) {
        class Adapter {
            refresh(params) {
                return false;
            }
            getGui() {
                return this.eGui;
            }
            init(params) {
                const callbackResult = callback(params);
                const type = typeof callbackResult;
                if (type === "string" || type === "number" || type === "boolean") {
                    this.eGui = loadTemplate("<span>" + callbackResult + "</span>");
                    return;
                }
                if (callbackResult == null) {
                    this.eGui = loadTemplate("<span></span>");
                    return;
                }
                this.eGui = callbackResult;
            }
        }
        return Adapter;
    }
    doesImplementIComponent(candidate) {
        if (!candidate) return false;
        return candidate.prototype && "getGui" in candidate.prototype;
    }
};
__decorateClass([
    Autowired("componentMetadataProvider")
], AgComponentUtils.prototype, "componentMetadataProvider", 2);
AgComponentUtils = __decorateClass([
    Bean("agComponentUtils")
], AgComponentUtils);
// community-modules/core/src/components/framework/componentMetadataProvider.ts
var ComponentMetadataProvider = class extends BeanStub {
    postConstruct() {
        this.componentMetaData = {
            dateComponent: {
                mandatoryMethodList: [
                    "getDate",
                    "setDate"
                ],
                optionalMethodList: [
                    "afterGuiAttached",
                    "setInputPlaceholder",
                    "setInputAriaLabel",
                    "setDisabled",
                    "onParamsUpdated",
                    "refresh"
                ]
            },
            detailCellRenderer: {
                mandatoryMethodList: [],
                optionalMethodList: [
                    "refresh"
                ],
                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
            },
            headerComponent: {
                mandatoryMethodList: [],
                optionalMethodList: [
                    "refresh"
                ]
            },
            headerGroupComponent: {
                mandatoryMethodList: [],
                optionalMethodList: []
            },
            loadingCellRenderer: {
                mandatoryMethodList: [],
                optionalMethodList: [],
                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
            },
            loadingOverlayComponent: {
                mandatoryMethodList: [],
                optionalMethodList: [
                    "refresh"
                ]
            },
            noRowsOverlayComponent: {
                mandatoryMethodList: [],
                optionalMethodList: [
                    "refresh"
                ]
            },
            floatingFilterComponent: {
                mandatoryMethodList: [
                    "onParentModelChanged"
                ],
                optionalMethodList: [
                    "afterGuiAttached",
                    "onParamsUpdated",
                    "refresh"
                ]
            },
            cellRenderer: {
                mandatoryMethodList: [],
                optionalMethodList: [
                    "refresh",
                    "afterGuiAttached"
                ],
                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
            },
            cellEditor: {
                mandatoryMethodList: [
                    "getValue"
                ],
                optionalMethodList: [
                    "isPopup",
                    "isCancelBeforeStart",
                    "isCancelAfterEnd",
                    "getPopupPosition",
                    "focusIn",
                    "focusOut",
                    "afterGuiAttached",
                    "refresh"
                ]
            },
            innerRenderer: {
                mandatoryMethodList: [],
                optionalMethodList: [
                    "afterGuiAttached"
                ],
                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
            },
            fullWidthCellRenderer: {
                mandatoryMethodList: [],
                optionalMethodList: [
                    "refresh",
                    "afterGuiAttached"
                ],
                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
            },
            groupRowRenderer: {
                mandatoryMethodList: [],
                optionalMethodList: [
                    "afterGuiAttached"
                ],
                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
            },
            filter: {
                mandatoryMethodList: [
                    "isFilterActive",
                    "doesFilterPass",
                    "getModel",
                    "setModel"
                ],
                optionalMethodList: [
                    "afterGuiAttached",
                    "afterGuiDetached",
                    "onNewRowsLoaded",
                    "getModelAsString",
                    "onFloatingFilterChanged",
                    "onAnyFilterChanged",
                    "refresh"
                ]
            },
            statusPanel: {
                mandatoryMethodList: [],
                optionalMethodList: [
                    "refresh"
                ]
            },
            toolPanel: {
                mandatoryMethodList: [],
                optionalMethodList: [
                    "refresh",
                    "getState"
                ]
            },
            tooltipComponent: {
                mandatoryMethodList: [],
                optionalMethodList: []
            },
            menuItem: {
                mandatoryMethodList: [],
                optionalMethodList: [
                    "setActive",
                    "select",
                    "setExpanded",
                    "configureDefaults"
                ]
            }
        };
    }
    retrieve(name) {
        return this.componentMetaData[name];
    }
};
__decorateClass([
    Autowired("agComponentUtils")
], ComponentMetadataProvider.prototype, "agComponentUtils", 2);
__decorateClass([
    PostConstruct
], ComponentMetadataProvider.prototype, "postConstruct", 1);
ComponentMetadataProvider = __decorateClass([
    Bean("componentMetadataProvider")
], ComponentMetadataProvider);
// community-modules/core/src/environment.ts
var DEFAULT_ROW_HEIGHT = 25;
var MIN_COL_WIDTH = 10;
var MAT_GRID_SIZE = 8;
var BASE_GRID_SIZE = 4;
var BALHAM_GRID_SIZE = 4;
var ALPINE_GRID_SIZE = 6;
var QUARTZ_ICON_SIZE = 16;
var QUARTZ_FONT_SIZE = 14;
var QUARTZ_GRID_SIZE = 8;
var HARD_CODED_SIZES = {
    // this item is required for custom themes
    "ag-theme-custom": {
        headerHeight: 25,
        headerCellMinWidth: 24,
        listItemHeight: BASE_GRID_SIZE * 5,
        rowHeight: 25,
        chartMenuPanelWidth: 220
    },
    "ag-theme-material": {
        headerHeight: MAT_GRID_SIZE * 7,
        headerCellMinWidth: 48,
        listItemHeight: MAT_GRID_SIZE * 4,
        rowHeight: MAT_GRID_SIZE * 6,
        chartMenuPanelWidth: 240
    },
    "ag-theme-balham": {
        headerHeight: BALHAM_GRID_SIZE * 8,
        headerCellMinWidth: 24,
        listItemHeight: BALHAM_GRID_SIZE * 6,
        rowHeight: BALHAM_GRID_SIZE * 7,
        chartMenuPanelWidth: 220
    },
    "ag-theme-alpine": {
        headerHeight: ALPINE_GRID_SIZE * 8,
        headerCellMinWidth: 36,
        listItemHeight: ALPINE_GRID_SIZE * 4,
        rowHeight: ALPINE_GRID_SIZE * 7,
        chartMenuPanelWidth: 240
    },
    "ag-theme-quartz": {
        headerHeight: QUARTZ_FONT_SIZE + QUARTZ_GRID_SIZE * 4.25,
        headerCellMinWidth: 36,
        listItemHeight: QUARTZ_ICON_SIZE + QUARTZ_GRID_SIZE,
        rowHeight: QUARTZ_FONT_SIZE + QUARTZ_GRID_SIZE * 3.5,
        chartMenuPanelWidth: 260
    }
};
var SASS_PROPERTY_BUILDER = {
    headerHeight: [
        "ag-header-row"
    ],
    headerCellMinWidth: [
        "ag-header-cell"
    ],
    listItemHeight: [
        "ag-virtual-list-item"
    ],
    rowHeight: [
        "ag-row"
    ],
    chartMenuPanelWidth: [
        "ag-chart-docked-container"
    ]
};
var Environment = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.calculatedSizes = {};
        this.calculatedTheme = null;
    }
    postConstruct() {
        var _a;
        const el = (_a = this.getTheme().el) != null ? _a : this.eGridDiv;
        this.addManagedPropertyListener("rowHeight", ()=>this.refreshRowHeightVariable());
        this.mutationObserver = new MutationObserver(()=>{
            this.calculatedSizes = {};
            this.calculatedTheme = null;
            this.calculatedTheme = this.getTheme();
            this.fireGridStylesChangedEvent();
        });
        this.mutationObserver.observe(el || this.eGridDiv, {
            attributes: true,
            attributeFilter: [
                "class"
            ]
        });
    }
    fireGridStylesChangedEvent() {
        const event = {
            type: Events.EVENT_GRID_STYLES_CHANGED
        };
        this.eventService.dispatchEvent(event);
    }
    getSassVariable(key) {
        const { themeFamily, el } = this.getTheme();
        if (!themeFamily || themeFamily.indexOf("ag-theme") !== 0) return;
        if (!this.calculatedSizes) this.calculatedSizes = {};
        if (!this.calculatedSizes[themeFamily]) this.calculatedSizes[themeFamily] = {};
        const size = this.calculatedSizes[themeFamily][key];
        if (size != null) return size;
        this.calculatedSizes[themeFamily][key] = this.calculateValueForSassProperty(key, themeFamily, el);
        return this.calculatedSizes[themeFamily][key];
    }
    calculateValueForSassProperty(property, theme, themeElement) {
        const useTheme = "ag-theme-" + (theme.match("material") ? "material" : theme.match("balham") ? "balham" : theme.match("alpine") ? "alpine" : "custom");
        const defaultValue = HARD_CODED_SIZES[useTheme][property];
        const eDocument = this.gos.getDocument();
        if (!themeElement) themeElement = this.eGridDiv;
        if (!SASS_PROPERTY_BUILDER[property]) return defaultValue;
        const classList = SASS_PROPERTY_BUILDER[property];
        const div = eDocument.createElement("div");
        const classesFromThemeElement = Array.from(themeElement.classList);
        div.classList.add(theme, ...classesFromThemeElement);
        div.style.position = "absolute";
        const el = classList.reduce((prevEl, currentClass)=>{
            const currentDiv = eDocument.createElement("div");
            currentDiv.style.position = "static";
            currentDiv.classList.add(currentClass);
            prevEl.appendChild(currentDiv);
            return currentDiv;
        }, div);
        let calculatedValue = 0;
        if (eDocument.body) {
            eDocument.body.appendChild(div);
            const sizeName = property.toLowerCase().indexOf("height") !== -1 ? "height" : "width";
            calculatedValue = parseInt(window.getComputedStyle(el)[sizeName], 10);
            eDocument.body.removeChild(div);
        }
        return calculatedValue || defaultValue;
    }
    isThemeDark() {
        const { theme } = this.getTheme();
        return !!theme && theme.indexOf("dark") >= 0;
    }
    chartMenuPanelWidth() {
        return this.getSassVariable("chartMenuPanelWidth");
    }
    getTheme() {
        if (this.calculatedTheme) return this.calculatedTheme;
        const reg = /\bag-(material|(?:theme-([\w\-]*)))\b/g;
        let el = this.eGridDiv;
        let themeMatch = null;
        let allThemes = [];
        while(el){
            themeMatch = reg.exec(el.className);
            if (!themeMatch) el = el.parentElement || void 0;
            else {
                const matched = el.className.match(reg);
                if (matched) allThemes = matched;
                break;
            }
        }
        if (!themeMatch) return {
            allThemes
        };
        const theme = themeMatch[0];
        this.calculatedTheme = {
            theme,
            el,
            themeFamily: theme.replace(/-dark$/, ""),
            allThemes
        };
        return this.calculatedTheme;
    }
    getFromTheme(defaultValue, sassVariableName) {
        var _a;
        return (_a = this.getSassVariable(sassVariableName)) != null ? _a : defaultValue;
    }
    getDefaultRowHeight() {
        return this.getFromTheme(DEFAULT_ROW_HEIGHT, "rowHeight");
    }
    getListItemHeight() {
        return this.getFromTheme(20, "listItemHeight");
    }
    refreshRowHeightVariable() {
        const oldRowHeight = this.eGridDiv.style.getPropertyValue("--ag-line-height").trim();
        const height = this.gos.get("rowHeight");
        if (height == null || isNaN(height) || !isFinite(height)) {
            if (oldRowHeight !== null) this.eGridDiv.style.setProperty("--ag-line-height", null);
            return -1;
        }
        const newRowHeight = `${height}px`;
        if (oldRowHeight != newRowHeight) {
            this.eGridDiv.style.setProperty("--ag-line-height", newRowHeight);
            return height;
        }
        return oldRowHeight != "" ? parseFloat(oldRowHeight) : -1;
    }
    getMinColWidth() {
        const measuredMin = this.getFromTheme(null, "headerCellMinWidth");
        return exists(measuredMin) ? Math.max(measuredMin, MIN_COL_WIDTH) : MIN_COL_WIDTH;
    }
    destroy() {
        this.calculatedSizes = null;
        if (this.mutationObserver) this.mutationObserver.disconnect();
        super.destroy();
    }
};
__decorateClass([
    Autowired("eGridDiv")
], Environment.prototype, "eGridDiv", 2);
__decorateClass([
    PostConstruct
], Environment.prototype, "postConstruct", 1);
Environment = __decorateClass([
    Bean("environment")
], Environment);
// community-modules/core/src/rendering/rowContainerHeightService.ts
var RowContainerHeightService = class extends BeanStub {
    constructor(){
        super(...arguments);
        // the scrollY position
        this.scrollY = 0;
        // how tall the body is
        this.uiBodyHeight = 0;
    }
    agWire(loggerFactory) {
        this.logger = loggerFactory.create("RowContainerHeightService");
    }
    postConstruct() {
        this.addManagedListener(this.eventService, Events.EVENT_BODY_HEIGHT_CHANGED, this.updateOffset.bind(this));
        this.maxDivHeight = getMaxDivHeight();
        this.logger.log("maxDivHeight = " + this.maxDivHeight);
    }
    isStretching() {
        return this.stretching;
    }
    getDivStretchOffset() {
        return this.divStretchOffset;
    }
    updateOffset() {
        if (!this.stretching) return;
        const gridBodyCon = this.ctrlsService.getGridBodyCtrl();
        const newScrollY = gridBodyCon.getScrollFeature().getVScrollPosition().top;
        const newBodyHeight = this.getUiBodyHeight();
        const atLeastOneChanged = newScrollY !== this.scrollY || newBodyHeight !== this.uiBodyHeight;
        if (atLeastOneChanged) {
            this.scrollY = newScrollY;
            this.uiBodyHeight = newBodyHeight;
            this.calculateOffset();
        }
    }
    calculateOffset() {
        this.setUiContainerHeight(this.maxDivHeight);
        this.pixelsToShave = this.modelHeight - this.uiContainerHeight;
        this.maxScrollY = this.uiContainerHeight - this.uiBodyHeight;
        const scrollPercent = this.scrollY / this.maxScrollY;
        const divStretchOffset = scrollPercent * this.pixelsToShave;
        this.logger.log(`Div Stretch Offset = ${divStretchOffset} (${this.pixelsToShave} * ${scrollPercent})`);
        this.setDivStretchOffset(divStretchOffset);
    }
    setUiContainerHeight(height) {
        if (height !== this.uiContainerHeight) {
            this.uiContainerHeight = height;
            this.eventService.dispatchEvent({
                type: Events.EVENT_ROW_CONTAINER_HEIGHT_CHANGED
            });
        }
    }
    clearOffset() {
        this.setUiContainerHeight(this.modelHeight);
        this.pixelsToShave = 0;
        this.setDivStretchOffset(0);
    }
    setDivStretchOffset(newOffset) {
        const newOffsetFloor = typeof newOffset === "number" ? Math.floor(newOffset) : null;
        if (this.divStretchOffset === newOffsetFloor) return;
        this.divStretchOffset = newOffsetFloor;
        this.eventService.dispatchEvent({
            type: Events.EVENT_HEIGHT_SCALE_CHANGED
        });
    }
    setModelHeight(modelHeight) {
        this.modelHeight = modelHeight;
        this.stretching = modelHeight != null && this.maxDivHeight > 0 && modelHeight > this.maxDivHeight;
        if (this.stretching) this.calculateOffset();
        else this.clearOffset();
    }
    getUiContainerHeight() {
        return this.uiContainerHeight;
    }
    getRealPixelPosition(modelPixel) {
        return modelPixel - this.divStretchOffset;
    }
    getUiBodyHeight() {
        const gridBodyCon = this.ctrlsService.getGridBodyCtrl();
        const pos = gridBodyCon.getScrollFeature().getVScrollPosition();
        return pos.bottom - pos.top;
    }
    getScrollPositionForPixel(rowTop) {
        if (this.pixelsToShave <= 0) return rowTop;
        const modelMaxScroll = this.modelHeight - this.getUiBodyHeight();
        const scrollPercent = rowTop / modelMaxScroll;
        const scrollPixel = this.maxScrollY * scrollPercent;
        return scrollPixel;
    }
};
__decorateClass([
    Autowired("ctrlsService")
], RowContainerHeightService.prototype, "ctrlsService", 2);
__decorateClass([
    __decorateParam(0, Qualifier("loggerFactory"))
], RowContainerHeightService.prototype, "agWire", 1);
__decorateClass([
    PostConstruct
], RowContainerHeightService.prototype, "postConstruct", 1);
RowContainerHeightService = __decorateClass([
    Bean("rowContainerHeightService")
], RowContainerHeightService);
// community-modules/core/src/rowNodes/selectableService.ts
var SelectableService = class extends BeanStub {
    init() {
        this.addManagedPropertyListener("isRowSelectable", ()=>this.updateSelectable());
    }
    /**
   * Used by CSRM only, to update selectable state after group state changes.
   */ updateSelectableAfterGrouping() {
        this.updateSelectable(true);
    }
    updateSelectable(skipLeafNodes = false) {
        const isRowSelecting = !!this.gos.get("rowSelection");
        const isRowSelectable = this.gos.get("isRowSelectable");
        if (!isRowSelecting || !isRowSelectable) return;
        const isGroupSelectsChildren = this.gos.get("groupSelectsChildren");
        const isCsrmGroupSelectsChildren = this.rowModel.getType() === "clientSide" && isGroupSelectsChildren;
        const nodesToDeselect = [];
        const nodeCallback = (node)=>{
            if (skipLeafNodes && !node.group) return;
            if (isCsrmGroupSelectsChildren && node.group) {
                const hasSelectableChild = node.childrenAfterGroup.some((rowNode)=>rowNode.selectable === true);
                node.setRowSelectable(hasSelectableChild, true);
                return;
            }
            const rowSelectable = isRowSelectable ? isRowSelectable(node) : true;
            node.setRowSelectable(rowSelectable, true);
            if (!rowSelectable && node.isSelected()) nodesToDeselect.push(node);
        };
        if (isCsrmGroupSelectsChildren) {
            const csrm = this.rowModel;
            const changedPath = new ChangedPath(false, csrm.getRootNode());
            changedPath.forEachChangedNodeDepthFirst(nodeCallback, true, true);
        } else this.rowModel.forEachNode(nodeCallback);
        if (nodesToDeselect.length) this.selectionService.setNodesSelected({
            nodes: nodesToDeselect,
            newValue: false,
            source: "selectableChanged"
        });
        if (isCsrmGroupSelectsChildren && this.selectionService instanceof SelectionService) this.selectionService.updateGroupsFromChildrenSelections("selectableChanged");
    }
};
__decorateClass([
    Autowired("rowModel")
], SelectableService.prototype, "rowModel", 2);
__decorateClass([
    Autowired("selectionService")
], SelectableService.prototype, "selectionService", 2);
__decorateClass([
    PostConstruct
], SelectableService.prototype, "init", 1);
SelectableService = __decorateClass([
    Bean("selectableService")
], SelectableService);
// community-modules/core/src/pagination/paginationComp.ts
var PaginationComp = class extends Component {
    constructor(){
        super();
        this.previousAndFirstButtonsDisabled = false;
        this.nextButtonDisabled = false;
        this.lastButtonDisabled = false;
        this.areListenersSetup = false;
    }
    postConstruct() {
        const isRtl = this.gos.get("enableRtl");
        this.setTemplate(this.getTemplate());
        const { btFirst, btPrevious, btNext, btLast, pageSizeComp } = this;
        this.activateTabIndex([
            btFirst,
            btPrevious,
            btNext,
            btLast
        ]);
        btFirst.insertAdjacentElement("afterbegin", createIconNoSpan(isRtl ? "last" : "first", this.gos));
        btPrevious.insertAdjacentElement("afterbegin", createIconNoSpan(isRtl ? "next" : "previous", this.gos));
        btNext.insertAdjacentElement("afterbegin", createIconNoSpan(isRtl ? "previous" : "next", this.gos));
        btLast.insertAdjacentElement("afterbegin", createIconNoSpan(isRtl ? "first" : "last", this.gos));
        this.addManagedPropertyListener("pagination", this.onPaginationChanged.bind(this));
        this.addManagedPropertyListener("suppressPaginationPanel", this.onPaginationChanged.bind(this));
        this.addManagedPropertyListeners([
            "paginationPageSizeSelector",
            "paginationAutoPageSize",
            "suppressPaginationPanel"
        ], ()=>this.onPageSizeRelatedOptionsChange());
        this.pageSizeComp.toggleSelectDisplay(this.pageSizeComp.shouldShowPageSizeSelector());
        this.onPaginationChanged();
    }
    onPaginationChanged() {
        const isPaging = this.gos.get("pagination");
        const paginationPanelEnabled = isPaging && !this.gos.get("suppressPaginationPanel");
        this.setDisplayed(paginationPanelEnabled);
        if (!paginationPanelEnabled) return;
        this.setupListeners();
        this.enableOrDisableButtons();
        this.updateRowLabels();
        this.setCurrentPageLabel();
        this.setTotalLabels();
        this.onPageSizeRelatedOptionsChange();
    }
    onPageSizeRelatedOptionsChange() {
        this.pageSizeComp.toggleSelectDisplay(this.pageSizeComp.shouldShowPageSizeSelector());
    }
    setupListeners() {
        if (!this.areListenersSetup) {
            this.addManagedListener(this.eventService, Events.EVENT_PAGINATION_CHANGED, this.onPaginationChanged.bind(this));
            [
                {
                    el: this.btFirst,
                    fn: this.onBtFirst.bind(this)
                },
                {
                    el: this.btPrevious,
                    fn: this.onBtPrevious.bind(this)
                },
                {
                    el: this.btNext,
                    fn: this.onBtNext.bind(this)
                },
                {
                    el: this.btLast,
                    fn: this.onBtLast.bind(this)
                }
            ].forEach((item)=>{
                const { el, fn } = item;
                this.addManagedListener(el, "click", fn);
                this.addManagedListener(el, "keydown", (e)=>{
                    if (e.key === KeyCode.ENTER || e.key === KeyCode.SPACE) {
                        e.preventDefault();
                        fn();
                    }
                });
            });
            this.areListenersSetup = true;
        }
    }
    onBtFirst() {
        if (!this.previousAndFirstButtonsDisabled) this.paginationProxy.goToFirstPage();
    }
    setCurrentPageLabel() {
        const pagesExist = this.paginationProxy.getTotalPages() > 0;
        const currentPage = this.paginationProxy.getCurrentPage();
        const toDisplay = pagesExist ? currentPage + 1 : 0;
        this.lbCurrent.textContent = this.formatNumber(toDisplay);
    }
    formatNumber(value) {
        const userFunc = this.gos.getCallback("paginationNumberFormatter");
        if (userFunc) {
            const params = {
                value
            };
            return userFunc(params);
        }
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        const thousandSeparator = localeTextFunc("thousandSeparator", ",");
        const decimalSeparator = localeTextFunc("decimalSeparator", ".");
        return formatNumberCommas(value, thousandSeparator, decimalSeparator);
    }
    getTemplate() {
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        const strPage = localeTextFunc("page", "Page");
        const strTo = localeTextFunc("to", "to");
        const strOf = localeTextFunc("of", "of");
        const strFirst = localeTextFunc("firstPage", "First Page");
        const strPrevious = localeTextFunc("previousPage", "Previous Page");
        const strNext = localeTextFunc("nextPage", "Next Page");
        const strLast = localeTextFunc("lastPage", "Last Page");
        const compId = this.getCompId();
        return /* html */ `<div class="ag-paging-panel ag-unselectable" id="ag-${compId}">
                <ag-page-size-selector ref="pageSizeComp"></ag-page-size-selector>
                <span class="ag-paging-row-summary-panel" role="status">
                    <span id="ag-${compId}-first-row" ref="lbFirstRowOnPage" class="ag-paging-row-summary-panel-number"></span>
                    <span id="ag-${compId}-to">${strTo}</span>
                    <span id="ag-${compId}-last-row" ref="lbLastRowOnPage" class="ag-paging-row-summary-panel-number"></span>
                    <span id="ag-${compId}-of">${strOf}</span>
                    <span id="ag-${compId}-row-count" ref="lbRecordCount" class="ag-paging-row-summary-panel-number"></span>
                </span>
                <span class="ag-paging-page-summary-panel" role="presentation">
                    <div ref="btFirst" class="ag-button ag-paging-button" role="button" aria-label="${strFirst}"></div>
                    <div ref="btPrevious" class="ag-button ag-paging-button" role="button" aria-label="${strPrevious}"></div>
                    <span class="ag-paging-description" role="status">
                        <span id="ag-${compId}-start-page">${strPage}</span>
                        <span id="ag-${compId}-start-page-number" ref="lbCurrent" class="ag-paging-number"></span>
                        <span id="ag-${compId}-of-page">${strOf}</span>
                        <span id="ag-${compId}-of-page-number" ref="lbTotal" class="ag-paging-number"></span>
                    </span>
                    <div ref="btNext" class="ag-button ag-paging-button" role="button" aria-label="${strNext}"></div>
                    <div ref="btLast" class="ag-button ag-paging-button" role="button" aria-label="${strLast}"></div>
                </span>
            </div>`;
    }
    onBtNext() {
        if (!this.nextButtonDisabled) this.paginationProxy.goToNextPage();
    }
    onBtPrevious() {
        if (!this.previousAndFirstButtonsDisabled) this.paginationProxy.goToPreviousPage();
    }
    onBtLast() {
        if (!this.lastButtonDisabled) this.paginationProxy.goToLastPage();
    }
    enableOrDisableButtons() {
        const currentPage = this.paginationProxy.getCurrentPage();
        const maxRowFound = this.paginationProxy.isLastPageFound();
        const totalPages = this.paginationProxy.getTotalPages();
        this.previousAndFirstButtonsDisabled = currentPage === 0;
        this.toggleButtonDisabled(this.btFirst, this.previousAndFirstButtonsDisabled);
        this.toggleButtonDisabled(this.btPrevious, this.previousAndFirstButtonsDisabled);
        const zeroPagesToDisplay = this.isZeroPagesToDisplay();
        const onLastPage = currentPage === totalPages - 1;
        this.nextButtonDisabled = onLastPage || zeroPagesToDisplay;
        this.lastButtonDisabled = !maxRowFound || zeroPagesToDisplay || currentPage === totalPages - 1;
        this.toggleButtonDisabled(this.btNext, this.nextButtonDisabled);
        this.toggleButtonDisabled(this.btLast, this.lastButtonDisabled);
    }
    toggleButtonDisabled(button, disabled) {
        setAriaDisabled(button, disabled);
        button.classList.toggle("ag-disabled", disabled);
    }
    updateRowLabels() {
        const currentPage = this.paginationProxy.getCurrentPage();
        const pageSize = this.paginationProxy.getPageSize();
        const maxRowFound = this.paginationProxy.isLastPageFound();
        const rowCount = this.paginationProxy.isLastPageFound() ? this.paginationProxy.getMasterRowCount() : null;
        let startRow;
        let endRow;
        if (this.isZeroPagesToDisplay()) startRow = endRow = 0;
        else {
            startRow = pageSize * currentPage + 1;
            endRow = startRow + pageSize - 1;
            if (maxRowFound && endRow > rowCount) endRow = rowCount;
        }
        this.lbFirstRowOnPage.textContent = this.formatNumber(startRow);
        if (this.rowNodeBlockLoader.isLoading()) {
            const translate = this.localeService.getLocaleTextFunc();
            this.lbLastRowOnPage.innerHTML = translate("pageLastRowUnknown", "?");
        } else this.lbLastRowOnPage.textContent = this.formatNumber(endRow);
    }
    isZeroPagesToDisplay() {
        const maxRowFound = this.paginationProxy.isLastPageFound();
        const totalPages = this.paginationProxy.getTotalPages();
        return maxRowFound && totalPages === 0;
    }
    setTotalLabels() {
        const lastPageFound = this.paginationProxy.isLastPageFound();
        const totalPages = this.paginationProxy.getTotalPages();
        const rowCount = lastPageFound ? this.paginationProxy.getMasterRowCount() : null;
        if (rowCount === 1) {
            const firstRow = this.paginationProxy.getRow(0);
            const hiddenGroupRow = firstRow && firstRow.group && !(firstRow.groupData || firstRow.aggData);
            if (hiddenGroupRow) {
                this.setTotalLabelsToZero();
                return;
            }
        }
        if (lastPageFound) {
            this.lbTotal.textContent = this.formatNumber(totalPages);
            this.lbRecordCount.textContent = this.formatNumber(rowCount);
        } else {
            const moreText = this.localeService.getLocaleTextFunc()("more", "more");
            this.lbTotal.innerHTML = moreText;
            this.lbRecordCount.innerHTML = moreText;
        }
    }
    setTotalLabelsToZero() {
        this.lbFirstRowOnPage.textContent = this.formatNumber(0);
        this.lbCurrent.textContent = this.formatNumber(0);
        this.lbLastRowOnPage.textContent = this.formatNumber(0);
        this.lbTotal.textContent = this.formatNumber(0);
        this.lbRecordCount.textContent = this.formatNumber(0);
    }
};
__decorateClass([
    Autowired("paginationProxy")
], PaginationComp.prototype, "paginationProxy", 2);
__decorateClass([
    Autowired("rowNodeBlockLoader")
], PaginationComp.prototype, "rowNodeBlockLoader", 2);
__decorateClass([
    RefSelector("btFirst")
], PaginationComp.prototype, "btFirst", 2);
__decorateClass([
    RefSelector("btPrevious")
], PaginationComp.prototype, "btPrevious", 2);
__decorateClass([
    RefSelector("btNext")
], PaginationComp.prototype, "btNext", 2);
__decorateClass([
    RefSelector("btLast")
], PaginationComp.prototype, "btLast", 2);
__decorateClass([
    RefSelector("lbRecordCount")
], PaginationComp.prototype, "lbRecordCount", 2);
__decorateClass([
    RefSelector("lbFirstRowOnPage")
], PaginationComp.prototype, "lbFirstRowOnPage", 2);
__decorateClass([
    RefSelector("lbLastRowOnPage")
], PaginationComp.prototype, "lbLastRowOnPage", 2);
__decorateClass([
    RefSelector("lbCurrent")
], PaginationComp.prototype, "lbCurrent", 2);
__decorateClass([
    RefSelector("lbTotal")
], PaginationComp.prototype, "lbTotal", 2);
__decorateClass([
    RefSelector("pageSizeComp")
], PaginationComp.prototype, "pageSizeComp", 2);
__decorateClass([
    PostConstruct
], PaginationComp.prototype, "postConstruct", 1);
// community-modules/core/src/rendering/overlays/overlayWrapperComponent.ts
var _OverlayWrapperComponent = class _OverlayWrapperComponent extends Component {
    constructor(){
        super(_OverlayWrapperComponent.TEMPLATE);
        this.inProgress = false;
        this.destroyRequested = false;
    }
    updateLayoutClasses(cssClass, params) {
        const overlayWrapperClassList = this.eOverlayWrapper.classList;
        overlayWrapperClassList.toggle("ag-layout-auto-height" /* AUTO_HEIGHT */ , params.autoHeight);
        overlayWrapperClassList.toggle("ag-layout-normal" /* NORMAL */ , params.normal);
        overlayWrapperClassList.toggle("ag-layout-print" /* PRINT */ , params.print);
    }
    postConstruct() {
        this.createManagedBean(new LayoutFeature(this));
        this.setDisplayed(false, {
            skipAriaHidden: true
        });
        this.overlayService.registerOverlayWrapperComp(this);
    }
    setWrapperTypeClass(overlayWrapperCssClass) {
        const overlayWrapperClassList = this.eOverlayWrapper.classList;
        if (this.activeOverlayWrapperCssClass) overlayWrapperClassList.toggle(this.activeOverlayWrapperCssClass, false);
        this.activeOverlayWrapperCssClass = overlayWrapperCssClass;
        overlayWrapperClassList.toggle(overlayWrapperCssClass, true);
    }
    showOverlay(overlayComp, overlayWrapperCssClass, updateListenerDestroyFunc) {
        if (this.inProgress) return;
        this.setWrapperTypeClass(overlayWrapperCssClass);
        this.destroyActiveOverlay();
        this.inProgress = true;
        if (overlayComp) overlayComp.then((comp)=>{
            this.inProgress = false;
            this.eOverlayWrapper.appendChild(comp.getGui());
            this.activeOverlay = comp;
            this.updateListenerDestroyFunc = updateListenerDestroyFunc;
            if (this.destroyRequested) {
                this.destroyRequested = false;
                this.destroyActiveOverlay();
            }
        });
        this.setDisplayed(true, {
            skipAriaHidden: true
        });
    }
    destroyActiveOverlay() {
        var _a;
        if (this.inProgress) {
            this.destroyRequested = true;
            return;
        }
        if (!this.activeOverlay) return;
        this.activeOverlay = this.getContext().destroyBean(this.activeOverlay);
        (_a = this.updateListenerDestroyFunc) == null || _a.call(this);
        clearElement(this.eOverlayWrapper);
    }
    hideOverlay() {
        this.destroyActiveOverlay();
        this.setDisplayed(false, {
            skipAriaHidden: true
        });
    }
    destroy() {
        this.destroyActiveOverlay();
        super.destroy();
    }
};
// wrapping in outer div, and wrapper, is needed to center the loading icon
_OverlayWrapperComponent.TEMPLATE = /* html */ `
        <div class="ag-overlay" role="presentation">
            <div class="ag-overlay-panel" role="presentation">
                <div class="ag-overlay-wrapper" ref="eOverlayWrapper" role="presentation"></div>
            </div>
        </div>`;
__decorateClass([
    Autowired("overlayService")
], _OverlayWrapperComponent.prototype, "overlayService", 2);
__decorateClass([
    RefSelector("eOverlayWrapper")
], _OverlayWrapperComponent.prototype, "eOverlayWrapper", 2);
__decorateClass([
    PostConstruct
], _OverlayWrapperComponent.prototype, "postConstruct", 1);
var OverlayWrapperComponent = _OverlayWrapperComponent;
// community-modules/core/src/entities/rowPositionUtils.ts
var RowPositionUtils = class extends BeanStub {
    getFirstRow() {
        let rowIndex = 0;
        let rowPinned;
        if (this.pinnedRowModel.getPinnedTopRowCount()) rowPinned = "top";
        else if (this.rowModel.getRowCount()) {
            rowPinned = null;
            rowIndex = this.paginationProxy.getPageFirstRow();
        } else if (this.pinnedRowModel.getPinnedBottomRowCount()) rowPinned = "bottom";
        return rowPinned === void 0 ? null : {
            rowIndex,
            rowPinned
        };
    }
    getLastRow() {
        let rowIndex;
        let rowPinned = null;
        const pinnedBottomCount = this.pinnedRowModel.getPinnedBottomRowCount();
        const pinnedTopCount = this.pinnedRowModel.getPinnedTopRowCount();
        if (pinnedBottomCount) {
            rowPinned = "bottom";
            rowIndex = pinnedBottomCount - 1;
        } else if (this.rowModel.getRowCount()) {
            rowPinned = null;
            rowIndex = this.paginationProxy.getPageLastRow();
        } else if (pinnedTopCount) {
            rowPinned = "top";
            rowIndex = pinnedTopCount - 1;
        }
        return rowIndex === void 0 ? null : {
            rowIndex,
            rowPinned
        };
    }
    getRowNode(gridRow) {
        switch(gridRow.rowPinned){
            case "top":
                return this.pinnedRowModel.getPinnedTopRowData()[gridRow.rowIndex];
            case "bottom":
                return this.pinnedRowModel.getPinnedBottomRowData()[gridRow.rowIndex];
            default:
                return this.rowModel.getRow(gridRow.rowIndex);
        }
    }
    sameRow(rowA, rowB) {
        if (!rowA && !rowB) return true;
        if (rowA && !rowB || !rowA && rowB) return false;
        return rowA.rowIndex === rowB.rowIndex && rowA.rowPinned == rowB.rowPinned;
    }
    // tests if this row selection is before the other row selection
    before(rowA, rowB) {
        switch(rowA.rowPinned){
            case "top":
                if (rowB.rowPinned !== "top") return true;
                break;
            case "bottom":
                if (rowB.rowPinned !== "bottom") return false;
                break;
            default:
                if (exists(rowB.rowPinned)) return rowB.rowPinned !== "top";
                break;
        }
        return rowA.rowIndex < rowB.rowIndex;
    }
};
__decorateClass([
    Autowired("rowModel")
], RowPositionUtils.prototype, "rowModel", 2);
__decorateClass([
    Autowired("pinnedRowModel")
], RowPositionUtils.prototype, "pinnedRowModel", 2);
__decorateClass([
    Autowired("paginationProxy")
], RowPositionUtils.prototype, "paginationProxy", 2);
RowPositionUtils = __decorateClass([
    Bean("rowPositionUtils")
], RowPositionUtils);
// community-modules/core/src/entities/cellPositionUtils.ts
var CellPositionUtils = class extends BeanStub {
    createId(cellPosition) {
        const { rowIndex, rowPinned, column } = cellPosition;
        return this.createIdFromValues({
            rowIndex,
            column,
            rowPinned
        });
    }
    createIdFromValues(cellPosition) {
        const { rowIndex, rowPinned, column } = cellPosition;
        return `${rowIndex}.${rowPinned == null ? "null" : rowPinned}.${column.getId()}`;
    }
    equals(cellA, cellB) {
        const colsMatch = cellA.column === cellB.column;
        const floatingMatch = cellA.rowPinned === cellB.rowPinned;
        const indexMatch = cellA.rowIndex === cellB.rowIndex;
        return colsMatch && floatingMatch && indexMatch;
    }
};
CellPositionUtils = __decorateClass([
    Bean("cellPositionUtils")
], CellPositionUtils);
// community-modules/core/src/undoRedo/undoRedoStack.ts
var UndoRedoAction = class {
    constructor(cellValueChanges){
        this.cellValueChanges = cellValueChanges;
    }
};
var RangeUndoRedoAction = class extends UndoRedoAction {
    constructor(cellValueChanges, initialRange, finalRange, ranges){
        super(cellValueChanges);
        this.initialRange = initialRange;
        this.finalRange = finalRange;
        this.ranges = ranges;
    }
};
var _UndoRedoStack = class _UndoRedoStack {
    constructor(maxStackSize){
        this.actionStack = [];
        this.maxStackSize = maxStackSize ? maxStackSize : _UndoRedoStack.DEFAULT_STACK_SIZE;
        this.actionStack = new Array(this.maxStackSize);
    }
    pop() {
        return this.actionStack.pop();
    }
    push(item) {
        const shouldAddActions = item.cellValueChanges && item.cellValueChanges.length > 0;
        if (!shouldAddActions) return;
        if (this.actionStack.length === this.maxStackSize) this.actionStack.shift();
        this.actionStack.push(item);
    }
    clear() {
        this.actionStack = [];
    }
    getCurrentStackSize() {
        return this.actionStack.length;
    }
};
_UndoRedoStack.DEFAULT_STACK_SIZE = 10;
var UndoRedoStack = _UndoRedoStack;
// community-modules/core/src/undoRedo/undoRedoService.ts
var UndoRedoService = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.cellValueChanges = [];
        this.activeCellEdit = null;
        this.activeRowEdit = null;
        this.isPasting = false;
        this.isRangeInAction = false;
        this.onCellValueChanged = (event)=>{
            const eventCell = {
                column: event.column,
                rowIndex: event.rowIndex,
                rowPinned: event.rowPinned
            };
            const isCellEditing = this.activeCellEdit !== null && this.cellPositionUtils.equals(this.activeCellEdit, eventCell);
            const isRowEditing = this.activeRowEdit !== null && this.rowPositionUtils.sameRow(this.activeRowEdit, eventCell);
            const shouldCaptureAction = isCellEditing || isRowEditing || this.isPasting || this.isRangeInAction;
            if (!shouldCaptureAction) return;
            const { rowPinned, rowIndex, column, oldValue, value } = event;
            const cellValueChange = {
                rowPinned,
                rowIndex,
                columnId: column.getColId(),
                newValue: value,
                oldValue
            };
            this.cellValueChanges.push(cellValueChange);
        };
        this.clearStacks = ()=>{
            this.undoStack.clear();
            this.redoStack.clear();
        };
    }
    init() {
        if (!this.gos.get("undoRedoCellEditing")) return;
        const undoRedoLimit = this.gos.get("undoRedoCellEditingLimit");
        if (undoRedoLimit <= 0) return;
        this.undoStack = new UndoRedoStack(undoRedoLimit);
        this.redoStack = new UndoRedoStack(undoRedoLimit);
        this.addRowEditingListeners();
        this.addCellEditingListeners();
        this.addPasteListeners();
        this.addFillListeners();
        this.addCellKeyListeners();
        this.addManagedListener(this.eventService, Events.EVENT_CELL_VALUE_CHANGED, this.onCellValueChanged);
        this.addManagedListener(this.eventService, Events.EVENT_MODEL_UPDATED, (e)=>{
            if (!e.keepUndoRedoStack) this.clearStacks();
        });
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.clearStacks);
        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.clearStacks);
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_GROUP_OPENED, this.clearStacks);
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.clearStacks);
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_MOVED, this.clearStacks);
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PINNED, this.clearStacks);
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_VISIBLE, this.clearStacks);
        this.addManagedListener(this.eventService, Events.EVENT_ROW_DRAG_END, this.clearStacks);
        this.ctrlsService.whenReady((p)=>{
            this.gridBodyCtrl = p.gridBodyCtrl;
        });
    }
    getCurrentUndoStackSize() {
        return this.undoStack ? this.undoStack.getCurrentStackSize() : 0;
    }
    getCurrentRedoStackSize() {
        return this.redoStack ? this.redoStack.getCurrentStackSize() : 0;
    }
    undo(source) {
        const startEvent = {
            type: Events.EVENT_UNDO_STARTED,
            source
        };
        this.eventService.dispatchEvent(startEvent);
        const operationPerformed = this.undoRedo(this.undoStack, this.redoStack, "initialRange", "oldValue", "undo");
        const endEvent = {
            type: Events.EVENT_UNDO_ENDED,
            source,
            operationPerformed
        };
        this.eventService.dispatchEvent(endEvent);
    }
    redo(source) {
        const startEvent = {
            type: Events.EVENT_REDO_STARTED,
            source
        };
        this.eventService.dispatchEvent(startEvent);
        const operationPerformed = this.undoRedo(this.redoStack, this.undoStack, "finalRange", "newValue", "redo");
        const endEvent = {
            type: Events.EVENT_REDO_ENDED,
            source,
            operationPerformed
        };
        this.eventService.dispatchEvent(endEvent);
    }
    undoRedo(undoRedoStack, opposingUndoRedoStack, rangeProperty, cellValueChangeProperty, source) {
        if (!undoRedoStack) return false;
        const undoRedoAction = undoRedoStack.pop();
        if (!undoRedoAction || !undoRedoAction.cellValueChanges) return false;
        this.processAction(undoRedoAction, (cellValueChange)=>cellValueChange[cellValueChangeProperty], source);
        if (undoRedoAction instanceof RangeUndoRedoAction) this.processRange(this.rangeService, undoRedoAction.ranges || [
            undoRedoAction[rangeProperty]
        ]);
        else this.processCell(undoRedoAction.cellValueChanges);
        opposingUndoRedoStack.push(undoRedoAction);
        return true;
    }
    processAction(action, valueExtractor, source) {
        action.cellValueChanges.forEach((cellValueChange)=>{
            const { rowIndex, rowPinned, columnId } = cellValueChange;
            const rowPosition = {
                rowIndex,
                rowPinned
            };
            const currentRow = this.rowPositionUtils.getRowNode(rowPosition);
            if (!currentRow.displayed) return;
            currentRow.setDataValue(columnId, valueExtractor(cellValueChange), source);
        });
    }
    processRange(rangeService, ranges) {
        let lastFocusedCell;
        rangeService.removeAllCellRanges(true);
        ranges.forEach((range, idx)=>{
            if (!range) return;
            const startRow = range.startRow;
            const endRow = range.endRow;
            if (idx === ranges.length - 1) {
                lastFocusedCell = {
                    rowPinned: startRow.rowPinned,
                    rowIndex: startRow.rowIndex,
                    columnId: range.startColumn.getColId()
                };
                this.setLastFocusedCell(lastFocusedCell);
            }
            const cellRangeParams = {
                rowStartIndex: startRow.rowIndex,
                rowStartPinned: startRow.rowPinned,
                rowEndIndex: endRow.rowIndex,
                rowEndPinned: endRow.rowPinned,
                columnStart: range.startColumn,
                columns: range.columns
            };
            rangeService.addCellRange(cellRangeParams);
        });
    }
    processCell(cellValueChanges) {
        const cellValueChange = cellValueChanges[0];
        const { rowIndex, rowPinned } = cellValueChange;
        const rowPosition = {
            rowIndex,
            rowPinned
        };
        const row = this.rowPositionUtils.getRowNode(rowPosition);
        const lastFocusedCell = {
            rowPinned: cellValueChange.rowPinned,
            rowIndex: row.rowIndex,
            columnId: cellValueChange.columnId
        };
        this.setLastFocusedCell(lastFocusedCell, this.rangeService);
    }
    setLastFocusedCell(lastFocusedCell, rangeService) {
        const { rowIndex, columnId, rowPinned } = lastFocusedCell;
        const scrollFeature = this.gridBodyCtrl.getScrollFeature();
        const column = this.columnModel.getGridColumn(columnId);
        if (!column) return;
        scrollFeature.ensureIndexVisible(rowIndex);
        scrollFeature.ensureColumnVisible(column);
        const cellPosition = {
            rowIndex,
            column,
            rowPinned
        };
        this.focusService.setFocusedCell(__spreadProps(__spreadValues({}, cellPosition), {
            forceBrowserFocus: true
        }));
        rangeService == null || rangeService.setRangeToCell(cellPosition);
    }
    addRowEditingListeners() {
        this.addManagedListener(this.eventService, Events.EVENT_ROW_EDITING_STARTED, (e)=>{
            this.activeRowEdit = {
                rowIndex: e.rowIndex,
                rowPinned: e.rowPinned
            };
        });
        this.addManagedListener(this.eventService, Events.EVENT_ROW_EDITING_STOPPED, ()=>{
            const action = new UndoRedoAction(this.cellValueChanges);
            this.pushActionsToUndoStack(action);
            this.activeRowEdit = null;
        });
    }
    addCellEditingListeners() {
        this.addManagedListener(this.eventService, Events.EVENT_CELL_EDITING_STARTED, (e)=>{
            this.activeCellEdit = {
                column: e.column,
                rowIndex: e.rowIndex,
                rowPinned: e.rowPinned
            };
        });
        this.addManagedListener(this.eventService, Events.EVENT_CELL_EDITING_STOPPED, (e)=>{
            this.activeCellEdit = null;
            const shouldPushAction = e.valueChanged && !this.activeRowEdit && !this.isPasting && !this.isRangeInAction;
            if (shouldPushAction) {
                const action = new UndoRedoAction(this.cellValueChanges);
                this.pushActionsToUndoStack(action);
            }
        });
    }
    addPasteListeners() {
        this.addManagedListener(this.eventService, Events.EVENT_PASTE_START, ()=>{
            this.isPasting = true;
        });
        this.addManagedListener(this.eventService, Events.EVENT_PASTE_END, ()=>{
            const action = new UndoRedoAction(this.cellValueChanges);
            this.pushActionsToUndoStack(action);
            this.isPasting = false;
        });
    }
    addFillListeners() {
        this.addManagedListener(this.eventService, Events.EVENT_FILL_START, ()=>{
            this.isRangeInAction = true;
        });
        this.addManagedListener(this.eventService, Events.EVENT_FILL_END, (event)=>{
            const action = new RangeUndoRedoAction(this.cellValueChanges, event.initialRange, event.finalRange);
            this.pushActionsToUndoStack(action);
            this.isRangeInAction = false;
        });
    }
    addCellKeyListeners() {
        this.addManagedListener(this.eventService, Events.EVENT_KEY_SHORTCUT_CHANGED_CELL_START, ()=>{
            this.isRangeInAction = true;
        });
        this.addManagedListener(this.eventService, Events.EVENT_KEY_SHORTCUT_CHANGED_CELL_END, ()=>{
            let action;
            if (this.rangeService && this.gos.get("enableRangeSelection")) action = new RangeUndoRedoAction(this.cellValueChanges, void 0, void 0, [
                ...this.rangeService.getCellRanges()
            ]);
            else action = new UndoRedoAction(this.cellValueChanges);
            this.pushActionsToUndoStack(action);
            this.isRangeInAction = false;
        });
    }
    pushActionsToUndoStack(action) {
        this.undoStack.push(action);
        this.cellValueChanges = [];
        this.redoStack.clear();
    }
};
__decorateClass([
    Autowired("focusService")
], UndoRedoService.prototype, "focusService", 2);
__decorateClass([
    Autowired("ctrlsService")
], UndoRedoService.prototype, "ctrlsService", 2);
__decorateClass([
    Autowired("cellPositionUtils")
], UndoRedoService.prototype, "cellPositionUtils", 2);
__decorateClass([
    Autowired("rowPositionUtils")
], UndoRedoService.prototype, "rowPositionUtils", 2);
__decorateClass([
    Autowired("columnModel")
], UndoRedoService.prototype, "columnModel", 2);
__decorateClass([
    Optional("rangeService")
], UndoRedoService.prototype, "rangeService", 2);
__decorateClass([
    PostConstruct
], UndoRedoService.prototype, "init", 1);
UndoRedoService = __decorateClass([
    Bean("undoRedoService")
], UndoRedoService);
// community-modules/core/src/headerRendering/common/headerPosition.ts
var HeaderPositionUtils = class extends BeanStub {
    findHeader(focusedHeader, direction) {
        let nextColumn;
        let getColMethod;
        if (focusedHeader.column instanceof ColumnGroup) nextColumn = this.columnModel.getDisplayedGroupAtDirection(focusedHeader.column, direction);
        else {
            getColMethod = `getDisplayedCol${direction}`;
            nextColumn = this.columnModel[getColMethod](focusedHeader.column);
        }
        if (!nextColumn) return;
        let { headerRowIndex } = focusedHeader;
        if (this.getHeaderRowType(headerRowIndex) !== "filter" /* FLOATING_FILTER */ ) {
            const columnsInPath = [
                nextColumn
            ];
            while(nextColumn.getParent()){
                nextColumn = nextColumn.getParent();
                columnsInPath.push(nextColumn);
            }
            nextColumn = columnsInPath[columnsInPath.length - 1 - headerRowIndex];
        }
        const { column, headerRowIndex: indexToFocus } = this.getHeaderIndexToFocus(nextColumn, headerRowIndex);
        return {
            column,
            headerRowIndex: indexToFocus
        };
    }
    getHeaderIndexToFocus(column, currentIndex) {
        let nextColumn;
        if (column instanceof ColumnGroup && this.isAnyChildSpanningHeaderHeight(column) && column.isPadding()) {
            const targetColumn = column;
            nextColumn = targetColumn.getLeafColumns()[0];
            let col = nextColumn;
            while(col !== targetColumn){
                currentIndex++;
                col = col.getParent();
            }
        }
        return {
            column: nextColumn || column,
            headerRowIndex: currentIndex
        };
    }
    isAnyChildSpanningHeaderHeight(columnGroup) {
        if (!columnGroup) return false;
        return columnGroup.getLeafColumns().some((col)=>col.isSpanHeaderHeight());
    }
    getColumnVisibleParent(currentColumn, currentIndex) {
        const currentRowType = this.getHeaderRowType(currentIndex);
        const isFloatingFilter = currentRowType === "filter" /* FLOATING_FILTER */ ;
        const isColumn = currentRowType === "column" /* COLUMN */ ;
        let nextFocusColumn = isFloatingFilter ? currentColumn : currentColumn.getParent();
        let nextRow = currentIndex - 1;
        let headerRowIndexWithoutSpan = nextRow;
        if (isColumn && this.isAnyChildSpanningHeaderHeight(currentColumn.getParent())) {
            while(nextFocusColumn && nextFocusColumn.isPadding()){
                nextFocusColumn = nextFocusColumn.getParent();
                nextRow--;
            }
            headerRowIndexWithoutSpan = nextRow;
            if (nextRow < 0) {
                nextFocusColumn = currentColumn;
                nextRow = currentIndex;
                headerRowIndexWithoutSpan = void 0;
            }
        }
        return {
            column: nextFocusColumn,
            headerRowIndex: nextRow,
            headerRowIndexWithoutSpan
        };
    }
    getColumnVisibleChild(column, currentIndex, direction = "After") {
        const currentRowType = this.getHeaderRowType(currentIndex);
        let nextFocusColumn = column;
        let nextRow = currentIndex + 1;
        let headerRowIndexWithoutSpan = nextRow;
        if (currentRowType === "group" /* COLUMN_GROUP */ ) {
            const leafColumns = column.getDisplayedLeafColumns();
            const leafColumn = direction === "After" ? leafColumns[0] : last(leafColumns);
            const columnsInTheWay = [];
            let currentColumn = leafColumn;
            while(currentColumn.getParent() !== column){
                currentColumn = currentColumn.getParent();
                columnsInTheWay.push(currentColumn);
            }
            nextFocusColumn = leafColumn;
            if (leafColumn.isSpanHeaderHeight()) for(let i = columnsInTheWay.length - 1; i >= 0; i--){
                const colToFocus = columnsInTheWay[i];
                if (!colToFocus.isPadding()) {
                    nextFocusColumn = colToFocus;
                    break;
                }
                nextRow++;
            }
            else {
                nextFocusColumn = last(columnsInTheWay);
                if (!nextFocusColumn) nextFocusColumn = leafColumn;
            }
        }
        return {
            column: nextFocusColumn,
            headerRowIndex: nextRow,
            headerRowIndexWithoutSpan
        };
    }
    getHeaderRowType(rowIndex) {
        const centerHeaderContainer = this.ctrlsService.getHeaderRowContainerCtrl();
        if (centerHeaderContainer) return centerHeaderContainer.getRowType(rowIndex);
    }
    findColAtEdgeForHeaderRow(level, position) {
        const displayedColumns = this.columnModel.getAllDisplayedColumns();
        const column = displayedColumns[position === "start" ? 0 : displayedColumns.length - 1];
        if (!column) return;
        const childContainer = this.ctrlsService.getHeaderRowContainerCtrl(column.getPinned());
        const type = childContainer.getRowType(level);
        if (type == "group" /* COLUMN_GROUP */ ) {
            const columnGroup = this.columnModel.getColumnGroupAtLevel(column, level);
            return {
                headerRowIndex: level,
                column: columnGroup
            };
        }
        return {
            // if type==null, means the header level didn't exist
            headerRowIndex: type == null ? -1 : level,
            column
        };
    }
};
__decorateClass([
    Autowired("columnModel")
], HeaderPositionUtils.prototype, "columnModel", 2);
__decorateClass([
    Autowired("ctrlsService")
], HeaderPositionUtils.prototype, "ctrlsService", 2);
HeaderPositionUtils = __decorateClass([
    Bean("headerPositionUtils")
], HeaderPositionUtils);
// community-modules/core/src/columns/columnDefFactory.ts
var ColumnDefFactory = class {
    buildColumnDefs(cols, rowGroupColumns, pivotColumns) {
        const res = [];
        const colGroupDefs = {};
        cols.forEach((col)=>{
            const colDef = this.createDefFromColumn(col, rowGroupColumns, pivotColumns);
            let addToResult = true;
            let childDef = colDef;
            let pointer = col.getOriginalParent();
            let lastPointer = null;
            while(pointer){
                let parentDef = null;
                if (pointer.isPadding()) {
                    pointer = pointer.getOriginalParent();
                    continue;
                }
                const existingParentDef = colGroupDefs[pointer.getGroupId()];
                if (existingParentDef) {
                    existingParentDef.children.push(childDef);
                    addToResult = false;
                    break;
                }
                parentDef = this.createDefFromGroup(pointer);
                if (parentDef) {
                    parentDef.children = [
                        childDef
                    ];
                    colGroupDefs[parentDef.groupId] = parentDef;
                    childDef = parentDef;
                    pointer = pointer.getOriginalParent();
                }
                if (pointer != null && lastPointer === pointer) {
                    addToResult = false;
                    break;
                }
                lastPointer = pointer;
            }
            if (addToResult) res.push(childDef);
        });
        return res;
    }
    createDefFromGroup(group) {
        const defCloned = deepCloneDefinition(group.getColGroupDef(), [
            "children"
        ]);
        if (defCloned) defCloned.groupId = group.getGroupId();
        return defCloned;
    }
    createDefFromColumn(col, rowGroupColumns, pivotColumns) {
        const colDefCloned = deepCloneDefinition(col.getColDef());
        colDefCloned.colId = col.getColId();
        colDefCloned.width = col.getActualWidth();
        colDefCloned.rowGroup = col.isRowGroupActive();
        colDefCloned.rowGroupIndex = col.isRowGroupActive() ? rowGroupColumns.indexOf(col) : null;
        colDefCloned.pivot = col.isPivotActive();
        colDefCloned.pivotIndex = col.isPivotActive() ? pivotColumns.indexOf(col) : null;
        colDefCloned.aggFunc = col.isValueActive() ? col.getAggFunc() : null;
        colDefCloned.hide = col.isVisible() ? void 0 : true;
        colDefCloned.pinned = col.isPinned() ? col.getPinned() : null;
        colDefCloned.sort = col.getSort() ? col.getSort() : null;
        colDefCloned.sortIndex = col.getSortIndex() != null ? col.getSortIndex() : null;
        return colDefCloned;
    }
};
ColumnDefFactory = __decorateClass([
    Bean("columnDefFactory")
], ColumnDefFactory);
// community-modules/core/src/rendering/row/rowCssClassCalculator.ts
var RowCssClassCalculator = class {
    getInitialRowClasses(params) {
        const classes = [];
        if (exists(params.extraCssClass)) classes.push(params.extraCssClass);
        classes.push("ag-row");
        classes.push(params.rowFocused ? "ag-row-focus" : "ag-row-no-focus");
        if (params.fadeRowIn) classes.push("ag-opacity-zero");
        classes.push(params.rowIsEven ? "ag-row-even" : "ag-row-odd");
        if (params.rowNode.isRowPinned()) classes.push("ag-row-pinned");
        if (params.rowNode.isSelected()) classes.push("ag-row-selected");
        if (params.rowNode.footer) classes.push("ag-row-footer");
        classes.push("ag-row-level-" + params.rowLevel);
        if (params.rowNode.stub) classes.push("ag-row-loading");
        if (params.fullWidthRow) classes.push("ag-full-width-row");
        if (params.expandable) {
            classes.push("ag-row-group");
            classes.push(params.rowNode.expanded ? "ag-row-group-expanded" : "ag-row-group-contracted");
        }
        if (params.rowNode.dragging) classes.push("ag-row-dragging");
        pushAll(classes, this.processClassesFromGridOptions(params.rowNode));
        pushAll(classes, this.preProcessRowClassRules(params.rowNode));
        classes.push(params.printLayout ? "ag-row-position-relative" : "ag-row-position-absolute");
        if (params.firstRowOnPage) classes.push("ag-row-first");
        if (params.lastRowOnPage) classes.push("ag-row-last");
        if (params.fullWidthRow) {
            if (params.pinned === "left") classes.push("ag-cell-last-left-pinned");
            if (params.pinned === "right") classes.push("ag-cell-first-right-pinned");
        }
        return classes;
    }
    processClassesFromGridOptions(rowNode) {
        const res = [];
        const process = (rowCls)=>{
            if (typeof rowCls === "string") res.push(rowCls);
            else if (Array.isArray(rowCls)) rowCls.forEach((e)=>res.push(e));
        };
        const rowClass = this.gos.get("rowClass");
        if (rowClass) {
            if (typeof rowClass === "function") {
                console.warn("AG Grid: rowClass should not be a function, please use getRowClass instead");
                return [];
            }
            process(rowClass);
        }
        const rowClassFunc = this.gos.getCallback("getRowClass");
        if (rowClassFunc) {
            const params = {
                data: rowNode.data,
                node: rowNode,
                rowIndex: rowNode.rowIndex
            };
            const rowClassFuncResult = rowClassFunc(params);
            process(rowClassFuncResult);
        }
        return res;
    }
    preProcessRowClassRules(rowNode) {
        const res = [];
        this.processRowClassRules(rowNode, (className)=>{
            res.push(className);
        }, (className)=>{});
        return res;
    }
    processRowClassRules(rowNode, onApplicableClass, onNotApplicableClass) {
        const rowClassParams = this.gos.addGridCommonParams({
            data: rowNode.data,
            node: rowNode,
            rowIndex: rowNode.rowIndex
        });
        this.stylingService.processClassRules(void 0, this.gos.get("rowClassRules"), rowClassParams, onApplicableClass, onNotApplicableClass);
    }
    calculateRowLevel(rowNode) {
        if (rowNode.group) return rowNode.level;
        return rowNode.parent ? rowNode.parent.level + 1 : 0;
    }
};
__decorateClass([
    Autowired("stylingService")
], RowCssClassCalculator.prototype, "stylingService", 2);
__decorateClass([
    Autowired("gridOptionsService")
], RowCssClassCalculator.prototype, "gos", 2);
RowCssClassCalculator = __decorateClass([
    Bean("rowCssClassCalculator")
], RowCssClassCalculator);
// community-modules/core/src/rowNodes/rowNodeSorter.ts
var RowNodeSorter = class extends BeanStub {
    init() {
        this.isAccentedSort = this.gos.get("accentedSort");
        this.primaryColumnsSortGroups = this.gos.isColumnsSortingCoupledToGroup();
        this.addManagedPropertyListener("accentedSort", (propChange)=>this.isAccentedSort = propChange.currentValue);
        this.addManagedPropertyListener("autoGroupColumnDef", ()=>this.primaryColumnsSortGroups = this.gos.isColumnsSortingCoupledToGroup());
    }
    doFullSort(rowNodes, sortOptions) {
        const mapper = (rowNode, pos)=>({
                currentPos: pos,
                rowNode
            });
        const sortedRowNodes = rowNodes.map(mapper);
        sortedRowNodes.sort(this.compareRowNodes.bind(this, sortOptions));
        return sortedRowNodes.map((item)=>item.rowNode);
    }
    compareRowNodes(sortOptions, sortedNodeA, sortedNodeB) {
        const nodeA = sortedNodeA.rowNode;
        const nodeB = sortedNodeB.rowNode;
        for(let i = 0, len = sortOptions.length; i < len; i++){
            const sortOption = sortOptions[i];
            const isDescending = sortOption.sort === "desc";
            const valueA = this.getValue(nodeA, sortOption.column);
            const valueB = this.getValue(nodeB, sortOption.column);
            let comparatorResult;
            const providedComparator = this.getComparator(sortOption, nodeA);
            if (providedComparator) comparatorResult = providedComparator(valueA, valueB, nodeA, nodeB, isDescending);
            else comparatorResult = _.defaultComparator(valueA, valueB, this.isAccentedSort);
            const validResult = !isNaN(comparatorResult);
            if (validResult && comparatorResult !== 0) return sortOption.sort === "asc" ? comparatorResult : comparatorResult * -1;
        }
        return sortedNodeA.currentPos - sortedNodeB.currentPos;
    }
    getComparator(sortOption, rowNode) {
        const column = sortOption.column;
        const comparatorOnCol = column.getColDef().comparator;
        if (comparatorOnCol != null) return comparatorOnCol;
        if (!column.getColDef().showRowGroup) return;
        const groupLeafField = !rowNode.group && column.getColDef().field;
        if (!groupLeafField) return;
        const primaryColumn = this.columnModel.getPrimaryColumn(groupLeafField);
        if (!primaryColumn) return;
        return primaryColumn.getColDef().comparator;
    }
    getValue(node, column) {
        var _a, _b;
        if (!this.primaryColumnsSortGroups) return this.valueService.getValue(column, node, false, false);
        const isNodeGroupedAtLevel = node.rowGroupColumn === column;
        if (isNodeGroupedAtLevel) {
            const isGroupRows = this.gos.isGroupUseEntireRow(this.columnModel.isPivotActive());
            if (isGroupRows) {
                const leafChild = (_a = node.allLeafChildren) == null ? void 0 : _a[0];
                if (leafChild) return this.valueService.getValue(column, leafChild, false, false);
                return void 0;
            }
            const displayCol = this.columnModel.getGroupDisplayColumnForGroup(column.getId());
            if (!displayCol) return void 0;
            return (_b = node.groupData) == null ? void 0 : _b[displayCol.getId()];
        }
        if (node.group && column.getColDef().showRowGroup) return void 0;
        return this.valueService.getValue(column, node, false, false);
    }
};
__decorateClass([
    Autowired("valueService")
], RowNodeSorter.prototype, "valueService", 2);
__decorateClass([
    Autowired("columnModel")
], RowNodeSorter.prototype, "columnModel", 2);
__decorateClass([
    PostConstruct
], RowNodeSorter.prototype, "init", 1);
RowNodeSorter = __decorateClass([
    Bean("rowNodeSorter")
], RowNodeSorter);
// community-modules/core/src/ctrlsService.ts
var CtrlsService = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.params = {};
        this.ready = false;
        this.readyCallbacks = [];
    }
    checkReady() {
        const params = this.params;
        this.ready = params.gridCtrl != null && params.gridBodyCtrl != null && params.center != null && params.left != null && params.right != null && params.bottomCenter != null && params.bottomLeft != null && params.bottomRight != null && params.topCenter != null && params.topLeft != null && params.topRight != null && params.stickyTopCenter != null && params.stickyTopLeft != null && params.stickyTopRight != null && params.stickyBottomCenter != null && params.stickyBottomLeft != null && params.stickyBottomRight != null && params.centerHeader != null && params.leftHeader != null && params.rightHeader != null && params.fakeHScrollComp != null && params.fakeVScrollComp != null && params.gridHeaderCtrl != null;
        if (this.ready) {
            this.readyCallbacks.forEach((c)=>c(params));
            this.readyCallbacks.length = 0;
        }
    }
    whenReady(callback) {
        if (this.ready) callback(this.params);
        else this.readyCallbacks.push(callback);
    }
    register(ctrlType, ctrl) {
        this.params[ctrlType] = ctrl;
        this.checkReady();
    }
    registerHeaderContainer(ctrl, pinned) {
        switch(pinned){
            case "left":
                this.params.leftHeader = ctrl;
                break;
            case "right":
                this.params.rightHeader = ctrl;
                break;
            default:
                this.params.centerHeader = ctrl;
                break;
        }
        this.checkReady();
    }
    get(ctrlType) {
        return this.params[ctrlType];
    }
    getParams() {
        return this.params;
    }
    getGridBodyCtrl() {
        return this.params.gridBodyCtrl;
    }
    getHeaderRowContainerCtrls() {
        return [
            this.params.leftHeader,
            this.params.rightHeader,
            this.params.centerHeader
        ];
    }
    getHeaderRowContainerCtrl(pinned) {
        switch(pinned){
            case "left":
                return this.params.leftHeader;
            case "right":
                return this.params.rightHeader;
            default:
                return this.params.centerHeader;
        }
    }
};
CtrlsService.NAME = "ctrlsService";
CtrlsService = __decorateClass([
    Bean(CtrlsService.NAME)
], CtrlsService);
// community-modules/core/src/ctrlsFactory.ts
var CtrlsFactory = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.registry = {};
    }
    register(meta) {
        this.registry[meta.controllerName] = meta.controllerClass;
    }
    getInstance(name) {
        const ControllerClass = this.registry[name];
        if (ControllerClass == null) return void 0;
        return new ControllerClass();
    }
};
CtrlsFactory = __decorateClass([
    Bean("ctrlsFactory")
], CtrlsFactory);
// community-modules/core/src/gridBodyComp/abstractFakeScrollComp.ts
var AbstractFakeScrollComp = class extends Component {
    constructor(template, direction){
        super(template);
        this.direction = direction;
        this.hideTimeout = null;
    }
    postConstruct() {
        this.addManagedListener(this.eventService, Events.EVENT_SCROLL_VISIBILITY_CHANGED, this.onScrollVisibilityChanged.bind(this));
        this.onScrollVisibilityChanged();
        this.addOrRemoveCssClass("ag-apple-scrollbar", isMacOsUserAgent() || isIOSUserAgent());
    }
    initialiseInvisibleScrollbar() {
        if (this.invisibleScrollbar !== void 0) return;
        this.invisibleScrollbar = isInvisibleScrollbar();
        if (this.invisibleScrollbar) {
            this.hideAndShowInvisibleScrollAsNeeded();
            this.addActiveListenerToggles();
        }
    }
    addActiveListenerToggles() {
        const activateEvents = [
            "mouseenter",
            "mousedown",
            "touchstart"
        ];
        const deactivateEvents = [
            "mouseleave",
            "touchend"
        ];
        const eGui = this.getGui();
        activateEvents.forEach((eventName)=>this.addManagedListener(eGui, eventName, ()=>this.addOrRemoveCssClass("ag-scrollbar-active", true)));
        deactivateEvents.forEach((eventName)=>this.addManagedListener(eGui, eventName, ()=>this.addOrRemoveCssClass("ag-scrollbar-active", false)));
    }
    onScrollVisibilityChanged() {
        if (this.invisibleScrollbar === void 0) this.initialiseInvisibleScrollbar();
        this.animationFrameService.requestAnimationFrame(()=>this.setScrollVisible());
    }
    hideAndShowInvisibleScrollAsNeeded() {
        this.addManagedListener(this.eventService, Events.EVENT_BODY_SCROLL, (params)=>{
            if (params.direction === this.direction) {
                if (this.hideTimeout !== null) {
                    window.clearTimeout(this.hideTimeout);
                    this.hideTimeout = null;
                }
                this.addOrRemoveCssClass("ag-scrollbar-scrolling", true);
            }
        });
        this.addManagedListener(this.eventService, Events.EVENT_BODY_SCROLL_END, ()=>{
            this.hideTimeout = window.setTimeout(()=>{
                this.addOrRemoveCssClass("ag-scrollbar-scrolling", false);
                this.hideTimeout = null;
            }, 400);
        });
    }
    attemptSettingScrollPosition(value) {
        const viewport = this.getViewport();
        waitUntil(()=>isVisible(viewport), ()=>this.setScrollPosition(value), 100);
    }
    getViewport() {
        return this.eViewport;
    }
    getContainer() {
        return this.eContainer;
    }
    onScrollCallback(fn) {
        this.addManagedListener(this.getViewport(), "scroll", fn);
    }
};
__decorateClass([
    RefSelector("eViewport")
], AbstractFakeScrollComp.prototype, "eViewport", 2);
__decorateClass([
    RefSelector("eContainer")
], AbstractFakeScrollComp.prototype, "eContainer", 2);
__decorateClass([
    Autowired("scrollVisibleService")
], AbstractFakeScrollComp.prototype, "scrollVisibleService", 2);
__decorateClass([
    Autowired("ctrlsService")
], AbstractFakeScrollComp.prototype, "ctrlsService", 2);
__decorateClass([
    Autowired("animationFrameService")
], AbstractFakeScrollComp.prototype, "animationFrameService", 2);
// community-modules/core/src/gridBodyComp/fakeHScrollComp.ts
var _FakeHScrollComp = class _FakeHScrollComp extends AbstractFakeScrollComp {
    constructor(){
        super(_FakeHScrollComp.TEMPLATE, "horizontal");
    }
    postConstruct() {
        super.postConstruct();
        const spacerWidthsListener = this.setFakeHScrollSpacerWidths.bind(this);
        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, spacerWidthsListener);
        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, spacerWidthsListener);
        this.addManagedListener(this.eventService, Events.EVENT_PINNED_ROW_DATA_CHANGED, this.onPinnedRowDataChanged.bind(this));
        this.addManagedPropertyListener("domLayout", spacerWidthsListener);
        this.ctrlsService.register("fakeHScrollComp", this);
        this.createManagedBean(new CenterWidthFeature((width)=>this.eContainer.style.width = `${width}px`));
        this.addManagedPropertyListeners([
            "suppressHorizontalScroll"
        ], this.onScrollVisibilityChanged.bind(this));
    }
    initialiseInvisibleScrollbar() {
        if (this.invisibleScrollbar !== void 0) return;
        this.enableRtl = this.gos.get("enableRtl");
        super.initialiseInvisibleScrollbar();
        if (this.invisibleScrollbar) this.refreshCompBottom();
    }
    onPinnedRowDataChanged() {
        this.refreshCompBottom();
    }
    refreshCompBottom() {
        if (!this.invisibleScrollbar) return;
        const bottomPinnedHeight = this.pinnedRowModel.getPinnedBottomTotalHeight();
        this.getGui().style.bottom = `${bottomPinnedHeight}px`;
    }
    onScrollVisibilityChanged() {
        super.onScrollVisibilityChanged();
        this.setFakeHScrollSpacerWidths();
    }
    setFakeHScrollSpacerWidths() {
        const vScrollShowing = this.scrollVisibleService.isVerticalScrollShowing();
        let rightSpacing = this.columnModel.getDisplayedColumnsRightWidth();
        const scrollOnRight = !this.enableRtl && vScrollShowing;
        const scrollbarWidth = this.gos.getScrollbarWidth();
        if (scrollOnRight) rightSpacing += scrollbarWidth;
        setFixedWidth(this.eRightSpacer, rightSpacing);
        this.eRightSpacer.classList.toggle("ag-scroller-corner", rightSpacing <= scrollbarWidth);
        let leftSpacing = this.columnModel.getDisplayedColumnsLeftWidth();
        const scrollOnLeft = this.enableRtl && vScrollShowing;
        if (scrollOnLeft) leftSpacing += scrollbarWidth;
        setFixedWidth(this.eLeftSpacer, leftSpacing);
        this.eLeftSpacer.classList.toggle("ag-scroller-corner", leftSpacing <= scrollbarWidth);
    }
    setScrollVisible() {
        const hScrollShowing = this.scrollVisibleService.isHorizontalScrollShowing();
        const invisibleScrollbar2 = this.invisibleScrollbar;
        const isSuppressHorizontalScroll = this.gos.get("suppressHorizontalScroll");
        const scrollbarWidth = hScrollShowing ? this.gos.getScrollbarWidth() || 0 : 0;
        const adjustedScrollbarWidth = scrollbarWidth === 0 && invisibleScrollbar2 ? 16 : scrollbarWidth;
        const scrollContainerSize = !isSuppressHorizontalScroll ? adjustedScrollbarWidth : 0;
        this.addOrRemoveCssClass("ag-scrollbar-invisible", invisibleScrollbar2);
        setFixedHeight(this.getGui(), scrollContainerSize);
        setFixedHeight(this.eViewport, scrollContainerSize);
        setFixedHeight(this.eContainer, scrollContainerSize);
        this.setDisplayed(hScrollShowing, {
            skipAriaHidden: true
        });
    }
    getScrollPosition() {
        return getScrollLeft(this.getViewport(), this.enableRtl);
    }
    setScrollPosition(value) {
        if (!isVisible(this.getViewport())) this.attemptSettingScrollPosition(value);
        setScrollLeft(this.getViewport(), value, this.enableRtl);
    }
};
_FakeHScrollComp.TEMPLATE = /* html */ `<div class="ag-body-horizontal-scroll" aria-hidden="true">
            <div class="ag-horizontal-left-spacer" ref="eLeftSpacer"></div>
            <div class="ag-body-horizontal-scroll-viewport" ref="eViewport">
                <div class="ag-body-horizontal-scroll-container" ref="eContainer"></div>
            </div>
            <div class="ag-horizontal-right-spacer" ref="eRightSpacer"></div>
        </div>`;
__decorateClass([
    RefSelector("eLeftSpacer")
], _FakeHScrollComp.prototype, "eLeftSpacer", 2);
__decorateClass([
    RefSelector("eRightSpacer")
], _FakeHScrollComp.prototype, "eRightSpacer", 2);
__decorateClass([
    Autowired("columnModel")
], _FakeHScrollComp.prototype, "columnModel", 2);
__decorateClass([
    Autowired("pinnedRowModel")
], _FakeHScrollComp.prototype, "pinnedRowModel", 2);
__decorateClass([
    PostConstruct
], _FakeHScrollComp.prototype, "postConstruct", 1);
var FakeHScrollComp = _FakeHScrollComp;
// community-modules/core/src/gridBodyComp/pinnedWidthService.ts
var PinnedWidthService = class extends BeanStub {
    postConstruct() {
        const listener = this.checkContainerWidths.bind(this);
        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_CHANGED, listener);
        this.addManagedListener(this.eventService, Events.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, listener);
        this.addManagedPropertyListener("domLayout", listener);
    }
    checkContainerWidths() {
        const printLayout = this.gos.isDomLayout("print");
        const newLeftWidth = printLayout ? 0 : this.columnModel.getDisplayedColumnsLeftWidth();
        const newRightWidth = printLayout ? 0 : this.columnModel.getDisplayedColumnsRightWidth();
        if (newLeftWidth != this.leftWidth) {
            this.leftWidth = newLeftWidth;
            this.eventService.dispatchEvent({
                type: Events.EVENT_LEFT_PINNED_WIDTH_CHANGED
            });
        }
        if (newRightWidth != this.rightWidth) {
            this.rightWidth = newRightWidth;
            this.eventService.dispatchEvent({
                type: Events.EVENT_RIGHT_PINNED_WIDTH_CHANGED
            });
        }
    }
    getPinnedRightWidth() {
        return this.rightWidth;
    }
    getPinnedLeftWidth() {
        return this.leftWidth;
    }
};
__decorateClass([
    Autowired("columnModel")
], PinnedWidthService.prototype, "columnModel", 2);
__decorateClass([
    PostConstruct
], PinnedWidthService.prototype, "postConstruct", 1);
PinnedWidthService = __decorateClass([
    Bean("pinnedWidthService")
], PinnedWidthService);
// community-modules/core/src/entities/rowNodeEventThrottle.ts
var RowNodeEventThrottle = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.events = [];
    }
    postConstruct() {
        if (this.rowModel.getType() == "clientSide") this.clientSideRowModel = this.rowModel;
    }
    // because the user can call rowNode.setExpanded() many times in one VM turn,
    // we throttle the calls to ClientSideRowModel using animationFrameService. this means for 100
    // row nodes getting expanded, we only update the CSRM once, and then we fire all events after
    // CSRM has updated.
    //
    // if we did not do this, then the user could call setExpanded on 100+ rows, causing the grid
    // to re-render 100+ times, which would be a performance lag.
    //
    // we use animationFrameService
    // rather than _.debounce() so this will get done if anyone flushes the animationFrameService
    // (eg user calls api.ensureRowVisible(), which in turn flushes ).
    dispatchExpanded(event, forceSync) {
        if (this.clientSideRowModel == null) {
            this.eventService.dispatchEvent(event);
            return;
        }
        this.events.push(event);
        const func = ()=>{
            if (this.clientSideRowModel) this.clientSideRowModel.onRowGroupOpened();
            this.events.forEach((e)=>this.eventService.dispatchEvent(e));
            this.events = [];
        };
        if (forceSync) func();
        else {
            if (this.dispatchExpandedDebounced == null) this.dispatchExpandedDebounced = this.animationFrameService.debounce(func);
            this.dispatchExpandedDebounced();
        }
    }
};
__decorateClass([
    Autowired("animationFrameService")
], RowNodeEventThrottle.prototype, "animationFrameService", 2);
__decorateClass([
    Autowired("rowModel")
], RowNodeEventThrottle.prototype, "rowModel", 2);
__decorateClass([
    PostConstruct
], RowNodeEventThrottle.prototype, "postConstruct", 1);
RowNodeEventThrottle = __decorateClass([
    Bean("rowNodeEventThrottle")
], RowNodeEventThrottle);
// community-modules/core/src/validation/rules/colDefValidations.ts
var COLUMN_DEFINITION_DEPRECATIONS = {
    columnsMenuParams: {
        version: "31.1",
        message: "Use `columnChooserParams` instead."
    },
    suppressMenu: {
        version: "31.1",
        message: "Use `suppressHeaderMenuButton` instead."
    },
    suppressCellFlash: {
        version: "31.2",
        message: "Use `enableCellChangeFlash={false}` in the ColDef"
    },
    dndSource: {
        version: "31.2",
        message: "This feature has been replaced by `Row Dragging to an External DropZone`."
    },
    dndSourceOnRowDrag: {
        version: "31.2",
        message: "This feature has been replaced by `Row Dragging to an External DropZone`."
    }
};
var CSRM_REQUIRES_ROW_GROUP_MODULE = (_options, gridOptions)=>{
    var _a;
    if (((_a = gridOptions.rowModelType) != null ? _a : "clientSide") === "clientSide") return {
        module: "@ag-grid-enterprise/row-grouping" /* RowGroupingModule */ 
    };
    return null;
};
var COLUMN_DEFINITION_VALIDATIONS = {
    // supported on all row models, but need module for client side.
    enableRowGroup: CSRM_REQUIRES_ROW_GROUP_MODULE,
    rowGroup: CSRM_REQUIRES_ROW_GROUP_MODULE,
    rowGroupIndex: CSRM_REQUIRES_ROW_GROUP_MODULE,
    enablePivot: CSRM_REQUIRES_ROW_GROUP_MODULE,
    enableValue: CSRM_REQUIRES_ROW_GROUP_MODULE,
    pivot: CSRM_REQUIRES_ROW_GROUP_MODULE,
    pivotIndex: CSRM_REQUIRES_ROW_GROUP_MODULE,
    aggFunc: CSRM_REQUIRES_ROW_GROUP_MODULE,
    cellEditor: (options)=>{
        if (options.cellEditor === "agRichSelect" || options.cellEditor === "agRichSelectCellEditor") return {
            module: "@ag-grid-enterprise/rich-select" /* RichSelectModule */ 
        };
        return null;
    },
    menuTabs: (options)=>{
        var _a;
        const enterpriseMenuTabs = [
            "columnsMenuTab",
            "generalMenuTab"
        ];
        if ((_a = options.menuTabs) == null ? void 0 : _a.some((tab)=>enterpriseMenuTabs.includes(tab))) return {
            module: "@ag-grid-enterprise/menu" /* MenuModule */ 
        };
        return null;
    },
    columnsMenuParams: {
        module: [
            "@ag-grid-enterprise/menu" /* MenuModule */ ,
            "@ag-grid-enterprise/column-tool-panel" /* ColumnsToolPanelModule */ 
        ]
    },
    columnChooserParams: {
        module: [
            "@ag-grid-enterprise/menu" /* MenuModule */ ,
            "@ag-grid-enterprise/column-tool-panel" /* ColumnsToolPanelModule */ 
        ]
    },
    headerCheckboxSelection: {
        supportedRowModels: [
            "clientSide",
            "serverSide"
        ],
        dependencies: (_options, { rowSelection })=>rowSelection === "multiple" ? null : "headerCheckboxSelection is only supported with rowSelection=multiple"
    },
    headerCheckboxSelectionFilteredOnly: {
        supportedRowModels: [
            "clientSide"
        ],
        dependencies: (_options, { rowSelection })=>rowSelection === "multiple" ? null : "headerCheckboxSelectionFilteredOnly is only supported with rowSelection=multiple"
    },
    headerCheckboxSelectionCurrentPageOnly: {
        supportedRowModels: [
            "clientSide"
        ],
        dependencies: (_options, { rowSelection })=>rowSelection === "multiple" ? null : "headerCheckboxSelectionCurrentPageOnly is only supported with rowSelection=multiple"
    },
    children: ()=>COL_DEF_VALIDATORS
};
var colDefPropertyMap = {
    headerName: void 0,
    columnGroupShow: void 0,
    headerClass: void 0,
    toolPanelClass: void 0,
    headerValueGetter: void 0,
    pivotKeys: void 0,
    groupId: void 0,
    colId: void 0,
    sort: void 0,
    initialSort: void 0,
    field: void 0,
    type: void 0,
    cellDataType: void 0,
    tooltipComponent: void 0,
    tooltipField: void 0,
    headerTooltip: void 0,
    cellClass: void 0,
    showRowGroup: void 0,
    filter: void 0,
    initialAggFunc: void 0,
    defaultAggFunc: void 0,
    aggFunc: void 0,
    pinned: void 0,
    initialPinned: void 0,
    chartDataType: void 0,
    cellAriaRole: void 0,
    cellEditorPopupPosition: void 0,
    headerGroupComponent: void 0,
    headerGroupComponentParams: void 0,
    cellStyle: void 0,
    cellRenderer: void 0,
    cellRendererParams: void 0,
    cellEditor: void 0,
    cellEditorParams: void 0,
    filterParams: void 0,
    pivotValueColumn: void 0,
    headerComponent: void 0,
    headerComponentParams: void 0,
    floatingFilterComponent: void 0,
    floatingFilterComponentParams: void 0,
    tooltipComponentParams: void 0,
    refData: void 0,
    columnsMenuParams: void 0,
    columnChooserParams: void 0,
    children: void 0,
    sortingOrder: void 0,
    allowedAggFuncs: void 0,
    menuTabs: void 0,
    pivotTotalColumnIds: void 0,
    cellClassRules: void 0,
    icons: void 0,
    sortIndex: void 0,
    initialSortIndex: void 0,
    flex: void 0,
    initialFlex: void 0,
    width: void 0,
    initialWidth: void 0,
    minWidth: void 0,
    maxWidth: void 0,
    rowGroupIndex: void 0,
    initialRowGroupIndex: void 0,
    pivotIndex: void 0,
    initialPivotIndex: void 0,
    suppressCellFlash: void 0,
    suppressColumnsToolPanel: void 0,
    suppressFiltersToolPanel: void 0,
    openByDefault: void 0,
    marryChildren: void 0,
    suppressStickyLabel: void 0,
    hide: void 0,
    initialHide: void 0,
    rowGroup: void 0,
    initialRowGroup: void 0,
    pivot: void 0,
    initialPivot: void 0,
    checkboxSelection: void 0,
    showDisabledCheckboxes: void 0,
    headerCheckboxSelection: void 0,
    headerCheckboxSelectionFilteredOnly: void 0,
    headerCheckboxSelectionCurrentPageOnly: void 0,
    suppressMenu: void 0,
    suppressHeaderMenuButton: void 0,
    suppressMovable: void 0,
    lockPosition: void 0,
    lockVisible: void 0,
    lockPinned: void 0,
    unSortIcon: void 0,
    suppressSizeToFit: void 0,
    suppressAutoSize: void 0,
    enableRowGroup: void 0,
    enablePivot: void 0,
    enableValue: void 0,
    editable: void 0,
    suppressPaste: void 0,
    suppressNavigable: void 0,
    enableCellChangeFlash: void 0,
    rowDrag: void 0,
    dndSource: void 0,
    autoHeight: void 0,
    wrapText: void 0,
    sortable: void 0,
    resizable: void 0,
    singleClickEdit: void 0,
    floatingFilter: void 0,
    cellEditorPopup: void 0,
    suppressFillHandle: void 0,
    wrapHeaderText: void 0,
    autoHeaderHeight: void 0,
    dndSourceOnRowDrag: void 0,
    valueGetter: void 0,
    valueSetter: void 0,
    filterValueGetter: void 0,
    keyCreator: void 0,
    valueFormatter: void 0,
    valueParser: void 0,
    comparator: void 0,
    equals: void 0,
    pivotComparator: void 0,
    suppressKeyboardEvent: void 0,
    suppressHeaderKeyboardEvent: void 0,
    colSpan: void 0,
    rowSpan: void 0,
    getQuickFilterText: void 0,
    onCellValueChanged: void 0,
    onCellClicked: void 0,
    onCellDoubleClicked: void 0,
    onCellContextMenu: void 0,
    rowDragText: void 0,
    tooltipValueGetter: void 0,
    cellRendererSelector: void 0,
    cellEditorSelector: void 0,
    suppressSpanHeaderHeight: void 0,
    useValueFormatterForExport: void 0,
    useValueParserForImport: void 0,
    mainMenuItems: void 0,
    contextMenuItems: void 0,
    suppressFloatingFilterButton: void 0,
    suppressHeaderFilterButton: void 0,
    suppressHeaderContextMenu: void 0,
    loadingCellRenderer: void 0,
    loadingCellRendererParams: void 0,
    loadingCellRendererSelector: void 0
};
var ALL_PROPERTIES = Object.keys(colDefPropertyMap);
var COL_DEF_VALIDATORS = {
    objectName: "colDef",
    allProperties: ALL_PROPERTIES,
    docsUrl: "column-properties/",
    deprecations: COLUMN_DEFINITION_DEPRECATIONS,
    validations: COLUMN_DEFINITION_VALIDATIONS
};
// community-modules/core/src/validation/rules/gridOptionsValidations.ts
var GRID_OPTION_DEPRECATIONS = {
    enableChartToolPanelsButton: {
        version: "29"
    },
    functionsPassive: {
        version: "29.2"
    },
    onColumnRowGroupChangeRequest: {
        version: "29.2"
    },
    onColumnPivotChangeRequest: {
        version: "29.2"
    },
    onColumnValueChangeRequest: {
        version: "29.2"
    },
    onColumnAggFuncChangeRequest: {
        version: "29.2"
    },
    serverSideFilterAllLevels: {
        version: "30",
        message: "All server-side group levels are now filtered by default. This can be toggled using `serverSideOnlyRefreshFilteredGroups`."
    },
    suppressAggAtRootLevel: {
        version: "30",
        message: "The root level aggregation is now suppressed by default. This can be toggled using  `alwaysAggregateAtRootLevel`."
    },
    excludeHiddenColumnsFromQuickFilter: {
        version: "30",
        message: "Hidden columns are now excluded from the Quick Filter by default. This can be toggled using `includeHiddenColumnsInQuickFilter`."
    },
    enterMovesDown: {
        version: "30",
        renamed: "enterNavigatesVertically"
    },
    enterMovesDownAfterEdit: {
        version: "30",
        renamed: "enterNavigatesVerticallyAfterEdit"
    },
    suppressParentsInRowNodes: {
        version: "30.2",
        message: "Using suppressParentsInRowNodes is no longer recommended. To serialize nodes it is now recommended to instead remove the parent node reference before serialization."
    },
    advancedFilterModel: {
        version: "31",
        message: "Use `initialState.filter.advancedFilterModel` instead."
    },
    suppressAsyncEvents: {
        version: "31",
        message: "Events should be handled asynchronously."
    },
    cellFadeDelay: {
        version: "31.1",
        renamed: "cellFadeDuration"
    },
    cellFlashDelay: {
        version: "31.1",
        renamed: "cellFlashDuration"
    },
    suppressServerSideInfiniteScroll: {
        version: "31.1"
    },
    serverSideSortOnServer: {
        version: "31.1"
    },
    serverSideFilterOnServer: {
        version: "31.1"
    },
    enableCellChangeFlash: {
        version: "31.2",
        message: "Use `enableCellChangeFlash` in the `ColDef` or `defaultColDef` for all columns."
    },
    groupIncludeFooter: {
        version: "31.3",
        message: "Use `groupTotalRow` instead."
    },
    groupIncludeTotalFooter: {
        version: "31.3",
        message: "Use `grandTotalRow` instead."
    }
};
var GRID_OPTION_DEFAULTS = {
    suppressContextMenu: false,
    preventDefaultOnContextMenu: false,
    allowContextMenuWithControlKey: false,
    suppressMenuHide: false,
    enableBrowserTooltips: false,
    tooltipTrigger: "hover",
    tooltipShowDelay: 2e3,
    tooltipHideDelay: 1e4,
    tooltipMouseTrack: false,
    tooltipShowMode: "standard",
    tooltipInteraction: false,
    copyHeadersToClipboard: false,
    copyGroupHeadersToClipboard: false,
    clipboardDelimiter: "	",
    suppressCopyRowsToClipboard: false,
    suppressCopySingleCellRanges: false,
    suppressLastEmptyLineOnPaste: false,
    suppressClipboardPaste: false,
    suppressClipboardApi: false,
    suppressCutToClipboard: false,
    maintainColumnOrder: false,
    suppressFieldDotNotation: false,
    allowDragFromColumnsToolPanel: false,
    suppressMovableColumns: false,
    suppressColumnMoveAnimation: false,
    suppressDragLeaveHidesColumns: false,
    suppressRowGroupHidesColumns: false,
    suppressAutoSize: false,
    autoSizePadding: 20,
    skipHeaderOnAutoSize: false,
    singleClickEdit: false,
    suppressClickEdit: false,
    readOnlyEdit: false,
    stopEditingWhenCellsLoseFocus: false,
    enterNavigatesVertically: false,
    enterNavigatesVerticallyAfterEdit: false,
    enableCellEditingOnBackspace: false,
    undoRedoCellEditing: false,
    undoRedoCellEditingLimit: 10,
    suppressCsvExport: false,
    suppressExcelExport: false,
    cacheQuickFilter: false,
    includeHiddenColumnsInQuickFilter: false,
    excludeChildrenWhenTreeDataFiltering: false,
    enableAdvancedFilter: false,
    includeHiddenColumnsInAdvancedFilter: false,
    enableCharts: false,
    suppressChartToolPanelsButton: false,
    masterDetail: false,
    keepDetailRows: false,
    keepDetailRowsCount: 10,
    detailRowAutoHeight: false,
    tabIndex: 0,
    rowBuffer: 10,
    valueCache: false,
    valueCacheNeverExpires: false,
    enableCellExpressions: false,
    suppressTouch: false,
    suppressFocusAfterRefresh: false,
    suppressAsyncEvents: false,
    suppressBrowserResizeObserver: false,
    suppressPropertyNamesCheck: false,
    suppressChangeDetection: false,
    debug: false,
    suppressLoadingOverlay: false,
    suppressNoRowsOverlay: false,
    pagination: false,
    paginationPageSize: 100,
    paginationPageSizeSelector: true,
    paginationAutoPageSize: false,
    paginateChildRows: false,
    suppressPaginationPanel: false,
    pivotMode: false,
    pivotPanelShow: "never",
    pivotDefaultExpanded: 0,
    pivotSuppressAutoColumn: false,
    suppressExpandablePivotGroups: false,
    functionsReadOnly: false,
    suppressAggFuncInHeader: false,
    alwaysAggregateAtRootLevel: false,
    aggregateOnlyChangedColumns: false,
    suppressAggFilteredOnly: false,
    removePivotHeaderRowWhenSingleValueColumn: false,
    animateRows: true,
    enableCellChangeFlash: false,
    cellFlashDelay: 500,
    cellFlashDuration: 500,
    cellFadeDelay: 1e3,
    cellFadeDuration: 1e3,
    allowShowChangeAfterFilter: false,
    domLayout: "normal",
    ensureDomOrder: false,
    enableRtl: false,
    suppressColumnVirtualisation: false,
    suppressMaxRenderedRowRestriction: false,
    suppressRowVirtualisation: false,
    rowDragManaged: false,
    suppressRowDrag: false,
    suppressMoveWhenRowDragging: false,
    rowDragEntireRow: false,
    rowDragMultiRow: false,
    embedFullWidthRows: false,
    groupDisplayType: "singleColumn",
    groupDefaultExpanded: 0,
    groupMaintainOrder: false,
    groupSelectsChildren: false,
    groupIncludeTotalFooter: false,
    groupSuppressBlankHeader: false,
    groupSelectsFiltered: false,
    showOpenedGroup: false,
    groupRemoveSingleChildren: false,
    groupRemoveLowestSingleChildren: false,
    groupHideOpenParents: false,
    groupAllowUnbalanced: false,
    rowGroupPanelShow: "never",
    suppressMakeColumnVisibleAfterUnGroup: false,
    treeData: false,
    rowGroupPanelSuppressSort: false,
    suppressGroupRowsSticky: false,
    rowModelType: "clientSide",
    asyncTransactionWaitMillis: 50,
    suppressModelUpdateAfterUpdateTransaction: false,
    cacheOverflowSize: 1,
    infiniteInitialRowCount: 1,
    serverSideInitialRowCount: 1,
    suppressServerSideInfiniteScroll: false,
    cacheBlockSize: 100,
    maxBlocksInCache: -1,
    maxConcurrentDatasourceRequests: 2,
    blockLoadDebounceMillis: 0,
    purgeClosedRowNodes: false,
    serverSideSortAllLevels: false,
    serverSideOnlyRefreshFilteredGroups: false,
    serverSideSortOnServer: false,
    serverSideFilterOnServer: false,
    serverSidePivotResultFieldSeparator: "_",
    viewportRowModelPageSize: 5,
    viewportRowModelBufferSize: 5,
    alwaysShowHorizontalScroll: false,
    alwaysShowVerticalScroll: false,
    debounceVerticalScrollbar: false,
    suppressHorizontalScroll: false,
    suppressScrollOnNewData: false,
    suppressScrollWhenPopupsAreOpen: false,
    suppressAnimationFrame: false,
    suppressMiddleClickScrolls: false,
    suppressPreventDefaultOnMouseWheel: false,
    rowMultiSelectWithClick: false,
    suppressRowDeselection: false,
    suppressRowClickSelection: false,
    suppressCellFocus: false,
    suppressHeaderFocus: false,
    suppressMultiRangeSelection: false,
    enableCellTextSelection: false,
    enableRangeSelection: false,
    enableRangeHandle: false,
    enableFillHandle: false,
    fillHandleDirection: "xy",
    suppressClearOnFillReduction: false,
    accentedSort: false,
    unSortIcon: false,
    suppressMultiSort: false,
    alwaysMultiSort: false,
    suppressMaintainUnsortedOrder: false,
    suppressRowHoverHighlight: false,
    suppressRowTransform: false,
    columnHoverHighlight: false,
    deltaSort: false,
    enableGroupEdit: false,
    suppressGroupMaintainValueType: false,
    functionsPassive: false,
    groupLockGroupColumns: 0,
    serverSideEnableClientSideSort: false,
    suppressServerSideFullWidthLoadingRow: false,
    pivotMaxGeneratedColumns: -1
};
var GRID_OPTION_VALIDATIONS = {
    sideBar: {
        module: "@ag-grid-enterprise/side-bar" /* SideBarModule */ 
    },
    statusBar: {
        module: "@ag-grid-enterprise/status-bar" /* StatusBarModule */ 
    },
    enableCharts: {
        module: "@ag-grid-enterprise/charts" /* GridChartsModule */ 
    },
    getMainMenuItems: {
        module: "@ag-grid-enterprise/menu" /* MenuModule */ 
    },
    getContextMenuItems: {
        module: "@ag-grid-enterprise/menu" /* MenuModule */ 
    },
    allowContextMenuWithControlKey: {
        module: "@ag-grid-enterprise/menu" /* MenuModule */ 
    },
    enableAdvancedFilter: {
        module: "@ag-grid-enterprise/advanced-filter" /* AdvancedFilterModule */ 
    },
    treeData: {
        supportedRowModels: [
            "clientSide",
            "serverSide"
        ],
        module: "@ag-grid-enterprise/row-grouping" /* RowGroupingModule */ ,
        dependencies: (options)=>{
            var _a;
            const rowModel = (_a = options.rowModelType) != null ? _a : "clientSide";
            switch(rowModel){
                case "clientSide":
                    const csrmWarning = `treeData requires 'getDataPath' in the ${rowModel} row model.`;
                    return options.getDataPath ? null : csrmWarning;
                case "serverSide":
                    const ssrmWarning = `treeData requires 'isServerSideGroup' and 'getServerSideGroupKey' in the ${rowModel} row model.`;
                    return options.isServerSideGroup && options.getServerSideGroupKey ? null : ssrmWarning;
            }
            return null;
        }
    },
    masterDetail: {
        module: "@ag-grid-enterprise/master-detail" /* MasterDetailModule */ 
    },
    enableRangeSelection: {
        module: "@ag-grid-enterprise/range-selection" /* RangeSelectionModule */ 
    },
    enableRangeHandle: {
        dependencies: {
            enableRangeSelection: [
                true
            ]
        }
    },
    enableFillHandle: {
        dependencies: {
            enableRangeSelection: [
                true
            ]
        }
    },
    groupDefaultExpanded: {
        supportedRowModels: [
            "clientSide"
        ]
    },
    groupIncludeFooter: {
        supportedRowModels: [
            "clientSide",
            "serverSide"
        ],
        dependencies: (options)=>{
            var _a;
            const rowModel = (_a = options.rowModelType) != null ? _a : "clientSide";
            switch(rowModel){
                case "clientSide":
                    return null;
                case "serverSide":
                    const warning = "groupIncludeFooter is not supported alongside suppressServerSideInfiniteScroll";
                    return options.suppressServerSideInfiniteScroll ? warning : null;
            }
            return null;
        }
    },
    groupIncludeTotalFooter: {
        supportedRowModels: [
            "clientSide"
        ]
    },
    groupRemoveSingleChildren: {
        dependencies: {
            groupHideOpenParents: [
                void 0,
                false
            ],
            groupRemoveLowestSingleChildren: [
                void 0,
                false
            ]
        }
    },
    groupRemoveLowestSingleChildren: {
        dependencies: {
            groupHideOpenParents: [
                void 0,
                false
            ],
            groupRemoveSingleChildren: [
                void 0,
                false
            ]
        }
    },
    groupSelectsChildren: {
        dependencies: {
            rowSelection: [
                "multiple"
            ]
        }
    },
    suppressParentsInRowNodes: {
        dependencies: {
            groupSelectsChildren: [
                void 0,
                false
            ]
        }
    },
    viewportDatasource: {
        supportedRowModels: [
            "viewport"
        ],
        module: "@ag-grid-enterprise/viewport-row-model" /* ViewportRowModelModule */ 
    },
    serverSideDatasource: {
        supportedRowModels: [
            "serverSide"
        ],
        module: "@ag-grid-enterprise/server-side-row-model" /* ServerSideRowModelModule */ 
    },
    cacheBlockSize: {
        supportedRowModels: [
            "serverSide",
            "infinite"
        ]
    },
    datasource: {
        supportedRowModels: [
            "infinite"
        ],
        module: "@ag-grid-community/infinite-row-model" /* InfiniteRowModelModule */ 
    },
    rowData: {
        supportedRowModels: [
            "clientSide"
        ],
        module: "@ag-grid-community/client-side-row-model" /* ClientSideRowModelModule */ 
    },
    columnDefs: ()=>COL_DEF_VALIDATORS,
    defaultColDef: ()=>COL_DEF_VALIDATORS,
    defaultColGroupDef: ()=>COL_DEF_VALIDATORS,
    autoGroupColumnDef: ()=>COL_DEF_VALIDATORS
};
var GRID_OPTIONS_VALIDATORS = {
    objectName: "gridOptions",
    allProperties: [
        ...PropertyKeys.ALL_PROPERTIES,
        ...ComponentUtil.EVENT_CALLBACKS
    ],
    propertyExceptions: [
        "api",
        "columnApi"
    ],
    docsUrl: "grid-options/",
    deprecations: GRID_OPTION_DEPRECATIONS,
    validations: GRID_OPTION_VALIDATIONS
};
// community-modules/core/src/gridOptionsService.ts
var GridOptionsService = class {
    constructor(){
        this.destroyed = false;
        this.domDataKey = "__AG_" + Math.random().toString();
        this.propertyEventService = new EventService();
        // responsible for calling the onXXX functions on gridOptions
        // It forces events defined in GridOptionsService.alwaysSyncGlobalEvents to be fired synchronously.
        // This is required for events such as GridPreDestroyed.
        // Other events can be fired asynchronously or synchronously depending on config.
        this.globalEventHandlerFactory = (restrictToSyncOnly)=>{
            return (eventName, event)=>{
                if (this.destroyed) return;
                const alwaysSync = ALWAYS_SYNC_GLOBAL_EVENTS.has(eventName);
                if (alwaysSync && !restrictToSyncOnly || !alwaysSync && restrictToSyncOnly) return;
                const eventHandlerName = ComponentUtil.getCallbackForEvent(eventName);
                const eventHandler = this.gridOptions[eventHandlerName];
                if (typeof eventHandler === "function") this.frameworkOverrides.wrapOutgoing(()=>{
                    eventHandler(event);
                });
            };
        };
    }
    // This is quicker then having code call gridOptionsService.get('context')
    get context() {
        return this.gridOptions["context"];
    }
    init() {
        this.columnApi = new ColumnApi(this.api);
        const async = !this.get("suppressAsyncEvents");
        this.eventService.addGlobalListener(this.globalEventHandlerFactory().bind(this), async);
        this.eventService.addGlobalListener(this.globalEventHandlerFactory(true).bind(this), false);
        this.propertyEventService.setFrameworkOverrides(this.frameworkOverrides);
        this.getScrollbarWidth();
    }
    destroy() {
        this.destroyed = true;
        this.columnApi = void 0;
    }
    /**
   * Get the raw value of the GridOptions property provided.
   * @param property
   */ get(property) {
        var _a;
        return (_a = this.gridOptions[property]) != null ? _a : GRID_OPTION_DEFAULTS[property];
    }
    /**
   * Get the GridOption callback but wrapped so that the common params of api,columnApi and context are automatically applied to the params.
   * @param property GridOption callback properties based on the fact that this property has a callback with params extending AgGridCommon
   */ getCallback(property) {
        return this.mergeGridCommonParams(this.gridOptions[property]);
    }
    /**
   * Returns `true` if a value has been specified for this GridOption.
   * @param property GridOption property
   */ exists(property) {
        return exists(this.gridOptions[property]);
    }
    /**
  * Wrap the user callback and attach the api, columnApi and context to the params object on the way through.
  * @param callback User provided callback
  * @returns Wrapped callback where the params object not require api, columnApi and context
  */ mergeGridCommonParams(callback) {
        if (callback) {
            const wrapped = (callbackParams)=>{
                const mergedParams = callbackParams;
                mergedParams.api = this.api;
                mergedParams.columnApi = this.columnApi;
                mergedParams.context = this.context;
                return callback(mergedParams);
            };
            return wrapped;
        }
        return callback;
    }
    static toBoolean(value) {
        if (typeof value === "boolean") return value;
        if (typeof value === "string") return value.toUpperCase() === "TRUE" || value == "";
        return false;
    }
    static toNumber(value) {
        if (typeof value === "number") return value;
        if (typeof value === "string") {
            const parsed = parseInt(value);
            if (isNaN(parsed)) return void 0;
            return parsed;
        }
        return void 0;
    }
    static toConstrainedNum(min, max) {
        return (value)=>{
            const num = GridOptionsService.toNumber(value);
            if (num == null || num < min || num > max) return void 0;
            return num;
        };
    }
    static getCoercedValue(key, value) {
        const coerceFunc = GridOptionsService.PROPERTY_COERCIONS.get(key);
        if (!coerceFunc) return value;
        return coerceFunc(value);
    }
    static getCoercedGridOptions(gridOptions) {
        const newGo = {};
        Object.entries(gridOptions).forEach(([key, value])=>{
            const coercedValue = GridOptionsService.getCoercedValue(key, value);
            newGo[key] = coercedValue;
        });
        return newGo;
    }
    updateGridOptions({ options, force, source = "api" }) {
        const changeSet = {
            id: GridOptionsService.changeSetId++,
            properties: []
        };
        const events = [];
        Object.entries(options).forEach(([key, value])=>{
            if (source === "api" && INITIAL_GRID_OPTION_KEYS[key]) warnOnce(`${key} is an initial property and cannot be updated.`);
            const coercedValue = GridOptionsService.getCoercedValue(key, value);
            const shouldForce = force || typeof coercedValue === "object" && source === "api";
            const previousValue = this.gridOptions[key];
            if (shouldForce || previousValue !== coercedValue) {
                this.gridOptions[key] = coercedValue;
                const event = {
                    type: key,
                    currentValue: coercedValue,
                    previousValue,
                    changeSet,
                    source
                };
                events.push(event);
            }
        });
        this.validationService.processGridOptions(this.gridOptions);
        changeSet.properties = events.map((event)=>event.type);
        events.forEach((event)=>{
            if (this.gridOptions.debug) console.log(`AG Grid: Updated property ${event.type} from `, event.previousValue, " to  ", event.currentValue);
            this.propertyEventService.dispatchEvent(event);
        });
    }
    addEventListener(key, listener) {
        this.propertyEventService.addEventListener(key, listener);
    }
    removeEventListener(key, listener) {
        this.propertyEventService.removeEventListener(key, listener);
    }
    // *************** Helper methods ************************** //
    // Methods to share common GridOptions related logic that goes above accessing a single property
    // the user might be using some non-standard scrollbar, eg a scrollbar that has zero
    // width and overlays (like the Safari scrollbar, but presented in Chrome). so we
    // allow the user to provide the scroll width before we work it out.
    getScrollbarWidth() {
        if (this.scrollbarWidth == null) {
            const useGridOptions = typeof this.gridOptions.scrollbarWidth === "number" && this.gridOptions.scrollbarWidth >= 0;
            const scrollbarWidth = useGridOptions ? this.gridOptions.scrollbarWidth : getScrollbarWidth();
            if (scrollbarWidth != null) {
                this.scrollbarWidth = scrollbarWidth;
                this.eventService.dispatchEvent({
                    type: Events.EVENT_SCROLLBAR_WIDTH_CHANGED
                });
            }
        }
        return this.scrollbarWidth;
    }
    isRowModelType(rowModelType) {
        return this.gridOptions.rowModelType === rowModelType || rowModelType === "clientSide" && missing(this.gridOptions.rowModelType);
    }
    isDomLayout(domLayout) {
        var _a;
        const gridLayout = (_a = this.gridOptions.domLayout) != null ? _a : "normal";
        return gridLayout === domLayout;
    }
    isRowSelection() {
        return this.gridOptions.rowSelection === "single" || this.gridOptions.rowSelection === "multiple";
    }
    useAsyncEvents() {
        return !this.get("suppressAsyncEvents");
    }
    isGetRowHeightFunction() {
        return typeof this.gridOptions.getRowHeight === "function";
    }
    getRowHeightForNode(rowNode, allowEstimate = false, defaultRowHeight) {
        if (defaultRowHeight == null) defaultRowHeight = this.environment.getDefaultRowHeight();
        if (this.isGetRowHeightFunction()) {
            if (allowEstimate) return {
                height: defaultRowHeight,
                estimated: true
            };
            const params = {
                node: rowNode,
                data: rowNode.data
            };
            const height = this.getCallback("getRowHeight")(params);
            if (this.isNumeric(height)) {
                if (height === 0) warnOnce("The return of `getRowHeight` cannot be zero. If the intention is to hide rows, use a filter instead.");
                return {
                    height: Math.max(1, height),
                    estimated: false
                };
            }
        }
        if (rowNode.detail && this.get("masterDetail")) return this.getMasterDetailRowHeight();
        const rowHeight = this.gridOptions.rowHeight && this.isNumeric(this.gridOptions.rowHeight) ? this.gridOptions.rowHeight : defaultRowHeight;
        return {
            height: rowHeight,
            estimated: false
        };
    }
    getMasterDetailRowHeight() {
        if (this.get("detailRowAutoHeight")) return {
            height: 1,
            estimated: false
        };
        if (this.isNumeric(this.gridOptions.detailRowHeight)) return {
            height: this.gridOptions.detailRowHeight,
            estimated: false
        };
        return {
            height: 300,
            estimated: false
        };
    }
    // we don't allow dynamic row height for virtual paging
    getRowHeightAsNumber() {
        if (!this.gridOptions.rowHeight || missing(this.gridOptions.rowHeight)) return this.environment.getDefaultRowHeight();
        const rowHeight = this.environment.refreshRowHeightVariable();
        if (rowHeight !== -1) return rowHeight;
        console.warn("AG Grid row height must be a number if not using standard row model");
        return this.environment.getDefaultRowHeight();
    }
    isNumeric(value) {
        return !isNaN(value) && typeof value === "number" && isFinite(value);
    }
    getDomDataKey() {
        return this.domDataKey;
    }
    // returns the dom data, or undefined if not found
    getDomData(element, key) {
        const domData = element[this.getDomDataKey()];
        return domData ? domData[key] : void 0;
    }
    setDomData(element, key, value) {
        const domDataKey = this.getDomDataKey();
        let domData = element[domDataKey];
        if (missing(domData)) {
            domData = {};
            element[domDataKey] = domData;
        }
        domData[key] = value;
    }
    getDocument() {
        let result = null;
        if (this.gridOptions.getDocument && exists(this.gridOptions.getDocument)) result = this.gridOptions.getDocument();
        else if (this.eGridDiv) result = this.eGridDiv.ownerDocument;
        if (result && exists(result)) return result;
        return document;
    }
    getWindow() {
        const eDocument = this.getDocument();
        return eDocument.defaultView || window;
    }
    getRootNode() {
        return this.eGridDiv.getRootNode();
    }
    getActiveDomElement() {
        return this.getRootNode().activeElement;
    }
    getAsyncTransactionWaitMillis() {
        return exists(this.gridOptions.asyncTransactionWaitMillis) ? this.gridOptions.asyncTransactionWaitMillis : 50;
    }
    isAnimateRows() {
        if (this.get("ensureDomOrder")) return false;
        return this.get("animateRows");
    }
    isGroupRowsSticky() {
        if (this.get("paginateChildRows") || this.get("groupHideOpenParents") || this.isDomLayout("print")) return false;
        return true;
    }
    isColumnsSortingCoupledToGroup() {
        const autoGroupColumnDef = this.gridOptions.autoGroupColumnDef;
        return !(autoGroupColumnDef == null ? void 0 : autoGroupColumnDef.comparator) && !this.get("treeData");
    }
    getGroupAggFiltering() {
        const userValue = this.gridOptions.groupAggFiltering;
        if (typeof userValue === "function") return this.getCallback("groupAggFiltering");
        if (userValue === true) return ()=>true;
        return void 0;
    }
    getGrandTotalRow() {
        const userValue = this.gridOptions.grandTotalRow;
        if (userValue) return userValue;
        const legacyValue = this.gridOptions.groupIncludeTotalFooter;
        if (legacyValue) return "bottom";
        return void 0;
    }
    getGroupTotalRowCallback() {
        const userValue = this.get("groupTotalRow");
        if (typeof userValue === "function") return this.getCallback("groupTotalRow");
        if (userValue) return ()=>userValue;
        const legacyValue = this.get("groupIncludeFooter");
        if (typeof legacyValue === "function") {
            const legacyCallback = this.getCallback("groupIncludeFooter");
            return (p)=>{
                return legacyCallback(p) ? "bottom" : void 0;
            };
        }
        return ()=>legacyValue ? "bottom" : void 0;
    }
    isGroupMultiAutoColumn() {
        if (this.gridOptions.groupDisplayType) return this.gridOptions.groupDisplayType === "multipleColumns";
        return this.get("groupHideOpenParents");
    }
    isGroupUseEntireRow(pivotMode) {
        if (pivotMode) return false;
        return this.gridOptions.groupDisplayType === "groupRows";
    }
    getGridCommonParams() {
        return {
            api: this.api,
            columnApi: this.columnApi,
            context: this.context
        };
    }
    addGridCommonParams(params) {
        const updatedParams = params;
        updatedParams.api = this.api;
        updatedParams.columnApi = this.columnApi;
        updatedParams.context = this.context;
        return updatedParams;
    }
};
/**
 * Handles value coercion including validation of ranges etc. If value is invalid, undefined is set, allowing default to be used.
 */ GridOptionsService.PROPERTY_COERCIONS = new Map([
    ...PropertyKeys.BOOLEAN_PROPERTIES.map((key)=>[
            key,
            GridOptionsService.toBoolean
        ]),
    ...PropertyKeys.NUMBER_PROPERTIES.map((key)=>[
            key,
            GridOptionsService.toNumber
        ]),
    [
        "groupAggFiltering",
        (val)=>typeof val === "function" ? val : GridOptionsService.toBoolean(val)
    ],
    [
        "pageSize",
        GridOptionsService.toConstrainedNum(1, Number.MAX_VALUE)
    ],
    [
        "autoSizePadding",
        GridOptionsService.toConstrainedNum(0, Number.MAX_VALUE)
    ],
    [
        "keepDetailRowsCount",
        GridOptionsService.toConstrainedNum(1, Number.MAX_VALUE)
    ],
    [
        "rowBuffer",
        GridOptionsService.toConstrainedNum(0, Number.MAX_VALUE)
    ],
    [
        "infiniteInitialRowCount",
        GridOptionsService.toConstrainedNum(1, Number.MAX_VALUE)
    ],
    [
        "cacheOverflowSize",
        GridOptionsService.toConstrainedNum(1, Number.MAX_VALUE)
    ],
    [
        "cacheBlockSize",
        GridOptionsService.toConstrainedNum(1, Number.MAX_VALUE)
    ],
    [
        "serverSideInitialRowCount",
        GridOptionsService.toConstrainedNum(1, Number.MAX_VALUE)
    ],
    [
        "viewportRowModelPageSize",
        GridOptionsService.toConstrainedNum(1, Number.MAX_VALUE)
    ],
    [
        "viewportRowModelBufferSize",
        GridOptionsService.toConstrainedNum(0, Number.MAX_VALUE)
    ]
]);
GridOptionsService.changeSetId = 0;
__decorateClass([
    Autowired("gridOptions")
], GridOptionsService.prototype, "gridOptions", 2);
__decorateClass([
    Autowired("eventService")
], GridOptionsService.prototype, "eventService", 2);
__decorateClass([
    Autowired("environment")
], GridOptionsService.prototype, "environment", 2);
__decorateClass([
    Autowired("frameworkOverrides")
], GridOptionsService.prototype, "frameworkOverrides", 2);
__decorateClass([
    Autowired("eGridDiv")
], GridOptionsService.prototype, "eGridDiv", 2);
__decorateClass([
    Autowired("validationService")
], GridOptionsService.prototype, "validationService", 2);
__decorateClass([
    Autowired("gridApi")
], GridOptionsService.prototype, "api", 2);
__decorateClass([
    PostConstruct
], GridOptionsService.prototype, "init", 1);
__decorateClass([
    PreDestroy
], GridOptionsService.prototype, "destroy", 1);
GridOptionsService = __decorateClass([
    Bean("gridOptionsService")
], GridOptionsService);
// community-modules/core/src/localeService.ts
var LocaleService = class extends BeanStub {
    getLocaleTextFunc() {
        const getLocaleText = this.gos.getCallback("getLocaleText");
        if (getLocaleText) return (key, defaultValue, variableValues)=>{
            const params = {
                key,
                defaultValue,
                variableValues
            };
            return getLocaleText(params);
        };
        const localeText = this.gos.get("localeText");
        return (key, defaultValue, variableValues)=>{
            let localisedText = localeText && localeText[key];
            if (localisedText && variableValues && variableValues.length) {
                let found = 0;
                while(true){
                    if (found >= variableValues.length) break;
                    const idx = localisedText.indexOf("${variable}");
                    if (idx === -1) break;
                    localisedText = localisedText.replace("${variable}", variableValues[found++]);
                }
            }
            return localisedText != null ? localisedText : defaultValue;
        };
    }
};
LocaleService = __decorateClass([
    Bean("localeService")
], LocaleService);
// community-modules/core/src/gridBodyComp/fakeVScrollComp.ts
var _FakeVScrollComp = class _FakeVScrollComp extends AbstractFakeScrollComp {
    constructor(){
        super(_FakeVScrollComp.TEMPLATE, "vertical");
    }
    postConstruct() {
        super.postConstruct();
        this.createManagedBean(new SetHeightFeature(this.eContainer));
        this.ctrlsService.register("fakeVScrollComp", this);
        this.addManagedListener(this.eventService, Events.EVENT_ROW_CONTAINER_HEIGHT_CHANGED, this.onRowContainerHeightChanged.bind(this));
    }
    setScrollVisible() {
        const vScrollShowing = this.scrollVisibleService.isVerticalScrollShowing();
        const invisibleScrollbar2 = this.invisibleScrollbar;
        const scrollbarWidth = vScrollShowing ? this.gos.getScrollbarWidth() || 0 : 0;
        const adjustedScrollbarWidth = scrollbarWidth === 0 && invisibleScrollbar2 ? 16 : scrollbarWidth;
        this.addOrRemoveCssClass("ag-scrollbar-invisible", invisibleScrollbar2);
        setFixedWidth(this.getGui(), adjustedScrollbarWidth);
        setFixedWidth(this.eViewport, adjustedScrollbarWidth);
        setFixedWidth(this.eContainer, adjustedScrollbarWidth);
        this.setDisplayed(vScrollShowing, {
            skipAriaHidden: true
        });
    }
    onRowContainerHeightChanged() {
        const { ctrlsService } = this;
        const gridBodyCtrl = ctrlsService.getGridBodyCtrl();
        const gridBodyViewportEl = gridBodyCtrl.getBodyViewportElement();
        const eViewportScrollTop = this.getScrollPosition();
        const gridBodyViewportScrollTop = gridBodyViewportEl.scrollTop;
        if (eViewportScrollTop != gridBodyViewportScrollTop) this.setScrollPosition(gridBodyViewportScrollTop, true);
    }
    getScrollPosition() {
        return this.getViewport().scrollTop;
    }
    setScrollPosition(value, force) {
        if (!force && !isVisible(this.getViewport())) this.attemptSettingScrollPosition(value);
        this.getViewport().scrollTop = value;
    }
};
_FakeVScrollComp.TEMPLATE = /* html */ `<div class="ag-body-vertical-scroll" aria-hidden="true">
            <div class="ag-body-vertical-scroll-viewport" ref="eViewport">
                <div class="ag-body-vertical-scroll-container" ref="eContainer"></div>
            </div>
        </div>`;
__decorateClass([
    PostConstruct
], _FakeVScrollComp.prototype, "postConstruct", 1);
var FakeVScrollComp = _FakeVScrollComp;
// community-modules/core/src/columns/dataTypeService.ts
var MONTH_LOCALE_TEXT = {
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December"
};
var MONTH_KEYS = [
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december"
];
var DataTypeService = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.dataTypeDefinitions = {};
        this.isWaitingForRowData = false;
        this.isColumnTypeOverrideInDataTypeDefinitions = false;
        // keep track of any column state updates whilst waiting for data types to be inferred
        this.columnStateUpdatesPendingInference = {};
        this.columnStateUpdateListenerDestroyFuncs = [];
    }
    init() {
        this.groupHideOpenParents = this.gos.get("groupHideOpenParents");
        this.addManagedPropertyListener("groupHideOpenParents", ()=>{
            this.groupHideOpenParents = this.gos.get("groupHideOpenParents");
        });
        this.processDataTypeDefinitions();
        this.addManagedPropertyListener("dataTypeDefinitions", (event)=>{
            this.processDataTypeDefinitions();
            this.columnModel.recreateColumnDefs(convertSourceType(event.source));
        });
    }
    processDataTypeDefinitions() {
        var _a;
        const defaultDataTypes = this.getDefaultDataTypes();
        this.dataTypeDefinitions = {};
        Object.entries(defaultDataTypes).forEach(([cellDataType, dataTypeDefinition])=>{
            this.dataTypeDefinitions[cellDataType] = __spreadProps(__spreadValues({}, dataTypeDefinition), {
                groupSafeValueFormatter: this.createGroupSafeValueFormatter(dataTypeDefinition)
            });
        });
        const dataTypeDefinitions = (_a = this.gos.get("dataTypeDefinitions")) != null ? _a : {};
        this.dataTypeMatchers = {};
        Object.entries(dataTypeDefinitions).forEach(([cellDataType, dataTypeDefinition])=>{
            const mergedDataTypeDefinition = this.processDataTypeDefinition(dataTypeDefinition, dataTypeDefinitions, [
                cellDataType
            ], defaultDataTypes);
            if (mergedDataTypeDefinition) {
                this.dataTypeDefinitions[cellDataType] = mergedDataTypeDefinition;
                if (dataTypeDefinition.dataTypeMatcher) this.dataTypeMatchers[cellDataType] = dataTypeDefinition.dataTypeMatcher;
            }
        });
        this.checkObjectValueHandlers(defaultDataTypes);
        [
            "dateString",
            "text",
            "number",
            "boolean",
            "date"
        ].forEach((cellDataType)=>{
            const overriddenDataTypeMatcher = this.dataTypeMatchers[cellDataType];
            if (overriddenDataTypeMatcher) delete this.dataTypeMatchers[cellDataType];
            this.dataTypeMatchers[cellDataType] = overriddenDataTypeMatcher != null ? overriddenDataTypeMatcher : defaultDataTypes[cellDataType].dataTypeMatcher;
        });
    }
    mergeDataTypeDefinitions(parentDataTypeDefinition, childDataTypeDefinition) {
        const mergedDataTypeDefinition = __spreadValues(__spreadValues({}, parentDataTypeDefinition), childDataTypeDefinition);
        if (parentDataTypeDefinition.columnTypes && childDataTypeDefinition.columnTypes && childDataTypeDefinition.appendColumnTypes) mergedDataTypeDefinition.columnTypes = [
            ...this.convertColumnTypes(parentDataTypeDefinition.columnTypes),
            ...this.convertColumnTypes(childDataTypeDefinition.columnTypes)
        ];
        return mergedDataTypeDefinition;
    }
    processDataTypeDefinition(dataTypeDefinition, dataTypeDefinitions, alreadyProcessedDataTypes, defaultDataTypes) {
        let mergedDataTypeDefinition;
        const extendsCellDataType = dataTypeDefinition.extendsDataType;
        if (dataTypeDefinition.columnTypes) this.isColumnTypeOverrideInDataTypeDefinitions = true;
        if (dataTypeDefinition.extendsDataType === dataTypeDefinition.baseDataType) {
            let baseDataTypeDefinition = defaultDataTypes[extendsCellDataType];
            const overriddenBaseDataTypeDefinition = dataTypeDefinitions[extendsCellDataType];
            if (baseDataTypeDefinition && overriddenBaseDataTypeDefinition) baseDataTypeDefinition = overriddenBaseDataTypeDefinition;
            if (!this.validateDataTypeDefinition(dataTypeDefinition, baseDataTypeDefinition, extendsCellDataType)) return void 0;
            mergedDataTypeDefinition = this.mergeDataTypeDefinitions(baseDataTypeDefinition, dataTypeDefinition);
        } else {
            if (alreadyProcessedDataTypes.includes(extendsCellDataType)) {
                warnOnce('Data type definition hierarchies (via the "extendsDataType" property) cannot contain circular references.');
                return void 0;
            }
            const extendedDataTypeDefinition = dataTypeDefinitions[extendsCellDataType];
            if (!this.validateDataTypeDefinition(dataTypeDefinition, extendedDataTypeDefinition, extendsCellDataType)) return void 0;
            const mergedExtendedDataTypeDefinition = this.processDataTypeDefinition(extendedDataTypeDefinition, dataTypeDefinitions, [
                ...alreadyProcessedDataTypes,
                extendsCellDataType
            ], defaultDataTypes);
            if (!mergedExtendedDataTypeDefinition) return void 0;
            mergedDataTypeDefinition = this.mergeDataTypeDefinitions(mergedExtendedDataTypeDefinition, dataTypeDefinition);
        }
        return __spreadProps(__spreadValues({}, mergedDataTypeDefinition), {
            groupSafeValueFormatter: this.createGroupSafeValueFormatter(mergedDataTypeDefinition)
        });
    }
    validateDataTypeDefinition(dataTypeDefinition, parentDataTypeDefinition, parentCellDataType) {
        if (!parentDataTypeDefinition) {
            warnOnce(`The data type definition ${parentCellDataType} does not exist.`);
            return false;
        }
        if (parentDataTypeDefinition.baseDataType !== dataTypeDefinition.baseDataType) {
            warnOnce('The "baseDataType" property of a data type definition must match that of its parent.');
            return false;
        }
        return true;
    }
    createGroupSafeValueFormatter(dataTypeDefinition) {
        if (!dataTypeDefinition.valueFormatter) return void 0;
        return (params)=>{
            var _a, _b;
            if ((_a = params.node) == null ? void 0 : _a.group) {
                const aggFunc = params.column.getAggFunc();
                if (aggFunc) {
                    if (aggFunc === "first" || aggFunc === "last") return dataTypeDefinition.valueFormatter(params);
                    if (dataTypeDefinition.baseDataType === "number" && aggFunc !== "count") {
                        if (typeof params.value === "number") return dataTypeDefinition.valueFormatter(params);
                        if (typeof params.value === "object") {
                            if (!params.value) return void 0;
                            if ("toNumber" in params.value) return dataTypeDefinition.valueFormatter(__spreadProps(__spreadValues({}, params), {
                                value: params.value.toNumber()
                            }));
                            if ("value" in params.value) return dataTypeDefinition.valueFormatter(__spreadProps(__spreadValues({}, params), {
                                value: params.value.value
                            }));
                        }
                    }
                }
                if (!this.gos.get("suppressGroupMaintainValueType")) return void 0;
            } else if (this.groupHideOpenParents && params.column.isRowGroupActive()) {
                if (typeof params.value !== "string" || ((_b = dataTypeDefinition.dataTypeMatcher) == null ? void 0 : _b.call(dataTypeDefinition, params.value))) return dataTypeDefinition.valueFormatter(params);
                if (!this.gos.get("suppressGroupMaintainValueType")) return void 0;
            }
            return dataTypeDefinition.valueFormatter(params);
        };
    }
    updateColDefAndGetDataTypeDefinitionColumnType(colDef, userColDef, colId) {
        let { cellDataType } = userColDef;
        const { field } = userColDef;
        if (cellDataType === void 0) cellDataType = colDef.cellDataType;
        if (cellDataType == null || cellDataType === true) cellDataType = this.canInferCellDataType(colDef, userColDef) ? this.inferCellDataType(field, colId) : false;
        if (!cellDataType) {
            colDef.cellDataType = false;
            return void 0;
        }
        const dataTypeDefinition = this.dataTypeDefinitions[cellDataType];
        if (!dataTypeDefinition) {
            warnOnce(`Missing data type definition - "${cellDataType}"`);
            return void 0;
        }
        colDef.cellDataType = cellDataType;
        if (dataTypeDefinition.groupSafeValueFormatter) colDef.valueFormatter = dataTypeDefinition.groupSafeValueFormatter;
        if (dataTypeDefinition.valueParser) colDef.valueParser = dataTypeDefinition.valueParser;
        if (!dataTypeDefinition.suppressDefaultProperties) this.setColDefPropertiesForBaseDataType(colDef, dataTypeDefinition, colId);
        return dataTypeDefinition.columnTypes;
    }
    updateColDefAndGetColumnType(colDef, userColDef, colId) {
        var _a, _b;
        const dataTypeDefinitionColumnType = this.updateColDefAndGetDataTypeDefinitionColumnType(colDef, userColDef, colId);
        const columnTypes = (_b = (_a = userColDef.type) != null ? _a : dataTypeDefinitionColumnType) != null ? _b : colDef.type;
        colDef.type = columnTypes;
        return columnTypes ? this.convertColumnTypes(columnTypes) : void 0;
    }
    addColumnListeners(column) {
        if (!this.isWaitingForRowData) return;
        const columnStateUpdates = this.columnStateUpdatesPendingInference[column.getColId()];
        if (!columnStateUpdates) return;
        const columnListener = (event)=>{
            columnStateUpdates.add(event.key);
        };
        column.addEventListener(Column.EVENT_STATE_UPDATED, columnListener);
        this.columnStateUpdateListenerDestroyFuncs.push(()=>column.removeEventListener(Column.EVENT_STATE_UPDATED, columnListener));
    }
    canInferCellDataType(colDef, userColDef) {
        var _a;
        if (this.rowModel.getType() !== "clientSide") return false;
        const propsToCheckForInference = {
            cellRenderer: true,
            valueGetter: true,
            valueParser: true,
            refData: true
        };
        if (this.doColDefPropsPreventInference(userColDef, propsToCheckForInference)) return false;
        const columnTypes = userColDef.type === null ? colDef.type : userColDef.type;
        if (columnTypes) {
            const columnTypeDefs = (_a = this.gos.get("columnTypes")) != null ? _a : {};
            const hasPropsPreventingInference = this.convertColumnTypes(columnTypes).some((columnType)=>{
                const columnTypeDef = columnTypeDefs[columnType.trim()];
                return columnTypeDef && this.doColDefPropsPreventInference(columnTypeDef, propsToCheckForInference);
            });
            if (hasPropsPreventingInference) return false;
        }
        return !this.doColDefPropsPreventInference(colDef, propsToCheckForInference);
    }
    doColDefPropsPreventInference(colDef, propsToCheckForInference) {
        return [
            [
                "cellRenderer",
                "agSparklineCellRenderer"
            ],
            [
                "valueGetter",
                void 0
            ],
            [
                "valueParser",
                void 0
            ],
            [
                "refData",
                void 0
            ]
        ].some(([prop, comparisonValue])=>this.doesColDefPropPreventInference(colDef, propsToCheckForInference, prop, comparisonValue));
    }
    doesColDefPropPreventInference(colDef, checkProps, prop, comparisonValue) {
        if (!checkProps[prop]) return false;
        const value = colDef[prop];
        if (value === null) {
            checkProps[prop] = false;
            return false;
        } else return comparisonValue === void 0 ? !!value : value === comparisonValue;
    }
    inferCellDataType(field, colId) {
        var _a;
        if (!field) return void 0;
        let value;
        const initialData = this.getInitialData();
        if (initialData) {
            const fieldContainsDots = field.indexOf(".") >= 0 && !this.gos.get("suppressFieldDotNotation");
            value = getValueUsingField(initialData, field, fieldContainsDots);
        } else this.initWaitForRowData(colId);
        if (value == null) return void 0;
        const [cellDataType] = (_a = Object.entries(this.dataTypeMatchers).find(([_cellDataType, dataTypeMatcher])=>dataTypeMatcher(value))) != null ? _a : [
            "object"
        ];
        return cellDataType;
    }
    getInitialData() {
        const rowData = this.gos.get("rowData");
        if (rowData == null ? void 0 : rowData.length) return rowData[0];
        else if (this.initialData) return this.initialData;
        else {
            const rowNodes = this.rowModel.getRootNode().allLeafChildren;
            if (rowNodes == null ? void 0 : rowNodes.length) return rowNodes[0].data;
        }
        return null;
    }
    initWaitForRowData(colId) {
        this.columnStateUpdatesPendingInference[colId] = /* @__PURE__ */ new Set();
        if (this.isWaitingForRowData) return;
        this.isWaitingForRowData = true;
        const columnTypeOverridesExist = this.isColumnTypeOverrideInDataTypeDefinitions;
        if (columnTypeOverridesExist) this.columnModel.queueResizeOperations();
        const destroyFunc = this.addManagedListener(this.eventService, Events.EVENT_ROW_DATA_UPDATE_STARTED, (event)=>{
            const { firstRowData } = event;
            if (!firstRowData) return;
            destroyFunc == null || destroyFunc();
            this.isWaitingForRowData = false;
            this.processColumnsPendingInference(firstRowData, columnTypeOverridesExist);
            this.columnStateUpdatesPendingInference = {};
            if (columnTypeOverridesExist) this.columnModel.processResizeOperations();
            const dataTypesInferredEvent = {
                type: Events.EVENT_DATA_TYPES_INFERRED
            };
            this.eventService.dispatchEvent(dataTypesInferredEvent);
        });
    }
    isPendingInference() {
        return this.isWaitingForRowData;
    }
    processColumnsPendingInference(firstRowData, columnTypeOverridesExist) {
        this.initialData = firstRowData;
        const state = [];
        this.columnStateUpdateListenerDestroyFuncs.forEach((destroyFunc)=>destroyFunc());
        this.columnStateUpdateListenerDestroyFuncs = [];
        const newRowGroupColumnStateWithoutIndex = {};
        const newPivotColumnStateWithoutIndex = {};
        Object.entries(this.columnStateUpdatesPendingInference).forEach(([colId, columnStateUpdates])=>{
            const column = this.columnModel.getGridColumn(colId);
            if (!column) return;
            const oldColDef = column.getColDef();
            if (!this.columnModel.resetColumnDefIntoColumn(column, "cellDataTypeInferred")) return;
            const newColDef = column.getColDef();
            if (columnTypeOverridesExist && newColDef.type && newColDef.type !== oldColDef.type) {
                const updatedColumnState = this.getUpdatedColumnState(column, columnStateUpdates);
                if (updatedColumnState.rowGroup && updatedColumnState.rowGroupIndex == null) newRowGroupColumnStateWithoutIndex[colId] = updatedColumnState;
                if (updatedColumnState.pivot && updatedColumnState.pivotIndex == null) newPivotColumnStateWithoutIndex[colId] = updatedColumnState;
                state.push(updatedColumnState);
            }
        });
        if (columnTypeOverridesExist) state.push(...this.columnModel.generateColumnStateForRowGroupAndPivotIndexes(newRowGroupColumnStateWithoutIndex, newPivotColumnStateWithoutIndex));
        if (state.length) this.columnModel.applyColumnState({
            state
        }, "cellDataTypeInferred");
        this.initialData = null;
    }
    getUpdatedColumnState(column, columnStateUpdates) {
        const columnState = this.columnModel.getColumnStateFromColDef(column);
        columnStateUpdates.forEach((key)=>{
            delete columnState[key];
            if (key === "rowGroup") delete columnState.rowGroupIndex;
            else if (key === "pivot") delete columnState.pivotIndex;
        });
        return columnState;
    }
    checkObjectValueHandlers(defaultDataTypes) {
        const resolvedObjectDataTypeDefinition = this.dataTypeDefinitions.object;
        const defaultObjectDataTypeDefinition = defaultDataTypes.object;
        this.hasObjectValueParser = resolvedObjectDataTypeDefinition.valueParser !== defaultObjectDataTypeDefinition.valueParser;
        this.hasObjectValueFormatter = resolvedObjectDataTypeDefinition.valueFormatter !== defaultObjectDataTypeDefinition.valueFormatter;
    }
    convertColumnTypes(type) {
        let typeKeys = [];
        if (type instanceof Array) {
            const invalidArray = type.some((a)=>typeof a !== "string");
            if (invalidArray) console.warn("if colDef.type is supplied an array it should be of type 'string[]'");
            else typeKeys = type;
        } else if (typeof type === "string") typeKeys = type.split(",");
        else console.warn("colDef.type should be of type 'string' | 'string[]'");
        return typeKeys;
    }
    getDateStringTypeDefinition(column) {
        var _a;
        if (!column) return this.dataTypeDefinitions.dateString;
        return (_a = this.getDataTypeDefinition(column)) != null ? _a : this.dataTypeDefinitions.dateString;
    }
    getDateParserFunction(column) {
        return this.getDateStringTypeDefinition(column).dateParser;
    }
    getDateFormatterFunction(column) {
        return this.getDateStringTypeDefinition(column).dateFormatter;
    }
    getDataTypeDefinition(column) {
        const colDef = column.getColDef();
        if (!colDef.cellDataType) return void 0;
        return this.dataTypeDefinitions[colDef.cellDataType];
    }
    getBaseDataType(column) {
        var _a;
        return (_a = this.getDataTypeDefinition(column)) == null ? void 0 : _a.baseDataType;
    }
    checkType(column, value) {
        var _a;
        if (value == null) return true;
        const dataTypeMatcher = (_a = this.getDataTypeDefinition(column)) == null ? void 0 : _a.dataTypeMatcher;
        if (!dataTypeMatcher) return true;
        return dataTypeMatcher(value);
    }
    validateColDef(colDef) {
        if (colDef.cellDataType === "object") {
            if (colDef.valueFormatter === this.dataTypeDefinitions.object.groupSafeValueFormatter && !this.hasObjectValueFormatter) warnOnce('Cell data type is "object" but no value formatter has been provided. Please either provide an object data type definition with a value formatter, or set "colDef.valueFormatter"');
            if (colDef.editable && colDef.valueParser === this.dataTypeDefinitions.object.valueParser && !this.hasObjectValueParser) warnOnce('Cell data type is "object" but no value parser has been provided. Please either provide an object data type definition with a value parser, or set "colDef.valueParser"');
        }
    }
    setColDefPropertiesForBaseDataType(colDef, dataTypeDefinition, colId) {
        const formatValue = (column, node, value)=>{
            let valueFormatter = column.getColDef().valueFormatter;
            if (valueFormatter === dataTypeDefinition.groupSafeValueFormatter) valueFormatter = dataTypeDefinition.valueFormatter;
            return this.valueService.formatValue(column, node, value, valueFormatter);
        };
        const usingSetFilter = ModuleRegistry.__isRegistered("@ag-grid-enterprise/set-filter" /* SetFilterModule */ , this.context.getGridId());
        const translate = this.localeService.getLocaleTextFunc();
        const mergeFilterParams = (params)=>{
            const { filterParams } = colDef;
            colDef.filterParams = typeof filterParams === "object" ? __spreadValues(__spreadValues({}, filterParams), params) : params;
        };
        switch(dataTypeDefinition.baseDataType){
            case "number":
                colDef.cellEditor = "agNumberCellEditor";
                if (usingSetFilter) mergeFilterParams({
                    comparator: (a, b)=>{
                        const valA = a == null ? 0 : parseInt(a);
                        const valB = b == null ? 0 : parseInt(b);
                        if (valA === valB) return 0;
                        return valA > valB ? 1 : -1;
                    }
                });
                break;
            case "boolean":
                colDef.cellEditor = "agCheckboxCellEditor";
                colDef.cellRenderer = "agCheckboxCellRenderer";
                colDef.suppressKeyboardEvent = (params)=>!!params.colDef.editable && params.event.key === KeyCode.SPACE;
                if (usingSetFilter) mergeFilterParams({
                    valueFormatter: (params)=>{
                        if (!exists(params.value)) return translate("blanks", "(Blanks)");
                        return translate(String(params.value), params.value ? "True" : "False");
                    }
                });
                else mergeFilterParams({
                    maxNumConditions: 1,
                    debounceMs: 0,
                    filterOptions: [
                        "empty",
                        {
                            displayKey: "true",
                            displayName: "True",
                            predicate: (_filterValues, cellValue)=>cellValue,
                            numberOfInputs: 0
                        },
                        {
                            displayKey: "false",
                            displayName: "False",
                            predicate: (_filterValues, cellValue)=>cellValue === false,
                            numberOfInputs: 0
                        }
                    ]
                });
                break;
            case "date":
                colDef.cellEditor = "agDateCellEditor";
                colDef.keyCreator = (params)=>formatValue(params.column, params.node, params.value);
                if (usingSetFilter) mergeFilterParams({
                    valueFormatter: (params)=>{
                        const valueFormatted = formatValue(params.column, params.node, params.value);
                        return exists(valueFormatted) ? valueFormatted : translate("blanks", "(Blanks)");
                    },
                    treeList: true,
                    treeListFormatter: (pathKey, level)=>{
                        if (level === 1 && pathKey != null) {
                            const monthKey = MONTH_KEYS[Number(pathKey) - 1];
                            return translate(monthKey, MONTH_LOCALE_TEXT[monthKey]);
                        }
                        return pathKey != null ? pathKey : translate("blanks", "(Blanks)");
                    }
                });
                break;
            case "dateString":
                {
                    colDef.cellEditor = "agDateStringCellEditor";
                    colDef.keyCreator = (params)=>formatValue(params.column, params.node, params.value);
                    const convertToDate = dataTypeDefinition.dateParser;
                    if (usingSetFilter) mergeFilterParams({
                        valueFormatter: (params)=>{
                            const valueFormatted = formatValue(params.column, params.node, params.value);
                            return exists(valueFormatted) ? valueFormatted : translate("blanks", "(Blanks)");
                        },
                        treeList: true,
                        treeListPathGetter: (value)=>{
                            const date = convertToDate(value != null ? value : void 0);
                            return date ? [
                                String(date.getFullYear()),
                                String(date.getMonth() + 1),
                                String(date.getDate())
                            ] : null;
                        },
                        treeListFormatter: (pathKey, level)=>{
                            if (level === 1 && pathKey != null) {
                                const monthKey = MONTH_KEYS[Number(pathKey) - 1];
                                return translate(monthKey, MONTH_LOCALE_TEXT[monthKey]);
                            }
                            return pathKey != null ? pathKey : translate("blanks", "(Blanks)");
                        }
                    });
                    else mergeFilterParams({
                        comparator: (filterDate, cellValue)=>{
                            const cellAsDate = convertToDate(cellValue);
                            if (cellValue == null || cellAsDate < filterDate) return -1;
                            if (cellAsDate > filterDate) return 1;
                            return 0;
                        }
                    });
                    break;
                }
            case "object":
                colDef.cellEditorParams = {
                    useFormatter: true
                };
                colDef.comparator = (a, b)=>{
                    const column = this.columnModel.getPrimaryColumn(colId);
                    const colDef2 = column == null ? void 0 : column.getColDef();
                    if (!column || !colDef2) return 0;
                    const valA = a == null ? "" : formatValue(column, null, a);
                    const valB = b == null ? "" : formatValue(column, null, b);
                    if (valA === valB) return 0;
                    return valA > valB ? 1 : -1;
                };
                colDef.keyCreator = (params)=>formatValue(params.column, params.node, params.value);
                if (usingSetFilter) mergeFilterParams({
                    valueFormatter: (params)=>{
                        const valueFormatted = formatValue(params.column, params.node, params.value);
                        return exists(valueFormatted) ? valueFormatted : translate("blanks", "(Blanks)");
                    }
                });
                else colDef.filterValueGetter = (params)=>formatValue(params.column, params.node, this.valueService.getValue(params.column, params.node));
                break;
        }
    }
    getDefaultDataTypes() {
        const defaultDateFormatMatcher = (value)=>!!value.match("^\\d{4}-\\d{2}-\\d{2}$");
        const translate = this.localeService.getLocaleTextFunc();
        return {
            number: {
                baseDataType: "number",
                // can be empty space with legacy copy
                valueParser: (params)=>{
                    var _a, _b;
                    return ((_b = (_a = params.newValue) == null ? void 0 : _a.trim) == null ? void 0 : _b.call(_a)) === "" ? null : Number(params.newValue);
                },
                valueFormatter: (params)=>{
                    if (params.value == null) return "";
                    if (typeof params.value !== "number" || isNaN(params.value)) return translate("invalidNumber", "Invalid Number");
                    return String(params.value);
                },
                dataTypeMatcher: (value)=>typeof value === "number"
            },
            text: {
                baseDataType: "text",
                valueParser: (params)=>params.newValue === "" ? null : toStringOrNull(params.newValue),
                dataTypeMatcher: (value)=>typeof value === "string"
            },
            boolean: {
                baseDataType: "boolean",
                valueParser: (params)=>{
                    var _a, _b;
                    if (params.newValue == null) return params.newValue;
                    return ((_b = (_a = params.newValue) == null ? void 0 : _a.trim) == null ? void 0 : _b.call(_a)) === "" ? null : String(params.newValue).toLowerCase() === "true";
                },
                valueFormatter: (params)=>params.value == null ? "" : String(params.value),
                dataTypeMatcher: (value)=>typeof value === "boolean"
            },
            date: {
                baseDataType: "date",
                valueParser: (params)=>parseDateTimeFromString(params.newValue == null ? null : String(params.newValue)),
                valueFormatter: (params)=>{
                    var _a;
                    if (params.value == null) return "";
                    if (!(params.value instanceof Date) || isNaN(params.value.getTime())) return translate("invalidDate", "Invalid Date");
                    return (_a = serialiseDate(params.value, false)) != null ? _a : "";
                },
                dataTypeMatcher: (value)=>value instanceof Date
            },
            dateString: {
                baseDataType: "dateString",
                dateParser: (value)=>{
                    var _a;
                    return (_a = parseDateTimeFromString(value)) != null ? _a : void 0;
                },
                dateFormatter: (value)=>{
                    var _a;
                    return (_a = serialiseDate(value != null ? value : null, false)) != null ? _a : void 0;
                },
                valueParser: (params)=>defaultDateFormatMatcher(String(params.newValue)) ? params.newValue : null,
                valueFormatter: (params)=>defaultDateFormatMatcher(String(params.value)) ? params.value : "",
                dataTypeMatcher: (value)=>typeof value === "string" && defaultDateFormatMatcher(value)
            },
            object: {
                baseDataType: "object",
                valueParser: ()=>null,
                valueFormatter: (params)=>{
                    var _a;
                    return (_a = toStringOrNull(params.value)) != null ? _a : "";
                }
            }
        };
    }
};
__decorateClass([
    Autowired("rowModel")
], DataTypeService.prototype, "rowModel", 2);
__decorateClass([
    Autowired("columnModel")
], DataTypeService.prototype, "columnModel", 2);
__decorateClass([
    Autowired("valueService")
], DataTypeService.prototype, "valueService", 2);
__decorateClass([
    PostConstruct
], DataTypeService.prototype, "init", 1);
DataTypeService = __decorateClass([
    Bean("dataTypeService")
], DataTypeService);
// community-modules/core/src/syncService.ts
var SyncService = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.waitingForColumns = false;
    }
    postConstruct() {
        this.addManagedPropertyListener("columnDefs", (event)=>this.setColumnDefs(event));
    }
    start() {
        this.ctrlsService.whenReady(()=>{
            const columnDefs = this.gos.get("columnDefs");
            if (columnDefs) this.setColumnsAndData(columnDefs);
            else this.waitingForColumns = true;
            this.gridReady();
        });
    }
    setColumnsAndData(columnDefs) {
        this.columnModel.setColumnDefs(columnDefs != null ? columnDefs : [], "gridInitializing");
        this.rowModel.start();
    }
    gridReady() {
        this.dispatchGridReadyEvent();
        const isEnterprise = ModuleRegistry.__isRegistered("@ag-grid-enterprise/core" /* EnterpriseCoreModule */ , this.context.getGridId());
        const logger = new Logger("AG Grid", ()=>this.gos.get("debug"));
        logger.log(`initialised successfully, enterprise = ${isEnterprise}`);
    }
    dispatchGridReadyEvent() {
        const readyEvent = {
            type: Events.EVENT_GRID_READY
        };
        this.eventService.dispatchEvent(readyEvent);
    }
    setColumnDefs(event) {
        const columnDefs = this.gos.get("columnDefs");
        if (!columnDefs) return;
        if (this.waitingForColumns) {
            this.waitingForColumns = false;
            this.setColumnsAndData(columnDefs);
            return;
        }
        this.columnModel.setColumnDefs(columnDefs, convertSourceType(event.source));
    }
};
__decorateClass([
    Autowired("ctrlsService")
], SyncService.prototype, "ctrlsService", 2);
__decorateClass([
    Autowired("columnModel")
], SyncService.prototype, "columnModel", 2);
__decorateClass([
    Autowired("rowModel")
], SyncService.prototype, "rowModel", 2);
__decorateClass([
    PostConstruct
], SyncService.prototype, "postConstruct", 1);
SyncService = __decorateClass([
    Bean("syncService")
], SyncService);
// community-modules/core/src/rendering/overlays/overlayService.ts
var OverlayService = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.manuallyDisplayed = false;
    }
    postConstruct() {
        this.addManagedListener(this.eventService, Events.EVENT_ROW_DATA_UPDATED, ()=>this.onRowDataUpdated());
        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, ()=>this.onNewColumnsLoaded());
    }
    registerOverlayWrapperComp(overlayWrapperComp) {
        this.overlayWrapperComp = overlayWrapperComp;
        if (!this.gos.get("columnDefs") || this.gos.isRowModelType("clientSide") && !this.gos.get("rowData")) this.showLoadingOverlay();
    }
    showLoadingOverlay() {
        if (this.gos.get("suppressLoadingOverlay")) return;
        const params = {};
        const compDetails = this.userComponentFactory.getLoadingOverlayCompDetails(params);
        this.showOverlay(compDetails, "ag-overlay-loading-wrapper", "loadingOverlayComponentParams");
    }
    showNoRowsOverlay() {
        if (this.gos.get("suppressNoRowsOverlay")) return;
        const params = {};
        const compDetails = this.userComponentFactory.getNoRowsOverlayCompDetails(params);
        this.showOverlay(compDetails, "ag-overlay-no-rows-wrapper", "noRowsOverlayComponentParams");
    }
    showOverlay(compDetails, wrapperCssClass, gridOption) {
        const promise = compDetails.newAgStackInstance();
        const listenerDestroyFunc = this.addManagedPropertyListener(gridOption, ({ currentValue })=>{
            promise.then((comp)=>{
                if (comp.refresh) comp.refresh(this.gos.addGridCommonParams(__spreadValues({}, currentValue != null ? currentValue : {})));
            });
        });
        this.manuallyDisplayed = this.columnModel.isReady() && !this.paginationProxy.isEmpty();
        this.overlayWrapperComp.showOverlay(promise, wrapperCssClass, listenerDestroyFunc);
    }
    hideOverlay() {
        this.manuallyDisplayed = false;
        this.overlayWrapperComp.hideOverlay();
    }
    showOrHideOverlay() {
        const isEmpty = this.paginationProxy.isEmpty();
        const isSuppressNoRowsOverlay = this.gos.get("suppressNoRowsOverlay");
        if (isEmpty && !isSuppressNoRowsOverlay) this.showNoRowsOverlay();
        else this.hideOverlay();
    }
    onRowDataUpdated() {
        this.showOrHideOverlay();
    }
    onNewColumnsLoaded() {
        if (this.columnModel.isReady() && !this.paginationProxy.isEmpty() && !this.manuallyDisplayed) this.hideOverlay();
    }
};
__decorateClass([
    Autowired("userComponentFactory")
], OverlayService.prototype, "userComponentFactory", 2);
__decorateClass([
    Autowired("paginationProxy")
], OverlayService.prototype, "paginationProxy", 2);
__decorateClass([
    Autowired("columnModel")
], OverlayService.prototype, "columnModel", 2);
__decorateClass([
    PostConstruct
], OverlayService.prototype, "postConstruct", 1);
OverlayService = __decorateClass([
    Bean("overlayService")
], OverlayService);
// community-modules/core/src/misc/stateService.ts
var StateService = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.suppressEvents = true;
        this.queuedUpdateSources = /* @__PURE__ */ new Set();
        this.dispatchStateUpdateEventDebounced = debounce(()=>this.dispatchQueuedStateUpdateEvents(), 0);
        // If user is doing a manual expand all node by node, we don't want to process one at a time.
        // EVENT_ROW_GROUP_OPENED is already async, so no impact of making the state async here.
        this.onRowGroupOpenedDebounced = debounce(()=>this.updateCachedState("rowGroupExpansion", this.getRowGroupExpansionState()), 0);
        // similar to row expansion, want to debounce. However, selection is synchronous, so need to mark as stale in case `getState` is called.
        this.onRowSelectedDebounced = debounce(()=>{
            this.staleStateKeys.delete("rowSelection");
            this.updateCachedState("rowSelection", this.getRowSelectionState());
        }, 0);
        this.staleStateKeys = /* @__PURE__ */ new Set();
    }
    postConstruct() {
        var _a;
        this.isClientSideRowModel = this.rowModel.getType() === "clientSide";
        this.cachedState = (_a = this.gos.get("initialState")) != null ? _a : {};
        this.ctrlsService.whenReady(()=>this.suppressEventsAndDispatchInitEvent(()=>this.setupStateOnGridReady()));
        const newColumnsLoadedDestroyFunc = this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, ({ source })=>{
            if (source === "gridInitializing") {
                newColumnsLoadedDestroyFunc == null || newColumnsLoadedDestroyFunc();
                this.suppressEventsAndDispatchInitEvent(()=>this.setupStateOnColumnsInitialised());
            }
        });
        const rowCountReadyDestroyFunc = this.addManagedListener(this.eventService, Events.EVENT_ROW_COUNT_READY, ()=>{
            rowCountReadyDestroyFunc == null || rowCountReadyDestroyFunc();
            this.suppressEventsAndDispatchInitEvent(()=>this.setupStateOnRowCountReady());
        });
        const firstDataRenderedDestroyFunc = this.addManagedListener(this.eventService, Events.EVENT_FIRST_DATA_RENDERED, ()=>{
            firstDataRenderedDestroyFunc == null || firstDataRenderedDestroyFunc();
            this.suppressEventsAndDispatchInitEvent(()=>this.setupStateOnFirstDataRendered());
        });
    }
    getState() {
        if (this.staleStateKeys.size) this.refreshStaleState();
        return this.cachedState;
    }
    setupStateOnGridReady() {
        this.updateCachedState("sideBar", this.getSideBarState());
        this.addManagedListener(this.eventService, Events.EVENT_TOOL_PANEL_VISIBLE_CHANGED, ()=>this.updateCachedState("sideBar", this.getSideBarState()));
        this.addManagedListener(this.eventService, Events.EVENT_SIDE_BAR_UPDATED, ()=>this.updateCachedState("sideBar", this.getSideBarState()));
    }
    setupStateOnColumnsInitialised() {
        var _a;
        const initialState = (_a = this.gos.get("initialState")) != null ? _a : {};
        this.setColumnState(initialState);
        this.setColumnGroupState(initialState);
        this.updateColumnState([
            "aggregation",
            "columnOrder",
            "columnPinning",
            "columnSizing",
            "columnVisibility",
            "pivot",
            "pivot",
            "rowGroup",
            "sort"
        ]);
        this.updateCachedState("columnGroup", this.getColumnGroupState());
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_VALUE_CHANGED, ()=>this.updateColumnState([
                "aggregation"
            ]));
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_MOVED, ()=>this.updateColumnState([
                "columnOrder"
            ]));
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PINNED, ()=>this.updateColumnState([
                "columnPinning"
            ]));
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_RESIZED, ()=>this.updateColumnState([
                "columnSizing"
            ]));
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_VISIBLE, ()=>this.updateColumnState([
                "columnVisibility"
            ]));
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_CHANGED, ()=>this.updateColumnState([
                "pivot"
            ]));
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, ()=>this.updateColumnState([
                "pivot"
            ]));
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, ()=>this.updateColumnState([
                "rowGroup"
            ]));
        this.addManagedListener(this.eventService, Events.EVENT_SORT_CHANGED, ()=>this.updateColumnState([
                "sort"
            ]));
        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, ()=>this.updateColumnState([
                "aggregation",
                "columnOrder",
                "columnPinning",
                "columnSizing",
                "columnVisibility",
                "pivot",
                "pivot",
                "rowGroup",
                "sort"
            ]));
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_GROUP_OPENED, ()=>this.updateCachedState("columnGroup", this.getColumnGroupState()));
    }
    setupStateOnRowCountReady() {
        var _a;
        const { filter: filterState, rowGroupExpansion: rowGroupExpansionState, rowSelection: rowSelectionState, pagination: paginationState } = (_a = this.gos.get("initialState")) != null ? _a : {};
        const advancedFilterModel = this.gos.get("advancedFilterModel");
        if (filterState || advancedFilterModel) this.setFilterState(filterState, advancedFilterModel);
        if (rowGroupExpansionState) this.setRowGroupExpansionState(rowGroupExpansionState);
        if (rowSelectionState) this.setRowSelectionState(rowSelectionState);
        if (paginationState) this.setPaginationState(paginationState);
        this.updateCachedState("filter", this.getFilterState());
        this.updateCachedState("rowGroupExpansion", this.getRowGroupExpansionState());
        this.updateCachedState("rowSelection", this.getRowSelectionState());
        this.updateCachedState("pagination", this.getPaginationState());
        this.addManagedListener(this.eventService, Events.EVENT_FILTER_CHANGED, ()=>this.updateCachedState("filter", this.getFilterState()));
        this.addManagedListener(this.eventService, Events.EVENT_ROW_GROUP_OPENED, ()=>this.onRowGroupOpenedDebounced());
        this.addManagedListener(this.eventService, Events.EVENT_EXPAND_COLLAPSE_ALL, ()=>this.updateCachedState("rowGroupExpansion", this.getRowGroupExpansionState()));
        this.addManagedListener(this.eventService, Events.EVENT_SELECTION_CHANGED, ()=>{
            this.staleStateKeys.add("rowSelection");
            this.onRowSelectedDebounced();
        });
        this.addManagedListener(this.eventService, Events.EVENT_PAGINATION_CHANGED, (event)=>{
            if (event.newPage || event.newPageSize) this.updateCachedState("pagination", this.getPaginationState());
        });
    }
    setupStateOnFirstDataRendered() {
        var _a;
        const { scroll: scrollState, rangeSelection: rangeSelectionState, focusedCell: focusedCellState, columnOrder: columnOrderState } = (_a = this.gos.get("initialState")) != null ? _a : {};
        if (focusedCellState) this.setFocusedCellState(focusedCellState);
        if (rangeSelectionState) this.setRangeSelectionState(rangeSelectionState);
        if (scrollState) this.setScrollState(scrollState);
        this.setColumnPivotState(!!(columnOrderState == null ? void 0 : columnOrderState.orderedColIds));
        this.updateCachedState("sideBar", this.getSideBarState());
        this.updateCachedState("focusedCell", this.getFocusedCellState());
        this.updateCachedState("rangeSelection", this.getRangeSelectionState());
        this.updateCachedState("scroll", this.getScrollState());
        this.addManagedListener(this.eventService, Events.EVENT_CELL_FOCUSED, ()=>this.updateCachedState("focusedCell", this.getFocusedCellState()));
        this.addManagedListener(this.eventService, Events.EVENT_RANGE_SELECTION_CHANGED, (event)=>{
            if (event.finished) this.updateCachedState("rangeSelection", this.getRangeSelectionState());
        });
        this.addManagedListener(this.eventService, Events.EVENT_BODY_SCROLL_END, ()=>this.updateCachedState("scroll", this.getScrollState()));
    }
    getColumnState() {
        const pivotMode = this.columnModel.isPivotMode();
        const sortColumns = [];
        const groupColIds = [];
        const aggregationColumns = [];
        const pivotColIds = [];
        const leftColIds = [];
        const rightColIds = [];
        const hiddenColIds = [];
        const columnSizes = [];
        const columns = [];
        const columnState = this.columnModel.getColumnState();
        for(let i = 0; i < columnState.length; i++){
            const { colId, sort, sortIndex, rowGroup, rowGroupIndex, aggFunc, pivot, pivotIndex, pinned, hide, width, flex } = columnState[i];
            columns.push(colId);
            if (sort) sortColumns[sortIndex != null ? sortIndex : 0] = {
                colId,
                sort
            };
            if (rowGroup) groupColIds[rowGroupIndex != null ? rowGroupIndex : 0] = colId;
            if (typeof aggFunc === "string") aggregationColumns.push({
                colId,
                aggFunc
            });
            if (pivot) pivotColIds[pivotIndex != null ? pivotIndex : 0] = colId;
            if (pinned) (pinned === "right" ? rightColIds : leftColIds).push(colId);
            if (hide) hiddenColIds.push(colId);
            if (flex || width) columnSizes.push({
                colId,
                flex: flex != null ? flex : void 0,
                width
            });
        }
        return {
            sort: sortColumns.length ? {
                sortModel: sortColumns
            } : void 0,
            rowGroup: groupColIds.length ? {
                groupColIds
            } : void 0,
            aggregation: aggregationColumns.length ? {
                aggregationModel: aggregationColumns
            } : void 0,
            pivot: pivotColIds.length || pivotMode ? {
                pivotMode,
                pivotColIds
            } : void 0,
            columnPinning: leftColIds.length || rightColIds.length ? {
                leftColIds,
                rightColIds
            } : void 0,
            columnVisibility: hiddenColIds.length ? {
                hiddenColIds
            } : void 0,
            columnSizing: columnSizes.length ? {
                columnSizingModel: columnSizes
            } : void 0,
            columnOrder: columns.length ? {
                orderedColIds: columns
            } : void 0
        };
    }
    setColumnState(initialState) {
        const { sort: sortState, rowGroup: groupState, aggregation: aggregationState, pivot: pivotState, columnPinning: columnPinningState, columnVisibility: columnVisibilityState, columnSizing: columnSizingState, columnOrder: columnOrderState } = initialState;
        const columnStateMap = {};
        const getColumnState = (colId)=>{
            let columnState = columnStateMap[colId];
            if (columnState) return columnState;
            columnState = {
                colId
            };
            columnStateMap[colId] = columnState;
            return columnState;
        };
        if (sortState) sortState.sortModel.forEach(({ colId, sort }, sortIndex)=>{
            const columnState = getColumnState(colId);
            columnState.sort = sort;
            columnState.sortIndex = sortIndex;
        });
        if (groupState) groupState.groupColIds.forEach((colId, rowGroupIndex)=>{
            const columnState = getColumnState(colId);
            columnState.rowGroup = true;
            columnState.rowGroupIndex = rowGroupIndex;
        });
        if (aggregationState) aggregationState.aggregationModel.forEach(({ colId, aggFunc })=>{
            getColumnState(colId).aggFunc = aggFunc;
        });
        if (pivotState) {
            pivotState.pivotColIds.forEach((colId, pivotIndex)=>{
                const columnState = getColumnState(colId);
                columnState.pivot = true;
                columnState.pivotIndex = pivotIndex;
            });
            this.gos.updateGridOptions({
                options: {
                    pivotMode: pivotState.pivotMode
                },
                source: "gridInitializing"
            });
        }
        if (columnPinningState) {
            columnPinningState.leftColIds.forEach((colId)=>{
                getColumnState(colId).pinned = "left";
            });
            columnPinningState.rightColIds.forEach((colId)=>{
                getColumnState(colId).pinned = "right";
            });
        }
        if (columnVisibilityState) columnVisibilityState.hiddenColIds.forEach((colId)=>{
            getColumnState(colId).hide = true;
        });
        if (columnSizingState) columnSizingState.columnSizingModel.forEach(({ colId, flex, width })=>{
            const columnState = getColumnState(colId);
            columnState.flex = flex != null ? flex : null;
            columnState.width = width;
        });
        const columns = columnOrderState == null ? void 0 : columnOrderState.orderedColIds;
        const applyOrder = !!(columns == null ? void 0 : columns.length);
        const columnStates = applyOrder ? columns.map((colId)=>getColumnState(colId)) : Object.values(columnStateMap);
        if (columnStates.length) {
            this.columnStates = columnStates;
            const defaultState = {
                sort: null,
                sortIndex: null,
                rowGroup: null,
                rowGroupIndex: null,
                aggFunc: null,
                pivot: null,
                pivotIndex: null,
                pinned: null,
                hide: null,
                flex: null
            };
            this.columnModel.applyColumnState({
                state: columnStates,
                applyOrder,
                defaultState
            }, "gridInitializing");
        }
    }
    setColumnPivotState(applyOrder) {
        const columnStates = this.columnStates;
        this.columnStates = void 0;
        const columnGroupStates = this.columnGroupStates;
        this.columnGroupStates = void 0;
        if (!this.columnModel.isSecondaryColumnsPresent()) return;
        if (columnStates) {
            let secondaryColumnStates = [];
            for (const columnState of columnStates)if (this.columnModel.getSecondaryColumn(columnState.colId)) secondaryColumnStates.push(columnState);
            this.columnModel.applyColumnState({
                state: secondaryColumnStates,
                applyOrder
            }, "gridInitializing");
        }
        if (columnGroupStates) this.columnModel.setColumnGroupState(columnGroupStates, "gridInitializing");
    }
    getColumnGroupState() {
        const columnGroupState = this.columnModel.getColumnGroupState();
        const openColumnGroups = [];
        columnGroupState.forEach(({ groupId, open })=>{
            if (open) openColumnGroups.push(groupId);
        });
        return openColumnGroups.length ? {
            openColumnGroupIds: openColumnGroups
        } : void 0;
    }
    setColumnGroupState(initialState) {
        var _a;
        if (!initialState.hasOwnProperty("columnGroup")) return;
        const openColumnGroups = new Set((_a = initialState.columnGroup) == null ? void 0 : _a.openColumnGroupIds);
        const existingColumnGroupState = this.columnModel.getColumnGroupState();
        const stateItems = existingColumnGroupState.map(({ groupId })=>{
            const open = openColumnGroups.has(groupId);
            if (open) openColumnGroups.delete(groupId);
            return {
                groupId,
                open
            };
        });
        openColumnGroups.forEach((groupId)=>{
            stateItems.push({
                groupId,
                open: true
            });
        });
        if (stateItems.length) this.columnGroupStates = stateItems;
        this.columnModel.setColumnGroupState(stateItems, "gridInitializing");
    }
    getFilterState() {
        var _a;
        let filterModel = this.filterManager.getFilterModel();
        if (filterModel && Object.keys(filterModel).length === 0) filterModel = void 0;
        const advancedFilterModel = (_a = this.filterManager.getAdvancedFilterModel()) != null ? _a : void 0;
        return filterModel || advancedFilterModel ? {
            filterModel,
            advancedFilterModel
        } : void 0;
    }
    setFilterState(filterState, gridOptionAdvancedFilterModel) {
        const { filterModel, advancedFilterModel } = filterState != null ? filterState : {
            advancedFilterModel: gridOptionAdvancedFilterModel
        };
        if (filterModel) this.filterManager.setFilterModel(filterModel, "columnFilter");
        if (advancedFilterModel) this.filterManager.setAdvancedFilterModel(advancedFilterModel);
    }
    getRangeSelectionState() {
        var _a;
        const cellRanges = (_a = this.rangeService) == null ? void 0 : _a.getCellRanges().map((cellRange)=>{
            const { id, type, startRow, endRow, columns, startColumn } = cellRange;
            return {
                id,
                type,
                startRow,
                endRow,
                colIds: columns.map((column)=>column.getColId()),
                startColId: startColumn.getColId()
            };
        });
        return (cellRanges == null ? void 0 : cellRanges.length) ? {
            cellRanges
        } : void 0;
    }
    setRangeSelectionState(rangeSelectionState) {
        if (!this.gos.get("enableRangeSelection") || !this.rangeService) return;
        const cellRanges = [];
        rangeSelectionState.cellRanges.forEach((cellRange)=>{
            const columns = [];
            cellRange.colIds.forEach((colId)=>{
                const column = this.columnModel.getGridColumn(colId);
                if (column) columns.push(column);
            });
            if (!columns.length) return;
            let startColumn = this.columnModel.getGridColumn(cellRange.startColId);
            if (!startColumn) {
                const allColumns = this.columnModel.getAllDisplayedColumns();
                const columnSet = new Set(columns);
                startColumn = allColumns.find((column)=>columnSet.has(column));
            }
            cellRanges.push(__spreadProps(__spreadValues({}, cellRange), {
                columns,
                startColumn
            }));
        });
        this.rangeService.setCellRanges(cellRanges);
    }
    getScrollState() {
        var _a, _b, _c;
        if (!this.isClientSideRowModel) return void 0;
        const scrollFeature = (_a = this.ctrlsService.getGridBodyCtrl()) == null ? void 0 : _a.getScrollFeature();
        const { left } = (_b = scrollFeature == null ? void 0 : scrollFeature.getHScrollPosition()) != null ? _b : {
            left: 0
        };
        const { top } = (_c = scrollFeature == null ? void 0 : scrollFeature.getVScrollPosition()) != null ? _c : {
            top: 0
        };
        return top || left ? {
            top,
            left
        } : void 0;
    }
    setScrollState(scrollState) {
        var _a;
        if (!this.isClientSideRowModel) return;
        const { top, left } = scrollState;
        (_a = this.ctrlsService.getGridBodyCtrl()) == null || _a.getScrollFeature().setScrollPosition(top, left);
    }
    getSideBarState() {
        var _a, _b;
        return (_b = (_a = this.sideBarService) == null ? void 0 : _a.getSideBarComp()) == null ? void 0 : _b.getState();
    }
    getFocusedCellState() {
        if (!this.isClientSideRowModel) return void 0;
        const focusedCell = this.focusService.getFocusedCell();
        if (focusedCell) {
            const { column, rowIndex, rowPinned } = focusedCell;
            return {
                colId: column.getColId(),
                rowIndex,
                rowPinned
            };
        }
        return void 0;
    }
    setFocusedCellState(focusedCellState) {
        if (!this.isClientSideRowModel) return;
        const { colId, rowIndex, rowPinned } = focusedCellState;
        this.focusService.setFocusedCell({
            column: this.columnModel.getGridColumn(colId),
            rowIndex,
            rowPinned,
            forceBrowserFocus: true,
            preventScrollOnBrowserFocus: true
        });
    }
    getPaginationState() {
        const page = this.paginationProxy.getCurrentPage();
        const pageSize = !this.gos.get("paginationAutoPageSize") ? this.paginationProxy.getPageSize() : void 0;
        if (!page && !pageSize) return;
        return {
            page,
            pageSize
        };
    }
    setPaginationState(paginationState) {
        if (paginationState.pageSize && !this.gos.get("paginationAutoPageSize")) this.paginationProxy.setPageSize(paginationState.pageSize, "initialState");
        if (typeof paginationState.page === "number") this.paginationProxy.setPage(paginationState.page);
    }
    getRowSelectionState() {
        var _a;
        const selectionState = this.selectionService.getSelectionState();
        const noSelections = !selectionState || !Array.isArray(selectionState) && (selectionState.selectAll === false || selectionState.selectAllChildren === false) && !((_a = selectionState == null ? void 0 : selectionState.toggledNodes) == null ? void 0 : _a.length);
        return noSelections ? void 0 : selectionState;
    }
    setRowSelectionState(rowSelectionState) {
        this.selectionService.setSelectionState(rowSelectionState, "gridInitializing");
    }
    getRowGroupExpansionState() {
        const expandedRowGroups = this.expansionService.getExpandedRows();
        return expandedRowGroups.length ? {
            expandedRowGroupIds: expandedRowGroups
        } : void 0;
    }
    setRowGroupExpansionState(rowGroupExpansionState) {
        this.expansionService.expandRows(rowGroupExpansionState.expandedRowGroupIds);
    }
    updateColumnState(features) {
        const newColumnState = this.getColumnState();
        let hasChanged = false;
        Object.entries(newColumnState).forEach(([key, value])=>{
            if (!jsonEquals(value, this.cachedState[key])) hasChanged = true;
        });
        this.cachedState = __spreadValues(__spreadValues({}, this.cachedState), newColumnState);
        if (hasChanged) this.dispatchStateUpdateEvent(features);
    }
    updateCachedState(key, value) {
        const existingValue = this.cachedState[key];
        this.setCachedStateValue(key, value);
        if (!jsonEquals(value, existingValue)) this.dispatchStateUpdateEvent([
            key
        ]);
    }
    setCachedStateValue(key, value) {
        this.cachedState = __spreadProps(__spreadValues({}, this.cachedState), {
            [key]: value
        });
    }
    refreshStaleState() {
        this.staleStateKeys.forEach((key)=>{
            switch(key){
                case "rowSelection":
                    this.setCachedStateValue(key, this.getRowSelectionState());
                    break;
            }
        });
        this.staleStateKeys.clear();
    }
    dispatchStateUpdateEvent(sources) {
        if (this.suppressEvents) return;
        sources.forEach((source)=>this.queuedUpdateSources.add(source));
        this.dispatchStateUpdateEventDebounced();
    }
    dispatchQueuedStateUpdateEvents() {
        const sources = Array.from(this.queuedUpdateSources);
        this.queuedUpdateSources.clear();
        const event = {
            type: Events.EVENT_STATE_UPDATED,
            sources,
            state: this.cachedState
        };
        this.eventService.dispatchEvent(event);
    }
    suppressEventsAndDispatchInitEvent(updateFunc) {
        this.suppressEvents = true;
        this.columnAnimationService.setSuppressAnimation(true);
        updateFunc();
        setTimeout(()=>{
            this.suppressEvents = false;
            this.queuedUpdateSources.clear();
            if (!this.isAlive()) return;
            this.columnAnimationService.setSuppressAnimation(false);
            this.dispatchStateUpdateEvent([
                "gridInitializing"
            ]);
        });
    }
};
__decorateClass([
    Autowired("filterManager")
], StateService.prototype, "filterManager", 2);
__decorateClass([
    Autowired("ctrlsService")
], StateService.prototype, "ctrlsService", 2);
__decorateClass([
    Autowired("focusService")
], StateService.prototype, "focusService", 2);
__decorateClass([
    Autowired("columnModel")
], StateService.prototype, "columnModel", 2);
__decorateClass([
    Autowired("paginationProxy")
], StateService.prototype, "paginationProxy", 2);
__decorateClass([
    Autowired("rowModel")
], StateService.prototype, "rowModel", 2);
__decorateClass([
    Autowired("selectionService")
], StateService.prototype, "selectionService", 2);
__decorateClass([
    Autowired("expansionService")
], StateService.prototype, "expansionService", 2);
__decorateClass([
    Autowired("columnAnimationService")
], StateService.prototype, "columnAnimationService", 2);
__decorateClass([
    Optional("sideBarService")
], StateService.prototype, "sideBarService", 2);
__decorateClass([
    Optional("rangeService")
], StateService.prototype, "rangeService", 2);
__decorateClass([
    PostConstruct
], StateService.prototype, "postConstruct", 1);
StateService = __decorateClass([
    Bean("stateService")
], StateService);
// community-modules/core/src/validation/validationService.ts
var ValidationService = class extends BeanStub {
    init() {
        this.processGridOptions(this.gridOptions);
    }
    processGridOptions(options) {
        this.processOptions(options, GRID_OPTIONS_VALIDATORS);
    }
    processColumnDefs(options) {
        this.processOptions(options, COL_DEF_VALIDATORS);
    }
    processOptions(options, validator) {
        const { validations, deprecations, allProperties, propertyExceptions, objectName, docsUrl } = validator;
        if (allProperties && this.gridOptions.suppressPropertyNamesCheck !== true) this.checkProperties(options, [
            ...propertyExceptions != null ? propertyExceptions : [],
            ...Object.keys(deprecations)
        ], allProperties, objectName, docsUrl);
        const warnings = /* @__PURE__ */ new Set();
        const optionKeys = Object.keys(options);
        optionKeys.forEach((key)=>{
            var _a;
            const deprecation = deprecations[key];
            if (deprecation) {
                if ("renamed" in deprecation) {
                    const { renamed, version } = deprecation;
                    warnings.add(`As of v${version}, ${String(key)} is deprecated. Please use ${String(renamed)} instead.`);
                    options[renamed] = options[key];
                } else {
                    const { message, version } = deprecation;
                    warnings.add(`As of v${version}, ${String(key)} is deprecated. ${message != null ? message : ""}`);
                }
            }
            const value = options[key];
            if (value == null || value === false) return;
            const rulesOrGetter = validations[key];
            let rules;
            if (!rulesOrGetter) return;
            else if (typeof rulesOrGetter === "function") {
                const fromGetter = rulesOrGetter(options, this.gridOptions);
                if (!fromGetter) return;
                if ("objectName" in fromGetter) {
                    const value2 = options[key];
                    if (Array.isArray(value2)) {
                        value2.forEach((item)=>{
                            this.processOptions(item, fromGetter);
                        });
                        return;
                    }
                    this.processOptions(options[key], fromGetter);
                    return;
                }
                rules = fromGetter;
            } else rules = rulesOrGetter;
            const { module, dependencies, supportedRowModels } = rules;
            if (supportedRowModels) {
                const rowModel = (_a = this.gridOptions.rowModelType) != null ? _a : "clientSide";
                if (!supportedRowModels.includes(rowModel)) {
                    warnings.add(`${String(key)} is not supported with the '${rowModel}' row model.`);
                    return;
                }
            }
            if (module) {
                const modules = Array.isArray(module) ? module : [
                    module
                ];
                let allRegistered = true;
                modules.forEach((m)=>{
                    if (!ModuleRegistry.__assertRegistered(m, String(key), this.context.getGridId())) {
                        allRegistered = false;
                        warnings.add(`${String(key)} is only available when ${m} is loaded.`);
                    }
                });
                if (!allRegistered) return;
            }
            if (dependencies) {
                const warning = this.checkForWarning(key, dependencies, options);
                if (warning) {
                    warnings.add(warning);
                    return;
                }
            }
        });
        if (warnings.size > 0) warnings.forEach((warning)=>{
            warnOnce(warning);
        });
    }
    checkForWarning(key, validator, options) {
        if (typeof validator === "function") return validator(options, this.gridOptions);
        const optionEntries = Object.entries(validator);
        const failed = optionEntries.find(([key2, value])=>{
            const gridOptionValue = options[key2];
            return !value.includes(gridOptionValue);
        });
        if (!failed) return null;
        const [failedKey, possibleOptions] = failed;
        if (possibleOptions.length > 1) return `'${String(key)}' requires '${failedKey}' to be one of [${possibleOptions.join(", ")}].`;
        return `'${String(key)}' requires '${failedKey}' to be ${possibleOptions[0]}.`;
    }
    checkProperties(object, exceptions, validProperties, containerName, docsUrl) {
        const VUE_FRAMEWORK_PROPS = [
            "__ob__",
            "__v_skip",
            "__metadata__"
        ];
        const invalidProperties = fuzzyCheckStrings(Object.getOwnPropertyNames(object), [
            ...VUE_FRAMEWORK_PROPS,
            ...exceptions,
            ...validProperties
        ], validProperties);
        iterateObject(invalidProperties, (key, value)=>{
            warnOnce(`invalid ${containerName} property '${key}' did you mean any of these: ${value.slice(0, 8).join(", ")}`);
        });
        if (Object.keys(invalidProperties).length > 0 && docsUrl) {
            const url = this.getFrameworkOverrides().getDocLink(docsUrl);
            warnOnce(`to see all the valid ${containerName} properties please check: ${url}`);
        }
    }
};
__decorateClass([
    Autowired("gridOptions")
], ValidationService.prototype, "gridOptions", 2);
__decorateClass([
    PostConstruct
], ValidationService.prototype, "init", 1);
ValidationService = __decorateClass([
    Bean("validationService")
], ValidationService);
// community-modules/core/src/misc/apiEventService.ts
var ApiEventService = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.syncEventListeners = /* @__PURE__ */ new Map();
        this.asyncEventListeners = /* @__PURE__ */ new Map();
        this.syncGlobalEventListeners = /* @__PURE__ */ new Set();
        this.globalEventListenerPairs = /* @__PURE__ */ new Map();
    }
    postConstruct() {
        this.frameworkEventWrappingService = new FrameworkEventListenerService(this.getFrameworkOverrides());
    }
    addEventListener(eventType, userListener) {
        const listener = this.frameworkEventWrappingService.wrap(userListener);
        const async = this.gos.useAsyncEvents() && !ALWAYS_SYNC_GLOBAL_EVENTS.has(eventType);
        const listeners = async ? this.asyncEventListeners : this.syncEventListeners;
        if (!listeners.has(eventType)) listeners.set(eventType, /* @__PURE__ */ new Set());
        listeners.get(eventType).add(listener);
        this.eventService.addEventListener(eventType, listener, async);
    }
    removeEventListener(eventType, userListener) {
        var _a;
        const listener = this.frameworkEventWrappingService.unwrap(userListener);
        const asyncListeners = this.asyncEventListeners.get(eventType);
        const hasAsync = !!(asyncListeners == null ? void 0 : asyncListeners.delete(listener));
        if (!hasAsync) (_a = this.syncEventListeners.get(eventType)) == null || _a.delete(listener);
        this.eventService.removeEventListener(eventType, listener, hasAsync);
    }
    addGlobalListener(userListener) {
        const listener = this.frameworkEventWrappingService.wrapGlobal(userListener);
        const async = this.gos.useAsyncEvents();
        if (async) {
            const syncListener = (eventType, event)=>{
                if (ALWAYS_SYNC_GLOBAL_EVENTS.has(eventType)) listener(eventType, event);
            };
            const asyncListener = (eventType, event)=>{
                if (!ALWAYS_SYNC_GLOBAL_EVENTS.has(eventType)) listener(eventType, event);
            };
            this.globalEventListenerPairs.set(userListener, {
                syncListener,
                asyncListener
            });
            this.eventService.addGlobalListener(syncListener, false);
            this.eventService.addGlobalListener(asyncListener, true);
        } else {
            this.syncGlobalEventListeners.add(listener);
            this.eventService.addGlobalListener(listener, false);
        }
    }
    removeGlobalListener(userListener) {
        const listener = this.frameworkEventWrappingService.unwrapGlobal(userListener);
        const hasAsync = this.globalEventListenerPairs.has(listener);
        if (hasAsync) {
            const { syncListener, asyncListener } = this.globalEventListenerPairs.get(listener);
            this.eventService.removeGlobalListener(syncListener, false);
            this.eventService.removeGlobalListener(asyncListener, true);
            this.globalEventListenerPairs.delete(userListener);
        } else {
            this.syncGlobalEventListeners.delete(listener);
            this.eventService.removeGlobalListener(listener, false);
        }
    }
    destroyEventListeners(map, async) {
        map.forEach((listeners, eventType)=>{
            listeners.forEach((listener)=>this.eventService.removeEventListener(eventType, listener, async));
            listeners.clear();
        });
        map.clear();
    }
    destroyGlobalListeners(set, async) {
        set.forEach((listener)=>this.eventService.removeGlobalListener(listener, async));
        set.clear();
    }
    destroy() {
        super.destroy();
        this.destroyEventListeners(this.syncEventListeners, false);
        this.destroyEventListeners(this.asyncEventListeners, true);
        this.destroyGlobalListeners(this.syncGlobalEventListeners, false);
        this.globalEventListenerPairs.forEach(({ syncListener, asyncListener })=>{
            this.eventService.removeGlobalListener(syncListener, false);
            this.eventService.removeGlobalListener(asyncListener, true);
        });
        this.globalEventListenerPairs.clear();
    }
};
__decorateClass([
    PostConstruct
], ApiEventService.prototype, "postConstruct", 1);
ApiEventService = __decorateClass([
    Bean("apiEventService")
], ApiEventService);
// community-modules/core/src/pagination/pageSizeSelector/pageSizeSelectorComp.ts
var PageSizeSelectorComp = class extends Component {
    constructor(){
        super(/* html */ `<span class="ag-paging-page-size"></span>`);
        this.hasEmptyOption = false;
        this.handlePageSizeItemSelected = ()=>{
            if (!this.selectPageSizeComp) return;
            const newValue = this.selectPageSizeComp.getValue();
            if (!newValue) return;
            const paginationPageSize = Number(newValue);
            if (isNaN(paginationPageSize) || paginationPageSize < 1 || paginationPageSize === this.paginationProxy.getPageSize()) return;
            this.paginationProxy.setPageSize(paginationPageSize, "pageSizeSelector");
            if (this.hasEmptyOption) this.toggleSelectDisplay(true);
            this.selectPageSizeComp.getFocusableElement().focus();
        };
    }
    init() {
        this.addManagedPropertyListener("paginationPageSizeSelector", ()=>{
            this.onPageSizeSelectorValuesChange();
        });
        this.addManagedListener(this.eventService, Events.EVENT_PAGINATION_CHANGED, (event)=>this.handlePaginationChanged(event));
    }
    handlePaginationChanged(paginationChangedEvent) {
        if (!this.selectPageSizeComp || !(paginationChangedEvent == null ? void 0 : paginationChangedEvent.newPageSize)) return;
        const paginationPageSize = this.paginationProxy.getPageSize();
        if (this.getPageSizeSelectorValues().includes(paginationPageSize)) this.selectPageSizeComp.setValue(paginationPageSize.toString());
        else if (this.hasEmptyOption) this.selectPageSizeComp.setValue("");
        else this.toggleSelectDisplay(true);
    }
    toggleSelectDisplay(show) {
        if (this.selectPageSizeComp) this.reset();
        if (!show) return;
        this.reloadPageSizesSelector();
        if (!this.selectPageSizeComp) return;
        this.appendChild(this.selectPageSizeComp);
    }
    reset() {
        clearElement(this.getGui());
        if (!this.selectPageSizeComp) return;
        this.destroyBean(this.selectPageSizeComp);
        this.selectPageSizeComp = void 0;
    }
    onPageSizeSelectorValuesChange() {
        if (!this.selectPageSizeComp) return;
        if (this.shouldShowPageSizeSelector()) this.reloadPageSizesSelector();
    }
    shouldShowPageSizeSelector() {
        return this.gos.get("pagination") && !this.gos.get("suppressPaginationPanel") && !this.gos.get("paginationAutoPageSize") && this.gos.get("paginationPageSizeSelector") !== false;
    }
    reloadPageSizesSelector() {
        const pageSizeOptions = this.getPageSizeSelectorValues();
        const paginationPageSizeOption = this.paginationProxy.getPageSize();
        const shouldAddAndSelectEmptyOption = !paginationPageSizeOption || !pageSizeOptions.includes(paginationPageSizeOption);
        if (shouldAddAndSelectEmptyOption) {
            pageSizeOptions.unshift("");
            warnOnce(`The paginationPageSize grid option is set to a value that is not in the list of page size options.
                Please make sure that the paginationPageSize grid option is set to one of the values in the 
                paginationPageSizeSelector array, or set the paginationPageSizeSelector to false to hide the page size selector.`);
        }
        if (this.selectPageSizeComp) {
            this.destroyBean(this.selectPageSizeComp);
            this.selectPageSizeComp = void 0;
        }
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        const localisedLabel = localeTextFunc("pageSizeSelectorLabel", "Page Size:");
        const options = pageSizeOptions.map((value)=>({
                value: String(value),
                text: String(value)
            }));
        const localisedAriaLabel = localeTextFunc("ariaPageSizeSelectorLabel", "Page Size");
        this.selectPageSizeComp = this.createManagedBean(new AgSelect()).addOptions(options).setValue(String(shouldAddAndSelectEmptyOption ? "" : paginationPageSizeOption)).setAriaLabel(localisedAriaLabel).setLabel(localisedLabel).onValueChange(()=>this.handlePageSizeItemSelected());
        this.hasEmptyOption = shouldAddAndSelectEmptyOption;
    }
    getPageSizeSelectorValues() {
        const defaultValues = [
            20,
            50,
            100
        ];
        const paginationPageSizeSelectorValues = this.gos.get("paginationPageSizeSelector");
        if (!Array.isArray(paginationPageSizeSelectorValues) || !this.validateValues(paginationPageSizeSelectorValues)) return defaultValues;
        return [
            ...paginationPageSizeSelectorValues
        ].sort((a, b)=>a - b);
    }
    validateValues(values2) {
        if (!values2.length) {
            warnOnce(`The paginationPageSizeSelector grid option is an empty array. This is most likely a mistake.
                If you want to hide the page size selector, please set the paginationPageSizeSelector to false.`);
            return false;
        }
        for(let i = 0; i < values2.length; i++){
            const value = values2[i];
            const isNumber = typeof value === "number";
            const isPositive = value > 0;
            if (!isNumber) {
                warnOnce(`The paginationPageSizeSelector grid option contains a non-numeric value.
                    Please make sure that all values in the paginationPageSizeSelector array are numbers.`);
                return false;
            }
            if (!isPositive) {
                warnOnce(`The paginationPageSizeSelector grid option contains a negative number or zero.
                    Please make sure that all values in the paginationPageSizeSelector array are positive.`);
                return false;
            }
        }
        return true;
    }
    destroy() {
        this.toggleSelectDisplay(false);
        super.destroy();
    }
};
__decorateClass([
    Autowired("paginationProxy")
], PageSizeSelectorComp.prototype, "paginationProxy", 2);
__decorateClass([
    PostConstruct
], PageSizeSelectorComp.prototype, "init", 1);
// community-modules/core/src/rendering/ariaAnnouncementService.ts
var AriaAnnouncementService = class extends BeanStub {
    constructor(){
        super();
        this.descriptionContainer = null;
        this.announceValue = debounce(this.announceValue.bind(this), 200);
    }
    postConstruct() {
        const eDocument = this.gos.getDocument();
        const div = this.descriptionContainer = eDocument.createElement("div");
        div.classList.add("ag-aria-description-container");
        setAriaLive(div, "polite");
        setAriaRelevant(div, "additions text");
        setAriaAtomic(div, true);
        this.eGridDiv.appendChild(div);
    }
    announceValue(value) {
        if (!this.descriptionContainer) return;
        this.descriptionContainer.textContent = "";
        setTimeout(()=>{
            if (this.isAlive() && this.descriptionContainer) this.descriptionContainer.textContent = value;
        }, 50);
    }
    destroy() {
        super.destroy();
        const { descriptionContainer } = this;
        if (descriptionContainer) {
            clearElement(descriptionContainer);
            if (descriptionContainer.parentElement) descriptionContainer.parentElement.removeChild(descriptionContainer);
        }
        this.descriptionContainer = null;
        this.eGridDiv = null;
    }
};
__decorateClass([
    Autowired("eGridDiv")
], AriaAnnouncementService.prototype, "eGridDiv", 2);
__decorateClass([
    PostConstruct
], AriaAnnouncementService.prototype, "postConstruct", 1);
AriaAnnouncementService = __decorateClass([
    Bean("ariaAnnouncementService")
], AriaAnnouncementService);
// community-modules/core/src/grid.ts
var GlobalGridOptions = class {
};
GlobalGridOptions.gridOptions = void 0;
function provideGlobalGridOptions(gridOptions) {
    GlobalGridOptions.gridOptions = gridOptions;
}
function createGrid(eGridDiv, gridOptions, params) {
    if (!gridOptions) {
        errorOnce("No gridOptions provided to createGrid");
        return {};
    }
    const api = new GridCoreCreator().create(eGridDiv, gridOptions, (context)=>{
        const gridComp = new GridComp(eGridDiv);
        context.createBean(gridComp);
    }, void 0, params);
    if (!Object.isFrozen(gridOptions) && !(params == null ? void 0 : params.frameworkOverrides)) {
        const apiUrl = "https://ag-grid.com/javascript-data-grid/grid-interface/#grid-api";
        Object.defineProperty(gridOptions, "api", {
            get: ()=>{
                errorOnce(`gridOptions.api is no longer supported. See ${apiUrl}.`);
                return void 0;
            },
            configurable: true
        });
        Object.defineProperty(gridOptions, "columnApi", {
            get: ()=>{
                errorOnce(`gridOptions.columnApi is no longer supported and all methods moved to the grid api. See ${apiUrl}.`);
                return void 0;
            },
            configurable: true
        });
    }
    return api;
}
var Grid = class {
    // Not typed to enable setting api / columnApi for backwards compatibility
    constructor(eGridDiv, gridOptions, params){
        warnOnce("Since v31 new Grid(...) is deprecated. Use createGrid instead: `const gridApi = createGrid(...)`. The grid api is returned from createGrid and will not be available on gridOptions.");
        if (!gridOptions) {
            errorOnce("No gridOptions provided to the grid");
            return;
        }
        this.gridOptions = gridOptions;
        const api = new GridCoreCreator().create(eGridDiv, gridOptions, (context)=>{
            const gridComp = new GridComp(eGridDiv);
            const bean = context.createBean(gridComp);
            bean.addDestroyFunc(()=>{
                this.destroy();
            });
        }, void 0, params);
        this.gridOptions.api = api;
        this.gridOptions.columnApi = new ColumnApi(api);
    }
    destroy() {
        var _a;
        if (this.gridOptions) {
            (_a = this.gridOptions.api) == null || _a.destroy();
            delete this.gridOptions.api;
            delete this.gridOptions.columnApi;
        }
    }
};
var nextGridId = 1;
var GridCoreCreator = class {
    create(eGridDiv, providedOptions, createUi, acceptChanges, params) {
        var _a;
        let mergedGridOps = {};
        if (GlobalGridOptions.gridOptions) {
            mergeDeep(mergedGridOps, GlobalGridOptions.gridOptions, true, true);
            mergedGridOps = __spreadValues(__spreadValues({}, mergedGridOps), providedOptions);
        } else mergedGridOps = providedOptions;
        const gridOptions = GridOptionsService.getCoercedGridOptions(mergedGridOps);
        const debug = !!gridOptions.debug;
        const gridId = (_a = gridOptions.gridId) != null ? _a : String(nextGridId++);
        const registeredModules = this.getRegisteredModules(params, gridId);
        const beanClasses = this.createBeansList(gridOptions.rowModelType, registeredModules, gridId);
        const providedBeanInstances = this.createProvidedBeans(eGridDiv, gridOptions, params);
        if (!beanClasses) {
            errorOnce("Failed to create grid.");
            return void 0;
        }
        const contextParams = {
            providedBeanInstances,
            beanClasses,
            debug,
            gridId
        };
        const contextLogger = new Logger("Context", ()=>contextParams.debug);
        const context = new Context(contextParams, contextLogger);
        const beans = context.getBean("beans");
        this.registerModuleUserComponents(beans, registeredModules);
        this.registerStackComponents(beans, registeredModules);
        this.registerControllers(beans, registeredModules);
        createUi(context);
        beans.syncService.start();
        if (acceptChanges) acceptChanges(context);
        const gridApi = context.getBean("gridApi");
        return gridApi;
    }
    registerControllers(beans, registeredModules) {
        registeredModules.forEach((module)=>{
            if (module.controllers) module.controllers.forEach((meta)=>beans.ctrlsFactory.register(meta));
        });
    }
    registerStackComponents(beans, registeredModules) {
        const agStackComponents = this.createAgStackComponentsList(registeredModules);
        beans.agStackComponentsRegistry.setupComponents(agStackComponents);
    }
    getRegisteredModules(params, gridId) {
        const passedViaConstructor = params ? params.modules : null;
        const registered = ModuleRegistry.__getRegisteredModules(gridId);
        const allModules = [];
        const mapNames = {};
        const addModule = (moduleBased, mod, gridId2)=>{
            const addIndividualModule = (currentModule)=>{
                if (!mapNames[currentModule.moduleName]) {
                    mapNames[currentModule.moduleName] = true;
                    allModules.push(currentModule);
                    ModuleRegistry.__register(currentModule, moduleBased, gridId2);
                }
            };
            addIndividualModule(mod);
            if (mod.dependantModules) mod.dependantModules.forEach((m)=>addModule(moduleBased, m, gridId2));
        };
        if (passedViaConstructor) passedViaConstructor.forEach((m)=>addModule(true, m, gridId));
        if (registered) registered.forEach((m)=>addModule(!ModuleRegistry.__isPackageBased(), m, void 0));
        return allModules;
    }
    registerModuleUserComponents(beans, registeredModules) {
        const moduleUserComps = this.extractModuleEntity(registeredModules, (module)=>module.userComponents ? module.userComponents : []);
        moduleUserComps.forEach((compMeta)=>{
            beans.userComponentRegistry.registerDefaultComponent(compMeta.componentName, compMeta.componentClass);
        });
    }
    createProvidedBeans(eGridDiv, gridOptions, params) {
        let frameworkOverrides = params ? params.frameworkOverrides : null;
        if (missing(frameworkOverrides)) frameworkOverrides = new VanillaFrameworkOverrides();
        const seed = {
            gridOptions,
            eGridDiv,
            globalEventListener: params ? params.globalEventListener : null,
            globalSyncEventListener: params ? params.globalSyncEventListener : null,
            frameworkOverrides
        };
        if (params && params.providedBeanInstances) Object.assign(seed, params.providedBeanInstances);
        return seed;
    }
    createAgStackComponentsList(registeredModules) {
        let components = [
            {
                componentName: "AgCheckbox",
                componentClass: AgCheckbox
            },
            {
                componentName: "AgRadioButton",
                componentClass: AgRadioButton
            },
            {
                componentName: "AgToggleButton",
                componentClass: AgToggleButton
            },
            {
                componentName: "AgInputTextField",
                componentClass: AgInputTextField
            },
            {
                componentName: "AgInputTextArea",
                componentClass: AgInputTextArea
            },
            {
                componentName: "AgInputNumberField",
                componentClass: AgInputNumberField
            },
            {
                componentName: "AgInputDateField",
                componentClass: AgInputDateField
            },
            {
                componentName: "AgInputRange",
                componentClass: AgInputRange
            },
            {
                componentName: "AgRichSelect",
                componentClass: AgRichSelect
            },
            {
                componentName: "AgSelect",
                componentClass: AgSelect
            },
            {
                componentName: "AgSlider",
                componentClass: AgSlider
            },
            {
                componentName: "AgGridBody",
                componentClass: GridBodyComp
            },
            {
                componentName: "AgHeaderRoot",
                componentClass: GridHeaderComp
            },
            {
                componentName: "AgSortIndicator",
                componentClass: SortIndicatorComp
            },
            {
                componentName: "AgPagination",
                componentClass: PaginationComp
            },
            {
                componentName: "AgPageSizeSelector",
                componentClass: PageSizeSelectorComp
            },
            {
                componentName: "AgOverlayWrapper",
                componentClass: OverlayWrapperComponent
            },
            {
                componentName: "AgGroupComponent",
                componentClass: AgGroupComponent
            },
            {
                componentName: "AgRowContainer",
                componentClass: RowContainerComp
            },
            {
                componentName: "AgFakeHorizontalScroll",
                componentClass: FakeHScrollComp
            },
            {
                componentName: "AgFakeVerticalScroll",
                componentClass: FakeVScrollComp
            },
            {
                componentName: "AgAutocomplete",
                componentClass: AgAutocomplete
            }
        ];
        const moduleAgStackComps = this.extractModuleEntity(registeredModules, (module)=>module.agStackComponents ? module.agStackComponents : []);
        components = components.concat(moduleAgStackComps);
        return components;
    }
    createBeansList(rowModelType = "clientSide", registeredModules, gridId) {
        const rowModelModules = registeredModules.filter((module)=>!module.rowModel || module.rowModel === rowModelType);
        const rowModelModuleNames = {
            clientSide: "@ag-grid-community/client-side-row-model" /* ClientSideRowModelModule */ ,
            infinite: "@ag-grid-community/infinite-row-model" /* InfiniteRowModelModule */ ,
            serverSide: "@ag-grid-enterprise/server-side-row-model" /* ServerSideRowModelModule */ ,
            viewport: "@ag-grid-enterprise/viewport-row-model" /* ViewportRowModelModule */ 
        };
        if (!rowModelModuleNames[rowModelType]) {
            errorOnce("Could not find row model for rowModelType = " + rowModelType);
            return;
        }
        if (!ModuleRegistry.__assertRegistered(rowModelModuleNames[rowModelType], `rowModelType = '${rowModelType}'`, gridId)) return;
        const beans = [
            Beans,
            RowPositionUtils,
            CellPositionUtils,
            HeaderPositionUtils,
            PaginationAutoPageSizeService,
            GridApi,
            UserComponentRegistry,
            AgComponentUtils,
            ComponentMetadataProvider,
            ResizeObserverService,
            UserComponentFactory,
            RowContainerHeightService,
            HorizontalResizeService,
            LocaleService,
            ValidationService,
            PinnedRowModel,
            DragService,
            DisplayedGroupCreator,
            EventService,
            GridOptionsService,
            PopupService,
            SelectionService,
            FilterManager,
            ColumnModel,
            HeaderNavigationService,
            PaginationProxy,
            RowRenderer,
            ExpressionService,
            ColumnFactory,
            AlignedGridsService,
            NavigationService,
            ValueCache,
            ValueService,
            LoggerFactory,
            AutoWidthCalculator,
            StandardMenuFactory,
            DragAndDropService,
            ColumnApi,
            FocusService,
            MouseEventService,
            Environment,
            CellNavigationService,
            StylingService,
            ScrollVisibleService,
            SortController,
            ColumnHoverService,
            ColumnAnimationService,
            SelectableService,
            AutoGroupColService,
            ChangeDetectionService,
            AnimationFrameService,
            UndoRedoService,
            AgStackComponentsRegistry,
            ColumnDefFactory,
            RowCssClassCalculator,
            RowNodeBlockLoader,
            RowNodeSorter,
            CtrlsService,
            PinnedWidthService,
            RowNodeEventThrottle,
            CtrlsFactory,
            DataTypeService,
            QuickFilterService,
            SyncService,
            OverlayService,
            StateService,
            ExpansionService,
            ApiEventService,
            AriaAnnouncementService,
            MenuService
        ];
        const moduleBeans = this.extractModuleEntity(rowModelModules, (module)=>module.beans ? module.beans : []);
        beans.push(...moduleBeans);
        const beansNoDuplicates = [];
        beans.forEach((bean)=>{
            if (beansNoDuplicates.indexOf(bean) < 0) beansNoDuplicates.push(bean);
        });
        return beansNoDuplicates;
    }
    extractModuleEntity(moduleEntities, extractor) {
        return [].concat(...moduleEntities.map(extractor));
    }
};
// community-modules/core/src/components/framework/frameworkComponentWrapper.ts
var BaseComponentWrapper = class {
    wrap(OriginalConstructor, mandatoryMethodList, optionalMethodList = [], componentType) {
        const wrapper = this.createWrapper(OriginalConstructor, componentType);
        mandatoryMethodList.forEach((methodName)=>{
            this.createMethod(wrapper, methodName, true);
        });
        optionalMethodList.forEach((methodName)=>{
            this.createMethod(wrapper, methodName, false);
        });
        return wrapper;
    }
    unwrap(comp) {
        return comp;
    }
    createMethod(wrapper, methodName, mandatory) {
        wrapper.addMethod(methodName, this.createMethodProxy(wrapper, methodName, mandatory));
    }
    createMethodProxy(wrapper, methodName, mandatory) {
        return function() {
            if (wrapper.hasMethod(methodName)) return wrapper.callMethod(methodName, arguments);
            if (mandatory) console.warn("AG Grid: Framework component is missing the method " + methodName + "()");
            return null;
        };
    }
};
// community-modules/core/src/interfaces/iChartOptions.ts
var ChartMappings = class {
};
ChartMappings.CHART_TYPE_TO_SERIES_TYPE = {
    column: "bar",
    groupedColumn: "bar",
    stackedColumn: "bar",
    normalizedColumn: "bar",
    bar: "bar",
    groupedBar: "bar",
    stackedBar: "bar",
    normalizedBar: "bar",
    line: "line",
    scatter: "scatter",
    bubble: "bubble",
    pie: "pie",
    donut: "donut",
    doughnut: "donut",
    area: "area",
    stackedArea: "area",
    normalizedArea: "area",
    histogram: "histogram",
    radarLine: "radar-line",
    radarArea: "radar-area",
    nightingale: "nightingale",
    radialColumn: "radial-column",
    radialBar: "radial-bar",
    sunburst: "sunburst",
    rangeBar: "range-bar",
    rangeArea: "range-area",
    boxPlot: "box-plot",
    treemap: "treemap",
    heatmap: "heatmap",
    waterfall: "waterfall"
};
ChartMappings.COMBO_CHART_TYPES = [
    "columnLineCombo",
    "areaColumnCombo",
    "customCombo"
];
ChartMappings.SERIES_GROUP_TYPES = [
    "grouped",
    "stacked",
    "normalized"
];
// community-modules/core/src/interfaces/iSparklineCellRendererParams.ts
var BarColumnLabelPlacement = /* @__PURE__ */ ((BarColumnLabelPlacement2)=>{
    BarColumnLabelPlacement2["InsideBase"] = "insideBase";
    BarColumnLabelPlacement2["InsideEnd"] = "insideEnd";
    BarColumnLabelPlacement2["Center"] = "center";
    BarColumnLabelPlacement2["OutsideEnd"] = "outsideEnd";
    return BarColumnLabelPlacement2;
})(BarColumnLabelPlacement || {});
// community-modules/core/src/main.ts
var globalObj = typeof global === "undefined" ? {} : global;
globalObj.HTMLElement = typeof HTMLElement === "undefined" ? {} : HTMLElement;
globalObj.HTMLButtonElement = typeof HTMLButtonElement === "undefined" ? {} : HTMLButtonElement;
globalObj.HTMLSelectElement = typeof HTMLSelectElement === "undefined" ? {} : HTMLSelectElement;
globalObj.HTMLInputElement = typeof HTMLInputElement === "undefined" ? {} : HTMLInputElement;
globalObj.Node = typeof Node === "undefined" ? {} : Node;
globalObj.MouseEvent = typeof MouseEvent === "undefined" ? {} : MouseEvent;
// community-modules/client-side-row-model/src/clientSideRowModel/clientSideNodeManager.ts
var _ClientSideNodeManager = class _ClientSideNodeManager {
    constructor(rootNode, gos, eventService, columnModel, selectionService, beans){
        this.nextId = 0;
        // has row data actually been set
        this.rowCountReady = false;
        // when user is provide the id's, we also keep a map of ids to row nodes for convenience
        this.allNodesMap = {};
        this.rootNode = rootNode;
        this.gos = gos;
        this.eventService = eventService;
        this.columnModel = columnModel;
        this.beans = beans;
        this.selectionService = selectionService;
        this.rootNode.group = true;
        this.rootNode.level = -1;
        this.rootNode.id = _ClientSideNodeManager.ROOT_NODE_ID;
        this.rootNode.allLeafChildren = [];
        this.rootNode.childrenAfterGroup = [];
        this.rootNode.childrenAfterSort = [];
        this.rootNode.childrenAfterAggFilter = [];
        this.rootNode.childrenAfterFilter = [];
    }
    getCopyOfNodesMap() {
        return _.cloneObject(this.allNodesMap);
    }
    getRowNode(id) {
        return this.allNodesMap[id];
    }
    setRowData(rowData) {
        if (typeof rowData === "string") {
            console.warn("AG Grid: rowData must be an array.");
            return;
        }
        this.rowCountReady = true;
        this.dispatchRowDataUpdateStartedEvent(rowData);
        const rootNode = this.rootNode;
        const sibling = this.rootNode.sibling;
        rootNode.childrenAfterFilter = null;
        rootNode.childrenAfterGroup = null;
        rootNode.childrenAfterAggFilter = null;
        rootNode.childrenAfterSort = null;
        rootNode.childrenMapped = null;
        rootNode.updateHasChildren();
        this.nextId = 0;
        this.allNodesMap = {};
        if (rowData) rootNode.allLeafChildren = rowData.map((dataItem)=>this.createNode(dataItem, this.rootNode, _ClientSideNodeManager.TOP_LEVEL));
        else {
            rootNode.allLeafChildren = [];
            rootNode.childrenAfterGroup = [];
        }
        if (sibling) {
            sibling.childrenAfterFilter = rootNode.childrenAfterFilter;
            sibling.childrenAfterGroup = rootNode.childrenAfterGroup;
            sibling.childrenAfterAggFilter = rootNode.childrenAfterAggFilter;
            sibling.childrenAfterSort = rootNode.childrenAfterSort;
            sibling.childrenMapped = rootNode.childrenMapped;
            sibling.allLeafChildren = rootNode.allLeafChildren;
        }
    }
    updateRowData(rowDataTran, rowNodeOrder) {
        this.rowCountReady = true;
        this.dispatchRowDataUpdateStartedEvent(rowDataTran.add);
        const rowNodeTransaction = {
            remove: [],
            update: [],
            add: []
        };
        const nodesToUnselect = [];
        this.executeRemove(rowDataTran, rowNodeTransaction, nodesToUnselect);
        this.executeUpdate(rowDataTran, rowNodeTransaction, nodesToUnselect);
        this.executeAdd(rowDataTran, rowNodeTransaction);
        this.updateSelection(nodesToUnselect, "rowDataChanged");
        if (rowNodeOrder) _.sortRowNodesByOrder(this.rootNode.allLeafChildren, rowNodeOrder);
        return rowNodeTransaction;
    }
    isRowCountReady() {
        return this.rowCountReady;
    }
    dispatchRowDataUpdateStartedEvent(rowData) {
        const event = {
            type: Events.EVENT_ROW_DATA_UPDATE_STARTED,
            firstRowData: (rowData == null ? void 0 : rowData.length) ? rowData[0] : null
        };
        this.eventService.dispatchEvent(event);
    }
    updateSelection(nodesToUnselect, source) {
        const selectionChanged = nodesToUnselect.length > 0;
        if (selectionChanged) this.selectionService.setNodesSelected({
            newValue: false,
            nodes: nodesToUnselect,
            suppressFinishActions: true,
            source
        });
        this.selectionService.updateGroupsFromChildrenSelections(source);
        if (selectionChanged) {
            const event = {
                type: Events.EVENT_SELECTION_CHANGED,
                source
            };
            this.eventService.dispatchEvent(event);
        }
    }
    executeAdd(rowDataTran, rowNodeTransaction) {
        var _a;
        const { add, addIndex } = rowDataTran;
        if (_.missingOrEmpty(add)) return;
        const newNodes = add.map((item)=>this.createNode(item, this.rootNode, _ClientSideNodeManager.TOP_LEVEL));
        if (typeof addIndex === "number" && addIndex >= 0) {
            const { allLeafChildren } = this.rootNode;
            const len = allLeafChildren.length;
            let normalisedAddIndex = addIndex;
            const isTreeData = this.gos.get("treeData");
            if (isTreeData && addIndex > 0 && len > 0) {
                for(let i = 0; i < len; i++)if (((_a = allLeafChildren[i]) == null ? void 0 : _a.rowIndex) == addIndex - 1) {
                    normalisedAddIndex = i + 1;
                    break;
                }
            }
            const nodesBeforeIndex = allLeafChildren.slice(0, normalisedAddIndex);
            const nodesAfterIndex = allLeafChildren.slice(normalisedAddIndex, allLeafChildren.length);
            this.rootNode.allLeafChildren = [
                ...nodesBeforeIndex,
                ...newNodes,
                ...nodesAfterIndex
            ];
        } else this.rootNode.allLeafChildren = [
            ...this.rootNode.allLeafChildren,
            ...newNodes
        ];
        if (this.rootNode.sibling) this.rootNode.sibling.allLeafChildren = this.rootNode.allLeafChildren;
        rowNodeTransaction.add = newNodes;
    }
    executeRemove(rowDataTran, rowNodeTransaction, nodesToUnselect) {
        const { remove } = rowDataTran;
        if (_.missingOrEmpty(remove)) return;
        const rowIdsRemoved = {};
        remove.forEach((item)=>{
            const rowNode = this.lookupRowNode(item);
            if (!rowNode) return;
            if (rowNode.isSelected()) nodesToUnselect.push(rowNode);
            rowNode.clearRowTopAndRowIndex();
            rowIdsRemoved[rowNode.id] = true;
            delete this.allNodesMap[rowNode.id];
            rowNodeTransaction.remove.push(rowNode);
        });
        this.rootNode.allLeafChildren = this.rootNode.allLeafChildren.filter((rowNode)=>!rowIdsRemoved[rowNode.id]);
        if (this.rootNode.sibling) this.rootNode.sibling.allLeafChildren = this.rootNode.allLeafChildren;
    }
    executeUpdate(rowDataTran, rowNodeTransaction, nodesToUnselect) {
        const { update } = rowDataTran;
        if (_.missingOrEmpty(update)) return;
        update.forEach((item)=>{
            const rowNode = this.lookupRowNode(item);
            if (!rowNode) return;
            rowNode.updateData(item);
            if (!rowNode.selectable && rowNode.isSelected()) nodesToUnselect.push(rowNode);
            this.setMasterForRow(rowNode, item, _ClientSideNodeManager.TOP_LEVEL, false);
            rowNodeTransaction.update.push(rowNode);
        });
    }
    lookupRowNode(data) {
        const getRowIdFunc = this.gos.getCallback("getRowId");
        let rowNode;
        if (getRowIdFunc) {
            const id = getRowIdFunc({
                data,
                level: 0
            });
            rowNode = this.allNodesMap[id];
            if (!rowNode) {
                console.error(`AG Grid: could not find row id=${id}, data item was not found for this id`);
                return null;
            }
        } else {
            rowNode = this.rootNode.allLeafChildren.find((node)=>node.data === data);
            if (!rowNode) {
                console.error(`AG Grid: could not find data item as object was not found`, data);
                console.error(`Consider using getRowId to help the Grid find matching row data`);
                return null;
            }
        }
        return rowNode || null;
    }
    createNode(dataItem, parent, level) {
        const node = new RowNode(this.beans);
        node.group = false;
        this.setMasterForRow(node, dataItem, level, true);
        const suppressParentsInRowNodes = this.gos.get("suppressParentsInRowNodes");
        if (parent && !suppressParentsInRowNodes) node.parent = parent;
        node.level = level;
        node.setDataAndId(dataItem, this.nextId.toString());
        if (this.allNodesMap[node.id]) console.warn(`AG Grid: duplicate node id '${node.id}' detected from getRowId callback, this could cause issues in your grid.`);
        this.allNodesMap[node.id] = node;
        this.nextId++;
        return node;
    }
    setMasterForRow(rowNode, data, level, setExpanded) {
        const isTreeData = this.gos.get("treeData");
        if (isTreeData) {
            rowNode.setMaster(false);
            if (setExpanded) rowNode.expanded = false;
        } else {
            const masterDetail = this.gos.get("masterDetail");
            if (masterDetail) {
                const isRowMasterFunc = this.gos.get("isRowMaster");
                if (isRowMasterFunc) rowNode.setMaster(isRowMasterFunc(data));
                else rowNode.setMaster(true);
            } else rowNode.setMaster(false);
            if (setExpanded) {
                const rowGroupColumns = this.columnModel.getRowGroupColumns();
                const numRowGroupColumns = rowGroupColumns ? rowGroupColumns.length : 0;
                const masterRowLevel = level + numRowGroupColumns;
                rowNode.expanded = rowNode.master ? this.isExpanded(masterRowLevel) : false;
            }
        }
    }
    isExpanded(level) {
        const expandByDefault = this.gos.get("groupDefaultExpanded");
        if (expandByDefault === -1) return true;
        return level < expandByDefault;
    }
};
_ClientSideNodeManager.TOP_LEVEL = 0;
_ClientSideNodeManager.ROOT_NODE_ID = "ROOT_NODE_ID";
var ClientSideNodeManager = _ClientSideNodeManager;
// community-modules/client-side-row-model/src/clientSideRowModel/clientSideRowModel.ts
var ClientSideRowModel = class extends BeanStub {
    constructor(){
        super(...arguments);
        this.onRowHeightChanged_debounced = _.debounce(this.onRowHeightChanged.bind(this), 100);
        this.rowsToDisplay = [];
        /** Has the start method been called */ this.hasStarted = false;
        /** E.g. data has been set into the node manager already */ this.shouldSkipSettingDataOnStart = false;
        /**
     * This is to prevent refresh model being called when it's already being called.
     * E.g. the group stage can trigger initial state filter model to be applied. This fires onFilterChanged,
     * which then triggers the listener here that calls refresh model again but at the filter stage
     * (which is about to be run by the original call).
     */ this.isRefreshingModel = false;
        this.rowCountReady = false;
    }
    init() {
        const refreshEverythingFunc = this.refreshModel.bind(this, {
            step: "group" /* EVERYTHING */ 
        });
        const animate = !this.gos.get("suppressAnimationFrame");
        const refreshEverythingAfterColsChangedFunc = this.refreshModel.bind(this, {
            step: "group" /* EVERYTHING */ ,
            // after cols change, row grouping (the first stage) could of changed
            afterColumnsChanged: true,
            keepRenderedRows: true,
            // we want animations cos sorting or filtering could be applied
            animate
        });
        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, refreshEverythingAfterColsChangedFunc);
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, refreshEverythingFunc);
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_VALUE_CHANGED, this.onValueChanged.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_CHANGED, this.refreshModel.bind(this, {
            step: "pivot" /* PIVOT */ 
        }));
        this.addManagedListener(this.eventService, Events.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, refreshEverythingFunc);
        this.addManagedListener(this.eventService, Events.EVENT_GRID_STYLES_CHANGED, this.onGridStylesChanges.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_GRID_READY, ()=>this.onGridReady());
        this.addPropertyListeners();
        this.rootNode = new RowNode(this.beans);
        this.nodeManager = new ClientSideNodeManager(this.rootNode, this.gos, this.eventService, this.columnModel, this.selectionService, this.beans);
    }
    addPropertyListeners() {
        const resetProps = /* @__PURE__ */ new Set([
            "treeData",
            "masterDetail"
        ]);
        const groupStageRefreshProps = /* @__PURE__ */ new Set([
            "suppressParentsInRowNodes",
            "groupDefaultExpanded",
            "groupAllowUnbalanced",
            "initialGroupOrderComparator",
            "groupHideOpenParents",
            "groupDisplayType"
        ]);
        const filterStageRefreshProps = /* @__PURE__ */ new Set([
            "excludeChildrenWhenTreeDataFiltering"
        ]);
        const pivotStageRefreshProps = /* @__PURE__ */ new Set([
            "removePivotHeaderRowWhenSingleValueColumn",
            "pivotRowTotals",
            "pivotColumnGroupTotals",
            "suppressExpandablePivotGroups"
        ]);
        const aggregateStageRefreshProps = /* @__PURE__ */ new Set([
            "getGroupRowAgg",
            "alwaysAggregateAtRootLevel",
            "groupIncludeTotalFooter",
            "suppressAggFilteredOnly",
            "grandTotalRow"
        ]);
        const sortStageRefreshProps = /* @__PURE__ */ new Set([
            "postSortRows",
            "groupDisplayType",
            "accentedSort"
        ]);
        const filterAggStageRefreshProps = /* @__PURE__ */ new Set([]);
        const flattenStageRefreshProps = /* @__PURE__ */ new Set([
            "groupRemoveSingleChildren",
            "groupRemoveLowestSingleChildren",
            "groupIncludeFooter",
            "groupTotalRow"
        ]);
        const allProps = [
            ...resetProps,
            ...groupStageRefreshProps,
            ...filterStageRefreshProps,
            ...pivotStageRefreshProps,
            ...pivotStageRefreshProps,
            ...aggregateStageRefreshProps,
            ...sortStageRefreshProps,
            ...filterAggStageRefreshProps,
            ...flattenStageRefreshProps
        ];
        this.addManagedPropertyListeners(allProps, (params)=>{
            var _a;
            const properties = (_a = params.changeSet) == null ? void 0 : _a.properties;
            if (!properties) return;
            const arePropertiesImpacted = (propSet)=>properties.some((prop)=>propSet.has(prop));
            if (arePropertiesImpacted(resetProps)) {
                this.setRowData(this.rootNode.allLeafChildren.map((child)=>child.data));
                return;
            }
            if (arePropertiesImpacted(groupStageRefreshProps)) {
                this.refreshModel({
                    step: "group" /* EVERYTHING */ 
                });
                return;
            }
            if (arePropertiesImpacted(filterStageRefreshProps)) {
                this.refreshModel({
                    step: "filter" /* FILTER */ 
                });
                return;
            }
            if (arePropertiesImpacted(pivotStageRefreshProps)) {
                this.refreshModel({
                    step: "pivot" /* PIVOT */ 
                });
                return;
            }
            if (arePropertiesImpacted(aggregateStageRefreshProps)) {
                this.refreshModel({
                    step: "aggregate" /* AGGREGATE */ 
                });
                return;
            }
            if (arePropertiesImpacted(sortStageRefreshProps)) {
                this.refreshModel({
                    step: "sort" /* SORT */ 
                });
                return;
            }
            if (arePropertiesImpacted(filterAggStageRefreshProps)) {
                this.refreshModel({
                    step: "filter_aggregates" /* FILTER_AGGREGATES */ 
                });
                return;
            }
            if (arePropertiesImpacted(flattenStageRefreshProps)) this.refreshModel({
                step: "map" /* MAP */ 
            });
        });
        this.addManagedPropertyListener("rowHeight", ()=>this.resetRowHeights());
    }
    start() {
        this.hasStarted = true;
        if (this.shouldSkipSettingDataOnStart) this.dispatchUpdateEventsAndRefresh();
        else this.setInitialData();
    }
    setInitialData() {
        const rowData = this.gos.get("rowData");
        if (rowData) {
            this.shouldSkipSettingDataOnStart = true;
            this.setRowData(rowData);
        }
    }
    ensureRowHeightsValid(startPixel, endPixel, startLimitIndex, endLimitIndex) {
        let atLeastOneChange;
        let res = false;
        do {
            atLeastOneChange = false;
            const rowAtStartPixel = this.getRowIndexAtPixel(startPixel);
            const rowAtEndPixel = this.getRowIndexAtPixel(endPixel);
            const firstRow = Math.max(rowAtStartPixel, startLimitIndex);
            const lastRow = Math.min(rowAtEndPixel, endLimitIndex);
            for(let rowIndex = firstRow; rowIndex <= lastRow; rowIndex++){
                const rowNode = this.getRow(rowIndex);
                if (rowNode.rowHeightEstimated) {
                    const rowHeight = this.gos.getRowHeightForNode(rowNode);
                    rowNode.setRowHeight(rowHeight.height);
                    atLeastOneChange = true;
                    res = true;
                }
            }
            if (atLeastOneChange) this.setRowTopAndRowIndex();
        }while (atLeastOneChange);
        return res;
    }
    setRowTopAndRowIndex() {
        const defaultRowHeight = this.environment.getDefaultRowHeight();
        let nextRowTop = 0;
        const displayedRowsMapped = /* @__PURE__ */ new Set();
        const allowEstimate = this.gos.isDomLayout("normal");
        for(let i = 0; i < this.rowsToDisplay.length; i++){
            const rowNode = this.rowsToDisplay[i];
            if (rowNode.id != null) displayedRowsMapped.add(rowNode.id);
            if (rowNode.rowHeight == null) {
                const rowHeight = this.gos.getRowHeightForNode(rowNode, allowEstimate, defaultRowHeight);
                rowNode.setRowHeight(rowHeight.height, rowHeight.estimated);
            }
            rowNode.setRowTop(nextRowTop);
            rowNode.setRowIndex(i);
            nextRowTop += rowNode.rowHeight;
        }
        return displayedRowsMapped;
    }
    clearRowTopAndRowIndex(changedPath, displayedRowsMapped) {
        const changedPathActive = changedPath.isActive();
        const clearIfNotDisplayed = (rowNode)=>{
            if (rowNode && rowNode.id != null && !displayedRowsMapped.has(rowNode.id)) rowNode.clearRowTopAndRowIndex();
        };
        const recurse = (rowNode)=>{
            clearIfNotDisplayed(rowNode);
            clearIfNotDisplayed(rowNode.detailNode);
            clearIfNotDisplayed(rowNode.sibling);
            if (rowNode.hasChildren()) {
                if (rowNode.childrenAfterGroup) {
                    const isRootNode = rowNode.level == -1;
                    const skipChildren = changedPathActive && !isRootNode && !rowNode.expanded;
                    if (!skipChildren) rowNode.childrenAfterGroup.forEach(recurse);
                }
            }
        };
        recurse(this.rootNode);
    }
    // returns false if row was moved, otherwise true
    ensureRowsAtPixel(rowNodes, pixel, increment = 0) {
        const indexAtPixelNow = this.getRowIndexAtPixel(pixel);
        const rowNodeAtPixelNow = this.getRow(indexAtPixelNow);
        const animate = !this.gos.get("suppressAnimationFrame");
        if (rowNodeAtPixelNow === rowNodes[0]) return false;
        rowNodes.forEach((rowNode)=>{
            _.removeFromArray(this.rootNode.allLeafChildren, rowNode);
        });
        rowNodes.forEach((rowNode, idx)=>{
            _.insertIntoArray(this.rootNode.allLeafChildren, rowNode, Math.max(indexAtPixelNow + increment, 0) + idx);
        });
        this.refreshModel({
            step: "group" /* EVERYTHING */ ,
            keepRenderedRows: true,
            keepEditingRows: true,
            animate
        });
        return true;
    }
    highlightRowAtPixel(rowNode, pixel) {
        const indexAtPixelNow = pixel != null ? this.getRowIndexAtPixel(pixel) : null;
        const rowNodeAtPixelNow = indexAtPixelNow != null ? this.getRow(indexAtPixelNow) : null;
        if (!rowNodeAtPixelNow || !rowNode || rowNodeAtPixelNow === rowNode || pixel == null) {
            if (this.lastHighlightedRow) {
                this.lastHighlightedRow.setHighlighted(null);
                this.lastHighlightedRow = null;
            }
            return;
        }
        const highlight = this.getHighlightPosition(pixel, rowNodeAtPixelNow);
        if (this.lastHighlightedRow && this.lastHighlightedRow !== rowNodeAtPixelNow) {
            this.lastHighlightedRow.setHighlighted(null);
            this.lastHighlightedRow = null;
        }
        rowNodeAtPixelNow.setHighlighted(highlight);
        this.lastHighlightedRow = rowNodeAtPixelNow;
    }
    getHighlightPosition(pixel, rowNode) {
        if (!rowNode) {
            const index = this.getRowIndexAtPixel(pixel);
            rowNode = this.getRow(index || 0);
            if (!rowNode) return 1 /* Below */ ;
        }
        const { rowTop, rowHeight } = rowNode;
        return pixel - rowTop < rowHeight / 2 ? 0 /* Above */  : 1 /* Below */ ;
    }
    getLastHighlightedRowNode() {
        return this.lastHighlightedRow;
    }
    isLastRowIndexKnown() {
        return true;
    }
    getRowCount() {
        if (this.rowsToDisplay) return this.rowsToDisplay.length;
        return 0;
    }
    getTopLevelRowCount() {
        const showingRootNode = this.rowsToDisplay && this.rowsToDisplay[0] === this.rootNode;
        if (showingRootNode) return 1;
        const filteredChildren = this.rootNode.childrenAfterAggFilter;
        return filteredChildren ? filteredChildren.length : 0;
    }
    getTopLevelRowDisplayedIndex(topLevelIndex) {
        const showingRootNode = this.rowsToDisplay && this.rowsToDisplay[0] === this.rootNode;
        if (showingRootNode) return topLevelIndex;
        let rowNode = this.rootNode.childrenAfterSort[topLevelIndex];
        if (this.gos.get("groupHideOpenParents")) while(rowNode.expanded && rowNode.childrenAfterSort && rowNode.childrenAfterSort.length > 0)rowNode = rowNode.childrenAfterSort[0];
        return rowNode.rowIndex;
    }
    getRowBounds(index) {
        if (_.missing(this.rowsToDisplay)) return null;
        const rowNode = this.rowsToDisplay[index];
        if (rowNode) return {
            rowTop: rowNode.rowTop,
            rowHeight: rowNode.rowHeight
        };
        return null;
    }
    onRowGroupOpened() {
        const animate = this.gos.isAnimateRows();
        this.refreshModel({
            step: "map" /* MAP */ ,
            keepRenderedRows: true,
            animate
        });
    }
    onFilterChanged(event) {
        if (event.afterDataChange) return;
        const animate = this.gos.isAnimateRows();
        const primaryOrQuickFilterChanged = event.columns.length === 0 || event.columns.some((col)=>col.isPrimary());
        const step = primaryOrQuickFilterChanged ? "filter" /* FILTER */  : "filter_aggregates" /* FILTER_AGGREGATES */ ;
        this.refreshModel({
            step,
            keepRenderedRows: true,
            animate
        });
    }
    onSortChanged() {
        const animate = this.gos.isAnimateRows();
        this.refreshModel({
            step: "sort" /* SORT */ ,
            keepRenderedRows: true,
            animate,
            keepEditingRows: true
        });
    }
    getType() {
        return "clientSide";
    }
    onValueChanged() {
        if (this.columnModel.isPivotActive()) this.refreshModel({
            step: "pivot" /* PIVOT */ 
        });
        else this.refreshModel({
            step: "aggregate" /* AGGREGATE */ 
        });
    }
    createChangePath(rowNodeTransactions) {
        const noTransactions = _.missingOrEmpty(rowNodeTransactions);
        const changedPath = new ChangedPath(false, this.rootNode);
        if (noTransactions || this.gos.get("treeData")) changedPath.setInactive();
        return changedPath;
    }
    isSuppressModelUpdateAfterUpdateTransaction(params) {
        if (!this.gos.get("suppressModelUpdateAfterUpdateTransaction")) return false;
        if (params.rowNodeTransactions == null) return false;
        const transWithAddsOrDeletes = params.rowNodeTransactions.filter((tx)=>tx.add != null && tx.add.length > 0 || tx.remove != null && tx.remove.length > 0);
        const transactionsContainUpdatesOnly = transWithAddsOrDeletes == null || transWithAddsOrDeletes.length == 0;
        return transactionsContainUpdatesOnly;
    }
    buildRefreshModelParams(step) {
        let paramsStep = "group" /* EVERYTHING */ ;
        const stepsMapped = {
            everything: "group" /* EVERYTHING */ ,
            group: "group" /* EVERYTHING */ ,
            filter: "filter" /* FILTER */ ,
            map: "map" /* MAP */ ,
            aggregate: "aggregate" /* AGGREGATE */ ,
            sort: "sort" /* SORT */ ,
            pivot: "pivot" /* PIVOT */ 
        };
        if (_.exists(step)) paramsStep = stepsMapped[step];
        if (_.missing(paramsStep)) {
            console.error(`AG Grid: invalid step ${step}, available steps are ${Object.keys(stepsMapped).join(", ")}`);
            return void 0;
        }
        const animate = !this.gos.get("suppressAnimationFrame");
        const modelParams = {
            step: paramsStep,
            keepRenderedRows: true,
            keepEditingRows: true,
            animate
        };
        return modelParams;
    }
    refreshModel(paramsOrStep) {
        if (!this.hasStarted || this.isRefreshingModel || this.columnModel.shouldRowModelIgnoreRefresh()) return;
        let params = typeof paramsOrStep === "object" && "step" in paramsOrStep ? paramsOrStep : this.buildRefreshModelParams(paramsOrStep);
        if (!params) return;
        if (this.isSuppressModelUpdateAfterUpdateTransaction(params)) return;
        const changedPath = this.createChangePath(params.rowNodeTransactions);
        this.isRefreshingModel = true;
        switch(params.step){
            case "group" /* EVERYTHING */ :
                this.doRowGrouping(params.rowNodeTransactions, params.rowNodeOrder, changedPath, !!params.afterColumnsChanged);
            case "filter" /* FILTER */ :
                this.doFilter(changedPath);
            case "pivot" /* PIVOT */ :
                this.doPivot(changedPath);
            case "aggregate" /* AGGREGATE */ :
                this.doAggregate(changedPath);
            case "filter_aggregates" /* FILTER_AGGREGATES */ :
                this.doFilterAggregates(changedPath);
            case "sort" /* SORT */ :
                this.doSort(params.rowNodeTransactions, changedPath);
            case "map" /* MAP */ :
                this.doRowsToDisplay();
        }
        const displayedNodesMapped = this.setRowTopAndRowIndex();
        this.clearRowTopAndRowIndex(changedPath, displayedNodesMapped);
        this.isRefreshingModel = false;
        const event = {
            type: Events.EVENT_MODEL_UPDATED,
            animate: params.animate,
            keepRenderedRows: params.keepRenderedRows,
            newData: params.newData,
            newPage: false,
            keepUndoRedoStack: params.keepUndoRedoStack
        };
        this.eventService.dispatchEvent(event);
    }
    isEmpty() {
        const rowsMissing = _.missing(this.rootNode.allLeafChildren) || this.rootNode.allLeafChildren.length === 0;
        return _.missing(this.rootNode) || rowsMissing || !this.columnModel.isReady();
    }
    isRowsToRender() {
        return _.exists(this.rowsToDisplay) && this.rowsToDisplay.length > 0;
    }
    getNodesInRangeForSelection(firstInRange, lastInRange) {
        let started = !lastInRange;
        let finished = false;
        const result = [];
        const groupsSelectChildren = this.gos.get("groupSelectsChildren");
        this.forEachNodeAfterFilterAndSort((rowNode)=>{
            if (finished) return;
            if (started) {
                if (rowNode === lastInRange || rowNode === firstInRange) {
                    finished = true;
                    if (rowNode.group && groupsSelectChildren) {
                        result.push(...rowNode.allLeafChildren);
                        return;
                    }
                }
            }
            if (!started) {
                if (rowNode !== lastInRange && rowNode !== firstInRange) return;
                started = true;
            }
            const includeThisNode = !rowNode.group || !groupsSelectChildren;
            if (includeThisNode) {
                result.push(rowNode);
                return;
            }
        });
        return result;
    }
    setDatasource(datasource) {
        console.error("AG Grid: should never call setDatasource on clientSideRowController");
    }
    getTopLevelNodes() {
        return this.rootNode ? this.rootNode.childrenAfterGroup : null;
    }
    getRootNode() {
        return this.rootNode;
    }
    getRow(index) {
        return this.rowsToDisplay[index];
    }
    isRowPresent(rowNode) {
        return this.rowsToDisplay.indexOf(rowNode) >= 0;
    }
    getRowIndexAtPixel(pixelToMatch) {
        if (this.isEmpty() || this.rowsToDisplay.length === 0) return -1;
        let bottomPointer = 0;
        let topPointer = this.rowsToDisplay.length - 1;
        if (pixelToMatch <= 0) return 0;
        const lastNode = _.last(this.rowsToDisplay);
        if (lastNode.rowTop <= pixelToMatch) return this.rowsToDisplay.length - 1;
        let oldBottomPointer = -1;
        let oldTopPointer = -1;
        while(true){
            const midPointer = Math.floor((bottomPointer + topPointer) / 2);
            const currentRowNode = this.rowsToDisplay[midPointer];
            if (this.isRowInPixel(currentRowNode, pixelToMatch)) return midPointer;
            if (currentRowNode.rowTop < pixelToMatch) bottomPointer = midPointer + 1;
            else if (currentRowNode.rowTop > pixelToMatch) topPointer = midPointer - 1;
            const caughtInInfiniteLoop = oldBottomPointer === bottomPointer && oldTopPointer === topPointer;
            if (caughtInInfiniteLoop) return midPointer;
            oldBottomPointer = bottomPointer;
            oldTopPointer = topPointer;
        }
    }
    isRowInPixel(rowNode, pixelToMatch) {
        const topPixel = rowNode.rowTop;
        const bottomPixel = rowNode.rowTop + rowNode.rowHeight;
        const pixelInRow = topPixel <= pixelToMatch && bottomPixel > pixelToMatch;
        return pixelInRow;
    }
    forEachLeafNode(callback) {
        if (this.rootNode.allLeafChildren) this.rootNode.allLeafChildren.forEach((rowNode, index)=>callback(rowNode, index));
    }
    forEachNode(callback, includeFooterNodes = false) {
        this.recursivelyWalkNodesAndCallback({
            nodes: [
                ...this.rootNode.childrenAfterGroup || []
            ],
            callback,
            recursionType: 0 /* Normal */ ,
            index: 0,
            includeFooterNodes
        });
    }
    forEachNodeAfterFilter(callback, includeFooterNodes = false) {
        this.recursivelyWalkNodesAndCallback({
            nodes: [
                ...this.rootNode.childrenAfterAggFilter || []
            ],
            callback,
            recursionType: 1 /* AfterFilter */ ,
            index: 0,
            includeFooterNodes
        });
    }
    forEachNodeAfterFilterAndSort(callback, includeFooterNodes = false) {
        this.recursivelyWalkNodesAndCallback({
            nodes: [
                ...this.rootNode.childrenAfterSort || []
            ],
            callback,
            recursionType: 2 /* AfterFilterAndSort */ ,
            index: 0,
            includeFooterNodes
        });
    }
    forEachPivotNode(callback, includeFooterNodes = false) {
        this.recursivelyWalkNodesAndCallback({
            nodes: [
                this.rootNode
            ],
            callback,
            recursionType: 3 /* PivotNodes */ ,
            index: 0,
            includeFooterNodes
        });
    }
    // iterates through each item in memory, and calls the callback function
    // nodes - the rowNodes to traverse
    // callback - the user provided callback
    // recursion type - need this to know what child nodes to recurse, eg if looking at all nodes, or filtered notes etc
    // index - works similar to the index in forEach in javascript's array function
    recursivelyWalkNodesAndCallback(params) {
        const { nodes, callback, recursionType, includeFooterNodes } = params;
        let { index } = params;
        const addFooters = (position)=>{
            var _a;
            const parentNode = (_a = nodes[0]) == null ? void 0 : _a.parent;
            if (!parentNode) return;
            const grandTotal = includeFooterNodes && this.gos.getGrandTotalRow();
            const isGroupIncludeFooter = this.gos.getGroupTotalRowCallback();
            const groupTotal = includeFooterNodes && isGroupIncludeFooter({
                node: parentNode
            });
            const isRootNode = parentNode === this.rootNode;
            if (isRootNode) {
                if (grandTotal === position) {
                    parentNode.createFooter();
                    callback(parentNode.sibling, index++);
                }
                return;
            }
            if (groupTotal === position) {
                parentNode.createFooter();
                callback(parentNode.sibling, index++);
            }
        };
        addFooters("top");
        for(let i = 0; i < nodes.length; i++){
            const node = nodes[i];
            callback(node, index++);
            if (node.hasChildren() && !node.footer) {
                let nodeChildren = null;
                switch(recursionType){
                    case 0 /* Normal */ :
                        nodeChildren = node.childrenAfterGroup;
                        break;
                    case 1 /* AfterFilter */ :
                        nodeChildren = node.childrenAfterAggFilter;
                        break;
                    case 2 /* AfterFilterAndSort */ :
                        nodeChildren = node.childrenAfterSort;
                        break;
                    case 3 /* PivotNodes */ :
                        nodeChildren = !node.leafGroup ? node.childrenAfterSort : null;
                        break;
                }
                if (nodeChildren) index = this.recursivelyWalkNodesAndCallback({
                    nodes: [
                        ...nodeChildren
                    ],
                    callback,
                    recursionType,
                    index,
                    includeFooterNodes
                });
            }
        }
        addFooters("bottom");
        return index;
    }
    // it's possible to recompute the aggregate without doing the other parts
    // + api.refreshClientSideRowModel('aggregate')
    doAggregate(changedPath) {
        var _a;
        (_a = this.aggregationStage) == null || _a.execute({
            rowNode: this.rootNode,
            changedPath
        });
    }
    doFilterAggregates(changedPath) {
        if (this.filterAggregatesStage) this.filterAggregatesStage.execute({
            rowNode: this.rootNode,
            changedPath
        });
        else this.rootNode.childrenAfterAggFilter = this.rootNode.childrenAfterFilter;
    }
    // + gridApi.expandAll()
    // + gridApi.collapseAll()
    expandOrCollapseAll(expand) {
        const usingTreeData = this.gos.get("treeData");
        const usingPivotMode = this.columnModel.isPivotActive();
        const recursiveExpandOrCollapse = (rowNodes)=>{
            if (!rowNodes) return;
            rowNodes.forEach((rowNode)=>{
                const actionRow = ()=>{
                    rowNode.expanded = expand;
                    recursiveExpandOrCollapse(rowNode.childrenAfterGroup);
                };
                if (usingTreeData) {
                    const hasChildren = _.exists(rowNode.childrenAfterGroup);
                    if (hasChildren) actionRow();
                    return;
                }
                if (usingPivotMode) {
                    const notLeafGroup = !rowNode.leafGroup;
                    if (notLeafGroup) actionRow();
                    return;
                }
                const isRowGroup = rowNode.group;
                if (isRowGroup) actionRow();
            });
        };
        if (this.rootNode) recursiveExpandOrCollapse(this.rootNode.childrenAfterGroup);
        this.refreshModel({
            step: "map" /* MAP */ 
        });
        const eventSource = expand ? "expandAll" : "collapseAll";
        const event = {
            type: Events.EVENT_EXPAND_COLLAPSE_ALL,
            source: eventSource
        };
        this.eventService.dispatchEvent(event);
    }
    doSort(rowNodeTransactions, changedPath) {
        this.sortStage.execute({
            rowNode: this.rootNode,
            rowNodeTransactions,
            changedPath
        });
    }
    doRowGrouping(rowNodeTransactions, rowNodeOrder, changedPath, afterColumnsChanged) {
        if (this.groupStage) {
            if (rowNodeTransactions) this.groupStage.execute({
                rowNode: this.rootNode,
                rowNodeTransactions,
                rowNodeOrder,
                changedPath
            });
            else this.groupStage.execute({
                rowNode: this.rootNode,
                changedPath,
                afterColumnsChanged
            });
            if (this.gos.get("groupSelectsChildren")) {
                const selectionChanged = this.selectionService.updateGroupsFromChildrenSelections("rowGroupChanged", changedPath);
                if (selectionChanged) {
                    const event = {
                        type: Events.EVENT_SELECTION_CHANGED,
                        source: "rowGroupChanged"
                    };
                    this.eventService.dispatchEvent(event);
                }
            }
        } else {
            this.rootNode.childrenAfterGroup = this.rootNode.allLeafChildren;
            if (this.rootNode.sibling) this.rootNode.sibling.childrenAfterGroup = this.rootNode.childrenAfterGroup;
            this.rootNode.updateHasChildren();
        }
        if (this.nodeManager.isRowCountReady()) {
            this.rowCountReady = true;
            this.eventService.dispatchEventOnce({
                type: Events.EVENT_ROW_COUNT_READY
            });
        }
    }
    doFilter(changedPath) {
        this.filterStage.execute({
            rowNode: this.rootNode,
            changedPath
        });
    }
    doPivot(changedPath) {
        var _a;
        (_a = this.pivotStage) == null || _a.execute({
            rowNode: this.rootNode,
            changedPath
        });
    }
    getCopyOfNodesMap() {
        return this.nodeManager.getCopyOfNodesMap();
    }
    getRowNode(id) {
        const idIsGroup = typeof id == "string" && id.indexOf(RowNode.ID_PREFIX_ROW_GROUP) == 0;
        if (idIsGroup) {
            let res = void 0;
            this.forEachNode((node)=>{
                if (node.id === id) res = node;
            });
            return res;
        }
        return this.nodeManager.getRowNode(id);
    }
    // rows: the rows to put into the model
    setRowData(rowData) {
        this.selectionService.reset("rowDataChanged");
        this.nodeManager.setRowData(rowData);
        if (this.hasStarted) this.dispatchUpdateEventsAndRefresh();
    }
    dispatchUpdateEventsAndRefresh() {
        const rowDataUpdatedEvent = {
            type: Events.EVENT_ROW_DATA_UPDATED
        };
        this.eventService.dispatchEvent(rowDataUpdatedEvent);
        this.refreshModel({
            step: "group" /* EVERYTHING */ ,
            newData: true
        });
    }
    batchUpdateRowData(rowDataTransaction, callback) {
        if (this.applyAsyncTransactionsTimeout == null) {
            this.rowDataTransactionBatch = [];
            const waitMillis = this.gos.getAsyncTransactionWaitMillis();
            this.applyAsyncTransactionsTimeout = window.setTimeout(()=>{
                this.executeBatchUpdateRowData();
            }, waitMillis);
        }
        this.rowDataTransactionBatch.push({
            rowDataTransaction,
            callback
        });
    }
    flushAsyncTransactions() {
        if (this.applyAsyncTransactionsTimeout != null) {
            clearTimeout(this.applyAsyncTransactionsTimeout);
            this.executeBatchUpdateRowData();
        }
    }
    executeBatchUpdateRowData() {
        this.valueCache.onDataChanged();
        const callbackFuncsBound = [];
        const rowNodeTrans = [];
        let forceRowNodeOrder = false;
        if (this.rowDataTransactionBatch) this.rowDataTransactionBatch.forEach((tranItem)=>{
            const rowNodeTran = this.nodeManager.updateRowData(tranItem.rowDataTransaction, void 0);
            rowNodeTrans.push(rowNodeTran);
            if (tranItem.callback) callbackFuncsBound.push(tranItem.callback.bind(null, rowNodeTran));
            if (typeof tranItem.rowDataTransaction.addIndex === "number") forceRowNodeOrder = true;
        });
        this.commonUpdateRowData(rowNodeTrans, void 0, forceRowNodeOrder);
        if (callbackFuncsBound.length > 0) window.setTimeout(()=>{
            callbackFuncsBound.forEach((func)=>func());
        }, 0);
        if (rowNodeTrans.length > 0) {
            const event = {
                type: Events.EVENT_ASYNC_TRANSACTIONS_FLUSHED,
                results: rowNodeTrans
            };
            this.eventService.dispatchEvent(event);
        }
        this.rowDataTransactionBatch = null;
        this.applyAsyncTransactionsTimeout = void 0;
    }
    updateRowData(rowDataTran, rowNodeOrder) {
        this.valueCache.onDataChanged();
        const rowNodeTran = this.nodeManager.updateRowData(rowDataTran, rowNodeOrder);
        const forceRowNodeOrder = typeof rowDataTran.addIndex === "number";
        this.commonUpdateRowData([
            rowNodeTran
        ], rowNodeOrder, forceRowNodeOrder);
        return rowNodeTran;
    }
    createRowNodeOrder() {
        const suppressSortOrder = this.gos.get("suppressMaintainUnsortedOrder");
        if (suppressSortOrder) return;
        const orderMap = {};
        if (this.rootNode && this.rootNode.allLeafChildren) for(let index = 0; index < this.rootNode.allLeafChildren.length; index++){
            const node = this.rootNode.allLeafChildren[index];
            orderMap[node.id] = index;
        }
        return orderMap;
    }
    // common to updateRowData and batchUpdateRowData
    commonUpdateRowData(rowNodeTrans, rowNodeOrder, forceRowNodeOrder) {
        if (!this.hasStarted) return;
        const animate = !this.gos.get("suppressAnimationFrame");
        if (forceRowNodeOrder) rowNodeOrder = this.createRowNodeOrder();
        const event = {
            type: Events.EVENT_ROW_DATA_UPDATED
        };
        this.eventService.dispatchEvent(event);
        this.refreshModel({
            step: "group" /* EVERYTHING */ ,
            rowNodeTransactions: rowNodeTrans,
            rowNodeOrder,
            keepRenderedRows: true,
            keepEditingRows: true,
            animate
        });
    }
    doRowsToDisplay() {
        this.rowsToDisplay = this.flattenStage.execute({
            rowNode: this.rootNode
        });
    }
    onRowHeightChanged() {
        this.refreshModel({
            step: "map" /* MAP */ ,
            keepRenderedRows: true,
            keepEditingRows: true,
            keepUndoRedoStack: true
        });
    }
    /** This method is debounced. It is used for row auto-height. If we don't debounce,
   * then the Row Models will end up recalculating each row position
   * for each row height change and result in the Row Renderer laying out rows.
   * This is particularly bad if using print layout, and showing eg 1,000 rows,
   * each row will change it's height, causing Row Model to update 1,000 times.
   */ onRowHeightChangedDebounced() {
        this.onRowHeightChanged_debounced();
    }
    resetRowHeights() {
        const atLeastOne = this.resetRowHeightsForAllRowNodes();
        this.rootNode.setRowHeight(this.rootNode.rowHeight, true);
        if (this.rootNode.sibling) this.rootNode.sibling.setRowHeight(this.rootNode.sibling.rowHeight, true);
        if (atLeastOne) this.onRowHeightChanged();
    }
    resetRowHeightsForAllRowNodes() {
        let atLeastOne = false;
        this.forEachNode((rowNode)=>{
            rowNode.setRowHeight(rowNode.rowHeight, true);
            const detailNode = rowNode.detailNode;
            if (detailNode) detailNode.setRowHeight(detailNode.rowHeight, true);
            if (rowNode.sibling) rowNode.sibling.setRowHeight(rowNode.sibling.rowHeight, true);
            atLeastOne = true;
        });
        return atLeastOne;
    }
    onGridStylesChanges() {
        if (this.columnModel.isAutoRowHeightActive()) return;
        this.resetRowHeights();
    }
    onGridReady() {
        if (this.hasStarted) return;
        this.setInitialData();
    }
    isRowDataLoaded() {
        return this.rowCountReady;
    }
};
__decorateClass([
    Autowired("columnModel")
], ClientSideRowModel.prototype, "columnModel", 2);
__decorateClass([
    Autowired("selectionService")
], ClientSideRowModel.prototype, "selectionService", 2);
__decorateClass([
    Autowired("valueCache")
], ClientSideRowModel.prototype, "valueCache", 2);
__decorateClass([
    Autowired("beans")
], ClientSideRowModel.prototype, "beans", 2);
__decorateClass([
    Autowired("filterStage")
], ClientSideRowModel.prototype, "filterStage", 2);
__decorateClass([
    Autowired("sortStage")
], ClientSideRowModel.prototype, "sortStage", 2);
__decorateClass([
    Autowired("flattenStage")
], ClientSideRowModel.prototype, "flattenStage", 2);
__decorateClass([
    Optional("groupStage")
], ClientSideRowModel.prototype, "groupStage", 2);
__decorateClass([
    Optional("aggregationStage")
], ClientSideRowModel.prototype, "aggregationStage", 2);
__decorateClass([
    Optional("pivotStage")
], ClientSideRowModel.prototype, "pivotStage", 2);
__decorateClass([
    Optional("filterAggregatesStage")
], ClientSideRowModel.prototype, "filterAggregatesStage", 2);
__decorateClass([
    PostConstruct
], ClientSideRowModel.prototype, "init", 1);
ClientSideRowModel = __decorateClass([
    Bean("rowModel")
], ClientSideRowModel);
// community-modules/client-side-row-model/src/clientSideRowModel/filterStage.ts
var FilterStage = class extends BeanStub {
    execute(params) {
        const { changedPath } = params;
        this.filterService.filter(changedPath);
    }
};
__decorateClass([
    Autowired("filterService")
], FilterStage.prototype, "filterService", 2);
FilterStage = __decorateClass([
    Bean("filterStage")
], FilterStage);
// community-modules/client-side-row-model/src/clientSideRowModel/sortStage.ts
var SortStage = class extends BeanStub {
    execute(params) {
        const sortOptions = this.sortController.getSortOptions();
        const sortActive = _.exists(sortOptions) && sortOptions.length > 0;
        const deltaSort = sortActive && _.exists(params.rowNodeTransactions) && this.gos.get("deltaSort");
        const sortContainsGroupColumns = sortOptions.some((opt)=>{
            const isSortingCoupled = this.gos.isColumnsSortingCoupledToGroup();
            if (isSortingCoupled) return opt.column.isPrimary() && opt.column.isRowGroupActive();
            return !!opt.column.getColDef().showRowGroup;
        });
        this.sortService.sort(sortOptions, sortActive, deltaSort, params.rowNodeTransactions, params.changedPath, sortContainsGroupColumns);
    }
};
__decorateClass([
    Autowired("sortService")
], SortStage.prototype, "sortService", 2);
__decorateClass([
    Autowired("sortController")
], SortStage.prototype, "sortController", 2);
SortStage = __decorateClass([
    Bean("sortStage")
], SortStage);
// community-modules/client-side-row-model/src/clientSideRowModel/flattenStage.ts
var FlattenStage = class extends BeanStub {
    execute(params) {
        const rootNode = params.rowNode;
        const result = [];
        const skipLeafNodes = this.beans.columnModel.isPivotMode();
        const showRootNode = skipLeafNodes && rootNode.leafGroup;
        const topList = showRootNode ? [
            rootNode
        ] : rootNode.childrenAfterSort;
        const details = this.getFlattenDetails();
        this.recursivelyAddToRowsToDisplay(details, topList, result, skipLeafNodes, 0);
        const atLeastOneRowPresent = result.length > 0;
        const includeGrandTotalRow = !showRootNode && atLeastOneRowPresent && details.grandTotalRow;
        if (includeGrandTotalRow) {
            rootNode.createFooter();
            const addToTop = details.grandTotalRow === "top";
            this.addRowNodeToRowsToDisplay(details, rootNode.sibling, result, 0, addToTop);
        }
        return result;
    }
    getFlattenDetails() {
        const groupRemoveSingleChildren = this.gos.get("groupRemoveSingleChildren");
        const groupRemoveLowestSingleChildren = !groupRemoveSingleChildren && this.gos.get("groupRemoveLowestSingleChildren");
        return {
            groupRemoveLowestSingleChildren,
            groupRemoveSingleChildren,
            isGroupMultiAutoColumn: this.gos.isGroupMultiAutoColumn(),
            hideOpenParents: this.gos.get("groupHideOpenParents"),
            grandTotalRow: this.gos.getGrandTotalRow(),
            groupTotalRow: this.gos.getGroupTotalRowCallback()
        };
    }
    recursivelyAddToRowsToDisplay(details, rowsToFlatten, result, skipLeafNodes, uiLevel) {
        if (_.missingOrEmpty(rowsToFlatten)) return;
        for(let i = 0; i < rowsToFlatten.length; i++){
            const rowNode = rowsToFlatten[i];
            const isParent = rowNode.hasChildren();
            const isSkippedLeafNode = skipLeafNodes && !isParent;
            const isRemovedSingleChildrenGroup = details.groupRemoveSingleChildren && isParent && rowNode.childrenAfterGroup.length === 1;
            const isRemovedLowestSingleChildrenGroup = details.groupRemoveLowestSingleChildren && isParent && rowNode.leafGroup && rowNode.childrenAfterGroup.length === 1;
            const neverAllowToExpand = skipLeafNodes && rowNode.leafGroup;
            const isHiddenOpenParent = details.hideOpenParents && rowNode.expanded && !rowNode.master && !neverAllowToExpand;
            const thisRowShouldBeRendered = !isSkippedLeafNode && !isHiddenOpenParent && !isRemovedSingleChildrenGroup && !isRemovedLowestSingleChildrenGroup;
            if (thisRowShouldBeRendered) this.addRowNodeToRowsToDisplay(details, rowNode, result, uiLevel);
            if (skipLeafNodes && rowNode.leafGroup) continue;
            if (isParent) {
                const excludedParent = isRemovedSingleChildrenGroup || isRemovedLowestSingleChildrenGroup;
                if (rowNode.expanded || excludedParent) {
                    const doesRowShowFooter = details.groupTotalRow({
                        node: rowNode
                    });
                    if (!doesRowShowFooter) rowNode.destroyFooter();
                    const uiLevelForChildren = excludedParent ? uiLevel : uiLevel + 1;
                    if (doesRowShowFooter === "top") {
                        rowNode.createFooter();
                        this.addRowNodeToRowsToDisplay(details, rowNode.sibling, result, uiLevelForChildren);
                    }
                    this.recursivelyAddToRowsToDisplay(details, rowNode.childrenAfterSort, result, skipLeafNodes, uiLevelForChildren);
                    if (doesRowShowFooter === "bottom") {
                        rowNode.createFooter();
                        this.addRowNodeToRowsToDisplay(details, rowNode.sibling, result, uiLevelForChildren);
                    }
                }
            } else if (rowNode.master && rowNode.expanded) {
                const detailNode = this.createDetailNode(rowNode);
                this.addRowNodeToRowsToDisplay(details, detailNode, result, uiLevel);
            }
        }
    }
    // duplicated method, it's also in floatingRowModel
    addRowNodeToRowsToDisplay(details, rowNode, result, uiLevel, addToTop) {
        if (addToTop) result.unshift(rowNode);
        else result.push(rowNode);
        rowNode.setUiLevel(details.isGroupMultiAutoColumn ? 0 : uiLevel);
    }
    createDetailNode(masterNode) {
        if (_.exists(masterNode.detailNode)) return masterNode.detailNode;
        const detailNode = new RowNode(this.beans);
        detailNode.detail = true;
        detailNode.selectable = false;
        detailNode.parent = masterNode;
        if (_.exists(masterNode.id)) detailNode.id = "detail_" + masterNode.id;
        detailNode.data = masterNode.data;
        detailNode.level = masterNode.level + 1;
        masterNode.detailNode = detailNode;
        return detailNode;
    }
};
__decorateClass([
    Autowired("beans")
], FlattenStage.prototype, "beans", 2);
FlattenStage = __decorateClass([
    Bean("flattenStage")
], FlattenStage);
// community-modules/client-side-row-model/src/clientSideRowModel/sortService.ts
var SortService = class extends BeanStub {
    sort(sortOptions, sortActive, useDeltaSort, rowNodeTransactions, changedPath, sortContainsGroupColumns) {
        const groupMaintainOrder = this.gos.get("groupMaintainOrder");
        const groupColumnsPresent = this.columnModel.getAllGridColumns().some((c)=>c.isRowGroupActive());
        let allDirtyNodes = {};
        if (useDeltaSort && rowNodeTransactions) allDirtyNodes = this.calculateDirtyNodes(rowNodeTransactions);
        const isPivotMode = this.columnModel.isPivotMode();
        const postSortFunc = this.gos.getCallback("postSortRows");
        const callback = (rowNode)=>{
            var _a;
            this.pullDownGroupDataForHideOpenParents(rowNode.childrenAfterAggFilter, true);
            const skipSortingPivotLeafs = isPivotMode && rowNode.leafGroup;
            let skipSortingGroups = groupMaintainOrder && groupColumnsPresent && !rowNode.leafGroup && !sortContainsGroupColumns;
            if (skipSortingGroups) {
                const nextGroup = (_a = this.columnModel.getRowGroupColumns()) == null ? void 0 : _a[rowNode.level + 1];
                const wasSortExplicitlyRemoved = (nextGroup == null ? void 0 : nextGroup.getSort()) === null;
                const childrenToBeSorted = rowNode.childrenAfterAggFilter.slice(0);
                if (rowNode.childrenAfterSort && !wasSortExplicitlyRemoved) {
                    const indexedOrders = {};
                    rowNode.childrenAfterSort.forEach((node, idx)=>{
                        indexedOrders[node.id] = idx;
                    });
                    childrenToBeSorted.sort((row1, row2)=>{
                        var _a2, _b;
                        return ((_a2 = indexedOrders[row1.id]) != null ? _a2 : 0) - ((_b = indexedOrders[row2.id]) != null ? _b : 0);
                    });
                }
                rowNode.childrenAfterSort = childrenToBeSorted;
            } else if (!sortActive || skipSortingPivotLeafs) rowNode.childrenAfterSort = rowNode.childrenAfterAggFilter.slice(0);
            else if (useDeltaSort) rowNode.childrenAfterSort = this.doDeltaSort(rowNode, allDirtyNodes, changedPath, sortOptions);
            else rowNode.childrenAfterSort = this.rowNodeSorter.doFullSort(rowNode.childrenAfterAggFilter, sortOptions);
            if (rowNode.sibling) rowNode.sibling.childrenAfterSort = rowNode.childrenAfterSort;
            this.updateChildIndexes(rowNode);
            if (postSortFunc) {
                const params = {
                    nodes: rowNode.childrenAfterSort
                };
                postSortFunc(params);
            }
        };
        if (changedPath) changedPath.forEachChangedNodeDepthFirst(callback);
        this.updateGroupDataForHideOpenParents(changedPath);
    }
    calculateDirtyNodes(rowNodeTransactions) {
        const dirtyNodes = {};
        const addNodesFunc = (rowNodes)=>{
            if (rowNodes) rowNodes.forEach((rowNode)=>dirtyNodes[rowNode.id] = true);
        };
        if (rowNodeTransactions) rowNodeTransactions.forEach((tran)=>{
            addNodesFunc(tran.add);
            addNodesFunc(tran.update);
            addNodesFunc(tran.remove);
        });
        return dirtyNodes;
    }
    doDeltaSort(rowNode, allTouchedNodes, changedPath, sortOptions) {
        const unsortedRows = rowNode.childrenAfterAggFilter;
        const oldSortedRows = rowNode.childrenAfterSort;
        if (!oldSortedRows) return this.rowNodeSorter.doFullSort(unsortedRows, sortOptions);
        const untouchedRowsMap = {};
        const touchedRows = [];
        unsortedRows.forEach((row)=>{
            if (allTouchedNodes[row.id] || !changedPath.canSkip(row)) touchedRows.push(row);
            else untouchedRowsMap[row.id] = true;
        });
        const sortedUntouchedRows = oldSortedRows.filter((child)=>untouchedRowsMap[child.id]);
        const mapNodeToSortedNode = (rowNode2, pos)=>({
                currentPos: pos,
                rowNode: rowNode2
            });
        const sortedChangedRows = touchedRows.map(mapNodeToSortedNode).sort((a, b)=>this.rowNodeSorter.compareRowNodes(sortOptions, a, b));
        return this.mergeSortedArrays(sortOptions, sortedChangedRows, sortedUntouchedRows.map(mapNodeToSortedNode)).map(({ rowNode: rowNode2 })=>rowNode2);
    }
    // Merge two sorted arrays into each other
    mergeSortedArrays(sortOptions, arr1, arr2) {
        const res = [];
        let i = 0;
        let j = 0;
        while(i < arr1.length && j < arr2.length){
            const compareResult = this.rowNodeSorter.compareRowNodes(sortOptions, arr1[i], arr2[j]);
            if (compareResult < 0) res.push(arr1[i++]);
            else res.push(arr2[j++]);
        }
        while(i < arr1.length)res.push(arr1[i++]);
        while(j < arr2.length)res.push(arr2[j++]);
        return res;
    }
    updateChildIndexes(rowNode) {
        if (_.missing(rowNode.childrenAfterSort)) return;
        const listToSort = rowNode.childrenAfterSort;
        for(let i = 0; i < listToSort.length; i++){
            const child = listToSort[i];
            const firstChild = i === 0;
            const lastChild = i === rowNode.childrenAfterSort.length - 1;
            child.setFirstChild(firstChild);
            child.setLastChild(lastChild);
            child.setChildIndex(i);
        }
    }
    updateGroupDataForHideOpenParents(changedPath) {
        if (!this.gos.get("groupHideOpenParents")) return;
        if (this.gos.get("treeData")) {
            _.warnOnce(`The property hideOpenParents dose not work with Tree Data. This is because Tree Data has values at the group level, it doesn't make sense to hide them.`);
            return false;
        }
        const callback = (rowNode)=>{
            this.pullDownGroupDataForHideOpenParents(rowNode.childrenAfterSort, false);
            rowNode.childrenAfterSort.forEach((child)=>{
                if (child.hasChildren()) callback(child);
            });
        };
        if (changedPath) changedPath.executeFromRootNode((rowNode)=>callback(rowNode));
    }
    pullDownGroupDataForHideOpenParents(rowNodes, clearOperation) {
        if (!this.gos.get("groupHideOpenParents") || _.missing(rowNodes)) return;
        rowNodes.forEach((childRowNode)=>{
            const groupDisplayCols = this.columnModel.getGroupDisplayColumns();
            groupDisplayCols.forEach((groupDisplayCol)=>{
                const showRowGroup = groupDisplayCol.getColDef().showRowGroup;
                if (typeof showRowGroup !== "string") {
                    console.error("AG Grid: groupHideOpenParents only works when specifying specific columns for colDef.showRowGroup");
                    return;
                }
                const displayingGroupKey = showRowGroup;
                const rowGroupColumn = this.columnModel.getPrimaryColumn(displayingGroupKey);
                const thisRowNodeMatches = rowGroupColumn === childRowNode.rowGroupColumn;
                if (thisRowNodeMatches) return;
                if (clearOperation) childRowNode.setGroupValue(groupDisplayCol.getId(), void 0);
                else {
                    const parentToStealFrom = childRowNode.getFirstChildOfFirstChild(rowGroupColumn);
                    if (parentToStealFrom) childRowNode.setGroupValue(groupDisplayCol.getId(), parentToStealFrom.key);
                }
            });
        });
    }
};
__decorateClass([
    Autowired("columnModel")
], SortService.prototype, "columnModel", 2);
__decorateClass([
    Autowired("rowNodeSorter")
], SortService.prototype, "rowNodeSorter", 2);
SortService = __decorateClass([
    Bean("sortService")
], SortService);
// community-modules/client-side-row-model/src/clientSideRowModel/filterService.ts
var FilterService = class extends BeanStub {
    filter(changedPath) {
        const filterActive = this.filterManager.isChildFilterPresent();
        this.filterNodes(filterActive, changedPath);
    }
    filterNodes(filterActive, changedPath) {
        const filterCallback = (rowNode, includeChildNodes)=>{
            if (rowNode.hasChildren()) {
                if (filterActive && !includeChildNodes) rowNode.childrenAfterFilter = rowNode.childrenAfterGroup.filter((childNode)=>{
                    const passBecauseChildren = childNode.childrenAfterFilter && childNode.childrenAfterFilter.length > 0;
                    const passBecauseDataPasses = childNode.data && this.filterManager.doesRowPassFilter({
                        rowNode: childNode
                    });
                    return passBecauseChildren || passBecauseDataPasses;
                });
                else rowNode.childrenAfterFilter = rowNode.childrenAfterGroup;
            } else rowNode.childrenAfterFilter = rowNode.childrenAfterGroup;
            if (rowNode.sibling) rowNode.sibling.childrenAfterFilter = rowNode.childrenAfterFilter;
        };
        if (this.doingTreeDataFiltering()) {
            const treeDataDepthFirstFilter = (rowNode, alreadyFoundInParent)=>{
                if (rowNode.childrenAfterGroup) for(let i = 0; i < rowNode.childrenAfterGroup.length; i++){
                    const childNode = rowNode.childrenAfterGroup[i];
                    const foundInParent = alreadyFoundInParent || this.filterManager.doesRowPassFilter({
                        rowNode: childNode
                    });
                    if (childNode.childrenAfterGroup) treeDataDepthFirstFilter(rowNode.childrenAfterGroup[i], foundInParent);
                    else filterCallback(childNode, foundInParent);
                }
                filterCallback(rowNode, alreadyFoundInParent);
            };
            const treeDataFilterCallback = (rowNode)=>treeDataDepthFirstFilter(rowNode, false);
            changedPath.executeFromRootNode(treeDataFilterCallback);
        } else {
            const defaultFilterCallback = (rowNode)=>filterCallback(rowNode, false);
            changedPath.forEachChangedNodeDepthFirst(defaultFilterCallback, true);
        }
    }
    doingTreeDataFiltering() {
        return this.gos.get("treeData") && !this.gos.get("excludeChildrenWhenTreeDataFiltering");
    }
};
__decorateClass([
    Autowired("filterManager")
], FilterService.prototype, "filterManager", 2);
FilterService = __decorateClass([
    Bean("filterService")
], FilterService);
// community-modules/client-side-row-model/src/clientSideRowModel/immutableService.ts
var ImmutableService = class extends BeanStub {
    postConstruct() {
        if (this.rowModel.getType() === "clientSide") {
            this.clientSideRowModel = this.rowModel;
            this.addManagedPropertyListener("rowData", ()=>this.onRowDataUpdated());
        }
    }
    isActive() {
        const getRowIdProvided = this.gos.exists("getRowId");
        const resetRowDataOnUpdate = this.gos.get("resetRowDataOnUpdate");
        if (resetRowDataOnUpdate) return false;
        return getRowIdProvided;
    }
    setRowData(rowData) {
        const transactionAndMap = this.createTransactionForRowData(rowData);
        if (!transactionAndMap) return;
        const [transaction, orderIdMap] = transactionAndMap;
        this.clientSideRowModel.updateRowData(transaction, orderIdMap);
    }
    // converts the setRowData() command to a transaction
    createTransactionForRowData(rowData) {
        if (_.missing(this.clientSideRowModel)) {
            console.error("AG Grid: ImmutableService only works with ClientSideRowModel");
            return;
        }
        const getRowIdFunc = this.gos.getCallback("getRowId");
        if (getRowIdFunc == null) {
            console.error("AG Grid: ImmutableService requires getRowId() callback to be implemented, your row data needs IDs!");
            return;
        }
        const transaction = {
            remove: [],
            update: [],
            add: []
        };
        const existingNodesMap = this.clientSideRowModel.getCopyOfNodesMap();
        const suppressSortOrder = this.gos.get("suppressMaintainUnsortedOrder");
        const orderMap = suppressSortOrder ? void 0 : {};
        if (_.exists(rowData)) rowData.forEach((data, index)=>{
            const id = getRowIdFunc({
                data,
                level: 0
            });
            const existingNode = existingNodesMap[id];
            if (orderMap) orderMap[id] = index;
            if (existingNode) {
                const dataHasChanged = existingNode.data !== data;
                if (dataHasChanged) transaction.update.push(data);
                existingNodesMap[id] = void 0;
            } else transaction.add.push(data);
        });
        _.iterateObject(existingNodesMap, (id, rowNode)=>{
            if (rowNode) transaction.remove.push(rowNode.data);
        });
        return [
            transaction,
            orderMap
        ];
    }
    onRowDataUpdated() {
        const rowData = this.gos.get("rowData");
        if (!rowData) return;
        if (this.isActive()) this.setRowData(rowData);
        else {
            this.selectionService.reset("rowDataChanged");
            this.clientSideRowModel.setRowData(rowData);
        }
    }
};
__decorateClass([
    Autowired("rowModel")
], ImmutableService.prototype, "rowModel", 2);
__decorateClass([
    Autowired("rowRenderer")
], ImmutableService.prototype, "rowRenderer", 2);
__decorateClass([
    Autowired("selectionService")
], ImmutableService.prototype, "selectionService", 2);
__decorateClass([
    PostConstruct
], ImmutableService.prototype, "postConstruct", 1);
ImmutableService = __decorateClass([
    Bean("immutableService")
], ImmutableService);
// community-modules/client-side-row-model/src/version.ts
var VERSION = "31.3.4";
// community-modules/client-side-row-model/src/clientSideRowModelModule.ts
var ClientSideRowModelModule = {
    version: VERSION,
    moduleName: "@ag-grid-community/client-side-row-model" /* ClientSideRowModelModule */ ,
    rowModel: "clientSide",
    beans: [
        ClientSideRowModel,
        FilterStage,
        SortStage,
        FlattenStage,
        SortService,
        FilterService,
        ImmutableService
    ]
};
// community-modules/infinite-row-model/dist/package/main.esm.mjs
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc2 = Object.getOwnPropertyDescriptor;
var __decorateClass2 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc2(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) __defProp2(target, key, result);
    return result;
};
var __decorateParam2 = (index, decorator)=>(target, key)=>decorator(target, key, index);
var InfiniteBlock = class extends RowNodeBlock {
    constructor(id, parentCache, params){
        super(id);
        this.parentCache = parentCache;
        this.params = params;
        this.startRow = id * params.blockSize;
        this.endRow = this.startRow + params.blockSize;
    }
    postConstruct() {
        this.createRowNodes();
    }
    getBlockStateJson() {
        return {
            id: "" + this.getId(),
            state: {
                blockNumber: this.getId(),
                startRow: this.getStartRow(),
                endRow: this.getEndRow(),
                pageStatus: this.getState()
            }
        };
    }
    setDataAndId(rowNode, data, index) {
        if (_.exists(data)) rowNode.setDataAndId(data, index.toString());
        else rowNode.setDataAndId(void 0, void 0);
    }
    loadFromDatasource() {
        const params = this.createLoadParams();
        if (_.missing(this.params.datasource.getRows)) {
            console.warn(`AG Grid: datasource is missing getRows method`);
            return;
        }
        window.setTimeout(()=>{
            this.params.datasource.getRows(params);
        }, 0);
    }
    processServerFail() {}
    createLoadParams() {
        const params = {
            startRow: this.getStartRow(),
            endRow: this.getEndRow(),
            successCallback: this.pageLoaded.bind(this, this.getVersion()),
            failCallback: this.pageLoadFailed.bind(this, this.getVersion()),
            sortModel: this.params.sortModel,
            filterModel: this.params.filterModel,
            context: this.gos.getGridCommonParams().context
        };
        return params;
    }
    forEachNode(callback, sequence, rowCount) {
        this.rowNodes.forEach((rowNode, index)=>{
            const rowIndex = this.startRow + index;
            if (rowIndex < rowCount) callback(rowNode, sequence.next());
        });
    }
    getLastAccessed() {
        return this.lastAccessed;
    }
    getRow(rowIndex, dontTouchLastAccessed = false) {
        if (!dontTouchLastAccessed) this.lastAccessed = this.params.lastAccessedSequence.next();
        const localIndex = rowIndex - this.startRow;
        return this.rowNodes[localIndex];
    }
    getStartRow() {
        return this.startRow;
    }
    getEndRow() {
        return this.endRow;
    }
    // creates empty row nodes, data is missing as not loaded yet
    createRowNodes() {
        this.rowNodes = [];
        for(let i = 0; i < this.params.blockSize; i++){
            const rowIndex = this.startRow + i;
            const rowNode = new RowNode(this.beans);
            rowNode.setRowHeight(this.params.rowHeight);
            rowNode.uiLevel = 0;
            rowNode.setRowIndex(rowIndex);
            rowNode.setRowTop(this.params.rowHeight * rowIndex);
            this.rowNodes.push(rowNode);
        }
    }
    processServerResult(params) {
        this.rowNodes.forEach((rowNode, index)=>{
            const data = params.rowData ? params.rowData[index] : void 0;
            if (!rowNode.id && rowNode.alreadyRendered && data) {
                this.rowNodes[index] = new RowNode(this.beans);
                this.rowNodes[index].setRowIndex(rowNode.rowIndex);
                this.rowNodes[index].setRowTop(rowNode.rowTop);
                this.rowNodes[index].setRowHeight(rowNode.rowHeight);
                rowNode.clearRowTopAndRowIndex();
            }
            this.setDataAndId(this.rowNodes[index], data, this.startRow + index);
        });
        const finalRowCount = params.rowCount != null && params.rowCount >= 0 ? params.rowCount : void 0;
        this.parentCache.pageLoaded(this, finalRowCount);
    }
    destroyRowNodes() {
        this.rowNodes.forEach((rowNode)=>{
            rowNode.clearRowTopAndRowIndex();
        });
    }
};
__decorateClass2([
    Autowired("beans")
], InfiniteBlock.prototype, "beans", 2);
__decorateClass2([
    PostConstruct
], InfiniteBlock.prototype, "postConstruct", 1);
__decorateClass2([
    PreDestroy
], InfiniteBlock.prototype, "destroyRowNodes", 1);
var _InfiniteCache = class _InfiniteCache2 extends BeanStub {
    constructor(params){
        super();
        this.lastRowIndexKnown = false;
        this.blocks = {};
        this.blockCount = 0;
        this.rowCount = params.initialRowCount;
        this.params = params;
    }
    setBeans(loggerFactory) {
        this.logger = loggerFactory.create("InfiniteCache");
    }
    // the rowRenderer will not pass dontCreatePage, meaning when rendering the grid,
    // it will want new pages in the cache as it asks for rows. only when we are inserting /
    // removing rows via the api is dontCreatePage set, where we move rows between the pages.
    getRow(rowIndex, dontCreatePage = false) {
        const blockId = Math.floor(rowIndex / this.params.blockSize);
        let block = this.blocks[blockId];
        if (!block) {
            if (dontCreatePage) return void 0;
            block = this.createBlock(blockId);
        }
        return block.getRow(rowIndex);
    }
    createBlock(blockNumber) {
        const newBlock = this.createBean(new InfiniteBlock(blockNumber, this, this.params));
        this.blocks[newBlock.getId()] = newBlock;
        this.blockCount++;
        this.purgeBlocksIfNeeded(newBlock);
        this.params.rowNodeBlockLoader.addBlock(newBlock);
        return newBlock;
    }
    // we have this on infinite row model only, not server side row model,
    // because for server side, it would leave the children in inconsistent
    // state - eg if a node had children, but after the refresh it had data
    // for a different row, then the children would be with the wrong row node.
    refreshCache() {
        const nothingToRefresh = this.blockCount == 0;
        if (nothingToRefresh) {
            this.purgeCache();
            return;
        }
        this.getBlocksInOrder().forEach((block)=>block.setStateWaitingToLoad());
        this.params.rowNodeBlockLoader.checkBlockToLoad();
    }
    destroyAllBlocks() {
        this.getBlocksInOrder().forEach((block)=>this.destroyBlock(block));
    }
    getRowCount() {
        return this.rowCount;
    }
    isLastRowIndexKnown() {
        return this.lastRowIndexKnown;
    }
    // block calls this, when page loaded
    pageLoaded(block, lastRow) {
        if (!this.isAlive()) return;
        this.logger.log(`onPageLoaded: page = ${block.getId()}, lastRow = ${lastRow}`);
        this.checkRowCount(block, lastRow);
        this.onCacheUpdated();
    }
    purgeBlocksIfNeeded(blockToExclude) {
        const blocksForPurging = this.getBlocksInOrder().filter((b)=>b != blockToExclude);
        const lastAccessedComparator = (a, b)=>b.getLastAccessed() - a.getLastAccessed();
        blocksForPurging.sort(lastAccessedComparator);
        const maxBlocksProvided = this.params.maxBlocksInCache > 0;
        const blocksToKeep = maxBlocksProvided ? this.params.maxBlocksInCache - 1 : null;
        const emptyBlocksToKeep = _InfiniteCache2.MAX_EMPTY_BLOCKS_TO_KEEP - 1;
        blocksForPurging.forEach((block, index)=>{
            const purgeBecauseBlockEmpty = block.getState() === InfiniteBlock.STATE_WAITING_TO_LOAD && index >= emptyBlocksToKeep;
            const purgeBecauseCacheFull = maxBlocksProvided ? index >= blocksToKeep : false;
            if (purgeBecauseBlockEmpty || purgeBecauseCacheFull) {
                if (this.isBlockCurrentlyDisplayed(block)) return;
                if (this.isBlockFocused(block)) return;
                this.removeBlockFromCache(block);
            }
        });
    }
    isBlockFocused(block) {
        const focusedCell = this.focusService.getFocusCellToUseAfterRefresh();
        if (!focusedCell) return false;
        if (focusedCell.rowPinned != null) return false;
        const blockIndexStart = block.getStartRow();
        const blockIndexEnd = block.getEndRow();
        const hasFocus = focusedCell.rowIndex >= blockIndexStart && focusedCell.rowIndex < blockIndexEnd;
        return hasFocus;
    }
    isBlockCurrentlyDisplayed(block) {
        const startIndex = block.getStartRow();
        const endIndex = block.getEndRow() - 1;
        return this.rowRenderer.isRangeInRenderedViewport(startIndex, endIndex);
    }
    removeBlockFromCache(blockToRemove) {
        if (!blockToRemove) return;
        this.destroyBlock(blockToRemove);
    }
    checkRowCount(block, lastRow) {
        if (typeof lastRow === "number" && lastRow >= 0) {
            this.rowCount = lastRow;
            this.lastRowIndexKnown = true;
        } else if (!this.lastRowIndexKnown) {
            const lastRowIndex = (block.getId() + 1) * this.params.blockSize;
            const lastRowIndexPlusOverflow = lastRowIndex + this.params.overflowSize;
            if (this.rowCount < lastRowIndexPlusOverflow) this.rowCount = lastRowIndexPlusOverflow;
        }
    }
    setRowCount(rowCount, lastRowIndexKnown) {
        this.rowCount = rowCount;
        if (_.exists(lastRowIndexKnown)) this.lastRowIndexKnown = lastRowIndexKnown;
        if (!this.lastRowIndexKnown) {
            if (this.rowCount % this.params.blockSize === 0) this.rowCount++;
        }
        this.onCacheUpdated();
    }
    forEachNodeDeep(callback) {
        const sequence = new NumberSequence();
        this.getBlocksInOrder().forEach((block)=>block.forEachNode(callback, sequence, this.rowCount));
    }
    getBlocksInOrder() {
        const blockComparator = (a, b)=>a.getId() - b.getId();
        const blocks = _.getAllValuesInObject(this.blocks).sort(blockComparator);
        return blocks;
    }
    destroyBlock(block) {
        delete this.blocks[block.getId()];
        this.destroyBean(block);
        this.blockCount--;
        this.params.rowNodeBlockLoader.removeBlock(block);
    }
    // gets called 1) row count changed 2) cache purged 3) items inserted
    onCacheUpdated() {
        if (this.isAlive()) {
            this.destroyAllBlocksPastVirtualRowCount();
            const event = {
                type: Events.EVENT_STORE_UPDATED
            };
            this.eventService.dispatchEvent(event);
        }
    }
    destroyAllBlocksPastVirtualRowCount() {
        const blocksToDestroy = [];
        this.getBlocksInOrder().forEach((block)=>{
            const startRow = block.getId() * this.params.blockSize;
            if (startRow >= this.rowCount) blocksToDestroy.push(block);
        });
        if (blocksToDestroy.length > 0) blocksToDestroy.forEach((block)=>this.destroyBlock(block));
    }
    purgeCache() {
        this.getBlocksInOrder().forEach((block)=>this.removeBlockFromCache(block));
        this.lastRowIndexKnown = false;
        if (this.rowCount === 0) this.rowCount = this.params.initialRowCount;
        this.onCacheUpdated();
    }
    getRowNodesInRange(firstInRange, lastInRange) {
        const result = [];
        let lastBlockId = -1;
        let inActiveRange = false;
        const numberSequence = new NumberSequence();
        if (_.missing(firstInRange)) inActiveRange = true;
        let foundGapInSelection = false;
        this.getBlocksInOrder().forEach((block)=>{
            if (foundGapInSelection) return;
            if (inActiveRange && lastBlockId + 1 !== block.getId()) {
                foundGapInSelection = true;
                return;
            }
            lastBlockId = block.getId();
            block.forEachNode((rowNode)=>{
                const hitFirstOrLast = rowNode === firstInRange || rowNode === lastInRange;
                if (inActiveRange || hitFirstOrLast) result.push(rowNode);
                if (hitFirstOrLast) inActiveRange = !inActiveRange;
            }, numberSequence, this.rowCount);
        });
        const invalidRange = foundGapInSelection || inActiveRange;
        return invalidRange ? [] : result;
    }
};
_InfiniteCache.MAX_EMPTY_BLOCKS_TO_KEEP = 2;
__decorateClass2([
    Autowired("rowRenderer")
], _InfiniteCache.prototype, "rowRenderer", 2);
__decorateClass2([
    Autowired("focusService")
], _InfiniteCache.prototype, "focusService", 2);
__decorateClass2([
    __decorateParam2(0, Qualifier("loggerFactory"))
], _InfiniteCache.prototype, "setBeans", 1);
__decorateClass2([
    PreDestroy
], _InfiniteCache.prototype, "destroyAllBlocks", 1);
var InfiniteCache = _InfiniteCache;
var InfiniteRowModel = class extends BeanStub {
    getRowBounds(index) {
        return {
            rowHeight: this.rowHeight,
            rowTop: this.rowHeight * index
        };
    }
    // we don't implement as lazy row heights is not supported in this row model
    ensureRowHeightsValid(startPixel, endPixel, startLimitIndex, endLimitIndex) {
        return false;
    }
    init() {
        if (!this.gos.isRowModelType("infinite")) return;
        this.rowHeight = this.gos.getRowHeightAsNumber();
        this.addEventListeners();
        this.addDestroyFunc(()=>this.destroyCache());
        this.verifyProps();
    }
    verifyProps() {
        if (this.gos.exists("initialGroupOrderComparator")) _.warnOnce("initialGroupOrderComparator cannot be used with Infinite Row Model as sorting is done on the server side");
    }
    start() {
        this.setDatasource(this.gos.get("datasource"));
    }
    destroyDatasource() {
        if (this.datasource) {
            this.getContext().destroyBean(this.datasource);
            this.rowRenderer.datasourceChanged();
            this.datasource = null;
        }
    }
    addEventListeners() {
        this.addManagedListener(this.eventService, Events.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.onColumnEverything.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_STORE_UPDATED, this.onCacheUpdated.bind(this));
        this.addManagedPropertyListener("datasource", ()=>this.setDatasource(this.gos.get("datasource")));
        this.addManagedPropertyListener("cacheBlockSize", ()=>this.resetCache());
        this.addManagedPropertyListener("rowHeight", ()=>{
            this.rowHeight = this.gos.getRowHeightAsNumber();
            this.cacheParams.rowHeight = this.rowHeight;
            this.updateRowHeights();
        });
    }
    onFilterChanged() {
        this.reset();
    }
    onSortChanged() {
        this.reset();
    }
    onColumnEverything() {
        let resetRequired;
        if (this.cacheParams) resetRequired = this.isSortModelDifferent();
        else resetRequired = true;
        if (resetRequired) this.reset();
    }
    isSortModelDifferent() {
        return !_.jsonEquals(this.cacheParams.sortModel, this.sortController.getSortModel());
    }
    getType() {
        return "infinite";
    }
    setDatasource(datasource) {
        this.destroyDatasource();
        this.datasource = datasource;
        if (datasource) this.reset();
    }
    isEmpty() {
        return !this.infiniteCache;
    }
    isRowsToRender() {
        return !!this.infiniteCache;
    }
    getNodesInRangeForSelection(firstInRange, lastInRange) {
        return this.infiniteCache ? this.infiniteCache.getRowNodesInRange(firstInRange, lastInRange) : [];
    }
    reset() {
        if (!this.datasource) return;
        const getRowIdFunc = this.gos.getCallback("getRowId");
        const userGeneratingIds = getRowIdFunc != null;
        if (!userGeneratingIds) this.selectionService.reset("rowDataChanged");
        this.resetCache();
    }
    createModelUpdatedEvent() {
        return {
            type: Events.EVENT_MODEL_UPDATED,
            // not sure if these should all be false - noticed if after implementing,
            // maybe they should be true?
            newPage: false,
            newPageSize: false,
            newData: false,
            keepRenderedRows: true,
            animate: false
        };
    }
    resetCache() {
        this.destroyCache();
        this.cacheParams = {
            // the user provided datasource
            datasource: this.datasource,
            // sort and filter model
            filterModel: this.filterManager.getFilterModel(),
            sortModel: this.sortController.getSortModel(),
            rowNodeBlockLoader: this.rowNodeBlockLoader,
            // properties - this way we take a snapshot of them, so if user changes any, they will be
            // used next time we create a new cache, which is generally after a filter or sort change,
            // or a new datasource is set
            initialRowCount: this.gos.get("infiniteInitialRowCount"),
            maxBlocksInCache: this.gos.get("maxBlocksInCache"),
            rowHeight: this.gos.getRowHeightAsNumber(),
            // if user doesn't provide overflow, we use default overflow of 1, so user can scroll past
            // the current page and request first row of next page
            overflowSize: this.gos.get("cacheOverflowSize"),
            // page size needs to be 1 or greater. having it at 1 would be silly, as you would be hitting the
            // server for one page at a time. so the default if not specified is 100.
            blockSize: this.gos.get("cacheBlockSize"),
            // the cache could create this, however it is also used by the pages, so handy to create it
            // here as the settings are also passed to the pages
            lastAccessedSequence: new NumberSequence()
        };
        this.infiniteCache = this.createBean(new InfiniteCache(this.cacheParams));
        this.eventService.dispatchEventOnce({
            type: Events.EVENT_ROW_COUNT_READY
        });
        const event = this.createModelUpdatedEvent();
        this.eventService.dispatchEvent(event);
    }
    updateRowHeights() {
        this.forEachNode((node)=>{
            node.setRowHeight(this.rowHeight);
            node.setRowTop(this.rowHeight * node.rowIndex);
        });
        const event = this.createModelUpdatedEvent();
        this.eventService.dispatchEvent(event);
    }
    destroyCache() {
        if (this.infiniteCache) this.infiniteCache = this.destroyBean(this.infiniteCache);
    }
    onCacheUpdated() {
        const event = this.createModelUpdatedEvent();
        this.eventService.dispatchEvent(event);
    }
    getRow(rowIndex) {
        if (!this.infiniteCache) return void 0;
        if (rowIndex >= this.infiniteCache.getRowCount()) return void 0;
        return this.infiniteCache.getRow(rowIndex);
    }
    getRowNode(id) {
        let result;
        this.forEachNode((rowNode)=>{
            if (rowNode.id === id) result = rowNode;
        });
        return result;
    }
    forEachNode(callback) {
        if (this.infiniteCache) this.infiniteCache.forEachNodeDeep(callback);
    }
    getTopLevelRowCount() {
        return this.getRowCount();
    }
    getTopLevelRowDisplayedIndex(topLevelIndex) {
        return topLevelIndex;
    }
    getRowIndexAtPixel(pixel) {
        if (this.rowHeight !== 0) {
            const rowIndexForPixel = Math.floor(pixel / this.rowHeight);
            const lastRowIndex = this.getRowCount() - 1;
            if (rowIndexForPixel > lastRowIndex) return lastRowIndex;
            return rowIndexForPixel;
        }
        return 0;
    }
    getRowCount() {
        return this.infiniteCache ? this.infiniteCache.getRowCount() : 0;
    }
    isRowPresent(rowNode) {
        const foundRowNode = this.getRowNode(rowNode.id);
        return !!foundRowNode;
    }
    refreshCache() {
        if (this.infiniteCache) this.infiniteCache.refreshCache();
    }
    purgeCache() {
        if (this.infiniteCache) this.infiniteCache.purgeCache();
    }
    // for iRowModel
    isLastRowIndexKnown() {
        if (this.infiniteCache) return this.infiniteCache.isLastRowIndexKnown();
        return false;
    }
    setRowCount(rowCount, lastRowIndexKnown) {
        if (this.infiniteCache) this.infiniteCache.setRowCount(rowCount, lastRowIndexKnown);
    }
};
__decorateClass2([
    Autowired("filterManager")
], InfiniteRowModel.prototype, "filterManager", 2);
__decorateClass2([
    Autowired("sortController")
], InfiniteRowModel.prototype, "sortController", 2);
__decorateClass2([
    Autowired("selectionService")
], InfiniteRowModel.prototype, "selectionService", 2);
__decorateClass2([
    Autowired("rowRenderer")
], InfiniteRowModel.prototype, "rowRenderer", 2);
__decorateClass2([
    Autowired("rowNodeBlockLoader")
], InfiniteRowModel.prototype, "rowNodeBlockLoader", 2);
__decorateClass2([
    PostConstruct
], InfiniteRowModel.prototype, "init", 1);
__decorateClass2([
    PreDestroy
], InfiniteRowModel.prototype, "destroyDatasource", 1);
InfiniteRowModel = __decorateClass2([
    Bean("rowModel")
], InfiniteRowModel);
var VERSION2 = "31.3.4";
var InfiniteRowModelModule = {
    version: VERSION2,
    moduleName: "@ag-grid-community/infinite-row-model" /* InfiniteRowModelModule */ ,
    rowModel: "infinite",
    beans: [
        InfiniteRowModel
    ]
};
// community-modules/csv-export/dist/package/main.esm.mjs
var __defProp3 = Object.defineProperty;
var __defProps2 = Object.defineProperties;
var __getOwnPropDesc3 = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols2 = Object.getOwnPropertySymbols;
var __hasOwnProp2 = Object.prototype.hasOwnProperty;
var __propIsEnum2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp2 = (obj, key, value)=>key in obj ? __defProp3(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues2 = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp2.call(b, prop)) __defNormalProp2(a, prop, b[prop]);
    if (__getOwnPropSymbols2) {
        for (var prop of __getOwnPropSymbols2(b))if (__propIsEnum2.call(b, prop)) __defNormalProp2(a, prop, b[prop]);
    }
    return a;
};
var __spreadProps2 = (a, b)=>__defProps2(a, __getOwnPropDescs2(b));
var __decorateClass3 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc3(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) __defProp3(target, key, result);
    return result;
};
var __async = (__this, __arguments, generator)=>{
    return new Promise((resolve, reject)=>{
        var fulfilled = (value)=>{
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = (value)=>{
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = (x)=>x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var BaseCreator = class {
    setBeans(beans) {
        this.beans = beans;
    }
    getFileName(fileName) {
        const extension = this.getDefaultFileExtension();
        if (fileName == null || !fileName.length) fileName = this.getDefaultFileName();
        return fileName.indexOf(".") === -1 ? `${fileName}.${extension}` : fileName;
    }
    getData(params) {
        const serializingSession = this.createSerializingSession(params);
        return this.beans.gridSerializer.serialize(serializingSession, params);
    }
    getDefaultFileName() {
        return `export.${this.getDefaultFileExtension()}`;
    }
};
var BaseGridSerializingSession = class {
    constructor(config){
        this.groupColumns = [];
        const { columnModel, valueService, gos, processCellCallback, processHeaderCallback, processGroupHeaderCallback, processRowGroupCallback } = config;
        this.columnModel = columnModel;
        this.valueService = valueService;
        this.gos = gos;
        this.processCellCallback = processCellCallback;
        this.processHeaderCallback = processHeaderCallback;
        this.processGroupHeaderCallback = processGroupHeaderCallback;
        this.processRowGroupCallback = processRowGroupCallback;
    }
    prepare(columnsToExport) {
        this.groupColumns = columnsToExport.filter((col)=>!!col.getColDef().showRowGroup);
    }
    extractHeaderValue(column) {
        const value = this.getHeaderName(this.processHeaderCallback, column);
        return value != null ? value : "";
    }
    extractRowCellValue(column, index, accumulatedRowIndex, type, node) {
        const hideOpenParents = this.gos.get("groupHideOpenParents");
        const value = (!hideOpenParents || node.footer) && this.shouldRenderGroupSummaryCell(node, column, index) ? this.createValueForGroupNode(column, node) : this.valueService.getValue(column, node);
        const processedValue = this.processCell({
            accumulatedRowIndex,
            rowNode: node,
            column,
            value,
            processCellCallback: this.processCellCallback,
            type
        });
        return processedValue;
    }
    shouldRenderGroupSummaryCell(node, column, currentColumnIndex) {
        var _a;
        const isGroupNode = node && node.group;
        if (!isGroupNode) return false;
        const currentColumnGroupIndex = this.groupColumns.indexOf(column);
        if (currentColumnGroupIndex !== -1) {
            if (((_a = node.groupData) == null ? void 0 : _a[column.getId()]) != null) return true;
            if (this.gos.isRowModelType("serverSide") && node.group) return true;
            if (node.footer && node.level === -1) {
                const colDef = column.getColDef();
                const isFullWidth = colDef == null || colDef.showRowGroup === true;
                return isFullWidth || colDef.showRowGroup === this.columnModel.getRowGroupColumns()[0].getId();
            }
        }
        const isGroupUseEntireRow = this.gos.isGroupUseEntireRow(this.columnModel.isPivotMode());
        return currentColumnIndex === 0 && isGroupUseEntireRow;
    }
    getHeaderName(callback, column) {
        if (callback) return callback(this.gos.addGridCommonParams({
            column
        }));
        return this.columnModel.getDisplayNameForColumn(column, "csv", true);
    }
    createValueForGroupNode(column, node) {
        if (this.processRowGroupCallback) return this.processRowGroupCallback(this.gos.addGridCommonParams({
            column,
            node
        }));
        const isTreeData = this.gos.get("treeData");
        const isSuppressGroupMaintainValueType = this.gos.get("suppressGroupMaintainValueType");
        const getValueFromNode = (node2)=>{
            var _a, _b;
            if (isTreeData || isSuppressGroupMaintainValueType) return node2.key;
            const value = (_a = node2.groupData) == null ? void 0 : _a[column.getId()];
            if (!value || !node2.rowGroupColumn || node2.rowGroupColumn.getColDef().useValueFormatterForExport === false) return value;
            return (_b = this.valueService.formatValue(node2.rowGroupColumn, node2, value)) != null ? _b : value;
        };
        const isFooter = node.footer;
        const keys2 = [
            getValueFromNode(node)
        ];
        if (!this.gos.isGroupMultiAutoColumn()) while(node.parent){
            node = node.parent;
            keys2.push(getValueFromNode(node));
        }
        const groupValue = keys2.reverse().join(" -> ");
        return isFooter ? `Total ${groupValue}` : groupValue;
    }
    processCell(params) {
        var _a;
        const { accumulatedRowIndex, rowNode, column, value, processCellCallback, type } = params;
        if (processCellCallback) return {
            value: (_a = processCellCallback(this.gos.addGridCommonParams({
                accumulatedRowIndex,
                column,
                node: rowNode,
                value,
                type,
                parseValue: (valueToParse)=>this.valueService.parseValue(column, rowNode, valueToParse, this.valueService.getValue(column, rowNode)),
                formatValue: (valueToFormat)=>{
                    var _a2;
                    return (_a2 = this.valueService.formatValue(column, rowNode, valueToFormat)) != null ? _a2 : valueToFormat;
                }
            }))) != null ? _a : ""
        };
        if (column.getColDef().useValueFormatterForExport !== false) return {
            value: value != null ? value : "",
            valueFormatted: this.valueService.formatValue(column, rowNode, value)
        };
        return {
            value: value != null ? value : ""
        };
    }
};
var Downloader = class {
    static download(fileName, content) {
        const win = document.defaultView || window;
        if (!win) {
            console.warn("AG Grid: There is no `window` associated with the current `document`");
            return;
        }
        const element = document.createElement("a");
        const url = win.URL.createObjectURL(content);
        element.setAttribute("href", url);
        element.setAttribute("download", fileName);
        element.style.display = "none";
        document.body.appendChild(element);
        element.dispatchEvent(new MouseEvent("click", {
            bubbles: false,
            cancelable: true,
            view: win
        }));
        document.body.removeChild(element);
        win.setTimeout(()=>{
            win.URL.revokeObjectURL(url);
        }, 0);
    }
};
var LINE_SEPARATOR = "\r\n";
var CsvSerializingSession = class extends BaseGridSerializingSession {
    constructor(config){
        super(config);
        this.isFirstLine = true;
        this.result = "";
        const { suppressQuotes, columnSeparator } = config;
        this.suppressQuotes = suppressQuotes;
        this.columnSeparator = columnSeparator;
    }
    addCustomContent(content) {
        if (!content) return;
        if (typeof content === "string") {
            if (!/^\s*\n/.test(content)) this.beginNewLine();
            content = content.replace(/\r?\n/g, LINE_SEPARATOR);
            this.result += content;
        } else content.forEach((row)=>{
            this.beginNewLine();
            row.forEach((cell, index)=>{
                if (index !== 0) this.result += this.columnSeparator;
                this.result += this.putInQuotes(cell.data.value || "");
                if (cell.mergeAcross) this.appendEmptyCells(cell.mergeAcross);
            });
        });
    }
    onNewHeaderGroupingRow() {
        this.beginNewLine();
        return {
            onColumn: this.onNewHeaderGroupingRowColumn.bind(this)
        };
    }
    onNewHeaderGroupingRowColumn(columnGroup, header, index, span) {
        if (index != 0) this.result += this.columnSeparator;
        this.result += this.putInQuotes(header);
        this.appendEmptyCells(span);
    }
    appendEmptyCells(count) {
        for(let i = 1; i <= count; i++)this.result += this.columnSeparator + this.putInQuotes("");
    }
    onNewHeaderRow() {
        this.beginNewLine();
        return {
            onColumn: this.onNewHeaderRowColumn.bind(this)
        };
    }
    onNewHeaderRowColumn(column, index) {
        if (index != 0) this.result += this.columnSeparator;
        this.result += this.putInQuotes(this.extractHeaderValue(column));
    }
    onNewBodyRow() {
        this.beginNewLine();
        return {
            onColumn: this.onNewBodyRowColumn.bind(this)
        };
    }
    onNewBodyRowColumn(column, index, node) {
        var _a;
        if (index != 0) this.result += this.columnSeparator;
        const rowCellValue = this.extractRowCellValue(column, index, index, "csv", node);
        this.result += this.putInQuotes((_a = rowCellValue.valueFormatted) != null ? _a : rowCellValue.value);
    }
    putInQuotes(value) {
        if (this.suppressQuotes) return value;
        if (value === null || value === void 0) return '""';
        let stringValue;
        if (typeof value === "string") stringValue = value;
        else if (typeof value.toString === "function") stringValue = value.toString();
        else {
            console.warn("AG Grid: unknown value type during csv conversion");
            stringValue = "";
        }
        const valueEscaped = stringValue.replace(/"/g, '""');
        return '"' + valueEscaped + '"';
    }
    parse() {
        return this.result;
    }
    beginNewLine() {
        if (!this.isFirstLine) this.result += LINE_SEPARATOR;
        this.isFirstLine = false;
    }
};
var CsvCreator = class extends BaseCreator {
    postConstruct() {
        this.setBeans({
            gridSerializer: this.gridSerializer,
            gos: this.gos
        });
    }
    getMergedParams(params) {
        const baseParams = this.gos.get("defaultCsvExportParams");
        return Object.assign({}, baseParams, params);
    }
    export(userParams) {
        if (this.isExportSuppressed()) {
            console.warn(`AG Grid: Export cancelled. Export is not allowed as per your configuration.`);
            return;
        }
        const mergedParams = this.getMergedParams(userParams);
        const data = this.getData(mergedParams);
        const packagedFile = new Blob([
            "\uFEFF",
            data
        ], {
            type: "text/plain"
        });
        const fileName = typeof mergedParams.fileName === "function" ? mergedParams.fileName(this.gos.getGridCommonParams()) : mergedParams.fileName;
        Downloader.download(this.getFileName(fileName), packagedFile);
    }
    exportDataAsCsv(params) {
        this.export(params);
    }
    getDataAsCsv(params, skipDefaultParams = false) {
        const mergedParams = skipDefaultParams ? Object.assign({}, params) : this.getMergedParams(params);
        return this.getData(mergedParams);
    }
    getDefaultFileExtension() {
        return "csv";
    }
    createSerializingSession(params) {
        const { columnModel, valueService, gos } = this;
        const { processCellCallback, processHeaderCallback, processGroupHeaderCallback, processRowGroupCallback, suppressQuotes, columnSeparator } = params;
        return new CsvSerializingSession({
            columnModel,
            valueService,
            gos,
            processCellCallback: processCellCallback || void 0,
            processHeaderCallback: processHeaderCallback || void 0,
            processGroupHeaderCallback: processGroupHeaderCallback || void 0,
            processRowGroupCallback: processRowGroupCallback || void 0,
            suppressQuotes: suppressQuotes || false,
            columnSeparator: columnSeparator || ","
        });
    }
    isExportSuppressed() {
        return this.gos.get("suppressCsvExport");
    }
};
__decorateClass3([
    Autowired("columnModel")
], CsvCreator.prototype, "columnModel", 2);
__decorateClass3([
    Autowired("valueService")
], CsvCreator.prototype, "valueService", 2);
__decorateClass3([
    Autowired("gridSerializer")
], CsvCreator.prototype, "gridSerializer", 2);
__decorateClass3([
    Autowired("gridOptionsService")
], CsvCreator.prototype, "gos", 2);
__decorateClass3([
    PostConstruct
], CsvCreator.prototype, "postConstruct", 1);
CsvCreator = __decorateClass3([
    Bean("csvCreator")
], CsvCreator);
var RowType = /* @__PURE__ */ ((RowType2)=>{
    RowType2[RowType2["HEADER_GROUPING"] = 0] = "HEADER_GROUPING";
    RowType2[RowType2["HEADER"] = 1] = "HEADER";
    RowType2[RowType2["BODY"] = 2] = "BODY";
    return RowType2;
})(RowType || {});
var GridSerializer = class extends BeanStub {
    serialize(gridSerializingSession, params = {}) {
        const { allColumns, columnKeys, skipRowGroups } = params;
        const columnsToExport = this.getColumnsToExport(allColumns, skipRowGroups, columnKeys);
        const serializeChain = _.compose(// first pass, put in the header names of the cols
        this.prepareSession(columnsToExport), this.prependContent(params), this.exportColumnGroups(params, columnsToExport), this.exportHeaders(params, columnsToExport), this.processPinnedTopRows(params, columnsToExport), this.processRows(params, columnsToExport), this.processPinnedBottomRows(params, columnsToExport), this.appendContent(params));
        return serializeChain(gridSerializingSession).parse();
    }
    processRow(gridSerializingSession, params, columnsToExport, node) {
        const rowSkipper = params.shouldRowBeSkipped || (()=>false);
        const skipSingleChildrenGroup = this.gos.get("groupRemoveSingleChildren");
        const skipLowestSingleChildrenGroup = this.gos.get("groupRemoveLowestSingleChildren");
        const isClipboardExport = params.rowPositions != null;
        const isExplicitExportSelection = isClipboardExport || !!params.onlySelected;
        const hideOpenParents = this.gos.get("groupHideOpenParents") && !isExplicitExportSelection;
        const isLeafNode = this.columnModel.isPivotMode() ? node.leafGroup : !node.group;
        const isFooter = !!node.footer;
        const skipRowGroups = params.skipRowGroups;
        const shouldSkipLowestGroup = skipLowestSingleChildrenGroup && node.leafGroup;
        const shouldSkipCurrentGroup = node.allChildrenCount === 1 && (skipSingleChildrenGroup || shouldSkipLowestGroup);
        if (!isLeafNode && !isFooter && (params.skipRowGroups || shouldSkipCurrentGroup || hideOpenParents) || params.onlySelected && !node.isSelected() || params.skipPinnedTop && node.rowPinned === "top" || params.skipPinnedBottom && node.rowPinned === "bottom") return;
        const nodeIsRootNode = node.level === -1;
        if (nodeIsRootNode && !isLeafNode && !isFooter) return;
        const shouldRowBeSkipped = rowSkipper(this.gos.addGridCommonParams({
            node
        }));
        if (shouldRowBeSkipped) return;
        const rowAccumulator = gridSerializingSession.onNewBodyRow(node);
        columnsToExport.forEach((column, index)=>{
            rowAccumulator.onColumn(column, index, node);
        });
        if (params.getCustomContentBelowRow) {
            const content = params.getCustomContentBelowRow(this.gos.addGridCommonParams({
                node
            }));
            if (content) gridSerializingSession.addCustomContent(content);
        }
    }
    appendContent(params) {
        return (gridSerializingSession)=>{
            const appendContent = params.appendContent;
            if (appendContent) gridSerializingSession.addCustomContent(appendContent);
            return gridSerializingSession;
        };
    }
    prependContent(params) {
        return (gridSerializingSession)=>{
            const prependContent = params.prependContent;
            if (prependContent) gridSerializingSession.addCustomContent(prependContent);
            return gridSerializingSession;
        };
    }
    prepareSession(columnsToExport) {
        return (gridSerializingSession)=>{
            gridSerializingSession.prepare(columnsToExport);
            return gridSerializingSession;
        };
    }
    exportColumnGroups(params, columnsToExport) {
        return (gridSerializingSession)=>{
            if (!params.skipColumnGroupHeaders) {
                const groupInstanceIdCreator = new GroupInstanceIdCreator();
                const displayedGroups = this.displayedGroupCreator.createDisplayedGroups(columnsToExport, groupInstanceIdCreator, null);
                this.recursivelyAddHeaderGroups(displayedGroups, gridSerializingSession, params.processGroupHeaderCallback);
            }
            return gridSerializingSession;
        };
    }
    exportHeaders(params, columnsToExport) {
        return (gridSerializingSession)=>{
            if (!params.skipColumnHeaders) {
                const gridRowIterator = gridSerializingSession.onNewHeaderRow();
                columnsToExport.forEach((column, index)=>{
                    gridRowIterator.onColumn(column, index, void 0);
                });
            }
            return gridSerializingSession;
        };
    }
    processPinnedTopRows(params, columnsToExport) {
        return (gridSerializingSession)=>{
            const processRow = this.processRow.bind(this, gridSerializingSession, params, columnsToExport);
            if (params.rowPositions) params.rowPositions.filter((position)=>position.rowPinned === "top").sort((a, b)=>a.rowIndex - b.rowIndex).map((position)=>this.pinnedRowModel.getPinnedTopRow(position.rowIndex)).forEach(processRow);
            else this.pinnedRowModel.forEachPinnedTopRow(processRow);
            return gridSerializingSession;
        };
    }
    processRows(params, columnsToExport) {
        return (gridSerializingSession)=>{
            const rowModel = this.rowModel;
            const rowModelType = rowModel.getType();
            const usingCsrm = rowModelType === "clientSide";
            const usingSsrm = rowModelType === "serverSide";
            const onlySelectedNonStandardModel = !usingCsrm && params.onlySelected;
            const processRow = this.processRow.bind(this, gridSerializingSession, params, columnsToExport);
            const { exportedRows = "filteredAndSorted" } = params;
            if (params.rowPositions) params.rowPositions.filter((position)=>position.rowPinned == null).sort((a, b)=>a.rowIndex - b.rowIndex).map((position)=>rowModel.getRow(position.rowIndex)).forEach(processRow);
            else if (this.columnModel.isPivotMode()) {
                if (usingCsrm) rowModel.forEachPivotNode(processRow, true);
                else if (usingSsrm) rowModel.forEachNodeAfterFilterAndSort(processRow, true);
                else rowModel.forEachNode(processRow);
            } else if (params.onlySelectedAllPages || onlySelectedNonStandardModel) {
                const selectedNodes = this.selectionService.getSelectedNodes();
                this.replicateSortedOrder(selectedNodes);
                selectedNodes.forEach(processRow);
            } else {
                if (exportedRows === "all") rowModel.forEachNode(processRow);
                else if (usingCsrm) rowModel.forEachNodeAfterFilterAndSort(processRow, true);
                else if (usingSsrm) rowModel.forEachNodeAfterFilterAndSort(processRow, true);
                else rowModel.forEachNode(processRow);
            }
            return gridSerializingSession;
        };
    }
    replicateSortedOrder(rows) {
        const sortOptions = this.sortController.getSortOptions();
        const compareNodes = (rowA, rowB)=>{
            var _a, _b, _c, _d;
            if (rowA.rowIndex != null && rowB.rowIndex != null) return rowA.rowIndex - rowB.rowIndex;
            if (rowA.level === rowB.level) {
                if (((_a = rowA.parent) == null ? void 0 : _a.id) === ((_b = rowB.parent) == null ? void 0 : _b.id)) return this.rowNodeSorter.compareRowNodes(sortOptions, {
                    rowNode: rowA,
                    currentPos: (_c = rowA.rowIndex) != null ? _c : -1
                }, {
                    rowNode: rowB,
                    currentPos: (_d = rowB.rowIndex) != null ? _d : -1
                });
                return compareNodes(rowA.parent, rowB.parent);
            }
            if (rowA.level > rowB.level) return compareNodes(rowA.parent, rowB);
            return compareNodes(rowA, rowB.parent);
        };
        rows.sort(compareNodes);
    }
    processPinnedBottomRows(params, columnsToExport) {
        return (gridSerializingSession)=>{
            const processRow = this.processRow.bind(this, gridSerializingSession, params, columnsToExport);
            if (params.rowPositions) params.rowPositions.filter((position)=>position.rowPinned === "bottom").sort((a, b)=>a.rowIndex - b.rowIndex).map((position)=>this.pinnedRowModel.getPinnedBottomRow(position.rowIndex)).forEach(processRow);
            else this.pinnedRowModel.forEachPinnedBottomRow(processRow);
            return gridSerializingSession;
        };
    }
    getColumnsToExport(allColumns = false, skipRowGroups = false, columnKeys) {
        const isPivotMode = this.columnModel.isPivotMode();
        if (columnKeys && columnKeys.length) return this.columnModel.getGridColumns(columnKeys);
        const isTreeData = this.gos.get("treeData");
        let columnsToExport = [];
        if (allColumns && !isPivotMode) columnsToExport = this.columnModel.getAllGridColumns();
        else columnsToExport = this.columnModel.getAllDisplayedColumns();
        if (skipRowGroups && !isTreeData) columnsToExport = columnsToExport.filter((column)=>column.getColId() !== GROUP_AUTO_COLUMN_ID);
        return columnsToExport;
    }
    recursivelyAddHeaderGroups(displayedGroups, gridSerializingSession, processGroupHeaderCallback) {
        const directChildrenHeaderGroups = [];
        displayedGroups.forEach((columnGroupChild)=>{
            const columnGroup = columnGroupChild;
            if (!columnGroup.getChildren) return;
            columnGroup.getChildren().forEach((it)=>directChildrenHeaderGroups.push(it));
        });
        if (displayedGroups.length > 0 && displayedGroups[0] instanceof ColumnGroup) this.doAddHeaderHeader(gridSerializingSession, displayedGroups, processGroupHeaderCallback);
        if (directChildrenHeaderGroups && directChildrenHeaderGroups.length > 0) this.recursivelyAddHeaderGroups(directChildrenHeaderGroups, gridSerializingSession, processGroupHeaderCallback);
    }
    doAddHeaderHeader(gridSerializingSession, displayedGroups, processGroupHeaderCallback) {
        const gridRowIterator = gridSerializingSession.onNewHeaderGroupingRow();
        let columnIndex = 0;
        displayedGroups.forEach((columnGroupChild)=>{
            const columnGroup = columnGroupChild;
            let name;
            if (processGroupHeaderCallback) name = processGroupHeaderCallback(this.gos.addGridCommonParams({
                columnGroup
            }));
            else name = this.columnModel.getDisplayNameForColumnGroup(columnGroup, "header");
            const collapsibleGroupRanges = columnGroup.getLeafColumns().reduce((collapsibleGroups, currentColumn, currentIdx, arr)=>{
                let lastGroup = _.last(collapsibleGroups);
                const groupShow = currentColumn.getColumnGroupShow() === "open";
                if (!groupShow) {
                    if (lastGroup && lastGroup[1] == null) lastGroup[1] = currentIdx - 1;
                } else if (!lastGroup || lastGroup[1] != null) {
                    lastGroup = [
                        currentIdx
                    ];
                    collapsibleGroups.push(lastGroup);
                }
                if (currentIdx === arr.length - 1 && lastGroup && lastGroup[1] == null) lastGroup[1] = currentIdx;
                return collapsibleGroups;
            }, []);
            gridRowIterator.onColumn(columnGroup, name || "", columnIndex++, columnGroup.getLeafColumns().length - 1, collapsibleGroupRanges);
        });
    }
};
__decorateClass3([
    Autowired("displayedGroupCreator")
], GridSerializer.prototype, "displayedGroupCreator", 2);
__decorateClass3([
    Autowired("columnModel")
], GridSerializer.prototype, "columnModel", 2);
__decorateClass3([
    Autowired("rowModel")
], GridSerializer.prototype, "rowModel", 2);
__decorateClass3([
    Autowired("pinnedRowModel")
], GridSerializer.prototype, "pinnedRowModel", 2);
__decorateClass3([
    Autowired("selectionService")
], GridSerializer.prototype, "selectionService", 2);
__decorateClass3([
    Autowired("rowNodeSorter")
], GridSerializer.prototype, "rowNodeSorter", 2);
__decorateClass3([
    Autowired("sortController")
], GridSerializer.prototype, "sortController", 2);
GridSerializer = __decorateClass3([
    Bean("gridSerializer")
], GridSerializer);
var VERSION3 = "31.3.4";
var CsvExportModule = {
    version: VERSION3,
    moduleName: "@ag-grid-community/csv-export" /* CsvExportModule */ ,
    beans: [
        CsvCreator,
        GridSerializer
    ]
};
var LINE_SEPARATOR2 = "\r\n";
var XmlFactory = class {
    static createHeader(headerElement = {}) {
        const headerStart = "<?";
        const headerEnd = "?>";
        const keys2 = [
            "version"
        ];
        if (!headerElement.version) headerElement.version = "1.0";
        if (headerElement.encoding) keys2.push("encoding");
        if (headerElement.standalone) keys2.push("standalone");
        const att = keys2.map((key)=>`${key}="${headerElement[key]}"`).join(" ");
        return `${headerStart}xml ${att} ${headerEnd}`;
    }
    static createXml(xmlElement, booleanTransformer) {
        let props = "";
        if (xmlElement.properties) {
            if (xmlElement.properties.prefixedAttributes) xmlElement.properties.prefixedAttributes.forEach((prefixedSet)=>{
                Object.keys(prefixedSet.map).forEach((key)=>{
                    props += this.returnAttributeIfPopulated(prefixedSet.prefix + key, prefixedSet.map[key], booleanTransformer);
                });
            });
            if (xmlElement.properties.rawMap) Object.keys(xmlElement.properties.rawMap).forEach((key)=>{
                props += this.returnAttributeIfPopulated(key, xmlElement.properties.rawMap[key], booleanTransformer);
            });
        }
        let result = "<" + xmlElement.name + props;
        if (!xmlElement.children && xmlElement.textNode == null) return result + "/>" + LINE_SEPARATOR2;
        if (xmlElement.textNode != null) return result + ">" + xmlElement.textNode + "</" + xmlElement.name + ">" + LINE_SEPARATOR2;
        result += ">" + LINE_SEPARATOR2;
        if (xmlElement.children) xmlElement.children.forEach((it)=>{
            result += this.createXml(it, booleanTransformer);
        });
        return result + "</" + xmlElement.name + ">" + LINE_SEPARATOR2;
    }
    static returnAttributeIfPopulated(key, value, booleanTransformer) {
        if (!value && value !== "" && value !== 0) return "";
        let xmlValue = value;
        if (typeof value === "boolean") {
            if (booleanTransformer) xmlValue = booleanTransformer(value);
        }
        return ` ${key}="${xmlValue}"`;
    }
};
var convertTime = (date)=>{
    let time = date.getHours();
    time <<= 6;
    time = time | date.getMinutes();
    time <<= 5;
    time = time | date.getSeconds() / 2;
    return time;
};
var convertDate = (date)=>{
    let dt = date.getFullYear() - 1980;
    dt <<= 4;
    dt = dt | date.getMonth() + 1;
    dt <<= 5;
    dt = dt | date.getDate();
    return dt;
};
function convertDecToHex(number, bytes) {
    let hex = "";
    for(let i = 0; i < bytes; i++){
        hex += String.fromCharCode(number & 255);
        number >>>= 8;
    }
    return hex;
}
var getCrcFromCrc32TableAndByteArray = (content)=>{
    if (!content.length) return 0;
    let crc = -1;
    let j = 0;
    let k = 0;
    let l = 0;
    for(let i = 0; i < content.length; i++){
        j = content[i];
        k = (crc ^ j) & 255;
        l = crcTable[k];
        crc = crc >>> 8 ^ l;
    }
    return crc ^ -1;
};
var getCrcFromCrc32Table = (content)=>{
    if (!content.length) return 0;
    if (typeof content === "string") return getCrcFromCrc32TableAndByteArray(new TextEncoder().encode(content));
    return getCrcFromCrc32TableAndByteArray(content);
};
var crcTable = new Uint32Array([
    0,
    1996959894,
    3993919788,
    2567524794,
    124634137,
    1886057615,
    3915621685,
    2657392035,
    249268274,
    2044508324,
    3772115230,
    2547177864,
    162941995,
    2125561021,
    3887607047,
    2428444049,
    498536548,
    1789927666,
    4089016648,
    2227061214,
    450548861,
    1843258603,
    4107580753,
    2211677639,
    325883990,
    1684777152,
    4251122042,
    2321926636,
    335633487,
    1661365465,
    4195302755,
    2366115317,
    997073096,
    1281953886,
    3579855332,
    2724688242,
    1006888145,
    1258607687,
    3524101629,
    2768942443,
    901097722,
    1119000684,
    3686517206,
    2898065728,
    853044451,
    1172266101,
    3705015759,
    2882616665,
    651767980,
    1373503546,
    3369554304,
    3218104598,
    565507253,
    1454621731,
    3485111705,
    3099436303,
    671266974,
    1594198024,
    3322730930,
    2970347812,
    795835527,
    1483230225,
    3244367275,
    3060149565,
    1994146192,
    31158534,
    2563907772,
    4023717930,
    1907459465,
    112637215,
    2680153253,
    3904427059,
    2013776290,
    251722036,
    2517215374,
    3775830040,
    2137656763,
    141376813,
    2439277719,
    3865271297,
    1802195444,
    476864866,
    2238001368,
    4066508878,
    1812370925,
    453092731,
    2181625025,
    4111451223,
    1706088902,
    314042704,
    2344532202,
    4240017532,
    1658658271,
    366619977,
    2362670323,
    4224994405,
    1303535960,
    984961486,
    2747007092,
    3569037538,
    1256170817,
    1037604311,
    2765210733,
    3554079995,
    1131014506,
    879679996,
    2909243462,
    3663771856,
    1141124467,
    855842277,
    2852801631,
    3708648649,
    1342533948,
    654459306,
    3188396048,
    3373015174,
    1466479909,
    544179635,
    3110523913,
    3462522015,
    1591671054,
    702138776,
    2966460450,
    3352799412,
    1504918807,
    783551873,
    3082640443,
    3233442989,
    3988292384,
    2596254646,
    62317068,
    1957810842,
    3939845945,
    2647816111,
    81470997,
    1943803523,
    3814918930,
    2489596804,
    225274430,
    2053790376,
    3826175755,
    2466906013,
    167816743,
    2097651377,
    4027552580,
    2265490386,
    503444072,
    1762050814,
    4150417245,
    2154129355,
    426522225,
    1852507879,
    4275313526,
    2312317920,
    282753626,
    1742555852,
    4189708143,
    2394877945,
    397917763,
    1622183637,
    3604390888,
    2714866558,
    953729732,
    1340076626,
    3518719985,
    2797360999,
    1068828381,
    1219638859,
    3624741850,
    2936675148,
    906185462,
    1090812512,
    3747672003,
    2825379669,
    829329135,
    1181335161,
    3412177804,
    3160834842,
    628085408,
    1382605366,
    3423369109,
    3138078467,
    570562233,
    1426400815,
    3317316542,
    2998733608,
    733239954,
    1555261956,
    3268935591,
    3050360625,
    752459403,
    1541320221,
    2607071920,
    3965973030,
    1969922972,
    40735498,
    2617837225,
    3943577151,
    1913087877,
    83908371,
    2512341634,
    3803740692,
    2075208622,
    213261112,
    2463272603,
    3855990285,
    2094854071,
    198958881,
    2262029012,
    4057260610,
    1759359992,
    534414190,
    2176718541,
    4139329115,
    1873836001,
    414664567,
    2282248934,
    4279200368,
    1711684554,
    285281116,
    2405801727,
    4167216745,
    1634467795,
    376229701,
    2685067896,
    3608007406,
    1308918612,
    956543938,
    2808555105,
    3495958263,
    1231636301,
    1047427035,
    2932959818,
    3654703836,
    1088359270,
    936918e3,
    2847714899,
    3736837829,
    1202900863,
    817233897,
    3183342108,
    3401237130,
    1404277552,
    615818150,
    3134207493,
    3453421203,
    1423857449,
    601450431,
    3009837614,
    3294710456,
    1567103746,
    711928724,
    3020668471,
    3272380065,
    1510334235,
    755167117
]);
var compressBlob = (data)=>__async(void 0, null, function*() {
        let chunksSize = 0;
        const chunks = [];
        const writeCompressedData = new WritableStream({
            write: (chunk)=>{
                chunks.push(chunk);
                chunksSize += chunk.length;
            }
        });
        const readable = new ReadableStream({
            start: (controller)=>{
                const reader = new FileReader();
                reader.onload = (e)=>{
                    var _a;
                    if ((_a = e.target) == null ? void 0 : _a.result) controller.enqueue(e.target.result);
                    controller.close();
                };
                reader.readAsArrayBuffer(data);
            }
        });
        const compressStream = new window.CompressionStream("deflate-raw");
        yield readable.pipeThrough(compressStream).pipeTo(writeCompressedData);
        return {
            size: chunksSize,
            content: new Blob(chunks)
        };
    });
var deflateLocalFile = (rawContent)=>__async(void 0, null, function*() {
        const contentAsBlob = new Blob([
            rawContent
        ]);
        const { size: compressedSize, content: compressedContent } = yield compressBlob(contentAsBlob);
        const compressedContentAsUint8Array = new Uint8Array((yield compressedContent.arrayBuffer()));
        return {
            size: compressedSize,
            content: compressedContentAsUint8Array
        };
    });
var { utf8_encode: utf8_encode2 } = _;
var getDeflatedHeaderAndContent = (currentFile, offset)=>__async(void 0, null, function*() {
        const { content } = currentFile;
        const { size, content: rawContent } = !content ? {
            size: 0,
            content: Uint8Array.from([])
        } : getDecodedContent(content);
        let deflatedContent = void 0;
        let deflatedSize = void 0;
        let deflationPerformed = false;
        const shouldDeflate = currentFile.type === "file" && rawContent && size > 0;
        if (shouldDeflate) {
            const result = yield deflateLocalFile(rawContent);
            deflatedContent = result.content;
            deflatedSize = result.size;
            deflationPerformed = true;
        }
        const headers = getHeaders(currentFile, deflationPerformed, offset, size, rawContent, deflatedSize);
        return __spreadProps2(__spreadValues2({}, headers), {
            content: deflatedContent || rawContent,
            isCompressed: deflationPerformed
        });
    });
var getHeaderAndContent = (currentFile, offset)=>{
    const { content } = currentFile;
    const { content: rawContent } = !content ? {
        content: Uint8Array.from([])
    } : getDecodedContent(content);
    const headers = getHeaders(currentFile, false, offset, rawContent.length, rawContent, void 0);
    return __spreadProps2(__spreadValues2({}, headers), {
        content: rawContent,
        isCompressed: false
    });
};
var getHeaders = (currentFile, isCompressed, offset, rawSize, rawContent, deflatedSize)=>{
    const { content, path, created: creationDate } = currentFile;
    const time = convertTime(creationDate);
    const dt = convertDate(creationDate);
    const crcFlag = getCrcFromCrc32Table(rawContent);
    const zipSize = deflatedSize !== void 0 ? deflatedSize : rawSize;
    const utfPath = utf8_encode2(path);
    const isUTF8 = utfPath !== path;
    let extraFields = "";
    if (isUTF8) {
        const uExtraFieldPath = convertDecToHex(1, 1) + convertDecToHex(getCrcFromCrc32Table(utfPath), 4) + utfPath;
        extraFields = "up" + convertDecToHex(uExtraFieldPath.length, 2) + uExtraFieldPath;
    }
    const commonHeader = "\0" + // version needed to extract
    (isUTF8 ? "\0\b" : "\0\0") + // Language encoding flag (EFS) (12th bit turned on)
    convertDecToHex(isCompressed ? 8 : 0, 2) + // As per ECMA-376 Part 2 specs
    convertDecToHex(time, 2) + // last modified time
    convertDecToHex(dt, 2) + // last modified date
    convertDecToHex(zipSize ? crcFlag : 0, 4) + convertDecToHex(deflatedSize != null ? deflatedSize : rawSize, 4) + // compressed size
    convertDecToHex(rawSize, 4) + // uncompressed size
    convertDecToHex(utfPath.length, 2) + // file name length
    convertDecToHex(extraFields.length, 2);
    const localFileHeader = "PK" + commonHeader + utfPath + extraFields;
    const centralDirectoryHeader = "PK\0" + commonHeader + // file header
    "\0\0\0\0\0\0" + (content ? "\0\0\0\0" : "\0\0\0") + // external file attributes
    convertDecToHex(offset, 4) + // relative offset of local header
    utfPath + // file name
    extraFields;
    return {
        localFileHeader: Uint8Array.from(localFileHeader, (c)=>c.charCodeAt(0)),
        centralDirectoryHeader: Uint8Array.from(centralDirectoryHeader, (c)=>c.charCodeAt(0))
    };
};
var buildCentralDirectoryEnd = (tLen, cLen, lLen)=>{
    const str = "PK\0\0\0\0" + convertDecToHex(tLen, 2) + // total number of entries in the central folder
    convertDecToHex(tLen, 2) + // total number of entries in the central folder
    convertDecToHex(cLen, 4) + // size of the central folder
    convertDecToHex(lLen, 4) + // central folder start offset
    "\0\0";
    return Uint8Array.from(str, (c)=>c.charCodeAt(0));
};
var convertStringToByteArray = (str)=>{
    const bytes = new Uint8Array(str.length);
    for(let i = 0; i < str.length; i++)bytes[i] = str.charCodeAt(i);
    return bytes;
};
var getDecodedContent = (content)=>{
    let contentToUse;
    if (typeof content === "string") {
        const base64String = atob(content.split(";base64,")[1]);
        contentToUse = convertStringToByteArray(base64String);
    } else contentToUse = content;
    return {
        size: contentToUse.length,
        content: contentToUse
    };
};
var ZipContainer = class {
    static addFolders(paths) {
        paths.forEach(this.addFolder.bind(this));
    }
    static addFolder(path) {
        this.folders.push({
            path,
            created: /* @__PURE__ */ new Date(),
            isBase64: false,
            type: "folder"
        });
    }
    static addFile(path, content, isBase64 = false) {
        this.files.push({
            path,
            created: /* @__PURE__ */ new Date(),
            content: isBase64 ? content : new TextEncoder().encode(content),
            isBase64,
            type: "file"
        });
    }
    static getZipFile(mimeType = "application/zip") {
        return __async(this, null, function*() {
            const textOutput = yield this.buildCompressedFileStream();
            this.clearStream();
            return new Blob([
                textOutput
            ], {
                type: mimeType
            });
        });
    }
    static getUncompressedZipFile(mimeType = "application/zip") {
        const textOutput = this.buildFileStream();
        this.clearStream();
        return new Blob([
            textOutput
        ], {
            type: mimeType
        });
    }
    static clearStream() {
        this.folders = [];
        this.files = [];
    }
    static packageFiles(files) {
        let fileData = new Uint8Array(0);
        let folderData = new Uint8Array(0);
        let filesContentAndHeaderLength = 0;
        let folderHeadersLength = 0;
        for (const currentFile of files){
            const { localFileHeader, centralDirectoryHeader, content } = currentFile;
            const dataWithHeader = new Uint8Array(fileData.length + localFileHeader.length);
            dataWithHeader.set(fileData);
            dataWithHeader.set(localFileHeader, fileData.length);
            fileData = dataWithHeader;
            const dataWithContent = new Uint8Array(fileData.length + content.length);
            dataWithContent.set(fileData);
            dataWithContent.set(content, fileData.length);
            fileData = dataWithContent;
            const folderDataWithFolderHeader = new Uint8Array(folderData.length + centralDirectoryHeader.length);
            folderDataWithFolderHeader.set(folderData);
            folderDataWithFolderHeader.set(centralDirectoryHeader, folderData.length);
            folderData = folderDataWithFolderHeader;
            filesContentAndHeaderLength += localFileHeader.length + content.length;
            folderHeadersLength += centralDirectoryHeader.length;
        }
        const folderEnd = buildCentralDirectoryEnd(files.length, folderHeadersLength, filesContentAndHeaderLength);
        const result = new Uint8Array(fileData.length + folderData.length + folderEnd.length);
        result.set(fileData);
        result.set(folderData, fileData.length);
        result.set(folderEnd, fileData.length + folderData.length);
        return result;
    }
    static buildCompressedFileStream() {
        return __async(this, null, function*() {
            const totalFiles = [
                ...this.folders,
                ...this.files
            ];
            const readyFiles = [];
            let lL = 0;
            for (const currentFile of totalFiles){
                const output = yield getDeflatedHeaderAndContent(currentFile, lL);
                const { localFileHeader, content } = output;
                readyFiles.push(output);
                lL += localFileHeader.length + content.length;
            }
            return this.packageFiles(readyFiles);
        });
    }
    static buildFileStream() {
        const totalFiles = [
            ...this.folders,
            ...this.files
        ];
        const readyFiles = [];
        let lL = 0;
        for (const currentFile of totalFiles){
            const readyFile = getHeaderAndContent(currentFile, lL);
            const { localFileHeader, content } = readyFile;
            readyFiles.push(readyFile);
            lL += localFileHeader.length + content.length;
        }
        return this.packageFiles(readyFiles);
    }
};
ZipContainer.folders = [];
ZipContainer.files = [];
// packages/ag-grid-community/src/main.ts
ModuleRegistry.__registerModules([
    ClientSideRowModelModule,
    InfiniteRowModelModule,
    CsvExportModule
], false, void 0);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hRNim":[function(require,module,exports,__globalThis) {
'use strict';
var l, s;
l = require("16f31c1727ed0291");
s = require("d38e18015ef6662b");
exports.version = l.version;
exports.renderToString = l.renderToString;
exports.renderToStaticMarkup = l.renderToStaticMarkup;
exports.renderToNodeStream = l.renderToNodeStream;
exports.renderToStaticNodeStream = l.renderToStaticNodeStream;
exports.renderToReadableStream = s.renderToReadableStream;

},{"16f31c1727ed0291":"fkC0T","d38e18015ef6662b":"e1KKT"}],"fkC0T":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var aa = require("51526ccfbe8a07b8");
function l(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var p = Object.prototype.hasOwnProperty, fa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ha = {}, ia = {};
function ja(a) {
    if (p.call(ia, a)) return !0;
    if (p.call(ha, a)) return !1;
    if (fa.test(a)) return ia[a] = !0;
    ha[a] = !0;
    return !1;
}
function r(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    t[a] = new r(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    t[b] = new r(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    t[a] = new r(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    t[a] = new r(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    t[a] = new r(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    t[a] = new r(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    t[a] = new r(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    t[a] = new r(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    t[a] = new r(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ka = /[\-:]([a-z])/g;
function la(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(ka, la);
    t[b] = new r(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ka, la);
    t[b] = new r(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(ka, la);
    t[b] = new r(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    t[a] = new r(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
t.xlinkHref = new r("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    t[a] = new r(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var u = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, ma = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(u).forEach(function(a) {
    ma.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        u[b] = u[a];
    });
});
var na = /["'&<>]/;
function v(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = na.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var oa = /([A-Z])/g, pa = /^ms-/, qa = Array.isArray;
function w(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function ra(a, b, c) {
    switch(b){
        case "select":
            return w(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return w(2, null);
        case "math":
            return w(3, null);
        case "foreignObject":
            return w(1, null);
        case "table":
            return w(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return w(5, null);
        case "colgroup":
            return w(7, null);
        case "tr":
            return w(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? w(1, null) : a;
}
var sa = new Map;
function ta(a, b, c) {
    if ("object" !== typeof c) throw Error(l(62));
    b = !0;
    for(var d in c)if (p.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = v(d);
                f = v(("" + f).trim());
            } else {
                e = d;
                var g = sa.get(e);
                void 0 !== g ? e = g : (g = v(e.replace(oa, "-$1").toLowerCase().replace(pa, "-ms-")), sa.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || p.call(u, d) ? "" + f : f + "px" : v(("" + f).trim());
            }
            b ? (b = !1, a.push(' style="', e, ":", f)) : a.push(";", e, ":", f);
        }
    }
    b || a.push('"');
}
function x(a, b, c, d) {
    switch(c){
        case "style":
            ta(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = t.hasOwnProperty(c) ? t[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = b.attributeName;
            switch(b.type){
                case 3:
                    d && a.push(" ", c, '=""');
                    break;
                case 4:
                    !0 === d ? a.push(" ", c, '=""') : !1 !== d && a.push(" ", c, '="', v(d), '"');
                    break;
                case 5:
                    isNaN(d) || a.push(" ", c, '="', v(d), '"');
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push(" ", c, '="', v(d), '"');
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push(" ", c, '="', v(d), '"');
            }
        } else if (ja(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push(" ", c, '="', v(d), '"');
        }
    }
}
function y(a, b, c) {
    if (null != b) {
        if (null != c) throw Error(l(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error(l(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push("" + b);
    }
}
function ua(a) {
    var b = "";
    aa.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function va(a, b, c, d) {
    a.push(A(c));
    var f = c = null, e;
    for(e in b)if (p.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                x(a, d, e, g);
        }
    }
    a.push(">");
    y(a, f, c);
    return "string" === typeof c ? (a.push(v(c)), null) : c;
}
var wa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, xa = new Map;
function A(a) {
    var b = xa.get(a);
    if (void 0 === b) {
        if (!wa.test(a)) throw Error(l(65, a));
        b = "<" + a;
        xa.set(a, b);
    }
    return b;
}
function ya(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push(A("select"));
            var e = null, g = null;
            for(n in c)if (p.call(c, n)) {
                var h = c[n];
                if (null != h) switch(n){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        x(a, d, n, h);
                }
            }
            a.push(">");
            y(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push(A("option"));
            var k = h = null, m = null;
            var n = null;
            for(e in c)if (p.call(c, e)) {
                var q = c[e];
                if (null != q) switch(e){
                    case "children":
                        h = q;
                        break;
                    case "selected":
                        m = q;
                        break;
                    case "dangerouslySetInnerHTML":
                        n = q;
                        break;
                    case "value":
                        k = q;
                    default:
                        x(a, d, e, q);
                }
            }
            if (null != g) {
                if (c = null !== k ? "" + k : ua(h), qa(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push(' selected=""');
                        break;
                    }
                } else "" + g === c && a.push(' selected=""');
            } else m && a.push(' selected=""');
            a.push(">");
            y(a, n, h);
            return h;
        case "textarea":
            a.push(A("textarea"));
            n = g = e = null;
            for(h in c)if (p.call(c, h) && (k = c[h], null != k)) switch(h){
                case "children":
                    n = k;
                    break;
                case "value":
                    e = k;
                    break;
                case "defaultValue":
                    g = k;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error(l(91));
                default:
                    x(a, d, h, k);
            }
            null === e && null !== g && (e = g);
            a.push(">");
            if (null != n) {
                if (null != e) throw Error(l(92));
                if (qa(n) && 1 < n.length) throw Error(l(93));
                e = "" + n;
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            null !== e && a.push(v("" + e));
            return null;
        case "input":
            a.push(A("input"));
            k = n = h = e = null;
            for(g in c)if (p.call(c, g) && (m = c[g], null != m)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error(l(399, "input"));
                case "defaultChecked":
                    k = m;
                    break;
                case "defaultValue":
                    h = m;
                    break;
                case "checked":
                    n = m;
                    break;
                case "value":
                    e = m;
                    break;
                default:
                    x(a, d, g, m);
            }
            null !== n ? x(a, d, "checked", n) : null !== k && x(a, d, "checked", k);
            null !== e ? x(a, d, "value", e) : null !== h && x(a, d, "value", h);
            a.push("/>");
            return null;
        case "menuitem":
            a.push(A("menuitem"));
            for(var C in c)if (p.call(c, C) && (e = c[C], null != e)) switch(C){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error(l(400));
                default:
                    x(a, d, C, e);
            }
            a.push(">");
            return null;
        case "title":
            a.push(A("title"));
            e = null;
            for(q in c)if (p.call(c, q) && (g = c[q], null != g)) switch(q){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error(l(434));
                default:
                    x(a, d, q, g);
            }
            a.push(">");
            return e;
        case "listing":
        case "pre":
            a.push(A(b));
            g = e = null;
            for(k in c)if (p.call(c, k) && (h = c[k], null != h)) switch(k){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    x(a, d, k, h);
            }
            a.push(">");
            if (null != g) {
                if (null != e) throw Error(l(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error(l(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push("\n", c) : a.push("" + c));
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push(A(b));
            for(var D in c)if (p.call(c, D) && (e = c[D], null != e)) switch(D){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error(l(399, b));
                default:
                    x(a, d, D, e);
            }
            a.push("/>");
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return va(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push("<!DOCTYPE html>"), va(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return va(a, c, b, d);
            a.push(A(b));
            g = e = null;
            for(m in c)if (p.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    ta(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    ja(m) && "function" !== typeof h && "symbol" !== typeof h && a.push(" ", m, '="', v(h), '"');
            }
            a.push(">");
            y(a, g, e);
            return e;
    }
}
function za(a, b, c) {
    a.push('\x3c!--$?--\x3e<template id="');
    if (null === c) throw Error(l(395));
    a.push(c);
    return a.push('"></template>');
}
function Aa(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return a.push('<div hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 2:
            return a.push('<svg aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 3:
            return a.push('<math aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 4:
            return a.push('<table hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 5:
            return a.push('<table hidden><tbody id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 6:
            return a.push('<table hidden><tr id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 7:
            return a.push('<table hidden><colgroup id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        default:
            throw Error(l(397));
    }
}
function Ba(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return a.push("</div>");
        case 2:
            return a.push("</svg>");
        case 3:
            return a.push("</math>");
        case 4:
            return a.push("</table>");
        case 5:
            return a.push("</tbody></table>");
        case 6:
            return a.push("</tr></table>");
        case 7:
            return a.push("</colgroup></table>");
        default:
            throw Error(l(397));
    }
}
var Ca = /[<\u2028\u2029]/g;
function Da(a) {
    return JSON.stringify(a).replace(Ca, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
function Ea(a, b) {
    b = void 0 === b ? "" : b;
    return {
        bootstrapChunks: [],
        startInlineScript: "<script>",
        placeholderPrefix: b + "P:",
        segmentPrefix: b + "S:",
        boundaryPrefix: b + "B:",
        idPrefix: b,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1,
        generateStaticMarkup: a
    };
}
function Fa(a, b, c, d) {
    if (c.generateStaticMarkup) return a.push(v(b)), !1;
    "" === b ? a = d : (d && a.push("\x3c!-- --\x3e"), a.push(v(b)), a = !0);
    return a;
}
var B = Object.assign, Ga = Symbol.for("react.element"), Ha = Symbol.for("react.portal"), Ia = Symbol.for("react.fragment"), Ja = Symbol.for("react.strict_mode"), Ka = Symbol.for("react.profiler"), La = Symbol.for("react.provider"), Ma = Symbol.for("react.context"), Na = Symbol.for("react.forward_ref"), Oa = Symbol.for("react.suspense"), Pa = Symbol.for("react.suspense_list"), Qa = Symbol.for("react.memo"), Ra = Symbol.for("react.lazy"), Sa = Symbol.for("react.scope"), Ta = Symbol.for("react.debug_trace_mode"), Ua = Symbol.for("react.legacy_hidden"), Va = Symbol.for("react.default_value"), Wa = Symbol.iterator;
function Xa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case Ia:
            return "Fragment";
        case Ha:
            return "Portal";
        case Ka:
            return "Profiler";
        case Ja:
            return "StrictMode";
        case Oa:
            return "Suspense";
        case Pa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case Ma:
            return (a.displayName || "Context") + ".Consumer";
        case La:
            return (a._context.displayName || "Context") + ".Provider";
        case Na:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case Qa:
            return b = a.displayName || null, null !== b ? b : Xa(a.type) || "Memo";
        case Ra:
            b = a._payload;
            a = a._init;
            try {
                return Xa(a(b));
            } catch (c) {}
    }
    return null;
}
var Ya = {};
function Za(a, b) {
    a = a.contextTypes;
    if (!a) return Ya;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var E = null;
function F(a, b) {
    if (a !== b) {
        a.context._currentValue2 = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error(l(401));
        } else {
            if (null === c) throw Error(l(401));
            F(a, c);
        }
        b.context._currentValue2 = b.value;
    }
}
function $a(a) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    null !== a && $a(a);
}
function ab(a) {
    var b = a.parent;
    null !== b && ab(b);
    a.context._currentValue2 = a.value;
}
function bb(a, b) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    if (null === a) throw Error(l(402));
    a.depth === b.depth ? F(a, b) : bb(a, b);
}
function cb(a, b) {
    var c = b.parent;
    if (null === c) throw Error(l(402));
    a.depth === c.depth ? F(a, c) : cb(a, c);
    b.context._currentValue2 = b.value;
}
function G(a) {
    var b = E;
    b !== a && (null === b ? ab(a) : null === a ? $a(b) : b.depth === a.depth ? F(b, a) : b.depth > a.depth ? bb(b, a) : cb(b, a), E = a);
}
var db = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function eb(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = db;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue2 : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : B({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && db.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = B({}, e, h)) : B(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var fb = {
    id: 1,
    overflow: ""
};
function gb(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - H(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - H(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - H(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var H = Math.clz32 ? Math.clz32 : hb, ib = Math.log, jb = Math.LN2;
function hb(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (ib(a) / jb | 0) | 0;
}
function kb(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var lb = "function" === typeof Object.is ? Object.is : kb, I = null, ob = null, J = null, K = null, L = !1, M = !1, N = 0, O = null, P = 0;
function Q() {
    if (null === I) throw Error(l(321));
    return I;
}
function pb() {
    if (0 < P) throw Error(l(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function qb() {
    null === K ? null === J ? (L = !1, J = K = pb()) : (L = !0, K = J) : null === K.next ? (L = !1, K = K.next = pb()) : (L = !0, K = K.next);
    return K;
}
function rb() {
    ob = I = null;
    M = !1;
    J = null;
    P = 0;
    K = O = null;
}
function sb(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function tb(a, b, c) {
    I = Q();
    K = qb();
    if (L) {
        var d = K.queue;
        b = d.dispatch;
        if (null !== O && (c = O.get(d), void 0 !== c)) {
            O.delete(d);
            d = K.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            K.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            K.memoizedState,
            b
        ];
    }
    a = a === sb ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    K.memoizedState = a;
    a = K.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = ub.bind(null, I, a);
    return [
        K.memoizedState,
        a
    ];
}
function vb(a, b) {
    I = Q();
    K = qb();
    b = void 0 === b ? null : b;
    if (null !== K) {
        var c = K.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!lb(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    K.memoizedState = [
        a,
        b
    ];
    return a;
}
function ub(a, b, c) {
    if (25 <= P) throw Error(l(301));
    if (a === I) {
        if (M = !0, a = {
            action: c,
            next: null
        }, null === O && (O = new Map), c = O.get(b), void 0 === c) O.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function wb() {
    throw Error(l(394));
}
function R() {}
var xb = {
    readContext: function(a) {
        return a._currentValue2;
    },
    useContext: function(a) {
        Q();
        return a._currentValue2;
    },
    useMemo: vb,
    useReducer: tb,
    useRef: function(a) {
        I = Q();
        K = qb();
        var b = K.memoizedState;
        return null === b ? (a = {
            current: a
        }, K.memoizedState = a) : b;
    },
    useState: function(a) {
        return tb(sb, a);
    },
    useInsertionEffect: R,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return vb(function() {
            return a;
        }, b);
    },
    useImperativeHandle: R,
    useEffect: R,
    useDebugValue: R,
    useDeferredValue: function(a) {
        Q();
        return a;
    },
    useTransition: function() {
        Q();
        return [
            !1,
            wb
        ];
    },
    useId: function() {
        var a = ob.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - H(a) - 1)).toString(32) + b;
        var c = S;
        if (null === c) throw Error(l(404));
        b = N++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        Q();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error(l(407));
        return c();
    }
}, S = null, yb = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function zb(a) {
    console.error(a);
    return null;
}
function T() {}
function Ab(a, b, c, d, f, e, g, h, k) {
    var m = [], n = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: n,
        pingedTasks: m,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? zb : f,
        onAllReady: void 0 === e ? T : e,
        onShellReady: void 0 === g ? T : g,
        onShellError: void 0 === h ? T : h,
        onFatalError: void 0 === k ? T : k
    };
    c = U(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = Bb(b, a, null, c, n, Ya, null, fb);
    m.push(a);
    return b;
}
function Bb(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var k = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(k);
            1 === b.length && Cb(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(k);
    return k;
}
function U(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function V(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function W(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, a.destination.destroy(b)) : (a.status = 1, a.fatalError = b);
}
function Db(a, b, c, d, f) {
    I = {};
    ob = b;
    N = 0;
    for(a = c(d, f); M;)M = !1, N = 0, P += 1, K = null, a = c(d, f);
    rb();
    return a;
}
function Eb(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error(l(108, Xa(d) || "Unknown", h));
            d = B({}, g, c);
        }
        b.legacyContext = d;
        X(a, b, f);
        b.legacyContext = g;
    } else X(a, b, f);
}
function Fb(a, b) {
    if (a && a.defaultProps) {
        b = B({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function Gb(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = Za(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue2 : f);
            eb(e, c, d, f);
            Eb(a, b, e, c);
        } else {
            e = Za(c, b.legacyContext);
            f = Db(a, b, c, d, e);
            var g = 0 !== N;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) eb(f, c, d, e), Eb(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = gb(d, 1, 0);
                try {
                    X(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else X(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = ya(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = ra(g, c, d);
        Hb(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push("</", c, ">");
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case Ua:
            case Ta:
            case Ja:
            case Ka:
            case Ia:
                X(a, b, d.children);
                return;
            case Pa:
                X(a, b, d.children);
                return;
            case Sa:
                throw Error(l(343));
            case Oa:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, k = U(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(k);
                    f.lastPushedText = !1;
                    var m = U(a, 0, null, f.formatContext, !1, !1);
                    m.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = m;
                    try {
                        if (Hb(a, b, d), a.responseState.generateStaticMarkup || m.lastPushedText && m.textEmbedded && m.chunks.push("\x3c!-- --\x3e"), m.status = 1, Y(h, m), 0 === h.pendingTasks) break a;
                    } catch (n) {
                        m.status = 4, h.forceClientRender = !0, h.errorDigest = V(a, n);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = Bb(a, e, c, k, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case Na:
                d = Db(a, b, c.render, d, f);
                if (0 !== N) {
                    c = b.treeContext;
                    b.treeContext = gb(c, 1, 0);
                    try {
                        X(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else X(a, b, d);
                return;
            case Qa:
                c = c.type;
                d = Fb(c, d);
                Gb(a, b, c, d, f);
                return;
            case La:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue2;
                c._currentValue2 = d;
                g = E;
                E = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                X(a, b, f);
                a = E;
                if (null === a) throw Error(l(403));
                d = a.parentValue;
                a.context._currentValue2 = d === Va ? a.context._defaultValue : d;
                a = E = a.parent;
                b.context = a;
                return;
            case Ma:
                d = d.children;
                d = d(c._currentValue2);
                X(a, b, d);
                return;
            case Ra:
                f = c._init;
                c = f(c._payload);
                d = Fb(c, d);
                Gb(a, b, c, d, void 0);
                return;
        }
        throw Error(l(130, null == c ? c : typeof c, ""));
    }
}
function X(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case Ga:
                Gb(a, b, c.type, c.props, c.ref);
                return;
            case Ha:
                throw Error(l(257));
            case Ra:
                var d = c._init;
                c = d(c._payload);
                X(a, b, c);
                return;
        }
        if (qa(c)) {
            Ib(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = Wa && c[Wa] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                Ib(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error(l(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = Fa(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = Fa(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function Ib(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = gb(e, d, f);
        try {
            Hb(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function Hb(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return X(a, b, c);
    } catch (k) {
        if (rb(), "object" === typeof k && null !== k && "function" === typeof k.then) {
            c = k;
            var g = b.blockedSegment, h = U(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = Bb(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            G(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, G(e), k;
    }
}
function Jb(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    Kb(this, b, a);
}
function Lb(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.push(null))) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error(l(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return Lb(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function Y(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && Y(a, c);
    } else a.completedSegments.push(b);
}
function Kb(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error(l(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = T, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && Y(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach(Jb, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && (Y(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function Cb(a) {
    if (2 !== a.status) {
        var b = E, c = yb.current;
        yb.current = xb;
        var d = S;
        S = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, k = g.blockedSegment;
                if (0 === k.status) {
                    G(g.context);
                    try {
                        X(h, g, g.node), h.responseState.generateStaticMarkup || k.lastPushedText && k.textEmbedded && k.chunks.push("\x3c!-- --\x3e"), g.abortSet.delete(g), k.status = 1, Kb(h, g.blockedBoundary, k);
                    } catch (z) {
                        if (rb(), "object" === typeof z && null !== z && "function" === typeof z.then) {
                            var m = g.ping;
                            z.then(m, m);
                        } else {
                            g.abortSet.delete(g);
                            k.status = 4;
                            var n = g.blockedBoundary, q = z, C = V(h, q);
                            null === n ? W(h, q) : (n.pendingTasks--, n.forceClientRender || (n.forceClientRender = !0, n.errorDigest = C, n.parentFlushed && h.clientRenderedBoundaries.push(n)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var D = h.onAllReady;
                                D();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && Mb(a, a.destination);
        } catch (z) {
            V(a, z), W(a, z);
        } finally{
            S = d, yb.current = c, c === xb && G(b);
        }
    }
}
function Z(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            b.push('<template id="');
            b.push(a.placeholderPrefix);
            a = d.toString(16);
            b.push(a);
            return b.push('"></template>');
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)b.push(d[e]);
                f = Nb(a, b, f);
            }
            for(; e < d.length - 1; e++)b.push(d[e]);
            e < d.length && (f = b.push(d[e]));
            return f;
        default:
            throw Error(l(390));
    }
}
function Nb(a, b, c) {
    var d = c.boundary;
    if (null === d) return Z(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) return a.responseState.generateStaticMarkup || (d = d.errorDigest, b.push("\x3c!--$!--\x3e"), b.push("<template"), d && (b.push(' data-dgst="'), d = v(d), b.push(d), b.push('"')), b.push("></template>")), Z(a, b, c), a = a.responseState.generateStaticMarkup ? !0 : b.push("\x3c!--/$--\x3e"), a;
    if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = f.boundaryPrefix + e.toString(16);
        d = d.id = f;
        za(b, a.responseState, d);
        Z(a, b, c);
        return b.push("\x3c!--/$--\x3e");
    }
    if (d.byteSize > a.progressiveChunkSize) return d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), za(b, a.responseState, d.id), Z(a, b, c), b.push("\x3c!--/$--\x3e");
    a.responseState.generateStaticMarkup || b.push("\x3c!--$--\x3e");
    c = d.completedSegments;
    if (1 !== c.length) throw Error(l(391));
    Nb(a, b, c[0]);
    a = a.responseState.generateStaticMarkup ? !0 : b.push("\x3c!--/$--\x3e");
    return a;
}
function Ob(a, b, c) {
    Aa(b, a.responseState, c.formatContext, c.id);
    Nb(a, b, c);
    return Ba(b, c.formatContext);
}
function Pb(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)Qb(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    b.push(a.startInlineScript);
    a.sentCompleteBoundaryFunction ? b.push('$RC("') : (a.sentCompleteBoundaryFunction = !0, b.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'));
    if (null === d) throw Error(l(395));
    c = c.toString(16);
    b.push(d);
    b.push('","');
    b.push(a.segmentPrefix);
    b.push(c);
    return b.push('")\x3c/script>');
}
function Qb(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error(l(392));
        return Ob(a, b, d);
    }
    Ob(a, b, d);
    a = a.responseState;
    b.push(a.startInlineScript);
    a.sentCompleteSegmentFunction ? b.push('$RS("') : (a.sentCompleteSegmentFunction = !0, b.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'));
    b.push(a.segmentPrefix);
    f = f.toString(16);
    b.push(f);
    b.push('","');
    b.push(a.placeholderPrefix);
    b.push(f);
    return b.push('")\x3c/script>');
}
function Mb(a, b) {
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            Nb(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)b.push(d[c]);
            c < d.length && b.push(d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, k = g.id, m = g.errorDigest, n = g.errorMessage, q = g.errorComponentStack;
            d.push(h.startInlineScript);
            h.sentClientRenderFunction ? d.push('$RX("') : (h.sentClientRenderFunction = !0, d.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'));
            if (null === k) throw Error(l(395));
            d.push(k);
            d.push('"');
            if (m || n || q) {
                d.push(",");
                var C = Da(m || "");
                d.push(C);
            }
            if (n || q) {
                d.push(",");
                var D = Da(n || "");
                d.push(D);
            }
            if (q) {
                d.push(",");
                var z = Da(q);
                d.push(z);
            }
            if (!d.push(")\x3c/script>")) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var ba = a.completedBoundaries;
        for(e = 0; e < ba.length; e++)if (!Pb(a, b, ba[e])) {
            a.destination = null;
            e++;
            ba.splice(0, e);
            return;
        }
        ba.splice(0, e);
        var ca = a.partialBoundaries;
        for(e = 0; e < ca.length; e++){
            var mb = ca[e];
            a: {
                f = a;
                g = b;
                var da = mb.completedSegments;
                for(h = 0; h < da.length; h++)if (!Qb(f, g, mb, da[h])) {
                    h++;
                    da.splice(0, h);
                    var nb = !1;
                    break a;
                }
                da.splice(0, h);
                nb = !0;
            }
            if (!nb) {
                a.destination = null;
                e++;
                ca.splice(0, e);
                return;
            }
        }
        ca.splice(0, e);
        var ea = a.completedBoundaries;
        for(e = 0; e < ea.length; e++)if (!Pb(a, b, ea[e])) {
            a.destination = null;
            e++;
            ea.splice(0, e);
            return;
        }
        ea.splice(0, e);
    } finally{
        0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.push(null);
    }
}
function Rb(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return Lb(c, a, b);
        });
        c.clear();
        null !== a.destination && Mb(a, a.destination);
    } catch (d) {
        V(a, d), W(a, d);
    }
}
function Sb() {}
function Tb(a, b, c, d) {
    var f = !1, e = null, g = "", h = {
        push: function(a) {
            null !== a && (g += a);
            return !0;
        },
        destroy: function(a) {
            f = !0;
            e = a;
        }
    }, k = !1;
    a = Ab(a, Ea(c, b ? b.identifierPrefix : void 0), {
        insertionMode: 1,
        selectedValue: null
    }, Infinity, Sb, void 0, function() {
        k = !0;
    }, void 0, void 0);
    Cb(a);
    Rb(a, d);
    if (1 === a.status) a.status = 2, h.destroy(a.fatalError);
    else if (2 !== a.status && null === a.destination) {
        a.destination = h;
        try {
            Mb(a, h);
        } catch (m) {
            V(a, m), W(a, m);
        }
    }
    if (f) throw e;
    if (!k) throw Error(l(426));
    return g;
}
exports.renderToNodeStream = function() {
    throw Error(l(207));
};
exports.renderToStaticMarkup = function(a, b) {
    return Tb(a, b, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
exports.renderToStaticNodeStream = function() {
    throw Error(l(208));
};
exports.renderToString = function(a, b) {
    return Tb(a, b, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
exports.version = "18.3.1";

},{"51526ccfbe8a07b8":"bmhQu"}],"e1KKT":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var aa = require("25c06765b630fbbf");
function k(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var l = null, n = 0;
function p(a, b) {
    if (0 !== b.length) {
        if (512 < b.length) 0 < n && (a.enqueue(new Uint8Array(l.buffer, 0, n)), l = new Uint8Array(512), n = 0), a.enqueue(b);
        else {
            var c = l.length - n;
            c < b.length && (0 === c ? a.enqueue(l) : (l.set(b.subarray(0, c), n), a.enqueue(l), b = b.subarray(c)), l = new Uint8Array(512), n = 0);
            l.set(b, n);
            n += b.length;
        }
    }
}
function t(a, b) {
    p(a, b);
    return !0;
}
function ba(a) {
    l && 0 < n && (a.enqueue(new Uint8Array(l.buffer, 0, n)), l = null, n = 0);
}
var ca = new TextEncoder;
function u(a) {
    return ca.encode(a);
}
function w(a) {
    return ca.encode(a);
}
function da(a, b) {
    "function" === typeof a.error ? a.error(b) : a.close();
}
var x = Object.prototype.hasOwnProperty, ea = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, fa = {}, ha = {};
function ia(a) {
    if (x.call(ha, a)) return !0;
    if (x.call(fa, a)) return !1;
    if (ea.test(a)) return ha[a] = !0;
    fa[a] = !0;
    return !1;
}
function y(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new y(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    z[b] = new y(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    z[a] = new y(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    z[a] = new y(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new y(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    z[a] = new y(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    z[a] = new y(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    z[a] = new y(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    z[a] = new y(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ja = /[\-:]([a-z])/g;
function ka(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(ja, ka);
    z[b] = new y(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ja, ka);
    z[b] = new y(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(ja, ka);
    z[b] = new y(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    z[a] = new y(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new y("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    z[a] = new y(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var B = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, la = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(B).forEach(function(a) {
    la.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        B[b] = B[a];
    });
});
var oa = /["'&<>]/;
function C(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = oa.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var pa = /([A-Z])/g, qa = /^ms-/, ra = Array.isArray, sa = w("<script>"), ta = w("\x3c/script>"), ua = w('<script src="'), va = w('<script type="module" src="'), wa = w('" async="">\x3c/script>'), xa = /(<\/|<)(s)(cript)/gi;
function ya(a, b, c, d) {
    return "" + b + ("s" === c ? "\\u0073" : "\\u0053") + d;
}
function za(a, b, c, d, f) {
    a = void 0 === a ? "" : a;
    b = void 0 === b ? sa : w('<script nonce="' + C(b) + '">');
    var e = [];
    void 0 !== c && e.push(b, u(("" + c).replace(xa, ya)), ta);
    if (void 0 !== d) for(c = 0; c < d.length; c++)e.push(ua, u(C(d[c])), wa);
    if (void 0 !== f) for(d = 0; d < f.length; d++)e.push(va, u(C(f[d])), wa);
    return {
        bootstrapChunks: e,
        startInlineScript: b,
        placeholderPrefix: w(a + "P:"),
        segmentPrefix: w(a + "S:"),
        boundaryPrefix: a + "B:",
        idPrefix: a,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
    };
}
function D(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function Aa(a) {
    return D("http://www.w3.org/2000/svg" === a ? 2 : "http://www.w3.org/1998/Math/MathML" === a ? 3 : 0, null);
}
function Ba(a, b, c) {
    switch(b){
        case "select":
            return D(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return D(2, null);
        case "math":
            return D(3, null);
        case "foreignObject":
            return D(1, null);
        case "table":
            return D(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return D(5, null);
        case "colgroup":
            return D(7, null);
        case "tr":
            return D(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? D(1, null) : a;
}
var Ca = w("\x3c!-- --\x3e");
function Da(a, b, c, d) {
    if ("" === b) return d;
    d && a.push(Ca);
    a.push(u(C(b)));
    return !0;
}
var Ea = new Map, Fa = w(' style="'), Ga = w(":"), Ha = w(";");
function Ia(a, b, c) {
    if ("object" !== typeof c) throw Error(k(62));
    b = !0;
    for(var d in c)if (x.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = u(C(d));
                f = u(C(("" + f).trim()));
            } else {
                e = d;
                var g = Ea.get(e);
                void 0 !== g ? e = g : (g = w(C(e.replace(pa, "-$1").toLowerCase().replace(qa, "-ms-"))), Ea.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || x.call(B, d) ? u("" + f) : u(f + "px") : u(C(("" + f).trim()));
            }
            b ? (b = !1, a.push(Fa, e, Ga, f)) : a.push(Ha, e, Ga, f);
        }
    }
    b || a.push(E);
}
var H = w(" "), I = w('="'), E = w('"'), Ja = w('=""');
function J(a, b, c, d) {
    switch(c){
        case "style":
            Ia(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = z.hasOwnProperty(c) ? z[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = u(b.attributeName);
            switch(b.type){
                case 3:
                    d && a.push(H, c, Ja);
                    break;
                case 4:
                    !0 === d ? a.push(H, c, Ja) : !1 !== d && a.push(H, c, I, u(C(d)), E);
                    break;
                case 5:
                    isNaN(d) || a.push(H, c, I, u(C(d)), E);
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push(H, c, I, u(C(d)), E);
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push(H, c, I, u(C(d)), E);
            }
        } else if (ia(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push(H, u(c), I, u(C(d)), E);
        }
    }
}
var K = w(">"), Ka = w("/>");
function L(a, b, c) {
    if (null != b) {
        if (null != c) throw Error(k(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error(k(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push(u("" + b));
    }
}
function La(a) {
    var b = "";
    aa.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
var Ma = w(' selected=""');
function Na(a, b, c, d) {
    a.push(M(c));
    var f = c = null, e;
    for(e in b)if (x.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                J(a, d, e, g);
        }
    }
    a.push(K);
    L(a, f, c);
    return "string" === typeof c ? (a.push(u(C(c))), null) : c;
}
var Oa = w("\n"), Pa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Qa = new Map;
function M(a) {
    var b = Qa.get(a);
    if (void 0 === b) {
        if (!Pa.test(a)) throw Error(k(65, a));
        b = w("<" + a);
        Qa.set(a, b);
    }
    return b;
}
var Ra = w("<!DOCTYPE html>");
function Sa(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push(M("select"));
            var e = null, g = null;
            for(r in c)if (x.call(c, r)) {
                var h = c[r];
                if (null != h) switch(r){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        J(a, d, r, h);
                }
            }
            a.push(K);
            L(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push(M("option"));
            var m = h = null, q = null;
            var r = null;
            for(e in c)if (x.call(c, e)) {
                var v = c[e];
                if (null != v) switch(e){
                    case "children":
                        h = v;
                        break;
                    case "selected":
                        q = v;
                        break;
                    case "dangerouslySetInnerHTML":
                        r = v;
                        break;
                    case "value":
                        m = v;
                    default:
                        J(a, d, e, v);
                }
            }
            if (null != g) {
                if (c = null !== m ? "" + m : La(h), ra(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push(Ma);
                        break;
                    }
                } else "" + g === c && a.push(Ma);
            } else q && a.push(Ma);
            a.push(K);
            L(a, r, h);
            return h;
        case "textarea":
            a.push(M("textarea"));
            r = g = e = null;
            for(h in c)if (x.call(c, h) && (m = c[h], null != m)) switch(h){
                case "children":
                    r = m;
                    break;
                case "value":
                    e = m;
                    break;
                case "defaultValue":
                    g = m;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error(k(91));
                default:
                    J(a, d, h, m);
            }
            null === e && null !== g && (e = g);
            a.push(K);
            if (null != r) {
                if (null != e) throw Error(k(92));
                if (ra(r) && 1 < r.length) throw Error(k(93));
                e = "" + r;
            }
            "string" === typeof e && "\n" === e[0] && a.push(Oa);
            null !== e && a.push(u(C("" + e)));
            return null;
        case "input":
            a.push(M("input"));
            m = r = h = e = null;
            for(g in c)if (x.call(c, g) && (q = c[g], null != q)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error(k(399, "input"));
                case "defaultChecked":
                    m = q;
                    break;
                case "defaultValue":
                    h = q;
                    break;
                case "checked":
                    r = q;
                    break;
                case "value":
                    e = q;
                    break;
                default:
                    J(a, d, g, q);
            }
            null !== r ? J(a, d, "checked", r) : null !== m && J(a, d, "checked", m);
            null !== e ? J(a, d, "value", e) : null !== h && J(a, d, "value", h);
            a.push(Ka);
            return null;
        case "menuitem":
            a.push(M("menuitem"));
            for(var A in c)if (x.call(c, A) && (e = c[A], null != e)) switch(A){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error(k(400));
                default:
                    J(a, d, A, e);
            }
            a.push(K);
            return null;
        case "title":
            a.push(M("title"));
            e = null;
            for(v in c)if (x.call(c, v) && (g = c[v], null != g)) switch(v){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error(k(434));
                default:
                    J(a, d, v, g);
            }
            a.push(K);
            return e;
        case "listing":
        case "pre":
            a.push(M(b));
            g = e = null;
            for(m in c)if (x.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    J(a, d, m, h);
            }
            a.push(K);
            if (null != g) {
                if (null != e) throw Error(k(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error(k(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push(Oa, u(c)) : a.push(u("" + c)));
            }
            "string" === typeof e && "\n" === e[0] && a.push(Oa);
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push(M(b));
            for(var F in c)if (x.call(c, F) && (e = c[F], null != e)) switch(F){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error(k(399, b));
                default:
                    J(a, d, F, e);
            }
            a.push(Ka);
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return Na(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push(Ra), Na(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return Na(a, c, b, d);
            a.push(M(b));
            g = e = null;
            for(q in c)if (x.call(c, q) && (h = c[q], null != h)) switch(q){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    Ia(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    ia(q) && "function" !== typeof h && "symbol" !== typeof h && a.push(H, u(q), I, u(C(h)), E);
            }
            a.push(K);
            L(a, g, e);
            return e;
    }
}
var Ta = w("</"), Ua = w(">"), Va = w('<template id="'), Wa = w('"></template>'), Xa = w("\x3c!--$--\x3e"), Ya = w('\x3c!--$?--\x3e<template id="'), Za = w('"></template>'), $a = w("\x3c!--$!--\x3e"), ab = w("\x3c!--/$--\x3e"), bb = w("<template"), cb = w('"'), db = w(' data-dgst="');
w(' data-msg="');
w(' data-stck="');
var eb = w("></template>");
function fb(a, b, c) {
    p(a, Ya);
    if (null === c) throw Error(k(395));
    p(a, c);
    return t(a, Za);
}
var gb = w('<div hidden id="'), hb = w('">'), ib = w("</div>"), jb = w('<svg aria-hidden="true" style="display:none" id="'), kb = w('">'), lb = w("</svg>"), mb = w('<math aria-hidden="true" style="display:none" id="'), nb = w('">'), ob = w("</math>"), pb = w('<table hidden id="'), qb = w('">'), rb = w("</table>"), sb = w('<table hidden><tbody id="'), tb = w('">'), ub = w("</tbody></table>"), vb = w('<table hidden><tr id="'), wb = w('">'), xb = w("</tr></table>"), yb = w('<table hidden><colgroup id="'), zb = w('">'), Ab = w("</colgroup></table>");
function Bb(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return p(a, gb), p(a, b.segmentPrefix), p(a, u(d.toString(16))), t(a, hb);
        case 2:
            return p(a, jb), p(a, b.segmentPrefix), p(a, u(d.toString(16))), t(a, kb);
        case 3:
            return p(a, mb), p(a, b.segmentPrefix), p(a, u(d.toString(16))), t(a, nb);
        case 4:
            return p(a, pb), p(a, b.segmentPrefix), p(a, u(d.toString(16))), t(a, qb);
        case 5:
            return p(a, sb), p(a, b.segmentPrefix), p(a, u(d.toString(16))), t(a, tb);
        case 6:
            return p(a, vb), p(a, b.segmentPrefix), p(a, u(d.toString(16))), t(a, wb);
        case 7:
            return p(a, yb), p(a, b.segmentPrefix), p(a, u(d.toString(16))), t(a, zb);
        default:
            throw Error(k(397));
    }
}
function Cb(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return t(a, ib);
        case 2:
            return t(a, lb);
        case 3:
            return t(a, ob);
        case 4:
            return t(a, rb);
        case 5:
            return t(a, ub);
        case 6:
            return t(a, xb);
        case 7:
            return t(a, Ab);
        default:
            throw Error(k(397));
    }
}
var Db = w('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), Eb = w('$RS("'), Gb = w('","'), Hb = w('")\x3c/script>'), Ib = w('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), Jb = w('$RC("'), Kb = w('","'), Lb = w('")\x3c/script>'), Mb = w('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), Nb = w('$RX("'), Ob = w('"'), Pb = w(")\x3c/script>"), Qb = w(","), Rb = /[<\u2028\u2029]/g;
function Sb(a) {
    return JSON.stringify(a).replace(Rb, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
var N = Object.assign, Tb = Symbol.for("react.element"), Ub = Symbol.for("react.portal"), Vb = Symbol.for("react.fragment"), Wb = Symbol.for("react.strict_mode"), Xb = Symbol.for("react.profiler"), Yb = Symbol.for("react.provider"), Zb = Symbol.for("react.context"), $b = Symbol.for("react.forward_ref"), ac = Symbol.for("react.suspense"), bc = Symbol.for("react.suspense_list"), cc = Symbol.for("react.memo"), dc = Symbol.for("react.lazy"), ec = Symbol.for("react.scope"), fc = Symbol.for("react.debug_trace_mode"), gc = Symbol.for("react.legacy_hidden"), hc = Symbol.for("react.default_value"), ic = Symbol.iterator;
function jc(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case Vb:
            return "Fragment";
        case Ub:
            return "Portal";
        case Xb:
            return "Profiler";
        case Wb:
            return "StrictMode";
        case ac:
            return "Suspense";
        case bc:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case Zb:
            return (a.displayName || "Context") + ".Consumer";
        case Yb:
            return (a._context.displayName || "Context") + ".Provider";
        case $b:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case cc:
            return b = a.displayName || null, null !== b ? b : jc(a.type) || "Memo";
        case dc:
            b = a._payload;
            a = a._init;
            try {
                return jc(a(b));
            } catch (c) {}
    }
    return null;
}
var kc = {};
function lc(a, b) {
    a = a.contextTypes;
    if (!a) return kc;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var O = null;
function P(a, b) {
    if (a !== b) {
        a.context._currentValue = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error(k(401));
        } else {
            if (null === c) throw Error(k(401));
            P(a, c);
        }
        b.context._currentValue = b.value;
    }
}
function mc(a) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    null !== a && mc(a);
}
function nc(a) {
    var b = a.parent;
    null !== b && nc(b);
    a.context._currentValue = a.value;
}
function oc(a, b) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    if (null === a) throw Error(k(402));
    a.depth === b.depth ? P(a, b) : oc(a, b);
}
function pc(a, b) {
    var c = b.parent;
    if (null === c) throw Error(k(402));
    a.depth === c.depth ? P(a, c) : pc(a, c);
    b.context._currentValue = b.value;
}
function Q(a) {
    var b = O;
    b !== a && (null === b ? nc(a) : null === a ? mc(b) : b.depth === a.depth ? P(b, a) : b.depth > a.depth ? oc(b, a) : pc(b, a), O = a);
}
var qc = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function rc(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = qc;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : N({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && qc.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = N({}, e, h)) : N(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var sc = {
    id: 1,
    overflow: ""
};
function tc(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - uc(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - uc(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - uc(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var uc = Math.clz32 ? Math.clz32 : vc, wc = Math.log, xc = Math.LN2;
function vc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (wc(a) / xc | 0) | 0;
}
function yc(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var zc = "function" === typeof Object.is ? Object.is : yc, R = null, Ac = null, Bc = null, S = null, T = !1, Cc = !1, U = 0, V = null, Dc = 0;
function W() {
    if (null === R) throw Error(k(321));
    return R;
}
function Ec() {
    if (0 < Dc) throw Error(k(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function Fc() {
    null === S ? null === Bc ? (T = !1, Bc = S = Ec()) : (T = !0, S = Bc) : null === S.next ? (T = !1, S = S.next = Ec()) : (T = !0, S = S.next);
    return S;
}
function Gc() {
    Ac = R = null;
    Cc = !1;
    Bc = null;
    Dc = 0;
    S = V = null;
}
function Hc(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Ic(a, b, c) {
    R = W();
    S = Fc();
    if (T) {
        var d = S.queue;
        b = d.dispatch;
        if (null !== V && (c = V.get(d), void 0 !== c)) {
            V.delete(d);
            d = S.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            S.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            S.memoizedState,
            b
        ];
    }
    a = a === Hc ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    S.memoizedState = a;
    a = S.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = Jc.bind(null, R, a);
    return [
        S.memoizedState,
        a
    ];
}
function Kc(a, b) {
    R = W();
    S = Fc();
    b = void 0 === b ? null : b;
    if (null !== S) {
        var c = S.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!zc(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    S.memoizedState = [
        a,
        b
    ];
    return a;
}
function Jc(a, b, c) {
    if (25 <= Dc) throw Error(k(301));
    if (a === R) {
        if (Cc = !0, a = {
            action: c,
            next: null
        }, null === V && (V = new Map), c = V.get(b), void 0 === c) V.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function Lc() {
    throw Error(k(394));
}
function Mc() {}
var Oc = {
    readContext: function(a) {
        return a._currentValue;
    },
    useContext: function(a) {
        W();
        return a._currentValue;
    },
    useMemo: Kc,
    useReducer: Ic,
    useRef: function(a) {
        R = W();
        S = Fc();
        var b = S.memoizedState;
        return null === b ? (a = {
            current: a
        }, S.memoizedState = a) : b;
    },
    useState: function(a) {
        return Ic(Hc, a);
    },
    useInsertionEffect: Mc,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return Kc(function() {
            return a;
        }, b);
    },
    useImperativeHandle: Mc,
    useEffect: Mc,
    useDebugValue: Mc,
    useDeferredValue: function(a) {
        W();
        return a;
    },
    useTransition: function() {
        W();
        return [
            !1,
            Lc
        ];
    },
    useId: function() {
        var a = Ac.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - uc(a) - 1)).toString(32) + b;
        var c = Nc;
        if (null === c) throw Error(k(404));
        b = U++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        W();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error(k(407));
        return c();
    }
}, Nc = null, Pc = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function Qc(a) {
    console.error(a);
    return null;
}
function X() {}
function Rc(a, b, c, d, f, e, g, h, m) {
    var q = [], r = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: r,
        pingedTasks: q,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? Qc : f,
        onAllReady: void 0 === e ? X : e,
        onShellReady: void 0 === g ? X : g,
        onShellError: void 0 === h ? X : h,
        onFatalError: void 0 === m ? X : m
    };
    c = Sc(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = Tc(b, a, null, c, r, kc, null, sc);
    q.push(a);
    return b;
}
function Tc(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var m = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(m);
            1 === b.length && Uc(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(m);
    return m;
}
function Sc(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function Y(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function Vc(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, da(a.destination, b)) : (a.status = 1, a.fatalError = b);
}
function Wc(a, b, c, d, f) {
    R = {};
    Ac = b;
    U = 0;
    for(a = c(d, f); Cc;)Cc = !1, U = 0, Dc += 1, S = null, a = c(d, f);
    Gc();
    return a;
}
function Xc(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error(k(108, jc(d) || "Unknown", h));
            d = N({}, g, c);
        }
        b.legacyContext = d;
        Z(a, b, f);
        b.legacyContext = g;
    } else Z(a, b, f);
}
function Yc(a, b) {
    if (a && a.defaultProps) {
        b = N({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function Zc(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = lc(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue : f);
            rc(e, c, d, f);
            Xc(a, b, e, c);
        } else {
            e = lc(c, b.legacyContext);
            f = Wc(a, b, c, d, e);
            var g = 0 !== U;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) rc(f, c, d, e), Xc(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = tc(d, 1, 0);
                try {
                    Z(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else Z(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = Sa(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = Ba(g, c, d);
        $c(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push(Ta, u(c), Ua);
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case gc:
            case fc:
            case Wb:
            case Xb:
            case Vb:
                Z(a, b, d.children);
                return;
            case bc:
                Z(a, b, d.children);
                return;
            case ec:
                throw Error(k(343));
            case ac:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, m = Sc(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(m);
                    f.lastPushedText = !1;
                    var q = Sc(a, 0, null, f.formatContext, !1, !1);
                    q.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = q;
                    try {
                        if ($c(a, b, d), q.lastPushedText && q.textEmbedded && q.chunks.push(Ca), q.status = 1, ad(h, q), 0 === h.pendingTasks) break a;
                    } catch (r) {
                        q.status = 4, h.forceClientRender = !0, h.errorDigest = Y(a, r);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = Tc(a, e, c, m, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $b:
                d = Wc(a, b, c.render, d, f);
                if (0 !== U) {
                    c = b.treeContext;
                    b.treeContext = tc(c, 1, 0);
                    try {
                        Z(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else Z(a, b, d);
                return;
            case cc:
                c = c.type;
                d = Yc(c, d);
                Zc(a, b, c, d, f);
                return;
            case Yb:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue;
                c._currentValue = d;
                g = O;
                O = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                Z(a, b, f);
                a = O;
                if (null === a) throw Error(k(403));
                d = a.parentValue;
                a.context._currentValue = d === hc ? a.context._defaultValue : d;
                a = O = a.parent;
                b.context = a;
                return;
            case Zb:
                d = d.children;
                d = d(c._currentValue);
                Z(a, b, d);
                return;
            case dc:
                f = c._init;
                c = f(c._payload);
                d = Yc(c, d);
                Zc(a, b, c, d, void 0);
                return;
        }
        throw Error(k(130, null == c ? c : typeof c, ""));
    }
}
function Z(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case Tb:
                Zc(a, b, c.type, c.props, c.ref);
                return;
            case Ub:
                throw Error(k(257));
            case dc:
                var d = c._init;
                c = d(c._payload);
                Z(a, b, c);
                return;
        }
        if (ra(c)) {
            bd(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = ic && c[ic] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                bd(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error(k(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = Da(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = Da(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function bd(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = tc(e, d, f);
        try {
            $c(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $c(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return Z(a, b, c);
    } catch (m) {
        if (Gc(), "object" === typeof m && null !== m && "function" === typeof m.then) {
            c = m;
            var g = b.blockedSegment, h = Sc(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = Tc(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            Q(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, Q(e), m;
    }
}
function cd(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    dd(this, b, a);
}
function ed(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.close())) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error(k(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return ed(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function ad(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && ad(a, c);
    } else a.completedSegments.push(b);
}
function dd(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error(k(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = X, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && ad(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach(cd, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && (ad(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function Uc(a) {
    if (2 !== a.status) {
        var b = O, c = Pc.current;
        Pc.current = Oc;
        var d = Nc;
        Nc = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, m = g.blockedSegment;
                if (0 === m.status) {
                    Q(g.context);
                    try {
                        Z(h, g, g.node), m.lastPushedText && m.textEmbedded && m.chunks.push(Ca), g.abortSet.delete(g), m.status = 1, dd(h, g.blockedBoundary, m);
                    } catch (G) {
                        if (Gc(), "object" === typeof G && null !== G && "function" === typeof G.then) {
                            var q = g.ping;
                            G.then(q, q);
                        } else {
                            g.abortSet.delete(g);
                            m.status = 4;
                            var r = g.blockedBoundary, v = G, A = Y(h, v);
                            null === r ? Vc(h, v) : (r.pendingTasks--, r.forceClientRender || (r.forceClientRender = !0, r.errorDigest = A, r.parentFlushed && h.clientRenderedBoundaries.push(r)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var F = h.onAllReady;
                                F();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && fd(a, a.destination);
        } catch (G) {
            Y(a, G), Vc(a, G);
        } finally{
            Nc = d, Pc.current = c, c === Oc && Q(b);
        }
    }
}
function gd(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            p(b, Va);
            p(b, a.placeholderPrefix);
            a = u(d.toString(16));
            p(b, a);
            return t(b, Wa);
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)p(b, d[e]);
                f = hd(a, b, f);
            }
            for(; e < d.length - 1; e++)p(b, d[e]);
            e < d.length && (f = t(b, d[e]));
            return f;
        default:
            throw Error(k(390));
    }
}
function hd(a, b, c) {
    var d = c.boundary;
    if (null === d) return gd(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) d = d.errorDigest, t(b, $a), p(b, bb), d && (p(b, db), p(b, u(C(d))), p(b, cb)), t(b, eb), gd(a, b, c);
    else if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = w(f.boundaryPrefix + e.toString(16));
        d = d.id = f;
        fb(b, a.responseState, d);
        gd(a, b, c);
    } else if (d.byteSize > a.progressiveChunkSize) d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), fb(b, a.responseState, d.id), gd(a, b, c);
    else {
        t(b, Xa);
        c = d.completedSegments;
        if (1 !== c.length) throw Error(k(391));
        hd(a, b, c[0]);
    }
    return t(b, ab);
}
function id(a, b, c) {
    Bb(b, a.responseState, c.formatContext, c.id);
    hd(a, b, c);
    return Cb(b, c.formatContext);
}
function jd(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)kd(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    p(b, a.startInlineScript);
    a.sentCompleteBoundaryFunction ? p(b, Jb) : (a.sentCompleteBoundaryFunction = !0, p(b, Ib));
    if (null === d) throw Error(k(395));
    c = u(c.toString(16));
    p(b, d);
    p(b, Kb);
    p(b, a.segmentPrefix);
    p(b, c);
    return t(b, Lb);
}
function kd(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error(k(392));
        return id(a, b, d);
    }
    id(a, b, d);
    a = a.responseState;
    p(b, a.startInlineScript);
    a.sentCompleteSegmentFunction ? p(b, Eb) : (a.sentCompleteSegmentFunction = !0, p(b, Db));
    p(b, a.segmentPrefix);
    f = u(f.toString(16));
    p(b, f);
    p(b, Gb);
    p(b, a.placeholderPrefix);
    p(b, f);
    return t(b, Hb);
}
function fd(a, b) {
    l = new Uint8Array(512);
    n = 0;
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            hd(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)p(b, d[c]);
            c < d.length && t(b, d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, m = g.id, q = g.errorDigest, r = g.errorMessage, v = g.errorComponentStack;
            p(d, h.startInlineScript);
            h.sentClientRenderFunction ? p(d, Nb) : (h.sentClientRenderFunction = !0, p(d, Mb));
            if (null === m) throw Error(k(395));
            p(d, m);
            p(d, Ob);
            if (q || r || v) p(d, Qb), p(d, u(Sb(q || "")));
            if (r || v) p(d, Qb), p(d, u(Sb(r || "")));
            v && (p(d, Qb), p(d, u(Sb(v))));
            if (!t(d, Pb)) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var A = a.completedBoundaries;
        for(e = 0; e < A.length; e++)if (!jd(a, b, A[e])) {
            a.destination = null;
            e++;
            A.splice(0, e);
            return;
        }
        A.splice(0, e);
        ba(b);
        l = new Uint8Array(512);
        n = 0;
        var F = a.partialBoundaries;
        for(e = 0; e < F.length; e++){
            var G = F[e];
            a: {
                f = a;
                g = b;
                var ma = G.completedSegments;
                for(h = 0; h < ma.length; h++)if (!kd(f, g, G, ma[h])) {
                    h++;
                    ma.splice(0, h);
                    var Fb = !1;
                    break a;
                }
                ma.splice(0, h);
                Fb = !0;
            }
            if (!Fb) {
                a.destination = null;
                e++;
                F.splice(0, e);
                return;
            }
        }
        F.splice(0, e);
        var na = a.completedBoundaries;
        for(e = 0; e < na.length; e++)if (!jd(a, b, na[e])) {
            a.destination = null;
            e++;
            na.splice(0, e);
            return;
        }
        na.splice(0, e);
    } finally{
        ba(b), 0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.close();
    }
}
function ld(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return ed(c, a, b);
        });
        c.clear();
        null !== a.destination && fd(a, a.destination);
    } catch (d) {
        Y(a, d), Vc(a, d);
    }
}
exports.renderToReadableStream = function(a, b) {
    return new Promise(function(c, d) {
        var f, e, g = new Promise(function(a, b) {
            e = a;
            f = b;
        }), h = Rc(a, za(b ? b.identifierPrefix : void 0, b ? b.nonce : void 0, b ? b.bootstrapScriptContent : void 0, b ? b.bootstrapScripts : void 0, b ? b.bootstrapModules : void 0), Aa(b ? b.namespaceURI : void 0), b ? b.progressiveChunkSize : void 0, b ? b.onError : void 0, e, function() {
            var a = new ReadableStream({
                type: "bytes",
                pull: function(a) {
                    if (1 === h.status) h.status = 2, da(a, h.fatalError);
                    else if (2 !== h.status && null === h.destination) {
                        h.destination = a;
                        try {
                            fd(h, a);
                        } catch (A) {
                            Y(h, A), Vc(h, A);
                        }
                    }
                },
                cancel: function() {
                    ld(h);
                }
            }, {
                highWaterMark: 0
            });
            a.allReady = g;
            c(a);
        }, function(a) {
            g.catch(function() {});
            d(a);
        }, f);
        if (b && b.signal) {
            var m = b.signal, q = function() {
                ld(h, m.reason);
                m.removeEventListener("abort", q);
            };
            m.addEventListener("abort", q);
        }
        Uc(h);
    });
};
exports.version = "18.3.1";

},{"25c06765b630fbbf":"bmhQu"}],"dWbzV":[function() {},{}],"cSUeE":[function() {},{}],"bm77J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "appTimeBundle", ()=>$e);
parcelHelpers.export(exports, "asyncCountBundle", ()=>We);
parcelHelpers.export(exports, "createCacheBundle", ()=>Xe);
parcelHelpers.export(exports, "createRouteBundle", ()=>Qe);
parcelHelpers.export(exports, "createAsyncResourceBundle", ()=>Ye);
parcelHelpers.export(exports, "createReactorBundle", ()=>ze);
parcelHelpers.export(exports, "getIdleDispatcher", ()=>Ke);
parcelHelpers.export(exports, "onlineBundle", ()=>Ze);
parcelHelpers.export(exports, "createUrlBundle", ()=>Je);
parcelHelpers.export(exports, "debugBundle", ()=>et);
parcelHelpers.export(exports, "composeBundlesRaw", ()=>tt);
parcelHelpers.export(exports, "createGeolocationBundle", ()=>nt);
parcelHelpers.export(exports, "composeBundles", ()=>rt);
parcelHelpers.export(exports, "createSelector", ()=>q);
parcelHelpers.export(exports, "resolveSelectors", ()=>M);
parcelHelpers.export(exports, "HAS_DEBUG_FLAG", ()=>$);
parcelHelpers.export(exports, "HAS_WINDOW", ()=>W);
parcelHelpers.export(exports, "IS_BROWSER", ()=>X);
parcelHelpers.export(exports, "raf", ()=>Y);
parcelHelpers.export(exports, "ric", ()=>z);
parcelHelpers.export(exports, "isPassiveSupported", ()=>K);
parcelHelpers.export(exports, "PASSIVE_EVENTS_SUPPORTED", ()=>Z);
parcelHelpers.export(exports, "startsWith", ()=>J);
parcelHelpers.export(exports, "flattenExtractedToObject", ()=>ee);
parcelHelpers.export(exports, "flattenExtractedToArray", ()=>te);
parcelHelpers.export(exports, "addGlobalListener", ()=>ne);
parcelHelpers.export(exports, "selectorNameToValueName", ()=>re);
parcelHelpers.export(exports, "debounce", ()=>oe);
parcelHelpers.export(exports, "saveScrollPosition", ()=>ae);
parcelHelpers.export(exports, "restoreScrollPosition", ()=>ie);
parcelHelpers.export(exports, "initScrollPosition", ()=>ce);
parcelHelpers.export(exports, "createStore", ()=>D);
parcelHelpers.export(exports, "combineReducers", ()=>x);
parcelHelpers.export(exports, "bindActionCreators", ()=>L);
parcelHelpers.export(exports, "applyMiddleware", ()=>F);
parcelHelpers.export(exports, "compose", ()=>k);
var global = arguments[3];
var e = {
    name: "appTime",
    reducer: Date.now,
    selectAppTime: function(e) {
        return e.appTime;
    }
}, t = {
    STARTED: 1,
    FINISHED: -1,
    FAILED: -1
}, n = /_(STARTED|FINISHED|FAILED)$/, r = {
    name: "asyncCount",
    reducer: function(e, r) {
        void 0 === e && (e = 0);
        var o = n.exec(r.type);
        return o ? e + t[o[1]] : e;
    },
    selectAsyncActive: function(e) {
        return e.asyncCount > 0;
    }
};
var o = "object" == typeof global && global && global.Object === Object && global, a = "object" == typeof self && self && self.Object === Object && self, i = (o || a || Function("return this")()).Symbol, c = Object.prototype, u = c.hasOwnProperty, s = c.toString, l = i ? i.toStringTag : void 0;
var f = Object.prototype.toString;
var d = "[object Null]", p = "[object Undefined]", h = i ? i.toStringTag : void 0;
function v(e) {
    return null == e ? void 0 === e ? p : d : h && h in Object(e) ? function(e) {
        var t = u.call(e, l), n = e[l];
        try {
            e[l] = void 0;
            var r = !0;
        } catch (e) {}
        var o = s.call(e);
        return r && (t ? e[l] = n : delete e[l]), o;
    }(e) : function(e) {
        return f.call(e);
    }(e);
}
var y, g, m = (y = Object.getPrototypeOf, g = Object, function(e) {
    return y(g(e));
});
var b = "[object Object]", E = Function.prototype, w = Object.prototype, A = E.toString, O = w.hasOwnProperty, T = A.call(Object);
function I(e) {
    if (!function(e) {
        return null != e && "object" == typeof e;
    }(e) || v(e) != b) return !1;
    var t = m(e);
    if (null === t) return !0;
    var n = O.call(t, "constructor") && t.constructor;
    return "function" == typeof n && n instanceof n && A.call(n) == T;
}
var j = function(e) {
    var t, n = e.Symbol;
    return "function" == typeof n ? n.observable ? t = n.observable : (t = n("observable"), n.observable = t) : t = "@@observable", t;
}("undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : module), S = {
    INIT: "@@redux/INIT"
};
function D(e, t, n) {
    var r;
    if ("function" == typeof t && void 0 === n && (n = t, t = void 0), void 0 !== n) {
        if ("function" != typeof n) throw new Error("Expected the enhancer to be a function.");
        return n(D)(e, t);
    }
    if ("function" != typeof e) throw new Error("Expected the reducer to be a function.");
    var o = e, a = t, i = [], c = i, u = !1;
    function s() {
        c === i && (c = i.slice());
    }
    function l() {
        return a;
    }
    function f(e) {
        if ("function" != typeof e) throw new Error("Expected listener to be a function.");
        var t = !0;
        return s(), c.push(e), function() {
            if (t) {
                t = !1, s();
                var n = c.indexOf(e);
                c.splice(n, 1);
            }
        };
    }
    function d(e) {
        if (!I(e)) throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
        if (void 0 === e.type) throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
        if (u) throw new Error("Reducers may not dispatch actions.");
        try {
            u = !0, a = o(a, e);
        } finally{
            u = !1;
        }
        for(var t = i = c, n = 0; n < t.length; n++)(0, t[n])();
        return e;
    }
    return d({
        type: S.INIT
    }), (r = {
        dispatch: d,
        subscribe: f,
        getState: l,
        replaceReducer: function(e) {
            if ("function" != typeof e) throw new Error("Expected the nextReducer to be a function.");
            o = e, d({
                type: S.INIT
            });
        }
    })[j] = function() {
        var e, t = f;
        return (e = {
            subscribe: function(e) {
                if ("object" != typeof e) throw new TypeError("Expected the observer to be an object.");
                function n() {
                    e.next && e.next(l());
                }
                return n(), {
                    unsubscribe: t(n)
                };
            }
        })[j] = function() {
            return this;
        }, e;
    }, r;
}
function R(e) {
    "undefined" != typeof console && "function" == typeof console.error && console.error(e);
    try {
        throw new Error(e);
    } catch (e) {}
}
function C(e, t) {
    var n = t && t.type;
    return "Given action " + (n && '"' + n.toString() + '"' || "an action") + ', reducer "' + e + '" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.';
}
function x(e) {
    for(var t = Object.keys(e), n = {}, r = 0; r < t.length; r++){
        var o = t[r];
        "function" == typeof e[o] && (n[o] = e[o]);
    }
    var a = Object.keys(n), i = void 0;
    var c = void 0;
    try {
        !function(e) {
            Object.keys(e).forEach(function(t) {
                var n = e[t];
                if (void 0 === n(void 0, {
                    type: S.INIT
                })) throw new Error('Reducer "' + t + "\" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.");
                if (void 0 === n(void 0, {
                    type: "@@redux/PROBE_UNKNOWN_ACTION_" + Math.random().toString(36).substring(7).split("").join(".")
                })) throw new Error('Reducer "' + t + "\" returned undefined when probed with a random type. Don't try to handle " + S.INIT + ' or other actions in "redux/*" namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.');
            });
        }(n);
    } catch (e) {
        c = e;
    }
    return function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = arguments[1];
        if (c) throw c;
        var r;
        for(var o = !1, u = {}, s = 0; s < a.length; s++){
            var l = a[s], f = e[l], d = (0, n[l])(f, t);
            if (void 0 === d) {
                var p = C(l, t);
                throw new Error(p);
            }
            u[l] = d, o = o || d !== f;
        }
        return o ? u : e;
    };
}
function N(e, t) {
    return function() {
        return t(e.apply(void 0, arguments));
    };
}
function L(e, t) {
    if ("function" == typeof e) return N(e, t);
    if ("object" != typeof e || null === e) throw new Error("bindActionCreators expected an object or a function, instead received " + (null === e ? "null" : typeof e) + '. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
    for(var n = Object.keys(e), r = {}, o = 0; o < n.length; o++){
        var a = n[o], i = e[a];
        "function" == typeof i && (r[a] = N(i, t));
    }
    return r;
}
function k() {
    for(var e = arguments.length, t = Array(e), n = 0; n < e; n++)t[n] = arguments[n];
    return 0 === t.length ? function(e) {
        return e;
    } : 1 === t.length ? t[0] : t.reduce(function(e, t) {
        return function() {
            return e(t.apply(void 0, arguments));
        };
    });
}
var U = Object.assign || function(e) {
    for(var t = 1; t < arguments.length; t++){
        var n = arguments[t];
        for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
};
function F() {
    for(var e = arguments.length, t = Array(e), n = 0; n < e; n++)t[n] = arguments[n];
    return function(e) {
        return function(n, r, o) {
            var a, i = e(n, r, o), c = i.dispatch, u = {
                getState: i.getState,
                dispatch: function(e) {
                    return c(e);
                }
            };
            return a = t.map(function(e) {
                return e(u);
            }), c = k.apply(void 0, a)(i.dispatch), U({}, i, {
                dispatch: c
            });
        };
    };
}
function P() {}
function _(e, t) {
    return e === t;
}
function B(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : _, n = null, r = null;
    return function() {
        return function(e, t, n) {
            if (null === t || null === n || t.length !== n.length) return !1;
            for(var r = t.length, o = 0; o < r; o++)if (!e(t[o], n[o])) return !1;
            return !0;
        }(t, n, arguments) || (r = e.apply(null, arguments)), n = arguments, r;
    };
}
var H = function(e) {
    for(var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return function() {
        for(var t = arguments.length, r = Array(t), o = 0; o < t; o++)r[o] = arguments[o];
        var a = 0, i = r.pop(), c = function(e) {
            var t = Array.isArray(e[0]) ? e[0] : e;
            if (!t.every(function(e) {
                return "function" == typeof e;
            })) {
                var n = t.map(function(e) {
                    return typeof e;
                }).join(", ");
                throw new Error("Selector creators expect all input-selectors to be functions, instead received the following types: [" + n + "]");
            }
            return t;
        }(r), u = e.apply(void 0, [
            function() {
                return a++, i.apply(null, arguments);
            }
        ].concat(n)), s = B(function() {
            for(var e = [], t = c.length, n = 0; n < t; n++)e.push(c[n].apply(null, arguments));
            return u.apply(null, e);
        });
        return s.resultFunc = i, s.recomputations = function() {
            return a;
        }, s.resetRecomputations = function() {
            return a = 0;
        }, s;
    };
}(B), q = function() {
    for(var e = [], t = arguments.length; t--;)e[t] = arguments[t];
    var n = e.slice(-1)[0], r = function(e, t) {
        var r = t.map(function(t) {
            return function(e, t) {
                if ("string" != typeof t) return t;
                var n = e[t];
                if (!n) throw Error("No selector " + t + " found on the obj.");
                return n;
            }(e, t);
        });
        return r.push(n), H.apply(void 0, r);
    };
    return r.deps = e.slice(0, -1), r.resultFunc = n, r;
}, M = function(e) {
    var t = function(t) {
        return t.call && !t.deps || !e[t].deps;
    }, n = !1, r = function(r) {
        var o = e[r];
        t(r) ? n = !0 : o.deps = o.deps.map(function(t, o) {
            if (t.call) {
                for(var a in e)if (e[a] === t) return a;
                if (!t.deps) return n = !0, t;
            }
            if (e[t]) return t;
            throw Error("The input selector at index " + o + " for '" + r + "' is missing from the object passed to resolveSelectors()");
        });
    };
    for(var o in e)r(o);
    if (!n) throw Error("You must pass at least one real selector. If they're all string references there's no");
    for(var a, i = function() {
        var n = !1;
        for(var r in e){
            var o = e[r];
            t(r) || (n = !0, o.deps.every(t) && (e[r] = o(e, o.deps)));
        }
        return n;
    }; i();)if (a || (a = Date.now()), Date.now() - a > 500) throw Error("Could not resolve selector dependencies.");
    return e;
}, V = !1;
try {
    V = !!window.localStorage.debug;
} catch (H) {}
var G, $ = V || !1, W = "undefined" != typeof window, X = W || "undefined" != typeof self, Q = function(e) {
    setTimeout(e, 0);
}, Y = X && self.requestAnimationFrame ? self.requestAnimationFrame : Q, z = X && self.requestIdleCallback ? self.requestIdleCallback : Q, K = function() {
    var e = !1;
    try {
        var t = Object.defineProperty({}, "passive", {
            get: function() {
                e = !0;
            }
        });
        window.addEventListener("test", t, t), window.removeEventListener("test", t, t);
    } catch (t) {
        e = !1;
    }
    return e;
}, Z = K(), J = function(e, t) {
    return e.substr(0, t.length) === t;
}, ee = function(e) {
    var t = {};
    for(var n in e)Object.assign(t, e[n]);
    return t;
}, te = function(e) {
    var t = [];
    for(var n in e)t.push.apply(t, e[n]);
    return t;
}, ne = function(e, t, n) {
    void 0 === n && (n = {
        passive: !1
    }), X && (n.passive ? Z ? self.addEventListener(e, t, {
        passive: !0
    }) : self.addEventListener(e, oe(t, 200), !1) : self.addEventListener(e, t));
}, re = function(e) {
    var t = "s" === e[0] ? 6 : 5;
    return e[t].toLowerCase() + e.slice(t + 1);
}, oe = function(e, t) {
    var n, r = function() {
        var r = this, o = arguments;
        clearTimeout(n), n = setTimeout(function() {
            e.apply(r, o);
        }, t);
    };
    return r.cancel = function() {
        clearTimeout(n);
    }, r;
}, ae = function() {
    history.replaceState({
        height: document.body.offsetHeight,
        width: document.body.offsetWidth,
        y: document.body.scrollTop,
        x: document.body.scrollLeft
    }, "");
}, ie = function() {
    var e = history.state;
    e && (document.body.setAttribute("style", "height: " + e.height + "px; width: " + e.width + "px;"), window.scrollTo(e.x, e.y), z(function() {
        return document.body.removeAttribute("style");
    }));
}, ce = function() {
    W && (history.scrollRestoration && (history.scrollRestoration = "manual"), ne("popstate", ie), ne("scroll", oe(ae, 300), {
        passive: !0
    }), ie());
}, ue = function(e) {
    var t = e.name;
    if (!t) throw TypeError('bundles must have a "name" property');
    var n = {
        name: t,
        reducer: e.reducer || e.getReducer && e.getReducer() || null,
        init: e.init || null,
        extraArgCreators: e.getExtraArgs || null,
        middlewareCreators: e.getMiddleware,
        actionCreators: null,
        selectors: null,
        reactorNames: null,
        rawBundle: e
    };
    return Object.keys(e).forEach(function(t) {
        if (J(t, "do")) (n.actionCreators || (n.actionCreators = {}))[t] = e[t];
        else {
            var r = J(t, "select"), o = J(t, "react");
            (r || o) && ((n.selectors || (n.selectors = {}))[t] = e[t], o && (n.reactorNames || (n.reactorNames = [])).push(t));
        }
    }), n;
}, se = function(e) {
    var t = {
        bundleNames: [],
        reducers: {},
        selectors: {},
        actionCreators: {},
        rawBundles: [],
        processedBundles: [],
        initMethods: [],
        middlewareCreators: [],
        extraArgCreators: [],
        reactorNames: []
    };
    return e.map(ue).forEach(function(e) {
        var n;
        t.bundleNames.push(e.name), Object.assign(t.selectors, e.selectors), Object.assign(t.actionCreators, e.actionCreators), e.reducer && Object.assign(t.reducers, ((G = {})[e.name] = e.reducer, G)), e.init && t.initMethods.push(e.init), e.middlewareCreators && t.middlewareCreators.push(e.middlewareCreators), e.extraArgCreators && t.extraArgCreators.push(e.extraArgCreators), e.reactorNames && (n = t.reactorNames).push.apply(n, e.reactorNames), t.processedBundles.push(e), t.rawBundles.push(e.rawBundle);
    }), t;
};
var le = function(e, t) {
    e.meta || (e.meta = {
        chunks: [],
        unboundSelectors: {},
        unboundActionCreators: {},
        reactorNames: []
    });
    var n = e.meta;
    n.chunks.push(t);
    var r = Object.assign(n.unboundSelectors, t.selectors);
    M(r), n.unboundSelectors = r, function(e, t) {
        var n = function(n) {
            var r = t[n];
            e[n] || (e[n] = function() {
                return r(e.getState());
            });
        };
        for(var r in t)n(r);
    }(e, r), n.reactorNames = n.reactorNames.concat(t.reactorNames), Object.assign(n.unboundActionCreators, t.actionCreators), Object.assign(e, L(t.actionCreators, e.dispatch)), t.initMethods.forEach(function(t) {
        return t(e);
    });
}, fe = function(e) {
    return function(t, n) {
        return "BATCH_ACTIONS" === n.type ? n.actions.reduce(e, t) : e(t, n);
    };
}, de = function() {
    for(var e = [], t = arguments.length; t--;)e[t] = arguments[t];
    var n = se(e);
    return function(e) {
        var t, r = D(fe(x(n.reducers)), e, (function() {
            for(var e = [], t = arguments.length; t--;)e[t] = arguments[t];
            return function(t) {
                return function(n, r, o) {
                    var a, i, c = t(n, r, o);
                    return i = e.map(function(e) {
                        return e(c);
                    }), a = k.apply(void 0, i)(c.dispatch), Object.assign(c, {
                        dispatch: a
                    });
                };
            };
        }).apply(void 0, [
            function(e) {
                return function(t) {
                    return function(n) {
                        var r = n.actionCreator, o = n.args;
                        if (r) {
                            var a = e.meta.unboundActionCreators[r];
                            if (!a) throw Error("NoSuchActionCreator: " + r);
                            return t(o ? a.apply(void 0, o) : a());
                        }
                        return t(n);
                    };
                };
            },
            (t = n.extraArgCreators, function(e) {
                var n = t.reduce(function(t, n) {
                    return Object.assign(t, n(e));
                }, {});
                return function(t) {
                    return function(r) {
                        return "function" == typeof r ? r(Object.assign({}, {
                            getState: e.getState,
                            dispatch: e.dispatch,
                            store: e
                        }, n)) : t(r);
                    };
                };
            })
        ].concat(n.middlewareCreators.map(function(e) {
            return e(n);
        }))));
        return r.select = function(e) {
            return e.reduce(function(e, t) {
                if (!r[t]) throw Error("SelectorNotFound " + t);
                return e[re(t)] = r[t](), e;
            }, {});
        }, r.selectAll = function() {
            return r.select(Object.keys(r.meta.unboundSelectors));
        }, r.action = function(e, t) {
            return r[e].apply(r, t);
        }, function(e) {
            e.subscriptions = {
                watchedValues: {}
            };
            var t = e.subscriptions.set = new Set, n = e.subscriptions.watchedSelectors = {}, r = function(e) {
                n[e] = (n[e] || 0) + 1;
            }, o = function(e) {
                var t = n[e] - 1;
                0 === t ? delete n[e] : n[e] = t;
            };
            e.subscribe(function() {
                var r = n.all ? e.selectAll() : e.select(Object.keys(n)), o = e.subscriptions.watchedValues, a = {};
                for(var i in r){
                    var c = r[i];
                    c !== o[i] && (a[i] = c);
                }
                e.subscriptions.watchedValues = r, t.forEach(function(e) {
                    var t = {}, n = !1;
                    "all" === e.names ? (Object.assign(t, a), n = !!Object.keys(t).length) : e.names.forEach(function(e) {
                        a.hasOwnProperty(e) && (t[e] = a[e], n = !0);
                    }), n && e.fn(t);
                });
            }), e.subscribeToAllChanges = function(t) {
                return e.subscribeToSelectors("all", t);
            }, e.subscribeToSelectors = function(n, a) {
                var i = "all" === n, c = {
                    fn: a,
                    names: i ? "all" : n.map(re)
                };
                return t.add(c), i ? r("all") : n.forEach(r), Object.assign(e.subscriptions.watchedValues, i ? e.selectAll() : e.select(n)), function() {
                    t.delete(c), i ? o("all") : n.forEach(o);
                };
            };
        }(r), le(r, n), r.integrateBundles = function() {
            for(var e = [], t = arguments.length; t--;)e[t] = arguments[t];
            le(r, se(e));
            var n = r.meta.chunks.reduce(function(e, t) {
                return Object.assign(e, t.reducers);
            }, {});
            r.replaceReducer(fe(x(n)));
        }, r;
    };
}, pe = /\((.*?)\)/g, he = /(\(\?)?:\w+/g, ve = /[\-{}\[\]+?.,\\\^$|#\s]/g, ye = /\*/g, ge = function(e, t) {
    var n = Object.keys(e);
    for(var r in e)e[r] = {
        value: e[r]
    };
    return function(r) {
        var o, a;
        return n.some(function(t) {
            var n, i, c;
            (a = e[t]).regExp || (c = [], i = (i = t).replace(ve, "\\$&").replace(pe, "(?:$1)?").replace(he, function(e, t) {
                return c.push(e.slice(1)), t ? e : "([^/?]+)";
            }).replace(ye, function(e, t) {
                return c.push("path"), "([^?]*?)";
            }), n = {
                regExp: new RegExp("^" + i + "(?:\\?([\\s\\S]*))?$"),
                namedParams: c
            }, a.regExp = n.regExp, a.namedParams = n.namedParams, a.pattern = t);
            var u = a.regExp.exec(r);
            if (u) return u = u.slice(1, -1), o = u.reduce(function(e, t, n) {
                return t && (e[a.namedParams[n]] = t), e;
            }, {}), !0;
        }) ? {
            page: a.value,
            params: o,
            url: r,
            pattern: a.pattern
        } : t ? {
            page: t,
            url: r,
            params: null
        } : null;
    };
};
var me = {
    name: null,
    getPromise: null,
    actionBaseType: null,
    staleAfter: 9e5,
    retryAfter: 6e4,
    expireAfter: Infinity,
    checkIfOnline: !0,
    persist: !0
};
function be(e) {
    var t = Object.assign({}, me, e), n = t.name, r = t.staleAfter, o = t.retryAfter, a = t.actionBaseType, i = t.checkIfOnline, c = t.expireAfter, u = n.charAt(0).toUpperCase() + n.slice(1), s = a || n.toUpperCase();
    var l;
    var f = function(e) {
        return e[n];
    }, d = function(e) {
        return e[n].data;
    }, p = function(e) {
        return e[n].lastSuccess;
    }, h = q(f, function(e) {
        return e.errorTimes.slice(-1)[0] || null;
    }), v = q(f, p, "selectAppTime", function(e, t, n) {
        return !!e.isOutdated || !!t && n - t > r;
    }), y = q(h, "selectAppTime", function(e, t) {
        return !!e && t - e < o;
    }), g = q(f, function(e) {
        return e.isLoading;
    }), m = q(f, function(e) {
        return e.failedPermanently;
    }), b = q(g, m, y, d, v, "selectIsOnline", function(e, t, n, r, o, a) {
        return !(i && !a || e || t || n) && (!r || o);
    }), E = {
        STARTED: s + "_FETCH_STARTED",
        FINISHED: s + "_FETCH_FINISHED",
        FAILED: s + "_FETCH_FAILED",
        CLEARED: s + "_CLEARED",
        OUTDATED: s + "_OUTDATED",
        EXPIRED: s + "_EXPIRED"
    }, w = function() {
        return {
            type: E.EXPIRED
        };
    }, A = {
        data: null,
        errorTimes: [],
        errorType: null,
        lastSuccess: null,
        isOutdated: !1,
        isLoading: !1,
        isExpired: !1,
        failedPermanently: !1
    }, O = {
        name: n,
        reducer: function(e, t) {
            void 0 === e && (e = A);
            var n, r = t.type, o = t.payload, a = t.error, i = t.merge;
            if (r === E.STARTED) return Object.assign({}, e, {
                isLoading: !0
            });
            if (r === E.FINISHED) return n = i ? Object.assign({}, e.data, o) : o, Object.assign({}, e, {
                isLoading: !1,
                data: n,
                lastSuccess: Date.now(),
                errorTimes: [],
                errorType: null,
                failedPermanently: !1,
                isOutdated: !1,
                isExpired: !1
            });
            if (r === E.FAILED) {
                var c = a && a.message || a;
                return Object.assign({}, e, {
                    isLoading: !1,
                    errorTimes: e.errorTimes.concat([
                        Date.now()
                    ]),
                    errorType: c,
                    failedPermanently: !(!a || !a.permanent)
                });
            }
            return r === E.CLEARED ? A : r === E.EXPIRED ? Object.assign({}, A, {
                isExpired: !0,
                errorTimes: e.errorTimes,
                errorType: e.errorType
            }) : r === E.OUTDATED ? Object.assign({}, e, {
                isOutdated: !0
            }) : e;
        }
    };
    return O["select" + u + "Raw"] = f, O["select" + u] = d, O["select" + u + "IsStale"] = v, O["select" + u + "IsExpired"] = function(e) {
        return e[n].isExpired;
    }, O["select" + u + "LastError"] = h, O["select" + u + "IsWaitingToRetry"] = y, O["select" + u + "IsLoading"] = g, O["select" + u + "FailedPermanently"] = m, O["select" + u + "ShouldUpdate"] = b, O["doFetch" + u] = function() {
        return function(e) {
            var n = e.dispatch;
            return n({
                type: E.STARTED
            }), t.getPromise(e).then(function(e) {
                n(function(e) {
                    return {
                        type: E.FINISHED,
                        payload: e
                    };
                }(e));
            }, function(e) {
                n(function(e) {
                    return {
                        type: E.FAILED,
                        error: e
                    };
                }(e));
            });
        };
    }, O["doMark" + u + "AsOutdated"] = function() {
        return {
            type: E.OUTDATED
        };
    }, O["doClear" + u] = function() {
        return {
            type: E.CLEARED
        };
    }, O["doExpire" + u] = w, t.persist && (O.persistActions = [
        E.FINISHED,
        E.EXPIRED,
        E.OUTDATED,
        E.CLEARED
    ]), Infinity !== c && (O["reactExpire" + u] = q(p, "selectAppTime", function(e, t) {
        return !!e && (t - e > c ? w() : void 0);
    })), O;
}
var Ee = !("undefined" == typeof window && "undefined" == typeof self), we = "undefined" == typeof requestIdleCallback ? function(e) {
    return setTimeout(e, 0);
} : requestIdleCallback;
var Ae = function(e, t) {
    void 0 === t && (t = !1);
    var n = new Error(e);
    return t && (n.permanent = !0), n;
}, Oe = [
    "An unknown geolocation error occured",
    "Geolocation permission denied",
    "Geolocation unavailable",
    "Geolocation request timed out"
], Te = {
    timeout: 6e4,
    enableHighAccuracy: !1,
    persist: !0,
    staleAge: 9e5,
    retryAfter: 6e4
};
var Ie = {
    idleTimeout: 3e4,
    idleAction: "APP_IDLE",
    doneCallback: null,
    stopWhenTabInactive: !0
}, je = {
    timeout: 500
}, Se = function(e, t, n) {
    return oe(function() {
        e ? Y(function() {
            return z(n, je);
        }) : z(n, je);
    }, t);
};
function De(e) {
    return {
        name: "reactors",
        init: function(t) {
            var n, r = Object.assign({}, Ie, e), o = r.idleAction, a = r.idleTimeout;
            a && (n = Se(r.stopWhenTabInactive, a, function() {
                return t.dispatch({
                    type: o
                });
            }));
            var i = function() {
                t.nextReaction || (t.meta.reactorNames.some(function(e) {
                    var n = t[e]();
                    return n && (t.activeReactor = e, t.nextReaction = n), n;
                }), t.nextReaction && z(function() {
                    var e = t.nextReaction;
                    t.activeReactor = null, t.nextReaction = null, t.dispatch(e);
                }, je)), n && (n(), X || t.nextReaction || t.selectAsyncActive && t.selectAsyncActive() || (n && n.cancel(), r.doneCallback && r.doneCallback()));
            };
            t.subscribe(i), i();
        }
    };
}
var Re = Object.prototype.hasOwnProperty;
var Ce = {
    stringify: function(e, t) {
        t = t || "";
        var n = [];
        for(var r in "string" != typeof t && (t = "?"), e)Re.call(e, r) && n.push(encodeURIComponent(r) + "=" + encodeURIComponent(e[r]));
        return n.length ? t + n.join("&") : "";
    },
    parse: function(e) {
        for(var t, n = /([^=?&]+)=?([^&]*)/g, r = {}; t = n.exec(e); r[decodeURIComponent(t[1])] = decodeURIComponent(t[2]));
        return r;
    }
}, xe = function(e) {
    return "[object String]" === Object.prototype.toString.call(e);
}, Ne = function(e) {
    return void 0 !== e;
}, Le = function(e) {
    return xe(e) ? e : Ce.stringify(e);
}, ke = /^[0-9.]+$/, Ue = function(e, t) {
    if (ke.test(e)) return [];
    var n = e.split(".");
    return t ? n.slice(-2).join(".") : e.split(".").slice(0, -2);
}, Fe = function(e, t) {
    return t.charAt(0) === e ? t.slice(1) : t;
}, Pe = function(e, t) {
    return t === e || "" === t ? "" : t.charAt(0) !== e ? e + t : t;
}, _e = W ? window.location : {}, Be = {
    name: "url",
    inert: !W,
    actionType: "URL_UPDATED",
    handleScrollRestoration: !0
}, He = function(e) {
    var t = {};
    for(var n in e){
        var r = e[n];
        xe(r) && (t[n] = r);
    }
    return t;
};
function qe(e) {
    var t = Object.assign({}, Be, e), n = t.actionType, r = function(e) {
        return e[t.name];
    }, o = q(r, function(e) {
        return He(new URL(e.url));
    }), a = q(o, function(e) {
        return Ce.parse(e.search);
    }), i = q(a, function(e) {
        return Ce.stringify(e);
    }), c = q(o, function(e) {
        return e.pathname;
    }), u = q(o, function(e) {
        return Fe("#", e.hash);
    }), s = q(u, function(e) {
        return Ce.parse(e);
    }), l = q(o, function(e) {
        return e.hostname;
    }), f = q(l, function(e) {
        return Ue(e);
    }), d = function(e, t) {
        return void 0 === t && (t = {
            replace: !1
        }), function(o) {
            var a = o.dispatch, i = o.getState, c = e;
            if ("string" == typeof e) {
                var u = new URL("/" === e.charAt(0) ? "http://example.com" + e : e);
                c = {
                    pathname: u.pathname,
                    query: u.search || "",
                    hash: u.hash || ""
                };
            }
            var s = new URL(r(i()).url);
            Ne(c.pathname) && (s.pathname = c.pathname), Ne(c.hash) && (s.hash = Le(c.hash)), Ne(c.query) && (s.search = Le(c.query)), a({
                type: n,
                payload: {
                    url: s.href,
                    replace: t.replace
                }
            });
        };
    };
    return {
        name: t.name,
        init: function(e) {
            if (!t.inert) {
                t.handleScrollRestoration && ce(), window.addEventListener("popstate", function() {
                    e.doUpdateUrl({
                        pathname: _e.pathname,
                        hash: _e.hash,
                        query: _e.search
                    });
                });
                var n = e.selectUrlRaw();
                e.subscribe(function() {
                    var r = e.selectUrlRaw();
                    if (n !== r && r.url !== _e.href) try {
                        window.history[r.replace ? "replaceState" : "pushState"]({}, null, r.url), t.handleScrollRestoration && ae(), document.body.scrollTop = 0, document.body.scrollLeft = 0;
                    } catch (e) {
                        console.error(e);
                    }
                    n = r;
                });
            }
        },
        getReducer: function() {
            var e = {
                url: !t.inert && W ? _e.href : "/",
                replace: !1
            };
            return function(t, r) {
                void 0 === t && (t = e);
                var o = r.type, a = r.payload;
                return "@@redux/INIT" === o && "string" == typeof t ? {
                    url: t,
                    replace: !1
                } : o === n ? Object.assign({
                    url: a.url || a,
                    replace: !!a.replace
                }) : t;
            };
        },
        doUpdateUrl: d,
        doReplaceUrl: function(e) {
            return d(e, {
                replace: !0
            });
        },
        doUpdateQuery: function(e, t) {
            return void 0 === t && (t = {
                replace: !0
            }), d({
                query: Le(e)
            }, t);
        },
        doUpdateHash: function(e, t) {
            return void 0 === t && (t = {
                replace: !1
            }), d({
                hash: Pe("#", Le(e))
            }, t);
        },
        selectUrlRaw: r,
        selectUrlObject: o,
        selectQueryObject: a,
        selectQueryString: i,
        selectPathname: c,
        selectHash: u,
        selectHashObject: s,
        selectHostname: l,
        selectSubdomains: f
    };
}
function Me(e) {
    return function(t) {
        return function(n) {
            var r = e.getState().debug;
            r && (console.group(n.type), console.info("action:", n));
            var o = t(n);
            return r && (console.debug("state:", e.getState()), self.logSelectors && self.logSelectors(), self.logNextReaction && self.logNextReaction(), console.groupEnd(n.type)), o;
        };
    };
}
var Ve = {
    name: "debug",
    reducer: function(e, t) {
        void 0 === e && (e = $);
        var n = t.type;
        return "DEBUG_ENABLED" === n || "DEBUG_DISABLED" !== n && e;
    },
    doEnableDebug: function() {
        return {
            type: "DEBUG_ENABLED"
        };
    },
    doDisableDebug: function() {
        return {
            type: "DEBUG_DISABLED"
        };
    },
    selectIsDebug: function(e) {
        return e.debug;
    },
    getMiddleware: function() {
        return Me;
    },
    init: function(e) {
        if (e.selectIsDebug()) {
            var t = e.meta.chunks[0].bundleNames;
            self.store = e;
            var n = [];
            for(var r in e)0 === r.indexOf("do") && n.push(r);
            n.sort();
            e.logSelectors = self.logSelectors = function() {
                e.selectAll && console.log("%cselectors:", "color: #4CAF50;", e.selectAll());
            }, e.logBundles = self.logBundles = function() {
                console.log("%cinstalled bundles:\n  %c%s", "color: #1676D2;", "color: black;", t.join("\n  "));
            }, e.logActionCreators = self.logActionCreators = function() {
                console.groupCollapsed("%caction creators", "color: #F57C00;"), n.forEach(function(e) {
                    return console.log(e);
                }), console.groupEnd();
            }, e.logReactors = self.logReactors = function() {
                console.groupCollapsed("%creactors", "color: #F57C00;"), e.meta.reactorNames.forEach(function(e) {
                    return console.log(e);
                }), console.groupEnd();
            }, e.logNextReaction = self.logNextReaction = function() {
                var t = e.nextReaction;
                t && console.log("%cnext reaction:\n  %c" + e.activeReactor, "color: #F57C00;", "color: black;", t);
            }, console.groupCollapsed("%credux bundler", "color: #1676D2;"), e.logBundles(), e.logSelectors(), e.logReactors(), console.groupEnd(), e.isReacting && console.log("%cqueuing reaction:", "color: #F57C00;");
        }
    }
}, Ge = {
    name: "online",
    selectIsOnline: function(e) {
        return e.online;
    },
    reducer: function(e, t) {
        void 0 === e && (e = !0);
        var n = t.type;
        return "OFFLINE" !== n && ("ONLINE" === n || e);
    },
    init: function(e) {
        ne("online", function() {
            return e.dispatch({
                type: "ONLINE"
            });
        }), ne("offline", function() {
            return e.dispatch({
                type: "OFFLINE"
            });
        });
    }
}, $e = e, We = r, Xe = function(e) {
    return {
        name: "localCache",
        getMiddleware: function(t) {
            var n, r, o, a, i = {};
            return t.rawBundles.forEach(function(e) {
                e.persistActions && e.persistActions.forEach(function(t) {
                    i[t] || (i[t] = []), i[t].push(e.name);
                });
            }), r = (n = {
                actionMap: i,
                cacheFn: e
            }).cacheFn, o = n.actionMap, a = n.logger, function(e) {
                var t = e.getState;
                return function(e) {
                    return function(n) {
                        var i = o[n.type], c = e(n), u = t();
                        return Ee && i && we(function() {
                            Promise.all(i.map(function(e) {
                                return r(e, u[e]);
                            })).then(function() {
                                a && a("cached " + i.join(", ") + " due to " + n.type);
                            });
                        }, {
                            timeout: 500
                        }), c;
                    };
                };
            };
        }
    };
}, Qe = function(e) {
    return {
        name: "routes",
        selectRouteInfo: q("selectPathname", ge(e)),
        selectRouteParams: q("selectRouteInfo", function(e) {
            return e.params;
        }),
        selectRoute: q("selectRouteInfo", function(e) {
            return e.page;
        })
    };
}, Ye = be, ze = De, Ke = Se, Ze = Ge, Je = qe, et = Ve, tt = de, nt = function(e) {
    var t = Object.assign({}, Te, e);
    return be({
        name: "geolocation",
        actionBaseType: "GEOLOCATION_REQUEST",
        getPromise: function() {
            return new Promise(function(e, n) {
                X && navigator.geolocation || n(Ae("Geolocation not supported", !0)), navigator.geolocation.getCurrentPosition(function(t) {
                    var n = {}, r = t.coords;
                    for(var o in r)n[o] = r[o];
                    n.timestamp = t.timestamp, e(n);
                }, function(e) {
                    var t = e.code;
                    n(Ae(Oe[t], 1 === t));
                }, {
                    timeout: t.timeout,
                    enableHighAccuracy: t.enableHighAccuracy
                });
            });
        },
        persist: t.persist,
        staleAge: t.staleAge,
        retryAfter: t.retryAfter
    });
}, rt = function() {
    for(var t = [], n = arguments.length; n--;)t[n] = arguments[n];
    t || (t = []);
    var o = [
        e,
        r,
        Ge,
        qe(),
        De(),
        Ve
    ].concat(t);
    return de.apply(void 0, o);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"L2GyB":[function(require,module,exports,__globalThis) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ var global = arguments[3];
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.18.1';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`', INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * **Security:** See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
     * — `_.template` is insecure and will be removed in v5.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            // Prevent prototype pollution:
            // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
            // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
            var index = -1, length = path.length;
            if (!length) return true;
            while(++index < length){
                var key = toKey(path[index]);
                // Always block "__proto__" anywhere in the path if it's not expected
                if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) return false;
                // Block constructor/prototype as non-terminal traversal keys to prevent
                // escaping the object graph into built-in constructors and prototypes.
                if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
            }
            var obj = parent(object, path);
            return obj == null || delete obj[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                baseAssignValue(result, pair[0], pair[1]);
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * **Note:** If `lower` is greater than `upper`, the values are swapped.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * // when lower is greater than upper the values are swapped
     * _.random(5, 0);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(-5);
     * // => an integer between -5 and 0
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Security:** `_.template` is insecure and should not be used. It will be
     * removed in Lodash v5. Avoid untrusted input. See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            arrayEach(importsKeys, function(key) {
                if (reForbiddenIdentifierChars.test(key)) throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
            });
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

},{}],"cVAov":[function(require,module,exports,__globalThis) {
'use strict';
/*
 bins - a module for bins defined on an ordered set of maps
 such as the genomes in Gramene.

 Bin numbers are global so they can uniquely identify an interval
 on a chromosome (aka. region). This is why the maps and regions need to be ordered.

 Once the maps have been loaded, you can get a binMapper for a set of bins.

 The bins can be defined as follows:
 a bin size for uniform-width bins in nucleotides
 an arbitrary set of intervals {taxon_id: , region: , start: , end: }

 bins = require('bins.js')(map_info);
 mapper_2Mb = bins.binMapper('uniform',2000000);
 bin = mapper_2Mb.pos2bin(taxon_id, region, position); // returns -1 for positions not in a bin
 interval = mapper_2Mb.bin2pos(bin); // returns an interval that contains position
 */ var isNumber = require("8fa9ac69cca4d17d");
var _ = require("a564f9510dddc1e1");
var Genomes = require("f8c6a58a6ac0b8f7");
module.exports = function(RAW_GENOME_DATA) {
    // generate new genome data structure from (immutable) raw data
    function genomesMap(binName, bins, getBinSizeForGenome) {
        return new Genomes(RAW_GENOME_DATA, binName, bins, getBinSizeForGenome);
    }
    function bins(binName, getBinSizeForGenome) {
        var bins = [];
        var genomeMaps = genomesMap(binName, bins, getBinSizeForGenome);
        return {
            binnedGenomes: function() {
                return genomeMaps;
            },
            bin2pos: function(bin) {
                if (bin < 0 || bin >= bins.length) throw 'bin ' + bin + ' out of range';
                return bins[bin];
            },
            pos2bin: function(tax, rname, position) {
                var genome = genomeMaps.get(tax);
                if (!genome) throw tax + ' not a known taxonomy id';
                var binSize = getBinSizeForGenome(genome);
                var region = genome.region(rname);
                if (!region) // perhaps the user is requesting some scaffold
                // that we have lumped into the 'unanchored' category
                region = genome.region('UNANCHORED');
                if (!region) throw rname + ' not a known seq region';
                if (region.name === 'UNANCHORED') // the unanchored region only has one bin
                return region.startBin;
                if (position < 1 || position >= region.size) throw 'position ' + position + ' out of range';
                return region.startBin + Math.floor((position - 1) / binSize);
            },
            nbins: bins.length,
            _getBinSizeForGenome: getBinSizeForGenome
        };
    }
    function variableBins(bins) {
        // sort the bins to match the order given in the maps
        var genomes = genomesMap();
        // NB THIS FOREACH FUNCTION IS MODIFYING THE BIN OBJECTS
        // PASSED IN.
        bins.map(function(bin) {
            bin.assembly = genomes.get(bin.taxon_id);
            bin.region = bin.assembly.region(bin.region);
            return bin;
        }).sort(function(a, b) {
            // check species
            if (a.taxon_id > b.taxon_id) return 1;
            if (a.taxon_id < b.taxon_id) return -1;
            // same species, check index of region
            if (a.region.idx > b.region.idx) return 1;
            if (a.region.idx < b.region.idx) return -1;
            // same region,  check for overlap and compare bin start positions
            if (a.start > b.start) {
                if (a.start <= b.end) throw new Error('overlapping bins found: ' + JSON.stringify(a) + ' and ' + JSON.stringify(b));
                return 1;
            }
            if (a.start < b.start) {
                if (a.end >= b.start) throw new Error('overlapping bins found: ' + JSON.stringify(a) + ' and ' + JSON.stringify(b));
                return -1;
            }
            throw new Error('found two apparently identical bins: ' + JSON.stringify(a) + ' and ' + JSON.stringify(b));
        });
        var binPos = bins;
        var posBin = {};
        for(var i = 0; i < binPos.length; i++){
            var bin = binPos[i];
            var regionName = bin.region.name;
            if (!posBin.hasOwnProperty(bin.taxon_id)) posBin[bin.taxon_id] = {};
            if (!posBin[bin.taxon_id].hasOwnProperty(regionName)) posBin[bin.taxon_id][regionName] = {
                o: i,
                bins: []
            };
            posBin[bin.taxon_id][regionName].bins.push(bin.start, bin.end);
        }
        return {
            bin2pos: function(bin) {
                if (bin < 0 || bin >= binPos.length) throw 'bin ' + bin + ' out of range';
                return binPos[bin];
            },
            pos2bin: function(tax, region, position) {
                if (!(posBin.hasOwnProperty(tax) && posBin[tax].hasOwnProperty(region))) return -1; // no bins here
                var rbins = posBin[tax][region].bins;
                // binary search in rbins for position
                var a = 0;
                var b = rbins.length - 1;
                if (position < rbins[a] || position > rbins[b] || !isNumber(position)) return -1;
                while(a < b){
                    // assume uniform bin distribution and guess a bin
                    var f = Math.floor((b - a) * (position - rbins[a]) / (rbins[b] - rbins[a]));
                    if (f < 0) return -1;
                    if (f > a && f % 2 == 1) f--;
                    if (position < rbins[f]) b = f - 1;
                    else if (position > rbins[f + 1]) a = f + 2;
                    else return posBin[tax][region].o + f / 2;
                }
                return -1;
            },
            nbins: binPos.length
        };
    }
    return {
        uniformBinMapper: function(binWidth) {
            var name = 'uniform_' + binWidth + 'Mb__bin';
            if (!isNumber(binWidth)) throw new Error('binWidth must be numeric: ' + binWidth);
            return bins(name, function getGlobalBinWidth() {
                return binWidth;
            });
        },
        fixedBinMapper: function(binsPerGenome) {
            var name = 'fixed_' + binsPerGenome + '__bin';
            if (!isNumber(binsPerGenome)) throw new Error('binsPerGenome must be numeric: ' + binsPerGenome);
            return bins(name, function determineBinWidthForGenome(genome) {
                if (genome.assembledGenomeSize === 0) return 0;
                if (genome.assembledGenomeSize < 100000) throw new Error('assembled genome sizes between 1 and 100000 are not supported');
                var binSize = Math.floor(genome.assembledGenomeSize / binsPerGenome);
                function countBins(binSize) {
                    var nbins = 0;
                    genome.eachRegion(function(region) {
                        if (region.name === 'UNANCHORED') nbins++;
                        else nbins += Math.ceil(region.size / binSize);
                    });
                    return nbins;
                }
                var nbins = countBins(binSize);
                if (nbins > binsPerGenome && binsPerGenome > genome.regionCount()) {
                    var a = Math.floor(genome.assembledGenomeSize / (binsPerGenome - genome.regionCount()));
                    var b = binSize;
                    while(a != b && countBins(a) != binsPerGenome){
                        var m = Math.floor((a + b) / 2);
                        var mbins = countBins(m);
                        if (mbins <= binsPerGenome) a = a === m ? b : m;
                        else if (mbins > binsPerGenome) b = b === m ? a : m;
                    }
                    binSize = a;
                }
                return binSize;
            });
        },
        // assume we've been given array of valid non-overlapping intervals as objects with keys
        // taxon_id, region, start, end
        // arg checking might be a good idea
        variableBinMapper: function(binsArray) {
            return variableBins(binsArray);
        }
    };
};

},{"8fa9ac69cca4d17d":"aEMRz","a564f9510dddc1e1":"L2GyB","f8c6a58a6ac0b8f7":"kWRlh"}],"aEMRz":[function(require,module,exports,__globalThis) {
/*!
 * is-number <https://github.com/jonschlinkert/is-number>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */ 'use strict';
module.exports = function isNumber(n) {
    return !!+n && !Array.isArray(n) && isFinite(n) || n === '0' || n === 0;
};

},{}],"kWRlh":[function(require,module,exports,__globalThis) {
'use strict';
var _ = require("e9ae1baa996d99d1");
var genomeStats = require("f98677cdf7848c47").genomeStats;
var setResultsCount = 0;
function Genomes(rawData, binName, bins1, getBinSizeForGenome) {
    this._genomesArray = createGenomeObjects(rawData);
    this._genomesLUT = _.keyBy(this._genomesArray, 'taxon_id');
    this.binName = binName;
    this._bins = bins1;
    if (getBinSizeForGenome) mapGenomesToBins(this, getBinSizeForGenome);
}
Genomes.prototype.binCount = function() {
    return this._bins.length;
};
Genomes.prototype.getBin = function(idx) {
    checkIdx(idx, this._bins);
    return this._bins[idx];
};
Genomes.prototype.getBins = function(startIdx, endIdx) {
    checkIdx(startIdx, this._bins);
    checkIdx(endIdx, this._bins);
    if (startIdx > endIdx) throw new Error("Start index is after end index.");
    return _.slice(this._bins, startIdx, endIdx + 1);
};
Genomes.prototype.allBins = function() {
    return _.clone(this._bins);
};
function checkIdx(idx, bins1) {
    if (!_.isFinite(idx)) throw new Error("Supplied index not a finite number.");
    if (idx < 0 || idx > bins1.length - 1) throw new Error("Supplied index out of range.");
}
Genomes.prototype.each = function(iteratee) {
    _.forEach(this._genomesArray, function(region) {
        iteratee(region, region.name);
    }, this);
//_.forOwn(this._genomesLUT, iteratee, this);
};
Genomes.prototype.reduce = function(reducer, initialValue) {
    return _.reduce(this._genomesLUT, reducer, initialValue);
};
Genomes.prototype.get = function(taxonId) {
    return this._genomesLUT[taxonId];
};
Genomes.prototype.setResults = function(binnedResults) {
    checkResultsObject(binnedResults, this._bins.length, this.binName);
    var data = binnedResults.data;
    for(var i = 0; i < this._bins.length; i++){
        var bin = this._bins[i];
        bin.results = data[bin.idx] || {
            count: 0
        };
    }
    this.results = this.reduce(function(acc, genome) {
        updateGenomeResults(genome);
        acc.count += genome.results.count;
        acc.bins += genome.results.bins;
        return acc;
    }, {
        count: 0,
        bins: 0
    });
    ++setResultsCount;
    this.stats = genomeStats(this._bins, this._genomesArray, setResultsCount);
};
Genomes.prototype.clearResults = function() {
    for(var i = 0; i < bins.length; i++){
        var bin = bins[i];
        delete bin.result;
    }
};
function mapGenomesToBins(genomes, getBinSizeForGenome) {
    genomes.each(function(genome) {
        var tax = genome.taxon_id;
        var binSize = getBinSizeForGenome(genome);
        var genomeBinCount = 0;
        genome.startBin = genomes.binCount();
        genome.eachRegion(function(region, rname) {
            var nbins = rname === 'UNANCHORED' ? 1 : Math.ceil(region.size / binSize);
            region.startBin = genomes.binCount();
            for(var j = 0; j < nbins; j++){
                var idx = region.startBin + j;
                var start = j * binSize + 1;
                var end = j + 1 === nbins ? region.size : (j + 1) * binSize;
                var bin = {
                    taxon_id: tax,
                    region: rname,
                    start: start,
                    end: end,
                    idx: idx
                };
                addBin(bin, genomes, region);
                ++genomeBinCount;
            }
        });
        genome.nbins = genomeBinCount;
    });
}
function addBin(bin, genomes, region) {
    genomes._bins.push(bin);
    region._bins.push(bin);
}
function checkResultsObject(binnedResults, binCount, binName) {
    var lastBin;
    if (!(binnedResults && typeof binnedResults === 'object' && binnedResults.data && binnedResults.displayName)) throw new Error('Please supply valid results parameter');
    if (binnedResults.displayName && binnedResults.displayName !== binName) throw new Error('Results are for ' + binnedResults.displayName + ' bins. Should be ' + binName);
    lastBin = _.max(Object.keys(binnedResults.data), function(binId) {
        return +binId;
    });
    if (lastBin > binCount) throw new Error('Bin count mismatch!');
}
function createGenomeObjects(rawData) {
    return _(rawData).map(function(d) {
        return new Genome({
            taxon_id: d.taxon_id,
            system_name: d.system_name,
            assembledGenomeSize: d.length,
            regions: d.regions
        });
    }).sortBy('taxon_id').value();
}
function Genome(params) {
    this._regionsArray = refactorMapRegions(params.regions);
    this._regionsLUT = _.keyBy(this._regionsArray, 'name');
    this.taxon_id = params.taxon_id;
    this.assembledGenomeSize = params.assembledGenomeSize;
    this.system_name = params.system_name;
    // the above does not include UNANCHORED region. Let's include that here:
    this.fullGenomeSize = this.reduceRegions(function(total, region) {
        return total + region.size;
    }, 0);
    if (this.fullGenomeSize < this.assembledGenomeSize) throw new Error('inconsistencies in genome sizes! The assembled length of ' + this.taxon_id + '\'s genome (' + this.assembledGenomeSize + ') is longer than the sum of all regions of that genome (' + this.fullGenomeSize + ')');
}
Genome.prototype.regionCount = function() {
    return _.size(this._regionsLUT);
};
Genome.prototype.region = function(name) {
    return this._regionsLUT[name];
};
Genome.prototype.eachRegion = function(iteratee) {
    _.forEach(this._regionsArray, function(region) {
        iteratee(region, region.name);
    }, this);
};
Genome.prototype.mapRegions = function(iteratee) {
    return _.map(this._regionsArray, iteratee, this);
};
Genome.prototype.reduceRegions = function(reducer, initialValue) {
    return _.reduce(this._regionsArray, reducer, initialValue);
};
function updateGenomeResults(genome) {
    genome.results = genome.reduceRegions(function(acc, region) {
        updateRegionResults(region);
        acc.count += region.results.count;
        acc.bins += region.results.bins;
        return acc;
    }, {
        count: 0,
        bins: 0
    });
}
function refactorMapRegions(regions) {
    var regionArray, rname, indices;
    if (!regions) {
        console.log('No regions. I hope we are testing');
        return {};
    }
    if (regions.lengths && regions.names) {
        indices = _.range(regions.names.length);
        regionArray = _.zip(regions.names, regions.lengths, indices).map(function(region) {
            return new Region({
                name: region[0],
                size: region[1],
                idx: region[2]
            });
        });
        return regionArray;
    } else throw new Error("regions must have lengths and names defined");
}
// REGION
function Region(params) {
    this.name = params.name;
    this.size = params.size;
    this.idx = params.idx;
    this._bins = [];
}
function updateRegionResults(region) {
    region.results = region.reduceBins(function(acc, bin) {
        if (bin.results && bin.results.count) {
            acc.count += bin.results.count;
            acc.bins++;
        }
        return acc;
    }, {
        count: 0,
        bins: 0
    });
}
Region.prototype.firstBin = function() {
    return this.binCount() ? this._bins[0] : undefined;
};
Region.prototype.eachBin = function(iteratee) {
    _.forEach(this._bins, iteratee);
};
Region.prototype.mapBins = function(iteratee) {
    return _.map(this._bins, iteratee);
};
Region.prototype.bin = function(idx) {
    return this._bins[idx];
};
Region.prototype.binCount = function() {
    return this._bins.length;
};
Region.prototype.reduceBins = function(reducer, initialValue) {
    return _.reduce(this._bins, reducer, initialValue);
};
// EXPORTS
Genome.Region = Region;
Genomes.Genome = Genome;
module.exports = Genomes;

},{"e9ae1baa996d99d1":"L2GyB","f98677cdf7848c47":"ergDc"}],"ergDc":[function(require,module,exports,__globalThis) {
'use strict';
var _ = require("887c74c05ec1e333");
function calcStats(array) {
    var result = _.reduce(array, function(total, item) {
        var count = item.results.count;
        total.count++;
        total.min = Math.min(total.min, count);
        total.max = Math.max(total.max, count);
        total.sum += count;
        total.sumSq += Math.pow(count, 2);
        return total;
    }, {
        count: 0,
        min: Infinity,
        max: 0,
        sum: 0,
        sumSq: 0
    });
    result.avg = result.sum / result.count;
    result.stdev = Math.sqrt(result.sumSq / result.count - Math.pow(result.avg, 2));
    return result;
}
function globalStatistics(bins, genomes, setResultsCount) {
    var anchoredBins, stats;
    stats = {};
    anchoredBins = _.filter(bins, function(bin) {
        return bin.region !== 'UNANCHORED';
    });
    stats.genomes = calcStats(genomes);
    stats.bins = calcStats(anchoredBins);
    stats.timesSetResultsHasBeenCalled = setResultsCount;
    return stats;
}
module.exports = {
    calcStats: calcStats,
    genomeStats: globalStatistics
};

},{"887c74c05ec1e333":"L2GyB"}],"eBvDB":[function(require,module,exports,__globalThis) {
'use strict';
/*
 trees - a module for trees in gramene

 */ var TreeModel = require("2d48bdf96d0e6aa");
var FlatToNested = require("cbcf633a71c12bea");
var _ = require("5466903d89e3ea5d");
var treemodelExtensions = require("385ded5c923931ea");
module.exports = {
    tree: function(taxonomy) {
        function cleanUpProperties(taxonomy) {
            return taxonomy.map(function(taxon) {
                if (!taxon.is_a) {
                    if (taxon._id !== 1) throw new Error('unrooted node!');
                }
                if (taxon.hasOwnProperty('property_value')) taxon.rank = taxon.property_value.replace(/has_rank NCBITaxon:/, '');
                return {
                    id: taxon._id,
                    parent: taxon.is_a ? taxon.is_a[0] : undefined,
                    rank: taxon.rank,
                    name: taxon.name,
                    synonyms: taxon.synonym || [],
                    geneCount: taxon.num_genes,
                    leftIndex: taxon.left_index || 0,
                    reactomePrefix: taxon.reactomePrefix
                };
            });
        }
        function createTree(nestedTaxa) {
            function childNodeNameLexComparator(a, b) {
                return a.name > b.name ? 1 : -1;
            }
            function childNodeGeneCountComparator(a, b) {
                return a.geneCount < b.geneCount ? 1 : -1;
            }
            function childNodeComparator(a, b) {
                if (a.leftIndex) return a.leftIndex < b.leftIndex ? -1 : 1;
                if (a.geneCount) return a.geneCount < b.geneCount ? 1 : -1;
                return a.name > b.name ? 1 : -1;
            }
            return new TreeModel({
                modelComparatorFn: childNodeComparator
            }).parse(nestedTaxa);
        }
        function compressTreePaths(tree) {
            tree.all(function(node) {
                return !node.isRoot() && node.children.length === 1;
            }).forEach(function(node) {
                var parent = node.parent, child = node.children[0];
                parent.addChild(child);
                node.drop();
                // maintain the link from the compressed node to the parent
                // (this is deleted in call to node.drop())
                node.parent = parent;
                node.compressed = true;
                // Add compressed nodes to child and not parent
                if (!child.compressedNodes) child.compressedNodes = [];
                child.compressedNodes.push(node);
                if (node.compressedNodes) {
                    child.compressedNodes = node.compressedNodes.concat(child.compressedNodes);
                    delete node.compressedNodes;
                }
            });
        }
        //function decorateTree(tree) {
        //  tree.lca = function lowestCommonAncestor(nodes) {
        //    var parentNodesInCommon = _.chain(nodes)
        //      .map(function (node) {
        //        return node.getPath();
        //      })
        //      .reduce(function (acc, nextPath) {
        //        return _.intersection(acc, nextPath)
        //      })
        //      .value();
        //    return parentNodesInCommon.pop();
        //  };
        //
        //  tree.pathBetween = function pathBetweenNodes(from, to) {
        //
        //    var lca, fromPath, toPath, fromLcaIdx, toLcaIdx, pathBetween;
        //
        //    // find the lowest commen ancestor
        //    lca = tree.lca([from, to]);
        //
        //    // get the full path from -> root, and reverse it
        //    fromPath = _(from.getPath().reverse());
        //
        //    // get the full path to -> root
        //    toPath = _(to.getPath());
        //
        //    // find the index of lca in fromPath and toPath
        //    fromLcaIdx = fromPath.findIndex(lca);
        //    toLcaIdx = toPath.findIndex(lca);
        //
        //    // slice and combine the arrays to get the path between
        //    pathBetween = fromPath.slice(0, fromLcaIdx).concat(toPath.slice(toLcaIdx).value());
        //
        //    return pathBetween.value();
        //  };
        //}
        //
        //function addPrototypeDecorations(tree) {
        //  var prototree = Object.getPrototypeOf(tree);
        //
        //  prototree.depth = function calculateEffectiveNodeDepth(includeCompressedNodes) {
        //    var path = this.getPath()
        //      , depth = path.length - 1
        //      , compressedDepth;
        //
        //    if(includeCompressedNodes) {
        //      compressedDepth = _.reduce(path, function (acc, n) {
        //        return acc + (n.compressedNodes ? n.compressedNodes.length : 0);
        //      }, 0);
        //      depth += compressedDepth;
        //    }
        //
        //    return depth;
        //  };
        //
        //  prototree.pathTo = function(to) {
        //    return tree.pathBetween(this, to);
        //  };
        //
        //  prototree.leafNodes = function findAllLeafNodes() {
        //    return this.all(function (node) { return !node.hasChildren(); });
        //  };
        //
        //  prototree.lcaWith = function(otherNodes) {
        //    var nodes = _.clone(otherNodes);
        //    nodes.push(this);
        //    return tree.lca(nodes);
        //  }
        //}
        //
        //function indexTree(tree, attrs) {
        //  tree.indices = _.chain(attrs)
        //    .map(function (attr) {
        //      var result = {_attr: attr};
        //      tree.walk(function (node) {
        //        result[node.model[attr]] = node;
        //      });
        //      return result;
        //    })
        //    .indexBy('_attr')
        //    .value();
        //}
        var taxa, nestedTaxa, tree;
        taxa = cleanUpProperties(taxonomy);
        nestedTaxa = new FlatToNested().convert(taxa);
        tree = createTree(nestedTaxa);
        treemodelExtensions.indexTree(tree, [
            'id',
            'name'
        ]);
        compressTreePaths(tree);
        treemodelExtensions.decorateTree(tree);
        treemodelExtensions.addPrototypeDecorations(tree);
        return tree;
    }
};

},{"2d48bdf96d0e6aa":"5AXxY","cbcf633a71c12bea":"03Rza","5466903d89e3ea5d":"8bWZr","385ded5c923931ea":"jrU9D"}],"5AXxY":[function(require,module,exports,__globalThis) {
var mergeSort, findInsertIndex;
mergeSort = require("d1ac30c990142154");
findInsertIndex = require("c93acf17e6b45ca8");
module.exports = function() {
    'use strict';
    var walkStrategies;
    walkStrategies = {};
    function k(result) {
        return function() {
            return result;
        };
    }
    function TreeModel(config) {
        config = config || {};
        this.config = config;
        this.config.childrenPropertyName = config.childrenPropertyName || 'children';
        this.config.modelComparatorFn = config.modelComparatorFn;
    }
    function addChildToNode(node, child) {
        child.parent = node;
        node.children.push(child);
        return child;
    }
    function Node(config, model) {
        this.config = config;
        this.model = model;
        this.children = [];
    }
    TreeModel.prototype.parse = function(model) {
        var i, childCount, node;
        if (!(model instanceof Object)) throw new TypeError('Model must be of type object.');
        node = new Node(this.config, model);
        if (model[this.config.childrenPropertyName] instanceof Array) {
            if (this.config.modelComparatorFn) model[this.config.childrenPropertyName] = mergeSort(this.config.modelComparatorFn, model[this.config.childrenPropertyName]);
            for(i = 0, childCount = model[this.config.childrenPropertyName].length; i < childCount; i++)addChildToNode(node, this.parse(model[this.config.childrenPropertyName][i]));
        }
        return node;
    };
    function hasComparatorFunction(node) {
        return typeof node.config.modelComparatorFn === 'function';
    }
    Node.prototype.isRoot = function() {
        return this.parent === undefined;
    };
    Node.prototype.hasChildren = function() {
        return this.children.length > 0;
    };
    function addChild(self, child, insertIndex) {
        var index;
        if (!(child instanceof Node)) throw new TypeError('Child must be of type Node.');
        child.parent = self;
        if (!(self.model[self.config.childrenPropertyName] instanceof Array)) self.model[self.config.childrenPropertyName] = [];
        if (hasComparatorFunction(self)) {
            // Find the index to insert the child
            index = findInsertIndex(self.config.modelComparatorFn, self.model[self.config.childrenPropertyName], child.model);
            // Add to the model children
            self.model[self.config.childrenPropertyName].splice(index, 0, child.model);
            // Add to the node children
            self.children.splice(index, 0, child);
        } else if (insertIndex === undefined) {
            self.model[self.config.childrenPropertyName].push(child.model);
            self.children.push(child);
        } else {
            if (insertIndex < 0 || insertIndex > self.children.length) throw new Error('Invalid index.');
            self.model[self.config.childrenPropertyName].splice(insertIndex, 0, child.model);
            self.children.splice(insertIndex, 0, child);
        }
        return child;
    }
    Node.prototype.addChild = function(child) {
        return addChild(this, child);
    };
    Node.prototype.addChildAtIndex = function(child, index) {
        if (hasComparatorFunction(this)) throw new Error('Cannot add child at index when using a comparator function.');
        return addChild(this, child, index);
    };
    Node.prototype.setIndex = function(index) {
        if (hasComparatorFunction(this)) throw new Error('Cannot set node index when using a comparator function.');
        if (this.isRoot()) {
            if (index === 0) return this;
            throw new Error('Invalid index.');
        }
        if (index < 0 || index >= this.parent.children.length) throw new Error('Invalid index.');
        var oldIndex = this.parent.children.indexOf(this);
        this.parent.children.splice(index, 0, this.parent.children.splice(oldIndex, 1)[0]);
        this.parent.model[this.parent.config.childrenPropertyName].splice(index, 0, this.parent.model[this.parent.config.childrenPropertyName].splice(oldIndex, 1)[0]);
        return this;
    };
    Node.prototype.getPath = function() {
        var path = [];
        (function addToPath(node) {
            path.unshift(node);
            if (!node.isRoot()) addToPath(node.parent);
        })(this);
        return path;
    };
    Node.prototype.getIndex = function() {
        if (this.isRoot()) return 0;
        return this.parent.children.indexOf(this);
    };
    /**
   * Parse the arguments of traversal functions. These functions can take one optional
   * first argument which is an options object. If present, this object will be stored
   * in args.options. The only mandatory argument is the callback function which can
   * appear in the first or second position (if an options object is given). This
   * function will be saved to args.fn. The last optional argument is the context on
   * which the callback function will be called. It will be available in args.ctx.
   *
   * @returns Parsed arguments.
   */ function parseArgs() {
        var args = {};
        if (arguments.length === 1) {
            if (typeof arguments[0] === 'function') args.fn = arguments[0];
            else args.options = arguments[0];
        } else if (arguments.length === 2) {
            if (typeof arguments[0] === 'function') {
                args.fn = arguments[0];
                args.ctx = arguments[1];
            } else {
                args.options = arguments[0];
                args.fn = arguments[1];
            }
        } else {
            args.options = arguments[0];
            args.fn = arguments[1];
            args.ctx = arguments[2];
        }
        args.options = args.options || {};
        if (!args.options.strategy) args.options.strategy = 'pre';
        if (!walkStrategies[args.options.strategy]) throw new Error('Unknown tree walk strategy. Valid strategies are \'pre\' [default], \'post\' and \'breadth\'.');
        return args;
    }
    Node.prototype.walk = function() {
        var args;
        args = parseArgs.apply(this, arguments);
        walkStrategies[args.options.strategy].call(this, args.fn, args.ctx);
    };
    walkStrategies.pre = function depthFirstPreOrder(callback, context) {
        var i, childCount, keepGoing;
        keepGoing = callback.call(context, this);
        for(i = 0, childCount = this.children.length; i < childCount; i++){
            if (keepGoing === false) return false;
            keepGoing = depthFirstPreOrder.call(this.children[i], callback, context);
        }
        return keepGoing;
    };
    walkStrategies.post = function depthFirstPostOrder(callback, context) {
        var i, childCount, keepGoing;
        for(i = 0, childCount = this.children.length; i < childCount; i++){
            keepGoing = depthFirstPostOrder.call(this.children[i], callback, context);
            if (keepGoing === false) return false;
        }
        keepGoing = callback.call(context, this);
        return keepGoing;
    };
    walkStrategies.breadth = function breadthFirst(callback, context) {
        var queue = [
            this
        ];
        (function processQueue() {
            var i, childCount, node;
            if (queue.length === 0) return;
            node = queue.shift();
            for(i = 0, childCount = node.children.length; i < childCount; i++)queue.push(node.children[i]);
            if (callback.call(context, node) !== false) processQueue();
        })();
    };
    Node.prototype.all = function() {
        var args, all = [];
        args = parseArgs.apply(this, arguments);
        args.fn = args.fn || k(true);
        walkStrategies[args.options.strategy].call(this, function(node) {
            if (args.fn.call(args.ctx, node)) all.push(node);
        }, args.ctx);
        return all;
    };
    Node.prototype.first = function() {
        var args, first;
        args = parseArgs.apply(this, arguments);
        args.fn = args.fn || k(true);
        walkStrategies[args.options.strategy].call(this, function(node) {
            if (args.fn.call(args.ctx, node)) {
                first = node;
                return false;
            }
        }, args.ctx);
        return first;
    };
    Node.prototype.drop = function() {
        var indexOfChild;
        if (!this.isRoot()) {
            indexOfChild = this.parent.children.indexOf(this);
            this.parent.children.splice(indexOfChild, 1);
            this.parent.model[this.config.childrenPropertyName].splice(indexOfChild, 1);
            this.parent = undefined;
            delete this.parent;
        }
        return this;
    };
    return TreeModel;
}();

},{"d1ac30c990142154":"jQDXi","c93acf17e6b45ca8":"jyE6k"}],"jQDXi":[function(require,module,exports,__globalThis) {
module.exports = function() {
    'use strict';
    /**
   * Sort an array using the merge sort algorithm.
   *
   * @param {function} comparatorFn The comparator function.
   * @param {array} arr The array to sort.
   * @returns {array} The sorted array.
   */ function mergeSort(comparatorFn, arr) {
        var len = arr.length, firstHalf, secondHalf;
        if (len >= 2) {
            firstHalf = arr.slice(0, len / 2);
            secondHalf = arr.slice(len / 2, len);
            return merge(comparatorFn, mergeSort(comparatorFn, firstHalf), mergeSort(comparatorFn, secondHalf));
        } else return arr.slice();
    }
    /**
   * The merge part of the merge sort algorithm.
   *
   * @param {function} comparatorFn The comparator function.
   * @param {array} arr1 The first sorted array.
   * @param {array} arr2 The second sorted array.
   * @returns {array} The merged and sorted array.
   */ function merge(comparatorFn, arr1, arr2) {
        var result = [], left1 = arr1.length, left2 = arr2.length;
        while(left1 > 0 && left2 > 0)if (comparatorFn(arr1[0], arr2[0]) <= 0) {
            result.push(arr1.shift());
            left1--;
        } else {
            result.push(arr2.shift());
            left2--;
        }
        if (left1 > 0) result.push.apply(result, arr1);
        else result.push.apply(result, arr2);
        return result;
    }
    return mergeSort;
}();

},{}],"jyE6k":[function(require,module,exports,__globalThis) {
module.exports = function() {
    'use strict';
    /**
   * Find the index to insert an element in array keeping the sort order.
   *
   * @param {function} comparatorFn The comparator function which sorted the array.
   * @param {array} arr The sorted array.
   * @param {object} el The element to insert.
   */ function findInsertIndex(comparatorFn, arr, el) {
        var i, len;
        for(i = 0, len = arr.length; i < len; i++){
            if (comparatorFn(arr[i], el) > 0) break;
        }
        return i;
    }
    return findInsertIndex;
}();

},{}],"03Rza":[function(require,module,exports,__globalThis) {
module.exports = function() {
    'use strict';
    function initPush(arrayName, obj, toPush) {
        if (obj[arrayName] === undefined) obj[arrayName] = [];
        obj[arrayName].push(toPush);
    }
    function multiInitPush(arrayName, obj, toPushArray) {
        var len;
        len = toPushArray.length;
        if (obj[arrayName] === undefined) obj[arrayName] = [];
        while(len-- > 0)obj[arrayName].push(toPushArray.shift());
    }
    /**
   * Create a new FlatToNested object.
   *
   * @constructor
   * @param {object} config The configuration object.
   */ function FlatToNested(config) {
        this.config = config = config || {};
        this.config.id = config.id || 'id';
        this.config.parent = config.parent || 'parent';
        this.config.children = config.children || 'children';
        this.config.options = config.options || {
            deleteParent: true
        };
    }
    /**
   * Convert a hierarchy from flat to nested representation.
   *
   * @param {array} flat The array with the hierachy flat representation.
   */ FlatToNested.prototype.convert = function(flat) {
        var i, len, temp, roots, id, parent, nested, pendingChildOf, flatEl;
        i = 0;
        roots = [];
        temp = {};
        pendingChildOf = {};
        for(i, len = flat.length; i < len; i++){
            flatEl = flat[i];
            id = flatEl[this.config.id];
            parent = flatEl[this.config.parent];
            temp[id] = flatEl;
            if (parent === undefined || parent === null) // Current object has no parent, so it's a root element.
            roots.push(flatEl);
            else {
                if (temp[parent] !== undefined) // Parent is already in temp, adding the current object to its children array.
                initPush(this.config.children, temp[parent], flatEl);
                else // Parent for this object is not yet in temp, adding it to pendingChildOf.
                initPush(parent, pendingChildOf, flatEl);
                if (this.config.options.deleteParent) delete flatEl[this.config.parent];
            }
            if (pendingChildOf[id] !== undefined) // Current object has children pending for it. Adding these to the object.
            multiInitPush(this.config.children, flatEl, pendingChildOf[id]);
        }
        if (roots.length === 1) nested = roots[0];
        else if (roots.length > 1) {
            nested = {};
            nested[this.config.children] = roots;
        } else nested = {};
        return nested;
    };
    return FlatToNested;
}();

},{}],"8bWZr":[function(require,module,exports,__globalThis) {
/**
 * @license
 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern -d -o ./index.js`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ var global = arguments[3];
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '3.10.1';
    /** Used to compose bitmasks for wrapper metadata. */ var BIND_FLAG = 1, BIND_KEY_FLAG = 2, CURRY_BOUND_FLAG = 4, CURRY_FLAG = 8, CURRY_RIGHT_FLAG = 16, PARTIAL_FLAG = 32, PARTIAL_RIGHT_FLAG = 64, ARY_FLAG = 128, REARG_FLAG = 256;
    /** Used as default options for `_.trunc`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect when a function becomes hot. */ var HOT_COUNT = 150, HOT_SPAN = 16;
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2;
    /** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = 'Expected a function';
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', weakMapTag = '[object WeakMap]';
    var arrayBufferTag = '[object ArrayBuffer]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g, reUnescapedHtml = /[&<>"'`]/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
    /**
   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
   */ var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g, reHasRegExpChars = RegExp(reRegExpChars.source);
    /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */ var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect hexadecimal string values. */ var reHasHexPrefix = /^0[xX]/;
    /** Used to detect host constructors (Safari > 5). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect unsigned integer values. */ var reIsUint = /^\d+$/;
    /** Used to match latin-1 supplementary letters (excluding mathematical operators). */ var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to match words to create compound words. */ var reWords = function() {
        var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]', lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';
        return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
    }();
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'ArrayBuffer',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Math',
        'Number',
        'Object',
        'RegExp',
        'Set',
        'String',
        '_',
        'clearTimeout',
        'isFinite',
        'parseFloat',
        'parseInt',
        'setTimeout',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[stringTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[mapTag] = cloneableTags[setTag] = cloneableTags[weakMapTag] = false;
    /** Used to map latin-1 supplementary letters to basic latin letters. */ var deburredLetters = {
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcC': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xeC': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '`': '&#96;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'",
        '&#96;': '`'
    };
    /** Used to determine if values are of the language type `Object`. */ var objectTypes = {
        'function': true,
        'object': true
    };
    /** Used to escape characters for inclusion in compiled regexes. */ var regexpEscapes = {
        '0': 'x30',
        '1': 'x31',
        '2': 'x32',
        '3': 'x33',
        '4': 'x34',
        '5': 'x35',
        '6': 'x36',
        '7': 'x37',
        '8': 'x38',
        '9': 'x39',
        'A': 'x41',
        'B': 'x42',
        'C': 'x43',
        'D': 'x44',
        'E': 'x45',
        'F': 'x46',
        'a': 'x61',
        'b': 'x62',
        'c': 'x63',
        'd': 'x64',
        'e': 'x65',
        'f': 'x66',
        'n': 'x6e',
        'r': 'x72',
        't': 'x74',
        'u': 'x75',
        'v': 'x76',
        'x': 'x78'
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Detect free variable `exports`. */ var freeExports = objectTypes["object"] && exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = objectTypes["object"] && module && !module.nodeType && module;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;
    /** Detect free variable `self`. */ var freeSelf = objectTypes[typeof self] && self && self.Object && self;
    /** Detect free variable `window`. */ var freeWindow = objectTypes[typeof window] && window && window.Object && window;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;
    /**
   * Used as a reference to the global object.
   *
   * The `this` value is used if it's the global object to avoid Greasemonkey's
   * restricted `window` object, otherwise the `window` object is used.
   */ var root = freeGlobal || freeWindow !== (this && this.window) && freeWindow || freeSelf || this;
    /*--------------------------------------------------------------------------*/ /**
   * The base implementation of `compareAscending` which compares values and
   * sorts them in ascending order without guaranteeing a stable sort.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {number} Returns the sort order indicator for `value`.
   */ function baseCompareAscending(value, other) {
        if (value !== other) {
            var valIsNull = value === null, valIsUndef = value === undefined, valIsReflexive = value === value;
            var othIsNull = other === null, othIsUndef = other === undefined, othIsReflexive = other === other;
            if (value > other && !othIsNull || !valIsReflexive || valIsNull && !othIsUndef && othIsReflexive || valIsUndef && othIsReflexive) return 1;
            if (value < other && !valIsNull || !othIsReflexive || othIsNull && !valIsUndef && valIsReflexive || othIsUndef && valIsReflexive) return -1;
        }
        return 0;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {Function} predicate The function invoked per iteration.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromRight) {
        var length = array.length, index = fromRight ? length : -1;
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without support for binary searches.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        if (value !== value) return indexOfNaN(array, fromIndex);
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isFunction` without support for environments
   * with incorrect `typeof` results.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
   */ function baseIsFunction(value) {
        // Avoid a Chakra JIT bug in compatibility modes of IE 11.
        // See https://github.com/jashkenas/underscore/issues/1621 for more details.
        return typeof value == 'function' || false;
    }
    /**
   * Converts `value` to a string if it's not one. An empty string is returned
   * for `null` or `undefined` values.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */ function baseToString(value) {
        return value == null ? '' : value + '';
    }
    /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the first character not found in `chars`.
   */ function charsLeftIndex(string, chars) {
        var index = -1, length = string.length;
        while(++index < length && chars.indexOf(string.charAt(index)) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the last character not found in `chars`.
   */ function charsRightIndex(string, chars) {
        var index = string.length;
        while(index-- && chars.indexOf(string.charAt(index)) > -1);
        return index;
    }
    /**
   * Used by `_.sortBy` to compare transformed elements of a collection and stable
   * sort them in ascending order.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @returns {number} Returns the sort order indicator for `object`.
   */ function compareAscending(object, other) {
        return baseCompareAscending(object.criteria, other.criteria) || object.index - other.index;
    }
    /**
   * Used by `_.sortByOrder` to compare multiple properties of a value to another
   * and stable sort them.
   *
   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
   * a value is sorted in ascending order if its corresponding order is "asc", and
   * descending if "desc".
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {boolean[]} orders The order to sort by for each property.
   * @returns {number} Returns the sort order indicator for `object`.
   */ function compareMultiple(object, other, orders) {
        var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
        while(++index < length){
            var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
            if (result) {
                if (index >= ordersLength) return result;
                var order = orders[index];
                return result * (order === 'asc' || order === true ? 1 : -1);
            }
        }
        // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
        // that causes it, under certain circumstances, to provide the same value for
        // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
        // for more details.
        //
        // This also ensures a stable sort in V8 and other engines.
        // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
        return object.index - other.index;
    }
    /**
   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ function deburrLetter(letter) {
        return deburredLetters[letter];
    }
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeHtmlChar(chr) {
        return htmlEscapes[chr];
    }
    /**
   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @param {string} leadingChar The capture group for a leading character.
   * @param {string} whitespaceChar The capture group for a whitespace character.
   * @returns {string} Returns the escaped character.
   */ function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
        if (leadingChar) chr = regexpEscapes[chr];
        else if (whitespaceChar) chr = stringEscapes[chr];
        return '\\' + chr;
    }
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the index at which the first occurrence of `NaN` is found in `array`.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
   */ function indexOfNaN(array, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 0 : -1);
        while(fromRight ? index-- : ++index < length){
            var other = array[index];
            if (other !== other) return index;
        }
        return -1;
    }
    /**
   * Checks if `value` is object-like.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   */ function isObjectLike(value) {
        return !!value && typeof value == 'object';
    }
    /**
   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
   * character code is whitespace.
   *
   * @private
   * @param {number} charCode The character code to inspect.
   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
   */ function isSpace(charCode) {
        return charCode <= 160 && charCode >= 9 && charCode <= 13 || charCode == 32 || charCode == 160 || charCode == 5760 || charCode == 6158 || charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279);
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = -1, result = [];
        while(++index < length)if (array[index] === placeholder) {
            array[index] = PLACEHOLDER;
            result[++resIndex] = index;
        }
        return result;
    }
    /**
   * An implementation of `_.uniq` optimized for sorted arrays without support
   * for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} [iteratee] The function invoked per iteration.
   * @returns {Array} Returns the new duplicate-value-free array.
   */ function sortedUniq(array, iteratee) {
        var seen, index = -1, length = array.length, resIndex = -1, result = [];
        while(++index < length){
            var value = array[index], computed = iteratee ? iteratee(value, index, array) : value;
            if (!index || seen !== computed) {
                seen = computed;
                result[++resIndex] = value;
            }
        }
        return result;
    }
    /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the first non-whitespace character.
   */ function trimmedLeftIndex(string) {
        var index = -1, length = string.length;
        while(++index < length && isSpace(string.charCodeAt(index)));
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedRightIndex(string) {
        var index = string.length;
        while(index-- && isSpace(string.charCodeAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ function unescapeHtmlChar(chr) {
        return htmlUnescapes[chr];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the given `context` object.
   *
   * @static
   * @memberOf _
   * @category Utility
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // using `context` to mock `Date#getTime` use in `_.now`
   * var mock = _.runInContext({
   *   'Date': function() {
   *     return { 'getTime': getTimeMock };
   *   }
   * });
   *
   * // or creating a suped-up `defer` in Node.js
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ function runInContext(context) {
        // Avoid issues with some ES3 environments that attempt to use values, named
        // after built-in constructors like `Object`, for the creation of literals.
        // ES5 clears this up by stating that literals must use built-in constructors.
        // See https://es5.github.io/#x11.1.5 for more details.
        context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;
        /** Native constructor references. */ var Array = context.Array, Date = context.Date, Error = context.Error, Function = context.Function, Math = context.Math, Number = context.Number, Object = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for native method references. */ var arrayProto = Array.prototype, objectProto = Object.prototype, stringProto = String.prototype;
        /** Used to resolve the decompiled source of functions. */ var fnToString = Function.prototype.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /**
     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
     * of values.
     */ var objToString = objectProto.toString;
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Native method references. */ var ArrayBuffer = context.ArrayBuffer, clearTimeout = context.clearTimeout, parseFloat = context.parseFloat, pow = Math.pow, propertyIsEnumerable = objectProto.propertyIsEnumerable, Set = getNative(context, 'Set'), setTimeout = context.setTimeout, splice = arrayProto.splice, Uint8Array = context.Uint8Array, WeakMap = getNative(context, 'WeakMap');
        /* Native method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeCreate = getNative(Object, 'create'), nativeFloor = Math.floor, nativeIsArray = getNative(Array, 'isArray'), nativeIsFinite = context.isFinite, nativeKeys = getNative(Object, 'keys'), nativeMax = Math.max, nativeMin = Math.min, nativeNow = getNative(Date, 'now'), nativeParseInt = context.parseInt, nativeRandom = Math.random;
        /** Used as references for `-Infinity` and `Infinity`. */ var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY, POSITIVE_INFINITY = Number.POSITIVE_INFINITY;
        /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
        /**
     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
     * of an array-like value.
     */ var MAX_SAFE_INTEGER = 9007199254740991;
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
     * Methods that operate on and return arrays, collections, and functions can
     * be chained together. Methods that retrieve a single value or may return a
     * primitive value will automatically end the chain returning the unwrapped
     * value. Explicit chaining may be enabled using `_.chain`. The execution of
     * chained methods is lazy, that is, execution is deferred until `_#value`
     * is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
     * fusion is an optimization strategy which merge iteratee calls; this can help
     * to avoid the creation of intermediate data structures and greatly reduce the
     * number of iteratee executions.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
     * `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
     * and `where`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
     * `unescape`, `uniqueId`, `value`, and `words`
     *
     * The wrapper method `sample` will return a wrapped value when `n` is provided,
     * otherwise an unwrapped value is returned.
     *
     * @name _
     * @constructor
     * @category Chain
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // returns an unwrapped value
     * wrapped.reduce(function(total, n) {
     *   return total + n;
     * });
     * // => 6
     *
     * // returns a wrapped value
     * var squares = wrapped.map(function(n) {
     *   return n * n;
     * });
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The function whose prototype all chaining wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
     */ function LodashWrapper(value, chainAll, actions) {
            this.__wrapped__ = value;
            this.__actions__ = actions || [];
            this.__chain__ = !!chainAll;
        }
        /**
     * An object environment feature flags.
     *
     * @static
     * @memberOf _
     * @type Object
     */ var support = lodash.support = {};
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB). Change the following template settings to use
     * alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type Object
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type string
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type Object
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type Function
         */ '_': lodash
            }
        };
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = POSITIVE_INFINITY;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = arrayCopy(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = arrayCopy(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = arrayCopy(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || arrLength < LARGE_ARRAY_SIZE || arrLength == length && takeCount == length) return baseWrapperValue(isRight && isArr ? array.reverse() : array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates a cache object to store key/value pairs.
     *
     * @private
     * @static
     * @name Cache
     * @memberOf _.memoize
     */ function MapCache() {
            this.__data__ = {};
        }
        /**
     * Removes `key` and its value from the cache.
     *
     * @private
     * @name delete
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
     */ function mapDelete(key) {
            return this.has(key) && delete this.__data__[key];
        }
        /**
     * Gets the cached value for `key`.
     *
     * @private
     * @name get
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the cached value.
     */ function mapGet(key) {
            return key == '__proto__' ? undefined : this.__data__[key];
        }
        /**
     * Checks if a cached value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapHas(key) {
            return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
        }
        /**
     * Sets `value` to `key` of the cache.
     *
     * @private
     * @name set
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to cache.
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache object.
     */ function mapSet(key, value) {
            if (key != '__proto__') this.__data__[key] = value;
            return this;
        }
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates a cache object to store unique values.
     *
     * @private
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var length = values ? values.length : 0;
            this.data = {
                'hash': nativeCreate(null),
                'set': new Set
            };
            while(length--)this.push(values[length]);
        }
        /**
     * Checks if `value` is in `cache` mimicking the return signature of
     * `_.indexOf` by returning `0` if the value is found, else `-1`.
     *
     * @private
     * @param {Object} cache The cache to search.
     * @param {*} value The value to search for.
     * @returns {number} Returns `0` if `value` is found, else `-1`.
     */ function cacheIndexOf(cache, value) {
            var data = cache.data, result = typeof value == 'string' || isObject(value) ? data.set.has(value) : data.hash[value];
            return result ? 0 : -1;
        }
        /**
     * Adds `value` to the cache.
     *
     * @private
     * @name push
     * @memberOf SetCache
     * @param {*} value The value to cache.
     */ function cachePush(value) {
            var data = this.data;
            if (typeof value == 'string' || isObject(value)) data.set.add(value);
            else data.hash[value] = true;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates a new array joining `array` with `other`.
     *
     * @private
     * @param {Array} array The array to join.
     * @param {Array} other The other array to join.
     * @returns {Array} Returns the new concatenated array.
     */ function arrayConcat(array, other) {
            var index = -1, length = array.length, othIndex = -1, othLength = other.length, result = Array(length + othLength);
            while(++index < length)result[index] = array[index];
            while(++othIndex < othLength)result[index++] = other[othIndex];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function arrayCopy(source, array) {
            var index = -1, length = source.length;
            array || (array = Array(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * A specialized version of `_.forEach` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */ function arrayEach(array, iteratee) {
            var index = -1, length = array.length;
            while(++index < length){
                if (iteratee(array[index], index, array) === false) break;
            }
            return array;
        }
        /**
     * A specialized version of `_.forEachRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */ function arrayEachRight(array, iteratee) {
            var length = array.length;
            while(length--){
                if (iteratee(array[length], length, array) === false) break;
            }
            return array;
        }
        /**
     * A specialized version of `_.every` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     */ function arrayEvery(array, predicate) {
            var index = -1, length = array.length;
            while(++index < length){
                if (!predicate(array[index], index, array)) return false;
            }
            return true;
        }
        /**
     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
     * with one argument: (value).
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */ function arrayExtremum(array, iteratee, comparator, exValue) {
            var index = -1, length = array.length, computed = exValue, result = computed;
            while(++index < length){
                var value = array[index], current = +iteratee(value);
                if (comparator(current, computed)) {
                    computed = current;
                    result = value;
                }
            }
            return result;
        }
        /**
     * A specialized version of `_.filter` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function arrayFilter(array, predicate) {
            var index = -1, length = array.length, resIndex = -1, result = [];
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) result[++resIndex] = value;
            }
            return result;
        }
        /**
     * A specialized version of `_.map` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function arrayMap(array, iteratee) {
            var index = -1, length = array.length, result = Array(length);
            while(++index < length)result[index] = iteratee(array[index], index, array);
            return result;
        }
        /**
     * Appends the elements of `values` to `array`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to append.
     * @returns {Array} Returns `array`.
     */ function arrayPush(array, values) {
            var index = -1, length = values.length, offset = array.length;
            while(++index < length)array[offset + index] = values[index];
            return array;
        }
        /**
     * A specialized version of `_.reduce` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the first element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */ function arrayReduce(array, iteratee, accumulator, initFromArray) {
            var index = -1, length = array.length;
            if (initFromArray && length) accumulator = array[++index];
            while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
            return accumulator;
        }
        /**
     * A specialized version of `_.reduceRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the last element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */ function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
            var length = array.length;
            if (initFromArray && length) accumulator = array[--length];
            while(length--)accumulator = iteratee(accumulator, array[length], length, array);
            return accumulator;
        }
        /**
     * A specialized version of `_.some` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function arraySome(array, predicate) {
            var index = -1, length = array.length;
            while(++index < length){
                if (predicate(array[index], index, array)) return true;
            }
            return false;
        }
        /**
     * A specialized version of `_.sum` for arrays without support for callback
     * shorthands and `this` binding..
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */ function arraySum(array, iteratee) {
            var length = array.length, result = 0;
            while(length--)result += +iteratee(array[length]) || 0;
            return result;
        }
        /**
     * Used by `_.defaults` to customize its `_.assign` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */ function assignDefaults(objectValue, sourceValue) {
            return objectValue === undefined ? sourceValue : objectValue;
        }
        /**
     * Used by `_.template` to customize its `_.assign` use.
     *
     * **Note:** This function is like `assignDefaults` except that it ignores
     * inherited property values when checking if a property is `undefined`.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @param {string} key The key associated with the object and source values.
     * @param {Object} object The destination object.
     * @returns {*} Returns the value to assign to the destination object.
     */ function assignOwnDefaults(objectValue, sourceValue, key, object) {
            return objectValue === undefined || !hasOwnProperty.call(object, key) ? sourceValue : objectValue;
        }
        /**
     * A specialized version of `_.assign` for customizing assigned values without
     * support for argument juggling, multiple sources, and `this` binding `customizer`
     * functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     */ function assignWith(object, source, customizer) {
            var index = -1, props = keys(source), length = props.length;
            while(++index < length){
                var key = props[index], value = object[key], result = customizer(value, source[key], key, object, source);
                if ((result === result ? result !== value : value === value) || value === undefined && !(key in object)) object[key] = result;
            }
            return object;
        }
        /**
     * The base implementation of `_.assign` without support for argument juggling,
     * multiple sources, and `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return source == null ? object : baseCopy(source, keys(source), object);
        }
        /**
     * The base implementation of `_.at` without support for string collections
     * and individual key arguments.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {number[]|string[]} props The property names or indexes of elements to pick.
     * @returns {Array} Returns the new array of picked elements.
     */ function baseAt(collection, props) {
            var index = -1, isNil = collection == null, isArr = !isNil && isArrayLike(collection), length = isArr ? collection.length : 0, propsLength = props.length, result = Array(propsLength);
            while(++index < propsLength){
                var key = props[index];
                if (isArr) result[index] = isIndex(key, length) ? collection[key] : undefined;
                else result[index] = isNil ? undefined : collection[key];
            }
            return result;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property names to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @returns {Object} Returns `object`.
     */ function baseCopy(source, props, object) {
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                object[key] = source[key];
            }
            return object;
        }
        /**
     * The base implementation of `_.callback` which supports specifying the
     * number of arguments to provide to `func`.
     *
     * @private
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */ function baseCallback(func, thisArg, argCount) {
            var type = typeof func;
            if (type == 'function') return thisArg === undefined ? func : bindCallback(func, thisArg, argCount);
            if (func == null) return identity;
            if (type == 'object') return baseMatches(func);
            return thisArg === undefined ? property(func) : baseMatchesProperty(func, thisArg);
        }
        /**
     * The base implementation of `_.clone` without support for argument juggling
     * and `this` binding `customizer` functions.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The object `value` belongs to.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates clones with source counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
            var result;
            if (customizer) result = object ? customizer(value, key, object) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return arrayCopy(value, result);
            } else {
                var tag = objToString.call(value), isFunc = tag == funcTag;
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = initCloneObject(isFunc ? {} : value);
                    if (!isDeep) return baseAssign(result, value);
                } else return cloneableTags[tag] ? initCloneByTag(value, tag, isDeep) : object ? value : {};
            }
            // Check for circular references and return its corresponding clone.
            stackA || (stackA = []);
            stackB || (stackB = []);
            var length = stackA.length;
            while(length--){
                if (stackA[length] == value) return stackB[length];
            }
            // Add the source value to the stack of traversed objects and associate it with its clone.
            stackA.push(value);
            stackB.push(result);
            // Recursively populate clone (susceptible to call stack limits).
            (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
                result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
            });
            return result;
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} prototype The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(prototype) {
                if (isObject(prototype)) {
                    object.prototype = prototype;
                    var result = new object;
                    object.prototype = undefined;
                }
                return result || {};
            };
        }();
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts an index
     * of where to slice the arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Object} args The arguments provide to `func`.
     * @returns {number} Returns the timer id.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of `_.difference` which accepts a single array
     * of values to exclude.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values) {
            var length = array ? array.length : 0, result = [];
            if (!length) return result;
            var index = -1, indexOf = getIndexOf(), isCommon = indexOf == baseIndexOf, cache = isCommon && values.length >= LARGE_ARRAY_SIZE ? createCache(values) : null, valuesLength = values.length;
            if (cache) {
                indexOf = cacheIndexOf;
                isCommon = false;
                values = cache;
            }
            outer: while(++index < length){
                var value = array[index];
                if (isCommon && value === value) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === value) continue outer;
                    }
                    result.push(value);
                } else if (indexOf(values, value, 0) < 0) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * Gets the extremum value of `collection` invoking `iteratee` for each value
     * in `collection` to generate the criterion by which the value is ranked.
     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(collection, iteratee, comparator, exValue) {
            var computed = exValue, result = computed;
            baseEach(collection, function(value, index, collection) {
                var current = +iteratee(value, index, collection);
                if (comparator(current, computed) || current === exValue && current === result) {
                    computed = current;
                    result = value;
                }
            });
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = start == null ? 0 : +start || 0;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : +end || 0;
            if (end < 0) end += length;
            length = start > end ? 0 : end >>> 0;
            start >>>= 0;
            while(start < length)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
     * without support for callback shorthands and `this` binding, which iterates
     * over `collection` using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function} predicate The function invoked per iteration.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @param {boolean} [retKey] Specify returning the key of the found element
     *  instead of the element itself.
     * @returns {*} Returns the found element or its key, else `undefined`.
     */ function baseFind(collection, predicate, eachFunc, retKey) {
            var result;
            eachFunc(collection, function(value, key, collection) {
                if (predicate(value, key, collection)) {
                    result = retKey ? key : value;
                    return false;
                }
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with added support for restricting
     * flattening and specifying the start index.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, isDeep, isStrict, result) {
            result || (result = []);
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index];
                if (isObjectLike(value) && isArrayLike(value) && (isStrict || isArray(value) || isArguments(value))) {
                    if (isDeep) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, isDeep, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForIn` and `baseForOwn` which iterates
     * over `object` properties returned by `keysFunc` invoking `iteratee` for
     * each property. Iteratee functions may exit iteration early by explicitly
     * returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forIn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForIn(object, iteratee) {
            return baseFor(object, iteratee, keysIn);
        }
        /**
     * The base implementation of `_.forOwn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from those provided.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the new array of filtered property names.
     */ function baseFunctions(object, props) {
            var index = -1, length = props.length, resIndex = -1, result = [];
            while(++index < length){
                var key = props[index];
                if (isFunction(object[key])) result[++resIndex] = key;
            }
            return result;
        }
        /**
     * The base implementation of `get` without support for string paths
     * and default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path of the property to get.
     * @param {string} [pathKey] The key representation of path.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path, pathKey) {
            if (object == null) return;
            if (pathKey !== undefined && pathKey in toObject(object)) path = [
                pathKey
            ];
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[path[index++]];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `_.isEqual` without support for `this` binding
     * `customizer` functions.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
            if (value === other) return true;
            if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
            if (!objIsArr) {
                objTag = objToString.call(object);
                if (objTag == argsTag) objTag = objectTag;
                else if (objTag != objectTag) objIsArr = isTypedArray(object);
            }
            if (!othIsArr) {
                othTag = objToString.call(other);
                if (othTag == argsTag) othTag = objectTag;
                else if (othTag != objectTag) othIsArr = isTypedArray(other);
            }
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && !(objIsArr || objIsObj)) return equalByTag(object, other, objTag);
            if (!isLoose) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
            }
            if (!isSameTag) return false;
            // Assume cyclic values are equal.
            // For more information on detecting circular references see https://es5.github.io/#JO.
            stackA || (stackA = []);
            stackB || (stackB = []);
            var length = stackA.length;
            while(length--){
                if (stackA[length] == object) return stackB[length] == other;
            }
            // Add `object` and `other` to the stack of traversed objects.
            stackA.push(object);
            stackB.push(other);
            var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
            stackA.pop();
            stackB.pop();
            return result;
        }
        /**
     * The base implementation of `_.isMatch` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} matchData The propery names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = toObject(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var result = customizer ? customizer(objValue, srcValue, key) : undefined;
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.map` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which does not clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) {
                var key = matchData[0][0], value = matchData[0][1];
                return function(object) {
                    if (object == null) return false;
                    return object[key] === value && (value !== undefined || key in toObject(object));
                };
            }
            return function(object) {
                return baseIsMatch(object, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to compare.
     * @returns {Function} Returns the new function.
     */ function baseMatchesProperty(path, srcValue) {
            var isArr = isArray(path), isCommon = isKey(path) && isStrictComparable(srcValue), pathKey = path + '';
            path = toPath(path);
            return function(object) {
                if (object == null) return false;
                var key = pathKey;
                object = toObject(object);
                if ((isArr || !isCommon) && !(key in object)) {
                    object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
                    if (object == null) return false;
                    key = last(path);
                    object = toObject(object);
                }
                return object[key] === srcValue ? srcValue !== undefined || key in object : baseIsEqual(srcValue, object[key], undefined, true);
            };
        }
        /**
     * The base implementation of `_.merge` without support for argument juggling,
     * multiple sources, and `this` binding `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {Object} Returns `object`.
     */ function baseMerge(object, source, customizer, stackA, stackB) {
            if (!isObject(object)) return object;
            var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)), props = isSrcArr ? undefined : keys(source);
            arrayEach(props || source, function(srcValue, key) {
                if (props) {
                    key = srcValue;
                    srcValue = source[key];
                }
                if (isObjectLike(srcValue)) {
                    stackA || (stackA = []);
                    stackB || (stackB = []);
                    baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
                } else {
                    var value = object[key], result = customizer ? customizer(value, srcValue, key, object, source) : undefined, isCommon = result === undefined;
                    if (isCommon) result = srcValue;
                    if ((result !== undefined || isSrcArr && !(key in object)) && (isCommon || (result === result ? result !== value : value === value))) object[key] = result;
                }
            });
            return object;
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
            var length = stackA.length, srcValue = source[key];
            while(length--)if (stackA[length] == srcValue) {
                object[key] = stackB[length];
                return;
            }
            var value = object[key], result = customizer ? customizer(value, srcValue, key, object, source) : undefined, isCommon = result === undefined;
            if (isCommon) {
                result = srcValue;
                if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) result = isArray(value) ? value : isArrayLike(value) ? arrayCopy(value) : [];
                else if (isPlainObject(srcValue) || isArguments(srcValue)) result = isArguments(value) ? toPlainObject(value) : isPlainObject(value) ? value : {};
                else isCommon = false;
            }
            // Add the source value to the stack of traversed objects and associate
            // it with its merged value.
            stackA.push(srcValue);
            stackB.push(result);
            if (isCommon) // Recursively merge objects and arrays (susceptible to call stack limits).
            object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
            else if (result === result ? result !== value : value === value) object[key] = result;
        }
        /**
     * The base implementation of `_.property` without support for deep paths.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @returns {Function} Returns the new function.
     */ function baseProperty(key) {
            return function(object) {
                return object == null ? undefined : object[key];
            };
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     */ function basePropertyDeep(path) {
            var pathKey = path + '';
            path = toPath(path);
            return function(object) {
                return baseGet(object, path, pathKey);
            };
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * index arguments and capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0;
            while(length--){
                var index = indexes[length];
                if (index != previous && isIndex(index)) {
                    var previous = index;
                    splice.call(array, index, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for argument juggling
     * and returning floating-point numbers.
     *
     * @private
     * @param {number} min The minimum possible value.
     * @param {number} max The maximum possible value.
     * @returns {number} Returns the random number.
     */ function baseRandom(min, max) {
            return min + nativeFloor(nativeRandom() * (max - min + 1));
        }
        /**
     * The base implementation of `_.reduce` and `_.reduceRight` without support
     * for callback shorthands and `this` binding, which iterates over `collection`
     * using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} accumulator The initial value.
     * @param {boolean} initFromCollection Specify using the first or last element
     *  of `collection` as the initial value.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @returns {*} Returns the accumulated value.
     */ function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
            eachFunc(collection, function(value, index, collection) {
                accumulator = initFromCollection ? (initFromCollection = false, value) : iteratee(accumulator, value, index, collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `setData` without support for hot loop detection.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            start = start == null ? 0 : +start || 0;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : +end || 0;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortBy` which uses `comparer` to define
     * the sort order of `array` and replaces criteria objects with their
     * corresponding values.
     *
     * @private
     * @param {Array} array The array to sort.
     * @param {Function} comparer The function to define sort order.
     * @returns {Array} Returns `array`.
     */ function baseSortBy(array, comparer) {
            var length = array.length;
            array.sort(comparer);
            while(length--)array[length] = array[length].value;
            return array;
        }
        /**
     * The base implementation of `_.sortByOrder` without param guards.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseSortByOrder(collection, iteratees, orders) {
            var callback = getCallback(), index = -1;
            iteratees = arrayMap(iteratees, function(iteratee) {
                return callback(iteratee);
            });
            var result = baseMap(collection, function(value) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.sum` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */ function baseSum(collection, iteratee) {
            var result = 0;
            baseEach(collection, function(value, index, collection) {
                result += +iteratee(value, index, collection) || 0;
            });
            return result;
        }
        /**
     * The base implementation of `_.uniq` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The function invoked per iteration.
     * @returns {Array} Returns the new duplicate-value-free array.
     */ function baseUniq(array, iteratee) {
            var index = -1, indexOf = getIndexOf(), length = array.length, isCommon = indexOf == baseIndexOf, isLarge = isCommon && length >= LARGE_ARRAY_SIZE, seen = isLarge ? createCache() : null, result = [];
            if (seen) {
                indexOf = cacheIndexOf;
                isCommon = false;
            } else {
                isLarge = false;
                seen = iteratee ? [] : result;
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value, index, array) : value;
                if (isCommon && value === value) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (indexOf(seen, computed, 0) < 0) {
                    if (iteratee || isLarge) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.values` and `_.valuesIn` which creates an
     * array of `object` property values corresponding to the property names
     * of `props`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} props The property names to get values for.
     * @returns {Object} Returns the array of property values.
     */ function baseValues(object, props) {
            var index = -1, length = props.length, result = Array(length);
            while(++index < length)result[index] = object[props[index]];
            return result;
        }
        /**
     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
     * and `_.takeWhile` without support for callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to peform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            var index = -1, length = actions.length;
            while(++index < length){
                var action = actions[index];
                result = action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }
            return result;
        }
        /**
     * Performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function binaryIndex(array, value, retHighest) {
            var low = 0, high = array ? array.length : low;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if ((retHighest ? computed <= value : computed < value) && computed !== null) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return binaryIndexBy(array, value, identity, retHighest);
        }
        /**
     * This function is like `binaryIndex` except that it invokes `iteratee` for
     * `value` and each element of `array` to compute their sort ranking. The
     * iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function binaryIndexBy(array, value, iteratee, retHighest) {
            value = iteratee(value);
            var low = 0, high = array ? array.length : 0, valIsNaN = value !== value, valIsNull = value === null, valIsUndef = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), isDef = computed !== undefined, isReflexive = computed === computed;
                if (valIsNaN) var setLow = isReflexive || retHighest;
                else if (valIsNull) setLow = isReflexive && isDef && (retHighest || computed != null);
                else if (valIsUndef) setLow = isReflexive && (retHighest || isDef);
                else if (computed == null) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * A specialized version of `baseCallback` which only supports `this` binding
     * and specifying the number of arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */ function bindCallback(func, thisArg, argCount) {
            if (typeof func != 'function') return identity;
            if (thisArg === undefined) return func;
            switch(argCount){
                case 1:
                    return function(value) {
                        return func.call(thisArg, value);
                    };
                case 3:
                    return function(value, index, collection) {
                        return func.call(thisArg, value, index, collection);
                    };
                case 4:
                    return function(accumulator, value, index, collection) {
                        return func.call(thisArg, accumulator, value, index, collection);
                    };
                case 5:
                    return function(value, other, key, object, source) {
                        return func.call(thisArg, value, other, key, object, source);
                    };
            }
            return function() {
                return func.apply(thisArg, arguments);
            };
        }
        /**
     * Creates a clone of the given array buffer.
     *
     * @private
     * @param {ArrayBuffer} buffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function bufferClone(buffer) {
            var result = new ArrayBuffer(buffer.byteLength), view = new Uint8Array(result);
            view.set(new Uint8Array(buffer));
            return result;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders) {
            var holdersLength = holders.length, argsIndex = -1, argsLength = nativeMax(args.length - holdersLength, 0), leftIndex = -1, leftLength = partials.length, result = Array(leftLength + argsLength);
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)result[holders[argsIndex]] = args[argsIndex];
            while(argsLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders) {
            var holdersIndex = -1, holdersLength = holders.length, argsIndex = -1, argsLength = nativeMax(args.length - holdersLength, 0), rightIndex = -1, rightLength = partials.length, result = Array(argsLength + rightLength);
            while(++argsIndex < argsLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
     *
     * @private
     * @param {Function} setter The function to set keys and values of the accumulator object.
     * @param {Function} [initializer] The function to initialize the accumulator object.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee, thisArg) {
                var result = initializer ? initializer() : {};
                iteratee = getCallback(iteratee, thisArg, 3);
                if (isArray(collection)) {
                    var index = -1, length = collection.length;
                    while(++index < length){
                        var value = collection[index];
                        setter(result, value, iteratee(value, index, collection), collection);
                    }
                } else baseEach(collection, function(value, key, collection) {
                    setter(result, value, iteratee(value, key, collection), collection);
                });
                return result;
            };
        }
        /**
     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return restParam(function(object, sources) {
                var index = -1, length = object == null ? 0 : sources.length, customizer = length > 2 ? sources[length - 2] : undefined, guard = length > 2 ? sources[2] : undefined, thisArg = length > 1 ? sources[length - 1] : undefined;
                if (typeof customizer == 'function') {
                    customizer = bindCallback(customizer, thisArg, 5);
                    length -= 2;
                } else {
                    customizer = typeof thisArg == 'function' ? thisArg : undefined;
                    length -= customizer ? 1 : 0;
                }
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                var length = collection ? getLength(collection) : 0;
                if (!isLength(length)) return eachFunc(collection, iteratee);
                var index = fromRight ? length : -1, iterable = toObject(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var iterable = toObject(object), props = keysFunc(object), length = props.length, index = fromRight ? length : -1;
                while(fromRight ? index-- : ++index < length){
                    var key = props[index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` and invokes it with the `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new bound function.
     */ function createBindWrapper(func, thisArg) {
            var Ctor = createCtorWrapper(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(thisArg, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a `Set` cache object to optimize linear searches of large arrays.
     *
     * @private
     * @param {Array} [values] The values to cache.
     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
     */ function createCache(values) {
            return nativeCreate && Set ? new SetCache(values) : null;
        }
        /**
     * Creates a function that produces compound words out of the words in a
     * given string.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                var index = -1, array = words(deburr(string)), length = array.length, result = '';
                while(++index < length)result = callback(result, array[index], index);
                return result;
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtorWrapper(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors.
                // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a `_.curry` or `_.curryRight` function.
     *
     * @private
     * @param {boolean} flag The curry bit flag.
     * @returns {Function} Returns the new curry function.
     */ function createCurry(flag) {
            function curryFunc(func, arity, guard) {
                if (guard && isIterateeCall(func, arity, guard)) arity = undefined;
                var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
                result.placeholder = curryFunc.placeholder;
                return result;
            }
            return curryFunc;
        }
        /**
     * Creates a `_.defaults` or `_.defaultsDeep` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Function} Returns the new defaults function.
     */ function createDefaults(assigner, customizer) {
            return restParam(function(args) {
                var object = args[0];
                if (object == null) return object;
                args.push(customizer);
                return assigner.apply(undefined, args);
            });
        }
        /**
     * Creates a `_.max` or `_.min` function.
     *
     * @private
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {Function} Returns the new extremum function.
     */ function createExtremum(comparator, exValue) {
            return function(collection, iteratee, thisArg) {
                if (thisArg && isIterateeCall(collection, iteratee, thisArg)) iteratee = undefined;
                iteratee = getCallback(iteratee, thisArg, 3);
                if (iteratee.length == 1) {
                    collection = isArray(collection) ? collection : toIterable(collection);
                    var result = arrayExtremum(collection, iteratee, comparator, exValue);
                    if (!(collection.length && result === exValue)) return result;
                }
                return baseExtremum(collection, iteratee, comparator, exValue);
            };
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */ function createFind(eachFunc, fromRight) {
            return function(collection, predicate, thisArg) {
                predicate = getCallback(predicate, thisArg, 3);
                if (isArray(collection)) {
                    var index = baseFindIndex(collection, predicate, fromRight);
                    return index > -1 ? collection[index] : undefined;
                }
                return baseFind(collection, predicate, eachFunc);
            };
        }
        /**
     * Creates a `_.findIndex` or `_.findLastIndex` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */ function createFindIndex(fromRight) {
            return function(array, predicate, thisArg) {
                if (!(array && array.length)) return -1;
                predicate = getCallback(predicate, thisArg, 3);
                return baseFindIndex(array, predicate, fromRight);
            };
        }
        /**
     * Creates a `_.findKey` or `_.findLastKey` function.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new find function.
     */ function createFindKey(objectFunc) {
            return function(object, predicate, thisArg) {
                predicate = getCallback(predicate, thisArg, 3);
                return baseFind(object, predicate, objectFunc, true);
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return function() {
                var wrapper, length = arguments.length, index = fromRight ? length : -1, leftIndex = 0, funcs = Array(length);
                while(fromRight ? index-- : ++index < length){
                    var func = funcs[leftIndex++] = arguments[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? -1 : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            };
        }
        /**
     * Creates a function for `_.forEach` or `_.forEachRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */ function createForEach(arrayFunc, eachFunc) {
            return function(collection, iteratee, thisArg) {
                return typeof iteratee == 'function' && thisArg === undefined && isArray(collection) ? arrayFunc(collection, iteratee) : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
            };
        }
        /**
     * Creates a function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */ function createForIn(objectFunc) {
            return function(object, iteratee, thisArg) {
                if (typeof iteratee != 'function' || thisArg !== undefined) iteratee = bindCallback(iteratee, thisArg, 3);
                return objectFunc(object, iteratee, keysIn);
            };
        }
        /**
     * Creates a function for `_.forOwn` or `_.forOwnRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */ function createForOwn(objectFunc) {
            return function(object, iteratee, thisArg) {
                if (typeof iteratee != 'function' || thisArg !== undefined) iteratee = bindCallback(iteratee, thisArg, 3);
                return objectFunc(object, iteratee);
            };
        }
        /**
     * Creates a function for `_.mapKeys` or `_.mapValues`.
     *
     * @private
     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
     * @returns {Function} Returns the new map function.
     */ function createObjectMapper(isMapKeys) {
            return function(object, iteratee, thisArg) {
                var result = {};
                iteratee = getCallback(iteratee, thisArg, 3);
                baseForOwn(object, function(value, key, object) {
                    var mapped = iteratee(value, key, object);
                    key = isMapKeys ? mapped : key;
                    value = isMapKeys ? value : mapped;
                    result[key] = value;
                });
                return result;
            };
        }
        /**
     * Creates a function for `_.padLeft` or `_.padRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify padding from the right.
     * @returns {Function} Returns the new pad function.
     */ function createPadDir(fromRight) {
            return function(string, length, chars) {
                string = baseToString(string);
                return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
            };
        }
        /**
     * Creates a `_.partial` or `_.partialRight` function.
     *
     * @private
     * @param {boolean} flag The partial bit flag.
     * @returns {Function} Returns the new partial function.
     */ function createPartial(flag) {
            var partialFunc = restParam(function(func, partials) {
                var holders = replaceHolders(partials, partialFunc.placeholder);
                return createWrapper(func, flag, undefined, partials, holders);
            });
            return partialFunc;
        }
        /**
     * Creates a function for `_.reduce` or `_.reduceRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */ function createReduce(arrayFunc, eachFunc) {
            return function(collection, iteratee, accumulator, thisArg) {
                var initFromArray = arguments.length < 3;
                return typeof iteratee == 'function' && thisArg === undefined && isArray(collection) ? arrayFunc(collection, iteratee, accumulator, initFromArray) : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
            };
        }
        /**
     * Creates a function that wraps `func` and invokes it with optional `this`
     * binding of, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & ARY_FLAG, isBind = bitmask & BIND_FLAG, isBindKey = bitmask & BIND_KEY_FLAG, isCurry = bitmask & CURRY_FLAG, isCurryBound = bitmask & CURRY_BOUND_FLAG, isCurryRight = bitmask & CURRY_RIGHT_FLAG, Ctor = isBindKey ? undefined : createCtorWrapper(func);
            function wrapper() {
                // Avoid `arguments` object use disqualifying optimizations by
                // converting it to an array before providing it to other functions.
                var length = arguments.length, index = length, args = Array(length);
                while(index--)args[index] = arguments[index];
                if (partials) args = composeArgs(args, partials, holders);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight);
                if (isCurry || isCurryRight) {
                    var placeholder = wrapper.placeholder, argsHolders = replaceHolders(args, placeholder);
                    length -= argsHolders.length;
                    if (length < arity) {
                        var newArgPos = argPos ? arrayCopy(argPos) : undefined, newArity = nativeMax(arity - length, 0), newsHolders = isCurry ? argsHolders : undefined, newHoldersRight = isCurry ? undefined : argsHolders, newPartials = isCurry ? args : undefined, newPartialsRight = isCurry ? undefined : args;
                        bitmask |= isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG;
                        bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
                        if (!isCurryBound) bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
                        var newData = [
                            func,
                            bitmask,
                            thisArg,
                            newPartials,
                            newsHolders,
                            newPartialsRight,
                            newHoldersRight,
                            newArgPos,
                            ary,
                            newArity
                        ], result = createHybridWrapper.apply(undefined, newData);
                        if (isLaziable(func)) setData(result, newData);
                        result.placeholder = placeholder;
                        return result;
                    }
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                if (argPos) args = reorder(args, argPos);
                if (isAry && ary < args.length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtorWrapper(func);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates the padding required for `string` based on the given `length`.
     * The `chars` string is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {string} string The string to create padding for.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the pad for `string`.
     */ function createPadding(string, length, chars) {
            var strLength = string.length;
            length = +length;
            if (strLength >= length || !nativeIsFinite(length)) return '';
            var padLength = length - strLength;
            chars = chars == null ? ' ' : chars + '';
            return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
        }
        /**
     * Creates a function that wraps `func` and invokes it with the optional `this`
     * binding of `thisArg` and the `partials` prepended to those provided to
     * the wrapper.
     *
     * @private
     * @param {Function} func The function to partially apply arguments to.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to the new function.
     * @returns {Function} Returns the new bound function.
     */ function createPartialWrapper(func, bitmask, thisArg, partials) {
            var isBind = bitmask & BIND_FLAG, Ctor = createCtorWrapper(func);
            function wrapper() {
                // Avoid `arguments` object use disqualifying optimizations by
                // converting it to an array before providing it `func`.
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength);
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                precision = precision === undefined ? 0 : +precision || 0;
                if (precision) {
                    precision = pow(10, precision);
                    return func(number * precision) / precision;
                }
                return func(number);
            };
        }
        /**
     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
     *
     * @private
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {Function} Returns the new index function.
     */ function createSortedIndex(retHighest) {
            return function(array, value, iteratee, thisArg) {
                var callback = getCallback(iteratee);
                return iteratee == null && callback === baseCallback ? binaryIndex(array, value, retHighest) : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags.
     *  The bitmask may be composed of the following flags:
     *     1 - `_.bind`
     *     2 - `_.bindKey`
     *     4 - `_.curry` or `_.curryRight` of a bound function
     *     8 - `_.curry`
     *    16 - `_.curryRight`
     *    32 - `_.partial`
     *    64 - `_.partialRight`
     *   128 - `_.rearg`
     *   256 - `_.ary`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            length -= holders ? holders.length : 0;
            if (bitmask & PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func), newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) {
                mergeData(newData, data);
                bitmask = newData[1];
                arity = newData[9];
            }
            newData[9] = arity == null ? isBindKey ? 0 : func.length : nativeMax(arity - length, 0) || 0;
            if (bitmask == BIND_FLAG) var result = createBindWrapper(newData[0], newData[2]);
            else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) result = createPartialWrapper.apply(undefined, newData);
            else result = createHybridWrapper.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setter(result, newData);
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing arrays.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
            var index = -1, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isLoose && othLength > arrLength)) return false;
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index], result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
                if (result !== undefined) {
                    if (result) continue;
                    return false;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (isLoose) {
                    if (!arraySome(other, function(othValue) {
                        return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
                    })) return false;
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) return false;
            }
            return true;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag) {
            switch(tag){
                case boolTag:
                case dateTag:
                    // Coerce dates and booleans to numbers, dates to milliseconds and booleans
                    // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
                    return +object == +other;
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case numberTag:
                    // Treat `NaN` vs. `NaN` as equal.
                    return object != +object ? other != +other : object == +other;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings primitives and string
                    // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
                    return object == other + '';
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
            var objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
            if (objLength != othLength && !isLoose) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            var skipCtor = isLoose;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key], result = customizer ? customizer(isLoose ? othValue : objValue, isLoose ? objValue : othValue, key) : undefined;
                // Recursively compare objects (susceptible to call stack limits).
                if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) return false;
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (!skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) return false;
            }
            return true;
        }
        /**
     * Gets the appropriate "callback" function. If the `_.callback` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseCallback` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function} Returns the chosen function or its result.
     */ function getCallback(func, thisArg, argCount) {
            var result = lodash.callback || callback;
            result = result === callback ? baseCallback : result;
            return argCount ? result(func, thisArg, argCount) : result;
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name, array = realNames[result], length = array ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseIndexOf` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function|number} Returns the chosen function or its result.
     */ function getIndexOf(collection, target, fromIndex) {
            var result = lodash.indexOf || indexOf;
            result = result === indexOf ? baseIndexOf : result;
            return collection ? result(collection, target, fromIndex) : result;
        }
        /**
     * Gets the "length" property value of `object`.
     *
     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
     * that affects Safari on at least iOS 8.1-8.3 ARM64.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {*} Returns the "length" value.
     */ var getLength = baseProperty('length');
        /**
     * Gets the propery names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = pairs(object), length = result.length;
            while(length--)result[length][2] = isStrictComparable(result[length][1]);
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = object == null ? undefined : object[key];
            return isNative(value) ? value : undefined;
        }
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add array properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            var Ctor = object.constructor;
            if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) Ctor = Object;
            return new Ctor;
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return bufferClone(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    var buffer = object.buffer;
                    return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    var result = new Ctor(object.source, reFlags.exec(object));
                    result.lastIndex = object.lastIndex;
            }
            return result;
        }
        /**
     * Invokes the method at `path` on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function invokePath(object, path, args) {
            if (object != null && !isKey(path, object)) {
                path = toPath(path);
                object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
                path = last(path);
            }
            var func = object == null ? object : object[path];
            return func == null ? undefined : func.apply(object, args);
        }
        /**
     * Checks if `value` is array-like.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     */ function isArrayLike(value) {
            return value != null && isLength(getLength(value));
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            value = typeof value == 'number' || reIsUint.test(value) ? +value : -1;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the provided arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
                var other = object[index];
                return value === value ? value === other : other !== other;
            }
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            var type = typeof value;
            if (type == 'string' && reIsPlainProp.test(value) || type == 'number') return true;
            if (isArray(value)) return false;
            var result = !reIsDeepProp.test(value);
            return result || object != null && value in toObject(object);
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func);
            if (!(funcName in LazyWrapper.prototype)) return false;
            var other = lodash[funcName];
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers required to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
     * augment function arguments, making the order in which they are executed important,
     * preventing the merging of metadata. However, we make an exception for a safe
     * common case where curried functions have `_.ary` and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < ARY_FLAG;
            var isCombo = srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG || srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8] || srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & BIND_FLAG ? 0 : CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = arrayCopy(value);
            // Use source `ary` if it's smaller.
            if (srcBitmask & ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */ function mergeDefaults(objectValue, sourceValue) {
            return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
        }
        /**
     * A specialized version of `_.pick` which picks `object` properties specified
     * by `props`.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} props The property names to pick.
     * @returns {Object} Returns the new object.
     */ function pickByArray(object, props) {
            object = toObject(object);
            var index = -1, length = props.length, result = {};
            while(++index < length){
                var key = props[index];
                if (key in object) result[key] = object[key];
            }
            return result;
        }
        /**
     * A specialized version of `_.pick` which picks `object` properties `predicate`
     * returns truthy for.
     *
     * @private
     * @param {Object} object The source object.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Object} Returns the new object.
     */ function pickByCallback(object, predicate) {
            var result = {};
            baseForIn(object, function(value, key, object) {
                if (predicate(value, key, object)) result[key] = value;
            });
            return result;
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = arrayCopy(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity function
     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = function() {
            var count = 0, lastCalled = 0;
            return function(key, value) {
                var stamp = now(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return key;
                } else count = 0;
                return baseSetData(key, value);
            };
        }();
        /**
     * A fallback implementation of `Object.keys` which creates an array of the
     * own enumerable property names of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function shimKeys(object) {
            var props = keysIn(object), propsLength = props.length, length = propsLength && object.length;
            var allowIndexes = !!length && isLength(length) && (isArray(object) || isArguments(object));
            var index = -1, result = [];
            while(++index < propsLength){
                var key = props[index];
                if (allowIndexes && isIndex(key, length) || hasOwnProperty.call(object, key)) result.push(key);
            }
            return result;
        }
        /**
     * Converts `value` to an array-like object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array|Object} Returns the array-like object.
     */ function toIterable(value) {
            if (value == null) return [];
            if (!isArrayLike(value)) return values(value);
            return isObject(value) ? value : Object(value);
        }
        /**
     * Converts `value` to an object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Object} Returns the object.
     */ function toObject(value) {
            return isObject(value) ? value : Object(value);
        }
        /**
     * Converts `value` to property path array if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array} Returns the property path array.
     */ function toPath(value) {
            if (isArray(value)) return value;
            var result = [];
            baseToString(value).replace(rePropName, function(match, number, quote, string) {
                result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            return wrapper instanceof LazyWrapper ? wrapper.clone() : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `collection` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new array containing chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size == null) size = 1;
            else size = nativeMax(nativeFloor(size) || 1, 1);
            var index = 0, length = array ? array.length : 0, resIndex = -1, result = Array(nativeCeil(length / size));
            while(index < length)result[++resIndex] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array ? array.length : 0, resIndex = -1, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[++resIndex] = value;
            }
            return result;
        }
        /**
     * Creates an array of unique `array` values not included in the other
     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The arrays of values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.difference([1, 2, 3], [4, 2]);
     * // => [1, 3]
     */ var difference = restParam(function(array, values) {
            return isObjectLike(array) && isArrayLike(array) ? baseDifference(array, baseFlatten(values, false, true)) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array ? array.length : 0;
            if (!length) return [];
            if (guard ? isIterateeCall(array, n, guard) : n == null) n = 1;
            return baseSlice(array, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array ? array.length : 0;
            if (!length) return [];
            if (guard ? isIterateeCall(array, n, guard) : n == null) n = 1;
            n = length - (+n || 0);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that match the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [1]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
     * // => ['barney']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate, thisArg) {
            return array && array.length ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropWhile(users, 'active', false), 'user');
     * // => ['pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate, thisArg) {
            return array && array.length ? baseWhile(array, getCallback(predicate, thisArg, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8], '*', 1, 2);
     * // => [4, '*', 8]
     */ function fill(array, value, start, end) {
            var length = array ? array.length : 0;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(chr) {
     *   return chr.user == 'barney';
     * });
     * // => 0
     *
     * // using the `_.matches` callback shorthand
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findIndex(users, 'active', false);
     * // => 0
     *
     * // using the `_.property` callback shorthand
     * _.findIndex(users, 'active');
     * // => 2
     */ var findIndex = createFindIndex();
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(chr) {
     *   return chr.user == 'pebbles';
     * });
     * // => 2
     *
     * // using the `_.matches` callback shorthand
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastIndex(users, 'active', false);
     * // => 2
     *
     * // using the `_.property` callback shorthand
     * _.findLastIndex(users, 'active');
     * // => 0
     */ var findLastIndex = createFindIndex(true);
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias head
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.first([1, 2, 3]);
     * // => 1
     *
     * _.first([]);
     * // => undefined
     */ function first(array) {
            return array ? array[0] : undefined;
        }
        /**
     * Flattens a nested array. If `isDeep` is `true` the array is recursively
     * flattened, otherwise it is only flattened a single level.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, 3, [4]]]);
     * // => [1, 2, 3, [4]]
     *
     * // using `isDeep`
     * _.flatten([1, [2, 3, [4]]], true);
     * // => [1, 2, 3, 4]
     */ function flatten(array, isDeep, guard) {
            var length = array ? array.length : 0;
            if (guard && isIterateeCall(array, isDeep, guard)) isDeep = false;
            return length ? baseFlatten(array, isDeep) : [];
        }
        /**
     * Recursively flattens a nested array.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to recursively flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, 3, [4]]]);
     * // => [1, 2, 3, 4]
     */ function flattenDeep(array) {
            var length = array ? array.length : 0;
            return length ? baseFlatten(array, true) : [];
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
     * performs a faster binary search.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
     *  to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // using `fromIndex`
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     *
     * // performing a binary search
     * _.indexOf([1, 1, 2, 2], 2, true);
     * // => 2
     */ function indexOf(array, value, fromIndex) {
            var length = array ? array.length : 0;
            if (!length) return -1;
            if (typeof fromIndex == 'number') fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
            else if (fromIndex) {
                var index = binaryIndex(array, value);
                if (index < length && (value === value ? value === array[index] : array[index] !== array[index])) return index;
                return -1;
            }
            return baseIndexOf(array, value, fromIndex || 0);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            return dropRight(array, 1);
        }
        /**
     * Creates an array of unique values that are included in all of the provided
     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of shared values.
     * @example
     * _.intersection([1, 2], [4, 2], [2, 1]);
     * // => [2]
     */ var intersection = restParam(function(arrays) {
            var othLength = arrays.length, othIndex = othLength, caches = Array(length), indexOf = getIndexOf(), isCommon = indexOf == baseIndexOf, result = [];
            while(othIndex--){
                var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
                caches[othIndex] = isCommon && value.length >= 120 ? createCache(othIndex && value) : null;
            }
            var array = arrays[0], index = -1, length = array ? array.length : 0, seen = caches[0];
            outer: while(++index < length){
                value = array[index];
                if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
                    var othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) continue outer;
                    }
                    if (seen) seen.push(value);
                    result.push(value);
                }
            }
            return result;
        });
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array ? array.length : 0;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
     *  or `true` to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // using `fromIndex`
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     *
     * // performing a binary search
     * _.lastIndexOf([1, 1, 2, 2], 2, true);
     * // => 3
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array ? array.length : 0;
            if (!length) return -1;
            var index = length;
            if (typeof fromIndex == 'number') index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
            else if (fromIndex) {
                index = binaryIndex(array, value, true) - 1;
                var other = array[index];
                if (value === value ? value === other : other !== other) return index;
                return -1;
            }
            if (value !== value) return indexOfNaN(array, index, true);
            while(index--){
                if (array[index] === value) return index;
            }
            return -1;
        }
        /**
     * Removes all provided values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3, 1, 2, 3];
     *
     * _.pull(array, 2, 3);
     * console.log(array);
     * // => [1, 1]
     */ function pull() {
            var args = arguments, array = args[0];
            if (!(array && array.length)) return array;
            var index = 0, indexOf = getIndexOf(), length = args.length;
            while(++index < length){
                var fromIndex = 0, value = args[index];
                while((fromIndex = indexOf(array, value, fromIndex)) > -1)splice.call(array, fromIndex, 1);
            }
            return array;
        }
        /**
     * Removes elements from `array` corresponding to the given indexes and returns
     * an array of the removed elements. Indexes may be specified as an array of
     * indexes or as individual arguments.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [5, 10, 15, 20];
     * var evens = _.pullAt(array, 1, 3);
     *
     * console.log(array);
     * // => [5, 15]
     *
     * console.log(evens);
     * // => [10, 20]
     */ var pullAt = restParam(function(array, indexes) {
            indexes = baseFlatten(indexes);
            var result = baseAt(array, indexes);
            basePullAt(array, indexes.sort(baseCompareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate, thisArg) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getCallback(predicate, thisArg, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias tail
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.rest([1, 2, 3]);
     * // => [2, 3]
     */ function rest(array) {
            return drop(array, 1);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of `Array#slice` to support node
     * lists in IE < 9 and to ensure dense arrays are returned.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array ? array.length : 0;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value` should
     * be inserted into `array` in order to maintain its sort order. If an iteratee
     * function is provided it is invoked for `value` and each element of `array`
     * to compute their sort ranking. The iteratee is bound to `thisArg` and
     * invoked with one argument; (value).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     *
     * _.sortedIndex([4, 4, 5, 5], 5);
     * // => 2
     *
     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
     *
     * // using an iteratee function
     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
     *   return this.data[word];
     * }, dict);
     * // => 1
     *
     * // using the `_.property` callback shorthand
     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
     * // => 1
     */ var sortedIndex = createSortedIndex();
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 4, 5, 5], 5);
     * // => 4
     */ var sortedLastIndex = createSortedIndex(true);
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            var length = array ? array.length : 0;
            if (!length) return [];
            if (guard ? isIterateeCall(array, n, guard) : n == null) n = 1;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array ? array.length : 0;
            if (!length) return [];
            if (guard ? isIterateeCall(array, n, guard) : n == null) n = 1;
            n = length - (+n || 0);
            return baseSlice(array, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
     * and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [2, 3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
     * // => []
     */ function takeRightWhile(array, predicate, thisArg) {
            return array && array.length ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [1, 2]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false},
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeWhile(users, 'active', false), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeWhile(users, 'active'), 'user');
     * // => []
     */ function takeWhile(array, predicate, thisArg) {
            return array && array.length ? baseWhile(array, getCallback(predicate, thisArg, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all of the provided arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([1, 2], [4, 2], [2, 1]);
     * // => [1, 2, 4]
     */ var union = restParam(function(arrays) {
            return baseUniq(baseFlatten(arrays, false, true));
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurence of each element
     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
     * for sorted arrays. If an iteratee function is provided it is invoked for
     * each element in the array to generate the criterion by which uniqueness
     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, array).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias unique
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {boolean} [isSorted] Specify the array is sorted.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new duplicate-value-free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     *
     * // using `isSorted`
     * _.uniq([1, 1, 2], true);
     * // => [1, 2]
     *
     * // using an iteratee function
     * _.uniq([1, 2.5, 1.5, 2], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => [1, 2.5]
     *
     * // using the `_.property` callback shorthand
     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniq(array, isSorted, iteratee, thisArg) {
            var length = array ? array.length : 0;
            if (!length) return [];
            if (isSorted != null && typeof isSorted != 'boolean') {
                thisArg = iteratee;
                iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
                isSorted = false;
            }
            var callback = getCallback();
            if (!(iteratee == null && callback === baseCallback)) iteratee = callback(iteratee, thisArg, 3);
            return isSorted && getIndexOf() == baseIndexOf ? sortedUniq(array, iteratee) : baseUniq(array, iteratee);
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     *
     * _.unzip(zipped);
     * // => [['fred', 'barney'], [30, 40], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var index = -1, length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLike(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            var result = Array(length);
            while(++index < length)result[index] = arrayMap(array, baseProperty(index));
            return result;
        }
        /**
     * This method is like `_.unzip` except that it accepts an iteratee to specify
     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee] The function to combine regrouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee, thisArg) {
            var length = array ? array.length : 0;
            if (!length) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            iteratee = bindCallback(iteratee, thisArg, 4);
            return arrayMap(result, function(group) {
                return arrayReduce(group, iteratee, undefined, true);
            });
        }
        /**
     * Creates an array excluding all provided values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to filter.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.without([1, 2, 1, 3], 1, 2);
     * // => [3]
     */ var without = restParam(function(array, values) {
            return isArrayLike(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the provided arrays.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of values.
     * @example
     *
     * _.xor([1, 2], [4, 2]);
     * // => [1, 4]
     */ function xor() {
            var index = -1, length = arguments.length;
            while(++index < length){
                var array = arguments[index];
                if (isArrayLike(array)) var result = result ? arrayPush(baseDifference(result, array), baseDifference(array, result)) : array;
            }
            return result ? baseUniq(result) : [];
        }
        /**
     * Creates an array of grouped elements, the first of which contains the first
     * elements of the given arrays, the second of which contains the second elements
     * of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     */ var zip = restParam(unzip);
        /**
     * The inverse of `_.pairs`; this method returns an object composed from arrays
     * of property names and values. Provide either a single two dimensional array,
     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
     * and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @alias object
     * @category Array
     * @param {Array} props The property names.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject([['fred', 30], ['barney', 40]]);
     * // => { 'fred': 30, 'barney': 40 }
     *
     * _.zipObject(['fred', 'barney'], [30, 40]);
     * // => { 'fred': 30, 'barney': 40 }
     */ function zipObject(props, values) {
            var index = -1, length = props ? props.length : 0, result = {};
            if (length && !values && !isArray(props[0])) values = [];
            while(++index < length){
                var key = props[index];
                if (values) result[key] = values[index];
                else if (key) result[key[0]] = key[1];
            }
            return result;
        }
        /**
     * This method is like `_.zip` except that it accepts an iteratee to specify
     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee] The function to combine grouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
     * // => [111, 222]
     */ var zipWith = restParam(function(arrays) {
            var length = arrays.length, iteratee = length > 2 ? arrays[length - 2] : undefined, thisArg = length > 1 ? arrays[length - 1] : undefined;
            if (length > 2 && typeof iteratee == 'function') length -= 2;
            else {
                iteratee = length > 1 && typeof thisArg == 'function' ? (--length, thisArg) : undefined;
                thisArg = undefined;
            }
            arrays.length = length;
            return unzipWith(arrays, iteratee, thisArg);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object that wraps `value` with explicit method
     * chaining enabled.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _.chain(users)
     *   .sortBy('age')
     *   .map(function(chr) {
     *     return chr.user + ' is ' + chr.age;
     *   })
     *   .first()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor is
     * bound to `thisArg` and invoked with one argument; (value). The purpose of
     * this method is to "tap into" a method chain in order to perform operations
     * on intermediate results within the chain.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor, thisArg) {
            interceptor.call(thisArg, value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor, thisArg) {
            return interceptor.call(thisArg, value);
        }
        /**
     * Enables explicit method chaining on the wrapper object.
     *
     * @name chain
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // without explicit chaining
     * _(users).first();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // with explicit chaining
     * _(users).chain()
     *   .first()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chained sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Creates a new array joining a wrapped array with any additional arrays
     * and/or values.
     *
     * @name concat
     * @memberOf _
     * @category Chain
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var wrapped = _(array).concat(2, [3], [[4]]);
     *
     * console.log(wrapped.value());
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ var wrapperConcat = restParam(function(values) {
            values = baseFlatten(values);
            return this.thru(function(array) {
                return arrayConcat(isArray(array) ? array : [
                    toObject(array)
                ], values);
            });
        });
        /**
     * Creates a clone of the chained sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).map(function(value) {
     *   return Math.pow(value, 2);
     * });
     *
     * var other = [3, 4];
     * var otherWrapped = wrapped.plant(other);
     *
     * otherWrapped.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * Reverses the wrapped array so the first element becomes the last, the
     * second element becomes the second to last, and so on.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            var interceptor = function(value) {
                return wrapped && wrapped.__dir__ < 0 ? value : value.reverse();
            };
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        interceptor
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(interceptor);
        }
        /**
     * Produces the result of coercing the unwrapped value to a string.
     *
     * @name toString
     * @memberOf _
     * @category Chain
     * @returns {string} Returns the coerced string value.
     * @example
     *
     * _([1, 2, 3]).toString();
     * // => '1,2,3'
     */ function wrapperToString() {
            return this.value() + '';
        }
        /**
     * Executes the chained sequence to extract the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @alias run, toJSON, valueOf
     * @category Chain
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements corresponding to the given keys, or indexes,
     * of `collection`. Keys may be specified as individual arguments or as arrays
     * of keys.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(number|number[]|string|string[])} [props] The property names
     *  or indexes of elements to pick, specified individually or in arrays.
     * @returns {Array} Returns the new array of picked elements.
     * @example
     *
     * _.at(['a', 'b', 'c'], [0, 2]);
     * // => ['a', 'c']
     *
     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
     * // => ['barney', 'pebbles']
     */ var at = restParam(function(collection, props) {
            return baseAt(collection, baseFlatten(props));
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the number of times the key was returned by `iteratee`.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            hasOwnProperty.call(result, key) ? ++result[key] : result[key] = 1;
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * The predicate is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias all
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'active': false },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.every(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, thisArg) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (thisArg && isIterateeCall(collection, predicate, thisArg)) predicate = undefined;
            if (typeof predicate != 'function' || thisArg !== undefined) predicate = getCallback(predicate, thisArg, 3);
            return func(collection, predicate);
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias select
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.filter([4, 5, 6], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [4, 6]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.filter(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.filter(users, 'active'), 'user');
     * // => ['barney']
     */ function filter(collection, predicate, thisArg) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            predicate = getCallback(predicate, thisArg, 3);
            return func(collection, predicate);
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias detect
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.result(_.find(users, function(chr) {
     *   return chr.age < 40;
     * }), 'user');
     * // => 'barney'
     *
     * // using the `_.matches` callback shorthand
     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.result(_.find(users, 'active', false), 'user');
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.result(_.find(users, 'active'), 'user');
     * // => 'barney'
     */ var find = createFind(baseEach);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(baseEachRight, true);
        /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning the first element that has equivalent property
     * values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
     * // => 'barney'
     *
     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
     * // => 'fred'
     */ function findWhere(collection, source) {
            return find(collection, baseMatches(source));
        }
        /**
     * Iterates over elements of `collection` invoking `iteratee` for each element.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection). Iteratee functions may exit iteration early
     * by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length" property
     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
     * may be used for object iteration.
     *
     * @static
     * @memberOf _
     * @alias each
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEach(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from left to right and returns the array
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
     *   console.log(n, key);
     * });
     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
     */ var forEach = createForEach(arrayEach, baseEach);
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias eachRight
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEachRight(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from right to left and returns the array
     */ var forEachRight = createForEach(arrayEachRight, baseEachRight);
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is an array of the elements responsible for generating the key.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * // using the `_.property` callback shorthand
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else result[key] = [
                value
            ];
        });
        /**
     * Checks if `value` is in `collection` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @alias contains, include
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {*} target The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
     * // => true
     *
     * _.includes('pebbles', 'eb');
     * // => true
     */ function includes(collection, target, fromIndex, guard) {
            var length = collection ? getLength(collection) : 0;
            if (!isLength(length)) {
                collection = values(collection);
                length = collection.length;
            }
            if (typeof fromIndex != 'number' || guard && isIterateeCall(target, fromIndex, guard)) fromIndex = 0;
            else fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex || 0;
            return typeof collection == 'string' || !isArray(collection) && isString(collection) ? fromIndex <= length && collection.indexOf(target, fromIndex) > -1 : !!length && getIndexOf(collection, target, fromIndex) > -1;
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the last element responsible for generating the key. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var keyData = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.indexBy(keyData, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return String.fromCharCode(object.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return this.fromCharCode(object.code);
     * }, String);
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     */ var indexBy = createAggregator(function(result, value, key) {
            result[key] = value;
        });
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `methodName` is a function it is
     * invoked for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invoke([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invoke = restParam(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', isProp = isKey(path), result = isArrayLike(collection) ? Array(collection.length) : [];
            baseEach(collection, function(value) {
                var func = isFunc ? path : isProp && value != null ? value[path] : undefined;
                result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
            });
            return result;
        });
        /**
     * Creates an array of values by running each element in `collection` through
     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
     * `sum`, `uniq`, and `words`
     *
     * @static
     * @memberOf _
     * @alias collect
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function timesThree(n) {
     *   return n * 3;
     * }
     *
     * _.map([1, 2], timesThree);
     * // => [3, 6]
     *
     * _.map({ 'a': 1, 'b': 2 }, timesThree);
     * // => [3, 6] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee, thisArg) {
            var func = isArray(collection) ? arrayMap : baseMap;
            iteratee = getCallback(iteratee, thisArg, 3);
            return func(collection, iteratee);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, while the second of which
     * contains elements `predicate` returns falsey for. The predicate is bound
     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * _.partition([1, 2, 3], function(n) {
     *   return n % 2;
     * });
     * // => [[1, 3], [2]]
     *
     * _.partition([1.2, 2.3, 3.4], function(n) {
     *   return this.floor(n) % 2;
     * }, Math);
     * // => [[1.2, 3.4], [2.3]]
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * var mapper = function(array) {
     *   return _.pluck(array, 'user');
     * };
     *
     * // using the `_.matches` callback shorthand
     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
     * // => [['pebbles'], ['barney', 'fred']]
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.map(_.partition(users, 'active', false), mapper);
     * // => [['barney', 'pebbles'], ['fred']]
     *
     * // using the `_.property` callback shorthand
     * _.map(_.partition(users, 'active'), mapper);
     * // => [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Gets the property value of `path` from all elements in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|string} path The path of the property to pluck.
     * @returns {Array} Returns the property values.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.pluck(users, 'user');
     * // => ['barney', 'fred']
     *
     * var userIndex = _.indexBy(users, 'user');
     * _.pluck(userIndex, 'age');
     * // => [36, 40] (iteration order is not guaranteed)
     */ function pluck(collection, path) {
            return map(collection, property(path));
        }
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` through `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not provided the first element of `collection` is used as the initial
     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
     * and `sortByOrder`
     *
     * @static
     * @memberOf _
     * @alias foldl, inject
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.reduce([1, 2], function(total, n) {
     *   return total + n;
     * });
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     *   return result;
     * }, {});
     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
     */ var reduce = createReduce(arrayReduce, baseEach);
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias foldr
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ var reduceRight = createReduce(arrayReduceRight, baseEachRight);
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.reject([1, 2, 3, 4], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [1, 3]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.reject(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.reject(users, 'active'), 'user');
     * // => ['barney']
     */ function reject(collection, predicate, thisArg) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            predicate = getCallback(predicate, thisArg, 3);
            return func(collection, function(value, index, collection) {
                return !predicate(value, index, collection);
            });
        }
        /**
     * Gets a random element or `n` random elements from a collection.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to sample.
     * @param {number} [n] The number of elements to sample.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {*} Returns the random sample(s).
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     *
     * _.sample([1, 2, 3, 4], 2);
     * // => [3, 1]
     */ function sample(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n == null) {
                collection = toIterable(collection);
                var length = collection.length;
                return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
            }
            var index = -1, result = toArray(collection), length = result.length, lastIndex = length - 1;
            n = nativeMin(n < 0 ? 0 : +n || 0, length);
            while(++index < n){
                var rand = baseRandom(index, lastIndex), value = result[rand];
                result[rand] = result[index];
                result[index] = value;
            }
            result.length = n;
            return result;
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            return sample(collection, POSITIVE_INFINITY);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable properties for objects.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the size of `collection`.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            var length = collection ? getLength(collection) : 0;
            return isLength(length) ? length : keys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * The function returns as soon as it finds a passing value and does not iterate
     * over the entire collection. The predicate is bound to `thisArg` and invoked
     * with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias any
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.some(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, thisArg) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (thisArg && isIterateeCall(collection, predicate, thisArg)) predicate = undefined;
            if (typeof predicate != 'function' || thisArg !== undefined) predicate = getCallback(predicate, thisArg, 3);
            return func(collection, predicate);
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection through `iteratee`. This method performs
     * a stable sort, that is, it preserves the original sort order of equal elements.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return Math.sin(n);
     * });
     * // => [3, 1, 2]
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return this.sin(n);
     * }, Math);
     * // => [3, 1, 2]
     *
     * var users = [
     *   { 'user': 'fred' },
     *   { 'user': 'pebbles' },
     *   { 'user': 'barney' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.sortBy(users, 'user'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */ function sortBy(collection, iteratee, thisArg) {
            if (collection == null) return [];
            if (thisArg && isIterateeCall(collection, iteratee, thisArg)) iteratee = undefined;
            var index = -1;
            iteratee = getCallback(iteratee, thisArg, 3);
            var result = baseMap(collection, function(value, key, collection) {
                return {
                    'criteria': iteratee(value, key, collection),
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, compareAscending);
        }
        /**
     * This method is like `_.sortBy` except that it can sort by multiple iteratees
     * or property names.
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
     *  The iteratees to sort by, specified as individual values or arrays of values.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
     *
     * _.map(_.sortByAll(users, 'user', function(chr) {
     *   return Math.floor(chr.age / 10);
     * }), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */ var sortByAll = restParam(function(collection, iteratees) {
            if (collection == null) return [];
            var guard = iteratees[2];
            if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) iteratees.length = 1;
            return baseSortByOrder(collection, baseFlatten(iteratees), []);
        });
        /**
     * This method is like `_.sortByAll` except that it allows specifying the
     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
     * values are sorted in ascending order. Otherwise, a value is sorted in
     * ascending order if its corresponding order is "asc", and descending if "desc".
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // sort by `user` in ascending order and by `age` in descending order
     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */ function sortByOrder(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (guard && isIterateeCall(iteratees, orders, guard)) orders = undefined;
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseSortByOrder(collection, iteratees, orders);
        }
        /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning an array of all elements that have equivalent
     * property values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
     * ];
     *
     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
     * // => ['barney']
     *
     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
     * // => ['fred']
     */ function where(collection, source) {
            return filter(collection, baseMatches(source));
        }
        /*------------------------------------------------------------------------*/ /**
     * Gets the number of milliseconds that have elapsed since the Unix epoch
     * (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @category Date
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => logs the number of milliseconds it took for the deferred function to be invoked
     */ var now = nativeNow || function() {
            return new Date().getTime();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it is called `n` or more times.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => logs 'done saving!' after the two async saves have completed
     */ function after(n, func) {
            if (typeof func != 'function') {
                if (typeof n == 'function') {
                    var temp = n;
                    n = func;
                    func = temp;
                } else throw new TypeError(FUNC_ERROR_TEXT);
            }
            n = nativeIsFinite(n = +n) ? n : 0;
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that accepts up to `n` arguments ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            if (guard && isIterateeCall(func, n, guard)) n = undefined;
            n = func && n == null ? func.length : nativeMax(+n || 0, 0);
            return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it is called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery('#add').on('click', _.before(5, addContactToList));
     * // => allows adding up to 4 contacts to the list
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') {
                if (typeof n == 'function') {
                    var temp = n;
                    n = func;
                    func = temp;
                } else throw new TypeError(FUNC_ERROR_TEXT);
            }
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and prepends any additional `_.bind` arguments to those provided to the
     * bound function.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind` this method does not set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var greet = function(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * };
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // using placeholders
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = restParam(function(func, thisArg, partials) {
            var bitmask = BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, bind.placeholder);
                bitmask |= PARTIAL_FLAG;
            }
            return createWrapper(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method. Method names may be specified as individual arguments or as arrays
     * of method names. If no method names are provided all enumerable function
     * properties, own and inherited, of `object` are bound.
     *
     * **Note:** This method does not set the "length" property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} [methodNames] The object method names to bind,
     *  specified as individual method names or arrays of method names.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'onClick': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view);
     * jQuery('#docs').on('click', view.onClick);
     * // => logs 'clicked docs' when the element is clicked
     */ var bindAll = restParam(function(object, methodNames) {
            methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);
            var index = -1, length = methodNames.length;
            while(++index < length){
                var key = methodNames[index];
                object[key] = createWrapper(object[key], BIND_FLAG, object);
            }
            return object;
        });
        /**
     * Creates a function that invokes the method at `object[key]` and prepends
     * any additional `_.bindKey` arguments to those provided to the bound function.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist.
     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object the method belongs to.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // using placeholders
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = restParam(function(object, key, partials) {
            var bitmask = BIND_FLAG | BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, bindKey.placeholder);
                bitmask |= PARTIAL_FLAG;
            }
            return createWrapper(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts one or more arguments of `func` that when
     * called either invokes `func` returning its result, if all `func` arguments
     * have been provided, or returns a function that accepts one or more of the
     * remaining `func` arguments, and so on. The arity of `func` may be specified
     * if `func.length` is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ var curry = createCurry(CURRY_FLAG);
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ var curryRight = createCurry(CURRY_RIGHT_FLAG);
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed invocations. Provide an options object to indicate that `func`
     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
     * Subsequent calls to the debounced function return the result of the last
     * `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the debounced function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=false] Specify invoking on the leading
     *  edge of the timeout.
     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
     *  delayed before it is invoked.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // avoid costly calculations while the window size is in flux
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // ensure `batchLog` is invoked once after 1 second of debounced calls
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', _.debounce(batchLog, 250, {
     *   'maxWait': 1000
     * }));
     *
     * // cancel a debounced call
     * var todoChanges = _.debounce(batchLog, 1000);
     * Object.observe(models.todo, todoChanges);
     *
     * Object.observe(models, function(changes) {
     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
     *     todoChanges.cancel();
     *   }
     * }, ['delete']);
     *
     * // ...at some point `models.todo` is changed
     * models.todo.completed = true;
     *
     * // ...before 1 second has passed `models.todo` is deleted
     * // which cancels the debounced `todoChanges` call
     * delete models.todo;
     */ function debounce(func, wait, options) {
            var args, maxTimeoutId, result, stamp, thisArg, timeoutId, trailingCall, lastCalled = 0, maxWait = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = wait < 0 ? 0 : +wait || 0;
            if (options === true) {
                var leading = true;
                trailing = false;
            } else if (isObject(options)) {
                leading = !!options.leading;
                maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function cancel() {
                if (timeoutId) clearTimeout(timeoutId);
                if (maxTimeoutId) clearTimeout(maxTimeoutId);
                lastCalled = 0;
                maxTimeoutId = timeoutId = trailingCall = undefined;
            }
            function complete(isCalled, id) {
                if (id) clearTimeout(id);
                maxTimeoutId = timeoutId = trailingCall = undefined;
                if (isCalled) {
                    lastCalled = now();
                    result = func.apply(thisArg, args);
                    if (!timeoutId && !maxTimeoutId) args = thisArg = undefined;
                }
            }
            function delayed() {
                var remaining = wait - (now() - stamp);
                if (remaining <= 0 || remaining > wait) complete(trailingCall, maxTimeoutId);
                else timeoutId = setTimeout(delayed, remaining);
            }
            function maxDelayed() {
                complete(trailing, timeoutId);
            }
            function debounced() {
                args = arguments;
                stamp = now();
                thisArg = this;
                trailingCall = trailing && (timeoutId || !leading);
                if (maxWait === false) var leadingCall = leading && !timeoutId;
                else {
                    if (!maxTimeoutId && !leading) lastCalled = stamp;
                    var remaining = maxWait - (stamp - lastCalled), isCalled = remaining <= 0 || remaining > maxWait;
                    if (isCalled) {
                        if (maxTimeoutId) maxTimeoutId = clearTimeout(maxTimeoutId);
                        lastCalled = stamp;
                        result = func.apply(thisArg, args);
                    } else if (!maxTimeoutId) maxTimeoutId = setTimeout(maxDelayed, remaining);
                }
                if (isCalled && timeoutId) timeoutId = clearTimeout(timeoutId);
                else if (!timeoutId && wait !== maxWait) timeoutId = setTimeout(delayed, wait);
                if (leadingCall) {
                    isCalled = true;
                    result = func.apply(thisArg, args);
                }
                if (isCalled && !timeoutId && !maxTimeoutId) args = thisArg = undefined;
                return result;
            }
            debounced.cancel = cancel;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // logs 'deferred' after one or more milliseconds
     */ var defer = restParam(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => logs 'later' after one second
     */ var delay = restParam(function(func, wait, args) {
            return baseDelay(func, wait, args);
        });
        /**
     * Creates a function that returns the result of invoking the provided
     * functions with the `this` binding of the created function, where each
     * successive invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow(_.add, square);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the provided functions from right to left.
     *
     * @static
     * @memberOf _
     * @alias backflow, compose
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight(square, _.add);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is coerced to a string and used as the
     * cache key. The `func` is invoked with the `this` binding of the memoized
     * function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoizing function.
     * @example
     *
     * var upperCase = _.memoize(function(string) {
     *   return string.toUpperCase();
     * });
     *
     * upperCase('fred');
     * // => 'FRED'
     *
     * // modifying the result cache
     * upperCase.cache.set('fred', 'BARNEY');
     * upperCase('fred');
     * // => 'BARNEY'
     *
     * // replacing `_.memoize.Cache`
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'barney' };
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'fred' }
     *
     * _.memoize.Cache = WeakMap;
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'barney' }
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result);
                return result;
            };
            memoized.cache = new memoize.Cache;
            return memoized;
        }
        /**
     * Creates a function that runs each argument through a corresponding
     * transform function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms] The functions to transform
     * arguments, specified as individual functions or arrays of functions.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var modded = _.modArgs(function(x, y) {
     *   return [x, y];
     * }, square, doubled);
     *
     * modded(1, 2);
     * // => [1, 4]
     *
     * modded(5, 10);
     * // => [25, 20]
     */ var modArgs = restParam(function(func, transforms) {
            transforms = baseFlatten(transforms);
            if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) throw new TypeError(FUNC_ERROR_TEXT);
            var length = transforms.length;
            return restParam(function(args) {
                var index = nativeMin(args.length, length);
                while(index--)args[index] = transforms[index](args[index]);
                return func.apply(this, args);
            });
        });
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                return !predicate.apply(this, arguments);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first call. The `func` is invoked
     * with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // `initialize` invokes `createApplication` once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with `partial` arguments prepended
     * to those provided to the new function. This method is like `_.bind` except
     * it does **not** alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // using placeholders
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = createPartial(PARTIAL_FLAG);
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to those provided to the new function.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // using placeholders
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = createPartial(PARTIAL_RIGHT_FLAG);
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified indexes where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, 2, 0, 1);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     *
     * var map = _.rearg(_.map, [1, 0]);
     * map(function(n) {
     *   return n * 3;
     * }, [1, 2, 3]);
     * // => [3, 6, 9]
     */ var rearg = restParam(function(func, indexes) {
            return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as an array.
     *
     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.restParam(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function restParam(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = nativeMax(start === undefined ? func.length - 1 : +start || 0, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), rest = Array(length);
                while(++index < length)rest[index] = args[start + index];
                switch(start){
                    case 0:
                        return func.call(this, rest);
                    case 1:
                        return func.call(this, args[0], rest);
                    case 2:
                        return func.call(this, args[0], args[1], rest);
                }
                var otherArgs = Array(start + 1);
                index = -1;
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = rest;
                return func.apply(this, otherArgs);
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the created
     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
     *
     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * // with a Promise
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function(array) {
                return func.apply(this, array);
            };
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed invocations. Provide an options object to indicate
     * that `func` should be invoked on the leading and/or trailing edge of the
     * `wait` timeout. Subsequent calls to the throttled function return the
     * result of the last `func` call.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the throttled function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=true] Specify invoking on the leading
     *  edge of the timeout.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // avoid excessively updating the position while scrolling
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
     *   'trailing': false
     * }));
     *
     * // cancel a trailing throttled call
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (options === false) leading = false;
            else if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': +wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that provides `value` to the wrapper function as its
     * first argument. Any additional arguments provided to the function are
     * appended to those provided to the wrapper function. The wrapper is invoked
     * with the `this` binding of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} wrapper The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            wrapper = wrapper == null ? identity : wrapper;
            return createWrapper(wrapper, PARTIAL_FLAG, undefined, [
                value
            ], []);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
     * otherwise they are assigned by reference. If `customizer` is provided it is
     * invoked to produce the cloned values. If `customizer` returns `undefined`
     * cloning is handled by the method instead. The `customizer` is bound to
     * `thisArg` and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var shallow = _.clone(users);
     * shallow[0] === users[0];
     * // => true
     *
     * var deep = _.clone(users, true);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.clone(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 0
     */ function clone(value, isDeep, customizer, thisArg) {
            if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) isDeep = false;
            else if (typeof isDeep == 'function') {
                thisArg = customizer;
                customizer = isDeep;
                isDeep = false;
            }
            return typeof customizer == 'function' ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1)) : baseClone(value, isDeep);
        }
        /**
     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
     * to produce the cloned values. If `customizer` returns `undefined` cloning
     * is handled by the method instead. The `customizer` is bound to `thisArg`
     * and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the deep cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var deep = _.cloneDeep(users);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.cloneDeep(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 20
     */ function cloneDeep(value, customizer, thisArg) {
            return typeof customizer == 'function' ? baseClone(value, true, bindCallback(customizer, thisArg, 1)) : baseClone(value, true);
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ function gt(value, other) {
            return value > other;
        }
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ function gte(value, other) {
            return value >= other;
        }
        /**
     * Checks if `value` is classified as an `arguments` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ function isArguments(value) {
            return isObjectLike(value) && isArrayLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        }
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(function() { return arguments; }());
     * // => false
     */ var isArray = nativeIsArray || function(value) {
            return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
        };
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && objToString.call(value) == boolTag;
        }
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ function isDate(value) {
            return isObjectLike(value) && objToString.call(value) == dateTag;
        }
        /**
     * Checks if `value` is a DOM element.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
        }
        /**
     * Checks if `value` is empty. A value is considered empty unless it is an
     * `arguments` object, array, string, or jQuery-like collection with a length
     * greater than `0` or an object with own enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Array|Object|string} value The value to inspect.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) || isObjectLike(value) && isFunction(value.splice))) return !value.length;
            return !keys(value).length;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent. If `customizer` is provided it is invoked to compare values.
     * If `customizer` returns `undefined` comparisons are handled by the method
     * instead. The `customizer` is bound to `thisArg` and invoked with three
     * arguments: (value, other [, index|key]).
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. Functions and DOM nodes
     * are **not** supported. Provide a customizer function to extend support
     * for comparing other values.
     *
     * @static
     * @memberOf _
     * @alias eq
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'fred' };
     *
     * object == other;
     * // => false
     *
     * _.isEqual(object, other);
     * // => true
     *
     * // using a customizer callback
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqual(array, other, function(value, other) {
     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
     *     return true;
     *   }
     * });
     * // => true
     */ function isEqual(value, other, customizer, thisArg) {
            customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(10);
     * // => true
     *
     * _.isFinite('10');
     * // => false
     *
     * _.isFinite(true);
     * // => false
     *
     * _.isFinite(Object(10));
     * // => false
     *
     * _.isFinite(Infinity);
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in older versions of Chrome and Safari which return 'function' for regexes
            // and Safari 8 equivalents which return 'object' for typed array constructors.
            return isObject(value) && objToString.call(value) == funcTag;
        }
        /**
     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(1);
     * // => false
     */ function isObject(value) {
            // Avoid a V8 JIT bug in Chrome 19-20.
            // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
            var type = typeof value;
            return !!value && (type == 'object' || type == 'function');
        }
        /**
     * Performs a deep comparison between `object` and `source` to determine if
     * `object` contains equivalent property values. If `customizer` is provided
     * it is invoked to compare values. If `customizer` returns `undefined`
     * comparisons are handled by the method instead. The `customizer` is bound
     * to `thisArg` and invoked with three arguments: (value, other, index|key).
     *
     * **Note:** This method supports comparing properties of arrays, booleans,
     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
     * and DOM nodes are **not** supported. Provide a customizer function to extend
     * support for comparing other values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.isMatch(object, { 'age': 40 });
     * // => true
     *
     * _.isMatch(object, { 'age': 36 });
     * // => false
     *
     * // using a customizer callback
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatch(object, source, function(value, other) {
     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
     * });
     * // => true
     */ function isMatch(object, source, customizer, thisArg) {
            customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
            return baseIsMatch(object, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
     * which returns `true` for `undefined` and other non-numeric values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a native function.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (value == null) return false;
            if (isFunction(value)) return reIsNative.test(fnToString.call(value));
            return isObjectLike(value) && reIsHostCtor.test(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
     * as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isNumber(8.4);
     * // => true
     *
     * _.isNumber(NaN);
     * // => true
     *
     * _.isNumber('8.4');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && objToString.call(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * **Note:** This method assumes objects created by the `Object` constructor
     * have no inherited enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            var Ctor;
            // Exit early for non `Object` objects.
            if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) || !hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor))) return false;
            // IE < 9 iterates inherited properties before own properties. If the first
            // iterated property is an object's own property then there are no inherited
            // enumerable properties.
            var result;
            // In most environments an object's own properties are iterated before
            // its inherited properties. If the last iterated property is an object's
            // own property then there are no inherited enumerable properties.
            baseForIn(value, function(subValue, key) {
                result = key;
            });
            return result === undefined || hasOwnProperty.call(value, result);
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ function isRegExp(value) {
            return isObject(value) && objToString.call(value) == regexpTag;
        }
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || isObjectLike(value) && objToString.call(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ function isTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
        }
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ function lt(value, other) {
            return value < other;
        }
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ function lte(value, other) {
            return value <= other;
        }
        /**
     * Converts `value` to an array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * (function() {
     *   return _.toArray(arguments).slice(1);
     * }(1, 2, 3));
     * // => [2, 3]
     */ function toArray(value) {
            var length = value ? getLength(value) : 0;
            if (!isLength(length)) return values(value);
            if (!length) return [];
            return arrayCopy(value);
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable
     * properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return baseCopy(value, keysIn(value));
        }
        /*------------------------------------------------------------------------*/ /**
     * Recursively merges own enumerable properties of the source object(s), that
     * don't resolve to `undefined` into the destination object. Subsequent sources
     * overwrite property assignments of previous sources. If `customizer` is
     * provided it is invoked to produce the merged values of the destination and
     * source properties. If `customizer` returns `undefined` merging is handled
     * by the method instead. The `customizer` is bound to `thisArg` and invoked
     * with five arguments: (objectValue, sourceValue, key, object, source).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var users = {
     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
     * };
     *
     * var ages = {
     *   'data': [{ 'age': 36 }, { 'age': 40 }]
     * };
     *
     * _.merge(users, ages);
     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
     *
     * // using a customizer callback
     * var object = {
     *   'fruits': ['apple'],
     *   'vegetables': ['beet']
     * };
     *
     * var other = {
     *   'fruits': ['banana'],
     *   'vegetables': ['carrot']
     * };
     *
     * _.merge(object, other, function(a, b) {
     *   if (_.isArray(a)) {
     *     return a.concat(b);
     *   }
     * });
     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
     */ var merge = createAssigner(baseMerge);
        /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object. Subsequent sources overwrite property assignments of previous sources.
     * If `customizer` is provided it is invoked to produce the assigned values.
     * The `customizer` is bound to `thisArg` and invoked with five arguments:
     * (objectValue, sourceValue, key, object, source).
     *
     * **Note:** This method mutates `object` and is based on
     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
     *
     * @static
     * @memberOf _
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using a customizer callback
     * var defaults = _.partialRight(_.assign, function(value, other) {
     *   return _.isUndefined(value) ? other : value;
     * });
     *
     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */ var assign = createAssigner(function(object, source, customizer) {
            return customizer ? assignWith(object, source, customizer) : baseAssign(object, source);
        });
        /**
     * Creates an object that inherits from the given `prototype` object. If a
     * `properties` object is provided its own enumerable properties are assigned
     * to the created object.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties, guard) {
            var result = baseCreate(prototype);
            if (guard && isIterateeCall(prototype, properties, guard)) properties = undefined;
            return properties ? baseAssign(result, properties) : result;
        }
        /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object for all destination properties that resolve to `undefined`. Once a
     * property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */ var defaults = createDefaults(assign, assignDefaults);
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
     * // => { 'user': { 'name': 'barney', 'age': 36 } }
     *
     */ var defaultsDeep = createDefaults(merge, mergeDefaults);
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // using the `_.matches` callback shorthand
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findKey(users, 'active');
     * // => 'barney'
     */ var findKey = createFindKey(baseForOwn);
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => returns `pebbles` assuming `_.findKey` returns `barney`
     *
     * // using the `_.matches` callback shorthand
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ var findLastKey = createFindKey(baseForOwnRight);
        /**
     * Iterates over own and inherited enumerable properties of an object invoking
     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
     */ var forIn = createForIn(baseFor);
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
     */ var forInRight = createForIn(baseForRight);
        /**
     * Iterates over own enumerable properties of an object invoking `iteratee`
     * for each property. The `iteratee` is bound to `thisArg` and invoked with
     * three arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a' and 'b' (iteration order is not guaranteed)
     */ var forOwn = createForOwn(baseForOwn);
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
     */ var forOwnRight = createForOwn(baseForOwnRight);
        /**
     * Creates an array of function property names from all enumerable properties,
     * own and inherited, of `object`.
     *
     * @static
     * @memberOf _
     * @alias methods
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the new array of property names.
     * @example
     *
     * _.functions(_);
     * // => ['after', 'ary', 'assign', ...]
     */ function functions(object) {
            return baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the property value at `path` of `object`. If the resolved value is
     * `undefined` the `defaultValue` is used in its place.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': { 'c': 3 } } };
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b.c');
     * // => true
     *
     * _.has(object, ['a', 'b', 'c']);
     * // => true
     */ function has(object, path) {
            if (object == null) return false;
            var result = hasOwnProperty.call(object, path);
            if (!result && !isKey(path)) {
                path = toPath(path);
                object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
                if (object == null) return false;
                path = last(path);
                result = hasOwnProperty.call(object, path);
            }
            return result || isLength(object.length) && isIndex(path, object.length) && (isArray(object) || isArguments(object));
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite property
     * assignments of previous values unless `multiValue` is `true`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to invert.
     * @param {boolean} [multiValue] Allow multiple values per key.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     *
     * // with `multiValue`
     * _.invert(object, true);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function invert(object, multiValue, guard) {
            if (guard && isIterateeCall(object, multiValue, guard)) multiValue = undefined;
            var index = -1, props = keys(object), length = props.length, result = {};
            while(++index < length){
                var key = props[index], value = object[key];
                if (multiValue) {
                    if (hasOwnProperty.call(result, value)) result[value].push(key);
                    else result[value] = [
                        key
                    ];
                } else result[value] = key;
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ var keys = !nativeKeys ? shimKeys : function(object) {
            var Ctor = object == null ? undefined : object.constructor;
            if (typeof Ctor == 'function' && Ctor.prototype === object || typeof object != 'function' && isArrayLike(object)) return shimKeys(object);
            return isObject(object) ? nativeKeys(object) : [];
        };
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            if (object == null) return [];
            if (!isObject(object)) object = Object(object);
            var length = object.length;
            length = length && isLength(length) && (isArray(object) || isArguments(object)) && length || 0;
            var Ctor = object.constructor, index = -1, isProto = typeof Ctor == 'function' && Ctor.prototype === object, result = Array(length), skipIndexes = length > 0;
            while(++index < length)result[index] = index + '';
            for(var key in object)if (!(skipIndexes && isIndex(key, length)) && !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * property of `object` through `iteratee`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ var mapKeys = createObjectMapper(true);
        /**
     * Creates an object with the same keys as `object` and values generated by
     * running each own enumerable property of `object` through `iteratee`. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, key, object).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
     *   return n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * // using the `_.property` callback shorthand
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ var mapValues = createObjectMapper();
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable properties of `object` that are not omitted.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to omit, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.omit(object, 'age');
     * // => { 'user': 'fred' }
     *
     * _.omit(object, _.isNumber);
     * // => { 'user': 'fred' }
     */ var omit = restParam(function(object, props) {
            if (object == null) return {};
            if (typeof props[0] != 'function') {
                var props = arrayMap(baseFlatten(props), String);
                return pickByArray(object, baseDifference(keysIn(object), props));
            }
            var predicate = bindCallback(props[0], props[1], 3);
            return pickByCallback(object, function(value, key, object) {
                return !predicate(value, key, object);
            });
        });
        /**
     * Creates a two dimensional array of the key-value pairs for `object`,
     * e.g. `[[key1, value1], [key2, value2]]`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the new array of key-value pairs.
     * @example
     *
     * _.pairs({ 'barney': 36, 'fred': 40 });
     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
     */ function pairs(object) {
            object = toObject(object);
            var index = -1, props = keys(object), length = props.length, result = Array(length);
            while(++index < length){
                var key = props[index];
                result[index] = [
                    key,
                    object[key]
                ];
            }
            return result;
        }
        /**
     * Creates an object composed of the picked `object` properties. Property
     * names may be specified as individual arguments or as arrays of property
     * names. If `predicate` is provided it is invoked for each property of `object`
     * picking the properties `predicate` returns truthy for. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to pick, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.pick(object, 'user');
     * // => { 'user': 'fred' }
     *
     * _.pick(object, _.isString);
     * // => { 'user': 'fred' }
     */ var pick = restParam(function(object, props) {
            if (object == null) return {};
            return typeof props[0] == 'function' ? pickByCallback(object, bindCallback(props[0], props[1], 3)) : pickByArray(object, baseFlatten(props));
        });
        /**
     * This method is like `_.get` except that if the resolved value is a function
     * it is invoked with the `this` binding of its parent object and its result
     * is returned.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a.b.c', 'default');
     * // => 'default'
     *
     * _.result(object, 'a.b.c', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            var result = object == null ? undefined : object[path];
            if (result === undefined) {
                if (object != null && !isKey(path, object)) {
                    path = toPath(path);
                    object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
                    result = object == null ? undefined : object[last(path)];
                }
                result = result === undefined ? defaultValue : result;
            }
            return isFunction(result) ? result.call(object) : result;
        }
        /**
     * Sets the property value of `path` on `object`. If a portion of `path`
     * does not exist it is created.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to augment.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, 'x[0].y.z', 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            if (object == null) return object;
            var pathKey = path + '';
            path = object[pathKey] != null || isKey(path, object) ? [
                pathKey
            ] : toPath(path);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = path[index];
                if (isObject(nested)) {
                    if (index == lastIndex) nested[key] = value;
                    else if (nested[key] == null) nested[key] = isIndex(path[index + 1]) ? [] : {};
                }
                nested = nested[key];
            }
            return object;
        }
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own enumerable
     * properties through `iteratee`, with each invocation potentially mutating
     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
     * with four arguments: (accumulator, value, key, object). Iteratee functions
     * may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Array|Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * });
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     */ function transform(object, iteratee, accumulator, thisArg) {
            var isArr = isArray(object) || isTypedArray(object);
            iteratee = getCallback(iteratee, thisArg, 4);
            if (accumulator == null) {
                if (isArr || isObject(object)) {
                    var Ctor = object.constructor;
                    if (isArr) accumulator = isArray(object) ? new Ctor : [];
                    else accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
                } else accumulator = {};
            }
            (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Creates an array of the own enumerable property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable property values
     * of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Checks if `n` is between `start` and up to but not including, `end`. If
     * `end` is not specified it is set to `start` with `start` then set to `0`.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} n The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     */ function inRange(value, start, end) {
            start = +start || 0;
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = +end || 0;
            return value >= nativeMin(start, end) && value < nativeMax(start, end);
        }
        /**
     * Produces a random number between `min` and `max` (inclusive). If only one
     * argument is provided a number between `0` and the given number is returned.
     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
     * number is returned instead of an integer.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} [min=0] The minimum possible value.
     * @param {number} [max=1] The maximum possible value.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(min, max, floating) {
            if (floating && isIterateeCall(min, max, floating)) max = floating = undefined;
            var noMin = min == null, noMax = max == null;
            if (floating == null) {
                if (noMax && typeof min == 'boolean') {
                    floating = min;
                    min = 1;
                } else if (typeof max == 'boolean') {
                    floating = max;
                    noMax = true;
                }
            }
            if (noMin && noMax) {
                max = 1;
                noMax = false;
            }
            min = +min || 0;
            if (noMax) {
                max = min;
                min = 0;
            } else max = +max || 0;
            if (floating || min % 1 || max % 1) {
                var rand = nativeRandom();
                return nativeMin(min + rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1))), max);
            }
            return baseRandom(min, max);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar');
     * // => 'fooBar'
     *
     * _.camelCase('__foo_bar__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? word.charAt(0).toUpperCase() + word.slice(1) : word);
        });
        /**
     * Capitalizes the first character of `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('fred');
     * // => 'Fred'
     */ function capitalize(string) {
            string = baseToString(string);
            return string && string.charAt(0).toUpperCase() + string.slice(1);
        }
        /**
     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = baseToString(string);
            return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search from.
     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = baseToString(string);
            target = target + '';
            var length = string.length;
            position = position === undefined ? length : nativeMin(position < 0 ? 0 : +position || 0, length);
            position -= target.length;
            return position >= 0 && string.indexOf(target, position) == position;
        }
        /**
     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
     * their corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional characters
     * use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value.
     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * Backticks are escaped because in Internet Explorer < 9, they can break out
     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
     * for more details.
     *
     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
     * to reduce XSS vectors.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            // Reset `lastIndex` because in IE < 9 `String#replace` does not.
            string = baseToString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
     */ function escapeRegExp(string) {
            string = baseToString(string);
            return string && reHasRegExpChars.test(string) ? string.replace(reRegExpChars, escapeRegExpChar) : string || '(?:)';
        }
        /**
     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__foo_bar__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = baseToString(string);
            length = +length;
            var strLength = string.length;
            if (strLength >= length || !nativeIsFinite(length)) return string;
            var mid = (length - strLength) / 2, leftLength = nativeFloor(mid), rightLength = nativeCeil(mid);
            chars = createPadding('', rightLength, chars);
            return chars.slice(0, leftLength) + string + chars;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padLeft('abc', 6);
     * // => '   abc'
     *
     * _.padLeft('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padLeft('abc', 3);
     * // => 'abc'
     */ var padLeft = createPadDir();
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padRight('abc', 6);
     * // => 'abc   '
     *
     * _.padRight('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padRight('abc', 3);
     * // => 'abc'
     */ var padRight = createPadDir(true);
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
     * in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
     * of `parseInt`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt(string, radix, guard) {
            // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
            // Chrome fails to trim leading <BOM> whitespace characters.
            // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
            if (guard ? isIterateeCall(string, radix, guard) : radix == null) radix = 0;
            else if (radix) radix = +radix;
            string = trim(string);
            return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=0] The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n) {
            var result = '';
            string = baseToString(string);
            n = +n;
            if (n < 1 || !string || !nativeIsFinite(n)) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                string += string;
            }while (n);
            return result;
        }
        /**
     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--foo-bar');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__foo_bar__');
     * // => 'Foo Bar'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = baseToString(string);
            position = position == null ? 0 : nativeMin(position < 0 ? 0 : +position || 0, string.length);
            return string.lastIndexOf(target, position) == position;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is provided it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options] The options object.
     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
     * @param {Object} [options.imports] An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
     * @param {string} [options.variable] The data object variable name.
     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // using the "interpolate" delimiter to create a compiled template
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // using the HTML "escape" delimiter to escape data property values
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the internal `print` function in "evaluate" delimiters
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // using custom template delimiters
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // using backslashes to treat delimiters as plain text
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // using the `imports` option to import `jQuery` as `jq`
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the `sourceURL` option to specify a custom sourceURL for the template
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
     *
     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // using the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and a stack trace
     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, otherOptions) {
            // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (otherOptions && isIterateeCall(string, options, otherOptions)) options = otherOptions = undefined;
            string = baseToString(string);
            options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);
            var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            var sourceURL = '//# sourceURL=' + ('sourceURL' in options ? options.sourceURL : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products requires returning the `match`
                // string in order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            var value = string;
            string = baseToString(string);
            if (!string) return string;
            if (guard ? isIterateeCall(value, chars, guard) : chars == null) return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
            chars = chars + '';
            return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimLeft('  abc  ');
     * // => 'abc  '
     *
     * _.trimLeft('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimLeft(string, chars, guard) {
            var value = string;
            string = baseToString(string);
            if (!string) return string;
            if (guard ? isIterateeCall(value, chars, guard) : chars == null) return string.slice(trimmedLeftIndex(string));
            return string.slice(charsLeftIndex(string, chars + ''));
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimRight('  abc  ');
     * // => '  abc'
     *
     * _.trimRight('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimRight(string, chars, guard) {
            var value = string;
            string = baseToString(string);
            if (!string) return string;
            if (guard ? isIterateeCall(value, chars, guard) : chars == null) return string.slice(0, trimmedRightIndex(string) + 1);
            return string.slice(0, charsRightIndex(string, chars + '') + 1);
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object|number} [options] The options object or maximum string length.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.trunc('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', 24);
     * // => 'hi-diddly-ho there, n...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function trunc(string, options, guard) {
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (options != null) {
                if (isObject(options)) {
                    var separator = 'separator' in options ? options.separator : separator;
                    length = 'length' in options ? +options.length || 0 : length;
                    omission = 'omission' in options ? baseToString(options.omission) : omission;
                } else length = +options || 0;
            }
            string = baseToString(string);
            if (length >= string.length) return string;
            var end = length - omission.length;
            if (end < 1) return omission;
            var result = string.slice(0, end);
            if (separator == null) return result + omission;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, newEnd, substring = string.slice(0, end);
                    if (!separator.global) separator = RegExp1(separator.source, (reFlags.exec(separator) || '') + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))newEnd = match.index;
                    result = result.slice(0, newEnd == null ? end : newEnd);
                }
            } else if (string.indexOf(separator, end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
     * corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
     * entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = baseToString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            if (guard && isIterateeCall(string, pattern, guard)) pattern = undefined;
            string = baseToString(string);
            return string.match(pattern || reWords) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function} func The function to attempt.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // avoid throwing errors for invalid selectors
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = restParam(function(func, args) {
            try {
                return func.apply(undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and arguments of the created function. If `func` is a property name the
     * created callback returns the property value for a given element. If `func`
     * is an object the created callback returns `true` for elements that contain
     * the equivalent object properties, otherwise it returns `false`.
     *
     * @static
     * @memberOf _
     * @alias iteratee
     * @category Utility
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // wrap to create custom callback shorthands
     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
     *   if (!match) {
     *     return callback(func, thisArg);
     *   }
     *   return function(object) {
     *     return match[2] == 'gt'
     *       ? object[match[1]] > match[3]
     *       : object[match[1]] < match[3];
     *   };
     * });
     *
     * _.filter(users, 'age__gt36');
     * // => [{ 'user': 'fred', 'age': 40 }]
     */ function callback(func, thisArg, guard) {
            if (guard && isIterateeCall(func, thisArg, guard)) thisArg = undefined;
            return isObjectLike(func) ? matches(func) : baseCallback(func, thisArg);
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var getter = _.constant(object);
     *
     * getter() === object;
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * This method returns the first argument provided to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.identity(object) === object;
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that performs a deep comparison between a given object
     * and `source`, returning `true` if the given object has equivalent property
     * values, else `false`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
     */ function matches(source) {
            return baseMatches(baseClone(source, true));
        }
        /**
     * Creates a function that compares the property value of `path` on a given
     * object to `value`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * _.find(users, _.matchesProperty('user', 'fred'));
     * // => { 'user': 'fred' }
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, true));
        }
        /**
     * Creates a function that invokes the method at `path` on a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': _.constant(2) } } },
     *   { 'a': { 'b': { 'c': _.constant(1) } } }
     * ];
     *
     * _.map(objects, _.method('a.b.c'));
     * // => [2, 1]
     *
     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */ var method = restParam(function(path, args) {
            return function(object) {
                return invokePath(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path on `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = restParam(function(object, args) {
            return function(path) {
                return invokePath(object, path, args);
            };
        });
        /**
     * Adds all own enumerable function properties of a source object to the
     * destination object. If `object` is a function then methods are added to
     * its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.chain=true] Specify whether the functions added
     *  are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            if (options == null) {
                var isObj = isObject(source), props = isObj ? keys(source) : undefined, methodNames = props && props.length ? baseFunctions(source, props) : undefined;
                if (!(methodNames ? methodNames.length : isObj)) {
                    methodNames = false;
                    options = source;
                    source = object;
                    object = this;
                }
            }
            if (!methodNames) methodNames = baseFunctions(source, keys(source));
            var chain = true, index = -1, isFunc = isFunction(object), length = methodNames.length;
            if (options === false) chain = false;
            else if (isObject(options) && 'chain' in options) chain = options.chain;
            while(++index < length){
                var methodName = methodNames[index], func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function(func) {
                    return function() {
                        var chainAll = this.__chain__;
                        if (chain || chainAll) {
                            var result = object(this.__wrapped__), actions = result.__actions__ = arrayCopy(this.__actions__);
                            actions.push({
                                'func': func,
                                'args': arguments,
                                'thisArg': object
                            });
                            result.__chain__ = chainAll;
                            return result;
                        }
                        return func.apply(object, arrayPush([
                            this.value()
                        ], arguments));
                    };
                }(func);
            }
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            root._ = oldDash;
            return this;
        }
        /**
     * A no-operation function that returns `undefined` regardless of the
     * arguments it receives.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.noop(object) === undefined;
     * // => true
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that returns the property value at `path` on a
     * given object.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': 2 } } },
     *   { 'a': { 'b': { 'c': 1 } } }
     * ];
     *
     * _.map(objects, _.property('a.b.c'));
     * // => [2, 1]
     *
     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the property value at a given path on `object`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return baseGet(object, toPath(path), path + '');
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. If `end` is not specified it is
     * set to `start` with `start` then set to `0`. If `end` is less than `start`
     * a zero-length range is created unless a negative `step` is specified.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the new array of numbers.
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ function range(start, end, step) {
            if (step && isIterateeCall(start, end, step)) end = step = undefined;
            start = +start || 0;
            step = step == null ? 1 : +step || 0;
            if (end == null) {
                end = start;
                start = 0;
            } else end = +end || 0;
            // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
            // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
            while(++index < length){
                result[index] = start;
                start += step;
            }
            return result;
        }
        /**
     * Invokes the iteratee function `n` times, returning an array of the results
     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
     * one argument; (index).
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
     * // => [3, 6, 4]
     *
     * _.times(3, function(n) {
     *   mage.castSpell(n);
     * });
     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
     *
     * _.times(3, function(n) {
     *   this.cast(n);
     * }, mage);
     * // => also invokes `mage.castSpell(n)` three times
     */ function times(n, iteratee, thisArg) {
            n = nativeFloor(n);
            // Exit early to avoid a JSC JIT bug in Safari 8
            // where `Array(0)` is treated as `Array(1)`.
            if (n < 1 || !nativeIsFinite(n)) return [];
            var index = -1, result = Array(nativeMin(n, MAX_ARRAY_LENGTH));
            iteratee = bindCallback(iteratee, thisArg, 1);
            while(++index < n)if (index < MAX_ARRAY_LENGTH) result[index] = iteratee(index);
            else iteratee(index);
            return result;
        }
        /**
     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {string} [prefix] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return baseToString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} augend The first number to add.
     * @param {number} addend The second number to add.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ function add(augend, addend) {
            return (+augend || 0) + (+addend || 0);
        }
        /**
     * Calculates `n` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Calculates `n` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Gets the maximum value of `collection`. If `collection` is empty or falsey
     * `-Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => -Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.max(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using the `_.property` callback shorthand
     * _.max(users, 'age');
     * // => { 'user': 'fred', 'age': 40 }
     */ var max = createExtremum(gt, NEGATIVE_INFINITY);
        /**
     * Gets the minimum value of `collection`. If `collection` is empty or falsey
     * `Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.min(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // using the `_.property` callback shorthand
     * _.min(users, 'age');
     * // => { 'user': 'barney', 'age': 36 }
     */ var min = createExtremum(lt, POSITIVE_INFINITY);
        /**
     * Calculates `n` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Gets the sum of the values in `collection`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 6]);
     * // => 10
     *
     * _.sum({ 'a': 4, 'b': 6 });
     * // => 10
     *
     * var objects = [
     *   { 'n': 4 },
     *   { 'n': 6 }
     * ];
     *
     * _.sum(objects, function(object) {
     *   return object.n;
     * });
     * // => 10
     *
     * // using the `_.property` callback shorthand
     * _.sum(objects, 'n');
     * // => 10
     */ function sum(collection, iteratee, thisArg) {
            if (thisArg && isIterateeCall(collection, iteratee, thisArg)) iteratee = undefined;
            iteratee = getCallback(iteratee, thisArg, 3);
            return iteratee.length == 1 ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee) : baseSum(collection, iteratee);
        }
        /*------------------------------------------------------------------------*/ // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        // Add functions to the `Map` cache.
        MapCache.prototype['delete'] = mapDelete;
        MapCache.prototype.get = mapGet;
        MapCache.prototype.has = mapHas;
        MapCache.prototype.set = mapSet;
        // Add functions to the `Set` cache.
        SetCache.prototype.push = cachePush;
        // Assign cache to `_.memoize`.
        memoize.Cache = MapCache;
        // Add functions that return wrapped values when chaining.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.callback = callback;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.functions = functions;
        lodash.groupBy = groupBy;
        lodash.indexBy = indexBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.invert = invert;
        lodash.invoke = invoke;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.modArgs = modArgs;
        lodash.negate = negate;
        lodash.omit = omit;
        lodash.once = once;
        lodash.pairs = pairs;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pluck = pluck;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.restParam = restParam;
        lodash.set = set;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortByAll = sortByAll;
        lodash.sortByOrder = sortByOrder;
        lodash.spread = spread;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.times = times;
        lodash.toArray = toArray;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.union = union;
        lodash.uniq = uniq;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.where = where;
        lodash.without = without;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.backflow = flowRight;
        lodash.collect = map;
        lodash.compose = flowRight;
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.extend = assign;
        lodash.iteratee = callback;
        lodash.methods = functions;
        lodash.object = zipObject;
        lodash.select = filter;
        lodash.tail = rest;
        lodash.unique = uniq;
        // Add functions to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add functions that return unwrapped values when chaining.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.deburr = deburr;
        lodash.endsWith = endsWith;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.findWhere = findWhere;
        lodash.first = first;
        lodash.floor = floor;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isBoolean = isBoolean;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isMatch = isMatch;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isString = isString;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.min = min;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padLeft = padLeft;
        lodash.padRight = padRight;
        lodash.parseInt = parseInt;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.sum = sum;
        lodash.template = template;
        lodash.trim = trim;
        lodash.trimLeft = trimLeft;
        lodash.trimRight = trimRight;
        lodash.trunc = trunc;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.words = words;
        // Add aliases.
        lodash.all = every;
        lodash.any = some;
        lodash.contains = includes;
        lodash.eq = isEqual;
        lodash.detect = find;
        lodash.foldl = reduce;
        lodash.foldr = reduceRight;
        lodash.head = first;
        lodash.include = includes;
        lodash.inject = reduce;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!lodash.prototype[methodName]) source[methodName] = func;
            });
            return source;
        }(), false);
        /*------------------------------------------------------------------------*/ // Add functions capable of returning wrapped and unwrapped values when chaining.
        lodash.sample = sample;
        lodash.prototype.sample = function(n) {
            if (!this.__chain__ && n == null) return sample(this.value());
            return this.thru(function(value) {
                return sample(value, n);
            });
        };
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type string
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                var filtered = this.__filtered__;
                if (filtered && !index) return new LazyWrapper(this);
                n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);
                var result = this.clone();
                if (filtered) result.__takeCount__ = nativeMin(result.__takeCount__, n);
                else result.__views__.push({
                    'size': n,
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type != LAZY_MAP_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getCallback(iteratee, thisArg, 1),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.first` and `_.last`.
        arrayEach([
            'first',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
        arrayEach([
            'initial',
            'rest'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
        arrayEach([
            'pluck',
            'where'
        ], function(methodName, index) {
            var operationName = index ? 'filter' : 'map', createCallback = index ? baseMatches : property;
            LazyWrapper.prototype[methodName] = function(value) {
                return this[operationName](createCallback(value));
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.reject = function(predicate, thisArg) {
            predicate = getCallback(predicate, thisArg, 1);
            return this.filter(function(value) {
                return !predicate(value);
            });
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = start == null ? 0 : +start || 0;
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = +end || 0;
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
            return this.reverse().takeWhile(predicate, thisArg).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(POSITIVE_INFINITY);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName), retUnwrapped = /^(?:first|last)$/.test(methodName), lodashFunc = lodash[retUnwrapped ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName];
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var args = retUnwrapped ? [
                    1
                ] : arguments, chainAll = this.__chain__, value = this.__wrapped__, isHybrid = !!this.__actions__.length, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var interceptor = function(value) {
                    return retUnwrapped && chainAll ? lodashFunc(value, 1)[0] : lodashFunc.apply(undefined, arrayPush([
                        value
                    ], args));
                };
                var action = {
                    'func': thru,
                    'args': [
                        interceptor
                    ],
                    'thisArg': undefined
                }, onlyLazy = isLazy && !isHybrid;
                if (retUnwrapped && !chainAll) {
                    if (onlyLazy) {
                        value = value.clone();
                        value.__actions__.push(action);
                        return func.call(value);
                    }
                    return lodashFunc.call(undefined, this.value())[0];
                }
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push(action);
                    return new LodashWrapper(result, chainAll);
                }
                return this.thru(interceptor);
            };
        });
        // Add `Array` and `String` methods to `lodash.prototype`.
        arrayEach([
            'join',
            'pop',
            'push',
            'replace',
            'shift',
            'sort',
            'splice',
            'split',
            'unshift'
        ], function(methodName) {
            var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) return func.apply(this.value(), args);
                return this[chainName](function(value) {
                    return func.apply(value, args);
                });
            };
        });
        // Map minified function names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name, names = realNames[key] || (realNames[key] = []);
                names.push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add functions to the lazy wrapper.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chaining functions to the `lodash` wrapper.
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.concat = wrapperConcat;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toString = wrapperToString;
        lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add function aliases to the `lodash` wrapper.
        lodash.prototype.collect = lodash.prototype.map;
        lodash.prototype.head = lodash.prototype.first;
        lodash.prototype.select = lodash.prototype.filter;
        lodash.prototype.tail = lodash.prototype.rest;
        return lodash;
    }
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers like r.js check for condition patterns like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose lodash to the global object when an AMD loader is present to avoid
        // errors in cases where lodash is loaded by a script tag and not intended
        // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
        // more details.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeExports && freeModule) {
        // Export for Node.js or RingoJS.
        if (moduleExports) (freeModule.exports = _)._ = _;
        else freeExports._ = _;
    } else // Export for a browser or Rhino.
    root._ = _;
}).call(this);

},{}],"jrU9D":[function(require,module,exports,__globalThis) {
var _ = require("9f860c5130fd7392");
var TreeModel = require("2cb8e19742822075");
function decorateTree(tree) {
    tree.lca = function lowestCommonAncestor(nodes) {
        var parentNodesInCommon = _.chain(nodes).map(function(node) {
            if (!node || !_.isFunction(node.getPath)) throw new Error('Cannot calculate lca with a null node');
            return node.getPath();
        }).reduce(function(acc, nextPath) {
            return _.intersection(acc, nextPath);
        }).value();
        return parentNodesInCommon.pop();
    };
    tree.pathBetween = function pathBetweenNodes(from, to) {
        var lca, fromPath, toPath, fromLcaIdx, toLcaIdx, pathBetween;
        // find the lowest commen ancestor
        lca = tree.lca([
            from,
            to
        ]);
        // get the full path from -> root, and reverse it
        fromPath = _(from.getPath().reverse());
        // get the full path to -> root
        toPath = _(to.getPath());
        // find the index of lca in fromPath and toPath
        fromLcaIdx = fromPath.findIndex(lca);
        toLcaIdx = toPath.findIndex(lca);
        // slice and combine the arrays to get the path between
        pathBetween = fromPath.slice(0, fromLcaIdx).concat(toPath.slice(toLcaIdx).value());
        return pathBetween.value();
    };
}
function addPrototypeDecorations(tree) {
    var prototree = Object.getPrototypeOf(tree);
    if (!shouldDecorateTreePrototype(prototree)) return;
    prototree.depth = function calculateEffectiveNodeDepth(includeCompressedNodes) {
        var path = this.getPath(), depth = path.length - 1, compressedDepth;
        if (includeCompressedNodes) {
            compressedDepth = _.reduce(path, function(acc, n) {
                return acc + (n.compressedNodes ? n.compressedNodes.length : 0);
            }, 0);
            depth += compressedDepth;
        }
        return depth;
    };
    prototree.pathTo = function(to) {
        return tree.pathBetween(this, to);
    };
    prototree.leafNodes = function findAllLeafNodes() {
        return this.all(function(node) {
            return !node.hasChildren();
        });
    };
    prototree.lcaWith = function(otherNodes) {
        var nodes = _.clone(otherNodes);
        nodes.push(this);
        return tree.lca(nodes);
    };
    prototree.filterWalk = function(callback) {
        function filterWalkRecursive(node) {
            var evaluateChildren = callback(node);
            if (evaluateChildren && _.isArray(node.children)) _.forEach(node.children, filterWalkRecursive);
        }
        return filterWalkRecursive(this);
    };
}
function shouldDecorateTreePrototype(prototype) {
    return !(_.isFunction(prototype.depth) && _.isFunction(prototype.pathTo) && _.isFunction(prototype.leafNodes) && _.isFunction(prototype.lcaWith));
}
function indexTree(tree, attrs) {
    tree.indices = _.chain(attrs).map(function(attr) {
        var result = {
            _attr: attr
        };
        tree.walk(function(node) {
            var key = node.model[attr];
            if (!_.isUndefined(key)) result[key] = node;
        });
        return result;
    }).indexBy('_attr').value();
}
function pruneTree(tree, testNode) {
    var treeModel = new TreeModel({
        modelComparatorFn: tree.config.modelComparatorFn
    });
    function pruneChildren(source) {
        if (source.hasChildren()) {
            var shouldAdd = testNode(source);
            var kids = [];
            source.children.forEach(function(sourceChild) {
                var destChild = pruneChildren(sourceChild);
                if (destChild) kids.push(destChild);
            });
            if (shouldAdd || kids.length > 0) {
                if (kids.length === 1) {
                    kids[0].model.distance_to_parent += source.model.distance_to_parent;
                    return kids[0];
                } else {
                    // create a new node and add the kids to it
                    var model = _.clone(source.model);
                    delete model.children;
                    var parent = treeModel.parse(model);
                    kids.forEach(function(k) {
                        parent.addChild(k);
                    });
                    return parent;
                }
            }
        } else if (testNode(source)) {
            var leaf = _.clone(source.model);
            return treeModel.parse(leaf);
        }
        return false;
    }
    // var model = _.clone(tree.model);
    // delete model.children;
    // var root = treeModel.parse(model);
    var root = pruneChildren(tree);
    if (!root.model._id) {
        root.model._id = tree.model._id;
        root.model.tree_stable_id = tree.model.tree_stable_id;
    }
    if (tree.indices) indexTree(root, Object.keys(tree.indices));
    decorateTree(root);
    addPrototypeDecorations(root);
    return root;
}
function identity(geneA, geneB) {
    if (geneA === geneB) return 1;
    if (!geneA.model.consensus) geneA.model.consensus = cigarToConsensus(geneA.model.cigar, geneA.model.sequence);
    if (!geneB.model.consensus) geneB.model.consensus = cigarToConsensus(geneB.model.cigar, geneB.model.sequence);
    var seqA = geneA.model.consensus.sequence;
    var seqB = geneB.model.consensus.sequence;
    if (seqA.length !== seqB.length) {
        console.error('alignment sequences are not the same length');
        return 0;
    }
    var matchCnt = 0;
    var totalCnt = 0;
    var gapCode = '-'.charCodeAt(0);
    for(var i = 0; i < seqA.length; i++){
        totalCnt++;
        if (seqA[i] === seqB[i]) {
            if (seqA[i] === gapCode) totalCnt--;
            else matchCnt++;
        }
    }
    return matchCnt / totalCnt;
}
function cigarToConsensus(cigar, seq) {
    var pieces = cigar.split(/([DM])/);
    var clength = 0;
    var stretch = 0;
    pieces.forEach(function(piece) {
        if (piece === "M" || piece === "D") {
            if (stretch === 0) stretch = 1;
            clength += stretch;
        } else stretch = +piece;
    });
    stretch = 0;
    var size = 0;
    var gap = '-'.charCodeAt(0);
    var alignseq = new Uint16Array(clength);
    var frequency = new Uint16Array(clength);
    alignseq.fill(gap);
    var offset = 0;
    pieces.forEach(function(piece) {
        if (piece === "M") {
            if (stretch === 0) stretch = 1;
            frequency.fill(1, offset, offset + stretch);
            for(var i = 0; i < stretch; i++)alignseq[offset++] = seq.charCodeAt(size + i);
            size += stretch;
            stretch = 0;
        } else if (piece === "D") {
            if (stretch === 0) stretch = 1;
            offset += stretch;
            stretch = 0;
        } else if (!!piece) stretch = +piece;
    });
    return {
        sequence: alignseq,
        frequency: frequency,
        nSeqs: 1,
        consensusLength: clength
    };
}
function addConsensus(tree) {
    // generate a consensus for each node in the tree
    // the consensus is a string and an array of frequencies (gap frequencies are always 0)
    // for leaf nodes use the sequence and cigar attributes to define the node's consensus
    // for internal nodes (2 children) select the consensus based on the frequency in the child nodes
    // todo: try run-length encoding to save memory?
    if (tree.model.consensus) return;
    function mergeConsensi(A, B) {
        var res = _.cloneDeep(A);
        const len = A.sequence.length;
        res.nSeqs += B.nSeqs;
        for(var i = 0; i < len; i++){
            if (B.sequence[i] === res.sequence[i]) res.frequency[i] += B.frequency[i];
            else if (B.frequency[i] > res.frequency[i]) {
                res.frequency[i] = B.frequency[i];
                res.sequence[i] = B.sequence[i];
            }
        }
        return res;
    }
    function addConsensusToNode(node) {
        if (node.model.sequence && node.model.cigar) node.model.consensus = cigarToConsensus(node.model.cigar, node.model.sequence);
        else {
            addConsensusToNode(node.children[0]);
            addConsensusToNode(node.children[1]);
            node.model.consensus = mergeConsensi(node.children[0].model.consensus, node.children[1].model.consensus);
        }
    }
    addConsensusToNode(tree);
    removeGaps(tree);
}
function removeGaps(tree) {
    // if there are gaps in the tree root's consensus, identify them and remove them from the rest of the tree
    // remove gaps from the consensus, and from the cigar string in the leaf nodes (maybe ?)
    const msaLength = tree.model.consensus.frequency.length;
    var nonGapStarts = [];
    var nonGapLengths = [];
    var nonGapStart = 0;
    var nonGapLength = 0;
    var totalLength = 0;
    for(var i = 0; i < msaLength; i++){
        if (tree.model.consensus.frequency[i] > 0) {
            if (i === nonGapStart + nonGapLength) nonGapLength++;
            else {
                nonGapStart = i;
                nonGapLength = 1;
            }
        } else if (nonGapLength) {
            totalLength += nonGapLength;
            nonGapStarts.push(nonGapStart);
            nonGapLengths.push(nonGapLength);
            nonGapLength = 0;
        }
    }
    if (nonGapLength) {
        totalLength += nonGapLength;
        nonGapStarts.push(nonGapStart);
        nonGapLengths.push(nonGapLength);
    }
    if (totalLength < msaLength) {
        function removeGapsFromNode(node) {
            var consensus = {
                nSeqs: node.model.consensus.nSeqs,
                consensusLength: totalLength,
                sequence: new Uint16Array(totalLength),
                frequency: new Uint16Array(totalLength)
            };
            var srcSeqBuffer = node.model.consensus.sequence.buffer;
            var srcFreqBuffer = node.model.consensus.frequency.buffer;
            var dstSeqBuffer = consensus.sequence.buffer;
            var dstFreqBuffer = consensus.frequency.buffer;
            var dstOffset = 0;
            for(let i = 0; i < nonGapStarts.length; i++){
                var srcOffset = 2 * nonGapStarts[i];
                var lengthInBytes = 2 * nonGapLengths[i];
                var srcU8 = new Uint8Array(srcSeqBuffer, srcOffset, lengthInBytes);
                var dstU8 = new Uint8Array(dstSeqBuffer, dstOffset, lengthInBytes);
                dstU8.set(srcU8);
                srcU8 = new Uint8Array(srcFreqBuffer, srcOffset, lengthInBytes);
                dstU8 = new Uint8Array(dstFreqBuffer, dstOffset, lengthInBytes);
                dstU8.set(srcU8);
                dstOffset += lengthInBytes;
            }
            node.model.consensus = consensus;
            node.children.forEach(function(child) {
                removeGapsFromNode(child);
            });
        }
        removeGapsFromNode(tree);
    }
}
module.exports = {
    decorateTree: decorateTree,
    addPrototypeDecorations: addPrototypeDecorations,
    indexTree: indexTree,
    pruneTree: pruneTree,
    addConsensus: addConsensus,
    identity: identity
};

},{"9f860c5130fd7392":"8bWZr","2cb8e19742822075":"5AXxY"}],"fZjTS":[function(require,module,exports,__globalThis) {
'use strict';
var binsPromise = require("9730914d7acf32a1").binsPromise;
var treesPromise = require("c5090ca85a6ca1e2").promise;
var Q = require("7900f44b975fba6c");
var _ = require("1aafda790f7abfe5");
// given two objects that have the same keys and whose values are all integers
// return a new object that sums them together. If either object is null, return
// the other one.
function addCounts(o1, o2) {
    var result;
    if (o1 && o2) result = _.merge(o1, o2, function(a, b) {
        return a + b;
    });
    else if (o1) result = o1;
    else result = o2;
    return result;
}
function addGenomesToTaxonomy(taxonomy, genomes) {
    var taxonomyPrototype = Object.getPrototypeOf(taxonomy);
    taxonomy.leafNodes().forEach(function(speciesNode) {
        var species = speciesNode.model, genome = genomes.get(species.id);
        if (!genome) console.warn('No genome found for', species);
        species.genome = genome;
    });
    function calcStatsForTaxonomyNode(node) {
        var statsFromChildren, statsFromGenome;
        if (node.model.genome) statsFromGenome = {
            genomes: 1,
            genes: node.model.geneCount,
            bins: node.model.genome.nbins
        };
        if (node.children && node.children.length) statsFromChildren = _.reduce(node.children, function(total, childNode) {
            return addCounts(total, calcStatsForTaxonomyNode(childNode));
        }, {
            genomes: 0,
            genes: 0,
            bins: 0
        });
        node.model.stats = addCounts(statsFromGenome, statsFromChildren);
        return node.model.stats;
    }
    calcStatsForTaxonomyNode(taxonomy);
    taxonomyPrototype.genomes = function() {
        return this.leafNodes().map(function(species) {
            return species.model.genome;
        });
    };
    taxonomyPrototype.binCount = genomes.binCount.bind(genomes);
    taxonomyPrototype.getBin = function(idx) {
        return genomes.getBin(idx);
    };
    taxonomyPrototype.getBins = function(start, end) {
        return genomes.getBins(start, end);
    };
    taxonomyPrototype.allBins = function() {
        return genomes.allBins();
    };
    taxonomyPrototype.results = function() {
        return this.model.results;
    };
    taxonomyPrototype.stats = function() {
        return this.model.stats;
    };
    taxonomyPrototype.globalResultSetStats = function() {
        return genomes.stats;
    };
    taxonomy.setResults = function() {
        var maxProportion = 0, maxProportionNode;
        genomes.setResults.apply(genomes, arguments);
        function updateCounts(node) {
            var countFromChildren = {
                count: 0,
                bins: 0
            }, countFromGenome = {
                count: 0,
                bins: 0
            }, resultCount, geneCount, proportion;
            if (node.model.genome) countFromGenome = node.model.genome.results;
            if (node.children && node.children.length) countFromChildren = _.reduce(node.children, function(total, childNode) {
                return addCounts(total, updateCounts(childNode));
            }, {
                count: 0,
                bins: 0
            });
            node.model.results = addCounts(countFromGenome, countFromChildren);
            resultCount = node.model.results.count;
            geneCount = node.model.stats.genes;
            proportion = geneCount ? resultCount / geneCount : 0;
            node.model.results.proportion = proportion;
            if (proportion > maxProportion) {
                maxProportion = proportion;
                maxProportionNode = node;
            }
            return node.model.results;
        }
        updateCounts(taxonomy);
        genomes.stats.maxProportion = maxProportion;
        genomes.stats.maxProportionNode = maxProportionNode;
    };
    function getNodesAndReturnModel(self, predicate) {
        return (function() {
            return this.all(predicate).map(function(node) {
                return node.model;
            });
        }).call(self);
    }
    taxonomyPrototype.species = function() {
        return getNodesAndReturnModel(this, function(node) {
            return node.model.genome;
        });
    };
    taxonomyPrototype.speciesWithResults = function() {
        return getNodesAndReturnModel(this, function(node) {
            return node.model.genome && node.model.genome.results && node.model.genome.results.count;
        });
    };
}
function removeGenomesFromTaxonomy(taxonomy) {
    taxonomy.leafNodes().forEach(function(speciesNode) {
        delete speciesNode.model.genome;
    });
    [
        'results',
        'binCount',
        'setResults',
        'species'
    ].map(function(fnName) {
        delete taxonomy[fnName];
    });
}
function addGeneratorToTaxonomy(binsGenerator, taxonomy) {
    taxonomy.binParams = {};
    taxonomy.setBinType = function(methodName, param) {
        var newParams = methodName ? {
            method: methodName,
            param: param
        } : {};
        if (_.isEqual(this.binParams, newParams)) return false;
        var binFn = binsGenerator[methodName + 'BinMapper'];
        if (!binFn) {
            removeGenomesFromTaxonomy(taxonomy);
            if (_.isEqual(this.binParams, {})) return false;
            this.binParams = {};
            return true;
        }
        var genomes = binFn(param).binnedGenomes();
        this.binParams = {
            method: methodName,
            param: param
        };
        addGenomesToTaxonomy(taxonomy, genomes);
        return true;
    };
    taxonomy.removeBins = function() {
        return taxonomy.setBinType();
    };
    return taxonomy;
}
module.exports = {
    get: function(local) {
        return Q.all([
            binsPromise.get(local),
            treesPromise.get(local)
        ]).spread(addGeneratorToTaxonomy);
    },
    build: addGeneratorToTaxonomy
};

},{"9730914d7acf32a1":"b25V8","c5090ca85a6ca1e2":"hlIfA","7900f44b975fba6c":"iWYSC","1aafda790f7abfe5":"4SmGX"}],"b25V8":[function(require,module,exports,__globalThis) {
module.exports = {
    bins: require("c37caac4ac896d52"),
    binsPromise: require("895b8c564459e226")
};

},{"c37caac4ac896d52":"cVAov","895b8c564459e226":"1aNZ8"}],"1aNZ8":[function(require,module,exports,__globalThis) {
'use strict';
var Q = require("88ffaac8d4d31d99");
var bins = require("615132b47f96e46c");
module.exports = {
    get: function(local) {
        var src;
        if (local) src = Q(require("d7d4def9ef100dd6"));
        else {
            var grameneClient = require("d9f3c1ec84be9bf8").client.grameneClient;
            src = grameneClient.then(function(client) {
                var deferred, params;
                deferred = Q.defer();
                params = {
                    rows: -1,
                    type: "genome"
                };
                client['Data access'].maps(params).then(function(response) {
                    response.client = client;
                    deferred.resolve(response);
                });
                return deferred.promise;
            });
        }
        return src.then(justTheData).then(binPromise);
    }
};
function justTheData(response) {
    return response.obj;
}
function binPromise(data) {
    return Q.fcall(bins, data);
}

},{"88ffaac8d4d31d99":"iWYSC","615132b47f96e46c":"cVAov","d7d4def9ef100dd6":"bYRGX","d9f3c1ec84be9bf8":"aIXvU"}],"iWYSC":[function(require,module,exports,__globalThis) {
var process = require("a7d8f4392cc0c32b");
// vim:ts=4:sts=4:sw=4:
/*!
 *
 * Copyright 2009-2017 Kris Kowal under the terms of the MIT
 * license found at https://github.com/kriskowal/q/blob/v1/LICENSE
 *
 * With parts by Tyler Close
 * Copyright 2007-2009 Tyler Close under the terms of the MIT X license found
 * at http://www.opensource.org/licenses/mit-license.html
 * Forked at ref_send.js version: 2009-05-11
 *
 * With parts by Mark Miller
 * Copyright (C) 2011 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */ (function(definition) {
    "use strict";
    // This file will function properly as a <script> tag, or a module
    // using CommonJS and NodeJS or RequireJS module formats.  In
    // Common/Node/RequireJS, the module exports the Q API and when
    // executed as a simple <script>, it creates a Q global instead.
    // Montage Require
    if (typeof bootstrap === "function") bootstrap("promise", definition);
    else {
        var global, previousQ;
        module.exports = definition();
    }
})(function() {
    "use strict";
    var hasStacks = false;
    try {
        throw new Error();
    } catch (e) {
        hasStacks = !!e.stack;
    }
    // All code after this point will be filtered from stack traces reported
    // by Q.
    var qStartingLine = captureLine();
    var qFileName;
    // shims
    // used for fallback in "allResolved"
    var noop = function() {};
    // Use the fastest possible means to execute a task in a future turn
    // of the event loop.
    var nextTick = function() {
        // linked list of tasks (single, with head node)
        var head = {
            task: void 0,
            next: null
        };
        var tail = head;
        var flushing = false;
        var requestTick = void 0;
        var isNodeJS = false;
        // queue for late tasks, used by unhandled rejection tracking
        var laterQueue = [];
        function flush() {
            /* jshint loopfunc: true */ var task, domain;
            while(head.next){
                head = head.next;
                task = head.task;
                head.task = void 0;
                domain = head.domain;
                if (domain) {
                    head.domain = void 0;
                    domain.enter();
                }
                runSingle(task, domain);
            }
            while(laterQueue.length){
                task = laterQueue.pop();
                runSingle(task);
            }
            flushing = false;
        }
        // runs a single function in the async queue
        function runSingle(task, domain) {
            try {
                task();
            } catch (e) {
                if (isNodeJS) {
                    // In node, uncaught exceptions are considered fatal errors.
                    // Re-throw them synchronously to interrupt flushing!
                    // Ensure continuation if the uncaught exception is suppressed
                    // listening "uncaughtException" events (as domains does).
                    // Continue in next event to avoid tick recursion.
                    if (domain) domain.exit();
                    setTimeout(flush, 0);
                    if (domain) domain.enter();
                    throw e;
                } else // In browsers, uncaught exceptions are not fatal.
                // Re-throw them asynchronously to avoid slow-downs.
                setTimeout(function() {
                    throw e;
                }, 0);
            }
            if (domain) domain.exit();
        }
        nextTick = function(task) {
            tail = tail.next = {
                task: task,
                domain: isNodeJS && process.domain,
                next: null
            };
            if (!flushing) {
                flushing = true;
                requestTick();
            }
        };
        if (typeof setImmediate === "function") {
            // In IE10, Node.js 0.9+, or https://github.com/NobleJS/setImmediate
            if (typeof window !== "undefined") requestTick = setImmediate.bind(window, flush);
            else requestTick = function() {
                setImmediate(flush);
            };
        } else if (typeof MessageChannel !== "undefined") {
            // modern browsers
            // http://www.nonblocking.io/2011/06/windownexttick.html
            var channel = new MessageChannel();
            // At least Safari Version 6.0.5 (8536.30.1) intermittently cannot create
            // working message ports the first time a page loads.
            channel.port1.onmessage = function() {
                requestTick = requestPortTick;
                channel.port1.onmessage = flush;
                flush();
            };
            var requestPortTick = function() {
                // Opera requires us to provide a message payload, regardless of
                // whether we use it.
                channel.port2.postMessage(0);
            };
            requestTick = function() {
                setTimeout(flush, 0);
                requestPortTick();
            };
        } else // old browsers
        requestTick = function() {
            setTimeout(flush, 0);
        };
        // runs a task after all other tasks have been run
        // this is useful for unhandled rejection tracking that needs to happen
        // after all `then`d tasks have been run.
        nextTick.runAfter = function(task) {
            laterQueue.push(task);
            if (!flushing) {
                flushing = true;
                requestTick();
            }
        };
        return nextTick;
    }();
    // Attempt to make generics safe in the face of downstream
    // modifications.
    // There is no situation where this is necessary.
    // If you need a security guarantee, these primordials need to be
    // deeply frozen anyway, and if you don’t need a security guarantee,
    // this is just plain paranoid.
    // However, this **might** have the nice side-effect of reducing the size of
    // the minified code by reducing x.call() to merely x()
    // See Mark Miller’s explanation of what this does.
    // http://wiki.ecmascript.org/doku.php?id=conventions:safe_meta_programming
    var call = Function.call;
    function uncurryThis(f) {
        return function() {
            return call.apply(f, arguments);
        };
    }
    // This is equivalent, but slower:
    // uncurryThis = Function_bind.bind(Function_bind.call);
    // http://jsperf.com/uncurrythis
    var array_slice = uncurryThis(Array.prototype.slice);
    var array_reduce = uncurryThis(Array.prototype.reduce || function(callback, basis) {
        var index = 0, length = this.length;
        // concerning the initial value, if one is not provided
        if (arguments.length === 1) // seek to the first value in the array, accounting
        // for the possibility that is is a sparse array
        do {
            if (index in this) {
                basis = this[index++];
                break;
            }
            if (++index >= length) throw new TypeError();
        }while (1);
        // reduce
        for(; index < length; index++)// account for the possibility that the array is sparse
        if (index in this) basis = callback(basis, this[index], index);
        return basis;
    });
    var array_indexOf = uncurryThis(Array.prototype.indexOf || function(value) {
        // not a very good shim, but good enough for our one use of it
        for(var i = 0; i < this.length; i++){
            if (this[i] === value) return i;
        }
        return -1;
    });
    var array_map = uncurryThis(Array.prototype.map || function(callback, thisp) {
        var self = this;
        var collect = [];
        array_reduce(self, function(undefined1, value, index) {
            collect.push(callback.call(thisp, value, index, self));
        }, void 0);
        return collect;
    });
    var object_create = Object.create || function(prototype) {
        function Type() {}
        Type.prototype = prototype;
        return new Type();
    };
    var object_defineProperty = Object.defineProperty || function(obj, prop, descriptor) {
        obj[prop] = descriptor.value;
        return obj;
    };
    var object_hasOwnProperty = uncurryThis(Object.prototype.hasOwnProperty);
    var object_keys = Object.keys || function(object) {
        var keys = [];
        for(var key in object)if (object_hasOwnProperty(object, key)) keys.push(key);
        return keys;
    };
    var object_toString = uncurryThis(Object.prototype.toString);
    function isObject(value) {
        return value === Object(value);
    }
    // generator related shims
    // FIXME: Remove this function once ES6 generators are in SpiderMonkey.
    function isStopIteration(exception) {
        return object_toString(exception) === "[object StopIteration]" || exception instanceof QReturnValue;
    }
    // FIXME: Remove this helper and Q.return once ES6 generators are in
    // SpiderMonkey.
    var QReturnValue;
    if (typeof ReturnValue !== "undefined") QReturnValue = ReturnValue;
    else QReturnValue = function(value) {
        this.value = value;
    };
    // long stack traces
    var STACK_JUMP_SEPARATOR = "From previous event:";
    function makeStackTraceLong(error, promise) {
        // If possible, transform the error stack trace by removing Node and Q
        // cruft, then concatenating with the stack trace of `promise`. See #57.
        if (hasStacks && promise.stack && typeof error === "object" && error !== null && error.stack) {
            var stacks = [];
            for(var p = promise; !!p; p = p.source)if (p.stack && (!error.__minimumStackCounter__ || error.__minimumStackCounter__ > p.stackCounter)) {
                object_defineProperty(error, "__minimumStackCounter__", {
                    value: p.stackCounter,
                    configurable: true
                });
                stacks.unshift(p.stack);
            }
            stacks.unshift(error.stack);
            var concatedStacks = stacks.join("\n" + STACK_JUMP_SEPARATOR + "\n");
            var stack = filterStackString(concatedStacks);
            object_defineProperty(error, "stack", {
                value: stack,
                configurable: true
            });
        }
    }
    function filterStackString(stackString) {
        var lines = stackString.split("\n");
        var desiredLines = [];
        for(var i = 0; i < lines.length; ++i){
            var line = lines[i];
            if (!isInternalFrame(line) && !isNodeFrame(line) && line) desiredLines.push(line);
        }
        return desiredLines.join("\n");
    }
    function isNodeFrame(stackLine) {
        return stackLine.indexOf("(module.js:") !== -1 || stackLine.indexOf("(node.js:") !== -1;
    }
    function getFileNameAndLineNumber(stackLine) {
        // Named functions: "at functionName (filename:lineNumber:columnNumber)"
        // In IE10 function name can have spaces ("Anonymous function") O_o
        var attempt1 = /at .+ \((.+):(\d+):(?:\d+)\)$/.exec(stackLine);
        if (attempt1) return [
            attempt1[1],
            Number(attempt1[2])
        ];
        // Anonymous functions: "at filename:lineNumber:columnNumber"
        var attempt2 = /at ([^ ]+):(\d+):(?:\d+)$/.exec(stackLine);
        if (attempt2) return [
            attempt2[1],
            Number(attempt2[2])
        ];
        // Firefox style: "function@filename:lineNumber or @filename:lineNumber"
        var attempt3 = /.*@(.+):(\d+)$/.exec(stackLine);
        if (attempt3) return [
            attempt3[1],
            Number(attempt3[2])
        ];
    }
    function isInternalFrame(stackLine) {
        var fileNameAndLineNumber = getFileNameAndLineNumber(stackLine);
        if (!fileNameAndLineNumber) return false;
        var fileName = fileNameAndLineNumber[0];
        var lineNumber = fileNameAndLineNumber[1];
        return fileName === qFileName && lineNumber >= qStartingLine && lineNumber <= qEndingLine;
    }
    // discover own file name and line number range for filtering stack
    // traces
    function captureLine() {
        if (!hasStacks) return;
        try {
            throw new Error();
        } catch (e) {
            var lines = e.stack.split("\n");
            var firstLine = lines[0].indexOf("@") > 0 ? lines[1] : lines[2];
            var fileNameAndLineNumber = getFileNameAndLineNumber(firstLine);
            if (!fileNameAndLineNumber) return;
            qFileName = fileNameAndLineNumber[0];
            return fileNameAndLineNumber[1];
        }
    }
    function deprecate(callback, name, alternative) {
        return function() {
            if (typeof console !== "undefined" && typeof console.warn === "function") console.warn(name + " is deprecated, use " + alternative + " instead.", new Error("").stack);
            return callback.apply(callback, arguments);
        };
    }
    // end of shims
    // beginning of real work
    /**
 * Constructs a promise for an immediate reference, passes promises through, or
 * coerces promises from different systems.
 * @param value immediate reference or promise
 */ function Q(value) {
        // If the object is already a Promise, return it directly.  This enables
        // the resolve function to both be used to created references from objects,
        // but to tolerably coerce non-promises to promises.
        if (value instanceof Promise) return value;
        // assimilate thenables
        if (isPromiseAlike(value)) return coerce(value);
        else return fulfill(value);
    }
    Q.resolve = Q;
    /**
 * Performs a task in a future turn of the event loop.
 * @param {Function} task
 */ Q.nextTick = nextTick;
    /**
 * Controls whether or not long stack traces will be on
 */ Q.longStackSupport = false;
    /**
 * The counter is used to determine the stopping point for building
 * long stack traces. In makeStackTraceLong we walk backwards through
 * the linked list of promises, only stacks which were created before
 * the rejection are concatenated.
 */ var longStackCounter = 1;
    /**
 * Constructs a {promise, resolve, reject} object.
 *
 * `resolve` is a callback to invoke with a more resolved value for the
 * promise. To fulfill the promise, invoke `resolve` with any value that is
 * not a thenable. To reject the promise, invoke `resolve` with a rejected
 * thenable, or invoke `reject` with the reason directly. To resolve the
 * promise to another thenable, thus putting it in the same state, invoke
 * `resolve` with that other thenable.
 */ Q.defer = defer;
    function defer() {
        // if "messages" is an "Array", that indicates that the promise has not yet
        // been resolved.  If it is "undefined", it has been resolved.  Each
        // element of the messages array is itself an array of complete arguments to
        // forward to the resolved promise.  We coerce the resolution value to a
        // promise using the `resolve` function because it handles both fully
        // non-thenable values and other thenables gracefully.
        var messages = [], progressListeners = [], resolvedPromise;
        var deferred = object_create(defer.prototype);
        var promise = object_create(Promise.prototype);
        promise.promiseDispatch = function(resolve, op, operands) {
            var args = array_slice(arguments);
            if (messages) {
                messages.push(args);
                if (op === "when" && operands[1]) progressListeners.push(operands[1]);
            } else Q.nextTick(function() {
                resolvedPromise.promiseDispatch.apply(resolvedPromise, args);
            });
        };
        // XXX deprecated
        promise.valueOf = function() {
            if (messages) return promise;
            var nearerValue = nearer(resolvedPromise);
            if (isPromise(nearerValue)) resolvedPromise = nearerValue; // shorten chain
            return nearerValue;
        };
        promise.inspect = function() {
            if (!resolvedPromise) return {
                state: "pending"
            };
            return resolvedPromise.inspect();
        };
        if (Q.longStackSupport && hasStacks) try {
            throw new Error();
        } catch (e) {
            // NOTE: don't try to use `Error.captureStackTrace` or transfer the
            // accessor around; that causes memory leaks as per GH-111. Just
            // reify the stack trace as a string ASAP.
            //
            // At the same time, cut off the first line; it's always just
            // "[object Promise]\n", as per the `toString`.
            promise.stack = e.stack.substring(e.stack.indexOf("\n") + 1);
            promise.stackCounter = longStackCounter++;
        }
        // NOTE: we do the checks for `resolvedPromise` in each method, instead of
        // consolidating them into `become`, since otherwise we'd create new
        // promises with the lines `become(whatever(value))`. See e.g. GH-252.
        function become(newPromise) {
            resolvedPromise = newPromise;
            if (Q.longStackSupport && hasStacks) // Only hold a reference to the new promise if long stacks
            // are enabled to reduce memory usage
            promise.source = newPromise;
            array_reduce(messages, function(undefined1, message) {
                Q.nextTick(function() {
                    newPromise.promiseDispatch.apply(newPromise, message);
                });
            }, void 0);
            messages = void 0;
            progressListeners = void 0;
        }
        deferred.promise = promise;
        deferred.resolve = function(value) {
            if (resolvedPromise) return;
            become(Q(value));
        };
        deferred.fulfill = function(value) {
            if (resolvedPromise) return;
            become(fulfill(value));
        };
        deferred.reject = function(reason) {
            if (resolvedPromise) return;
            become(reject(reason));
        };
        deferred.notify = function(progress) {
            if (resolvedPromise) return;
            array_reduce(progressListeners, function(undefined1, progressListener) {
                Q.nextTick(function() {
                    progressListener(progress);
                });
            }, void 0);
        };
        return deferred;
    }
    /**
 * Creates a Node-style callback that will resolve or reject the deferred
 * promise.
 * @returns a nodeback
 */ defer.prototype.makeNodeResolver = function() {
        var self = this;
        return function(error, value) {
            if (error) self.reject(error);
            else if (arguments.length > 2) self.resolve(array_slice(arguments, 1));
            else self.resolve(value);
        };
    };
    /**
 * @param resolver {Function} a function that returns nothing and accepts
 * the resolve, reject, and notify functions for a deferred.
 * @returns a promise that may be resolved with the given resolve and reject
 * functions, or rejected by a thrown exception in resolver
 */ Q.Promise = promise; // ES6
    Q.promise = promise;
    function promise(resolver) {
        if (typeof resolver !== "function") throw new TypeError("resolver must be a function.");
        var deferred = defer();
        try {
            resolver(deferred.resolve, deferred.reject, deferred.notify);
        } catch (reason) {
            deferred.reject(reason);
        }
        return deferred.promise;
    }
    promise.race = race; // ES6
    promise.all = all; // ES6
    promise.reject = reject; // ES6
    promise.resolve = Q; // ES6
    // XXX experimental.  This method is a way to denote that a local value is
    // serializable and should be immediately dispatched to a remote upon request,
    // instead of passing a reference.
    Q.passByCopy = function(object) {
        //freeze(object);
        //passByCopies.set(object, true);
        return object;
    };
    Promise.prototype.passByCopy = function() {
        //freeze(object);
        //passByCopies.set(object, true);
        return this;
    };
    /**
 * If two promises eventually fulfill to the same value, promises that value,
 * but otherwise rejects.
 * @param x {Any*}
 * @param y {Any*}
 * @returns {Any*} a promise for x and y if they are the same, but a rejection
 * otherwise.
 *
 */ Q.join = function(x, y) {
        return Q(x).join(y);
    };
    Promise.prototype.join = function(that) {
        return Q([
            this,
            that
        ]).spread(function(x, y) {
            if (x === y) // TODO: "===" should be Object.is or equiv
            return x;
            else throw new Error("Q can't join: not the same: " + x + " " + y);
        });
    };
    /**
 * Returns a promise for the first of an array of promises to become settled.
 * @param answers {Array[Any*]} promises to race
 * @returns {Any*} the first promise to be settled
 */ Q.race = race;
    function race(answerPs) {
        return promise(function(resolve, reject) {
            // Switch to this once we can assume at least ES5
            // answerPs.forEach(function (answerP) {
            //     Q(answerP).then(resolve, reject);
            // });
            // Use this in the meantime
            for(var i = 0, len = answerPs.length; i < len; i++)Q(answerPs[i]).then(resolve, reject);
        });
    }
    Promise.prototype.race = function() {
        return this.then(Q.race);
    };
    /**
 * Constructs a Promise with a promise descriptor object and optional fallback
 * function.  The descriptor contains methods like when(rejected), get(name),
 * set(name, value), post(name, args), and delete(name), which all
 * return either a value, a promise for a value, or a rejection.  The fallback
 * accepts the operation name, a resolver, and any further arguments that would
 * have been forwarded to the appropriate method above had a method been
 * provided with the proper name.  The API makes no guarantees about the nature
 * of the returned object, apart from that it is usable whereever promises are
 * bought and sold.
 */ Q.makePromise = Promise;
    function Promise(descriptor, fallback, inspect) {
        if (fallback === void 0) fallback = function(op) {
            return reject(new Error("Promise does not support operation: " + op));
        };
        if (inspect === void 0) inspect = function() {
            return {
                state: "unknown"
            };
        };
        var promise = object_create(Promise.prototype);
        promise.promiseDispatch = function(resolve, op, args) {
            var result;
            try {
                if (descriptor[op]) result = descriptor[op].apply(promise, args);
                else result = fallback.call(promise, op, args);
            } catch (exception) {
                result = reject(exception);
            }
            if (resolve) resolve(result);
        };
        promise.inspect = inspect;
        // XXX deprecated `valueOf` and `exception` support
        if (inspect) {
            var inspected = inspect();
            if (inspected.state === "rejected") promise.exception = inspected.reason;
            promise.valueOf = function() {
                var inspected = inspect();
                if (inspected.state === "pending" || inspected.state === "rejected") return promise;
                return inspected.value;
            };
        }
        return promise;
    }
    Promise.prototype.toString = function() {
        return "[object Promise]";
    };
    Promise.prototype.then = function(fulfilled, rejected, progressed) {
        var self = this;
        var deferred = defer();
        var done = false; // ensure the untrusted promise makes at most a
        // single call to one of the callbacks
        function _fulfilled(value) {
            try {
                return typeof fulfilled === "function" ? fulfilled(value) : value;
            } catch (exception) {
                return reject(exception);
            }
        }
        function _rejected(exception) {
            if (typeof rejected === "function") {
                makeStackTraceLong(exception, self);
                try {
                    return rejected(exception);
                } catch (newException) {
                    return reject(newException);
                }
            }
            return reject(exception);
        }
        function _progressed(value) {
            return typeof progressed === "function" ? progressed(value) : value;
        }
        Q.nextTick(function() {
            self.promiseDispatch(function(value) {
                if (done) return;
                done = true;
                deferred.resolve(_fulfilled(value));
            }, "when", [
                function(exception) {
                    if (done) return;
                    done = true;
                    deferred.resolve(_rejected(exception));
                }
            ]);
        });
        // Progress propagator need to be attached in the current tick.
        self.promiseDispatch(void 0, "when", [
            void 0,
            function(value) {
                var newValue;
                var threw = false;
                try {
                    newValue = _progressed(value);
                } catch (e) {
                    threw = true;
                    if (Q.onerror) Q.onerror(e);
                    else throw e;
                }
                if (!threw) deferred.notify(newValue);
            }
        ]);
        return deferred.promise;
    };
    Q.tap = function(promise, callback) {
        return Q(promise).tap(callback);
    };
    /**
 * Works almost like "finally", but not called for rejections.
 * Original resolution value is passed through callback unaffected.
 * Callback may return a promise that will be awaited for.
 * @param {Function} callback
 * @returns {Q.Promise}
 * @example
 * doSomething()
 *   .then(...)
 *   .tap(console.log)
 *   .then(...);
 */ Promise.prototype.tap = function(callback) {
        callback = Q(callback);
        return this.then(function(value) {
            return callback.fcall(value).thenResolve(value);
        });
    };
    /**
 * Registers an observer on a promise.
 *
 * Guarantees:
 *
 * 1. that fulfilled and rejected will be called only once.
 * 2. that either the fulfilled callback or the rejected callback will be
 *    called, but not both.
 * 3. that fulfilled and rejected will not be called in this turn.
 *
 * @param value      promise or immediate reference to observe
 * @param fulfilled  function to be called with the fulfilled value
 * @param rejected   function to be called with the rejection exception
 * @param progressed function to be called on any progress notifications
 * @return promise for the return value from the invoked callback
 */ Q.when = when;
    function when(value, fulfilled, rejected, progressed) {
        return Q(value).then(fulfilled, rejected, progressed);
    }
    Promise.prototype.thenResolve = function(value) {
        return this.then(function() {
            return value;
        });
    };
    Q.thenResolve = function(promise, value) {
        return Q(promise).thenResolve(value);
    };
    Promise.prototype.thenReject = function(reason) {
        return this.then(function() {
            throw reason;
        });
    };
    Q.thenReject = function(promise, reason) {
        return Q(promise).thenReject(reason);
    };
    /**
 * If an object is not a promise, it is as "near" as possible.
 * If a promise is rejected, it is as "near" as possible too.
 * If it’s a fulfilled promise, the fulfillment value is nearer.
 * If it’s a deferred promise and the deferred has been resolved, the
 * resolution is "nearer".
 * @param object
 * @returns most resolved (nearest) form of the object
 */ // XXX should we re-do this?
    Q.nearer = nearer;
    function nearer(value) {
        if (isPromise(value)) {
            var inspected = value.inspect();
            if (inspected.state === "fulfilled") return inspected.value;
        }
        return value;
    }
    /**
 * @returns whether the given object is a promise.
 * Otherwise it is a fulfilled value.
 */ Q.isPromise = isPromise;
    function isPromise(object) {
        return object instanceof Promise;
    }
    Q.isPromiseAlike = isPromiseAlike;
    function isPromiseAlike(object) {
        return isObject(object) && typeof object.then === "function";
    }
    /**
 * @returns whether the given object is a pending promise, meaning not
 * fulfilled or rejected.
 */ Q.isPending = isPending;
    function isPending(object) {
        return isPromise(object) && object.inspect().state === "pending";
    }
    Promise.prototype.isPending = function() {
        return this.inspect().state === "pending";
    };
    /**
 * @returns whether the given object is a value or fulfilled
 * promise.
 */ Q.isFulfilled = isFulfilled;
    function isFulfilled(object) {
        return !isPromise(object) || object.inspect().state === "fulfilled";
    }
    Promise.prototype.isFulfilled = function() {
        return this.inspect().state === "fulfilled";
    };
    /**
 * @returns whether the given object is a rejected promise.
 */ Q.isRejected = isRejected;
    function isRejected(object) {
        return isPromise(object) && object.inspect().state === "rejected";
    }
    Promise.prototype.isRejected = function() {
        return this.inspect().state === "rejected";
    };
    //// BEGIN UNHANDLED REJECTION TRACKING
    // This promise library consumes exceptions thrown in handlers so they can be
    // handled by a subsequent promise.  The exceptions get added to this array when
    // they are created, and removed when they are handled.  Note that in ES6 or
    // shimmed environments, this would naturally be a `Set`.
    var unhandledReasons = [];
    var unhandledRejections = [];
    var reportedUnhandledRejections = [];
    var trackUnhandledRejections = true;
    function resetUnhandledRejections() {
        unhandledReasons.length = 0;
        unhandledRejections.length = 0;
        if (!trackUnhandledRejections) trackUnhandledRejections = true;
    }
    function trackRejection(promise, reason) {
        if (!trackUnhandledRejections) return;
        unhandledRejections.push(promise);
        if (reason && typeof reason.stack !== "undefined") unhandledReasons.push(reason.stack);
        else unhandledReasons.push("(no stack) " + reason);
    }
    function untrackRejection(promise) {
        if (!trackUnhandledRejections) return;
        var at = array_indexOf(unhandledRejections, promise);
        if (at !== -1) {
            unhandledRejections.splice(at, 1);
            unhandledReasons.splice(at, 1);
        }
    }
    Q.resetUnhandledRejections = resetUnhandledRejections;
    Q.getUnhandledReasons = function() {
        // Make a copy so that consumers can't interfere with our internal state.
        return unhandledReasons.slice();
    };
    Q.stopUnhandledRejectionTracking = function() {
        resetUnhandledRejections();
        trackUnhandledRejections = false;
    };
    resetUnhandledRejections();
    //// END UNHANDLED REJECTION TRACKING
    /**
 * Constructs a rejected promise.
 * @param reason value describing the failure
 */ Q.reject = reject;
    function reject(reason) {
        var rejection = Promise({
            "when": function(rejected) {
                // note that the error has been handled
                if (rejected) untrackRejection(this);
                return rejected ? rejected(reason) : this;
            }
        }, function fallback() {
            return this;
        }, function inspect() {
            return {
                state: "rejected",
                reason: reason
            };
        });
        // Note that the reason has not been handled.
        trackRejection(rejection, reason);
        return rejection;
    }
    /**
 * Constructs a fulfilled promise for an immediate reference.
 * @param value immediate reference
 */ Q.fulfill = fulfill;
    function fulfill(value) {
        return Promise({
            "when": function() {
                return value;
            },
            "get": function(name) {
                return value[name];
            },
            "set": function(name, rhs) {
                value[name] = rhs;
            },
            "delete": function(name) {
                delete value[name];
            },
            "post": function(name, args) {
                // Mark Miller proposes that post with no name should apply a
                // promised function.
                if (name === null || name === void 0) return value.apply(void 0, args);
                else return value[name].apply(value, args);
            },
            "apply": function(thisp, args) {
                return value.apply(thisp, args);
            },
            "keys": function() {
                return object_keys(value);
            }
        }, void 0, function inspect() {
            return {
                state: "fulfilled",
                value: value
            };
        });
    }
    /**
 * Converts thenables to Q promises.
 * @param promise thenable promise
 * @returns a Q promise
 */ function coerce(promise) {
        var deferred = defer();
        Q.nextTick(function() {
            try {
                promise.then(deferred.resolve, deferred.reject, deferred.notify);
            } catch (exception) {
                deferred.reject(exception);
            }
        });
        return deferred.promise;
    }
    /**
 * Annotates an object such that it will never be
 * transferred away from this process over any promise
 * communication channel.
 * @param object
 * @returns promise a wrapping of that object that
 * additionally responds to the "isDef" message
 * without a rejection.
 */ Q.master = master;
    function master(object) {
        return Promise({
            "isDef": function() {}
        }, function fallback(op, args) {
            return dispatch(object, op, args);
        }, function() {
            return Q(object).inspect();
        });
    }
    /**
 * Spreads the values of a promised array of arguments into the
 * fulfillment callback.
 * @param fulfilled callback that receives variadic arguments from the
 * promised array
 * @param rejected callback that receives the exception if the promise
 * is rejected.
 * @returns a promise for the return value or thrown exception of
 * either callback.
 */ Q.spread = spread;
    function spread(value, fulfilled, rejected) {
        return Q(value).spread(fulfilled, rejected);
    }
    Promise.prototype.spread = function(fulfilled, rejected) {
        return this.all().then(function(array) {
            return fulfilled.apply(void 0, array);
        }, rejected);
    };
    /**
 * The async function is a decorator for generator functions, turning
 * them into asynchronous generators.  Although generators are only part
 * of the newest ECMAScript 6 drafts, this code does not cause syntax
 * errors in older engines.  This code should continue to work and will
 * in fact improve over time as the language improves.
 *
 * ES6 generators are currently part of V8 version 3.19 with the
 * --harmony-generators runtime flag enabled.  SpiderMonkey has had them
 * for longer, but under an older Python-inspired form.  This function
 * works on both kinds of generators.
 *
 * Decorates a generator function such that:
 *  - it may yield promises
 *  - execution will continue when that promise is fulfilled
 *  - the value of the yield expression will be the fulfilled value
 *  - it returns a promise for the return value (when the generator
 *    stops iterating)
 *  - the decorated function returns a promise for the return value
 *    of the generator or the first rejected promise among those
 *    yielded.
 *  - if an error is thrown in the generator, it propagates through
 *    every following yield until it is caught, or until it escapes
 *    the generator function altogether, and is translated into a
 *    rejection for the promise returned by the decorated generator.
 */ Q.async = async;
    function async(makeGenerator) {
        return function() {
            // when verb is "send", arg is a value
            // when verb is "throw", arg is an exception
            function continuer(verb, arg) {
                var result;
                // Until V8 3.19 / Chromium 29 is released, SpiderMonkey is the only
                // engine that has a deployed base of browsers that support generators.
                // However, SM's generators use the Python-inspired semantics of
                // outdated ES6 drafts.  We would like to support ES6, but we'd also
                // like to make it possible to use generators in deployed browsers, so
                // we also support Python-style generators.  At some point we can remove
                // this block.
                if (typeof StopIteration === "undefined") {
                    // ES6 Generators
                    try {
                        result = generator[verb](arg);
                    } catch (exception) {
                        return reject(exception);
                    }
                    if (result.done) return Q(result.value);
                    else return when(result.value, callback, errback);
                } else {
                    // SpiderMonkey Generators
                    // FIXME: Remove this case when SM does ES6 generators.
                    try {
                        result = generator[verb](arg);
                    } catch (exception) {
                        if (isStopIteration(exception)) return Q(exception.value);
                        else return reject(exception);
                    }
                    return when(result, callback, errback);
                }
            }
            var generator = makeGenerator.apply(this, arguments);
            var callback = continuer.bind(continuer, "next");
            var errback = continuer.bind(continuer, "throw");
            return callback();
        };
    }
    /**
 * The spawn function is a small wrapper around async that immediately
 * calls the generator and also ends the promise chain, so that any
 * unhandled errors are thrown instead of forwarded to the error
 * handler. This is useful because it's extremely common to run
 * generators at the top-level to work with libraries.
 */ Q.spawn = spawn;
    function spawn(makeGenerator) {
        Q.done(Q.async(makeGenerator)());
    }
    // FIXME: Remove this interface once ES6 generators are in SpiderMonkey.
    /**
 * Throws a ReturnValue exception to stop an asynchronous generator.
 *
 * This interface is a stop-gap measure to support generator return
 * values in older Firefox/SpiderMonkey.  In browsers that support ES6
 * generators like Chromium 29, just use "return" in your generator
 * functions.
 *
 * @param value the return value for the surrounding generator
 * @throws ReturnValue exception with the value.
 * @example
 * // ES6 style
 * Q.async(function* () {
 *      var foo = yield getFooPromise();
 *      var bar = yield getBarPromise();
 *      return foo + bar;
 * })
 * // Older SpiderMonkey style
 * Q.async(function () {
 *      var foo = yield getFooPromise();
 *      var bar = yield getBarPromise();
 *      Q.return(foo + bar);
 * })
 */ Q["return"] = _return;
    function _return(value) {
        throw new QReturnValue(value);
    }
    /**
 * The promised function decorator ensures that any promise arguments
 * are settled and passed as values (`this` is also settled and passed
 * as a value).  It will also ensure that the result of a function is
 * always a promise.
 *
 * @example
 * var add = Q.promised(function (a, b) {
 *     return a + b;
 * });
 * add(Q(a), Q(B));
 *
 * @param {function} callback The function to decorate
 * @returns {function} a function that has been decorated.
 */ Q.promised = promised;
    function promised(callback) {
        return function() {
            return spread([
                this,
                all(arguments)
            ], function(self, args) {
                return callback.apply(self, args);
            });
        };
    }
    /**
 * sends a message to a value in a future turn
 * @param object* the recipient
 * @param op the name of the message operation, e.g., "when",
 * @param args further arguments to be forwarded to the operation
 * @returns result {Promise} a promise for the result of the operation
 */ Q.dispatch = dispatch;
    function dispatch(object, op, args) {
        return Q(object).dispatch(op, args);
    }
    Promise.prototype.dispatch = function(op, args) {
        var self = this;
        var deferred = defer();
        Q.nextTick(function() {
            self.promiseDispatch(deferred.resolve, op, args);
        });
        return deferred.promise;
    };
    /**
 * Gets the value of a property in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of property to get
 * @return promise for the property value
 */ Q.get = function(object, key) {
        return Q(object).dispatch("get", [
            key
        ]);
    };
    Promise.prototype.get = function(key) {
        return this.dispatch("get", [
            key
        ]);
    };
    /**
 * Sets the value of a property in a future turn.
 * @param object    promise or immediate reference for object object
 * @param name      name of property to set
 * @param value     new value of property
 * @return promise for the return value
 */ Q.set = function(object, key, value) {
        return Q(object).dispatch("set", [
            key,
            value
        ]);
    };
    Promise.prototype.set = function(key, value) {
        return this.dispatch("set", [
            key,
            value
        ]);
    };
    /**
 * Deletes a property in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of property to delete
 * @return promise for the return value
 */ Q.del = Q["delete"] = function(object, key) {
        return Q(object).dispatch("delete", [
            key
        ]);
    };
    Promise.prototype.del = Promise.prototype["delete"] = function(key) {
        return this.dispatch("delete", [
            key
        ]);
    };
    /**
 * Invokes a method in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of method to invoke
 * @param value     a value to post, typically an array of
 *                  invocation arguments for promises that
 *                  are ultimately backed with `resolve` values,
 *                  as opposed to those backed with URLs
 *                  wherein the posted value can be any
 *                  JSON serializable object.
 * @return promise for the return value
 */ // bound locally because it is used by other methods
    Q.mapply = Q.post = function(object, name, args) {
        return Q(object).dispatch("post", [
            name,
            args
        ]);
    };
    Promise.prototype.mapply = Promise.prototype.post = function(name, args) {
        return this.dispatch("post", [
            name,
            args
        ]);
    };
    /**
 * Invokes a method in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of method to invoke
 * @param ...args   array of invocation arguments
 * @return promise for the return value
 */ Q.send = Q.mcall = Q.invoke = function(object, name /*...args*/ ) {
        return Q(object).dispatch("post", [
            name,
            array_slice(arguments, 2)
        ]);
    };
    Promise.prototype.send = Promise.prototype.mcall = Promise.prototype.invoke = function(name /*...args*/ ) {
        return this.dispatch("post", [
            name,
            array_slice(arguments, 1)
        ]);
    };
    /**
 * Applies the promised function in a future turn.
 * @param object    promise or immediate reference for target function
 * @param args      array of application arguments
 */ Q.fapply = function(object, args) {
        return Q(object).dispatch("apply", [
            void 0,
            args
        ]);
    };
    Promise.prototype.fapply = function(args) {
        return this.dispatch("apply", [
            void 0,
            args
        ]);
    };
    /**
 * Calls the promised function in a future turn.
 * @param object    promise or immediate reference for target function
 * @param ...args   array of application arguments
 */ Q["try"] = Q.fcall = function(object /* ...args*/ ) {
        return Q(object).dispatch("apply", [
            void 0,
            array_slice(arguments, 1)
        ]);
    };
    Promise.prototype.fcall = function() {
        return this.dispatch("apply", [
            void 0,
            array_slice(arguments)
        ]);
    };
    /**
 * Binds the promised function, transforming return values into a fulfilled
 * promise and thrown errors into a rejected one.
 * @param object    promise or immediate reference for target function
 * @param ...args   array of application arguments
 */ Q.fbind = function(object /*...args*/ ) {
        var promise = Q(object);
        var args = array_slice(arguments, 1);
        return function fbound() {
            return promise.dispatch("apply", [
                this,
                args.concat(array_slice(arguments))
            ]);
        };
    };
    Promise.prototype.fbind = function() {
        var promise = this;
        var args = array_slice(arguments);
        return function fbound() {
            return promise.dispatch("apply", [
                this,
                args.concat(array_slice(arguments))
            ]);
        };
    };
    /**
 * Requests the names of the owned properties of a promised
 * object in a future turn.
 * @param object    promise or immediate reference for target object
 * @return promise for the keys of the eventually settled object
 */ Q.keys = function(object) {
        return Q(object).dispatch("keys", []);
    };
    Promise.prototype.keys = function() {
        return this.dispatch("keys", []);
    };
    /**
 * Turns an array of promises into a promise for an array.  If any of
 * the promises gets rejected, the whole array is rejected immediately.
 * @param {Array*} an array (or promise for an array) of values (or
 * promises for values)
 * @returns a promise for an array of the corresponding values
 */ // By Mark Miller
    // http://wiki.ecmascript.org/doku.php?id=strawman:concurrency&rev=1308776521#allfulfilled
    Q.all = all;
    function all(promises) {
        return when(promises, function(promises) {
            var pendingCount = 0;
            var deferred = defer();
            array_reduce(promises, function(undefined1, promise, index) {
                var snapshot;
                if (isPromise(promise) && (snapshot = promise.inspect()).state === "fulfilled") promises[index] = snapshot.value;
                else {
                    ++pendingCount;
                    when(promise, function(value) {
                        promises[index] = value;
                        if (--pendingCount === 0) deferred.resolve(promises);
                    }, deferred.reject, function(progress) {
                        deferred.notify({
                            index: index,
                            value: progress
                        });
                    });
                }
            }, void 0);
            if (pendingCount === 0) deferred.resolve(promises);
            return deferred.promise;
        });
    }
    Promise.prototype.all = function() {
        return all(this);
    };
    /**
 * Returns the first resolved promise of an array. Prior rejected promises are
 * ignored.  Rejects only if all promises are rejected.
 * @param {Array*} an array containing values or promises for values
 * @returns a promise fulfilled with the value of the first resolved promise,
 * or a rejected promise if all promises are rejected.
 */ Q.any = any;
    function any(promises) {
        if (promises.length === 0) return Q.resolve();
        var deferred = Q.defer();
        var pendingCount = 0;
        array_reduce(promises, function(prev, current, index) {
            var promise = promises[index];
            pendingCount++;
            when(promise, onFulfilled, onRejected, onProgress);
            function onFulfilled(result) {
                deferred.resolve(result);
            }
            function onRejected(err) {
                pendingCount--;
                if (pendingCount === 0) {
                    var rejection = err || new Error("" + err);
                    rejection.message = "Q can't get fulfillment value from any promise, all promises were rejected. Last error message: " + rejection.message;
                    deferred.reject(rejection);
                }
            }
            function onProgress(progress) {
                deferred.notify({
                    index: index,
                    value: progress
                });
            }
        }, undefined);
        return deferred.promise;
    }
    Promise.prototype.any = function() {
        return any(this);
    };
    /**
 * Waits for all promises to be settled, either fulfilled or
 * rejected.  This is distinct from `all` since that would stop
 * waiting at the first rejection.  The promise returned by
 * `allResolved` will never be rejected.
 * @param promises a promise for an array (or an array) of promises
 * (or values)
 * @return a promise for an array of promises
 */ Q.allResolved = deprecate(allResolved, "allResolved", "allSettled");
    function allResolved(promises) {
        return when(promises, function(promises) {
            promises = array_map(promises, Q);
            return when(all(array_map(promises, function(promise) {
                return when(promise, noop, noop);
            })), function() {
                return promises;
            });
        });
    }
    Promise.prototype.allResolved = function() {
        return allResolved(this);
    };
    /**
 * @see Promise#allSettled
 */ Q.allSettled = allSettled;
    function allSettled(promises) {
        return Q(promises).allSettled();
    }
    /**
 * Turns an array of promises into a promise for an array of their states (as
 * returned by `inspect`) when they have all settled.
 * @param {Array[Any*]} values an array (or promise for an array) of values (or
 * promises for values)
 * @returns {Array[State]} an array of states for the respective values.
 */ Promise.prototype.allSettled = function() {
        return this.then(function(promises) {
            return all(array_map(promises, function(promise) {
                promise = Q(promise);
                function regardless() {
                    return promise.inspect();
                }
                return promise.then(regardless, regardless);
            }));
        });
    };
    /**
 * Captures the failure of a promise, giving an oportunity to recover
 * with a callback.  If the given promise is fulfilled, the returned
 * promise is fulfilled.
 * @param {Any*} promise for something
 * @param {Function} callback to fulfill the returned promise if the
 * given promise is rejected
 * @returns a promise for the return value of the callback
 */ Q.fail = Q["catch"] = function(object, rejected) {
        return Q(object).then(void 0, rejected);
    };
    Promise.prototype.fail = Promise.prototype["catch"] = function(rejected) {
        return this.then(void 0, rejected);
    };
    /**
 * Attaches a listener that can respond to progress notifications from a
 * promise's originating deferred. This listener receives the exact arguments
 * passed to ``deferred.notify``.
 * @param {Any*} promise for something
 * @param {Function} callback to receive any progress notifications
 * @returns the given promise, unchanged
 */ Q.progress = progress;
    function progress(object, progressed) {
        return Q(object).then(void 0, void 0, progressed);
    }
    Promise.prototype.progress = function(progressed) {
        return this.then(void 0, void 0, progressed);
    };
    /**
 * Provides an opportunity to observe the settling of a promise,
 * regardless of whether the promise is fulfilled or rejected.  Forwards
 * the resolution to the returned promise when the callback is done.
 * The callback can return a promise to defer completion.
 * @param {Any*} promise
 * @param {Function} callback to observe the resolution of the given
 * promise, takes no arguments.
 * @returns a promise for the resolution of the given promise when
 * ``fin`` is done.
 */ Q.fin = Q["finally"] = function(object, callback) {
        return Q(object)["finally"](callback);
    };
    Promise.prototype.fin = Promise.prototype["finally"] = function(callback) {
        if (!callback || typeof callback.apply !== "function") throw new Error("Q can't apply finally callback");
        callback = Q(callback);
        return this.then(function(value) {
            return callback.fcall().then(function() {
                return value;
            });
        }, function(reason) {
            // TODO attempt to recycle the rejection with "this".
            return callback.fcall().then(function() {
                throw reason;
            });
        });
    };
    /**
 * Terminates a chain of promises, forcing rejections to be
 * thrown as exceptions.
 * @param {Any*} promise at the end of a chain of promises
 * @returns nothing
 */ Q.done = function(object, fulfilled, rejected, progress) {
        return Q(object).done(fulfilled, rejected, progress);
    };
    Promise.prototype.done = function(fulfilled, rejected, progress) {
        var onUnhandledError = function(error) {
            // forward to a future turn so that ``when``
            // does not catch it and turn it into a rejection.
            Q.nextTick(function() {
                makeStackTraceLong(error, promise);
                if (Q.onerror) Q.onerror(error);
                else throw error;
            });
        };
        // Avoid unnecessary `nextTick`ing via an unnecessary `when`.
        var promise = fulfilled || rejected || progress ? this.then(fulfilled, rejected, progress) : this;
        promise.then(void 0, onUnhandledError);
    };
    /**
 * Causes a promise to be rejected if it does not get fulfilled before
 * some milliseconds time out.
 * @param {Any*} promise
 * @param {Number} milliseconds timeout
 * @param {Any*} custom error message or Error object (optional)
 * @returns a promise for the resolution of the given promise if it is
 * fulfilled before the timeout, otherwise rejected.
 */ Q.timeout = function(object, ms, error) {
        return Q(object).timeout(ms, error);
    };
    Promise.prototype.timeout = function(ms, error) {
        var deferred = defer();
        var timeoutId = setTimeout(function() {
            if (!error || "string" === typeof error) {
                error = new Error(error || "Timed out after " + ms + " ms");
                error.code = "ETIMEDOUT";
            }
            deferred.reject(error);
        }, ms);
        this.then(function(value) {
            clearTimeout(timeoutId);
            deferred.resolve(value);
        }, function(exception) {
            clearTimeout(timeoutId);
            deferred.reject(exception);
        }, deferred.notify);
        return deferred.promise;
    };
    /**
 * Returns a promise for the given value (or promised value), some
 * milliseconds after it resolved. Passes rejections immediately.
 * @param {Any*} promise
 * @param {Number} milliseconds
 * @returns a promise for the resolution of the given promise after milliseconds
 * time has elapsed since the resolution of the given promise.
 * If the given promise rejects, that is passed immediately.
 */ Q.delay = function(object, timeout) {
        if (timeout === void 0) {
            timeout = object;
            object = void 0;
        }
        return Q(object).delay(timeout);
    };
    Promise.prototype.delay = function(timeout) {
        return this.then(function(value) {
            var deferred = defer();
            setTimeout(function() {
                deferred.resolve(value);
            }, timeout);
            return deferred.promise;
        });
    };
    /**
 * Passes a continuation to a Node function, which is called with the given
 * arguments provided as an array, and returns a promise.
 *
 *      Q.nfapply(FS.readFile, [__filename])
 *      .then(function (content) {
 *      })
 *
 */ Q.nfapply = function(callback, args) {
        return Q(callback).nfapply(args);
    };
    Promise.prototype.nfapply = function(args) {
        var deferred = defer();
        var nodeArgs = array_slice(args);
        nodeArgs.push(deferred.makeNodeResolver());
        this.fapply(nodeArgs).fail(deferred.reject);
        return deferred.promise;
    };
    /**
 * Passes a continuation to a Node function, which is called with the given
 * arguments provided individually, and returns a promise.
 * @example
 * Q.nfcall(FS.readFile, __filename)
 * .then(function (content) {
 * })
 *
 */ Q.nfcall = function(callback /*...args*/ ) {
        var args = array_slice(arguments, 1);
        return Q(callback).nfapply(args);
    };
    Promise.prototype.nfcall = function() {
        var nodeArgs = array_slice(arguments);
        var deferred = defer();
        nodeArgs.push(deferred.makeNodeResolver());
        this.fapply(nodeArgs).fail(deferred.reject);
        return deferred.promise;
    };
    /**
 * Wraps a NodeJS continuation passing function and returns an equivalent
 * version that returns a promise.
 * @example
 * Q.nfbind(FS.readFile, __filename)("utf-8")
 * .then(console.log)
 * .done()
 */ Q.nfbind = Q.denodeify = function(callback /*...args*/ ) {
        if (callback === undefined) throw new Error("Q can't wrap an undefined function");
        var baseArgs = array_slice(arguments, 1);
        return function() {
            var nodeArgs = baseArgs.concat(array_slice(arguments));
            var deferred = defer();
            nodeArgs.push(deferred.makeNodeResolver());
            Q(callback).fapply(nodeArgs).fail(deferred.reject);
            return deferred.promise;
        };
    };
    Promise.prototype.nfbind = Promise.prototype.denodeify = function() {
        var args = array_slice(arguments);
        args.unshift(this);
        return Q.denodeify.apply(void 0, args);
    };
    Q.nbind = function(callback, thisp /*...args*/ ) {
        var baseArgs = array_slice(arguments, 2);
        return function() {
            var nodeArgs = baseArgs.concat(array_slice(arguments));
            var deferred = defer();
            nodeArgs.push(deferred.makeNodeResolver());
            function bound() {
                return callback.apply(thisp, arguments);
            }
            Q(bound).fapply(nodeArgs).fail(deferred.reject);
            return deferred.promise;
        };
    };
    Promise.prototype.nbind = function() {
        var args = array_slice(arguments, 0);
        args.unshift(this);
        return Q.nbind.apply(void 0, args);
    };
    /**
 * Calls a method of a Node-style object that accepts a Node-style
 * callback with a given array of arguments, plus a provided callback.
 * @param object an object that has the named method
 * @param {String} name name of the method of object
 * @param {Array} args arguments to pass to the method; the callback
 * will be provided by Q and appended to these arguments.
 * @returns a promise for the value or error
 */ Q.nmapply = Q.npost = function(object, name, args) {
        return Q(object).npost(name, args);
    };
    Promise.prototype.nmapply = Promise.prototype.npost = function(name, args) {
        var nodeArgs = array_slice(args || []);
        var deferred = defer();
        nodeArgs.push(deferred.makeNodeResolver());
        this.dispatch("post", [
            name,
            nodeArgs
        ]).fail(deferred.reject);
        return deferred.promise;
    };
    /**
 * Calls a method of a Node-style object that accepts a Node-style
 * callback, forwarding the given variadic arguments, plus a provided
 * callback argument.
 * @param object an object that has the named method
 * @param {String} name name of the method of object
 * @param ...args arguments to pass to the method; the callback will
 * be provided by Q and appended to these arguments.
 * @returns a promise for the value or error
 */ Q.nsend = Q.nmcall = Q.ninvoke = function(object, name /*...args*/ ) {
        var nodeArgs = array_slice(arguments, 2);
        var deferred = defer();
        nodeArgs.push(deferred.makeNodeResolver());
        Q(object).dispatch("post", [
            name,
            nodeArgs
        ]).fail(deferred.reject);
        return deferred.promise;
    };
    Promise.prototype.nsend = Promise.prototype.nmcall = Promise.prototype.ninvoke = function(name /*...args*/ ) {
        var nodeArgs = array_slice(arguments, 1);
        var deferred = defer();
        nodeArgs.push(deferred.makeNodeResolver());
        this.dispatch("post", [
            name,
            nodeArgs
        ]).fail(deferred.reject);
        return deferred.promise;
    };
    /**
 * If a function would like to support both Node continuation-passing-style and
 * promise-returning-style, it can end its internal promise chain with
 * `nodeify(nodeback)`, forwarding the optional nodeback argument.  If the user
 * elects to use a nodeback, the result will be sent there.  If they do not
 * pass a nodeback, they will receive the result promise.
 * @param object a result (or a promise for a result)
 * @param {Function} nodeback a Node.js-style callback
 * @returns either the promise or nothing
 */ Q.nodeify = nodeify;
    function nodeify(object, nodeback) {
        return Q(object).nodeify(nodeback);
    }
    Promise.prototype.nodeify = function(nodeback) {
        if (nodeback) this.then(function(value) {
            Q.nextTick(function() {
                nodeback(null, value);
            });
        }, function(error) {
            Q.nextTick(function() {
                nodeback(error);
            });
        });
        else return this;
    };
    Q.noConflict = function() {
        throw new Error("Q.noConflict only works when Q is used as a global");
    };
    // All code before this point will be filtered from stack traces.
    var qEndingLine = captureLine();
    return Q;
});

},{"a7d8f4392cc0c32b":"4jeNM"}],"4jeNM":[function(require,module,exports,__globalThis) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
process.cwd = function() {
    return '/';
};
process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() {
    return 0;
};

},{}],"bYRGX":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"obj\":[{\"_id\":\"GCA_000091205.1\",\"db\":\"cyanidioschyzon_merolae_core_48_82_1\",\"taxon_id\":280699,\"system_name\":\"cyanidioschyzon_merolae\",\"type\":\"genome\",\"length\":16728945,\"regions\":{\"names\":[\"1\",\"2\",\"3\",\"4\",\"5\",\"6\",\"7\",\"8\",\"9\",\"10\",\"11\",\"12\",\"13\",\"14\",\"15\",\"16\",\"17\",\"18\",\"19\",\"20\",\"Mito\",\"Chloro\"],\"lengths\":[422616,457013,481791,513455,528682,536163,584452,739753,810151,839707,852849,859119,866983,852727,902900,908485,1232258,1253087,1282939,1621617,32211,149987]},\"num_genes\":5106},{\"_id\":\"GCA_000001735.1\",\"db\":\"arabidopsis_thaliana_core_48_82_10\",\"taxon_id\":3702,\"system_name\":\"arabidopsis_thaliana\",\"type\":\"genome\",\"length\":119667750,\"regions\":{\"names\":[\"1\",\"2\",\"3\",\"4\",\"5\",\"Mt\",\"Pt\"],\"lengths\":[30427671,19698289,23459830,18585056,26975502,366924,154478]},\"num_genes\":33602},{\"_id\":\"GCA_000005505.1\",\"db\":\"brachypodium_distachyon_core_48_82_12\",\"taxon_id\":15368,\"system_name\":\"brachypodium_distachyon\",\"type\":\"genome\",\"length\":271148425,\"regions\":{\"names\":[\"1\",\"2\",\"3\",\"4\",\"5\",\"UNANCHORED\"],\"lengths\":[74834646,59328898,59892396,48648102,28444383,774881]},\"num_genes\":26552},{\"_id\":\"GCA_000092065.1\",\"db\":\"ostreococcus_lucimarinus_core_48_82_1\",\"taxon_id\":436017,\"system_name\":\"ostreococcus_lucimarinus\",\"type\":\"genome\",\"length\":13204888,\"regions\":{\"names\":[\"1\",\"2\",\"3\",\"4\",\"5\",\"6\",\"7\",\"8\",\"9\",\"10\",\"11\",\"12\",\"13\",\"14\",\"15\",\"16\",\"17\",\"18\",\"19\",\"20\",\"21\"],\"lengths\":[1152508,895087,982987,930724,847696,818664,783246,701771,670853,613585,593542,538963,528469,708927,468366,428333,366173,149386,154676,549133,321799]},\"num_genes\":7640},{\"_id\":\"GCA_000338895.2\",\"db\":\"oryza_meridionalis_core_48_82_13\",\"taxon_id\":40149,\"system_name\":\"oryza_meridionalis\",\"type\":\"genome\",\"length\":0,\"regions\":{\"names\":[\"UNANCHORED\"],\"lengths\":[335668232]},\"num_genes\":31591},{\"_id\":\"GCA_000003745.2\",\"db\":\"vitis_vinifera_core_48_82_3\",\"taxon_id\":29760,\"system_name\":\"vitis_vinifera\",\"type\":\"genome\",\"length\":426176009,\"regions\":{\"names\":[\"1\",\"2\",\"3\",\"4\",\"5\",\"6\",\"7\",\"8\",\"9\",\"10\",\"11\",\"12\",\"13\",\"14\",\"15\",\"16\",\"17\",\"18\",\"19\",\"UNANCHORED\"],\"lengths\":[23037639,18779844,19341862,23867706,25021643,21508407,21026613,22385789,23006712,18140952,19818926,22702307,24396255,30274277,20304914,22053297,17126926,29360087,24021853,60089413]},\"num_genes\":29971},{\"_id\":\"GCA_000576495.1\",\"db\":\"oryza_glumaepatula_core_48_82_15\",\"taxon_id\":40148,\"system_name\":\"oryza_glumaepatula\",\"type\":\"genome\",\"length\":372860283,\"regions\":{\"names\":[\"1\",\"2\",\"3\",\"4\",\"5\",\"6\",\"7\",\"8\",\"9\",\"10\",\"11\",\"12\"],\"lengths\":[46529941,38039368,37594838,32884216,30429317,31548187,28350858,27185770,23490084,22967634,27098305,26741765]},\"num_genes\":39018},{\"_id\":\"GCA_000005425.2\",\"db\":\"oryza_sativa_core_48_82_7\",\"taxon_id\":39947,\"system_name\":\"oryza_sativa\",\"type\":\"genome\",\"length\":373245519,\"regions\":{\"names\":[\"1\",\"2\",\"3\",\"4\",\"5\",\"6\",\"7\",\"8\",\"9\",\"10\",\"11\",\"12\",\"UNANCHORED\"],\"lengths\":[43270923,35937250,36413819,35502694,29958434,31248787,29697621,28443022,23012720,23207287,29021106,27531856,1178721]},\"num_genes\":91080},{\"_id\":\"PRJEB4137\",\"db\":\"oryza_rufipogon_core_48_82_11\",\"taxon_id\":4529,\"system_name\":\"oryza_rufipogon\",\"type\":\"genome\",\"length\":338040714,\"regions\":{\"names\":[\"1\",\"2\",\"3\",\"4\",\"5\",\"6\",\"7\",\"8\",\"9\",\"10\",\"11\",\"12\"],\"lengths\":[39866532,33962743,34446443,30521686,26652778,27870862,26200591,25958679,20482102,20731201,27785585,23561512]},\"num_genes\":39799},{\"_id\":\"GCA_000576065.1\",\"db\":\"oryza_nivara_core_48_82_10\",\"taxon_id\":4536,\"system_name\":\"oryza_nivara\",\"type\":\"genome\",\"length\":337950324,\"regions\":{\"names\":[\"1\",\"2\",\"3\",\"4\",\"5\",\"6\",\"7\",\"8\",\"9\",\"10\",\"11\",\"12\"],\"lengths\":[42845077,35065507,36134596,28646061,28014461,29411429,24717764,26703665,20407407,21549876,24378308,20076173]},\"num_genes\":37985},{\"_id\":\"GCA_000325765.3\",\"db\":\"leersia_perrieri_core_48_82_14\",\"taxon_id\":77586,\"system_name\":\"leersia_perrieri\",\"type\":\"genome\",\"length\":266687832,\"regions\":{\"names\":[\"1\",\"2\",\"3\",\"4\",\"5\",\"6\",\"7\",\"8\",\"9\",\"10\",\"11\",\"12\"],\"lengths\":[32922458,26406337,29602667,23326293,20807039,21016138,22540073,20165712,15534364,15557830,21046960,17761961]},\"num_genes\":30615},{\"_id\":\"GCA_000002595.2\",\"db\":\"chlamydomonas_reinhardtii_core_48_82_1\",\"taxon_id\":3055,\"system_name\":\"chlamydomonas_reinhardtii\",\"type\":\"genome\",\"length\":0,\"regions\":{\"names\":[\"UNANCHORED\"],\"lengths\":[120404952]},\"num_genes\":14487},{\"_id\":\"GCA_000313855.1\",\"db\":\"musa_acuminata_core_48_82_1\",\"taxon_id\":214687,\"system_name\":\"musa_acuminata\",\"type\":\"genome\",\"length\":331812599,\"regions\":{\"names\":[\"1\",\"2\",\"3\",\"4\",\"5\",\"6\",\"7\",\"8\",\"9\",\"10\",\"11\",\"UNANCHORED\"],\"lengths\":[27573629,22054697,30470407,30051516,29377369,34899179,28617404,35439739,34148863,33665772,25514024,141147818]},\"num_genes\":37579},{\"_id\":\"GCA_000573905.1\",\"db\":\"oryza_punctata_core_48_82_12\",\"taxon_id\":4537,\"system_name\":\"oryza_punctata\",\"type\":\"genome\",\"length\":393816603,\"regions\":{\"names\":[\"1\",\"2\",\"3\",\"4\",\"5\",\"6\",\"7\",\"8\",\"9\",\"10\",\"11\",\"12\"],\"lengths\":[46096743,39559433,38925377,33711903,31082981,34615992,31244610,29853973,26294017,25992119,28494620,27944835]},\"num_genes\":36957},{\"_id\":\"GCA_000182155.2\",\"db\":\"oryza_barthii_core_48_82_3\",\"taxon_id\":65489,\"system_name\":\"oryza_barthii\",\"type\":\"genome\",\"length\":308272304,\"regions\":{\"names\":[\"1\",\"2\",\"3\",\"4\",\"5\",\"6\",\"7\",\"8\",\"9\",\"10\",\"11\",\"12\"],\"lengths\":[36915442,31686972,33311619,27574323,24206129,25711811,24128185,22678724,19219615,19274048,23014695,20550741]},\"num_genes\":36899},{\"_id\":\"GCA_000346465.1\",\"db\":\"prunus_persica_core_48_82_1\",\"taxon_id\":3760,\"system_name\":\"prunus_persica\",\"type\":\"genome\",\"length\":0,\"regions\":{\"names\":[\"UNANCHORED\"],\"lengths\":[227251827]},\"num_genes\":29499},{\"_id\":\"GCA_000143415.1\",\"db\":\"selaginella_moellendorffii_core_48_82_1\",\"taxon_id\":88036,\"system_name\":\"selaginella_moellendorffii\",\"type\":\"genome\",\"length\":0,\"regions\":{\"names\":[\"UNANCHORED\"],\"lengths\":[212645483]},\"num_genes\":34888},{\"_id\":\"GCA_000226075.1\",\"db\":\"solanum_tuberosum_core_48_82_4\",\"taxon_id\":4113,\"system_name\":\"solanum_tuberosum\",\"type\":\"genome\",\"length\":724917384,\"regions\":{\"names\":[\"1\",\"2\",\"3\",\"4\",\"5\",\"6\",\"7\",\"8\",\"9\",\"10\",\"11\",\"12\",\"UNANCHORED\"],\"lengths\":[88663952,48614681,62190286,72208621,52070158,59532096,56760843,56938457,61540751,59756223,45475667,61165649,85736662]},\"num_genes\":42974},{\"_id\":\"GCA_000263155.1\",\"db\":\"setaria_italica_core_48_82_21\",\"taxon_id\":4555,\"system_name\":\"setaria_italica\",\"type\":\"genome\",\"length\":401300876,\"regions\":{\"names\":[\"1\",\"2\",\"3\",\"4\",\"5\",\"6\",\"7\",\"8\",\"9\",\"UNANCHORED\"],\"lengths\":[42145699,49200776,50652576,40408058,47253416,36015257,35964515,40690061,58970518,4436465]},\"num_genes\":35471},{\"_id\":\"GCA_000005005.5\",\"db\":\"zea_mays_core_48_82_6\",\"taxon_id\":4577,\"system_name\":\"zea_mays\",\"type\":\"genome\",\"length\":2060653601,\"regions\":{\"names\":[\"1\",\"2\",\"3\",\"4\",\"5\",\"6\",\"7\",\"8\",\"9\",\"10\",\"Pt\",\"Mt\",\"UNANCHORED\"],\"lengths\":[301476924,237917468,232245527,242062272,217959525,169407836,176826311,175377492,157038028,149632204,140384,569630,7210561]},\"num_genes\":39625},{\"_id\":\"GCA_000219495.2\",\"db\":\"medicago_truncatula_core_48_82_2\",\"taxon_id\":3880,\"system_name\":\"medicago_truncatula\",\"type\":\"genome\",\"length\":384466993,\"regions\":{\"names\":[\"1\",\"2\",\"3\",\"4\",\"5\",\"6\",\"7\",\"8\",\"UNANCHORED\"],\"lengths\":[52991155,45729672,55515152,56582383,43630510,35275713,49172423,45569985,28333398]},\"num_genes\":54073},{\"_id\":\"GCA_000403535.1\",\"db\":\"theobroma_cacao_core_48_82_1\",\"taxon_id\":3641,\"system_name\":\"theobroma_cacao\",\"type\":\"genome\",\"length\":330456197,\"regions\":{\"names\":[\"1\",\"2\",\"3\",\"4\",\"5\",\"6\",\"7\",\"8\",\"9\",\"10\",\"UNANCHORED\"],\"lengths\":[38988864,42436413,34397752,33492547,40442896,27290986,24379470,21543242,42035188,25448839,15537478]},\"num_genes\":29188},{\"_id\":\"GCA_000004515.1\",\"db\":\"glycine_max_core_48_82_1\",\"taxon_id\":3847,\"system_name\":\"glycine_max\",\"type\":\"genome\",\"length\":950068807,\"regions\":{\"names\":[\"1\",\"2\",\"3\",\"4\",\"5\",\"6\",\"7\",\"8\",\"9\",\"10\",\"11\",\"12\",\"13\",\"14\",\"15\",\"16\",\"17\",\"18\",\"19\",\"20\",\"UNANCHORED\"],\"lengths\":[55915595,51656713,47781076,49243852,41936504,50722821,44683157,46995532,46843750,50969635,39172790,40113140,44408971,49711204,50939160,37397385,41906774,62308140,50589441,46773167,23275573]},\"num_genes\":54174},{\"_id\":\"GCA_000004255.1\",\"db\":\"arabidopsis_lyrata_core_48_82_10\",\"taxon_id\":81972,\"system_name\":\"arabidopsis_lyrata\",\"type\":\"genome\",\"length\":194182311,\"regions\":{\"names\":[\"1\",\"2\",\"3\",\"4\",\"5\",\"6\",\"7\",\"8\",\"UNANCHORED\"],\"lengths\":[33132539,19320864,24464547,23328337,21221946,25113588,24649197,22951293,12485624]},\"num_genes\":32667},{\"_id\":\"GCA_000147395.1\",\"db\":\"oryza_glaberrima_core_48_82_2\",\"taxon_id\":4538,\"system_name\":\"oryza_glaberrima\",\"type\":\"genome\",\"length\":285037524,\"regions\":{\"names\":[\"1\",\"2\",\"3\",\"4\",\"5\",\"6\",\"7\",\"8\",\"9\",\"10\",\"11\",\"12\",\"UNANCHORED\"],\"lengths\":[32613412,29142869,33053699,26299011,23192814,24174485,21799424,20292731,17607432,16910673,20796451,19154523,31382050]},\"num_genes\":73878},{\"_id\":\"GCA_000188115.2\",\"db\":\"solanum_lycopersicum_core_48_82_250\",\"taxon_id\":4081,\"system_name\":\"solanum_lycopersicum\",\"type\":\"genome\",\"length\":802138220,\"regions\":{\"names\":[\"1\",\"2\",\"3\",\"4\",\"5\",\"6\",\"7\",\"8\",\"9\",\"10\",\"11\",\"12\",\"UNANCHORED\"],\"lengths\":[98543444,55340444,70787664,66470942,65875088,49751636,68045021,65866657,72482091,65527505,56302525,67145203,21492721]},\"num_genes\":38735},{\"_id\":\"GCA_000002425.1\",\"db\":\"physcomitrella_patens_core_48_82_11\",\"taxon_id\":3218,\"system_name\":\"physcomitrella_patens\",\"type\":\"genome\",\"length\":0,\"regions\":{\"names\":[\"UNANCHORED\"],\"lengths\":[479985347]},\"num_genes\":32273},{\"_id\":\"GCA_000003195.1\",\"db\":\"sorghum_bicolor_core_48_82_14\",\"taxon_id\":4558,\"system_name\":\"sorghum_bicolor\",\"type\":\"genome\",\"length\":659229367,\"regions\":{\"names\":[\"1\",\"2\",\"3\",\"4\",\"5\",\"6\",\"7\",\"8\",\"9\",\"10\",\"UNANCHORED\"],\"lengths\":[73840631,77932606,74441160,68034345,62352331,62208784,64342021,55460251,59635592,60981646,79311565]},\"num_genes\":34567},{\"_id\":\"GCA_000471905.1\",\"db\":\"amborella_trichopoda_core_48_82_1\",\"taxon_id\":13333,\"system_name\":\"amborella_trichopoda\",\"type\":\"genome\",\"length\":0,\"regions\":{\"names\":[\"UNANCHORED\"],\"lengths\":[706332640]},\"num_genes\":28721},{\"_id\":\"GCA_000002775.2\",\"db\":\"populus_trichocarpa_core_48_82_20\",\"taxon_id\":3694,\"system_name\":\"populus_trichocarpa\",\"type\":\"genome\",\"length\":378545895,\"regions\":{\"names\":[\"1\",\"2\",\"3\",\"4\",\"5\",\"6\",\"7\",\"8\",\"9\",\"10\",\"11\",\"12\",\"13\",\"14\",\"15\",\"16\",\"17\",\"18\",\"19\",\"UNANCHORED\"],\"lengths\":[48367220,23562801,20216605,23188140,25802683,26894541,15101417,18835763,12942059,21538349,18885544,14929429,15658869,17716633,15134944,14134809,14661173,14966190,16008726,38592049]},\"num_genes\":41377},{\"_id\":\"GCA_000231095.2\",\"db\":\"oryza_brachyantha_core_48_82_14\",\"taxon_id\":4533,\"system_name\":\"oryza_brachyantha\",\"type\":\"genome\",\"length\":250927218,\"regions\":{\"names\":[\"1\",\"2\",\"3\",\"4\",\"5\",\"6\",\"7\",\"8\",\"9\",\"10\",\"11\",\"12\",\"UNANCHORED\"],\"lengths\":[33916305,27085147,29620734,21479432,20131956,21794218,18603524,18224760,14107269,14643570,16001410,15318893,9910950]},\"num_genes\":34155},{\"_id\":\"GCA_000695525.1\",\"db\":\"brassica_oleracea_core_48_82_1\",\"taxon_id\":109376,\"system_name\":\"brassica_oleracea\",\"type\":\"genome\",\"length\":446885882,\"regions\":{\"names\":[\"C1\",\"C2\",\"C3\",\"C4\",\"C5\",\"C6\",\"C7\",\"C8\",\"C9\",\"UNANCHORED\"],\"lengths\":[43764888,52886895,64984695,53719093,46902585,39822476,48366697,41758685,54679868,41736625]},\"num_genes\":59225},{\"_id\":\"GCA_000004655.2\",\"db\":\"oryza_indica_core_48_82_2\",\"taxon_id\":39946,\"system_name\":\"oryza_indica\",\"type\":\"genome\",\"length\":374545499,\"regions\":{\"names\":[\"1\",\"2\",\"3\",\"4\",\"5\",\"6\",\"7\",\"8\",\"9\",\"10\",\"11\",\"12\",\"UNANCHORED\"],\"lengths\":[47283185,38103930,41884883,34718618,31240961,32913967,27957088,30396518,21757032,22204031,23035369,23049917,52459391]},\"num_genes\":88438},{\"_id\":\"GCA_000326085.1\",\"db\":\"hordeum_vulgare_core_48_82_2\",\"taxon_id\":112509,\"system_name\":\"hordeum_vulgare\",\"type\":\"genome\",\"length\":3902943035,\"regions\":{\"names\":[\"1\",\"2\",\"3\",\"4\",\"5\",\"6\",\"7\",\"Pt\",\"UNANCHORED\"],\"lengths\":[464124043,628342783,564427874,544168226,561411686,538755036,601597413,115974,142357816]},\"num_genes\":26067},{\"_id\":\"v0117-2013Aug\",\"db\":\"oryza_longistaminata_core_48_82_117\",\"taxon_id\":4528,\"system_name\":\"oryza_longistaminata\",\"type\":\"genome\",\"length\":0,\"regions\":{\"names\":[\"UNANCHORED\"],\"lengths\":[344631721]},\"num_genes\":29974},{\"_id\":\"GCA_000309985.1\",\"db\":\"brassica_rapa_core_48_82_1\",\"taxon_id\":51351,\"system_name\":\"brassica_rapa\",\"type\":\"genome\",\"length\":256240462,\"regions\":{\"names\":[\"A01\",\"A02\",\"A03\",\"A04\",\"A05\",\"A06\",\"A07\",\"A08\",\"A09\",\"A10\",\"UNANCHORED\"],\"lengths\":[28605136,27846329,31715688,18965343,23939834,26271742,22586724,21594650,37120481,17594535,27582321]},\"num_genes\":42846},{\"_id\":\"GCA_000347335.1\",\"db\":\"aegilops_tauschii_core_48_82_1\",\"taxon_id\":37682,\"system_name\":\"aegilops_tauschii\",\"type\":\"genome\",\"length\":0,\"regions\":{\"names\":[\"UNANCHORED\"],\"lengths\":[3313764331]},\"num_genes\":37035},{\"_id\":\"IWGSC1.0+popseq\",\"db\":\"triticum_aestivum_core_48_82_2\",\"taxon_id\":4565,\"system_name\":\"triticum_aestivum\",\"type\":\"genome\",\"length\":5012504396,\"regions\":{\"names\":[\"1A\",\"1B\",\"1D\",\"2A\",\"2B\",\"2D\",\"3A\",\"3B\",\"3D\",\"4A\",\"4B\",\"4D\",\"5A\",\"5B\",\"5D\",\"6A\",\"6B\",\"6D\",\"7A\",\"7B\",\"7D\",\"Mt\",\"Pt\",\"UNANCHORED\"],\"lengths\":[248437066,295113561,135633378,254944609,345274828,150381694,185052605,774434471,124322642,215863839,317344599,121193423,148252673,273623383,161539237,207910053,204046169,177000238,182007620,251517909,238042887,452528,114984,1470784488]},\"num_genes\":112496},{\"_id\":\"GCA_000347455.1\",\"db\":\"triticum_urartu_core_48_82_1\",\"taxon_id\":4572,\"system_name\":\"triticum_urartu\",\"type\":\"genome\",\"length\":0,\"regions\":{\"names\":[\"UNANCHORED\"],\"lengths\":[3747163292]},\"num_genes\":37604}]}");

},{}],"aIXvU":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = {
    resultTypes: require("a1624f3290f132d3"),
    client: require("df5fdbabb5fbe5dd")
};

},{"a1624f3290f132d3":"guDeJ","df5fdbabb5fbe5dd":"fgGjt"}],"guDeJ":[function(require,module,exports,__globalThis) {
'use strict';
var _ = require("1fe6d69a919c017d");
var resultTypes = {
    list: {
        rows: 10,
        start: 0
    },
    distribution: {
        'facet.limit': -1,
        'facet.mincount': 1
    },
    facet: {
        'facet.limit': 50,
        'facet.mincount': 0,
        'facet.field': 'taxon_id'
    },
    tally: {
        'json.facet': {
            'species': 'unique(taxon_id)',
            'biotype': 'unique(biotype)',
            'GO': 'unique(GO_xrefi)',
            'PO': 'unique(PO_xrefi)',
            'domains': 'unique(interpro_xrefi)',
            'epl_gene_tree': 'unique(epl_gene_tree)'
        }
    }
};
module.exports = {
    get: function(type, details) {
        var rt = _.cloneDeep(resultTypes[type]), facetField, kvpStringArray;
        if (!rt) return;
        // details are specific configurations for this 'instance' of
        // the result type, e.g. facet field.
        if (details) // add the details to the object
        _.assign(rt, details);
        // if 'facet.field' and 'key' are defined then we are faceting. Refactor all
        // properties into a string that fits the SOLR syntax for LocalParams
        // described here http://wiki.apache.org/solr/LocalParams
        /* e.g/

    {
      'facet.field': 'foo',
      key: 'bar',
      'facet.mincount': -1,
      'facet.limit': 10
    }

    will become
    {
      'facet.field': '{!key=bar facet.mincount=-1 facet.limit=10}foo'
    }

    We do this to encapsulate properties, and allow the same facet.field
    to be faceted more than once.
     */ facetField = rt['facet.field'];
        if (facetField) {
            delete rt['facet.field'];
            if (!rt.key) rt.key = facetField;
            kvpStringArray = _.map(rt, function(propVal, propKey) {
                return propKey + '=\'' + propVal + '\'';
            });
            rt = {
                'facet.field': '{!' + kvpStringArray.join(' ') + '}' + facetField
            };
        }
        return rt;
    }
};

},{"1fe6d69a919c017d":"4lC24"}],"4lC24":[function(require,module,exports,__globalThis) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ var global = arguments[3];
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

},{}],"fgGjt":[function(require,module,exports,__globalThis) {
'use strict';
var _ = require("13d48fc81aa32fa4");
var Q = require("4c556b00079fba19");
var geneSearch = require("faf6d56253d010a8");
var suggest = require("380cd9fbec5353a6");
var mongo = require("15d03c8a2dc4e355");
function testSearch(example) {
    var tests = require("32493f163ae088f6");
    var testResults = _.get(tests, [
        example,
        'response'
    ]);
    if (!testResults) throw new Error("testSearch should be one of " + _.keys(tests).join(', '));
    return Q(_.cloneDeep(testResults)).then(geneSearch.reformatResponse);
}
exports.grameneClient = require("b888088ec522971c");
exports.validate = require("f46634523bb6353c");
exports.geneSearch = geneSearch.promise;
exports.suggest = suggest.promise;
exports.genes = mongo.genes;
exports.genetrees = mongo.genetrees;
exports.domains = mongo.domains;
exports.pathways = mongo.pathways;
exports.GO = mongo.GO;
exports.PO = mongo.PO;
exports._testSearch = testSearch;

},{"13d48fc81aa32fa4":"4lC24","4c556b00079fba19":"hoTdJ","faf6d56253d010a8":"eY6VV","380cd9fbec5353a6":"ec6U8","15d03c8a2dc4e355":"uPk8m","32493f163ae088f6":"fx7Q6","b888088ec522971c":"dS5bn","f46634523bb6353c":"hU2Ab"}],"hoTdJ":[function(require,module,exports,__globalThis) {
var process = require("bc086e6aeae9537");
// vim:ts=4:sts=4:sw=4:
/*!
 *
 * Copyright 2009-2017 Kris Kowal under the terms of the MIT
 * license found at https://github.com/kriskowal/q/blob/v1/LICENSE
 *
 * With parts by Tyler Close
 * Copyright 2007-2009 Tyler Close under the terms of the MIT X license found
 * at http://www.opensource.org/licenses/mit-license.html
 * Forked at ref_send.js version: 2009-05-11
 *
 * With parts by Mark Miller
 * Copyright (C) 2011 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */ (function(definition) {
    "use strict";
    // This file will function properly as a <script> tag, or a module
    // using CommonJS and NodeJS or RequireJS module formats.  In
    // Common/Node/RequireJS, the module exports the Q API and when
    // executed as a simple <script>, it creates a Q global instead.
    // Montage Require
    if (typeof bootstrap === "function") bootstrap("promise", definition);
    else {
        var global, previousQ;
        module.exports = definition();
    }
})(function() {
    "use strict";
    var hasStacks = false;
    try {
        throw new Error();
    } catch (e) {
        hasStacks = !!e.stack;
    }
    // All code after this point will be filtered from stack traces reported
    // by Q.
    var qStartingLine = captureLine();
    var qFileName;
    // shims
    // used for fallback in "allResolved"
    var noop = function() {};
    // Use the fastest possible means to execute a task in a future turn
    // of the event loop.
    var nextTick = function() {
        // linked list of tasks (single, with head node)
        var head = {
            task: void 0,
            next: null
        };
        var tail = head;
        var flushing = false;
        var requestTick = void 0;
        var isNodeJS = false;
        // queue for late tasks, used by unhandled rejection tracking
        var laterQueue = [];
        function flush() {
            /* jshint loopfunc: true */ var task, domain;
            while(head.next){
                head = head.next;
                task = head.task;
                head.task = void 0;
                domain = head.domain;
                if (domain) {
                    head.domain = void 0;
                    domain.enter();
                }
                runSingle(task, domain);
            }
            while(laterQueue.length){
                task = laterQueue.pop();
                runSingle(task);
            }
            flushing = false;
        }
        // runs a single function in the async queue
        function runSingle(task, domain) {
            try {
                task();
            } catch (e) {
                if (isNodeJS) {
                    // In node, uncaught exceptions are considered fatal errors.
                    // Re-throw them synchronously to interrupt flushing!
                    // Ensure continuation if the uncaught exception is suppressed
                    // listening "uncaughtException" events (as domains does).
                    // Continue in next event to avoid tick recursion.
                    if (domain) domain.exit();
                    setTimeout(flush, 0);
                    if (domain) domain.enter();
                    throw e;
                } else // In browsers, uncaught exceptions are not fatal.
                // Re-throw them asynchronously to avoid slow-downs.
                setTimeout(function() {
                    throw e;
                }, 0);
            }
            if (domain) domain.exit();
        }
        nextTick = function(task) {
            tail = tail.next = {
                task: task,
                domain: isNodeJS && process.domain,
                next: null
            };
            if (!flushing) {
                flushing = true;
                requestTick();
            }
        };
        if (typeof setImmediate === "function") {
            // In IE10, Node.js 0.9+, or https://github.com/NobleJS/setImmediate
            if (typeof window !== "undefined") requestTick = setImmediate.bind(window, flush);
            else requestTick = function() {
                setImmediate(flush);
            };
        } else if (typeof MessageChannel !== "undefined") {
            // modern browsers
            // http://www.nonblocking.io/2011/06/windownexttick.html
            var channel = new MessageChannel();
            // At least Safari Version 6.0.5 (8536.30.1) intermittently cannot create
            // working message ports the first time a page loads.
            channel.port1.onmessage = function() {
                requestTick = requestPortTick;
                channel.port1.onmessage = flush;
                flush();
            };
            var requestPortTick = function() {
                // Opera requires us to provide a message payload, regardless of
                // whether we use it.
                channel.port2.postMessage(0);
            };
            requestTick = function() {
                setTimeout(flush, 0);
                requestPortTick();
            };
        } else // old browsers
        requestTick = function() {
            setTimeout(flush, 0);
        };
        // runs a task after all other tasks have been run
        // this is useful for unhandled rejection tracking that needs to happen
        // after all `then`d tasks have been run.
        nextTick.runAfter = function(task) {
            laterQueue.push(task);
            if (!flushing) {
                flushing = true;
                requestTick();
            }
        };
        return nextTick;
    }();
    // Attempt to make generics safe in the face of downstream
    // modifications.
    // There is no situation where this is necessary.
    // If you need a security guarantee, these primordials need to be
    // deeply frozen anyway, and if you don’t need a security guarantee,
    // this is just plain paranoid.
    // However, this **might** have the nice side-effect of reducing the size of
    // the minified code by reducing x.call() to merely x()
    // See Mark Miller’s explanation of what this does.
    // http://wiki.ecmascript.org/doku.php?id=conventions:safe_meta_programming
    var call = Function.call;
    function uncurryThis(f) {
        return function() {
            return call.apply(f, arguments);
        };
    }
    // This is equivalent, but slower:
    // uncurryThis = Function_bind.bind(Function_bind.call);
    // http://jsperf.com/uncurrythis
    var array_slice = uncurryThis(Array.prototype.slice);
    var array_reduce = uncurryThis(Array.prototype.reduce || function(callback, basis) {
        var index = 0, length = this.length;
        // concerning the initial value, if one is not provided
        if (arguments.length === 1) // seek to the first value in the array, accounting
        // for the possibility that is is a sparse array
        do {
            if (index in this) {
                basis = this[index++];
                break;
            }
            if (++index >= length) throw new TypeError();
        }while (1);
        // reduce
        for(; index < length; index++)// account for the possibility that the array is sparse
        if (index in this) basis = callback(basis, this[index], index);
        return basis;
    });
    var array_indexOf = uncurryThis(Array.prototype.indexOf || function(value) {
        // not a very good shim, but good enough for our one use of it
        for(var i = 0; i < this.length; i++){
            if (this[i] === value) return i;
        }
        return -1;
    });
    var array_map = uncurryThis(Array.prototype.map || function(callback, thisp) {
        var self = this;
        var collect = [];
        array_reduce(self, function(undefined1, value, index) {
            collect.push(callback.call(thisp, value, index, self));
        }, void 0);
        return collect;
    });
    var object_create = Object.create || function(prototype) {
        function Type() {}
        Type.prototype = prototype;
        return new Type();
    };
    var object_defineProperty = Object.defineProperty || function(obj, prop, descriptor) {
        obj[prop] = descriptor.value;
        return obj;
    };
    var object_hasOwnProperty = uncurryThis(Object.prototype.hasOwnProperty);
    var object_keys = Object.keys || function(object) {
        var keys = [];
        for(var key in object)if (object_hasOwnProperty(object, key)) keys.push(key);
        return keys;
    };
    var object_toString = uncurryThis(Object.prototype.toString);
    function isObject(value) {
        return value === Object(value);
    }
    // generator related shims
    // FIXME: Remove this function once ES6 generators are in SpiderMonkey.
    function isStopIteration(exception) {
        return object_toString(exception) === "[object StopIteration]" || exception instanceof QReturnValue;
    }
    // FIXME: Remove this helper and Q.return once ES6 generators are in
    // SpiderMonkey.
    var QReturnValue;
    if (typeof ReturnValue !== "undefined") QReturnValue = ReturnValue;
    else QReturnValue = function(value) {
        this.value = value;
    };
    // long stack traces
    var STACK_JUMP_SEPARATOR = "From previous event:";
    function makeStackTraceLong(error, promise) {
        // If possible, transform the error stack trace by removing Node and Q
        // cruft, then concatenating with the stack trace of `promise`. See #57.
        if (hasStacks && promise.stack && typeof error === "object" && error !== null && error.stack) {
            var stacks = [];
            for(var p = promise; !!p; p = p.source)if (p.stack && (!error.__minimumStackCounter__ || error.__minimumStackCounter__ > p.stackCounter)) {
                object_defineProperty(error, "__minimumStackCounter__", {
                    value: p.stackCounter,
                    configurable: true
                });
                stacks.unshift(p.stack);
            }
            stacks.unshift(error.stack);
            var concatedStacks = stacks.join("\n" + STACK_JUMP_SEPARATOR + "\n");
            var stack = filterStackString(concatedStacks);
            object_defineProperty(error, "stack", {
                value: stack,
                configurable: true
            });
        }
    }
    function filterStackString(stackString) {
        var lines = stackString.split("\n");
        var desiredLines = [];
        for(var i = 0; i < lines.length; ++i){
            var line = lines[i];
            if (!isInternalFrame(line) && !isNodeFrame(line) && line) desiredLines.push(line);
        }
        return desiredLines.join("\n");
    }
    function isNodeFrame(stackLine) {
        return stackLine.indexOf("(module.js:") !== -1 || stackLine.indexOf("(node.js:") !== -1;
    }
    function getFileNameAndLineNumber(stackLine) {
        // Named functions: "at functionName (filename:lineNumber:columnNumber)"
        // In IE10 function name can have spaces ("Anonymous function") O_o
        var attempt1 = /at .+ \((.+):(\d+):(?:\d+)\)$/.exec(stackLine);
        if (attempt1) return [
            attempt1[1],
            Number(attempt1[2])
        ];
        // Anonymous functions: "at filename:lineNumber:columnNumber"
        var attempt2 = /at ([^ ]+):(\d+):(?:\d+)$/.exec(stackLine);
        if (attempt2) return [
            attempt2[1],
            Number(attempt2[2])
        ];
        // Firefox style: "function@filename:lineNumber or @filename:lineNumber"
        var attempt3 = /.*@(.+):(\d+)$/.exec(stackLine);
        if (attempt3) return [
            attempt3[1],
            Number(attempt3[2])
        ];
    }
    function isInternalFrame(stackLine) {
        var fileNameAndLineNumber = getFileNameAndLineNumber(stackLine);
        if (!fileNameAndLineNumber) return false;
        var fileName = fileNameAndLineNumber[0];
        var lineNumber = fileNameAndLineNumber[1];
        return fileName === qFileName && lineNumber >= qStartingLine && lineNumber <= qEndingLine;
    }
    // discover own file name and line number range for filtering stack
    // traces
    function captureLine() {
        if (!hasStacks) return;
        try {
            throw new Error();
        } catch (e) {
            var lines = e.stack.split("\n");
            var firstLine = lines[0].indexOf("@") > 0 ? lines[1] : lines[2];
            var fileNameAndLineNumber = getFileNameAndLineNumber(firstLine);
            if (!fileNameAndLineNumber) return;
            qFileName = fileNameAndLineNumber[0];
            return fileNameAndLineNumber[1];
        }
    }
    function deprecate(callback, name, alternative) {
        return function() {
            if (typeof console !== "undefined" && typeof console.warn === "function") console.warn(name + " is deprecated, use " + alternative + " instead.", new Error("").stack);
            return callback.apply(callback, arguments);
        };
    }
    // end of shims
    // beginning of real work
    /**
 * Constructs a promise for an immediate reference, passes promises through, or
 * coerces promises from different systems.
 * @param value immediate reference or promise
 */ function Q(value) {
        // If the object is already a Promise, return it directly.  This enables
        // the resolve function to both be used to created references from objects,
        // but to tolerably coerce non-promises to promises.
        if (value instanceof Promise) return value;
        // assimilate thenables
        if (isPromiseAlike(value)) return coerce(value);
        else return fulfill(value);
    }
    Q.resolve = Q;
    /**
 * Performs a task in a future turn of the event loop.
 * @param {Function} task
 */ Q.nextTick = nextTick;
    /**
 * Controls whether or not long stack traces will be on
 */ Q.longStackSupport = false;
    /**
 * The counter is used to determine the stopping point for building
 * long stack traces. In makeStackTraceLong we walk backwards through
 * the linked list of promises, only stacks which were created before
 * the rejection are concatenated.
 */ var longStackCounter = 1;
    /**
 * Constructs a {promise, resolve, reject} object.
 *
 * `resolve` is a callback to invoke with a more resolved value for the
 * promise. To fulfill the promise, invoke `resolve` with any value that is
 * not a thenable. To reject the promise, invoke `resolve` with a rejected
 * thenable, or invoke `reject` with the reason directly. To resolve the
 * promise to another thenable, thus putting it in the same state, invoke
 * `resolve` with that other thenable.
 */ Q.defer = defer;
    function defer() {
        // if "messages" is an "Array", that indicates that the promise has not yet
        // been resolved.  If it is "undefined", it has been resolved.  Each
        // element of the messages array is itself an array of complete arguments to
        // forward to the resolved promise.  We coerce the resolution value to a
        // promise using the `resolve` function because it handles both fully
        // non-thenable values and other thenables gracefully.
        var messages = [], progressListeners = [], resolvedPromise;
        var deferred = object_create(defer.prototype);
        var promise = object_create(Promise.prototype);
        promise.promiseDispatch = function(resolve, op, operands) {
            var args = array_slice(arguments);
            if (messages) {
                messages.push(args);
                if (op === "when" && operands[1]) progressListeners.push(operands[1]);
            } else Q.nextTick(function() {
                resolvedPromise.promiseDispatch.apply(resolvedPromise, args);
            });
        };
        // XXX deprecated
        promise.valueOf = function() {
            if (messages) return promise;
            var nearerValue = nearer(resolvedPromise);
            if (isPromise(nearerValue)) resolvedPromise = nearerValue; // shorten chain
            return nearerValue;
        };
        promise.inspect = function() {
            if (!resolvedPromise) return {
                state: "pending"
            };
            return resolvedPromise.inspect();
        };
        if (Q.longStackSupport && hasStacks) try {
            throw new Error();
        } catch (e) {
            // NOTE: don't try to use `Error.captureStackTrace` or transfer the
            // accessor around; that causes memory leaks as per GH-111. Just
            // reify the stack trace as a string ASAP.
            //
            // At the same time, cut off the first line; it's always just
            // "[object Promise]\n", as per the `toString`.
            promise.stack = e.stack.substring(e.stack.indexOf("\n") + 1);
            promise.stackCounter = longStackCounter++;
        }
        // NOTE: we do the checks for `resolvedPromise` in each method, instead of
        // consolidating them into `become`, since otherwise we'd create new
        // promises with the lines `become(whatever(value))`. See e.g. GH-252.
        function become(newPromise) {
            resolvedPromise = newPromise;
            if (Q.longStackSupport && hasStacks) // Only hold a reference to the new promise if long stacks
            // are enabled to reduce memory usage
            promise.source = newPromise;
            array_reduce(messages, function(undefined1, message) {
                Q.nextTick(function() {
                    newPromise.promiseDispatch.apply(newPromise, message);
                });
            }, void 0);
            messages = void 0;
            progressListeners = void 0;
        }
        deferred.promise = promise;
        deferred.resolve = function(value) {
            if (resolvedPromise) return;
            become(Q(value));
        };
        deferred.fulfill = function(value) {
            if (resolvedPromise) return;
            become(fulfill(value));
        };
        deferred.reject = function(reason) {
            if (resolvedPromise) return;
            become(reject(reason));
        };
        deferred.notify = function(progress) {
            if (resolvedPromise) return;
            array_reduce(progressListeners, function(undefined1, progressListener) {
                Q.nextTick(function() {
                    progressListener(progress);
                });
            }, void 0);
        };
        return deferred;
    }
    /**
 * Creates a Node-style callback that will resolve or reject the deferred
 * promise.
 * @returns a nodeback
 */ defer.prototype.makeNodeResolver = function() {
        var self = this;
        return function(error, value) {
            if (error) self.reject(error);
            else if (arguments.length > 2) self.resolve(array_slice(arguments, 1));
            else self.resolve(value);
        };
    };
    /**
 * @param resolver {Function} a function that returns nothing and accepts
 * the resolve, reject, and notify functions for a deferred.
 * @returns a promise that may be resolved with the given resolve and reject
 * functions, or rejected by a thrown exception in resolver
 */ Q.Promise = promise; // ES6
    Q.promise = promise;
    function promise(resolver) {
        if (typeof resolver !== "function") throw new TypeError("resolver must be a function.");
        var deferred = defer();
        try {
            resolver(deferred.resolve, deferred.reject, deferred.notify);
        } catch (reason) {
            deferred.reject(reason);
        }
        return deferred.promise;
    }
    promise.race = race; // ES6
    promise.all = all; // ES6
    promise.reject = reject; // ES6
    promise.resolve = Q; // ES6
    // XXX experimental.  This method is a way to denote that a local value is
    // serializable and should be immediately dispatched to a remote upon request,
    // instead of passing a reference.
    Q.passByCopy = function(object) {
        //freeze(object);
        //passByCopies.set(object, true);
        return object;
    };
    Promise.prototype.passByCopy = function() {
        //freeze(object);
        //passByCopies.set(object, true);
        return this;
    };
    /**
 * If two promises eventually fulfill to the same value, promises that value,
 * but otherwise rejects.
 * @param x {Any*}
 * @param y {Any*}
 * @returns {Any*} a promise for x and y if they are the same, but a rejection
 * otherwise.
 *
 */ Q.join = function(x, y) {
        return Q(x).join(y);
    };
    Promise.prototype.join = function(that) {
        return Q([
            this,
            that
        ]).spread(function(x, y) {
            if (x === y) // TODO: "===" should be Object.is or equiv
            return x;
            else throw new Error("Q can't join: not the same: " + x + " " + y);
        });
    };
    /**
 * Returns a promise for the first of an array of promises to become settled.
 * @param answers {Array[Any*]} promises to race
 * @returns {Any*} the first promise to be settled
 */ Q.race = race;
    function race(answerPs) {
        return promise(function(resolve, reject) {
            // Switch to this once we can assume at least ES5
            // answerPs.forEach(function (answerP) {
            //     Q(answerP).then(resolve, reject);
            // });
            // Use this in the meantime
            for(var i = 0, len = answerPs.length; i < len; i++)Q(answerPs[i]).then(resolve, reject);
        });
    }
    Promise.prototype.race = function() {
        return this.then(Q.race);
    };
    /**
 * Constructs a Promise with a promise descriptor object and optional fallback
 * function.  The descriptor contains methods like when(rejected), get(name),
 * set(name, value), post(name, args), and delete(name), which all
 * return either a value, a promise for a value, or a rejection.  The fallback
 * accepts the operation name, a resolver, and any further arguments that would
 * have been forwarded to the appropriate method above had a method been
 * provided with the proper name.  The API makes no guarantees about the nature
 * of the returned object, apart from that it is usable whereever promises are
 * bought and sold.
 */ Q.makePromise = Promise;
    function Promise(descriptor, fallback, inspect) {
        if (fallback === void 0) fallback = function(op) {
            return reject(new Error("Promise does not support operation: " + op));
        };
        if (inspect === void 0) inspect = function() {
            return {
                state: "unknown"
            };
        };
        var promise = object_create(Promise.prototype);
        promise.promiseDispatch = function(resolve, op, args) {
            var result;
            try {
                if (descriptor[op]) result = descriptor[op].apply(promise, args);
                else result = fallback.call(promise, op, args);
            } catch (exception) {
                result = reject(exception);
            }
            if (resolve) resolve(result);
        };
        promise.inspect = inspect;
        // XXX deprecated `valueOf` and `exception` support
        if (inspect) {
            var inspected = inspect();
            if (inspected.state === "rejected") promise.exception = inspected.reason;
            promise.valueOf = function() {
                var inspected = inspect();
                if (inspected.state === "pending" || inspected.state === "rejected") return promise;
                return inspected.value;
            };
        }
        return promise;
    }
    Promise.prototype.toString = function() {
        return "[object Promise]";
    };
    Promise.prototype.then = function(fulfilled, rejected, progressed) {
        var self = this;
        var deferred = defer();
        var done = false; // ensure the untrusted promise makes at most a
        // single call to one of the callbacks
        function _fulfilled(value) {
            try {
                return typeof fulfilled === "function" ? fulfilled(value) : value;
            } catch (exception) {
                return reject(exception);
            }
        }
        function _rejected(exception) {
            if (typeof rejected === "function") {
                makeStackTraceLong(exception, self);
                try {
                    return rejected(exception);
                } catch (newException) {
                    return reject(newException);
                }
            }
            return reject(exception);
        }
        function _progressed(value) {
            return typeof progressed === "function" ? progressed(value) : value;
        }
        Q.nextTick(function() {
            self.promiseDispatch(function(value) {
                if (done) return;
                done = true;
                deferred.resolve(_fulfilled(value));
            }, "when", [
                function(exception) {
                    if (done) return;
                    done = true;
                    deferred.resolve(_rejected(exception));
                }
            ]);
        });
        // Progress propagator need to be attached in the current tick.
        self.promiseDispatch(void 0, "when", [
            void 0,
            function(value) {
                var newValue;
                var threw = false;
                try {
                    newValue = _progressed(value);
                } catch (e) {
                    threw = true;
                    if (Q.onerror) Q.onerror(e);
                    else throw e;
                }
                if (!threw) deferred.notify(newValue);
            }
        ]);
        return deferred.promise;
    };
    Q.tap = function(promise, callback) {
        return Q(promise).tap(callback);
    };
    /**
 * Works almost like "finally", but not called for rejections.
 * Original resolution value is passed through callback unaffected.
 * Callback may return a promise that will be awaited for.
 * @param {Function} callback
 * @returns {Q.Promise}
 * @example
 * doSomething()
 *   .then(...)
 *   .tap(console.log)
 *   .then(...);
 */ Promise.prototype.tap = function(callback) {
        callback = Q(callback);
        return this.then(function(value) {
            return callback.fcall(value).thenResolve(value);
        });
    };
    /**
 * Registers an observer on a promise.
 *
 * Guarantees:
 *
 * 1. that fulfilled and rejected will be called only once.
 * 2. that either the fulfilled callback or the rejected callback will be
 *    called, but not both.
 * 3. that fulfilled and rejected will not be called in this turn.
 *
 * @param value      promise or immediate reference to observe
 * @param fulfilled  function to be called with the fulfilled value
 * @param rejected   function to be called with the rejection exception
 * @param progressed function to be called on any progress notifications
 * @return promise for the return value from the invoked callback
 */ Q.when = when;
    function when(value, fulfilled, rejected, progressed) {
        return Q(value).then(fulfilled, rejected, progressed);
    }
    Promise.prototype.thenResolve = function(value) {
        return this.then(function() {
            return value;
        });
    };
    Q.thenResolve = function(promise, value) {
        return Q(promise).thenResolve(value);
    };
    Promise.prototype.thenReject = function(reason) {
        return this.then(function() {
            throw reason;
        });
    };
    Q.thenReject = function(promise, reason) {
        return Q(promise).thenReject(reason);
    };
    /**
 * If an object is not a promise, it is as "near" as possible.
 * If a promise is rejected, it is as "near" as possible too.
 * If it’s a fulfilled promise, the fulfillment value is nearer.
 * If it’s a deferred promise and the deferred has been resolved, the
 * resolution is "nearer".
 * @param object
 * @returns most resolved (nearest) form of the object
 */ // XXX should we re-do this?
    Q.nearer = nearer;
    function nearer(value) {
        if (isPromise(value)) {
            var inspected = value.inspect();
            if (inspected.state === "fulfilled") return inspected.value;
        }
        return value;
    }
    /**
 * @returns whether the given object is a promise.
 * Otherwise it is a fulfilled value.
 */ Q.isPromise = isPromise;
    function isPromise(object) {
        return object instanceof Promise;
    }
    Q.isPromiseAlike = isPromiseAlike;
    function isPromiseAlike(object) {
        return isObject(object) && typeof object.then === "function";
    }
    /**
 * @returns whether the given object is a pending promise, meaning not
 * fulfilled or rejected.
 */ Q.isPending = isPending;
    function isPending(object) {
        return isPromise(object) && object.inspect().state === "pending";
    }
    Promise.prototype.isPending = function() {
        return this.inspect().state === "pending";
    };
    /**
 * @returns whether the given object is a value or fulfilled
 * promise.
 */ Q.isFulfilled = isFulfilled;
    function isFulfilled(object) {
        return !isPromise(object) || object.inspect().state === "fulfilled";
    }
    Promise.prototype.isFulfilled = function() {
        return this.inspect().state === "fulfilled";
    };
    /**
 * @returns whether the given object is a rejected promise.
 */ Q.isRejected = isRejected;
    function isRejected(object) {
        return isPromise(object) && object.inspect().state === "rejected";
    }
    Promise.prototype.isRejected = function() {
        return this.inspect().state === "rejected";
    };
    //// BEGIN UNHANDLED REJECTION TRACKING
    // This promise library consumes exceptions thrown in handlers so they can be
    // handled by a subsequent promise.  The exceptions get added to this array when
    // they are created, and removed when they are handled.  Note that in ES6 or
    // shimmed environments, this would naturally be a `Set`.
    var unhandledReasons = [];
    var unhandledRejections = [];
    var reportedUnhandledRejections = [];
    var trackUnhandledRejections = true;
    function resetUnhandledRejections() {
        unhandledReasons.length = 0;
        unhandledRejections.length = 0;
        if (!trackUnhandledRejections) trackUnhandledRejections = true;
    }
    function trackRejection(promise, reason) {
        if (!trackUnhandledRejections) return;
        unhandledRejections.push(promise);
        if (reason && typeof reason.stack !== "undefined") unhandledReasons.push(reason.stack);
        else unhandledReasons.push("(no stack) " + reason);
    }
    function untrackRejection(promise) {
        if (!trackUnhandledRejections) return;
        var at = array_indexOf(unhandledRejections, promise);
        if (at !== -1) {
            unhandledRejections.splice(at, 1);
            unhandledReasons.splice(at, 1);
        }
    }
    Q.resetUnhandledRejections = resetUnhandledRejections;
    Q.getUnhandledReasons = function() {
        // Make a copy so that consumers can't interfere with our internal state.
        return unhandledReasons.slice();
    };
    Q.stopUnhandledRejectionTracking = function() {
        resetUnhandledRejections();
        trackUnhandledRejections = false;
    };
    resetUnhandledRejections();
    //// END UNHANDLED REJECTION TRACKING
    /**
 * Constructs a rejected promise.
 * @param reason value describing the failure
 */ Q.reject = reject;
    function reject(reason) {
        var rejection = Promise({
            "when": function(rejected) {
                // note that the error has been handled
                if (rejected) untrackRejection(this);
                return rejected ? rejected(reason) : this;
            }
        }, function fallback() {
            return this;
        }, function inspect() {
            return {
                state: "rejected",
                reason: reason
            };
        });
        // Note that the reason has not been handled.
        trackRejection(rejection, reason);
        return rejection;
    }
    /**
 * Constructs a fulfilled promise for an immediate reference.
 * @param value immediate reference
 */ Q.fulfill = fulfill;
    function fulfill(value) {
        return Promise({
            "when": function() {
                return value;
            },
            "get": function(name) {
                return value[name];
            },
            "set": function(name, rhs) {
                value[name] = rhs;
            },
            "delete": function(name) {
                delete value[name];
            },
            "post": function(name, args) {
                // Mark Miller proposes that post with no name should apply a
                // promised function.
                if (name === null || name === void 0) return value.apply(void 0, args);
                else return value[name].apply(value, args);
            },
            "apply": function(thisp, args) {
                return value.apply(thisp, args);
            },
            "keys": function() {
                return object_keys(value);
            }
        }, void 0, function inspect() {
            return {
                state: "fulfilled",
                value: value
            };
        });
    }
    /**
 * Converts thenables to Q promises.
 * @param promise thenable promise
 * @returns a Q promise
 */ function coerce(promise) {
        var deferred = defer();
        Q.nextTick(function() {
            try {
                promise.then(deferred.resolve, deferred.reject, deferred.notify);
            } catch (exception) {
                deferred.reject(exception);
            }
        });
        return deferred.promise;
    }
    /**
 * Annotates an object such that it will never be
 * transferred away from this process over any promise
 * communication channel.
 * @param object
 * @returns promise a wrapping of that object that
 * additionally responds to the "isDef" message
 * without a rejection.
 */ Q.master = master;
    function master(object) {
        return Promise({
            "isDef": function() {}
        }, function fallback(op, args) {
            return dispatch(object, op, args);
        }, function() {
            return Q(object).inspect();
        });
    }
    /**
 * Spreads the values of a promised array of arguments into the
 * fulfillment callback.
 * @param fulfilled callback that receives variadic arguments from the
 * promised array
 * @param rejected callback that receives the exception if the promise
 * is rejected.
 * @returns a promise for the return value or thrown exception of
 * either callback.
 */ Q.spread = spread;
    function spread(value, fulfilled, rejected) {
        return Q(value).spread(fulfilled, rejected);
    }
    Promise.prototype.spread = function(fulfilled, rejected) {
        return this.all().then(function(array) {
            return fulfilled.apply(void 0, array);
        }, rejected);
    };
    /**
 * The async function is a decorator for generator functions, turning
 * them into asynchronous generators.  Although generators are only part
 * of the newest ECMAScript 6 drafts, this code does not cause syntax
 * errors in older engines.  This code should continue to work and will
 * in fact improve over time as the language improves.
 *
 * ES6 generators are currently part of V8 version 3.19 with the
 * --harmony-generators runtime flag enabled.  SpiderMonkey has had them
 * for longer, but under an older Python-inspired form.  This function
 * works on both kinds of generators.
 *
 * Decorates a generator function such that:
 *  - it may yield promises
 *  - execution will continue when that promise is fulfilled
 *  - the value of the yield expression will be the fulfilled value
 *  - it returns a promise for the return value (when the generator
 *    stops iterating)
 *  - the decorated function returns a promise for the return value
 *    of the generator or the first rejected promise among those
 *    yielded.
 *  - if an error is thrown in the generator, it propagates through
 *    every following yield until it is caught, or until it escapes
 *    the generator function altogether, and is translated into a
 *    rejection for the promise returned by the decorated generator.
 */ Q.async = async;
    function async(makeGenerator) {
        return function() {
            // when verb is "send", arg is a value
            // when verb is "throw", arg is an exception
            function continuer(verb, arg) {
                var result;
                // Until V8 3.19 / Chromium 29 is released, SpiderMonkey is the only
                // engine that has a deployed base of browsers that support generators.
                // However, SM's generators use the Python-inspired semantics of
                // outdated ES6 drafts.  We would like to support ES6, but we'd also
                // like to make it possible to use generators in deployed browsers, so
                // we also support Python-style generators.  At some point we can remove
                // this block.
                if (typeof StopIteration === "undefined") {
                    // ES6 Generators
                    try {
                        result = generator[verb](arg);
                    } catch (exception) {
                        return reject(exception);
                    }
                    if (result.done) return Q(result.value);
                    else return when(result.value, callback, errback);
                } else {
                    // SpiderMonkey Generators
                    // FIXME: Remove this case when SM does ES6 generators.
                    try {
                        result = generator[verb](arg);
                    } catch (exception) {
                        if (isStopIteration(exception)) return Q(exception.value);
                        else return reject(exception);
                    }
                    return when(result, callback, errback);
                }
            }
            var generator = makeGenerator.apply(this, arguments);
            var callback = continuer.bind(continuer, "next");
            var errback = continuer.bind(continuer, "throw");
            return callback();
        };
    }
    /**
 * The spawn function is a small wrapper around async that immediately
 * calls the generator and also ends the promise chain, so that any
 * unhandled errors are thrown instead of forwarded to the error
 * handler. This is useful because it's extremely common to run
 * generators at the top-level to work with libraries.
 */ Q.spawn = spawn;
    function spawn(makeGenerator) {
        Q.done(Q.async(makeGenerator)());
    }
    // FIXME: Remove this interface once ES6 generators are in SpiderMonkey.
    /**
 * Throws a ReturnValue exception to stop an asynchronous generator.
 *
 * This interface is a stop-gap measure to support generator return
 * values in older Firefox/SpiderMonkey.  In browsers that support ES6
 * generators like Chromium 29, just use "return" in your generator
 * functions.
 *
 * @param value the return value for the surrounding generator
 * @throws ReturnValue exception with the value.
 * @example
 * // ES6 style
 * Q.async(function* () {
 *      var foo = yield getFooPromise();
 *      var bar = yield getBarPromise();
 *      return foo + bar;
 * })
 * // Older SpiderMonkey style
 * Q.async(function () {
 *      var foo = yield getFooPromise();
 *      var bar = yield getBarPromise();
 *      Q.return(foo + bar);
 * })
 */ Q["return"] = _return;
    function _return(value) {
        throw new QReturnValue(value);
    }
    /**
 * The promised function decorator ensures that any promise arguments
 * are settled and passed as values (`this` is also settled and passed
 * as a value).  It will also ensure that the result of a function is
 * always a promise.
 *
 * @example
 * var add = Q.promised(function (a, b) {
 *     return a + b;
 * });
 * add(Q(a), Q(B));
 *
 * @param {function} callback The function to decorate
 * @returns {function} a function that has been decorated.
 */ Q.promised = promised;
    function promised(callback) {
        return function() {
            return spread([
                this,
                all(arguments)
            ], function(self, args) {
                return callback.apply(self, args);
            });
        };
    }
    /**
 * sends a message to a value in a future turn
 * @param object* the recipient
 * @param op the name of the message operation, e.g., "when",
 * @param args further arguments to be forwarded to the operation
 * @returns result {Promise} a promise for the result of the operation
 */ Q.dispatch = dispatch;
    function dispatch(object, op, args) {
        return Q(object).dispatch(op, args);
    }
    Promise.prototype.dispatch = function(op, args) {
        var self = this;
        var deferred = defer();
        Q.nextTick(function() {
            self.promiseDispatch(deferred.resolve, op, args);
        });
        return deferred.promise;
    };
    /**
 * Gets the value of a property in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of property to get
 * @return promise for the property value
 */ Q.get = function(object, key) {
        return Q(object).dispatch("get", [
            key
        ]);
    };
    Promise.prototype.get = function(key) {
        return this.dispatch("get", [
            key
        ]);
    };
    /**
 * Sets the value of a property in a future turn.
 * @param object    promise or immediate reference for object object
 * @param name      name of property to set
 * @param value     new value of property
 * @return promise for the return value
 */ Q.set = function(object, key, value) {
        return Q(object).dispatch("set", [
            key,
            value
        ]);
    };
    Promise.prototype.set = function(key, value) {
        return this.dispatch("set", [
            key,
            value
        ]);
    };
    /**
 * Deletes a property in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of property to delete
 * @return promise for the return value
 */ Q.del = Q["delete"] = function(object, key) {
        return Q(object).dispatch("delete", [
            key
        ]);
    };
    Promise.prototype.del = Promise.prototype["delete"] = function(key) {
        return this.dispatch("delete", [
            key
        ]);
    };
    /**
 * Invokes a method in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of method to invoke
 * @param value     a value to post, typically an array of
 *                  invocation arguments for promises that
 *                  are ultimately backed with `resolve` values,
 *                  as opposed to those backed with URLs
 *                  wherein the posted value can be any
 *                  JSON serializable object.
 * @return promise for the return value
 */ // bound locally because it is used by other methods
    Q.mapply = Q.post = function(object, name, args) {
        return Q(object).dispatch("post", [
            name,
            args
        ]);
    };
    Promise.prototype.mapply = Promise.prototype.post = function(name, args) {
        return this.dispatch("post", [
            name,
            args
        ]);
    };
    /**
 * Invokes a method in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of method to invoke
 * @param ...args   array of invocation arguments
 * @return promise for the return value
 */ Q.send = Q.mcall = Q.invoke = function(object, name /*...args*/ ) {
        return Q(object).dispatch("post", [
            name,
            array_slice(arguments, 2)
        ]);
    };
    Promise.prototype.send = Promise.prototype.mcall = Promise.prototype.invoke = function(name /*...args*/ ) {
        return this.dispatch("post", [
            name,
            array_slice(arguments, 1)
        ]);
    };
    /**
 * Applies the promised function in a future turn.
 * @param object    promise or immediate reference for target function
 * @param args      array of application arguments
 */ Q.fapply = function(object, args) {
        return Q(object).dispatch("apply", [
            void 0,
            args
        ]);
    };
    Promise.prototype.fapply = function(args) {
        return this.dispatch("apply", [
            void 0,
            args
        ]);
    };
    /**
 * Calls the promised function in a future turn.
 * @param object    promise or immediate reference for target function
 * @param ...args   array of application arguments
 */ Q["try"] = Q.fcall = function(object /* ...args*/ ) {
        return Q(object).dispatch("apply", [
            void 0,
            array_slice(arguments, 1)
        ]);
    };
    Promise.prototype.fcall = function() {
        return this.dispatch("apply", [
            void 0,
            array_slice(arguments)
        ]);
    };
    /**
 * Binds the promised function, transforming return values into a fulfilled
 * promise and thrown errors into a rejected one.
 * @param object    promise or immediate reference for target function
 * @param ...args   array of application arguments
 */ Q.fbind = function(object /*...args*/ ) {
        var promise = Q(object);
        var args = array_slice(arguments, 1);
        return function fbound() {
            return promise.dispatch("apply", [
                this,
                args.concat(array_slice(arguments))
            ]);
        };
    };
    Promise.prototype.fbind = function() {
        var promise = this;
        var args = array_slice(arguments);
        return function fbound() {
            return promise.dispatch("apply", [
                this,
                args.concat(array_slice(arguments))
            ]);
        };
    };
    /**
 * Requests the names of the owned properties of a promised
 * object in a future turn.
 * @param object    promise or immediate reference for target object
 * @return promise for the keys of the eventually settled object
 */ Q.keys = function(object) {
        return Q(object).dispatch("keys", []);
    };
    Promise.prototype.keys = function() {
        return this.dispatch("keys", []);
    };
    /**
 * Turns an array of promises into a promise for an array.  If any of
 * the promises gets rejected, the whole array is rejected immediately.
 * @param {Array*} an array (or promise for an array) of values (or
 * promises for values)
 * @returns a promise for an array of the corresponding values
 */ // By Mark Miller
    // http://wiki.ecmascript.org/doku.php?id=strawman:concurrency&rev=1308776521#allfulfilled
    Q.all = all;
    function all(promises) {
        return when(promises, function(promises) {
            var pendingCount = 0;
            var deferred = defer();
            array_reduce(promises, function(undefined1, promise, index) {
                var snapshot;
                if (isPromise(promise) && (snapshot = promise.inspect()).state === "fulfilled") promises[index] = snapshot.value;
                else {
                    ++pendingCount;
                    when(promise, function(value) {
                        promises[index] = value;
                        if (--pendingCount === 0) deferred.resolve(promises);
                    }, deferred.reject, function(progress) {
                        deferred.notify({
                            index: index,
                            value: progress
                        });
                    });
                }
            }, void 0);
            if (pendingCount === 0) deferred.resolve(promises);
            return deferred.promise;
        });
    }
    Promise.prototype.all = function() {
        return all(this);
    };
    /**
 * Returns the first resolved promise of an array. Prior rejected promises are
 * ignored.  Rejects only if all promises are rejected.
 * @param {Array*} an array containing values or promises for values
 * @returns a promise fulfilled with the value of the first resolved promise,
 * or a rejected promise if all promises are rejected.
 */ Q.any = any;
    function any(promises) {
        if (promises.length === 0) return Q.resolve();
        var deferred = Q.defer();
        var pendingCount = 0;
        array_reduce(promises, function(prev, current, index) {
            var promise = promises[index];
            pendingCount++;
            when(promise, onFulfilled, onRejected, onProgress);
            function onFulfilled(result) {
                deferred.resolve(result);
            }
            function onRejected(err) {
                pendingCount--;
                if (pendingCount === 0) {
                    var rejection = err || new Error("" + err);
                    rejection.message = "Q can't get fulfillment value from any promise, all promises were rejected. Last error message: " + rejection.message;
                    deferred.reject(rejection);
                }
            }
            function onProgress(progress) {
                deferred.notify({
                    index: index,
                    value: progress
                });
            }
        }, undefined);
        return deferred.promise;
    }
    Promise.prototype.any = function() {
        return any(this);
    };
    /**
 * Waits for all promises to be settled, either fulfilled or
 * rejected.  This is distinct from `all` since that would stop
 * waiting at the first rejection.  The promise returned by
 * `allResolved` will never be rejected.
 * @param promises a promise for an array (or an array) of promises
 * (or values)
 * @return a promise for an array of promises
 */ Q.allResolved = deprecate(allResolved, "allResolved", "allSettled");
    function allResolved(promises) {
        return when(promises, function(promises) {
            promises = array_map(promises, Q);
            return when(all(array_map(promises, function(promise) {
                return when(promise, noop, noop);
            })), function() {
                return promises;
            });
        });
    }
    Promise.prototype.allResolved = function() {
        return allResolved(this);
    };
    /**
 * @see Promise#allSettled
 */ Q.allSettled = allSettled;
    function allSettled(promises) {
        return Q(promises).allSettled();
    }
    /**
 * Turns an array of promises into a promise for an array of their states (as
 * returned by `inspect`) when they have all settled.
 * @param {Array[Any*]} values an array (or promise for an array) of values (or
 * promises for values)
 * @returns {Array[State]} an array of states for the respective values.
 */ Promise.prototype.allSettled = function() {
        return this.then(function(promises) {
            return all(array_map(promises, function(promise) {
                promise = Q(promise);
                function regardless() {
                    return promise.inspect();
                }
                return promise.then(regardless, regardless);
            }));
        });
    };
    /**
 * Captures the failure of a promise, giving an oportunity to recover
 * with a callback.  If the given promise is fulfilled, the returned
 * promise is fulfilled.
 * @param {Any*} promise for something
 * @param {Function} callback to fulfill the returned promise if the
 * given promise is rejected
 * @returns a promise for the return value of the callback
 */ Q.fail = Q["catch"] = function(object, rejected) {
        return Q(object).then(void 0, rejected);
    };
    Promise.prototype.fail = Promise.prototype["catch"] = function(rejected) {
        return this.then(void 0, rejected);
    };
    /**
 * Attaches a listener that can respond to progress notifications from a
 * promise's originating deferred. This listener receives the exact arguments
 * passed to ``deferred.notify``.
 * @param {Any*} promise for something
 * @param {Function} callback to receive any progress notifications
 * @returns the given promise, unchanged
 */ Q.progress = progress;
    function progress(object, progressed) {
        return Q(object).then(void 0, void 0, progressed);
    }
    Promise.prototype.progress = function(progressed) {
        return this.then(void 0, void 0, progressed);
    };
    /**
 * Provides an opportunity to observe the settling of a promise,
 * regardless of whether the promise is fulfilled or rejected.  Forwards
 * the resolution to the returned promise when the callback is done.
 * The callback can return a promise to defer completion.
 * @param {Any*} promise
 * @param {Function} callback to observe the resolution of the given
 * promise, takes no arguments.
 * @returns a promise for the resolution of the given promise when
 * ``fin`` is done.
 */ Q.fin = Q["finally"] = function(object, callback) {
        return Q(object)["finally"](callback);
    };
    Promise.prototype.fin = Promise.prototype["finally"] = function(callback) {
        if (!callback || typeof callback.apply !== "function") throw new Error("Q can't apply finally callback");
        callback = Q(callback);
        return this.then(function(value) {
            return callback.fcall().then(function() {
                return value;
            });
        }, function(reason) {
            // TODO attempt to recycle the rejection with "this".
            return callback.fcall().then(function() {
                throw reason;
            });
        });
    };
    /**
 * Terminates a chain of promises, forcing rejections to be
 * thrown as exceptions.
 * @param {Any*} promise at the end of a chain of promises
 * @returns nothing
 */ Q.done = function(object, fulfilled, rejected, progress) {
        return Q(object).done(fulfilled, rejected, progress);
    };
    Promise.prototype.done = function(fulfilled, rejected, progress) {
        var onUnhandledError = function(error) {
            // forward to a future turn so that ``when``
            // does not catch it and turn it into a rejection.
            Q.nextTick(function() {
                makeStackTraceLong(error, promise);
                if (Q.onerror) Q.onerror(error);
                else throw error;
            });
        };
        // Avoid unnecessary `nextTick`ing via an unnecessary `when`.
        var promise = fulfilled || rejected || progress ? this.then(fulfilled, rejected, progress) : this;
        promise.then(void 0, onUnhandledError);
    };
    /**
 * Causes a promise to be rejected if it does not get fulfilled before
 * some milliseconds time out.
 * @param {Any*} promise
 * @param {Number} milliseconds timeout
 * @param {Any*} custom error message or Error object (optional)
 * @returns a promise for the resolution of the given promise if it is
 * fulfilled before the timeout, otherwise rejected.
 */ Q.timeout = function(object, ms, error) {
        return Q(object).timeout(ms, error);
    };
    Promise.prototype.timeout = function(ms, error) {
        var deferred = defer();
        var timeoutId = setTimeout(function() {
            if (!error || "string" === typeof error) {
                error = new Error(error || "Timed out after " + ms + " ms");
                error.code = "ETIMEDOUT";
            }
            deferred.reject(error);
        }, ms);
        this.then(function(value) {
            clearTimeout(timeoutId);
            deferred.resolve(value);
        }, function(exception) {
            clearTimeout(timeoutId);
            deferred.reject(exception);
        }, deferred.notify);
        return deferred.promise;
    };
    /**
 * Returns a promise for the given value (or promised value), some
 * milliseconds after it resolved. Passes rejections immediately.
 * @param {Any*} promise
 * @param {Number} milliseconds
 * @returns a promise for the resolution of the given promise after milliseconds
 * time has elapsed since the resolution of the given promise.
 * If the given promise rejects, that is passed immediately.
 */ Q.delay = function(object, timeout) {
        if (timeout === void 0) {
            timeout = object;
            object = void 0;
        }
        return Q(object).delay(timeout);
    };
    Promise.prototype.delay = function(timeout) {
        return this.then(function(value) {
            var deferred = defer();
            setTimeout(function() {
                deferred.resolve(value);
            }, timeout);
            return deferred.promise;
        });
    };
    /**
 * Passes a continuation to a Node function, which is called with the given
 * arguments provided as an array, and returns a promise.
 *
 *      Q.nfapply(FS.readFile, [__filename])
 *      .then(function (content) {
 *      })
 *
 */ Q.nfapply = function(callback, args) {
        return Q(callback).nfapply(args);
    };
    Promise.prototype.nfapply = function(args) {
        var deferred = defer();
        var nodeArgs = array_slice(args);
        nodeArgs.push(deferred.makeNodeResolver());
        this.fapply(nodeArgs).fail(deferred.reject);
        return deferred.promise;
    };
    /**
 * Passes a continuation to a Node function, which is called with the given
 * arguments provided individually, and returns a promise.
 * @example
 * Q.nfcall(FS.readFile, __filename)
 * .then(function (content) {
 * })
 *
 */ Q.nfcall = function(callback /*...args*/ ) {
        var args = array_slice(arguments, 1);
        return Q(callback).nfapply(args);
    };
    Promise.prototype.nfcall = function() {
        var nodeArgs = array_slice(arguments);
        var deferred = defer();
        nodeArgs.push(deferred.makeNodeResolver());
        this.fapply(nodeArgs).fail(deferred.reject);
        return deferred.promise;
    };
    /**
 * Wraps a NodeJS continuation passing function and returns an equivalent
 * version that returns a promise.
 * @example
 * Q.nfbind(FS.readFile, __filename)("utf-8")
 * .then(console.log)
 * .done()
 */ Q.nfbind = Q.denodeify = function(callback /*...args*/ ) {
        if (callback === undefined) throw new Error("Q can't wrap an undefined function");
        var baseArgs = array_slice(arguments, 1);
        return function() {
            var nodeArgs = baseArgs.concat(array_slice(arguments));
            var deferred = defer();
            nodeArgs.push(deferred.makeNodeResolver());
            Q(callback).fapply(nodeArgs).fail(deferred.reject);
            return deferred.promise;
        };
    };
    Promise.prototype.nfbind = Promise.prototype.denodeify = function() {
        var args = array_slice(arguments);
        args.unshift(this);
        return Q.denodeify.apply(void 0, args);
    };
    Q.nbind = function(callback, thisp /*...args*/ ) {
        var baseArgs = array_slice(arguments, 2);
        return function() {
            var nodeArgs = baseArgs.concat(array_slice(arguments));
            var deferred = defer();
            nodeArgs.push(deferred.makeNodeResolver());
            function bound() {
                return callback.apply(thisp, arguments);
            }
            Q(bound).fapply(nodeArgs).fail(deferred.reject);
            return deferred.promise;
        };
    };
    Promise.prototype.nbind = function() {
        var args = array_slice(arguments, 0);
        args.unshift(this);
        return Q.nbind.apply(void 0, args);
    };
    /**
 * Calls a method of a Node-style object that accepts a Node-style
 * callback with a given array of arguments, plus a provided callback.
 * @param object an object that has the named method
 * @param {String} name name of the method of object
 * @param {Array} args arguments to pass to the method; the callback
 * will be provided by Q and appended to these arguments.
 * @returns a promise for the value or error
 */ Q.nmapply = Q.npost = function(object, name, args) {
        return Q(object).npost(name, args);
    };
    Promise.prototype.nmapply = Promise.prototype.npost = function(name, args) {
        var nodeArgs = array_slice(args || []);
        var deferred = defer();
        nodeArgs.push(deferred.makeNodeResolver());
        this.dispatch("post", [
            name,
            nodeArgs
        ]).fail(deferred.reject);
        return deferred.promise;
    };
    /**
 * Calls a method of a Node-style object that accepts a Node-style
 * callback, forwarding the given variadic arguments, plus a provided
 * callback argument.
 * @param object an object that has the named method
 * @param {String} name name of the method of object
 * @param ...args arguments to pass to the method; the callback will
 * be provided by Q and appended to these arguments.
 * @returns a promise for the value or error
 */ Q.nsend = Q.nmcall = Q.ninvoke = function(object, name /*...args*/ ) {
        var nodeArgs = array_slice(arguments, 2);
        var deferred = defer();
        nodeArgs.push(deferred.makeNodeResolver());
        Q(object).dispatch("post", [
            name,
            nodeArgs
        ]).fail(deferred.reject);
        return deferred.promise;
    };
    Promise.prototype.nsend = Promise.prototype.nmcall = Promise.prototype.ninvoke = function(name /*...args*/ ) {
        var nodeArgs = array_slice(arguments, 1);
        var deferred = defer();
        nodeArgs.push(deferred.makeNodeResolver());
        this.dispatch("post", [
            name,
            nodeArgs
        ]).fail(deferred.reject);
        return deferred.promise;
    };
    /**
 * If a function would like to support both Node continuation-passing-style and
 * promise-returning-style, it can end its internal promise chain with
 * `nodeify(nodeback)`, forwarding the optional nodeback argument.  If the user
 * elects to use a nodeback, the result will be sent there.  If they do not
 * pass a nodeback, they will receive the result promise.
 * @param object a result (or a promise for a result)
 * @param {Function} nodeback a Node.js-style callback
 * @returns either the promise or nothing
 */ Q.nodeify = nodeify;
    function nodeify(object, nodeback) {
        return Q(object).nodeify(nodeback);
    }
    Promise.prototype.nodeify = function(nodeback) {
        if (nodeback) this.then(function(value) {
            Q.nextTick(function() {
                nodeback(null, value);
            });
        }, function(error) {
            Q.nextTick(function() {
                nodeback(error);
            });
        });
        else return this;
    };
    Q.noConflict = function() {
        throw new Error("Q.noConflict only works when Q is used as a global");
    };
    // All code before this point will be filtered from stack traces.
    var qEndingLine = captureLine();
    return Q;
});

},{"bc086e6aeae9537":"4jeNM"}],"eY6VV":[function(require,module,exports,__globalThis) {
'use strict';
var _ = require("f52621e5e3210961");
var grameneSwaggerClient = require("57383dd9f51ca6af");
var validate = require("672b6ad7ef8fafc9");
function makeCall(gramene, query) {
    var params = getSolrParameters(query);
    params.collection = 'genes';
    return gramene['Search'].genes(params).then(function(res) {
        res.client = gramene;
        return res;
    });
}
function getSolrParameters(query) {
    var result = defaultSolrParameters();
    if (!query) return result;
    result.q = (query.q || '') + '*';
    for(var rtName in query.resultTypes)_.assign(result, query.resultTypes[rtName], function(existing, another) {
        var result = existing;
        // handle the case where the same key may be defined in many result types, for example
        // facet.field. It's typical for solr to have multiple facet.field parameters in the URL,
        // e.g.
        // http://data.gramene.org/search/genes?wt=json&indent=true&q=*&rows=2&start=0&facet=true&facet.field=bin_10Mb&facet.field=bin_5Mb&facet.limit=10&facet.mincount=1&f.bin_10Mb.facet.limit=10&fq=Interpro_xrefs:(IPR008978
        // IPR002068)
        if (existing) {
            if (_.isArray(existing)) {
                existing.push(another);
                result = existing;
            } else result = [
                existing,
                another
            ];
        } else result = another;
        return result;
    });
    if (query.filters && Object.keys(query.filters).length) {
        result.fq = Object.keys(query.filters);
        result.facet = true;
    }
    return result;
}
function defaultSolrParameters() {
    return {
        q: '*',
        rows: 0,
        facet: true
    };
}
function reformatResponse(response) {
    var data = response.obj;
    var fixed = {};
    if (data.facet_counts) {
        var originalFacets = data.facet_counts.facet_fields;
        if (originalFacets && !data.results) {
            fixed = data.results = {};
            for(var f in originalFacets)fixed[f] = reformatFacet(originalFacets[f], isSearchFieldNumeric(f), f);
            delete data.facet_counts;
        }
    }
    if (data.response.docs.length) fixed.list = data.response.docs;
    fixed.metadata = {
        count: data.response.numFound,
        qtime: data.responseHeader.QTime,
        url: response.url,
        client: response.client,
        validation: response.validation
    };
    if (response.headers) fixed.metadata.date = response.headers.date;
    if (data.facets) {
        fixed.tally = {};
        for(var f in data.facets)fixed.tally[f] = data.facets[f];
    }
    return fixed;
}
function isSearchFieldNumeric(fieldName) {
    return fieldName && (_.endsWith(fieldName, '__bin') || _.endsWith(fieldName, '__ancestors') || _.startsWith(fieldName, 'transcript__') || _.startsWith(fieldName, 'protein__') || fieldName === 'taxon_id' || fieldName === 'start' || fieldName === 'end' || fieldName === 'gene_idx' || fieldName === 'strand');
}
function reformatFacet(facetData, numericIds, displayName) {
    // facet data is an array of alternating ids (string) and counts (int),
    // e.g. ["4565", 99155, "3847", 54159, "109376", 46500, ... ]
    // we will make an associative array with id key and an object
    // for count and other values that may be added later.
    // e.g. { data : { "4565" : { count : 99155 }, // order here not guaranteed :-(
    //                 "3847" : { count: 54159 },
    //                 "109376" : { count: 46500 }
    //               }
    //      }
    var result = {
        data: {},
        sorted: [],
        count: 0,
        displayName: displayName
    };
    for(var i = 0; i < facetData.length; i += 2){
        var id = numericIds ? parseInt(facetData[i]) : facetData[i], count = facetData[i + 1], datum = {
            id: id,
            count: count
        };
        result.data[id] = datum;
        result.sorted.push(datum);
        if (count > 0) result.count++;
    }
    return result;
}
function promise(query) {
    return grameneSwaggerClient.then(function(client) {
        return makeCall(client, query);
    }).then(validate("SolrGeneResponse")).then(reformatResponse);
}
module.exports = {
    makeCall: makeCall,
    reformatResponse: reformatResponse,
    promise: promise
};

},{"f52621e5e3210961":"4lC24","57383dd9f51ca6af":"dS5bn","672b6ad7ef8fafc9":"hU2Ab"}],"dS5bn":[function(require,module,exports,__globalThis) {
'use strict';
var _ = require("c2088497dac360f3");
var Validator = require("720c59d7e19e7350");
var serverUrl = require("b724a232ddd178af");
var grameneSwaggerClient = function() {
    var SwaggerClient = require("a44280fae31de0e");
    return new SwaggerClient({
        url: serverUrl(),
        usePromise: true
    }).then(function addValidator(client) {
        new Validator(client);
        return client;
    });
}();
module.exports = grameneSwaggerClient;

},{"c2088497dac360f3":"4lC24","720c59d7e19e7350":"1AJuB","b724a232ddd178af":"cdZZx","a44280fae31de0e":"9oQNF"}],"1AJuB":[function(require,module,exports,__globalThis) {
/**
 * Created by bdunn on 21/10/2014.
 */ module.exports = require("644533d8cbdb281d");

},{"644533d8cbdb281d":"7I76s"}],"7I76s":[function(require,module,exports,__globalThis) {
/**
 * Created by bdunn and ssreedharan on 18/09/2014.
 */ module.exports = exports = Validator;
function Validator(swagger) {
    this.customValidators = {};
    if (!(this instanceof Validator)) return new Validator(swagger);
    var self = this;
    this.swagger = swagger;
    if (swagger) swagger.validateModel = function(modelName, obj, allowBlankTarget, disallowExtraProperties) {
        // this is now going to run in the scope of swagger...
        // Find the list of all Models from the allModels property or the definition property
        // This supports Swagger 1.2 and Swagger 2.0
        var models = this.allModels;
        if (this.definitions) models = this.definitions;
        var model = modelName;
        if (isStringType(modelName) && models[modelName]) model = models[modelName];
        // Add support for the use of discriminators this does not add support for the extends part of the
        // specification
        var subModelName = model.discriminator && obj[model.discriminator];
        if (subModelName && models[subModelName]) model = models[subModelName];
        return validate(modelName, obj, model, models, allowBlankTarget, disallowExtraProperties, self.customValidators);
    };
}
Validator.prototype.validate = function(target, swaggerModel, swaggerModels, allowBlankTarget, disallowExtraProperties) {
    return validate('rootModel', target, swaggerModel, swaggerModels, allowBlankTarget, disallowExtraProperties, this.customValidators);
};
Validator.prototype.addFieldValidatorToModel = function(model, fieldName, validatorFunction) {
    if (!model) throw new Error("Model is required");
    else if (typeof model != 'object') throw new error("Model must be an object");
    if (!fieldName) throw new Error("FieldName is required");
    else if (typeof fieldName !== 'string') throw new Error("FieldName must be a string");
    if (!validatorFunction) throw new Error("ValidatorFunction is required");
    else if (typeof validatorFunction !== 'function') throw new Error("ValidatorFunction is not a function");
    if (model.id) this.addFieldValidator(model.id, fieldName, validatorFunction);
    var modelValidator = model['x-validators'];
    if (!modelValidator) {
        modelValidator = {};
        modelValidator[fieldName] = [
            validatorFunction
        ];
        model['x-validators'] = modelValidator;
        return true;
    } else {
        var fieldValidators = modelValidator[fieldName];
        if (!fieldValidators) {
            fieldValidators = [
                validatorFunction
            ];
            modelValidator[fieldName] = fieldValidators;
            return true;
        } else {
            fieldValidators.push(validatorFunction);
            return true;
        }
    }
    return false;
};
Validator.prototype.addFieldValidator = function(modelName, fieldName, validatorFunction) {
    if (!modelName) throw new Error("ModelName is required");
    else if (typeof modelName !== 'string') throw new Error("ModelName must be a string");
    if (!fieldName) throw new Error("FieldName is required");
    else if (typeof fieldName !== 'string') throw new Error("FieldName must be a string");
    if (!validatorFunction) throw new Error("ValidatorFunction is required");
    else if (typeof validatorFunction !== 'function') throw new Error("ValidatorFunction is not a function");
    var modelValidator = this.customValidators[modelName];
    if (!modelValidator) {
        modelValidator = {};
        modelValidator[fieldName] = [
            validatorFunction
        ];
        this.customValidators[modelName] = modelValidator;
        return true;
    } else {
        var fieldValidators = modelValidator[fieldName];
        if (!fieldValidators) {
            fieldValidators = [
                validatorFunction
            ];
            modelValidator[fieldName] = fieldValidators;
            return true;
        } else {
            fieldValidators.push(validatorFunction);
            return true;
        }
    }
};
Validator.prototype.getFieldValidators = function(modelName, fieldName) {
    return getCustomValidators(modelName, fieldName, this.customValidators);
};
function getCustomValidators(modelName, fieldName, validators) {
    if (modelName) {
        if (validators) {
            if (!validators[modelName]) return null;
            else if (!validators[modelName][fieldName]) return null;
            else return validators[modelName][fieldName];
        }
    }
    return null;
}
function getCustomValidatorsFromModel(model, fieldName) {
    if (model && model['x-validators']) {
        if (!model['x-validators'][fieldName]) return null;
        else return model['x-validators'][fieldName];
    }
    return null;
}
function validate(name, target, swaggerModel, swaggerModels, allowBlankTargets, disallowExtraProperties, customValidators) {
    if (swaggerModels === true && allowBlankTargets === undefined) {
        allowBlankTargets = true;
        swaggerModels = undefined;
    } else if (swaggerModels === false || swaggerModels === null) swaggerModels = undefined;
    if (!target) return createReturnObject(new Error('Unable to validate an undefined value.'));
    else if (allowBlankTargets !== true && isEmpty(target)) return createReturnObject(new Error('Unable to validate an empty value.'));
    if (!swaggerModel) return createReturnObject(new Error('Unable to validate against an undefined model.'));
    var targetType = typeof target;
    var modelType = swaggerModel.type || 'object';
    if (targetType !== "object" && targetType !== modelType) return createReturnObject(new Error('Unable to validate a model with an type: ' + targetType + ', expected: ' + modelType));
    var requireFieldErrs;
    if (swaggerModel.required && swaggerModel.required.length > 0) {
        requireFieldErrs = validateRequiredFields(target, swaggerModel.required);
        if (requireFieldErrs) return createReturnObject(requireFieldErrs);
    }
    var validationErrs = validateSpec(name, target, swaggerModel, swaggerModels, disallowExtraProperties, customValidators);
    if (validationErrs) return createReturnObject(validationErrs, swaggerModel.id || name);
    else return createReturnObject();
}
function isEmpty(target) {
    for(var p in target){
        if (target[p] != target.constructor.prototype[p]) return false;
    }
    return true;
}
function createReturnObject(errors, modelName) {
    var result = {};
    if (!errors) {
        result.valid = true;
        result.errorCount = 0;
    } else {
        result.valid = false;
        if (!errors.message) {
            result.errorCount = errors.length;
            result.errors = errors;
        } else {
            result.errorCount = 1;
            result.errors = [
                errors
            ];
        }
        result.GetErrorMessages = function() {
            var errorMessages = [];
            for(index in this.errors)errorMessages.push(this.errors[index].message);
            return errorMessages;
        };
        result.GetFormattedErrors = function() {
            var errors = [];
            for(var index1 in this.errors){
                var error1 = JSON.stringify(this.errors[index1], [
                    "message",
                    "arguments",
                    "type",
                    "name"
                ]);
                errors.push(JSON.parse(error1));
            }
            return errors;
        };
    }
    if (modelName) result.modelName = modelName;
    return result;
}
function validateProperties(targetProperties, modelProperties) {
    var errors = [];
    if (targetProperties) {
        for(key in targetProperties)if (!modelProperties[targetProperties[key]]) errors.push(new Error("Target property '" + targetProperties[key] + "' is not in the model"));
    }
    return errors.length > 0 ? errors : null;
}
function validateSpec(name, target, model, models, disallowExtraProperties, customValidators) {
    var properties = model.properties;
    var errors = [];
    // if there are no properties, it's a reference to a primitive type
    if (!properties) {
        if (!model.type) return null;
        var singleValueErrors = validateValue(name, model, target, models);
        if (singleValueErrors) singleValueErrors.forEach(function(error1) {
            errors.push(error1);
        });
    } else {
        if (disallowExtraProperties) errors = validateProperties(Object.keys(target), properties) || [];
        for(key in properties){
            var field = properties[key];
            var value = target[key];
            if (value !== undefined) {
                var valueErrors = validateValue(key, field, value, models);
                if (!valueErrors) valueErrors = validateCustom(model.id || name, key, value, customValidators);
                if (!valueErrors) valueErrors = validateCustomFromModel(model, key, value);
                if (valueErrors) valueErrors.forEach(function(error1) {
                    errors.push(error1);
                });
            }
        }
    }
    return errors.length > 0 ? errors : null;
}
function validateCustomFromModel(model, name, value) {
    var validations = getCustomValidatorsFromModel(model, name);
    if (!validations) return null;
    var errors = [];
    validations.forEach(function(validation) {
        try {
            var validationErrors = validation(name, value);
            if (validationErrors) {
                if (validationErrors.message) errors.push(validationErrors);
                else validationErrors.forEach(function(validationError) {
                    errors.push(validationError);
                });
            }
        } catch (e) {
            console.warn(error);
        }
    });
    return errors.length > 0 ? errors : null;
}
function validateCustom(modelName, name, value, customValidators) {
    var validations = getCustomValidators(modelName, name, customValidators);
    if (!validations) return null;
    var errors = [];
    validations.forEach(function(validation) {
        try {
            var validationErrors = validation(name, value);
            if (validationErrors) {
                if (validationErrors.message) errors.push(validationErrors);
                else validationErrors.forEach(function(validationError) {
                    errors.push(validationError);
                });
            }
        } catch (e) {
            console.warn(error);
        }
    });
    return errors.length > 0 ? errors : null;
}
function validateValue(key1, field, value, models) {
    var errors = [];
    if (value !== undefined) {
        var typeErr = validateType(key1, value, field, models);
        if (typeErr) {
            if (typeErr.valid === undefined) {
                errors.push(typeErr);
                return errors;
            } else if (!typeErr.valid) {
                typeErr.errors.forEach(function(error1) {
                    errors.push(error1);
                });
                return errors;
            } else return null;
        }
        if (field["x-validatedType"] === 'string') {
            if (field.minLength > 0 || field.maxLength > 0) {
                var err1 = validateMinMaxLength(key1, value, field.minLength, field.maxLength);
                if (err1) errors.push(err1);
            }
        }
        if (field.type === 'integer' || field.type === 'number' || field["x-validatedType"] === 'date' || field["x-validatedType"] === 'date-time') {
            if (field.minimum || field.maximum || field.minimum === 0 || field.maximum === 0) {
                var err2 = validateMinMaxValue(key1, value, field.minimum, field.maximum);
                if (err2) errors.push(err2);
            }
            if (field.exclusiveMinimum || field.exclusiveMaximum) {
                var minimum;
                var maximum;
                if (field.exclusiveMinimum || field.exclusiveMinimum === 0) minimum = field.exclusiveMinimum + 1;
                if (field.exclusiveMaximum || field.exclusiveMaximum === 0) maximum = field.exclusiveMaximum - 1;
                if (field["x-validatedType"] === "date" || field["x-validatedType"] === 'date-time') {
                    if (field.exclusiveMinimum) minimum = incrementDateString(field.exclusiveMinimum, 1);
                    if (field.exclusiveMaximum) maximum = incrementDateString(field.exclusiveMaximum, -1);
                    value = new Date(value).toISOString();
                } else if (field.type === 'number' || field["x-validatedType"] === 'float' || field["x-validatedType"] === 'double') {
                    if (field.exclusiveMinimum) minimum = field.exclusiveMinimum + 0.00000000001;
                    if (field.exclusiveMaximum) maximum = field.exclusiveMaximum - 0.00000000001;
                }
                var err3 = validateMinMaxValue(key1, value, minimum, maximum, true);
                if (err3) errors.push(err3);
            }
        }
        field["x-validatedType"];
        if (field.enum) {
            var err = validateEnums(key1, value, field.enum);
            if (err) errors.push(err);
        }
    }
    return errors.length > 0 ? errors : null;
}
function validateType(name, property, field, models) {
    var expectedType = field.type;
    if (!expectedType) {
        if (models && field.$ref) {
            var fieldRef1 = field.$ref.replace('#/definitions/', '');
            return validate(name, property, models[fieldRef1], models);
        } else return null;
    } else expectedType = expectedType.toLowerCase();
    // Only attempt to validate an object if properties are defined in the model.
    // Otherwise, it's a poorly defined part of the schema that we will accept without
    // asking any further questions of it.
    if (expectedType === 'object') {
        if (field.properties) return validate(name, property, field, models);
        else return null;
    }
    if (expectedType === 'array') {
        if (!Array.isArray(property)) return new Error(name + ' is not an array. An array is expected.');
        if (field.items && field.items.type) {
            // These items are a baser type and not a referenced model
            var fieldType = field.items.type;
            var count = 0;
            var arrayErrors1 = [];
            property.forEach(function(value) {
                var errors1 = validateValue(name + count.toString(), field.items, value, models);
                if (errors1) errors1.forEach(function(error1) {
                    arrayErrors1.push(error1);
                });
                count = count + 1;
            });
            if (arrayErrors1.length > 0) return createReturnObject(arrayErrors1, "Array of " + fieldType + " (" + name + ")");
        } else if (models && field.items && field.items.$ref) {
            // These items are a referenced model
            var fieldRef2 = field.items.$ref.replace('#/definitions/', '');
            var model = models[fieldRef2];
            if (model) {
                var arrayErrors2 = [];
                property.forEach(function(value) {
                    var errors2 = validate(name, value, model, models);
                    if (errors2 && !errors2.valid) errors2.errors.forEach(function(error1) {
                        arrayErrors2.push(error1);
                    });
                });
                if (arrayErrors2.length > 0) return createReturnObject(arrayErrors2, "Array of " + field.items.$ref + " (" + name + ")");
            }
        }
        return null;
    }
    var format = field.format;
    if (format) format = format.toLowerCase();
    if (property === undefined || property === null) return null;
    if (expectedType === 'string') {
        if (isStringType(property, format)) {
            field["x-validatedType"] = format || expectedType;
            return null;
        }
    } else if (expectedType === 'boolean') {
        if (isExpectedType(property, expectedType)) {
            field["x-validatedType"] = format || expectedType;
            return null;
        }
    } else if (expectedType === 'integer') {
        if (isIntegerType(property, format)) {
            field["x-validatedType"] = format || expectedType;
            return null;
        }
    } else if (expectedType === 'number') {
        if (isNumberType(property, format)) {
            field["x-validatedType"] = format || expectedType;
            return null;
        }
    }
    //if(!format) {
    return new Error(name + ' (' + wrapNUllProperty(property) + ') is not a type of ' + (format || expectedType));
//} else {
//    return new Error(name + ' (' + wrapNUllProperty(property) + ') is not a type of ' + format)
//}
}
function isStringType(property, format) {
    if (isExpectedType(property, 'string')) {
        if (!format) return true;
        else if (format === 'date' || format === 'date-time') {
            var date = new Date(property);
            if (date !== "Invalid Date" && !isNaN(date) && isNaN(property)) return !(format === 'date' && property.length !== 10);
        } else // If format is specified but not special rules apply then validation is true
        return true;
    }
    return false;
}
function isIntegerType(property, format) {
    if (!isNumberType(property)) // If is is not a number then it cannot be an integer.
    return false;
    if (!format) return true;
    else if (format === 'int32') {
        var int32Max = Math.pow(2, 31) - 1;
        var value1 = parseInt(property);
        if (!isNaN(value1) && isFinite(property) && value1 >= -(int32Max + 1) && value1 <= int32Max) return true;
    } else if (format === 'int64') {
        var value2 = parseInt(property);
        if (!isNaN(value2) && isFinite(property)) return true;
    } else // If format is specified but no special rules apply then validation is true
    return true;
    return false;
}
function isNumberType(property, format) {
    if (!format || format === 'float' || format === 'double') {
        if (!isNaN(parseFloat(property)) && isFinite(property)) return true;
    } else // If format is specified but not special rules apply then validation is true
    return true;
    return false;
}
function isExpectedType(property, expectedType) {
    return typeof property === expectedType;
}
function wrapNUllProperty(property) {
    if (property === null) return "{null}";
    if (property === "") return "{empty string}";
    return property;
}
function validateMinLength(name, value, minLength) {
    if (minLength > 0) {
        if (value.length < minLength) {
            if (minLength === 1) return new Error(name + ' cannot be blank');
            return new Error(name + ' must be at least ' + minLength.toString() + ' characters long');
        }
    }
    return null;
}
function validateMaxLength(name, value, maxLength) {
    if (maxLength > 0) {
        if (value.length > maxLength) return new Error(name + ' must be no more than ' + maxLength.toString() + ' characters long');
    }
    return null;
}
function validateMinMaxLength(name, value, minLength, maxLength) {
    if (!minLength && !maxLength) return null;
    else if (!minLength) return validateMaxLength(name, value, maxLength);
    else if (!maxLength) return validateMinLength(name, value, minLength);
    if (value.length < minLength || value.length > maxLength) {
        if (minLength === 1) return new Error(name + ' cannot be blank and cannot be longer than ' + maxLength.toString() + ' characters long');
        return new Error(name + ' must be at least ' + minLength.toString() + ' characters long and no more than ' + maxLength.toString() + ' characters long');
    }
    return null;
}
function validateMinValue(name, value, minValue) {
    if (minValue || minValue === 0) {
        if (value < minValue) return new Error(name + ' must be at least ' + minValue.toString());
    }
    return null;
}
function validateMaxValue(name, value, maxValue) {
    if (maxValue || maxValue === 0) {
        if (value > maxValue) return new Error(name + ' must be no more than ' + maxValue.toString());
    }
    return null;
}
function validateMinMaxValue(name, value, minValue, maxValue, exclusive) {
    exclusive;
    !minValue && maxValue;
    if (minValue === undefined) return validateMaxValue(name, value, maxValue);
    else if (maxValue === undefined) return validateMinValue(name, value, minValue);
    if (value < minValue || value > maxValue) return new Error(name + ' must be at least ' + minValue.toString() + ' and no more than ' + maxValue.toString());
    return null;
}
function validateRequiredFields(object, fields) {
    if (!(fields instanceof Array)) throw new Error('fields must be an array of required fields');
    var errors = [];
    for(var i = 0; i < fields.length; ++i){
        var property = fields[i];
        try {
            if (!object.hasOwnProperty(property) || object[property] === "" || object[property] === null) errors.push(new Error(property + ' is a required field'));
        } catch (e) {
            errors.push(new Error('object does not have property ' + property));
        }
    }
    return errors.length > 0 ? errors : null;
}
function validateEnums(name, value, enums) {
    if (value === undefined || value === null) return null;
    for(var index1 in enums){
        if (value === enums[index1]) return null;
    }
    return new Error(name + ' is not set to an allowed value (see enum)');
}
function incrementDateString(dateString, increment) {
    var incrementingDate = new Date(dateString);
    incrementingDate.setMilliseconds(incrementingDate.getMilliseconds() + increment);
    return incrementingDate.toISOString();
}

},{}],"cdZZx":[function(require,module,exports,__globalThis) {
var global = arguments[3];
'use strict';
var queryString = require("88c04a80fecfd8e7");
var HARDCODED_SERVER = "https://data.gramene.org/latest/swagger";
function determineServerUrl() {
    var server;
    if (global) {
        if (global.location && global.location.search) {
            server = queryString.parse(global.location.search).server;
            if (server) return server;
        }
        if (global.gramene && global.gramene.defaultServer) return global.gramene.defaultServer;
    }
    return HARDCODED_SERVER;
}
determineServerUrl.HARDCODED_SERVER = HARDCODED_SERVER;
module.exports = determineServerUrl;

},{"88c04a80fecfd8e7":"cANlQ"}],"cANlQ":[function(require,module,exports,__globalThis) {
'use strict';
var strictUriEncode = require("228acb06a4f2d97e");
exports.extract = function(str) {
    return str.split('?')[1] || '';
};
exports.parse = function(str) {
    if (typeof str !== 'string') return {};
    str = str.trim().replace(/^(\?|#|&)/, '');
    if (!str) return {};
    return str.split('&').reduce(function(ret, param) {
        var parts = param.replace(/\+/g, ' ').split('=');
        // Firefox (pre 40) decodes `%3D` to `=`
        // https://github.com/sindresorhus/query-string/pull/37
        var key = parts.shift();
        var val = parts.length > 0 ? parts.join('=') : undefined;
        key = decodeURIComponent(key);
        // missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        val = val === undefined ? null : decodeURIComponent(val);
        if (!ret.hasOwnProperty(key)) ret[key] = val;
        else if (Array.isArray(ret[key])) ret[key].push(val);
        else ret[key] = [
            ret[key],
            val
        ];
        return ret;
    }, {});
};
exports.stringify = function(obj) {
    return obj ? Object.keys(obj).sort().map(function(key) {
        var val = obj[key];
        if (val === undefined) return '';
        if (val === null) return key;
        if (Array.isArray(val)) return val.slice().sort().map(function(val2) {
            return strictUriEncode(key) + '=' + strictUriEncode(val2);
        }).join('&');
        return strictUriEncode(key) + '=' + strictUriEncode(val);
    }).filter(function(x) {
        return x.length > 0;
    }).join('&') : '';
};

},{"228acb06a4f2d97e":"daeYp"}],"daeYp":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
};

},{}],"9oQNF":[function(require,module,exports,__globalThis) {
'use strict';
var auth = require("8bbc890601c97981");
var helpers = require("83201f79ef2e8e3f");
var SwaggerClient = require("8c582242b998fb64");
var deprecationWrapper = function(url, options) {
    helpers.log('This is deprecated, use "new SwaggerClient" instead.');
    return new SwaggerClient(url, options);
};
/* Here for IE8 Support */ if (!Array.prototype.indexOf) Array.prototype.indexOf = function(obj, start) {
    for(var i = start || 0, j = this.length; i < j; i++){
        if (this[i] === obj) return i;
    }
    return -1;
};
/* Here for IE8 Support */ if (!String.prototype.trim) String.prototype.trim = function() {
    return this.replace(/^\s+|\s+$/g, '');
};
/* Here for node 10.x support */ if (!String.prototype.endsWith) String.prototype.endsWith = function(suffix) {
    return this.indexOf(suffix, this.length - suffix.length) !== -1;
};
module.exports = SwaggerClient;
SwaggerClient.ApiKeyAuthorization = auth.ApiKeyAuthorization;
SwaggerClient.PasswordAuthorization = auth.PasswordAuthorization;
SwaggerClient.CookieAuthorization = auth.CookieAuthorization;
SwaggerClient.SwaggerApi = deprecationWrapper;
SwaggerClient.SwaggerClient = deprecationWrapper;
SwaggerClient.SchemaMarkup = require("c08a33c1779ff827");

},{"8bbc890601c97981":"035Fw","83201f79ef2e8e3f":"jrGf3","8c582242b998fb64":"aTJzX","c08a33c1779ff827":"cH9it"}],"035Fw":[function(require,module,exports,__globalThis) {
'use strict';
var helpers = require("ab928d179d21a1c5");
var btoa = require("22a2d0f7c8ac94d4"); // jshint ignore:line
var CookieJar = require("3959725fe84a5b9e").CookieJar;
var _ = {
    each: require("dad1f6860e768dcc"),
    includes: require("cb5803a61141af3e"),
    isObject: require("1cf5d955313a977a"),
    isArray: require("7336822ec1eb28b2")
};
/**
 * SwaggerAuthorizations applys the correct authorization to an operation being executed
 */ var SwaggerAuthorizations = module.exports.SwaggerAuthorizations = function(authz) {
    this.authz = authz || {};
};
/**
 * Add auths to the hash
 * Will overwrite any existing
 *
 */ SwaggerAuthorizations.prototype.add = function(name, auth) {
    if (_.isObject(name)) for(var key in name)this.authz[key] = name[key];
    else if (typeof name === 'string') this.authz[name] = auth;
    return auth;
};
SwaggerAuthorizations.prototype.remove = function(name) {
    return delete this.authz[name];
};
SwaggerAuthorizations.prototype.apply = function(obj, securities) {
    var status = true;
    var applyAll = !securities;
    var flattenedSecurities = [];
    // favor the object-level authorizations over global
    var authz = obj.clientAuthorizations || this.authz;
    // Securities could be [ {} ]
    _.each(securities, function(obj, key) {
        // Make sure we account for securities being [ str ]
        if (typeof key === 'string') flattenedSecurities.push(key);
        // Flatten keys in to our array
        _.each(obj, function(val, key) {
            flattenedSecurities.push(key);
        });
    });
    _.each(authz, function(auth, authName) {
        if (applyAll || _.includes(flattenedSecurities, authName)) {
            var newStatus = auth.apply(obj);
            status = status && !!newStatus; // logical ORs regarding status
        }
    });
    return status;
};
/**
 * ApiKeyAuthorization allows a query param or header to be injected
 */ var ApiKeyAuthorization = module.exports.ApiKeyAuthorization = function(name, value, type) {
    this.name = name;
    this.value = value;
    this.type = type;
};
ApiKeyAuthorization.prototype.apply = function(obj) {
    if (this.type === 'query') {
        // see if already applied.  If so, don't do it again
        var qp;
        if (obj.url.indexOf('?') > 0) {
            qp = obj.url.substring(obj.url.indexOf('?') + 1);
            var parts = qp.split('&');
            if (parts && parts.length > 0) for(var i = 0; i < parts.length; i++){
                var kv = parts[i].split('=');
                if (kv && kv.length > 0) {
                    if (kv[0] === this.name) // skip it
                    return false;
                }
            }
        }
        if (obj.url.indexOf('?') > 0) obj.url = obj.url + '&' + this.name + '=' + this.value;
        else obj.url = obj.url + '?' + this.name + '=' + this.value;
        return true;
    } else if (this.type === 'header') {
        if (typeof obj.headers[this.name] === 'undefined') obj.headers[this.name] = this.value;
        return true;
    }
};
var CookieAuthorization = module.exports.CookieAuthorization = function(cookie) {
    this.cookie = cookie;
};
CookieAuthorization.prototype.apply = function(obj) {
    obj.cookieJar = obj.cookieJar || new CookieJar();
    obj.cookieJar.setCookie(this.cookie);
    return true;
};
/**
 * Password Authorization is a basic auth implementation
 */ var PasswordAuthorization = module.exports.PasswordAuthorization = function(username, password) {
    if (arguments.length === 3) {
        helpers.log('PasswordAuthorization: the \'name\' argument has been removed, pass only username and password');
        username = arguments[1];
        password = arguments[2];
    }
    this.username = username;
    this.password = password;
};
PasswordAuthorization.prototype.apply = function(obj) {
    if (typeof obj.headers.Authorization === 'undefined') obj.headers.Authorization = 'Basic ' + btoa(this.username + ':' + this.password);
    return true;
};

},{"ab928d179d21a1c5":"jrGf3","22a2d0f7c8ac94d4":"lNsKT","3959725fe84a5b9e":"6WSSV","dad1f6860e768dcc":"emwTI","cb5803a61141af3e":"5a1wa","1cf5d955313a977a":"kAgGx","7336822ec1eb28b2":"fOaCr"}],"jrGf3":[function(require,module,exports,__globalThis) {
'use strict';
var _ = {
    isPlainObject: require("52cfe5a6cd641d8b"),
    indexOf: require("d8f18533ecfb9ec9")
};
module.exports.__bind = function(fn, me) {
    return function() {
        return fn.apply(me, arguments);
    };
};
var log = module.exports.log = function() {
    // Only log if available and we're not testing
    if (console && true) console.log(Array.prototype.slice.call(arguments)[0]);
};
module.exports.fail = function(message) {
    log(message);
};
var optionHtml = module.exports.optionHtml = function(label, value) {
    return '<tr><td class="optionName">' + label + ':</td><td>' + value + '</td></tr>';
};
var resolveSchema = module.exports.resolveSchema = function(schema) {
    if (_.isPlainObject(schema.schema)) schema = resolveSchema(schema.schema);
    return schema;
};
var simpleRef = module.exports.simpleRef = function(name) {
    if (typeof name === 'undefined') return null;
    if (name.indexOf('#/definitions/') === 0) return name.substring(14);
    else return name;
};

},{"52cfe5a6cd641d8b":"3iMXW","d8f18533ecfb9ec9":"hcpb9"}],"3iMXW":[function(require,module,exports,__globalThis) {
var baseForIn = require("d8806dcd6400f5bf"), isArguments = require("7c6c563f7e10cb0a"), isHostObject = require("e109c657786b7823"), isObjectLike = require("e2e320a05b487d71"), support = require("32f1ba9e5461ecb7");
/** `Object#toString` result references. */ var objectTag = '[object Object]';
/** Used for native method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var objToString = objectProto.toString;
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * **Note:** This method assumes objects created by the `Object` constructor
 * have no inherited enumerable properties.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    var Ctor;
    // Exit early for non `Object` objects.
    if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isHostObject(value) && !isArguments(value)) || !hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor))) return false;
    // IE < 9 iterates inherited properties before own properties. If the first
    // iterated property is an object's own property then there are no inherited
    // enumerable properties.
    var result;
    if (support.ownLast) {
        baseForIn(value, function(subValue, key, object) {
            result = hasOwnProperty.call(object, key);
            return false;
        });
        return result !== false;
    }
    // In most environments an object's own properties are iterated before
    // its inherited properties. If the last iterated property is an object's
    // own property then there are no inherited enumerable properties.
    baseForIn(value, function(subValue, key) {
        result = key;
    });
    return result === undefined || hasOwnProperty.call(value, result);
}
module.exports = isPlainObject;

},{"d8806dcd6400f5bf":"b4dyd","7c6c563f7e10cb0a":"eDDOa","e109c657786b7823":"3RGsa","e2e320a05b487d71":"1EGfv","32f1ba9e5461ecb7":"lBAKU"}],"b4dyd":[function(require,module,exports,__globalThis) {
var baseFor = require("1d2ea77cde67ca80"), keysIn = require("44d90f88465aa33c");
/**
 * The base implementation of `_.forIn` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForIn(object, iteratee) {
    return baseFor(object, iteratee, keysIn);
}
module.exports = baseForIn;

},{"1d2ea77cde67ca80":"jjGmc","44d90f88465aa33c":"gOKNs"}],"jjGmc":[function(require,module,exports,__globalThis) {
var createBaseFor = require("424b5dc08068ae22");
/**
 * The base implementation of `baseForIn` and `baseForOwn` which iterates
 * over `object` properties returned by `keysFunc` invoking `iteratee` for
 * each property. Iteratee functions may exit iteration early by explicitly
 * returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
module.exports = baseFor;

},{"424b5dc08068ae22":"4TKlM"}],"4TKlM":[function(require,module,exports,__globalThis) {
var toObject = require("d0507ede999590bc");
/**
 * Creates a base function for `_.forIn` or `_.forInRight`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var iterable = toObject(object), props = keysFunc(object), length = props.length, index = fromRight ? length : -1;
        while(fromRight ? index-- : ++index < length){
            var key = props[index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = createBaseFor;

},{"d0507ede999590bc":"9rJrG"}],"9rJrG":[function(require,module,exports,__globalThis) {
var isObject = require("4aa284f73ae434f"), isString = require("7fd5b9c6b5473097"), support = require("1fcc5bae3c155564");
/**
 * Converts `value` to an object if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Object} Returns the object.
 */ function toObject(value) {
    if (support.unindexedChars && isString(value)) {
        var index = -1, length = value.length, result = Object(value);
        while(++index < length)result[index] = value.charAt(index);
        return result;
    }
    return isObject(value) ? value : Object(value);
}
module.exports = toObject;

},{"4aa284f73ae434f":"kAgGx","7fd5b9c6b5473097":"ewvLp","1fcc5bae3c155564":"lBAKU"}],"kAgGx":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */ function isObject(value) {
    // Avoid a V8 JIT bug in Chrome 19-20.
    // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
module.exports = isObject;

},{}],"ewvLp":[function(require,module,exports,__globalThis) {
var isObjectLike = require("ee6901621bab2c72");
/** `Object#toString` result references. */ var stringTag = '[object String]';
/** Used for native method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var objToString = objectProto.toString;
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function isString(value) {
    return typeof value == 'string' || isObjectLike(value) && objToString.call(value) == stringTag;
}
module.exports = isString;

},{"ee6901621bab2c72":"1EGfv"}],"1EGfv":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
module.exports = isObjectLike;

},{}],"lBAKU":[function(require,module,exports,__globalThis) {
/** Used for native method references. */ var arrayProto = Array.prototype, errorProto = Error.prototype, objectProto = Object.prototype;
/** Native method references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/**
 * An object environment feature flags.
 *
 * @static
 * @memberOf _
 * @type Object
 */ var support = {};
(function(x) {
    var Ctor = function() {
        this.x = x;
    }, object = {
        '0': x,
        'length': x
    }, props = [];
    Ctor.prototype = {
        'valueOf': x,
        'y': x
    };
    for(var key in new Ctor)props.push(key);
    /**
   * Detect if `name` or `message` properties of `Error.prototype` are
   * enumerable by default (IE < 9, Safari < 5.1).
   *
   * @memberOf _.support
   * @type boolean
   */ support.enumErrorProps = propertyIsEnumerable.call(errorProto, 'message') || propertyIsEnumerable.call(errorProto, 'name');
    /**
   * Detect if `prototype` properties are enumerable by default.
   *
   * Firefox < 3.6, Opera > 9.50 - Opera < 11.60, and Safari < 5.1
   * (if the prototype or a property on the prototype has been set)
   * incorrectly set the `[[Enumerable]]` value of a function's `prototype`
   * property to `true`.
   *
   * @memberOf _.support
   * @type boolean
   */ support.enumPrototypes = propertyIsEnumerable.call(Ctor, 'prototype');
    /**
   * Detect if properties shadowing those on `Object.prototype` are non-enumerable.
   *
   * In IE < 9 an object's own properties, shadowing non-enumerable ones,
   * are made non-enumerable as well (a.k.a the JScript `[[DontEnum]]` bug).
   *
   * @memberOf _.support
   * @type boolean
   */ support.nonEnumShadows = !/valueOf/.test(props);
    /**
   * Detect if own properties are iterated after inherited properties (IE < 9).
   *
   * @memberOf _.support
   * @type boolean
   */ support.ownLast = props[0] != 'x';
    /**
   * Detect if `Array#shift` and `Array#splice` augment array-like objects
   * correctly.
   *
   * Firefox < 10, compatibility modes of IE 8, and IE < 9 have buggy Array
   * `shift()` and `splice()` functions that fail to remove the last element,
   * `value[0]`, of array-like objects even though the "length" property is
   * set to `0`. The `shift()` method is buggy in compatibility modes of IE 8,
   * while `splice()` is buggy regardless of mode in IE < 9.
   *
   * @memberOf _.support
   * @type boolean
   */ support.spliceObjects = (splice.call(object, 0, 1), !object[0]);
    /**
   * Detect lack of support for accessing string characters by index.
   *
   * IE < 8 can't access characters by index. IE 8 can only access characters
   * by index on string literals, not string objects.
   *
   * @memberOf _.support
   * @type boolean
   */ support.unindexedChars = "x" + Object('x')[0] != 'xx';
})(1, 0);
module.exports = support;

},{}],"gOKNs":[function(require,module,exports,__globalThis) {
var arrayEach = require("e7ad595c2a5ba125"), isArguments = require("d55f5d06f7293021"), isArray = require("8f36f0ccb73a2f82"), isFunction = require("5bb764d488bc37f6"), isIndex = require("3ed600781ee036cd"), isLength = require("af37ad70871213dd"), isObject = require("860c663b12fcbfcb"), isString = require("a134b8c26e472fac"), support = require("4f8f83e9ca9596a2");
/** `Object#toString` result references. */ var arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', stringTag = '[object String]';
/** Used to fix the JScript `[[DontEnum]]` bug. */ var shadowProps = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];
/** Used for native method references. */ var errorProto = Error.prototype, objectProto = Object.prototype, stringProto = String.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var objToString = objectProto.toString;
/** Used to avoid iterating over non-enumerable properties in IE < 9. */ var nonEnumProps = {};
nonEnumProps[arrayTag] = nonEnumProps[dateTag] = nonEnumProps[numberTag] = {
    'constructor': true,
    'toLocaleString': true,
    'toString': true,
    'valueOf': true
};
nonEnumProps[boolTag] = nonEnumProps[stringTag] = {
    'constructor': true,
    'toString': true,
    'valueOf': true
};
nonEnumProps[errorTag] = nonEnumProps[funcTag] = nonEnumProps[regexpTag] = {
    'constructor': true,
    'toString': true
};
nonEnumProps[objectTag] = {
    'constructor': true
};
arrayEach(shadowProps, function(key) {
    for(var tag in nonEnumProps)if (hasOwnProperty.call(nonEnumProps, tag)) {
        var props = nonEnumProps[tag];
        props[key] = hasOwnProperty.call(props, key);
    }
});
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    if (object == null) return [];
    if (!isObject(object)) object = Object(object);
    var length = object.length;
    length = length && isLength(length) && (isArray(object) || isArguments(object) || isString(object)) && length || 0;
    var Ctor = object.constructor, index = -1, proto = isFunction(Ctor) && Ctor.prototype || objectProto, isProto = proto === object, result = Array(length), skipIndexes = length > 0, skipErrorProps = support.enumErrorProps && (object === errorProto || object instanceof Error), skipProto = support.enumPrototypes && isFunction(object);
    while(++index < length)result[index] = index + '';
    // lodash skips the `constructor` property when it infers it's iterating
    // over a `prototype` object because IE < 9 can't set the `[[Enumerable]]`
    // attribute of an existing property and the `constructor` property of a
    // prototype defaults to non-enumerable.
    for(var key in object)if (!(skipProto && key == 'prototype') && !(skipErrorProps && (key == 'message' || key == 'name')) && !(skipIndexes && isIndex(key, length)) && !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    if (support.nonEnumShadows && object !== objectProto) {
        var tag = object === stringProto ? stringTag : object === errorProto ? errorTag : objToString.call(object), nonEnums = nonEnumProps[tag] || nonEnumProps[objectTag];
        if (tag == objectTag) proto = objectProto;
        length = shadowProps.length;
        while(length--){
            key = shadowProps[length];
            var nonEnum = nonEnums[key];
            if (!(isProto && nonEnum) && (nonEnum ? hasOwnProperty.call(object, key) : object[key] !== proto[key])) result.push(key);
        }
    }
    return result;
}
module.exports = keysIn;

},{"e7ad595c2a5ba125":"7vAju","d55f5d06f7293021":"eDDOa","8f36f0ccb73a2f82":"fOaCr","5bb764d488bc37f6":"7K3Vo","3ed600781ee036cd":"6dSPe","af37ad70871213dd":"ah6gY","860c663b12fcbfcb":"kAgGx","a134b8c26e472fac":"ewvLp","4f8f83e9ca9596a2":"lBAKU"}],"7vAju":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.forEach` for arrays without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = arrayEach;

},{}],"eDDOa":[function(require,module,exports,__globalThis) {
var isArrayLike = require("fa52ff37ec1de0d8"), isObjectLike = require("3851e1298603f729");
/** Used for native method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Native method references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is classified as an `arguments` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    return isObjectLike(value) && isArrayLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
}
module.exports = isArguments;

},{"fa52ff37ec1de0d8":"6UsMq","3851e1298603f729":"1EGfv"}],"6UsMq":[function(require,module,exports,__globalThis) {
var getLength = require("3d09b666335338c7"), isLength = require("c5060a7e73381ac6");
/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */ function isArrayLike(value) {
    return value != null && isLength(getLength(value));
}
module.exports = isArrayLike;

},{"3d09b666335338c7":"kBGYK","c5060a7e73381ac6":"ah6gY"}],"kBGYK":[function(require,module,exports,__globalThis) {
var baseProperty = require("3dc685a8f993ebd6");
/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */ var getLength = baseProperty('length');
module.exports = getLength;

},{"3dc685a8f993ebd6":"8i6R2"}],"8i6R2":[function(require,module,exports,__globalThis) {
var toObject = require("abcd5252389dc234");
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : toObject(object)[key];
    };
}
module.exports = baseProperty;

},{"abcd5252389dc234":"9rJrG"}],"ah6gY":[function(require,module,exports,__globalThis) {
/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"fOaCr":[function(require,module,exports,__globalThis) {
var getNative = require("f2f40ceb0311af1"), isLength = require("397f349c566cd57b"), isObjectLike = require("3bcb808c050ad330");
/** `Object#toString` result references. */ var arrayTag = '[object Array]';
/** Used for native method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var objToString = objectProto.toString;
/* Native method references for those with the same name as other `lodash` methods. */ var nativeIsArray = getNative(Array, 'isArray');
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(function() { return arguments; }());
 * // => false
 */ var isArray = nativeIsArray || function(value) {
    return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
};
module.exports = isArray;

},{"f2f40ceb0311af1":"kBeqf","397f349c566cd57b":"ah6gY","3bcb808c050ad330":"1EGfv"}],"kBeqf":[function(require,module,exports,__globalThis) {
var isNative = require("a09596582eec21e1");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = object == null ? undefined : object[key];
    return isNative(value) ? value : undefined;
}
module.exports = getNative;

},{"a09596582eec21e1":"7oVVi"}],"7oVVi":[function(require,module,exports,__globalThis) {
var isFunction = require("5db0bc1450fcf90e"), isHostObject = require("9140932d48b8f6ac"), isObjectLike = require("c3792f99a90ac25e");
/** Used to detect host constructors (Safari > 5). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for native method references. */ var objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var fnToString = Function.prototype.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */ function isNative(value) {
    if (value == null) return false;
    if (isFunction(value)) return reIsNative.test(fnToString.call(value));
    return isObjectLike(value) && (isHostObject(value) ? reIsNative : reIsHostCtor).test(value);
}
module.exports = isNative;

},{"5db0bc1450fcf90e":"7K3Vo","9140932d48b8f6ac":"3RGsa","c3792f99a90ac25e":"1EGfv"}],"7K3Vo":[function(require,module,exports,__globalThis) {
var isObject = require("e0865cde86f2a7c");
/** `Object#toString` result references. */ var funcTag = '[object Function]';
/** Used for native method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var objToString = objectProto.toString;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in older versions of Chrome and Safari which return 'function' for regexes
    // and Safari 8 which returns 'object' for typed array constructors.
    return isObject(value) && objToString.call(value) == funcTag;
}
module.exports = isFunction;

},{"e0865cde86f2a7c":"kAgGx"}],"3RGsa":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ var isHostObject = function() {
    try {
        Object({
            'toString': 0
        } + '');
    } catch (e) {
        return function() {
            return false;
        };
    }
    return function(value) {
        // IE < 9 presents many host objects as `Object` objects that can coerce
        // to strings despite having improperly defined `toString` methods.
        return typeof value.toString != 'function' && typeof (value + '') == 'string';
    };
}();
module.exports = isHostObject;

},{}],"6dSPe":[function(require,module,exports,__globalThis) {
/** Used to detect unsigned integer values. */ var reIsUint = /^\d+$/;
/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    value = typeof value == 'number' || reIsUint.test(value) ? +value : -1;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{}],"hcpb9":[function(require,module,exports,__globalThis) {
var baseIndexOf = require("bfd4b0c5a5b99ca2"), binaryIndex = require("285b7f1b6877d2f1");
/* Native method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * Gets the index at which the first occurrence of `value` is found in `array`
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * for equality comparisons. If `fromIndex` is negative, it's used as the offset
 * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
 * performs a faster binary search.
 *
 * @static
 * @memberOf _
 * @category Array
 * @param {Array} array The array to search.
 * @param {*} value The value to search for.
 * @param {boolean|number} [fromIndex=0] The index to search from or `true`
 *  to perform a binary search on a sorted array.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.indexOf([1, 2, 1, 2], 2);
 * // => 1
 *
 * // using `fromIndex`
 * _.indexOf([1, 2, 1, 2], 2, 2);
 * // => 3
 *
 * // performing a binary search
 * _.indexOf([1, 1, 2, 2], 2, true);
 * // => 2
 */ function indexOf(array, value, fromIndex) {
    var length = array ? array.length : 0;
    if (!length) return -1;
    if (typeof fromIndex == 'number') fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
    else if (fromIndex) {
        var index = binaryIndex(array, value);
        if (index < length && (value === value ? value === array[index] : array[index] !== array[index])) return index;
        return -1;
    }
    return baseIndexOf(array, value, fromIndex || 0);
}
module.exports = indexOf;

},{"bfd4b0c5a5b99ca2":"dbPkS","285b7f1b6877d2f1":"2jSPv"}],"dbPkS":[function(require,module,exports,__globalThis) {
var indexOfNaN = require("426b55c838053433");
/**
 * The base implementation of `_.indexOf` without support for binary searches.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseIndexOf(array, value, fromIndex) {
    if (value !== value) return indexOfNaN(array, fromIndex);
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = baseIndexOf;

},{"426b55c838053433":"6ex1L"}],"6ex1L":[function(require,module,exports,__globalThis) {
/**
 * Gets the index at which the first occurrence of `NaN` is found in `array`.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched `NaN`, else `-1`.
 */ function indexOfNaN(array, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 0 : -1);
    while(fromRight ? index-- : ++index < length){
        var other = array[index];
        if (other !== other) return index;
    }
    return -1;
}
module.exports = indexOfNaN;

},{}],"2jSPv":[function(require,module,exports,__globalThis) {
var binaryIndexBy = require("6b4b83f5b019cbe8"), identity = require("f55fa7fbaff4063");
/** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
/**
 * Performs a binary search of `array` to determine the index at which `value`
 * should be inserted into `array` in order to maintain its sort order.
 *
 * @private
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {boolean} [retHighest] Specify returning the highest qualified index.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 */ function binaryIndex(array, value, retHighest) {
    var low = 0, high = array ? array.length : low;
    if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while(low < high){
            var mid = low + high >>> 1, computed = array[mid];
            if ((retHighest ? computed <= value : computed < value) && computed !== null) low = mid + 1;
            else high = mid;
        }
        return high;
    }
    return binaryIndexBy(array, value, identity, retHighest);
}
module.exports = binaryIndex;

},{"6b4b83f5b019cbe8":"72xF8","f55fa7fbaff4063":"j6dIJ"}],"72xF8":[function(require,module,exports,__globalThis) {
/* Native method references for those with the same name as other `lodash` methods. */ var nativeFloor = Math.floor, nativeMin = Math.min;
/** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1;
/**
 * This function is like `binaryIndex` except that it invokes `iteratee` for
 * `value` and each element of `array` to compute their sort ranking. The
 * iteratee is invoked with one argument; (value).
 *
 * @private
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {boolean} [retHighest] Specify returning the highest qualified index.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 */ function binaryIndexBy(array, value, iteratee, retHighest) {
    value = iteratee(value);
    var low = 0, high = array ? array.length : 0, valIsNaN = value !== value, valIsNull = value === null, valIsUndef = value === undefined;
    while(low < high){
        var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), isDef = computed !== undefined, isReflexive = computed === computed;
        if (valIsNaN) var setLow = isReflexive || retHighest;
        else if (valIsNull) setLow = isReflexive && isDef && (retHighest || computed != null);
        else if (valIsUndef) setLow = isReflexive && (retHighest || isDef);
        else if (computed == null) setLow = false;
        else setLow = retHighest ? computed <= value : computed < value;
        if (setLow) low = mid + 1;
        else high = mid;
    }
    return nativeMin(high, MAX_ARRAY_INDEX);
}
module.exports = binaryIndexBy;

},{}],"j6dIJ":[function(require,module,exports,__globalThis) {
/**
 * This method returns the first argument provided to it.
 *
 * @static
 * @memberOf _
 * @category Utility
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.identity(object) === object;
 * // => true
 */ function identity(value) {
    return value;
}
module.exports = identity;

},{}],"lNsKT":[function(require,module,exports,__globalThis) {
var Buffer = require("7fd0e6545d33cad8").Buffer;
(function() {
    "use strict";
    function btoa(str) {
        var buffer;
        if (str instanceof Buffer) buffer = str;
        else buffer = Buffer.from(str.toString(), 'binary');
        return buffer.toString('base64');
    }
    module.exports = btoa;
})();

},{"7fd0e6545d33cad8":"cjdyz"}],"cjdyz":[function(require,module,exports,__globalThis) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 'use strict';
var base64 = require("9c62938f1dccc73c");
var ieee754 = require("aceacb6a4531a9d2");
var customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
var K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    var b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = byteLength(string, encoding) | 0;
    var buf = createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    var buf = createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        var buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return utf8Slice(this, start, end);
        case 'ascii':
            return asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return latin1Slice(this, start, end);
        case 'base64':
            return base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = exports.INSPECT_MAX_BYTES;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

},{"9c62938f1dccc73c":"bICrG","aceacb6a4531a9d2":"7IMNJ"}],"bICrG":[function(require,module,exports,__globalThis) {
'use strict';
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join('');
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

},{}],"7IMNJ":[function(require,module,exports,__globalThis) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"6WSSV":[function(require,module,exports,__globalThis) {
/* jshint node: true */ (function() {
    "use strict";
    function CookieAccessInfo(domain, path, secure, script) {
        if (this instanceof CookieAccessInfo) {
            this.domain = domain || undefined;
            this.path = path || "/";
            this.secure = !!secure;
            this.script = !!script;
            return this;
        }
        return new CookieAccessInfo(domain, path, secure, script);
    }
    CookieAccessInfo.All = Object.freeze(Object.create(null));
    exports.CookieAccessInfo = CookieAccessInfo;
    function Cookie(cookiestr, request_domain, request_path) {
        if (cookiestr instanceof Cookie) return cookiestr;
        if (this instanceof Cookie) {
            this.name = null;
            this.value = null;
            this.expiration_date = Infinity;
            this.path = String(request_path || "/");
            this.explicit_path = false;
            this.domain = request_domain || null;
            this.explicit_domain = false;
            this.secure = false; //how to define default?
            this.noscript = false; //httponly
            if (cookiestr) this.parse(cookiestr, request_domain, request_path);
            return this;
        }
        return new Cookie(cookiestr, request_domain, request_path);
    }
    exports.Cookie = Cookie;
    Cookie.prototype.toString = function toString() {
        var str = [
            this.name + "=" + this.value
        ];
        if (this.expiration_date !== Infinity) str.push("expires=" + new Date(this.expiration_date).toGMTString());
        if (this.domain) str.push("domain=" + this.domain);
        if (this.path) str.push("path=" + this.path);
        if (this.secure) str.push("secure");
        if (this.noscript) str.push("httponly");
        return str.join("; ");
    };
    Cookie.prototype.toValueString = function toValueString() {
        return this.name + "=" + this.value;
    };
    var cookie_str_splitter = /[:](?=\s*[a-zA-Z0-9_\-]+\s*[=])/g;
    Cookie.prototype.parse = function parse(str, request_domain, request_path) {
        if (this instanceof Cookie) {
            var parts = str.split(";").filter(function(value) {
                return !!value;
            });
            var i;
            var pair = parts[0].match(/([^=]+)=([\s\S]*)/);
            if (!pair) {
                console.warn("Invalid cookie header encountered. Header: '" + str + "'");
                return;
            }
            var key = pair[1];
            var value = pair[2];
            if (typeof key !== 'string' || key.length === 0 || typeof value !== 'string') {
                console.warn("Unable to extract values from cookie header. Cookie: '" + str + "'");
                return;
            }
            this.name = key;
            this.value = value;
            for(i = 1; i < parts.length; i += 1){
                pair = parts[i].match(/([^=]+)(?:=([\s\S]*))?/);
                key = pair[1].trim().toLowerCase();
                value = pair[2];
                switch(key){
                    case "httponly":
                        this.noscript = true;
                        break;
                    case "expires":
                        this.expiration_date = value ? Number(Date.parse(value)) : Infinity;
                        break;
                    case "path":
                        this.path = value ? value.trim() : "";
                        this.explicit_path = true;
                        break;
                    case "domain":
                        this.domain = value ? value.trim() : "";
                        this.explicit_domain = !!this.domain;
                        break;
                    case "secure":
                        this.secure = true;
                        break;
                }
            }
            if (!this.explicit_path) this.path = request_path || "/";
            if (!this.explicit_domain) this.domain = request_domain;
            return this;
        }
        return new Cookie().parse(str, request_domain, request_path);
    };
    Cookie.prototype.matches = function matches(access_info) {
        if (access_info === CookieAccessInfo.All) return true;
        if (this.noscript && access_info.script || this.secure && !access_info.secure || !this.collidesWith(access_info)) return false;
        return true;
    };
    Cookie.prototype.collidesWith = function collidesWith(access_info) {
        if (this.path && !access_info.path || this.domain && !access_info.domain) return false;
        if (this.path && access_info.path.indexOf(this.path) !== 0) return false;
        if (this.explicit_path && access_info.path.indexOf(this.path) !== 0) return false;
        var access_domain = access_info.domain && access_info.domain.replace(/^[\.]/, '');
        var cookie_domain = this.domain && this.domain.replace(/^[\.]/, '');
        if (cookie_domain === access_domain) return true;
        if (cookie_domain) {
            if (!this.explicit_domain) return false; // we already checked if the domains were exactly the same
            var wildcard = access_domain.indexOf(cookie_domain);
            if (wildcard === -1 || wildcard !== access_domain.length - cookie_domain.length) return false;
            return true;
        }
        return true;
    };
    function CookieJar() {
        var cookies, cookies_list, collidable_cookie;
        if (this instanceof CookieJar) {
            cookies = Object.create(null); //name: [Cookie]
            this.setCookie = function setCookie(cookie, request_domain, request_path) {
                var remove, i;
                cookie = new Cookie(cookie, request_domain, request_path);
                //Delete the cookie if the set is past the current time
                remove = cookie.expiration_date <= Date.now();
                if (cookies[cookie.name] !== undefined) {
                    cookies_list = cookies[cookie.name];
                    for(i = 0; i < cookies_list.length; i += 1){
                        collidable_cookie = cookies_list[i];
                        if (collidable_cookie.collidesWith(cookie)) {
                            if (remove) {
                                cookies_list.splice(i, 1);
                                if (cookies_list.length === 0) delete cookies[cookie.name];
                                return false;
                            }
                            cookies_list[i] = cookie;
                            return cookie;
                        }
                    }
                    if (remove) return false;
                    cookies_list.push(cookie);
                    return cookie;
                }
                if (remove) return false;
                cookies[cookie.name] = [
                    cookie
                ];
                return cookies[cookie.name];
            };
            //returns a cookie
            this.getCookie = function getCookie(cookie_name, access_info) {
                var cookie, i;
                cookies_list = cookies[cookie_name];
                if (!cookies_list) return;
                for(i = 0; i < cookies_list.length; i += 1){
                    cookie = cookies_list[i];
                    if (cookie.expiration_date <= Date.now()) {
                        if (cookies_list.length === 0) delete cookies[cookie.name];
                        continue;
                    }
                    if (cookie.matches(access_info)) return cookie;
                }
            };
            //returns a list of cookies
            this.getCookies = function getCookies(access_info) {
                var matches = [], cookie_name, cookie;
                for(cookie_name in cookies){
                    cookie = this.getCookie(cookie_name, access_info);
                    if (cookie) matches.push(cookie);
                }
                matches.toString = function toString() {
                    return matches.join(":");
                };
                matches.toValueString = function toValueString() {
                    return matches.map(function(c) {
                        return c.toValueString();
                    }).join('; ');
                };
                return matches;
            };
            return this;
        }
        return new CookieJar();
    }
    exports.CookieJar = CookieJar;
    //returns list of cookies that were set correctly. Cookies that are expired and removed are not returned.
    CookieJar.prototype.setCookies = function setCookies(cookies, request_domain, request_path) {
        cookies = Array.isArray(cookies) ? cookies : cookies.split(cookie_str_splitter);
        var successful = [], i, cookie;
        cookies = cookies.map(function(item) {
            return new Cookie(item, request_domain, request_path);
        });
        for(i = 0; i < cookies.length; i += 1){
            cookie = cookies[i];
            if (this.setCookie(cookie, request_domain, request_path)) successful.push(cookie);
        }
        return successful;
    };
})();

},{}],"emwTI":[function(require,module,exports,__globalThis) {
module.exports = require("f5ea1c83ebdab09");

},{"f5ea1c83ebdab09":"k4dlV"}],"k4dlV":[function(require,module,exports,__globalThis) {
var arrayEach = require("91cf4684b6cdc411"), baseEach = require("a10cb554d48eb7a0"), createForEach = require("ae3f902d5384df4b");
/**
 * Iterates over elements of `collection` invoking `iteratee` for each element.
 * The `iteratee` is bound to `thisArg` and invoked with three arguments:
 * (value, index|key, collection). Iteratee functions may exit iteration early
 * by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length" property
 * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
 * may be used for object iteration.
 *
 * @static
 * @memberOf _
 * @alias each
 * @category Collection
 * @param {Array|Object|string} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [thisArg] The `this` binding of `iteratee`.
 * @returns {Array|Object|string} Returns `collection`.
 * @example
 *
 * _([1, 2]).forEach(function(n) {
 *   console.log(n);
 * }).value();
 * // => logs each value from left to right and returns the array
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
 *   console.log(n, key);
 * });
 * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
 */ var forEach = createForEach(arrayEach, baseEach);
module.exports = forEach;

},{"91cf4684b6cdc411":"7vAju","a10cb554d48eb7a0":"hF7Z3","ae3f902d5384df4b":"klmT2"}],"hF7Z3":[function(require,module,exports,__globalThis) {
var baseForOwn = require("c7c737dc1cbd73c4"), createBaseEach = require("d3fc9b0f2bd05ec4");
/**
 * The base implementation of `_.forEach` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Array|Object|string} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object|string} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
module.exports = baseEach;

},{"c7c737dc1cbd73c4":"e1MTL","d3fc9b0f2bd05ec4":"iPF09"}],"e1MTL":[function(require,module,exports,__globalThis) {
var baseFor = require("557a2da7681e5c32"), keys = require("c895792e5eb17b83");
/**
 * The base implementation of `_.forOwn` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return baseFor(object, iteratee, keys);
}
module.exports = baseForOwn;

},{"557a2da7681e5c32":"jjGmc","c895792e5eb17b83":"1wIxZ"}],"1wIxZ":[function(require,module,exports,__globalThis) {
var getNative = require("2ce15773ad848000"), isArrayLike = require("465f8b5388c005c1"), isObject = require("9c3155fb0d333635"), shimKeys = require("8e94814d2ac71de1"), support = require("35513a6f08d05634");
/* Native method references for those with the same name as other `lodash` methods. */ var nativeKeys = getNative(Object, 'keys');
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ var keys = !nativeKeys ? shimKeys : function(object) {
    var Ctor = object == null ? undefined : object.constructor;
    if (typeof Ctor == 'function' && Ctor.prototype === object || (typeof object == 'function' ? support.enumPrototypes : isArrayLike(object))) return shimKeys(object);
    return isObject(object) ? nativeKeys(object) : [];
};
module.exports = keys;

},{"2ce15773ad848000":"kBeqf","465f8b5388c005c1":"6UsMq","9c3155fb0d333635":"kAgGx","8e94814d2ac71de1":"ehbct","35513a6f08d05634":"lBAKU"}],"ehbct":[function(require,module,exports,__globalThis) {
var isArguments = require("5bc1e6df5370f2f3"), isArray = require("95fe698fa472b0a2"), isIndex = require("8640ea927c9817c5"), isLength = require("2c68525711ee4233"), isString = require("25d51ca3cf9d0391"), keysIn = require("bcc4949e82e94423");
/** Used for native method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A fallback implementation of `Object.keys` which creates an array of the
 * own enumerable property names of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function shimKeys(object) {
    var props = keysIn(object), propsLength = props.length, length = propsLength && object.length;
    var allowIndexes = !!length && isLength(length) && (isArray(object) || isArguments(object) || isString(object));
    var index = -1, result = [];
    while(++index < propsLength){
        var key = props[index];
        if (allowIndexes && isIndex(key, length) || hasOwnProperty.call(object, key)) result.push(key);
    }
    return result;
}
module.exports = shimKeys;

},{"5bc1e6df5370f2f3":"eDDOa","95fe698fa472b0a2":"fOaCr","8640ea927c9817c5":"6dSPe","2c68525711ee4233":"ah6gY","25d51ca3cf9d0391":"ewvLp","bcc4949e82e94423":"gOKNs"}],"iPF09":[function(require,module,exports,__globalThis) {
var getLength = require("d51490df1db6a430"), isLength = require("e93f36effc4d47ac"), toObject = require("7b7ddbb643aed4dc");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        var length = collection ? getLength(collection) : 0;
        if (!isLength(length)) return eachFunc(collection, iteratee);
        var index = fromRight ? length : -1, iterable = toObject(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = createBaseEach;

},{"d51490df1db6a430":"kBGYK","e93f36effc4d47ac":"ah6gY","7b7ddbb643aed4dc":"9rJrG"}],"klmT2":[function(require,module,exports,__globalThis) {
var bindCallback = require("e7c02fdb539997c9"), isArray = require("4832abafdb23612c");
/**
 * Creates a function for `_.forEach` or `_.forEachRight`.
 *
 * @private
 * @param {Function} arrayFunc The function to iterate over an array.
 * @param {Function} eachFunc The function to iterate over a collection.
 * @returns {Function} Returns the new each function.
 */ function createForEach(arrayFunc, eachFunc) {
    return function(collection, iteratee, thisArg) {
        return typeof iteratee == 'function' && thisArg === undefined && isArray(collection) ? arrayFunc(collection, iteratee) : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
    };
}
module.exports = createForEach;

},{"e7c02fdb539997c9":"4VK6g","4832abafdb23612c":"fOaCr"}],"4VK6g":[function(require,module,exports,__globalThis) {
var identity = require("50205aa7db1cf604");
/**
 * A specialized version of `baseCallback` which only supports `this` binding
 * and specifying the number of arguments to provide to `func`.
 *
 * @private
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {number} [argCount] The number of arguments to provide to `func`.
 * @returns {Function} Returns the callback.
 */ function bindCallback(func, thisArg, argCount) {
    if (typeof func != 'function') return identity;
    if (thisArg === undefined) return func;
    switch(argCount){
        case 1:
            return function(value) {
                return func.call(thisArg, value);
            };
        case 3:
            return function(value, index, collection) {
                return func.call(thisArg, value, index, collection);
            };
        case 4:
            return function(accumulator, value, index, collection) {
                return func.call(thisArg, accumulator, value, index, collection);
            };
        case 5:
            return function(value, other, key, object, source) {
                return func.call(thisArg, value, other, key, object, source);
            };
    }
    return function() {
        return func.apply(thisArg, arguments);
    };
}
module.exports = bindCallback;

},{"50205aa7db1cf604":"j6dIJ"}],"5a1wa":[function(require,module,exports,__globalThis) {
var baseIndexOf = require("27386b57acb04df7"), getLength = require("21d3adcb72485cfc"), isArray = require("420a4a5e8dccabe4"), isIterateeCall = require("5e5a4526a7631f5f"), isLength = require("d0cd068f72fc3688"), isString = require("9be1abbabd4b2357"), values = require("474172780a921637");
/* Native method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * Checks if `target` is in `collection` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * for equality comparisons. If `fromIndex` is negative, it's used as the offset
 * from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @alias contains, include
 * @category Collection
 * @param {Array|Object|string} collection The collection to search.
 * @param {*} target The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
 * @returns {boolean} Returns `true` if a matching element is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
 * // => true
 *
 * _.includes('pebbles', 'eb');
 * // => true
 */ function includes(collection, target, fromIndex, guard) {
    var length = collection ? getLength(collection) : 0;
    if (!isLength(length)) {
        collection = values(collection);
        length = collection.length;
    }
    if (typeof fromIndex != 'number' || guard && isIterateeCall(target, fromIndex, guard)) fromIndex = 0;
    else fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex || 0;
    return typeof collection == 'string' || !isArray(collection) && isString(collection) ? fromIndex <= length && collection.indexOf(target, fromIndex) > -1 : !!length && baseIndexOf(collection, target, fromIndex) > -1;
}
module.exports = includes;

},{"27386b57acb04df7":"dbPkS","21d3adcb72485cfc":"kBGYK","420a4a5e8dccabe4":"fOaCr","5e5a4526a7631f5f":"3d53P","d0cd068f72fc3688":"ah6gY","9be1abbabd4b2357":"ewvLp","474172780a921637":"lcz9Q"}],"3d53P":[function(require,module,exports,__globalThis) {
var isArrayLike = require("e29d81eceedd4778"), isIndex = require("63f9812d4ea7d1d0"), isObject = require("aae8352971f9cfba");
/**
 * Checks if the provided arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
        var other = object[index];
        return value === value ? value === other : other !== other;
    }
    return false;
}
module.exports = isIterateeCall;

},{"e29d81eceedd4778":"6UsMq","63f9812d4ea7d1d0":"6dSPe","aae8352971f9cfba":"kAgGx"}],"lcz9Q":[function(require,module,exports,__globalThis) {
var baseValues = require("ba5b38e83cd7382a"), keys = require("21edbe59675093c6");
/**
 * Creates an array of the own enumerable property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function values(object) {
    return baseValues(object, keys(object));
}
module.exports = values;

},{"ba5b38e83cd7382a":"6WVwD","21edbe59675093c6":"1wIxZ"}],"6WVwD":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function baseValues(object, props) {
    var index = -1, length = props.length, result = Array(length);
    while(++index < length)result[index] = object[props[index]];
    return result;
}
module.exports = baseValues;

},{}],"aTJzX":[function(require,module,exports,__globalThis) {
'use strict';
var _ = {
    bind: require("59de08d293835368"),
    cloneDeep: require("1b4a557e1929872f"),
    find: require("e6093a9ab8240194"),
    forEach: require("65886096172bbdfc"),
    indexOf: require("2868c2d3ec09b496"),
    isArray: require("d4cee27f258a3617"),
    isObject: require("38f56c13f5249781"),
    isFunction: require("77ed0f73e266693a"),
    isPlainObject: require("91f2779e268a37b1"),
    isUndefined: require("a13b9912526d3943")
};
var auth = require("53588027645da7d3");
var helpers = require("e34faa71a19eb196");
var Model = require("ad7ed480b3ce53b");
var Operation = require("7c04186ffd5720c6");
var OperationGroup = require("7edebbf15fc3f266");
var Resolver = require("9a5a1093c3fd0deb");
var SwaggerHttp = require("fadc86f39579eb45");
var SwaggerSpecConverter = require("2d5eff50fbc60bf8");
var Q = require("99cf7190227d3a66");
// We have to keep track of the function/property names to avoid collisions for tag names which are used to allow the
// following usage: 'client.{tagName}'
var reservedClientTags = [
    'apis',
    'authorizationScheme',
    'authorizations',
    'basePath',
    'build',
    'buildFrom1_1Spec',
    'buildFrom1_2Spec',
    'buildFromSpec',
    'clientAuthorizations',
    'convertInfo',
    'debug',
    'defaultErrorCallback',
    'defaultSuccessCallback',
    'enableCookies',
    'fail',
    'failure',
    'finish',
    'help',
    'host',
    'idFromOp',
    'info',
    'initialize',
    'isBuilt',
    'isValid',
    'modelPropertyMacro',
    'models',
    'modelsArray',
    'options',
    'parameterMacro',
    'parseUri',
    'progress',
    'resourceCount',
    'sampleModels',
    'selfReflect',
    'setConsolidatedModels',
    'spec',
    'supportedSubmitMethods',
    'swaggerRequestHeaders',
    'tagFromLabel',
    'title',
    'url',
    'useJQuery',
    'jqueryAjaxCache'
];
// We have to keep track of the function/property names to avoid collisions for tag names which are used to allow the
// following usage: 'client.apis.{tagName}'
var reservedApiTags = [
    'apis',
    'asCurl',
    'description',
    'externalDocs',
    'help',
    'label',
    'name',
    'operation',
    'operations',
    'operationsArray',
    'path',
    'tag'
];
var supportedOperationMethods = [
    'delete',
    'get',
    'head',
    'options',
    'patch',
    'post',
    'put'
];
var SwaggerClient = module.exports = function(url, options) {
    this.authorizations = null;
    this.authorizationScheme = null;
    this.basePath = null;
    this.debug = false;
    this.enableCookies = false;
    this.info = null;
    this.isBuilt = false;
    this.isValid = false;
    this.modelsArray = [];
    this.resourceCount = 0;
    this.url = null;
    this.useJQuery = false;
    this.jqueryAjaxCache = false;
    this.swaggerObject = {};
    this.deferredClient = undefined;
    this.clientAuthorizations = new auth.SwaggerAuthorizations();
    if (typeof url !== 'undefined') return this.initialize(url, options);
    else return this;
};
SwaggerClient.prototype.initialize = function(url, options) {
    this.models = {};
    this.sampleModels = {};
    if (typeof url === 'string') this.url = url;
    else if (_.isObject(url)) {
        options = url;
        this.url = options.url;
    }
    if (this.url && this.url.indexOf('http:') === -1 && this.url.indexOf('https:') === -1) // no protocol, so we can only use window if it exists
    {
        if (typeof window !== 'undefined' && window && window.location) this.url = window.location.origin + this.url;
    }
    options = options || {};
    this.clientAuthorizations.add(options.authorizations);
    this.swaggerRequestHeaders = options.swaggerRequestHeaders || 'application/json;charset=utf-8,*/*';
    this.defaultSuccessCallback = options.defaultSuccessCallback || null;
    this.defaultErrorCallback = options.defaultErrorCallback || null;
    this.modelPropertyMacro = options.modelPropertyMacro || null;
    this.parameterMacro = options.parameterMacro || null;
    this.usePromise = options.usePromise || null;
    // operation request timeout default
    this.timeout = options.timeout || null;
    // default to request timeout when not specified
    this.fetchSpecTimeout = typeof options.fetchSpecTimeout !== 'undefined' ? options.fetchSpecTimeout : options.timeout || null;
    if (this.usePromise) this.deferredClient = Q.defer();
    if (typeof options.success === 'function') this.success = options.success;
    if (options.useJQuery) this.useJQuery = options.useJQuery;
    if (options.jqueryAjaxCache) this.jqueryAjaxCache = options.jqueryAjaxCache;
    if (options.enableCookies) this.enableCookies = options.enableCookies;
    this.options = options || {};
    // maybe don't need this?
    this.options.timeout = this.timeout;
    this.options.fetchSpecTimeout = this.fetchSpecTimeout;
    this.supportedSubmitMethods = options.supportedSubmitMethods || [];
    this.failure = options.failure || function(err) {
        throw err;
    };
    this.progress = options.progress || function() {};
    this.spec = _.cloneDeep(options.spec); // Clone so we do not alter the provided document
    if (options.scheme) this.scheme = options.scheme;
    if (this.usePromise || typeof options.success === 'function') {
        this.ready = true;
        return this.build();
    }
};
SwaggerClient.prototype.build = function(mock) {
    if (this.isBuilt) return this;
    var self = this;
    if (this.spec) this.progress('fetching resource list; Please wait.');
    else this.progress('fetching resource list: ' + this.url + '; Please wait.');
    var obj = {
        useJQuery: this.useJQuery,
        jqueryAjaxCache: this.jqueryAjaxCache,
        url: this.url,
        method: 'get',
        headers: {
            accept: this.swaggerRequestHeaders
        },
        on: {
            error: function(response) {
                if (self.url.substring(0, 4) !== 'http') return self.fail('Please specify the protocol for ' + self.url);
                else if (response.errObj && (response.errObj.code === 'ECONNABORTED' || response.errObj.message.indexOf('timeout') !== -1)) return self.fail('Request timed out after ' + self.fetchSpecTimeout + 'ms');
                else if (response.status === 0) return self.fail('Can\'t read from server.  It may not have the appropriate access-control-origin settings.');
                else if (response.status === 404) return self.fail('Can\'t read swagger JSON from ' + self.url);
                else return self.fail(response.status + ' : ' + response.statusText + ' ' + self.url);
            },
            response: function(resp) {
                var responseObj = resp.obj;
                if (!responseObj) return self.fail('failed to parse JSON/YAML response');
                self.swaggerVersion = responseObj.swaggerVersion;
                self.swaggerObject = responseObj;
                if (responseObj.swagger && parseInt(responseObj.swagger) === 2) {
                    self.swaggerVersion = responseObj.swagger;
                    new Resolver().resolve(responseObj, self.url, self.buildFromSpec, self);
                    self.isValid = true;
                } else {
                    var converter = new SwaggerSpecConverter();
                    self.oldSwaggerObject = self.swaggerObject;
                    converter.setDocumentationLocation(self.url);
                    converter.convert(responseObj, self.clientAuthorizations, self.options, function(spec) {
                        self.swaggerObject = spec;
                        new Resolver().resolve(spec, self.url, self.buildFromSpec, self);
                        self.isValid = true;
                    });
                }
            }
        }
    };
    // only set timeout when specified
    if (this.fetchSpecTimeout) obj.timeout = this.fetchSpecTimeout;
    if (this.spec) {
        self.swaggerObject = this.spec;
        setTimeout(function() {
            new Resolver().resolve(self.spec, self.url, self.buildFromSpec, self);
        }, 10);
    } else {
        this.clientAuthorizations.apply(obj);
        if (mock) return obj;
        new SwaggerHttp().execute(obj, this.options);
    }
    return this.usePromise ? this.deferredClient.promise : this;
};
SwaggerClient.prototype.buildFromSpec = function(response) {
    if (this.isBuilt) return this;
    this.apis = {};
    this.apisArray = [];
    this.basePath = response.basePath || '';
    this.consumes = response.consumes;
    this.host = response.host || '';
    this.info = response.info || {};
    this.produces = response.produces;
    this.schemes = response.schemes || [];
    this.securityDefinitions = response.securityDefinitions;
    this.security = response.security;
    this.title = response.title || '';
    if (response.externalDocs) this.externalDocs = response.externalDocs;
    // legacy support
    this.authSchemes = response.securityDefinitions;
    var definedTags = {};
    var k;
    if (Array.isArray(response.tags)) {
        definedTags = {};
        for(k = 0; k < response.tags.length; k++){
            var t = response.tags[k];
            definedTags[t.name] = t;
        }
    }
    var location;
    if (typeof this.url === 'string') {
        location = this.parseUri(this.url);
        if (typeof this.scheme === 'undefined' && typeof this.schemes === 'undefined' || this.schemes.length === 0) {
            if (typeof window !== 'undefined') // use the window scheme
            this.scheme = window.location.protocol.replace(':', '');
            else this.scheme = location.scheme || 'http';
        } else if (typeof this.scheme === 'undefined') {
            if (typeof window !== 'undefined') {
                var scheme = window.location.protocol.replace(':', '');
                if (scheme === 'https' && this.schemes.indexOf(scheme) === -1) {
                    // can't call http from https served page in a browser!
                    helpers.log('Cannot call a http server from https inside a browser!');
                    this.scheme = 'http';
                } else if (this.schemes.indexOf(scheme) !== -1) this.scheme = scheme;
                else if (this.schemes.indexOf('https') !== -1) this.scheme = 'https';
                else this.scheme = 'http';
            } else this.scheme = this.schemes[0] || location.scheme;
        }
        if (typeof this.host === 'undefined' || this.host === '') {
            this.host = location.host;
            if (location.port) this.host = this.host + ':' + location.port;
        }
    } else {
        if (typeof this.schemes === 'undefined' || this.schemes.length === 0) this.scheme = 'http';
        else if (typeof this.scheme === 'undefined') this.scheme = this.schemes[0];
    }
    this.definitions = response.definitions;
    var key;
    for(key in this.definitions){
        var model = new Model(key, this.definitions[key], this.models, this.modelPropertyMacro);
        if (model) this.models[key] = model;
    }
    // get paths, create functions for each operationId
    var self = this;
    // Bind help to 'client.apis'
    self.apis.help = _.bind(self.help, self);
    _.forEach(response.paths, function(pathObj, path) {
        // Only process a path if it's an object
        if (!_.isPlainObject(pathObj)) return;
        _.forEach(supportedOperationMethods, function(method) {
            var operation = pathObj[method];
            if (_.isUndefined(operation)) // Operation does not exist
            return;
            else if (!_.isPlainObject(operation)) {
                // Operation exists but it is not an Operation Object.  Since this is invalid, log it.
                helpers.log('The \'' + method + '\' operation for \'' + path + '\' path is not an Operation Object');
                return;
            }
            var tags = operation.tags;
            if (_.isUndefined(tags) || !_.isArray(tags) || tags.length === 0) tags = operation.tags = [
                'default'
            ];
            var operationId = self.idFromOp(path, method, operation);
            var operationObject = new Operation(self, operation.scheme, operationId, method, path, operation, self.definitions, self.models, self.clientAuthorizations);
            // bind self operation's execute command to the api
            _.forEach(tags, function(tag) {
                var clientProperty = _.indexOf(reservedClientTags, tag) > -1 ? '_' + tag : tag;
                var apiProperty = _.indexOf(reservedApiTags, tag) > -1 ? '_' + tag : tag;
                var operationGroup = self[clientProperty];
                if (clientProperty !== tag) helpers.log('The \'' + tag + '\' tag conflicts with a SwaggerClient function/property name.  Use \'client.' + clientProperty + '\' or \'client.apis.' + tag + '\' instead of \'client.' + tag + '\'.');
                if (apiProperty !== tag) helpers.log('The \'' + tag + '\' tag conflicts with a SwaggerClient operation function/property name.  Use ' + '\'client.apis.' + apiProperty + '\' instead of \'client.apis.' + tag + '\'.');
                if (_.indexOf(reservedApiTags, operationId) > -1) {
                    helpers.log('The \'' + operationId + '\' operationId conflicts with a SwaggerClient operation ' + 'function/property name.  Use \'client.apis.' + apiProperty + '._' + operationId + '\' instead of \'client.apis.' + apiProperty + '.' + operationId + '\'.');
                    operationId = '_' + operationId;
                    operationObject.nickname = operationId; // So 'client.apis.[tag].operationId.help() works properly
                }
                if (_.isUndefined(operationGroup)) {
                    operationGroup = self[clientProperty] = self.apis[apiProperty] = {};
                    operationGroup.operations = {};
                    operationGroup.label = apiProperty;
                    operationGroup.apis = {};
                    var tagDef = definedTags[tag];
                    if (!_.isUndefined(tagDef)) {
                        operationGroup.description = tagDef.description;
                        operationGroup.externalDocs = tagDef.externalDocs;
                    }
                    self[clientProperty].help = _.bind(self.help, operationGroup);
                    self.apisArray.push(new OperationGroup(tag, operationGroup.description, operationGroup.externalDocs, operationObject));
                }
                operationId = self.makeUniqueOperationId(operationId, self.apis[apiProperty]);
                // Bind tag help
                if (!_.isFunction(operationGroup.help)) operationGroup.help = _.bind(self.help, operationGroup);
                // bind to the apis object
                self.apis[apiProperty][operationId] = operationGroup[operationId] = _.bind(operationObject.execute, operationObject);
                self.apis[apiProperty][operationId].help = operationGroup[operationId].help = _.bind(operationObject.help, operationObject);
                self.apis[apiProperty][operationId].asCurl = operationGroup[operationId].asCurl = _.bind(operationObject.asCurl, operationObject);
                operationGroup.apis[operationId] = operationGroup.operations[operationId] = operationObject;
                // legacy UI feature
                var api = _.find(self.apisArray, function(api) {
                    return api.tag === tag;
                });
                if (api) api.operationsArray.push(operationObject);
            });
        });
    });
    // sort the apisArray according to the tags
    var sortedApis = [];
    _.forEach(Object.keys(definedTags), function(tag) {
        var pos;
        for(pos in self.apisArray){
            var _api = self.apisArray[pos];
            if (_api && tag === _api.name) {
                sortedApis.push(_api);
                self.apisArray[pos] = null;
            }
        }
    });
    // add anything left
    _.forEach(self.apisArray, function(api) {
        if (api) sortedApis.push(api);
    });
    self.apisArray = sortedApis;
    _.forEach(response.definitions, function(definitionObj, definition) {
        definitionObj.id = definition.toLowerCase();
        definitionObj.name = definition;
        self.modelsArray.push(definitionObj);
    });
    this.isBuilt = true;
    if (this.usePromise) {
        this.isValid = true;
        this.isBuilt = true;
        this.deferredClient.resolve(this);
        return this.deferredClient.promise;
    }
    if (this.success) this.success();
    return this;
};
SwaggerClient.prototype.makeUniqueOperationId = function(operationId, api) {
    var count = 0;
    var name = operationId;
    // make unique across this operation group
    while(true){
        var matched = false;
        _.forEach(api.operations, function(operation) {
            if (operation.nickname === name) matched = true;
        });
        if (!matched) return name;
        name = operationId + '_' + count;
        count++;
    }
    return operationId;
};
SwaggerClient.prototype.parseUri = function(uri) {
    var urlParseRE = /^(((([^:\/#\?]+:)?(?:(\/\/)((?:(([^:@\/#\?]+)(?:\:([^:@\/#\?]+))?)@)?(([^:\/#\?\]\[]+|\[[^\/\]@#?]+\])(?:\:([0-9]+))?))?)?)?((\/?(?:[^\/\?#]+\/+)*)([^\?#]*)))?(\?[^#]+)?)(#.*)?/;
    var parts = urlParseRE.exec(uri);
    return {
        scheme: parts[4] ? parts[4].replace(':', '') : undefined,
        host: parts[11],
        port: parts[12],
        path: parts[15]
    };
};
SwaggerClient.prototype.help = function(dontPrint) {
    var output = '';
    if (this instanceof SwaggerClient) _.forEach(this.apis, function(api, name) {
        if (_.isPlainObject(api)) {
            output += 'operations for the \'' + name + '\' tag\n';
            _.forEach(api.operations, function(operation, name) {
                output += '  * ' + name + ': ' + operation.summary + '\n';
            });
        }
    });
    else if (this instanceof OperationGroup || _.isPlainObject(this)) {
        output += 'operations for the \'' + this.label + '\' tag\n';
        _.forEach(this.apis, function(operation, name) {
            output += '  * ' + name + ': ' + operation.summary + '\n';
        });
    }
    if (dontPrint) return output;
    else {
        helpers.log(output);
        return output;
    }
};
SwaggerClient.prototype.tagFromLabel = function(label) {
    return label;
};
SwaggerClient.prototype.idFromOp = function(path, httpMethod, op) {
    if (!op || !op.operationId) {
        op = op || {};
        op.operationId = httpMethod + '_' + path;
    }
    var opId = op.operationId.replace(/[\s!@#$%^&*()_+=\[{\]};:<>|.\/?,\\'""-]/g, '_') || path.substring(1) + '_' + httpMethod;
    opId = opId.replace(/((_){2,})/g, '_');
    opId = opId.replace(/^(_)*/g, '');
    opId = opId.replace(/([_])*$/g, '');
    return opId;
};
SwaggerClient.prototype.setHost = function(host) {
    this.host = host;
    if (this.apis) _.forEach(this.apis, function(api) {
        if (api.operations) _.forEach(api.operations, function(operation) {
            operation.host = host;
        });
    });
};
SwaggerClient.prototype.setBasePath = function(basePath) {
    this.basePath = basePath;
    if (this.apis) _.forEach(this.apis, function(api) {
        if (api.operations) _.forEach(api.operations, function(operation) {
            operation.basePath = basePath;
        });
    });
};
SwaggerClient.prototype.setSchemes = function(schemes) {
    this.schemes = schemes;
    if (schemes && schemes.length > 0) {
        if (this.apis) _.forEach(this.apis, function(api) {
            if (api.operations) _.forEach(api.operations, function(operation) {
                operation.scheme = schemes[0];
            });
        });
    }
};
SwaggerClient.prototype.fail = function(message) {
    if (this.usePromise) {
        this.deferredClient.reject(message);
        return this.deferredClient.promise;
    } else if (this.failure) this.failure(message);
    else this.failure(message);
};

},{"59de08d293835368":"88dJQ","1b4a557e1929872f":"lgoPK","e6093a9ab8240194":"aPrFS","65886096172bbdfc":"k4dlV","2868c2d3ec09b496":"hcpb9","d4cee27f258a3617":"fOaCr","38f56c13f5249781":"kAgGx","77ed0f73e266693a":"7K3Vo","91f2779e268a37b1":"3iMXW","a13b9912526d3943":"lKXOz","53588027645da7d3":"035Fw","e34faa71a19eb196":"jrGf3","ad7ed480b3ce53b":"kQ1i6","7c04186ffd5720c6":"93e4n","7edebbf15fc3f266":"ijKzP","9a5a1093c3fd0deb":"lp813","fadc86f39579eb45":"lF2n0","2d5eff50fbc60bf8":"daNwX","99cf7190227d3a66":"hoTdJ"}],"88dJQ":[function(require,module,exports,__globalThis) {
var createWrapper = require("e0b388ff87118ddd"), replaceHolders = require("735413ad2766f467"), restParam = require("fe22cdee55556380");
/** Used to compose bitmasks for wrapper metadata. */ var BIND_FLAG = 1, PARTIAL_FLAG = 32;
/**
 * Creates a function that invokes `func` with the `this` binding of `thisArg`
 * and prepends any additional `_.bind` arguments to those provided to the
 * bound function.
 *
 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for partially applied arguments.
 *
 * **Note:** Unlike native `Function#bind` this method does not set the "length"
 * property of bound functions.
 *
 * @static
 * @memberOf _
 * @category Function
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new bound function.
 * @example
 *
 * var greet = function(greeting, punctuation) {
 *   return greeting + ' ' + this.user + punctuation;
 * };
 *
 * var object = { 'user': 'fred' };
 *
 * var bound = _.bind(greet, object, 'hi');
 * bound('!');
 * // => 'hi fred!'
 *
 * // using placeholders
 * var bound = _.bind(greet, object, _, '!');
 * bound('hi');
 * // => 'hi fred!'
 */ var bind = restParam(function(func, thisArg, partials) {
    var bitmask = BIND_FLAG;
    if (partials.length) {
        var holders = replaceHolders(partials, bind.placeholder);
        bitmask |= PARTIAL_FLAG;
    }
    return createWrapper(func, bitmask, thisArg, partials, holders);
});
// Assign default placeholders.
bind.placeholder = {};
module.exports = bind;

},{"e0b388ff87118ddd":"16ZGT","735413ad2766f467":"gooc2","fe22cdee55556380":"6LY9I"}],"16ZGT":[function(require,module,exports,__globalThis) {
var baseSetData = require("10d12242f0af957e"), createBindWrapper = require("6634131b707515c1"), createHybridWrapper = require("75635cdad43e67a6"), createPartialWrapper = require("35b5ed651cfdf57f"), getData = require("332ccd1bcf7f170d"), mergeData = require("643b85c1e330aadc"), setData = require("e2e72a3fc3a3e524");
/** Used to compose bitmasks for wrapper metadata. */ var BIND_FLAG = 1, BIND_KEY_FLAG = 2, PARTIAL_FLAG = 32, PARTIAL_RIGHT_FLAG = 64;
/** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = 'Expected a function';
/* Native method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to reference.
 * @param {number} bitmask The bitmask of flags.
 *  The bitmask may be composed of the following flags:
 *     1 - `_.bind`
 *     2 - `_.bindKey`
 *     4 - `_.curry` or `_.curryRight` of a bound function
 *     8 - `_.curry`
 *    16 - `_.curryRight`
 *    32 - `_.partial`
 *    64 - `_.partialRight`
 *   128 - `_.rearg`
 *   256 - `_.ary`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
    var isBindKey = bitmask & BIND_KEY_FLAG;
    if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    var length = partials ? partials.length : 0;
    if (!length) {
        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
    }
    length -= holders ? holders.length : 0;
    if (bitmask & PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials, holdersRight = holders;
        partials = holders = undefined;
    }
    var data = isBindKey ? undefined : getData(func), newData = [
        func,
        bitmask,
        thisArg,
        partials,
        holders,
        partialsRight,
        holdersRight,
        argPos,
        ary,
        arity
    ];
    if (data) {
        mergeData(newData, data);
        bitmask = newData[1];
        arity = newData[9];
    }
    newData[9] = arity == null ? isBindKey ? 0 : func.length : nativeMax(arity - length, 0) || 0;
    if (bitmask == BIND_FLAG) var result = createBindWrapper(newData[0], newData[2]);
    else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) result = createPartialWrapper.apply(undefined, newData);
    else result = createHybridWrapper.apply(undefined, newData);
    var setter = data ? baseSetData : setData;
    return setter(result, newData);
}
module.exports = createWrapper;

},{"10d12242f0af957e":"4dBgR","6634131b707515c1":"2TViX","75635cdad43e67a6":"iH1rF","35b5ed651cfdf57f":"jJ29f","332ccd1bcf7f170d":"ekZEq","643b85c1e330aadc":"aMQEH","e2e72a3fc3a3e524":"bkMxb"}],"4dBgR":[function(require,module,exports,__globalThis) {
var identity = require("54549fdf2736f1ed"), metaMap = require("4784527062aa813");
/**
 * The base implementation of `setData` without support for hot loop detection.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var baseSetData = !metaMap ? identity : function(func, data) {
    metaMap.set(func, data);
    return func;
};
module.exports = baseSetData;

},{"54549fdf2736f1ed":"j6dIJ","4784527062aa813":"5bhFA"}],"5bhFA":[function(require,module,exports,__globalThis) {
var global = arguments[3];
var getNative = require("84647aa630723161");
/** Native method references. */ var WeakMap = getNative(global, 'WeakMap');
/** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
module.exports = metaMap;

},{"84647aa630723161":"kBeqf"}],"2TViX":[function(require,module,exports,__globalThis) {
var global = arguments[3];
var createCtorWrapper = require("c1f917f38951c6de");
/**
 * Creates a function that wraps `func` and invokes it with the `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to bind.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new bound function.
 */ function createBindWrapper(func, thisArg) {
    var Ctor = createCtorWrapper(func);
    function wrapper() {
        var fn = this && this !== global && this instanceof wrapper ? Ctor : func;
        return fn.apply(thisArg, arguments);
    }
    return wrapper;
}
module.exports = createBindWrapper;

},{"c1f917f38951c6de":"iItVb"}],"iItVb":[function(require,module,exports,__globalThis) {
var baseCreate = require("c57d514c385e0d3d"), isObject = require("14eabf936f5bc88a");
/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */ function createCtorWrapper(Ctor) {
    return function() {
        // Use a `switch` statement to work with class constructors.
        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch(args.length){
            case 0:
                return new Ctor;
            case 1:
                return new Ctor(args[0]);
            case 2:
                return new Ctor(args[0], args[1]);
            case 3:
                return new Ctor(args[0], args[1], args[2]);
            case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
    };
}
module.exports = createCtorWrapper;

},{"c57d514c385e0d3d":"kc9LV","14eabf936f5bc88a":"kAgGx"}],"kc9LV":[function(require,module,exports,__globalThis) {
var isObject = require("5937d21ec258e9eb");
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(prototype) {
        if (isObject(prototype)) {
            object.prototype = prototype;
            var result = new object;
            object.prototype = undefined;
        }
        return result || {};
    };
}();
module.exports = baseCreate;

},{"5937d21ec258e9eb":"kAgGx"}],"iH1rF":[function(require,module,exports,__globalThis) {
var global = arguments[3];
var arrayCopy = require("3de335edf6c3ad2c"), composeArgs = require("79615714229d476a"), composeArgsRight = require("bc324fb5012e4682"), createCtorWrapper = require("69e29d0631dc30ff"), isLaziable = require("1b8d97a832940703"), reorder = require("bd02dcd98fbb3924"), replaceHolders = require("bc32d77594aa3b92"), setData = require("4fad2b679000d374");
/** Used to compose bitmasks for wrapper metadata. */ var BIND_FLAG = 1, BIND_KEY_FLAG = 2, CURRY_BOUND_FLAG = 4, CURRY_FLAG = 8, CURRY_RIGHT_FLAG = 16, PARTIAL_FLAG = 32, PARTIAL_RIGHT_FLAG = 64, ARY_FLAG = 128;
/* Native method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * Creates a function that wraps `func` and invokes it with optional `this`
 * binding of, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to reference.
 * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
    var isAry = bitmask & ARY_FLAG, isBind = bitmask & BIND_FLAG, isBindKey = bitmask & BIND_KEY_FLAG, isCurry = bitmask & CURRY_FLAG, isCurryBound = bitmask & CURRY_BOUND_FLAG, isCurryRight = bitmask & CURRY_RIGHT_FLAG, Ctor = isBindKey ? undefined : createCtorWrapper(func);
    function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it to other functions.
        var length = arguments.length, index = length, args = Array(length);
        while(index--)args[index] = arguments[index];
        if (partials) args = composeArgs(args, partials, holders);
        if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight);
        if (isCurry || isCurryRight) {
            var placeholder = wrapper.placeholder, argsHolders = replaceHolders(args, placeholder);
            length -= argsHolders.length;
            if (length < arity) {
                var newArgPos = argPos ? arrayCopy(argPos) : undefined, newArity = nativeMax(arity - length, 0), newsHolders = isCurry ? argsHolders : undefined, newHoldersRight = isCurry ? undefined : argsHolders, newPartials = isCurry ? args : undefined, newPartialsRight = isCurry ? undefined : args;
                bitmask |= isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG;
                bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
                if (!isCurryBound) bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
                var newData = [
                    func,
                    bitmask,
                    thisArg,
                    newPartials,
                    newsHolders,
                    newPartialsRight,
                    newHoldersRight,
                    newArgPos,
                    ary,
                    newArity
                ], result = createHybridWrapper.apply(undefined, newData);
                if (isLaziable(func)) setData(result, newData);
                result.placeholder = placeholder;
                return result;
            }
        }
        var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
        if (argPos) args = reorder(args, argPos);
        if (isAry && ary < args.length) args.length = ary;
        if (this && this !== global && this instanceof wrapper) fn = Ctor || createCtorWrapper(func);
        return fn.apply(thisBinding, args);
    }
    return wrapper;
}
module.exports = createHybridWrapper;

},{"3de335edf6c3ad2c":"k3qSK","79615714229d476a":"lONKG","bc324fb5012e4682":"iOKg2","69e29d0631dc30ff":"iItVb","1b8d97a832940703":"j0gkv","bd02dcd98fbb3924":"2Nmpi","bc32d77594aa3b92":"gooc2","4fad2b679000d374":"bkMxb"}],"k3qSK":[function(require,module,exports,__globalThis) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function arrayCopy(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = arrayCopy;

},{}],"lONKG":[function(require,module,exports,__globalThis) {
/* Native method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array|Object} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @returns {Array} Returns the new array of composed arguments.
 */ function composeArgs(args, partials, holders) {
    var holdersLength = holders.length, argsIndex = -1, argsLength = nativeMax(args.length - holdersLength, 0), leftIndex = -1, leftLength = partials.length, result = Array(leftLength + argsLength);
    while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
    while(++argsIndex < holdersLength)result[holders[argsIndex]] = args[argsIndex];
    while(argsLength--)result[leftIndex++] = args[argsIndex++];
    return result;
}
module.exports = composeArgs;

},{}],"iOKg2":[function(require,module,exports,__globalThis) {
/* Native method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array|Object} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @returns {Array} Returns the new array of composed arguments.
 */ function composeArgsRight(args, partials, holders) {
    var holdersIndex = -1, holdersLength = holders.length, argsIndex = -1, argsLength = nativeMax(args.length - holdersLength, 0), rightIndex = -1, rightLength = partials.length, result = Array(argsLength + rightLength);
    while(++argsIndex < argsLength)result[argsIndex] = args[argsIndex];
    var offset = argsIndex;
    while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
    while(++holdersIndex < holdersLength)result[offset + holders[holdersIndex]] = args[argsIndex++];
    return result;
}
module.exports = composeArgsRight;

},{}],"j0gkv":[function(require,module,exports,__globalThis) {
var LazyWrapper = require("c4a442b44122f2f3"), getData = require("e19a252aedaf1340"), getFuncName = require("cc0dde0390b8dafd"), lodash = require("c380381cd7119145");
/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
 */ function isLaziable(func) {
    var funcName = getFuncName(func), other = lodash[funcName];
    if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
    if (func === other) return true;
    var data = getData(other);
    return !!data && func === data[0];
}
module.exports = isLaziable;

},{"c4a442b44122f2f3":"ggSG5","e19a252aedaf1340":"ekZEq","cc0dde0390b8dafd":"caNYa","c380381cd7119145":"e5csc"}],"ggSG5":[function(require,module,exports,__globalThis) {
var baseCreate = require("96871f32b049164a"), baseLodash = require("a882644be5a0690f");
/** Used as references for `-Infinity` and `Infinity`. */ var POSITIVE_INFINITY = Number.POSITIVE_INFINITY;
/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @param {*} value The value to wrap.
 */ function LazyWrapper(value) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__dir__ = 1;
    this.__filtered__ = false;
    this.__iteratees__ = [];
    this.__takeCount__ = POSITIVE_INFINITY;
    this.__views__ = [];
}
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;
module.exports = LazyWrapper;

},{"96871f32b049164a":"kc9LV","a882644be5a0690f":"6sesA"}],"6sesA":[function(require,module,exports,__globalThis) {
/**
 * The function whose prototype all chaining wrappers inherit from.
 *
 * @private
 */ function baseLodash() {
// No operation performed.
}
module.exports = baseLodash;

},{}],"ekZEq":[function(require,module,exports,__globalThis) {
var metaMap = require("5b9ac751e4c65cf2"), noop = require("b5ec272f5f5a14f1");
/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */ var getData = !metaMap ? noop : function(func) {
    return metaMap.get(func);
};
module.exports = getData;

},{"5b9ac751e4c65cf2":"5bhFA","b5ec272f5f5a14f1":"4NTPB"}],"4NTPB":[function(require,module,exports,__globalThis) {
/**
 * A no-operation function that returns `undefined` regardless of the
 * arguments it receives.
 *
 * @static
 * @memberOf _
 * @category Utility
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.noop(object) === undefined;
 * // => true
 */ function noop() {
// No operation performed.
}
module.exports = noop;

},{}],"caNYa":[function(require,module,exports,__globalThis) {
var realNames = require("c2d4d97bab832791");
/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */ function getFuncName(func) {
    var result = func.name + '', array = realNames[result], length = array ? array.length : 0;
    while(length--){
        var data = array[length], otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) return data.name;
    }
    return result;
}
module.exports = getFuncName;

},{"c2d4d97bab832791":"goSk8"}],"goSk8":[function(require,module,exports,__globalThis) {
/** Used to lookup unminified function names. */ var realNames = {};
module.exports = realNames;

},{}],"e5csc":[function(require,module,exports,__globalThis) {
var LazyWrapper = require("ac0abded625ebcf8"), LodashWrapper = require("4f78e3384f02173d"), baseLodash = require("ca07e5efaa00ab21"), isArray = require("eb2cafe49dcb318b"), isObjectLike = require("13ba92c01618da3b"), wrapperClone = require("69bf4dee1f32ebab");
/** Used for native method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates a `lodash` object which wraps `value` to enable implicit chaining.
 * Methods that operate on and return arrays, collections, and functions can
 * be chained together. Methods that retrieve a single value or may return a
 * primitive value will automatically end the chain returning the unwrapped
 * value. Explicit chaining may be enabled using `_.chain`. The execution of
 * chained methods is lazy, that is, execution is deferred until `_#value`
 * is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
 * fusion is an optimization strategy which merge iteratee calls; this can help
 * to avoid the creation of intermediate data structures and greatly reduce the
 * number of iteratee executions.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
 * `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
 * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
 * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
 * and `where`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
 * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
 * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
 * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
 * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
 * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
 * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
 * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
 * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
 * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
 * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
 * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
 * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
 * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
 * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
 * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
 * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
 * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
 * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
 * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
 * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
 * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
 * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
 * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
 * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
 * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
 * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
 * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
 * `unescape`, `uniqueId`, `value`, and `words`
 *
 * The wrapper method `sample` will return a wrapped value when `n` is provided,
 * otherwise an unwrapped value is returned.
 *
 * @name _
 * @constructor
 * @category Chain
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // returns an unwrapped value
 * wrapped.reduce(function(total, n) {
 *   return total + n;
 * });
 * // => 6
 *
 * // returns a wrapped value
 * var squares = wrapped.map(function(n) {
 *   return n * n;
 * });
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */ function lodash(value) {
    if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) return value;
        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
    }
    return new LodashWrapper(value);
}
// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
module.exports = lodash;

},{"ac0abded625ebcf8":"ggSG5","4f78e3384f02173d":"j4xoh","ca07e5efaa00ab21":"6sesA","eb2cafe49dcb318b":"fOaCr","13ba92c01618da3b":"1EGfv","69bf4dee1f32ebab":"8Bsfw"}],"j4xoh":[function(require,module,exports,__globalThis) {
var baseCreate = require("88f3a5e9849bb18d"), baseLodash = require("54ce8ec86684e2b9");
/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
 * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
 */ function LodashWrapper(value, chainAll, actions) {
    this.__wrapped__ = value;
    this.__actions__ = actions || [];
    this.__chain__ = !!chainAll;
}
LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;
module.exports = LodashWrapper;

},{"88f3a5e9849bb18d":"kc9LV","54ce8ec86684e2b9":"6sesA"}],"8Bsfw":[function(require,module,exports,__globalThis) {
var LazyWrapper = require("dc6657cfa63e71bd"), LodashWrapper = require("5e1edeaf794f4da5"), arrayCopy = require("fc132580844dbaeb");
/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */ function wrapperClone(wrapper) {
    return wrapper instanceof LazyWrapper ? wrapper.clone() : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
}
module.exports = wrapperClone;

},{"dc6657cfa63e71bd":"ggSG5","5e1edeaf794f4da5":"j4xoh","fc132580844dbaeb":"k3qSK"}],"2Nmpi":[function(require,module,exports,__globalThis) {
var arrayCopy = require("ddbf96e97c4ce11e"), isIndex = require("9a3e9563b2042084");
/* Native method references for those with the same name as other `lodash` methods. */ var nativeMin = Math.min;
/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */ function reorder(array, indexes) {
    var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = arrayCopy(array);
    while(length--){
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
    }
    return array;
}
module.exports = reorder;

},{"ddbf96e97c4ce11e":"k3qSK","9a3e9563b2042084":"6dSPe"}],"gooc2":[function(require,module,exports,__globalThis) {
/** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */ function replaceHolders(array, placeholder) {
    var index = -1, length = array.length, resIndex = -1, result = [];
    while(++index < length)if (array[index] === placeholder) {
        array[index] = PLACEHOLDER;
        result[++resIndex] = index;
    }
    return result;
}
module.exports = replaceHolders;

},{}],"bkMxb":[function(require,module,exports,__globalThis) {
var baseSetData = require("433d67d482d020c9"), now = require("63296a47743fce43");
/** Used to detect when a function becomes hot. */ var HOT_COUNT = 150, HOT_SPAN = 16;
/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity function
 * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var setData = function() {
    var count = 0, lastCalled = 0;
    return function(key, value) {
        var stamp = now(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return key;
        } else count = 0;
        return baseSetData(key, value);
    };
}();
module.exports = setData;

},{"433d67d482d020c9":"4dBgR","63296a47743fce43":"1henq"}],"1henq":[function(require,module,exports,__globalThis) {
var getNative = require("aa281a32afb635b");
/* Native method references for those with the same name as other `lodash` methods. */ var nativeNow = getNative(Date, 'now');
/**
 * Gets the number of milliseconds that have elapsed since the Unix epoch
 * (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @category Date
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => logs the number of milliseconds it took for the deferred function to be invoked
 */ var now = nativeNow || function() {
    return new Date().getTime();
};
module.exports = now;

},{"aa281a32afb635b":"kBeqf"}],"jJ29f":[function(require,module,exports,__globalThis) {
var global = arguments[3];
var createCtorWrapper = require("a79808e8b9d2975a");
/** Used to compose bitmasks for wrapper metadata. */ var BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` and invokes it with the optional `this`
 * binding of `thisArg` and the `partials` prepended to those provided to
 * the wrapper.
 *
 * @private
 * @param {Function} func The function to partially apply arguments to.
 * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to the new function.
 * @returns {Function} Returns the new bound function.
 */ function createPartialWrapper(func, bitmask, thisArg, partials) {
    var isBind = bitmask & BIND_FLAG, Ctor = createCtorWrapper(func);
    function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it `func`.
        var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength);
        while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
        while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
        var fn = this && this !== global && this instanceof wrapper ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, args);
    }
    return wrapper;
}
module.exports = createPartialWrapper;

},{"a79808e8b9d2975a":"iItVb"}],"aMQEH":[function(require,module,exports,__globalThis) {
var arrayCopy = require("5a2596b7d7af2727"), composeArgs = require("120be7ec8f9b5883"), composeArgsRight = require("1cfb101a75309fa0"), replaceHolders = require("8abefa33d2c40a71");
/** Used to compose bitmasks for wrapper metadata. */ var BIND_FLAG = 1, CURRY_BOUND_FLAG = 4, CURRY_FLAG = 8, ARY_FLAG = 128, REARG_FLAG = 256;
/** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
/* Native method references for those with the same name as other `lodash` methods. */ var nativeMin = Math.min;
/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers required to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
 * augment function arguments, making the order in which they are executed important,
 * preventing the merging of metadata. However, we make an exception for a safe
 * common case where curried functions have `_.ary` and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */ function mergeData(data, source) {
    var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < ARY_FLAG;
    var isCombo = srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG || srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8] || srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG;
    // Exit early if metadata can't be merged.
    if (!(isCommon || isCombo)) return data;
    // Use source `thisArg` if available.
    if (srcBitmask & BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & BIND_FLAG ? 0 : CURRY_BOUND_FLAG;
    }
    // Compose partial arguments.
    var value = source[3];
    if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
    }
    // Compose partial right arguments.
    value = source[5];
    if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
    }
    // Use source `argPos` if available.
    value = source[7];
    if (value) data[7] = arrayCopy(value);
    // Use source `ary` if it's smaller.
    if (srcBitmask & ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
    // Use source `arity` if one is not provided.
    if (data[9] == null) data[9] = source[9];
    // Use source `func` and merge bitmasks.
    data[0] = source[0];
    data[1] = newBitmask;
    return data;
}
module.exports = mergeData;

},{"5a2596b7d7af2727":"k3qSK","120be7ec8f9b5883":"lONKG","1cfb101a75309fa0":"iOKg2","8abefa33d2c40a71":"gooc2"}],"6LY9I":[function(require,module,exports,__globalThis) {
/** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = 'Expected a function';
/* Native method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * Creates a function that invokes `func` with the `this` binding of the
 * created function and arguments from `start` and beyond provided as an array.
 *
 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/Web/JavaScript/Reference/Functions/rest_parameters).
 *
 * @static
 * @memberOf _
 * @category Function
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var say = _.restParam(function(what, names) {
 *   return what + ' ' + _.initial(names).join(', ') +
 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
 * });
 *
 * say('hello', 'fred', 'barney', 'pebbles');
 * // => 'hello fred, barney, & pebbles'
 */ function restParam(func, start) {
    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    start = nativeMax(start === undefined ? func.length - 1 : +start || 0, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), rest = Array(length);
        while(++index < length)rest[index] = args[start + index];
        switch(start){
            case 0:
                return func.call(this, rest);
            case 1:
                return func.call(this, args[0], rest);
            case 2:
                return func.call(this, args[0], args[1], rest);
        }
        var otherArgs = Array(start + 1);
        index = -1;
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = rest;
        return func.apply(this, otherArgs);
    };
}
module.exports = restParam;

},{}],"lgoPK":[function(require,module,exports,__globalThis) {
var baseClone = require("4a7ff1a3351a0a65"), bindCallback = require("8c8f16abe37d856d");
/**
 * Creates a deep clone of `value`. If `customizer` is provided it's invoked
 * to produce the cloned values. If `customizer` returns `undefined` cloning
 * is handled by the method instead. The `customizer` is bound to `thisArg`
 * and invoked with up to three argument; (value [, index|key, object]).
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
 * The enumerable properties of `arguments` objects and objects created by
 * constructors other than `Object` are cloned to plain `Object` objects. An
 * empty object is returned for uncloneable values such as functions, DOM nodes,
 * Maps, Sets, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to deep clone.
 * @param {Function} [customizer] The function to customize cloning values.
 * @param {*} [thisArg] The `this` binding of `customizer`.
 * @returns {*} Returns the deep cloned value.
 * @example
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * var deep = _.cloneDeep(users);
 * deep[0] === users[0];
 * // => false
 *
 * // using a customizer callback
 * var el = _.cloneDeep(document.body, function(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(true);
 *   }
 * });
 *
 * el === document.body
 * // => false
 * el.nodeName
 * // => BODY
 * el.childNodes.length;
 * // => 20
 */ function cloneDeep(value, customizer, thisArg) {
    return typeof customizer == 'function' ? baseClone(value, true, bindCallback(customizer, thisArg, 3)) : baseClone(value, true);
}
module.exports = cloneDeep;

},{"4a7ff1a3351a0a65":"bmmE1","8c8f16abe37d856d":"4VK6g"}],"bmmE1":[function(require,module,exports,__globalThis) {
var arrayCopy = require("58e64402e7c510a3"), arrayEach = require("79b49bd6c61591f8"), baseAssign = require("3aec1efd09e19b89"), baseForOwn = require("b3611aab0970f2e6"), initCloneArray = require("6c3264e664dae5b2"), initCloneByTag = require("a118981861c944e7"), initCloneObject = require("5f91883f0285c603"), isArray = require("c9ea897588922463"), isHostObject = require("c1452d51d2439fae"), isObject = require("70cfe19164b46595");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[stringTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[mapTag] = cloneableTags[setTag] = cloneableTags[weakMapTag] = false;
/** Used for native method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var objToString = objectProto.toString;
/**
 * The base implementation of `_.clone` without support for argument juggling
 * and `this` binding `customizer` functions.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {Function} [customizer] The function to customize cloning values.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The object `value` belongs to.
 * @param {Array} [stackA=[]] Tracks traversed source objects.
 * @param {Array} [stackB=[]] Associates clones with source counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
    var result;
    if (customizer) result = object ? customizer(value, key, object) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return arrayCopy(value, result);
    } else {
        var tag = objToString.call(value), isFunc = tag == funcTag;
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            if (isHostObject(value)) return object ? value : {};
            result = initCloneObject(isFunc ? {} : value);
            if (!isDeep) return baseAssign(result, value);
        } else return cloneableTags[tag] ? initCloneByTag(value, tag, isDeep) : object ? value : {};
    }
    // Check for circular references and return its corresponding clone.
    stackA || (stackA = []);
    stackB || (stackB = []);
    var length = stackA.length;
    while(length--){
        if (stackA[length] == value) return stackB[length];
    }
    // Add the source value to the stack of traversed objects and associate it with its clone.
    stackA.push(value);
    stackB.push(result);
    // Recursively populate clone (susceptible to call stack limits).
    (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
    });
    return result;
}
module.exports = baseClone;

},{"58e64402e7c510a3":"k3qSK","79b49bd6c61591f8":"7vAju","3aec1efd09e19b89":"6BbfO","b3611aab0970f2e6":"e1MTL","6c3264e664dae5b2":"7U8fn","a118981861c944e7":"95Qnn","5f91883f0285c603":"1xGWZ","c9ea897588922463":"fOaCr","c1452d51d2439fae":"3RGsa","70cfe19164b46595":"kAgGx"}],"6BbfO":[function(require,module,exports,__globalThis) {
var baseCopy = require("ccf72247beddfa8"), keys = require("60fe21d0d899ad5f");
/**
 * The base implementation of `_.assign` without support for argument juggling,
 * multiple sources, and `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return source == null ? object : baseCopy(source, keys(source), object);
}
module.exports = baseAssign;

},{"ccf72247beddfa8":"aJ3pM","60fe21d0d899ad5f":"1wIxZ"}],"aJ3pM":[function(require,module,exports,__globalThis) {
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property names to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @returns {Object} Returns `object`.
 */ function baseCopy(source, props, object) {
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        object[key] = source[key];
    }
    return object;
}
module.exports = baseCopy;

},{}],"7U8fn":[function(require,module,exports,__globalThis) {
/** Used for native method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add array properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = initCloneArray;

},{}],"95Qnn":[function(require,module,exports,__globalThis) {
var global = arguments[3];
var bufferClone = require("af15a14d2e4c28cf");
/** `Object#toString` result references. */ var boolTag = '[object Boolean]', dateTag = '[object Date]', numberTag = '[object Number]', regexpTag = '[object RegExp]', stringTag = '[object String]';
var arrayBufferTag = '[object ArrayBuffer]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/** Native method references. */ var Uint8Array = global.Uint8Array;
/** Used to lookup a type array constructors by `toStringTag`. */ var ctorByTag = {};
ctorByTag[float32Tag] = global.Float32Array;
ctorByTag[float64Tag] = global.Float64Array;
ctorByTag[int8Tag] = global.Int8Array;
ctorByTag[int16Tag] = global.Int16Array;
ctorByTag[int32Tag] = global.Int32Array;
ctorByTag[uint8Tag] = Uint8Array;
ctorByTag[uint8ClampedTag] = global.Uint8ClampedArray;
ctorByTag[uint16Tag] = global.Uint16Array;
ctorByTag[uint32Tag] = global.Uint32Array;
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return bufferClone(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            // Safari 5 mobile incorrectly has `Object` as the constructor of typed arrays.
            if (Ctor instanceof Ctor) Ctor = ctorByTag[tag];
            var buffer = object.buffer;
            return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            var result = new Ctor(object.source, reFlags.exec(object));
            result.lastIndex = object.lastIndex;
    }
    return result;
}
module.exports = initCloneByTag;

},{"af15a14d2e4c28cf":"02vF2"}],"02vF2":[function(require,module,exports,__globalThis) {
/** Native method references. */ var global = arguments[3];
var ArrayBuffer = global.ArrayBuffer, Uint8Array = global.Uint8Array;
/**
 * Creates a clone of the given array buffer.
 *
 * @private
 * @param {ArrayBuffer} buffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function bufferClone(buffer) {
    var result = new ArrayBuffer(buffer.byteLength), view = new Uint8Array(result);
    view.set(new Uint8Array(buffer));
    return result;
}
module.exports = bufferClone;

},{}],"1xGWZ":[function(require,module,exports,__globalThis) {
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    var Ctor = object.constructor;
    if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) Ctor = Object;
    return new Ctor;
}
module.exports = initCloneObject;

},{}],"aPrFS":[function(require,module,exports,__globalThis) {
var baseEach = require("ace8af108514ce6b"), createFind = require("64dc8979067b862b");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is bound to `thisArg` and
 * invoked with three arguments: (value, index|key, collection).
 *
 * If a property name is provided for `predicate` the created `_.property`
 * style callback returns the property value of the given element.
 *
 * If a value is also provided for `thisArg` the created `_.matchesProperty`
 * style callback returns `true` for elements that have a matching property
 * value, else `false`.
 *
 * If an object is provided for `predicate` the created `_.matches` style
 * callback returns `true` for elements that have the properties of the given
 * object, else `false`.
 *
 * @static
 * @memberOf _
 * @alias detect
 * @category Collection
 * @param {Array|Object|string} collection The collection to search.
 * @param {Function|Object|string} [predicate=_.identity] The function invoked
 *  per iteration.
 * @param {*} [thisArg] The `this` binding of `predicate`.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.result(_.find(users, function(chr) {
 *   return chr.age < 40;
 * }), 'user');
 * // => 'barney'
 *
 * // using the `_.matches` callback shorthand
 * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
 * // => 'pebbles'
 *
 * // using the `_.matchesProperty` callback shorthand
 * _.result(_.find(users, 'active', false), 'user');
 * // => 'fred'
 *
 * // using the `_.property` callback shorthand
 * _.result(_.find(users, 'active'), 'user');
 * // => 'barney'
 */ var find = createFind(baseEach);
module.exports = find;

},{"ace8af108514ce6b":"hF7Z3","64dc8979067b862b":"eiQk4"}],"eiQk4":[function(require,module,exports,__globalThis) {
var baseCallback = require("2847d6de42da155c"), baseFind = require("848627331e771676"), baseFindIndex = require("c51548074a69407a"), isArray = require("5462dc77ee5e82c7");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new find function.
 */ function createFind(eachFunc, fromRight) {
    return function(collection, predicate, thisArg) {
        predicate = baseCallback(predicate, thisArg, 3);
        if (isArray(collection)) {
            var index = baseFindIndex(collection, predicate, fromRight);
            return index > -1 ? collection[index] : undefined;
        }
        return baseFind(collection, predicate, eachFunc);
    };
}
module.exports = createFind;

},{"2847d6de42da155c":"g5e3s","848627331e771676":"3PoZP","c51548074a69407a":"ccid9","5462dc77ee5e82c7":"fOaCr"}],"g5e3s":[function(require,module,exports,__globalThis) {
var baseMatches = require("e937900e8011f7bb"), baseMatchesProperty = require("8d041bad89a42461"), bindCallback = require("680c509d4ab92777"), identity = require("322399344b9d70b6"), property = require("9181cc27a3dbe45a");
/**
 * The base implementation of `_.callback` which supports specifying the
 * number of arguments to provide to `func`.
 *
 * @private
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {number} [argCount] The number of arguments to provide to `func`.
 * @returns {Function} Returns the callback.
 */ function baseCallback(func, thisArg, argCount) {
    var type = typeof func;
    if (type == 'function') return thisArg === undefined ? func : bindCallback(func, thisArg, argCount);
    if (func == null) return identity;
    if (type == 'object') return baseMatches(func);
    return thisArg === undefined ? property(func) : baseMatchesProperty(func, thisArg);
}
module.exports = baseCallback;

},{"e937900e8011f7bb":"8bH3m","8d041bad89a42461":"32QtX","680c509d4ab92777":"4VK6g","322399344b9d70b6":"j6dIJ","9181cc27a3dbe45a":"eCKgb"}],"8bH3m":[function(require,module,exports,__globalThis) {
var baseIsMatch = require("72ec95970add1a1a"), getMatchData = require("fb9d062733d8778e"), toObject = require("f95ae7271f2217ab");
/**
 * The base implementation of `_.matches` which does not clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) {
        var key = matchData[0][0], value = matchData[0][1];
        return function(object) {
            if (object == null) return false;
            object = toObject(object);
            return object[key] === value && (value !== undefined || key in object);
        };
    }
    return function(object) {
        return baseIsMatch(object, matchData);
    };
}
module.exports = baseMatches;

},{"72ec95970add1a1a":"5Jeng","fb9d062733d8778e":"axYTw","f95ae7271f2217ab":"9rJrG"}],"5Jeng":[function(require,module,exports,__globalThis) {
var baseIsEqual = require("431c92fcee02c869"), toObject = require("b9b3e5b22a196054");
/**
 * The base implementation of `_.isMatch` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Array} matchData The propery names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparing objects.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = toObject(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var result = customizer ? customizer(objValue, srcValue, key) : undefined;
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) return false;
        }
    }
    return true;
}
module.exports = baseIsMatch;

},{"431c92fcee02c869":"hicVQ","b9b3e5b22a196054":"9rJrG"}],"hicVQ":[function(require,module,exports,__globalThis) {
var baseIsEqualDeep = require("7a623922f4dccd68"), isObject = require("30884be5094d163d"), isObjectLike = require("8055c596342cfa03");
/**
 * The base implementation of `_.isEqual` without support for `this` binding
 * `customizer` functions.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparing values.
 * @param {boolean} [isLoose] Specify performing partial comparisons.
 * @param {Array} [stackA] Tracks traversed `value` objects.
 * @param {Array} [stackB] Tracks traversed `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
    if (value === other) return true;
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
}
module.exports = baseIsEqual;

},{"7a623922f4dccd68":"4jlvh","30884be5094d163d":"kAgGx","8055c596342cfa03":"1EGfv"}],"4jlvh":[function(require,module,exports,__globalThis) {
var equalArrays = require("60a5482ef02d2554"), equalByTag = require("4d5bfd9ea504b7d9"), equalObjects = require("9c3c3f5ad71ad0d3"), isArray = require("587cb46580a4f87"), isHostObject = require("9df0bb358e1c557c"), isTypedArray = require("2dcb47fc7adb44cd");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', objectTag = '[object Object]';
/** Used for native method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var objToString = objectProto.toString;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparing objects.
 * @param {boolean} [isLoose] Specify performing partial comparisons.
 * @param {Array} [stackA=[]] Tracks traversed `value` objects.
 * @param {Array} [stackB=[]] Tracks traversed `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
        objTag = objToString.call(object);
        if (objTag == argsTag) objTag = objectTag;
        else if (objTag != objectTag) objIsArr = isTypedArray(object);
    }
    if (!othIsArr) {
        othTag = objToString.call(other);
        if (othTag == argsTag) othTag = objectTag;
        else if (othTag != objectTag) othIsArr = isTypedArray(other);
    }
    var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
    if (isSameTag && !(objIsArr || objIsObj)) return equalByTag(object, other, objTag);
    if (!isLoose) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
    }
    if (!isSameTag) return false;
    // Assume cyclic values are equal.
    // For more information on detecting circular references see https://es5.github.io/#JO.
    stackA || (stackA = []);
    stackB || (stackB = []);
    var length = stackA.length;
    while(length--){
        if (stackA[length] == object) return stackB[length] == other;
    }
    // Add `object` and `other` to the stack of traversed objects.
    stackA.push(object);
    stackB.push(other);
    var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
    stackA.pop();
    stackB.pop();
    return result;
}
module.exports = baseIsEqualDeep;

},{"60a5482ef02d2554":"5s5ng","4d5bfd9ea504b7d9":"30Oqi","9c3c3f5ad71ad0d3":"lXGp4","587cb46580a4f87":"fOaCr","9df0bb358e1c557c":"3RGsa","2dcb47fc7adb44cd":"lO6GJ"}],"5s5ng":[function(require,module,exports,__globalThis) {
var arraySome = require("7c1169f6a591fc");
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparing arrays.
 * @param {boolean} [isLoose] Specify performing partial comparisons.
 * @param {Array} [stackA] Tracks traversed `value` objects.
 * @param {Array} [stackB] Tracks traversed `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
    var index = -1, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isLoose && othLength > arrLength)) return false;
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index], result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
        if (result !== undefined) {
            if (result) continue;
            return false;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (isLoose) {
            if (!arraySome(other, function(othValue) {
                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
            })) return false;
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) return false;
    }
    return true;
}
module.exports = equalArrays;

},{"7c1169f6a591fc":"2H20t"}],"2H20t":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.some` for arrays without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = arraySome;

},{}],"30Oqi":[function(require,module,exports,__globalThis) {
/** `Object#toString` result references. */ var boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', numberTag = '[object Number]', regexpTag = '[object RegExp]', stringTag = '[object String]';
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag) {
    switch(tag){
        case boolTag:
        case dateTag:
            // Coerce dates and booleans to numbers, dates to milliseconds and booleans
            // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
            return +object == +other;
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case numberTag:
            // Treat `NaN` vs. `NaN` as equal.
            return object != +object ? other != +other : object == +other;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings primitives and string
            // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
            return object == other + '';
    }
    return false;
}
module.exports = equalByTag;

},{}],"lXGp4":[function(require,module,exports,__globalThis) {
var keys = require("3c6d9ec8dd2919b0");
/** Used for native method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparing values.
 * @param {boolean} [isLoose] Specify performing partial comparisons.
 * @param {Array} [stackA] Tracks traversed `value` objects.
 * @param {Array} [stackB] Tracks traversed `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
    var objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isLoose) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    var skipCtor = isLoose;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key], result = customizer ? customizer(isLoose ? othValue : objValue, isLoose ? objValue : othValue, key) : undefined;
        // Recursively compare objects (susceptible to call stack limits).
        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) return false;
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (!skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) return false;
    }
    return true;
}
module.exports = equalObjects;

},{"3c6d9ec8dd2919b0":"1wIxZ"}],"lO6GJ":[function(require,module,exports,__globalThis) {
var isLength = require("d3b5aff77318f51"), isObjectLike = require("b66bde811801341e");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Used for native method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var objToString = objectProto.toString;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ function isTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
}
module.exports = isTypedArray;

},{"d3b5aff77318f51":"ah6gY","b66bde811801341e":"1EGfv"}],"axYTw":[function(require,module,exports,__globalThis) {
var isStrictComparable = require("595b8172e472ddaa"), pairs = require("928b34289a325c14");
/**
 * Gets the propery names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = pairs(object), length = result.length;
    while(length--)result[length][2] = isStrictComparable(result[length][1]);
    return result;
}
module.exports = getMatchData;

},{"595b8172e472ddaa":"h9f1M","928b34289a325c14":"9cZuy"}],"h9f1M":[function(require,module,exports,__globalThis) {
var isObject = require("112aa793a00eaf9a");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
module.exports = isStrictComparable;

},{"112aa793a00eaf9a":"kAgGx"}],"9cZuy":[function(require,module,exports,__globalThis) {
var keys = require("dd673baa2dce11b"), toObject = require("d5c32635937f59f2");
/**
 * Creates a two dimensional array of the key-value pairs for `object`,
 * e.g. `[[key1, value1], [key2, value2]]`.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the new array of key-value pairs.
 * @example
 *
 * _.pairs({ 'barney': 36, 'fred': 40 });
 * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
 */ function pairs(object) {
    object = toObject(object);
    var index = -1, props = keys(object), length = props.length, result = Array(length);
    while(++index < length){
        var key = props[index];
        result[index] = [
            key,
            object[key]
        ];
    }
    return result;
}
module.exports = pairs;

},{"dd673baa2dce11b":"1wIxZ","d5c32635937f59f2":"9rJrG"}],"32QtX":[function(require,module,exports,__globalThis) {
var baseGet = require("56e3c80d82b354b6"), baseIsEqual = require("87d3bd4faf33098b"), baseSlice = require("bf2289b1797b84e1"), isArray = require("4abac827dc6361ed"), isKey = require("a3943500eec032c1"), isStrictComparable = require("ab8f024fc32bd8d9"), last = require("d29ecb90e182c3db"), toObject = require("2ebe2879eb90b366"), toPath = require("bfe064fe8f021ee4");
/**
 * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to compare.
 * @returns {Function} Returns the new function.
 */ function baseMatchesProperty(path, srcValue) {
    var isArr = isArray(path), isCommon = isKey(path) && isStrictComparable(srcValue), pathKey = path + '';
    path = toPath(path);
    return function(object) {
        if (object == null) return false;
        var key = pathKey;
        object = toObject(object);
        if ((isArr || !isCommon) && !(key in object)) {
            object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
            if (object == null) return false;
            key = last(path);
            object = toObject(object);
        }
        return object[key] === srcValue ? srcValue !== undefined || key in object : baseIsEqual(srcValue, object[key], undefined, true);
    };
}
module.exports = baseMatchesProperty;

},{"56e3c80d82b354b6":"cp1OB","87d3bd4faf33098b":"hicVQ","bf2289b1797b84e1":"eJya5","4abac827dc6361ed":"fOaCr","a3943500eec032c1":"bDNeI","ab8f024fc32bd8d9":"h9f1M","d29ecb90e182c3db":"159To","2ebe2879eb90b366":"9rJrG","bfe064fe8f021ee4":"byXl1"}],"cp1OB":[function(require,module,exports,__globalThis) {
var toObject = require("ee28103dd1452034");
/**
 * The base implementation of `get` without support for string paths
 * and default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path of the property to get.
 * @param {string} [pathKey] The key representation of path.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path, pathKey) {
    if (object == null) return;
    object = toObject(object);
    if (pathKey !== undefined && pathKey in object) path = [
        pathKey
    ];
    var index = 0, length = path.length;
    while(object != null && index < length)object = toObject(object)[path[index++]];
    return index && index == length ? object : undefined;
}
module.exports = baseGet;

},{"ee28103dd1452034":"9rJrG"}],"eJya5":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function baseSlice(array, start, end) {
    var index = -1, length = array.length;
    start = start == null ? 0 : +start || 0;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end === undefined || end > length ? length : +end || 0;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = baseSlice;

},{}],"bDNeI":[function(require,module,exports,__globalThis) {
var isArray = require("aa9836de498c4539"), toObject = require("184327e1be7734ae");
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    var type = typeof value;
    if (type == 'string' && reIsPlainProp.test(value) || type == 'number') return true;
    if (isArray(value)) return false;
    var result = !reIsDeepProp.test(value);
    return result || object != null && value in toObject(object);
}
module.exports = isKey;

},{"aa9836de498c4539":"fOaCr","184327e1be7734ae":"9rJrG"}],"159To":[function(require,module,exports,__globalThis) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function last(array) {
    var length = array ? array.length : 0;
    return length ? array[length - 1] : undefined;
}
module.exports = last;

},{}],"byXl1":[function(require,module,exports,__globalThis) {
var baseToString = require("8695e130acc91130"), isArray = require("fb003eaf0cca1ebb");
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `value` to property path array if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Array} Returns the property path array.
 */ function toPath(value) {
    if (isArray(value)) return value;
    var result = [];
    baseToString(value).replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
}
module.exports = toPath;

},{"8695e130acc91130":"gi28G","fb003eaf0cca1ebb":"fOaCr"}],"gi28G":[function(require,module,exports,__globalThis) {
/**
 * Converts `value` to a string if it's not one. An empty string is returned
 * for `null` or `undefined` values.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    return value == null ? '' : value + '';
}
module.exports = baseToString;

},{}],"eCKgb":[function(require,module,exports,__globalThis) {
var baseProperty = require("b9c6fb32266a9c41"), basePropertyDeep = require("118225bdd7e4b6c1"), isKey = require("75028f2483a3e64c");
/**
 * Creates a function that returns the property value at `path` on a
 * given object.
 *
 * @static
 * @memberOf _
 * @category Utility
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': { 'c': 2 } } },
 *   { 'a': { 'b': { 'c': 1 } } }
 * ];
 *
 * _.map(objects, _.property('a.b.c'));
 * // => [2, 1]
 *
 * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
}
module.exports = property;

},{"b9c6fb32266a9c41":"8i6R2","118225bdd7e4b6c1":"3Gvg9","75028f2483a3e64c":"bDNeI"}],"3Gvg9":[function(require,module,exports,__globalThis) {
var baseGet = require("42d8f28905b8099"), toPath = require("73df1a7a7362ffe");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new function.
 */ function basePropertyDeep(path) {
    var pathKey = path + '';
    path = toPath(path);
    return function(object) {
        return baseGet(object, path, pathKey);
    };
}
module.exports = basePropertyDeep;

},{"42d8f28905b8099":"cp1OB","73df1a7a7362ffe":"byXl1"}],"3PoZP":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
 * without support for callback shorthands and `this` binding, which iterates
 * over `collection` using the provided `eachFunc`.
 *
 * @private
 * @param {Array|Object|string} collection The collection to search.
 * @param {Function} predicate The function invoked per iteration.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @param {boolean} [retKey] Specify returning the key of the found element
 *  instead of the element itself.
 * @returns {*} Returns the found element or its key, else `undefined`.
 */ function baseFind(collection, predicate, eachFunc, retKey) {
    var result;
    eachFunc(collection, function(value, key, collection) {
        if (predicate(value, key, collection)) {
            result = retKey ? key : value;
            return false;
        }
    });
    return result;
}
module.exports = baseFind;

},{}],"ccid9":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for callback shorthands and `this` binding.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {Function} predicate The function invoked per iteration.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseFindIndex(array, predicate, fromRight) {
    var length = array.length, index = fromRight ? length : -1;
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = baseFindIndex;

},{}],"lKXOz":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function isUndefined(value) {
    return value === undefined;
}
module.exports = isUndefined;

},{}],"kQ1i6":[function(require,module,exports,__globalThis) {
'use strict';
var log = require("ee9bd478ae5d3057").log;
var _ = {
    isPlainObject: require("89997754fc279496"),
    isString: require("50033b80bd95f9c3")
};
var SchemaMarkup = require("4c6fa022d4decf20");
var jsyaml = require("6bd71deaa6e06566");
var Model = module.exports = function(name, definition, models, modelPropertyMacro) {
    this.definition = definition || {};
    this.isArray = definition.type === 'array';
    this.models = models || {};
    this.name = name || definition.title || 'Inline Model';
    this.modelPropertyMacro = modelPropertyMacro || function(property) {
        return property.default;
    };
    return this;
};
// Note!  This function will be removed in 2.2.x!
Model.prototype.createJSONSample = Model.prototype.getSampleValue = function(modelsToIgnore) {
    modelsToIgnore = modelsToIgnore || {};
    modelsToIgnore[this.name] = this;
    // Response support
    if (this.examples && _.isPlainObject(this.examples) && this.examples['application/json']) {
        this.definition.example = this.examples['application/json'];
        if (_.isString(this.definition.example)) this.definition.example = jsyaml.safeLoad(this.definition.example);
    } else if (!this.definition.example) this.definition.example = this.examples;
    return SchemaMarkup.schemaToJSON(this.definition, this.models, modelsToIgnore, this.modelPropertyMacro);
};
Model.prototype.getMockSignature = function() {
    return SchemaMarkup.schemaToHTML(this.name, this.definition, this.models, this.modelPropertyMacro);
};

},{"ee9bd478ae5d3057":"jrGf3","89997754fc279496":"3iMXW","50033b80bd95f9c3":"ewvLp","4c6fa022d4decf20":"cH9it","6bd71deaa6e06566":"63vik"}],"cH9it":[function(require,module,exports,__globalThis) {
'use strict';
var Helpers = require("a732758aeab31bf6");
var _ = {
    isPlainObject: require("9e5c423113e040eb"),
    isUndefined: require("41933284a730463b"),
    isArray: require("b22214ca08f50b1d"),
    isObject: require("9dd8e58b9cc3764d"),
    isEmpty: require("f3f4dcc4ed87b97e"),
    map: require("9174e757fed28518"),
    indexOf: require("4bc8303c0e0fa32f"),
    cloneDeep: require("94260c17e05c2c34"),
    keys: require("b9a879d97ef327a7"),
    forEach: require("4cf12c1989ab011b")
};
module.exports.optionHtml = optionHtml;
module.exports.typeFromJsonSchema = typeFromJsonSchema;
module.exports.getStringSignature = getStringSignature;
module.exports.schemaToHTML = schemaToHTML;
module.exports.schemaToJSON = schemaToJSON;
function optionHtml(label, value) {
    return '<tr><td class="optionName">' + label + ':</td><td>' + value + '</td></tr>';
}
function typeFromJsonSchema(type, format) {
    var str;
    if (type === 'integer' && format === 'int32') str = 'integer';
    else if (type === 'integer' && format === 'int64') str = 'long';
    else if (type === 'integer' && typeof format === 'undefined') str = 'long';
    else if (type === 'string' && format === 'date-time') str = 'date-time';
    else if (type === 'string' && format === 'date') str = 'date';
    else if (type === 'number' && format === 'float') str = 'float';
    else if (type === 'number' && format === 'double') str = 'double';
    else if (type === 'number' && typeof format === 'undefined') str = 'double';
    else if (type === 'boolean') str = 'boolean';
    else if (type === 'string') str = 'string';
    return str;
}
function getStringSignature(obj, baseComponent) {
    var str = '';
    if (typeof obj.$ref !== 'undefined') str += Helpers.simpleRef(obj.$ref);
    else if (typeof obj.type === 'undefined') str += 'object';
    else if (obj.type === 'array') {
        if (baseComponent) str += getStringSignature(obj.items || obj.$ref || {});
        else {
            str += 'Array[';
            str += getStringSignature(obj.items || obj.$ref || {});
            str += ']';
        }
    } else if (obj.type === 'integer' && obj.format === 'int32') str += 'integer';
    else if (obj.type === 'integer' && obj.format === 'int64') str += 'long';
    else if (obj.type === 'integer' && typeof obj.format === 'undefined') str += 'long';
    else if (obj.type === 'string' && obj.format === 'date-time') str += 'date-time';
    else if (obj.type === 'string' && obj.format === 'date') str += 'date';
    else if (obj.type === 'string' && typeof obj.format === 'undefined') str += 'string';
    else if (obj.type === 'number' && obj.format === 'float') str += 'float';
    else if (obj.type === 'number' && obj.format === 'double') str += 'double';
    else if (obj.type === 'number' && typeof obj.format === 'undefined') str += 'double';
    else if (obj.type === 'boolean') str += 'boolean';
    else if (obj.$ref) str += Helpers.simpleRef(obj.$ref);
    else str += obj.type;
    return str;
}
function schemaToJSON(schema, models, modelsToIgnore, modelPropertyMacro) {
    // Resolve the schema (Handle nested schemas)
    schema = Helpers.resolveSchema(schema);
    if (typeof modelPropertyMacro !== 'function') modelPropertyMacro = function(prop) {
        return (prop || {}).default;
    };
    modelsToIgnore = modelsToIgnore || {};
    var type = schema.type || 'object';
    var format = schema.format;
    var model;
    var output;
    if (!_.isUndefined(schema.example)) output = schema.example;
    else if (_.isUndefined(schema.items) && _.isArray(schema.enum)) output = schema.enum[0];
    if (_.isUndefined(output)) {
        if (schema.$ref) {
            model = models[Helpers.simpleRef(schema.$ref)];
            if (!_.isUndefined(model)) {
                if (_.isUndefined(modelsToIgnore[model.name])) {
                    modelsToIgnore[model.name] = model;
                    output = schemaToJSON(model.definition, models, modelsToIgnore, modelPropertyMacro);
                    delete modelsToIgnore[model.name];
                } else if (model.type === 'array') output = [];
                else output = {};
            }
        } else if (!_.isUndefined(schema.default)) output = schema.default;
        else if (type === 'string') {
            if (format === 'date-time') output = new Date().toISOString();
            else if (format === 'date') output = new Date().toISOString().split('T')[0];
            else output = 'string';
        } else if (type === 'integer') output = 0;
        else if (type === 'number') output = 0.0;
        else if (type === 'boolean') output = true;
        else if (type === 'object') {
            output = {};
            _.forEach(schema.properties, function(property, name) {
                var cProperty = _.cloneDeep(property);
                // Allow macro to set the default value
                cProperty.default = modelPropertyMacro(property);
                output[name] = schemaToJSON(cProperty, models, modelsToIgnore, modelPropertyMacro);
            });
        } else if (type === 'array') {
            output = [];
            if (_.isArray(schema.items)) _.forEach(schema.items, function(item) {
                output.push(schemaToJSON(item, models, modelsToIgnore, modelPropertyMacro));
            });
            else if (_.isPlainObject(schema.items)) output.push(schemaToJSON(schema.items, models, modelsToIgnore, modelPropertyMacro));
            else if (_.isUndefined(schema.items)) output.push({});
            else Helpers.log('Array type\'s \'items\' property is not an array or an object, cannot process');
        }
    }
    return output;
}
function schemaToHTML(name, schema, models, modelPropertyMacro) {
    var strongOpen = '<span class="strong">';
    var strongClose = '</span>';
    // Allow for ignoring the 'name' argument.... shifting the rest
    if (_.isObject(arguments[0])) {
        name = void 0;
        schema = arguments[0];
        models = arguments[1];
        modelPropertyMacro = arguments[2];
    }
    models = models || {};
    // Resolve the schema (Handle nested schemas)
    schema = Helpers.resolveSchema(schema);
    // Return for empty object
    if (_.isEmpty(schema)) return strongOpen + 'Empty' + strongClose;
    // Dereference $ref from 'models'
    if (typeof schema.$ref === 'string') {
        name = Helpers.simpleRef(schema.$ref);
        schema = models[name];
        if (typeof schema === 'undefined') return strongOpen + name + ' is not defined!' + strongClose;
    }
    if (typeof name !== 'string') name = schema.title || 'Inline Model';
    // If we are a Model object... adjust accordingly
    if (schema.definition) schema = schema.definition;
    if (typeof modelPropertyMacro !== 'function') modelPropertyMacro = function(prop) {
        return (prop || {}).default;
    };
    var references = {};
    var seenModels = [];
    var inlineModels = 0;
    // Generate current HTML
    var html = processModel(schema, name);
    // Generate references HTML
    while(_.keys(references).length > 0)/* jshint ignore:start */ _.forEach(references, function(schema, name) {
        var seenModel = _.indexOf(seenModels, name) > -1;
        delete references[name];
        if (!seenModel) {
            seenModels.push(name);
            html += '<br />' + processModel(schema, name);
        }
    });
    return html;
    /////////////////////////////////
    function addReference(schema, name, skipRef) {
        var modelName = name;
        var model;
        if (schema.$ref) {
            modelName = schema.title || Helpers.simpleRef(schema.$ref);
            model = models[modelName];
        } else if (_.isUndefined(name)) {
            modelName = schema.title || 'Inline Model ' + ++inlineModels;
            model = {
                definition: schema
            };
        }
        if (skipRef !== true) references[modelName] = _.isUndefined(model) ? {} : model.definition;
        return modelName;
    }
    function primitiveToHTML(schema) {
        var html = '<span class="propType">';
        var type = schema.type || 'object';
        if (schema.$ref) html += addReference(schema, Helpers.simpleRef(schema.$ref));
        else if (type === 'object') {
            if (!_.isUndefined(schema.properties)) html += addReference(schema);
            else html += 'object';
        } else if (type === 'array') {
            html += 'Array[';
            if (_.isArray(schema.items)) html += _.map(schema.items, addReference).join(',');
            else if (_.isPlainObject(schema.items)) {
                if (_.isUndefined(schema.items.$ref)) {
                    if (!_.isUndefined(schema.items.type) && _.indexOf([
                        'array',
                        'object'
                    ], schema.items.type) === -1) html += schema.items.type;
                    else html += addReference(schema.items);
                } else html += addReference(schema.items, Helpers.simpleRef(schema.items.$ref));
            } else {
                Helpers.log('Array type\'s \'items\' schema is not an array or an object, cannot process');
                html += 'object';
            }
            html += ']';
        } else html += schema.type;
        html += '</span>';
        return html;
    }
    function primitiveToOptionsHTML(schema, html) {
        var options = '';
        var type = schema.type || 'object';
        var isArray = type === 'array';
        if (isArray) {
            if (_.isPlainObject(schema.items) && !_.isUndefined(schema.items.type)) type = schema.items.type;
            else type = 'object';
        }
        if (!_.isUndefined(schema.default)) options += optionHtml('Default', schema.default);
        switch(type){
            case 'string':
                if (schema.minLength) options += optionHtml('Min. Length', schema.minLength);
                if (schema.maxLength) options += optionHtml('Max. Length', schema.maxLength);
                if (schema.pattern) options += optionHtml('Reg. Exp.', schema.pattern);
                break;
            case 'integer':
            case 'number':
                if (schema.minimum) options += optionHtml('Min. Value', schema.minimum);
                if (schema.exclusiveMinimum) options += optionHtml('Exclusive Min.', 'true');
                if (schema.maximum) options += optionHtml('Max. Value', schema.maximum);
                if (schema.exclusiveMaximum) options += optionHtml('Exclusive Max.', 'true');
                if (schema.multipleOf) options += optionHtml('Multiple Of', schema.multipleOf);
                break;
        }
        if (isArray) {
            if (schema.minItems) options += optionHtml('Min. Items', schema.minItems);
            if (schema.maxItems) options += optionHtml('Max. Items', schema.maxItems);
            if (schema.uniqueItems) options += optionHtml('Unique Items', 'true');
            if (schema.collectionFormat) options += optionHtml('Coll. Format', schema.collectionFormat);
        }
        if (_.isUndefined(schema.items)) {
            if (_.isArray(schema.enum)) {
                var enumString;
                if (type === 'number' || type === 'integer') enumString = schema.enum.join(', ');
                else enumString = '"' + schema.enum.join('", "') + '"';
                options += optionHtml('Enum', enumString);
            }
        }
        if (options.length > 0) html = '<span class="propWrap">' + html + '<table class="optionsWrapper"><tr><th colspan="2">' + type + '</th></tr>' + options + '</table></span>';
        return html;
    }
    function processModel(schema, name) {
        var type = schema.type || 'object';
        var isArray = schema.type === 'array';
        var html = strongOpen + name + ' ' + (isArray ? '[' : '{') + strongClose;
        if (name) seenModels.push(name);
        if (isArray) {
            if (_.isArray(schema.items)) html += '<div>' + _.map(schema.items, function(item) {
                var type = item.type || 'object';
                if (_.isUndefined(item.$ref)) {
                    if (_.indexOf([
                        'array',
                        'object'
                    ], type) > -1) {
                        if (type === 'object' && _.isUndefined(item.properties)) return 'object';
                        else return addReference(item);
                    } else return primitiveToOptionsHTML(item, type);
                } else return addReference(item, Helpers.simpleRef(item.$ref));
            }).join(',</div><div>');
            else if (_.isPlainObject(schema.items)) {
                if (_.isUndefined(schema.items.$ref)) {
                    if (_.indexOf([
                        'array',
                        'object'
                    ], schema.items.type || 'object') > -1) {
                        if ((_.isUndefined(schema.items.type) || schema.items.type === 'object') && _.isUndefined(schema.items.properties)) html += '<div>object</div>';
                        else html += '<div>' + addReference(schema.items) + '</div>';
                    } else html += '<div>' + primitiveToOptionsHTML(schema.items, schema.items.type) + '</div>';
                } else html += '<div>' + addReference(schema.items, Helpers.simpleRef(schema.items.$ref)) + '</div>';
            } else {
                Helpers.log('Array type\'s \'items\' property is not an array or an object, cannot process');
                html += '<div>object</div>';
            }
        } else {
            if (schema.$ref) html += '<div>' + addReference(schema, name) + '</div>';
            else if (type === 'object') {
                if (_.isPlainObject(schema.properties)) {
                    var contents = _.map(schema.properties, function(property, name) {
                        var propertyIsRequired = _.indexOf(schema.required, name) >= 0;
                        var cProperty = _.cloneDeep(property);
                        var requiredClass = propertyIsRequired ? 'required' : '';
                        var html = '<span class="propName ' + requiredClass + '">' + name + '</span> (';
                        var model;
                        var propDescription;
                        // Allow macro to set the default value
                        cProperty.default = modelPropertyMacro(cProperty);
                        // Resolve the schema (Handle nested schemas)
                        cProperty = Helpers.resolveSchema(cProperty);
                        propDescription = property.description || cProperty.description;
                        // We need to handle property references to primitives (Issue 339)
                        if (!_.isUndefined(cProperty.$ref)) {
                            model = models[Helpers.simpleRef(cProperty.$ref)];
                            if (!_.isUndefined(model) && _.indexOf([
                                undefined,
                                'array',
                                'object'
                            ], model.definition.type) === -1) // Use referenced schema
                            cProperty = Helpers.resolveSchema(model.definition);
                        }
                        html += primitiveToHTML(cProperty);
                        if (!propertyIsRequired) html += ', <span class="propOptKey">optional</span>';
                        if (property.readOnly) html += ', <span class="propReadOnly">read only</span>';
                        html += ')';
                        if (!_.isUndefined(propDescription)) html += ': <span class="propDesc">' + propDescription + '</span>';
                        if (cProperty.enum) html += ' = <span class="propVals">[\'' + cProperty.enum.join('\', \'') + '\']</span>';
                        return '<div' + (property.readOnly ? ' class="readOnly"' : '') + '>' + primitiveToOptionsHTML(cProperty, html);
                    }).join(',</div>');
                    if (contents) html += contents + '</div>';
                }
            } else html += '<div>' + primitiveToOptionsHTML(schema, type) + '</div>';
        }
        return html + strongOpen + (isArray ? ']' : '}') + strongClose;
    }
}

},{"a732758aeab31bf6":"jrGf3","9e5c423113e040eb":"3iMXW","41933284a730463b":"lKXOz","b22214ca08f50b1d":"fOaCr","9dd8e58b9cc3764d":"kAgGx","f3f4dcc4ed87b97e":"i3zxH","9174e757fed28518":"ceK4P","4bc8303c0e0fa32f":"hcpb9","94260c17e05c2c34":"lgoPK","b9a879d97ef327a7":"1wIxZ","4cf12c1989ab011b":"k4dlV"}],"i3zxH":[function(require,module,exports,__globalThis) {
var isArguments = require("48971430fb9ac546"), isArray = require("5b4fd40cf21dd254"), isArrayLike = require("57128dd068297b45"), isFunction = require("6bfb82c629416683"), isObjectLike = require("a699af9c1c10ffc6"), isString = require("948198d8bf8479c0"), keys = require("2f3b7cdb204ca8d8");
/**
 * Checks if `value` is empty. A value is considered empty unless it's an
 * `arguments` object, array, string, or jQuery-like collection with a length
 * greater than `0` or an object with own enumerable properties.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {Array|Object|string} value The value to inspect.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function isEmpty(value) {
    if (value == null) return true;
    if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) || isObjectLike(value) && isFunction(value.splice))) return !value.length;
    return !keys(value).length;
}
module.exports = isEmpty;

},{"48971430fb9ac546":"eDDOa","5b4fd40cf21dd254":"fOaCr","57128dd068297b45":"6UsMq","6bfb82c629416683":"7K3Vo","a699af9c1c10ffc6":"1EGfv","948198d8bf8479c0":"ewvLp","2f3b7cdb204ca8d8":"1wIxZ"}],"ceK4P":[function(require,module,exports,__globalThis) {
var arrayMap = require("353c206fc5d57738"), baseCallback = require("718256b4a6bf66b7"), baseMap = require("a74283ca5c35bff9"), isArray = require("1465b9497fdfe274");
/**
 * Creates an array of values by running each element in `collection` through
 * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
 * arguments: (value, index|key, collection).
 *
 * If a property name is provided for `iteratee` the created `_.property`
 * style callback returns the property value of the given element.
 *
 * If a value is also provided for `thisArg` the created `_.matchesProperty`
 * style callback returns `true` for elements that have a matching property
 * value, else `false`.
 *
 * If an object is provided for `iteratee` the created `_.matches` style
 * callback returns `true` for elements that have the properties of the given
 * object, else `false`.
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
 * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
 * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
 * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
 * `sum`, `uniq`, and `words`
 *
 * @static
 * @memberOf _
 * @alias collect
 * @category Collection
 * @param {Array|Object|string} collection The collection to iterate over.
 * @param {Function|Object|string} [iteratee=_.identity] The function invoked
 *  per iteration.
 * @param {*} [thisArg] The `this` binding of `iteratee`.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function timesThree(n) {
 *   return n * 3;
 * }
 *
 * _.map([1, 2], timesThree);
 * // => [3, 6]
 *
 * _.map({ 'a': 1, 'b': 2 }, timesThree);
 * // => [3, 6] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // using the `_.property` callback shorthand
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function map(collection, iteratee, thisArg) {
    var func = isArray(collection) ? arrayMap : baseMap;
    iteratee = baseCallback(iteratee, thisArg, 3);
    return func(collection, iteratee);
}
module.exports = map;

},{"353c206fc5d57738":"GEFxk","718256b4a6bf66b7":"g5e3s","a74283ca5c35bff9":"659v4","1465b9497fdfe274":"fOaCr"}],"GEFxk":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.map` for arrays without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = arrayMap;

},{}],"659v4":[function(require,module,exports,__globalThis) {
var baseEach = require("995065b6389c1256"), isArrayLike = require("5e39a045d6afa371");
/**
 * The base implementation of `_.map` without support for callback shorthands
 * and `this` binding.
 *
 * @private
 * @param {Array|Object|string} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function baseMap(collection, iteratee) {
    var index = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
    baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = baseMap;

},{"995065b6389c1256":"hF7Z3","5e39a045d6afa371":"6UsMq"}],"63vik":[function(require,module,exports,__globalThis) {
'use strict';
var yaml = require("e8a030f548024baf");
module.exports = yaml;

},{"e8a030f548024baf":"dVPzj"}],"dVPzj":[function(require,module,exports,__globalThis) {
'use strict';
var loader = require("d1b162709e71952e");
var dumper = require("6f812097090f6db7");
function deprecated(name) {
    return function() {
        throw new Error('Function ' + name + ' is deprecated and cannot be used.');
    };
}
module.exports.Type = require("53415c35451afe7c");
module.exports.Schema = require("7e4ccf5f2f27dcd6");
module.exports.FAILSAFE_SCHEMA = require("8909b06f22c795be");
module.exports.JSON_SCHEMA = require("bfafdc88fdc48745");
module.exports.CORE_SCHEMA = require("7b4867c7935c3e2f");
module.exports.DEFAULT_SAFE_SCHEMA = require("b165f64cee802dc2");
module.exports.DEFAULT_FULL_SCHEMA = require("74df2356e34aa5fb");
module.exports.load = loader.load;
module.exports.loadAll = loader.loadAll;
module.exports.safeLoad = loader.safeLoad;
module.exports.safeLoadAll = loader.safeLoadAll;
module.exports.dump = dumper.dump;
module.exports.safeDump = dumper.safeDump;
module.exports.YAMLException = require("c0d883bd22a0e4ac");
// Deprecated schema names from JS-YAML 2.0.x
module.exports.MINIMAL_SCHEMA = require("8909b06f22c795be");
module.exports.SAFE_SCHEMA = require("b165f64cee802dc2");
module.exports.DEFAULT_SCHEMA = require("74df2356e34aa5fb");
// Deprecated functions from JS-YAML 1.x.x
module.exports.scan = deprecated('scan');
module.exports.parse = deprecated('parse');
module.exports.compose = deprecated('compose');
module.exports.addConstructor = deprecated('addConstructor');

},{"d1b162709e71952e":"6LRO9","6f812097090f6db7":"lW86X","53415c35451afe7c":"26f2S","7e4ccf5f2f27dcd6":"klPjX","8909b06f22c795be":"ff4oa","bfafdc88fdc48745":"akRtv","7b4867c7935c3e2f":"hWLhI","b165f64cee802dc2":"9LPyf","74df2356e34aa5fb":"31U4w","c0d883bd22a0e4ac":"aTl5o"}],"6LRO9":[function(require,module,exports,__globalThis) {
'use strict';
/*eslint-disable max-len,no-use-before-define*/ var common = require("ed7740994e43e9e7");
var YAMLException = require("3a701411ba3b7df2");
var Mark = require("61a940e880de018b");
var DEFAULT_SAFE_SCHEMA = require("d682e401d37e90c9");
var DEFAULT_FULL_SCHEMA = require("df46c00531ed2d1b");
var _hasOwnProperty = Object.prototype.hasOwnProperty;
var CONTEXT_FLOW_IN = 1;
var CONTEXT_FLOW_OUT = 2;
var CONTEXT_BLOCK_IN = 3;
var CONTEXT_BLOCK_OUT = 4;
var CHOMPING_CLIP = 1;
var CHOMPING_STRIP = 2;
var CHOMPING_KEEP = 3;
var PATTERN_NON_PRINTABLE = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x84\x86-\x9F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
var PATTERN_NON_ASCII_LINE_BREAKS = /[\x85\u2028\u2029]/;
var PATTERN_FLOW_INDICATORS = /[,\[\]\{\}]/;
var PATTERN_TAG_HANDLE = /^(?:!|!!|![a-z\-]+!)$/i;
var PATTERN_TAG_URI = /^(?:!|[^,\[\]\{\}])(?:%[0-9a-f]{2}|[0-9a-z\-#;\/\?:@&=\+\$,_\.!~\*'\(\)\[\]])*$/i;
function _class(obj) {
    return Object.prototype.toString.call(obj);
}
function is_EOL(c) {
    return c === 0x0A /* LF */  || c === 0x0D /* CR */ ;
}
function is_WHITE_SPACE(c) {
    return c === 0x09 /* Tab */  || c === 0x20 /* Space */ ;
}
function is_WS_OR_EOL(c) {
    return c === 0x09 /* Tab */  || c === 0x20 /* Space */  || c === 0x0A /* LF */  || c === 0x0D /* CR */ ;
}
function is_FLOW_INDICATOR(c) {
    return c === 0x2C /* , */  || c === 0x5B /* [ */  || c === 0x5D /* ] */  || c === 0x7B /* { */  || c === 0x7D /* } */ ;
}
function fromHexCode(c) {
    var lc;
    if (0x30 /* 0 */  <= c && c <= 0x39 /* 9 */ ) return c - 0x30;
    /*eslint-disable no-bitwise*/ lc = c | 0x20;
    if (0x61 /* a */  <= lc && lc <= 0x66 /* f */ ) return lc - 0x61 + 10;
    return -1;
}
function escapedHexLen(c) {
    if (c === 0x78 /* x */ ) return 2;
    if (c === 0x75 /* u */ ) return 4;
    if (c === 0x55 /* U */ ) return 8;
    return 0;
}
function fromDecimalCode(c) {
    if (0x30 /* 0 */  <= c && c <= 0x39 /* 9 */ ) return c - 0x30;
    return -1;
}
function simpleEscapeSequence(c) {
    /* eslint-disable indent */ return c === 0x30 /* 0 */  ? '\x00' : c === 0x61 /* a */  ? '\x07' : c === 0x62 /* b */  ? '\x08' : c === 0x74 /* t */  ? '\x09' : c === 0x09 /* Tab */  ? '\x09' : c === 0x6E /* n */  ? '\x0A' : c === 0x76 /* v */  ? '\x0B' : c === 0x66 /* f */  ? '\x0C' : c === 0x72 /* r */  ? '\x0D' : c === 0x65 /* e */  ? '\x1B' : c === 0x20 /* Space */  ? ' ' : c === 0x22 /* " */  ? '\x22' : c === 0x2F /* / */  ? '/' : c === 0x5C /* \ */  ? '\x5C' : c === 0x4E /* N */  ? '\x85' : c === 0x5F /* _ */  ? '\xA0' : c === 0x4C /* L */  ? '\u2028' : c === 0x50 /* P */  ? '\u2029' : '';
}
function charFromCodepoint(c) {
    if (c <= 0xFFFF) return String.fromCharCode(c);
    // Encode UTF-16 surrogate pair
    // https://en.wikipedia.org/wiki/UTF-16#Code_points_U.2B010000_to_U.2B10FFFF
    return String.fromCharCode((c - 0x010000 >> 10) + 0xD800, (c - 0x010000 & 0x03FF) + 0xDC00);
}
var simpleEscapeCheck = new Array(256); // integer, for fast access
var simpleEscapeMap = new Array(256);
for(var i = 0; i < 256; i++){
    simpleEscapeCheck[i] = simpleEscapeSequence(i) ? 1 : 0;
    simpleEscapeMap[i] = simpleEscapeSequence(i);
}
function State(input, options) {
    this.input = input;
    this.filename = options['filename'] || null;
    this.schema = options['schema'] || DEFAULT_FULL_SCHEMA;
    this.onWarning = options['onWarning'] || null;
    this.legacy = options['legacy'] || false;
    this.json = options['json'] || false;
    this.listener = options['listener'] || null;
    this.implicitTypes = this.schema.compiledImplicit;
    this.typeMap = this.schema.compiledTypeMap;
    this.length = input.length;
    this.position = 0;
    this.line = 0;
    this.lineStart = 0;
    this.lineIndent = 0;
    this.documents = [];
/*
  this.version;
  this.checkLineBreaks;
  this.tagMap;
  this.anchorMap;
  this.tag;
  this.anchor;
  this.kind;
  this.result;*/ }
function generateError(state, message) {
    return new YAMLException(message, new Mark(state.filename, state.input, state.position, state.line, state.position - state.lineStart));
}
function throwError(state, message) {
    throw generateError(state, message);
}
function throwWarning(state, message) {
    if (state.onWarning) state.onWarning.call(null, generateError(state, message));
}
var directiveHandlers = {
    YAML: function handleYamlDirective(state, name, args) {
        var match, major, minor;
        if (state.version !== null) throwError(state, 'duplication of %YAML directive');
        if (args.length !== 1) throwError(state, 'YAML directive accepts exactly one argument');
        match = /^([0-9]+)\.([0-9]+)$/.exec(args[0]);
        if (match === null) throwError(state, 'ill-formed argument of the YAML directive');
        major = parseInt(match[1], 10);
        minor = parseInt(match[2], 10);
        if (major !== 1) throwError(state, 'unacceptable YAML version of the document');
        state.version = args[0];
        state.checkLineBreaks = minor < 2;
        if (minor !== 1 && minor !== 2) throwWarning(state, 'unsupported YAML version of the document');
    },
    TAG: function handleTagDirective(state, name, args) {
        var handle, prefix;
        if (args.length !== 2) throwError(state, 'TAG directive accepts exactly two arguments');
        handle = args[0];
        prefix = args[1];
        if (!PATTERN_TAG_HANDLE.test(handle)) throwError(state, 'ill-formed tag handle (first argument) of the TAG directive');
        if (_hasOwnProperty.call(state.tagMap, handle)) throwError(state, 'there is a previously declared suffix for "' + handle + '" tag handle');
        if (!PATTERN_TAG_URI.test(prefix)) throwError(state, 'ill-formed tag prefix (second argument) of the TAG directive');
        state.tagMap[handle] = prefix;
    }
};
function captureSegment(state, start, end, checkJson) {
    var _position, _length, _character, _result;
    if (start < end) {
        _result = state.input.slice(start, end);
        if (checkJson) for(_position = 0, _length = _result.length; _position < _length; _position += 1){
            _character = _result.charCodeAt(_position);
            if (!(_character === 0x09 || 0x20 <= _character && _character <= 0x10FFFF)) throwError(state, 'expected valid JSON character');
        }
        else if (PATTERN_NON_PRINTABLE.test(_result)) throwError(state, 'the stream contains non-printable characters');
        state.result += _result;
    }
}
function mergeMappings(state, destination, source, overridableKeys) {
    var sourceKeys, key, index, quantity;
    if (!common.isObject(source)) throwError(state, 'cannot merge mappings; the provided source object is unacceptable');
    sourceKeys = Object.keys(source);
    for(index = 0, quantity = sourceKeys.length; index < quantity; index += 1){
        key = sourceKeys[index];
        if (!_hasOwnProperty.call(destination, key)) {
            destination[key] = source[key];
            overridableKeys[key] = true;
        }
    }
}
function storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode, startLine, startPos) {
    var index, quantity;
    // The output is a plain object here, so keys can only be strings.
    // We need to convert keyNode to a string, but doing so can hang the process
    // (deeply nested arrays that explode exponentially using aliases).
    if (Array.isArray(keyNode)) {
        keyNode = Array.prototype.slice.call(keyNode);
        for(index = 0, quantity = keyNode.length; index < quantity; index += 1){
            if (Array.isArray(keyNode[index])) throwError(state, 'nested arrays are not supported inside keys');
            if (typeof keyNode === 'object' && _class(keyNode[index]) === '[object Object]') keyNode[index] = '[object Object]';
        }
    }
    // Avoid code execution in load() via toString property
    // (still use its own toString for arrays, timestamps,
    // and whatever user schema extensions happen to have @@toStringTag)
    if (typeof keyNode === 'object' && _class(keyNode) === '[object Object]') keyNode = '[object Object]';
    keyNode = String(keyNode);
    if (_result === null) _result = {};
    if (keyTag === 'tag:yaml.org,2002:merge') {
        if (Array.isArray(valueNode)) for(index = 0, quantity = valueNode.length; index < quantity; index += 1)mergeMappings(state, _result, valueNode[index], overridableKeys);
        else mergeMappings(state, _result, valueNode, overridableKeys);
    } else {
        if (!state.json && !_hasOwnProperty.call(overridableKeys, keyNode) && _hasOwnProperty.call(_result, keyNode)) {
            state.line = startLine || state.line;
            state.position = startPos || state.position;
            throwError(state, 'duplicated mapping key');
        }
        _result[keyNode] = valueNode;
        delete overridableKeys[keyNode];
    }
    return _result;
}
function readLineBreak(state) {
    var ch;
    ch = state.input.charCodeAt(state.position);
    if (ch === 0x0A /* LF */ ) state.position++;
    else if (ch === 0x0D /* CR */ ) {
        state.position++;
        if (state.input.charCodeAt(state.position) === 0x0A /* LF */ ) state.position++;
    } else throwError(state, 'a line break is expected');
    state.line += 1;
    state.lineStart = state.position;
}
function skipSeparationSpace(state, allowComments, checkIndent) {
    var lineBreaks = 0, ch = state.input.charCodeAt(state.position);
    while(ch !== 0){
        while(is_WHITE_SPACE(ch))ch = state.input.charCodeAt(++state.position);
        if (allowComments && ch === 0x23 /* # */ ) do ch = state.input.charCodeAt(++state.position);
        while (ch !== 0x0A /* LF */  && ch !== 0x0D /* CR */  && ch !== 0);
        if (is_EOL(ch)) {
            readLineBreak(state);
            ch = state.input.charCodeAt(state.position);
            lineBreaks++;
            state.lineIndent = 0;
            while(ch === 0x20 /* Space */ ){
                state.lineIndent++;
                ch = state.input.charCodeAt(++state.position);
            }
        } else break;
    }
    if (checkIndent !== -1 && lineBreaks !== 0 && state.lineIndent < checkIndent) throwWarning(state, 'deficient indentation');
    return lineBreaks;
}
function testDocumentSeparator(state) {
    var _position = state.position, ch;
    ch = state.input.charCodeAt(_position);
    // Condition state.position === state.lineStart is tested
    // in parent on each call, for efficiency. No needs to test here again.
    if ((ch === 0x2D /* - */  || ch === 0x2E /* . */ ) && ch === state.input.charCodeAt(_position + 1) && ch === state.input.charCodeAt(_position + 2)) {
        _position += 3;
        ch = state.input.charCodeAt(_position);
        if (ch === 0 || is_WS_OR_EOL(ch)) return true;
    }
    return false;
}
function writeFoldedLines(state, count) {
    if (count === 1) state.result += ' ';
    else if (count > 1) state.result += common.repeat('\n', count - 1);
}
function readPlainScalar(state, nodeIndent, withinFlowCollection) {
    var preceding, following, captureStart, captureEnd, hasPendingContent, _line, _lineStart, _lineIndent, _kind = state.kind, _result = state.result, ch;
    ch = state.input.charCodeAt(state.position);
    if (is_WS_OR_EOL(ch) || is_FLOW_INDICATOR(ch) || ch === 0x23 /* # */  || ch === 0x26 /* & */  || ch === 0x2A /* * */  || ch === 0x21 /* ! */  || ch === 0x7C /* | */  || ch === 0x3E /* > */  || ch === 0x27 /* ' */  || ch === 0x22 /* " */  || ch === 0x25 /* % */  || ch === 0x40 /* @ */  || ch === 0x60 /* ` */ ) return false;
    if (ch === 0x3F /* ? */  || ch === 0x2D /* - */ ) {
        following = state.input.charCodeAt(state.position + 1);
        if (is_WS_OR_EOL(following) || withinFlowCollection && is_FLOW_INDICATOR(following)) return false;
    }
    state.kind = 'scalar';
    state.result = '';
    captureStart = captureEnd = state.position;
    hasPendingContent = false;
    while(ch !== 0){
        if (ch === 0x3A /* : */ ) {
            following = state.input.charCodeAt(state.position + 1);
            if (is_WS_OR_EOL(following) || withinFlowCollection && is_FLOW_INDICATOR(following)) break;
        } else if (ch === 0x23 /* # */ ) {
            preceding = state.input.charCodeAt(state.position - 1);
            if (is_WS_OR_EOL(preceding)) break;
        } else if (state.position === state.lineStart && testDocumentSeparator(state) || withinFlowCollection && is_FLOW_INDICATOR(ch)) break;
        else if (is_EOL(ch)) {
            _line = state.line;
            _lineStart = state.lineStart;
            _lineIndent = state.lineIndent;
            skipSeparationSpace(state, false, -1);
            if (state.lineIndent >= nodeIndent) {
                hasPendingContent = true;
                ch = state.input.charCodeAt(state.position);
                continue;
            } else {
                state.position = captureEnd;
                state.line = _line;
                state.lineStart = _lineStart;
                state.lineIndent = _lineIndent;
                break;
            }
        }
        if (hasPendingContent) {
            captureSegment(state, captureStart, captureEnd, false);
            writeFoldedLines(state, state.line - _line);
            captureStart = captureEnd = state.position;
            hasPendingContent = false;
        }
        if (!is_WHITE_SPACE(ch)) captureEnd = state.position + 1;
        ch = state.input.charCodeAt(++state.position);
    }
    captureSegment(state, captureStart, captureEnd, false);
    if (state.result) return true;
    state.kind = _kind;
    state.result = _result;
    return false;
}
function readSingleQuotedScalar(state, nodeIndent) {
    var ch, captureStart, captureEnd;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 0x27 /* ' */ ) return false;
    state.kind = 'scalar';
    state.result = '';
    state.position++;
    captureStart = captureEnd = state.position;
    while((ch = state.input.charCodeAt(state.position)) !== 0){
        if (ch === 0x27 /* ' */ ) {
            captureSegment(state, captureStart, state.position, true);
            ch = state.input.charCodeAt(++state.position);
            if (ch === 0x27 /* ' */ ) {
                captureStart = state.position;
                state.position++;
                captureEnd = state.position;
            } else return true;
        } else if (is_EOL(ch)) {
            captureSegment(state, captureStart, captureEnd, true);
            writeFoldedLines(state, skipSeparationSpace(state, false, nodeIndent));
            captureStart = captureEnd = state.position;
        } else if (state.position === state.lineStart && testDocumentSeparator(state)) throwError(state, 'unexpected end of the document within a single quoted scalar');
        else {
            state.position++;
            captureEnd = state.position;
        }
    }
    throwError(state, 'unexpected end of the stream within a single quoted scalar');
}
function readDoubleQuotedScalar(state, nodeIndent) {
    var captureStart, captureEnd, hexLength, hexResult, tmp, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 0x22 /* " */ ) return false;
    state.kind = 'scalar';
    state.result = '';
    state.position++;
    captureStart = captureEnd = state.position;
    while((ch = state.input.charCodeAt(state.position)) !== 0){
        if (ch === 0x22 /* " */ ) {
            captureSegment(state, captureStart, state.position, true);
            state.position++;
            return true;
        } else if (ch === 0x5C /* \ */ ) {
            captureSegment(state, captureStart, state.position, true);
            ch = state.input.charCodeAt(++state.position);
            if (is_EOL(ch)) skipSeparationSpace(state, false, nodeIndent);
            else if (ch < 256 && simpleEscapeCheck[ch]) {
                state.result += simpleEscapeMap[ch];
                state.position++;
            } else if ((tmp = escapedHexLen(ch)) > 0) {
                hexLength = tmp;
                hexResult = 0;
                for(; hexLength > 0; hexLength--){
                    ch = state.input.charCodeAt(++state.position);
                    if ((tmp = fromHexCode(ch)) >= 0) hexResult = (hexResult << 4) + tmp;
                    else throwError(state, 'expected hexadecimal character');
                }
                state.result += charFromCodepoint(hexResult);
                state.position++;
            } else throwError(state, 'unknown escape sequence');
            captureStart = captureEnd = state.position;
        } else if (is_EOL(ch)) {
            captureSegment(state, captureStart, captureEnd, true);
            writeFoldedLines(state, skipSeparationSpace(state, false, nodeIndent));
            captureStart = captureEnd = state.position;
        } else if (state.position === state.lineStart && testDocumentSeparator(state)) throwError(state, 'unexpected end of the document within a double quoted scalar');
        else {
            state.position++;
            captureEnd = state.position;
        }
    }
    throwError(state, 'unexpected end of the stream within a double quoted scalar');
}
function readFlowCollection(state, nodeIndent) {
    var readNext = true, _line, _tag = state.tag, _result, _anchor = state.anchor, following, terminator, isPair, isExplicitPair, isMapping, overridableKeys = {}, keyNode, keyTag, valueNode, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch === 0x5B /* [ */ ) {
        terminator = 0x5D; /* ] */ 
        isMapping = false;
        _result = [];
    } else if (ch === 0x7B /* { */ ) {
        terminator = 0x7D; /* } */ 
        isMapping = true;
        _result = {};
    } else return false;
    if (state.anchor !== null) state.anchorMap[state.anchor] = _result;
    ch = state.input.charCodeAt(++state.position);
    while(ch !== 0){
        skipSeparationSpace(state, true, nodeIndent);
        ch = state.input.charCodeAt(state.position);
        if (ch === terminator) {
            state.position++;
            state.tag = _tag;
            state.anchor = _anchor;
            state.kind = isMapping ? 'mapping' : 'sequence';
            state.result = _result;
            return true;
        } else if (!readNext) throwError(state, 'missed comma between flow collection entries');
        keyTag = keyNode = valueNode = null;
        isPair = isExplicitPair = false;
        if (ch === 0x3F /* ? */ ) {
            following = state.input.charCodeAt(state.position + 1);
            if (is_WS_OR_EOL(following)) {
                isPair = isExplicitPair = true;
                state.position++;
                skipSeparationSpace(state, true, nodeIndent);
            }
        }
        _line = state.line;
        composeNode(state, nodeIndent, CONTEXT_FLOW_IN, false, true);
        keyTag = state.tag;
        keyNode = state.result;
        skipSeparationSpace(state, true, nodeIndent);
        ch = state.input.charCodeAt(state.position);
        if ((isExplicitPair || state.line === _line) && ch === 0x3A /* : */ ) {
            isPair = true;
            ch = state.input.charCodeAt(++state.position);
            skipSeparationSpace(state, true, nodeIndent);
            composeNode(state, nodeIndent, CONTEXT_FLOW_IN, false, true);
            valueNode = state.result;
        }
        if (isMapping) storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode);
        else if (isPair) _result.push(storeMappingPair(state, null, overridableKeys, keyTag, keyNode, valueNode));
        else _result.push(keyNode);
        skipSeparationSpace(state, true, nodeIndent);
        ch = state.input.charCodeAt(state.position);
        if (ch === 0x2C /* , */ ) {
            readNext = true;
            ch = state.input.charCodeAt(++state.position);
        } else readNext = false;
    }
    throwError(state, 'unexpected end of the stream within a flow collection');
}
function readBlockScalar(state, nodeIndent) {
    var captureStart, folding, chomping = CHOMPING_CLIP, didReadContent = false, detectedIndent = false, textIndent = nodeIndent, emptyLines = 0, atMoreIndented = false, tmp, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch === 0x7C /* | */ ) folding = false;
    else if (ch === 0x3E /* > */ ) folding = true;
    else return false;
    state.kind = 'scalar';
    state.result = '';
    while(ch !== 0){
        ch = state.input.charCodeAt(++state.position);
        if (ch === 0x2B /* + */  || ch === 0x2D /* - */ ) {
            if (CHOMPING_CLIP === chomping) chomping = ch === 0x2B /* + */  ? CHOMPING_KEEP : CHOMPING_STRIP;
            else throwError(state, 'repeat of a chomping mode identifier');
        } else if ((tmp = fromDecimalCode(ch)) >= 0) {
            if (tmp === 0) throwError(state, 'bad explicit indentation width of a block scalar; it cannot be less than one');
            else if (!detectedIndent) {
                textIndent = nodeIndent + tmp - 1;
                detectedIndent = true;
            } else throwError(state, 'repeat of an indentation width identifier');
        } else break;
    }
    if (is_WHITE_SPACE(ch)) {
        do ch = state.input.charCodeAt(++state.position);
        while (is_WHITE_SPACE(ch));
        if (ch === 0x23 /* # */ ) do ch = state.input.charCodeAt(++state.position);
        while (!is_EOL(ch) && ch !== 0);
    }
    while(ch !== 0){
        readLineBreak(state);
        state.lineIndent = 0;
        ch = state.input.charCodeAt(state.position);
        while((!detectedIndent || state.lineIndent < textIndent) && ch === 0x20 /* Space */ ){
            state.lineIndent++;
            ch = state.input.charCodeAt(++state.position);
        }
        if (!detectedIndent && state.lineIndent > textIndent) textIndent = state.lineIndent;
        if (is_EOL(ch)) {
            emptyLines++;
            continue;
        }
        // End of the scalar.
        if (state.lineIndent < textIndent) {
            // Perform the chomping.
            if (chomping === CHOMPING_KEEP) state.result += common.repeat('\n', didReadContent ? 1 + emptyLines : emptyLines);
            else if (chomping === CHOMPING_CLIP) {
                if (didReadContent) state.result += '\n';
            }
            break;
        }
        // Folded style: use fancy rules to handle line breaks.
        if (folding) {
            // Lines starting with white space characters (more-indented lines) are not folded.
            if (is_WHITE_SPACE(ch)) {
                atMoreIndented = true;
                // except for the first content line (cf. Example 8.1)
                state.result += common.repeat('\n', didReadContent ? 1 + emptyLines : emptyLines);
            // End of more-indented block.
            } else if (atMoreIndented) {
                atMoreIndented = false;
                state.result += common.repeat('\n', emptyLines + 1);
            // Just one line break - perceive as the same line.
            } else if (emptyLines === 0) {
                if (didReadContent) state.result += ' ';
            } else state.result += common.repeat('\n', emptyLines);
        // Literal style: just add exact number of line breaks between content lines.
        } else // Keep all line breaks except the header line break.
        state.result += common.repeat('\n', didReadContent ? 1 + emptyLines : emptyLines);
        didReadContent = true;
        detectedIndent = true;
        emptyLines = 0;
        captureStart = state.position;
        while(!is_EOL(ch) && ch !== 0)ch = state.input.charCodeAt(++state.position);
        captureSegment(state, captureStart, state.position, false);
    }
    return true;
}
function readBlockSequence(state, nodeIndent) {
    var _line, _tag = state.tag, _anchor = state.anchor, _result = [], following, detected = false, ch;
    if (state.anchor !== null) state.anchorMap[state.anchor] = _result;
    ch = state.input.charCodeAt(state.position);
    while(ch !== 0){
        if (ch !== 0x2D /* - */ ) break;
        following = state.input.charCodeAt(state.position + 1);
        if (!is_WS_OR_EOL(following)) break;
        detected = true;
        state.position++;
        if (skipSeparationSpace(state, true, -1)) {
            if (state.lineIndent <= nodeIndent) {
                _result.push(null);
                ch = state.input.charCodeAt(state.position);
                continue;
            }
        }
        _line = state.line;
        composeNode(state, nodeIndent, CONTEXT_BLOCK_IN, false, true);
        _result.push(state.result);
        skipSeparationSpace(state, true, -1);
        ch = state.input.charCodeAt(state.position);
        if ((state.line === _line || state.lineIndent > nodeIndent) && ch !== 0) throwError(state, 'bad indentation of a sequence entry');
        else if (state.lineIndent < nodeIndent) break;
    }
    if (detected) {
        state.tag = _tag;
        state.anchor = _anchor;
        state.kind = 'sequence';
        state.result = _result;
        return true;
    }
    return false;
}
function readBlockMapping(state, nodeIndent, flowIndent) {
    var following, allowCompact, _line, _pos, _tag = state.tag, _anchor = state.anchor, _result = {}, overridableKeys = {}, keyTag = null, keyNode = null, valueNode = null, atExplicitKey = false, detected = false, ch;
    if (state.anchor !== null) state.anchorMap[state.anchor] = _result;
    ch = state.input.charCodeAt(state.position);
    while(ch !== 0){
        following = state.input.charCodeAt(state.position + 1);
        _line = state.line; // Save the current line.
        _pos = state.position;
        //
        // Explicit notation case. There are two separate blocks:
        // first for the key (denoted by "?") and second for the value (denoted by ":")
        //
        if ((ch === 0x3F /* ? */  || ch === 0x3A /* : */ ) && is_WS_OR_EOL(following)) {
            if (ch === 0x3F /* ? */ ) {
                if (atExplicitKey) {
                    storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null);
                    keyTag = keyNode = valueNode = null;
                }
                detected = true;
                atExplicitKey = true;
                allowCompact = true;
            } else if (atExplicitKey) {
                // i.e. 0x3A/* : */ === character after the explicit key.
                atExplicitKey = false;
                allowCompact = true;
            } else throwError(state, 'incomplete explicit mapping pair; a key node is missed; or followed by a non-tabulated empty line');
            state.position += 1;
            ch = following;
        //
        // Implicit notation case. Flow-style node as the key first, then ":", and the value.
        //
        } else if (composeNode(state, flowIndent, CONTEXT_FLOW_OUT, false, true)) {
            if (state.line === _line) {
                ch = state.input.charCodeAt(state.position);
                while(is_WHITE_SPACE(ch))ch = state.input.charCodeAt(++state.position);
                if (ch === 0x3A /* : */ ) {
                    ch = state.input.charCodeAt(++state.position);
                    if (!is_WS_OR_EOL(ch)) throwError(state, 'a whitespace character is expected after the key-value separator within a block mapping');
                    if (atExplicitKey) {
                        storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null);
                        keyTag = keyNode = valueNode = null;
                    }
                    detected = true;
                    atExplicitKey = false;
                    allowCompact = false;
                    keyTag = state.tag;
                    keyNode = state.result;
                } else if (detected) throwError(state, 'can not read an implicit mapping pair; a colon is missed');
                else {
                    state.tag = _tag;
                    state.anchor = _anchor;
                    return true; // Keep the result of `composeNode`.
                }
            } else if (detected) throwError(state, 'can not read a block mapping entry; a multiline key may not be an implicit key');
            else {
                state.tag = _tag;
                state.anchor = _anchor;
                return true; // Keep the result of `composeNode`.
            }
        } else break; // Reading is done. Go to the epilogue.
        //
        // Common reading code for both explicit and implicit notations.
        //
        if (state.line === _line || state.lineIndent > nodeIndent) {
            if (composeNode(state, nodeIndent, CONTEXT_BLOCK_OUT, true, allowCompact)) {
                if (atExplicitKey) keyNode = state.result;
                else valueNode = state.result;
            }
            if (!atExplicitKey) {
                storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode, _line, _pos);
                keyTag = keyNode = valueNode = null;
            }
            skipSeparationSpace(state, true, -1);
            ch = state.input.charCodeAt(state.position);
        }
        if (state.lineIndent > nodeIndent && ch !== 0) throwError(state, 'bad indentation of a mapping entry');
        else if (state.lineIndent < nodeIndent) break;
    }
    //
    // Epilogue.
    //
    // Special case: last mapping's node contains only the key in explicit notation.
    if (atExplicitKey) storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null);
    // Expose the resulting mapping.
    if (detected) {
        state.tag = _tag;
        state.anchor = _anchor;
        state.kind = 'mapping';
        state.result = _result;
    }
    return detected;
}
function readTagProperty(state) {
    var _position, isVerbatim = false, isNamed = false, tagHandle, tagName, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 0x21 /* ! */ ) return false;
    if (state.tag !== null) throwError(state, 'duplication of a tag property');
    ch = state.input.charCodeAt(++state.position);
    if (ch === 0x3C /* < */ ) {
        isVerbatim = true;
        ch = state.input.charCodeAt(++state.position);
    } else if (ch === 0x21 /* ! */ ) {
        isNamed = true;
        tagHandle = '!!';
        ch = state.input.charCodeAt(++state.position);
    } else tagHandle = '!';
    _position = state.position;
    if (isVerbatim) {
        do ch = state.input.charCodeAt(++state.position);
        while (ch !== 0 && ch !== 0x3E /* > */ );
        if (state.position < state.length) {
            tagName = state.input.slice(_position, state.position);
            ch = state.input.charCodeAt(++state.position);
        } else throwError(state, 'unexpected end of the stream within a verbatim tag');
    } else {
        while(ch !== 0 && !is_WS_OR_EOL(ch)){
            if (ch === 0x21 /* ! */ ) {
                if (!isNamed) {
                    tagHandle = state.input.slice(_position - 1, state.position + 1);
                    if (!PATTERN_TAG_HANDLE.test(tagHandle)) throwError(state, 'named tag handle cannot contain such characters');
                    isNamed = true;
                    _position = state.position + 1;
                } else throwError(state, 'tag suffix cannot contain exclamation marks');
            }
            ch = state.input.charCodeAt(++state.position);
        }
        tagName = state.input.slice(_position, state.position);
        if (PATTERN_FLOW_INDICATORS.test(tagName)) throwError(state, 'tag suffix cannot contain flow indicator characters');
    }
    if (tagName && !PATTERN_TAG_URI.test(tagName)) throwError(state, 'tag name cannot contain such characters: ' + tagName);
    if (isVerbatim) state.tag = tagName;
    else if (_hasOwnProperty.call(state.tagMap, tagHandle)) state.tag = state.tagMap[tagHandle] + tagName;
    else if (tagHandle === '!') state.tag = '!' + tagName;
    else if (tagHandle === '!!') state.tag = 'tag:yaml.org,2002:' + tagName;
    else throwError(state, 'undeclared tag handle "' + tagHandle + '"');
    return true;
}
function readAnchorProperty(state) {
    var _position, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 0x26 /* & */ ) return false;
    if (state.anchor !== null) throwError(state, 'duplication of an anchor property');
    ch = state.input.charCodeAt(++state.position);
    _position = state.position;
    while(ch !== 0 && !is_WS_OR_EOL(ch) && !is_FLOW_INDICATOR(ch))ch = state.input.charCodeAt(++state.position);
    if (state.position === _position) throwError(state, 'name of an anchor node must contain at least one character');
    state.anchor = state.input.slice(_position, state.position);
    return true;
}
function readAlias(state) {
    var _position, alias, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 0x2A /* * */ ) return false;
    ch = state.input.charCodeAt(++state.position);
    _position = state.position;
    while(ch !== 0 && !is_WS_OR_EOL(ch) && !is_FLOW_INDICATOR(ch))ch = state.input.charCodeAt(++state.position);
    if (state.position === _position) throwError(state, 'name of an alias node must contain at least one character');
    alias = state.input.slice(_position, state.position);
    if (!_hasOwnProperty.call(state.anchorMap, alias)) throwError(state, 'unidentified alias "' + alias + '"');
    state.result = state.anchorMap[alias];
    skipSeparationSpace(state, true, -1);
    return true;
}
function composeNode(state, parentIndent, nodeContext, allowToSeek, allowCompact) {
    var allowBlockStyles, allowBlockScalars, allowBlockCollections, indentStatus = 1, atNewLine = false, hasContent = false, typeIndex, typeQuantity, type, flowIndent, blockIndent;
    if (state.listener !== null) state.listener('open', state);
    state.tag = null;
    state.anchor = null;
    state.kind = null;
    state.result = null;
    allowBlockStyles = allowBlockScalars = allowBlockCollections = CONTEXT_BLOCK_OUT === nodeContext || CONTEXT_BLOCK_IN === nodeContext;
    if (allowToSeek) {
        if (skipSeparationSpace(state, true, -1)) {
            atNewLine = true;
            if (state.lineIndent > parentIndent) indentStatus = 1;
            else if (state.lineIndent === parentIndent) indentStatus = 0;
            else if (state.lineIndent < parentIndent) indentStatus = -1;
        }
    }
    if (indentStatus === 1) {
        while(readTagProperty(state) || readAnchorProperty(state))if (skipSeparationSpace(state, true, -1)) {
            atNewLine = true;
            allowBlockCollections = allowBlockStyles;
            if (state.lineIndent > parentIndent) indentStatus = 1;
            else if (state.lineIndent === parentIndent) indentStatus = 0;
            else if (state.lineIndent < parentIndent) indentStatus = -1;
        } else allowBlockCollections = false;
    }
    if (allowBlockCollections) allowBlockCollections = atNewLine || allowCompact;
    if (indentStatus === 1 || CONTEXT_BLOCK_OUT === nodeContext) {
        if (CONTEXT_FLOW_IN === nodeContext || CONTEXT_FLOW_OUT === nodeContext) flowIndent = parentIndent;
        else flowIndent = parentIndent + 1;
        blockIndent = state.position - state.lineStart;
        if (indentStatus === 1) {
            if (allowBlockCollections && (readBlockSequence(state, blockIndent) || readBlockMapping(state, blockIndent, flowIndent)) || readFlowCollection(state, flowIndent)) hasContent = true;
            else {
                if (allowBlockScalars && readBlockScalar(state, flowIndent) || readSingleQuotedScalar(state, flowIndent) || readDoubleQuotedScalar(state, flowIndent)) hasContent = true;
                else if (readAlias(state)) {
                    hasContent = true;
                    if (state.tag !== null || state.anchor !== null) throwError(state, 'alias node should not have any properties');
                } else if (readPlainScalar(state, flowIndent, CONTEXT_FLOW_IN === nodeContext)) {
                    hasContent = true;
                    if (state.tag === null) state.tag = '?';
                }
                if (state.anchor !== null) state.anchorMap[state.anchor] = state.result;
            }
        } else if (indentStatus === 0) // Special case: block sequences are allowed to have same indentation level as the parent.
        // http://www.yaml.org/spec/1.2/spec.html#id2799784
        hasContent = allowBlockCollections && readBlockSequence(state, blockIndent);
    }
    if (state.tag !== null && state.tag !== '!') {
        if (state.tag === '?') {
            // Implicit resolving is not allowed for non-scalar types, and '?'
            // non-specific tag is only automatically assigned to plain scalars.
            //
            // We only need to check kind conformity in case user explicitly assigns '?'
            // tag, for example like this: "!<?> [0]"
            //
            if (state.result !== null && state.kind !== 'scalar') throwError(state, 'unacceptable node kind for !<?> tag; it should be "scalar", not "' + state.kind + '"');
            for(typeIndex = 0, typeQuantity = state.implicitTypes.length; typeIndex < typeQuantity; typeIndex += 1){
                type = state.implicitTypes[typeIndex];
                if (type.resolve(state.result)) {
                    state.result = type.construct(state.result);
                    state.tag = type.tag;
                    if (state.anchor !== null) state.anchorMap[state.anchor] = state.result;
                    break;
                }
            }
        } else if (_hasOwnProperty.call(state.typeMap[state.kind || 'fallback'], state.tag)) {
            type = state.typeMap[state.kind || 'fallback'][state.tag];
            if (state.result !== null && type.kind !== state.kind) throwError(state, 'unacceptable node kind for !<' + state.tag + '> tag; it should be "' + type.kind + '", not "' + state.kind + '"');
            if (!type.resolve(state.result)) throwError(state, 'cannot resolve a node with !<' + state.tag + '> explicit tag');
            else {
                state.result = type.construct(state.result);
                if (state.anchor !== null) state.anchorMap[state.anchor] = state.result;
            }
        } else throwError(state, 'unknown tag !<' + state.tag + '>');
    }
    if (state.listener !== null) state.listener('close', state);
    return state.tag !== null || state.anchor !== null || hasContent;
}
function readDocument(state) {
    var documentStart = state.position, _position, directiveName, directiveArgs, hasDirectives = false, ch;
    state.version = null;
    state.checkLineBreaks = state.legacy;
    state.tagMap = {};
    state.anchorMap = {};
    while((ch = state.input.charCodeAt(state.position)) !== 0){
        skipSeparationSpace(state, true, -1);
        ch = state.input.charCodeAt(state.position);
        if (state.lineIndent > 0 || ch !== 0x25 /* % */ ) break;
        hasDirectives = true;
        ch = state.input.charCodeAt(++state.position);
        _position = state.position;
        while(ch !== 0 && !is_WS_OR_EOL(ch))ch = state.input.charCodeAt(++state.position);
        directiveName = state.input.slice(_position, state.position);
        directiveArgs = [];
        if (directiveName.length < 1) throwError(state, 'directive name must not be less than one character in length');
        while(ch !== 0){
            while(is_WHITE_SPACE(ch))ch = state.input.charCodeAt(++state.position);
            if (ch === 0x23 /* # */ ) {
                do ch = state.input.charCodeAt(++state.position);
                while (ch !== 0 && !is_EOL(ch));
                break;
            }
            if (is_EOL(ch)) break;
            _position = state.position;
            while(ch !== 0 && !is_WS_OR_EOL(ch))ch = state.input.charCodeAt(++state.position);
            directiveArgs.push(state.input.slice(_position, state.position));
        }
        if (ch !== 0) readLineBreak(state);
        if (_hasOwnProperty.call(directiveHandlers, directiveName)) directiveHandlers[directiveName](state, directiveName, directiveArgs);
        else throwWarning(state, 'unknown document directive "' + directiveName + '"');
    }
    skipSeparationSpace(state, true, -1);
    if (state.lineIndent === 0 && state.input.charCodeAt(state.position) === 0x2D /* - */  && state.input.charCodeAt(state.position + 1) === 0x2D /* - */  && state.input.charCodeAt(state.position + 2) === 0x2D /* - */ ) {
        state.position += 3;
        skipSeparationSpace(state, true, -1);
    } else if (hasDirectives) throwError(state, 'directives end mark is expected');
    composeNode(state, state.lineIndent - 1, CONTEXT_BLOCK_OUT, false, true);
    skipSeparationSpace(state, true, -1);
    if (state.checkLineBreaks && PATTERN_NON_ASCII_LINE_BREAKS.test(state.input.slice(documentStart, state.position))) throwWarning(state, 'non-ASCII line breaks are interpreted as content');
    state.documents.push(state.result);
    if (state.position === state.lineStart && testDocumentSeparator(state)) {
        if (state.input.charCodeAt(state.position) === 0x2E /* . */ ) {
            state.position += 3;
            skipSeparationSpace(state, true, -1);
        }
        return;
    }
    if (state.position < state.length - 1) throwError(state, 'end of the stream or a document separator is expected');
    else return;
}
function loadDocuments(input, options) {
    input = String(input);
    options = options || {};
    if (input.length !== 0) {
        // Add tailing `\n` if not exists
        if (input.charCodeAt(input.length - 1) !== 0x0A /* LF */  && input.charCodeAt(input.length - 1) !== 0x0D /* CR */ ) input += '\n';
        // Strip BOM
        if (input.charCodeAt(0) === 0xFEFF) input = input.slice(1);
    }
    var state = new State(input, options);
    var nullpos = input.indexOf('\0');
    if (nullpos !== -1) {
        state.position = nullpos;
        throwError(state, 'null byte is not allowed in input');
    }
    // Use 0 as string terminator. That significantly simplifies bounds check.
    state.input += '\0';
    while(state.input.charCodeAt(state.position) === 0x20 /* Space */ ){
        state.lineIndent += 1;
        state.position += 1;
    }
    while(state.position < state.length - 1)readDocument(state);
    return state.documents;
}
function loadAll(input, iterator, options) {
    if (iterator !== null && typeof iterator === 'object' && typeof options === 'undefined') {
        options = iterator;
        iterator = null;
    }
    var documents = loadDocuments(input, options);
    if (typeof iterator !== 'function') return documents;
    for(var index = 0, length = documents.length; index < length; index += 1)iterator(documents[index]);
}
function load(input, options) {
    var documents = loadDocuments(input, options);
    if (documents.length === 0) /*eslint-disable no-undefined*/ return undefined;
    else if (documents.length === 1) return documents[0];
    throw new YAMLException('expected a single document in the stream, but found more');
}
function safeLoadAll(input, iterator, options) {
    if (typeof iterator === 'object' && iterator !== null && typeof options === 'undefined') {
        options = iterator;
        iterator = null;
    }
    return loadAll(input, iterator, common.extend({
        schema: DEFAULT_SAFE_SCHEMA
    }, options));
}
function safeLoad(input, options) {
    return load(input, common.extend({
        schema: DEFAULT_SAFE_SCHEMA
    }, options));
}
module.exports.loadAll = loadAll;
module.exports.load = load;
module.exports.safeLoadAll = safeLoadAll;
module.exports.safeLoad = safeLoad;

},{"ed7740994e43e9e7":"9ECBt","3a701411ba3b7df2":"aTl5o","61a940e880de018b":"iFKRS","d682e401d37e90c9":"9LPyf","df46c00531ed2d1b":"31U4w"}],"9ECBt":[function(require,module,exports,__globalThis) {
'use strict';
function isNothing(subject) {
    return typeof subject === 'undefined' || subject === null;
}
function isObject(subject) {
    return typeof subject === 'object' && subject !== null;
}
function toArray(sequence) {
    if (Array.isArray(sequence)) return sequence;
    else if (isNothing(sequence)) return [];
    return [
        sequence
    ];
}
function extend(target, source) {
    var index, length, key, sourceKeys;
    if (source) {
        sourceKeys = Object.keys(source);
        for(index = 0, length = sourceKeys.length; index < length; index += 1){
            key = sourceKeys[index];
            target[key] = source[key];
        }
    }
    return target;
}
function repeat(string, count) {
    var result = '', cycle;
    for(cycle = 0; cycle < count; cycle += 1)result += string;
    return result;
}
function isNegativeZero(number) {
    return number === 0 && Number.NEGATIVE_INFINITY === 1 / number;
}
module.exports.isNothing = isNothing;
module.exports.isObject = isObject;
module.exports.toArray = toArray;
module.exports.repeat = repeat;
module.exports.isNegativeZero = isNegativeZero;
module.exports.extend = extend;

},{}],"aTl5o":[function(require,module,exports,__globalThis) {
// YAML error class. http://stackoverflow.com/questions/8458984
//
'use strict';
function YAMLException(reason, mark) {
    // Super constructor
    Error.call(this);
    this.name = 'YAMLException';
    this.reason = reason;
    this.mark = mark;
    this.message = (this.reason || '(unknown reason)') + (this.mark ? ' ' + this.mark.toString() : '');
    // Include stack trace in error object
    if (Error.captureStackTrace) // Chrome and NodeJS
    Error.captureStackTrace(this, this.constructor);
    else // FF, IE 10+ and Safari 6+. Fallback for others
    this.stack = new Error().stack || '';
}
// Inherit from Error
YAMLException.prototype = Object.create(Error.prototype);
YAMLException.prototype.constructor = YAMLException;
YAMLException.prototype.toString = function toString(compact) {
    var result = this.name + ': ';
    result += this.reason || '(unknown reason)';
    if (!compact && this.mark) result += ' ' + this.mark.toString();
    return result;
};
module.exports = YAMLException;

},{}],"iFKRS":[function(require,module,exports,__globalThis) {
'use strict';
var common = require("30c5d50c194343b0");
function Mark(name, buffer, position, line, column) {
    this.name = name;
    this.buffer = buffer;
    this.position = position;
    this.line = line;
    this.column = column;
}
Mark.prototype.getSnippet = function getSnippet(indent, maxLength) {
    var head, start, tail, end, snippet;
    if (!this.buffer) return null;
    indent = indent || 4;
    maxLength = maxLength || 75;
    head = '';
    start = this.position;
    while(start > 0 && '\x00\r\n\x85\u2028\u2029'.indexOf(this.buffer.charAt(start - 1)) === -1){
        start -= 1;
        if (this.position - start > maxLength / 2 - 1) {
            head = ' ... ';
            start += 5;
            break;
        }
    }
    tail = '';
    end = this.position;
    while(end < this.buffer.length && '\x00\r\n\x85\u2028\u2029'.indexOf(this.buffer.charAt(end)) === -1){
        end += 1;
        if (end - this.position > maxLength / 2 - 1) {
            tail = ' ... ';
            end -= 5;
            break;
        }
    }
    snippet = this.buffer.slice(start, end);
    return common.repeat(' ', indent) + head + snippet + tail + '\n' + common.repeat(' ', indent + this.position - start + head.length) + '^';
};
Mark.prototype.toString = function toString(compact) {
    var snippet, where = '';
    if (this.name) where += 'in "' + this.name + '" ';
    where += 'at line ' + (this.line + 1) + ', column ' + (this.column + 1);
    if (!compact) {
        snippet = this.getSnippet();
        if (snippet) where += ':\n' + snippet;
    }
    return where;
};
module.exports = Mark;

},{"30c5d50c194343b0":"9ECBt"}],"9LPyf":[function(require,module,exports,__globalThis) {
// JS-YAML's default schema for `safeLoad` function.
// It is not described in the YAML specification.
//
// This schema is based on standard YAML's Core schema and includes most of
// extra types described at YAML tag repository. (http://yaml.org/type/)
'use strict';
var Schema = require("50af2ebea58fe2b9");
module.exports = new Schema({
    include: [
        require("94bb42c3147eabe1")
    ],
    implicit: [
        require("d492d7a193ebb4ca"),
        require("cc49d6f2e7b62971")
    ],
    explicit: [
        require("6cea496992227045"),
        require("87cfcac5aee50868"),
        require("d83137be1f451673"),
        require("b62e6b799cbb76e0")
    ]
});

},{"50af2ebea58fe2b9":"klPjX","94bb42c3147eabe1":"hWLhI","d492d7a193ebb4ca":"1SkIo","cc49d6f2e7b62971":"gscWm","6cea496992227045":"7Tw84","87cfcac5aee50868":"3cg2y","d83137be1f451673":"5EPrV","b62e6b799cbb76e0":"6j44M"}],"klPjX":[function(require,module,exports,__globalThis) {
'use strict';
/*eslint-disable max-len*/ var common = require("928ea83de4a3cfa");
var YAMLException = require("7206d1d67c161ec9");
var Type = require("8acabfaa8cae91d4");
function compileList(schema, name, result) {
    var exclude = [];
    schema.include.forEach(function(includedSchema) {
        result = compileList(includedSchema, name, result);
    });
    schema[name].forEach(function(currentType) {
        result.forEach(function(previousType, previousIndex) {
            if (previousType.tag === currentType.tag && previousType.kind === currentType.kind) exclude.push(previousIndex);
        });
        result.push(currentType);
    });
    return result.filter(function(type, index) {
        return exclude.indexOf(index) === -1;
    });
}
function compileMap() {
    var result = {
        scalar: {},
        sequence: {},
        mapping: {},
        fallback: {}
    }, index, length;
    function collectType(type) {
        result[type.kind][type.tag] = result['fallback'][type.tag] = type;
    }
    for(index = 0, length = arguments.length; index < length; index += 1)arguments[index].forEach(collectType);
    return result;
}
function Schema(definition) {
    this.include = definition.include || [];
    this.implicit = definition.implicit || [];
    this.explicit = definition.explicit || [];
    this.implicit.forEach(function(type) {
        if (type.loadKind && type.loadKind !== 'scalar') throw new YAMLException('There is a non-scalar type in the implicit list of a schema. Implicit resolving of such types is not supported.');
    });
    this.compiledImplicit = compileList(this, 'implicit', []);
    this.compiledExplicit = compileList(this, 'explicit', []);
    this.compiledTypeMap = compileMap(this.compiledImplicit, this.compiledExplicit);
}
Schema.DEFAULT = null;
Schema.create = function createSchema() {
    var schemas, types;
    switch(arguments.length){
        case 1:
            schemas = Schema.DEFAULT;
            types = arguments[0];
            break;
        case 2:
            schemas = arguments[0];
            types = arguments[1];
            break;
        default:
            throw new YAMLException('Wrong number of arguments for Schema.create function');
    }
    schemas = common.toArray(schemas);
    types = common.toArray(types);
    if (!schemas.every(function(schema) {
        return schema instanceof Schema;
    })) throw new YAMLException('Specified list of super schemas (or a single Schema object) contains a non-Schema object.');
    if (!types.every(function(type) {
        return type instanceof Type;
    })) throw new YAMLException('Specified list of YAML types (or a single Type object) contains a non-Type object.');
    return new Schema({
        include: schemas,
        explicit: types
    });
};
module.exports = Schema;

},{"928ea83de4a3cfa":"9ECBt","7206d1d67c161ec9":"aTl5o","8acabfaa8cae91d4":"26f2S"}],"26f2S":[function(require,module,exports,__globalThis) {
'use strict';
var YAMLException = require("71d7d3e0e37e95e2");
var TYPE_CONSTRUCTOR_OPTIONS = [
    'kind',
    'resolve',
    'construct',
    'instanceOf',
    'predicate',
    'represent',
    'defaultStyle',
    'styleAliases'
];
var YAML_NODE_KINDS = [
    'scalar',
    'sequence',
    'mapping'
];
function compileStyleAliases(map) {
    var result = {};
    if (map !== null) Object.keys(map).forEach(function(style) {
        map[style].forEach(function(alias) {
            result[String(alias)] = style;
        });
    });
    return result;
}
function Type(tag, options) {
    options = options || {};
    Object.keys(options).forEach(function(name) {
        if (TYPE_CONSTRUCTOR_OPTIONS.indexOf(name) === -1) throw new YAMLException('Unknown option "' + name + '" is met in definition of "' + tag + '" YAML type.');
    });
    // TODO: Add tag format check.
    this.tag = tag;
    this.kind = options['kind'] || null;
    this.resolve = options['resolve'] || function() {
        return true;
    };
    this.construct = options['construct'] || function(data) {
        return data;
    };
    this.instanceOf = options['instanceOf'] || null;
    this.predicate = options['predicate'] || null;
    this.represent = options['represent'] || null;
    this.defaultStyle = options['defaultStyle'] || null;
    this.styleAliases = compileStyleAliases(options['styleAliases'] || null);
    if (YAML_NODE_KINDS.indexOf(this.kind) === -1) throw new YAMLException('Unknown kind "' + this.kind + '" is specified for "' + tag + '" YAML type.');
}
module.exports = Type;

},{"71d7d3e0e37e95e2":"aTl5o"}],"hWLhI":[function(require,module,exports,__globalThis) {
// Standard YAML's Core schema.
// http://www.yaml.org/spec/1.2/spec.html#id2804923
//
// NOTE: JS-YAML does not support schema-specific tag resolution restrictions.
// So, Core schema has no distinctions from JSON schema is JS-YAML.
'use strict';
var Schema = require("4307559b5429ce71");
module.exports = new Schema({
    include: [
        require("2fe0db80bba13e68")
    ]
});

},{"4307559b5429ce71":"klPjX","2fe0db80bba13e68":"akRtv"}],"akRtv":[function(require,module,exports,__globalThis) {
// Standard YAML's JSON schema.
// http://www.yaml.org/spec/1.2/spec.html#id2803231
//
// NOTE: JS-YAML does not support schema-specific tag resolution restrictions.
// So, this schema is not such strict as defined in the YAML specification.
// It allows numbers in binary notaion, use `Null` and `NULL` as `null`, etc.
'use strict';
var Schema = require("e8492e8defac66ae");
module.exports = new Schema({
    include: [
        require("9e4c68681b1b15a8")
    ],
    implicit: [
        require("9a06633f4176abf5"),
        require("f3ba4450e2525708"),
        require("c2f9f9d7c82db2a4"),
        require("3760fd945eb05fa3")
    ]
});

},{"e8492e8defac66ae":"klPjX","9e4c68681b1b15a8":"ff4oa","9a06633f4176abf5":"jE4Ib","f3ba4450e2525708":"bzYYc","c2f9f9d7c82db2a4":"9fGvo","3760fd945eb05fa3":"3dGrr"}],"ff4oa":[function(require,module,exports,__globalThis) {
// Standard YAML's Failsafe schema.
// http://www.yaml.org/spec/1.2/spec.html#id2802346
'use strict';
var Schema = require("7484f0d7743d12f2");
module.exports = new Schema({
    explicit: [
        require("22b1f199644a1be"),
        require("55b109b9e88dc9da"),
        require("a6d7f0cefc25d0af")
    ]
});

},{"7484f0d7743d12f2":"klPjX","22b1f199644a1be":"5oyFT","55b109b9e88dc9da":"kniY8","a6d7f0cefc25d0af":"b3wey"}],"5oyFT":[function(require,module,exports,__globalThis) {
'use strict';
var Type = require("7afcc97931a0eedf");
module.exports = new Type('tag:yaml.org,2002:str', {
    kind: 'scalar',
    construct: function(data) {
        return data !== null ? data : '';
    }
});

},{"7afcc97931a0eedf":"26f2S"}],"kniY8":[function(require,module,exports,__globalThis) {
'use strict';
var Type = require("e879d8032dcc2b53");
module.exports = new Type('tag:yaml.org,2002:seq', {
    kind: 'sequence',
    construct: function(data) {
        return data !== null ? data : [];
    }
});

},{"e879d8032dcc2b53":"26f2S"}],"b3wey":[function(require,module,exports,__globalThis) {
'use strict';
var Type = require("5f3b514814c6feb1");
module.exports = new Type('tag:yaml.org,2002:map', {
    kind: 'mapping',
    construct: function(data) {
        return data !== null ? data : {};
    }
});

},{"5f3b514814c6feb1":"26f2S"}],"jE4Ib":[function(require,module,exports,__globalThis) {
'use strict';
var Type = require("bab9d5554cdee615");
function resolveYamlNull(data) {
    if (data === null) return true;
    var max = data.length;
    return max === 1 && data === '~' || max === 4 && (data === 'null' || data === 'Null' || data === 'NULL');
}
function constructYamlNull() {
    return null;
}
function isNull(object) {
    return object === null;
}
module.exports = new Type('tag:yaml.org,2002:null', {
    kind: 'scalar',
    resolve: resolveYamlNull,
    construct: constructYamlNull,
    predicate: isNull,
    represent: {
        canonical: function() {
            return '~';
        },
        lowercase: function() {
            return 'null';
        },
        uppercase: function() {
            return 'NULL';
        },
        camelcase: function() {
            return 'Null';
        }
    },
    defaultStyle: 'lowercase'
});

},{"bab9d5554cdee615":"26f2S"}],"bzYYc":[function(require,module,exports,__globalThis) {
'use strict';
var Type = require("3310d48c350277ff");
function resolveYamlBoolean(data) {
    if (data === null) return false;
    var max = data.length;
    return max === 4 && (data === 'true' || data === 'True' || data === 'TRUE') || max === 5 && (data === 'false' || data === 'False' || data === 'FALSE');
}
function constructYamlBoolean(data) {
    return data === 'true' || data === 'True' || data === 'TRUE';
}
function isBoolean(object) {
    return Object.prototype.toString.call(object) === '[object Boolean]';
}
module.exports = new Type('tag:yaml.org,2002:bool', {
    kind: 'scalar',
    resolve: resolveYamlBoolean,
    construct: constructYamlBoolean,
    predicate: isBoolean,
    represent: {
        lowercase: function(object) {
            return object ? 'true' : 'false';
        },
        uppercase: function(object) {
            return object ? 'TRUE' : 'FALSE';
        },
        camelcase: function(object) {
            return object ? 'True' : 'False';
        }
    },
    defaultStyle: 'lowercase'
});

},{"3310d48c350277ff":"26f2S"}],"9fGvo":[function(require,module,exports,__globalThis) {
'use strict';
var common = require("a79480fa4e4fc740");
var Type = require("e1872e066dbacdb9");
function isHexCode(c) {
    return 0x30 /* 0 */  <= c && c <= 0x39 /* 9 */  || 0x41 /* A */  <= c && c <= 0x46 /* F */  || 0x61 /* a */  <= c && c <= 0x66 /* f */ ;
}
function isOctCode(c) {
    return 0x30 /* 0 */  <= c && c <= 0x37 /* 7 */ ;
}
function isDecCode(c) {
    return 0x30 /* 0 */  <= c && c <= 0x39 /* 9 */ ;
}
function resolveYamlInteger(data) {
    if (data === null) return false;
    var max = data.length, index = 0, hasDigits = false, ch;
    if (!max) return false;
    ch = data[index];
    // sign
    if (ch === '-' || ch === '+') ch = data[++index];
    if (ch === '0') {
        // 0
        if (index + 1 === max) return true;
        ch = data[++index];
        // base 2, base 8, base 16
        if (ch === 'b') {
            // base 2
            index++;
            for(; index < max; index++){
                ch = data[index];
                if (ch === '_') continue;
                if (ch !== '0' && ch !== '1') return false;
                hasDigits = true;
            }
            return hasDigits && ch !== '_';
        }
        if (ch === 'x') {
            // base 16
            index++;
            for(; index < max; index++){
                ch = data[index];
                if (ch === '_') continue;
                if (!isHexCode(data.charCodeAt(index))) return false;
                hasDigits = true;
            }
            return hasDigits && ch !== '_';
        }
        // base 8
        for(; index < max; index++){
            ch = data[index];
            if (ch === '_') continue;
            if (!isOctCode(data.charCodeAt(index))) return false;
            hasDigits = true;
        }
        return hasDigits && ch !== '_';
    }
    // base 10 (except 0) or base 60
    // value should not start with `_`;
    if (ch === '_') return false;
    for(; index < max; index++){
        ch = data[index];
        if (ch === '_') continue;
        if (ch === ':') break;
        if (!isDecCode(data.charCodeAt(index))) return false;
        hasDigits = true;
    }
    // Should have digits and should not end with `_`
    if (!hasDigits || ch === '_') return false;
    // if !base60 - done;
    if (ch !== ':') return true;
    // base60 almost not used, no needs to optimize
    return /^(:[0-5]?[0-9])+$/.test(data.slice(index));
}
function constructYamlInteger(data) {
    var value = data, sign = 1, ch, base, digits = [];
    if (value.indexOf('_') !== -1) value = value.replace(/_/g, '');
    ch = value[0];
    if (ch === '-' || ch === '+') {
        if (ch === '-') sign = -1;
        value = value.slice(1);
        ch = value[0];
    }
    if (value === '0') return 0;
    if (ch === '0') {
        if (value[1] === 'b') return sign * parseInt(value.slice(2), 2);
        if (value[1] === 'x') return sign * parseInt(value, 16);
        return sign * parseInt(value, 8);
    }
    if (value.indexOf(':') !== -1) {
        value.split(':').forEach(function(v) {
            digits.unshift(parseInt(v, 10));
        });
        value = 0;
        base = 1;
        digits.forEach(function(d) {
            value += d * base;
            base *= 60;
        });
        return sign * value;
    }
    return sign * parseInt(value, 10);
}
function isInteger(object) {
    return Object.prototype.toString.call(object) === '[object Number]' && object % 1 === 0 && !common.isNegativeZero(object);
}
module.exports = new Type('tag:yaml.org,2002:int', {
    kind: 'scalar',
    resolve: resolveYamlInteger,
    construct: constructYamlInteger,
    predicate: isInteger,
    represent: {
        binary: function(obj) {
            return obj >= 0 ? '0b' + obj.toString(2) : '-0b' + obj.toString(2).slice(1);
        },
        octal: function(obj) {
            return obj >= 0 ? '0' + obj.toString(8) : '-0' + obj.toString(8).slice(1);
        },
        decimal: function(obj) {
            return obj.toString(10);
        },
        /* eslint-disable max-len */ hexadecimal: function(obj) {
            return obj >= 0 ? '0x' + obj.toString(16).toUpperCase() : '-0x' + obj.toString(16).toUpperCase().slice(1);
        }
    },
    defaultStyle: 'decimal',
    styleAliases: {
        binary: [
            2,
            'bin'
        ],
        octal: [
            8,
            'oct'
        ],
        decimal: [
            10,
            'dec'
        ],
        hexadecimal: [
            16,
            'hex'
        ]
    }
});

},{"a79480fa4e4fc740":"9ECBt","e1872e066dbacdb9":"26f2S"}],"3dGrr":[function(require,module,exports,__globalThis) {
'use strict';
var common = require("4bcd6984fe954e9");
var Type = require("b088a2fb8a04518d");
var YAML_FLOAT_PATTERN = new RegExp(// 2.5e4, 2.5 and integers
"^(?:[-+]?(?:0|[1-9][0-9_]*)(?:\\.[0-9_]*)?(?:[eE][-+]?[0-9]+)?|\\.[0-9_]+(?:[eE][-+]?[0-9]+)?|[-+]?[0-9][0-9_]*(?::[0-5]?[0-9])+\\.[0-9_]*|[-+]?\\.(?:inf|Inf|INF)|\\.(?:nan|NaN|NAN))$");
function resolveYamlFloat(data) {
    if (data === null) return false;
    if (!YAML_FLOAT_PATTERN.test(data) || // Quick hack to not allow integers end with `_`
    // Probably should update regexp & check speed
    data[data.length - 1] === '_') return false;
    return true;
}
function constructYamlFloat(data) {
    var value, sign, base, digits;
    value = data.replace(/_/g, '').toLowerCase();
    sign = value[0] === '-' ? -1 : 1;
    digits = [];
    if ('+-'.indexOf(value[0]) >= 0) value = value.slice(1);
    if (value === '.inf') return sign === 1 ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY;
    else if (value === '.nan') return NaN;
    else if (value.indexOf(':') >= 0) {
        value.split(':').forEach(function(v) {
            digits.unshift(parseFloat(v, 10));
        });
        value = 0.0;
        base = 1;
        digits.forEach(function(d) {
            value += d * base;
            base *= 60;
        });
        return sign * value;
    }
    return sign * parseFloat(value, 10);
}
var SCIENTIFIC_WITHOUT_DOT = /^[-+]?[0-9]+e/;
function representYamlFloat(object, style) {
    var res;
    if (isNaN(object)) switch(style){
        case 'lowercase':
            return '.nan';
        case 'uppercase':
            return '.NAN';
        case 'camelcase':
            return '.NaN';
    }
    else if (Number.POSITIVE_INFINITY === object) switch(style){
        case 'lowercase':
            return '.inf';
        case 'uppercase':
            return '.INF';
        case 'camelcase':
            return '.Inf';
    }
    else if (Number.NEGATIVE_INFINITY === object) switch(style){
        case 'lowercase':
            return '-.inf';
        case 'uppercase':
            return '-.INF';
        case 'camelcase':
            return '-.Inf';
    }
    else if (common.isNegativeZero(object)) return '-0.0';
    res = object.toString(10);
    // JS stringifier can build scientific format without dots: 5e-100,
    // while YAML requres dot: 5.e-100. Fix it with simple hack
    return SCIENTIFIC_WITHOUT_DOT.test(res) ? res.replace('e', '.e') : res;
}
function isFloat(object) {
    return Object.prototype.toString.call(object) === '[object Number]' && (object % 1 !== 0 || common.isNegativeZero(object));
}
module.exports = new Type('tag:yaml.org,2002:float', {
    kind: 'scalar',
    resolve: resolveYamlFloat,
    construct: constructYamlFloat,
    predicate: isFloat,
    represent: representYamlFloat,
    defaultStyle: 'lowercase'
});

},{"4bcd6984fe954e9":"9ECBt","b088a2fb8a04518d":"26f2S"}],"1SkIo":[function(require,module,exports,__globalThis) {
'use strict';
var Type = require("3b621d288a85293b");
var YAML_DATE_REGEXP = new RegExp("^([0-9][0-9][0-9][0-9])-([0-9][0-9])-([0-9][0-9])$"); // [3] day
var YAML_TIMESTAMP_REGEXP = new RegExp("^([0-9][0-9][0-9][0-9])-([0-9][0-9]?)-([0-9][0-9]?)(?:[Tt]|[ \\t]+)([0-9][0-9]?):([0-9][0-9]):([0-9][0-9])(?:\\.([0-9]*))?(?:[ \\t]*(Z|([-+])([0-9][0-9]?)(?::([0-9][0-9]))?))?$"); // [11] tz_minute
function resolveYamlTimestamp(data) {
    if (data === null) return false;
    if (YAML_DATE_REGEXP.exec(data) !== null) return true;
    if (YAML_TIMESTAMP_REGEXP.exec(data) !== null) return true;
    return false;
}
function constructYamlTimestamp(data) {
    var match, year, month, day, hour, minute, second, fraction = 0, delta = null, tz_hour, tz_minute, date;
    match = YAML_DATE_REGEXP.exec(data);
    if (match === null) match = YAML_TIMESTAMP_REGEXP.exec(data);
    if (match === null) throw new Error('Date resolve error');
    // match: [1] year [2] month [3] day
    year = +match[1];
    month = +match[2] - 1; // JS month starts with 0
    day = +match[3];
    if (!match[4]) return new Date(Date.UTC(year, month, day));
    // match: [4] hour [5] minute [6] second [7] fraction
    hour = +match[4];
    minute = +match[5];
    second = +match[6];
    if (match[7]) {
        fraction = match[7].slice(0, 3);
        while(fraction.length < 3)fraction += '0';
        fraction = +fraction;
    }
    // match: [8] tz [9] tz_sign [10] tz_hour [11] tz_minute
    if (match[9]) {
        tz_hour = +match[10];
        tz_minute = +(match[11] || 0);
        delta = (tz_hour * 60 + tz_minute) * 60000; // delta in mili-seconds
        if (match[9] === '-') delta = -delta;
    }
    date = new Date(Date.UTC(year, month, day, hour, minute, second, fraction));
    if (delta) date.setTime(date.getTime() - delta);
    return date;
}
function representYamlTimestamp(object /*, style*/ ) {
    return object.toISOString();
}
module.exports = new Type('tag:yaml.org,2002:timestamp', {
    kind: 'scalar',
    resolve: resolveYamlTimestamp,
    construct: constructYamlTimestamp,
    instanceOf: Date,
    represent: representYamlTimestamp
});

},{"3b621d288a85293b":"26f2S"}],"gscWm":[function(require,module,exports,__globalThis) {
'use strict';
var Type = require("c6c4c453c8ffddc9");
function resolveYamlMerge(data) {
    return data === '<<' || data === null;
}
module.exports = new Type('tag:yaml.org,2002:merge', {
    kind: 'scalar',
    resolve: resolveYamlMerge
});

},{"c6c4c453c8ffddc9":"26f2S"}],"7Tw84":[function(require,module,exports,__globalThis) {
'use strict';
/*eslint-disable no-bitwise*/ var NodeBuffer;
try {
    // A trick for browserified version, to not include `Buffer` shim
    var _require = undefined;
    NodeBuffer = _require('buffer').Buffer;
} catch (__) {}
var Type = require("2337062c981a37e2");
// [ 64, 65, 66 ] -> [ padding, CR, LF ]
var BASE64_MAP = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=\n\r';
function resolveYamlBinary(data) {
    if (data === null) return false;
    var code, idx, bitlen = 0, max = data.length, map = BASE64_MAP;
    // Convert one by one.
    for(idx = 0; idx < max; idx++){
        code = map.indexOf(data.charAt(idx));
        // Skip CR/LF
        if (code > 64) continue;
        // Fail on illegal characters
        if (code < 0) return false;
        bitlen += 6;
    }
    // If there are any bits left, source was corrupted
    return bitlen % 8 === 0;
}
function constructYamlBinary(data) {
    var idx, tailbits, input = data.replace(/[\r\n=]/g, ''), max = input.length, map = BASE64_MAP, bits = 0, result = [];
    // Collect by 6*4 bits (3 bytes)
    for(idx = 0; idx < max; idx++){
        if (idx % 4 === 0 && idx) {
            result.push(bits >> 16 & 0xFF);
            result.push(bits >> 8 & 0xFF);
            result.push(bits & 0xFF);
        }
        bits = bits << 6 | map.indexOf(input.charAt(idx));
    }
    // Dump tail
    tailbits = max % 4 * 6;
    if (tailbits === 0) {
        result.push(bits >> 16 & 0xFF);
        result.push(bits >> 8 & 0xFF);
        result.push(bits & 0xFF);
    } else if (tailbits === 18) {
        result.push(bits >> 10 & 0xFF);
        result.push(bits >> 2 & 0xFF);
    } else if (tailbits === 12) result.push(bits >> 4 & 0xFF);
    // Wrap into Buffer for NodeJS and leave Array for browser
    if (NodeBuffer) // Support node 6.+ Buffer API when available
    return NodeBuffer.from ? NodeBuffer.from(result) : new NodeBuffer(result);
    return result;
}
function representYamlBinary(object /*, style*/ ) {
    var result = '', bits = 0, idx, tail, max = object.length, map = BASE64_MAP;
    // Convert every three bytes to 4 ASCII characters.
    for(idx = 0; idx < max; idx++){
        if (idx % 3 === 0 && idx) {
            result += map[bits >> 18 & 0x3F];
            result += map[bits >> 12 & 0x3F];
            result += map[bits >> 6 & 0x3F];
            result += map[bits & 0x3F];
        }
        bits = (bits << 8) + object[idx];
    }
    // Dump tail
    tail = max % 3;
    if (tail === 0) {
        result += map[bits >> 18 & 0x3F];
        result += map[bits >> 12 & 0x3F];
        result += map[bits >> 6 & 0x3F];
        result += map[bits & 0x3F];
    } else if (tail === 2) {
        result += map[bits >> 10 & 0x3F];
        result += map[bits >> 4 & 0x3F];
        result += map[bits << 2 & 0x3F];
        result += map[64];
    } else if (tail === 1) {
        result += map[bits >> 2 & 0x3F];
        result += map[bits << 4 & 0x3F];
        result += map[64];
        result += map[64];
    }
    return result;
}
function isBinary(object) {
    return NodeBuffer && NodeBuffer.isBuffer(object);
}
module.exports = new Type('tag:yaml.org,2002:binary', {
    kind: 'scalar',
    resolve: resolveYamlBinary,
    construct: constructYamlBinary,
    predicate: isBinary,
    represent: representYamlBinary
});

},{"2337062c981a37e2":"26f2S"}],"3cg2y":[function(require,module,exports,__globalThis) {
'use strict';
var Type = require("19a6bbaa7ebc4634");
var _hasOwnProperty = Object.prototype.hasOwnProperty;
var _toString = Object.prototype.toString;
function resolveYamlOmap(data) {
    if (data === null) return true;
    var objectKeys = [], index, length, pair, pairKey, pairHasKey, object = data;
    for(index = 0, length = object.length; index < length; index += 1){
        pair = object[index];
        pairHasKey = false;
        if (_toString.call(pair) !== '[object Object]') return false;
        for(pairKey in pair)if (_hasOwnProperty.call(pair, pairKey)) {
            if (!pairHasKey) pairHasKey = true;
            else return false;
        }
        if (!pairHasKey) return false;
        if (objectKeys.indexOf(pairKey) === -1) objectKeys.push(pairKey);
        else return false;
    }
    return true;
}
function constructYamlOmap(data) {
    return data !== null ? data : [];
}
module.exports = new Type('tag:yaml.org,2002:omap', {
    kind: 'sequence',
    resolve: resolveYamlOmap,
    construct: constructYamlOmap
});

},{"19a6bbaa7ebc4634":"26f2S"}],"5EPrV":[function(require,module,exports,__globalThis) {
'use strict';
var Type = require("cd88d5807b2105f1");
var _toString = Object.prototype.toString;
function resolveYamlPairs(data) {
    if (data === null) return true;
    var index, length, pair, keys, result, object = data;
    result = new Array(object.length);
    for(index = 0, length = object.length; index < length; index += 1){
        pair = object[index];
        if (_toString.call(pair) !== '[object Object]') return false;
        keys = Object.keys(pair);
        if (keys.length !== 1) return false;
        result[index] = [
            keys[0],
            pair[keys[0]]
        ];
    }
    return true;
}
function constructYamlPairs(data) {
    if (data === null) return [];
    var index, length, pair, keys, result, object = data;
    result = new Array(object.length);
    for(index = 0, length = object.length; index < length; index += 1){
        pair = object[index];
        keys = Object.keys(pair);
        result[index] = [
            keys[0],
            pair[keys[0]]
        ];
    }
    return result;
}
module.exports = new Type('tag:yaml.org,2002:pairs', {
    kind: 'sequence',
    resolve: resolveYamlPairs,
    construct: constructYamlPairs
});

},{"cd88d5807b2105f1":"26f2S"}],"6j44M":[function(require,module,exports,__globalThis) {
'use strict';
var Type = require("b1b5e199c858fdd7");
var _hasOwnProperty = Object.prototype.hasOwnProperty;
function resolveYamlSet(data) {
    if (data === null) return true;
    var key, object = data;
    for(key in object)if (_hasOwnProperty.call(object, key)) {
        if (object[key] !== null) return false;
    }
    return true;
}
function constructYamlSet(data) {
    return data !== null ? data : {};
}
module.exports = new Type('tag:yaml.org,2002:set', {
    kind: 'mapping',
    resolve: resolveYamlSet,
    construct: constructYamlSet
});

},{"b1b5e199c858fdd7":"26f2S"}],"31U4w":[function(require,module,exports,__globalThis) {
// JS-YAML's default schema for `load` function.
// It is not described in the YAML specification.
//
// This schema is based on JS-YAML's default safe schema and includes
// JavaScript-specific types: !!js/undefined, !!js/regexp and !!js/function.
//
// Also this schema is used as default base schema at `Schema.create` function.
'use strict';
var Schema = require("12cda25e36df1cc3");
module.exports = Schema.DEFAULT = new Schema({
    include: [
        require("99ed807ee0a0a365")
    ],
    explicit: [
        require("e32eccd5cdd8aaa2"),
        require("b55d5786601d55bd"),
        require("50f5796b4c48a52c")
    ]
});

},{"12cda25e36df1cc3":"klPjX","99ed807ee0a0a365":"9LPyf","e32eccd5cdd8aaa2":"kL8BM","b55d5786601d55bd":"brlzf","50f5796b4c48a52c":"ljaKx"}],"kL8BM":[function(require,module,exports,__globalThis) {
'use strict';
var Type = require("e5af49ae385d4d57");
function resolveJavascriptUndefined() {
    return true;
}
function constructJavascriptUndefined() {
    /*eslint-disable no-undefined*/ return undefined;
}
function representJavascriptUndefined() {
    return '';
}
function isUndefined(object) {
    return typeof object === 'undefined';
}
module.exports = new Type('tag:yaml.org,2002:js/undefined', {
    kind: 'scalar',
    resolve: resolveJavascriptUndefined,
    construct: constructJavascriptUndefined,
    predicate: isUndefined,
    represent: representJavascriptUndefined
});

},{"e5af49ae385d4d57":"26f2S"}],"brlzf":[function(require,module,exports,__globalThis) {
'use strict';
var Type = require("e8945c3f8f93a788");
function resolveJavascriptRegExp(data) {
    if (data === null) return false;
    if (data.length === 0) return false;
    var regexp = data, tail = /\/([gim]*)$/.exec(data), modifiers = '';
    // if regexp starts with '/' it can have modifiers and must be properly closed
    // `/foo/gim` - modifiers tail can be maximum 3 chars
    if (regexp[0] === '/') {
        if (tail) modifiers = tail[1];
        if (modifiers.length > 3) return false;
        // if expression starts with /, is should be properly terminated
        if (regexp[regexp.length - modifiers.length - 1] !== '/') return false;
    }
    return true;
}
function constructJavascriptRegExp(data) {
    var regexp = data, tail = /\/([gim]*)$/.exec(data), modifiers = '';
    // `/foo/gim` - tail can be maximum 4 chars
    if (regexp[0] === '/') {
        if (tail) modifiers = tail[1];
        regexp = regexp.slice(1, regexp.length - modifiers.length - 1);
    }
    return new RegExp(regexp, modifiers);
}
function representJavascriptRegExp(object /*, style*/ ) {
    var result = '/' + object.source + '/';
    if (object.global) result += 'g';
    if (object.multiline) result += 'm';
    if (object.ignoreCase) result += 'i';
    return result;
}
function isRegExp(object) {
    return Object.prototype.toString.call(object) === '[object RegExp]';
}
module.exports = new Type('tag:yaml.org,2002:js/regexp', {
    kind: 'scalar',
    resolve: resolveJavascriptRegExp,
    construct: constructJavascriptRegExp,
    predicate: isRegExp,
    represent: representJavascriptRegExp
});

},{"e8945c3f8f93a788":"26f2S"}],"ljaKx":[function(require,module,exports,__globalThis) {
'use strict';
var esprima;
// Browserified version does not have esprima
//
// 1. For node.js just require module as deps
// 2. For browser try to require mudule via external AMD system.
//    If not found - try to fallback to window.esprima. If not
//    found too - then fail to parse.
//
try {
    // workaround to exclude package from browserify list.
    var _require = undefined;
    esprima = _require('esprima');
} catch (_) {
    /* eslint-disable no-redeclare */ /* global window */ if (typeof window !== 'undefined') esprima = window.esprima;
}
var Type = require("820085b5efa82d46");
function resolveJavascriptFunction(data) {
    if (data === null) return false;
    try {
        var source = '(' + data + ')', ast = esprima.parse(source, {
            range: true
        });
        if (ast.type !== 'Program' || ast.body.length !== 1 || ast.body[0].type !== 'ExpressionStatement' || ast.body[0].expression.type !== 'ArrowFunctionExpression' && ast.body[0].expression.type !== 'FunctionExpression') return false;
        return true;
    } catch (err) {
        return false;
    }
}
function constructJavascriptFunction(data) {
    /*jslint evil:true*/ var source = '(' + data + ')', ast = esprima.parse(source, {
        range: true
    }), params = [], body;
    if (ast.type !== 'Program' || ast.body.length !== 1 || ast.body[0].type !== 'ExpressionStatement' || ast.body[0].expression.type !== 'ArrowFunctionExpression' && ast.body[0].expression.type !== 'FunctionExpression') throw new Error('Failed to resolve function');
    ast.body[0].expression.params.forEach(function(param) {
        params.push(param.name);
    });
    body = ast.body[0].expression.body.range;
    // Esprima's ranges include the first '{' and the last '}' characters on
    // function expressions. So cut them out.
    if (ast.body[0].expression.body.type === 'BlockStatement') /*eslint-disable no-new-func*/ return new Function(params, source.slice(body[0] + 1, body[1] - 1));
    // ES6 arrow functions can omit the BlockStatement. In that case, just return
    // the body.
    /*eslint-disable no-new-func*/ return new Function(params, 'return ' + source.slice(body[0], body[1]));
}
function representJavascriptFunction(object /*, style*/ ) {
    return object.toString();
}
function isFunction(object) {
    return Object.prototype.toString.call(object) === '[object Function]';
}
module.exports = new Type('tag:yaml.org,2002:js/function', {
    kind: 'scalar',
    resolve: resolveJavascriptFunction,
    construct: constructJavascriptFunction,
    predicate: isFunction,
    represent: representJavascriptFunction
});

},{"820085b5efa82d46":"26f2S"}],"lW86X":[function(require,module,exports,__globalThis) {
'use strict';
/*eslint-disable no-use-before-define*/ var common = require("5838f980073eb1c0");
var YAMLException = require("213618ee9e49da0d");
var DEFAULT_FULL_SCHEMA = require("7f1573fc187377e8");
var DEFAULT_SAFE_SCHEMA = require("8e4eba08460c0f1a");
var _toString = Object.prototype.toString;
var _hasOwnProperty = Object.prototype.hasOwnProperty;
var CHAR_TAB = 0x09; /* Tab */ 
var CHAR_LINE_FEED = 0x0A; /* LF */ 
var CHAR_CARRIAGE_RETURN = 0x0D; /* CR */ 
var CHAR_SPACE = 0x20; /* Space */ 
var CHAR_EXCLAMATION = 0x21; /* ! */ 
var CHAR_DOUBLE_QUOTE = 0x22; /* " */ 
var CHAR_SHARP = 0x23; /* # */ 
var CHAR_PERCENT = 0x25; /* % */ 
var CHAR_AMPERSAND = 0x26; /* & */ 
var CHAR_SINGLE_QUOTE = 0x27; /* ' */ 
var CHAR_ASTERISK = 0x2A; /* * */ 
var CHAR_COMMA = 0x2C; /* , */ 
var CHAR_MINUS = 0x2D; /* - */ 
var CHAR_COLON = 0x3A; /* : */ 
var CHAR_EQUALS = 0x3D; /* = */ 
var CHAR_GREATER_THAN = 0x3E; /* > */ 
var CHAR_QUESTION = 0x3F; /* ? */ 
var CHAR_COMMERCIAL_AT = 0x40; /* @ */ 
var CHAR_LEFT_SQUARE_BRACKET = 0x5B; /* [ */ 
var CHAR_RIGHT_SQUARE_BRACKET = 0x5D; /* ] */ 
var CHAR_GRAVE_ACCENT = 0x60; /* ` */ 
var CHAR_LEFT_CURLY_BRACKET = 0x7B; /* { */ 
var CHAR_VERTICAL_LINE = 0x7C; /* | */ 
var CHAR_RIGHT_CURLY_BRACKET = 0x7D; /* } */ 
var ESCAPE_SEQUENCES = {};
ESCAPE_SEQUENCES[0x00] = '\\0';
ESCAPE_SEQUENCES[0x07] = '\\a';
ESCAPE_SEQUENCES[0x08] = '\\b';
ESCAPE_SEQUENCES[0x09] = '\\t';
ESCAPE_SEQUENCES[0x0A] = '\\n';
ESCAPE_SEQUENCES[0x0B] = '\\v';
ESCAPE_SEQUENCES[0x0C] = '\\f';
ESCAPE_SEQUENCES[0x0D] = '\\r';
ESCAPE_SEQUENCES[0x1B] = '\\e';
ESCAPE_SEQUENCES[0x22] = '\\"';
ESCAPE_SEQUENCES[0x5C] = '\\\\';
ESCAPE_SEQUENCES[0x85] = '\\N';
ESCAPE_SEQUENCES[0xA0] = '\\_';
ESCAPE_SEQUENCES[0x2028] = '\\L';
ESCAPE_SEQUENCES[0x2029] = '\\P';
var DEPRECATED_BOOLEANS_SYNTAX = [
    'y',
    'Y',
    'yes',
    'Yes',
    'YES',
    'on',
    'On',
    'ON',
    'n',
    'N',
    'no',
    'No',
    'NO',
    'off',
    'Off',
    'OFF'
];
function compileStyleMap(schema, map) {
    var result, keys, index, length, tag, style, type;
    if (map === null) return {};
    result = {};
    keys = Object.keys(map);
    for(index = 0, length = keys.length; index < length; index += 1){
        tag = keys[index];
        style = String(map[tag]);
        if (tag.slice(0, 2) === '!!') tag = 'tag:yaml.org,2002:' + tag.slice(2);
        type = schema.compiledTypeMap['fallback'][tag];
        if (type && _hasOwnProperty.call(type.styleAliases, style)) style = type.styleAliases[style];
        result[tag] = style;
    }
    return result;
}
function encodeHex(character) {
    var string, handle, length;
    string = character.toString(16).toUpperCase();
    if (character <= 0xFF) {
        handle = 'x';
        length = 2;
    } else if (character <= 0xFFFF) {
        handle = 'u';
        length = 4;
    } else if (character <= 0xFFFFFFFF) {
        handle = 'U';
        length = 8;
    } else throw new YAMLException('code point within a string may not be greater than 0xFFFFFFFF');
    return '\\' + handle + common.repeat('0', length - string.length) + string;
}
function State(options) {
    this.schema = options['schema'] || DEFAULT_FULL_SCHEMA;
    this.indent = Math.max(1, options['indent'] || 2);
    this.noArrayIndent = options['noArrayIndent'] || false;
    this.skipInvalid = options['skipInvalid'] || false;
    this.flowLevel = common.isNothing(options['flowLevel']) ? -1 : options['flowLevel'];
    this.styleMap = compileStyleMap(this.schema, options['styles'] || null);
    this.sortKeys = options['sortKeys'] || false;
    this.lineWidth = options['lineWidth'] || 80;
    this.noRefs = options['noRefs'] || false;
    this.noCompatMode = options['noCompatMode'] || false;
    this.condenseFlow = options['condenseFlow'] || false;
    this.implicitTypes = this.schema.compiledImplicit;
    this.explicitTypes = this.schema.compiledExplicit;
    this.tag = null;
    this.result = '';
    this.duplicates = [];
    this.usedDuplicates = null;
}
// Indents every line in a string. Empty lines (\n only) are not indented.
function indentString(string, spaces) {
    var ind = common.repeat(' ', spaces), position = 0, next = -1, result = '', line, length = string.length;
    while(position < length){
        next = string.indexOf('\n', position);
        if (next === -1) {
            line = string.slice(position);
            position = length;
        } else {
            line = string.slice(position, next + 1);
            position = next + 1;
        }
        if (line.length && line !== '\n') result += ind;
        result += line;
    }
    return result;
}
function generateNextLine(state, level) {
    return '\n' + common.repeat(' ', state.indent * level);
}
function testImplicitResolving(state, str) {
    var index, length, type;
    for(index = 0, length = state.implicitTypes.length; index < length; index += 1){
        type = state.implicitTypes[index];
        if (type.resolve(str)) return true;
    }
    return false;
}
// [33] s-white ::= s-space | s-tab
function isWhitespace(c) {
    return c === CHAR_SPACE || c === CHAR_TAB;
}
// Returns true if the character can be printed without escaping.
// From YAML 1.2: "any allowed characters known to be non-printable
// should also be escaped. [However,] This isn’t mandatory"
// Derived from nb-char - \t - #x85 - #xA0 - #x2028 - #x2029.
function isPrintable(c) {
    return 0x00020 <= c && c <= 0x00007E || 0x000A1 <= c && c <= 0x00D7FF && c !== 0x2028 && c !== 0x2029 || 0x0E000 <= c && c <= 0x00FFFD && c !== 0xFEFF /* BOM */  || 0x10000 <= c && c <= 0x10FFFF;
}
// [34] ns-char ::= nb-char - s-white
// [27] nb-char ::= c-printable - b-char - c-byte-order-mark
// [26] b-char  ::= b-line-feed | b-carriage-return
// [24] b-line-feed       ::=     #xA    /* LF */
// [25] b-carriage-return ::=     #xD    /* CR */
// [3]  c-byte-order-mark ::=     #xFEFF
function isNsChar(c) {
    return isPrintable(c) && !isWhitespace(c) && c !== 0xFEFF && c !== CHAR_CARRIAGE_RETURN && c !== CHAR_LINE_FEED;
}
// Simplified test for values allowed after the first character in plain style.
function isPlainSafe(c, prev) {
    // Uses a subset of nb-char - c-flow-indicator - ":" - "#"
    // where nb-char ::= c-printable - b-char - c-byte-order-mark.
    return isPrintable(c) && c !== 0xFEFF && c !== CHAR_COMMA && c !== CHAR_LEFT_SQUARE_BRACKET && c !== CHAR_RIGHT_SQUARE_BRACKET && c !== CHAR_LEFT_CURLY_BRACKET && c !== CHAR_RIGHT_CURLY_BRACKET && c !== CHAR_COLON && (c !== CHAR_SHARP || prev && isNsChar(prev));
}
// Simplified test for values allowed as the first character in plain style.
function isPlainSafeFirst(c) {
    // Uses a subset of ns-char - c-indicator
    // where ns-char = nb-char - s-white.
    return isPrintable(c) && c !== 0xFEFF && !isWhitespace(c) // - s-white
     && c !== CHAR_MINUS && c !== CHAR_QUESTION && c !== CHAR_COLON && c !== CHAR_COMMA && c !== CHAR_LEFT_SQUARE_BRACKET && c !== CHAR_RIGHT_SQUARE_BRACKET && c !== CHAR_LEFT_CURLY_BRACKET && c !== CHAR_RIGHT_CURLY_BRACKET && c !== CHAR_SHARP && c !== CHAR_AMPERSAND && c !== CHAR_ASTERISK && c !== CHAR_EXCLAMATION && c !== CHAR_VERTICAL_LINE && c !== CHAR_EQUALS && c !== CHAR_GREATER_THAN && c !== CHAR_SINGLE_QUOTE && c !== CHAR_DOUBLE_QUOTE && c !== CHAR_PERCENT && c !== CHAR_COMMERCIAL_AT && c !== CHAR_GRAVE_ACCENT;
}
// Determines whether block indentation indicator is required.
function needIndentIndicator(string) {
    var leadingSpaceRe = /^\n* /;
    return leadingSpaceRe.test(string);
}
var STYLE_PLAIN = 1, STYLE_SINGLE = 2, STYLE_LITERAL = 3, STYLE_FOLDED = 4, STYLE_DOUBLE = 5;
// Determines which scalar styles are possible and returns the preferred style.
// lineWidth = -1 => no limit.
// Pre-conditions: str.length > 0.
// Post-conditions:
//    STYLE_PLAIN or STYLE_SINGLE => no \n are in the string.
//    STYLE_LITERAL => no lines are suitable for folding (or lineWidth is -1).
//    STYLE_FOLDED => a line > lineWidth and can be folded (and lineWidth != -1).
function chooseScalarStyle(string, singleLineOnly, indentPerLevel, lineWidth, testAmbiguousType) {
    var i;
    var char, prev_char;
    var hasLineBreak = false;
    var hasFoldableLine = false; // only checked if shouldTrackWidth
    var shouldTrackWidth = lineWidth !== -1;
    var previousLineBreak = -1; // count the first line correctly
    var plain = isPlainSafeFirst(string.charCodeAt(0)) && !isWhitespace(string.charCodeAt(string.length - 1));
    if (singleLineOnly) // Case: no block styles.
    // Check for disallowed characters to rule out plain and single.
    for(i = 0; i < string.length; i++){
        char = string.charCodeAt(i);
        if (!isPrintable(char)) return STYLE_DOUBLE;
        prev_char = i > 0 ? string.charCodeAt(i - 1) : null;
        plain = plain && isPlainSafe(char, prev_char);
    }
    else {
        // Case: block styles permitted.
        for(i = 0; i < string.length; i++){
            char = string.charCodeAt(i);
            if (char === CHAR_LINE_FEED) {
                hasLineBreak = true;
                // Check if any line can be folded.
                if (shouldTrackWidth) {
                    hasFoldableLine = hasFoldableLine || // Foldable line = too long, and not more-indented.
                    i - previousLineBreak - 1 > lineWidth && string[previousLineBreak + 1] !== ' ';
                    previousLineBreak = i;
                }
            } else if (!isPrintable(char)) return STYLE_DOUBLE;
            prev_char = i > 0 ? string.charCodeAt(i - 1) : null;
            plain = plain && isPlainSafe(char, prev_char);
        }
        // in case the end is missing a \n
        hasFoldableLine = hasFoldableLine || shouldTrackWidth && i - previousLineBreak - 1 > lineWidth && string[previousLineBreak + 1] !== ' ';
    }
    // Although every style can represent \n without escaping, prefer block styles
    // for multiline, since they're more readable and they don't add empty lines.
    // Also prefer folding a super-long line.
    if (!hasLineBreak && !hasFoldableLine) // Strings interpretable as another type have to be quoted;
    // e.g. the string 'true' vs. the boolean true.
    return plain && !testAmbiguousType(string) ? STYLE_PLAIN : STYLE_SINGLE;
    // Edge case: block indentation indicator can only have one digit.
    if (indentPerLevel > 9 && needIndentIndicator(string)) return STYLE_DOUBLE;
    // At this point we know block styles are valid.
    // Prefer literal style unless we want to fold.
    return hasFoldableLine ? STYLE_FOLDED : STYLE_LITERAL;
}
// Note: line breaking/folding is implemented for only the folded style.
// NB. We drop the last trailing newline (if any) of a returned block scalar
//  since the dumper adds its own newline. This always works:
//    • No ending newline => unaffected; already using strip "-" chomping.
//    • Ending newline    => removed then restored.
//  Importantly, this keeps the "+" chomp indicator from gaining an extra line.
function writeScalar(state, string, level, iskey) {
    state.dump = function() {
        if (string.length === 0) return "''";
        if (!state.noCompatMode && DEPRECATED_BOOLEANS_SYNTAX.indexOf(string) !== -1) return "'" + string + "'";
        var indent = state.indent * Math.max(1, level); // no 0-indent scalars
        // As indentation gets deeper, let the width decrease monotonically
        // to the lower bound min(state.lineWidth, 40).
        // Note that this implies
        //  state.lineWidth ≤ 40 + state.indent: width is fixed at the lower bound.
        //  state.lineWidth > 40 + state.indent: width decreases until the lower bound.
        // This behaves better than a constant minimum width which disallows narrower options,
        // or an indent threshold which causes the width to suddenly increase.
        var lineWidth = state.lineWidth === -1 ? -1 : Math.max(Math.min(state.lineWidth, 40), state.lineWidth - indent);
        // Without knowing if keys are implicit/explicit, assume implicit for safety.
        var singleLineOnly = iskey || state.flowLevel > -1 && level >= state.flowLevel;
        function testAmbiguity(string) {
            return testImplicitResolving(state, string);
        }
        switch(chooseScalarStyle(string, singleLineOnly, state.indent, lineWidth, testAmbiguity)){
            case STYLE_PLAIN:
                return string;
            case STYLE_SINGLE:
                return "'" + string.replace(/'/g, "''") + "'";
            case STYLE_LITERAL:
                return '|' + blockHeader(string, state.indent) + dropEndingNewline(indentString(string, indent));
            case STYLE_FOLDED:
                return '>' + blockHeader(string, state.indent) + dropEndingNewline(indentString(foldString(string, lineWidth), indent));
            case STYLE_DOUBLE:
                return '"' + escapeString(string, lineWidth) + '"';
            default:
                throw new YAMLException('impossible error: invalid scalar style');
        }
    }();
}
// Pre-conditions: string is valid for a block scalar, 1 <= indentPerLevel <= 9.
function blockHeader(string, indentPerLevel) {
    var indentIndicator = needIndentIndicator(string) ? String(indentPerLevel) : '';
    // note the special case: the string '\n' counts as a "trailing" empty line.
    var clip = string[string.length - 1] === '\n';
    var keep = clip && (string[string.length - 2] === '\n' || string === '\n');
    var chomp = keep ? '+' : clip ? '' : '-';
    return indentIndicator + chomp + '\n';
}
// (See the note for writeScalar.)
function dropEndingNewline(string) {
    return string[string.length - 1] === '\n' ? string.slice(0, -1) : string;
}
// Note: a long line without a suitable break point will exceed the width limit.
// Pre-conditions: every char in str isPrintable, str.length > 0, width > 0.
function foldString(string, width) {
    // In folded style, $k$ consecutive newlines output as $k+1$ newlines—
    // unless they're before or after a more-indented line, or at the very
    // beginning or end, in which case $k$ maps to $k$.
    // Therefore, parse each chunk as newline(s) followed by a content line.
    var lineRe = /(\n+)([^\n]*)/g;
    // first line (possibly an empty line)
    var result = function() {
        var nextLF = string.indexOf('\n');
        nextLF = nextLF !== -1 ? nextLF : string.length;
        lineRe.lastIndex = nextLF;
        return foldLine(string.slice(0, nextLF), width);
    }();
    // If we haven't reached the first content line yet, don't add an extra \n.
    var prevMoreIndented = string[0] === '\n' || string[0] === ' ';
    var moreIndented;
    // rest of the lines
    var match;
    while(match = lineRe.exec(string)){
        var prefix = match[1], line = match[2];
        moreIndented = line[0] === ' ';
        result += prefix + (!prevMoreIndented && !moreIndented && line !== '' ? '\n' : '') + foldLine(line, width);
        prevMoreIndented = moreIndented;
    }
    return result;
}
// Greedy line breaking.
// Picks the longest line under the limit each time,
// otherwise settles for the shortest line over the limit.
// NB. More-indented lines *cannot* be folded, as that would add an extra \n.
function foldLine(line, width) {
    if (line === '' || line[0] === ' ') return line;
    // Since a more-indented line adds a \n, breaks can't be followed by a space.
    var breakRe = / [^ ]/g; // note: the match index will always be <= length-2.
    var match;
    // start is an inclusive index. end, curr, and next are exclusive.
    var start = 0, end, curr = 0, next = 0;
    var result = '';
    // Invariants: 0 <= start <= length-1.
    //   0 <= curr <= next <= max(0, length-2). curr - start <= width.
    // Inside the loop:
    //   A match implies length >= 2, so curr and next are <= length-2.
    while(match = breakRe.exec(line)){
        next = match.index;
        // maintain invariant: curr - start <= width
        if (next - start > width) {
            end = curr > start ? curr : next; // derive end <= length-2
            result += '\n' + line.slice(start, end);
            // skip the space that was output as \n
            start = end + 1; // derive start <= length-1
        }
        curr = next;
    }
    // By the invariants, start <= length-1, so there is something left over.
    // It is either the whole string or a part starting from non-whitespace.
    result += '\n';
    // Insert a break if the remainder is too long and there is a break available.
    if (line.length - start > width && curr > start) result += line.slice(start, curr) + '\n' + line.slice(curr + 1);
    else result += line.slice(start);
    return result.slice(1); // drop extra \n joiner
}
// Escapes a double-quoted string.
function escapeString(string) {
    var result = '';
    var char, nextChar;
    var escapeSeq;
    for(var i = 0; i < string.length; i++){
        char = string.charCodeAt(i);
        // Check for surrogate pairs (reference Unicode 3.0 section "3.7 Surrogates").
        if (char >= 0xD800 && char <= 0xDBFF /* high surrogate */ ) {
            nextChar = string.charCodeAt(i + 1);
            if (nextChar >= 0xDC00 && nextChar <= 0xDFFF /* low surrogate */ ) {
                // Combine the surrogate pair and store it escaped.
                result += encodeHex((char - 0xD800) * 0x400 + nextChar - 0xDC00 + 0x10000);
                // Advance index one extra since we already used that char here.
                i++;
                continue;
            }
        }
        escapeSeq = ESCAPE_SEQUENCES[char];
        result += !escapeSeq && isPrintable(char) ? string[i] : escapeSeq || encodeHex(char);
    }
    return result;
}
function writeFlowSequence(state, level, object) {
    var _result = '', _tag = state.tag, index, length;
    for(index = 0, length = object.length; index < length; index += 1)// Write only valid elements.
    if (writeNode(state, level, object[index], false, false)) {
        if (index !== 0) _result += ',' + (!state.condenseFlow ? ' ' : '');
        _result += state.dump;
    }
    state.tag = _tag;
    state.dump = '[' + _result + ']';
}
function writeBlockSequence(state, level, object, compact) {
    var _result = '', _tag = state.tag, index, length;
    for(index = 0, length = object.length; index < length; index += 1)// Write only valid elements.
    if (writeNode(state, level + 1, object[index], true, true)) {
        if (!compact || index !== 0) _result += generateNextLine(state, level);
        if (state.dump && CHAR_LINE_FEED === state.dump.charCodeAt(0)) _result += '-';
        else _result += '- ';
        _result += state.dump;
    }
    state.tag = _tag;
    state.dump = _result || '[]'; // Empty sequence if no valid values.
}
function writeFlowMapping(state, level, object) {
    var _result = '', _tag = state.tag, objectKeyList = Object.keys(object), index, length, objectKey, objectValue, pairBuffer;
    for(index = 0, length = objectKeyList.length; index < length; index += 1){
        pairBuffer = '';
        if (index !== 0) pairBuffer += ', ';
        if (state.condenseFlow) pairBuffer += '"';
        objectKey = objectKeyList[index];
        objectValue = object[objectKey];
        if (!writeNode(state, level, objectKey, false, false)) continue; // Skip this pair because of invalid key;
        if (state.dump.length > 1024) pairBuffer += '? ';
        pairBuffer += state.dump + (state.condenseFlow ? '"' : '') + ':' + (state.condenseFlow ? '' : ' ');
        if (!writeNode(state, level, objectValue, false, false)) continue; // Skip this pair because of invalid value.
        pairBuffer += state.dump;
        // Both key and value are valid.
        _result += pairBuffer;
    }
    state.tag = _tag;
    state.dump = '{' + _result + '}';
}
function writeBlockMapping(state, level, object, compact) {
    var _result = '', _tag = state.tag, objectKeyList = Object.keys(object), index, length, objectKey, objectValue, explicitPair, pairBuffer;
    // Allow sorting keys so that the output file is deterministic
    if (state.sortKeys === true) // Default sorting
    objectKeyList.sort();
    else if (typeof state.sortKeys === 'function') // Custom sort function
    objectKeyList.sort(state.sortKeys);
    else if (state.sortKeys) // Something is wrong
    throw new YAMLException('sortKeys must be a boolean or a function');
    for(index = 0, length = objectKeyList.length; index < length; index += 1){
        pairBuffer = '';
        if (!compact || index !== 0) pairBuffer += generateNextLine(state, level);
        objectKey = objectKeyList[index];
        objectValue = object[objectKey];
        if (!writeNode(state, level + 1, objectKey, true, true, true)) continue; // Skip this pair because of invalid key.
        explicitPair = state.tag !== null && state.tag !== '?' || state.dump && state.dump.length > 1024;
        if (explicitPair) {
            if (state.dump && CHAR_LINE_FEED === state.dump.charCodeAt(0)) pairBuffer += '?';
            else pairBuffer += '? ';
        }
        pairBuffer += state.dump;
        if (explicitPair) pairBuffer += generateNextLine(state, level);
        if (!writeNode(state, level + 1, objectValue, true, explicitPair)) continue; // Skip this pair because of invalid value.
        if (state.dump && CHAR_LINE_FEED === state.dump.charCodeAt(0)) pairBuffer += ':';
        else pairBuffer += ': ';
        pairBuffer += state.dump;
        // Both key and value are valid.
        _result += pairBuffer;
    }
    state.tag = _tag;
    state.dump = _result || '{}'; // Empty mapping if no valid pairs.
}
function detectType(state, object, explicit) {
    var _result, typeList, index, length, type, style;
    typeList = explicit ? state.explicitTypes : state.implicitTypes;
    for(index = 0, length = typeList.length; index < length; index += 1){
        type = typeList[index];
        if ((type.instanceOf || type.predicate) && (!type.instanceOf || typeof object === 'object' && object instanceof type.instanceOf) && (!type.predicate || type.predicate(object))) {
            state.tag = explicit ? type.tag : '?';
            if (type.represent) {
                style = state.styleMap[type.tag] || type.defaultStyle;
                if (_toString.call(type.represent) === '[object Function]') _result = type.represent(object, style);
                else if (_hasOwnProperty.call(type.represent, style)) _result = type.represent[style](object, style);
                else throw new YAMLException('!<' + type.tag + '> tag resolver accepts not "' + style + '" style');
                state.dump = _result;
            }
            return true;
        }
    }
    return false;
}
// Serializes `object` and writes it to global `result`.
// Returns true on success, or false on invalid object.
//
function writeNode(state, level, object, block, compact, iskey) {
    state.tag = null;
    state.dump = object;
    if (!detectType(state, object, false)) detectType(state, object, true);
    var type = _toString.call(state.dump);
    if (block) block = state.flowLevel < 0 || state.flowLevel > level;
    var objectOrArray = type === '[object Object]' || type === '[object Array]', duplicateIndex, duplicate;
    if (objectOrArray) {
        duplicateIndex = state.duplicates.indexOf(object);
        duplicate = duplicateIndex !== -1;
    }
    if (state.tag !== null && state.tag !== '?' || duplicate || state.indent !== 2 && level > 0) compact = false;
    if (duplicate && state.usedDuplicates[duplicateIndex]) state.dump = '*ref_' + duplicateIndex;
    else {
        if (objectOrArray && duplicate && !state.usedDuplicates[duplicateIndex]) state.usedDuplicates[duplicateIndex] = true;
        if (type === '[object Object]') {
            if (block && Object.keys(state.dump).length !== 0) {
                writeBlockMapping(state, level, state.dump, compact);
                if (duplicate) state.dump = '&ref_' + duplicateIndex + state.dump;
            } else {
                writeFlowMapping(state, level, state.dump);
                if (duplicate) state.dump = '&ref_' + duplicateIndex + ' ' + state.dump;
            }
        } else if (type === '[object Array]') {
            var arrayLevel = state.noArrayIndent && level > 0 ? level - 1 : level;
            if (block && state.dump.length !== 0) {
                writeBlockSequence(state, arrayLevel, state.dump, compact);
                if (duplicate) state.dump = '&ref_' + duplicateIndex + state.dump;
            } else {
                writeFlowSequence(state, arrayLevel, state.dump);
                if (duplicate) state.dump = '&ref_' + duplicateIndex + ' ' + state.dump;
            }
        } else if (type === '[object String]') {
            if (state.tag !== '?') writeScalar(state, state.dump, level, iskey);
        } else {
            if (state.skipInvalid) return false;
            throw new YAMLException('unacceptable kind of an object to dump ' + type);
        }
        if (state.tag !== null && state.tag !== '?') state.dump = '!<' + state.tag + '> ' + state.dump;
    }
    return true;
}
function getDuplicateReferences(object, state) {
    var objects = [], duplicatesIndexes = [], index, length;
    inspectNode(object, objects, duplicatesIndexes);
    for(index = 0, length = duplicatesIndexes.length; index < length; index += 1)state.duplicates.push(objects[duplicatesIndexes[index]]);
    state.usedDuplicates = new Array(length);
}
function inspectNode(object, objects, duplicatesIndexes) {
    var objectKeyList, index, length;
    if (object !== null && typeof object === 'object') {
        index = objects.indexOf(object);
        if (index !== -1) {
            if (duplicatesIndexes.indexOf(index) === -1) duplicatesIndexes.push(index);
        } else {
            objects.push(object);
            if (Array.isArray(object)) for(index = 0, length = object.length; index < length; index += 1)inspectNode(object[index], objects, duplicatesIndexes);
            else {
                objectKeyList = Object.keys(object);
                for(index = 0, length = objectKeyList.length; index < length; index += 1)inspectNode(object[objectKeyList[index]], objects, duplicatesIndexes);
            }
        }
    }
}
function dump(input, options) {
    options = options || {};
    var state = new State(options);
    if (!state.noRefs) getDuplicateReferences(input, state);
    if (writeNode(state, 0, input, true, true)) return state.dump + '\n';
    return '';
}
function safeDump(input, options) {
    return dump(input, common.extend({
        schema: DEFAULT_SAFE_SCHEMA
    }, options));
}
module.exports.dump = dump;
module.exports.safeDump = safeDump;

},{"5838f980073eb1c0":"9ECBt","213618ee9e49da0d":"aTl5o","7f1573fc187377e8":"31U4w","8e4eba08460c0f1a":"9LPyf"}],"93e4n":[function(require,module,exports,__globalThis) {
'use strict';
var _ = {
    cloneDeep: require("e6ee062a552db893"),
    isUndefined: require("3c160ab6f2c55155"),
    isEmpty: require("599206838b910ae"),
    isObject: require("62d71a2aa63c17bd")
};
var helpers = require("f6ba2bdf9a23eefa");
var Model = require("e50ff2760700d845");
var SwaggerHttp = require("ebb2811b37428550");
var Q = require("c8192dae4392438c");
var Operation = module.exports = function(parent, scheme, operationId, httpMethod, path, args, definitions, models, clientAuthorizations) {
    var errors = [];
    parent = parent || {};
    args = args || {};
    if (parent && parent.options) {
        this.client = parent.options.client || null;
        this.requestInterceptor = parent.options.requestInterceptor || null;
        this.responseInterceptor = parent.options.responseInterceptor || null;
    }
    this.authorizations = args.security;
    this.basePath = parent.basePath || '/';
    this.clientAuthorizations = clientAuthorizations;
    this.consumes = args.consumes || parent.consumes || [
        'application/json'
    ];
    this.produces = args.produces || parent.produces || [
        'application/json'
    ];
    this.deprecated = args.deprecated;
    this.description = args.description;
    this.host = parent.host;
    this.method = httpMethod || errors.push('Operation ' + operationId + ' is missing method.');
    this.models = models || {};
    this.nickname = operationId || errors.push('Operations must have a nickname.');
    this.operation = args;
    this.operations = {};
    this.parameters = args !== null ? args.parameters || [] : {};
    this.parent = parent;
    this.path = path || errors.push('Operation ' + this.nickname + ' is missing path.');
    this.responses = args.responses || {};
    this.scheme = scheme || parent.scheme || 'http';
    this.schemes = args.schemes || parent.schemes;
    this.security = args.security || parent.security;
    this.summary = args.summary || '';
    this.timeout = parent.timeout;
    this.type = null;
    this.useJQuery = parent.useJQuery;
    this.jqueryAjaxCache = parent.jqueryAjaxCache;
    this.enableCookies = parent.enableCookies;
    if (!this.host) {
        if (typeof window !== 'undefined') this.host = window.location.host;
        else this.host = 'localhost';
    }
    this.parameterMacro = parent.parameterMacro || function(operation, parameter) {
        return parameter.default;
    };
    this.inlineModels = [];
    if (this.basePath !== '/' && this.basePath.slice(-1) === '/') this.basePath = this.basePath.slice(0, -1);
    if (typeof this.deprecated === 'string') switch(this.deprecated.toLowerCase()){
        case 'true':
        case 'yes':
        case '1':
            this.deprecated = true;
            break;
        case 'false':
        case 'no':
        case '0':
        case null:
            this.deprecated = false;
            break;
        default:
            this.deprecated = Boolean(this.deprecated);
    }
    var i, model;
    if (definitions) {
        // add to global models
        var key;
        for(key in definitions){
            model = new Model(key, definitions[key], this.models, parent.modelPropertyMacro);
            if (model) this.models[key] = model;
        }
    } else definitions = {};
    for(i = 0; i < this.parameters.length; i++){
        var param = this.parameters[i];
        // Allow macro to set the default value
        param.default = this.parameterMacro(this, param);
        if (param.type === 'array') {
            param.isList = true;
            param.allowMultiple = true;
        // the enum can be defined at the items level
        //if (param.items && param.items.enum) {
        //  param['enum'] = param.items.enum;
        //}
        }
        var innerType = this.getType(param);
        if (innerType && innerType.toString().toLowerCase() === 'boolean') {
            param.allowableValues = {};
            param.isList = true;
            param['enum'] = [
                true,
                false
            ]; // use actual primitives
        }
        if (typeof param['x-example'] !== 'undefined') {
            var d = param['x-example'];
            param.default = d;
        }
        if (param['x-examples']) {
            var d = param['x-examples'].default;
            if (typeof d !== 'undefined') param.default = d;
        }
        var enumValues = param['enum'] || param.items && param.items['enum'];
        if (typeof enumValues !== 'undefined') {
            var id;
            param.allowableValues = {};
            param.allowableValues.values = [];
            param.allowableValues.descriptiveValues = [];
            for(id = 0; id < enumValues.length; id++){
                var value = enumValues[id];
                var isDefault = value === param.default || value + '' === param.default;
                param.allowableValues.values.push(value);
                // Always have string for descriptive values....
                param.allowableValues.descriptiveValues.push({
                    value: value + '',
                    isDefault: isDefault
                });
            }
        }
        if (param.type === 'array') {
            innerType = [
                innerType
            ];
            if (typeof param.allowableValues === 'undefined') {
                // can't show as a list if no values to select from
                delete param.isList;
                delete param.allowMultiple;
            }
        }
        param.modelSignature = {
            type: innerType,
            definitions: this.models
        };
        param.signature = this.getModelSignature(innerType, this.models).toString();
        param.sampleJSON = this.getModelSampleJSON(innerType, this.models);
        param.responseClassSignature = param.signature;
    }
    var defaultResponseCode, response, responses = this.responses;
    if (responses['200']) {
        response = responses['200'];
        defaultResponseCode = '200';
    } else if (responses['201']) {
        response = responses['201'];
        defaultResponseCode = '201';
    } else if (responses['202']) {
        response = responses['202'];
        defaultResponseCode = '202';
    } else if (responses['203']) {
        response = responses['203'];
        defaultResponseCode = '203';
    } else if (responses['204']) {
        response = responses['204'];
        defaultResponseCode = '204';
    } else if (responses['205']) {
        response = responses['205'];
        defaultResponseCode = '205';
    } else if (responses['206']) {
        response = responses['206'];
        defaultResponseCode = '206';
    } else if (responses['default']) {
        response = responses['default'];
        defaultResponseCode = 'default';
    }
    if (response && response.schema) {
        var resolvedModel = this.resolveModel(response.schema, definitions);
        var successResponse;
        delete responses[defaultResponseCode];
        if (resolvedModel) {
            this.successResponse = {};
            successResponse = this.successResponse[defaultResponseCode] = resolvedModel;
        } else if (!response.schema.type || response.schema.type === 'object' || response.schema.type === 'array') {
            // Inline model
            this.successResponse = {};
            successResponse = this.successResponse[defaultResponseCode] = new Model(undefined, response.schema || {}, this.models, parent.modelPropertyMacro);
        } else {
            // Primitive
            this.successResponse = {};
            successResponse = this.successResponse[defaultResponseCode] = response.schema;
        }
        if (successResponse) {
            // Attach response properties
            if (response.description) successResponse.description = response.description;
            if (response.examples) successResponse.examples = response.examples;
            if (response.headers) successResponse.headers = response.headers;
        }
        this.type = response;
    }
    if (errors.length > 0) {
        if (this.resource && this.resource.api && this.resource.api.fail) this.resource.api.fail(errors);
    }
    return this;
};
Operation.prototype.isDefaultArrayItemValue = function(value, param) {
    if (param.default && Array.isArray(param.default)) return param.default.indexOf(value) !== -1;
    return value === param.default;
};
Operation.prototype.getType = function(param) {
    var type = param.type;
    var format = param.format;
    var isArray = false;
    var str;
    if (type === 'integer' && format === 'int32') str = 'integer';
    else if (type === 'integer' && format === 'int64') str = 'long';
    else if (type === 'integer') str = 'integer';
    else if (type === 'string') {
        if (format === 'date-time') str = 'date-time';
        else if (format === 'date') str = 'date';
        else str = 'string';
    } else if (type === 'number' && format === 'float') str = 'float';
    else if (type === 'number' && format === 'double') str = 'double';
    else if (type === 'number') str = 'double';
    else if (type === 'boolean') str = 'boolean';
    else if (type === 'array') {
        isArray = true;
        if (param.items) str = this.getType(param.items);
    } else if (type === 'file') str = 'file';
    if (param.$ref) str = helpers.simpleRef(param.$ref);
    var schema = param.schema;
    if (schema) {
        var ref = schema.$ref;
        if (ref) {
            ref = helpers.simpleRef(ref);
            if (isArray) return [
                ref
            ];
            else return ref;
        } else {
            // If inline schema, we add it our interal hash -> which gives us it's ID (int)
            if (schema.type === 'object') return this.addInlineModel(schema);
            return this.getType(schema);
        }
    }
    if (isArray) return [
        str
    ];
    else return str;
};
/**
 * adds an inline schema (model) to a hash, where we can ref it later
 * @param {object} schema a schema
 * @return {number} the ID of the schema being added, or null
 **/ Operation.prototype.addInlineModel = function(schema) {
    var len = this.inlineModels.length;
    var model = this.resolveModel(schema, {});
    if (model) {
        this.inlineModels.push(model);
        return 'Inline Model ' + len; // return string ref of the inline model (used with #getInlineModel)
    }
    return null; // report errors?
};
/**
 * gets the internal ref to an inline model
 * @param {string} inline_str a string reference to an inline model
 * @return {Model} the model being referenced. Or null
 **/ Operation.prototype.getInlineModel = function(inlineStr) {
    if (/^Inline Model \d+$/.test(inlineStr)) {
        var id = parseInt(inlineStr.substr(12).trim(), 10); //
        var model = this.inlineModels[id];
        return model;
    }
    // I'm returning null here, should I rather throw an error?
    return null;
};
Operation.prototype.resolveModel = function(schema, definitions) {
    if (typeof schema.$ref !== 'undefined') {
        var ref = schema.$ref;
        if (ref.indexOf('#/definitions/') === 0) ref = ref.substring(14);
        if (definitions[ref]) return new Model(ref, definitions[ref], this.models, this.parent.modelPropertyMacro);
    // schema must at least be an object to get resolved to an inline Model
    } else if (schema && typeof schema === 'object' && (schema.type === 'object' || _.isUndefined(schema.type))) return new Model(undefined, schema, this.models, this.parent.modelPropertyMacro);
    return null;
};
Operation.prototype.help = function(dontPrint) {
    var out = this.nickname + ': ' + this.summary + '\n';
    for(var i = 0; i < this.parameters.length; i++){
        var param = this.parameters[i];
        var typeInfo = param.signature;
        out += '\n  * ' + param.name + ' (' + typeInfo + '): ' + param.description;
    }
    if (typeof dontPrint === 'undefined') helpers.log(out);
    return out;
};
Operation.prototype.getModelSignature = function(type, definitions) {
    var isPrimitive, listType;
    if (type instanceof Array) {
        listType = true;
        type = type[0];
    }
    // Convert undefined to string of 'undefined'
    if (typeof type === 'undefined') {
        type = 'undefined';
        isPrimitive = true;
    } else if (definitions[type]) {
        // a model def exists?
        type = definitions[type]; /* Model */ 
        isPrimitive = false;
    } else if (this.getInlineModel(type)) {
        type = this.getInlineModel(type); /* Model */ 
        isPrimitive = false;
    } else // We default to primitive
    isPrimitive = true;
    if (isPrimitive) {
        if (listType) return 'Array[' + type + ']';
        else return type.toString();
    } else {
        if (listType) return 'Array[' + type.getMockSignature() + ']';
        else return type.getMockSignature();
    }
};
Operation.prototype.supportHeaderParams = function() {
    return true;
};
Operation.prototype.supportedSubmitMethods = function() {
    return this.parent.supportedSubmitMethods;
};
Operation.prototype.getHeaderParams = function(args) {
    var headers = this.setContentTypes(args, {});
    var headerParamsByLowerCase = {};
    for(var i = 0; i < this.parameters.length; i++){
        var param = this.parameters[i];
        if (param.in === 'header') headerParamsByLowerCase[param.name.toLowerCase()] = param;
    }
    for(var arg in args){
        var headerParam = headerParamsByLowerCase[arg.toLowerCase()];
        if (typeof headerParam !== 'undefined') {
            var value = args[arg];
            if (Array.isArray(value)) value = value.toString();
            headers[headerParam.name] = value;
        }
    }
    return headers;
};
Operation.prototype.urlify = function(args) {
    var formParams = {};
    var requestUrl = this.path.replace(/#.*/, ''); // remove URL fragment
    var querystring = ''; // grab params from the args, build the querystring along the way
    for(var i = 0; i < this.parameters.length; i++){
        var param = this.parameters[i];
        if (typeof args[param.name] !== 'undefined') {
            if (param.in === 'path') {
                var reg = new RegExp('\{' + param.name + '\}', 'gi');
                var value = args[param.name];
                if (Array.isArray(value)) value = this.encodePathCollection(param.collectionFormat, param.name, value);
                else value = this.encodePathParam(value);
                requestUrl = requestUrl.replace(reg, value);
            } else if (param.in === 'query' && typeof args[param.name] !== 'undefined') {
                if (querystring === '' && requestUrl.indexOf('?') < 0) querystring += '?';
                else querystring += '&';
                if (typeof param.collectionFormat !== 'undefined') {
                    var qp = args[param.name];
                    if (Array.isArray(qp)) querystring += this.encodeQueryCollection(param.collectionFormat, param.name, qp);
                    else querystring += this.encodeQueryKey(param.name) + '=' + this.encodeQueryParam(args[param.name]);
                } else querystring += this.encodeQueryKey(param.name) + '=' + this.encodeQueryParam(args[param.name]);
            } else if (param.in === 'formData') formParams[param.name] = args[param.name];
        }
    }
    var url = this.scheme + '://' + this.host;
    if (this.basePath !== '/') url += this.basePath;
    return url + requestUrl + querystring;
};
Operation.prototype.getMissingParams = function(args) {
    var missingParams = []; // check required params, track the ones that are missing
    var i;
    for(i = 0; i < this.parameters.length; i++){
        var param = this.parameters[i];
        if (param.required === true) {
            if (typeof args[param.name] === 'undefined') missingParams = param.name;
        }
    }
    return missingParams;
};
Operation.prototype.getBody = function(headers, args, opts) {
    var formParams = {}, hasFormParams, body, key, value, hasBody = false;
    // look at each param and put form params in an object
    for(var i = 0; i < this.parameters.length; i++){
        var param = this.parameters[i];
        if (typeof args[param.name] !== 'undefined') {
            if (param.in === 'body') body = args[param.name];
            else if (param.in === 'formData') {
                formParams[param.name] = {
                    param: param,
                    value: args[param.name]
                };
                hasFormParams = true;
            }
        } else if (param.in === 'body') hasBody = true;
    }
    // if body is null and hasBody is true, AND a JSON body is requested, send empty {}
    if (hasBody && typeof body === 'undefined') {
        var contentType = headers['Content-Type'];
        if (contentType && contentType.indexOf('application/json') === 0) body = '{}';
    }
    var isMultiPart = false;
    if (headers['Content-Type'] && headers['Content-Type'].indexOf('multipart/form-data') >= 0) isMultiPart = true;
    // handle form params
    if (hasFormParams && !isMultiPart) {
        var encoded = '';
        for(key in formParams){
            var param = formParams[key].param;
            value = formParams[key].value;
            if (typeof value !== 'undefined') {
                if (Array.isArray(value)) {
                    if (encoded !== '') encoded += '&';
                    encoded += this.encodeQueryCollection(param.collectionFormat, key, value);
                } else {
                    if (encoded !== '') encoded += '&';
                    encoded += encodeURIComponent(key) + '=' + encodeURIComponent(value);
                }
            }
        }
        body = encoded;
    } else if (isMultiPart) {
        var bodyParam;
        if (typeof FormData === 'function') {
            bodyParam = new FormData();
            bodyParam.type = 'formData';
            for(key in formParams){
                var param = formParams[key].param;
                value = args[key];
                if (typeof value !== 'undefined') {
                    if (({}).toString.apply(value) === '[object File]') bodyParam.append(key, value);
                    else if (value.type === 'file' && value.value) bodyParam.append(key, value.value);
                    else if (Array.isArray(value)) {
                        if (param.collectionFormat === 'multi') {
                            bodyParam.delete(key);
                            for(var v in value)bodyParam.append(key, value[v]);
                        } else bodyParam.append(key, this.encodeQueryCollection(param.collectionFormat, key, value).split('=').slice(1).join('='));
                    } else bodyParam.append(key, value);
                }
            }
            body = bodyParam;
        } else {
            bodyParam = {};
            for(key in formParams){
                value = args[key];
                if (Array.isArray(value)) {
                    var delimeter;
                    var format = param.collectionFormat || 'multi';
                    if (format === 'ssv') delimeter = ' ';
                    else if (format === 'pipes') delimeter = '|';
                    else if (format === 'tsv') delimeter = '\t';
                    else if (format === 'multi') {
                        bodyParam[key] = value;
                        break;
                    } else delimeter = ',';
                    var data;
                    value.forEach(function(v) {
                        if (data) data += delimeter;
                        else data = '';
                        data += v;
                    });
                    bodyParam[key] = data;
                } else bodyParam[key] = value;
            }
            body = bodyParam;
        }
        headers['Content-Type'] = 'multipart/form-data';
    }
    return body;
};
/**
 * gets sample response for a single operation
 **/ Operation.prototype.getModelSampleJSON = function(type, models) {
    var listType, sampleJson, innerType;
    models = models || {};
    listType = type instanceof Array;
    innerType = listType ? type[0] : type;
    if (models[innerType]) sampleJson = models[innerType].createJSONSample();
    else if (this.getInlineModel(innerType)) sampleJson = this.getInlineModel(innerType).createJSONSample(); // may return null, if type isn't correct
    if (sampleJson) {
        sampleJson = listType ? [
            sampleJson
        ] : sampleJson;
        if (typeof sampleJson === 'string') return sampleJson;
        else if (_.isObject(sampleJson)) {
            var t = sampleJson;
            if (sampleJson instanceof Array && sampleJson.length > 0) t = sampleJson[0];
            if (t.nodeName && typeof t === 'Node') {
                var xmlString = new XMLSerializer().serializeToString(t);
                return this.formatXml(xmlString);
            } else return JSON.stringify(sampleJson, null, 2);
        } else return sampleJson;
    }
};
/**
 * legacy binding
 **/ Operation.prototype.do = function(args, opts, callback, error, parent) {
    return this.execute(args, opts, callback, error, parent);
};
/**
 * executes an operation
 **/ Operation.prototype.execute = function(arg1, arg2, arg3, arg4, parent) {
    var args = arg1 || {};
    var opts = {}, success, error, deferred, timeout;
    if (_.isObject(arg2)) {
        opts = arg2;
        success = arg3;
        error = arg4;
    }
    timeout = typeof opts.timeout !== 'undefined' ? opts.timeout : this.timeout;
    if (this.client) opts.client = this.client;
    // add the request interceptor from parent, if none sent from client
    if (!opts.requestInterceptor && this.requestInterceptor) opts.requestInterceptor = this.requestInterceptor;
    if (!opts.responseInterceptor && this.responseInterceptor) opts.responseInterceptor = this.responseInterceptor;
    if (typeof arg2 === 'function') {
        success = arg2;
        error = arg3;
    }
    if (this.parent.usePromise) deferred = Q.defer();
    else {
        success = success || this.parent.defaultSuccessCallback || helpers.log;
        error = error || this.parent.defaultErrorCallback || helpers.log;
    }
    if (typeof opts.useJQuery === 'undefined') opts.useJQuery = this.useJQuery;
    if (typeof opts.jqueryAjaxCache === 'undefined') opts.jqueryAjaxCache = this.jqueryAjaxCache;
    if (typeof opts.enableCookies === 'undefined') opts.enableCookies = this.enableCookies;
    var missingParams = this.getMissingParams(args);
    if (missingParams.length > 0) {
        var message = 'missing required params: ' + missingParams;
        helpers.fail(message);
        if (this.parent.usePromise) {
            deferred.reject(message);
            return deferred.promise;
        } else {
            error(message, parent);
            return {};
        }
    }
    var allHeaders = this.getHeaderParams(args);
    var contentTypeHeaders = this.setContentTypes(args, opts);
    var headers = {}, attrname;
    for(attrname in allHeaders)headers[attrname] = allHeaders[attrname];
    for(attrname in contentTypeHeaders)headers[attrname] = contentTypeHeaders[attrname];
    var body = this.getBody(contentTypeHeaders, args, opts);
    var url = this.urlify(args);
    if (url.indexOf('.{format}') > 0) {
        if (headers) {
            var format = headers.Accept || headers.accept;
            if (format && format.indexOf('json') > 0) url = url.replace('.{format}', '.json');
            else if (format && format.indexOf('xml') > 0) url = url.replace('.{format}', '.xml');
        }
    }
    var obj = {
        url: url,
        method: this.method.toUpperCase(),
        body: body,
        enableCookies: opts.enableCookies,
        useJQuery: opts.useJQuery,
        jqueryAjaxCache: opts.jqueryAjaxCache,
        deferred: deferred,
        headers: headers,
        clientAuthorizations: opts.clientAuthorizations,
        on: {
            response: function(response) {
                if (deferred) {
                    deferred.resolve(response);
                    return deferred.promise;
                } else return success(response, parent);
            },
            error: function(response) {
                if (deferred) {
                    deferred.reject(response);
                    return deferred.promise;
                } else return error(response, parent);
            }
        }
    };
    if (timeout) obj.timeout = timeout;
    this.clientAuthorizations.apply(obj, this.operation.security);
    if (opts.mock === true) return obj;
    else return new SwaggerHttp().execute(obj, opts);
};
function itemByPriority(col, itemPriority) {
    // No priorities? return first...
    if (_.isEmpty(itemPriority)) return col[0];
    for(var i = 0, len = itemPriority.length; i < len; i++){
        if (col.indexOf(itemPriority[i]) > -1) return itemPriority[i];
    }
    // Otherwise return first
    return col[0];
}
Operation.prototype.setContentTypes = function(args, opts) {
    // default type
    var allDefinedParams = this.parameters;
    var body;
    var consumes = args.parameterContentType || itemByPriority(this.consumes, [
        'application/json',
        'application/yaml'
    ]);
    var accepts = opts.responseContentType || itemByPriority(this.produces, [
        'application/json',
        'application/yaml'
    ]);
    var definedFileParams = [];
    var definedFormParams = [];
    var headers = {};
    var i;
    // get params from the operation and set them in definedFileParams, definedFormParams, headers
    for(i = 0; i < allDefinedParams.length; i++){
        var param = allDefinedParams[i];
        if (param.in === 'formData') {
            if (param.type === 'file') definedFileParams.push(param);
            else definedFormParams.push(param);
        } else if (param.in === 'header' && opts) {
            var key = param.name;
            var headerValue = opts[param.name];
            if (typeof opts[param.name] !== 'undefined') headers[key] = headerValue;
        } else if (param.in === 'body' && typeof args[param.name] !== 'undefined') body = args[param.name];
    }
    // if there's a body, need to set the consumes header via requestContentType
    var hasBody = body || definedFileParams.length || definedFormParams.length;
    if (this.method === 'post' || this.method === 'put' || this.method === 'patch' || (this.method === 'delete' || this.method === 'get') && hasBody) {
        if (opts.requestContentType) consumes = opts.requestContentType;
        // if any form params, content type must be set
        if (definedFormParams.length > 0) {
            consumes = undefined;
            if (opts.requestContentType) consumes = opts.requestContentType;
            else if (definedFileParams.length > 0) consumes = 'multipart/form-data';
            else {
                if (this.consumes && this.consumes.length > 0) // use the consumes setting
                for(var c in this.consumes){
                    var chk = this.consumes[c];
                    if (chk.indexOf('application/x-www-form-urlencoded') === 0 || chk.indexOf('multipart/form-data') === 0) consumes = chk;
                }
            }
            if (typeof consumes === 'undefined') // default to x-www-from-urlencoded
            consumes = 'application/x-www-form-urlencoded';
        }
    } else consumes = null;
    if (consumes && this.consumes) {
        if (this.consumes.indexOf(consumes) === -1) helpers.log('server doesn\'t consume ' + consumes + ', try ' + JSON.stringify(this.consumes));
    }
    if (!this.matchesAccept(accepts)) helpers.log('server can\'t produce ' + accepts);
    if (consumes && body !== '' || consumes === 'application/x-www-form-urlencoded') headers['Content-Type'] = consumes;
    else if (this.consumes && this.consumes.length > 0 && this.consumes[0] === 'application/x-www-form-urlencoded') headers['Content-Type'] = this.consumes[0];
    if (accepts) headers.Accept = accepts;
    return headers;
};
/**
 * Returns true if the request accepts header matches anything in this.produces.
 *  If this.produces contains * / *, ignore the accept header.
 * @param {string=} accepts The client request accept header.
 * @return {boolean}
 */ Operation.prototype.matchesAccept = function(accepts) {
    // no accepts or produces, no problem!
    if (!accepts || !this.produces) return true;
    return this.produces.indexOf(accepts) !== -1 || this.produces.indexOf('*/*') !== -1;
};
Operation.prototype.asCurl = function(args1, args2) {
    var opts = {
        mock: true
    };
    if (typeof args2 === 'object') for(var argKey in args2)opts[argKey] = args2[argKey];
    var obj = this.execute(args1, opts);
    this.clientAuthorizations.apply(obj, this.operation.security);
    var results = [];
    results.push('-X ' + this.method.toUpperCase());
    if (typeof obj.headers !== 'undefined') {
        var key;
        for(key in obj.headers){
            var value = obj.headers[key];
            if (typeof value === 'string') value = value.replace(/\'/g, '\\u0027');
            results.push('--header \'' + key + ': ' + value + '\'');
        }
    }
    var isFormData = false;
    var isMultipart = false;
    var type = obj.headers['Content-Type'];
    if (type && type.indexOf('application/x-www-form-urlencoded') === 0) isFormData = true;
    else if (type && type.indexOf('multipart/form-data') === 0) {
        isFormData = true;
        isMultipart = true;
    }
    if (obj.body) {
        var body;
        if (_.isObject(obj.body)) {
            if (isMultipart) {
                isMultipart = true;
                // add the form data
                for(var i = 0; i < this.parameters.length; i++){
                    var parameter = this.parameters[i];
                    if (parameter.in === 'formData') {
                        if (!body) body = '';
                        var paramValue;
                        if (typeof FormData === 'function' && obj.body instanceof FormData) paramValue = obj.body.getAll(parameter.name);
                        else paramValue = obj.body[parameter.name];
                        if (paramValue) {
                            if (parameter.type === 'file') {
                                if (paramValue.name) body += '-F ' + parameter.name + '=@"' + paramValue.name + '" ';
                            } else if (Array.isArray(paramValue)) {
                                if (parameter.collectionFormat === 'multi') for(var v in paramValue)body += '-F ' + this.encodeQueryKey(parameter.name) + '=' + paramValue[v] + ' ';
                                else body += '-F ' + this.encodeQueryCollection(parameter.collectionFormat, parameter.name, paramValue) + ' ';
                            } else body += '-F ' + this.encodeQueryKey(parameter.name) + '=' + paramValue + ' ';
                        }
                    }
                }
            }
            if (!body) body = JSON.stringify(obj.body);
        } else body = obj.body;
        // escape @ => %40, ' => %27
        body = body.replace(/\'/g, '%27').replace(/\n/g, ' \\ \n ');
        if (!isFormData) // escape & => %26
        body = body.replace(/&/g, '%26');
        if (isMultipart) results.push(body);
        else results.push('-d \'' + body.replace(/@/g, '%40') + '\'');
    }
    return 'curl ' + results.join(' ') + ' \'' + obj.url + '\'';
};
Operation.prototype.encodePathCollection = function(type, name, value) {
    var encoded = '';
    var i;
    var separator = '';
    if (type === 'ssv') separator = '%20';
    else if (type === 'tsv') separator = '%09';
    else if (type === 'pipes') separator = '|';
    else separator = ',';
    for(i = 0; i < value.length; i++)if (i === 0) encoded = this.encodeQueryParam(value[i]);
    else encoded += separator + this.encodeQueryParam(value[i]);
    return encoded;
};
Operation.prototype.encodeQueryCollection = function(type, name, value) {
    var encoded = '';
    var i;
    type = type || 'default';
    if (type === 'default' || type === 'multi') for(i = 0; i < value.length; i++){
        if (i > 0) encoded += '&';
        encoded += this.encodeQueryKey(name) + '=' + this.encodeQueryParam(value[i]);
    }
    else {
        var separator = '';
        if (type === 'csv') separator = ',';
        else if (type === 'ssv') separator = '%20';
        else if (type === 'tsv') separator = '%09';
        else if (type === 'pipes') separator = '|';
        else if (type === 'brackets') for(i = 0; i < value.length; i++){
            if (i !== 0) encoded += '&';
            encoded += this.encodeQueryKey(name) + '[]=' + this.encodeQueryParam(value[i]);
        }
        if (separator !== '') {
            for(i = 0; i < value.length; i++)if (i === 0) encoded = this.encodeQueryKey(name) + '=' + this.encodeQueryParam(value[i]);
            else encoded += separator + this.encodeQueryParam(value[i]);
        }
    }
    return encoded;
};
Operation.prototype.encodeQueryKey = function(arg) {
    return encodeURIComponent(arg).replace('%5B', '[').replace('%5D', ']').replace('%24', '$');
};
Operation.prototype.encodeQueryParam = function(arg) {
    return encodeURIComponent(arg);
};
/**
 * TODO revisit, might not want to leave '/'
 **/ Operation.prototype.encodePathParam = function(pathParam) {
    return encodeURIComponent(pathParam);
};

},{"e6ee062a552db893":"lgoPK","3c160ab6f2c55155":"lKXOz","599206838b910ae":"i3zxH","62d71a2aa63c17bd":"kAgGx","f6ba2bdf9a23eefa":"jrGf3","e50ff2760700d845":"kQ1i6","ebb2811b37428550":"lF2n0","c8192dae4392438c":"hoTdJ"}],"lF2n0":[function(require,module,exports,__globalThis) {
var Buffer = require("16a3b2c532e89fe7").Buffer;
'use strict';
var helpers = require("cb94b9f9448e1d7a");
var request = require("7b6b57a5f9b34559");
var jsyaml = require("4c22619ec5f6427c");
var _ = {
    isObject: require("2af639efb3469f6"),
    keys: require("47ca71a5d4207e67")
};
/*
 * JQueryHttpClient is a light-weight, node or browser HTTP client
 */ var JQueryHttpClient = function() {
    this.type = 'JQueryHttpClient';
};
/*
 * SuperagentHttpClient is a light-weight, node or browser HTTP client
 */ var SuperagentHttpClient = function() {
    this.type = 'SuperagentHttpClient';
};
/**
 * SwaggerHttp is a wrapper for executing requests
 */ var SwaggerHttp = module.exports = function() {};
SwaggerHttp.prototype.execute = function(obj, opts) {
    var client;
    if (opts && opts.client) client = opts.client;
    else client = new SuperagentHttpClient(opts);
    client.opts = opts || {};
    // legacy support
    var hasJQuery = false;
    if (typeof window !== 'undefined') {
        if (typeof window.jQuery !== 'undefined') hasJQuery = true;
    }
    // OPTIONS support
    if (obj.method.toLowerCase() === 'options' && client.type === 'SuperagentHttpClient') {
        log('forcing jQuery as OPTIONS are not supported by SuperAgent');
        obj.useJQuery = true;
    }
    if (this.isInternetExplorer() && (obj.useJQuery === false || !hasJQuery)) throw new Error('Unsupported configuration! JQuery is required but not available');
    if (obj && obj.useJQuery === true || this.isInternetExplorer() && hasJQuery) client = new JQueryHttpClient(opts);
    var success = obj.on.response;
    var error = obj.on.error;
    var requestInterceptor = function(data) {
        if (opts && opts.requestInterceptor) data = opts.requestInterceptor.apply(data);
        return data;
    };
    var responseInterceptor = function(data) {
        if (opts && opts.responseInterceptor) data = opts.responseInterceptor.apply(data);
        return success(data);
    };
    var errorInterceptor = function(data) {
        if (opts && opts.responseInterceptor) data = opts.responseInterceptor.apply(data);
        error(data);
    };
    obj.on.error = function(data) {
        errorInterceptor(data);
    };
    obj.on.response = function(data) {
        responseInterceptor(data);
    };
    if (_.isObject(obj) && _.isObject(obj.body)) {
        // special processing for file uploads via jquery
        if (obj.body.type && obj.body.type === 'formData') {
            if (opts.useJQuery) {
                obj.contentType = false;
                obj.processData = false;
                delete obj.headers['Content-Type'];
            }
        }
    }
    obj = requestInterceptor(obj) || obj;
    if (obj.beforeSend) obj.beforeSend(function(_obj) {
        client.execute(_obj || obj);
    });
    else client.execute(obj);
    return obj.deferred ? obj.deferred.promise : obj;
};
SwaggerHttp.prototype.isInternetExplorer = function() {
    var detectedIE = false;
    if (typeof navigator !== 'undefined' && navigator.userAgent) {
        var nav = navigator.userAgent.toLowerCase();
        if (nav.indexOf('msie') !== -1) {
            var version = parseInt(nav.split('msie')[1]);
            if (version <= 8) detectedIE = true;
        }
    }
    return detectedIE;
};
JQueryHttpClient.prototype.execute = function(obj) {
    var jq = this.jQuery || typeof window !== 'undefined' && window.jQuery;
    var cb = obj.on;
    var request = obj;
    if (typeof jq === 'undefined' || jq === false) throw new Error('Unsupported configuration! JQuery is required but not available');
    obj.type = obj.method;
    obj.cache = obj.jqueryAjaxCache;
    obj.data = obj.body;
    delete obj.jqueryAjaxCache;
    delete obj.useJQuery;
    delete obj.body;
    obj.complete = function(response) {
        var headers = {};
        var headerArray = response.getAllResponseHeaders().split('\n');
        for(var i = 0; i < headerArray.length; i++){
            var toSplit = headerArray[i].trim();
            if (toSplit.length === 0) continue;
            var separator = toSplit.indexOf(':');
            if (separator === -1) {
                // Name but no value in the header
                headers[toSplit] = null;
                continue;
            }
            var name = toSplit.substring(0, separator).trim();
            var value = toSplit.substring(separator + 1).trim();
            headers[name] = value;
        }
        var out = {
            url: request.url,
            method: request.method,
            status: response.status,
            statusText: response.statusText,
            data: response.responseText,
            headers: headers
        };
        try {
            var possibleObj = response.responseJSON || jsyaml.safeLoad(response.responseText);
            out.obj = typeof possibleObj === 'string' ? {} : possibleObj;
        } catch (ex) {
            // do not set out.obj
            helpers.log('unable to parse JSON/YAML content');
        }
        // I can throw, or parse null?
        out.obj = out.obj || null;
        if (response.status >= 200 && response.status < 300) cb.response(out);
        else if (response.status === 0 || response.status >= 400 && response.status < 599) cb.error(out);
        else return cb.response(out);
    };
    jq.support.cors = true;
    return jq.ajax(obj);
};
SuperagentHttpClient.prototype.execute = function(obj) {
    var method = obj.method.toLowerCase();
    var timeout = obj.timeout;
    if (method === 'delete') method = 'del';
    var headers = obj.headers || {};
    var r = request[method](obj.url);
    if (timeout) r.timeout(timeout);
    if (obj.enableCookies) r.withCredentials();
    var accept = obj.headers.Accept;
    if (this.binaryRequest(accept)) r.on('request', function() {
        if (this.xhr) this.xhr.responseType = 'blob';
    });
    if (obj.body) {
        if (_.isObject(obj.body)) {
            var contentType = obj.headers['Content-Type'] || '';
            if (contentType.indexOf('multipart/form-data') === 0) {
                delete headers['Content-Type'];
                if (({}).toString.apply(obj.body) === '[object FormData]') {
                    var itr = obj.body.keys();
                    var p = [];
                    while(true){
                        var v = itr.next();
                        if (v.done) break;
                        var key = v.value;
                        // only once
                        if (p.indexOf(key) === -1) {
                            p.push(key);
                            var value = obj.body.getAll(key);
                            if (({}).toString.apply(value) === '[object File]') r.attach(key, value);
                            else {
                                if (Array.isArray(value)) for(var t in value)r.field(key, value[t]);
                                else r.field(key, value);
                            }
                        }
                    }
                } else {
                    var keyname, value, v;
                    for(keyname in obj.body){
                        value = obj.body[keyname];
                        if (Array.isArray(value)) for(v in value)r.field(keyname, v);
                        else r.field(keyname, value);
                    }
                }
            } else if (_.isObject(obj.body)) {
                obj.body = JSON.stringify(obj.body);
                r.send(obj.body);
            }
        } else r.send(obj.body);
    }
    var name;
    for(name in headers)r.set(name, headers[name]);
    if (typeof r.buffer === 'function') r.buffer(); // force superagent to populate res.text with the raw response data
    r.end(function(err, res) {
        res = res || {
            status: 0,
            headers: {
                error: 'no response from server'
            }
        };
        var response = {
            url: obj.url,
            method: obj.method,
            headers: res.headers
        };
        var cb;
        if (!err && res.error) err = res.error;
        if (err && obj.on && obj.on.error) {
            response.errObj = err;
            response.status = res ? res.status : 500;
            response.statusText = res ? res.text : err.message;
            if (res.headers && res.headers['content-type']) {
                if (res.headers['content-type'].indexOf('application/json') >= 0) try {
                    response.obj = JSON.parse(response.statusText);
                } catch (e) {
                    response.obj = null;
                }
            }
            cb = obj.on.error;
        } else if (res && obj.on && obj.on.response) {
            var possibleObj;
            // Already parsed by by superagent?
            if (res.body && _.keys(res.body).length > 0) possibleObj = res.body;
            else try {
                possibleObj = jsyaml.safeLoad(res.text);
                // can parse into a string... which we don't need running around in the system
                possibleObj = typeof possibleObj === 'string' ? null : possibleObj;
            } catch (e) {
                helpers.log('cannot parse JSON/YAML content');
            }
            // null means we can't parse into object
            if (typeof Buffer === 'function' && Buffer.isBuffer(possibleObj)) response.data = possibleObj;
            else response.obj = typeof possibleObj === 'object' ? possibleObj : null;
            response.status = res.status;
            response.statusText = res.text;
            cb = obj.on.response;
        }
        if (res.xhr && res.xhr.response) response.data = res.xhr.response;
        else if (!response.data) response.data = response.statusText;
        if (cb) cb(response);
    });
};
SuperagentHttpClient.prototype.binaryRequest = function(accept) {
    if (!accept) return false;
    return /^image/i.test(accept) || /^application\/pdf/.test(accept);
};

},{"16a3b2c532e89fe7":"cjdyz","cb94b9f9448e1d7a":"jrGf3","7b6b57a5f9b34559":"asAQj","4c22619ec5f6427c":"63vik","2af639efb3469f6":"kAgGx","47ca71a5d4207e67":"1wIxZ"}],"asAQj":[function(require,module,exports,__globalThis) {
/**
 * Root reference for iframes.
 */ var root;
if (typeof window !== 'undefined') root = window;
else if (typeof self !== 'undefined') root = self;
else {
    console.warn("Using browser-only version of superagent in non-browser environment");
    root = this;
}
var Emitter = require("d7d238d83606fd12");
var requestBase = require("85321e33f16d545");
var isObject = require("2cf43b18776cbca8");
/**
 * Noop.
 */ function noop() {}
/**
 * Expose `request`.
 */ var request = module.exports = require("fabf6fe1da616200").bind(null, Request);
/**
 * Determine XHR.
 */ request.getXHR = function() {
    if (root.XMLHttpRequest && (!root.location || 'file:' != root.location.protocol || !root.ActiveXObject)) return new XMLHttpRequest;
    else {
        try {
            return new ActiveXObject('Microsoft.XMLHTTP');
        } catch (e) {}
        try {
            return new ActiveXObject('Msxml2.XMLHTTP.6.0');
        } catch (e) {}
        try {
            return new ActiveXObject('Msxml2.XMLHTTP.3.0');
        } catch (e) {}
        try {
            return new ActiveXObject('Msxml2.XMLHTTP');
        } catch (e) {}
    }
    throw Error("Browser-only verison of superagent could not find XHR");
};
/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */ var trim = ''.trim ? function(s) {
    return s.trim();
} : function(s) {
    return s.replace(/(^\s*|\s*$)/g, '');
};
/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */ function serialize(obj) {
    if (!isObject(obj)) return obj;
    var pairs = [];
    for(var key in obj)pushEncodedKeyValuePair(pairs, key, obj[key]);
    return pairs.join('&');
}
/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */ function pushEncodedKeyValuePair(pairs, key, val) {
    if (val != null) {
        if (Array.isArray(val)) val.forEach(function(v) {
            pushEncodedKeyValuePair(pairs, key, v);
        });
        else if (isObject(val)) for(var subkey in val)pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
        else pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(val));
    } else if (val === null) pairs.push(encodeURIComponent(key));
}
/**
 * Expose serialization method.
 */ request.serializeObject = serialize;
/**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */ function parseString(str) {
    var obj = {};
    var pairs = str.split('&');
    var pair;
    var pos;
    for(var i = 0, len = pairs.length; i < len; ++i){
        pair = pairs[i];
        pos = pair.indexOf('=');
        if (pos == -1) obj[decodeURIComponent(pair)] = '';
        else obj[decodeURIComponent(pair.slice(0, pos))] = decodeURIComponent(pair.slice(pos + 1));
    }
    return obj;
}
/**
 * Expose parser.
 */ request.parseString = parseString;
/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */ request.types = {
    html: 'text/html',
    json: 'application/json',
    xml: 'application/xml',
    urlencoded: 'application/x-www-form-urlencoded',
    'form': 'application/x-www-form-urlencoded',
    'form-data': 'application/x-www-form-urlencoded'
};
/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */ request.serialize = {
    'application/x-www-form-urlencoded': serialize,
    'application/json': JSON.stringify
};
/**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */ request.parse = {
    'application/x-www-form-urlencoded': parseString,
    'application/json': JSON.parse
};
/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */ function parseHeader(str) {
    var lines = str.split(/\r?\n/);
    var fields = {};
    var index;
    var line;
    var field;
    var val;
    lines.pop(); // trailing CRLF
    for(var i = 0, len = lines.length; i < len; ++i){
        line = lines[i];
        index = line.indexOf(':');
        field = line.slice(0, index).toLowerCase();
        val = trim(line.slice(index + 1));
        fields[field] = val;
    }
    return fields;
}
/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */ function isJSON(mime) {
    return /[\/+]json\b/.test(mime);
}
/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function type(str) {
    return str.split(/ *; */).shift();
}
/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */ function params(str) {
    return str.split(/ *; */).reduce(function(obj, str) {
        var parts = str.split(/ *= */), key = parts.shift(), val = parts.shift();
        if (key && val) obj[key] = val;
        return obj;
    }, {});
}
/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */ function Response(req, options) {
    options = options || {};
    this.req = req;
    this.xhr = this.req.xhr;
    // responseText is accessible only if responseType is '' or 'text' and on older browsers
    this.text = this.req.method != 'HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text') || typeof this.xhr.responseType === 'undefined' ? this.xhr.responseText : null;
    this.statusText = this.req.xhr.statusText;
    this._setStatusProperties(this.xhr.status);
    this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
    // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
    // getResponseHeader still works. so we get content-type even if getting
    // other headers fails.
    this.header['content-type'] = this.xhr.getResponseHeader('content-type');
    this._setHeaderProperties(this.header);
    this.body = this.req.method != 'HEAD' ? this._parseBody(this.text ? this.text : this.xhr.response) : null;
}
/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */ Response.prototype.get = function(field) {
    return this.header[field.toLowerCase()];
};
/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */ Response.prototype._setHeaderProperties = function(header) {
    // content-type
    var ct = this.header['content-type'] || '';
    this.type = type(ct);
    // params
    var obj = params(ct);
    for(var key in obj)this[key] = obj[key];
};
/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */ Response.prototype._parseBody = function(str) {
    var parse = request.parse[this.type];
    if (!parse && isJSON(this.type)) parse = request.parse['application/json'];
    return parse && str && (str.length || str instanceof Object) ? parse(str) : null;
};
/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */ Response.prototype._setStatusProperties = function(status) {
    // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
    if (status === 1223) status = 204;
    var type = status / 100 | 0;
    // status / class
    this.status = this.statusCode = status;
    this.statusType = type;
    // basics
    this.info = 1 == type;
    this.ok = 2 == type;
    this.clientError = 4 == type;
    this.serverError = 5 == type;
    this.error = 4 == type || 5 == type ? this.toError() : false;
    // sugar
    this.accepted = 202 == status;
    this.noContent = 204 == status;
    this.badRequest = 400 == status;
    this.unauthorized = 401 == status;
    this.notAcceptable = 406 == status;
    this.notFound = 404 == status;
    this.forbidden = 403 == status;
};
/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */ Response.prototype.toError = function() {
    var req = this.req;
    var method = req.method;
    var url = req.url;
    var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
    var err = new Error(msg);
    err.status = this.status;
    err.method = method;
    err.url = url;
    return err;
};
/**
 * Expose `Response`.
 */ request.Response = Response;
/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */ function Request(method, url) {
    var self1 = this;
    this._query = this._query || [];
    this.method = method;
    this.url = url;
    this.header = {}; // preserves header name case
    this._header = {}; // coerces header names to lowercase
    this.on('end', function() {
        var err = null;
        var res = null;
        try {
            res = new Response(self1);
        } catch (e) {
            err = new Error('Parser is unable to parse the response');
            err.parse = true;
            err.original = e;
            // issue #675: return the raw response if the response parsing fails
            err.rawResponse = self1.xhr && self1.xhr.responseText ? self1.xhr.responseText : null;
            // issue #876: return the http status code if the response parsing fails
            err.statusCode = self1.xhr && self1.xhr.status ? self1.xhr.status : null;
            return self1.callback(err);
        }
        self1.emit('response', res);
        var new_err;
        try {
            if (res.status < 200 || res.status >= 300) {
                new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
                new_err.original = err;
                new_err.response = res;
                new_err.status = res.status;
            }
        } catch (e) {
            new_err = e; // #985 touching res may cause INVALID_STATE_ERR on old Android
        }
        // #1000 don't catch errors from the callback to avoid double calling it
        if (new_err) self1.callback(new_err, res);
        else self1.callback(null, res);
    });
}
/**
 * Mixin `Emitter` and `requestBase`.
 */ Emitter(Request.prototype);
for(var key in requestBase)Request.prototype[key] = requestBase[key];
/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.type = function(type) {
    this.set('Content-Type', request.types[type] || type);
    return this;
};
/**
 * Set responseType to `val`. Presently valid responseTypes are 'blob' and
 * 'arraybuffer'.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.responseType = function(val) {
    this._responseType = val;
    return this;
};
/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.accept = function(type) {
    this.set('Accept', request.types[type] || type);
    return this;
};
/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} pass
 * @param {Object} options with 'type' property 'auto' or 'basic' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.auth = function(user, pass, options) {
    if (!options) options = {
        type: 'basic'
    };
    switch(options.type){
        case 'basic':
            var str = btoa(user + ':' + pass);
            this.set('Authorization', 'Basic ' + str);
            break;
        case 'auto':
            this.username = user;
            this.password = pass;
            break;
    }
    return this;
};
/**
* Add query-string `val`.
*
* Examples:
*
*   request.get('/shoes')
*     .query('size=10')
*     .query({ color: 'blue' })
*
* @param {Object|String} val
* @return {Request} for chaining
* @api public
*/ Request.prototype.query = function(val) {
    if ('string' != typeof val) val = serialize(val);
    if (val) this._query.push(val);
    return this;
};
/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `filename`.
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String} filename
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.attach = function(field, file, filename) {
    this._getFormData().append(field, file, filename || file.name);
    return this;
};
Request.prototype._getFormData = function() {
    if (!this._formData) this._formData = new root.FormData();
    return this._formData;
};
/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */ Request.prototype.callback = function(err, res) {
    var fn = this._callback;
    this.clearTimeout();
    fn(err, res);
};
/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */ Request.prototype.crossDomainError = function() {
    var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
    err.crossDomain = true;
    err.status = this.status;
    err.method = this.method;
    err.url = this.url;
    this.callback(err);
};
/**
 * Invoke callback with timeout error.
 *
 * @api private
 */ Request.prototype._timeoutError = function() {
    var timeout = this._timeout;
    var err = new Error('timeout of ' + timeout + 'ms exceeded');
    err.timeout = timeout;
    this.callback(err);
};
/**
 * Compose querystring to append to req.url
 *
 * @api private
 */ Request.prototype._appendQueryString = function() {
    var query = this._query.join('&');
    if (query) this.url += ~this.url.indexOf('?') ? '&' + query : '?' + query;
};
/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.end = function(fn) {
    var self1 = this;
    var xhr = this.xhr = request.getXHR();
    var timeout = this._timeout;
    var data = this._formData || this._data;
    // store callback
    this._callback = fn || noop;
    // state change
    xhr.onreadystatechange = function() {
        if (4 != xhr.readyState) return;
        // In IE9, reads to any property (e.g. status) off of an aborted XHR will
        // result in the error "Could not complete the operation due to error c00c023f"
        var status;
        try {
            status = xhr.status;
        } catch (e) {
            status = 0;
        }
        if (0 == status) {
            if (self1.timedout) return self1._timeoutError();
            if (self1._aborted) return;
            return self1.crossDomainError();
        }
        self1.emit('end');
    };
    // progress
    var handleProgress = function(direction, e) {
        if (e.total > 0) e.percent = e.loaded / e.total * 100;
        e.direction = direction;
        self1.emit('progress', e);
    };
    if (this.hasListeners('progress')) try {
        xhr.onprogress = handleProgress.bind(null, 'download');
        if (xhr.upload) xhr.upload.onprogress = handleProgress.bind(null, 'upload');
    } catch (e) {
    // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
    // Reported here:
    // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
    // timeout
    if (timeout && !this._timer) this._timer = setTimeout(function() {
        self1.timedout = true;
        self1.abort();
    }, timeout);
    // querystring
    this._appendQueryString();
    // initiate request
    if (this.username && this.password) xhr.open(this.method, this.url, true, this.username, this.password);
    else xhr.open(this.method, this.url, true);
    // CORS
    if (this._withCredentials) xhr.withCredentials = true;
    // body
    if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
        // serialize stuff
        var contentType = this._header['content-type'];
        var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
        if (!serialize && isJSON(contentType)) serialize = request.serialize['application/json'];
        if (serialize) data = serialize(data);
    }
    // set header fields
    for(var field in this.header){
        if (null == this.header[field]) continue;
        xhr.setRequestHeader(field, this.header[field]);
    }
    if (this._responseType) xhr.responseType = this._responseType;
    // send stuff
    this.emit('request', this);
    // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
    // We need null here if data is undefined
    xhr.send(typeof data !== 'undefined' ? data : null);
    return this;
};
/**
 * Expose `Request`.
 */ request.Request = Request;
/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.get = function(url, data, fn) {
    var req = request('GET', url);
    if ('function' == typeof data) fn = data, data = null;
    if (data) req.query(data);
    if (fn) req.end(fn);
    return req;
};
/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.head = function(url, data, fn) {
    var req = request('HEAD', url);
    if ('function' == typeof data) fn = data, data = null;
    if (data) req.send(data);
    if (fn) req.end(fn);
    return req;
};
/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.options = function(url, data, fn) {
    var req = request('OPTIONS', url);
    if ('function' == typeof data) fn = data, data = null;
    if (data) req.send(data);
    if (fn) req.end(fn);
    return req;
};
/**
 * DELETE `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ function del(url, fn) {
    var req = request('DELETE', url);
    if (fn) req.end(fn);
    return req;
}
request['del'] = del;
request['delete'] = del;
/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.patch = function(url, data, fn) {
    var req = request('PATCH', url);
    if ('function' == typeof data) fn = data, data = null;
    if (data) req.send(data);
    if (fn) req.end(fn);
    return req;
};
/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.post = function(url, data, fn) {
    var req = request('POST', url);
    if ('function' == typeof data) fn = data, data = null;
    if (data) req.send(data);
    if (fn) req.end(fn);
    return req;
};
/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.put = function(url, data, fn) {
    var req = request('PUT', url);
    if ('function' == typeof data) fn = data, data = null;
    if (data) req.send(data);
    if (fn) req.end(fn);
    return req;
};

},{"d7d238d83606fd12":"eG34O","85321e33f16d545":"iHmNv","2cf43b18776cbca8":"bKqdy","fabf6fe1da616200":"9btjg"}],"eG34O":[function(require,module,exports,__globalThis) {
/**
 * Expose `Emitter`.
 */ module.exports = Emitter;
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function Emitter(obj) {
    if (obj) return mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function mixin(obj) {
    for(var key in Emitter.prototype)obj[key] = Emitter.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ Emitter.prototype.on = Emitter.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ Emitter.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ Emitter.prototype.off = Emitter.prototype.removeListener = Emitter.prototype.removeAllListeners = Emitter.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks['$' + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks['$' + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ Emitter.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks['$' + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ Emitter.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ Emitter.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};

},{}],"iHmNv":[function(require,module,exports,__globalThis) {
/**
 * Module of mixed-in functions shared between node and client code
 */ var isObject = require("6ea197851d7fb620");
/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */ exports.clearTimeout = function _clearTimeout() {
    this._timeout = 0;
    clearTimeout(this._timer);
    return this;
};
/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */ exports.parse = function parse(fn) {
    this._parser = fn;
    return this;
};
/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */ exports.serialize = function serialize(fn) {
    this._serializer = fn;
    return this;
};
/**
 * Set timeout to `ms`.
 *
 * @param {Number} ms
 * @return {Request} for chaining
 * @api public
 */ exports.timeout = function timeout(ms) {
    this._timeout = ms;
    return this;
};
/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} reject
 * @return {Request}
 */ exports.then = function then(resolve, reject) {
    if (!this._fullfilledPromise) {
        var self = this;
        this._fullfilledPromise = new Promise(function(innerResolve, innerReject) {
            self.end(function(err, res) {
                if (err) innerReject(err);
                else innerResolve(res);
            });
        });
    }
    return this._fullfilledPromise.then(resolve, reject);
};
exports.catch = function(cb) {
    return this.then(undefined, cb);
};
/**
 * Allow for extension
 */ exports.use = function use(fn) {
    fn(this);
    return this;
};
/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */ exports.get = function(field) {
    return this._header[field.toLowerCase()];
};
/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */ exports.getHeader = exports.get;
/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */ exports.set = function(field, val) {
    if (isObject(field)) {
        for(var key in field)this.set(key, field[key]);
        return this;
    }
    this._header[field.toLowerCase()] = val;
    this.header[field] = val;
    return this;
};
/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 */ exports.unset = function(field) {
    delete this._header[field.toLowerCase()];
    delete this.header[field];
    return this;
};
/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name
 * @param {String|Blob|File|Buffer|fs.ReadStream} val
 * @return {Request} for chaining
 * @api public
 */ exports.field = function(name, val) {
    // name should be either a string or an object.
    if (null === name || undefined === name) throw new Error('.field(name, val) name can not be empty');
    if (isObject(name)) {
        for(var key in name)this.field(key, name[key]);
        return this;
    }
    // val should be defined now
    if (null === val || undefined === val) throw new Error('.field(name, val) val can not be empty');
    this._getFormData().append(name, val);
    return this;
};
/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */ exports.abort = function() {
    if (this._aborted) return this;
    this._aborted = true;
    this.xhr && this.xhr.abort(); // browser
    this.req && this.req.abort(); // node
    this.clearTimeout();
    this.emit('abort');
    return this;
};
/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */ exports.withCredentials = function() {
    // This is browser-only functionality. Node side is no-op.
    this._withCredentials = true;
    return this;
};
/**
 * Set the max redirects to `n`. Does noting in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */ exports.redirects = function(n) {
    this._maxRedirects = n;
    return this;
};
/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */ exports.toJSON = function() {
    return {
        method: this.method,
        url: this.url,
        data: this._data,
        headers: this._header
    };
};
/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * TODO: future proof, move to compoent land
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */ exports._isHost = function _isHost(obj) {
    var str = ({}).toString.call(obj);
    switch(str){
        case '[object File]':
        case '[object Blob]':
        case '[object FormData]':
            return true;
        default:
            return false;
    }
};
/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */ exports.send = function(data) {
    var obj = isObject(data);
    var type = this._header['content-type'];
    // merge
    if (obj && isObject(this._data)) for(var key in data)this._data[key] = data[key];
    else if ('string' == typeof data) {
        // default to x-www-form-urlencoded
        if (!type) this.type('form');
        type = this._header['content-type'];
        if ('application/x-www-form-urlencoded' == type) this._data = this._data ? this._data + '&' + data : data;
        else this._data = (this._data || '') + data;
    } else this._data = data;
    if (!obj || this._isHost(data)) return this;
    // default to json
    if (!type) this.type('json');
    return this;
};

},{"6ea197851d7fb620":"bKqdy"}],"bKqdy":[function(require,module,exports,__globalThis) {
/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */ function isObject(obj) {
    return null !== obj && 'object' === typeof obj;
}
module.exports = isObject;

},{}],"9btjg":[function(require,module,exports,__globalThis) {
// The node and browser modules expose versions of this with the
// appropriate constructor function bound as first argument
/**
 * Issue a request:
 *
 * Examples:
 *
 *    request('GET', '/users').end(callback)
 *    request('/users').end(callback)
 *    request('/users', callback)
 *
 * @param {String} method
 * @param {String|Function} url or callback
 * @return {Request}
 * @api public
 */ function request(RequestConstructor, method, url) {
    // callback
    if ('function' == typeof url) return new RequestConstructor('GET', method).end(url);
    // url first
    if (2 == arguments.length) return new RequestConstructor('GET', method);
    return new RequestConstructor(method, url);
}
module.exports = request;

},{}],"ijKzP":[function(require,module,exports,__globalThis) {
'use strict';
var OperationGroup = module.exports = function(tag, description, externalDocs, operation) {
    this.description = description;
    this.externalDocs = externalDocs;
    this.name = tag;
    this.operation = operation;
    this.operationsArray = [];
    this.path = tag;
    this.tag = tag;
};
OperationGroup.prototype.sort = function() {};

},{}],"lp813":[function(require,module,exports,__globalThis) {
'use strict';
var SwaggerHttp = require("2b584128bc6096f0");
var _ = {
    isObject: require("d72f3fba01be27f1"),
    cloneDeep: require("6122221af1ba0369"),
    isArray: require("7f0357aaadfd90a0"),
    isString: require("c4e426d6d36aa197")
};
/**
 * Resolves a spec's remote references
 */ var Resolver = module.exports = function() {
    this.failedUrls = [];
    this.resolverCache = {};
    this.pendingUrls = {};
};
Resolver.prototype.processAllOf = function(root, name, definition, resolutionTable, unresolvedRefs, spec) {
    var i, location, property;
    definition['x-resolved-from'] = [
        '#/definitions/' + name
    ];
    var allOf = definition.allOf;
    // the refs go first
    allOf.sort(function(a, b) {
        if (a.$ref && b.$ref) return 0;
        else if (a.$ref) return -1;
        else return 1;
    });
    for(i = 0; i < allOf.length; i++){
        property = allOf[i];
        location = '/definitions/' + name + '/allOf';
        this.resolveInline(root, spec, property, resolutionTable, unresolvedRefs, location);
    }
};
Resolver.prototype.resolve = function(spec, arg1, arg2, arg3) {
    this.spec = spec;
    var root = arg1, callback = arg2, scope = arg3, opts = {}, location, i;
    if (typeof arg1 === 'function') {
        root = null;
        callback = arg1;
        scope = arg2;
    }
    var _root = root;
    this.scope = scope || this;
    this.iteration = this.iteration || 0;
    if (this.scope.options && this.scope.options.requestInterceptor) opts.requestInterceptor = this.scope.options.requestInterceptor;
    if (this.scope.options && this.scope.options.responseInterceptor) opts.responseInterceptor = this.scope.options.responseInterceptor;
    var name, path, property, propertyName;
    var processedCalls = 0, resolvedRefs = {}, unresolvedRefs = {};
    var resolutionTable = []; // store objects for dereferencing
    spec.definitions = spec.definitions || {};
    // definitions
    for(name in spec.definitions){
        var definition = spec.definitions[name];
        if (definition['$ref']) this.resolveInline(root, spec, definition, resolutionTable, unresolvedRefs, definition);
        else {
            for(propertyName in definition.properties){
                property = definition.properties[propertyName];
                if (_.isArray(property.allOf)) this.processAllOf(root, name, property, resolutionTable, unresolvedRefs, spec);
                else this.resolveTo(root, property, resolutionTable, '/definitions');
            }
            if (definition.allOf) this.processAllOf(root, name, definition, resolutionTable, unresolvedRefs, spec);
        }
    }
    // shared parameters
    spec.parameters = spec.parameters || {};
    for(name in spec.parameters){
        var parameter = spec.parameters[name];
        if (parameter.in === 'body' && parameter.schema) {
            if (_.isArray(parameter.schema.allOf)) {
                // move to a definition
                var modelName = 'inline_model';
                var name = modelName;
                var done = false;
                var counter = 0;
                while(!done){
                    if (typeof spec.definitions[name] === 'undefined') {
                        done = true;
                        break;
                    }
                    name = modelName + '_' + counter;
                    counter++;
                }
                spec.definitions[name] = {
                    allOf: parameter.schema.allOf
                };
                delete parameter.schema.allOf;
                parameter.schema.$ref = '#/definitions/' + name;
                this.processAllOf(root, name, spec.definitions[name], resolutionTable, unresolvedRefs, spec);
            } else this.resolveTo(root, parameter.schema, resolutionTable, location);
        }
        if (parameter.$ref) // parameter reference
        this.resolveInline(root, spec, parameter, resolutionTable, unresolvedRefs, parameter.$ref);
    }
    // operations
    for(name in spec.paths){
        var method, operation, responseCode;
        path = spec.paths[name];
        for(method in path)// operation reference
        if (method === '$ref') {
            // location = path[method];
            location = '/paths' + name;
            this.resolveInline(root, spec, path, resolutionTable, unresolvedRefs, location);
        } else {
            operation = path[method];
            var sharedParameters = path.parameters || [];
            var parameters = operation.parameters || [];
            for(i in sharedParameters){
                var parameter = sharedParameters[i];
                parameters.unshift(parameter);
            }
            if (method !== 'parameters' && _.isObject(operation)) operation.parameters = operation.parameters || parameters;
            for(i in parameters){
                var parameter = parameters[i];
                location = '/paths' + name + '/' + method + '/parameters';
                if (parameter.in === 'body' && parameter.schema) {
                    if (_.isArray(parameter.schema.allOf)) {
                        // move to a definition
                        var modelName = 'inline_model';
                        var name = modelName;
                        var done = false;
                        var counter = 0;
                        while(!done){
                            if (typeof spec.definitions[name] === 'undefined') {
                                done = true;
                                break;
                            }
                            name = modelName + '_' + counter;
                            counter++;
                        }
                        spec.definitions[name] = {
                            allOf: parameter.schema.allOf
                        };
                        delete parameter.schema.allOf;
                        parameter.schema.$ref = '#/definitions/' + name;
                        this.processAllOf(root, name, spec.definitions[name], resolutionTable, unresolvedRefs, spec);
                    } else this.resolveTo(root, parameter.schema, resolutionTable, location);
                }
                if (parameter.$ref) // parameter reference
                this.resolveInline(root, spec, parameter, resolutionTable, unresolvedRefs, parameter.$ref);
            }
            for(responseCode in operation.responses){
                var response = operation.responses[responseCode];
                location = '/paths' + name + '/' + method + '/responses/' + responseCode;
                if (_.isObject(response)) {
                    if (response.$ref) // response reference
                    this.resolveInline(root, spec, response, resolutionTable, unresolvedRefs, location);
                    if (response.schema) {
                        var responseObj = response;
                        if (_.isArray(responseObj.schema.allOf)) {
                            // move to a definition
                            var modelName = 'inline_model';
                            var name = modelName;
                            var done = false;
                            var counter = 0;
                            while(!done){
                                if (typeof spec.definitions[name] === 'undefined') {
                                    done = true;
                                    break;
                                }
                                name = modelName + '_' + counter;
                                counter++;
                            }
                            spec.definitions[name] = {
                                allOf: responseObj.schema.allOf
                            };
                            delete responseObj.schema.allOf;
                            delete responseObj.schema.type;
                            responseObj.schema.$ref = '#/definitions/' + name;
                            this.processAllOf(root, name, spec.definitions[name], resolutionTable, unresolvedRefs, spec);
                        } else if ('array' === responseObj.schema.type) {
                            if (responseObj.schema.items && responseObj.schema.items.$ref) // response reference
                            this.resolveInline(root, spec, responseObj.schema.items, resolutionTable, unresolvedRefs, location);
                        } else this.resolveTo(root, response.schema, resolutionTable, location);
                    }
                }
            }
        }
        // clear them out to avoid multiple resolutions
        path.parameters = [];
    }
    var expectedCalls = 0, toResolve = [];
    // if the root is same as obj[i].root we can resolve locally
    var all = resolutionTable;
    var parts;
    for(i = 0; i < all.length; i++){
        var a = all[i];
        if (root === a.root) {
            if (a.resolveAs === 'ref') {
                // resolve any path walking
                var joined = ((a.root || '') + '/' + a.key).split('/');
                var normalized = [];
                var url = '';
                var k;
                if (a.key.indexOf('../') >= 0) {
                    for(var j = 0; j < joined.length; j++)if (joined[j] === '..') normalized = normalized.slice(0, normalized.length - 1);
                    else normalized.push(joined[j]);
                    for(k = 0; k < normalized.length; k++){
                        if (k > 0) url += '/';
                        url += normalized[k];
                    }
                    // we now have to remote resolve this because the path has changed
                    a.root = url;
                    toResolve.push(a);
                } else {
                    parts = a.key.split('#');
                    if (parts.length === 2) {
                        if (parts[0].indexOf('http:') === 0 || parts[0].indexOf('https:') === 0) a.root = parts[0];
                        location = parts[1].split('/');
                        var r;
                        var s = spec;
                        for(k = 0; k < location.length; k++){
                            var part = location[k];
                            if (part !== '') {
                                s = s[part];
                                if (typeof s !== 'undefined') r = s;
                                else {
                                    r = null;
                                    break;
                                }
                            }
                        }
                        if (r === null) // must resolve this too
                        toResolve.push(a);
                    }
                }
            } else if (a.resolveAs === 'inline') {
                if (a.key && a.key.indexOf('#') === -1 && a.key.charAt(0) !== '/') {
                    // handle relative schema
                    parts = a.root.split('/');
                    location = '';
                    for(i = 0; i < parts.length - 1; i++)location += parts[i] + '/';
                    location += a.key;
                    a.root = location;
                    a.location = '';
                }
                toResolve.push(a);
            }
        } else toResolve.push(a);
    }
    expectedCalls = toResolve.length;
    // resolve anything that is local
    var lock = {};
    for(var ii = 0; ii < toResolve.length; ii++)(function(item, spec, self, lock, ii) {
        if (!item.root || item.root === root) {
            // local resolve
            self.resolveItem(spec, _root, resolutionTable, resolvedRefs, unresolvedRefs, item);
            processedCalls += 1;
            if (processedCalls === expectedCalls) self.finish(spec, root, resolutionTable, resolvedRefs, unresolvedRefs, callback, true);
        } else if (self.failedUrls.indexOf(item.root) === -1) {
            var obj = {
                useJQuery: false,
                url: item.root,
                method: 'get',
                headers: {
                    accept: self.scope.swaggerRequestHeaders || 'application/json'
                },
                on: {
                    error: function(error) {
                        processedCalls += 1;
                        console.log('failed url: ' + obj.url);
                        self.failedUrls.push(obj.url);
                        if (lock) delete lock[item.root];
                        unresolvedRefs[item.key] = {
                            root: item.root,
                            location: item.location
                        };
                        if (processedCalls === expectedCalls) self.finish(spec, _root, resolutionTable, resolvedRefs, unresolvedRefs, callback);
                    },
                    response: function(response) {
                        var swagger = response.obj;
                        if (lock) delete lock[item.root];
                        if (self.resolverCache) self.resolverCache[item.root] = swagger;
                        self.resolveItem(swagger, item.root, resolutionTable, resolvedRefs, unresolvedRefs, item);
                        processedCalls += 1;
                        if (processedCalls === expectedCalls) self.finish(spec, _root, resolutionTable, resolvedRefs, unresolvedRefs, callback);
                    }
                } // jshint ignore:line
            };
            // apply timeout only when specified
            if (scope && scope.fetchSpecTimeout) obj.timeout = scope.fetchSpecTimeout;
            if (scope && scope.clientAuthorizations) scope.clientAuthorizations.apply(obj);
            (function waitForUnlock() {
                setTimeout(function() {
                    if (lock[obj.url]) waitForUnlock();
                    else {
                        var cached = self.resolverCache[obj.url];
                        if (_.isObject(cached)) obj.on.response({
                            obj: cached
                        });
                        else {
                            lock[obj.url] = true;
                            new SwaggerHttp().execute(obj, opts);
                        }
                    }
                }, 0);
            })();
        } else {
            processedCalls += 1;
            unresolvedRefs[item.key] = {
                root: item.root,
                location: item.location
            };
            if (processedCalls === expectedCalls) self.finish(spec, _root, resolutionTable, resolvedRefs, unresolvedRefs, callback);
        }
    })(toResolve[ii], spec, this, lock, ii);
    if (Object.keys(toResolve).length === 0) this.finish(spec, _root, resolutionTable, resolvedRefs, unresolvedRefs, callback);
};
Resolver.prototype.resolveItem = function(spec, root, resolutionTable, resolvedRefs, unresolvedRefs, item) {
    var path = item.location;
    var location = spec, parts = path.split('/');
    if (path !== '') for(var j = 0; j < parts.length; j++){
        var segment = parts[j];
        if (segment.indexOf('~1') !== -1) {
            segment = parts[j].replace(/~0/g, '~').replace(/~1/g, '/');
            if (segment.charAt(0) !== '/') segment = '/' + segment;
        }
        if (typeof location === 'undefined' || location === null) break;
        if (segment === '' && j === parts.length - 1 && parts.length > 1) {
            location = null;
            break;
        }
        if (segment.length > 0) location = location[segment];
    }
    var resolved = item.key;
    parts = item.key.split('/');
    var resolvedName = parts[parts.length - 1];
    if (resolvedName.indexOf('#') >= 0) resolvedName = resolvedName.split('#')[1];
    if (location !== null && typeof location !== 'undefined') resolvedRefs[resolved] = {
        name: resolvedName,
        obj: location,
        key: item.key,
        root: item.root
    };
    else unresolvedRefs[resolved] = {
        root: item.root,
        location: item.location
    };
};
Resolver.prototype.finish = function(spec, root, resolutionTable, resolvedRefs, unresolvedRefs, callback, localResolve) {
    // walk resolution table and replace with resolved refs
    var ref;
    for(ref in resolutionTable){
        var item = resolutionTable[ref];
        var key = item.key;
        var resolvedTo = resolvedRefs[key];
        if (resolvedTo) {
            spec.definitions = spec.definitions || {};
            if (item.resolveAs === 'ref') {
                if (localResolve !== true) // don't retain root for local definitions
                for(key in resolvedTo.obj){
                    var abs = this.retainRoot(key, resolvedTo.obj[key], item.root);
                    resolvedTo.obj[key] = abs;
                }
                spec.definitions[resolvedTo.name] = resolvedTo.obj;
                item.obj.$ref = '#/definitions/' + resolvedTo.name;
            } else if (item.resolveAs === 'inline') {
                var targetObj = item.obj;
                targetObj['x-resolved-from'] = [
                    item.key
                ];
                delete targetObj.$ref;
                for(key in resolvedTo.obj){
                    var abs = resolvedTo.obj[key];
                    if (localResolve !== true) // don't retain root for local definitions
                    abs = this.retainRoot(key, resolvedTo.obj[key], item.root);
                    targetObj[key] = abs;
                }
            }
        }
    }
    var existingUnresolved = this.countUnresolvedRefs(spec);
    if (existingUnresolved === 0 || this.iteration > 5) {
        this.resolveAllOf(spec.definitions);
        this.resolverCache = null;
        callback.call(this.scope, spec, unresolvedRefs);
    } else {
        this.iteration += 1;
        this.resolve(spec, root, callback, this.scope);
    }
};
Resolver.prototype.countUnresolvedRefs = function(spec) {
    var i;
    var refs = this.getRefs(spec);
    var keys = [];
    var unresolvedKeys = [];
    for(i in refs)if (i.indexOf('#') === 0) keys.push(i.substring(1));
    else unresolvedKeys.push(i);
    // verify possible keys
    for(i = 0; i < keys.length; i++){
        var part = keys[i];
        var parts = part.split('/');
        var obj = spec;
        for(var k = 0; k < parts.length; k++){
            var key = parts[k];
            if (key !== '') {
                obj = obj[key];
                if (typeof obj === 'undefined') {
                    unresolvedKeys.push(part);
                    break;
                }
            }
        }
    }
    return unresolvedKeys.length;
};
Resolver.prototype.getRefs = function(spec, obj) {
    obj = obj || spec;
    var output = {};
    for(var key in obj){
        if (!obj.hasOwnProperty(key)) continue;
        var item = obj[key];
        if (key === '$ref' && typeof item === 'string') output[item] = null;
        else if (_.isObject(item)) {
            var o = this.getRefs(item);
            for(var k in o)output[k] = null;
        }
    }
    return output;
};
function splitUrl(url) {
    var result = {};
    var proto = /[a-z]+:\/\//i.exec(url);
    if (proto) {
        result.proto = proto[0].slice(0, -3);
        url = url.slice(result.proto.length + 1);
    }
    if (url.slice(0, 2) === '//') {
        result.domain = url.slice(2).split('/')[0];
        url = url.slice(2 + result.domain.length);
    }
    var p = url.split('#');
    if (p[0].length) result.path = p[0];
    if (p.length > 1) result.fragment = p.slice(1).join('#');
    return result;
}
function unsplitUrl(url) {
    var result = url.path;
    if (result === undefined) result = '';
    if (url.fragment !== undefined) result += '#' + url.fragment;
    if (url.domain !== undefined) {
        if (result.slice(0, 1) === '/') result = result.slice(1);
        result = '//' + url.domain + '/' + result;
        if (url.proto !== undefined) result = url.proto + ':' + result;
    }
    return result;
}
function joinUrl(base, rel) {
    var relsp = splitUrl(rel);
    if (relsp.domain !== undefined) return rel;
    var result = splitUrl(base);
    if (relsp.path === undefined) // change only fragment part
    result.fragment = relsp.fragment;
    else if (relsp.path.slice(0, 1) === '/') {
        // relative to domain
        result.path = relsp.path;
        result.fragment = relsp.fragment;
    } else {
        // relative to path
        var path = result.path === undefined ? [] : result.path.split('/');
        var relpath = relsp.path.split('/');
        if (path.length) path.pop();
        while(relpath[0] === '..' || relpath[0] === '.'){
            if (relpath[0] === '..') path.pop();
            relpath.shift();
        }
        result.path = path.concat(relpath).join('/');
        result.fragment = relsp.fragment;
    }
    return unsplitUrl(result);
}
Resolver.prototype.retainRoot = function(origKey, obj, root) {
    // walk object and look for relative $refs
    if (_.isObject(obj)) for(var key in obj){
        var item = obj[key];
        if (key === '$ref' && typeof item === 'string') obj[key] = joinUrl(root, item);
        else if (_.isObject(item)) this.retainRoot(key, item, root);
    }
    else if (_.isString(obj) && origKey === '$ref') obj = joinUrl(root, obj);
    return obj;
};
/**
 * immediately in-lines local refs, queues remote refs
 * for inline resolution
 */ Resolver.prototype.resolveInline = function(root, spec, property, resolutionTable, unresolvedRefs, location) {
    var key = property.$ref, ref = property.$ref, i, p, p2, rs;
    var rootTrimmed = false;
    root = root || '' // Guard against .split. @fehguy, you'll need to check if this logic fits
    ;
    // More imporantly is how do we gracefully handle relative urls, when provided just a 'spec', not a 'url' ?
    if (ref) {
        if (ref.indexOf('../') === 0) {
            // reset root
            p = ref.split('../');
            p2 = root.split('/');
            ref = '';
            for(i = 0; i < p.length; i++)if (p[i] === '') p2 = p2.slice(0, p2.length - 1);
            else ref += p[i];
            root = '';
            for(i = 0; i < p2.length - 1; i++){
                if (i > 0) root += '/';
                root += p2[i];
            }
            rootTrimmed = true;
        }
        if (ref.indexOf('#') >= 0) {
            if (ref.indexOf('/') === 0) {
                rs = ref.split('#');
                p = root.split('//');
                p2 = p[1].split('/');
                root = p[0] + '//' + p2[0] + rs[0];
                location = rs[1];
            } else {
                rs = ref.split('#');
                if (rs[0] !== '') {
                    p2 = root.split('/');
                    p2 = p2.slice(0, p2.length - 1);
                    if (!rootTrimmed) {
                        root = '';
                        for(var k = 0; k < p2.length; k++){
                            if (k > 0) root += '/';
                            root += p2[k];
                        }
                    }
                    root += '/' + ref.split('#')[0];
                }
                location = rs[1];
            }
        }
        if (ref.indexOf('http:') === 0 || ref.indexOf('https:') === 0) {
            if (ref.indexOf('#') >= 0) {
                root = ref.split('#')[0];
                location = ref.split('#')[1];
            } else {
                root = ref;
                location = '';
            }
            resolutionTable.push({
                obj: property,
                resolveAs: 'inline',
                root: root,
                key: key,
                location: location
            });
        } else if (ref.indexOf('#') === 0) {
            location = ref.split('#')[1];
            resolutionTable.push({
                obj: property,
                resolveAs: 'inline',
                root: root,
                key: key,
                location: location
            });
        } else if (ref.indexOf('/') === 0 && ref.indexOf('#') === -1) {
            location = ref;
            var matches = root.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i);
            if (matches) {
                root = matches[0] + ref.substring(1);
                location = '';
            }
            resolutionTable.push({
                obj: property,
                resolveAs: 'inline',
                root: root,
                key: key,
                location: location
            });
        } else resolutionTable.push({
            obj: property,
            resolveAs: 'inline',
            root: root,
            key: key,
            location: location
        });
    } else if (property.type === 'array') this.resolveTo(root, property.items, resolutionTable, location);
};
Resolver.prototype.resolveTo = function(root, property, resolutionTable, location) {
    var sp, i;
    var ref = property.$ref;
    var lroot = root;
    if (typeof ref !== 'undefined' && ref !== null) {
        if (ref.indexOf('#') >= 0) {
            var parts = ref.split('#');
            // #/definitions/foo
            // foo.json#/bar
            if (parts[0] && ref.indexOf('/') === 0) ;
            else if (parts[0] && (parts[0].indexOf('http:') === 0 || parts[0].indexOf('https:') === 0)) {
                lroot = parts[0];
                ref = parts[1];
            } else if (parts[0] && parts[0].length > 0) {
                // relative file
                sp = root.split('/');
                lroot = '';
                for(i = 0; i < sp.length - 1; i++)lroot += sp[i] + '/';
                lroot += parts[0];
            }
            location = parts[1];
        } else if (ref.indexOf('http:') === 0 || ref.indexOf('https:') === 0) {
            lroot = ref;
            location = '';
        } else {
            // relative file
            sp = root.split('/');
            lroot = '';
            for(i = 0; i < sp.length - 1; i++)lroot += sp[i] + '/';
            lroot += ref;
            location = '';
        }
        resolutionTable.push({
            obj: property,
            resolveAs: 'ref',
            root: lroot,
            key: ref,
            location: location
        });
    } else if (property.type === 'array') {
        var items = property.items;
        this.resolveTo(root, items, resolutionTable, location);
    } else if (property && (property.properties || property.additionalProperties)) {
        var name = this.uniqueName('inline_model');
        if (property.title) name = this.uniqueName(property.title);
        delete property.title;
        this.spec.definitions[name] = _.cloneDeep(property);
        property['$ref'] = '#/definitions/' + name;
        delete property.type;
        delete property.properties;
    }
};
Resolver.prototype.uniqueName = function(base) {
    var name = base;
    var count = 0;
    while(true){
        if (!_.isObject(this.spec.definitions[name])) return name;
        name = base + '_' + count;
        count++;
    }
};
Resolver.prototype.resolveAllOf = function(spec, obj, depth) {
    depth = depth || 0;
    obj = obj || spec;
    var name;
    for(var key in obj){
        if (!obj.hasOwnProperty(key)) continue;
        var item = obj[key];
        if (item === null) throw new TypeError('Swagger 2.0 does not support null types (' + obj + ').  See https://github.com/swagger-api/swagger-spec/issues/229.');
        if (typeof item === 'object') this.resolveAllOf(spec, item, depth + 1);
        if (item && typeof item.allOf !== 'undefined') {
            var allOf = item.allOf;
            if (_.isArray(allOf)) {
                var output = _.cloneDeep(item);
                delete output.allOf;
                output['x-composed'] = true;
                if (typeof item['x-resolved-from'] !== 'undefined') output['x-resolved-from'] = item['x-resolved-from'];
                for(var i = 0; i < allOf.length; i++){
                    var component = allOf[i];
                    var source = 'self';
                    if (typeof component['x-resolved-from'] !== 'undefined') source = component['x-resolved-from'][0];
                    for(var part in component)if (!output.hasOwnProperty(part)) {
                        output[part] = _.cloneDeep(component[part]);
                        if (part === 'properties') for(name in output[part])output[part][name]['x-resolved-from'] = source;
                    } else {
                        if (part === 'properties') {
                            var properties = component[part];
                            for(name in properties){
                                output.properties[name] = _.cloneDeep(properties[name]);
                                var resolvedFrom = properties[name]['x-resolved-from'];
                                if (typeof resolvedFrom === 'undefined' || resolvedFrom === 'self') resolvedFrom = source;
                                output.properties[name]['x-resolved-from'] = resolvedFrom;
                            }
                        } else if (part === 'required') {
                            // merge & dedup the required array
                            var a = output.required.concat(component[part]);
                            for(var k = 0; k < a.length; ++k){
                                for(var j = k + 1; j < a.length; ++j)if (a[k] === a[j]) a.splice(j--, 1);
                            }
                            output.required = a;
                        } else if (part === 'x-resolved-from') output['x-resolved-from'].push(source);
                    }
                }
                obj[key] = output;
            }
        }
    }
};

},{"2b584128bc6096f0":"lF2n0","d72f3fba01be27f1":"kAgGx","6122221af1ba0369":"lgoPK","7f0357aaadfd90a0":"fOaCr","c4e426d6d36aa197":"ewvLp"}],"daNwX":[function(require,module,exports,__globalThis) {
'use strict';
var SwaggerHttp = require("fad08307b047b297");
var _ = {
    isObject: require("452aae97882a843a")
};
var SwaggerSpecConverter = module.exports = function() {
    this.errors = [];
    this.warnings = [];
    this.modelMap = {};
};
SwaggerSpecConverter.prototype.setDocumentationLocation = function(location) {
    this.docLocation = location;
};
/**
 * converts a resource listing OR api declaration
 **/ SwaggerSpecConverter.prototype.convert = function(obj, clientAuthorizations, opts, callback) {
    // not a valid spec
    if (!obj || !Array.isArray(obj.apis)) return this.finish(callback, null);
    this.clientAuthorizations = clientAuthorizations;
    // create a new swagger object to return
    var swagger = {
        swagger: '2.0'
    };
    swagger.originalVersion = obj.swaggerVersion;
    // add the info
    this.apiInfo(obj, swagger);
    // add security definitions
    this.securityDefinitions(obj, swagger);
    // take basePath into account
    if (obj.basePath) this.setDocumentationLocation(obj.basePath);
    // see if this is a single-file swagger definition
    var isSingleFileSwagger = false;
    var i;
    for(i = 0; i < obj.apis.length; i++){
        var api = obj.apis[i];
        if (Array.isArray(api.operations)) isSingleFileSwagger = true;
    }
    if (isSingleFileSwagger) {
        this.declaration(obj, swagger);
        this.finish(callback, swagger);
    } else this.resourceListing(obj, swagger, opts, callback);
};
SwaggerSpecConverter.prototype.declaration = function(obj, swagger) {
    var name, i, p, pos;
    if (!obj.apis) return;
    if (obj.basePath.indexOf('http://') === 0) {
        p = obj.basePath.substring(7);
        pos = p.indexOf('/');
        if (pos > 0) {
            swagger.host = p.substring(0, pos);
            swagger.basePath = p.substring(pos);
        } else {
            swagger.host = p;
            swagger.basePath = '/';
        }
    } else if (obj.basePath.indexOf('https://') === 0) {
        p = obj.basePath.substring(8);
        pos = p.indexOf('/');
        if (pos > 0) {
            swagger.host = p.substring(0, pos);
            swagger.basePath = p.substring(pos);
        } else {
            swagger.host = p;
            swagger.basePath = '/';
        }
    } else swagger.basePath = obj.basePath;
    var resourceLevelAuth;
    if (obj.authorizations) resourceLevelAuth = obj.authorizations;
    if (obj.consumes) swagger.consumes = obj.consumes;
    if (obj.produces) swagger.produces = obj.produces;
    // build a mapping of id to name for 1.0 model resolutions
    if (_.isObject(obj)) for(name in obj.models){
        var existingModel = obj.models[name];
        var key = existingModel.id || name;
        this.modelMap[key] = name;
    }
    for(i = 0; i < obj.apis.length; i++){
        var api = obj.apis[i];
        var path = api.path;
        var operations = api.operations;
        this.operations(path, obj.resourcePath, operations, resourceLevelAuth, swagger);
    }
    var models = obj.models || {};
    this.models(models, swagger);
};
SwaggerSpecConverter.prototype.models = function(obj, swagger) {
    if (!_.isObject(obj)) return;
    var name;
    swagger.definitions = swagger.definitions || {};
    for(name in obj){
        var existingModel = obj[name];
        var _required = [];
        var schema = {
            properties: {}
        };
        var propertyName;
        for(propertyName in existingModel.properties){
            var existingProperty = existingModel.properties[propertyName];
            var property = {};
            this.dataType(existingProperty, property);
            if (existingProperty.description) property.description = existingProperty.description;
            if (existingProperty['enum']) property['enum'] = existingProperty['enum'];
            if (typeof existingProperty.required === 'boolean' && existingProperty.required === true) _required.push(propertyName);
            if (typeof existingProperty.required === 'string' && existingProperty.required === 'true') _required.push(propertyName);
            schema.properties[propertyName] = property;
        }
        if (_required.length > 0) schema.required = _required;
        else schema.required = existingModel.required;
        swagger.definitions[name] = schema;
    }
};
SwaggerSpecConverter.prototype.extractTag = function(resourcePath) {
    var pathString = resourcePath || 'default';
    if (pathString.indexOf('http:') === 0 || pathString.indexOf('https:') === 0) {
        pathString = pathString.split([
            '/'
        ]);
        pathString = pathString[pathString.length - 1].substring();
    }
    if (pathString.endsWith('.json')) pathString = pathString.substring(0, pathString.length - 5);
    return pathString.replace('/', '');
};
SwaggerSpecConverter.prototype.operations = function(path, resourcePath, obj, resourceLevelAuth, swagger) {
    if (!Array.isArray(obj)) return;
    var i;
    if (!swagger.paths) swagger.paths = {};
    var pathObj = swagger.paths[path] || {};
    var tag = this.extractTag(resourcePath);
    swagger.tags = swagger.tags || [];
    var matched = false;
    for(i = 0; i < swagger.tags.length; i++){
        var tagObject = swagger.tags[i];
        if (tagObject.name === tag) matched = true;
    }
    if (!matched) swagger.tags.push({
        name: tag
    });
    for(i = 0; i < obj.length; i++){
        var existingOperation = obj[i];
        var method = (existingOperation.method || existingOperation.httpMethod).toLowerCase();
        var operation = {
            tags: [
                tag
            ]
        };
        var existingAuthorizations = existingOperation.authorizations;
        if (existingAuthorizations && Object.keys(existingAuthorizations).length === 0) existingAuthorizations = resourceLevelAuth;
        if (typeof existingAuthorizations !== 'undefined') {
            var scopesObject;
            for(var key in existingAuthorizations){
                operation.security = operation.security || [];
                var scopes = existingAuthorizations[key];
                if (scopes) {
                    var securityScopes = [];
                    for(var j in scopes)securityScopes.push(scopes[j].scope);
                    scopesObject = {};
                    scopesObject[key] = securityScopes;
                    operation.security.push(scopesObject);
                } else {
                    scopesObject = {};
                    scopesObject[key] = [];
                    operation.security.push(scopesObject);
                }
            }
        }
        if (existingOperation.consumes) operation.consumes = existingOperation.consumes;
        else if (swagger.consumes) operation.consumes = swagger.consumes;
        if (existingOperation.produces) operation.produces = existingOperation.produces;
        else if (swagger.produces) operation.produces = swagger.produces;
        if (existingOperation.summary) operation.summary = existingOperation.summary;
        if (existingOperation.notes) operation.description = existingOperation.notes;
        if (existingOperation.nickname) operation.operationId = existingOperation.nickname;
        if (existingOperation.deprecated) operation.deprecated = existingOperation.deprecated;
        this.authorizations(existingAuthorizations, swagger);
        this.parameters(operation, existingOperation.parameters, swagger);
        this.responseMessages(operation, existingOperation, swagger);
        pathObj[method] = operation;
    }
    swagger.paths[path] = pathObj;
};
SwaggerSpecConverter.prototype.responseMessages = function(operation, existingOperation) {
    if (!_.isObject(existingOperation)) return;
    // build default response from the operation (1.x)
    var defaultResponse = {};
    this.dataType(existingOperation, defaultResponse);
    // TODO: look into the real problem of rendering responses in swagger-ui
    // ....should reponseType have an implicit schema?
    if (!defaultResponse.schema && defaultResponse.type) defaultResponse = {
        schema: defaultResponse
    };
    operation.responses = operation.responses || {};
    // grab from responseMessages (1.2)
    var has200 = false;
    if (Array.isArray(existingOperation.responseMessages)) {
        var i;
        var existingResponses = existingOperation.responseMessages;
        for(i = 0; i < existingResponses.length; i++){
            var existingResponse = existingResponses[i];
            var response = {
                description: existingResponse.message
            };
            if (existingResponse.code === 200) has200 = true;
            // Convert responseModel -> schema{$ref: responseModel}
            if (existingResponse.responseModel) response.schema = {
                '$ref': '#/definitions/' + existingResponse.responseModel
            };
            operation.responses['' + existingResponse.code] = response;
        }
    }
    if (has200) operation.responses['default'] = defaultResponse;
    else operation.responses['200'] = defaultResponse;
};
SwaggerSpecConverter.prototype.authorizations = function(obj) {
    // TODO
    if (!_.isObject(obj)) return;
};
SwaggerSpecConverter.prototype.parameters = function(operation, obj) {
    if (!Array.isArray(obj)) return;
    var i;
    for(i = 0; i < obj.length; i++){
        var existingParameter = obj[i];
        var parameter = {};
        parameter.name = existingParameter.name;
        parameter.description = existingParameter.description;
        parameter.required = existingParameter.required;
        parameter.in = existingParameter.paramType;
        // per #168
        if (parameter.in === 'body') parameter.name = 'body';
        if (parameter.in === 'form') parameter.in = 'formData';
        if (existingParameter.enum) parameter.enum = existingParameter.enum;
        if (existingParameter.allowMultiple === true || existingParameter.allowMultiple === 'true') {
            var innerType = {};
            this.dataType(existingParameter, innerType);
            parameter.type = 'array';
            parameter.items = innerType;
            if (existingParameter.allowableValues) {
                var av = existingParameter.allowableValues;
                if (av.valueType === 'LIST') parameter['enum'] = av.values;
            }
        } else this.dataType(existingParameter, parameter);
        if (typeof existingParameter.defaultValue !== 'undefined') parameter.default = existingParameter.defaultValue;
        operation.parameters = operation.parameters || [];
        operation.parameters.push(parameter);
    }
};
SwaggerSpecConverter.prototype.dataType = function(source, target) {
    if (!_.isObject(source)) return;
    if (source.minimum) target.minimum = source.minimum;
    if (source.maximum) target.maximum = source.maximum;
    if (source.format) target.format = source.format;
    // default can be 'false'
    if (typeof source.defaultValue !== 'undefined') target.default = source.defaultValue;
    var jsonSchemaType = this.toJsonSchema(source);
    if (jsonSchemaType) {
        target = target || {};
        if (jsonSchemaType.type) target.type = jsonSchemaType.type;
        if (jsonSchemaType.format) target.format = jsonSchemaType.format;
        if (jsonSchemaType.$ref) target.schema = {
            $ref: jsonSchemaType.$ref
        };
        if (jsonSchemaType.items) target.items = jsonSchemaType.items;
    }
};
SwaggerSpecConverter.prototype.toJsonSchema = function(source) {
    if (!source) return 'object';
    var detectedType = source.type || source.dataType || source.responseClass || '';
    var lcType = detectedType.toLowerCase();
    var format = (source.format || '').toLowerCase();
    if (lcType.indexOf('list[') === 0) {
        var innerType = detectedType.substring(5, detectedType.length - 1);
        var jsonType = this.toJsonSchema({
            type: innerType
        });
        return {
            type: 'array',
            items: jsonType
        };
    } else if (lcType === 'int' || lcType === 'integer' && format === 'int32') return {
        type: 'integer',
        format: 'int32'
    };
    else if (lcType === 'long' || lcType === 'integer' && format === 'int64') return {
        type: 'integer',
        format: 'int64'
    };
    else if (lcType === 'integer') return {
        type: 'integer',
        format: 'int64'
    };
    else if (lcType === 'float' || lcType === 'number' && format === 'float') return {
        type: 'number',
        format: 'float'
    };
    else if (lcType === 'double' || lcType === 'number' && format === 'double') return {
        type: 'number',
        format: 'double'
    };
    else if (lcType === 'string' && format === 'date-time' || lcType === 'date') return {
        type: 'string',
        format: 'date-time'
    };
    else if (lcType === 'string') return {
        type: 'string'
    };
    else if (lcType === 'file') return {
        type: 'file'
    };
    else if (lcType === 'boolean') return {
        type: 'boolean'
    };
    else if (lcType === 'boolean') return {
        type: 'boolean'
    };
    else if (lcType === 'array' || lcType === 'list') {
        if (source.items) {
            var it = this.toJsonSchema(source.items);
            return {
                type: 'array',
                items: it
            };
        } else return {
            type: 'array',
            items: {
                type: 'object'
            }
        };
    } else if (source.$ref) return {
        $ref: this.modelMap[source.$ref] ? '#/definitions/' + this.modelMap[source.$ref] : source.$ref
    };
    else if (lcType === 'void' || lcType === '') return {};
    else if (this.modelMap[source.type]) // If this a model using `type` instead of `$ref`, that's fine.
    return {
        $ref: '#/definitions/' + this.modelMap[source.type]
    };
    else // Unknown model type or 'object', pass it along.
    return {
        type: source.type
    };
};
SwaggerSpecConverter.prototype.resourceListing = function(obj, swagger, opts, callback) {
    var i;
    var processedCount = 0; // jshint ignore:line
    var self = this; // jshint ignore:line
    var expectedCount = obj.apis.length;
    var _swagger = swagger; // jshint ignore:line
    var _opts = {};
    if (opts && opts.requestInterceptor) _opts.requestInterceptor = opts.requestInterceptor;
    if (opts && opts.responseInterceptor) _opts.responseInterceptor = opts.responseInterceptor;
    var swaggerRequestHeaders = 'application/json';
    if (opts && opts.swaggerRequestHeaders) swaggerRequestHeaders = opts.swaggerRequestHeaders;
    if (expectedCount === 0) this.finish(callback, swagger);
    for(i = 0; i < expectedCount; i++){
        var api = obj.apis[i];
        var path = api.path;
        var absolutePath = this.getAbsolutePath(obj.swaggerVersion, this.docLocation, path);
        if (api.description) {
            swagger.tags = swagger.tags || [];
            swagger.tags.push({
                name: this.extractTag(api.path),
                description: api.description || ''
            });
        }
        var http = {
            url: absolutePath,
            headers: {
                accept: swaggerRequestHeaders
            },
            on: {},
            method: 'get',
            timeout: opts.timeout
        };
        /* jshint ignore:start */ http.on.response = function(data) {
            processedCount += 1;
            var obj = data.obj;
            if (obj) self.declaration(obj, _swagger);
            if (processedCount === expectedCount) self.finish(callback, _swagger);
        };
        http.on.error = function(data) {
            console.error(data);
            processedCount += 1;
            if (processedCount === expectedCount) self.finish(callback, _swagger);
        };
        /* jshint ignore:end */ if (this.clientAuthorizations && typeof this.clientAuthorizations.apply === 'function') this.clientAuthorizations.apply(http);
        new SwaggerHttp().execute(http, _opts);
    }
};
SwaggerSpecConverter.prototype.getAbsolutePath = function(version, docLocation, path) {
    if (version === '1.0') {
        if (docLocation.endsWith('.json')) {
            // get root path
            var pos = docLocation.lastIndexOf('/');
            if (pos > 0) docLocation = docLocation.substring(0, pos);
        }
    }
    var location = docLocation;
    if (path.indexOf('http:') === 0 || path.indexOf('https:') === 0) location = path;
    else {
        if (docLocation.endsWith('/')) location = docLocation.substring(0, docLocation.length - 1);
        location += path;
    }
    location = location.replace('{format}', 'json');
    return location;
};
SwaggerSpecConverter.prototype.securityDefinitions = function(obj, swagger) {
    if (obj.authorizations) {
        var name;
        for(name in obj.authorizations){
            var isValid = false;
            var securityDefinition = {};
            var definition = obj.authorizations[name];
            if (definition.type === 'apiKey') {
                securityDefinition.type = 'apiKey';
                securityDefinition.in = definition.passAs;
                securityDefinition.name = definition.keyname || name;
                isValid = true;
            } else if (definition.type === 'basicAuth') {
                securityDefinition.type = 'basicAuth';
                isValid = true;
            } else if (definition.type === 'oauth2') {
                var existingScopes = definition.scopes || [];
                var scopes = {};
                var i;
                for(i in existingScopes){
                    var scope = existingScopes[i];
                    scopes[scope.scope] = scope.description;
                }
                securityDefinition.type = 'oauth2';
                if (i > 0) securityDefinition.scopes = scopes;
                if (definition.grantTypes) {
                    if (definition.grantTypes.implicit) {
                        var implicit = definition.grantTypes.implicit;
                        securityDefinition.flow = 'implicit';
                        securityDefinition.authorizationUrl = implicit.loginEndpoint;
                        isValid = true;
                    }
                    /* jshint ignore:start */ if (definition.grantTypes['authorization_code']) {
                        if (!securityDefinition.flow) {
                            // cannot set if flow is already defined
                            var authCode = definition.grantTypes['authorization_code'];
                            securityDefinition.flow = 'accessCode';
                            securityDefinition.authorizationUrl = authCode.tokenRequestEndpoint.url;
                            securityDefinition.tokenUrl = authCode.tokenEndpoint.url;
                            isValid = true;
                        }
                    }
                /* jshint ignore:end */ }
            }
            if (isValid) {
                swagger.securityDefinitions = swagger.securityDefinitions || {};
                swagger.securityDefinitions[name] = securityDefinition;
            }
        }
    }
};
SwaggerSpecConverter.prototype.apiInfo = function(obj, swagger) {
    // info section
    if (obj.info) {
        var info = obj.info;
        swagger.info = {};
        if (info.contact) {
            swagger.info.contact = {};
            swagger.info.contact.email = info.contact;
        }
        if (info.description) swagger.info.description = info.description;
        if (info.title) swagger.info.title = info.title;
        if (info.termsOfServiceUrl) swagger.info.termsOfService = info.termsOfServiceUrl;
        if (info.license || info.licenseUrl) {
            swagger.license = {};
            if (info.license) swagger.license.name = info.license;
            if (info.licenseUrl) swagger.license.url = info.licenseUrl;
        }
    } else this.warnings.push('missing info section');
};
SwaggerSpecConverter.prototype.finish = function(callback, obj) {
    callback(obj);
};

},{"fad08307b047b297":"lF2n0","452aae97882a843a":"kAgGx"}],"hU2Ab":[function(require,module,exports,__globalThis) {
"use strict";
function swaggerResponseValidatorPromiseFactory(modelName) {
    if (!modelName) throw new Error("No modelName supplied");
    return function swaggerResponseValidatorPromise(response) {
        var client, data, validation;
        if (!response || !response.obj) throw new Error("Bad Response");
        client = response.client;
        data = response.obj;
        if (client && client.validateModel) {
            validation = client.validateModel(modelName, data);
            response.validation = validation;
        }
        return response;
    };
}
module.exports = swaggerResponseValidatorPromiseFactory;

},{}],"ec6U8":[function(require,module,exports,__globalThis) {
'use strict';
var _ = require("56b3974c1cdc4572");
var grameneSwaggerClient = require("a5aeb40b0f1261a3");
var validate = require("a997c470ccc444c1");
function makeCall(gramene, queryString) {
    var params = {
        q: queryString ? queryString + '*' : '*'
    };
    return gramene['Search'].suggestions(params).then(function(res) {
        res.client = gramene;
        return res;
    });
}
function reformatResponse(response) {
    var query, category, categories;
    query = _.get(response, 'obj.responseHeader.params.q');
    // remove the trailing '*'
    if (query && query.length) query = query.slice(0, -1);
    category = _.get(response, 'obj.grouped.category');
    categories = _.get(response, 'obj.grouped.category.groups');
    if (categories) // the following line is a safer equivalent of
    // `return response.obj.grouped.category.groups.map(function(category) {`
    categories = categories.map(function reformatSuggestionCategory(category) {
        var doclist = category.doclist;
        if (!category.doclist) {
            console.error('No doclist for category ', category);
            return;
        }
        return {
            label: category.groupValue,
            suggestions: doclist.docs,
            max_score: doclist.maxScore,
            num_found: doclist.numFound
        };
    });
    return {
        metadata: {
            query: query,
            count: category.matches,
            url: response.url,
            validation: response.validation
        },
        categories: categories
    };
}
function promise(queryString) {
    return grameneSwaggerClient.then(function(client) {
        return makeCall(client, queryString);
    }).then(validate("SolrSuggestResponse")).then(reformatResponse);
}
module.exports = {
    makeCall: makeCall,
    reformatResponse: reformatResponse,
    promise: promise
};

},{"56b3974c1cdc4572":"4lC24","a5aeb40b0f1261a3":"dS5bn","a997c470ccc444c1":"hU2Ab"}],"uPk8m":[function(require,module,exports,__globalThis) {
'use strict';
var _ = require("36d2990f14ea0b0a");
var validate = require("bfd424f7cc9bb017");
var grameneSwaggerClient = require("9339de5c8622fd10");
// hard code these here so that we can guarantee module.export functions are
// available immediately.
var collections = {
    genes: "MongoGenesResponse",
    genetrees: "MongoGenetreesResponse",
    maps: "MongoMapsResponse",
    domains: "InterProResponse",
    taxonomy: "TaxonomyResponse",
    GO: "OntologyResponse",
    PO: "OntologyResponse",
    pathways: "ReactomeEntityResponse"
};
module.exports = _.mapValues(collections, callPromiseFactory);
function callPromiseFactory(schemaName, methodName) {
    function getCallFunction(gramene) {
        return gramene['Data access'][methodName];
    }
    function getSchemaName(gramene) {
        const $ref = _.get(gramene, [
            'Data access',
            'apis',
            methodName,
            'type',
            'schema',
            '$ref'
        ]);
        if ($ref && $ref.indexOf('#/definitions/') === 0) return $ref.substring(14);
    }
    function checkSchemaAgainst(gramene) {
        var scheamNameFromAPI = getSchemaName(gramene);
        if (scheamNameFromAPI !== schemaName) throw new Error("Schema name mismatch. Expected " + schemaName + ", got " + scheamNameFromAPI);
    }
    function makeCall(gramene, query) {
        var ids, params, apiMethodToInvoke;
        checkSchemaAgainst(gramene);
        ids = getIdListString(query);
        params = {
            idList: ids
        };
        apiMethodToInvoke = getCallFunction(gramene);
        return apiMethodToInvoke(params).then(function addApiToResponseAndResolvePromise(res) {
            res.client = gramene;
            return res;
        });
    }
    return function promise(queryString) {
        return grameneSwaggerClient.then(function makeCallFactory(client) {
            return makeCall(client, queryString);
        }).then(validate(schemaName)).then(reformatResponse);
    };
}
function getIdListString(query) {
    if (_.isString(query)) return query;
    if (_.isArray(query)) return query.join(',');
    throw new Error('Query should be a string or an array. We were provided ' + typeof query);
}
function reformatResponse(response) {
    var results = response.obj;
    return {
        metadata: {
            url: response.url,
            count: results.length,
            validation: response.validation
        },
        docs: results
    };
}

},{"36d2990f14ea0b0a":"4lC24","bfd424f7cc9bb017":"hU2Ab","9339de5c8622fd10":"dS5bn"}],"fx7Q6":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"default\":{\"query\":{\"q\":\"\",\"filters\":{},\"resultTypes\":{\"taxon_id\":{\"facet.field\":\"{!facet.limit='50' facet.mincount='0' key='taxon_id'}taxon_id\"}},\"cachedResultTypes\":{}},\"response\":{\"validation\":{\"valid\":true},\"obj\":{\"responseHeader\":{\"status\":0,\"QTime\":0,\"params\":{\"facet\":\"true\",\"q\":\"*\",\"wt\":\"json\",\"rows\":\"0\"}},\"response\":{\"numFound\":1666975,\"start\":0,\"docs\":[]},\"facet_counts\":{\"facet_queries\":{},\"facet_fields\":{},\"facet_dates\":{},\"facet_ranges\":{},\"facet_intervals\":{},\"facet_heatmaps\":{}}}}},\"faceted\":{\"query\":{\"q\":\"\",\"filters\":{\"_terms:(PAD4)\":{}},\"resultTypes\":{\"taxon_id\":{\"facet.field\":\"{!facet.limit='50' facet.mincount='0' key='taxon_id'}taxon_id\"}},\"cachedResultTypes\":{}},\"response\":{\"validation\":{\"valid\":true},\"obj\":{\"responseHeader\":{\"status\":0,\"QTime\":2,\"params\":{\"facet\":\"true\",\"q\":\"*\",\"facet.field\":\"{!facet.limit='50' facet.mincount='0' key='taxon_id'}taxon_id\",\"fq\":\"_terms:(PAD4)\",\"rows\":\"0\"}},\"response\":{\"numFound\":5,\"start\":0,\"maxScore\":1,\"docs\":[]},\"facet_counts\":{\"facet_queries\":{},\"facet_fields\":{\"taxon_id\":[\"3702\",1,\"3760\",1,\"4113\",1,\"29760\",1,\"81972\",1,\"3055\",0,\"3218\",0,\"3641\",0,\"3694\",0,\"3847\",0,\"3880\",0,\"4081\",0,\"4528\",0,\"4529\",0,\"4533\",0,\"4536\",0,\"4537\",0,\"4538\",0,\"4555\",0,\"4558\",0,\"4565\",0,\"4572\",0,\"4577\",0,\"13333\",0,\"15368\",0,\"37682\",0,\"39946\",0,\"39947\",0,\"40148\",0,\"40149\",0,\"51351\",0,\"65489\",0,\"77586\",0,\"88036\",0,\"109376\",0,\"112509\",0,\"214687\",0,\"280699\",0,\"436017\",0]},\"facet_dates\":{},\"facet_ranges\":{},\"facet_intervals\":{},\"facet_heatmaps\":{}}}}},\"rows10\":{\"query\":{\"q\":\"\",\"filters\":{\"_terms:(PAD4)\":{}},\"resultTypes\":{\"list\":{\"rows\":10,\"start\":0},\"fixed_200__bin\":{\"facet.field\":\"{!facet.limit='-1' facet.mincount='1' key='fixed_200__bin'}fixed_200__bin\"}},\"count\":5,\"cachedResultTypes\":{}},\"response\":{\"validation\":{\"valid\":true},\"obj\":{\"responseHeader\":{\"status\":0,\"QTime\":97,\"params\":{\"facet\":\"true\",\"start\":\"0\",\"q\":\"*\",\"facet.field\":\"{!facet.limit='-1' facet.mincount='1' key='fixed_200__bin'}fixed_200__bin\",\"fq\":\"_terms:(PAD4)\",\"rows\":\"10\"}},\"response\":{\"numFound\":5,\"start\":0,\"maxScore\":1,\"docs\":[{\"id\":\"PRUPE_ppa025554mg\",\"name\":\"PAD4\",\"description\":\"alpha/beta-Hydrolases superfamily protein\",\"taxon_id\":3760,\"biotype\":\"protein_coding\",\"capabilities\":[\"location\",\"homology\",\"xrefs\",\"GO\",\"domains\",\"taxonomy\"],\"closest_rep_id\":\"MTR_8g494200\",\"closest_rep_taxon_id\":3880,\"closest_rep_description\":\"phytoalexin deficient protein\",\"model_rep_id\":\"AT3G52430\",\"model_rep_taxon_id\":3702,\"model_rep_name\":\"PAD4\",\"model_rep_description\":\"Lipase-like PAD4\",\"score\":1},{\"id\":\"PGSC0003DMG400019873\",\"name\":\"PAD4\",\"description\":\"Phytoalexin-deficient 4-2 protein\",\"taxon_id\":4113,\"biotype\":\"protein_coding\",\"capabilities\":[\"location\",\"homology\",\"xrefs\",\"GO\",\"domains\",\"taxonomy\"],\"score\":1},{\"id\":\"AT3G52430\",\"name\":\"PAD4\",\"description\":\"Lipase-like PAD4\",\"taxon_id\":3702,\"biotype\":\"protein_coding\",\"capabilities\":[\"location\",\"homology\",\"xrefs\",\"GO\",\"PO\",\"domains\",\"taxonomy\"],\"model_rep_id\":\"AT3G52430\",\"model_rep_taxon_id\":3702,\"model_rep_name\":\"PAD4\",\"model_rep_description\":\"Lipase-like PAD4\",\"score\":1},{\"id\":\"scaffold_502313.1\",\"name\":\"PAD4\",\"description\":\"Phytoalexin deficient 4\",\"taxon_id\":81972,\"biotype\":\"protein_coding\",\"capabilities\":[\"location\",\"homology\",\"xrefs\",\"GO\",\"domains\",\"taxonomy\"],\"score\":1},{\"id\":\"VIT_07s0031g02390\",\"name\":\"PAD4\",\"description\":\"Putative uncharacterized protein\",\"taxon_id\":29760,\"biotype\":\"protein_coding\",\"capabilities\":[\"location\",\"homology\",\"xrefs\",\"GO\",\"domains\",\"taxonomy\"],\"closest_rep_id\":\"AT3G52430\",\"closest_rep_taxon_id\":3702,\"closest_rep_name\":\"PAD4\",\"closest_rep_description\":\"Lipase-like PAD4\",\"score\":1}]},\"facet_counts\":{\"facet_queries\":{},\"facet_fields\":{\"fixed_200__bin\":[\"516\",1,\"602\",1,\"1231\",1,\"3476\",1,\"4927\",1]},\"facet_dates\":{},\"facet_ranges\":{},\"facet_intervals\":{},\"facet_heatmaps\":{}}}}}}");

},{}],"hlIfA":[function(require,module,exports,__globalThis) {
module.exports = {
    taxonomy: require("4104a3def612fed5"),
    promise: require("c9486c8a719d924e"),
    genetree: require("69d3bcc85fdff6ea"),
    extensions: require("18e3da586d765d90")
};

},{"4104a3def612fed5":"eBvDB","c9486c8a719d924e":"kiwah","69d3bcc85fdff6ea":"bWOsi","18e3da586d765d90":"jrU9D"}],"kiwah":[function(require,module,exports,__globalThis) {
'use strict';
var grameneClient = require("2ec3ed788e882add").client.grameneClient;
var validateFactory = require("2ec3ed788e882add").client.validate;
var Q = require("118046cbdfbd8139");
var taxonomy = require("11a050e81e7472e6");
module.exports = {
    get: function(local) {
        var src;
        if (local) src = Q(require("bddd69bd6786a169"));
        else src = grameneClient.then(function(client) {
            var deferred, params;
            deferred = Q.defer();
            params = {
                rows: -1,
                subset: 'gramene',
                fl: [
                    '_id',
                    'is_a',
                    'property_value',
                    'name',
                    'synonym',
                    'num_genes',
                    'reactomePrefix'
                ]
            };
            client['Data access'].taxonomy(params, function(response) {
                response.client = client;
                deferred.resolve(response);
            });
            return deferred.promise;
        });
        return src.then(validateFactory('TaxonomyResponse')).then(justTheData).then(taxonomyPromise);
    }
};
function justTheData(json) {
    return Q(json.obj);
}
function taxonomyPromise(data) {
    return Q.fcall(taxonomy.tree, data);
}

},{"2ec3ed788e882add":"goK7c","118046cbdfbd8139":"iWYSC","11a050e81e7472e6":"eBvDB","bddd69bd6786a169":"TI30D"}],"goK7c":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = {
    resultTypes: require("aa8ca3b24a41267f"),
    client: require("c277dc03fed845")
};

},{"aa8ca3b24a41267f":"4xnQv","c277dc03fed845":"5oZmO"}],"4xnQv":[function(require,module,exports,__globalThis) {
'use strict';
var _ = require("66462dabac18e21e");
var resultTypes = {
    list: {
        rows: 10,
        start: 0
    },
    distribution: {
        'facet.limit': -1,
        'facet.mincount': 1
    },
    facet: {
        'facet.limit': 50,
        'facet.mincount': 0,
        'facet.field': 'taxon_id'
    },
    tally: {
        'json.facet': {
            'species': 'unique(taxon_id)',
            'biotype': 'unique(biotype)',
            'GO': 'unique(GO_xrefi)',
            'PO': 'unique(PO_xrefi)',
            'domains': 'unique(interpro_xrefi)',
            'epl_gene_tree': 'unique(epl_gene_tree)'
        }
    }
};
module.exports = {
    get: function(type, details) {
        var rt = _.cloneDeep(resultTypes[type]), facetField, kvpStringArray;
        if (!rt) return;
        // details are specific configurations for this 'instance' of
        // the result type, e.g. facet field.
        if (details) // add the details to the object
        _.assign(rt, details);
        // if 'facet.field' and 'key' are defined then we are faceting. Refactor all
        // properties into a string that fits the SOLR syntax for LocalParams
        // described here http://wiki.apache.org/solr/LocalParams
        /* e.g/

    {
      'facet.field': 'foo',
      key: 'bar',
      'facet.mincount': -1,
      'facet.limit': 10
    }

    will become
    {
      'facet.field': '{!key=bar facet.mincount=-1 facet.limit=10}foo'
    }

    We do this to encapsulate properties, and allow the same facet.field
    to be faceted more than once.
     */ facetField = rt['facet.field'];
        if (facetField) {
            delete rt['facet.field'];
            if (!rt.key) rt.key = facetField;
            kvpStringArray = _.map(rt, function(propVal, propKey) {
                return propKey + '=\'' + propVal + '\'';
            });
            rt = {
                'facet.field': '{!' + kvpStringArray.join(' ') + '}' + facetField
            };
        }
        return rt;
    }
};

},{"66462dabac18e21e":"8bWZr"}],"5oZmO":[function(require,module,exports,__globalThis) {
'use strict';
var _ = require("cc3925d0e5206bf2");
var Q = require("375160853f69ef6f");
var geneSearch = require("cb0fcf87308c80f0");
var suggest = require("2f6dcb6721fe9fba");
var mongo = require("3145443c27041822");
function testSearch(example) {
    var tests = require("45de24980b885ce9");
    var testResults = _.get(tests, [
        example,
        'response'
    ]);
    if (!testResults) throw new Error("testSearch should be one of " + _.keys(tests).join(', '));
    return Q(_.cloneDeep(testResults)).then(geneSearch.reformatResponse);
}
exports.grameneClient = require("26ac41562b4811b");
exports.validate = require("2b2dc6b1d9e6837f");
exports.geneSearch = geneSearch.promise;
exports.suggest = suggest.promise;
exports.genes = mongo.genes;
exports.genetrees = mongo.genetrees;
exports.domains = mongo.domains;
exports.pathways = mongo.pathways;
exports.GO = mongo.GO;
exports.PO = mongo.PO;
exports._testSearch = testSearch;

},{"cc3925d0e5206bf2":"8bWZr","375160853f69ef6f":"iWYSC","cb0fcf87308c80f0":"kUoOC","2f6dcb6721fe9fba":"aOMEP","3145443c27041822":"fNiZG","45de24980b885ce9":"8CcbO","26ac41562b4811b":"4HmSJ","2b2dc6b1d9e6837f":"9iFCf"}],"kUoOC":[function(require,module,exports,__globalThis) {
'use strict';
var _ = require("cb483fbc4b59b8a5");
var Q = require("6e4a335eb076897f");
var grameneSwaggerClient = require("a6e4662dcf150b5a");
var validate = require("528b893fbb67303b");
function makeCall(gramene, query) {
    var deferred = Q.defer();
    var params = getSolrParameters(query);
    params.collection = 'genes';
    gramene['Search'].genes(params, function(res) {
        res.client = gramene;
        deferred.resolve(res);
    });
    return deferred.promise;
}
function getSolrParameters(query) {
    var result = defaultSolrParameters();
    if (!query) return result;
    result.q = (query.q || '') + '*';
    for(var rtName in query.resultTypes)_.assign(result, query.resultTypes[rtName], function(existing, another) {
        var result = existing;
        // handle the case where the same key may be defined in many result types, for example
        // facet.field. It's typical for solr to have multiple facet.field parameters in the URL,
        // e.g.
        // http://data.gramene.org/search/genes?wt=json&indent=true&q=*&rows=2&start=0&facet=true&facet.field=bin_10Mb&facet.field=bin_5Mb&facet.limit=10&facet.mincount=1&f.bin_10Mb.facet.limit=10&fq=Interpro_xrefs:(IPR008978
        // IPR002068)
        if (existing) {
            if (_.isArray(existing)) {
                existing.push(another);
                result = existing;
            } else result = [
                existing,
                another
            ];
        } else result = another;
        return result;
    });
    if (query.filters && Object.keys(query.filters).length) {
        result.fq = Object.keys(query.filters);
        result.facet = true;
    }
    return result;
}
function defaultSolrParameters() {
    return {
        q: '*',
        rows: 0,
        facet: true
    };
}
function reformatResponse(response) {
    var data = response.obj;
    var fixed = {};
    if (data.facet_counts) {
        var originalFacets = data.facet_counts.facet_fields;
        if (originalFacets && !data.results) {
            fixed = data.results = {};
            for(var f in originalFacets)fixed[f] = reformatFacet(originalFacets[f], isSearchFieldNumeric(f), f);
            delete data.facet_counts;
        }
    }
    if (data.response.docs.length) fixed.list = data.response.docs;
    fixed.metadata = {
        count: data.response.numFound,
        qtime: data.responseHeader.QTime,
        url: response.url,
        client: response.client,
        validation: response.validation
    };
    if (response.headers) fixed.metadata.date = response.headers.date;
    if (data.facets) {
        fixed.tally = {};
        for(var f in data.facets)fixed.tally[f] = data.facets[f];
    }
    return fixed;
}
function isSearchFieldNumeric(fieldName) {
    return fieldName && (_.endsWith(fieldName, '__bin') || _.endsWith(fieldName, '__ancestors') || _.startsWith(fieldName, 'transcript__') || _.startsWith(fieldName, 'protein__') || fieldName === 'taxon_id' || fieldName === 'start' || fieldName === 'end' || fieldName === 'gene_idx' || fieldName === 'strand');
}
function reformatFacet(facetData, numericIds, displayName) {
    // facet data is an array of alternating ids (string) and counts (int),
    // e.g. ["4565", 99155, "3847", 54159, "109376", 46500, ... ]
    // we will make an associative array with id key and an object
    // for count and other values that may be added later.
    // e.g. { data : { "4565" : { count : 99155 }, // order here not guaranteed :-(
    //                 "3847" : { count: 54159 },
    //                 "109376" : { count: 46500 }
    //               }
    //      }
    var result = {
        data: {},
        sorted: [],
        count: 0,
        displayName: displayName
    };
    for(var i = 0; i < facetData.length; i += 2){
        var id = numericIds ? parseInt(facetData[i]) : facetData[i], count = facetData[i + 1], datum = {
            id: id,
            count: count
        };
        result.data[id] = datum;
        result.sorted.push(datum);
        if (count > 0) result.count++;
    }
    return result;
}
function promise(query) {
    return grameneSwaggerClient.then(function(client) {
        return makeCall(client, query);
    }).then(validate("SolrGeneResponse")).then(reformatResponse);
}
module.exports = {
    makeCall: makeCall,
    reformatResponse: reformatResponse,
    promise: promise
};

},{"cb483fbc4b59b8a5":"8bWZr","6e4a335eb076897f":"iWYSC","a6e4662dcf150b5a":"4HmSJ","528b893fbb67303b":"9iFCf"}],"4HmSJ":[function(require,module,exports,__globalThis) {
'use strict';
var _ = require("acab36f26b3149b5");
var Q = require("77adbcc7619b4041");
var Validator = require("df6e7fbd5aa72cdc");
var serverUrl = require("a7c8bcdfb8a81753");
var grameneSwaggerClient = function() {
    var Client = require("34565f0645309ca8");
    var deferred = Q.defer();
    var gramene = new Client({
        url: serverUrl(),
        success: function() {
            deferred.resolve(gramene);
        }
    });
    return deferred.promise.then(function addValidator(client) {
        new Validator(client);
        return client;
    });
}();
module.exports = grameneSwaggerClient;

},{"acab36f26b3149b5":"8bWZr","77adbcc7619b4041":"iWYSC","df6e7fbd5aa72cdc":"aUYGi","a7c8bcdfb8a81753":"dKnMA","34565f0645309ca8":"aTBSV"}],"aUYGi":[function(require,module,exports,__globalThis) {
/**
 * Created by bdunn on 21/10/2014.
 */ module.exports = require("33283aadefad9e66");

},{"33283aadefad9e66":"99TN0"}],"99TN0":[function(require,module,exports,__globalThis) {
'use strict';
/**
 * Created by bdunn and ssreedharan on 18/09/2014.
 */ module.exports = Validator;
function Validator(swagger) {
    if (!(this instanceof Validator)) return new Validator(swagger);
    var self = this;
    this.customValidators = {};
    this.swagger = swagger;
    if (swagger) swagger.validateModel = function(modelName, obj, allowBlankTarget, disallowExtraProperties) {
        // this is now going to run in the scope of swagger...
        // Find the list of all Models from the allModels property or the definition property
        // This supports Swagger 1.2 and Swagger 2.0
        var models = this.allModels;
        if (this.definitions) models = this.definitions;
        var model = modelName;
        if (isStringType(modelName) && models[modelName]) model = models[modelName];
        // Add support for the use of discriminators this does not add support for the extends part of the
        // specification
        // var subModelName = model.discriminator && obj[model.discriminator];
        // if(subModelName && models[subModelName])
        // {
        //     model = models[subModelName];
        // }
        return validate(modelName, obj, model, models, allowBlankTarget, disallowExtraProperties, self.customValidators);
    };
}
Validator.prototype.validate = function(target, swaggerModel, swaggerModels, allowBlankTarget, disallowExtraProperties) {
    return validate('rootModel', target, swaggerModel, swaggerModels, allowBlankTarget, disallowExtraProperties, this.customValidators);
};
Validator.prototype.addFieldValidatorToModel = function(model, fieldName, validatorFunction) {
    if (!model) throw new Error("Model is required");
    else if (typeof model != 'object') throw new Error("Model must be an object");
    if (!fieldName) throw new Error("FieldName is required");
    else if (typeof fieldName !== 'string') throw new Error("FieldName must be a string");
    if (!validatorFunction) throw new Error("ValidatorFunction is required");
    else if (typeof validatorFunction !== 'function') throw new Error("ValidatorFunction is not a function");
    if (model.id) this.addFieldValidator(model.id, fieldName, validatorFunction);
    var modelValidator = model['x-validators'];
    if (!modelValidator) {
        modelValidator = {};
        modelValidator[fieldName] = [
            validatorFunction
        ];
        model['x-validators'] = modelValidator;
        return true;
    } else {
        var fieldValidators = modelValidator[fieldName];
        if (!fieldValidators) {
            fieldValidators = [
                validatorFunction
            ];
            modelValidator[fieldName] = fieldValidators;
            return true;
        } else {
            fieldValidators.push(validatorFunction);
            return true;
        }
    }
    return false;
};
Validator.prototype.addFieldValidator = function(modelName, fieldName, validatorFunction) {
    if (!modelName) throw new Error("ModelName is required");
    else if (typeof modelName !== 'string') throw new Error("ModelName must be a string");
    if (!fieldName) throw new Error("FieldName is required");
    else if (typeof fieldName !== 'string') throw new Error("FieldName must be a string");
    if (!validatorFunction) throw new Error("ValidatorFunction is required");
    else if (typeof validatorFunction !== 'function') throw new Error("ValidatorFunction is not a function");
    var modelValidator = this.customValidators[modelName];
    if (!modelValidator) {
        modelValidator = {};
        modelValidator[fieldName] = [
            validatorFunction
        ];
        this.customValidators[modelName] = modelValidator;
        return true;
    } else {
        var fieldValidators = modelValidator[fieldName];
        if (!fieldValidators) {
            fieldValidators = [
                validatorFunction
            ];
            modelValidator[fieldName] = fieldValidators;
            return true;
        } else {
            fieldValidators.push(validatorFunction);
            return true;
        }
    }
};
Validator.prototype.getFieldValidators = function(modelName, fieldName) {
    return getCustomValidators(modelName, fieldName, this.customValidators);
};
function getCustomValidators(modelName, fieldName, validators) {
    if (modelName) {
        if (validators) {
            if (!validators[modelName]) return null;
            else if (!validators[modelName][fieldName]) return null;
            else return validators[modelName][fieldName];
        }
    }
    return null;
}
function getCustomValidatorsFromModel(model, fieldName) {
    if (model && model['x-validators']) {
        if (!model['x-validators'][fieldName]) return null;
        else return model['x-validators'][fieldName];
    }
    return null;
}
function validate(name, target, swaggerModel, swaggerModels, allowBlankTargets, disallowExtraProperties, customValidators) {
    if (swaggerModels === true && allowBlankTargets === undefined) {
        allowBlankTargets = true;
        swaggerModels = undefined;
    } else if (swaggerModels === false || swaggerModels === null) swaggerModels = undefined;
    if (target === undefined || target === null) return createReturnObject(new Error('Unable to validate an undefined value.'));
    else if (allowBlankTargets !== true && isEmptyObject(target)) return createReturnObject(new Error('Unable to validate an empty value.'));
    if (!swaggerModel) return createReturnObject(new Error('Unable to validate against an undefined model.'));
    var targetType = typeof target;
    var modelType = swaggerModel.type || 'object';
    if (targetType !== "object" && targetType !== modelType) return createReturnObject(new Error('Unable to validate a model with an type: ' + targetType + ', expected: ' + modelType));
    var requireFieldErrs;
    var model = getMergedModel(swaggerModel, swaggerModels);
    //model = getRefedModel(model, swaggerModels);
    model = getDiscriminatedModel(target, model, swaggerModels);
    if (model.required && model.required.length > 0) {
        requireFieldErrs = validateRequiredFields(target, model.required, model.properties);
        if (requireFieldErrs) return createReturnObject(requireFieldErrs);
    }
    var validationErrs = validateSpec(name, target, model, swaggerModels, allowBlankTargets, disallowExtraProperties, customValidators);
    if (validationErrs) return createReturnObject(validationErrs, model.id || name);
    else return createReturnObject();
}
function isEmptyObject(target) {
    //Abort if target is not an object, otherwise isEmptyObject(1) === true and we don't want that.
    if (typeof target !== 'object') return false;
    //Abort if target is an array, otherwise isEmptyObject([]) === true and we don't want that.
    if (Array.isArray(target)) return false;
    for(var p in target){
        if (target[p] != target.constructor.prototype[p]) return false;
    }
    return true;
}
function createReturnObject(errors, modelName) {
    var result = {};
    if (!errors) {
        result.valid = true;
        result.errorCount = 0;
    } else {
        result.valid = false;
        if (!errors.message) {
            result.errorCount = errors.length;
            result.errors = errors;
        } else {
            result.errorCount = 1;
            result.errors = [
                errors
            ];
        }
        result.GetErrorMessages = function() {
            var errorMessages = [];
            for(var index in this.errors)errorMessages.push(this.errors[index].message);
            return errorMessages;
        };
        result.GetFormattedErrors = function() {
            var errors = [];
            for(var index in this.errors){
                var error = JSON.stringify(this.errors[index], [
                    "message",
                    "arguments",
                    "type",
                    "name"
                ]);
                errors.push(JSON.parse(error));
            }
            return errors;
        };
    }
    if (modelName) result.modelName = modelName;
    return result;
}
function validateProperties(target, model, models) {
    var targetProperties = Object.keys(target);
    var errors = [];
    var refModel = getRefedModel(model, models);
    refModel = getDiscriminatedModel(target, refModel, models);
    if (targetProperties) {
        for(var key in targetProperties)if (!refModel.properties[targetProperties[key]]) errors.push(new Error("Target property '" + targetProperties[key] + "' is not in the model"));
    }
    return errors.length > 0 ? errors : null;
}
function validateSpec(name, target, model, models, allowBlankTargets, disallowExtraProperties, customValidators) {
    var properties = model.properties;
    var errors = [];
    // if there is a $ref property, it's a ref to other model
    if (model.$ref) {
        var refErrors = validateType(name, target, model, models, allowBlankTargets, disallowExtraProperties);
        if (!refErrors.valid) errors = refErrors.errors;
    } else if (!properties) {
        if (!model.type) return null;
        var singleValueErrors = validateValue(name, model, target, models);
        if (singleValueErrors) singleValueErrors.forEach(function(error) {
            errors.push(error);
        });
    } else {
        if (disallowExtraProperties && !Array.isArray(target)) {
            errors = validateProperties(target, model, models) || [];
            if (model.discriminator && errors.length >= 1) {
                if (errors.length == 1 && errors[0].message == "Target property '" + model.discriminator + "' is not in the model") // remove discriminator if it is the only error.
                errors = [];
                else {
                    var tempErrors = errors;
                    errors = [];
                    tempErrors.forEach(function(error) {
                        if (error.message != "Target property '" + model.discriminator + "' is not in the model") errors.push(error);
                    });
                }
            }
        }
        for(var key in properties){
            var field = properties[key];
            var value = target[key];
            if (value !== undefined) {
                var valueErrors = validateValue(key, field, value, models, allowBlankTargets, disallowExtraProperties);
                if (!valueErrors) valueErrors = validateCustom(model.id || name, key, value, customValidators);
                if (!valueErrors) valueErrors = validateCustomFromModel(model, key, value);
                if (valueErrors) valueErrors.forEach(function(error) {
                    errors.push(error);
                });
            }
        }
    }
    return errors.length > 0 ? errors : null;
}
function validateCustomFromModel(model, name, value) {
    var validations = getCustomValidatorsFromModel(model, name);
    if (!validations) return null;
    var errors = [];
    validations.forEach(function(validation) {
        try {
            var validationErrors = validation(name, value);
            if (validationErrors) {
                if (validationErrors.message) errors.push(validationErrors);
                else validationErrors.forEach(function(validationError) {
                    errors.push(validationError);
                });
            }
        } catch (e) {
            console.warn(e);
        }
    });
    return errors.length > 0 ? errors : null;
}
function validateCustom(modelName, name, value, customValidators) {
    var validations = getCustomValidators(modelName, name, customValidators);
    if (!validations) return null;
    var errors = [];
    validations.forEach(function(validation) {
        try {
            var validationErrors = validation(name, value);
            if (validationErrors) {
                if (validationErrors.message) errors.push(validationErrors);
                else validationErrors.forEach(function(validationError) {
                    errors.push(validationError);
                });
            }
        } catch (e) {
            console.warn(e);
        }
    });
    return errors.length > 0 ? errors : null;
}
function validateValue(key, field, value, models, allowBlankTargets, disallowExtraProperties) {
    var errors = [];
    if (value !== undefined) {
        var typeErr = validateType(key, value, field, models, allowBlankTargets, disallowExtraProperties);
        if (typeErr) {
            if (typeErr.valid === undefined) {
                errors.push(typeErr);
                return errors;
            } else if (!typeErr.valid) {
                typeErr.errors.forEach(function(error) {
                    errors.push(error);
                });
                return errors;
            } else return null;
        }
        if (field["x-validatedType"] === 'string') {
            if (field.minLength > 0 || field.maxLength > 0) {
                var err1 = validateMinMaxLength(key, value, field.minLength, field.maxLength);
                if (err1) errors.push(err1);
            }
            if (field.pattern) {
                var errPattern = validatePattern(key, value, field.pattern);
                if (errPattern) errors.push(errPattern);
            }
        }
        if (field.type === 'integer' || field.type === 'number' || field["x-validatedType"] === 'date' || field["x-validatedType"] === 'date-time') {
            var exclusiveMin = field.exclusiveMinimum === true;
            var exclusiveMax = field.exclusiveMaximum === true;
            if (field.minimum || field.maximum || field.minimum === 0 || field.maximum === 0) {
                var err2 = validateMinMaxValue(key, value, field.minimum, field.maximum, exclusiveMin, exclusiveMax);
                if (err2) errors.push(err2);
            }
            if (field.exclusiveMinimum || field.exclusiveMaximum || field.exclusiveMinimum === 0 || field.exclusiveMaximum === 0) {
                var err3 = validateMinMaxValue(key, value, field.exclusiveMinimum, field.exclusiveMaximum, true, true);
                if (err3) errors.push(err3);
            }
        }
        field["x-validatedType"];
        if (field.enum) {
            var err = validateEnums(key, value, field.enum);
            if (err) errors.push(err);
        }
    }
    return errors.length > 0 ? errors : null;
}
function validateType(name, property, field, models, allowBlankTargets, disallowExtraProperties) {
    var expectedType = field.type;
    if (!expectedType) {
        if (models && field.$ref) {
            var fieldRef1 = field.$ref.replace('#/definitions/', '');
            return validate(name, property, models[fieldRef1], models, allowBlankTargets, disallowExtraProperties);
        } else return null;
    } else expectedType = expectedType.toLowerCase();
    // Only attempt to validate an object if properties are defined in the model.
    // Otherwise, it's a poorly defined part of the schema that we will accept without
    // asking any further questions of it.
    if (expectedType === 'object') {
        if (field.properties) return validate(name, property, field, models, allowBlankTargets, disallowExtraProperties);
        else return null;
    }
    if (expectedType === 'array') {
        if (!Array.isArray(property)) return new Error(name + ' is not an array. An array is expected.');
        if (field.items && field.items.type) {
            // These items are a baser type and not a referenced model
            var fieldType = field.items.type;
            var count = 0;
            var arrayErrors1 = [];
            property.forEach(function(value) {
                var errors1 = validateValue(name + count.toString(), field.items, value, models, allowBlankTargets, disallowExtraProperties);
                if (errors1) errors1.forEach(function(error) {
                    arrayErrors1.push(error);
                });
                count = count + 1;
            });
            if (arrayErrors1.length > 0) return createReturnObject(arrayErrors1, "Array of " + fieldType + " (" + name + ")");
        } else if (models && field.items && field.items.$ref) {
            // These items are a referenced model
            var fieldRef2 = field.items.$ref.replace('#/definitions/', '');
            var model = models[fieldRef2];
            if (model) {
                var arrayErrors2 = [];
                property.forEach(function(value) {
                    var errors2 = validate(name, value, model, models, allowBlankTargets, disallowExtraProperties);
                    if (errors2 && !errors2.valid) errors2.errors.forEach(function(error) {
                        arrayErrors2.push(error);
                    });
                });
                if (arrayErrors2.length > 0) return createReturnObject(arrayErrors2, "Array of " + field.items.$ref + " (" + name + ")");
            }
        }
        return null;
    }
    var format = field.format;
    if (format) format = format.toLowerCase();
    if (property === undefined || property === null) return null;
    if (expectedType === 'string') {
        if (isStringType(property, format)) {
            field["x-validatedType"] = format || expectedType;
            return null;
        }
    } else if (expectedType === 'boolean') {
        if (isExpectedType(property, expectedType)) {
            field["x-validatedType"] = format || expectedType;
            return null;
        }
    } else if (expectedType === 'integer') {
        if (isIntegerType(property, format)) {
            field["x-validatedType"] = format || expectedType;
            return null;
        }
    } else if (expectedType === 'number') {
        if (isNumberType(property, format)) {
            field["x-validatedType"] = format || expectedType;
            return null;
        }
    }
    //if(!format) {
    return new Error(name + ' (' + wrapNullProperty(property) + ') is not a type of ' + (format || expectedType));
//} else {
//    return new Error(name + ' (' + wrapNullProperty(property) + ') is not a type of ' + format)
//}
}
function isStringType(property, format) {
    if (isExpectedType(property, 'string')) {
        if (!format) return true;
        else if (format === 'date' || format === 'date-time') {
            var date = new Date(property);
            if (date !== "Invalid Date" && !isNaN(date) && isNaN(property)) return !(format === 'date' && property.length !== 10);
        } else // If format is specified but not special rules apply then validation is true
        return true;
    }
    return false;
}
function isIntegerType(property, format) {
    if (!isNumberType(property)) // If is is not a number then it cannot be an integer.
    return false;
    if (property !== Math.floor(property)) return false;
    if (!format) return true;
    else if (format === 'int32') {
        var int32Max = Math.pow(2, 31) - 1;
        var value1 = parseInt(property);
        if (!isNaN(value1) && isFinite(property) && value1 >= -(int32Max + 1) && value1 <= int32Max) return true;
    } else if (format === 'int64') {
        var value2 = parseInt(property);
        if (!isNaN(value2) && isFinite(property)) return true;
    } else // If format is specified but no special rules apply then validation is true
    return true;
    return false;
}
function isNumberType(property, format) {
    if (!isExpectedType(property, 'number')) return false;
    else if (!format || format === 'float' || format === 'double') {
        if (!isNaN(parseFloat(property)) && isFinite(property)) return true;
    } else // If format is specified but not special rules apply then validation is true
    return true;
    return false;
}
function isExpectedType(property, expectedType) {
    return typeof property === expectedType;
}
function wrapNullProperty(property) {
    if (property === null) return "{null}";
    if (property === "") return "{empty string}";
    return property;
}
function validateMinLength(name, value, minLength) {
    if (minLength > 0) {
        if (value.length < minLength) {
            if (minLength === 1) return new Error(name + ' cannot be blank');
            return new Error(name + ' must be at least ' + minLength.toString() + ' characters long');
        }
    }
    return null;
}
function validateMaxLength(name, value, maxLength) {
    if (maxLength > 0) {
        if (value.length > maxLength) return new Error(name + ' must be no more than ' + maxLength.toString() + ' characters long');
    }
    return null;
}
function validateMinMaxLength(name, value, minLength, maxLength) {
    if (!minLength && !maxLength) return null;
    else if (!minLength) return validateMaxLength(name, value, maxLength);
    else if (!maxLength) return validateMinLength(name, value, minLength);
    if (value.length < minLength || value.length > maxLength) {
        if (minLength === 1) return new Error(name + ' cannot be blank and cannot be longer than ' + maxLength.toString() + ' characters long');
        return new Error(name + ' must be at least ' + minLength.toString() + ' characters long and no more than ' + maxLength.toString() + ' characters long');
    }
    return null;
}
function validateMinValue(name, value, minValue, exclusive) {
    if (minValue || minValue === 0) {
        if (!exclusive && value < minValue) return new Error(name + ' must be at least ' + minValue.toString());
        else if (exclusive && value <= minValue) return new Error(name + ' must be greater than ' + minValue.toString());
    }
    return null;
}
function validateMaxValue(name, value, maxValue, exclusive) {
    if (maxValue || maxValue === 0) {
        if (!exclusive && value > maxValue) return new Error(name + ' must be no more than ' + maxValue.toString());
        else if (exclusive && value >= maxValue) return new Error(name + ' must be less than ' + maxValue.toString());
    }
    return null;
}
function validateMinMaxValue(name, value, minValue, maxValue, exclusiveMin, exclusiveMax) {
    !minValue && maxValue;
    if (minValue === undefined || minValue === true) return validateMaxValue(name, value, maxValue, exclusiveMax);
    else if (maxValue === undefined || maxValue === true) return validateMinValue(name, value, minValue, exclusiveMin);
    if (!exclusiveMin && !exclusiveMax && (value < minValue || value > maxValue)) return new Error(name + ' must be at least ' + minValue.toString() + ' and no more than ' + maxValue.toString());
    else if (exclusiveMin && exclusiveMax && (value <= minValue || value >= maxValue)) return new Error(name + ' must be greater than ' + minValue.toString() + ' and less than ' + maxValue.toString());
    else if (exclusiveMin && (value <= minValue || value > maxValue)) return new Error(name + ' must be greater than ' + minValue.toString() + ' and no more than ' + maxValue.toString());
    else if (exclusiveMax && (value > maxValue || value < minValue)) return new Error(name + ' must be at least ' + minValue.toString() + ' and less than ' + maxValue.toString());
    return null;
}
function validateRequiredFields(object, fields, modelFields) {
    if (!(fields instanceof Array)) throw new Error('fields must be an array of required fields');
    var errors = [];
    for(var i = 0; i < fields.length; ++i){
        var property = fields[i];
        try {
            if (!object.hasOwnProperty(property) || object[property] === "" || object[property] === null && !modelFields[property]['x-nullable']) errors.push(new Error(property + ' is a required field'));
        } catch (e) {
            errors.push(new Error('object does not have property ' + property));
        }
    }
    return errors.length > 0 ? errors : null;
}
function validateEnums(name, value, enums) {
    if (value === undefined || value === null) return null;
    for(var index in enums){
        if (value === enums[index]) return null;
    }
    return new Error(name + ' is not set to an allowed value (see enum)');
}
function validatePattern(name, value, pattern) {
    if (value === undefined || value === null || !pattern) return null;
    var regex = new RegExp(pattern);
    if (regex.test(value)) return null;
    return new Error(name + ' does not match the pattern ' + pattern);
}
function incrementDateString(dateString, increment) {
    var incrementingDate = new Date(dateString);
    incrementingDate.setMilliseconds(incrementingDate.getMilliseconds() + increment);
    return incrementingDate.toISOString();
}
function merge(target, source) {
    if (typeof source == 'undefined') return target;
    if (typeof target == 'undefined') return source;
    if (typeof target != 'object') target = {};
    for(var property in source)if (source.hasOwnProperty(property)) {
        var sourceProp = source[property];
        if (Array.isArray(sourceProp)) {
            if (typeof target[property] == 'undefined') target[property] = sourceProp;
            else target[property] = target[property].concat(sourceProp);
        } else if (typeof sourceProp === 'object') {
            if (!target[property]) target[property] = {};
            target[property] = merge(target[property], sourceProp);
        } else target[property] = sourceProp;
    }
    for(var a = 2, l = arguments.length; a < l; a++)merge(target, arguments[a]);
    return target;
}
function getDiscriminatedModel(target, model, models) {
    // Check for a discriminator
    var subModelName = model.discriminator && target[model.discriminator];
    if (subModelName && models[subModelName]) {
        var discriminator = model.discriminator;
        model = models[subModelName];
        model = getMergedModel(model, models);
        model.discriminator = discriminator;
    }
    return model;
}
function getMergedModel(model, models) {
    if (model.allOf) {
        var merged = merge({}, model);
        delete merged.allOf;
        model.allOf.forEach(function(item) {
            if (item.$ref) {
                // Is a reference to an existing model
                var modelRef = models[item.$ref.replace('#/definitions/', '')];
                if (modelRef.allOf) modelRef = getMergedModel(modelRef, models);
                merged = merge(merged, modelRef);
            } else merged = merge(merged, item);
        });
        return merged;
    }
    return model;
}
function getRefedModel(model, models) {
    if (model.properties) {
        var outModel = merge({}, model);
        var keys = Object.keys(model.properties);
        for(var key in keys){
            var item = outModel.properties[keys[key]];
            if (item && item.$ref) {
                var reference = item.$ref;
                delete item.$ref;
                var modelRef = models[reference.replace('#/definitions/', '')];
                if (modelRef) {
                    if (modelRef.allOf) modelRef = getMergedModel(modelRef, models);
                    modelRef = getRefedModel(modelRef, models);
                    outModel.properties[keys[key]] = merge(item, modelRef);
                }
            }
        }
    }
    return outModel;
}

},{}],"dKnMA":[function(require,module,exports,__globalThis) {
var global = arguments[3];
'use strict';
var queryString = require("7276a83c6080614");
var HARDCODED_SERVER = "http://data.gramene.org/swagger";
function determineServerUrl() {
    var server;
    if (global) {
        if (global.location && global.location.search) {
            server = queryString.parse(global.location.search).server;
            if (server) return server;
        }
        if (global.gramene && global.gramene.defaultServer) return global.gramene.defaultServer;
    }
    return HARDCODED_SERVER;
}
determineServerUrl.HARDCODED_SERVER = HARDCODED_SERVER;
module.exports = determineServerUrl;

},{"7276a83c6080614":"kI7c0"}],"kI7c0":[function(require,module,exports,__globalThis) {
'use strict';
var strictUriEncode = require("29e8409c085f4b23");
exports.extract = function(str) {
    return str.split('?')[1] || '';
};
exports.parse = function(str) {
    if (typeof str !== 'string') return {};
    str = str.trim().replace(/^(\?|#|&)/, '');
    if (!str) return {};
    return str.split('&').reduce(function(ret, param) {
        var parts = param.replace(/\+/g, ' ').split('=');
        // Firefox (pre 40) decodes `%3D` to `=`
        // https://github.com/sindresorhus/query-string/pull/37
        var key = parts.shift();
        var val = parts.length > 0 ? parts.join('=') : undefined;
        key = decodeURIComponent(key);
        // missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        val = val === undefined ? null : decodeURIComponent(val);
        if (!ret.hasOwnProperty(key)) ret[key] = val;
        else if (Array.isArray(ret[key])) ret[key].push(val);
        else ret[key] = [
            ret[key],
            val
        ];
        return ret;
    }, {});
};
exports.stringify = function(obj) {
    return obj ? Object.keys(obj).sort().map(function(key) {
        var val = obj[key];
        if (val === undefined) return '';
        if (val === null) return key;
        if (Array.isArray(val)) return val.slice().sort().map(function(val2) {
            return strictUriEncode(key) + '=' + strictUriEncode(val2);
        }).join('&');
        return strictUriEncode(key) + '=' + strictUriEncode(val);
    }).filter(function(x) {
        return x.length > 0;
    }).join('&') : '';
};

},{"29e8409c085f4b23":"9k6OI"}],"9k6OI":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
};

},{}],"aTBSV":[function(require,module,exports,__globalThis) {
'use strict';
var auth = require("fa241f6dd6e917a");
var helpers = require("50b2261b0f384b09");
var SwaggerClient = require("d94123be253c46af");
var deprecationWrapper = function(url, options) {
    helpers.log('This is deprecated, use "new SwaggerClient" instead.');
    return new SwaggerClient(url, options);
};
/* Here for IE8 Support */ if (!Array.prototype.indexOf) Array.prototype.indexOf = function(obj, start) {
    for(var i = start || 0, j = this.length; i < j; i++){
        if (this[i] === obj) return i;
    }
    return -1;
};
/* Here for IE8 Support */ if (!String.prototype.trim) String.prototype.trim = function() {
    return this.replace(/^\s+|\s+$/g, '');
};
/* Here for node 10.x support */ if (!String.prototype.endsWith) String.prototype.endsWith = function(suffix) {
    return this.indexOf(suffix, this.length - suffix.length) !== -1;
};
module.exports = SwaggerClient;
SwaggerClient.ApiKeyAuthorization = auth.ApiKeyAuthorization;
SwaggerClient.PasswordAuthorization = auth.PasswordAuthorization;
SwaggerClient.CookieAuthorization = auth.CookieAuthorization;
SwaggerClient.SwaggerApi = deprecationWrapper;
SwaggerClient.SwaggerClient = deprecationWrapper;
SwaggerClient.SchemaMarkup = require("4faadaadff8f54b9");

},{"fa241f6dd6e917a":"euq2V","50b2261b0f384b09":"7AAzh","d94123be253c46af":"c38CO","4faadaadff8f54b9":"6Sl8F"}],"euq2V":[function(require,module,exports,__globalThis) {
'use strict';
var helpers = require("ede457e77eb53ec");
var btoa = require("164f312749a966de"); // jshint ignore:line
var CookieJar = require("73de08e561c5a7d5").CookieJar;
var _ = {
    each: require("d5f78f914934fb72"),
    includes: require("dfe8f2fab4d7f8f5"),
    isObject: require("457924651b1c20e7"),
    isArray: require("c5ec9653ebca6777")
};
/**
 * SwaggerAuthorizations applys the correct authorization to an operation being executed
 */ var SwaggerAuthorizations = module.exports.SwaggerAuthorizations = function(authz) {
    this.authz = authz || {};
};
/**
 * Add auths to the hash
 * Will overwrite any existing
 *
 */ SwaggerAuthorizations.prototype.add = function(name, auth) {
    if (_.isObject(name)) for(var key in name)this.authz[key] = name[key];
    else if (typeof name === 'string') this.authz[name] = auth;
    return auth;
};
SwaggerAuthorizations.prototype.remove = function(name) {
    return delete this.authz[name];
};
SwaggerAuthorizations.prototype.apply = function(obj, securities) {
    var status = true;
    var applyAll = !securities;
    var flattenedSecurities = [];
    // favor the object-level authorizations over global
    var authz = obj.clientAuthorizations || this.authz;
    // Securities could be [ {} ]
    _.each(securities, function(obj, key) {
        // Make sure we account for securities being [ str ]
        if (typeof key === 'string') flattenedSecurities.push(key);
        // Flatten keys in to our array
        _.each(obj, function(val, key) {
            flattenedSecurities.push(key);
        });
    });
    _.each(authz, function(auth, authName) {
        if (applyAll || _.includes(flattenedSecurities, authName)) {
            var newStatus = auth.apply(obj);
            status = status && !!newStatus; // logical ORs regarding status
        }
    });
    return status;
};
/**
 * ApiKeyAuthorization allows a query param or header to be injected
 */ var ApiKeyAuthorization = module.exports.ApiKeyAuthorization = function(name, value, type) {
    this.name = name;
    this.value = value;
    this.type = type;
};
ApiKeyAuthorization.prototype.apply = function(obj) {
    if (this.type === 'query') {
        // see if already applied.  If so, don't do it again
        var qp;
        if (obj.url.indexOf('?') > 0) {
            qp = obj.url.substring(obj.url.indexOf('?') + 1);
            var parts = qp.split('&');
            if (parts && parts.length > 0) for(var i = 0; i < parts.length; i++){
                var kv = parts[i].split('=');
                if (kv && kv.length > 0) {
                    if (kv[0] === this.name) // skip it
                    return false;
                }
            }
        }
        if (obj.url.indexOf('?') > 0) obj.url = obj.url + '&' + this.name + '=' + this.value;
        else obj.url = obj.url + '?' + this.name + '=' + this.value;
        return true;
    } else if (this.type === 'header') {
        if (typeof obj.headers[this.name] === 'undefined') obj.headers[this.name] = this.value;
        return true;
    }
};
var CookieAuthorization = module.exports.CookieAuthorization = function(cookie) {
    this.cookie = cookie;
};
CookieAuthorization.prototype.apply = function(obj) {
    obj.cookieJar = obj.cookieJar || new CookieJar();
    obj.cookieJar.setCookie(this.cookie);
    return true;
};
/**
 * Password Authorization is a basic auth implementation
 */ var PasswordAuthorization = module.exports.PasswordAuthorization = function(username, password) {
    if (arguments.length === 3) {
        helpers.log('PasswordAuthorization: the \'name\' argument has been removed, pass only username and password');
        username = arguments[1];
        password = arguments[2];
    }
    this.username = username;
    this.password = password;
};
PasswordAuthorization.prototype.apply = function(obj) {
    if (typeof obj.headers.Authorization === 'undefined') obj.headers.Authorization = 'Basic ' + btoa(this.username + ':' + this.password);
    return true;
};

},{"ede457e77eb53ec":"7AAzh","164f312749a966de":"cgZDa","73de08e561c5a7d5":"dB0DQ","d5f78f914934fb72":"lQkrF","dfe8f2fab4d7f8f5":"jx3PB","457924651b1c20e7":"2h87f","c5ec9653ebca6777":"42oZf"}],"7AAzh":[function(require,module,exports,__globalThis) {
'use strict';
var _ = {
    isPlainObject: require("d00b9e023dd94608"),
    indexOf: require("4182fe8de78d7b4a")
};
module.exports.__bind = function(fn, me) {
    return function() {
        return fn.apply(me, arguments);
    };
};
var log = module.exports.log = function() {
    // Only log if available and we're not testing
    if (console && true) console.log(Array.prototype.slice.call(arguments)[0]);
};
module.exports.fail = function(message) {
    log(message);
};
var optionHtml = module.exports.optionHtml = function(label, value) {
    return '<tr><td class="optionName">' + label + ':</td><td>' + value + '</td></tr>';
};
var resolveSchema = module.exports.resolveSchema = function(schema) {
    if (_.isPlainObject(schema.schema)) schema = resolveSchema(schema.schema);
    return schema;
};
var simpleRef = module.exports.simpleRef = function(name) {
    if (typeof name === 'undefined') return null;
    if (name.indexOf('#/definitions/') === 0) return name.substring(14);
    else return name;
};

},{"d00b9e023dd94608":"i4FFk","4182fe8de78d7b4a":"FlPsZ"}],"i4FFk":[function(require,module,exports,__globalThis) {
var baseForIn = require("332e8a8d87f364ea"), isArguments = require("30e6ae38c39b55c5"), isHostObject = require("d4c8eab01e651220"), isObjectLike = require("a8fac6b6afea3c40"), support = require("5f6a74beb74d960e");
/** `Object#toString` result references. */ var objectTag = '[object Object]';
/** Used for native method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var objToString = objectProto.toString;
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * **Note:** This method assumes objects created by the `Object` constructor
 * have no inherited enumerable properties.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    var Ctor;
    // Exit early for non `Object` objects.
    if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isHostObject(value) && !isArguments(value)) || !hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor))) return false;
    // IE < 9 iterates inherited properties before own properties. If the first
    // iterated property is an object's own property then there are no inherited
    // enumerable properties.
    var result;
    if (support.ownLast) {
        baseForIn(value, function(subValue, key, object) {
            result = hasOwnProperty.call(object, key);
            return false;
        });
        return result !== false;
    }
    // In most environments an object's own properties are iterated before
    // its inherited properties. If the last iterated property is an object's
    // own property then there are no inherited enumerable properties.
    baseForIn(value, function(subValue, key) {
        result = key;
    });
    return result === undefined || hasOwnProperty.call(value, result);
}
module.exports = isPlainObject;

},{"332e8a8d87f364ea":"1Adqi","30e6ae38c39b55c5":"jI8K5","d4c8eab01e651220":"8j3dt","a8fac6b6afea3c40":"wRUw9","5f6a74beb74d960e":"kG5My"}],"1Adqi":[function(require,module,exports,__globalThis) {
var baseFor = require("1cdeb00be1937d48"), keysIn = require("c404fe46baee00f3");
/**
 * The base implementation of `_.forIn` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForIn(object, iteratee) {
    return baseFor(object, iteratee, keysIn);
}
module.exports = baseForIn;

},{"1cdeb00be1937d48":"ib7Cj","c404fe46baee00f3":"aO8Vk"}],"ib7Cj":[function(require,module,exports,__globalThis) {
var createBaseFor = require("1998dd9306312df5");
/**
 * The base implementation of `baseForIn` and `baseForOwn` which iterates
 * over `object` properties returned by `keysFunc` invoking `iteratee` for
 * each property. Iteratee functions may exit iteration early by explicitly
 * returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
module.exports = baseFor;

},{"1998dd9306312df5":"8a3tc"}],"8a3tc":[function(require,module,exports,__globalThis) {
var toObject = require("add94caa497bea37");
/**
 * Creates a base function for `_.forIn` or `_.forInRight`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var iterable = toObject(object), props = keysFunc(object), length = props.length, index = fromRight ? length : -1;
        while(fromRight ? index-- : ++index < length){
            var key = props[index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = createBaseFor;

},{"add94caa497bea37":"3Gay2"}],"3Gay2":[function(require,module,exports,__globalThis) {
var isObject = require("99bcea2c6213fcba"), isString = require("36f0c3f534ed6930"), support = require("fa53aa2490647bd0");
/**
 * Converts `value` to an object if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Object} Returns the object.
 */ function toObject(value) {
    if (support.unindexedChars && isString(value)) {
        var index = -1, length = value.length, result = Object(value);
        while(++index < length)result[index] = value.charAt(index);
        return result;
    }
    return isObject(value) ? value : Object(value);
}
module.exports = toObject;

},{"99bcea2c6213fcba":"2h87f","36f0c3f534ed6930":"eSX4L","fa53aa2490647bd0":"kG5My"}],"2h87f":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */ function isObject(value) {
    // Avoid a V8 JIT bug in Chrome 19-20.
    // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
module.exports = isObject;

},{}],"eSX4L":[function(require,module,exports,__globalThis) {
var isObjectLike = require("4e4305de4c17ed83");
/** `Object#toString` result references. */ var stringTag = '[object String]';
/** Used for native method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var objToString = objectProto.toString;
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function isString(value) {
    return typeof value == 'string' || isObjectLike(value) && objToString.call(value) == stringTag;
}
module.exports = isString;

},{"4e4305de4c17ed83":"wRUw9"}],"wRUw9":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
module.exports = isObjectLike;

},{}],"kG5My":[function(require,module,exports,__globalThis) {
/** Used for native method references. */ var arrayProto = Array.prototype, errorProto = Error.prototype, objectProto = Object.prototype;
/** Native method references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/**
 * An object environment feature flags.
 *
 * @static
 * @memberOf _
 * @type Object
 */ var support = {};
(function(x) {
    var Ctor = function() {
        this.x = x;
    }, object = {
        '0': x,
        'length': x
    }, props = [];
    Ctor.prototype = {
        'valueOf': x,
        'y': x
    };
    for(var key in new Ctor)props.push(key);
    /**
   * Detect if `name` or `message` properties of `Error.prototype` are
   * enumerable by default (IE < 9, Safari < 5.1).
   *
   * @memberOf _.support
   * @type boolean
   */ support.enumErrorProps = propertyIsEnumerable.call(errorProto, 'message') || propertyIsEnumerable.call(errorProto, 'name');
    /**
   * Detect if `prototype` properties are enumerable by default.
   *
   * Firefox < 3.6, Opera > 9.50 - Opera < 11.60, and Safari < 5.1
   * (if the prototype or a property on the prototype has been set)
   * incorrectly set the `[[Enumerable]]` value of a function's `prototype`
   * property to `true`.
   *
   * @memberOf _.support
   * @type boolean
   */ support.enumPrototypes = propertyIsEnumerable.call(Ctor, 'prototype');
    /**
   * Detect if properties shadowing those on `Object.prototype` are non-enumerable.
   *
   * In IE < 9 an object's own properties, shadowing non-enumerable ones,
   * are made non-enumerable as well (a.k.a the JScript `[[DontEnum]]` bug).
   *
   * @memberOf _.support
   * @type boolean
   */ support.nonEnumShadows = !/valueOf/.test(props);
    /**
   * Detect if own properties are iterated after inherited properties (IE < 9).
   *
   * @memberOf _.support
   * @type boolean
   */ support.ownLast = props[0] != 'x';
    /**
   * Detect if `Array#shift` and `Array#splice` augment array-like objects
   * correctly.
   *
   * Firefox < 10, compatibility modes of IE 8, and IE < 9 have buggy Array
   * `shift()` and `splice()` functions that fail to remove the last element,
   * `value[0]`, of array-like objects even though the "length" property is
   * set to `0`. The `shift()` method is buggy in compatibility modes of IE 8,
   * while `splice()` is buggy regardless of mode in IE < 9.
   *
   * @memberOf _.support
   * @type boolean
   */ support.spliceObjects = (splice.call(object, 0, 1), !object[0]);
    /**
   * Detect lack of support for accessing string characters by index.
   *
   * IE < 8 can't access characters by index. IE 8 can only access characters
   * by index on string literals, not string objects.
   *
   * @memberOf _.support
   * @type boolean
   */ support.unindexedChars = "x" + Object('x')[0] != 'xx';
})(1, 0);
module.exports = support;

},{}],"aO8Vk":[function(require,module,exports,__globalThis) {
var arrayEach = require("cba6af53c6beada0"), isArguments = require("d6c0cf022c2f85f"), isArray = require("49050377632f94fc"), isFunction = require("ad8c61883b3c9db"), isIndex = require("9eae2b82fcb19c3a"), isLength = require("c060dde9986fafd0"), isObject = require("44fa925044eb1bbb"), isString = require("b67327acfb2460b"), support = require("f77c4002b5b8fd71");
/** `Object#toString` result references. */ var arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', stringTag = '[object String]';
/** Used to fix the JScript `[[DontEnum]]` bug. */ var shadowProps = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];
/** Used for native method references. */ var errorProto = Error.prototype, objectProto = Object.prototype, stringProto = String.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var objToString = objectProto.toString;
/** Used to avoid iterating over non-enumerable properties in IE < 9. */ var nonEnumProps = {};
nonEnumProps[arrayTag] = nonEnumProps[dateTag] = nonEnumProps[numberTag] = {
    'constructor': true,
    'toLocaleString': true,
    'toString': true,
    'valueOf': true
};
nonEnumProps[boolTag] = nonEnumProps[stringTag] = {
    'constructor': true,
    'toString': true,
    'valueOf': true
};
nonEnumProps[errorTag] = nonEnumProps[funcTag] = nonEnumProps[regexpTag] = {
    'constructor': true,
    'toString': true
};
nonEnumProps[objectTag] = {
    'constructor': true
};
arrayEach(shadowProps, function(key) {
    for(var tag in nonEnumProps)if (hasOwnProperty.call(nonEnumProps, tag)) {
        var props = nonEnumProps[tag];
        props[key] = hasOwnProperty.call(props, key);
    }
});
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    if (object == null) return [];
    if (!isObject(object)) object = Object(object);
    var length = object.length;
    length = length && isLength(length) && (isArray(object) || isArguments(object) || isString(object)) && length || 0;
    var Ctor = object.constructor, index = -1, proto = isFunction(Ctor) && Ctor.prototype || objectProto, isProto = proto === object, result = Array(length), skipIndexes = length > 0, skipErrorProps = support.enumErrorProps && (object === errorProto || object instanceof Error), skipProto = support.enumPrototypes && isFunction(object);
    while(++index < length)result[index] = index + '';
    // lodash skips the `constructor` property when it infers it's iterating
    // over a `prototype` object because IE < 9 can't set the `[[Enumerable]]`
    // attribute of an existing property and the `constructor` property of a
    // prototype defaults to non-enumerable.
    for(var key in object)if (!(skipProto && key == 'prototype') && !(skipErrorProps && (key == 'message' || key == 'name')) && !(skipIndexes && isIndex(key, length)) && !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    if (support.nonEnumShadows && object !== objectProto) {
        var tag = object === stringProto ? stringTag : object === errorProto ? errorTag : objToString.call(object), nonEnums = nonEnumProps[tag] || nonEnumProps[objectTag];
        if (tag == objectTag) proto = objectProto;
        length = shadowProps.length;
        while(length--){
            key = shadowProps[length];
            var nonEnum = nonEnums[key];
            if (!(isProto && nonEnum) && (nonEnum ? hasOwnProperty.call(object, key) : object[key] !== proto[key])) result.push(key);
        }
    }
    return result;
}
module.exports = keysIn;

},{"cba6af53c6beada0":"4rk8p","d6c0cf022c2f85f":"jI8K5","49050377632f94fc":"42oZf","ad8c61883b3c9db":"fTvdo","9eae2b82fcb19c3a":"eagib","c060dde9986fafd0":"j1Pbs","44fa925044eb1bbb":"2h87f","b67327acfb2460b":"eSX4L","f77c4002b5b8fd71":"kG5My"}],"4rk8p":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.forEach` for arrays without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = arrayEach;

},{}],"jI8K5":[function(require,module,exports,__globalThis) {
var isArrayLike = require("c39b5918beb6be67"), isObjectLike = require("dbf66c1b731769f4");
/** Used for native method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Native method references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is classified as an `arguments` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    return isObjectLike(value) && isArrayLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
}
module.exports = isArguments;

},{"c39b5918beb6be67":"lXCsV","dbf66c1b731769f4":"wRUw9"}],"lXCsV":[function(require,module,exports,__globalThis) {
var getLength = require("546948d3dc7b93bd"), isLength = require("acf32a709ecf5bc9");
/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */ function isArrayLike(value) {
    return value != null && isLength(getLength(value));
}
module.exports = isArrayLike;

},{"546948d3dc7b93bd":"gAsco","acf32a709ecf5bc9":"j1Pbs"}],"gAsco":[function(require,module,exports,__globalThis) {
var baseProperty = require("811e829cacd4fee0");
/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */ var getLength = baseProperty('length');
module.exports = getLength;

},{"811e829cacd4fee0":"deK74"}],"deK74":[function(require,module,exports,__globalThis) {
var toObject = require("10962e4605e3f84e");
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : toObject(object)[key];
    };
}
module.exports = baseProperty;

},{"10962e4605e3f84e":"3Gay2"}],"j1Pbs":[function(require,module,exports,__globalThis) {
/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"42oZf":[function(require,module,exports,__globalThis) {
var getNative = require("e5c98de899efbf57"), isLength = require("122950e14fd2711"), isObjectLike = require("9c3b948581357a47");
/** `Object#toString` result references. */ var arrayTag = '[object Array]';
/** Used for native method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var objToString = objectProto.toString;
/* Native method references for those with the same name as other `lodash` methods. */ var nativeIsArray = getNative(Array, 'isArray');
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(function() { return arguments; }());
 * // => false
 */ var isArray = nativeIsArray || function(value) {
    return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
};
module.exports = isArray;

},{"e5c98de899efbf57":"65o1m","122950e14fd2711":"j1Pbs","9c3b948581357a47":"wRUw9"}],"65o1m":[function(require,module,exports,__globalThis) {
var isNative = require("59e4ff3645d25738");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = object == null ? undefined : object[key];
    return isNative(value) ? value : undefined;
}
module.exports = getNative;

},{"59e4ff3645d25738":"jmWEU"}],"jmWEU":[function(require,module,exports,__globalThis) {
var isFunction = require("4960b328815d3607"), isHostObject = require("de587ba2c3ee7574"), isObjectLike = require("92344fbe3131702f");
/** Used to detect host constructors (Safari > 5). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for native method references. */ var objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var fnToString = Function.prototype.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */ function isNative(value) {
    if (value == null) return false;
    if (isFunction(value)) return reIsNative.test(fnToString.call(value));
    return isObjectLike(value) && (isHostObject(value) ? reIsNative : reIsHostCtor).test(value);
}
module.exports = isNative;

},{"4960b328815d3607":"fTvdo","de587ba2c3ee7574":"8j3dt","92344fbe3131702f":"wRUw9"}],"fTvdo":[function(require,module,exports,__globalThis) {
var isObject = require("5061e3412c42a8f1");
/** `Object#toString` result references. */ var funcTag = '[object Function]';
/** Used for native method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var objToString = objectProto.toString;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in older versions of Chrome and Safari which return 'function' for regexes
    // and Safari 8 which returns 'object' for typed array constructors.
    return isObject(value) && objToString.call(value) == funcTag;
}
module.exports = isFunction;

},{"5061e3412c42a8f1":"2h87f"}],"8j3dt":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ var isHostObject = function() {
    try {
        Object({
            'toString': 0
        } + '');
    } catch (e) {
        return function() {
            return false;
        };
    }
    return function(value) {
        // IE < 9 presents many host objects as `Object` objects that can coerce
        // to strings despite having improperly defined `toString` methods.
        return typeof value.toString != 'function' && typeof (value + '') == 'string';
    };
}();
module.exports = isHostObject;

},{}],"eagib":[function(require,module,exports,__globalThis) {
/** Used to detect unsigned integer values. */ var reIsUint = /^\d+$/;
/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    value = typeof value == 'number' || reIsUint.test(value) ? +value : -1;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{}],"FlPsZ":[function(require,module,exports,__globalThis) {
var baseIndexOf = require("fb96ffe2819b0b2c"), binaryIndex = require("aa6f05e527d75b93");
/* Native method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * Gets the index at which the first occurrence of `value` is found in `array`
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * for equality comparisons. If `fromIndex` is negative, it's used as the offset
 * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
 * performs a faster binary search.
 *
 * @static
 * @memberOf _
 * @category Array
 * @param {Array} array The array to search.
 * @param {*} value The value to search for.
 * @param {boolean|number} [fromIndex=0] The index to search from or `true`
 *  to perform a binary search on a sorted array.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.indexOf([1, 2, 1, 2], 2);
 * // => 1
 *
 * // using `fromIndex`
 * _.indexOf([1, 2, 1, 2], 2, 2);
 * // => 3
 *
 * // performing a binary search
 * _.indexOf([1, 1, 2, 2], 2, true);
 * // => 2
 */ function indexOf(array, value, fromIndex) {
    var length = array ? array.length : 0;
    if (!length) return -1;
    if (typeof fromIndex == 'number') fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
    else if (fromIndex) {
        var index = binaryIndex(array, value);
        if (index < length && (value === value ? value === array[index] : array[index] !== array[index])) return index;
        return -1;
    }
    return baseIndexOf(array, value, fromIndex || 0);
}
module.exports = indexOf;

},{"fb96ffe2819b0b2c":"0twlP","aa6f05e527d75b93":"3uaEB"}],"0twlP":[function(require,module,exports,__globalThis) {
var indexOfNaN = require("c1e0807b312197e0");
/**
 * The base implementation of `_.indexOf` without support for binary searches.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseIndexOf(array, value, fromIndex) {
    if (value !== value) return indexOfNaN(array, fromIndex);
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = baseIndexOf;

},{"c1e0807b312197e0":"4jVC8"}],"4jVC8":[function(require,module,exports,__globalThis) {
/**
 * Gets the index at which the first occurrence of `NaN` is found in `array`.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched `NaN`, else `-1`.
 */ function indexOfNaN(array, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 0 : -1);
    while(fromRight ? index-- : ++index < length){
        var other = array[index];
        if (other !== other) return index;
    }
    return -1;
}
module.exports = indexOfNaN;

},{}],"3uaEB":[function(require,module,exports,__globalThis) {
var binaryIndexBy = require("388e9fbeb955295f"), identity = require("3526849835cc87ea");
/** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
/**
 * Performs a binary search of `array` to determine the index at which `value`
 * should be inserted into `array` in order to maintain its sort order.
 *
 * @private
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {boolean} [retHighest] Specify returning the highest qualified index.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 */ function binaryIndex(array, value, retHighest) {
    var low = 0, high = array ? array.length : low;
    if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while(low < high){
            var mid = low + high >>> 1, computed = array[mid];
            if ((retHighest ? computed <= value : computed < value) && computed !== null) low = mid + 1;
            else high = mid;
        }
        return high;
    }
    return binaryIndexBy(array, value, identity, retHighest);
}
module.exports = binaryIndex;

},{"388e9fbeb955295f":"98Cad","3526849835cc87ea":"hrnuZ"}],"98Cad":[function(require,module,exports,__globalThis) {
/* Native method references for those with the same name as other `lodash` methods. */ var nativeFloor = Math.floor, nativeMin = Math.min;
/** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1;
/**
 * This function is like `binaryIndex` except that it invokes `iteratee` for
 * `value` and each element of `array` to compute their sort ranking. The
 * iteratee is invoked with one argument; (value).
 *
 * @private
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {boolean} [retHighest] Specify returning the highest qualified index.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 */ function binaryIndexBy(array, value, iteratee, retHighest) {
    value = iteratee(value);
    var low = 0, high = array ? array.length : 0, valIsNaN = value !== value, valIsNull = value === null, valIsUndef = value === undefined;
    while(low < high){
        var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), isDef = computed !== undefined, isReflexive = computed === computed;
        if (valIsNaN) var setLow = isReflexive || retHighest;
        else if (valIsNull) setLow = isReflexive && isDef && (retHighest || computed != null);
        else if (valIsUndef) setLow = isReflexive && (retHighest || isDef);
        else if (computed == null) setLow = false;
        else setLow = retHighest ? computed <= value : computed < value;
        if (setLow) low = mid + 1;
        else high = mid;
    }
    return nativeMin(high, MAX_ARRAY_INDEX);
}
module.exports = binaryIndexBy;

},{}],"hrnuZ":[function(require,module,exports,__globalThis) {
/**
 * This method returns the first argument provided to it.
 *
 * @static
 * @memberOf _
 * @category Utility
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.identity(object) === object;
 * // => true
 */ function identity(value) {
    return value;
}
module.exports = identity;

},{}],"cgZDa":[function(require,module,exports,__globalThis) {
var Buffer = require("fe6f303321d3398b").Buffer;
(function() {
    "use strict";
    function btoa(str) {
        var buffer;
        if (str instanceof Buffer) buffer = str;
        else buffer = Buffer.from(str.toString(), 'binary');
        return buffer.toString('base64');
    }
    module.exports = btoa;
})();

},{"fe6f303321d3398b":"cjdyz"}],"dB0DQ":[function(require,module,exports,__globalThis) {
/* jshint node: true */ (function() {
    "use strict";
    function CookieAccessInfo(domain, path, secure, script) {
        if (this instanceof CookieAccessInfo) {
            this.domain = domain || undefined;
            this.path = path || "/";
            this.secure = !!secure;
            this.script = !!script;
            return this;
        }
        return new CookieAccessInfo(domain, path, secure, script);
    }
    CookieAccessInfo.All = Object.freeze(Object.create(null));
    exports.CookieAccessInfo = CookieAccessInfo;
    function Cookie(cookiestr, request_domain, request_path) {
        if (cookiestr instanceof Cookie) return cookiestr;
        if (this instanceof Cookie) {
            this.name = null;
            this.value = null;
            this.expiration_date = Infinity;
            this.path = String(request_path || "/");
            this.explicit_path = false;
            this.domain = request_domain || null;
            this.explicit_domain = false;
            this.secure = false; //how to define default?
            this.noscript = false; //httponly
            if (cookiestr) this.parse(cookiestr, request_domain, request_path);
            return this;
        }
        return new Cookie(cookiestr, request_domain, request_path);
    }
    exports.Cookie = Cookie;
    Cookie.prototype.toString = function toString() {
        var str = [
            this.name + "=" + this.value
        ];
        if (this.expiration_date !== Infinity) str.push("expires=" + new Date(this.expiration_date).toGMTString());
        if (this.domain) str.push("domain=" + this.domain);
        if (this.path) str.push("path=" + this.path);
        if (this.secure) str.push("secure");
        if (this.noscript) str.push("httponly");
        return str.join("; ");
    };
    Cookie.prototype.toValueString = function toValueString() {
        return this.name + "=" + this.value;
    };
    var cookie_str_splitter = /[:](?=\s*[a-zA-Z0-9_\-]+\s*[=])/g;
    Cookie.prototype.parse = function parse(str, request_domain, request_path) {
        if (this instanceof Cookie) {
            if (str.length > 32768) {
                console.warn("Cookie too long for parsing (>32768 characters)");
                return;
            }
            var parts = str.split(";").filter(function(value) {
                return !!value;
            });
            var i;
            var pair = parts[0].match(/([^=]+)=([\s\S]*)/);
            if (!pair) {
                console.warn("Invalid cookie header encountered. Header: '" + str + "'");
                return;
            }
            var key = pair[1];
            var value = pair[2];
            if (typeof key !== 'string' || key.length === 0 || typeof value !== 'string') {
                console.warn("Unable to extract values from cookie header. Cookie: '" + str + "'");
                return;
            }
            this.name = key;
            this.value = value;
            for(i = 1; i < parts.length; i += 1){
                pair = parts[i].match(/([^=]+)(?:=([\s\S]*))?/);
                key = pair[1].trim().toLowerCase();
                value = pair[2];
                switch(key){
                    case "httponly":
                        this.noscript = true;
                        break;
                    case "expires":
                        this.expiration_date = value ? Number(Date.parse(value)) : Infinity;
                        break;
                    case "path":
                        this.path = value ? value.trim() : "";
                        this.explicit_path = true;
                        break;
                    case "domain":
                        this.domain = value ? value.trim() : "";
                        this.explicit_domain = !!this.domain;
                        break;
                    case "secure":
                        this.secure = true;
                        break;
                }
            }
            if (!this.explicit_path) this.path = request_path || "/";
            if (!this.explicit_domain) this.domain = request_domain;
            return this;
        }
        return new Cookie().parse(str, request_domain, request_path);
    };
    Cookie.prototype.matches = function matches(access_info) {
        if (access_info === CookieAccessInfo.All) return true;
        if (this.noscript && access_info.script || this.secure && !access_info.secure || !this.collidesWith(access_info)) return false;
        return true;
    };
    Cookie.prototype.collidesWith = function collidesWith(access_info) {
        if (this.path && !access_info.path || this.domain && !access_info.domain) return false;
        if (this.path && access_info.path.indexOf(this.path) !== 0) return false;
        if (this.explicit_path && access_info.path.indexOf(this.path) !== 0) return false;
        var access_domain = access_info.domain && access_info.domain.replace(/^[\.]/, '');
        var cookie_domain = this.domain && this.domain.replace(/^[\.]/, '');
        if (cookie_domain === access_domain) return true;
        if (cookie_domain) {
            if (!this.explicit_domain) return false; // we already checked if the domains were exactly the same
            var wildcard = access_domain.indexOf(cookie_domain);
            if (wildcard === -1 || wildcard !== access_domain.length - cookie_domain.length) return false;
            return true;
        }
        return true;
    };
    function CookieJar() {
        var cookies, cookies_list, collidable_cookie;
        if (this instanceof CookieJar) {
            cookies = Object.create(null); //name: [Cookie]
            this.setCookie = function setCookie(cookie, request_domain, request_path) {
                var remove, i;
                cookie = new Cookie(cookie, request_domain, request_path);
                //Delete the cookie if the set is past the current time
                remove = cookie.expiration_date <= Date.now();
                if (cookies[cookie.name] !== undefined) {
                    cookies_list = cookies[cookie.name];
                    for(i = 0; i < cookies_list.length; i += 1){
                        collidable_cookie = cookies_list[i];
                        if (collidable_cookie.collidesWith(cookie)) {
                            if (remove) {
                                cookies_list.splice(i, 1);
                                if (cookies_list.length === 0) delete cookies[cookie.name];
                                return false;
                            }
                            cookies_list[i] = cookie;
                            return cookie;
                        }
                    }
                    if (remove) return false;
                    cookies_list.push(cookie);
                    return cookie;
                }
                if (remove) return false;
                cookies[cookie.name] = [
                    cookie
                ];
                return cookies[cookie.name];
            };
            //returns a cookie
            this.getCookie = function getCookie(cookie_name, access_info) {
                var cookie, i;
                cookies_list = cookies[cookie_name];
                if (!cookies_list) return;
                for(i = 0; i < cookies_list.length; i += 1){
                    cookie = cookies_list[i];
                    if (cookie.expiration_date <= Date.now()) {
                        if (cookies_list.length === 0) delete cookies[cookie.name];
                        continue;
                    }
                    if (cookie.matches(access_info)) return cookie;
                }
            };
            //returns a list of cookies
            this.getCookies = function getCookies(access_info) {
                var matches = [], cookie_name, cookie;
                for(cookie_name in cookies){
                    cookie = this.getCookie(cookie_name, access_info);
                    if (cookie) matches.push(cookie);
                }
                matches.toString = function toString() {
                    return matches.join(":");
                };
                matches.toValueString = function toValueString() {
                    return matches.map(function(c) {
                        return c.toValueString();
                    }).join('; ');
                };
                return matches;
            };
            return this;
        }
        return new CookieJar();
    }
    exports.CookieJar = CookieJar;
    //returns list of cookies that were set correctly. Cookies that are expired and removed are not returned.
    CookieJar.prototype.setCookies = function setCookies(cookies, request_domain, request_path) {
        cookies = Array.isArray(cookies) ? cookies : cookies.split(cookie_str_splitter);
        var successful = [], i, cookie;
        cookies = cookies.map(function(item) {
            return new Cookie(item, request_domain, request_path);
        });
        for(i = 0; i < cookies.length; i += 1){
            cookie = cookies[i];
            if (this.setCookie(cookie, request_domain, request_path)) successful.push(cookie);
        }
        return successful;
    };
})();

},{}],"lQkrF":[function(require,module,exports,__globalThis) {
module.exports = require("11034c2fc11f611e");

},{"11034c2fc11f611e":"9dHGp"}],"9dHGp":[function(require,module,exports,__globalThis) {
var arrayEach = require("7303a323c9ec4bd4"), baseEach = require("a0bf94f17722d3af"), createForEach = require("8ded608df371c30d");
/**
 * Iterates over elements of `collection` invoking `iteratee` for each element.
 * The `iteratee` is bound to `thisArg` and invoked with three arguments:
 * (value, index|key, collection). Iteratee functions may exit iteration early
 * by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length" property
 * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
 * may be used for object iteration.
 *
 * @static
 * @memberOf _
 * @alias each
 * @category Collection
 * @param {Array|Object|string} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [thisArg] The `this` binding of `iteratee`.
 * @returns {Array|Object|string} Returns `collection`.
 * @example
 *
 * _([1, 2]).forEach(function(n) {
 *   console.log(n);
 * }).value();
 * // => logs each value from left to right and returns the array
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
 *   console.log(n, key);
 * });
 * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
 */ var forEach = createForEach(arrayEach, baseEach);
module.exports = forEach;

},{"7303a323c9ec4bd4":"4rk8p","a0bf94f17722d3af":"lyAU9","8ded608df371c30d":"8YFpC"}],"lyAU9":[function(require,module,exports,__globalThis) {
var baseForOwn = require("3bee75a01f23877e"), createBaseEach = require("27b3cb6798ba4aa6");
/**
 * The base implementation of `_.forEach` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Array|Object|string} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object|string} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
module.exports = baseEach;

},{"3bee75a01f23877e":"dhaBE","27b3cb6798ba4aa6":"aATGB"}],"dhaBE":[function(require,module,exports,__globalThis) {
var baseFor = require("277df033ebd94a8"), keys = require("be7092de6304fef3");
/**
 * The base implementation of `_.forOwn` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return baseFor(object, iteratee, keys);
}
module.exports = baseForOwn;

},{"277df033ebd94a8":"ib7Cj","be7092de6304fef3":"dWOkG"}],"dWOkG":[function(require,module,exports,__globalThis) {
var getNative = require("56037532cd3d94d"), isArrayLike = require("a819067a29647663"), isObject = require("9abaa29bb09e7a94"), shimKeys = require("ae5d1912374f080f"), support = require("3eda13f0b33b8cc2");
/* Native method references for those with the same name as other `lodash` methods. */ var nativeKeys = getNative(Object, 'keys');
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ var keys = !nativeKeys ? shimKeys : function(object) {
    var Ctor = object == null ? undefined : object.constructor;
    if (typeof Ctor == 'function' && Ctor.prototype === object || (typeof object == 'function' ? support.enumPrototypes : isArrayLike(object))) return shimKeys(object);
    return isObject(object) ? nativeKeys(object) : [];
};
module.exports = keys;

},{"56037532cd3d94d":"65o1m","a819067a29647663":"lXCsV","9abaa29bb09e7a94":"2h87f","ae5d1912374f080f":"5IuFM","3eda13f0b33b8cc2":"kG5My"}],"5IuFM":[function(require,module,exports,__globalThis) {
var isArguments = require("1547122cebc5d319"), isArray = require("398e01068e30aaa4"), isIndex = require("6988b1d6b01af052"), isLength = require("3ae3cb5565279a2e"), isString = require("3988d235f494eb6e"), keysIn = require("e9eeeaee8aa1319d");
/** Used for native method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A fallback implementation of `Object.keys` which creates an array of the
 * own enumerable property names of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function shimKeys(object) {
    var props = keysIn(object), propsLength = props.length, length = propsLength && object.length;
    var allowIndexes = !!length && isLength(length) && (isArray(object) || isArguments(object) || isString(object));
    var index = -1, result = [];
    while(++index < propsLength){
        var key = props[index];
        if (allowIndexes && isIndex(key, length) || hasOwnProperty.call(object, key)) result.push(key);
    }
    return result;
}
module.exports = shimKeys;

},{"1547122cebc5d319":"jI8K5","398e01068e30aaa4":"42oZf","6988b1d6b01af052":"eagib","3ae3cb5565279a2e":"j1Pbs","3988d235f494eb6e":"eSX4L","e9eeeaee8aa1319d":"aO8Vk"}],"aATGB":[function(require,module,exports,__globalThis) {
var getLength = require("2ee680cb256744db"), isLength = require("a056e827451fb78a"), toObject = require("962728ca2d614112");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        var length = collection ? getLength(collection) : 0;
        if (!isLength(length)) return eachFunc(collection, iteratee);
        var index = fromRight ? length : -1, iterable = toObject(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = createBaseEach;

},{"2ee680cb256744db":"gAsco","a056e827451fb78a":"j1Pbs","962728ca2d614112":"3Gay2"}],"8YFpC":[function(require,module,exports,__globalThis) {
var bindCallback = require("b2c4fe9ddf6f2f24"), isArray = require("6402f3ce911243a5");
/**
 * Creates a function for `_.forEach` or `_.forEachRight`.
 *
 * @private
 * @param {Function} arrayFunc The function to iterate over an array.
 * @param {Function} eachFunc The function to iterate over a collection.
 * @returns {Function} Returns the new each function.
 */ function createForEach(arrayFunc, eachFunc) {
    return function(collection, iteratee, thisArg) {
        return typeof iteratee == 'function' && thisArg === undefined && isArray(collection) ? arrayFunc(collection, iteratee) : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
    };
}
module.exports = createForEach;

},{"b2c4fe9ddf6f2f24":"3iDHf","6402f3ce911243a5":"42oZf"}],"3iDHf":[function(require,module,exports,__globalThis) {
var identity = require("d1121f5762fc654");
/**
 * A specialized version of `baseCallback` which only supports `this` binding
 * and specifying the number of arguments to provide to `func`.
 *
 * @private
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {number} [argCount] The number of arguments to provide to `func`.
 * @returns {Function} Returns the callback.
 */ function bindCallback(func, thisArg, argCount) {
    if (typeof func != 'function') return identity;
    if (thisArg === undefined) return func;
    switch(argCount){
        case 1:
            return function(value) {
                return func.call(thisArg, value);
            };
        case 3:
            return function(value, index, collection) {
                return func.call(thisArg, value, index, collection);
            };
        case 4:
            return function(accumulator, value, index, collection) {
                return func.call(thisArg, accumulator, value, index, collection);
            };
        case 5:
            return function(value, other, key, object, source) {
                return func.call(thisArg, value, other, key, object, source);
            };
    }
    return function() {
        return func.apply(thisArg, arguments);
    };
}
module.exports = bindCallback;

},{"d1121f5762fc654":"hrnuZ"}],"jx3PB":[function(require,module,exports,__globalThis) {
var baseIndexOf = require("a3b01e942dfab2e1"), getLength = require("857813b46e993178"), isArray = require("c3648cd96e4e3c87"), isIterateeCall = require("72110215ce678ea8"), isLength = require("dee16ecfff6c0361"), isString = require("e004ca1f94b6d9a2"), values = require("687a78a36f689b39");
/* Native method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * Checks if `target` is in `collection` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * for equality comparisons. If `fromIndex` is negative, it's used as the offset
 * from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @alias contains, include
 * @category Collection
 * @param {Array|Object|string} collection The collection to search.
 * @param {*} target The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
 * @returns {boolean} Returns `true` if a matching element is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
 * // => true
 *
 * _.includes('pebbles', 'eb');
 * // => true
 */ function includes(collection, target, fromIndex, guard) {
    var length = collection ? getLength(collection) : 0;
    if (!isLength(length)) {
        collection = values(collection);
        length = collection.length;
    }
    if (typeof fromIndex != 'number' || guard && isIterateeCall(target, fromIndex, guard)) fromIndex = 0;
    else fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex || 0;
    return typeof collection == 'string' || !isArray(collection) && isString(collection) ? fromIndex <= length && collection.indexOf(target, fromIndex) > -1 : !!length && baseIndexOf(collection, target, fromIndex) > -1;
}
module.exports = includes;

},{"a3b01e942dfab2e1":"0twlP","857813b46e993178":"gAsco","c3648cd96e4e3c87":"42oZf","72110215ce678ea8":"fokFX","dee16ecfff6c0361":"j1Pbs","e004ca1f94b6d9a2":"eSX4L","687a78a36f689b39":"2k9gG"}],"fokFX":[function(require,module,exports,__globalThis) {
var isArrayLike = require("8cc0583cd7c7245b"), isIndex = require("d1ab62f6c8e33314"), isObject = require("9c7264fa5194afac");
/**
 * Checks if the provided arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
        var other = object[index];
        return value === value ? value === other : other !== other;
    }
    return false;
}
module.exports = isIterateeCall;

},{"8cc0583cd7c7245b":"lXCsV","d1ab62f6c8e33314":"eagib","9c7264fa5194afac":"2h87f"}],"2k9gG":[function(require,module,exports,__globalThis) {
var baseValues = require("b6360907e35c083a"), keys = require("80eb2ea3914169d1");
/**
 * Creates an array of the own enumerable property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function values(object) {
    return baseValues(object, keys(object));
}
module.exports = values;

},{"b6360907e35c083a":"8kxbF","80eb2ea3914169d1":"dWOkG"}],"8kxbF":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function baseValues(object, props) {
    var index = -1, length = props.length, result = Array(length);
    while(++index < length)result[index] = object[props[index]];
    return result;
}
module.exports = baseValues;

},{}],"c38CO":[function(require,module,exports,__globalThis) {
'use strict';
var _ = {
    bind: require("33c34d78b69aad99"),
    cloneDeep: require("f0f2139fde238d"),
    find: require("e508a73a1b8c356d"),
    forEach: require("bfa9eb57c396698"),
    indexOf: require("271e052018994d38"),
    isArray: require("7a369d4a43412e88"),
    isObject: require("32bbf81f199f1b54"),
    isFunction: require("3e93f250d8798118"),
    isPlainObject: require("c7e95eeb0a132564"),
    isUndefined: require("11fa9b2a21129504")
};
var auth = require("b684271afa89b5d3");
var helpers = require("f30014955259a2d0");
var Model = require("62ce23b20e85689");
var Operation = require("ae1ba031ee67c0f");
var OperationGroup = require("805ab5a46bc2ec13");
var Resolver = require("1d5cbc4f4b63e901");
var SwaggerHttp = require("a1a69a7060309ba3");
var SwaggerSpecConverter = require("9702b559f9fbe89c");
var Q = require("86e5fe1638661be7");
// We have to keep track of the function/property names to avoid collisions for tag names which are used to allow the
// following usage: 'client.{tagName}'
var reservedClientTags = [
    'apis',
    'authorizationScheme',
    'authorizations',
    'basePath',
    'build',
    'buildFrom1_1Spec',
    'buildFrom1_2Spec',
    'buildFromSpec',
    'clientAuthorizations',
    'convertInfo',
    'debug',
    'defaultErrorCallback',
    'defaultSuccessCallback',
    'enableCookies',
    'fail',
    'failure',
    'finish',
    'help',
    'host',
    'idFromOp',
    'info',
    'initialize',
    'isBuilt',
    'isValid',
    'modelPropertyMacro',
    'models',
    'modelsArray',
    'options',
    'parameterMacro',
    'parseUri',
    'progress',
    'resourceCount',
    'sampleModels',
    'selfReflect',
    'setConsolidatedModels',
    'spec',
    'supportedSubmitMethods',
    'swaggerRequestHeaders',
    'tagFromLabel',
    'title',
    'url',
    'useJQuery',
    'jqueryAjaxCache'
];
// We have to keep track of the function/property names to avoid collisions for tag names which are used to allow the
// following usage: 'client.apis.{tagName}'
var reservedApiTags = [
    'apis',
    'asCurl',
    'description',
    'externalDocs',
    'help',
    'label',
    'name',
    'operation',
    'operations',
    'operationsArray',
    'path',
    'tag'
];
var supportedOperationMethods = [
    'delete',
    'get',
    'head',
    'options',
    'patch',
    'post',
    'put'
];
var SwaggerClient = module.exports = function(url, options) {
    this.authorizations = null;
    this.authorizationScheme = null;
    this.basePath = null;
    this.debug = false;
    this.enableCookies = false;
    this.info = null;
    this.isBuilt = false;
    this.isValid = false;
    this.modelsArray = [];
    this.resourceCount = 0;
    this.url = null;
    this.useJQuery = false;
    this.jqueryAjaxCache = false;
    this.swaggerObject = {};
    this.deferredClient = undefined;
    this.clientAuthorizations = new auth.SwaggerAuthorizations();
    if (typeof url !== 'undefined') return this.initialize(url, options);
    else return this;
};
SwaggerClient.prototype.initialize = function(url, options) {
    this.models = {};
    this.sampleModels = {};
    if (typeof url === 'string') this.url = url;
    else if (_.isObject(url)) {
        options = url;
        this.url = options.url;
    }
    if (this.url && this.url.indexOf('http:') === -1 && this.url.indexOf('https:') === -1) // no protocol, so we can only use window if it exists
    {
        if (typeof window !== 'undefined' && window && window.location) this.url = window.location.origin + this.url;
    }
    options = options || {};
    this.clientAuthorizations.add(options.authorizations);
    this.swaggerRequestHeaders = options.swaggerRequestHeaders || 'application/json;charset=utf-8,*/*';
    this.defaultSuccessCallback = options.defaultSuccessCallback || null;
    this.defaultErrorCallback = options.defaultErrorCallback || null;
    this.modelPropertyMacro = options.modelPropertyMacro || null;
    this.parameterMacro = options.parameterMacro || null;
    this.usePromise = options.usePromise || null;
    // operation request timeout default
    this.timeout = options.timeout || null;
    // default to request timeout when not specified
    this.fetchSpecTimeout = typeof options.fetchSpecTimeout !== 'undefined' ? options.fetchSpecTimeout : options.timeout || null;
    if (this.usePromise) this.deferredClient = Q.defer();
    if (typeof options.success === 'function') this.success = options.success;
    if (options.useJQuery) this.useJQuery = options.useJQuery;
    if (options.jqueryAjaxCache) this.jqueryAjaxCache = options.jqueryAjaxCache;
    if (options.enableCookies) this.enableCookies = options.enableCookies;
    this.options = options || {};
    // maybe don't need this?
    this.options.timeout = this.timeout;
    this.options.fetchSpecTimeout = this.fetchSpecTimeout;
    this.supportedSubmitMethods = options.supportedSubmitMethods || [];
    this.failure = options.failure || function(err) {
        throw err;
    };
    this.progress = options.progress || function() {};
    this.spec = _.cloneDeep(options.spec); // Clone so we do not alter the provided document
    if (options.scheme) this.scheme = options.scheme;
    if (this.usePromise || typeof options.success === 'function') {
        this.ready = true;
        return this.build();
    }
};
SwaggerClient.prototype.build = function(mock) {
    if (this.isBuilt) return this;
    var self = this;
    if (this.spec) this.progress('fetching resource list; Please wait.');
    else this.progress('fetching resource list: ' + this.url + '; Please wait.');
    var obj = {
        useJQuery: this.useJQuery,
        jqueryAjaxCache: this.jqueryAjaxCache,
        url: this.url,
        method: 'get',
        headers: {
            accept: this.swaggerRequestHeaders
        },
        on: {
            error: function(response) {
                if (self.url.substring(0, 4) !== 'http') return self.fail('Please specify the protocol for ' + self.url);
                else if (response.errObj && (response.errObj.code === 'ECONNABORTED' || response.errObj.message.indexOf('timeout') !== -1)) return self.fail('Request timed out after ' + self.fetchSpecTimeout + 'ms');
                else if (response.status === 0) return self.fail('Can\'t read from server.  It may not have the appropriate access-control-origin settings.');
                else if (response.status === 404) return self.fail('Can\'t read swagger JSON from ' + self.url);
                else return self.fail(response.status + ' : ' + response.statusText + ' ' + self.url);
            },
            response: function(resp) {
                var responseObj = resp.obj;
                if (!responseObj) return self.fail('failed to parse JSON/YAML response');
                self.swaggerVersion = responseObj.swaggerVersion;
                self.swaggerObject = responseObj;
                if (responseObj.swagger && parseInt(responseObj.swagger) === 2) {
                    self.swaggerVersion = responseObj.swagger;
                    new Resolver().resolve(responseObj, self.url, self.buildFromSpec, self);
                    self.isValid = true;
                } else {
                    var converter = new SwaggerSpecConverter();
                    self.oldSwaggerObject = self.swaggerObject;
                    converter.setDocumentationLocation(self.url);
                    converter.convert(responseObj, self.clientAuthorizations, self.options, function(spec) {
                        self.swaggerObject = spec;
                        new Resolver().resolve(spec, self.url, self.buildFromSpec, self);
                        self.isValid = true;
                    });
                }
            }
        }
    };
    // only set timeout when specified
    if (this.fetchSpecTimeout) obj.timeout = this.fetchSpecTimeout;
    if (this.spec) {
        self.swaggerObject = this.spec;
        setTimeout(function() {
            new Resolver().resolve(self.spec, self.url, self.buildFromSpec, self);
        }, 10);
    } else {
        this.clientAuthorizations.apply(obj);
        if (mock) return obj;
        new SwaggerHttp().execute(obj, this.options);
    }
    return this.usePromise ? this.deferredClient.promise : this;
};
SwaggerClient.prototype.buildFromSpec = function(response) {
    if (this.isBuilt) return this;
    this.apis = {};
    this.apisArray = [];
    this.basePath = response.basePath || '';
    this.consumes = response.consumes;
    this.host = response.host || '';
    this.info = response.info || {};
    this.produces = response.produces;
    this.schemes = response.schemes || [];
    this.securityDefinitions = response.securityDefinitions;
    this.security = response.security;
    this.title = response.title || '';
    if (response.externalDocs) this.externalDocs = response.externalDocs;
    // legacy support
    this.authSchemes = response.securityDefinitions;
    var definedTags = {};
    var k;
    if (Array.isArray(response.tags)) {
        definedTags = {};
        for(k = 0; k < response.tags.length; k++){
            var t = response.tags[k];
            definedTags[t.name] = t;
        }
    }
    var location;
    if (typeof this.url === 'string') {
        location = this.parseUri(this.url);
        if (typeof this.scheme === 'undefined' && typeof this.schemes === 'undefined' || this.schemes.length === 0) {
            if (typeof window !== 'undefined') // use the window scheme
            this.scheme = window.location.protocol.replace(':', '');
            else this.scheme = location.scheme || 'http';
        } else if (typeof this.scheme === 'undefined') {
            if (typeof window !== 'undefined') {
                var scheme = window.location.protocol.replace(':', '');
                if (scheme === 'https' && this.schemes.indexOf(scheme) === -1) {
                    // can't call http from https served page in a browser!
                    helpers.log('Cannot call a http server from https inside a browser!');
                    this.scheme = 'http';
                } else if (this.schemes.indexOf(scheme) !== -1) this.scheme = scheme;
                else if (this.schemes.indexOf('https') !== -1) this.scheme = 'https';
                else this.scheme = 'http';
            } else this.scheme = this.schemes[0] || location.scheme;
        }
        if (typeof this.host === 'undefined' || this.host === '') {
            this.host = location.host;
            if (location.port) this.host = this.host + ':' + location.port;
        }
    } else {
        if (typeof this.schemes === 'undefined' || this.schemes.length === 0) this.scheme = 'http';
        else if (typeof this.scheme === 'undefined') this.scheme = this.schemes[0];
    }
    this.definitions = response.definitions;
    var key;
    for(key in this.definitions){
        var model = new Model(key, this.definitions[key], this.models, this.modelPropertyMacro);
        if (model) this.models[key] = model;
    }
    // get paths, create functions for each operationId
    var self = this;
    // Bind help to 'client.apis'
    self.apis.help = _.bind(self.help, self);
    _.forEach(response.paths, function(pathObj, path) {
        // Only process a path if it's an object
        if (!_.isPlainObject(pathObj)) return;
        _.forEach(supportedOperationMethods, function(method) {
            var operation = pathObj[method];
            if (_.isUndefined(operation)) // Operation does not exist
            return;
            else if (!_.isPlainObject(operation)) {
                // Operation exists but it is not an Operation Object.  Since this is invalid, log it.
                helpers.log('The \'' + method + '\' operation for \'' + path + '\' path is not an Operation Object');
                return;
            }
            var tags = operation.tags;
            if (_.isUndefined(tags) || !_.isArray(tags) || tags.length === 0) tags = operation.tags = [
                'default'
            ];
            var operationId = self.idFromOp(path, method, operation);
            var operationObject = new Operation(self, operation.scheme, operationId, method, path, operation, self.definitions, self.models, self.clientAuthorizations);
            // bind self operation's execute command to the api
            _.forEach(tags, function(tag) {
                var clientProperty = _.indexOf(reservedClientTags, tag) > -1 ? '_' + tag : tag;
                var apiProperty = _.indexOf(reservedApiTags, tag) > -1 ? '_' + tag : tag;
                var operationGroup = self[clientProperty];
                if (clientProperty !== tag) helpers.log('The \'' + tag + '\' tag conflicts with a SwaggerClient function/property name.  Use \'client.' + clientProperty + '\' or \'client.apis.' + tag + '\' instead of \'client.' + tag + '\'.');
                if (apiProperty !== tag) helpers.log('The \'' + tag + '\' tag conflicts with a SwaggerClient operation function/property name.  Use ' + '\'client.apis.' + apiProperty + '\' instead of \'client.apis.' + tag + '\'.');
                if (_.indexOf(reservedApiTags, operationId) > -1) {
                    helpers.log('The \'' + operationId + '\' operationId conflicts with a SwaggerClient operation ' + 'function/property name.  Use \'client.apis.' + apiProperty + '._' + operationId + '\' instead of \'client.apis.' + apiProperty + '.' + operationId + '\'.');
                    operationId = '_' + operationId;
                    operationObject.nickname = operationId; // So 'client.apis.[tag].operationId.help() works properly
                }
                if (_.isUndefined(operationGroup)) {
                    operationGroup = self[clientProperty] = self.apis[apiProperty] = {};
                    operationGroup.operations = {};
                    operationGroup.label = apiProperty;
                    operationGroup.apis = {};
                    var tagDef = definedTags[tag];
                    if (!_.isUndefined(tagDef)) {
                        operationGroup.description = tagDef.description;
                        operationGroup.externalDocs = tagDef.externalDocs;
                    }
                    self[clientProperty].help = _.bind(self.help, operationGroup);
                    self.apisArray.push(new OperationGroup(tag, operationGroup.description, operationGroup.externalDocs, operationObject));
                }
                operationId = self.makeUniqueOperationId(operationId, self.apis[apiProperty]);
                // Bind tag help
                if (!_.isFunction(operationGroup.help)) operationGroup.help = _.bind(self.help, operationGroup);
                // bind to the apis object
                self.apis[apiProperty][operationId] = operationGroup[operationId] = _.bind(operationObject.execute, operationObject);
                self.apis[apiProperty][operationId].help = operationGroup[operationId].help = _.bind(operationObject.help, operationObject);
                self.apis[apiProperty][operationId].asCurl = operationGroup[operationId].asCurl = _.bind(operationObject.asCurl, operationObject);
                operationGroup.apis[operationId] = operationGroup.operations[operationId] = operationObject;
                // legacy UI feature
                var api = _.find(self.apisArray, function(api) {
                    return api.tag === tag;
                });
                if (api) api.operationsArray.push(operationObject);
            });
        });
    });
    // sort the apisArray according to the tags
    var sortedApis = [];
    _.forEach(Object.keys(definedTags), function(tag) {
        var pos;
        for(pos in self.apisArray){
            var _api = self.apisArray[pos];
            if (_api && tag === _api.name) {
                sortedApis.push(_api);
                self.apisArray[pos] = null;
            }
        }
    });
    // add anything left
    _.forEach(self.apisArray, function(api) {
        if (api) sortedApis.push(api);
    });
    self.apisArray = sortedApis;
    _.forEach(response.definitions, function(definitionObj, definition) {
        definitionObj.id = definition.toLowerCase();
        definitionObj.name = definition;
        self.modelsArray.push(definitionObj);
    });
    this.isBuilt = true;
    if (this.usePromise) {
        this.isValid = true;
        this.isBuilt = true;
        this.deferredClient.resolve(this);
        return this.deferredClient.promise;
    }
    if (this.success) this.success();
    return this;
};
SwaggerClient.prototype.makeUniqueOperationId = function(operationId, api) {
    var count = 0;
    var name = operationId;
    // make unique across this operation group
    while(true){
        var matched = false;
        _.forEach(api.operations, function(operation) {
            if (operation.nickname === name) matched = true;
        });
        if (!matched) return name;
        name = operationId + '_' + count;
        count++;
    }
    return operationId;
};
SwaggerClient.prototype.parseUri = function(uri) {
    var urlParseRE = /^(((([^:\/#\?]+:)?(?:(\/\/)((?:(([^:@\/#\?]+)(?:\:([^:@\/#\?]+))?)@)?(([^:\/#\?\]\[]+|\[[^\/\]@#?]+\])(?:\:([0-9]+))?))?)?)?((\/?(?:[^\/\?#]+\/+)*)([^\?#]*)))?(\?[^#]+)?)(#.*)?/;
    var parts = urlParseRE.exec(uri);
    return {
        scheme: parts[4] ? parts[4].replace(':', '') : undefined,
        host: parts[11],
        port: parts[12],
        path: parts[15]
    };
};
SwaggerClient.prototype.help = function(dontPrint) {
    var output = '';
    if (this instanceof SwaggerClient) _.forEach(this.apis, function(api, name) {
        if (_.isPlainObject(api)) {
            output += 'operations for the \'' + name + '\' tag\n';
            _.forEach(api.operations, function(operation, name) {
                output += '  * ' + name + ': ' + operation.summary + '\n';
            });
        }
    });
    else if (this instanceof OperationGroup || _.isPlainObject(this)) {
        output += 'operations for the \'' + this.label + '\' tag\n';
        _.forEach(this.apis, function(operation, name) {
            output += '  * ' + name + ': ' + operation.summary + '\n';
        });
    }
    if (dontPrint) return output;
    else {
        helpers.log(output);
        return output;
    }
};
SwaggerClient.prototype.tagFromLabel = function(label) {
    return label;
};
SwaggerClient.prototype.idFromOp = function(path, httpMethod, op) {
    if (!op || !op.operationId) {
        op = op || {};
        op.operationId = httpMethod + '_' + path;
    }
    var opId = op.operationId.replace(/[\s!@#$%^&*()_+=\[{\]};:<>|.\/?,\\'""-]/g, '_') || path.substring(1) + '_' + httpMethod;
    opId = opId.replace(/((_){2,})/g, '_');
    opId = opId.replace(/^(_)*/g, '');
    opId = opId.replace(/([_])*$/g, '');
    return opId;
};
SwaggerClient.prototype.setHost = function(host) {
    this.host = host;
    if (this.apis) _.forEach(this.apis, function(api) {
        if (api.operations) _.forEach(api.operations, function(operation) {
            operation.host = host;
        });
    });
};
SwaggerClient.prototype.setBasePath = function(basePath) {
    this.basePath = basePath;
    if (this.apis) _.forEach(this.apis, function(api) {
        if (api.operations) _.forEach(api.operations, function(operation) {
            operation.basePath = basePath;
        });
    });
};
SwaggerClient.prototype.setSchemes = function(schemes) {
    this.schemes = schemes;
    if (schemes && schemes.length > 0) {
        if (this.apis) _.forEach(this.apis, function(api) {
            if (api.operations) _.forEach(api.operations, function(operation) {
                operation.scheme = schemes[0];
            });
        });
    }
};
SwaggerClient.prototype.fail = function(message) {
    if (this.usePromise) {
        this.deferredClient.reject(message);
        return this.deferredClient.promise;
    } else if (this.failure) this.failure(message);
    else this.failure(message);
};

},{"33c34d78b69aad99":"4iMZR","f0f2139fde238d":"7UzDg","e508a73a1b8c356d":"iRfsD","bfa9eb57c396698":"9dHGp","271e052018994d38":"FlPsZ","7a369d4a43412e88":"42oZf","32bbf81f199f1b54":"2h87f","3e93f250d8798118":"fTvdo","c7e95eeb0a132564":"i4FFk","11fa9b2a21129504":"kKkpQ","b684271afa89b5d3":"euq2V","f30014955259a2d0":"7AAzh","62ce23b20e85689":"aepyO","ae1ba031ee67c0f":"dGc8H","805ab5a46bc2ec13":"8pY2G","1d5cbc4f4b63e901":"h2F7k","a1a69a7060309ba3":"bUg9C","9702b559f9fbe89c":"jNa6g","86e5fe1638661be7":"iWYSC"}],"4iMZR":[function(require,module,exports,__globalThis) {
var createWrapper = require("57e37ab406e1060d"), replaceHolders = require("8ed48d568bc8a676"), restParam = require("ad1c844b9d954cd1");
/** Used to compose bitmasks for wrapper metadata. */ var BIND_FLAG = 1, PARTIAL_FLAG = 32;
/**
 * Creates a function that invokes `func` with the `this` binding of `thisArg`
 * and prepends any additional `_.bind` arguments to those provided to the
 * bound function.
 *
 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for partially applied arguments.
 *
 * **Note:** Unlike native `Function#bind` this method does not set the "length"
 * property of bound functions.
 *
 * @static
 * @memberOf _
 * @category Function
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new bound function.
 * @example
 *
 * var greet = function(greeting, punctuation) {
 *   return greeting + ' ' + this.user + punctuation;
 * };
 *
 * var object = { 'user': 'fred' };
 *
 * var bound = _.bind(greet, object, 'hi');
 * bound('!');
 * // => 'hi fred!'
 *
 * // using placeholders
 * var bound = _.bind(greet, object, _, '!');
 * bound('hi');
 * // => 'hi fred!'
 */ var bind = restParam(function(func, thisArg, partials) {
    var bitmask = BIND_FLAG;
    if (partials.length) {
        var holders = replaceHolders(partials, bind.placeholder);
        bitmask |= PARTIAL_FLAG;
    }
    return createWrapper(func, bitmask, thisArg, partials, holders);
});
// Assign default placeholders.
bind.placeholder = {};
module.exports = bind;

},{"57e37ab406e1060d":"74bby","8ed48d568bc8a676":"cglne","ad1c844b9d954cd1":"c7ATf"}],"74bby":[function(require,module,exports,__globalThis) {
var baseSetData = require("5c9426407a62454"), createBindWrapper = require("cc1778c1cf88495b"), createHybridWrapper = require("47a08758bea5a109"), createPartialWrapper = require("5e44df7bfa99b96b"), getData = require("ec06a08a66097bd1"), mergeData = require("4e909702e2880b19"), setData = require("2d2f2b3ad4e468f");
/** Used to compose bitmasks for wrapper metadata. */ var BIND_FLAG = 1, BIND_KEY_FLAG = 2, PARTIAL_FLAG = 32, PARTIAL_RIGHT_FLAG = 64;
/** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = 'Expected a function';
/* Native method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to reference.
 * @param {number} bitmask The bitmask of flags.
 *  The bitmask may be composed of the following flags:
 *     1 - `_.bind`
 *     2 - `_.bindKey`
 *     4 - `_.curry` or `_.curryRight` of a bound function
 *     8 - `_.curry`
 *    16 - `_.curryRight`
 *    32 - `_.partial`
 *    64 - `_.partialRight`
 *   128 - `_.rearg`
 *   256 - `_.ary`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
    var isBindKey = bitmask & BIND_KEY_FLAG;
    if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    var length = partials ? partials.length : 0;
    if (!length) {
        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
    }
    length -= holders ? holders.length : 0;
    if (bitmask & PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials, holdersRight = holders;
        partials = holders = undefined;
    }
    var data = isBindKey ? undefined : getData(func), newData = [
        func,
        bitmask,
        thisArg,
        partials,
        holders,
        partialsRight,
        holdersRight,
        argPos,
        ary,
        arity
    ];
    if (data) {
        mergeData(newData, data);
        bitmask = newData[1];
        arity = newData[9];
    }
    newData[9] = arity == null ? isBindKey ? 0 : func.length : nativeMax(arity - length, 0) || 0;
    if (bitmask == BIND_FLAG) var result = createBindWrapper(newData[0], newData[2]);
    else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) result = createPartialWrapper.apply(undefined, newData);
    else result = createHybridWrapper.apply(undefined, newData);
    var setter = data ? baseSetData : setData;
    return setter(result, newData);
}
module.exports = createWrapper;

},{"5c9426407a62454":"6zFPi","cc1778c1cf88495b":"3e6U6","47a08758bea5a109":"6pwT3","5e44df7bfa99b96b":"PSlDV","ec06a08a66097bd1":"1uc0Z","4e909702e2880b19":"2hTy7","2d2f2b3ad4e468f":"hHHQT"}],"6zFPi":[function(require,module,exports,__globalThis) {
var identity = require("f360ad9468de875b"), metaMap = require("8bebf944384b77de");
/**
 * The base implementation of `setData` without support for hot loop detection.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var baseSetData = !metaMap ? identity : function(func, data) {
    metaMap.set(func, data);
    return func;
};
module.exports = baseSetData;

},{"f360ad9468de875b":"hrnuZ","8bebf944384b77de":"iE8ZS"}],"iE8ZS":[function(require,module,exports,__globalThis) {
var global = arguments[3];
var getNative = require("676ea4afdfdc1f5e");
/** Native method references. */ var WeakMap = getNative(global, 'WeakMap');
/** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
module.exports = metaMap;

},{"676ea4afdfdc1f5e":"65o1m"}],"3e6U6":[function(require,module,exports,__globalThis) {
var global = arguments[3];
var createCtorWrapper = require("3811cceba1e641f5");
/**
 * Creates a function that wraps `func` and invokes it with the `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to bind.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new bound function.
 */ function createBindWrapper(func, thisArg) {
    var Ctor = createCtorWrapper(func);
    function wrapper() {
        var fn = this && this !== global && this instanceof wrapper ? Ctor : func;
        return fn.apply(thisArg, arguments);
    }
    return wrapper;
}
module.exports = createBindWrapper;

},{"3811cceba1e641f5":"37HvT"}],"37HvT":[function(require,module,exports,__globalThis) {
var baseCreate = require("639f35e2263e90fe"), isObject = require("5772efbb47766c0f");
/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */ function createCtorWrapper(Ctor) {
    return function() {
        // Use a `switch` statement to work with class constructors.
        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch(args.length){
            case 0:
                return new Ctor;
            case 1:
                return new Ctor(args[0]);
            case 2:
                return new Ctor(args[0], args[1]);
            case 3:
                return new Ctor(args[0], args[1], args[2]);
            case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
    };
}
module.exports = createCtorWrapper;

},{"639f35e2263e90fe":"j9C6o","5772efbb47766c0f":"2h87f"}],"j9C6o":[function(require,module,exports,__globalThis) {
var isObject = require("e6722f3f4eb2d806");
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(prototype) {
        if (isObject(prototype)) {
            object.prototype = prototype;
            var result = new object;
            object.prototype = undefined;
        }
        return result || {};
    };
}();
module.exports = baseCreate;

},{"e6722f3f4eb2d806":"2h87f"}],"6pwT3":[function(require,module,exports,__globalThis) {
var global = arguments[3];
var arrayCopy = require("49417aa462bcb0d7"), composeArgs = require("9ab54114c880ae18"), composeArgsRight = require("332347cd9073703c"), createCtorWrapper = require("b5d69ef4549c693d"), isLaziable = require("e58767a40aebd6d3"), reorder = require("8c0ba926b4a083d1"), replaceHolders = require("258f938d2d3cac43"), setData = require("a0a5f952314560ae");
/** Used to compose bitmasks for wrapper metadata. */ var BIND_FLAG = 1, BIND_KEY_FLAG = 2, CURRY_BOUND_FLAG = 4, CURRY_FLAG = 8, CURRY_RIGHT_FLAG = 16, PARTIAL_FLAG = 32, PARTIAL_RIGHT_FLAG = 64, ARY_FLAG = 128;
/* Native method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * Creates a function that wraps `func` and invokes it with optional `this`
 * binding of, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to reference.
 * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
    var isAry = bitmask & ARY_FLAG, isBind = bitmask & BIND_FLAG, isBindKey = bitmask & BIND_KEY_FLAG, isCurry = bitmask & CURRY_FLAG, isCurryBound = bitmask & CURRY_BOUND_FLAG, isCurryRight = bitmask & CURRY_RIGHT_FLAG, Ctor = isBindKey ? undefined : createCtorWrapper(func);
    function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it to other functions.
        var length = arguments.length, index = length, args = Array(length);
        while(index--)args[index] = arguments[index];
        if (partials) args = composeArgs(args, partials, holders);
        if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight);
        if (isCurry || isCurryRight) {
            var placeholder = wrapper.placeholder, argsHolders = replaceHolders(args, placeholder);
            length -= argsHolders.length;
            if (length < arity) {
                var newArgPos = argPos ? arrayCopy(argPos) : undefined, newArity = nativeMax(arity - length, 0), newsHolders = isCurry ? argsHolders : undefined, newHoldersRight = isCurry ? undefined : argsHolders, newPartials = isCurry ? args : undefined, newPartialsRight = isCurry ? undefined : args;
                bitmask |= isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG;
                bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
                if (!isCurryBound) bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
                var newData = [
                    func,
                    bitmask,
                    thisArg,
                    newPartials,
                    newsHolders,
                    newPartialsRight,
                    newHoldersRight,
                    newArgPos,
                    ary,
                    newArity
                ], result = createHybridWrapper.apply(undefined, newData);
                if (isLaziable(func)) setData(result, newData);
                result.placeholder = placeholder;
                return result;
            }
        }
        var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
        if (argPos) args = reorder(args, argPos);
        if (isAry && ary < args.length) args.length = ary;
        if (this && this !== global && this instanceof wrapper) fn = Ctor || createCtorWrapper(func);
        return fn.apply(thisBinding, args);
    }
    return wrapper;
}
module.exports = createHybridWrapper;

},{"49417aa462bcb0d7":"hJh6y","9ab54114c880ae18":"fiEoG","332347cd9073703c":"dj5gN","b5d69ef4549c693d":"37HvT","e58767a40aebd6d3":"hyoHh","8c0ba926b4a083d1":"b72zQ","258f938d2d3cac43":"cglne","a0a5f952314560ae":"hHHQT"}],"hJh6y":[function(require,module,exports,__globalThis) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function arrayCopy(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = arrayCopy;

},{}],"fiEoG":[function(require,module,exports,__globalThis) {
/* Native method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array|Object} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @returns {Array} Returns the new array of composed arguments.
 */ function composeArgs(args, partials, holders) {
    var holdersLength = holders.length, argsIndex = -1, argsLength = nativeMax(args.length - holdersLength, 0), leftIndex = -1, leftLength = partials.length, result = Array(leftLength + argsLength);
    while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
    while(++argsIndex < holdersLength)result[holders[argsIndex]] = args[argsIndex];
    while(argsLength--)result[leftIndex++] = args[argsIndex++];
    return result;
}
module.exports = composeArgs;

},{}],"dj5gN":[function(require,module,exports,__globalThis) {
/* Native method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array|Object} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @returns {Array} Returns the new array of composed arguments.
 */ function composeArgsRight(args, partials, holders) {
    var holdersIndex = -1, holdersLength = holders.length, argsIndex = -1, argsLength = nativeMax(args.length - holdersLength, 0), rightIndex = -1, rightLength = partials.length, result = Array(argsLength + rightLength);
    while(++argsIndex < argsLength)result[argsIndex] = args[argsIndex];
    var offset = argsIndex;
    while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
    while(++holdersIndex < holdersLength)result[offset + holders[holdersIndex]] = args[argsIndex++];
    return result;
}
module.exports = composeArgsRight;

},{}],"hyoHh":[function(require,module,exports,__globalThis) {
var LazyWrapper = require("3b44225f86ed1b82"), getData = require("fe830638e9d3cecd"), getFuncName = require("2f7d177f77c6c392"), lodash = require("dfb9f642696b4c7d");
/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
 */ function isLaziable(func) {
    var funcName = getFuncName(func), other = lodash[funcName];
    if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
    if (func === other) return true;
    var data = getData(other);
    return !!data && func === data[0];
}
module.exports = isLaziable;

},{"3b44225f86ed1b82":"j9bKd","fe830638e9d3cecd":"1uc0Z","2f7d177f77c6c392":"4BYF0","dfb9f642696b4c7d":"jRu64"}],"j9bKd":[function(require,module,exports,__globalThis) {
var baseCreate = require("f6c712b001ebd9cf"), baseLodash = require("eb6f65383173f492");
/** Used as references for `-Infinity` and `Infinity`. */ var POSITIVE_INFINITY = Number.POSITIVE_INFINITY;
/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @param {*} value The value to wrap.
 */ function LazyWrapper(value) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__dir__ = 1;
    this.__filtered__ = false;
    this.__iteratees__ = [];
    this.__takeCount__ = POSITIVE_INFINITY;
    this.__views__ = [];
}
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;
module.exports = LazyWrapper;

},{"f6c712b001ebd9cf":"j9C6o","eb6f65383173f492":"9nbrh"}],"9nbrh":[function(require,module,exports,__globalThis) {
/**
 * The function whose prototype all chaining wrappers inherit from.
 *
 * @private
 */ function baseLodash() {
// No operation performed.
}
module.exports = baseLodash;

},{}],"1uc0Z":[function(require,module,exports,__globalThis) {
var metaMap = require("ad0716ee2a9b4889"), noop = require("55eaf32254dc9c2f");
/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */ var getData = !metaMap ? noop : function(func) {
    return metaMap.get(func);
};
module.exports = getData;

},{"ad0716ee2a9b4889":"iE8ZS","55eaf32254dc9c2f":"iaMue"}],"iaMue":[function(require,module,exports,__globalThis) {
/**
 * A no-operation function that returns `undefined` regardless of the
 * arguments it receives.
 *
 * @static
 * @memberOf _
 * @category Utility
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.noop(object) === undefined;
 * // => true
 */ function noop() {
// No operation performed.
}
module.exports = noop;

},{}],"4BYF0":[function(require,module,exports,__globalThis) {
var realNames = require("936911c9c143fff4");
/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */ function getFuncName(func) {
    var result = func.name + '', array = realNames[result], length = array ? array.length : 0;
    while(length--){
        var data = array[length], otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) return data.name;
    }
    return result;
}
module.exports = getFuncName;

},{"936911c9c143fff4":"kyBLK"}],"kyBLK":[function(require,module,exports,__globalThis) {
/** Used to lookup unminified function names. */ var realNames = {};
module.exports = realNames;

},{}],"jRu64":[function(require,module,exports,__globalThis) {
var LazyWrapper = require("da4eee378f32653c"), LodashWrapper = require("6f10d73fc9fa8f35"), baseLodash = require("69bec324461943e9"), isArray = require("ead958d0626093f0"), isObjectLike = require("62725493f7836d5"), wrapperClone = require("1d327a856539047f");
/** Used for native method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates a `lodash` object which wraps `value` to enable implicit chaining.
 * Methods that operate on and return arrays, collections, and functions can
 * be chained together. Methods that retrieve a single value or may return a
 * primitive value will automatically end the chain returning the unwrapped
 * value. Explicit chaining may be enabled using `_.chain`. The execution of
 * chained methods is lazy, that is, execution is deferred until `_#value`
 * is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
 * fusion is an optimization strategy which merge iteratee calls; this can help
 * to avoid the creation of intermediate data structures and greatly reduce the
 * number of iteratee executions.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
 * `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
 * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
 * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
 * and `where`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
 * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
 * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
 * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
 * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
 * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
 * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
 * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
 * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
 * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
 * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
 * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
 * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
 * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
 * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
 * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
 * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
 * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
 * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
 * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
 * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
 * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
 * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
 * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
 * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
 * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
 * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
 * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
 * `unescape`, `uniqueId`, `value`, and `words`
 *
 * The wrapper method `sample` will return a wrapped value when `n` is provided,
 * otherwise an unwrapped value is returned.
 *
 * @name _
 * @constructor
 * @category Chain
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // returns an unwrapped value
 * wrapped.reduce(function(total, n) {
 *   return total + n;
 * });
 * // => 6
 *
 * // returns a wrapped value
 * var squares = wrapped.map(function(n) {
 *   return n * n;
 * });
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */ function lodash(value) {
    if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) return value;
        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
    }
    return new LodashWrapper(value);
}
// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
module.exports = lodash;

},{"da4eee378f32653c":"j9bKd","6f10d73fc9fa8f35":"5mXM7","69bec324461943e9":"9nbrh","ead958d0626093f0":"42oZf","62725493f7836d5":"wRUw9","1d327a856539047f":"04TEt"}],"5mXM7":[function(require,module,exports,__globalThis) {
var baseCreate = require("f9967750d082289d"), baseLodash = require("78286fe4d0b55f6d");
/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
 * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
 */ function LodashWrapper(value, chainAll, actions) {
    this.__wrapped__ = value;
    this.__actions__ = actions || [];
    this.__chain__ = !!chainAll;
}
LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;
module.exports = LodashWrapper;

},{"f9967750d082289d":"j9C6o","78286fe4d0b55f6d":"9nbrh"}],"04TEt":[function(require,module,exports,__globalThis) {
var LazyWrapper = require("c783f3684fdb11ae"), LodashWrapper = require("7b4eb3955da98638"), arrayCopy = require("c1039f82b29fe533");
/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */ function wrapperClone(wrapper) {
    return wrapper instanceof LazyWrapper ? wrapper.clone() : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
}
module.exports = wrapperClone;

},{"c783f3684fdb11ae":"j9bKd","7b4eb3955da98638":"5mXM7","c1039f82b29fe533":"hJh6y"}],"b72zQ":[function(require,module,exports,__globalThis) {
var arrayCopy = require("4819c7648dcb8f16"), isIndex = require("6ed6f9b307ca45ee");
/* Native method references for those with the same name as other `lodash` methods. */ var nativeMin = Math.min;
/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */ function reorder(array, indexes) {
    var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = arrayCopy(array);
    while(length--){
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
    }
    return array;
}
module.exports = reorder;

},{"4819c7648dcb8f16":"hJh6y","6ed6f9b307ca45ee":"eagib"}],"cglne":[function(require,module,exports,__globalThis) {
/** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */ function replaceHolders(array, placeholder) {
    var index = -1, length = array.length, resIndex = -1, result = [];
    while(++index < length)if (array[index] === placeholder) {
        array[index] = PLACEHOLDER;
        result[++resIndex] = index;
    }
    return result;
}
module.exports = replaceHolders;

},{}],"hHHQT":[function(require,module,exports,__globalThis) {
var baseSetData = require("9ea7390daf512f5f"), now = require("791b3b8a27a01d7b");
/** Used to detect when a function becomes hot. */ var HOT_COUNT = 150, HOT_SPAN = 16;
/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity function
 * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var setData = function() {
    var count = 0, lastCalled = 0;
    return function(key, value) {
        var stamp = now(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return key;
        } else count = 0;
        return baseSetData(key, value);
    };
}();
module.exports = setData;

},{"9ea7390daf512f5f":"6zFPi","791b3b8a27a01d7b":"8kt42"}],"8kt42":[function(require,module,exports,__globalThis) {
var getNative = require("ad4515357f3b0053");
/* Native method references for those with the same name as other `lodash` methods. */ var nativeNow = getNative(Date, 'now');
/**
 * Gets the number of milliseconds that have elapsed since the Unix epoch
 * (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @category Date
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => logs the number of milliseconds it took for the deferred function to be invoked
 */ var now = nativeNow || function() {
    return new Date().getTime();
};
module.exports = now;

},{"ad4515357f3b0053":"65o1m"}],"PSlDV":[function(require,module,exports,__globalThis) {
var global = arguments[3];
var createCtorWrapper = require("dffbe9bbe63a30b7");
/** Used to compose bitmasks for wrapper metadata. */ var BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` and invokes it with the optional `this`
 * binding of `thisArg` and the `partials` prepended to those provided to
 * the wrapper.
 *
 * @private
 * @param {Function} func The function to partially apply arguments to.
 * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to the new function.
 * @returns {Function} Returns the new bound function.
 */ function createPartialWrapper(func, bitmask, thisArg, partials) {
    var isBind = bitmask & BIND_FLAG, Ctor = createCtorWrapper(func);
    function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it `func`.
        var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength);
        while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
        while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
        var fn = this && this !== global && this instanceof wrapper ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, args);
    }
    return wrapper;
}
module.exports = createPartialWrapper;

},{"dffbe9bbe63a30b7":"37HvT"}],"2hTy7":[function(require,module,exports,__globalThis) {
var arrayCopy = require("93759954ce3ee947"), composeArgs = require("f99f83934647d8e5"), composeArgsRight = require("480d926924574085"), replaceHolders = require("ce810aba9a1048cd");
/** Used to compose bitmasks for wrapper metadata. */ var BIND_FLAG = 1, CURRY_BOUND_FLAG = 4, CURRY_FLAG = 8, ARY_FLAG = 128, REARG_FLAG = 256;
/** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
/* Native method references for those with the same name as other `lodash` methods. */ var nativeMin = Math.min;
/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers required to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
 * augment function arguments, making the order in which they are executed important,
 * preventing the merging of metadata. However, we make an exception for a safe
 * common case where curried functions have `_.ary` and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */ function mergeData(data, source) {
    var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < ARY_FLAG;
    var isCombo = srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG || srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8] || srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG;
    // Exit early if metadata can't be merged.
    if (!(isCommon || isCombo)) return data;
    // Use source `thisArg` if available.
    if (srcBitmask & BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & BIND_FLAG ? 0 : CURRY_BOUND_FLAG;
    }
    // Compose partial arguments.
    var value = source[3];
    if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
    }
    // Compose partial right arguments.
    value = source[5];
    if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
    }
    // Use source `argPos` if available.
    value = source[7];
    if (value) data[7] = arrayCopy(value);
    // Use source `ary` if it's smaller.
    if (srcBitmask & ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
    // Use source `arity` if one is not provided.
    if (data[9] == null) data[9] = source[9];
    // Use source `func` and merge bitmasks.
    data[0] = source[0];
    data[1] = newBitmask;
    return data;
}
module.exports = mergeData;

},{"93759954ce3ee947":"hJh6y","f99f83934647d8e5":"fiEoG","480d926924574085":"dj5gN","ce810aba9a1048cd":"cglne"}],"c7ATf":[function(require,module,exports,__globalThis) {
/** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = 'Expected a function';
/* Native method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * Creates a function that invokes `func` with the `this` binding of the
 * created function and arguments from `start` and beyond provided as an array.
 *
 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/Web/JavaScript/Reference/Functions/rest_parameters).
 *
 * @static
 * @memberOf _
 * @category Function
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var say = _.restParam(function(what, names) {
 *   return what + ' ' + _.initial(names).join(', ') +
 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
 * });
 *
 * say('hello', 'fred', 'barney', 'pebbles');
 * // => 'hello fred, barney, & pebbles'
 */ function restParam(func, start) {
    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    start = nativeMax(start === undefined ? func.length - 1 : +start || 0, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), rest = Array(length);
        while(++index < length)rest[index] = args[start + index];
        switch(start){
            case 0:
                return func.call(this, rest);
            case 1:
                return func.call(this, args[0], rest);
            case 2:
                return func.call(this, args[0], args[1], rest);
        }
        var otherArgs = Array(start + 1);
        index = -1;
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = rest;
        return func.apply(this, otherArgs);
    };
}
module.exports = restParam;

},{}],"7UzDg":[function(require,module,exports,__globalThis) {
var baseClone = require("de8c4c1368250821"), bindCallback = require("57bcbe73e2b40376");
/**
 * Creates a deep clone of `value`. If `customizer` is provided it's invoked
 * to produce the cloned values. If `customizer` returns `undefined` cloning
 * is handled by the method instead. The `customizer` is bound to `thisArg`
 * and invoked with up to three argument; (value [, index|key, object]).
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
 * The enumerable properties of `arguments` objects and objects created by
 * constructors other than `Object` are cloned to plain `Object` objects. An
 * empty object is returned for uncloneable values such as functions, DOM nodes,
 * Maps, Sets, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to deep clone.
 * @param {Function} [customizer] The function to customize cloning values.
 * @param {*} [thisArg] The `this` binding of `customizer`.
 * @returns {*} Returns the deep cloned value.
 * @example
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * var deep = _.cloneDeep(users);
 * deep[0] === users[0];
 * // => false
 *
 * // using a customizer callback
 * var el = _.cloneDeep(document.body, function(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(true);
 *   }
 * });
 *
 * el === document.body
 * // => false
 * el.nodeName
 * // => BODY
 * el.childNodes.length;
 * // => 20
 */ function cloneDeep(value, customizer, thisArg) {
    return typeof customizer == 'function' ? baseClone(value, true, bindCallback(customizer, thisArg, 3)) : baseClone(value, true);
}
module.exports = cloneDeep;

},{"de8c4c1368250821":"1Kb8l","57bcbe73e2b40376":"3iDHf"}],"1Kb8l":[function(require,module,exports,__globalThis) {
var arrayCopy = require("abb591dcf47c63d3"), arrayEach = require("74059e8aa8f68369"), baseAssign = require("face3cde64043e98"), baseForOwn = require("c9f75fcd07333ab"), initCloneArray = require("9508bf0f9c79bc1c"), initCloneByTag = require("96417b7f7c7dd271"), initCloneObject = require("3bc8162ac12a6f1d"), isArray = require("16494dfcf8f4a8da"), isHostObject = require("8deb2e8b5918c7cb"), isObject = require("6dd549f4acfaf486");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[stringTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[mapTag] = cloneableTags[setTag] = cloneableTags[weakMapTag] = false;
/** Used for native method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var objToString = objectProto.toString;
/**
 * The base implementation of `_.clone` without support for argument juggling
 * and `this` binding `customizer` functions.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {Function} [customizer] The function to customize cloning values.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The object `value` belongs to.
 * @param {Array} [stackA=[]] Tracks traversed source objects.
 * @param {Array} [stackB=[]] Associates clones with source counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
    var result;
    if (customizer) result = object ? customizer(value, key, object) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return arrayCopy(value, result);
    } else {
        var tag = objToString.call(value), isFunc = tag == funcTag;
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            if (isHostObject(value)) return object ? value : {};
            result = initCloneObject(isFunc ? {} : value);
            if (!isDeep) return baseAssign(result, value);
        } else return cloneableTags[tag] ? initCloneByTag(value, tag, isDeep) : object ? value : {};
    }
    // Check for circular references and return its corresponding clone.
    stackA || (stackA = []);
    stackB || (stackB = []);
    var length = stackA.length;
    while(length--){
        if (stackA[length] == value) return stackB[length];
    }
    // Add the source value to the stack of traversed objects and associate it with its clone.
    stackA.push(value);
    stackB.push(result);
    // Recursively populate clone (susceptible to call stack limits).
    (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
    });
    return result;
}
module.exports = baseClone;

},{"abb591dcf47c63d3":"hJh6y","74059e8aa8f68369":"4rk8p","face3cde64043e98":"9Saaz","c9f75fcd07333ab":"dhaBE","9508bf0f9c79bc1c":"hWu0x","96417b7f7c7dd271":"ggXzP","3bc8162ac12a6f1d":"9AgNF","16494dfcf8f4a8da":"42oZf","8deb2e8b5918c7cb":"8j3dt","6dd549f4acfaf486":"2h87f"}],"9Saaz":[function(require,module,exports,__globalThis) {
var baseCopy = require("b0e2ccf677627a6"), keys = require("a804bc86ba64b1ee");
/**
 * The base implementation of `_.assign` without support for argument juggling,
 * multiple sources, and `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return source == null ? object : baseCopy(source, keys(source), object);
}
module.exports = baseAssign;

},{"b0e2ccf677627a6":"1mDgs","a804bc86ba64b1ee":"dWOkG"}],"1mDgs":[function(require,module,exports,__globalThis) {
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property names to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @returns {Object} Returns `object`.
 */ function baseCopy(source, props, object) {
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        object[key] = source[key];
    }
    return object;
}
module.exports = baseCopy;

},{}],"hWu0x":[function(require,module,exports,__globalThis) {
/** Used for native method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add array properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = initCloneArray;

},{}],"ggXzP":[function(require,module,exports,__globalThis) {
var global = arguments[3];
var bufferClone = require("a6d85d8c9d30d0e");
/** `Object#toString` result references. */ var boolTag = '[object Boolean]', dateTag = '[object Date]', numberTag = '[object Number]', regexpTag = '[object RegExp]', stringTag = '[object String]';
var arrayBufferTag = '[object ArrayBuffer]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/** Native method references. */ var Uint8Array = global.Uint8Array;
/** Used to lookup a type array constructors by `toStringTag`. */ var ctorByTag = {};
ctorByTag[float32Tag] = global.Float32Array;
ctorByTag[float64Tag] = global.Float64Array;
ctorByTag[int8Tag] = global.Int8Array;
ctorByTag[int16Tag] = global.Int16Array;
ctorByTag[int32Tag] = global.Int32Array;
ctorByTag[uint8Tag] = Uint8Array;
ctorByTag[uint8ClampedTag] = global.Uint8ClampedArray;
ctorByTag[uint16Tag] = global.Uint16Array;
ctorByTag[uint32Tag] = global.Uint32Array;
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return bufferClone(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            // Safari 5 mobile incorrectly has `Object` as the constructor of typed arrays.
            if (Ctor instanceof Ctor) Ctor = ctorByTag[tag];
            var buffer = object.buffer;
            return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            var result = new Ctor(object.source, reFlags.exec(object));
            result.lastIndex = object.lastIndex;
    }
    return result;
}
module.exports = initCloneByTag;

},{"a6d85d8c9d30d0e":"6M1qi"}],"6M1qi":[function(require,module,exports,__globalThis) {
/** Native method references. */ var global = arguments[3];
var ArrayBuffer = global.ArrayBuffer, Uint8Array = global.Uint8Array;
/**
 * Creates a clone of the given array buffer.
 *
 * @private
 * @param {ArrayBuffer} buffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function bufferClone(buffer) {
    var result = new ArrayBuffer(buffer.byteLength), view = new Uint8Array(result);
    view.set(new Uint8Array(buffer));
    return result;
}
module.exports = bufferClone;

},{}],"9AgNF":[function(require,module,exports,__globalThis) {
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    var Ctor = object.constructor;
    if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) Ctor = Object;
    return new Ctor;
}
module.exports = initCloneObject;

},{}],"iRfsD":[function(require,module,exports,__globalThis) {
var baseEach = require("f327dee848906fb"), createFind = require("1643ce663254b2c1");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is bound to `thisArg` and
 * invoked with three arguments: (value, index|key, collection).
 *
 * If a property name is provided for `predicate` the created `_.property`
 * style callback returns the property value of the given element.
 *
 * If a value is also provided for `thisArg` the created `_.matchesProperty`
 * style callback returns `true` for elements that have a matching property
 * value, else `false`.
 *
 * If an object is provided for `predicate` the created `_.matches` style
 * callback returns `true` for elements that have the properties of the given
 * object, else `false`.
 *
 * @static
 * @memberOf _
 * @alias detect
 * @category Collection
 * @param {Array|Object|string} collection The collection to search.
 * @param {Function|Object|string} [predicate=_.identity] The function invoked
 *  per iteration.
 * @param {*} [thisArg] The `this` binding of `predicate`.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.result(_.find(users, function(chr) {
 *   return chr.age < 40;
 * }), 'user');
 * // => 'barney'
 *
 * // using the `_.matches` callback shorthand
 * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
 * // => 'pebbles'
 *
 * // using the `_.matchesProperty` callback shorthand
 * _.result(_.find(users, 'active', false), 'user');
 * // => 'fred'
 *
 * // using the `_.property` callback shorthand
 * _.result(_.find(users, 'active'), 'user');
 * // => 'barney'
 */ var find = createFind(baseEach);
module.exports = find;

},{"f327dee848906fb":"lyAU9","1643ce663254b2c1":"8m2Zn"}],"8m2Zn":[function(require,module,exports,__globalThis) {
var baseCallback = require("b43a722518b13489"), baseFind = require("7e24098f91e2a13f"), baseFindIndex = require("472d07463e75bddd"), isArray = require("1485fae328da4b39");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new find function.
 */ function createFind(eachFunc, fromRight) {
    return function(collection, predicate, thisArg) {
        predicate = baseCallback(predicate, thisArg, 3);
        if (isArray(collection)) {
            var index = baseFindIndex(collection, predicate, fromRight);
            return index > -1 ? collection[index] : undefined;
        }
        return baseFind(collection, predicate, eachFunc);
    };
}
module.exports = createFind;

},{"b43a722518b13489":"i2vSs","7e24098f91e2a13f":"i71Px","472d07463e75bddd":"61ODT","1485fae328da4b39":"42oZf"}],"i2vSs":[function(require,module,exports,__globalThis) {
var baseMatches = require("d0cfdf59d2ad9ea8"), baseMatchesProperty = require("36b33488f9aac84e"), bindCallback = require("fd12c9967c25d533"), identity = require("8328d066231632d5"), property = require("cbba83da15bd367a");
/**
 * The base implementation of `_.callback` which supports specifying the
 * number of arguments to provide to `func`.
 *
 * @private
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {number} [argCount] The number of arguments to provide to `func`.
 * @returns {Function} Returns the callback.
 */ function baseCallback(func, thisArg, argCount) {
    var type = typeof func;
    if (type == 'function') return thisArg === undefined ? func : bindCallback(func, thisArg, argCount);
    if (func == null) return identity;
    if (type == 'object') return baseMatches(func);
    return thisArg === undefined ? property(func) : baseMatchesProperty(func, thisArg);
}
module.exports = baseCallback;

},{"d0cfdf59d2ad9ea8":"cjYEM","36b33488f9aac84e":"aUce1","fd12c9967c25d533":"3iDHf","8328d066231632d5":"hrnuZ","cbba83da15bd367a":"cFlpm"}],"cjYEM":[function(require,module,exports,__globalThis) {
var baseIsMatch = require("6e46b2b62aab46a4"), getMatchData = require("cfc539f6d696bde1"), toObject = require("d0fc69cc0f334917");
/**
 * The base implementation of `_.matches` which does not clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) {
        var key = matchData[0][0], value = matchData[0][1];
        return function(object) {
            if (object == null) return false;
            object = toObject(object);
            return object[key] === value && (value !== undefined || key in object);
        };
    }
    return function(object) {
        return baseIsMatch(object, matchData);
    };
}
module.exports = baseMatches;

},{"6e46b2b62aab46a4":"6KS5t","cfc539f6d696bde1":"a9Lxz","d0fc69cc0f334917":"3Gay2"}],"6KS5t":[function(require,module,exports,__globalThis) {
var baseIsEqual = require("dc33dd1b5d323fee"), toObject = require("80fd9bd9aa3633d7");
/**
 * The base implementation of `_.isMatch` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Array} matchData The propery names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparing objects.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = toObject(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var result = customizer ? customizer(objValue, srcValue, key) : undefined;
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) return false;
        }
    }
    return true;
}
module.exports = baseIsMatch;

},{"dc33dd1b5d323fee":"hWQlN","80fd9bd9aa3633d7":"3Gay2"}],"hWQlN":[function(require,module,exports,__globalThis) {
var baseIsEqualDeep = require("3e42096b63000d4"), isObject = require("819380694f51566e"), isObjectLike = require("6a22d4707a736c83");
/**
 * The base implementation of `_.isEqual` without support for `this` binding
 * `customizer` functions.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparing values.
 * @param {boolean} [isLoose] Specify performing partial comparisons.
 * @param {Array} [stackA] Tracks traversed `value` objects.
 * @param {Array} [stackB] Tracks traversed `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
    if (value === other) return true;
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
}
module.exports = baseIsEqual;

},{"3e42096b63000d4":"bn62n","819380694f51566e":"2h87f","6a22d4707a736c83":"wRUw9"}],"bn62n":[function(require,module,exports,__globalThis) {
var equalArrays = require("86b2cfb40ad92e95"), equalByTag = require("29d2cd8682303fd"), equalObjects = require("fc8c69efc5417ebd"), isArray = require("b7e399f8a30e396c"), isHostObject = require("2b6ece1ef8d345a5"), isTypedArray = require("14bad758f925c258");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', objectTag = '[object Object]';
/** Used for native method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var objToString = objectProto.toString;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparing objects.
 * @param {boolean} [isLoose] Specify performing partial comparisons.
 * @param {Array} [stackA=[]] Tracks traversed `value` objects.
 * @param {Array} [stackB=[]] Tracks traversed `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
        objTag = objToString.call(object);
        if (objTag == argsTag) objTag = objectTag;
        else if (objTag != objectTag) objIsArr = isTypedArray(object);
    }
    if (!othIsArr) {
        othTag = objToString.call(other);
        if (othTag == argsTag) othTag = objectTag;
        else if (othTag != objectTag) othIsArr = isTypedArray(other);
    }
    var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
    if (isSameTag && !(objIsArr || objIsObj)) return equalByTag(object, other, objTag);
    if (!isLoose) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
    }
    if (!isSameTag) return false;
    // Assume cyclic values are equal.
    // For more information on detecting circular references see https://es5.github.io/#JO.
    stackA || (stackA = []);
    stackB || (stackB = []);
    var length = stackA.length;
    while(length--){
        if (stackA[length] == object) return stackB[length] == other;
    }
    // Add `object` and `other` to the stack of traversed objects.
    stackA.push(object);
    stackB.push(other);
    var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
    stackA.pop();
    stackB.pop();
    return result;
}
module.exports = baseIsEqualDeep;

},{"86b2cfb40ad92e95":"hOj47","29d2cd8682303fd":"j88e9","fc8c69efc5417ebd":"drdAJ","b7e399f8a30e396c":"42oZf","2b6ece1ef8d345a5":"8j3dt","14bad758f925c258":"fkW6g"}],"hOj47":[function(require,module,exports,__globalThis) {
var arraySome = require("9623b4fc51b82455");
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparing arrays.
 * @param {boolean} [isLoose] Specify performing partial comparisons.
 * @param {Array} [stackA] Tracks traversed `value` objects.
 * @param {Array} [stackB] Tracks traversed `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
    var index = -1, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isLoose && othLength > arrLength)) return false;
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index], result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
        if (result !== undefined) {
            if (result) continue;
            return false;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (isLoose) {
            if (!arraySome(other, function(othValue) {
                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
            })) return false;
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) return false;
    }
    return true;
}
module.exports = equalArrays;

},{"9623b4fc51b82455":"50et1"}],"50et1":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.some` for arrays without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = arraySome;

},{}],"j88e9":[function(require,module,exports,__globalThis) {
/** `Object#toString` result references. */ var boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', numberTag = '[object Number]', regexpTag = '[object RegExp]', stringTag = '[object String]';
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag) {
    switch(tag){
        case boolTag:
        case dateTag:
            // Coerce dates and booleans to numbers, dates to milliseconds and booleans
            // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
            return +object == +other;
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case numberTag:
            // Treat `NaN` vs. `NaN` as equal.
            return object != +object ? other != +other : object == +other;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings primitives and string
            // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
            return object == other + '';
    }
    return false;
}
module.exports = equalByTag;

},{}],"drdAJ":[function(require,module,exports,__globalThis) {
var keys = require("3be410a84702733e");
/** Used for native method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparing values.
 * @param {boolean} [isLoose] Specify performing partial comparisons.
 * @param {Array} [stackA] Tracks traversed `value` objects.
 * @param {Array} [stackB] Tracks traversed `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
    var objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isLoose) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    var skipCtor = isLoose;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key], result = customizer ? customizer(isLoose ? othValue : objValue, isLoose ? objValue : othValue, key) : undefined;
        // Recursively compare objects (susceptible to call stack limits).
        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) return false;
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (!skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) return false;
    }
    return true;
}
module.exports = equalObjects;

},{"3be410a84702733e":"dWOkG"}],"fkW6g":[function(require,module,exports,__globalThis) {
var isLength = require("71c317b8e318231b"), isObjectLike = require("9b523d0db7d6e3e9");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Used for native method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var objToString = objectProto.toString;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ function isTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
}
module.exports = isTypedArray;

},{"71c317b8e318231b":"j1Pbs","9b523d0db7d6e3e9":"wRUw9"}],"a9Lxz":[function(require,module,exports,__globalThis) {
var isStrictComparable = require("d799a7ccf21bcdc1"), pairs = require("80daa28946696e81");
/**
 * Gets the propery names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = pairs(object), length = result.length;
    while(length--)result[length][2] = isStrictComparable(result[length][1]);
    return result;
}
module.exports = getMatchData;

},{"d799a7ccf21bcdc1":"4Am1I","80daa28946696e81":"7I5hP"}],"4Am1I":[function(require,module,exports,__globalThis) {
var isObject = require("2be7fd19684a2495");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
module.exports = isStrictComparable;

},{"2be7fd19684a2495":"2h87f"}],"7I5hP":[function(require,module,exports,__globalThis) {
var keys = require("411820d27cc03707"), toObject = require("37d1849a2bfdcd6e");
/**
 * Creates a two dimensional array of the key-value pairs for `object`,
 * e.g. `[[key1, value1], [key2, value2]]`.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the new array of key-value pairs.
 * @example
 *
 * _.pairs({ 'barney': 36, 'fred': 40 });
 * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
 */ function pairs(object) {
    object = toObject(object);
    var index = -1, props = keys(object), length = props.length, result = Array(length);
    while(++index < length){
        var key = props[index];
        result[index] = [
            key,
            object[key]
        ];
    }
    return result;
}
module.exports = pairs;

},{"411820d27cc03707":"dWOkG","37d1849a2bfdcd6e":"3Gay2"}],"aUce1":[function(require,module,exports,__globalThis) {
var baseGet = require("4569c4c5769c0b36"), baseIsEqual = require("cedc5628950534f1"), baseSlice = require("53f33d90b019aea7"), isArray = require("1b3e16a956263cd8"), isKey = require("5dd97822b59c3ab0"), isStrictComparable = require("4044b284e347b6e0"), last = require("f97125ce63b98e1a"), toObject = require("e79edb743b506d6"), toPath = require("2663da52adea66b4");
/**
 * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to compare.
 * @returns {Function} Returns the new function.
 */ function baseMatchesProperty(path, srcValue) {
    var isArr = isArray(path), isCommon = isKey(path) && isStrictComparable(srcValue), pathKey = path + '';
    path = toPath(path);
    return function(object) {
        if (object == null) return false;
        var key = pathKey;
        object = toObject(object);
        if ((isArr || !isCommon) && !(key in object)) {
            object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
            if (object == null) return false;
            key = last(path);
            object = toObject(object);
        }
        return object[key] === srcValue ? srcValue !== undefined || key in object : baseIsEqual(srcValue, object[key], undefined, true);
    };
}
module.exports = baseMatchesProperty;

},{"4569c4c5769c0b36":"gKddT","cedc5628950534f1":"hWQlN","53f33d90b019aea7":"95ctC","1b3e16a956263cd8":"42oZf","5dd97822b59c3ab0":"fW9jb","4044b284e347b6e0":"4Am1I","f97125ce63b98e1a":"2S4LE","e79edb743b506d6":"3Gay2","2663da52adea66b4":"8TPiL"}],"gKddT":[function(require,module,exports,__globalThis) {
var toObject = require("a50d3ebae2ccb092");
/**
 * The base implementation of `get` without support for string paths
 * and default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path of the property to get.
 * @param {string} [pathKey] The key representation of path.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path, pathKey) {
    if (object == null) return;
    object = toObject(object);
    if (pathKey !== undefined && pathKey in object) path = [
        pathKey
    ];
    var index = 0, length = path.length;
    while(object != null && index < length)object = toObject(object)[path[index++]];
    return index && index == length ? object : undefined;
}
module.exports = baseGet;

},{"a50d3ebae2ccb092":"3Gay2"}],"95ctC":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function baseSlice(array, start, end) {
    var index = -1, length = array.length;
    start = start == null ? 0 : +start || 0;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end === undefined || end > length ? length : +end || 0;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = baseSlice;

},{}],"fW9jb":[function(require,module,exports,__globalThis) {
var isArray = require("52b87061d680b684"), toObject = require("ae4f38b228e257d9");
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    var type = typeof value;
    if (type == 'string' && reIsPlainProp.test(value) || type == 'number') return true;
    if (isArray(value)) return false;
    var result = !reIsDeepProp.test(value);
    return result || object != null && value in toObject(object);
}
module.exports = isKey;

},{"52b87061d680b684":"42oZf","ae4f38b228e257d9":"3Gay2"}],"2S4LE":[function(require,module,exports,__globalThis) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function last(array) {
    var length = array ? array.length : 0;
    return length ? array[length - 1] : undefined;
}
module.exports = last;

},{}],"8TPiL":[function(require,module,exports,__globalThis) {
var baseToString = require("afedbdbab22a93f6"), isArray = require("7c5dcce97d0bf806");
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `value` to property path array if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Array} Returns the property path array.
 */ function toPath(value) {
    if (isArray(value)) return value;
    var result = [];
    baseToString(value).replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
}
module.exports = toPath;

},{"afedbdbab22a93f6":"b1x8h","7c5dcce97d0bf806":"42oZf"}],"b1x8h":[function(require,module,exports,__globalThis) {
/**
 * Converts `value` to a string if it's not one. An empty string is returned
 * for `null` or `undefined` values.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    return value == null ? '' : value + '';
}
module.exports = baseToString;

},{}],"cFlpm":[function(require,module,exports,__globalThis) {
var baseProperty = require("98bf3a8040564cab"), basePropertyDeep = require("cc26ed7c3eef5dbc"), isKey = require("44787d5028a66020");
/**
 * Creates a function that returns the property value at `path` on a
 * given object.
 *
 * @static
 * @memberOf _
 * @category Utility
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': { 'c': 2 } } },
 *   { 'a': { 'b': { 'c': 1 } } }
 * ];
 *
 * _.map(objects, _.property('a.b.c'));
 * // => [2, 1]
 *
 * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
}
module.exports = property;

},{"98bf3a8040564cab":"deK74","cc26ed7c3eef5dbc":"ZYWy9","44787d5028a66020":"fW9jb"}],"ZYWy9":[function(require,module,exports,__globalThis) {
var baseGet = require("18d869d07de381b5"), toPath = require("42d07e6736a67b73");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new function.
 */ function basePropertyDeep(path) {
    var pathKey = path + '';
    path = toPath(path);
    return function(object) {
        return baseGet(object, path, pathKey);
    };
}
module.exports = basePropertyDeep;

},{"18d869d07de381b5":"gKddT","42d07e6736a67b73":"8TPiL"}],"i71Px":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
 * without support for callback shorthands and `this` binding, which iterates
 * over `collection` using the provided `eachFunc`.
 *
 * @private
 * @param {Array|Object|string} collection The collection to search.
 * @param {Function} predicate The function invoked per iteration.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @param {boolean} [retKey] Specify returning the key of the found element
 *  instead of the element itself.
 * @returns {*} Returns the found element or its key, else `undefined`.
 */ function baseFind(collection, predicate, eachFunc, retKey) {
    var result;
    eachFunc(collection, function(value, key, collection) {
        if (predicate(value, key, collection)) {
            result = retKey ? key : value;
            return false;
        }
    });
    return result;
}
module.exports = baseFind;

},{}],"61ODT":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for callback shorthands and `this` binding.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {Function} predicate The function invoked per iteration.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseFindIndex(array, predicate, fromRight) {
    var length = array.length, index = fromRight ? length : -1;
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = baseFindIndex;

},{}],"kKkpQ":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function isUndefined(value) {
    return value === undefined;
}
module.exports = isUndefined;

},{}],"aepyO":[function(require,module,exports,__globalThis) {
'use strict';
var log = require("1ef8d4eccc543a62").log;
var _ = {
    isPlainObject: require("7d119803d4c97bb0"),
    isString: require("192cd42dbe3e99d4")
};
var SchemaMarkup = require("a354c7a61144f05d");
var jsyaml = require("556c1a32e15cdd33");
var Model = module.exports = function(name, definition, models, modelPropertyMacro) {
    this.definition = definition || {};
    this.isArray = definition.type === 'array';
    this.models = models || {};
    this.name = name || definition.title || 'Inline Model';
    this.modelPropertyMacro = modelPropertyMacro || function(property) {
        return property.default;
    };
    return this;
};
// Note!  This function will be removed in 2.2.x!
Model.prototype.createJSONSample = Model.prototype.getSampleValue = function(modelsToIgnore) {
    modelsToIgnore = modelsToIgnore || {};
    modelsToIgnore[this.name] = this;
    // Response support
    if (this.examples && _.isPlainObject(this.examples) && this.examples['application/json']) {
        this.definition.example = this.examples['application/json'];
        if (_.isString(this.definition.example)) this.definition.example = jsyaml.safeLoad(this.definition.example);
    } else if (!this.definition.example) this.definition.example = this.examples;
    return SchemaMarkup.schemaToJSON(this.definition, this.models, modelsToIgnore, this.modelPropertyMacro);
};
Model.prototype.getMockSignature = function() {
    return SchemaMarkup.schemaToHTML(this.name, this.definition, this.models, this.modelPropertyMacro);
};

},{"1ef8d4eccc543a62":"7AAzh","7d119803d4c97bb0":"i4FFk","192cd42dbe3e99d4":"eSX4L","a354c7a61144f05d":"6Sl8F","556c1a32e15cdd33":"3sPhj"}],"6Sl8F":[function(require,module,exports,__globalThis) {
'use strict';
var Helpers = require("6ab2bf051f5c58f2");
var _ = {
    isPlainObject: require("a2f0388865df0579"),
    isUndefined: require("66e843b4ec58d4b3"),
    isArray: require("8310bd71e0af8aaa"),
    isObject: require("a2d018c7a81b0993"),
    isEmpty: require("a794b307c9dac71c"),
    map: require("a52fdf4ac2542975"),
    indexOf: require("56c512b05c947745"),
    cloneDeep: require("22b4eab86cf9a3e7"),
    keys: require("abebd6ac71afa2e7"),
    forEach: require("3177ae7de8301d43")
};
module.exports.optionHtml = optionHtml;
module.exports.typeFromJsonSchema = typeFromJsonSchema;
module.exports.getStringSignature = getStringSignature;
module.exports.schemaToHTML = schemaToHTML;
module.exports.schemaToJSON = schemaToJSON;
function optionHtml(label, value) {
    return '<tr><td class="optionName">' + label + ':</td><td>' + value + '</td></tr>';
}
function typeFromJsonSchema(type, format) {
    var str;
    if (type === 'integer' && format === 'int32') str = 'integer';
    else if (type === 'integer' && format === 'int64') str = 'long';
    else if (type === 'integer' && typeof format === 'undefined') str = 'long';
    else if (type === 'string' && format === 'date-time') str = 'date-time';
    else if (type === 'string' && format === 'date') str = 'date';
    else if (type === 'number' && format === 'float') str = 'float';
    else if (type === 'number' && format === 'double') str = 'double';
    else if (type === 'number' && typeof format === 'undefined') str = 'double';
    else if (type === 'boolean') str = 'boolean';
    else if (type === 'string') str = 'string';
    return str;
}
function getStringSignature(obj, baseComponent) {
    var str = '';
    if (typeof obj.$ref !== 'undefined') str += Helpers.simpleRef(obj.$ref);
    else if (typeof obj.type === 'undefined') str += 'object';
    else if (obj.type === 'array') {
        if (baseComponent) str += getStringSignature(obj.items || obj.$ref || {});
        else {
            str += 'Array[';
            str += getStringSignature(obj.items || obj.$ref || {});
            str += ']';
        }
    } else if (obj.type === 'integer' && obj.format === 'int32') str += 'integer';
    else if (obj.type === 'integer' && obj.format === 'int64') str += 'long';
    else if (obj.type === 'integer' && typeof obj.format === 'undefined') str += 'long';
    else if (obj.type === 'string' && obj.format === 'date-time') str += 'date-time';
    else if (obj.type === 'string' && obj.format === 'date') str += 'date';
    else if (obj.type === 'string' && typeof obj.format === 'undefined') str += 'string';
    else if (obj.type === 'number' && obj.format === 'float') str += 'float';
    else if (obj.type === 'number' && obj.format === 'double') str += 'double';
    else if (obj.type === 'number' && typeof obj.format === 'undefined') str += 'double';
    else if (obj.type === 'boolean') str += 'boolean';
    else if (obj.$ref) str += Helpers.simpleRef(obj.$ref);
    else str += obj.type;
    return str;
}
function schemaToJSON(schema, models, modelsToIgnore, modelPropertyMacro) {
    // Resolve the schema (Handle nested schemas)
    schema = Helpers.resolveSchema(schema);
    if (typeof modelPropertyMacro !== 'function') modelPropertyMacro = function(prop) {
        return (prop || {}).default;
    };
    modelsToIgnore = modelsToIgnore || {};
    var type = schema.type || 'object';
    var format = schema.format;
    var model;
    var output;
    if (!_.isUndefined(schema.example)) output = schema.example;
    else if (_.isUndefined(schema.items) && _.isArray(schema.enum)) output = schema.enum[0];
    if (_.isUndefined(output)) {
        if (schema.$ref) {
            model = models[Helpers.simpleRef(schema.$ref)];
            if (!_.isUndefined(model)) {
                if (_.isUndefined(modelsToIgnore[model.name])) {
                    modelsToIgnore[model.name] = model;
                    output = schemaToJSON(model.definition, models, modelsToIgnore, modelPropertyMacro);
                    delete modelsToIgnore[model.name];
                } else if (model.type === 'array') output = [];
                else output = {};
            }
        } else if (!_.isUndefined(schema.default)) output = schema.default;
        else if (type === 'string') {
            if (format === 'date-time') output = new Date().toISOString();
            else if (format === 'date') output = new Date().toISOString().split('T')[0];
            else output = 'string';
        } else if (type === 'integer') output = 0;
        else if (type === 'number') output = 0.0;
        else if (type === 'boolean') output = true;
        else if (type === 'object') {
            output = {};
            _.forEach(schema.properties, function(property, name) {
                var cProperty = _.cloneDeep(property);
                // Allow macro to set the default value
                cProperty.default = modelPropertyMacro(property);
                output[name] = schemaToJSON(cProperty, models, modelsToIgnore, modelPropertyMacro);
            });
        } else if (type === 'array') {
            output = [];
            if (_.isArray(schema.items)) _.forEach(schema.items, function(item) {
                output.push(schemaToJSON(item, models, modelsToIgnore, modelPropertyMacro));
            });
            else if (_.isPlainObject(schema.items)) output.push(schemaToJSON(schema.items, models, modelsToIgnore, modelPropertyMacro));
            else if (_.isUndefined(schema.items)) output.push({});
            else Helpers.log('Array type\'s \'items\' property is not an array or an object, cannot process');
        }
    }
    return output;
}
function schemaToHTML(name, schema, models, modelPropertyMacro) {
    var strongOpen = '<span class="strong">';
    var strongClose = '</span>';
    // Allow for ignoring the 'name' argument.... shifting the rest
    if (_.isObject(arguments[0])) {
        name = void 0;
        schema = arguments[0];
        models = arguments[1];
        modelPropertyMacro = arguments[2];
    }
    models = models || {};
    // Resolve the schema (Handle nested schemas)
    schema = Helpers.resolveSchema(schema);
    // Return for empty object
    if (_.isEmpty(schema)) return strongOpen + 'Empty' + strongClose;
    // Dereference $ref from 'models'
    if (typeof schema.$ref === 'string') {
        name = Helpers.simpleRef(schema.$ref);
        schema = models[name];
        if (typeof schema === 'undefined') return strongOpen + name + ' is not defined!' + strongClose;
    }
    if (typeof name !== 'string') name = schema.title || 'Inline Model';
    // If we are a Model object... adjust accordingly
    if (schema.definition) schema = schema.definition;
    if (typeof modelPropertyMacro !== 'function') modelPropertyMacro = function(prop) {
        return (prop || {}).default;
    };
    var references = {};
    var seenModels = [];
    var inlineModels = 0;
    // Generate current HTML
    var html = processModel(schema, name);
    // Generate references HTML
    while(_.keys(references).length > 0)/* jshint ignore:start */ _.forEach(references, function(schema, name) {
        var seenModel = _.indexOf(seenModels, name) > -1;
        delete references[name];
        if (!seenModel) {
            seenModels.push(name);
            html += '<br />' + processModel(schema, name);
        }
    });
    return html;
    /////////////////////////////////
    function addReference(schema, name, skipRef) {
        var modelName = name;
        var model;
        if (schema.$ref) {
            modelName = schema.title || Helpers.simpleRef(schema.$ref);
            model = models[modelName];
        } else if (_.isUndefined(name)) {
            modelName = schema.title || 'Inline Model ' + ++inlineModels;
            model = {
                definition: schema
            };
        }
        if (skipRef !== true) references[modelName] = _.isUndefined(model) ? {} : model.definition;
        return modelName;
    }
    function primitiveToHTML(schema) {
        var html = '<span class="propType">';
        var type = schema.type || 'object';
        if (schema.$ref) html += addReference(schema, Helpers.simpleRef(schema.$ref));
        else if (type === 'object') {
            if (!_.isUndefined(schema.properties)) html += addReference(schema);
            else html += 'object';
        } else if (type === 'array') {
            html += 'Array[';
            if (_.isArray(schema.items)) html += _.map(schema.items, addReference).join(',');
            else if (_.isPlainObject(schema.items)) {
                if (_.isUndefined(schema.items.$ref)) {
                    if (!_.isUndefined(schema.items.type) && _.indexOf([
                        'array',
                        'object'
                    ], schema.items.type) === -1) html += schema.items.type;
                    else html += addReference(schema.items);
                } else html += addReference(schema.items, Helpers.simpleRef(schema.items.$ref));
            } else {
                Helpers.log('Array type\'s \'items\' schema is not an array or an object, cannot process');
                html += 'object';
            }
            html += ']';
        } else html += schema.type;
        html += '</span>';
        return html;
    }
    function primitiveToOptionsHTML(schema, html) {
        var options = '';
        var type = schema.type || 'object';
        var isArray = type === 'array';
        if (isArray) {
            if (_.isPlainObject(schema.items) && !_.isUndefined(schema.items.type)) type = schema.items.type;
            else type = 'object';
        }
        if (!_.isUndefined(schema.default)) options += optionHtml('Default', schema.default);
        switch(type){
            case 'string':
                if (schema.minLength) options += optionHtml('Min. Length', schema.minLength);
                if (schema.maxLength) options += optionHtml('Max. Length', schema.maxLength);
                if (schema.pattern) options += optionHtml('Reg. Exp.', schema.pattern);
                break;
            case 'integer':
            case 'number':
                if (schema.minimum) options += optionHtml('Min. Value', schema.minimum);
                if (schema.exclusiveMinimum) options += optionHtml('Exclusive Min.', 'true');
                if (schema.maximum) options += optionHtml('Max. Value', schema.maximum);
                if (schema.exclusiveMaximum) options += optionHtml('Exclusive Max.', 'true');
                if (schema.multipleOf) options += optionHtml('Multiple Of', schema.multipleOf);
                break;
        }
        if (isArray) {
            if (schema.minItems) options += optionHtml('Min. Items', schema.minItems);
            if (schema.maxItems) options += optionHtml('Max. Items', schema.maxItems);
            if (schema.uniqueItems) options += optionHtml('Unique Items', 'true');
            if (schema.collectionFormat) options += optionHtml('Coll. Format', schema.collectionFormat);
        }
        if (_.isUndefined(schema.items)) {
            if (_.isArray(schema.enum)) {
                var enumString;
                if (type === 'number' || type === 'integer') enumString = schema.enum.join(', ');
                else enumString = '"' + schema.enum.join('", "') + '"';
                options += optionHtml('Enum', enumString);
            }
        }
        if (options.length > 0) html = '<span class="propWrap">' + html + '<table class="optionsWrapper"><tr><th colspan="2">' + type + '</th></tr>' + options + '</table></span>';
        return html;
    }
    function processModel(schema, name) {
        var type = schema.type || 'object';
        var isArray = schema.type === 'array';
        var html = strongOpen + name + ' ' + (isArray ? '[' : '{') + strongClose;
        if (name) seenModels.push(name);
        if (isArray) {
            if (_.isArray(schema.items)) html += '<div>' + _.map(schema.items, function(item) {
                var type = item.type || 'object';
                if (_.isUndefined(item.$ref)) {
                    if (_.indexOf([
                        'array',
                        'object'
                    ], type) > -1) {
                        if (type === 'object' && _.isUndefined(item.properties)) return 'object';
                        else return addReference(item);
                    } else return primitiveToOptionsHTML(item, type);
                } else return addReference(item, Helpers.simpleRef(item.$ref));
            }).join(',</div><div>');
            else if (_.isPlainObject(schema.items)) {
                if (_.isUndefined(schema.items.$ref)) {
                    if (_.indexOf([
                        'array',
                        'object'
                    ], schema.items.type || 'object') > -1) {
                        if ((_.isUndefined(schema.items.type) || schema.items.type === 'object') && _.isUndefined(schema.items.properties)) html += '<div>object</div>';
                        else html += '<div>' + addReference(schema.items) + '</div>';
                    } else html += '<div>' + primitiveToOptionsHTML(schema.items, schema.items.type) + '</div>';
                } else html += '<div>' + addReference(schema.items, Helpers.simpleRef(schema.items.$ref)) + '</div>';
            } else {
                Helpers.log('Array type\'s \'items\' property is not an array or an object, cannot process');
                html += '<div>object</div>';
            }
        } else {
            if (schema.$ref) html += '<div>' + addReference(schema, name) + '</div>';
            else if (type === 'object') {
                if (_.isPlainObject(schema.properties)) {
                    var contents = _.map(schema.properties, function(property, name) {
                        var propertyIsRequired = _.indexOf(schema.required, name) >= 0;
                        var cProperty = _.cloneDeep(property);
                        var requiredClass = propertyIsRequired ? 'required' : '';
                        var html = '<span class="propName ' + requiredClass + '">' + name + '</span> (';
                        var model;
                        var propDescription;
                        // Allow macro to set the default value
                        cProperty.default = modelPropertyMacro(cProperty);
                        // Resolve the schema (Handle nested schemas)
                        cProperty = Helpers.resolveSchema(cProperty);
                        propDescription = property.description || cProperty.description;
                        // We need to handle property references to primitives (Issue 339)
                        if (!_.isUndefined(cProperty.$ref)) {
                            model = models[Helpers.simpleRef(cProperty.$ref)];
                            if (!_.isUndefined(model) && _.indexOf([
                                undefined,
                                'array',
                                'object'
                            ], model.definition.type) === -1) // Use referenced schema
                            cProperty = Helpers.resolveSchema(model.definition);
                        }
                        html += primitiveToHTML(cProperty);
                        if (!propertyIsRequired) html += ', <span class="propOptKey">optional</span>';
                        if (property.readOnly) html += ', <span class="propReadOnly">read only</span>';
                        html += ')';
                        if (!_.isUndefined(propDescription)) html += ': <span class="propDesc">' + propDescription + '</span>';
                        if (cProperty.enum) html += ' = <span class="propVals">[\'' + cProperty.enum.join('\', \'') + '\']</span>';
                        return '<div' + (property.readOnly ? ' class="readOnly"' : '') + '>' + primitiveToOptionsHTML(cProperty, html);
                    }).join(',</div>');
                    if (contents) html += contents + '</div>';
                }
            } else html += '<div>' + primitiveToOptionsHTML(schema, type) + '</div>';
        }
        return html + strongOpen + (isArray ? ']' : '}') + strongClose;
    }
}

},{"6ab2bf051f5c58f2":"7AAzh","a2f0388865df0579":"i4FFk","66e843b4ec58d4b3":"kKkpQ","8310bd71e0af8aaa":"42oZf","a2d018c7a81b0993":"2h87f","a794b307c9dac71c":"7DG4c","a52fdf4ac2542975":"anI1V","56c512b05c947745":"FlPsZ","22b4eab86cf9a3e7":"7UzDg","abebd6ac71afa2e7":"dWOkG","3177ae7de8301d43":"9dHGp"}],"7DG4c":[function(require,module,exports,__globalThis) {
var isArguments = require("33b88c540d62a451"), isArray = require("6940a2746f0fd1c1"), isArrayLike = require("901923792717e7de"), isFunction = require("84513eb97b47a929"), isObjectLike = require("e11738f8dd10b3ae"), isString = require("2309ecaf9c85a07a"), keys = require("a138951eb8b30c9a");
/**
 * Checks if `value` is empty. A value is considered empty unless it's an
 * `arguments` object, array, string, or jQuery-like collection with a length
 * greater than `0` or an object with own enumerable properties.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {Array|Object|string} value The value to inspect.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function isEmpty(value) {
    if (value == null) return true;
    if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) || isObjectLike(value) && isFunction(value.splice))) return !value.length;
    return !keys(value).length;
}
module.exports = isEmpty;

},{"33b88c540d62a451":"jI8K5","6940a2746f0fd1c1":"42oZf","901923792717e7de":"lXCsV","84513eb97b47a929":"fTvdo","e11738f8dd10b3ae":"wRUw9","2309ecaf9c85a07a":"eSX4L","a138951eb8b30c9a":"dWOkG"}],"anI1V":[function(require,module,exports,__globalThis) {
var arrayMap = require("75f5879d53acd805"), baseCallback = require("d24123d5e8fb3b60"), baseMap = require("f6a499ab6f77dec8"), isArray = require("3c740b2b93b07a89");
/**
 * Creates an array of values by running each element in `collection` through
 * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
 * arguments: (value, index|key, collection).
 *
 * If a property name is provided for `iteratee` the created `_.property`
 * style callback returns the property value of the given element.
 *
 * If a value is also provided for `thisArg` the created `_.matchesProperty`
 * style callback returns `true` for elements that have a matching property
 * value, else `false`.
 *
 * If an object is provided for `iteratee` the created `_.matches` style
 * callback returns `true` for elements that have the properties of the given
 * object, else `false`.
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
 * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
 * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
 * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
 * `sum`, `uniq`, and `words`
 *
 * @static
 * @memberOf _
 * @alias collect
 * @category Collection
 * @param {Array|Object|string} collection The collection to iterate over.
 * @param {Function|Object|string} [iteratee=_.identity] The function invoked
 *  per iteration.
 * @param {*} [thisArg] The `this` binding of `iteratee`.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function timesThree(n) {
 *   return n * 3;
 * }
 *
 * _.map([1, 2], timesThree);
 * // => [3, 6]
 *
 * _.map({ 'a': 1, 'b': 2 }, timesThree);
 * // => [3, 6] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // using the `_.property` callback shorthand
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function map(collection, iteratee, thisArg) {
    var func = isArray(collection) ? arrayMap : baseMap;
    iteratee = baseCallback(iteratee, thisArg, 3);
    return func(collection, iteratee);
}
module.exports = map;

},{"75f5879d53acd805":"948IB","d24123d5e8fb3b60":"i2vSs","f6a499ab6f77dec8":"gwUGG","3c740b2b93b07a89":"42oZf"}],"948IB":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.map` for arrays without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = arrayMap;

},{}],"gwUGG":[function(require,module,exports,__globalThis) {
var baseEach = require("1f4eb3f34674e253"), isArrayLike = require("c62b329cf6eea491");
/**
 * The base implementation of `_.map` without support for callback shorthands
 * and `this` binding.
 *
 * @private
 * @param {Array|Object|string} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function baseMap(collection, iteratee) {
    var index = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
    baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = baseMap;

},{"1f4eb3f34674e253":"lyAU9","c62b329cf6eea491":"lXCsV"}],"3sPhj":[function(require,module,exports,__globalThis) {
'use strict';
var yaml = require("ee6c599fd8289ab2");
module.exports = yaml;

},{"ee6c599fd8289ab2":"9mucZ"}],"9mucZ":[function(require,module,exports,__globalThis) {
'use strict';
var loader = require("9769ed3c29fb30b4");
var dumper = require("b6ffba4d804b9ba6");
function deprecated(name) {
    return function() {
        throw new Error('Function ' + name + ' is deprecated and cannot be used.');
    };
}
module.exports.Type = require("181276e190c64f1a");
module.exports.Schema = require("8a1fe35d5b1cf12a");
module.exports.FAILSAFE_SCHEMA = require("d0814dfad240ff8b");
module.exports.JSON_SCHEMA = require("ae049f94184b4873");
module.exports.CORE_SCHEMA = require("112da38f59e20383");
module.exports.DEFAULT_SAFE_SCHEMA = require("8101c6d7311c0a80");
module.exports.DEFAULT_FULL_SCHEMA = require("c7cdc32365e3fa73");
module.exports.load = loader.load;
module.exports.loadAll = loader.loadAll;
module.exports.safeLoad = loader.safeLoad;
module.exports.safeLoadAll = loader.safeLoadAll;
module.exports.dump = dumper.dump;
module.exports.safeDump = dumper.safeDump;
module.exports.YAMLException = require("15cb9194040c7f74");
// Deprecated schema names from JS-YAML 2.0.x
module.exports.MINIMAL_SCHEMA = require("d0814dfad240ff8b");
module.exports.SAFE_SCHEMA = require("8101c6d7311c0a80");
module.exports.DEFAULT_SCHEMA = require("c7cdc32365e3fa73");
// Deprecated functions from JS-YAML 1.x.x
module.exports.scan = deprecated('scan');
module.exports.parse = deprecated('parse');
module.exports.compose = deprecated('compose');
module.exports.addConstructor = deprecated('addConstructor');

},{"9769ed3c29fb30b4":"650iU","b6ffba4d804b9ba6":"6bpv3","181276e190c64f1a":"kPZ9d","8a1fe35d5b1cf12a":"dwfqa","d0814dfad240ff8b":"6prT0","ae049f94184b4873":"a2kJO","112da38f59e20383":"8O4Hw","8101c6d7311c0a80":"hKMmA","c7cdc32365e3fa73":"dRAq3","15cb9194040c7f74":"9ywNX"}],"650iU":[function(require,module,exports,__globalThis) {
'use strict';
/*eslint-disable max-len,no-use-before-define*/ var common = require("2508ac67c7eb7572");
var YAMLException = require("65cc866ae17c6738");
var Mark = require("f4cf36d9b894e032");
var DEFAULT_SAFE_SCHEMA = require("9104f1efefb8b906");
var DEFAULT_FULL_SCHEMA = require("9c5aee641539b20b");
var _hasOwnProperty = Object.prototype.hasOwnProperty;
var CONTEXT_FLOW_IN = 1;
var CONTEXT_FLOW_OUT = 2;
var CONTEXT_BLOCK_IN = 3;
var CONTEXT_BLOCK_OUT = 4;
var CHOMPING_CLIP = 1;
var CHOMPING_STRIP = 2;
var CHOMPING_KEEP = 3;
var PATTERN_NON_PRINTABLE = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x84\x86-\x9F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
var PATTERN_NON_ASCII_LINE_BREAKS = /[\x85\u2028\u2029]/;
var PATTERN_FLOW_INDICATORS = /[,\[\]\{\}]/;
var PATTERN_TAG_HANDLE = /^(?:!|!!|![a-z\-]+!)$/i;
var PATTERN_TAG_URI = /^(?:!|[^,\[\]\{\}])(?:%[0-9a-f]{2}|[0-9a-z\-#;\/\?:@&=\+\$,_\.!~\*'\(\)\[\]])*$/i;
function _class(obj) {
    return Object.prototype.toString.call(obj);
}
function is_EOL(c) {
    return c === 0x0A /* LF */  || c === 0x0D /* CR */ ;
}
function is_WHITE_SPACE(c) {
    return c === 0x09 /* Tab */  || c === 0x20 /* Space */ ;
}
function is_WS_OR_EOL(c) {
    return c === 0x09 /* Tab */  || c === 0x20 /* Space */  || c === 0x0A /* LF */  || c === 0x0D /* CR */ ;
}
function is_FLOW_INDICATOR(c) {
    return c === 0x2C /* , */  || c === 0x5B /* [ */  || c === 0x5D /* ] */  || c === 0x7B /* { */  || c === 0x7D /* } */ ;
}
function fromHexCode(c) {
    var lc;
    if (0x30 /* 0 */  <= c && c <= 0x39 /* 9 */ ) return c - 0x30;
    /*eslint-disable no-bitwise*/ lc = c | 0x20;
    if (0x61 /* a */  <= lc && lc <= 0x66 /* f */ ) return lc - 0x61 + 10;
    return -1;
}
function escapedHexLen(c) {
    if (c === 0x78 /* x */ ) return 2;
    if (c === 0x75 /* u */ ) return 4;
    if (c === 0x55 /* U */ ) return 8;
    return 0;
}
function fromDecimalCode(c) {
    if (0x30 /* 0 */  <= c && c <= 0x39 /* 9 */ ) return c - 0x30;
    return -1;
}
function simpleEscapeSequence(c) {
    /* eslint-disable indent */ return c === 0x30 /* 0 */  ? '\x00' : c === 0x61 /* a */  ? '\x07' : c === 0x62 /* b */  ? '\x08' : c === 0x74 /* t */  ? '\x09' : c === 0x09 /* Tab */  ? '\x09' : c === 0x6E /* n */  ? '\x0A' : c === 0x76 /* v */  ? '\x0B' : c === 0x66 /* f */  ? '\x0C' : c === 0x72 /* r */  ? '\x0D' : c === 0x65 /* e */  ? '\x1B' : c === 0x20 /* Space */  ? ' ' : c === 0x22 /* " */  ? '\x22' : c === 0x2F /* / */  ? '/' : c === 0x5C /* \ */  ? '\x5C' : c === 0x4E /* N */  ? '\x85' : c === 0x5F /* _ */  ? '\xA0' : c === 0x4C /* L */  ? '\u2028' : c === 0x50 /* P */  ? '\u2029' : '';
}
function charFromCodepoint(c) {
    if (c <= 0xFFFF) return String.fromCharCode(c);
    // Encode UTF-16 surrogate pair
    // https://en.wikipedia.org/wiki/UTF-16#Code_points_U.2B010000_to_U.2B10FFFF
    return String.fromCharCode((c - 0x010000 >> 10) + 0xD800, (c - 0x010000 & 0x03FF) + 0xDC00);
}
// set a property of a literal object, while protecting against prototype pollution,
// see https://github.com/nodeca/js-yaml/issues/164 for more details
function setProperty(object, key, value) {
    // used for this specific key only because Object.defineProperty is slow
    if (key === '__proto__') Object.defineProperty(object, key, {
        configurable: true,
        enumerable: true,
        writable: true,
        value: value
    });
    else object[key] = value;
}
var simpleEscapeCheck = new Array(256); // integer, for fast access
var simpleEscapeMap = new Array(256);
for(var i = 0; i < 256; i++){
    simpleEscapeCheck[i] = simpleEscapeSequence(i) ? 1 : 0;
    simpleEscapeMap[i] = simpleEscapeSequence(i);
}
function State(input, options) {
    this.input = input;
    this.filename = options['filename'] || null;
    this.schema = options['schema'] || DEFAULT_FULL_SCHEMA;
    this.onWarning = options['onWarning'] || null;
    this.legacy = options['legacy'] || false;
    this.json = options['json'] || false;
    this.listener = options['listener'] || null;
    this.implicitTypes = this.schema.compiledImplicit;
    this.typeMap = this.schema.compiledTypeMap;
    this.length = input.length;
    this.position = 0;
    this.line = 0;
    this.lineStart = 0;
    this.lineIndent = 0;
    this.documents = [];
/*
  this.version;
  this.checkLineBreaks;
  this.tagMap;
  this.anchorMap;
  this.tag;
  this.anchor;
  this.kind;
  this.result;*/ }
function generateError(state, message) {
    return new YAMLException(message, new Mark(state.filename, state.input, state.position, state.line, state.position - state.lineStart));
}
function throwError(state, message) {
    throw generateError(state, message);
}
function throwWarning(state, message) {
    if (state.onWarning) state.onWarning.call(null, generateError(state, message));
}
var directiveHandlers = {
    YAML: function handleYamlDirective(state, name, args) {
        var match, major, minor;
        if (state.version !== null) throwError(state, 'duplication of %YAML directive');
        if (args.length !== 1) throwError(state, 'YAML directive accepts exactly one argument');
        match = /^([0-9]+)\.([0-9]+)$/.exec(args[0]);
        if (match === null) throwError(state, 'ill-formed argument of the YAML directive');
        major = parseInt(match[1], 10);
        minor = parseInt(match[2], 10);
        if (major !== 1) throwError(state, 'unacceptable YAML version of the document');
        state.version = args[0];
        state.checkLineBreaks = minor < 2;
        if (minor !== 1 && minor !== 2) throwWarning(state, 'unsupported YAML version of the document');
    },
    TAG: function handleTagDirective(state, name, args) {
        var handle, prefix;
        if (args.length !== 2) throwError(state, 'TAG directive accepts exactly two arguments');
        handle = args[0];
        prefix = args[1];
        if (!PATTERN_TAG_HANDLE.test(handle)) throwError(state, 'ill-formed tag handle (first argument) of the TAG directive');
        if (_hasOwnProperty.call(state.tagMap, handle)) throwError(state, 'there is a previously declared suffix for "' + handle + '" tag handle');
        if (!PATTERN_TAG_URI.test(prefix)) throwError(state, 'ill-formed tag prefix (second argument) of the TAG directive');
        state.tagMap[handle] = prefix;
    }
};
function captureSegment(state, start, end, checkJson) {
    var _position, _length, _character, _result;
    if (start < end) {
        _result = state.input.slice(start, end);
        if (checkJson) for(_position = 0, _length = _result.length; _position < _length; _position += 1){
            _character = _result.charCodeAt(_position);
            if (!(_character === 0x09 || 0x20 <= _character && _character <= 0x10FFFF)) throwError(state, 'expected valid JSON character');
        }
        else if (PATTERN_NON_PRINTABLE.test(_result)) throwError(state, 'the stream contains non-printable characters');
        state.result += _result;
    }
}
function mergeMappings(state, destination, source, overridableKeys) {
    var sourceKeys, key, index, quantity;
    if (!common.isObject(source)) throwError(state, 'cannot merge mappings; the provided source object is unacceptable');
    sourceKeys = Object.keys(source);
    for(index = 0, quantity = sourceKeys.length; index < quantity; index += 1){
        key = sourceKeys[index];
        if (!_hasOwnProperty.call(destination, key)) {
            setProperty(destination, key, source[key]);
            overridableKeys[key] = true;
        }
    }
}
function storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode, startLine, startPos) {
    var index, quantity;
    // The output is a plain object here, so keys can only be strings.
    // We need to convert keyNode to a string, but doing so can hang the process
    // (deeply nested arrays that explode exponentially using aliases).
    if (Array.isArray(keyNode)) {
        keyNode = Array.prototype.slice.call(keyNode);
        for(index = 0, quantity = keyNode.length; index < quantity; index += 1){
            if (Array.isArray(keyNode[index])) throwError(state, 'nested arrays are not supported inside keys');
            if (typeof keyNode === 'object' && _class(keyNode[index]) === '[object Object]') keyNode[index] = '[object Object]';
        }
    }
    // Avoid code execution in load() via toString property
    // (still use its own toString for arrays, timestamps,
    // and whatever user schema extensions happen to have @@toStringTag)
    if (typeof keyNode === 'object' && _class(keyNode) === '[object Object]') keyNode = '[object Object]';
    keyNode = String(keyNode);
    if (_result === null) _result = {};
    if (keyTag === 'tag:yaml.org,2002:merge') {
        if (Array.isArray(valueNode)) for(index = 0, quantity = valueNode.length; index < quantity; index += 1)mergeMappings(state, _result, valueNode[index], overridableKeys);
        else mergeMappings(state, _result, valueNode, overridableKeys);
    } else {
        if (!state.json && !_hasOwnProperty.call(overridableKeys, keyNode) && _hasOwnProperty.call(_result, keyNode)) {
            state.line = startLine || state.line;
            state.position = startPos || state.position;
            throwError(state, 'duplicated mapping key');
        }
        setProperty(_result, keyNode, valueNode);
        delete overridableKeys[keyNode];
    }
    return _result;
}
function readLineBreak(state) {
    var ch;
    ch = state.input.charCodeAt(state.position);
    if (ch === 0x0A /* LF */ ) state.position++;
    else if (ch === 0x0D /* CR */ ) {
        state.position++;
        if (state.input.charCodeAt(state.position) === 0x0A /* LF */ ) state.position++;
    } else throwError(state, 'a line break is expected');
    state.line += 1;
    state.lineStart = state.position;
}
function skipSeparationSpace(state, allowComments, checkIndent) {
    var lineBreaks = 0, ch = state.input.charCodeAt(state.position);
    while(ch !== 0){
        while(is_WHITE_SPACE(ch))ch = state.input.charCodeAt(++state.position);
        if (allowComments && ch === 0x23 /* # */ ) do ch = state.input.charCodeAt(++state.position);
        while (ch !== 0x0A /* LF */  && ch !== 0x0D /* CR */  && ch !== 0);
        if (is_EOL(ch)) {
            readLineBreak(state);
            ch = state.input.charCodeAt(state.position);
            lineBreaks++;
            state.lineIndent = 0;
            while(ch === 0x20 /* Space */ ){
                state.lineIndent++;
                ch = state.input.charCodeAt(++state.position);
            }
        } else break;
    }
    if (checkIndent !== -1 && lineBreaks !== 0 && state.lineIndent < checkIndent) throwWarning(state, 'deficient indentation');
    return lineBreaks;
}
function testDocumentSeparator(state) {
    var _position = state.position, ch;
    ch = state.input.charCodeAt(_position);
    // Condition state.position === state.lineStart is tested
    // in parent on each call, for efficiency. No needs to test here again.
    if ((ch === 0x2D /* - */  || ch === 0x2E /* . */ ) && ch === state.input.charCodeAt(_position + 1) && ch === state.input.charCodeAt(_position + 2)) {
        _position += 3;
        ch = state.input.charCodeAt(_position);
        if (ch === 0 || is_WS_OR_EOL(ch)) return true;
    }
    return false;
}
function writeFoldedLines(state, count) {
    if (count === 1) state.result += ' ';
    else if (count > 1) state.result += common.repeat('\n', count - 1);
}
function readPlainScalar(state, nodeIndent, withinFlowCollection) {
    var preceding, following, captureStart, captureEnd, hasPendingContent, _line, _lineStart, _lineIndent, _kind = state.kind, _result = state.result, ch;
    ch = state.input.charCodeAt(state.position);
    if (is_WS_OR_EOL(ch) || is_FLOW_INDICATOR(ch) || ch === 0x23 /* # */  || ch === 0x26 /* & */  || ch === 0x2A /* * */  || ch === 0x21 /* ! */  || ch === 0x7C /* | */  || ch === 0x3E /* > */  || ch === 0x27 /* ' */  || ch === 0x22 /* " */  || ch === 0x25 /* % */  || ch === 0x40 /* @ */  || ch === 0x60 /* ` */ ) return false;
    if (ch === 0x3F /* ? */  || ch === 0x2D /* - */ ) {
        following = state.input.charCodeAt(state.position + 1);
        if (is_WS_OR_EOL(following) || withinFlowCollection && is_FLOW_INDICATOR(following)) return false;
    }
    state.kind = 'scalar';
    state.result = '';
    captureStart = captureEnd = state.position;
    hasPendingContent = false;
    while(ch !== 0){
        if (ch === 0x3A /* : */ ) {
            following = state.input.charCodeAt(state.position + 1);
            if (is_WS_OR_EOL(following) || withinFlowCollection && is_FLOW_INDICATOR(following)) break;
        } else if (ch === 0x23 /* # */ ) {
            preceding = state.input.charCodeAt(state.position - 1);
            if (is_WS_OR_EOL(preceding)) break;
        } else if (state.position === state.lineStart && testDocumentSeparator(state) || withinFlowCollection && is_FLOW_INDICATOR(ch)) break;
        else if (is_EOL(ch)) {
            _line = state.line;
            _lineStart = state.lineStart;
            _lineIndent = state.lineIndent;
            skipSeparationSpace(state, false, -1);
            if (state.lineIndent >= nodeIndent) {
                hasPendingContent = true;
                ch = state.input.charCodeAt(state.position);
                continue;
            } else {
                state.position = captureEnd;
                state.line = _line;
                state.lineStart = _lineStart;
                state.lineIndent = _lineIndent;
                break;
            }
        }
        if (hasPendingContent) {
            captureSegment(state, captureStart, captureEnd, false);
            writeFoldedLines(state, state.line - _line);
            captureStart = captureEnd = state.position;
            hasPendingContent = false;
        }
        if (!is_WHITE_SPACE(ch)) captureEnd = state.position + 1;
        ch = state.input.charCodeAt(++state.position);
    }
    captureSegment(state, captureStart, captureEnd, false);
    if (state.result) return true;
    state.kind = _kind;
    state.result = _result;
    return false;
}
function readSingleQuotedScalar(state, nodeIndent) {
    var ch, captureStart, captureEnd;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 0x27 /* ' */ ) return false;
    state.kind = 'scalar';
    state.result = '';
    state.position++;
    captureStart = captureEnd = state.position;
    while((ch = state.input.charCodeAt(state.position)) !== 0){
        if (ch === 0x27 /* ' */ ) {
            captureSegment(state, captureStart, state.position, true);
            ch = state.input.charCodeAt(++state.position);
            if (ch === 0x27 /* ' */ ) {
                captureStart = state.position;
                state.position++;
                captureEnd = state.position;
            } else return true;
        } else if (is_EOL(ch)) {
            captureSegment(state, captureStart, captureEnd, true);
            writeFoldedLines(state, skipSeparationSpace(state, false, nodeIndent));
            captureStart = captureEnd = state.position;
        } else if (state.position === state.lineStart && testDocumentSeparator(state)) throwError(state, 'unexpected end of the document within a single quoted scalar');
        else {
            state.position++;
            captureEnd = state.position;
        }
    }
    throwError(state, 'unexpected end of the stream within a single quoted scalar');
}
function readDoubleQuotedScalar(state, nodeIndent) {
    var captureStart, captureEnd, hexLength, hexResult, tmp, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 0x22 /* " */ ) return false;
    state.kind = 'scalar';
    state.result = '';
    state.position++;
    captureStart = captureEnd = state.position;
    while((ch = state.input.charCodeAt(state.position)) !== 0){
        if (ch === 0x22 /* " */ ) {
            captureSegment(state, captureStart, state.position, true);
            state.position++;
            return true;
        } else if (ch === 0x5C /* \ */ ) {
            captureSegment(state, captureStart, state.position, true);
            ch = state.input.charCodeAt(++state.position);
            if (is_EOL(ch)) skipSeparationSpace(state, false, nodeIndent);
            else if (ch < 256 && simpleEscapeCheck[ch]) {
                state.result += simpleEscapeMap[ch];
                state.position++;
            } else if ((tmp = escapedHexLen(ch)) > 0) {
                hexLength = tmp;
                hexResult = 0;
                for(; hexLength > 0; hexLength--){
                    ch = state.input.charCodeAt(++state.position);
                    if ((tmp = fromHexCode(ch)) >= 0) hexResult = (hexResult << 4) + tmp;
                    else throwError(state, 'expected hexadecimal character');
                }
                state.result += charFromCodepoint(hexResult);
                state.position++;
            } else throwError(state, 'unknown escape sequence');
            captureStart = captureEnd = state.position;
        } else if (is_EOL(ch)) {
            captureSegment(state, captureStart, captureEnd, true);
            writeFoldedLines(state, skipSeparationSpace(state, false, nodeIndent));
            captureStart = captureEnd = state.position;
        } else if (state.position === state.lineStart && testDocumentSeparator(state)) throwError(state, 'unexpected end of the document within a double quoted scalar');
        else {
            state.position++;
            captureEnd = state.position;
        }
    }
    throwError(state, 'unexpected end of the stream within a double quoted scalar');
}
function readFlowCollection(state, nodeIndent) {
    var readNext = true, _line, _tag = state.tag, _result, _anchor = state.anchor, following, terminator, isPair, isExplicitPair, isMapping, overridableKeys = {}, keyNode, keyTag, valueNode, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch === 0x5B /* [ */ ) {
        terminator = 0x5D; /* ] */ 
        isMapping = false;
        _result = [];
    } else if (ch === 0x7B /* { */ ) {
        terminator = 0x7D; /* } */ 
        isMapping = true;
        _result = {};
    } else return false;
    if (state.anchor !== null) state.anchorMap[state.anchor] = _result;
    ch = state.input.charCodeAt(++state.position);
    while(ch !== 0){
        skipSeparationSpace(state, true, nodeIndent);
        ch = state.input.charCodeAt(state.position);
        if (ch === terminator) {
            state.position++;
            state.tag = _tag;
            state.anchor = _anchor;
            state.kind = isMapping ? 'mapping' : 'sequence';
            state.result = _result;
            return true;
        } else if (!readNext) throwError(state, 'missed comma between flow collection entries');
        keyTag = keyNode = valueNode = null;
        isPair = isExplicitPair = false;
        if (ch === 0x3F /* ? */ ) {
            following = state.input.charCodeAt(state.position + 1);
            if (is_WS_OR_EOL(following)) {
                isPair = isExplicitPair = true;
                state.position++;
                skipSeparationSpace(state, true, nodeIndent);
            }
        }
        _line = state.line;
        composeNode(state, nodeIndent, CONTEXT_FLOW_IN, false, true);
        keyTag = state.tag;
        keyNode = state.result;
        skipSeparationSpace(state, true, nodeIndent);
        ch = state.input.charCodeAt(state.position);
        if ((isExplicitPair || state.line === _line) && ch === 0x3A /* : */ ) {
            isPair = true;
            ch = state.input.charCodeAt(++state.position);
            skipSeparationSpace(state, true, nodeIndent);
            composeNode(state, nodeIndent, CONTEXT_FLOW_IN, false, true);
            valueNode = state.result;
        }
        if (isMapping) storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode);
        else if (isPair) _result.push(storeMappingPair(state, null, overridableKeys, keyTag, keyNode, valueNode));
        else _result.push(keyNode);
        skipSeparationSpace(state, true, nodeIndent);
        ch = state.input.charCodeAt(state.position);
        if (ch === 0x2C /* , */ ) {
            readNext = true;
            ch = state.input.charCodeAt(++state.position);
        } else readNext = false;
    }
    throwError(state, 'unexpected end of the stream within a flow collection');
}
function readBlockScalar(state, nodeIndent) {
    var captureStart, folding, chomping = CHOMPING_CLIP, didReadContent = false, detectedIndent = false, textIndent = nodeIndent, emptyLines = 0, atMoreIndented = false, tmp, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch === 0x7C /* | */ ) folding = false;
    else if (ch === 0x3E /* > */ ) folding = true;
    else return false;
    state.kind = 'scalar';
    state.result = '';
    while(ch !== 0){
        ch = state.input.charCodeAt(++state.position);
        if (ch === 0x2B /* + */  || ch === 0x2D /* - */ ) {
            if (CHOMPING_CLIP === chomping) chomping = ch === 0x2B /* + */  ? CHOMPING_KEEP : CHOMPING_STRIP;
            else throwError(state, 'repeat of a chomping mode identifier');
        } else if ((tmp = fromDecimalCode(ch)) >= 0) {
            if (tmp === 0) throwError(state, 'bad explicit indentation width of a block scalar; it cannot be less than one');
            else if (!detectedIndent) {
                textIndent = nodeIndent + tmp - 1;
                detectedIndent = true;
            } else throwError(state, 'repeat of an indentation width identifier');
        } else break;
    }
    if (is_WHITE_SPACE(ch)) {
        do ch = state.input.charCodeAt(++state.position);
        while (is_WHITE_SPACE(ch));
        if (ch === 0x23 /* # */ ) do ch = state.input.charCodeAt(++state.position);
        while (!is_EOL(ch) && ch !== 0);
    }
    while(ch !== 0){
        readLineBreak(state);
        state.lineIndent = 0;
        ch = state.input.charCodeAt(state.position);
        while((!detectedIndent || state.lineIndent < textIndent) && ch === 0x20 /* Space */ ){
            state.lineIndent++;
            ch = state.input.charCodeAt(++state.position);
        }
        if (!detectedIndent && state.lineIndent > textIndent) textIndent = state.lineIndent;
        if (is_EOL(ch)) {
            emptyLines++;
            continue;
        }
        // End of the scalar.
        if (state.lineIndent < textIndent) {
            // Perform the chomping.
            if (chomping === CHOMPING_KEEP) state.result += common.repeat('\n', didReadContent ? 1 + emptyLines : emptyLines);
            else if (chomping === CHOMPING_CLIP) {
                if (didReadContent) state.result += '\n';
            }
            break;
        }
        // Folded style: use fancy rules to handle line breaks.
        if (folding) {
            // Lines starting with white space characters (more-indented lines) are not folded.
            if (is_WHITE_SPACE(ch)) {
                atMoreIndented = true;
                // except for the first content line (cf. Example 8.1)
                state.result += common.repeat('\n', didReadContent ? 1 + emptyLines : emptyLines);
            // End of more-indented block.
            } else if (atMoreIndented) {
                atMoreIndented = false;
                state.result += common.repeat('\n', emptyLines + 1);
            // Just one line break - perceive as the same line.
            } else if (emptyLines === 0) {
                if (didReadContent) state.result += ' ';
            } else state.result += common.repeat('\n', emptyLines);
        // Literal style: just add exact number of line breaks between content lines.
        } else // Keep all line breaks except the header line break.
        state.result += common.repeat('\n', didReadContent ? 1 + emptyLines : emptyLines);
        didReadContent = true;
        detectedIndent = true;
        emptyLines = 0;
        captureStart = state.position;
        while(!is_EOL(ch) && ch !== 0)ch = state.input.charCodeAt(++state.position);
        captureSegment(state, captureStart, state.position, false);
    }
    return true;
}
function readBlockSequence(state, nodeIndent) {
    var _line, _tag = state.tag, _anchor = state.anchor, _result = [], following, detected = false, ch;
    if (state.anchor !== null) state.anchorMap[state.anchor] = _result;
    ch = state.input.charCodeAt(state.position);
    while(ch !== 0){
        if (ch !== 0x2D /* - */ ) break;
        following = state.input.charCodeAt(state.position + 1);
        if (!is_WS_OR_EOL(following)) break;
        detected = true;
        state.position++;
        if (skipSeparationSpace(state, true, -1)) {
            if (state.lineIndent <= nodeIndent) {
                _result.push(null);
                ch = state.input.charCodeAt(state.position);
                continue;
            }
        }
        _line = state.line;
        composeNode(state, nodeIndent, CONTEXT_BLOCK_IN, false, true);
        _result.push(state.result);
        skipSeparationSpace(state, true, -1);
        ch = state.input.charCodeAt(state.position);
        if ((state.line === _line || state.lineIndent > nodeIndent) && ch !== 0) throwError(state, 'bad indentation of a sequence entry');
        else if (state.lineIndent < nodeIndent) break;
    }
    if (detected) {
        state.tag = _tag;
        state.anchor = _anchor;
        state.kind = 'sequence';
        state.result = _result;
        return true;
    }
    return false;
}
function readBlockMapping(state, nodeIndent, flowIndent) {
    var following, allowCompact, _line, _pos, _tag = state.tag, _anchor = state.anchor, _result = {}, overridableKeys = {}, keyTag = null, keyNode = null, valueNode = null, atExplicitKey = false, detected = false, ch;
    if (state.anchor !== null) state.anchorMap[state.anchor] = _result;
    ch = state.input.charCodeAt(state.position);
    while(ch !== 0){
        following = state.input.charCodeAt(state.position + 1);
        _line = state.line; // Save the current line.
        _pos = state.position;
        //
        // Explicit notation case. There are two separate blocks:
        // first for the key (denoted by "?") and second for the value (denoted by ":")
        //
        if ((ch === 0x3F /* ? */  || ch === 0x3A /* : */ ) && is_WS_OR_EOL(following)) {
            if (ch === 0x3F /* ? */ ) {
                if (atExplicitKey) {
                    storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null);
                    keyTag = keyNode = valueNode = null;
                }
                detected = true;
                atExplicitKey = true;
                allowCompact = true;
            } else if (atExplicitKey) {
                // i.e. 0x3A/* : */ === character after the explicit key.
                atExplicitKey = false;
                allowCompact = true;
            } else throwError(state, 'incomplete explicit mapping pair; a key node is missed; or followed by a non-tabulated empty line');
            state.position += 1;
            ch = following;
        //
        // Implicit notation case. Flow-style node as the key first, then ":", and the value.
        //
        } else if (composeNode(state, flowIndent, CONTEXT_FLOW_OUT, false, true)) {
            if (state.line === _line) {
                ch = state.input.charCodeAt(state.position);
                while(is_WHITE_SPACE(ch))ch = state.input.charCodeAt(++state.position);
                if (ch === 0x3A /* : */ ) {
                    ch = state.input.charCodeAt(++state.position);
                    if (!is_WS_OR_EOL(ch)) throwError(state, 'a whitespace character is expected after the key-value separator within a block mapping');
                    if (atExplicitKey) {
                        storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null);
                        keyTag = keyNode = valueNode = null;
                    }
                    detected = true;
                    atExplicitKey = false;
                    allowCompact = false;
                    keyTag = state.tag;
                    keyNode = state.result;
                } else if (detected) throwError(state, 'can not read an implicit mapping pair; a colon is missed');
                else {
                    state.tag = _tag;
                    state.anchor = _anchor;
                    return true; // Keep the result of `composeNode`.
                }
            } else if (detected) throwError(state, 'can not read a block mapping entry; a multiline key may not be an implicit key');
            else {
                state.tag = _tag;
                state.anchor = _anchor;
                return true; // Keep the result of `composeNode`.
            }
        } else break; // Reading is done. Go to the epilogue.
        //
        // Common reading code for both explicit and implicit notations.
        //
        if (state.line === _line || state.lineIndent > nodeIndent) {
            if (composeNode(state, nodeIndent, CONTEXT_BLOCK_OUT, true, allowCompact)) {
                if (atExplicitKey) keyNode = state.result;
                else valueNode = state.result;
            }
            if (!atExplicitKey) {
                storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode, _line, _pos);
                keyTag = keyNode = valueNode = null;
            }
            skipSeparationSpace(state, true, -1);
            ch = state.input.charCodeAt(state.position);
        }
        if (state.lineIndent > nodeIndent && ch !== 0) throwError(state, 'bad indentation of a mapping entry');
        else if (state.lineIndent < nodeIndent) break;
    }
    //
    // Epilogue.
    //
    // Special case: last mapping's node contains only the key in explicit notation.
    if (atExplicitKey) storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null);
    // Expose the resulting mapping.
    if (detected) {
        state.tag = _tag;
        state.anchor = _anchor;
        state.kind = 'mapping';
        state.result = _result;
    }
    return detected;
}
function readTagProperty(state) {
    var _position, isVerbatim = false, isNamed = false, tagHandle, tagName, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 0x21 /* ! */ ) return false;
    if (state.tag !== null) throwError(state, 'duplication of a tag property');
    ch = state.input.charCodeAt(++state.position);
    if (ch === 0x3C /* < */ ) {
        isVerbatim = true;
        ch = state.input.charCodeAt(++state.position);
    } else if (ch === 0x21 /* ! */ ) {
        isNamed = true;
        tagHandle = '!!';
        ch = state.input.charCodeAt(++state.position);
    } else tagHandle = '!';
    _position = state.position;
    if (isVerbatim) {
        do ch = state.input.charCodeAt(++state.position);
        while (ch !== 0 && ch !== 0x3E /* > */ );
        if (state.position < state.length) {
            tagName = state.input.slice(_position, state.position);
            ch = state.input.charCodeAt(++state.position);
        } else throwError(state, 'unexpected end of the stream within a verbatim tag');
    } else {
        while(ch !== 0 && !is_WS_OR_EOL(ch)){
            if (ch === 0x21 /* ! */ ) {
                if (!isNamed) {
                    tagHandle = state.input.slice(_position - 1, state.position + 1);
                    if (!PATTERN_TAG_HANDLE.test(tagHandle)) throwError(state, 'named tag handle cannot contain such characters');
                    isNamed = true;
                    _position = state.position + 1;
                } else throwError(state, 'tag suffix cannot contain exclamation marks');
            }
            ch = state.input.charCodeAt(++state.position);
        }
        tagName = state.input.slice(_position, state.position);
        if (PATTERN_FLOW_INDICATORS.test(tagName)) throwError(state, 'tag suffix cannot contain flow indicator characters');
    }
    if (tagName && !PATTERN_TAG_URI.test(tagName)) throwError(state, 'tag name cannot contain such characters: ' + tagName);
    if (isVerbatim) state.tag = tagName;
    else if (_hasOwnProperty.call(state.tagMap, tagHandle)) state.tag = state.tagMap[tagHandle] + tagName;
    else if (tagHandle === '!') state.tag = '!' + tagName;
    else if (tagHandle === '!!') state.tag = 'tag:yaml.org,2002:' + tagName;
    else throwError(state, 'undeclared tag handle "' + tagHandle + '"');
    return true;
}
function readAnchorProperty(state) {
    var _position, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 0x26 /* & */ ) return false;
    if (state.anchor !== null) throwError(state, 'duplication of an anchor property');
    ch = state.input.charCodeAt(++state.position);
    _position = state.position;
    while(ch !== 0 && !is_WS_OR_EOL(ch) && !is_FLOW_INDICATOR(ch))ch = state.input.charCodeAt(++state.position);
    if (state.position === _position) throwError(state, 'name of an anchor node must contain at least one character');
    state.anchor = state.input.slice(_position, state.position);
    return true;
}
function readAlias(state) {
    var _position, alias, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 0x2A /* * */ ) return false;
    ch = state.input.charCodeAt(++state.position);
    _position = state.position;
    while(ch !== 0 && !is_WS_OR_EOL(ch) && !is_FLOW_INDICATOR(ch))ch = state.input.charCodeAt(++state.position);
    if (state.position === _position) throwError(state, 'name of an alias node must contain at least one character');
    alias = state.input.slice(_position, state.position);
    if (!_hasOwnProperty.call(state.anchorMap, alias)) throwError(state, 'unidentified alias "' + alias + '"');
    state.result = state.anchorMap[alias];
    skipSeparationSpace(state, true, -1);
    return true;
}
function composeNode(state, parentIndent, nodeContext, allowToSeek, allowCompact) {
    var allowBlockStyles, allowBlockScalars, allowBlockCollections, indentStatus = 1, atNewLine = false, hasContent = false, typeIndex, typeQuantity, type, flowIndent, blockIndent;
    if (state.listener !== null) state.listener('open', state);
    state.tag = null;
    state.anchor = null;
    state.kind = null;
    state.result = null;
    allowBlockStyles = allowBlockScalars = allowBlockCollections = CONTEXT_BLOCK_OUT === nodeContext || CONTEXT_BLOCK_IN === nodeContext;
    if (allowToSeek) {
        if (skipSeparationSpace(state, true, -1)) {
            atNewLine = true;
            if (state.lineIndent > parentIndent) indentStatus = 1;
            else if (state.lineIndent === parentIndent) indentStatus = 0;
            else if (state.lineIndent < parentIndent) indentStatus = -1;
        }
    }
    if (indentStatus === 1) {
        while(readTagProperty(state) || readAnchorProperty(state))if (skipSeparationSpace(state, true, -1)) {
            atNewLine = true;
            allowBlockCollections = allowBlockStyles;
            if (state.lineIndent > parentIndent) indentStatus = 1;
            else if (state.lineIndent === parentIndent) indentStatus = 0;
            else if (state.lineIndent < parentIndent) indentStatus = -1;
        } else allowBlockCollections = false;
    }
    if (allowBlockCollections) allowBlockCollections = atNewLine || allowCompact;
    if (indentStatus === 1 || CONTEXT_BLOCK_OUT === nodeContext) {
        if (CONTEXT_FLOW_IN === nodeContext || CONTEXT_FLOW_OUT === nodeContext) flowIndent = parentIndent;
        else flowIndent = parentIndent + 1;
        blockIndent = state.position - state.lineStart;
        if (indentStatus === 1) {
            if (allowBlockCollections && (readBlockSequence(state, blockIndent) || readBlockMapping(state, blockIndent, flowIndent)) || readFlowCollection(state, flowIndent)) hasContent = true;
            else {
                if (allowBlockScalars && readBlockScalar(state, flowIndent) || readSingleQuotedScalar(state, flowIndent) || readDoubleQuotedScalar(state, flowIndent)) hasContent = true;
                else if (readAlias(state)) {
                    hasContent = true;
                    if (state.tag !== null || state.anchor !== null) throwError(state, 'alias node should not have any properties');
                } else if (readPlainScalar(state, flowIndent, CONTEXT_FLOW_IN === nodeContext)) {
                    hasContent = true;
                    if (state.tag === null) state.tag = '?';
                }
                if (state.anchor !== null) state.anchorMap[state.anchor] = state.result;
            }
        } else if (indentStatus === 0) // Special case: block sequences are allowed to have same indentation level as the parent.
        // http://www.yaml.org/spec/1.2/spec.html#id2799784
        hasContent = allowBlockCollections && readBlockSequence(state, blockIndent);
    }
    if (state.tag !== null && state.tag !== '!') {
        if (state.tag === '?') {
            // Implicit resolving is not allowed for non-scalar types, and '?'
            // non-specific tag is only automatically assigned to plain scalars.
            //
            // We only need to check kind conformity in case user explicitly assigns '?'
            // tag, for example like this: "!<?> [0]"
            //
            if (state.result !== null && state.kind !== 'scalar') throwError(state, 'unacceptable node kind for !<?> tag; it should be "scalar", not "' + state.kind + '"');
            for(typeIndex = 0, typeQuantity = state.implicitTypes.length; typeIndex < typeQuantity; typeIndex += 1){
                type = state.implicitTypes[typeIndex];
                if (type.resolve(state.result)) {
                    state.result = type.construct(state.result);
                    state.tag = type.tag;
                    if (state.anchor !== null) state.anchorMap[state.anchor] = state.result;
                    break;
                }
            }
        } else if (_hasOwnProperty.call(state.typeMap[state.kind || 'fallback'], state.tag)) {
            type = state.typeMap[state.kind || 'fallback'][state.tag];
            if (state.result !== null && type.kind !== state.kind) throwError(state, 'unacceptable node kind for !<' + state.tag + '> tag; it should be "' + type.kind + '", not "' + state.kind + '"');
            if (!type.resolve(state.result)) throwError(state, 'cannot resolve a node with !<' + state.tag + '> explicit tag');
            else {
                state.result = type.construct(state.result);
                if (state.anchor !== null) state.anchorMap[state.anchor] = state.result;
            }
        } else throwError(state, 'unknown tag !<' + state.tag + '>');
    }
    if (state.listener !== null) state.listener('close', state);
    return state.tag !== null || state.anchor !== null || hasContent;
}
function readDocument(state) {
    var documentStart = state.position, _position, directiveName, directiveArgs, hasDirectives = false, ch;
    state.version = null;
    state.checkLineBreaks = state.legacy;
    state.tagMap = {};
    state.anchorMap = {};
    while((ch = state.input.charCodeAt(state.position)) !== 0){
        skipSeparationSpace(state, true, -1);
        ch = state.input.charCodeAt(state.position);
        if (state.lineIndent > 0 || ch !== 0x25 /* % */ ) break;
        hasDirectives = true;
        ch = state.input.charCodeAt(++state.position);
        _position = state.position;
        while(ch !== 0 && !is_WS_OR_EOL(ch))ch = state.input.charCodeAt(++state.position);
        directiveName = state.input.slice(_position, state.position);
        directiveArgs = [];
        if (directiveName.length < 1) throwError(state, 'directive name must not be less than one character in length');
        while(ch !== 0){
            while(is_WHITE_SPACE(ch))ch = state.input.charCodeAt(++state.position);
            if (ch === 0x23 /* # */ ) {
                do ch = state.input.charCodeAt(++state.position);
                while (ch !== 0 && !is_EOL(ch));
                break;
            }
            if (is_EOL(ch)) break;
            _position = state.position;
            while(ch !== 0 && !is_WS_OR_EOL(ch))ch = state.input.charCodeAt(++state.position);
            directiveArgs.push(state.input.slice(_position, state.position));
        }
        if (ch !== 0) readLineBreak(state);
        if (_hasOwnProperty.call(directiveHandlers, directiveName)) directiveHandlers[directiveName](state, directiveName, directiveArgs);
        else throwWarning(state, 'unknown document directive "' + directiveName + '"');
    }
    skipSeparationSpace(state, true, -1);
    if (state.lineIndent === 0 && state.input.charCodeAt(state.position) === 0x2D /* - */  && state.input.charCodeAt(state.position + 1) === 0x2D /* - */  && state.input.charCodeAt(state.position + 2) === 0x2D /* - */ ) {
        state.position += 3;
        skipSeparationSpace(state, true, -1);
    } else if (hasDirectives) throwError(state, 'directives end mark is expected');
    composeNode(state, state.lineIndent - 1, CONTEXT_BLOCK_OUT, false, true);
    skipSeparationSpace(state, true, -1);
    if (state.checkLineBreaks && PATTERN_NON_ASCII_LINE_BREAKS.test(state.input.slice(documentStart, state.position))) throwWarning(state, 'non-ASCII line breaks are interpreted as content');
    state.documents.push(state.result);
    if (state.position === state.lineStart && testDocumentSeparator(state)) {
        if (state.input.charCodeAt(state.position) === 0x2E /* . */ ) {
            state.position += 3;
            skipSeparationSpace(state, true, -1);
        }
        return;
    }
    if (state.position < state.length - 1) throwError(state, 'end of the stream or a document separator is expected');
    else return;
}
function loadDocuments(input, options) {
    input = String(input);
    options = options || {};
    if (input.length !== 0) {
        // Add tailing `\n` if not exists
        if (input.charCodeAt(input.length - 1) !== 0x0A /* LF */  && input.charCodeAt(input.length - 1) !== 0x0D /* CR */ ) input += '\n';
        // Strip BOM
        if (input.charCodeAt(0) === 0xFEFF) input = input.slice(1);
    }
    var state = new State(input, options);
    var nullpos = input.indexOf('\0');
    if (nullpos !== -1) {
        state.position = nullpos;
        throwError(state, 'null byte is not allowed in input');
    }
    // Use 0 as string terminator. That significantly simplifies bounds check.
    state.input += '\0';
    while(state.input.charCodeAt(state.position) === 0x20 /* Space */ ){
        state.lineIndent += 1;
        state.position += 1;
    }
    while(state.position < state.length - 1)readDocument(state);
    return state.documents;
}
function loadAll(input, iterator, options) {
    if (iterator !== null && typeof iterator === 'object' && typeof options === 'undefined') {
        options = iterator;
        iterator = null;
    }
    var documents = loadDocuments(input, options);
    if (typeof iterator !== 'function') return documents;
    for(var index = 0, length = documents.length; index < length; index += 1)iterator(documents[index]);
}
function load(input, options) {
    var documents = loadDocuments(input, options);
    if (documents.length === 0) /*eslint-disable no-undefined*/ return undefined;
    else if (documents.length === 1) return documents[0];
    throw new YAMLException('expected a single document in the stream, but found more');
}
function safeLoadAll(input, iterator, options) {
    if (typeof iterator === 'object' && iterator !== null && typeof options === 'undefined') {
        options = iterator;
        iterator = null;
    }
    return loadAll(input, iterator, common.extend({
        schema: DEFAULT_SAFE_SCHEMA
    }, options));
}
function safeLoad(input, options) {
    return load(input, common.extend({
        schema: DEFAULT_SAFE_SCHEMA
    }, options));
}
module.exports.loadAll = loadAll;
module.exports.load = load;
module.exports.safeLoadAll = safeLoadAll;
module.exports.safeLoad = safeLoad;

},{"2508ac67c7eb7572":"5F3ap","65cc866ae17c6738":"9ywNX","f4cf36d9b894e032":"fADhP","9104f1efefb8b906":"hKMmA","9c5aee641539b20b":"dRAq3"}],"5F3ap":[function(require,module,exports,__globalThis) {
'use strict';
function isNothing(subject) {
    return typeof subject === 'undefined' || subject === null;
}
function isObject(subject) {
    return typeof subject === 'object' && subject !== null;
}
function toArray(sequence) {
    if (Array.isArray(sequence)) return sequence;
    else if (isNothing(sequence)) return [];
    return [
        sequence
    ];
}
function extend(target, source) {
    var index, length, key, sourceKeys;
    if (source) {
        sourceKeys = Object.keys(source);
        for(index = 0, length = sourceKeys.length; index < length; index += 1){
            key = sourceKeys[index];
            target[key] = source[key];
        }
    }
    return target;
}
function repeat(string, count) {
    var result = '', cycle;
    for(cycle = 0; cycle < count; cycle += 1)result += string;
    return result;
}
function isNegativeZero(number) {
    return number === 0 && Number.NEGATIVE_INFINITY === 1 / number;
}
module.exports.isNothing = isNothing;
module.exports.isObject = isObject;
module.exports.toArray = toArray;
module.exports.repeat = repeat;
module.exports.isNegativeZero = isNegativeZero;
module.exports.extend = extend;

},{}],"9ywNX":[function(require,module,exports,__globalThis) {
// YAML error class. http://stackoverflow.com/questions/8458984
//
'use strict';
function YAMLException(reason, mark) {
    // Super constructor
    Error.call(this);
    this.name = 'YAMLException';
    this.reason = reason;
    this.mark = mark;
    this.message = (this.reason || '(unknown reason)') + (this.mark ? ' ' + this.mark.toString() : '');
    // Include stack trace in error object
    if (Error.captureStackTrace) // Chrome and NodeJS
    Error.captureStackTrace(this, this.constructor);
    else // FF, IE 10+ and Safari 6+. Fallback for others
    this.stack = new Error().stack || '';
}
// Inherit from Error
YAMLException.prototype = Object.create(Error.prototype);
YAMLException.prototype.constructor = YAMLException;
YAMLException.prototype.toString = function toString(compact) {
    var result = this.name + ': ';
    result += this.reason || '(unknown reason)';
    if (!compact && this.mark) result += ' ' + this.mark.toString();
    return result;
};
module.exports = YAMLException;

},{}],"fADhP":[function(require,module,exports,__globalThis) {
'use strict';
var common = require("6a5cc639a6daff5b");
function Mark(name, buffer, position, line, column) {
    this.name = name;
    this.buffer = buffer;
    this.position = position;
    this.line = line;
    this.column = column;
}
Mark.prototype.getSnippet = function getSnippet(indent, maxLength) {
    var head, start, tail, end, snippet;
    if (!this.buffer) return null;
    indent = indent || 4;
    maxLength = maxLength || 75;
    head = '';
    start = this.position;
    while(start > 0 && '\x00\r\n\x85\u2028\u2029'.indexOf(this.buffer.charAt(start - 1)) === -1){
        start -= 1;
        if (this.position - start > maxLength / 2 - 1) {
            head = ' ... ';
            start += 5;
            break;
        }
    }
    tail = '';
    end = this.position;
    while(end < this.buffer.length && '\x00\r\n\x85\u2028\u2029'.indexOf(this.buffer.charAt(end)) === -1){
        end += 1;
        if (end - this.position > maxLength / 2 - 1) {
            tail = ' ... ';
            end -= 5;
            break;
        }
    }
    snippet = this.buffer.slice(start, end);
    return common.repeat(' ', indent) + head + snippet + tail + '\n' + common.repeat(' ', indent + this.position - start + head.length) + '^';
};
Mark.prototype.toString = function toString(compact) {
    var snippet, where = '';
    if (this.name) where += 'in "' + this.name + '" ';
    where += 'at line ' + (this.line + 1) + ', column ' + (this.column + 1);
    if (!compact) {
        snippet = this.getSnippet();
        if (snippet) where += ':\n' + snippet;
    }
    return where;
};
module.exports = Mark;

},{"6a5cc639a6daff5b":"5F3ap"}],"hKMmA":[function(require,module,exports,__globalThis) {
// JS-YAML's default schema for `safeLoad` function.
// It is not described in the YAML specification.
//
// This schema is based on standard YAML's Core schema and includes most of
// extra types described at YAML tag repository. (http://yaml.org/type/)
'use strict';
var Schema = require("c555dd232f51c43");
module.exports = new Schema({
    include: [
        require("3f6f89b05ee4b353")
    ],
    implicit: [
        require("21056bd254f3a225"),
        require("79bfac264befa88d")
    ],
    explicit: [
        require("f120b646c1364669"),
        require("f9fd216776385761"),
        require("df9b323414e21366"),
        require("693508cbce668497")
    ]
});

},{"c555dd232f51c43":"dwfqa","3f6f89b05ee4b353":"8O4Hw","21056bd254f3a225":"8YGLf","79bfac264befa88d":"8cwg2","f120b646c1364669":"eahUu","f9fd216776385761":"6PBxo","df9b323414e21366":"jZxPm","693508cbce668497":"gIjqY"}],"dwfqa":[function(require,module,exports,__globalThis) {
'use strict';
/*eslint-disable max-len*/ var common = require("afc8f42c54842dfd");
var YAMLException = require("748b56c46abd4687");
var Type = require("1267671e65322df");
function compileList(schema, name, result) {
    var exclude = [];
    schema.include.forEach(function(includedSchema) {
        result = compileList(includedSchema, name, result);
    });
    schema[name].forEach(function(currentType) {
        result.forEach(function(previousType, previousIndex) {
            if (previousType.tag === currentType.tag && previousType.kind === currentType.kind) exclude.push(previousIndex);
        });
        result.push(currentType);
    });
    return result.filter(function(type, index) {
        return exclude.indexOf(index) === -1;
    });
}
function compileMap() {
    var result = {
        scalar: {},
        sequence: {},
        mapping: {},
        fallback: {}
    }, index, length;
    function collectType(type) {
        result[type.kind][type.tag] = result['fallback'][type.tag] = type;
    }
    for(index = 0, length = arguments.length; index < length; index += 1)arguments[index].forEach(collectType);
    return result;
}
function Schema(definition) {
    this.include = definition.include || [];
    this.implicit = definition.implicit || [];
    this.explicit = definition.explicit || [];
    this.implicit.forEach(function(type) {
        if (type.loadKind && type.loadKind !== 'scalar') throw new YAMLException('There is a non-scalar type in the implicit list of a schema. Implicit resolving of such types is not supported.');
    });
    this.compiledImplicit = compileList(this, 'implicit', []);
    this.compiledExplicit = compileList(this, 'explicit', []);
    this.compiledTypeMap = compileMap(this.compiledImplicit, this.compiledExplicit);
}
Schema.DEFAULT = null;
Schema.create = function createSchema() {
    var schemas, types;
    switch(arguments.length){
        case 1:
            schemas = Schema.DEFAULT;
            types = arguments[0];
            break;
        case 2:
            schemas = arguments[0];
            types = arguments[1];
            break;
        default:
            throw new YAMLException('Wrong number of arguments for Schema.create function');
    }
    schemas = common.toArray(schemas);
    types = common.toArray(types);
    if (!schemas.every(function(schema) {
        return schema instanceof Schema;
    })) throw new YAMLException('Specified list of super schemas (or a single Schema object) contains a non-Schema object.');
    if (!types.every(function(type) {
        return type instanceof Type;
    })) throw new YAMLException('Specified list of YAML types (or a single Type object) contains a non-Type object.');
    return new Schema({
        include: schemas,
        explicit: types
    });
};
module.exports = Schema;

},{"afc8f42c54842dfd":"5F3ap","748b56c46abd4687":"9ywNX","1267671e65322df":"kPZ9d"}],"kPZ9d":[function(require,module,exports,__globalThis) {
'use strict';
var YAMLException = require("dca76246aa131bb6");
var TYPE_CONSTRUCTOR_OPTIONS = [
    'kind',
    'resolve',
    'construct',
    'instanceOf',
    'predicate',
    'represent',
    'defaultStyle',
    'styleAliases'
];
var YAML_NODE_KINDS = [
    'scalar',
    'sequence',
    'mapping'
];
function compileStyleAliases(map) {
    var result = {};
    if (map !== null) Object.keys(map).forEach(function(style) {
        map[style].forEach(function(alias) {
            result[String(alias)] = style;
        });
    });
    return result;
}
function Type(tag, options) {
    options = options || {};
    Object.keys(options).forEach(function(name) {
        if (TYPE_CONSTRUCTOR_OPTIONS.indexOf(name) === -1) throw new YAMLException('Unknown option "' + name + '" is met in definition of "' + tag + '" YAML type.');
    });
    // TODO: Add tag format check.
    this.tag = tag;
    this.kind = options['kind'] || null;
    this.resolve = options['resolve'] || function() {
        return true;
    };
    this.construct = options['construct'] || function(data) {
        return data;
    };
    this.instanceOf = options['instanceOf'] || null;
    this.predicate = options['predicate'] || null;
    this.represent = options['represent'] || null;
    this.defaultStyle = options['defaultStyle'] || null;
    this.styleAliases = compileStyleAliases(options['styleAliases'] || null);
    if (YAML_NODE_KINDS.indexOf(this.kind) === -1) throw new YAMLException('Unknown kind "' + this.kind + '" is specified for "' + tag + '" YAML type.');
}
module.exports = Type;

},{"dca76246aa131bb6":"9ywNX"}],"8O4Hw":[function(require,module,exports,__globalThis) {
// Standard YAML's Core schema.
// http://www.yaml.org/spec/1.2/spec.html#id2804923
//
// NOTE: JS-YAML does not support schema-specific tag resolution restrictions.
// So, Core schema has no distinctions from JSON schema is JS-YAML.
'use strict';
var Schema = require("e45352a00d8a39d8");
module.exports = new Schema({
    include: [
        require("fb2d4fa8b50f2992")
    ]
});

},{"e45352a00d8a39d8":"dwfqa","fb2d4fa8b50f2992":"a2kJO"}],"a2kJO":[function(require,module,exports,__globalThis) {
// Standard YAML's JSON schema.
// http://www.yaml.org/spec/1.2/spec.html#id2803231
//
// NOTE: JS-YAML does not support schema-specific tag resolution restrictions.
// So, this schema is not such strict as defined in the YAML specification.
// It allows numbers in binary notaion, use `Null` and `NULL` as `null`, etc.
'use strict';
var Schema = require("cbd2874f35042310");
module.exports = new Schema({
    include: [
        require("6930927d07c6568d")
    ],
    implicit: [
        require("551ce40b4e444d25"),
        require("b243e7bc566af6eb"),
        require("361130cd326c98bb"),
        require("5742d9ee9bcc643e")
    ]
});

},{"cbd2874f35042310":"dwfqa","6930927d07c6568d":"6prT0","551ce40b4e444d25":"8fg3B","b243e7bc566af6eb":"8dm9R","361130cd326c98bb":"a4s3d","5742d9ee9bcc643e":"8GGv4"}],"6prT0":[function(require,module,exports,__globalThis) {
// Standard YAML's Failsafe schema.
// http://www.yaml.org/spec/1.2/spec.html#id2802346
'use strict';
var Schema = require("39fc5a5e8c920624");
module.exports = new Schema({
    explicit: [
        require("8f6b1a006e8d067f"),
        require("e2924fd49e6422ba"),
        require("ef478ae0a5329e1d")
    ]
});

},{"39fc5a5e8c920624":"dwfqa","8f6b1a006e8d067f":"6q4yB","e2924fd49e6422ba":"3fEeo","ef478ae0a5329e1d":"k6DV3"}],"6q4yB":[function(require,module,exports,__globalThis) {
'use strict';
var Type = require("f0a10fad49f83925");
module.exports = new Type('tag:yaml.org,2002:str', {
    kind: 'scalar',
    construct: function(data) {
        return data !== null ? data : '';
    }
});

},{"f0a10fad49f83925":"kPZ9d"}],"3fEeo":[function(require,module,exports,__globalThis) {
'use strict';
var Type = require("24febf051fc92010");
module.exports = new Type('tag:yaml.org,2002:seq', {
    kind: 'sequence',
    construct: function(data) {
        return data !== null ? data : [];
    }
});

},{"24febf051fc92010":"kPZ9d"}],"k6DV3":[function(require,module,exports,__globalThis) {
'use strict';
var Type = require("88c3f3803459034b");
module.exports = new Type('tag:yaml.org,2002:map', {
    kind: 'mapping',
    construct: function(data) {
        return data !== null ? data : {};
    }
});

},{"88c3f3803459034b":"kPZ9d"}],"8fg3B":[function(require,module,exports,__globalThis) {
'use strict';
var Type = require("f9d5a5615b1866b7");
function resolveYamlNull(data) {
    if (data === null) return true;
    var max = data.length;
    return max === 1 && data === '~' || max === 4 && (data === 'null' || data === 'Null' || data === 'NULL');
}
function constructYamlNull() {
    return null;
}
function isNull(object) {
    return object === null;
}
module.exports = new Type('tag:yaml.org,2002:null', {
    kind: 'scalar',
    resolve: resolveYamlNull,
    construct: constructYamlNull,
    predicate: isNull,
    represent: {
        canonical: function() {
            return '~';
        },
        lowercase: function() {
            return 'null';
        },
        uppercase: function() {
            return 'NULL';
        },
        camelcase: function() {
            return 'Null';
        }
    },
    defaultStyle: 'lowercase'
});

},{"f9d5a5615b1866b7":"kPZ9d"}],"8dm9R":[function(require,module,exports,__globalThis) {
'use strict';
var Type = require("211d978f9345311c");
function resolveYamlBoolean(data) {
    if (data === null) return false;
    var max = data.length;
    return max === 4 && (data === 'true' || data === 'True' || data === 'TRUE') || max === 5 && (data === 'false' || data === 'False' || data === 'FALSE');
}
function constructYamlBoolean(data) {
    return data === 'true' || data === 'True' || data === 'TRUE';
}
function isBoolean(object) {
    return Object.prototype.toString.call(object) === '[object Boolean]';
}
module.exports = new Type('tag:yaml.org,2002:bool', {
    kind: 'scalar',
    resolve: resolveYamlBoolean,
    construct: constructYamlBoolean,
    predicate: isBoolean,
    represent: {
        lowercase: function(object) {
            return object ? 'true' : 'false';
        },
        uppercase: function(object) {
            return object ? 'TRUE' : 'FALSE';
        },
        camelcase: function(object) {
            return object ? 'True' : 'False';
        }
    },
    defaultStyle: 'lowercase'
});

},{"211d978f9345311c":"kPZ9d"}],"a4s3d":[function(require,module,exports,__globalThis) {
'use strict';
var common = require("881a9f08b583bd5c");
var Type = require("7f14c4d135a9d4f8");
function isHexCode(c) {
    return 0x30 /* 0 */  <= c && c <= 0x39 /* 9 */  || 0x41 /* A */  <= c && c <= 0x46 /* F */  || 0x61 /* a */  <= c && c <= 0x66 /* f */ ;
}
function isOctCode(c) {
    return 0x30 /* 0 */  <= c && c <= 0x37 /* 7 */ ;
}
function isDecCode(c) {
    return 0x30 /* 0 */  <= c && c <= 0x39 /* 9 */ ;
}
function resolveYamlInteger(data) {
    if (data === null) return false;
    var max = data.length, index = 0, hasDigits = false, ch;
    if (!max) return false;
    ch = data[index];
    // sign
    if (ch === '-' || ch === '+') ch = data[++index];
    if (ch === '0') {
        // 0
        if (index + 1 === max) return true;
        ch = data[++index];
        // base 2, base 8, base 16
        if (ch === 'b') {
            // base 2
            index++;
            for(; index < max; index++){
                ch = data[index];
                if (ch === '_') continue;
                if (ch !== '0' && ch !== '1') return false;
                hasDigits = true;
            }
            return hasDigits && ch !== '_';
        }
        if (ch === 'x') {
            // base 16
            index++;
            for(; index < max; index++){
                ch = data[index];
                if (ch === '_') continue;
                if (!isHexCode(data.charCodeAt(index))) return false;
                hasDigits = true;
            }
            return hasDigits && ch !== '_';
        }
        // base 8
        for(; index < max; index++){
            ch = data[index];
            if (ch === '_') continue;
            if (!isOctCode(data.charCodeAt(index))) return false;
            hasDigits = true;
        }
        return hasDigits && ch !== '_';
    }
    // base 10 (except 0) or base 60
    // value should not start with `_`;
    if (ch === '_') return false;
    for(; index < max; index++){
        ch = data[index];
        if (ch === '_') continue;
        if (ch === ':') break;
        if (!isDecCode(data.charCodeAt(index))) return false;
        hasDigits = true;
    }
    // Should have digits and should not end with `_`
    if (!hasDigits || ch === '_') return false;
    // if !base60 - done;
    if (ch !== ':') return true;
    // base60 almost not used, no needs to optimize
    return /^(:[0-5]?[0-9])+$/.test(data.slice(index));
}
function constructYamlInteger(data) {
    var value = data, sign = 1, ch, base, digits = [];
    if (value.indexOf('_') !== -1) value = value.replace(/_/g, '');
    ch = value[0];
    if (ch === '-' || ch === '+') {
        if (ch === '-') sign = -1;
        value = value.slice(1);
        ch = value[0];
    }
    if (value === '0') return 0;
    if (ch === '0') {
        if (value[1] === 'b') return sign * parseInt(value.slice(2), 2);
        if (value[1] === 'x') return sign * parseInt(value, 16);
        return sign * parseInt(value, 8);
    }
    if (value.indexOf(':') !== -1) {
        value.split(':').forEach(function(v) {
            digits.unshift(parseInt(v, 10));
        });
        value = 0;
        base = 1;
        digits.forEach(function(d) {
            value += d * base;
            base *= 60;
        });
        return sign * value;
    }
    return sign * parseInt(value, 10);
}
function isInteger(object) {
    return Object.prototype.toString.call(object) === '[object Number]' && object % 1 === 0 && !common.isNegativeZero(object);
}
module.exports = new Type('tag:yaml.org,2002:int', {
    kind: 'scalar',
    resolve: resolveYamlInteger,
    construct: constructYamlInteger,
    predicate: isInteger,
    represent: {
        binary: function(obj) {
            return obj >= 0 ? '0b' + obj.toString(2) : '-0b' + obj.toString(2).slice(1);
        },
        octal: function(obj) {
            return obj >= 0 ? '0' + obj.toString(8) : '-0' + obj.toString(8).slice(1);
        },
        decimal: function(obj) {
            return obj.toString(10);
        },
        /* eslint-disable max-len */ hexadecimal: function(obj) {
            return obj >= 0 ? '0x' + obj.toString(16).toUpperCase() : '-0x' + obj.toString(16).toUpperCase().slice(1);
        }
    },
    defaultStyle: 'decimal',
    styleAliases: {
        binary: [
            2,
            'bin'
        ],
        octal: [
            8,
            'oct'
        ],
        decimal: [
            10,
            'dec'
        ],
        hexadecimal: [
            16,
            'hex'
        ]
    }
});

},{"881a9f08b583bd5c":"5F3ap","7f14c4d135a9d4f8":"kPZ9d"}],"8GGv4":[function(require,module,exports,__globalThis) {
'use strict';
var common = require("c37f1de7dc91e3fe");
var Type = require("7f0af24ef8cfee11");
var YAML_FLOAT_PATTERN = new RegExp(// 2.5e4, 2.5 and integers
"^(?:[-+]?(?:0|[1-9][0-9_]*)(?:\\.[0-9_]*)?(?:[eE][-+]?[0-9]+)?|\\.[0-9_]+(?:[eE][-+]?[0-9]+)?|[-+]?[0-9][0-9_]*(?::[0-5]?[0-9])+\\.[0-9_]*|[-+]?\\.(?:inf|Inf|INF)|\\.(?:nan|NaN|NAN))$");
function resolveYamlFloat(data) {
    if (data === null) return false;
    if (!YAML_FLOAT_PATTERN.test(data) || // Quick hack to not allow integers end with `_`
    // Probably should update regexp & check speed
    data[data.length - 1] === '_') return false;
    return true;
}
function constructYamlFloat(data) {
    var value, sign, base, digits;
    value = data.replace(/_/g, '').toLowerCase();
    sign = value[0] === '-' ? -1 : 1;
    digits = [];
    if ('+-'.indexOf(value[0]) >= 0) value = value.slice(1);
    if (value === '.inf') return sign === 1 ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY;
    else if (value === '.nan') return NaN;
    else if (value.indexOf(':') >= 0) {
        value.split(':').forEach(function(v) {
            digits.unshift(parseFloat(v, 10));
        });
        value = 0.0;
        base = 1;
        digits.forEach(function(d) {
            value += d * base;
            base *= 60;
        });
        return sign * value;
    }
    return sign * parseFloat(value, 10);
}
var SCIENTIFIC_WITHOUT_DOT = /^[-+]?[0-9]+e/;
function representYamlFloat(object, style) {
    var res;
    if (isNaN(object)) switch(style){
        case 'lowercase':
            return '.nan';
        case 'uppercase':
            return '.NAN';
        case 'camelcase':
            return '.NaN';
    }
    else if (Number.POSITIVE_INFINITY === object) switch(style){
        case 'lowercase':
            return '.inf';
        case 'uppercase':
            return '.INF';
        case 'camelcase':
            return '.Inf';
    }
    else if (Number.NEGATIVE_INFINITY === object) switch(style){
        case 'lowercase':
            return '-.inf';
        case 'uppercase':
            return '-.INF';
        case 'camelcase':
            return '-.Inf';
    }
    else if (common.isNegativeZero(object)) return '-0.0';
    res = object.toString(10);
    // JS stringifier can build scientific format without dots: 5e-100,
    // while YAML requres dot: 5.e-100. Fix it with simple hack
    return SCIENTIFIC_WITHOUT_DOT.test(res) ? res.replace('e', '.e') : res;
}
function isFloat(object) {
    return Object.prototype.toString.call(object) === '[object Number]' && (object % 1 !== 0 || common.isNegativeZero(object));
}
module.exports = new Type('tag:yaml.org,2002:float', {
    kind: 'scalar',
    resolve: resolveYamlFloat,
    construct: constructYamlFloat,
    predicate: isFloat,
    represent: representYamlFloat,
    defaultStyle: 'lowercase'
});

},{"c37f1de7dc91e3fe":"5F3ap","7f0af24ef8cfee11":"kPZ9d"}],"8YGLf":[function(require,module,exports,__globalThis) {
'use strict';
var Type = require("125ac17f0fc05140");
var YAML_DATE_REGEXP = new RegExp("^([0-9][0-9][0-9][0-9])-([0-9][0-9])-([0-9][0-9])$"); // [3] day
var YAML_TIMESTAMP_REGEXP = new RegExp("^([0-9][0-9][0-9][0-9])-([0-9][0-9]?)-([0-9][0-9]?)(?:[Tt]|[ \\t]+)([0-9][0-9]?):([0-9][0-9]):([0-9][0-9])(?:\\.([0-9]*))?(?:[ \\t]*(Z|([-+])([0-9][0-9]?)(?::([0-9][0-9]))?))?$"); // [11] tz_minute
function resolveYamlTimestamp(data) {
    if (data === null) return false;
    if (YAML_DATE_REGEXP.exec(data) !== null) return true;
    if (YAML_TIMESTAMP_REGEXP.exec(data) !== null) return true;
    return false;
}
function constructYamlTimestamp(data) {
    var match, year, month, day, hour, minute, second, fraction = 0, delta = null, tz_hour, tz_minute, date;
    match = YAML_DATE_REGEXP.exec(data);
    if (match === null) match = YAML_TIMESTAMP_REGEXP.exec(data);
    if (match === null) throw new Error('Date resolve error');
    // match: [1] year [2] month [3] day
    year = +match[1];
    month = +match[2] - 1; // JS month starts with 0
    day = +match[3];
    if (!match[4]) return new Date(Date.UTC(year, month, day));
    // match: [4] hour [5] minute [6] second [7] fraction
    hour = +match[4];
    minute = +match[5];
    second = +match[6];
    if (match[7]) {
        fraction = match[7].slice(0, 3);
        while(fraction.length < 3)fraction += '0';
        fraction = +fraction;
    }
    // match: [8] tz [9] tz_sign [10] tz_hour [11] tz_minute
    if (match[9]) {
        tz_hour = +match[10];
        tz_minute = +(match[11] || 0);
        delta = (tz_hour * 60 + tz_minute) * 60000; // delta in mili-seconds
        if (match[9] === '-') delta = -delta;
    }
    date = new Date(Date.UTC(year, month, day, hour, minute, second, fraction));
    if (delta) date.setTime(date.getTime() - delta);
    return date;
}
function representYamlTimestamp(object /*, style*/ ) {
    return object.toISOString();
}
module.exports = new Type('tag:yaml.org,2002:timestamp', {
    kind: 'scalar',
    resolve: resolveYamlTimestamp,
    construct: constructYamlTimestamp,
    instanceOf: Date,
    represent: representYamlTimestamp
});

},{"125ac17f0fc05140":"kPZ9d"}],"8cwg2":[function(require,module,exports,__globalThis) {
'use strict';
var Type = require("fba211a6b8e36560");
function resolveYamlMerge(data) {
    return data === '<<' || data === null;
}
module.exports = new Type('tag:yaml.org,2002:merge', {
    kind: 'scalar',
    resolve: resolveYamlMerge
});

},{"fba211a6b8e36560":"kPZ9d"}],"eahUu":[function(require,module,exports,__globalThis) {
'use strict';
/*eslint-disable no-bitwise*/ var NodeBuffer;
try {
    // A trick for browserified version, to not include `Buffer` shim
    var _require = undefined;
    NodeBuffer = _require('buffer').Buffer;
} catch (__) {}
var Type = require("7e30331548cd06a4");
// [ 64, 65, 66 ] -> [ padding, CR, LF ]
var BASE64_MAP = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=\n\r';
function resolveYamlBinary(data) {
    if (data === null) return false;
    var code, idx, bitlen = 0, max = data.length, map = BASE64_MAP;
    // Convert one by one.
    for(idx = 0; idx < max; idx++){
        code = map.indexOf(data.charAt(idx));
        // Skip CR/LF
        if (code > 64) continue;
        // Fail on illegal characters
        if (code < 0) return false;
        bitlen += 6;
    }
    // If there are any bits left, source was corrupted
    return bitlen % 8 === 0;
}
function constructYamlBinary(data) {
    var idx, tailbits, input = data.replace(/[\r\n=]/g, ''), max = input.length, map = BASE64_MAP, bits = 0, result = [];
    // Collect by 6*4 bits (3 bytes)
    for(idx = 0; idx < max; idx++){
        if (idx % 4 === 0 && idx) {
            result.push(bits >> 16 & 0xFF);
            result.push(bits >> 8 & 0xFF);
            result.push(bits & 0xFF);
        }
        bits = bits << 6 | map.indexOf(input.charAt(idx));
    }
    // Dump tail
    tailbits = max % 4 * 6;
    if (tailbits === 0) {
        result.push(bits >> 16 & 0xFF);
        result.push(bits >> 8 & 0xFF);
        result.push(bits & 0xFF);
    } else if (tailbits === 18) {
        result.push(bits >> 10 & 0xFF);
        result.push(bits >> 2 & 0xFF);
    } else if (tailbits === 12) result.push(bits >> 4 & 0xFF);
    // Wrap into Buffer for NodeJS and leave Array for browser
    if (NodeBuffer) // Support node 6.+ Buffer API when available
    return NodeBuffer.from ? NodeBuffer.from(result) : new NodeBuffer(result);
    return result;
}
function representYamlBinary(object /*, style*/ ) {
    var result = '', bits = 0, idx, tail, max = object.length, map = BASE64_MAP;
    // Convert every three bytes to 4 ASCII characters.
    for(idx = 0; idx < max; idx++){
        if (idx % 3 === 0 && idx) {
            result += map[bits >> 18 & 0x3F];
            result += map[bits >> 12 & 0x3F];
            result += map[bits >> 6 & 0x3F];
            result += map[bits & 0x3F];
        }
        bits = (bits << 8) + object[idx];
    }
    // Dump tail
    tail = max % 3;
    if (tail === 0) {
        result += map[bits >> 18 & 0x3F];
        result += map[bits >> 12 & 0x3F];
        result += map[bits >> 6 & 0x3F];
        result += map[bits & 0x3F];
    } else if (tail === 2) {
        result += map[bits >> 10 & 0x3F];
        result += map[bits >> 4 & 0x3F];
        result += map[bits << 2 & 0x3F];
        result += map[64];
    } else if (tail === 1) {
        result += map[bits >> 2 & 0x3F];
        result += map[bits << 4 & 0x3F];
        result += map[64];
        result += map[64];
    }
    return result;
}
function isBinary(object) {
    return NodeBuffer && NodeBuffer.isBuffer(object);
}
module.exports = new Type('tag:yaml.org,2002:binary', {
    kind: 'scalar',
    resolve: resolveYamlBinary,
    construct: constructYamlBinary,
    predicate: isBinary,
    represent: representYamlBinary
});

},{"7e30331548cd06a4":"kPZ9d"}],"6PBxo":[function(require,module,exports,__globalThis) {
'use strict';
var Type = require("50dd1763ed7a35f9");
var _hasOwnProperty = Object.prototype.hasOwnProperty;
var _toString = Object.prototype.toString;
function resolveYamlOmap(data) {
    if (data === null) return true;
    var objectKeys = [], index, length, pair, pairKey, pairHasKey, object = data;
    for(index = 0, length = object.length; index < length; index += 1){
        pair = object[index];
        pairHasKey = false;
        if (_toString.call(pair) !== '[object Object]') return false;
        for(pairKey in pair)if (_hasOwnProperty.call(pair, pairKey)) {
            if (!pairHasKey) pairHasKey = true;
            else return false;
        }
        if (!pairHasKey) return false;
        if (objectKeys.indexOf(pairKey) === -1) objectKeys.push(pairKey);
        else return false;
    }
    return true;
}
function constructYamlOmap(data) {
    return data !== null ? data : [];
}
module.exports = new Type('tag:yaml.org,2002:omap', {
    kind: 'sequence',
    resolve: resolveYamlOmap,
    construct: constructYamlOmap
});

},{"50dd1763ed7a35f9":"kPZ9d"}],"jZxPm":[function(require,module,exports,__globalThis) {
'use strict';
var Type = require("9b9a7bf91dd66bba");
var _toString = Object.prototype.toString;
function resolveYamlPairs(data) {
    if (data === null) return true;
    var index, length, pair, keys, result, object = data;
    result = new Array(object.length);
    for(index = 0, length = object.length; index < length; index += 1){
        pair = object[index];
        if (_toString.call(pair) !== '[object Object]') return false;
        keys = Object.keys(pair);
        if (keys.length !== 1) return false;
        result[index] = [
            keys[0],
            pair[keys[0]]
        ];
    }
    return true;
}
function constructYamlPairs(data) {
    if (data === null) return [];
    var index, length, pair, keys, result, object = data;
    result = new Array(object.length);
    for(index = 0, length = object.length; index < length; index += 1){
        pair = object[index];
        keys = Object.keys(pair);
        result[index] = [
            keys[0],
            pair[keys[0]]
        ];
    }
    return result;
}
module.exports = new Type('tag:yaml.org,2002:pairs', {
    kind: 'sequence',
    resolve: resolveYamlPairs,
    construct: constructYamlPairs
});

},{"9b9a7bf91dd66bba":"kPZ9d"}],"gIjqY":[function(require,module,exports,__globalThis) {
'use strict';
var Type = require("3237cf42ae93e0b6");
var _hasOwnProperty = Object.prototype.hasOwnProperty;
function resolveYamlSet(data) {
    if (data === null) return true;
    var key, object = data;
    for(key in object)if (_hasOwnProperty.call(object, key)) {
        if (object[key] !== null) return false;
    }
    return true;
}
function constructYamlSet(data) {
    return data !== null ? data : {};
}
module.exports = new Type('tag:yaml.org,2002:set', {
    kind: 'mapping',
    resolve: resolveYamlSet,
    construct: constructYamlSet
});

},{"3237cf42ae93e0b6":"kPZ9d"}],"dRAq3":[function(require,module,exports,__globalThis) {
// JS-YAML's default schema for `load` function.
// It is not described in the YAML specification.
//
// This schema is based on JS-YAML's default safe schema and includes
// JavaScript-specific types: !!js/undefined, !!js/regexp and !!js/function.
//
// Also this schema is used as default base schema at `Schema.create` function.
'use strict';
var Schema = require("1c1ab2e62ae88fa");
module.exports = Schema.DEFAULT = new Schema({
    include: [
        require("bf49c828bf44b2b5")
    ],
    explicit: [
        require("5d98318346e361f3"),
        require("af7e614008c1e3df"),
        require("6ae5e1c8ceb13b33")
    ]
});

},{"1c1ab2e62ae88fa":"dwfqa","bf49c828bf44b2b5":"hKMmA","5d98318346e361f3":"15i9Q","af7e614008c1e3df":"k4Vzh","6ae5e1c8ceb13b33":"3iCqF"}],"15i9Q":[function(require,module,exports,__globalThis) {
'use strict';
var Type = require("b5217410a0d2f091");
function resolveJavascriptUndefined() {
    return true;
}
function constructJavascriptUndefined() {
    /*eslint-disable no-undefined*/ return undefined;
}
function representJavascriptUndefined() {
    return '';
}
function isUndefined(object) {
    return typeof object === 'undefined';
}
module.exports = new Type('tag:yaml.org,2002:js/undefined', {
    kind: 'scalar',
    resolve: resolveJavascriptUndefined,
    construct: constructJavascriptUndefined,
    predicate: isUndefined,
    represent: representJavascriptUndefined
});

},{"b5217410a0d2f091":"kPZ9d"}],"k4Vzh":[function(require,module,exports,__globalThis) {
'use strict';
var Type = require("cba44dc01821143c");
function resolveJavascriptRegExp(data) {
    if (data === null) return false;
    if (data.length === 0) return false;
    var regexp = data, tail = /\/([gim]*)$/.exec(data), modifiers = '';
    // if regexp starts with '/' it can have modifiers and must be properly closed
    // `/foo/gim` - modifiers tail can be maximum 3 chars
    if (regexp[0] === '/') {
        if (tail) modifiers = tail[1];
        if (modifiers.length > 3) return false;
        // if expression starts with /, is should be properly terminated
        if (regexp[regexp.length - modifiers.length - 1] !== '/') return false;
    }
    return true;
}
function constructJavascriptRegExp(data) {
    var regexp = data, tail = /\/([gim]*)$/.exec(data), modifiers = '';
    // `/foo/gim` - tail can be maximum 4 chars
    if (regexp[0] === '/') {
        if (tail) modifiers = tail[1];
        regexp = regexp.slice(1, regexp.length - modifiers.length - 1);
    }
    return new RegExp(regexp, modifiers);
}
function representJavascriptRegExp(object /*, style*/ ) {
    var result = '/' + object.source + '/';
    if (object.global) result += 'g';
    if (object.multiline) result += 'm';
    if (object.ignoreCase) result += 'i';
    return result;
}
function isRegExp(object) {
    return Object.prototype.toString.call(object) === '[object RegExp]';
}
module.exports = new Type('tag:yaml.org,2002:js/regexp', {
    kind: 'scalar',
    resolve: resolveJavascriptRegExp,
    construct: constructJavascriptRegExp,
    predicate: isRegExp,
    represent: representJavascriptRegExp
});

},{"cba44dc01821143c":"kPZ9d"}],"3iCqF":[function(require,module,exports,__globalThis) {
'use strict';
var esprima;
// Browserified version does not have esprima
//
// 1. For node.js just require module as deps
// 2. For browser try to require mudule via external AMD system.
//    If not found - try to fallback to window.esprima. If not
//    found too - then fail to parse.
//
try {
    // workaround to exclude package from browserify list.
    var _require = undefined;
    esprima = _require('esprima');
} catch (_) {
    /* eslint-disable no-redeclare */ /* global window */ if (typeof window !== 'undefined') esprima = window.esprima;
}
var Type = require("29e58bbedf3b8bb");
function resolveJavascriptFunction(data) {
    if (data === null) return false;
    try {
        var source = '(' + data + ')', ast = esprima.parse(source, {
            range: true
        });
        if (ast.type !== 'Program' || ast.body.length !== 1 || ast.body[0].type !== 'ExpressionStatement' || ast.body[0].expression.type !== 'ArrowFunctionExpression' && ast.body[0].expression.type !== 'FunctionExpression') return false;
        return true;
    } catch (err) {
        return false;
    }
}
function constructJavascriptFunction(data) {
    /*jslint evil:true*/ var source = '(' + data + ')', ast = esprima.parse(source, {
        range: true
    }), params = [], body;
    if (ast.type !== 'Program' || ast.body.length !== 1 || ast.body[0].type !== 'ExpressionStatement' || ast.body[0].expression.type !== 'ArrowFunctionExpression' && ast.body[0].expression.type !== 'FunctionExpression') throw new Error('Failed to resolve function');
    ast.body[0].expression.params.forEach(function(param) {
        params.push(param.name);
    });
    body = ast.body[0].expression.body.range;
    // Esprima's ranges include the first '{' and the last '}' characters on
    // function expressions. So cut them out.
    if (ast.body[0].expression.body.type === 'BlockStatement') /*eslint-disable no-new-func*/ return new Function(params, source.slice(body[0] + 1, body[1] - 1));
    // ES6 arrow functions can omit the BlockStatement. In that case, just return
    // the body.
    /*eslint-disable no-new-func*/ return new Function(params, 'return ' + source.slice(body[0], body[1]));
}
function representJavascriptFunction(object /*, style*/ ) {
    return object.toString();
}
function isFunction(object) {
    return Object.prototype.toString.call(object) === '[object Function]';
}
module.exports = new Type('tag:yaml.org,2002:js/function', {
    kind: 'scalar',
    resolve: resolveJavascriptFunction,
    construct: constructJavascriptFunction,
    predicate: isFunction,
    represent: representJavascriptFunction
});

},{"29e58bbedf3b8bb":"kPZ9d"}],"6bpv3":[function(require,module,exports,__globalThis) {
'use strict';
/*eslint-disable no-use-before-define*/ var common = require("f26a05f168a3556c");
var YAMLException = require("4c04a9b2e37e6f28");
var DEFAULT_FULL_SCHEMA = require("52fc20edb074fc61");
var DEFAULT_SAFE_SCHEMA = require("ea9d907a8876b7ba");
var _toString = Object.prototype.toString;
var _hasOwnProperty = Object.prototype.hasOwnProperty;
var CHAR_TAB = 0x09; /* Tab */ 
var CHAR_LINE_FEED = 0x0A; /* LF */ 
var CHAR_CARRIAGE_RETURN = 0x0D; /* CR */ 
var CHAR_SPACE = 0x20; /* Space */ 
var CHAR_EXCLAMATION = 0x21; /* ! */ 
var CHAR_DOUBLE_QUOTE = 0x22; /* " */ 
var CHAR_SHARP = 0x23; /* # */ 
var CHAR_PERCENT = 0x25; /* % */ 
var CHAR_AMPERSAND = 0x26; /* & */ 
var CHAR_SINGLE_QUOTE = 0x27; /* ' */ 
var CHAR_ASTERISK = 0x2A; /* * */ 
var CHAR_COMMA = 0x2C; /* , */ 
var CHAR_MINUS = 0x2D; /* - */ 
var CHAR_COLON = 0x3A; /* : */ 
var CHAR_EQUALS = 0x3D; /* = */ 
var CHAR_GREATER_THAN = 0x3E; /* > */ 
var CHAR_QUESTION = 0x3F; /* ? */ 
var CHAR_COMMERCIAL_AT = 0x40; /* @ */ 
var CHAR_LEFT_SQUARE_BRACKET = 0x5B; /* [ */ 
var CHAR_RIGHT_SQUARE_BRACKET = 0x5D; /* ] */ 
var CHAR_GRAVE_ACCENT = 0x60; /* ` */ 
var CHAR_LEFT_CURLY_BRACKET = 0x7B; /* { */ 
var CHAR_VERTICAL_LINE = 0x7C; /* | */ 
var CHAR_RIGHT_CURLY_BRACKET = 0x7D; /* } */ 
var ESCAPE_SEQUENCES = {};
ESCAPE_SEQUENCES[0x00] = '\\0';
ESCAPE_SEQUENCES[0x07] = '\\a';
ESCAPE_SEQUENCES[0x08] = '\\b';
ESCAPE_SEQUENCES[0x09] = '\\t';
ESCAPE_SEQUENCES[0x0A] = '\\n';
ESCAPE_SEQUENCES[0x0B] = '\\v';
ESCAPE_SEQUENCES[0x0C] = '\\f';
ESCAPE_SEQUENCES[0x0D] = '\\r';
ESCAPE_SEQUENCES[0x1B] = '\\e';
ESCAPE_SEQUENCES[0x22] = '\\"';
ESCAPE_SEQUENCES[0x5C] = '\\\\';
ESCAPE_SEQUENCES[0x85] = '\\N';
ESCAPE_SEQUENCES[0xA0] = '\\_';
ESCAPE_SEQUENCES[0x2028] = '\\L';
ESCAPE_SEQUENCES[0x2029] = '\\P';
var DEPRECATED_BOOLEANS_SYNTAX = [
    'y',
    'Y',
    'yes',
    'Yes',
    'YES',
    'on',
    'On',
    'ON',
    'n',
    'N',
    'no',
    'No',
    'NO',
    'off',
    'Off',
    'OFF'
];
function compileStyleMap(schema, map) {
    var result, keys, index, length, tag, style, type;
    if (map === null) return {};
    result = {};
    keys = Object.keys(map);
    for(index = 0, length = keys.length; index < length; index += 1){
        tag = keys[index];
        style = String(map[tag]);
        if (tag.slice(0, 2) === '!!') tag = 'tag:yaml.org,2002:' + tag.slice(2);
        type = schema.compiledTypeMap['fallback'][tag];
        if (type && _hasOwnProperty.call(type.styleAliases, style)) style = type.styleAliases[style];
        result[tag] = style;
    }
    return result;
}
function encodeHex(character) {
    var string, handle, length;
    string = character.toString(16).toUpperCase();
    if (character <= 0xFF) {
        handle = 'x';
        length = 2;
    } else if (character <= 0xFFFF) {
        handle = 'u';
        length = 4;
    } else if (character <= 0xFFFFFFFF) {
        handle = 'U';
        length = 8;
    } else throw new YAMLException('code point within a string may not be greater than 0xFFFFFFFF');
    return '\\' + handle + common.repeat('0', length - string.length) + string;
}
function State(options) {
    this.schema = options['schema'] || DEFAULT_FULL_SCHEMA;
    this.indent = Math.max(1, options['indent'] || 2);
    this.noArrayIndent = options['noArrayIndent'] || false;
    this.skipInvalid = options['skipInvalid'] || false;
    this.flowLevel = common.isNothing(options['flowLevel']) ? -1 : options['flowLevel'];
    this.styleMap = compileStyleMap(this.schema, options['styles'] || null);
    this.sortKeys = options['sortKeys'] || false;
    this.lineWidth = options['lineWidth'] || 80;
    this.noRefs = options['noRefs'] || false;
    this.noCompatMode = options['noCompatMode'] || false;
    this.condenseFlow = options['condenseFlow'] || false;
    this.implicitTypes = this.schema.compiledImplicit;
    this.explicitTypes = this.schema.compiledExplicit;
    this.tag = null;
    this.result = '';
    this.duplicates = [];
    this.usedDuplicates = null;
}
// Indents every line in a string. Empty lines (\n only) are not indented.
function indentString(string, spaces) {
    var ind = common.repeat(' ', spaces), position = 0, next = -1, result = '', line, length = string.length;
    while(position < length){
        next = string.indexOf('\n', position);
        if (next === -1) {
            line = string.slice(position);
            position = length;
        } else {
            line = string.slice(position, next + 1);
            position = next + 1;
        }
        if (line.length && line !== '\n') result += ind;
        result += line;
    }
    return result;
}
function generateNextLine(state, level) {
    return '\n' + common.repeat(' ', state.indent * level);
}
function testImplicitResolving(state, str) {
    var index, length, type;
    for(index = 0, length = state.implicitTypes.length; index < length; index += 1){
        type = state.implicitTypes[index];
        if (type.resolve(str)) return true;
    }
    return false;
}
// [33] s-white ::= s-space | s-tab
function isWhitespace(c) {
    return c === CHAR_SPACE || c === CHAR_TAB;
}
// Returns true if the character can be printed without escaping.
// From YAML 1.2: "any allowed characters known to be non-printable
// should also be escaped. [However,] This isn’t mandatory"
// Derived from nb-char - \t - #x85 - #xA0 - #x2028 - #x2029.
function isPrintable(c) {
    return 0x00020 <= c && c <= 0x00007E || 0x000A1 <= c && c <= 0x00D7FF && c !== 0x2028 && c !== 0x2029 || 0x0E000 <= c && c <= 0x00FFFD && c !== 0xFEFF /* BOM */  || 0x10000 <= c && c <= 0x10FFFF;
}
// [34] ns-char ::= nb-char - s-white
// [27] nb-char ::= c-printable - b-char - c-byte-order-mark
// [26] b-char  ::= b-line-feed | b-carriage-return
// [24] b-line-feed       ::=     #xA    /* LF */
// [25] b-carriage-return ::=     #xD    /* CR */
// [3]  c-byte-order-mark ::=     #xFEFF
function isNsChar(c) {
    return isPrintable(c) && !isWhitespace(c) && c !== 0xFEFF && c !== CHAR_CARRIAGE_RETURN && c !== CHAR_LINE_FEED;
}
// Simplified test for values allowed after the first character in plain style.
function isPlainSafe(c, prev) {
    // Uses a subset of nb-char - c-flow-indicator - ":" - "#"
    // where nb-char ::= c-printable - b-char - c-byte-order-mark.
    return isPrintable(c) && c !== 0xFEFF && c !== CHAR_COMMA && c !== CHAR_LEFT_SQUARE_BRACKET && c !== CHAR_RIGHT_SQUARE_BRACKET && c !== CHAR_LEFT_CURLY_BRACKET && c !== CHAR_RIGHT_CURLY_BRACKET && c !== CHAR_COLON && (c !== CHAR_SHARP || prev && isNsChar(prev));
}
// Simplified test for values allowed as the first character in plain style.
function isPlainSafeFirst(c) {
    // Uses a subset of ns-char - c-indicator
    // where ns-char = nb-char - s-white.
    return isPrintable(c) && c !== 0xFEFF && !isWhitespace(c) // - s-white
     && c !== CHAR_MINUS && c !== CHAR_QUESTION && c !== CHAR_COLON && c !== CHAR_COMMA && c !== CHAR_LEFT_SQUARE_BRACKET && c !== CHAR_RIGHT_SQUARE_BRACKET && c !== CHAR_LEFT_CURLY_BRACKET && c !== CHAR_RIGHT_CURLY_BRACKET && c !== CHAR_SHARP && c !== CHAR_AMPERSAND && c !== CHAR_ASTERISK && c !== CHAR_EXCLAMATION && c !== CHAR_VERTICAL_LINE && c !== CHAR_EQUALS && c !== CHAR_GREATER_THAN && c !== CHAR_SINGLE_QUOTE && c !== CHAR_DOUBLE_QUOTE && c !== CHAR_PERCENT && c !== CHAR_COMMERCIAL_AT && c !== CHAR_GRAVE_ACCENT;
}
// Determines whether block indentation indicator is required.
function needIndentIndicator(string) {
    var leadingSpaceRe = /^\n* /;
    return leadingSpaceRe.test(string);
}
var STYLE_PLAIN = 1, STYLE_SINGLE = 2, STYLE_LITERAL = 3, STYLE_FOLDED = 4, STYLE_DOUBLE = 5;
// Determines which scalar styles are possible and returns the preferred style.
// lineWidth = -1 => no limit.
// Pre-conditions: str.length > 0.
// Post-conditions:
//    STYLE_PLAIN or STYLE_SINGLE => no \n are in the string.
//    STYLE_LITERAL => no lines are suitable for folding (or lineWidth is -1).
//    STYLE_FOLDED => a line > lineWidth and can be folded (and lineWidth != -1).
function chooseScalarStyle(string, singleLineOnly, indentPerLevel, lineWidth, testAmbiguousType) {
    var i;
    var char, prev_char;
    var hasLineBreak = false;
    var hasFoldableLine = false; // only checked if shouldTrackWidth
    var shouldTrackWidth = lineWidth !== -1;
    var previousLineBreak = -1; // count the first line correctly
    var plain = isPlainSafeFirst(string.charCodeAt(0)) && !isWhitespace(string.charCodeAt(string.length - 1));
    if (singleLineOnly) // Case: no block styles.
    // Check for disallowed characters to rule out plain and single.
    for(i = 0; i < string.length; i++){
        char = string.charCodeAt(i);
        if (!isPrintable(char)) return STYLE_DOUBLE;
        prev_char = i > 0 ? string.charCodeAt(i - 1) : null;
        plain = plain && isPlainSafe(char, prev_char);
    }
    else {
        // Case: block styles permitted.
        for(i = 0; i < string.length; i++){
            char = string.charCodeAt(i);
            if (char === CHAR_LINE_FEED) {
                hasLineBreak = true;
                // Check if any line can be folded.
                if (shouldTrackWidth) {
                    hasFoldableLine = hasFoldableLine || // Foldable line = too long, and not more-indented.
                    i - previousLineBreak - 1 > lineWidth && string[previousLineBreak + 1] !== ' ';
                    previousLineBreak = i;
                }
            } else if (!isPrintable(char)) return STYLE_DOUBLE;
            prev_char = i > 0 ? string.charCodeAt(i - 1) : null;
            plain = plain && isPlainSafe(char, prev_char);
        }
        // in case the end is missing a \n
        hasFoldableLine = hasFoldableLine || shouldTrackWidth && i - previousLineBreak - 1 > lineWidth && string[previousLineBreak + 1] !== ' ';
    }
    // Although every style can represent \n without escaping, prefer block styles
    // for multiline, since they're more readable and they don't add empty lines.
    // Also prefer folding a super-long line.
    if (!hasLineBreak && !hasFoldableLine) // Strings interpretable as another type have to be quoted;
    // e.g. the string 'true' vs. the boolean true.
    return plain && !testAmbiguousType(string) ? STYLE_PLAIN : STYLE_SINGLE;
    // Edge case: block indentation indicator can only have one digit.
    if (indentPerLevel > 9 && needIndentIndicator(string)) return STYLE_DOUBLE;
    // At this point we know block styles are valid.
    // Prefer literal style unless we want to fold.
    return hasFoldableLine ? STYLE_FOLDED : STYLE_LITERAL;
}
// Note: line breaking/folding is implemented for only the folded style.
// NB. We drop the last trailing newline (if any) of a returned block scalar
//  since the dumper adds its own newline. This always works:
//    • No ending newline => unaffected; already using strip "-" chomping.
//    • Ending newline    => removed then restored.
//  Importantly, this keeps the "+" chomp indicator from gaining an extra line.
function writeScalar(state, string, level, iskey) {
    state.dump = function() {
        if (string.length === 0) return "''";
        if (!state.noCompatMode && DEPRECATED_BOOLEANS_SYNTAX.indexOf(string) !== -1) return "'" + string + "'";
        var indent = state.indent * Math.max(1, level); // no 0-indent scalars
        // As indentation gets deeper, let the width decrease monotonically
        // to the lower bound min(state.lineWidth, 40).
        // Note that this implies
        //  state.lineWidth ≤ 40 + state.indent: width is fixed at the lower bound.
        //  state.lineWidth > 40 + state.indent: width decreases until the lower bound.
        // This behaves better than a constant minimum width which disallows narrower options,
        // or an indent threshold which causes the width to suddenly increase.
        var lineWidth = state.lineWidth === -1 ? -1 : Math.max(Math.min(state.lineWidth, 40), state.lineWidth - indent);
        // Without knowing if keys are implicit/explicit, assume implicit for safety.
        var singleLineOnly = iskey || state.flowLevel > -1 && level >= state.flowLevel;
        function testAmbiguity(string) {
            return testImplicitResolving(state, string);
        }
        switch(chooseScalarStyle(string, singleLineOnly, state.indent, lineWidth, testAmbiguity)){
            case STYLE_PLAIN:
                return string;
            case STYLE_SINGLE:
                return "'" + string.replace(/'/g, "''") + "'";
            case STYLE_LITERAL:
                return '|' + blockHeader(string, state.indent) + dropEndingNewline(indentString(string, indent));
            case STYLE_FOLDED:
                return '>' + blockHeader(string, state.indent) + dropEndingNewline(indentString(foldString(string, lineWidth), indent));
            case STYLE_DOUBLE:
                return '"' + escapeString(string, lineWidth) + '"';
            default:
                throw new YAMLException('impossible error: invalid scalar style');
        }
    }();
}
// Pre-conditions: string is valid for a block scalar, 1 <= indentPerLevel <= 9.
function blockHeader(string, indentPerLevel) {
    var indentIndicator = needIndentIndicator(string) ? String(indentPerLevel) : '';
    // note the special case: the string '\n' counts as a "trailing" empty line.
    var clip = string[string.length - 1] === '\n';
    var keep = clip && (string[string.length - 2] === '\n' || string === '\n');
    var chomp = keep ? '+' : clip ? '' : '-';
    return indentIndicator + chomp + '\n';
}
// (See the note for writeScalar.)
function dropEndingNewline(string) {
    return string[string.length - 1] === '\n' ? string.slice(0, -1) : string;
}
// Note: a long line without a suitable break point will exceed the width limit.
// Pre-conditions: every char in str isPrintable, str.length > 0, width > 0.
function foldString(string, width) {
    // In folded style, $k$ consecutive newlines output as $k+1$ newlines—
    // unless they're before or after a more-indented line, or at the very
    // beginning or end, in which case $k$ maps to $k$.
    // Therefore, parse each chunk as newline(s) followed by a content line.
    var lineRe = /(\n+)([^\n]*)/g;
    // first line (possibly an empty line)
    var result = function() {
        var nextLF = string.indexOf('\n');
        nextLF = nextLF !== -1 ? nextLF : string.length;
        lineRe.lastIndex = nextLF;
        return foldLine(string.slice(0, nextLF), width);
    }();
    // If we haven't reached the first content line yet, don't add an extra \n.
    var prevMoreIndented = string[0] === '\n' || string[0] === ' ';
    var moreIndented;
    // rest of the lines
    var match;
    while(match = lineRe.exec(string)){
        var prefix = match[1], line = match[2];
        moreIndented = line[0] === ' ';
        result += prefix + (!prevMoreIndented && !moreIndented && line !== '' ? '\n' : '') + foldLine(line, width);
        prevMoreIndented = moreIndented;
    }
    return result;
}
// Greedy line breaking.
// Picks the longest line under the limit each time,
// otherwise settles for the shortest line over the limit.
// NB. More-indented lines *cannot* be folded, as that would add an extra \n.
function foldLine(line, width) {
    if (line === '' || line[0] === ' ') return line;
    // Since a more-indented line adds a \n, breaks can't be followed by a space.
    var breakRe = / [^ ]/g; // note: the match index will always be <= length-2.
    var match;
    // start is an inclusive index. end, curr, and next are exclusive.
    var start = 0, end, curr = 0, next = 0;
    var result = '';
    // Invariants: 0 <= start <= length-1.
    //   0 <= curr <= next <= max(0, length-2). curr - start <= width.
    // Inside the loop:
    //   A match implies length >= 2, so curr and next are <= length-2.
    while(match = breakRe.exec(line)){
        next = match.index;
        // maintain invariant: curr - start <= width
        if (next - start > width) {
            end = curr > start ? curr : next; // derive end <= length-2
            result += '\n' + line.slice(start, end);
            // skip the space that was output as \n
            start = end + 1; // derive start <= length-1
        }
        curr = next;
    }
    // By the invariants, start <= length-1, so there is something left over.
    // It is either the whole string or a part starting from non-whitespace.
    result += '\n';
    // Insert a break if the remainder is too long and there is a break available.
    if (line.length - start > width && curr > start) result += line.slice(start, curr) + '\n' + line.slice(curr + 1);
    else result += line.slice(start);
    return result.slice(1); // drop extra \n joiner
}
// Escapes a double-quoted string.
function escapeString(string) {
    var result = '';
    var char, nextChar;
    var escapeSeq;
    for(var i = 0; i < string.length; i++){
        char = string.charCodeAt(i);
        // Check for surrogate pairs (reference Unicode 3.0 section "3.7 Surrogates").
        if (char >= 0xD800 && char <= 0xDBFF /* high surrogate */ ) {
            nextChar = string.charCodeAt(i + 1);
            if (nextChar >= 0xDC00 && nextChar <= 0xDFFF /* low surrogate */ ) {
                // Combine the surrogate pair and store it escaped.
                result += encodeHex((char - 0xD800) * 0x400 + nextChar - 0xDC00 + 0x10000);
                // Advance index one extra since we already used that char here.
                i++;
                continue;
            }
        }
        escapeSeq = ESCAPE_SEQUENCES[char];
        result += !escapeSeq && isPrintable(char) ? string[i] : escapeSeq || encodeHex(char);
    }
    return result;
}
function writeFlowSequence(state, level, object) {
    var _result = '', _tag = state.tag, index, length;
    for(index = 0, length = object.length; index < length; index += 1)// Write only valid elements.
    if (writeNode(state, level, object[index], false, false)) {
        if (index !== 0) _result += ',' + (!state.condenseFlow ? ' ' : '');
        _result += state.dump;
    }
    state.tag = _tag;
    state.dump = '[' + _result + ']';
}
function writeBlockSequence(state, level, object, compact) {
    var _result = '', _tag = state.tag, index, length;
    for(index = 0, length = object.length; index < length; index += 1)// Write only valid elements.
    if (writeNode(state, level + 1, object[index], true, true)) {
        if (!compact || index !== 0) _result += generateNextLine(state, level);
        if (state.dump && CHAR_LINE_FEED === state.dump.charCodeAt(0)) _result += '-';
        else _result += '- ';
        _result += state.dump;
    }
    state.tag = _tag;
    state.dump = _result || '[]'; // Empty sequence if no valid values.
}
function writeFlowMapping(state, level, object) {
    var _result = '', _tag = state.tag, objectKeyList = Object.keys(object), index, length, objectKey, objectValue, pairBuffer;
    for(index = 0, length = objectKeyList.length; index < length; index += 1){
        pairBuffer = '';
        if (index !== 0) pairBuffer += ', ';
        if (state.condenseFlow) pairBuffer += '"';
        objectKey = objectKeyList[index];
        objectValue = object[objectKey];
        if (!writeNode(state, level, objectKey, false, false)) continue; // Skip this pair because of invalid key;
        if (state.dump.length > 1024) pairBuffer += '? ';
        pairBuffer += state.dump + (state.condenseFlow ? '"' : '') + ':' + (state.condenseFlow ? '' : ' ');
        if (!writeNode(state, level, objectValue, false, false)) continue; // Skip this pair because of invalid value.
        pairBuffer += state.dump;
        // Both key and value are valid.
        _result += pairBuffer;
    }
    state.tag = _tag;
    state.dump = '{' + _result + '}';
}
function writeBlockMapping(state, level, object, compact) {
    var _result = '', _tag = state.tag, objectKeyList = Object.keys(object), index, length, objectKey, objectValue, explicitPair, pairBuffer;
    // Allow sorting keys so that the output file is deterministic
    if (state.sortKeys === true) // Default sorting
    objectKeyList.sort();
    else if (typeof state.sortKeys === 'function') // Custom sort function
    objectKeyList.sort(state.sortKeys);
    else if (state.sortKeys) // Something is wrong
    throw new YAMLException('sortKeys must be a boolean or a function');
    for(index = 0, length = objectKeyList.length; index < length; index += 1){
        pairBuffer = '';
        if (!compact || index !== 0) pairBuffer += generateNextLine(state, level);
        objectKey = objectKeyList[index];
        objectValue = object[objectKey];
        if (!writeNode(state, level + 1, objectKey, true, true, true)) continue; // Skip this pair because of invalid key.
        explicitPair = state.tag !== null && state.tag !== '?' || state.dump && state.dump.length > 1024;
        if (explicitPair) {
            if (state.dump && CHAR_LINE_FEED === state.dump.charCodeAt(0)) pairBuffer += '?';
            else pairBuffer += '? ';
        }
        pairBuffer += state.dump;
        if (explicitPair) pairBuffer += generateNextLine(state, level);
        if (!writeNode(state, level + 1, objectValue, true, explicitPair)) continue; // Skip this pair because of invalid value.
        if (state.dump && CHAR_LINE_FEED === state.dump.charCodeAt(0)) pairBuffer += ':';
        else pairBuffer += ': ';
        pairBuffer += state.dump;
        // Both key and value are valid.
        _result += pairBuffer;
    }
    state.tag = _tag;
    state.dump = _result || '{}'; // Empty mapping if no valid pairs.
}
function detectType(state, object, explicit) {
    var _result, typeList, index, length, type, style;
    typeList = explicit ? state.explicitTypes : state.implicitTypes;
    for(index = 0, length = typeList.length; index < length; index += 1){
        type = typeList[index];
        if ((type.instanceOf || type.predicate) && (!type.instanceOf || typeof object === 'object' && object instanceof type.instanceOf) && (!type.predicate || type.predicate(object))) {
            state.tag = explicit ? type.tag : '?';
            if (type.represent) {
                style = state.styleMap[type.tag] || type.defaultStyle;
                if (_toString.call(type.represent) === '[object Function]') _result = type.represent(object, style);
                else if (_hasOwnProperty.call(type.represent, style)) _result = type.represent[style](object, style);
                else throw new YAMLException('!<' + type.tag + '> tag resolver accepts not "' + style + '" style');
                state.dump = _result;
            }
            return true;
        }
    }
    return false;
}
// Serializes `object` and writes it to global `result`.
// Returns true on success, or false on invalid object.
//
function writeNode(state, level, object, block, compact, iskey) {
    state.tag = null;
    state.dump = object;
    if (!detectType(state, object, false)) detectType(state, object, true);
    var type = _toString.call(state.dump);
    if (block) block = state.flowLevel < 0 || state.flowLevel > level;
    var objectOrArray = type === '[object Object]' || type === '[object Array]', duplicateIndex, duplicate;
    if (objectOrArray) {
        duplicateIndex = state.duplicates.indexOf(object);
        duplicate = duplicateIndex !== -1;
    }
    if (state.tag !== null && state.tag !== '?' || duplicate || state.indent !== 2 && level > 0) compact = false;
    if (duplicate && state.usedDuplicates[duplicateIndex]) state.dump = '*ref_' + duplicateIndex;
    else {
        if (objectOrArray && duplicate && !state.usedDuplicates[duplicateIndex]) state.usedDuplicates[duplicateIndex] = true;
        if (type === '[object Object]') {
            if (block && Object.keys(state.dump).length !== 0) {
                writeBlockMapping(state, level, state.dump, compact);
                if (duplicate) state.dump = '&ref_' + duplicateIndex + state.dump;
            } else {
                writeFlowMapping(state, level, state.dump);
                if (duplicate) state.dump = '&ref_' + duplicateIndex + ' ' + state.dump;
            }
        } else if (type === '[object Array]') {
            var arrayLevel = state.noArrayIndent && level > 0 ? level - 1 : level;
            if (block && state.dump.length !== 0) {
                writeBlockSequence(state, arrayLevel, state.dump, compact);
                if (duplicate) state.dump = '&ref_' + duplicateIndex + state.dump;
            } else {
                writeFlowSequence(state, arrayLevel, state.dump);
                if (duplicate) state.dump = '&ref_' + duplicateIndex + ' ' + state.dump;
            }
        } else if (type === '[object String]') {
            if (state.tag !== '?') writeScalar(state, state.dump, level, iskey);
        } else {
            if (state.skipInvalid) return false;
            throw new YAMLException('unacceptable kind of an object to dump ' + type);
        }
        if (state.tag !== null && state.tag !== '?') state.dump = '!<' + state.tag + '> ' + state.dump;
    }
    return true;
}
function getDuplicateReferences(object, state) {
    var objects = [], duplicatesIndexes = [], index, length;
    inspectNode(object, objects, duplicatesIndexes);
    for(index = 0, length = duplicatesIndexes.length; index < length; index += 1)state.duplicates.push(objects[duplicatesIndexes[index]]);
    state.usedDuplicates = new Array(length);
}
function inspectNode(object, objects, duplicatesIndexes) {
    var objectKeyList, index, length;
    if (object !== null && typeof object === 'object') {
        index = objects.indexOf(object);
        if (index !== -1) {
            if (duplicatesIndexes.indexOf(index) === -1) duplicatesIndexes.push(index);
        } else {
            objects.push(object);
            if (Array.isArray(object)) for(index = 0, length = object.length; index < length; index += 1)inspectNode(object[index], objects, duplicatesIndexes);
            else {
                objectKeyList = Object.keys(object);
                for(index = 0, length = objectKeyList.length; index < length; index += 1)inspectNode(object[objectKeyList[index]], objects, duplicatesIndexes);
            }
        }
    }
}
function dump(input, options) {
    options = options || {};
    var state = new State(options);
    if (!state.noRefs) getDuplicateReferences(input, state);
    if (writeNode(state, 0, input, true, true)) return state.dump + '\n';
    return '';
}
function safeDump(input, options) {
    return dump(input, common.extend({
        schema: DEFAULT_SAFE_SCHEMA
    }, options));
}
module.exports.dump = dump;
module.exports.safeDump = safeDump;

},{"f26a05f168a3556c":"5F3ap","4c04a9b2e37e6f28":"9ywNX","52fc20edb074fc61":"dRAq3","ea9d907a8876b7ba":"hKMmA"}],"dGc8H":[function(require,module,exports,__globalThis) {
'use strict';
var _ = {
    cloneDeep: require("40546b9cf3e7b33a"),
    isUndefined: require("b013028ac87a8872"),
    isEmpty: require("587336246679526"),
    isObject: require("6077b038d663d2ff")
};
var helpers = require("41fd6979be14d422");
var Model = require("ccb4c7bdde266871");
var SwaggerHttp = require("c95b745576b99dfb");
var Q = require("f3a0c14d9d625480");
var Operation = module.exports = function(parent, scheme, operationId, httpMethod, path, args, definitions, models, clientAuthorizations) {
    var errors = [];
    parent = parent || {};
    args = args || {};
    if (parent && parent.options) {
        this.client = parent.options.client || null;
        this.requestInterceptor = parent.options.requestInterceptor || null;
        this.responseInterceptor = parent.options.responseInterceptor || null;
    }
    this.authorizations = args.security;
    this.basePath = parent.basePath || '/';
    this.clientAuthorizations = clientAuthorizations;
    this.consumes = args.consumes || parent.consumes || [
        'application/json'
    ];
    this.produces = args.produces || parent.produces || [
        'application/json'
    ];
    this.deprecated = args.deprecated;
    this.description = args.description;
    this.host = parent.host;
    this.method = httpMethod || errors.push('Operation ' + operationId + ' is missing method.');
    this.models = models || {};
    this.nickname = operationId || errors.push('Operations must have a nickname.');
    this.operation = args;
    this.operations = {};
    this.parameters = args !== null ? args.parameters || [] : {};
    this.parent = parent;
    this.path = path || errors.push('Operation ' + this.nickname + ' is missing path.');
    this.responses = args.responses || {};
    this.scheme = scheme || parent.scheme || 'http';
    this.schemes = args.schemes || parent.schemes;
    this.security = args.security || parent.security;
    this.summary = args.summary || '';
    this.timeout = parent.timeout;
    this.type = null;
    this.useJQuery = parent.useJQuery;
    this.jqueryAjaxCache = parent.jqueryAjaxCache;
    this.enableCookies = parent.enableCookies;
    if (!this.host) {
        if (typeof window !== 'undefined') this.host = window.location.host;
        else this.host = 'localhost';
    }
    this.parameterMacro = parent.parameterMacro || function(operation, parameter) {
        return parameter.default;
    };
    this.inlineModels = [];
    if (this.basePath !== '/' && this.basePath.slice(-1) === '/') this.basePath = this.basePath.slice(0, -1);
    if (typeof this.deprecated === 'string') switch(this.deprecated.toLowerCase()){
        case 'true':
        case 'yes':
        case '1':
            this.deprecated = true;
            break;
        case 'false':
        case 'no':
        case '0':
        case null:
            this.deprecated = false;
            break;
        default:
            this.deprecated = Boolean(this.deprecated);
    }
    var i, model;
    if (definitions) {
        // add to global models
        var key;
        for(key in definitions){
            model = new Model(key, definitions[key], this.models, parent.modelPropertyMacro);
            if (model) this.models[key] = model;
        }
    } else definitions = {};
    for(i = 0; i < this.parameters.length; i++){
        var param = this.parameters[i];
        // Allow macro to set the default value
        param.default = this.parameterMacro(this, param);
        if (param.type === 'array') {
            param.isList = true;
            param.allowMultiple = true;
        // the enum can be defined at the items level
        //if (param.items && param.items.enum) {
        //  param['enum'] = param.items.enum;
        //}
        }
        var innerType = this.getType(param);
        if (innerType && innerType.toString().toLowerCase() === 'boolean') {
            param.allowableValues = {};
            param.isList = true;
            param['enum'] = [
                true,
                false
            ]; // use actual primitives
        }
        if (typeof param['x-example'] !== 'undefined') {
            var d = param['x-example'];
            param.default = d;
        }
        if (param['x-examples']) {
            var d = param['x-examples'].default;
            if (typeof d !== 'undefined') param.default = d;
        }
        var enumValues = param['enum'] || param.items && param.items['enum'];
        if (typeof enumValues !== 'undefined') {
            var id;
            param.allowableValues = {};
            param.allowableValues.values = [];
            param.allowableValues.descriptiveValues = [];
            for(id = 0; id < enumValues.length; id++){
                var value = enumValues[id];
                var isDefault = value === param.default || value + '' === param.default;
                param.allowableValues.values.push(value);
                // Always have string for descriptive values....
                param.allowableValues.descriptiveValues.push({
                    value: value + '',
                    isDefault: isDefault
                });
            }
        }
        if (param.type === 'array') {
            innerType = [
                innerType
            ];
            if (typeof param.allowableValues === 'undefined') {
                // can't show as a list if no values to select from
                delete param.isList;
                delete param.allowMultiple;
            }
        }
        param.modelSignature = {
            type: innerType,
            definitions: this.models
        };
        param.signature = this.getModelSignature(innerType, this.models).toString();
        param.sampleJSON = this.getModelSampleJSON(innerType, this.models);
        param.responseClassSignature = param.signature;
    }
    var defaultResponseCode, response, responses = this.responses;
    if (responses['200']) {
        response = responses['200'];
        defaultResponseCode = '200';
    } else if (responses['201']) {
        response = responses['201'];
        defaultResponseCode = '201';
    } else if (responses['202']) {
        response = responses['202'];
        defaultResponseCode = '202';
    } else if (responses['203']) {
        response = responses['203'];
        defaultResponseCode = '203';
    } else if (responses['204']) {
        response = responses['204'];
        defaultResponseCode = '204';
    } else if (responses['205']) {
        response = responses['205'];
        defaultResponseCode = '205';
    } else if (responses['206']) {
        response = responses['206'];
        defaultResponseCode = '206';
    } else if (responses['default']) {
        response = responses['default'];
        defaultResponseCode = 'default';
    }
    if (response && response.schema) {
        var resolvedModel = this.resolveModel(response.schema, definitions);
        var successResponse;
        delete responses[defaultResponseCode];
        if (resolvedModel) {
            this.successResponse = {};
            successResponse = this.successResponse[defaultResponseCode] = resolvedModel;
        } else if (!response.schema.type || response.schema.type === 'object' || response.schema.type === 'array') {
            // Inline model
            this.successResponse = {};
            successResponse = this.successResponse[defaultResponseCode] = new Model(undefined, response.schema || {}, this.models, parent.modelPropertyMacro);
        } else {
            // Primitive
            this.successResponse = {};
            successResponse = this.successResponse[defaultResponseCode] = response.schema;
        }
        if (successResponse) {
            // Attach response properties
            if (response.description) successResponse.description = response.description;
            if (response.examples) successResponse.examples = response.examples;
            if (response.headers) successResponse.headers = response.headers;
        }
        this.type = response;
    }
    if (errors.length > 0) {
        if (this.resource && this.resource.api && this.resource.api.fail) this.resource.api.fail(errors);
    }
    return this;
};
Operation.prototype.isDefaultArrayItemValue = function(value, param) {
    if (param.default && Array.isArray(param.default)) return param.default.indexOf(value) !== -1;
    return value === param.default;
};
Operation.prototype.getType = function(param) {
    var type = param.type;
    var format = param.format;
    var isArray = false;
    var str;
    if (type === 'integer' && format === 'int32') str = 'integer';
    else if (type === 'integer' && format === 'int64') str = 'long';
    else if (type === 'integer') str = 'integer';
    else if (type === 'string') {
        if (format === 'date-time') str = 'date-time';
        else if (format === 'date') str = 'date';
        else str = 'string';
    } else if (type === 'number' && format === 'float') str = 'float';
    else if (type === 'number' && format === 'double') str = 'double';
    else if (type === 'number') str = 'double';
    else if (type === 'boolean') str = 'boolean';
    else if (type === 'array') {
        isArray = true;
        if (param.items) str = this.getType(param.items);
    } else if (type === 'file') str = 'file';
    if (param.$ref) str = helpers.simpleRef(param.$ref);
    var schema = param.schema;
    if (schema) {
        var ref = schema.$ref;
        if (ref) {
            ref = helpers.simpleRef(ref);
            if (isArray) return [
                ref
            ];
            else return ref;
        } else {
            // If inline schema, we add it our interal hash -> which gives us it's ID (int)
            if (schema.type === 'object') return this.addInlineModel(schema);
            return this.getType(schema);
        }
    }
    if (isArray) return [
        str
    ];
    else return str;
};
/**
 * adds an inline schema (model) to a hash, where we can ref it later
 * @param {object} schema a schema
 * @return {number} the ID of the schema being added, or null
 **/ Operation.prototype.addInlineModel = function(schema) {
    var len = this.inlineModels.length;
    var model = this.resolveModel(schema, {});
    if (model) {
        this.inlineModels.push(model);
        return 'Inline Model ' + len; // return string ref of the inline model (used with #getInlineModel)
    }
    return null; // report errors?
};
/**
 * gets the internal ref to an inline model
 * @param {string} inline_str a string reference to an inline model
 * @return {Model} the model being referenced. Or null
 **/ Operation.prototype.getInlineModel = function(inlineStr) {
    if (/^Inline Model \d+$/.test(inlineStr)) {
        var id = parseInt(inlineStr.substr(12).trim(), 10); //
        var model = this.inlineModels[id];
        return model;
    }
    // I'm returning null here, should I rather throw an error?
    return null;
};
Operation.prototype.resolveModel = function(schema, definitions) {
    if (typeof schema.$ref !== 'undefined') {
        var ref = schema.$ref;
        if (ref.indexOf('#/definitions/') === 0) ref = ref.substring(14);
        if (definitions[ref]) return new Model(ref, definitions[ref], this.models, this.parent.modelPropertyMacro);
    // schema must at least be an object to get resolved to an inline Model
    } else if (schema && typeof schema === 'object' && (schema.type === 'object' || _.isUndefined(schema.type))) return new Model(undefined, schema, this.models, this.parent.modelPropertyMacro);
    return null;
};
Operation.prototype.help = function(dontPrint) {
    var out = this.nickname + ': ' + this.summary + '\n';
    for(var i = 0; i < this.parameters.length; i++){
        var param = this.parameters[i];
        var typeInfo = param.signature;
        out += '\n  * ' + param.name + ' (' + typeInfo + '): ' + param.description;
    }
    if (typeof dontPrint === 'undefined') helpers.log(out);
    return out;
};
Operation.prototype.getModelSignature = function(type, definitions) {
    var isPrimitive, listType;
    if (type instanceof Array) {
        listType = true;
        type = type[0];
    }
    // Convert undefined to string of 'undefined'
    if (typeof type === 'undefined') {
        type = 'undefined';
        isPrimitive = true;
    } else if (definitions[type]) {
        // a model def exists?
        type = definitions[type]; /* Model */ 
        isPrimitive = false;
    } else if (this.getInlineModel(type)) {
        type = this.getInlineModel(type); /* Model */ 
        isPrimitive = false;
    } else // We default to primitive
    isPrimitive = true;
    if (isPrimitive) {
        if (listType) return 'Array[' + type + ']';
        else return type.toString();
    } else {
        if (listType) return 'Array[' + type.getMockSignature() + ']';
        else return type.getMockSignature();
    }
};
Operation.prototype.supportHeaderParams = function() {
    return true;
};
Operation.prototype.supportedSubmitMethods = function() {
    return this.parent.supportedSubmitMethods;
};
Operation.prototype.getHeaderParams = function(args) {
    var headers = this.setContentTypes(args, {});
    var headerParamsByLowerCase = {};
    for(var i = 0; i < this.parameters.length; i++){
        var param = this.parameters[i];
        if (param.in === 'header') headerParamsByLowerCase[param.name.toLowerCase()] = param;
    }
    for(var arg in args){
        var headerParam = headerParamsByLowerCase[arg.toLowerCase()];
        if (typeof headerParam !== 'undefined') {
            var value = args[arg];
            if (Array.isArray(value)) value = value.toString();
            headers[headerParam.name] = value;
        }
    }
    return headers;
};
Operation.prototype.urlify = function(args) {
    var formParams = {};
    var requestUrl = this.path.replace(/#.*/, ''); // remove URL fragment
    var querystring = ''; // grab params from the args, build the querystring along the way
    for(var i = 0; i < this.parameters.length; i++){
        var param = this.parameters[i];
        if (typeof args[param.name] !== 'undefined') {
            if (param.in === 'path') {
                var reg = new RegExp('\{' + param.name + '\}', 'gi');
                var value = args[param.name];
                if (Array.isArray(value)) value = this.encodePathCollection(param.collectionFormat, param.name, value);
                else value = this.encodePathParam(value);
                requestUrl = requestUrl.replace(reg, value);
            } else if (param.in === 'query' && typeof args[param.name] !== 'undefined') {
                if (querystring === '' && requestUrl.indexOf('?') < 0) querystring += '?';
                else querystring += '&';
                if (typeof param.collectionFormat !== 'undefined') {
                    var qp = args[param.name];
                    if (Array.isArray(qp)) querystring += this.encodeQueryCollection(param.collectionFormat, param.name, qp);
                    else querystring += this.encodeQueryKey(param.name) + '=' + this.encodeQueryParam(args[param.name]);
                } else querystring += this.encodeQueryKey(param.name) + '=' + this.encodeQueryParam(args[param.name]);
            } else if (param.in === 'formData') formParams[param.name] = args[param.name];
        }
    }
    var url = this.scheme + '://' + this.host;
    if (this.basePath !== '/') url += this.basePath;
    return url + requestUrl + querystring;
};
Operation.prototype.getMissingParams = function(args) {
    var missingParams = []; // check required params, track the ones that are missing
    var i;
    for(i = 0; i < this.parameters.length; i++){
        var param = this.parameters[i];
        if (param.required === true) {
            if (typeof args[param.name] === 'undefined') missingParams = param.name;
        }
    }
    return missingParams;
};
Operation.prototype.getBody = function(headers, args, opts) {
    var formParams = {}, hasFormParams, body, key, value, hasBody = false;
    // look at each param and put form params in an object
    for(var i = 0; i < this.parameters.length; i++){
        var param = this.parameters[i];
        if (typeof args[param.name] !== 'undefined') {
            if (param.in === 'body') body = args[param.name];
            else if (param.in === 'formData') {
                formParams[param.name] = {
                    param: param,
                    value: args[param.name]
                };
                hasFormParams = true;
            }
        } else if (param.in === 'body') hasBody = true;
    }
    // if body is null and hasBody is true, AND a JSON body is requested, send empty {}
    if (hasBody && typeof body === 'undefined') {
        var contentType = headers['Content-Type'];
        if (contentType && contentType.indexOf('application/json') === 0) body = '{}';
    }
    var isMultiPart = false;
    if (headers['Content-Type'] && headers['Content-Type'].indexOf('multipart/form-data') >= 0) isMultiPart = true;
    // handle form params
    if (hasFormParams && !isMultiPart) {
        var encoded = '';
        for(key in formParams){
            var param = formParams[key].param;
            value = formParams[key].value;
            if (typeof value !== 'undefined') {
                if (Array.isArray(value)) {
                    if (encoded !== '') encoded += '&';
                    encoded += this.encodeQueryCollection(param.collectionFormat, key, value);
                } else {
                    if (encoded !== '') encoded += '&';
                    encoded += encodeURIComponent(key) + '=' + encodeURIComponent(value);
                }
            }
        }
        body = encoded;
    } else if (isMultiPart) {
        var bodyParam;
        if (typeof FormData === 'function') {
            bodyParam = new FormData();
            bodyParam.type = 'formData';
            for(key in formParams){
                var param = formParams[key].param;
                value = args[key];
                if (typeof value !== 'undefined') {
                    if (({}).toString.apply(value) === '[object File]') bodyParam.append(key, value);
                    else if (value.type === 'file' && value.value) bodyParam.append(key, value.value);
                    else if (Array.isArray(value)) {
                        if (param.collectionFormat === 'multi') {
                            bodyParam.delete(key);
                            for(var v in value)bodyParam.append(key, value[v]);
                        } else bodyParam.append(key, this.encodeQueryCollection(param.collectionFormat, key, value).split('=').slice(1).join('='));
                    } else bodyParam.append(key, value);
                }
            }
            body = bodyParam;
        } else {
            bodyParam = {};
            for(key in formParams){
                value = args[key];
                if (Array.isArray(value)) {
                    var delimeter;
                    var format = param.collectionFormat || 'multi';
                    if (format === 'ssv') delimeter = ' ';
                    else if (format === 'pipes') delimeter = '|';
                    else if (format === 'tsv') delimeter = '\t';
                    else if (format === 'multi') {
                        bodyParam[key] = value;
                        break;
                    } else delimeter = ',';
                    var data;
                    value.forEach(function(v) {
                        if (data) data += delimeter;
                        else data = '';
                        data += v;
                    });
                    bodyParam[key] = data;
                } else bodyParam[key] = value;
            }
            body = bodyParam;
        }
        headers['Content-Type'] = 'multipart/form-data';
    }
    return body;
};
/**
 * gets sample response for a single operation
 **/ Operation.prototype.getModelSampleJSON = function(type, models) {
    var listType, sampleJson, innerType;
    models = models || {};
    listType = type instanceof Array;
    innerType = listType ? type[0] : type;
    if (models[innerType]) sampleJson = models[innerType].createJSONSample();
    else if (this.getInlineModel(innerType)) sampleJson = this.getInlineModel(innerType).createJSONSample(); // may return null, if type isn't correct
    if (sampleJson) {
        sampleJson = listType ? [
            sampleJson
        ] : sampleJson;
        if (typeof sampleJson === 'string') return sampleJson;
        else if (_.isObject(sampleJson)) {
            var t = sampleJson;
            if (sampleJson instanceof Array && sampleJson.length > 0) t = sampleJson[0];
            if (t.nodeName && typeof t === 'Node') {
                var xmlString = new XMLSerializer().serializeToString(t);
                return this.formatXml(xmlString);
            } else return JSON.stringify(sampleJson, null, 2);
        } else return sampleJson;
    }
};
/**
 * legacy binding
 **/ Operation.prototype.do = function(args, opts, callback, error, parent) {
    return this.execute(args, opts, callback, error, parent);
};
/**
 * executes an operation
 **/ Operation.prototype.execute = function(arg1, arg2, arg3, arg4, parent) {
    var args = arg1 || {};
    var opts = {}, success, error, deferred, timeout;
    if (_.isObject(arg2)) {
        opts = arg2;
        success = arg3;
        error = arg4;
    }
    timeout = typeof opts.timeout !== 'undefined' ? opts.timeout : this.timeout;
    if (this.client) opts.client = this.client;
    // add the request interceptor from parent, if none sent from client
    if (!opts.requestInterceptor && this.requestInterceptor) opts.requestInterceptor = this.requestInterceptor;
    if (!opts.responseInterceptor && this.responseInterceptor) opts.responseInterceptor = this.responseInterceptor;
    if (typeof arg2 === 'function') {
        success = arg2;
        error = arg3;
    }
    if (this.parent.usePromise) deferred = Q.defer();
    else {
        success = success || this.parent.defaultSuccessCallback || helpers.log;
        error = error || this.parent.defaultErrorCallback || helpers.log;
    }
    if (typeof opts.useJQuery === 'undefined') opts.useJQuery = this.useJQuery;
    if (typeof opts.jqueryAjaxCache === 'undefined') opts.jqueryAjaxCache = this.jqueryAjaxCache;
    if (typeof opts.enableCookies === 'undefined') opts.enableCookies = this.enableCookies;
    var missingParams = this.getMissingParams(args);
    if (missingParams.length > 0) {
        var message = 'missing required params: ' + missingParams;
        helpers.fail(message);
        if (this.parent.usePromise) {
            deferred.reject(message);
            return deferred.promise;
        } else {
            error(message, parent);
            return {};
        }
    }
    var allHeaders = this.getHeaderParams(args);
    var contentTypeHeaders = this.setContentTypes(args, opts);
    var headers = {}, attrname;
    for(attrname in allHeaders)headers[attrname] = allHeaders[attrname];
    for(attrname in contentTypeHeaders)headers[attrname] = contentTypeHeaders[attrname];
    var body = this.getBody(contentTypeHeaders, args, opts);
    var url = this.urlify(args);
    if (url.indexOf('.{format}') > 0) {
        if (headers) {
            var format = headers.Accept || headers.accept;
            if (format && format.indexOf('json') > 0) url = url.replace('.{format}', '.json');
            else if (format && format.indexOf('xml') > 0) url = url.replace('.{format}', '.xml');
        }
    }
    var obj = {
        url: url,
        method: this.method.toUpperCase(),
        body: body,
        enableCookies: opts.enableCookies,
        useJQuery: opts.useJQuery,
        jqueryAjaxCache: opts.jqueryAjaxCache,
        deferred: deferred,
        headers: headers,
        clientAuthorizations: opts.clientAuthorizations,
        on: {
            response: function(response) {
                if (deferred) {
                    deferred.resolve(response);
                    return deferred.promise;
                } else return success(response, parent);
            },
            error: function(response) {
                if (deferred) {
                    deferred.reject(response);
                    return deferred.promise;
                } else return error(response, parent);
            }
        }
    };
    if (timeout) obj.timeout = timeout;
    this.clientAuthorizations.apply(obj, this.operation.security);
    if (opts.mock === true) return obj;
    else return new SwaggerHttp().execute(obj, opts);
};
function itemByPriority(col, itemPriority) {
    // No priorities? return first...
    if (_.isEmpty(itemPriority)) return col[0];
    for(var i = 0, len = itemPriority.length; i < len; i++){
        if (col.indexOf(itemPriority[i]) > -1) return itemPriority[i];
    }
    // Otherwise return first
    return col[0];
}
Operation.prototype.setContentTypes = function(args, opts) {
    // default type
    var allDefinedParams = this.parameters;
    var body;
    var consumes = args.parameterContentType || itemByPriority(this.consumes, [
        'application/json',
        'application/yaml'
    ]);
    var accepts = opts.responseContentType || itemByPriority(this.produces, [
        'application/json',
        'application/yaml'
    ]);
    var definedFileParams = [];
    var definedFormParams = [];
    var headers = {};
    var i;
    // get params from the operation and set them in definedFileParams, definedFormParams, headers
    for(i = 0; i < allDefinedParams.length; i++){
        var param = allDefinedParams[i];
        if (param.in === 'formData') {
            if (param.type === 'file') definedFileParams.push(param);
            else definedFormParams.push(param);
        } else if (param.in === 'header' && opts) {
            var key = param.name;
            var headerValue = opts[param.name];
            if (typeof opts[param.name] !== 'undefined') headers[key] = headerValue;
        } else if (param.in === 'body' && typeof args[param.name] !== 'undefined') body = args[param.name];
    }
    // if there's a body, need to set the consumes header via requestContentType
    var hasBody = body || definedFileParams.length || definedFormParams.length;
    if (this.method === 'post' || this.method === 'put' || this.method === 'patch' || (this.method === 'delete' || this.method === 'get') && hasBody) {
        if (opts.requestContentType) consumes = opts.requestContentType;
        // if any form params, content type must be set
        if (definedFormParams.length > 0) {
            consumes = undefined;
            if (opts.requestContentType) consumes = opts.requestContentType;
            else if (definedFileParams.length > 0) consumes = 'multipart/form-data';
            else {
                if (this.consumes && this.consumes.length > 0) // use the consumes setting
                for(var c in this.consumes){
                    var chk = this.consumes[c];
                    if (chk.indexOf('application/x-www-form-urlencoded') === 0 || chk.indexOf('multipart/form-data') === 0) consumes = chk;
                }
            }
            if (typeof consumes === 'undefined') // default to x-www-from-urlencoded
            consumes = 'application/x-www-form-urlencoded';
        }
    } else consumes = null;
    if (consumes && this.consumes) {
        if (this.consumes.indexOf(consumes) === -1) helpers.log('server doesn\'t consume ' + consumes + ', try ' + JSON.stringify(this.consumes));
    }
    if (!this.matchesAccept(accepts)) helpers.log('server can\'t produce ' + accepts);
    if (consumes && body !== '' || consumes === 'application/x-www-form-urlencoded') headers['Content-Type'] = consumes;
    else if (this.consumes && this.consumes.length > 0 && this.consumes[0] === 'application/x-www-form-urlencoded') headers['Content-Type'] = this.consumes[0];
    if (accepts) headers.Accept = accepts;
    return headers;
};
/**
 * Returns true if the request accepts header matches anything in this.produces.
 *  If this.produces contains * / *, ignore the accept header.
 * @param {string=} accepts The client request accept header.
 * @return {boolean}
 */ Operation.prototype.matchesAccept = function(accepts) {
    // no accepts or produces, no problem!
    if (!accepts || !this.produces) return true;
    return this.produces.indexOf(accepts) !== -1 || this.produces.indexOf('*/*') !== -1;
};
Operation.prototype.asCurl = function(args1, args2) {
    var opts = {
        mock: true
    };
    if (typeof args2 === 'object') for(var argKey in args2)opts[argKey] = args2[argKey];
    var obj = this.execute(args1, opts);
    this.clientAuthorizations.apply(obj, this.operation.security);
    var results = [];
    results.push('-X ' + this.method.toUpperCase());
    if (typeof obj.headers !== 'undefined') {
        var key;
        for(key in obj.headers){
            var value = obj.headers[key];
            if (typeof value === 'string') value = value.replace(/\'/g, '\\u0027');
            results.push('--header \'' + key + ': ' + value + '\'');
        }
    }
    var isFormData = false;
    var isMultipart = false;
    var type = obj.headers['Content-Type'];
    if (type && type.indexOf('application/x-www-form-urlencoded') === 0) isFormData = true;
    else if (type && type.indexOf('multipart/form-data') === 0) {
        isFormData = true;
        isMultipart = true;
    }
    if (obj.body) {
        var body;
        if (_.isObject(obj.body)) {
            if (isMultipart) {
                isMultipart = true;
                // add the form data
                for(var i = 0; i < this.parameters.length; i++){
                    var parameter = this.parameters[i];
                    if (parameter.in === 'formData') {
                        if (!body) body = '';
                        var paramValue;
                        if (typeof FormData === 'function' && obj.body instanceof FormData) paramValue = obj.body.getAll(parameter.name);
                        else paramValue = obj.body[parameter.name];
                        if (paramValue) {
                            if (parameter.type === 'file') {
                                if (paramValue.name) body += '-F ' + parameter.name + '=@"' + paramValue.name + '" ';
                            } else if (Array.isArray(paramValue)) {
                                if (parameter.collectionFormat === 'multi') for(var v in paramValue)body += '-F ' + this.encodeQueryKey(parameter.name) + '=' + paramValue[v] + ' ';
                                else body += '-F ' + this.encodeQueryCollection(parameter.collectionFormat, parameter.name, paramValue) + ' ';
                            } else body += '-F ' + this.encodeQueryKey(parameter.name) + '=' + paramValue + ' ';
                        }
                    }
                }
            }
            if (!body) body = JSON.stringify(obj.body);
        } else body = obj.body;
        // escape @ => %40, ' => %27
        body = body.replace(/\'/g, '%27').replace(/\n/g, ' \\ \n ');
        if (!isFormData) // escape & => %26
        body = body.replace(/&/g, '%26');
        if (isMultipart) results.push(body);
        else results.push('-d \'' + body.replace(/@/g, '%40') + '\'');
    }
    return 'curl ' + results.join(' ') + ' \'' + obj.url + '\'';
};
Operation.prototype.encodePathCollection = function(type, name, value) {
    var encoded = '';
    var i;
    var separator = '';
    if (type === 'ssv') separator = '%20';
    else if (type === 'tsv') separator = '%09';
    else if (type === 'pipes') separator = '|';
    else separator = ',';
    for(i = 0; i < value.length; i++)if (i === 0) encoded = this.encodeQueryParam(value[i]);
    else encoded += separator + this.encodeQueryParam(value[i]);
    return encoded;
};
Operation.prototype.encodeQueryCollection = function(type, name, value) {
    var encoded = '';
    var i;
    type = type || 'default';
    if (type === 'default' || type === 'multi') for(i = 0; i < value.length; i++){
        if (i > 0) encoded += '&';
        encoded += this.encodeQueryKey(name) + '=' + this.encodeQueryParam(value[i]);
    }
    else {
        var separator = '';
        if (type === 'csv') separator = ',';
        else if (type === 'ssv') separator = '%20';
        else if (type === 'tsv') separator = '%09';
        else if (type === 'pipes') separator = '|';
        else if (type === 'brackets') for(i = 0; i < value.length; i++){
            if (i !== 0) encoded += '&';
            encoded += this.encodeQueryKey(name) + '[]=' + this.encodeQueryParam(value[i]);
        }
        if (separator !== '') {
            for(i = 0; i < value.length; i++)if (i === 0) encoded = this.encodeQueryKey(name) + '=' + this.encodeQueryParam(value[i]);
            else encoded += separator + this.encodeQueryParam(value[i]);
        }
    }
    return encoded;
};
Operation.prototype.encodeQueryKey = function(arg) {
    return encodeURIComponent(arg).replace('%5B', '[').replace('%5D', ']').replace('%24', '$');
};
Operation.prototype.encodeQueryParam = function(arg) {
    return encodeURIComponent(arg);
};
/**
 * TODO revisit, might not want to leave '/'
 **/ Operation.prototype.encodePathParam = function(pathParam) {
    return encodeURIComponent(pathParam);
};

},{"40546b9cf3e7b33a":"7UzDg","b013028ac87a8872":"kKkpQ","587336246679526":"7DG4c","6077b038d663d2ff":"2h87f","41fd6979be14d422":"7AAzh","ccb4c7bdde266871":"aepyO","c95b745576b99dfb":"bUg9C","f3a0c14d9d625480":"iWYSC"}],"bUg9C":[function(require,module,exports,__globalThis) {
var Buffer = require("8b7d8ecb4fbaba9b").Buffer;
'use strict';
var helpers = require("8a5cebbade2f2b9e");
var request = require("917c14056fca9b19");
var jsyaml = require("43db5514035a7047");
var _ = {
    isObject: require("3a285970d73dc2e2"),
    keys: require("5937362ff6c158e5")
};
/*
 * JQueryHttpClient is a light-weight, node or browser HTTP client
 */ var JQueryHttpClient = function() {
    this.type = 'JQueryHttpClient';
};
/*
 * SuperagentHttpClient is a light-weight, node or browser HTTP client
 */ var SuperagentHttpClient = function() {
    this.type = 'SuperagentHttpClient';
};
/**
 * SwaggerHttp is a wrapper for executing requests
 */ var SwaggerHttp = module.exports = function() {};
SwaggerHttp.prototype.execute = function(obj, opts) {
    var client;
    if (opts && opts.client) client = opts.client;
    else client = new SuperagentHttpClient(opts);
    client.opts = opts || {};
    // legacy support
    var hasJQuery = false;
    if (typeof window !== 'undefined') {
        if (typeof window.jQuery !== 'undefined') hasJQuery = true;
    }
    // OPTIONS support
    if (obj.method.toLowerCase() === 'options' && client.type === 'SuperagentHttpClient') {
        log('forcing jQuery as OPTIONS are not supported by SuperAgent');
        obj.useJQuery = true;
    }
    if (this.isInternetExplorer() && (obj.useJQuery === false || !hasJQuery)) throw new Error('Unsupported configuration! JQuery is required but not available');
    if (obj && obj.useJQuery === true || this.isInternetExplorer() && hasJQuery) client = new JQueryHttpClient(opts);
    var success = obj.on.response;
    var error = obj.on.error;
    var requestInterceptor = function(data) {
        if (opts && opts.requestInterceptor) data = opts.requestInterceptor.apply(data);
        return data;
    };
    var responseInterceptor = function(data) {
        if (opts && opts.responseInterceptor) data = opts.responseInterceptor.apply(data);
        return success(data);
    };
    var errorInterceptor = function(data) {
        if (opts && opts.responseInterceptor) data = opts.responseInterceptor.apply(data);
        error(data);
    };
    obj.on.error = function(data) {
        errorInterceptor(data);
    };
    obj.on.response = function(data) {
        responseInterceptor(data);
    };
    if (_.isObject(obj) && _.isObject(obj.body)) {
        // special processing for file uploads via jquery
        if (obj.body.type && obj.body.type === 'formData') {
            if (opts.useJQuery) {
                obj.contentType = false;
                obj.processData = false;
                delete obj.headers['Content-Type'];
            }
        }
    }
    obj = requestInterceptor(obj) || obj;
    if (obj.beforeSend) obj.beforeSend(function(_obj) {
        client.execute(_obj || obj);
    });
    else client.execute(obj);
    return obj.deferred ? obj.deferred.promise : obj;
};
SwaggerHttp.prototype.isInternetExplorer = function() {
    var detectedIE = false;
    if (typeof navigator !== 'undefined' && navigator.userAgent) {
        var nav = navigator.userAgent.toLowerCase();
        if (nav.indexOf('msie') !== -1) {
            var version = parseInt(nav.split('msie')[1]);
            if (version <= 8) detectedIE = true;
        }
    }
    return detectedIE;
};
JQueryHttpClient.prototype.execute = function(obj) {
    var jq = this.jQuery || typeof window !== 'undefined' && window.jQuery;
    var cb = obj.on;
    var request = obj;
    if (typeof jq === 'undefined' || jq === false) throw new Error('Unsupported configuration! JQuery is required but not available');
    obj.type = obj.method;
    obj.cache = obj.jqueryAjaxCache;
    obj.data = obj.body;
    delete obj.jqueryAjaxCache;
    delete obj.useJQuery;
    delete obj.body;
    obj.complete = function(response) {
        var headers = {};
        var headerArray = response.getAllResponseHeaders().split('\n');
        for(var i = 0; i < headerArray.length; i++){
            var toSplit = headerArray[i].trim();
            if (toSplit.length === 0) continue;
            var separator = toSplit.indexOf(':');
            if (separator === -1) {
                // Name but no value in the header
                headers[toSplit] = null;
                continue;
            }
            var name = toSplit.substring(0, separator).trim();
            var value = toSplit.substring(separator + 1).trim();
            headers[name] = value;
        }
        var out = {
            url: request.url,
            method: request.method,
            status: response.status,
            statusText: response.statusText,
            data: response.responseText,
            headers: headers
        };
        try {
            var possibleObj = response.responseJSON || jsyaml.safeLoad(response.responseText);
            out.obj = typeof possibleObj === 'string' ? {} : possibleObj;
        } catch (ex) {
            // do not set out.obj
            helpers.log('unable to parse JSON/YAML content');
        }
        // I can throw, or parse null?
        out.obj = out.obj || null;
        if (response.status >= 200 && response.status < 300) cb.response(out);
        else if (response.status === 0 || response.status >= 400 && response.status < 599) cb.error(out);
        else return cb.response(out);
    };
    jq.support.cors = true;
    return jq.ajax(obj);
};
SuperagentHttpClient.prototype.execute = function(obj) {
    var method = obj.method.toLowerCase();
    var timeout = obj.timeout;
    if (method === 'delete') method = 'del';
    var headers = obj.headers || {};
    var r = request[method](obj.url);
    if (timeout) r.timeout(timeout);
    if (obj.enableCookies) r.withCredentials();
    var accept = obj.headers.Accept;
    if (this.binaryRequest(accept)) r.on('request', function() {
        if (this.xhr) this.xhr.responseType = 'blob';
    });
    if (obj.body) {
        if (_.isObject(obj.body)) {
            var contentType = obj.headers['Content-Type'] || '';
            if (contentType.indexOf('multipart/form-data') === 0) {
                delete headers['Content-Type'];
                if (({}).toString.apply(obj.body) === '[object FormData]') {
                    var itr = obj.body.keys();
                    var p = [];
                    while(true){
                        var v = itr.next();
                        if (v.done) break;
                        var key = v.value;
                        // only once
                        if (p.indexOf(key) === -1) {
                            p.push(key);
                            var value = obj.body.getAll(key);
                            if (({}).toString.apply(value) === '[object File]') r.attach(key, value);
                            else {
                                if (Array.isArray(value)) for(var t in value)r.field(key, value[t]);
                                else r.field(key, value);
                            }
                        }
                    }
                } else {
                    var keyname, value, v;
                    for(keyname in obj.body){
                        value = obj.body[keyname];
                        if (Array.isArray(value)) for(v in value)r.field(keyname, v);
                        else r.field(keyname, value);
                    }
                }
            } else if (_.isObject(obj.body)) {
                obj.body = JSON.stringify(obj.body);
                r.send(obj.body);
            }
        } else r.send(obj.body);
    }
    var name;
    for(name in headers)r.set(name, headers[name]);
    if (typeof r.buffer === 'function') r.buffer(); // force superagent to populate res.text with the raw response data
    r.end(function(err, res) {
        res = res || {
            status: 0,
            headers: {
                error: 'no response from server'
            }
        };
        var response = {
            url: obj.url,
            method: obj.method,
            headers: res.headers
        };
        var cb;
        if (!err && res.error) err = res.error;
        if (err && obj.on && obj.on.error) {
            response.errObj = err;
            response.status = res ? res.status : 500;
            response.statusText = res ? res.text : err.message;
            if (res.headers && res.headers['content-type']) {
                if (res.headers['content-type'].indexOf('application/json') >= 0) try {
                    response.obj = JSON.parse(response.statusText);
                } catch (e) {
                    response.obj = null;
                }
            }
            cb = obj.on.error;
        } else if (res && obj.on && obj.on.response) {
            var possibleObj;
            // Already parsed by by superagent?
            if (res.body && _.keys(res.body).length > 0) possibleObj = res.body;
            else try {
                possibleObj = jsyaml.safeLoad(res.text);
                // can parse into a string... which we don't need running around in the system
                possibleObj = typeof possibleObj === 'string' ? null : possibleObj;
            } catch (e) {
                helpers.log('cannot parse JSON/YAML content');
            }
            // null means we can't parse into object
            if (typeof Buffer === 'function' && Buffer.isBuffer(possibleObj)) response.data = possibleObj;
            else response.obj = typeof possibleObj === 'object' ? possibleObj : null;
            response.status = res.status;
            response.statusText = res.text;
            cb = obj.on.response;
        }
        if (res.xhr && res.xhr.response) response.data = res.xhr.response;
        else if (!response.data) response.data = response.statusText;
        if (cb) cb(response);
    });
};
SuperagentHttpClient.prototype.binaryRequest = function(accept) {
    if (!accept) return false;
    return /^image/i.test(accept) || /^application\/pdf/.test(accept);
};

},{"8b7d8ecb4fbaba9b":"cjdyz","8a5cebbade2f2b9e":"7AAzh","917c14056fca9b19":"9eKR9","43db5514035a7047":"3sPhj","3a285970d73dc2e2":"2h87f","5937362ff6c158e5":"dWOkG"}],"9eKR9":[function(require,module,exports,__globalThis) {
/**
 * Root reference for iframes.
 */ var root;
if (typeof window !== 'undefined') root = window;
else if (typeof self !== 'undefined') root = self;
else {
    console.warn("Using browser-only version of superagent in non-browser environment");
    root = this;
}
var Emitter = require("456f6bd33e02ee6f");
var requestBase = require("899932225afc353e");
var isObject = require("c33c93361422e6ab");
/**
 * Noop.
 */ function noop() {}
/**
 * Expose `request`.
 */ var request = module.exports = require("3689ed0ff7fecdd").bind(null, Request);
/**
 * Determine XHR.
 */ request.getXHR = function() {
    if (root.XMLHttpRequest && (!root.location || 'file:' != root.location.protocol || !root.ActiveXObject)) return new XMLHttpRequest;
    else {
        try {
            return new ActiveXObject('Microsoft.XMLHTTP');
        } catch (e) {}
        try {
            return new ActiveXObject('Msxml2.XMLHTTP.6.0');
        } catch (e) {}
        try {
            return new ActiveXObject('Msxml2.XMLHTTP.3.0');
        } catch (e) {}
        try {
            return new ActiveXObject('Msxml2.XMLHTTP');
        } catch (e) {}
    }
    throw Error("Browser-only verison of superagent could not find XHR");
};
/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */ var trim = ''.trim ? function(s) {
    return s.trim();
} : function(s) {
    return s.replace(/(^\s*|\s*$)/g, '');
};
/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */ function serialize(obj) {
    if (!isObject(obj)) return obj;
    var pairs = [];
    for(var key in obj)pushEncodedKeyValuePair(pairs, key, obj[key]);
    return pairs.join('&');
}
/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */ function pushEncodedKeyValuePair(pairs, key, val) {
    if (val != null) {
        if (Array.isArray(val)) val.forEach(function(v) {
            pushEncodedKeyValuePair(pairs, key, v);
        });
        else if (isObject(val)) for(var subkey in val)pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
        else pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(val));
    } else if (val === null) pairs.push(encodeURIComponent(key));
}
/**
 * Expose serialization method.
 */ request.serializeObject = serialize;
/**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */ function parseString(str) {
    var obj = {};
    var pairs = str.split('&');
    var pair;
    var pos;
    for(var i = 0, len = pairs.length; i < len; ++i){
        pair = pairs[i];
        pos = pair.indexOf('=');
        if (pos == -1) obj[decodeURIComponent(pair)] = '';
        else obj[decodeURIComponent(pair.slice(0, pos))] = decodeURIComponent(pair.slice(pos + 1));
    }
    return obj;
}
/**
 * Expose parser.
 */ request.parseString = parseString;
/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */ request.types = {
    html: 'text/html',
    json: 'application/json',
    xml: 'application/xml',
    urlencoded: 'application/x-www-form-urlencoded',
    'form': 'application/x-www-form-urlencoded',
    'form-data': 'application/x-www-form-urlencoded'
};
/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */ request.serialize = {
    'application/x-www-form-urlencoded': serialize,
    'application/json': JSON.stringify
};
/**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */ request.parse = {
    'application/x-www-form-urlencoded': parseString,
    'application/json': JSON.parse
};
/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */ function parseHeader(str) {
    var lines = str.split(/\r?\n/);
    var fields = {};
    var index;
    var line;
    var field;
    var val;
    lines.pop(); // trailing CRLF
    for(var i = 0, len = lines.length; i < len; ++i){
        line = lines[i];
        index = line.indexOf(':');
        field = line.slice(0, index).toLowerCase();
        val = trim(line.slice(index + 1));
        fields[field] = val;
    }
    return fields;
}
/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */ function isJSON(mime) {
    return /[\/+]json\b/.test(mime);
}
/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function type(str) {
    return str.split(/ *; */).shift();
}
/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */ function params(str) {
    return str.split(/ *; */).reduce(function(obj, str) {
        var parts = str.split(/ *= */), key = parts.shift(), val = parts.shift();
        if (key && val) obj[key] = val;
        return obj;
    }, {});
}
/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */ function Response(req, options) {
    options = options || {};
    this.req = req;
    this.xhr = this.req.xhr;
    // responseText is accessible only if responseType is '' or 'text' and on older browsers
    this.text = this.req.method != 'HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text') || typeof this.xhr.responseType === 'undefined' ? this.xhr.responseText : null;
    this.statusText = this.req.xhr.statusText;
    this._setStatusProperties(this.xhr.status);
    this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
    // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
    // getResponseHeader still works. so we get content-type even if getting
    // other headers fails.
    this.header['content-type'] = this.xhr.getResponseHeader('content-type');
    this._setHeaderProperties(this.header);
    this.body = this.req.method != 'HEAD' ? this._parseBody(this.text ? this.text : this.xhr.response) : null;
}
/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */ Response.prototype.get = function(field) {
    return this.header[field.toLowerCase()];
};
/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */ Response.prototype._setHeaderProperties = function(header) {
    // content-type
    var ct = this.header['content-type'] || '';
    this.type = type(ct);
    // params
    var obj = params(ct);
    for(var key in obj)this[key] = obj[key];
};
/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */ Response.prototype._parseBody = function(str) {
    var parse = request.parse[this.type];
    if (!parse && isJSON(this.type)) parse = request.parse['application/json'];
    return parse && str && (str.length || str instanceof Object) ? parse(str) : null;
};
/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */ Response.prototype._setStatusProperties = function(status) {
    // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
    if (status === 1223) status = 204;
    var type = status / 100 | 0;
    // status / class
    this.status = this.statusCode = status;
    this.statusType = type;
    // basics
    this.info = 1 == type;
    this.ok = 2 == type;
    this.clientError = 4 == type;
    this.serverError = 5 == type;
    this.error = 4 == type || 5 == type ? this.toError() : false;
    // sugar
    this.accepted = 202 == status;
    this.noContent = 204 == status;
    this.badRequest = 400 == status;
    this.unauthorized = 401 == status;
    this.notAcceptable = 406 == status;
    this.notFound = 404 == status;
    this.forbidden = 403 == status;
};
/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */ Response.prototype.toError = function() {
    var req = this.req;
    var method = req.method;
    var url = req.url;
    var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
    var err = new Error(msg);
    err.status = this.status;
    err.method = method;
    err.url = url;
    return err;
};
/**
 * Expose `Response`.
 */ request.Response = Response;
/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */ function Request(method, url) {
    var self1 = this;
    this._query = this._query || [];
    this.method = method;
    this.url = url;
    this.header = {}; // preserves header name case
    this._header = {}; // coerces header names to lowercase
    this.on('end', function() {
        var err = null;
        var res = null;
        try {
            res = new Response(self1);
        } catch (e) {
            err = new Error('Parser is unable to parse the response');
            err.parse = true;
            err.original = e;
            // issue #675: return the raw response if the response parsing fails
            err.rawResponse = self1.xhr && self1.xhr.responseText ? self1.xhr.responseText : null;
            // issue #876: return the http status code if the response parsing fails
            err.statusCode = self1.xhr && self1.xhr.status ? self1.xhr.status : null;
            return self1.callback(err);
        }
        self1.emit('response', res);
        var new_err;
        try {
            if (res.status < 200 || res.status >= 300) {
                new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
                new_err.original = err;
                new_err.response = res;
                new_err.status = res.status;
            }
        } catch (e) {
            new_err = e; // #985 touching res may cause INVALID_STATE_ERR on old Android
        }
        // #1000 don't catch errors from the callback to avoid double calling it
        if (new_err) self1.callback(new_err, res);
        else self1.callback(null, res);
    });
}
/**
 * Mixin `Emitter` and `requestBase`.
 */ Emitter(Request.prototype);
for(var key in requestBase)Request.prototype[key] = requestBase[key];
/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.type = function(type) {
    this.set('Content-Type', request.types[type] || type);
    return this;
};
/**
 * Set responseType to `val`. Presently valid responseTypes are 'blob' and
 * 'arraybuffer'.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.responseType = function(val) {
    this._responseType = val;
    return this;
};
/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.accept = function(type) {
    this.set('Accept', request.types[type] || type);
    return this;
};
/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} pass
 * @param {Object} options with 'type' property 'auto' or 'basic' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.auth = function(user, pass, options) {
    if (!options) options = {
        type: 'basic'
    };
    switch(options.type){
        case 'basic':
            var str = btoa(user + ':' + pass);
            this.set('Authorization', 'Basic ' + str);
            break;
        case 'auto':
            this.username = user;
            this.password = pass;
            break;
    }
    return this;
};
/**
* Add query-string `val`.
*
* Examples:
*
*   request.get('/shoes')
*     .query('size=10')
*     .query({ color: 'blue' })
*
* @param {Object|String} val
* @return {Request} for chaining
* @api public
*/ Request.prototype.query = function(val) {
    if ('string' != typeof val) val = serialize(val);
    if (val) this._query.push(val);
    return this;
};
/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `filename`.
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String} filename
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.attach = function(field, file, filename) {
    this._getFormData().append(field, file, filename || file.name);
    return this;
};
Request.prototype._getFormData = function() {
    if (!this._formData) this._formData = new root.FormData();
    return this._formData;
};
/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */ Request.prototype.callback = function(err, res) {
    var fn = this._callback;
    this.clearTimeout();
    fn(err, res);
};
/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */ Request.prototype.crossDomainError = function() {
    var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
    err.crossDomain = true;
    err.status = this.status;
    err.method = this.method;
    err.url = this.url;
    this.callback(err);
};
/**
 * Invoke callback with timeout error.
 *
 * @api private
 */ Request.prototype._timeoutError = function() {
    var timeout = this._timeout;
    var err = new Error('timeout of ' + timeout + 'ms exceeded');
    err.timeout = timeout;
    this.callback(err);
};
/**
 * Compose querystring to append to req.url
 *
 * @api private
 */ Request.prototype._appendQueryString = function() {
    var query = this._query.join('&');
    if (query) this.url += ~this.url.indexOf('?') ? '&' + query : '?' + query;
};
/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.end = function(fn) {
    var self1 = this;
    var xhr = this.xhr = request.getXHR();
    var timeout = this._timeout;
    var data = this._formData || this._data;
    // store callback
    this._callback = fn || noop;
    // state change
    xhr.onreadystatechange = function() {
        if (4 != xhr.readyState) return;
        // In IE9, reads to any property (e.g. status) off of an aborted XHR will
        // result in the error "Could not complete the operation due to error c00c023f"
        var status;
        try {
            status = xhr.status;
        } catch (e) {
            status = 0;
        }
        if (0 == status) {
            if (self1.timedout) return self1._timeoutError();
            if (self1._aborted) return;
            return self1.crossDomainError();
        }
        self1.emit('end');
    };
    // progress
    var handleProgress = function(direction, e) {
        if (e.total > 0) e.percent = e.loaded / e.total * 100;
        e.direction = direction;
        self1.emit('progress', e);
    };
    if (this.hasListeners('progress')) try {
        xhr.onprogress = handleProgress.bind(null, 'download');
        if (xhr.upload) xhr.upload.onprogress = handleProgress.bind(null, 'upload');
    } catch (e) {
    // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
    // Reported here:
    // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
    // timeout
    if (timeout && !this._timer) this._timer = setTimeout(function() {
        self1.timedout = true;
        self1.abort();
    }, timeout);
    // querystring
    this._appendQueryString();
    // initiate request
    if (this.username && this.password) xhr.open(this.method, this.url, true, this.username, this.password);
    else xhr.open(this.method, this.url, true);
    // CORS
    if (this._withCredentials) xhr.withCredentials = true;
    // body
    if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
        // serialize stuff
        var contentType = this._header['content-type'];
        var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
        if (!serialize && isJSON(contentType)) serialize = request.serialize['application/json'];
        if (serialize) data = serialize(data);
    }
    // set header fields
    for(var field in this.header){
        if (null == this.header[field]) continue;
        xhr.setRequestHeader(field, this.header[field]);
    }
    if (this._responseType) xhr.responseType = this._responseType;
    // send stuff
    this.emit('request', this);
    // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
    // We need null here if data is undefined
    xhr.send(typeof data !== 'undefined' ? data : null);
    return this;
};
/**
 * Expose `Request`.
 */ request.Request = Request;
/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.get = function(url, data, fn) {
    var req = request('GET', url);
    if ('function' == typeof data) fn = data, data = null;
    if (data) req.query(data);
    if (fn) req.end(fn);
    return req;
};
/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.head = function(url, data, fn) {
    var req = request('HEAD', url);
    if ('function' == typeof data) fn = data, data = null;
    if (data) req.send(data);
    if (fn) req.end(fn);
    return req;
};
/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.options = function(url, data, fn) {
    var req = request('OPTIONS', url);
    if ('function' == typeof data) fn = data, data = null;
    if (data) req.send(data);
    if (fn) req.end(fn);
    return req;
};
/**
 * DELETE `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ function del(url, fn) {
    var req = request('DELETE', url);
    if (fn) req.end(fn);
    return req;
}
request['del'] = del;
request['delete'] = del;
/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.patch = function(url, data, fn) {
    var req = request('PATCH', url);
    if ('function' == typeof data) fn = data, data = null;
    if (data) req.send(data);
    if (fn) req.end(fn);
    return req;
};
/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.post = function(url, data, fn) {
    var req = request('POST', url);
    if ('function' == typeof data) fn = data, data = null;
    if (data) req.send(data);
    if (fn) req.end(fn);
    return req;
};
/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.put = function(url, data, fn) {
    var req = request('PUT', url);
    if ('function' == typeof data) fn = data, data = null;
    if (data) req.send(data);
    if (fn) req.end(fn);
    return req;
};

},{"456f6bd33e02ee6f":"1DKfP","899932225afc353e":"bKDwE","c33c93361422e6ab":"14AqW","3689ed0ff7fecdd":"hIp14"}],"1DKfP":[function(require,module,exports,__globalThis) {
/**
 * Expose `Emitter`.
 */ module.exports = Emitter;
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function Emitter(obj) {
    if (obj) return mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function mixin(obj) {
    for(var key in Emitter.prototype)obj[key] = Emitter.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ Emitter.prototype.on = Emitter.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ Emitter.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ Emitter.prototype.off = Emitter.prototype.removeListener = Emitter.prototype.removeAllListeners = Emitter.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks['$' + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks['$' + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ Emitter.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks['$' + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ Emitter.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ Emitter.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};

},{}],"bKDwE":[function(require,module,exports,__globalThis) {
/**
 * Module of mixed-in functions shared between node and client code
 */ var isObject = require("4e71bcb01a1f4287");
/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */ exports.clearTimeout = function _clearTimeout() {
    this._timeout = 0;
    clearTimeout(this._timer);
    return this;
};
/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */ exports.parse = function parse(fn) {
    this._parser = fn;
    return this;
};
/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */ exports.serialize = function serialize(fn) {
    this._serializer = fn;
    return this;
};
/**
 * Set timeout to `ms`.
 *
 * @param {Number} ms
 * @return {Request} for chaining
 * @api public
 */ exports.timeout = function timeout(ms) {
    this._timeout = ms;
    return this;
};
/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} reject
 * @return {Request}
 */ exports.then = function then(resolve, reject) {
    if (!this._fullfilledPromise) {
        var self = this;
        this._fullfilledPromise = new Promise(function(innerResolve, innerReject) {
            self.end(function(err, res) {
                if (err) innerReject(err);
                else innerResolve(res);
            });
        });
    }
    return this._fullfilledPromise.then(resolve, reject);
};
exports.catch = function(cb) {
    return this.then(undefined, cb);
};
/**
 * Allow for extension
 */ exports.use = function use(fn) {
    fn(this);
    return this;
};
/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */ exports.get = function(field) {
    return this._header[field.toLowerCase()];
};
/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */ exports.getHeader = exports.get;
/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */ exports.set = function(field, val) {
    if (isObject(field)) {
        for(var key in field)this.set(key, field[key]);
        return this;
    }
    this._header[field.toLowerCase()] = val;
    this.header[field] = val;
    return this;
};
/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 */ exports.unset = function(field) {
    delete this._header[field.toLowerCase()];
    delete this.header[field];
    return this;
};
/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name
 * @param {String|Blob|File|Buffer|fs.ReadStream} val
 * @return {Request} for chaining
 * @api public
 */ exports.field = function(name, val) {
    // name should be either a string or an object.
    if (null === name || undefined === name) throw new Error('.field(name, val) name can not be empty');
    if (isObject(name)) {
        for(var key in name)this.field(key, name[key]);
        return this;
    }
    // val should be defined now
    if (null === val || undefined === val) throw new Error('.field(name, val) val can not be empty');
    this._getFormData().append(name, val);
    return this;
};
/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */ exports.abort = function() {
    if (this._aborted) return this;
    this._aborted = true;
    this.xhr && this.xhr.abort(); // browser
    this.req && this.req.abort(); // node
    this.clearTimeout();
    this.emit('abort');
    return this;
};
/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */ exports.withCredentials = function() {
    // This is browser-only functionality. Node side is no-op.
    this._withCredentials = true;
    return this;
};
/**
 * Set the max redirects to `n`. Does noting in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */ exports.redirects = function(n) {
    this._maxRedirects = n;
    return this;
};
/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */ exports.toJSON = function() {
    return {
        method: this.method,
        url: this.url,
        data: this._data,
        headers: this._header
    };
};
/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * TODO: future proof, move to compoent land
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */ exports._isHost = function _isHost(obj) {
    var str = ({}).toString.call(obj);
    switch(str){
        case '[object File]':
        case '[object Blob]':
        case '[object FormData]':
            return true;
        default:
            return false;
    }
};
/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */ exports.send = function(data) {
    var obj = isObject(data);
    var type = this._header['content-type'];
    // merge
    if (obj && isObject(this._data)) for(var key in data)this._data[key] = data[key];
    else if ('string' == typeof data) {
        // default to x-www-form-urlencoded
        if (!type) this.type('form');
        type = this._header['content-type'];
        if ('application/x-www-form-urlencoded' == type) this._data = this._data ? this._data + '&' + data : data;
        else this._data = (this._data || '') + data;
    } else this._data = data;
    if (!obj || this._isHost(data)) return this;
    // default to json
    if (!type) this.type('json');
    return this;
};

},{"4e71bcb01a1f4287":"14AqW"}],"14AqW":[function(require,module,exports,__globalThis) {
/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */ function isObject(obj) {
    return null !== obj && 'object' === typeof obj;
}
module.exports = isObject;

},{}],"hIp14":[function(require,module,exports,__globalThis) {
// The node and browser modules expose versions of this with the
// appropriate constructor function bound as first argument
/**
 * Issue a request:
 *
 * Examples:
 *
 *    request('GET', '/users').end(callback)
 *    request('/users').end(callback)
 *    request('/users', callback)
 *
 * @param {String} method
 * @param {String|Function} url or callback
 * @return {Request}
 * @api public
 */ function request(RequestConstructor, method, url) {
    // callback
    if ('function' == typeof url) return new RequestConstructor('GET', method).end(url);
    // url first
    if (2 == arguments.length) return new RequestConstructor('GET', method);
    return new RequestConstructor(method, url);
}
module.exports = request;

},{}],"8pY2G":[function(require,module,exports,__globalThis) {
'use strict';
var OperationGroup = module.exports = function(tag, description, externalDocs, operation) {
    this.description = description;
    this.externalDocs = externalDocs;
    this.name = tag;
    this.operation = operation;
    this.operationsArray = [];
    this.path = tag;
    this.tag = tag;
};
OperationGroup.prototype.sort = function() {};

},{}],"h2F7k":[function(require,module,exports,__globalThis) {
'use strict';
var SwaggerHttp = require("88bbe8ab2558ae8a");
var _ = {
    isObject: require("e226c2be006fa75d"),
    cloneDeep: require("cecb3425bee8a1c5"),
    isArray: require("235f82d379ea8d34"),
    isString: require("c1224cae5b846001")
};
/**
 * Resolves a spec's remote references
 */ var Resolver = module.exports = function() {
    this.failedUrls = [];
    this.resolverCache = {};
    this.pendingUrls = {};
};
Resolver.prototype.processAllOf = function(root, name, definition, resolutionTable, unresolvedRefs, spec) {
    var i, location, property;
    definition['x-resolved-from'] = [
        '#/definitions/' + name
    ];
    var allOf = definition.allOf;
    // the refs go first
    allOf.sort(function(a, b) {
        if (a.$ref && b.$ref) return 0;
        else if (a.$ref) return -1;
        else return 1;
    });
    for(i = 0; i < allOf.length; i++){
        property = allOf[i];
        location = '/definitions/' + name + '/allOf';
        this.resolveInline(root, spec, property, resolutionTable, unresolvedRefs, location);
    }
};
Resolver.prototype.resolve = function(spec, arg1, arg2, arg3) {
    this.spec = spec;
    var root = arg1, callback = arg2, scope = arg3, opts = {}, location, i;
    if (typeof arg1 === 'function') {
        root = null;
        callback = arg1;
        scope = arg2;
    }
    var _root = root;
    this.scope = scope || this;
    this.iteration = this.iteration || 0;
    if (this.scope.options && this.scope.options.requestInterceptor) opts.requestInterceptor = this.scope.options.requestInterceptor;
    if (this.scope.options && this.scope.options.responseInterceptor) opts.responseInterceptor = this.scope.options.responseInterceptor;
    var name, path, property, propertyName;
    var processedCalls = 0, resolvedRefs = {}, unresolvedRefs = {};
    var resolutionTable = []; // store objects for dereferencing
    spec.definitions = spec.definitions || {};
    // definitions
    for(name in spec.definitions){
        var definition = spec.definitions[name];
        if (definition['$ref']) this.resolveInline(root, spec, definition, resolutionTable, unresolvedRefs, definition);
        else {
            for(propertyName in definition.properties){
                property = definition.properties[propertyName];
                if (_.isArray(property.allOf)) this.processAllOf(root, name, property, resolutionTable, unresolvedRefs, spec);
                else this.resolveTo(root, property, resolutionTable, '/definitions');
            }
            if (definition.allOf) this.processAllOf(root, name, definition, resolutionTable, unresolvedRefs, spec);
        }
    }
    // shared parameters
    spec.parameters = spec.parameters || {};
    for(name in spec.parameters){
        var parameter = spec.parameters[name];
        if (parameter.in === 'body' && parameter.schema) {
            if (_.isArray(parameter.schema.allOf)) {
                // move to a definition
                var modelName = 'inline_model';
                var name = modelName;
                var done = false;
                var counter = 0;
                while(!done){
                    if (typeof spec.definitions[name] === 'undefined') {
                        done = true;
                        break;
                    }
                    name = modelName + '_' + counter;
                    counter++;
                }
                spec.definitions[name] = {
                    allOf: parameter.schema.allOf
                };
                delete parameter.schema.allOf;
                parameter.schema.$ref = '#/definitions/' + name;
                this.processAllOf(root, name, spec.definitions[name], resolutionTable, unresolvedRefs, spec);
            } else this.resolveTo(root, parameter.schema, resolutionTable, location);
        }
        if (parameter.$ref) // parameter reference
        this.resolveInline(root, spec, parameter, resolutionTable, unresolvedRefs, parameter.$ref);
    }
    // operations
    for(name in spec.paths){
        var method, operation, responseCode;
        path = spec.paths[name];
        for(method in path)// operation reference
        if (method === '$ref') {
            // location = path[method];
            location = '/paths' + name;
            this.resolveInline(root, spec, path, resolutionTable, unresolvedRefs, location);
        } else {
            operation = path[method];
            var sharedParameters = path.parameters || [];
            var parameters = operation.parameters || [];
            for(i in sharedParameters){
                var parameter = sharedParameters[i];
                parameters.unshift(parameter);
            }
            if (method !== 'parameters' && _.isObject(operation)) operation.parameters = operation.parameters || parameters;
            for(i in parameters){
                var parameter = parameters[i];
                location = '/paths' + name + '/' + method + '/parameters';
                if (parameter.in === 'body' && parameter.schema) {
                    if (_.isArray(parameter.schema.allOf)) {
                        // move to a definition
                        var modelName = 'inline_model';
                        var name = modelName;
                        var done = false;
                        var counter = 0;
                        while(!done){
                            if (typeof spec.definitions[name] === 'undefined') {
                                done = true;
                                break;
                            }
                            name = modelName + '_' + counter;
                            counter++;
                        }
                        spec.definitions[name] = {
                            allOf: parameter.schema.allOf
                        };
                        delete parameter.schema.allOf;
                        parameter.schema.$ref = '#/definitions/' + name;
                        this.processAllOf(root, name, spec.definitions[name], resolutionTable, unresolvedRefs, spec);
                    } else this.resolveTo(root, parameter.schema, resolutionTable, location);
                }
                if (parameter.$ref) // parameter reference
                this.resolveInline(root, spec, parameter, resolutionTable, unresolvedRefs, parameter.$ref);
            }
            for(responseCode in operation.responses){
                var response = operation.responses[responseCode];
                location = '/paths' + name + '/' + method + '/responses/' + responseCode;
                if (_.isObject(response)) {
                    if (response.$ref) // response reference
                    this.resolveInline(root, spec, response, resolutionTable, unresolvedRefs, location);
                    if (response.schema) {
                        var responseObj = response;
                        if (_.isArray(responseObj.schema.allOf)) {
                            // move to a definition
                            var modelName = 'inline_model';
                            var name = modelName;
                            var done = false;
                            var counter = 0;
                            while(!done){
                                if (typeof spec.definitions[name] === 'undefined') {
                                    done = true;
                                    break;
                                }
                                name = modelName + '_' + counter;
                                counter++;
                            }
                            spec.definitions[name] = {
                                allOf: responseObj.schema.allOf
                            };
                            delete responseObj.schema.allOf;
                            delete responseObj.schema.type;
                            responseObj.schema.$ref = '#/definitions/' + name;
                            this.processAllOf(root, name, spec.definitions[name], resolutionTable, unresolvedRefs, spec);
                        } else if ('array' === responseObj.schema.type) {
                            if (responseObj.schema.items && responseObj.schema.items.$ref) // response reference
                            this.resolveInline(root, spec, responseObj.schema.items, resolutionTable, unresolvedRefs, location);
                        } else this.resolveTo(root, response.schema, resolutionTable, location);
                    }
                }
            }
        }
        // clear them out to avoid multiple resolutions
        path.parameters = [];
    }
    var expectedCalls = 0, toResolve = [];
    // if the root is same as obj[i].root we can resolve locally
    var all = resolutionTable;
    var parts;
    for(i = 0; i < all.length; i++){
        var a = all[i];
        if (root === a.root) {
            if (a.resolveAs === 'ref') {
                // resolve any path walking
                var joined = ((a.root || '') + '/' + a.key).split('/');
                var normalized = [];
                var url = '';
                var k;
                if (a.key.indexOf('../') >= 0) {
                    for(var j = 0; j < joined.length; j++)if (joined[j] === '..') normalized = normalized.slice(0, normalized.length - 1);
                    else normalized.push(joined[j]);
                    for(k = 0; k < normalized.length; k++){
                        if (k > 0) url += '/';
                        url += normalized[k];
                    }
                    // we now have to remote resolve this because the path has changed
                    a.root = url;
                    toResolve.push(a);
                } else {
                    parts = a.key.split('#');
                    if (parts.length === 2) {
                        if (parts[0].indexOf('http:') === 0 || parts[0].indexOf('https:') === 0) a.root = parts[0];
                        location = parts[1].split('/');
                        var r;
                        var s = spec;
                        for(k = 0; k < location.length; k++){
                            var part = location[k];
                            if (part !== '') {
                                s = s[part];
                                if (typeof s !== 'undefined') r = s;
                                else {
                                    r = null;
                                    break;
                                }
                            }
                        }
                        if (r === null) // must resolve this too
                        toResolve.push(a);
                    }
                }
            } else if (a.resolveAs === 'inline') {
                if (a.key && a.key.indexOf('#') === -1 && a.key.charAt(0) !== '/') {
                    // handle relative schema
                    parts = a.root.split('/');
                    location = '';
                    for(i = 0; i < parts.length - 1; i++)location += parts[i] + '/';
                    location += a.key;
                    a.root = location;
                    a.location = '';
                }
                toResolve.push(a);
            }
        } else toResolve.push(a);
    }
    expectedCalls = toResolve.length;
    // resolve anything that is local
    var lock = {};
    for(var ii = 0; ii < toResolve.length; ii++)(function(item, spec, self, lock, ii) {
        if (!item.root || item.root === root) {
            // local resolve
            self.resolveItem(spec, _root, resolutionTable, resolvedRefs, unresolvedRefs, item);
            processedCalls += 1;
            if (processedCalls === expectedCalls) self.finish(spec, root, resolutionTable, resolvedRefs, unresolvedRefs, callback, true);
        } else if (self.failedUrls.indexOf(item.root) === -1) {
            var obj = {
                useJQuery: false,
                url: item.root,
                method: 'get',
                headers: {
                    accept: self.scope.swaggerRequestHeaders || 'application/json'
                },
                on: {
                    error: function(error) {
                        processedCalls += 1;
                        console.log('failed url: ' + obj.url);
                        self.failedUrls.push(obj.url);
                        if (lock) delete lock[item.root];
                        unresolvedRefs[item.key] = {
                            root: item.root,
                            location: item.location
                        };
                        if (processedCalls === expectedCalls) self.finish(spec, _root, resolutionTable, resolvedRefs, unresolvedRefs, callback);
                    },
                    response: function(response) {
                        var swagger = response.obj;
                        if (lock) delete lock[item.root];
                        if (self.resolverCache) self.resolverCache[item.root] = swagger;
                        self.resolveItem(swagger, item.root, resolutionTable, resolvedRefs, unresolvedRefs, item);
                        processedCalls += 1;
                        if (processedCalls === expectedCalls) self.finish(spec, _root, resolutionTable, resolvedRefs, unresolvedRefs, callback);
                    }
                } // jshint ignore:line
            };
            // apply timeout only when specified
            if (scope && scope.fetchSpecTimeout) obj.timeout = scope.fetchSpecTimeout;
            if (scope && scope.clientAuthorizations) scope.clientAuthorizations.apply(obj);
            (function waitForUnlock() {
                setTimeout(function() {
                    if (lock[obj.url]) waitForUnlock();
                    else {
                        var cached = self.resolverCache[obj.url];
                        if (_.isObject(cached)) obj.on.response({
                            obj: cached
                        });
                        else {
                            lock[obj.url] = true;
                            new SwaggerHttp().execute(obj, opts);
                        }
                    }
                }, 0);
            })();
        } else {
            processedCalls += 1;
            unresolvedRefs[item.key] = {
                root: item.root,
                location: item.location
            };
            if (processedCalls === expectedCalls) self.finish(spec, _root, resolutionTable, resolvedRefs, unresolvedRefs, callback);
        }
    })(toResolve[ii], spec, this, lock, ii);
    if (Object.keys(toResolve).length === 0) this.finish(spec, _root, resolutionTable, resolvedRefs, unresolvedRefs, callback);
};
Resolver.prototype.resolveItem = function(spec, root, resolutionTable, resolvedRefs, unresolvedRefs, item) {
    var path = item.location;
    var location = spec, parts = path.split('/');
    if (path !== '') for(var j = 0; j < parts.length; j++){
        var segment = parts[j];
        if (segment.indexOf('~1') !== -1) {
            segment = parts[j].replace(/~0/g, '~').replace(/~1/g, '/');
            if (segment.charAt(0) !== '/') segment = '/' + segment;
        }
        if (typeof location === 'undefined' || location === null) break;
        if (segment === '' && j === parts.length - 1 && parts.length > 1) {
            location = null;
            break;
        }
        if (segment.length > 0) location = location[segment];
    }
    var resolved = item.key;
    parts = item.key.split('/');
    var resolvedName = parts[parts.length - 1];
    if (resolvedName.indexOf('#') >= 0) resolvedName = resolvedName.split('#')[1];
    if (location !== null && typeof location !== 'undefined') resolvedRefs[resolved] = {
        name: resolvedName,
        obj: location,
        key: item.key,
        root: item.root
    };
    else unresolvedRefs[resolved] = {
        root: item.root,
        location: item.location
    };
};
Resolver.prototype.finish = function(spec, root, resolutionTable, resolvedRefs, unresolvedRefs, callback, localResolve) {
    // walk resolution table and replace with resolved refs
    var ref;
    for(ref in resolutionTable){
        var item = resolutionTable[ref];
        var key = item.key;
        var resolvedTo = resolvedRefs[key];
        if (resolvedTo) {
            spec.definitions = spec.definitions || {};
            if (item.resolveAs === 'ref') {
                if (localResolve !== true) // don't retain root for local definitions
                for(key in resolvedTo.obj){
                    var abs = this.retainRoot(key, resolvedTo.obj[key], item.root);
                    resolvedTo.obj[key] = abs;
                }
                spec.definitions[resolvedTo.name] = resolvedTo.obj;
                item.obj.$ref = '#/definitions/' + resolvedTo.name;
            } else if (item.resolveAs === 'inline') {
                var targetObj = item.obj;
                targetObj['x-resolved-from'] = [
                    item.key
                ];
                delete targetObj.$ref;
                for(key in resolvedTo.obj){
                    var abs = resolvedTo.obj[key];
                    if (localResolve !== true) // don't retain root for local definitions
                    abs = this.retainRoot(key, resolvedTo.obj[key], item.root);
                    targetObj[key] = abs;
                }
            }
        }
    }
    var existingUnresolved = this.countUnresolvedRefs(spec);
    if (existingUnresolved === 0 || this.iteration > 5) {
        this.resolveAllOf(spec.definitions);
        this.resolverCache = null;
        callback.call(this.scope, spec, unresolvedRefs);
    } else {
        this.iteration += 1;
        this.resolve(spec, root, callback, this.scope);
    }
};
Resolver.prototype.countUnresolvedRefs = function(spec) {
    var i;
    var refs = this.getRefs(spec);
    var keys = [];
    var unresolvedKeys = [];
    for(i in refs)if (i.indexOf('#') === 0) keys.push(i.substring(1));
    else unresolvedKeys.push(i);
    // verify possible keys
    for(i = 0; i < keys.length; i++){
        var part = keys[i];
        var parts = part.split('/');
        var obj = spec;
        for(var k = 0; k < parts.length; k++){
            var key = parts[k];
            if (key !== '') {
                obj = obj[key];
                if (typeof obj === 'undefined') {
                    unresolvedKeys.push(part);
                    break;
                }
            }
        }
    }
    return unresolvedKeys.length;
};
Resolver.prototype.getRefs = function(spec, obj) {
    obj = obj || spec;
    var output = {};
    for(var key in obj){
        if (!obj.hasOwnProperty(key)) continue;
        var item = obj[key];
        if (key === '$ref' && typeof item === 'string') output[item] = null;
        else if (_.isObject(item)) {
            var o = this.getRefs(item);
            for(var k in o)output[k] = null;
        }
    }
    return output;
};
function splitUrl(url) {
    var result = {};
    var proto = /[a-z]+:\/\//i.exec(url);
    if (proto) {
        result.proto = proto[0].slice(0, -3);
        url = url.slice(result.proto.length + 1);
    }
    if (url.slice(0, 2) === '//') {
        result.domain = url.slice(2).split('/')[0];
        url = url.slice(2 + result.domain.length);
    }
    var p = url.split('#');
    if (p[0].length) result.path = p[0];
    if (p.length > 1) result.fragment = p.slice(1).join('#');
    return result;
}
function unsplitUrl(url) {
    var result = url.path;
    if (result === undefined) result = '';
    if (url.fragment !== undefined) result += '#' + url.fragment;
    if (url.domain !== undefined) {
        if (result.slice(0, 1) === '/') result = result.slice(1);
        result = '//' + url.domain + '/' + result;
        if (url.proto !== undefined) result = url.proto + ':' + result;
    }
    return result;
}
function joinUrl(base, rel) {
    var relsp = splitUrl(rel);
    if (relsp.domain !== undefined) return rel;
    var result = splitUrl(base);
    if (relsp.path === undefined) // change only fragment part
    result.fragment = relsp.fragment;
    else if (relsp.path.slice(0, 1) === '/') {
        // relative to domain
        result.path = relsp.path;
        result.fragment = relsp.fragment;
    } else {
        // relative to path
        var path = result.path === undefined ? [] : result.path.split('/');
        var relpath = relsp.path.split('/');
        if (path.length) path.pop();
        while(relpath[0] === '..' || relpath[0] === '.'){
            if (relpath[0] === '..') path.pop();
            relpath.shift();
        }
        result.path = path.concat(relpath).join('/');
        result.fragment = relsp.fragment;
    }
    return unsplitUrl(result);
}
Resolver.prototype.retainRoot = function(origKey, obj, root) {
    // walk object and look for relative $refs
    if (_.isObject(obj)) for(var key in obj){
        var item = obj[key];
        if (key === '$ref' && typeof item === 'string') obj[key] = joinUrl(root, item);
        else if (_.isObject(item)) this.retainRoot(key, item, root);
    }
    else if (_.isString(obj) && origKey === '$ref') obj = joinUrl(root, obj);
    return obj;
};
/**
 * immediately in-lines local refs, queues remote refs
 * for inline resolution
 */ Resolver.prototype.resolveInline = function(root, spec, property, resolutionTable, unresolvedRefs, location) {
    var key = property.$ref, ref = property.$ref, i, p, p2, rs;
    var rootTrimmed = false;
    root = root || '' // Guard against .split. @fehguy, you'll need to check if this logic fits
    ;
    // More imporantly is how do we gracefully handle relative urls, when provided just a 'spec', not a 'url' ?
    if (ref) {
        if (ref.indexOf('../') === 0) {
            // reset root
            p = ref.split('../');
            p2 = root.split('/');
            ref = '';
            for(i = 0; i < p.length; i++)if (p[i] === '') p2 = p2.slice(0, p2.length - 1);
            else ref += p[i];
            root = '';
            for(i = 0; i < p2.length - 1; i++){
                if (i > 0) root += '/';
                root += p2[i];
            }
            rootTrimmed = true;
        }
        if (ref.indexOf('#') >= 0) {
            if (ref.indexOf('/') === 0) {
                rs = ref.split('#');
                p = root.split('//');
                p2 = p[1].split('/');
                root = p[0] + '//' + p2[0] + rs[0];
                location = rs[1];
            } else {
                rs = ref.split('#');
                if (rs[0] !== '') {
                    p2 = root.split('/');
                    p2 = p2.slice(0, p2.length - 1);
                    if (!rootTrimmed) {
                        root = '';
                        for(var k = 0; k < p2.length; k++){
                            if (k > 0) root += '/';
                            root += p2[k];
                        }
                    }
                    root += '/' + ref.split('#')[0];
                }
                location = rs[1];
            }
        }
        if (ref.indexOf('http:') === 0 || ref.indexOf('https:') === 0) {
            if (ref.indexOf('#') >= 0) {
                root = ref.split('#')[0];
                location = ref.split('#')[1];
            } else {
                root = ref;
                location = '';
            }
            resolutionTable.push({
                obj: property,
                resolveAs: 'inline',
                root: root,
                key: key,
                location: location
            });
        } else if (ref.indexOf('#') === 0) {
            location = ref.split('#')[1];
            resolutionTable.push({
                obj: property,
                resolveAs: 'inline',
                root: root,
                key: key,
                location: location
            });
        } else if (ref.indexOf('/') === 0 && ref.indexOf('#') === -1) {
            location = ref;
            var matches = root.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i);
            if (matches) {
                root = matches[0] + ref.substring(1);
                location = '';
            }
            resolutionTable.push({
                obj: property,
                resolveAs: 'inline',
                root: root,
                key: key,
                location: location
            });
        } else resolutionTable.push({
            obj: property,
            resolveAs: 'inline',
            root: root,
            key: key,
            location: location
        });
    } else if (property.type === 'array') this.resolveTo(root, property.items, resolutionTable, location);
};
Resolver.prototype.resolveTo = function(root, property, resolutionTable, location) {
    var sp, i;
    var ref = property.$ref;
    var lroot = root;
    if (typeof ref !== 'undefined' && ref !== null) {
        if (ref.indexOf('#') >= 0) {
            var parts = ref.split('#');
            // #/definitions/foo
            // foo.json#/bar
            if (parts[0] && ref.indexOf('/') === 0) ;
            else if (parts[0] && (parts[0].indexOf('http:') === 0 || parts[0].indexOf('https:') === 0)) {
                lroot = parts[0];
                ref = parts[1];
            } else if (parts[0] && parts[0].length > 0) {
                // relative file
                sp = root.split('/');
                lroot = '';
                for(i = 0; i < sp.length - 1; i++)lroot += sp[i] + '/';
                lroot += parts[0];
            }
            location = parts[1];
        } else if (ref.indexOf('http:') === 0 || ref.indexOf('https:') === 0) {
            lroot = ref;
            location = '';
        } else {
            // relative file
            sp = root.split('/');
            lroot = '';
            for(i = 0; i < sp.length - 1; i++)lroot += sp[i] + '/';
            lroot += ref;
            location = '';
        }
        resolutionTable.push({
            obj: property,
            resolveAs: 'ref',
            root: lroot,
            key: ref,
            location: location
        });
    } else if (property.type === 'array') {
        var items = property.items;
        this.resolveTo(root, items, resolutionTable, location);
    } else if (property && (property.properties || property.additionalProperties)) {
        var name = this.uniqueName('inline_model');
        if (property.title) name = this.uniqueName(property.title);
        delete property.title;
        this.spec.definitions[name] = _.cloneDeep(property);
        property['$ref'] = '#/definitions/' + name;
        delete property.type;
        delete property.properties;
    }
};
Resolver.prototype.uniqueName = function(base) {
    var name = base;
    var count = 0;
    while(true){
        if (!_.isObject(this.spec.definitions[name])) return name;
        name = base + '_' + count;
        count++;
    }
};
Resolver.prototype.resolveAllOf = function(spec, obj, depth) {
    depth = depth || 0;
    obj = obj || spec;
    var name;
    for(var key in obj){
        if (!obj.hasOwnProperty(key)) continue;
        var item = obj[key];
        if (item === null) throw new TypeError('Swagger 2.0 does not support null types (' + obj + ').  See https://github.com/swagger-api/swagger-spec/issues/229.');
        if (typeof item === 'object') this.resolveAllOf(spec, item, depth + 1);
        if (item && typeof item.allOf !== 'undefined') {
            var allOf = item.allOf;
            if (_.isArray(allOf)) {
                var output = _.cloneDeep(item);
                delete output.allOf;
                output['x-composed'] = true;
                if (typeof item['x-resolved-from'] !== 'undefined') output['x-resolved-from'] = item['x-resolved-from'];
                for(var i = 0; i < allOf.length; i++){
                    var component = allOf[i];
                    var source = 'self';
                    if (typeof component['x-resolved-from'] !== 'undefined') source = component['x-resolved-from'][0];
                    for(var part in component)if (!output.hasOwnProperty(part)) {
                        output[part] = _.cloneDeep(component[part]);
                        if (part === 'properties') for(name in output[part])output[part][name]['x-resolved-from'] = source;
                    } else {
                        if (part === 'properties') {
                            var properties = component[part];
                            for(name in properties){
                                output.properties[name] = _.cloneDeep(properties[name]);
                                var resolvedFrom = properties[name]['x-resolved-from'];
                                if (typeof resolvedFrom === 'undefined' || resolvedFrom === 'self') resolvedFrom = source;
                                output.properties[name]['x-resolved-from'] = resolvedFrom;
                            }
                        } else if (part === 'required') {
                            // merge & dedup the required array
                            var a = output.required.concat(component[part]);
                            for(var k = 0; k < a.length; ++k){
                                for(var j = k + 1; j < a.length; ++j)if (a[k] === a[j]) a.splice(j--, 1);
                            }
                            output.required = a;
                        } else if (part === 'x-resolved-from') output['x-resolved-from'].push(source);
                    }
                }
                obj[key] = output;
            }
        }
    }
};

},{"88bbe8ab2558ae8a":"bUg9C","e226c2be006fa75d":"2h87f","cecb3425bee8a1c5":"7UzDg","235f82d379ea8d34":"42oZf","c1224cae5b846001":"eSX4L"}],"jNa6g":[function(require,module,exports,__globalThis) {
'use strict';
var SwaggerHttp = require("a177f12c2fa6a434");
var _ = {
    isObject: require("5631ae1c64a0cc2d")
};
var SwaggerSpecConverter = module.exports = function() {
    this.errors = [];
    this.warnings = [];
    this.modelMap = {};
};
SwaggerSpecConverter.prototype.setDocumentationLocation = function(location) {
    this.docLocation = location;
};
/**
 * converts a resource listing OR api declaration
 **/ SwaggerSpecConverter.prototype.convert = function(obj, clientAuthorizations, opts, callback) {
    // not a valid spec
    if (!obj || !Array.isArray(obj.apis)) return this.finish(callback, null);
    this.clientAuthorizations = clientAuthorizations;
    // create a new swagger object to return
    var swagger = {
        swagger: '2.0'
    };
    swagger.originalVersion = obj.swaggerVersion;
    // add the info
    this.apiInfo(obj, swagger);
    // add security definitions
    this.securityDefinitions(obj, swagger);
    // take basePath into account
    if (obj.basePath) this.setDocumentationLocation(obj.basePath);
    // see if this is a single-file swagger definition
    var isSingleFileSwagger = false;
    var i;
    for(i = 0; i < obj.apis.length; i++){
        var api = obj.apis[i];
        if (Array.isArray(api.operations)) isSingleFileSwagger = true;
    }
    if (isSingleFileSwagger) {
        this.declaration(obj, swagger);
        this.finish(callback, swagger);
    } else this.resourceListing(obj, swagger, opts, callback);
};
SwaggerSpecConverter.prototype.declaration = function(obj, swagger) {
    var name, i, p, pos;
    if (!obj.apis) return;
    if (obj.basePath.indexOf('http://') === 0) {
        p = obj.basePath.substring(7);
        pos = p.indexOf('/');
        if (pos > 0) {
            swagger.host = p.substring(0, pos);
            swagger.basePath = p.substring(pos);
        } else {
            swagger.host = p;
            swagger.basePath = '/';
        }
    } else if (obj.basePath.indexOf('https://') === 0) {
        p = obj.basePath.substring(8);
        pos = p.indexOf('/');
        if (pos > 0) {
            swagger.host = p.substring(0, pos);
            swagger.basePath = p.substring(pos);
        } else {
            swagger.host = p;
            swagger.basePath = '/';
        }
    } else swagger.basePath = obj.basePath;
    var resourceLevelAuth;
    if (obj.authorizations) resourceLevelAuth = obj.authorizations;
    if (obj.consumes) swagger.consumes = obj.consumes;
    if (obj.produces) swagger.produces = obj.produces;
    // build a mapping of id to name for 1.0 model resolutions
    if (_.isObject(obj)) for(name in obj.models){
        var existingModel = obj.models[name];
        var key = existingModel.id || name;
        this.modelMap[key] = name;
    }
    for(i = 0; i < obj.apis.length; i++){
        var api = obj.apis[i];
        var path = api.path;
        var operations = api.operations;
        this.operations(path, obj.resourcePath, operations, resourceLevelAuth, swagger);
    }
    var models = obj.models || {};
    this.models(models, swagger);
};
SwaggerSpecConverter.prototype.models = function(obj, swagger) {
    if (!_.isObject(obj)) return;
    var name;
    swagger.definitions = swagger.definitions || {};
    for(name in obj){
        var existingModel = obj[name];
        var _required = [];
        var schema = {
            properties: {}
        };
        var propertyName;
        for(propertyName in existingModel.properties){
            var existingProperty = existingModel.properties[propertyName];
            var property = {};
            this.dataType(existingProperty, property);
            if (existingProperty.description) property.description = existingProperty.description;
            if (existingProperty['enum']) property['enum'] = existingProperty['enum'];
            if (typeof existingProperty.required === 'boolean' && existingProperty.required === true) _required.push(propertyName);
            if (typeof existingProperty.required === 'string' && existingProperty.required === 'true') _required.push(propertyName);
            schema.properties[propertyName] = property;
        }
        if (_required.length > 0) schema.required = _required;
        else schema.required = existingModel.required;
        swagger.definitions[name] = schema;
    }
};
SwaggerSpecConverter.prototype.extractTag = function(resourcePath) {
    var pathString = resourcePath || 'default';
    if (pathString.indexOf('http:') === 0 || pathString.indexOf('https:') === 0) {
        pathString = pathString.split([
            '/'
        ]);
        pathString = pathString[pathString.length - 1].substring();
    }
    if (pathString.endsWith('.json')) pathString = pathString.substring(0, pathString.length - 5);
    return pathString.replace('/', '');
};
SwaggerSpecConverter.prototype.operations = function(path, resourcePath, obj, resourceLevelAuth, swagger) {
    if (!Array.isArray(obj)) return;
    var i;
    if (!swagger.paths) swagger.paths = {};
    var pathObj = swagger.paths[path] || {};
    var tag = this.extractTag(resourcePath);
    swagger.tags = swagger.tags || [];
    var matched = false;
    for(i = 0; i < swagger.tags.length; i++){
        var tagObject = swagger.tags[i];
        if (tagObject.name === tag) matched = true;
    }
    if (!matched) swagger.tags.push({
        name: tag
    });
    for(i = 0; i < obj.length; i++){
        var existingOperation = obj[i];
        var method = (existingOperation.method || existingOperation.httpMethod).toLowerCase();
        var operation = {
            tags: [
                tag
            ]
        };
        var existingAuthorizations = existingOperation.authorizations;
        if (existingAuthorizations && Object.keys(existingAuthorizations).length === 0) existingAuthorizations = resourceLevelAuth;
        if (typeof existingAuthorizations !== 'undefined') {
            var scopesObject;
            for(var key in existingAuthorizations){
                operation.security = operation.security || [];
                var scopes = existingAuthorizations[key];
                if (scopes) {
                    var securityScopes = [];
                    for(var j in scopes)securityScopes.push(scopes[j].scope);
                    scopesObject = {};
                    scopesObject[key] = securityScopes;
                    operation.security.push(scopesObject);
                } else {
                    scopesObject = {};
                    scopesObject[key] = [];
                    operation.security.push(scopesObject);
                }
            }
        }
        if (existingOperation.consumes) operation.consumes = existingOperation.consumes;
        else if (swagger.consumes) operation.consumes = swagger.consumes;
        if (existingOperation.produces) operation.produces = existingOperation.produces;
        else if (swagger.produces) operation.produces = swagger.produces;
        if (existingOperation.summary) operation.summary = existingOperation.summary;
        if (existingOperation.notes) operation.description = existingOperation.notes;
        if (existingOperation.nickname) operation.operationId = existingOperation.nickname;
        if (existingOperation.deprecated) operation.deprecated = existingOperation.deprecated;
        this.authorizations(existingAuthorizations, swagger);
        this.parameters(operation, existingOperation.parameters, swagger);
        this.responseMessages(operation, existingOperation, swagger);
        pathObj[method] = operation;
    }
    swagger.paths[path] = pathObj;
};
SwaggerSpecConverter.prototype.responseMessages = function(operation, existingOperation) {
    if (!_.isObject(existingOperation)) return;
    // build default response from the operation (1.x)
    var defaultResponse = {};
    this.dataType(existingOperation, defaultResponse);
    // TODO: look into the real problem of rendering responses in swagger-ui
    // ....should reponseType have an implicit schema?
    if (!defaultResponse.schema && defaultResponse.type) defaultResponse = {
        schema: defaultResponse
    };
    operation.responses = operation.responses || {};
    // grab from responseMessages (1.2)
    var has200 = false;
    if (Array.isArray(existingOperation.responseMessages)) {
        var i;
        var existingResponses = existingOperation.responseMessages;
        for(i = 0; i < existingResponses.length; i++){
            var existingResponse = existingResponses[i];
            var response = {
                description: existingResponse.message
            };
            if (existingResponse.code === 200) has200 = true;
            // Convert responseModel -> schema{$ref: responseModel}
            if (existingResponse.responseModel) response.schema = {
                '$ref': '#/definitions/' + existingResponse.responseModel
            };
            operation.responses['' + existingResponse.code] = response;
        }
    }
    if (has200) operation.responses['default'] = defaultResponse;
    else operation.responses['200'] = defaultResponse;
};
SwaggerSpecConverter.prototype.authorizations = function(obj) {
    // TODO
    if (!_.isObject(obj)) return;
};
SwaggerSpecConverter.prototype.parameters = function(operation, obj) {
    if (!Array.isArray(obj)) return;
    var i;
    for(i = 0; i < obj.length; i++){
        var existingParameter = obj[i];
        var parameter = {};
        parameter.name = existingParameter.name;
        parameter.description = existingParameter.description;
        parameter.required = existingParameter.required;
        parameter.in = existingParameter.paramType;
        // per #168
        if (parameter.in === 'body') parameter.name = 'body';
        if (parameter.in === 'form') parameter.in = 'formData';
        if (existingParameter.enum) parameter.enum = existingParameter.enum;
        if (existingParameter.allowMultiple === true || existingParameter.allowMultiple === 'true') {
            var innerType = {};
            this.dataType(existingParameter, innerType);
            parameter.type = 'array';
            parameter.items = innerType;
            if (existingParameter.allowableValues) {
                var av = existingParameter.allowableValues;
                if (av.valueType === 'LIST') parameter['enum'] = av.values;
            }
        } else this.dataType(existingParameter, parameter);
        if (typeof existingParameter.defaultValue !== 'undefined') parameter.default = existingParameter.defaultValue;
        operation.parameters = operation.parameters || [];
        operation.parameters.push(parameter);
    }
};
SwaggerSpecConverter.prototype.dataType = function(source, target) {
    if (!_.isObject(source)) return;
    if (source.minimum) target.minimum = source.minimum;
    if (source.maximum) target.maximum = source.maximum;
    if (source.format) target.format = source.format;
    // default can be 'false'
    if (typeof source.defaultValue !== 'undefined') target.default = source.defaultValue;
    var jsonSchemaType = this.toJsonSchema(source);
    if (jsonSchemaType) {
        target = target || {};
        if (jsonSchemaType.type) target.type = jsonSchemaType.type;
        if (jsonSchemaType.format) target.format = jsonSchemaType.format;
        if (jsonSchemaType.$ref) target.schema = {
            $ref: jsonSchemaType.$ref
        };
        if (jsonSchemaType.items) target.items = jsonSchemaType.items;
    }
};
SwaggerSpecConverter.prototype.toJsonSchema = function(source) {
    if (!source) return 'object';
    var detectedType = source.type || source.dataType || source.responseClass || '';
    var lcType = detectedType.toLowerCase();
    var format = (source.format || '').toLowerCase();
    if (lcType.indexOf('list[') === 0) {
        var innerType = detectedType.substring(5, detectedType.length - 1);
        var jsonType = this.toJsonSchema({
            type: innerType
        });
        return {
            type: 'array',
            items: jsonType
        };
    } else if (lcType === 'int' || lcType === 'integer' && format === 'int32') return {
        type: 'integer',
        format: 'int32'
    };
    else if (lcType === 'long' || lcType === 'integer' && format === 'int64') return {
        type: 'integer',
        format: 'int64'
    };
    else if (lcType === 'integer') return {
        type: 'integer',
        format: 'int64'
    };
    else if (lcType === 'float' || lcType === 'number' && format === 'float') return {
        type: 'number',
        format: 'float'
    };
    else if (lcType === 'double' || lcType === 'number' && format === 'double') return {
        type: 'number',
        format: 'double'
    };
    else if (lcType === 'string' && format === 'date-time' || lcType === 'date') return {
        type: 'string',
        format: 'date-time'
    };
    else if (lcType === 'string') return {
        type: 'string'
    };
    else if (lcType === 'file') return {
        type: 'file'
    };
    else if (lcType === 'boolean') return {
        type: 'boolean'
    };
    else if (lcType === 'boolean') return {
        type: 'boolean'
    };
    else if (lcType === 'array' || lcType === 'list') {
        if (source.items) {
            var it = this.toJsonSchema(source.items);
            return {
                type: 'array',
                items: it
            };
        } else return {
            type: 'array',
            items: {
                type: 'object'
            }
        };
    } else if (source.$ref) return {
        $ref: this.modelMap[source.$ref] ? '#/definitions/' + this.modelMap[source.$ref] : source.$ref
    };
    else if (lcType === 'void' || lcType === '') return {};
    else if (this.modelMap[source.type]) // If this a model using `type` instead of `$ref`, that's fine.
    return {
        $ref: '#/definitions/' + this.modelMap[source.type]
    };
    else // Unknown model type or 'object', pass it along.
    return {
        type: source.type
    };
};
SwaggerSpecConverter.prototype.resourceListing = function(obj, swagger, opts, callback) {
    var i;
    var processedCount = 0; // jshint ignore:line
    var self = this; // jshint ignore:line
    var expectedCount = obj.apis.length;
    var _swagger = swagger; // jshint ignore:line
    var _opts = {};
    if (opts && opts.requestInterceptor) _opts.requestInterceptor = opts.requestInterceptor;
    if (opts && opts.responseInterceptor) _opts.responseInterceptor = opts.responseInterceptor;
    var swaggerRequestHeaders = 'application/json';
    if (opts && opts.swaggerRequestHeaders) swaggerRequestHeaders = opts.swaggerRequestHeaders;
    if (expectedCount === 0) this.finish(callback, swagger);
    for(i = 0; i < expectedCount; i++){
        var api = obj.apis[i];
        var path = api.path;
        var absolutePath = this.getAbsolutePath(obj.swaggerVersion, this.docLocation, path);
        if (api.description) {
            swagger.tags = swagger.tags || [];
            swagger.tags.push({
                name: this.extractTag(api.path),
                description: api.description || ''
            });
        }
        var http = {
            url: absolutePath,
            headers: {
                accept: swaggerRequestHeaders
            },
            on: {},
            method: 'get',
            timeout: opts.timeout
        };
        /* jshint ignore:start */ http.on.response = function(data) {
            processedCount += 1;
            var obj = data.obj;
            if (obj) self.declaration(obj, _swagger);
            if (processedCount === expectedCount) self.finish(callback, _swagger);
        };
        http.on.error = function(data) {
            console.error(data);
            processedCount += 1;
            if (processedCount === expectedCount) self.finish(callback, _swagger);
        };
        /* jshint ignore:end */ if (this.clientAuthorizations && typeof this.clientAuthorizations.apply === 'function') this.clientAuthorizations.apply(http);
        new SwaggerHttp().execute(http, _opts);
    }
};
SwaggerSpecConverter.prototype.getAbsolutePath = function(version, docLocation, path) {
    if (version === '1.0') {
        if (docLocation.endsWith('.json')) {
            // get root path
            var pos = docLocation.lastIndexOf('/');
            if (pos > 0) docLocation = docLocation.substring(0, pos);
        }
    }
    var location = docLocation;
    if (path.indexOf('http:') === 0 || path.indexOf('https:') === 0) location = path;
    else {
        if (docLocation.endsWith('/')) location = docLocation.substring(0, docLocation.length - 1);
        location += path;
    }
    location = location.replace('{format}', 'json');
    return location;
};
SwaggerSpecConverter.prototype.securityDefinitions = function(obj, swagger) {
    if (obj.authorizations) {
        var name;
        for(name in obj.authorizations){
            var isValid = false;
            var securityDefinition = {};
            var definition = obj.authorizations[name];
            if (definition.type === 'apiKey') {
                securityDefinition.type = 'apiKey';
                securityDefinition.in = definition.passAs;
                securityDefinition.name = definition.keyname || name;
                isValid = true;
            } else if (definition.type === 'basicAuth') {
                securityDefinition.type = 'basicAuth';
                isValid = true;
            } else if (definition.type === 'oauth2') {
                var existingScopes = definition.scopes || [];
                var scopes = {};
                var i;
                for(i in existingScopes){
                    var scope = existingScopes[i];
                    scopes[scope.scope] = scope.description;
                }
                securityDefinition.type = 'oauth2';
                if (i > 0) securityDefinition.scopes = scopes;
                if (definition.grantTypes) {
                    if (definition.grantTypes.implicit) {
                        var implicit = definition.grantTypes.implicit;
                        securityDefinition.flow = 'implicit';
                        securityDefinition.authorizationUrl = implicit.loginEndpoint;
                        isValid = true;
                    }
                    /* jshint ignore:start */ if (definition.grantTypes['authorization_code']) {
                        if (!securityDefinition.flow) {
                            // cannot set if flow is already defined
                            var authCode = definition.grantTypes['authorization_code'];
                            securityDefinition.flow = 'accessCode';
                            securityDefinition.authorizationUrl = authCode.tokenRequestEndpoint.url;
                            securityDefinition.tokenUrl = authCode.tokenEndpoint.url;
                            isValid = true;
                        }
                    }
                /* jshint ignore:end */ }
            }
            if (isValid) {
                swagger.securityDefinitions = swagger.securityDefinitions || {};
                swagger.securityDefinitions[name] = securityDefinition;
            }
        }
    }
};
SwaggerSpecConverter.prototype.apiInfo = function(obj, swagger) {
    // info section
    if (obj.info) {
        var info = obj.info;
        swagger.info = {};
        if (info.contact) {
            swagger.info.contact = {};
            swagger.info.contact.email = info.contact;
        }
        if (info.description) swagger.info.description = info.description;
        if (info.title) swagger.info.title = info.title;
        if (info.termsOfServiceUrl) swagger.info.termsOfService = info.termsOfServiceUrl;
        if (info.license || info.licenseUrl) {
            swagger.license = {};
            if (info.license) swagger.license.name = info.license;
            if (info.licenseUrl) swagger.license.url = info.licenseUrl;
        }
    } else this.warnings.push('missing info section');
};
SwaggerSpecConverter.prototype.finish = function(callback, obj) {
    callback(obj);
};

},{"a177f12c2fa6a434":"bUg9C","5631ae1c64a0cc2d":"2h87f"}],"9iFCf":[function(require,module,exports,__globalThis) {
"use strict";
function swaggerResponseValidatorPromiseFactory(modelName) {
    if (!modelName) throw new Error("No modelName supplied");
    return function swaggerResponseValidatorPromise(response) {
        var client, data, validation;
        if (!response || !response.obj) throw new Error("Bad Response");
        client = response.client;
        data = response.obj;
        if (client && client.validateModel) {
            validation = client.validateModel(modelName, data);
            response.validation = validation;
        }
        return response;
    };
}
module.exports = swaggerResponseValidatorPromiseFactory;

},{}],"aOMEP":[function(require,module,exports,__globalThis) {
'use strict';
var _ = require("c63b96361e38306d");
var Q = require("3a3c0f3173cd177");
var grameneSwaggerClient = require("84f23a89442a0a91");
var validate = require("b83139ec9f7e53b6");
function makeCall(gramene, queryString) {
    var deferred = Q.defer();
    var params = {
        q: queryString ? queryString + '*' : '*'
    };
    gramene['Search'].suggestions(params, function(res) {
        res.client = gramene;
        deferred.resolve(res);
    });
    return deferred.promise;
}
function reformatResponse(response) {
    var query, category, categories;
    query = _.get(response, 'obj.responseHeader.params.q');
    // remove the trailing '*'
    if (query && query.length) query = query.slice(0, -1);
    category = _.get(response, 'obj.grouped.category');
    categories = _.get(response, 'obj.grouped.category.groups');
    if (categories) // the following line is a safer equivalent of
    // `return response.obj.grouped.category.groups.map(function(category) {`
    categories = categories.map(function reformatSuggestionCategory(category) {
        var doclist = category.doclist;
        if (!category.doclist) {
            console.error('No doclist for category ', category);
            return;
        }
        return {
            label: category.groupValue,
            suggestions: doclist.docs,
            max_score: doclist.maxScore,
            num_found: doclist.numFound
        };
    });
    return {
        metadata: {
            query: query,
            count: category.matches,
            url: response.url,
            validation: response.validation
        },
        categories: categories
    };
}
function promise(queryString) {
    return grameneSwaggerClient.then(function(client) {
        return makeCall(client, queryString);
    }).then(validate("SolrSuggestResponse")).then(reformatResponse);
}
module.exports = {
    makeCall: makeCall,
    reformatResponse: reformatResponse,
    promise: promise
};

},{"c63b96361e38306d":"8bWZr","3a3c0f3173cd177":"iWYSC","84f23a89442a0a91":"4HmSJ","b83139ec9f7e53b6":"9iFCf"}],"fNiZG":[function(require,module,exports,__globalThis) {
'use strict';
var _ = require("24120ab890a2539f");
var Q = require("a7a45c1f7ea3a558");
var validate = require("9caa57313175d04f");
var grameneSwaggerClient = require("5fb938e5e3686215");
// hard code these here so that we can guarantee module.export functions are
// available immediately.
var collections = {
    genes: "MongoGenesResponse",
    genetrees: "MongoGenetreesResponse",
    maps: "MongoMapsResponse",
    domains: "InterProResponse",
    taxonomy: "TaxonomyResponse",
    GO: "OntologyResponse",
    PO: "OntologyResponse",
    pathways: "ReactomeEntityResponse"
};
module.exports = _.mapValues(collections, callPromiseFactory);
function callPromiseFactory(schemaName, methodName) {
    function getCallFunction(gramene) {
        return gramene['Data access'][methodName];
    }
    function getSchemaName(gramene) {
        var $ref = _.get(gramene, [
            'Data access',
            'apis',
            methodName,
            'type',
            'schema',
            '$ref'
        ]);
        if ($ref && $ref.indexOf('#/definitions/') == 0) return $ref.substring(14);
    }
    function checkSchemaAgainst(gramene) {
        var scheamNameFromAPI = getSchemaName(gramene);
        if (scheamNameFromAPI !== schemaName) throw new Error("Schema name mismatch. Expected " + schemaName + ", got " + scheamNameFromAPI);
    }
    function makeCall(gramene, query) {
        var deferred, ids, params, apiMethodToInvoke;
        checkSchemaAgainst(gramene);
        deferred = Q.defer();
        ids = getIdListString(query);
        params = {
            idList: ids
        };
        apiMethodToInvoke = getCallFunction(gramene);
        apiMethodToInvoke(params, function addApiToResponseAndResolvePromise(res) {
            res.client = gramene;
            deferred.resolve(res);
        });
        return deferred.promise;
    }
    return function promise(queryString) {
        return grameneSwaggerClient.then(function makeCallFactory(client) {
            return makeCall(client, queryString);
        }).then(validate(schemaName)).then(reformatResponse);
    };
}
function getIdListString(query) {
    if (_.isString(query)) return query;
    if (_.isArray(query)) return query.join(',');
    throw new Error('Query should be a string or an array. We were provided ' + typeof query);
}
function reformatResponse(response) {
    var results = response.obj;
    return {
        metadata: {
            url: response.url,
            count: results.length,
            validation: response.validation
        },
        docs: results
    };
}

},{"24120ab890a2539f":"8bWZr","a7a45c1f7ea3a558":"iWYSC","9caa57313175d04f":"9iFCf","5fb938e5e3686215":"4HmSJ"}],"8CcbO":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"default\":{\"query\":{\"q\":\"\",\"filters\":{},\"resultTypes\":{\"taxon_id\":{\"facet.field\":\"{!facet.limit='50' facet.mincount='0' key='taxon_id'}taxon_id\"}},\"cachedResultTypes\":{}},\"response\":{\"validation\":{\"valid\":true},\"obj\":{\"responseHeader\":{\"status\":0,\"QTime\":0,\"params\":{\"facet\":\"true\",\"q\":\"*\",\"wt\":\"json\",\"rows\":\"0\"}},\"response\":{\"numFound\":1666975,\"start\":0,\"docs\":[]},\"facet_counts\":{\"facet_queries\":{},\"facet_fields\":{},\"facet_dates\":{},\"facet_ranges\":{},\"facet_intervals\":{},\"facet_heatmaps\":{}}}}},\"faceted\":{\"query\":{\"q\":\"\",\"filters\":{\"_terms:(PAD4)\":{}},\"resultTypes\":{\"taxon_id\":{\"facet.field\":\"{!facet.limit='50' facet.mincount='0' key='taxon_id'}taxon_id\"}},\"cachedResultTypes\":{}},\"response\":{\"validation\":{\"valid\":true},\"obj\":{\"responseHeader\":{\"status\":0,\"QTime\":2,\"params\":{\"facet\":\"true\",\"q\":\"*\",\"facet.field\":\"{!facet.limit='50' facet.mincount='0' key='taxon_id'}taxon_id\",\"fq\":\"_terms:(PAD4)\",\"rows\":\"0\"}},\"response\":{\"numFound\":5,\"start\":0,\"maxScore\":1,\"docs\":[]},\"facet_counts\":{\"facet_queries\":{},\"facet_fields\":{\"taxon_id\":[\"3702\",1,\"3760\",1,\"4113\",1,\"29760\",1,\"81972\",1,\"3055\",0,\"3218\",0,\"3641\",0,\"3694\",0,\"3847\",0,\"3880\",0,\"4081\",0,\"4528\",0,\"4529\",0,\"4533\",0,\"4536\",0,\"4537\",0,\"4538\",0,\"4555\",0,\"4558\",0,\"4565\",0,\"4572\",0,\"4577\",0,\"13333\",0,\"15368\",0,\"37682\",0,\"39946\",0,\"39947\",0,\"40148\",0,\"40149\",0,\"51351\",0,\"65489\",0,\"77586\",0,\"88036\",0,\"109376\",0,\"112509\",0,\"214687\",0,\"280699\",0,\"436017\",0]},\"facet_dates\":{},\"facet_ranges\":{},\"facet_intervals\":{},\"facet_heatmaps\":{}}}}},\"rows10\":{\"query\":{\"q\":\"\",\"filters\":{\"_terms:(PAD4)\":{}},\"resultTypes\":{\"list\":{\"rows\":10,\"start\":0},\"fixed_200__bin\":{\"facet.field\":\"{!facet.limit='-1' facet.mincount='1' key='fixed_200__bin'}fixed_200__bin\"}},\"count\":5,\"cachedResultTypes\":{}},\"response\":{\"validation\":{\"valid\":true},\"obj\":{\"responseHeader\":{\"status\":0,\"QTime\":97,\"params\":{\"facet\":\"true\",\"start\":\"0\",\"q\":\"*\",\"facet.field\":\"{!facet.limit='-1' facet.mincount='1' key='fixed_200__bin'}fixed_200__bin\",\"fq\":\"_terms:(PAD4)\",\"rows\":\"10\"}},\"response\":{\"numFound\":5,\"start\":0,\"maxScore\":1,\"docs\":[{\"id\":\"PRUPE_ppa025554mg\",\"name\":\"PAD4\",\"description\":\"alpha/beta-Hydrolases superfamily protein\",\"taxon_id\":3760,\"biotype\":\"protein_coding\",\"capabilities\":[\"location\",\"homology\",\"xrefs\",\"GO\",\"domains\",\"taxonomy\"],\"closest_rep_id\":\"MTR_8g494200\",\"closest_rep_taxon_id\":3880,\"closest_rep_description\":\"phytoalexin deficient protein\",\"model_rep_id\":\"AT3G52430\",\"model_rep_taxon_id\":3702,\"model_rep_name\":\"PAD4\",\"model_rep_description\":\"Lipase-like PAD4\",\"score\":1},{\"id\":\"PGSC0003DMG400019873\",\"name\":\"PAD4\",\"description\":\"Phytoalexin-deficient 4-2 protein\",\"taxon_id\":4113,\"biotype\":\"protein_coding\",\"capabilities\":[\"location\",\"homology\",\"xrefs\",\"GO\",\"domains\",\"taxonomy\"],\"score\":1},{\"id\":\"AT3G52430\",\"name\":\"PAD4\",\"description\":\"Lipase-like PAD4\",\"taxon_id\":3702,\"biotype\":\"protein_coding\",\"capabilities\":[\"location\",\"homology\",\"xrefs\",\"GO\",\"PO\",\"domains\",\"taxonomy\"],\"model_rep_id\":\"AT3G52430\",\"model_rep_taxon_id\":3702,\"model_rep_name\":\"PAD4\",\"model_rep_description\":\"Lipase-like PAD4\",\"score\":1},{\"id\":\"scaffold_502313.1\",\"name\":\"PAD4\",\"description\":\"Phytoalexin deficient 4\",\"taxon_id\":81972,\"biotype\":\"protein_coding\",\"capabilities\":[\"location\",\"homology\",\"xrefs\",\"GO\",\"domains\",\"taxonomy\"],\"score\":1},{\"id\":\"VIT_07s0031g02390\",\"name\":\"PAD4\",\"description\":\"Putative uncharacterized protein\",\"taxon_id\":29760,\"biotype\":\"protein_coding\",\"capabilities\":[\"location\",\"homology\",\"xrefs\",\"GO\",\"domains\",\"taxonomy\"],\"closest_rep_id\":\"AT3G52430\",\"closest_rep_taxon_id\":3702,\"closest_rep_name\":\"PAD4\",\"closest_rep_description\":\"Lipase-like PAD4\",\"score\":1}]},\"facet_counts\":{\"facet_queries\":{},\"facet_fields\":{\"fixed_200__bin\":[\"516\",1,\"602\",1,\"1231\",1,\"3476\",1,\"4927\",1]},\"facet_dates\":{},\"facet_ranges\":{},\"facet_intervals\":{},\"facet_heatmaps\":{}}}}}}");

},{}],"TI30D":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"obj\":[{\"_id\":1,\"ancestors\":[1],\"id\":\"NCBITaxon:1\",\"name\":\"root\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":1568831,\"parents\":[],\"synonym\":[\"all\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":2759,\"ancestors\":[1,2759,131567],\"id\":\"NCBITaxon:2759\",\"is_a\":[131567],\"name\":\"Eukaryota\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":1568831,\"parents\":[\"131567\"],\"property_value\":\"has_rank NCBITaxon:superkingdom\",\"synonym\":[\"Eucarya\",\"Eucaryotae\",\"eucaryotes\",\"Eukarya\",\"Eukaryotae\",\"eukaryotes\",\"eukaryotes\"],\"xref\":[\"GC_ID:1\",\"PMID:23020233\"]},{\"_id\":2763,\"ancestors\":[1,2759,2763,131567],\"id\":\"NCBITaxon:2763\",\"is_a\":[2759],\"name\":\"Rhodophyta\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":5106,\"parents\":[\"2759\"],\"synonym\":[\"algae\",\"red algae\",\"red algae\",\"Rhodophyceae\",\"Rhodophycota\",\"rhodophytes\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":2797,\"ancestors\":[1,2759,2763,2797,131567],\"id\":\"NCBITaxon:2797\",\"is_a\":[2763],\"name\":\"Bangiophyceae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":5106,\"parents\":[\"2763\"],\"property_value\":\"has_rank NCBITaxon:class\",\"synonym\":[\"Bangiophycideae\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":3041,\"ancestors\":[1,2759,3041,33090,131567],\"id\":\"NCBITaxon:3041\",\"is_a\":[33090],\"name\":\"Chlorophyta\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":22127,\"parents\":[\"33090\"],\"property_value\":\"has_rank NCBITaxon:phylum\",\"synonym\":[\"algae\",\"Chlorophycota\",\"Chlorophyta sensu Bremer 1985\",\"green algae\",\"green algae\"],\"xref\":[\"GC_ID:1\",\"PMID:23020233\"]},{\"_id\":3042,\"alt_id\":[167765,3069],\"ancestors\":[1,2759,3041,3042,3166,33090,131567],\"id\":\"NCBITaxon:3042\",\"is_a\":[3166],\"name\":\"Chlamydomonadales\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":14487,\"parents\":[\"3166\"],\"property_value\":\"has_rank NCBITaxon:order\",\"synonym\":[\"Chlorococcales\",\"Volvocales\",\"Volvocida\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":3051,\"ancestors\":[1,2759,3041,3042,3051,3166,33090,131567],\"id\":\"NCBITaxon:3051\",\"is_a\":[3042],\"name\":\"Chlamydomonadaceae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":14487,\"parents\":[\"3042\"],\"property_value\":\"has_rank NCBITaxon:family\",\"xref\":[\"GC_ID:1\"]},{\"_id\":3052,\"ancestors\":[1,2759,3041,3042,3051,3052,3166,33090,131567],\"id\":\"NCBITaxon:3052\",\"is_a\":[3051],\"name\":\"Chlamydomonas\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":14487,\"parents\":[\"3051\"],\"property_value\":\"has_rank NCBITaxon:genus\",\"xref\":[\"GC_ID:1\"]},{\"_id\":3055,\"alt_id\":[3058,61248],\"ancestors\":[1,2759,3041,3042,3051,3052,3055,3166,33090,131567],\"id\":\"NCBITaxon:3055\",\"is_a\":[3052],\"name\":\"Chlamydomonas reinhardtii\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":14487,\"parents\":[\"3052\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"Chlamydomonas reihhardtii\",\"Chlamydomonas smithii\",\"Chlamydonas reinhardtii\"],\"xref\":[\"GC_ID:1\",\"PMID:12355262\"]},{\"_id\":3152,\"ancestors\":[1,2759,3041,3152,33090,131567],\"id\":\"NCBITaxon:3152\",\"is_a\":[3041],\"name\":\"prasinophytes\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":7640,\"parents\":[\"3041\"],\"synonym\":[\"Micromonadophyceae\",\"Prasinomonadida\",\"Prasinophyceae\",\"Prasinophyta\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":3166,\"ancestors\":[1,2759,3041,3166,33090,131567],\"id\":\"NCBITaxon:3166\",\"is_a\":[3041],\"name\":\"Chlorophyceae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":14487,\"parents\":[\"3041\"],\"property_value\":\"has_rank NCBITaxon:class\",\"xref\":[\"GC_ID:1\",\"PMID:23020233\"]},{\"_id\":3193,\"ancestors\":[1,2759,3193,33090,35493,131221,131567],\"id\":\"NCBITaxon:3193\",\"is_a\":[131221],\"name\":\"Embryophyta\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":1541598,\"parents\":[\"131221\"],\"synonym\":[\"higher plants\",\"land plants\",\"land plants\",\"plants\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":3208,\"alt_id\":[3194],\"ancestors\":[1,2759,3193,3208,33090,35493,131221,131567],\"id\":\"NCBITaxon:3208\",\"is_a\":[3193],\"name\":\"Bryophyta\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":32273,\"parents\":[\"3193\"],\"synonym\":[\"bryophytes\",\"Bryopsida\",\"mosses\",\"mosses\",\"Musci\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":3214,\"ancestors\":[1,2759,3193,3208,3214,33090,35493,131221,131567,404260],\"id\":\"NCBITaxon:3214\",\"is_a\":[404260],\"name\":\"Bryopsida\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":32273,\"parents\":[\"404260\"],\"property_value\":\"has_rank NCBITaxon:class\",\"xref\":[\"GC_ID:1\"]},{\"_id\":3215,\"ancestors\":[1,2759,3193,3208,3214,3215,33090,35493,114656,131221,131567,404260],\"id\":\"NCBITaxon:3215\",\"is_a\":[114656],\"name\":\"Funariales\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":32273,\"parents\":[\"114656\"],\"property_value\":\"has_rank NCBITaxon:order\",\"xref\":[\"GC_ID:1\"]},{\"_id\":3216,\"ancestors\":[1,2759,3193,3208,3214,3215,3216,33090,35493,114656,131221,131567,404260],\"id\":\"NCBITaxon:3216\",\"is_a\":[3215],\"name\":\"Funariaceae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":32273,\"parents\":[\"3215\"],\"property_value\":\"has_rank NCBITaxon:family\",\"xref\":[\"GC_ID:1\"]},{\"_id\":3217,\"ancestors\":[1,2759,3193,3208,3214,3215,3216,3217,33090,35493,114656,131221,131567,404260],\"id\":\"NCBITaxon:3217\",\"is_a\":[3216],\"name\":\"Physcomitrella\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":32273,\"parents\":[\"3216\"],\"property_value\":\"has_rank NCBITaxon:genus\",\"xref\":[\"GC_ID:1\",\"PMID:25015729\"]},{\"_id\":3218,\"alt_id\":[1130753,145481],\"ancestors\":[1,2759,3193,3208,3214,3215,3216,3217,3218,33090,35493,114656,131221,131567,404260],\"id\":\"NCBITaxon:3218\",\"is_a\":[3217],\"name\":\"Physcomitrella patens\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":32273,\"parents\":[\"3217\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"Physcomitrella patens subsp. patens\",\"Physcomitrium patens\"],\"xref\":[\"GC_ID:1\",\"PMID:25015729\"]},{\"_id\":3244,\"ancestors\":[1,2759,3193,3244,33090,35493,58023,131221,131567,1521260],\"id\":\"NCBITaxon:3244\",\"is_a\":[1521260],\"name\":\"Selaginellales\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":34888,\"parents\":[\"1521260\"],\"property_value\":\"has_rank NCBITaxon:order\",\"synonym\":[\"spike mosses\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":3245,\"ancestors\":[1,2759,3193,3244,3245,33090,35493,58023,131221,131567,1521260],\"id\":\"NCBITaxon:3245\",\"is_a\":[3244],\"name\":\"Selaginellaceae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":34888,\"parents\":[\"3244\"],\"property_value\":\"has_rank NCBITaxon:family\",\"synonym\":[\"spike moss family\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":3246,\"ancestors\":[1,2759,3193,3244,3245,3246,33090,35493,58023,131221,131567,1521260],\"id\":\"NCBITaxon:3246\",\"is_a\":[3245],\"name\":\"Selaginella\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":34888,\"parents\":[\"3245\"],\"property_value\":\"has_rank NCBITaxon:genus\",\"xref\":[\"GC_ID:1\"]},{\"_id\":3398,\"ancestors\":[1,2759,3193,3398,33090,35493,58023,58024,78536,131221,131567],\"id\":\"NCBITaxon:3398\",\"is_a\":[58024],\"name\":\"Magnoliophyta\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":1474437,\"parents\":[\"58024\"],\"synonym\":[\"Angiospermae\",\"angiosperms\",\"flowering plants\",\"flowering plants\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":3602,\"alt_id\":[39206],\"ancestors\":[1,2759,3193,3398,3602,33090,35493,58023,58024,71240,71275,78536,91827,91834,131221,131567,403667,1437183,1437201],\"id\":\"NCBITaxon:3602\",\"is_a\":[403667],\"name\":\"Vitaceae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":29971,\"parents\":[\"403667\"],\"property_value\":\"has_rank NCBITaxon:family\",\"synonym\":[\"grape family\",\"Vitidaceae\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":3603,\"ancestors\":[1,2759,3193,3398,3602,3603,33090,35493,58023,58024,71240,71275,78536,91827,91834,131221,131567,403667,1437183,1437201],\"id\":\"NCBITaxon:3603\",\"is_a\":[3602],\"name\":\"Vitis\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":29971,\"parents\":[\"3602\"],\"property_value\":\"has_rank NCBITaxon:genus\",\"xref\":[\"GC_ID:1\"]},{\"_id\":3629,\"alt_id\":[3639,45192,45323],\"ancestors\":[1,2759,3193,3398,3629,33090,35493,41938,58023,58024,71240,71275,78536,91827,91836,131221,131567,1437183,1437201],\"id\":\"NCBITaxon:3629\",\"is_a\":[41938],\"name\":\"Malvaceae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":29188,\"parents\":[\"41938\"],\"property_value\":\"has_rank NCBITaxon:family\",\"synonym\":[\"mallow family\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":3640,\"ancestors\":[1,2759,3193,3398,3629,3640,33090,35493,41938,58023,58024,71240,71275,78536,91827,91836,131221,131567,214909,1437183,1437201],\"id\":\"NCBITaxon:3640\",\"is_a\":[214909],\"name\":\"Theobroma\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":29188,\"parents\":[\"214909\"],\"property_value\":\"has_rank NCBITaxon:genus\",\"xref\":[\"GC_ID:1\"]},{\"_id\":3641,\"ancestors\":[1,2759,3193,3398,3629,3640,3641,33090,35493,41938,58023,58024,71240,71275,78536,91827,91836,131221,131567,214909,1437183,1437201],\"id\":\"NCBITaxon:3641\",\"is_a\":[3640],\"name\":\"Theobroma cacao\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":29188,\"parents\":[\"3640\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"cacao\",\"chocolate\",\"cocoa\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":3646,\"alt_id\":[3976,40028,4003,4333,4385],\"ancestors\":[1,2759,3193,3398,3646,33090,35493,58023,58024,71240,71275,78536,91827,91835,131221,131567,1437183,1437201],\"id\":\"NCBITaxon:3646\",\"is_a\":[91835],\"name\":\"Malpighiales\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":41377,\"parents\":[\"91835\"],\"property_value\":\"has_rank NCBITaxon:order\",\"synonym\":[\"Violales\",\"Violanae\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":3688,\"alt_id\":[124995,45162],\"ancestors\":[1,2759,3193,3398,3646,3688,33090,35493,58023,58024,71240,71275,78536,91827,91835,131221,131567,1437183,1437201],\"id\":\"NCBITaxon:3688\",\"is_a\":[3646],\"name\":\"Salicaceae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":41377,\"parents\":[\"3646\"],\"property_value\":\"has_rank NCBITaxon:family\",\"synonym\":[\"Flacourtiaceae\",\"willow family\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":3689,\"alt_id\":[36505],\"ancestors\":[1,2759,3193,3398,3646,3688,3689,33090,35493,58023,58024,71240,71275,78536,91827,91835,131221,131567,238069,1437183,1437201],\"id\":\"NCBITaxon:3689\",\"is_a\":[238069],\"name\":\"Populus\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":41377,\"parents\":[\"238069\"],\"property_value\":\"has_rank NCBITaxon:genus\",\"synonym\":[\"poplar\",\"poplar trees\",\"poplars\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":3694,\"ancestors\":[1,2759,3193,3398,3646,3688,3689,3694,33090,35493,58023,58024,71240,71275,78536,91827,91835,131221,131567,238069,1437183,1437201],\"id\":\"NCBITaxon:3694\",\"is_a\":[3689],\"name\":\"Populus trichocarpa\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":41377,\"parents\":[\"3689\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"black cottonwood\",\"Populus balsamifera subsp. trichocarpa\",\"western balsam poplar\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":3699,\"ancestors\":[1,2759,3193,3398,3699,33090,35493,58023,58024,71240,71275,78536,91827,91836,131221,131567,1437183,1437201],\"id\":\"NCBITaxon:3699\",\"is_a\":[91836],\"name\":\"Brassicales\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":168340,\"parents\":[\"91836\"],\"property_value\":\"has_rank NCBITaxon:order\",\"synonym\":[\"Capparales\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":3700,\"alt_id\":[25773],\"ancestors\":[1,2759,3193,3398,3699,3700,33090,35493,58023,58024,71240,71275,78536,91827,91836,131221,131567,1437183,1437201],\"id\":\"NCBITaxon:3700\",\"is_a\":[3699],\"name\":\"Brassicaceae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":168340,\"parents\":[\"3699\"],\"property_value\":\"has_rank NCBITaxon:family\",\"synonym\":[\"Cruciferae\",\"mustard family\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":3701,\"alt_id\":[45250],\"ancestors\":[1,2759,3193,3398,3699,3700,3701,33090,35493,58023,58024,71240,71275,78536,91827,91836,131221,131567,980083,1437183,1437201],\"id\":\"NCBITaxon:3701\",\"is_a\":[980083],\"name\":\"Arabidopsis\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":66269,\"parents\":[\"980083\"],\"property_value\":\"has_rank NCBITaxon:genus\",\"synonym\":[\"Cardaminopsis\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":3702,\"ancestors\":[1,2759,3193,3398,3699,3700,3701,3702,33090,35493,58023,58024,71240,71275,78536,91827,91836,131221,131567,980083,1437183,1437201],\"id\":\"NCBITaxon:3702\",\"is_a\":[3701],\"name\":\"Arabidopsis thaliana\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":33602,\"parents\":[\"3701\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"Arabidopsis thaliana (thale cress)\",\"Arbisopsis thaliana\",\"mouse-ear cress\",\"thale cress\",\"thale-cress\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":3705,\"ancestors\":[1,2759,3193,3398,3699,3700,3705,33090,35493,58023,58024,71240,71275,78536,91827,91836,131221,131567,981071,1437183,1437201],\"id\":\"NCBITaxon:3705\",\"is_a\":[981071],\"name\":\"Brassica\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":102071,\"parents\":[\"981071\"],\"property_value\":\"has_rank NCBITaxon:genus\",\"xref\":[\"GC_ID:1\"]},{\"_id\":3711,\"alt_id\":[3706],\"ancestors\":[1,2759,3193,3398,3699,3700,3705,3711,33090,35493,58023,58024,71240,71275,78536,91827,91836,131221,131567,981071,1437183,1437201],\"id\":\"NCBITaxon:3711\",\"is_a\":[3705],\"name\":\"Brassica rapa\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":42846,\"parents\":[\"3705\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"field mustard\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":3712,\"ancestors\":[1,2759,3193,3398,3699,3700,3705,3712,33090,35493,58023,58024,71240,71275,78536,91827,91836,131221,131567,981071,1437183,1437201],\"id\":\"NCBITaxon:3712\",\"is_a\":[3705],\"name\":\"Brassica oleracea\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":59225,\"parents\":[\"3705\"],\"property_value\":\"has_rank NCBITaxon:species\",\"xref\":[\"GC_ID:1\"]},{\"_id\":3744,\"alt_id\":[3473,3601,4266],\"ancestors\":[1,2759,3193,3398,3744,33090,35493,58023,58024,71240,71275,78536,91827,91835,131221,131567,1437183,1437201],\"id\":\"NCBITaxon:3744\",\"is_a\":[91835],\"name\":\"Rosales\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":29499,\"parents\":[\"91835\"],\"property_value\":\"has_rank NCBITaxon:order\",\"xref\":[\"GC_ID:1\"]},{\"_id\":3745,\"ancestors\":[1,2759,3193,3398,3744,3745,33090,35493,58023,58024,71240,71275,78536,91827,91835,131221,131567,1437183,1437201],\"id\":\"NCBITaxon:3745\",\"is_a\":[3744],\"name\":\"Rosaceae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":29499,\"parents\":[\"3744\"],\"property_value\":\"has_rank NCBITaxon:family\",\"synonym\":[\"Malaceae\",\"rose family\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":3754,\"alt_id\":[140650,203800],\"ancestors\":[1,2759,3193,3398,3744,3745,3754,33090,35493,58023,58024,71240,71275,78536,91827,91835,131221,131567,171637,721805,1437183,1437201],\"id\":\"NCBITaxon:3754\",\"is_a\":[721805],\"name\":\"Prunus\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":29499,\"parents\":[\"721805\"],\"property_value\":\"has_rank NCBITaxon:genus\",\"xref\":[\"GC_ID:1\"]},{\"_id\":3760,\"alt_id\":[203801],\"ancestors\":[1,2759,3193,3398,3744,3745,3754,3760,33090,35493,58023,58024,71240,71275,78536,91827,91835,131221,131567,171637,721805,1437183,1437201],\"id\":\"NCBITaxon:3760\",\"is_a\":[3754],\"name\":\"Prunus persica\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":29499,\"parents\":[\"3754\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"Amygdalus persica\",\"peach\",\"Persica vulgaris\",\"Prunus persica var densa\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":3803,\"ancestors\":[1,2759,3193,3398,3803,33090,35493,58023,58024,71240,71275,72025,78536,91827,91835,131221,131567,1437183,1437201],\"id\":\"NCBITaxon:3803\",\"is_a\":[72025],\"name\":\"Fabaceae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":108247,\"parents\":[\"72025\"],\"property_value\":\"has_rank NCBITaxon:family\",\"synonym\":[\"Leguminosae\",\"pea family\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":3814,\"alt_id\":[24958],\"ancestors\":[1,2759,3193,3398,3803,3814,33090,35493,58023,58024,71240,71275,72025,78536,91827,91835,131221,131567,1437183,1437201],\"id\":\"NCBITaxon:3814\",\"is_a\":[3803],\"name\":\"Papilionoideae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":108247,\"parents\":[\"3803\"],\"property_value\":\"has_rank NCBITaxon:subfamily\",\"synonym\":[\"Faboideae\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":3846,\"ancestors\":[1,2759,3193,3398,3803,3814,3846,33090,35493,58023,58024,71240,71275,72025,78536,91827,91835,131221,131567,163735,1437183,1437201],\"id\":\"NCBITaxon:3846\",\"is_a\":[163735],\"name\":\"Glycine\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":54174,\"parents\":[\"163735\"],\"property_value\":\"has_rank NCBITaxon:genus\",\"xref\":[\"GC_ID:1\"]},{\"_id\":3847,\"ancestors\":[1,2759,3193,3398,3803,3814,3846,3847,33090,35493,58023,58024,71240,71275,72025,78536,91827,91835,131221,131567,163735,1437183,1437201,1462606],\"id\":\"NCBITaxon:3847\",\"is_a\":[1462606],\"name\":\"Glycine max\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":54174,\"parents\":[\"1462606\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"Glycine max; cv. Wye\",\"soybean\",\"soybeans\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":3877,\"ancestors\":[1,2759,3193,3398,3803,3814,3877,33090,35493,58023,58024,71240,71275,72025,78536,91827,91835,131221,131567,163742,1437183,1437201],\"id\":\"NCBITaxon:3877\",\"is_a\":[163742],\"name\":\"Medicago\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":54073,\"parents\":[\"163742\"],\"property_value\":\"has_rank NCBITaxon:genus\",\"synonym\":[\"medics\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":3880,\"ancestors\":[1,2759,3193,3398,3803,3814,3877,3880,33090,35493,58023,58024,71240,71275,72025,78536,91827,91835,131221,131567,163742,1437183,1437201],\"id\":\"NCBITaxon:3880\",\"is_a\":[3877],\"name\":\"Medicago truncatula\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":54073,\"parents\":[\"3877\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"barrel medic\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":4069,\"alt_id\":[41936],\"ancestors\":[1,2759,3193,3398,4069,33090,35493,58023,58024,71240,71274,78536,91827,91888,131221,131567,1437183,1437201],\"id\":\"NCBITaxon:4069\",\"is_a\":[91888],\"name\":\"Solanales\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":81709,\"parents\":[\"91888\"],\"property_value\":\"has_rank NCBITaxon:order\",\"synonym\":[\"Solananae\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":4070,\"alt_id\":[40319],\"ancestors\":[1,2759,3193,3398,4069,4070,33090,35493,58023,58024,71240,71274,78536,91827,91888,131221,131567,1437183,1437201],\"id\":\"NCBITaxon:4070\",\"is_a\":[4069],\"name\":\"Solanaceae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":81709,\"parents\":[\"4069\"],\"property_value\":\"has_rank NCBITaxon:family\",\"synonym\":[\"nightshade family\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":4081,\"alt_id\":[195582],\"ancestors\":[1,2759,3193,3398,4069,4070,4081,4107,33090,35493,49274,58023,58024,71240,71274,78536,91827,91888,131221,131567,424551,424574,1437183,1437201],\"id\":\"NCBITaxon:4081\",\"is_a\":[49274],\"name\":\"Solanum lycopersicum\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":38735,\"parents\":[\"49274\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"Lycopersicon esculentum\",\"Lycopersicon esculentum var. esculentum\",\"Lycopersicon lycopersicum\",\"Lycopersicum esculentum\",\"Solanum esculentum\",\"Solanum lycopersicon\",\"tomato\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":4107,\"alt_id\":[4080,49275],\"ancestors\":[1,2759,3193,3398,4069,4070,4107,33090,35493,58023,58024,71240,71274,78536,91827,91888,131221,131567,424551,424574,1437183,1437201],\"id\":\"NCBITaxon:4107\",\"is_a\":[424574],\"name\":\"Solanum\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":81709,\"parents\":[\"424574\"],\"property_value\":\"has_rank NCBITaxon:genus\",\"xref\":[\"GC_ID:1\"]},{\"_id\":4113,\"alt_id\":[90692],\"ancestors\":[1,2759,3193,3398,4069,4070,4107,4113,33090,35493,58023,58024,71240,71274,78536,91827,91888,131221,131567,424551,424574,1437183,1437201],\"id\":\"NCBITaxon:4113\",\"is_a\":[4107],\"name\":\"Solanum tuberosum\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":42974,\"parents\":[\"4107\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"potato\",\"potatoes\",\"Solanum tuberosum subsp. tuberosum\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":4447,\"ancestors\":[1,2759,3193,3398,4447,33090,35493,58023,58024,78536,131221,131567,1437183],\"id\":\"NCBITaxon:4447\",\"is_a\":[1437183],\"name\":\"Liliopsida\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":957385,\"parents\":[\"1437183\"],\"property_value\":\"has_rank NCBITaxon:class\",\"synonym\":[\"monocots\",\"monocots\",\"Monocotyledoneae\",\"monocotyledons\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":4479,\"alt_id\":[1661618],\"ancestors\":[1,2759,3193,3398,4447,4479,4734,33090,35493,38820,58023,58024,78536,131221,131567,1437183,1437197],\"id\":\"NCBITaxon:4479\",\"is_a\":[38820],\"name\":\"Poaceae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":919806,\"parents\":[\"38820\"],\"property_value\":\"has_rank NCBITaxon:family\",\"synonym\":[\"Bambusaceae\",\"Gramineae\",\"grass family\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":4480,\"alt_id\":[37875,58864,72405],\"ancestors\":[1,2759,3193,3398,4447,4479,4480,4734,33090,35493,38820,58023,58024,78536,131221,131567,147368,147389,359160,1437183,1437197,1648030,1648038],\"id\":\"NCBITaxon:4480\",\"is_a\":[1648030],\"name\":\"Aegilops\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":37035,\"parents\":[\"1648030\"],\"property_value\":\"has_rank NCBITaxon:genus\",\"synonym\":[\"Aegilops L.\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":4512,\"ancestors\":[1,2759,3193,3398,4447,4479,4512,4734,33090,35493,38820,58023,58024,78536,131221,131567,147368,147389,359160,1437183,1437197,1648017,1648038],\"id\":\"NCBITaxon:4512\",\"is_a\":[1648017],\"name\":\"Hordeum\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":26067,\"parents\":[\"1648017\"],\"property_value\":\"has_rank NCBITaxon:genus\",\"synonym\":[\"barleys\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":4513,\"alt_id\":[36528],\"ancestors\":[1,2759,3193,3398,4447,4479,4512,4513,4734,33090,35493,38820,58023,58024,78536,131221,131567,147368,147389,359160,1437183,1437197,1648017,1648038],\"id\":\"NCBITaxon:4513\",\"is_a\":[4512],\"name\":\"Hordeum vulgare\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":26067,\"parents\":[\"4512\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"barley\",\"Horedum vulgare\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":4527,\"alt_id\":[77587],\"ancestors\":[1,2759,3193,3398,4447,4479,4527,4734,33090,35493,38820,58023,58024,78536,131221,131567,147367,147380,359160,1437183,1437197,1648021],\"id\":\"NCBITaxon:4527\",\"is_a\":[1648021],\"name\":\"Oryza\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":539774,\"parents\":[\"1648021\"],\"property_value\":\"has_rank NCBITaxon:genus\",\"xref\":[\"GC_ID:1\"]},{\"_id\":4528,\"ancestors\":[1,2759,3193,3398,4447,4479,4527,4528,4734,33090,35493,38820,58023,58024,78536,131221,131567,147367,147380,359160,1437183,1437197,1648021],\"id\":\"NCBITaxon:4528\",\"is_a\":[4527],\"name\":\"Oryza longistaminata\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":29974,\"parents\":[\"4527\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"long-staminate rice\",\"red rice\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":4529,\"ancestors\":[1,2759,3193,3398,4447,4479,4527,4529,4734,33090,35493,38820,58023,58024,78536,131221,131567,147367,147380,359160,1437183,1437197,1648021],\"id\":\"NCBITaxon:4529\",\"is_a\":[4527],\"name\":\"Oryza rufipogon\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":39799,\"parents\":[\"4527\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"common wild rice\",\"red rice\"],\"xref\":[\"GC_ID:1\",\"PMID:15654106\",\"PMID:17617555\",\"PMID:17907810\"]},{\"_id\":4530,\"alt_id\":[389215],\"ancestors\":[1,2759,3193,3398,4447,4479,4527,4530,4734,33090,35493,38820,58023,58024,78536,131221,131567,147367,147380,359160,1437183,1437197,1648021],\"id\":\"NCBITaxon:4530\",\"is_a\":[4527],\"name\":\"Oryza sativa\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":179518,\"parents\":[\"4527\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"red rice\",\"rice\"],\"xref\":[\"GC_ID:1\",\"PMID:15654106\",\"PMID:17617555\",\"PMID:17907810\",\"PMID:19706531\"]},{\"_id\":4533,\"ancestors\":[1,2759,3193,3398,4447,4479,4527,4533,4734,33090,35493,38820,58023,58024,78536,131221,131567,147367,147380,359160,1437183,1437197,1648021],\"id\":\"NCBITaxon:4533\",\"is_a\":[4527],\"name\":\"Oryza brachyantha\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":34155,\"parents\":[\"4527\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"malo sina\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":4536,\"ancestors\":[1,2759,3193,3398,4447,4479,4527,4536,4734,33090,35493,38820,58023,58024,78536,131221,131567,147367,147380,359160,1437183,1437197,1648021],\"id\":\"NCBITaxon:4536\",\"is_a\":[4527],\"name\":\"Oryza nivara\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":37985,\"parents\":[\"4527\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"Oryza nivarra\",\"Oryza sativa f. spontanea\",\"Oryza sativa f. spontanea Roshev. nom. illeg.\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":4537,\"ancestors\":[1,2759,3193,3398,4447,4479,4527,4537,4734,33090,35493,38820,58023,58024,78536,131221,131567,147367,147380,359160,1437183,1437197,1648021],\"id\":\"NCBITaxon:4537\",\"is_a\":[4527],\"name\":\"Oryza punctata\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":36957,\"parents\":[\"4527\"],\"property_value\":\"has_rank NCBITaxon:species\",\"xref\":[\"GC_ID:1\"]},{\"_id\":4538,\"ancestors\":[1,2759,3193,3398,4447,4479,4527,4538,4734,33090,35493,38820,58023,58024,78536,131221,131567,147367,147380,359160,1437183,1437197,1648021],\"id\":\"NCBITaxon:4538\",\"is_a\":[4527],\"name\":\"Oryza glaberrima\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":73878,\"parents\":[\"4527\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"African rice\"],\"xref\":[\"GC_ID:1\",\"PMID:17617555\"]},{\"_id\":4554,\"ancestors\":[1,2759,3193,3398,4447,4479,4554,4734,33090,35493,38820,58023,58024,78536,131221,131567,147369,147370,147428,1293361,1437183,1437197,1648036],\"id\":\"NCBITaxon:4554\",\"is_a\":[1293361],\"name\":\"Setaria <grass>\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":35471,\"parents\":[\"1293361\"],\"property_value\":\"has_rank NCBITaxon:genus\",\"synonym\":[\"Setaria\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":4555,\"ancestors\":[1,2759,3193,3398,4447,4479,4554,4555,4734,33090,35493,38820,58023,58024,78536,131221,131567,147369,147370,147428,1293361,1437183,1437197,1648036],\"id\":\"NCBITaxon:4555\",\"is_a\":[4554],\"name\":\"Setaria italica\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":35471,\"parents\":[\"4554\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"Chaetochloa italica\",\"foxtail millet\",\"Panicum italicum\",\"Setaria viridis subsp. italica\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":4557,\"ancestors\":[1,2759,3193,3398,4447,4479,4557,4734,33090,35493,38820,58023,58024,78536,131221,131567,147369,147370,147429,1437183,1437197,1648028,1648033],\"id\":\"NCBITaxon:4557\",\"is_a\":[1648028],\"name\":\"Sorghum\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":34567,\"parents\":[\"1648028\"],\"property_value\":\"has_rank NCBITaxon:genus\",\"xref\":[\"GC_ID:1\"]},{\"_id\":4564,\"ancestors\":[1,2759,3193,3398,4447,4479,4564,4734,33090,35493,38820,58023,58024,78536,131221,131567,147368,147389,359160,1437183,1437197,1648030,1648038],\"id\":\"NCBITaxon:4564\",\"is_a\":[1648030],\"name\":\"Triticum\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":150100,\"parents\":[\"1648030\"],\"property_value\":\"has_rank NCBITaxon:genus\",\"xref\":[\"GC_ID:1\"]},{\"_id\":131567,\"ancestors\":[1,131567],\"id\":\"NCBITaxon:131567\",\"is_a\":[1],\"name\":\"cellular organisms\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":1568831,\"parents\":[\"1\"],\"synonym\":[\"biota\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":4558,\"ancestors\":[1,2759,3193,3398,4447,4479,4557,4558,4734,33090,35493,38820,58023,58024,78536,131221,131567,147369,147370,147429,1437183,1437197,1648028,1648033],\"id\":\"NCBITaxon:4558\",\"is_a\":[4557],\"name\":\"Sorghum bicolor\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":34567,\"parents\":[\"4557\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"Andropogon sorghum\",\"broomcorn\",\"milo\",\"sorghum\",\"Sorghum bicolor milo\",\"Sorghum bicolor subsp. bicolor\",\"Sorghum nervosum\",\"Sorghum saccharatum\",\"Sorghum vulgare\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":4565,\"alt_id\":[235075,39424],\"ancestors\":[1,2759,3193,3398,4447,4479,4564,4565,4734,33090,35493,38820,58023,58024,78536,131221,131567,147368,147389,359160,1437183,1437197,1648030,1648038],\"id\":\"NCBITaxon:4565\",\"is_a\":[4564],\"name\":\"Triticum aestivum\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":112496,\"parents\":[\"4564\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"bread wheat\",\"Canadian hard winter wheat\",\"common wheat\",\"Tricum aestivum\",\"Triticum aestivam\",\"Triticum aestivum subsp. aestivum\",\"Triticum aestivum8\",\"Triticum vulgare\",\"wheat\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":4572,\"ancestors\":[1,2759,3193,3398,4447,4479,4564,4572,4734,33090,35493,38820,58023,58024,78536,131221,131567,147368,147389,359160,1437183,1437197,1648030,1648038],\"id\":\"NCBITaxon:4572\",\"is_a\":[4564],\"name\":\"Triticum urartu\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":37604,\"parents\":[\"4564\"],\"property_value\":\"has_rank NCBITaxon:species\",\"xref\":[\"GC_ID:1\"]},{\"_id\":4575,\"ancestors\":[1,2759,3193,3398,4447,4479,4575,4734,33090,35493,38820,58023,58024,78536,131221,131567,147369,147370,147429,1437183,1437197,1648029,1648033],\"id\":\"NCBITaxon:4575\",\"is_a\":[1648029],\"name\":\"Zea\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":39625,\"parents\":[\"1648029\"],\"property_value\":\"has_rank NCBITaxon:genus\",\"synonym\":[\"Euchlaena\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":4577,\"alt_id\":[4578],\"ancestors\":[1,2759,3193,3398,4447,4479,4575,4577,4734,33090,35493,38820,58023,58024,78536,131221,131567,147369,147370,147429,1437183,1437197,1648029,1648033],\"id\":\"NCBITaxon:4577\",\"is_a\":[4575],\"name\":\"Zea mays\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":39625,\"parents\":[\"4575\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"maize\",\"Zea mays mays\",\"Zea mays var. japonica\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":4618,\"alt_id\":[40513],\"ancestors\":[1,2759,3193,3398,4447,4618,4734,33090,35493,58023,58024,78536,131221,131567,1437183,1437197],\"id\":\"NCBITaxon:4618\",\"is_a\":[4734],\"name\":\"Zingiberales\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":37579,\"parents\":[\"4734\"],\"property_value\":\"has_rank NCBITaxon:order\",\"synonym\":[\"Scitamineae\",\"Zingiberiflorae\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":4637,\"ancestors\":[1,2759,3193,3398,4447,4618,4637,4734,33090,35493,58023,58024,78536,131221,131567,1437183,1437197],\"id\":\"NCBITaxon:4637\",\"is_a\":[4618],\"name\":\"Musaceae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":37579,\"parents\":[\"4618\"],\"property_value\":\"has_rank NCBITaxon:family\",\"synonym\":[\"banana family\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":4640,\"ancestors\":[1,2759,3193,3398,4447,4618,4637,4640,4734,33090,35493,58023,58024,78536,131221,131567,1437183,1437197],\"id\":\"NCBITaxon:4640\",\"is_a\":[4637],\"name\":\"Musa\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":37579,\"parents\":[\"4637\"],\"property_value\":\"has_rank NCBITaxon:genus\",\"xref\":[\"GC_ID:1\"]},{\"_id\":4641,\"alt_id\":[214695],\"ancestors\":[1,2759,3193,3398,4447,4618,4637,4640,4641,4734,33090,35493,58023,58024,78536,131221,131567,1437183,1437197],\"id\":\"NCBITaxon:4641\",\"is_a\":[4640],\"name\":\"Musa acuminata\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":37579,\"parents\":[\"4640\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"banana\",\"dessert bananas\",\"dwarf banana\",\"Musa AA Group\",\"Musa accumunata\",\"Musa acuminata AA Group\",\"Musa nana\",\"sweet banana\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":4734,\"ancestors\":[1,2759,3193,3398,4447,4734,33090,35493,58023,58024,78536,131221,131567,1437183,1437197],\"id\":\"NCBITaxon:4734\",\"is_a\":[1437197],\"name\":\"commelinids\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":957385,\"parents\":[\"1437197\"],\"property_value\":\"has_rank NCBITaxon:subclass\",\"synonym\":[\"Commelinidae\",\"Commeliniflorae\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":13332,\"ancestors\":[1,2759,3193,3398,13332,22097,33090,35493,58023,58024,78536,131221,131567,232365,261009],\"id\":\"NCBITaxon:13332\",\"is_a\":[22097],\"name\":\"Amborella\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":28721,\"parents\":[\"22097\"],\"property_value\":\"has_rank NCBITaxon:genus\",\"xref\":[\"GC_ID:1\"]},{\"_id\":13333,\"ancestors\":[1,2759,3193,3398,13332,13333,22097,33090,35493,58023,58024,78536,131221,131567,232365,261009],\"id\":\"NCBITaxon:13333\",\"is_a\":[13332],\"name\":\"Amborella trichopoda\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":28721,\"parents\":[\"13332\"],\"property_value\":\"has_rank NCBITaxon:species\",\"xref\":[\"GC_ID:1\"]},{\"_id\":13792,\"ancestors\":[1,2759,3041,3152,13792,33090,131567,1035538],\"id\":\"NCBITaxon:13792\",\"is_a\":[1035538],\"name\":\"Mamiellales\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":7640,\"parents\":[\"1035538\"],\"property_value\":\"has_rank NCBITaxon:order\",\"xref\":[\"GC_ID:1\"]},{\"_id\":15367,\"ancestors\":[1,2759,3193,3398,4447,4479,4734,15367,33090,35493,38820,58023,58024,78536,131221,131567,147368,147385,359160,1437183,1437197],\"id\":\"NCBITaxon:15367\",\"is_a\":[147385],\"name\":\"Brachypodium\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":26552,\"parents\":[\"147385\"],\"property_value\":\"has_rank NCBITaxon:genus\",\"synonym\":[\"false bromes\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":15368,\"ancestors\":[1,2759,3193,3398,4447,4479,4734,15367,15368,33090,35493,38820,58023,58024,78536,131221,131567,147368,147385,359160,1437183,1437197],\"id\":\"NCBITaxon:15368\",\"is_a\":[15367],\"name\":\"Brachypodium distachyon\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":26552,\"parents\":[\"15367\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"annual false brome\",\"false brome\",\"purple false brome\",\"stiff brome\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":22097,\"ancestors\":[1,2759,3193,3398,22097,33090,35493,58023,58024,78536,131221,131567,232365,261009],\"id\":\"NCBITaxon:22097\",\"is_a\":[261009],\"name\":\"Amborellaceae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":28721,\"parents\":[\"261009\"],\"property_value\":\"has_rank NCBITaxon:family\",\"xref\":[\"GC_ID:1\"]},{\"_id\":29760,\"ancestors\":[1,2759,3193,3398,3602,3603,29760,33090,35493,58023,58024,71240,71275,78536,91827,91834,131221,131567,403667,1437183,1437201],\"id\":\"NCBITaxon:29760\",\"is_a\":[3603],\"name\":\"Vitis vinifera\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":29971,\"parents\":[\"3603\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"Vitis vinifera subsp. vinifera\",\"wine grape\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":33090,\"ancestors\":[1,2759,33090,131567],\"id\":\"NCBITaxon:33090\",\"is_a\":[2759],\"name\":\"Viridiplantae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":1563725,\"parents\":[\"2759\"],\"property_value\":\"has_rank NCBITaxon:kingdom\",\"synonym\":[\"Chlorobionta\",\"Chlorophyta/Embryophyta group\",\"chlorophyte/embryophyte group\",\"green plants\",\"green plants\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":35493,\"ancestors\":[1,2759,33090,35493,131567],\"id\":\"NCBITaxon:35493\",\"is_a\":[33090],\"name\":\"Streptophyta\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":1541598,\"parents\":[\"33090\"],\"property_value\":\"has_rank NCBITaxon:phylum\",\"xref\":[\"GC_ID:1\"]},{\"_id\":35711,\"ancestors\":[1,2759,3193,3398,4447,4479,4734,33090,35493,35711,38820,58023,58024,78536,131221,131567,147367,147380,359160,1437183,1437197,1648021],\"id\":\"NCBITaxon:35711\",\"is_a\":[1648021],\"name\":\"Leersia\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":30615,\"parents\":[\"1648021\"],\"property_value\":\"has_rank NCBITaxon:genus\",\"synonym\":[\"cutgrass\",\"white grass\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":37682,\"alt_id\":[40669,4482,70688],\"ancestors\":[1,2759,3193,3398,4447,4479,4480,4734,33090,35493,37682,38820,58023,58024,78536,131221,131567,147368,147389,359160,1437183,1437197,1648030,1648038],\"id\":\"NCBITaxon:37682\",\"is_a\":[4480],\"name\":\"Aegilops tauschii\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":37035,\"parents\":[\"4480\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"Aegilops squarrosa\",\"Aegilops squarrosa auct., non L.\",\"Aegilops squarrosa subsp. squarrosa\",\"Aegilopsm tauschii\",\"Patropyrum tauschii\",\"Patropyrum tauschii subsp. tauschii\",\"Triticum aegilops\",\"Triticum tauschii\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":38820,\"alt_id\":[4478,4727],\"ancestors\":[1,2759,3193,3398,4447,4734,33090,35493,38820,58023,58024,78536,131221,131567,1437183,1437197],\"id\":\"NCBITaxon:38820\",\"is_a\":[4734],\"name\":\"Poales\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":919806,\"parents\":[\"4734\"],\"property_value\":\"has_rank NCBITaxon:order\",\"xref\":[\"GC_ID:1\"]},{\"_id\":39946,\"ancestors\":[1,2759,3193,3398,4447,4479,4527,4530,4734,33090,35493,38820,39946,58023,58024,78536,131221,131567,147367,147380,359160,1437183,1437197,1648021],\"id\":\"NCBITaxon:39946\",\"is_a\":[4530],\"name\":\"Oryza sativa Indica Group\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":88438,\"parents\":[\"4530\"],\"synonym\":[\"Indian rice\",\"Indica rice\",\"long-grained rice\",\"Oryza sativa (indica cultivar-group)\",\"Oryza sativa (indica group)\",\"Oryza sativa indica\",\"Oryza sativa ssp. indica\",\"Oryza sativa subsp. indica\"],\"xref\":[\"GC_ID:1\",\"PMID:15654106\",\"PMID:17617555\",\"PMID:17907810\",\"PMID:19706531\"]},{\"_id\":39947,\"ancestors\":[1,2759,3193,3398,4447,4479,4527,4530,4734,33090,35493,38820,39947,58023,58024,78536,131221,131567,147367,147380,359160,1437183,1437197,1648021],\"id\":\"NCBITaxon:39947\",\"is_a\":[4530],\"name\":\"Oryza sativa Japonica Group\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":91080,\"parents\":[\"4530\"],\"synonym\":[\"Japanese rice\",\"Japonica rice\",\"Oryza sativa (japonica culticar-group)\",\"Oryza sativa (japonica cultivar-group)\",\"Oryza sativa japonica\",\"Oryza sativa subsp. japonica\"],\"xref\":[\"GC_ID:1\",\"PMID:15654106\",\"PMID:17617555\",\"PMID:17907810\",\"PMID:19706531\"]},{\"_id\":40148,\"ancestors\":[1,2759,3193,3398,4447,4479,4527,4734,33090,35493,38820,40148,58023,58024,78536,131221,131567,147367,147380,359160,1437183,1437197,1648021],\"id\":\"NCBITaxon:40148\",\"is_a\":[4527],\"name\":\"Oryza glumipatula\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":39018,\"parents\":[\"4527\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"Oryza glumaepatula\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":40149,\"ancestors\":[1,2759,3193,3398,4447,4479,4527,4734,33090,35493,38820,40149,58023,58024,78536,131221,131567,147367,147380,359160,1437183,1437197,1648021],\"id\":\"NCBITaxon:40149\",\"is_a\":[4527],\"name\":\"Oryza meridionalis\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":31591,\"parents\":[\"4527\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"Oryza meridionales\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":41938,\"alt_id\":[3628],\"ancestors\":[1,2759,3193,3398,33090,35493,41938,58023,58024,71240,71275,78536,91827,91836,131221,131567,1437183,1437201],\"id\":\"NCBITaxon:41938\",\"is_a\":[91836],\"name\":\"Malvales\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":29188,\"parents\":[\"91836\"],\"property_value\":\"has_rank NCBITaxon:order\",\"synonym\":[\"Malvanae\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":45156,\"ancestors\":[1,2759,2763,2797,45156,131567,265316,265318],\"id\":\"NCBITaxon:45156\",\"is_a\":[265316],\"name\":\"Cyanidioschyzon\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":5106,\"parents\":[\"265316\"],\"property_value\":\"has_rank NCBITaxon:genus\",\"xref\":[\"GC_ID:1\"]},{\"_id\":45157,\"ancestors\":[1,2759,2763,2797,45156,45157,131567,265316,265318],\"id\":\"NCBITaxon:45157\",\"is_a\":[45156],\"name\":\"Cyanidioschyzon merolae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":5106,\"parents\":[\"45156\"],\"property_value\":\"has_rank NCBITaxon:species\",\"xref\":[\"GC_ID:1\"]},{\"_id\":49274,\"ancestors\":[1,2759,3193,3398,4069,4070,4107,33090,35493,49274,58023,58024,71240,71274,78536,91827,91888,131221,131567,424551,424574,1437183,1437201],\"id\":\"NCBITaxon:49274\",\"is_a\":[4107],\"name\":\"Lycopersicon\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":38735,\"parents\":[\"4107\"],\"property_value\":\"has_rank NCBITaxon:subgenus\",\"synonym\":[\"Lycopersicon (Mill.) Seithe\",\"Lycopersicum\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":51351,\"ancestors\":[1,2759,3193,3398,3699,3700,3705,3711,33090,35493,51351,58023,58024,71240,71275,78536,91827,91836,131221,131567,981071,1437183,1437201],\"id\":\"NCBITaxon:51351\",\"is_a\":[3711],\"name\":\"Brassica rapa subsp. pekinensis\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":42846,\"parents\":[\"3711\"],\"property_value\":\"has_rank NCBITaxon:subspecies\",\"synonym\":[\"bai cai\",\"Brassica campestris (Pekinensis Group)\",\"Brassica campestris ssp. pekinensis\",\"Brassica campestris subsp. pekinensis\",\"Brassica campestris var. pekinensis\",\"Brassica pekinensis\",\"Brassica rapa Chinese Cabbage Group\",\"Brassica rapa ssp. pekinensis\",\"Brassica rapa var. glabra\",\"celery cabbage\",\"Chinese cabbage\",\"pe-tsai\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":58023,\"ancestors\":[1,2759,3193,33090,35493,58023,131221,131567],\"id\":\"NCBITaxon:58023\",\"is_a\":[3193],\"name\":\"Tracheophyta\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":1509325,\"parents\":[\"3193\"],\"synonym\":[\"vascular plants\",\"vascular plants\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":58024,\"ancestors\":[1,2759,3193,33090,35493,58023,58024,78536,131221,131567],\"id\":\"NCBITaxon:58024\",\"is_a\":[78536],\"name\":\"Spermatophyta\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":1474437,\"parents\":[\"78536\"],\"synonym\":[\"seed plants\",\"seed plants\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":59689,\"alt_id\":[63679],\"ancestors\":[1,2759,3193,3398,3699,3700,3701,33090,35493,58023,58024,59689,71240,71275,78536,91827,91836,131221,131567,980083,1437183,1437201],\"id\":\"NCBITaxon:59689\",\"is_a\":[3701],\"name\":\"Arabidopsis lyrata\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":32667,\"parents\":[\"3701\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"lyrate rockcress\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":65489,\"ancestors\":[1,2759,3193,3398,4447,4479,4527,4734,33090,35493,38820,58023,58024,65489,78536,131221,131567,147367,147380,359160,1437183,1437197,1648021],\"id\":\"NCBITaxon:65489\",\"is_a\":[4527],\"name\":\"Oryza barthii\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":36899,\"parents\":[\"4527\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"African wild rice\",\"Oryza breviligulata\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":70447,\"ancestors\":[1,2759,3041,3152,13792,33090,70447,131567,1035538,1525212],\"id\":\"NCBITaxon:70447\",\"is_a\":[1525212],\"name\":\"Ostreococcus\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":7640,\"parents\":[\"1525212\"],\"property_value\":\"has_rank NCBITaxon:genus\",\"xref\":[\"GC_ID:1\"]},{\"_id\":71240,\"alt_id\":[3399],\"ancestors\":[1,2759,3193,3398,33090,35493,58023,58024,71240,78536,131221,131567,1437183],\"id\":\"NCBITaxon:71240\",\"is_a\":[1437183],\"name\":\"eudicotyledons\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":488331,\"parents\":[\"1437183\"],\"synonym\":[\"dicots\",\"Dicotyledoneae\",\"dicotyledons\",\"eudicots\",\"Magnoliopsida\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":71274,\"ancestors\":[1,2759,3193,3398,33090,35493,58023,58024,71240,71274,78536,91827,131221,131567,1437183,1437201],\"id\":\"NCBITaxon:71274\",\"is_a\":[1437201],\"name\":\"asterids\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":81709,\"parents\":[\"1437201\"],\"property_value\":\"has_rank NCBITaxon:subclass\",\"synonym\":[\"Asteridae\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":71275,\"ancestors\":[1,2759,3193,3398,33090,35493,58023,58024,71240,71275,78536,91827,131221,131567,1437183,1437201],\"id\":\"NCBITaxon:71275\",\"is_a\":[1437201],\"name\":\"rosids\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":406622,\"parents\":[\"1437201\"],\"property_value\":\"has_rank NCBITaxon:subclass\",\"synonym\":[\"Rosidae\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":72025,\"ancestors\":[1,2759,3193,3398,33090,35493,58023,58024,71240,71275,72025,78536,91827,91835,131221,131567,1437183,1437201],\"id\":\"NCBITaxon:72025\",\"is_a\":[91835],\"name\":\"Fabales\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":108247,\"parents\":[\"91835\"],\"property_value\":\"has_rank NCBITaxon:order\",\"xref\":[\"GC_ID:1\"]},{\"_id\":77586,\"ancestors\":[1,2759,3193,3398,4447,4479,4734,33090,35493,35711,38820,58023,58024,77586,78536,131221,131567,147367,147380,359160,1437183,1437197,1648021],\"id\":\"NCBITaxon:77586\",\"is_a\":[35711],\"name\":\"Leersia perrieri\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":30615,\"parents\":[\"35711\"],\"property_value\":\"has_rank NCBITaxon:species\",\"xref\":[\"GC_ID:1\"]},{\"_id\":78536,\"ancestors\":[1,2759,3193,33090,35493,58023,78536,131221,131567],\"id\":\"NCBITaxon:78536\",\"is_a\":[58023],\"name\":\"Euphyllophyta\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":1474437,\"parents\":[\"58023\"],\"synonym\":[\"euphyllophytes\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":81972,\"ancestors\":[1,2759,3193,3398,3699,3700,3701,33090,35493,58023,58024,59689,71240,71275,78536,81972,91827,91836,131221,131567,980083,1437183,1437201],\"id\":\"NCBITaxon:81972\",\"is_a\":[59689],\"name\":\"Arabidopsis lyrata subsp. lyrata\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":32667,\"parents\":[\"59689\"],\"property_value\":\"has_rank NCBITaxon:subspecies\",\"synonym\":[\"Arabis lyrata\",\"Arabis lyrata subsp. lyrata\",\"Cardaminopsis lyrata\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":88036,\"ancestors\":[1,2759,3193,3244,3245,3246,33090,35493,58023,88036,131221,131567,1521260],\"id\":\"NCBITaxon:88036\",\"is_a\":[3246],\"name\":\"Selaginella moellendorffii\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":34888,\"parents\":[\"3246\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"Selaginella moellendorfii\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":91827,\"alt_id\":[1437200],\"ancestors\":[1,2759,3193,3398,33090,35493,58023,58024,71240,78536,91827,131221,131567,1437183],\"id\":\"NCBITaxon:91827\",\"is_a\":[71240],\"name\":\"Gunneridae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":488331,\"parents\":[\"71240\"],\"synonym\":[\"core eudicots\",\"core eudicotyledons\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":91834,\"alt_id\":[72024],\"ancestors\":[1,2759,3193,3398,33090,35493,58023,58024,71240,71275,78536,91827,91834,131221,131567,1437183,1437201],\"id\":\"NCBITaxon:91834\",\"is_a\":[71275],\"name\":\"rosids incertae sedis\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":29971,\"parents\":[\"71275\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":91835,\"alt_id\":[41939,4293],\"ancestors\":[1,2759,3193,3398,33090,35493,58023,58024,71240,71275,78536,91827,91835,131221,131567,1437183,1437201],\"id\":\"NCBITaxon:91835\",\"is_a\":[71275],\"name\":\"fabids\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":179123,\"parents\":[\"71275\"],\"synonym\":[\"eurosids I\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":91836,\"ancestors\":[1,2759,3193,3398,33090,35493,58023,58024,71240,71275,78536,91827,91836,131221,131567,1437183,1437201],\"id\":\"NCBITaxon:91836\",\"is_a\":[71275],\"name\":\"malvids\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":197528,\"parents\":[\"71275\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":91888,\"alt_id\":[41935],\"ancestors\":[1,2759,3193,3398,33090,35493,58023,58024,71240,71274,78536,91827,91888,131221,131567,1437183,1437201],\"id\":\"NCBITaxon:91888\",\"is_a\":[71274],\"name\":\"lamiids\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":81709,\"parents\":[\"71274\"],\"synonym\":[\"euasterids I\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":109376,\"ancestors\":[1,2759,3193,3398,3699,3700,3705,3712,33090,35493,58023,58024,71240,71275,78536,91827,91836,109376,131221,131567,981071,1437183,1437201],\"id\":\"NCBITaxon:109376\",\"is_a\":[3712],\"name\":\"Brassica oleracea var. oleracea\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":59225,\"parents\":[\"3712\"],\"property_value\":\"has_rank NCBITaxon:varietas\",\"synonym\":[\"Brassica oleracea subsp. oleracea\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":112509,\"alt_id\":[4514],\"ancestors\":[1,2759,3193,3398,4447,4479,4512,4513,4734,33090,35493,38820,58023,58024,78536,112509,131221,131567,147368,147389,359160,1437183,1437197,1648017,1648038],\"id\":\"NCBITaxon:112509\",\"is_a\":[4513],\"name\":\"Hordeum vulgare subsp. vulgare\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":26067,\"parents\":[\"4513\"],\"property_value\":\"has_rank NCBITaxon:subspecies\",\"synonym\":[\"barley\",\"domesticated barley\",\"Hordeum sativum\",\"Hordeum vulgare var. nudum\",\"Hordeum vulgare var. vulgare\",\"two-rowed barley\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":114656,\"ancestors\":[1,2759,3193,3208,3214,33090,35493,114656,131221,131567,404260],\"id\":\"NCBITaxon:114656\",\"is_a\":[3214],\"name\":\"Funariidae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":32273,\"parents\":[\"3214\"],\"property_value\":\"has_rank NCBITaxon:subclass\",\"xref\":[\"GC_ID:1\"]},{\"_id\":131221,\"ancestors\":[1,2759,33090,35493,131221,131567],\"id\":\"NCBITaxon:131221\",\"is_a\":[35493],\"name\":\"Streptophytina\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":1541598,\"parents\":[\"35493\"],\"synonym\":[\"Charophyta/Embryophyta group\",\"charophyte/embryophyte group\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":147367,\"alt_id\":[1647564],\"ancestors\":[1,2759,3193,3398,4447,4479,4734,33090,35493,38820,58023,58024,78536,131221,131567,147367,359160,1437183,1437197],\"id\":\"NCBITaxon:147367\",\"is_a\":[359160],\"name\":\"Oryzoideae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":570389,\"parents\":[\"359160\"],\"property_value\":\"has_rank NCBITaxon:subfamily\",\"synonym\":[\"Ehrhartoideae\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":147368,\"ancestors\":[1,2759,3193,3398,4447,4479,4734,33090,35493,38820,58023,58024,78536,131221,131567,147368,359160,1437183,1437197],\"id\":\"NCBITaxon:147368\",\"is_a\":[359160],\"name\":\"Pooideae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":239754,\"parents\":[\"359160\"],\"property_value\":\"has_rank NCBITaxon:subfamily\",\"xref\":[\"GC_ID:1\"]},{\"_id\":147369,\"alt_id\":[219388],\"ancestors\":[1,2759,3193,3398,4447,4479,4734,33090,35493,38820,58023,58024,78536,131221,131567,147369,147370,1437183,1437197],\"id\":\"NCBITaxon:147369\",\"is_a\":[147370],\"name\":\"Panicoideae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":109663,\"parents\":[\"147370\"],\"property_value\":\"has_rank NCBITaxon:subfamily\",\"synonym\":[\"Centothecoideae\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":147370,\"ancestors\":[1,2759,3193,3398,4447,4479,4734,33090,35493,38820,58023,58024,78536,131221,131567,147370,1437183,1437197],\"id\":\"NCBITaxon:147370\",\"is_a\":[4479],\"name\":\"PACMAD clade\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":109663,\"parents\":[\"4479\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":147380,\"ancestors\":[1,2759,3193,3398,4447,4479,4734,33090,35493,38820,58023,58024,78536,131221,131567,147367,147380,359160,1437183,1437197],\"id\":\"NCBITaxon:147380\",\"is_a\":[147367],\"name\":\"Oryzeae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":570389,\"parents\":[\"147367\"],\"property_value\":\"has_rank NCBITaxon:tribe\",\"xref\":[\"GC_ID:1\"]},{\"_id\":147385,\"ancestors\":[1,2759,3193,3398,4447,4479,4734,33090,35493,38820,58023,58024,78536,131221,131567,147368,147385,359160,1437183,1437197],\"id\":\"NCBITaxon:147385\",\"is_a\":[147368],\"name\":\"Brachypodieae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":26552,\"parents\":[\"147368\"],\"property_value\":\"has_rank NCBITaxon:tribe\",\"xref\":[\"GC_ID:1\"]},{\"_id\":147389,\"ancestors\":[1,2759,3193,3398,4447,4479,4734,33090,35493,38820,58023,58024,78536,131221,131567,147368,147389,359160,1437183,1437197,1648038],\"id\":\"NCBITaxon:147389\",\"is_a\":[1648038],\"name\":\"Triticeae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":213202,\"parents\":[\"1648038\"],\"property_value\":\"has_rank NCBITaxon:tribe\",\"xref\":[\"GC_ID:1\"]},{\"_id\":147428,\"ancestors\":[1,2759,3193,3398,4447,4479,4734,33090,35493,38820,58023,58024,78536,131221,131567,147369,147370,147428,1437183,1437197,1648036],\"id\":\"NCBITaxon:147428\",\"is_a\":[1648036],\"name\":\"Paniceae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":35471,\"parents\":[\"1648036\"],\"property_value\":\"has_rank NCBITaxon:tribe\",\"xref\":[\"GC_ID:1\"]},{\"_id\":147429,\"ancestors\":[1,2759,3193,3398,4447,4479,4734,33090,35493,38820,58023,58024,78536,131221,131567,147369,147370,147429,1437183,1437197,1648033],\"id\":\"NCBITaxon:147429\",\"is_a\":[1648033],\"name\":\"Andropogoneae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":74192,\"parents\":[\"1648033\"],\"property_value\":\"has_rank NCBITaxon:tribe\",\"xref\":[\"GC_ID:1\"]},{\"_id\":163735,\"ancestors\":[1,2759,3193,3398,3803,3814,33090,35493,58023,58024,71240,71275,72025,78536,91827,91835,131221,131567,163735,1437183,1437201],\"id\":\"NCBITaxon:163735\",\"is_a\":[3814],\"name\":\"Phaseoleae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":54174,\"parents\":[\"3814\"],\"property_value\":\"has_rank NCBITaxon:tribe\",\"xref\":[\"GC_ID:1\"]},{\"_id\":163742,\"ancestors\":[1,2759,3193,3398,3803,3814,33090,35493,58023,58024,71240,71275,72025,78536,91827,91835,131221,131567,163742,1437183,1437201],\"id\":\"NCBITaxon:163742\",\"is_a\":[3814],\"name\":\"Trifolieae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":54073,\"parents\":[\"3814\"],\"property_value\":\"has_rank NCBITaxon:tribe\",\"xref\":[\"GC_ID:1\"]},{\"_id\":171637,\"alt_id\":[171636,721786],\"ancestors\":[1,2759,3193,3398,3744,3745,33090,35493,58023,58024,71240,71275,78536,91827,91835,131221,131567,171637,1437183,1437201],\"id\":\"NCBITaxon:171637\",\"is_a\":[3745],\"name\":\"Maloideae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":29499,\"parents\":[\"3745\"],\"property_value\":\"has_rank NCBITaxon:subfamily\",\"synonym\":[\"Amygdaloideae\",\"Spiraeoideae\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":214687,\"ancestors\":[1,2759,3193,3398,4447,4618,4637,4640,4641,4734,33090,35493,58023,58024,78536,131221,131567,214687,1437183,1437197],\"id\":\"NCBITaxon:214687\",\"is_a\":[4641],\"name\":\"Musa acuminata subsp. malaccensis\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":37579,\"parents\":[\"4641\"],\"property_value\":\"has_rank NCBITaxon:subspecies\",\"synonym\":[\"Musa acuminata var. malaccensis\",\"pisang utan\",\"true apple banana\",\"wild Malaysian banana\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":214909,\"ancestors\":[1,2759,3193,3398,3629,33090,35493,41938,58023,58024,71240,71275,78536,91827,91836,131221,131567,214909,1437183,1437201],\"id\":\"NCBITaxon:214909\",\"is_a\":[3629],\"name\":\"Byttnerioideae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":29188,\"parents\":[\"3629\"],\"property_value\":\"has_rank NCBITaxon:subfamily\",\"xref\":[\"GC_ID:1\"]},{\"_id\":232365,\"ancestors\":[1,2759,3193,3398,33090,35493,58023,58024,78536,131221,131567,232365],\"id\":\"NCBITaxon:232365\",\"is_a\":[3398],\"name\":\"basal Magnoliophyta\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":28721,\"parents\":[\"3398\"],\"synonym\":[\"stem Magnoliophyta\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":238069,\"ancestors\":[1,2759,3193,3398,3646,3688,33090,35493,58023,58024,71240,71275,78536,91827,91835,131221,131567,238069,1437183,1437201],\"id\":\"NCBITaxon:238069\",\"is_a\":[3688],\"name\":\"Saliceae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":41377,\"parents\":[\"3688\"],\"property_value\":\"has_rank NCBITaxon:tribe\",\"xref\":[\"GC_ID:1\"]},{\"_id\":242159,\"ancestors\":[1,2759,3041,3152,13792,33090,70447,131567,242159,1035538,1525212],\"id\":\"NCBITaxon:242159\",\"is_a\":[70447],\"name\":\"Ostreococcus 'lucimarinus'\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":7640,\"parents\":[\"70447\"],\"property_value\":\"has_rank NCBITaxon:species\",\"synonym\":[\"Ostreococcus lucimarinus\",\"Ostreococcus sp. CCE9901\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":261009,\"ancestors\":[1,2759,3193,3398,33090,35493,58023,58024,78536,131221,131567,232365,261009],\"id\":\"NCBITaxon:261009\",\"is_a\":[232365],\"name\":\"Amborellales\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":28721,\"parents\":[\"232365\"],\"property_value\":\"has_rank NCBITaxon:order\",\"xref\":[\"GC_ID:1\"]},{\"_id\":265316,\"ancestors\":[1,2759,2763,2797,131567,265316,265318],\"id\":\"NCBITaxon:265316\",\"is_a\":[265318],\"name\":\"Cyanidiaceae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":5106,\"parents\":[\"265318\"],\"property_value\":\"has_rank NCBITaxon:family\",\"xref\":[\"GC_ID:1\"]},{\"_id\":265318,\"ancestors\":[1,2759,2763,2797,131567,265318],\"id\":\"NCBITaxon:265318\",\"is_a\":[2797],\"name\":\"Cyanidiales\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":5106,\"parents\":[\"2797\"],\"property_value\":\"has_rank NCBITaxon:order\",\"xref\":[\"GC_ID:1\"]},{\"_id\":280699,\"ancestors\":[1,2759,2763,2797,45156,45157,131567,265316,265318,280699],\"id\":\"NCBITaxon:280699\",\"is_a\":[45157],\"name\":\"Cyanidioschyzon merolae strain 10D\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":5106,\"parents\":[\"45157\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":359160,\"ancestors\":[1,2759,3193,3398,4447,4479,4734,33090,35493,38820,58023,58024,78536,131221,131567,359160,1437183,1437197],\"id\":\"NCBITaxon:359160\",\"is_a\":[4479],\"name\":\"BOP clade\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":810143,\"parents\":[\"4479\"],\"synonym\":[\"BEP clade\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":403667,\"ancestors\":[1,2759,3193,3398,33090,35493,58023,58024,71240,71275,78536,91827,91834,131221,131567,403667,1437183,1437201],\"id\":\"NCBITaxon:403667\",\"is_a\":[91834],\"name\":\"Vitales\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":29971,\"parents\":[\"91834\"],\"property_value\":\"has_rank NCBITaxon:order\",\"xref\":[\"GC_ID:1\"]},{\"_id\":404260,\"ancestors\":[1,2759,3193,3208,33090,35493,131221,131567,404260],\"id\":\"NCBITaxon:404260\",\"is_a\":[3208],\"name\":\"Bryophytina\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":32273,\"parents\":[\"3208\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":424551,\"ancestors\":[1,2759,3193,3398,4069,4070,33090,35493,58023,58024,71240,71274,78536,91827,91888,131221,131567,424551,1437183,1437201],\"id\":\"NCBITaxon:424551\",\"is_a\":[4070],\"name\":\"Solanoideae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":81709,\"parents\":[\"4070\"],\"property_value\":\"has_rank NCBITaxon:subfamily\",\"xref\":[\"GC_ID:1\"]},{\"_id\":424574,\"ancestors\":[1,2759,3193,3398,4069,4070,33090,35493,58023,58024,71240,71274,78536,91827,91888,131221,131567,424551,424574,1437183,1437201],\"id\":\"NCBITaxon:424574\",\"is_a\":[424551],\"name\":\"Solaneae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":81709,\"parents\":[\"424551\"],\"property_value\":\"has_rank NCBITaxon:tribe\",\"xref\":[\"GC_ID:1\"]},{\"_id\":436017,\"ancestors\":[1,2759,3041,3152,13792,33090,70447,131567,242159,436017,1035538,1525212],\"id\":\"NCBITaxon:436017\",\"is_a\":[242159],\"name\":\"Ostreococcus lucimarinus CCE9901\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":7640,\"parents\":[\"242159\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":721805,\"ancestors\":[1,2759,3193,3398,3744,3745,33090,35493,58023,58024,71240,71275,78536,91827,91835,131221,131567,171637,721805,1437183,1437201],\"id\":\"NCBITaxon:721805\",\"is_a\":[171637],\"name\":\"Amygdaleae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":29499,\"parents\":[\"171637\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":980083,\"ancestors\":[1,2759,3193,3398,3699,3700,33090,35493,58023,58024,71240,71275,78536,91827,91836,131221,131567,980083,1437183,1437201],\"id\":\"NCBITaxon:980083\",\"is_a\":[3700],\"name\":\"Camelineae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":66269,\"parents\":[\"3700\"],\"property_value\":\"has_rank NCBITaxon:tribe\",\"xref\":[\"GC_ID:1\"]},{\"_id\":981071,\"ancestors\":[1,2759,3193,3398,3699,3700,33090,35493,58023,58024,71240,71275,78536,91827,91836,131221,131567,981071,1437183,1437201],\"id\":\"NCBITaxon:981071\",\"is_a\":[3700],\"name\":\"Brassiceae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":102071,\"parents\":[\"3700\"],\"property_value\":\"has_rank NCBITaxon:tribe\",\"xref\":[\"GC_ID:1\"]},{\"_id\":1035538,\"ancestors\":[1,2759,3041,3152,33090,131567,1035538],\"id\":\"NCBITaxon:1035538\",\"is_a\":[3152],\"name\":\"Mamiellophyceae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":7640,\"parents\":[\"3152\"],\"property_value\":\"has_rank NCBITaxon:class\",\"xref\":[\"GC_ID:1\",\"PMID:23020233\"]},{\"_id\":1293361,\"ancestors\":[1,2759,3193,3398,4447,4479,4734,33090,35493,38820,58023,58024,78536,131221,131567,147369,147370,147428,1293361,1437183,1437197,1648036],\"id\":\"NCBITaxon:1293361\",\"is_a\":[147428],\"name\":\"Cenchrinae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":35471,\"parents\":[\"147428\"],\"property_value\":\"has_rank NCBITaxon:subtribe\",\"xref\":[\"GC_ID:1\"]},{\"_id\":1437183,\"ancestors\":[1,2759,3193,3398,33090,35493,58023,58024,78536,131221,131567,1437183],\"id\":\"NCBITaxon:1437183\",\"is_a\":[3398],\"name\":\"Mesangiospermae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":1445716,\"parents\":[\"3398\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":1437197,\"ancestors\":[1,2759,3193,3398,4447,33090,35493,58023,58024,78536,131221,131567,1437183,1437197],\"id\":\"NCBITaxon:1437197\",\"is_a\":[4447],\"name\":\"Petrosaviidae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":957385,\"parents\":[\"4447\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":1437201,\"ancestors\":[1,2759,3193,3398,33090,35493,58023,58024,71240,78536,91827,131221,131567,1437183,1437201],\"id\":\"NCBITaxon:1437201\",\"is_a\":[91827],\"name\":\"Pentapetalae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":488331,\"parents\":[\"91827\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":1462606,\"ancestors\":[1,2759,3193,3398,3803,3814,3846,33090,35493,58023,58024,71240,71275,72025,78536,91827,91835,131221,131567,163735,1437183,1437201,1462606],\"id\":\"NCBITaxon:1462606\",\"is_a\":[3846],\"name\":\"Soja\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":54174,\"parents\":[\"3846\"],\"property_value\":\"has_rank NCBITaxon:subgenus\",\"xref\":[\"GC_ID:1\"]},{\"_id\":1521260,\"ancestors\":[1,2759,3193,33090,35493,58023,131221,131567,1521260],\"id\":\"NCBITaxon:1521260\",\"is_a\":[58023],\"name\":\"Lycopodiidae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":34888,\"parents\":[\"58023\"],\"property_value\":\"has_rank NCBITaxon:subclass\",\"xref\":[\"GC_ID:1\"]},{\"_id\":1525212,\"ancestors\":[1,2759,3041,3152,13792,33090,131567,1035538,1525212],\"id\":\"NCBITaxon:1525212\",\"is_a\":[13792],\"name\":\"Bathycoccaceae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":7640,\"parents\":[\"13792\"],\"property_value\":\"has_rank NCBITaxon:family\",\"xref\":[\"GC_ID:1\"]},{\"_id\":1648017,\"ancestors\":[1,2759,3193,3398,4447,4479,4734,33090,35493,38820,58023,58024,78536,131221,131567,147368,147389,359160,1437183,1437197,1648017,1648038],\"id\":\"NCBITaxon:1648017\",\"is_a\":[147389],\"name\":\"Hordeinae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":26067,\"parents\":[\"147389\"],\"property_value\":\"has_rank NCBITaxon:subtribe\",\"xref\":[\"GC_ID:1\"]},{\"_id\":1648021,\"ancestors\":[1,2759,3193,3398,4447,4479,4734,33090,35493,38820,58023,58024,78536,131221,131567,147367,147380,359160,1437183,1437197,1648021],\"id\":\"NCBITaxon:1648021\",\"is_a\":[147380],\"name\":\"Oryzinae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":570389,\"parents\":[\"147380\"],\"property_value\":\"has_rank NCBITaxon:subtribe\",\"xref\":[\"GC_ID:1\"]},{\"_id\":1648028,\"ancestors\":[1,2759,3193,3398,4447,4479,4734,33090,35493,38820,58023,58024,78536,131221,131567,147369,147370,147429,1437183,1437197,1648028,1648033],\"id\":\"NCBITaxon:1648028\",\"is_a\":[147429],\"name\":\"Sorghinae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":34567,\"parents\":[\"147429\"],\"property_value\":\"has_rank NCBITaxon:subtribe\",\"xref\":[\"GC_ID:1\"]},{\"_id\":1648029,\"ancestors\":[1,2759,3193,3398,4447,4479,4734,33090,35493,38820,58023,58024,78536,131221,131567,147369,147370,147429,1437183,1437197,1648029,1648033],\"id\":\"NCBITaxon:1648029\",\"is_a\":[147429],\"name\":\"Tripsacinae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":39625,\"parents\":[\"147429\"],\"property_value\":\"has_rank NCBITaxon:subtribe\",\"xref\":[\"GC_ID:1\"]},{\"_id\":1648030,\"ancestors\":[1,2759,3193,3398,4447,4479,4734,33090,35493,38820,58023,58024,78536,131221,131567,147368,147389,359160,1437183,1437197,1648030,1648038],\"id\":\"NCBITaxon:1648030\",\"is_a\":[147389],\"name\":\"Triticinae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":187135,\"parents\":[\"147389\"],\"property_value\":\"has_rank NCBITaxon:subtribe\",\"xref\":[\"GC_ID:1\"]},{\"_id\":1648033,\"ancestors\":[1,2759,3193,3398,4447,4479,4734,33090,35493,38820,58023,58024,78536,131221,131567,147369,147370,1437183,1437197,1648033],\"id\":\"NCBITaxon:1648033\",\"is_a\":[147369],\"name\":\"Andropogonodae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":74192,\"parents\":[\"147369\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":1648036,\"ancestors\":[1,2759,3193,3398,4447,4479,4734,33090,35493,38820,58023,58024,78536,131221,131567,147369,147370,1437183,1437197,1648036],\"id\":\"NCBITaxon:1648036\",\"is_a\":[147369],\"name\":\"Panicodae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":35471,\"parents\":[\"147369\"],\"xref\":[\"GC_ID:1\"]},{\"_id\":1648038,\"ancestors\":[1,2759,3193,3398,4447,4479,4734,33090,35493,38820,58023,58024,78536,131221,131567,147368,359160,1437183,1437197,1648038],\"id\":\"NCBITaxon:1648038\",\"is_a\":[147368],\"name\":\"Triticodae\",\"namespace\":\"ncbi_taxonomy\",\"num_genes\":213202,\"parents\":[\"147368\"],\"xref\":[\"GC_ID:1\"]}]}");

},{}],"bWOsi":[function(require,module,exports,__globalThis) {
var TreeModel = require("6b6e32044d34358");
var _ = require("c25b5ed594598325");
var extensions = require("b9b4143891521588");
module.exports = {
    tree: function(genetree) {
        function leftIndexComparator(a, b) {
            return a.left_index > b.left_index ? 1 : -1;
        }
        var tree = new TreeModel({
            modelComparatorFn: leftIndexComparator
        }).parse(genetree[0]);
        extensions.indexTree(tree, [
            'protein_stable_id',
            'gene_stable_id'
        ]);
        extensions.decorateTree(tree);
        extensions.addPrototypeDecorations(tree);
        tree.geneCount = tree.leafNodes().length;
        tree._id = tree.model._id;
        return tree;
    }
};

},{"6b6e32044d34358":"5AXxY","c25b5ed594598325":"8bWZr","b9b4143891521588":"jrU9D"}],"4SmGX":[function(require,module,exports,__globalThis) {
/**
 * @license
 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern -d -o ./index.js`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ var global = arguments[3];
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '3.10.1';
    /** Used to compose bitmasks for wrapper metadata. */ var BIND_FLAG = 1, BIND_KEY_FLAG = 2, CURRY_BOUND_FLAG = 4, CURRY_FLAG = 8, CURRY_RIGHT_FLAG = 16, PARTIAL_FLAG = 32, PARTIAL_RIGHT_FLAG = 64, ARY_FLAG = 128, REARG_FLAG = 256;
    /** Used as default options for `_.trunc`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect when a function becomes hot. */ var HOT_COUNT = 150, HOT_SPAN = 16;
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2;
    /** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = 'Expected a function';
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', weakMapTag = '[object WeakMap]';
    var arrayBufferTag = '[object ArrayBuffer]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g, reUnescapedHtml = /[&<>"'`]/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
    /**
   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
   */ var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g, reHasRegExpChars = RegExp(reRegExpChars.source);
    /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */ var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect hexadecimal string values. */ var reHasHexPrefix = /^0[xX]/;
    /** Used to detect host constructors (Safari > 5). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect unsigned integer values. */ var reIsUint = /^\d+$/;
    /** Used to match latin-1 supplementary letters (excluding mathematical operators). */ var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to match words to create compound words. */ var reWords = function() {
        var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]', lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';
        return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
    }();
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'ArrayBuffer',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Math',
        'Number',
        'Object',
        'RegExp',
        'Set',
        'String',
        '_',
        'clearTimeout',
        'isFinite',
        'parseFloat',
        'parseInt',
        'setTimeout',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[stringTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[mapTag] = cloneableTags[setTag] = cloneableTags[weakMapTag] = false;
    /** Used to map latin-1 supplementary letters to basic latin letters. */ var deburredLetters = {
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcC': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xeC': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '`': '&#96;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'",
        '&#96;': '`'
    };
    /** Used to determine if values are of the language type `Object`. */ var objectTypes = {
        'function': true,
        'object': true
    };
    /** Used to escape characters for inclusion in compiled regexes. */ var regexpEscapes = {
        '0': 'x30',
        '1': 'x31',
        '2': 'x32',
        '3': 'x33',
        '4': 'x34',
        '5': 'x35',
        '6': 'x36',
        '7': 'x37',
        '8': 'x38',
        '9': 'x39',
        'A': 'x41',
        'B': 'x42',
        'C': 'x43',
        'D': 'x44',
        'E': 'x45',
        'F': 'x46',
        'a': 'x61',
        'b': 'x62',
        'c': 'x63',
        'd': 'x64',
        'e': 'x65',
        'f': 'x66',
        'n': 'x6e',
        'r': 'x72',
        't': 'x74',
        'u': 'x75',
        'v': 'x76',
        'x': 'x78'
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Detect free variable `exports`. */ var freeExports = objectTypes["object"] && exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = objectTypes["object"] && module && !module.nodeType && module;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;
    /** Detect free variable `self`. */ var freeSelf = objectTypes[typeof self] && self && self.Object && self;
    /** Detect free variable `window`. */ var freeWindow = objectTypes[typeof window] && window && window.Object && window;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;
    /**
   * Used as a reference to the global object.
   *
   * The `this` value is used if it's the global object to avoid Greasemonkey's
   * restricted `window` object, otherwise the `window` object is used.
   */ var root = freeGlobal || freeWindow !== (this && this.window) && freeWindow || freeSelf || this;
    /*--------------------------------------------------------------------------*/ /**
   * The base implementation of `compareAscending` which compares values and
   * sorts them in ascending order without guaranteeing a stable sort.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {number} Returns the sort order indicator for `value`.
   */ function baseCompareAscending(value, other) {
        if (value !== other) {
            var valIsNull = value === null, valIsUndef = value === undefined, valIsReflexive = value === value;
            var othIsNull = other === null, othIsUndef = other === undefined, othIsReflexive = other === other;
            if (value > other && !othIsNull || !valIsReflexive || valIsNull && !othIsUndef && othIsReflexive || valIsUndef && othIsReflexive) return 1;
            if (value < other && !valIsNull || !othIsReflexive || othIsNull && !valIsUndef && valIsReflexive || othIsUndef && valIsReflexive) return -1;
        }
        return 0;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {Function} predicate The function invoked per iteration.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromRight) {
        var length = array.length, index = fromRight ? length : -1;
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without support for binary searches.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        if (value !== value) return indexOfNaN(array, fromIndex);
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isFunction` without support for environments
   * with incorrect `typeof` results.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
   */ function baseIsFunction(value) {
        // Avoid a Chakra JIT bug in compatibility modes of IE 11.
        // See https://github.com/jashkenas/underscore/issues/1621 for more details.
        return typeof value == 'function' || false;
    }
    /**
   * Converts `value` to a string if it's not one. An empty string is returned
   * for `null` or `undefined` values.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */ function baseToString(value) {
        return value == null ? '' : value + '';
    }
    /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the first character not found in `chars`.
   */ function charsLeftIndex(string, chars) {
        var index = -1, length = string.length;
        while(++index < length && chars.indexOf(string.charAt(index)) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the last character not found in `chars`.
   */ function charsRightIndex(string, chars) {
        var index = string.length;
        while(index-- && chars.indexOf(string.charAt(index)) > -1);
        return index;
    }
    /**
   * Used by `_.sortBy` to compare transformed elements of a collection and stable
   * sort them in ascending order.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @returns {number} Returns the sort order indicator for `object`.
   */ function compareAscending(object, other) {
        return baseCompareAscending(object.criteria, other.criteria) || object.index - other.index;
    }
    /**
   * Used by `_.sortByOrder` to compare multiple properties of a value to another
   * and stable sort them.
   *
   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
   * a value is sorted in ascending order if its corresponding order is "asc", and
   * descending if "desc".
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {boolean[]} orders The order to sort by for each property.
   * @returns {number} Returns the sort order indicator for `object`.
   */ function compareMultiple(object, other, orders) {
        var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
        while(++index < length){
            var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
            if (result) {
                if (index >= ordersLength) return result;
                var order = orders[index];
                return result * (order === 'asc' || order === true ? 1 : -1);
            }
        }
        // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
        // that causes it, under certain circumstances, to provide the same value for
        // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
        // for more details.
        //
        // This also ensures a stable sort in V8 and other engines.
        // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
        return object.index - other.index;
    }
    /**
   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ function deburrLetter(letter) {
        return deburredLetters[letter];
    }
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeHtmlChar(chr) {
        return htmlEscapes[chr];
    }
    /**
   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @param {string} leadingChar The capture group for a leading character.
   * @param {string} whitespaceChar The capture group for a whitespace character.
   * @returns {string} Returns the escaped character.
   */ function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
        if (leadingChar) chr = regexpEscapes[chr];
        else if (whitespaceChar) chr = stringEscapes[chr];
        return '\\' + chr;
    }
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the index at which the first occurrence of `NaN` is found in `array`.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
   */ function indexOfNaN(array, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 0 : -1);
        while(fromRight ? index-- : ++index < length){
            var other = array[index];
            if (other !== other) return index;
        }
        return -1;
    }
    /**
   * Checks if `value` is object-like.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   */ function isObjectLike(value) {
        return !!value && typeof value == 'object';
    }
    /**
   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
   * character code is whitespace.
   *
   * @private
   * @param {number} charCode The character code to inspect.
   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
   */ function isSpace(charCode) {
        return charCode <= 160 && charCode >= 9 && charCode <= 13 || charCode == 32 || charCode == 160 || charCode == 5760 || charCode == 6158 || charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279);
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = -1, result = [];
        while(++index < length)if (array[index] === placeholder) {
            array[index] = PLACEHOLDER;
            result[++resIndex] = index;
        }
        return result;
    }
    /**
   * An implementation of `_.uniq` optimized for sorted arrays without support
   * for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} [iteratee] The function invoked per iteration.
   * @returns {Array} Returns the new duplicate-value-free array.
   */ function sortedUniq(array, iteratee) {
        var seen, index = -1, length = array.length, resIndex = -1, result = [];
        while(++index < length){
            var value = array[index], computed = iteratee ? iteratee(value, index, array) : value;
            if (!index || seen !== computed) {
                seen = computed;
                result[++resIndex] = value;
            }
        }
        return result;
    }
    /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the first non-whitespace character.
   */ function trimmedLeftIndex(string) {
        var index = -1, length = string.length;
        while(++index < length && isSpace(string.charCodeAt(index)));
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedRightIndex(string) {
        var index = string.length;
        while(index-- && isSpace(string.charCodeAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ function unescapeHtmlChar(chr) {
        return htmlUnescapes[chr];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the given `context` object.
   *
   * @static
   * @memberOf _
   * @category Utility
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // using `context` to mock `Date#getTime` use in `_.now`
   * var mock = _.runInContext({
   *   'Date': function() {
   *     return { 'getTime': getTimeMock };
   *   }
   * });
   *
   * // or creating a suped-up `defer` in Node.js
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ function runInContext(context) {
        // Avoid issues with some ES3 environments that attempt to use values, named
        // after built-in constructors like `Object`, for the creation of literals.
        // ES5 clears this up by stating that literals must use built-in constructors.
        // See https://es5.github.io/#x11.1.5 for more details.
        context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;
        /** Native constructor references. */ var Array = context.Array, Date = context.Date, Error = context.Error, Function = context.Function, Math = context.Math, Number = context.Number, Object = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for native method references. */ var arrayProto = Array.prototype, objectProto = Object.prototype, stringProto = String.prototype;
        /** Used to resolve the decompiled source of functions. */ var fnToString = Function.prototype.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /**
     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
     * of values.
     */ var objToString = objectProto.toString;
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Native method references. */ var ArrayBuffer = context.ArrayBuffer, clearTimeout = context.clearTimeout, parseFloat = context.parseFloat, pow = Math.pow, propertyIsEnumerable = objectProto.propertyIsEnumerable, Set = getNative(context, 'Set'), setTimeout = context.setTimeout, splice = arrayProto.splice, Uint8Array = context.Uint8Array, WeakMap = getNative(context, 'WeakMap');
        /* Native method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeCreate = getNative(Object, 'create'), nativeFloor = Math.floor, nativeIsArray = getNative(Array, 'isArray'), nativeIsFinite = context.isFinite, nativeKeys = getNative(Object, 'keys'), nativeMax = Math.max, nativeMin = Math.min, nativeNow = getNative(Date, 'now'), nativeParseInt = context.parseInt, nativeRandom = Math.random;
        /** Used as references for `-Infinity` and `Infinity`. */ var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY, POSITIVE_INFINITY = Number.POSITIVE_INFINITY;
        /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
        /**
     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
     * of an array-like value.
     */ var MAX_SAFE_INTEGER = 9007199254740991;
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
     * Methods that operate on and return arrays, collections, and functions can
     * be chained together. Methods that retrieve a single value or may return a
     * primitive value will automatically end the chain returning the unwrapped
     * value. Explicit chaining may be enabled using `_.chain`. The execution of
     * chained methods is lazy, that is, execution is deferred until `_#value`
     * is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
     * fusion is an optimization strategy which merge iteratee calls; this can help
     * to avoid the creation of intermediate data structures and greatly reduce the
     * number of iteratee executions.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
     * `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
     * and `where`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
     * `unescape`, `uniqueId`, `value`, and `words`
     *
     * The wrapper method `sample` will return a wrapped value when `n` is provided,
     * otherwise an unwrapped value is returned.
     *
     * @name _
     * @constructor
     * @category Chain
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // returns an unwrapped value
     * wrapped.reduce(function(total, n) {
     *   return total + n;
     * });
     * // => 6
     *
     * // returns a wrapped value
     * var squares = wrapped.map(function(n) {
     *   return n * n;
     * });
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The function whose prototype all chaining wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
     */ function LodashWrapper(value, chainAll, actions) {
            this.__wrapped__ = value;
            this.__actions__ = actions || [];
            this.__chain__ = !!chainAll;
        }
        /**
     * An object environment feature flags.
     *
     * @static
     * @memberOf _
     * @type Object
     */ var support = lodash.support = {};
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB). Change the following template settings to use
     * alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type Object
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type string
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type Object
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type Function
         */ '_': lodash
            }
        };
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = POSITIVE_INFINITY;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = arrayCopy(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = arrayCopy(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = arrayCopy(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || arrLength < LARGE_ARRAY_SIZE || arrLength == length && takeCount == length) return baseWrapperValue(isRight && isArr ? array.reverse() : array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates a cache object to store key/value pairs.
     *
     * @private
     * @static
     * @name Cache
     * @memberOf _.memoize
     */ function MapCache() {
            this.__data__ = {};
        }
        /**
     * Removes `key` and its value from the cache.
     *
     * @private
     * @name delete
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
     */ function mapDelete(key) {
            return this.has(key) && delete this.__data__[key];
        }
        /**
     * Gets the cached value for `key`.
     *
     * @private
     * @name get
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the cached value.
     */ function mapGet(key) {
            return key == '__proto__' ? undefined : this.__data__[key];
        }
        /**
     * Checks if a cached value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapHas(key) {
            return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
        }
        /**
     * Sets `value` to `key` of the cache.
     *
     * @private
     * @name set
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to cache.
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache object.
     */ function mapSet(key, value) {
            if (key != '__proto__') this.__data__[key] = value;
            return this;
        }
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates a cache object to store unique values.
     *
     * @private
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var length = values ? values.length : 0;
            this.data = {
                'hash': nativeCreate(null),
                'set': new Set
            };
            while(length--)this.push(values[length]);
        }
        /**
     * Checks if `value` is in `cache` mimicking the return signature of
     * `_.indexOf` by returning `0` if the value is found, else `-1`.
     *
     * @private
     * @param {Object} cache The cache to search.
     * @param {*} value The value to search for.
     * @returns {number} Returns `0` if `value` is found, else `-1`.
     */ function cacheIndexOf(cache, value) {
            var data = cache.data, result = typeof value == 'string' || isObject(value) ? data.set.has(value) : data.hash[value];
            return result ? 0 : -1;
        }
        /**
     * Adds `value` to the cache.
     *
     * @private
     * @name push
     * @memberOf SetCache
     * @param {*} value The value to cache.
     */ function cachePush(value) {
            var data = this.data;
            if (typeof value == 'string' || isObject(value)) data.set.add(value);
            else data.hash[value] = true;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates a new array joining `array` with `other`.
     *
     * @private
     * @param {Array} array The array to join.
     * @param {Array} other The other array to join.
     * @returns {Array} Returns the new concatenated array.
     */ function arrayConcat(array, other) {
            var index = -1, length = array.length, othIndex = -1, othLength = other.length, result = Array(length + othLength);
            while(++index < length)result[index] = array[index];
            while(++othIndex < othLength)result[index++] = other[othIndex];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function arrayCopy(source, array) {
            var index = -1, length = source.length;
            array || (array = Array(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * A specialized version of `_.forEach` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */ function arrayEach(array, iteratee) {
            var index = -1, length = array.length;
            while(++index < length){
                if (iteratee(array[index], index, array) === false) break;
            }
            return array;
        }
        /**
     * A specialized version of `_.forEachRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */ function arrayEachRight(array, iteratee) {
            var length = array.length;
            while(length--){
                if (iteratee(array[length], length, array) === false) break;
            }
            return array;
        }
        /**
     * A specialized version of `_.every` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     */ function arrayEvery(array, predicate) {
            var index = -1, length = array.length;
            while(++index < length){
                if (!predicate(array[index], index, array)) return false;
            }
            return true;
        }
        /**
     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
     * with one argument: (value).
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */ function arrayExtremum(array, iteratee, comparator, exValue) {
            var index = -1, length = array.length, computed = exValue, result = computed;
            while(++index < length){
                var value = array[index], current = +iteratee(value);
                if (comparator(current, computed)) {
                    computed = current;
                    result = value;
                }
            }
            return result;
        }
        /**
     * A specialized version of `_.filter` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function arrayFilter(array, predicate) {
            var index = -1, length = array.length, resIndex = -1, result = [];
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) result[++resIndex] = value;
            }
            return result;
        }
        /**
     * A specialized version of `_.map` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function arrayMap(array, iteratee) {
            var index = -1, length = array.length, result = Array(length);
            while(++index < length)result[index] = iteratee(array[index], index, array);
            return result;
        }
        /**
     * Appends the elements of `values` to `array`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to append.
     * @returns {Array} Returns `array`.
     */ function arrayPush(array, values) {
            var index = -1, length = values.length, offset = array.length;
            while(++index < length)array[offset + index] = values[index];
            return array;
        }
        /**
     * A specialized version of `_.reduce` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the first element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */ function arrayReduce(array, iteratee, accumulator, initFromArray) {
            var index = -1, length = array.length;
            if (initFromArray && length) accumulator = array[++index];
            while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
            return accumulator;
        }
        /**
     * A specialized version of `_.reduceRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the last element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */ function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
            var length = array.length;
            if (initFromArray && length) accumulator = array[--length];
            while(length--)accumulator = iteratee(accumulator, array[length], length, array);
            return accumulator;
        }
        /**
     * A specialized version of `_.some` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function arraySome(array, predicate) {
            var index = -1, length = array.length;
            while(++index < length){
                if (predicate(array[index], index, array)) return true;
            }
            return false;
        }
        /**
     * A specialized version of `_.sum` for arrays without support for callback
     * shorthands and `this` binding..
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */ function arraySum(array, iteratee) {
            var length = array.length, result = 0;
            while(length--)result += +iteratee(array[length]) || 0;
            return result;
        }
        /**
     * Used by `_.defaults` to customize its `_.assign` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */ function assignDefaults(objectValue, sourceValue) {
            return objectValue === undefined ? sourceValue : objectValue;
        }
        /**
     * Used by `_.template` to customize its `_.assign` use.
     *
     * **Note:** This function is like `assignDefaults` except that it ignores
     * inherited property values when checking if a property is `undefined`.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @param {string} key The key associated with the object and source values.
     * @param {Object} object The destination object.
     * @returns {*} Returns the value to assign to the destination object.
     */ function assignOwnDefaults(objectValue, sourceValue, key, object) {
            return objectValue === undefined || !hasOwnProperty.call(object, key) ? sourceValue : objectValue;
        }
        /**
     * A specialized version of `_.assign` for customizing assigned values without
     * support for argument juggling, multiple sources, and `this` binding `customizer`
     * functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     */ function assignWith(object, source, customizer) {
            var index = -1, props = keys(source), length = props.length;
            while(++index < length){
                var key = props[index], value = object[key], result = customizer(value, source[key], key, object, source);
                if ((result === result ? result !== value : value === value) || value === undefined && !(key in object)) object[key] = result;
            }
            return object;
        }
        /**
     * The base implementation of `_.assign` without support for argument juggling,
     * multiple sources, and `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return source == null ? object : baseCopy(source, keys(source), object);
        }
        /**
     * The base implementation of `_.at` without support for string collections
     * and individual key arguments.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {number[]|string[]} props The property names or indexes of elements to pick.
     * @returns {Array} Returns the new array of picked elements.
     */ function baseAt(collection, props) {
            var index = -1, isNil = collection == null, isArr = !isNil && isArrayLike(collection), length = isArr ? collection.length : 0, propsLength = props.length, result = Array(propsLength);
            while(++index < propsLength){
                var key = props[index];
                if (isArr) result[index] = isIndex(key, length) ? collection[key] : undefined;
                else result[index] = isNil ? undefined : collection[key];
            }
            return result;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property names to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @returns {Object} Returns `object`.
     */ function baseCopy(source, props, object) {
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                object[key] = source[key];
            }
            return object;
        }
        /**
     * The base implementation of `_.callback` which supports specifying the
     * number of arguments to provide to `func`.
     *
     * @private
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */ function baseCallback(func, thisArg, argCount) {
            var type = typeof func;
            if (type == 'function') return thisArg === undefined ? func : bindCallback(func, thisArg, argCount);
            if (func == null) return identity;
            if (type == 'object') return baseMatches(func);
            return thisArg === undefined ? property(func) : baseMatchesProperty(func, thisArg);
        }
        /**
     * The base implementation of `_.clone` without support for argument juggling
     * and `this` binding `customizer` functions.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The object `value` belongs to.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates clones with source counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
            var result;
            if (customizer) result = object ? customizer(value, key, object) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return arrayCopy(value, result);
            } else {
                var tag = objToString.call(value), isFunc = tag == funcTag;
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = initCloneObject(isFunc ? {} : value);
                    if (!isDeep) return baseAssign(result, value);
                } else return cloneableTags[tag] ? initCloneByTag(value, tag, isDeep) : object ? value : {};
            }
            // Check for circular references and return its corresponding clone.
            stackA || (stackA = []);
            stackB || (stackB = []);
            var length = stackA.length;
            while(length--){
                if (stackA[length] == value) return stackB[length];
            }
            // Add the source value to the stack of traversed objects and associate it with its clone.
            stackA.push(value);
            stackB.push(result);
            // Recursively populate clone (susceptible to call stack limits).
            (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
                result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
            });
            return result;
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} prototype The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(prototype) {
                if (isObject(prototype)) {
                    object.prototype = prototype;
                    var result = new object;
                    object.prototype = undefined;
                }
                return result || {};
            };
        }();
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts an index
     * of where to slice the arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Object} args The arguments provide to `func`.
     * @returns {number} Returns the timer id.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of `_.difference` which accepts a single array
     * of values to exclude.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values) {
            var length = array ? array.length : 0, result = [];
            if (!length) return result;
            var index = -1, indexOf = getIndexOf(), isCommon = indexOf == baseIndexOf, cache = isCommon && values.length >= LARGE_ARRAY_SIZE ? createCache(values) : null, valuesLength = values.length;
            if (cache) {
                indexOf = cacheIndexOf;
                isCommon = false;
                values = cache;
            }
            outer: while(++index < length){
                var value = array[index];
                if (isCommon && value === value) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === value) continue outer;
                    }
                    result.push(value);
                } else if (indexOf(values, value, 0) < 0) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * Gets the extremum value of `collection` invoking `iteratee` for each value
     * in `collection` to generate the criterion by which the value is ranked.
     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(collection, iteratee, comparator, exValue) {
            var computed = exValue, result = computed;
            baseEach(collection, function(value, index, collection) {
                var current = +iteratee(value, index, collection);
                if (comparator(current, computed) || current === exValue && current === result) {
                    computed = current;
                    result = value;
                }
            });
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = start == null ? 0 : +start || 0;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : +end || 0;
            if (end < 0) end += length;
            length = start > end ? 0 : end >>> 0;
            start >>>= 0;
            while(start < length)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
     * without support for callback shorthands and `this` binding, which iterates
     * over `collection` using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function} predicate The function invoked per iteration.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @param {boolean} [retKey] Specify returning the key of the found element
     *  instead of the element itself.
     * @returns {*} Returns the found element or its key, else `undefined`.
     */ function baseFind(collection, predicate, eachFunc, retKey) {
            var result;
            eachFunc(collection, function(value, key, collection) {
                if (predicate(value, key, collection)) {
                    result = retKey ? key : value;
                    return false;
                }
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with added support for restricting
     * flattening and specifying the start index.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, isDeep, isStrict, result) {
            result || (result = []);
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index];
                if (isObjectLike(value) && isArrayLike(value) && (isStrict || isArray(value) || isArguments(value))) {
                    if (isDeep) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, isDeep, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForIn` and `baseForOwn` which iterates
     * over `object` properties returned by `keysFunc` invoking `iteratee` for
     * each property. Iteratee functions may exit iteration early by explicitly
     * returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forIn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForIn(object, iteratee) {
            return baseFor(object, iteratee, keysIn);
        }
        /**
     * The base implementation of `_.forOwn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from those provided.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the new array of filtered property names.
     */ function baseFunctions(object, props) {
            var index = -1, length = props.length, resIndex = -1, result = [];
            while(++index < length){
                var key = props[index];
                if (isFunction(object[key])) result[++resIndex] = key;
            }
            return result;
        }
        /**
     * The base implementation of `get` without support for string paths
     * and default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path of the property to get.
     * @param {string} [pathKey] The key representation of path.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path, pathKey) {
            if (object == null) return;
            if (pathKey !== undefined && pathKey in toObject(object)) path = [
                pathKey
            ];
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[path[index++]];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `_.isEqual` without support for `this` binding
     * `customizer` functions.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
            if (value === other) return true;
            if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
            if (!objIsArr) {
                objTag = objToString.call(object);
                if (objTag == argsTag) objTag = objectTag;
                else if (objTag != objectTag) objIsArr = isTypedArray(object);
            }
            if (!othIsArr) {
                othTag = objToString.call(other);
                if (othTag == argsTag) othTag = objectTag;
                else if (othTag != objectTag) othIsArr = isTypedArray(other);
            }
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && !(objIsArr || objIsObj)) return equalByTag(object, other, objTag);
            if (!isLoose) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
            }
            if (!isSameTag) return false;
            // Assume cyclic values are equal.
            // For more information on detecting circular references see https://es5.github.io/#JO.
            stackA || (stackA = []);
            stackB || (stackB = []);
            var length = stackA.length;
            while(length--){
                if (stackA[length] == object) return stackB[length] == other;
            }
            // Add `object` and `other` to the stack of traversed objects.
            stackA.push(object);
            stackB.push(other);
            var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
            stackA.pop();
            stackB.pop();
            return result;
        }
        /**
     * The base implementation of `_.isMatch` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} matchData The propery names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = toObject(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var result = customizer ? customizer(objValue, srcValue, key) : undefined;
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.map` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which does not clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) {
                var key = matchData[0][0], value = matchData[0][1];
                return function(object) {
                    if (object == null) return false;
                    return object[key] === value && (value !== undefined || key in toObject(object));
                };
            }
            return function(object) {
                return baseIsMatch(object, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to compare.
     * @returns {Function} Returns the new function.
     */ function baseMatchesProperty(path, srcValue) {
            var isArr = isArray(path), isCommon = isKey(path) && isStrictComparable(srcValue), pathKey = path + '';
            path = toPath(path);
            return function(object) {
                if (object == null) return false;
                var key = pathKey;
                object = toObject(object);
                if ((isArr || !isCommon) && !(key in object)) {
                    object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
                    if (object == null) return false;
                    key = last(path);
                    object = toObject(object);
                }
                return object[key] === srcValue ? srcValue !== undefined || key in object : baseIsEqual(srcValue, object[key], undefined, true);
            };
        }
        /**
     * The base implementation of `_.merge` without support for argument juggling,
     * multiple sources, and `this` binding `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {Object} Returns `object`.
     */ function baseMerge(object, source, customizer, stackA, stackB) {
            if (!isObject(object)) return object;
            var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)), props = isSrcArr ? undefined : keys(source);
            arrayEach(props || source, function(srcValue, key) {
                if (props) {
                    key = srcValue;
                    srcValue = source[key];
                }
                if (isObjectLike(srcValue)) {
                    stackA || (stackA = []);
                    stackB || (stackB = []);
                    baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
                } else {
                    var value = object[key], result = customizer ? customizer(value, srcValue, key, object, source) : undefined, isCommon = result === undefined;
                    if (isCommon) result = srcValue;
                    if ((result !== undefined || isSrcArr && !(key in object)) && (isCommon || (result === result ? result !== value : value === value))) object[key] = result;
                }
            });
            return object;
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
            var length = stackA.length, srcValue = source[key];
            while(length--)if (stackA[length] == srcValue) {
                object[key] = stackB[length];
                return;
            }
            var value = object[key], result = customizer ? customizer(value, srcValue, key, object, source) : undefined, isCommon = result === undefined;
            if (isCommon) {
                result = srcValue;
                if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) result = isArray(value) ? value : isArrayLike(value) ? arrayCopy(value) : [];
                else if (isPlainObject(srcValue) || isArguments(srcValue)) result = isArguments(value) ? toPlainObject(value) : isPlainObject(value) ? value : {};
                else isCommon = false;
            }
            // Add the source value to the stack of traversed objects and associate
            // it with its merged value.
            stackA.push(srcValue);
            stackB.push(result);
            if (isCommon) // Recursively merge objects and arrays (susceptible to call stack limits).
            object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
            else if (result === result ? result !== value : value === value) object[key] = result;
        }
        /**
     * The base implementation of `_.property` without support for deep paths.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @returns {Function} Returns the new function.
     */ function baseProperty(key) {
            return function(object) {
                return object == null ? undefined : object[key];
            };
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     */ function basePropertyDeep(path) {
            var pathKey = path + '';
            path = toPath(path);
            return function(object) {
                return baseGet(object, path, pathKey);
            };
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * index arguments and capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0;
            while(length--){
                var index = indexes[length];
                if (index != previous && isIndex(index)) {
                    var previous = index;
                    splice.call(array, index, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for argument juggling
     * and returning floating-point numbers.
     *
     * @private
     * @param {number} min The minimum possible value.
     * @param {number} max The maximum possible value.
     * @returns {number} Returns the random number.
     */ function baseRandom(min, max) {
            return min + nativeFloor(nativeRandom() * (max - min + 1));
        }
        /**
     * The base implementation of `_.reduce` and `_.reduceRight` without support
     * for callback shorthands and `this` binding, which iterates over `collection`
     * using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} accumulator The initial value.
     * @param {boolean} initFromCollection Specify using the first or last element
     *  of `collection` as the initial value.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @returns {*} Returns the accumulated value.
     */ function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
            eachFunc(collection, function(value, index, collection) {
                accumulator = initFromCollection ? (initFromCollection = false, value) : iteratee(accumulator, value, index, collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `setData` without support for hot loop detection.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            start = start == null ? 0 : +start || 0;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : +end || 0;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortBy` which uses `comparer` to define
     * the sort order of `array` and replaces criteria objects with their
     * corresponding values.
     *
     * @private
     * @param {Array} array The array to sort.
     * @param {Function} comparer The function to define sort order.
     * @returns {Array} Returns `array`.
     */ function baseSortBy(array, comparer) {
            var length = array.length;
            array.sort(comparer);
            while(length--)array[length] = array[length].value;
            return array;
        }
        /**
     * The base implementation of `_.sortByOrder` without param guards.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseSortByOrder(collection, iteratees, orders) {
            var callback = getCallback(), index = -1;
            iteratees = arrayMap(iteratees, function(iteratee) {
                return callback(iteratee);
            });
            var result = baseMap(collection, function(value) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.sum` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */ function baseSum(collection, iteratee) {
            var result = 0;
            baseEach(collection, function(value, index, collection) {
                result += +iteratee(value, index, collection) || 0;
            });
            return result;
        }
        /**
     * The base implementation of `_.uniq` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The function invoked per iteration.
     * @returns {Array} Returns the new duplicate-value-free array.
     */ function baseUniq(array, iteratee) {
            var index = -1, indexOf = getIndexOf(), length = array.length, isCommon = indexOf == baseIndexOf, isLarge = isCommon && length >= LARGE_ARRAY_SIZE, seen = isLarge ? createCache() : null, result = [];
            if (seen) {
                indexOf = cacheIndexOf;
                isCommon = false;
            } else {
                isLarge = false;
                seen = iteratee ? [] : result;
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value, index, array) : value;
                if (isCommon && value === value) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (indexOf(seen, computed, 0) < 0) {
                    if (iteratee || isLarge) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.values` and `_.valuesIn` which creates an
     * array of `object` property values corresponding to the property names
     * of `props`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} props The property names to get values for.
     * @returns {Object} Returns the array of property values.
     */ function baseValues(object, props) {
            var index = -1, length = props.length, result = Array(length);
            while(++index < length)result[index] = object[props[index]];
            return result;
        }
        /**
     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
     * and `_.takeWhile` without support for callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to peform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            var index = -1, length = actions.length;
            while(++index < length){
                var action = actions[index];
                result = action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }
            return result;
        }
        /**
     * Performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function binaryIndex(array, value, retHighest) {
            var low = 0, high = array ? array.length : low;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if ((retHighest ? computed <= value : computed < value) && computed !== null) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return binaryIndexBy(array, value, identity, retHighest);
        }
        /**
     * This function is like `binaryIndex` except that it invokes `iteratee` for
     * `value` and each element of `array` to compute their sort ranking. The
     * iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function binaryIndexBy(array, value, iteratee, retHighest) {
            value = iteratee(value);
            var low = 0, high = array ? array.length : 0, valIsNaN = value !== value, valIsNull = value === null, valIsUndef = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), isDef = computed !== undefined, isReflexive = computed === computed;
                if (valIsNaN) var setLow = isReflexive || retHighest;
                else if (valIsNull) setLow = isReflexive && isDef && (retHighest || computed != null);
                else if (valIsUndef) setLow = isReflexive && (retHighest || isDef);
                else if (computed == null) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * A specialized version of `baseCallback` which only supports `this` binding
     * and specifying the number of arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */ function bindCallback(func, thisArg, argCount) {
            if (typeof func != 'function') return identity;
            if (thisArg === undefined) return func;
            switch(argCount){
                case 1:
                    return function(value) {
                        return func.call(thisArg, value);
                    };
                case 3:
                    return function(value, index, collection) {
                        return func.call(thisArg, value, index, collection);
                    };
                case 4:
                    return function(accumulator, value, index, collection) {
                        return func.call(thisArg, accumulator, value, index, collection);
                    };
                case 5:
                    return function(value, other, key, object, source) {
                        return func.call(thisArg, value, other, key, object, source);
                    };
            }
            return function() {
                return func.apply(thisArg, arguments);
            };
        }
        /**
     * Creates a clone of the given array buffer.
     *
     * @private
     * @param {ArrayBuffer} buffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function bufferClone(buffer) {
            var result = new ArrayBuffer(buffer.byteLength), view = new Uint8Array(result);
            view.set(new Uint8Array(buffer));
            return result;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders) {
            var holdersLength = holders.length, argsIndex = -1, argsLength = nativeMax(args.length - holdersLength, 0), leftIndex = -1, leftLength = partials.length, result = Array(leftLength + argsLength);
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)result[holders[argsIndex]] = args[argsIndex];
            while(argsLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders) {
            var holdersIndex = -1, holdersLength = holders.length, argsIndex = -1, argsLength = nativeMax(args.length - holdersLength, 0), rightIndex = -1, rightLength = partials.length, result = Array(argsLength + rightLength);
            while(++argsIndex < argsLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
     *
     * @private
     * @param {Function} setter The function to set keys and values of the accumulator object.
     * @param {Function} [initializer] The function to initialize the accumulator object.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee, thisArg) {
                var result = initializer ? initializer() : {};
                iteratee = getCallback(iteratee, thisArg, 3);
                if (isArray(collection)) {
                    var index = -1, length = collection.length;
                    while(++index < length){
                        var value = collection[index];
                        setter(result, value, iteratee(value, index, collection), collection);
                    }
                } else baseEach(collection, function(value, key, collection) {
                    setter(result, value, iteratee(value, key, collection), collection);
                });
                return result;
            };
        }
        /**
     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return restParam(function(object, sources) {
                var index = -1, length = object == null ? 0 : sources.length, customizer = length > 2 ? sources[length - 2] : undefined, guard = length > 2 ? sources[2] : undefined, thisArg = length > 1 ? sources[length - 1] : undefined;
                if (typeof customizer == 'function') {
                    customizer = bindCallback(customizer, thisArg, 5);
                    length -= 2;
                } else {
                    customizer = typeof thisArg == 'function' ? thisArg : undefined;
                    length -= customizer ? 1 : 0;
                }
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                var length = collection ? getLength(collection) : 0;
                if (!isLength(length)) return eachFunc(collection, iteratee);
                var index = fromRight ? length : -1, iterable = toObject(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var iterable = toObject(object), props = keysFunc(object), length = props.length, index = fromRight ? length : -1;
                while(fromRight ? index-- : ++index < length){
                    var key = props[index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` and invokes it with the `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new bound function.
     */ function createBindWrapper(func, thisArg) {
            var Ctor = createCtorWrapper(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(thisArg, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a `Set` cache object to optimize linear searches of large arrays.
     *
     * @private
     * @param {Array} [values] The values to cache.
     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
     */ function createCache(values) {
            return nativeCreate && Set ? new SetCache(values) : null;
        }
        /**
     * Creates a function that produces compound words out of the words in a
     * given string.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                var index = -1, array = words(deburr(string)), length = array.length, result = '';
                while(++index < length)result = callback(result, array[index], index);
                return result;
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtorWrapper(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors.
                // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a `_.curry` or `_.curryRight` function.
     *
     * @private
     * @param {boolean} flag The curry bit flag.
     * @returns {Function} Returns the new curry function.
     */ function createCurry(flag) {
            function curryFunc(func, arity, guard) {
                if (guard && isIterateeCall(func, arity, guard)) arity = undefined;
                var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
                result.placeholder = curryFunc.placeholder;
                return result;
            }
            return curryFunc;
        }
        /**
     * Creates a `_.defaults` or `_.defaultsDeep` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Function} Returns the new defaults function.
     */ function createDefaults(assigner, customizer) {
            return restParam(function(args) {
                var object = args[0];
                if (object == null) return object;
                args.push(customizer);
                return assigner.apply(undefined, args);
            });
        }
        /**
     * Creates a `_.max` or `_.min` function.
     *
     * @private
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {Function} Returns the new extremum function.
     */ function createExtremum(comparator, exValue) {
            return function(collection, iteratee, thisArg) {
                if (thisArg && isIterateeCall(collection, iteratee, thisArg)) iteratee = undefined;
                iteratee = getCallback(iteratee, thisArg, 3);
                if (iteratee.length == 1) {
                    collection = isArray(collection) ? collection : toIterable(collection);
                    var result = arrayExtremum(collection, iteratee, comparator, exValue);
                    if (!(collection.length && result === exValue)) return result;
                }
                return baseExtremum(collection, iteratee, comparator, exValue);
            };
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */ function createFind(eachFunc, fromRight) {
            return function(collection, predicate, thisArg) {
                predicate = getCallback(predicate, thisArg, 3);
                if (isArray(collection)) {
                    var index = baseFindIndex(collection, predicate, fromRight);
                    return index > -1 ? collection[index] : undefined;
                }
                return baseFind(collection, predicate, eachFunc);
            };
        }
        /**
     * Creates a `_.findIndex` or `_.findLastIndex` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */ function createFindIndex(fromRight) {
            return function(array, predicate, thisArg) {
                if (!(array && array.length)) return -1;
                predicate = getCallback(predicate, thisArg, 3);
                return baseFindIndex(array, predicate, fromRight);
            };
        }
        /**
     * Creates a `_.findKey` or `_.findLastKey` function.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new find function.
     */ function createFindKey(objectFunc) {
            return function(object, predicate, thisArg) {
                predicate = getCallback(predicate, thisArg, 3);
                return baseFind(object, predicate, objectFunc, true);
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return function() {
                var wrapper, length = arguments.length, index = fromRight ? length : -1, leftIndex = 0, funcs = Array(length);
                while(fromRight ? index-- : ++index < length){
                    var func = funcs[leftIndex++] = arguments[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? -1 : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            };
        }
        /**
     * Creates a function for `_.forEach` or `_.forEachRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */ function createForEach(arrayFunc, eachFunc) {
            return function(collection, iteratee, thisArg) {
                return typeof iteratee == 'function' && thisArg === undefined && isArray(collection) ? arrayFunc(collection, iteratee) : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
            };
        }
        /**
     * Creates a function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */ function createForIn(objectFunc) {
            return function(object, iteratee, thisArg) {
                if (typeof iteratee != 'function' || thisArg !== undefined) iteratee = bindCallback(iteratee, thisArg, 3);
                return objectFunc(object, iteratee, keysIn);
            };
        }
        /**
     * Creates a function for `_.forOwn` or `_.forOwnRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */ function createForOwn(objectFunc) {
            return function(object, iteratee, thisArg) {
                if (typeof iteratee != 'function' || thisArg !== undefined) iteratee = bindCallback(iteratee, thisArg, 3);
                return objectFunc(object, iteratee);
            };
        }
        /**
     * Creates a function for `_.mapKeys` or `_.mapValues`.
     *
     * @private
     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
     * @returns {Function} Returns the new map function.
     */ function createObjectMapper(isMapKeys) {
            return function(object, iteratee, thisArg) {
                var result = {};
                iteratee = getCallback(iteratee, thisArg, 3);
                baseForOwn(object, function(value, key, object) {
                    var mapped = iteratee(value, key, object);
                    key = isMapKeys ? mapped : key;
                    value = isMapKeys ? value : mapped;
                    result[key] = value;
                });
                return result;
            };
        }
        /**
     * Creates a function for `_.padLeft` or `_.padRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify padding from the right.
     * @returns {Function} Returns the new pad function.
     */ function createPadDir(fromRight) {
            return function(string, length, chars) {
                string = baseToString(string);
                return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
            };
        }
        /**
     * Creates a `_.partial` or `_.partialRight` function.
     *
     * @private
     * @param {boolean} flag The partial bit flag.
     * @returns {Function} Returns the new partial function.
     */ function createPartial(flag) {
            var partialFunc = restParam(function(func, partials) {
                var holders = replaceHolders(partials, partialFunc.placeholder);
                return createWrapper(func, flag, undefined, partials, holders);
            });
            return partialFunc;
        }
        /**
     * Creates a function for `_.reduce` or `_.reduceRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */ function createReduce(arrayFunc, eachFunc) {
            return function(collection, iteratee, accumulator, thisArg) {
                var initFromArray = arguments.length < 3;
                return typeof iteratee == 'function' && thisArg === undefined && isArray(collection) ? arrayFunc(collection, iteratee, accumulator, initFromArray) : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
            };
        }
        /**
     * Creates a function that wraps `func` and invokes it with optional `this`
     * binding of, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & ARY_FLAG, isBind = bitmask & BIND_FLAG, isBindKey = bitmask & BIND_KEY_FLAG, isCurry = bitmask & CURRY_FLAG, isCurryBound = bitmask & CURRY_BOUND_FLAG, isCurryRight = bitmask & CURRY_RIGHT_FLAG, Ctor = isBindKey ? undefined : createCtorWrapper(func);
            function wrapper() {
                // Avoid `arguments` object use disqualifying optimizations by
                // converting it to an array before providing it to other functions.
                var length = arguments.length, index = length, args = Array(length);
                while(index--)args[index] = arguments[index];
                if (partials) args = composeArgs(args, partials, holders);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight);
                if (isCurry || isCurryRight) {
                    var placeholder = wrapper.placeholder, argsHolders = replaceHolders(args, placeholder);
                    length -= argsHolders.length;
                    if (length < arity) {
                        var newArgPos = argPos ? arrayCopy(argPos) : undefined, newArity = nativeMax(arity - length, 0), newsHolders = isCurry ? argsHolders : undefined, newHoldersRight = isCurry ? undefined : argsHolders, newPartials = isCurry ? args : undefined, newPartialsRight = isCurry ? undefined : args;
                        bitmask |= isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG;
                        bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
                        if (!isCurryBound) bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
                        var newData = [
                            func,
                            bitmask,
                            thisArg,
                            newPartials,
                            newsHolders,
                            newPartialsRight,
                            newHoldersRight,
                            newArgPos,
                            ary,
                            newArity
                        ], result = createHybridWrapper.apply(undefined, newData);
                        if (isLaziable(func)) setData(result, newData);
                        result.placeholder = placeholder;
                        return result;
                    }
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                if (argPos) args = reorder(args, argPos);
                if (isAry && ary < args.length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtorWrapper(func);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates the padding required for `string` based on the given `length`.
     * The `chars` string is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {string} string The string to create padding for.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the pad for `string`.
     */ function createPadding(string, length, chars) {
            var strLength = string.length;
            length = +length;
            if (strLength >= length || !nativeIsFinite(length)) return '';
            var padLength = length - strLength;
            chars = chars == null ? ' ' : chars + '';
            return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
        }
        /**
     * Creates a function that wraps `func` and invokes it with the optional `this`
     * binding of `thisArg` and the `partials` prepended to those provided to
     * the wrapper.
     *
     * @private
     * @param {Function} func The function to partially apply arguments to.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to the new function.
     * @returns {Function} Returns the new bound function.
     */ function createPartialWrapper(func, bitmask, thisArg, partials) {
            var isBind = bitmask & BIND_FLAG, Ctor = createCtorWrapper(func);
            function wrapper() {
                // Avoid `arguments` object use disqualifying optimizations by
                // converting it to an array before providing it `func`.
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength);
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                precision = precision === undefined ? 0 : +precision || 0;
                if (precision) {
                    precision = pow(10, precision);
                    return func(number * precision) / precision;
                }
                return func(number);
            };
        }
        /**
     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
     *
     * @private
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {Function} Returns the new index function.
     */ function createSortedIndex(retHighest) {
            return function(array, value, iteratee, thisArg) {
                var callback = getCallback(iteratee);
                return iteratee == null && callback === baseCallback ? binaryIndex(array, value, retHighest) : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags.
     *  The bitmask may be composed of the following flags:
     *     1 - `_.bind`
     *     2 - `_.bindKey`
     *     4 - `_.curry` or `_.curryRight` of a bound function
     *     8 - `_.curry`
     *    16 - `_.curryRight`
     *    32 - `_.partial`
     *    64 - `_.partialRight`
     *   128 - `_.rearg`
     *   256 - `_.ary`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            length -= holders ? holders.length : 0;
            if (bitmask & PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func), newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) {
                mergeData(newData, data);
                bitmask = newData[1];
                arity = newData[9];
            }
            newData[9] = arity == null ? isBindKey ? 0 : func.length : nativeMax(arity - length, 0) || 0;
            if (bitmask == BIND_FLAG) var result = createBindWrapper(newData[0], newData[2]);
            else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) result = createPartialWrapper.apply(undefined, newData);
            else result = createHybridWrapper.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setter(result, newData);
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing arrays.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
            var index = -1, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isLoose && othLength > arrLength)) return false;
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index], result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
                if (result !== undefined) {
                    if (result) continue;
                    return false;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (isLoose) {
                    if (!arraySome(other, function(othValue) {
                        return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
                    })) return false;
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) return false;
            }
            return true;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag) {
            switch(tag){
                case boolTag:
                case dateTag:
                    // Coerce dates and booleans to numbers, dates to milliseconds and booleans
                    // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
                    return +object == +other;
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case numberTag:
                    // Treat `NaN` vs. `NaN` as equal.
                    return object != +object ? other != +other : object == +other;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings primitives and string
                    // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
                    return object == other + '';
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
            var objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
            if (objLength != othLength && !isLoose) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            var skipCtor = isLoose;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key], result = customizer ? customizer(isLoose ? othValue : objValue, isLoose ? objValue : othValue, key) : undefined;
                // Recursively compare objects (susceptible to call stack limits).
                if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) return false;
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (!skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) return false;
            }
            return true;
        }
        /**
     * Gets the appropriate "callback" function. If the `_.callback` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseCallback` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function} Returns the chosen function or its result.
     */ function getCallback(func, thisArg, argCount) {
            var result = lodash.callback || callback;
            result = result === callback ? baseCallback : result;
            return argCount ? result(func, thisArg, argCount) : result;
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name, array = realNames[result], length = array ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseIndexOf` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function|number} Returns the chosen function or its result.
     */ function getIndexOf(collection, target, fromIndex) {
            var result = lodash.indexOf || indexOf;
            result = result === indexOf ? baseIndexOf : result;
            return collection ? result(collection, target, fromIndex) : result;
        }
        /**
     * Gets the "length" property value of `object`.
     *
     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
     * that affects Safari on at least iOS 8.1-8.3 ARM64.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {*} Returns the "length" value.
     */ var getLength = baseProperty('length');
        /**
     * Gets the propery names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = pairs(object), length = result.length;
            while(length--)result[length][2] = isStrictComparable(result[length][1]);
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = object == null ? undefined : object[key];
            return isNative(value) ? value : undefined;
        }
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add array properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            var Ctor = object.constructor;
            if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) Ctor = Object;
            return new Ctor;
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return bufferClone(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    var buffer = object.buffer;
                    return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    var result = new Ctor(object.source, reFlags.exec(object));
                    result.lastIndex = object.lastIndex;
            }
            return result;
        }
        /**
     * Invokes the method at `path` on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function invokePath(object, path, args) {
            if (object != null && !isKey(path, object)) {
                path = toPath(path);
                object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
                path = last(path);
            }
            var func = object == null ? object : object[path];
            return func == null ? undefined : func.apply(object, args);
        }
        /**
     * Checks if `value` is array-like.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     */ function isArrayLike(value) {
            return value != null && isLength(getLength(value));
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            value = typeof value == 'number' || reIsUint.test(value) ? +value : -1;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the provided arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
                var other = object[index];
                return value === value ? value === other : other !== other;
            }
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            var type = typeof value;
            if (type == 'string' && reIsPlainProp.test(value) || type == 'number') return true;
            if (isArray(value)) return false;
            var result = !reIsDeepProp.test(value);
            return result || object != null && value in toObject(object);
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func);
            if (!(funcName in LazyWrapper.prototype)) return false;
            var other = lodash[funcName];
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers required to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
     * augment function arguments, making the order in which they are executed important,
     * preventing the merging of metadata. However, we make an exception for a safe
     * common case where curried functions have `_.ary` and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < ARY_FLAG;
            var isCombo = srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG || srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8] || srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & BIND_FLAG ? 0 : CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = arrayCopy(value);
            // Use source `ary` if it's smaller.
            if (srcBitmask & ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */ function mergeDefaults(objectValue, sourceValue) {
            return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
        }
        /**
     * A specialized version of `_.pick` which picks `object` properties specified
     * by `props`.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} props The property names to pick.
     * @returns {Object} Returns the new object.
     */ function pickByArray(object, props) {
            object = toObject(object);
            var index = -1, length = props.length, result = {};
            while(++index < length){
                var key = props[index];
                if (key in object) result[key] = object[key];
            }
            return result;
        }
        /**
     * A specialized version of `_.pick` which picks `object` properties `predicate`
     * returns truthy for.
     *
     * @private
     * @param {Object} object The source object.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Object} Returns the new object.
     */ function pickByCallback(object, predicate) {
            var result = {};
            baseForIn(object, function(value, key, object) {
                if (predicate(value, key, object)) result[key] = value;
            });
            return result;
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = arrayCopy(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity function
     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = function() {
            var count = 0, lastCalled = 0;
            return function(key, value) {
                var stamp = now(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return key;
                } else count = 0;
                return baseSetData(key, value);
            };
        }();
        /**
     * A fallback implementation of `Object.keys` which creates an array of the
     * own enumerable property names of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function shimKeys(object) {
            var props = keysIn(object), propsLength = props.length, length = propsLength && object.length;
            var allowIndexes = !!length && isLength(length) && (isArray(object) || isArguments(object));
            var index = -1, result = [];
            while(++index < propsLength){
                var key = props[index];
                if (allowIndexes && isIndex(key, length) || hasOwnProperty.call(object, key)) result.push(key);
            }
            return result;
        }
        /**
     * Converts `value` to an array-like object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array|Object} Returns the array-like object.
     */ function toIterable(value) {
            if (value == null) return [];
            if (!isArrayLike(value)) return values(value);
            return isObject(value) ? value : Object(value);
        }
        /**
     * Converts `value` to an object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Object} Returns the object.
     */ function toObject(value) {
            return isObject(value) ? value : Object(value);
        }
        /**
     * Converts `value` to property path array if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array} Returns the property path array.
     */ function toPath(value) {
            if (isArray(value)) return value;
            var result = [];
            baseToString(value).replace(rePropName, function(match, number, quote, string) {
                result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            return wrapper instanceof LazyWrapper ? wrapper.clone() : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `collection` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new array containing chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size == null) size = 1;
            else size = nativeMax(nativeFloor(size) || 1, 1);
            var index = 0, length = array ? array.length : 0, resIndex = -1, result = Array(nativeCeil(length / size));
            while(index < length)result[++resIndex] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array ? array.length : 0, resIndex = -1, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[++resIndex] = value;
            }
            return result;
        }
        /**
     * Creates an array of unique `array` values not included in the other
     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The arrays of values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.difference([1, 2, 3], [4, 2]);
     * // => [1, 3]
     */ var difference = restParam(function(array, values) {
            return isObjectLike(array) && isArrayLike(array) ? baseDifference(array, baseFlatten(values, false, true)) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array ? array.length : 0;
            if (!length) return [];
            if (guard ? isIterateeCall(array, n, guard) : n == null) n = 1;
            return baseSlice(array, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array ? array.length : 0;
            if (!length) return [];
            if (guard ? isIterateeCall(array, n, guard) : n == null) n = 1;
            n = length - (+n || 0);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that match the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [1]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
     * // => ['barney']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate, thisArg) {
            return array && array.length ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropWhile(users, 'active', false), 'user');
     * // => ['pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate, thisArg) {
            return array && array.length ? baseWhile(array, getCallback(predicate, thisArg, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8], '*', 1, 2);
     * // => [4, '*', 8]
     */ function fill(array, value, start, end) {
            var length = array ? array.length : 0;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(chr) {
     *   return chr.user == 'barney';
     * });
     * // => 0
     *
     * // using the `_.matches` callback shorthand
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findIndex(users, 'active', false);
     * // => 0
     *
     * // using the `_.property` callback shorthand
     * _.findIndex(users, 'active');
     * // => 2
     */ var findIndex = createFindIndex();
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(chr) {
     *   return chr.user == 'pebbles';
     * });
     * // => 2
     *
     * // using the `_.matches` callback shorthand
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastIndex(users, 'active', false);
     * // => 2
     *
     * // using the `_.property` callback shorthand
     * _.findLastIndex(users, 'active');
     * // => 0
     */ var findLastIndex = createFindIndex(true);
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias head
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.first([1, 2, 3]);
     * // => 1
     *
     * _.first([]);
     * // => undefined
     */ function first(array) {
            return array ? array[0] : undefined;
        }
        /**
     * Flattens a nested array. If `isDeep` is `true` the array is recursively
     * flattened, otherwise it is only flattened a single level.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, 3, [4]]]);
     * // => [1, 2, 3, [4]]
     *
     * // using `isDeep`
     * _.flatten([1, [2, 3, [4]]], true);
     * // => [1, 2, 3, 4]
     */ function flatten(array, isDeep, guard) {
            var length = array ? array.length : 0;
            if (guard && isIterateeCall(array, isDeep, guard)) isDeep = false;
            return length ? baseFlatten(array, isDeep) : [];
        }
        /**
     * Recursively flattens a nested array.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to recursively flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, 3, [4]]]);
     * // => [1, 2, 3, 4]
     */ function flattenDeep(array) {
            var length = array ? array.length : 0;
            return length ? baseFlatten(array, true) : [];
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
     * performs a faster binary search.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
     *  to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // using `fromIndex`
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     *
     * // performing a binary search
     * _.indexOf([1, 1, 2, 2], 2, true);
     * // => 2
     */ function indexOf(array, value, fromIndex) {
            var length = array ? array.length : 0;
            if (!length) return -1;
            if (typeof fromIndex == 'number') fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
            else if (fromIndex) {
                var index = binaryIndex(array, value);
                if (index < length && (value === value ? value === array[index] : array[index] !== array[index])) return index;
                return -1;
            }
            return baseIndexOf(array, value, fromIndex || 0);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            return dropRight(array, 1);
        }
        /**
     * Creates an array of unique values that are included in all of the provided
     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of shared values.
     * @example
     * _.intersection([1, 2], [4, 2], [2, 1]);
     * // => [2]
     */ var intersection = restParam(function(arrays) {
            var othLength = arrays.length, othIndex = othLength, caches = Array(length), indexOf = getIndexOf(), isCommon = indexOf == baseIndexOf, result = [];
            while(othIndex--){
                var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
                caches[othIndex] = isCommon && value.length >= 120 ? createCache(othIndex && value) : null;
            }
            var array = arrays[0], index = -1, length = array ? array.length : 0, seen = caches[0];
            outer: while(++index < length){
                value = array[index];
                if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
                    var othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) continue outer;
                    }
                    if (seen) seen.push(value);
                    result.push(value);
                }
            }
            return result;
        });
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array ? array.length : 0;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
     *  or `true` to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // using `fromIndex`
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     *
     * // performing a binary search
     * _.lastIndexOf([1, 1, 2, 2], 2, true);
     * // => 3
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array ? array.length : 0;
            if (!length) return -1;
            var index = length;
            if (typeof fromIndex == 'number') index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
            else if (fromIndex) {
                index = binaryIndex(array, value, true) - 1;
                var other = array[index];
                if (value === value ? value === other : other !== other) return index;
                return -1;
            }
            if (value !== value) return indexOfNaN(array, index, true);
            while(index--){
                if (array[index] === value) return index;
            }
            return -1;
        }
        /**
     * Removes all provided values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3, 1, 2, 3];
     *
     * _.pull(array, 2, 3);
     * console.log(array);
     * // => [1, 1]
     */ function pull() {
            var args = arguments, array = args[0];
            if (!(array && array.length)) return array;
            var index = 0, indexOf = getIndexOf(), length = args.length;
            while(++index < length){
                var fromIndex = 0, value = args[index];
                while((fromIndex = indexOf(array, value, fromIndex)) > -1)splice.call(array, fromIndex, 1);
            }
            return array;
        }
        /**
     * Removes elements from `array` corresponding to the given indexes and returns
     * an array of the removed elements. Indexes may be specified as an array of
     * indexes or as individual arguments.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [5, 10, 15, 20];
     * var evens = _.pullAt(array, 1, 3);
     *
     * console.log(array);
     * // => [5, 15]
     *
     * console.log(evens);
     * // => [10, 20]
     */ var pullAt = restParam(function(array, indexes) {
            indexes = baseFlatten(indexes);
            var result = baseAt(array, indexes);
            basePullAt(array, indexes.sort(baseCompareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate, thisArg) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getCallback(predicate, thisArg, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias tail
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.rest([1, 2, 3]);
     * // => [2, 3]
     */ function rest(array) {
            return drop(array, 1);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of `Array#slice` to support node
     * lists in IE < 9 and to ensure dense arrays are returned.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array ? array.length : 0;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value` should
     * be inserted into `array` in order to maintain its sort order. If an iteratee
     * function is provided it is invoked for `value` and each element of `array`
     * to compute their sort ranking. The iteratee is bound to `thisArg` and
     * invoked with one argument; (value).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     *
     * _.sortedIndex([4, 4, 5, 5], 5);
     * // => 2
     *
     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
     *
     * // using an iteratee function
     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
     *   return this.data[word];
     * }, dict);
     * // => 1
     *
     * // using the `_.property` callback shorthand
     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
     * // => 1
     */ var sortedIndex = createSortedIndex();
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 4, 5, 5], 5);
     * // => 4
     */ var sortedLastIndex = createSortedIndex(true);
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            var length = array ? array.length : 0;
            if (!length) return [];
            if (guard ? isIterateeCall(array, n, guard) : n == null) n = 1;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array ? array.length : 0;
            if (!length) return [];
            if (guard ? isIterateeCall(array, n, guard) : n == null) n = 1;
            n = length - (+n || 0);
            return baseSlice(array, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
     * and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [2, 3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
     * // => []
     */ function takeRightWhile(array, predicate, thisArg) {
            return array && array.length ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [1, 2]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false},
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeWhile(users, 'active', false), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeWhile(users, 'active'), 'user');
     * // => []
     */ function takeWhile(array, predicate, thisArg) {
            return array && array.length ? baseWhile(array, getCallback(predicate, thisArg, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all of the provided arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([1, 2], [4, 2], [2, 1]);
     * // => [1, 2, 4]
     */ var union = restParam(function(arrays) {
            return baseUniq(baseFlatten(arrays, false, true));
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurence of each element
     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
     * for sorted arrays. If an iteratee function is provided it is invoked for
     * each element in the array to generate the criterion by which uniqueness
     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, array).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias unique
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {boolean} [isSorted] Specify the array is sorted.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new duplicate-value-free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     *
     * // using `isSorted`
     * _.uniq([1, 1, 2], true);
     * // => [1, 2]
     *
     * // using an iteratee function
     * _.uniq([1, 2.5, 1.5, 2], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => [1, 2.5]
     *
     * // using the `_.property` callback shorthand
     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniq(array, isSorted, iteratee, thisArg) {
            var length = array ? array.length : 0;
            if (!length) return [];
            if (isSorted != null && typeof isSorted != 'boolean') {
                thisArg = iteratee;
                iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
                isSorted = false;
            }
            var callback = getCallback();
            if (!(iteratee == null && callback === baseCallback)) iteratee = callback(iteratee, thisArg, 3);
            return isSorted && getIndexOf() == baseIndexOf ? sortedUniq(array, iteratee) : baseUniq(array, iteratee);
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     *
     * _.unzip(zipped);
     * // => [['fred', 'barney'], [30, 40], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var index = -1, length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLike(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            var result = Array(length);
            while(++index < length)result[index] = arrayMap(array, baseProperty(index));
            return result;
        }
        /**
     * This method is like `_.unzip` except that it accepts an iteratee to specify
     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee] The function to combine regrouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee, thisArg) {
            var length = array ? array.length : 0;
            if (!length) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            iteratee = bindCallback(iteratee, thisArg, 4);
            return arrayMap(result, function(group) {
                return arrayReduce(group, iteratee, undefined, true);
            });
        }
        /**
     * Creates an array excluding all provided values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to filter.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.without([1, 2, 1, 3], 1, 2);
     * // => [3]
     */ var without = restParam(function(array, values) {
            return isArrayLike(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the provided arrays.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of values.
     * @example
     *
     * _.xor([1, 2], [4, 2]);
     * // => [1, 4]
     */ function xor() {
            var index = -1, length = arguments.length;
            while(++index < length){
                var array = arguments[index];
                if (isArrayLike(array)) var result = result ? arrayPush(baseDifference(result, array), baseDifference(array, result)) : array;
            }
            return result ? baseUniq(result) : [];
        }
        /**
     * Creates an array of grouped elements, the first of which contains the first
     * elements of the given arrays, the second of which contains the second elements
     * of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     */ var zip = restParam(unzip);
        /**
     * The inverse of `_.pairs`; this method returns an object composed from arrays
     * of property names and values. Provide either a single two dimensional array,
     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
     * and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @alias object
     * @category Array
     * @param {Array} props The property names.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject([['fred', 30], ['barney', 40]]);
     * // => { 'fred': 30, 'barney': 40 }
     *
     * _.zipObject(['fred', 'barney'], [30, 40]);
     * // => { 'fred': 30, 'barney': 40 }
     */ function zipObject(props, values) {
            var index = -1, length = props ? props.length : 0, result = {};
            if (length && !values && !isArray(props[0])) values = [];
            while(++index < length){
                var key = props[index];
                if (values) result[key] = values[index];
                else if (key) result[key[0]] = key[1];
            }
            return result;
        }
        /**
     * This method is like `_.zip` except that it accepts an iteratee to specify
     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee] The function to combine grouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
     * // => [111, 222]
     */ var zipWith = restParam(function(arrays) {
            var length = arrays.length, iteratee = length > 2 ? arrays[length - 2] : undefined, thisArg = length > 1 ? arrays[length - 1] : undefined;
            if (length > 2 && typeof iteratee == 'function') length -= 2;
            else {
                iteratee = length > 1 && typeof thisArg == 'function' ? (--length, thisArg) : undefined;
                thisArg = undefined;
            }
            arrays.length = length;
            return unzipWith(arrays, iteratee, thisArg);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object that wraps `value` with explicit method
     * chaining enabled.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _.chain(users)
     *   .sortBy('age')
     *   .map(function(chr) {
     *     return chr.user + ' is ' + chr.age;
     *   })
     *   .first()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor is
     * bound to `thisArg` and invoked with one argument; (value). The purpose of
     * this method is to "tap into" a method chain in order to perform operations
     * on intermediate results within the chain.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor, thisArg) {
            interceptor.call(thisArg, value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor, thisArg) {
            return interceptor.call(thisArg, value);
        }
        /**
     * Enables explicit method chaining on the wrapper object.
     *
     * @name chain
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // without explicit chaining
     * _(users).first();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // with explicit chaining
     * _(users).chain()
     *   .first()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chained sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Creates a new array joining a wrapped array with any additional arrays
     * and/or values.
     *
     * @name concat
     * @memberOf _
     * @category Chain
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var wrapped = _(array).concat(2, [3], [[4]]);
     *
     * console.log(wrapped.value());
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ var wrapperConcat = restParam(function(values) {
            values = baseFlatten(values);
            return this.thru(function(array) {
                return arrayConcat(isArray(array) ? array : [
                    toObject(array)
                ], values);
            });
        });
        /**
     * Creates a clone of the chained sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).map(function(value) {
     *   return Math.pow(value, 2);
     * });
     *
     * var other = [3, 4];
     * var otherWrapped = wrapped.plant(other);
     *
     * otherWrapped.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * Reverses the wrapped array so the first element becomes the last, the
     * second element becomes the second to last, and so on.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            var interceptor = function(value) {
                return wrapped && wrapped.__dir__ < 0 ? value : value.reverse();
            };
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        interceptor
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(interceptor);
        }
        /**
     * Produces the result of coercing the unwrapped value to a string.
     *
     * @name toString
     * @memberOf _
     * @category Chain
     * @returns {string} Returns the coerced string value.
     * @example
     *
     * _([1, 2, 3]).toString();
     * // => '1,2,3'
     */ function wrapperToString() {
            return this.value() + '';
        }
        /**
     * Executes the chained sequence to extract the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @alias run, toJSON, valueOf
     * @category Chain
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements corresponding to the given keys, or indexes,
     * of `collection`. Keys may be specified as individual arguments or as arrays
     * of keys.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(number|number[]|string|string[])} [props] The property names
     *  or indexes of elements to pick, specified individually or in arrays.
     * @returns {Array} Returns the new array of picked elements.
     * @example
     *
     * _.at(['a', 'b', 'c'], [0, 2]);
     * // => ['a', 'c']
     *
     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
     * // => ['barney', 'pebbles']
     */ var at = restParam(function(collection, props) {
            return baseAt(collection, baseFlatten(props));
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the number of times the key was returned by `iteratee`.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            hasOwnProperty.call(result, key) ? ++result[key] : result[key] = 1;
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * The predicate is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias all
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'active': false },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.every(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, thisArg) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (thisArg && isIterateeCall(collection, predicate, thisArg)) predicate = undefined;
            if (typeof predicate != 'function' || thisArg !== undefined) predicate = getCallback(predicate, thisArg, 3);
            return func(collection, predicate);
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias select
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.filter([4, 5, 6], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [4, 6]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.filter(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.filter(users, 'active'), 'user');
     * // => ['barney']
     */ function filter(collection, predicate, thisArg) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            predicate = getCallback(predicate, thisArg, 3);
            return func(collection, predicate);
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias detect
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.result(_.find(users, function(chr) {
     *   return chr.age < 40;
     * }), 'user');
     * // => 'barney'
     *
     * // using the `_.matches` callback shorthand
     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.result(_.find(users, 'active', false), 'user');
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.result(_.find(users, 'active'), 'user');
     * // => 'barney'
     */ var find = createFind(baseEach);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(baseEachRight, true);
        /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning the first element that has equivalent property
     * values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
     * // => 'barney'
     *
     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
     * // => 'fred'
     */ function findWhere(collection, source) {
            return find(collection, baseMatches(source));
        }
        /**
     * Iterates over elements of `collection` invoking `iteratee` for each element.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection). Iteratee functions may exit iteration early
     * by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length" property
     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
     * may be used for object iteration.
     *
     * @static
     * @memberOf _
     * @alias each
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEach(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from left to right and returns the array
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
     *   console.log(n, key);
     * });
     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
     */ var forEach = createForEach(arrayEach, baseEach);
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias eachRight
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEachRight(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from right to left and returns the array
     */ var forEachRight = createForEach(arrayEachRight, baseEachRight);
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is an array of the elements responsible for generating the key.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * // using the `_.property` callback shorthand
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else result[key] = [
                value
            ];
        });
        /**
     * Checks if `value` is in `collection` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @alias contains, include
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {*} target The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
     * // => true
     *
     * _.includes('pebbles', 'eb');
     * // => true
     */ function includes(collection, target, fromIndex, guard) {
            var length = collection ? getLength(collection) : 0;
            if (!isLength(length)) {
                collection = values(collection);
                length = collection.length;
            }
            if (typeof fromIndex != 'number' || guard && isIterateeCall(target, fromIndex, guard)) fromIndex = 0;
            else fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex || 0;
            return typeof collection == 'string' || !isArray(collection) && isString(collection) ? fromIndex <= length && collection.indexOf(target, fromIndex) > -1 : !!length && getIndexOf(collection, target, fromIndex) > -1;
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the last element responsible for generating the key. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var keyData = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.indexBy(keyData, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return String.fromCharCode(object.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return this.fromCharCode(object.code);
     * }, String);
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     */ var indexBy = createAggregator(function(result, value, key) {
            result[key] = value;
        });
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `methodName` is a function it is
     * invoked for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invoke([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invoke = restParam(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', isProp = isKey(path), result = isArrayLike(collection) ? Array(collection.length) : [];
            baseEach(collection, function(value) {
                var func = isFunc ? path : isProp && value != null ? value[path] : undefined;
                result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
            });
            return result;
        });
        /**
     * Creates an array of values by running each element in `collection` through
     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
     * `sum`, `uniq`, and `words`
     *
     * @static
     * @memberOf _
     * @alias collect
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function timesThree(n) {
     *   return n * 3;
     * }
     *
     * _.map([1, 2], timesThree);
     * // => [3, 6]
     *
     * _.map({ 'a': 1, 'b': 2 }, timesThree);
     * // => [3, 6] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee, thisArg) {
            var func = isArray(collection) ? arrayMap : baseMap;
            iteratee = getCallback(iteratee, thisArg, 3);
            return func(collection, iteratee);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, while the second of which
     * contains elements `predicate` returns falsey for. The predicate is bound
     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * _.partition([1, 2, 3], function(n) {
     *   return n % 2;
     * });
     * // => [[1, 3], [2]]
     *
     * _.partition([1.2, 2.3, 3.4], function(n) {
     *   return this.floor(n) % 2;
     * }, Math);
     * // => [[1.2, 3.4], [2.3]]
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * var mapper = function(array) {
     *   return _.pluck(array, 'user');
     * };
     *
     * // using the `_.matches` callback shorthand
     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
     * // => [['pebbles'], ['barney', 'fred']]
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.map(_.partition(users, 'active', false), mapper);
     * // => [['barney', 'pebbles'], ['fred']]
     *
     * // using the `_.property` callback shorthand
     * _.map(_.partition(users, 'active'), mapper);
     * // => [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Gets the property value of `path` from all elements in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|string} path The path of the property to pluck.
     * @returns {Array} Returns the property values.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.pluck(users, 'user');
     * // => ['barney', 'fred']
     *
     * var userIndex = _.indexBy(users, 'user');
     * _.pluck(userIndex, 'age');
     * // => [36, 40] (iteration order is not guaranteed)
     */ function pluck(collection, path) {
            return map(collection, property(path));
        }
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` through `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not provided the first element of `collection` is used as the initial
     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
     * and `sortByOrder`
     *
     * @static
     * @memberOf _
     * @alias foldl, inject
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.reduce([1, 2], function(total, n) {
     *   return total + n;
     * });
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     *   return result;
     * }, {});
     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
     */ var reduce = createReduce(arrayReduce, baseEach);
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias foldr
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ var reduceRight = createReduce(arrayReduceRight, baseEachRight);
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.reject([1, 2, 3, 4], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [1, 3]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.reject(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.reject(users, 'active'), 'user');
     * // => ['barney']
     */ function reject(collection, predicate, thisArg) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            predicate = getCallback(predicate, thisArg, 3);
            return func(collection, function(value, index, collection) {
                return !predicate(value, index, collection);
            });
        }
        /**
     * Gets a random element or `n` random elements from a collection.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to sample.
     * @param {number} [n] The number of elements to sample.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {*} Returns the random sample(s).
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     *
     * _.sample([1, 2, 3, 4], 2);
     * // => [3, 1]
     */ function sample(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n == null) {
                collection = toIterable(collection);
                var length = collection.length;
                return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
            }
            var index = -1, result = toArray(collection), length = result.length, lastIndex = length - 1;
            n = nativeMin(n < 0 ? 0 : +n || 0, length);
            while(++index < n){
                var rand = baseRandom(index, lastIndex), value = result[rand];
                result[rand] = result[index];
                result[index] = value;
            }
            result.length = n;
            return result;
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            return sample(collection, POSITIVE_INFINITY);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable properties for objects.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the size of `collection`.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            var length = collection ? getLength(collection) : 0;
            return isLength(length) ? length : keys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * The function returns as soon as it finds a passing value and does not iterate
     * over the entire collection. The predicate is bound to `thisArg` and invoked
     * with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias any
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.some(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, thisArg) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (thisArg && isIterateeCall(collection, predicate, thisArg)) predicate = undefined;
            if (typeof predicate != 'function' || thisArg !== undefined) predicate = getCallback(predicate, thisArg, 3);
            return func(collection, predicate);
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection through `iteratee`. This method performs
     * a stable sort, that is, it preserves the original sort order of equal elements.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return Math.sin(n);
     * });
     * // => [3, 1, 2]
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return this.sin(n);
     * }, Math);
     * // => [3, 1, 2]
     *
     * var users = [
     *   { 'user': 'fred' },
     *   { 'user': 'pebbles' },
     *   { 'user': 'barney' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.sortBy(users, 'user'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */ function sortBy(collection, iteratee, thisArg) {
            if (collection == null) return [];
            if (thisArg && isIterateeCall(collection, iteratee, thisArg)) iteratee = undefined;
            var index = -1;
            iteratee = getCallback(iteratee, thisArg, 3);
            var result = baseMap(collection, function(value, key, collection) {
                return {
                    'criteria': iteratee(value, key, collection),
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, compareAscending);
        }
        /**
     * This method is like `_.sortBy` except that it can sort by multiple iteratees
     * or property names.
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
     *  The iteratees to sort by, specified as individual values or arrays of values.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
     *
     * _.map(_.sortByAll(users, 'user', function(chr) {
     *   return Math.floor(chr.age / 10);
     * }), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */ var sortByAll = restParam(function(collection, iteratees) {
            if (collection == null) return [];
            var guard = iteratees[2];
            if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) iteratees.length = 1;
            return baseSortByOrder(collection, baseFlatten(iteratees), []);
        });
        /**
     * This method is like `_.sortByAll` except that it allows specifying the
     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
     * values are sorted in ascending order. Otherwise, a value is sorted in
     * ascending order if its corresponding order is "asc", and descending if "desc".
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // sort by `user` in ascending order and by `age` in descending order
     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */ function sortByOrder(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (guard && isIterateeCall(iteratees, orders, guard)) orders = undefined;
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseSortByOrder(collection, iteratees, orders);
        }
        /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning an array of all elements that have equivalent
     * property values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
     * ];
     *
     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
     * // => ['barney']
     *
     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
     * // => ['fred']
     */ function where(collection, source) {
            return filter(collection, baseMatches(source));
        }
        /*------------------------------------------------------------------------*/ /**
     * Gets the number of milliseconds that have elapsed since the Unix epoch
     * (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @category Date
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => logs the number of milliseconds it took for the deferred function to be invoked
     */ var now = nativeNow || function() {
            return new Date().getTime();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it is called `n` or more times.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => logs 'done saving!' after the two async saves have completed
     */ function after(n, func) {
            if (typeof func != 'function') {
                if (typeof n == 'function') {
                    var temp = n;
                    n = func;
                    func = temp;
                } else throw new TypeError(FUNC_ERROR_TEXT);
            }
            n = nativeIsFinite(n = +n) ? n : 0;
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that accepts up to `n` arguments ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            if (guard && isIterateeCall(func, n, guard)) n = undefined;
            n = func && n == null ? func.length : nativeMax(+n || 0, 0);
            return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it is called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery('#add').on('click', _.before(5, addContactToList));
     * // => allows adding up to 4 contacts to the list
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') {
                if (typeof n == 'function') {
                    var temp = n;
                    n = func;
                    func = temp;
                } else throw new TypeError(FUNC_ERROR_TEXT);
            }
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and prepends any additional `_.bind` arguments to those provided to the
     * bound function.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind` this method does not set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var greet = function(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * };
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // using placeholders
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = restParam(function(func, thisArg, partials) {
            var bitmask = BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, bind.placeholder);
                bitmask |= PARTIAL_FLAG;
            }
            return createWrapper(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method. Method names may be specified as individual arguments or as arrays
     * of method names. If no method names are provided all enumerable function
     * properties, own and inherited, of `object` are bound.
     *
     * **Note:** This method does not set the "length" property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} [methodNames] The object method names to bind,
     *  specified as individual method names or arrays of method names.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'onClick': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view);
     * jQuery('#docs').on('click', view.onClick);
     * // => logs 'clicked docs' when the element is clicked
     */ var bindAll = restParam(function(object, methodNames) {
            methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);
            var index = -1, length = methodNames.length;
            while(++index < length){
                var key = methodNames[index];
                object[key] = createWrapper(object[key], BIND_FLAG, object);
            }
            return object;
        });
        /**
     * Creates a function that invokes the method at `object[key]` and prepends
     * any additional `_.bindKey` arguments to those provided to the bound function.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist.
     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object the method belongs to.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // using placeholders
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = restParam(function(object, key, partials) {
            var bitmask = BIND_FLAG | BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, bindKey.placeholder);
                bitmask |= PARTIAL_FLAG;
            }
            return createWrapper(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts one or more arguments of `func` that when
     * called either invokes `func` returning its result, if all `func` arguments
     * have been provided, or returns a function that accepts one or more of the
     * remaining `func` arguments, and so on. The arity of `func` may be specified
     * if `func.length` is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ var curry = createCurry(CURRY_FLAG);
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ var curryRight = createCurry(CURRY_RIGHT_FLAG);
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed invocations. Provide an options object to indicate that `func`
     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
     * Subsequent calls to the debounced function return the result of the last
     * `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the debounced function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=false] Specify invoking on the leading
     *  edge of the timeout.
     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
     *  delayed before it is invoked.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // avoid costly calculations while the window size is in flux
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // ensure `batchLog` is invoked once after 1 second of debounced calls
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', _.debounce(batchLog, 250, {
     *   'maxWait': 1000
     * }));
     *
     * // cancel a debounced call
     * var todoChanges = _.debounce(batchLog, 1000);
     * Object.observe(models.todo, todoChanges);
     *
     * Object.observe(models, function(changes) {
     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
     *     todoChanges.cancel();
     *   }
     * }, ['delete']);
     *
     * // ...at some point `models.todo` is changed
     * models.todo.completed = true;
     *
     * // ...before 1 second has passed `models.todo` is deleted
     * // which cancels the debounced `todoChanges` call
     * delete models.todo;
     */ function debounce(func, wait, options) {
            var args, maxTimeoutId, result, stamp, thisArg, timeoutId, trailingCall, lastCalled = 0, maxWait = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = wait < 0 ? 0 : +wait || 0;
            if (options === true) {
                var leading = true;
                trailing = false;
            } else if (isObject(options)) {
                leading = !!options.leading;
                maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function cancel() {
                if (timeoutId) clearTimeout(timeoutId);
                if (maxTimeoutId) clearTimeout(maxTimeoutId);
                lastCalled = 0;
                maxTimeoutId = timeoutId = trailingCall = undefined;
            }
            function complete(isCalled, id) {
                if (id) clearTimeout(id);
                maxTimeoutId = timeoutId = trailingCall = undefined;
                if (isCalled) {
                    lastCalled = now();
                    result = func.apply(thisArg, args);
                    if (!timeoutId && !maxTimeoutId) args = thisArg = undefined;
                }
            }
            function delayed() {
                var remaining = wait - (now() - stamp);
                if (remaining <= 0 || remaining > wait) complete(trailingCall, maxTimeoutId);
                else timeoutId = setTimeout(delayed, remaining);
            }
            function maxDelayed() {
                complete(trailing, timeoutId);
            }
            function debounced() {
                args = arguments;
                stamp = now();
                thisArg = this;
                trailingCall = trailing && (timeoutId || !leading);
                if (maxWait === false) var leadingCall = leading && !timeoutId;
                else {
                    if (!maxTimeoutId && !leading) lastCalled = stamp;
                    var remaining = maxWait - (stamp - lastCalled), isCalled = remaining <= 0 || remaining > maxWait;
                    if (isCalled) {
                        if (maxTimeoutId) maxTimeoutId = clearTimeout(maxTimeoutId);
                        lastCalled = stamp;
                        result = func.apply(thisArg, args);
                    } else if (!maxTimeoutId) maxTimeoutId = setTimeout(maxDelayed, remaining);
                }
                if (isCalled && timeoutId) timeoutId = clearTimeout(timeoutId);
                else if (!timeoutId && wait !== maxWait) timeoutId = setTimeout(delayed, wait);
                if (leadingCall) {
                    isCalled = true;
                    result = func.apply(thisArg, args);
                }
                if (isCalled && !timeoutId && !maxTimeoutId) args = thisArg = undefined;
                return result;
            }
            debounced.cancel = cancel;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // logs 'deferred' after one or more milliseconds
     */ var defer = restParam(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => logs 'later' after one second
     */ var delay = restParam(function(func, wait, args) {
            return baseDelay(func, wait, args);
        });
        /**
     * Creates a function that returns the result of invoking the provided
     * functions with the `this` binding of the created function, where each
     * successive invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow(_.add, square);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the provided functions from right to left.
     *
     * @static
     * @memberOf _
     * @alias backflow, compose
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight(square, _.add);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is coerced to a string and used as the
     * cache key. The `func` is invoked with the `this` binding of the memoized
     * function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoizing function.
     * @example
     *
     * var upperCase = _.memoize(function(string) {
     *   return string.toUpperCase();
     * });
     *
     * upperCase('fred');
     * // => 'FRED'
     *
     * // modifying the result cache
     * upperCase.cache.set('fred', 'BARNEY');
     * upperCase('fred');
     * // => 'BARNEY'
     *
     * // replacing `_.memoize.Cache`
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'barney' };
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'fred' }
     *
     * _.memoize.Cache = WeakMap;
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'barney' }
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result);
                return result;
            };
            memoized.cache = new memoize.Cache;
            return memoized;
        }
        /**
     * Creates a function that runs each argument through a corresponding
     * transform function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms] The functions to transform
     * arguments, specified as individual functions or arrays of functions.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var modded = _.modArgs(function(x, y) {
     *   return [x, y];
     * }, square, doubled);
     *
     * modded(1, 2);
     * // => [1, 4]
     *
     * modded(5, 10);
     * // => [25, 20]
     */ var modArgs = restParam(function(func, transforms) {
            transforms = baseFlatten(transforms);
            if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) throw new TypeError(FUNC_ERROR_TEXT);
            var length = transforms.length;
            return restParam(function(args) {
                var index = nativeMin(args.length, length);
                while(index--)args[index] = transforms[index](args[index]);
                return func.apply(this, args);
            });
        });
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                return !predicate.apply(this, arguments);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first call. The `func` is invoked
     * with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // `initialize` invokes `createApplication` once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with `partial` arguments prepended
     * to those provided to the new function. This method is like `_.bind` except
     * it does **not** alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // using placeholders
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = createPartial(PARTIAL_FLAG);
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to those provided to the new function.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // using placeholders
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = createPartial(PARTIAL_RIGHT_FLAG);
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified indexes where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, 2, 0, 1);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     *
     * var map = _.rearg(_.map, [1, 0]);
     * map(function(n) {
     *   return n * 3;
     * }, [1, 2, 3]);
     * // => [3, 6, 9]
     */ var rearg = restParam(function(func, indexes) {
            return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as an array.
     *
     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.restParam(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function restParam(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = nativeMax(start === undefined ? func.length - 1 : +start || 0, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), rest = Array(length);
                while(++index < length)rest[index] = args[start + index];
                switch(start){
                    case 0:
                        return func.call(this, rest);
                    case 1:
                        return func.call(this, args[0], rest);
                    case 2:
                        return func.call(this, args[0], args[1], rest);
                }
                var otherArgs = Array(start + 1);
                index = -1;
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = rest;
                return func.apply(this, otherArgs);
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the created
     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
     *
     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * // with a Promise
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function(array) {
                return func.apply(this, array);
            };
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed invocations. Provide an options object to indicate
     * that `func` should be invoked on the leading and/or trailing edge of the
     * `wait` timeout. Subsequent calls to the throttled function return the
     * result of the last `func` call.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the throttled function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=true] Specify invoking on the leading
     *  edge of the timeout.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // avoid excessively updating the position while scrolling
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
     *   'trailing': false
     * }));
     *
     * // cancel a trailing throttled call
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (options === false) leading = false;
            else if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': +wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that provides `value` to the wrapper function as its
     * first argument. Any additional arguments provided to the function are
     * appended to those provided to the wrapper function. The wrapper is invoked
     * with the `this` binding of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} wrapper The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            wrapper = wrapper == null ? identity : wrapper;
            return createWrapper(wrapper, PARTIAL_FLAG, undefined, [
                value
            ], []);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
     * otherwise they are assigned by reference. If `customizer` is provided it is
     * invoked to produce the cloned values. If `customizer` returns `undefined`
     * cloning is handled by the method instead. The `customizer` is bound to
     * `thisArg` and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var shallow = _.clone(users);
     * shallow[0] === users[0];
     * // => true
     *
     * var deep = _.clone(users, true);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.clone(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 0
     */ function clone(value, isDeep, customizer, thisArg) {
            if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) isDeep = false;
            else if (typeof isDeep == 'function') {
                thisArg = customizer;
                customizer = isDeep;
                isDeep = false;
            }
            return typeof customizer == 'function' ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1)) : baseClone(value, isDeep);
        }
        /**
     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
     * to produce the cloned values. If `customizer` returns `undefined` cloning
     * is handled by the method instead. The `customizer` is bound to `thisArg`
     * and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the deep cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var deep = _.cloneDeep(users);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.cloneDeep(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 20
     */ function cloneDeep(value, customizer, thisArg) {
            return typeof customizer == 'function' ? baseClone(value, true, bindCallback(customizer, thisArg, 1)) : baseClone(value, true);
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ function gt(value, other) {
            return value > other;
        }
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ function gte(value, other) {
            return value >= other;
        }
        /**
     * Checks if `value` is classified as an `arguments` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ function isArguments(value) {
            return isObjectLike(value) && isArrayLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        }
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(function() { return arguments; }());
     * // => false
     */ var isArray = nativeIsArray || function(value) {
            return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
        };
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && objToString.call(value) == boolTag;
        }
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ function isDate(value) {
            return isObjectLike(value) && objToString.call(value) == dateTag;
        }
        /**
     * Checks if `value` is a DOM element.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
        }
        /**
     * Checks if `value` is empty. A value is considered empty unless it is an
     * `arguments` object, array, string, or jQuery-like collection with a length
     * greater than `0` or an object with own enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Array|Object|string} value The value to inspect.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) || isObjectLike(value) && isFunction(value.splice))) return !value.length;
            return !keys(value).length;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent. If `customizer` is provided it is invoked to compare values.
     * If `customizer` returns `undefined` comparisons are handled by the method
     * instead. The `customizer` is bound to `thisArg` and invoked with three
     * arguments: (value, other [, index|key]).
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. Functions and DOM nodes
     * are **not** supported. Provide a customizer function to extend support
     * for comparing other values.
     *
     * @static
     * @memberOf _
     * @alias eq
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'fred' };
     *
     * object == other;
     * // => false
     *
     * _.isEqual(object, other);
     * // => true
     *
     * // using a customizer callback
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqual(array, other, function(value, other) {
     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
     *     return true;
     *   }
     * });
     * // => true
     */ function isEqual(value, other, customizer, thisArg) {
            customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(10);
     * // => true
     *
     * _.isFinite('10');
     * // => false
     *
     * _.isFinite(true);
     * // => false
     *
     * _.isFinite(Object(10));
     * // => false
     *
     * _.isFinite(Infinity);
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in older versions of Chrome and Safari which return 'function' for regexes
            // and Safari 8 equivalents which return 'object' for typed array constructors.
            return isObject(value) && objToString.call(value) == funcTag;
        }
        /**
     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(1);
     * // => false
     */ function isObject(value) {
            // Avoid a V8 JIT bug in Chrome 19-20.
            // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
            var type = typeof value;
            return !!value && (type == 'object' || type == 'function');
        }
        /**
     * Performs a deep comparison between `object` and `source` to determine if
     * `object` contains equivalent property values. If `customizer` is provided
     * it is invoked to compare values. If `customizer` returns `undefined`
     * comparisons are handled by the method instead. The `customizer` is bound
     * to `thisArg` and invoked with three arguments: (value, other, index|key).
     *
     * **Note:** This method supports comparing properties of arrays, booleans,
     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
     * and DOM nodes are **not** supported. Provide a customizer function to extend
     * support for comparing other values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.isMatch(object, { 'age': 40 });
     * // => true
     *
     * _.isMatch(object, { 'age': 36 });
     * // => false
     *
     * // using a customizer callback
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatch(object, source, function(value, other) {
     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
     * });
     * // => true
     */ function isMatch(object, source, customizer, thisArg) {
            customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
            return baseIsMatch(object, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
     * which returns `true` for `undefined` and other non-numeric values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a native function.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (value == null) return false;
            if (isFunction(value)) return reIsNative.test(fnToString.call(value));
            return isObjectLike(value) && reIsHostCtor.test(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
     * as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isNumber(8.4);
     * // => true
     *
     * _.isNumber(NaN);
     * // => true
     *
     * _.isNumber('8.4');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && objToString.call(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * **Note:** This method assumes objects created by the `Object` constructor
     * have no inherited enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            var Ctor;
            // Exit early for non `Object` objects.
            if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) || !hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor))) return false;
            // IE < 9 iterates inherited properties before own properties. If the first
            // iterated property is an object's own property then there are no inherited
            // enumerable properties.
            var result;
            // In most environments an object's own properties are iterated before
            // its inherited properties. If the last iterated property is an object's
            // own property then there are no inherited enumerable properties.
            baseForIn(value, function(subValue, key) {
                result = key;
            });
            return result === undefined || hasOwnProperty.call(value, result);
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ function isRegExp(value) {
            return isObject(value) && objToString.call(value) == regexpTag;
        }
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || isObjectLike(value) && objToString.call(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ function isTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
        }
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ function lt(value, other) {
            return value < other;
        }
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ function lte(value, other) {
            return value <= other;
        }
        /**
     * Converts `value` to an array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * (function() {
     *   return _.toArray(arguments).slice(1);
     * }(1, 2, 3));
     * // => [2, 3]
     */ function toArray(value) {
            var length = value ? getLength(value) : 0;
            if (!isLength(length)) return values(value);
            if (!length) return [];
            return arrayCopy(value);
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable
     * properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return baseCopy(value, keysIn(value));
        }
        /*------------------------------------------------------------------------*/ /**
     * Recursively merges own enumerable properties of the source object(s), that
     * don't resolve to `undefined` into the destination object. Subsequent sources
     * overwrite property assignments of previous sources. If `customizer` is
     * provided it is invoked to produce the merged values of the destination and
     * source properties. If `customizer` returns `undefined` merging is handled
     * by the method instead. The `customizer` is bound to `thisArg` and invoked
     * with five arguments: (objectValue, sourceValue, key, object, source).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var users = {
     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
     * };
     *
     * var ages = {
     *   'data': [{ 'age': 36 }, { 'age': 40 }]
     * };
     *
     * _.merge(users, ages);
     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
     *
     * // using a customizer callback
     * var object = {
     *   'fruits': ['apple'],
     *   'vegetables': ['beet']
     * };
     *
     * var other = {
     *   'fruits': ['banana'],
     *   'vegetables': ['carrot']
     * };
     *
     * _.merge(object, other, function(a, b) {
     *   if (_.isArray(a)) {
     *     return a.concat(b);
     *   }
     * });
     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
     */ var merge = createAssigner(baseMerge);
        /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object. Subsequent sources overwrite property assignments of previous sources.
     * If `customizer` is provided it is invoked to produce the assigned values.
     * The `customizer` is bound to `thisArg` and invoked with five arguments:
     * (objectValue, sourceValue, key, object, source).
     *
     * **Note:** This method mutates `object` and is based on
     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
     *
     * @static
     * @memberOf _
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using a customizer callback
     * var defaults = _.partialRight(_.assign, function(value, other) {
     *   return _.isUndefined(value) ? other : value;
     * });
     *
     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */ var assign = createAssigner(function(object, source, customizer) {
            return customizer ? assignWith(object, source, customizer) : baseAssign(object, source);
        });
        /**
     * Creates an object that inherits from the given `prototype` object. If a
     * `properties` object is provided its own enumerable properties are assigned
     * to the created object.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties, guard) {
            var result = baseCreate(prototype);
            if (guard && isIterateeCall(prototype, properties, guard)) properties = undefined;
            return properties ? baseAssign(result, properties) : result;
        }
        /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object for all destination properties that resolve to `undefined`. Once a
     * property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */ var defaults = createDefaults(assign, assignDefaults);
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
     * // => { 'user': { 'name': 'barney', 'age': 36 } }
     *
     */ var defaultsDeep = createDefaults(merge, mergeDefaults);
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // using the `_.matches` callback shorthand
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findKey(users, 'active');
     * // => 'barney'
     */ var findKey = createFindKey(baseForOwn);
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => returns `pebbles` assuming `_.findKey` returns `barney`
     *
     * // using the `_.matches` callback shorthand
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ var findLastKey = createFindKey(baseForOwnRight);
        /**
     * Iterates over own and inherited enumerable properties of an object invoking
     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
     */ var forIn = createForIn(baseFor);
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
     */ var forInRight = createForIn(baseForRight);
        /**
     * Iterates over own enumerable properties of an object invoking `iteratee`
     * for each property. The `iteratee` is bound to `thisArg` and invoked with
     * three arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a' and 'b' (iteration order is not guaranteed)
     */ var forOwn = createForOwn(baseForOwn);
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
     */ var forOwnRight = createForOwn(baseForOwnRight);
        /**
     * Creates an array of function property names from all enumerable properties,
     * own and inherited, of `object`.
     *
     * @static
     * @memberOf _
     * @alias methods
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the new array of property names.
     * @example
     *
     * _.functions(_);
     * // => ['after', 'ary', 'assign', ...]
     */ function functions(object) {
            return baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the property value at `path` of `object`. If the resolved value is
     * `undefined` the `defaultValue` is used in its place.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': { 'c': 3 } } };
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b.c');
     * // => true
     *
     * _.has(object, ['a', 'b', 'c']);
     * // => true
     */ function has(object, path) {
            if (object == null) return false;
            var result = hasOwnProperty.call(object, path);
            if (!result && !isKey(path)) {
                path = toPath(path);
                object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
                if (object == null) return false;
                path = last(path);
                result = hasOwnProperty.call(object, path);
            }
            return result || isLength(object.length) && isIndex(path, object.length) && (isArray(object) || isArguments(object));
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite property
     * assignments of previous values unless `multiValue` is `true`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to invert.
     * @param {boolean} [multiValue] Allow multiple values per key.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     *
     * // with `multiValue`
     * _.invert(object, true);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function invert(object, multiValue, guard) {
            if (guard && isIterateeCall(object, multiValue, guard)) multiValue = undefined;
            var index = -1, props = keys(object), length = props.length, result = {};
            while(++index < length){
                var key = props[index], value = object[key];
                if (multiValue) {
                    if (hasOwnProperty.call(result, value)) result[value].push(key);
                    else result[value] = [
                        key
                    ];
                } else result[value] = key;
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ var keys = !nativeKeys ? shimKeys : function(object) {
            var Ctor = object == null ? undefined : object.constructor;
            if (typeof Ctor == 'function' && Ctor.prototype === object || typeof object != 'function' && isArrayLike(object)) return shimKeys(object);
            return isObject(object) ? nativeKeys(object) : [];
        };
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            if (object == null) return [];
            if (!isObject(object)) object = Object(object);
            var length = object.length;
            length = length && isLength(length) && (isArray(object) || isArguments(object)) && length || 0;
            var Ctor = object.constructor, index = -1, isProto = typeof Ctor == 'function' && Ctor.prototype === object, result = Array(length), skipIndexes = length > 0;
            while(++index < length)result[index] = index + '';
            for(var key in object)if (!(skipIndexes && isIndex(key, length)) && !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * property of `object` through `iteratee`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ var mapKeys = createObjectMapper(true);
        /**
     * Creates an object with the same keys as `object` and values generated by
     * running each own enumerable property of `object` through `iteratee`. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, key, object).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
     *   return n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * // using the `_.property` callback shorthand
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ var mapValues = createObjectMapper();
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable properties of `object` that are not omitted.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to omit, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.omit(object, 'age');
     * // => { 'user': 'fred' }
     *
     * _.omit(object, _.isNumber);
     * // => { 'user': 'fred' }
     */ var omit = restParam(function(object, props) {
            if (object == null) return {};
            if (typeof props[0] != 'function') {
                var props = arrayMap(baseFlatten(props), String);
                return pickByArray(object, baseDifference(keysIn(object), props));
            }
            var predicate = bindCallback(props[0], props[1], 3);
            return pickByCallback(object, function(value, key, object) {
                return !predicate(value, key, object);
            });
        });
        /**
     * Creates a two dimensional array of the key-value pairs for `object`,
     * e.g. `[[key1, value1], [key2, value2]]`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the new array of key-value pairs.
     * @example
     *
     * _.pairs({ 'barney': 36, 'fred': 40 });
     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
     */ function pairs(object) {
            object = toObject(object);
            var index = -1, props = keys(object), length = props.length, result = Array(length);
            while(++index < length){
                var key = props[index];
                result[index] = [
                    key,
                    object[key]
                ];
            }
            return result;
        }
        /**
     * Creates an object composed of the picked `object` properties. Property
     * names may be specified as individual arguments or as arrays of property
     * names. If `predicate` is provided it is invoked for each property of `object`
     * picking the properties `predicate` returns truthy for. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to pick, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.pick(object, 'user');
     * // => { 'user': 'fred' }
     *
     * _.pick(object, _.isString);
     * // => { 'user': 'fred' }
     */ var pick = restParam(function(object, props) {
            if (object == null) return {};
            return typeof props[0] == 'function' ? pickByCallback(object, bindCallback(props[0], props[1], 3)) : pickByArray(object, baseFlatten(props));
        });
        /**
     * This method is like `_.get` except that if the resolved value is a function
     * it is invoked with the `this` binding of its parent object and its result
     * is returned.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a.b.c', 'default');
     * // => 'default'
     *
     * _.result(object, 'a.b.c', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            var result = object == null ? undefined : object[path];
            if (result === undefined) {
                if (object != null && !isKey(path, object)) {
                    path = toPath(path);
                    object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
                    result = object == null ? undefined : object[last(path)];
                }
                result = result === undefined ? defaultValue : result;
            }
            return isFunction(result) ? result.call(object) : result;
        }
        /**
     * Sets the property value of `path` on `object`. If a portion of `path`
     * does not exist it is created.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to augment.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, 'x[0].y.z', 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            if (object == null) return object;
            var pathKey = path + '';
            path = object[pathKey] != null || isKey(path, object) ? [
                pathKey
            ] : toPath(path);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = path[index];
                if (isObject(nested)) {
                    if (index == lastIndex) nested[key] = value;
                    else if (nested[key] == null) nested[key] = isIndex(path[index + 1]) ? [] : {};
                }
                nested = nested[key];
            }
            return object;
        }
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own enumerable
     * properties through `iteratee`, with each invocation potentially mutating
     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
     * with four arguments: (accumulator, value, key, object). Iteratee functions
     * may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Array|Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * });
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     */ function transform(object, iteratee, accumulator, thisArg) {
            var isArr = isArray(object) || isTypedArray(object);
            iteratee = getCallback(iteratee, thisArg, 4);
            if (accumulator == null) {
                if (isArr || isObject(object)) {
                    var Ctor = object.constructor;
                    if (isArr) accumulator = isArray(object) ? new Ctor : [];
                    else accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
                } else accumulator = {};
            }
            (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Creates an array of the own enumerable property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable property values
     * of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Checks if `n` is between `start` and up to but not including, `end`. If
     * `end` is not specified it is set to `start` with `start` then set to `0`.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} n The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     */ function inRange(value, start, end) {
            start = +start || 0;
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = +end || 0;
            return value >= nativeMin(start, end) && value < nativeMax(start, end);
        }
        /**
     * Produces a random number between `min` and `max` (inclusive). If only one
     * argument is provided a number between `0` and the given number is returned.
     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
     * number is returned instead of an integer.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} [min=0] The minimum possible value.
     * @param {number} [max=1] The maximum possible value.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(min, max, floating) {
            if (floating && isIterateeCall(min, max, floating)) max = floating = undefined;
            var noMin = min == null, noMax = max == null;
            if (floating == null) {
                if (noMax && typeof min == 'boolean') {
                    floating = min;
                    min = 1;
                } else if (typeof max == 'boolean') {
                    floating = max;
                    noMax = true;
                }
            }
            if (noMin && noMax) {
                max = 1;
                noMax = false;
            }
            min = +min || 0;
            if (noMax) {
                max = min;
                min = 0;
            } else max = +max || 0;
            if (floating || min % 1 || max % 1) {
                var rand = nativeRandom();
                return nativeMin(min + rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1))), max);
            }
            return baseRandom(min, max);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar');
     * // => 'fooBar'
     *
     * _.camelCase('__foo_bar__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? word.charAt(0).toUpperCase() + word.slice(1) : word);
        });
        /**
     * Capitalizes the first character of `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('fred');
     * // => 'Fred'
     */ function capitalize(string) {
            string = baseToString(string);
            return string && string.charAt(0).toUpperCase() + string.slice(1);
        }
        /**
     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = baseToString(string);
            return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search from.
     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = baseToString(string);
            target = target + '';
            var length = string.length;
            position = position === undefined ? length : nativeMin(position < 0 ? 0 : +position || 0, length);
            position -= target.length;
            return position >= 0 && string.indexOf(target, position) == position;
        }
        /**
     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
     * their corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional characters
     * use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value.
     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * Backticks are escaped because in Internet Explorer < 9, they can break out
     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
     * for more details.
     *
     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
     * to reduce XSS vectors.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            // Reset `lastIndex` because in IE < 9 `String#replace` does not.
            string = baseToString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
     */ function escapeRegExp(string) {
            string = baseToString(string);
            return string && reHasRegExpChars.test(string) ? string.replace(reRegExpChars, escapeRegExpChar) : string || '(?:)';
        }
        /**
     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__foo_bar__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = baseToString(string);
            length = +length;
            var strLength = string.length;
            if (strLength >= length || !nativeIsFinite(length)) return string;
            var mid = (length - strLength) / 2, leftLength = nativeFloor(mid), rightLength = nativeCeil(mid);
            chars = createPadding('', rightLength, chars);
            return chars.slice(0, leftLength) + string + chars;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padLeft('abc', 6);
     * // => '   abc'
     *
     * _.padLeft('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padLeft('abc', 3);
     * // => 'abc'
     */ var padLeft = createPadDir();
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padRight('abc', 6);
     * // => 'abc   '
     *
     * _.padRight('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padRight('abc', 3);
     * // => 'abc'
     */ var padRight = createPadDir(true);
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
     * in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
     * of `parseInt`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt(string, radix, guard) {
            // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
            // Chrome fails to trim leading <BOM> whitespace characters.
            // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
            if (guard ? isIterateeCall(string, radix, guard) : radix == null) radix = 0;
            else if (radix) radix = +radix;
            string = trim(string);
            return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=0] The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n) {
            var result = '';
            string = baseToString(string);
            n = +n;
            if (n < 1 || !string || !nativeIsFinite(n)) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                string += string;
            }while (n);
            return result;
        }
        /**
     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--foo-bar');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__foo_bar__');
     * // => 'Foo Bar'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = baseToString(string);
            position = position == null ? 0 : nativeMin(position < 0 ? 0 : +position || 0, string.length);
            return string.lastIndexOf(target, position) == position;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is provided it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options] The options object.
     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
     * @param {Object} [options.imports] An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
     * @param {string} [options.variable] The data object variable name.
     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // using the "interpolate" delimiter to create a compiled template
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // using the HTML "escape" delimiter to escape data property values
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the internal `print` function in "evaluate" delimiters
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // using custom template delimiters
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // using backslashes to treat delimiters as plain text
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // using the `imports` option to import `jQuery` as `jq`
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the `sourceURL` option to specify a custom sourceURL for the template
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
     *
     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // using the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and a stack trace
     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, otherOptions) {
            // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (otherOptions && isIterateeCall(string, options, otherOptions)) options = otherOptions = undefined;
            string = baseToString(string);
            options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);
            var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            var sourceURL = '//# sourceURL=' + ('sourceURL' in options ? options.sourceURL : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products requires returning the `match`
                // string in order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            var value = string;
            string = baseToString(string);
            if (!string) return string;
            if (guard ? isIterateeCall(value, chars, guard) : chars == null) return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
            chars = chars + '';
            return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimLeft('  abc  ');
     * // => 'abc  '
     *
     * _.trimLeft('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimLeft(string, chars, guard) {
            var value = string;
            string = baseToString(string);
            if (!string) return string;
            if (guard ? isIterateeCall(value, chars, guard) : chars == null) return string.slice(trimmedLeftIndex(string));
            return string.slice(charsLeftIndex(string, chars + ''));
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimRight('  abc  ');
     * // => '  abc'
     *
     * _.trimRight('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimRight(string, chars, guard) {
            var value = string;
            string = baseToString(string);
            if (!string) return string;
            if (guard ? isIterateeCall(value, chars, guard) : chars == null) return string.slice(0, trimmedRightIndex(string) + 1);
            return string.slice(0, charsRightIndex(string, chars + '') + 1);
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object|number} [options] The options object or maximum string length.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.trunc('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', 24);
     * // => 'hi-diddly-ho there, n...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function trunc(string, options, guard) {
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (options != null) {
                if (isObject(options)) {
                    var separator = 'separator' in options ? options.separator : separator;
                    length = 'length' in options ? +options.length || 0 : length;
                    omission = 'omission' in options ? baseToString(options.omission) : omission;
                } else length = +options || 0;
            }
            string = baseToString(string);
            if (length >= string.length) return string;
            var end = length - omission.length;
            if (end < 1) return omission;
            var result = string.slice(0, end);
            if (separator == null) return result + omission;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, newEnd, substring = string.slice(0, end);
                    if (!separator.global) separator = RegExp1(separator.source, (reFlags.exec(separator) || '') + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))newEnd = match.index;
                    result = result.slice(0, newEnd == null ? end : newEnd);
                }
            } else if (string.indexOf(separator, end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
     * corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
     * entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = baseToString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            if (guard && isIterateeCall(string, pattern, guard)) pattern = undefined;
            string = baseToString(string);
            return string.match(pattern || reWords) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function} func The function to attempt.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // avoid throwing errors for invalid selectors
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = restParam(function(func, args) {
            try {
                return func.apply(undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and arguments of the created function. If `func` is a property name the
     * created callback returns the property value for a given element. If `func`
     * is an object the created callback returns `true` for elements that contain
     * the equivalent object properties, otherwise it returns `false`.
     *
     * @static
     * @memberOf _
     * @alias iteratee
     * @category Utility
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // wrap to create custom callback shorthands
     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
     *   if (!match) {
     *     return callback(func, thisArg);
     *   }
     *   return function(object) {
     *     return match[2] == 'gt'
     *       ? object[match[1]] > match[3]
     *       : object[match[1]] < match[3];
     *   };
     * });
     *
     * _.filter(users, 'age__gt36');
     * // => [{ 'user': 'fred', 'age': 40 }]
     */ function callback(func, thisArg, guard) {
            if (guard && isIterateeCall(func, thisArg, guard)) thisArg = undefined;
            return isObjectLike(func) ? matches(func) : baseCallback(func, thisArg);
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var getter = _.constant(object);
     *
     * getter() === object;
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * This method returns the first argument provided to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.identity(object) === object;
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that performs a deep comparison between a given object
     * and `source`, returning `true` if the given object has equivalent property
     * values, else `false`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
     */ function matches(source) {
            return baseMatches(baseClone(source, true));
        }
        /**
     * Creates a function that compares the property value of `path` on a given
     * object to `value`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * _.find(users, _.matchesProperty('user', 'fred'));
     * // => { 'user': 'fred' }
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, true));
        }
        /**
     * Creates a function that invokes the method at `path` on a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': _.constant(2) } } },
     *   { 'a': { 'b': { 'c': _.constant(1) } } }
     * ];
     *
     * _.map(objects, _.method('a.b.c'));
     * // => [2, 1]
     *
     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */ var method = restParam(function(path, args) {
            return function(object) {
                return invokePath(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path on `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = restParam(function(object, args) {
            return function(path) {
                return invokePath(object, path, args);
            };
        });
        /**
     * Adds all own enumerable function properties of a source object to the
     * destination object. If `object` is a function then methods are added to
     * its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.chain=true] Specify whether the functions added
     *  are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            if (options == null) {
                var isObj = isObject(source), props = isObj ? keys(source) : undefined, methodNames = props && props.length ? baseFunctions(source, props) : undefined;
                if (!(methodNames ? methodNames.length : isObj)) {
                    methodNames = false;
                    options = source;
                    source = object;
                    object = this;
                }
            }
            if (!methodNames) methodNames = baseFunctions(source, keys(source));
            var chain = true, index = -1, isFunc = isFunction(object), length = methodNames.length;
            if (options === false) chain = false;
            else if (isObject(options) && 'chain' in options) chain = options.chain;
            while(++index < length){
                var methodName = methodNames[index], func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function(func) {
                    return function() {
                        var chainAll = this.__chain__;
                        if (chain || chainAll) {
                            var result = object(this.__wrapped__), actions = result.__actions__ = arrayCopy(this.__actions__);
                            actions.push({
                                'func': func,
                                'args': arguments,
                                'thisArg': object
                            });
                            result.__chain__ = chainAll;
                            return result;
                        }
                        return func.apply(object, arrayPush([
                            this.value()
                        ], arguments));
                    };
                }(func);
            }
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            root._ = oldDash;
            return this;
        }
        /**
     * A no-operation function that returns `undefined` regardless of the
     * arguments it receives.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.noop(object) === undefined;
     * // => true
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that returns the property value at `path` on a
     * given object.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': 2 } } },
     *   { 'a': { 'b': { 'c': 1 } } }
     * ];
     *
     * _.map(objects, _.property('a.b.c'));
     * // => [2, 1]
     *
     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the property value at a given path on `object`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return baseGet(object, toPath(path), path + '');
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. If `end` is not specified it is
     * set to `start` with `start` then set to `0`. If `end` is less than `start`
     * a zero-length range is created unless a negative `step` is specified.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the new array of numbers.
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ function range(start, end, step) {
            if (step && isIterateeCall(start, end, step)) end = step = undefined;
            start = +start || 0;
            step = step == null ? 1 : +step || 0;
            if (end == null) {
                end = start;
                start = 0;
            } else end = +end || 0;
            // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
            // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
            while(++index < length){
                result[index] = start;
                start += step;
            }
            return result;
        }
        /**
     * Invokes the iteratee function `n` times, returning an array of the results
     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
     * one argument; (index).
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
     * // => [3, 6, 4]
     *
     * _.times(3, function(n) {
     *   mage.castSpell(n);
     * });
     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
     *
     * _.times(3, function(n) {
     *   this.cast(n);
     * }, mage);
     * // => also invokes `mage.castSpell(n)` three times
     */ function times(n, iteratee, thisArg) {
            n = nativeFloor(n);
            // Exit early to avoid a JSC JIT bug in Safari 8
            // where `Array(0)` is treated as `Array(1)`.
            if (n < 1 || !nativeIsFinite(n)) return [];
            var index = -1, result = Array(nativeMin(n, MAX_ARRAY_LENGTH));
            iteratee = bindCallback(iteratee, thisArg, 1);
            while(++index < n)if (index < MAX_ARRAY_LENGTH) result[index] = iteratee(index);
            else iteratee(index);
            return result;
        }
        /**
     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {string} [prefix] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return baseToString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} augend The first number to add.
     * @param {number} addend The second number to add.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ function add(augend, addend) {
            return (+augend || 0) + (+addend || 0);
        }
        /**
     * Calculates `n` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Calculates `n` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Gets the maximum value of `collection`. If `collection` is empty or falsey
     * `-Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => -Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.max(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using the `_.property` callback shorthand
     * _.max(users, 'age');
     * // => { 'user': 'fred', 'age': 40 }
     */ var max = createExtremum(gt, NEGATIVE_INFINITY);
        /**
     * Gets the minimum value of `collection`. If `collection` is empty or falsey
     * `Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.min(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // using the `_.property` callback shorthand
     * _.min(users, 'age');
     * // => { 'user': 'barney', 'age': 36 }
     */ var min = createExtremum(lt, POSITIVE_INFINITY);
        /**
     * Calculates `n` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Gets the sum of the values in `collection`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 6]);
     * // => 10
     *
     * _.sum({ 'a': 4, 'b': 6 });
     * // => 10
     *
     * var objects = [
     *   { 'n': 4 },
     *   { 'n': 6 }
     * ];
     *
     * _.sum(objects, function(object) {
     *   return object.n;
     * });
     * // => 10
     *
     * // using the `_.property` callback shorthand
     * _.sum(objects, 'n');
     * // => 10
     */ function sum(collection, iteratee, thisArg) {
            if (thisArg && isIterateeCall(collection, iteratee, thisArg)) iteratee = undefined;
            iteratee = getCallback(iteratee, thisArg, 3);
            return iteratee.length == 1 ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee) : baseSum(collection, iteratee);
        }
        /*------------------------------------------------------------------------*/ // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        // Add functions to the `Map` cache.
        MapCache.prototype['delete'] = mapDelete;
        MapCache.prototype.get = mapGet;
        MapCache.prototype.has = mapHas;
        MapCache.prototype.set = mapSet;
        // Add functions to the `Set` cache.
        SetCache.prototype.push = cachePush;
        // Assign cache to `_.memoize`.
        memoize.Cache = MapCache;
        // Add functions that return wrapped values when chaining.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.callback = callback;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.functions = functions;
        lodash.groupBy = groupBy;
        lodash.indexBy = indexBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.invert = invert;
        lodash.invoke = invoke;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.modArgs = modArgs;
        lodash.negate = negate;
        lodash.omit = omit;
        lodash.once = once;
        lodash.pairs = pairs;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pluck = pluck;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.restParam = restParam;
        lodash.set = set;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortByAll = sortByAll;
        lodash.sortByOrder = sortByOrder;
        lodash.spread = spread;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.times = times;
        lodash.toArray = toArray;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.union = union;
        lodash.uniq = uniq;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.where = where;
        lodash.without = without;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.backflow = flowRight;
        lodash.collect = map;
        lodash.compose = flowRight;
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.extend = assign;
        lodash.iteratee = callback;
        lodash.methods = functions;
        lodash.object = zipObject;
        lodash.select = filter;
        lodash.tail = rest;
        lodash.unique = uniq;
        // Add functions to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add functions that return unwrapped values when chaining.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.deburr = deburr;
        lodash.endsWith = endsWith;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.findWhere = findWhere;
        lodash.first = first;
        lodash.floor = floor;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isBoolean = isBoolean;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isMatch = isMatch;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isString = isString;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.min = min;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padLeft = padLeft;
        lodash.padRight = padRight;
        lodash.parseInt = parseInt;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.sum = sum;
        lodash.template = template;
        lodash.trim = trim;
        lodash.trimLeft = trimLeft;
        lodash.trimRight = trimRight;
        lodash.trunc = trunc;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.words = words;
        // Add aliases.
        lodash.all = every;
        lodash.any = some;
        lodash.contains = includes;
        lodash.eq = isEqual;
        lodash.detect = find;
        lodash.foldl = reduce;
        lodash.foldr = reduceRight;
        lodash.head = first;
        lodash.include = includes;
        lodash.inject = reduce;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!lodash.prototype[methodName]) source[methodName] = func;
            });
            return source;
        }(), false);
        /*------------------------------------------------------------------------*/ // Add functions capable of returning wrapped and unwrapped values when chaining.
        lodash.sample = sample;
        lodash.prototype.sample = function(n) {
            if (!this.__chain__ && n == null) return sample(this.value());
            return this.thru(function(value) {
                return sample(value, n);
            });
        };
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type string
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                var filtered = this.__filtered__;
                if (filtered && !index) return new LazyWrapper(this);
                n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);
                var result = this.clone();
                if (filtered) result.__takeCount__ = nativeMin(result.__takeCount__, n);
                else result.__views__.push({
                    'size': n,
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type != LAZY_MAP_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getCallback(iteratee, thisArg, 1),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.first` and `_.last`.
        arrayEach([
            'first',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
        arrayEach([
            'initial',
            'rest'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
        arrayEach([
            'pluck',
            'where'
        ], function(methodName, index) {
            var operationName = index ? 'filter' : 'map', createCallback = index ? baseMatches : property;
            LazyWrapper.prototype[methodName] = function(value) {
                return this[operationName](createCallback(value));
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.reject = function(predicate, thisArg) {
            predicate = getCallback(predicate, thisArg, 1);
            return this.filter(function(value) {
                return !predicate(value);
            });
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = start == null ? 0 : +start || 0;
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = +end || 0;
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
            return this.reverse().takeWhile(predicate, thisArg).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(POSITIVE_INFINITY);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName), retUnwrapped = /^(?:first|last)$/.test(methodName), lodashFunc = lodash[retUnwrapped ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName];
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var args = retUnwrapped ? [
                    1
                ] : arguments, chainAll = this.__chain__, value = this.__wrapped__, isHybrid = !!this.__actions__.length, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var interceptor = function(value) {
                    return retUnwrapped && chainAll ? lodashFunc(value, 1)[0] : lodashFunc.apply(undefined, arrayPush([
                        value
                    ], args));
                };
                var action = {
                    'func': thru,
                    'args': [
                        interceptor
                    ],
                    'thisArg': undefined
                }, onlyLazy = isLazy && !isHybrid;
                if (retUnwrapped && !chainAll) {
                    if (onlyLazy) {
                        value = value.clone();
                        value.__actions__.push(action);
                        return func.call(value);
                    }
                    return lodashFunc.call(undefined, this.value())[0];
                }
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push(action);
                    return new LodashWrapper(result, chainAll);
                }
                return this.thru(interceptor);
            };
        });
        // Add `Array` and `String` methods to `lodash.prototype`.
        arrayEach([
            'join',
            'pop',
            'push',
            'replace',
            'shift',
            'sort',
            'splice',
            'split',
            'unshift'
        ], function(methodName) {
            var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) return func.apply(this.value(), args);
                return this[chainName](function(value) {
                    return func.apply(value, args);
                });
            };
        });
        // Map minified function names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name, names = realNames[key] || (realNames[key] = []);
                names.push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add functions to the lazy wrapper.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chaining functions to the `lodash` wrapper.
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.concat = wrapperConcat;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toString = wrapperToString;
        lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add function aliases to the `lodash` wrapper.
        lodash.prototype.collect = lodash.prototype.map;
        lodash.prototype.head = lodash.prototype.first;
        lodash.prototype.select = lodash.prototype.filter;
        lodash.prototype.tail = lodash.prototype.rest;
        return lodash;
    }
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers like r.js check for condition patterns like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose lodash to the global object when an AMD loader is present to avoid
        // errors in cases where lodash is loaded by a script tag and not intended
        // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
        // more details.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeExports && freeModule) {
        // Export for Node.js or RingoJS.
        if (moduleExports) (freeModule.exports = _)._ = _;
        else freeExports._ = _;
    } else // Export for a browser or Rhino.
    root._ = _;
}).call(this);

},{}],"6nfNA":[function(require,module,exports,__globalThis) {
"use strict";
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = exports.ReactGAImplementation = void 0;
var _ga = _interopRequireWildcard(require("8aae62742fe02e10"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var ReactGAImplementation = _ga.GA4;
exports.ReactGAImplementation = ReactGAImplementation;
var _default = _ga["default"];
exports["default"] = _default;

},{"8aae62742fe02e10":"3I6Tx"}],"3I6Tx":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = exports.GA4 = void 0;
var _gtag = _interopRequireDefault(require("19166929ae4d5e05"));
var _format = _interopRequireDefault(require("2e61426181aa7cb3"));
var _excluded = [
    "eventCategory",
    "eventAction",
    "eventLabel",
    "eventValue",
    "hitType"
], _excluded2 = [
    "title",
    "location"
], _excluded3 = [
    "page",
    "hitType"
];
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/*
Links
https://developers.google.com/gtagjs/reference/api
https://developers.google.com/tag-platform/gtagjs/reference
*/ /**
 * @typedef GaOptions
 * @type {Object}
 * @property {boolean} [cookieUpdate=true]
 * @property {number} [cookieExpires=63072000] Default two years
 * @property {string} [cookieDomain="auto"]
 * @property {string} [cookieFlags]
 * @property {string} [userId]
 * @property {string} [clientId]
 * @property {boolean} [anonymizeIp]
 * @property {string} [contentGroup1]
 * @property {string} [contentGroup2]
 * @property {string} [contentGroup3]
 * @property {string} [contentGroup4]
 * @property {string} [contentGroup5]
 * @property {boolean} [allowAdFeatures=true]
 * @property {boolean} [allowAdPersonalizationSignals]
 * @property {boolean} [nonInteraction]
 * @property {string} [page]
 */ /**
 * @typedef UaEventOptions
 * @type {Object}
 * @property {string} action
 * @property {string} category
 * @property {string} [label]
 * @property {number} [value]
 * @property {boolean} [nonInteraction]
 * @property {('beacon'|'xhr'|'image')} [transport]
 */ /**
 * @typedef InitOptions
 * @type {Object}
 * @property {string} trackingId
 * @property {GaOptions|any} [gaOptions]
 * @property {Object} [gtagOptions] New parameter
 */ var GA4 = /*#__PURE__*/ function() {
    function GA4() {
        var _this = this;
        _classCallCheck(this, GA4);
        _defineProperty(this, "reset", function() {
            _this.isInitialized = false;
            _this._testMode = false;
            _this._currentMeasurementId;
            _this._hasLoadedGA = false;
            _this._isQueuing = false;
            _this._queueGtag = [];
        });
        _defineProperty(this, "_gtag", function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if (!_this._testMode) {
                if (_this._isQueuing) _this._queueGtag.push(args);
                else _gtag["default"].apply(void 0, args);
            } else _this._queueGtag.push(args);
        });
        _defineProperty(this, "_loadGA", function(GA_MEASUREMENT_ID, nonce) {
            var gtagUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "https://www.googletagmanager.com/gtag/js";
            if (typeof window === "undefined" || typeof document === "undefined") return;
            if (!_this._hasLoadedGA) {
                // Global Site Tag (gtag.js) - Google Analytics
                var script = document.createElement("script");
                script.async = true;
                script.src = "".concat(gtagUrl, "?id=").concat(GA_MEASUREMENT_ID);
                if (nonce) script.setAttribute("nonce", nonce);
                document.body.appendChild(script);
                window.dataLayer = window.dataLayer || [];
                window.gtag = function gtag() {
                    window.dataLayer.push(arguments);
                };
                _this._hasLoadedGA = true;
            }
        });
        _defineProperty(this, "_toGtagOptions", function(gaOptions) {
            if (!gaOptions) return;
            var mapFields = {
                // Old https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#cookieUpdate
                // New https://developers.google.com/analytics/devguides/collection/gtagjs/cookies-user-id#cookie_update
                cookieUpdate: "cookie_update",
                cookieExpires: "cookie_expires",
                cookieDomain: "cookie_domain",
                cookieFlags: "cookie_flags",
                // must be in set method?
                userId: "user_id",
                clientId: "client_id",
                anonymizeIp: "anonymize_ip",
                // https://support.google.com/analytics/answer/2853546?hl=en#zippy=%2Cin-this-article
                contentGroup1: "content_group1",
                contentGroup2: "content_group2",
                contentGroup3: "content_group3",
                contentGroup4: "content_group4",
                contentGroup5: "content_group5",
                // https://support.google.com/analytics/answer/9050852?hl=en
                allowAdFeatures: "allow_google_signals",
                allowAdPersonalizationSignals: "allow_ad_personalization_signals",
                nonInteraction: "non_interaction",
                page: "page_path",
                hitCallback: "event_callback"
            };
            var gtagOptions = Object.entries(gaOptions).reduce(function(prev, _ref) {
                var _ref2 = _slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                if (mapFields[key]) prev[mapFields[key]] = value;
                else prev[key] = value;
                return prev;
            }, {});
            return gtagOptions;
        });
        _defineProperty(this, "initialize", function(GA_MEASUREMENT_ID) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            if (!GA_MEASUREMENT_ID) throw new Error("Require GA_MEASUREMENT_ID");
            var initConfigs = typeof GA_MEASUREMENT_ID === "string" ? [
                {
                    trackingId: GA_MEASUREMENT_ID
                }
            ] : GA_MEASUREMENT_ID;
            _this._currentMeasurementId = initConfigs[0].trackingId;
            var gaOptions = options.gaOptions, gtagOptions = options.gtagOptions, nonce = options.nonce, _options$testMode = options.testMode, testMode = _options$testMode === void 0 ? false : _options$testMode, gtagUrl = options.gtagUrl;
            _this._testMode = testMode;
            if (!testMode) _this._loadGA(_this._currentMeasurementId, nonce, gtagUrl);
            if (!_this.isInitialized) {
                _this._gtag("js", new Date());
                initConfigs.forEach(function(config) {
                    var mergedGtagOptions = _objectSpread(_objectSpread(_objectSpread({}, _this._toGtagOptions(_objectSpread(_objectSpread({}, gaOptions), config.gaOptions))), gtagOptions), config.gtagOptions);
                    if (Object.keys(mergedGtagOptions).length) _this._gtag("config", config.trackingId, mergedGtagOptions);
                    else _this._gtag("config", config.trackingId);
                });
            }
            _this.isInitialized = true;
            if (!testMode) {
                var queues = _toConsumableArray(_this._queueGtag);
                _this._queueGtag = [];
                _this._isQueuing = false;
                while(queues.length){
                    var queue = queues.shift();
                    _this._gtag.apply(_this, _toConsumableArray(queue));
                    if (queue[0] === "get") _this._isQueuing = true;
                }
            }
        });
        _defineProperty(this, "set", function(fieldsObject) {
            if (!fieldsObject) {
                console.warn("`fieldsObject` is required in .set()");
                return;
            }
            if (_typeof(fieldsObject) !== "object") {
                console.warn("Expected `fieldsObject` arg to be an Object");
                return;
            }
            if (Object.keys(fieldsObject).length === 0) console.warn("empty `fieldsObject` given to .set()");
            _this._gaCommand("set", fieldsObject);
        });
        _defineProperty(this, "_gaCommandSendEvent", function(eventCategory, eventAction, eventLabel, eventValue, fieldsObject) {
            _this._gtag("event", eventAction, _objectSpread(_objectSpread({
                event_category: eventCategory,
                event_label: eventLabel,
                value: eventValue
            }, fieldsObject && {
                non_interaction: fieldsObject.nonInteraction
            }), _this._toGtagOptions(fieldsObject)));
        });
        _defineProperty(this, "_gaCommandSendEventParameters", function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            if (typeof args[0] === "string") _this._gaCommandSendEvent.apply(_this, _toConsumableArray(args.slice(1)));
            else {
                var _args$ = args[0], eventCategory = _args$.eventCategory, eventAction = _args$.eventAction, eventLabel = _args$.eventLabel, eventValue = _args$.eventValue, hitType = _args$.hitType, rest = _objectWithoutProperties(_args$, _excluded);
                _this._gaCommandSendEvent(eventCategory, eventAction, eventLabel, eventValue, rest);
            }
        });
        _defineProperty(this, "_gaCommandSendTiming", function(timingCategory, timingVar, timingValue, timingLabel) {
            _this._gtag("event", "timing_complete", {
                name: timingVar,
                value: timingValue,
                event_category: timingCategory,
                event_label: timingLabel
            });
        });
        _defineProperty(this, "_gaCommandSendPageview", function(page, fieldsObject) {
            if (fieldsObject && Object.keys(fieldsObject).length) {
                var _this$_toGtagOptions = _this._toGtagOptions(fieldsObject), title = _this$_toGtagOptions.title, location = _this$_toGtagOptions.location, rest = _objectWithoutProperties(_this$_toGtagOptions, _excluded2);
                _this._gtag("event", "page_view", _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, page && {
                    page_path: page
                }), title && {
                    page_title: title
                }), location && {
                    page_location: location
                }), rest));
            } else if (page) _this._gtag("event", "page_view", {
                page_path: page
            });
            else _this._gtag("event", "page_view");
        });
        _defineProperty(this, "_gaCommandSendPageviewParameters", function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            if (typeof args[0] === "string") _this._gaCommandSendPageview.apply(_this, _toConsumableArray(args.slice(1)));
            else {
                var _args$2 = args[0], page = _args$2.page, hitType = _args$2.hitType, rest = _objectWithoutProperties(_args$2, _excluded3);
                _this._gaCommandSendPageview(page, rest);
            }
        });
        _defineProperty(this, "_gaCommandSend", function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            var hitType = typeof args[0] === "string" ? args[0] : args[0].hitType;
            switch(hitType){
                case "event":
                    _this._gaCommandSendEventParameters.apply(_this, args);
                    break;
                case "pageview":
                    _this._gaCommandSendPageviewParameters.apply(_this, args);
                    break;
                case "timing":
                    _this._gaCommandSendTiming.apply(_this, _toConsumableArray(args.slice(1)));
                    break;
                case "screenview":
                case "transaction":
                case "item":
                case "social":
                case "exception":
                    console.warn("Unsupported send command: ".concat(hitType));
                    break;
                default:
                    console.warn("Send command doesn't exist: ".concat(hitType));
            }
        });
        _defineProperty(this, "_gaCommandSet", function() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            if (typeof args[0] === "string") args[0] = _defineProperty({}, args[0], args[1]);
            _this._gtag("set", _this._toGtagOptions(args[0]));
        });
        _defineProperty(this, "_gaCommand", function(command) {
            for(var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++)args[_key6 - 1] = arguments[_key6];
            switch(command){
                case "send":
                    _this._gaCommandSend.apply(_this, args);
                    break;
                case "set":
                    _this._gaCommandSet.apply(_this, args);
                    break;
                default:
                    console.warn("Command doesn't exist: ".concat(command));
            }
        });
        _defineProperty(this, "ga", function() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            if (typeof args[0] === "string") _this._gaCommand.apply(_this, args);
            else {
                var readyCallback = args[0];
                _this._gtag("get", _this._currentMeasurementId, "client_id", function(clientId) {
                    _this._isQueuing = false;
                    var queues = _this._queueGtag;
                    readyCallback({
                        get: function get(property) {
                            return property === "clientId" ? clientId : property === "trackingId" ? _this._currentMeasurementId : property === "apiVersion" ? "1" : undefined;
                        }
                    });
                    while(queues.length){
                        var queue = queues.shift();
                        _this._gtag.apply(_this, _toConsumableArray(queue));
                    }
                });
                _this._isQueuing = true;
            }
            return _this.ga;
        });
        _defineProperty(this, "event", function(optionsOrName, params) {
            if (typeof optionsOrName === "string") _this._gtag("event", optionsOrName, _this._toGtagOptions(params));
            else {
                var action = optionsOrName.action, category = optionsOrName.category, label = optionsOrName.label, value = optionsOrName.value, nonInteraction = optionsOrName.nonInteraction, transport = optionsOrName.transport;
                if (!category || !action) {
                    console.warn("args.category AND args.action are required in event()");
                    return;
                }
                // Required Fields
                var fieldObject = {
                    hitType: "event",
                    eventCategory: (0, _format["default"])(category),
                    eventAction: (0, _format["default"])(action)
                };
                // Optional Fields
                if (label) fieldObject.eventLabel = (0, _format["default"])(label);
                if (typeof value !== "undefined") {
                    if (typeof value !== "number") console.warn("Expected `args.value` arg to be a Number.");
                    else fieldObject.eventValue = value;
                }
                if (typeof nonInteraction !== "undefined") {
                    if (typeof nonInteraction !== "boolean") console.warn("`args.nonInteraction` must be a boolean.");
                    else fieldObject.nonInteraction = nonInteraction;
                }
                if (typeof transport !== "undefined") {
                    if (typeof transport !== "string") console.warn("`args.transport` must be a string.");
                    else {
                        if ([
                            "beacon",
                            "xhr",
                            "image"
                        ].indexOf(transport) === -1) console.warn("`args.transport` must be either one of these values: `beacon`, `xhr` or `image`");
                        fieldObject.transport = transport;
                    }
                }
                _this._gaCommand("send", fieldObject);
            }
        });
        _defineProperty(this, "send", function(fieldObject) {
            _this._gaCommand("send", fieldObject);
        });
        this.reset();
    }
    _createClass(GA4, [
        {
            key: "gtag",
            value: function gtag() {
                this._gtag.apply(this, arguments);
            }
        }
    ]);
    return GA4;
}();
exports.GA4 = GA4;
var _default = new GA4();
exports["default"] = _default;

},{"19166929ae4d5e05":"bpdUf","2e61426181aa7cb3":"8PClZ"}],"bpdUf":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var gtag = function gtag() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (typeof window !== "undefined") {
        var _window;
        if (typeof window.gtag === "undefined") {
            window.dataLayer = window.dataLayer || [];
            window.gtag = function gtag() {
                window.dataLayer.push(arguments);
            };
        }
        (_window = window).gtag.apply(_window, args);
    }
};
var _default = gtag;
exports["default"] = _default;

},{}],"8PClZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = format;
var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
function toTitleCase(string) {
    return string.toString().trim().replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function(match, index, title) {
        if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ":" && (title.charAt(index + match.length) !== "-" || title.charAt(index - 1) === "-") && title.charAt(index - 1).search(/[^\s-]/) < 0) return match.toLowerCase();
        if (match.substr(1).search(/[A-Z]|\../) > -1) return match;
        return match.charAt(0).toUpperCase() + match.substr(1);
    });
}
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
    // There's no point trying to validate rfc822 fully, just look for ...@...
    return typeof s === "string" && s.indexOf("@") !== -1;
}
var redacted = "REDACTED (Potential Email Address)";
function redactEmail(string) {
    if (mightBeEmail(string)) {
        console.warn("This arg looks like an email address, redacting.");
        return redacted;
    }
    return string;
}
function format() {
    var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var titleCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var redactingEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var _str = s || "";
    if (titleCase) _str = toTitleCase(s);
    if (redactingEmail) _str = redactEmail(_str);
    return _str;
}

},{}],"cl12L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BRAPI_DIMENSION_PAGE_SIZE", ()=>(0, _chunkFT42GMYPJs.BRAPI_DIMENSION_PAGE_SIZE));
parcelHelpers.export(exports, "BRAPI_VARIANTS_PAGE_SIZE", ()=>(0, _chunkFT42GMYPJs.BRAPI_VARIANTS_PAGE_SIZE));
parcelHelpers.export(exports, "ENSEMBL_DEFAULT_DOMAIN_SOURCES", ()=>(0, _chunkFT42GMYPJs.ENSEMBL_DEFAULT_DOMAIN_SOURCES));
parcelHelpers.export(exports, "ENSEMBL_DEFAULT_MIRROR", ()=>(0, _chunkFT42GMYPJs.ENSEMBL_DEFAULT_MIRROR));
parcelHelpers.export(exports, "ENSEMBL_MIRRORS", ()=>(0, _chunkFT42GMYPJs.ENSEMBL_MIRRORS));
parcelHelpers.export(exports, "GRAMENE_DEFAULT_BASE", ()=>(0, _chunkFT42GMYPJs.GRAMENE_DEFAULT_BASE));
parcelHelpers.export(exports, "GRAMENE_DEFAULT_TREE_FIELD", ()=>(0, _chunkFT42GMYPJs.GRAMENE_DEFAULT_TREE_FIELD));
parcelHelpers.export(exports, "GRAMENE_GENE_STRUCTURE_FL", ()=>(0, _chunkFT42GMYPJs.GRAMENE_GENE_STRUCTURE_FL));
parcelHelpers.export(exports, "brapiAlleleMatrixSource", ()=>(0, _chunkFT42GMYPJs.brapiAlleleMatrixSource));
parcelHelpers.export(exports, "brapiBaseOf", ()=>(0, _chunkFT42GMYPJs.brapiBaseOf));
parcelHelpers.export(exports, "brapiMatrixUrlWithDefaults", ()=>(0, _chunkFT42GMYPJs.brapiMatrixUrlWithDefaults));
parcelHelpers.export(exports, "brapiPages", ()=>(0, _chunkFT42GMYPJs.brapiPages));
parcelHelpers.export(exports, "brapiVariantsUrlFrom", ()=>(0, _chunkFT42GMYPJs.brapiVariantsUrlFrom));
parcelHelpers.export(exports, "createLoader", ()=>(0, _chunkFT42GMYPJs.createLoader));
parcelHelpers.export(exports, "defineSlot", ()=>(0, _chunkFT42GMYPJs.defineSlot));
parcelHelpers.export(exports, "ensemblGeneTreeSource", ()=>(0, _chunkFT42GMYPJs.ensemblGeneTreeSource));
parcelHelpers.export(exports, "ensemblGeneTreeUrl", ()=>(0, _chunkFT42GMYPJs.ensemblGeneTreeUrl));
parcelHelpers.export(exports, "expandCigar", ()=>(0, _chunkFT42GMYPJs.expandCigar));
parcelHelpers.export(exports, "extendSource", ()=>(0, _chunkFT42GMYPJs.extendSource));
parcelHelpers.export(exports, "facetPairsToCounts", ()=>(0, _chunkFT42GMYPJs.facetPairsToCounts));
parcelHelpers.export(exports, "fetchBrapiAlleleMatrix", ()=>(0, _chunkFT42GMYPJs.fetchBrapiAlleleMatrix));
parcelHelpers.export(exports, "fetchBrapiGermplasm", ()=>(0, _chunkFT42GMYPJs.fetchBrapiGermplasm));
parcelHelpers.export(exports, "fetchBrapiVariantSetTree", ()=>(0, _chunkFT42GMYPJs.fetchBrapiVariantSetTree));
parcelHelpers.export(exports, "fetchBrapiVariants", ()=>(0, _chunkFT42GMYPJs.fetchBrapiVariants));
parcelHelpers.export(exports, "fetchEnsemblGeneTree", ()=>(0, _chunkFT42GMYPJs.fetchEnsemblGeneTree));
parcelHelpers.export(exports, "fetchEnsemblOverlap", ()=>(0, _chunkFT42GMYPJs.fetchEnsemblOverlap));
parcelHelpers.export(exports, "fetchEnsemblProteinDomains", ()=>(0, _chunkFT42GMYPJs.fetchEnsemblProteinDomains));
parcelHelpers.export(exports, "fetchGrameneExprAttrDocs", ()=>(0, _chunkFT42GMYPJs.fetchGrameneExprAttrDocs));
parcelHelpers.export(exports, "fetchGrameneGene", ()=>(0, _chunkFT42GMYPJs.fetchGrameneGene));
parcelHelpers.export(exports, "fetchGrameneGeneStructures", ()=>(0, _chunkFT42GMYPJs.fetchGrameneGeneStructures));
parcelHelpers.export(exports, "fetchGrameneGenetree", ()=>(0, _chunkFT42GMYPJs.fetchGrameneGenetree));
parcelHelpers.export(exports, "fetchGrameneNeighborhood", ()=>(0, _chunkFT42GMYPJs.fetchGrameneNeighborhood));
parcelHelpers.export(exports, "fetchGrameneSearchDocs", ()=>(0, _chunkFT42GMYPJs.fetchGrameneSearchDocs));
parcelHelpers.export(exports, "fileTreeSource", ()=>(0, _chunkFT42GMYPJs.fileTreeSource));
parcelHelpers.export(exports, "fromBrAPIAlleleMatrix", ()=>(0, _chunkFT42GMYPJs.fromBrAPIAlleleMatrix));
parcelHelpers.export(exports, "fromBrAPIGermplasm", ()=>(0, _chunkFT42GMYPJs.fromBrAPIGermplasm));
parcelHelpers.export(exports, "fromBrAPITree", ()=>(0, _chunkFT42GMYPJs.fromBrAPITree));
parcelHelpers.export(exports, "fromBrAPIVariants", ()=>(0, _chunkFT42GMYPJs.fromBrAPIVariants));
parcelHelpers.export(exports, "fromEnsemblGeneStructure", ()=>(0, _chunkFT42GMYPJs.fromEnsemblGeneStructure));
parcelHelpers.export(exports, "fromEnsemblGeneTree", ()=>(0, _chunkFT42GMYPJs.fromEnsemblGeneTree));
parcelHelpers.export(exports, "fromEnsemblGenomeFeatures", ()=>(0, _chunkFT42GMYPJs.fromEnsemblGenomeFeatures));
parcelHelpers.export(exports, "fromEnsemblProteinFeatures", ()=>(0, _chunkFT42GMYPJs.fromEnsemblProteinFeatures));
parcelHelpers.export(exports, "fromGrameneGene", ()=>(0, _chunkFT42GMYPJs.fromGrameneGene));
parcelHelpers.export(exports, "fromGrameneGeneStructures", ()=>(0, _chunkFT42GMYPJs.fromGrameneGeneStructures));
parcelHelpers.export(exports, "fromGrameneGenetree", ()=>(0, _chunkFT42GMYPJs.fromGrameneGenetree));
parcelHelpers.export(exports, "fromGrameneNeighborhood", ()=>(0, _chunkFT42GMYPJs.fromGrameneNeighborhood));
parcelHelpers.export(exports, "grameneGeneTreeRef", ()=>(0, _chunkFT42GMYPJs.grameneGeneTreeRef));
parcelHelpers.export(exports, "grameneGeneTreeSource", ()=>(0, _chunkFT42GMYPJs.grameneGeneTreeSource));
parcelHelpers.export(exports, "grameneNeighborhoodQuery", ()=>(0, _chunkFT42GMYPJs.grameneNeighborhoodQuery));
parcelHelpers.export(exports, "hostPropsFrom", ()=>(0, _chunkFT42GMYPJs.hostPropsFrom));
parcelHelpers.export(exports, "mergeHostData", ()=>(0, _chunkFT42GMYPJs.mergeHostData));
parcelHelpers.export(exports, "mergeVariantSites", ()=>(0, _chunkFT42GMYPJs.mergeVariantSites));
parcelHelpers.export(exports, "mirrorFor", ()=>(0, _chunkFT42GMYPJs.mirrorFor));
parcelHelpers.export(exports, "staticSource", ()=>(0, _chunkFT42GMYPJs.staticSource));
parcelHelpers.export(exports, "zoneStatusOf", ()=>(0, _chunkFT42GMYPJs.zoneStatusOf));
parcelHelpers.export(exports, "detectDelimiter", ()=>(0, _chunk27AE42SIJs.detectDelimiter));
parcelHelpers.export(exports, "detectTreeFormat", ()=>(0, _chunk27AE42SIJs.detectTreeFormat));
parcelHelpers.export(exports, "inferColumnKind", ()=>(0, _chunk27AE42SIJs.inferColumnKind));
parcelHelpers.export(exports, "parseDelimitedLine", ()=>(0, _chunk27AE42SIJs.parseDelimitedLine));
parcelHelpers.export(exports, "parseNewick", ()=>(0, _chunk27AE42SIJs.parseNewick));
parcelHelpers.export(exports, "parseNewickAll", ()=>(0, _chunk27AE42SIJs.parseNewickAll));
parcelHelpers.export(exports, "parseNexus", ()=>(0, _chunk27AE42SIJs.parseNexus));
parcelHelpers.export(exports, "parsePhyloXML", ()=>(0, _chunk27AE42SIJs.parsePhyloXML));
parcelHelpers.export(exports, "parseTableFile", ()=>(0, _chunk27AE42SIJs.parseTableFile));
parcelHelpers.export(exports, "parseTreeFile", ()=>(0, _chunk27AE42SIJs.parseTreeFile));
parcelHelpers.export(exports, "parseTreeSource", ()=>(0, _chunk27AE42SIJs.parseTreeSource));
parcelHelpers.export(exports, "DEFAULT_SEP_PHASED", ()=>(0, _chunkNFAGMBWMJs.DEFAULT_SEP_PHASED));
parcelHelpers.export(exports, "DEFAULT_SEP_UNPHASED", ()=>(0, _chunkNFAGMBWMJs.DEFAULT_SEP_UNPHASED));
parcelHelpers.export(exports, "DEFAULT_UNKNOWN", ()=>(0, _chunkNFAGMBWMJs.DEFAULT_UNKNOWN));
parcelHelpers.export(exports, "DOSAGE_L1_MEAN", ()=>(0, _chunkNFAGMBWMJs.DOSAGE_L1_MEAN));
parcelHelpers.export(exports, "averageDosage", ()=>(0, _chunkNFAGMBWMJs.averageDosage));
parcelHelpers.export(exports, "colorForAverageDosage", ()=>(0, _chunkNFAGMBWMJs.colorForAverageDosage));
parcelHelpers.export(exports, "colorForCall", ()=>(0, _chunkNFAGMBWMJs.colorForCall));
parcelHelpers.export(exports, "decodeCall", ()=>(0, _chunkNFAGMBWMJs.decodeCall));
parcelHelpers.export(exports, "distanceMatrix", ()=>(0, _chunkNFAGMBWMJs.distanceMatrix));
parcelHelpers.export(exports, "dosagesFromCalls", ()=>(0, _chunkNFAGMBWMJs.dosagesFromCalls));
parcelHelpers.export(exports, "dosagesFromGenotypeMatrix", ()=>(0, _chunkNFAGMBWMJs.dosagesFromGenotypeMatrix));
parcelHelpers.export(exports, "upgma", ()=>(0, _chunkNFAGMBWMJs.upgma));
parcelHelpers.export(exports, "upgmaFromCalls", ()=>(0, _chunkNFAGMBWMJs.upgmaFromCalls));
parcelHelpers.export(exports, "HttpError", ()=>(0, _chunkLPNPUTTSJs.HttpError));
parcelHelpers.export(exports, "RETRYABLE_STATUS", ()=>(0, _chunkLPNPUTTSJs.RETRYABLE_STATUS));
parcelHelpers.export(exports, "backoffMs", ()=>(0, _chunkLPNPUTTSJs.backoffMs));
parcelHelpers.export(exports, "buildUrl", ()=>(0, _chunkLPNPUTTSJs.buildUrl));
parcelHelpers.export(exports, "chunk", ()=>(0, _chunkLPNPUTTSJs.chunk));
parcelHelpers.export(exports, "defaultFetch", ()=>(0, _chunkLPNPUTTSJs.defaultFetch));
parcelHelpers.export(exports, "fanOut", ()=>(0, _chunkLPNPUTTSJs.fanOut));
parcelHelpers.export(exports, "fanOutChunks", ()=>(0, _chunkLPNPUTTSJs.fanOutChunks));
parcelHelpers.export(exports, "fetchWithRetry", ()=>(0, _chunkLPNPUTTSJs.fetchWithRetry));
parcelHelpers.export(exports, "getJson", ()=>(0, _chunkLPNPUTTSJs.getJson));
parcelHelpers.export(exports, "mergeRecords", ()=>(0, _chunkLPNPUTTSJs.mergeRecords));
parcelHelpers.export(exports, "splitUrl", ()=>(0, _chunkLPNPUTTSJs.splitUrl));
parcelHelpers.export(exports, "withRetry", ()=>(0, _chunkLPNPUTTSJs.withRetry));
parcelHelpers.export(exports, "EMPTY_VIEW_STATE", ()=>(0, _chunkL3UJS2UAJs.EMPTY_VIEW_STATE));
parcelHelpers.export(exports, "LEAF_ROW_HEIGHT", ()=>(0, _chunkL3UJS2UAJs.LEAF_ROW_HEIGHT));
parcelHelpers.export(exports, "SUMMARY_ROW_HEIGHT", ()=>(0, _chunkL3UJS2UAJs.SUMMARY_ROW_HEIGHT));
parcelHelpers.export(exports, "applyPivot", ()=>(0, _chunkL3UJS2UAJs.applyPivot));
parcelHelpers.export(exports, "buildInitialViewState", ()=>(0, _chunkL3UJS2UAJs.buildInitialViewState));
parcelHelpers.export(exports, "computeRowRange", ()=>(0, _chunkL3UJS2UAJs.computeRowRange));
parcelHelpers.export(exports, "computeVisibleRows", ()=>(0, _chunkL3UJS2UAJs.computeVisibleRows));
parcelHelpers.export(exports, "createDerivedPruneLayer", ()=>(0, _chunkL3UJS2UAJs.createDerivedPruneLayer));
parcelHelpers.export(exports, "decodeHashState", ()=>(0, _chunkL3UJS2UAJs.decodeHashState));
parcelHelpers.export(exports, "encodeHashState", ()=>(0, _chunkL3UJS2UAJs.encodeHashState));
parcelHelpers.export(exports, "ensureZones", ()=>(0, _chunkL3UJS2UAJs.ensureZones));
parcelHelpers.export(exports, "isViewStateLike", ()=>(0, _chunkL3UJS2UAJs.isViewStateLike));
parcelHelpers.export(exports, "mergeDerivedPrunes", ()=>(0, _chunkL3UJS2UAJs.mergeDerivedPrunes));
parcelHelpers.export(exports, "normalizeViewState", ()=>(0, _chunkL3UJS2UAJs.normalizeViewState));
parcelHelpers.export(exports, "pixelWidthsToFr", ()=>(0, _chunkL3UJS2UAJs.pixelWidthsToFr));
parcelHelpers.export(exports, "readHashState", ()=>(0, _chunkL3UJS2UAJs.readHashState));
parcelHelpers.export(exports, "softResetForNewTree", ()=>(0, _chunkL3UJS2UAJs.softResetForNewTree));
parcelHelpers.export(exports, "stripDerivedPrunes", ()=>(0, _chunkL3UJS2UAJs.stripDerivedPrunes));
parcelHelpers.export(exports, "stripPrunesForSnapshot", ()=>(0, _chunkL3UJS2UAJs.stripPrunesForSnapshot));
parcelHelpers.export(exports, "writeHashState", ()=>(0, _chunkL3UJS2UAJs.writeHashState));
parcelHelpers.export(exports, "countsFromFacet", ()=>(0, _chunkZSCNX7IQJs.countsFromFacet));
parcelHelpers.export(exports, "geneIdByLeafNodeId", ()=>(0, _chunkZSCNX7IQJs.geneIdByLeafNodeId));
parcelHelpers.export(exports, "joinByLeaf", ()=>(0, _chunkZSCNX7IQJs.joinByLeaf));
parcelHelpers.export(exports, "joinByTaxon", ()=>(0, _chunkZSCNX7IQJs.joinByTaxon));
parcelHelpers.export(exports, "leafNodeIdByGeneId", ()=>(0, _chunkZSCNX7IQJs.leafNodeIdByGeneId));
parcelHelpers.export(exports, "maxByNode", ()=>(0, _chunkZSCNX7IQJs.maxByNode));
parcelHelpers.export(exports, "rowFlags", ()=>(0, _chunkZSCNX7IQJs.rowFlags));
parcelHelpers.export(exports, "rowsInRange", ()=>(0, _chunkZSCNX7IQJs.rowsInRange));
parcelHelpers.export(exports, "rowsTotalHeight", ()=>(0, _chunkZSCNX7IQJs.rowsTotalHeight));
parcelHelpers.export(exports, "sumByNode", ()=>(0, _chunkZSCNX7IQJs.sumByNode));
parcelHelpers.export(exports, "EMPTY_NODE_ID_SET", ()=>(0, _chunkF6Q2MMZHJs.EMPTY_NODE_ID_SET));
parcelHelpers.export(exports, "ancestorIdsOf", ()=>(0, _chunkF6Q2MMZHJs.ancestorIdsOf));
parcelHelpers.export(exports, "assertValidTree", ()=>(0, _chunkF6Q2MMZHJs.assertValidTree));
parcelHelpers.export(exports, "buildChildrenIndex", ()=>(0, _chunkF6Q2MMZHJs.buildChildrenIndex));
parcelHelpers.export(exports, "computePivotState", ()=>(0, _chunkF6Q2MMZHJs.computePivotState));
parcelHelpers.export(exports, "countLeavesInSubtree", ()=>(0, _chunkF6Q2MMZHJs.countLeavesInSubtree));
parcelHelpers.export(exports, "depthOf", ()=>(0, _chunkF6Q2MMZHJs.depthOf));
parcelHelpers.export(exports, "fromHierarchy", ()=>(0, _chunkF6Q2MMZHJs.fromHierarchy));
parcelHelpers.export(exports, "fromTreeModel", ()=>(0, _chunkF6Q2MMZHJs.fromTreeModel));
parcelHelpers.export(exports, "isLeafNode", ()=>(0, _chunkF6Q2MMZHJs.isLeafNode));
parcelHelpers.export(exports, "lca", ()=>(0, _chunkF6Q2MMZHJs.lca));
parcelHelpers.export(exports, "leafGeneIds", ()=>(0, _chunkF6Q2MMZHJs.leafGeneIds));
parcelHelpers.export(exports, "leafIdsOf", ()=>(0, _chunkF6Q2MMZHJs.leafIdsOf));
parcelHelpers.export(exports, "leafOrder", ()=>(0, _chunkF6Q2MMZHJs.leafOrder));
parcelHelpers.export(exports, "leavesFailing", ()=>(0, _chunkF6Q2MMZHJs.leavesFailing));
parcelHelpers.export(exports, "maximalExcludedClades", ()=>(0, _chunkF6Q2MMZHJs.maximalExcludedClades));
parcelHelpers.export(exports, "nodeHeights", ()=>(0, _chunkF6Q2MMZHJs.nodeHeights));
parcelHelpers.export(exports, "pathToRoot", ()=>(0, _chunkF6Q2MMZHJs.pathToRoot));
parcelHelpers.export(exports, "postorder", ()=>(0, _chunkF6Q2MMZHJs.postorder));
parcelHelpers.export(exports, "preorder", ()=>(0, _chunkF6Q2MMZHJs.preorder));
parcelHelpers.export(exports, "pruneToLeaves", ()=>(0, _chunkF6Q2MMZHJs.pruneToLeaves));
parcelHelpers.export(exports, "quoteNewickLabel", ()=>(0, _chunkF6Q2MMZHJs.quoteNewickLabel));
parcelHelpers.export(exports, "rollUp", ()=>(0, _chunkF6Q2MMZHJs.rollUp));
parcelHelpers.export(exports, "subtree", ()=>(0, _chunkF6Q2MMZHJs.subtree));
parcelHelpers.export(exports, "subtreeIdsOf", ()=>(0, _chunkF6Q2MMZHJs.subtreeIdsOf));
parcelHelpers.export(exports, "sumLeafCounts", ()=>(0, _chunkF6Q2MMZHJs.sumLeafCounts));
parcelHelpers.export(exports, "swapsForLeafOrder", ()=>(0, _chunkF6Q2MMZHJs.swapsForLeafOrder));
parcelHelpers.export(exports, "toNewick", ()=>(0, _chunkF6Q2MMZHJs.toNewick));
parcelHelpers.export(exports, "validateTree", ()=>(0, _chunkF6Q2MMZHJs.validateTree));
parcelHelpers.export(exports, "AGGREGATE_METHODS", ()=>AGGREGATE_METHODS) //# sourceMappingURL=index.js.map
;
parcelHelpers.export(exports, "DEFAULT_METHOD_ID", ()=>DEFAULT_METHOD_ID);
parcelHelpers.export(exports, "NULL_GLYPH", ()=>NULL_GLYPH);
parcelHelpers.export(exports, "SEARCH_MATCH_LIMIT", ()=>SEARCH_MATCH_LIMIT);
parcelHelpers.export(exports, "defaultAggregators", ()=>defaultAggregators);
parcelHelpers.export(exports, "methodForKind", ()=>methodForKind);
parcelHelpers.export(exports, "normalizeAggregateResult", ()=>normalizeAggregateResult);
var _chunkSDSXDAADJs = require("./chunk-SDSXDAAD.js");
var _chunkFT42GMYPJs = require("./chunk-FT42GMYP.js");
var _chunk27AE42SIJs = require("./chunk-27AE42SI.js");
var _chunkNFAGMBWMJs = require("./chunk-NFAGMBWM.js");
var _chunkLPNPUTTSJs = require("./chunk-LPNPUTTS.js");
var _chunkL3UJS2UAJs = require("./chunk-L3UJS2UA.js");
var _chunkZSCNX7IQJs = require("./chunk-ZSCNX7IQ.js");
var _chunkF6Q2MMZHJs = require("./chunk-F6Q2MMZH.js");
// src/types.ts
var SEARCH_MATCH_LIMIT = 1e4;
// src/table/aggregators.ts
var NULL_GLYPH = "\u2014";
function fmtNum(n, digits = 2) {
    return n.toLocaleString(void 0, {
        maximumFractionDigits: digits
    });
}
function asNumbers(values) {
    return values.filter((v)=>typeof v === "number" && Number.isFinite(v));
}
var meanStdev = ({ values, totalLeaves, leavesWithValue })=>{
    const nums = asNumbers(values);
    if (nums.length === 0) return {
        text: NULL_GLYPH,
        title: `n=0 / ${totalLeaves}`
    };
    let mean = 0;
    for (const v of nums)mean += v;
    mean /= nums.length;
    if (nums.length === 1) return {
        text: fmtNum(mean),
        title: `n=1 / ${totalLeaves}
value=${fmtNum(mean, 6)}`,
        numeric: mean
    };
    let min = nums[0];
    let max = nums[0];
    let sumSq = 0;
    for (const v of nums){
        if (v < min) min = v;
        if (v > max) max = v;
        const d = v - mean;
        sumSq += d * d;
    }
    const stdev = Math.sqrt(sumSq / (nums.length - 1));
    const text = `${fmtNum(mean)} \xB1 ${fmtNum(stdev)}`;
    const title = [
        `n=${leavesWithValue} / ${totalLeaves}`,
        `mean=${fmtNum(mean, 6)}`,
        `stdev=${fmtNum(stdev, 6)}`,
        `min=${fmtNum(min, 6)}`,
        `max=${fmtNum(max, 6)}`
    ].join("\n");
    return {
        text,
        title,
        numeric: mean
    };
};
var meanOnly = ({ values, totalLeaves })=>{
    const nums = asNumbers(values);
    if (nums.length === 0) return {
        text: NULL_GLYPH,
        title: `n=0 / ${totalLeaves}`
    };
    let mean = 0;
    for (const v of nums)mean += v;
    mean /= nums.length;
    return {
        text: fmtNum(mean),
        title: `mean of ${nums.length} / ${totalLeaves}`,
        numeric: mean
    };
};
var median = ({ values, totalLeaves })=>{
    const nums = asNumbers(values).slice().sort((a, b)=>a - b);
    if (nums.length === 0) return {
        text: NULL_GLYPH,
        title: `n=0 / ${totalLeaves}`
    };
    const mid = Math.floor(nums.length / 2);
    const m = nums.length % 2 === 0 ? (nums[mid - 1] + nums[mid]) / 2 : nums[mid];
    return {
        text: fmtNum(m),
        title: `median of ${nums.length} / ${totalLeaves}`,
        numeric: m
    };
};
var minMax = ({ values, totalLeaves })=>{
    const nums = asNumbers(values);
    if (nums.length === 0) return {
        text: NULL_GLYPH,
        title: `n=0 / ${totalLeaves}`
    };
    let mn = nums[0];
    let mx = nums[0];
    for (const v of nums){
        if (v < mn) mn = v;
        if (v > mx) mx = v;
    }
    const text = mn === mx ? fmtNum(mn) : `${fmtNum(mn)} \u2013 ${fmtNum(mx)}`;
    return {
        text,
        title: `min=${fmtNum(mn, 6)}
max=${fmtNum(mx, 6)}
n=${nums.length} / ${totalLeaves}`,
        numeric: (mn + mx) / 2
    };
};
var sum = ({ values, totalLeaves })=>{
    const nums = asNumbers(values);
    if (nums.length === 0) return {
        text: NULL_GLYPH,
        title: `n=0 / ${totalLeaves}`
    };
    let s = 0;
    for (const v of nums)s += v;
    return {
        text: fmtNum(s),
        title: `sum of ${nums.length} / ${totalLeaves}`,
        numeric: s
    };
};
var fraction = ({ values, totalLeaves, leavesWithValue })=>{
    if (leavesWithValue === 0) return {
        text: NULL_GLYPH,
        title: `n=0 / ${totalLeaves}`
    };
    let trues = 0;
    for (const v of values)if (v === true) trues++;
    return {
        text: `${trues}/${leavesWithValue}`,
        title: `${trues} true \xB7 ${leavesWithValue - trues} false \xB7 ${totalLeaves - leavesWithValue} missing`,
        numeric: leavesWithValue === 0 ? 0 : trues / leavesWithValue
    };
};
var percent = ({ values, totalLeaves, leavesWithValue })=>{
    if (leavesWithValue === 0) return {
        text: NULL_GLYPH,
        title: `n=0 / ${totalLeaves}`
    };
    let trues = 0;
    for (const v of values)if (v === true) trues++;
    const pct = trues / leavesWithValue * 100;
    return {
        text: `${fmtNum(pct, 1)}%`,
        title: `${trues}/${leavesWithValue} true (of ${totalLeaves} total)`,
        numeric: trues / leavesWithValue
    };
};
var countTrue = ({ values, totalLeaves })=>{
    let trues = 0;
    for (const v of values)if (v === true) trues++;
    return {
        text: trues === 0 ? NULL_GLYPH : `${trues}`,
        title: `${trues} true / ${totalLeaves} leaves`,
        numeric: trues
    };
};
var dominant = ({ values, totalLeaves, leavesWithValue })=>{
    if (values.length === 0) return {
        text: NULL_GLYPH,
        title: `n=0 / ${totalLeaves}`
    };
    const counts = /* @__PURE__ */ new Map();
    for (const v of values){
        const s = String(v);
        counts.set(s, (counts.get(s) ?? 0) + 1);
    }
    const sorted = Array.from(counts.entries()).sort((a, b)=>b[1] - a[1]);
    if (sorted.length === 1) return {
        text: sorted[0][0],
        title: `${leavesWithValue}/${totalLeaves} all "${sorted[0][0]}"`
    };
    const text = sorted.length <= 3 ? sorted.map(([s])=>s).join(", ") : `${sorted.length} unique`;
    const title = sorted.slice(0, 8).map(([s, c])=>`${s}: ${c}`).concat(sorted.length > 8 ? [
        `\u2026 +${sorted.length - 8} more`
    ] : []).join("\n");
    return {
        text,
        title
    };
};
var uniqueCount = ({ values, totalLeaves })=>{
    if (values.length === 0) return {
        text: NULL_GLYPH,
        title: `n=0 / ${totalLeaves}`
    };
    const set = new Set(values.map((v)=>String(v)));
    return {
        text: `${set.size}`,
        title: `${set.size} unique values across ${values.length} / ${totalLeaves}`,
        numeric: set.size
    };
};
var AGGREGATE_METHODS = {
    number: [
        {
            id: "mean-stdev",
            label: "Mean \xB1 stdev",
            fn: meanStdev
        },
        {
            id: "mean",
            label: "Mean",
            fn: meanOnly
        },
        {
            id: "median",
            label: "Median",
            fn: median
        },
        {
            id: "min-max",
            label: "Min \u2013 Max",
            fn: minMax
        },
        {
            id: "sum",
            label: "Sum",
            fn: sum
        }
    ],
    boolean: [
        {
            id: "fraction",
            label: "n / total",
            fn: fraction
        },
        {
            id: "percent",
            label: "Percent true",
            fn: percent
        },
        {
            id: "count-true",
            label: "Count true",
            fn: countTrue
        }
    ],
    string: [
        {
            id: "dominant",
            label: "Dominant value",
            fn: dominant
        },
        {
            id: "unique-count",
            label: "Unique count",
            fn: uniqueCount
        }
    ]
};
var DEFAULT_METHOD_ID = {
    number: "mean-stdev",
    boolean: "fraction",
    string: "dominant"
};
function methodForKind(kind, id) {
    const list = AGGREGATE_METHODS[kind];
    if (id) {
        const m = list.find((m2)=>m2.id === id);
        if (m) return m;
    }
    const def = list.find((m)=>m.id === DEFAULT_METHOD_ID[kind]);
    return def ?? list[0];
}
var defaultAggregators = {
    number: methodForKind("number", void 0).fn,
    boolean: methodForKind("boolean", void 0).fn,
    string: methodForKind("string", void 0).fn
};
function normalizeAggregateResult(out) {
    return typeof out === "string" ? {
        text: out
    } : out;
}

},{"./chunk-SDSXDAAD.js":"ajNr9","./chunk-FT42GMYP.js":"g1iVz","./chunk-27AE42SI.js":"deWm1","./chunk-NFAGMBWM.js":"1Bebw","./chunk-LPNPUTTS.js":"4knjt","./chunk-L3UJS2UA.js":"e3cof","./chunk-ZSCNX7IQ.js":"eGIqJ","./chunk-F6Q2MMZH.js":"kxqsj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ajNr9":[function(require,module,exports,__globalThis) {
//# sourceMappingURL=chunk-SDSXDAAD.js.map

},{}],"g1iVz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BRAPI_DIMENSION_PAGE_SIZE", ()=>BRAPI_DIMENSION_PAGE_SIZE) //# sourceMappingURL=chunk-FT42GMYP.js.map
;
parcelHelpers.export(exports, "BRAPI_VARIANTS_PAGE_SIZE", ()=>BRAPI_VARIANTS_PAGE_SIZE);
parcelHelpers.export(exports, "ENSEMBL_DEFAULT_DOMAIN_SOURCES", ()=>ENSEMBL_DEFAULT_DOMAIN_SOURCES);
parcelHelpers.export(exports, "ENSEMBL_DEFAULT_MIRROR", ()=>ENSEMBL_DEFAULT_MIRROR);
parcelHelpers.export(exports, "ENSEMBL_MIRRORS", ()=>ENSEMBL_MIRRORS);
parcelHelpers.export(exports, "GRAMENE_DEFAULT_BASE", ()=>GRAMENE_DEFAULT_BASE);
parcelHelpers.export(exports, "GRAMENE_DEFAULT_TREE_FIELD", ()=>GRAMENE_DEFAULT_TREE_FIELD);
parcelHelpers.export(exports, "GRAMENE_GENE_STRUCTURE_FL", ()=>GRAMENE_GENE_STRUCTURE_FL);
parcelHelpers.export(exports, "brapiAlleleMatrixSource", ()=>brapiAlleleMatrixSource);
parcelHelpers.export(exports, "brapiBaseOf", ()=>brapiBaseOf);
parcelHelpers.export(exports, "brapiMatrixUrlWithDefaults", ()=>brapiMatrixUrlWithDefaults);
parcelHelpers.export(exports, "brapiPages", ()=>brapiPages);
parcelHelpers.export(exports, "brapiVariantsUrlFrom", ()=>brapiVariantsUrlFrom);
parcelHelpers.export(exports, "createLoader", ()=>createLoader);
parcelHelpers.export(exports, "defineSlot", ()=>defineSlot);
parcelHelpers.export(exports, "ensemblGeneTreeSource", ()=>ensemblGeneTreeSource);
parcelHelpers.export(exports, "ensemblGeneTreeUrl", ()=>ensemblGeneTreeUrl);
parcelHelpers.export(exports, "expandCigar", ()=>expandCigar);
parcelHelpers.export(exports, "extendSource", ()=>extendSource);
parcelHelpers.export(exports, "facetPairsToCounts", ()=>facetPairsToCounts);
parcelHelpers.export(exports, "fetchBrapiAlleleMatrix", ()=>fetchBrapiAlleleMatrix);
parcelHelpers.export(exports, "fetchBrapiGermplasm", ()=>fetchBrapiGermplasm);
parcelHelpers.export(exports, "fetchBrapiVariantSetTree", ()=>fetchBrapiVariantSetTree);
parcelHelpers.export(exports, "fetchBrapiVariants", ()=>fetchBrapiVariants);
parcelHelpers.export(exports, "fetchEnsemblGeneTree", ()=>fetchEnsemblGeneTree);
parcelHelpers.export(exports, "fetchEnsemblOverlap", ()=>fetchEnsemblOverlap);
parcelHelpers.export(exports, "fetchEnsemblProteinDomains", ()=>fetchEnsemblProteinDomains);
parcelHelpers.export(exports, "fetchGrameneExprAttrDocs", ()=>fetchGrameneExprAttrDocs);
parcelHelpers.export(exports, "fetchGrameneGene", ()=>fetchGrameneGene);
parcelHelpers.export(exports, "fetchGrameneGeneStructures", ()=>fetchGrameneGeneStructures);
parcelHelpers.export(exports, "fetchGrameneGenetree", ()=>fetchGrameneGenetree);
parcelHelpers.export(exports, "fetchGrameneNeighborhood", ()=>fetchGrameneNeighborhood);
parcelHelpers.export(exports, "fetchGrameneSearchDocs", ()=>fetchGrameneSearchDocs);
parcelHelpers.export(exports, "fileTreeSource", ()=>fileTreeSource);
parcelHelpers.export(exports, "fromBrAPIAlleleMatrix", ()=>fromBrAPIAlleleMatrix);
parcelHelpers.export(exports, "fromBrAPIGermplasm", ()=>fromBrAPIGermplasm);
parcelHelpers.export(exports, "fromBrAPITree", ()=>fromBrAPITree);
parcelHelpers.export(exports, "fromBrAPIVariants", ()=>fromBrAPIVariants);
parcelHelpers.export(exports, "fromEnsemblGeneStructure", ()=>fromEnsemblGeneStructure);
parcelHelpers.export(exports, "fromEnsemblGeneTree", ()=>fromEnsemblGeneTree);
parcelHelpers.export(exports, "fromEnsemblGenomeFeatures", ()=>fromEnsemblGenomeFeatures);
parcelHelpers.export(exports, "fromEnsemblProteinFeatures", ()=>fromEnsemblProteinFeatures);
parcelHelpers.export(exports, "fromGrameneGene", ()=>fromGrameneGene);
parcelHelpers.export(exports, "fromGrameneGeneStructures", ()=>fromGrameneGeneStructures);
parcelHelpers.export(exports, "fromGrameneGenetree", ()=>fromGrameneGenetree);
parcelHelpers.export(exports, "fromGrameneNeighborhood", ()=>fromGrameneNeighborhood);
parcelHelpers.export(exports, "grameneGeneTreeRef", ()=>grameneGeneTreeRef);
parcelHelpers.export(exports, "grameneGeneTreeSource", ()=>grameneGeneTreeSource);
parcelHelpers.export(exports, "grameneNeighborhoodQuery", ()=>grameneNeighborhoodQuery);
parcelHelpers.export(exports, "hostPropsFrom", ()=>hostPropsFrom);
parcelHelpers.export(exports, "mergeHostData", ()=>mergeHostData);
parcelHelpers.export(exports, "mergeVariantSites", ()=>mergeVariantSites);
parcelHelpers.export(exports, "mirrorFor", ()=>mirrorFor);
parcelHelpers.export(exports, "staticSource", ()=>staticSource);
parcelHelpers.export(exports, "zoneStatusOf", ()=>zoneStatusOf);
var _chunk27AE42SIJs = require("./chunk-27AE42SI.js");
var _chunkNFAGMBWMJs = require("./chunk-NFAGMBWM.js");
var _chunkLPNPUTTSJs = require("./chunk-LPNPUTTS.js");
var _chunkF6Q2MMZHJs = require("./chunk-F6Q2MMZH.js");
// src/adapters/ensembl.ts
function fromEnsemblGeneTree(json, options = {}) {
    const response = json;
    if (!response || !response.tree) throw new Error('fromEnsemblGeneTree: input is not a valid Ensembl gene-tree response (missing top-level "tree")');
    const nodes = {};
    const taxonomy = {};
    const sequences = {};
    const geneMetadata = {};
    const proteinIdByGeneId = {};
    let nextId = 0;
    const walk = (en, parentId)=>{
        const id = `n${nextId++}`;
        const isLeaf = !en.children || en.children.length === 0;
        const node = {
            id,
            parentId,
            distance: typeof en.branch_length === "number" ? en.branch_length : 0,
            isLeaf
        };
        if (en.taxonomy?.id !== void 0) {
            node.taxonomyId = en.taxonomy.id;
            if (!taxonomy[en.taxonomy.id]) {
                const tax = {};
                if (en.taxonomy.scientific_name) tax.scientificName = en.taxonomy.scientific_name;
                if (en.taxonomy.common_name) tax.commonName = en.taxonomy.common_name;
                taxonomy[en.taxonomy.id] = tax;
            }
        }
        if (en.events?.type === "speciation" || en.events?.type === "duplication") node.eventType = en.events.type;
        if (en.confidence && typeof en.confidence.bootstrap === "number") node.bootstrap = en.confidence.bootstrap;
        if (isLeaf) {
            const accession = en.id?.accession;
            if (accession) {
                node.geneId = accession;
                if (en.sequence?.mol_seq?.seq) sequences[accession] = en.sequence.mol_seq.seq;
                const meta = {};
                if (en.sequence?.name) meta.displayName = en.sequence.name;
                if (Object.keys(meta).length > 0) geneMetadata[accession] = meta;
                const proteinId = extractProteinId(en.sequence);
                if (proteinId) proteinIdByGeneId[accession] = proteinId;
            }
        }
        nodes[id] = node;
        if (en.children) for (const child of en.children)walk(child, id);
        return id;
    };
    const rootId = walk(response.tree, null);
    const sequenceList = Object.values(sequences);
    let msa;
    if (sequenceList.length > 0) {
        const length = sequenceList.reduce((m, s)=>Math.max(m, s.length), 0);
        for (const k of Object.keys(sequences)){
            const s = sequences[k];
            if (s.length < length) sequences[k] = s.padEnd(length, "-");
        }
        const alphabet = options.alphabet ?? detectAlphabet(sequenceList);
        msa = {
            alphabet,
            length,
            sequences
        };
    }
    return {
        tree: {
            rootId,
            nodes
        },
        taxonomy,
        ...msa !== void 0 ? {
            msa
        } : {},
        geneMetadata,
        proteinIdByGeneId
    };
}
function extractProteinId(seq) {
    if (!seq) return null;
    const sid = seq.id;
    if (Array.isArray(sid)) {
        const arr = sid;
        const ensembl = arr.find((e)=>e && typeof e === "object" && typeof e.accession === "string" && (e.source ?? "").toLowerCase().includes("ensembl"));
        const pick = ensembl ?? arr.find((e)=>e && typeof e.accession === "string");
        if (pick?.accession) return pick.accession;
    } else if (typeof sid === "string" && sid !== "") return sid;
    else if (sid && typeof sid === "object") {
        const obj = sid;
        if (typeof obj.accession === "string" && obj.accession !== "") return obj.accession;
    }
    if (typeof seq.name === "string" && /^ENS\w*P\d+/i.test(seq.name)) return seq.name;
    return null;
}
function fromEnsemblProteinFeatures(json, options = {}) {
    if (!Array.isArray(json)) throw new Error("fromEnsemblProteinFeatures: expected an array of protein-feature rows");
    const allow = options.sources && options.sources.length > 0 ? new Set(options.sources) : null;
    const out = [];
    for (const raw of json){
        if (!raw || typeof raw !== "object") continue;
        if (typeof raw.id !== "string" || raw.id === "") continue;
        if (typeof raw.start !== "number" || typeof raw.end !== "number") continue;
        if (allow && !allow.has(raw.type ?? "")) continue;
        const domain = {
            id: raw.id,
            name: raw.description ?? raw.id,
            start: raw.start,
            end: raw.end
        };
        if (typeof raw.type === "string" && raw.type !== "") domain.source = raw.type;
        out.push(domain);
    }
    return out;
}
function detectAlphabet(sequences) {
    const sample = sequences.slice(0, 5).join("").slice(0, 4e3);
    return /^[ACGTNacgtn\-]*$/.test(sample) ? "dna" : "protein";
}
function fromEnsemblGeneStructure(json, geneId) {
    if (!Array.isArray(json)) return null;
    const features = json;
    const transcripts = [];
    const exonsByTranscript = /* @__PURE__ */ new Map();
    const cdsByTranscript = /* @__PURE__ */ new Map();
    for (const f of features){
        if (!f || typeof f.feature_type !== "string") continue;
        if (f.feature_type === "transcript") {
            if (f.Parent === geneId) transcripts.push(f);
        } else if (f.feature_type === "exon" && typeof f.Parent === "string") {
            const arr = exonsByTranscript.get(f.Parent) ?? [];
            arr.push(f);
            exonsByTranscript.set(f.Parent, arr);
        } else if (f.feature_type === "cds" && typeof f.Parent === "string") {
            const arr = cdsByTranscript.get(f.Parent) ?? [];
            arr.push(f);
            cdsByTranscript.set(f.Parent, arr);
        }
    }
    if (transcripts.length === 0) return null;
    const ref = transcripts.find((t)=>typeof t.seq_region_name === "string" && typeof t.strand === "number");
    if (!ref || typeof ref.seq_region_name !== "string" || typeof ref.strand !== "number") return null;
    const region = ref.seq_region_name;
    const strand = ref.strand === -1 ? -1 : 1;
    let geneStart = Infinity;
    let geneEnd = -Infinity;
    const transcriptsOut = [];
    let canonicalId = null;
    for (const t of transcripts){
        if (typeof t.id !== "string" || typeof t.start !== "number" || typeof t.end !== "number") continue;
        if (t.start < geneStart) geneStart = t.start;
        if (t.end > geneEnd) geneEnd = t.end;
        const exonRows = (exonsByTranscript.get(t.id) ?? []).filter((e)=>typeof e.start === "number" && typeof e.end === "number").sort((a, b)=>(a.start ?? 0) - (b.start ?? 0));
        const cdsRows = (cdsByTranscript.get(t.id) ?? []).filter((c)=>typeof c.start === "number" && typeof c.end === "number");
        const exonsOut = [];
        for (const e of exonRows){
            const eStart = e.start;
            const eEnd = e.end;
            let cdsStart;
            let cdsEnd;
            for (const c of cdsRows){
                const cStart = c.start;
                const cEnd = c.end;
                if (cEnd < eStart || cStart > eEnd) continue;
                const sub = Math.max(cStart, eStart);
                const eub = Math.min(cEnd, eEnd);
                cdsStart = cdsStart === void 0 ? sub : Math.min(cdsStart, sub);
                cdsEnd = cdsEnd === void 0 ? eub : Math.max(cdsEnd, eub);
            }
            exonsOut.push({
                start: eStart,
                end: eEnd,
                ...cdsStart !== void 0 ? {
                    cdsStart
                } : {},
                ...cdsEnd !== void 0 ? {
                    cdsEnd
                } : {}
            });
        }
        if (t.is_canonical === 1) canonicalId = t.id;
        transcriptsOut.push({
            id: t.id,
            isCanonical: t.is_canonical === 1,
            ...typeof t.biotype === "string" ? {
                biotype: t.biotype
            } : {},
            exons: exonsOut
        });
    }
    if (transcriptsOut.length === 0) return null;
    if (!canonicalId) {
        let bestCds = -1;
        let bestLen = -1;
        let bestId = transcriptsOut[0].id;
        for (const tr of transcriptsOut){
            let cds = 0;
            let len = 0;
            for (const e of tr.exons){
                if (e.cdsStart !== void 0 && e.cdsEnd !== void 0) cds += e.cdsEnd - e.cdsStart + 1;
                len += e.end - e.start + 1;
            }
            if (cds > bestCds || cds === bestCds && len > bestLen) {
                bestCds = cds;
                bestLen = len;
                bestId = tr.id;
            }
        }
        canonicalId = bestId;
        const found = transcriptsOut.find((tr)=>tr.id === canonicalId);
        if (found) found.isCanonical = true;
    }
    const name = typeof ref.external_name === "string" && ref.external_name !== "" ? // Ensembl appends "-201" etc. to transcript-level external_names;
    // strip that to surface the bare gene symbol.
    ref.external_name.replace(/-\d+$/, "") : void 0;
    return {
        region,
        strand,
        start: geneStart,
        end: geneEnd,
        canonicalTranscriptId: canonicalId,
        transcripts: transcriptsOut,
        ...name !== void 0 ? {
            name
        } : {}
    };
}
function fromEnsemblGenomeFeatures(json) {
    if (!Array.isArray(json)) return [];
    const out = [];
    for (const raw of json){
        if (!raw || typeof raw !== "object") continue;
        if (typeof raw.id !== "string" || typeof raw.start !== "number" || typeof raw.end !== "number") continue;
        if (raw.feature_type === "gene" || raw.feature_type === "transcript" || raw.feature_type === "exon" || raw.feature_type === "cds") continue;
        const kind = raw.feature_type_class && raw.feature_type_class !== "" && raw.feature_type_class || raw.feature_type || "feature";
        const f = {
            id: raw.id,
            kind,
            start: raw.start,
            end: raw.end
        };
        if (raw.strand === 1 || raw.strand === -1) f.strand = raw.strand;
        const label = raw.description ?? raw.binding_matrix_stable_id ?? raw.feature_type_class ?? raw.feature_type;
        if (typeof label === "string" && label !== "") f.label = label;
        out.push(f);
    }
    return out;
}
// src/adapters/gramene.ts
function fromGrameneGenetree(json, options = {}) {
    if (!Array.isArray(json) || json.length === 0) throw new Error("fromGrameneGenetree: expected a non-empty array of genetree root nodes");
    const root = json[0];
    const nodes = {};
    const taxonomy = {};
    const sequences = {};
    const geneMetadata = {};
    const proteinDomains = {};
    const exonJunctions = {};
    const proteinIdByGeneId = {};
    let nextId = 0;
    const walk = (gn, parentId)=>{
        const id = `n${nextId++}`;
        const isLeaf = !gn.children || gn.children.length === 0;
        const node = {
            id,
            parentId,
            distance: typeof gn.distance_to_parent === "number" ? gn.distance_to_parent : 0,
            isLeaf
        };
        if (typeof gn.taxon_id === "number") {
            node.taxonomyId = gn.taxon_id;
            if (!taxonomy[gn.taxon_id]) {
                const tax = {};
                if (gn.taxon_name) tax.scientificName = gn.taxon_name;
                if (isLeaf && gn.system_name) tax.commonName = gn.system_name;
                taxonomy[gn.taxon_id] = tax;
            }
        }
        if (gn.node_type === "speciation" || gn.node_type === "duplication") node.eventType = gn.node_type;
        if (typeof gn.bootstrap === "number") node.bootstrap = gn.bootstrap;
        if (isLeaf) {
            const accession = gn.gene_stable_id;
            if (accession) {
                node.geneId = accession;
                if (gn.sequence) {
                    const aligned = gn.cigar ? expandCigar(gn.sequence, gn.cigar) : gn.sequence;
                    sequences[accession] = aligned;
                }
                const meta = {};
                if (gn.gene_display_label) meta.displayName = gn.gene_display_label;
                if (gn.gene_description) meta.description = gn.gene_description;
                if (gn.protein_stable_id) meta.proteinId = gn.protein_stable_id;
                if (Object.keys(meta).length > 0) geneMetadata[accession] = meta;
                if (gn.protein_stable_id) proteinIdByGeneId[accession] = gn.protein_stable_id;
                if (gn.exon_junctions && gn.exon_junctions.length > 0) {
                    const seen = /* @__PURE__ */ new Set();
                    const clean = [];
                    for (const j of gn.exon_junctions){
                        if (typeof j !== "number" || !Number.isFinite(j) || j <= 0) continue;
                        if (seen.has(j)) continue;
                        seen.add(j);
                        clean.push(j);
                    }
                    if (clean.length > 0) exonJunctions[accession] = clean;
                }
                if (gn.domains && gn.domains.length > 0) {
                    const hits = [];
                    for (const d of gn.domains){
                        if (typeof d.id !== "string" || d.id === "") continue;
                        if (typeof d.start !== "number" || typeof d.end !== "number") continue;
                        hits.push({
                            id: d.id,
                            name: d.name ?? d.description ?? d.id,
                            start: d.start,
                            end: d.end,
                            source: "InterPro"
                        });
                    }
                    if (hits.length > 0) proteinDomains[accession] = hits;
                }
            }
        }
        nodes[id] = node;
        if (gn.children) for (const child of gn.children)walk(child, id);
        return id;
    };
    const rootId = walk(root, null);
    const sequenceList = Object.values(sequences);
    let msa;
    if (sequenceList.length > 0) {
        const length = sequenceList.reduce((m, s)=>Math.max(m, s.length), 0);
        for (const k of Object.keys(sequences)){
            const s = sequences[k];
            if (s.length < length) sequences[k] = s.padEnd(length, "-");
        }
        msa = {
            alphabet: options.alphabet ?? "protein",
            length,
            sequences
        };
    }
    return {
        tree: {
            rootId,
            nodes
        },
        taxonomy,
        ...msa !== void 0 ? {
            msa
        } : {},
        geneMetadata,
        proteinDomains,
        exonJunctions,
        proteinIdByGeneId,
        treeField: typeof root.tree_set === "string" && root.tree_set !== "" ? root.tree_set : GRAMENE_DEFAULT_TREE_FIELD
    };
}
function expandCigar(sequence, cigar) {
    if (!cigar) return sequence;
    const out = [];
    let pos = 0;
    for (const match of cigar.matchAll(/(\d*)([MD])/g)){
        const len = match[1] === "" ? 1 : parseInt(match[1], 10);
        if (match[2] === "M") {
            out.push(sequence.substr(pos, len));
            pos += len;
        } else out.push("-".repeat(len));
    }
    return out.join("");
}
var GRAMENE_DEFAULT_TREE_FIELD = "gene_tree";
var NOT_TREE_KEYS = /* @__PURE__ */ new Set([
    "homologous_genes",
    "supertree"
]);
function grameneGeneTreeRef(homology) {
    if (!homology || typeof homology !== "object") return null;
    const h = homology;
    const idOf = (v)=>{
        const id = v && typeof v === "object" ? v.id : void 0;
        return typeof id === "string" && id !== "" ? id : null;
    };
    const main = idOf(h[GRAMENE_DEFAULT_TREE_FIELD]);
    if (main) return {
        id: main,
        field: GRAMENE_DEFAULT_TREE_FIELD
    };
    for (const key of Object.keys(h)){
        if (NOT_TREE_KEYS.has(key)) continue;
        const id = idOf(h[key]);
        if (id) return {
            id,
            field: key
        };
    }
    return null;
}
function fromGrameneGene(json) {
    if (!Array.isArray(json) || json.length === 0) throw new Error("fromGrameneGene: expected a non-empty array of gene docs");
    const doc = json[0];
    if (typeof doc._id !== "string" || doc._id === "") throw new Error("fromGrameneGene: gene doc is missing _id");
    const ref = grameneGeneTreeRef(doc.homology);
    return {
        geneId: doc._id,
        geneTreeId: ref ? ref.id : null,
        geneTreeField: ref ? ref.field : null,
        taxonomyId: typeof doc.taxon_id === "number" ? doc.taxon_id : null,
        systemName: doc.system_name ?? null,
        description: doc.description ?? null
    };
}
function fromGrameneNeighborhood(json, options = {}) {
    const treeField = options.treeField ?? GRAMENE_DEFAULT_TREE_FIELD;
    const docs = json?.response?.docs;
    if (!Array.isArray(docs)) return {};
    const groups = /* @__PURE__ */ new Map();
    for (const doc of docs){
        if (typeof doc.id !== "string" || doc.id === "") continue;
        if (typeof doc.gene_idx !== "number" || !Number.isFinite(doc.gene_idx)) continue;
        if (typeof doc.region !== "string" || doc.region === "") continue;
        if (typeof doc.system_name !== "string" || doc.system_name === "") continue;
        const key = `${doc.system_name}	${doc.region}`;
        let arr = groups.get(key);
        if (!arr) {
            arr = [];
            groups.set(key, arr);
        }
        arr.push(doc);
    }
    for (const arr of groups.values())arr.sort((a, b)=>(a.gene_idx ?? 0) - (b.gene_idx ?? 0));
    const toGene = (d)=>{
        const gene = {
            id: d.id,
            strand: d.strand === -1 ? -1 : 1,
            start: typeof d.start === "number" ? d.start : 0,
            end: typeof d.end === "number" ? d.end : 0
        };
        if (d.name) gene.name = d.name;
        if (d.description && d.description !== '""') gene.description = d.description;
        if (d.region) gene.region = d.region;
        if (d.biotype) gene.biotype = d.biotype;
        const family = d[treeField] ?? d.gene_tree;
        if (typeof family === "string" && family !== "") gene.geneTree = family;
        return gene;
    };
    const FLANK = 10;
    const out = {};
    for (const arr of groups.values())for(let i = 0; i < arr.length; i++){
        const center = arr[i];
        const lo = Math.max(0, i - FLANK);
        const hi = Math.min(arr.length, i + FLANK + 1);
        out[center.id] = {
            center: toGene(center),
            upstream: arr.slice(lo, i).map(toGene),
            downstream: arr.slice(i + 1, hi).map(toGene)
        };
    }
    return out;
}
function fromGrameneGeneStructures(json) {
    if (!Array.isArray(json)) return {};
    const out = {};
    for (const docRaw of json){
        const doc = docRaw;
        if (typeof doc._id !== "string" || doc._id === "") continue;
        const loc = doc.location;
        const gs = doc.gene_structure;
        if (!loc || !gs) continue;
        if (typeof loc.region !== "string" || loc.region === "" || typeof loc.start !== "number" || typeof loc.end !== "number" || loc.end < loc.start) continue;
        const strand = loc.strand === -1 ? -1 : 1;
        const exonsById = /* @__PURE__ */ new Map();
        for (const e of gs.exons ?? [])if (typeof e.id === "string" && typeof e.start === "number" && typeof e.end === "number" && e.end >= e.start) exonsById.set(e.id, e);
        if (exonsById.size === 0) continue;
        const transcripts = [];
        for (const t of gs.transcripts ?? []){
            if (!Array.isArray(t.exons) || t.exons.length === 0) continue;
            const orderedRel = [];
            for (const eid of t.exons){
                const rel = exonsById.get(eid);
                if (rel) orderedRel.push(rel);
            }
            if (orderedRel.length === 0) continue;
            const cdsCs = t.cds?.start;
            const cdsCe = t.cds?.end;
            const useCds = typeof cdsCs === "number" && typeof cdsCe === "number" && cdsCe >= cdsCs;
            const exonsOut = [];
            let cdnaCursor = 0;
            for (const rel of orderedRel){
                const exonLen = rel.end - rel.start + 1;
                const exonCdnaStart = cdnaCursor + 1;
                const exonCdnaEnd = cdnaCursor + exonLen;
                let gStart;
                let gEnd;
                if (strand === 1) {
                    gStart = loc.start + rel.start - 1;
                    gEnd = loc.start + rel.end - 1;
                } else {
                    gStart = loc.end - rel.end + 1;
                    gEnd = loc.end - rel.start + 1;
                }
                let cdsStart;
                let cdsEnd;
                if (useCds) {
                    const ovS = Math.max(exonCdnaStart, cdsCs);
                    const ovE = Math.min(exonCdnaEnd, cdsCe);
                    if (ovE >= ovS) {
                        const localStart = ovS - exonCdnaStart;
                        const localEnd = ovE - exonCdnaStart;
                        if (strand === 1) {
                            cdsStart = gStart + localStart;
                            cdsEnd = gStart + localEnd;
                        } else {
                            cdsStart = gEnd - localEnd;
                            cdsEnd = gEnd - localStart;
                        }
                    }
                }
                exonsOut.push({
                    start: gStart,
                    end: gEnd,
                    ...cdsStart !== void 0 ? {
                        cdsStart
                    } : {},
                    ...cdsEnd !== void 0 ? {
                        cdsEnd
                    } : {}
                });
                cdnaCursor = exonCdnaEnd;
            }
            exonsOut.sort((a, b)=>a.start - b.start);
            const tid = t.translation?.id && t.translation.id !== "" ? t.translation.id : `${doc._id}_t${transcripts.length + 1}`;
            const biotype = useCds ? "protein_coding" : t.biotype;
            transcripts.push({
                id: tid,
                ...biotype !== void 0 ? {
                    biotype
                } : {},
                exons: exonsOut
            });
        }
        if (transcripts.length === 0) continue;
        let canonical = transcripts[0];
        if (typeof doc.canonical_transcript === "string") {
            const named = transcripts.find((tr)=>tr.id === doc.canonical_transcript);
            if (named) canonical = named;
        } else {
            let bestCds = -1;
            let bestExonLen = -1;
            for (const tr of transcripts){
                let cdsLen = 0;
                let exonLen = 0;
                for (const e of tr.exons){
                    if (e.cdsStart !== void 0 && e.cdsEnd !== void 0) cdsLen += e.cdsEnd - e.cdsStart + 1;
                    exonLen += e.end - e.start + 1;
                }
                if (cdsLen > bestCds || cdsLen === bestCds && exonLen > bestExonLen) {
                    bestCds = cdsLen;
                    bestExonLen = exonLen;
                    canonical = tr;
                }
            }
        }
        canonical.isCanonical = true;
        out[doc._id] = {
            region: loc.region,
            strand,
            start: loc.start,
            end: loc.end,
            canonicalTranscriptId: canonical.id,
            transcripts,
            ...typeof doc.name === "string" && doc.name !== "" ? {
                name: doc.name
            } : {}
        };
    }
    return out;
}
// src/adapters/brapi.ts
function fromBrAPIAlleleMatrix(raw, opts = {}) {
    const result = raw?.result ?? raw;
    if (!result || typeof result !== "object") throw new Error("BrAPI: response has no `result` object");
    const r = result;
    const sampleIds = expectStringArray(r.callSetDbIds, "callSetDbIds");
    const variantIds = expectStringArray(r.variantDbIds, "variantDbIds");
    const dataMatrices = r.dataMatrices;
    if (!Array.isArray(dataMatrices) || dataMatrices.length === 0) throw new Error("BrAPI: no `dataMatrices` in response");
    const firstMatrix = dataMatrices.find((m)=>typeof m.dataMatrixName === "string" && /genotype/i.test(m.dataMatrixName)) ?? dataMatrices[0];
    const cells = firstMatrix.dataMatrix;
    if (!Array.isArray(cells)) throw new Error("BrAPI: `dataMatrix` is missing or not an array");
    if (cells.length !== variantIds.length) throw new Error(`BrAPI: dataMatrix row count (${cells.length}) doesn't match variantDbIds (${variantIds.length})`);
    const callsByGeneId = {};
    for(let s = 0; s < sampleIds.length; s++)callsByGeneId[sampleIds[s]] = new Array(variantIds.length);
    for(let v = 0; v < variantIds.length; v++){
        const row = cells[v];
        if (!Array.isArray(row)) throw new Error(`BrAPI: dataMatrix[${v}] is not an array`);
        if (row.length !== sampleIds.length) throw new Error(`BrAPI: dataMatrix[${v}] has ${row.length} cells but expected ${sampleIds.length}`);
        for(let s = 0; s < sampleIds.length; s++)callsByGeneId[sampleIds[s]][v] = String(row[s] ?? "");
    }
    const variants = variantIds.map((id)=>parseVariantId(id));
    let newick;
    let treeMethod;
    let treeMetric;
    let leafOrder;
    const tree = r.tree;
    if (tree && typeof tree === "object") {
        const t = tree;
        if (typeof t.newick === "string") newick = t.newick;
        if (typeof t.method === "string") treeMethod = t.method;
        if (typeof t.metric === "string") treeMetric = t.metric;
        if (Array.isArray(t.leafOrder)) leafOrder = t.leafOrder.map(String);
    }
    const variantSetDbIds = Array.isArray(r.variantSetDbIds) ? r.variantSetDbIds.map(String) : [];
    const pagination = Array.isArray(r.pagination) ? r.pagination.flatMap((p)=>{
        if (!p || typeof p !== "object") return [];
        const q = p;
        const n = (v)=>typeof v === "number" && Number.isFinite(v) ? v : 0;
        return [
            {
                dimension: typeof q.dimension === "string" ? q.dimension : "",
                page: n(q.page),
                pageSize: n(q.pageSize),
                totalCount: n(q.totalCount),
                totalPages: n(q.totalPages)
            }
        ];
    }) : void 0;
    let regionLabel = opts.regionLabel;
    if (!regionLabel && variants.length > 0) {
        const first = variants[0];
        const last = variants[variants.length - 1];
        if (first.reference && first.reference === last.reference && first.position !== void 0 && last.position !== void 0) regionLabel = `${first.reference}:${first.position.toLocaleString()}\u2013${last.position.toLocaleString()}`;
    }
    const matrix = {
        variants,
        callsByGeneId,
        ...typeof r.sepPhased === "string" ? {
            sepPhased: r.sepPhased
        } : {},
        ...typeof r.sepUnphased === "string" ? {
            sepUnphased: r.sepUnphased
        } : {},
        ...typeof r.unknownString === "string" ? {
            unknownString: r.unknownString
        } : {},
        ...regionLabel !== void 0 ? {
            regionLabel
        } : {}
    };
    return {
        matrix,
        sampleIds,
        ...variantSetDbIds[0] !== void 0 ? {
            variantSetDbId: variantSetDbIds[0]
        } : {},
        ...newick !== void 0 ? {
            newick
        } : {},
        ...treeMethod !== void 0 ? {
            treeMethod
        } : {},
        ...treeMetric !== void 0 ? {
            treeMetric
        } : {},
        ...leafOrder !== void 0 ? {
            leafOrder
        } : {},
        ...pagination !== void 0 ? {
            pagination
        } : {}
    };
}
function parseVariantId(id) {
    const m = id.match(/^([^:]+):(\d+)$/);
    if (!m) return {
        id
    };
    return {
        id,
        reference: m[1],
        position: Number(m[2])
    };
}
function fromBrAPIGermplasm(raw) {
    const result = raw?.result ?? raw;
    if (!result || typeof result !== "object") return {};
    const data = result.data ?? result;
    if (!Array.isArray(data)) return {};
    const STANDARD_KEYS = /* @__PURE__ */ new Set([
        "germplasmDbId",
        "germplasmName",
        "accessionNumber",
        "defaultDisplayName",
        "commonCropName",
        "genus",
        "species",
        "subtaxa",
        "countryOfOriginCode",
        "pedigree",
        "synonyms",
        "extras"
    ]);
    const out = {};
    for (const entry of data){
        if (!entry || typeof entry !== "object") continue;
        const r = entry;
        const g = {};
        for (const key of [
            "germplasmDbId",
            "germplasmName",
            "accessionNumber",
            "defaultDisplayName",
            "commonCropName",
            "genus",
            "species",
            "subtaxa",
            "countryOfOriginCode",
            "pedigree"
        ]){
            const v = r[key];
            if (typeof v === "string") g[key] = v;
        }
        if (Array.isArray(r.synonyms)) g.synonyms = r.synonyms.filter((x)=>typeof x === "string");
        const extras = {};
        if (r.extras && typeof r.extras === "object") Object.assign(extras, r.extras);
        for (const k of Object.keys(r))if (!STANDARD_KEYS.has(k)) extras[k] = r[k];
        if (Object.keys(extras).length > 0) g.extras = extras;
        if (g.germplasmDbId) out[g.germplasmDbId] = g;
        if (g.germplasmName) out[g.germplasmName] = g;
    }
    return out;
}
function expectStringArray(value, name) {
    if (!Array.isArray(value)) throw new Error(`BrAPI: \`${name}\` is missing or not an array`);
    return value.map(String);
}
function fromBrAPIVariants(raw, opts = {}) {
    const result = raw?.result ?? raw;
    const data = result && typeof result === "object" && !Array.isArray(result) ? result.data : result;
    if (!Array.isArray(data)) return [];
    const seen = /* @__PURE__ */ new Set();
    const seenIds = /* @__PURE__ */ new Set();
    const out = [];
    for (const rec of data){
        if (!rec || typeof rec !== "object") continue;
        const row = rec;
        if (typeof row.variantDbId === "string" && row.variantDbId !== "") {
            const id = row.variantDbId;
            if (seenIds.has(id)) continue;
            seenIds.add(id);
            const start = row.start;
            const alt2 = Array.isArray(row.alternateBases) ? row.alternateBases.filter((a)=>typeof a === "string") : void 0;
            const reference = typeof row.referenceName === "string" && row.referenceName !== "" ? row.referenceName : opts.reference;
            out.push({
                id,
                ...reference !== void 0 ? {
                    reference
                } : {},
                ...typeof start === "number" && Number.isFinite(start) ? {
                    position: start
                } : {},
                ...typeof row.referenceBases === "string" && row.referenceBases !== "" ? {
                    ref: row.referenceBases
                } : {},
                ...alt2 !== void 0 ? {
                    alt: alt2
                } : {}
            });
            continue;
        }
        const pos = row.pos;
        if (typeof pos !== "number" || !Number.isFinite(pos)) continue;
        if (seen.has(pos)) continue;
        seen.add(pos);
        const alt = Array.isArray(row.alleles) ? row.alleles.slice(1).filter((a)=>typeof a === "string") : [];
        const site = {
            id: `${opts.reference ?? ""}:${pos}`,
            position: pos,
            alt,
            ...opts.reference !== void 0 ? {
                reference: opts.reference
            } : {},
            ...typeof row.ref === "string" ? {
                ref: row.ref
            } : {}
        };
        out.push(site);
    }
    return out;
}
function mergeVariantSites(matrix, sites) {
    const byPos = /* @__PURE__ */ new Map();
    const byId = /* @__PURE__ */ new Map();
    for (const s of sites){
        if (s.position !== void 0 && !byPos.has(s.position)) byPos.set(s.position, s);
        if (!byId.has(s.id)) byId.set(s.id, s);
    }
    let changed = false;
    const variants = matrix.variants.map((v)=>{
        const hit = (v.position !== void 0 ? byPos.get(v.position) : void 0) ?? byId.get(v.id);
        if (!hit) return v;
        changed = true;
        return {
            ...v,
            ...hit.ref !== void 0 ? {
                ref: hit.ref
            } : {},
            ...hit.alt !== void 0 ? {
                alt: hit.alt
            } : {},
            ...hit.alleleFrequency !== void 0 ? {
                alleleFrequency: hit.alleleFrequency
            } : {}
        };
    });
    return changed ? {
        ...matrix,
        variants
    } : matrix;
}
function fromBrAPITree(r, opts = {}) {
    if (r.newick === void 0 || r.newick.trim() === "") return null;
    const { tree } = (0, _chunk27AE42SIJs.parseNewick)(r.newick, {
        ...opts,
        labelsAsIds: false,
        leafGeneId: true
    });
    if (!r.leafOrder || r.leafOrder.length === 0) return {
        tree,
        swappedNodeIds: [],
        unmatched: []
    };
    const { swappedNodeIds, unmatched } = (0, _chunkF6Q2MMZHJs.swapsForLeafOrder)(tree, r.leafOrder, (leaf)=>leaf.geneId ?? leaf.id);
    return {
        tree,
        swappedNodeIds,
        unmatched
    };
}
// src/sources/loader.ts
var IDLE = Object.freeze({
    status: "idle",
    value: void 0,
    error: null,
    progress: null,
    itemErrors: null
});
var errorMessage = (err)=>err instanceof Error ? err.message : String(err);
function shallowEqualRecord(a, b) {
    const ka = Object.keys(a);
    const kb = Object.keys(b);
    if (ka.length !== kb.length) return false;
    for (const k of ka){
        if (!(k in b) || a[k] !== b[k]) return false;
    }
    return true;
}
var sameProgress = (a, b)=>a !== null && a.done === b.done && a.total === b.total && a.failed === b.failed;
function raceAbort(promise, signal) {
    if (signal.aborted) {
        promise.catch(()=>void 0);
        return Promise.reject(new Error("aborted"));
    }
    return new Promise((resolve, reject)=>{
        const onAbort = ()=>reject(new Error("aborted"));
        signal.addEventListener("abort", onAbort, {
            once: true
        });
        promise.then((v)=>{
            signal.removeEventListener("abort", onAbort);
            resolve(v);
        }, (e)=>{
            signal.removeEventListener("abort", onAbort);
            reject(e);
        });
    });
}
function mergeHostData(base, patch, opts = {}) {
    const warn = opts.warnOnOverwrite === true || opts.onOverwrite !== void 0;
    const report = opts.onOverwrite ?? ((key)=>{
        console.warn(`tbrowse-core: host data "${key}" overwritten by a later patch`);
    });
    const out = {
        ...base
    };
    const baseRec = base;
    const patchRec = patch;
    for (const key of Object.keys(patchRec)){
        const value = patchRec[key];
        if (value === void 0) continue;
        if (key === "hostData" && isRecord(value) && isRecord(baseRec["hostData"])) {
            const baseInner = baseRec["hostData"];
            const merged = {
                ...baseInner
            };
            for (const inner of Object.keys(value)){
                const v = value[inner];
                if (v === void 0) continue;
                if (warn && baseInner[inner] !== void 0) report(`hostData.${inner}`);
                merged[inner] = v;
            }
            out["hostData"] = merged;
            continue;
        }
        if (warn && baseRec[key] !== void 0) report(key);
        out[key] = value;
    }
    return out;
}
function isRecord(v) {
    return typeof v === "object" && v !== null && !Array.isArray(v);
}
function zoneStatusOf(slots, zoneSlots) {
    const out = {};
    for (const zoneId of Object.keys(zoneSlots)){
        const ids = zoneSlots[zoneId] ?? [];
        let status;
        for (const id of ids){
            const s = slots[id];
            if (!s || s.status === "idle") continue;
            if (s.status === "loading") {
                status = "loading";
                break;
            }
            if (s.status === "error") status = "error";
            else if (status === void 0) status = "ready";
        }
        if (status !== void 0) out[zoneId] = status;
    }
    return out;
}
function hostPropsFrom(s) {
    if (!s.tree) return null;
    const out = {
        tree: s.tree
    };
    if (s.root?.taxonomy !== void 0) out["taxonomy"] = s.root.taxonomy;
    if (s.root?.nodeOfInterest !== void 0) out["nodeOfInterest"] = s.root.nodeOfInterest;
    out["zoneStatus"] = s.zoneStatus;
    const data = s.data;
    for (const key of Object.keys(data)){
        const v = data[key];
        if (v !== void 0) out[key] = v;
    }
    return out;
}
function createLoader(source, options = {}) {
    const fetch = (0, _chunkLPNPUTTSJs.withRetry)(options.fetch ?? (0, _chunkLPNPUTTSJs.defaultFetch), options.retry);
    const zoneSlots = options.zoneSlots ?? {};
    const warnOnOverwrite = options.warnOnOverwrite === true;
    const slotById = /* @__PURE__ */ new Map();
    for (const slot of source.slots)slotById.set(slot.id, slot);
    const idleSlots = ()=>{
        const out = {};
        for (const slot of source.slots)out[slot.id] = IDLE;
        return out;
    };
    let snapshot = {
        status: "idle",
        error: null,
        tree: null,
        root: null,
        data: {},
        slots: idleSlots(),
        zoneStatus: {},
        pivot: null,
        generation: 0
    };
    const listeners = /* @__PURE__ */ new Set();
    let epoch = 0;
    let controller = null;
    let ctxCurrent;
    const warned = /* @__PURE__ */ new Set();
    let root = null;
    const patches = /* @__PURE__ */ new Map();
    const signalFor = ()=>{
        if (!controller || controller.signal.aborted) controller = new AbortController();
        return controller.signal;
    };
    const commit = (next)=>{
        let changed = false;
        for (const key of Object.keys(next))if (snapshot[key] !== next[key]) {
            changed = true;
            break;
        }
        if (!changed) return;
        snapshot = {
            ...snapshot,
            ...next
        };
        for (const listener of [
            ...listeners
        ])listener();
    };
    const keepZoneStatus = (next)=>shallowEqualRecord(snapshot.zoneStatus, next) ? snapshot.zoneStatus : next;
    const recomputeData = ()=>{
        let data = {
            ...root?.data ?? {}
        };
        for (const slot of source.slots){
            const patch = patches.get(slot.id);
            if (!patch) continue;
            data = warnOnOverwrite ? mergeHostData(data, patch, {
                onOverwrite: (key)=>{
                    const tag = `${slot.id}:${key}`;
                    if (warned.has(tag)) return;
                    warned.add(tag);
                    console.warn(`tbrowse-core: host data "${key}" overwritten by a later patch`);
                }
            }) : mergeHostData(data, patch);
        }
        return shallowEqualRecord(snapshot.data, data) ? snapshot.data : data;
    };
    const setSlot = (id, state, extra = {})=>{
        const slots = {
            ...snapshot.slots,
            [id]: state
        };
        commit({
            ...extra,
            slots,
            zoneStatus: keepZoneStatus(zoneStatusOf(slots, zoneSlots))
        });
    };
    const runSlot = async (slot, myEpoch)=>{
        const currentRoot = root;
        if (!currentRoot) return;
        const id = slot.id;
        patches.delete(id);
        setSlot(id, {
            ...IDLE,
            status: "loading"
        }, {
            data: recomputeData()
        });
        const onProgress = (p)=>{
            if (myEpoch !== epoch) return;
            const cur = snapshot.slots[id];
            if (!cur || cur.status !== "loading" || sameProgress(cur.progress, p)) return;
            setSlot(id, {
                ...cur,
                progress: {
                    done: p.done,
                    total: p.total,
                    failed: p.failed
                }
            });
        };
        const signal = signalFor();
        let value;
        try {
            value = await raceAbort(slot.run({
                ctx: ctxCurrent,
                fetch,
                signal,
                tree: currentRoot.tree,
                root: currentRoot,
                onProgress,
                ...options.concurrency !== void 0 ? {
                    concurrency: options.concurrency
                } : {}
            }), signal);
        } catch (err) {
            if (myEpoch !== epoch) return;
            setSlot(id, {
                ...IDLE,
                status: "error",
                error: errorMessage(err)
            });
            return;
        }
        if (myEpoch !== epoch) return;
        try {
            const rawItemErrors = slot.itemErrorsOf?.(value) ?? null;
            const itemErrors = rawItemErrors && Object.keys(rawItemErrors).length > 0 ? rawItemErrors : null;
            const failure = slot.failWhen?.(value, itemErrors) ?? null;
            if (failure !== null) {
                setSlot(id, {
                    status: "error",
                    value,
                    error: failure,
                    progress: null,
                    itemErrors
                });
                return;
            }
            const extra = {};
            if (slot.patchMeta && root) {
                const meta = slot.patchMeta(value, root.meta, root);
                if (meta !== root.meta) {
                    root = {
                        ...root,
                        meta
                    };
                    extra.root = root;
                }
            }
            patches.set(id, slot.toHostData(value, root ?? currentRoot));
            extra.data = recomputeData();
            setSlot(id, {
                status: "ready",
                value,
                error: null,
                progress: null,
                itemErrors
            }, extra);
        } catch (err) {
            if (myEpoch !== epoch) return;
            patches.delete(id);
            setSlot(id, {
                ...IDLE,
                status: "error",
                error: errorMessage(err)
            }, {
                data: recomputeData()
            });
        }
    };
    const abortInFlight = (reason)=>{
        epoch++;
        if (controller) {
            controller.abort();
            controller = null;
        }
        let slots = null;
        for (const id of Object.keys(snapshot.slots)){
            const s = snapshot.slots[id];
            if (!s || s.status !== "loading") continue;
            slots ?? (slots = {
                ...snapshot.slots
            });
            slots[id] = {
                ...IDLE,
                status: "error",
                error: reason
            };
        }
        const extra = snapshot.status === "loading" ? {
            status: "error",
            error: reason
        } : {};
        if (slots) commit({
            ...extra,
            slots,
            zoneStatus: keepZoneStatus(zoneStatusOf(slots, zoneSlots))
        });
        else commit(extra);
    };
    const loader = {
        source,
        getSnapshot: ()=>snapshot,
        subscribe (listener) {
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        },
        async start (ctx) {
            abortInFlight("aborted");
            const myEpoch = epoch;
            ctxCurrent = ctx;
            root = null;
            patches.clear();
            const signal = signalFor();
            commit({
                status: "loading",
                error: null,
                tree: null,
                root: null,
                data: {},
                slots: idleSlots(),
                zoneStatus: {},
                pivot: null,
                generation: snapshot.generation + 1
            });
            let result;
            try {
                result = await raceAbort(source.loadRoot({
                    ctx,
                    fetch,
                    signal
                }), signal);
            } catch (err) {
                if (myEpoch === epoch) commit({
                    status: "error",
                    error: errorMessage(err)
                });
                return snapshot;
            }
            if (myEpoch !== epoch) return snapshot;
            root = result;
            const pivot = result.nodeOfInterest !== void 0 ? (0, _chunkF6Q2MMZHJs.computePivotState)(result.tree, result.nodeOfInterest) : null;
            commit({
                status: "ready",
                error: null,
                tree: result.tree,
                root: result,
                data: recomputeData(),
                pivot
            });
            const eager = [];
            for (const slot of source.slots){
                if (slot.mode === "lazy") continue;
                try {
                    if (slot.enabled?.(ctx, result) === false) continue;
                    eager.push(slot);
                } catch (err) {
                    setSlot(slot.id, {
                        ...IDLE,
                        status: "error",
                        error: errorMessage(err)
                    });
                }
            }
            await Promise.all(eager.map((slot)=>runSlot(slot, myEpoch)));
            return snapshot;
        },
        async load (slotId) {
            const slot = slotById.get(slotId);
            if (!slot) throw new Error(`tbrowse-core: unknown slot "${slotId}" on source "${source.id}"`);
            if (!root) throw new Error(`tbrowse-core: load("${slotId}") called before the root loaded`);
            if (snapshot.slots[slotId]?.status === "loading") return;
            await runSlot(slot, epoch);
        },
        abort () {
            abortInFlight("aborted");
        },
        dispose () {
            listeners.clear();
            abortInFlight("aborted");
        }
    };
    return loader;
}
// src/sources/extend.ts
function defineSlot(slot) {
    return slot;
}
function extendSource(source, patch) {
    const without = new Set(patch.without ?? []);
    const slots = source.slots.filter((s)=>!without.has(s.id));
    for (const slot of patch.slots ?? []){
        const at = slots.findIndex((s)=>s.id === slot.id);
        if (at >= 0) slots[at] = slot;
        else slots.push(slot);
    }
    return {
        id: patch.id ?? source.id,
        ...source.label !== void 0 ? {
            label: source.label
        } : {},
        loadRoot: (rc)=>source.loadRoot(rc),
        slots
    };
}
function staticSource(rootOf, slots = []) {
    return {
        id: "static",
        loadRoot: async ({ ctx })=>rootOf(ctx),
        slots
    };
}
// src/sources/ensembl.ts
var ENSEMBL_MIRRORS = [
    {
        host: "rest.ensembl.org",
        release: 116,
        route: "species"
    },
    // sep2025 takes the archive overflow traffic and measures several
    // times slower than its neighbours; prefer a lower release if the
    // per-leaf fan-outs feel sluggish.
    {
        host: "sep2025.rest.ensembl.org",
        release: 115,
        route: "species"
    },
    {
        host: "may2025.rest.ensembl.org",
        release: 114,
        route: "species"
    },
    {
        host: "oct2024.rest.ensembl.org",
        release: 113,
        route: "species"
    },
    {
        host: "may2024.rest.ensembl.org",
        release: 112,
        route: "species"
    },
    {
        host: "jan2024.rest.ensembl.org",
        release: 111,
        route: "species"
    },
    {
        host: "jul2023.rest.ensembl.org",
        release: 110,
        route: "species"
    },
    {
        host: "feb2023.rest.ensembl.org",
        release: 109,
        route: "bare"
    },
    {
        host: "oct2022.rest.ensembl.org",
        release: 108,
        route: "bare"
    },
    {
        host: "jul2022.rest.ensembl.org",
        release: 107,
        route: "bare"
    },
    {
        host: "dec2021.rest.ensembl.org",
        release: 105,
        route: "bare"
    }
];
var ENSEMBL_DEFAULT_MIRROR = "rest.ensembl.org";
function mirrorFor(host, release) {
    const known = ENSEMBL_MIRRORS.find((m)=>m.host === host);
    if (known) return known;
    const rel = release ?? ENSEMBL_MIRRORS[0]?.release ?? 112;
    return {
        host,
        release: rel,
        route: rel >= 110 ? "species" : "bare"
    };
}
function ensemblGeneTreeUrl(geneId, opts = {}) {
    const m = mirrorFor(opts.host ?? ENSEMBL_DEFAULT_MIRROR);
    const species = opts.species ?? "homo_sapiens";
    const member = m.route === "species" ? `${species}/${encodeURIComponent(geneId)}` : encodeURIComponent(geneId);
    const params = [
        `aligned=${opts.aligned === false ? 0 : 1}`,
        `sequence=${opts.sequence ?? "protein"}`
    ];
    return `https://${m.host}/genetree/member/id/${member}?${params.join("&")}`;
}
async function fetchEnsemblGeneTree(geneId, opts = {}) {
    const host = opts.host ?? ENSEMBL_DEFAULT_MIRROR;
    const url = ensemblGeneTreeUrl(geneId, {
        host,
        ...opts.species !== void 0 ? {
            species: opts.species
        } : {}
    });
    let json;
    try {
        json = await (0, _chunkLPNPUTTSJs.getJson)(url, {
            ...opts.fetch !== void 0 ? {
                fetch: opts.fetch
            } : {},
            ...opts.signal !== void 0 ? {
                signal: opts.signal
            } : {}
        });
    } catch (err) {
        if (err instanceof (0, _chunkLPNPUTTSJs.HttpError)) {
            const m = mirrorFor(host);
            throw new Error(err.status === 404 ? `HTTP 404 from ${m.host} (release ${m.release}) \u2014 no gene tree for ${geneId}` : `HTTP ${err.status} from ${m.host}`);
        }
        throw err;
    }
    return fromEnsemblGeneTree(json, {
        ...opts.alphabet !== void 0 ? {
            alphabet: opts.alphabet
        } : {}
    });
}
var ENSEMBL_DEFAULT_DOMAIN_SOURCES = [
    "Pfam",
    "Smart"
];
function fetchEnsemblProteinDomains(proteinIdByGeneId, opts = {}) {
    const host = opts.host ?? ENSEMBL_DEFAULT_MIRROR;
    const sources = opts.sources ?? ENSEMBL_DEFAULT_DOMAIN_SOURCES;
    const keys = Object.keys(proteinIdByGeneId);
    return (0, _chunkLPNPUTTSJs.fanOut)(keys, async (geneId, signal)=>{
        const ensp = proteinIdByGeneId[geneId];
        const url = `https://${host}/overlap/translation/${encodeURIComponent(ensp)}?feature=protein_feature`;
        const json = await (0, _chunkLPNPUTTSJs.getJson)(url, {
            ...opts.fetch !== void 0 ? {
                fetch: opts.fetch
            } : {},
            signal
        });
        return fromEnsemblProteinFeatures(json, {
            sources
        });
    }, {
        ...opts.concurrency !== void 0 ? {
            concurrency: opts.concurrency
        } : {},
        ...opts.signal !== void 0 ? {
            signal: opts.signal
        } : {},
        ...opts.onProgress !== void 0 ? {
            onProgress: opts.onProgress
        } : {}
    });
}
var OVERLAP_FEATURES = "feature=transcript;feature=exon;feature=cds;feature=regulatory;feature=motif";
async function fetchEnsemblOverlap(geneIds, opts = {}) {
    const host = opts.host ?? ENSEMBL_DEFAULT_MIRROR;
    const r = await (0, _chunkLPNPUTTSJs.fanOut)(geneIds, async (geneId, signal)=>{
        const url = `https://${host}/overlap/id/${encodeURIComponent(geneId)}?${OVERLAP_FEATURES}`;
        const json = await (0, _chunkLPNPUTTSJs.getJson)(url, {
            ...opts.fetch !== void 0 ? {
                fetch: opts.fetch
            } : {},
            signal
        });
        return {
            structure: fromEnsemblGeneStructure(json, geneId),
            features: fromEnsemblGenomeFeatures(json)
        };
    }, {
        ...opts.concurrency !== void 0 ? {
            concurrency: opts.concurrency
        } : {},
        ...opts.signal !== void 0 ? {
            signal: opts.signal
        } : {},
        ...opts.onProgress !== void 0 ? {
            onProgress: opts.onProgress
        } : {}
    });
    const geneStructures = {};
    const genomeFeatures = {};
    const geneStructureErrors = {
        ...r.errors
    };
    for (const geneId of geneIds){
        const hit = r.results[geneId];
        if (!hit) continue;
        if (hit.structure) geneStructures[geneId] = hit.structure;
        else geneStructureErrors[geneId] = "no gene structure in response";
        if (hit.features.length > 0) genomeFeatures[geneId] = hit.features;
    }
    return {
        geneStructures,
        genomeFeatures,
        geneStructureErrors
    };
}
var proteinDomainsSlot = {
    id: "proteinDomains",
    mode: "lazy",
    async run ({ ctx, fetch, signal, root, onProgress, concurrency }) {
        const map = root.meta.proteinIdByGeneId;
        if (Object.keys(map).length === 0) throw new Error("No protein ids on this tree");
        return fetchEnsemblProteinDomains(map, {
            host: root.meta.mirror.host,
            ...ctx.domainSources !== void 0 ? {
                sources: ctx.domainSources
            } : {},
            ...concurrency !== void 0 ? {
                concurrency
            } : {},
            fetch,
            signal,
            onProgress
        });
    },
    toHostData: (v)=>({
            proteinDomains: v.results
        }),
    itemErrorsOf: (v)=>Object.keys(v.errors).length > 0 ? v.errors : null,
    failWhen: (v)=>Object.keys(v.results).length === 0 ? `All ${v.progress.total} domain requests failed (${v.lastError})` : null
};
var overlapSlot = {
    id: "overlap",
    mode: "lazy",
    async run ({ fetch, signal, tree, root, onProgress, concurrency }) {
        const leaves = (0, _chunkF6Q2MMZHJs.leafGeneIds)(tree);
        if (leaves.length === 0) throw new Error("No leaves on this tree");
        return fetchEnsemblOverlap(leaves, {
            host: root.meta.mirror.host,
            ...concurrency !== void 0 ? {
                concurrency
            } : {},
            fetch,
            signal,
            onProgress
        });
    },
    toHostData: (v)=>{
        const patch = {
            geneStructures: v.geneStructures
        };
        if (Object.keys(v.genomeFeatures).length > 0) patch.genomeFeatures = v.genomeFeatures;
        if (Object.keys(v.geneStructureErrors).length > 0) patch.geneStructureErrors = v.geneStructureErrors;
        return patch;
    }
};
var ensemblGeneTreeSource = {
    id: "ensembl-genetree",
    label: "Ensembl gene tree",
    async loadRoot ({ ctx, fetch, signal }) {
        const geneId = ctx.geneId.trim();
        const host = ctx.host ?? ENSEMBL_DEFAULT_MIRROR;
        const r = await fetchEnsemblGeneTree(geneId, {
            host,
            ...ctx.species !== void 0 ? {
                species: ctx.species
            } : {},
            fetch,
            signal
        });
        const data = {
            geneMetadata: r.geneMetadata
        };
        if (r.msa !== void 0) data.msa = r.msa;
        return {
            tree: r.tree,
            taxonomy: r.taxonomy,
            nodeOfInterest: geneId,
            data,
            meta: {
                proteinIdByGeneId: r.proteinIdByGeneId,
                mirror: mirrorFor(host)
            }
        };
    },
    slots: [
        proteinDomainsSlot,
        overlapSlot
    ]
};
// src/sources/gramene.ts
var GRAMENE_DEFAULT_BASE = "https://data.gramene.org/v69";
var transport = (opts)=>({
        ...opts.fetch !== void 0 ? {
            fetch: opts.fetch
        } : {},
        ...opts.signal !== void 0 ? {
            signal: opts.signal
        } : {}
    });
var NEIGHBORHOOD_FL = "id,name,gene_tree,gene_idx,region,start,end,strand,biotype,system_name,description";
function grameneNeighborhoodQuery(treeId, treeField = GRAMENE_DEFAULT_TREE_FIELD) {
    return {
        fl: treeField === GRAMENE_DEFAULT_TREE_FIELD ? NEIGHBORHOOD_FL : `${NEIGHBORHOOD_FL},${treeField}`,
        fq: `{!graph from=compara_neighbors_10 to=compara_idx_multi maxDepth=1 cache=false}${treeField}:${treeId}`,
        rows: "100000",
        start: "0"
    };
}
async function fetchGrameneGene(base, geneId, opts = {}) {
    const json = await (0, _chunkLPNPUTTSJs.getJson)((0, _chunkLPNPUTTSJs.buildUrl)(base, "/genes", {
        idList: geneId
    }), transport(opts));
    return fromGrameneGene(json);
}
async function fetchGrameneGenetree(base, treeId, opts = {}) {
    const json = await (0, _chunkLPNPUTTSJs.getJson)((0, _chunkLPNPUTTSJs.buildUrl)(base, "/genetrees", {
        idList: treeId
    }), transport(opts));
    return fromGrameneGenetree(json, {
        ...opts.alphabet !== void 0 ? {
            alphabet: opts.alphabet
        } : {}
    });
}
async function fetchGrameneNeighborhood(base, treeId, opts = {}) {
    const treeField = opts.treeField ?? GRAMENE_DEFAULT_TREE_FIELD;
    const json = await (0, _chunkLPNPUTTSJs.getJson)((0, _chunkLPNPUTTSJs.buildUrl)(base, "/search", grameneNeighborhoodQuery(treeId, treeField)), transport(opts));
    return fromGrameneNeighborhood(json, {
        treeField
    });
}
var GRAMENE_GENE_STRUCTURE_FL = "_id,name,location,gene_structure,canonical_transcript";
function fetchGrameneGeneStructures(base, geneIds, opts = {}) {
    const chunkSize = opts.chunkSize ?? 200;
    const fl = opts.fl === void 0 ? GRAMENE_GENE_STRUCTURE_FL : opts.fl;
    return (0, _chunkLPNPUTTSJs.fanOutChunks)(geneIds, chunkSize, async (ids, signal)=>{
        const url = (0, _chunkLPNPUTTSJs.buildUrl)(base, "/genes", {
            idList: ids.join(","),
            rows: -1,
            ...fl !== null ? {
                fl
            } : {}
        });
        const json = await (0, _chunkLPNPUTTSJs.getJson)(url, {
            ...opts.fetch !== void 0 ? {
                fetch: opts.fetch
            } : {},
            signal
        });
        return fromGrameneGeneStructures(Array.isArray(json) ? json : []);
    }, {
        ...opts.signal !== void 0 ? {
            signal: opts.signal
        } : {},
        ...opts.onProgress !== void 0 ? {
            onProgress: opts.onProgress
        } : {}
    });
}
async function fetchGrameneSearchDocs(base, params, opts = {}) {
    const url = (0, _chunkLPNPUTTSJs.buildUrl)(base, "/search", {
        q: params.q ?? "*:*",
        fq: params.fq,
        fl: params.fl,
        ...params.rows !== void 0 ? {
            rows: params.rows
        } : {}
    });
    const json = await (0, _chunkLPNPUTTSJs.getJson)(url, transport(opts));
    const docs = json?.response?.docs;
    return Array.isArray(docs) ? docs : [];
}
function fetchGrameneExprAttrDocs(base, treeId, opts = {}) {
    return fetchGrameneSearchDocs(base, {
        q: "*:*",
        fq: [
            `${opts.treeField ?? GRAMENE_DEFAULT_TREE_FIELD}:${treeId}`,
            "capabilities:expression_attributes"
        ],
        fl: "id,expr_*__attr_*",
        rows: opts.rows ?? 1e4
    }, transport(opts));
}
function facetPairsToCounts(facet) {
    const out = {};
    if (!Array.isArray(facet)) return out;
    for(let i = 0; i < facet.length; i += 2){
        const key = facet[i];
        if (key === void 0) continue;
        const n = Number(facet[i + 1]);
        out[String(key)] = Number.isFinite(n) ? n : 0;
    }
    return out;
}
var neighborhoodSlot = {
    id: "neighborhood",
    mode: "eager",
    enabled: (ctx)=>ctx.neighborhood !== false,
    run: ({ ctx, fetch, signal, root })=>fetchGrameneNeighborhood(ctx.base ?? GRAMENE_DEFAULT_BASE, root.meta.treeId, {
            treeField: root.meta.treeField,
            fetch,
            signal
        }),
    toHostData: (v)=>({
            neighborhood: v
        })
};
var geneStructuresSlot = {
    id: "geneStructures",
    mode: "eager",
    enabled: (ctx)=>ctx.geneStructures !== false,
    run: ({ ctx, fetch, signal, tree, onProgress })=>fetchGrameneGeneStructures(ctx.base ?? GRAMENE_DEFAULT_BASE, (0, _chunkF6Q2MMZHJs.leafGeneIds)(tree), {
            ...ctx.geneStructureChunkSize !== void 0 ? {
                chunkSize: ctx.geneStructureChunkSize
            } : {},
            ...ctx.geneStructureFl !== void 0 ? {
                fl: ctx.geneStructureFl
            } : {},
            fetch,
            signal,
            onProgress
        }),
    toHostData: (v)=>({
            geneStructures: v.results
        }),
    itemErrorsOf: (v)=>Object.keys(v.errors).length > 0 ? v.errors : null,
    failWhen: (v)=>v.progress.total > 0 && v.progress.failed === v.progress.total ? `All ${v.progress.total} gene-structure requests failed (${v.lastError})` : null
};
var grameneGeneTreeSource = {
    id: "gramene-genetree",
    label: "Gramene gene tree",
    async loadRoot ({ ctx, fetch, signal }) {
        const base = ctx.base ?? GRAMENE_DEFAULT_BASE;
        let treeId = ctx.treeId;
        let gene;
        if (treeId === void 0) {
            if (ctx.geneId === void 0) throw new Error("grameneGeneTreeSource: ctx.geneId or ctx.treeId is required");
            gene = await fetchGrameneGene(base, ctx.geneId, {
                fetch,
                signal
            });
            if (!gene.geneTreeId) throw new Error(`Gene ${gene.geneId} has no gene tree assigned`);
            treeId = gene.geneTreeId;
        }
        const r = ctx.rawGenetree !== void 0 ? fromGrameneGenetree(Array.isArray(ctx.rawGenetree) ? ctx.rawGenetree : [
            ctx.rawGenetree
        ]) : await fetchGrameneGenetree(base, treeId, {
            fetch,
            signal
        });
        const data = {
            geneMetadata: r.geneMetadata,
            proteinDomains: r.proteinDomains,
            exonJunctions: r.exonJunctions
        };
        if (r.msa !== void 0) data.msa = r.msa;
        const treeField = r.treeField !== GRAMENE_DEFAULT_TREE_FIELD ? r.treeField : ctx.treeField ?? gene?.geneTreeField ?? GRAMENE_DEFAULT_TREE_FIELD;
        const meta = {
            treeId,
            treeField,
            proteinIdByGeneId: r.proteinIdByGeneId
        };
        if (gene !== void 0) meta.gene = gene;
        return {
            tree: r.tree,
            taxonomy: r.taxonomy,
            ...ctx.geneId !== void 0 ? {
                nodeOfInterest: ctx.geneId
            } : {},
            data,
            meta
        };
    },
    slots: [
        neighborhoodSlot,
        geneStructuresSlot
    ]
};
// src/sources/brapi.ts
var transport2 = (opts)=>({
        ...opts.fetch !== void 0 ? {
            fetch: opts.fetch
        } : {},
        ...opts.signal !== void 0 ? {
            signal: opts.signal
        } : {}
    });
async function* brapiPages(url, opts = {}) {
    const pageSize = opts.pageSize ?? 1e3;
    const maxPages = opts.maxPages ?? Infinity;
    for(let page = 0; page < maxPages; page++){
        const json = await (0, _chunkLPNPUTTSJs.getJson)((0, _chunkLPNPUTTSJs.buildUrl)(url, "", {
            pageSize,
            page
        }), transport2(opts));
        const body = json && typeof json === "object" ? json : {};
        const result = body.result && typeof body.result === "object" ? body.result : {};
        const data = Array.isArray(result.data) ? result.data : [];
        const metadata = body.metadata && typeof body.metadata === "object" ? body.metadata : {};
        const pagination = metadata.pagination && typeof metadata.pagination === "object" ? metadata.pagination : null;
        const num = (v, fallback)=>typeof v === "number" && Number.isFinite(v) ? v : fallback;
        const currentPage = num(pagination?.currentPage, page);
        const totalPages = num(pagination?.totalPages, 1);
        const totalCount = num(pagination?.totalCount, data.length);
        yield {
            data,
            currentPage,
            totalPages,
            totalCount
        };
        if (pagination === null || currentPage >= totalPages - 1) return;
    }
}
function brapiBaseOf(matrixUrl) {
    const { path } = (0, _chunkLPNPUTTSJs.splitUrl)(matrixUrl);
    const m = path.match(/^(.*\/brapi\/v\d+)(?:\/|$)/);
    if (m) return m[1];
    if (/\/allelematrix-search/.test(path)) return path.replace(/\/allelematrix-search.*$/, "");
    const noTrailing = path.replace(/\/+$/, "");
    const cut = noTrailing.lastIndexOf("/");
    return cut === -1 ? "" : noTrailing.slice(0, cut);
}
var STANDARD_VARIANTS_PARAMS = /* @__PURE__ */ new Set([
    "variantDbId",
    "variantSetDbId",
    "referenceDbId",
    "referenceSetDbId",
    "referenceName",
    "start",
    "end",
    "callSetDbId",
    "germplasmDbId",
    "germplasmName",
    "germplasmPUI",
    "studyDbId",
    "studyName",
    "externalReferenceId",
    "externalReferenceSource"
]);
var BRAPI_VARIANTS_PAGE_SIZE = 1e3;
function brapiVariantsUrlFrom(matrixUrl) {
    const { path, params } = (0, _chunkLPNPUTTSJs.splitUrl)(matrixUrl);
    let variantsPath;
    if (/\/allelematrix-search/.test(path)) {
        variantsPath = path.replace(/\/allelematrix-search.*$/, "/variants");
        params.delete("tree");
    } else {
        variantsPath = `${brapiBaseOf(matrixUrl)}/variants`;
        for (const key of [
            ...params.keys()
        ])if (!STANDARD_VARIANTS_PARAMS.has(key)) params.delete(key);
        params.set("pageSize", String(BRAPI_VARIANTS_PAGE_SIZE));
    }
    const qs = params.toString();
    return qs === "" ? variantsPath : `${variantsPath}?${qs}`;
}
var BRAPI_DIMENSION_PAGE_SIZE = 1e3;
function brapiMatrixUrlWithDefaults(matrixUrl) {
    const { path, params } = (0, _chunkLPNPUTTSJs.splitUrl)(matrixUrl);
    if (!/\/allelematrix\/?$/.test(path)) return matrixUrl;
    if (params.has("dimensionVariantPageSize") || params.has("dimensionCallSetPageSize")) return matrixUrl;
    params.set("dimensionVariantPageSize", String(BRAPI_DIMENSION_PAGE_SIZE));
    params.set("dimensionCallSetPageSize", String(BRAPI_DIMENSION_PAGE_SIZE));
    return `${path}?${params.toString()}`;
}
async function fetchBrapiAlleleMatrix(url, opts = {}) {
    const json = await (0, _chunkLPNPUTTSJs.getJson)(brapiMatrixUrlWithDefaults(url), transport2(opts));
    return fromBrAPIAlleleMatrix(json, opts.regionLabel !== void 0 ? {
        regionLabel: opts.regionLabel
    } : {});
}
async function fetchBrapiGermplasm(base, ids, opts = {}) {
    const wanted = new Set(ids);
    const out = {};
    for await (const page of brapiPages(`${base}/germplasm`, opts)){
        const all = fromBrAPIGermplasm(page.data);
        for (const id of Object.keys(all))if (wanted.has(id)) out[id] = all[id];
    }
    return out;
}
async function fetchBrapiVariants(variantsUrl, opts = {}) {
    const maxPages = opts.maxPages ?? Infinity;
    const rows = [];
    let url = variantsUrl;
    for(let requests = 0; requests < maxPages; requests++){
        const json = await (0, _chunkLPNPUTTSJs.getJson)(url, transport2(opts));
        const body = json && typeof json === "object" ? json : {};
        const result = body.result && typeof body.result === "object" ? body.result : null;
        const data = result !== null && Array.isArray(result.data) ? result.data : Array.isArray(json) ? json : [];
        rows.push(...data);
        const metadata = body.metadata && typeof body.metadata === "object" ? body.metadata : {};
        const pagination = metadata.pagination && typeof metadata.pagination === "object" ? metadata.pagination : null;
        if (pagination === null) break;
        const currentPage = typeof pagination.currentPage === "number" ? pagination.currentPage : requests;
        const totalPages = typeof pagination.totalPages === "number" ? pagination.totalPages : 1;
        if (currentPage >= totalPages - 1 || data.length === 0) break;
        url = (0, _chunkLPNPUTTSJs.buildUrl)(variantsUrl, "", {
            page: currentPage + 1
        });
    }
    return fromBrAPIVariants(rows, opts.reference !== void 0 ? {
        reference: opts.reference
    } : {});
}
async function fetchBrapiVariantSetTree(base, variantSetDbId, opts = {}) {
    let json;
    try {
        json = await (0, _chunkLPNPUTTSJs.getJson)(`${base}/variantsets/${encodeURIComponent(variantSetDbId)}/tree`, transport2(opts));
    } catch (err) {
        if (err instanceof (0, _chunkLPNPUTTSJs.HttpError) && err.status === 404) return null;
        throw err;
    }
    const body = json?.result ?? json;
    if (!body || typeof body !== "object") throw new Error("BrAPI: variantset tree response is not an object");
    const t = body;
    if (typeof t.newick !== "string") throw new Error("BrAPI: variantset tree response has no `newick`");
    return {
        newick: t.newick,
        leafOrder: Array.isArray(t.leafOrder) ? t.leafOrder.map(String) : [],
        ...typeof t.method === "string" ? {
            method: t.method
        } : {},
        ...typeof t.metric === "string" ? {
            metric: t.metric
        } : {}
    };
}
function starTree(samples) {
    const nodes = {
        root: {
            id: "root",
            parentId: null,
            distance: 0,
            isLeaf: false
        }
    };
    samples.forEach((s, i)=>{
        const id = `l${i}`;
        nodes[id] = {
            id,
            parentId: "root",
            distance: 1,
            isLeaf: true,
            geneId: s
        };
    });
    return {
        rootId: "root",
        nodes
    };
}
var germplasmSlot = {
    id: "germplasm",
    mode: "eager",
    enabled: (ctx)=>ctx.germplasm !== false,
    run: ({ ctx, fetch, signal, root })=>fetchBrapiGermplasm(ctx.base ?? brapiBaseOf(ctx.matrixUrl), root.meta.sampleIds, {
            fetch,
            signal
        }),
    toHostData: (germplasm)=>({
            germplasm
        })
};
var variantsSlot = {
    id: "variants",
    mode: "eager",
    enabled: (ctx)=>ctx.variants !== false,
    run: ({ ctx, fetch, signal, root })=>{
        const reference = root.meta.matrix.variants[0]?.reference;
        return fetchBrapiVariants(brapiVariantsUrlFrom(ctx.matrixUrl), {
            fetch,
            signal,
            ...reference !== void 0 ? {
                reference
            } : {}
        });
    },
    toHostData: ()=>({}),
    patchMeta: (sites, meta)=>({
            ...meta,
            matrix: mergeVariantSites(meta.matrix, sites)
        })
};
var brapiAlleleMatrixSource = {
    id: "brapi-allelematrix",
    label: "BrAPI allele matrix",
    async loadRoot ({ ctx, fetch, signal }) {
        const r = await fetchBrapiAlleleMatrix(ctx.matrixUrl, {
            fetch,
            signal,
            ...ctx.regionLabel !== void 0 ? {
                regionLabel: ctx.regionLabel
            } : {}
        });
        let tree;
        let swappedNodeIds = [];
        let treeMethod = r.treeMethod;
        let treeMetric = r.treeMetric;
        const parsed = fromBrAPITree(r);
        if (parsed) {
            tree = parsed.tree;
            swappedNodeIds = parsed.swappedNodeIds;
        } else {
            const fallback = ctx.treeFallback ?? "upgma";
            if (fallback === "none") throw new Error("BrAPI: response has no tree");
            if (fallback === "star") {
                tree = starTree(r.sampleIds);
                treeMethod = "star";
                treeMetric = void 0;
            } else {
                const { dosages, samples, numVariants } = (0, _chunkNFAGMBWMJs.dosagesFromGenotypeMatrix)(r.matrix, r.sampleIds);
                const result = (0, _chunkNFAGMBWMJs.upgma)(samples, (0, _chunkNFAGMBWMJs.distanceMatrix)(dosages, samples.length, numVariants));
                tree = result.tree;
                treeMethod = result.method;
                treeMetric = (0, _chunkNFAGMBWMJs.DOSAGE_L1_MEAN);
            }
        }
        return {
            tree,
            data: {},
            meta: {
                matrix: r.matrix,
                sampleIds: r.sampleIds,
                ...r.variantSetDbId !== void 0 ? {
                    variantSetDbId: r.variantSetDbId
                } : {},
                swappedNodeIds,
                ...r.pagination !== void 0 ? {
                    pagination: r.pagination
                } : {},
                ...treeMethod !== void 0 ? {
                    treeMethod
                } : {},
                ...treeMetric !== void 0 ? {
                    treeMetric
                } : {}
            }
        };
    },
    slots: [
        germplasmSlot,
        variantsSlot
    ]
};
// src/sources/file.ts
var fileTreeSource = {
    id: "file",
    label: "Tree file",
    async loadRoot ({ ctx }) {
        const parsed = await (0, _chunk27AE42SIJs.parseTreeSource)(ctx.file, {
            ...ctx.parseDocument !== void 0 ? {
                parseDocument: ctx.parseDocument
            } : {},
            ...ctx.DOMParser !== void 0 ? {
                DOMParser: ctx.DOMParser
            } : {}
        });
        const filename = typeof ctx.file === "string" ? void 0 : ctx.file.name;
        const meta = {
            format: parsed.format,
            warnings: parsed.warnings
        };
        if (filename !== void 0) meta.filename = filename;
        return {
            tree: parsed.tree,
            ...parsed.taxonomy !== void 0 ? {
                taxonomy: parsed.taxonomy
            } : {},
            meta
        };
    },
    slots: []
};

},{"./chunk-27AE42SI.js":"deWm1","./chunk-NFAGMBWM.js":"1Bebw","./chunk-LPNPUTTS.js":"4knjt","./chunk-F6Q2MMZH.js":"kxqsj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"deWm1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "detectDelimiter", ()=>detectDelimiter) //# sourceMappingURL=chunk-27AE42SI.js.map
;
parcelHelpers.export(exports, "detectTreeFormat", ()=>detectTreeFormat);
parcelHelpers.export(exports, "inferColumnKind", ()=>inferColumnKind);
parcelHelpers.export(exports, "parseDelimitedLine", ()=>parseDelimitedLine);
parcelHelpers.export(exports, "parseNewick", ()=>parseNewick);
parcelHelpers.export(exports, "parseNewickAll", ()=>parseNewickAll);
parcelHelpers.export(exports, "parseNexus", ()=>parseNexus);
parcelHelpers.export(exports, "parsePhyloXML", ()=>parsePhyloXML);
parcelHelpers.export(exports, "parseTableFile", ()=>parseTableFile);
parcelHelpers.export(exports, "parseTreeFile", ()=>parseTreeFile);
parcelHelpers.export(exports, "parseTreeSource", ()=>parseTreeSource);
var _chunkF6Q2MMZHJs = require("./chunk-F6Q2MMZH.js");
// src/parsers/newick.ts
function parseNewick(text, opts = {}) {
    const leafGeneId = opts.leafGeneId ?? true;
    const labelsAsIds = opts.labelsAsIds ?? true;
    const prefix = opts.idPrefix ?? "";
    const warnings = [];
    const cleaned = text.replace(/\[[^\]]*\]/g, "");
    const body = cleaned.trim().replace(/;\s*$/, "").trim();
    if (body.length === 0) throw new Error("Newick: empty input");
    const nodes = {};
    let pos = 0;
    let synthetic = 0;
    let ordinal = 0;
    const seenIds = /* @__PURE__ */ new Set();
    const uniqueId = (raw, isLeaf)=>{
        const base = raw.trim();
        if (base !== "" && !seenIds.has(base)) {
            seenIds.add(base);
            return base;
        }
        if (base !== "") {
            let n = 2;
            let candidate2 = `${base}__${n}`;
            while(seenIds.has(candidate2)){
                n++;
                candidate2 = `${base}__${n}`;
            }
            seenIds.add(candidate2);
            warnings.push(`duplicate ${isLeaf ? "leaf" : "internal"} label "${base}" \u2014 renamed to "${candidate2}"`);
            return candidate2;
        }
        let candidate = `${prefix}__${isLeaf ? "leaf" : "node"}_${synthetic++}`;
        while(seenIds.has(candidate))candidate = `${prefix}__${isLeaf ? "leaf" : "node"}_${synthetic++}`;
        seenIds.add(candidate);
        return candidate;
    };
    const readToken = ()=>{
        if (body[pos] === "'") {
            pos++;
            let out2 = "";
            while(pos < body.length){
                if (body[pos] === "'") {
                    if (body[pos + 1] === "'") {
                        out2 += "'";
                        pos += 2;
                        continue;
                    }
                    pos++;
                    return out2;
                }
                out2 += body[pos++];
            }
            throw new Error("Newick: unterminated quoted name");
        }
        let out = "";
        while(pos < body.length && !",():;".includes(body[pos]))out += body[pos++];
        return out.trim();
    };
    const parseSubtree = ()=>{
        const childIds = [];
        if (body[pos] === "(") {
            pos++;
            childIds.push(parseSubtree());
            while(body[pos] === ","){
                pos++;
                childIds.push(parseSubtree());
            }
            if (body[pos] !== ")") throw new Error(`Newick: expected ')' at position ${pos}, found '${body[pos] ?? "<eof>"}'`);
            pos++;
        }
        const isLeaf = childIds.length === 0;
        const label = readToken();
        let distance = 0;
        let bootstrap;
        if (body[pos] === ":") {
            pos++;
            const lenTok = readToken();
            const len = Number(lenTok);
            if (Number.isFinite(len) && len >= 0) distance = len;
            else if (lenTok !== "") warnings.push(`invalid branch length "${lenTok}"`);
        }
        if (!isLeaf && label !== "" && Number.isFinite(Number(label))) {
            const n = Number(label);
            if (n >= 0 && n <= 100) bootstrap = n;
        }
        const id = labelsAsIds ? uniqueId(label, isLeaf) : `${prefix}n${ordinal++}`;
        const node = {
            id,
            parentId: null,
            distance,
            isLeaf
        };
        if (isLeaf && label !== "" && leafGeneId) node.geneId = label;
        if (bootstrap !== void 0) node.bootstrap = bootstrap;
        nodes[id] = node;
        for (const cid of childIds){
            const child = nodes[cid];
            if (child) child.parentId = id;
        }
        return id;
    };
    const rootId = parseSubtree();
    if (pos < body.length) warnings.push(`trailing content at position ${pos}: ${body.slice(pos, pos + 30)}\u2026`);
    const tree = {
        rootId,
        nodes
    };
    (0, _chunkF6Q2MMZHJs.assertValidTree)(tree);
    return {
        format: "newick",
        tree,
        warnings
    };
}
function parseNewickAll(text, opts = {}) {
    const chunks = [];
    let cur = "";
    let inQuote = false;
    let commentDepth = 0;
    for(let i = 0; i < text.length; i++){
        const c = text[i];
        if (inQuote) {
            cur += c;
            if (c === "'") inQuote = false;
            continue;
        }
        if (commentDepth > 0) {
            cur += c;
            if (c === "]") commentDepth--;
            continue;
        }
        if (c === "'") {
            inQuote = true;
            cur += c;
        } else if (c === "[") {
            commentDepth++;
            cur += c;
        } else if (c === ";") {
            chunks.push(cur);
            cur = "";
        } else cur += c;
    }
    chunks.push(cur);
    const out = [];
    for (const chunk of chunks){
        const stripped = chunk.replace(/\[[^\]]*\]/g, "").trim();
        if (stripped.length === 0) continue;
        out.push(parseNewick(chunk, opts));
    }
    return out;
}
// src/parsers/nexus.ts
function parseNexus(text, opts = {}) {
    const head = text.match(/#nexus/i);
    if (!head) throw new Error("Nexus: missing #NEXUS header");
    const treesMatch = text.match(/begin\s+trees\s*;([\s\S]*?)end\s*;/i);
    if (!treesMatch) throw new Error("Nexus: no TREES block found");
    const block = treesMatch[1] ?? "";
    const translate = {};
    const transMatch = block.match(/translate\s+([\s\S]*?);/i);
    if (transMatch) {
        const pairs = (transMatch[1] ?? "").split(",").map((p)=>p.trim()).filter((p)=>p.length > 0);
        for (const p of pairs){
            const m = p.match(/^(\S+)\s+(.+)$/);
            if (m) translate[m[1]] = m[2].replace(/^['"]|['"]$/g, "");
        }
    }
    const treeMatch = block.match(/tree\s+\S+\s*=(?:\s*\[[^\]]*\])?\s*([\s\S]*?);/i);
    if (!treeMatch) throw new Error("Nexus: no `tree NAME = ...;` line found in TREES block");
    let newick = (treeMatch[1] ?? "").trim() + ";";
    if (Object.keys(translate).length > 0) newick = newick.replace(/([(,])\s*(\w+)/g, (full, sep, tok)=>{
        const name = translate[tok];
        return name ? `${sep}${quoteIfNeeded(name)}` : full;
    });
    const inner = parseNewick(newick, opts);
    return {
        ...inner,
        format: "nexus"
    };
}
function quoteIfNeeded(s) {
    return /[\s,():;]/.test(s) ? `'${s.replace(/'/g, "''")}'` : s;
}
// src/parsers/phyloxml.ts
var ELEMENT_NODE = 1;
function elementsByLocalName(doc, name) {
    const all = doc.getElementsByTagName("*");
    const out = [];
    for(let i = 0; i < all.length; i++){
        const el = all[i];
        if (el.localName === name) out.push(el);
    }
    return out;
}
var NO_PARSER_MESSAGE = "PhyloXML: no XML parser in this environment; pass opts.parseDocument or opts.DOMParser (e.g. @xmldom/xmldom)";
function parsePhyloXML(text, opts = {}) {
    const doc = parseDocumentWith(text, opts);
    const parserError = doc.getElementsByTagName("parsererror")[0];
    if (parserError) throw new Error(`PhyloXML: malformed XML \u2014 ${parserError.textContent ?? ""}`);
    const phylogenies = elementsByLocalName(doc, "phylogeny");
    let rootClade = null;
    for(let i = 0; i < phylogenies.length && rootClade === null; i++)rootClade = directChild(phylogenies[i], "clade");
    if (!rootClade) throw new Error("PhyloXML: no <phylogeny> element");
    const warnings = [];
    const nodes = {};
    const taxonomy = {};
    let synthetic = 0;
    const seen = /* @__PURE__ */ new Set();
    let nextTaxId = 1;
    const walk = (clade, parentId)=>{
        const childClades = directChildren(clade, "clade");
        const isLeaf = childClades.length === 0;
        const nameEl = directChild(clade, "name");
        const rawName = nameEl?.textContent?.trim() ?? "";
        let id = rawName;
        if (id === "" || seen.has(id)) {
            const fallback = `__${isLeaf ? "leaf" : "node"}_${synthetic++}`;
            if (rawName !== "" && id !== "") warnings.push(`duplicate clade name "${rawName}" \u2014 renamed to "${fallback}"`);
            id = fallback;
        }
        seen.add(id);
        const branchEl = directChild(clade, "branch_length");
        const branchAttr = clade.getAttribute("branch_length");
        const distRaw = branchEl?.textContent ?? branchAttr ?? "";
        const distance = Number.isFinite(Number(distRaw)) ? Number(distRaw) : 0;
        let taxonomyId;
        const taxEl = directChild(clade, "taxonomy");
        if (taxEl) {
            const tid = nextTaxId++;
            taxonomyId = tid;
            const sci = directChild(taxEl, "scientific_name")?.textContent?.trim();
            const common = directChild(taxEl, "common_name")?.textContent?.trim();
            const rank = directChild(taxEl, "rank")?.textContent?.trim();
            const entry = {
                ...sci !== void 0 ? {
                    scientificName: sci
                } : {},
                ...common !== void 0 ? {
                    commonName: common
                } : {},
                ...rank !== void 0 ? {
                    rank
                } : {}
            };
            taxonomy[tid] = entry;
        }
        const node = {
            id,
            parentId,
            distance,
            isLeaf
        };
        if (isLeaf && rawName !== "") node.geneId = rawName;
        if (taxonomyId !== void 0) node.taxonomyId = taxonomyId;
        nodes[id] = node;
        for (const child of childClades)walk(child, id);
        return id;
    };
    const rootId = walk(rootClade, null);
    const tree = {
        rootId,
        nodes
    };
    (0, _chunkF6Q2MMZHJs.assertValidTree)(tree);
    return {
        format: "phyloxml",
        tree,
        ...Object.keys(taxonomy).length > 0 ? {
            taxonomy
        } : {},
        warnings
    };
}
function parseDocumentWith(text, opts) {
    if (opts.parseDocument) return opts.parseDocument(text);
    const Ctor = opts.DOMParser ?? globalThis.DOMParser;
    if (!Ctor) throw new Error(NO_PARSER_MESSAGE);
    return new Ctor().parseFromString(text, "application/xml");
}
function directChildren(parent, tag) {
    const out = [];
    const kids = parent.childNodes;
    for(let i = 0; i < kids.length; i++){
        const c = kids[i];
        if (c.nodeType === ELEMENT_NODE && c.localName === tag) out.push(c);
    }
    return out;
}
function directChild(parent, tag) {
    const kids = parent.childNodes;
    for(let i = 0; i < kids.length; i++){
        const c = kids[i];
        if (c.nodeType === ELEMENT_NODE && c.localName === tag) return c;
    }
    return null;
}
// src/parsers/treeFile.ts
var EXTENSION_FORMATS = {
    nwk: "newick",
    newick: "newick",
    tree: "newick",
    tre: "newick",
    nex: "nexus",
    nexus: "nexus",
    nxs: "nexus",
    xml: "phyloxml",
    phyloxml: "phyloxml"
};
function detectTreeFormat(text, filename) {
    const head = text.trimStart().slice(0, 200).toLowerCase();
    if (head.startsWith("<?xml") || head.includes("<phyloxml") || head.includes("<phylogeny")) return "phyloxml";
    if (head.startsWith("#nexus")) return "nexus";
    if (text.includes("(")) return "newick";
    if (filename !== void 0) {
        const ext = filename.toLowerCase().match(/\.([a-z0-9]+)$/)?.[1];
        if (ext !== void 0) return EXTENSION_FORMATS[ext] ?? null;
    }
    return null;
}
function parseTreeFile(text, filenameOrOpts) {
    const opts = typeof filenameOrOpts === "string" ? {
        filename: filenameOrOpts
    } : filenameOrOpts ?? {};
    const format = detectTreeFormat(text, opts.filename);
    if (format === null) throw new Error(`${opts.filename ?? "tree file"}: could not recognize tree format \u2014 expected Newick, Nexus, or PhyloXML`);
    if (format === "phyloxml") return parsePhyloXML(text, opts);
    if (format === "nexus") return parseNexus(text, opts);
    return parseNewick(text, opts);
}
async function parseTreeSource(src, opts = {}) {
    if (typeof src === "string") return parseTreeFile(src, opts);
    const text = await src.text();
    const filename = opts.filename ?? src.name;
    return parseTreeFile(text, {
        ...opts,
        ...filename !== void 0 ? {
            filename
        } : {}
    });
}
// src/parsers/table.ts
var BOOLEAN_TRUE = /* @__PURE__ */ new Set([
    "true",
    "t",
    "yes",
    "y",
    "1"
]);
var BOOLEAN_FALSE = /* @__PURE__ */ new Set([
    "false",
    "f",
    "no",
    "n",
    "0"
]);
var COMMON_GENE_HEADERS = [
    "gene_id",
    "geneid",
    "id",
    "gene"
];
function parseTableFile(text, opts = {}) {
    const warnings = [];
    const trimmed = text.replace(/^﻿/, "");
    const lines = splitLines(trimmed);
    if (lines.length < 2) return {
        columns: [],
        table: {},
        rowCount: 0,
        warnings: [
            "File is empty or has no data rows"
        ]
    };
    const firstLine = lines[0];
    const delimiter = opts.delimiter ?? detectDelimiter(firstLine);
    const headerRow = parseDelimitedLine(firstLine, delimiter);
    const dataRows = lines.slice(1).filter((l)=>l.trim().length > 0).map((l)=>parseDelimitedLine(l, delimiter));
    if (headerRow.length === 0) return {
        columns: [],
        table: {},
        rowCount: 0,
        warnings: [
            "Could not parse a header row"
        ]
    };
    const geneIdIdx = pickGeneIdColumn(headerRow, opts.geneIdHeader);
    if (geneIdIdx < 0) warnings.push(`No gene-id column found (expected one of ${COMMON_GENE_HEADERS.join(", ")}); using the first column "${headerRow[0]}"`);
    const idIdx = geneIdIdx >= 0 ? geneIdIdx : 0;
    const dataColumnIndices = [];
    for(let i = 0; i < headerRow.length; i++){
        if (i === idIdx) continue;
        dataColumnIndices.push(i);
    }
    const rawValuesByCol = dataColumnIndices.map(()=>[]);
    const tableEntries = [];
    for (const row of dataRows){
        const gene = row[idIdx]?.trim();
        if (!gene) continue;
        const cells = [];
        for(let j = 0; j < dataColumnIndices.length; j++){
            const idx = dataColumnIndices[j];
            const cell = row[idx];
            const v = cell?.trim();
            cells.push(v);
            if (v !== void 0 && v !== "") rawValuesByCol[j].push(v);
        }
        tableEntries.push({
            gene,
            cells
        });
    }
    const seenIds = /* @__PURE__ */ new Set();
    const columns = dataColumnIndices.map((origIdx, j)=>{
        const label = headerRow[origIdx]?.trim() || `column_${j + 1}`;
        let id = slugify(label);
        if (id === "" || seenIds.has(id)) {
            let n = 2;
            const base = id || `col${j + 1}`;
            while(seenIds.has(`${base}_${n}`))n++;
            id = `${base}_${n}`;
        }
        seenIds.add(id);
        const kind = inferColumnKind(rawValuesByCol[j]);
        return {
            id,
            label,
            kind
        };
    });
    const table = {};
    for (const { gene, cells } of tableEntries){
        const row = {};
        for(let j = 0; j < columns.length; j++){
            const col = columns[j];
            const v = cells[j];
            if (v === void 0 || v === "") {
                row[col.id] = null;
                continue;
            }
            row[col.id] = coerce(v, col.kind);
        }
        if (gene in table) warnings.push(`Duplicate gene id "${gene}" \u2014 last row kept`);
        table[gene] = row;
    }
    return {
        columns,
        table,
        rowCount: Object.keys(table).length,
        warnings
    };
}
function pickGeneIdColumn(headerRow, override) {
    if (override) {
        const want = override.toLowerCase();
        const idx = headerRow.findIndex((h)=>h.trim().toLowerCase() === want);
        return idx;
    }
    for (const candidate of COMMON_GENE_HEADERS){
        const idx = headerRow.findIndex((h)=>h.trim().toLowerCase().replace(/\s+/g, "") === candidate);
        if (idx >= 0) return idx;
    }
    return -1;
}
function detectDelimiter(line) {
    const tabs = line.split("	").length - 1;
    const commas = line.split(",").length - 1;
    if (tabs > commas) return "	";
    return ",";
}
function splitLines(text) {
    return text.replace(/\r\n?/g, "\n").split("\n");
}
function parseDelimitedLine(line, delimiter) {
    const out = [];
    let cur = "";
    let inQuotes = false;
    for(let i = 0; i < line.length; i++){
        const c = line[i];
        if (inQuotes) {
            if (c === '"') {
                if (line[i + 1] === '"') {
                    cur += '"';
                    i++;
                } else inQuotes = false;
            } else cur += c;
        } else if (c === '"') inQuotes = true;
        else if (c === delimiter) {
            out.push(cur);
            cur = "";
        } else cur += c;
    }
    out.push(cur);
    return out;
}
function inferColumnKind(values) {
    if (values.length === 0) return "string";
    let allNum = true;
    let allBool = true;
    for (const v of values){
        const lower = v.toLowerCase();
        if (allBool && !BOOLEAN_TRUE.has(lower) && !BOOLEAN_FALSE.has(lower)) allBool = false;
        if (allNum) {
            const n = Number(v);
            if (!Number.isFinite(n) || v === "") allNum = false;
        }
        if (!allBool && !allNum) return "string";
    }
    if (allBool) {
        const hasNonNumericBool = values.some((v)=>{
            const lower = v.toLowerCase();
            return BOOLEAN_TRUE.has(lower) || BOOLEAN_FALSE.has(lower) ? Number.isNaN(Number(v)) : false;
        });
        if (hasNonNumericBool) return "boolean";
    }
    if (allNum) return "number";
    return "string";
}
function coerce(raw, kind) {
    if (kind === "number") {
        const n = Number(raw);
        return Number.isFinite(n) ? n : raw;
    }
    if (kind === "boolean") return BOOLEAN_TRUE.has(raw.toLowerCase());
    return raw;
}
function slugify(label) {
    return label.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
}

},{"./chunk-F6Q2MMZH.js":"kxqsj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kxqsj":[function(require,module,exports,__globalThis) {
// src/tree/walk.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EMPTY_NODE_ID_SET", ()=>EMPTY_NODE_ID_SET) //# sourceMappingURL=chunk-F6Q2MMZH.js.map
;
parcelHelpers.export(exports, "ancestorIdsOf", ()=>ancestorIdsOf);
parcelHelpers.export(exports, "assertValidTree", ()=>assertValidTree);
parcelHelpers.export(exports, "buildChildrenIndex", ()=>buildChildrenIndex);
parcelHelpers.export(exports, "computePivotState", ()=>computePivotState);
parcelHelpers.export(exports, "countLeavesInSubtree", ()=>countLeavesInSubtree);
parcelHelpers.export(exports, "depthOf", ()=>depthOf);
parcelHelpers.export(exports, "fromHierarchy", ()=>fromHierarchy);
parcelHelpers.export(exports, "fromTreeModel", ()=>fromTreeModel);
parcelHelpers.export(exports, "isLeafNode", ()=>isLeafNode);
parcelHelpers.export(exports, "lca", ()=>lca);
parcelHelpers.export(exports, "leafGeneIds", ()=>leafGeneIds);
parcelHelpers.export(exports, "leafIdsOf", ()=>leafIdsOf);
parcelHelpers.export(exports, "leafOrder", ()=>leafOrder);
parcelHelpers.export(exports, "leavesFailing", ()=>leavesFailing);
parcelHelpers.export(exports, "maximalExcludedClades", ()=>maximalExcludedClades);
parcelHelpers.export(exports, "nodeHeights", ()=>nodeHeights);
parcelHelpers.export(exports, "pathToRoot", ()=>pathToRoot);
parcelHelpers.export(exports, "postorder", ()=>postorder);
parcelHelpers.export(exports, "preorder", ()=>preorder);
parcelHelpers.export(exports, "pruneToLeaves", ()=>pruneToLeaves);
parcelHelpers.export(exports, "quoteNewickLabel", ()=>quoteNewickLabel);
parcelHelpers.export(exports, "rollUp", ()=>rollUp);
parcelHelpers.export(exports, "subtree", ()=>subtree);
parcelHelpers.export(exports, "subtreeIdsOf", ()=>subtreeIdsOf);
parcelHelpers.export(exports, "sumLeafCounts", ()=>sumLeafCounts);
parcelHelpers.export(exports, "swapsForLeafOrder", ()=>swapsForLeafOrder);
parcelHelpers.export(exports, "toNewick", ()=>toNewick);
parcelHelpers.export(exports, "validateTree", ()=>validateTree);
var NO_CHILDREN = [];
function orderedChildren(id, childrenIndex, swapped) {
    const kids = childrenIndex.get(id) ?? NO_CHILDREN;
    return swapped !== void 0 && swapped.has(id) ? [
        ...kids
    ].reverse() : kids;
}
function preorder(tree, opts = {}) {
    const childrenIndex = opts.childrenIndex ?? buildChildrenIndex(tree);
    const out = [];
    const stack = [
        opts.rootId ?? tree.rootId
    ];
    while(stack.length > 0){
        const id = stack.pop();
        const n = tree.nodes[id];
        if (!n) continue;
        out.push(id);
        if (n.isLeaf) continue;
        const kids = orderedChildren(id, childrenIndex, opts.swappedNodeIds);
        for(let i = kids.length - 1; i >= 0; i--)stack.push(kids[i]);
    }
    return out;
}
function postorder(tree, opts = {}) {
    const childrenIndex = opts.childrenIndex ?? buildChildrenIndex(tree);
    const out = [];
    const stack = [
        {
            id: opts.rootId ?? tree.rootId,
            expanded: false
        }
    ];
    while(stack.length > 0){
        const top = stack[stack.length - 1];
        const n = tree.nodes[top.id];
        if (!n) {
            stack.pop();
            continue;
        }
        if (n.isLeaf || top.expanded) {
            out.push(top.id);
            stack.pop();
            continue;
        }
        top.expanded = true;
        const kids = orderedChildren(top.id, childrenIndex, opts.swappedNodeIds);
        for(let i = kids.length - 1; i >= 0; i--)stack.push({
            id: kids[i],
            expanded: false
        });
    }
    return out;
}
function leafOrder(tree, opts = {}) {
    const childrenIndex = opts.childrenIndex ?? buildChildrenIndex(tree);
    const out = [];
    const stack = [
        opts.rootId ?? tree.rootId
    ];
    while(stack.length > 0){
        const id = stack.pop();
        const n = tree.nodes[id];
        if (!n) continue;
        if (n.isLeaf) {
            out.push(id);
            continue;
        }
        const kids = orderedChildren(id, childrenIndex, opts.swappedNodeIds);
        for(let i = kids.length - 1; i >= 0; i--)stack.push(kids[i]);
    }
    return out;
}
// src/tree/rollup.ts
function rollUp(tree, leafValue, combine, opts = {}) {
    const childrenIndex = opts.childrenIndex ?? buildChildrenIndex(tree);
    const values = /* @__PURE__ */ new Map();
    const stack = [
        {
            id: tree.rootId,
            expanded: false
        }
    ];
    while(stack.length > 0){
        const top = stack[stack.length - 1];
        const node = tree.nodes[top.id];
        if (!node) {
            stack.pop();
            continue;
        }
        if (node.isLeaf) {
            values.set(top.id, leafValue(node));
            stack.pop();
            continue;
        }
        const kids = childrenIndex.get(top.id) ?? [];
        if (!top.expanded) {
            top.expanded = true;
            for(let i = kids.length - 1; i >= 0; i--)stack.push({
                id: kids[i],
                expanded: false
            });
            continue;
        }
        const childValues = [];
        for (const k of kids)if (values.has(k)) childValues.push(values.get(k));
        values.set(top.id, combine(childValues, node));
        stack.pop();
    }
    const out = {};
    for (const [id, v] of values)out[id] = v;
    return out;
}
function sumLeafCounts(tree, leafCounts) {
    return rollUp(tree, (leaf)=>leafCounts[leaf.id] || 0, (childValues)=>{
        let sum = 0;
        for (const v of childValues)sum += v;
        return sum;
    });
}
function maximalExcludedClades(tree, keepLeaf, childrenIndex = buildChildrenIndex(tree)) {
    const nodes = tree.nodes;
    const memo = /* @__PURE__ */ new Map();
    const hasKept = (id)=>{
        const cached = memo.get(id);
        if (cached !== void 0) return cached;
        const n = nodes[id];
        const v = !n ? false : n.isLeaf ? keepLeaf(n) : (childrenIndex.get(id) ?? []).some(hasKept);
        memo.set(id, v);
        return v;
    };
    return Object.values(nodes).filter((n)=>!hasKept(n.id) && (n.parentId == null || hasKept(n.parentId))).map((n)=>n.id);
}
function leavesFailing(tree, keepLeaf) {
    return leafIdsOf(tree).filter((id)=>!keepLeaf(tree.nodes[id]));
}
// src/tree/prune.ts
function pruneToLeaves(tree, keep, opts = {}) {
    const collapseUnary = opts.collapseUnary ?? true;
    const keepLeaf = typeof keep === "function" ? keep : (leaf)=>keep.has(leaf.id);
    const childrenIndex = buildChildrenIndex(tree);
    const survivor = /* @__PURE__ */ new Map();
    const extraDistance = /* @__PURE__ */ new Map();
    const stack = [
        {
            id: tree.rootId,
            expanded: false
        }
    ];
    while(stack.length > 0){
        const top = stack[stack.length - 1];
        const node = tree.nodes[top.id];
        if (!node) {
            stack.pop();
            continue;
        }
        if (node.isLeaf) {
            if (keepLeaf(node)) survivor.set(top.id, top.id);
            stack.pop();
            continue;
        }
        const kids = childrenIndex.get(top.id) ?? [];
        if (!top.expanded) {
            top.expanded = true;
            for(let i = kids.length - 1; i >= 0; i--)stack.push({
                id: kids[i],
                expanded: false
            });
            continue;
        }
        const alive = [];
        for (const k of kids){
            const s = survivor.get(k);
            if (s !== void 0) alive.push(s);
        }
        if (alive.length === 0) ;
        else if (alive.length === 1 && collapseUnary) {
            const child = alive[0];
            survivor.set(top.id, child);
            extraDistance.set(child, (extraDistance.get(child) ?? 0) + node.distance);
        } else survivor.set(top.id, top.id);
        stack.pop();
    }
    const newRootId = survivor.get(tree.rootId);
    if (newRootId === void 0) return null;
    const nodes = {};
    for (const id of Object.keys(tree.nodes)){
        if (survivor.get(id) !== id) continue;
        const node = tree.nodes[id];
        const parentId = id === newRootId ? null : survivorParent(node, tree, survivor);
        const extra = extraDistance.get(id) ?? 0;
        nodes[id] = {
            ...node,
            parentId,
            distance: node.distance + extra
        };
    }
    return {
        rootId: newRootId,
        nodes
    };
}
function survivorParent(node, tree, survivor) {
    let p = node.parentId;
    while(p !== null){
        if (survivor.get(p) === p) return p;
        p = tree.nodes[p]?.parentId ?? null;
    }
    return null;
}
function subtree(tree, rootId) {
    const root = tree.nodes[rootId];
    if (!root) throw new Error(`subtree: node "${rootId}" is not in the tree`);
    const ids = subtreeIdsOf(rootId, buildChildrenIndex(tree));
    const nodes = {};
    for (const id of Object.keys(tree.nodes)){
        if (!ids.has(id)) continue;
        const node = tree.nodes[id];
        nodes[id] = id === rootId ? {
            ...node,
            parentId: null
        } : {
            ...node
        };
    }
    return {
        rootId,
        nodes
    };
}
// src/tree/pivot.ts
function computePivotState(tree, identifier) {
    let target = null;
    for (const id of Object.keys(tree.nodes)){
        const n = tree.nodes[id];
        if (!n) continue;
        if (n.isLeaf && n.geneId === identifier) {
            target = id;
            break;
        }
    }
    if (target === null && tree.nodes[identifier] !== void 0) target = identifier;
    if (target === null) {
        console.warn(`tbrowse: nodeOfInterest "${identifier}" not found (no leaf with this geneId, no node with this id)`);
        return null;
    }
    const path = [];
    let cur = target;
    while(cur !== null){
        path.push(cur);
        cur = tree.nodes[cur]?.parentId ?? null;
    }
    path.reverse();
    const pathSet = new Set(path);
    const collapsedNodeIds = [];
    for (const id of Object.keys(tree.nodes)){
        if (pathSet.has(id)) continue;
        const node = tree.nodes[id];
        if (!node || node.isLeaf) continue;
        collapsedNodeIds.push(id);
    }
    const childrenIndex = buildChildrenIndex(tree);
    const swappedNodeIds = [];
    for(let i = 0; i < path.length - 1; i++){
        const ancestorId = path[i];
        const pathChildId = path[i + 1];
        const children = childrenIndex.get(ancestorId) ?? [];
        if (children.indexOf(pathChildId) > 0) swappedNodeIds.push(ancestorId);
    }
    return {
        collapsedNodeIds,
        swappedNodeIds,
        targetId: target
    };
}
// src/tree/newick.ts
function defaultLabel(node) {
    return node.isLeaf ? node.geneId ?? node.id : null;
}
function quoteNewickLabel(label) {
    if (/[\s,():;'\[\]]/.test(label)) return `'${label.replace(/'/g, "''")}'`;
    return label;
}
function toNewick(tree, opts = {}) {
    const label = opts.label ?? defaultLabel;
    const branchLengths = opts.branchLengths ?? true;
    const precision = opts.precision ?? 6;
    const swapped = opts.swappedNodeIds;
    const childrenIndex = opts.childrenIndex ?? buildChildrenIndex(tree);
    const rootId = opts.rootId ?? tree.rootId;
    const root = tree.nodes[rootId];
    if (!root) throw new Error(`toNewick: node "${rootId}" is not in the tree`);
    const labelOf = (n)=>{
        const l = label(n);
        return l === null ? "" : quoteNewickLabel(l);
    };
    const childrenOf = (n)=>{
        if (n.isLeaf) return "";
        const kids = childrenIndex.get(n.id) ?? [];
        const ordered = swapped !== void 0 && swapped.has(n.id) ? [
            ...kids
        ].reverse() : kids;
        const parts = [];
        for (const k of ordered){
            const child = tree.nodes[k];
            if (child) parts.push(visit(child));
        }
        return parts.length > 0 ? `(${parts.join(",")})` : "";
    };
    const visit = (n)=>{
        const len = branchLengths ? `:${n.distance.toFixed(precision)}` : "";
        return `${childrenOf(n)}${labelOf(n)}${len}`;
    };
    return `${childrenOf(root)}${labelOf(root)};`;
}
// src/tree/hierarchy.ts
function fromHierarchy(root, acc) {
    const nodes = {};
    const taxonomy = {};
    const leafIds = [];
    const warnings = [];
    const rootId = String(acc.id(root));
    const stack = [
        {
            node: root,
            parent: null,
            parentId: null
        }
    ];
    while(stack.length > 0){
        const { node, parent, parentId } = stack.pop();
        const id = String(acc.id(node));
        if (nodes[id]) {
            warnings.push(`duplicate node id "${id}" skipped`);
            continue;
        }
        const kids = acc.children(node) ?? [];
        const isLeaf = kids.length === 0;
        const distance = acc.distance ? acc.distance(node, parent) : parentId === null ? 0 : 1;
        const taxonomyId = acc.taxonomyId?.(node);
        const geneId = acc.geneId?.(node);
        nodes[id] = {
            id,
            parentId,
            distance,
            isLeaf,
            ...taxonomyId !== void 0 ? {
                taxonomyId
            } : {},
            ...geneId !== void 0 ? {
                geneId
            } : {}
        };
        const taxon = acc.taxon?.(node);
        if (taxon !== void 0) {
            if (taxonomyId !== void 0) taxonomy[String(taxonomyId)] = taxon;
            else warnings.push(`node "${id}" has a taxon entry but no taxonomyId; entry dropped`);
        }
        if (isLeaf) leafIds.push(id);
        for(let i = kids.length - 1; i >= 0; i--)stack.push({
            node: kids[i],
            parent: node,
            parentId: id
        });
    }
    return {
        tree: {
            rootId,
            nodes
        },
        taxonomy,
        leafIds,
        warnings
    };
}
function fromTreeModel(root, opts = {}) {
    if (!root || !root.model) throw new Error("fromTreeModel: root has no model");
    const distance = opts.distance ?? 1;
    const asNumber = opts.taxonomyIdAs === "number";
    const result = fromHierarchy(root, {
        id: (n)=>n.model.id,
        // The original walk returned early on a child without a `model`; filter those out.
        children: (n)=>n.children?.filter((k)=>k && k.model),
        distance: (_n, parent)=>parent === null ? 0 : distance,
        taxonomyId: (n)=>asNumber ? Number(n.model.id) : String(n.model.id),
        taxon: (n)=>{
            const name = n.model.name;
            const rank = n.model.rank;
            return {
                ...name !== void 0 ? {
                    scientificName: name,
                    commonName: name
                } : {},
                ...rank !== void 0 ? {
                    rank
                } : {}
            };
        }
    });
    return {
        ...result,
        leafTaxonIds: result.leafIds
    };
}
// src/tree/swaps.ts
function defaultKey(leaf) {
    return leaf.geneId ?? leaf.id;
}
function swapsForLeafOrder(tree, order, key = defaultKey) {
    const rank = /* @__PURE__ */ new Map();
    order.forEach((label, i)=>{
        if (!rank.has(label)) rank.set(label, i);
    });
    const matched = /* @__PURE__ */ new Set();
    const childrenIndex = buildChildrenIndex(tree);
    const swappedNodeIds = [];
    const minRank = /* @__PURE__ */ new Map();
    const stack = [
        {
            id: tree.rootId,
            expanded: false
        }
    ];
    while(stack.length > 0){
        const top = stack[stack.length - 1];
        const node = tree.nodes[top.id];
        if (!node) {
            stack.pop();
            continue;
        }
        if (node.isLeaf) {
            const k = key(node);
            const r = rank.get(k);
            if (r !== void 0) matched.add(k);
            minRank.set(top.id, r ?? Infinity);
            stack.pop();
            continue;
        }
        const kids = childrenIndex.get(top.id) ?? [];
        if (!top.expanded) {
            top.expanded = true;
            for(let i = kids.length - 1; i >= 0; i--)stack.push({
                id: kids[i],
                expanded: false
            });
            continue;
        }
        const ranks = [];
        for (const k of kids){
            const r = minRank.get(k);
            if (r !== void 0) ranks.push(r);
        }
        let descending = ranks.length >= 2;
        for(let i = 1; i < ranks.length && descending; i++)if (!(ranks[i] < ranks[i - 1])) descending = false;
        if (descending) swappedNodeIds.push(top.id);
        minRank.set(top.id, ranks.length > 0 ? Math.min(...ranks) : Infinity);
        stack.pop();
    }
    const unmatched = [];
    for (const label of rank.keys())if (!matched.has(label)) unmatched.push(label);
    return {
        swappedNodeIds,
        unmatched
    };
}
// src/tree/index.ts
function buildChildrenIndex(tree) {
    const map = /* @__PURE__ */ new Map();
    for (const id of Object.keys(tree.nodes)){
        const n = tree.nodes[id];
        if (!n || n.parentId === null) continue;
        let arr = map.get(n.parentId);
        if (!arr) {
            arr = [];
            map.set(n.parentId, arr);
        }
        arr.push(id);
    }
    return map;
}
function subtreeIdsOf(rootId, childrenIndex) {
    const result = /* @__PURE__ */ new Set([
        rootId
    ]);
    const stack = [
        rootId
    ];
    while(stack.length > 0){
        const id = stack.pop();
        const kids = childrenIndex.get(id);
        if (!kids) continue;
        for (const k of kids)if (!result.has(k)) {
            result.add(k);
            stack.push(k);
        }
    }
    return result;
}
function ancestorIdsOf(tree, nodeId) {
    const result = /* @__PURE__ */ new Set();
    let cur = tree.nodes[nodeId]?.parentId ?? null;
    while(cur !== null){
        if (result.has(cur)) break;
        result.add(cur);
        cur = tree.nodes[cur]?.parentId ?? null;
    }
    return result;
}
var EMPTY_NODE_ID_SET = /* @__PURE__ */ new Set();
function countLeavesInSubtree(rootId, tree, childrenIndex) {
    let count = 0;
    const stack = [
        rootId
    ];
    while(stack.length > 0){
        const id = stack.pop();
        const n = tree.nodes[id];
        if (!n) continue;
        if (n.isLeaf) {
            count++;
            continue;
        }
        const kids = childrenIndex.get(id);
        if (kids) for (const k of kids)stack.push(k);
    }
    return count;
}
function leafIdsOf(tree, opts = {}) {
    const childrenIndex = opts.childrenIndex ?? buildChildrenIndex(tree);
    const out = [];
    const visit = (id)=>{
        const n = tree.nodes[id];
        if (!n) return;
        if (n.isLeaf) {
            out.push(id);
            return;
        }
        const kids = childrenIndex.get(id);
        if (kids) for (const k of kids)visit(k);
    };
    visit(opts.rootId ?? tree.rootId);
    return out;
}
function leafGeneIds(tree) {
    const out = [];
    for (const id of leafIdsOf(tree)){
        const g = tree.nodes[id]?.geneId;
        if (g) out.push(g);
    }
    return out;
}
function pathToRoot(tree, nodeId) {
    const path = [];
    const seen = /* @__PURE__ */ new Set();
    let cur = tree.nodes[nodeId] ? nodeId : null;
    while(cur !== null && !seen.has(cur)){
        seen.add(cur);
        path.push(cur);
        cur = tree.nodes[cur]?.parentId ?? null;
    }
    return path;
}
function lca(tree, ids) {
    let common = null;
    for (const id of ids){
        const path = pathToRoot(tree, id);
        if (path.length === 0) return null;
        if (common === null) {
            common = path;
            continue;
        }
        const inPath = new Set(path);
        const idx = common.findIndex((x)=>inPath.has(x));
        if (idx < 0) return null;
        common = common.slice(idx);
    }
    return common ? common[0] ?? null : null;
}
function depthOf(tree, nodeId) {
    if (!tree.nodes[nodeId]) return NaN;
    let d = 0;
    for (const id of pathToRoot(tree, nodeId)){
        const n = tree.nodes[id];
        if (n.parentId !== null) d += n.distance;
    }
    return d;
}
function nodeHeights(tree, childrenIndex = buildChildrenIndex(tree)) {
    const rootDist = {};
    let max = 0;
    const stack = [
        [
            tree.rootId,
            0
        ]
    ];
    while(stack.length > 0){
        const [id, d] = stack.pop();
        const n = tree.nodes[id];
        if (!n) continue;
        rootDist[id] = d;
        if (d > max) max = d;
        const kids = childrenIndex.get(id);
        if (kids) for (const k of kids)stack.push([
            k,
            d + (tree.nodes[k]?.distance ?? 0)
        ]);
    }
    const heights = {};
    for (const id of Object.keys(rootDist))heights[id] = max - rootDist[id];
    return {
        heights,
        maxHeight: max
    };
}
function validateTree(tree) {
    const problems = [];
    const root = tree.nodes[tree.rootId];
    if (!root) {
        problems.push(`root "${tree.rootId}" is not in nodes`);
        return problems;
    }
    if (root.parentId !== null) problems.push(`root "${tree.rootId}" has a parent`);
    const childrenIndex = buildChildrenIndex(tree);
    let leaves = 0;
    for (const id of Object.keys(tree.nodes)){
        const n = tree.nodes[id];
        if (n.id !== id) problems.push(`node keyed "${id}" has id "${n.id}"`);
        if (n.parentId !== null && !tree.nodes[n.parentId]) problems.push(`node "${id}" has unknown parent "${n.parentId}"`);
        const kids = childrenIndex.get(id);
        if (n.isLeaf) {
            leaves++;
            if (kids && kids.length > 0) problems.push(`leaf "${id}" has ${kids.length} children`);
        } else if (!kids || kids.length === 0) problems.push(`internal node "${id}" has no children`);
    }
    if (leaves === 0) problems.push("tree has no leaves");
    const reachable = subtreeIdsOf(tree.rootId, childrenIndex);
    for (const id of Object.keys(tree.nodes))if (!reachable.has(id)) problems.push(`node "${id}" is not reachable from the root`);
    for (const id of Object.keys(tree.nodes)){
        const seen = /* @__PURE__ */ new Set();
        let cur = id;
        while(cur !== null){
            if (seen.has(cur)) {
                problems.push(`cycle through "${cur}"`);
                break;
            }
            seen.add(cur);
            cur = tree.nodes[cur]?.parentId ?? null;
        }
    }
    return problems;
}
function assertValidTree(tree) {
    const problems = validateTree(tree);
    if (problems.length > 0) throw new Error(`Invalid tree: ${problems.join("; ")}`);
}
function isLeafNode(node) {
    return !!node && node.isLeaf;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1Bebw":[function(require,module,exports,__globalThis) {
// src/genotype/encoding.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_SEP_PHASED", ()=>DEFAULT_SEP_PHASED) //# sourceMappingURL=chunk-NFAGMBWM.js.map
;
parcelHelpers.export(exports, "DEFAULT_SEP_UNPHASED", ()=>DEFAULT_SEP_UNPHASED);
parcelHelpers.export(exports, "DEFAULT_UNKNOWN", ()=>DEFAULT_UNKNOWN);
parcelHelpers.export(exports, "DOSAGE_L1_MEAN", ()=>DOSAGE_L1_MEAN);
parcelHelpers.export(exports, "averageDosage", ()=>averageDosage);
parcelHelpers.export(exports, "colorForAverageDosage", ()=>colorForAverageDosage);
parcelHelpers.export(exports, "colorForCall", ()=>colorForCall);
parcelHelpers.export(exports, "decodeCall", ()=>decodeCall);
parcelHelpers.export(exports, "distanceMatrix", ()=>distanceMatrix);
parcelHelpers.export(exports, "dosagesFromCalls", ()=>dosagesFromCalls);
parcelHelpers.export(exports, "dosagesFromGenotypeMatrix", ()=>dosagesFromGenotypeMatrix);
parcelHelpers.export(exports, "upgma", ()=>upgma);
parcelHelpers.export(exports, "upgmaFromCalls", ()=>upgmaFromCalls);
var DEFAULT_SEP_PHASED = "|";
var DEFAULT_SEP_UNPHASED = "/";
var DEFAULT_UNKNOWN = ".";
function decodeCall(raw, sepPhased = DEFAULT_SEP_PHASED, sepUnphased = DEFAULT_SEP_UNPHASED, unknown = DEFAULT_UNKNOWN) {
    if (!raw || raw.length === 0) return {
        alleles: [
            -1,
            -1
        ],
        phased: false,
        altDosage: 0,
        missing: true
    };
    const phased = raw.indexOf(sepPhased) >= 0;
    const sep = phased ? sepPhased : sepUnphased;
    const parts = raw.split(sep);
    const alleles = [];
    let missing = false;
    let altDosage = 0;
    for (const p of parts){
        if (p === unknown || p === "") {
            alleles.push(-1);
            missing = true;
            continue;
        }
        const n = Number(p);
        if (!Number.isFinite(n) || n < 0) {
            alleles.push(-1);
            missing = true;
            continue;
        }
        alleles.push(n);
        if (n > 0) altDosage++;
    }
    return {
        alleles,
        phased,
        altDosage,
        missing
    };
}
function colorForCall(call) {
    if (call.missing && call.altDosage === 0) return "#e3e3e3";
    if (call.altDosage === 0) return "#f5f7fa";
    if (call.altDosage === 1) return "#7fa8d8";
    return "#284b80";
}
function averageDosage(matrix, geneIds, variantIdx, sepPhased = matrix.sepPhased ?? DEFAULT_SEP_PHASED, sepUnphased = matrix.sepUnphased ?? DEFAULT_SEP_UNPHASED, unknown = matrix.unknownString ?? DEFAULT_UNKNOWN) {
    let total = 0;
    let n = 0;
    for (const id of geneIds){
        const row = matrix.callsByGeneId[id];
        if (!row) continue;
        const call = decodeCall(row[variantIdx], sepPhased, sepUnphased, unknown);
        if (call.missing && call.altDosage === 0) continue;
        total += call.altDosage;
        n++;
    }
    if (n === 0) return null;
    return total / n;
}
function colorForAverageDosage(d) {
    if (d <= 1) {
        const t2 = d;
        return mix("#f5f7fa", "#7fa8d8", t2);
    }
    const t = d - 1;
    return mix("#7fa8d8", "#284b80", t);
}
function mix(a, b, t) {
    const ar = parseInt(a.slice(1, 3), 16);
    const ag = parseInt(a.slice(3, 5), 16);
    const ab = parseInt(a.slice(5, 7), 16);
    const br = parseInt(b.slice(1, 3), 16);
    const bg = parseInt(b.slice(3, 5), 16);
    const bb = parseInt(b.slice(5, 7), 16);
    const r = Math.round(ar + (br - ar) * t);
    const g = Math.round(ag + (bg - ag) * t);
    const bl = Math.round(ab + (bb - ab) * t);
    return `rgb(${r},${g},${bl})`;
}
// src/cluster/upgma.ts
var DOSAGE_L1_MEAN = "dosage_l1_mean";
function dosagesFromCalls(calls, samples, variantPositions) {
    const sIdx = /* @__PURE__ */ new Map();
    samples.forEach((s, i)=>sIdx.set(s, i));
    const vIdx = /* @__PURE__ */ new Map();
    variantPositions.forEach((p, i)=>vIdx.set(p, i));
    const n = variantPositions.length * samples.length;
    const arr = new Float32Array(n);
    arr.fill(NaN);
    for (const c of calls){
        const gt = c.GT;
        if (!gt || gt.length === 0) continue;
        let alt = 0, tot = 0;
        for (const a of gt){
            if (a === null) continue;
            tot++;
            if (a !== 0) alt++;
        }
        if (tot === 0) continue;
        const v = vIdx.get(c.pos);
        const s = sIdx.get(c.sample);
        if (v === void 0 || s === void 0) continue;
        arr[v * samples.length + s] = alt / tot;
    }
    return arr;
}
function dosagesFromGenotypeMatrix(matrix, samples) {
    const names = samples ? [
        ...samples
    ] : Object.keys(matrix.callsByGeneId);
    const numVariants = matrix.variants.length;
    const numSamples = names.length;
    const dosages = new Float32Array(numVariants * numSamples);
    dosages.fill(NaN);
    const sepPhased = matrix.sepPhased ?? DEFAULT_SEP_PHASED;
    const sepUnphased = matrix.sepUnphased ?? DEFAULT_SEP_UNPHASED;
    const unknown = matrix.unknownString ?? DEFAULT_UNKNOWN;
    for(let s = 0; s < numSamples; s++){
        const row = matrix.callsByGeneId[names[s]];
        if (!row) continue;
        for(let v = 0; v < numVariants; v++){
            const call = decodeCall(row[v], sepPhased, sepUnphased, unknown);
            let called = 0;
            for (const a of call.alleles)if (a >= 0) called++;
            if (called === 0) continue;
            dosages[v * numSamples + s] = call.altDosage / called;
        }
    }
    return {
        dosages,
        samples: names,
        numVariants
    };
}
function distanceMatrix(dosages, numSamples, numVariants) {
    const m = new Float32Array(numSamples * numSamples);
    for(let i = 0; i < numSamples; i++)for(let j = i + 1; j < numSamples; j++){
        let sum = 0, count = 0;
        for(let v = 0; v < numVariants; v++){
            const di = dosages[v * numSamples + i];
            const dj = dosages[v * numSamples + j];
            if (Number.isNaN(di) || Number.isNaN(dj)) continue;
            sum += Math.abs(di - dj);
            count++;
        }
        const d = count === 0 ? 0 : sum / count;
        m[i * numSamples + j] = d;
        m[j * numSamples + i] = d;
    }
    return m;
}
function upgma(samples, dist, opts = {}) {
    const n = samples.length;
    if (n === 0) throw new Error("upgma: no samples");
    const prefix = opts.idPrefix ?? "";
    let root;
    if (n === 1) root = {
        kind: "leaf",
        index: 0,
        height: 0,
        size: 1
    };
    else {
        const clusters = samples.map((_, i)=>({
                kind: "leaf",
                index: i,
                height: 0,
                size: 1
            }));
        const m = [];
        for(let i = 0; i < n; i++){
            m[i] = new Array(n);
            for(let j = 0; j < n; j++)m[i][j] = dist[i * n + j];
        }
        let active = clusters.length;
        const aliveIdx = clusters.map((_, i)=>i);
        let merges = 0;
        while(active > 1){
            let minA = 0, minB = 1, minD = Infinity;
            for(let a = 0; a < active; a++)for(let b = a + 1; b < active; b++){
                const d = m[aliveIdx[a]][aliveIdx[b]];
                if (d < minD) {
                    minD = d;
                    minA = a;
                    minB = b;
                }
            }
            const i = aliveIdx[minA];
            const j = aliveIdx[minB];
            const ci = clusters[i];
            const cj = clusters[j];
            const merged = {
                kind: "internal",
                left: ci,
                right: cj,
                height: minD / 2,
                size: ci.size + cj.size,
                order: merges++
            };
            clusters[i] = merged;
            for(let k = 0; k < active; k++){
                if (k === minA || k === minB) continue;
                const ki = aliveIdx[k];
                const dNew = (ci.size * m[i][ki] + cj.size * m[j][ki]) / (ci.size + cj.size);
                m[i][ki] = dNew;
                m[ki][i] = dNew;
            }
            aliveIdx.splice(minB, 1);
            active--;
        }
        root = clusters[aliveIdx[0]];
    }
    const nodes = {};
    const heights = {};
    const leafOrder = [];
    let maxHeight = 0;
    const visit = (c, parentId, parentHeight)=>{
        const distance = parentId === null ? 0 : parentHeight - c.height;
        if (c.kind === "leaf") {
            const id2 = `${prefix}l${c.index}`;
            nodes[id2] = {
                id: id2,
                parentId,
                distance,
                isLeaf: true,
                geneId: samples[c.index]
            };
            heights[id2] = 0;
            leafOrder.push(samples[c.index]);
            return id2;
        }
        const id = `${prefix}c${c.order}`;
        nodes[id] = {
            id,
            parentId,
            distance,
            isLeaf: false
        };
        heights[id] = c.height;
        if (c.height > maxHeight) maxHeight = c.height;
        visit(c.left, id, c.height);
        visit(c.right, id, c.height);
        return id;
    };
    const rootId = visit(root, null, root.height);
    return {
        tree: {
            rootId,
            nodes
        },
        heights,
        leafOrder,
        maxHeight,
        method: "upgma",
        metric: DOSAGE_L1_MEAN
    };
}
function upgmaFromCalls(calls, samples, variantPositions) {
    const dosages = dosagesFromCalls(calls, samples, variantPositions);
    const dist = distanceMatrix(dosages, samples.length, variantPositions.length);
    return upgma(samples, dist);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4knjt":[function(require,module,exports,__globalThis) {
// src/fetch/retry.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpError", ()=>HttpError) //# sourceMappingURL=chunk-LPNPUTTS.js.map
;
parcelHelpers.export(exports, "RETRYABLE_STATUS", ()=>RETRYABLE_STATUS);
parcelHelpers.export(exports, "backoffMs", ()=>backoffMs);
parcelHelpers.export(exports, "buildUrl", ()=>buildUrl);
parcelHelpers.export(exports, "chunk", ()=>chunk);
parcelHelpers.export(exports, "defaultFetch", ()=>defaultFetch);
parcelHelpers.export(exports, "fanOut", ()=>fanOut);
parcelHelpers.export(exports, "fanOutChunks", ()=>fanOutChunks);
parcelHelpers.export(exports, "fetchWithRetry", ()=>fetchWithRetry);
parcelHelpers.export(exports, "getJson", ()=>getJson);
parcelHelpers.export(exports, "mergeRecords", ()=>mergeRecords);
parcelHelpers.export(exports, "splitUrl", ()=>splitUrl);
parcelHelpers.export(exports, "withRetry", ()=>withRetry);
var RETRYABLE_STATUS = /* @__PURE__ */ new Set([
    429,
    500,
    502,
    503,
    504,
    520,
    522,
    524
]);
var sleep = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
function defaultFetch(input, init) {
    const f = globalThis.fetch;
    if (typeof f !== "function") return Promise.reject(new Error("No global fetch available; pass `fetch` in the options"));
    return globalThis.fetch(input, init);
}
function backoffMs(attempt, baseDelayMs, retryAfter, maxDelayMs = 8e3) {
    if (retryAfter) {
        const secs = Number(retryAfter);
        if (Number.isFinite(secs) && secs >= 0) return Math.min(secs * 1e3, 3e4);
    }
    const capped = Math.min(baseDelayMs * 2 ** attempt, maxDelayMs);
    return Math.round(capped * (0.5 + Math.random() * 0.5));
}
async function fetchWithRetry(url, init = {}, opts = {}) {
    const { attempts = 4, baseDelayMs = 500, maxDelayMs = 8e3, retryable = RETRYABLE_STATUS, fetch = defaultFetch } = opts;
    let lastError = null;
    for(let attempt = 0; attempt < attempts; attempt++)try {
        const res = await fetch(url, init);
        if (res.ok || !retryable.has(res.status)) return res;
        if (attempt === attempts - 1) return res;
        await sleep(backoffMs(attempt, baseDelayMs, res.headers.get("Retry-After"), maxDelayMs));
    } catch (err) {
        lastError = err;
        if (attempt === attempts - 1) break;
        await sleep(backoffMs(attempt, baseDelayMs, null, maxDelayMs));
    }
    throw lastError instanceof Error ? lastError : new Error(`Network error fetching ${url}`);
}
function withRetry(fetch, opts = {}) {
    return (input, init)=>fetchWithRetry(input, init, {
            ...opts,
            fetch
        });
}
// src/fetch/json.ts
var HttpError = class extends Error {
    constructor(status, url, bodyText){
        super(`HTTP ${status} for ${url}`);
        this.name = "HttpError";
        this.status = status;
        this.url = url;
        if (bodyText !== void 0) this.bodyText = bodyText;
    }
};
async function getJson(url, opts = {}) {
    const fetch = opts.fetch ?? defaultFetch;
    const init = {
        headers: {
            Accept: "application/json",
            ...opts.headers
        },
        ...opts.signal !== void 0 ? {
            signal: opts.signal
        } : {}
    };
    const res = await fetch(url, init);
    if (!res.ok) {
        let bodyText;
        try {
            bodyText = await res.text();
        } catch  {
            bodyText = void 0;
        }
        throw new HttpError(res.status, url, bodyText);
    }
    return await res.json();
}
function buildUrl(base, path, params = {}) {
    let joined;
    if (path === "") joined = base;
    else {
        const b = base.endsWith("/") ? base.slice(0, -1) : base;
        const p = path.startsWith("/") ? path : `/${path}`;
        joined = b + p;
    }
    const qs = new URLSearchParams();
    for (const [key, value] of Object.entries(params)){
        if (value === void 0) continue;
        if (Array.isArray(value)) for (const v of value)qs.append(key, String(v));
        else qs.append(key, String(value));
    }
    const query = qs.toString();
    if (query === "") return joined;
    return joined + (joined.includes("?") ? "&" : "?") + query;
}
function splitUrl(url) {
    const q = url.indexOf("?");
    if (q === -1) return {
        path: url,
        params: new URLSearchParams()
    };
    return {
        path: url.slice(0, q),
        params: new URLSearchParams(url.slice(q + 1))
    };
}
// src/fetch/fanOut.ts
var errorMessage = (err)=>err instanceof Error ? err.message : String(err);
async function runPool(items, concurrency, outer, settle) {
    let cursor = 0;
    const worker = async ()=>{
        while(cursor < items.length){
            const item = items[cursor++];
            if (outer?.aborted) {
                await settle(item, null);
                continue;
            }
            const ctrl = new AbortController();
            const onAbort = ()=>ctrl.abort(outer?.reason);
            outer?.addEventListener("abort", onAbort, {
                once: true
            });
            try {
                await settle(item, ctrl.signal);
            } finally{
                outer?.removeEventListener("abort", onAbort);
            }
        }
    };
    const n = Math.max(1, Math.min(Math.floor(concurrency), items.length));
    await Promise.all(Array.from({
        length: n
    }, ()=>worker()));
}
async function fanOut(keys, worker, opts = {}) {
    const total = keys.length;
    const results = {};
    const errors = {};
    let done = 0;
    let failed = 0;
    let lastError = null;
    const fail = (key, msg)=>{
        errors[key] = msg;
        failed++;
        lastError = msg;
    };
    await runPool(keys, opts.concurrency ?? 6, opts.signal, async (key, signal)=>{
        if (signal === null) fail(key, "aborted");
        else try {
            results[key] = await worker(key, signal);
        } catch (err) {
            fail(key, errorMessage(err));
        }
        done++;
        opts.onProgress?.({
            done,
            total,
            failed
        });
    });
    return {
        results,
        errors,
        progress: {
            done,
            total,
            failed
        },
        lastError
    };
}
function chunk(items, size) {
    const n = Math.max(1, Math.floor(size));
    const out = [];
    for(let i = 0; i < items.length; i += n)out.push(items.slice(i, i + n));
    return out;
}
async function fanOutChunks(keys, size, worker, opts = {}) {
    const total = keys.length;
    const chunks = chunk(keys, size);
    const results = {};
    const errors = {};
    let done = 0;
    let failed = 0;
    let lastError = null;
    const failChunk = (part, msg)=>{
        for (const key of part)errors[key] = msg;
        failed += part.length;
        lastError = msg;
    };
    await runPool(chunks, opts.concurrency ?? 6, opts.signal, async (part, signal)=>{
        if (signal === null) failChunk(part, "aborted");
        else try {
            Object.assign(results, await worker(part, signal));
        } catch (err) {
            failChunk(part, errorMessage(err));
        }
        done += part.length;
        opts.onProgress?.({
            done,
            total,
            failed
        });
    });
    return {
        results,
        errors,
        progress: {
            done,
            total,
            failed
        },
        lastError
    };
}
function mergeRecords(...parts) {
    const out = {};
    for (const part of parts)if (part !== void 0) Object.assign(out, part);
    return out;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e3cof":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EMPTY_VIEW_STATE", ()=>EMPTY_VIEW_STATE) //# sourceMappingURL=chunk-L3UJS2UA.js.map
;
parcelHelpers.export(exports, "LEAF_ROW_HEIGHT", ()=>LEAF_ROW_HEIGHT);
parcelHelpers.export(exports, "SUMMARY_ROW_HEIGHT", ()=>SUMMARY_ROW_HEIGHT);
parcelHelpers.export(exports, "applyPivot", ()=>applyPivot);
parcelHelpers.export(exports, "buildInitialViewState", ()=>buildInitialViewState);
parcelHelpers.export(exports, "computeRowRange", ()=>computeRowRange);
parcelHelpers.export(exports, "computeVisibleRows", ()=>computeVisibleRows);
parcelHelpers.export(exports, "createDerivedPruneLayer", ()=>createDerivedPruneLayer);
parcelHelpers.export(exports, "decodeHashState", ()=>decodeHashState);
parcelHelpers.export(exports, "encodeHashState", ()=>encodeHashState);
parcelHelpers.export(exports, "ensureZones", ()=>ensureZones);
parcelHelpers.export(exports, "isViewStateLike", ()=>isViewStateLike);
parcelHelpers.export(exports, "mergeDerivedPrunes", ()=>mergeDerivedPrunes);
parcelHelpers.export(exports, "normalizeViewState", ()=>normalizeViewState);
parcelHelpers.export(exports, "pixelWidthsToFr", ()=>pixelWidthsToFr);
parcelHelpers.export(exports, "readHashState", ()=>readHashState);
parcelHelpers.export(exports, "softResetForNewTree", ()=>softResetForNewTree);
parcelHelpers.export(exports, "stripDerivedPrunes", ()=>stripDerivedPrunes);
parcelHelpers.export(exports, "stripPrunesForSnapshot", ()=>stripPrunesForSnapshot);
parcelHelpers.export(exports, "writeHashState", ()=>writeHashState);
var _chunkF6Q2MMZHJs = require("./chunk-F6Q2MMZH.js");
// src/view/initial.ts
var EMPTY_VIEW_STATE = Object.freeze({
    selectedNodeId: null,
    collapsedNodeIds: [],
    prunedNodeIds: [],
    swappedNodeIds: [],
    compressedNodeIds: [],
    nodeOfInterestId: null,
    zones: [],
    zoneStates: {},
    search: null
});
function isPlainObject(v) {
    return typeof v === "object" && v !== null && !Array.isArray(v);
}
function buildInitialViewState(zones, opts = {}) {
    const data = opts.data;
    const zoneStates = {};
    for (const z of zones)zoneStates[z.id] = z.defaultZoneState;
    if (opts.zoneStates) for (const [id, supplied] of Object.entries(opts.zoneStates)){
        const seeded = zoneStates[id];
        zoneStates[id] = isPlainObject(seeded) && isPlainObject(supplied) ? {
            ...seeded,
            ...supplied
        } : supplied;
    }
    let collapsedFromPivot = [];
    let swappedFromPivot = [];
    let nodeOfInterestId = null;
    if (opts.nodeOfInterest && data) {
        const pivot = (0, _chunkF6Q2MMZHJs.computePivotState)(data.tree, opts.nodeOfInterest);
        if (pivot) {
            collapsedFromPivot = pivot.collapsedNodeIds;
            swappedFromPivot = pivot.swappedNodeIds;
            nodeOfInterestId = pivot.targetId;
        }
    }
    const claimed = /* @__PURE__ */ new Set();
    const zoneEntries = zones.map((z)=>{
        let visible = (z.defaultVisible ?? true) && (data ? z.isAvailable(data) : true);
        const forced = opts.visible?.[z.id];
        if (forced !== void 0) visible = forced;
        if (visible && z.exclusiveGroup) {
            if (claimed.has(z.exclusiveGroup)) visible = false;
            else claimed.add(z.exclusiveGroup);
        }
        return {
            id: z.id,
            width: opts.widths?.[z.id] ?? z.defaultWidth,
            visible
        };
    });
    return {
        ...EMPTY_VIEW_STATE,
        collapsedNodeIds: collapsedFromPivot,
        swappedNodeIds: swappedFromPivot,
        nodeOfInterestId,
        zones: zoneEntries,
        zoneStates,
        ...opts.overrides
    };
}
function applyPivot(vs, pivot) {
    if (!pivot) return vs;
    return {
        ...vs,
        collapsedNodeIds: pivot.collapsedNodeIds,
        swappedNodeIds: pivot.swappedNodeIds,
        nodeOfInterestId: pivot.targetId
    };
}
function softResetForNewTree(vs) {
    return {
        ...vs,
        selectedNodeId: null,
        collapsedNodeIds: [],
        prunedNodeIds: [],
        swappedNodeIds: [],
        compressedNodeIds: [],
        nodeOfInterestId: null,
        search: null
    };
}
function ensureZones(vs, zones) {
    const known = /* @__PURE__ */ new Map();
    for (const z of zones)known.set(z.id, z);
    const current = vs.zones ?? [];
    const kept = current.filter((entry)=>known.has(entry.id));
    const present = new Set(kept.map((entry)=>entry.id));
    const appended = [];
    for (const z of zones){
        if (present.has(z.id)) continue;
        present.add(z.id);
        appended.push({
            id: z.id,
            width: z.defaultWidth,
            visible: z.defaultVisible ?? true
        });
    }
    if (kept.length === current.length && appended.length === 0) return vs;
    return {
        ...vs,
        zones: [
            ...kept,
            ...appended
        ]
    };
}
function idArray(v) {
    return Array.isArray(v) ? v.filter((x)=>typeof x === "string") : [];
}
function stringArray(v) {
    return Array.isArray(v) ? v.filter((x)=>typeof x === "string") : void 0;
}
function nodeIdOrNull(v) {
    return typeof v === "string" ? v : null;
}
var FALLBACK_ZONE_WIDTH = 25;
function normalizeZones(v) {
    if (!Array.isArray(v)) return [];
    const out = [];
    for (const raw of v){
        if (!isPlainObject(raw) || typeof raw["id"] !== "string") continue;
        const width = raw["width"];
        const visible = raw["visible"];
        const userToggled = raw["userToggled"];
        out.push({
            id: raw["id"],
            width: typeof width === "number" && Number.isFinite(width) ? width : FALLBACK_ZONE_WIDTH,
            visible: typeof visible === "boolean" ? visible : true,
            ...typeof userToggled === "boolean" ? {
                userToggled
            } : {}
        });
    }
    return out;
}
function normalizeSearch(v) {
    if (!isPlainObject(v) || typeof v["query"] !== "string") return null;
    const excludedFields = stringArray(v["excludedFields"]);
    const caseSensitive = v["caseSensitive"];
    const regex = v["regex"];
    return {
        query: v["query"],
        ...excludedFields !== void 0 ? {
            excludedFields
        } : {},
        ...typeof caseSensitive === "boolean" ? {
            caseSensitive
        } : {},
        ...typeof regex === "boolean" ? {
            regex
        } : {}
    };
}
function normalizeViewState(input, zones) {
    const src = isPlainObject(input) ? input : {};
    const rowHeight = src["rowHeight"];
    const fontSize = src["fontSize"];
    const unlinkedZoneGroups = stringArray(src["unlinkedZoneGroups"]);
    const zoneStates = src["zoneStates"];
    const vs = {
        selectedNodeId: nodeIdOrNull(src["selectedNodeId"]),
        collapsedNodeIds: idArray(src["collapsedNodeIds"]),
        prunedNodeIds: idArray(src["prunedNodeIds"]),
        swappedNodeIds: idArray(src["swappedNodeIds"]),
        compressedNodeIds: idArray(src["compressedNodeIds"]),
        nodeOfInterestId: nodeIdOrNull(src["nodeOfInterestId"]),
        zones: normalizeZones(src["zones"]),
        zoneStates: isPlainObject(zoneStates) ? zoneStates : {},
        ...typeof rowHeight === "number" && Number.isFinite(rowHeight) ? {
            rowHeight
        } : {},
        ...typeof fontSize === "number" && Number.isFinite(fontSize) ? {
            fontSize
        } : {},
        ...unlinkedZoneGroups !== void 0 ? {
            unlinkedZoneGroups
        } : {},
        search: normalizeSearch(src["search"])
    };
    return zones ? ensureZones(vs, zones) : vs;
}
function pixelWidthsToFr(targetPx, containerPx, flexZoneId, minFlexPx = 160) {
    const out = {};
    let used = 0;
    for (const [id, px] of Object.entries(targetPx)){
        if (id === flexZoneId) continue;
        out[id] = px;
        used += px;
    }
    out[flexZoneId] = Math.max(minFlexPx, containerPx - used);
    return out;
}
// src/view/hash.ts
function encodeHashState(state) {
    return "#" + encodeURIComponent(JSON.stringify(state));
}
function decodeHashState(hash, guard) {
    const raw = hash.startsWith("#") ? hash.slice(1) : hash;
    if (!raw) return null;
    let parsed;
    try {
        parsed = JSON.parse(decodeURIComponent(raw));
    } catch  {
        return null;
    }
    if (!parsed || typeof parsed !== "object") return null;
    if (guard && !guard(parsed)) return null;
    return parsed;
}
function readHashState(guard) {
    const g = globalThis;
    if (!g.location) return null;
    return decodeHashState(g.location.hash, guard);
}
function writeHashState(state, mode = "replace") {
    const g = globalThis;
    if (!g.location || !g.history) return;
    const next = encodeHashState(state);
    if (g.location.hash === next) return;
    const url = (g.location.pathname ?? "") + (g.location.search ?? "") + next;
    if (mode === "push") g.history.pushState(null, "", url);
    else g.history.replaceState(null, "", url);
}
function isViewStateLike(v) {
    if (typeof v !== "object" || v === null || Array.isArray(v)) return false;
    const o = v;
    for (const key of [
        "collapsedNodeIds",
        "prunedNodeIds",
        "swappedNodeIds",
        "compressedNodeIds",
        "zones",
        "unlinkedZoneGroups"
    ]){
        if (key in o && o[key] !== void 0 && !Array.isArray(o[key])) return false;
    }
    if ("zoneStates" in o && o["zoneStates"] !== void 0) {
        const zs = o["zoneStates"];
        if (typeof zs !== "object" || zs === null || Array.isArray(zs)) return false;
    }
    if ("search" in o && o["search"] !== void 0 && o["search"] !== null) {
        const s = o["search"];
        if (typeof s !== "object" || typeof s["query"] !== "string") return false;
    }
    return true;
}
// src/view/derivedPrune.ts
function mergeDerivedPrunes(vs, derived) {
    if (derived.length === 0) return vs;
    const seen = /* @__PURE__ */ new Set();
    const merged = [];
    for (const id of vs.prunedNodeIds ?? []){
        if (seen.has(id)) continue;
        seen.add(id);
        merged.push(id);
    }
    for (const id of derived){
        if (seen.has(id)) continue;
        seen.add(id);
        merged.push(id);
    }
    return {
        ...vs,
        prunedNodeIds: merged
    };
}
function stripDerivedPrunes(vs, derived) {
    if (derived.length === 0) return vs;
    const derivedSet = new Set(derived);
    return {
        ...vs,
        prunedNodeIds: (vs.prunedNodeIds ?? []).filter((id)=>!derivedSet.has(id))
    };
}
function createDerivedPruneLayer(derived) {
    return {
        derived,
        effective: (vs)=>mergeDerivedPrunes(vs, derived),
        onChange: (next)=>stripDerivedPrunes(next, derived)
    };
}
function stripPrunesForSnapshot(vs) {
    return {
        ...vs,
        prunedNodeIds: []
    };
}
// src/view/visibleRows.ts
var LEAF_ROW_HEIGHT = 24;
var SUMMARY_ROW_HEIGHT = 24;
function computeVisibleRows(input) {
    var _a;
    const { tree, collapsedNodeIds, prunedNodeIds, swappedNodeIds } = input;
    const leafHeight = input.rowHeight ?? LEAF_ROW_HEIGHT;
    const summaryHeight = input.rowHeight ?? SUMMARY_ROW_HEIGHT;
    const childrenOf = {};
    for (const node of Object.values(tree.nodes))if (node.parentId !== null) (childrenOf[_a = node.parentId] ?? (childrenOf[_a] = [])).push(node.id);
    const rows = [];
    let y = 0;
    const walk = (nodeId)=>{
        if (prunedNodeIds.has(nodeId)) return;
        const node = tree.nodes[nodeId];
        if (!node) return;
        if (collapsedNodeIds.has(nodeId) && !node.isLeaf) {
            const leafCount = countLeaves(nodeId, tree, prunedNodeIds, childrenOf);
            if (leafCount === 0) return;
            rows.push({
                kind: "collapsedSummary",
                nodeId,
                y,
                height: summaryHeight,
                leafCount
            });
            y += summaryHeight;
            return;
        }
        if (node.isLeaf) {
            rows.push({
                kind: "leaf",
                nodeId,
                y,
                height: leafHeight,
                leafCount: 1
            });
            y += leafHeight;
            return;
        }
        const kids = childrenOf[nodeId] ?? [];
        if (swappedNodeIds?.has(nodeId)) for(let i = kids.length - 1; i >= 0; i--)walk(kids[i]);
        else for (const childId of kids)walk(childId);
    };
    walk(tree.rootId);
    return rows;
}
function countLeaves(nodeId, tree, prunedNodeIds, childrenOf) {
    if (prunedNodeIds.has(nodeId)) return 0;
    const node = tree.nodes[nodeId];
    if (!node) return 0;
    if (node.isLeaf) return 1;
    let total = 0;
    for (const childId of childrenOf[nodeId] ?? [])total += countLeaves(childId, tree, prunedNodeIds, childrenOf);
    return total;
}
var DEFAULT_OVERSCAN = 5;
function computeRowRange(rows, scrollTop, viewportHeight, overscan = DEFAULT_OVERSCAN) {
    if (rows.length === 0 || viewportHeight === 0) return {
        startIndex: 0,
        endIndex: rows.length
    };
    let firstVisible = rows.length;
    for(let i = 0; i < rows.length; i++){
        const r = rows[i];
        if (r.y + r.height > scrollTop) {
            firstVisible = i;
            break;
        }
    }
    let lastVisible = firstVisible - 1;
    const viewportBottom = scrollTop + viewportHeight;
    for(let i = firstVisible; i < rows.length; i++){
        if (rows[i].y >= viewportBottom) break;
        lastVisible = i;
    }
    const startIndex = Math.max(0, firstVisible - overscan);
    const endIndex = Math.min(rows.length, lastVisible + 1 + overscan);
    return {
        startIndex,
        endIndex
    };
}

},{"./chunk-F6Q2MMZH.js":"kxqsj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eGIqJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "countsFromFacet", ()=>countsFromFacet) //# sourceMappingURL=chunk-ZSCNX7IQ.js.map
;
parcelHelpers.export(exports, "geneIdByLeafNodeId", ()=>geneIdByLeafNodeId);
parcelHelpers.export(exports, "joinByLeaf", ()=>joinByLeaf);
parcelHelpers.export(exports, "joinByTaxon", ()=>joinByTaxon);
parcelHelpers.export(exports, "leafNodeIdByGeneId", ()=>leafNodeIdByGeneId);
parcelHelpers.export(exports, "maxByNode", ()=>maxByNode);
parcelHelpers.export(exports, "rowFlags", ()=>rowFlags);
parcelHelpers.export(exports, "rowsInRange", ()=>rowsInRange);
parcelHelpers.export(exports, "rowsTotalHeight", ()=>rowsTotalHeight);
parcelHelpers.export(exports, "sumByNode", ()=>sumByNode);
var _chunkF6Q2MMZHJs = require("./chunk-F6Q2MMZH.js");
// src/zone/rows.ts
function rowFlags(row, s) {
    return {
        isSelected: s.selectedNodeId === row.nodeId,
        isExactHover: s.hoveredNodeId === row.nodeId,
        isInHoveredSubtree: !!(s.hoveredSubtreeIds && s.hoveredSubtreeIds.has(row.nodeId))
    };
}
function rowsTotalHeight(rows) {
    const last = rows[rows.length - 1];
    return last ? last.y + last.height : 0;
}
function rowsInRange(rows, range) {
    return rows.slice(range.startIndex, range.endIndex);
}
// src/zone/join.ts
function leafNodeIdByGeneId(tree) {
    const nodeOf = {};
    for (const n of Object.values(tree.nodes))if (n.isLeaf && n.geneId) nodeOf[n.geneId] = n.id;
    return nodeOf;
}
function geneIdByLeafNodeId(tree) {
    const nodeGene = {};
    for (const n of Object.values(tree.nodes))if (n.isLeaf && n.geneId) nodeGene[n.id] = n.geneId;
    return nodeGene;
}
function joinByLeaf(tree, byGeneId) {
    const nodeOf = leafNodeIdByGeneId(tree);
    const byNode = {};
    const unmatched = [];
    for (const geneId of Object.keys(byGeneId)){
        const nodeId = nodeOf[geneId];
        if (nodeId === void 0) {
            unmatched.push(geneId);
            continue;
        }
        byNode[nodeId] = byGeneId[geneId];
    }
    return {
        byNode,
        unmatched
    };
}
function joinByTaxon(tree, byTaxonId) {
    const byNode = {};
    const matched = /* @__PURE__ */ new Set();
    for (const n of Object.values(tree.nodes)){
        if (n.taxonomyId === void 0) continue;
        const key = String(n.taxonomyId);
        if (!Object.prototype.hasOwnProperty.call(byTaxonId, key)) continue;
        byNode[n.id] = byTaxonId[key];
        matched.add(key);
    }
    const unmatched = [];
    for (const key of Object.keys(byTaxonId))if (!matched.has(key)) unmatched.push(key);
    return {
        byNode,
        unmatched
    };
}
// src/zone/counts.ts
function leafCountsFromFacet(facet) {
    const leafCount = {};
    if (Array.isArray(facet)) for(let i = 0; i < facet.length; i += 2)leafCount[String(facet[i])] = Number(facet[i + 1]);
    return leafCount;
}
function countsFromFacet(tree, facet, key = "nodeId") {
    const leafCount = leafCountsFromFacet(facet);
    if (key === "nodeId") return (0, _chunkF6Q2MMZHJs.sumLeafCounts)(tree, leafCount);
    return (0, _chunkF6Q2MMZHJs.rollUp)(tree, (leaf)=>leaf.taxonomyId !== void 0 ? leafCount[String(leaf.taxonomyId)] || 0 : 0, (childValues)=>{
        let sum = 0;
        for (const v of childValues)sum += v;
        return sum;
    });
}
function sumByNode(tree, leafValues) {
    return (0, _chunkF6Q2MMZHJs.sumLeafCounts)(tree, leafValues);
}
function maxByNode(tree, leafValues) {
    return (0, _chunkF6Q2MMZHJs.rollUp)(tree, (leaf)=>leafValues[leaf.id] || 0, (childValues)=>{
        let max = 0;
        let first = true;
        for (const v of childValues){
            if (first || v > max) max = v;
            first = false;
        }
        return max;
    });
}

},{"./chunk-F6Q2MMZH.js":"kxqsj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jBmZO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Accordion", ()=>(0, _accordionDefault.default));
parcelHelpers.export(exports, "AccordionContext", ()=>(0, _accordionContextDefault.default));
parcelHelpers.export(exports, "AccordionCollapse", ()=>(0, _accordionCollapseDefault.default));
parcelHelpers.export(exports, "AccordionButton", ()=>(0, _accordionButtonDefault.default));
parcelHelpers.export(exports, "useAccordionButton", ()=>(0, _accordionButton.useAccordionButton));
parcelHelpers.export(exports, "AccordionBody", ()=>(0, _accordionBodyDefault.default));
parcelHelpers.export(exports, "AccordionHeader", ()=>(0, _accordionHeaderDefault.default));
parcelHelpers.export(exports, "AccordionItem", ()=>(0, _accordionItemDefault.default));
parcelHelpers.export(exports, "Alert", ()=>(0, _alertDefault.default));
parcelHelpers.export(exports, "AlertHeading", ()=>(0, _alertHeadingDefault.default));
parcelHelpers.export(exports, "AlertLink", ()=>(0, _alertLinkDefault.default));
parcelHelpers.export(exports, "Anchor", ()=>(0, _anchorDefault.default));
parcelHelpers.export(exports, "Badge", ()=>(0, _badgeDefault.default));
parcelHelpers.export(exports, "Breadcrumb", ()=>(0, _breadcrumbDefault.default));
parcelHelpers.export(exports, "BreadcrumbItem", ()=>(0, _breadcrumbItemDefault.default));
parcelHelpers.export(exports, "Button", ()=>(0, _buttonDefault.default));
parcelHelpers.export(exports, "ButtonGroup", ()=>(0, _buttonGroupDefault.default));
parcelHelpers.export(exports, "ButtonToolbar", ()=>(0, _buttonToolbarDefault.default));
parcelHelpers.export(exports, "Card", ()=>(0, _cardDefault.default));
parcelHelpers.export(exports, "CardBody", ()=>(0, _cardBodyDefault.default));
parcelHelpers.export(exports, "CardFooter", ()=>(0, _cardFooterDefault.default));
parcelHelpers.export(exports, "CardGroup", ()=>(0, _cardGroupDefault.default));
parcelHelpers.export(exports, "CardHeader", ()=>(0, _cardHeaderDefault.default));
parcelHelpers.export(exports, "CardImg", ()=>(0, _cardImgDefault.default));
parcelHelpers.export(exports, "CardImgOverlay", ()=>(0, _cardImgOverlayDefault.default));
parcelHelpers.export(exports, "CardLink", ()=>(0, _cardLinkDefault.default));
parcelHelpers.export(exports, "CardSubtitle", ()=>(0, _cardSubtitleDefault.default));
parcelHelpers.export(exports, "CardText", ()=>(0, _cardTextDefault.default));
parcelHelpers.export(exports, "CardTitle", ()=>(0, _cardTitleDefault.default));
parcelHelpers.export(exports, "Carousel", ()=>(0, _carouselDefault.default));
parcelHelpers.export(exports, "CarouselCaption", ()=>(0, _carouselCaptionDefault.default));
parcelHelpers.export(exports, "CarouselItem", ()=>(0, _carouselItemDefault.default));
parcelHelpers.export(exports, "CloseButton", ()=>(0, _closeButtonDefault.default));
parcelHelpers.export(exports, "Col", ()=>(0, _colDefault.default));
parcelHelpers.export(exports, "Collapse", ()=>(0, _collapseDefault.default));
parcelHelpers.export(exports, "Container", ()=>(0, _containerDefault.default));
parcelHelpers.export(exports, "Dropdown", ()=>(0, _dropdownDefault.default));
parcelHelpers.export(exports, "DropdownButton", ()=>(0, _dropdownButtonDefault.default));
parcelHelpers.export(exports, "DropdownDivider", ()=>(0, _dropdownDividerDefault.default));
parcelHelpers.export(exports, "DropdownHeader", ()=>(0, _dropdownHeaderDefault.default));
parcelHelpers.export(exports, "DropdownItem", ()=>(0, _dropdownItemDefault.default));
parcelHelpers.export(exports, "DropdownItemText", ()=>(0, _dropdownItemTextDefault.default));
parcelHelpers.export(exports, "DropdownMenu", ()=>(0, _dropdownMenuDefault.default));
parcelHelpers.export(exports, "DropdownToggle", ()=>(0, _dropdownToggleDefault.default));
parcelHelpers.export(exports, "Fade", ()=>(0, _fadeDefault.default));
parcelHelpers.export(exports, "Figure", ()=>(0, _figureDefault.default));
parcelHelpers.export(exports, "FigureCaption", ()=>(0, _figureCaptionDefault.default));
parcelHelpers.export(exports, "FigureImage", ()=>(0, _figureImageDefault.default));
parcelHelpers.export(exports, "Form", ()=>(0, _formDefault.default));
parcelHelpers.export(exports, "FormControl", ()=>(0, _formControlDefault.default));
parcelHelpers.export(exports, "FormCheck", ()=>(0, _formCheckDefault.default));
parcelHelpers.export(exports, "FormFloating", ()=>(0, _formFloatingDefault.default));
parcelHelpers.export(exports, "FloatingLabel", ()=>(0, _floatingLabelDefault.default));
parcelHelpers.export(exports, "FormGroup", ()=>(0, _formGroupDefault.default));
parcelHelpers.export(exports, "FormLabel", ()=>(0, _formLabelDefault.default));
parcelHelpers.export(exports, "FormText", ()=>(0, _formTextDefault.default));
parcelHelpers.export(exports, "FormSelect", ()=>(0, _formSelectDefault.default));
parcelHelpers.export(exports, "Image", ()=>(0, _imageDefault.default));
parcelHelpers.export(exports, "InputGroup", ()=>(0, _inputGroupDefault.default));
parcelHelpers.export(exports, "ListGroup", ()=>(0, _listGroupDefault.default));
parcelHelpers.export(exports, "ListGroupItem", ()=>(0, _listGroupItemDefault.default));
parcelHelpers.export(exports, "Modal", ()=>(0, _modalDefault.default));
parcelHelpers.export(exports, "ModalBody", ()=>(0, _modalBodyDefault.default));
parcelHelpers.export(exports, "ModalDialog", ()=>(0, _modalDialogDefault.default));
parcelHelpers.export(exports, "ModalFooter", ()=>(0, _modalFooterDefault.default));
parcelHelpers.export(exports, "ModalHeader", ()=>(0, _modalHeaderDefault.default));
parcelHelpers.export(exports, "ModalTitle", ()=>(0, _modalTitleDefault.default));
parcelHelpers.export(exports, "Nav", ()=>(0, _navDefault.default));
parcelHelpers.export(exports, "Navbar", ()=>(0, _navbarDefault.default));
parcelHelpers.export(exports, "NavbarBrand", ()=>(0, _navbarBrandDefault.default));
parcelHelpers.export(exports, "NavbarCollapse", ()=>(0, _navbarCollapseDefault.default));
parcelHelpers.export(exports, "NavbarOffcanvas", ()=>(0, _navbarOffcanvasDefault.default));
parcelHelpers.export(exports, "NavbarText", ()=>(0, _navbarTextDefault.default));
parcelHelpers.export(exports, "NavbarToggle", ()=>(0, _navbarToggleDefault.default));
parcelHelpers.export(exports, "NavDropdown", ()=>(0, _navDropdownDefault.default));
parcelHelpers.export(exports, "NavItem", ()=>(0, _navItemDefault.default));
parcelHelpers.export(exports, "NavLink", ()=>(0, _navLinkDefault.default));
parcelHelpers.export(exports, "Offcanvas", ()=>(0, _offcanvasDefault.default));
parcelHelpers.export(exports, "OffcanvasBody", ()=>(0, _offcanvasBodyDefault.default));
parcelHelpers.export(exports, "OffcanvasHeader", ()=>(0, _offcanvasHeaderDefault.default));
parcelHelpers.export(exports, "OffcanvasTitle", ()=>(0, _offcanvasTitleDefault.default));
parcelHelpers.export(exports, "OffcanvasToggling", ()=>(0, _offcanvasTogglingDefault.default));
parcelHelpers.export(exports, "Overlay", ()=>(0, _overlayDefault.default));
parcelHelpers.export(exports, "OverlayTrigger", ()=>(0, _overlayTriggerDefault.default));
parcelHelpers.export(exports, "PageItem", ()=>(0, _pageItemDefault.default));
parcelHelpers.export(exports, "Pagination", ()=>(0, _paginationDefault.default));
parcelHelpers.export(exports, "Placeholder", ()=>(0, _placeholderDefault.default));
parcelHelpers.export(exports, "PlaceholderButton", ()=>(0, _placeholderButtonDefault.default));
parcelHelpers.export(exports, "Popover", ()=>(0, _popoverDefault.default));
parcelHelpers.export(exports, "PopoverBody", ()=>(0, _popoverBodyDefault.default));
parcelHelpers.export(exports, "PopoverHeader", ()=>(0, _popoverHeaderDefault.default));
parcelHelpers.export(exports, "ProgressBar", ()=>(0, _progressBarDefault.default));
parcelHelpers.export(exports, "Ratio", ()=>(0, _ratioDefault.default));
parcelHelpers.export(exports, "Row", ()=>(0, _rowDefault.default));
parcelHelpers.export(exports, "Spinner", ()=>(0, _spinnerDefault.default));
parcelHelpers.export(exports, "SplitButton", ()=>(0, _splitButtonDefault.default));
parcelHelpers.export(exports, "SSRProvider", ()=>(0, _ssrproviderDefault.default));
parcelHelpers.export(exports, "Stack", ()=>(0, _stackDefault.default));
parcelHelpers.export(exports, "Tab", ()=>(0, _tabDefault.default));
parcelHelpers.export(exports, "TabContainer", ()=>(0, _tabContainerDefault.default));
parcelHelpers.export(exports, "TabContent", ()=>(0, _tabContentDefault.default));
parcelHelpers.export(exports, "Table", ()=>(0, _tableDefault.default));
parcelHelpers.export(exports, "TabPane", ()=>(0, _tabPaneDefault.default));
parcelHelpers.export(exports, "Tabs", ()=>(0, _tabsDefault.default));
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _themeProviderDefault.default));
parcelHelpers.export(exports, "Toast", ()=>(0, _toastDefault.default));
parcelHelpers.export(exports, "ToastBody", ()=>(0, _toastBodyDefault.default));
parcelHelpers.export(exports, "ToastContainer", ()=>(0, _toastContainerDefault.default));
parcelHelpers.export(exports, "ToastHeader", ()=>(0, _toastHeaderDefault.default));
parcelHelpers.export(exports, "ToggleButton", ()=>(0, _toggleButtonDefault.default));
parcelHelpers.export(exports, "ToggleButtonGroup", ()=>(0, _toggleButtonGroupDefault.default));
parcelHelpers.export(exports, "Tooltip", ()=>(0, _tooltipDefault.default));
var _accordion = require("./Accordion");
var _accordionDefault = parcelHelpers.interopDefault(_accordion);
var _accordionContext = require("./AccordionContext");
var _accordionContextDefault = parcelHelpers.interopDefault(_accordionContext);
var _accordionCollapse = require("./AccordionCollapse");
var _accordionCollapseDefault = parcelHelpers.interopDefault(_accordionCollapse);
var _accordionButton = require("./AccordionButton");
var _accordionButtonDefault = parcelHelpers.interopDefault(_accordionButton);
var _accordionBody = require("./AccordionBody");
var _accordionBodyDefault = parcelHelpers.interopDefault(_accordionBody);
var _accordionHeader = require("./AccordionHeader");
var _accordionHeaderDefault = parcelHelpers.interopDefault(_accordionHeader);
var _accordionItem = require("./AccordionItem");
var _accordionItemDefault = parcelHelpers.interopDefault(_accordionItem);
var _alert = require("./Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _alertHeading = require("./AlertHeading");
var _alertHeadingDefault = parcelHelpers.interopDefault(_alertHeading);
var _alertLink = require("./AlertLink");
var _alertLinkDefault = parcelHelpers.interopDefault(_alertLink);
var _anchor = require("./Anchor");
var _anchorDefault = parcelHelpers.interopDefault(_anchor);
var _badge = require("./Badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
var _breadcrumb = require("./Breadcrumb");
var _breadcrumbDefault = parcelHelpers.interopDefault(_breadcrumb);
var _breadcrumbItem = require("./BreadcrumbItem");
var _breadcrumbItemDefault = parcelHelpers.interopDefault(_breadcrumbItem);
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _buttonGroup = require("./ButtonGroup");
var _buttonGroupDefault = parcelHelpers.interopDefault(_buttonGroup);
var _buttonToolbar = require("./ButtonToolbar");
var _buttonToolbarDefault = parcelHelpers.interopDefault(_buttonToolbar);
var _card = require("./Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardBody = require("./CardBody");
var _cardBodyDefault = parcelHelpers.interopDefault(_cardBody);
var _cardFooter = require("./CardFooter");
var _cardFooterDefault = parcelHelpers.interopDefault(_cardFooter);
var _cardGroup = require("./CardGroup");
var _cardGroupDefault = parcelHelpers.interopDefault(_cardGroup);
var _cardHeader = require("./CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardImg = require("./CardImg");
var _cardImgDefault = parcelHelpers.interopDefault(_cardImg);
var _cardImgOverlay = require("./CardImgOverlay");
var _cardImgOverlayDefault = parcelHelpers.interopDefault(_cardImgOverlay);
var _cardLink = require("./CardLink");
var _cardLinkDefault = parcelHelpers.interopDefault(_cardLink);
var _cardSubtitle = require("./CardSubtitle");
var _cardSubtitleDefault = parcelHelpers.interopDefault(_cardSubtitle);
var _cardText = require("./CardText");
var _cardTextDefault = parcelHelpers.interopDefault(_cardText);
var _cardTitle = require("./CardTitle");
var _cardTitleDefault = parcelHelpers.interopDefault(_cardTitle);
var _carousel = require("./Carousel");
var _carouselDefault = parcelHelpers.interopDefault(_carousel);
var _carouselCaption = require("./CarouselCaption");
var _carouselCaptionDefault = parcelHelpers.interopDefault(_carouselCaption);
var _carouselItem = require("./CarouselItem");
var _carouselItemDefault = parcelHelpers.interopDefault(_carouselItem);
var _closeButton = require("./CloseButton");
var _closeButtonDefault = parcelHelpers.interopDefault(_closeButton);
var _col = require("./Col");
var _colDefault = parcelHelpers.interopDefault(_col);
var _collapse = require("./Collapse");
var _collapseDefault = parcelHelpers.interopDefault(_collapse);
var _container = require("./Container");
var _containerDefault = parcelHelpers.interopDefault(_container);
var _dropdown = require("./Dropdown");
var _dropdownDefault = parcelHelpers.interopDefault(_dropdown);
var _dropdownButton = require("./DropdownButton");
var _dropdownButtonDefault = parcelHelpers.interopDefault(_dropdownButton);
var _dropdownDivider = require("./DropdownDivider");
var _dropdownDividerDefault = parcelHelpers.interopDefault(_dropdownDivider);
var _dropdownHeader = require("./DropdownHeader");
var _dropdownHeaderDefault = parcelHelpers.interopDefault(_dropdownHeader);
var _dropdownItem = require("./DropdownItem");
var _dropdownItemDefault = parcelHelpers.interopDefault(_dropdownItem);
var _dropdownItemText = require("./DropdownItemText");
var _dropdownItemTextDefault = parcelHelpers.interopDefault(_dropdownItemText);
var _dropdownMenu = require("./DropdownMenu");
var _dropdownMenuDefault = parcelHelpers.interopDefault(_dropdownMenu);
var _dropdownToggle = require("./DropdownToggle");
var _dropdownToggleDefault = parcelHelpers.interopDefault(_dropdownToggle);
var _fade = require("./Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _figure = require("./Figure");
var _figureDefault = parcelHelpers.interopDefault(_figure);
var _figureCaption = require("./FigureCaption");
var _figureCaptionDefault = parcelHelpers.interopDefault(_figureCaption);
var _figureImage = require("./FigureImage");
var _figureImageDefault = parcelHelpers.interopDefault(_figureImage);
var _form = require("./Form");
var _formDefault = parcelHelpers.interopDefault(_form);
var _formControl = require("./FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _formCheck = require("./FormCheck");
var _formCheckDefault = parcelHelpers.interopDefault(_formCheck);
var _formFloating = require("./FormFloating");
var _formFloatingDefault = parcelHelpers.interopDefault(_formFloating);
var _floatingLabel = require("./FloatingLabel");
var _floatingLabelDefault = parcelHelpers.interopDefault(_floatingLabel);
var _formGroup = require("./FormGroup");
var _formGroupDefault = parcelHelpers.interopDefault(_formGroup);
var _formLabel = require("./FormLabel");
var _formLabelDefault = parcelHelpers.interopDefault(_formLabel);
var _formText = require("./FormText");
var _formTextDefault = parcelHelpers.interopDefault(_formText);
var _formSelect = require("./FormSelect");
var _formSelectDefault = parcelHelpers.interopDefault(_formSelect);
var _image = require("./Image");
var _imageDefault = parcelHelpers.interopDefault(_image);
var _inputGroup = require("./InputGroup");
var _inputGroupDefault = parcelHelpers.interopDefault(_inputGroup);
var _listGroup = require("./ListGroup");
var _listGroupDefault = parcelHelpers.interopDefault(_listGroup);
var _listGroupItem = require("./ListGroupItem");
var _listGroupItemDefault = parcelHelpers.interopDefault(_listGroupItem);
var _modal = require("./Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _modalBody = require("./ModalBody");
var _modalBodyDefault = parcelHelpers.interopDefault(_modalBody);
var _modalDialog = require("./ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _modalFooter = require("./ModalFooter");
var _modalFooterDefault = parcelHelpers.interopDefault(_modalFooter);
var _modalHeader = require("./ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _modalTitle = require("./ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _nav = require("./Nav");
var _navDefault = parcelHelpers.interopDefault(_nav);
var _navbar = require("./Navbar");
var _navbarDefault = parcelHelpers.interopDefault(_navbar);
var _navbarBrand = require("./NavbarBrand");
var _navbarBrandDefault = parcelHelpers.interopDefault(_navbarBrand);
var _navbarCollapse = require("./NavbarCollapse");
var _navbarCollapseDefault = parcelHelpers.interopDefault(_navbarCollapse);
var _navbarOffcanvas = require("./NavbarOffcanvas");
var _navbarOffcanvasDefault = parcelHelpers.interopDefault(_navbarOffcanvas);
var _navbarText = require("./NavbarText");
var _navbarTextDefault = parcelHelpers.interopDefault(_navbarText);
var _navbarToggle = require("./NavbarToggle");
var _navbarToggleDefault = parcelHelpers.interopDefault(_navbarToggle);
var _navDropdown = require("./NavDropdown");
var _navDropdownDefault = parcelHelpers.interopDefault(_navDropdown);
var _navItem = require("./NavItem");
var _navItemDefault = parcelHelpers.interopDefault(_navItem);
var _navLink = require("./NavLink");
var _navLinkDefault = parcelHelpers.interopDefault(_navLink);
var _offcanvas = require("./Offcanvas");
var _offcanvasDefault = parcelHelpers.interopDefault(_offcanvas);
var _offcanvasBody = require("./OffcanvasBody");
var _offcanvasBodyDefault = parcelHelpers.interopDefault(_offcanvasBody);
var _offcanvasHeader = require("./OffcanvasHeader");
var _offcanvasHeaderDefault = parcelHelpers.interopDefault(_offcanvasHeader);
var _offcanvasTitle = require("./OffcanvasTitle");
var _offcanvasTitleDefault = parcelHelpers.interopDefault(_offcanvasTitle);
var _offcanvasToggling = require("./OffcanvasToggling");
var _offcanvasTogglingDefault = parcelHelpers.interopDefault(_offcanvasToggling);
var _overlay = require("./Overlay");
var _overlayDefault = parcelHelpers.interopDefault(_overlay);
var _overlayTrigger = require("./OverlayTrigger");
var _overlayTriggerDefault = parcelHelpers.interopDefault(_overlayTrigger);
var _pageItem = require("./PageItem");
var _pageItemDefault = parcelHelpers.interopDefault(_pageItem);
var _pagination = require("./Pagination");
var _paginationDefault = parcelHelpers.interopDefault(_pagination);
var _placeholder = require("./Placeholder");
var _placeholderDefault = parcelHelpers.interopDefault(_placeholder);
var _placeholderButton = require("./PlaceholderButton");
var _placeholderButtonDefault = parcelHelpers.interopDefault(_placeholderButton);
var _popover = require("./Popover");
var _popoverDefault = parcelHelpers.interopDefault(_popover);
var _popoverBody = require("./PopoverBody");
var _popoverBodyDefault = parcelHelpers.interopDefault(_popoverBody);
var _popoverHeader = require("./PopoverHeader");
var _popoverHeaderDefault = parcelHelpers.interopDefault(_popoverHeader);
var _progressBar = require("./ProgressBar");
var _progressBarDefault = parcelHelpers.interopDefault(_progressBar);
var _ratio = require("./Ratio");
var _ratioDefault = parcelHelpers.interopDefault(_ratio);
var _row = require("./Row");
var _rowDefault = parcelHelpers.interopDefault(_row);
var _spinner = require("./Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _splitButton = require("./SplitButton");
var _splitButtonDefault = parcelHelpers.interopDefault(_splitButton);
var _ssrprovider = require("./SSRProvider");
var _ssrproviderDefault = parcelHelpers.interopDefault(_ssrprovider);
var _stack = require("./Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _tab = require("./Tab");
var _tabDefault = parcelHelpers.interopDefault(_tab);
var _tabContainer = require("./TabContainer");
var _tabContainerDefault = parcelHelpers.interopDefault(_tabContainer);
var _tabContent = require("./TabContent");
var _tabContentDefault = parcelHelpers.interopDefault(_tabContent);
var _table = require("./Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _tabPane = require("./TabPane");
var _tabPaneDefault = parcelHelpers.interopDefault(_tabPane);
var _tabs = require("./Tabs");
var _tabsDefault = parcelHelpers.interopDefault(_tabs);
var _themeProvider = require("./ThemeProvider");
var _themeProviderDefault = parcelHelpers.interopDefault(_themeProvider);
var _toast = require("./Toast");
var _toastDefault = parcelHelpers.interopDefault(_toast);
var _toastBody = require("./ToastBody");
var _toastBodyDefault = parcelHelpers.interopDefault(_toastBody);
var _toastContainer = require("./ToastContainer");
var _toastContainerDefault = parcelHelpers.interopDefault(_toastContainer);
var _toastHeader = require("./ToastHeader");
var _toastHeaderDefault = parcelHelpers.interopDefault(_toastHeader);
var _toggleButton = require("./ToggleButton");
var _toggleButtonDefault = parcelHelpers.interopDefault(_toggleButton);
var _toggleButtonGroup = require("./ToggleButtonGroup");
var _toggleButtonGroupDefault = parcelHelpers.interopDefault(_toggleButtonGroup);
var _tooltip = require("./Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);

},{"./Accordion":"7sFI5","./AccordionContext":"1De5G","./AccordionCollapse":"fhDLo","./AccordionButton":"hTsF5","./AccordionBody":"dGxdx","./AccordionHeader":"YYBiu","./AccordionItem":"iZIcR","./Alert":"eF7kW","./AlertHeading":"fFBqX","./AlertLink":"hnK0V","./Anchor":"8dmjM","./Badge":"lrmEf","./Breadcrumb":"3Dege","./BreadcrumbItem":"7hznE","./Button":"6Xv8z","./ButtonGroup":"go7mS","./ButtonToolbar":"3xSgH","./Card":"gVV6u","./CardBody":"3IQ9j","./CardFooter":"87XQO","./CardGroup":"3Ct3M","./CardHeader":"92pVY","./CardImg":"iiLCd","./CardImgOverlay":"7cMNk","./CardLink":"eR80E","./CardSubtitle":"i4nov","./CardText":"aP2AK","./CardTitle":"7q2yC","./Carousel":"5LGZU","./CarouselCaption":"rpaKV","./CarouselItem":"kVj1K","./CloseButton":"7enKR","./Col":"ii9A3","./Collapse":"fzFC1","./Container":"8Pton","./Dropdown":"7uokG","./DropdownButton":"7NrMh","./DropdownDivider":"iQqDM","./DropdownHeader":"3yRHg","./DropdownItem":"8SRt4","./DropdownItemText":"lnX7Z","./DropdownMenu":"6sEFY","./DropdownToggle":"9yXfJ","./Fade":"iLhiL","./Figure":"fBRm1","./FigureCaption":"c7Ux8","./FigureImage":"cbPkT","./Form":"iMBBh","./FormControl":"lyROR","./FormCheck":"977FY","./FormFloating":"iULhb","./FloatingLabel":"3fazd","./FormGroup":"7EfpY","./FormLabel":"jAE2J","./FormText":"4XNmI","./FormSelect":"bNV4p","./Image":"3rbpJ","./InputGroup":"jdRoo","./ListGroup":"lPYmk","./ListGroupItem":"ixfAY","./Modal":"92IrJ","./ModalBody":"6OsGC","./ModalDialog":"bV6m5","./ModalFooter":"5NIrW","./ModalHeader":"coXPD","./ModalTitle":"6CGnd","./Nav":"axkz0","./Navbar":"34dRz","./NavbarBrand":"KlMqJ","./NavbarCollapse":"a8aGZ","./NavbarOffcanvas":"kKQ8O","./NavbarText":"g0Ec4","./NavbarToggle":"kc1gC","./NavDropdown":"918Zj","./NavItem":"ciiMI","./NavLink":"e3vjD","./Offcanvas":"d3y7E","./OffcanvasBody":"eCS2w","./OffcanvasHeader":"hEhv6","./OffcanvasTitle":"c7ThV","./OffcanvasToggling":"7BYbG","./Overlay":"89Q0I","./OverlayTrigger":"gfJVo","./PageItem":"9rt3i","./Pagination":"cQ0W6","./Placeholder":"cqCf1","./PlaceholderButton":"iG7HN","./Popover":"3fGIC","./PopoverBody":"hit36","./PopoverHeader":"fFi0I","./ProgressBar":"2I4Ha","./Ratio":"1dOkm","./Row":"3Fk66","./Spinner":"4RdUY","./SplitButton":"4S6ld","./SSRProvider":"hzuI4","./Stack":"1ZYHU","./Tab":"10Nxs","./TabContainer":"koe4F","./TabContent":"6v86b","./Table":"7SWKQ","./TabPane":"8lsLw","./Tabs":"eJbuZ","./ThemeProvider":"aQ1Mj","./Toast":"eYOJl","./ToastBody":"kmL3i","./ToastContainer":"8oPNT","./ToastHeader":"cEZ7z","./ToggleButton":"inQyE","./ToggleButtonGroup":"gEA1B","./Tooltip":"l1XDI","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7sFI5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _uncontrollable = require("uncontrollable");
var _themeProvider = require("./ThemeProvider");
var _accordionBody = require("./AccordionBody");
var _accordionBodyDefault = parcelHelpers.interopDefault(_accordionBody);
var _accordionButton = require("./AccordionButton");
var _accordionButtonDefault = parcelHelpers.interopDefault(_accordionButton);
var _accordionCollapse = require("./AccordionCollapse");
var _accordionCollapseDefault = parcelHelpers.interopDefault(_accordionCollapse);
var _accordionContext = require("./AccordionContext");
var _accordionContextDefault = parcelHelpers.interopDefault(_accordionContext);
var _accordionHeader = require("./AccordionHeader");
var _accordionHeaderDefault = parcelHelpers.interopDefault(_accordionHeader);
var _accordionItem = require("./AccordionItem");
var _accordionItemDefault = parcelHelpers.interopDefault(_accordionItem);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Accordion = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', activeKey, bsPrefix, className, onSelect, flush, alwaysOpen, ...controlledProps } = (0, _uncontrollable.useUncontrolled)(props, {
        activeKey: 'onSelect'
    });
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'accordion');
    const contextValue = (0, _react.useMemo)(()=>({
            activeEventKey: activeKey,
            onSelect,
            alwaysOpen
        }), [
        activeKey,
        onSelect,
        alwaysOpen
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accordionContextDefault.default).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
            ref: ref,
            ...controlledProps,
            className: (0, _classnamesDefault.default)(className, prefix, flush && `${prefix}-flush`)
        })
    });
});
Accordion.displayName = 'Accordion';
exports.default = Object.assign(Accordion, {
    Button: (0, _accordionButtonDefault.default),
    Collapse: (0, _accordionCollapseDefault.default),
    Item: (0, _accordionItemDefault.default),
    Header: (0, _accordionHeaderDefault.default),
    Body: (0, _accordionBodyDefault.default)
});

},{"classnames":"9HH2M","react":"bmhQu","uncontrollable":"1yRhe","./ThemeProvider":"aQ1Mj","./AccordionBody":"dGxdx","./AccordionButton":"hTsF5","./AccordionCollapse":"fhDLo","./AccordionContext":"1De5G","./AccordionHeader":"YYBiu","./AccordionItem":"iZIcR","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dGxdx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _accordionCollapse = require("./AccordionCollapse");
var _accordionCollapseDefault = parcelHelpers.interopDefault(_accordionCollapse);
var _accordionItemContext = require("./AccordionItemContext");
var _accordionItemContextDefault = parcelHelpers.interopDefault(_accordionItemContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const AccordionBody = /*#__PURE__*/ _react.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', bsPrefix, className, onEnter, onEntering, onEntered, onExit, onExiting, onExited, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'accordion-body');
    const { eventKey } = (0, _react.useContext)((0, _accordionItemContextDefault.default));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accordionCollapseDefault.default), {
        eventKey: eventKey,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: onExited,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, _classnamesDefault.default)(className, bsPrefix)
        })
    });
});
AccordionBody.displayName = 'AccordionBody';
exports.default = AccordionBody;

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","./AccordionCollapse":"fhDLo","./AccordionItemContext":"a6vHx","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fhDLo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _collapse = require("./Collapse");
var _collapseDefault = parcelHelpers.interopDefault(_collapse);
var _accordionContext = require("./AccordionContext");
var _accordionContextDefault = parcelHelpers.interopDefault(_accordionContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
/**
 * This component accepts all of [`Collapse`'s props](/docs/utilities/transitions#collapse-1).
 */ const AccordionCollapse = /*#__PURE__*/ _react.forwardRef(({ as: Component = 'div', bsPrefix, className, children, eventKey, ...props }, ref)=>{
    const { activeEventKey } = (0, _react.useContext)((0, _accordionContextDefault.default));
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'accordion-collapse');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapseDefault.default), {
        ref: ref,
        in: (0, _accordionContext.isAccordionItemSelected)(activeEventKey, eventKey),
        ...props,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
            children: _react.Children.only(children)
        })
    });
});
AccordionCollapse.displayName = 'AccordionCollapse';
exports.default = AccordionCollapse;

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","./Collapse":"fzFC1","./AccordionContext":"1De5G","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1De5G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAccordionItemSelected", ()=>isAccordionItemSelected);
var _react = require("react");
"use client";
function isAccordionItemSelected(activeEventKey, eventKey) {
    return Array.isArray(activeEventKey) ? activeEventKey.includes(eventKey) : activeEventKey === eventKey;
}
const context = /*#__PURE__*/ _react.createContext({});
context.displayName = 'AccordionContext';
exports.default = context;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a6vHx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
const context = /*#__PURE__*/ _react.createContext({
    eventKey: ''
});
context.displayName = 'AccordionItemContext';
exports.default = context;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hTsF5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAccordionButton", ()=>useAccordionButton);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _accordionContext = require("./AccordionContext");
var _accordionContextDefault = parcelHelpers.interopDefault(_accordionContext);
var _accordionItemContext = require("./AccordionItemContext");
var _accordionItemContextDefault = parcelHelpers.interopDefault(_accordionItemContext);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function useAccordionButton(eventKey, onClick) {
    const { activeEventKey, onSelect, alwaysOpen } = (0, _react.useContext)((0, _accordionContextDefault.default));
    return (e)=>{
        /*
      Compare the event key in context with the given event key.
      If they are the same, then collapse the component.
    */ let eventKeyPassed = eventKey === activeEventKey ? null : eventKey;
        if (alwaysOpen) {
            if (Array.isArray(activeEventKey)) {
                if (activeEventKey.includes(eventKey)) eventKeyPassed = activeEventKey.filter((k)=>k !== eventKey);
                else eventKeyPassed = [
                    ...activeEventKey,
                    eventKey
                ];
            } else // activeEventKey is undefined.
            eventKeyPassed = [
                eventKey
            ];
        }
        onSelect == null || onSelect(eventKeyPassed, e);
        onClick == null || onClick(e);
    };
}
const AccordionButton = /*#__PURE__*/ _react.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'button', bsPrefix, className, onClick, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'accordion-button');
    const { eventKey } = (0, _react.useContext)((0, _accordionItemContextDefault.default));
    const accordionOnClick = useAccordionButton(eventKey, onClick);
    const { activeEventKey } = (0, _react.useContext)((0, _accordionContextDefault.default));
    if (Component === 'button') props.type = 'button';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        onClick: accordionOnClick,
        ...props,
        "aria-expanded": Array.isArray(activeEventKey) ? activeEventKey.includes(eventKey) : eventKey === activeEventKey,
        className: (0, _classnamesDefault.default)(className, bsPrefix, !(0, _accordionContext.isAccordionItemSelected)(activeEventKey, eventKey) && 'collapsed')
    });
});
AccordionButton.displayName = 'AccordionButton';
exports.default = AccordionButton;

},{"react":"bmhQu","classnames":"9HH2M","./AccordionContext":"1De5G","./AccordionItemContext":"a6vHx","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"YYBiu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _accordionButton = require("./AccordionButton");
var _accordionButtonDefault = parcelHelpers.interopDefault(_accordionButton);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const AccordionHeader = /*#__PURE__*/ _react.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'h2', 'aria-controls': ariaControls, bsPrefix, className, children, onClick, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'accordion-header');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accordionButtonDefault.default), {
            onClick: onClick,
            "aria-controls": ariaControls,
            children: children
        })
    });
});
AccordionHeader.displayName = 'AccordionHeader';
exports.default = AccordionHeader;

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","./AccordionButton":"hTsF5","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iZIcR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _accordionItemContext = require("./AccordionItemContext");
var _accordionItemContextDefault = parcelHelpers.interopDefault(_accordionItemContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const AccordionItem = /*#__PURE__*/ _react.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', bsPrefix, className, eventKey, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'accordion-item');
    const contextValue = (0, _react.useMemo)(()=>({
            eventKey
        }), [
        eventKey
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accordionItemContextDefault.default).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, _classnamesDefault.default)(className, bsPrefix)
        })
    });
});
AccordionItem.displayName = 'AccordionItem';
exports.default = AccordionItem;

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","./AccordionItemContext":"a6vHx","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eF7kW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _uncontrollable = require("uncontrollable");
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _themeProvider = require("./ThemeProvider");
var _alertHeading = require("./AlertHeading");
var _alertHeadingDefault = parcelHelpers.interopDefault(_alertHeading);
var _alertLink = require("./AlertLink");
var _alertLinkDefault = parcelHelpers.interopDefault(_alertLink);
var _fade = require("./Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _closeButton = require("./CloseButton");
var _closeButtonDefault = parcelHelpers.interopDefault(_closeButton);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Alert = /*#__PURE__*/ _react.forwardRef((uncontrolledProps, ref)=>{
    const { bsPrefix, show = true, closeLabel = 'Close alert', closeVariant, className, children, variant = 'primary', onClose, dismissible, transition = (0, _fadeDefault.default), ...props } = (0, _uncontrollable.useUncontrolled)(uncontrolledProps, {
        show: 'onClose'
    });
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'alert');
    const handleClose = (0, _useEventCallbackDefault.default)((e)=>{
        if (onClose) onClose(false, e);
    });
    const Transition = transition === true ? (0, _fadeDefault.default) : transition;
    const alert = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        role: "alert",
        ...!Transition ? props : undefined,
        ref: ref,
        className: (0, _classnamesDefault.default)(className, prefix, variant && `${prefix}-${variant}`, dismissible && `${prefix}-dismissible`),
        children: [
            dismissible && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeButtonDefault.default), {
                onClick: handleClose,
                "aria-label": closeLabel,
                variant: closeVariant
            }),
            children
        ]
    });
    if (!Transition) return show ? alert : null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Transition, {
        unmountOnExit: true,
        ...props,
        ref: undefined,
        in: show,
        children: alert
    });
});
Alert.displayName = 'Alert';
exports.default = Object.assign(Alert, {
    Link: (0, _alertLinkDefault.default),
    Heading: (0, _alertHeadingDefault.default)
});

},{"classnames":"9HH2M","react":"bmhQu","uncontrollable":"1yRhe","@restart/hooks/useEventCallback":"8gfnN","./ThemeProvider":"aQ1Mj","./AlertHeading":"fFBqX","./AlertLink":"hnK0V","./Fade":"iLhiL","./CloseButton":"7enKR","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fFBqX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _divWithClassName = require("./divWithClassName");
var _divWithClassNameDefault = parcelHelpers.interopDefault(_divWithClassName);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DivStyledAsH4 = (0, _divWithClassNameDefault.default)('h4');
DivStyledAsH4.displayName = 'DivStyledAsH4';
const AlertHeading = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'alert-heading');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
AlertHeading.displayName = 'AlertHeading';
exports.default = AlertHeading;

},{"react":"bmhQu","classnames":"9HH2M","./ThemeProvider":"aQ1Mj","./divWithClassName":"kXtiN","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hnK0V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _anchor = require("@restart/ui/Anchor");
var _anchorDefault = parcelHelpers.interopDefault(_anchor);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const AlertLink = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = (0, _anchorDefault.default), ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'alert-link');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
AlertLink.displayName = 'AlertLink';
exports.default = AlertLink;

},{"react":"bmhQu","classnames":"9HH2M","@restart/ui/Anchor":"iVIEK","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8dmjM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _anchor = require("@restart/ui/Anchor");
var _anchorDefault = parcelHelpers.interopDefault(_anchor);
exports.default = (0, _anchorDefault.default);

},{"@restart/ui/Anchor":"iVIEK","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lrmEf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Badge = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, bg = 'primary', pill = false, text, className, as: Component = 'span', ...props }, ref)=>{
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'badge');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, _classnamesDefault.default)(className, prefix, pill && `rounded-pill`, text && `text-${text}`, bg && `bg-${bg}`)
    });
});
Badge.displayName = 'Badge';
exports.default = Badge;

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3Dege":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _breadcrumbItem = require("./BreadcrumbItem");
var _breadcrumbItemDefault = parcelHelpers.interopDefault(_breadcrumbItem);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Breadcrumb = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, listProps = {}, children, label = 'breadcrumb', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'nav', ...props }, ref)=>{
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'breadcrumb');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        "aria-label": label,
        className: className,
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("ol", {
            ...listProps,
            className: (0, _classnamesDefault.default)(prefix, listProps == null ? void 0 : listProps.className),
            children: children
        })
    });
});
Breadcrumb.displayName = 'Breadcrumb';
exports.default = Object.assign(Breadcrumb, {
    Item: (0, _breadcrumbItemDefault.default)
});

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","./BreadcrumbItem":"7hznE","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7hznE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _anchor = require("@restart/ui/Anchor");
var _anchorDefault = parcelHelpers.interopDefault(_anchor);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const BreadcrumbItem = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, active = false, children, className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'li', linkAs: LinkComponent = (0, _anchorDefault.default), linkProps = {}, href, title, target, ...props }, ref)=>{
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'breadcrumb-item');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, _classnamesDefault.default)(prefix, className, {
            active
        }),
        "aria-current": active ? 'page' : undefined,
        children: active ? children : /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinkComponent, {
            ...linkProps,
            href: href,
            title: title,
            target: target,
            children: children
        })
    });
});
BreadcrumbItem.displayName = 'BreadcrumbItem';
exports.default = BreadcrumbItem;

},{"classnames":"9HH2M","react":"bmhQu","@restart/ui/Anchor":"iVIEK","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"go7mS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const ButtonGroup = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, size, vertical = false, className, role = 'group', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...rest }, ref)=>{
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'btn-group');
    let baseClass = prefix;
    if (vertical) baseClass = `${prefix}-vertical`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...rest,
        ref: ref,
        role: role,
        className: (0, _classnamesDefault.default)(className, baseClass, size && `${prefix}-${size}`)
    });
});
ButtonGroup.displayName = 'ButtonGroup';
exports.default = ButtonGroup;

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3xSgH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const ButtonToolbar = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, role = 'toolbar', ...props }, ref)=>{
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'btn-toolbar');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, _classnamesDefault.default)(className, prefix),
        role: role
    });
});
ButtonToolbar.displayName = 'ButtonToolbar';
exports.default = ButtonToolbar;

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gVV6u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _cardBody = require("./CardBody");
var _cardBodyDefault = parcelHelpers.interopDefault(_cardBody);
var _cardFooter = require("./CardFooter");
var _cardFooterDefault = parcelHelpers.interopDefault(_cardFooter);
var _cardHeader = require("./CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardImg = require("./CardImg");
var _cardImgDefault = parcelHelpers.interopDefault(_cardImg);
var _cardImgOverlay = require("./CardImgOverlay");
var _cardImgOverlayDefault = parcelHelpers.interopDefault(_cardImgOverlay);
var _cardLink = require("./CardLink");
var _cardLinkDefault = parcelHelpers.interopDefault(_cardLink);
var _cardSubtitle = require("./CardSubtitle");
var _cardSubtitleDefault = parcelHelpers.interopDefault(_cardSubtitle);
var _cardText = require("./CardText");
var _cardTextDefault = parcelHelpers.interopDefault(_cardText);
var _cardTitle = require("./CardTitle");
var _cardTitleDefault = parcelHelpers.interopDefault(_cardTitle);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Card = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, bg, text, border, body = false, children, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, _classnamesDefault.default)(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
        children: body ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardBodyDefault.default), {
            children: children
        }) : children
    });
});
Card.displayName = 'Card';
exports.default = Object.assign(Card, {
    Img: (0, _cardImgDefault.default),
    Title: (0, _cardTitleDefault.default),
    Subtitle: (0, _cardSubtitleDefault.default),
    Body: (0, _cardBodyDefault.default),
    Link: (0, _cardLinkDefault.default),
    Text: (0, _cardTextDefault.default),
    Header: (0, _cardHeaderDefault.default),
    Footer: (0, _cardFooterDefault.default),
    ImgOverlay: (0, _cardImgOverlayDefault.default)
});

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","./CardBody":"3IQ9j","./CardFooter":"87XQO","./CardHeader":"92pVY","./CardImg":"iiLCd","./CardImgOverlay":"7cMNk","./CardLink":"eR80E","./CardSubtitle":"i4nov","./CardText":"aP2AK","./CardTitle":"7q2yC","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3IQ9j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const CardBody = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card-body');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
CardBody.displayName = 'CardBody';
exports.default = CardBody;

},{"react":"bmhQu","classnames":"9HH2M","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"87XQO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const CardFooter = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card-footer');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
CardFooter.displayName = 'CardFooter';
exports.default = CardFooter;

},{"react":"bmhQu","classnames":"9HH2M","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"92pVY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _cardHeaderContext = require("./CardHeaderContext");
var _cardHeaderContextDefault = parcelHelpers.interopDefault(_cardHeaderContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const CardHeader = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card-header');
    const contextValue = (0, _react.useMemo)(()=>({
            cardHeaderBsPrefix: prefix
        }), [
        prefix
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderContextDefault.default).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, _classnamesDefault.default)(className, prefix)
        })
    });
});
CardHeader.displayName = 'CardHeader';
exports.default = CardHeader;

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","./CardHeaderContext":"dlz2Y","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iiLCd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const CardImg = /*#__PURE__*/ _react.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix, className, variant, as: Component = 'img', ...props }, ref)=>{
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card-img');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(variant ? `${prefix}-${variant}` : prefix, className),
        ...props
    });
});
CardImg.displayName = 'CardImg';
exports.default = CardImg;

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7cMNk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const CardImgOverlay = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card-img-overlay');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
CardImgOverlay.displayName = 'CardImgOverlay';
exports.default = CardImgOverlay;

},{"react":"bmhQu","classnames":"9HH2M","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eR80E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const CardLink = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'a', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card-link');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
CardLink.displayName = 'CardLink';
exports.default = CardLink;

},{"react":"bmhQu","classnames":"9HH2M","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i4nov":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _divWithClassName = require("./divWithClassName");
var _divWithClassNameDefault = parcelHelpers.interopDefault(_divWithClassName);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DivStyledAsH6 = (0, _divWithClassNameDefault.default)('h6');
const CardSubtitle = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = DivStyledAsH6, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card-subtitle');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
CardSubtitle.displayName = 'CardSubtitle';
exports.default = CardSubtitle;

},{"react":"bmhQu","classnames":"9HH2M","./ThemeProvider":"aQ1Mj","./divWithClassName":"kXtiN","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aP2AK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const CardText = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'p', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card-text');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
CardText.displayName = 'CardText';
exports.default = CardText;

},{"react":"bmhQu","classnames":"9HH2M","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7q2yC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _divWithClassName = require("./divWithClassName");
var _divWithClassNameDefault = parcelHelpers.interopDefault(_divWithClassName);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DivStyledAsH5 = (0, _divWithClassNameDefault.default)('h5');
const CardTitle = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card-title');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
CardTitle.displayName = 'CardTitle';
exports.default = CardTitle;

},{"react":"bmhQu","classnames":"9HH2M","./ThemeProvider":"aQ1Mj","./divWithClassName":"kXtiN","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3Ct3M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const CardGroup = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'card-group');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
CardGroup.displayName = 'CardGroup';
exports.default = CardGroup;

},{"react":"bmhQu","classnames":"9HH2M","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5LGZU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useUpdateEffect = require("@restart/hooks/useUpdateEffect");
var _useUpdateEffectDefault = parcelHelpers.interopDefault(_useUpdateEffect);
var _useCommittedRef = require("@restart/hooks/useCommittedRef");
var _useCommittedRefDefault = parcelHelpers.interopDefault(_useCommittedRef);
var _useTimeout = require("@restart/hooks/useTimeout");
var _useTimeoutDefault = parcelHelpers.interopDefault(_useTimeout);
var _anchor = require("@restart/ui/Anchor");
var _anchorDefault = parcelHelpers.interopDefault(_anchor);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _uncontrollable = require("uncontrollable");
var _carouselCaption = require("./CarouselCaption");
var _carouselCaptionDefault = parcelHelpers.interopDefault(_carouselCaption);
var _carouselItem = require("./CarouselItem");
var _carouselItemDefault = parcelHelpers.interopDefault(_carouselItem);
var _elementChildren = require("./ElementChildren");
var _themeProvider = require("./ThemeProvider");
var _transitionEndListener = require("./transitionEndListener");
var _transitionEndListenerDefault = parcelHelpers.interopDefault(_transitionEndListener);
var _triggerBrowserReflow = require("./triggerBrowserReflow");
var _triggerBrowserReflowDefault = parcelHelpers.interopDefault(_triggerBrowserReflow);
var _transitionWrapper = require("./TransitionWrapper");
var _transitionWrapperDefault = parcelHelpers.interopDefault(_transitionWrapper);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const SWIPE_THRESHOLD = 40;
function isVisible(element) {
    if (!element || !element.style || !element.parentNode || !element.parentNode.style) return false;
    const elementStyle = getComputedStyle(element);
    return elementStyle.display !== 'none' && elementStyle.visibility !== 'hidden' && getComputedStyle(element.parentNode).display !== 'none';
}
const Carousel = /*#__PURE__*/ // eslint-disable-next-line react/display-name
_react.forwardRef(({ defaultActiveIndex = 0, ...uncontrolledProps }, ref)=>{
    const { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', bsPrefix, slide = true, fade = false, controls = true, indicators = true, indicatorLabels = [], activeIndex, onSelect, onSlide, onSlid, interval = 5000, keyboard = true, onKeyDown, pause = 'hover', onMouseOver, onMouseOut, wrap = true, touch = true, onTouchStart, onTouchMove, onTouchEnd, prevIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        "aria-hidden": "true",
        className: "carousel-control-prev-icon"
    }), prevLabel = 'Previous', nextIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        "aria-hidden": "true",
        className: "carousel-control-next-icon"
    }), nextLabel = 'Next', variant, className, children, ...props } = (0, _uncontrollable.useUncontrolled)({
        defaultActiveIndex,
        ...uncontrolledProps
    }, {
        activeIndex: 'onSelect'
    });
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'carousel');
    const isRTL = (0, _themeProvider.useIsRTL)();
    const nextDirectionRef = (0, _react.useRef)(null);
    const [direction, setDirection] = (0, _react.useState)('next');
    const [paused, setPaused] = (0, _react.useState)(false);
    const [isSliding, setIsSliding] = (0, _react.useState)(false);
    const [renderedActiveIndex, setRenderedActiveIndex] = (0, _react.useState)(activeIndex || 0);
    (0, _react.useEffect)(()=>{
        if (!isSliding && activeIndex !== renderedActiveIndex) {
            if (nextDirectionRef.current) setDirection(nextDirectionRef.current);
            else setDirection((activeIndex || 0) > renderedActiveIndex ? 'next' : 'prev');
            if (slide) setIsSliding(true);
            setRenderedActiveIndex(activeIndex || 0);
        }
    }, [
        activeIndex,
        isSliding,
        renderedActiveIndex,
        slide
    ]);
    (0, _react.useEffect)(()=>{
        if (nextDirectionRef.current) nextDirectionRef.current = null;
    });
    let numChildren = 0;
    let activeChildInterval;
    // Iterate to grab all of the children's interval values
    // (and count them, too)
    (0, _elementChildren.forEach)(children, (child, index)=>{
        ++numChildren;
        if (index === activeIndex) activeChildInterval = child.props.interval;
    });
    const activeChildIntervalRef = (0, _useCommittedRefDefault.default)(activeChildInterval);
    const prev = (0, _react.useCallback)((event)=>{
        if (isSliding) return;
        let nextActiveIndex = renderedActiveIndex - 1;
        if (nextActiveIndex < 0) {
            if (!wrap) return;
            nextActiveIndex = numChildren - 1;
        }
        nextDirectionRef.current = 'prev';
        onSelect == null || onSelect(nextActiveIndex, event);
    }, [
        isSliding,
        renderedActiveIndex,
        onSelect,
        wrap,
        numChildren
    ]);
    // This is used in the setInterval, so it should not invalidate.
    const next = (0, _useEventCallbackDefault.default)((event)=>{
        if (isSliding) return;
        let nextActiveIndex = renderedActiveIndex + 1;
        if (nextActiveIndex >= numChildren) {
            if (!wrap) return;
            nextActiveIndex = 0;
        }
        nextDirectionRef.current = 'next';
        onSelect == null || onSelect(nextActiveIndex, event);
    });
    const elementRef = (0, _react.useRef)();
    (0, _react.useImperativeHandle)(ref, ()=>({
            element: elementRef.current,
            prev,
            next
        }));
    // This is used in the setInterval, so it should not invalidate.
    const nextWhenVisible = (0, _useEventCallbackDefault.default)(()=>{
        if (!document.hidden && isVisible(elementRef.current)) {
            if (isRTL) prev();
            else next();
        }
    });
    const slideDirection = direction === 'next' ? 'start' : 'end';
    (0, _useUpdateEffectDefault.default)(()=>{
        if (slide) // These callbacks will be handled by the <Transition> callbacks.
        return;
        onSlide == null || onSlide(renderedActiveIndex, slideDirection);
        onSlid == null || onSlid(renderedActiveIndex, slideDirection);
    }, [
        renderedActiveIndex
    ]);
    const orderClassName = `${prefix}-item-${direction}`;
    const directionalClassName = `${prefix}-item-${slideDirection}`;
    const handleEnter = (0, _react.useCallback)((node)=>{
        (0, _triggerBrowserReflowDefault.default)(node);
        onSlide == null || onSlide(renderedActiveIndex, slideDirection);
    }, [
        onSlide,
        renderedActiveIndex,
        slideDirection
    ]);
    const handleEntered = (0, _react.useCallback)(()=>{
        setIsSliding(false);
        onSlid == null || onSlid(renderedActiveIndex, slideDirection);
    }, [
        onSlid,
        renderedActiveIndex,
        slideDirection
    ]);
    const handleKeyDown = (0, _react.useCallback)((event)=>{
        if (keyboard && !/input|textarea/i.test(event.target.tagName)) switch(event.key){
            case 'ArrowLeft':
                event.preventDefault();
                if (isRTL) next(event);
                else prev(event);
                return;
            case 'ArrowRight':
                event.preventDefault();
                if (isRTL) prev(event);
                else next(event);
                return;
            default:
        }
        onKeyDown == null || onKeyDown(event);
    }, [
        keyboard,
        onKeyDown,
        prev,
        next,
        isRTL
    ]);
    const handleMouseOver = (0, _react.useCallback)((event)=>{
        if (pause === 'hover') setPaused(true);
        onMouseOver == null || onMouseOver(event);
    }, [
        pause,
        onMouseOver
    ]);
    const handleMouseOut = (0, _react.useCallback)((event)=>{
        setPaused(false);
        onMouseOut == null || onMouseOut(event);
    }, [
        onMouseOut
    ]);
    const touchStartXRef = (0, _react.useRef)(0);
    const touchDeltaXRef = (0, _react.useRef)(0);
    const touchUnpauseTimeout = (0, _useTimeoutDefault.default)();
    const handleTouchStart = (0, _react.useCallback)((event)=>{
        touchStartXRef.current = event.touches[0].clientX;
        touchDeltaXRef.current = 0;
        if (pause === 'hover') setPaused(true);
        onTouchStart == null || onTouchStart(event);
    }, [
        pause,
        onTouchStart
    ]);
    const handleTouchMove = (0, _react.useCallback)((event)=>{
        if (event.touches && event.touches.length > 1) touchDeltaXRef.current = 0;
        else touchDeltaXRef.current = event.touches[0].clientX - touchStartXRef.current;
        onTouchMove == null || onTouchMove(event);
    }, [
        onTouchMove
    ]);
    const handleTouchEnd = (0, _react.useCallback)((event)=>{
        if (touch) {
            const touchDeltaX = touchDeltaXRef.current;
            if (Math.abs(touchDeltaX) > SWIPE_THRESHOLD) {
                if (touchDeltaX > 0) prev(event);
                else next(event);
            }
        }
        if (pause === 'hover') touchUnpauseTimeout.set(()=>{
            setPaused(false);
        }, interval || undefined);
        onTouchEnd == null || onTouchEnd(event);
    }, [
        touch,
        pause,
        prev,
        next,
        touchUnpauseTimeout,
        interval,
        onTouchEnd
    ]);
    const shouldPlay = interval != null && !paused && !isSliding;
    const intervalHandleRef = (0, _react.useRef)();
    (0, _react.useEffect)(()=>{
        var _ref, _activeChildIntervalR;
        if (!shouldPlay) return undefined;
        const nextFunc = isRTL ? prev : next;
        intervalHandleRef.current = window.setInterval(document.visibilityState ? nextWhenVisible : nextFunc, (_ref = (_activeChildIntervalR = activeChildIntervalRef.current) != null ? _activeChildIntervalR : interval) != null ? _ref : undefined);
        return ()=>{
            if (intervalHandleRef.current !== null) clearInterval(intervalHandleRef.current);
        };
    }, [
        shouldPlay,
        prev,
        next,
        activeChildIntervalRef,
        interval,
        nextWhenVisible,
        isRTL
    ]);
    const indicatorOnClicks = (0, _react.useMemo)(()=>indicators && Array.from({
            length: numChildren
        }, (_, index)=>(event)=>{
                onSelect == null || onSelect(index, event);
            }), [
        indicators,
        numChildren,
        onSelect
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Component, {
        ref: elementRef,
        ...props,
        onKeyDown: handleKeyDown,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        onTouchStart: handleTouchStart,
        onTouchMove: handleTouchMove,
        onTouchEnd: handleTouchEnd,
        className: (0, _classnamesDefault.default)(className, prefix, slide && 'slide', fade && `${prefix}-fade`, variant && `${prefix}-${variant}`),
        children: [
            indicators && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `${prefix}-indicators`,
                children: (0, _elementChildren.map)(children, (_, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        "data-bs-target": "" // Bootstrap requires this in their css.
                        ,
                        "aria-label": indicatorLabels != null && indicatorLabels.length ? indicatorLabels[index] : `Slide ${index + 1}`,
                        className: index === renderedActiveIndex ? 'active' : undefined,
                        onClick: indicatorOnClicks ? indicatorOnClicks[index] : undefined,
                        "aria-current": index === renderedActiveIndex
                    }, index))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `${prefix}-inner`,
                children: (0, _elementChildren.map)(children, (child, index)=>{
                    const isActive = index === renderedActiveIndex;
                    return slide ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transitionWrapperDefault.default), {
                        in: isActive,
                        onEnter: isActive ? handleEnter : undefined,
                        onEntered: isActive ? handleEntered : undefined,
                        addEndListener: (0, _transitionEndListenerDefault.default),
                        children: (status, innerProps)=>/*#__PURE__*/ _react.cloneElement(child, {
                                ...innerProps,
                                className: (0, _classnamesDefault.default)(child.props.className, isActive && status !== 'entered' && orderClassName, (status === 'entered' || status === 'exiting') && 'active', (status === 'entering' || status === 'exiting') && directionalClassName)
                            })
                    }) : /*#__PURE__*/ _react.cloneElement(child, {
                        className: (0, _classnamesDefault.default)(child.props.className, isActive && 'active')
                    });
                })
            }),
            controls && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    (wrap || activeIndex !== 0) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _anchorDefault.default), {
                        className: `${prefix}-control-prev`,
                        onClick: prev,
                        children: [
                            prevIcon,
                            prevLabel && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "visually-hidden",
                                children: prevLabel
                            })
                        ]
                    }),
                    (wrap || activeIndex !== numChildren - 1) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _anchorDefault.default), {
                        className: `${prefix}-control-next`,
                        onClick: next,
                        children: [
                            nextIcon,
                            nextLabel && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "visually-hidden",
                                children: nextLabel
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
Carousel.displayName = 'Carousel';
exports.default = Object.assign(Carousel, {
    Caption: (0, _carouselCaptionDefault.default),
    Item: (0, _carouselItemDefault.default)
});

},{"@restart/hooks/useEventCallback":"8gfnN","@restart/hooks/useUpdateEffect":"hUej9","@restart/hooks/useCommittedRef":"3fCg9","@restart/hooks/useTimeout":"1vt3i","@restart/ui/Anchor":"iVIEK","classnames":"9HH2M","react":"bmhQu","uncontrollable":"1yRhe","./CarouselCaption":"rpaKV","./CarouselItem":"kVj1K","./ElementChildren":"iO22F","./ThemeProvider":"aQ1Mj","./transitionEndListener":"92uND","./triggerBrowserReflow":"d9hBI","./TransitionWrapper":"3fmIS","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hUej9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
/**
 * Runs an effect only when the dependencies have changed, skipping the
 * initial "on mount" run. Caution, if the dependency list never changes,
 * the effect is **never run**
 *
 * ```ts
 *  const ref = useRef<HTMLInput>(null);
 *
 *  // focuses an element only if the focus changes, and not on mount
 *  useUpdateEffect(() => {
 *    const element = ref.current?.children[focusedIdx] as HTMLElement
 *
 *    element?.focus()
 *
 *  }, [focusedIndex])
 * ```
 * @param effect An effect to run on mount
 *
 * @category effects
 */ function useUpdateEffect(fn, deps) {
    const isFirst = (0, _react.useRef)(true);
    (0, _react.useEffect)(()=>{
        if (isFirst.current) {
            isFirst.current = false;
            return;
        }
        return fn();
    }, deps);
}
exports.default = useUpdateEffect;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1vt3i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useTimeout);
var _react = require("react");
var _useMounted = require("./useMounted");
var _useMountedDefault = parcelHelpers.interopDefault(_useMounted);
var _useWillUnmount = require("./useWillUnmount");
var _useWillUnmountDefault = parcelHelpers.interopDefault(_useWillUnmount);
/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */ const MAX_DELAY_MS = 2 ** 31 - 1;
function setChainedTimeout(handleRef, fn, timeoutAtMs) {
    const delayMs = timeoutAtMs - Date.now();
    handleRef.current = delayMs <= MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(()=>setChainedTimeout(handleRef, fn, timeoutAtMs), MAX_DELAY_MS);
}
function useTimeout() {
    const isMounted = (0, _useMountedDefault.default)();
    // types are confused between node and web here IDK
    const handleRef = (0, _react.useRef)();
    (0, _useWillUnmountDefault.default)(()=>clearTimeout(handleRef.current));
    return (0, _react.useMemo)(()=>{
        const clear = ()=>clearTimeout(handleRef.current);
        function set(fn, delayMs = 0) {
            if (!isMounted()) return;
            clear();
            if (delayMs <= MAX_DELAY_MS) // For simplicity, if the timeout is short, just set a normal timeout.
            handleRef.current = setTimeout(fn, delayMs);
            else setChainedTimeout(handleRef, fn, Date.now() + delayMs);
        }
        return {
            set,
            clear,
            handleRef
        };
    }, []);
}

},{"react":"bmhQu","./useMounted":"4l396","./useWillUnmount":"8eQCP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4l396":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useMounted);
var _react = require("react");
function useMounted() {
    const mounted = (0, _react.useRef)(true);
    const isMounted = (0, _react.useRef)(()=>mounted.current);
    (0, _react.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8eQCP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useWillUnmount);
var _useUpdatedRef = require("./useUpdatedRef");
var _useUpdatedRefDefault = parcelHelpers.interopDefault(_useUpdatedRef);
var _react = require("react");
function useWillUnmount(fn) {
    const onUnmount = (0, _useUpdatedRefDefault.default)(fn);
    (0, _react.useEffect)(()=>()=>onUnmount.current(), []);
}

},{"./useUpdatedRef":"jI7jV","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jI7jV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useUpdatedRef);
var _react = require("react");
function useUpdatedRef(value) {
    const valueRef = (0, _react.useRef)(value);
    valueRef.current = value;
    return valueRef;
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"rpaKV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const CarouselCaption = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'carousel-caption');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
CarouselCaption.displayName = 'CarouselCaption';
exports.default = CarouselCaption;

},{"react":"bmhQu","classnames":"9HH2M","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kVj1K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const CarouselItem = /*#__PURE__*/ _react.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', bsPrefix, className, ...props }, ref)=>{
    const finalClassName = (0, _classnamesDefault.default)(className, (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'carousel-item'));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        ...props,
        className: finalClassName
    });
});
CarouselItem.displayName = 'CarouselItem';
exports.default = CarouselItem;

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iO22F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "map", ()=>map);
parcelHelpers.export(exports, "forEach", ()=>forEach);
parcelHelpers.export(exports, "hasChildOfType", ()=>hasChildOfType);
var _react = require("react");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function map(children, func) {
    let index = 0;
    return _react.Children.map(children, (child)=>/*#__PURE__*/ _react.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function forEach(children, func) {
    let index = 0;
    _react.Children.forEach(children, (child)=>{
        if (/*#__PURE__*/ _react.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function hasChildOfType(children, type) {
    return _react.Children.toArray(children).some((child)=>/*#__PURE__*/ _react.isValidElement(child) && child.type === type);
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ii9A3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCol", ()=>useCol);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function useCol({ as, bsPrefix, className, ...props }) {
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'col');
    const breakpoints = (0, _themeProvider.useBootstrapBreakpoints)();
    const minBreakpoint = (0, _themeProvider.useBootstrapMinBreakpoint)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === 'object' && propValue != null) ({ span, offset, order } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        {
            ...props,
            className: (0, _classnamesDefault.default)(className, ...spans, ...classes)
        },
        {
            as,
            bsPrefix,
            spans
        }
    ];
}
const Col = /*#__PURE__*/ _react.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const [{ className, ...colProps }, { as: Component = 'div', bsPrefix, spans }] = useCol(props);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...colProps,
        ref: ref,
        className: (0, _classnamesDefault.default)(className, !spans.length && bsPrefix)
    });
});
Col.displayName = 'Col';
exports.default = Col;

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8Pton":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Container = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, fluid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className, ...props }, ref)=>{
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'container');
    const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, _classnamesDefault.default)(className, fluid ? `${prefix}${suffix}` : prefix)
    });
});
Container.displayName = 'Container';
exports.default = Container;

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7NrMh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _dropdown = require("./Dropdown");
var _dropdownDefault = parcelHelpers.interopDefault(_dropdown);
var _dropdownToggle = require("./DropdownToggle");
var _dropdownToggleDefault = parcelHelpers.interopDefault(_dropdownToggle);
var _dropdownMenu = require("./DropdownMenu");
var _dropdownMenuDefault = parcelHelpers.interopDefault(_dropdownMenu);
var _types = require("./types");
var _jsxRuntime = require("react/jsx-runtime");
const propTypes = {
    /**
   * An html id attribute for the Toggle button, necessary for assistive technologies, such as screen readers.
   * @type {string}
   */ id: (0, _propTypesDefault.default).string,
    /** An `href` passed to the Toggle component */ href: (0, _propTypesDefault.default).string,
    /** An `onClick` handler passed to the Toggle component */ onClick: (0, _propTypesDefault.default).func,
    /** The content of the non-toggle Button.  */ title: (0, _propTypesDefault.default).node.isRequired,
    /** Disables both Buttons  */ disabled: (0, _propTypesDefault.default).bool,
    /**
   * Aligns the dropdown menu.
   *
   * _see [DropdownMenu](#dropdown-menu-props) for more details_
   *
   * @type {"start"|"end"|{ sm: "start"|"end" }|{ md: "start"|"end" }|{ lg: "start"|"end" }|{ xl: "start"|"end"}|{ xxl: "start"|"end"} }
   */ align: (0, _types.alignPropType),
    /** An ARIA accessible role applied to the Menu component. When set to 'menu', The dropdown */ menuRole: (0, _propTypesDefault.default).string,
    /** Whether to render the dropdown menu in the DOM before the first time it is shown */ renderMenuOnMount: (0, _propTypesDefault.default).bool,
    /**
   *  Which event when fired outside the component will cause it to be closed.
   *
   * _see [DropdownMenu](#dropdown-menu-props) for more details_
   */ rootCloseEvent: (0, _propTypesDefault.default).string,
    /**
   * Menu color variant.
   *
   * Omitting this will use the default light color.
   */ menuVariant: (0, _propTypesDefault.default).oneOf([
        'dark'
    ]),
    /**
   * Allow Dropdown to flip in case of an overlapping on the reference element. For more information refer to
   * Popper.js's flip [docs](https://popper.js.org/docs/v2/modifiers/flip/).
   *
   */ flip: (0, _propTypesDefault.default).bool,
    /** @ignore */ bsPrefix: (0, _propTypesDefault.default).string,
    /** @ignore */ variant: (0, _propTypesDefault.default).string,
    /** @ignore */ size: (0, _propTypesDefault.default).string
};
/**
 * A convenience component for simple or general use dropdowns. Renders a `Button` toggle and all `children`
 * are passed directly to the default `Dropdown.Menu`. This component accepts all of
 * [`Dropdown`'s props](#dropdown-props).
 *
 * _All unknown props are passed through to the `Dropdown` component._ Only
 * the Button `variant`, `size` and `bsPrefix` props are passed to the toggle,
 * along with menu-related props are passed to the `Dropdown.Menu`
 */ const DropdownButton = /*#__PURE__*/ _react.forwardRef(({ title, children, bsPrefix, rootCloseEvent, variant, size, menuRole, renderMenuOnMount, disabled, href, id, menuVariant, flip, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dropdownDefault.default), {
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownToggleDefault.default), {
                id: id,
                href: href,
                size: size,
                variant: variant,
                disabled: disabled,
                childBsPrefix: bsPrefix,
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenuDefault.default), {
                role: menuRole,
                renderOnMount: renderMenuOnMount,
                rootCloseEvent: rootCloseEvent,
                variant: menuVariant,
                flip: flip,
                children: children
            })
        ]
    }));
DropdownButton.displayName = 'DropdownButton';
DropdownButton.propTypes = propTypes;
exports.default = DropdownButton;

},{"react":"bmhQu","prop-types":"gLXGb","./Dropdown":"7uokG","./DropdownToggle":"9yXfJ","./DropdownMenu":"6sEFY","./types":"bbBUb","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fBRm1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _figureImage = require("./FigureImage");
var _figureImageDefault = parcelHelpers.interopDefault(_figureImage);
var _figureCaption = require("./FigureCaption");
var _figureCaptionDefault = parcelHelpers.interopDefault(_figureCaption);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Figure = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'figure', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'figure');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
Figure.displayName = 'Figure';
exports.default = Object.assign(Figure, {
    Image: (0, _figureImageDefault.default),
    Caption: (0, _figureCaptionDefault.default)
});

},{"react":"bmhQu","classnames":"9HH2M","./FigureImage":"cbPkT","./FigureCaption":"c7Ux8","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cbPkT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _image = require("./Image");
var _imageDefault = parcelHelpers.interopDefault(_image);
var _jsxRuntime = require("react/jsx-runtime");
const FigureImage = /*#__PURE__*/ _react.forwardRef(({ className, fluid = true, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imageDefault.default), {
        ref: ref,
        ...props,
        fluid: fluid,
        className: (0, _classnamesDefault.default)(className, 'figure-img')
    }));
FigureImage.displayName = 'FigureImage';
FigureImage.propTypes = (0, _image.propTypes);
exports.default = FigureImage;

},{"classnames":"9HH2M","react":"bmhQu","./Image":"3rbpJ","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3rbpJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "propTypes", ()=>propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const propTypes = {
    /**
   * @default 'img'
   */ bsPrefix: (0, _propTypesDefault.default).string,
    /**
   * Sets image as fluid image.
   */ fluid: (0, _propTypesDefault.default).bool,
    /**
   * Sets image shape as rounded.
   */ rounded: (0, _propTypesDefault.default).bool,
    /**
   * Sets image shape as circle.
   */ roundedCircle: (0, _propTypesDefault.default).bool,
    /**
   * Sets image shape as thumbnail.
   */ thumbnail: (0, _propTypesDefault.default).bool
};
const Image = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, fluid = false, rounded = false, roundedCircle = false, thumbnail = false, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'img');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
        ref: ref,
        ...props,
        className: (0, _classnamesDefault.default)(className, fluid && `${bsPrefix}-fluid`, rounded && `rounded`, roundedCircle && `rounded-circle`, thumbnail && `${bsPrefix}-thumbnail`)
    });
});
Image.displayName = 'Image';
exports.default = Image;

},{"classnames":"9HH2M","react":"bmhQu","prop-types":"gLXGb","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c7Ux8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FigureCaption = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'figcaption', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'figure-caption');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
FigureCaption.displayName = 'FigureCaption';
exports.default = FigureCaption;

},{"react":"bmhQu","classnames":"9HH2M","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iMBBh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _formCheck = require("./FormCheck");
var _formCheckDefault = parcelHelpers.interopDefault(_formCheck);
var _formControl = require("./FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _formFloating = require("./FormFloating");
var _formFloatingDefault = parcelHelpers.interopDefault(_formFloating);
var _formGroup = require("./FormGroup");
var _formGroupDefault = parcelHelpers.interopDefault(_formGroup);
var _formLabel = require("./FormLabel");
var _formLabelDefault = parcelHelpers.interopDefault(_formLabel);
var _formRange = require("./FormRange");
var _formRangeDefault = parcelHelpers.interopDefault(_formRange);
var _formSelect = require("./FormSelect");
var _formSelectDefault = parcelHelpers.interopDefault(_formSelect);
var _formText = require("./FormText");
var _formTextDefault = parcelHelpers.interopDefault(_formText);
var _switch = require("./Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _floatingLabel = require("./FloatingLabel");
var _floatingLabelDefault = parcelHelpers.interopDefault(_floatingLabel);
var _jsxRuntime = require("react/jsx-runtime");
const propTypes = {
    /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */ _ref: (0, _propTypesDefault.default).any,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: (0, _propTypesDefault.default).bool,
    as: (0, _propTypesDefault.default).elementType
};
const Form = /*#__PURE__*/ _react.forwardRef(({ className, validated, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'form', ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, _classnamesDefault.default)(className, validated && 'was-validated')
    }));
Form.displayName = 'Form';
Form.propTypes = propTypes;
exports.default = Object.assign(Form, {
    Group: (0, _formGroupDefault.default),
    Control: (0, _formControlDefault.default),
    Floating: (0, _formFloatingDefault.default),
    Check: (0, _formCheckDefault.default),
    Switch: (0, _switchDefault.default),
    Label: (0, _formLabelDefault.default),
    Text: (0, _formTextDefault.default),
    Range: (0, _formRangeDefault.default),
    Select: (0, _formSelectDefault.default),
    FloatingLabel: (0, _floatingLabelDefault.default)
});

},{"classnames":"9HH2M","prop-types":"gLXGb","react":"bmhQu","./FormCheck":"977FY","./FormControl":"lyROR","./FormFloating":"iULhb","./FormGroup":"7EfpY","./FormLabel":"jAE2J","./FormRange":"buLNF","./FormSelect":"bNV4p","./FormText":"4XNmI","./Switch":"k8fb6","./FloatingLabel":"3fazd","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"977FY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _feedback = require("./Feedback");
var _feedbackDefault = parcelHelpers.interopDefault(_feedback);
var _formCheckInput = require("./FormCheckInput");
var _formCheckInputDefault = parcelHelpers.interopDefault(_formCheckInput);
var _formCheckLabel = require("./FormCheckLabel");
var _formCheckLabelDefault = parcelHelpers.interopDefault(_formCheckLabel);
var _formContext = require("./FormContext");
var _formContextDefault = parcelHelpers.interopDefault(_formContext);
var _themeProvider = require("./ThemeProvider");
var _elementChildren = require("./ElementChildren");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FormCheck = /*#__PURE__*/ _react.forwardRef(({ id, bsPrefix, bsSwitchPrefix, inline = false, reverse = false, disabled = false, isValid = false, isInvalid = false, feedbackTooltip = false, feedback, feedbackType, className, style, title = '', type = 'checkbox', label, children, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as = 'input', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'form-check');
    bsSwitchPrefix = (0, _themeProvider.useBootstrapPrefix)(bsSwitchPrefix, 'form-switch');
    const { controlId } = (0, _react.useContext)((0, _formContextDefault.default));
    const innerFormContext = (0, _react.useMemo)(()=>({
            controlId: id || controlId
        }), [
        controlId,
        id
    ]);
    const hasLabel = !children && label != null && label !== false || (0, _elementChildren.hasChildOfType)(children, (0, _formCheckLabelDefault.default));
    const input = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formCheckInputDefault.default), {
        ...props,
        type: type === 'switch' ? 'checkbox' : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: as
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formContextDefault.default).Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            style: style,
            className: (0, _classnamesDefault.default)(className, hasLabel && bsPrefix, inline && `${bsPrefix}-inline`, reverse && `${bsPrefix}-reverse`, type === 'switch' && bsSwitchPrefix),
            children: children || /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formCheckLabelDefault.default), {
                        title: title,
                        children: label
                    }),
                    feedback && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _feedbackDefault.default), {
                        type: feedbackType,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
FormCheck.displayName = 'FormCheck';
exports.default = Object.assign(FormCheck, {
    Input: (0, _formCheckInputDefault.default),
    Label: (0, _formCheckLabelDefault.default)
});

},{"classnames":"9HH2M","react":"bmhQu","./Feedback":"6ZPJv","./FormCheckInput":"6Bo9v","./FormCheckLabel":"1j6Fn","./FormContext":"gJVRs","./ThemeProvider":"aQ1Mj","./ElementChildren":"iO22F","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6ZPJv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _jsxRuntime = require("react/jsx-runtime");
const propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, _propTypesDefault.default).string,
    /** Display feedback as a tooltip. */ tooltip: (0, _propTypesDefault.default).bool,
    as: (0, _propTypesDefault.default).elementType
};
const Feedback = /*#__PURE__*/ _react.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ as: Component = 'div', className, type = 'valid', tooltip = false, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, _classnamesDefault.default)(className, `${type}-${tooltip ? 'tooltip' : 'feedback'}`)
    }));
Feedback.displayName = 'Feedback';
Feedback.propTypes = propTypes;
exports.default = Feedback;

},{"classnames":"9HH2M","react":"bmhQu","prop-types":"gLXGb","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1j6Fn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _formContext = require("./FormContext");
var _formContextDefault = parcelHelpers.interopDefault(_formContext);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FormCheckLabel = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, htmlFor, ...props }, ref)=>{
    const { controlId } = (0, _react.useContext)((0, _formContextDefault.default));
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'form-check-label');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
        ...props,
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, _classnamesDefault.default)(className, bsPrefix)
    });
});
FormCheckLabel.displayName = 'FormCheckLabel';
exports.default = FormCheckLabel;

},{"classnames":"9HH2M","react":"bmhQu","./FormContext":"gJVRs","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lyROR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _feedback = require("./Feedback");
var _feedbackDefault = parcelHelpers.interopDefault(_feedback);
var _formContext = require("./FormContext");
var _formContextDefault = parcelHelpers.interopDefault(_formContext);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FormControl = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, type, size, htmlSize, id, className, isValid = false, isInvalid = false, plaintext, readOnly, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId } = (0, _react.useContext)((0, _formContextDefault.default));
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'form-control');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, _classnamesDefault.default)(className, plaintext ? `${bsPrefix}-plaintext` : bsPrefix, size && `${bsPrefix}-${size}`, type === 'color' && `${bsPrefix}-color`, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
FormControl.displayName = 'FormControl';
exports.default = Object.assign(FormControl, {
    Feedback: (0, _feedbackDefault.default)
});

},{"classnames":"9HH2M","react":"bmhQu","warning":"fSSz5","./Feedback":"6ZPJv","./FormContext":"gJVRs","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iULhb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FormFloating = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
FormFloating.displayName = 'FormFloating';
exports.default = FormFloating;

},{"react":"bmhQu","classnames":"9HH2M","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7EfpY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _formContext = require("./FormContext");
var _formContextDefault = parcelHelpers.interopDefault(_formContext);
var _jsxRuntime = require("react/jsx-runtime");
const FormGroup = /*#__PURE__*/ _react.forwardRef(({ controlId, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const context = (0, _react.useMemo)(()=>({
            controlId
        }), [
        controlId
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formContextDefault.default).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
            ...props,
            ref: ref
        })
    });
});
FormGroup.displayName = 'FormGroup';
exports.default = FormGroup;

},{"react":"bmhQu","./FormContext":"gJVRs","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jAE2J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _col = require("./Col");
var _colDefault = parcelHelpers.interopDefault(_col);
var _formContext = require("./FormContext");
var _formContextDefault = parcelHelpers.interopDefault(_formContext);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FormLabel = /*#__PURE__*/ _react.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'label', bsPrefix, column = false, visuallyHidden = false, className, htmlFor, ...props }, ref)=>{
    const { controlId } = (0, _react.useContext)((0, _formContextDefault.default));
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'form-label');
    let columnClass = 'col-form-label';
    if (typeof column === 'string') columnClass = `${columnClass} ${columnClass}-${column}`;
    const classes = (0, _classnamesDefault.default)(className, bsPrefix, visuallyHidden && 'visually-hidden', column && columnClass);
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _colDefault.default), {
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
});
FormLabel.displayName = 'FormLabel';
exports.default = FormLabel;

},{"classnames":"9HH2M","react":"bmhQu","warning":"fSSz5","./Col":"ii9A3","./FormContext":"gJVRs","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"buLNF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _formContext = require("./FormContext");
var _formContextDefault = parcelHelpers.interopDefault(_formContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FormRange = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, id, ...props }, ref)=>{
    const { controlId } = (0, _react.useContext)((0, _formContextDefault.default));
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'form-range');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
        ...props,
        type: "range",
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        id: id || controlId
    });
});
FormRange.displayName = 'FormRange';
exports.default = FormRange;

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","./FormContext":"gJVRs","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bNV4p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _formContext = require("./FormContext");
var _formContextDefault = parcelHelpers.interopDefault(_formContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FormSelect = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, size, htmlSize, className, isValid = false, isInvalid = false, id, ...props }, ref)=>{
    const { controlId } = (0, _react.useContext)((0, _formContextDefault.default));
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'form-select');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
        ...props,
        size: htmlSize,
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix, size && `${bsPrefix}-${size}`, isValid && `is-valid`, isInvalid && `is-invalid`),
        id: id || controlId
    });
});
FormSelect.displayName = 'FormSelect';
exports.default = FormSelect;

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","./FormContext":"gJVRs","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4XNmI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FormText = /*#__PURE__*/ _react.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix, className, as: Component = 'small', muted, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'form-text');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix, muted && 'text-muted')
    });
});
FormText.displayName = 'FormText';
exports.default = FormText;

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k8fb6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _formCheck = require("./FormCheck");
var _formCheckDefault = parcelHelpers.interopDefault(_formCheck);
var _jsxRuntime = require("react/jsx-runtime");
const Switch = /*#__PURE__*/ _react.forwardRef((props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formCheckDefault.default), {
        ...props,
        ref: ref,
        type: "switch"
    }));
Switch.displayName = 'Switch';
exports.default = Object.assign(Switch, {
    Input: (0, _formCheckDefault.default).Input,
    Label: (0, _formCheckDefault.default).Label
});

},{"react":"bmhQu","./FormCheck":"977FY","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3fazd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _formGroup = require("./FormGroup");
var _formGroupDefault = parcelHelpers.interopDefault(_formGroup);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const FloatingLabel = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, children, controlId, label, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formGroupDefault.default), {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        controlId: controlId,
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: controlId,
                children: label
            })
        ]
    });
});
FloatingLabel.displayName = 'FloatingLabel';
exports.default = FloatingLabel;

},{"classnames":"9HH2M","react":"bmhQu","./FormGroup":"7EfpY","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lPYmk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _uncontrollable = require("uncontrollable");
var _nav = require("@restart/ui/Nav");
var _navDefault = parcelHelpers.interopDefault(_nav);
var _themeProvider = require("./ThemeProvider");
var _listGroupItem = require("./ListGroupItem");
var _listGroupItemDefault = parcelHelpers.interopDefault(_listGroupItem);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const ListGroup = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { className, bsPrefix: initialBsPrefix, variant, horizontal, numbered, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as = 'div', ...controlledProps } = (0, _uncontrollable.useUncontrolled)(props, {
        activeKey: 'onSelect'
    });
    const bsPrefix = (0, _themeProvider.useBootstrapPrefix)(initialBsPrefix, 'list-group');
    let horizontalVariant;
    if (horizontal) horizontalVariant = horizontal === true ? 'horizontal' : `horizontal-${horizontal}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navDefault.default), {
        ref: ref,
        ...controlledProps,
        as: as,
        className: (0, _classnamesDefault.default)(className, bsPrefix, variant && `${bsPrefix}-${variant}`, horizontalVariant && `${bsPrefix}-${horizontalVariant}`, numbered && `${bsPrefix}-numbered`)
    });
});
ListGroup.displayName = 'ListGroup';
exports.default = Object.assign(ListGroup, {
    Item: (0, _listGroupItemDefault.default)
});

},{"classnames":"9HH2M","react":"bmhQu","warning":"fSSz5","uncontrollable":"1yRhe","@restart/ui/Nav":"hvvF8","./ThemeProvider":"aQ1Mj","./ListGroupItem":"ixfAY","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ixfAY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _navItem = require("@restart/ui/NavItem");
var _selectableContext = require("@restart/ui/SelectableContext");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const ListGroupItem = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, active, disabled, eventKey, className, variant, action, as, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'list-group-item');
    const [navItemProps, meta] = (0, _navItem.useNavItem)({
        key: (0, _selectableContext.makeEventKey)(eventKey, props.href),
        active,
        ...props
    });
    const handleClick = (0, _useEventCallbackDefault.default)((event)=>{
        if (disabled) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        navItemProps.onClick(event);
    });
    if (disabled && props.tabIndex === undefined) {
        props.tabIndex = -1;
        props['aria-disabled'] = true;
    }
    const Component = as || (action ? props.href ? 'a' : 'button' : 'div');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        ...props,
        ...navItemProps,
        onClick: handleClick,
        className: (0, _classnamesDefault.default)(className, bsPrefix, meta.isActive && 'active', disabled && 'disabled', variant && `${bsPrefix}-${variant}`, action && `${bsPrefix}-action`)
    });
});
ListGroupItem.displayName = 'ListGroupItem';
exports.default = ListGroupItem;

},{"classnames":"9HH2M","react":"bmhQu","warning":"fSSz5","@restart/hooks/useEventCallback":"8gfnN","@restart/ui/NavItem":"fiRYi","@restart/ui/SelectableContext":"e59aX","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"92IrJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _addEventListener = require("dom-helpers/addEventListener");
var _addEventListenerDefault = parcelHelpers.interopDefault(_addEventListener);
var _canUseDOM = require("dom-helpers/canUseDOM");
var _canUseDOMDefault = parcelHelpers.interopDefault(_canUseDOM);
var _ownerDocument = require("dom-helpers/ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
var _removeEventListener = require("dom-helpers/removeEventListener");
var _removeEventListenerDefault = parcelHelpers.interopDefault(_removeEventListener);
var _scrollbarSize = require("dom-helpers/scrollbarSize");
var _scrollbarSizeDefault = parcelHelpers.interopDefault(_scrollbarSize);
var _useCallbackRef = require("@restart/hooks/useCallbackRef");
var _useCallbackRefDefault = parcelHelpers.interopDefault(_useCallbackRef);
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
var _useWillUnmount = require("@restart/hooks/useWillUnmount");
var _useWillUnmountDefault = parcelHelpers.interopDefault(_useWillUnmount);
var _transitionEnd = require("dom-helpers/transitionEnd");
var _transitionEndDefault = parcelHelpers.interopDefault(_transitionEnd);
var _react = require("react");
var _modal = require("@restart/ui/Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _bootstrapModalManager = require("./BootstrapModalManager");
var _fade = require("./Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _modalBody = require("./ModalBody");
var _modalBodyDefault = parcelHelpers.interopDefault(_modalBody);
var _modalContext = require("./ModalContext");
var _modalContextDefault = parcelHelpers.interopDefault(_modalContext);
var _modalDialog = require("./ModalDialog");
var _modalDialogDefault = parcelHelpers.interopDefault(_modalDialog);
var _modalFooter = require("./ModalFooter");
var _modalFooterDefault = parcelHelpers.interopDefault(_modalFooter);
var _modalHeader = require("./ModalHeader");
var _modalHeaderDefault = parcelHelpers.interopDefault(_modalHeader);
var _modalTitle = require("./ModalTitle");
var _modalTitleDefault = parcelHelpers.interopDefault(_modalTitle);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function DialogTransition(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeDefault.default), {
        ...props,
        timeout: null
    });
}
function BackdropTransition(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeDefault.default), {
        ...props,
        timeout: null
    });
}
const Modal = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, style, dialogClassName, contentClassName, children, dialogAs: Dialog = (0, _modalDialogDefault.default), 'data-bs-theme': dataBsTheme, 'aria-labelledby': ariaLabelledby, 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, /* BaseModal props */ show = false, animation = true, backdrop = true, keyboard = true, onEscapeKeyDown, onShow, onHide, container, autoFocus = true, enforceFocus = true, restoreFocus = true, restoreFocusOptions, onEntered, onExit, onExiting, onEnter, onEntering, onExited, backdropClassName, manager: propsManager, ...props }, ref)=>{
    const [modalStyle, setStyle] = (0, _react.useState)({});
    const [animateStaticModal, setAnimateStaticModal] = (0, _react.useState)(false);
    const waitingForMouseUpRef = (0, _react.useRef)(false);
    const ignoreBackdropClickRef = (0, _react.useRef)(false);
    const removeStaticModalAnimationRef = (0, _react.useRef)(null);
    const [modal, setModalRef] = (0, _useCallbackRefDefault.default)();
    const mergedRef = (0, _useMergedRefsDefault.default)(ref, setModalRef);
    const handleHide = (0, _useEventCallbackDefault.default)(onHide);
    const isRTL = (0, _themeProvider.useIsRTL)();
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'modal');
    const modalContext = (0, _react.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        return (0, _bootstrapModalManager.getSharedManager)({
            isRTL
        });
    }
    function updateDialogStyle(node) {
        if (!(0, _canUseDOMDefault.default)) return;
        const containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
        const modalIsOverflowing = node.scrollHeight > (0, _ownerDocumentDefault.default)(node).documentElement.clientHeight;
        setStyle({
            paddingRight: containerIsOverflowing && !modalIsOverflowing ? (0, _scrollbarSizeDefault.default)() : undefined,
            paddingLeft: !containerIsOverflowing && modalIsOverflowing ? (0, _scrollbarSizeDefault.default)() : undefined
        });
    }
    const handleWindowResize = (0, _useEventCallbackDefault.default)(()=>{
        if (modal) updateDialogStyle(modal.dialog);
    });
    (0, _useWillUnmountDefault.default)(()=>{
        (0, _removeEventListenerDefault.default)(window, 'resize', handleWindowResize);
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
    });
    // We prevent the modal from closing during a drag by detecting where the
    // click originates from. If it starts in the modal and then ends outside
    // don't close.
    const handleDialogMouseDown = ()=>{
        waitingForMouseUpRef.current = true;
    };
    const handleMouseUp = (e)=>{
        if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) ignoreBackdropClickRef.current = true;
        waitingForMouseUpRef.current = false;
    };
    const handleStaticModalAnimation = ()=>{
        setAnimateStaticModal(true);
        removeStaticModalAnimationRef.current = (0, _transitionEndDefault.default)(modal.dialog, ()=>{
            setAnimateStaticModal(false);
        });
    };
    const handleStaticBackdropClick = (e)=>{
        if (e.target !== e.currentTarget) return;
        handleStaticModalAnimation();
    };
    const handleClick = (e)=>{
        if (backdrop === 'static') {
            handleStaticBackdropClick(e);
            return;
        }
        if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
            ignoreBackdropClickRef.current = false;
            return;
        }
        onHide == null || onHide();
    };
    const handleEscapeKeyDown = (e)=>{
        if (keyboard) onEscapeKeyDown == null || onEscapeKeyDown(e);
        else {
            // Call preventDefault to stop modal from closing in @restart/ui.
            e.preventDefault();
            if (backdrop === 'static') // Play static modal animation.
            handleStaticModalAnimation();
        }
    };
    const handleEnter = (node, isAppearing)=>{
        if (node) updateDialogStyle(node);
        onEnter == null || onEnter(node, isAppearing);
    };
    const handleExit = (node)=>{
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
        onExit == null || onExit(node);
    };
    const handleEntering = (node, isAppearing)=>{
        onEntering == null || onEntering(node, isAppearing);
        // FIXME: This should work even when animation is disabled.
        (0, _addEventListenerDefault.default)(window, 'resize', handleWindowResize);
    };
    const handleExited = (node)=>{
        if (node) node.style.display = ''; // RHL removes it sometimes
        onExited == null || onExited(node);
        // FIXME: This should work even when animation is disabled.
        (0, _removeEventListenerDefault.default)(window, 'resize', handleWindowResize);
    };
    const renderBackdrop = (0, _react.useCallback)((backdropProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            ...backdropProps,
            className: (0, _classnamesDefault.default)(`${bsPrefix}-backdrop`, backdropClassName, !animation && 'show')
        }), [
        animation,
        backdropClassName,
        bsPrefix
    ]);
    const baseModalStyle = {
        ...style,
        ...modalStyle
    };
    // If `display` is not set to block, autoFocus inside the modal fails
    // https://github.com/react-bootstrap/react-bootstrap/issues/5102
    baseModalStyle.display = 'block';
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            role: "dialog",
            ...dialogProps,
            style: baseModalStyle,
            className: (0, _classnamesDefault.default)(className, bsPrefix, animateStaticModal && `${bsPrefix}-static`, !animation && 'show'),
            onClick: backdrop ? handleClick : undefined,
            onMouseUp: handleMouseUp,
            "data-bs-theme": dataBsTheme,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledby,
            "aria-describedby": ariaDescribedby,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Dialog, {
                ...props,
                onMouseDown: handleDialogMouseDown,
                className: dialogClassName,
                contentClassName: contentClassName,
                children: children
            })
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalContextDefault.default).Provider, {
        value: modalContext,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDefault.default), {
            show: show,
            ref: mergedRef,
            backdrop: backdrop,
            container: container,
            keyboard: true // Always set true - see handleEscapeKeyDown
            ,
            autoFocus: autoFocus,
            enforceFocus: enforceFocus,
            restoreFocus: restoreFocus,
            restoreFocusOptions: restoreFocusOptions,
            onEscapeKeyDown: handleEscapeKeyDown,
            onShow: onShow,
            onHide: onHide,
            onEnter: handleEnter,
            onEntering: handleEntering,
            onEntered: onEntered,
            onExit: handleExit,
            onExiting: onExiting,
            onExited: handleExited,
            manager: getModalManager(),
            transition: animation ? DialogTransition : undefined,
            backdropTransition: animation ? BackdropTransition : undefined,
            renderBackdrop: renderBackdrop,
            renderDialog: renderDialog
        })
    });
});
Modal.displayName = 'Modal';
exports.default = Object.assign(Modal, {
    Body: (0, _modalBodyDefault.default),
    Header: (0, _modalHeaderDefault.default),
    Title: (0, _modalTitleDefault.default),
    Footer: (0, _modalFooterDefault.default),
    Dialog: (0, _modalDialogDefault.default),
    TRANSITION_DURATION: 300,
    BACKDROP_TRANSITION_DURATION: 150
});

},{"classnames":"9HH2M","dom-helpers/addEventListener":"fjZpG","dom-helpers/canUseDOM":"b1d70","dom-helpers/ownerDocument":"4O8MX","dom-helpers/removeEventListener":"185GE","dom-helpers/scrollbarSize":"es16G","@restart/hooks/useCallbackRef":"1Oxy7","@restart/hooks/useEventCallback":"8gfnN","@restart/hooks/useMergedRefs":"ai8mn","@restart/hooks/useWillUnmount":"8eQCP","dom-helpers/transitionEnd":"etfsa","react":"bmhQu","@restart/ui/Modal":"41jvx","./BootstrapModalManager":"fPmGg","./Fade":"iLhiL","./ModalBody":"6OsGC","./ModalContext":"3Poo0","./ModalDialog":"bV6m5","./ModalFooter":"5NIrW","./ModalHeader":"coXPD","./ModalTitle":"6CGnd","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"es16G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>scrollbarSize);
var _canUseDOM = require("./canUseDOM");
var _canUseDOMDefault = parcelHelpers.interopDefault(_canUseDOM);
var size;
function scrollbarSize(recalc) {
    if (!size && size !== 0 || recalc) {
        if (0, _canUseDOMDefault.default) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return size;
}

},{"./canUseDOM":"b1d70","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1Oxy7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useCallbackRef);
var _react = require("react");
function useCallbackRef() {
    return (0, _react.useState)(null);
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6OsGC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const ModalBody = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'modal-body');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
ModalBody.displayName = 'ModalBody';
exports.default = ModalBody;

},{"react":"bmhQu","classnames":"9HH2M","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bV6m5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const ModalDialog = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, contentClassName, centered, size, fullscreen, children, scrollable, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'modal');
    const dialogClass = `${bsPrefix}-dialog`;
    const fullScreenClass = typeof fullscreen === 'string' ? `${bsPrefix}-fullscreen-${fullscreen}` : `${bsPrefix}-fullscreen`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, _classnamesDefault.default)(dialogClass, className, size && `${bsPrefix}-${size}`, centered && `${dialogClass}-centered`, scrollable && `${dialogClass}-scrollable`, fullscreen && fullScreenClass),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: (0, _classnamesDefault.default)(`${bsPrefix}-content`, contentClassName),
            children: children
        })
    });
});
ModalDialog.displayName = 'ModalDialog';
exports.default = ModalDialog;

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5NIrW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const ModalFooter = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'modal-footer');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
ModalFooter.displayName = 'ModalFooter';
exports.default = ModalFooter;

},{"react":"bmhQu","classnames":"9HH2M","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"coXPD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _abstractModalHeader = require("./AbstractModalHeader");
var _abstractModalHeaderDefault = parcelHelpers.interopDefault(_abstractModalHeader);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const ModalHeader = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, closeLabel = 'Close', closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'modal-header');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _abstractModalHeaderDefault.default), {
        ref: ref,
        ...props,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
ModalHeader.displayName = 'ModalHeader';
exports.default = ModalHeader;

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","./AbstractModalHeader":"3ht9b","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6CGnd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _divWithClassName = require("./divWithClassName");
var _divWithClassNameDefault = parcelHelpers.interopDefault(_divWithClassName);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const DivStyledAsH4 = (0, _divWithClassNameDefault.default)('h4');
const ModalTitle = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'modal-title');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
ModalTitle.displayName = 'ModalTitle';
exports.default = ModalTitle;

},{"react":"bmhQu","classnames":"9HH2M","./divWithClassName":"kXtiN","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"89Q0I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _overlay = require("@restart/ui/Overlay");
var _overlayDefault = parcelHelpers.interopDefault(_overlay);
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useIsomorphicEffect = require("@restart/hooks/useIsomorphicEffect");
var _useIsomorphicEffectDefault = parcelHelpers.interopDefault(_useIsomorphicEffect);
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
var _useOverlayOffset = require("./useOverlayOffset");
var _useOverlayOffsetDefault = parcelHelpers.interopDefault(_useOverlayOffset);
var _fade = require("./Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _safeFindDOMNode = require("./safeFindDOMNode");
var _safeFindDOMNodeDefault = parcelHelpers.interopDefault(_safeFindDOMNode);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function wrapRefs(props, arrowProps) {
    const { ref } = props;
    const { ref: aRef } = arrowProps;
    props.ref = ref.__wrapped || (ref.__wrapped = (r)=>ref((0, _safeFindDOMNodeDefault.default)(r)));
    arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = (r)=>aRef((0, _safeFindDOMNodeDefault.default)(r)));
}
const Overlay = /*#__PURE__*/ _react.forwardRef(({ children: overlay, transition = (0, _fadeDefault.default), popperConfig = {}, rootClose = false, placement = 'top', show: outerShow = false, ...outerProps }, outerRef)=>{
    const popperRef = (0, _react.useRef)({});
    const [firstRenderedState, setFirstRenderedState] = (0, _react.useState)(null);
    const [ref, modifiers] = (0, _useOverlayOffsetDefault.default)(outerProps.offset);
    const mergedRef = (0, _useMergedRefsDefault.default)(outerRef, ref);
    const actualTransition = transition === true ? (0, _fadeDefault.default) : transition || undefined;
    const handleFirstUpdate = (0, _useEventCallbackDefault.default)((state)=>{
        setFirstRenderedState(state);
        popperConfig == null || popperConfig.onFirstUpdate == null || popperConfig.onFirstUpdate(state);
    });
    (0, _useIsomorphicEffectDefault.default)(()=>{
        if (firstRenderedState && outerProps.target) // Must wait for target element to resolve before updating popper.
        popperRef.current.scheduleUpdate == null || popperRef.current.scheduleUpdate();
    }, [
        firstRenderedState,
        outerProps.target
    ]);
    (0, _react.useEffect)(()=>{
        if (!outerShow) setFirstRenderedState(null);
    }, [
        outerShow
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overlayDefault.default), {
        ...outerProps,
        ref: mergedRef,
        popperConfig: {
            ...popperConfig,
            modifiers: modifiers.concat(popperConfig.modifiers || []),
            onFirstUpdate: handleFirstUpdate
        },
        transition: actualTransition,
        rootClose: rootClose,
        placement: placement,
        show: outerShow,
        children: (overlayProps, { arrowProps, popper: popperObj, show })=>{
            var _popperObj$state;
            wrapRefs(overlayProps, arrowProps);
            // Need to get placement from popper object, handling case when overlay is flipped using 'flip' prop
            const updatedPlacement = popperObj == null ? void 0 : popperObj.placement;
            const popper = Object.assign(popperRef.current, {
                state: popperObj == null ? void 0 : popperObj.state,
                scheduleUpdate: popperObj == null ? void 0 : popperObj.update,
                placement: updatedPlacement,
                outOfBoundaries: (popperObj == null || (_popperObj$state = popperObj.state) == null || (_popperObj$state = _popperObj$state.modifiersData.hide) == null ? void 0 : _popperObj$state.isReferenceHidden) || false,
                strategy: popperConfig.strategy
            });
            const hasDoneInitialMeasure = !!firstRenderedState;
            if (typeof overlay === 'function') return overlay({
                ...overlayProps,
                placement: updatedPlacement,
                show,
                ...!transition && show && {
                    className: 'show'
                },
                popper,
                arrowProps,
                hasDoneInitialMeasure
            });
            return /*#__PURE__*/ _react.cloneElement(overlay, {
                ...overlayProps,
                placement: updatedPlacement,
                arrowProps,
                popper,
                hasDoneInitialMeasure,
                className: (0, _classnamesDefault.default)(overlay.props.className, !transition && show && 'show'),
                style: {
                    ...overlay.props.style,
                    ...overlayProps.style
                }
            });
        }
    });
});
Overlay.displayName = 'Overlay';
exports.default = Overlay;

},{"react":"bmhQu","classnames":"9HH2M","@restart/ui/Overlay":"7VDo8","@restart/hooks/useEventCallback":"8gfnN","@restart/hooks/useIsomorphicEffect":"gqtk8","@restart/hooks/useMergedRefs":"ai8mn","./useOverlayOffset":"50qG8","./Fade":"iLhiL","./safeFindDOMNode":"4l67l","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7VDo8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _useCallbackRef = require("@restart/hooks/useCallbackRef");
var _useCallbackRefDefault = parcelHelpers.interopDefault(_useCallbackRef);
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
var _usePopper = require("./usePopper");
var _usePopperDefault = parcelHelpers.interopDefault(_usePopper);
var _useRootClose = require("./useRootClose");
var _useRootCloseDefault = parcelHelpers.interopDefault(_useRootClose);
var _useWaitForDOMRef = require("./useWaitForDOMRef");
var _useWaitForDOMRefDefault = parcelHelpers.interopDefault(_useWaitForDOMRef);
var _mergeOptionsWithPopperConfig = require("./mergeOptionsWithPopperConfig");
var _mergeOptionsWithPopperConfigDefault = parcelHelpers.interopDefault(_mergeOptionsWithPopperConfig);
var _imperativeTransition = require("./ImperativeTransition");
/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */ const Overlay = /*#__PURE__*/ _react.forwardRef((props, outerRef)=>{
    const { flip, offset, placement, containerPadding, popperConfig = {}, transition: Transition, runTransition } = props;
    const [rootElement, attachRef] = (0, _useCallbackRefDefault.default)();
    const [arrowElement, attachArrowRef] = (0, _useCallbackRefDefault.default)();
    const mergedRef = (0, _useMergedRefsDefault.default)(attachRef, outerRef);
    const container = (0, _useWaitForDOMRefDefault.default)(props.container);
    const target = (0, _useWaitForDOMRefDefault.default)(props.target);
    const [exited, setExited] = (0, _react.useState)(!props.show);
    const popper = (0, _usePopperDefault.default)(target, rootElement, (0, _mergeOptionsWithPopperConfigDefault.default)({
        placement,
        enableEvents: !!props.show,
        containerPadding: containerPadding || 5,
        flip,
        offset,
        arrowElement,
        popperConfig
    }));
    // TODO: I think this needs to be in an effect
    if (props.show && exited) setExited(false);
    const handleHidden = (...args)=>{
        setExited(true);
        if (props.onExited) props.onExited(...args);
    };
    // Don't un-render the overlay while it's transitioning out.
    const mountOverlay = props.show || !exited;
    (0, _useRootCloseDefault.default)(rootElement, props.onHide, {
        disabled: !props.rootClose || props.rootCloseDisabled,
        clickTrigger: props.rootCloseEvent
    });
    if (!mountOverlay) // Don't bother showing anything if we don't have to.
    return null;
    const { onExit, onExiting, onEnter, onEntering, onEntered } = props;
    let child = props.children(Object.assign({}, popper.attributes.popper, {
        style: popper.styles.popper,
        ref: mergedRef
    }), {
        popper,
        placement,
        show: !!props.show,
        arrowProps: Object.assign({}, popper.attributes.arrow, {
            style: popper.styles.arrow,
            ref: attachArrowRef
        })
    });
    child = (0, _imperativeTransition.renderTransition)(Transition, runTransition, {
        in: !!props.show,
        appear: true,
        mountOnEnter: true,
        unmountOnExit: true,
        children: child,
        onExit,
        onExiting,
        onExited: handleHidden,
        onEnter,
        onEntering,
        onEntered
    });
    return container ? /*#__PURE__*/ (0, _reactDomDefault.default).createPortal(child, container) : null;
});
Overlay.displayName = 'Overlay';
exports.default = Overlay;

},{"react":"bmhQu","react-dom":"82aNB","@restart/hooks/useCallbackRef":"dezJ9","@restart/hooks/useMergedRefs":"hXy8K","./usePopper":"3xm4J","./useRootClose":"aoJIO","./useWaitForDOMRef":"4agJT","./mergeOptionsWithPopperConfig":"118Fa","./ImperativeTransition":"aK0SH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aoJIO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listen = require("dom-helpers/listen");
var _listenDefault = parcelHelpers.interopDefault(_listen);
var _ownerDocument = require("dom-helpers/ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
var _react = require("react");
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useClickOutside = require("./useClickOutside");
var _useClickOutsideDefault = parcelHelpers.interopDefault(_useClickOutside);
var _utils = require("./utils");
const noop = ()=>{};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function useRootClose(ref, onRootClose, { disabled, clickTrigger } = {}) {
    const onClose = onRootClose || noop;
    (0, _useClickOutsideDefault.default)(ref, onClose, {
        disabled,
        clickTrigger
    });
    const handleKeyUp = (0, _useEventCallbackDefault.default)((e)=>{
        if ((0, _utils.isEscKey)(e)) onClose(e);
    });
    (0, _react.useEffect)(()=>{
        if (disabled || ref == null) return undefined;
        const doc = (0, _ownerDocumentDefault.default)((0, _useClickOutside.getRefTarget)(ref));
        // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (doc.defaultView || window).event;
        const removeKeyupListener = (0, _listenDefault.default)(doc, 'keyup', (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        return ()=>{
            removeKeyupListener();
        };
    }, [
        ref,
        disabled,
        handleKeyUp
    ]);
}
exports.default = useRootClose;

},{"dom-helpers/listen":"diWFU","dom-helpers/ownerDocument":"4O8MX","react":"bmhQu","@restart/hooks/useEventCallback":"j7CsD","./useClickOutside":"uqij7","./utils":"8cTwY","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"50qG8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useOverlayOffset);
var _react = require("react");
var _hasClass = require("dom-helpers/hasClass");
var _hasClassDefault = parcelHelpers.interopDefault(_hasClass);
var _themeProvider = require("./ThemeProvider");
var _popover = require("./Popover");
var _popoverDefault = parcelHelpers.interopDefault(_popover);
var _tooltip = require("./Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
"use client";
function useOverlayOffset(customOffset) {
    const overlayRef = (0, _react.useRef)(null);
    const popoverClass = (0, _themeProvider.useBootstrapPrefix)(undefined, 'popover');
    const tooltipClass = (0, _themeProvider.useBootstrapPrefix)(undefined, 'tooltip');
    const offset = (0, _react.useMemo)(()=>({
            name: 'offset',
            options: {
                offset: ()=>{
                    if (customOffset) return customOffset;
                    if (overlayRef.current) {
                        if ((0, _hasClassDefault.default)(overlayRef.current, popoverClass)) return (0, _popoverDefault.default).POPPER_OFFSET;
                        if ((0, _hasClassDefault.default)(overlayRef.current, tooltipClass)) return (0, _tooltipDefault.default).TOOLTIP_OFFSET;
                    }
                    return [
                        0,
                        0
                    ];
                }
            }
        }), [
        customOffset,
        popoverClass,
        tooltipClass
    ]);
    return [
        overlayRef,
        [
            offset
        ]
    ];
}

},{"react":"bmhQu","dom-helpers/hasClass":"7ZnXu","./ThemeProvider":"aQ1Mj","./Popover":"3fGIC","./Tooltip":"l1XDI","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3fGIC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _popoverHeader = require("./PopoverHeader");
var _popoverHeaderDefault = parcelHelpers.interopDefault(_popoverHeader);
var _popoverBody = require("./PopoverBody");
var _popoverBodyDefault = parcelHelpers.interopDefault(_popoverBody);
var _helpers = require("./helpers");
var _getInitialPopperStyles = require("./getInitialPopperStyles");
var _getInitialPopperStylesDefault = parcelHelpers.interopDefault(_getInitialPopperStyles);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Popover = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, placement = 'right', className, style, children, body, arrowProps, hasDoneInitialMeasure, popper, show, ...props }, ref)=>{
    const decoratedBsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'popover');
    const isRTL = (0, _themeProvider.useIsRTL)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
    const bsDirection = (0, _helpers.getOverlayDirection)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, _getInitialPopperStylesDefault.default)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: ref,
        role: "tooltip",
        style: computedStyle,
        "x-placement": primaryPlacement,
        className: (0, _classnamesDefault.default)(className, decoratedBsPrefix, primaryPlacement && `bs-popover-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "popover-arrow",
                ...arrowProps
            }),
            body ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popoverBodyDefault.default), {
                children: children
            }) : children
        ]
    });
});
Popover.displayName = 'Popover';
exports.default = Object.assign(Popover, {
    Header: (0, _popoverHeaderDefault.default),
    Body: (0, _popoverBodyDefault.default),
    // Default popover offset.
    // https://github.com/twbs/bootstrap/blob/5c32767e0e0dbac2d934bcdee03719a65d3f1187/js/src/popover.js#L28
    POPPER_OFFSET: [
        0,
        8
    ]
});

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","./PopoverHeader":"fFi0I","./PopoverBody":"hit36","./helpers":"lLyaa","./getInitialPopperStyles":"8LkkW","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fFi0I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const PopoverHeader = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'popover-header');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
PopoverHeader.displayName = 'PopoverHeader';
exports.default = PopoverHeader;

},{"react":"bmhQu","classnames":"9HH2M","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hit36":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const PopoverBody = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'popover-body');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
PopoverBody.displayName = 'PopoverBody';
exports.default = PopoverBody;

},{"react":"bmhQu","classnames":"9HH2M","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lLyaa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BsPrefixComponent", ()=>BsPrefixComponent);
// Need to use this instead of typeof Component to get proper type checking.
parcelHelpers.export(exports, "getOverlayDirection", ()=>getOverlayDirection);
var _react = require("react");
class BsPrefixComponent extends _react.Component {
}
function getOverlayDirection(placement, isRTL) {
    let bsDirection = placement;
    if (placement === 'left') bsDirection = isRTL ? 'end' : 'start';
    else if (placement === 'right') bsDirection = isRTL ? 'start' : 'end';
    return bsDirection;
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8LkkW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getInitialPopperStyles);
function getInitialPopperStyles(position = 'absolute') {
    return {
        position,
        top: '0',
        left: '0',
        opacity: '0',
        pointerEvents: 'none'
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l1XDI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _helpers = require("./helpers");
var _getInitialPopperStyles = require("./getInitialPopperStyles");
var _getInitialPopperStylesDefault = parcelHelpers.interopDefault(_getInitialPopperStyles);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Tooltip = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, placement = 'right', className, style, children, arrowProps, hasDoneInitialMeasure, popper, show, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'tooltip');
    const isRTL = (0, _themeProvider.useIsRTL)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
    const bsDirection = (0, _helpers.getOverlayDirection)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, _getInitialPopperStylesDefault.default)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: ref,
        style: computedStyle,
        role: "tooltip",
        "x-placement": primaryPlacement,
        className: (0, _classnamesDefault.default)(className, bsPrefix, `bs-tooltip-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "tooltip-arrow",
                ...arrowProps
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `${bsPrefix}-inner`,
                children: children
            })
        ]
    });
});
Tooltip.displayName = 'Tooltip';
exports.default = Object.assign(Tooltip, {
    // Default tooltip offset.
    // https://github.com/twbs/bootstrap/blob/beca2a6c7f6bc88b6449339fc76edcda832c59e5/js/src/tooltip.js#L65
    TOOLTIP_OFFSET: [
        0,
        6
    ]
});

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","./helpers":"lLyaa","./getInitialPopperStyles":"8LkkW","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gfJVo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _contains = require("dom-helpers/contains");
var _containsDefault = parcelHelpers.interopDefault(_contains);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _useTimeout = require("@restart/hooks/useTimeout");
var _useTimeoutDefault = parcelHelpers.interopDefault(_useTimeout);
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _uncontrollable = require("uncontrollable");
var _useMergedRefs = require("@restart/hooks/useMergedRefs");
var _useMergedRefsDefault = parcelHelpers.interopDefault(_useMergedRefs);
var _utils = require("@restart/ui/utils");
var _overlay = require("./Overlay");
var _overlayDefault = parcelHelpers.interopDefault(_overlay);
var _safeFindDOMNode = require("./safeFindDOMNode");
var _safeFindDOMNodeDefault = parcelHelpers.interopDefault(_safeFindDOMNode);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function normalizeDelay(delay) {
    return delay && typeof delay === 'object' ? delay : {
        show: delay,
        hide: delay
    };
}
// Simple implementation of mouseEnter and mouseLeave.
// React's built version is broken: https://github.com/facebook/react/issues/4251
// for cases when the trigger is disabled and mouseOut/Over can cause flicker
// moving from one child element to another.
function handleMouseOverOut(handler, args, relatedNative) {
    const [e] = args;
    const target = e.currentTarget;
    const related = e.relatedTarget || e.nativeEvent[relatedNative];
    if ((!related || related !== target) && !(0, _containsDefault.default)(target, related)) handler(...args);
}
const triggerType = (0, _propTypesDefault.default).oneOf([
    'click',
    'hover',
    'focus'
]);
const OverlayTrigger = ({ trigger = [
    'hover',
    'focus'
], overlay, children, popperConfig = {}, show: propsShow, defaultShow = false, onToggle, delay: propsDelay, placement, flip = placement && placement.indexOf('auto') !== -1, ...props })=>{
    const triggerNodeRef = (0, _react.useRef)(null);
    const mergedRef = (0, _useMergedRefsDefault.default)(triggerNodeRef, (0, _utils.getChildRef)(children));
    const timeout = (0, _useTimeoutDefault.default)();
    const hoverStateRef = (0, _react.useRef)('');
    const [show, setShow] = (0, _uncontrollable.useUncontrolledProp)(propsShow, defaultShow, onToggle);
    const delay = normalizeDelay(propsDelay);
    const { onFocus, onBlur, onClick } = typeof children !== 'function' ? _react.Children.only(children).props : {};
    const attachRef = (r)=>{
        mergedRef((0, _safeFindDOMNodeDefault.default)(r));
    };
    const handleShow = (0, _react.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = 'show';
        if (!delay.show) {
            setShow(true);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === 'show') setShow(true);
        }, delay.show);
    }, [
        delay.show,
        setShow,
        timeout
    ]);
    const handleHide = (0, _react.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = 'hide';
        if (!delay.hide) {
            setShow(false);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === 'hide') setShow(false);
        }, delay.hide);
    }, [
        delay.hide,
        setShow,
        timeout
    ]);
    const handleFocus = (0, _react.useCallback)((...args)=>{
        handleShow();
        onFocus == null || onFocus(...args);
    }, [
        handleShow,
        onFocus
    ]);
    const handleBlur = (0, _react.useCallback)((...args)=>{
        handleHide();
        onBlur == null || onBlur(...args);
    }, [
        handleHide,
        onBlur
    ]);
    const handleClick = (0, _react.useCallback)((...args)=>{
        setShow(!show);
        onClick == null || onClick(...args);
    }, [
        onClick,
        setShow,
        show
    ]);
    const handleMouseOver = (0, _react.useCallback)((...args)=>{
        handleMouseOverOut(handleShow, args, 'fromElement');
    }, [
        handleShow
    ]);
    const handleMouseOut = (0, _react.useCallback)((...args)=>{
        handleMouseOverOut(handleHide, args, 'toElement');
    }, [
        handleHide
    ]);
    const triggers = trigger == null ? [] : [].concat(trigger);
    const triggerProps = {
        ref: attachRef
    };
    if (triggers.indexOf('click') !== -1) triggerProps.onClick = handleClick;
    if (triggers.indexOf('focus') !== -1) {
        triggerProps.onFocus = handleFocus;
        triggerProps.onBlur = handleBlur;
    }
    if (triggers.indexOf('hover') !== -1) {
        triggerProps.onMouseOver = handleMouseOver;
        triggerProps.onMouseOut = handleMouseOut;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            typeof children === 'function' ? children(triggerProps) : /*#__PURE__*/ (0, _react.cloneElement)(children, triggerProps),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overlayDefault.default), {
                ...props,
                show: show,
                onHide: handleHide,
                flip: flip,
                placement: placement,
                popperConfig: popperConfig,
                target: triggerNodeRef.current,
                children: overlay
            })
        ]
    });
};
exports.default = OverlayTrigger;

},{"dom-helpers/contains":"kQPO5","prop-types":"gLXGb","react":"bmhQu","@restart/hooks/useTimeout":"1vt3i","warning":"fSSz5","uncontrollable":"1yRhe","@restart/hooks/useMergedRefs":"ai8mn","@restart/ui/utils":"8cTwY","./Overlay":"89Q0I","./safeFindDOMNode":"4l67l","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9rt3i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "First", ()=>First);
parcelHelpers.export(exports, "Prev", ()=>Prev);
parcelHelpers.export(exports, "Ellipsis", ()=>Ellipsis);
parcelHelpers.export(exports, "Next", ()=>Next);
parcelHelpers.export(exports, "Last", ()=>Last);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _anchor = require("@restart/ui/Anchor");
var _anchorDefault = parcelHelpers.interopDefault(_anchor);
var _jsxRuntime = require("react/jsx-runtime");
const PageItem = /*#__PURE__*/ _react.forwardRef(({ active = false, disabled = false, className, style, activeLabel = '(current)', children, linkStyle, linkClassName, as = (0, _anchorDefault.default), ...props }, ref)=>{
    const Component = active || disabled ? 'span' : as;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
        ref: ref,
        style: style,
        className: (0, _classnamesDefault.default)(className, 'page-item', {
            active,
            disabled
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Component, {
            className: (0, _classnamesDefault.default)('page-link', linkClassName),
            style: linkStyle,
            ...props,
            children: [
                children,
                active && activeLabel && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "visually-hidden",
                    children: activeLabel
                })
            ]
        })
    });
});
PageItem.displayName = 'PageItem';
exports.default = PageItem;
function createButton(name, defaultValue, label = name) {
    const Button = /*#__PURE__*/ _react.forwardRef(({ children, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(PageItem, {
            ...props,
            ref: ref,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    "aria-hidden": "true",
                    children: children || defaultValue
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "visually-hidden",
                    children: label
                })
            ]
        }));
    Button.displayName = name;
    return Button;
}
const First = createButton('First', "\xab");
const Prev = createButton('Prev', "\u2039", 'Previous');
const Ellipsis = createButton('Ellipsis', "\u2026", 'More');
const Next = createButton('Next', "\u203A");
const Last = createButton('Last', "\xbb");

},{"classnames":"9HH2M","react":"bmhQu","@restart/ui/Anchor":"iVIEK","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cQ0W6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _pageItem = require("./PageItem");
var _pageItemDefault = parcelHelpers.interopDefault(_pageItem);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Pagination = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, size, ...props }, ref)=>{
    const decoratedBsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'pagination');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
        ref: ref,
        ...props,
        className: (0, _classnamesDefault.default)(className, decoratedBsPrefix, size && `${decoratedBsPrefix}-${size}`)
    });
});
Pagination.displayName = 'Pagination';
exports.default = Object.assign(Pagination, {
    First: (0, _pageItem.First),
    Prev: (0, _pageItem.Prev),
    Ellipsis: (0, _pageItem.Ellipsis),
    Item: (0, _pageItemDefault.default),
    Next: (0, _pageItem.Next),
    Last: (0, _pageItem.Last)
});

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","./PageItem":"9rt3i","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cqCf1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _usePlaceholder = require("./usePlaceholder");
var _usePlaceholderDefault = parcelHelpers.interopDefault(_usePlaceholder);
var _placeholderButton = require("./PlaceholderButton");
var _placeholderButtonDefault = parcelHelpers.interopDefault(_placeholderButton);
var _jsxRuntime = require("react/jsx-runtime");
const Placeholder = /*#__PURE__*/ _react.forwardRef(({ as: Component = 'span', ...props }, ref)=>{
    const placeholderProps = (0, _usePlaceholderDefault.default)(props);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...placeholderProps,
        ref: ref
    });
});
Placeholder.displayName = 'Placeholder';
exports.default = Object.assign(Placeholder, {
    Button: (0, _placeholderButtonDefault.default)
});

},{"react":"bmhQu","./usePlaceholder":"l9R3e","./PlaceholderButton":"iG7HN","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l9R3e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePlaceholder);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _col = require("./Col");
"use client";
function usePlaceholder({ animation, bg, bsPrefix, size, ...props }) {
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'placeholder');
    const [{ className, ...colProps }] = (0, _col.useCol)(props);
    return {
        ...colProps,
        className: (0, _classnamesDefault.default)(className, animation ? `${bsPrefix}-${animation}` : bsPrefix, size && `${bsPrefix}-${size}`, bg && `bg-${bg}`)
    };
}

},{"classnames":"9HH2M","./ThemeProvider":"aQ1Mj","./Col":"ii9A3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iG7HN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _usePlaceholder = require("./usePlaceholder");
var _usePlaceholderDefault = parcelHelpers.interopDefault(_usePlaceholder);
var _jsxRuntime = require("react/jsx-runtime");
const PlaceholderButton = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const placeholderProps = (0, _usePlaceholderDefault.default)(props);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
        ...placeholderProps,
        ref: ref,
        disabled: true,
        tabIndex: -1
    });
});
PlaceholderButton.displayName = 'PlaceholderButton';
exports.default = PlaceholderButton;

},{"react":"bmhQu","./Button":"6Xv8z","./usePlaceholder":"l9R3e","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2I4Ha":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _elementChildren = require("./ElementChildren");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const ROUND_PRECISION = 1000;
/**
 * Validate that children, if any, are instances of `ProgressBar`.
 */ function onlyProgressBar(props, propName, componentName) {
    const children = props[propName];
    if (!children) return null;
    let error = null;
    _react.Children.forEach(children, (child)=>{
        if (error) return;
        /**
     * Compare types in a way that works with libraries that patch and proxy
     * components like react-hot-loader.
     *
     * see https://github.com/gaearon/react-hot-loader#checking-element-types
     */ const element = /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProgressBar, {});
        if (child.type === element.type) return;
        const childType = child.type;
        const childIdentifier = /*#__PURE__*/ _react.isValidElement(child) ? childType.displayName || childType.name || childType : child;
        error = new Error(`Children of ${componentName} can contain only ProgressBar ` + `components. Found ${childIdentifier}.`);
    });
    return error;
}
function getPercentage(now, min, max) {
    const percentage = (now - min) / (max - min) * 100;
    return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
}
function renderProgressBar({ min, now, max, label, visuallyHidden, striped, animated, className, style, variant, bsPrefix, ...props }, ref) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: ref,
        ...props,
        role: "progressbar",
        className: (0, _classnamesDefault.default)(className, `${bsPrefix}-bar`, {
            [`bg-${variant}`]: variant,
            [`${bsPrefix}-bar-animated`]: animated,
            [`${bsPrefix}-bar-striped`]: animated || striped
        }),
        style: {
            width: `${getPercentage(now, min, max)}%`,
            ...style
        },
        "aria-valuenow": now,
        "aria-valuemin": min,
        "aria-valuemax": max,
        children: visuallyHidden ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: "visually-hidden",
            children: label
        }) : label
    });
}
const ProgressBar = /*#__PURE__*/ _react.forwardRef(({ isChild = false, ...rest }, ref)=>{
    const props = {
        min: 0,
        max: 100,
        animated: false,
        visuallyHidden: false,
        striped: false,
        ...rest
    };
    props.bsPrefix = (0, _themeProvider.useBootstrapPrefix)(props.bsPrefix, 'progress');
    if (isChild) return renderProgressBar(props, ref);
    const { min, now, max, label, visuallyHidden, striped, animated, bsPrefix, variant, className, children, ...wrapperProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: ref,
        ...wrapperProps,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        children: children ? (0, _elementChildren.map)(children, (child)=>/*#__PURE__*/ (0, _react.cloneElement)(child, {
                isChild: true
            })) : renderProgressBar({
            min,
            now,
            max,
            label,
            visuallyHidden,
            striped,
            animated,
            bsPrefix,
            variant
        }, ref)
    });
});
ProgressBar.displayName = 'ProgressBar';
exports.default = ProgressBar;

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","./ElementChildren":"iO22F","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1dOkm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function toPercent(num) {
    if (num <= 0) return '100%';
    if (num < 1) return `${num * 100}%`;
    return `${num}%`;
}
const Ratio = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, children, aspectRatio = '1x1', style, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'ratio');
    const isCustomRatio = typeof aspectRatio === 'number';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: ref,
        ...props,
        style: {
            ...style,
            ...isCustomRatio && {
                '--bs-aspect-ratio': toPercent(aspectRatio)
            }
        },
        className: (0, _classnamesDefault.default)(bsPrefix, className, !isCustomRatio && `${bsPrefix}-${aspectRatio}`),
        children: _react.Children.only(children)
    });
});
Ratio.displayName = 'Ratio';
exports.default = Ratio;

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3Fk66":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Row = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const decoratedBsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'row');
    const breakpoints = (0, _themeProvider.useBootstrapBreakpoints)();
    const minBreakpoint = (0, _themeProvider.useBootstrapMinBreakpoint)();
    const sizePrefix = `${decoratedBsPrefix}-cols`;
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let cols;
        if (propValue != null && typeof propValue === 'object') ({ cols } = propValue);
        else cols = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, _classnamesDefault.default)(className, decoratedBsPrefix, ...classes)
    });
});
Row.displayName = 'Row';
exports.default = Row;

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4RdUY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Spinner = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, variant, animation = 'border', size, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'spinner');
    const bsSpinnerPrefix = `${bsPrefix}-${animation}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, _classnamesDefault.default)(className, bsSpinnerPrefix, size && `${bsSpinnerPrefix}-${size}`, variant && `text-${variant}`)
    });
});
Spinner.displayName = 'Spinner';
exports.default = Spinner;

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4S6ld":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _buttonGroup = require("./ButtonGroup");
var _buttonGroupDefault = parcelHelpers.interopDefault(_buttonGroup);
var _dropdown = require("./Dropdown");
var _dropdownDefault = parcelHelpers.interopDefault(_dropdown);
var _types = require("./types");
var _jsxRuntime = require("react/jsx-runtime");
const propTypes = {
    /**
   * An html id attribute for the Toggle button, necessary for assistive technologies, such as screen readers.
   * @type {string}
   * @required
   */ id: (0, _propTypesDefault.default).string,
    /**
   * Accessible label for the toggle; the value of `title` if not specified.
   */ toggleLabel: (0, _propTypesDefault.default).string,
    /** An `href` passed to the non-toggle Button */ href: (0, _propTypesDefault.default).string,
    /** An anchor `target` passed to the non-toggle Button */ target: (0, _propTypesDefault.default).string,
    /** An `onClick` handler passed to the non-toggle Button */ onClick: (0, _propTypesDefault.default).func,
    /** The content of the non-toggle Button.  */ title: (0, _propTypesDefault.default).node.isRequired,
    /** A `type` passed to the non-toggle Button */ type: (0, _propTypesDefault.default).string,
    /** Disables both Buttons  */ disabled: (0, _propTypesDefault.default).bool,
    /**
   * Aligns the dropdown menu.
   *
   * _see [DropdownMenu](#dropdown-menu-props) for more details_
   *
   * @type {"start"|"end"|{ sm: "start"|"end" }|{ md: "start"|"end" }|{ lg: "start"|"end" }|{ xl: "start"|"end"}|{ xxl: "start"|"end"} }
   */ align: (0, _types.alignPropType),
    /** An ARIA accessible role applied to the Menu component. When set to 'menu', The dropdown */ menuRole: (0, _propTypesDefault.default).string,
    /** Whether to render the dropdown menu in the DOM before the first time it is shown */ renderMenuOnMount: (0, _propTypesDefault.default).bool,
    /**
   *  Which event when fired outside the component will cause it to be closed.
   *
   * _see [DropdownMenu](#dropdown-menu-props) for more details_
   */ rootCloseEvent: (0, _propTypesDefault.default).string,
    /**
   * Allow Dropdown to flip in case of an overlapping on the reference element. For more information refer to
   * Popper.js's flip [docs](https://popper.js.org/docs/v2/modifiers/flip/).
   *
   */ flip: (0, _propTypesDefault.default).bool,
    /** @ignore */ bsPrefix: (0, _propTypesDefault.default).string,
    /** @ignore */ variant: (0, _propTypesDefault.default).string,
    /** @ignore */ size: (0, _propTypesDefault.default).string
};
/**
 * A convenience component for simple or general use split button dropdowns. Renders a
 * `ButtonGroup` containing a `Button` and a `Button` toggle for the `Dropdown`. All `children`
 * are passed directly to the default `Dropdown.Menu`. This component accepts all of [`Dropdown`'s
 * props](#dropdown-props).
 *
 * _All unknown props are passed through to the `Dropdown` component._
 * The Button `variant`, `size` and `bsPrefix` props are passed to the button and toggle,
 * and menu-related props are passed to the `Dropdown.Menu`
 */ const SplitButton = /*#__PURE__*/ _react.forwardRef(({ id, bsPrefix, size, variant, title, type = 'button', toggleLabel = 'Toggle dropdown', children, onClick, href, target, menuRole, renderMenuOnMount, rootCloseEvent, flip, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dropdownDefault.default), {
        ref: ref,
        ...props,
        as: (0, _buttonGroupDefault.default),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                size: size,
                variant: variant,
                disabled: props.disabled,
                bsPrefix: bsPrefix,
                href: href,
                target: target,
                onClick: onClick,
                type: type,
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownDefault.default).Toggle, {
                split: true,
                id: id,
                size: size,
                variant: variant,
                disabled: props.disabled,
                childBsPrefix: bsPrefix,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "visually-hidden",
                    children: toggleLabel
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownDefault.default).Menu, {
                role: menuRole,
                renderOnMount: renderMenuOnMount,
                rootCloseEvent: rootCloseEvent,
                flip: flip,
                children: children
            })
        ]
    }));
SplitButton.propTypes = propTypes;
SplitButton.displayName = 'SplitButton';
exports.default = SplitButton;

},{"react":"bmhQu","prop-types":"gLXGb","./Button":"6Xv8z","./ButtonGroup":"go7mS","./Dropdown":"7uokG","./types":"bbBUb","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hzuI4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ssr = require("@restart/ui/ssr");
exports.default = (0, _ssr.SSRProvider);

},{"@restart/ui/ssr":"j7dFp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1ZYHU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _createUtilityClasses = require("./createUtilityClasses");
var _createUtilityClassesDefault = parcelHelpers.interopDefault(_createUtilityClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Stack = /*#__PURE__*/ _react.forwardRef(({ as: Component = 'div', bsPrefix, className, direction, gap, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, direction === 'horizontal' ? 'hstack' : 'vstack');
    const breakpoints = (0, _themeProvider.useBootstrapBreakpoints)();
    const minBreakpoint = (0, _themeProvider.useBootstrapMinBreakpoint)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix, ...(0, _createUtilityClassesDefault.default)({
            gap
        }, breakpoints, minBreakpoint))
    });
});
Stack.displayName = 'Stack';
exports.default = Stack;

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","./createUtilityClasses":"4H0ox","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4H0ox":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "responsivePropType", ()=>responsivePropType);
parcelHelpers.export(exports, "default", ()=>createUtilityClassName);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _themeProvider = require("./ThemeProvider");
function responsivePropType(propType) {
    return (0, _propTypesDefault.default).oneOfType([
        propType,
        (0, _propTypesDefault.default).shape({
            xs: propType,
            sm: propType,
            md: propType,
            lg: propType,
            xl: propType,
            xxl: propType
        })
    ]);
}
function createUtilityClassName(utilityValues, breakpoints = (0, _themeProvider.DEFAULT_BREAKPOINTS), minBreakpoint = (0, _themeProvider.DEFAULT_MIN_BREAKPOINT)) {
    const classes = [];
    Object.entries(utilityValues).forEach(([utilName, utilValue])=>{
        if (utilValue != null) {
            if (typeof utilValue === 'object') breakpoints.forEach((brkPoint)=>{
                const bpValue = utilValue[brkPoint];
                if (bpValue != null) {
                    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
                    classes.push(`${utilName}${infix}-${bpValue}`);
                }
            });
            else classes.push(`${utilName}-${utilValue}`);
        }
    });
    return classes;
}

},{"prop-types":"gLXGb","./ThemeProvider":"aQ1Mj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"10Nxs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _tabContainer = require("./TabContainer");
var _tabContainerDefault = parcelHelpers.interopDefault(_tabContainer);
var _tabContent = require("./TabContent");
var _tabContentDefault = parcelHelpers.interopDefault(_tabContent);
var _tabPane = require("./TabPane");
var _tabPaneDefault = parcelHelpers.interopDefault(_tabPane);
const propTypes = {
    eventKey: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    /**
   * Content for the tab title.
   */ title: (0, _propTypesDefault.default).node.isRequired,
    /**
   * The disabled state of the tab.
   */ disabled: (0, _propTypesDefault.default).bool,
    /**
   * Class to pass to the underlying nav link.
   */ tabClassName: (0, _propTypesDefault.default).string,
    /**
   * Object containing attributes to pass to underlying nav link.
   */ tabAttrs: (0, _propTypesDefault.default).object
};
const Tab = ()=>{
    throw new Error("ReactBootstrap: The `Tab` component is not meant to be rendered! It's an abstract component that is only valid as a direct Child of the `Tabs` Component. For custom tabs components use TabPane and TabsContainer directly");
};
Tab.propTypes = propTypes;
exports.default = Object.assign(Tab, {
    Container: (0, _tabContainerDefault.default),
    Content: (0, _tabContentDefault.default),
    Pane: (0, _tabPaneDefault.default)
});

},{"prop-types":"gLXGb","./TabContainer":"koe4F","./TabContent":"6v86b","./TabPane":"8lsLw","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"koe4F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tabs = require("@restart/ui/Tabs");
var _tabsDefault = parcelHelpers.interopDefault(_tabs);
var _getTabTransitionComponent = require("./getTabTransitionComponent");
var _getTabTransitionComponentDefault = parcelHelpers.interopDefault(_getTabTransitionComponent);
var _jsxRuntime = require("react/jsx-runtime");
const TabContainer = ({ transition, ...props })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabsDefault.default), {
        ...props,
        transition: (0, _getTabTransitionComponentDefault.default)(transition)
    });
TabContainer.displayName = 'TabContainer';
exports.default = TabContainer;

},{"@restart/ui/Tabs":"3u9fe","./getTabTransitionComponent":"7979w","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3u9fe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _uncontrollable = require("uncontrollable");
var _ssr = require("./ssr");
var _tabContext = require("./TabContext");
var _tabContextDefault = parcelHelpers.interopDefault(_tabContext);
var _selectableContext = require("./SelectableContext");
var _selectableContextDefault = parcelHelpers.interopDefault(_selectableContext);
var _tabPanel = require("./TabPanel");
var _tabPanelDefault = parcelHelpers.interopDefault(_tabPanel);
var _jsxRuntime = require("react/jsx-runtime");
const Tabs = (props)=>{
    const { id: userId, generateChildId: generateCustomChildId, onSelect: propsOnSelect, activeKey: propsActiveKey, defaultActiveKey, transition, mountOnEnter, unmountOnExit, children } = props;
    const [activeKey, onSelect] = (0, _uncontrollable.useUncontrolledProp)(propsActiveKey, defaultActiveKey, propsOnSelect);
    const id = (0, _ssr.useSSRSafeId)(userId);
    const generateChildId = (0, _react.useMemo)(()=>generateCustomChildId || ((key, type)=>id ? `${id}-${type}-${key}` : null), [
        id,
        generateCustomChildId
    ]);
    const tabContext = (0, _react.useMemo)(()=>({
            onSelect,
            activeKey,
            transition,
            mountOnEnter: mountOnEnter || false,
            unmountOnExit: unmountOnExit || false,
            getControlledId: (key)=>generateChildId(key, 'tabpane'),
            getControllerId: (key)=>generateChildId(key, 'tab')
        }), [
        onSelect,
        activeKey,
        transition,
        mountOnEnter,
        unmountOnExit,
        generateChildId
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabContextDefault.default).Provider, {
        value: tabContext,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectableContextDefault.default).Provider, {
            value: onSelect || null,
            children: children
        })
    });
};
Tabs.Panel = (0, _tabPanelDefault.default);
exports.default = Tabs;

},{"react":"bmhQu","uncontrollable":"2jAIi","./ssr":"j7dFp","./TabContext":"1801Q","./SelectableContext":"e59aX","./TabPanel":"d1v50","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d1v50":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTabPanel", ()=>useTabPanel);
var _react = require("react");
var _tabContext = require("./TabContext");
var _tabContextDefault = parcelHelpers.interopDefault(_tabContext);
var _selectableContext = require("./SelectableContext");
var _selectableContextDefault = parcelHelpers.interopDefault(_selectableContext);
var _noopTransition = require("./NoopTransition");
var _noopTransitionDefault = parcelHelpers.interopDefault(_noopTransition);
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "active",
    "eventKey",
    "mountOnEnter",
    "transition",
    "unmountOnExit",
    "role",
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited"
], _excluded2 = [
    "activeKey",
    "getControlledId",
    "getControllerId"
], _excluded3 = [
    "as"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function useTabPanel(_ref) {
    let { active, eventKey, mountOnEnter, transition, unmountOnExit, role = 'tabpanel', onEnter, onEntering, onEntered, onExit, onExiting, onExited } = _ref, props = _objectWithoutPropertiesLoose(_ref, _excluded);
    const context = (0, _react.useContext)((0, _tabContextDefault.default));
    if (!context) return [
        Object.assign({}, props, {
            role
        }),
        {
            eventKey,
            isActive: active,
            mountOnEnter,
            transition,
            unmountOnExit,
            onEnter,
            onEntering,
            onEntered,
            onExit,
            onExiting,
            onExited
        }
    ];
    const { activeKey, getControlledId, getControllerId } = context, rest = _objectWithoutPropertiesLoose(context, _excluded2);
    const key = (0, _selectableContext.makeEventKey)(eventKey);
    return [
        Object.assign({}, props, {
            role,
            id: getControlledId(eventKey),
            'aria-labelledby': getControllerId(eventKey)
        }),
        {
            eventKey,
            isActive: active == null && key != null ? (0, _selectableContext.makeEventKey)(activeKey) === key : active,
            transition: transition || rest.transition,
            mountOnEnter: mountOnEnter != null ? mountOnEnter : rest.mountOnEnter,
            unmountOnExit: unmountOnExit != null ? unmountOnExit : rest.unmountOnExit,
            onEnter,
            onEntering,
            onEntered,
            onExit,
            onExiting,
            onExited
        }
    ];
}
const TabPanel = /*#__PURE__*/ _react.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(_ref2, ref)=>{
    let { as: Component = 'div' } = _ref2, props = _objectWithoutPropertiesLoose(_ref2, _excluded3);
    const [tabPanelProps, { isActive, onEnter, onEntering, onEntered, onExit, onExiting, onExited, mountOnEnter, unmountOnExit, transition: Transition = (0, _noopTransitionDefault.default) }] = useTabPanel(props);
    // We provide an empty the TabContext so `<Nav>`s in `<TabPanel>`s don't
    // conflict with the top level one.
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabContextDefault.default).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectableContextDefault.default).Provider, {
            value: null,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Transition, {
                in: isActive,
                onEnter: onEnter,
                onEntering: onEntering,
                onEntered: onEntered,
                onExit: onExit,
                onExiting: onExiting,
                onExited: onExited,
                mountOnEnter: mountOnEnter,
                unmountOnExit: unmountOnExit,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, Object.assign({}, tabPanelProps, {
                    ref: ref,
                    hidden: !isActive,
                    "aria-hidden": !isActive
                }))
            })
        })
    });
});
TabPanel.displayName = 'TabPanel';
exports.default = TabPanel;

},{"react":"bmhQu","./TabContext":"1801Q","./SelectableContext":"e59aX","./NoopTransition":"jO1Qq","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7979w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getTabTransitionComponent);
var _noopTransition = require("@restart/ui/NoopTransition");
var _noopTransitionDefault = parcelHelpers.interopDefault(_noopTransition);
var _fade = require("./Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
function getTabTransitionComponent(transition) {
    if (typeof transition === 'boolean') return transition ? (0, _fadeDefault.default) : (0, _noopTransitionDefault.default);
    return transition;
}

},{"@restart/ui/NoopTransition":"jO1Qq","./Fade":"iLhiL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6v86b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const TabContent = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'tab-content');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
TabContent.displayName = 'TabContent';
exports.default = TabContent;

},{"react":"bmhQu","classnames":"9HH2M","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8lsLw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _selectableContext = require("@restart/ui/SelectableContext");
var _selectableContextDefault = parcelHelpers.interopDefault(_selectableContext);
var _tabContext = require("@restart/ui/TabContext");
var _tabContextDefault = parcelHelpers.interopDefault(_tabContext);
var _tabPanel = require("@restart/ui/TabPanel");
var _themeProvider = require("./ThemeProvider");
var _fade = require("./Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _getTabTransitionComponent = require("./getTabTransitionComponent");
var _getTabTransitionComponentDefault = parcelHelpers.interopDefault(_getTabTransitionComponent);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const TabPane = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, transition, ...props }, ref)=>{
    const [{ className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', ...rest }, { isActive, onEnter, onEntering, onEntered, onExit, onExiting, onExited, mountOnEnter, unmountOnExit, transition: Transition = (0, _fadeDefault.default) }] = (0, _tabPanel.useTabPanel)({
        ...props,
        transition: (0, _getTabTransitionComponentDefault.default)(transition)
    });
    const prefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'tab-pane');
    // We provide an empty the TabContext so `<Nav>`s in `<TabPanel>`s don't
    // conflict with the top level one.
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabContextDefault.default).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectableContextDefault.default).Provider, {
            value: null,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Transition, {
                in: isActive,
                onEnter: onEnter,
                onEntering: onEntering,
                onEntered: onEntered,
                onExit: onExit,
                onExiting: onExiting,
                onExited: onExited,
                mountOnEnter: mountOnEnter,
                unmountOnExit: unmountOnExit,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
                    ...rest,
                    ref: ref,
                    className: (0, _classnamesDefault.default)(className, prefix, isActive && 'active')
                })
            })
        })
    });
});
TabPane.displayName = 'TabPane';
exports.default = TabPane;

},{"classnames":"9HH2M","react":"bmhQu","@restart/ui/SelectableContext":"e59aX","@restart/ui/TabContext":"1801Q","@restart/ui/TabPanel":"d1v50","./ThemeProvider":"aQ1Mj","./Fade":"iLhiL","./getTabTransitionComponent":"7979w","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7SWKQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Table = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, striped, bordered, borderless, hover, size, variant, responsive, ...props }, ref)=>{
    const decoratedBsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'table');
    const classes = (0, _classnamesDefault.default)(className, decoratedBsPrefix, variant && `${decoratedBsPrefix}-${variant}`, size && `${decoratedBsPrefix}-${size}`, striped && `${decoratedBsPrefix}-${typeof striped === 'string' ? `striped-${striped}` : 'striped'}`, bordered && `${decoratedBsPrefix}-bordered`, borderless && `${decoratedBsPrefix}-borderless`, hover && `${decoratedBsPrefix}-hover`);
    const table = /*#__PURE__*/ (0, _jsxRuntime.jsx)("table", {
        ...props,
        className: classes,
        ref: ref
    });
    if (responsive) {
        let responsiveClass = `${decoratedBsPrefix}-responsive`;
        if (typeof responsive === 'string') responsiveClass = `${responsiveClass}-${responsive}`;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: responsiveClass,
            children: table
        });
    }
    return table;
});
Table.displayName = 'Table';
exports.default = Table;

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eJbuZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _uncontrollable = require("uncontrollable");
var _tabs = require("@restart/ui/Tabs");
var _tabsDefault = parcelHelpers.interopDefault(_tabs);
var _nav = require("./Nav");
var _navDefault = parcelHelpers.interopDefault(_nav);
var _navLink = require("./NavLink");
var _navLinkDefault = parcelHelpers.interopDefault(_navLink);
var _navItem = require("./NavItem");
var _navItemDefault = parcelHelpers.interopDefault(_navItem);
var _tabContent = require("./TabContent");
var _tabContentDefault = parcelHelpers.interopDefault(_tabContent);
var _tabPane = require("./TabPane");
var _tabPaneDefault = parcelHelpers.interopDefault(_tabPane);
var _elementChildren = require("./ElementChildren");
var _getTabTransitionComponent = require("./getTabTransitionComponent");
var _getTabTransitionComponentDefault = parcelHelpers.interopDefault(_getTabTransitionComponent);
var _jsxRuntime = require("react/jsx-runtime");
function getDefaultActiveKey(children) {
    let defaultActiveKey;
    (0, _elementChildren.forEach)(children, (child)=>{
        if (defaultActiveKey == null) defaultActiveKey = child.props.eventKey;
    });
    return defaultActiveKey;
}
function renderTab(child) {
    const { title, eventKey, disabled, tabClassName, tabAttrs, id } = child.props;
    if (title == null) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItemDefault.default), {
        as: "li",
        role: "presentation",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navLinkDefault.default), {
            as: "button",
            type: "button",
            eventKey: eventKey,
            disabled: disabled,
            id: id,
            className: tabClassName,
            ...tabAttrs,
            children: title
        })
    });
}
const Tabs = (props)=>{
    const { id, onSelect, transition, mountOnEnter = false, unmountOnExit = false, variant = 'tabs', children, activeKey = getDefaultActiveKey(children), ...controlledProps } = (0, _uncontrollable.useUncontrolled)(props, {
        activeKey: 'onSelect'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tabsDefault.default), {
        id: id,
        activeKey: activeKey,
        onSelect: onSelect,
        transition: (0, _getTabTransitionComponentDefault.default)(transition),
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navDefault.default), {
                id: id,
                ...controlledProps,
                role: "tablist",
                as: "ul",
                variant: variant,
                children: (0, _elementChildren.map)(children, renderTab)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabContentDefault.default), {
                children: (0, _elementChildren.map)(children, (child)=>{
                    const childProps = {
                        ...child.props
                    };
                    delete childProps.title;
                    delete childProps.disabled;
                    delete childProps.tabClassName;
                    delete childProps.tabAttrs;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabPaneDefault.default), {
                        ...childProps
                    });
                })
            })
        ]
    });
};
Tabs.displayName = 'Tabs';
exports.default = Tabs;

},{"react":"bmhQu","uncontrollable":"1yRhe","@restart/ui/Tabs":"3u9fe","./Nav":"axkz0","./NavLink":"e3vjD","./NavItem":"ciiMI","./TabContent":"6v86b","./TabPane":"8lsLw","./ElementChildren":"iO22F","./getTabTransitionComponent":"7979w","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eYOJl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _useTimeout = require("@restart/hooks/useTimeout");
var _useTimeoutDefault = parcelHelpers.interopDefault(_useTimeout);
var _toastFade = require("./ToastFade");
var _toastFadeDefault = parcelHelpers.interopDefault(_toastFade);
var _toastHeader = require("./ToastHeader");
var _toastHeaderDefault = parcelHelpers.interopDefault(_toastHeader);
var _toastBody = require("./ToastBody");
var _toastBodyDefault = parcelHelpers.interopDefault(_toastBody);
var _themeProvider = require("./ThemeProvider");
var _toastContext = require("./ToastContext");
var _toastContextDefault = parcelHelpers.interopDefault(_toastContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const Toast = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, transition: Transition = (0, _toastFadeDefault.default), show = true, animation = true, delay = 5000, autohide = false, onClose, onEntered, onExit, onExiting, onEnter, onEntering, onExited, bg, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'toast');
    // We use refs for these, because we don't want to restart the autohide
    // timer in case these values change.
    const delayRef = (0, _react.useRef)(delay);
    const onCloseRef = (0, _react.useRef)(onClose);
    (0, _react.useEffect)(()=>{
        delayRef.current = delay;
        onCloseRef.current = onClose;
    }, [
        delay,
        onClose
    ]);
    const autohideTimeout = (0, _useTimeoutDefault.default)();
    const autohideToast = !!(autohide && show);
    const autohideFunc = (0, _react.useCallback)(()=>{
        if (autohideToast) onCloseRef.current == null || onCloseRef.current();
    }, [
        autohideToast
    ]);
    (0, _react.useEffect)(()=>{
        // Only reset timer if show or autohide changes.
        autohideTimeout.set(autohideFunc, delayRef.current);
    }, [
        autohideTimeout,
        autohideFunc
    ]);
    const toastContext = (0, _react.useMemo)(()=>({
            onClose
        }), [
        onClose
    ]);
    const hasAnimation = !!(Transition && animation);
    const toast = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, _classnamesDefault.default)(bsPrefix, className, bg && `bg-${bg}`, !hasAnimation && (show ? 'show' : 'hide')),
        role: "alert",
        "aria-live": "assertive",
        "aria-atomic": "true"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toastContextDefault.default).Provider, {
        value: toastContext,
        children: hasAnimation && Transition ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Transition, {
            in: show,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered,
            onExit: onExit,
            onExiting: onExiting,
            onExited: onExited,
            unmountOnExit: true,
            children: toast
        }) : toast
    });
});
Toast.displayName = 'Toast';
exports.default = Object.assign(Toast, {
    Body: (0, _toastBodyDefault.default),
    Header: (0, _toastHeaderDefault.default)
});

},{"react":"bmhQu","classnames":"9HH2M","@restart/hooks/useTimeout":"1vt3i","./ToastFade":"90hKN","./ToastHeader":"cEZ7z","./ToastBody":"kmL3i","./ThemeProvider":"aQ1Mj","./ToastContext":"6dpt4","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"90hKN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _transition = require("react-transition-group/Transition");
var _fade = require("./Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _jsxRuntime = require("react/jsx-runtime");
const fadeStyles = {
    [(0, _transition.ENTERING)]: 'showing',
    [(0, _transition.EXITING)]: 'showing show'
};
const ToastFade = /*#__PURE__*/ _react.forwardRef((props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeDefault.default), {
        ...props,
        ref: ref,
        transitionClasses: fadeStyles
    }));
ToastFade.displayName = 'ToastFade';
exports.default = ToastFade;

},{"react":"bmhQu","react-transition-group/Transition":"eHQNI","./Fade":"iLhiL","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cEZ7z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _useEventCallback = require("@restart/hooks/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _themeProvider = require("./ThemeProvider");
var _closeButton = require("./CloseButton");
var _closeButtonDefault = parcelHelpers.interopDefault(_closeButton);
var _toastContext = require("./ToastContext");
var _toastContextDefault = parcelHelpers.interopDefault(_toastContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const ToastHeader = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, closeLabel = 'Close', closeVariant, closeButton = true, className, children, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'toast-header');
    const context = (0, _react.useContext)((0, _toastContextDefault.default));
    const handleClick = (0, _useEventCallbackDefault.default)((e)=>{
        context == null || context.onClose == null || context.onClose(e);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: ref,
        ...props,
        className: (0, _classnamesDefault.default)(bsPrefix, className),
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeButtonDefault.default), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick,
                "data-dismiss": "toast"
            })
        ]
    });
});
ToastHeader.displayName = 'ToastHeader';
exports.default = ToastHeader;

},{"classnames":"9HH2M","react":"bmhQu","@restart/hooks/useEventCallback":"8gfnN","./ThemeProvider":"aQ1Mj","./CloseButton":"7enKR","./ToastContext":"6dpt4","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6dpt4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
const ToastContext = /*#__PURE__*/ _react.createContext({
    onClose () {}
});
exports.default = ToastContext;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kmL3i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const ToastBody = /*#__PURE__*/ _react.forwardRef(({ className, bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'toast-body');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        className: (0, _classnamesDefault.default)(className, bsPrefix),
        ...props
    });
});
ToastBody.displayName = 'ToastBody';
exports.default = ToastBody;

},{"react":"bmhQu","classnames":"9HH2M","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8oPNT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const positionClasses = {
    'top-start': 'top-0 start-0',
    'top-center': 'top-0 start-50 translate-middle-x',
    'top-end': 'top-0 end-0',
    'middle-start': 'top-50 start-0 translate-middle-y',
    'middle-center': 'top-50 start-50 translate-middle',
    'middle-end': 'top-50 end-0 translate-middle-y',
    'bottom-start': 'bottom-0 start-0',
    'bottom-center': 'bottom-0 start-50 translate-middle-x',
    'bottom-end': 'bottom-0 end-0'
};
const ToastContainer = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, position, containerPosition, className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'toast-container');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, _classnamesDefault.default)(bsPrefix, position && positionClasses[position], containerPosition && `position-${containerPosition}`, className)
    });
});
ToastContainer.displayName = 'ToastContainer';
exports.default = ToastContainer;

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"inQyE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const noop = ()=>undefined;
const ToggleButton = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, name, className, checked, type, onChange, value, disabled, id, inputRef, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'btn-check');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: bsPrefix,
                name: name,
                type: type,
                value: value,
                ref: inputRef,
                autoComplete: "off",
                checked: !!checked,
                disabled: !!disabled,
                onChange: onChange || noop,
                id: id
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                ...props,
                ref: ref,
                className: (0, _classnamesDefault.default)(className, disabled && 'disabled'),
                type: undefined,
                role: undefined,
                as: "label",
                htmlFor: id
            })
        ]
    });
});
ToggleButton.displayName = 'ToggleButton';
exports.default = ToggleButton;

},{"classnames":"9HH2M","react":"bmhQu","./ThemeProvider":"aQ1Mj","./Button":"6Xv8z","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gEA1B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _invariant = require("invariant");
var _invariantDefault = parcelHelpers.interopDefault(_invariant);
var _uncontrollable = require("uncontrollable");
var _createChainedFunction = require("./createChainedFunction");
var _createChainedFunctionDefault = parcelHelpers.interopDefault(_createChainedFunction);
var _elementChildren = require("./ElementChildren");
var _buttonGroup = require("./ButtonGroup");
var _buttonGroupDefault = parcelHelpers.interopDefault(_buttonGroup);
var _toggleButton = require("./ToggleButton");
var _toggleButtonDefault = parcelHelpers.interopDefault(_toggleButton);
var _jsxRuntime = require("react/jsx-runtime");
const ToggleButtonGroup = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { children, type = 'radio', name, value, onChange, vertical = false, ...controlledProps } = (0, _uncontrollable.useUncontrolled)(props, {
        value: 'onChange'
    });
    const getValues = ()=>value == null ? [] : [].concat(value);
    const handleToggle = (inputVal, event)=>{
        if (!onChange) return;
        const values = getValues();
        const isActive = values.indexOf(inputVal) !== -1;
        if (type === 'radio') {
            if (!isActive) onChange(inputVal, event);
            return;
        }
        if (isActive) onChange(values.filter((n)=>n !== inputVal), event);
        else onChange([
            ...values,
            inputVal
        ], event);
    };
    !(type !== 'radio' || !!name) && (0, _invariantDefault.default)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonGroupDefault.default), {
        ...controlledProps,
        ref: ref,
        vertical: vertical,
        children: (0, _elementChildren.map)(children, (child)=>{
            const values = getValues();
            const { value: childVal, onChange: childOnChange } = child.props;
            const handler = (e)=>handleToggle(childVal, e);
            return /*#__PURE__*/ _react.cloneElement(child, {
                type,
                name: child.name || name,
                checked: values.indexOf(childVal) !== -1,
                onChange: (0, _createChainedFunctionDefault.default)(childOnChange, handler)
            });
        })
    });
});
ToggleButtonGroup.displayName = 'ToggleButtonGroup';
exports.default = Object.assign(ToggleButtonGroup, {
    Button: (0, _toggleButtonDefault.default)
});

},{"react":"bmhQu","invariant":"3cETI","uncontrollable":"1yRhe","./createChainedFunction":"jIxkV","./ElementChildren":"iO22F","./ButtonGroup":"go7mS","./ToggleButton":"inQyE","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"13dwh":[function(require,module,exports,__globalThis) {
module.exports = require("5bdf5d330b1c5b98");

},{"5bdf5d330b1c5b98":"7EGUf"}],"7EGUf":[function(require,module,exports,__globalThis) {
Object.defineProperty(exports, "__esModule", {
    value: !0
});
var t = require("ac6b16128f94da1b");
function i() {
    return i = Object.assign ? Object.assign.bind() : function(t) {
        for(var i = 1; i < arguments.length; i++){
            var s = arguments[i];
            for(var n in s)Object.prototype.hasOwnProperty.call(s, n) && (t[n] = s[n]);
        }
        return t;
    }, i.apply(this, arguments);
}
var s = t.createElement("svg", {
    viewBox: "-2 -5 14 20",
    height: "100%",
    width: "100%",
    style: {
        position: "absolute",
        top: 0
    }
}, t.createElement("path", {
    d: "M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12",
    fill: "#fff",
    fillRule: "evenodd"
})), n = t.createElement("svg", {
    height: "100%",
    width: "100%",
    viewBox: "-2 -5 17 21",
    style: {
        position: "absolute",
        top: 0
    }
}, t.createElement("path", {
    d: "M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0",
    fill: "#fff",
    fillRule: "evenodd"
}));
function o(t) {
    if (7 === t.length) return t;
    for(var i = "#", s = 1; s < 4; s += 1)i += t[s] + t[s];
    return i;
}
function h(t, i, s, n, h) {
    return function(t, i, s, n, o) {
        var h = (t - s) / (i - s);
        if (0 === h) return n;
        if (1 === h) return o;
        for(var e = "#", a = 1; a < 6; a += 2){
            var r = parseInt(n.substr(a, 2), 16), l = parseInt(o.substr(a, 2), 16), u = Math.round((1 - h) * r + h * l).toString(16);
            1 === u.length && (u = "0" + u), e += u;
        }
        return e;
    }(t, i, s, o(n), o(h));
}
var e = function(s) {
    function n(t) {
        s.call(this, t);
        var i = t.height, n = t.width, o = t.checked;
        this.t = t.handleDiameter || i - 2, this.i = Math.max(n - i, n - (i + this.t) / 2), this.o = Math.max(0, (i - this.t) / 2), this.state = {
            h: o ? this.i : this.o
        }, this.l = 0, this.u = 0, this.p = this.p.bind(this), this.v = this.v.bind(this), this.k = this.k.bind(this), this.M = this.M.bind(this), this.m = this.m.bind(this), this.T = this.T.bind(this), this.$ = this.$.bind(this), this.C = this.C.bind(this), this.O = this.O.bind(this), this.D = this.D.bind(this), this.S = this.S.bind(this), this.W = this.W.bind(this);
    }
    return s && (n.__proto__ = s), (n.prototype = Object.create(s && s.prototype)).constructor = n, n.prototype.componentDidMount = function() {
        this.I = !0;
    }, n.prototype.componentDidUpdate = function(t) {
        t.checked !== this.props.checked && this.setState({
            h: this.props.checked ? this.i : this.o
        });
    }, n.prototype.componentWillUnmount = function() {
        this.I = !1;
    }, n.prototype.H = function(t) {
        this.j.focus(), this.setState({
            R: t,
            B: !0,
            L: Date.now()
        });
    }, n.prototype.N = function(t) {
        var i = this.state, s = i.R, n = i.h, o = (this.props.checked ? this.i : this.o) + t - s;
        i.U || t === s || this.setState({
            U: !0
        });
        var h = Math.min(this.i, Math.max(this.o, o));
        h !== n && this.setState({
            h: h
        });
    }, n.prototype.A = function(t) {
        var i = this.state, s = i.h, n = i.U, o = i.L, h = this.props.checked, e = (this.i + this.o) / 2;
        this.setState({
            h: this.props.checked ? this.i : this.o
        });
        var a = Date.now() - o;
        (!n || a < 250 || h && s <= e || !h && s >= e) && this.X(t), this.I && this.setState({
            U: !1,
            B: !1
        }), this.l = Date.now();
    }, n.prototype.p = function(t) {
        t.preventDefault(), "number" == typeof t.button && 0 !== t.button || (this.H(t.clientX), window.addEventListener("mousemove", this.v), window.addEventListener("mouseup", this.k));
    }, n.prototype.v = function(t) {
        t.preventDefault(), this.N(t.clientX);
    }, n.prototype.k = function(t) {
        this.A(t), window.removeEventListener("mousemove", this.v), window.removeEventListener("mouseup", this.k);
    }, n.prototype.M = function(t) {
        this._ = null, this.H(t.touches[0].clientX);
    }, n.prototype.m = function(t) {
        this.N(t.touches[0].clientX);
    }, n.prototype.T = function(t) {
        t.preventDefault(), this.A(t);
    }, n.prototype.C = function(t) {
        Date.now() - this.l > 50 && (this.X(t), Date.now() - this.u > 50 && this.I && this.setState({
            B: !1
        }));
    }, n.prototype.O = function() {
        this.u = Date.now();
    }, n.prototype.D = function() {
        this.setState({
            B: !0
        });
    }, n.prototype.S = function() {
        this.setState({
            B: !1
        });
    }, n.prototype.W = function(t) {
        this.j = t;
    }, n.prototype.$ = function(t) {
        t.preventDefault(), this.j.focus(), this.X(t), this.I && this.setState({
            B: !1
        });
    }, n.prototype.X = function(t) {
        var i = this.props;
        (0, i.onChange)(!i.checked, t, i.id);
    }, n.prototype.render = function() {
        var s = this.props, n = s.checked, o = s.disabled, e = s.className, a = s.offColor, r = s.onColor, l = s.offHandleColor, u = s.onHandleColor, c = s.checkedIcon, d = s.uncheckedIcon, f = s.checkedHandleIcon, p = s.uncheckedHandleIcon, b = s.boxShadow, v = s.activeBoxShadow, g = s.height, y = s.width, w = s.borderRadius, k = function(t, i) {
            var s = {};
            for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && -1 === i.indexOf(n) && (s[n] = t[n]);
            return s;
        }(s, [
            "checked",
            "disabled",
            "className",
            "offColor",
            "onColor",
            "offHandleColor",
            "onHandleColor",
            "checkedIcon",
            "uncheckedIcon",
            "checkedHandleIcon",
            "uncheckedHandleIcon",
            "boxShadow",
            "activeBoxShadow",
            "height",
            "width",
            "borderRadius",
            "handleDiameter"
        ]), M = this.state, m = M.h, T = M.U, x = M.B, $ = {
            position: "relative",
            display: "inline-block",
            textAlign: "left",
            opacity: o ? .5 : 1,
            direction: "ltr",
            borderRadius: g / 2,
            WebkitTransition: "opacity 0.25s",
            MozTransition: "opacity 0.25s",
            transition: "opacity 0.25s",
            touchAction: "none",
            WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
            WebkitUserSelect: "none",
            MozUserSelect: "none",
            msUserSelect: "none",
            userSelect: "none"
        }, C = {
            height: g,
            width: y,
            margin: Math.max(0, (this.t - g) / 2),
            position: "relative",
            background: h(m, this.i, this.o, a, r),
            borderRadius: "number" == typeof w ? w : g / 2,
            cursor: o ? "default" : "pointer",
            WebkitTransition: T ? null : "background 0.25s",
            MozTransition: T ? null : "background 0.25s",
            transition: T ? null : "background 0.25s"
        }, O = {
            height: g,
            width: Math.min(1.5 * g, y - (this.t + g) / 2 + 1),
            position: "relative",
            opacity: (m - this.o) / (this.i - this.o),
            pointerEvents: "none",
            WebkitTransition: T ? null : "opacity 0.25s",
            MozTransition: T ? null : "opacity 0.25s",
            transition: T ? null : "opacity 0.25s"
        }, D = {
            height: g,
            width: Math.min(1.5 * g, y - (this.t + g) / 2 + 1),
            position: "absolute",
            opacity: 1 - (m - this.o) / (this.i - this.o),
            right: 0,
            top: 0,
            pointerEvents: "none",
            WebkitTransition: T ? null : "opacity 0.25s",
            MozTransition: T ? null : "opacity 0.25s",
            transition: T ? null : "opacity 0.25s"
        }, S = {
            height: this.t,
            width: this.t,
            background: h(m, this.i, this.o, l, u),
            display: "inline-block",
            cursor: o ? "default" : "pointer",
            borderRadius: "number" == typeof w ? w - 1 : "50%",
            position: "absolute",
            transform: "translateX(" + m + "px)",
            top: Math.max(0, (g - this.t) / 2),
            outline: 0,
            boxShadow: x ? v : b,
            border: 0,
            WebkitTransition: T ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s",
            MozTransition: T ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s",
            transition: T ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s"
        }, W = {
            height: this.t,
            width: this.t,
            opacity: Math.max(2 * (1 - (m - this.o) / (this.i - this.o) - .5), 0),
            position: "absolute",
            left: 0,
            top: 0,
            pointerEvents: "none",
            WebkitTransition: T ? null : "opacity 0.25s",
            MozTransition: T ? null : "opacity 0.25s",
            transition: T ? null : "opacity 0.25s"
        }, z = {
            height: this.t,
            width: this.t,
            opacity: Math.max(2 * ((m - this.o) / (this.i - this.o) - .5), 0),
            position: "absolute",
            left: 0,
            top: 0,
            pointerEvents: "none",
            WebkitTransition: T ? null : "opacity 0.25s",
            MozTransition: T ? null : "opacity 0.25s",
            transition: T ? null : "opacity 0.25s"
        };
        return t.createElement("div", {
            className: e,
            style: $
        }, t.createElement("div", {
            className: "react-switch-bg",
            style: C,
            onClick: o ? null : this.$,
            onMouseDown: function(t) {
                return t.preventDefault();
            }
        }, c && t.createElement("div", {
            style: O
        }, c), d && t.createElement("div", {
            style: D
        }, d)), t.createElement("div", {
            className: "react-switch-handle",
            style: S,
            onClick: function(t) {
                return t.preventDefault();
            },
            onMouseDown: o ? null : this.p,
            onTouchStart: o ? null : this.M,
            onTouchMove: o ? null : this.m,
            onTouchEnd: o ? null : this.T,
            onTouchCancel: o ? null : this.S
        }, p && t.createElement("div", {
            style: W
        }, p), f && t.createElement("div", {
            style: z
        }, f)), t.createElement("input", i({}, {
            type: "checkbox",
            role: "switch",
            "aria-checked": n,
            checked: n,
            disabled: o,
            style: {
                border: 0,
                clip: "rect(0 0 0 0)",
                height: 1,
                margin: -1,
                overflow: "hidden",
                padding: 0,
                position: "absolute",
                width: 1
            }
        }, k, {
            ref: this.W,
            onFocus: this.D,
            onBlur: this.S,
            onKeyUp: this.O,
            onChange: this.C
        })));
    }, n;
}(t.Component);
e.defaultProps = {
    disabled: !1,
    offColor: "#888",
    onColor: "#080",
    offHandleColor: "#fff",
    onHandleColor: "#fff",
    uncheckedIcon: s,
    checkedIcon: n,
    boxShadow: null,
    activeBoxShadow: "0 0 2px 3px #3bf",
    height: 28,
    width: 56
}, exports.default = e;

},{"ac6b16128f94da1b":"bmhQu"}],"68aAv":[function(require,module,exports,__globalThis) {
// THIS FILE IS AUTO GENERATED
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IoAccessibilityOutline", ()=>IoAccessibilityOutline);
parcelHelpers.export(exports, "IoAccessibilitySharp", ()=>IoAccessibilitySharp);
parcelHelpers.export(exports, "IoAccessibility", ()=>IoAccessibility);
parcelHelpers.export(exports, "IoAddCircleOutline", ()=>IoAddCircleOutline);
parcelHelpers.export(exports, "IoAddCircleSharp", ()=>IoAddCircleSharp);
parcelHelpers.export(exports, "IoAddCircle", ()=>IoAddCircle);
parcelHelpers.export(exports, "IoAddOutline", ()=>IoAddOutline);
parcelHelpers.export(exports, "IoAddSharp", ()=>IoAddSharp);
parcelHelpers.export(exports, "IoAdd", ()=>IoAdd);
parcelHelpers.export(exports, "IoAirplaneOutline", ()=>IoAirplaneOutline);
parcelHelpers.export(exports, "IoAirplaneSharp", ()=>IoAirplaneSharp);
parcelHelpers.export(exports, "IoAirplane", ()=>IoAirplane);
parcelHelpers.export(exports, "IoAlarmOutline", ()=>IoAlarmOutline);
parcelHelpers.export(exports, "IoAlarmSharp", ()=>IoAlarmSharp);
parcelHelpers.export(exports, "IoAlarm", ()=>IoAlarm);
parcelHelpers.export(exports, "IoAlbumsOutline", ()=>IoAlbumsOutline);
parcelHelpers.export(exports, "IoAlbumsSharp", ()=>IoAlbumsSharp);
parcelHelpers.export(exports, "IoAlbums", ()=>IoAlbums);
parcelHelpers.export(exports, "IoAlertCircleOutline", ()=>IoAlertCircleOutline);
parcelHelpers.export(exports, "IoAlertCircleSharp", ()=>IoAlertCircleSharp);
parcelHelpers.export(exports, "IoAlertCircle", ()=>IoAlertCircle);
parcelHelpers.export(exports, "IoAlertOutline", ()=>IoAlertOutline);
parcelHelpers.export(exports, "IoAlertSharp", ()=>IoAlertSharp);
parcelHelpers.export(exports, "IoAlert", ()=>IoAlert);
parcelHelpers.export(exports, "IoAmericanFootballOutline", ()=>IoAmericanFootballOutline);
parcelHelpers.export(exports, "IoAmericanFootballSharp", ()=>IoAmericanFootballSharp);
parcelHelpers.export(exports, "IoAmericanFootball", ()=>IoAmericanFootball);
parcelHelpers.export(exports, "IoAnalyticsOutline", ()=>IoAnalyticsOutline);
parcelHelpers.export(exports, "IoAnalyticsSharp", ()=>IoAnalyticsSharp);
parcelHelpers.export(exports, "IoAnalytics", ()=>IoAnalytics);
parcelHelpers.export(exports, "IoApertureOutline", ()=>IoApertureOutline);
parcelHelpers.export(exports, "IoApertureSharp", ()=>IoApertureSharp);
parcelHelpers.export(exports, "IoAperture", ()=>IoAperture);
parcelHelpers.export(exports, "IoAppsOutline", ()=>IoAppsOutline);
parcelHelpers.export(exports, "IoAppsSharp", ()=>IoAppsSharp);
parcelHelpers.export(exports, "IoApps", ()=>IoApps);
parcelHelpers.export(exports, "IoArchiveOutline", ()=>IoArchiveOutline);
parcelHelpers.export(exports, "IoArchiveSharp", ()=>IoArchiveSharp);
parcelHelpers.export(exports, "IoArchive", ()=>IoArchive);
parcelHelpers.export(exports, "IoArrowBackCircleOutline", ()=>IoArrowBackCircleOutline);
parcelHelpers.export(exports, "IoArrowBackCircleSharp", ()=>IoArrowBackCircleSharp);
parcelHelpers.export(exports, "IoArrowBackCircle", ()=>IoArrowBackCircle);
parcelHelpers.export(exports, "IoArrowBackOutline", ()=>IoArrowBackOutline);
parcelHelpers.export(exports, "IoArrowBackSharp", ()=>IoArrowBackSharp);
parcelHelpers.export(exports, "IoArrowBack", ()=>IoArrowBack);
parcelHelpers.export(exports, "IoArrowDownCircleOutline", ()=>IoArrowDownCircleOutline);
parcelHelpers.export(exports, "IoArrowDownCircleSharp", ()=>IoArrowDownCircleSharp);
parcelHelpers.export(exports, "IoArrowDownCircle", ()=>IoArrowDownCircle);
parcelHelpers.export(exports, "IoArrowDownOutline", ()=>IoArrowDownOutline);
parcelHelpers.export(exports, "IoArrowDownSharp", ()=>IoArrowDownSharp);
parcelHelpers.export(exports, "IoArrowDown", ()=>IoArrowDown);
parcelHelpers.export(exports, "IoArrowForwardCircleOutline", ()=>IoArrowForwardCircleOutline);
parcelHelpers.export(exports, "IoArrowForwardCircleSharp", ()=>IoArrowForwardCircleSharp);
parcelHelpers.export(exports, "IoArrowForwardCircle", ()=>IoArrowForwardCircle);
parcelHelpers.export(exports, "IoArrowForwardOutline", ()=>IoArrowForwardOutline);
parcelHelpers.export(exports, "IoArrowForwardSharp", ()=>IoArrowForwardSharp);
parcelHelpers.export(exports, "IoArrowForward", ()=>IoArrowForward);
parcelHelpers.export(exports, "IoArrowRedoCircleOutline", ()=>IoArrowRedoCircleOutline);
parcelHelpers.export(exports, "IoArrowRedoCircleSharp", ()=>IoArrowRedoCircleSharp);
parcelHelpers.export(exports, "IoArrowRedoCircle", ()=>IoArrowRedoCircle);
parcelHelpers.export(exports, "IoArrowRedoOutline", ()=>IoArrowRedoOutline);
parcelHelpers.export(exports, "IoArrowRedoSharp", ()=>IoArrowRedoSharp);
parcelHelpers.export(exports, "IoArrowRedo", ()=>IoArrowRedo);
parcelHelpers.export(exports, "IoArrowUndoCircleOutline", ()=>IoArrowUndoCircleOutline);
parcelHelpers.export(exports, "IoArrowUndoCircleSharp", ()=>IoArrowUndoCircleSharp);
parcelHelpers.export(exports, "IoArrowUndoCircle", ()=>IoArrowUndoCircle);
parcelHelpers.export(exports, "IoArrowUndoOutline", ()=>IoArrowUndoOutline);
parcelHelpers.export(exports, "IoArrowUndoSharp", ()=>IoArrowUndoSharp);
parcelHelpers.export(exports, "IoArrowUndo", ()=>IoArrowUndo);
parcelHelpers.export(exports, "IoArrowUpCircleOutline", ()=>IoArrowUpCircleOutline);
parcelHelpers.export(exports, "IoArrowUpCircleSharp", ()=>IoArrowUpCircleSharp);
parcelHelpers.export(exports, "IoArrowUpCircle", ()=>IoArrowUpCircle);
parcelHelpers.export(exports, "IoArrowUpOutline", ()=>IoArrowUpOutline);
parcelHelpers.export(exports, "IoArrowUpSharp", ()=>IoArrowUpSharp);
parcelHelpers.export(exports, "IoArrowUp", ()=>IoArrowUp);
parcelHelpers.export(exports, "IoAtCircleOutline", ()=>IoAtCircleOutline);
parcelHelpers.export(exports, "IoAtCircleSharp", ()=>IoAtCircleSharp);
parcelHelpers.export(exports, "IoAtCircle", ()=>IoAtCircle);
parcelHelpers.export(exports, "IoAtOutline", ()=>IoAtOutline);
parcelHelpers.export(exports, "IoAtSharp", ()=>IoAtSharp);
parcelHelpers.export(exports, "IoAt", ()=>IoAt);
parcelHelpers.export(exports, "IoAttachOutline", ()=>IoAttachOutline);
parcelHelpers.export(exports, "IoAttachSharp", ()=>IoAttachSharp);
parcelHelpers.export(exports, "IoAttach", ()=>IoAttach);
parcelHelpers.export(exports, "IoBackspaceOutline", ()=>IoBackspaceOutline);
parcelHelpers.export(exports, "IoBackspaceSharp", ()=>IoBackspaceSharp);
parcelHelpers.export(exports, "IoBackspace", ()=>IoBackspace);
parcelHelpers.export(exports, "IoBagAddOutline", ()=>IoBagAddOutline);
parcelHelpers.export(exports, "IoBagAddSharp", ()=>IoBagAddSharp);
parcelHelpers.export(exports, "IoBagAdd", ()=>IoBagAdd);
parcelHelpers.export(exports, "IoBagCheckOutline", ()=>IoBagCheckOutline);
parcelHelpers.export(exports, "IoBagCheckSharp", ()=>IoBagCheckSharp);
parcelHelpers.export(exports, "IoBagCheck", ()=>IoBagCheck);
parcelHelpers.export(exports, "IoBagHandleOutline", ()=>IoBagHandleOutline);
parcelHelpers.export(exports, "IoBagHandleSharp", ()=>IoBagHandleSharp);
parcelHelpers.export(exports, "IoBagHandle", ()=>IoBagHandle);
parcelHelpers.export(exports, "IoBagOutline", ()=>IoBagOutline);
parcelHelpers.export(exports, "IoBagRemoveOutline", ()=>IoBagRemoveOutline);
parcelHelpers.export(exports, "IoBagRemoveSharp", ()=>IoBagRemoveSharp);
parcelHelpers.export(exports, "IoBagRemove", ()=>IoBagRemove);
parcelHelpers.export(exports, "IoBagSharp", ()=>IoBagSharp);
parcelHelpers.export(exports, "IoBag", ()=>IoBag);
parcelHelpers.export(exports, "IoBalloonOutline", ()=>IoBalloonOutline);
parcelHelpers.export(exports, "IoBalloonSharp", ()=>IoBalloonSharp);
parcelHelpers.export(exports, "IoBalloon", ()=>IoBalloon);
parcelHelpers.export(exports, "IoBanOutline", ()=>IoBanOutline);
parcelHelpers.export(exports, "IoBanSharp", ()=>IoBanSharp);
parcelHelpers.export(exports, "IoBan", ()=>IoBan);
parcelHelpers.export(exports, "IoBandageOutline", ()=>IoBandageOutline);
parcelHelpers.export(exports, "IoBandageSharp", ()=>IoBandageSharp);
parcelHelpers.export(exports, "IoBandage", ()=>IoBandage);
parcelHelpers.export(exports, "IoBarChartOutline", ()=>IoBarChartOutline);
parcelHelpers.export(exports, "IoBarChartSharp", ()=>IoBarChartSharp);
parcelHelpers.export(exports, "IoBarChart", ()=>IoBarChart);
parcelHelpers.export(exports, "IoBarbellOutline", ()=>IoBarbellOutline);
parcelHelpers.export(exports, "IoBarbellSharp", ()=>IoBarbellSharp);
parcelHelpers.export(exports, "IoBarbell", ()=>IoBarbell);
parcelHelpers.export(exports, "IoBarcodeOutline", ()=>IoBarcodeOutline);
parcelHelpers.export(exports, "IoBarcodeSharp", ()=>IoBarcodeSharp);
parcelHelpers.export(exports, "IoBarcode", ()=>IoBarcode);
parcelHelpers.export(exports, "IoBaseballOutline", ()=>IoBaseballOutline);
parcelHelpers.export(exports, "IoBaseballSharp", ()=>IoBaseballSharp);
parcelHelpers.export(exports, "IoBaseball", ()=>IoBaseball);
parcelHelpers.export(exports, "IoBasketOutline", ()=>IoBasketOutline);
parcelHelpers.export(exports, "IoBasketSharp", ()=>IoBasketSharp);
parcelHelpers.export(exports, "IoBasket", ()=>IoBasket);
parcelHelpers.export(exports, "IoBasketballOutline", ()=>IoBasketballOutline);
parcelHelpers.export(exports, "IoBasketballSharp", ()=>IoBasketballSharp);
parcelHelpers.export(exports, "IoBasketball", ()=>IoBasketball);
parcelHelpers.export(exports, "IoBatteryChargingOutline", ()=>IoBatteryChargingOutline);
parcelHelpers.export(exports, "IoBatteryChargingSharp", ()=>IoBatteryChargingSharp);
parcelHelpers.export(exports, "IoBatteryCharging", ()=>IoBatteryCharging);
parcelHelpers.export(exports, "IoBatteryDeadOutline", ()=>IoBatteryDeadOutline);
parcelHelpers.export(exports, "IoBatteryDeadSharp", ()=>IoBatteryDeadSharp);
parcelHelpers.export(exports, "IoBatteryDead", ()=>IoBatteryDead);
parcelHelpers.export(exports, "IoBatteryFullOutline", ()=>IoBatteryFullOutline);
parcelHelpers.export(exports, "IoBatteryFullSharp", ()=>IoBatteryFullSharp);
parcelHelpers.export(exports, "IoBatteryFull", ()=>IoBatteryFull);
parcelHelpers.export(exports, "IoBatteryHalfOutline", ()=>IoBatteryHalfOutline);
parcelHelpers.export(exports, "IoBatteryHalfSharp", ()=>IoBatteryHalfSharp);
parcelHelpers.export(exports, "IoBatteryHalf", ()=>IoBatteryHalf);
parcelHelpers.export(exports, "IoBeakerOutline", ()=>IoBeakerOutline);
parcelHelpers.export(exports, "IoBeakerSharp", ()=>IoBeakerSharp);
parcelHelpers.export(exports, "IoBeaker", ()=>IoBeaker);
parcelHelpers.export(exports, "IoBedOutline", ()=>IoBedOutline);
parcelHelpers.export(exports, "IoBedSharp", ()=>IoBedSharp);
parcelHelpers.export(exports, "IoBed", ()=>IoBed);
parcelHelpers.export(exports, "IoBeerOutline", ()=>IoBeerOutline);
parcelHelpers.export(exports, "IoBeerSharp", ()=>IoBeerSharp);
parcelHelpers.export(exports, "IoBeer", ()=>IoBeer);
parcelHelpers.export(exports, "IoBicycleOutline", ()=>IoBicycleOutline);
parcelHelpers.export(exports, "IoBicycleSharp", ()=>IoBicycleSharp);
parcelHelpers.export(exports, "IoBicycle", ()=>IoBicycle);
parcelHelpers.export(exports, "IoBluetoothOutline", ()=>IoBluetoothOutline);
parcelHelpers.export(exports, "IoBluetoothSharp", ()=>IoBluetoothSharp);
parcelHelpers.export(exports, "IoBluetooth", ()=>IoBluetooth);
parcelHelpers.export(exports, "IoBoatOutline", ()=>IoBoatOutline);
parcelHelpers.export(exports, "IoBoatSharp", ()=>IoBoatSharp);
parcelHelpers.export(exports, "IoBoat", ()=>IoBoat);
parcelHelpers.export(exports, "IoBodyOutline", ()=>IoBodyOutline);
parcelHelpers.export(exports, "IoBodySharp", ()=>IoBodySharp);
parcelHelpers.export(exports, "IoBody", ()=>IoBody);
parcelHelpers.export(exports, "IoBonfireOutline", ()=>IoBonfireOutline);
parcelHelpers.export(exports, "IoBonfireSharp", ()=>IoBonfireSharp);
parcelHelpers.export(exports, "IoBonfire", ()=>IoBonfire);
parcelHelpers.export(exports, "IoBookOutline", ()=>IoBookOutline);
parcelHelpers.export(exports, "IoBookSharp", ()=>IoBookSharp);
parcelHelpers.export(exports, "IoBook", ()=>IoBook);
parcelHelpers.export(exports, "IoBookmarkOutline", ()=>IoBookmarkOutline);
parcelHelpers.export(exports, "IoBookmarkSharp", ()=>IoBookmarkSharp);
parcelHelpers.export(exports, "IoBookmark", ()=>IoBookmark);
parcelHelpers.export(exports, "IoBookmarksOutline", ()=>IoBookmarksOutline);
parcelHelpers.export(exports, "IoBookmarksSharp", ()=>IoBookmarksSharp);
parcelHelpers.export(exports, "IoBookmarks", ()=>IoBookmarks);
parcelHelpers.export(exports, "IoBowlingBallOutline", ()=>IoBowlingBallOutline);
parcelHelpers.export(exports, "IoBowlingBallSharp", ()=>IoBowlingBallSharp);
parcelHelpers.export(exports, "IoBowlingBall", ()=>IoBowlingBall);
parcelHelpers.export(exports, "IoBriefcaseOutline", ()=>IoBriefcaseOutline);
parcelHelpers.export(exports, "IoBriefcaseSharp", ()=>IoBriefcaseSharp);
parcelHelpers.export(exports, "IoBriefcase", ()=>IoBriefcase);
parcelHelpers.export(exports, "IoBrowsersOutline", ()=>IoBrowsersOutline);
parcelHelpers.export(exports, "IoBrowsersSharp", ()=>IoBrowsersSharp);
parcelHelpers.export(exports, "IoBrowsers", ()=>IoBrowsers);
parcelHelpers.export(exports, "IoBrushOutline", ()=>IoBrushOutline);
parcelHelpers.export(exports, "IoBrushSharp", ()=>IoBrushSharp);
parcelHelpers.export(exports, "IoBrush", ()=>IoBrush);
parcelHelpers.export(exports, "IoBugOutline", ()=>IoBugOutline);
parcelHelpers.export(exports, "IoBugSharp", ()=>IoBugSharp);
parcelHelpers.export(exports, "IoBug", ()=>IoBug);
parcelHelpers.export(exports, "IoBuildOutline", ()=>IoBuildOutline);
parcelHelpers.export(exports, "IoBuildSharp", ()=>IoBuildSharp);
parcelHelpers.export(exports, "IoBuild", ()=>IoBuild);
parcelHelpers.export(exports, "IoBulbOutline", ()=>IoBulbOutline);
parcelHelpers.export(exports, "IoBulbSharp", ()=>IoBulbSharp);
parcelHelpers.export(exports, "IoBulb", ()=>IoBulb);
parcelHelpers.export(exports, "IoBusOutline", ()=>IoBusOutline);
parcelHelpers.export(exports, "IoBusSharp", ()=>IoBusSharp);
parcelHelpers.export(exports, "IoBus", ()=>IoBus);
parcelHelpers.export(exports, "IoBusinessOutline", ()=>IoBusinessOutline);
parcelHelpers.export(exports, "IoBusinessSharp", ()=>IoBusinessSharp);
parcelHelpers.export(exports, "IoBusiness", ()=>IoBusiness);
parcelHelpers.export(exports, "IoCafeOutline", ()=>IoCafeOutline);
parcelHelpers.export(exports, "IoCafeSharp", ()=>IoCafeSharp);
parcelHelpers.export(exports, "IoCafe", ()=>IoCafe);
parcelHelpers.export(exports, "IoCalculatorOutline", ()=>IoCalculatorOutline);
parcelHelpers.export(exports, "IoCalculatorSharp", ()=>IoCalculatorSharp);
parcelHelpers.export(exports, "IoCalculator", ()=>IoCalculator);
parcelHelpers.export(exports, "IoCalendarClearOutline", ()=>IoCalendarClearOutline);
parcelHelpers.export(exports, "IoCalendarClearSharp", ()=>IoCalendarClearSharp);
parcelHelpers.export(exports, "IoCalendarClear", ()=>IoCalendarClear);
parcelHelpers.export(exports, "IoCalendarNumberOutline", ()=>IoCalendarNumberOutline);
parcelHelpers.export(exports, "IoCalendarNumberSharp", ()=>IoCalendarNumberSharp);
parcelHelpers.export(exports, "IoCalendarNumber", ()=>IoCalendarNumber);
parcelHelpers.export(exports, "IoCalendarOutline", ()=>IoCalendarOutline);
parcelHelpers.export(exports, "IoCalendarSharp", ()=>IoCalendarSharp);
parcelHelpers.export(exports, "IoCalendar", ()=>IoCalendar);
parcelHelpers.export(exports, "IoCallOutline", ()=>IoCallOutline);
parcelHelpers.export(exports, "IoCallSharp", ()=>IoCallSharp);
parcelHelpers.export(exports, "IoCall", ()=>IoCall);
parcelHelpers.export(exports, "IoCameraOutline", ()=>IoCameraOutline);
parcelHelpers.export(exports, "IoCameraReverseOutline", ()=>IoCameraReverseOutline);
parcelHelpers.export(exports, "IoCameraReverseSharp", ()=>IoCameraReverseSharp);
parcelHelpers.export(exports, "IoCameraReverse", ()=>IoCameraReverse);
parcelHelpers.export(exports, "IoCameraSharp", ()=>IoCameraSharp);
parcelHelpers.export(exports, "IoCamera", ()=>IoCamera);
parcelHelpers.export(exports, "IoCarOutline", ()=>IoCarOutline);
parcelHelpers.export(exports, "IoCarSharp", ()=>IoCarSharp);
parcelHelpers.export(exports, "IoCarSportOutline", ()=>IoCarSportOutline);
parcelHelpers.export(exports, "IoCarSportSharp", ()=>IoCarSportSharp);
parcelHelpers.export(exports, "IoCarSport", ()=>IoCarSport);
parcelHelpers.export(exports, "IoCar", ()=>IoCar);
parcelHelpers.export(exports, "IoCardOutline", ()=>IoCardOutline);
parcelHelpers.export(exports, "IoCardSharp", ()=>IoCardSharp);
parcelHelpers.export(exports, "IoCard", ()=>IoCard);
parcelHelpers.export(exports, "IoCaretBackCircleOutline", ()=>IoCaretBackCircleOutline);
parcelHelpers.export(exports, "IoCaretBackCircleSharp", ()=>IoCaretBackCircleSharp);
parcelHelpers.export(exports, "IoCaretBackCircle", ()=>IoCaretBackCircle);
parcelHelpers.export(exports, "IoCaretBackOutline", ()=>IoCaretBackOutline);
parcelHelpers.export(exports, "IoCaretBackSharp", ()=>IoCaretBackSharp);
parcelHelpers.export(exports, "IoCaretBack", ()=>IoCaretBack);
parcelHelpers.export(exports, "IoCaretDownCircleOutline", ()=>IoCaretDownCircleOutline);
parcelHelpers.export(exports, "IoCaretDownCircleSharp", ()=>IoCaretDownCircleSharp);
parcelHelpers.export(exports, "IoCaretDownCircle", ()=>IoCaretDownCircle);
parcelHelpers.export(exports, "IoCaretDownOutline", ()=>IoCaretDownOutline);
parcelHelpers.export(exports, "IoCaretDownSharp", ()=>IoCaretDownSharp);
parcelHelpers.export(exports, "IoCaretDown", ()=>IoCaretDown);
parcelHelpers.export(exports, "IoCaretForwardCircleOutline", ()=>IoCaretForwardCircleOutline);
parcelHelpers.export(exports, "IoCaretForwardCircleSharp", ()=>IoCaretForwardCircleSharp);
parcelHelpers.export(exports, "IoCaretForwardCircle", ()=>IoCaretForwardCircle);
parcelHelpers.export(exports, "IoCaretForwardOutline", ()=>IoCaretForwardOutline);
parcelHelpers.export(exports, "IoCaretForwardSharp", ()=>IoCaretForwardSharp);
parcelHelpers.export(exports, "IoCaretForward", ()=>IoCaretForward);
parcelHelpers.export(exports, "IoCaretUpCircleOutline", ()=>IoCaretUpCircleOutline);
parcelHelpers.export(exports, "IoCaretUpCircleSharp", ()=>IoCaretUpCircleSharp);
parcelHelpers.export(exports, "IoCaretUpCircle", ()=>IoCaretUpCircle);
parcelHelpers.export(exports, "IoCaretUpOutline", ()=>IoCaretUpOutline);
parcelHelpers.export(exports, "IoCaretUpSharp", ()=>IoCaretUpSharp);
parcelHelpers.export(exports, "IoCaretUp", ()=>IoCaretUp);
parcelHelpers.export(exports, "IoCartOutline", ()=>IoCartOutline);
parcelHelpers.export(exports, "IoCartSharp", ()=>IoCartSharp);
parcelHelpers.export(exports, "IoCart", ()=>IoCart);
parcelHelpers.export(exports, "IoCashOutline", ()=>IoCashOutline);
parcelHelpers.export(exports, "IoCashSharp", ()=>IoCashSharp);
parcelHelpers.export(exports, "IoCash", ()=>IoCash);
parcelHelpers.export(exports, "IoCellularOutline", ()=>IoCellularOutline);
parcelHelpers.export(exports, "IoCellularSharp", ()=>IoCellularSharp);
parcelHelpers.export(exports, "IoCellular", ()=>IoCellular);
parcelHelpers.export(exports, "IoChatboxEllipsesOutline", ()=>IoChatboxEllipsesOutline);
parcelHelpers.export(exports, "IoChatboxEllipsesSharp", ()=>IoChatboxEllipsesSharp);
parcelHelpers.export(exports, "IoChatboxEllipses", ()=>IoChatboxEllipses);
parcelHelpers.export(exports, "IoChatboxOutline", ()=>IoChatboxOutline);
parcelHelpers.export(exports, "IoChatboxSharp", ()=>IoChatboxSharp);
parcelHelpers.export(exports, "IoChatbox", ()=>IoChatbox);
parcelHelpers.export(exports, "IoChatbubbleEllipsesOutline", ()=>IoChatbubbleEllipsesOutline);
parcelHelpers.export(exports, "IoChatbubbleEllipsesSharp", ()=>IoChatbubbleEllipsesSharp);
parcelHelpers.export(exports, "IoChatbubbleEllipses", ()=>IoChatbubbleEllipses);
parcelHelpers.export(exports, "IoChatbubbleOutline", ()=>IoChatbubbleOutline);
parcelHelpers.export(exports, "IoChatbubbleSharp", ()=>IoChatbubbleSharp);
parcelHelpers.export(exports, "IoChatbubble", ()=>IoChatbubble);
parcelHelpers.export(exports, "IoChatbubblesOutline", ()=>IoChatbubblesOutline);
parcelHelpers.export(exports, "IoChatbubblesSharp", ()=>IoChatbubblesSharp);
parcelHelpers.export(exports, "IoChatbubbles", ()=>IoChatbubbles);
parcelHelpers.export(exports, "IoCheckboxOutline", ()=>IoCheckboxOutline);
parcelHelpers.export(exports, "IoCheckboxSharp", ()=>IoCheckboxSharp);
parcelHelpers.export(exports, "IoCheckbox", ()=>IoCheckbox);
parcelHelpers.export(exports, "IoCheckmarkCircleOutline", ()=>IoCheckmarkCircleOutline);
parcelHelpers.export(exports, "IoCheckmarkCircleSharp", ()=>IoCheckmarkCircleSharp);
parcelHelpers.export(exports, "IoCheckmarkCircle", ()=>IoCheckmarkCircle);
parcelHelpers.export(exports, "IoCheckmarkDoneCircleOutline", ()=>IoCheckmarkDoneCircleOutline);
parcelHelpers.export(exports, "IoCheckmarkDoneCircleSharp", ()=>IoCheckmarkDoneCircleSharp);
parcelHelpers.export(exports, "IoCheckmarkDoneCircle", ()=>IoCheckmarkDoneCircle);
parcelHelpers.export(exports, "IoCheckmarkDoneOutline", ()=>IoCheckmarkDoneOutline);
parcelHelpers.export(exports, "IoCheckmarkDoneSharp", ()=>IoCheckmarkDoneSharp);
parcelHelpers.export(exports, "IoCheckmarkDone", ()=>IoCheckmarkDone);
parcelHelpers.export(exports, "IoCheckmarkOutline", ()=>IoCheckmarkOutline);
parcelHelpers.export(exports, "IoCheckmarkSharp", ()=>IoCheckmarkSharp);
parcelHelpers.export(exports, "IoCheckmark", ()=>IoCheckmark);
parcelHelpers.export(exports, "IoChevronBackCircleOutline", ()=>IoChevronBackCircleOutline);
parcelHelpers.export(exports, "IoChevronBackCircleSharp", ()=>IoChevronBackCircleSharp);
parcelHelpers.export(exports, "IoChevronBackCircle", ()=>IoChevronBackCircle);
parcelHelpers.export(exports, "IoChevronBackOutline", ()=>IoChevronBackOutline);
parcelHelpers.export(exports, "IoChevronBackSharp", ()=>IoChevronBackSharp);
parcelHelpers.export(exports, "IoChevronBack", ()=>IoChevronBack);
parcelHelpers.export(exports, "IoChevronDownCircleOutline", ()=>IoChevronDownCircleOutline);
parcelHelpers.export(exports, "IoChevronDownCircleSharp", ()=>IoChevronDownCircleSharp);
parcelHelpers.export(exports, "IoChevronDownCircle", ()=>IoChevronDownCircle);
parcelHelpers.export(exports, "IoChevronDownOutline", ()=>IoChevronDownOutline);
parcelHelpers.export(exports, "IoChevronDownSharp", ()=>IoChevronDownSharp);
parcelHelpers.export(exports, "IoChevronDown", ()=>IoChevronDown);
parcelHelpers.export(exports, "IoChevronForwardCircleOutline", ()=>IoChevronForwardCircleOutline);
parcelHelpers.export(exports, "IoChevronForwardCircleSharp", ()=>IoChevronForwardCircleSharp);
parcelHelpers.export(exports, "IoChevronForwardCircle", ()=>IoChevronForwardCircle);
parcelHelpers.export(exports, "IoChevronForwardOutline", ()=>IoChevronForwardOutline);
parcelHelpers.export(exports, "IoChevronForwardSharp", ()=>IoChevronForwardSharp);
parcelHelpers.export(exports, "IoChevronForward", ()=>IoChevronForward);
parcelHelpers.export(exports, "IoChevronUpCircleOutline", ()=>IoChevronUpCircleOutline);
parcelHelpers.export(exports, "IoChevronUpCircleSharp", ()=>IoChevronUpCircleSharp);
parcelHelpers.export(exports, "IoChevronUpCircle", ()=>IoChevronUpCircle);
parcelHelpers.export(exports, "IoChevronUpOutline", ()=>IoChevronUpOutline);
parcelHelpers.export(exports, "IoChevronUpSharp", ()=>IoChevronUpSharp);
parcelHelpers.export(exports, "IoChevronUp", ()=>IoChevronUp);
parcelHelpers.export(exports, "IoClipboardOutline", ()=>IoClipboardOutline);
parcelHelpers.export(exports, "IoClipboardSharp", ()=>IoClipboardSharp);
parcelHelpers.export(exports, "IoClipboard", ()=>IoClipboard);
parcelHelpers.export(exports, "IoCloseCircleOutline", ()=>IoCloseCircleOutline);
parcelHelpers.export(exports, "IoCloseCircleSharp", ()=>IoCloseCircleSharp);
parcelHelpers.export(exports, "IoCloseCircle", ()=>IoCloseCircle);
parcelHelpers.export(exports, "IoCloseOutline", ()=>IoCloseOutline);
parcelHelpers.export(exports, "IoCloseSharp", ()=>IoCloseSharp);
parcelHelpers.export(exports, "IoClose", ()=>IoClose);
parcelHelpers.export(exports, "IoCloudCircleOutline", ()=>IoCloudCircleOutline);
parcelHelpers.export(exports, "IoCloudCircleSharp", ()=>IoCloudCircleSharp);
parcelHelpers.export(exports, "IoCloudCircle", ()=>IoCloudCircle);
parcelHelpers.export(exports, "IoCloudDoneOutline", ()=>IoCloudDoneOutline);
parcelHelpers.export(exports, "IoCloudDoneSharp", ()=>IoCloudDoneSharp);
parcelHelpers.export(exports, "IoCloudDone", ()=>IoCloudDone);
parcelHelpers.export(exports, "IoCloudDownloadOutline", ()=>IoCloudDownloadOutline);
parcelHelpers.export(exports, "IoCloudDownloadSharp", ()=>IoCloudDownloadSharp);
parcelHelpers.export(exports, "IoCloudDownload", ()=>IoCloudDownload);
parcelHelpers.export(exports, "IoCloudOfflineOutline", ()=>IoCloudOfflineOutline);
parcelHelpers.export(exports, "IoCloudOfflineSharp", ()=>IoCloudOfflineSharp);
parcelHelpers.export(exports, "IoCloudOffline", ()=>IoCloudOffline);
parcelHelpers.export(exports, "IoCloudOutline", ()=>IoCloudOutline);
parcelHelpers.export(exports, "IoCloudSharp", ()=>IoCloudSharp);
parcelHelpers.export(exports, "IoCloudUploadOutline", ()=>IoCloudUploadOutline);
parcelHelpers.export(exports, "IoCloudUploadSharp", ()=>IoCloudUploadSharp);
parcelHelpers.export(exports, "IoCloudUpload", ()=>IoCloudUpload);
parcelHelpers.export(exports, "IoCloud", ()=>IoCloud);
parcelHelpers.export(exports, "IoCloudyNightOutline", ()=>IoCloudyNightOutline);
parcelHelpers.export(exports, "IoCloudyNightSharp", ()=>IoCloudyNightSharp);
parcelHelpers.export(exports, "IoCloudyNight", ()=>IoCloudyNight);
parcelHelpers.export(exports, "IoCloudyOutline", ()=>IoCloudyOutline);
parcelHelpers.export(exports, "IoCloudySharp", ()=>IoCloudySharp);
parcelHelpers.export(exports, "IoCloudy", ()=>IoCloudy);
parcelHelpers.export(exports, "IoCodeDownloadOutline", ()=>IoCodeDownloadOutline);
parcelHelpers.export(exports, "IoCodeDownloadSharp", ()=>IoCodeDownloadSharp);
parcelHelpers.export(exports, "IoCodeDownload", ()=>IoCodeDownload);
parcelHelpers.export(exports, "IoCodeOutline", ()=>IoCodeOutline);
parcelHelpers.export(exports, "IoCodeSharp", ()=>IoCodeSharp);
parcelHelpers.export(exports, "IoCodeSlashOutline", ()=>IoCodeSlashOutline);
parcelHelpers.export(exports, "IoCodeSlashSharp", ()=>IoCodeSlashSharp);
parcelHelpers.export(exports, "IoCodeSlash", ()=>IoCodeSlash);
parcelHelpers.export(exports, "IoCodeWorkingOutline", ()=>IoCodeWorkingOutline);
parcelHelpers.export(exports, "IoCodeWorkingSharp", ()=>IoCodeWorkingSharp);
parcelHelpers.export(exports, "IoCodeWorking", ()=>IoCodeWorking);
parcelHelpers.export(exports, "IoCode", ()=>IoCode);
parcelHelpers.export(exports, "IoCogOutline", ()=>IoCogOutline);
parcelHelpers.export(exports, "IoCogSharp", ()=>IoCogSharp);
parcelHelpers.export(exports, "IoCog", ()=>IoCog);
parcelHelpers.export(exports, "IoColorFillOutline", ()=>IoColorFillOutline);
parcelHelpers.export(exports, "IoColorFillSharp", ()=>IoColorFillSharp);
parcelHelpers.export(exports, "IoColorFill", ()=>IoColorFill);
parcelHelpers.export(exports, "IoColorFilterOutline", ()=>IoColorFilterOutline);
parcelHelpers.export(exports, "IoColorFilterSharp", ()=>IoColorFilterSharp);
parcelHelpers.export(exports, "IoColorFilter", ()=>IoColorFilter);
parcelHelpers.export(exports, "IoColorPaletteOutline", ()=>IoColorPaletteOutline);
parcelHelpers.export(exports, "IoColorPaletteSharp", ()=>IoColorPaletteSharp);
parcelHelpers.export(exports, "IoColorPalette", ()=>IoColorPalette);
parcelHelpers.export(exports, "IoColorWandOutline", ()=>IoColorWandOutline);
parcelHelpers.export(exports, "IoColorWandSharp", ()=>IoColorWandSharp);
parcelHelpers.export(exports, "IoColorWand", ()=>IoColorWand);
parcelHelpers.export(exports, "IoCompassOutline", ()=>IoCompassOutline);
parcelHelpers.export(exports, "IoCompassSharp", ()=>IoCompassSharp);
parcelHelpers.export(exports, "IoCompass", ()=>IoCompass);
parcelHelpers.export(exports, "IoConstructOutline", ()=>IoConstructOutline);
parcelHelpers.export(exports, "IoConstructSharp", ()=>IoConstructSharp);
parcelHelpers.export(exports, "IoConstruct", ()=>IoConstruct);
parcelHelpers.export(exports, "IoContractOutline", ()=>IoContractOutline);
parcelHelpers.export(exports, "IoContractSharp", ()=>IoContractSharp);
parcelHelpers.export(exports, "IoContract", ()=>IoContract);
parcelHelpers.export(exports, "IoContrastOutline", ()=>IoContrastOutline);
parcelHelpers.export(exports, "IoContrastSharp", ()=>IoContrastSharp);
parcelHelpers.export(exports, "IoContrast", ()=>IoContrast);
parcelHelpers.export(exports, "IoCopyOutline", ()=>IoCopyOutline);
parcelHelpers.export(exports, "IoCopySharp", ()=>IoCopySharp);
parcelHelpers.export(exports, "IoCopy", ()=>IoCopy);
parcelHelpers.export(exports, "IoCreateOutline", ()=>IoCreateOutline);
parcelHelpers.export(exports, "IoCreateSharp", ()=>IoCreateSharp);
parcelHelpers.export(exports, "IoCreate", ()=>IoCreate);
parcelHelpers.export(exports, "IoCropOutline", ()=>IoCropOutline);
parcelHelpers.export(exports, "IoCropSharp", ()=>IoCropSharp);
parcelHelpers.export(exports, "IoCrop", ()=>IoCrop);
parcelHelpers.export(exports, "IoCubeOutline", ()=>IoCubeOutline);
parcelHelpers.export(exports, "IoCubeSharp", ()=>IoCubeSharp);
parcelHelpers.export(exports, "IoCube", ()=>IoCube);
parcelHelpers.export(exports, "IoCutOutline", ()=>IoCutOutline);
parcelHelpers.export(exports, "IoCutSharp", ()=>IoCutSharp);
parcelHelpers.export(exports, "IoCut", ()=>IoCut);
parcelHelpers.export(exports, "IoDesktopOutline", ()=>IoDesktopOutline);
parcelHelpers.export(exports, "IoDesktopSharp", ()=>IoDesktopSharp);
parcelHelpers.export(exports, "IoDesktop", ()=>IoDesktop);
parcelHelpers.export(exports, "IoDiamondOutline", ()=>IoDiamondOutline);
parcelHelpers.export(exports, "IoDiamondSharp", ()=>IoDiamondSharp);
parcelHelpers.export(exports, "IoDiamond", ()=>IoDiamond);
parcelHelpers.export(exports, "IoDiceOutline", ()=>IoDiceOutline);
parcelHelpers.export(exports, "IoDiceSharp", ()=>IoDiceSharp);
parcelHelpers.export(exports, "IoDice", ()=>IoDice);
parcelHelpers.export(exports, "IoDiscOutline", ()=>IoDiscOutline);
parcelHelpers.export(exports, "IoDiscSharp", ()=>IoDiscSharp);
parcelHelpers.export(exports, "IoDisc", ()=>IoDisc);
parcelHelpers.export(exports, "IoDocumentAttachOutline", ()=>IoDocumentAttachOutline);
parcelHelpers.export(exports, "IoDocumentAttachSharp", ()=>IoDocumentAttachSharp);
parcelHelpers.export(exports, "IoDocumentAttach", ()=>IoDocumentAttach);
parcelHelpers.export(exports, "IoDocumentLockOutline", ()=>IoDocumentLockOutline);
parcelHelpers.export(exports, "IoDocumentLockSharp", ()=>IoDocumentLockSharp);
parcelHelpers.export(exports, "IoDocumentLock", ()=>IoDocumentLock);
parcelHelpers.export(exports, "IoDocumentOutline", ()=>IoDocumentOutline);
parcelHelpers.export(exports, "IoDocumentSharp", ()=>IoDocumentSharp);
parcelHelpers.export(exports, "IoDocumentTextOutline", ()=>IoDocumentTextOutline);
parcelHelpers.export(exports, "IoDocumentTextSharp", ()=>IoDocumentTextSharp);
parcelHelpers.export(exports, "IoDocumentText", ()=>IoDocumentText);
parcelHelpers.export(exports, "IoDocument", ()=>IoDocument);
parcelHelpers.export(exports, "IoDocumentsOutline", ()=>IoDocumentsOutline);
parcelHelpers.export(exports, "IoDocumentsSharp", ()=>IoDocumentsSharp);
parcelHelpers.export(exports, "IoDocuments", ()=>IoDocuments);
parcelHelpers.export(exports, "IoDownloadOutline", ()=>IoDownloadOutline);
parcelHelpers.export(exports, "IoDownloadSharp", ()=>IoDownloadSharp);
parcelHelpers.export(exports, "IoDownload", ()=>IoDownload);
parcelHelpers.export(exports, "IoDuplicateOutline", ()=>IoDuplicateOutline);
parcelHelpers.export(exports, "IoDuplicateSharp", ()=>IoDuplicateSharp);
parcelHelpers.export(exports, "IoDuplicate", ()=>IoDuplicate);
parcelHelpers.export(exports, "IoEarOutline", ()=>IoEarOutline);
parcelHelpers.export(exports, "IoEarSharp", ()=>IoEarSharp);
parcelHelpers.export(exports, "IoEar", ()=>IoEar);
parcelHelpers.export(exports, "IoEarthOutline", ()=>IoEarthOutline);
parcelHelpers.export(exports, "IoEarthSharp", ()=>IoEarthSharp);
parcelHelpers.export(exports, "IoEarth", ()=>IoEarth);
parcelHelpers.export(exports, "IoEaselOutline", ()=>IoEaselOutline);
parcelHelpers.export(exports, "IoEaselSharp", ()=>IoEaselSharp);
parcelHelpers.export(exports, "IoEasel", ()=>IoEasel);
parcelHelpers.export(exports, "IoEggOutline", ()=>IoEggOutline);
parcelHelpers.export(exports, "IoEggSharp", ()=>IoEggSharp);
parcelHelpers.export(exports, "IoEgg", ()=>IoEgg);
parcelHelpers.export(exports, "IoEllipseOutline", ()=>IoEllipseOutline);
parcelHelpers.export(exports, "IoEllipseSharp", ()=>IoEllipseSharp);
parcelHelpers.export(exports, "IoEllipse", ()=>IoEllipse);
parcelHelpers.export(exports, "IoEllipsisHorizontalCircleOutline", ()=>IoEllipsisHorizontalCircleOutline);
parcelHelpers.export(exports, "IoEllipsisHorizontalCircleSharp", ()=>IoEllipsisHorizontalCircleSharp);
parcelHelpers.export(exports, "IoEllipsisHorizontalCircle", ()=>IoEllipsisHorizontalCircle);
parcelHelpers.export(exports, "IoEllipsisHorizontalOutline", ()=>IoEllipsisHorizontalOutline);
parcelHelpers.export(exports, "IoEllipsisHorizontalSharp", ()=>IoEllipsisHorizontalSharp);
parcelHelpers.export(exports, "IoEllipsisHorizontal", ()=>IoEllipsisHorizontal);
parcelHelpers.export(exports, "IoEllipsisVerticalCircleOutline", ()=>IoEllipsisVerticalCircleOutline);
parcelHelpers.export(exports, "IoEllipsisVerticalCircleSharp", ()=>IoEllipsisVerticalCircleSharp);
parcelHelpers.export(exports, "IoEllipsisVerticalCircle", ()=>IoEllipsisVerticalCircle);
parcelHelpers.export(exports, "IoEllipsisVerticalOutline", ()=>IoEllipsisVerticalOutline);
parcelHelpers.export(exports, "IoEllipsisVerticalSharp", ()=>IoEllipsisVerticalSharp);
parcelHelpers.export(exports, "IoEllipsisVertical", ()=>IoEllipsisVertical);
parcelHelpers.export(exports, "IoEnterOutline", ()=>IoEnterOutline);
parcelHelpers.export(exports, "IoEnterSharp", ()=>IoEnterSharp);
parcelHelpers.export(exports, "IoEnter", ()=>IoEnter);
parcelHelpers.export(exports, "IoExitOutline", ()=>IoExitOutline);
parcelHelpers.export(exports, "IoExitSharp", ()=>IoExitSharp);
parcelHelpers.export(exports, "IoExit", ()=>IoExit);
parcelHelpers.export(exports, "IoExpandOutline", ()=>IoExpandOutline);
parcelHelpers.export(exports, "IoExpandSharp", ()=>IoExpandSharp);
parcelHelpers.export(exports, "IoExpand", ()=>IoExpand);
parcelHelpers.export(exports, "IoExtensionPuzzleOutline", ()=>IoExtensionPuzzleOutline);
parcelHelpers.export(exports, "IoExtensionPuzzleSharp", ()=>IoExtensionPuzzleSharp);
parcelHelpers.export(exports, "IoExtensionPuzzle", ()=>IoExtensionPuzzle);
parcelHelpers.export(exports, "IoEyeOffOutline", ()=>IoEyeOffOutline);
parcelHelpers.export(exports, "IoEyeOffSharp", ()=>IoEyeOffSharp);
parcelHelpers.export(exports, "IoEyeOff", ()=>IoEyeOff);
parcelHelpers.export(exports, "IoEyeOutline", ()=>IoEyeOutline);
parcelHelpers.export(exports, "IoEyeSharp", ()=>IoEyeSharp);
parcelHelpers.export(exports, "IoEye", ()=>IoEye);
parcelHelpers.export(exports, "IoEyedropOutline", ()=>IoEyedropOutline);
parcelHelpers.export(exports, "IoEyedropSharp", ()=>IoEyedropSharp);
parcelHelpers.export(exports, "IoEyedrop", ()=>IoEyedrop);
parcelHelpers.export(exports, "IoFastFoodOutline", ()=>IoFastFoodOutline);
parcelHelpers.export(exports, "IoFastFoodSharp", ()=>IoFastFoodSharp);
parcelHelpers.export(exports, "IoFastFood", ()=>IoFastFood);
parcelHelpers.export(exports, "IoFemaleOutline", ()=>IoFemaleOutline);
parcelHelpers.export(exports, "IoFemaleSharp", ()=>IoFemaleSharp);
parcelHelpers.export(exports, "IoFemale", ()=>IoFemale);
parcelHelpers.export(exports, "IoFileTrayFullOutline", ()=>IoFileTrayFullOutline);
parcelHelpers.export(exports, "IoFileTrayFullSharp", ()=>IoFileTrayFullSharp);
parcelHelpers.export(exports, "IoFileTrayFull", ()=>IoFileTrayFull);
parcelHelpers.export(exports, "IoFileTrayOutline", ()=>IoFileTrayOutline);
parcelHelpers.export(exports, "IoFileTraySharp", ()=>IoFileTraySharp);
parcelHelpers.export(exports, "IoFileTrayStackedOutline", ()=>IoFileTrayStackedOutline);
parcelHelpers.export(exports, "IoFileTrayStackedSharp", ()=>IoFileTrayStackedSharp);
parcelHelpers.export(exports, "IoFileTrayStacked", ()=>IoFileTrayStacked);
parcelHelpers.export(exports, "IoFileTray", ()=>IoFileTray);
parcelHelpers.export(exports, "IoFilmOutline", ()=>IoFilmOutline);
parcelHelpers.export(exports, "IoFilmSharp", ()=>IoFilmSharp);
parcelHelpers.export(exports, "IoFilm", ()=>IoFilm);
parcelHelpers.export(exports, "IoFilterCircleOutline", ()=>IoFilterCircleOutline);
parcelHelpers.export(exports, "IoFilterCircleSharp", ()=>IoFilterCircleSharp);
parcelHelpers.export(exports, "IoFilterCircle", ()=>IoFilterCircle);
parcelHelpers.export(exports, "IoFilterOutline", ()=>IoFilterOutline);
parcelHelpers.export(exports, "IoFilterSharp", ()=>IoFilterSharp);
parcelHelpers.export(exports, "IoFilter", ()=>IoFilter);
parcelHelpers.export(exports, "IoFingerPrintOutline", ()=>IoFingerPrintOutline);
parcelHelpers.export(exports, "IoFingerPrintSharp", ()=>IoFingerPrintSharp);
parcelHelpers.export(exports, "IoFingerPrint", ()=>IoFingerPrint);
parcelHelpers.export(exports, "IoFishOutline", ()=>IoFishOutline);
parcelHelpers.export(exports, "IoFishSharp", ()=>IoFishSharp);
parcelHelpers.export(exports, "IoFish", ()=>IoFish);
parcelHelpers.export(exports, "IoFitnessOutline", ()=>IoFitnessOutline);
parcelHelpers.export(exports, "IoFitnessSharp", ()=>IoFitnessSharp);
parcelHelpers.export(exports, "IoFitness", ()=>IoFitness);
parcelHelpers.export(exports, "IoFlagOutline", ()=>IoFlagOutline);
parcelHelpers.export(exports, "IoFlagSharp", ()=>IoFlagSharp);
parcelHelpers.export(exports, "IoFlag", ()=>IoFlag);
parcelHelpers.export(exports, "IoFlameOutline", ()=>IoFlameOutline);
parcelHelpers.export(exports, "IoFlameSharp", ()=>IoFlameSharp);
parcelHelpers.export(exports, "IoFlame", ()=>IoFlame);
parcelHelpers.export(exports, "IoFlashOffOutline", ()=>IoFlashOffOutline);
parcelHelpers.export(exports, "IoFlashOffSharp", ()=>IoFlashOffSharp);
parcelHelpers.export(exports, "IoFlashOff", ()=>IoFlashOff);
parcelHelpers.export(exports, "IoFlashOutline", ()=>IoFlashOutline);
parcelHelpers.export(exports, "IoFlashSharp", ()=>IoFlashSharp);
parcelHelpers.export(exports, "IoFlash", ()=>IoFlash);
parcelHelpers.export(exports, "IoFlashlightOutline", ()=>IoFlashlightOutline);
parcelHelpers.export(exports, "IoFlashlightSharp", ()=>IoFlashlightSharp);
parcelHelpers.export(exports, "IoFlashlight", ()=>IoFlashlight);
parcelHelpers.export(exports, "IoFlaskOutline", ()=>IoFlaskOutline);
parcelHelpers.export(exports, "IoFlaskSharp", ()=>IoFlaskSharp);
parcelHelpers.export(exports, "IoFlask", ()=>IoFlask);
parcelHelpers.export(exports, "IoFlowerOutline", ()=>IoFlowerOutline);
parcelHelpers.export(exports, "IoFlowerSharp", ()=>IoFlowerSharp);
parcelHelpers.export(exports, "IoFlower", ()=>IoFlower);
parcelHelpers.export(exports, "IoFolderOpenOutline", ()=>IoFolderOpenOutline);
parcelHelpers.export(exports, "IoFolderOpenSharp", ()=>IoFolderOpenSharp);
parcelHelpers.export(exports, "IoFolderOpen", ()=>IoFolderOpen);
parcelHelpers.export(exports, "IoFolderOutline", ()=>IoFolderOutline);
parcelHelpers.export(exports, "IoFolderSharp", ()=>IoFolderSharp);
parcelHelpers.export(exports, "IoFolder", ()=>IoFolder);
parcelHelpers.export(exports, "IoFootballOutline", ()=>IoFootballOutline);
parcelHelpers.export(exports, "IoFootballSharp", ()=>IoFootballSharp);
parcelHelpers.export(exports, "IoFootball", ()=>IoFootball);
parcelHelpers.export(exports, "IoFootstepsOutline", ()=>IoFootstepsOutline);
parcelHelpers.export(exports, "IoFootstepsSharp", ()=>IoFootstepsSharp);
parcelHelpers.export(exports, "IoFootsteps", ()=>IoFootsteps);
parcelHelpers.export(exports, "IoFunnelOutline", ()=>IoFunnelOutline);
parcelHelpers.export(exports, "IoFunnelSharp", ()=>IoFunnelSharp);
parcelHelpers.export(exports, "IoFunnel", ()=>IoFunnel);
parcelHelpers.export(exports, "IoGameControllerOutline", ()=>IoGameControllerOutline);
parcelHelpers.export(exports, "IoGameControllerSharp", ()=>IoGameControllerSharp);
parcelHelpers.export(exports, "IoGameController", ()=>IoGameController);
parcelHelpers.export(exports, "IoGiftOutline", ()=>IoGiftOutline);
parcelHelpers.export(exports, "IoGiftSharp", ()=>IoGiftSharp);
parcelHelpers.export(exports, "IoGift", ()=>IoGift);
parcelHelpers.export(exports, "IoGitBranchOutline", ()=>IoGitBranchOutline);
parcelHelpers.export(exports, "IoGitBranchSharp", ()=>IoGitBranchSharp);
parcelHelpers.export(exports, "IoGitBranch", ()=>IoGitBranch);
parcelHelpers.export(exports, "IoGitCommitOutline", ()=>IoGitCommitOutline);
parcelHelpers.export(exports, "IoGitCommitSharp", ()=>IoGitCommitSharp);
parcelHelpers.export(exports, "IoGitCommit", ()=>IoGitCommit);
parcelHelpers.export(exports, "IoGitCompareOutline", ()=>IoGitCompareOutline);
parcelHelpers.export(exports, "IoGitCompareSharp", ()=>IoGitCompareSharp);
parcelHelpers.export(exports, "IoGitCompare", ()=>IoGitCompare);
parcelHelpers.export(exports, "IoGitMergeOutline", ()=>IoGitMergeOutline);
parcelHelpers.export(exports, "IoGitMergeSharp", ()=>IoGitMergeSharp);
parcelHelpers.export(exports, "IoGitMerge", ()=>IoGitMerge);
parcelHelpers.export(exports, "IoGitNetworkOutline", ()=>IoGitNetworkOutline);
parcelHelpers.export(exports, "IoGitNetworkSharp", ()=>IoGitNetworkSharp);
parcelHelpers.export(exports, "IoGitNetwork", ()=>IoGitNetwork);
parcelHelpers.export(exports, "IoGitPullRequestOutline", ()=>IoGitPullRequestOutline);
parcelHelpers.export(exports, "IoGitPullRequestSharp", ()=>IoGitPullRequestSharp);
parcelHelpers.export(exports, "IoGitPullRequest", ()=>IoGitPullRequest);
parcelHelpers.export(exports, "IoGlassesOutline", ()=>IoGlassesOutline);
parcelHelpers.export(exports, "IoGlassesSharp", ()=>IoGlassesSharp);
parcelHelpers.export(exports, "IoGlasses", ()=>IoGlasses);
parcelHelpers.export(exports, "IoGlobeOutline", ()=>IoGlobeOutline);
parcelHelpers.export(exports, "IoGlobeSharp", ()=>IoGlobeSharp);
parcelHelpers.export(exports, "IoGlobe", ()=>IoGlobe);
parcelHelpers.export(exports, "IoGolfOutline", ()=>IoGolfOutline);
parcelHelpers.export(exports, "IoGolfSharp", ()=>IoGolfSharp);
parcelHelpers.export(exports, "IoGolf", ()=>IoGolf);
parcelHelpers.export(exports, "IoGridOutline", ()=>IoGridOutline);
parcelHelpers.export(exports, "IoGridSharp", ()=>IoGridSharp);
parcelHelpers.export(exports, "IoGrid", ()=>IoGrid);
parcelHelpers.export(exports, "IoHammerOutline", ()=>IoHammerOutline);
parcelHelpers.export(exports, "IoHammerSharp", ()=>IoHammerSharp);
parcelHelpers.export(exports, "IoHammer", ()=>IoHammer);
parcelHelpers.export(exports, "IoHandLeftOutline", ()=>IoHandLeftOutline);
parcelHelpers.export(exports, "IoHandLeftSharp", ()=>IoHandLeftSharp);
parcelHelpers.export(exports, "IoHandLeft", ()=>IoHandLeft);
parcelHelpers.export(exports, "IoHandRightOutline", ()=>IoHandRightOutline);
parcelHelpers.export(exports, "IoHandRightSharp", ()=>IoHandRightSharp);
parcelHelpers.export(exports, "IoHandRight", ()=>IoHandRight);
parcelHelpers.export(exports, "IoHappyOutline", ()=>IoHappyOutline);
parcelHelpers.export(exports, "IoHappySharp", ()=>IoHappySharp);
parcelHelpers.export(exports, "IoHappy", ()=>IoHappy);
parcelHelpers.export(exports, "IoHardwareChipOutline", ()=>IoHardwareChipOutline);
parcelHelpers.export(exports, "IoHardwareChipSharp", ()=>IoHardwareChipSharp);
parcelHelpers.export(exports, "IoHardwareChip", ()=>IoHardwareChip);
parcelHelpers.export(exports, "IoHeadsetOutline", ()=>IoHeadsetOutline);
parcelHelpers.export(exports, "IoHeadsetSharp", ()=>IoHeadsetSharp);
parcelHelpers.export(exports, "IoHeadset", ()=>IoHeadset);
parcelHelpers.export(exports, "IoHeartCircleOutline", ()=>IoHeartCircleOutline);
parcelHelpers.export(exports, "IoHeartCircleSharp", ()=>IoHeartCircleSharp);
parcelHelpers.export(exports, "IoHeartCircle", ()=>IoHeartCircle);
parcelHelpers.export(exports, "IoHeartDislikeCircleOutline", ()=>IoHeartDislikeCircleOutline);
parcelHelpers.export(exports, "IoHeartDislikeCircleSharp", ()=>IoHeartDislikeCircleSharp);
parcelHelpers.export(exports, "IoHeartDislikeCircle", ()=>IoHeartDislikeCircle);
parcelHelpers.export(exports, "IoHeartDislikeOutline", ()=>IoHeartDislikeOutline);
parcelHelpers.export(exports, "IoHeartDislikeSharp", ()=>IoHeartDislikeSharp);
parcelHelpers.export(exports, "IoHeartDislike", ()=>IoHeartDislike);
parcelHelpers.export(exports, "IoHeartHalfOutline", ()=>IoHeartHalfOutline);
parcelHelpers.export(exports, "IoHeartHalfSharp", ()=>IoHeartHalfSharp);
parcelHelpers.export(exports, "IoHeartHalf", ()=>IoHeartHalf);
parcelHelpers.export(exports, "IoHeartOutline", ()=>IoHeartOutline);
parcelHelpers.export(exports, "IoHeartSharp", ()=>IoHeartSharp);
parcelHelpers.export(exports, "IoHeart", ()=>IoHeart);
parcelHelpers.export(exports, "IoHelpBuoyOutline", ()=>IoHelpBuoyOutline);
parcelHelpers.export(exports, "IoHelpBuoySharp", ()=>IoHelpBuoySharp);
parcelHelpers.export(exports, "IoHelpBuoy", ()=>IoHelpBuoy);
parcelHelpers.export(exports, "IoHelpCircleOutline", ()=>IoHelpCircleOutline);
parcelHelpers.export(exports, "IoHelpCircleSharp", ()=>IoHelpCircleSharp);
parcelHelpers.export(exports, "IoHelpCircle", ()=>IoHelpCircle);
parcelHelpers.export(exports, "IoHelpOutline", ()=>IoHelpOutline);
parcelHelpers.export(exports, "IoHelpSharp", ()=>IoHelpSharp);
parcelHelpers.export(exports, "IoHelp", ()=>IoHelp);
parcelHelpers.export(exports, "IoHomeOutline", ()=>IoHomeOutline);
parcelHelpers.export(exports, "IoHomeSharp", ()=>IoHomeSharp);
parcelHelpers.export(exports, "IoHome", ()=>IoHome);
parcelHelpers.export(exports, "IoHourglassOutline", ()=>IoHourglassOutline);
parcelHelpers.export(exports, "IoHourglassSharp", ()=>IoHourglassSharp);
parcelHelpers.export(exports, "IoHourglass", ()=>IoHourglass);
parcelHelpers.export(exports, "IoIceCreamOutline", ()=>IoIceCreamOutline);
parcelHelpers.export(exports, "IoIceCreamSharp", ()=>IoIceCreamSharp);
parcelHelpers.export(exports, "IoIceCream", ()=>IoIceCream);
parcelHelpers.export(exports, "IoIdCardOutline", ()=>IoIdCardOutline);
parcelHelpers.export(exports, "IoIdCardSharp", ()=>IoIdCardSharp);
parcelHelpers.export(exports, "IoIdCard", ()=>IoIdCard);
parcelHelpers.export(exports, "IoImageOutline", ()=>IoImageOutline);
parcelHelpers.export(exports, "IoImageSharp", ()=>IoImageSharp);
parcelHelpers.export(exports, "IoImage", ()=>IoImage);
parcelHelpers.export(exports, "IoImagesOutline", ()=>IoImagesOutline);
parcelHelpers.export(exports, "IoImagesSharp", ()=>IoImagesSharp);
parcelHelpers.export(exports, "IoImages", ()=>IoImages);
parcelHelpers.export(exports, "IoInfiniteOutline", ()=>IoInfiniteOutline);
parcelHelpers.export(exports, "IoInfiniteSharp", ()=>IoInfiniteSharp);
parcelHelpers.export(exports, "IoInfinite", ()=>IoInfinite);
parcelHelpers.export(exports, "IoInformationCircleOutline", ()=>IoInformationCircleOutline);
parcelHelpers.export(exports, "IoInformationCircleSharp", ()=>IoInformationCircleSharp);
parcelHelpers.export(exports, "IoInformationCircle", ()=>IoInformationCircle);
parcelHelpers.export(exports, "IoInformationOutline", ()=>IoInformationOutline);
parcelHelpers.export(exports, "IoInformationSharp", ()=>IoInformationSharp);
parcelHelpers.export(exports, "IoInformation", ()=>IoInformation);
parcelHelpers.export(exports, "IoInvertModeOutline", ()=>IoInvertModeOutline);
parcelHelpers.export(exports, "IoInvertModeSharp", ()=>IoInvertModeSharp);
parcelHelpers.export(exports, "IoInvertMode", ()=>IoInvertMode);
parcelHelpers.export(exports, "IoJournalOutline", ()=>IoJournalOutline);
parcelHelpers.export(exports, "IoJournalSharp", ()=>IoJournalSharp);
parcelHelpers.export(exports, "IoJournal", ()=>IoJournal);
parcelHelpers.export(exports, "IoKeyOutline", ()=>IoKeyOutline);
parcelHelpers.export(exports, "IoKeySharp", ()=>IoKeySharp);
parcelHelpers.export(exports, "IoKey", ()=>IoKey);
parcelHelpers.export(exports, "IoKeypadOutline", ()=>IoKeypadOutline);
parcelHelpers.export(exports, "IoKeypadSharp", ()=>IoKeypadSharp);
parcelHelpers.export(exports, "IoKeypad", ()=>IoKeypad);
parcelHelpers.export(exports, "IoLanguageOutline", ()=>IoLanguageOutline);
parcelHelpers.export(exports, "IoLanguageSharp", ()=>IoLanguageSharp);
parcelHelpers.export(exports, "IoLanguage", ()=>IoLanguage);
parcelHelpers.export(exports, "IoLaptopOutline", ()=>IoLaptopOutline);
parcelHelpers.export(exports, "IoLaptopSharp", ()=>IoLaptopSharp);
parcelHelpers.export(exports, "IoLaptop", ()=>IoLaptop);
parcelHelpers.export(exports, "IoLayersOutline", ()=>IoLayersOutline);
parcelHelpers.export(exports, "IoLayersSharp", ()=>IoLayersSharp);
parcelHelpers.export(exports, "IoLayers", ()=>IoLayers);
parcelHelpers.export(exports, "IoLeafOutline", ()=>IoLeafOutline);
parcelHelpers.export(exports, "IoLeafSharp", ()=>IoLeafSharp);
parcelHelpers.export(exports, "IoLeaf", ()=>IoLeaf);
parcelHelpers.export(exports, "IoLibraryOutline", ()=>IoLibraryOutline);
parcelHelpers.export(exports, "IoLibrarySharp", ()=>IoLibrarySharp);
parcelHelpers.export(exports, "IoLibrary", ()=>IoLibrary);
parcelHelpers.export(exports, "IoLinkOutline", ()=>IoLinkOutline);
parcelHelpers.export(exports, "IoLinkSharp", ()=>IoLinkSharp);
parcelHelpers.export(exports, "IoLink", ()=>IoLink);
parcelHelpers.export(exports, "IoListCircleOutline", ()=>IoListCircleOutline);
parcelHelpers.export(exports, "IoListCircleSharp", ()=>IoListCircleSharp);
parcelHelpers.export(exports, "IoListCircle", ()=>IoListCircle);
parcelHelpers.export(exports, "IoListOutline", ()=>IoListOutline);
parcelHelpers.export(exports, "IoListSharp", ()=>IoListSharp);
parcelHelpers.export(exports, "IoList", ()=>IoList);
parcelHelpers.export(exports, "IoLocateOutline", ()=>IoLocateOutline);
parcelHelpers.export(exports, "IoLocateSharp", ()=>IoLocateSharp);
parcelHelpers.export(exports, "IoLocate", ()=>IoLocate);
parcelHelpers.export(exports, "IoLocationOutline", ()=>IoLocationOutline);
parcelHelpers.export(exports, "IoLocationSharp", ()=>IoLocationSharp);
parcelHelpers.export(exports, "IoLocation", ()=>IoLocation);
parcelHelpers.export(exports, "IoLockClosedOutline", ()=>IoLockClosedOutline);
parcelHelpers.export(exports, "IoLockClosedSharp", ()=>IoLockClosedSharp);
parcelHelpers.export(exports, "IoLockClosed", ()=>IoLockClosed);
parcelHelpers.export(exports, "IoLockOpenOutline", ()=>IoLockOpenOutline);
parcelHelpers.export(exports, "IoLockOpenSharp", ()=>IoLockOpenSharp);
parcelHelpers.export(exports, "IoLockOpen", ()=>IoLockOpen);
parcelHelpers.export(exports, "IoLogInOutline", ()=>IoLogInOutline);
parcelHelpers.export(exports, "IoLogInSharp", ()=>IoLogInSharp);
parcelHelpers.export(exports, "IoLogIn", ()=>IoLogIn);
parcelHelpers.export(exports, "IoLogOutOutline", ()=>IoLogOutOutline);
parcelHelpers.export(exports, "IoLogOutSharp", ()=>IoLogOutSharp);
parcelHelpers.export(exports, "IoLogOut", ()=>IoLogOut);
parcelHelpers.export(exports, "IoLogoAlipay", ()=>IoLogoAlipay);
parcelHelpers.export(exports, "IoLogoAmazon", ()=>IoLogoAmazon);
parcelHelpers.export(exports, "IoLogoAmplify", ()=>IoLogoAmplify);
parcelHelpers.export(exports, "IoLogoAndroid", ()=>IoLogoAndroid);
parcelHelpers.export(exports, "IoLogoAngular", ()=>IoLogoAngular);
parcelHelpers.export(exports, "IoLogoAppleAppstore", ()=>IoLogoAppleAppstore);
parcelHelpers.export(exports, "IoLogoAppleAr", ()=>IoLogoAppleAr);
parcelHelpers.export(exports, "IoLogoApple", ()=>IoLogoApple);
parcelHelpers.export(exports, "IoLogoBehance", ()=>IoLogoBehance);
parcelHelpers.export(exports, "IoLogoBitbucket", ()=>IoLogoBitbucket);
parcelHelpers.export(exports, "IoLogoBitcoin", ()=>IoLogoBitcoin);
parcelHelpers.export(exports, "IoLogoBuffer", ()=>IoLogoBuffer);
parcelHelpers.export(exports, "IoLogoCapacitor", ()=>IoLogoCapacitor);
parcelHelpers.export(exports, "IoLogoChrome", ()=>IoLogoChrome);
parcelHelpers.export(exports, "IoLogoClosedCaptioning", ()=>IoLogoClosedCaptioning);
parcelHelpers.export(exports, "IoLogoCodepen", ()=>IoLogoCodepen);
parcelHelpers.export(exports, "IoLogoCss3", ()=>IoLogoCss3);
parcelHelpers.export(exports, "IoLogoDesignernews", ()=>IoLogoDesignernews);
parcelHelpers.export(exports, "IoLogoDeviantart", ()=>IoLogoDeviantart);
parcelHelpers.export(exports, "IoLogoDiscord", ()=>IoLogoDiscord);
parcelHelpers.export(exports, "IoLogoDocker", ()=>IoLogoDocker);
parcelHelpers.export(exports, "IoLogoDribbble", ()=>IoLogoDribbble);
parcelHelpers.export(exports, "IoLogoDropbox", ()=>IoLogoDropbox);
parcelHelpers.export(exports, "IoLogoEdge", ()=>IoLogoEdge);
parcelHelpers.export(exports, "IoLogoElectron", ()=>IoLogoElectron);
parcelHelpers.export(exports, "IoLogoEuro", ()=>IoLogoEuro);
parcelHelpers.export(exports, "IoLogoFacebook", ()=>IoLogoFacebook);
parcelHelpers.export(exports, "IoLogoFigma", ()=>IoLogoFigma);
parcelHelpers.export(exports, "IoLogoFirebase", ()=>IoLogoFirebase);
parcelHelpers.export(exports, "IoLogoFirefox", ()=>IoLogoFirefox);
parcelHelpers.export(exports, "IoLogoFlickr", ()=>IoLogoFlickr);
parcelHelpers.export(exports, "IoLogoFoursquare", ()=>IoLogoFoursquare);
parcelHelpers.export(exports, "IoLogoGithub", ()=>IoLogoGithub);
parcelHelpers.export(exports, "IoLogoGitlab", ()=>IoLogoGitlab);
parcelHelpers.export(exports, "IoLogoGooglePlaystore", ()=>IoLogoGooglePlaystore);
parcelHelpers.export(exports, "IoLogoGoogle", ()=>IoLogoGoogle);
parcelHelpers.export(exports, "IoLogoHackernews", ()=>IoLogoHackernews);
parcelHelpers.export(exports, "IoLogoHtml5", ()=>IoLogoHtml5);
parcelHelpers.export(exports, "IoLogoInstagram", ()=>IoLogoInstagram);
parcelHelpers.export(exports, "IoLogoIonic", ()=>IoLogoIonic);
parcelHelpers.export(exports, "IoLogoIonitron", ()=>IoLogoIonitron);
parcelHelpers.export(exports, "IoLogoJavascript", ()=>IoLogoJavascript);
parcelHelpers.export(exports, "IoLogoLaravel", ()=>IoLogoLaravel);
parcelHelpers.export(exports, "IoLogoLinkedin", ()=>IoLogoLinkedin);
parcelHelpers.export(exports, "IoLogoMarkdown", ()=>IoLogoMarkdown);
parcelHelpers.export(exports, "IoLogoMastodon", ()=>IoLogoMastodon);
parcelHelpers.export(exports, "IoLogoMedium", ()=>IoLogoMedium);
parcelHelpers.export(exports, "IoLogoMicrosoft", ()=>IoLogoMicrosoft);
parcelHelpers.export(exports, "IoLogoNoSmoking", ()=>IoLogoNoSmoking);
parcelHelpers.export(exports, "IoLogoNodejs", ()=>IoLogoNodejs);
parcelHelpers.export(exports, "IoLogoNpm", ()=>IoLogoNpm);
parcelHelpers.export(exports, "IoLogoOctocat", ()=>IoLogoOctocat);
parcelHelpers.export(exports, "IoLogoPaypal", ()=>IoLogoPaypal);
parcelHelpers.export(exports, "IoLogoPinterest", ()=>IoLogoPinterest);
parcelHelpers.export(exports, "IoLogoPlaystation", ()=>IoLogoPlaystation);
parcelHelpers.export(exports, "IoLogoPwa", ()=>IoLogoPwa);
parcelHelpers.export(exports, "IoLogoPython", ()=>IoLogoPython);
parcelHelpers.export(exports, "IoLogoReact", ()=>IoLogoReact);
parcelHelpers.export(exports, "IoLogoReddit", ()=>IoLogoReddit);
parcelHelpers.export(exports, "IoLogoRss", ()=>IoLogoRss);
parcelHelpers.export(exports, "IoLogoSass", ()=>IoLogoSass);
parcelHelpers.export(exports, "IoLogoSkype", ()=>IoLogoSkype);
parcelHelpers.export(exports, "IoLogoSlack", ()=>IoLogoSlack);
parcelHelpers.export(exports, "IoLogoSnapchat", ()=>IoLogoSnapchat);
parcelHelpers.export(exports, "IoLogoSoundcloud", ()=>IoLogoSoundcloud);
parcelHelpers.export(exports, "IoLogoStackoverflow", ()=>IoLogoStackoverflow);
parcelHelpers.export(exports, "IoLogoSteam", ()=>IoLogoSteam);
parcelHelpers.export(exports, "IoLogoStencil", ()=>IoLogoStencil);
parcelHelpers.export(exports, "IoLogoTableau", ()=>IoLogoTableau);
parcelHelpers.export(exports, "IoLogoTiktok", ()=>IoLogoTiktok);
parcelHelpers.export(exports, "IoLogoTumblr", ()=>IoLogoTumblr);
parcelHelpers.export(exports, "IoLogoTux", ()=>IoLogoTux);
parcelHelpers.export(exports, "IoLogoTwitch", ()=>IoLogoTwitch);
parcelHelpers.export(exports, "IoLogoTwitter", ()=>IoLogoTwitter);
parcelHelpers.export(exports, "IoLogoUsd", ()=>IoLogoUsd);
parcelHelpers.export(exports, "IoLogoVenmo", ()=>IoLogoVenmo);
parcelHelpers.export(exports, "IoLogoVercel", ()=>IoLogoVercel);
parcelHelpers.export(exports, "IoLogoVimeo", ()=>IoLogoVimeo);
parcelHelpers.export(exports, "IoLogoVk", ()=>IoLogoVk);
parcelHelpers.export(exports, "IoLogoVue", ()=>IoLogoVue);
parcelHelpers.export(exports, "IoLogoWebComponent", ()=>IoLogoWebComponent);
parcelHelpers.export(exports, "IoLogoWechat", ()=>IoLogoWechat);
parcelHelpers.export(exports, "IoLogoWhatsapp", ()=>IoLogoWhatsapp);
parcelHelpers.export(exports, "IoLogoWindows", ()=>IoLogoWindows);
parcelHelpers.export(exports, "IoLogoWordpress", ()=>IoLogoWordpress);
parcelHelpers.export(exports, "IoLogoXbox", ()=>IoLogoXbox);
parcelHelpers.export(exports, "IoLogoXing", ()=>IoLogoXing);
parcelHelpers.export(exports, "IoLogoYahoo", ()=>IoLogoYahoo);
parcelHelpers.export(exports, "IoLogoYen", ()=>IoLogoYen);
parcelHelpers.export(exports, "IoLogoYoutube", ()=>IoLogoYoutube);
parcelHelpers.export(exports, "IoMagnetOutline", ()=>IoMagnetOutline);
parcelHelpers.export(exports, "IoMagnetSharp", ()=>IoMagnetSharp);
parcelHelpers.export(exports, "IoMagnet", ()=>IoMagnet);
parcelHelpers.export(exports, "IoMailOpenOutline", ()=>IoMailOpenOutline);
parcelHelpers.export(exports, "IoMailOpenSharp", ()=>IoMailOpenSharp);
parcelHelpers.export(exports, "IoMailOpen", ()=>IoMailOpen);
parcelHelpers.export(exports, "IoMailOutline", ()=>IoMailOutline);
parcelHelpers.export(exports, "IoMailSharp", ()=>IoMailSharp);
parcelHelpers.export(exports, "IoMailUnreadOutline", ()=>IoMailUnreadOutline);
parcelHelpers.export(exports, "IoMailUnreadSharp", ()=>IoMailUnreadSharp);
parcelHelpers.export(exports, "IoMailUnread", ()=>IoMailUnread);
parcelHelpers.export(exports, "IoMail", ()=>IoMail);
parcelHelpers.export(exports, "IoMaleFemaleOutline", ()=>IoMaleFemaleOutline);
parcelHelpers.export(exports, "IoMaleFemaleSharp", ()=>IoMaleFemaleSharp);
parcelHelpers.export(exports, "IoMaleFemale", ()=>IoMaleFemale);
parcelHelpers.export(exports, "IoMaleOutline", ()=>IoMaleOutline);
parcelHelpers.export(exports, "IoMaleSharp", ()=>IoMaleSharp);
parcelHelpers.export(exports, "IoMale", ()=>IoMale);
parcelHelpers.export(exports, "IoManOutline", ()=>IoManOutline);
parcelHelpers.export(exports, "IoManSharp", ()=>IoManSharp);
parcelHelpers.export(exports, "IoMan", ()=>IoMan);
parcelHelpers.export(exports, "IoMapOutline", ()=>IoMapOutline);
parcelHelpers.export(exports, "IoMapSharp", ()=>IoMapSharp);
parcelHelpers.export(exports, "IoMap", ()=>IoMap);
parcelHelpers.export(exports, "IoMedalOutline", ()=>IoMedalOutline);
parcelHelpers.export(exports, "IoMedalSharp", ()=>IoMedalSharp);
parcelHelpers.export(exports, "IoMedal", ()=>IoMedal);
parcelHelpers.export(exports, "IoMedicalOutline", ()=>IoMedicalOutline);
parcelHelpers.export(exports, "IoMedicalSharp", ()=>IoMedicalSharp);
parcelHelpers.export(exports, "IoMedical", ()=>IoMedical);
parcelHelpers.export(exports, "IoMedkitOutline", ()=>IoMedkitOutline);
parcelHelpers.export(exports, "IoMedkitSharp", ()=>IoMedkitSharp);
parcelHelpers.export(exports, "IoMedkit", ()=>IoMedkit);
parcelHelpers.export(exports, "IoMegaphoneOutline", ()=>IoMegaphoneOutline);
parcelHelpers.export(exports, "IoMegaphoneSharp", ()=>IoMegaphoneSharp);
parcelHelpers.export(exports, "IoMegaphone", ()=>IoMegaphone);
parcelHelpers.export(exports, "IoMenuOutline", ()=>IoMenuOutline);
parcelHelpers.export(exports, "IoMenuSharp", ()=>IoMenuSharp);
parcelHelpers.export(exports, "IoMenu", ()=>IoMenu);
parcelHelpers.export(exports, "IoMicCircleOutline", ()=>IoMicCircleOutline);
parcelHelpers.export(exports, "IoMicCircleSharp", ()=>IoMicCircleSharp);
parcelHelpers.export(exports, "IoMicCircle", ()=>IoMicCircle);
parcelHelpers.export(exports, "IoMicOffCircleOutline", ()=>IoMicOffCircleOutline);
parcelHelpers.export(exports, "IoMicOffCircleSharp", ()=>IoMicOffCircleSharp);
parcelHelpers.export(exports, "IoMicOffCircle", ()=>IoMicOffCircle);
parcelHelpers.export(exports, "IoMicOffOutline", ()=>IoMicOffOutline);
parcelHelpers.export(exports, "IoMicOffSharp", ()=>IoMicOffSharp);
parcelHelpers.export(exports, "IoMicOff", ()=>IoMicOff);
parcelHelpers.export(exports, "IoMicOutline", ()=>IoMicOutline);
parcelHelpers.export(exports, "IoMicSharp", ()=>IoMicSharp);
parcelHelpers.export(exports, "IoMic", ()=>IoMic);
parcelHelpers.export(exports, "IoMoonOutline", ()=>IoMoonOutline);
parcelHelpers.export(exports, "IoMoonSharp", ()=>IoMoonSharp);
parcelHelpers.export(exports, "IoMoon", ()=>IoMoon);
parcelHelpers.export(exports, "IoMoveOutline", ()=>IoMoveOutline);
parcelHelpers.export(exports, "IoMoveSharp", ()=>IoMoveSharp);
parcelHelpers.export(exports, "IoMove", ()=>IoMove);
parcelHelpers.export(exports, "IoMusicalNoteOutline", ()=>IoMusicalNoteOutline);
parcelHelpers.export(exports, "IoMusicalNoteSharp", ()=>IoMusicalNoteSharp);
parcelHelpers.export(exports, "IoMusicalNote", ()=>IoMusicalNote);
parcelHelpers.export(exports, "IoMusicalNotesOutline", ()=>IoMusicalNotesOutline);
parcelHelpers.export(exports, "IoMusicalNotesSharp", ()=>IoMusicalNotesSharp);
parcelHelpers.export(exports, "IoMusicalNotes", ()=>IoMusicalNotes);
parcelHelpers.export(exports, "IoNavigateCircleOutline", ()=>IoNavigateCircleOutline);
parcelHelpers.export(exports, "IoNavigateCircleSharp", ()=>IoNavigateCircleSharp);
parcelHelpers.export(exports, "IoNavigateCircle", ()=>IoNavigateCircle);
parcelHelpers.export(exports, "IoNavigateOutline", ()=>IoNavigateOutline);
parcelHelpers.export(exports, "IoNavigateSharp", ()=>IoNavigateSharp);
parcelHelpers.export(exports, "IoNavigate", ()=>IoNavigate);
parcelHelpers.export(exports, "IoNewspaperOutline", ()=>IoNewspaperOutline);
parcelHelpers.export(exports, "IoNewspaperSharp", ()=>IoNewspaperSharp);
parcelHelpers.export(exports, "IoNewspaper", ()=>IoNewspaper);
parcelHelpers.export(exports, "IoNotificationsCircleOutline", ()=>IoNotificationsCircleOutline);
parcelHelpers.export(exports, "IoNotificationsCircleSharp", ()=>IoNotificationsCircleSharp);
parcelHelpers.export(exports, "IoNotificationsCircle", ()=>IoNotificationsCircle);
parcelHelpers.export(exports, "IoNotificationsOffCircleOutline", ()=>IoNotificationsOffCircleOutline);
parcelHelpers.export(exports, "IoNotificationsOffCircleSharp", ()=>IoNotificationsOffCircleSharp);
parcelHelpers.export(exports, "IoNotificationsOffCircle", ()=>IoNotificationsOffCircle);
parcelHelpers.export(exports, "IoNotificationsOffOutline", ()=>IoNotificationsOffOutline);
parcelHelpers.export(exports, "IoNotificationsOffSharp", ()=>IoNotificationsOffSharp);
parcelHelpers.export(exports, "IoNotificationsOff", ()=>IoNotificationsOff);
parcelHelpers.export(exports, "IoNotificationsOutline", ()=>IoNotificationsOutline);
parcelHelpers.export(exports, "IoNotificationsSharp", ()=>IoNotificationsSharp);
parcelHelpers.export(exports, "IoNotifications", ()=>IoNotifications);
parcelHelpers.export(exports, "IoNuclearOutline", ()=>IoNuclearOutline);
parcelHelpers.export(exports, "IoNuclearSharp", ()=>IoNuclearSharp);
parcelHelpers.export(exports, "IoNuclear", ()=>IoNuclear);
parcelHelpers.export(exports, "IoNutritionOutline", ()=>IoNutritionOutline);
parcelHelpers.export(exports, "IoNutritionSharp", ()=>IoNutritionSharp);
parcelHelpers.export(exports, "IoNutrition", ()=>IoNutrition);
parcelHelpers.export(exports, "IoOpenOutline", ()=>IoOpenOutline);
parcelHelpers.export(exports, "IoOpenSharp", ()=>IoOpenSharp);
parcelHelpers.export(exports, "IoOpen", ()=>IoOpen);
parcelHelpers.export(exports, "IoOptionsOutline", ()=>IoOptionsOutline);
parcelHelpers.export(exports, "IoOptionsSharp", ()=>IoOptionsSharp);
parcelHelpers.export(exports, "IoOptions", ()=>IoOptions);
parcelHelpers.export(exports, "IoPaperPlaneOutline", ()=>IoPaperPlaneOutline);
parcelHelpers.export(exports, "IoPaperPlaneSharp", ()=>IoPaperPlaneSharp);
parcelHelpers.export(exports, "IoPaperPlane", ()=>IoPaperPlane);
parcelHelpers.export(exports, "IoPartlySunnyOutline", ()=>IoPartlySunnyOutline);
parcelHelpers.export(exports, "IoPartlySunnySharp", ()=>IoPartlySunnySharp);
parcelHelpers.export(exports, "IoPartlySunny", ()=>IoPartlySunny);
parcelHelpers.export(exports, "IoPauseCircleOutline", ()=>IoPauseCircleOutline);
parcelHelpers.export(exports, "IoPauseCircleSharp", ()=>IoPauseCircleSharp);
parcelHelpers.export(exports, "IoPauseCircle", ()=>IoPauseCircle);
parcelHelpers.export(exports, "IoPauseOutline", ()=>IoPauseOutline);
parcelHelpers.export(exports, "IoPauseSharp", ()=>IoPauseSharp);
parcelHelpers.export(exports, "IoPause", ()=>IoPause);
parcelHelpers.export(exports, "IoPawOutline", ()=>IoPawOutline);
parcelHelpers.export(exports, "IoPawSharp", ()=>IoPawSharp);
parcelHelpers.export(exports, "IoPaw", ()=>IoPaw);
parcelHelpers.export(exports, "IoPencilOutline", ()=>IoPencilOutline);
parcelHelpers.export(exports, "IoPencilSharp", ()=>IoPencilSharp);
parcelHelpers.export(exports, "IoPencil", ()=>IoPencil);
parcelHelpers.export(exports, "IoPeopleCircleOutline", ()=>IoPeopleCircleOutline);
parcelHelpers.export(exports, "IoPeopleCircleSharp", ()=>IoPeopleCircleSharp);
parcelHelpers.export(exports, "IoPeopleCircle", ()=>IoPeopleCircle);
parcelHelpers.export(exports, "IoPeopleOutline", ()=>IoPeopleOutline);
parcelHelpers.export(exports, "IoPeopleSharp", ()=>IoPeopleSharp);
parcelHelpers.export(exports, "IoPeople", ()=>IoPeople);
parcelHelpers.export(exports, "IoPersonAddOutline", ()=>IoPersonAddOutline);
parcelHelpers.export(exports, "IoPersonAddSharp", ()=>IoPersonAddSharp);
parcelHelpers.export(exports, "IoPersonAdd", ()=>IoPersonAdd);
parcelHelpers.export(exports, "IoPersonCircleOutline", ()=>IoPersonCircleOutline);
parcelHelpers.export(exports, "IoPersonCircleSharp", ()=>IoPersonCircleSharp);
parcelHelpers.export(exports, "IoPersonCircle", ()=>IoPersonCircle);
parcelHelpers.export(exports, "IoPersonOutline", ()=>IoPersonOutline);
parcelHelpers.export(exports, "IoPersonRemoveOutline", ()=>IoPersonRemoveOutline);
parcelHelpers.export(exports, "IoPersonRemoveSharp", ()=>IoPersonRemoveSharp);
parcelHelpers.export(exports, "IoPersonRemove", ()=>IoPersonRemove);
parcelHelpers.export(exports, "IoPersonSharp", ()=>IoPersonSharp);
parcelHelpers.export(exports, "IoPerson", ()=>IoPerson);
parcelHelpers.export(exports, "IoPhoneLandscapeOutline", ()=>IoPhoneLandscapeOutline);
parcelHelpers.export(exports, "IoPhoneLandscapeSharp", ()=>IoPhoneLandscapeSharp);
parcelHelpers.export(exports, "IoPhoneLandscape", ()=>IoPhoneLandscape);
parcelHelpers.export(exports, "IoPhonePortraitOutline", ()=>IoPhonePortraitOutline);
parcelHelpers.export(exports, "IoPhonePortraitSharp", ()=>IoPhonePortraitSharp);
parcelHelpers.export(exports, "IoPhonePortrait", ()=>IoPhonePortrait);
parcelHelpers.export(exports, "IoPieChartOutline", ()=>IoPieChartOutline);
parcelHelpers.export(exports, "IoPieChartSharp", ()=>IoPieChartSharp);
parcelHelpers.export(exports, "IoPieChart", ()=>IoPieChart);
parcelHelpers.export(exports, "IoPinOutline", ()=>IoPinOutline);
parcelHelpers.export(exports, "IoPinSharp", ()=>IoPinSharp);
parcelHelpers.export(exports, "IoPin", ()=>IoPin);
parcelHelpers.export(exports, "IoPintOutline", ()=>IoPintOutline);
parcelHelpers.export(exports, "IoPintSharp", ()=>IoPintSharp);
parcelHelpers.export(exports, "IoPint", ()=>IoPint);
parcelHelpers.export(exports, "IoPizzaOutline", ()=>IoPizzaOutline);
parcelHelpers.export(exports, "IoPizzaSharp", ()=>IoPizzaSharp);
parcelHelpers.export(exports, "IoPizza", ()=>IoPizza);
parcelHelpers.export(exports, "IoPlanetOutline", ()=>IoPlanetOutline);
parcelHelpers.export(exports, "IoPlanetSharp", ()=>IoPlanetSharp);
parcelHelpers.export(exports, "IoPlanet", ()=>IoPlanet);
parcelHelpers.export(exports, "IoPlayBackCircleOutline", ()=>IoPlayBackCircleOutline);
parcelHelpers.export(exports, "IoPlayBackCircleSharp", ()=>IoPlayBackCircleSharp);
parcelHelpers.export(exports, "IoPlayBackCircle", ()=>IoPlayBackCircle);
parcelHelpers.export(exports, "IoPlayBackOutline", ()=>IoPlayBackOutline);
parcelHelpers.export(exports, "IoPlayBackSharp", ()=>IoPlayBackSharp);
parcelHelpers.export(exports, "IoPlayBack", ()=>IoPlayBack);
parcelHelpers.export(exports, "IoPlayCircleOutline", ()=>IoPlayCircleOutline);
parcelHelpers.export(exports, "IoPlayCircleSharp", ()=>IoPlayCircleSharp);
parcelHelpers.export(exports, "IoPlayCircle", ()=>IoPlayCircle);
parcelHelpers.export(exports, "IoPlayForwardCircleOutline", ()=>IoPlayForwardCircleOutline);
parcelHelpers.export(exports, "IoPlayForwardCircleSharp", ()=>IoPlayForwardCircleSharp);
parcelHelpers.export(exports, "IoPlayForwardCircle", ()=>IoPlayForwardCircle);
parcelHelpers.export(exports, "IoPlayForwardOutline", ()=>IoPlayForwardOutline);
parcelHelpers.export(exports, "IoPlayForwardSharp", ()=>IoPlayForwardSharp);
parcelHelpers.export(exports, "IoPlayForward", ()=>IoPlayForward);
parcelHelpers.export(exports, "IoPlayOutline", ()=>IoPlayOutline);
parcelHelpers.export(exports, "IoPlaySharp", ()=>IoPlaySharp);
parcelHelpers.export(exports, "IoPlaySkipBackCircleOutline", ()=>IoPlaySkipBackCircleOutline);
parcelHelpers.export(exports, "IoPlaySkipBackCircleSharp", ()=>IoPlaySkipBackCircleSharp);
parcelHelpers.export(exports, "IoPlaySkipBackCircle", ()=>IoPlaySkipBackCircle);
parcelHelpers.export(exports, "IoPlaySkipBackOutline", ()=>IoPlaySkipBackOutline);
parcelHelpers.export(exports, "IoPlaySkipBackSharp", ()=>IoPlaySkipBackSharp);
parcelHelpers.export(exports, "IoPlaySkipBack", ()=>IoPlaySkipBack);
parcelHelpers.export(exports, "IoPlaySkipForwardCircleOutline", ()=>IoPlaySkipForwardCircleOutline);
parcelHelpers.export(exports, "IoPlaySkipForwardCircleSharp", ()=>IoPlaySkipForwardCircleSharp);
parcelHelpers.export(exports, "IoPlaySkipForwardCircle", ()=>IoPlaySkipForwardCircle);
parcelHelpers.export(exports, "IoPlaySkipForwardOutline", ()=>IoPlaySkipForwardOutline);
parcelHelpers.export(exports, "IoPlaySkipForwardSharp", ()=>IoPlaySkipForwardSharp);
parcelHelpers.export(exports, "IoPlaySkipForward", ()=>IoPlaySkipForward);
parcelHelpers.export(exports, "IoPlay", ()=>IoPlay);
parcelHelpers.export(exports, "IoPodiumOutline", ()=>IoPodiumOutline);
parcelHelpers.export(exports, "IoPodiumSharp", ()=>IoPodiumSharp);
parcelHelpers.export(exports, "IoPodium", ()=>IoPodium);
parcelHelpers.export(exports, "IoPowerOutline", ()=>IoPowerOutline);
parcelHelpers.export(exports, "IoPowerSharp", ()=>IoPowerSharp);
parcelHelpers.export(exports, "IoPower", ()=>IoPower);
parcelHelpers.export(exports, "IoPricetagOutline", ()=>IoPricetagOutline);
parcelHelpers.export(exports, "IoPricetagSharp", ()=>IoPricetagSharp);
parcelHelpers.export(exports, "IoPricetag", ()=>IoPricetag);
parcelHelpers.export(exports, "IoPricetagsOutline", ()=>IoPricetagsOutline);
parcelHelpers.export(exports, "IoPricetagsSharp", ()=>IoPricetagsSharp);
parcelHelpers.export(exports, "IoPricetags", ()=>IoPricetags);
parcelHelpers.export(exports, "IoPrintOutline", ()=>IoPrintOutline);
parcelHelpers.export(exports, "IoPrintSharp", ()=>IoPrintSharp);
parcelHelpers.export(exports, "IoPrint", ()=>IoPrint);
parcelHelpers.export(exports, "IoPrismOutline", ()=>IoPrismOutline);
parcelHelpers.export(exports, "IoPrismSharp", ()=>IoPrismSharp);
parcelHelpers.export(exports, "IoPrism", ()=>IoPrism);
parcelHelpers.export(exports, "IoPulseOutline", ()=>IoPulseOutline);
parcelHelpers.export(exports, "IoPulseSharp", ()=>IoPulseSharp);
parcelHelpers.export(exports, "IoPulse", ()=>IoPulse);
parcelHelpers.export(exports, "IoPushOutline", ()=>IoPushOutline);
parcelHelpers.export(exports, "IoPushSharp", ()=>IoPushSharp);
parcelHelpers.export(exports, "IoPush", ()=>IoPush);
parcelHelpers.export(exports, "IoQrCodeOutline", ()=>IoQrCodeOutline);
parcelHelpers.export(exports, "IoQrCodeSharp", ()=>IoQrCodeSharp);
parcelHelpers.export(exports, "IoQrCode", ()=>IoQrCode);
parcelHelpers.export(exports, "IoRadioButtonOffOutline", ()=>IoRadioButtonOffOutline);
parcelHelpers.export(exports, "IoRadioButtonOffSharp", ()=>IoRadioButtonOffSharp);
parcelHelpers.export(exports, "IoRadioButtonOff", ()=>IoRadioButtonOff);
parcelHelpers.export(exports, "IoRadioButtonOnOutline", ()=>IoRadioButtonOnOutline);
parcelHelpers.export(exports, "IoRadioButtonOnSharp", ()=>IoRadioButtonOnSharp);
parcelHelpers.export(exports, "IoRadioButtonOn", ()=>IoRadioButtonOn);
parcelHelpers.export(exports, "IoRadioOutline", ()=>IoRadioOutline);
parcelHelpers.export(exports, "IoRadioSharp", ()=>IoRadioSharp);
parcelHelpers.export(exports, "IoRadio", ()=>IoRadio);
parcelHelpers.export(exports, "IoRainyOutline", ()=>IoRainyOutline);
parcelHelpers.export(exports, "IoRainySharp", ()=>IoRainySharp);
parcelHelpers.export(exports, "IoRainy", ()=>IoRainy);
parcelHelpers.export(exports, "IoReaderOutline", ()=>IoReaderOutline);
parcelHelpers.export(exports, "IoReaderSharp", ()=>IoReaderSharp);
parcelHelpers.export(exports, "IoReader", ()=>IoReader);
parcelHelpers.export(exports, "IoReceiptOutline", ()=>IoReceiptOutline);
parcelHelpers.export(exports, "IoReceiptSharp", ()=>IoReceiptSharp);
parcelHelpers.export(exports, "IoReceipt", ()=>IoReceipt);
parcelHelpers.export(exports, "IoRecordingOutline", ()=>IoRecordingOutline);
parcelHelpers.export(exports, "IoRecordingSharp", ()=>IoRecordingSharp);
parcelHelpers.export(exports, "IoRecording", ()=>IoRecording);
parcelHelpers.export(exports, "IoRefreshCircleOutline", ()=>IoRefreshCircleOutline);
parcelHelpers.export(exports, "IoRefreshCircleSharp", ()=>IoRefreshCircleSharp);
parcelHelpers.export(exports, "IoRefreshCircle", ()=>IoRefreshCircle);
parcelHelpers.export(exports, "IoRefreshOutline", ()=>IoRefreshOutline);
parcelHelpers.export(exports, "IoRefreshSharp", ()=>IoRefreshSharp);
parcelHelpers.export(exports, "IoRefresh", ()=>IoRefresh);
parcelHelpers.export(exports, "IoReloadCircleOutline", ()=>IoReloadCircleOutline);
parcelHelpers.export(exports, "IoReloadCircleSharp", ()=>IoReloadCircleSharp);
parcelHelpers.export(exports, "IoReloadCircle", ()=>IoReloadCircle);
parcelHelpers.export(exports, "IoReloadOutline", ()=>IoReloadOutline);
parcelHelpers.export(exports, "IoReloadSharp", ()=>IoReloadSharp);
parcelHelpers.export(exports, "IoReload", ()=>IoReload);
parcelHelpers.export(exports, "IoRemoveCircleOutline", ()=>IoRemoveCircleOutline);
parcelHelpers.export(exports, "IoRemoveCircleSharp", ()=>IoRemoveCircleSharp);
parcelHelpers.export(exports, "IoRemoveCircle", ()=>IoRemoveCircle);
parcelHelpers.export(exports, "IoRemoveOutline", ()=>IoRemoveOutline);
parcelHelpers.export(exports, "IoRemoveSharp", ()=>IoRemoveSharp);
parcelHelpers.export(exports, "IoRemove", ()=>IoRemove);
parcelHelpers.export(exports, "IoReorderFourOutline", ()=>IoReorderFourOutline);
parcelHelpers.export(exports, "IoReorderFourSharp", ()=>IoReorderFourSharp);
parcelHelpers.export(exports, "IoReorderFour", ()=>IoReorderFour);
parcelHelpers.export(exports, "IoReorderThreeOutline", ()=>IoReorderThreeOutline);
parcelHelpers.export(exports, "IoReorderThreeSharp", ()=>IoReorderThreeSharp);
parcelHelpers.export(exports, "IoReorderThree", ()=>IoReorderThree);
parcelHelpers.export(exports, "IoReorderTwoOutline", ()=>IoReorderTwoOutline);
parcelHelpers.export(exports, "IoReorderTwoSharp", ()=>IoReorderTwoSharp);
parcelHelpers.export(exports, "IoReorderTwo", ()=>IoReorderTwo);
parcelHelpers.export(exports, "IoRepeatOutline", ()=>IoRepeatOutline);
parcelHelpers.export(exports, "IoRepeatSharp", ()=>IoRepeatSharp);
parcelHelpers.export(exports, "IoRepeat", ()=>IoRepeat);
parcelHelpers.export(exports, "IoResizeOutline", ()=>IoResizeOutline);
parcelHelpers.export(exports, "IoResizeSharp", ()=>IoResizeSharp);
parcelHelpers.export(exports, "IoResize", ()=>IoResize);
parcelHelpers.export(exports, "IoRestaurantOutline", ()=>IoRestaurantOutline);
parcelHelpers.export(exports, "IoRestaurantSharp", ()=>IoRestaurantSharp);
parcelHelpers.export(exports, "IoRestaurant", ()=>IoRestaurant);
parcelHelpers.export(exports, "IoReturnDownBackOutline", ()=>IoReturnDownBackOutline);
parcelHelpers.export(exports, "IoReturnDownBackSharp", ()=>IoReturnDownBackSharp);
parcelHelpers.export(exports, "IoReturnDownBack", ()=>IoReturnDownBack);
parcelHelpers.export(exports, "IoReturnDownForwardOutline", ()=>IoReturnDownForwardOutline);
parcelHelpers.export(exports, "IoReturnDownForwardSharp", ()=>IoReturnDownForwardSharp);
parcelHelpers.export(exports, "IoReturnDownForward", ()=>IoReturnDownForward);
parcelHelpers.export(exports, "IoReturnUpBackOutline", ()=>IoReturnUpBackOutline);
parcelHelpers.export(exports, "IoReturnUpBackSharp", ()=>IoReturnUpBackSharp);
parcelHelpers.export(exports, "IoReturnUpBack", ()=>IoReturnUpBack);
parcelHelpers.export(exports, "IoReturnUpForwardOutline", ()=>IoReturnUpForwardOutline);
parcelHelpers.export(exports, "IoReturnUpForwardSharp", ()=>IoReturnUpForwardSharp);
parcelHelpers.export(exports, "IoReturnUpForward", ()=>IoReturnUpForward);
parcelHelpers.export(exports, "IoRibbonOutline", ()=>IoRibbonOutline);
parcelHelpers.export(exports, "IoRibbonSharp", ()=>IoRibbonSharp);
parcelHelpers.export(exports, "IoRibbon", ()=>IoRibbon);
parcelHelpers.export(exports, "IoRocketOutline", ()=>IoRocketOutline);
parcelHelpers.export(exports, "IoRocketSharp", ()=>IoRocketSharp);
parcelHelpers.export(exports, "IoRocket", ()=>IoRocket);
parcelHelpers.export(exports, "IoRoseOutline", ()=>IoRoseOutline);
parcelHelpers.export(exports, "IoRoseSharp", ()=>IoRoseSharp);
parcelHelpers.export(exports, "IoRose", ()=>IoRose);
parcelHelpers.export(exports, "IoSadOutline", ()=>IoSadOutline);
parcelHelpers.export(exports, "IoSadSharp", ()=>IoSadSharp);
parcelHelpers.export(exports, "IoSad", ()=>IoSad);
parcelHelpers.export(exports, "IoSaveOutline", ()=>IoSaveOutline);
parcelHelpers.export(exports, "IoSaveSharp", ()=>IoSaveSharp);
parcelHelpers.export(exports, "IoSave", ()=>IoSave);
parcelHelpers.export(exports, "IoScaleOutline", ()=>IoScaleOutline);
parcelHelpers.export(exports, "IoScaleSharp", ()=>IoScaleSharp);
parcelHelpers.export(exports, "IoScale", ()=>IoScale);
parcelHelpers.export(exports, "IoScanCircleOutline", ()=>IoScanCircleOutline);
parcelHelpers.export(exports, "IoScanCircleSharp", ()=>IoScanCircleSharp);
parcelHelpers.export(exports, "IoScanCircle", ()=>IoScanCircle);
parcelHelpers.export(exports, "IoScanOutline", ()=>IoScanOutline);
parcelHelpers.export(exports, "IoScanSharp", ()=>IoScanSharp);
parcelHelpers.export(exports, "IoScan", ()=>IoScan);
parcelHelpers.export(exports, "IoSchoolOutline", ()=>IoSchoolOutline);
parcelHelpers.export(exports, "IoSchoolSharp", ()=>IoSchoolSharp);
parcelHelpers.export(exports, "IoSchool", ()=>IoSchool);
parcelHelpers.export(exports, "IoSearchCircleOutline", ()=>IoSearchCircleOutline);
parcelHelpers.export(exports, "IoSearchCircleSharp", ()=>IoSearchCircleSharp);
parcelHelpers.export(exports, "IoSearchCircle", ()=>IoSearchCircle);
parcelHelpers.export(exports, "IoSearchOutline", ()=>IoSearchOutline);
parcelHelpers.export(exports, "IoSearchSharp", ()=>IoSearchSharp);
parcelHelpers.export(exports, "IoSearch", ()=>IoSearch);
parcelHelpers.export(exports, "IoSendOutline", ()=>IoSendOutline);
parcelHelpers.export(exports, "IoSendSharp", ()=>IoSendSharp);
parcelHelpers.export(exports, "IoSend", ()=>IoSend);
parcelHelpers.export(exports, "IoServerOutline", ()=>IoServerOutline);
parcelHelpers.export(exports, "IoServerSharp", ()=>IoServerSharp);
parcelHelpers.export(exports, "IoServer", ()=>IoServer);
parcelHelpers.export(exports, "IoSettingsOutline", ()=>IoSettingsOutline);
parcelHelpers.export(exports, "IoSettingsSharp", ()=>IoSettingsSharp);
parcelHelpers.export(exports, "IoSettings", ()=>IoSettings);
parcelHelpers.export(exports, "IoShapesOutline", ()=>IoShapesOutline);
parcelHelpers.export(exports, "IoShapesSharp", ()=>IoShapesSharp);
parcelHelpers.export(exports, "IoShapes", ()=>IoShapes);
parcelHelpers.export(exports, "IoShareOutline", ()=>IoShareOutline);
parcelHelpers.export(exports, "IoShareSharp", ()=>IoShareSharp);
parcelHelpers.export(exports, "IoShareSocialOutline", ()=>IoShareSocialOutline);
parcelHelpers.export(exports, "IoShareSocialSharp", ()=>IoShareSocialSharp);
parcelHelpers.export(exports, "IoShareSocial", ()=>IoShareSocial);
parcelHelpers.export(exports, "IoShare", ()=>IoShare);
parcelHelpers.export(exports, "IoShieldCheckmarkOutline", ()=>IoShieldCheckmarkOutline);
parcelHelpers.export(exports, "IoShieldCheckmarkSharp", ()=>IoShieldCheckmarkSharp);
parcelHelpers.export(exports, "IoShieldCheckmark", ()=>IoShieldCheckmark);
parcelHelpers.export(exports, "IoShieldHalfOutline", ()=>IoShieldHalfOutline);
parcelHelpers.export(exports, "IoShieldHalfSharp", ()=>IoShieldHalfSharp);
parcelHelpers.export(exports, "IoShieldHalf", ()=>IoShieldHalf);
parcelHelpers.export(exports, "IoShieldOutline", ()=>IoShieldOutline);
parcelHelpers.export(exports, "IoShieldSharp", ()=>IoShieldSharp);
parcelHelpers.export(exports, "IoShield", ()=>IoShield);
parcelHelpers.export(exports, "IoShirtOutline", ()=>IoShirtOutline);
parcelHelpers.export(exports, "IoShirtSharp", ()=>IoShirtSharp);
parcelHelpers.export(exports, "IoShirt", ()=>IoShirt);
parcelHelpers.export(exports, "IoShuffleOutline", ()=>IoShuffleOutline);
parcelHelpers.export(exports, "IoShuffleSharp", ()=>IoShuffleSharp);
parcelHelpers.export(exports, "IoShuffle", ()=>IoShuffle);
parcelHelpers.export(exports, "IoSkullOutline", ()=>IoSkullOutline);
parcelHelpers.export(exports, "IoSkullSharp", ()=>IoSkullSharp);
parcelHelpers.export(exports, "IoSkull", ()=>IoSkull);
parcelHelpers.export(exports, "IoSnowOutline", ()=>IoSnowOutline);
parcelHelpers.export(exports, "IoSnowSharp", ()=>IoSnowSharp);
parcelHelpers.export(exports, "IoSnow", ()=>IoSnow);
parcelHelpers.export(exports, "IoSparklesOutline", ()=>IoSparklesOutline);
parcelHelpers.export(exports, "IoSparklesSharp", ()=>IoSparklesSharp);
parcelHelpers.export(exports, "IoSparkles", ()=>IoSparkles);
parcelHelpers.export(exports, "IoSpeedometerOutline", ()=>IoSpeedometerOutline);
parcelHelpers.export(exports, "IoSpeedometerSharp", ()=>IoSpeedometerSharp);
parcelHelpers.export(exports, "IoSpeedometer", ()=>IoSpeedometer);
parcelHelpers.export(exports, "IoSquareOutline", ()=>IoSquareOutline);
parcelHelpers.export(exports, "IoSquareSharp", ()=>IoSquareSharp);
parcelHelpers.export(exports, "IoSquare", ()=>IoSquare);
parcelHelpers.export(exports, "IoStarHalfOutline", ()=>IoStarHalfOutline);
parcelHelpers.export(exports, "IoStarHalfSharp", ()=>IoStarHalfSharp);
parcelHelpers.export(exports, "IoStarHalf", ()=>IoStarHalf);
parcelHelpers.export(exports, "IoStarOutline", ()=>IoStarOutline);
parcelHelpers.export(exports, "IoStarSharp", ()=>IoStarSharp);
parcelHelpers.export(exports, "IoStar", ()=>IoStar);
parcelHelpers.export(exports, "IoStatsChartOutline", ()=>IoStatsChartOutline);
parcelHelpers.export(exports, "IoStatsChartSharp", ()=>IoStatsChartSharp);
parcelHelpers.export(exports, "IoStatsChart", ()=>IoStatsChart);
parcelHelpers.export(exports, "IoStopCircleOutline", ()=>IoStopCircleOutline);
parcelHelpers.export(exports, "IoStopCircleSharp", ()=>IoStopCircleSharp);
parcelHelpers.export(exports, "IoStopCircle", ()=>IoStopCircle);
parcelHelpers.export(exports, "IoStopOutline", ()=>IoStopOutline);
parcelHelpers.export(exports, "IoStopSharp", ()=>IoStopSharp);
parcelHelpers.export(exports, "IoStop", ()=>IoStop);
parcelHelpers.export(exports, "IoStopwatchOutline", ()=>IoStopwatchOutline);
parcelHelpers.export(exports, "IoStopwatchSharp", ()=>IoStopwatchSharp);
parcelHelpers.export(exports, "IoStopwatch", ()=>IoStopwatch);
parcelHelpers.export(exports, "IoStorefrontOutline", ()=>IoStorefrontOutline);
parcelHelpers.export(exports, "IoStorefrontSharp", ()=>IoStorefrontSharp);
parcelHelpers.export(exports, "IoStorefront", ()=>IoStorefront);
parcelHelpers.export(exports, "IoSubwayOutline", ()=>IoSubwayOutline);
parcelHelpers.export(exports, "IoSubwaySharp", ()=>IoSubwaySharp);
parcelHelpers.export(exports, "IoSubway", ()=>IoSubway);
parcelHelpers.export(exports, "IoSunnyOutline", ()=>IoSunnyOutline);
parcelHelpers.export(exports, "IoSunnySharp", ()=>IoSunnySharp);
parcelHelpers.export(exports, "IoSunny", ()=>IoSunny);
parcelHelpers.export(exports, "IoSwapHorizontalOutline", ()=>IoSwapHorizontalOutline);
parcelHelpers.export(exports, "IoSwapHorizontalSharp", ()=>IoSwapHorizontalSharp);
parcelHelpers.export(exports, "IoSwapHorizontal", ()=>IoSwapHorizontal);
parcelHelpers.export(exports, "IoSwapVerticalOutline", ()=>IoSwapVerticalOutline);
parcelHelpers.export(exports, "IoSwapVerticalSharp", ()=>IoSwapVerticalSharp);
parcelHelpers.export(exports, "IoSwapVertical", ()=>IoSwapVertical);
parcelHelpers.export(exports, "IoSyncCircleOutline", ()=>IoSyncCircleOutline);
parcelHelpers.export(exports, "IoSyncCircleSharp", ()=>IoSyncCircleSharp);
parcelHelpers.export(exports, "IoSyncCircle", ()=>IoSyncCircle);
parcelHelpers.export(exports, "IoSyncOutline", ()=>IoSyncOutline);
parcelHelpers.export(exports, "IoSyncSharp", ()=>IoSyncSharp);
parcelHelpers.export(exports, "IoSync", ()=>IoSync);
parcelHelpers.export(exports, "IoTabletLandscapeOutline", ()=>IoTabletLandscapeOutline);
parcelHelpers.export(exports, "IoTabletLandscapeSharp", ()=>IoTabletLandscapeSharp);
parcelHelpers.export(exports, "IoTabletLandscape", ()=>IoTabletLandscape);
parcelHelpers.export(exports, "IoTabletPortraitOutline", ()=>IoTabletPortraitOutline);
parcelHelpers.export(exports, "IoTabletPortraitSharp", ()=>IoTabletPortraitSharp);
parcelHelpers.export(exports, "IoTabletPortrait", ()=>IoTabletPortrait);
parcelHelpers.export(exports, "IoTelescopeOutline", ()=>IoTelescopeOutline);
parcelHelpers.export(exports, "IoTelescopeSharp", ()=>IoTelescopeSharp);
parcelHelpers.export(exports, "IoTelescope", ()=>IoTelescope);
parcelHelpers.export(exports, "IoTennisballOutline", ()=>IoTennisballOutline);
parcelHelpers.export(exports, "IoTennisballSharp", ()=>IoTennisballSharp);
parcelHelpers.export(exports, "IoTennisball", ()=>IoTennisball);
parcelHelpers.export(exports, "IoTerminalOutline", ()=>IoTerminalOutline);
parcelHelpers.export(exports, "IoTerminalSharp", ()=>IoTerminalSharp);
parcelHelpers.export(exports, "IoTerminal", ()=>IoTerminal);
parcelHelpers.export(exports, "IoTextOutline", ()=>IoTextOutline);
parcelHelpers.export(exports, "IoTextSharp", ()=>IoTextSharp);
parcelHelpers.export(exports, "IoText", ()=>IoText);
parcelHelpers.export(exports, "IoThermometerOutline", ()=>IoThermometerOutline);
parcelHelpers.export(exports, "IoThermometerSharp", ()=>IoThermometerSharp);
parcelHelpers.export(exports, "IoThermometer", ()=>IoThermometer);
parcelHelpers.export(exports, "IoThumbsDownOutline", ()=>IoThumbsDownOutline);
parcelHelpers.export(exports, "IoThumbsDownSharp", ()=>IoThumbsDownSharp);
parcelHelpers.export(exports, "IoThumbsDown", ()=>IoThumbsDown);
parcelHelpers.export(exports, "IoThumbsUpOutline", ()=>IoThumbsUpOutline);
parcelHelpers.export(exports, "IoThumbsUpSharp", ()=>IoThumbsUpSharp);
parcelHelpers.export(exports, "IoThumbsUp", ()=>IoThumbsUp);
parcelHelpers.export(exports, "IoThunderstormOutline", ()=>IoThunderstormOutline);
parcelHelpers.export(exports, "IoThunderstormSharp", ()=>IoThunderstormSharp);
parcelHelpers.export(exports, "IoThunderstorm", ()=>IoThunderstorm);
parcelHelpers.export(exports, "IoTicketOutline", ()=>IoTicketOutline);
parcelHelpers.export(exports, "IoTicketSharp", ()=>IoTicketSharp);
parcelHelpers.export(exports, "IoTicket", ()=>IoTicket);
parcelHelpers.export(exports, "IoTimeOutline", ()=>IoTimeOutline);
parcelHelpers.export(exports, "IoTimeSharp", ()=>IoTimeSharp);
parcelHelpers.export(exports, "IoTime", ()=>IoTime);
parcelHelpers.export(exports, "IoTimerOutline", ()=>IoTimerOutline);
parcelHelpers.export(exports, "IoTimerSharp", ()=>IoTimerSharp);
parcelHelpers.export(exports, "IoTimer", ()=>IoTimer);
parcelHelpers.export(exports, "IoTodayOutline", ()=>IoTodayOutline);
parcelHelpers.export(exports, "IoTodaySharp", ()=>IoTodaySharp);
parcelHelpers.export(exports, "IoToday", ()=>IoToday);
parcelHelpers.export(exports, "IoToggleOutline", ()=>IoToggleOutline);
parcelHelpers.export(exports, "IoToggleSharp", ()=>IoToggleSharp);
parcelHelpers.export(exports, "IoToggle", ()=>IoToggle);
parcelHelpers.export(exports, "IoTrailSignOutline", ()=>IoTrailSignOutline);
parcelHelpers.export(exports, "IoTrailSignSharp", ()=>IoTrailSignSharp);
parcelHelpers.export(exports, "IoTrailSign", ()=>IoTrailSign);
parcelHelpers.export(exports, "IoTrainOutline", ()=>IoTrainOutline);
parcelHelpers.export(exports, "IoTrainSharp", ()=>IoTrainSharp);
parcelHelpers.export(exports, "IoTrain", ()=>IoTrain);
parcelHelpers.export(exports, "IoTransgenderOutline", ()=>IoTransgenderOutline);
parcelHelpers.export(exports, "IoTransgenderSharp", ()=>IoTransgenderSharp);
parcelHelpers.export(exports, "IoTransgender", ()=>IoTransgender);
parcelHelpers.export(exports, "IoTrashBinOutline", ()=>IoTrashBinOutline);
parcelHelpers.export(exports, "IoTrashBinSharp", ()=>IoTrashBinSharp);
parcelHelpers.export(exports, "IoTrashBin", ()=>IoTrashBin);
parcelHelpers.export(exports, "IoTrashOutline", ()=>IoTrashOutline);
parcelHelpers.export(exports, "IoTrashSharp", ()=>IoTrashSharp);
parcelHelpers.export(exports, "IoTrash", ()=>IoTrash);
parcelHelpers.export(exports, "IoTrendingDownOutline", ()=>IoTrendingDownOutline);
parcelHelpers.export(exports, "IoTrendingDownSharp", ()=>IoTrendingDownSharp);
parcelHelpers.export(exports, "IoTrendingDown", ()=>IoTrendingDown);
parcelHelpers.export(exports, "IoTrendingUpOutline", ()=>IoTrendingUpOutline);
parcelHelpers.export(exports, "IoTrendingUpSharp", ()=>IoTrendingUpSharp);
parcelHelpers.export(exports, "IoTrendingUp", ()=>IoTrendingUp);
parcelHelpers.export(exports, "IoTriangleOutline", ()=>IoTriangleOutline);
parcelHelpers.export(exports, "IoTriangleSharp", ()=>IoTriangleSharp);
parcelHelpers.export(exports, "IoTriangle", ()=>IoTriangle);
parcelHelpers.export(exports, "IoTrophyOutline", ()=>IoTrophyOutline);
parcelHelpers.export(exports, "IoTrophySharp", ()=>IoTrophySharp);
parcelHelpers.export(exports, "IoTrophy", ()=>IoTrophy);
parcelHelpers.export(exports, "IoTvOutline", ()=>IoTvOutline);
parcelHelpers.export(exports, "IoTvSharp", ()=>IoTvSharp);
parcelHelpers.export(exports, "IoTv", ()=>IoTv);
parcelHelpers.export(exports, "IoUmbrellaOutline", ()=>IoUmbrellaOutline);
parcelHelpers.export(exports, "IoUmbrellaSharp", ()=>IoUmbrellaSharp);
parcelHelpers.export(exports, "IoUmbrella", ()=>IoUmbrella);
parcelHelpers.export(exports, "IoUnlinkOutline", ()=>IoUnlinkOutline);
parcelHelpers.export(exports, "IoUnlinkSharp", ()=>IoUnlinkSharp);
parcelHelpers.export(exports, "IoUnlink", ()=>IoUnlink);
parcelHelpers.export(exports, "IoVideocamOffOutline", ()=>IoVideocamOffOutline);
parcelHelpers.export(exports, "IoVideocamOffSharp", ()=>IoVideocamOffSharp);
parcelHelpers.export(exports, "IoVideocamOff", ()=>IoVideocamOff);
parcelHelpers.export(exports, "IoVideocamOutline", ()=>IoVideocamOutline);
parcelHelpers.export(exports, "IoVideocamSharp", ()=>IoVideocamSharp);
parcelHelpers.export(exports, "IoVideocam", ()=>IoVideocam);
parcelHelpers.export(exports, "IoVolumeHighOutline", ()=>IoVolumeHighOutline);
parcelHelpers.export(exports, "IoVolumeHighSharp", ()=>IoVolumeHighSharp);
parcelHelpers.export(exports, "IoVolumeHigh", ()=>IoVolumeHigh);
parcelHelpers.export(exports, "IoVolumeLowOutline", ()=>IoVolumeLowOutline);
parcelHelpers.export(exports, "IoVolumeLowSharp", ()=>IoVolumeLowSharp);
parcelHelpers.export(exports, "IoVolumeLow", ()=>IoVolumeLow);
parcelHelpers.export(exports, "IoVolumeMediumOutline", ()=>IoVolumeMediumOutline);
parcelHelpers.export(exports, "IoVolumeMediumSharp", ()=>IoVolumeMediumSharp);
parcelHelpers.export(exports, "IoVolumeMedium", ()=>IoVolumeMedium);
parcelHelpers.export(exports, "IoVolumeMuteOutline", ()=>IoVolumeMuteOutline);
parcelHelpers.export(exports, "IoVolumeMuteSharp", ()=>IoVolumeMuteSharp);
parcelHelpers.export(exports, "IoVolumeMute", ()=>IoVolumeMute);
parcelHelpers.export(exports, "IoVolumeOffOutline", ()=>IoVolumeOffOutline);
parcelHelpers.export(exports, "IoVolumeOffSharp", ()=>IoVolumeOffSharp);
parcelHelpers.export(exports, "IoVolumeOff", ()=>IoVolumeOff);
parcelHelpers.export(exports, "IoWalkOutline", ()=>IoWalkOutline);
parcelHelpers.export(exports, "IoWalkSharp", ()=>IoWalkSharp);
parcelHelpers.export(exports, "IoWalk", ()=>IoWalk);
parcelHelpers.export(exports, "IoWalletOutline", ()=>IoWalletOutline);
parcelHelpers.export(exports, "IoWalletSharp", ()=>IoWalletSharp);
parcelHelpers.export(exports, "IoWallet", ()=>IoWallet);
parcelHelpers.export(exports, "IoWarningOutline", ()=>IoWarningOutline);
parcelHelpers.export(exports, "IoWarningSharp", ()=>IoWarningSharp);
parcelHelpers.export(exports, "IoWarning", ()=>IoWarning);
parcelHelpers.export(exports, "IoWatchOutline", ()=>IoWatchOutline);
parcelHelpers.export(exports, "IoWatchSharp", ()=>IoWatchSharp);
parcelHelpers.export(exports, "IoWatch", ()=>IoWatch);
parcelHelpers.export(exports, "IoWaterOutline", ()=>IoWaterOutline);
parcelHelpers.export(exports, "IoWaterSharp", ()=>IoWaterSharp);
parcelHelpers.export(exports, "IoWater", ()=>IoWater);
parcelHelpers.export(exports, "IoWifiOutline", ()=>IoWifiOutline);
parcelHelpers.export(exports, "IoWifiSharp", ()=>IoWifiSharp);
parcelHelpers.export(exports, "IoWifi", ()=>IoWifi);
parcelHelpers.export(exports, "IoWineOutline", ()=>IoWineOutline);
parcelHelpers.export(exports, "IoWineSharp", ()=>IoWineSharp);
parcelHelpers.export(exports, "IoWine", ()=>IoWine);
parcelHelpers.export(exports, "IoWomanOutline", ()=>IoWomanOutline);
parcelHelpers.export(exports, "IoWomanSharp", ()=>IoWomanSharp);
parcelHelpers.export(exports, "IoWoman", ()=>IoWoman);
var _lib = require("../lib");
function IoAccessibilityOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "56",
                    "r": "40",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M204.23 274.44c2.9-18.06 4.2-35.52-.5-47.59-4-10.38-12.7-16.19-23.2-20.15L88 176.76c-12-4-23.21-10.7-24-23.94-1-17 14-28 29-24 0 0 88 31.14 163 31.14s162-31 162-31c18-5 30 9 30 23.79 0 14.21-11 19.21-24 23.94l-88 31.91c-8 3-21 9-26 18.18-6 10.75-5 29.53-2.1 47.59l5.9 29.63 37.41 163.9c2.8 13.15-6.3 25.44-19.4 27.74S308 489 304.12 476.28l-37.56-115.93q-2.71-8.34-4.8-16.87L256 320l-5.3 21.65q-2.52 10.35-5.8 20.48L208 476.18c-4 12.85-14.5 21.75-27.6 19.46s-22.4-15.59-19.46-27.74l37.39-163.83z"
                }
            }
        ]
    })(props);
}
function IoAccessibilitySharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 112c-66.82 17.92-119.55 32-192 32s-125.18-14.08-192-32l-16 51c48 20.53 96.71 35.16 147.2 53.2L144 496l56.4 16L246 336h20l45.6 176 56.4-16-51.2-279.8C367.26 199.93 416 183.53 464 164zm-192 0a56 56 0 1156-56 56.06 56.06 0 01-56 56z"
                }
            }
        ]
    })(props);
}
function IoAccessibility(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 112a56 56 0 1156-56 56.06 56.06 0 01-56 56z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M432 112.8l-.45.12-.42.13c-1 .28-2 .58-3 .89-18.61 5.46-108.93 30.92-172.56 30.92-59.13 0-141.28-22-167.56-29.47a73.79 73.79 0 00-8-2.58c-19-5-32 14.3-32 31.94 0 17.47 15.7 25.79 31.55 31.76v.28l95.22 29.74c9.73 3.73 12.33 7.54 13.6 10.84 4.13 10.59.83 31.56-.34 38.88l-5.8 45-32.19 176.19q-.15.72-.27 1.47l-.23 1.27c-2.32 16.15 9.54 31.82 32 31.82 19.6 0 28.25-13.53 32-31.94s28-157.57 42-157.57 42.84 157.57 42.84 157.57c3.75 18.41 12.4 31.94 32 31.94 22.52 0 34.38-15.74 32-31.94a57.17 57.17 0 00-.76-4.06L329 301.27l-5.79-45c-4.19-26.21-.82-34.87.32-36.9a1.09 1.09 0 00.08-.15c1.08-2 6-6.48 17.48-10.79l89.28-31.21a16.9 16.9 0 001.62-.52c16-6 32-14.3 32-31.93S451 107.81 432 112.8z"
                }
            }
        ]
    })(props);
}
function IoAddCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 176v160m80-80H176"
                }
            }
        ]
    })(props);
}
function IoAddCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm96 224h-80v80h-32v-80h-80v-32h80v-80h32v80h80z"
                }
            }
        ]
    })(props);
}
function IoAddCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm80 224h-64v64a16 16 0 01-32 0v-64h-64a16 16 0 010-32h64v-64a16 16 0 0132 0v64h64a16 16 0 010 32z"
                }
            }
        ]
    })(props);
}
function IoAddOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 112v288m144-144H112"
                }
            }
        ]
    })(props);
}
function IoAddSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 112v288m144-144H112"
                }
            }
        ]
    })(props);
}
function IoAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 112v288m144-144H112"
                }
            }
        ]
    })(props);
}
function IoAirplaneOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M407.72 224c-3.4 0-14.79.1-18 .3l-64.9 1.7a1.83 1.83 0 01-1.69-.9L193.55 67.56a9 9 0 00-6.66-3.56H160l73 161a2.35 2.35 0 01-2.26 3.35l-121.69 1.8a8.06 8.06 0 01-6.6-3.1l-37-45c-3-3.9-8.62-6-13.51-6H33.08c-1.29 0-1.1 1.21-.75 2.43l19.84 71.42a16.3 16.3 0 010 11.9L32.31 333c-.59 1.95-.52 3 1.77 3H52c8.14 0 9.25-1.06 13.41-6.3l37.7-45.7a8.19 8.19 0 016.6-3.1l120.68 2.7a2.7 2.7 0 012.43 3.74L160 448h26.64a9 9 0 006.65-3.55L323.14 287c.39-.6 2-.9 2.69-.9l63.9 1.7c3.3.2 14.59.3 18 .3C452 288.1 480 275.93 480 256s-27.88-32-72.28-32z"
                }
            }
        ]
    })(props);
}
function IoAirplaneSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.72 208c-2.72 0-14.44.08-18.67.31l-57.77 1.52L198.06 48h-62.81l74.59 164.61-97.31 1.44L68.25 160H16.14l20.61 94.18c.15.54.33 1.07.53 1.59a.26.26 0 010 .15 15.42 15.42 0 00-.53 1.58L15.86 352h51.78l45.45-55 96.77 2.17L135.24 464h63l133-161.75 57.77 1.54c4.29.23 16 .31 18.66.31 24.35 0 44.27-3.34 59.21-9.94C492.22 283 496 265.46 496 256c0-30.06-33-48-88.28-48zm-71.29 87.9z"
                }
            }
        ]
    })(props);
}
function IoAirplane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.62 464H160a16 16 0 01-14.57-22.6l64.46-142.25L113.1 297l-35.3 42.77C71.07 348.23 65.7 352 52 352H34.08a17.66 17.66 0 01-14.7-7.06c-2.38-3.21-4.72-8.65-2.44-16.41l19.82-71c.15-.53.33-1.06.53-1.58a.38.38 0 000-.15 14.82 14.82 0 01-.53-1.59l-19.84-71.45c-2.15-7.61.2-12.93 2.56-16.06a16.83 16.83 0 0113.6-6.7H52c10.23 0 20.16 4.59 26 12l34.57 42.05 97.32-1.44-64.44-142A16 16 0 01160 48h26.91a25 25 0 0119.35 9.8l125.05 152 57.77-1.52c4.23-.23 15.95-.31 18.66-.31C463 208 496 225.94 496 256c0 9.46-3.78 27-29.07 38.16-14.93 6.6-34.85 9.94-59.21 9.94-2.68 0-14.37-.08-18.66-.31l-57.76-1.54-125.36 152a25 25 0 01-19.32 9.75z"
                }
            }
        ]
    })(props);
}
function IoAlarmOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M416.07 272a160 160 0 10-160 160 160 160 0 00160-160zM142.12 91.21A46.67 46.67 0 00112 80l-2.79.08C83.66 81.62 64 104 64.07 131c0 13.21 4.66 19.37 10.88 27.23a4.55 4.55 0 003.24 1.77h.88a3.23 3.23 0 002.54-1.31L142.38 99a5.38 5.38 0 001.55-4 5.26 5.26 0 00-1.81-3.79zm227.76 0A46.67 46.67 0 01400 80l2.79.08C428.34 81.62 448 104 447.93 131c0 13.21-4.66 19.37-10.88 27.23a4.55 4.55 0 01-3.24 1.76h-.88a3.23 3.23 0 01-2.54-1.31L369.62 99a5.38 5.38 0 01-1.55-4 5.26 5.26 0 011.81-3.79z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256.07 160v112h-80m240 160l-40-40m-280 40l40-40"
                }
            }
        ]
    })(props);
}
function IoAlarmSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M403.79 64.11l-3.27-.1H400c-14.73 0-28.55 5.91-40.52 15S344 96 344 96l88 86s11.25-5.71 17.61-13.85 14.28-18.08 14.32-37.11c.07-35.49-26.33-64.89-60.14-66.93zm-295.58 0l3.27-.1h.52c14.73 0 28.55 5.91 40.52 15S168 96 168 96l-88 86s-11.25-5.71-17.61-13.85S48.11 150.07 48.07 131C48 95.55 74.4 66.15 108.21 64.11z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M391.3 384.6a.06.06 0 010-.08C425 344 441 288.24 427 229.23c-13.64-57.52-72.67-115.69-130.34-128.66C182 74.79 80.07 161.71 80.07 272a175.15 175.15 0 0040.78 112.52.06.06 0 010 .08L73 432a.06.06 0 000 .08l23 22.51a.06.06 0 00.08 0l47.43-47.37a.06.06 0 01.08 0 175.64 175.64 0 00225.05 0h.07L416 454.59a.06.06 0 00.08 0L440 432zM272.07 288H160v-31.9l.05-.05h80V144h32z"
                }
            }
        ]
    })(props);
}
function IoAlarm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M153.59 110.46A21.41 21.41 0 00152.48 79 62.67 62.67 0 00112 64l-3.27.09h-.48C74.4 66.15 48 95.55 48.07 131c0 19 8 29.06 14.32 37.11a20.61 20.61 0 0014.7 7.8c.26 0 .7.05 2 .05a19.06 19.06 0 0013.75-5.89zm250.2-46.35l-3.27-.1H400a62.67 62.67 0 00-40.52 15 21.41 21.41 0 00-1.11 31.44l60.77 59.65a19.06 19.06 0 0013.79 5.9c1.28 0 1.72 0 2-.05a20.61 20.61 0 0014.69-7.8c6.36-8.05 14.28-18.08 14.32-37.11.06-35.49-26.34-64.89-60.15-66.93z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256.07 96c-97 0-176 78.95-176 176a175.23 175.23 0 0040.81 112.56l-36.12 36.13a16 16 0 1022.63 22.62l36.12-36.12a175.63 175.63 0 00225.12 0l36.13 36.12a16 16 0 1022.63-22.62l-36.13-36.13A175.17 175.17 0 00432.07 272c0-97-78.95-176-176-176zm16 176a16 16 0 01-16 16h-80a16 16 0 010-32h64v-96a16 16 0 0132 0z"
                }
            }
        ]
    })(props);
}
function IoAlbumsOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "384",
                    "height": "256",
                    "x": "64",
                    "y": "176",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "28.87",
                    "ry": "28.87"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M144 80h224m-256 48h288"
                }
            }
        ]
    })(props);
}
function IoAlbumsSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 64h256v32H128zm-32 48h320v32H96zm368 336H48V160h416z"
                }
            }
        ]
    })(props);
}
function IoAlbums(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 96H144a16 16 0 010-32h224a16 16 0 010 32zm32 48H112a16 16 0 010-32h288a16 16 0 010 32zm19.13 304H92.87A44.92 44.92 0 0148 403.13V204.87A44.92 44.92 0 0192.87 160h326.26A44.92 44.92 0 01464 204.87v198.26A44.92 44.92 0 01419.13 448z"
                }
            }
        ]
    })(props);
}
function IoAlertCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M250.26 166.05L256 288l5.73-121.95a5.74 5.74 0 00-5.79-6h0a5.74 5.74 0 00-5.68 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 367.91a20 20 0 1120-20 20 20 0 01-20 20z"
                }
            }
        ]
    })(props);
}
function IoAlertCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M240 304h32l6-160h-44l6 160z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm20 319.91h-40v-40h40zM272 304h-32l-6-160h44z"
                }
            }
        ]
    })(props);
}
function IoAlertCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm0 319.91a20 20 0 1120-20 20 20 0 01-20 20zm21.72-201.15l-5.74 122a16 16 0 01-32 0l-5.74-121.94v-.05a21.74 21.74 0 1143.44 0z"
                }
            }
        ]
    })(props);
}
function IoAlertOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 80c-8.66 0-16.58 7.36-16 16l8 216a8 8 0 008 8h0a8 8 0 008-8l8-216c.58-8.64-7.34-16-16-16z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "416",
                    "r": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function IoAlertSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M240 80l8 240h16l8-240h-32zm0 320h32v32h-32z"
                }
            }
        ]
    })(props);
}
function IoAlert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 80c-8.66 0-16.58 7.36-16 16l8 216a8 8 0 008 8h0a8 8 0 008-8l8-216c.58-8.64-7.34-16-16-16z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "416",
                    "r": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function IoAmericanFootballOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "267.57",
                    "ry": "173.44",
                    "transform": "rotate(-45 256 256.002)"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M334.04 177.96L177.96 334.04M278.3 278.3l-44.6-44.6m89.19 0l-44.59-44.59m178.38 22.29L300.6 55.32m-89.2 401.36L55.32 300.6m178.38 22.29l-44.59-44.59"
                }
            }
        ]
    })(props);
}
function IoAmericanFootballSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120.9 120.51c-44.75 44.56-67.29 101.05-78.64 145.9l202.31 201.44c45.05-11.3 101.78-33.74 146.53-78.3s67.29-101.05 78.64-145.91L267.43 42.21C222.38 53.51 165.65 76 120.9 120.51zm259 257.83zm-45-224.2l22.52 22.42-33.78 33.63 22.52 22.42L323.55 255 301 232.61 278.52 255 301 277.45l-22.51 22.42L256 277.45l-22.52 22.42L256 322.29l-22.52 22.42L211 322.29l-33.78 33.63-22.55-22.42 33.78-33.63-22.52-22.42L188.45 255 211 277.45 233.48 255 211 232.61l22.51-22.42L256 232.61l22.52-22.42L256 187.77l22.52-22.42L301 187.77zm143.58 44.27C485.85 143.65 464 48.05 464 48.05s-96.14-21.88-151.14-14.54c-2.54.33-5.21.72-8 1.14l172.47 171.71c.43-2.76.81-5.42 1.15-7.95zM33.52 311.65C26.15 366.41 48.05 464 48.05 464s60 16 99.86 16a391.92 391.92 0 0051.23-3.45c2.54-.33 5.21-.72 8-1.15L34.67 303.7c-.43 2.76-.81 5.42-1.15 7.95z"
                }
            }
        ]
    })(props);
}
function IoAmericanFootball(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M122.06 122.06c-44.37 44.37-66.71 100.61-78 145.28l200.6 200.56c44.67-11.25 100.91-33.59 145.28-78s66.71-100.61 78-145.28L267.34 44.1c-44.67 11.25-100.91 33.59-145.28 77.96zm256.73 256.72zM300.65 189L323 166.71A15.78 15.78 0 01345.29 189L323 211.35l11.16 11.17a15.78 15.78 0 01-22.32 22.32l-11.16-11.16L278.32 256l11.16 11.16a15.78 15.78 0 11-22.32 22.32L256 278.32l-22.32 22.33 11.16 11.16a15.78 15.78 0 11-22.32 22.32L211.35 323 189 345.29A15.78 15.78 0 01166.71 323L189 300.65l-11.16-11.17a15.78 15.78 0 0122.32-22.32l11.16 11.16L233.68 256l-11.16-11.16a15.78 15.78 0 1122.32-22.32L256 233.68l22.32-22.33-11.16-11.16a15.78 15.78 0 0122.32-22.32zm175.92 10.63c7.31-54.53 4-120.26-20-144.21s-89.68-27.3-144.21-20c-2.51.34-5.16.72-7.91 1.15l171 171c.4-2.78.78-5.43 1.12-7.94zM35.43 312.37c-7.31 54.53-4 120.26 20 144.21C72.17 473.33 109.34 480 148.84 480a387 387 0 0050.79-3.43c2.51-.34 5.16-.72 7.91-1.15l-171-171c-.39 2.79-.77 5.44-1.11 7.95z"
                }
            }
        ]
    })(props);
}
function IoAnalyticsOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M344 280l88-88m-200 24l64 64M80 320l104-104"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "456",
                    "cy": "168",
                    "r": "24",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "320",
                    "cy": "304",
                    "r": "24",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "208",
                    "cy": "192",
                    "r": "24",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "56",
                    "cy": "344",
                    "r": "24",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function IoAnalyticsSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M450 128a46 46 0 00-44.11 59l-71.37 71.36a45.88 45.88 0 00-29 0l-52.91-52.91a46 46 0 10-89.12 0L75 293.88A46.08 46.08 0 10106.11 325l87.37-87.36a45.85 45.85 0 0029 0l52.92 52.92a46 46 0 1089.12 0L437 218.12A46 46 0 10450 128z"
                }
            }
        ]
    })(props);
}
function IoAnalytics(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M456 128a40 40 0 00-37.23 54.6l-84.17 84.17a39.86 39.86 0 00-29.2 0l-60.17-60.17a40 40 0 10-74.46 0L70.6 306.77a40 40 0 1022.63 22.63L193.4 229.23a39.86 39.86 0 0029.2 0l60.17 60.17a40 40 0 1074.46 0l84.17-84.17A40 40 0 10456 128z"
                }
            }
        ]
    })(props);
}
function IoApertureOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M360 94.59V296m83.13-83.13L296 360m121.41 0H216m83.13 83.13l-144-144M152 416V216m-83.13 83.13l144-144M94.59 152H288m-75.13-83.13L360 216"
                }
            }
        ]
    })(props);
}
function IoApertureSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 48l129.49 128.18V48H216zm-34.53 10.38L80 134h176l-74.53-75.62zM336 344h128V216L336 344zm118-162L378 80v176l76-74zM48 166v128l128-128H48zm282 288l102-76H256l74 76zM58 330l76 102V256l-76 74zm287.49-107.88l-55.55-55.46h-67.88l-55.55 55.46v67.76l55.62 55.52c.44 0 .88-.06 1.33-.06h66.48l55.55-55.46zM165.98 336.09L166 464h128L165.98 336.09z"
                }
            }
        ]
    })(props);
}
function IoAperture(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M250.54 129.17l-67.8-67.8A209.65 209.65 0 0086.32 136h161.4a4 4 0 002.82-6.83zM167.72 168H67.63a207.34 207.34 0 00-16.15 125.9l119.06-119.07a4 4 0 00-2.82-6.83zm176.28-.28V67.56a207.82 207.82 0 00-125.89-16.08l119.06 119.06a4 4 0 006.83-2.82zm116.52 50.38L341.46 337.17a4 4 0 002.82 6.83h100.09a207.34 207.34 0 0016.15-125.9zm-77.69 32.44l67.83-67.82A209.08 209.08 0 00376 86.2v161.52a4 4 0 006.83 2.82zm-161.15 91.23a8 8 0 005.54 2.23h59.66a8 8 0 005.7-2.39l49.18-50a8 8 0 002.3-5.62l-.06-60.81a8 8 0 00-2.38-5.69l-50-49.25a8 8 0 00-5.63-2.3l-60.84.06a8 8 0 00-5.69 2.38l-49.25 50a8 8 0 00-2.3 5.63l.06 60.78a8 8 0 002.45 5.76zm39.78 41.06l67.8 67.8A209.65 209.65 0 00425.68 376h-161.4a4 4 0 00-2.82 6.83zM168 344.28v100.16a207.82 207.82 0 00125.89 16.08L174.83 341.46a4 4 0 00-6.83 2.82zm-38.83-82.82l-67.83 67.83A209.1 209.1 0 00136 425.8V264.28a4 4 0 00-6.83-2.82z"
                }
            }
        ]
    })(props);
}
function IoAppsOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "64",
                    "y": "64",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "40",
                    "ry": "40"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "216",
                    "y": "64",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "40",
                    "ry": "40"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "368",
                    "y": "64",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "40",
                    "ry": "40"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "64",
                    "y": "216",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "40",
                    "ry": "40"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "216",
                    "y": "216",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "40",
                    "ry": "40"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "368",
                    "y": "216",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "40",
                    "ry": "40"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "64",
                    "y": "368",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "40",
                    "ry": "40"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "216",
                    "y": "368",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "40",
                    "ry": "40"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "368",
                    "y": "368",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "40",
                    "ry": "40"
                }
            }
        ]
    })(props);
}
function IoAppsSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "112",
                    "height": "112",
                    "x": "48",
                    "y": "48",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "112",
                    "height": "112",
                    "x": "200",
                    "y": "48",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "112",
                    "height": "112",
                    "x": "352",
                    "y": "48",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "112",
                    "height": "112",
                    "x": "48",
                    "y": "200",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "112",
                    "height": "112",
                    "x": "200",
                    "y": "200",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "112",
                    "height": "112",
                    "x": "352",
                    "y": "200",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "112",
                    "height": "112",
                    "x": "48",
                    "y": "352",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "112",
                    "height": "112",
                    "x": "200",
                    "y": "352",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "112",
                    "height": "112",
                    "x": "352",
                    "y": "352",
                    "rx": "8",
                    "ry": "8"
                }
            }
        ]
    })(props);
}
function IoApps(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104 160a56 56 0 1156-56 56.06 56.06 0 01-56 56zm152 0a56 56 0 1156-56 56.06 56.06 0 01-56 56zm152 0a56 56 0 1156-56 56.06 56.06 0 01-56 56zM104 312a56 56 0 1156-56 56.06 56.06 0 01-56 56zm152 0a56 56 0 1156-56 56.06 56.06 0 01-56 56zm152 0a56 56 0 1156-56 56.06 56.06 0 01-56 56zM104 464a56 56 0 1156-56 56.06 56.06 0 01-56 56zm152 0a56 56 0 1156-56 56.06 56.06 0 01-56 56zm152 0a56 56 0 1156-56 56.06 56.06 0 01-56 56z"
                }
            }
        ]
    })(props);
}
function IoArchiveOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M80 152v256a40.12 40.12 0 0040 40h272a40.12 40.12 0 0040-40V152"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "416",
                    "height": "80",
                    "x": "48",
                    "y": "64",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "28",
                    "ry": "28"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 304l-64 64-64-64m64 41.89V224"
                }
            }
        ]
    })(props);
}
function IoArchiveSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "448",
                    "height": "80",
                    "x": "32",
                    "y": "48",
                    "rx": "12",
                    "ry": "12"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M64 160v280a24 24 0 0024 24h336a24 24 0 0024-24V160zm192 230.63L169.32 304 192 281.32l48 48.05V208h32v121.37l48.07-48.07 22.61 22.64z"
                }
            }
        ]
    })(props);
}
function IoArchive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 164v244a56 56 0 0056 56h272a56 56 0 0056-56V164a4 4 0 00-4-4H68a4 4 0 00-4 4zm267 151.63l-63.69 63.68a16 16 0 01-22.62 0L181 315.63c-6.09-6.09-6.65-16-.85-22.38a16 16 0 0123.16-.56L240 329.37V224.45c0-8.61 6.62-16 15.23-16.43A16 16 0 01272 224v105.37l36.69-36.68a16 16 0 0123.16.56c5.8 6.37 5.24 16.29-.85 22.38z"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "448",
                    "height": "80",
                    "x": "32",
                    "y": "48",
                    "rx": "32",
                    "ry": "32"
                }
            }
        ]
    })(props);
}
function IoArrowBackCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M249.38 336L170 256l79.38-80m-68.35 80H342"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            }
        ]
    })(props);
}
function IoArrowBackCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 256c0 114.87 93.13 208 208 208s208-93.13 208-208S370.87 48 256 48 48 141.13 48 256zm224-80.09L208.42 240H358v32H208.42L272 336.09l-22.7 22.54L147.46 256 249.3 153.37z"
                }
            }
        ]
    })(props);
}
function IoArrowBackCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 256c0 114.87 93.13 208 208 208s208-93.13 208-208S370.87 48 256 48 48 141.13 48 256zm212.65-91.36a16 16 0 01.09 22.63L208.42 240H342a16 16 0 010 32H208.42l52.32 52.73A16 16 0 11238 347.27l-79.39-80a16 16 0 010-22.54l79.39-80a16 16 0 0122.65-.09z"
                }
            }
        ]
    })(props);
}
function IoArrowBackOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M244 400L100 256l144-144M120 256h292"
                }
            }
        ]
    })(props);
}
function IoArrowBackSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "48",
                    "d": "M244 400L100 256l144-144M120 256h292"
                }
            }
        ]
    })(props);
}
function IoArrowBack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M244 400L100 256l144-144M120 256h292"
                }
            }
        ]
    })(props);
}
function IoArrowDownCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M176 262.62L256 342l80-79.38m-80 68.35V170"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z"
                }
            }
        ]
    })(props);
}
function IoArrowDownCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 464c114.87 0 208-93.13 208-208S370.87 48 256 48 48 141.13 48 256s93.13 208 208 208zm-80.09-224L240 303.58V154h32v149.58L336.09 240l22.54 22.71L256 364.54 153.37 262.7z"
                }
            }
        ]
    })(props);
}
function IoArrowDownCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 464c114.87 0 208-93.13 208-208S370.87 48 256 48 48 141.13 48 256s93.13 208 208 208zm-91.36-212.65a16 16 0 0122.63-.09L240 303.58V170a16 16 0 0132 0v133.58l52.73-52.32A16 16 0 11347.27 274l-80 79.39a16 16 0 01-22.54 0l-80-79.39a16 16 0 01-.09-22.65z"
                }
            }
        ]
    })(props);
}
function IoArrowDownOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M112 268l144 144 144-144M256 392V100"
                }
            }
        ]
    })(props);
}
function IoArrowDownSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "48",
                    "d": "M112 268l144 144 144-144M256 392V100"
                }
            }
        ]
    })(props);
}
function IoArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M112 268l144 144 144-144M256 392V100"
                }
            }
        ]
    })(props);
}
function IoArrowForwardCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M262.62 336L342 256l-79.38-80m68.35 80H170"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 448c106 0 192-86 192-192S362 64 256 64 64 150 64 256s86 192 192 192z"
                }
            }
        ]
    })(props);
}
function IoArrowForwardCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256c0-114.87-93.13-208-208-208S48 141.13 48 256s93.13 208 208 208 208-93.13 208-208zm-224 80.09L303.58 272H154v-32h149.58L240 175.91l22.71-22.54L364.54 256 262.7 358.63z"
                }
            }
        ]
    })(props);
}
function IoArrowForwardCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256c0-114.87-93.13-208-208-208S48 141.13 48 256s93.13 208 208 208 208-93.13 208-208zm-212.65 91.36a16 16 0 01-.09-22.63L303.58 272H170a16 16 0 010-32h133.58l-52.32-52.73A16 16 0 11274 164.73l79.39 80a16 16 0 010 22.54l-79.39 80a16 16 0 01-22.65.09z"
                }
            }
        ]
    })(props);
}
function IoArrowForwardOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M268 112l144 144-144 144m124-144H100"
                }
            }
        ]
    })(props);
}
function IoArrowForwardSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "48",
                    "d": "M268 112l144 144-144 144m124-144H100"
                }
            }
        ]
    })(props);
}
function IoArrowForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M268 112l144 144-144 144m124-144H100"
                }
            }
        ]
    })(props);
}
function IoArrowRedoCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M266.91 327.74v-37.32c-57.07 0-84.51 13.47-108.58 38.68-5.4 5.65-15 1.32-14.29-6.43 5.45-61.45 34.14-117.09 122.87-117.09v-37.32a8.32 8.32 0 0114-6L365.42 242a8.2 8.2 0 010 11.94L281 333.71a8.32 8.32 0 01-14.09-5.97z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M64 256c0 106 86 192 192 192s192-86 192-192S362 64 256 64 64 150 64 256z"
                }
            }
        ]
    })(props);
}
function IoArrowRedoCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 256c0 114.87 93.13 208 208 208s208-93.13 208-208S370.87 48 256 48 48 141.13 48 256zm98 88c0-68.13 22.67-137.14 119.17-137.14V152L366 248l-100.83 96v-54.86c-66.69 0-91.32 19.29-119.17 54.86z"
                }
            }
        ]
    })(props);
}
function IoArrowRedoCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 256c0 114.87 93.13 208 208 208s208-93.13 208-208S370.87 48 256 48 48 141.13 48 256zm96 66.67c5.45-61.45 34.14-117.09 122.87-117.09v-37.32a8.32 8.32 0 0114-6L365.42 242a8.2 8.2 0 010 11.94L281 333.71a8.32 8.32 0 01-14-6v-37.29c-57.07 0-84.51 13.47-108.58 38.68-5.49 5.65-15.07 1.32-14.42-6.43z"
                }
            }
        ]
    })(props);
}
function IoArrowRedoOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M448 256L272 88v96C103.57 184 64 304.77 64 424c48.61-62.24 91.6-96 208-96v96z"
                }
            }
        ]
    })(props);
}
function IoArrowRedoSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 399.26C48 335.19 62.44 284 90.91 247c34.38-44.67 88.68-68.77 161.56-71.75V72L464 252 252.47 432V329.35c-44.25 1.19-77.66 7.58-104.27 19.84-28.75 13.25-49.6 33.05-72.08 58.7L48 440z"
                }
            }
        ]
    })(props);
}
function IoArrowRedo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M58.79 439.13A16 16 0 0148 424c0-73.1 14.68-131.56 43.65-173.77 35-51 90.21-78.46 164.35-81.87V88a16 16 0 0127.05-11.57l176 168a16 16 0 010 23.14l-176 168A16 16 0 01256 424v-79.77c-45 1.36-79 8.65-106.07 22.64-29.25 15.12-50.46 37.71-73.32 67a16 16 0 01-17.82 5.28z"
                }
            }
        ]
    })(props);
}
function IoArrowUndoCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M245.09 327.74v-37.32c57.07 0 84.51 13.47 108.58 38.68 5.4 5.65 15 1.32 14.29-6.43-5.45-61.45-34.14-117.09-122.87-117.09v-37.32a8.32 8.32 0 00-14.05-6L146.58 242a8.2 8.2 0 000 11.94L231 333.71a8.32 8.32 0 0014.09-5.97z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z"
                }
            }
        ]
    })(props);
}
function IoArrowUndoCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm-9.17 241.14V344L146 248l100.83-96v54.86c96.5 0 119.17 69 119.17 137.14-27.85-35.57-52.48-54.86-119.17-54.86z"
                }
            }
        ]
    })(props);
}
function IoArrowUndoCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm97.67 281.1c-24.07-25.21-51.51-38.68-108.58-38.68v37.32a8.32 8.32 0 01-14.05 6L146.58 254a8.2 8.2 0 010-11.94L231 162.29a8.32 8.32 0 0114.05 6v37.32c88.73 0 117.42 55.64 122.87 117.09.73 7.72-8.85 12.05-14.25 6.4z"
                }
            }
        ]
    })(props);
}
function IoArrowUndoOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M240 424v-96c116.4 0 159.39 33.76 208 96 0-119.23-39.57-240-208-240V88L64 256z"
                }
            }
        ]
    })(props);
}
function IoArrowUndoSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 440l-28.12-32.11c-22.48-25.65-43.33-45.45-72.08-58.7-26.61-12.26-60-18.65-104.27-19.84V432L48 252 259.53 72v103.21c72.88 3 127.18 27.08 161.56 71.75C449.56 284 464 335.19 464 399.26z"
                }
            }
        ]
    })(props);
}
function IoArrowUndo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 440a16 16 0 01-12.61-6.15c-22.86-29.27-44.07-51.86-73.32-67C335 352.88 301 345.59 256 344.23V424a16 16 0 01-27 11.57l-176-168a16 16 0 010-23.14l176-168A16 16 0 01256 88v80.36c74.14 3.41 129.38 30.91 164.35 81.87C449.32 292.44 464 350.9 464 424a16 16 0 01-16 16z"
                }
            }
        ]
    })(props);
}
function IoArrowUpCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M176 249.38L256 170l80 79.38m-80-68.35V342"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            }
        ]
    })(props);
}
function IoArrowUpCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm80.09 224L272 208.42V358h-32V208.42L175.91 272l-22.54-22.7L256 147.46 358.63 249.3z"
                }
            }
        ]
    })(props);
}
function IoArrowUpCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm91.36 212.65a16 16 0 01-22.63.09L272 208.42V342a16 16 0 01-32 0V208.42l-52.73 52.32A16 16 0 11164.73 238l80-79.39a16 16 0 0122.54 0l80 79.39a16 16 0 01.09 22.65z"
                }
            }
        ]
    })(props);
}
function IoArrowUpOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M112 244l144-144 144 144M256 120v292"
                }
            }
        ]
    })(props);
}
function IoArrowUpSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "48",
                    "d": "M112 244l144-144 144 144M256 120v292"
                }
            }
        ]
    })(props);
}
function IoArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M112 244l144-144 144 144M256 120v292"
                }
            }
        ]
    })(props);
}
function IoAtCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448.08 256.08c0-106-86-192-192-192s-192 86-192 192 86 192 192 192 192-85.97 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "28",
                    "d": "M300.81 358.29c-20.83 7.42-34.05 9.59-54.19 9.59-61.17 0-106.39-50.07-101-111.84S205 144.21 266.14 144.21c68.92 0 106.79 45.55 101.47 106.55-4 45.54-32.8 58.66-47.89 56-14.2-2.55-25.92-15.52-23.75-40.35l5.62-44.66c-7.58-9.17-28.11-18-49.93-14.54C231.77 210.3 209 228 206.56 256s14.49 50.84 39.93 50.84 47.86-18.39 50.69-50.84"
                }
            }
        ]
    })(props);
}
function IoAtCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.41 48.74c-114.85 0-208 93.11-208 208s93.12 208 208 208 208-93.12 208-208-93.16-208-208-208zM381.22 252c-2.85 32.63-16.78 49.7-28 58.26s-24.69 12.34-36.33 10.26a41.63 41.63 0 01-27-17.52 60.84 60.84 0 01-43.72 17.9 51.65 51.65 0 01-38.55-16.83c-11.39-12.42-17-30.36-15.33-49.23 3.05-35 30.92-57.39 56.87-61.48 27.21-4.29 52.24 6.54 62.91 19.46l3.84 4.66-6.34 50.38c-1.19 14.34 3.29 23.48 12.29 25.1 2.39.42 8.11-.13 14.38-4.93 6.72-5.15 15.14-16 17.1-38.47 2.32-26.55-4.35-49.19-19.28-65.49-15.5-16.9-39.1-25.84-68.24-25.84-54 0-101.81 44.43-106.57 99-2.29 26.2 5.66 50.68 22.39 68.93C198 344 221 353.88 246.29 353.88c19 0 30.61-2.05 49.49-8.78l13.22-4.69 9.39 26.37-13.19 4.7c-21.82 7.77-36.68 10.4-58.88 10.4-33.28 0-63.57-13.06-85.3-36.77-22.09-24.11-32.62-56.17-29.65-90.29 2.91-33.33 18.46-64.63 43.77-88.12s57.57-36.49 90.7-36.49c37.2 0 67.94 12.08 88.88 34.93 20.05 21.91 29.48 52.75 26.5 86.86z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M253.51 221c-14.83 2.33-31.55 15.84-33.34 36.26-1 11.06 2 21.22 8.08 27.87a23.63 23.63 0 0017.91 7.75c19.7 0 33.8-14.79 36.8-38.59l1.75-13.89h.09l1.65-13.11a49.63 49.63 0 00-32.94-6.3z"
                }
            }
        ]
    })(props);
}
function IoAtCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.46 48.74c-114.84 0-208 93.11-208 208s93.12 208 208 208 208-93.12 208-208-93.15-208-208-208zM380.28 252c-2.85 32.63-16.79 49.7-28 58.26S327.61 322.58 316 320.5a41.61 41.61 0 01-26.82-17.19 62.06 62.06 0 01-44 17.57 51.66 51.66 0 01-38.55-16.83c-11.38-12.42-17-30.36-15.32-49.23 3-35 30.91-57.39 56.87-61.48 27.2-4.29 52.23 6.54 62.9 19.46l3.85 4.66-6.34 50.38c-1.19 14.34 3.28 23.48 12.29 25.1 2.39.42 8.1-.13 14.37-4.93 6.72-5.15 15.14-16 17.1-38.47 2.35-26.54-4.35-49.19-19.25-65.49-15.49-16.9-39.09-25.84-68.23-25.84-54 0-101.81 44.43-106.58 99-2.28 26.2 5.67 50.68 22.4 68.93 16.36 17.86 39.31 27.74 64.66 27.74 19 0 30.61-2.05 49.48-8.78a14 14 0 019.4 26.38c-21.82 7.77-36.68 10.4-58.88 10.4-33.28 0-63.57-13.06-85.3-36.77C138 321 127.42 288.94 130.4 254.82c2.91-33.33 18.45-64.63 43.77-88.12s57.57-36.49 90.7-36.49c37.2 0 67.93 12.08 88.87 34.93 20.09 21.91 29.51 52.75 26.54 86.86z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M252.57 221c-14.83 2.33-31.56 15.84-33.34 36.26-1 11.06 2 21.22 8.07 27.87a23.65 23.65 0 0017.91 7.75c20.31 0 34.73-14.94 36.75-38.06a14 14 0 01.34-2.07l3.2-25.45a49.61 49.61 0 00-32.93-6.3z"
                }
            }
        ]
    })(props);
}
function IoAtOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 254.27c-4.5 51-40.12 80-80.55 80s-67.34-35.82-63.45-80 37.12-80 77.55-80 70.33 36 66.45 80z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M319.77 415.77c-28.56 12-47.28 14.5-79.28 14.5-97.2 0-169-78.8-160.49-176s94.31-176 191.51-176C381 78.27 441.19 150 432.73 246c-6.31 71.67-52.11 92.32-76.09 88.07-22.56-4-41.18-24.42-37.74-63.5l8.48-96.25"
                }
            }
        ]
    })(props);
}
function IoAtSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.6 115.78c-32.07-35-79.47-53.51-137.09-53.51-51 0-100.69 19.8-139.82 55.76s-63.13 83.84-67.63 134.83c-4.55 51.67 11.41 100.29 44.94 136.9 33.37 36.44 80.07 56.51 131.49 56.51 32.52 0 53.61-2.36 85.48-15.75l14.75-6.2-12.4-29.5-14.75 6.18c-27.15 11.4-43.78 13.25-73.08 13.25-42.34 0-80.65-16.38-107.89-46.12-27.4-29.92-40.42-69.86-36.66-112.48 7.84-89 86.6-161.4 175.57-161.4 48.4 0 87.65 14.91 113.49 43.13 24.61 26.87 35.6 63.92 31.79 107.15-3.29 37.35-17.76 55.74-29.32 64.6-11 8.44-22 10.18-28 9.11-17.68-3.13-26.87-20.46-24.59-46.29l9.93-109.12L311.9 160l-2 22.29a79.69 79.69 0 00-57.32-24c-23.8 0-46.54 10.07-64 28.37-16.77 17.53-27.23 41.05-29.45 66.22-2.45 27.87 5.75 54.34 22.51 72.64a76.14 76.14 0 0056.88 24.77A93 93 0 00310 318a60 60 0 0042.88 31.81c16.89 3 36.73-2.69 53.08-15.21 30.19-23.13 39.36-60.19 41.74-87.2 4.52-51.7-9.7-98.4-40.1-131.62zm-126.34 186a62.19 62.19 0 01-42.81 16.53 43.94 43.94 0 01-33.28-14.38c-10.71-11.7-15.9-29.27-14.23-48.22 3.23-36.68 30.29-65.4 61.61-65.4a48.16 48.16 0 0135.88 15.82c10.87 11.87 16.2 28.87 14.63 46.73-1.78 20.28-9.33 37.14-21.8 48.88z"
                }
            }
        ]
    })(props);
}
function IoAt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 254.27c-4.5 51-40.12 80-80.55 80s-67.34-35.82-63.45-80 37.12-80 77.55-80 70.33 36 66.45 80z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M319.77 415.77c-28.56 12-47.28 14.5-79.28 14.5-97.2 0-169-78.8-160.49-176s94.31-176 191.51-176C381 78.27 441.19 150 432.73 246c-6.31 71.67-52.11 92.32-76.09 88.07-22.56-4-41.18-24.42-37.74-63.5l8.48-96.25"
                }
            }
        ]
    })(props);
}
function IoAttachOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M216.08 192v143.85a40.08 40.08 0 0080.15 0l.13-188.55a67.94 67.94 0 10-135.87 0v189.82a95.51 95.51 0 10191 0V159.74"
                }
            }
        ]
    })(props);
}
function IoAttachSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M216.08 192v143.55a40.08 40.08 0 0080.15 0l.13-188.55a67.94 67.94 0 10-135.87 0v189.82a95.51 95.51 0 00191 0V159.44"
                }
            }
        ]
    })(props);
}
function IoAttach(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M216.08 192v143.85a40.08 40.08 0 0080.15 0l.13-188.55a67.94 67.94 0 10-135.87 0v189.82a95.51 95.51 0 10191 0V159.74"
                }
            }
        ]
    })(props);
}
function IoBackspaceOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M135.19 390.14a28.79 28.79 0 0021.68 9.86h246.26A29 29 0 00432 371.13V140.87A29 29 0 00403.13 112H156.87a28.84 28.84 0 00-21.67 9.84v0L46.33 256l88.86 134.11z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M336.67 192.33L206.66 322.34m130.01 0L206.66 192.33m130.01 0L206.66 322.34m130.01 0L206.66 192.33"
                }
            }
        ]
    })(props);
}
function IoBackspaceSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 96L32 256l112 160h304V96zm215.3 226.34L336.67 345l-65-65-65 65L184 322.34l65-65-65-65 22.63-22.63 65 65 65-65 22.63 22.63-65 65z"
                }
            }
        ]
    })(props);
}
function IoBackspace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M403.13 96H156.87a44.9 44.9 0 00-33.68 15.27 15.88 15.88 0 00-1.91 2.7L32 247.75a16 16 0 000 16.5l89.15 133.57a16.24 16.24 0 002 2.88 44.89 44.89 0 0033.7 15.3h246.28A44.92 44.92 0 00448 371.13V140.87A44.92 44.92 0 00403.13 96zM348 311a16 16 0 11-22.63 22.62L271.67 280 218 333.65A16 16 0 01195.35 311L249 257.33l-53.69-53.69A16 16 0 01218 181l53.69 53.7 53.67-53.7A16 16 0 01348 203.64l-53.7 53.69z"
                }
            }
        ]
    })(props);
}
function IoBagAddOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 256v128m64-64H192M80 176a16 16 0 00-16 16v216c0 30.24 25.76 56 56 56h272c30.24 0 56-24.51 56-54.75V192a16 16 0 00-16-16zm80 0v-32a96 96 0 0196-96h0a96 96 0 0196 96v32"
                }
            }
        ]
    })(props);
}
function IoBagAddSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M460 160h-88v-12A116.13 116.13 0 00258.89 32h-5.78A116.13 116.13 0 00140 148v12H52a4 4 0 00-4 4v300a16 16 0 0016 16h384a16 16 0 0016-16V164a4 4 0 00-4-4zm-280-11c0-41.84 33.41-76.56 75.25-77A76.08 76.08 0 01332 148v12H180zm156 187h-64v64h-32v-64h-64v-32h64v-64h32v64h64z"
                }
            }
        ]
    })(props);
}
function IoBagAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M454.66 169.4A31.86 31.86 0 00432 160h-64v-16a112 112 0 00-224 0v16H80a32 32 0 00-32 32v216c0 39 33 72 72 72h272a72.22 72.22 0 0050.48-20.55 69.48 69.48 0 0021.52-50.2V192a31.78 31.78 0 00-9.34-22.6zM320 336h-48v48a16 16 0 01-32 0v-48h-48a16 16 0 010-32h48v-48a16 16 0 0132 0v48h48a16 16 0 010 32zm16-176H176v-16a80 80 0 01160 0z"
                }
            }
        ]
    })(props);
}
function IoBagCheckOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 264l-89.6 112-38.4-44.88"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M80 176a16 16 0 00-16 16v216c0 30.24 25.76 56 56 56h272c30.24 0 56-24.51 56-54.75V192a16 16 0 00-16-16zm80 0v-32a96 96 0 0196-96h0a96 96 0 0196 96v32"
                }
            }
        ]
    })(props);
}
function IoBagCheckSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M460 160h-88v-12A116.13 116.13 0 00258.89 32h-5.78A116.13 116.13 0 00140 148v12H52a4 4 0 00-4 4v300a16 16 0 0016 16h384a16 16 0 0016-16V164a4 4 0 00-4-4zm-280-11c0-41.84 33.41-76.56 75.25-77A76.08 76.08 0 01332 148v12H180zm50.81 252.12l-61.37-71.72 24.31-20.81L230 350.91l87.51-109.4 25 20z"
                }
            }
        ]
    })(props);
}
function IoBagCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M454.65 169.4A31.82 31.82 0 00432 160h-64v-16a112 112 0 00-224 0v16H80a32 32 0 00-32 32v216c0 39 33 72 72 72h272a72.22 72.22 0 0050.48-20.55 69.48 69.48 0 0021.52-50.2V192a31.75 31.75 0 00-9.35-22.6zM332.49 274l-89.6 112a16 16 0 01-12.23 6h-.26a16 16 0 01-12.16-5.6l-38.4-44.88a16 16 0 1124.32-20.8L230 350.91 307.51 254a16 16 0 0125 20zM336 160H176v-16a80 80 0 01160 0z"
                }
            }
        ]
    })(props);
}
function IoBagHandleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M80 176a16 16 0 00-16 16v216c0 30.24 25.76 56 56 56h272c30.24 0 56-24.51 56-54.75V192a16 16 0 00-16-16zm80 0v-32a96 96 0 0196-96h0a96 96 0 0196 96v32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 224v16a96 96 0 0096 96h0a96 96 0 0096-96v-16"
                }
            }
        ]
    })(props);
}
function IoBagHandleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M460 160h-88v-12A116.13 116.13 0 00258.89 32h-5.78A116.13 116.13 0 00140 148v12H52a4 4 0 00-4 4v300a16 16 0 0016 16h384a16 16 0 0016-16V164a4 4 0 00-4-4zm-280-11c0-41.84 33.41-76.56 75.25-77A76.08 76.08 0 01332 148v12H180zm188 91a112 112 0 01-224 0v-32h32v32a80 80 0 00160 0v-32h32z"
                }
            }
        ]
    })(props);
}
function IoBagHandle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M454.65 169.4A31.82 31.82 0 00432 160h-64v-16a112 112 0 00-224 0v16H80a32 32 0 00-32 32v216c0 39 33 72 72 72h272a72.22 72.22 0 0050.48-20.55 69.48 69.48 0 0021.52-50.2V192a31.75 31.75 0 00-9.35-22.6zM176 144a80 80 0 01160 0v16H176zm192 96a112 112 0 01-224 0v-16a16 16 0 0132 0v16a80 80 0 00160 0v-16a16 16 0 0132 0z"
                }
            }
        ]
    })(props);
}
function IoBagOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M80 176a16 16 0 00-16 16v216c0 30.24 25.76 56 56 56h272c30.24 0 56-24.51 56-54.75V192a16 16 0 00-16-16zm80 0v-32a96 96 0 0196-96h0a96 96 0 0196 96v32"
                }
            }
        ]
    })(props);
}
function IoBagRemoveOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 320H192M80 176a16 16 0 00-16 16v216c0 30.24 25.76 56 56 56h272c30.24 0 56-24.51 56-54.75V192a16 16 0 00-16-16zm80 0v-32a96 96 0 0196-96h0a96 96 0 0196 96v32"
                }
            }
        ]
    })(props);
}
function IoBagRemoveSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M460 160h-88v-12A116.13 116.13 0 00258.89 32h-5.78A116.13 116.13 0 00140 148v12H52a4 4 0 00-4 4v300a16 16 0 0016 16h384a16 16 0 0016-16V164a4 4 0 00-4-4zm-280-11c0-41.84 33.41-76.56 75.25-77A76.08 76.08 0 01332 148v12H180zm156 187H176v-32h160z"
                }
            }
        ]
    })(props);
}
function IoBagRemove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M454.66 169.4A31.86 31.86 0 00432 160h-64v-16a112 112 0 00-224 0v16H80a32 32 0 00-32 32v216c0 39 33 72 72 72h272a72.22 72.22 0 0050.48-20.55 69.48 69.48 0 0021.52-50.2V192a31.78 31.78 0 00-9.34-22.6zM320 336H192a16 16 0 010-32h128a16 16 0 010 32zm16-176H176v-16a80 80 0 01160 0z"
                }
            }
        ]
    })(props);
}
function IoBagSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372 160v-12A116.13 116.13 0 00258.89 32h-5.78A116.13 116.13 0 00140 148v12H52a4 4 0 00-4 4v300a16 16 0 0016 16h384a16 16 0 0016-16V164a4 4 0 00-4-4zm-40 0H180v-11c0-41.84 33.41-76.56 75.25-77A76.08 76.08 0 01332 148z"
                }
            }
        ]
    })(props);
}
function IoBag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M454.65 169.4A31.82 31.82 0 00432 160h-64v-16a112 112 0 00-224 0v16H80a32 32 0 00-32 32v216c0 39 33 72 72 72h272a72.22 72.22 0 0050.48-20.55 69.48 69.48 0 0021.52-50.2V192a31.75 31.75 0 00-9.35-22.6zM176 144a80 80 0 01160 0v16H176z"
                }
            }
        ]
    })(props);
}
function IoBalloonOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M414.11 153.82C429.66 264.4 345.85 357.09 282.54 366s-169.48-57.5-185-167.68a159.82 159.82 0 11316.53-44.49z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M236.06 308.05c-32.83-13-67.08-43.1-82.27-85.46M367.7 495.78c-32.83-13-63.31-40.06-78.5-82.41"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M266.71 368.21l-9.17 49.61 63.31-8.9-22.49-45.16-31.65 4.45z"
                }
            }
        ]
    })(props);
}
function IoBalloonSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M391 307.27c32.75-46.35 46.59-101.63 39-155.68C416.47 55.59 327.38-11.54 231.38 2S68.24 104.53 81.73 200.53c7.57 53.89 36.12 103.16 80.37 138.74 26.91 21.64 57.59 36.1 86.05 41.33l-8.36 45.23a8 8 0 009 9.38L279 431c15.9 35.87 41.65 60.48 78.41 75l14.88 5.88 11.77-29.75-14.88-5.89c-26.35-10.42-44.48-26.16-57-49.92l21.84-3.07a8 8 0 006.05-11.49l-20.49-41.16c25.98-12.87 51.49-35.18 71.42-63.33zm-160.82 15.66c-41.26-16.32-76.3-52.7-91.45-94.94l-5.4-15.06 30.12-10.8 5.4 15.06c14.5 40.44 47.27 65.77 73.1 76l14.88 5.88-11.77 29.76z"
                }
            }
        ]
    })(props);
}
function IoBalloon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M391 307.27c32.75-46.35 46.59-101.63 39-155.68A175.82 175.82 0 00231.38 2c-96 13.49-163.14 102.58-149.65 198.58 7.57 53.89 36.12 103.16 80.37 138.74 24.58 19.68 52.31 33.5 78.62 39.68a8 8 0 016 9.22l-4.87 26.38a16.29 16.29 0 001.48 10.57 16 16 0 0014.2 8.61 15.21 15.21 0 002.23-.16l17.81-2.5a2 2 0 012.09 1.14c16.72 36.31 45.46 63.85 82.15 78.36a16 16 0 0021-9.65c2.83-8.18-1.64-17.07-9.68-20.28a118.57 118.57 0 01-59.3-51.88 2 2 0 011.45-3l7.4-1a16.54 16.54 0 0010.08-5.23 16 16 0 002.39-17.8l-12.06-24.23a8 8 0 013.26-10.55c23.59-13.17 46.45-34 64.65-59.73zm-154.9 16.78a16 16 0 01-5.88-1.12c-41.26-16.32-76.3-52.7-91.45-94.94a16 16 0 1130.12-10.8c14.5 40.44 47.27 65.77 73.1 76a16 16 0 01-5.89 30.88z"
                }
            }
        ]
    })(props);
}
function IoBanOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "208",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M108.92 108.92l294.16 294.16"
                }
            }
        ]
    })(props);
}
function IoBanSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM432 256a175.09 175.09 0 01-35.8 106.26L149.74 115.8A175.09 175.09 0 01256 80c97.05 0 176 79 176 176zm-352 0a175.09 175.09 0 0135.8-106.26L362.26 396.2A175.09 175.09 0 01256 432c-97 0-176-78.95-176-176z"
                }
            }
        ]
    })(props);
}
function IoBan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "200",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "strokeMiterlimit": "10",
                    "strokeWidth": "48",
                    "d": "M114.58 114.58l282.84 282.84"
                }
            }
        ]
    })(props);
}
function IoBandageOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "560.87",
                    "height": "176.25",
                    "x": "-24.43",
                    "y": "167.88",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "88.12",
                    "ry": "88.12",
                    "transform": "rotate(-45 256 256.002)"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "176",
                    "height": "196",
                    "x": "169.41",
                    "y": "156.59",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "32",
                    "ry": "32",
                    "transform": "rotate(45 257.409 254.582)"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "208",
                    "r": "16"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "304",
                    "cy": "256",
                    "r": "16"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "208",
                    "cy": "256",
                    "r": "16"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "304",
                    "r": "16"
                }
            }
        ]
    })(props);
}
function IoBandageSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M27.71 337.1a40 40 0 000 56.54l90.65 90.65a40 40 0 0056.54 0l75.1-75.1L102.81 262zM496 147.1a39.87 39.87 0 00-11.75-28.38l-91-91a40.14 40.14 0 00-56.75 0L264 100.28 411.72 248l72.53-72.53A39.85 39.85 0 00496 147.1zM273.06 386.19l116-116L241.77 123l-116 116zm19.63-141.5a16 16 0 110 22.62 16 16 0 010-22.62zm-48-48a16 16 0 110 22.62 16 16 0 010-22.62zm0 96a16 16 0 110 22.62 16 16 0 010-22.62zm-25.38-48a16 16 0 11-22.62 0 16 16 0 0122.62 0z"
                }
            }
        ]
    })(props);
}
function IoBandage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M275.8 157a16 16 0 00-22.63 0l-93.34 93.34a16 16 0 000 22.63l79.2 79.2a16 16 0 0022.63 0L355 258.83a16 16 0 000-22.63zM137.21 295.6a47.81 47.81 0 01-9.43-13.38L69 341a72.2 72.2 0 000 102 72.37 72.37 0 00102 0l58.77-58.76a47.81 47.81 0 01-13.38-9.43zM392 48a71.55 71.55 0 00-51 21l-55.92 55.91a48.05 48.05 0 0113.36 9.45l79.19 79.19a48.05 48.05 0 019.45 13.36L443 171a72 72 0 00-51-123z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M275.8 157a16 16 0 00-22.63 0l-93.34 93.34a16 16 0 000 22.63l79.2 79.2a16 16 0 0022.63 0L355 258.83a16 16 0 000-22.63zm-56.49 110.31a16 16 0 110-22.62 16 16 0 010 22.62zm48 48a16 16 0 110-22.62 16 16 0 010 22.62zm0-96a16 16 0 110-22.62 16 16 0 010 22.62zm48 48a16 16 0 110-22.62 16 16 0 010 22.62zm150.3-220.92a104.38 104.38 0 00-147.25 0l-69.76 69.89a4 4 0 004.2 6.58 35.74 35.74 0 0111.69-2.54 47.7 47.7 0 0133.94 14.06l79.19 79.19a47.7 47.7 0 0114.06 33.94 35.68 35.68 0 01-2.54 11.69 4 4 0 006.58 4.2l69.89-69.76a104.38 104.38 0 000-147.25z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M254.34 386.83a47.91 47.91 0 01-33.94-14l-79.19-79.23a47.81 47.81 0 01-9.43-13.38c-4.59-9.7-1.39-25 2.48-36.9a4 4 0 00-6.64-4l-77.23 77.04a104.12 104.12 0 00147.25 147.25l72.75-72.88a4 4 0 00-4.21-6.58c-4.18 1.58-8.4 2.68-11.84 2.68z"
                }
            }
        ]
    })(props);
}
function IoBarChartOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M32 32v432a16 16 0 0016 16h432"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "192",
                    "x": "96",
                    "y": "224",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "20",
                    "ry": "20"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "240",
                    "x": "240",
                    "y": "176",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "20",
                    "ry": "20"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "304",
                    "x": "383.64",
                    "y": "112",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "20",
                    "ry": "20"
                }
            }
        ]
    })(props);
}
function IoBarChartSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 496H16V16h32v448h448v32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M192 432H80V208h112zm144 0H224V160h112zm143.64 0h-112V96h112z"
                }
            }
        ]
    })(props);
}
function IoBarChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 496H48a32 32 0 01-32-32V32a16 16 0 0132 0v432h432a16 16 0 010 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M156 432h-40a36 36 0 01-36-36V244a36 36 0 0136-36h40a36 36 0 0136 36v152a36 36 0 01-36 36zm144 0h-40a36 36 0 01-36-36V196a36 36 0 0136-36h40a36 36 0 0136 36v200a36 36 0 01-36 36zm143.64 0h-40a36 36 0 01-36-36V132a36 36 0 0136-36h40a36 36 0 0136 36v264a36 36 0 01-36 36z"
                }
            }
        ]
    })(props);
}
function IoBarbellOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 256h416"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "32",
                    "height": "256",
                    "x": "384",
                    "y": "128",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "16",
                    "ry": "16"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "32",
                    "height": "256",
                    "x": "96",
                    "y": "128",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "16",
                    "ry": "16"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "16",
                    "height": "128",
                    "x": "32",
                    "y": "192",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "16",
                    "height": "128",
                    "x": "464",
                    "y": "192",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "8",
                    "ry": "8"
                }
            }
        ]
    })(props);
}
function IoBarbellSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 176h-58v-64h-76v122H150V112H74v64H16v160h58v64h76V278h212v122h76v-64h58V176z"
                }
            }
        ]
    })(props);
}
function IoBarbell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M467 176a29.94 29.94 0 00-25.32 12.5 2 2 0 01-3.64-1.14v-36.65c0-20.75-16.34-38.21-37.08-38.7A38 38 0 00362 150v82a2 2 0 01-2 2H152a2 2 0 01-2-2v-81.29c0-20.75-16.34-38.21-37.08-38.7A38 38 0 0074 150v37.38a2 2 0 01-3.64 1.14A29.94 29.94 0 0045 176c-16.3.51-29 14.31-29 30.62v98.72c0 16.31 12.74 30.11 29 30.62a29.94 29.94 0 0025.32-12.5 2 2 0 013.68 1.16v36.67C74 382 90.34 399.5 111.08 400A38 38 0 00150 362v-82a2 2 0 012-2h208a2 2 0 012 2v81.29c0 20.75 16.34 38.21 37.08 38.7A38 38 0 00438 362v-37.38a2 2 0 013.64-1.14A29.94 29.94 0 00467 336c16.3-.51 29-14.31 29-30.62v-98.74c0-16.31-12.74-30.11-29-30.64z"
                }
            }
        ]
    })(props);
}
function IoBarcodeOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M384 400.33l35.13-.33A29 29 0 00448 371.13V140.87A29 29 0 00419.13 112l-35.13.33M128 112l-36.8.33c-15.88 0-27.2 13-27.2 28.87v230.27c0 15.87 11.32 28.86 27.2 28.86L128 400m256-208v128m-64-160v192m-64-176v160m-64-176v192m-64-160v128"
                }
            }
        ]
    })(props);
}
function IoBarcodeSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M400 400.33l48-.33V112l-48 .33M112 112l-48 .33v288l48-.33m272-208v128m-64-160v192m-64-176v160m-64-176v192m-64-160v128"
                }
            }
        ]
    })(props);
}
function IoBarcode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M419.13 96H419l-35.05.33L128 96h-.16l-36.74.33C66.93 96.38 48 116.07 48 141.2v230.27c0 25.15 19 44.86 43.2 44.86h.15l36.71-.33 255.92.33h.17l35.07-.33A44.91 44.91 0 00464 371.13V140.87A44.92 44.92 0 00419.13 96zM144 320a16 16 0 01-32 0V192a16 16 0 0132 0zm64 32a16 16 0 01-32 0V160a16 16 0 0132 0zm64-16a16 16 0 01-32 0V176a16 16 0 0132 0zm64 16a16 16 0 01-32 0V160a16 16 0 0132 0zm64-32a16 16 0 01-32 0V192a16 16 0 0132 0z"
                }
            }
        ]
    })(props);
}
function IoBaseballOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M294.25 108.6l-60.57 17.59m83.45 29.92l-51.5 36.4m90.26 2.36l-36.4 51.5m83.91-28.62l-17.59 60.57"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "192",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M432.94 255.05a192 192 0 01-176.31-180.7M108.54 294.31l17.59-60.57m29.92 83.45l36.4-51.5m2.36 90.26l51.5-36.4m-28.62 83.91l60.57-17.59M255 433.61A192 192 0 0074.29 256.69"
                }
            }
        ]
    })(props);
}
function IoBaseballSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M302.16 56.2a13.88 13.88 0 01-3.42 8.91l-.11 5.13-27.71-.57c0 1.3.09 2.61.16 3.91a177.33 177.33 0 003.45 26.31l24.72-7.18 7.81 26.88-24.71 7.18a177.21 177.21 0 0013.34 27.69l21.27-15 16.16 22.86-21.29 15.05q5.25 6.33 11.11 12.19c3.91 3.91 8 7.6 12.2 11.1l15.71-22.22 22.86 16.16L358 216.75a178.78 178.78 0 0027.68 13.32l7.49-25.8 26.89 7.81-7.5 25.83a177.8 177.8 0 0031 3.67l-.41-24.67 17.41-.29A208 208 0 00301.82 52.93a13.65 13.65 0 01.34 3.27zM214 441.64l27.91.49a177.46 177.46 0 00-3.62-29.95l-24.14 7-7.81-26.88 24.11-7a177.92 177.92 0 00-13.33-27.68L196.79 372l-16.16-22.86L201 334.73c-3.49-4.22-7.19-8.3-11.09-12.2s-8-7.62-12.19-11.12l-13.91 19.68L141 314.93l13.9-19.66a177.26 177.26 0 00-27.7-13.33l-6.37 21.94-26.89-7.81 6.38-22a177.32 177.32 0 00-26.32-3.4c-1.59-.09-3.18-.16-4.78-.2l.4 22.34-17.71.32a207.88 207.88 0 00161.81 166.48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M444.65 302.67l-.55-33.06a206 206 0 01-39.33-4.74L397 291.8l-26.94-7.8 7.83-27a206.91 206.91 0 01-36.06-17.35l-16.36 23.15-22.86-16.16 16.33-23.11a204.21 204.21 0 01-30-30l-22.19 15.67-16.16-22.87 22.17-15.67a206 206 0 01-17.38-36.06l-25.75 7.48-7.81-26.89 25.73-7.47q-2-9.21-3.18-18.64h-.47l-.78-14-.33-6-17.94-.32a13.38 13.38 0 01-1.79-.16l-6.35-.13.06-2.47a14 14 0 01-5.66-11.49 13.27 13.27 0 01.13-1.67A208 208 0 0052.16 217.43l16.1-.28.45 25.18 6.83.38 14 .77v.48q9.42 1.17 18.64 3.18l6.68-23L141.7 232l-6.7 23a205.3 205.3 0 0136.06 17.38l14.53-20.56L208.47 268 194 288.5a203.5 203.5 0 0130 30l21.3-15 16.16 22.86-21.36 15.05a206.86 206.86 0 0117.34 36.06l25.27-7.33 7.81 26.86-25.24 7.33a205.9 205.9 0 014.72 38.3l29.42.53-.29 16.48a207.94 207.94 0 00160-157.21z"
                }
            }
        ]
    })(props);
}
function IoBaseball(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M444 295.67l-.47-26.07a205.42 205.42 0 01-39.27-4.73l-5 17.35a14 14 0 11-26.88-7.81l5-17.38a206.47 206.47 0 01-36.05-17.35l-10.44 14.77a14 14 0 01-22.87-16.16l10.41-14.73a204.8 204.8 0 01-30-30L273.71 204a14 14 0 01-16.16-22.87l14.74-10.42a205.3 205.3 0 01-17.38-36.06l-17.32 5a14 14 0 11-7.81-26.89l17.3-5a205.88 205.88 0 01-4.43-32.59q-.17-3-.24-6l-18.22-.33a14 14 0 01-13.74-14A208 208 0 0055 202.42a16 16 0 0115 15.66l.44 24.43c1.58.05 3.16.11 4.73.2a205.88 205.88 0 0132.59 4.43l5-17.3a14 14 0 0126.89 7.81l-5 17.32a205.21 205.21 0 0136 17.38L181 257.61a14 14 0 0122.87 16.16l-10.39 14.73a205.65 205.65 0 0115.79 14.23 203.79 203.79 0 0114.23 15.79l14.73-10.41A14 14 0 01254.39 331l-14.76 10.43A206.86 206.86 0 01257 377.47l17.38-5.05a14 14 0 017.81 26.89l-17.35 5a205.89 205.89 0 014.7 38.28l18.27.33a16 16 0 0115.71 16.28 11.69 11.69 0 01-.08 1.19 208 208 0 00153.39-151.03A14 14 0 01444 295.67z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M301.49 56.2A14 14 0 01287.5 70h-.25l-16.81-.3c.05 1.31.1 2.62.17 3.93a178.83 178.83 0 003.44 26.31l16.29-4.74a14 14 0 017.81 26.8l-16.27 4.73a178.06 178.06 0 0013.33 27.69l13.84-9.78a14 14 0 1116.16 22.87l-13.86 9.79q5.25 6.33 11.12 12.19c3.9 3.91 8 7.6 12.2 11.1l9.78-13.84A14 14 0 11367.32 203l-9.76 13.8a178.83 178.83 0 0027.68 13.33l4.76-16.28a14 14 0 0126.89 7.81l-4.73 16.26a177.72 177.72 0 0030.95 3.65l-.16-9a14 14 0 0113.75-14.24h.25a14.67 14.67 0 012.59.25 208 208 0 00-158-163.51c-.06.4-.04.76-.05 1.13zm-93.05 401.35a16 16 0 0116.28-15.71l16.76.29a178.49 178.49 0 00-3.62-29.95l-16.26 4.72a14 14 0 11-7.81-26.9l16.21-4.7a177.92 177.92 0 00-13.33-27.68l-13.8 9.76a14 14 0 11-16.16-22.87l13.84-9.78c-3.5-4.22-7.19-8.3-11.1-12.2s-8-7.62-12.19-11.12l-9.79 13.86a14 14 0 11-22.87-16.16l9.78-13.84a177.16 177.16 0 00-27.69-13.33L122 298.21a14 14 0 11-26.9-7.81l4.73-16.29a177.32 177.32 0 00-26.31-3.44c-.89-.05-1.79-.08-2.68-.12l.16 10.59a16 16 0 01-15.71 16.28H55a16 16 0 01-3.94-.51 208 208 0 00157.65 163.87 15.72 15.72 0 01-.27-3.23z"
                }
            }
        ]
    })(props);
}
function IoBasketOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M68.4 192A20.38 20.38 0 0048 212.2a17.87 17.87 0 00.8 5.5L100.5 400a40.46 40.46 0 0039.1 29.5h232.8a40.88 40.88 0 0039.3-29.5l51.7-182.3.6-5.5a20.38 20.38 0 00-20.4-20.2H68.4zm193.32 160.07A42.07 42.07 0 11304 310a42.27 42.27 0 01-42.28 42.07z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 192l96-128 96 128"
                }
            }
        ]
    })(props);
}
function IoBasketSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M339.2 217.6L256 106.67 172.8 217.6l-25.6-19.2 96-128a16 16 0 0125.6 0l96 128z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M441.59 192H70.41a12 12 0 00-11.68 14.77L112.59 434h286.82l53.86-227.23A12 12 0 00441.59 192zM256 351.66A37.71 37.71 0 11293.89 314 37.88 37.88 0 01256 351.66z"
                }
            }
        ]
    })(props);
}
function IoBasket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M424.11 192H360L268.8 70.4a16 16 0 00-25.6 0L152 192H87.89a32.57 32.57 0 00-32.62 32.44 30.3 30.3 0 001.31 9l46.27 163.14a50.72 50.72 0 0048.84 36.91h208.62a51.21 51.21 0 0049-36.86l46.33-163.36a15.62 15.62 0 00.46-2.36l.53-4.93a13.3 13.3 0 00.09-1.55A32.57 32.57 0 00424.11 192zM256 106.67L320 192H192zm0 245a37.7 37.7 0 1137.88-37.7A37.87 37.87 0 01256 351.63z"
                }
            }
        ]
    })(props);
}
function IoBasketballOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "192",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M432.94 255.05a192 192 0 01-176.31-180.7M255 433.61A192 192 0 0074.29 256.69m45.95-136.45l271.52 271.52m-271.52 0l271.52-271.52"
                }
            }
        ]
    })(props);
}
function IoBasketballSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 233.37l34.45-34.45a207.08 207.08 0 01-50.12-135.25c0-5 .19-10.05.54-15A207.09 207.09 0 00120.67 98zm57.14-57.14L391.33 98A207.07 207.07 0 00273 48.8c-.41 4.9-.64 9.86-.64 14.87a175.25 175.25 0 0040.78 112.56zm22.63 22.63a175.25 175.25 0 00112.56 40.81c5 0 10-.23 14.87-.64A207.07 207.07 0 00414 120.67zM176.23 313.14a175.23 175.23 0 00-112.56-40.81q-7.52 0-14.87.64A207.07 207.07 0 0098 391.33zM256 278.63l-34.45 34.45a207.08 207.08 0 0150.12 135.25c0 5-.19 10.05-.54 15A207.06 207.06 0 00391.33 414zm192.33-6.96a207.08 207.08 0 01-135.25-50.12L278.63 256 414 391.33a207.09 207.09 0 0049.39-120.2c-5.01.35-10.02.54-15.06.54zM233.37 256L98 120.67a207.06 207.06 0 00-49.39 120.2c5-.35 10-.54 15-.54a207.08 207.08 0 01135.25 50.12zm-112.7 158A207.07 207.07 0 00239 463.2q.63-7.35.64-14.87a175.23 175.23 0 00-40.81-112.56z"
                }
            }
        ]
    })(props);
}
function IoBasketball(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 233.37l34.45-34.45a207.08 207.08 0 01-50.12-135.25c0-5 .19-10.05.54-15A207.09 207.09 0 00120.67 98zm57.14-57.14L391.33 98A207.07 207.07 0 00273 48.8c-.41 4.9-.64 9.86-.64 14.87a175.25 175.25 0 0040.78 112.56zm22.63 22.63a175.25 175.25 0 00112.56 40.81c5 0 10-.23 14.87-.64A207.07 207.07 0 00414 120.67zM176.23 313.14a175.23 175.23 0 00-112.56-40.81q-7.52 0-14.87.64A207.07 207.07 0 0098 391.33zM256 278.63l-34.45 34.45a207.08 207.08 0 0150.12 135.25c0 5-.19 10.05-.54 15A207.06 207.06 0 00391.33 414zm192.33-6.96a207.08 207.08 0 01-135.25-50.12L278.63 256 414 391.33a207.09 207.09 0 0049.39-120.2c-5.01.35-10.02.54-15.06.54zM233.37 256L98 120.67a207.06 207.06 0 00-49.39 120.2c5-.35 10-.54 15-.54a207.08 207.08 0 01135.25 50.12zm-112.7 158A207.07 207.07 0 00239 463.2q.63-7.35.64-14.87a175.23 175.23 0 00-40.81-112.56z"
                }
            }
        ]
    })(props);
}
function IoBatteryChargingOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 322.3V189.7A29.74 29.74 0 0177.7 160h137.44l24.4-32H77.7A61.77 61.77 0 0016 189.7v132.6A61.77 61.77 0 0077.7 384h96.85a22.57 22.57 0 01.26-7.32l.15-.75.21-.73 6.5-23.2H77.7A29.74 29.74 0 0148 322.3zM386.3 128h-98.64a22.69 22.69 0 01-.27 7.2l-.15.74-.21.73-6.54 23.33H386.3a29.74 29.74 0 0129.7 29.7v132.6a29.74 29.74 0 01-29.7 29.7H247l-24.42 32H386.3a61.77 61.77 0 0061.7-61.7V189.7a61.77 61.77 0 00-61.7-61.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M162.65 294.16a24.37 24.37 0 01-21.56-13 25 25 0 011.42-25.83l.31-.46.33-.44L197.62 183H89.69a20 20 0 00-20 20v106a20 20 0 0020 20h98.42l9.78-34.86z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M276.07 280.89l27.07-35.49a5.2 5.2 0 00.77-1.91 5 5 0 00.08-.66 5 5 0 00-.08-1.29 5.11 5.11 0 00-.68-1.75 4.76 4.76 0 00-.78-.95 3.48 3.48 0 00-.48-.38 4 4 0 00-1.11-.55 4.28 4.28 0 00-1.31-.2h-61.62l12.12-43.21 3.23-11.5 6.21-22.16.51-1.84 7.79-27.76a3.51 3.51 0 00.05-.55v-.16c0-.05 0-.26-.05-.38s0-.09 0-.14a2.2 2.2 0 00-.17-.45 3.77 3.77 0 00-.26-.39l-.09-.1a2.73 2.73 0 00-.25-.23l-.1-.08a3.14 3.14 0 00-.39-.24 2 2 0 00-.41-.14h-.59a2.3 2.3 0 00-.45 0 1.9 1.9 0 00-.42.15l-.13.07-.3.21-.11.1a2.4 2.4 0 00-.36.41l-18 23.63-13.14 17.22-9.85 12.83-63.71 83.55a5.72 5.72 0 00-.44.8 4.78 4.78 0 00-.35 1.09 4.7 4.7 0 00-.08 1.29 4.86 4.86 0 002 3.71 4.74 4.74 0 00.54.31 4.31 4.31 0 001.89.43h61.62L194.42 380.6a3.64 3.64 0 000 .56v.15a2.32 2.32 0 00.06.38.58.58 0 000 .14 2.2 2.2 0 00.17.45 3.62 3.62 0 00.26.38l.09.1.25.24a.39.39 0 01.1.08 2.22 2.22 0 00.39.23 2.83 2.83 0 00.41.14h.13a1.86 1.86 0 00.33 0h.13a2.32 2.32 0 00.45-.06 2.05 2.05 0 00.41-.16l.13-.07.3-.21.11-.09a2.4 2.4 0 00.36-.41L221.82 352l17.53-23z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M319.5 256.93l-.46.6L264.51 329h109.8a20 20 0 0020-20V203a20 20 0 00-20-20H274.05l-9.74 34.73h35.24A24.35 24.35 0 01321 230.5a25.21 25.21 0 01-1 25.79zM480 202.67a16 16 0 00-16 16v74.66a16 16 0 0032 0v-74.66a16 16 0 00-16-16z"
                }
            }
        ]
    })(props);
}
function IoBatteryChargingSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M306.68 237.62h-66.5l15.33-54.7 6.43-22.92 3.94-14 4.29-15.33a3.56 3.56 0 00.06-.44v-.19a1.85 1.85 0 000-.23 2 2 0 000-.24v-.14c0-.1-.07-.19-.11-.29v-.05a2.33 2.33 0 00-2-1.35h-.1a2.25 2.25 0 00-1.8 1l-12.5 17.15-18.82 25.55-8.36 11.48-35.41 48.6L160 274.26h66.44l-30 107a3.93 3.93 0 00-.06.48v.1a1.94 1.94 0 000 .34.29.29 0 000 .09 3 3 0 00.07.32v.06a1.83 1.83 0 00.14.32 2.38 2.38 0 001.52 1.16h.57a2.1 2.1 0 001.31-.5l.06-.05a2.6 2.6 0 00.42-.45L223.3 352l13-17.82z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M289.78 134.55l-.14.74-.21.73-6.72 24H417V352H248.05l-23.33 32H449V128H290.13a22.62 22.62 0 01-.35 6.55zM49 160h169.49l23.31-32H17v256h159.49a22.73 22.73 0 01.34-6.67l.15-.75.2-.73 6.69-23.85H49z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M264.76 329.08h130.55V182.92H276.28l-9.73 34.7H346l-23.16 31.78-58.08 79.68zM160 294.26h-39.31l23.15-31.78 57.95-79.56H70.69v146.16h119.6l9.77-34.82H160zm305-91.59h32v106.67h-32z"
                }
            }
        ]
    })(props);
}
function IoBatteryCharging(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 322.3V189.7A29.74 29.74 0 0177.7 160h137.44l24.4-32H77.7A61.77 61.77 0 0016 189.7v132.6A61.77 61.77 0 0077.7 384h96.85a22.57 22.57 0 01.26-7.32l.15-.75.21-.73 6.5-23.2H77.7A29.74 29.74 0 0148 322.3zM386.3 128h-98.64a22.69 22.69 0 01-.27 7.2l-.15.74-.21.73-6.54 23.33H386.3a29.74 29.74 0 0129.7 29.7v132.6a29.74 29.74 0 01-29.7 29.7H247l-24.42 32H386.3a61.77 61.77 0 0061.7-61.7V189.7a61.77 61.77 0 00-61.7-61.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M162.65 294.16a24.37 24.37 0 01-21.56-13 25 25 0 011.42-25.83l.31-.46.33-.44L197.62 183H89.69a20 20 0 00-20 20v106a20 20 0 0020 20h98.42l9.78-34.86z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M276.07 280.89l27.07-35.49a5.2 5.2 0 00.77-1.91 5 5 0 00.08-.66 5 5 0 00-.08-1.29 5.11 5.11 0 00-.68-1.75 4.76 4.76 0 00-.78-.95 3.48 3.48 0 00-.48-.38 4 4 0 00-1.11-.55 4.28 4.28 0 00-1.31-.2h-61.62l12.12-43.21 3.23-11.5 6.21-22.16.51-1.84 7.79-27.76a3.51 3.51 0 00.05-.55v-.16c0-.05 0-.26-.05-.38s0-.09 0-.14a2.2 2.2 0 00-.17-.45 3.77 3.77 0 00-.26-.39l-.09-.1a2.73 2.73 0 00-.25-.23l-.1-.08a3.14 3.14 0 00-.39-.24 2 2 0 00-.41-.14h-.59a2.3 2.3 0 00-.45 0 1.9 1.9 0 00-.42.15l-.13.07-.3.21-.11.1a2.4 2.4 0 00-.36.41l-18 23.63-13.14 17.22-9.85 12.83-63.71 83.55a5.72 5.72 0 00-.44.8 4.78 4.78 0 00-.35 1.09 4.7 4.7 0 00-.08 1.29 4.86 4.86 0 002 3.71 4.74 4.74 0 00.54.31 4.31 4.31 0 001.89.43h61.62L194.42 380.6a3.64 3.64 0 000 .56v.15a2.32 2.32 0 00.06.38.58.58 0 000 .14 2.2 2.2 0 00.17.45 3.62 3.62 0 00.26.38l.09.1.25.24a.39.39 0 01.1.08 2.22 2.22 0 00.39.23 2.83 2.83 0 00.41.14h.13a1.86 1.86 0 00.33 0h.13a2.32 2.32 0 00.45-.06 2.05 2.05 0 00.41-.16l.13-.07.3-.21.11-.09a2.4 2.4 0 00.36-.41L221.82 352l17.53-23z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M319.5 256.93l-.46.6L264.51 329h109.8a20 20 0 0020-20V203a20 20 0 00-20-20H274.05l-9.74 34.73h35.24A24.35 24.35 0 01321 230.5a25.21 25.21 0 01-1 25.79zM480 202.67a16 16 0 00-16 16v74.66a16 16 0 0032 0v-74.66a16 16 0 00-16-16z"
                }
            }
        ]
    })(props);
}
function IoBatteryDeadOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "400",
                    "height": "224",
                    "x": "31",
                    "y": "144",
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "45.7",
                    "ry": "45.7"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M479 218.67v74.66"
                }
            }
        ]
    })(props);
}
function IoBatteryDeadSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M32 144h400v224H32zm448 74.67v74.66"
                }
            }
        ]
    })(props);
}
function IoBatteryDead(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "400",
                    "height": "224",
                    "x": "31",
                    "y": "144",
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "45.7",
                    "ry": "45.7"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M479 218.67v74.66"
                }
            }
        ]
    })(props);
}
function IoBatteryFullOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "400",
                    "height": "224",
                    "x": "32",
                    "y": "144",
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "45.7",
                    "ry": "45.7"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "292.63",
                    "height": "114.14",
                    "x": "85.69",
                    "y": "198.93",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "4",
                    "ry": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M480 218.67v74.66"
                }
            }
        ]
    })(props);
}
function IoBatteryFullSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 384h432V128H17zm32-224h368v192H49z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M70.69 182.94h324.63v146.13H70.69zM465 202.67h32v106.67h-32z"
                }
            }
        ]
    })(props);
}
function IoBatteryFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "400",
                    "height": "224",
                    "x": "32",
                    "y": "144",
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "45.7",
                    "ry": "45.7"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "292.63",
                    "height": "114.14",
                    "x": "85.69",
                    "y": "198.93",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "4",
                    "ry": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M480 218.67v74.66"
                }
            }
        ]
    })(props);
}
function IoBatteryHalfOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "400",
                    "height": "224",
                    "x": "32",
                    "y": "144",
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "45.7",
                    "ry": "45.7"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "154.31",
                    "height": "114.13",
                    "x": "85.69",
                    "y": "198.93",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "4",
                    "ry": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M480 218.67v74.66"
                }
            }
        ]
    })(props);
}
function IoBatteryHalfSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 384h432V128H17zm32-224h368v192H49z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M70.69 182.92H256v146.16H70.69zM465 202.67h32v106.67h-32z"
                }
            }
        ]
    })(props);
}
function IoBatteryHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "400",
                    "height": "224",
                    "x": "32",
                    "y": "144",
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "45.7",
                    "ry": "45.7"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "154.31",
                    "height": "114.13",
                    "x": "85.69",
                    "y": "198.93",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "4",
                    "ry": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M480 218.67v74.66"
                }
            }
        ]
    })(props);
}
function IoBeakerOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M445.2 48.05L398 48H128c-54.3 0-64 35.7-64 48 30.3 4.2 48 8 48 40v264a64 64 0 0064 64h192a64 64 0 0064-64V96c0-19 11.5-38.35 12.6-40 1.2-1.9 3.4-4.4 3.4-5.5s-.3-2.45-2.8-2.45zM112 176h320"
                }
            }
        ]
    })(props);
}
function IoBeakerSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M453.55 54.7L464 32H128.4c-27.74 0-49 6.57-63.31 19.51C54.39 61.27 48 74.89 48 88v24h16c31 0 32 16.79 32 35v313a20 20 0 0020 20h312a20 20 0 0020-20V96c0-17.16 2.28-34.14 5.55-41.3zM416 96v64H128v-22c0-36.15-21-51-41.77-53.46C89 70 105.7 64.05 128.4 64.05h289.92A221.83 221.83 0 00416 96z"
                }
            }
        ]
    })(props);
}
function IoBeaker(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M444 32H128c-19.38 0-45.9 4.34-64.11 24.77C52.17 69.92 48 85.66 48 96a16 16 0 0013.8 15.85C91.7 116 96 117.79 96 136v264a80.07 80.07 0 0080 80h192a80.11 80.11 0 0080-80V96c0-12.55 7.46-27.25 10-31.36l.1-.14c.22-.35.5-.72.78-1.1 2-2.79 5.09-7 5.09-12.95C464 39.79 454.89 32 444 32zM84.11 83.08c5.24-8.87 17.17-19 44.29-19h294.43C419.3 72.87 416 84.27 416 96v64H128v-24c0-37.32-21.35-48.14-43.89-52.92z"
                }
            }
        ]
    })(props);
}
function IoBedOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M384 240H96V136a40.12 40.12 0 0140-40h240a40.12 40.12 0 0140 40v104zM48 416V304a64.19 64.19 0 0164-64h288a64.19 64.19 0 0164 64v112"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 416v-8a24.07 24.07 0 0124-24h368a24.07 24.07 0 0124 24v8M112 240v-16a32.09 32.09 0 0132-32h80a32.09 32.09 0 0132 32v16m0 0v-16a32.09 32.09 0 0132-32h80a32.09 32.09 0 0132 32v16"
                }
            }
        ]
    })(props);
}
function IoBedSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 224V96a16 16 0 00-16-16H96a16 16 0 00-16 16v128a48 48 0 00-48 48v160h36v-32h376v32h36V272a48 48 0 00-48-48zm-192 0H120v-32a16 16 0 0116-16h88a16 16 0 0116 16zm32-32a16 16 0 0116-16h88a16 16 0 0116 16v32H272z"
                }
            }
        ]
    })(props);
}
function IoBed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 230.7a79.44 79.44 0 00-32-6.7H112a79.51 79.51 0 00-32 6.69A80.09 80.09 0 0032 304v112a16 16 0 0032 0v-8a8.1 8.1 0 018-8h368a8.1 8.1 0 018 8v8a16 16 0 0032 0V304a80.09 80.09 0 00-48-73.3zM376 80H136a56 56 0 00-56 56v72a4 4 0 005.11 3.84A95.5 95.5 0 01112 208h4.23a4 4 0 004-3.55A32 32 0 01152 176h56a32 32 0 0131.8 28.45 4 4 0 004 3.55h24.46a4 4 0 004-3.55A32 32 0 01304 176h56a32 32 0 0131.8 28.45 4 4 0 004 3.55h4.2a95.51 95.51 0 0126.89 3.85A4 4 0 00432 208v-72a56 56 0 00-56-56z"
                }
            }
        ]
    })(props);
}
function IoBeerOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 200v240a40.12 40.12 0 01-40 40H136a40.12 40.12 0 01-40-40V224"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M352 224h40a56.16 56.16 0 0156 56v80a56.16 56.16 0 01-56 56h-40"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M224 256v160m64-160v160M160 256v160m160-304a48 48 0 010 96c-13.25 0-29.31-7.31-38-16H160c-8 22-27 32-48 32a48 48 0 010-96 47.91 47.91 0 0126 9"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M91.86 132.43a40 40 0 1160.46-52S160 91 160 96m-14.17-31.29C163.22 44.89 187.57 32 216 32c52.38 0 94 42.84 94 95.21a95 95 0 01-1.67 17.79"
                }
            }
        ]
    })(props);
}
function IoBeerSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 208h-80v-5.74A63.93 63.93 0 00321.65 96a111 111 0 00-27.59-47.29A108.62 108.62 0 00216 16c-29.91 0-57.78 12.28-79 34.67a56 56 0 00-67.51 77.51c-1 .86-1.91 1.74-2.83 2.66A63.56 63.56 0 0048 176.26a62.65 62.65 0 0020.77 46.54A65 65 0 0080 231v249a16 16 0 0016 16h256a16 16 0 0016-16v-48h80a16 16 0 0016-16V224a16 16 0 00-16-16zM176 432h-32V240h32zm64 0h-32V240h32zm64 0h-32V240h32zm16-240c-8.33 0-20.55-5.18-26.69-11.31l-4.68-4.69H148.79L145 186.53c-5.81 16-18.83 20.41-28.73 21.29a34.08 34.08 0 01-25.91-8.67 31 31 0 01-10.32-23 31.8 31.8 0 019.33-22.71c.16-.17.33-.32.5-.49A31.78 31.78 0 01112 144c.09 0 9.12.34 16.4 5.8l12.8 9.6 19.2-25.6-12.8-9.6A63.69 63.69 0 00112 112a64.79 64.79 0 00-14 1.55 24 24 0 0141.4-23.68l.23.35.4.46a35.78 35.78 0 015 8.94l5.62 15 30-11.24-5.62-15a68.2 68.2 0 00-10-17.74c-.38-.52-.79-1-1.19-1.51C178.38 55.45 196.64 48 216 48a76.86 76.86 0 0155.23 23.18A80.2 80.2 0 01292.61 142l-3 15.72 31.43 6 3-15.72a111.78 111.78 0 001.96-19.43 32 32 0 01-6 63.43zm112 208h-64V240h64z"
                }
            }
        ]
    })(props);
}
function IoBeer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392 208h-24v-5.74A63.93 63.93 0 00321.65 96a111 111 0 00-27.59-47.29A108.62 108.62 0 00216 16c-29.91 0-57.78 12.28-79 34.68a56 56 0 00-67.51 77.54A63.91 63.91 0 0080 231.39V440a56.06 56.06 0 0056 56h176a56.06 56.06 0 0056-56v-8h24a72.08 72.08 0 0072-72v-80a72.08 72.08 0 00-72-72zM176 416a16 16 0 01-32 0V256a16 16 0 0132 0zm64 0a16 16 0 01-32 0V256a16 16 0 0132 0zm64 0a16 16 0 01-32 0V256a16 16 0 0132 0zm16-224c-8.33 0-20.55-5.18-26.69-11.31A16 16 0 00282 176H160a16 16 0 00-15 10.53c-6.83 18.68-23.6 21.47-33 21.47a32 32 0 010-64c.09 0 9.12.34 16.4 5.8a16 16 0 1019.2-25.6A63.69 63.69 0 00112 112a63.55 63.55 0 00-14 1.57A24 24 0 01120 80a23.78 23.78 0 0119.38 9.84 51.35 51.35 0 014.71 7.9A16 16 0 00176 96c0-6.77-3.61-15.17-10.76-25-.46-.63-1-1.25-1.45-1.86C178.39 55.44 196.64 48 216 48a76.86 76.86 0 0155.23 23.18A80.2 80.2 0 01292.61 142a16 16 0 0012.73 18.71 16.29 16.29 0 003 .28 16 16 0 0015.7-13 111.78 111.78 0 001.96-19.42 32 32 0 01-6 63.43zm112 168a40 40 0 01-40 40h-24V240h24a40 40 0 0140 40z"
                }
            }
        ]
    })(props);
}
function IoBicycleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M388 288a76 76 0 1076 76 76.24 76.24 0 00-76-76zm-264 0a76 76 0 1076 76 76.24 76.24 0 00-76-76z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 360v-86l-64-42 80-88 40 72h56"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M320 136a31.89 31.89 0 0032-32.1A31.55 31.55 0 00320.2 72a32 32 0 10-.2 64z"
                }
            }
        ]
    })(props);
}
function IoBicycleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 192l-29.5-60.1C284.32 118 284.32 118 264 118c-13.26 0-14.76 0-23 7.3l-71.7 69.1c-8.3 8.45-9.3 9.45-9.3 26.6 0 12.67 3.78 14.61 18.51 22.9L240 278v90h32V254s-29-17-48.3-30l48.9-51.5c18.7 28.5 27.3 51.5 38 51.5H384v-32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M388 448a92 92 0 1192-92 92.1 92.1 0 01-92 92zm0-152a60 60 0 1060 60 60.07 60.07 0 00-60-60zM124 448a92 92 0 1192-92 92.1 92.1 0 01-92 92zm0-152a60 60 0 1060 60 60.07 60.07 0 00-60-60zm196-168a31.89 31.89 0 0032-32.1A31.55 31.55 0 00320.2 64a32 32 0 10-.2 64z"
                }
            }
        ]
    })(props);
}
function IoBicycle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M388 448a92 92 0 1192-92 92.1 92.1 0 01-92 92zm0-152a60 60 0 1060 60 60.07 60.07 0 00-60-60zM124 448a92 92 0 1192-92 92.1 92.1 0 01-92 92zm0-152a60 60 0 1060 60 60.07 60.07 0 00-60-60zm196-168a31.89 31.89 0 0032-32.1A31.55 31.55 0 00320.2 64a32 32 0 10-.2 64z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M367.55 192h-43.76a4 4 0 01-3.51-2.08l-31.74-58.17a31 31 0 00-49.38-7.75l-69.86 70.4a32.56 32.56 0 00-9.3 22.4c0 17.4 12.6 23.6 18.5 27.1 28.5 16.42 48.57 28.43 59.58 35.1a4 4 0 011.92 3.41v69.12c0 8.61 6.62 16 15.23 16.43A16 16 0 00272 352v-86a16 16 0 00-6.66-13l-37-26.61a4 4 0 01-.58-6l42-44.79a4 4 0 016.42.79L298 215.77a16 16 0 0014 8.23h56a16 16 0 0016-16.77c-.42-8.61-7.84-15.23-16.45-15.23z"
                }
            }
        ]
    })(props);
}
function IoBluetoothOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M144 352l224-192L256 48v416l112-112-224-192"
                }
            }
        ]
    })(props);
}
function IoBluetoothSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M397.41 161.13L236-.28v212.8l-94.17-80.72-26 30.37L225.27 256 115.8 349.83l26 30.37 94.2-80.72v212.8l161.41-161.41L286.73 256zM276 96.28l62.59 62.59L276 212.52zm62.58 256.85L276 415.72V299.48z"
                }
            }
        ]
    })(props);
}
function IoBluetooth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M388 160.77a20 20 0 00-5.85-14.91l-112-112A20 20 0 00236 48v164.52l-79-67.71a20 20 0 00-26 30.38L225.27 256 131 336.81a20 20 0 1026 30.38l79-67.71V464a20 20 0 0034.14 14.14l112-112a20 20 0 00-1.14-29.33L286.73 256 381 175.19a20 20 0 007-14.42zm-49.42 192.36L276 415.72V299.49zM276 212.52V96.28l62.59 62.59z"
                }
            }
        ]
    })(props);
}
function IoBoatOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M461.93 261.05c-2-4.76-6.71-7.83-11.67-9.49l-187.18-74.48a23.78 23.78 0 00-14.17 0l-187 74.52c-5 1.56-9.83 4.77-11.81 9.53s-2.94 9.37-1 15.08l46.53 119.15a7.46 7.46 0 007.47 4.64c26.69-1.68 50.31-15.23 68.38-32.5a7.66 7.66 0 0110.49 0C201.29 386 227 400 256 400s54.56-14 73.88-32.54a7.67 7.67 0 0110.5 0c18.07 17.28 41.69 30.86 68.38 32.54a7.45 7.45 0 007.46-4.61l46.7-119.16c1.98-4.78.99-10.41-.99-15.18z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M416 473.14a6.84 6.84 0 00-3.56-6c-27.08-14.55-51.77-36.82-62.63-48a10.05 10.05 0 00-12.72-1.51c-50.33 32.42-111.61 32.44-161.95.05a10.09 10.09 0 00-12.82 1.56c-10.77 11.28-35.19 33.3-62.43 47.75a7.15 7.15 0 00-3.89 5.73 6.73 6.73 0 007.92 7.15c20.85-4.18 41-13.68 60.2-23.83a8.71 8.71 0 018-.06A185.14 185.14 0 00340 456a8.82 8.82 0 018.09.06c19.1 10 39.22 19.59 60 23.8a6.72 6.72 0 007.95-6.71z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 96V72a24.07 24.07 0 00-24-24h-80a24.07 24.07 0 00-24 24v24m224 137v-89a48.14 48.14 0 00-48-48H144a48.14 48.14 0 00-48 48v92m160-52.4v212.85"
                }
            }
        ]
    })(props);
}
function IoBoatSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M477.77 246.42c-2.13-6-7.23-9.55-12.56-11.95L432 221.38V92a20 20 0 00-20-20h-76V40a16 16 0 00-16-16H192a16 16 0 00-16 16v32h-76a20 20 0 00-20 20v129.46l-33.08 13.06c-5.33 2.4-10.58 6-12.72 12s-3.16 11.81-1 19L84.25 415.7h1.06c34.12 0 64-17.41 85.31-43.82 21.32 26.41 51.18 42.12 85.3 42.12s64-15.76 85.31-42.17c21.32 26.41 51.18 43.87 85.3 43.87h1.06l51.25-150.17c2.16-6 1.07-13.1-1.07-19.11zM256 152l-144 56.83V108a4 4 0 014-4h280a4 4 0 014 4v100.76z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M345.22 407c-52.25 36.26-126.35 36.25-178.6 0 0 0-45.64 63-94.64 63l13.33 1c29.86 0 58.65-11.73 85.31-25.59a185.33 185.33 0 00170.6 0c26.66 13.87 55.45 25.6 85.31 25.6l13.33-1C392.21 470 345.22 407 345.22 407z"
                }
            }
        ]
    })(props);
}
function IoBoat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 473.14a6.83 6.83 0 00-3.57-6c-27.07-14.55-51.76-36.82-62.62-48a10.05 10.05 0 00-12.72-1.51c-50.33 32.42-111.61 32.44-161.95.05a10.09 10.09 0 00-12.82 1.56c-10.77 11.28-35.19 33.3-62.43 47.75a7.11 7.11 0 00-3.89 5.73 6.73 6.73 0 007.92 7.15c20.85-4.18 41-13.68 60.2-23.83a8.71 8.71 0 018-.06 185.14 185.14 0 00167.81 0 8.82 8.82 0 018.09.06c19.1 10 39.22 19.59 60 23.8a6.73 6.73 0 008-6.71zm60.71-226.23c-3.49-8.39-10.9-14.89-20.9-18.35L432 219.08V136a64 64 0 00-64-64h-32v-8a40 40 0 00-40-40h-80a40 40 0 00-40 40v8h-32a64 64 0 00-64 64v83.15l-23.58 9.39c-9.94 3.3-17.63 10-21.15 18.44-2.45 5.89-5.25 15-1.3 26.46l.1.3 46.66 119.44A23.33 23.33 0 00102.58 408c.5 0 1 0 1.53-.05 31.32-2 56-17.27 72.6-31.61C200.42 396.81 228.31 408 256 408s55.43-11.2 79.14-31.7c16.59 14.36 41.3 29.67 72.61 31.65a23.36 23.36 0 0023.37-14.74l46.65-119c3.28-8.09 2.9-17.76-1.06-27.3zM269 154.21l-1.14-.4a39.53 39.53 0 00-23.73 0l-.58.18-126.07 50.23a4 4 0 01-5.48-3.72V136a32 32 0 0132-32h224a32 32 0 0132 32v64.44a4 4 0 01-5.48 3.72z"
                }
            }
        ]
    })(props);
}
function IoBodyOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "56",
                    "r": "40",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M199.3 295.62h0l-30.4 172.2a24 24 0 0019.5 27.8 23.76 23.76 0 0027.6-19.5l21-119.9v.2s5.2-32.5 17.5-32.5h3.1c12.5 0 17.5 32.5 17.5 32.5v-.1l21 119.9a23.92 23.92 0 1047.1-8.4l-30.4-172.2-4.9-29.7c-2.9-18.1-4.2-47.6.5-59.7 4-10.4 14.13-14.2 23.2-14.2H424a24 24 0 000-48H88a24 24 0 000 48h92.5c9.23 0 19.2 3.8 23.2 14.2 4.7 12.1 3.4 41.6.5 59.7z"
                }
            }
        ]
    })(props);
}
function IoBodySharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "56",
                    "r": "56"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M464 128H48v52h144l-32 325.13 51 6.87 21.65-192h47.02L301 512l51-6.98L320 180h144v-52z"
                }
            }
        ]
    })(props);
}
function IoBody(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "56",
                    "r": "56"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M437 128H75a27 27 0 000 54h101.88c6.91 0 15 3.09 19.58 15 5.35 13.83 2.73 40.54-.57 61.23l-4.32 24.45a.42.42 0 01-.12.35l-34.6 196.81A27.43 27.43 0 00179 511.58a27.06 27.06 0 0031.42-22.29l23.91-136.8S242 320 256 320c14.23 0 21.74 32.49 21.74 32.49l23.91 136.92a27.24 27.24 0 1053.62-9.6L320.66 283a.45.45 0 00-.11-.35l-4.33-24.45c-3.3-20.69-5.92-47.4-.57-61.23 4.56-11.88 12.91-15 19.28-15H437a27 27 0 000-54z"
                }
            }
        ]
    })(props);
}
function IoBonfireOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M273.38 368.33c-.81-9.23-8.86-16.44-18.55-16.44a18.63 18.63 0 00-18.2 14.11l-18.2 88.38a35.75 35.75 0 00-.93 7.88c0 19.93 16.68 33.78 37.33 33.78s37.34-13.85 37.34-33.78a36.16 36.16 0 00-1.29-9.45zm137.67 39.53a41.78 41.78 0 00-5.95-4.35l-69.53-48.59c-6.77-4.25-14-4.13-19.25 1a13.53 13.53 0 00-2 17.2l52.5 69a36.57 36.57 0 004 4.69c9.1 10.17 29.28 10.73 40.37 0 10.94-10.91 10.81-30.35-.14-38.95zm52.25-71.98h-70.42c-4.55 0-8.88 3.35-8.88 8.16s2.95 7.85 6.92 9.16l66.43 20.55C467 376 480 367.4 480 356.66c0-13.66-7.6-20.78-16.7-20.78zM128.22 344c0-5-4.55-8.16-9.45-8.16H48.35c-8.87 0-16.35 9.58-16.35 20.32S44.62 376 54.3 373.75l67.43-20.55c4.39-1.31 6.49-4.2 6.49-9.2zm48.33 11L107 403.38a32.34 32.34 0 00-6 4.35 26.33 26.33 0 000 38.56 29.39 29.39 0 0040.36 0 30.75 30.75 0 004-4.68L197.9 373c3.5-5.58 2.92-12.49-2-17.06a15 15 0 00-19.35-.94z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M368 125.09c0-55.7-49.22-89.16-94.2-93.06a8 8 0 00-8.69 7.71c-3.12 76-109.38 110.69-119.87 178.68-7 45.4 16.65 72.37 34.31 85.78a15.94 15.94 0 0023.93-5.62c22.5-45.86 74.33-63.49 109.72-85.94 42.88-27.2 54.8-56.44 54.8-87.55z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M240 95.7c-12.82-23-30.51-31-59.16-31.63a3.86 3.86 0 00-4.06 3.51c-.95 34.22-32.78 44.85-32.78 73.15 0 19.37 5.39 29 17.16 39.28m191.29-1.25c8.6 14.31 15.55 30.08 15.55 48 0 52.52-42.47 93.1-94.86 93.1a94.42 94.42 0 01-65.14-26"
                }
            }
        ]
    })(props);
}
function IoBonfireSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M199.89 336l-15.25-5.62a100.35 100.35 0 01-32-23.08c-13.93-14.9-29.29-40.71-23.38-79.11 5.2-33.73 44.2-74.21 69.34-97.87 27.24-25.62 66-65.85 64.15-99.15L262 16h15.18C328.53 16 384 53.62 384 114.41c0 45.57-22 77.61-68.91 106.9-8 5-16.44 9.66-25.42 14.53-30.63 16.62-75.29 49.83-85.73 85.32zm-18.7-222.41C201 95 218.91 78.15 227.62 59.79q-2.76-1.68-5.7-3.09c-11.87-5.69-26.1-8.34-44.76-8.34h-16.94l.56 16.49c.47 14.06-6.06 22.51-14.33 33.21C137.8 109.26 128 121.94 128 141c0 10.23 1.29 18.76 4.2 26.36q3.5-5.31 7.61-10.63c12.19-15.73 27.05-29.68 41.38-43.14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M330.34 239.85c-9.31 5.9-19 11.14-29.25 16.71-32.65 17.69-63.48 34.44-73.23 67.44l-.6 2a110.5 110.5 0 0045.87 10c29.66 0 57.45-11.13 78.24-31.36A107.38 107.38 0 00384 227a92.39 92.39 0 00-5.59-31c-11.35 16.18-27.14 30.58-48.07 43.85zM268.72 360h-25.44a4 4 0 00-3.92 3.22l-25.36 128a4 4 0 003.92 4.78h76.26a4 4 0 003.92-4.78l-25.41-128a4 4 0 00-3.97-3.22zm56.96-5.68l-11.36 11.36a4 4 0 00-.5 5.05l59.47 89.21a4 4 0 006.16.61l41.1-41.1a4 4 0 00-.61-6.16l-89.21-59.47a4 4 0 00-5.05.5zM388 336a4 4 0 00-4 4v8.61a4 4 0 003.34 3.95l88 14.66a4 4 0 004.66-3.94V340a4 4 0 00-4-4zm-201.68 18.32l11.36 11.36a4 4 0 01.5 5.05l-59.47 89.21a4 4 0 01-6.16.61l-41.1-41.1a4 4 0 01.61-6.16l89.21-59.47a4 4 0 015.05.5zM124 336H36a4 4 0 00-4 4v23.28a4 4 0 004.66 3.94l88-14.66a4 4 0 003.34-3.95V340a4 4 0 00-4-4z"
                }
            }
        ]
    })(props);
}
function IoBonfire(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M273.38 368.37c-.81-9.23-8.86-16.44-18.55-16.44a18.63 18.63 0 00-18.2 14.07l-18.2 88.36a35.59 35.59 0 00-.93 7.87c0 19.93 16.68 33.77 37.33 33.77s37.34-13.84 37.34-33.77a36.16 36.16 0 00-1.29-9.45zm137.67 39.52a42.66 42.66 0 00-5.95-4.36L335.57 355c-6.77-4.24-14-4.13-19.25 1a13.52 13.52 0 00-2 17.19l52.5 69a38 38 0 004 4.69c9.1 10.16 29.28 10.72 40.37 0 10.94-10.96 10.81-30.39-.14-38.99zm52.25-71.96h-70.42c-4.55 0-8.88 3.35-8.88 8.15s2.95 7.85 6.92 9.16l66.43 20.55C467 376 480 367.44 480 356.71c0-13.63-7.6-20.78-16.7-20.78zm-335.08 8.15c0-4.95-4.55-8.15-9.45-8.15H48.35c-8.87 0-16.35 9.58-16.35 20.31S44.62 376 54.3 373.79l67.43-20.55c4.39-1.31 6.49-4.24 6.49-9.16zm48.33 10.97L107 403.41a32.29 32.29 0 00-6 4.34 26.33 26.33 0 000 38.56 29.41 29.41 0 0040.36 0 30.75 30.75 0 004-4.68L197.9 373c3.5-5.57 2.92-12.48-2-17a15 15 0 00-19.35-.95zm116.91-112.66c10-5.42 19.45-10.54 28.31-16.16 42.46-26.92 62.23-59 62.23-101 0-64.66-56.07-104.4-108.82-109-6.49-.57-15-.42-19.91 3.88s-5.88 12.56-6.15 19.1c-1.38 33.61-28.38 59-57 85.86-28 26.3-56.93 53.49-62.71 91-8.41 54.68 21.74 86.71 40.46 100.93a31.88 31.88 0 0019.3 6.51 32.32 32.32 0 007.41-.87 31.75 31.75 0 0021.27-16.95c14.91-30.39 45.77-47.12 75.61-63.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M139.82 156.57c12.22-15.76 27-29.68 41.37-43.15 19.92-18.72 37.81-35.58 46.5-53.86-12.24-7.37-27.36-11.36-46.51-11.36-17.79 0-20.39 5.18-20.39 19.06 0 12.56-6.53 20.54-14.34 30.65C137.8 109.1 128 121.77 128 140.84c0 10.23 1.29 18.77 4.2 26.37q3.5-5.32 7.62-10.64zm190.52 83.17c-9.33 5.92-19 11.16-29.25 16.71-28.91 15.68-56.21 30.48-68.88 56.28a62.6 62.6 0 01-1.88 3.61 8 8 0 003.89 11.3c12.31 5.1 25.13 8.27 38.91 8.27a111.42 111.42 0 0078.24-31.37A107.45 107.45 0 00384 226.85a86.56 86.56 0 00-1.33-15 8 8 0 00-13.8-4c-10.18 11.47-22.93 22-38.53 31.89z"
                }
            }
        ]
    })(props);
}
function IoBookOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 160c16-63.16 76.43-95.41 208-96a15.94 15.94 0 0116 16v288a16 16 0 01-16 16c-128 0-177.45 25.81-208 64-30.37-38-80-64-208-64-9.88 0-16-8.05-16-17.93V80a15.94 15.94 0 0116-16c131.57.59 192 32.84 208 96zm0 0v288"
                }
            }
        ]
    })(props);
}
function IoBookSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 48c-67.61.29-117.87 9.6-154.24 25.69-27.14 12-37.76 21.08-37.76 51.84V448c41.57-37.5 78.46-48 224-48V48zM48 48c67.61.29 117.87 9.6 154.24 25.69 27.14 12 37.76 21.08 37.76 51.84V448c-41.57-37.5-78.46-48-224-48V48z"
                }
            }
        ]
    })(props);
}
function IoBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M202.24 74C166.11 56.75 115.61 48.3 48 48a31.36 31.36 0 00-17.92 5.33A32 32 0 0016 79.9V366c0 19.34 13.76 33.93 32 33.93 71.07 0 142.36 6.64 185.06 47a4.11 4.11 0 006.94-3V106.82a15.89 15.89 0 00-5.46-12A143 143 0 00202.24 74zm279.68-20.7A31.33 31.33 0 00464 48c-67.61.3-118.11 8.71-154.24 26a143.31 143.31 0 00-32.31 20.78 15.93 15.93 0 00-5.45 12v337.13a3.93 3.93 0 006.68 2.81c25.67-25.5 70.72-46.82 185.36-46.81a32 32 0 0032-32v-288a32 32 0 00-14.12-26.61z"
                }
            }
        ]
    })(props);
}
function IoBookmarkOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 48H160a48 48 0 00-48 48v368l144-128 144 128V96a48 48 0 00-48-48z"
                }
            }
        ]
    })(props);
}
function IoBookmarkSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 480L256 357.41 96 480V32h320z"
                }
            }
        ]
    })(props);
}
function IoBookmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 480a16 16 0 01-10.63-4L256 357.41 122.63 476A16 16 0 0196 464V96a64.07 64.07 0 0164-64h192a64.07 64.07 0 0164 64v368a16 16 0 01-16 16z"
                }
            }
        ]
    })(props);
}
function IoBookmarksOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M128 80V64a48.14 48.14 0 0148-48h224a48.14 48.14 0 0148 48v368l-80-64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 96H112a48.14 48.14 0 00-48 48v352l152-128 152 128V144a48.14 48.14 0 00-48-48z"
                }
            }
        ]
    })(props);
}
function IoBookmarksSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 0v48h304v368l48 32V0H112z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M48 80v432l168-124 168 124V80H48z"
                }
            }
        ]
    })(props);
}
function IoBookmarks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 0H176a64.11 64.11 0 00-62 48h228a74 74 0 0174 74v304.89l22 17.6a16 16 0 0019.34.5 16.41 16.41 0 006.66-13.42V64a64 64 0 00-64-64z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M320 80H112a64 64 0 00-64 64v351.62A16.36 16.36 0 0054.6 509a16 16 0 0019.71-.71L216 388.92l141.69 119.32a16 16 0 0019.6.79 16.4 16.4 0 006.71-13.44V144a64 64 0 00-64-64z"
                }
            }
        ]
    })(props);
}
function IoBowlingBallOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "208",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "288",
                    "cy": "200",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "296",
                    "cy": "128",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "360",
                    "cy": "168",
                    "r": "24"
                }
            }
        ]
    })(props);
}
function IoBowlingBallSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM286 230a28 28 0 1128-28 28 28 0 01-28 28zm8-76a28 28 0 1128-28 28 28 0 01-28 28zm68 44a28 28 0 1128-28 28 28 0 01-28 28z"
                }
            }
        ]
    })(props);
}
function IoBowlingBall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM288 224a24 24 0 1124-24 24 24 0 01-24 24zm8-72a24 24 0 1124-24 24 24 0 01-24 24zm64 40a24 24 0 1124-24 24 24 0 01-24 24z"
                }
            }
        ]
    })(props);
}
function IoBriefcaseOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "448",
                    "height": "320",
                    "x": "32",
                    "y": "128",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M144 128V96a32 32 0 0132-32h160a32 32 0 0132 32v32m112 112H32m288 0v24a8 8 0 01-8 8H200a8 8 0 01-8-8v-24"
                }
            }
        ]
    })(props);
}
function IoBriefcaseSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 288H176v-32H16v196a12 12 0 0012 12h456a12 12 0 0012-12V256H336zm160-164a12 12 0 00-12-12H384V56a8 8 0 00-8-8H136a8 8 0 00-8 8v56H28a12 12 0 00-12 12v100h480zm-152-12H168V88h176z"
                }
            }
        ]
    })(props);
}
function IoBriefcase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M336 80H176a16 16 0 00-16 16v16h192V96a16 16 0 00-16-16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M496 176a64.07 64.07 0 00-64-64h-48V96a48.05 48.05 0 00-48-48H176a48.05 48.05 0 00-48 48v16H80a64.07 64.07 0 00-64 64v48h480zm-144-64H160V96a16 16 0 0116-16h160a16 16 0 0116 16zm-16 152a24 24 0 01-24 24H200a24 24 0 01-24-24v-4a4 4 0 00-4-4H16v144a64 64 0 0064 64h352a64 64 0 0064-64V256H340a4 4 0 00-4 4z"
                }
            }
        ]
    })(props);
}
function IoBrowsersOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "416",
                    "height": "384",
                    "x": "48",
                    "y": "64",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M397.82 64H114.18C77.69 64 48 94.15 48 131.2V176h16c0-16 16-32 32-32h320c16 0 32 16 32 32h16v-44.8c0-37.05-29.69-67.2-66.18-67.2z"
                }
            }
        ]
    })(props);
}
function IoBrowsersSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 64v384a16 16 0 0016 16h416a16 16 0 0016-16V64a16 16 0 00-16-16H48a16 16 0 00-16 16zm408 364H72a4 4 0 01-4-4V152a4 4 0 014-4h368a4 4 0 014 4v272a4 4 0 01-4 4z"
                }
            }
        ]
    })(props);
}
function IoBrowsers(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 48H96a64 64 0 00-64 64v288a64 64 0 0064 64h320a64 64 0 0064-64V112a64 64 0 00-64-64zm24 96H72a8 8 0 01-8-8v-24a32.09 32.09 0 0132-32h320a32.09 32.09 0 0132 32v24a8 8 0 01-8 8z"
                }
            }
        ]
    })(props);
}
function IoBrushOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M452.37 59.63h0a40.49 40.49 0 00-57.26 0L184 294.74c23.08 4.7 46.12 27.29 49.26 49.26l219.11-227.11a40.49 40.49 0 000-57.26zM138 336c-29.88 0-54 24.5-54 54.86 0 23.95-20.88 36.57-36 36.57C64.56 449.74 92.82 464 120 464c39.78 0 72-32.73 72-73.14 0-30.36-24.12-54.86-54-54.86z"
                }
            }
        ]
    })(props);
}
function IoBrushSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 96l-64-64-244 260 64 64zM142 320c-36.52 0-66 30.63-66 68.57 0 25.43-31 45.72-44 45.72C52.24 462.17 86.78 480 120 480c48.62 0 88-40.91 88-91.43 0-37.94-29.48-68.57-66-68.57z"
                }
            }
        ]
    })(props);
}
function IoBrush(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M233.15 360.11a15.7 15.7 0 01-4.92-.77 16 16 0 01-10.92-13c-2.15-15-19.95-32.46-36.62-35.85a16 16 0 01-8.69-26.33l211.09-235.1c.19-.22.39-.43.59-.63a56.57 56.57 0 0179.89 0 56.51 56.51 0 01.11 79.78l-219 227a16 16 0 01-11.53 4.9zm-113.26 120c-32.14 0-65.45-16.89-84.85-43a16 16 0 0112.85-25.54c5.34 0 20-4.87 20-20.57 0-39.07 31.4-70.86 70-70.86s70 31.79 70 70.86c0 49.12-39.48 89.11-88 89.11z"
                }
            }
        ]
    })(props);
}
function IoBugOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M370 378c28.89 23.52 46 46.07 46 86m-274-86c-28.89 23.52-46 46.06-46 86m288-256c28.89-23.52 32-56.07 32-96m-288 94c-28.89-23.52-32-54.06-32-94m368 176.13h-80m-256 0H48M256 192v256"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 448h0c-70.4 0-128-57.6-128-128v-96.07c0-65.07 57.6-96 128-96h0c70.4 0 128 25.6 128 96V320c0 70.4-57.6 128-128 128z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M179.43 143.52a49.08 49.08 0 01-3.43-15.73A80 80 0 01255.79 48h.42A80 80 0 01336 127.79a41.91 41.91 0 01-3.12 14.3"
                }
            }
        ]
    })(props);
}
function IoBugSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 304.13v-32h-80V215.2c29.42-27.95 32-64.76 32-103.2V96h-32v16c0 28-1.86 48.15-9.9 63.84C368 128 324.32 112 256 112c-39.8 0-75.19 7.06-100.43 24.32-14.9 10.19-25.2 24.91-32.7 39.72C114 160.57 112 140.82 112 112V96H80v16c0 37.44 2.59 73.36 32 101.2v58.93H32v32l80-.13c0 19 3.7 53.09 10.39 69.69C96.6 396.76 80 422.31 80 464v16h32v-16c0-27.66 9.1-44.71 26.17-61.32C160 448 177 464 240 464V176h32v288c65 0 80-16 101.83-61.32C390.9 419.29 400 436.35 400 464v16h32v-16c0-41.68-16.6-67.23-42.39-90.31C396.3 357.09 400 323 400 304z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32c-48.06 0-96 0-96 84 26.12-14 59.35-20 96-20 24.09 0 46.09 2.65 65.39 8 10.75 3 24.66 8.71 30.61 12 0-84-47.94-84-96-84z"
                }
            }
        ]
    })(props);
}
function IoBug(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M463.55 272.13H400v-48.2q0-4.32-.27-8.47c29.57-27.88 32.25-64.63 32.27-103 0-8.61-6.64-16-15.25-16.41A16 16 0 00400 112c0 28-1.86 48.15-9.9 63.84-19.22-41.15-65.78-63.91-134.1-63.91-39.8 0-74.19 9.13-99.43 26.39-14.9 10.19-26.2 22.91-33.7 37.72C114 160.65 112 141 112 112.46c0-8.61-6.6-16-15.2-16.44A16 16 0 0080 112c0 37.63 2.61 73.73 32.44 101.63q-.43 5.06-.44 10.3v48.2H48.45c-8.61 0-16 6.62-16.43 15.23a16 16 0 0016 16.77h64V320a143.32 143.32 0 0010.39 53.69C96.74 396.64 80.18 422 80 463.34c0 8.74 6.62 16.3 15.36 16.65A16 16 0 00112 464c0-27.66 9.1-44.71 26.17-61.32A144.37 144.37 0 00220 459.42a16 16 0 0020-15.49V192.45c0-8.61 6.62-16 15.23-16.43A16 16 0 01272 192v251.93a16 16 0 0020 15.49 144.4 144.4 0 0081.82-56.74c17 16.54 26.09 33.52 26.17 60.95a16.27 16.27 0 0015.1 16.37A16 16 0 00432 464c0-41.68-16.6-67.23-42.39-90.31A143.32 143.32 0 00400 320v-15.87h64a16 16 0 0016-16.77c-.42-8.61-7.84-15.23-16.45-15.23z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M321.39 104l.32.09c13.57 3.8 25.07-10.55 18.2-22.85A95.86 95.86 0 00256.21 32h-.42a95.87 95.87 0 00-84.19 50.13c-6.84 12.58 5.14 27 18.84 22.86 19.71-6 41.79-9.06 65.56-9.06 24.09 0 46.09 2.72 65.39 8.07z"
                }
            }
        ]
    })(props);
}
function IoBuildOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M393.87 190a32.1 32.1 0 01-45.25 0l-26.57-26.57a32.09 32.09 0 010-45.26L382.19 58a1 1 0 00-.3-1.64c-38.82-16.64-89.15-8.16-121.11 23.57-30.58 30.35-32.32 76-21.12 115.84a31.93 31.93 0 01-9.06 32.08L64 380a48.17 48.17 0 1068 68l153.86-167a31.93 31.93 0 0131.6-9.13c39.54 10.59 84.54 8.6 114.72-21.19 32.49-32 39.5-88.56 23.75-120.93a1 1 0 00-1.6-.26z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "96",
                    "cy": "416",
                    "r": "16"
                }
            }
        ]
    })(props);
}
function IoBuildSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M230 209.2L32 405.58 106.65 480l197.59-198.17c46.47 17.46 105.52 12.54 143-24.78 40.44-40.32 40.35-108 16.81-156.79l-87.33 87.06-52.32-52.13 87.33-87.06C363 24.46 294.67 24.34 254.23 64.66c-38.03 37.91-42.78 97.6-24.23 144.54z"
                }
            }
        ]
    })(props);
}
function IoBuild(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M469.54 120.52a16 16 0 00-25.54-4L382.56 178a16.12 16.12 0 01-22.63 0l-26.56-26.6a16 16 0 010-22.63l61.18-61.19a16 16 0 00-4.78-25.92C343.56 21 285.88 31.78 249.51 67.88c-30.9 30.68-40.11 78.62-25.25 131.53a15.89 15.89 0 01-4.49 16L53.29 367.46a64.17 64.17 0 1090.6 90.64l153.68-166.85a15.9 15.9 0 0115.77-4.57 179.3 179.3 0 0046.22 6.37c33.4 0 62.71-10.81 83.85-31.64 39.15-38.57 45.12-103.99 26.13-140.89zM99.48 447.15a32 32 0 1128.34-28.35 32 32 0 01-28.34 28.35z"
                }
            }
        ]
    })(props);
}
function IoBulbOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M304 384v-24c0-29 31.54-56.43 52-76 28.84-27.57 44-64.61 44-108 0-80-63.73-144-144-144a143.6 143.6 0 00-144 144c0 41.84 15.81 81.39 44 108 20.35 19.21 52 46.7 52 76v24m16 96h64m-80-48h96m-48-48V256"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M294 240s-21.51 16-38 16-38-16-38-16"
                }
            }
        ]
    })(props);
}
function IoBulbSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 464h96v32h-96zm-16-48h128v32H192zM369.42 62.69C339.35 32.58 299.07 16 256 16A159.62 159.62 0 0096 176c0 46.62 17.87 90.23 49 119.64l4.36 4.09C167.37 316.57 192 339.64 192 360v40h48V269.11L195.72 244 214 217.72 256 240l41.29-22.39 19.1 25.68-44.39 26V400h48v-40c0-19.88 24.36-42.93 42.15-59.77l4.91-4.66C399.08 265 416 223.61 416 176a159.16 159.16 0 00-46.58-113.31z"
                }
            }
        ]
    })(props);
}
function IoBulb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 464h-64a16 16 0 000 32h64a16 16 0 000-32zm16-48h-96a16 16 0 000 32h96a16 16 0 000-32zm65.42-353.31C339.35 32.58 299.07 16 256 16A159.62 159.62 0 0096 176c0 46.62 17.87 90.23 49 119.64l4.36 4.09C167.37 316.57 192 339.64 192 360v24a16 16 0 0016 16h24a8 8 0 008-8V274.82a8 8 0 00-5.13-7.47A130.73 130.73 0 01208.71 253a16 16 0 1118.58-26c7.4 5.24 21.65 13 28.71 13s21.31-7.78 28.73-13a16 16 0 0118.56 26 130.73 130.73 0 01-26.16 14.32 8 8 0 00-5.13 7.47V392a8 8 0 008 8h24a16 16 0 0016-16v-24c0-19.88 24.36-42.93 42.15-59.77l4.91-4.66C399.08 265 416 223.61 416 176a159.16 159.16 0 00-46.58-113.31z"
                }
            }
        ]
    })(props);
}
function IoBusOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "352",
                    "height": "192",
                    "x": "80",
                    "y": "112",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "32",
                    "ry": "32"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "352",
                    "height": "128",
                    "x": "80",
                    "y": "304",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "32",
                    "ry": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M400 112H112a32.09 32.09 0 01-32-32h0a32.09 32.09 0 0132-32h288a32.09 32.09 0 0132 32h0a32.09 32.09 0 01-32 32zM144 432v22a10 10 0 01-10 10h-28a10 10 0 01-10-10v-22zm272 0v22a10 10 0 01-10 10h-28a10 10 0 01-10-10v-22z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "368",
                    "cy": "368",
                    "r": "16",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "144",
                    "cy": "368",
                    "r": "16",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 112v192M80 80v288M432 80v288"
                }
            }
        ]
    })(props);
}
function IoBusSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M400 64H112a16 16 0 000 32h288a16 16 0 000-32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M424 32H88a24 24 0 00-24 24v360a32 32 0 0016 27.71V480h72v-32h208v32h72v-36.29A32 32 0 00448 416V56a24 24 0 00-24-24zM175.82 371.47a32 32 0 11-35.3-35.29 32.09 32.09 0 0135.3 35.29zM240 288H96V128h144zm16-192H96.46L96 64h320l-.46 32H256zm16 32h144v160H272zm64.18 236.53a32 32 0 1135.3 35.29 32.09 32.09 0 01-35.3-35.29z"
                }
            }
        ]
    })(props);
}
function IoBus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H112a48 48 0 00-48 48v320a47.91 47.91 0 0016 35.74V454a26 26 0 0026 26h28a26 26 0 0026-26v-6h192v6a26 26 0 0026 26h28a26 26 0 0026-26v-18.26A47.91 47.91 0 00448 400V80a48 48 0 00-48-48zM147.47 399.82a32 32 0 1128.35-28.35 32 32 0 01-28.35 28.35zM236 288H112a16 16 0 01-16-16V144a16 16 0 0116-16h124a4 4 0 014 4v152a4 4 0 01-4 4zm20-192H112.46c-8.6 0-16-6.6-16.44-15.19A16 16 0 01112 64h287.54c8.6 0 16 6.6 16.44 15.19A16 16 0 01400 96H256zm20 32h124a16 16 0 0116 16v128a16 16 0 01-16 16H276a4 4 0 01-4-4V132a4 4 0 014-4zm60.18 243.47a32 32 0 1128.35 28.35 32 32 0 01-28.35-28.35z"
                }
            }
        ]
    })(props);
}
function IoBusinessOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M176 416v64M80 32h192a32 32 0 0132 32v412a4 4 0 01-4 4H48h0V64a32 32 0 0132-32zm240 160h112a32 32 0 0132 32v256h0-160 0V208a16 16 0 0116-16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M98.08 431.87a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm80 240a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm80 320a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "256",
                    "cy": "176",
                    "rx": "15.95",
                    "ry": "16.03",
                    "transform": "rotate(-45 255.99 175.996)"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M258.08 111.87a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zM400 400a16 16 0 1016 16 16 16 0 00-16-16zm0-80a16 16 0 1016 16 16 16 0 00-16-16zm0-80a16 16 0 1016 16 16 16 0 00-16-16zm-64 160a16 16 0 1016 16 16 16 0 00-16-16zm0-80a16 16 0 1016 16 16 16 0 00-16-16zm0-80a16 16 0 1016 16 16 16 0 00-16-16z"
                }
            }
        ]
    })(props);
}
function IoBusinessSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 176V16H32v480h128v-96h32v96h288V176zM112 432H80v-32h32zm0-80H80v-32h32zm0-80H80v-32h32zm0-80H80v-32h32zm0-80H80V80h32zm128-32h32v32h-32zm-48 272h-32v-32h32zm0-80h-32v-32h32zm0-80h-32v-32h32zm0-80h-32V80h32zm80 320h-32v-32h32zm0-80h-32v-32h32zm0-80h-32v-32h32zm0-80h-32v-32h32v32zm176 272H320v-32h32v-32h-32v-48h32v-32h-32v-48h32v-32h-32v-32h128z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M384 400h32v32h-32zm0-80h32v32h-32zm0-80h32v32h-32z"
                }
            }
        ]
    })(props);
}
function IoBusiness(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 176H320V64a48 48 0 00-48-48H80a48 48 0 00-48 48v416a16 16 0 0016 16h104a8 8 0 008-8v-71.55c0-8.61 6.62-16 15.23-16.43A16 16 0 01192 416v72a8 8 0 008 8h264a16 16 0 0016-16V224a48 48 0 00-48-48zM98.08 431.87a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm80 240a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm80 320a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zM444 464H320V208h112a16 16 0 0116 16v236a4 4 0 01-4 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M400 400a16 16 0 1016 16 16 16 0 00-16-16zm0-80a16 16 0 1016 16 16 16 0 00-16-16zm0-80a16 16 0 1016 16 16 16 0 00-16-16zm-64 160a16 16 0 1016 16 16 16 0 00-16-16zm0-80a16 16 0 1016 16 16 16 0 00-16-16zm0-80a16 16 0 1016 16 16 16 0 00-16-16z"
                }
            }
        ]
    })(props);
}
function IoCafeOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M368 80h64a16 16 0 0116 16v34a46 46 0 01-46 46h-34M96 80h272v192a80 80 0 01-80 80H176a80 80 0 01-80-80V80h0zM64 416h336"
                }
            }
        ]
    })(props);
}
function IoCafeSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 64H80v254.34a19.83 19.83 0 005.86 14.14l29.65 29.66a19.87 19.87 0 0014.15 5.86h204.68a19.87 19.87 0 0014.15-5.86l29.65-29.66a19.83 19.83 0 005.86-14.14V192h32a16 16 0 0011.31-4.69l32-32A16 16 0 00464 144V80a16 16 0 00-16-16zm-16 73.37L409.37 160H384V96h48zM48 400h368v32H48z"
                }
            }
        ]
    })(props);
}
function IoCafe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 64H96a16 16 0 00-16 16v192a96.11 96.11 0 0096 96h112a96.11 96.11 0 0096-96v-80h18a62.07 62.07 0 0062-62V96a32 32 0 00-32-32zm0 66a30 30 0 01-30 30h-18V96h48zm-32 270H64a16 16 0 000 32h336a16 16 0 000-32z"
                }
            }
        ]
    })(props);
}
function IoCalculatorOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "288",
                    "height": "416",
                    "x": "112",
                    "y": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "32",
                    "ry": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160.01 112H352v64H160.01z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "168",
                    "cy": "248",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "248",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "344",
                    "cy": "248",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "168",
                    "cy": "328",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "328",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "168",
                    "cy": "408",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "408",
                    "r": "24"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "48",
                    "height": "128",
                    "x": "320",
                    "y": "304",
                    "rx": "24",
                    "ry": "24"
                }
            }
        ]
    })(props);
}
function IoCalculatorSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 48a16 16 0 00-16-16H112a16 16 0 00-16 16v416a16 16 0 0016 16h288a16 16 0 0016-16zM192 432h-48v-48h48zm0-80h-48v-48h48zm0-80h-48v-48h48zm88 160h-48v-48h48zm0-80h-48v-48h48zm0-80h-48v-48h48zm88 160h-48V304h48zm0-160h-48v-48h48zm0-96H144V80h224z"
                }
            }
        ]
    })(props);
}
function IoCalculator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 80a48.05 48.05 0 00-48-48H144a48.05 48.05 0 00-48 48v352a48.05 48.05 0 0048 48h224a48.05 48.05 0 0048-48zM168 432a24 24 0 1124-24 24 24 0 01-24 24zm0-80a24 24 0 1124-24 24 24 0 01-24 24zm0-80a24 24 0 1124-24 24 24 0 01-24 24zm88 160a24 24 0 1124-24 24 24 0 01-24 24zm0-80a24 24 0 1124-24 24 24 0 01-24 24zm0-80a24 24 0 1124-24 24 24 0 01-24 24zm112 136a24 24 0 01-48 0v-80a24 24 0 0148 0zm-24-136a24 24 0 1124-24 24 24 0 01-24 24zm19.31-100.69A16 16 0 01352 176H160a16 16 0 01-16-16V96a16 16 0 0116-16h192a16 16 0 0116 16v64a16 16 0 01-4.69 11.31z"
                }
            }
        ]
    })(props);
}
function IoCalendarClearOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "416",
                    "height": "384",
                    "x": "48",
                    "y": "80",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M128 48v32m256-32v32m80 80H48"
                }
            }
        ]
    })(props);
}
function IoCalendarClearSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 456a24 24 0 0024 24h400a24 24 0 0024-24V192H32zM480 87.77A23.8 23.8 0 00456 64h-55.92V32h-48v32H159.92V32h-48v32H56a23.8 23.8 0 00-24 23.77V144h448z"
                }
            }
        ]
    })(props);
}
function IoCalendarClear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 128a64 64 0 00-64-64h-16V48.45c0-8.61-6.62-16-15.23-16.43A16 16 0 00368 48v16H144V48.45c0-8.61-6.62-16-15.23-16.43A16 16 0 00112 48v16H96a64 64 0 00-64 64v12a4 4 0 004 4h440a4 4 0 004-4zM32 416a64 64 0 0064 64h320a64 64 0 0064-64V180a4 4 0 00-4-4H36a4 4 0 00-4 4z"
                }
            }
        ]
    })(props);
}
function IoCalendarNumberOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "416",
                    "height": "384",
                    "x": "48",
                    "y": "80",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M128 48v32m256-32v32m80 80H48m256 100l43.42-32H352v168m-160.13-89.37c9.11 0 25.79-4.28 36.72-15.47a37.9 37.9 0 0011.13-27.26c0-26.12-22.59-39.9-47.89-39.9-21.4 0-33.52 11.61-37.85 18.93M149 374.16c4.88 8.27 19.71 25.84 43.88 25.84 28.59 0 52.12-15.94 52.12-43.82 0-12.62-3.66-24-11.58-32.07-12.36-12.64-31.25-17.48-41.55-17.48"
                }
            }
        ]
    })(props);
}
function IoCalendarNumberSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 456a24 24 0 0024 24h400a24 24 0 0024-24V176H32zm310.17-244H368v200h-32V256.29l-35.39 26.08-19-25.76zM222 335.3c-8.54-8.74-22.75-12.67-30.11-12.67h-16v-32h16c4.85 0 17.41-2.6 25.28-10.65a22 22 0 006.57-16.08c0-23.23-28.63-23.9-31.89-23.9-17.34 0-23.8 10.61-24.07 11.06l-8.13 13.78-27.56-16.27 8.14-13.77c7.64-13 25.22-26.8 51.62-26.8 16.44 0 31.76 4.77 43.13 13.42 13.39 10.2 20.76 25.28 20.76 42.48A54 54 0 01240 302.35c-1.15 1.18-2.36 2.28-3.59 3.35a66.18 66.18 0 018.42 7.23c10.56 10.8 16.14 25.75 16.14 43.25 0 18.06-7.61 34-21.42 44.92-12.17 9.61-28.75 14.9-46.7 14.9-27.87 0-48.48-18.16-57.66-33.7l-8.13-13.78 27.56-16.27 8.16 13.75c1.08 1.84 11.15 18 30.1 18 16.66 0 36.12-7.29 36.12-27.82 0-6.25-1.22-14.95-7-20.88zM456 64h-55.92V32h-48v32H159.92V32h-48v32H56a23.8 23.8 0 00-24 23.77V144h448V87.77A23.8 23.8 0 00456 64z"
                }
            }
        ]
    })(props);
}
function IoCalendarNumber(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 64h-16V48.45c0-8.61-6.62-16-15.23-16.43A16 16 0 00368 48v16H144V48.45c0-8.61-6.62-16-15.23-16.43A16 16 0 00112 48v16H96a64 64 0 00-64 64v12a4 4 0 004 4h440a4 4 0 004-4v-12a64 64 0 00-64-64zm60 112H36a4 4 0 00-4 4v236a64 64 0 0064 64h320a64 64 0 0064-64V180a4 4 0 00-4-4zM239.58 401.1c-12.17 9.61-28.75 14.9-46.7 14.9-27.87 0-48.48-18.16-57.66-33.7a16 16 0 0127.56-16.3c1.08 1.84 11.15 18 30.1 18 16.66 0 36.12-7.29 36.12-27.82 0-6.25-1.22-14.95-7-20.88-8.54-8.74-22.75-12.67-30.11-12.67a16 16 0 010-32c4.85 0 17.41-2.6 25.28-10.65a22 22 0 006.57-16.08c0-23.23-28.63-23.9-31.89-23.9-17.34 0-23.8 10.61-24.07 11.06a16 16 0 11-27.55-16.26c7.64-13 25.22-26.8 51.62-26.8 16.44 0 31.76 4.77 43.13 13.42 13.39 10.2 20.76 25.28 20.76 42.48A54 54 0 01240 302.35c-1.15 1.18-2.36 2.28-3.59 3.35a66.18 66.18 0 018.42 7.23c10.56 10.8 16.14 25.75 16.14 43.25.03 18.06-7.58 34.01-21.39 44.92zM368 396a16 16 0 01-32 0V256.29l-22.51 16.59a16 16 0 11-19-25.76l43.42-32a16 16 0 019.49-3.12h4.6a16 16 0 0116 16z"
                }
            }
        ]
    })(props);
}
function IoCalendarOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "416",
                    "height": "384",
                    "x": "48",
                    "y": "80",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "296",
                    "cy": "232",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "376",
                    "cy": "232",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "296",
                    "cy": "312",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "376",
                    "cy": "312",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "136",
                    "cy": "312",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "216",
                    "cy": "312",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "136",
                    "cy": "392",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "216",
                    "cy": "392",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "296",
                    "cy": "392",
                    "r": "24"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M128 48v32m256-32v32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M464 160H48"
                }
            }
        ]
    })(props);
}
function IoCalendarSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 456a24 24 0 0024 24h400a24 24 0 0024-24V176H32zm320-244a4 4 0 014-4h40a4 4 0 014 4v40a4 4 0 01-4 4h-40a4 4 0 01-4-4zm0 80a4 4 0 014-4h40a4 4 0 014 4v40a4 4 0 01-4 4h-40a4 4 0 01-4-4zm-80-80a4 4 0 014-4h40a4 4 0 014 4v40a4 4 0 01-4 4h-40a4 4 0 01-4-4zm0 80a4 4 0 014-4h40a4 4 0 014 4v40a4 4 0 01-4 4h-40a4 4 0 01-4-4zm0 80a4 4 0 014-4h40a4 4 0 014 4v40a4 4 0 01-4 4h-40a4 4 0 01-4-4zm-80-80a4 4 0 014-4h40a4 4 0 014 4v40a4 4 0 01-4 4h-40a4 4 0 01-4-4zm0 80a4 4 0 014-4h40a4 4 0 014 4v40a4 4 0 01-4 4h-40a4 4 0 01-4-4zm-80-80a4 4 0 014-4h40a4 4 0 014 4v40a4 4 0 01-4 4h-40a4 4 0 01-4-4zm0 80a4 4 0 014-4h40a4 4 0 014 4v40a4 4 0 01-4 4h-40a4 4 0 01-4-4zM456 64h-55.92V32h-48v32H159.92V32h-48v32H56a23.8 23.8 0 00-24 23.77V144h448V87.77A23.8 23.8 0 00456 64z"
                }
            }
        ]
    })(props);
}
function IoCalendar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 128a64 64 0 00-64-64h-16V48.45c0-8.61-6.62-16-15.23-16.43A16 16 0 00368 48v16H144V48.45c0-8.61-6.62-16-15.23-16.43A16 16 0 00112 48v16H96a64 64 0 00-64 64v12a4 4 0 004 4h440a4 4 0 004-4zM32 416a64 64 0 0064 64h320a64 64 0 0064-64V179a3 3 0 00-3-3H35a3 3 0 00-3 3zm344-208a24 24 0 11-24 24 24 24 0 0124-24zm0 80a24 24 0 11-24 24 24 24 0 0124-24zm-80-80a24 24 0 11-24 24 24 24 0 0124-24zm0 80a24 24 0 11-24 24 24 24 0 0124-24zm0 80a24 24 0 11-24 24 24 24 0 0124-24zm-80-80a24 24 0 11-24 24 24 24 0 0124-24zm0 80a24 24 0 11-24 24 24 24 0 0124-24zm-80-80a24 24 0 11-24 24 24 24 0 0124-24zm0 80a24 24 0 11-24 24 24 24 0 0124-24z"
                }
            }
        ]
    })(props);
}
function IoCallOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M451 374c-15.88-16-54.34-39.35-73-48.76-24.3-12.24-26.3-13.24-45.4.95-12.74 9.47-21.21 17.93-36.12 14.75s-47.31-21.11-75.68-49.39-47.34-61.62-50.53-76.48 5.41-23.23 14.79-36c13.22-18 12.22-21 .92-45.3-8.81-18.9-32.84-57-48.9-72.8C119.9 44 119.9 47 108.83 51.6A160.15 160.15 0 0083 65.37C67 76 58.12 84.83 51.91 98.1s-9 44.38 23.07 102.64 54.57 88.05 101.14 134.49S258.5 406.64 310.85 436c64.76 36.27 89.6 29.2 102.91 23s22.18-15 32.83-31a159.09 159.09 0 0013.8-25.8C465 391.17 468 391.17 451 374z"
                }
            }
        ]
    })(props);
}
function IoCallSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M478.94 370.14c-5.22-5.56-23.65-22-57.53-43.75-34.13-21.94-59.3-35.62-66.52-38.81a3.83 3.83 0 00-3.92.49c-11.63 9.07-31.21 25.73-32.26 26.63-6.78 5.81-6.78 5.81-12.33 4-9.76-3.2-40.08-19.3-66.5-45.78s-43.35-57.55-46.55-67.3c-1.83-5.56-1.83-5.56 4-12.34.9-1.05 17.57-20.63 26.64-32.25a3.83 3.83 0 00.49-3.92c-3.19-7.23-16.87-32.39-38.81-66.52-21.78-33.87-38.2-52.3-43.76-57.52a3.9 3.9 0 00-3.89-.87 322.35 322.35 0 00-56 25.45A338 338 0 0033.35 92a3.83 3.83 0 00-1.26 3.74c2.09 9.74 12.08 50.4 43.08 106.72 31.63 57.48 53.55 86.93 100 133.22S252 405.21 309.54 436.84c56.32 31 97 41 106.72 43.07a3.86 3.86 0 003.75-1.26A337.73 337.73 0 00454.35 430a322.7 322.7 0 0025.45-56 3.9 3.9 0 00-.86-3.86z"
                }
            }
        ]
    })(props);
}
function IoCall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M391 480c-19.52 0-46.94-7.06-88-30-49.93-28-88.55-53.85-138.21-103.38C116.91 298.77 93.61 267.79 61 208.45c-36.84-67-30.56-102.12-23.54-117.13C45.82 73.38 58.16 62.65 74.11 52a176.3 176.3 0 0128.64-15.2c1-.43 1.93-.84 2.76-1.21 4.95-2.23 12.45-5.6 21.95-2 6.34 2.38 12 7.25 20.86 16 18.17 17.92 43 57.83 52.16 77.43 6.15 13.21 10.22 21.93 10.23 31.71 0 11.45-5.76 20.28-12.75 29.81-1.31 1.79-2.61 3.5-3.87 5.16-7.61 10-9.28 12.89-8.18 18.05 2.23 10.37 18.86 41.24 46.19 68.51s57.31 42.85 67.72 45.07c5.38 1.15 8.33-.59 18.65-8.47 1.48-1.13 3-2.3 4.59-3.47 10.66-7.93 19.08-13.54 30.26-13.54h.06c9.73 0 18.06 4.22 31.86 11.18 18 9.08 59.11 33.59 77.14 51.78 8.77 8.84 13.66 14.48 16.05 20.81 3.6 9.53.21 17-2 22-.37.83-.78 1.74-1.21 2.75a176.49 176.49 0 01-15.29 28.58c-10.63 15.9-21.4 28.21-39.38 36.58A67.42 67.42 0 01391 480z"
                }
            }
        ]
    })(props);
}
function IoCameraOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M350.54 148.68l-26.62-42.06C318.31 100.08 310.62 96 302 96h-92c-8.62 0-16.31 4.08-21.92 10.62l-26.62 42.06C155.85 155.23 148.62 160 140 160H80a32 32 0 00-32 32v192a32 32 0 0032 32h352a32 32 0 0032-32V192a32 32 0 00-32-32h-59c-8.65 0-16.85-4.77-22.46-11.32z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "272",
                    "r": "80",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M124 158v-22h-24v22"
                }
            }
        ]
    })(props);
}
function IoCameraReverseOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M350.54 148.68l-26.62-42.06C318.31 100.08 310.62 96 302 96h-92c-8.62 0-16.31 4.08-21.92 10.62l-26.62 42.06C155.85 155.23 148.62 160 140 160H80a32 32 0 00-32 32v192a32 32 0 0032 32h352a32 32 0 0032-32V192a32 32 0 00-32-32h-59c-8.65 0-16.85-4.77-22.46-11.32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M124 158v-22h-24v22m235.76 127.22v-13.31a80 80 0 00-131-61.6M176 258.78v13.31a80 80 0 00130.73 61.8"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M196 272l-20-20-20 20m200 0l-20 20-20-20"
                }
            }
        ]
    })(props);
}
function IoCameraReverseSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M456 144h-83c-3 0-6.72-1.94-9.62-5l-27.31-42.79C326 80 320 80 302 80h-92c-18 0-23 0-34.07 16.21L148.62 139c-2.22 2.42-5.34 5-8.62 5v-16a8 8 0 00-8-8H92a8 8 0 00-8 8v16H56a24 24 0 00-24 24v240a24 24 0 0024 24h400a24 24 0 0024-24V168a24 24 0 00-24-24zM256 368c-47.82 0-87.76-34.23-95-80h-43.63L176 229.37 234.63 288H194a64.07 64.07 0 00102.63 33.49L320 343l-3.68 3.72A96.64 96.64 0 01256 368zm80-53.84L277.11 256H318a64.26 64.26 0 00-103-33.36L192 200l3.14-2.45A96.19 96.19 0 01255.76 176c47.85 0 87 34.19 94.24 80h44.92z"
                }
            }
        ]
    })(props);
}
function IoCameraReverse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM316.84 346.3a96.06 96.06 0 01-155.66-59.18 16 16 0 01-16.49-26.43l20-20a16 16 0 0122.62 0l20 20A16 16 0 01196 288a17.31 17.31 0 01-2-.14 64.07 64.07 0 00102.66 33.63 16 16 0 1120.21 24.81zm50.47-63l-20 20a16 16 0 01-22.62 0l-20-20a16 16 0 0113.09-27.2A64 64 0 00215 222.64 16 16 0 11194.61 198a96 96 0 01156 59 16 16 0 0116.72 26.35z"
                }
            }
        ]
    })(props);
}
function IoCameraSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "272",
                    "r": "64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M456 144h-83c-3 0-6.72-1.94-9.62-5L336.1 96.2C325 80 320 80 302 80h-92c-18 0-24 0-34.07 16.21L148.62 139c-2.22 2.42-5.34 5-8.62 5v-16a8 8 0 00-8-8H92a8 8 0 00-8 8v16H56a24 24 0 00-24 24v240a24 24 0 0024 24h400a24 24 0 0024-24V168a24 24 0 00-24-24zM260.51 367.9a96 96 0 1191.39-91.39 96.11 96.11 0 01-91.39 91.39z"
                }
            }
        ]
    })(props);
}
function IoCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "272",
                    "r": "64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM256 368a96 96 0 1196-96 96.11 96.11 0 01-96 96z"
                }
            }
        ]
    })(props);
}
function IoCarOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M80 224l37.78-88.15C123.93 121.5 139.6 112 157.11 112h197.78c17.51 0 33.18 9.5 39.33 23.85L432 224m-352 0h352v144H80zm32 144v32H80v-32m352 0v32h-32v-32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "144",
                    "cy": "288",
                    "r": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "368",
                    "cy": "288",
                    "r": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function IoCarSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M447.68 220.78a16.44 16.44 0 00-1-3.1l-48-112A16 16 0 00384 96H128a16 16 0 00-14.71 9.7l-48 112a16.44 16.44 0 00-1 3.1A16.15 16.15 0 0064 224v184a8 8 0 008 8h32a8 8 0 008-8v-24h288v24a8 8 0 008 8h32a8 8 0 008-8V224a16.15 16.15 0 00-.32-3.22zM144 320a32 32 0 1132-32 32 32 0 01-32 32zm224 0a32 32 0 1132-32 32 32 0 01-32 32zM104.26 208l34.29-80h234.9l34.29 80z"
                }
            }
        ]
    })(props);
}
function IoCarSportOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M469.71 234.6c-7.33-9.73-34.56-16.43-46.08-33.94s-20.95-55.43-50.27-70S288 112 256 112s-88 4-117.36 18.63-38.75 52.52-50.27 70-38.75 24.24-46.08 33.97S29.8 305.84 32.94 336s9 48 9 48h86c14.08 0 18.66-5.29 47.46-8 31.6-3 62.6-4 80.6-4s50 1 81.58 4c28.8 2.73 33.53 8 47.46 8h85s5.86-17.84 9-48-2.04-91.67-9.33-101.4zM400 384h56v16h-56zm-344 0h56v16H56z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M364.47 309.16c-5.91-6.83-25.17-12.53-50.67-16.35S279 288 256.2 288s-33.17 1.64-57.61 4.81-42.79 8.81-50.66 16.35C136.12 320.6 153.42 333.44 167 335c13.16 1.5 39.47.95 89.31.95s76.15.55 89.31-.95c13.56-1.65 29.62-13.6 18.85-25.84zm67.1-66.11a3.23 3.23 0 00-3.1-3c-11.81-.42-23.8.42-45.07 6.69a93.88 93.88 0 00-30.08 15.06c-2.28 1.78-1.47 6.59 1.39 7.1a455.32 455.32 0 0052.82 3.1c10.59 0 21.52-3 23.55-12.44a52.41 52.41 0 00.49-16.51zm-351.14 0a3.23 3.23 0 013.1-3c11.81-.42 23.8.42 45.07 6.69a93.88 93.88 0 0130.08 15.06c2.28 1.78 1.47 6.59-1.39 7.1a455.32 455.32 0 01-52.82 3.1c-10.59 0-21.52-3-23.55-12.44a52.41 52.41 0 01-.49-16.51z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M432 192h16m-384 0h16m-2 19s46.35-12 178-12 178 12 178 12"
                }
            }
        ]
    })(props);
}
function IoCarSportSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 224c-3-5-32.61-17.79-32.61-17.79 5.15-2.66 8.67-3.21 8.67-14.21 0-12-.06-16-8.06-16h-27.14c-.11-.24-.23-.49-.34-.74-17.52-38.26-19.87-47.93-46-60.95C347.47 96.88 281.76 96 256 96s-91.47.88-126.49 18.31c-26.16 13-25.51 19.69-46 60.95 0 .11-.21.4-.4.74H55.94c-7.94 0-8 4-8 16 0 11 3.52 11.55 8.67 14.21C56.61 206.21 28 220 24 224s-8 32-8 80 4 96 4 96h11.94c0 14 2.06 16 8.06 16h80c6 0 8-2 8-16h256c0 14 2 16 8 16h82c4 0 6-3 6-16h12s4-49 4-96-5-75-8-80zm-362.74 44.94A516.94 516.94 0 0170.42 272c-20.42 0-21.12 1.31-22.56-11.44a72.16 72.16 0 01.51-17.51L49 240h3c12 0 23.27.51 44.55 6.78a98 98 0 0130.09 15.06C131 265 132 268 132 268zm247.16 72L368 352H144s.39-.61-5-11.18c-4-7.82 1-12.82 8.91-15.66C163.23 319.64 208 304 256 304s93.66 13.48 108.5 21.16C370 328 376.83 330 372.42 341zm-257-136.53a96.23 96.23 0 01-9.7.07c2.61-4.64 4.06-9.81 6.61-15.21 8-17 17.15-36.24 33.44-44.35 23.54-11.72 72.33-17 110.23-17s86.69 5.24 110.23 17c16.29 8.11 25.4 27.36 33.44 44.35 2.57 5.45 4 10.66 6.68 15.33-2 .11-4.3 0-9.79-.19zm347.72 56.11C461 273 463 272 441.58 272a516.94 516.94 0 01-54.84-3.06c-2.85-.51-3.66-5.32-1.38-7.1a93.84 93.84 0 0130.09-15.06c21.28-6.27 33.26-7.11 45.09-6.69a3.22 3.22 0 013.09 3 70.18 70.18 0 01-.49 17.47z"
                }
            }
        ]
    })(props);
}
function IoCarSport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M494.26 276.22c-3.6-40.41-9.53-48.28-11.77-51.24-5.15-6.84-13.39-11.31-22.11-16a3.6 3.6 0 01-.91-5.68 15.93 15.93 0 004.53-12.53A16.27 16.27 0 00447.65 176h-15.6a17 17 0 00-2 .13 8.5 8.5 0 00-1.41-.47c-9.24-19.53-21.89-46.27-48.11-59.32C341.64 97 270 96 256 96s-85.64 1-124.48 20.31c-26.22 13.05-38.87 39.79-48.11 59.32l-.08.16a6.52 6.52 0 00-1.35.34 17 17 0 00-2-.13H64.35A16.27 16.27 0 0048 190.77a15.93 15.93 0 004.59 12.47 3.6 3.6 0 01-.91 5.68c-8.72 4.72-17 9.19-22.11 16-2.24 3-8.16 10.83-11.77 51.24-2 22.74-2.3 46.28-.73 61.44 3.29 31.5 9.46 50.54 9.72 51.33a16 16 0 0013.2 10.87v.2a16 16 0 0016 16h56a16 16 0 0016-16c8.61 0 14.6-1.54 20.95-3.18a158.83 158.83 0 0128-4.91C207.45 389 237.79 388 256 388c17.84 0 49.52 1 80.08 3.91a159.16 159.16 0 0128.11 4.93c6.08 1.56 11.85 3 19.84 3.15a16 16 0 0016 16h56a16 16 0 0016-16v-.12A16 16 0 00485.27 389c.26-.79 6.43-19.83 9.72-51.33 1.57-15.17 1.29-38.67-.73-61.45zm-381.93-86.91c8-17 17.15-36.24 33.44-44.35 23.54-11.72 72.33-17 110.23-17s86.69 5.24 110.23 17c16.29 8.11 25.4 27.36 33.44 44.35l1 2.17a8 8 0 01-7.44 11.42C360 202 290 199.12 256 199.12s-104 2.95-137.28 3.85a8 8 0 01-7.44-11.42c.35-.74.72-1.49 1.05-2.24zm11.93 79.63A427.17 427.17 0 0172.42 272c-10.6 0-21.53-3-23.56-12.44-1.39-6.35-1.24-9.92-.49-13.51C49 243 50 240.78 55 240c13-2 20.27.51 41.55 6.78 14.11 4.15 24.29 9.68 30.09 14.06 2.91 2.16 1.36 7.8-2.38 8.1zm221.38 82c-13.16 1.5-39.48.95-89.34.95s-76.17.55-89.33-.95c-13.58-1.51-30.89-14.35-19.07-25.79 7.87-7.54 26.23-13.18 50.68-16.35s34.8-4.8 57.62-4.8 32.12 1 57.62 4.81 44.77 9.52 50.68 16.35c10.78 12.24-5.29 24.19-18.86 25.84zm117.5-91.39c-2 9.48-13 12.44-23.56 12.44a455.91 455.91 0 01-52.84-3.06c-3.06-.29-4.48-5.66-1.38-8.1 5.71-4.49 16-9.91 30.09-14.06 21.28-6.27 33.55-8.78 44.09-6.69 2.57.51 3.93 3.27 4.09 5a40.64 40.64 0 01-.49 14.48z"
                }
            }
        ]
    })(props);
}
function IoCar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M447.68 220.78a16 16 0 00-1-3.08l-37.78-88.16C400.19 109.17 379 96 354.89 96H157.11c-24.09 0-45.3 13.17-54 33.54L65.29 217.7A15.72 15.72 0 0064 224v176a16 16 0 0016 16h32a16 16 0 0016-16v-16h256v16a16 16 0 0016 16h32a16 16 0 0016-16V224a16.15 16.15 0 00-.32-3.22zM144 320a32 32 0 1132-32 32 32 0 01-32 32zm224 0a32 32 0 1132-32 32 32 0 01-32 32zM104.26 208l28.23-65.85C136.11 133.69 146 128 157.11 128h197.78c11.1 0 21 5.69 24.62 14.15L407.74 208z"
                }
            }
        ]
    })(props);
}
function IoCardOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "416",
                    "height": "320",
                    "x": "48",
                    "y": "96",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "56",
                    "ry": "56"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "60",
                    "d": "M48 192h416M128 300h48v20h-48z"
                }
            }
        ]
    })(props);
}
function IoCardSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 416a16 16 0 0016 16h416a16 16 0 0016-16V222H32zm66-138a8 8 0 018-8h92a8 8 0 018 8v64a8 8 0 01-8 8h-92a8 8 0 01-8-8zM464 80H48a16 16 0 00-16 16v66h448V96a16 16 0 00-16-16z"
                }
            }
        ]
    })(props);
}
function IoCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 376a56 56 0 0056 56h336a56 56 0 0056-56V222H32zm66-76a30 30 0 0130-30h48a30 30 0 0130 30v20a30 30 0 01-30 30h-48a30 30 0 01-30-30zM424 80H88a56 56 0 00-56 56v26h448v-26a56 56 0 00-56-56z"
                }
            }
        ]
    })(props);
}
function IoCaretBackCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M273.77 169.57l-89.09 74.13a16 16 0 000 24.6l89.09 74.13A16 16 0 00300 330.14V181.86a16 16 0 00-26.23-12.29z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            }
        ]
    })(props);
}
function IoCaretBackCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 256c0 114.87 93.13 208 208 208s208-93.13 208-208S370.87 48 256 48 48 141.13 48 256zm252 108.27L169.91 256 300 147.73z"
                }
            }
        ]
    })(props);
}
function IoCaretBackCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 256c0 114.87 93.13 208 208 208s208-93.13 208-208S370.87 48 256 48 48 141.13 48 256zm252-74.14v148.28a16 16 0 01-26.23 12.29l-89.09-74.13a16 16 0 010-24.6l89.09-74.13A16 16 0 01300 181.86z"
                }
            }
        ]
    })(props);
}
function IoCaretBackOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M321.94 98L158.82 237.78a24 24 0 000 36.44L321.94 414c15.57 13.34 39.62 2.28 39.62-18.22v-279.6c0-20.5-24.05-31.56-39.62-18.18z"
                }
            }
        ]
    })(props);
}
function IoCaretBackSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 64L144 256l224 192V64z"
                }
            }
        ]
    })(props);
}
function IoCaretBack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M321.94 98L158.82 237.78a24 24 0 000 36.44L321.94 414c15.57 13.34 39.62 2.28 39.62-18.22v-279.6c0-20.5-24.05-31.56-39.62-18.18z"
                }
            }
        ]
    })(props);
}
function IoCaretDownCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M342.43 238.23l-74.13 89.09a16 16 0 01-24.6 0l-74.13-89.09A16 16 0 01181.86 212h148.28a16 16 0 0112.29 26.23z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            }
        ]
    })(props);
}
function IoCaretDownCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256c0-114.87-93.13-208-208-208S48 141.13 48 256s93.13 208 208 208 208-93.13 208-208zm-99.73-44L256 342.09 147.73 212z"
                }
            }
        ]
    })(props);
}
function IoCaretDownCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256c0-114.87-93.13-208-208-208S48 141.13 48 256s93.13 208 208 208 208-93.13 208-208zm-121.57-17.77l-74.13 89.09a16 16 0 01-24.6 0l-74.13-89.09A16 16 0 01181.86 212h148.28a16 16 0 0112.29 26.23z"
                }
            }
        ]
    })(props);
}
function IoCaretDownOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M98 190.06l139.78 163.12a24 24 0 0036.44 0L414 190.06c13.34-15.57 2.28-39.62-18.22-39.62h-279.6c-20.5 0-31.56 24.05-18.18 39.62z"
                }
            }
        ]
    })(props);
}
function IoCaretDownSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 144l192 224 192-224H64z"
                }
            }
        ]
    })(props);
}
function IoCaretDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M98 190.06l139.78 163.12a24 24 0 0036.44 0L414 190.06c13.34-15.57 2.28-39.62-18.22-39.62h-279.6c-20.5 0-31.56 24.05-18.18 39.62z"
                }
            }
        ]
    })(props);
}
function IoCaretForwardCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M238.23 342.43l89.09-74.13a16 16 0 000-24.6l-89.09-74.13A16 16 0 00212 181.86v148.28a16 16 0 0026.23 12.29z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            }
        ]
    })(props);
}
function IoCaretForwardCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256c0-114.87-93.13-208-208-208S48 141.13 48 256s93.13 208 208 208 208-93.13 208-208zM212 147.73L342.09 256 212 364.27z"
                }
            }
        ]
    })(props);
}
function IoCaretForwardCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256c0-114.87-93.13-208-208-208S48 141.13 48 256s93.13 208 208 208 208-93.13 208-208zm-252 74.14V181.86a16 16 0 0126.23-12.29l89.09 74.13a16 16 0 010 24.6l-89.09 74.13A16 16 0 01212 330.14z"
                }
            }
        ]
    })(props);
}
function IoCaretForwardOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M190.06 414l163.12-139.78a24 24 0 000-36.44L190.06 98c-15.57-13.34-39.62-2.28-39.62 18.22v279.6c0 20.5 24.05 31.56 39.62 18.18z"
                }
            }
        ]
    })(props);
}
function IoCaretForwardSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 448l224-192L144 64v384z"
                }
            }
        ]
    })(props);
}
function IoCaretForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M190.06 414l163.12-139.78a24 24 0 000-36.44L190.06 98c-15.57-13.34-39.62-2.28-39.62 18.22v279.6c0 20.5 24.05 31.56 39.62 18.18z"
                }
            }
        ]
    })(props);
}
function IoCaretUpCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M342.43 273.77l-74.13-89.09a16 16 0 00-24.6 0l-74.13 89.09A16 16 0 00181.86 300h148.28a16 16 0 0012.29-26.23z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            }
        ]
    })(props);
}
function IoCaretUpCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zM147.73 300L256 169.91 364.27 300z"
                }
            }
        ]
    })(props);
}
function IoCaretUpCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm74.14 252H181.86a16 16 0 01-12.29-26.23l74.13-89.09a16 16 0 0124.6 0l74.13 89.09A16 16 0 01330.14 300z"
                }
            }
        ]
    })(props);
}
function IoCaretUpOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414 321.94L274.22 158.82a24 24 0 00-36.44 0L98 321.94c-13.34 15.57-2.28 39.62 18.22 39.62h279.6c20.5 0 31.56-24.05 18.18-39.62z"
                }
            }
        ]
    })(props);
}
function IoCaretUpSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 368L256 144 64 368h384z"
                }
            }
        ]
    })(props);
}
function IoCaretUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414 321.94L274.22 158.82a24 24 0 00-36.44 0L98 321.94c-13.34 15.57-2.28 39.62 18.22 39.62h279.6c20.5 0 31.56-24.05 18.18-39.62z"
                }
            }
        ]
    })(props);
}
function IoCartOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "176",
                    "cy": "416",
                    "r": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "400",
                    "cy": "416",
                    "r": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 80h64l48 272h256"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 288h249.44a8 8 0 007.85-6.43l28.8-144a8 8 0 00-7.85-9.57H128"
                }
            }
        ]
    })(props);
}
function IoCartSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "176",
                    "cy": "416",
                    "r": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "400",
                    "cy": "416",
                    "r": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M167.78 304h261.34l38.4-192H133.89l-8.47-48H32v32h66.58l48 272H432v-32H173.42l-5.64-32z"
                }
            }
        ]
    })(props);
}
function IoCart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "176",
                    "cy": "416",
                    "r": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "400",
                    "cy": "416",
                    "r": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M456.8 120.78a23.92 23.92 0 00-18.56-8.78H133.89l-6.13-34.78A16 16 0 00112 64H48a16 16 0 000 32h50.58l45.66 258.78A16 16 0 00160 368h256a16 16 0 000-32H173.42l-5.64-32h241.66A24.07 24.07 0 00433 284.71l28.8-144a24 24 0 00-5-19.93z"
                }
            }
        ]
    })(props);
}
function IoCashOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "448",
                    "height": "256",
                    "x": "32",
                    "y": "80",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "16",
                    "ry": "16",
                    "transform": "rotate(180 256 208)"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M64 384h384M96 432h320"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "208",
                    "r": "80",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M480 160a80 80 0 01-80-80M32 160a80 80 0 0080-80m368 176a80 80 0 00-80 80M32 256a80 80 0 0180 80"
                }
            }
        ]
    })(props);
}
function IoCashSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 368h416v32H48zm32 48h352v32H80zm400-240a96.11 96.11 0 01-96-96V64H128v16a96.11 96.11 0 01-96 96H16v64h16a96.11 96.11 0 0196 96v16h256v-16a96.11 96.11 0 0196-96h16v-64zM256 304a96 96 0 1196-96 96.11 96.11 0 01-96 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M96 80V64H16v80h16a64.07 64.07 0 0064-64zM32 272H16v80h80v-16a64.07 64.07 0 00-64-64zm448-128h16V64h-80v16a64.07 64.07 0 0064 64zm-64 192v16h80v-80h-16a64.07 64.07 0 00-64 64z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "208",
                    "r": "64"
                }
            }
        ]
    })(props);
}
function IoCash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 400H64a16 16 0 010-32h384a16 16 0 010 32zm-32 48H96a16 16 0 010-32h320a16 16 0 010 32zM32 272H16v48a32 32 0 0032 32h48v-16a64.07 64.07 0 00-64-64z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M480 240h16v-64h-16a96.11 96.11 0 01-96-96V64H128v16a96.11 96.11 0 01-96 96H16v64h16a96.11 96.11 0 0196 96v16h256v-16a96.11 96.11 0 0196-96zm-224 64a96 96 0 1196-96 96.11 96.11 0 01-96 96z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "208",
                    "r": "64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M416 336v16h48a32 32 0 0032-32v-48h-16a64.07 64.07 0 00-64 64zm64-192h16V96a32 32 0 00-32-32h-48v16a64.07 64.07 0 0064 64zM96 80V64H48a32 32 0 00-32 32v48h16a64.07 64.07 0 0064-64z"
                }
            }
        ]
    })(props);
}
function IoCellularOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "64",
                    "height": "320",
                    "x": "416",
                    "y": "96",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "64",
                    "height": "240",
                    "x": "288",
                    "y": "176",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "64",
                    "height": "176",
                    "x": "160",
                    "y": "240",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "64",
                    "height": "112",
                    "x": "32",
                    "y": "304",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "8",
                    "ry": "8"
                }
            }
        ]
    })(props);
}
function IoCellularSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 432h-96V80h96zm-128 0h-96V160h96zm-128 0h-96V224h96zm-128 0H16V288h96z"
                }
            }
        ]
    })(props);
}
function IoCellular(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M472 432h-48a24 24 0 01-24-24V104a24 24 0 0124-24h48a24 24 0 0124 24v304a24 24 0 01-24 24zm-128 0h-48a24 24 0 01-24-24V184a24 24 0 0124-24h48a24 24 0 0124 24v224a24 24 0 01-24 24zm-128 0h-48a24 24 0 01-24-24V248a24 24 0 0124-24h48a24 24 0 0124 24v160a24 24 0 01-24 24zm-128 0H40a24 24 0 01-24-24v-96a24 24 0 0124-24h48a24 24 0 0124 24v96a24 24 0 01-24 24z"
                }
            }
        ]
    })(props);
}
function IoChatboxEllipsesOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M408 64H104a56.16 56.16 0 00-56 56v192a56.16 56.16 0 0056 56h40v80l93.72-78.14a8 8 0 015.13-1.86H408a56.16 56.16 0 0056-56V120a56.16 56.16 0 00-56-56z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "160",
                    "cy": "216",
                    "r": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "216",
                    "r": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "352",
                    "cy": "216",
                    "r": "32"
                }
            }
        ]
    })(props);
}
function IoChatboxEllipsesSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M456 48H56a24 24 0 00-24 24v288a24 24 0 0024 24h72v80l117.74-80H456a24 24 0 0024-24V72a24 24 0 00-24-24zM160 248a32 32 0 1132-32 32 32 0 01-32 32zm96 0a32 32 0 1132-32 32 32 0 01-32 32zm96 0a32 32 0 1132-32 32 32 0 01-32 32zM456 80z"
                }
            }
        ]
    })(props);
}
function IoChatboxEllipses(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408 48H104a72.08 72.08 0 00-72 72v192a72.08 72.08 0 0072 72h24v64a16 16 0 0026.25 12.29L245.74 384H408a72.08 72.08 0 0072-72V120a72.08 72.08 0 00-72-72zM160 248a32 32 0 1132-32 32 32 0 01-32 32zm96 0a32 32 0 1132-32 32 32 0 01-32 32zm96 0a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function IoChatboxOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M408 64H104a56.16 56.16 0 00-56 56v192a56.16 56.16 0 0056 56h40v80l93.72-78.14a8 8 0 015.13-1.86H408a56.16 56.16 0 0056-56V120a56.16 56.16 0 00-56-56z"
                }
            }
        ]
    })(props);
}
function IoChatboxSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 464v-80H56a24 24 0 01-24-24V72a24 24 0 0124-24h400a24 24 0 0124 24v288a24 24 0 01-24 24H245.74zM456 80z"
                }
            }
        ]
    })(props);
}
function IoChatbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 464a16 16 0 01-16-16v-64h-24a72.08 72.08 0 01-72-72V120a72.08 72.08 0 0172-72h304a72.08 72.08 0 0172 72v192a72.08 72.08 0 01-72 72H245.74l-91.49 76.29A16.05 16.05 0 01144 464z"
                }
            }
        ]
    })(props);
}
function IoChatbubbleEllipsesOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M87.48 380c1.2-4.38-1.43-10.47-3.94-14.86a42.63 42.63 0 00-2.54-3.8 199.81 199.81 0 01-33-110C47.64 139.09 140.72 48 255.82 48 356.2 48 440 117.54 459.57 209.85a199 199 0 014.43 41.64c0 112.41-89.49 204.93-204.59 204.93-18.31 0-43-4.6-56.47-8.37s-26.92-8.77-30.39-10.11a31.14 31.14 0 00-11.13-2.07 30.7 30.7 0 00-12.08 2.43L81.5 462.78a15.92 15.92 0 01-4.66 1.22 9.61 9.61 0 01-9.58-9.74 15.85 15.85 0 01.6-3.29z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "160",
                    "cy": "256",
                    "r": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "352",
                    "cy": "256",
                    "r": "32"
                }
            }
        ]
    })(props);
}
function IoChatbubbleEllipsesSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M475.22 206.52c-10.34-48.65-37.76-92.93-77.22-124.68A227.4 227.4 0 00255.82 32C194.9 32 138 55.47 95.46 98.09 54.35 139.33 31.82 193.78 32 251.37a215.66 215.66 0 0035.65 118.76l4.35 6.05L48 480l114.8-28.56s2.3.77 4 1.42 16.33 6.26 31.85 10.6c12.9 3.6 39.74 9 60.77 9 59.65 0 115.35-23.1 156.83-65.06C457.36 365.77 480 310.42 480 251.49a213.5 213.5 0 00-4.78-44.97zM160 288a32 32 0 1132-32 32 32 0 01-32 32zm96 0a32 32 0 1132-32 32 32 0 01-32 32zm96 0a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function IoChatbubbleEllipses(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M398 81.84A227.4 227.4 0 00255.82 32C194.9 32 138 55.47 95.46 98.09 54.35 139.33 31.82 193.78 32 251.37a215.66 215.66 0 0035.65 118.76l.19.27c.28.41.57.82.86 1.22s.65.92.73 1.05l.22.4c1.13 2 2 4.44 1.23 6.9l-18.42 66.66a29.13 29.13 0 00-1.2 7.63A25.69 25.69 0 0076.83 480a29.44 29.44 0 0010.45-2.29l67.49-24.36.85-.33a14.75 14.75 0 015.8-1.15 15.12 15.12 0 015.37 1c1.62.63 16.33 6.26 31.85 10.6 12.9 3.6 39.74 9 60.77 9 59.65 0 115.35-23.1 156.83-65.06C457.36 365.77 480 310.42 480 251.49a213.5 213.5 0 00-4.78-45c-10.34-48.62-37.76-92.9-77.22-124.65zM87.48 380zM160 288a32 32 0 1132-32 32 32 0 01-32 32zm96 0a32 32 0 1132-32 32 32 0 01-32 32zm96 0a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function IoChatbubbleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M87.49 380c1.19-4.38-1.44-10.47-3.95-14.86a44.86 44.86 0 00-2.54-3.8 199.81 199.81 0 01-33-110C47.65 139.09 140.73 48 255.83 48 356.21 48 440 117.54 459.58 209.85a199 199 0 014.42 41.64c0 112.41-89.49 204.93-204.59 204.93-18.3 0-43-4.6-56.47-8.37s-26.92-8.77-30.39-10.11a31.09 31.09 0 00-11.12-2.07 30.71 30.71 0 00-12.09 2.43l-67.83 24.48a16 16 0 01-4.67 1.22 9.6 9.6 0 01-9.57-9.74 15.85 15.85 0 01.6-3.29z"
                }
            }
        ]
    })(props);
}
function IoChatbubbleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M475.22 206.52c-10.34-48.65-37.76-92.93-77.22-124.68A227.4 227.4 0 00255.82 32C194.9 32 138 55.47 95.46 98.09 54.35 139.33 31.82 193.78 32 251.37a215.66 215.66 0 0035.65 118.76l4.35 6.05L48 480l114.8-28.56s2.3.77 4 1.42 16.33 6.26 31.85 10.6c12.9 3.6 39.74 9 60.77 9 59.65 0 115.35-23.1 156.83-65.06C457.36 365.77 480 310.42 480 251.49a213.5 213.5 0 00-4.78-44.97z"
                }
            }
        ]
    })(props);
}
function IoChatbubble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M76.83 480a25.69 25.69 0 01-25.57-25.74 29.13 29.13 0 011.2-7.63L70.88 380c.77-2.46-.1-4.94-1.23-6.9l-.22-.4c-.08-.13-.46-.66-.73-1.05s-.58-.81-.86-1.22l-.19-.27A215.66 215.66 0 0132 251.37c-.18-57.59 22.35-112 63.46-153.28C138 55.47 194.9 32 255.82 32A227.4 227.4 0 01398 81.84c39.45 31.75 66.87 76 77.21 124.68a213.5 213.5 0 014.78 45c0 58.93-22.64 114.28-63.76 155.87-41.48 42-97.18 65.06-156.83 65.06-21 0-47.87-5.36-60.77-9-15.52-4.34-30.23-10-31.85-10.6a15.12 15.12 0 00-5.37-1 14.75 14.75 0 00-5.8 1.15l-.85.33-67.48 24.38A29.44 29.44 0 0176.83 480zm-2-31.8zM87.48 380z"
                }
            }
        ]
    })(props);
}
function IoChatbubblesOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M431 320.6c-1-3.6 1.2-8.6 3.3-12.2a33.68 33.68 0 012.1-3.1A162 162 0 00464 215c.3-92.2-77.5-167-173.7-167-83.9 0-153.9 57.1-170.3 132.9a160.7 160.7 0 00-3.7 34.2c0 92.3 74.8 169.1 171 169.1 15.3 0 35.9-4.6 47.2-7.7s22.5-7.2 25.4-8.3a26.44 26.44 0 019.3-1.7 26 26 0 0110.1 2l56.7 20.1a13.52 13.52 0 003.9 1 8 8 0 008-8 12.85 12.85 0 00-.5-2.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M66.46 232a146.23 146.23 0 006.39 152.67c2.31 3.49 3.61 6.19 3.21 8s-11.93 61.87-11.93 61.87a8 8 0 002.71 7.68A8.17 8.17 0 0072 464a7.26 7.26 0 002.91-.6l56.21-22a15.7 15.7 0 0112 .2c18.94 7.38 39.88 12 60.83 12A159.21 159.21 0 00284 432.11"
                }
            }
        ]
    })(props);
}
function IoChatbubblesSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 312.43c.77-1.11 1.51-2.26 2.27-3.34A174.55 174.55 0 00480 211.85C480.32 112.55 396.54 32 292.94 32c-90.36 0-165.74 61.49-183.4 143.12a172.81 172.81 0 00-4 36.83c0 99.4 80.56 182.11 184.16 182.11 16.47 0 38.66-4.95 50.83-8.29s24.23-7.75 27.35-8.94 8-2.41 11.89-1.29l77.42 22.38a4 4 0 005-4.86l-17.72-67.49c-1.23-5-1.39-5.94 3.53-13.14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M312.54 415.38a165.32 165.32 0 01-23.26 2.05c-42.43 0-82.5-11.2-115-32.2a184.09 184.09 0 01-53.09-49.32c-26.08-34.57-40.3-78.51-40.3-124.49 0-3.13.11-6.14.22-9.16a4.34 4.34 0 00-7.54-3.12 158.76 158.76 0 00-14.86 195.24c2.47 3.77 3.87 6.68 3.44 8.62l-14.09 72.26a4 4 0 005.22 4.53l68-24.24a16.85 16.85 0 0112.92.22c20.35 8 42.86 12.92 65.37 12.92a169.45 169.45 0 00116.63-46 4.29 4.29 0 00-3.66-7.31z"
                }
            }
        ]
    })(props);
}
function IoChatbubbles(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M60.44 389.17c0 .07 0 .2-.08.38.03-.12.05-.25.08-.38zM439.9 405.6a26.77 26.77 0 01-9.59-2l-56.78-20.13-.42-.17a9.88 9.88 0 00-3.91-.76 10.32 10.32 0 00-3.62.66c-1.38.52-13.81 5.19-26.85 8.77-7.07 1.94-31.68 8.27-51.43 8.27-50.48 0-97.68-19.4-132.89-54.63A183.38 183.38 0 01100.3 215.1a175.9 175.9 0 014.06-37.58c8.79-40.62 32.07-77.57 65.55-104A194.76 194.76 0 01290.3 32c52.21 0 100.86 20 137 56.18 34.16 34.27 52.88 79.33 52.73 126.87a177.86 177.86 0 01-30.3 99.15l-.19.28-.74 1c-.17.23-.34.45-.5.68l-.15.27a21.63 21.63 0 00-1.08 2.09l15.74 55.94a26.42 26.42 0 011.12 7.11 24 24 0 01-24.03 24.03z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M299.87 425.39a15.74 15.74 0 00-10.29-8.1c-5.78-1.53-12.52-1.27-17.67-1.65a201.78 201.78 0 01-128.82-58.75A199.21 199.21 0 0186.4 244.16C85 234.42 85 232 85 232a16 16 0 00-28-10.58s-7.88 8.58-11.6 17.19a162.09 162.09 0 0011 150.06C59 393 59 395 58.42 399.5c-2.73 14.11-7.51 39-10 51.91a24 24 0 008 22.92l.46.39A24.34 24.34 0 0072 480a23.42 23.42 0 009-1.79l53.51-20.65a8.05 8.05 0 015.72 0c21.07 7.84 43 12 63.78 12a176 176 0 0074.91-16.66c5.46-2.56 14-5.34 19-11.12a15 15 0 001.95-16.39z"
                }
            }
        ]
    })(props);
}
function IoCheckboxOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 176L217.6 336 160 272"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "384",
                    "height": "384",
                    "x": "64",
                    "y": "64",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48"
                }
            }
        ]
    })(props);
}
function IoCheckboxSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 48v416h416V48zm170 312.38l-80.6-89.57 23.79-21.41 56 62.22L350 153.46 374.54 174z"
                }
            }
        ]
    })(props);
}
function IoCheckbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 48H112a64.07 64.07 0 00-64 64v288a64.07 64.07 0 0064 64h288a64.07 64.07 0 0064-64V112a64.07 64.07 0 00-64-64zm-35.75 138.29l-134.4 160a16 16 0 01-12 5.71h-.27a16 16 0 01-11.89-5.3l-57.6-64a16 16 0 1123.78-21.4l45.29 50.32 122.59-145.91a16 16 0 0124.5 20.58z"
                }
            }
        ]
    })(props);
}
function IoCheckmarkCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 176L217.6 336 160 272"
                }
            }
        ]
    })(props);
}
function IoCheckmarkCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-38 312.38l-80.6-89.57 23.79-21.41 56 62.22L350 153.46 374.54 174z"
                }
            }
        ]
    })(props);
}
function IoCheckmarkCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm108.25 138.29l-134.4 160a16 16 0 01-12 5.71h-.27a16 16 0 01-11.89-5.3l-57.6-64a16 16 0 1123.78-21.4l45.29 50.32 122.59-145.91a16 16 0 0124.5 20.58z"
                }
            }
        ]
    })(props);
}
function IoCheckmarkDoneCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M368 192L256.13 320l-47.95-48m-16.23 48L144 272m161.71-80l-51.55 59"
                }
            }
        ]
    })(props);
}
function IoCheckmarkDoneCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm48.19 121.42l24.1 21.06-73.61 84.1-24.1-23.06zM191.93 342.63L121.37 272 144 249.37 214.57 320zm65 .79L185.55 272l22.64-22.62 47.16 47.21 111.13-127.17 24.1 21.06z"
                }
            }
        ]
    })(props);
}
function IoCheckmarkDoneCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M258.9 48C141.92 46.42 46.42 141.92 48 258.9c1.56 112.19 92.91 203.54 205.1 205.1 117 1.6 212.48-93.9 210.88-210.88C462.44 140.91 371.09 49.56 258.9 48zm-16.79 192.47l51.55-59a16 16 0 0124.1 21.06l-51.55 59a16 16 0 11-24.1-21.06zm-38.86 90.85a16 16 0 01-22.62 0l-47.95-48a16 16 0 1122.64-22.62l48 48a16 16 0 01-.07 22.62zm176.8-128.79l-111.88 128a16 16 0 01-11.51 5.47h-.54a16 16 0 01-11.32-4.69l-47.94-48a16 16 0 1122.64-22.62l29.8 29.83a8 8 0 0011.68-.39l95-108.66a16 16 0 0124.1 21.06z"
                }
            }
        ]
    })(props);
}
function IoCheckmarkDoneOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M464 128L240 384l-96-96m0 96l-96-96m320-160L232 284"
                }
            }
        ]
    })(props);
}
function IoCheckmarkDoneSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "44",
                    "d": "M465 127L241 384l-92-92m-9 93l-93-93m316-165L236 273"
                }
            }
        ]
    })(props);
}
function IoCheckmarkDone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M464 128L240 384l-96-96m0 96l-96-96m320-160L232 284"
                }
            }
        ]
    })(props);
}
function IoCheckmarkOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M416 128L192 384l-96-96"
                }
            }
        ]
    })(props);
}
function IoCheckmarkSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "44",
                    "d": "M416 128L192 384l-96-96"
                }
            }
        ]
    })(props);
}
function IoCheckmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M416 128L192 384l-96-96"
                }
            }
        ]
    })(props);
}
function IoChevronBackCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M296 352l-96-96 96-96"
                }
            }
        ]
    })(props);
}
function IoChevronBackCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm62.63 304L296 374.63 177.37 256 296 137.37 318.63 160l-96 96z"
                }
            }
        ]
    })(props);
}
function IoChevronBackCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm35.31 292.69a16 16 0 11-22.62 22.62l-96-96a16 16 0 010-22.62l96-96a16 16 0 0122.62 22.62L206.63 256z"
                }
            }
        ]
    })(props);
}
function IoChevronBackOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M328 112L184 256l144 144"
                }
            }
        ]
    })(props);
}
function IoChevronBackSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "48",
                    "d": "M328 112L184 256l144 144"
                }
            }
        ]
    })(props);
}
function IoChevronBack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M328 112L184 256l144 144"
                }
            }
        ]
    })(props);
}
function IoChevronDownCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 216l-96 96-96-96"
                }
            }
        ]
    })(props);
}
function IoChevronDownCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 464c114.87 0 208-93.13 208-208S370.87 48 256 48 48 141.13 48 256s93.13 208 208 208zm-96-270.63l96 96 96-96L374.63 216 256 334.63 137.37 216z"
                }
            }
        ]
    })(props);
}
function IoChevronDownCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256c0-114.87-93.13-208-208-208S48 141.13 48 256s93.13 208 208 208 208-93.13 208-208zm-100.69-28.69l-96 96a16 16 0 01-22.62 0l-96-96a16 16 0 0122.62-22.62L256 289.37l84.69-84.68a16 16 0 0122.62 22.62z"
                }
            }
        ]
    })(props);
}
function IoChevronDownOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M112 184l144 144 144-144"
                }
            }
        ]
    })(props);
}
function IoChevronDownSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "48",
                    "d": "M112 184l144 144 144-144"
                }
            }
        ]
    })(props);
}
function IoChevronDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M112 184l144 144 144-144"
                }
            }
        ]
    })(props);
}
function IoChevronForwardCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M64 256c0 106 86 192 192 192s192-86 192-192S362 64 256 64 64 150 64 256z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M216 352l96-96-96-96"
                }
            }
        ]
    })(props);
}
function IoChevronForwardCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm-40 326.63L193.37 352l96-96-96-96L216 137.37 334.63 256z"
                }
            }
        ]
    })(props);
}
function IoChevronForwardCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 256c0 114.87 93.13 208 208 208s208-93.13 208-208S370.87 48 256 48 48 141.13 48 256zm257.37 0l-84.68-84.69a16 16 0 0122.62-22.62l96 96a16 16 0 010 22.62l-96 96a16 16 0 01-22.62-22.62z"
                }
            }
        ]
    })(props);
}
function IoChevronForwardOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M184 112l144 144-144 144"
                }
            }
        ]
    })(props);
}
function IoChevronForwardSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "48",
                    "d": "M184 112l144 144-144 144"
                }
            }
        ]
    })(props);
}
function IoChevronForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M184 112l144 144-144 144"
                }
            }
        ]
    })(props);
}
function IoChevronUpCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 296l-96-96-96 96"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z"
                }
            }
        ]
    })(props);
}
function IoChevronUpCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm96 270.63l-96-96-96 96L137.37 296 256 177.37 374.63 296z"
                }
            }
        ]
    })(props);
}
function IoChevronUpCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm107.31 259.31a16 16 0 01-22.62 0L256 222.63l-84.69 84.68a16 16 0 01-22.62-22.62l96-96a16 16 0 0122.62 0l96 96a16 16 0 010 22.62z"
                }
            }
        ]
    })(props);
}
function IoChevronUpOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M112 328l144-144 144 144"
                }
            }
        ]
    })(props);
}
function IoChevronUpSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "48",
                    "d": "M112 328l144-144 144 144"
                }
            }
        ]
    })(props);
}
function IoChevronUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M112 328l144-144 144 144"
                }
            }
        ]
    })(props);
}
function IoClipboardOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M336 64h32a48 48 0 0148 48v320a48 48 0 01-48 48H144a48 48 0 01-48-48V112a48 48 0 0148-48h32"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "160",
                    "height": "64",
                    "x": "176",
                    "y": "32",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "26.13",
                    "ry": "26.13"
                }
            }
        ]
    })(props);
}
function IoClipboardSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M420 48h-68V28a12 12 0 00-12-12H172a12 12 0 00-12 12v20H92a12 12 0 00-12 12v424a12 12 0 0012 12h328a12 12 0 0012-12V60a12 12 0 00-12-12zm-84.13 64H176.13V80h159.74z"
                }
            }
        ]
    })(props);
}
function IoClipboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 48h-11.41a8 8 0 01-7.44-5.08A42.18 42.18 0 00309.87 16H202.13a42.18 42.18 0 00-39.28 26.92 8 8 0 01-7.44 5.08H144a64 64 0 00-64 64v320a64 64 0 0064 64h224a64 64 0 0064-64V112a64 64 0 00-64-64zm-48.13 64H192.13a16 16 0 010-32h127.74a16 16 0 010 32z"
                }
            }
        ]
    })(props);
}
function IoCloseCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 320L192 192m0 128l128-128"
                }
            }
        ]
    })(props);
}
function IoCloseCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm86.63 272L320 342.63l-64-64-64 64L169.37 320l64-64-64-64L192 169.37l64 64 64-64L342.63 192l-64 64z"
                }
            }
        ]
    })(props);
}
function IoCloseCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm75.31 260.69a16 16 0 11-22.62 22.62L256 278.63l-52.69 52.68a16 16 0 01-22.62-22.62L233.37 256l-52.68-52.69a16 16 0 0122.62-22.62L256 233.37l52.69-52.68a16 16 0 0122.62 22.62L278.63 256z"
                }
            }
        ]
    })(props);
}
function IoCloseOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M368 368L144 144m224 0L144 368"
                }
            }
        ]
    })(props);
}
function IoCloseSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 145.49L366.51 112 256 222.51 145.49 112 112 145.49 222.51 256 112 366.51 145.49 400 256 289.49 366.51 400 400 366.51 289.49 256 400 145.49z"
                }
            }
        ]
    })(props);
}
function IoClose(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"
                }
            }
        ]
    })(props);
}
function IoCloudCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M333.88 240.59a8 8 0 01-6.66-6.66C320.68 192.78 290.82 168 256 168c-32.37 0-53.93 21.22-62.48 43.58a7.92 7.92 0 01-6.16 5c-27.67 4.35-50.82 22.56-51.35 54.3-.52 31.53 25.51 57.11 57 57.11H326c27.5 0 50-13.72 50-44 0-27.22-22-40.41-42.12-43.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            }
        ]
    })(props);
}
function IoCloudCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm70 280H196c-33 0-60-23-60-56 0-34.21 26-53 56-56 7.28-23.9 29.5-48 64-48 36.5 0 67.55 27.23 72 72 21.49 1.12 48 14.09 48 44 0 30.28-22.5 44-50 44z"
                }
            }
        ]
    })(props);
}
function IoCloudCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm70 280H193.05c-31.53 0-57.56-25.58-57-57.11.53-31.74 23.68-49.95 51.35-54.3a7.92 7.92 0 006.16-5C202.07 189.22 223.63 168 256 168c33.17 0 61.85 22.49 70.14 60.21a17.75 17.75 0 0013.18 13.43C357.79 246.05 376 259.21 376 284c0 30.28-22.5 44-50 44z"
                }
            }
        ]
    })(props);
}
function IoCloudDoneOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M400 240c-8.89-89.54-71-144-144-144-69 0-113.44 48.2-128 96-60 6-112 43.59-112 112 0 66 54 112 120 112h260c55 0 100-27.44 100-88 0-59.82-53-85.76-96-88z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M317 208L209.2 336 163 284.8"
                }
            }
        ]
    })(props);
}
function IoCloudDoneSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.25 225.36c-6.52-41.18-24.05-76.4-51.11-102.46A153.57 153.57 0 00256 80c-35.5 0-68.24 11.69-94.68 33.8a156.42 156.42 0 00-45.22 63.61c-30.26 4.81-57.45 17.18-77.38 35.37C13.39 235.88 0 267.42 0 304c0 36 14.38 68.88 40.49 92.59C65.64 419.43 99.56 432 136 432h260c32.37 0 60.23-8.57 80.59-24.77C499.76 388.78 512 361.39 512 328c0-61.85-48.44-95.34-97.75-102.64zm-204.63 135l-69.22-76.7 23.76-21.44 44.62 49.46 106.29-126.2 24.47 20.61z"
                }
            }
        ]
    })(props);
}
function IoCloudDone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M424.44 227.25a16 16 0 01-12.12-12.39c-7.68-36.68-24.45-68.15-49.18-92A153.57 153.57 0 00256 80c-35.5 0-68.24 11.69-94.68 33.8a156.24 156.24 0 00-42 56 16 16 0 01-11.37 9.15c-27 5.62-51.07 17.34-69.18 33.87C13.39 235.88 0 267.42 0 304c0 36 14.38 68.88 40.49 92.59C65.64 419.43 99.56 432 136 432h260c32.37 0 60.23-8.57 80.59-24.77C499.76 388.78 512 361.39 512 328c0-57.57-42-90.58-87.56-100.75zm-95.2-8.94l-107.8 128a16 16 0 01-12 5.69h-.27a16 16 0 01-11.88-5.28l-45.9-50.87c-5.77-6.39-5.82-16.33.3-22.4a16 16 0 0123.16.63l33.9 37.58 96-114a16 16 0 1124.48 20.62z"
                }
            }
        ]
    })(props);
}
function IoCloudDownloadOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 336h76c55 0 100-21.21 100-75.6s-53-73.47-96-75.6C391.11 99.74 329 48 256 48c-69 0-113.44 45.79-128 91.2-60 5.7-112 35.88-112 98.4S70 336 136 336h56m0 64.1l64 63.9 64-63.9M256 224v224.03"
                }
            }
        ]
    })(props);
}
function IoCloudDownloadSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M472.7 189.5c-15.76-10-36.21-16.79-58.59-19.54-6.65-39.1-24.22-72.52-51.27-97.26C334.15 46.45 296.21 32 256 32c-35.35 0-68 11.08-94.37 32a149.7 149.7 0 00-45.29 60.42c-30.67 4.32-57 14.61-76.71 30C13.7 174.83 0 203.56 0 237.6 0 305 55.92 352 136 352h104V208h32v144h124c72.64 0 116-34.24 116-91.6 0-30.05-13.59-54.57-39.3-70.9zM240 419.42L191.98 371l-22.61 23L256 480l86.63-86-22.61-23L272 419.42V352h-32v67.42z"
                }
            }
        ]
    })(props);
}
function IoCloudDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M472.7 189.5c-13.26-8.43-29.83-14.56-48.08-17.93A16 16 0 01412 159.28c-7.86-34.51-24.6-64.13-49.15-86.58C334.15 46.45 296.21 32 256 32c-35.35 0-68 11.08-94.37 32a150.13 150.13 0 00-41.95 52.83A16.05 16.05 0 01108 125.8c-27.13 4.9-50.53 14.68-68.41 28.7C13.7 174.83 0 203.56 0 237.6 0 305 55.93 352 136 352h104V224.45c0-8.61 6.62-16 15.23-16.43A16 16 0 01272 224v128h124c72.64 0 116-34.24 116-91.6 0-30.05-13.59-54.57-39.3-70.9zM240 425.42l-36.7-36.64a16 16 0 00-22.6 22.65l64 63.89a16 16 0 0022.6 0l64-63.89a16 16 0 00-22.6-22.65L272 425.42V352h-32z"
                }
            }
        ]
    })(props);
}
function IoCloudOfflineOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M93.72 183.25C49.49 198.05 16 233.1 16 288c0 66 54 112 120 112h184.37m147.45-22.26C485.24 363.3 496 341.61 496 312c0-59.82-53-85.76-96-88-8.89-89.54-71-144-144-144-26.16 0-48.79 6.93-67.6 18.14"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 448L64 64"
                }
            }
        ]
    })(props);
}
function IoCloudOfflineSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M41.37 64l22.628-22.628L470.627 448l-22.628 22.627zm-2.65 148.78C13.39 235.88 0 267.42 0 304c0 36 14.38 68.88 40.49 92.59C65.64 419.43 99.56 432 136 432h228.12L110.51 178.39c-28.01 5.39-53.09 17.33-71.79 34.39zm437.87 194.45C499.76 388.78 512 361.39 512 328c0-61.85-48.44-95.34-97.75-102.64-6.52-41.18-24.05-76.4-51.11-102.46A153.57 153.57 0 00256 80c-30.47 0-58.9 8.62-83.07 25l302.82 302.86c.25-.21.57-.41.84-.63z"
                }
            }
        ]
    })(props);
}
function IoCloudOffline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 464a15.92 15.92 0 01-11.31-4.69l-384-384a16 16 0 0122.62-22.62l384 384A16 16 0 01448 464zM38.72 196.78C13.39 219.88 0 251.42 0 288c0 36 14.38 68.88 40.49 92.59C65.64 403.43 99.56 416 136 416h192.8a8 8 0 005.66-13.66L100.88 168.76a8 8 0 00-8-2C72 173.15 53.4 183.38 38.72 196.78zm437.87 194.45C499.76 372.78 512 345.39 512 312c0-57.57-42-90.58-87.56-100.75a16 16 0 01-12.12-12.39c-7.68-36.68-24.45-68.15-49.18-92A153.57 153.57 0 00256 64c-31.12 0-60.12 9-84.62 26.1a8 8 0 00-1.14 12.26L461.68 393.8a8 8 0 0010.2.93q2.43-1.68 4.71-3.5z"
                }
            }
        ]
    })(props);
}
function IoCloudOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M400 240c-8.89-89.54-71-144-144-144-69 0-113.44 48.2-128 96-60 6-112 43.59-112 112 0 66 54 112 120 112h260c55 0 100-27.44 100-88 0-59.82-53-85.76-96-88z"
                }
            }
        ]
    })(props);
}
function IoCloudSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M396 432H136c-36.44 0-70.36-12.57-95.51-35.41C14.38 372.88 0 340 0 304c0-36.58 13.39-68.12 38.72-91.22 19.93-18.19 47.12-30.56 77.38-35.37a156.42 156.42 0 0145.22-63.61C187.76 91.69 220.5 80 256 80a153.57 153.57 0 01107.14 42.9c27.06 26.06 44.59 61.28 51.11 102.46C463.56 232.66 512 266.15 512 328c0 33.39-12.24 60.78-35.41 79.23C456.23 423.43 428.37 432 396 432z"
                }
            }
        ]
    })(props);
}
function IoCloudUploadOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 367.79h76c55 0 100-29.21 100-83.6s-53-81.47-96-83.6c-8.89-85.06-71-136.8-144-136.8-69 0-113.44 45.79-128 91.2-60 5.7-112 43.88-112 106.4s54 106.4 120 106.4h56"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 255.79l-64-64-64 64m64 192.42V207.79"
                }
            }
        ]
    })(props);
}
function IoCloudUploadSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M473.66 210c-16.56-12.3-37.7-20.75-59.52-24-6.62-39.18-24.21-72.67-51.3-97.45-28.69-26.3-66.63-40.76-106.84-40.76-35.35 0-68 11.08-94.37 32.05a149.61 149.61 0 00-45.32 60.49c-29.94 4.6-57.12 16.68-77.39 34.55C13.46 197.33 0 227.24 0 261.39c0 34.52 14.49 66 40.79 88.76 25.12 21.69 58.94 33.64 95.21 33.64h104V230.42l-48 48-22.63-22.63L256 169.17l86.63 86.62L320 278.42l-48-48v153.37h124c31.34 0 59.91-8.8 80.45-24.77 23.26-18.1 35.55-44 35.55-74.83 0-29.94-13.26-55.61-38.34-74.19zM240 383.79h32v80.41h-32z"
                }
            }
        ]
    })(props);
}
function IoCloudUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M473.66 210c-14-10.38-31.2-18-49.36-22.11a16.11 16.11 0 01-12.19-12.22c-7.8-34.75-24.59-64.55-49.27-87.13C334.15 62.25 296.21 47.79 256 47.79c-35.35 0-68 11.08-94.37 32.05a150.07 150.07 0 00-42.06 53 16 16 0 01-11.31 8.87c-26.75 5.4-50.9 16.87-69.34 33.12C13.46 197.33 0 227.24 0 261.39c0 34.52 14.49 66 40.79 88.76 25.12 21.69 58.94 33.64 95.21 33.64h104V230.42l-36.69 36.69a16 16 0 01-23.16-.56c-5.8-6.37-5.24-16.3.85-22.39l63.69-63.68a16 16 0 0122.62 0L331 244.14c6.28 6.29 6.64 16.6.39 22.91a16 16 0 01-22.68.06L272 230.42v153.37h124c31.34 0 59.91-8.8 80.45-24.77 23.26-18.1 35.55-44 35.55-74.83 0-29.94-13.26-55.61-38.34-74.19zM240 448.21a16 16 0 1032 0v-64.42h-32z"
                }
            }
        ]
    })(props);
}
function IoCloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M396 432H136c-36.44 0-70.36-12.57-95.51-35.41C14.38 372.88 0 340 0 304c0-36.58 13.39-68.12 38.72-91.22 18.11-16.53 42.22-28.25 69.18-33.87a16 16 0 0011.37-9.15 156.24 156.24 0 0142.05-56C187.76 91.69 220.5 80 256 80a153.57 153.57 0 01107.14 42.9c24.73 23.81 41.5 55.28 49.18 92a16 16 0 0012.12 12.39C470 237.42 512 270.43 512 328c0 33.39-12.24 60.78-35.41 79.23C456.23 423.43 428.37 432 396 432z"
                }
            }
        ]
    })(props);
}
function IoCloudyNightOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M388.31 272c47.75 0 89.77-27.77 107.69-68.92-14.21 6.18-30.9 8.61-47.38 8.61A116.31 116.31 0 01332.31 95.38c0-16.48 2.43-33.17 8.61-47.38C299.77 65.92 272 107.94 272 155.69a116.31 116.31 0 003.44 28.18"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M90.61 306.85A16.07 16.07 0 00104 293.6C116.09 220.17 169.63 176 232 176c57.93 0 96.62 37.75 112.2 77.74a15.84 15.84 0 0012.2 9.87c50 8.15 91.6 41.54 91.6 99.59 0 59.4-48.6 100.8-108 100.8H106c-49.5 0-90-24.7-90-79.2 0-48.47 38.67-72.22 74.61-77.95z"
                }
            }
        ]
    })(props);
}
function IoCloudyNightSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M340 480H106c-29.5 0-54.92-7.83-73.53-22.64C11.23 440.44 0 415.35 0 384.8c0-29.44 12.09-54.25 35-71.74 14.55-11.13 33.41-18.87 53.2-22 6.06-36.92 21.92-68.53 46.29-92A139.82 139.82 0 01232 160c32.33 0 62.15 10.65 86.24 30.79a142.41 142.41 0 0140.83 57.05c27.18 4.48 51.59 15.68 69.56 32.08C451.77 301 464 329.82 464 363.2c0 32.85-13.13 62.87-37 84.52-22.89 20.82-53.8 32.28-87 32.28zm41.55-260.07c26.5 6.93 50 19.32 68.65 36.34q3.89 3.56 7.47 7.34c25.41-18.4 45.47-44.92 54.33-71.38-16.24 7.07-35.31 9.85-54.15 9.85-73.42 0-115.93-42.51-115.93-115.93 0-18.84 2.78-37.91 9.85-54.15-40.41 13.53-81 53.19-92.52 98.13a162.61 162.61 0 0179.52 36.12 173 173 0 0142.78 53.68z"
                }
            }
        ]
    })(props);
}
function IoCloudyNight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M340 480H106c-29.5 0-54.92-7.83-73.53-22.64C11.23 440.44 0 415.35 0 384.8c0-29.44 12.09-54.25 35-71.74 12.1-9.26 27.2-16.17 43.33-20.05a16 16 0 0011.81-12.21c7.15-32.54 22.25-60.49 44.33-81.75A139.82 139.82 0 01232 160c32.33 0 62.15 10.65 86.24 30.79a142.22 142.22 0 0137.65 49.54 16.06 16.06 0 0011.12 9c24 5.22 45.42 15.78 61.62 30.56C451.77 301 464 329.82 464 363.2c0 32.85-13.13 62.87-37 84.52-22.89 20.82-53.8 32.28-87 32.28zm170.53-270.21a16.34 16.34 0 00-1.35-15.8 16 16 0 00-19.57-5.58c-10.7 4.65-24.48 7.17-39.92 7.28-55.3.4-101.38-45-101.38-100.31 0-15.75 2.48-29.84 7.18-40.76a16.3 16.3 0 00-1.85-16.33 16 16 0 00-19.1-5c-38.63 16.82-66.18 51.51-75.27 92.54a4 4 0 003.19 4.79 162.54 162.54 0 0176.31 35.59 172.58 172.58 0 0139.64 47.84 16.35 16.35 0 009.54 7.64c23.89 7.17 45.1 18.9 62.25 34.54q4.44 4.07 8.48 8.42a4 4 0 005.16.57 129.12 129.12 0 0046.69-55.43z"
                }
            }
        ]
    })(props);
}
function IoCloudyOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M100.18 241.19a15.93 15.93 0 0013.37-13.25C126.6 145.59 186.34 96 256 96c64.69 0 107.79 42.36 124.92 87a16.11 16.11 0 0012.53 10.18C449.36 202.06 496 239.21 496 304c0 66-54 112-120 112H116c-55 0-100-27.44-100-88 0-54.43 43.89-80.81 84.18-86.81z"
                }
            }
        ]
    })(props);
}
function IoCloudySharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M376 432H116c-32.37 0-60.23-8.57-80.59-24.77C12.24 388.78 0 361.39 0 328c0-61.85 48.44-95.34 97.75-102.64 6.52-41.18 24-76.4 51.11-102.46A153.57 153.57 0 01256 80c35.5 0 68.24 11.69 94.68 33.8a156.42 156.42 0 0145.22 63.61c30.26 4.81 57.45 17.18 77.38 35.36C498.61 235.88 512 267.42 512 304c0 36-14.38 68.88-40.49 92.59C446.36 419.43 412.44 432 376 432z"
                }
            }
        ]
    })(props);
}
function IoCloudy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M376 432H116c-32.37 0-60.23-8.57-80.59-24.77C12.24 388.78 0 361.39 0 328c0-57.57 42-90.58 87.56-100.75a16 16 0 0012.12-12.39c7.68-36.68 24.45-68.15 49.18-92A153.57 153.57 0 01256 80c35.5 0 68.24 11.69 94.68 33.8a156.24 156.24 0 0142.05 56 16 16 0 0011.37 9.16c27 5.61 51.07 17.33 69.18 33.85C498.61 235.88 512 267.42 512 304c0 36-14.38 68.88-40.49 92.59C446.36 419.43 412.44 432 376 432z"
                }
            }
        ]
    })(props);
}
function IoCodeDownloadOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 368L32 256l128-112m192 224l128-112-128-112M192 288.1l64 63.9 64-63.9M256 160v176.03"
                }
            }
        ]
    })(props);
}
function IoCodeDownloadSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "42",
                    "d": "M160 368L32 256l128-112m192 224l128-112-128-112M192 288.1l64 63.9 64-63.9M256 160v176.03"
                }
            }
        ]
    })(props);
}
function IoCodeDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "42",
                    "d": "M160 368L32 256l128-112m192 224l128-112-128-112M192 288.1l64 63.9 64-63.9M256 160v176.03"
                }
            }
        ]
    })(props);
}
function IoCodeOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 368L32 256l128-112m192 224l128-112-128-112"
                }
            }
        ]
    })(props);
}
function IoCodeSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M161.98 397.63L0 256l161.98-141.63 27.65 31.61L64 256l125.63 110.02-27.65 31.61zm188.04 0l-27.65-31.61L448 256 322.37 145.98l27.65-31.61L512 256 350.02 397.63z"
                }
            }
        ]
    })(props);
}
function IoCodeSlashOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 368L32 256l128-112m192 224l128-112-128-112m-48-48l-96 320"
                }
            }
        ]
    })(props);
}
function IoCodeSlashSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M161.98 397.63L0 256l161.98-141.63 27.65 31.61L64 256l125.63 110.02-27.65 31.61zm188.04 0l-27.65-31.61L448 256 322.37 145.98l27.65-31.61L512 256 350.02 397.63zM222.15 442L182 430.08 289.85 70 330 81.92 222.15 442z"
                }
            }
        ]
    })(props);
}
function IoCodeSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 389a20.91 20.91 0 01-13.82-5.2l-128-112a21 21 0 010-31.6l128-112a21 21 0 0127.66 31.61L63.89 256l109.94 96.19A21 21 0 01160 389zm192 0a21 21 0 01-13.84-36.81L448.11 256l-109.94-96.19a21 21 0 0127.66-31.61l128 112a21 21 0 010 31.6l-128 112A20.89 20.89 0 01352 389zm-144 48a21 21 0 01-20.12-27l96-320a21 21 0 1140.23 12l-96 320A21 21 0 01208 437z"
                }
            }
        ]
    })(props);
}
function IoCodeWorkingOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "26"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "346",
                    "cy": "256",
                    "r": "26"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "166",
                    "cy": "256",
                    "r": "26"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 368L32 256l128-112m192 224l128-112-128-112"
                }
            }
        ]
    })(props);
}
function IoCodeWorkingSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "26",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "10"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "346",
                    "cy": "256",
                    "r": "26",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "10"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "166",
                    "cy": "256",
                    "r": "26",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "10"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "42",
                    "d": "M160 368L32 256l128-112m192 224l128-112-128-112"
                }
            }
        ]
    })(props);
}
function IoCodeWorking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "26",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "10"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "346",
                    "cy": "256",
                    "r": "26",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "10"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "166",
                    "cy": "256",
                    "r": "26",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "10"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "42",
                    "d": "M160 368L32 256l128-112m192 224l128-112-128-112"
                }
            }
        ]
    })(props);
}
function IoCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 389a20.91 20.91 0 01-13.82-5.2l-128-112a21 21 0 010-31.6l128-112a21 21 0 0127.66 31.61L63.89 256l109.94 96.19A21 21 0 01160 389zm192 0a21 21 0 01-13.84-36.81L448.11 256l-109.94-96.19a21 21 0 0127.66-31.61l128 112a21 21 0 010 31.6l-128 112A20.89 20.89 0 01352 389z"
                }
            }
        ]
    })(props);
}
function IoCogOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M456.7 242.27l-26.08-4.2a8 8 0 01-6.6-6.82c-.5-3.2-1-6.41-1.7-9.51a8.08 8.08 0 013.9-8.62l23.09-12.82a8.05 8.05 0 003.9-9.92l-4-11a7.94 7.94 0 00-9.4-5l-25.89 5a8 8 0 01-8.59-4.11q-2.25-4.2-4.8-8.41a8.16 8.16 0 01.7-9.52l17.29-19.94a8 8 0 00.3-10.62l-7.49-9a7.88 7.88 0 00-10.5-1.51l-22.69 13.63a8 8 0 01-9.39-.9c-2.4-2.11-4.9-4.21-7.4-6.22a8 8 0 01-2.5-9.11l9.4-24.75A8 8 0 00365 78.77l-10.2-5.91a8 8 0 00-10.39 2.21l-16.64 20.84a7.15 7.15 0 01-8.5 2.5s-5.6-2.3-9.8-3.71A8 8 0 01304 87l.4-26.45a8.07 8.07 0 00-6.6-8.42l-11.59-2a8.07 8.07 0 00-9.1 5.61l-8.6 25.05a8 8 0 01-7.79 5.41h-9.8a8.07 8.07 0 01-7.79-5.41l-8.6-25.05a8.07 8.07 0 00-9.1-5.61l-11.59 2a8.07 8.07 0 00-6.6 8.42l.4 26.45a8 8 0 01-5.49 7.71c-2.3.9-7.3 2.81-9.7 3.71-2.8 1-6.1.2-8.8-2.91l-16.51-20.34A8 8 0 00156.75 73l-10.2 5.91a7.94 7.94 0 00-3.3 10.09l9.4 24.75a8.06 8.06 0 01-2.5 9.11c-2.5 2-5 4.11-7.4 6.22a8 8 0 01-9.39.9L111 116.14a8 8 0 00-10.5 1.51l-7.49 9a8 8 0 00.3 10.62l17.29 19.94a8 8 0 01.7 9.52q-2.55 4-4.8 8.41a8.11 8.11 0 01-8.59 4.11l-25.89-5a8 8 0 00-9.4 5l-4 11a8.05 8.05 0 003.9 9.92L85.58 213a7.94 7.94 0 013.9 8.62c-.6 3.2-1.2 6.31-1.7 9.51a8.08 8.08 0 01-6.6 6.82l-26.08 4.2a8.09 8.09 0 00-7.1 7.92v11.72a7.86 7.86 0 007.1 7.92l26.08 4.2a8 8 0 016.6 6.82c.5 3.2 1 6.41 1.7 9.51a8.08 8.08 0 01-3.9 8.62L62.49 311.7a8.05 8.05 0 00-3.9 9.92l4 11a7.94 7.94 0 009.4 5l25.89-5a8 8 0 018.59 4.11q2.25 4.2 4.8 8.41a8.16 8.16 0 01-.7 9.52l-17.29 19.96a8 8 0 00-.3 10.62l7.49 9a7.88 7.88 0 0010.5 1.51l22.69-13.63a8 8 0 019.39.9c2.4 2.11 4.9 4.21 7.4 6.22a8 8 0 012.5 9.11l-9.4 24.75a8 8 0 003.3 10.12l10.2 5.91a8 8 0 0010.39-2.21l16.79-20.64c2.1-2.6 5.5-3.7 8.2-2.6 3.4 1.4 5.7 2.2 9.9 3.61a8 8 0 015.49 7.71l-.4 26.45a8.07 8.07 0 006.6 8.42l11.59 2a8.07 8.07 0 009.1-5.61l8.6-25a8 8 0 017.79-5.41h9.8a8.07 8.07 0 017.79 5.41l8.6 25a8.07 8.07 0 009.1 5.61l11.59-2a8.07 8.07 0 006.6-8.42l-.4-26.45a8 8 0 015.49-7.71c4.2-1.41 7-2.51 9.6-3.51s5.8-1 8.3 2.1l17 20.94A8 8 0 00355 439l10.2-5.91a7.93 7.93 0 003.3-10.12l-9.4-24.75a8.08 8.08 0 012.5-9.12c2.5-2 5-4.1 7.4-6.21a8 8 0 019.39-.9L401 395.66a8 8 0 0010.5-1.51l7.49-9a8 8 0 00-.3-10.62l-17.29-19.94a8 8 0 01-.7-9.52q2.55-4.05 4.8-8.41a8.11 8.11 0 018.59-4.11l25.89 5a8 8 0 009.4-5l4-11a8.05 8.05 0 00-3.9-9.92l-23.09-12.82a7.94 7.94 0 01-3.9-8.62c.6-3.2 1.2-6.31 1.7-9.51a8.08 8.08 0 016.6-6.82l26.08-4.2a8.09 8.09 0 007.1-7.92V250a8.25 8.25 0 00-7.27-7.73zM256 112a143.82 143.82 0 01139.38 108.12A16 16 0 01379.85 240H274.61a16 16 0 01-13.91-8.09l-52.1-91.71a16 16 0 019.85-23.39A146.94 146.94 0 01256 112zM112 256a144 144 0 0143.65-103.41 16 16 0 0125.17 3.47L233.06 248a16 16 0 010 15.87l-52.67 91.7a16 16 0 01-25.18 3.36A143.94 143.94 0 01112 256zm144 144a146.9 146.9 0 01-38.19-4.95 16 16 0 01-9.76-23.44l52.58-91.55a16 16 0 0113.88-8H379.9a16 16 0 0115.52 19.88A143.84 143.84 0 01256 400z"
                }
            }
        ]
    })(props);
}
function IoCogSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 249.93a10.58 10.58 0 00-9.36-9.94L429 235.84a5.42 5.42 0 01-4.5-4.67c-.49-3.15-1-6.42-1.7-9.52a5.52 5.52 0 012.63-5.85l22.78-12.65a10.35 10.35 0 005-12.83l-3.95-10.9a10.32 10.32 0 00-12.13-6.51l-25.55 5a5.5 5.5 0 01-5.82-2.81c-1.49-2.79-3.11-5.63-4.8-8.42a5.6 5.6 0 01.44-6.5l17-19.63a10.44 10.44 0 00.39-13.77l-7.42-8.91a10.24 10.24 0 00-13.58-2l-22.37 13.43a5.39 5.39 0 01-6.39-.63c-2.47-2.17-4.95-4.26-7.37-6.19a5.45 5.45 0 01-1.72-6.21l9.26-24.4a10.35 10.35 0 00-4.31-13.07l-10.08-5.85a10.31 10.31 0 00-13.46 2.83L325 96.28a4.58 4.58 0 01-5.6 1.72c-.62-.25-5.77-2.36-9.78-3.7a5.42 5.42 0 01-3.74-5.23l.39-26.07a10.48 10.48 0 00-8.57-10.88l-11.45-2a10.45 10.45 0 00-11.75 7.17L266 82.1a5.42 5.42 0 01-5.36 3.65h-9.75a5.53 5.53 0 01-5.3-3.67l-8.46-24.67a10.46 10.46 0 00-11.77-7.25l-11.46 2a10.46 10.46 0 00-8.57 10.79l.4 26.16a5.45 5.45 0 01-3.86 5.25c-2.28.89-7.26 2.78-9.51 3.63-2 .72-4.19-.07-6-2.1l-16.26-20A10.3 10.3 0 00156.69 73l-10.06 5.83A10.36 10.36 0 00142.31 92l9.25 24.34a5.54 5.54 0 01-1.7 6.23c-2.43 2-4.92 4-7.4 6.22a5.38 5.38 0 01-6.35.64L114 115.74a10.39 10.39 0 00-13.61 2l-7.4 8.9a10.32 10.32 0 00.37 13.76l17.09 19.6a5.42 5.42 0 01.45 6.45c-1.71 2.72-3.34 5.58-4.82 8.44a5.53 5.53 0 01-5.86 2.82l-25.51-4.93a10.34 10.34 0 00-12.14 6.51l-4 10.88a10.37 10.37 0 005 12.85l22.78 12.65a5.39 5.39 0 012.65 5.92l-.23 1.24c-.53 2.8-1 5.45-1.47 8.27a5.48 5.48 0 01-4.46 4.64l-25.7 4.15A10.42 10.42 0 0048 250.16v11.58A10.26 10.26 0 0057.16 272l25.68 4.14a5.41 5.41 0 014.5 4.67c.49 3.16 1 6.42 1.7 9.52a5.52 5.52 0 01-2.63 5.85l-22.77 12.67a10.35 10.35 0 00-5 12.83l4 10.9a10.33 10.33 0 0012.13 6.51l25.55-4.95a5.5 5.5 0 015.82 2.81c1.5 2.8 3.12 5.64 4.8 8.42a5.58 5.58 0 01-.44 6.5l-17 19.64a10.41 10.41 0 00-.5 13.76l7.41 8.91a10.24 10.24 0 0013.58 2l22.37-13.43a5.39 5.39 0 016.39.63c2.48 2.17 5 4.26 7.37 6.19a5.45 5.45 0 011.72 6.21l-9.26 24.4a10.35 10.35 0 004.31 13.07l10.11 5.84a10.3 10.3 0 0013.45-2.82L187 415.92c1.39-1.73 3.6-2.5 5.24-1.84 3.47 1.44 5.8 2.25 9.93 3.63a5.44 5.44 0 013.75 5.23l-.4 26.05a10.5 10.5 0 008.57 10.88l11.45 2a10.44 10.44 0 0011.75-7.17l8.5-24.77a5.48 5.48 0 015.36-3.65h9.75a5.52 5.52 0 015.3 3.67l8.47 24.67a10.48 10.48 0 0010 7.41 9.74 9.74 0 001.78-.16l11.47-2a10.46 10.46 0 008.56-10.79l-.4-26.16a5.43 5.43 0 013.75-5.2c3.84-1.29 6.53-2.33 8.91-3.24l.6-.24c3.06-1.06 4.53.14 5.47 1.31l16.75 20.63A10.3 10.3 0 00355 439l10.07-5.83a10.35 10.35 0 004.31-13.1l-9.24-24.34a5.52 5.52 0 011.69-6.23c2.43-2 4.92-4 7.4-6.22a5.39 5.39 0 016.38-.62l22.39 13.4a10.39 10.39 0 0013.61-2l7.4-8.9a10.31 10.31 0 00-.37-13.75l-17.06-19.67a5.42 5.42 0 01-.45-6.45c1.71-2.71 3.34-5.57 4.82-8.44a5.56 5.56 0 015.86-2.82l25.48 4.97a10.34 10.34 0 0012.14-6.51l3.95-10.88a10.36 10.36 0 00-5-12.84l-22.8-12.67a5.4 5.4 0 01-2.61-5.89l.23-1.25c.53-2.8 1-5.44 1.47-8.26a5.48 5.48 0 014.46-4.64l25.7-4.14a10.43 10.43 0 009.17-10.28v-11.71zM171.59 361.27a135.12 135.12 0 01.5-210.94l60 105.61zM256 391.11a133.75 133.75 0 01-48.49-9.05L268 276.79h121.22C379.21 341.45 323.29 391.11 256 391.11zm12.06-155.9l-59.95-105.5a133.87 133.87 0 0147.89-8.82c67.29 0 123.21 49.66 133.22 114.32z"
                }
            }
        ]
    })(props);
}
function IoCog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 249.93a10.58 10.58 0 00-9.36-9.94L429 235.84a5.42 5.42 0 01-4.5-4.67c-.49-3.15-1-6.42-1.7-9.52a5.52 5.52 0 012.63-5.85l22.78-12.65a10.35 10.35 0 005-12.83l-3.95-10.9a10.32 10.32 0 00-12.13-6.51l-25.55 5a5.51 5.51 0 01-5.82-2.81c-1.49-2.79-3.11-5.63-4.8-8.42a5.6 5.6 0 01.44-6.5l17-19.64a10.42 10.42 0 00.39-13.76l-7.42-8.91a10.24 10.24 0 00-13.58-2l-22.37 13.43a5.39 5.39 0 01-6.39-.63c-2.47-2.17-5-4.26-7.37-6.19a5.45 5.45 0 01-1.72-6.21l9.26-24.4a10.35 10.35 0 00-4.31-13.07l-10.09-5.89a10.3 10.3 0 00-13.45 2.83L325 96.28a4.6 4.6 0 01-5.6 1.72c-.61-.25-5.77-2.36-9.78-3.7a5.42 5.42 0 01-3.74-5.23l.39-26.07a10.48 10.48 0 00-8.57-10.88l-11.45-2a10.45 10.45 0 00-11.75 7.17L266 82.1a5.46 5.46 0 01-5.36 3.65h-9.75a5.5 5.5 0 01-5.3-3.67l-8.46-24.67a10.46 10.46 0 00-11.77-7.25l-11.47 2a10.46 10.46 0 00-8.56 10.79l.4 26.16a5.45 5.45 0 01-3.86 5.25c-2.29.89-7.26 2.79-9.52 3.63-2 .72-4.18-.07-5.94-2.1l-16.26-20A10.3 10.3 0 00156.69 73l-10.06 5.83A10.36 10.36 0 00142.31 92l9.25 24.34a5.54 5.54 0 01-1.7 6.23c-2.43 2-4.92 4-7.4 6.22a5.38 5.38 0 01-6.35.64L114 115.74a10.4 10.4 0 00-13.61 2L93 126.63a10.31 10.31 0 00.37 13.75L110.45 160a5.42 5.42 0 01.45 6.45c-1.71 2.72-3.34 5.58-4.82 8.44a5.53 5.53 0 01-5.86 2.82l-25.51-4.93a10.34 10.34 0 00-12.14 6.51l-4 10.88a10.38 10.38 0 005 12.85l22.78 12.65a5.39 5.39 0 012.65 5.92l-.24 1.27c-.52 2.79-1 5.43-1.46 8.24a5.48 5.48 0 01-4.46 4.64l-25.69 4.15A10.42 10.42 0 0048 250.16v11.58A10.26 10.26 0 0057.16 272l25.68 4.14a5.41 5.41 0 014.5 4.67c.49 3.16 1 6.42 1.7 9.52a5.52 5.52 0 01-2.63 5.85l-22.77 12.67a10.35 10.35 0 00-5 12.83l4 10.9a10.33 10.33 0 0012.13 6.51l25.55-4.95a5.49 5.49 0 015.82 2.81c1.5 2.8 3.11 5.63 4.8 8.42a5.58 5.58 0 01-.44 6.5l-17 19.63a10.41 10.41 0 00-.5 13.77l7.41 8.91a10.23 10.23 0 0013.58 2l22.37-13.43a5.39 5.39 0 016.39.63c2.48 2.17 5 4.26 7.37 6.19a5.47 5.47 0 011.73 6.21l-9.27 24.4a10.35 10.35 0 004.31 13.07l10.11 5.84a10.3 10.3 0 0013.45-2.82L187 415.92c1.4-1.73 3.6-2.5 5.23-1.84 3.48 1.44 5.81 2.25 9.94 3.63a5.44 5.44 0 013.75 5.23l-.4 26.05a10.5 10.5 0 008.57 10.88l11.45 2a10.43 10.43 0 0011.75-7.17l8.5-24.77a5.45 5.45 0 015.36-3.65h9.75a5.49 5.49 0 015.3 3.67l8.47 24.67a10.48 10.48 0 0010 7.41 9.74 9.74 0 001.78-.16l11.47-2a10.46 10.46 0 008.56-10.79l-.4-26.16a5.43 5.43 0 013.75-5.2c3.84-1.29 6.54-2.33 8.91-3.25l.6-.23c3.1-1.07 4.6.23 5.47 1.31l16.75 20.63A10.3 10.3 0 00355 439l10.07-5.83a10.35 10.35 0 004.31-13.1l-9.24-24.34a5.52 5.52 0 011.69-6.23c2.43-2 4.92-4 7.4-6.22a5.39 5.39 0 016.38-.62l22.39 13.4a10.39 10.39 0 0013.61-2l7.4-8.9a10.31 10.31 0 00-.37-13.75l-17.06-19.67a5.42 5.42 0 01-.45-6.45c1.71-2.71 3.34-5.57 4.82-8.44a5.55 5.55 0 015.86-2.82l25.48 4.97a10.34 10.34 0 0012.14-6.51l3.95-10.88a10.37 10.37 0 00-5-12.84l-22.8-12.67a5.4 5.4 0 01-2.61-5.89l.24-1.27c.52-2.79 1-5.43 1.46-8.24a5.48 5.48 0 014.46-4.64l25.69-4.14a10.43 10.43 0 009.18-10.28v-11.71zm-282.45 94a15.8 15.8 0 01-25.47 2.66 135.06 135.06 0 01.42-181.65 15.81 15.81 0 0125.5 2.77l45.65 80.35a15.85 15.85 0 010 15.74zM256 391.11a134.75 134.75 0 01-28.31-3 15.81 15.81 0 01-10.23-23.36l46-80a15.79 15.79 0 0113.7-7.93h92.14a15.8 15.8 0 0115.1 20.53c-17.49 54.32-68.4 93.76-128.4 93.76zm7.51-163.9L218 147.07a15.81 15.81 0 0110.31-23.3 134 134 0 0127.69-2.88c60 0 110.91 39.44 128.37 93.79a15.8 15.8 0 01-15.1 20.53h-92a15.78 15.78 0 01-13.76-8z"
                }
            }
        ]
    })(props);
}
function IoColorFillOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M419.1 337.45a3.94 3.94 0 00-6.1 0c-10.5 12.4-45 46.55-45 77.66 0 27 21.5 48.89 48 48.89h0c26.5 0 48-22 48-48.89 0-31.11-34.3-65.26-44.9-77.66zM387 287.9L155.61 58.36a36 36 0 00-51 0l-5.15 5.15a36 36 0 000 51l52.89 52.89 57-57L56.33 263.2a28 28 0 00.3 40l131.2 126a28.05 28.05 0 0038.9-.1c37.8-36.6 118.3-114.5 126.7-122.9 5.8-5.8 18.2-7.1 28.7-7.1h.3a6.53 6.53 0 004.57-11.2z"
                }
            }
        ]
    })(props);
}
function IoColorFillSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 320s-64 48-64 99.84c0 33.28 28.67 60.16 64 60.16s64-27 64-60.16C480 368 416 320 416 320zM144 32l-76 76 70 70L32 280l176 184 152.8-148.3L416 304zm24 116l-39.6-41 15.88-15.89L184 132z"
                }
            }
        ]
    })(props);
}
function IoColorFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 480c-35.29 0-64-29.11-64-64.88 0-33.29 28.67-65.4 44.08-82.64 1.87-2.1 3.49-3.91 4.68-5.31a19.94 19.94 0 0130.55 0c1.13 1.31 2.63 3 4.36 4.93 15.5 17.3 44.33 49.51 44.33 83.05 0 35.74-28.71 64.85-64 64.85zm-17.77-203.36L166.89 47.22a52.1 52.1 0 00-73.6 0l-4.51 4.51a53.2 53.2 0 00-15.89 37.33A51.66 51.66 0 0088.14 126l41.51 41.5L45 252a44.52 44.52 0 00-13 32 42.81 42.81 0 0013.5 30.84l131.24 126a44 44 0 0061.08-.18l124.11-120.28a15.6 15.6 0 018.23-4.29 69.21 69.21 0 0111.93-.86h.3a22.53 22.53 0 0015.84-38.59zM152.29 144.85l-41.53-41.52a20 20 0 010-28.34l5.16-5.15a20.07 20.07 0 0128.39 0L186 111.21z"
                }
            }
        ]
    })(props);
}
function IoColorFilterOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "184",
                    "r": "120",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "344",
                    "cy": "328",
                    "r": "120",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "168",
                    "cy": "328",
                    "r": "120",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function IoColorFilterSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 185a167.85 167.85 0 01134.9-18.28C382.36 99.83 325.12 48 256 48S129.64 99.83 121.1 166.67A167.85 167.85 0 01256 185zm80 146.73a167.51 167.51 0 01-52.37 118.08A135 135 0 00344 464c75 0 136-61 136-136a136 136 0 00-59.06-112.08A168.53 168.53 0 01336 331.73zm-52.42-125.54a167.87 167.87 0 0149.36 89.89 136.14 136.14 0 0058.06-95.7 135.87 135.87 0 00-107.43 5.81zM176.05 331.73a168.53 168.53 0 01-85-115.81A136 136 0 0032 328c0 75 61 136 136 136a135 135 0 0060.42-14.19 167.51 167.51 0 01-52.37-118.08zm3.01-35.65a167.87 167.87 0 0149.36-89.89A135.87 135.87 0 00121 200.38a136.14 136.14 0 0058.06 95.7zm123.84 49.25a168.22 168.22 0 01-93.8 0A135.9 135.9 0 00256 431.6a135.9 135.9 0 0046.9-86.27zM209 311.62a136 136 0 0094 0 135.93 135.93 0 00-47-87.22 135.93 135.93 0 00-47 87.22z"
                }
            }
        ]
    })(props);
}
function IoColorFilter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M253.72 202.53a4 4 0 004.56 0 151.88 151.88 0 01128.44-20.41 4 4 0 005.15-4C388.8 105.86 329 48 256 48s-132.8 57.86-135.87 130.15a4 4 0 005.15 4 151.88 151.88 0 01128.44 20.41zm151.59 10.03a152.53 152.53 0 01-83.08 108.23 4 4 0 00-2.28 3.69c0 1.17.05 2.34.05 3.52a151.58 151.58 0 01-47.15 109.94 4 4 0 00.64 6.31A135.24 135.24 0 00344 464c72.07 0 134.1-60.28 136-132.34a136.07 136.07 0 00-68.76-121.87 4 4 0 00-5.93 2.77z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M390.57 203.67a4 4 0 00-2.69-4.4 135.84 135.84 0 00-114.4 12.49 4 4 0 00-.64 6.29 151.92 151.92 0 0144.47 81.4 4 4 0 005.94 2.72 136.29 136.29 0 0067.32-98.5zM192 328c0-1.18 0-2.35.05-3.52a4 4 0 00-2.28-3.69 152.53 152.53 0 01-83.08-108.23 4 4 0 00-5.88-2.77 136.07 136.07 0 00-68.76 121.87C34 403.72 96 464 168.05 464a135.24 135.24 0 0070.46-19.75 4 4 0 00.64-6.31A151.58 151.58 0 01192 328z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M168 192a135.34 135.34 0 00-43.88 7.27 4 4 0 00-2.69 4.4 136.29 136.29 0 0067.32 98.5 4 4 0 005.94-2.72 151.92 151.92 0 0144.47-81.4 4 4 0 00-.64-6.29A135.18 135.18 0 00168 192zm88 144a151.44 151.44 0 01-42.72-6.12 4 4 0 00-5.15 4 135.69 135.69 0 0045.18 95.4 4 4 0 005.38 0 135.69 135.69 0 0045.18-95.4 4 4 0 00-5.15-4A151.44 151.44 0 01256 336zm46.57-27.67a135.94 135.94 0 00-43.87-81.58 4.06 4.06 0 00-5.4 0 135.94 135.94 0 00-43.87 81.58 4 4 0 002.69 4.4 136.06 136.06 0 0087.76 0 4 4 0 002.69-4.4z"
                }
            }
        ]
    })(props);
}
function IoColorPaletteOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M430.11 347.9c-6.6-6.1-16.3-7.6-24.6-9-11.5-1.9-15.9-4-22.6-10-14.3-12.7-14.3-31.1 0-43.8l30.3-26.9c46.4-41 46.4-108.2 0-149.2-34.2-30.1-80.1-45-127.8-45-55.7 0-113.9 20.3-158.8 60.1-83.5 73.8-83.5 194.7 0 268.5 41.5 36.7 97.5 55 152.9 55.4h1.7c55.4 0 110-17.9 148.8-52.4 14.4-12.7 11.99-36.6.1-47.7z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "144",
                    "cy": "208",
                    "r": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "152",
                    "cy": "311",
                    "r": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "224",
                    "cy": "144",
                    "r": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "367",
                    "r": "48"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "328",
                    "cy": "144",
                    "r": "32"
                }
            }
        ]
    })(props);
}
function IoColorPaletteSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 352c-12.6-.84-21-4-28-12-14-16-14-36 5.49-52.48l32.82-29.14c50.27-44.41 50.27-117.21 0-161.63C389.26 64.14 339.54 48 287.86 48c-60.34 0-123.39 22-172 65.11-90.46 80-90.46 210.92 0 290.87 45 39.76 105.63 59.59 165.64 60h1.84c60 0 119.07-19.5 161.2-56.77C464 390 464 385 444.62 355.56 440 348 431 353 416 352zM112 208a32 32 0 1132 32 32 32 0 01-32-32zm40 135a32 32 0 1132-32 32 32 0 01-32 32zm40-199a32 32 0 1132 32 32 32 0 01-32-32zm64 271a48 48 0 1148-48 48 48 0 01-48 48zm72-239a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function IoColorPalette(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M441 336.2l-.06-.05c-9.93-9.18-22.78-11.34-32.16-12.92l-.69-.12c-9.05-1.49-10.48-2.5-14.58-6.17-2.44-2.17-5.35-5.65-5.35-9.94s2.91-7.77 5.34-9.94l30.28-26.87c25.92-22.91 40.2-53.66 40.2-86.59s-14.25-63.68-40.2-86.6c-35.89-31.59-85-49-138.37-49C223.72 48 162 71.37 116 112.11c-43.87 38.77-68 90.71-68 146.24s24.16 107.47 68 146.23c21.75 19.24 47.49 34.18 76.52 44.42a266.17 266.17 0 0086.87 15h1.81c61 0 119.09-20.57 159.39-56.4 9.7-8.56 15.15-20.83 15.34-34.56.21-14.17-5.37-27.95-14.93-36.84zM112 208a32 32 0 1132 32 32 32 0 01-32-32zm40 135a32 32 0 1132-32 32 32 0 01-32 32zm40-199a32 32 0 1132 32 32 32 0 01-32-32zm64 271a48 48 0 1148-48 48 48 0 01-48 48zm72-239a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function IoColorWandOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "63.03",
                    "height": "378.2",
                    "x": "280.48",
                    "y": "122.9",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "31.52",
                    "transform": "rotate(-45 312.002 311.994)"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M178.38 178.38a31.64 31.64 0 000 44.75L223.25 268 268 223.25l-44.87-44.87a31.64 31.64 0 00-44.75 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M48 192h48M90.18 90.18l33.94 33.94M192 48v48m101.82-5.82l-33.94 33.94M124.12 259.88l-33.94 33.94"
                }
            }
        ]
    })(props);
}
function IoColorWandSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M133.441 200.647l67.197-67.196 78.142 78.142-67.196 67.196zM301.41 234.21l-67.19 67.2L412 480l68-68-178.59-177.79zM32 176h80v32H32zm35.624-85.75l22.627-22.628 56.569 56.569-22.627 22.627zM176 32h32v80h-32zm61.32 92.195l56.569-56.569 22.627 22.627-56.569 56.569zM67.62 293.887l56.569-56.569 22.627 22.627-56.569 56.569z"
                }
            }
        ]
    })(props);
}
function IoColorWand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 208H48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16zm28.1-67.9c-4.2 0-8.3-1.7-11.3-4.7l-33.9-33.9c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l33.9 33.9c6.3 6.2 6.3 16.4 0 22.6-3 3-7 4.7-11.3 4.7zM192 112c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16s16 7.2 16 16v48c0 8.8-7.2 16-16 16zm67.9 28.1c-8.8 0-16-7.2-16-16 0-4.2 1.7-8.3 4.7-11.3l33.9-33.9c6.2-6.2 16.4-6.2 22.6 0 6.2 6.2 6.2 16.4 0 22.6l-33.9 33.9c-3 3-7.1 4.7-11.3 4.7zM90.2 309.8c-8.8 0-16-7.2-16-16 0-4.2 1.7-8.3 4.7-11.3l33.9-33.9c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-33.9 33.9c-3 3-7.1 4.7-11.3 4.7zm144-142.8c-18.4-18.7-48.5-19-67.2-.7s-19 48.5-.7 67.2l.7.7 39.5 39.5c3.1 3.1 8.2 3.1 11.3 0l55.9-55.9c3.1-3.1 3.1-8.2 0-11.3L234.2 167zM457 389.8L307.6 240.4c-3.1-3.1-8.2-3.1-11.3 0l-55.9 55.9c-3.1 3.1-3.1 8.2 0 11.3L389.8 457c18.4 18.7 48.5 19 67.2.7 18.7-18.4 19-48.5.7-67.2-.2-.2-.4-.5-.7-.7z"
                }
            }
        ]
    })(props);
}
function IoCompassOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M350.67 150.93l-117.2 46.88a64 64 0 00-35.66 35.66l-46.88 117.2a8 8 0 0010.4 10.4l117.2-46.88a64 64 0 0035.66-35.66l46.88-117.2a8 8 0 00-10.4-10.4zM256 280a24 24 0 1124-24 24 24 0 01-24 24z"
                }
            }
        ]
    })(props);
}
function IoCompassSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "24"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm48 256l-160 64 64-160 160-64z"
                }
            }
        ]
    })(props);
}
function IoCompass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "24"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm105.07 113.33l-46.88 117.2a64 64 0 01-35.66 35.66l-117.2 46.88a8 8 0 01-10.4-10.4l46.88-117.2a64 64 0 0135.66-35.66l117.2-46.88a8 8 0 0110.4 10.4z"
                }
            }
        ]
    })(props);
}
function IoConstructOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M436.67 184.11a27.17 27.17 0 01-38.3 0l-22.48-22.49a27.15 27.15 0 010-38.29l50.89-50.89a.85.85 0 00-.26-1.38C393.68 57 351.09 64.15 324.05 91c-25.88 25.69-27.35 64.27-17.87 98a27 27 0 01-7.67 27.14l-173 160.76a40.76 40.76 0 1057.57 57.54l162.15-173.3a27 27 0 0126.77-7.7c33.46 8.94 71.49 7.26 97.07-17.94 27.49-27.08 33.42-74.94 20.1-102.33a.85.85 0 00-1.36-.22z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M224 284c-17.48-17-25.49-24.91-31-30.29a18.24 18.24 0 01-3.33-21.35 20.76 20.76 0 013.5-4.62l15.68-15.29a18.66 18.66 0 015.63-3.87 18.11 18.11 0 0120 3.62c5.45 5.29 15.43 15 33.41 32.52m49.18 46.58c40.95 38.1 90.62 83.27 110 99.41a13.46 13.46 0 01.94 19.92L394.63 444a14 14 0 01-20.29-.76c-16.53-19.18-61.09-67.11-99.27-107"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M17.34 193.5l29.41-28.74a4.71 4.71 0 013.41-1.35 4.85 4.85 0 013.41 1.35h0a9.86 9.86 0 008.19 2.77c3.83-.42 7.92-1.6 10.57-4.12 6-5.8-.94-17.23 4.34-24.54a207 207 0 0119.78-22.6c6-5.88 29.84-28.32 69.9-44.45A107.31 107.31 0 01206.67 64c22.59 0 40 10 46.26 15.67a89.54 89.54 0 0110.28 11.64 78.92 78.92 0 00-9.21-2.77 68.82 68.82 0 00-20-1.26c-13.33 1.09-29.41 7.26-38 14-13.9 11-19.87 25.72-20.81 44.71-.68 14.12 2.72 22.1 36.1 55.49a6.6 6.6 0 01-.34 9.16l-18.22 18a6.88 6.88 0 01-9.54.09c-21.94-21.94-36.65-33.09-45-38.16s-15.07-6.5-18.3-6.85a30.85 30.85 0 00-18.27 3.87 11.39 11.39 0 00-2.64 2 14.14 14.14 0 00.42 20.08l1.71 1.6a4.63 4.63 0 010 6.64L71.73 246.6a4.71 4.71 0 01-3.41 1.4 4.86 4.86 0 01-3.41-1.35l-47.57-46.43a4.88 4.88 0 010-6.72z"
                }
            }
        ]
    })(props);
}
function IoConstructSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.14 111.38l-81.09 80.84-48.58-48.41L448.56 63c-45.22-22-108.65-22.09-146.2 15.35-35.32 35.2-39.73 90.61-22.54 134.2L99.57 391.37a12 12 0 000 17l52.27 52.11a12 12 0 0017 0l180-180.5c43.16 16.21 98 11.64 132.74-23 37.5-37.45 37.42-100.34 15.56-145.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M365.45 308.62l-71.83 72 75.53 79.92a10.88 10.88 0 0015.65.21l60-60.46a11 11 0 00-.24-15.69zM119 212c0-4.87-4-9.33-7.45-12.78l-.25-.24-1.54-1.47a1.06 1.06 0 01-.26-.8 16.16 16.16 0 019.52-2c1.27.13 5.91.9 12.4 4.91 3.38 2.09 32.63 30.23 43.93 40.7a11 11 0 00.14 15.35l7.43 7.86 65.66-65.17-8.25-7.84a10.87 10.87 0 00-15.31-.06c-23-24.68-29-35.45-31-42.45-4.42-15.47 4.14-28 14-36 5.84-4.62 17.88-8.08 29-9a52.72 52.72 0 0111.61.6c3.47.5 6.3 1.14 7.39 1.4a68.51 68.51 0 0111 4l12-19a88.38 88.38 0 00-13.4-17.7 115.05 115.05 0 00-5.19-5.1c-7.78-7.15-28-19.2-54.59-19.2a117.38 117.38 0 00-44.77 8.82c-37.44 15.34-61.88 36.25-73.11 47.35l-.07.07A219.55 219.55 0 0067 128.56c-5.35 7.53-4.77 15.84-4.38 21.34 0 .32 0 .67.07 1a18.41 18.41 0 00-10.78-3.5A18 18 0 0039 152.73L2 189.62a6.79 6.79 0 000 9.6L65 262a6.72 6.72 0 009.5 0l37.06-37c3.44-3.44 7.44-8.14 7.44-13z"
                }
            }
        ]
    })(props);
}
function IoConstruct(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M503.58 126.2a16.85 16.85 0 00-27.07-4.55l-51.15 51.15a11.15 11.15 0 01-15.66 0l-22.48-22.48a11.17 11.17 0 010-15.67l50.88-50.89a16.85 16.85 0 00-5.27-27.4c-39.71-17-89.08-7.45-120 23.29-26.81 26.61-34.83 68-22 113.7a11 11 0 01-3.16 11.1L114.77 365.1a56.76 56.76 0 1080.14 80.18L357 272.08a11 11 0 0110.9-3.17c45 12 86 4 112.43-22 15.2-15 25.81-36.17 29.89-59.71 3.83-22.2 1.41-44.44-6.64-61z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M437.33 378.41c-13.94-11.59-43.72-38.4-74.07-66.22l-66.07 70.61c28.24 30 53.8 57.85 65 70.88l.07.08A30 30 0 00383.72 464h1.1a30.11 30.11 0 0021-8.62l.07-.07 33.43-33.37a29.46 29.46 0 00-2-43.53zM118.54 214.55a20.48 20.48 0 00-3-10.76 2.76 2.76 0 012.62-4.22h.06c.84.09 5.33.74 11.7 4.61 4.73 2.87 18.23 12.08 41.73 35.54a34.23 34.23 0 007.22 22.12l66.23-61.55a33.73 33.73 0 00-21.6-9.2 2.65 2.65 0 01-.21-.26l-.65-.69-24.54-33.84a28.45 28.45 0 01-4-26.11 35.23 35.23 0 0111.78-16.35c5.69-4.41 18.53-9.72 29.44-10.62a52.92 52.92 0 0115.19.94 65.57 65.57 0 017.06 2.13 15.46 15.46 0 002.15.63 16 16 0 0016.38-25.06c-.26-.35-1.32-1.79-2.89-3.73a91.85 91.85 0 00-9.6-10.36c-8.15-7.36-29.27-19.77-57-19.77a123.13 123.13 0 00-46.3 9c-38.37 15.45-63.47 36.58-75.01 47.79l-.09.09A222.14 222.14 0 0063.7 129.5a27 27 0 00-4.7 11.77 7.33 7.33 0 01-7.71 6.17H50.2a20.65 20.65 0 00-14.59 5.9L6.16 182.05l-.32.32a20.89 20.89 0 00-.24 28.72c.19.2.37.39.57.58L53.67 258a21 21 0 0014.65 6 20.65 20.65 0 0014.59-5.9l29.46-28.79a20.51 20.51 0 006.17-14.76z"
                }
            }
        ]
    })(props);
}
function IoContractOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M304 416V304h112m-101.8 10.23L432 432M208 96v112H96m101.8-10.23L80 80m336 128H304V96m10.23 101.8L432 80M96 304h112v112m-10.23-101.8L80 432"
                }
            }
        ]
    })(props);
}
function IoContractSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M304 416V304h112m-101.8 10.23L432 432M208 96v112H96m101.8-10.23L80 80m336 128H304V96m10.23 101.8L432 80M96 304h112v112m-10.23-101.8L80 432"
                }
            }
        ]
    })(props);
}
function IoContract(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M304 416V304h112m-101.8 10.23L432 432M208 96v112H96m101.8-10.23L80 80m336 128H304V96m10.23 101.8L432 80M96 304h112v112m-10.23-101.8L80 432"
                }
            }
        ]
    })(props);
}
function IoContrastOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "208",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 464c-114.88 0-208-93.12-208-208S141.12 48 256 48z"
                }
            }
        ]
    })(props);
}
function IoContrastSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C132.29 32 32 132.29 32 256s100.29 224 224 224 224-100.29 224-224S379.71 32 256 32zM128.72 383.28A180 180 0 01256 76v360a178.82 178.82 0 01-127.28-52.72z"
                }
            }
        ]
    })(props);
}
function IoContrast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32A224 224 0 0097.61 414.39 224 224 0 10414.39 97.61 222.53 222.53 0 00256 32zM64 256c0-105.87 86.13-192 192-192v384c-105.87 0-192-86.13-192-192z"
                }
            }
        ]
    })(props);
}
function IoCopyOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "336",
                    "height": "336",
                    "x": "128",
                    "y": "128",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "57",
                    "ry": "57"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M383.5 128l.5-24a56.16 56.16 0 00-56-56H112a64.19 64.19 0 00-64 64v216a56.16 56.16 0 0056 56h24"
                }
            }
        ]
    })(props);
}
function IoCopySharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M456 480H136a24 24 0 01-24-24V128a16 16 0 0116-16h328a24 24 0 0124 24v320a24 24 0 01-24 24z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M112 80h288V56a24 24 0 00-24-24H60a28 28 0 00-28 28v316a24 24 0 0024 24h24V112a32 32 0 0132-32z"
                }
            }
        ]
    })(props);
}
function IoCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408 480H184a72 72 0 01-72-72V184a72 72 0 0172-72h224a72 72 0 0172 72v224a72 72 0 01-72 72z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M160 80h235.88A72.12 72.12 0 00328 32H104a72 72 0 00-72 72v224a72.12 72.12 0 0048 67.88V160a80 80 0 0180-80z"
                }
            }
        ]
    })(props);
}
function IoCreateOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M384 224v184a40 40 0 01-40 40H104a40 40 0 01-40-40V168a40 40 0 0140-40h167.48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M459.94 53.25a16.06 16.06 0 00-23.22-.56L424.35 65a8 8 0 000 11.31l11.34 11.32a8 8 0 0011.34 0l12.06-12c6.1-6.09 6.67-16.01.85-22.38zM399.34 90L218.82 270.2a9 9 0 00-2.31 3.93L208.16 299a3.91 3.91 0 004.86 4.86l24.85-8.35a9 9 0 003.93-2.31L422 112.66a9 9 0 000-12.66l-9.95-10a9 9 0 00-12.71 0z"
                }
            }
        ]
    })(props);
}
function IoCreateSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464.37 49.2a22.07 22.07 0 00-31.88-.76l-18.31 18.25 31.18 31.1 18-17.91a22.16 22.16 0 001.01-30.68zM252.76 336H176v-76.76l9.4-9.38L323.54 112H48v352h352V188.46L262.14 326.6l-9.38 9.4zM400 143.16l32.79-32.86-31.09-31.09L368.85 112H400v31.16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M208 304h31.49L400 143.16V112h-31.15L208 272.51V304z"
                }
            }
        ]
    })(props);
}
function IoCreate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M459.94 53.25a16.06 16.06 0 00-23.22-.56L424.35 65a8 8 0 000 11.31l11.34 11.32a8 8 0 0011.34 0l12.06-12c6.1-6.09 6.67-16.01.85-22.38zM399.34 90L218.82 270.2a9 9 0 00-2.31 3.93L208.16 299a3.91 3.91 0 004.86 4.86l24.85-8.35a9 9 0 003.93-2.31L422 112.66a9 9 0 000-12.66l-9.95-10a9 9 0 00-12.71 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M386.34 193.66L264.45 315.79A41.08 41.08 0 01247.58 326l-25.9 8.67a35.92 35.92 0 01-44.33-44.33l8.67-25.9a41.08 41.08 0 0110.19-16.87l122.13-121.91a8 8 0 00-5.65-13.66H104a56 56 0 00-56 56v240a56 56 0 0056 56h240a56 56 0 0056-56V199.31a8 8 0 00-13.66-5.65z"
                }
            }
        ]
    })(props);
}
function IoCropOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M144 48v272a48 48 0 0048 48h272"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M368 304V192a48 48 0 00-48-48H208m160 224v96M144 144H48"
                }
            }
        ]
    })(props);
}
function IoCropSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M166 346V32h-44v90H32v44h90v224h224v90h44v-90h90v-44H166z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M346 320h44V122H192v44h154v154z"
                }
            }
        ]
    })(props);
}
function IoCrop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M458 346H192a26 26 0 01-26-26V54a22 22 0 00-44 0v68H54a22 22 0 000 44h68v154a70.08 70.08 0 0070 70h154v68a22 22 0 0044 0v-68h68a22 22 0 000-44z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M214 166h106a26 26 0 0126 26v106a22 22 0 0044 0V192a70.08 70.08 0 00-70-70H214a22 22 0 000 44z"
                }
            }
        ]
    })(props);
}
function IoCubeOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M448 341.37V170.61A32 32 0 00432.11 143l-152-88.46a47.94 47.94 0 00-48.24 0L79.89 143A32 32 0 0064 170.61v170.76A32 32 0 0079.89 369l152 88.46a48 48 0 0048.24 0l152-88.46A32 32 0 00448 341.37z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M69 153.99l187 110 187-110m-187 310v-200"
                }
            }
        ]
    })(props);
}
function IoCubeSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 170v196.92L240 480V284L48 170zm224 310l192-113.08V170L272 284zm176-122.36zM448 144L256 32 64 144l192 112 192-112z"
                }
            }
        ]
    })(props);
}
function IoCube(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.9 136.3a4 4 0 000-6.91L288.16 40.65a64.14 64.14 0 00-64.33 0L71.12 129.39a4 4 0 000 6.91L254 243.88a4 4 0 004.06 0zM54 163.51a4 4 0 00-6 3.49v173.89a48 48 0 0023.84 41.39L234 479.51a4 4 0 006-3.46V274.3a4 4 0 00-2-3.46zM272 275v201a4 4 0 006 3.46l162.15-97.23A48 48 0 00464 340.89V167a4 4 0 00-6-3.45l-184 108a4 4 0 00-2 3.45z"
                }
            }
        ]
    })(props);
}
function IoCutOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "104",
                    "cy": "152",
                    "r": "56",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "104",
                    "cy": "360",
                    "r": "56",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M157 175l-11 15 37 15s3.46-6.42 7-10z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M154.17 334.43L460 162c-2.5-6.7-28-12-64-4-29.12 6.47-121.16 29.05-159.16 56.05C205.85 236.06 227 272 192 298c-25.61 19-44.43 22.82-44.43 22.82zm190.3-56.19L295 306.67c14.23 6.74 65.54 33.27 117 36.33 14.92.89 30 .39 39-6z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "240",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function IoCutSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 128h-48l-198.94 70.46-59.13-31.59a72.16 72.16 0 10-25.69 41.47l52.2 31.72L192 277l-43.64 26.76a71.74 71.74 0 1024.79 38L480 160zm-376.52 64a40 40 0 1140-40 40 40 0 01-40 40zm0 208a40 40 0 1140-40 40 40 0 01-40 40zm152-144a16 16 0 1116-16 16 16 0 01-16 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M343.79 259.87l-83.74 48.18L432 368h47.99l.01-32-136.21-76.13z"
                }
            }
        ]
    })(props);
}
function IoCut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M103.48 224a71.64 71.64 0 0044.76-15.66l41.5 16.89 6.82-12.63a39.15 39.15 0 014.32-6.37l14.22-14.42-41.17-24.94A72 72 0 10103.48 224zm0-112a40 40 0 11-40 40 40 40 0 0140-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M480 169l-5.52-12.58c-4.48-10.42-14.74-16-32.78-17.85-10.12-1-26.95-1.24-49.69 3.81-20 4.45-122.14 28.2-164.95 58.62-20.25 14.39-24.06 33.67-27.06 49.16-2.78 14.14-5 25.31-18 35-15 11.14-27.27 16.38-33.58 18.6a71.74 71.74 0 1024.79 38zm-224.52 87a16 16 0 1116-16 16 16 0 01-16 16zm-152 144a40 40 0 1140-40 40 40 0 01-40 40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M343.79 259.87l-83.74 48.18 27.63 13.08 3.62 1.74C310 331.92 359.74 356 410.53 359c3.89.23 7.47.34 10.78.34C442 359.31 453 354 459.75 350L480 336z"
                }
            }
        ]
    })(props);
}
function IoDesktopOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "448",
                    "height": "320",
                    "x": "32",
                    "y": "64",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "32",
                    "ry": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M304 448l-8-64h-80l-8 64h96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M368 448H144"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M32 304v48a32.09 32.09 0 0032 32h384a32.09 32.09 0 0032-32v-48zm224 64a16 16 0 1116-16 16 16 0 01-16 16z"
                }
            }
        ]
    })(props);
}
function IoDesktopSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 48H32a16 16 0 00-16 16v320a16 16 0 0016 16h168v32h-72v32h256v-32h-72v-32h168a16 16 0 0016-16V64a16 16 0 00-16-16zm-20 36v216H52V84zM240.13 354.08a16 16 0 1113.79 13.79 16 16 0 01-13.79-13.79z"
                }
            }
        ]
    })(props);
}
function IoDesktop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 352a48.05 48.05 0 0048 48h133.88l-4 32H144a16 16 0 000 32h224a16 16 0 000-32h-49.88l-4-32H448a48.05 48.05 0 0048-48v-48H16zm240-16a16 16 0 11-16 16 16 16 0 0116-16zM496 96a48.05 48.05 0 00-48-48H64a48.05 48.05 0 00-48 48v192h480z"
                }
            }
        ]
    })(props);
}
function IoDiamondOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M35.42 188.21l207.75 269.46a16.17 16.17 0 0025.66 0l207.75-269.46a16.52 16.52 0 00.95-18.75L407.06 55.71A16.22 16.22 0 00393.27 48H118.73a16.22 16.22 0 00-13.79 7.71L34.47 169.46a16.52 16.52 0 00.95 18.75zM48 176h416"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M400 64l-48 112-96-128M112 64l48 112 96-128m0 400l-96-272m96 272l96-272"
                }
            }
        ]
    })(props);
}
function IoDiamondSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M396.31 32H264l84.19 112.26L396.31 32zm-280.62 0l48.12 112.26L248 32H115.69zM256 74.67L192 160h128l-64-85.33zm166.95-23.61L376.26 160H488L422.95 51.06zm-333.9 0L23 160h112.74L89.05 51.06zM146.68 192H24l222.8 288h.53L146.68 192zm218.64 0L264.67 480h.53L488 192H365.32zm-35.93 0H182.61L256 400l73.39-208z"
                }
            }
        ]
    })(props);
}
function IoDiamond(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M121.72 32a4 4 0 00-3.72 5.56l2.3 5.43 40.7 94.9a4 4 0 006.88.82L243 38.4a4 4 0 00-3.2-6.4zm298.21 26.06l-41.28 96.37a4 4 0 003.68 5.57h101a4 4 0 003.4-6.11L427 57.53a4 4 0 00-7.07.53zM85 57.57l-59.71 96.32a4 4 0 003.4 6.11h101a4 4 0 003.67-5.58L92 58.1a4 4 0 00-7-.53zM393.27 32H267.82a1.94 1.94 0 00-1.56 3.11l79.92 106.46a1.94 1.94 0 003.34-.4L391.6 43l3.4-8.34a1.92 1.92 0 00-1.7-2.66zM239 448l-89.43-253.49A3.78 3.78 0 00146 192H25.7a3.72 3.72 0 00-2.95 6l216 279.81a5.06 5.06 0 006.39 1.37 5 5 0 002.39-6.08zm247.3-256H366a3.75 3.75 0 00-3.54 2.51l-98.2 278.16a5.21 5.21 0 002.42 6.31 5.22 5.22 0 006.61-1.39L489.25 198a3.72 3.72 0 00-2.95-6zM259.2 78.93l56 74.67a4 4 0 01-3.2 6.4H200a4 4 0 01-3.2-6.4l56-74.67a4 4 0 016.4 0zm-7 310.31l-67.7-191.91a4 4 0 013.77-5.33h135.46a4 4 0 013.77 5.33l-67.73 191.91a4 4 0 01-7.54 0z"
                }
            }
        ]
    })(props);
}
function IoDiceOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M448 341.37V170.61A32 32 0 00432.11 143l-152-88.46a47.94 47.94 0 00-48.24 0L79.89 143A32 32 0 0064 170.61v170.76A32 32 0 0079.89 369l152 88.46a48 48 0 0048.24 0l152-88.46A32 32 0 00448 341.37z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M69 153.99l187 110 187-110m-187 310v-200"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "256",
                    "cy": "152",
                    "rx": "24",
                    "ry": "16"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "208",
                    "cy": "296",
                    "rx": "16",
                    "ry": "24"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "112",
                    "cy": "328",
                    "rx": "16",
                    "ry": "24"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "304",
                    "cy": "296",
                    "rx": "16",
                    "ry": "24"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "400",
                    "cy": "240",
                    "rx": "16",
                    "ry": "24"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "304",
                    "cy": "384",
                    "rx": "16",
                    "ry": "24"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "400",
                    "cy": "328",
                    "rx": "16",
                    "ry": "24"
                }
            }
        ]
    })(props);
}
function IoDiceSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 366.92L240 480V284L48 170zM192 288c8.84 0 16 10.75 16 24s-7.16 24-16 24-16-10.75-16-24 7.16-24 16-24zm-96 32c8.84 0 16 10.75 16 24s-7.16 24-16 24-16-10.75-16-24 7.16-24 16-24zm176-36v196l192-113.08V170zm48 140c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm0-88c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm96 32c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm0-88c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm32 77.64zM256 32L64 144l192 112 192-112zm0 120c-13.25 0-24-7.16-24-16s10.75-16 24-16 24 7.16 24 16-10.75 16-24 16z"
                }
            }
        ]
    })(props);
}
function IoDice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.88 129.37L288.16 40.62a64.14 64.14 0 00-64.33 0L71.12 129.37a4 4 0 000 6.9L254 243.85a4 4 0 004.06 0L440.9 136.27a4 4 0 00-.02-6.9zM256 152c-13.25 0-24-7.16-24-16s10.75-16 24-16 24 7.16 24 16-10.75 16-24 16zm-18 118.81L54 163.48a4 4 0 00-6 3.46v173.92a48 48 0 0023.84 41.39L234 479.48a4 4 0 006-3.46V274.27a4 4 0 00-2-3.46zM96 368c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm96-32c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm266-172.49L274 271.56a4 4 0 00-2 3.45V476a4 4 0 006 3.46l162.15-97.23A48 48 0 00464 340.86V167a4 4 0 00-6-3.49zM320 424c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm0-88c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm96 32c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm0-88c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24z"
                }
            }
        ]
    })(props);
}
function IoDiscOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "208",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "96",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "32"
                }
            }
        ]
    })(props);
}
function IoDiscSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM256 336a80 80 0 1180-80 80.09 80.09 0 01-80 80z"
                }
            }
        ]
    })(props);
}
function IoDisc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 176a80 80 0 1080 80 80.09 80.09 0 00-80-80zm0 112a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM256 368a112 112 0 11112-112 112.12 112.12 0 01-112 112z"
                }
            }
        ]
    })(props);
}
function IoDocumentAttachOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M208 64h66.75a32 32 0 0122.62 9.37l141.26 141.26a32 32 0 019.37 22.62V432a48 48 0 01-48 48H192a48 48 0 01-48-48V304"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M288 72v120a32 32 0 0032 32h120"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M160 80v152a23.69 23.69 0 01-24 24c-12 0-24-9.1-24-24V88c0-30.59 16.57-56 48-56s48 24.8 48 55.38v138.75c0 43-27.82 77.87-72 77.87s-72-34.86-72-77.87V144"
                }
            }
        ]
    })(props);
}
function IoDocumentAttachSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M280 240a8 8 0 01-8-8V48h-57.25a65.42 65.42 0 00-6.5-9.81C196.72 23.88 179.59 16 160 16c-37.68 0-64 29.61-64 72v144c0 25 20.34 40 40 40a39.57 39.57 0 0040-40V80h-32v152a7.75 7.75 0 01-8 8c-2.23 0-8-1.44-8-8V88c0-19.34 8.41-40 32-40 29.69 0 32 30.15 32 39.38v138.75c0 17.45-5.47 33.23-15.41 44.46C166.5 282 152.47 288 136 288s-30.5-6-40.59-17.41C85.47 259.36 80 243.58 80 226.13V144H48v82.13c0 51.51 33.19 89.63 80 93.53V468a12 12 0 0012 12h312a12 12 0 0012-12V240z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M308 208h146.31a2 2 0 001.42-3.41L307.41 56.27a2 2 0 00-3.41 1.42V204a4 4 0 004 4z"
                }
            }
        ]
    })(props);
}
function IoDocumentAttach(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M460 240H320a48 48 0 01-48-48V52a4 4 0 00-4-4h-53.25a65.42 65.42 0 00-6.5-9.81C196.72 23.88 179.59 16 160 16c-37.68 0-64 29.61-64 72v144c0 25 20.34 40 40 40a39.57 39.57 0 0040-40V80a16 16 0 00-32 0v152a7.75 7.75 0 01-8 8c-2.23 0-8-1.44-8-8V88c0-19.34 8.41-40 32-40 29.69 0 32 30.15 32 39.38v138.75c0 17.45-5.47 33.23-15.41 44.46C166.5 282 152.47 288 136 288s-30.5-6-40.59-17.41C85.47 259.36 80 243.58 80 226.13V144a16 16 0 00-32 0v82.13c0 51.51 33.19 89.63 80 93.53V432a64 64 0 0064 64h208a64 64 0 0064-64V244a4 4 0 00-4-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M320 208h129.81a2 2 0 001.41-3.41L307.41 60.78a2 2 0 00-3.41 1.41V192a16 16 0 0016 16z"
                }
            }
        ]
    })(props);
}
function IoDocumentLockOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M288 304v-18c0-16.63-14.26-30-32-30s-32 13.37-32 30v18"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M304 416h-96a32 32 0 01-32-32v-48a32 32 0 0132-32h96a32 32 0 0132 32v48a32 32 0 01-32 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M416 221.25V416a48 48 0 01-48 48H144a48 48 0 01-48-48V96a48 48 0 0148-48h98.75a32 32 0 0122.62 9.37l141.26 141.26a32 32 0 019.37 22.62z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 50.88V176a32 32 0 0032 32h125.12"
                }
            }
        ]
    })(props);
}
function IoDocumentLockSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M276 192h146.31a2 2 0 001.42-3.41L275.41 40.27a2 2 0 00-3.41 1.42V188a4 4 0 004 4zm-20 80c-8.82 0-16 6.28-16 14v18h32v-18c0-7.72-7.18-14-16-14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M248 224a8 8 0 01-8-8V32H92a12 12 0 00-12 12v424a12 12 0 0012 12h328a12 12 0 0012-12V224zm88 175.91A16.1 16.1 0 01319.91 416H192.09A16.1 16.1 0 01176 399.91V320c0-10 7-16 16-16h16v-18c0-25.36 21.53-46 48-46s48 20.64 48 46v18h16a15.8 15.8 0 0116 16z"
                }
            }
        ]
    })(props);
}
function IoDocumentLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 192h129.81a2 2 0 001.41-3.41L275.41 44.78a2 2 0 00-3.41 1.41V176a16 16 0 0016 16zm-32 80c-8.82 0-16 6.28-16 14v18h32v-18c0-7.72-7.18-14-16-14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M428 224H288a48 48 0 01-48-48V36a4 4 0 00-4-4h-92a64 64 0 00-64 64v320a64 64 0 0064 64h224a64 64 0 0064-64V228a4 4 0 00-4-4zm-92 160a32 32 0 01-32 32h-96a32 32 0 01-32-32v-48a32 32 0 0132-32v-18c0-25.36 21.53-46 48-46s48 20.64 48 46v18a32 32 0 0132 32z"
                }
            }
        ]
    })(props);
}
function IoDocumentOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M416 221.25V416a48 48 0 01-48 48H144a48 48 0 01-48-48V96a48 48 0 0148-48h98.75a32 32 0 0122.62 9.37l141.26 141.26a32 32 0 019.37 22.62z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 56v120a32 32 0 0032 32h120"
                }
            }
        ]
    })(props);
}
function IoDocumentSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 216V32H92a12 12 0 00-12 12v424a12 12 0 0012 12h328a12 12 0 0012-12V224H248a8 8 0 01-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M272 41.69V188a4 4 0 004 4h146.31a2 2 0 001.42-3.41L275.41 40.27a2 2 0 00-3.41 1.42z"
                }
            }
        ]
    })(props);
}
function IoDocumentTextOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M416 221.25V416a48 48 0 01-48 48H144a48 48 0 01-48-48V96a48 48 0 0148-48h98.75a32 32 0 0122.62 9.37l141.26 141.26a32 32 0 019.37 22.62z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 56v120a32 32 0 0032 32h120m-232 80h160m-160 80h160"
                }
            }
        ]
    })(props);
}
function IoDocumentTextSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 41.69V188a4 4 0 004 4h146.31a2 2 0 001.42-3.41L275.41 40.27a2 2 0 00-3.41 1.42z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M248 224a8 8 0 01-8-8V32H92a12 12 0 00-12 12v424a12 12 0 0012 12h328a12 12 0 0012-12V224zm104 160H160v-32h192zm0-80H160v-32h192z"
                }
            }
        ]
    })(props);
}
function IoDocumentText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M428 224H288a48 48 0 01-48-48V36a4 4 0 00-4-4h-92a64 64 0 00-64 64v320a64 64 0 0064 64h224a64 64 0 0064-64V228a4 4 0 00-4-4zm-92 160H176a16 16 0 010-32h160a16 16 0 010 32zm0-80H176a16 16 0 010-32h160a16 16 0 010 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M419.22 188.59L275.41 44.78a2 2 0 00-3.41 1.41V176a16 16 0 0016 16h129.81a2 2 0 001.41-3.41z"
                }
            }
        ]
    })(props);
}
function IoDocument(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M428 224H288a48 48 0 01-48-48V36a4 4 0 00-4-4h-92a64 64 0 00-64 64v320a64 64 0 0064 64h224a64 64 0 0064-64V228a4 4 0 00-4-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M419.22 188.59L275.41 44.78a2 2 0 00-3.41 1.41V176a16 16 0 0016 16h129.81a2 2 0 001.41-3.41z"
                }
            }
        ]
    })(props);
}
function IoDocumentsOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M336 264.13V436c0 24.3-19.05 44-42.95 44H107c-23.95 0-43-19.7-43-44V172a44.26 44.26 0 0144-44h94.12a24.55 24.55 0 0117.49 7.36l109.15 111a25.4 25.4 0 017.24 17.77z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M200 128v108a28.34 28.34 0 0028 28h108"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M176 128V76a44.26 44.26 0 0144-44h94a24.83 24.83 0 0117.61 7.36l109.15 111A25.09 25.09 0 01448 168v172c0 24.3-19.05 44-42.95 44H344"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M312 32v108a28.34 28.34 0 0028 28h108"
                }
            }
        ]
    })(props);
}
function IoDocumentsSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M307.94 248L216 154.52V242a6 6 0 006 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M184 268V144H60a12 12 0 00-12 12v328a12 12 0 0012 12h248a12 12 0 0012-12V280H196a12 12 0 01-12-12zm182-148h85.94L360 26.52V114a6 6 0 006 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M340 152a12 12 0 01-12-12V16H172a12 12 0 00-12 12v84h42.12A40.81 40.81 0 01231 124.14l109.16 111a41.11 41.11 0 0111.83 29V400H452a12 12 0 0012-12V152z"
                }
            }
        ]
    })(props);
}
function IoDocuments(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.39 248a4 4 0 002.86-6.8l-78.4-79.72a4 4 0 00-6.85 2.81V236a12 12 0 0012 12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M197 267a43.67 43.67 0 01-13-31v-92h-72a64.19 64.19 0 00-64 64v224a64 64 0 0064 64h144a64 64 0 0064-64V280h-92a43.61 43.61 0 01-31-13zm175-147h70.39a4 4 0 002.86-6.8l-78.4-79.72a4 4 0 00-6.85 2.81V108a12 12 0 0012 12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M372 152a44.34 44.34 0 01-44-44V16H220a60.07 60.07 0 00-60 60v36h42.12A40.81 40.81 0 01231 124.14l109.16 111a41.11 41.11 0 0111.83 29V400h53.05c32.51 0 58.95-26.92 58.95-60V152z"
                }
            }
        ]
    })(props);
}
function IoDownloadOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M336 176h40a40 40 0 0140 40v208a40 40 0 01-40 40H136a40 40 0 01-40-40V216a40 40 0 0140-40h40"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M176 272l80 80 80-80M256 48v288"
                }
            }
        ]
    })(props);
}
function IoDownloadSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 160v147.37l64-64L358.63 266 256 368.63 153.37 266 176 243.37l64 64V160H92a12 12 0 00-12 12v296a12 12 0 0012 12h328a12 12 0 0012-12V172a12 12 0 00-12-12zM240 32h32v128h-32z"
                }
            }
        ]
    })(props);
}
function IoDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M376 160H272v153.37l52.69-52.68a16 16 0 0122.62 22.62l-80 80a16 16 0 01-22.62 0l-80-80a16 16 0 0122.62-22.62L240 313.37V160H136a56.06 56.06 0 00-56 56v208a56.06 56.06 0 0056 56h240a56.06 56.06 0 0056-56V216a56.06 56.06 0 00-56-56zM272 48a16 16 0 00-32 0v112h32z"
                }
            }
        ]
    })(props);
}
function IoDuplicateOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "336",
                    "height": "336",
                    "x": "128",
                    "y": "128",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "57",
                    "ry": "57"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M383.5 128l.5-24a56.16 56.16 0 00-56-56H112a64.19 64.19 0 00-64 64v216a56.16 56.16 0 0056 56h24m168-168v160m80-80H216"
                }
            }
        ]
    })(props);
}
function IoDuplicateSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 80h288V56a24 24 0 00-24-24H66a34 34 0 00-34 34v310a24 24 0 0024 24h24V112a32 32 0 0132-32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M456 112H136a24 24 0 00-24 24v320a24 24 0 0024 24h320a24 24 0 0024-24V136a24 24 0 00-24-24zm-64 200h-80v80h-32v-80h-80v-32h80v-80h32v80h80z"
                }
            }
        ]
    })(props);
}
function IoDuplicate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408 112H184a72 72 0 00-72 72v224a72 72 0 0072 72h224a72 72 0 0072-72V184a72 72 0 00-72-72zm-32.45 200H312v63.55c0 8.61-6.62 16-15.23 16.43A16 16 0 01280 376v-64h-63.55c-8.61 0-16-6.62-16.43-15.23A16 16 0 01216 280h64v-63.55c0-8.61 6.62-16 15.23-16.43A16 16 0 01312 216v64h64a16 16 0 0116 16.77c-.42 8.61-7.84 15.23-16.45 15.23z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M395.88 80A72.12 72.12 0 00328 32H104a72 72 0 00-72 72v224a72.12 72.12 0 0048 67.88V160a80 80 0 0180-80z"
                }
            }
        ]
    })(props);
}
function IoEarOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M335.72 330.76C381.73 299.5 416 251.34 416 192a160 160 0 00-320 0v206.57c0 44.26 35.74 81.43 80 81.43h0c44.26 0 66.83-25.94 77.29-40 14.77-19.81 41.71-81.56 82.43-109.24z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 304V184c0-48.4 43.2-88 96-88h0c52.8 0 96 39.6 96 88"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 239c25-18 79.82-15 79.82-15 26 0 41.17 29.42 26 50.6 0 0-36.86 42.4-41.86 61.4"
                }
            }
        ]
    })(props);
}
function IoEarSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M380.48 68.09C347.09 34.5 302.88 16 256 16 159 16 80 95 80 192v206.57a97.59 97.59 0 0028 68.49A94.49 94.49 0 00176 496c19.93 0 41.06-7.69 62.8-22.87a181.46 181.46 0 0025.88-21.86C327.37 390.16 432 288.06 432 192c0-46.49-18.29-90.49-51.52-123.91zM368 200h-32v-16c0-39.7-35.89-72-80-72s-80 32.3-80 72v30.41c27.5-7.84 59.89-6.62 64.26-6.41a48 48 0 0138.62 75.9c-.3.41-.61.81-.95 1.2-16.55 19-36 45.49-38.46 55l-4.07 15.47-30.94-8.14 4.07-15.47c5.51-20.94 36.93-58.2 44.66-67.15A16 16 0 00239.82 240h-.88c-10.67-.58-42.66-.25-62.12 8l-.82.35V320h-32V184c0-57.35 50.24-104 112-104s112 46.65 112 104z"
                }
            }
        ]
    })(props);
}
function IoEar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 16C159 16 80 95 80 192v206.57a97.59 97.59 0 0028 68.49A94.51 94.51 0 00176 496c36.86 0 67.18-15.62 90.12-46.42 4.48-6 9.55-14.74 15.42-24.85 15.32-26.37 36.29-62.47 63.17-80.74 25.77-17.51 47.23-39.54 62-63.72C423.51 252.94 432 223.24 432 192c0-97-78.95-176-176-176zm96 184a16 16 0 01-16-16c0-39.7-35.89-72-80-72s-80 32.3-80 72v30.42c27.19-7.84 58.4-6.72 64.28-6.42a48 48 0 0138.6 75.9c-.3.41-.61.81-.95 1.2-16.55 19-36 45.48-38.46 55a16 16 0 01-30.94-8.14c5.51-20.94 36.93-58.2 44.66-67.15A16 16 0 00239.82 240h-.88c-16.6-.89-45.89.8-62.94 8.31V304a16 16 0 01-32 0V184c0-57.35 50.24-104 112-104s112 46.65 112 104a16 16 0 01-16 16z"
                }
            }
        ]
    })(props);
}
function IoEarthOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M464 256c0-114.87-93.13-208-208-208S48 141.13 48 256s93.13 208 208 208 208-93.13 208-208z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M445.57 172.14c-16.06.1-14.48 29.73-34.49 15.75-7.43-5.18-12-12.71-21.33-15-8.15-2-16.5.08-24.55 1.47-9.15 1.58-20 2.29-26.94 9.22-6.71 6.67-10.26 15.62-17.4 22.33-13.81 13-19.64 27.19-10.7 45.57 8.6 17.67 26.59 27.26 46 26 19.07-1.27 38.88-12.33 38.33 15.38-.2 9.8 1.85 16.6 4.86 25.71 2.79 8.4 2.6 16.54 3.24 25.21 1.18 16.2 4.16 34.36 12.2 48.67l15-21.16c1.85-2.62 5.72-6.29 6.64-9.38 1.63-5.47-1.58-14.87-1.95-21s-.19-12.34-1.13-18.47c-1.32-8.59-6.4-16.64-7.1-25.13-1.29-15.81 1.6-28.43-10.58-41.65-11.76-12.75-29-15.81-45.47-13.22-8.3 1.3-41.71 6.64-28.3-12.33 2.65-3.73 7.28-6.79 10.26-10.34 2.59-3.09 4.84-8.77 7.88-11.18s17-5.18 21-3.95 8.17 7 11.64 9.56a49.89 49.89 0 0021.81 9.36c13.66 2 42.22-5.94 42-23.46-.04-8.4-7.84-20.1-10.92-27.96zM287.45 316.3c-5.33-22.44-35.82-29.94-52.26-42.11-9.45-7-17.86-17.81-30.27-18.69-5.72-.41-10.51.83-16.18-.64-5.2-1.34-9.28-4.14-14.82-3.41-10.35 1.36-16.88 12.42-28 10.92-10.55-1.42-21.42-13.76-23.82-23.81-3.08-12.92 7.14-17.11 18.09-18.26 4.57-.48 9.7-1 14.09.67 5.78 2.15 8.51 7.81 13.7 10.67 9.73 5.33 11.7-3.19 10.21-11.83-2.23-12.94-4.83-18.22 6.71-27.12 8-6.14 14.84-10.58 13.56-21.61-.76-6.48-4.31-9.41-1-15.86 2.51-4.91 9.4-9.34 13.89-12.27 11.59-7.56 49.65-7 34.1-28.16-4.57-6.21-13-17.31-21-18.83-10-1.89-14.44 9.27-21.41 14.19-7.2 5.09-21.22 10.87-28.43 3-9.7-10.59 6.43-14.07 10-21.46s-8.27-21.36-14.61-24.9l-29.81 33.43a41.52 41.52 0 008.34 31.86c5.93 7.63 15.37 10.08 15.8 20.5.42 10-1.14 15.12-7.68 22.15-2.83 3-4.83 7.26-7.71 10.07-3.53 3.43-2.22 2.38-7.73 3.32-10.36 1.75-19.18 4.45-29.19 7.21C95.34 199.94 93.8 172.69 86.2 162l-25 20.19c-.27 3.31 4.1 9.4 5.29 13 6.83 20.57 20.61 36.48 29.51 56.16 9.37 20.84 34.53 15.06 45.64 33.32 9.86 16.2-.67 36.71 6.71 53.67 5.36 12.31 18 15 26.72 24 8.91 9.09 8.72 21.53 10.08 33.36a305.22 305.22 0 007.45 41.28c1.21 4.69 2.32 10.89 5.53 14.76 2.2 2.66 9.75 4.95 6.7 5.83 4.26.7 11.85 4.68 15.4 1.76 4.68-3.84 3.43-15.66 4.24-21 2.43-15.9 10.39-31.45 21.13-43.35 10.61-11.74 25.15-19.69 34.11-33 8.73-12.98 11.36-30.49 7.74-45.68zm-33.39 26.32c-6 10.71-19.36 17.88-27.95 26.39-2.33 2.31-7.29 10.31-10.21 8.58-2.09-1.24-2.8-11.62-3.57-14a61.17 61.17 0 00-21.71-29.95c-3.13-2.37-10.89-5.45-12.68-8.7-2-3.53-.2-11.86-.13-15.7.11-5.6-2.44-14.91-1.06-20 1.6-5.87-1.48-2.33 3.77-3.49 2.77-.62 14.21 1.39 17.66 2.11 5.48 1.14 8.5 4.55 12.82 8 11.36 9.11 23.87 16.16 36.6 23.14 9.86 5.46 12.76 12.37 6.46 23.62zm-69.6-275.53c4.74 4.63 9.2 10.11 16.27 10.57 6.69.45 13-3.17 18.84 1.38 6.48 5 11.15 11.33 19.75 12.89 8.32 1.51 17.13-3.35 19.19-11.86 2-8.11-2.31-16.93-2.57-25.07 0-1.13.61-6.15-.17-7-.58-.64-5.42.08-6.16.1q-8.13.24-16.22 1.12a207.1 207.1 0 00-57.18 14.65c2.43 1.68 5.48 2.35 8.25 3.22zm171.94 56.18c8.49 0 17.11-3.8 14.37-13.62-2.3-8.23-6.22-17.16-15.76-12.72-6.07 2.82-14.67 10-15.38 17.12-.81 8.08 11.11 9.22 16.77 9.22zm-6.78 42.97c8.67 5.19 21.53 2.75 28.07-4.66 5.11-5.8 8.12-15.87 17.31-15.86a15.4 15.4 0 0110.82 4.41c3.8 3.93 3.05 7.62 3.86 12.54 1.81 11.05 13.66.63 16.75-3.65 2-2.79 4.71-6.93 3.8-10.56-.84-3.39-4.8-7-6.56-10.11-5.14-9-9.37-19.47-17.07-26.74-7.41-7-16.52-6.19-23.55 1.08-5.76 6-12.45 10.75-16.39 18.05-2.78 5.13-5.91 7.58-11.54 8.91-3.1.73-6.64 1-9.24 3.08-7.24 5.7-3.12 19.39 3.74 23.51z"
                }
            }
        ]
    })(props);
}
function IoEarthSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M267 474l-.8-.13a.85.85 0 00.8.13zm181.9-286.22a5.51 5.51 0 00-10.67-.63A5.52 5.52 0 01433 191h-15.47a5.48 5.48 0 01-2.84-.79l-22.38-13.42a5.48 5.48 0 00-2.84-.79h-35.8a5.48 5.48 0 00-3.06.93l-44.15 29.43A5.52 5.52 0 00304 211v41.74a5.51 5.51 0 002.92 4.87l57.89 30.9a5.55 5.55 0 012.92 4.8l.27 23.49a5.53 5.53 0 002.85 4.75l23.26 12.87a5.54 5.54 0 012.85 4.83v48.6a5.52 5.52 0 009.17 4.14c9.38-8.26 22.83-20.32 24.62-23.08q4.44-6.87 8.33-14.07a207.39 207.39 0 0013.6-31c12.68-36.71 2.66-102.7-3.78-136.06zM286.4 302.8l-61.33-46a4 4 0 00-2.4-.8h-29.1a3.78 3.78 0 01-2.68-1.11l-13.72-13.72a4 4 0 00-2.83-1.17h-53.19a3.79 3.79 0 01-2.68-6.47l8.42-8.42a3.78 3.78 0 012.68-1.11h32.37a8 8 0 007.7-5.83l6.89-24.5a4 4 0 012-2.47L206 177.06a3.79 3.79 0 002.05-3.37v-12.5a3.82 3.82 0 01.68-2.17l14.6-21.02a3.75 3.75 0 011.78-1.38l20.43-7.67a3.79 3.79 0 002.46-3.55V114a3.8 3.8 0 00-1.69-3.16l-20.48-13.62A3.83 3.83 0 00222 97l-27.88 13.94a3.78 3.78 0 01-4-.41l-13.22-10.45a3.8 3.8 0 01.1-6l10.74-7.91a3.78 3.78 0 00-.09-6.16l-16.73-11.67a3.78 3.78 0 00-4-.22c-6.05 3.31-23.8 13.11-30.1 17.52a209.48 209.48 0 00-68.16 80c-1.82 3.76-4.07 7.59-4.29 11.72s-3.46 13.35-4.81 17.08a3.78 3.78 0 00.24 3.1l35.69 65.58a3.74 3.74 0 001.38 1.44l37.55 22.54a3.78 3.78 0 011.81 2.73l7.52 54.54a3.82 3.82 0 001.61 2.61l29.3 20.14a4 4 0 011.65 2.48l15.54 73.8a3.6 3.6 0 00.49 1.22c1.46 2.36 7.28 11 14.3 12.28-.65.18-1.23.59-1.88.78a47.63 47.63 0 015 1.16c2 .54 4 1 6 1.43 3.13.62 3.44 1.1 4.94-1.68 2-3.72 4.29-5 6-5.46a3.85 3.85 0 002.89-2.9l10.07-46.68a4 4 0 011.6-2.42l45-31.9a4 4 0 001.69-3.27V306a4 4 0 00-1.55-3.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M262 48s-3.65.21-4.39.23q-8.13.24-16.22 1.12A207.45 207.45 0 00184.21 64c2.43 1.68-1.75 3.22-1.75 3.22L189 80h35l24 12 21-12zm92.23 72.06l16.11-14a4 4 0 00-.94-6.65l-18.81-8.73a4 4 0 00-5.3 1.9l-7.75 16.21a4 4 0 001.49 5.11l10.46 6.54a4 4 0 004.74-.38zm75.41 20.61l-5.83-9c-.09-.14-.17-.28-.25-.43-1.05-2.15-9.74-19.7-17-26.51-5.45-5.15-7-3.67-7.43-2.53a3.77 3.77 0 01-1.19 1.6l-28.84 23.31a4 4 0 01-2.51.89h-14.93a4 4 0 00-2.83 1.17l-12 12a4 4 0 000 5.66l12 12a4 4 0 002.83 1.17h75.17a4 4 0 004-4.17l-.55-13.15a4 4 0 00-.64-2.01z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 72a184 184 0 11-130.1 53.9A182.77 182.77 0 01256 72m0-40C132.3 32 32 132.3 32 256s100.3 224 224 224 224-100.3 224-224S379.7 32 256 32z"
                }
            }
        ]
    })(props);
}
function IoEarth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.39 97.74A224 224 0 1097.61 414.52 224 224 0 10414.39 97.74zM64 256.13a191.63 191.63 0 016.7-50.31c7.34 15.8 18 29.45 25.25 45.66 9.37 20.84 34.53 15.06 45.64 33.32 9.86 16.21-.67 36.71 6.71 53.67 5.36 12.31 18 15 26.72 24 8.91 9.08 8.72 21.52 10.08 33.36a305.36 305.36 0 007.45 41.27c0 .1 0 .21.08.31C117.8 411.13 64 339.8 64 256.13zm192 192a193.12 193.12 0 01-32-2.68c.11-2.71.16-5.24.43-7 2.43-15.9 10.39-31.45 21.13-43.35 10.61-11.74 25.15-19.68 34.11-33 8.78-13 11.41-30.5 7.79-45.69-5.33-22.44-35.82-29.93-52.26-42.1-9.45-7-17.86-17.82-30.27-18.7-5.72-.4-10.51.83-16.18-.63-5.2-1.35-9.28-4.15-14.82-3.42-10.35 1.36-16.88 12.42-28 10.92-10.55-1.41-21.42-13.76-23.82-23.81-3.08-12.92 7.14-17.11 18.09-18.26 4.57-.48 9.7-1 14.09.68 5.78 2.14 8.51 7.8 13.7 10.66 9.73 5.34 11.7-3.19 10.21-11.83-2.23-12.94-4.83-18.21 6.71-27.12 8-6.14 14.84-10.58 13.56-21.61-.76-6.48-4.31-9.41-1-15.86 2.51-4.91 9.4-9.34 13.89-12.27 11.59-7.56 49.65-7 34.1-28.16-4.57-6.21-13-17.31-21-18.83-10-1.89-14.44 9.27-21.41 14.19-7.2 5.09-21.22 10.87-28.43 3-9.7-10.59 6.43-14.06 10-21.46 1.65-3.45 0-8.24-2.78-12.75q5.41-2.28 11-4.23a15.6 15.6 0 008 3c6.69.44 13-3.18 18.84 1.38 6.48 5 11.15 11.32 19.75 12.88 8.32 1.51 17.13-3.34 19.19-11.86 1.25-5.18 0-10.65-1.2-16a190.83 190.83 0 01105 32.21c-2-.76-4.39-.67-7.34.7-6.07 2.82-14.67 10-15.38 17.12-.81 8.08 11.11 9.22 16.77 9.22 8.5 0 17.11-3.8 14.37-13.62-1.19-4.26-2.81-8.69-5.42-11.37a193.27 193.27 0 0118 14.14c-.09.09-.18.17-.27.27-5.76 6-12.45 10.75-16.39 18.05-2.78 5.14-5.91 7.58-11.54 8.91-3.1.73-6.64 1-9.24 3.08-7.24 5.7-3.12 19.4 3.74 23.51 8.67 5.19 21.53 2.75 28.07-4.66 5.11-5.8 8.12-15.87 17.31-15.86a15.4 15.4 0 0110.82 4.41c3.8 3.94 3.05 7.62 3.86 12.54 1.43 8.74 9.14 4 13.83-.41a192.12 192.12 0 019.24 18.77c-5.16 7.43-9.26 15.53-21.67 6.87-7.43-5.19-12-12.72-21.33-15.06-8.15-2-16.5.08-24.55 1.47-9.15 1.59-20 2.29-26.94 9.22-6.71 6.68-10.26 15.62-17.4 22.33-13.81 13-19.64 27.19-10.7 45.57 8.6 17.67 26.59 27.26 46 26 19.07-1.27 38.88-12.33 38.33 15.38-.2 9.81 1.85 16.6 4.86 25.71 2.79 8.4 2.6 16.54 3.24 25.21a158 158 0 004.74 30.07A191.75 191.75 0 01256 448.13z"
                }
            }
        ]
    })(props);
}
function IoEaselOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "416",
                    "height": "272",
                    "x": "48",
                    "y": "80",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "32",
                    "ry": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 416v-64m0-272V48m144 416l-32-112M112 464l32-112"
                }
            }
        ]
    })(props);
}
function IoEaselSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M468 64H278V32h-44v32H44a12 12 0 00-12 12v280a12 12 0 0012 12h78.19L89.93 470.46l36.53 9.61L161.74 368H234v64h44v-64h71.84l31 111.7 36.83-8.57L389.05 368H468a12 12 0 0012-12V76a12 12 0 00-12-12zm-26 266H70V102h372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M88 120h336v192H88z"
                }
            }
        ]
    })(props);
}
function IoEasel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "352",
                    "height": "208",
                    "x": "80",
                    "y": "112",
                    "rx": "12",
                    "ry": "12"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M432 64H272V48a16 16 0 00-32 0v16H80a48.05 48.05 0 00-48 48v208a48.05 48.05 0 0048 48h42.79l-26.17 91.6a16 16 0 1030.76 8.8L156.07 368H240v48a16 16 0 0032 0v-48h83.93l28.69 100.4a16 16 0 1030.76-8.8L389.21 368H432a48.05 48.05 0 0048-48V112a48.05 48.05 0 00-48-48zm16 256a16 16 0 01-16 16H80a16 16 0 01-16-16V112a16 16 0 0116-16h352a16 16 0 0116 16z"
                }
            }
        ]
    })(props);
}
function IoEggOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 48C192 48 96 171.69 96 286.55S160 464 256 464s160-62.59 160-177.45S320 48 256 48z"
                }
            }
        ]
    })(props);
}
function IoEggSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M418.39 381.05c-8.08 21.68-19.76 40.1-34.72 54.75-14.38 14.07-32.1 24.95-52.67 32.34C309.08 476 283.85 480 256 480s-53.08-4-75-11.86c-20.57-7.39-38.29-18.27-52.67-32.34-15-14.65-26.64-33.07-34.72-54.75C84.58 356.82 80 328.53 80 296.94c0-30.28 6.68-62.57 19.86-96A371 371 0 01151 111.42C195.78 53.56 241 32 256 32s62.67 22.4 105 79.42c18.33 24.71 38.87 58.34 51.17 89.54 13.18 33.41 19.86 65.7 19.86 96-.03 31.57-4.61 59.86-13.64 84.09z"
                }
            }
        ]
    })(props);
}
function IoEgg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 480c-52.57 0-96.72-17.54-127.7-50.73C96.7 395.4 80 346.05 80 286.55 80 230.5 101.48 168 138.93 115 175.65 63 219.41 32 256 32s80.35 31 117.07 83C410.52 168 432 230.5 432 286.55c0 59.5-16.7 108.85-48.3 142.72C352.72 462.46 308.57 480 256 480z"
                }
            }
        ]
    })(props);
}
function IoEllipseOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "192",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function IoEllipseSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 464c-114.69 0-208-93.31-208-208S141.31 48 256 48s208 93.31 208 208-93.31 208-208 208z"
                }
            }
        ]
    })(props);
}
function IoEllipse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 464c-114.69 0-208-93.31-208-208S141.31 48 256 48s208 93.31 208 208-93.31 208-208 208z"
                }
            }
        ]
    })(props);
}
function IoEllipsisHorizontalCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "26"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "346",
                    "cy": "256",
                    "r": "26"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "166",
                    "cy": "256",
                    "r": "26"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            }
        ]
    })(props);
}
function IoEllipsisHorizontalCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm-90 234a26 26 0 1126-26 26 26 0 01-26 26zm90 0a26 26 0 1126-26 26 26 0 01-26 26zm90 0a26 26 0 1126-26 26 26 0 01-26 26z"
                }
            }
        ]
    })(props);
}
function IoEllipsisHorizontalCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "26"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "346",
                    "cy": "256",
                    "r": "26"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "166",
                    "cy": "256",
                    "r": "26"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            }
        ]
    })(props);
}
function IoEllipsisHorizontalOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "416",
                    "cy": "256",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "96",
                    "cy": "256",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function IoEllipsisHorizontalSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "48"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "416",
                    "cy": "256",
                    "r": "48"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "96",
                    "cy": "256",
                    "r": "48"
                }
            }
        ]
    })(props);
}
function IoEllipsisHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "48"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "416",
                    "cy": "256",
                    "r": "48"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "96",
                    "cy": "256",
                    "r": "48"
                }
            }
        ]
    })(props);
}
function IoEllipsisVerticalCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "26"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "346",
                    "r": "26"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "166",
                    "r": "26"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            }
        ]
    })(props);
}
function IoEllipsisVerticalCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256c0-114.87-93.13-208-208-208S48 141.13 48 256s93.13 208 208 208 208-93.13 208-208zm-234-90a26 26 0 1126 26 26 26 0 01-26-26zm0 90a26 26 0 1126 26 26 26 0 01-26-26zm0 90a26 26 0 1126 26 26 26 0 01-26-26z"
                }
            }
        ]
    })(props);
}
function IoEllipsisVerticalCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "26"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "346",
                    "r": "26"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "166",
                    "r": "26"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            }
        ]
    })(props);
}
function IoEllipsisVerticalOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "416",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "96",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function IoEllipsisVerticalSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "48"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "416",
                    "r": "48"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "96",
                    "r": "48"
                }
            }
        ]
    })(props);
}
function IoEllipsisVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "48"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "416",
                    "r": "48"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "96",
                    "r": "48"
                }
            }
        ]
    })(props);
}
function IoEnterOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M176 176v-40a40 40 0 0140-40h208a40 40 0 0140 40v240a40 40 0 01-40 40H216a40 40 0 01-40-40v-40"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M272 336l80-80-80-80M48 256h288"
                }
            }
        ]
    })(props);
}
function IoEnterSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 240h147.37l-64-64L266 153.37 368.63 256 266 358.63 243.37 336l64-64H160v148a12 12 0 0012 12h296a12 12 0 0012-12V92a12 12 0 00-12-12H172a12 12 0 00-12 12zm-128 0h128v32H32z"
                }
            }
        ]
    })(props);
}
function IoEnter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 136v104h153.37l-52.68-52.69a16 16 0 0122.62-22.62l80 80a16 16 0 010 22.62l-80 80a16 16 0 01-22.62-22.62L313.37 272H160v104a56.06 56.06 0 0056 56h208a56.06 56.06 0 0056-56V136a56.06 56.06 0 00-56-56H216a56.06 56.06 0 00-56 56zM48 240a16 16 0 000 32h112v-32z"
                }
            }
        ]
    })(props);
}
function IoExitOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 176v-40a40 40 0 00-40-40H88a40 40 0 00-40 40v240a40 40 0 0040 40h192a40 40 0 0040-40v-40m64-160l80 80-80 80m-193-80h273"
                }
            }
        ]
    })(props);
}
function IoExitSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M335.69 272h-161v-32h161V92a12 12 0 00-12-12h-280a12 12 0 00-12 12v328a12 12 0 0012 12h280a12 12 0 0012-12zm83.37 0l-64 64 22.63 22.63L480.31 256 377.69 153.37 355.06 176l64 64h-83.37v32h83.37z"
                }
            }
        ]
    })(props);
}
function IoExit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 376V272H191a16 16 0 010-32h145V136a56.06 56.06 0 00-56-56H88a56.06 56.06 0 00-56 56v240a56.06 56.06 0 0056 56h192a56.06 56.06 0 0056-56zm89.37-104l-52.68 52.69a16 16 0 0022.62 22.62l80-80a16 16 0 000-22.62l-80-80a16 16 0 00-22.62 22.62L425.37 240H336v32z"
                }
            }
        ]
    })(props);
}
function IoExpandOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M432 320v112H320m101.8-10.23L304 304M80 192V80h112M90.2 90.23L208 208M320 80h112v112M421.77 90.2L304 208M192 432H80V320m10.23 101.8L208 304"
                }
            }
        ]
    })(props);
}
function IoExpandSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M432 320v112H320m101.8-10.23L304 304M80 192V80h112M90.2 90.23L208 208M320 80h112v112M421.77 90.2L304 208M192 432H80V320m10.23 101.8L208 304"
                }
            }
        ]
    })(props);
}
function IoExpand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M432 320v112H320m101.8-10.23L304 304M80 192V80h112M90.2 90.23L208 208M320 80h112v112M421.77 90.2L304 208M192 432H80V320m10.23 101.8L208 304"
                }
            }
        ]
    })(props);
}
function IoExtensionPuzzleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M413.66 246.1H386a2 2 0 01-2-2v-77.24A38.86 38.86 0 00345.14 128H267.9a2 2 0 01-2-2V98.34c0-27.14-21.5-49.86-48.64-50.33a49.53 49.53 0 00-50.4 49.51V126a2 2 0 01-2 2H87.62A39.74 39.74 0 0048 167.62V238a2 2 0 002 2h26.91c29.37 0 53.68 25.48 54.09 54.85.42 29.87-23.51 57.15-53.29 57.15H50a2 2 0 00-2 2v70.38A39.74 39.74 0 0087.62 464H158a2 2 0 002-2v-20.93c0-30.28 24.75-56.35 55-57.06 30.1-.7 57 20.31 57 50.28V462a2 2 0 002 2h71.14A38.86 38.86 0 00384 425.14v-78a2 2 0 012-2h28.48c27.63 0 49.52-22.67 49.52-50.4s-23.2-48.64-50.34-48.64z"
                }
            }
        ]
    })(props);
}
function IoExtensionPuzzleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M345.14 480H256v-45.71a31.3 31.3 0 00-9.59-22.65c-7.67-7.56-18.83-11.81-30.57-11.64a44.38 44.38 0 00-28.45 10.67c-5.2 4.6-11.39 12.56-11.39 24.42V480H87.62A55.68 55.68 0 0132 424.38V336h45.71c9.16 0 18.07-3.92 25.09-11a42.06 42.06 0 0012.2-29.92C114.7 273.89 97.26 256 76.91 256H32v-89.34a53.77 53.77 0 0116.53-39A55.88 55.88 0 0187.62 112h63.24V97.52A65.53 65.53 0 01217.54 32c35.49.62 64.36 30.38 64.36 66.33V112h63.24A54.28 54.28 0 01400 166.86v63.24h13.66c36.58 0 66.34 29 66.34 64.64 0 36.61-29.39 66.4-65.52 66.4H400v63.24c0 30.67-24.61 55.62-54.86 55.62z"
                }
            }
        ]
    })(props);
}
function IoExtensionPuzzle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M345.14 480H274a18 18 0 01-18-18v-27.71a31.32 31.32 0 00-9.71-22.77c-7.78-7.59-19.08-11.8-30.89-11.51-21.36.5-39.4 19.3-39.4 41.06V462a18 18 0 01-18 18H87.62A55.62 55.62 0 0132 424.38V354a18 18 0 0118-18h27.71c9.16 0 18.07-3.92 25.09-11a42.06 42.06 0 0012.2-29.92C114.7 273.89 97.26 256 76.91 256H50a18 18 0 01-18-18v-70.38A55.62 55.62 0 0187.62 112h55.24a8 8 0 008-8v-6.48A65.53 65.53 0 01217.54 32c35.49.62 64.36 30.38 64.36 66.33V104a8 8 0 008 8h55.24A54.86 54.86 0 01400 166.86v55.24a8 8 0 008 8h5.66c36.58 0 66.34 29 66.34 64.64 0 36.61-29.39 66.4-65.52 66.4H408a8 8 0 00-8 8v56A54.86 54.86 0 01345.14 480z"
                }
            }
        ]
    })(props);
}
function IoEyeOffOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 448a15.92 15.92 0 01-11.31-4.69l-352-352a16 16 0 0122.62-22.62l352 352A16 16 0 01432 448zm-176.34-64c-41.49 0-81.5-12.28-118.92-36.5-34.07-22-64.74-53.51-88.7-91v-.08c19.94-28.57 41.78-52.73 65.24-72.21a2 2 0 00.14-2.94L93.5 161.38a2 2 0 00-2.71-.12c-24.92 21-48.05 46.76-69.08 76.92a31.92 31.92 0 00-.64 35.54c26.41 41.33 60.4 76.14 98.28 100.65C162 402 207.9 416 255.66 416a239.13 239.13 0 0075.8-12.58 2 2 0 00.77-3.31l-21.58-21.58a4 4 0 00-3.83-1 204.8 204.8 0 01-51.16 6.47zm235.18-145.4c-26.46-40.92-60.79-75.68-99.27-100.53C349 110.55 302 96 255.66 96a227.34 227.34 0 00-74.89 12.83 2 2 0 00-.75 3.31l21.55 21.55a4 4 0 003.88 1 192.82 192.82 0 0150.21-6.69c40.69 0 80.58 12.43 118.55 37 34.71 22.4 65.74 53.88 89.76 91a.13.13 0 010 .16 310.72 310.72 0 01-64.12 72.73 2 2 0 00-.15 2.95l19.9 19.89a2 2 0 002.7.13 343.49 343.49 0 0068.64-78.48 32.2 32.2 0 00-.1-34.78z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 160a95.88 95.88 0 00-21.37 2.4 2 2 0 00-1 3.38l112.59 112.56a2 2 0 003.38-1A96 96 0 00256 160zm-90.22 73.66a2 2 0 00-3.38 1 96 96 0 00115 115 2 2 0 001-3.38z"
                }
            }
        ]
    })(props);
}
function IoEyeOffSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M63.998 86.004l21.998-21.998L448 426.01l-21.998 21.998zM259.34 192.09l60.57 60.57a64.07 64.07 0 00-60.57-60.57zm-6.68 127.82l-60.57-60.57a64.07 64.07 0 0060.57 60.57z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 352a96 96 0 01-92.6-121.34l-69.07-69.08C66.12 187.42 39.24 221.14 16 256c26.42 44 62.56 89.24 100.2 115.18C159.38 400.92 206.33 416 255.76 416A233.47 233.47 0 00335 402.2l-53.61-53.6A95.84 95.84 0 01256 352zm0-192a96 96 0 0192.6 121.34L419.26 352c29.15-26.25 56.07-61.56 76.74-96-26.38-43.43-62.9-88.56-101.18-114.82C351.1 111.2 304.31 96 255.76 96a222.92 222.92 0 00-78.21 14.29l53.11 53.11A95.84 95.84 0 01256 160z"
                }
            }
        ]
    })(props);
}
function IoEyeOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 448a15.92 15.92 0 01-11.31-4.69l-352-352a16 16 0 0122.62-22.62l352 352A16 16 0 01432 448zM248 315.85l-51.79-51.79a2 2 0 00-3.39 1.69 64.11 64.11 0 0053.49 53.49 2 2 0 001.69-3.39zm16-119.7L315.87 248a2 2 0 003.4-1.69 64.13 64.13 0 00-53.55-53.55 2 2 0 00-1.72 3.39z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M491 273.36a32.2 32.2 0 00-.1-34.76c-26.46-40.92-60.79-75.68-99.27-100.53C349 110.55 302 96 255.68 96a226.54 226.54 0 00-71.82 11.79 4 4 0 00-1.56 6.63l47.24 47.24a4 4 0 003.82 1.05 96 96 0 01116 116 4 4 0 001.05 3.81l67.95 68a4 4 0 005.4.24 343.81 343.81 0 0067.24-77.4zM256 352a96 96 0 01-93.3-118.63 4 4 0 00-1.05-3.81l-66.84-66.87a4 4 0 00-5.41-.23c-24.39 20.81-47 46.13-67.67 75.72a31.92 31.92 0 00-.64 35.54c26.41 41.33 60.39 76.14 98.28 100.65C162.06 402 207.92 416 255.68 416a238.22 238.22 0 0072.64-11.55 4 4 0 001.61-6.64l-47.47-47.46a4 4 0 00-3.81-1.05A96 96 0 01256 352z"
                }
            }
        ]
    })(props);
}
function IoEyeOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M255.66 112c-77.94 0-157.89 45.11-220.83 135.33a16 16 0 00-.27 17.77C82.92 340.8 161.8 400 255.66 400c92.84 0 173.34-59.38 221.79-135.25a16.14 16.14 0 000-17.47C428.89 172.28 347.8 112 255.66 112z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "80",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function IoEyeSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M394.82 141.18C351.1 111.2 304.31 96 255.76 96c-43.69 0-86.28 13-126.59 38.48C88.52 160.23 48.67 207 16 256c26.42 44 62.56 89.24 100.2 115.18C159.38 400.92 206.33 416 255.76 416c49 0 95.85-15.07 139.3-44.79C433.31 345 469.71 299.82 496 256c-26.38-43.43-62.9-88.56-101.18-114.82zM256 352a96 96 0 1196-96 96.11 96.11 0 01-96 96z"
                }
            }
        ]
    })(props);
}
function IoEye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M490.84 238.6c-26.46-40.92-60.79-75.68-99.27-100.53C349 110.55 302 96 255.66 96c-42.52 0-84.33 12.15-124.27 36.11-40.73 24.43-77.63 60.12-109.68 106.07a31.92 31.92 0 00-.64 35.54c26.41 41.33 60.4 76.14 98.28 100.65C162 402 207.9 416 255.66 416c46.71 0 93.81-14.43 136.2-41.72 38.46-24.77 72.72-59.66 99.08-100.92a32.2 32.2 0 00-.1-34.76zM256 352a96 96 0 1196-96 96.11 96.11 0 01-96 96z"
                }
            }
        ]
    })(props);
}
function IoEyedropOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M262.51 204.22L70 396.69C57.56 409.15 48 464 48 464s54.38-9.09 67.31-22L307.8 249.51"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "192.15",
                    "height": "64.05",
                    "x": "211.72",
                    "y": "172.19",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "32.03",
                    "ry": "32.03",
                    "transform": "rotate(45 307.788 204.2)"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M289.91 141s20.57 8.57 37.22-8.08l54.67-70.63c18.5-19.41 49.26-18.69 67.94 0h0c18.68 18.68 19.34 48.81 0 67.93l-70.68 54.67c-15.65 15.65-8.08 37.22-8.08 37.22M115.31 442s-26.48 17.34-44.56-.73-.75-44.58-.75-44.58"
                }
            }
        ]
    })(props);
}
function IoEyedropSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 96.22a63.84 63.84 0 00-18.95-45.61 65 65 0 00-45.71-19h-.76a61.78 61.78 0 00-44.22 19.09l-74.88 74.88-33.88-33.86-34.07 33.91-33.85 34 44 44L32 409.37V480h70.63l205.7-205.71L352 317.94l11.31-11.19c.11-.1 10.42-10.31 22.79-22.68l33.85-34-33.89-33.89L461 141.23a63.18 63.18 0 0019-45.01zM245 292.35L219.65 267l40.68-40.69 25.38 25.38z"
                }
            }
        ]
    })(props);
}
function IoEyedrop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M461.05 51a65 65 0 00-45.71-19h-.76a61.81 61.81 0 00-44.36 19.25 12.81 12.81 0 00-1.07 1.25l-54 69.76c-5.62 7.1-12.74 8.68-16.78 4.64l-1.9-1.9a48 48 0 00-67.92 67.92l9.91 9.91a2 2 0 010 2.83L58.7 385.38C54 390.05 46.9 399.85 38.85 431c-4.06 15.71-6.51 29.66-6.61 30.24A16 16 0 0048 480a15.68 15.68 0 002.64-.22c.58-.1 14.44-2.43 30.13-6.44 31.07-7.94 41.05-15.24 45.85-20l179.77-179.79a2 2 0 012.82 0l9.92 9.92a48 48 0 0067.92-67.93l-1.59-1.54c-5-5-2.52-12.11 4.32-17.14l69.75-53.94a17.82 17.82 0 001.47-1.32 63.2 63.2 0 0019-45A63.88 63.88 0 00461.05 51zM250.78 283.9c-2.92 2.92-16.18 7.92-23.39.71s-2.24-20.42.69-23.35l33-33a2 2 0 012.83 0l19.84 19.83a2 2 0 010 2.83z"
                }
            }
        ]
    })(props);
}
function IoFastFoodOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M322 416c0 35.35-20.65 64-56 64H134c-35.35 0-56-28.65-56-64m258-80c17.67 0 32 17.91 32 40h0c0 22.09-14.33 40-32 40H64c-17.67 0-32-17.91-32-40h0c0-22.09 14.33-40 32-40"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M344 336H179.31a8 8 0 00-5.65 2.34l-26.83 26.83a4 4 0 01-5.66 0l-26.83-26.83a8 8 0 00-5.65-2.34H56a24 24 0 01-24-24h0a24 24 0 0124-24h288a24 24 0 0124 24h0a24 24 0 01-24 24zM64 276v-.22c0-55 45-83.78 100-83.78h72c55 0 100 29 100 84v-.22M241 112l7.44 63.97"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 480h139.31a32 32 0 0031.91-29.61L463 112"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M368 112l16-64 47-16"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M224 112h256"
                }
            }
        ]
    })(props);
}
function IoFastFoodSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 352H184.36l-41 35-41-35H16v24c0 30.59 21.13 55.51 47.26 56 2.43 15.12 8.31 28.78 17.16 39.47C93.51 487.28 112.54 496 134 496h132c21.46 0 40.49-8.72 53.58-24.55 8.85-10.69 14.73-24.35 17.16-39.47 13.88-.25 26.35-7.4 35-18.63A61.26 61.26 0 00384 376zm-279-32l38.33 28.19L182 320h202v-8a40.07 40.07 0 00-32-39.2c-.82-29.69-13-54.54-35.51-72C295.67 184.56 267.85 176 236 176h-72c-68.22 0-114.43 38.77-116 96.8A40.07 40.07 0 0016 312v8h89z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M463.08 96h-74.59l8.92-35.66L442 45l-10-29-62 20-14.49 60H208v32h18.75l1.86 16H236c39 0 73.66 10.9 100.12 31.52A121.9 121.9 0 01371 218.07a124.16 124.16 0 0110.73 32.65 72 72 0 0127.89 90.9A96 96 0 01416 376c0 22.34-7.6 43.63-21.4 59.95a80 80 0 01-31.83 22.95 109.21 109.21 0 01-18.53 33c-1.18 1.42-2.39 2.81-3.63 4.15H416c16 0 23-8 25-23l36.4-345H496V96z"
                }
            }
        ]
    })(props);
}
function IoFastFood(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 128h.09m111.46-32h-91.06l8.92-35.66 38.32-13.05c8.15-2.77 13-11.43 10.65-19.71a16 16 0 00-20.54-10.73l-47 16a16 16 0 00-10.36 11.27L355.51 96H224.45c-8.61 0-16 6.62-16.43 15.23A16 16 0 00224 128h2.75l1 8.66A8.3 8.3 0 00236 144c39 0 73.66 10.9 100.12 31.52A121.9 121.9 0 01371 218.07a123.4 123.4 0 0110.12 29.51 7.83 7.83 0 003.29 4.88 72 72 0 0126.38 86.43 7.92 7.92 0 00-.15 5.53A96 96 0 01416 376c0 22.34-7.6 43.63-21.4 59.95a80.12 80.12 0 01-28.78 21.67 8 8 0 00-4.21 4.37 108.19 108.19 0 01-17.37 29.86 2.5 2.5 0 001.9 4.11h49.21a48.22 48.22 0 0047.85-44.14L477.4 128h2.6a16 16 0 0016-16.77c-.42-8.61-7.84-15.23-16.45-15.23z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M108.69 320a23.87 23.87 0 0117 7l15.51 15.51a4 4 0 005.66 0L162.34 327a23.87 23.87 0 0117-7h196.58a8 8 0 008.08-7.92V312a40.07 40.07 0 00-32-39.2c-.82-29.69-13-54.54-35.51-72C295.67 184.56 267.85 176 236 176h-72c-68.22 0-114.43 38.77-116 96.8A40.07 40.07 0 0016 312a8 8 0 008 8zm77.25 32a8 8 0 00-5.66 2.34l-22.14 22.15a20 20 0 01-28.28 0l-22.14-22.15a8 8 0 00-5.66-2.34h-69.4a15.93 15.93 0 00-15.76 13.17A65.22 65.22 0 0016 376c0 30.59 21.13 55.51 47.26 56 2.43 15.12 8.31 28.78 17.16 39.47C93.51 487.28 112.54 496 134 496h132c21.46 0 40.49-8.72 53.58-24.55 8.85-10.69 14.73-24.35 17.16-39.47 26.13-.47 47.26-25.39 47.26-56a65.22 65.22 0 00-.9-10.83A15.93 15.93 0 00367.34 352z"
                }
            }
        ]
    })(props);
}
function IoFemaleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "184",
                    "r": "152",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 336v144m58-64H198"
                }
            }
        ]
    })(props);
}
function IoFemaleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M430 190c0-95.94-78.06-174-174-174S82 94.06 82 190c0 88.49 66.4 161.77 152 172.61V394h-58v44h58v58h44v-58h58v-44h-58v-31.39c85.6-10.84 152-84.12 152-172.61zm-304 0c0-71.68 58.32-130 130-130s130 58.32 130 130-58.32 130-130 130-130-58.32-130-130z"
                }
            }
        ]
    })(props);
}
function IoFemale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M430 190c0-95.94-78.06-174-174-174S82 94.06 82 190c0 88.49 66.4 161.77 152 172.61V394h-36a22 22 0 000 44h36v36a22 22 0 0044 0v-36h36a22 22 0 000-44h-36v-31.39c85.6-10.84 152-84.12 152-172.61zm-304 0c0-71.68 58.32-130 130-130s130 58.32 130 130-58.32 130-130 130-130-58.32-130-130z"
                }
            }
        ]
    })(props);
}
function IoFileTrayFullOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M384 80H128c-26 0-43 14-48 40L48 272v112a48.14 48.14 0 0048 48h320a48.14 48.14 0 0048-48V272l-32-152c-5-27-23-40-48-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 272h144m128 0h144m-272 0a64 64 0 00128 0M144 144h224m-240 64h256"
                }
            }
        ]
    })(props);
}
function IoFileTrayFullSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 128h256v38H128zm-16 64h288v38H112z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M448 64H64L32 256v192h448V256zm-12 192H320a64 64 0 01-128 0H76l22-150h316z"
                }
            }
        ]
    })(props);
}
function IoFileTrayFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M479.66 268.7l-32-151.81C441.48 83.77 417.68 64 384 64H128c-16.8 0-31 4.69-42.1 13.94s-18.37 22.31-21.58 38.89l-32 151.87A16.65 16.65 0 0032 272v112a64 64 0 0064 64h320a64 64 0 0064-64V272a16.65 16.65 0 00-.34-3.3zm-384-145.4v-.28c3.55-18.43 13.81-27 32.29-27H384c18.61 0 28.87 8.55 32.27 26.91 0 .13.05.26.07.39l26.93 127.88a4 4 0 01-3.92 4.82H320a15.92 15.92 0 00-16 15.82 48 48 0 11-96 0A15.92 15.92 0 00192 256H72.65a4 4 0 01-3.92-4.82z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M368 160H144a16 16 0 010-32h224a16 16 0 010 32zm16 64H128a16 16 0 010-32h256a16 16 0 010 32z"
                }
            }
        ]
    })(props);
}
function IoFileTrayOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M384 80H128c-26 0-43 14-48 40L48 272v112a48.14 48.14 0 0048 48h320a48.14 48.14 0 0048-48V272l-32-152c-5-27-23-40-48-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 272h144m128 0h144m-272 0a64 64 0 00128 0"
                }
            }
        ]
    })(props);
}
function IoFileTraySharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 64H64L32 256v192h448V256zm-12 192H320a64 64 0 01-128 0H76l22-150h316z"
                }
            }
        ]
    })(props);
}
function IoFileTrayStackedOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 336v96a48.14 48.14 0 0048 48h320a48.14 48.14 0 0048-48v-96"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 336h144m128 0h144m-272 0a64 64 0 00128 0"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M384 32H128c-26 0-43 14-48 40L48 192v96a48.14 48.14 0 0048 48h320a48.14 48.14 0 0048-48v-96L432 72c-5-27-23-40-48-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 192h144m128 0h144m-272 0a64 64 0 00128 0"
                }
            }
        ]
    })(props);
}
function IoFileTrayStackedSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 16H64L32 176v144h448V176zm-12 160H320a64 64 0 01-128 0H76L98 58h316zM320 352a64 64 0 01-128 0H32v144h448V352z"
                }
            }
        ]
    })(props);
}
function IoFileTrayStacked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 352H320a16 16 0 00-16 16 48 48 0 01-96 0 16 16 0 00-16-16H48a16 16 0 00-16 16v64a64.07 64.07 0 0064 64h320a64.07 64.07 0 0064-64v-64a16 16 0 00-16-16zm15.46-164.12L447.61 68.45C441.27 35.59 417.54 16 384 16H128c-16.8 0-31 4.69-42.1 13.94S67.66 52 64.4 68.4L32.54 187.88A15.9 15.9 0 0032 192v48c0 35.29 28.71 80 64 80h320c35.29 0 64-44.71 64-80v-48a15.9 15.9 0 00-.54-4.12zM440.57 176H320a15.92 15.92 0 00-16 15.82 48 48 0 11-96 0A15.92 15.92 0 00192 176H71.43a2 2 0 01-1.93-2.52L95.71 75c3.55-18.41 13.81-27 32.29-27h256c18.59 0 28.84 8.53 32.25 26.85l26.25 98.63a2 2 0 01-1.93 2.52z"
                }
            }
        ]
    })(props);
}
function IoFileTray(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M479.66 268.7l-32-151.81C441.48 83.77 417.68 64 384 64H128c-16.8 0-31 4.69-42.1 13.94s-18.37 22.31-21.58 38.89l-32 151.87A16.65 16.65 0 0032 272v112a64 64 0 0064 64h320a64 64 0 0064-64V272a16.65 16.65 0 00-.34-3.3zm-384-145.4v-.28c3.55-18.43 13.81-27 32.29-27H384c18.61 0 28.87 8.55 32.27 26.91 0 .13.05.26.07.39l26.93 127.88a4 4 0 01-3.92 4.82H320a15.92 15.92 0 00-16 15.82 48 48 0 11-96 0A15.92 15.92 0 00192 256H72.65a4 4 0 01-3.92-4.82z"
                }
            }
        ]
    })(props);
}
function IoFilmOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "416",
                    "height": "320",
                    "x": "48",
                    "y": "96",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "28",
                    "ry": "28"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "384",
                    "y": "336",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "28",
                    "ry": "28"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "384",
                    "y": "256",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "28",
                    "ry": "28"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "384",
                    "y": "176",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "28",
                    "ry": "28"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "384",
                    "y": "96",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "28",
                    "ry": "28"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "48",
                    "y": "336",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "28",
                    "ry": "28"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "48",
                    "y": "256",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "28",
                    "ry": "28"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "48",
                    "y": "176",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "28",
                    "ry": "28"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "48",
                    "y": "96",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "28",
                    "ry": "28"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "256",
                    "height": "160",
                    "x": "128",
                    "y": "96",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "28",
                    "ry": "28"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "256",
                    "height": "160",
                    "x": "128",
                    "y": "256",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "28",
                    "ry": "28"
                }
            }
        ]
    })(props);
}
function IoFilmSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 80H32v352h448zM112 352v48H64v-48zm0-80v48H64v-48zm0-80v48H64v-48zm0-80v48H64v-48zm256 160H144v-32h224zm80 80v48h-48v-48zm0-80v48h-48v-48zm0-80v48h-48v-48zm0-80v48h-48v-48z"
                }
            }
        ]
    })(props);
}
function IoFilm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 80H76a44.05 44.05 0 00-44 44v264a44.05 44.05 0 0044 44h360a44.05 44.05 0 0044-44V124a44.05 44.05 0 00-44-44zM112 388a12 12 0 01-12 12H76a12 12 0 01-12-12v-24a12 12 0 0112-12h24a12 12 0 0112 12zm0-80a12 12 0 01-12 12H76a12 12 0 01-12-12v-24a12 12 0 0112-12h24a12 12 0 0112 12zm0-80a12 12 0 01-12 12H76a12 12 0 01-12-12v-24a12 12 0 0112-12h24a12 12 0 0112 12zm0-80a12 12 0 01-12 12H76a12 12 0 01-12-12v-24a12 12 0 0112-12h24a12 12 0 0112 12zm241.68 124H158.32a16 16 0 010-32h195.36a16 16 0 110 32zM448 388a12 12 0 01-12 12h-24a12 12 0 01-12-12v-24a12 12 0 0112-12h24a12 12 0 0112 12zm0-80a12 12 0 01-12 12h-24a12 12 0 01-12-12v-24a12 12 0 0112-12h24a12 12 0 0112 12zm0-80a12 12 0 01-12 12h-24a12 12 0 01-12-12v-24a12 12 0 0112-12h24a12 12 0 0112 12zm0-80a12 12 0 01-12 12h-24a12 12 0 01-12-12v-24a12 12 0 0112-12h24a12 12 0 0112 12z"
                }
            }
        ]
    })(props);
}
function IoFilterCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M144 208h224m-192 64h160m-112 64h64"
                }
            }
        ]
    })(props);
}
function IoFilterCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm48 304h-96v-32h96zm48-64H160v-32h192zm32-64H128v-32h256z"
                }
            }
        ]
    })(props);
}
function IoFilterCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm32 304h-64a16 16 0 010-32h64a16 16 0 010 32zm48-64H176a16 16 0 010-32h160a16 16 0 010 32zm32-64H144a16 16 0 010-32h224a16 16 0 010 32z"
                }
            }
        ]
    })(props);
}
function IoFilterOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M32 144h448M112 256h288M208 368h96"
                }
            }
        ]
    })(props);
}
function IoFilterSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 120h480v48H16zm80 112h320v48H96zm96 112h128v48H192z"
                }
            }
        ]
    })(props);
}
function IoFilter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M472 168H40a24 24 0 010-48h432a24 24 0 010 48zm-80 112H120a24 24 0 010-48h272a24 24 0 010 48zm-96 112h-80a24 24 0 010-48h80a24 24 0 010 48z"
                }
            }
        ]
    })(props);
}
function IoFingerPrintOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M390.42 75.28a10.45 10.45 0 01-5.32-1.44C340.72 50.08 302.35 40 256.35 40c-45.77 0-89.23 11.28-128.76 33.84C122 77 115.11 74.8 111.87 69a12.4 12.4 0 014.63-16.32A281.81 281.81 0 01256.35 16c49.23 0 92.23 11.28 139.39 36.48a12 12 0 014.85 16.08 11.3 11.3 0 01-10.17 6.72zm-330.79 126a11.73 11.73 0 01-6.7-2.16 12.26 12.26 0 01-2.78-16.8c22.89-33.6 52-60 86.69-78.48 72.58-38.84 165.51-39.12 238.32-.24 34.68 18.48 63.8 44.64 86.69 78a12.29 12.29 0 01-2.78 16.8 11.26 11.26 0 01-16.18-2.88c-20.8-30.24-47.15-54-78.36-70.56-66.34-35.28-151.18-35.28-217.29.24-31.44 16.8-57.79 40.8-78.59 71a10 10 0 01-9.02 5.08zM204.1 491a10.66 10.66 0 01-8.09-3.6C175.9 466.48 165 453 149.55 424c-16-29.52-24.27-65.52-24.27-104.16 0-71.28 58.71-129.36 130.84-129.36S387 248.56 387 319.84a11.56 11.56 0 11-23.11 0c0-58.08-48.32-105.36-107.72-105.36S148.4 261.76 148.4 319.84c0 34.56 7.39 66.48 21.49 92.4 14.8 27.6 25 39.36 42.77 58.08a12.67 12.67 0 010 17 12.44 12.44 0 01-8.56 3.68zm165.75-44.4c-27.51 0-51.78-7.2-71.66-21.36a129.1 129.1 0 01-55-105.36 11.57 11.57 0 1123.12 0 104.28 104.28 0 0044.84 85.44c16.41 11.52 35.6 17 58.72 17a147.41 147.41 0 0024-2.4c6.24-1.2 12.25 3.12 13.4 9.84a11.92 11.92 0 01-9.47 13.92 152.28 152.28 0 01-27.95 2.88zM323.38 496a13 13 0 01-3-.48c-36.76-10.56-60.8-24.72-86-50.4-32.37-33.36-50.16-77.76-50.16-125.28 0-38.88 31.9-70.56 71.19-70.56s71.2 31.68 71.2 70.56c0 25.68 21.5 46.56 48.08 46.56s48.08-20.88 48.08-46.56c0-90.48-75.13-163.92-167.59-163.92-65.65 0-125.75 37.92-152.79 96.72-9 19.44-13.64 42.24-13.64 67.2 0 18.72 1.61 48.24 15.48 86.64 2.32 6.24-.69 13.2-6.7 15.36a11.34 11.34 0 01-14.79-7 276.39 276.39 0 01-16.88-95c0-28.8 5.32-55 15.72-77.76 30.75-67 98.94-110.4 173.6-110.4 105.18 0 190.71 84.24 190.71 187.92 0 38.88-31.9 70.56-71.2 70.56s-71.2-31.68-71.2-70.56c.01-25.68-21.49-46.6-48.07-46.6s-48.08 20.88-48.08 46.56c0 41 15.26 79.44 43.23 108.24 22 22.56 43 35 75.59 44.4 6.24 1.68 9.71 8.4 8.09 14.64a11.39 11.39 0 01-10.87 9.16z"
                }
            }
        ]
    })(props);
}
function IoFingerPrintSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M56.79 200.58l12.36 7.5 7.35-13.58C93.07 166.75 143.78 102 256 102c115 0 164 70.32 180.1 93.46l8.16 12.7L469.88 192l-8.54-13.36c-8.88-12.85-27.52-39.53-60.78-63.1C360.15 86.82 311.5 72.25 256 72.25c-128.07 0-186.69 75.11-206 107.25L42.63 192 54 198.86a14.09 14.09 0 001.63 1.1 12.57 12.57 0 001.16.62z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M379.22 172.32c-35.54-28.93-78.12-44.25-123.22-44.25-97.52 0-162.31 66-183.33 131.47C53.42 320 76.82 407.61 77.8 411.36l4.38 13.81 29.93-6.43-4.74-15c-.21-.75-22.1-82.93-5.41-135.21 9-28.08 27.73-55.4 51.35-74.79C181.81 170.39 217.35 158 256 158c90.58 0 141.93 70.61 156.45 108.11 11.27 28.93 8.67 61.82-6.28 82-5.53 7.39-15.28 16.07-30.12 15.32-33.81-1.72-39.66-18.43-47.79-50.25-3.9-15.32-7.9-31.18-17.87-44-12.14-15.75-29.8-23.36-54.28-23.36-26.33 0-46.27 8.68-59.38 25.72-28.6 37.28-10 100.93-9.21 103.61l.22.85c1.41 3.86 36.08 96.65 128.93 119.68l14.77 3.21 8.09-28.71-15.27-3.43c-74.22-18.43-105.21-94.39-107.59-100.39a152.44 152.44 0 01-5.1-29.79c-1.08-14.46-.32-34.39 9.43-47.14 7.15-9.32 18.64-13.82 35-13.82 29.79 0 34.78 14.57 42.58 44.79 7.58 29.46 18 69.85 75.84 72.75 22.21 1.07 42.26-8.79 56.34-27.65 21.13-28.28 25.14-71.57 10.19-110.14-11.68-30.36-34.21-60.54-61.73-83.04z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M154.18 343.21c-3.47-28.28 1.41-71 26.55-98.78 17.44-19.29 42.79-29 75.19-29 37.49 0 65.87 16.72 84.51 49.61a154 154 0 0117.88 53.25l1.43 14.69 30-2.2a112.63 112.63 0 00-1-15.6c-.11-1.28-3.57-32.46-21-63.75-24.06-43.11-62.63-65.93-111.74-65.93-41.5 0-74.55 13.18-98.06 39.11-31.85 35.14-38.35 86.25-33.91 122.35v.33c7.97 54.53 28.97 98.14 66.12 137.14l11.6 11.22 20.95-21.79-10.34-9.79c-32.72-34.28-51.25-72.64-58.18-120.86zM132.47 72.66c11.08-6.72 50.27-26.77 123.53-26.77 87.54 0 126.44 28.72 126.87 28.93l13.9 8.86L413 58.47l-13.22-8.56c-.52-.38-1.06-.76-1.6-1.12C385.5 40.54 340.54 16 256 16c-87.71 0-132.75 26.48-143.41 33.71L99 58.52l16.2 25.21z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M390.59 415.21c-33.37 3.75-60.45-2.67-80.71-18.85-34.24-27.43-38.68-75.11-38.79-76l-1.23-14.88-30.53 2.23 1.31 15c.22 2.46 5.2 60.75 49.62 96.54 22.11 17.89 49.74 26.89 82.24 26.89a187 187 0 0021.56-1.29l16.59-2.09-6.1-29.71z"
                }
            }
        ]
    })(props);
}
function IoFingerPrint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M63.28 202a15.29 15.29 0 01-7.7-2 14.84 14.84 0 01-5.52-20.46C69.34 147.36 128 72.25 256 72.25c55.47 0 104.12 14.57 144.53 43.29 33.26 23.57 51.9 50.25 60.78 63.1a14.79 14.79 0 01-4 20.79 15.52 15.52 0 01-21.24-4C420 172.32 371 102 256 102c-112.25 0-163 64.71-179.53 92.46A15 15 0 0163.28 202z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M320.49 496a15.31 15.31 0 01-3.79-.43c-92.85-23-127.52-115.82-128.93-119.68l-.22-.85c-.76-2.68-19.39-66.33 9.21-103.61 13.11-17 33.05-25.72 59.38-25.72 24.48 0 42.14 7.61 54.28 23.36 10 12.86 14 28.72 17.87 44 8.13 31.82 14 48.53 47.79 50.25 14.84.75 24.59-7.93 30.12-15.32 14.95-20.15 17.55-53 6.28-82C398 228.57 346.61 158 256 158c-38.68 0-74.22 12.43-102.72 35.79-23.59 19.35-42.28 46.67-51.28 74.75-16.69 52.28 5.2 134.46 5.41 135.21A14.83 14.83 0 0196.54 422a15.39 15.39 0 01-18.74-10.6c-1-3.75-24.38-91.4-5.1-151.82 21-65.47 85.81-131.47 183.33-131.47 45.07 0 87.65 15.32 123.19 44.25 27.52 22.5 50 52.72 61.76 82.93 14.95 38.57 10.94 81.86-10.19 110.14-14.08 18.86-34.13 28.72-56.34 27.65-57.86-2.9-68.26-43.29-75.84-72.75-7.8-30.22-12.79-44.79-42.58-44.79-16.36 0-27.85 4.5-35 13.82-9.75 12.75-10.51 32.68-9.43 47.14a152.44 152.44 0 005.1 29.79c2.38 6 33.37 82 107.59 100.39a14.88 14.88 0 0111 18.11 15.36 15.36 0 01-14.8 11.21z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M201.31 489.14a15.5 15.5 0 01-11.16-4.71c-37.16-39-58.18-82.61-66.09-137.14V347c-4.44-36.1 2.06-87.21 33.91-122.35 23.51-25.93 56.56-39.11 98.06-39.11 49.08 0 87.65 22.82 111.7 65.89 17.45 31.29 20.91 62.47 21 63.75a15.07 15.07 0 01-13.65 16.4 15.26 15.26 0 01-16.79-13.29A154 154 0 00340.43 265c-18.64-32.89-47-49.61-84.51-49.61-32.4 0-57.75 9.75-75.19 29-25.14 27.75-30 70.5-26.55 98.78 6.93 48.22 25.46 86.58 58.18 120.86a14.7 14.7 0 01-.76 21.11 15.44 15.44 0 01-10.29 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M372.5 446.18c-32.5 0-60.13-9-82.24-26.89-44.42-35.79-49.4-94.08-49.62-96.54a15.27 15.27 0 0130.45-2.36c.11.86 4.55 48.54 38.79 76 20.26 16.18 47.34 22.6 80.71 18.85a15.2 15.2 0 0116.91 13.18 14.92 14.92 0 01-13.44 16.5 187 187 0 01-21.56 1.26zm25.68-397.39C385.5 40.54 340.54 16 256 16c-88.74 0-133.81 27.11-143.78 34a11.59 11.59 0 00-1.84 1.4.36.36 0 01-.22.1 14.87 14.87 0 00-5.09 11.15 15.06 15.06 0 0015.31 14.85 15.56 15.56 0 008.88-2.79c.43-.32 39.22-28.82 126.77-28.82S382.58 74.29 383 74.5a15.25 15.25 0 009.21 3 15.06 15.06 0 0015.29-14.89 14.9 14.9 0 00-9.32-13.82z"
                }
            }
        ]
    })(props);
}
function IoFishOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M240 152c-50.71 12.21-94.15 52.31-120.3 73.43a261.14 261.14 0 00-23.81-19.58C59.53 179.29 16 176 16 176s11.37 51.53 41.36 79.83C27.37 284.14 16 335.67 16 335.67s43.53-3.29 79.89-29.85a259.18 259.18 0 0023.61-19.41c26.1 21.14 69.74 61.34 120.5 73.59l-16 56c39.43-6.67 78.86-35.51 94.72-48.25C448 362 496 279 496 256c0-22-48-106-176.89-111.73C303.52 131.78 263.76 102.72 224 96z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "416",
                    "cy": "239.99",
                    "r": "16"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "20",
                    "strokeWidth": "32",
                    "d": "M378.37 356a199.22 199.22 0 010-200"
                }
            }
        ]
    })(props);
}
function IoFishSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M335.45 256a214.83 214.83 0 0129.08-108l7.62-13.26a280.69 280.69 0 00-48.64-7.15c-21.94-16.9-54.64-36.95-92.34-43.33L208 80l13.37 61.86c-41.67 14.14-78.43 42.86-102.76 62.62q-7.06-5.91-14.78-11.55c-39.71-29-82.6-31.8-84.4-31.9L0 160l2.67 19.31c.29 2 6.79 44.73 31.65 76.52C9.46 287.63 3 330.33 2.67 332.36L0 352l19.43-1.36c1.8-.1 44.69-2.89 84.4-31.9q7.58-5.53 14.56-11.37c24.37 19.83 61.14 48.6 102.86 62.74L208 432l23.17-4.22c37.49-6.34 70.08-26.4 92-43.32a284.27 284.27 0 0049.32-7.23l-7.91-13.18A214.92 214.92 0 01335.45 256z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M499.59 221.75c-5.85-9.88-16.54-24.9-34.19-40.28a209.82 209.82 0 00-62-37L392.23 164a183.22 183.22 0 00-.09 183.87l11.75 19.57a209.26 209.26 0 0061.42-36.49C497.05 303.47 512 269 512 256c0-12.31-8-26.74-12.41-34.25zM416 256a16 16 0 1116-16 16 16 0 01-16 16z"
                }
            }
        ]
    })(props);
}
function IoFish(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 256c0-16.54-14.27-46.76-45.61-74a207.06 207.06 0 00-60.28-36.12 3.15 3.15 0 00-3.93 1.56c-.15.29-.3.57-.47.86l-9.59 15.9a183.24 183.24 0 00.07 183.78l.23.39 8.74 16a4 4 0 004.94 1.82C479.63 337.42 512 281.49 512 256zm-93.92-.14a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M335.45 256a214.8 214.8 0 0129.08-108l.12-.21 4.62-7.67a4 4 0 00-2.59-6 284.29 284.29 0 00-39.26-5.39 7.94 7.94 0 01-4.29-1.6c-19.28-14.66-57.5-40.3-96.46-46.89a16 16 0 00-18 20.18l10.62 37.17a4 4 0 01-2.42 4.84c-36.85 13.69-68.59 38.75-91.74 57.85a8 8 0 01-10.06.06q-4.72-3.75-9.69-7.39c-39.64-28.95-86.21-32.76-88.17-32.9a16 16 0 00-16.83 19.4c.42 1.93 9.19 40.69 31.7 71.61a8.09 8.09 0 010 9.55C9.57 291.52.8 330.29.38 332.22a16 16 0 0016.83 19.4c2-.14 48.53-4 88.12-32.88q4.85-3.56 9.47-7.22a8 8 0 0110.06.07c23.25 19.19 55.05 44.28 92 58a4 4 0 012.42 4.83l-10.66 37.18a16 16 0 0018 20.18c17.16-2.9 51.88-12.86 96.05-46.83a8.15 8.15 0 014.36-1.65 287.36 287.36 0 0039.22-5.3 4 4 0 002.69-5.83l-4.51-8.29A214.81 214.81 0 01335.45 256z"
                }
            }
        ]
    })(props);
}
function IoFitnessOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352.92 80C288 80 256 144 256 144s-32-64-96.92-64c-52.76 0-94.54 44.14-95.08 96.81-1.1 109.33 86.73 187.08 183 252.42a16 16 0 0018 0c96.26-65.34 184.09-143.09 183-252.42-.54-52.67-42.32-96.81-95.08-96.81z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 256h112l48-96 48 160 48-96 32 64h128"
                }
            }
        ]
    })(props);
}
function IoFitnessSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 272h-37.34a261.41 261.41 0 01-18.25 32H480zM32 240v32h37.34a225.1 225.1 0 01-12.4-32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M304 259.78l-51.73 103.46-48-160L169.89 272H69.34c10 20.92 23.5 41.41 40.63 61.68 40.12 47.46 94.25 79.75 137 108.32l9 6 9-6c42.78-28.57 96.91-60.86 137-108.32A322.78 322.78 0 00424.41 304h-98.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M211.73 116.76l48 160L304 188.22 345.89 272h96.77A213.13 213.13 0 00464 176.65C463.37 114.54 413.54 64 352.92 64c-48.11 0-80.1 28-96.92 48.21C239.18 92 207.19 64 159.08 64 98.46 64 48.63 114.54 48 176.65A211.23 211.23 0 0056.94 240h93.17z"
                }
            }
        ]
    })(props);
}
function IoFitness(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M193.69 152.84a16 16 0 0129.64 2.56l36.4 121.36 30-59.92a16 16 0 0128.62 0L345.89 272h96.76A213.08 213.08 0 00464 176.65C463.37 114.54 413.54 64 352.92 64c-48.09 0-80 29.54-96.92 51-16.88-21.49-48.83-51-96.92-51C98.46 64 48.63 114.54 48 176.65A211.13 211.13 0 0056.93 240h93.18z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M321.69 295.16L304 259.78l-33.69 67.38A16 16 0 01256 336q-.67 0-1.38-.06a16 16 0 01-14-11.34l-36.4-121.36-30 59.92A16 16 0 01160 272H69.35q14 29.29 37.27 57.66c18.77 22.88 52.8 59.46 131.39 112.81a31.84 31.84 0 0036 0c78.59-53.35 112.62-89.93 131.39-112.81a316.79 316.79 0 0019-25.66H336a16 16 0 01-14.31-8.84zM464 272h-21.35a260.11 260.11 0 01-18.25 32H464a16 16 0 000-32zM48 240a16 16 0 000 32h21.35a225.22 225.22 0 01-12.42-32z"
                }
            }
        ]
    })(props);
}
function IoFlagOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M80 464V68.14a8 8 0 014-6.9C91.81 56.66 112.92 48 160 48c64 0 145 48 192 48a199.53 199.53 0 0077.23-15.77 2 2 0 012.77 1.85v219.36a4 4 0 01-2.39 3.65C421.37 308.7 392.33 320 352 320c-48 0-128-32-192-32s-80 16-80 16"
                }
            }
        ]
    })(props);
}
function IoFlagSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M102 480H64V57.37l4.69-4.68C72.14 49.23 92.78 32 160 32c37.21 0 78.83 14.71 115.55 27.68C305.12 70.13 333.05 80 352 80c42.83 0 72.72-14.25 73-14.4l23-11.14v259.43l-8.84 4.42C437.71 319 403.19 336 352 336c-24.14 0-54.38-7.14-86.39-14.71C229.63 312.79 192.43 304 160 304c-36.87 0-49.74 5.58-58 9.11z"
                }
            }
        ]
    })(props);
}
function IoFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 480a16 16 0 01-16-16V68.13a24 24 0 0111.9-20.72C88 40.38 112.38 32 160 32c37.21 0 78.83 14.71 115.55 27.68C305.12 70.13 333.05 80 352 80a183.84 183.84 0 0071-14.5 18 18 0 0125 16.58v219.36a20 20 0 01-12 18.31c-8.71 3.81-40.51 16.25-84 16.25-24.14 0-54.38-7.14-86.39-14.71C229.63 312.79 192.43 304 160 304c-36.87 0-55.74 5.58-64 9.11V464a16 16 0 01-16 16z"
                }
            }
        ]
    })(props);
}
function IoFlameOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M112 320c0-93 124-165 96-272 66 0 192 96 192 272a144 144 0 01-288 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 368c0 57.71-32 80-64 80s-64-22.29-64-80 40-86 32-128c42 0 96 70.29 96 128z"
                }
            }
        ]
    })(props);
}
function IoFlameSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M394.24 197.56a300.67 300.67 0 00-53.38-90C301.2 61.65 240 32 192 32c19 70-14.36 117.12-44.79 163.77C122 234.36 96 274.27 96 320c0 88.22 71.78 160 160 160s160-71.78 160-160c0-43.3-7.32-84.49-21.76-122.44zM288.33 418.69C278 429.69 265.05 432 256 432s-22-2.31-32.33-13.31S208 390.24 208 368c0-25.14 8.82-44.28 17.34-62.78 6.48-14.07 14.66-27.22 15.11-44.49 11.3 5.88 23.67 16.91 34.54 31.28 18.17 24 29 52.42 29 76 .01 22.23-5.41 39.76-15.66 50.68z"
                }
            }
        ]
    })(props);
}
function IoFlame(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M394.23 197.56a300.43 300.43 0 00-53.37-90C301.2 61.65 249.05 32 208 32a16 16 0 00-15.48 20c13.87 53-14.88 97.07-45.31 143.72C122 234.36 96 274.27 96 320c0 88.22 71.78 160 160 160s160-71.78 160-160c0-43.3-7.32-84.49-21.77-122.44zm-105.9 221.13C278 429.69 265.05 432 256 432s-22-2.31-32.33-13.31S208 390.24 208 368c0-25.14 8.82-44.28 17.34-62.78 4.95-10.74 10-21.67 13-33.37a8 8 0 0112.49-4.51A126.48 126.48 0 01275 292c18.17 24 29 52.42 29 76 0 22.24-5.42 39.77-15.67 50.69z"
                }
            }
        ]
    })(props);
}
function IoFlashOffOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 448a15.92 15.92 0 01-11.31-4.69l-352-352a16 16 0 0122.62-22.62l352 352A16 16 0 01432 448zM294.34 84.28l-22.08 120.84a16 16 0 006.17 15.71 16.49 16.49 0 009.93 3.17h94.12l-38.37 47.42a4 4 0 00.28 5.34l17.07 17.07a4 4 0 005.94-.31l60.8-75.16a16.37 16.37 0 003.3-14.36 16 16 0 00-15.5-12H307.19L335.4 37.63c.05-.3.1-.59.13-.89A18.45 18.45 0 00302.73 23l-92.58 114.46a4 4 0 00.28 5.35l17.07 17.06a4 4 0 005.94-.31zm-76.56 343.29l22-120.71a16 16 0 00-6.19-15.7 16.54 16.54 0 00-9.92-3.16h-94.1l38.36-47.42a4 4 0 00-.28-5.34l-17.07-17.07a4 4 0 00-5.93.31L83.8 293.64A16.37 16.37 0 0080.5 308 16 16 0 0096 320h108.83l-28.09 154.36v.11a18.37 18.37 0 0032.5 14.53l92.61-114.46a4 4 0 00-.28-5.35l-17.07-17.06a4 4 0 00-5.94.31z"
                }
            }
        ]
    })(props);
}
function IoFlashOffSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M63.998 86.004l21.998-21.998L448 426.01l-21.998 21.998zM80 304h144l-32 192 108.18-129.82-148.36-148.36L80 304zm352-96H288l32-192-108.18 129.82 148.36 148.36L432 208z"
                }
            }
        ]
    })(props);
}
function IoFlashOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 448a15.92 15.92 0 01-11.31-4.69l-352-352a16 16 0 0122.62-22.62l352 352A16 16 0 01432 448zm-.5-244a16 16 0 00-15.5-12H307.19L335.4 37.63c.05-.3.1-.59.13-.89A18.45 18.45 0 00302.73 23l-92.58 114.46a4 4 0 00.29 5.35l151 151a4 4 0 005.94-.31l60.8-75.16A16.37 16.37 0 00431.5 204zM301.57 369.19l-151-151a4 4 0 00-5.93.31L83.8 293.64A16.37 16.37 0 0080.5 308 16 16 0 0096 320h108.83l-28.09 154.36v.11a18.37 18.37 0 0032.5 14.53l92.61-114.46a4 4 0 00-.28-5.35z"
                }
            }
        ]
    })(props);
}
function IoFlashOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M315.27 33L96 304h128l-31.51 173.23a2.36 2.36 0 002.33 2.77h0a2.36 2.36 0 001.89-.95L416 208H288l31.66-173.25a2.45 2.45 0 00-2.44-2.75h0a2.42 2.42 0 00-1.95 1z"
                }
            }
        ]
    })(props);
}
function IoFlashSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 208H288l32-192L80 304h144l-32 192z"
                }
            }
        ]
    })(props);
}
function IoFlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M194.82 496a18.36 18.36 0 01-18.1-21.53v-.11L204.83 320H96a16 16 0 01-12.44-26.06L302.73 23a18.45 18.45 0 0132.8 13.71c0 .3-.08.59-.13.89L307.19 192H416a16 16 0 0112.44 26.06L209.24 489a18.45 18.45 0 01-14.42 7z"
                }
            }
        ]
    })(props);
}
function IoFlashlightOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M456.64 162.86L349.12 55.36c-13.15-13.14-28.68-7.17-41.82 6l-11.95 12c-26.13 26.13-27.62 58.38-29.42 83.31-.89 12.24-9.78 27.55-18.51 36.28L58.58 381.67c-16.35 16.33-12.69 39.42 3.73 55.84l12.17 12.17c16.36 16.35 39.43 20.16 55.86 3.74l188.83-188.8c8.74-8.74 24-17.55 36.29-18.52 24.87-1.86 58.62-4.85 83.26-29.49l11.94-11.94c13.15-13.14 19.12-28.67 5.98-41.81z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "224.68",
                    "cy": "287.28",
                    "r": "20"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M289 81l142 142"
                }
            }
        ]
    })(props);
}
function IoFlashlightSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M330 16l-42.68 42.7L453.3 224.68 496 182 330 16z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "224.68",
                    "cy": "287.3",
                    "fill": "none",
                    "rx": "20.03",
                    "ry": "19.96"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M429.21 243.85L268 82.59 249.65 168 16 402l94 94 234.23-233.8zm-189 56.07a20 20 0 110-25.25 20 20 0 01-.02 25.25z"
                }
            }
        ]
    })(props);
}
function IoFlashlight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M462 216c9.35-9.35 15.14-19.09 17.19-28.95 2.7-12.95-1.29-25.55-11.22-35.48L360.43 44.05C346.29 29.92 322 24.07 296 50l-2 2a8 8 0 000 11.32L448.64 218a8 8 0 0011.36 0zm-211.86-62.92l-.16 2.34c-.53 7.18-6.88 19.15-13.88 26.14L47.27 370.36c-11.12 11.11-16.46 25.57-15.05 40.7C33.49 424.58 40.16 438 51 448.83L63.17 461c12.61 12.6 27.78 19 42.49 19a50.4 50.4 0 0036-15.24l188.84-188.8c7.07-7.07 18.84-13.3 26.17-13.87 17.48-1.32 43.57-3.28 67.79-15.65a4 4 0 001-6.37L271.69 86.31a4 4 0 00-6.39 1c-12.12 22.99-13.82 46.91-15.16 65.77zm-9.95 146.83a20 20 0 110-25.25 20 20 0 010 25.25z"
                }
            }
        ]
    })(props);
}
function IoFlaskOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M176 48h160M118 304h276M208 48v93.48a64.09 64.09 0 01-9.88 34.18L73.21 373.49C48.4 412.78 76.63 464 123.08 464h265.84c46.45 0 74.68-51.22 49.87-90.51L313.87 175.66a64.09 64.09 0 01-9.87-34.18V48"
                }
            }
        ]
    })(props);
}
function IoFlaskSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M469.11 382.76L325 153.92V74h32V32H155v42h32v79.92L42.89 382.76c-13 20.64-14.78 43.73-3 65.1S71.59 480 96 480h320c24.41 0 44.32-10.76 56.1-32.14s10.04-44.46-2.99-65.1zM224.39 173.39a29.76 29.76 0 004.62-16V74h54v84.59a25.85 25.85 0 004 13.82L356.82 283H155.18z"
                }
            }
        ]
    })(props);
}
function IoFlask(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M452.32 365L327.4 167.12a48.07 48.07 0 01-7.4-25.64V64h15.56c8.61 0 16-6.62 16.43-15.23A16 16 0 00336 32H176.45c-8.61 0-16 6.62-16.43 15.23A16 16 0 00176 64h16v77.48a47.92 47.92 0 01-7.41 25.63L59.68 365a74 74 0 00-2.5 75.84C70.44 465.19 96.36 480 124.13 480h263.74c27.77 0 53.69-14.81 66.95-39.21a74 74 0 00-2.5-75.79zM211.66 184.2A79.94 79.94 0 00224 141.48V68a4 4 0 014-4h56a4 4 0 014 4v73.48a79.94 79.94 0 0012.35 42.72l57.8 91.53a8 8 0 01-6.78 12.27H160.63a8 8 0 01-6.77-12.27z"
                }
            }
        ]
    })(props);
}
function IoFlowerOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M215.08 156.92c-4.89-24-10.77-56.27-10.77-73.23A51.36 51.36 0 01256 32h0c28.55 0 51.69 23.69 51.69 51.69 0 16.5-5.85 48.95-10.77 73.23m-81.84 198.16c-4.91 24.06-10.77 56.16-10.77 73.23A51.36 51.36 0 00256 480h0c28.55 0 51.69-23.69 51.69-51.69 0-16.54-5.85-48.93-10.77-73.23m58.16-140c24.06-4.91 56.16-10.77 73.23-10.77A51.36 51.36 0 01480 256h0c0 28.55-23.69 51.69-51.69 51.69-16.5 0-48.95-5.85-73.23-10.77m-198.16-81.85c-24-4.89-56.25-10.76-73.23-10.76A51.36 51.36 0 0032 256h0c0 28.55 23.69 51.69 51.69 51.69 16.5 0 48.95-5.85 73.23-10.77"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M296.92 156.92c13.55-20.48 32.3-47.25 44.37-59.31a51.35 51.35 0 0173.1 0h0c20.19 20.19 19.8 53.3 0 73.1-11.66 11.67-38.67 30.67-59.31 44.37m-198.16 81.84c-20.48 13.55-47.25 32.3-59.31 44.37a51.35 51.35 0 000 73.1h0c20.19 20.19 53.3 19.8 73.1 0 11.67-11.66 30.67-38.67 44.37-59.31m140-58.16c20.48 13.55 47.25 32.3 59.31 44.37a51.35 51.35 0 010 73.1h0c-20.19 20.19-53.3 19.8-73.1 0-11.69-11.69-30.66-38.65-44.37-59.31m-81.84-198.16c-13.53-20.43-32.38-47.32-44.37-59.31a51.35 51.35 0 00-73.1 0h0c-20.19 20.19-19.8 53.3 0 73.1 11.61 11.61 38.7 30.68 59.31 44.37"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "64",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function IoFlowerSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "43"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M475.93 303.91a67.49 67.49 0 00-47.62-115.6c-2.88 0-6.2.14-9.93.43 2.75-2.36 5.23-4.62 7.33-6.71A67.83 67.83 0 00378 66.33h-.25a67.27 67.27 0 00-47.82 20c-2.11 2.11-4.37 4.59-6.72 7.33.29-3.75.44-7.07.44-9.93a67.69 67.69 0 10-135.38 0c0 2.87.15 6.19.44 9.93-2.36-2.74-4.62-5.22-6.72-7.33a67.27 67.27 0 00-47.82-20H134A67.9 67.9 0 0086.29 182c2.1 2.09 4.58 4.35 7.34 6.72-3.74-.29-7.06-.44-9.94-.44a67.69 67.69 0 000 135.38c2.86 0 6.18-.15 9.93-.44-2.74 2.35-5.22 4.61-7.33 6.72a67.55 67.55 0 0047.82 115.42h.25A67.32 67.32 0 00182 425.71c2.09-2.1 4.35-4.58 6.71-7.33-.28 3.73-.43 7.05-.43 9.93a67.69 67.69 0 00135.38 0c0-2.87-.15-6.19-.44-9.94 2.36 2.75 4.62 5.24 6.72 7.34a67.32 67.32 0 0047.67 19.68h.25A67.5 67.5 0 00425.71 330c-2.11-2.11-4.59-4.37-7.33-6.72 3.75.29 7.07.44 9.93.44a67.27 67.27 0 0047.62-19.81zM256 341a85 85 0 1185-85 85.1 85.1 0 01-85 85z"
                }
            }
        ]
    })(props);
}
function IoFlower(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M475.93 303.91a67.49 67.49 0 00-44.34-115.53 5.2 5.2 0 01-4.58-3.21 5.21 5.21 0 011-5.51A67.83 67.83 0 00378 66.33h-.25A67.13 67.13 0 00332.35 84a5.21 5.21 0 01-5.52 1 5.23 5.23 0 01-3.22-4.58 67.68 67.68 0 00-135.23 0 5.2 5.2 0 01-3.21 4.58 5.21 5.21 0 01-5.52-1 67.11 67.11 0 00-45.44-17.69H134a67.91 67.91 0 00-50 113.34 5.21 5.21 0 011 5.51 5.2 5.2 0 01-4.58 3.21 67.71 67.71 0 000 135.23 5.23 5.23 0 014.58 3.23 5.22 5.22 0 01-1 5.52 67.54 67.54 0 0050.08 113h.25A67.38 67.38 0 00179.65 428a5.21 5.21 0 015.51-1 5.2 5.2 0 013.21 4.58 67.71 67.71 0 00135.23 0 5.23 5.23 0 013.22-4.58 5.21 5.21 0 015.51 1 67.38 67.38 0 0045.29 17.42h.25a67.48 67.48 0 0050.08-113 5.22 5.22 0 01-1-5.52 5.23 5.23 0 014.58-3.22 67.31 67.31 0 0044.4-19.77zM256 336a80 80 0 1180-80 80.09 80.09 0 01-80 80z"
                }
            }
        ]
    })(props);
}
function IoFolderOpenOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M64 192v-72a40 40 0 0140-40h75.89a40 40 0 0122.19 6.72l27.84 18.56a40 40 0 0022.19 6.72H408a40 40 0 0140 40v40"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M479.9 226.55L463.68 392a40 40 0 01-39.93 40H88.25a40 40 0 01-39.93-40L32.1 226.55A32 32 0 0164 192h384.1a32 32 0 0131.8 34.55z"
                }
            }
        ]
    })(props);
}
function IoFolderOpenSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.08 189.4l28.58 233.87A28 28 0 0072.52 448h367a28 28 0 0027.86-24.73l28.54-233.87A12 12 0 00484 176H28a12 12 0 00-11.92 13.4zM464 124a28 28 0 00-28-28H244.84l-48-32H76a28 28 0 00-28 28v52h416z"
                }
            }
        ]
    })(props);
}
function IoFolderOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408 96H252.11a23.89 23.89 0 01-13.31-4L211 73.41A55.77 55.77 0 00179.89 64H104a56.06 56.06 0 00-56 56v24h416c0-30.88-25.12-48-56-48zm15.75 352H88.25a56 56 0 01-55.93-55.15L16.18 228.11v-.28A48 48 0 0164 176h384.1a48 48 0 0147.8 51.83v.28l-16.22 164.74A56 56 0 01423.75 448zm56.15-221.45z"
                }
            }
        ]
    })(props);
}
function IoFolderOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M440 432H72a40 40 0 01-40-40V120a40 40 0 0140-40h75.89a40 40 0 0122.19 6.72l27.84 18.56a40 40 0 0022.19 6.72H440a40 40 0 0140 40v240a40 40 0 01-40 40zM32 192h448"
                }
            }
        ]
    })(props);
}
function IoFolderSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 420a28 28 0 0028 28h424a28 28 0 0028-28V208H16zm480-296a28 28 0 00-28-28H212.84l-48-32H44a28 28 0 00-28 28v84h480z"
                }
            }
        ]
    })(props);
}
function IoFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 152a56 56 0 00-56-56H220.11a23.89 23.89 0 01-13.31-4L179 73.41A55.77 55.77 0 00147.89 64H72a56 56 0 00-56 56v48a8 8 0 008 8h464a8 8 0 008-8zM16 392a56 56 0 0056 56h368a56 56 0 0056-56V216a8 8 0 00-8-8H24a8 8 0 00-8 8z"
                }
            }
        ]
    })(props);
}
function IoFootballOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "192",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 175.15l-76.09 63.83L200 320h112l20.09-81.02L256 175.15zm76.09 63.83l52.87-22.4 25.78-73.26M447 269.97l-62.04-53.39m-205.05 22.4l-52.87-22.4-25.78-73.26M65 269.97l62.04-53.39M256 175.15v-57.57l64-42.64m-128-.01l64 42.65M312 320l28 48-28 71m98.74-71H342m-142-48l-28 48 28.37 71.5M101.63 368H172"
                }
            }
        ]
    })(props);
}
function IoFootballSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm140.64 296.08h-46.77l-16.89-29 15-60.44L377.79 242l42.65 36.71a164.87 164.87 0 01-23.8 65.37zM134.21 242L164 254.67l15 60.44-16.89 29h-46.75a164.87 164.87 0 01-23.8-65.34zm249.07-92.47l-18.41 52.33-31.12 13.18L277 167.46v-35l43.86-29.22a166.87 166.87 0 0162.42 46.32zM191.14 103.2L235 132.42v35l-56.75 47.61-31.12-13.18-18.41-52.33a166.87 166.87 0 0162.42-46.32zm26.44 314.3l-20.1-50.66 16-27.51h85l16.06 27.53-20 50.6a166.23 166.23 0 01-77 0z"
                }
            }
        ]
    })(props);
}
function IoFootball(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm143 304h-45.22a8 8 0 01-6.91-4l-16.14-27.68a8 8 0 01-.86-6l14.86-59.92a8 8 0 014.65-5.45l28.1-11.9a8 8 0 018.34 1.3l41.63 35.82a8 8 0 012.69 7.26 174.75 174.75 0 01-24.28 66.68A8 8 0 01399 352zM134.52 237.13l28.1 11.9a8 8 0 014.65 5.45l14.86 59.92a8 8 0 01-.86 6L165.13 348a8 8 0 01-6.91 4H113a8 8 0 01-6.82-3.81 174.75 174.75 0 01-24.28-66.68 8 8 0 012.69-7.26l41.63-35.82a8 8 0 018.3-1.3zm256.94-87.24l-18.07 51.38A8 8 0 01369 206l-29.58 12.53a8 8 0 01-8.26-1.24L274.9 170.1a8 8 0 01-2.9-6.1v-33.58a8 8 0 013.56-6.65l42.83-28.54a8 8 0 017.66-.67A176.92 176.92 0 01390 142a8 8 0 011.46 7.89zM193.6 95.23l42.84 28.54a8 8 0 013.56 6.65V164a8 8 0 01-2.86 6.13l-56.26 47.19a8 8 0 01-8.26 1.24L143 206a8 8 0 01-4.43-4.72L120.5 149.9a8 8 0 011.5-7.9 176.92 176.92 0 0164-47.48 8 8 0 017.6.71zm17.31 327.46L191.18 373a8 8 0 01.52-7l15.17-26a8 8 0 016.91-4h84.44a8 8 0 016.91 4l15.18 26a8 8 0 01.53 7l-19.59 49.67a8 8 0 01-5.69 4.87 176.58 176.58 0 01-79 0 8 8 0 01-5.65-4.85z"
                }
            }
        ]
    })(props);
}
function IoFootstepsOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M200 246.84c8.81 58.62-7.33 90.67-52.91 97.41-50.65 7.49-71.52-26.44-80.33-85.06-11.85-78.88 16-127.94 55.71-131.1 36.14-2.87 68.71 60.14 77.53 118.75zm23.65 162.69c3.13 33.28-14.86 64.34-42 69.66-27.4 5.36-58.71-16.37-65.09-49.19s17.75-34.56 47.32-40.21 55.99-20.4 59.77 19.74zM312 150.83c-8.81 58.62 7.33 90.67 52.9 97.41 50.66 7.49 71.52-26.44 80.33-85.06 11.86-78.89-16-128.22-55.7-131.1-36.4-2.64-68.71 60.13-77.53 118.75zm-23.65 162.7c-3.13 33.27 14.86 64.34 42 69.66 27.4 5.36 58.71-16.37 65.09-49.19s-17.75-34.56-47.32-40.22-55.99-20.4-59.77 19.75z"
                }
            }
        ]
    })(props);
}
function IoFootstepsSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M130.54 358.31c-12.83 1.88-33.95 5.38-48-10.56S56.34 293.32 51 258.92c-7.88-50.7-.06-93.43 22-120.31 13-15.83 30.06-25 49.34-26.46 16.51-1.27 41.18 5.19 65 43.19 14.92 23.81 26.27 55.44 31.14 86.77 5.88 37.82 11.61 78.18-8.44 92.65-11.31 8.17-19.43 11-38.62 15.57-15.78 3.75-28.04 6.09-40.88 7.98zm-22.82 32.53l108.89-22.46c9.2-1.9 16.58 3.16 20 18.32 11.22 49.76-4.86 109.3-55.22 109.3-47.69 0-79.47-54.36-84.66-83.58-2.37-13.25 1.01-19.53 10.99-21.58zm232.87-136.5c-19.19-4.55-27.31-7.4-38.62-15.57-20.05-14.47-14.32-54.83-8.44-92.65 4.87-31.33 16.22-63 31.14-86.77 23.8-38 48.47-44.46 65-43.19C408.93 17.63 426 26.78 439 42.61c22.08 26.88 29.9 69.61 22 120.31-5.35 34.4-17.46 72.76-31.59 88.83s-35.13 12.44-48 10.56-25.05-4.23-40.82-7.97zm63.69 40.5l-108.89-22.46c-9.2-1.9-16.58 3.16-20 18.32-11.21 49.76 4.87 109.3 55.23 109.3 47.69 0 79.47-54.36 84.66-83.58 2.36-13.25-1.02-19.53-11-21.58z"
                }
            }
        ]
    })(props);
}
function IoFootsteps(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M133.83 361.27c-22.61 0-41-8.17-54.79-24.39s-22.84-40.29-28.11-75.31c-7.76-51.61-.06-95.11 21.68-122.48 12.8-16.12 29.6-25.44 48.58-26.94 16.25-1.3 40.54 5.29 64 44 14.69 24.24 25.86 56.44 30.65 88.34 5.79 38.51 1.48 66.86-13.18 86.65-11.64 15.72-29.54 25.46-53.21 29a106.46 106.46 0 01-15.62 1.13zM173 496c-13.21 0-26.6-4.23-38.66-12.36a79.79 79.79 0 01-33.52-50.6c-2.85-14.66-1.14-26.31 5.22-35.64 10.33-15.15 28.87-18.56 48.49-22.18 2.07-.38 4.17-.76 6.3-1.17 4.52-.86 9.14-2 13.62-3.11 16.78-4.14 34.14-8.43 48.47 1.75 9.59 6.8 15 18.36 16.62 35.32 1.84 19.57-2.36 39.1-11.83 55-10.19 17.11-25.47 28.42-43 31.86A61 61 0 01173 496zm205.17-230.73a106.69 106.69 0 01-15.6-1.2c-23.66-3.5-41.56-13.25-53.2-29-14.66-19.79-19-48.13-13.18-86.65 4.79-31.93 15.93-64.1 30.55-88.25 23.34-38.57 47.66-45.26 64-44.08 18.92 1.38 35.69 10.57 48.51 26.6 21.89 27.37 29.65 71 21.86 122.84-5.27 35-14.2 58.95-28.11 75.31s-32.22 24.43-54.83 24.43zM339 400a61 61 0 01-11.68-1.13c-17.56-3.44-32.84-14.75-43-31.86-9.47-15.9-13.67-35.43-11.83-55 1.6-17 7-28.52 16.62-35.33 14.33-10.17 31.69-5.89 48.47-1.74 4.48 1.1 9.1 2.24 13.62 3.11l6.29 1.17c19.63 3.61 38.17 7 48.5 22.17 6.36 9.33 8.07 21 5.22 35.64a79.78 79.78 0 01-33.52 50.61C365.56 395.78 352.17 400 339 400z"
                }
            }
        ]
    })(props);
}
function IoFunnelOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M35.4 87.12l168.65 196.44A16.07 16.07 0 01208 294v119.32a7.93 7.93 0 005.39 7.59l80.15 26.67A7.94 7.94 0 00304 440V294a16.07 16.07 0 014-10.44L476.6 87.12A14 14 0 00466 64H46.05A14 14 0 0035.4 87.12z"
                }
            }
        ]
    })(props);
}
function IoFunnelSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 48l192 240v128l128 48V288L512 48H0z"
                }
            }
        ]
    })(props);
}
function IoFunnel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 464a23.88 23.88 0 01-7.55-1.23L208.3 436.1a23.92 23.92 0 01-16.3-22.78V294.11a.44.44 0 00-.09-.13L23.26 97.54A30 30 0 0146.05 48H466a30 30 0 0122.79 49.54L320.09 294a.77.77 0 00-.09.13V440a23.93 23.93 0 01-24 24z"
                }
            }
        ]
    })(props);
}
function IoGameControllerOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M467.51 248.83c-18.4-83.18-45.69-136.24-89.43-149.17A91.5 91.5 0 00352 96c-26.89 0-48.11 16-96 16s-69.15-16-96-16a99.09 99.09 0 00-27.2 3.66C89 112.59 61.94 165.7 43.33 248.83c-19 84.91-15.56 152 21.58 164.88 26 9 49.25-9.61 71.27-37 25-31.2 55.79-40.8 119.82-40.8s93.62 9.6 118.66 40.8c22 27.41 46.11 45.79 71.42 37.16 41.02-14.01 40.44-79.13 21.43-165.04z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "292",
                    "cy": "224",
                    "r": "20"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M336 288a20 20 0 1120-19.95A20 20 0 01336 288z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "336",
                    "cy": "180",
                    "r": "20"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "380",
                    "cy": "224",
                    "r": "20"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 176v96m48-48h-96"
                }
            }
        ]
    })(props);
}
function IoGameControllerSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M478.07 356.88L439 151c-8.86-40.35-23-71-88-71H145c-66 0-79.14 30.65-88 71L18 356.88c-7 34.12 4.43 61.25 33.37 71.81S103 423 119.18 391.3l15.42-30.52a16 16 0 0114.28-8.78h198.28a16 16 0 0114.28 8.78l15.42 30.52c16.14 31.7 38.88 48 67.81 37.39S485 391 478.07 356.88zM224 240h-48v48h-32v-48H96v-32h48v-48h32v48h48zm68 4a20 20 0 1120-20 20 20 0 01-20 20zm44 44a20 20 0 1120-20 20 20 0 01-20 20zm0-88a20 20 0 1120-20 20 20 0 01-20 20zm44 44a20 20 0 1120-20 20 20 0 01-20 20z"
                }
            }
        ]
    })(props);
}
function IoGameController(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.13 245.38C461.92 149.49 430 98.31 382.65 84.33A107.13 107.13 0 00352 80c-13.71 0-25.65 3.34-38.28 6.88C298.5 91.15 281.21 96 256 96s-42.51-4.84-57.76-9.11C185.6 83.34 173.67 80 160 80a115.74 115.74 0 00-31.73 4.32c-47.1 13.92-79 65.08-100.52 161C4.61 348.54 16 413.71 59.69 428.83a56.62 56.62 0 0018.64 3.22c29.93 0 53.93-24.93 70.33-45.34 18.53-23.1 40.22-34.82 107.34-34.82 59.95 0 84.76 8.13 106.19 34.82 13.47 16.78 26.2 28.52 38.9 35.91 16.89 9.82 33.77 12 50.16 6.37 25.82-8.81 40.62-32.1 44-69.24 2.57-28.48-1.39-65.89-12.12-114.37zM208 240h-32v32a16 16 0 01-32 0v-32h-32a16 16 0 010-32h32v-32a16 16 0 0132 0v32h32a16 16 0 010 32zm84 4a20 20 0 1120-20 20 20 0 01-20 20zm44 44a20 20 0 1120-19.95A20 20 0 01336 288zm0-88a20 20 0 1120-20 20 20 0 01-20 20zm44 44a20 20 0 1120-20 20 20 0 01-20 20z"
                }
            }
        ]
    })(props);
}
function IoGiftOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 104v56h56a56 56 0 10-56-56zm0 0v56h-56a56 56 0 1156-56z"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "384",
                    "height": "112",
                    "x": "64",
                    "y": "160",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "32",
                    "ry": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M416 272v144a48 48 0 01-48 48H144a48 48 0 01-48-48V272m160-112v304"
                }
            }
        ]
    })(props);
}
function IoGiftSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M346 110a34 34 0 00-68 0v34h34a34 34 0 0034-34zm-112 0a34 34 0 10-34 34h34z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M234 144h44v112h164a22 22 0 0022-22v-68a22 22 0 00-22-22h-59.82A77.95 77.95 0 00256 55.79 78 78 0 00129.81 144H70a22 22 0 00-22 22v68a22 22 0 0022 22h164zm44-34a34 34 0 1134 34h-34zm-112 0a34 34 0 1168 0v34h-34a34 34 0 01-34-34zm112 370h132a22 22 0 0022-22V288H278zM80 458a22 22 0 0022 22h132V288H80z"
                }
            }
        ]
    })(props);
}
function IoGift(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M200 144h40v-40a40 40 0 10-40 40zm152-40a40 40 0 00-80 0v40h40a40 40 0 0040-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M80 416a64 64 0 0064 64h92a4 4 0 004-4V292a4 4 0 00-4-4H88a8 8 0 00-8 8zm160-164V144h32v108a4 4 0 004 4h140a47.93 47.93 0 0016-2.75A48.09 48.09 0 00464 208v-16a48 48 0 00-48-48h-40.54a2 2 0 01-1.7-3A72 72 0 00256 58.82 72 72 0 00138.24 141a2 2 0 01-1.7 3H96a48 48 0 00-48 48v16a48.09 48.09 0 0032 45.25A47.93 47.93 0 0096 256h140a4 4 0 004-4zm32-148a40 40 0 1140 40h-40zm-74.86-39.9A40 40 0 01240 104v40h-40a40 40 0 01-2.86-79.89zM276 480h92a64 64 0 0064-64V296a8 8 0 00-8-8H276a4 4 0 00-4 4v184a4 4 0 004 4z"
                }
            }
        ]
    })(props);
}
function IoGitBranchOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "160",
                    "cy": "96",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "160",
                    "cy": "416",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 368V144"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "352",
                    "cy": "160",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 208c0 128-192 48-192 160"
                }
            }
        ]
    })(props);
}
function IoGitBranchSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 96a64 64 0 00-58.86 89.11l-101.14 88V151.39a64 64 0 10-64 0v209.22a64 64 0 1064 0V358l154.25-134.27c1.9.17 3.81.27 5.75.27a64 64 0 000-128zM160 64a32 32 0 11-32 32 32 32 0 0132-32zm0 384a32 32 0 1132-32 32 32 0 01-32 32zm192-256a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function IoGitBranch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 160a64 64 0 10-96.27 55.24c-2.29 29.08-20.08 37-75 48.42-17.76 3.68-35.93 7.45-52.71 13.93v-126.2a64 64 0 10-64 0v209.22a64 64 0 1064.42.24c2.39-18 16-24.33 65.26-34.52 27.43-5.67 55.78-11.54 79.78-26.95 29-18.58 44.53-46.78 46.36-83.89A64 64 0 00416 160zM160 64a32 32 0 11-32 32 32 32 0 0132-32zm0 384a32 32 0 1132-32 32 32 0 01-32 32zm192-256a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function IoGitCommitOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "96",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 256H48m416 0H352"
                }
            }
        ]
    })(props);
}
function IoGitCommitSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 224H380a128 128 0 00-247.9 0H32v64h100.05A128 128 0 00380 288h100zm-224 96a64 64 0 1164-64 64.07 64.07 0 01-64 64z"
                }
            }
        ]
    })(props);
}
function IoGitCommit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 224h-68a128 128 0 00-247.9 0H64a32 32 0 000 64h68.05A128 128 0 00380 288h68a32 32 0 000-64zm-192 96a64 64 0 1164-64 64.07 64.07 0 01-64 64z"
                }
            }
        ]
    })(props);
}
function IoGitCompareOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M304 160l-64-64 64-64m-97 320l64 64-64 64"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "112",
                    "cy": "96",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "400",
                    "cy": "416",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 96h84a60 60 0 0160 60v212m-145 48h-84a60 60 0 01-60-60V144"
                }
            }
        ]
    })(props);
}
function IoGitCompareSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M209 384h-37a28 28 0 01-28-28V152a64 64 0 10-64-1.16V356a92.1 92.1 0 0092 92h37v55.21L294.39 416 209 328.79zM113 64a32 32 0 11-32 32 32 32 0 0132-32zm319 296.61V156a92.1 92.1 0 00-92-92h-35V9.93L217.14 96 305 182.07V128h35a28 28 0 0128 28v204.61a64 64 0 1064 0zM400 448a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function IoGitCompare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M218.31 340.69A16 16 0 00191 352v32h-20a28 28 0 01-28-28V152a64 64 0 10-64-1.16V356a92.1 92.1 0 0092 92h20v32a16 16 0 0027.31 11.31l64-64a16 16 0 000-22.62zM112 64a32 32 0 11-32 32 32 32 0 0132-32zm320 296.61V156a92.1 92.1 0 00-92-92h-20V32a16 16 0 00-27.31-11.31l-64 64a16 16 0 000 22.62l64 64A16 16 0 00320 160v-32h20a28 28 0 0128 28v204.61a64 64 0 1064 0zM400 448a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function IoGitMergeOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "129",
                    "cy": "96",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "129",
                    "cy": "416",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M129 144v224"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "385",
                    "cy": "288",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M129 144c0 96 112 144 208 144"
                }
            }
        ]
    })(props);
}
function IoGitMergeSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 224a63.66 63.66 0 00-37.95 12.5L160 153.36v-2a64 64 0 10-64 0v209.25a64 64 0 1064 0V223.46l160.41 71.69A64 64 0 10384 224zM128 64a32 32 0 11-32 32 32 32 0 0132-32zm0 384a32 32 0 1132-32 32 32 0 01-32 32zm256-128a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function IoGitMerge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M385 224a64 64 0 00-55.33 31.89c-42.23-1.21-85.19-12.72-116.21-31.33-32.2-19.32-49.71-44-52.15-73.35a64 64 0 10-64.31.18v209.22a64 64 0 1064 0v-94.46c44.76 34 107.28 52.38 168.56 53.76A64 64 0 10385 224zM129 64a32 32 0 11-32 32 32 32 0 0132-32zm0 384a32 32 0 1132-32 32 32 0 01-32 32zm256-128a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function IoGitNetworkOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "128",
                    "cy": "96",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "416",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 256v112"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "384",
                    "cy": "96",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M128 144c0 74.67 68.92 112 128 112m128-112c0 74.67-68.92 112-128 112"
                }
            }
        ]
    })(props);
}
function IoGitNetworkSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32a64 64 0 00-57.67 91.73l-70.83 80.82-70.19-80.1A64 64 0 10128 160c1.1 0 2.2 0 3.29-.08L224 265.7v94.91a64 64 0 1064 0v-96.05l91.78-104.71c1.39.09 2.8.15 4.22.15a64 64 0 000-128zM96 96a32 32 0 1132 32 32 32 0 01-32-32zm160 352a32 32 0 1132-32 32 32 0 01-32 32zm128-320a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function IoGitNetwork(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96a64 64 0 10-96.31 55.21c-1.79 20.87-11.47 38.1-28.87 51.29C305.07 216 280.09 224 256 224s-49.07-8-66.82-21.5c-17.4-13.19-27.08-30.42-28.87-51.29a64 64 0 10-64.11.29c2.08 40.87 21.17 76.87 54.31 102C171.3 269.26 197 280.19 224 285.09v75.52a64 64 0 1064 0v-75.52c27-4.9 52.7-15.83 73.49-31.59 33.14-25.13 52.23-61.13 54.31-102A64 64 0 00448 96zM128 64a32 32 0 11-32 32 32 32 0 0132-32zm128 384a32 32 0 1132-32 32 32 0 01-32 32zm128-320a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function IoGitPullRequestOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "128",
                    "cy": "416",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M128 144v224m160-208l-64-64 64-64"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "128",
                    "cy": "96",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "384",
                    "cy": "416",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M240 96h84a60 60 0 0160 60v212"
                }
            }
        ]
    })(props);
}
function IoGitPullRequestSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 96a64 64 0 10-97 54.81v209.8a64 64 0 1064 0V152a64.06 64.06 0 0033-56zm-64-32a32 32 0 11-32 32 32 32 0 0132-32zm-1 384a32 32 0 1132-32 32 32 0 01-32 32zm289-87.39V156a92.1 92.1 0 00-92-92h-35V9.93L201.14 96 289 182.07V128h35a28 28 0 0128 28v204.61a64 64 0 1064 0zM384 448a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function IoGitPullRequest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 96a64 64 0 10-96 55.39v209.22a64 64 0 1064 0V151.39A64 64 0 00192 96zm-64-32a32 32 0 11-32 32 32 32 0 0132-32zm0 384a32 32 0 1132-32 32 32 0 01-32 32zm288-87.39V156a92.1 92.1 0 00-92-92h-20V32a16 16 0 00-27.31-11.31l-64 64a16 16 0 000 22.62l64 64A16 16 0 00304 160v-32h20a28 28 0 0128 28v204.61a64 64 0 1064 0zM384 448a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function IoGlassesOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M224 232a32 32 0 0164 0m160-32h16m-400 0H48m16 0c0 96 16 128 80 128s80-32 80-128c0 0-16-16-80-16s-80 16-80 16zm384 0c0 96-16 128-80 128s-80-32-80-128c0 0 16-16 80-16s80 16 80 16z"
                }
            }
        ]
    })(props);
}
function IoGlassesSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 176H16v64h21.24l12.44 112h171.87L240 241.32V240a16 16 0 0132 0v1.32L290.45 352h171.87l12.44-112H496z"
                }
            }
        ]
    })(props);
}
function IoGlasses(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 184h-10.9a78.72 78.72 0 00-16-7.18C419.5 171 396.26 168 368 168s-51.5 3-69.06 8.82c-14.06 4.69-20.25 9.86-22.25 11.87a47.94 47.94 0 00-41.36 0c-2-2-8.19-7.18-22.25-11.87C195.5 171 172.26 168 144 168s-51.5 3-69.06 8.82a78.72 78.72 0 00-16 7.18H48a16 16 0 000 32h.17c1 45.46 6.44 72.78 18.11 92.23a66.78 66.78 0 0031.92 28c12.23 5.24 27.22 7.79 45.8 7.79 24.15 0 58.48-3.71 77.72-35.77 9.68-16.14 15.09-37.69 17.21-70.52A16 16 0 00240 232a16 16 0 0132 0 16 16 0 001.07 5.71c2.12 32.83 7.53 54.38 17.21 70.52a66.78 66.78 0 0031.92 28c12.23 5.24 27.22 7.79 45.8 7.79 24.15 0 58.48-3.71 77.72-35.77 11.67-19.45 17.13-46.77 18.11-92.23h.17a16 16 0 000-32z"
                }
            }
        ]
    })(props);
}
function IoGlobeOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 48c-58.07 0-112.67 93.13-112.67 208S197.93 464 256 464s112.67-93.13 112.67-208S314.07 48 256 48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M117.33 117.33c38.24 27.15 86.38 43.34 138.67 43.34s100.43-16.19 138.67-43.34m0 277.34c-38.24-27.15-86.38-43.34-138.67-43.34s-100.43 16.19-138.67 43.34"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 48v416m208-208H48"
                }
            }
        ]
    })(props);
}
function IoGlobeSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "44",
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "44",
                    "d": "M256 48c-58.07 0-112.67 93.13-112.67 208S197.93 464 256 464s112.67-93.13 112.67-208S314.07 48 256 48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "44",
                    "d": "M117.33 121.33c38.24 27.15 86.38 43.34 138.67 43.34s100.43-16.19 138.67-43.34m0 269.34c-38.24-27.15-86.38-43.34-138.67-43.34s-100.43 16.19-138.67 43.34"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "44",
                    "d": "M256 48v416m208-208H48"
                }
            }
        ]
    })(props);
}
function IoGlobe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M340.75 344.49c5.91-20.7 9.82-44.75 11.31-67.84a4.41 4.41 0 00-4.46-4.65h-71.06a4.43 4.43 0 00-4.47 4.39v55.3a4.44 4.44 0 004.14 4.38 273.51 273.51 0 0159 11.39 4.45 4.45 0 005.54-2.97zm-17.17 32.82a260.05 260.05 0 00-46.6-9.09 4.42 4.42 0 00-4.91 4.29v65.24a4.47 4.47 0 006.76 3.7c15.9-9.27 29-24.84 40.84-45.43 1.94-3.36 4.89-9.15 6.67-12.69a4.29 4.29 0 00-2.76-6.02zm-88.29-8.91a256.85 256.85 0 00-46.56 8.82c-2.64.76-3.75 4.4-2.55 6.79 1.79 3.56 4 8.11 5.89 11.51 13 23 26.84 37.5 41.24 45.93a4.47 4.47 0 006.76-3.7v-65.27a4.16 4.16 0 00-4.78-4.08zm.31-96.4h-71.06a4.41 4.41 0 00-4.46 4.64c1.48 23.06 5.37 47.16 11.26 67.84a4.46 4.46 0 005.59 3 272.2 272.2 0 0159-11.36 4.44 4.44 0 004.15-4.38V276.4a4.43 4.43 0 00-4.48-4.4zM277 143.78a235.8 235.8 0 0046.5-9.14 4.3 4.3 0 002.76-6c-1.79-3.57-4.27-8.68-6.17-12.09-12.29-22-26.14-37.35-41.24-46a4.48 4.48 0 00-6.76 3.7v65.23a4.43 4.43 0 004.91 4.3zm-.46 96.22h71.06a4.39 4.39 0 004.46-4.58c-1.48-22.77-5.27-47.8-11.16-68.22a4.46 4.46 0 00-5.59-2.95c-19 5.74-38.79 10.43-59.09 12a4.4 4.4 0 00-4.15 4.32v55.11a4.4 4.4 0 004.47 4.32zM233.31 70.56c-15.42 8.57-29.17 24.43-41.47 46.37-1.91 3.41-4.19 8.11-6 11.67a4.31 4.31 0 002.76 6 225.42 225.42 0 0046.54 9.17 4.43 4.43 0 004.91-4.29V74.26a4.49 4.49 0 00-6.74-3.7zm2.61 105.7c-20.3-1.55-40.11-6.24-59.09-12a4.46 4.46 0 00-5.59 2.95c-5.89 20.42-9.68 45.45-11.16 68.22a4.39 4.39 0 004.46 4.58h71.06a4.4 4.4 0 004.47-4.34v-55.09a4.4 4.4 0 00-4.15-4.32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM176.6 430.85a219.08 219.08 0 01-12.48-19.66c-2-3.69-4.84-9.26-6.73-13.13a7.29 7.29 0 00-10.31-3.16c-4.3 2.41-10 5.72-14.13 8.43a147.29 147.29 0 01-23.57-22.43 248.83 248.83 0 0130.41-18.36c1.86-1 2.77-2.14 2.18-4.18a374.8 374.8 0 01-14.09-82.17 4.36 4.36 0 00-4.3-4.17H66.84a2 2 0 01-2-1.7A98.28 98.28 0 0164 256a96.27 96.27 0 01.86-14.29 2 2 0 012-1.7h56.74c2.29 0 4.17-1.32 4.29-3.63a372.71 372.71 0 0114-81.83 4.36 4.36 0 00-2.19-5.11 260.63 260.63 0 01-29.84-17.9 169.82 169.82 0 0123.14-22.8c4.08 2.68 9.4 5.71 13.66 8.11a7.89 7.89 0 0011-3.42c1.88-3.87 4-8.18 6.06-11.88a221.93 221.93 0 0112.54-19.91A185 185 0 01256 64c28.94 0 55.9 7 80.53 18.46a202.23 202.23 0 0112 19c2.59 4.66 5.34 10.37 7.66 15.32a4.29 4.29 0 005.92 1.94c5.38-2.91 11.21-6.26 16.34-9.63a171.36 171.36 0 0123.2 23 244.89 244.89 0 01-29.06 17.31 4.35 4.35 0 00-2.18 5.12 348.68 348.68 0 0113.85 81.4 4.33 4.33 0 004.3 4.12l56.62-.07a2 2 0 012 1.7 117.46 117.46 0 010 28.62 2 2 0 01-2 1.72h-56.67a4.35 4.35 0 00-4.3 4.17 367.4 367.4 0 01-13.87 81.3 4.45 4.45 0 002.19 5.19c5 2.59 10.57 5.48 15.37 8.42s9.55 6.08 14.13 9.34a172.73 172.73 0 01-23 22.93c-2.44-1.61-5.34-3.44-7.84-4.94-1.72-1-4.89-2.77-6.65-3.76-3.82-2.14-7.88-.54-9.79 3.4s-4.83 9.59-6.87 13.25a212.42 212.42 0 01-12.35 19.53C310.91 442.37 284.94 448 256 448s-54.77-5.63-79.4-17.15z"
                }
            }
        ]
    })(props);
}
function IoGolfOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 400V32l176 80-176 80"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 336c-87 0-175.3 43.2-191.64 124.74C62.39 470.57 68.57 480 80 480h352c11.44 0 17.62-9.43 15.65-19.26C431.3 379.2 343 336 256 336z"
                }
            }
        ]
    })(props);
}
function IoGolfSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 16v304.47q8-.47 16-.47t16 .47V202.3L448 112z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M462.91 457.5c-8.54-42.85-35-78.74-76.62-103.8-32.43-19.55-72.53-31.3-114.29-33.7v95.79h-32V320c-41.79 2.4-81.89 14.15-114.32 33.7-41.59 25.06-68.08 60.95-76.62 103.8-2 9.81-.68 38.5-.68 38.5h415.21s1.28-28.69-.68-38.5z"
                }
            }
        ]
    })(props);
}
function IoGolf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 320.46V202.3l166.62-75.73a16 16 0 000-29.14l-176-80A16 16 0 00240 32v288.46q8-.45 16-.46t16 .46z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M463.33 457.5c-8.56-42.85-35.11-78.74-76.78-103.8-32.5-19.55-72.67-31.3-114.55-33.7v79.75a16 16 0 11-32 0V320c-41.88 2.4-82.05 14.15-114.55 33.7-41.67 25.06-68.22 60.95-76.78 103.8a32.49 32.49 0 006.44 27.08C61.13 492 70 496 80 496h352c10 0 18.88-4.05 24.9-11.42a32.49 32.49 0 006.43-27.08z"
                }
            }
        ]
    })(props);
}
function IoGridOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "176",
                    "height": "176",
                    "x": "48",
                    "y": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "20",
                    "ry": "20"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "176",
                    "height": "176",
                    "x": "288",
                    "y": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "20",
                    "ry": "20"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "176",
                    "height": "176",
                    "x": "48",
                    "y": "288",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "20",
                    "ry": "20"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "176",
                    "height": "176",
                    "x": "288",
                    "y": "288",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "20",
                    "ry": "20"
                }
            }
        ]
    })(props);
}
function IoGridSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 240H32V32h208zm240 0H272V32h208zM240 480H32V272h208zm240 0H272V272h208z"
                }
            }
        ]
    })(props);
}
function IoGrid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M204 240H68a36 36 0 01-36-36V68a36 36 0 0136-36h136a36 36 0 0136 36v136a36 36 0 01-36 36zm240 0H308a36 36 0 01-36-36V68a36 36 0 0136-36h136a36 36 0 0136 36v136a36 36 0 01-36 36zM204 480H68a36 36 0 01-36-36V308a36 36 0 0136-36h136a36 36 0 0136 36v136a36 36 0 01-36 36zm240 0H308a36 36 0 01-36-36V308a36 36 0 0136-36h136a36 36 0 0136 36v136a36 36 0 01-36 36z"
                }
            }
        ]
    })(props);
}
function IoHammerOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M277.42 247a24.68 24.68 0 00-4.08-5.47L255 223.44a21.63 21.63 0 00-6.56-4.57 20.93 20.93 0 00-23.28 4.27c-6.36 6.26-18 17.68-39 38.43C146 301.3 71.43 367.89 37.71 396.29a16 16 0 00-1.09 23.54l39 39.43a16.13 16.13 0 0023.67-.89c29.24-34.37 96.3-109 136-148.23 20.39-20.06 31.82-31.58 38.29-37.94a21.76 21.76 0 003.84-25.2zm201.01-46l-34.31-34a5.44 5.44 0 00-4-1.59 5.59 5.59 0 00-4 1.59h0a11.41 11.41 0 01-9.55 3.27c-4.48-.49-9.25-1.88-12.33-4.86-7-6.86 1.09-20.36-5.07-29a242.88 242.88 0 00-23.08-26.72c-7.06-7-34.81-33.47-81.55-52.53a123.79 123.79 0 00-47-9.24c-26.35 0-46.61 11.76-54 18.51-5.88 5.32-12 13.77-12 13.77a91.29 91.29 0 0110.81-3.2 79.53 79.53 0 0123.28-1.49C241.19 76.8 259.94 84.1 270 92c16.21 13 23.18 30.39 24.27 52.83.8 16.69-15.23 37.76-30.44 54.94a7.85 7.85 0 00.4 10.83l21.24 21.23a8 8 0 0011.14.1c13.93-13.51 31.09-28.47 40.82-34.46s17.58-7.68 21.35-8.09a35.71 35.71 0 0121.3 4.62 13.65 13.65 0 013.08 2.38c6.46 6.56 6.07 17.28-.5 23.74l-2 1.89a5.5 5.5 0 000 7.84l34.31 34a5.5 5.5 0 004 1.58 5.65 5.65 0 004-1.58L478.43 209a5.82 5.82 0 000-8z"
                }
            }
        ]
    })(props);
}
function IoHammerSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M294.28 256.9l-54.42-54.41a12 12 0 00-17 0L12.45 401a12 12 0 00-.27 17.2l66.05 66.28a12 12 0 0017.22-.23l198.81-210.36a12 12 0 00.02-16.99zm205.05-57.57l-43.89-43.58a21.46 21.46 0 00-15.28-6.26 21.89 21.89 0 00-12.79 4.14c0-.43.06-.85.09-1.22.45-6.5 1.15-16.32-5.2-25.22a258 258 0 00-24.8-28.74.6.6 0 00-.08-.08c-13.32-13.12-42.31-37.83-86.72-55.94A139.55 139.55 0 00257.56 32C226 32 202 46.24 192.81 54.68A53.4 53.4 0 00176 86.17L192 96s8.06-2 13.86-3.39a62.73 62.73 0 0118.45-1.15c13.19 1.09 28.79 7.64 35.69 13.09 11.7 9.41 17.33 22.09 18.26 41.09.2 4.23-9.52 21.35-24.16 39.84a8 8 0 00.61 10.62l45.37 45.37a8 8 0 0011 .25c12.07-11 30.49-28 34.67-30.59 7.69-4.73 13.19-5.64 14.7-5.8a19.18 19.18 0 0111.29 2.38 1.24 1.24 0 01-.31.95l-1.82 1.73-.3.28a21.52 21.52 0 00.05 30.54l43.95 43.68a8 8 0 0011.28 0l74.68-74.2a8 8 0 00.06-11.36z"
                }
            }
        ]
    })(props);
}
function IoHammer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M280.16 242.79l-26.11-26.12a32 32 0 00-45.14-.12L27.38 384.08c-6.61 6.23-10.95 14.17-11.35 23.06a32.11 32.11 0 009.21 23.94l39 39.43a.46.46 0 00.07.07A32.29 32.29 0 0087 480h1.18c8.89-.33 16.85-4.5 23.17-11.17l168.7-180.7a32 32 0 00.11-45.34zM490 190l-.31-.31-34.27-33.92a21.46 21.46 0 00-15.28-6.26 21.89 21.89 0 00-12.79 4.14c0-.43.06-.85.09-1.22.45-6.5 1.15-16.32-5.2-25.22a258 258 0 00-24.8-28.74.6.6 0 00-.08-.08c-13.32-13.12-42.31-37.83-86.72-55.94A139.55 139.55 0 00257.56 32C226 32 202 46.24 192.81 54.68a119.92 119.92 0 00-14.18 16.22 16 16 0 0018.65 24.34 74.45 74.45 0 018.58-2.63 63.46 63.46 0 0118.45-1.15c13.19 1.09 28.79 7.64 35.69 13.09 11.7 9.41 17.33 22.09 18.26 41.09.18 3.82-7.72 18.14-20 34.48a16 16 0 001.45 21l34.41 34.41a16 16 0 0022 .62c9.73-8.69 24.55-21.79 29.73-25 7.69-4.73 13.19-5.64 14.7-5.8a19.18 19.18 0 0111.29 2.38 1.24 1.24 0 01-.31.95l-1.82 1.73-.3.28a21.52 21.52 0 00.05 30.54l34.26 33.91a21.45 21.45 0 0015.28 6.25 21.7 21.7 0 0015.22-6.2l55.5-54.82c.19-.19.38-.39.56-.59A21.87 21.87 0 00490 190z"
                }
            }
        ]
    })(props);
}
function IoHandLeftOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M80 320V144a32 32 0 0132-32h0a32 32 0 0132 32v112m0 0V80a32 32 0 0132-32h0a32 32 0 0132 32v160m64 1V96a32 32 0 0132-32h0a32 32 0 0132 32v224m-128-80V48a32 32 0 0132-32h0a32 32 0 0132 32v192"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M80 320c0 117.4 64 176 152 176s123.71-39.6 144-88l52.71-144c6.66-18.05 3.64-34.79-11.87-43.6h0c-15.52-8.82-35.91-4.28-44.31 11.68L336 320"
                }
            }
        ]
    })(props);
}
function IoHandLeftSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M429.58 209.08c-15.06-6.62-32.38 1.31-38.5 17.62L356 312h-11.27V80c0-17.6-13.3-32-29.55-32-16.26 0-29.55 14.4-29.55 32v151.75l-14.78.25V32c0-17.6-13.3-32-29.55-32s-29.55 14.4-29.55 32v199.75L197 232V64c0-17.6-13.3-32-29.55-32-16.26 0-29.55 14.4-29.55 32v183.75l-14.8.25V128c0-17.6-13.3-32-29.55-32S64 110.4 64 128v216c0 75.8 37.13 168 169 168 40.8 0 79.42-7 100.66-21a121.41 121.41 0 0033.72-33.31 138 138 0 0016-31.78l62.45-175.14c6.17-16.31-1.19-35.06-16.25-41.69z"
                }
            }
        ]
    })(props);
}
function IoHandLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432.8 211.44c-15.52-8.82-34.91-2.28-43.31 13.68l-41.38 84.41a7 7 0 01-8.93 3.43 7 7 0 01-4.41-6.52V72c0-13.91-12.85-24-26.77-24s-26 10.09-26 24v156.64A11.24 11.24 0 01271.21 240 11 11 0 01260 229V24c0-13.91-10.94-24-24.86-24S210 10.09 210 24v204.64A11.24 11.24 0 01199.21 240 11 11 0 01188 229V56c0-13.91-12.08-24-26-24s-26 11.09-26 25v187.64A11.24 11.24 0 01125.21 256 11 11 0 01114 245V120c0-13.91-11.08-24-25-24s-25.12 10.22-25 24v216c0 117.41 72 176 160 176h16c88 0 115.71-39.6 136-88l68.71-169c6.62-18 3.6-34.75-11.91-43.56z"
                }
            }
        ]
    })(props);
}
function IoHandRightOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M432 320V144a32 32 0 00-32-32h0a32 32 0 00-32 32v112m0 0V80a32 32 0 00-32-32h0a32 32 0 00-32 32v160m-64 1V96a32 32 0 00-32-32h0a32 32 0 00-32 32v224m128-80V48a32 32 0 00-32-32h0a32 32 0 00-32 32v192"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M432 320c0 117.4-64 176-152 176s-123.71-39.6-144-88L83.33 264c-6.66-18.05-3.64-34.79 11.87-43.6h0c15.52-8.82 35.91-4.28 44.31 11.68L176 320"
                }
            }
        ]
    })(props);
}
function IoHandRightSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M82.42 209.08c15.06-6.62 32.38 1.31 38.5 17.62L156 312h11.27V80c0-17.6 13.3-32 29.55-32 16.26 0 29.55 14.4 29.55 32v151.75l14.78.25V32c0-17.6 13.3-32 29.55-32 16.3 0 29.55 14.4 29.55 32v199.75L315 232V64c0-17.6 13.3-32 29.55-32 16.26 0 29.55 14.4 29.55 32v183.75l14.78.25V128c0-17.6 13.3-32 29.55-32C434.7 96 448 110.4 448 128v216c0 75.8-37.13 168-169 168-40.8 0-79.42-7-100.66-21a121.41 121.41 0 01-33.72-33.31 138 138 0 01-16-31.78L66.16 250.77c-6.11-16.31 1.2-35.06 16.26-41.69z"
                }
            }
        ]
    })(props);
}
function IoHandRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M79.2 211.44c15.52-8.82 34.91-2.28 43.31 13.68l41.38 84.41a7 7 0 008.93 3.43 7 7 0 004.41-6.52V72c0-13.91 12.85-24 26.77-24s26 10.09 26 24v156.64A11.24 11.24 0 00240.79 240 11 11 0 00252 229V24c0-13.91 10.94-24 24.86-24S302 10.09 302 24v204.64A11.24 11.24 0 00312.79 240 11 11 0 00324 229V56c0-13.91 12.08-24 26-24s26 11.09 26 25v187.64A11.24 11.24 0 00386.79 256 11 11 0 00398 245V120c0-13.91 11.08-24 25-24s25.12 10.22 25 24v216c0 117.41-72 176-160 176h-16c-88 0-115.71-39.6-136-88L67.33 255c-6.66-18-3.64-34.75 11.87-43.56z"
                }
            }
        ]
    })(props);
}
function IoHappyOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "184",
                    "cy": "232",
                    "r": "24"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256.05 384c-45.42 0-83.62-29.53-95.71-69.83a8 8 0 017.82-10.17h175.69a8 8 0 017.82 10.17c-11.99 40.3-50.2 69.83-95.62 69.83z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "328",
                    "cy": "232",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "208",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function IoHappySharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM328 208a24 24 0 11-24 24 23.94 23.94 0 0124-24zm-144 0a24 24 0 11-24 24 23.94 23.94 0 0124-24zm72.05 176c-45.42 0-83.75-29.49-95.72-69.83C159.29 310.65 158 304 158 304h196s-1.31 6.69-2.33 10.17c-11.78 40.36-50.2 69.83-95.62 69.83z"
                }
            }
        ]
    })(props);
}
function IoHappy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM184 208a24 24 0 11-24 24 23.94 23.94 0 0124-24zm167.67 106.17c-12 40.3-50.2 69.83-95.62 69.83s-83.62-29.53-95.72-69.83a8 8 0 017.83-10.17h175.69a8 8 0 017.82 10.17zM328 256a24 24 0 1124-24 23.94 23.94 0 01-24 24z"
                }
            }
        ]
    })(props);
}
function IoHardwareChipOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "352",
                    "height": "352",
                    "x": "80",
                    "y": "80",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "224",
                    "height": "224",
                    "x": "144",
                    "y": "144",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "16",
                    "ry": "16"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 80V48m80 32V48M176 80V48m80 416v-32m80 32v-32m-160 32v-32m256-176h32m-32 80h32m-32-160h32M48 256h32m-32 80h32M48 176h32"
                }
            }
        ]
    })(props);
}
function IoHardwareChipSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 160h192v192H160z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M480 198v-44h-32V88a24 24 0 00-24-24h-66V32h-44v32h-36V32h-44v32h-36V32h-44v32H88a24 24 0 00-24 24v66H32v44h32v36H32v44h32v36H32v44h32v66a24 24 0 0024 24h66v32h44v-32h36v32h44v-32h36v32h44v-32h66a24 24 0 0024-24v-66h32v-44h-32v-36h32v-44h-32v-36zm-352-70h256v256H128z"
                }
            }
        ]
    })(props);
}
function IoHardwareChip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M352 128H160a32 32 0 00-32 32v192a32 32 0 0032 32h192a32 32 0 0032-32V160a32 32 0 00-32-32zm0 216a8 8 0 01-8 8H168a8 8 0 01-8-8V168a8 8 0 018-8h176a8 8 0 018 8z"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "192",
                    "height": "192",
                    "x": "160",
                    "y": "160",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M464 192a16 16 0 000-32h-16v-32a64.07 64.07 0 00-64-64h-32V48a16 16 0 00-32 0v16h-48V48a16 16 0 00-32 0v16h-48V48a16 16 0 00-32 0v16h-32a64.07 64.07 0 00-64 64v32H48a16 16 0 000 32h16v48H48a16 16 0 000 32h16v48H48a16 16 0 000 32h16v32a64.07 64.07 0 0064 64h32v16a16 16 0 0032 0v-16h48v16a16 16 0 0032 0v-16h48v16a16 16 0 0032 0v-16h32a64.07 64.07 0 0064-64v-32h16a16 16 0 000-32h-16v-48h16a16 16 0 000-32h-16v-48zm-80 160a32 32 0 01-32 32H160a32 32 0 01-32-32V160a32 32 0 0132-32h192a32 32 0 0132 32z"
                }
            }
        ]
    })(props);
}
function IoHeadsetOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M83 384c-13-33-35-93.37-35-128C48 141.12 149.33 48 256 48s208 93.12 208 208c0 34.63-23 97-35 128"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M108.39 270.13l-13.69 8h0c-30.23 17.7-31.7 72.41-3.38 122.2s75.87 75.81 106.1 58.12h0l13.69-8a16.16 16.16 0 005.78-21.87L130 276a15.74 15.74 0 00-21.61-5.87zm295.22 0l13.69 8h0c30.23 17.69 31.74 72.4 3.38 122.19s-75.87 75.81-106.1 58.12h0l-13.69-8a16.16 16.16 0 01-5.78-21.87L382 276a15.74 15.74 0 0121.61-5.87z"
                }
            }
        ]
    })(props);
}
function IoHeadsetSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M411.16 97.45C368.43 55.85 311.88 32 256 32S143.57 55.85 100.84 97.45C56.45 140.67 32 196 32 256s26.84 118.49 45.42 152.25S121 480 144 480c32 0 96-32 96-32L128 240l-54.42 31.73a176.07 176.07 0 01-1-18.84c0-48.57 19.32-94.1 56.15-130C164.24 88.34 210 70 256 70s91.73 18.34 127.27 52.93c36.83 35.86 56.14 81.39 56.14 130a175.56 175.56 0 01-1 18.82L384 240 272 448s64 32 96 32c23 0 48-38 66.58-71.75S480 316 480 256s-24.45-115.33-68.84-158.55z"
                }
            }
        ]
    })(props);
}
function IoHeadset(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M411.16 97.46C368.43 55.86 311.88 32 256 32S143.57 55.86 100.84 97.46C56.45 140.67 32 197 32 256c0 26.67 8.75 61.09 32.88 125.55S137 473 157.27 477.41c5.81 1.27 12.62 2.59 18.73 2.59a60.06 60.06 0 0030-8l14-8c15.07-8.82 19.47-28.13 10.8-43.35l-86.92-152.57a31.73 31.73 0 00-43.57-11.76l-13.69 8a56.49 56.49 0 00-14 11.59 4 4 0 01-7-2A114.68 114.68 0 0164 256c0-50.31 21-98.48 59.16-135.61C160 84.55 208.39 64 256 64s96 20.55 132.84 56.39C427 157.52 448 205.69 448 256a114.68 114.68 0 01-1.68 17.91 4 4 0 01-7 2 56.49 56.49 0 00-14-11.59l-13.69-8a31.73 31.73 0 00-43.57 11.76L281.2 420.65c-8.67 15.22-4.27 34.53 10.8 43.35l14 8a60.06 60.06 0 0030 8c6.11 0 12.92-1.32 18.73-2.59C375 473 423 446 447.12 381.55S480 282.67 480 256c0-59-24.45-115.33-68.84-158.54z"
                }
            }
        ]
    })(props);
}
function IoHeartCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 360a16 16 0 01-9-2.78c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5.31-31.06 25.22-56.33 55.53-56.33 20.4 0 35 10.63 44.1 20.41a6 6 0 008.72 0c9.11-9.78 23.7-20.41 44.1-20.41 30.31 0 55.22 25.27 55.53 56.33.28 27.1-9.31 52.13-29.3 76.5-9.38 11.44-26.4 29.73-65.7 56.41A16 16 0 01256 360z"
                }
            }
        ]
    })(props);
}
function IoHeartCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm74.69 252.82c-8.5 10.36-39.69 38.48-74.69 63.51-35-25-66.19-53.15-74.69-63.51-20-24.37-29.58-49.4-29.3-76.5.31-31.06 25.22-56.33 55.53-56.33 22 0 37.3 12.41 46.19 22.76l2.27 2.75 2.27-2.75C267 180.29 282.42 168 304.46 168c30.31 0 55.22 25.27 55.53 56.33.28 27.09-9.31 52.12-29.3 76.49z"
                }
            }
        ]
    })(props);
}
function IoHeartCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm74.69 252.82c-9.38 11.44-26.4 29.73-65.7 56.41a15.93 15.93 0 01-18 0c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5.31-31.06 25.22-56.33 55.53-56.33 20.4 0 35 10.63 44.1 20.41a6 6 0 008.72 0c9.11-9.78 23.7-20.41 44.1-20.41 30.31 0 55.22 25.27 55.53 56.33.3 27.1-9.29 52.13-29.28 76.5z"
                }
            }
        ]
    })(props);
}
function IoHeartDislikeCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M333.2 297.69c18.28-23.39 27.06-47.43 26.79-73.37-.31-31.06-25.22-56.33-55.53-56.33-20.4 0-35 10.64-44.11 20.42a5.93 5.93 0 01-8.7 0c-9.11-9.78-23.71-20.42-44.11-20.42L206 168a4 4 0 00-2.75 6.84l124 123.21a3.92 3.92 0 005.95-.36zM158.84 221a4 4 0 00-6.82 2.72v.64c-.28 27.1 9.31 52.13 29.3 76.5 9.38 11.44 26.4 29.73 65.7 56.41a15.93 15.93 0 0018 0c5.15-3.49 9.9-6.84 14.31-10a4 4 0 00.46-6.07zM336 368a15.92 15.92 0 01-11.31-4.69l-176-176a16 16 0 0122.62-22.62l176 176A16 16 0 01336 368z"
                }
            }
        ]
    })(props);
}
function IoHeartDislikeCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm63.73 310.36l-183.14-182.3 22.74-22.51 183.19 182.36zm-63.51 4.86c-35.36-25-66.31-51.92-74.91-62.4-20-24.37-29.58-49.4-29.3-76.5a58.27 58.27 0 01.85-9.31l130.21 129.4c-3.43 2.59-16.21 11.45-26.85 18.81zm74.47-62.4l-.31.38L197.33 169a53.8 53.8 0 0110.21-1 59.34 59.34 0 0144.1 19.41L256 192l4.36-4.6a59.34 59.34 0 0144.1-19.4c30.31 0 55.22 25.27 55.53 56.33.28 27.09-9.31 52.12-29.3 76.49z"
                }
            }
        ]
    })(props);
}
function IoHeartDislikeCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm23.3 299.19c-4.41 3.2-9.16 6.55-14.31 10a15.93 15.93 0 01-18 0c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5v-.64a4 4 0 016.82-2.72l120.95 120.2a4 4 0 01-.46 6.07zm68 16.12a16 16 0 01-22.62 0l-176-176a16 16 0 0122.62-22.62l176 176a16 16 0 01.01 22.62zm-14.1-65.62a3.92 3.92 0 01-6 .37l-124-123.21A4 4 0 01206 168h1.55c20.4 0 35 10.64 44.11 20.42a5.93 5.93 0 008.7 0c9.11-9.78 23.71-20.42 44.11-20.42 30.31 0 55.22 25.27 55.53 56.33.26 25.93-8.52 49.97-26.8 73.36z"
                }
            }
        ]
    })(props);
}
function IoHeartDislikeOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M417.84 448a15.94 15.94 0 01-11.35-4.72L40.65 75.26a16 16 0 0122.7-22.56l365.83 368a16 16 0 01-11.34 27.3zM364.92 80c-48.09 0-80 29.55-96.92 51-16.88-21.48-48.83-51-96.92-51a107.37 107.37 0 00-31 4.55L168 112c22.26 0 45.81 9 63.94 26.67a123 123 0 0121.75 28.47 16 16 0 0028.6 0 123 123 0 0121.77-28.51C322.19 121 342.66 112 364.92 112c43.15 0 78.62 36.33 79.07 81 .54 53.69-22.75 99.55-57.38 139.52l22.63 22.77c3-3.44 5.7-6.64 8.14-9.6 40-48.75 59.15-98.8 58.61-153C475.37 130.52 425.54 80 364.92 80zM268 432C180.38 372.51 91 297.6 92 193a83.69 83.69 0 012.24-18.39L69 149.14a115.1 115.1 0 00-9 43.49c-.54 54.22 18.63 104.27 58.61 153 18.77 22.87 52.8 59.45 131.39 112.8a31.84 31.84 0 0036 0c20.35-13.81 37.7-26.5 52.58-38.11l-22.66-22.81C300.25 409.6 284.09 421.05 268 432z"
                }
            }
        ]
    })(props);
}
function IoHeartDislikeSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 64.45l389.47 389.94 22.84-22.47L54.85 42 32 64.45zm30.67 128.46c-.56 55.63 19.77 106.94 62.16 156.88 40.25 47.42 94.56 79.67 137.47 108.21l9 6 9-6c18.49-12.3 39.1-25.3 59.79-39.89L71.74 149.28a114.62 114.62 0 00-9.07 43.63zm355.16 156.88c42.39-49.94 62.72-101.25 62.16-156.88-.63-62-50.61-112.54-111.43-112.54-48.26 0-80.35 28-97.23 48.17-16.88-20.2-49-48.17-97.23-48.17A108.24 108.24 0 00142.84 85l270 270.48c1.71-1.89 3.37-3.78 4.99-5.69z"
                }
            }
        ]
    })(props);
}
function IoHeartDislike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M417.84 448a16 16 0 01-11.35-4.72l-365.84-368a16 16 0 1122.7-22.56l365.83 368A16 16 0 01417.84 448zM364.92 80c-44.09 0-74.61 24.82-92.39 45.5a6 6 0 01-9.06 0C245.69 104.82 215.16 80 171.08 80a107.71 107.71 0 00-31 4.54l269.13 270.7c3-3.44 5.7-6.64 8.14-9.6 40-48.75 59.15-98.79 58.61-153C475.37 130.53 425.54 80 364.92 80zM69 149.15a115.06 115.06 0 00-9 43.49c-.54 54.21 18.63 104.25 58.61 153 18.77 22.87 52.8 59.45 131.39 112.8a31.88 31.88 0 0036 0c20.35-13.82 37.7-26.5 52.58-38.12z"
                }
            }
        ]
    })(props);
}
function IoHeartHalfOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352.92 64c-48.09 0-80 29.54-96.92 51-16.88-21.49-48.83-51-96.92-51C98.46 64 48.63 114.54 48 176.65c-.54 54.21 18.63 104.27 58.61 153 18.77 22.88 52.8 59.46 131.39 112.81a31.84 31.84 0 0036 0c78.59-53.35 112.62-89.93 131.39-112.81 40-48.74 59.15-98.8 58.61-153C463.37 114.54 413.54 64 352.92 64zM256 416V207.58c0-19.63 5.23-38.76 14.21-56.22a1.19 1.19 0 01.08-.16 123 123 0 0121.77-28.51C310.19 105 330.66 96 352.92 96c43.15 0 78.62 36.32 79.07 81C433 281.61 343.63 356.51 256 416z"
                }
            }
        ]
    })(props);
}
function IoHeartHalfSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352.92 64c-48.11 0-80.1 28-96.92 48.21C239.18 92 207.19 64 159.08 64 98.46 64 48.63 114.54 48 176.65c-.56 55.68 19.71 107 62 157 40.12 47.46 94.25 79.75 137 108.32l9 6 9-6c42.78-28.57 96.91-60.86 137-108.32 42.25-50 62.52-101.35 62-157C463.37 114.54 413.54 64 352.92 64zm24.67 249c-31.78 37.6-74.68 65.75-112.52 90.59l-9.07 6V162.23l24.59-29.54C294.53 116 318.38 96 352.92 96c43.15 0 78.62 36.32 79.07 81a178.63 178.63 0 01-12.69 68.59c-9.03 22.84-22.67 44.91-41.71 67.41z"
                }
            }
        ]
    })(props);
}
function IoHeartHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352.92 64c-48.09 0-80 29.54-96.92 51-16.88-21.49-48.83-51-96.92-51C98.46 64 48.63 114.54 48 176.65c-.54 54.21 18.63 104.27 58.61 153 18.77 22.88 52.8 59.46 131.39 112.81a31.84 31.84 0 0036 0c78.59-53.35 112.62-89.93 131.39-112.81 40-48.74 59.15-98.8 58.61-153C463.37 114.54 413.54 64 352.92 64zM256 416V207.58c0-19.63 5.23-38.76 14.21-56.22a1.19 1.19 0 01.08-.16 123 123 0 0121.77-28.51C310.19 105 330.66 96 352.92 96c43.15 0 78.62 36.32 79.07 81C433 281.61 343.63 356.51 256 416z"
                }
            }
        ]
    })(props);
}
function IoHeartOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352.92 80C288 80 256 144 256 144s-32-64-96.92-64c-52.76 0-94.54 44.14-95.08 96.81-1.1 109.33 86.73 187.08 183 252.42a16 16 0 0018 0c96.26-65.34 184.09-143.09 183-252.42-.54-52.67-42.32-96.81-95.08-96.81z"
                }
            }
        ]
    })(props);
}
function IoHeartSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 448l-9-6c-42.78-28.57-96.91-60.86-137-108.32-42.25-50-62.52-101.35-62-157C48.63 114.54 98.46 64 159.08 64c48.11 0 80.1 28 96.92 48.21C272.82 92 304.81 64 352.92 64c60.62 0 110.45 50.54 111.08 112.65.56 55.68-19.71 107-62 157-40.09 47.49-94.22 79.78-137 108.35z"
                }
            }
        ]
    })(props);
}
function IoHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 448a32 32 0 01-18-5.57c-78.59-53.35-112.62-89.93-131.39-112.8-40-48.75-59.15-98.8-58.61-153C48.63 114.52 98.46 64 159.08 64c44.08 0 74.61 24.83 92.39 45.51a6 6 0 009.06 0C278.31 88.81 308.84 64 352.92 64c60.62 0 110.45 50.52 111.08 112.64.54 54.21-18.63 104.26-58.61 153-18.77 22.87-52.8 59.45-131.39 112.8a32 32 0 01-18 5.56z"
                }
            }
        ]
    })(props);
}
function IoHelpBuoyOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "208",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "80",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M208 54l8 132m80 0l8-132m-96 404l8-132m80 0l8 132m154-250l-132 8m0 80l132 8M54 208l132 8m0 80l-132 8"
                }
            }
        ]
    })(props);
}
function IoHelpBuoySharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C132.29 32 32 132.29 32 256s100.29 224 224 224 224-100.29 224-224S379.71 32 256 32zm-64 224a64 64 0 1164 64 64 64 0 01-64-64zm237.24-62.29L342.91 199a104.86 104.86 0 00-29.86-29.86l5.24-86.33a185 185 0 01111 111zm-303.35-67.82a183.44 183.44 0 0167.82-43.13l5.29 86.33A104.86 104.86 0 00169.09 199l-86.33-5.24a183.44 183.44 0 0143.13-67.87zm-43.13 192.4l86.33-5.24A104.86 104.86 0 00199 342.91l-5.24 86.33a185 185 0 01-111-110.95zm303.35 67.82a183.44 183.44 0 01-67.82 43.13l-5.24-86.33a104.86 104.86 0 0029.86-29.86l86.33 5.24a183.44 183.44 0 01-43.13 67.82z"
                }
            }
        ]
    })(props);
}
function IoHelpBuoy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM192.13 260.18a64 64 0 1159.69 59.69 64.07 64.07 0 01-59.69-59.69zm240-66.64l-96.37 5.84a4.06 4.06 0 01-3.44-1.59 96 96 0 00-18.07-18.07 4.06 4.06 0 01-1.59-3.44l5.84-96.37a4 4 0 015.42-3.51A193 193 0 01435.6 188.12a4 4 0 01-3.51 5.42zM193.54 79.91l5.84 96.37a4.06 4.06 0 01-1.59 3.44 96 96 0 00-18.07 18.07 4.06 4.06 0 01-3.44 1.59l-96.37-5.84a4 4 0 01-3.51-5.42A193 193 0 01188.12 76.4a4 4 0 015.42 3.51zM79.91 318.46l96.37-5.84a4.06 4.06 0 013.44 1.59 96 96 0 0018.07 18.07 4.06 4.06 0 011.59 3.44l-5.84 96.37a4 4 0 01-5.42 3.51A193 193 0 0176.4 323.88a4 4 0 013.51-5.42zm238.55 113.63l-5.84-96.37a4.06 4.06 0 011.59-3.44 96 96 0 0018.07-18.07 4.06 4.06 0 013.44-1.59l96.37 5.84a4 4 0 013.51 5.42A193 193 0 01323.88 435.6a4 4 0 01-5.42-3.51z"
                }
            }
        ]
    })(props);
}
function IoHelpCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 80a176 176 0 10176 176A176 176 0 00256 80z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "28",
                    "d": "M200 202.29s.84-17.5 19.57-32.57C230.68 160.77 244 158.18 256 158c10.93-.14 20.69 1.67 26.53 4.45 10 4.76 29.47 16.38 29.47 41.09 0 26-17 37.81-36.37 50.8S251 281.43 251 296"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "250",
                    "cy": "348",
                    "r": "20"
                }
            }
        ]
    })(props);
}
function IoHelpCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M288.55 150.84c-8.09-3.86-20-6-32.72-5.82-18 .22-33.13 5.2-45 14.78-23 18.48-24.55 40.37-24.77 42.8a61.69 61.69 0 00-.09 12 3 3 0 003 2.69h21.23a3 3 0 003-3A65.7 65.7 0 01214 204c0-.11 1.14-11.7 14.36-22.34 7-5.64 16.11-8.44 27.83-8.59 9.32-.11 16.93 1.47 20.34 3.09C291 183 298 192.31 298 204.57c0 18-10.9 26.23-30.18 39.18C247.08 257.68 237 275.1 237 297v11a3 3 0 003 3h22a3 3 0 003-3v-11c0-9.16 2.23-19.13 18.44-30 19.95-13.41 42.56-28.6 42.56-62.43 0-23.14-13.3-42.23-37.45-53.73z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64zm10.44 302h-30.21a2.57 2.57 0 01-2.56-2.57v-30.2a2.57 2.57 0 012.56-2.57h30.21a2.57 2.57 0 012.56 2.57v30.2a2.57 2.57 0 01-2.56 2.57zm17-99C267.23 277.88 265 287.85 265 297v11a3 3 0 01-3 3h-22a3 3 0 01-3-3v-11c0-21.91 10.08-39.33 30.82-53.26C287.1 230.8 298 222.6 298 204.57c0-12.26-7-21.57-21.49-28.46-3.41-1.62-11-3.2-20.34-3.09-11.72.15-20.82 2.95-27.83 8.59C215.12 192.25 214 203.84 214 204a65.7 65.7 0 00-.84 10.28 3 3 0 01-3 3h-21.25a3 3 0 01-3-2.69 61.69 61.69 0 01.09-12c.22-2.43 1.8-24.32 24.77-42.8 11.91-9.58 27.06-14.56 45-14.78 12.7-.15 24.63 2 32.72 5.82 24.21 11.51 37.51 30.6 37.51 53.74 0 33.83-22.61 49.02-42.56 62.43z"
                }
            }
        ]
    })(props);
}
function IoHelpCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64zm-6 304a20 20 0 1120-20 20 20 0 01-20 20zm33.44-102C267.23 276.88 265 286.85 265 296a14 14 0 01-28 0c0-21.91 10.08-39.33 30.82-53.26C287.1 229.8 298 221.6 298 203.57c0-12.26-7-21.57-21.49-28.46-3.41-1.62-11-3.2-20.34-3.09-11.72.15-20.82 2.95-27.83 8.59C215.12 191.25 214 202.83 214 203a14 14 0 11-28-1.35c.11-2.43 1.8-24.32 24.77-42.8 11.91-9.58 27.06-14.56 45-14.78 12.7-.15 24.63 2 32.72 5.82C312.7 161.34 326 180.43 326 203.57c0 33.83-22.61 49.02-42.56 62.43z"
                }
            }
        ]
    })(props);
}
function IoHelpOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "40",
                    "d": "M160 164s1.44-33 33.54-59.46C212.6 88.83 235.49 84.28 256 84c18.73-.23 35.47 2.94 45.48 7.82C318.59 100.2 352 120.6 352 164c0 45.67-29.18 66.37-62.35 89.18S248 298.36 248 324"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "248",
                    "cy": "399.99",
                    "r": "32"
                }
            }
        ]
    })(props);
}
function IoHelpSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "40",
                    "d": "M160 164c0-10 1.44-33 33.54-59.46C212.6 88.83 235.49 84.28 256 84c18.73-.23 35.47 2.94 45.48 7.82C318.59 100.2 352 120.6 352 164c0 45.67-29.18 66.37-62.35 89.18S248 290.36 248 316"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "56",
                    "height": "56",
                    "x": "220",
                    "y": "368",
                    "rx": "3.5",
                    "ry": "3.5"
                }
            }
        ]
    })(props);
}
function IoHelp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "40",
                    "d": "M160 164s1.44-33 33.54-59.46C212.6 88.83 235.49 84.28 256 84c18.73-.23 35.47 2.94 45.48 7.82C318.59 100.2 352 120.6 352 164c0 45.67-29.18 66.37-62.35 89.18S248 298.36 248 324"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "248",
                    "cy": "399.99",
                    "r": "32"
                }
            }
        ]
    })(props);
}
function IoHomeOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M80 212v236a16 16 0 0016 16h96V328a24 24 0 0124-24h80a24 24 0 0124 24v136h96a16 16 0 0016-16V212"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M480 256L266.89 52c-5-5.28-16.69-5.34-21.78 0L32 256m368-77V64h-48v69"
                }
            }
        ]
    })(props);
}
function IoHomeSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 174.74V48h-80v58.45L256 32 0 272h64v208h144V320h96v160h144V272h64l-96-97.26z"
                }
            }
        ]
    })(props);
}
function IoHome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M261.56 101.28a8 8 0 00-11.06 0L66.4 277.15a8 8 0 00-2.47 5.79L63.9 448a32 32 0 0032 32H192a16 16 0 0016-16V328a8 8 0 018-8h80a8 8 0 018 8v136a16 16 0 0016 16h96.06a32 32 0 0032-32V282.94a8 8 0 00-2.47-5.79z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M490.91 244.15l-74.8-71.56V64a16 16 0 00-16-16h-48a16 16 0 00-16 16v32l-57.92-55.38C272.77 35.14 264.71 32 256 32c-8.68 0-16.72 3.14-22.14 8.63l-212.7 203.5c-6.22 6-7 15.87-1.34 22.37A16 16 0 0043 267.56L250.5 69.28a8 8 0 0111.06 0l207.52 198.28a16 16 0 0022.59-.44c6.14-6.36 5.63-16.86-.76-22.97z"
                }
            }
        ]
    })(props);
}
function IoHourglassOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M145.61 464h220.78c19.8 0 35.55-16.29 33.42-35.06C386.06 308 304 310 304 256s83.11-51 95.8-172.94c2-18.78-13.61-35.06-33.41-35.06H145.61c-19.8 0-35.37 16.28-33.41 35.06C124.89 205 208 201 208 256s-82.06 52-95.8 172.94c-2.14 18.77 13.61 35.06 33.41 35.06z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M343.3 432H169.13c-15.6 0-20-18-9.06-29.16C186.55 376 240 356.78 240 326V224c0-19.85-38-35-61.51-67.2-3.88-5.31-3.49-12.8 6.37-12.8h142.73c8.41 0 10.23 7.43 6.4 12.75C310.82 189 272 204.05 272 224v102c0 30.53 55.71 47 80.4 76.87 9.95 12.04 6.47 29.13-9.1 29.13z"
                }
            }
        ]
    })(props);
}
function IoHourglassSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 32H96v112l108 112L96 368v112h320V368L308 256l108-112zM272 224v112l91 96H148l92-96V224l-80-80h192z"
                }
            }
        ]
    })(props);
}
function IoHourglass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M415.7 427.13c-8.74-76.89-43.83-108.76-69.46-132C328.52 279 320 270.61 320 256c0-14.41 8.49-22.64 26.16-38.44 25.93-23.17 61.44-54.91 69.56-132.84a47 47 0 00-12-36.26A50.3 50.3 0 00366.39 32H145.61a50.34 50.34 0 00-37.39 16.46 47.05 47.05 0 00-11.94 36.26c8.09 77.68 43.47 109.19 69.3 132.19C183.42 232.8 192 241.09 192 256c0 15.1-8.6 23.56-26.5 39.75-25.5 23.1-60.5 54.73-69.2 131.38a46.59 46.59 0 0011.7 36.2A50.44 50.44 0 00145.61 480h220.78A50.44 50.44 0 00404 463.33a46.59 46.59 0 0011.7-36.2zM343.3 432H169.13c-15.6 0-20-18-9.06-29.16C186.55 376 240 356.78 240 326V224c0-19.85-38-35-61.51-67.2-3.88-5.31-3.49-12.8 6.37-12.8h142.73c8.41 0 10.22 7.43 6.4 12.75C310.82 189 272 204.05 272 224v102c0 30.53 55.71 47 80.4 76.87 9.95 12.04 6.47 29.13-9.1 29.13z"
                }
            }
        ]
    })(props);
}
function IoIceCreamOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 256l-96 224-62-145"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M299.42 223.48C291.74 239.75 275.18 252 256 252c-13.1 0-27-5-33.63-9.76C216.27 237.87 208 240 208 250v62a24.07 24.07 0 01-24 24h0a24.07 24.07 0 01-24-24v-56h-2c-35.35 0-62-28.65-62-64a64 64 0 0164-64h8v-8a88 88 0 01176 0v8h8a64 64 0 010 128c-21.78 0-42-13-52.59-32.51z"
                }
            }
        ]
    })(props);
}
function IoIceCreamSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M359.72 112.37a104 104 0 00-207.44 0A80.12 80.12 0 0080 192c0 39.36 26.37 71.23 62.38 78.46a2 2 0 011.62 2v38.83c0 21.84 17.2 40.22 39 40.74a40 40 0 0041-40v-47.84a2 2 0 012.72-1.86A83.47 83.47 0 00256 268a63.18 63.18 0 0042.24-16.59 2 2 0 012.74 0A74.63 74.63 0 00352 272a80 80 0 007.72-159.63z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 300v12a72.1 72.1 0 01-58.21 70.64L256 496l92.06-192.08a105.29 105.29 0 01-49.18-14.36A93.75 93.75 0 01256 300z"
                }
            }
        ]
    })(props);
}
function IoIceCream(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M183 352c-21.84-.52-39-18.9-39-40.74v-34.07a8 8 0 00-6-7.74c-33.75-8.85-58-39.71-58-77.45a80.14 80.14 0 0166.27-78.82 8 8 0 006.62-6.83 104 104 0 01206.22 0 8 8 0 006.62 6.83A80 80 0 01352 272a74.33 74.33 0 01-47.45-17.41 7.93 7.93 0 00-9.92-.14A62.89 62.89 0 01256 268a80.47 80.47 0 01-21.8-3.18 8 8 0 00-10.2 7.69V312a40 40 0 01-41 40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M263.39 299.7a8 8 0 00-7.39 7.91V312a72.11 72.11 0 01-50.69 68.76 8 8 0 00-4.91 10.78l40.91 94.8A16 16 0 00256 496a16 16 0 0014.69-9.7l73.78-172.15a8 8 0 00-6.2-11.07 106.31 106.31 0 01-35.9-11.59 8 8 0 00-7.13-.2 95 95 0 01-31.85 8.41z"
                }
            }
        ]
    })(props);
}
function IoIdCardOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "320",
                    "height": "448",
                    "x": "96",
                    "y": "32",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M208 80h96"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M333.48 284.51A39.65 39.65 0 00304 272c-11.6 0-22.09 4.41-29.54 12.43s-11.2 19.12-10.34 31C265.83 338.91 283.72 358 304 358s38.14-19.09 39.87-42.55c.88-11.78-2.82-22.77-10.39-30.94zM371.69 448H236.31a12.05 12.05 0 01-9.31-4.17 13 13 0 01-2.76-10.92c3.25-17.56 13.38-32.31 29.3-42.66C267.68 381.06 285.6 376 304 376s36.32 5.06 50.46 14.25c15.92 10.35 26.05 25.1 29.3 42.66a13 13 0 01-2.76 10.92 12.05 12.05 0 01-9.31 4.17z"
                }
            }
        ]
    })(props);
}
function IoIdCardSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408 16H104a24 24 0 00-24 24v432a24 24 0 0024 24h304a24 24 0 0024-24V40a24 24 0 00-24-24zm-61.1 296.77a43 43 0 11-40.71-40.71 43 43 0 0140.71 40.71zM192 64h128v32H192zm192 384H224v-24.6c0-32.72 53.27-49.21 80-49.21s80 16.49 80 49.21z"
                }
            }
        ]
    })(props);
}
function IoIdCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 16H144a64.07 64.07 0 00-64 64v352a64.07 64.07 0 0064 64h224a64.07 64.07 0 0064-64V80a64.07 64.07 0 00-64-64zm-34.52 268.51c7.57 8.17 11.27 19.16 10.39 30.94C342.14 338.91 324.25 358 304 358s-38.17-19.09-39.88-42.55c-.86-11.9 2.81-22.91 10.34-31S292.4 272 304 272a39.65 39.65 0 0129.48 12.51zM192 80a16 16 0 0116-16h96a16 16 0 010 32h-96a16 16 0 01-16-16zm189 363.83a12.05 12.05 0 01-9.31 4.17H236.31a12.05 12.05 0 01-9.31-4.17 13 13 0 01-2.76-10.92c3.25-17.56 13.38-32.31 29.3-42.66C267.68 381.06 285.6 376 304 376s36.32 5.06 50.46 14.25c15.92 10.35 26.05 25.1 29.3 42.66a13 13 0 01-2.76 10.92z"
                }
            }
        ]
    })(props);
}
function IoImageOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "416",
                    "height": "352",
                    "x": "48",
                    "y": "80",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "336",
                    "cy": "176",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M304 335.79l-90.66-90.49a32 32 0 00-43.87-1.3L48 352m176 80l123.34-123.34a32 32 0 0143.11-2L464 368"
                }
            }
        ]
    })(props);
}
function IoImageSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M456 64H56a24 24 0 00-24 24v336a24 24 0 0024 24h400a24 24 0 0024-24V88a24 24 0 00-24-24zm-124.38 64.2a48 48 0 11-43.42 43.42 48 48 0 0143.42-43.42zM76 416a12 12 0 01-12-12v-87.63L192.64 202l96.95 96.75L172.37 416zm372-12a12 12 0 01-12 12H217.63l149.53-149.53L448 333.84z"
                }
            }
        ]
    })(props);
}
function IoImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 64H96a64.07 64.07 0 00-64 64v256a64.07 64.07 0 0064 64h320a64.07 64.07 0 0064-64V128a64.07 64.07 0 00-64-64zm-80 64a48 48 0 11-48 48 48.05 48.05 0 0148-48zM96 416a32 32 0 01-32-32v-67.63l94.84-84.3a48.06 48.06 0 0165.8 1.9l64.95 64.81L172.37 416zm352-32a32 32 0 01-32 32H217.63l121.42-121.42a47.72 47.72 0 0161.64-.16L448 333.84z"
                }
            }
        ]
    })(props);
}
function IoImagesOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M432 112V96a48.14 48.14 0 00-48-48H64a48.14 48.14 0 00-48 48v256a48.14 48.14 0 0048 48h16"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "400",
                    "height": "336",
                    "x": "96",
                    "y": "128",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "45.99",
                    "ry": "45.99"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "372.92",
                    "cy": "219.64",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "30.77",
                    "ry": "30.55"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M342.15 372.17L255 285.78a30.93 30.93 0 00-42.18-1.21L96 387.64M265.23 464l118.59-117.73a31 31 0 0141.46-1.87L496 402.91"
                }
            }
        ]
    })(props);
}
function IoImagesSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "373.14",
                    "cy": "219.33",
                    "fill": "none",
                    "rx": "46.29",
                    "ry": "46"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M80 132v328a20 20 0 0020 20h392a20 20 0 0020-20V132a20 20 0 00-20-20H100a20 20 0 00-20 20zm293.14 41.33a46 46 0 11-46.28 46 46.19 46.19 0 0146.28-46zm-261.41 276v-95.48l122.76-110.2L328.27 337l-113 112.33zm368.27 0H259l144.58-144L480 370.59z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 32A20 20 0 000 52v344a20 20 0 0020 20h28V100a20 20 0 0120-20h380V52a20 20 0 00-20-20z"
                }
            }
        ]
    })(props);
}
function IoImages(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M450.29 112H142c-34 0-62 27.51-62 61.33v245.34c0 33.82 28 61.33 62 61.33h308c34 0 62-26.18 62-60V173.33c0-33.82-27.68-61.33-61.71-61.33zm-77.15 61.34a46 46 0 11-46.28 46 46.19 46.19 0 0146.28-46.01zm-231.55 276c-17 0-29.86-13.75-29.86-30.66v-64.83l90.46-80.79a46.54 46.54 0 0163.44 1.83L328.27 337l-113 112.33zM480 418.67a30.67 30.67 0 01-30.71 30.66H259L376.08 333a46.24 46.24 0 0159.44-.16L480 370.59z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64A64 64 0 000 96v256a64.11 64.11 0 0048 62V152a72 72 0 0172-72h326a64.11 64.11 0 00-62-48z"
                }
            }
        ]
    })(props);
}
function IoInfiniteOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 256s-48-96-126-96c-54.12 0-98 43-98 96s43.88 96 98 96c37.51 0 71-22.41 94-48m32-48s48 96 126 96c54.12 0 98-43 98-96s-43.88-96-98-96c-37.51 0-71 22.41-94 48"
                }
            }
        ]
    })(props);
}
function IoInfiniteSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M382 136c-40.87 0-73.46 20.53-93.6 37.76l-.71.61-11.47 12.47 25.32 41.61 18.74-18.79C339.89 193.1 361.78 184 382 184c40.8 0 74 32.3 74 72s-33.2 72-74 72c-62 0-104.14-81.95-104.56-82.78C275 240.29 221.56 136 130 136 62.73 136 8 189.83 8 256s54.73 120 122 120c32.95 0 65.38-13.11 93.79-37.92l.61-.54 11.38-12.38-25.33-41.61-18.83 18.88C172 319.4 151.26 328 130 328c-40.8 0-74-32.3-74-72s33.2-72 74-72c62 0 104.14 81.95 104.56 82.78C237 271.71 290.44 376 382 376c67.27 0 122-53.83 122-120s-54.73-120-122-120z"
                }
            }
        ]
    })(props);
}
function IoInfinite(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "48",
                    "d": "M256 256s-48-96-126-96c-54.12 0-98 43-98 96s43.88 96 98 96c30 0 56.45-13.18 78-32m48-64s48 96 126 96c54.12 0 98-43 98-96s-43.88-96-98-96c-29.37 0-56.66 13.75-78 32"
                }
            }
        ]
    })(props);
}
function IoInformationCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M248 64C146.39 64 64 146.39 64 248s82.39 184 184 184 184-82.39 184-184S349.61 64 248 64z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M220 220h32v116"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M208 340h88"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M248 130a26 26 0 1026 26 26 26 0 00-26-26z"
                }
            }
        ]
    })(props);
}
function IoInformationCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 56C145.72 56 56 145.72 56 256s89.72 200 200 200 200-89.72 200-200S366.28 56 256 56zm0 82a26 26 0 11-26 26 26 26 0 0126-26zm64 226H200v-32h44v-88h-32v-32h64v120h44z"
                }
            }
        ]
    })(props);
}
function IoInformationCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 56C145.72 56 56 145.72 56 256s89.72 200 200 200 200-89.72 200-200S366.28 56 256 56zm0 82a26 26 0 11-26 26 26 26 0 0126-26zm48 226h-88a16 16 0 010-32h28v-88h-16a16 16 0 010-32h32a16 16 0 0116 16v104h28a16 16 0 010 32z"
                }
            }
        ]
    })(props);
}
function IoInformationOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "40",
                    "d": "M196 220h64v172"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "40",
                    "d": "M187 396h138"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 160a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function IoInformationSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "40",
                    "d": "M196 220h64v172m-73 4h138"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 160a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function IoInformation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "40",
                    "d": "M196 220h64v172"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "40",
                    "d": "M187 396h138"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 160a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function IoInvertModeOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "208",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 176v160a80 80 0 010-160zm0-128v128a80 80 0 010 160v128c114.88 0 208-93.12 208-208S370.88 48 256 48z"
                }
            }
        ]
    })(props);
}
function IoInvertModeSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM256 432v-96a80 80 0 010-160V80c97.05 0 176 79 176 176s-78.95 176-176 176z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M336 256a80 80 0 00-80-80v160a80 80 0 0080-80z"
                }
            }
        ]
    })(props);
}
function IoInvertMode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "208",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 176v160a80 80 0 000-160zm0-128v128a80 80 0 000 160v128c-114.88 0-208-93.12-208-208S141.12 48 256 48z"
                }
            }
        ]
    })(props);
}
function IoJournalOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "320",
                    "height": "416",
                    "x": "96",
                    "y": "48",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "60",
                    "d": "M320 48v416"
                }
            }
        ]
    })(props);
}
function IoJournalSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290 32H104a24 24 0 00-24 24v400a24 24 0 0024 24h186zm118 0h-58v448h58a24 24 0 0024-24V56a24 24 0 00-24-24z"
                }
            }
        ]
    })(props);
}
function IoJournal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290 32H144a64.07 64.07 0 00-64 64v320a64.07 64.07 0 0064 64h146zm78 0h-18v448h18a64.07 64.07 0 0064-64V96a64.07 64.07 0 00-64-64z"
                }
            }
        ]
    })(props);
}
function IoKeyOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M218.1 167.17c0 13 0 25.6 4.1 37.4-43.1 50.6-156.9 184.3-167.5 194.5a20.17 20.17 0 00-6.7 15c0 8.5 5.2 16.7 9.6 21.3 6.6 6.9 34.8 33 40 28 15.4-15 18.5-19 24.8-25.2 9.5-9.3-1-28.3 2.3-36s6.8-9.2 12.5-10.4 15.8 2.9 23.7 3c8.3.1 12.8-3.4 19-9.2 5-4.6 8.6-8.9 8.7-15.6.2-9-12.8-20.9-3.1-30.4s23.7 6.2 34 5 22.8-15.5 24.1-21.6-11.7-21.8-9.7-30.7c.7-3 6.8-10 11.4-11s25 6.9 29.6 5.9c5.6-1.2 12.1-7.1 17.4-10.4 15.5 6.7 29.6 9.4 47.7 9.4 68.5 0 124-53.4 124-119.2S408.5 48 340 48s-121.9 53.37-121.9 119.17zM400 144a32 32 0 11-32-32 32 32 0 0132 32z"
                }
            }
        ]
    })(props);
}
function IoKeySharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M218.1 167.2c0 13 0 25.6 4.1 37.4-43.1 50.6-167.5 194.5-167.5 194.5l2.9 36.3s34.8 33 40 28c15.4-15 24.8-25.2 24.8-25.2l7.24-43.35 47.11-3.47 3.78-46.8 49.63-.95.49-50.09 52.69 2.1 9-18.84c15.5 6.7 29.6 9.4 47.7 9.4 68.5 0 124-53.4 124-119.2S408.5 48 340 48s-121.9 53.4-121.9 119.2zM406.85 144A38.85 38.85 0 11368 105.15 38.81 38.81 0 01406.85 144z"
                }
            }
        ]
    })(props);
}
function IoKey(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M218.1 167.17c0 13 0 25.6 4.1 37.4-43.1 50.6-156.9 184.3-167.5 194.5a20.17 20.17 0 00-6.7 15c0 8.5 5.2 16.7 9.6 21.3 6.6 6.9 34.8 33 40 28 15.4-15 18.5-19 24.8-25.2 9.5-9.3-1-28.3 2.3-36s6.8-9.2 12.5-10.4 15.8 2.9 23.7 3c8.3.1 12.8-3.4 19-9.2 5-4.6 8.6-8.9 8.7-15.6.2-9-12.8-20.9-3.1-30.4s23.7 6.2 34 5 22.8-15.5 24.1-21.6-11.7-21.8-9.7-30.7c.7-3 6.8-10 11.4-11s25 6.9 29.6 5.9c5.6-1.2 12.1-7.1 17.4-10.4 15.5 6.7 29.6 9.4 47.7 9.4 68.5 0 124-53.4 124-119.2S408.5 48 340 48s-121.9 53.37-121.9 119.17zM400 144a32 32 0 11-32-32 32 32 0 0132 32z"
                }
            }
        ]
    })(props);
}
function IoKeypadOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "448",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "320",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M288 192a32 32 0 11-32-32 32 32 0 0132 32z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "64",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "384",
                    "cy": "320",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "384",
                    "cy": "192",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "384",
                    "cy": "64",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "128",
                    "cy": "320",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "128",
                    "cy": "192",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "128",
                    "cy": "64",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function IoKeypadSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "96",
                    "height": "96",
                    "x": "80",
                    "y": "16",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "96",
                    "height": "96",
                    "x": "208",
                    "y": "16",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "96",
                    "height": "96",
                    "x": "336",
                    "y": "16",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "96",
                    "height": "96",
                    "x": "80",
                    "y": "144",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "96",
                    "height": "96",
                    "x": "208",
                    "y": "144",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "96",
                    "height": "96",
                    "x": "336",
                    "y": "144",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "96",
                    "height": "96",
                    "x": "80",
                    "y": "272",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "96",
                    "height": "96",
                    "x": "208",
                    "y": "272",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "96",
                    "height": "96",
                    "x": "208",
                    "y": "400",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "96",
                    "height": "96",
                    "x": "336",
                    "y": "272",
                    "rx": "8",
                    "ry": "8"
                }
            }
        ]
    })(props);
}
function IoKeypad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 400a48 48 0 1048 48 48 48 0 00-48-48zm0-128a48 48 0 1048 48 48 48 0 00-48-48zm0-128a48 48 0 1048 48 48 48 0 00-48-48zm0-128a48 48 0 1048 48 48 48 0 00-48-48zm128 256a48 48 0 1048 48 48 48 0 00-48-48zm0-128a48 48 0 1048 48 48 48 0 00-48-48zm0-128a48 48 0 1048 48 48 48 0 00-48-48zM128 272a48 48 0 1048 48 48 48 0 00-48-48zm0-128a48 48 0 1048 48 48 48 0 00-48-48zm0-128a48 48 0 1048 48 48 48 0 00-48-48z"
                }
            }
        ]
    })(props);
}
function IoLanguageOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 112h288M192 64v48m80 336l96-224 96 224m-162.5-64h133M281.3 112S257 206 199 277 80 384 80 384"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 336s-35-27-72-75-56-85-56-85"
                }
            }
        ]
    })(props);
}
function IoLanguageSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M363 176L246 464h47.24l24.49-58h90.54l24.49 58H480zm-26.69 186L363 279.85 389.69 362zM272 320c-.25-.19-20.59-15.77-45.42-42.67 39.58-53.64 62-114.61 71.15-143.33H352V90H214V48h-44v42H32v44h219.25c-9.52 26.95-27.05 69.5-53.79 108.36-32.68-43.44-47.14-75.88-47.33-76.22L143 152l-38 22 6.87 13.86c.89 1.56 17.19 37.9 54.71 86.57.92 1.21 1.85 2.39 2.78 3.57-49.72 56.86-89.15 79.09-89.66 79.47L64 368l23 36 19.3-11.47c2.2-1.67 41.33-24 92-80.78 24.52 26.28 43.22 40.83 44.3 41.67L255 362z"
                }
            }
        ]
    })(props);
}
function IoLanguage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M478.33 433.6l-90-218a22 22 0 00-40.67 0l-90 218a22 22 0 1040.67 16.79L316.66 406h102.67l18.33 44.39A22 22 0 00458 464a22 22 0 0020.32-30.4zM334.83 362L368 281.65 401.17 362zm-66.99-19.08a22 22 0 00-4.89-30.7c-.2-.15-15-11.13-36.49-34.73 39.65-53.68 62.11-114.75 71.27-143.49H330a22 22 0 000-44H214V70a22 22 0 00-44 0v20H54a22 22 0 000 44h197.25c-9.52 26.95-27.05 69.5-53.79 108.36-31.41-41.68-43.08-68.65-43.17-68.87a22 22 0 00-40.58 17c.58 1.38 14.55 34.23 52.86 83.93.92 1.19 1.83 2.35 2.74 3.51-39.24 44.35-77.74 71.86-93.85 80.74a22 22 0 1021.07 38.63c2.16-1.18 48.6-26.89 101.63-85.59 22.52 24.08 38 35.44 38.93 36.1a22 22 0 0030.75-4.9z"
                }
            }
        ]
    })(props);
}
function IoLaptopOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "416",
                    "height": "304",
                    "x": "48",
                    "y": "96",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "32.14",
                    "ry": "32.14"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M16 416h480"
                }
            }
        ]
    })(props);
}
function IoLaptopSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M477.29 400a27.75 27.75 0 002.71-12V108a28 28 0 00-28-28H60a28 28 0 00-28 28v280a27.75 27.75 0 002.71 12H0v32h512v-32z"
                }
            }
        ]
    })(props);
}
function IoLaptop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 400h-28.34A47.92 47.92 0 00480 367.86V128.14A48.2 48.2 0 00431.86 80H80.14A48.2 48.2 0 0032 128.14v239.72A47.92 47.92 0 0044.34 400H16a16 16 0 000 32h480a16 16 0 000-32z"
                }
            }
        ]
    })(props);
}
function IoLayersOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M434.8 137.65l-149.36-68.1c-16.19-7.4-42.69-7.4-58.88 0L77.3 137.65c-17.6 8-17.6 21.09 0 29.09l148 67.5c16.89 7.7 44.69 7.7 61.58 0l148-67.5c17.52-8 17.52-21.1-.08-29.09zM160 308.52l-82.7 37.11c-17.6 8-17.6 21.1 0 29.1l148 67.5c16.89 7.69 44.69 7.69 61.58 0l148-67.5c17.6-8 17.6-21.1 0-29.1l-79.94-38.47"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 204.48l-82.8 37.16c-17.6 8-17.6 21.1 0 29.1l148 67.49c16.89 7.7 44.69 7.7 61.58 0l148-67.49c17.7-8 17.7-21.1.1-29.1L352 204.48"
                }
            }
        ]
    })(props);
}
function IoLayersSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 150L256 48 32 150l224 104 224-104zM255.71 392.95l-144.81-66.2L32 362l224 102 224-102-78.69-35.3-145.6 66.25z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M480 256l-75.53-33.53L256.1 290.6l-148.77-68.17L32 256l224 102 224-102z"
                }
            }
        ]
    })(props);
}
function IoLayers(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 256c-13.47 0-26.94-2.39-37.44-7.17l-148-67.49C63.79 178.26 48 169.25 48 152.24s15.79-26 22.58-29.12l149.28-68.07c20.57-9.4 51.61-9.4 72.19 0l149.37 68.07c6.79 3.09 22.58 12.1 22.58 29.12s-15.79 26-22.58 29.11l-148 67.48C282.94 253.61 269.47 256 256 256zm176.76-100.86z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M441.36 226.81L426.27 220l-38.77 17.74-94 43c-10.5 4.8-24 7.19-37.44 7.19s-26.93-2.39-37.42-7.19l-94.07-43L85.79 220l-15.22 6.84C63.79 229.93 48 239 48 256s15.79 26.08 22.56 29.17l148 67.63C229 357.6 242.49 360 256 360s26.94-2.4 37.44-7.19l147.87-67.61c6.81-3.09 22.69-12.11 22.69-29.2s-15.77-26.07-22.64-29.19z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M441.36 330.8l-15.09-6.8-38.77 17.73-94 42.95c-10.5 4.78-24 7.18-37.44 7.18s-26.93-2.39-37.42-7.18l-94.07-43L85.79 324l-15.22 6.84C63.79 333.93 48 343 48 360s15.79 26.07 22.56 29.15l148 67.59C229 461.52 242.54 464 256 464s26.88-2.48 37.38-7.27l147.92-67.57c6.82-3.08 22.7-12.1 22.7-29.16s-15.77-26.07-22.64-29.2z"
                }
            }
        ]
    })(props);
}
function IoLeafOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M321.89 171.42C233 114 141 155.22 56 65.22c-19.8-21-8.3 235.5 98.1 332.7 77.79 71 197.9 63.08 238.4-5.92s18.28-163.17-70.61-220.58zM173 253c86 81 175 129 292 147"
                }
            }
        ]
    })(props);
}
function IoLeafSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M150.38 253.68l21.94-23.3 11.65 11c73.63 69.36 147.51 111.56 234.45 133.07 11.73-32 12.77-67.22 2.64-101.58-13.44-45.59-44.74-85.31-90.49-114.86-40.25-26-76.6-32.09-115.09-38.54-21.12-3.54-43-7.2-66.85-14.43-43.78-13.28-89.69-52.74-90.15-53.13L33.4 30.15 32 63.33c-.1 2.56-2.42 63.57 14.22 147.77 17.58 89 50.24 155.85 97.07 198.63 38 34.69 87.62 53.9 136.93 53.9a185.88 185.88 0 0027.78-2.07c41.72-6.32 76.43-27.27 96-57.75-89.5-23.28-165.95-67.55-242-139.16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M467.43 384.19c-16.83-2.59-33.13-5.84-49-9.77a158.49 158.49 0 01-12.13 25.68c-.74 1.25-1.51 2.49-2.29 3.71a583.43 583.43 0 0058.55 12l15.82 2.44 4.86-31.63z"
                }
            }
        ]
    })(props);
}
function IoLeaf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M161.35 242a16 16 0 0122.62-.68c73.63 69.36 147.51 111.56 234.45 133.07 11.73-32 12.77-67.22 2.64-101.58-13.44-45.59-44.74-85.31-90.49-114.86-40.84-26.38-81.66-33.25-121.15-39.89-49.82-8.38-96.88-16.3-141.79-63.85-5-5.26-11.81-7.37-18.32-5.66-7.44 2-12.43 7.88-14.82 17.6-5.6 22.75-2 86.51 13.75 153.82 25.29 108.14 65.65 162.86 95.06 189.73 38 34.69 87.62 53.9 136.93 53.9a186 186 0 0027.77-2.04c41.71-6.32 76.43-27.27 96-57.75-89.49-23.28-165.94-67.55-242-139.16a16 16 0 01-.65-22.65zm306.08 142.19c-16.83-2.59-33.13-5.84-49-9.77a157.71 157.71 0 01-12.13 25.68c-.73 1.25-1.5 2.49-2.29 3.71a584.21 584.21 0 0058.56 12 16 16 0 104.87-31.62z"
                }
            }
        ]
    })(props);
}
function IoLibraryOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "64",
                    "height": "368",
                    "x": "32",
                    "y": "96",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "16",
                    "ry": "16"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M112 224h128M112 400h128"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "128",
                    "height": "304",
                    "x": "112",
                    "y": "160",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "16",
                    "ry": "16"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "96",
                    "height": "416",
                    "x": "256",
                    "y": "48",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "16",
                    "ry": "16"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M422.46 96.11l-40.4 4.25c-11.12 1.17-19.18 11.57-17.93 23.1l34.92 321.59c1.26 11.53 11.37 20 22.49 18.84l40.4-4.25c11.12-1.17 19.18-11.57 17.93-23.1L445 115c-1.31-11.58-11.42-20.06-22.54-18.89z"
                }
            }
        ]
    })(props);
}
function IoLibrarySharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M84 480H28a12 12 0 01-12-12V92a12 12 0 0112-12h56a12 12 0 0112 12v376a12 12 0 01-12 12zm156-272v-52a12 12 0 00-12-12H124a12 12 0 00-12 12v52zM112 416v52a12 12 0 0012 12h104a12 12 0 0012-12v-52zm0-176h128v144H112zm228 240h-72a12 12 0 01-12-12V44a12 12 0 0112-12h72a12 12 0 0112 12v424a12 12 0 01-12 12zm29-379.3l30 367.83a12 12 0 0013.45 10.92l72.16-9a12 12 0 0010.47-12.9L465 91.21a12 12 0 00-13.2-10.94l-72.13 7.51A12 12 0 00369 100.7z"
                }
            }
        ]
    })(props);
}
function IoLibrary(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 480H48a32 32 0 01-32-32V112a32 32 0 0132-32h16a32 32 0 0132 32v336a32 32 0 01-32 32zm176-304a32 32 0 00-32-32h-64a32 32 0 00-32 32v28a4 4 0 004 4h120a4 4 0 004-4zM112 448a32 32 0 0032 32h64a32 32 0 0032-32v-30a2 2 0 00-2-2H114a2 2 0 00-2 2z"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "128",
                    "height": "144",
                    "x": "112",
                    "y": "240",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M320 480h-32a32 32 0 01-32-32V64a32 32 0 0132-32h32a32 32 0 0132 32v384a32 32 0 01-32 32zm175.89-34.55l-32.23-340c-1.48-15.65-16.94-27-34.53-25.31l-31.85 3c-17.59 1.67-30.65 15.71-29.17 31.36l32.23 340c1.48 15.65 16.94 27 34.53 25.31l31.85-3c17.59-1.67 30.65-15.71 29.17-31.36z"
                }
            }
        ]
    })(props);
}
function IoLinkOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "36",
                    "d": "M208 352h-64a96 96 0 010-192h64m96 0h64a96 96 0 010 192h-64m-140.71-96h187.42"
                }
            }
        ]
    })(props);
}
function IoLinkSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M200.66 352H144a96 96 0 010-192h55.41m113.18 0H368a96 96 0 010 192h-56.66m-142.27-96h175.86"
                }
            }
        ]
    })(props);
}
function IoLink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M200.66 352H144a96 96 0 010-192h55.41m113.18 0H368a96 96 0 010 192h-56.66m-142.27-96h175.86"
                }
            }
        ]
    })(props);
}
function IoListCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M224 184h128m-128 72h128m-128 71h128"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 258c0-106-86-192-192-192S64 152 64 258s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "168",
                    "cy": "184",
                    "r": "8",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "168",
                    "cy": "257",
                    "r": "8",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "168",
                    "cy": "328",
                    "r": "8",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function IoListCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-64 287.5a16 16 0 01-16 16h-16a16 16 0 01-16-16v-16a16 16 0 0116-16h16a16 16 0 0116 16zm0-71a16 16 0 01-16 16h-16a16 16 0 01-16-16v-16a16 16 0 0116-16h16a16 16 0 0116 16zm0-72a16 16 0 01-16 16h-16a16 16 0 01-16-16v-16a16 16 0 0116-16h16a16 16 0 0116 16zm176 151H212.67v-32H368zm0-71H212.67v-32H368zm0-72H212.67v-32H368z"
                }
            }
        ]
    })(props);
}
function IoListCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-88 302a24 24 0 1124-24 24 24 0 01-24 24zm0-71a24 24 0 1124-24 24 24 0 01-24 24zm0-73a24 24 0 1124-24 24 24 0 01-24 24zm184 135H224a16 16 0 010-32h128a16 16 0 010 32zm0-71H224a16 16 0 010-32h128a16 16 0 010 32zm0-72H224a16 16 0 010-32h128a16 16 0 010 32z"
                }
            }
        ]
    })(props);
}
function IoListOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 144h288M160 256h288M160 368h288"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "80",
                    "cy": "144",
                    "r": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "80",
                    "cy": "256",
                    "r": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "80",
                    "cy": "368",
                    "r": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function IoListSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M144 144h320M144 256h320M144 368h320"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M64 128h32v32H64zm0 112h32v32H64zm0 112h32v32H64z"
                }
            }
        ]
    })(props);
}
function IoList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M160 144h288M160 256h288M160 368h288"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "80",
                    "cy": "144",
                    "r": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "80",
                    "cy": "256",
                    "r": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "80",
                    "cy": "368",
                    "r": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function IoLocateOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M256 96V56m0 400v-40"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 112a144 144 0 10144 144 144 144 0 00-144-144z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M416 256h40m-400 0h40"
                }
            }
        ]
    })(props);
}
function IoLocateSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M256 96V56m0 400v-40m0-304a144 144 0 10144 144 144 144 0 00-144-144zm160 144h40m-400 0h40"
                }
            }
        ]
    })(props);
}
function IoLocate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M256 96V56m0 400v-40m0-304a144 144 0 10144 144 144 144 0 00-144-144zm160 144h40m-400 0h40"
                }
            }
        ]
    })(props);
}
function IoLocationOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 48c-79.5 0-144 61.39-144 137 0 87 96 224.87 131.25 272.49a15.77 15.77 0 0025.5 0C304 409.89 400 272.07 400 185c0-75.61-64.5-137-144-137z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "192",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function IoLocationSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C167.67 32 96 96.51 96 176c0 128 160 304 160 304s160-176 160-304c0-79.49-71.67-144-160-144zm0 224a64 64 0 1164-64 64.07 64.07 0 01-64 64z"
                }
            }
        ]
    })(props);
}
function IoLocation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "192",
                    "r": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32c-88.22 0-160 68.65-160 153 0 40.17 18.31 93.59 54.42 158.78 29 52.34 62.55 99.67 80 123.22a31.75 31.75 0 0051.22 0c17.42-23.55 51-70.88 80-123.22C397.69 278.61 416 225.19 416 185c0-84.35-71.78-153-160-153zm0 224a64 64 0 1164-64 64.07 64.07 0 01-64 64z"
                }
            }
        ]
    })(props);
}
function IoLockClosedOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M336 208v-95a80 80 0 00-160 0v95"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "320",
                    "height": "272",
                    "x": "96",
                    "y": "208",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48"
                }
            }
        ]
    })(props);
}
function IoLockClosedSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M420 192h-68v-80a96 96 0 10-192 0v80H92a12 12 0 00-12 12v280a12 12 0 0012 12h328a12 12 0 0012-12V204a12 12 0 00-12-12zm-106 0H198v-80.75a58 58 0 11116 0z"
                }
            }
        ]
    })(props);
}
function IoLockClosed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 192h-16v-80a96 96 0 10-192 0v80h-16a64.07 64.07 0 00-64 64v176a64.07 64.07 0 0064 64h224a64.07 64.07 0 0064-64V256a64.07 64.07 0 00-64-64zm-48 0H192v-80a64 64 0 11128 0z"
                }
            }
        ]
    })(props);
}
function IoLockOpenOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M336 112a80 80 0 00-160 0v96"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "320",
                    "height": "272",
                    "x": "96",
                    "y": "208",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48"
                }
            }
        ]
    })(props);
}
function IoLockOpenSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M420 192H198v-80.75a58.08 58.08 0 0199.07-41.07A59.4 59.4 0 01314 112h38a96 96 0 10-192 0v80H92a12 12 0 00-12 12v280a12 12 0 0012 12h328a12 12 0 0012-12V204a12 12 0 00-12-12z"
                }
            }
        ]
    })(props);
}
function IoLockOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 192H192v-80a64 64 0 11128 0 16 16 0 0032 0 96 96 0 10-192 0v80h-16a64.07 64.07 0 00-64 64v176a64.07 64.07 0 0064 64h224a64.07 64.07 0 0064-64V256a64.07 64.07 0 00-64-64z"
                }
            }
        ]
    })(props);
}
function IoLogInOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M192 176v-40a40 40 0 0140-40h160a40 40 0 0140 40v240a40 40 0 01-40 40H240c-22.09 0-48-17.91-48-40v-40"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M288 336l80-80-80-80M80 256h272"
                }
            }
        ]
    })(props);
}
function IoLogInSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 80H192a16 16 0 00-16 16v144h153.37l-64-64L288 153.37l91.31 91.32a16 16 0 010 22.62L288 358.63 265.37 336l64-64H176v144a16 16 0 0016 16h240a16 16 0 0016-16V96a16 16 0 00-16-16zM64 240h112v32H64z"
                }
            }
        ]
    })(props);
}
function IoLogIn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392 80H232a56.06 56.06 0 00-56 56v104h153.37l-52.68-52.69a16 16 0 0122.62-22.62l80 80a16 16 0 010 22.62l-80 80a16 16 0 01-22.62-22.62L329.37 272H176v104c0 32.05 33.79 56 64 56h152a56.06 56.06 0 0056-56V136a56.06 56.06 0 00-56-56zM80 240a16 16 0 000 32h96v-32z"
                }
            }
        ]
    })(props);
}
function IoLogOutOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M304 336v40a40 40 0 01-40 40H104a40 40 0 01-40-40V136a40 40 0 0140-40h152c22.09 0 48 17.91 48 40v40m64 160l80-80-80-80m-192 80h256"
                }
            }
        ]
    })(props);
}
function IoLogOutSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 240h160V96a16 16 0 00-16-16H64a16 16 0 00-16 16v320a16 16 0 0016 16h240a16 16 0 0016-16V272H160zm299.31 4.69L368 153.37 345.37 176l64 64H320v32h89.37l-64 64L368 358.63l91.31-91.32a16 16 0 000-22.62z"
                }
            }
        ]
    })(props);
}
function IoLogOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 256a16 16 0 0116-16h144V136c0-32-33.79-56-64-56H104a56.06 56.06 0 00-56 56v240a56.06 56.06 0 0056 56h160a56.06 56.06 0 0056-56V272H176a16 16 0 01-16-16zm299.31-11.31l-80-80a16 16 0 00-22.62 22.62L409.37 240H320v32h89.37l-52.68 52.69a16 16 0 1022.62 22.62l80-80a16 16 0 000-22.62z"
                }
            }
        ]
    })(props);
}
function IoLogoAlipay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M102.41 32C62.38 32 32 64.12 32 103.78v304.45C32 447.86 64.38 480 104.41 480h303.2c40 0 72.39-32.14 72.39-71.77v-3.11c-1.35-.56-115.47-48.57-174.5-76.7-39.82 48.57-91.18 78-144.5 78-90.18 0-120.8-78.22-78.1-129.72 9.31-11.22 25.15-21.94 49.73-28 38.45-9.36 99.64 5.85 157 24.61a309.41 309.41 0 0025.46-61.67H138.34V194h91.13v-31.83H119.09v-17.75h110.38V99s0-7.65 7.82-7.65h44.55v53H391v17.75H281.84V194h89.08a359.41 359.41 0 01-37.72 94.43c27 9.69 49.31 18.88 67.39 24.89 60.32 20 77.23 22.45 79.41 22.7V103.78C480 64.12 447.6 32 407.61 32h-305.2zM152 274.73q-5.81.06-11.67.63c-11.3 1.13-32.5 6.07-44.09 16.23-34.74 30-13.94 84.93 56.37 84.93 40.87 0 81.71-25.9 113.79-67.37-41.36-20-77-34.85-114.4-34.42z"
                }
            }
        ]
    })(props);
}
function IoLogoAmazon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48.48 378.73a300.52 300.52 0 00152.89 95.92 262.57 262.57 0 00159.3-17.25 225.52 225.52 0 0066.79-47 6.36 6.36 0 00-2-8.53 11.76 11.76 0 00-8-.05 401.92 401.92 0 01-116.55 39.34 358.13 358.13 0 01-127.29-8.83 446.73 446.73 0 01-119.1-60.49 5 5 0 00-6.06 6.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M387.15 388.44a168.11 168.11 0 0148.94-2.23l.67.13a10 10 0 017.37 12.05A204.71 204.71 0 01429 444.47a2.55 2.55 0 001.66 3.18 2.51 2.51 0 002.23-.37A83.31 83.31 0 00464 382.86a12.44 12.44 0 00-10.22-13.22A95.75 95.75 0 00384.91 384a2.55 2.55 0 00-.57 3.55 2.52 2.52 0 002.81.89zm-82.91-63.52a164 164 0 01-28.92 25.3A135.16 135.16 0 01208.63 369a99.49 99.49 0 01-57.49-19.85 97.25 97.25 0 01-27.36-100.28 112.35 112.35 0 0165.3-69.06 367.67 367.67 0 01104.7-15.55V127A37.82 37.82 0 00261 94.72a59.9 59.9 0 00-31.17 4.08 48.89 48.89 0 00-27.13 34.67 12 12 0 01-12.58 6.72l-50.9-4.5a11.38 11.38 0 01-8.38-10.16 103.66 103.66 0 0136.61-63.45A143.86 143.86 0 01257.85 32a146.24 146.24 0 0184.27 27.67 86.82 86.82 0 0130.7 70.22V258.8a84.46 84.46 0 008 31.28l15.87 23.23a13 13 0 010 11.23l-46.99 39.71a12.5 12.5 0 01-12.68-.44 244.84 244.84 0 01-32.78-38.89zm-10.6-116.83a257.68 257.68 0 00-44 2.89A63 63 0 00208 242.54a63 63 0 003.07 54 40.6 40.6 0 0047.11 12.19 78.61 78.61 0 0035.46-55.58v-45.06"
                }
            }
        ]
    })(props);
}
function IoLogoAmplify(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M112.31 268l40.36-68.69 34.65 59-67.54 115h135L289.31 432H16zm58.57-99.76l33.27-56.67L392.44 432h-66.68zM222.67 80h66.59L496 432h-66.68z"
                }
            }
        ]
    })(props);
}
function IoLogoAndroid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M380.91 199l42.47-73.57a8.63 8.63 0 00-3.12-11.76 8.52 8.52 0 00-11.71 3.12l-43 74.52c-32.83-15-69.78-23.35-109.52-23.35s-76.69 8.36-109.52 23.35l-43-74.52a8.6 8.6 0 10-14.88 8.64L131 199C57.8 238.64 8.19 312.77 0 399.55h512c-8.19-86.78-57.8-160.91-131.09-200.55zM138.45 327.65a21.46 21.46 0 1121.46-21.46 21.47 21.47 0 01-21.46 21.46zm235 0A21.46 21.46 0 11395 306.19a21.47 21.47 0 01-21.51 21.46z"
                }
            }
        ]
    })(props);
}
function IoLogoAngular(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M213.57 256h84.85l-42.43-89.36L213.57 256z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32L32 112l46.12 272L256 480l177.75-96L480 112zm88 320l-26.59-56H194.58L168 352h-40L256 72l128 280z"
                }
            }
        ]
    })(props);
}
function IoLogoAppleAppstore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C132.26 32 32 132.26 32 256s100.26 224 224 224 224-100.26 224-224S379.74 32 256 32zm-85 321.89a15.48 15.48 0 01-13.46 7.65 14.91 14.91 0 01-7.86-2.16 15.48 15.48 0 01-5.6-21.21l15.29-25.42a8.73 8.73 0 017.54-4.3h2.26c11.09 0 18.85 6.67 21.11 13.13zm129.45-50l-100.13.11h-66.55a15.46 15.46 0 01-15.51-16.15c.32-8.4 7.65-14.76 16-14.76h48.24l57.19-97.35-18.52-31.55C217 137 218.85 127.52 226 123a15.57 15.57 0 0121.87 5.17l9.9 16.91h.11l9.91-16.91A15.58 15.58 0 01289.6 123c7.11 4.52 8.94 14 4.74 21.22l-18.52 31.55-18 30.69-39.09 66.66v.11h57.61c7.22 0 16.27 3.88 19.93 10.12l.32.65c3.23 5.49 5.06 9.26 5.06 14.75a13.82 13.82 0 01-1.17 5.17zm77.75.11h-27.11v.11l19.82 33.71a15.8 15.8 0 01-5.17 21.53 15.53 15.53 0 01-8.08 2.27A15.71 15.71 0 01344.2 354l-29.29-49.86-18.2-31L273.23 233a38.35 38.35 0 01-.65-38c4.64-8.19 8.19-10.34 8.19-10.34L333 273h44.91c8.4 0 15.61 6.46 16 14.75A15.65 15.65 0 01378.23 304z"
                }
            }
        ]
    })(props);
}
function IoLogoAppleAr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M201.14 64L256 32l54.86 32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 32v80"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M310.86 448L256 480l-54.86-32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 480v-80"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M64 207.51V144l53.15-31.51"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M64 144l67.29 40"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M448 304.49V368l-53.15 31.51"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 368l-67.29-40"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M117.15 400L64 368v-63.51"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M64 368l66.64-40"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M394.85 112.49L448 144v63.51"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 144l-67.29 40M256 320v-64l54.86-32M256 256l-54.86-32"
                }
            }
        ]
    })(props);
}
function IoLogoApple(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M349.13 136.86c-40.32 0-57.36 19.24-85.44 19.24-28.79 0-50.75-19.1-85.69-19.1-34.2 0-70.67 20.88-93.83 56.45-32.52 50.16-27 144.63 25.67 225.11 18.84 28.81 44 61.12 77 61.47h.6c28.68 0 37.2-18.78 76.67-19h.6c38.88 0 46.68 18.89 75.24 18.89h.6c33-.35 59.51-36.15 78.35-64.85 13.56-20.64 18.6-31 29-54.35-76.19-28.92-88.43-136.93-13.08-178.34-23-28.8-55.32-45.48-85.79-45.48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M340.25 32c-24 1.63-52 16.91-68.4 36.86-14.88 18.08-27.12 44.9-22.32 70.91h1.92c25.56 0 51.72-15.39 67-35.11 14.72-18.77 25.88-45.37 21.8-72.66z"
                }
            }
        ]
    })(props);
}
function IoLogoBehance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344.1 233.6c-28.9 0-32.9 28.8-32.9 28.8h61.4s.4-28.8-28.5-28.8zm-139.3 28.8h-54.4v50h51.7c7.8-.2 22.4-2.4 22.4-24.3 0-26-19.7-25.7-19.7-25.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C132.3 32 32 132.3 32 256s100.3 224 224 224 224-100.3 224-224S379.7 32 256 32zm47.2 137.6h77.1v23h-77.1v-23zm-39 120.8c0 57-59.4 55.2-59.4 55.2h-97.2v-187h97.2c29.6 0 52.9 16.3 52.9 49.8S229.2 244 229.2 244c37.6 0 35 46.4 35 46.4zm144.2-3.1h-96.9c0 34.7 32.9 32.5 32.9 32.5 31.1 0 30-20.1 30-20.1h32.9c0 53.4-64 49.7-64 49.7-76.7 0-71.8-71.5-71.8-71.5s-.1-71.8 71.8-71.8c75.7.1 65.1 81.2 65.1 81.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M218 211.3c0-19.4-13.2-19.4-13.2-19.4h-54.4v41.7h51c8.8 0 16.6-2.9 16.6-22.3z"
                }
            }
        ]
    })(props);
}
function IoLogoBitbucket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.13 32.23a19.65 19.65 0 00-2.54-.23h-449C23 31.88 16.12 38.88 16 47.75a11.44 11.44 0 00.23 2.8l65.3 411.25a22.52 22.52 0 007 12.95A20 20 0 00102 480h313.18a15.45 15.45 0 0015.34-13.42l38.88-247.91H325.19l-18.46 112H205.21l-25.73-148h295.58l20.76-132c1.27-8.75-4.38-17.04-12.69-18.44z"
                }
            }
        ]
    })(props);
}
function IoLogoBitcoin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M410.47 279.2c-5-11.5-12.7-21.6-28.1-30.1a98.15 98.15 0 00-25.4-10 62.22 62.22 0 0016.3-11 56.37 56.37 0 0015.6-23.3 77.11 77.11 0 003.5-28.2c-1.1-16.8-4.4-33.1-13.2-44.8s-21.2-20.7-37.6-27c-12.6-4.8-25.5-7.8-45.5-8.9V32h-40v64h-32V32h-41v64H96v48h27.87c8.7 0 14.6.8 17.6 2.3a13.22 13.22 0 016.5 6c1.3 2.5 1.9 8.4 1.9 17.5V343c0 9-.6 14.8-1.9 17.4s-2 4.9-5.1 6.3-3.2 1.3-11.8 1.3h-26.4L96 416h87v64h41v-64h32v64h40v-64.4c26-1.3 44.5-4.7 59.4-10.3 19.3-7.2 34.1-17.7 44.7-31.5s14-34.9 14.93-51.2c.67-14.5-.03-33.2-4.56-43.4zM224 150h32v74h-32zm0 212v-90h32v90zm72-208.1c6 2.5 9.9 7.5 13.8 12.7 4.3 5.7 6.5 13.3 6.5 21.4 0 7.8-2.9 14.5-7.5 20.5-3.8 4.9-6.8 8.3-12.8 11.1zm28.8 186.7c-7.8 6.9-12.3 10.1-22.1 13.8a56.06 56.06 0 01-6.7 1.9v-82.8a40.74 40.74 0 0111.3 3.4c7.8 3.3 15.2 6.9 19.8 13.2a43.82 43.82 0 018 24.7c-.03 10.9-2.83 19.2-10.33 25.8z"
                }
            }
        ]
    })(props);
}
function IoLogoBuffer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M39.93 149.25l197.4 95.32c5.14 2.45 12 3.73 18.79 3.73s13.65-1.28 18.78-3.73l197.4-95.32c10.38-5 10.38-13.18 0-18.2L274.9 35.73c-5.13-2.45-12-3.73-18.78-3.73s-13.65 1.28-18.79 3.73l-197.4 95.32c-10.38 5.02-10.38 13.18 0 18.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M472.3 246.9s-36.05-17.38-40.83-19.72-6.07-2.21-11.09.12-145.6 70.23-145.6 70.23a45.71 45.71 0 01-18.78 3.74c-6.77 0-13.65-1.29-18.78-3.74 0 0-136.85-66-143.27-69.18C87 225 85 225 78.67 228l-39 18.78c-10.38 5-10.38 13.19 0 18.2L237.1 360.3c5.13 2.45 12 3.73 18.78 3.73s13.65-1.28 18.79-3.73l197.4-95.3c10.61-4.92 10.61-13.08.23-18.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M472.3 362.75s-36.05-17.38-40.83-19.75-6.07-2.21-11.09.12S274.9 413.5 274.9 413.5a45.74 45.74 0 01-18.78 3.73c-6.77 0-13.65-1.28-18.79-3.73 0 0-136.85-66-143.26-69.18-7-3.39-9-3.39-15.29-.35l-39 18.78c-10.39 5-10.39 13.18 0 18.2l197.4 95.32c5.13 2.56 12 3.73 18.78 3.73s13.65-1.28 18.78-3.73L472.18 381c10.5-5.07 10.5-13.23.12-18.25z"
                }
            }
        ]
    })(props);
}
function IoLogoCapacitor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 101.09L372.37 208.72l106.86 107.06-69.3 69.3-283.22-283.23L196 32.54l107.07 106.88L410.67 32zM32.55 196l69.3-69.31 283.22 283.24-69.3 69.3-107-106.87L101.08 480 32 410.67l107.42-107.61z"
                }
            }
        ]
    })(props);
}
function IoLogoChrome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M188.8 255.93a67.2 67.2 0 1067.2-67.18 67.38 67.38 0 00-67.2 67.18z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M476.75 217.79v.05a206.63 206.63 0 00-7-28.84h-.11a202.16 202.16 0 017.07 29 203.5 203.5 0 00-7.07-29h-155.4c19.05 17 31.36 40.17 31.36 67.05a86.55 86.55 0 01-12.31 44.73L231 478.45a2.44 2.44 0 010 .27v.28-.26a224 224 0 0025 1.26c6.84 0 13.61-.39 20.3-1a222.91 222.91 0 0029.78-4.74C405.68 451.52 480 362.4 480 255.94a225.25 225.25 0 00-3.25-38.15z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 345.5c-33.6 0-61.6-17.91-77.29-44.79L76 123.05l-.14-.24A224 224 0 00207.4 474.55v-.05l77.69-134.6a84.13 84.13 0 01-29.09 5.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M91.29 104.57l77.35 133.25A89.19 89.19 0 01256 166h205.17a246.51 246.51 0 00-25.78-43.94l.12.08A245.26 245.26 0 01461.17 166h.17a245.91 245.91 0 00-25.66-44 2.63 2.63 0 01-.35-.26 223.93 223.93 0 00-344.19-17.4l.14.24z"
                }
            }
        ]
    })(props);
}
function IoLogoClosedCaptioning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 80v352h512V80zm464 175.78c0 25.74-1.6 45.32-3.77 77.22s-19.2 54.34-59.09 57.86-95.77 3.85-145.14 3.74c-49 .11-105.14-.11-145.14-3.74s-56.8-26-59.09-57.86S48 281.52 48 255.78s.11-42.46 3.77-77.22 23-54.12 59.09-57.64 98.28-3.52 145.14-3.52 109 0 145.14 3.52 55.43 23 59.09 57.64 3.77 51.59 3.77 77.22z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M367.57 282.84v.77c0 17.93-11.11 28.49-25.95 28.49s-24.84-11.88-26.27-28.49c0 0-1.31-8.69-1.31-26.29a229.5 229.5 0 011.53-28.6c2.64-18.7 11.77-28.49 26.6-28.49s26.49 12.76 26.49 32.12v.55h49.58c0-24.09-6.05-45.76-18.25-59.4S369.76 153 345.8 153a108.06 108.06 0 00-33 4.73 58.82 58.82 0 00-25.94 16.61c-7.23 7.96-12.86 18.52-16.86 31.83s-6 30-6 50.27c0 19.8 1.65 36.3 4.84 49.61s8 23.87 14.4 31.79a49.76 49.76 0 0024 16.5q14.5 4.62 34 4.62c27.47 0 47.26-7 59.13-20.57S418 305.06 418 279.1h-50.65c.22 0 .22 2.75.22 3.74zm-170.27 0v.77c0 17.93-11.1 28.49-25.94 28.49s-24.84-11.88-26.27-28.49c0 0-1.31-8.69-1.31-26.29a229.5 229.5 0 011.53-28.6c2.64-18.7 11.77-28.49 26.6-28.49S198.4 213 198.4 232.35v.55H248c0-24.09-6-45.76-18.25-59.4S199.5 153 175.54 153a108.06 108.06 0 00-33 4.73 58.82 58.82 0 00-25.94 16.61c-7.26 7.92-12.86 18.48-16.93 31.79s-6 30-6 50.27c0 19.8 1.65 36.3 4.84 49.61s8 23.87 14.4 31.79a49.76 49.76 0 0024 16.5q14.51 4.62 34 4.62c27.48 0 47.27-7 59.14-20.57s17.81-33.33 17.81-59.29h-50.78c.22.04.22 2.79.22 3.78z"
                }
            }
        ]
    })(props);
}
function IoLogoCodepen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M241.24 303.94c-15.32-10.36-30.74-20.57-46.06-30.93-2-1.38-3.43-1.48-5.5 0l-38.88 26.12C182 319.9 244 361.32 244 361.32v-53.79c0-1.22-1.55-2.78-2.76-3.59zm-46.15-63.27q23.19-15.24 46.11-30.86a7.54 7.54 0 002.8-5.34v-51.7s-62 41.12-93.26 61.94c13.7 9.16 26.67 17.91 39.78 26.44 1.02.66 3.4.28 4.57-.48zm74.75-31.32q23.71 16.07 47.63 31.82a4.3 4.3 0 003.83 0l39.76-26.47L268 152.48v53.35a4.79 4.79 0 001.84 3.52zm-11.73 21.02a5.27 5.27 0 00-4.74.17c-4.82 3-9.47 6.2-14.17 9.35-8.25 5.53-25.35 17-25.35 17l38.84 25.86a6.18 6.18 0 006.26.11l39-26s-34.07-22.66-39.84-26.49zM141 237.12v39.61l29.62-19.84L141 237.12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C132.29 32 32 132.29 32 256s100.29 224 224 224 224-100.29 224-224S379.71 32 256 32zm139 265c0 5.78-2.65 9.86-7.51 13.09q-61.71 41-123.29 82.19c-5.85 3.92-11.17 3.75-17-.14q-61.17-41-122.63-81.67c-5.11-3.39-7.59-7.56-7.59-13.73V217c0-6.14 2.52-10.34 7.62-13.72 40.91-27.13 81.94-54.36 122.73-81.68 5.82-3.89 11.09-4 16.94-.09q61.54 41.21 123.26 82.19c4.68 3.11 7.45 6.95 7.45 12.66z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M316.25 273.23q-22.59 15.34-45.39 30.34c-2.41 1.58-2.89 3.31-2.86 6.19v51.34l93-62-38.53-25.88c-2.3-1.61-3.89-1.57-6.22.01zm53.75 3.45v-39.62l-29.59 19.87L370 276.68z"
                }
            }
        ]
    })(props);
}
function IoLogoCss3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32l35 403.22L255.77 480 413 435.15 448 32zm290.68 334.9L256.07 395l-98.46-28.24-6.75-77.76h48.26l3.43 39.56 53.59 15.16.13.28 53.47-14.85 5.64-64.15H203l-4-50h120.65l4.35-51H140l-4-49h240.58z"
                }
            }
        ]
    })(props);
}
function IoLogoDesignernews(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M295.31 122.8L222.86 64l72.68 122.64-.23-63.84z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M339.43 64v195.6h-41.6L225.6 141.28l1.94 118.32h-45.83V131.2L139.09 96c1.14 1.44 2.28 2.88 3.31 4.44 11.43 16.68 17.14 36.6 17.14 60.6 0 59-35 98.52-87.88 98.52H0v.48L228.11 448H512V205.72z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M111.89 162.52c0-34.8-16.23-54.12-45.38-54.12H44.57v106.8h21.72c29.71 0 45.6-18.48 45.6-52.68z"
                }
            }
        ]
    })(props);
}
function IoLogoDeviantart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408 103.28V16h-89.31l-8.9 8.78-42.15 78.48-13.25 8.74H104v119.85h82.68l7.36 8.71L104 408.72V496h89.3l8.91-8.79 42.14-78.48 13.26-8.73H408V280.13h-82.68l-7.36-8.75L408 103.28z"
                }
            }
        ]
    })(props);
}
function IoLogoDiscord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 66.52A50 50 0 00414.12 17L97.64 16A49.65 49.65 0 0048 65.52V392c0 27.3 22.28 48 49.64 48H368l-13-44 109 100zM324.65 329.81s-8.72-10.39-16-19.32C340.39 301.55 352.5 282 352.5 282a139 139 0 01-27.85 14.25 173.31 173.31 0 01-35.11 10.39 170.05 170.05 0 01-62.72-.24 184.45 184.45 0 01-35.59-10.4 141.46 141.46 0 01-17.68-8.21c-.73-.48-1.45-.72-2.18-1.21-.49-.24-.73-.48-1-.48-4.36-2.42-6.78-4.11-6.78-4.11s11.62 19.09 42.38 28.26c-7.27 9.18-16.23 19.81-16.23 19.81-53.51-1.69-73.85-36.47-73.85-36.47 0-77.06 34.87-139.62 34.87-139.62 34.87-25.85 67.8-25.12 67.8-25.12l2.42 2.9c-43.59 12.32-63.44 31.4-63.44 31.4s5.32-2.9 14.28-6.77c25.91-11.35 46.5-14.25 55-15.21a24 24 0 014.12-.49 205.62 205.62 0 0148.91-.48 201.62 201.62 0 0172.89 22.95s-19.13-18.15-60.3-30.45l3.39-3.86s33.17-.73 67.81 25.16c0 0 34.87 62.56 34.87 139.62 0-.28-20.35 34.5-73.86 36.19z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M212.05 218c-13.8 0-24.7 11.84-24.7 26.57s11.14 26.57 24.7 26.57c13.8 0 24.7-11.83 24.7-26.57.25-14.76-10.9-26.57-24.7-26.57zm88.38 0c-13.8 0-24.7 11.84-24.7 26.57s11.14 26.57 24.7 26.57c13.81 0 24.7-11.83 24.7-26.57S314 218 300.43 218z"
                }
            }
        ]
    })(props);
}
function IoLogoDocker(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M507 211.16c-1.42-1.19-14.25-10.94-41.79-10.94a132.55 132.55 0 00-21.61 1.9c-5.22-36.4-35.38-54-36.57-55l-7.36-4.28-4.75 6.9a101.65 101.65 0 00-13.06 30.45c-5 20.7-1.9 40.2 8.55 56.85-12.59 7.14-33 8.8-37.28 9H15.94A15.93 15.93 0 000 262.07a241.25 241.25 0 0014.75 86.83C26.39 379.35 43.72 402 66 415.74 91.22 431.2 132.3 440 178.6 440a344.23 344.23 0 0062.45-5.71 257.44 257.44 0 0081.69-29.73 223.55 223.55 0 0055.57-45.67c26.83-30.21 42.74-64 54.38-94h4.75c29.21 0 47.26-11.66 57.23-21.65a63.31 63.31 0 0015.2-22.36l2.14-6.18z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M47.29 236.37H92.4a4 4 0 004-4v-40.48a4 4 0 00-4-4H47.29a4 4 0 00-4 4v40.44a4.16 4.16 0 004 4m62.21.04h45.12a4 4 0 004-4v-40.48a4 4 0 00-4-4H109.5a4 4 0 00-4 4v40.44a4.16 4.16 0 004 4m63.4.04H218a4 4 0 004-4v-40.48a4 4 0 00-4-4h-45.1a4 4 0 00-4 4v40.44a3.87 3.87 0 004 4m62.46.04h45.12a4 4 0 004-4v-40.48a4 4 0 00-4-4h-45.12a4 4 0 00-4 4v40.44a4 4 0 004 4M109.5 178.57h45.12a4.16 4.16 0 004-4v-40.48a4 4 0 00-4-4H109.5a4 4 0 00-4 4v40.44a4.34 4.34 0 004 4m63.4.04H218a4.16 4.16 0 004-4v-40.48a4 4 0 00-4-4h-45.1a4 4 0 00-4 4v40.44a4 4 0 004 4m62.46.04h45.12a4.16 4.16 0 004-4v-40.48a4.16 4.16 0 00-4-4h-45.12a4 4 0 00-4 4v40.44a4.16 4.16 0 004 4m0-58h45.12a4 4 0 004-4V76a4.16 4.16 0 00-4-4h-45.12a4 4 0 00-4 4v40.44a4.17 4.17 0 004 4m62.92 115.93h45.12a4 4 0 004-4v-40.48a4 4 0 00-4-4h-45.12a4 4 0 00-4 4v40.44a4.16 4.16 0 004 4"
                }
            }
        ]
    })(props);
}
function IoLogoDribbble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C132.33 32 32 132.33 32 256s100.33 224 224 224 224-100.22 224-224S379.67 32 256 32zm142.22 103.25a186.36 186.36 0 0144 108.38c-40.37-2.1-88.67-2.1-127.4 1.52-4.9-12.37-9.92-24.5-15.4-36.17 44.66-19.36 79.08-44.8 98.8-73.73zM256 69.33a185.81 185.81 0 01119.12 42.94c-20.3 25.66-52.15 48-91.82 64.86C261.6 137 236.63 102.47 210 75.28a187.51 187.51 0 0146-5.95zm-84.47 20.42c26.95 26.83 52.27 61 74.44 101C203.85 203.62 155.55 211 104 211c-9.8 0-19.36-.35-28.81-.94a186.78 186.78 0 0196.34-120.31zM69.68 247.13c10.62.47 21.35.7 32.2.59 58.8-.7 113.52-9.92 160.54-25q6.65 13.83 12.6 28.35a115.43 115.43 0 00-16.69 5c-64.28 27-114.91 70.51-142.33 123.13A186 186 0 0169.33 256c0-3 .12-5.95.35-8.87zM256 442.67a185.57 185.57 0 01-114.45-39.32c24.85-49.23 69.18-90 125.07-115.27 5.25-2.45 12.25-4.43 20.3-6.18q10 27.64 17.85 57.4A678 678 0 01322 430.42a185.06 185.06 0 01-66 12.25zm100.92-29.75a672.61 672.61 0 00-17.39-92.05c-4-15.17-8.51-29.87-13.41-44.22 36.63-3 80.5-2.57 115.38 0a186.5 186.5 0 01-84.58 136.27z"
                }
            }
        ]
    })(props);
}
function IoLogoDropbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.32 126.24l-120.16 78.25 120.16 78.24L136.16 361 16 282.08l120.16-78.24L16 126.24 136.16 48zm-120.8 259.52l120.16-78.25 120.16 78.25L255.68 464zm120.8-103.68l120.16-78.24-120.16-77.6L375.84 48 496 126.24l-120.16 78.25L496 282.73 375.84 361z"
                }
            }
        ]
    })(props);
}
function IoLogoEdge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.5 15c-132 0-240 108-240 240s108 240 240 240c85.4 0 160.8-45.2 203.3-112.9a6.87 6.87 0 00-9.1-9.7 108.64 108.64 0 01-18.4 8.6c-36.8 12.6-57.1 13.1-82.1 12-27.9-1.2-61.9-10.8-85.8-25s-43.5-34.6-54.1-52.3-17-39.9-14.1-68.3c2.9-29 29.4-52.6 60.4-52.6 33.5 0 60.8 26.6 60.8 60.1 0 17-8.1 31.7-18.5 43.5-2.3 2.1-7.6 9.7 5.8 20 15.9 12.2 51.6 18 79.9 16.6s59.1-12.6 80.2-34.8c16.8-17.7 31.8-46.1 31.8-77.4C495.5 97.7 379.5 15 255.5 15z"
                }
            }
        ]
    })(props);
}
function IoLogoElectron(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M86.76 255a9.89 9.89 0 004.87-1.29 9.82 9.82 0 003.65-13.43c-16.46-28.56-17.81-52.12-7.45-70 14.26-24.57 53.61-33.65 105.27-24.29a9.86 9.86 0 0011.45-7.9 9.84 9.84 0 00-7.93-11.44c-29.19-5.28-56-5.18-77.39.3-22.3 5.71-39 17.28-48.45 33.48-14 24.19-12.7 54.73 7.42 89.62a9.85 9.85 0 008.56 4.95zm274.85-111.27c32.24.42 52.61 9.31 62.79 26.86 14.21 24.48 2.52 62.81-31.27 102.52a9.82 9.82 0 007.51 16.18 9.88 9.88 0 007.52-3.46c19.12-22.47 32.35-45.54 38.25-66.71 6.14-22 4.43-42.21-5-58.38-13.8-23.78-40.13-36.15-79.59-36.67h-.14a9.83 9.83 0 00-.12 19.66zm-35.14 271.16a9.88 9.88 0 00-13.5 3.35c-16.41 27.15-36.57 42.1-56.77 42.1-28.49 0-56-29.31-73.73-78.42a9.87 9.87 0 00-12.59-5.92 9.83 9.83 0 00-6 12.58c10 27.77 23.47 50.75 39 66.46 16.11 16.34 34.55 25 53.32 25 27.38 0 53.54-18.33 73.65-51.61a9.81 9.81 0 00-3.38-13.5zm105.23-76.35a32.14 32.14 0 00-29.9 44.33c-41.8 19.5-119.8 4.79-191.87-36.62-32.91-18.9-62.16-41.86-84.6-66.39a9.9 9.9 0 00-13.91-.65 9.8 9.8 0 00-.65 13.9c23.79 26 54.68 50.28 89.33 70.18 40.28 23.13 82.27 38.63 121.43 44.81a225.54 225.54 0 0035 2.91c23.12 0 43-4.3 58.51-12.79a32.2 32.2 0 1016.7-59.68zm0 44.66a12.6 12.6 0 01-7.82-2.72 10 10 0 00-2.2-2.21 12.61 12.61 0 1110 4.93z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M82.09 338.59c.57-21.26 12.41-47 33.68-73.16 23.19-28.45 56.69-56 94.34-77.65 33.25-19.1 65.2-31.9 98.07-38.91a9.83 9.83 0 10-4.12-19.22c-34.85 7.43-68.78 21-103.79 41.09C116.09 219.09 59.9 289.88 62.46 343.9a32.32 32.32 0 1019.63-5.31zM80.3 383.2a12.5 12.5 0 1112.59-12.5 12.56 12.56 0 01-12.59 12.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256.2 96.32a32.23 32.23 0 0026.53-13.81c17.89 11.69 34 35 45.81 66.12 13 34.39 19.84 75.38 19.84 118.54 0 37.18-5.19 72.35-15 103.6a9.72 9.72 0 00.66 7.49 9.82 9.82 0 005.8 4.84 9.89 9.89 0 0012.34-6.44c10.42-33.14 15.93-70.34 15.93-109.49 0-47.17-7.77-91.77-22.47-129-14.41-36.48-34.13-62.4-57.14-75.16a32.3 32.3 0 10-32.3 33.31zm0-44.66a12.5 12.5 0 11-12.59 12.5 12.56 12.56 0 0112.59-12.5zm-5.2 191.7a24.35 24.35 0 005.16 48.16 24.68 24.68 0 005.16-.55A24.36 24.36 0 10251 243.36z"
                }
            }
        ]
    })(props);
}
function IoLogoEuro(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M231.8 272v-48H376l8-48H231.8v-8.12c0-38.69 16.47-62.56 87.18-62.56 28.89 0 61.45 2.69 102.5 9.42l10.52-70A508.54 508.54 0 00315.46 32C189.26 32 135 76.4 135 158.46V176H80v48h55v48H80v48h55v33.54C135 435.6 189.23 480 315.43 480a507.76 507.76 0 00116.44-12.78l-10.58-70c-41.05 6.73-73.46 9.42-102.35 9.42-70.7 0-87.14-20.18-87.14-67.94V320h128.47l7.87-48z"
                }
            }
        ]
    })(props);
}
function IoLogoFacebook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M480 257.35c0-123.7-100.3-224-224-224s-224 100.3-224 224c0 111.8 81.9 204.47 189 221.29V322.12h-56.89v-64.77H221V208c0-56.13 33.45-87.16 84.61-87.16 24.51 0 50.15 4.38 50.15 4.38v55.13H327.5c-27.81 0-36.51 17.26-36.51 35v42h62.12l-9.92 64.77H291v156.54c107.1-16.81 189-109.48 189-221.31z"
                }
            }
        ]
    })(props);
}
function IoLogoFigma(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 176a80 80 0 000-160H176a80 80 0 000 160 80 80 0 000 160 80 80 0 1080 80V176z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "336",
                    "cy": "256",
                    "r": "80"
                }
            }
        ]
    })(props);
}
function IoLogoFirebase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M93.19 329.38l47.45-304.07c1.64-10.37 15.55-12.82 20.46-3.55l51 95.45zM432 400l-46.74-276.79a11 11 0 00-18.54-6L80 400l159.36 91.91a33.18 33.18 0 0031.91 0zM302.36 158.93l-36.54-69.54a10.86 10.86 0 00-19.36 0L85.83 375.74z"
                }
            }
        ]
    })(props);
}
function IoLogoFirefox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M471.46 194.62v-.07c-.22-.76-.45-1.52-.68-2.28-.05-.19-.11-.38-.17-.56-.43-1.44-.87-2.88-1.33-4.31l-.06-.2a223.24 223.24 0 00-10-25.56 191.77 191.77 0 00-12.9-23.8 225.15 225.15 0 00-74.74-73.74A222.9 222.9 0 00256 32c-7 0-14 .34-20.82 1-24.12 2.54-64.78 11.21-97.77 40.18C257.5 11.86 417.94 85.7 404.29 223c-4.86 49-46.46 82.67-85.19 88.35a73.73 73.73 0 01-20.8.21c-94.59-13.15-88.8-90.68-60.06-123.83-38-.24-67.47 46.79-53.15 93-32.95-61.18.35-157 70.93-186-82.95-12-160.71 28.2-185.7 98.07A330.23 330.23 0 0188.07 118s-45.22 35.74-54.44 110.9c-.14 1.16-.27 2.32-.39 3.49-.05.4-.09.8-.13 1.21q-.53 5.25-.8 10.57v.81c-.07 1.48-.13 3-.17 4.46v1.25c0 1.76-.07 3.52-.07 5.29 0 123.71 100.29 224 224 224S480 379.71 480 256a224 224 0 00-8.54-61.38z"
                }
            }
        ]
    })(props);
}
function IoLogoFlickr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C132.8 32 32 132.8 32 256s100.8 224 224 224 224-100.8 224-224S379.2 32 256 32zm-82.16 280A56 56 0 11228 257.84 56 56 0 01173.84 312zm168 0A56 56 0 11396 257.84 56 56 0 01341.84 312z"
                }
            }
        ]
    })(props);
}
function IoLogoFoursquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M376.76 32H138.54C105.67 32 96 56.8 96 72.41v379.64c0 17.59 9.42 24.12 14.72 26.27s19.91 4 28.67-6.17c0 0 112.47-130.89 114.4-132.83 2.92-2.93 2.92-2.93 5.84-2.93h72.77c30.58 0 35.49-21.87 38.69-34.75 2.65-10.79 32.48-164 42.45-212.56C421.14 52 411.74 32 376.76 32zm-5.67 269.64c2.65-10.79 32.48-164 42.45-212.56m-50.85 7.59l-10 51.73c-1.19 5.65-8.28 11.6-14.86 11.6h-95.92c-10.44 0-17.91 6.14-17.91 16.6v13.45c0 10.47 7.52 17.89 18 17.89h81.85c7.38 0 14.61 8.11 13 16s-9.09 46.57-10 50.89-5.84 11.72-14.61 11.72H248c-11.7 0-15.24 1.54-23.07 11.3s-78.26 94.59-78.26 94.59c-.71.82-1.41.58-1.41-.31V95.9c0-6.69 5.8-14.53 14.48-14.53h191.14a12.42 12.42 0 0111.81 15.3z"
                }
            }
        ]
    })(props);
}
function IoLogoGithub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C132.3 32 32 134.9 32 261.7c0 101.5 64.2 187.5 153.2 217.9a17.56 17.56 0 003.8.4c8.3 0 11.5-6.1 11.5-11.4 0-5.5-.2-19.9-.3-39.1a102.4 102.4 0 01-22.6 2.7c-43.1 0-52.9-33.5-52.9-33.5-10.2-26.5-24.9-33.6-24.9-33.6-19.5-13.7-.1-14.1 1.4-14.1h.1c22.5 2 34.3 23.8 34.3 23.8 11.2 19.6 26.2 25.1 39.6 25.1a63 63 0 0025.6-6c2-14.8 7.8-24.9 14.2-30.7-49.7-5.8-102-25.5-102-113.5 0-25.1 8.7-45.6 23-61.6-2.3-5.8-10-29.2 2.2-60.8a18.64 18.64 0 015-.5c8.1 0 26.4 3.1 56.6 24.1a208.21 208.21 0 01112.2 0c30.2-21 48.5-24.1 56.6-24.1a18.64 18.64 0 015 .5c12.2 31.6 4.5 55 2.2 60.8 14.3 16.1 23 36.6 23 61.6 0 88.2-52.4 107.6-102.3 113.3 8 7.1 15.2 21.1 15.2 42.5 0 30.7-.3 55.5-.3 63 0 5.4 3.1 11.5 11.4 11.5a19.35 19.35 0 004-.4C415.9 449.2 480 363.1 480 261.7 480 134.9 379.7 32 256 32z"
                }
            }
        ]
    })(props);
}
function IoLogoGitlab(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M494.07 281.6l-25.18-78.08a11 11 0 00-.61-2.1l-50.5-156.94a20.08 20.08 0 00-19.17-13.82 19.77 19.77 0 00-18.95 13.94l-48.14 149.55h-152L131.34 44.59a19.76 19.76 0 00-18.86-13.94h-.11a20.15 20.15 0 00-19.12 14L42.7 201.73c0 .14-.11.26-.16.4l-25.63 79.48a29.15 29.15 0 0010.44 32.46l221.44 162.41a11.25 11.25 0 0013.38-.07l221.48-162.34a29.13 29.13 0 0010.42-32.47m-331-64.51l61.73 191.76L76.63 217.09m209.64 191.8l59.19-183.84 2.55-8h86.52L300.47 390.44M398.8 59.31l43.37 134.83h-86.82M324.16 217l-43 133.58-25.66 79.56L186.94 217M112.27 59.31l43.46 134.83H69M40.68 295.58a6.19 6.19 0 01-2.21-6.9l19-59 139.61 180.59m273.26-114.69L313.92 410.22l.52-.69L453.5 229.64l19 59a6.2 6.2 0 01-2.19 6.92"
                }
            }
        ]
    })(props);
}
function IoLogoGooglePlaystore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 59.49v393a4.33 4.33 0 007.37 3.07L260 256 55.37 56.42A4.33 4.33 0 0048 59.49zM345.8 174L89.22 32.64l-.16-.09c-4.42-2.4-8.62 3.58-5 7.06l201.13 192.32zM84.08 472.39c-3.64 3.48.56 9.46 5 7.06l.16-.09L345.8 338l-60.61-57.95zM449.38 231l-71.65-39.46L310.36 256l67.37 64.43L449.38 281c19.49-10.77 19.49-39.23 0-50z"
                }
            }
        ]
    })(props);
}
function IoLogoGoogle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M473.16 221.48l-2.26-9.59H262.46v88.22H387c-12.93 61.4-72.93 93.72-121.94 93.72-35.66 0-73.25-15-98.13-39.11a140.08 140.08 0 01-41.8-98.88c0-37.16 16.7-74.33 41-98.78s61-38.13 97.49-38.13c41.79 0 71.74 22.19 82.94 32.31l62.69-62.36C390.86 72.72 340.34 32 261.6 32c-60.75 0-119 23.27-161.58 65.71C58 139.5 36.25 199.93 36.25 256s20.58 113.48 61.3 155.6c43.51 44.92 105.13 68.4 168.58 68.4 57.73 0 112.45-22.62 151.45-63.66 38.34-40.4 58.17-96.3 58.17-154.9 0-24.67-2.48-39.32-2.59-39.96z"
                }
            }
        ]
    })(props);
}
function IoLogoHackernews(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32v448h448V32zm249.67 250.83v84H235v-84l-77-140h55l46.32 97.54 44.33-97.54h52.73z"
                }
            }
        ]
    })(props);
}
function IoLogoHtml5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32l34.94 403.21L255.77 480 413 435.15 448 32zm308 132H188l4 51h176l-13.51 151.39L256 394.48l-98.68-28-6.78-77.48h48.26l3.42 39.29L256 343.07l53.42-14.92L315 264H148l-12.59-149.59H376.2z"
                }
            }
        ]
    })(props);
}
function IoLogoInstagram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M349.33 69.33a93.62 93.62 0 0193.34 93.34v186.66a93.62 93.62 0 01-93.34 93.34H162.67a93.62 93.62 0 01-93.34-93.34V162.67a93.62 93.62 0 0193.34-93.34h186.66m0-37.33H162.67C90.8 32 32 90.8 32 162.67v186.66C32 421.2 90.8 480 162.67 480h186.66C421.2 480 480 421.2 480 349.33V162.67C480 90.8 421.2 32 349.33 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M377.33 162.67a28 28 0 1128-28 27.94 27.94 0 01-28 28zM256 181.33A74.67 74.67 0 11181.33 256 74.75 74.75 0 01256 181.33m0-37.33a112 112 0 10112 112 112 112 0 00-112-112z"
                }
            }
        ]
    })(props);
}
function IoLogoIonic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 153.9A102.1 102.1 0 10358.1 256 102.23 102.23 0 00256 153.9z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "402.59",
                    "cy": "116.45",
                    "r": "46.52"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M459.86 163.2l-1.95-4.28-3.11 3.52a70 70 0 01-28.06 19.32l-3 1.1 1.22 2.93A181.43 181.43 0 01439 256c0 100.92-82.1 183-183 183S73 356.92 73 256 155.08 73 256 73a180.94 180.94 0 0178.43 17.7l2.87 1.3 1.25-2.92A70.19 70.19 0 01359.21 62l3.67-2.93-4.17-2.07A221.61 221.61 0 00256 32C132.49 32 32 132.49 32 256s100.49 224 224 224 224-100.49 224-224a222.19 222.19 0 00-20.14-92.8z"
                }
            }
        ]
    })(props);
}
function IoLogoIonitron(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M468.41 269.19c-2.64-33.39-11.76-58-31.44-57.39a1 1 0 00-.92 1.37c5.11 12.59 9.68 36.9 9.17 58.07a1 1 0 01-2 .08c-2.19-21.21-7.1-41.19-16.22-59.43a186.69 186.69 0 00-348.91 41 4 4 0 01-3.33 3.11l-8.65 1.22c-17.2 2.4-26.9 34.9-21.7 72.5s23.5 66.2 40.7 63.8l13.24-1.85a4 4 0 013.93 1.84 186.71 186.71 0 00339-56.07 4 4 0 013.68-3.08l4.4-.24c15.15-2.53 21.75-31.23 19.05-64.93zM94.5 270.42a1 1 0 011.59-1.19c9.63 10 20.25 27.65 23.32 49.86 3.24 23.05-2.24 45.2-9.13 57.87a1 1 0 01-1.84-.73c4.07-14.44 5.16-33.83 2.27-54.74-2.8-20.32-8.71-38.27-16.21-51.07zm178.77 109.79a15.53 15.53 0 01-15.41-13.83 15.48 15.48 0 1115.41 13.83zm81.84-4.72a15.37 15.37 0 1114.6-16.2 15.43 15.43 0 01-14.6 16.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M165.51 70a.31.31 0 01.1.2c.1.2.2.3.3.5v.1a5.78 5.78 0 002.3 2.7c2 1.5 5 2.4 8.6 3a63.69 63.69 0 0011.9.5 28.25 28.25 0 002.9-.2c-.4-.4-.8-.9-1.2-1.3h-1.3a52 52 0 01-11.6-.9 19.71 19.71 0 01-8.4-3.4 9.24 9.24 0 01-1.4-1.4 4.48 4.48 0 010-2.3c.5-2.3 2.4-4.8 5.5-7.4a57.25 57.25 0 0110.9-7c.9-.4 1.7-.9 2.6-1.3.1-.1.3-.1.5-.2a24.69 24.69 0 00-.2 10.5c2.3 11.9 11.6 20.3 23.2 20.6l4 24.3 12.7-3-4-23.3c10.8-4.6 16.3-16.1 14-28a25.8 25.8 0 00-3.9-9.5c-5.3-.8-15.6-.8-29.2 2.1 1.1-.3 2.1-.7 3.2-1a135.27 135.27 0 0121.5-4.2c.6-.1 1.2-.1 1.8-.2l3.5-.3h.6a61.83 61.83 0 0110.8.3 29 29 0 016.1 1.4 5.71 5.71 0 00-.9 3.2 6.12 6.12 0 004.3 5.8 25.53 25.53 0 01-2.1 2.8 26 26 0 01-2.9 2.8c-1.1.9-2.3 1.8-3.5 2.7l-6.5 3.8-.3 1.5a.35.35 0 00.2-.1l8.4-4.7c1.2-.8 2.4-1.6 3.4-2.4a29.15 29.15 0 003.2-2.8 29.86 29.86 0 002.4-2.8l.3-.6a6.14 6.14 0 005.4-6 6.06 6.06 0 00-6.1-6.1 6.81 6.81 0 00-2.8.7 24.6 24.6 0 00-8.2-2.7 63.48 63.48 0 00-15.5-.6 14.92 14.92 0 00-2.1.2 13.55 13.55 0 01-2 .2 25.15 25.15 0 00-18.7-3.7 25.86 25.86 0 00-17.8 13c-1.3.5-2.6 1.1-3.8 1.7-.7.3-1.3.6-2 .9a60.75 60.75 0 00-13.9 9.1c-3.1 2.9-4.9 5.7-5.3 8.3a6.14 6.14 0 00.7 4 2.19 2.19 0 01.3.5z"
                }
            }
        ]
    })(props);
}
function IoLogoJavascript(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32v448h448V32zm240 348c0 43.61-25.76 64.87-63.05 64.87-33.68 0-53.23-17.44-63.15-38.49l34.28-20.75c6.61 11.73 11.63 21.65 26.06 21.65 12 0 21.86-5.41 21.86-26.46V240h44zm99.35 63.87c-39.09 0-64.35-17.64-76.68-42L329 382c9 14.74 20.75 24.56 41.5 24.56 17.44 0 27.57-7.72 27.57-19.75 0-14.43-10.43-19.54-29.68-28l-10.52-4.52c-30.38-12.92-50.52-29.16-50.52-63.45 0-31.57 24.05-54.63 61.64-54.63 26.77 0 46 8.32 59.85 32.68L396 290c-7.22-12.93-15-18-27.06-18-12.33 0-20.15 7.82-20.15 18 0 12.63 7.82 17.74 25.86 25.56l10.52 4.51c35.79 15.34 55.94 31 55.94 66.16.01 37.9-29.76 57.64-69.76 57.64z"
                }
            }
        ]
    })(props);
}
function IoLogoLaravel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505.57 234.62c-3.28-3.53-26.82-32.29-39.51-47.79-6.75-8.24-12.08-14.75-14.32-17.45l-.18-.22-.2-.21c-5.22-5.83-12.64-12.51-23.78-12.51a39.78 39.78 0 00-5.41.44c-.37.05-.75.11-1.15.15-2.45.27-10.06 1.5-28.14 4.48-14 2.29-35.11 5.77-38.31 6.07l-.71.06-.69.13c-10 1.78-16.62 6.22-19.56 13.19-1.55 3.68-3.22 11.15 2.94 19.86 1.53 2.22 6.83 9.56 15.94 22.17 6.06 8.4 12.87 17.82 18.75 26L259.9 275 150.66 96.05l-.2-.34-.23-.33-.44-.65C145.32 88.17 139.76 80 123.7 80c-1.13 0-2.31 0-3.63.11-4.6.25-21.42 1.57-40.89 3.11-21.49 1.69-50.9 4-54.72 4.1h-.73l-.79.08c-9.14.89-15.77 4.6-19.7 11-6.55 10.69-1.42 22.69.26 26.63C6.87 133 37.56 197.7 64.63 254.81c18 37.94 36.58 77.17 38.1 80.65a34.85 34.85 0 0032.94 21.59 46.62 46.62 0 009.86-1.1h.21l.2-.05c13.86-3.38 57.83-14.54 89.2-22.59 1.9 3.32 3.9 6.83 6 10.44 21.93 38.5 37.9 66.35 43.16 73.46C287 421 295 432 310.06 432c5.46 0 10.46-1.4 15.74-2.89l1.53-.43h.12c10.53-3 150.69-52.16 157.87-55.35l.22-.1c5.44-2.41 13.66-6.05 16.18-15.4 1.65-6.12.18-12.33-4.38-18.46l-.07-.09-.07-.09c-.85-1.1-4-5.21-8.27-10.9-9.13-12.07-23.88-31.57-36.84-48.54 17.37-4.5 38.8-10.11 43.38-11.55 11.47-3.43 14.94-10.69 16-14.73.79-3.15 1.82-11.2-5.9-18.85zm-320 58.19c-17.81 4.17-30.22 7.08-37.89 8.9-6.67-13.34-19.74-39.65-32.5-65.33-29.74-59.92-45.1-90.77-53.18-106.9l8.15-.7c13.34-1.15 31.61-2.72 41.78-3.57 16.76 28.26 74.32 125.3 96.3 162.3zM427.58 172zM310.06 416.4zm53.67-56.95c-24.21 8-37.33 12.37-44.42 14.74-6.3-10.34-20.16-33.52-32.47-54.19l115.7-29.48c5 6.81 14.57 19.72 33.46 44.93-18.07 6.04-48.2 16.02-72.27 24zm55.87-121.63l-23.76-31.53c13.67-2.39 21.54-3.77 26.15-4.6l12 14.88 11.94 14.82c-8.2 1.99-17.74 4.32-26.33 6.43z"
                }
            }
        ]
    })(props);
}
function IoLogoLinkedin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M444.17 32H70.28C49.85 32 32 46.7 32 66.89v374.72C32 461.91 49.85 480 70.28 480h373.78c20.54 0 35.94-18.21 35.94-38.39V66.89C480.12 46.7 464.6 32 444.17 32zm-273.3 373.43h-64.18V205.88h64.18zM141 175.54h-.46c-20.54 0-33.84-15.29-33.84-34.43 0-19.49 13.65-34.42 34.65-34.42s33.85 14.82 34.31 34.42c-.01 19.14-13.31 34.43-34.66 34.43zm264.43 229.89h-64.18V296.32c0-26.14-9.34-44-32.56-44-17.74 0-28.24 12-32.91 23.69-1.75 4.2-2.22 9.92-2.22 15.76v113.66h-64.18V205.88h64.18v27.77c9.34-13.3 23.93-32.44 57.88-32.44 42.13 0 74 27.77 74 87.64z"
                }
            }
        ]
    })(props);
}
function IoLogoMarkdown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M475 64H37C16.58 64 0 81.38 0 102.77v306.42C0 430.59 16.58 448 37 448h438c20.38 0 37-17.41 37-38.81V102.77C512 81.38 495.42 64 475 64zM288 368h-64V256l-48 64-48-64v112H64V144h64l48 80 48-80h64zm96 0l-80-112h48.05L352 144h64v112h48z"
                }
            }
        ]
    })(props);
}
function IoLogoMastodon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 173.59c0-104.13-68.26-134.65-68.26-134.65C377.3 23.15 318.2 16.5 256.8 16h-1.51c-61.4.5-120.46 7.15-154.88 22.94 0 0-68.27 30.52-68.27 134.65 0 23.85-.46 52.35.29 82.59C34.91 358 51.11 458.37 145.32 483.29c43.43 11.49 80.73 13.89 110.76 12.24 54.47-3 85-19.42 85-19.42l-1.79-39.5s-38.93 12.27-82.64 10.77c-43.31-1.48-89-4.67-96-57.81a108.44 108.44 0 01-1-14.9 558.91 558.91 0 0096.39 12.85c32.95 1.51 63.84-1.93 95.22-5.67 60.18-7.18 112.58-44.24 119.16-78.09 10.42-53.34 9.58-130.17 9.58-130.17zm-80.54 134.16h-50V185.38c0-25.8-10.86-38.89-32.58-38.89-24 0-36.06 15.53-36.06 46.24v67h-49.66v-67c0-30.71-12-46.24-36.06-46.24-21.72 0-32.58 13.09-32.58 38.89v122.37h-50V181.67q0-38.65 19.75-61.39c13.6-15.15 31.4-22.92 53.51-22.92 25.58 0 44.95 9.82 57.75 29.48L256 147.69l12.45-20.85c12.81-19.66 32.17-29.48 57.75-29.48 22.11 0 39.91 7.77 53.51 22.92q19.79 22.72 19.75 61.39z"
                }
            }
        ]
    })(props);
}
function IoLogoMedium(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M28 28v456h456V28H28zm378.83 108.04l-24.46 23.45a7.162 7.162 0 00-2.72 6.86v172.28c-.44 2.61.61 5.26 2.72 6.86l23.88 23.45v5.15H286.13v-5.15l24.74-24.02c2.43-2.43 2.43-3.15 2.43-6.86V198.81l-68.79 174.71h-9.3l-80.09-174.71v117.1c-.67 4.92.97 9.88 4.43 13.44l32.18 39.03v5.15h-91.24v-5.15l32.18-39.03c3.44-3.57 4.98-8.56 4.15-13.44V180.5c.38-3.76-1.05-7.48-3.86-10.01l-28.6-34.46v-5.15h88.81l68.65 150.55 60.35-150.55h84.66v5.16z"
                }
            }
        ]
    })(props);
}
function IoLogoMicrosoft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M31.87 30.58H244.7v212.81H31.87zm235.02 0H479.7v212.81H266.89zM31.87 265.61H244.7v212.8H31.87zm235.02 0H479.7v212.8H266.89z"
                }
            }
        ]
    })(props);
}
function IoLogoNoSmoking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 256h16v48h-16zm-248 48h129.6l-48-48H112v48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M364.5 60.1a8.79 8.79 0 01-1-.6 218.79 218.79 0 00-34.4-14.8l-5.4-1.8A223.2 223.2 0 00256 32C132.3 32 32 132.3 32 256a223.71 223.71 0 00115.4 195.8c.4.2.7.5 1.1.7a218.79 218.79 0 0034.4 14.8l5.4 1.8A222.7 222.7 0 00256 480c123.7 0 224-100.3 224-224A223.76 223.76 0 00364.5 60.1zM256 426.4a161.85 161.85 0 01-27.2-2.4 170.14 170.14 0 01-28.5-7.3c-1.9-.6-3.8-1.2-5.6-1.9a162.39 162.39 0 01-19-8.6 170.33 170.33 0 01-90.1-150.3c0-37.2 12.4-71.4 32.7-99.4l237.2 237.2c-28.1 20.3-62.3 32.7-99.5 32.7zm137.8-71L156.6 118.2c28-20.2 62.1-32.6 99.4-32.6a162.79 162.79 0 0127.2 2.4 170.14 170.14 0 0128.5 7.3c1.8.6 3.7 1.2 5.6 1.9a162 162 0 0118 8.1 170.25 170.25 0 0191.2 150.8c-.1 37.2-12.5 71.3-32.7 99.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M352 256h-34l34 34v-34zm32 0h16v48h-16zm-23.9-43.3c-8.8-4.1-22-5.7-45.6-5.7h-3.6c-12.7.1-15.9-.1-20-6.1-2.8-4.2-1-14.8 3.7-21.9a8 8 0 00.4-8.2 8.26 8.26 0 00-7-4.3 53.67 53.67 0 01-18.3-3.9c-10.6-4.5-15.6-12.1-15.6-23.1 0-25.8 21.8-27.7 22.8-27.7v-16c-12 0-38.8 11-38.8 43.7 0 17.5 9 31 25.7 38a66.58 66.58 0 0012 3.6c-3.3 9.8-3.6 20.9 1.7 28.7 9 13.3 20.3 13.2 33.3 13.1h3.5c26.3 0 34.6 2.3 38.9 4.3 5.7 2.6 6.8 7.5 6.6 15.7v1h16v-1c0-7.1.3-22.8-15.7-30.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M400 244c0-25.7-3-39.2-9.1-49.6C382.3 180 368.5 172 352 172h-17.4c2.9-8.3 5.4-19.8 3.5-30.9-3.2-18.8-19.1-30-43.1-30v16c21 0 26.1 9.1 27.4 16.7 2.5 14.5-6.8 32.1-6.9 32.3a8 8 0 00.1 7.9 8.06 8.06 0 006.9 3.9H352c10.9 0 19.4 4.9 25.1 14.6 3.1 5.3 6.9 13.5 6.9 41.4h16z"
                }
            }
        ]
    })(props);
}
function IoLogoNodejs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M429.76 130.07L274.33 36.85a37 37 0 00-36.65 0L82.24 130.06A38.2 38.2 0 0064 162.83V349a38.26 38.26 0 0018.24 32.8L123 406.14l.23.13c20.58 10.53 28.46 10.53 37.59 10.53 32.14 0 52.11-20.8 52.11-54.29V182a8.51 8.51 0 00-8.42-8.58h-22.38a8.51 8.51 0 00-8.42 8.58v180.51a15 15 0 01-6.85 13.07c-5.9 3.6-14.47 2.84-24.14-2.15l-39.06-23.51a1.1 1.1 0 01-.48-.92V165.46a1.32 1.32 0 01.59-1.06l151.84-93a.82.82 0 01.73 0l151.93 93a1.34 1.34 0 01.55 1.1V349a1.28 1.28 0 01-.45 1l-152.06 90.65a1.22 1.22 0 01-.8 0l-38.83-23.06a7.8 7.8 0 00-7.83-.41l-.34.2c-10.72 6.35-13.6 8-23.54 11.62-1.62.59-5.43 2-5.76 5.77s3.29 6.45 6.51 8.32l51.9 31.87a35.67 35.67 0 0018.3 5.07h.58a35.87 35.87 0 0017.83-5.07l155.43-93.13A38.37 38.37 0 00448 349V162.83a38.21 38.21 0 00-18.24-32.76z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M307.88 318.05c-37.29 0-45.24-10.42-47.6-27.24a8.43 8.43 0 00-8.22-7.32h-19.8a8.44 8.44 0 00-8.26 8.58c0 14.58 5.12 62.17 83.92 62.17 24.38 0 44.66-5.7 58.63-16.49S388 311.26 388 292.55c0-37.55-24.5-47.83-72.75-54.55-49.05-6.82-49.05-10.29-49.05-17.89 0-5.47 0-18.28 35.46-18.28 25.23 0 38.74 3.19 43.06 20a8.35 8.35 0 008.06 6.67h19.87a8.24 8.24 0 006.16-2.86 8.91 8.91 0 002.12-6.44c-2.57-35.55-28.56-53.58-79.24-53.58-46.06 0-73.55 20.75-73.55 55.5 0 38.1 28.49 48.87 71.29 53.33 50 5.17 50 12.71 50 19.37.03 10.38-4.28 24.23-41.55 24.23z"
                }
            }
        ]
    })(props);
}
function IoLogoNpm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M227.6 213.1H256v57.1h-28.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 156v171.4h142.2V356H256v-28.6h256V156zm142.2 142.9h-28.4v-85.7H85.3v85.7H28.4V184.6h113.8zm142.2 0h-56.9v28.6h-56.9V184.6h113.8zm199.2 0h-28.4v-85.7h-28.4v85.7h-28.4v-85.7H370v85.7h-56.9V184.6h170.7v114.3z"
                }
            }
        ]
    })(props);
}
function IoLogoOctocat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M172.86 290.12c-9.75 0-18.11 4.56-24.86 13.87s-10.07 20.58-10.07 34 3.43 24.91 10.07 34.12S163 386 172.86 386c9.1 0 17-4.66 23.68-13.87s10.07-20.58 10.07-34.12-3.43-24.81-10.07-34-14.54-13.89-23.68-13.89zm167.46 0c-9.64 0-18.11 4.56-24.86 13.87s-10.07 20.58-10.07 34 3.43 24.91 10.07 34.12S330.57 386 340.32 386c9.11 0 17-4.66 23.79-13.87s10.07-20.58 10.07-34.12-3.43-24.81-10.07-34-14.57-13.89-23.79-13.89z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M459.36 165c-.11 0 2.89-15.49.32-42.47-2.36-27-8-51.78-17.25-74.53 0 0-4.72.87-13.72 3.14S405 58 384.89 67.18c-19.82 9.2-40.71 21.44-62.46 36.29-14.79-4.23-36.86-6.39-66.43-6.39-28.18 0-50.25 2.16-66.43 6.39Q117.9 53.25 69.46 48q-13.81 34.13-17.14 74.75c-2.57 27 .43 42.58.43 42.58C26.71 193.82 16 234.88 16 268.78c0 26.22.75 49.94 6.54 71 6 20.91 13.6 38 22.6 51.14A147.49 147.49 0 0079 425.43c13.39 10.08 25.71 17.34 36.86 21.89 11.25 4.76 24 8.23 38.57 10.72a279.19 279.19 0 0032.68 4.34s30 1.62 69 1.62 68.89-1.62 68.89-1.62a285.25 285.25 0 0032.68-4.38 178.91 178.91 0 0038.46-10.72c11.15-4.66 23.47-11.81 37-21.89a145 145 0 0033.75-34.55c9-13.11 16.6-30.23 22.6-51.14s6.51-44.81 6.51-71.03c0-32.82-10.71-74.42-36.64-103.67zm-70.07 253.07C359.39 432.26 315.46 438 257.18 438h-2.25c-58.29 0-102.22-5.63-131.57-19.93s-44.25-43.45-44.25-87.43c0-26.32 9.21-47.66 27.32-64 7.93-7 17.57-11.92 29.57-14.84s22.93-3 33.21-2.71c10.08.43 24.22 2.38 42.11 3.79s31.39 3.25 44.79 3.25c12.53 0 29.14-2.17 55.82-4.33s46.61-3.25 59.46-1.09c13.18 2.17 24.65 6.72 34.4 15.93q28.44 25.67 28.5 64c-.11 43.98-15.22 73.24-45 87.43z"
                }
            }
        ]
    })(props);
}
function IoLogoPaypal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M424.81 148.79c-.43 2.76-.93 5.58-1.49 8.48-19.17 98-84.76 131.8-168.54 131.8h-42.65a20.67 20.67 0 00-20.47 17.46l-21.84 137.84-6.18 39.07a10.86 10.86 0 009.07 12.42 10.72 10.72 0 001.7.13h75.65a18.18 18.18 0 0018-15.27l.74-3.83 14.24-90 .91-4.94a18.16 18.16 0 0118-15.3h11.31c73.3 0 130.67-29.62 147.44-115.32 7-35.8 3.38-65.69-15.16-86.72a72.27 72.27 0 00-20.73-15.82z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M385.52 51.09C363.84 26.52 324.71 16 274.63 16H129.25a20.75 20.75 0 00-20.54 17.48l-60.55 382a12.43 12.43 0 0010.39 14.22 12.58 12.58 0 001.94.15h89.76l22.54-142.29-.7 4.46a20.67 20.67 0 0120.47-17.46h42.65c83.77 0 149.36-33.86 168.54-131.8.57-2.9 1.05-5.72 1.49-8.48 5.7-36.22-.05-60.87-19.72-83.19z"
                }
            }
        ]
    })(props);
}
function IoLogoPinterest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.05 32c-123.7 0-224 100.3-224 224 0 91.7 55.2 170.5 134.1 205.2-.6-15.6-.1-34.4 3.9-51.4 4.3-18.2 28.8-122.1 28.8-122.1s-7.2-14.3-7.2-35.4c0-33.2 19.2-58 43.2-58 20.4 0 30.2 15.3 30.2 33.6 0 20.5-13.1 51.1-19.8 79.5-5.6 23.8 11.9 43.1 35.4 43.1 42.4 0 71-54.5 71-119.1 0-49.1-33.1-85.8-93.2-85.8-67.9 0-110.3 50.7-110.3 107.3 0 19.5 5.8 33.3 14.8 43.9 4.1 4.9 4.7 6.9 3.2 12.5-1.1 4.1-3.5 14-4.6 18-1.5 5.7-6.1 7.7-11.2 5.6-31.3-12.8-45.9-47-45.9-85.6 0-63.6 53.7-139.9 160.1-139.9 85.5 0 141.8 61.9 141.8 128.3 0 87.9-48.9 153.5-120.9 153.5-24.2 0-46.9-13.1-54.7-27.9 0 0-13 51.6-15.8 61.6-4.7 17.3-14 34.5-22.5 48a225.13 225.13 0 0063.5 9.2c123.7 0 224-100.3 224-224S379.75 32 256.05 32z"
                }
            }
        ]
    })(props);
}
function IoLogoPlaystation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M399.77 203c-.8-17.1-3.3-34.5-10.8-50.1a82.45 82.45 0 00-16.5-23.2 105.59 105.59 0 00-21.3-16.3c-17.1-10.2-37.5-17-84.4-31S192 64 192 64v358.3l79.9 25.7s.1-198.8.1-299.5v-3.8c0-9.3 7.5-16.8 16.1-16.8h.5c8.5 0 15.5 7.5 15.5 16.8V278c11 5.3 29.2 9.3 41.8 9.1a47.79 47.79 0 0024-5.7 49.11 49.11 0 0018.4-17.8 78.64 78.64 0 009.9-27.3c1.87-10.8 1.97-22.1 1.57-33.3zM86.67 357.8c27.4-9.8 89.3-29.5 89.3-29.5v-47.2s-76.5 24.8-111.3 37.1c-8.6 3.1-17.3 5.9-25.7 9.5-9.8 4.1-19.4 8.7-28.1 14.8a26.29 26.29 0 00-9.2 10.1 17.36 17.36 0 00-.5 13.6c2 5.1 5.8 9.3 10.1 12.6 7.8 5.9 17.1 9.5 26.4 12.2a262.42 262.42 0 0088.4 13.3c14.5-.2 36-1.9 50-4.4v-42s-11 2.5-41.3 12.5c-4.6 1.5-9.2 3.3-14 4.3a104.87 104.87 0 01-21.6 2.2c-6.5-.3-13.2-.7-19.3-3.1-2.2-1-4.6-2.2-5.5-4.6-.8-2 .3-4 1.7-5.4 2.8-2.9 6.8-4.5 10.6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 345.9c-.1-6-3.7-11.2-7.9-15-7.1-6.3-15.9-10.3-24.7-13.5-5.5-1.9-9.3-3.3-14.7-5-25.2-8.2-51.9-11.2-78.3-11.3-8 .3-23.1.5-31 1.4-21.9 2.5-67.3 15.4-67.3 15.4v48.8s67.5-21.6 96.5-31.8a94.43 94.43 0 0130.3-4.6c6.5.2 13.2.7 19.4 3.1 2.2.9 4.5 2.2 5.5 4.5.9 2.6-.9 5-2.9 6.5-4.7 3.8-10.7 5.3-16.2 7.4-41 14.5-132.7 44.7-132.7 44.7v47s117.2-39.6 170.8-58.8c8.9-3.3 17.9-6.1 26.4-10.4 7.9-4 15.8-8.6 21.8-15.3a19.74 19.74 0 005-13.1z"
                }
            }
        ]
    })(props);
}
function IoLogoPwa(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M330.7 352l77.72-192H356.9l-53.16 124.07L265.93 160h-39.61l-40.58 124.07-28.63-56.53-25.9 79.46 26.3 45h50.7l36.68-111.27 35 111.27zM48.79 286.09h31.65a93.39 93.39 0 0025.62-3.21l8.18-25.19 22.88-70.39a55.75 55.75 0 00-6-7.82Q113.54 160 79.59 160H0v192h48.79zm41.9-81.92q6.89 6.92 6.88 18.52t-6 18.53q-6.64 7.62-24.44 7.61H48.79v-51.58h18.42q16.59 0 23.48 6.92zm286.16 113.44l14.79-37.25h42.69l-20.26-56.51L439.41 160 512 352h-53.53l-12.4-34.39z"
                }
            }
        ]
    })(props);
}
function IoLogoPython(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M314 36.38c-18.59-3.06-45.8-4.47-64.27-4.38a311.09 311.09 0 00-51.66 4.38c-45.74 8-54.07 24.7-54.07 55.54V128h112v16H107.62C66.06 144 32.33 193.67 32 255.12v.88a162.91 162.91 0 003.13 32c9.29 46.28 38.23 80 72.49 80H128v-54c0-31.3 20.84-59.95 55-66.1l9.87-1.23H314a56.05 56.05 0 0015.06-2A52.48 52.48 0 00368 193.68V91.92c0-28.92-24.68-50.73-54-55.54zM194.93 105.5a20.37 20.37 0 1120.3-20.3 20.29 20.29 0 01-20.3 20.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M475.28 217c-10.7-42.61-38.41-73-70.9-73h-17.71v47.45c0 39.57-26 68.22-57.74 73.13a63.54 63.54 0 01-9.69.75H198.08a60 60 0 00-15.23 1.95C160.54 273.14 144 291.7 144 315.77v101.77c0 29 29.14 46 57.73 54.31 34.21 9.95 71.48 11.75 112.42 0 27.19-7.77 53.85-23.48 53.85-54.31V384H256v-16h148.38c29.44 0 54.95-24.93 67.45-61.31A156.83 156.83 0 00480 256a160.64 160.64 0 00-4.72-39zM316.51 404a20.37 20.37 0 11-20.3 20.3 20.29 20.29 0 0120.3-20.3z"
                }
            }
        ]
    })(props);
}
function IoLogoReact(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M410.66 180.72q-7.67-2.62-15.45-4.88 1.29-5.25 2.38-10.56c11.7-56.9 4.05-102.74-22.06-117.83-25-14.48-66 .61-107.36 36.69q-6.1 5.34-11.95 11-3.9-3.76-8-7.36c-43.35-38.58-86.8-54.83-112.88-39.69-25 14.51-32.43 57.6-21.9 111.53q1.58 8 3.55 15.93a320.85 320.85 0 00-17.77 5.6C48.46 198.9 16 226.73 16 255.59c0 29.82 34.84 59.72 87.77 77.85q6.44 2.19 13 4.07-2.13 8.49-3.77 17.17c-10 53-2.2 95.07 22.75 109.49 25.77 14.89 69-.41 111.14-37.31q5-4.38 10-9.25 6.32 6.11 13 11.86c40.8 35.18 81.09 49.39 106 34.93 25.75-14.94 34.12-60.14 23.25-115.13q-1.25-6.3-2.88-12.86 4.56-1.35 8.93-2.79c55-18.27 90.83-47.81 90.83-78-.02-29-33.52-57.01-85.36-74.9zm-129-81.08c35.43-30.91 68.55-43.11 83.65-34.39 16.07 9.29 22.32 46.75 12.22 95.88q-1 4.8-2.16 9.57a487.83 487.83 0 00-64.18-10.16 481.27 481.27 0 00-40.57-50.75q5.38-5.22 11.02-10.15zM157.73 280.25q6.51 12.6 13.61 24.89 7.23 12.54 15.07 24.71a435.28 435.28 0 01-44.24-7.13c4.24-13.72 9.46-27.97 15.56-42.47zm0-48.33c-6-14.19-11.08-28.15-15.25-41.63 13.7-3.07 28.3-5.58 43.52-7.48q-7.65 11.94-14.72 24.23t-13.58 24.88zm10.9 24.17q9.48-19.77 20.42-38.78 10.93-19 23.27-37.13c14.28-1.08 28.92-1.65 43.71-1.65s29.52.57 43.79 1.66q12.21 18.09 23.13 37t20.69 38.6Q334 275.63 323 294.73q-10.91 19-23 37.24c-14.25 1-29 1.55-44 1.55s-29.47-.47-43.46-1.38q-12.43-18.19-23.46-37.29t-20.48-38.76zM340.75 305q7.25-12.58 13.92-25.49a440.41 440.41 0 0116.12 42.32 434.44 434.44 0 01-44.79 7.65q7.62-12.09 14.75-24.48zm13.72-73.07q-6.64-12.65-13.81-25-7-12.18-14.59-24.06c15.31 1.94 30 4.52 43.77 7.67a439.89 439.89 0 01-15.37 41.39zm-98.24-107.45a439.75 439.75 0 0128.25 34.18q-28.35-1.35-56.74 0c9.33-12.34 18.88-23.79 28.49-34.18zM145.66 65.86c16.06-9.32 51.57 4 89 37.27 2.39 2.13 4.8 4.36 7.2 6.67A491.37 491.37 0 00201 160.51a499.12 499.12 0 00-64.06 10q-1.83-7.36-3.3-14.82c-9.05-46.23-3.06-81.08 12.02-89.83zm-23.41 251.85q-6-1.71-11.85-3.71c-23.4-8-42.73-18.44-56-29.81-11.88-10.19-17.9-20.36-17.9-28.6 0-17.51 26.06-39.85 69.52-55q8.19-2.85 16.52-5.21a493.54 493.54 0 0023.4 60.75 502.46 502.46 0 00-23.69 61.58zm111.13 93.67c-18.63 16.32-37.29 27.89-53.74 33.72-14.78 5.23-26.55 5.38-33.66 1.27-15.14-8.75-21.44-42.54-12.85-87.86q1.53-8 3.5-16a480.85 480.85 0 0064.69 9.39 501.2 501.2 0 0041.2 51c-2.98 2.93-6.03 5.75-9.14 8.48zm23.42-23.22c-9.72-10.51-19.42-22.14-28.88-34.64q13.79.54 28.08.54c9.78 0 19.46-.21 29-.64a439.33 439.33 0 01-28.2 34.74zm124.52 28.59c-2.86 15.44-8.61 25.74-15.72 29.86-15.13 8.78-47.48-2.63-82.36-32.72-4-3.44-8-7.13-12.07-11a484.54 484.54 0 0040.23-51.2 477.84 477.84 0 0065-10.05q1.47 5.94 2.6 11.64c4.81 24.3 5.5 46.28 2.32 63.47zm17.4-102.64c-2.62.87-5.32 1.71-8.06 2.53a483.26 483.26 0 00-24.31-60.94 481.52 481.52 0 0023.36-60.06c4.91 1.43 9.68 2.93 14.27 4.52 44.42 15.32 71.52 38 71.52 55.43 0 18.6-29.27 42.74-76.78 58.52z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 298.55a43 43 0 10-42.86-43 42.91 42.91 0 0042.86 43z"
                }
            }
        ]
    })(props);
}
function IoLogoReddit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M324 256a36 36 0 1036 36 36 36 0 00-36-36z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "188",
                    "cy": "292",
                    "r": "36",
                    "transform": "rotate(-22.5 187.997 291.992)"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M496 253.77c0-31.19-25.14-56.56-56-56.56a55.72 55.72 0 00-35.61 12.86c-35-23.77-80.78-38.32-129.65-41.27l22-79 66.41 13.2c1.9 26.48 24 47.49 50.65 47.49 28 0 50.78-23 50.78-51.21S441 48 413 48c-19.53 0-36.31 11.19-44.85 28.77l-90-17.89-31.1 109.52-4.63.13c-50.63 2.21-98.34 16.93-134.77 41.53A55.38 55.38 0 0072 197.21c-30.89 0-56 25.37-56 56.56a56.43 56.43 0 0028.11 49.06 98.65 98.65 0 00-.89 13.34c.11 39.74 22.49 77 63 105C146.36 448.77 199.51 464 256 464s109.76-15.23 149.83-42.89c40.53-28 62.85-65.27 62.85-105.06a109.32 109.32 0 00-.84-13.3A56.32 56.32 0 00496 253.77zM414 75a24 24 0 11-24 24 24 24 0 0124-24zM42.72 253.77a29.6 29.6 0 0129.42-29.71 29 29 0 0113.62 3.43c-15.5 14.41-26.93 30.41-34.07 47.68a30.23 30.23 0 01-8.97-21.4zM390.82 399c-35.74 24.59-83.6 38.14-134.77 38.14S157 423.61 121.29 399c-33-22.79-51.24-52.26-51.24-83A78.5 78.5 0 0175 288.72c5.68-15.74 16.16-30.48 31.15-43.79a155.17 155.17 0 0114.76-11.53l.3-.21.24-.17c35.72-24.52 83.52-38 134.61-38s98.9 13.51 134.62 38l.23.17.34.25A156.57 156.57 0 01406 244.92c15 13.32 25.48 28.05 31.16 43.81a85.44 85.44 0 014.31 17.67 77.29 77.29 0 01.6 9.65c-.01 30.72-18.21 60.19-51.25 82.95zm69.6-123.92c-7.13-17.28-18.56-33.29-34.07-47.72A29.09 29.09 0 01440 224a29.59 29.59 0 0129.41 29.71 30.07 30.07 0 01-8.99 21.39z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M323.23 362.22c-.25.25-25.56 26.07-67.15 26.27-42-.2-66.28-25.23-67.31-26.27a4.14 4.14 0 00-5.83 0l-13.7 13.47a4.15 4.15 0 000 5.89c3.4 3.4 34.7 34.23 86.78 34.45 51.94-.22 83.38-31.05 86.78-34.45a4.16 4.16 0 000-5.9l-13.71-13.47a4.13 4.13 0 00-5.81 0z"
                }
            }
        ]
    })(props);
}
function IoLogoRss(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M108.56 342.78a60.34 60.34 0 1060.56 60.44 60.63 60.63 0 00-60.56-60.44z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M48 186.67v86.55c52 0 101.94 15.39 138.67 52.11s52 86.56 52 138.67h86.66c0-151.56-125.66-277.33-277.33-277.33z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M48 48v86.56c185.25 0 329.22 144.08 329.22 329.44H464C464 234.66 277.67 48 48 48z"
                }
            }
        ]
    })(props);
}
function IoLogoSass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.78 328.07c-1.47-11.92-7.51-22.26-18-30.77a3.58 3.58 0 00-.43-.44l-.53-.38-.17-.12-5.57-4-.19-.14-.71-.5a3.5 3.5 0 00-.83-.35c-17.62-10.49-46.79-17.84-91.42-2.09-10.65-17.92-11.86-32.28-4.73-54.28 1.27-3.83.09-6.36-3.71-8-7.64-3.25-18.1-1.59-25.52.37-3.46.9-5.54 2.86-6.2 5.83-4.7 22-18.36 42.1-31.57 61.5l-.78 1.14c-8.14-17.26-6.45-30.63-.78-47.38 1.13-3.34.24-5.56-2.89-7.22-8.74-4.51-21.85-1.41-27.07.13-6.62 1.93-13.72 19.82-21.65 41.24-2 5.39-3.72 10-4.75 12.15-2.45 5-4.79 10.7-7.27 16.75-5.6 13.69-11.91 29.1-20.93 38.78-3.28-7.25 1.88-18.68 6.89-29.77 5.93-13.11 11.53-25.5 5.08-33.41a11.82 11.82 0 00-8.33-4.32 13.26 13.26 0 00-6.15 1c.67-5.65.7-10.11-.95-15.5-2.36-7.69-8.49-12-16.93-11.77-19.22.56-35.48 14.88-45.75 26.8-6.84 8-22 14.1-35.31 19.45-5.26 2.23-10.26 4.23-14.43 6.23-6.65-5.62-15.1-11.29-24-17.28-25-16.78-53.33-35.81-54.31-61.61-1.4-38.11 42-65.14 79.88-84.43 28.71-14.6 53.67-24.28 76.31-29.57 31.8-7.43 58.66-5.93 79.82 4.44 11.58 5.67 17 18 13.56 30.68-9 32.95-46.29 55.53-78.18 65.69-19.21 6.12-35.56 8.68-50 7.84-18.1-1.05-32.88-10.13-39.2-14a21.18 21.18 0 00-3.2-1.8l-.29-.07a3.21 3.21 0 00-3.19 1c-1.3 1.55-.84 4-.37 5.24 6.15 16.07 18.85 26.22 37.74 30.17a92.09 92.09 0 0018.78 1.79c44.21 0 100.62-25.49 121.34-46.48 14.13-14.3 24.42-29 28.68-54.35 4.45-26.55-13.55-45-31.89-53.5-44.57-20.57-95.19-12.44-129.81-2-40.5 12.21-82.4 34.41-114.94 60.93-40.12 32.67-54.62 63-43.12 90.25 11.81 27.93 40.61 45.4 68.46 62.3 9 5.45 17.56 10.64 25.27 16-2.32 1.13-4.69 2.28-7.1 3.43-23.38 11.33-49.9 24.08-64.61 45.15-10.68 15.35-12.68 30.63-5.94 45.42 3.6 7.87 10 13.21 18.89 15.87A50 50 0 0053 432c17.31 0 36.36-7 46.73-13.47 18.32-11.5 30.19-26.94 35.29-45.89 4.54-16.86 3.45-33.61-3.15-48.56l22.45-11.32c-10.83 36-2.53 57.5 6.59 69.36 3.36 4.37 9.42 7 16.19 7.12s13-2.43 16.52-6.77c6.66-8.25 11.58-17.9 16.11-27.55-.24 6.3.06 12.68 2.21 18.09 1.93 4.87 5.11 8.1 9.21 9.34 4.36 1.33 9.47.21 14.39-3.15 22.17-15.17 37.33-51.58 49.51-80.85 1.73-4.16 3.39-8.16 5-11.9a152.5 152.5 0 0012.5 31.07c1.18 2.14 1.08 3.08-.52 4.84-2.41 2.64-5.77 5.83-9.33 9.21-10.78 10.23-24.2 23-26 34.23-.7 4.5 2.4 8.6 7.21 9.53 14.47 2.88 31.9-1.33 46.64-11.25 13.4-9 18.44-21.55 15-37.19-3.33-15.06 4.27-33.76 22.59-55.62 3 12.53 7 22.66 12.52 31.53l-.15.12c-13.34 11.65-31.62 27.6-28.78 46.95a13.35 13.35 0 005.58 9.22 14.22 14.22 0 0011.2 2.06c17.47-3.67 30.62-11.06 40.18-22.57s6.07-24.27 2.85-34.17c25-6.78 47.26-6.61 68.1.5 11.7 4 20.09 10.57 24.93 19.64 6.09 11.41 2.8 21.94-9.29 29.65-3.71 2.37-5.5 3.82-5.61 5.65a2.65 2.65 0 001 2.23c1.4 1.15 5.72 3.15 15.49-3 9-5.65 14.28-13.34 15.63-23a39 39 0 00-.01-8.01zm-399.73 25.06l-.1 1.28c-1.56 14.64-9 27.4-22.15 38-8.26 6.66-17.23 10.75-25.25 11.53-5.6.54-9.67-.22-12.09-2.27-1.81-1.53-2.78-3.82-3-7-1.64-25.48 38.32-50.8 60.81-59.13a51.39 51.39 0 011.78 17.59zm102.35-71.86c-3.7 21.09-14.49 60.9-31.45 76.35-.81.74-1.49 1-1.8.93s-.55-.44-.8-1c-5.66-13.12-3.57-35.28 5-52.69 6.59-13.42 16-22.31 26.52-25a5.29 5.29 0 011.34-.19 1.58 1.58 0 011 .27 1.64 1.64 0 01.19 1.33zm83.49 76.88c-3.19 3.33-7.56 2.88-6.53 1.66l16.24-17.24c-1.31 5.93-5.18 10.84-9.71 15.58zm67.37-14.91a14.07 14.07 0 01-4.93 1.39c-.46-9.07 8.33-19.28 17-26.09 2.33 9.46-2.44 19.46-12.07 24.7z"
                }
            }
        ]
    })(props);
}
function IoLogoSkype(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M467.16 303.6a205.69 205.69 0 004.9-45.15c0-116.32-95.69-210.7-213.79-210.7a221.83 221.83 0 00-36.52 3A123.58 123.58 0 00155.93 32C87.55 32 32 86.72 32 154.15A119.56 119.56 0 0049 216a211.16 211.16 0 00-4.32 42.35c0 116.44 95.69 210.7 213.67 210.7a214 214 0 0039.09-3.5A125.45 125.45 0 00356.07 480C424.57 480 480 425.28 480 357.85a118 118 0 00-12.84-54.25zM368 359c-9.92 13.76-24.51 24.73-43.41 32.43S283.36 403 257.69 403c-30.69 0-56.36-5.37-76.55-15.87a101 101 0 01-35.24-30.8c-9.11-12.83-13.66-25.66-13.66-38 0-7.7 3-14.35 8.87-19.95 5.84-5.37 13.42-8.17 22.29-8.17 7.35 0 13.65 2.1 18.79 6.42 4.9 4.08 9.1 10.15 12.48 18.08A108.09 108.09 0 00207 336.15q6.32 8.22 17.86 13.65c7.82 3.62 18.2 5.48 31 5.48 17.62 0 32.09-3.73 42.94-11.08 10.74-7.12 15.88-15.75 15.88-26.25 0-8.28-2.69-14.82-8.29-19.95-5.83-5.37-13.42-9.57-22.87-12.37-9.69-3-22.87-6.18-39.21-9.56-22.17-4.67-41-10.27-56-16.57-15.28-6.42-27.65-15.4-36.76-26.48-9.22-11.32-13.77-25.55-13.77-42.24a67.86 67.86 0 0114.47-42.58c9.57-12.25 23.46-21.82 41.55-28.35 17.74-6.53 38.86-9.8 62.66-9.8 19.14 0 35.83 2.22 49.83 6.42s25.91 10.15 35.36 17.38 16.34 14.93 20.77 23 6.66 16.22 6.66 24c0 7.46-2.92 14.35-8.76 20.3a29.65 29.65 0 01-21.94 9.1c-7.93 0-14.12-1.87-18.43-5.6-4-3.5-8.17-8.87-12.72-16.69-5.37-9.91-11.79-17.85-19.14-23.45-7.24-5.36-19.14-8.16-35.71-8.16-15.29 0-27.77 3-37 9-8.87 5.72-13.19 12.37-13.19 20.18a18.26 18.26 0 004.32 12.25 38.13 38.13 0 0012.72 9.57 90.14 90.14 0 0017.15 6.53c6 1.64 15.87 4.09 29.53 7.12 17.38 3.62 33.25 7.82 47.26 12.13 14.24 4.55 26.49 10 36.52 16.45a72.93 72.93 0 0124.16 25.09c5.72 10 8.64 22.63 8.64 37.1A75.09 75.09 0 01368 359z"
                }
            }
        ]
    })(props);
}
function IoLogoSlack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M126.12 315.1A47.06 47.06 0 1179.06 268h47.06zm23.72 0a47.06 47.06 0 0194.12 0v117.84a47.06 47.06 0 11-94.12 0zm47.06-188.98A47.06 47.06 0 11244 79.06v47.06zm0 23.72a47.06 47.06 0 010 94.12H79.06a47.06 47.06 0 010-94.12zm188.98 47.06a47.06 47.06 0 1147.06 47.1h-47.06zm-23.72 0a47.06 47.06 0 01-94.12 0V79.06a47.06 47.06 0 1194.12 0zM315.1 385.88a47.06 47.06 0 11-47.1 47.06v-47.06zm0-23.72a47.06 47.06 0 010-94.12h117.84a47.06 47.06 0 110 94.12z"
                }
            }
        ]
    })(props);
}
function IoLogoSnapchat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 347.21a190.31 190.31 0 01-32.79-5.31c-27.28-6.63-54.84-24.26-68.12-52.43-6.9-14.63-2.64-18.59 11.86-24 14.18-5.27 29.8-7.72 36.86-23 5.89-12.76 1.13-27.76-10.41-35.49-15.71-10.53-30.35-.21-46.62 2.07 3.73-46.66 8.66-88.57-22.67-127.73C338.14 48.86 297.34 32 256.29 32s-81.86 16.86-107.81 49.33c-31.38 39.26-26.4 81.18-22.67 127.92-16.32-2.25-30.81-12.79-46.63-2.18-14.72 9.85-17 29.76-5.44 43s31.64 9.5 43.45 20.6c6.49 6.09 3.49 12.61-.35 20.14-14.48 28.4-39.26 45.74-69.84 51.56-4 .76-22.31 2.87-31 3.65 0 9.28.52 16.78 1.63 21.73 2.94 13.06 12.32 23.58 23.69 30.1 11.18 6.4 35.48 6.43 41.68 15.51 3 4.48 1.76 12.28 5.33 17.38a23.8 23.8 0 0015.37 9.75c18.61 3.61 37.32-7.2 56.42-2.1 14.85 3.95 26.52 15.87 39.26 24 15.51 9.85 32.34 16.42 50.83 17.49 38.1 2.21 59.93-18.91 90.58-36.42 19.5-11.14 38.15-3.86 58.88-2.68 20.1 1.15 23.53-9.25 29.62-24.88a27.37 27.37 0 001.54-4.85 10.52 10.52 0 002.28-1.47c2-1.57 10.55-2.34 12.76-2.86 10.28-2.44 20.34-5.15 29.17-11.2 11.31-7.76 17.65-18.5 19.58-32.64a93.73 93.73 0 001.38-15.67zM208 128c8.84 0 16 10.74 16 24s-7.16 24-16 24-16-10.74-16-24 7.16-24 16-24zm103.62 77.7c-15.25 15-35 23.3-55.62 23.3a78.37 78.37 0 01-55.66-23.34 8 8 0 0111.32-11.32A62.46 62.46 0 00256 213c16.39 0 32.15-6.64 44.39-18.7a8 8 0 0111.23 11.4zM304 176c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24z"
                }
            }
        ]
    })(props);
}
function IoLogoSoundcloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.8 278a2.11 2.11 0 00-2 2L0 308.64l3.74 28.16a2.12 2.12 0 002.05 2 2.14 2.14 0 002-2l4.44-28.17L7.83 280a2.14 2.14 0 00-2-2zm21.05-15.68a2.13 2.13 0 00-4.26 0l-5 46.32 5 45.3a2.13 2.13 0 004.26 0l5.73-45.31-5.73-46.32zm79.32-42.73a4 4 0 00-3.87 3.87l-4 85.22 4 55.08a3.88 3.88 0 007.75 0l4.53-55.08-4.53-85.22a4 4 0 00-3.88-3.87zm-41.05 29.62a3.09 3.09 0 00-3 3l-4.52 56.45 4.51 54.63a3 3 0 006 0l5.13-54.63-5.13-56.48a3.1 3.1 0 00-2.99-2.97zm82.76 118.39a4.83 4.83 0 004.75-4.74l3.93-54.15-3.93-113.46a4.75 4.75 0 00-9.5 0l-3.49 113.45 3.49 54.17a4.81 4.81 0 004.75 4.73zm85.4.25a6.6 6.6 0 006.5-6.52l2.74-52.6-2.74-131a6.5 6.5 0 10-13 0l-2.45 131c0 .08 2.45 52.67 2.45 52.67a6.59 6.59 0 006.5 6.45zm-43.02-.2a5.67 5.67 0 005.62-5.64l3.34-53.33-3.34-114.28a5.63 5.63 0 10-11.25 0l-3 114.29 3 53.32a5.66 5.66 0 005.63 5.6zm-104.7-.5a3.53 3.53 0 003.44-3.41l4.83-55.09-4.83-52.4a3.44 3.44 0 00-6.88 0l-4.26 52.38 4.26 55.08a3.5 3.5 0 003.44 3.44zm-40.72-3.02a2.67 2.67 0 002.57-2.52l5.43-53-5.42-55a2.57 2.57 0 00-5.14 0l-4.78 55 4.78 53a2.62 2.62 0 002.56 2.53zm166.85-171.6a6.1 6.1 0 00-6.07 6.09l-2.71 110.11 2.71 53a6.07 6.07 0 0012.13 0l3-53-3-110.13a6.1 6.1 0 00-6.06-6.07zM127 367.71a4.41 4.41 0 004.31-4.3l4.23-54.71-4.28-104.7a4.32 4.32 0 00-8.63 0l-3.74 104.7 3.75 54.73a4.38 4.38 0 004.36 4.28zm47.17-5.17l3.63-53.8-3.63-117.28a5.19 5.19 0 10-10.37 0l-3.23 117.28 3.23 53.83a5.18 5.18 0 0010.36 0zM449 241.1a62.42 62.42 0 00-24.33 4.9c-5-57.18-52.61-102-110.66-102a111.92 111.92 0 00-40.28 7.58c-4.75 1.85-6 3.76-6.06 7.46V360.4a7.66 7.66 0 006.8 7.5l174.56.11c34.78 0 63-28.41 63-63.45s-28.2-63.46-63-63.46zm-194.21-82.23a7 7 0 00-6.94 7L245 308.75l2.85 51.87a6.94 6.94 0 1013.87-.06v.06l3.09-51.87-3.09-142.93a7 7 0 00-6.93-6.95z"
                }
            }
        ]
    })(props);
}
function IoLogoStackoverflow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392 440V320h40v160H64V320h40v120z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M149.1 308.77l198.57 40.87 8.4-39.32-198.57-40.87zm26.27-93.12L359.22 300 376 263.76l-183.82-84.84zm50.95-89l156 127.78 25.74-30.52-156-127.78zM328 32l-33.39 23.8 120.82 160.37L448 192zM144 400h204v-40H144z"
                }
            }
        ]
    })(props);
}
function IoLogoSteam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M478.8 208.2a36 36 0 11-36-36 36 36 0 0136 36zM442.6 139a69.42 69.42 0 00-69.4 68.7l-43.2 62a48.86 48.86 0 00-5.4-.3 51.27 51.27 0 00-26.4 7.3L102.4 198a51.8 51.8 0 10-50.6 62.9 51.27 51.27 0 0026.4-7.3L274 332.2a51.76 51.76 0 00102.1-5.9l66.5-48.6a69.35 69.35 0 100-138.7zm0 22.9a46.45 46.45 0 11-46.5 46.5 46.54 46.54 0 0146.5-46.5zm-390.8 9a38.18 38.18 0 0133.7 20.2l-18.9-7.6v.1a30.21 30.21 0 00-22.6 56v.1l16.1 6.4a36.8 36.8 0 01-8.2.9 38.05 38.05 0 01-.1-76.1zm272.8 112.2a38.1 38.1 0 11-33.7 55.9c6.3 2.5 12.5 5 18.8 7.6a30.27 30.27 0 1022.5-56.2l-15.9-6.4a46.83 46.83 0 018.3-.9z"
                }
            }
        ]
    })(props);
}
function IoLogoStencil(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M188.8 334.07h197.33L279.47 448H83.2zM512 199H106.61L0 313h405.39zM232.2 64h196.6L322.62 177.93H125.87z"
                }
            }
        ]
    })(props);
}
function IoLogoTableau(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M242.69 340.3h26.62v-72.6h67v-25.82h-67v-72.6h-26.62v72.6h-66.15v25.82h66.15zM119.26 445.18h22.59v-64.54h59.7v-20.17h-59.7v-65.34h-22.59v65.34h-59.7v20.17h59.7zM370.15 212h22.59v-64.5h60.5v-19.37h-60.5V62.79h-22.59v65.34h-59.7v19.37h59.7zM246.72 496h19.36v-46h41.15v-16.92h-41.15v-46h-19.36v46h-40.33V450h40.33zM120.07 212h21v-65.31h60.51v-18.56H141V62.79h-21v65.34H59.56v18.56h60.51zm315.65 96.84h19.36v-45.18H496v-17.74h-40.92v-45.18h-19.36v45.18h-40.33v17.74h40.33z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M370.15 445.18h22.59v-64.54h60.5v-20.17h-60.5v-65.34h-22.59v65.34h-59.7v20.17h59.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M307 74.08V60.37h-40.34V16h-14.52v44.37h-40.33v13.71h40.33v44.37h14.52V74.08zM56.11 305.61h14.52v-44.37H111v-13.71H70.63V204H56.11v43.56H16v14.52l40.11-.08z"
                }
            }
        ]
    })(props);
}
function IoLogoTiktok(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M412.19 118.66a109.27 109.27 0 01-9.45-5.5 132.87 132.87 0 01-24.27-20.62c-18.1-20.71-24.86-41.72-27.35-56.43h.1C349.14 23.9 350 16 350.13 16h-82.44v318.78c0 4.28 0 8.51-.18 12.69 0 .52-.05 1-.08 1.56 0 .23 0 .47-.05.71v.18a70 70 0 01-35.22 55.56 68.8 68.8 0 01-34.11 9c-38.41 0-69.54-31.32-69.54-70s31.13-70 69.54-70a68.9 68.9 0 0121.41 3.39l.1-83.94a153.14 153.14 0 00-118 34.52 161.79 161.79 0 00-35.3 43.53c-3.48 6-16.61 30.11-18.2 69.24-1 22.21 5.67 45.22 8.85 54.73v.2c2 5.6 9.75 24.71 22.38 40.82A167.53 167.53 0 00115 470.66v-.2l.2.2c39.91 27.12 84.16 25.34 84.16 25.34 7.66-.31 33.32 0 62.46-13.81 32.32-15.31 50.72-38.12 50.72-38.12a158.46 158.46 0 0027.64-45.93c7.46-19.61 9.95-43.13 9.95-52.53V176.49c1 .6 14.32 9.41 14.32 9.41s19.19 12.3 49.13 20.31c21.48 5.7 50.42 6.9 50.42 6.9v-81.84c-10.14 1.1-30.73-2.1-51.81-12.61z"
                }
            }
        ]
    })(props);
}
function IoLogoTumblr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M390 32H120c-49.19 0-88 38.81-88 88v270c0 49.19 38.81 90 88 90h270c49.19 0 90-40.81 90-90V120c0-49.19-40.81-88-90-88zm-54 364h-52c-42.51 0-72-23.68-72-76v-80h-36v-48c42.51-11 57.95-48.32 60-80h44v72h52v56h-52l-.39 70.51c0 21.87 11 29.43 28.62 29.43L336 340z"
                }
            }
        ]
    })(props);
}
function IoLogoTux(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M443.66 405.05c-1.46-.79-2.85-1.54-4-2.2-6.47-3.83-13-10.52-11.85-17.83 2.42-15.94 2.89-23.47-.49-28.79a15.61 15.61 0 00-7.67-6.2v-.06c1.41-2.56 2.26-5.66 2.83-10.12 1.44-11-5-44-13.7-70.7-8.08-24.68-29.24-50-44.7-68.56l-3.61-4.34c-23.88-28.93-24.34-38.19-26.55-82.67-.32-6.47-.69-13.8-1.17-22C329.87 41.43 304 16 256 16c-25.2 0-44.62 7.15-57.72 21.26C187.79 48.55 182 64 182 80.78c0 29.52 2 53 2.15 54.29 1.4 35.7 1 41.22-8.31 57.55-2.23 3.93-8.38 10.87-14.89 18.21-8.48 9.57-18.09 20.41-23.36 29.22-3.77 6.31-5.88 12.63-8.11 19.33-3.4 10.21-7.26 21.78-18.15 36.57-12.57 17.07-15.52 29.61-11 47.45-4.94 6.45-4.83 14.37-4.75 20.23a25.84 25.84 0 01-.3 6.09c-2.29 7.59-12.42 9.4-22 10.18-1.58.12-3.1.21-4.55.29-7.26.39-13.53.74-17.13 6.3-3.47 5.36-1.12 13.8 2.14 25.48.72 2.58 1.46 5.25 2.19 8.06 1.83 7-.16 10.48-2.68 14.84-2.44 4.21-5.21 9-5.21 17.55 0 14.67 20 18 43.05 21.94 7.36 1.24 15 2.53 22.63 4.24a225.58 225.58 0 0134.08 10.68c9.72 3.73 17.4 6.68 26.43 6.68 16.18 0 28.25-9.77 39.92-19.21l2.15-1.75c5.53-4.49 21.5-4 34.34-3.64 3.46.1 6.73.2 9.65.2h6.22c13.48-.08 31.94-.18 42.23 2.5 3.75 1 6.2 3.72 9.29 7.19 5.87 6.56 13.17 14.75 33.39 14.75 19.39 0 29.55-8.71 41.32-18.8 7.16-6.13 14.56-12.48 25.07-17.86 3.92-2 7.62-3.87 11.08-5.61 22.64-11.38 35.11-17.65 35.11-27.82 0-9.91-12.24-16.5-20.34-20.86zM211.11 88.38a13.91 13.91 0 0112.47 9c1.95 5.55 1.81 10.42.21 12.94 0 0-.22-1-.36-1.44a14.85 14.85 0 00-6.44-8.59 11.35 11.35 0 00-8.94-1.47c-4.26 1.13-8.41 5-8.91 18.79-5.16-10.47-2.31-18 .92-23 2.31-3.73 7.47-6.33 11.05-6.23zm-17.5 375C192 479.24 175.2 479 170.09 478.59c-9.81-.82-21.66-4.69-33.13-8.43-4.52-1.47-9.19-3-13.73-4.34-13.2-3.89-30.12-6.74-43.72-9-3.22-.55-6.27-1.06-9.05-1.55s-4.61-1.27-5.2-2.3c-1-1.65.38-5.25 1.93-9.41C69.27 438 72.11 430.34 72 421c0-3.91-1.47-8.3-2.84-12.56-1.62-5-3.28-10.17-1.93-12.62 1.23-2.23 6.75-2.49 11.6-2.49h2.26c3.55 0 6.62.06 8.75-.53 6.51-1.81 14.86-6.92 17.81-13.88.9-2.17 1.37-6.94 2-14 .37-4.12.74-8.37 1.22-10.58a3.55 3.55 0 012.11-2.55c1.65-.77 6.78-1.91 18.63 4.08 11.18 5.65 22.88 25.84 34.2 45.37 3.56 6.14 6.92 11.94 10.3 17.36 14.04 22.54 18.83 31.6 17.5 44.8zm128.84-31.56a68.74 68.74 0 01-4.55 10.9.58.58 0 01-1.08-.42 56.61 56.61 0 002.11-18.43c-.25-4.73-.4-7.59-2.66-8.51s-4.26.83-9.45 5.54c-1.1 1-2.36 2.14-3.78 3.4-10.8 9.47-26.88 20.68-55.61 23.37-16.84 1.59-27.59-4.63-30.92-8.14a2.16 2.16 0 00-3.07-.08 2.23 2.23 0 00-.51 2.29c2.12 6.84 1.2 12.26-.49 16.19-.95 2.2-1.85 2.05-2-.34-.25-4.64-1-9.88-3-14.19-3.11-6.94-7-14.34-8.89-17.88v-.05c3.24-1.49 8.86-4.83 11.37-10.88s4.48-18-9.82-31.74c-6.28-6.05-22.1-17.16-36.06-27-10.9-7.65-22.17-15.56-23.65-17.51-4.49-5.89-6.37-9.3-6.94-19.65.07-2.3.13-4.59.19-6.89l.27-2.49a.58.58 0 011.15 0 63.07 63.07 0 002 9.72c1.08 3.73 2.4 7.58 3.62 9.18 3.19 4.22 7.56 7.39 11.67 8.49a5.48 5.48 0 005-.72c2.93-2.33 2.65-7.6 2.19-16.34-.47-9-1.11-21.34 1.85-34.55 5.62-25 10.91-32.51 17.61-42 .86-1.22 1.75-2.47 2.65-3.79 1.44-2.08 3-4.1 4.67-6.23 7.47-9.61 15.93-20.49 13.92-40.95-.51-5.19-.76-8.83-.86-11.39a1 1 0 011.88-.59l.49.77 1.21 2c4.86 8 13.64 22.57 25.1 22.57a13.62 13.62 0 002.36-.21c23.39-3.93 51.9-30.25 52.17-30.51 3.12-3 2.84-6.14 1.64-7.91a5.18 5.18 0 00-6.45-1.72c-3.29 1.4-7.14 3.15-11.22 5-13.82 6.27-37 16.75-42.25 14.34a23.11 23.11 0 01-6.32-5.13 1 1 0 011.14-1.65c5.59 2.29 9.55 1.45 14.2-.08l1-.34c9.37-3.09 14.2-4.77 30.76-12.08a97.55 97.55 0 0116.26-5.93c4-1 6.42-1.63 7.71-4.34a6.65 6.65 0 00-.5-7.13c-1.53-1.87-4.07-2.57-7-1.9-3.22.75-4.7 3-6.41 4.49-2.4 2.05-5 4.16-17.19 8.65-27 10-34.58 10.61-45.21 3.43-9.84-6.69-15.15-13.23-15.15-16 0-2.13 5.45-5.7 8.71-7.84 1.33-.87 2.59-1.69 3.62-2.46 4.34-3.22 13-11.39 13.38-11.73 5.4-5.41 17.91-2.18 25 2.58a2.23 2.23 0 001.72.41 2.14 2.14 0 001.68-2.58c-4.2-17.46-.13-27.34 4-32.55a22.58 22.58 0 0117.48-8.48c12.81 0 21.76 10 21.76 24.42 0 11-2.82 16.79-5.48 20.3a1.73 1.73 0 01-2.58.18 1.78 1.78 0 01-.24-2.2A24.61 24.61 0 00290 114a16.58 16.58 0 00-16.84-16.67c-3.94 0-13.48 1.5-16.77 15.44a29.81 29.81 0 00-.34 11.07l.08.71c.9 7.38 15.3 12.51 27.23 15.51 11.36 2.85 13 6.22 8.84 19.63s3.11 26.23 5.7 29.57a78.3 78.3 0 018.31 12.47 93.8 93.8 0 016.62 16.48c2.17 6.79 4.05 12.65 10.63 21.22 11.07 14.4 17.66 48.64 15 78-.21 2.41-.53 4.29-.77 5.67-.43 2.53-.72 4.2.66 5.38s3.16.7 7.26-.63l3.43-1.09a109.33 109.33 0 0112.58-2.8 2.15 2.15 0 001.59-1.16c3.43-6.91 3.85-15.22 4-22.47q0-1.31.06-2.79c.19-7.77.45-18.93-2.95-32a1 1 0 011.93-.64 93 93 0 016.66 25.55c2.55 22.58-1.9 32.09-1.94 32.17a1.61 1.61 0 00.95 2.25 17.12 17.12 0 016.95 4.67c1.46 1.66.93 2.4-1.14 1.62a36.26 36.26 0 00-12.77-2.29c-10.4 0-18.09 4.95-21.51 9.19-3.19 3.94-3.7 7.67-3.83 11.27l-.06.05c-7.48-.75-12.94 1.21-17.47 6.21l-.08.09c-6.26 7.75-4 24.63-1.29 38.48 1.28 6.45 5.59 25.52 1.73 37.68zm96.1 10.07c-15.71 6.71-25.43 14.51-34 21.39-5.65 4.53-11 8.81-17.28 12.14-10.12 5.34-24.91 6.53-33.27-7.7-2.37-4-.71-9.86 1.58-17.95 3.05-10.75 7.23-25.46 3.71-44.65-.94-5.12-1.77-9.51-2.49-13.31C334 377 332.9 371.43 334 367c.63-2.45 3.43-3 5.87-3a20.83 20.83 0 012.63.19 29.51 29.51 0 007 12.1c5.7 5.86 13.63 8.83 23.56 8.85 2.1.17 25.94 1.55 36.54-22.4 1.46.18 3.65.7 4.3 2.3 1.28 3.19-.27 8.91-1.52 13.5-.9 3.31-1.68 6.16-1.63 8.37.31 16 11 22.78 25.83 32.16 1.79 1.13 3.66 2.31 5.55 3.54S445 425 445 426c-.52 4.79-20 13.16-26.45 15.91z"
                }
            }
        ]
    })(props);
}
function IoLogoTwitch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 32l-32 80v304h96v64h64l64-64h80l112-112V32zm336 256l-64 64h-96l-64 64v-64h-80V80h304z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M320 143h48v129h-48zm-112 0h48v129h-48z"
                }
            }
        ]
    })(props);
}
function IoLogoTwitter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 109.5a201.8 201.8 0 01-56.55 15.3 97.51 97.51 0 0043.33-53.6 197.74 197.74 0 01-62.56 23.5A99.14 99.14 0 00348.31 64c-54.42 0-98.46 43.4-98.46 96.9a93.21 93.21 0 002.54 22.1 280.7 280.7 0 01-203-101.3A95.69 95.69 0 0036 130.4c0 33.6 17.53 63.3 44 80.7A97.5 97.5 0 0135.22 199v1.2c0 47 34 86.1 79 95a100.76 100.76 0 01-25.94 3.4 94.38 94.38 0 01-18.51-1.8c12.51 38.5 48.92 66.5 92.05 67.3A199.59 199.59 0 0139.5 405.6a203 203 0 01-23.5-1.4A278.68 278.68 0 00166.74 448c181.36 0 280.44-147.7 280.44-275.8 0-4.2-.11-8.4-.31-12.5A198.48 198.48 0 00496 109.5z"
                }
            }
        ]
    })(props);
}
function IoLogoUsd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 480v-36.42C160.53 439 112.25 398.06 112 336h72c1.77 26.34 23.86 46.45 56 50v-98l-26.77-7c-61-14.18-93.64-49.39-93.64-102.08C119.59 116.81 164.08 76.08 240 70V32h32v38c77.39 6.3 119 47.74 120 106h-72c-.76-24.06-15.83-43.39-48-46v92l30.82 7.28C367.61 243.46 400 277 400 332c0 64.34-43.74 105.88-128 111.32V480zm0-264v-86c-27.59 1.52-47.27 18.47-47.27 42.53 0 22.3 16.39 36.88 47.27 43.47zm32 78v92c38.15-1.54 56.38-18.92 56.38-45.77 0-24.58-18.23-41.13-56.38-46.23z"
                }
            }
        ]
    })(props);
}
function IoLogoVenmo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M444.17 32H70.28C49.85 32 32 46.7 32 66.89V441.6c0 20.31 17.85 38.4 38.28 38.4h373.78c20.54 0 35.94-18.2 35.94-38.39V66.89C480.12 46.7 464.6 32 444.17 32zM278 387H174.32l-41.57-248.56 90.75-8.62 22 176.87c20.53-33.45 45.88-86 45.88-121.87 0-19.62-3.36-33-8.61-44l82.63-16.72c9.56 15.78 13.86 32 13.86 52.57-.01 65.5-55.92 150.59-101.26 210.33z"
                }
            }
        ]
    })(props);
}
function IoLogoVercel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M256 48l240 416H16z"
                }
            }
        ]
    })(props);
}
function IoLogoVimeo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476.9 114c-5-23.39-17.51-38.78-40.61-46.27s-64.92-4.5-94.12 16.79c-26.79 19.51-46.26 54.42-54 78.28a4 4 0 005.13 5c10.77-3.8 21.72-7.1 34-6.45 15 .8 24.51 12 24.91 25.29.3 9.79-.2 18.69-3.6 27.68-10.74 28.68-27.61 56.46-47.55 80.75a72.49 72.49 0 01-10 9.89c-10.21 8.29-18.81 6.1-25.41-5.2-5.4-9.29-9-18.88-12.2-29.08-12.4-39.67-16.81-80.84-23.81-121.52-3.3-19.48-7-39.77-18-56.86-11.6-17.79-28.61-24.58-50-22-14.7 1.8-36.91 17.49-47.81 26.39 0 0-56 46.87-81.82 71.35l21.2 27s17.91-12.49 27.51-18.29c5.7-3.39 12.4-4.09 17.2.2 4.51 3.9 9.61 9 12.31 14.1 5.7 10.69 11.2 21.88 14.7 33.37 13.2 44.27 25.51 88.64 37.81 133.22 6.3 22.78 13.9 44.17 28 63.55 19.31 26.59 39.61 32.68 70.92 21.49 25.41-9.09 46.61-26.18 66-43.87 33.11-30.18 59.12-65.36 85.52-101.14 20.41-27.67 37.31-55.67 51.41-86.95C478.5 179.74 484 147.26 476.9 114z"
                }
            }
        ]
    })(props);
}
function IoLogoVk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M484.7 132c3.56-11.28 0-19.48-15.75-19.48h-52.37c-13.21 0-19.31 7.18-22.87 14.86 0 0-26.94 65.6-64.56 108.13-12.2 12.3-17.79 16.4-24.4 16.4-3.56 0-8.14-4.1-8.14-15.37V131.47c0-13.32-4.06-19.47-15.25-19.47H199c-8.14 0-13.22 6.15-13.22 12.3 0 12.81 18.81 15.89 20.84 51.76V254c0 16.91-3 20-9.66 20-17.79 0-61-66.11-86.92-141.44C105 117.64 99.88 112 86.66 112H33.79C18.54 112 16 119.17 16 126.86c0 13.84 17.79 83.53 82.86 175.77 43.21 63 104.72 96.86 160.13 96.86 33.56 0 37.62-7.69 37.62-20.5v-47.66c0-15.37 3.05-17.93 13.73-17.93 7.62 0 21.35 4.09 52.36 34.33C398.28 383.6 404.38 400 424.21 400h52.36c15.25 0 22.37-7.69 18.3-22.55-4.57-14.86-21.86-36.38-44.23-62-12.2-14.34-30.5-30.23-36.09-37.92-7.62-10.25-5.59-14.35 0-23.57-.51 0 63.55-91.22 70.15-122"
                }
            }
        ]
    })(props);
}
function IoLogoVue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 144.03l-55.49-96.11h-79.43L256 281.61 390.92 47.92h-79.43L256 144.03z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M409.4 47.92L256 313.61 102.6 47.92H15.74L256 464.08 496.26 47.92H409.4z"
                }
            }
        ]
    })(props);
}
function IoLogoWebComponent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M179.9 388l-76.16-132 76.16 132zm0 0h152.21l76.15-132-76.15-132H179.9l-76.16 132 76.16 132zm-76.16-132l76.16-132-76.16 132z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M496 256L376 48H239.74l-43.84 76h136.21l76.15 132-76.15 132H195.9l43.84 76H376l120-208z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M179.9 388l-76.16-132 76.16-132 43.84-76H136L16 256l120 208h87.74l-43.84-76z"
                }
            }
        ]
    })(props);
}
function IoLogoWechat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408.67 298.53a21 21 0 1120.9-21 20.85 20.85 0 01-20.9 21m-102.17 0a21 21 0 1120.9-21 20.84 20.84 0 01-20.9 21m152.09 118.86C491.1 394.08 512 359.13 512 319.51c0-71.08-68.5-129.35-154.41-129.35s-154.42 58.27-154.42 129.35 68.5 129.34 154.42 129.34c17.41 0 34.83-2.33 49.92-7 2.49-.86 3.48-1.17 4.64-1.17a16.67 16.67 0 018.13 2.34L454 462.83a11.62 11.62 0 003.48 1.17 5 5 0 004.65-4.66 14.27 14.27 0 00-.77-3.86c-.41-1.46-5-16-7.36-25.27a18.94 18.94 0 01-.33-3.47 11.4 11.4 0 015-9.35"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M246.13 178.51a24.47 24.47 0 010-48.94c12.77 0 24.38 11.65 24.38 24.47 1.16 12.82-10.45 24.47-24.38 24.47m-123.06 0A24.47 24.47 0 11147.45 154a24.57 24.57 0 01-24.38 24.47M184.6 48C82.43 48 0 116.75 0 203c0 46.61 24.38 88.56 63.85 116.53C67.34 321.84 68 327 68 329a11.38 11.38 0 01-.66 4.49C63.85 345.14 59.4 364 59.21 365s-1.16 3.5-1.16 4.66a5.49 5.49 0 005.8 5.83 7.15 7.15 0 003.49-1.17L108 351c3.49-2.33 5.81-2.33 9.29-2.33a16.33 16.33 0 015.81 1.16c18.57 5.83 39.47 8.16 60.37 8.16h10.45a133.24 133.24 0 01-5.81-38.45c0-78.08 75.47-141 168.35-141h10.45C354.1 105.1 277.48 48 184.6 48"
                }
            }
        ]
    })(props);
}
function IoLogoWhatsapp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M414.73 97.1A222.14 222.14 0 00256.94 32C134 32 33.92 131.58 33.87 254a220.61 220.61 0 0029.78 111L32 480l118.25-30.87a223.63 223.63 0 00106.6 27h.09c122.93 0 223-99.59 223.06-222A220.18 220.18 0 00414.73 97.1zM256.94 438.66h-.08a185.75 185.75 0 01-94.36-25.72l-6.77-4-70.17 18.32 18.73-68.09-4.41-7A183.46 183.46 0 0171.53 254c0-101.73 83.21-184.5 185.48-184.5a185 185 0 01185.33 184.64c-.04 101.74-83.21 184.52-185.4 184.52zm101.69-138.19c-5.57-2.78-33-16.2-38.08-18.05s-8.83-2.78-12.54 2.78-14.4 18-17.65 21.75-6.5 4.16-12.07 1.38-23.54-8.63-44.83-27.53c-16.57-14.71-27.75-32.87-31-38.42s-.35-8.56 2.44-11.32c2.51-2.49 5.57-6.48 8.36-9.72s3.72-5.56 5.57-9.26.93-6.94-.46-9.71-12.54-30.08-17.18-41.19c-4.53-10.82-9.12-9.35-12.54-9.52-3.25-.16-7-.2-10.69-.2a20.53 20.53 0 00-14.86 6.94c-5.11 5.56-19.51 19-19.51 46.28s20 53.68 22.76 57.38 39.3 59.73 95.21 83.76a323.11 323.11 0 0031.78 11.68c13.35 4.22 25.5 3.63 35.1 2.2 10.71-1.59 33-13.42 37.63-26.38s4.64-24.06 3.25-26.37-5.11-3.71-10.69-6.48z"
                }
            }
        ]
    })(props);
}
function IoLogoWindows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 265H232v179l248 36V265zm-264 0H32v150l184 26.7V265zM480 32L232 67.4V249h248V32zM216 69.7L32 96v153h184V69.7z"
                }
            }
        ]
    })(props);
}
function IoLogoWordpress(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M259 271.3L226.2 367h-.1l-25.4 73.1c1.8.5 3.5.9 5.3 1.4h.3a192.51 192.51 0 0049.5 6.5 157 157 0 0024.9-1.8 184.3 184.3 0 0032.5-7.1c2.6-.8 5.2-1.7 7.8-2.6-2.8-6-8.8-19.3-9.1-19.9zM80.8 180.5C70.8 203.1 64 230.9 64 256c0 6.3.3 12.6.9 18.8 6.9 71.2 52.9 131 116.1 157.9 2.6 1.1 5.3 2.2 8 3.2L96 180.6c-8-.3-9.5.2-15.2-.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M430.2 175.4a188 188 0 00-15.1-26.6c-1.6-2.4-3.4-4.8-5.1-7.2A193 193 0 00325.1 77a189.2 189.2 0 00-69.2-13 191.51 191.51 0 00-149.4 71.7A196 196 0 0089 161.3c14.2.1 31.8.1 33.8.1 18.1 0 46-2.2 46-2.2 9.4-.6 10.4 13.1 1.1 14.2 0 0-9.4 1.1-19.8 1.6L213 362l37.8-113.3-26.8-73.6c-9.4-.5-18.1-1.6-18.1-1.6-9.4-.5-8.2-14.8 1-14.2 0 0 28.5 2.2 45.5 2.2 18.1 0 46-2.2 46-2.2 9.3-.6 10.5 13.1 1.1 14.2 0 0-9.3 1.1-19.7 1.6l62.3 185.6 17.3-57.6c8.7-22.4 13.1-40.9 13.1-55.7 0-21.3-7.7-36.1-14.3-47.6-8.7-14.3-16.9-26.3-16.9-40.4 0-15.9 12-30.7 29-30.7h2.2c26.2-.7 34.8 25.3 35.9 43v.6c.4 7.2.1 12.5.1 18.8 0 17.4-3.3 37.1-13.1 61.8l-39 112.8-22.3 65.7c1.8-.8 3.5-1.6 5.3-2.5 56.7-27.4 98-82 106.7-146.7a172.07 172.07 0 001.9-26 191.11 191.11 0 00-17.8-80.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48a208.06 208.06 0 0181 399.66A208.06 208.06 0 01175 64.34 206.7 206.7 0 01256 48m0-16C132.29 32 32 132.29 32 256s100.29 224 224 224 224-100.29 224-224S379.71 32 256 32z"
                }
            }
        ]
    })(props);
}
function IoLogoXbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M126.8 248.3c39.7-58.6 77.9-92.8 77.9-92.8s-42.1-48.9-92.8-67.4l-3.3-.8A224.13 224.13 0 0077.2 391c0-4.4.6-70.3 49.6-142.7zM480 256a223.71 223.71 0 00-76.6-168.7l-3.2.9c-50.7 18.5-92.9 67.4-92.9 67.4s38.2 34.2 77.9 92.8c49 72.4 49.6 138.3 49.5 142.7A222.8 222.8 0 00480 256zM201.2 80.9c29.3 13.1 54.6 34.6 54.6 34.6s25.5-21.4 54.8-34.6c36.8-16.5 64.9-11.3 72.3-9.5a224.06 224.06 0 00-253.8 0c7.2-1.8 35.2-7.1 72.1 9.5zm157.5 212C312.4 236 255.8 199 255.8 199s-56.3 37-102.7 93.9c-39.8 48.9-54.6 84.8-62.6 107.8l-1.3 4.8a224 224 0 00333.6 0l-1.4-4.8c-8-23-22.9-58.9-62.7-107.8z"
                }
            }
        ]
    })(props);
}
function IoLogoXing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.8 303.9L469 32H365L209.4 303.8a1.35 1.35 0 000 1.7l98.9 173.8c.4.7.8.7 1.6.7H413l-99.3-174.7a1.74 1.74 0 01.1-1.4zm-91.9-87.7L163 113a2 2 0 00-2-1H65l58.9 104.4a1.13 1.13 0 01.1.8L43 352h96.8a1.54 1.54 0 001.6-.9l80.5-133.7a2.44 2.44 0 000-1.2z"
                }
            }
        ]
    })(props);
}
function IoLogoYahoo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M410.32 37.13c-13.56 0-27-.93-39.12-5.13L256 218.67 140.8 32c-12.12 4.2-24.84 5.13-38.4 5.13-13.32 0-26.52-1.05-38.4-5.13l153.6 248.15V480c12-4.08 25-5.13 38.4-5.13s26.4 1.05 38.4 5.13V280.5L448 32c-11.88 4-24.36 5.13-37.68 5.13z"
                }
            }
        ]
    })(props);
}
function IoLogoYen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 32h-80L256 253.13 144 32H64l112.37 208H128v48h73.56L216 319v17h-88v48h88v96h80v-96h88v-48h-88v-17l14.89-31H384v-48h-48.29z"
                }
            }
        ]
    })(props);
}
function IoLogoYoutube(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M508.64 148.79c0-45-33.1-81.2-74-81.2C379.24 65 322.74 64 265 64h-18c-57.6 0-114.2 1-169.6 3.6C36.6 67.6 3.5 104 3.5 149 1 184.59-.06 220.19 0 255.79q-.15 53.4 3.4 106.9c0 45 33.1 81.5 73.9 81.5 58.2 2.7 117.9 3.9 178.6 3.8q91.2.3 178.6-3.8c40.9 0 74-36.5 74-81.5 2.4-35.7 3.5-71.3 3.4-107q.34-53.4-3.26-106.9zM207 353.89v-196.5l145 98.2z"
                }
            }
        ]
    })(props);
}
function IoMagnetOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M421.83 293.82A144 144 0 00218.18 90.17m135.76 135.77a48 48 0 00-67.88-67.88"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M192 464v-48m-101.82 5.82l33.94-33.94M48 320h48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M286.06 158.06L172.92 271.19a32 32 0 01-45.25 0L105 248.57a32 32 0 010-45.26L218.18 90.17m203.65 203.65L308.69 407a32 32 0 01-45.26 0l-22.62-22.63a32 32 0 010-45.26l113.13-113.17M139.6 169.98l67.88 67.89m67.88 67.88l67.89 67.88"
                }
            }
        ]
    })(props);
}
function IoMagnetSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M191.98 463.58v-48M90.16 421.4l33.94-33.94m-76.12-67.88h48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M422.2 89.82a144 144 0 00-203.71-.07l-67.88 67.88 67.88 67.89 67.88-67.89a48 48 0 0168.46.59c18.3 18.92 17.48 49.24-1.14 67.86l-67.32 67.32 67.88 67.88 66.91-66.91c56.37-56.37 57.37-148.15 1.04-204.55zM82.718 225.517l45.255-45.254 67.883 67.882L150.6 293.4zM218.49 361.27l45.254-45.254 67.882 67.882-45.255 45.255z"
                }
            }
        ]
    })(props);
}
function IoMagnet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M191.98 463.79v-48m-101.82 5.82l33.94-33.94m-76.12-67.88h48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M267.56 312.32l-31.11 31.11a16 16 0 000 22.63l45.26 45.25a16 16 0 0022.62 0l31.12-31.11a4 4 0 000-5.66l-62.23-62.22a4 4 0 00-5.66 0zM131.8 176.55l-31.11 31.12a16 16 0 000 22.62l45.25 45.26a16 16 0 0022.63 0l31.11-31.11a4 4 0 000-5.66l-62.22-62.23a4 4 0 00-5.66 0zm297.05-93.27a144 144 0 00-203.71-.06l-65.06 65.05a4 4 0 000 5.66l62.23 62.22a4 4 0 005.66 0l65-65.05a48 48 0 0168.46.59c18.3 18.92 17.47 49.24-1.14 67.85L295.85 284a4 4 0 000 5.66l62.22 62.23a4 4 0 005.66 0l64.08-64.08c56.37-56.34 57.37-148.13 1.04-204.53z"
                }
            }
        ]
    })(props);
}
function IoMailOpenOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M441.6 171.61L266.87 85.37a24.57 24.57 0 00-21.74 0L70.4 171.61A40 40 0 0048 207.39V392c0 22.09 18.14 40 40.52 40h335c22.38 0 40.52-17.91 40.52-40V207.39a40 40 0 00-22.44-35.78z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M397.33 368L268.07 267.46a24 24 0 00-29.47 0L109.33 368m200-73l136-103m-384 0l139 105"
                }
            }
        ]
    })(props);
}
function IoMailOpenSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M471.05 168.36L263.24 65.69a16.37 16.37 0 00-14.48 0L41 168.36a16 16 0 00-9 14.31V432a16.09 16.09 0 0016.19 16h415.62A16.09 16.09 0 00480 432V182.67a16 16 0 00-8.95-14.31zM256 97.89l173 85.44-175.7 86.78-173-85.44z"
                }
            }
        ]
    })(props);
}
function IoMailOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448.67 154.45L274.1 68.2a41.1 41.1 0 00-36.2 0L63.33 154.45A55.6 55.6 0 0032 204.53v184.61c0 30.88 25.42 56 56.67 56h334.66c31.25 0 56.67-25.12 56.67-56V204.53a55.6 55.6 0 00-31.33-50.08zM252.38 96.82a8.22 8.22 0 017.24 0L429 180.48l-172 85a8.22 8.22 0 01-7.24 0L80.35 181.81z"
                }
            }
        ]
    })(props);
}
function IoMailOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "416",
                    "height": "320",
                    "x": "48",
                    "y": "96",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "40",
                    "ry": "40"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M112 160l144 112 144-112"
                }
            }
        ]
    })(props);
}
function IoMailSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 80H48a16 16 0 00-16 16v320a16 16 0 0016 16h416a16 16 0 0016-16V96a16 16 0 00-16-16zM265.82 284.63a16 16 0 01-19.64 0L89.55 162.81l19.64-25.26L256 251.73l146.81-114.18 19.64 25.26z"
                }
            }
        ]
    })(props);
}
function IoMailUnreadOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 96H88a40 40 0 00-40 40v240a40 40 0 0040 40h334.73a40 40 0 0040-40V239"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M112 160l144 112 87-65.67"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "431.95",
                    "cy": "128.05",
                    "r": "47.95"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M432 192a63.95 63.95 0 1163.95-63.95A64 64 0 01432 192zm0-95.9a32 32 0 1031.95 32 32 32 0 00-31.95-32z"
                }
            }
        ]
    })(props);
}
function IoMailUnreadSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M374.09 101c-.11.23-.21.46-.31.7-.34.75-.67 1.5-1 2.26l-.36.9c-.27.71-.54 1.42-.79 2.14-.12.35-.24.7-.35 1-.23.68-.44 1.37-.64 2.07l-.33 1.15q-.27 1-.51 2c-.1.41-.2.82-.28 1.23-.15.67-.28 1.36-.4 2-.08.42-.16.84-.23 1.27-.11.69-.2 1.4-.29 2.1-.05.42-.11.83-.16 1.25-.08.77-.13 1.54-.19 2.31 0 .36-.06.72-.08 1.09-.06 1.13-.09 2.27-.09 3.41 0 1 0 2 .07 2.94v.62c.05.95.12 1.89.21 2.83l.06.46c.09.87.2 1.72.32 2.57 0 .15 0 .31.07.46.14.92.31 1.84.49 2.75l.12.59c.2.92.4 1.84.64 2.75.23.92.5 1.82.77 2.71.06.19.12.38.17.57.28.88.57 1.74.88 2.59.05.15.11.29.16.43.29.78.6 1.55.92 2.32.05.14.11.28.17.42.35.83.73 1.65 1.11 2.47l.27.53c.4.82.81 1.64 1.24 2.44a64.21 64.21 0 0029.56 27.63l.37.17c1.78.8 3.59 1.53 5.45 2.17l.95.32 1.5.47c.45.14.9.26 1.36.39l1.92.5c.57.14 1.14.27 1.72.39l1.15.24 1.83.32.93.16c.9.13 1.81.24 2.72.34l.77.07c.73.07 1.47.13 2.22.17l.85.05c1 0 1.94.07 2.93.07 1.15 0 2.29 0 3.43-.09l1.09-.09c.77 0 1.54-.11 2.3-.19.42 0 .83-.1 1.25-.16.7-.08 1.41-.17 2.1-.28l1.27-.23c.68-.12 1.36-.25 2-.39l1.24-.29c.67-.16 1.35-.32 2-.51.39-.1.78-.21 1.16-.33.69-.2 1.37-.41 2.05-.63l1.07-.36c.7-.24 1.4-.5 2.1-.77l.94-.37c.74-.3 1.47-.62 2.19-.95l.77-.34c.8-.37 1.58-.77 2.36-1.17.17-.09.35-.17.52-.27.91-.48 1.8-1 2.68-1.5l.12-.07a63.95 63.95 0 10-89.21-84.88l-.21.39c-.3 1.03-.72 1.86-1.11 2.69z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M371.51 202.43l-105.69 82.2a16 16 0 01-19.64 0L89.55 162.81l19.64-25.26L256 251.73l94.36-73.39A95.81 95.81 0 01349 80H48a16 16 0 00-16 16v320a16 16 0 0016 16h416a16 16 0 0016-16V211.13a95.75 95.75 0 01-108.49-8.7z"
                }
            }
        ]
    })(props);
}
function IoMailUnread(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 128.05A64 64 0 00389.62 80a64.52 64.52 0 00-12.71 15.3v.06c-.54.9-1.05 1.82-1.55 2.74l-.24.49c-.42.79-.81 1.59-1.19 2.4-.12.25-.23.5-.34.75-.33.73-.65 1.47-.95 2.22-.13.31-.25.62-.37.93-.27.7-.53 1.4-.78 2.11l-.36 1.06c-.22.68-.43 1.37-.63 2.06-.12.39-.23.77-.33 1.16-.19.67-.35 1.35-.51 2-.1.41-.2.82-.29 1.23-.14.68-.27 1.37-.39 2-.08.42-.16.84-.23 1.26-.11.7-.2 1.41-.29 2.12-.05.41-.11.82-.16 1.24-.08.77-.13 1.54-.19 2.32 0 .36-.06.72-.08 1.08-.06 1.14-.1 2.28-.1 3.44 0 1 0 2 .08 2.94v.64q.08 1.41.21 2.82l.06.48c.09.85.19 1.69.32 2.52 0 .17 0 .35.07.52.14.91.31 1.81.49 2.71 0 .22.09.43.13.65.18.86.38 1.72.6 2.57v.19c.23.89.48 1.76.75 2.63l.21.68c.27.85.55 1.68.85 2.51.06.18.13.36.2.54.27.71.55 1.42.84 2.12.08.21.16.41.25.61.34.79.69 1.58 1.06 2.36l.33.67c.35.7.7 1.4 1.07 2.09a64.34 64.34 0 0022.14 23.81 62.22 62.22 0 007.62 4.15l.39.18q2.66 1.2 5.43 2.16l.95.32 1.5.47c.45.14.9.26 1.36.39l1.92.5 1.73.4 1.15.23 1.83.33.94.15c.9.13 1.81.25 2.72.35l.77.07c.73.06 1.47.12 2.21.16l.86.05c1 0 1.94.08 2.92.08 1.16 0 2.3 0 3.44-.1l1.08-.08c.78-.06 1.55-.11 2.32-.19l1.25-.16c.7-.09 1.41-.18 2.11-.29l1.26-.23c.68-.12 1.37-.25 2-.39l1.23-.29c.68-.16 1.36-.32 2-.51.39-.1.77-.21 1.16-.33.69-.2 1.38-.41 2.06-.63l1.06-.36c.71-.25 1.41-.51 2.11-.78l.93-.37c.75-.3 1.49-.62 2.22-.95l.75-.34c.81-.38 1.61-.77 2.4-1.19l.49-.24c.92-.5 1.84-1 2.74-1.55h.06A64.52 64.52 0 00480 170.38a63.81 63.81 0 0016-42.33z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M371.38 202.53l-105.56 82.1a16 16 0 01-19.64 0l-144-112a16 16 0 1119.64-25.26L256 251.73l94.22-73.28A95.86 95.86 0 01348.81 80H88a56.06 56.06 0 00-56 56v240a56.06 56.06 0 0056 56h336a56.06 56.06 0 0056-56V211.19a95.85 95.85 0 01-108.62-8.66z"
                }
            }
        ]
    })(props);
}
function IoMail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M424 80H88a56.06 56.06 0 00-56 56v240a56.06 56.06 0 0056 56h336a56.06 56.06 0 0056-56V136a56.06 56.06 0 00-56-56zm-14.18 92.63l-144 112a16 16 0 01-19.64 0l-144-112a16 16 0 1119.64-25.26L256 251.73l134.18-104.36a16 16 0 0119.64 25.26z"
                }
            }
        ]
    })(props);
}
function IoMaleFemaleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "216",
                    "cy": "200",
                    "r": "136",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M216 352v128m56-64H160m272-304V32h-80m-16.72 96.72L432 32"
                }
            }
        ]
    })(props);
}
function IoMaleFemaleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M330 16v44h42.89l-37.1 37.09A157.67 157.67 0 00216 42c-87.12 0-158 70.88-158 158 0 79.66 59.26 145.72 136 156.46V394h-50v44h50v58h44v-58h50v-44h-50v-37.54c76.74-10.74 136-76.8 136-156.46a157.23 157.23 0 00-14-64.93l44-44V134h44V16zM216 314a114 114 0 11114-114 114.13 114.13 0 01-114 114z"
                }
            }
        ]
    })(props);
}
function IoMaleFemale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M426 16h-74a22 22 0 000 44h20.89l-37.1 37.09A157.68 157.68 0 00216 42c-87.12 0-158 70.88-158 158 0 79.66 59.26 145.72 136 156.46V394h-28a22 22 0 000 44h28v36a22 22 0 0044 0v-36h28a22 22 0 000-44h-28v-37.54c76.74-10.74 136-76.8 136-156.46a157.15 157.15 0 00-14-64.92l44-44V112a22 22 0 0044 0V38a22 22 0 00-22-22zM216 314a114 114 0 11114-114 114.13 114.13 0 01-114 114z"
                }
            }
        ]
    })(props);
}
function IoMaleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "216",
                    "cy": "296",
                    "r": "152",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M448 160V64h-96m-28 124L448 64"
                }
            }
        ]
    })(props);
}
function IoMaleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M330 48v44h58.89l-60.39 60.39c-68.2-52.86-167-48-229.54 14.57C31.12 234.81 31.12 345.19 99 413a174.21 174.21 0 00246 0c62.57-62.58 67.43-161.34 14.57-229.54L420 123.11V182h44V48zm-16.08 333.92a130.13 130.13 0 01-183.84 0c-50.69-50.68-50.69-133.16 0-183.84s133.16-50.69 183.84 0 50.69 133.16 0 183.84z"
                }
            }
        ]
    })(props);
}
function IoMale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M442 48h-90a22 22 0 000 44h36.89l-60.39 60.39c-68.19-52.86-167-48-229.54 14.57C31.12 234.81 31.12 345.19 99 413a174.21 174.21 0 00246 0c62.57-62.58 67.43-161.35 14.57-229.54L420 123.11V160a22 22 0 0044 0V70a22 22 0 00-22-22zM313.92 381.92a130.13 130.13 0 01-183.84 0c-50.69-50.68-50.69-133.16 0-183.84s133.16-50.69 183.84 0 50.69 133.16 0 183.84z"
                }
            }
        ]
    })(props);
}
function IoManOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M208 208v264a23.73 23.73 0 0024 24h0a23.73 23.73 0 0024-24"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 336v136a23.73 23.73 0 0024 24h0a23.73 23.73 0 0024-24V208"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M208 192v88a23.72 23.72 0 01-24 24h0a23.72 23.72 0 01-24-24v-88a48 48 0 0148-48h96a48 48 0 0148 48v88a23.72 23.72 0 01-24 24h0a23.72 23.72 0 01-24-24v-88"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "56",
                    "r": "40",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function IoManSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "56",
                    "r": "56"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M336 128H176a32 32 0 00-32 32v160h48V192h8v320h52V328h8v184h52V192h8v128h48V160a32 32 0 00-32-32z"
                }
            }
        ]
    })(props);
}
function IoMan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "56",
                    "r": "56"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M304 128h-96a64.19 64.19 0 00-64 64v107.52c0 10.85 8.43 20.08 19.27 20.47A20 20 0 00184 300v-99.73a8.18 8.18 0 017.47-8.25 8 8 0 018.53 8V489a23 23 0 0023 23 23 23 0 0023-23V346.34a10.24 10.24 0 019.33-10.34A10 10 0 01266 346v143a23 23 0 0023 23 23 23 0 0023-23V200.27a8.18 8.18 0 017.47-8.25 8 8 0 018.53 8v99.52c0 10.85 8.43 20.08 19.27 20.47A20 20 0 00368 300V192a64.19 64.19 0 00-64-64z"
                }
            }
        ]
    })(props);
}
function IoMapOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M313.27 124.64L198.73 51.36a32 32 0 00-29.28.35L56.51 127.49A16 16 0 0048 141.63v295.8a16 16 0 0023.49 14.14l97.82-63.79a32 32 0 0129.5-.24l111.86 73a32 32 0 0029.27-.11l115.43-75.94a16 16 0 008.63-14.2V74.57a16 16 0 00-23.49-14.14l-98 63.86a32 32 0 01-29.24.35zM328 128v336M184 48v336"
                }
            }
        ]
    })(props);
}
function IoMapSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M327.71 130.93L184 39 32 144v336l152.29-98.93L328 473l152-105V32zM312 421l-112-72V91l112 72z"
                }
            }
        ]
    })(props);
}
function IoMap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48.17 113.34A32 32 0 0032 141.24V438a32 32 0 0047 28.37c.43-.23.85-.47 1.26-.74l84.14-55.05a8 8 0 003.63-6.72V46.45a8 8 0 00-12.51-6.63zm164.19-74.03A8 8 0 00200 46v357.56a8 8 0 003.63 6.72l96 62.42A8 8 0 00312 466V108.67a8 8 0 00-3.64-6.73zm252.17 7.16a31.64 31.64 0 00-31.5-.88 12.07 12.07 0 00-1.25.74l-84.15 55a8 8 0 00-3.63 6.72v357.46a8 8 0 0012.52 6.63l107.07-73.46a32 32 0 0016.41-28v-296a32.76 32.76 0 00-15.47-28.21z"
                }
            }
        ]
    })(props);
}
function IoMedalOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "352",
                    "r": "112",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "352",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M147 323L41.84 159.32a32 32 0 01-1.7-31.61l31-62A32 32 0 0199.78 48h312.44a32 32 0 0128.62 17.69l31 62a32 32 0 01-1.7 31.61L365 323m6-179H37m391.74-91.4L305 250M140.55 144L207 250"
                }
            }
        ]
    })(props);
}
function IoMedalSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 32L16 160h289.11l80.22-128H80z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M496 144L424 32 298 231.08a128 128 0 00-84 0L189.53 192H43.82l86.66 134.89a128 128 0 10251 0zM256 422a70 70 0 1170-70 70.08 70.08 0 01-70 70z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "352",
                    "r": "32"
                }
            }
        ]
    })(props);
}
function IoMedal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "352",
                    "r": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M99.78 32a48 48 0 00-42.94 26.53l-31 62A48.26 48.26 0 0024.28 160h278.2a4 4 0 003.39-1.87l75.5-120A4 4 0 00378 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M486.17 120.56l-31-62a47.7 47.7 0 00-32.79-25.46L342.5 160 298 231.08a128 128 0 00-84 0l-23.32-37.2a4 4 0 00-3.39-1.88H51.14a4 4 0 00-3.36 6.16l82.7 128.73a128 128 0 10251 0L483.62 168a48.22 48.22 0 002.55-47.44zm-226 295.31a64 64 0 1159.69-59.69 64.08 64.08 0 01-59.68 59.69z"
                }
            }
        ]
    })(props);
}
function IoMedicalOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M429.93 174.27l-16.47-28.59a15.49 15.49 0 00-21.15-5.7l-98.39 57a4 4 0 01-6-3.5L288 80a16 16 0 00-16-16h-32a16 16 0 00-16 16l.07 113.57a4 4 0 01-6 3.5l-98.39-57a15.49 15.49 0 00-21.15 5.7l-16.46 28.6a15.42 15.42 0 005.69 21.1l98.49 57.08a4 4 0 010 6.9l-98.49 57.08a15.54 15.54 0 00-5.69 21.1l16.47 28.59a15.49 15.49 0 0021.15 5.7l98.39-57a4 4 0 016 3.5L224 432a16 16 0 0016 16h32a16 16 0 0016-16l-.07-113.67a4 4 0 016-3.5l98.39 57a15.49 15.49 0 0021.15-5.7l16.47-28.59a15.42 15.42 0 00-5.69-21.1l-98.49-57.08a4 4 0 010-6.9l98.49-57.08a15.51 15.51 0 005.68-21.11z"
                }
            }
        ]
    })(props);
}
function IoMedicalSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M351.9 256L460 193.6l-48-83.2-108 62.4V48h-96v124.8l-108-62.4-48 83.2L160.1 256 52 318.4l48 83.2 108-62.4V464h96V339.2l108 62.4 48-83.2L351.9 256z"
                }
            }
        ]
    })(props);
}
function IoMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 464h-32a32 32 0 01-32-32l.05-85.82a4 4 0 00-6-3.47l-74.34 43.06a31.48 31.48 0 01-43-11.52l-16.5-28.64-.06-.1a31.65 31.65 0 0111.56-42.8l74.61-43.25a4 4 0 000-6.92l-74.54-43.21a31.41 31.41 0 01-11.55-43l16.44-28.55a31.48 31.48 0 0119.27-14.74 31.14 31.14 0 0123.8 3.2l74.31 43a4 4 0 006-3.47L208 80a32 32 0 0132-32h32a32 32 0 0132 32v85.72a4 4 0 006 3.47l74.34-43.06a31.51 31.51 0 0143 11.52l16.49 28.64.06.09a31.52 31.52 0 01-11.64 42.86l-74.53 43.2a4 4 0 000 6.92l74.53 43.2a31.42 31.42 0 0111.56 43l-16.44 28.55a31.48 31.48 0 01-19.27 14.74 31.14 31.14 0 01-23.8-3.2l-74.31-43a4 4 0 00-6 3.46L304 432a32 32 0 01-32 32zm-93.56-197.48zm0-21zm155.1-.08zm0 0z"
                }
            }
        ]
    })(props);
}
function IoMedkitOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "448",
                    "height": "352",
                    "x": "32",
                    "y": "112",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M144 112V80a32 32 0 0132-32h160a32 32 0 0132 32v32m-112 96v160m80-80H176"
                }
            }
        ]
    })(props);
}
function IoMedkitSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M168 72h176v24H168z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M484 96H384V40a8 8 0 00-8-8H136a8 8 0 00-8 8v56H28a12 12 0 00-12 12v360a12 12 0 0012 12h456a12 12 0 0012-12V108a12 12 0 00-12-12zM168 72h176v24H168zm184 238h-74v74h-44v-74h-74v-44h74v-74h44v74h74z"
                }
            }
        ]
    })(props);
}
function IoMedkit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M336 64H176a16 16 0 00-16 16v16h192V80a16 16 0 00-16-16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M432 96h-48V80a48.05 48.05 0 00-48-48H176a48.05 48.05 0 00-48 48v16H80a64.07 64.07 0 00-64 64v256a64 64 0 0064 64h352a64 64 0 0064-64V160a64.07 64.07 0 00-64-64zm-96 208h-64v64a16 16 0 01-32 0v-64h-64a16 16 0 010-32h64v-64a16 16 0 0132 0v64h64a16 16 0 010 32zm16-208H160V80a16 16 0 0116-16h160a16 16 0 0116 16z"
                }
            }
        ]
    })(props);
}
function IoMegaphoneOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M407.94 52.22S321.3 160 240 160H80a16 16 0 00-16 16v96a16 16 0 0016 16h160c81.3 0 167.94 108.23 167.94 108.23 6.06 8 24.06 2.52 24.06-9.83V62c0-12.31-17-18.82-24.06-9.78zM64 256s-16-6-16-32 16-32 16-32m384 54s16-4.33 16-22-16-22-16-22m-192-42v128M112 160v128"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M144 288v168a8 8 0 008 8h53a16 16 0 0015.29-20.73C211.91 416.39 192 386.08 192 336h16a16 16 0 0016-16v-16a16 16 0 00-16-16h-16"
                }
            }
        ]
    })(props);
}
function IoMegaphoneSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 144v332a4 4 0 004 4h100.07a8 8 0 007.82-9.7L208.71 352H232a8 8 0 008-8V144zm324.18 42.55L448 185.5V36a4 4 0 00-4-4h-42.5a4 4 0 00-2.63 1L272 144v160l126.87 111a4 4 0 002.63 1H444a4 4 0 004-4V262.5l4.18-1.05C461.8 258.84 480 247.67 480 224s-18.2-34.84-27.82-37.45zM96 144H52a4 4 0 00-4 4v35.59a43 43 0 00-4.24 4.35C38.4 194.32 32 205.74 32 224c0 20.19 7.89 33.13 16 40.42V300a4 4 0 004 4h44z"
                }
            }
        ]
    })(props);
}
function IoMegaphone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 176v.66a17.38 17.38 0 01-4.2 11.23v.05C38.4 194.32 32 205.74 32 224c0 16.55 5.3 28.23 11.68 35.91A19 19 0 0148 272a32 32 0 0032 32h8a8 8 0 008-8V152a8 8 0 00-8-8h-8a32 32 0 00-32 32zm404.18 10.55l-.93-.17a4 4 0 01-3.25-3.93V62c0-12.64-8.39-24-20.89-28.32-11.92-4.11-24.34-.76-31.68 8.53a431.18 431.18 0 01-51.31 51.69c-23.63 20-46.24 34.25-67 42.31a8 8 0 00-5.15 7.47V299a16 16 0 009.69 14.69c19.34 8.29 40.24 21.83 62 40.28a433.74 433.74 0 0151.68 52.16 26.22 26.22 0 0021.1 9.87 33.07 33.07 0 0010.44-1.74C439.71 410 448 399.05 448 386.4V265.53a4 4 0 013.33-3.94l.85-.14C461.8 258.84 480 247.67 480 224s-18.2-34.84-27.82-37.45zM240 320V152a8 8 0 00-8-8h-96a8 8 0 00-8 8v304a24 24 0 0024 24h52.45a32.66 32.66 0 0025.93-12.45 31.65 31.65 0 005.21-29.05c-1.62-5.18-3.63-11-5.77-17.19-7.91-22.9-18.34-37.07-21.12-69.32A32 32 0 00240 320z"
                }
            }
        ]
    })(props);
}
function IoMenuOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M80 160h352M80 256h352M80 352h352"
                }
            }
        ]
    })(props);
}
function IoMenuSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 384h384v-42.67H64zm0-106.67h384v-42.66H64zM64 128v42.67h384V128z"
                }
            }
        ]
    })(props);
}
function IoMenu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "48",
                    "d": "M88 152h336M88 256h336M88 360h336"
                }
            }
        ]
    })(props);
}
function IoMicCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M224 368h64m48-143.7v23.92c0 39.42-40.58 71.48-80 71.48h0c-39.42 0-80-32.06-80-71.48V224.3m80 95.7v48"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "96",
                    "height": "160",
                    "x": "208",
                    "y": "128",
                    "rx": "48",
                    "ry": "48"
                }
            }
        ]
    })(props);
}
function IoMicCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-48 128a48.14 48.14 0 0148-48 48.14 48.14 0 0148 48v64a48.14 48.14 0 01-48 48 48.14 48.14 0 01-48-48zm144 72.22c0 23.36-10.94 45.61-30.79 62.66A103.71 103.71 0 01272 334.26V352h32v32h-96v-32h32v-17.74a103.71 103.71 0 01-49.21-23.38c-19.85-17.05-30.79-39.3-30.79-62.66V208.3h32v39.92c0 25.66 28 55.48 64 55.48 29.6 0 64-24.23 64-55.48V208.3h32z"
                }
            }
        ]
    })(props);
}
function IoMicCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-48 128a48.14 48.14 0 0148-48 48.14 48.14 0 0148 48v64a48.14 48.14 0 01-48 48 48.14 48.14 0 01-48-48zm144 72.22c0 23.36-10.94 45.61-30.79 62.66A103.71 103.71 0 01272 334.26V352h16a16 16 0 010 32h-64a16 16 0 010-32h16v-17.74a103.71 103.71 0 01-49.21-23.38c-19.85-17.05-30.79-39.3-30.79-62.66V224.3a16 16 0 0132 0v23.92c0 25.66 28 55.48 64 55.48 29.6 0 64-24.23 64-55.48V224.3a16 16 0 1132 0z"
                }
            }
        ]
    })(props);
}
function IoMicOffCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 464c-114.69 0-208-93.31-208-208S141.31 48 256 48s208 93.31 208 208-93.31 208-208 208zm0-384c-97 0-176 79-176 176s79 176 176 176 176-78.95 176-176S353.05 80 256 80z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M352 369a15.93 15.93 0 01-11.84-5.24l-192-210a16 16 0 0123.68-21.52l192 210A16 16 0 01352 369zm0-120.78v-23.8a16.3 16.3 0 00-13.64-16.24c-9.88-1.48-18.36 6.51-18.36 16.12v23.92a43.35 43.35 0 01-3.07 15.91 4 4 0 00.76 4.16l19.19 21.1a2 2 0 003.19-.3A77.12 77.12 0 00352 248.22zM304 240v-64a48.14 48.14 0 00-48-48 48.08 48.08 0 00-41 23.1 4 4 0 00.47 4.77l84.42 92.86a2 2 0 003.46-1A47.84 47.84 0 00304 240zm-57.43 45.2l-36.46-40.11a1 1 0 00-1.74.8 48.26 48.26 0 0037.25 41 1 1 0 00.95-1.69z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M287.55 352H272v-17.74a100.33 100.33 0 0012.53-3.06 2 2 0 00.89-3.26l-21.07-23.19a3.94 3.94 0 00-3.29-1.29c-1.69.15-3.39.24-5.06.24-36 0-64-29.82-64-55.48V224.4a16.26 16.26 0 00-15.61-16.4A15.91 15.91 0 00160 224v24.22c0 23.36 10.94 45.61 30.79 62.66A103.71 103.71 0 00240 334.26V352h-15.55c-8.61 0-16 6.62-16.43 15.23A16 16 0 00224 384h64a16 16 0 0016-16.77c-.42-8.61-7.84-15.23-16.45-15.23z"
                }
            }
        ]
    })(props);
}
function IoMicOffCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm64 200.22V208h32v40.22a77.53 77.53 0 01-13.37 43.11L316 266.4a44.11 44.11 0 004-18.18zM256 128a48.14 48.14 0 0148 48v64a48.07 48.07 0 01-1.44 11.64l-89-97.92A48.13 48.13 0 01256 128zm48 256h-96v-32h32v-17.74a103.71 103.71 0 01-49.21-23.38c-19.85-17.05-30.79-39.3-30.79-62.66V208h32v40.22c0 25.66 28 55.48 64 55.48a56.91 56.91 0 007-.45l24.52 27a99.57 99.57 0 01-15.5 4V352h32zm-95.91-141.13l40.5 44.55a48.2 48.2 0 01-40.5-44.55zm136.07 124.89l-200.5-218.5 23.68-21.52 200.5 218.5z"
                }
            }
        ]
    })(props);
}
function IoMicOffCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm0 80a48.14 48.14 0 0148 48v64a47.84 47.84 0 01-.63 7.71 2 2 0 01-3.46 1l-84.42-92.86a4 4 0 01-.47-4.77A48.08 48.08 0 01256 128zm32 256h-63.55c-8.61 0-16-6.62-16.43-15.23A16 16 0 01224 352h16v-17.74a103.71 103.71 0 01-49.21-23.38c-19.85-17.05-30.79-39.3-30.79-62.66V224a15.91 15.91 0 0116.39-16A16.26 16.26 0 01192 224.4v23.82c0 25.66 28 55.48 64 55.48 1.67 0 3.37-.09 5.06-.24a3.94 3.94 0 013.29 1.29l21.07 23.19a2 2 0 01-.89 3.26 100.33 100.33 0 01-12.53 3.06V352h15.55c8.61 0 16 6.62 16.43 15.23A16 16 0 01288 384zm-77.89-138.91l36.46 40.11a1 1 0 01-.95 1.66 48.26 48.26 0 01-37.25-41 1 1 0 011.74-.77zm152.65 119.75a16 16 0 01-22.6-1.08l-192-210a16 16 0 0123.68-21.52l192 210a16 16 0 01-1.08 22.6zM352 248.22a77.12 77.12 0 01-11.93 40.87 2 2 0 01-3.19.3l-19.19-21.1a4 4 0 01-.76-4.16 43.35 43.35 0 003.07-15.91v-23.8a16.3 16.3 0 0113.64-16.24c9.88-1.48 18.36 6.51 18.36 16.12z"
                }
            }
        ]
    })(props);
}
function IoMicOffOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M432 400L96 64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M400 240v-31.55c0-8.61-6.62-16-15.23-16.43A16 16 0 00368 208v32a111.58 111.58 0 01-2.45 23.31 4.05 4.05 0 001.07 3.69l21.82 21.81a2 2 0 003.29-.72A143.27 143.27 0 00400 240zM256 352a112.36 112.36 0 01-112-112v-31.55c0-8.61-6.62-16-15.23-16.43A16 16 0 00112 208v32c0 74 56.1 135.12 128 143.11V432h-47.55c-8.61 0-16 6.62-16.43 15.23A16 16 0 00192 464h127.55c8.61 0 16-6.62 16.43-15.23A16 16 0 00320 432h-48v-48.89a143.08 143.08 0 0052-16.22 4 4 0 00.91-6.35L307 342.63a4 4 0 00-4.51-.78A110.78 110.78 0 01256 352zm0-272a47.18 47.18 0 0148 48v74.72a4 4 0 001.17 2.82L332.59 233a2 2 0 003.41-1.42V128.91C336 85 301 48.6 257.14 48a79.66 79.66 0 00-68.47 36.57 4 4 0 00.54 5l19.54 19.54a2 2 0 003.25-.63A47.44 47.44 0 01256 80z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M207.27 242.9L179.41 215a2 2 0 00-3.41 1.42V239a80.89 80.89 0 0023.45 56.9 78.55 78.55 0 0077.8 21.19 2 2 0 00.86-3.35l-24.91-24.91a4.08 4.08 0 00-2.42-1.15c-21.65-2.52-39.48-20.44-42.37-42.43a4 4 0 00-1.14-2.35z"
                }
            }
        ]
    })(props);
}
function IoMicOffSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M432 400L96 64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M368 192v48a111.74 111.74 0 01-2.93 25.45L390.65 291a143.07 143.07 0 009.35-51v-48zm-96 240v-48.89a143.11 143.11 0 0056.65-18.83L305 340.65A112.13 112.13 0 01144 240v-48h-32v48c0 74 56.1 135.12 128 143.11V432h-64v32h160v-32zm64-195.63V128c0-44.86-35.14-80-80-80a79.68 79.68 0 00-69 39.34"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M176 211.63V239a80.89 80.89 0 0023.45 56.9 78.55 78.55 0 0081 20.21z"
                }
            }
        ]
    })(props);
}
function IoMicOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M432 400L96 64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M400 240v-31.55c0-8.61-6.62-16-15.23-16.43A16 16 0 00368 208v32a111.68 111.68 0 01-2.68 24.38 2 2 0 00.53 1.84l22.59 22.59a2 2 0 003.29-.72A143.27 143.27 0 00400 240zM256 352a112.36 112.36 0 01-112-112v-31.55c0-8.61-6.62-16-15.23-16.43A16 16 0 00112 208v32c0 74 56.1 135.12 128 143.11V432h-47.55c-8.61 0-16 6.62-16.43 15.23A16 16 0 00192 464h127.55c8.61 0 16-6.62 16.43-15.23A16 16 0 00320 432h-48v-48.89a143.08 143.08 0 0052-16.22 4 4 0 00.91-6.35l-18.4-18.39a3 3 0 00-3.41-.58A111 111 0 01256 352zm1.14-304a79.66 79.66 0 00-68.47 36.57 4 4 0 00.54 5L332.59 233a2 2 0 003.41-1.42V128.91C336 85 301 48.6 257.14 48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M179.41 215a2 2 0 00-3.41 1.42V239a80.89 80.89 0 0023.45 56.9 78.55 78.55 0 0077.8 21.19 2 2 0 00.86-3.35z"
                }
            }
        ]
    })(props);
}
function IoMicOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M192 448h128m64-240v32c0 70.4-57.6 128-128 128h0c-70.4 0-128-57.6-128-128v-32m128 160v80"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 64a63.68 63.68 0 00-64 64v111c0 35.2 29 65 64 65s64-29 64-65V128c0-36-28-64-64-64z"
                }
            }
        ]
    })(props);
}
function IoMicSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M192 448h128m64-240v32c0 70.4-57.6 128-128 128h0c-70.4 0-128-57.6-128-128v-32m128 160v80"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 320a78.83 78.83 0 01-56.55-24.1A80.89 80.89 0 01176 239V128a79.69 79.69 0 0180-80c44.86 0 80 35.14 80 80v111c0 44.66-35.89 81-80 81z"
                }
            }
        ]
    })(props);
}
function IoMic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M192 448h128m64-240v32c0 70.4-57.6 128-128 128h0c-70.4 0-128-57.6-128-128v-32m128 160v80"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 320a78.83 78.83 0 01-56.55-24.1A80.89 80.89 0 01176 239V128a79.69 79.69 0 0180-80c44.86 0 80 35.14 80 80v111c0 44.66-35.89 81-80 81z"
                }
            }
        ]
    })(props);
}
function IoMoonOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 136c0-30.62 4.51-61.61 16-88C99.57 81.27 48 159.32 48 248c0 119.29 96.71 216 216 216 88.68 0 166.73-51.57 200-128-26.39 11.49-57.38 16-88 16-119.29 0-216-96.71-216-216z"
                }
            }
        ]
    })(props);
}
function IoMoonSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152.62 126.77c0-33 4.85-66.35 17.23-94.77C87.54 67.83 32 151.89 32 247.38 32 375.85 136.15 480 264.62 480c95.49 0 179.55-55.54 215.38-137.85-28.42 12.38-61.8 17.23-94.77 17.23-128.47 0-232.61-104.14-232.61-232.61z"
                }
            }
        ]
    })(props);
}
function IoMoon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M264 480A232 232 0 0132 248c0-94 54-178.28 137.61-214.67a16 16 0 0121.06 21.06C181.07 76.43 176 104.66 176 136c0 110.28 89.72 200 200 200 31.34 0 59.57-5.07 81.61-14.67a16 16 0 0121.06 21.06C442.28 426 358 480 264 480z"
                }
            }
        ]
    })(props);
}
function IoMoveOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M176 112l80-80 80 80m-80.02-80l.02 448m-80-80l80 80 80-80m64-224l80 80-80 80M112 176l-80 80 80 80m-80-80h448"
                }
            }
        ]
    })(props);
}
function IoMoveSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M176 112l80-80 80 80m-80.02-80l.02 448m-80-80l80 80 80-80m64-224l80 80-80 80M112 176l-80 80 80 80m-80-80h448"
                }
            }
        ]
    })(props);
}
function IoMove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M176 112l80-80 80 80m-80.02-80l.02 448m-80-80l80 80 80-80m64-224l80 80-80 80M112 176l-80 80 80 80m-80-80h448"
                }
            }
        ]
    })(props);
}
function IoMusicalNoteOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M240 343.31V424a32.28 32.28 0 01-21.88 30.65l-21.47 7.23c-25.9 8.71-52.65-10.75-52.65-38.32h0A34.29 34.29 0 01167.25 391l50.87-17.12A32.29 32.29 0 00240 343.24V92a16.13 16.13 0 0112.06-15.66L360.49 48.2A6 6 0 01368 54v57.76a16.13 16.13 0 01-12.12 15.67l-91.64 23.13A32.25 32.25 0 00240 181.91v39.39"
                }
            }
        ]
    })(props);
}
function IoMusicalNoteSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M381.55 32.05c-18.13 4.28-126.57 31.07-156 38.19a2 2 0 00-1.55 1.94V353.3a2 2 0 01-1.32 1.88L182 369.88c-29.82 10.66-54 18.94-54 59.06 0 32.47 23.53 47.18 37.95 50a81.77 81.77 0 0015 1.08c8.89 0 31-3.59 47.52-14.24C256 448 256 448 256 415.93V169.16a2 2 0 011.49-1.94l125-33a2 2 0 001.49-1.94V34a2 2 0 00-2.43-1.95z"
                }
            }
        ]
    })(props);
}
function IoMusicalNote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M183.83 480a55.2 55.2 0 01-32.36-10.55A56.64 56.64 0 01128 423.58a50.26 50.26 0 0134.14-47.73L213 358.73a16.25 16.25 0 0011-15.49V92a32.1 32.1 0 0124.09-31.15l108.39-28.14A22 22 0 01384 54v57.75a32.09 32.09 0 01-24.2 31.19l-91.65 23.13A16.24 16.24 0 00256 181.91V424a48.22 48.22 0 01-32.78 45.81l-21.47 7.23a56 56 0 01-17.92 2.96z"
                }
            }
        ]
    })(props);
}
function IoMusicalNotesOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M192 218v-6c0-14.84 10-27 24.24-30.59l174.59-46.68A20 20 0 01416 154v22"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M416 295.94v80c0 13.91-8.93 25.59-22 30l-22 8c-25.9 8.72-52-10.42-52-38h0a33.37 33.37 0 0123-32l51-18.15c13.07-4.4 22-15.94 22-29.85V58a10 10 0 00-12.6-9.61L204 102a16.48 16.48 0 00-12 16v226c0 13.91-8.93 25.6-22 30l-52 18c-13.88 4.68-22 17.22-22 32h0c0 27.58 26.52 46.55 52 38l22-8c13.07-4.4 22-16.08 22-30v-80"
                }
            }
        ]
    })(props);
}
function IoMusicalNotesSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M429.46 32.07c-23.6 6.53-205.55 58.81-250.54 71.43a4 4 0 00-2.92 3.83v247a2 2 0 01-1.33 1.89l-27.85 9.55c-19 7.44-66.82 16.68-66.82 59.19 0 35.54 24.63 51.54 45.86 54.28a52.06 52.06 0 007.81.8c7.37 0 36.38-7.08 53.3-18.08C208 448.25 208 448 208 412V202c0-.9.62-.84 1.48-1.07l188-51.92a2 2 0 012.53 2v155.54a2 2 0 01-1.36 1.89c-8.9 3-19.23 6.5-26.48 9.12C341.39 328.68 304 335.65 304 376c0 38.51 28.26 54.58 46.3 55.83a87.37 87.37 0 0021.33-1c9-1.38 24.09-5.9 38.14-14.86C432 401.79 432 401.51 432 360V34a2 2 0 00-2.54-1.93z"
                }
            }
        ]
    })(props);
}
function IoMusicalNotes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M421.84 37.37a25.86 25.86 0 00-22.6-4.46L199.92 86.49A32.3 32.3 0 00176 118v226c0 6.74-4.36 12.56-11.11 14.83l-.12.05-52 18C92.88 383.53 80 402 80 423.91a55.54 55.54 0 0023.23 45.63A54.78 54.78 0 00135.34 480a55.82 55.82 0 0017.75-2.93l.38-.13 21.84-7.94A47.84 47.84 0 00208 423.91v-212c0-7.29 4.77-13.21 12.16-15.07l.21-.06L395 150.14a4 4 0 015 3.86v141.93c0 6.75-4.25 12.38-11.11 14.68l-.25.09-50.89 18.11A49.09 49.09 0 00304 375.92a55.67 55.67 0 0023.23 45.8 54.63 54.63 0 0049.88 7.35l.36-.12 21.84-7.95A47.83 47.83 0 00432 375.92V58a25.74 25.74 0 00-10.16-20.63z"
                }
            }
        ]
    })(props);
}
function IoNavigateCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336.76 161l-186.53 82.35c-10.47 4.8-6.95 20.67 4.57 20.67H244a4 4 0 014 4v89.18c0 11.52 16 15 20.78 4.56L351 175.24A10.73 10.73 0 00336.76 161z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            }
        ]
    })(props);
}
function IoNavigateCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48A208.23 208.23 0 0048 256c0 114.68 93.31 208 208 208a208.23 208.23 0 00208-208c0-114.69-93.31-208-208-208zm-8 361V264H103l259-114.11z"
                }
            }
        ]
    })(props);
}
function IoNavigateCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M258.9 48C141.92 46.42 46.42 141.92 48 258.9c1.56 112.19 92.91 203.54 205.1 205.1 117 1.6 212.48-93.9 210.88-210.88C462.44 140.91 371.09 49.56 258.9 48zM351 175.24l-82.24 186.52c-4.79 10.47-20.78 7-20.78-4.56V268a4 4 0 00-4-4H154.8c-11.52 0-15-15.87-4.57-20.67L336.76 161A10.73 10.73 0 01351 175.24z"
                }
            }
        ]
    })(props);
}
function IoNavigateOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M448 64L64 240.14h200a8 8 0 018 8V448z"
                }
            }
        ]
    })(props);
}
function IoNavigateSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 32L32 240h240v240L480 32z"
                }
            }
        ]
    })(props);
}
function IoNavigate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 464a16 16 0 01-16-16.42V264.13a8 8 0 00-8-8H64.41a16.31 16.31 0 01-15.49-10.65 16 16 0 018.41-19.87l384-176.15a16 16 0 0121.22 21.19l-176 384A16 16 0 01272 464z"
                }
            }
        ]
    })(props);
}
function IoNewspaperOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M368 415.86V72a24.07 24.07 0 00-24-24H72a24.07 24.07 0 00-24 24v352a40.12 40.12 0 0040 40h328"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M416 464h0a48 48 0 01-48-48V128h72a24 24 0 0124 24v264a48 48 0 01-48 48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M240 128h64m-64 64h64m-192 64h192m-192 64h192m-192 64h192"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M176 208h-64a16 16 0 01-16-16v-64a16 16 0 0116-16h64a16 16 0 0116 16v64a16 16 0 01-16 16z"
                }
            }
        ]
    })(props);
}
function IoNewspaperSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "96",
                    "height": "96",
                    "x": "96",
                    "y": "112",
                    "fill": "none",
                    "rx": "16",
                    "ry": "16"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M468 112h-52v304a32 32 0 0032 32 32 32 0 0032-32V124a12 12 0 00-12-12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M431.15 477.75A64.11 64.11 0 01384 416V44a12 12 0 00-12-12H44a12 12 0 00-12 12v380a56 56 0 0056 56h342.85a1.14 1.14 0 00.3-2.25zM96 208v-96h96v96zm224 192H96v-32h224zm0-64H96v-32h224zm0-64H96v-32h224zm0-64h-96v-32h96zm0-64h-96v-32h96z"
                }
            }
        ]
    })(props);
}
function IoNewspaper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439.91 112h-23.82a.09.09 0 00-.09.09V416a32 32 0 0032 32 32 32 0 0032-32V152.09A40.09 40.09 0 00439.91 112z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M384 416V72a40 40 0 00-40-40H72a40 40 0 00-40 40v352a56 56 0 0056 56h342.85a1.14 1.14 0 001.15-1.15 1.14 1.14 0 00-.85-1.1A64.11 64.11 0 01384 416zM96 128a16 16 0 0116-16h64a16 16 0 0116 16v64a16 16 0 01-16 16h-64a16 16 0 01-16-16zm208 272H112.45c-8.61 0-16-6.62-16.43-15.23A16 16 0 01112 368h191.55c8.61 0 16 6.62 16.43 15.23A16 16 0 01304 400zm0-64H112.45c-8.61 0-16-6.62-16.43-15.23A16 16 0 01112 304h191.55c8.61 0 16 6.62 16.43 15.23A16 16 0 01304 336zm0-64H112.45c-8.61 0-16-6.62-16.43-15.23A16 16 0 01112 240h191.55c8.61 0 16 6.62 16.43 15.23A16 16 0 01304 272zm0-64h-63.55c-8.61 0-16-6.62-16.43-15.23A16 16 0 01240 176h63.55c8.61 0 16 6.62 16.43 15.23A16 16 0 01304 208zm0-64h-63.55c-8.61 0-16-6.62-16.43-15.23A16 16 0 01240 112h63.55c8.61 0 16 6.62 16.43 15.23A16 16 0 01304 144z"
                }
            }
        ]
    })(props);
}
function IoNotificationsCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M365.2 313c-16.33-19.34-27.86-27.47-27.86-80.8 0-48.86-25.78-66.23-47-74.67a11.39 11.39 0 01-6.34-6.68C280.29 138.6 269.88 128 256 128s-24.31 10.6-28 22.86a11.35 11.35 0 01-6.33 6.68c-21.24 8.46-47 25.8-47 74.67 0 53.33-11.54 61.46-27.87 80.8-6.77 8-.65 23 11.19 23H354C365.77 336 371.94 321 365.2 313zm-144.96 39a4 4 0 00-4 4.42C218.49 375.14 235.11 384 256 384c20.67 0 37.14-9.15 39.66-27.52a4 4 0 00-4-4.48z"
                }
            }
        ]
    })(props);
}
function IoNotificationsCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M295.68 351.43v.57h.32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M256 384c22.28 0 39.36-10.63 39.66-32H216c0 21.75 17.53 32 40 32zm39.67-32h.33l-.32-.57c0 .19-.01.38-.01.57z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm0 336c-22.48 0-40-10.25-40-32h80c-.3 21.37-17.71 32-40 32zm112-48H144v-28l28-36v-32.3c0-40.41 15.82-75.35 56-84.27l4-27.43h48l4 27.43c40 8.92 56 44 56 84.27V272l28 36z"
                }
            }
        ]
    })(props);
}
function IoNotificationsCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm0 336c-20.9 0-37.52-8.86-39.75-27.58a4 4 0 014-4.42h71.45a4 4 0 014 4.48C293.15 374.85 276.68 384 256 384zm98-48H158c-11.84 0-18-15-11.19-23 16.33-19.34 27.87-27.47 27.87-80.8 0-48.87 25.74-66.21 47-74.67a11.35 11.35 0 006.33-6.68C231.7 138.6 242.14 128 256 128s24.28 10.6 28 22.86a11.39 11.39 0 006.34 6.68c21.21 8.44 47 25.81 47 74.67 0 53.33 11.53 61.46 27.86 80.8 6.74 7.99.57 22.99-11.2 22.99z"
                }
            }
        ]
    })(props);
}
function IoNotificationsOffCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M220.24 352a4 4 0 00-4 4.42C218.49 375.14 235.11 384 256 384s37.5-8.86 39.73-27.58a4 4 0 00-4-4.42zM352 378a15.93 15.93 0 01-11.84-5.24l-192-212a16 16 0 0123.68-21.52l192 212A16 16 0 01352 378zM174.68 232.21c0 53.33-11.54 61.46-27.87 80.8-6.77 8-.65 23 11.19 23h118.83a4 4 0 002.95-6.7l-98-106.87a4 4 0 00-6.94 2.52c-.1 2.33-.16 4.75-.16 7.25zM365.2 313c-16.33-19.34-27.86-27.47-27.86-80.8 0-48.86-25.78-66.23-47-74.67a11.39 11.39 0 01-6.34-6.68C280.29 138.6 269.88 128 256 128s-24.31 10.6-28 22.86a11.35 11.35 0 01-6.33 6.68c-1.28.51-2.57 1.05-3.88 1.63a4 4 0 00-1.3 6.36L361 323.21a4 4 0 006.94-2.95 12 12 0 00-2.74-7.26z"
                }
            }
        ]
    })(props);
}
function IoNotificationsOffCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zM144 308l28-36v-32.3a131.83 131.83 0 012.34-25.42L285.92 336H144zm112.18 76C233.6 384 216 373.75 216 352h80c-.3 21.37-17.45 32-39.82 32zm93.48-3.74l-211-227 23.68-21.52 211 227zM368 330.85l-.32-.38-155.5-169.63a73.4 73.4 0 0115.82-5.41l4-27.43h48l4 27.43c40 8.92 56 44 56 84.27V272l28 36z"
                }
            }
        ]
    })(props);
}
function IoNotificationsOffCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zM146.83 313c16.33-19.34 27.86-27.47 27.86-80.8q0-3.75.2-7.26a4 4 0 017-2.52l98 106.87a4 4 0 01-2.94 6.7H158C146.18 336 140.06 321 146.83 313zm148.93 43.41C293.53 375.14 276.92 384 256 384s-37.51-8.86-39.75-27.58a4 4 0 014-4.42h71.53a4 4 0 013.98 4.42zm67 17.42a16 16 0 01-22.6-1.08l-192-212a16 16 0 0123.68-21.52l192 212a16 16 0 01-1.08 22.61zM361 323.21L216.49 165.53a4 4 0 011.3-6.36c1.31-.58 2.61-1.12 3.89-1.63a11.33 11.33 0 006.32-6.68c3.72-12.26 14.15-22.86 28-22.86s24.29 10.6 28 22.86a11.34 11.34 0 006.34 6.68c21.21 8.44 47 25.81 47 74.67 0 53.33 11.54 61.46 27.87 80.8a12.09 12.09 0 012.76 7.25 4 4 0 01-6.97 2.95z"
                }
            }
        ]
    })(props);
}
function IoNotificationsOffOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M128.51 204.59q-.37 6.15-.37 12.76C128.14 304 110 320 84.33 351.43 73.69 364.45 83 384 101.62 384H320m94.5-48.7c-18.48-23.45-30.62-47.05-30.62-118 0-79.3-40.52-107.57-73.88-121.3-4.43-1.82-8.6-6-9.95-10.55C294.21 65.54 277.82 48 256 48s-38.2 17.55-44 37.47c-1.35 4.6-5.52 8.71-10 10.53a149.57 149.57 0 00-18 8.79M320 384v16a64 64 0 01-128 0v-16"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 448L64 64"
                }
            }
        ]
    })(props);
}
function IoNotificationsOffSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M41.37 64l22.628-22.628L470.627 448l-22.628 22.627zM256 480a80.09 80.09 0 0073.3-48H182.7a80.09 80.09 0 0073.3 48zM112 227.47V288l-48 64v48h268.12L115.87 183.75a236.75 236.75 0 00-3.87 43.72zM448 352l-48-64v-60.53C400 157 372.64 95.61 304 80l-8-48h-80l-8 48a117.45 117.45 0 00-41.95 18.17l282 282z"
                }
            }
        ]
    })(props);
}
function IoNotificationsOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 464a15.92 15.92 0 01-11.31-4.69l-384-384a16 16 0 0122.62-22.62l384 384A16 16 0 01448 464zm-7.92-122.69c-1.66-2-3.29-4-4.89-5.93-22-26.61-35.31-42.67-35.31-118 0-39-9.33-71-27.72-95-13.56-17.73-31.89-31.18-56.05-41.12a3 3 0 01-.82-.67C306.6 51.49 282.82 32 256 32s-50.59 19.49-59.28 48.56a3.13 3.13 0 01-.81.65 157.88 157.88 0 00-21.88 11 8 8 0 00-1.49 12.49l261.78 261.74a8 8 0 0013.6-6.63 35.39 35.39 0 00-7.84-18.5zM112.14 217.35c0 75.36-13.29 91.42-35.31 118-1.6 1.93-3.23 3.89-4.89 5.93a35.16 35.16 0 00-4.65 37.62c6.17 13 19.32 21.07 34.33 21.07H312.8a8 8 0 005.66-13.66l-192-192a8 8 0 00-13.62 5q-.7 8.69-.7 18.04zM256 480a80.06 80.06 0 0070.44-42.13 4 4 0 00-3.54-5.87H189.12a4 4 0 00-3.55 5.87A80.06 80.06 0 00256 480z"
                }
            }
        ]
    })(props);
}
function IoNotificationsOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M427.68 351.43C402 320 383.87 304 383.87 217.35 383.87 138 343.35 109.73 310 96c-4.43-1.82-8.6-6-9.95-10.55C294.2 65.54 277.8 48 256 48s-38.21 17.55-44 37.47c-1.35 4.6-5.52 8.71-9.95 10.53-33.39 13.75-73.87 41.92-73.87 121.35C128.13 304 110 320 84.32 351.43 73.68 364.45 83 384 101.61 384h308.88c18.51 0 27.77-19.61 17.19-32.57zM320 384v16a64 64 0 01-128 0v-16"
                }
            }
        ]
    })(props);
}
function IoNotificationsSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 480a80.09 80.09 0 0073.3-48H182.7a80.09 80.09 0 0073.3 48zm144-192v-60.53C400 157 372.64 95.61 304 80l-8-48h-80l-8 48c-68.88 15.61-96 76.76-96 147.47V288l-48 64v48h384v-48z"
                }
            }
        ]
    })(props);
}
function IoNotifications(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.08 341.31c-1.66-2-3.29-4-4.89-5.93-22-26.61-35.31-42.67-35.31-118 0-39-9.33-71-27.72-95-13.56-17.73-31.89-31.18-56.05-41.12a3 3 0 01-.82-.67C306.6 51.49 282.82 32 256 32s-50.59 19.49-59.28 48.56a3.13 3.13 0 01-.81.65c-56.38 23.21-83.78 67.74-83.78 136.14 0 75.36-13.29 91.42-35.31 118-1.6 1.93-3.23 3.89-4.89 5.93a35.16 35.16 0 00-4.65 37.62c6.17 13 19.32 21.07 34.33 21.07H410.5c14.94 0 28-8.06 34.19-21a35.17 35.17 0 00-4.61-37.66zM256 480a80.06 80.06 0 0070.44-42.13 4 4 0 00-3.54-5.87H189.12a4 4 0 00-3.55 5.87A80.06 80.06 0 00256 480z"
                }
            }
        ]
    })(props);
}
function IoNuclearOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "192",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "64",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M224 192L171 85m117 107l53-107m-13.45 170.81l119.41.13m-147.87 57.19l72.25 95.06M184.45 255.81l-119.41.13m147.87 57.19l-72.25 95.06"
                }
            }
        ]
    })(props);
}
function IoNuclearSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M223.47 335.59l-51.71 68a169.73 169.73 0 00168.48 0l-51.71-68"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M403.08 108.92a208 208 0 00-294.16 294.16 208 208 0 00294.16-294.16zM342 256a86.13 86.13 0 01-53.47 79.59l51.71 68a169.73 169.73 0 01-168.48 0l51.71-68a86 86 0 01-50.56-101.77l-85.48.09a170.21 170.21 0 0173.83-119l37.94 76.59a85.78 85.78 0 01113.6 0l37.94-76.59a170.21 170.21 0 0173.83 119l-85.48-.09A85.87 85.87 0 01342 256z"
                }
            }
        ]
    })(props);
}
function IoNuclear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M258.9 48C141.92 46.42 46.42 141.92 48 258.9c1.56 112.19 92.91 203.54 205.1 205.1 117 1.6 212.48-93.9 210.88-210.88C462.44 140.91 371.09 49.56 258.9 48zM429 239.92l-93.08-.1a2 2 0 01-1.95-1.57 80.08 80.08 0 00-27.44-44.17 2 2 0 01-.54-2.43l41.32-83.43a2 2 0 012.87-.81A176.2 176.2 0 01431 237.71a2 2 0 01-2 2.21zm-220.8 20.46a48 48 0 1143.42 43.42 48 48 0 01-43.42-43.42zm-43.55-152.16L206 191.65a2 2 0 01-.54 2.43A80.08 80.08 0 00178 238.25a2 2 0 01-2 1.57l-93.08.1a2 2 0 01-2-2.21 176.2 176.2 0 0180.82-130.3 2 2 0 012.91.81zm-.37 295.34l56.31-74.09a2 2 0 012.43-.6 79.84 79.84 0 0066 0 2 2 0 012.43.6l56.31 74.09a2 2 0 01-.54 2.92 175.65 175.65 0 01-182.36 0 2 2 0 01-.58-2.92z"
                }
            }
        ]
    })(props);
}
function IoNutritionOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M352 128c-32.26-2.89-64 16-96 16s-63.75-19-96-16c-64 6-96 64-96 160 0 80 64 192 111.2 192s51.94-24 80.8-24 33.59 24 80.8 24S448 368 448 288c0-96-29-154-96-160z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M323.92 83.14c-21 21-45.66 27-58.82 28.79a8 8 0 01-9.1-8.73 97.6 97.6 0 0128.61-59.33c22-22 46-26.9 58.72-27.85a8 8 0 018.67 8.92 98 98 0 01-28.08 58.2z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "216",
                    "cy": "304",
                    "rx": "24",
                    "ry": "48"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "296",
                    "cy": "304",
                    "rx": "24",
                    "ry": "48"
                }
            }
        ]
    })(props);
}
function IoNutritionSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M438.71 159.43c-17.6-28.31-45.5-43.8-85.28-47.37-22.82-2-50.23 4.94-72.25 10.55C271.26 125.14 260 128 256 128s-15.18-2.86-25-5.39c-22.08-5.65-49.56-12.69-72.45-10.54-38.53 3.61-66 19.19-84 47.62S48 229 48 288c0 61.28 29.53 114.58 47.13 140.89C116.82 461.34 149.25 496 175.2 496c18.57 0 34.12-7.23 47.82-13.64C243 473 256 472 256 472s11 0 31.94 10.11C301.65 488.73 317.3 496 336.8 496c26.58 0 59.08-34.69 80.63-67.15C434.82 402.65 464 349.52 464 288c0-60-8-100.83-25.29-128.57zM216 352c-13.25 0-24-21.49-24-48s10.75-48 24-48 24 21.49 24 48-10.75 48-24 48zm80 0c-13.25 0-24-21.49-24-48s10.75-48 24-48 24 21.49 24 48-10.75 48-24 48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M323.72 82.76C353.68 52.82 352 16.18 352 16.14s-35.77-3.76-67.23 27.67S256.06 112 256.06 112s37.68.71 67.66-29.24z"
                }
            }
        ]
    })(props);
}
function IoNutrition(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439 166.29c-18.67-32.57-47.46-50.81-85.57-54.23-20.18-1.8-39 3.37-57.23 8.38-14.15 3.89-27.52 7.56-40.2 7.56s-26-3.68-40.06-7.57c-18.28-5-37.18-10.26-57.43-8.36-36.39 3.41-65.51 22.11-84.31 54.08C56.82 195.76 48 236.76 48 288c0 40.4 15 90.49 40 134 12.82 22.25 47 74 87.16 74 30.77 0 47.15-9.44 59.11-16.33 8.3-4.78 13.31-7.67 21.69-7.67s13.39 2.89 21.69 7.67c12 6.89 28.35 16.33 59.15 16.33 40.17 0 74.34-51.76 87.16-74 25.07-43.5 40-93.59 40-134 .04-52.57-8.14-92.38-24.96-121.71zM216 352c-13.25 0-24-21.49-24-48s10.75-48 24-48 24 21.49 24 48-10.75 48-24 48zm80 0c-13.25 0-24-21.49-24-48s10.75-48 24-48 24 21.49 24 48-10.75 48-24 48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M265.1 111.93c13.16-1.75 37.86-7.83 58.83-28.79a98 98 0 0028-58.2 8 8 0 00-8.55-8.94c-12.71.95-36.76 5.87-58.73 27.85A97.6 97.6 0 00256 103.2a8 8 0 009.1 8.73z"
                }
            }
        ]
    })(props);
}
function IoOpenOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M384 224v184a40 40 0 01-40 40H104a40 40 0 01-40-40V168a40 40 0 0140-40h167.48M336 64h112v112M224 288L440 72"
                }
            }
        ]
    })(props);
}
function IoOpenSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M201.37 288l176-176H48v352h352V134.63l-176 176L201.37 288z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M320 48v32h89.37l-32 32L400 134.63l32-32V192h32V48H320z"
                }
            }
        ]
    })(props);
}
function IoOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 304a16 16 0 01-11.31-27.31l157.94-157.94A55.7 55.7 0 00344 112H104a56.06 56.06 0 00-56 56v240a56.06 56.06 0 0056 56h240a56.06 56.06 0 0056-56V168a55.7 55.7 0 00-6.75-26.63L235.31 299.31A15.92 15.92 0 01224 304z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M448 48H336a16 16 0 000 32h73.37l-38.74 38.75a56.35 56.35 0 0122.62 22.62L432 102.63V176a16 16 0 0032 0V64a16 16 0 00-16-16z"
                }
            }
        ]
    })(props);
}
function IoOptionsOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M368 128h80m-384 0h240m64 256h80m-384 0h240m-96-128h240m-384 0h80"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "336",
                    "cy": "128",
                    "r": "32",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "176",
                    "cy": "256",
                    "r": "32",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "336",
                    "cy": "384",
                    "r": "32",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function IoOptionsSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M381.25 112a48 48 0 00-90.5 0H48v32h242.75a48 48 0 0090.5 0H464v-32zM176 208a48.09 48.09 0 00-45.25 32H48v32h82.75a48 48 0 0090.5 0H464v-32H221.25A48.09 48.09 0 00176 208zm160 128a48.09 48.09 0 00-45.25 32H48v32h242.75a48 48 0 0090.5 0H464v-32h-82.75A48.09 48.09 0 00336 336z"
                }
            }
        ]
    })(props);
}
function IoOptions(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 144h226.75a48 48 0 0090.5 0H448a16 16 0 000-32h-66.75a48 48 0 00-90.5 0H64a16 16 0 000 32zm384 224h-66.75a48 48 0 00-90.5 0H64a16 16 0 000 32h226.75a48 48 0 0090.5 0H448a16 16 0 000-32zm0-128H221.25a48 48 0 00-90.5 0H64a16 16 0 000 32h66.75a48 48 0 0090.5 0H448a16 16 0 000-32z"
                }
            }
        ]
    })(props);
}
function IoPaperPlaneOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M53.12 199.94l400-151.39a8 8 0 0110.33 10.33l-151.39 400a8 8 0 01-15-.34l-67.4-166.09a16 16 0 00-10.11-10.11L53.46 215a8 8 0 01-.34-15.06zM460 52L227 285"
                }
            }
        ]
    })(props);
}
function IoPaperPlaneSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 16L15.88 208 195 289 448 64 223 317l81 179L496 16z"
                }
            }
        ]
    })(props);
}
function IoPaperPlane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M473 39.05a24 24 0 00-25.5-5.46L47.47 185h-.08a24 24 0 001 45.16l.41.13 137.3 58.63a16 16 0 0015.54-3.59L422 80a7.07 7.07 0 0110 10L226.66 310.26a16 16 0 00-3.59 15.54l58.65 137.38c.06.2.12.38.19.57 3.2 9.27 11.3 15.81 21.09 16.25h1a24.63 24.63 0 0023-15.46L478.39 64.62A24 24 0 00473 39.05z"
                }
            }
        ]
    })(props);
}
function IoPartlySunnyOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M90.61 306.85A16.07 16.07 0 00104 293.6C116.09 220.17 169.63 176 232 176c57.93 0 96.62 37.75 112.2 77.74a15.84 15.84 0 0012.2 9.87c50 8.15 91.6 41.54 91.6 99.59 0 59.4-48.6 100.8-108 100.8H106c-49.5 0-90-24.7-90-79.2 0-48.47 38.67-72.22 74.61-77.95z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M384.8 271.4a80 80 0 10-123.55-92M464 208h32M336 48v32M222.86 94.86l22.63 22.63m203.65-22.63l-22.63 22.63"
                }
            }
        ]
    })(props);
}
function IoPartlySunnySharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M340 480H106c-29.5 0-54.92-7.83-73.53-22.64C11.23 440.44 0 415.35 0 384.8c0-26.66 10.08-49.8 29.14-66.91 15.24-13.68 36.17-23.21 59-26.84.06 0 .08 0 .09-.05 6.44-39 23.83-72.09 50.31-95.68A140.24 140.24 0 01232 160c30.23 0 58.48 9.39 81.71 27.17a142.69 142.69 0 0145.36 60.66c29.41 4.82 54.72 17.11 73.19 35.54C453 304.11 464 331.71 464 363.2c0 32.85-13.13 62.87-37 84.52-22.89 20.82-53.8 32.28-87 32.28zm19-232.18zm22.5-27.93a169.23 169.23 0 0145.44 19A96 96 0 00281 129.33q-2.85 2-5.54 4.2a162.47 162.47 0 0157.73 28.23 174.53 174.53 0 0148.31 58.13zM448 192h64v32h-64zM320 32h32v64h-32zm-64.65 97.63l12.45-12.45-44.62-44.63-22.63 22.63 33.17 33.17h.6a172 172 0 0121.03 1.28zm148.853-12.46l44.626-44.625 22.627 22.628-44.625 44.625z"
                }
            }
        ]
    })(props);
}
function IoPartlySunny(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M340 480H106c-29.5 0-54.92-7.83-73.53-22.64C11.23 440.44 0 415.35 0 384.8c0-26.66 10.08-49.8 29.14-66.91 15.24-13.68 36.17-23.21 59-26.84.06 0 .08 0 .09-.05 6.44-39 23.83-72.09 50.31-95.68A140.24 140.24 0 01232 160c30.23 0 58.48 9.39 81.71 27.17a142.24 142.24 0 0142.19 53.21 16 16 0 0011.19 9c26 5.61 48.4 17.29 65.17 34C453 304.11 464 331.71 464 363.2c0 32.85-13.13 62.87-37 84.52-22.89 20.82-53.8 32.28-87 32.28zm19-232.18zm28.89-26.14a168.8 168.8 0 0134.76 14.71 4 4 0 005.82-2.44 97 97 0 003.53-26.68c-.39-52.43-43.48-95.22-95.91-95.27A95.46 95.46 0 00281 129.33h-.06a3.38 3.38 0 001 6 162.45 162.45 0 0151.28 26.4 173.92 173.92 0 0145.32 52.51 16 16 0 009.35 7.44zM496 224h-32a16 16 0 010-32h32a16 16 0 010 32zM336 96a16 16 0 01-16-16V48a16 16 0 0132 0v32a16 16 0 01-16 16zm-90.51 37.49a15.92 15.92 0 01-11.31-4.69l-22.63-22.62a16 16 0 0122.63-22.63l22.62 22.63a16 16 0 01-11.31 27.31zm181.02 0a16 16 0 01-11.31-27.31l22.62-22.63a16 16 0 0122.63 22.63l-22.63 22.62a15.92 15.92 0 01-11.31 4.69z"
                }
            }
        ]
    })(props);
}
function IoPauseCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M208 192v128m96-128v128"
                }
            }
        ]
    })(props);
}
function IoPauseCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-32 288h-32V176h32zm96 0h-32V176h32z"
                }
            }
        ]
    })(props);
}
function IoPauseCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-32 272a16 16 0 01-32 0V192a16 16 0 0132 0zm96 0a16 16 0 01-32 0V192a16 16 0 0132 0z"
                }
            }
        ]
    })(props);
}
function IoPauseOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M176 96h16v320h-16zm144 0h16v320h-16z"
                }
            }
        ]
    })(props);
}
function IoPauseSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 432h-80V80h80zm144 0h-80V80h80z"
                }
            }
        ]
    })(props);
}
function IoPause(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 432h-48a16 16 0 01-16-16V96a16 16 0 0116-16h48a16 16 0 0116 16v320a16 16 0 01-16 16zm144 0h-48a16 16 0 01-16-16V96a16 16 0 0116-16h48a16 16 0 0116 16v320a16 16 0 01-16 16z"
                }
            }
        ]
    })(props);
}
function IoPawOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M457.74 170.1a30.26 30.26 0 00-11.16-2.1h-.4c-20.17.3-42.79 19.19-54.66 47.76-14.23 34.18-7.68 69.15 14.74 78.14a30.21 30.21 0 0011.15 2.1c20.27 0 43.2-19 55.17-47.76 14.13-34.18 7.48-69.15-14.84-78.14zM327.6 303.48C299.8 257.35 287.8 240 256 240s-43.9 17.46-71.7 63.48c-23.8 39.36-71.9 42.64-83.9 76.07a50.91 50.91 0 00-3.6 19.25c0 27.19 20.8 49.2 46.4 49.2 31.8 0 75.1-25.39 112.9-25.39S337 448 368.8 448c25.6 0 46.3-22 46.3-49.2a51 51 0 00-3.7-19.25c-12-33.55-60-36.71-83.8-76.07zM192.51 196a26.53 26.53 0 004-.3c23.21-3.37 37.7-35.53 32.44-71.85C224 89.61 203.22 64 181.49 64a26.53 26.53 0 00-4 .3c-23.21 3.37-37.7 35.53-32.44 71.85C150 170.29 170.78 196 192.51 196zm174.41-59.85c5.26-36.32-9.23-68.48-32.44-71.85a26.53 26.53 0 00-4-.3c-21.73 0-42.47 25.61-47.43 59.85-5.26 36.32 9.23 68.48 32.44 71.85a26.53 26.53 0 004 .3c21.73 0 42.51-25.71 47.43-59.85zM105.77 293.9c22.39-9 28.93-44 14.72-78.14C108.53 187 85.62 168 65.38 168a30.21 30.21 0 00-11.15 2.1c-22.39 9-28.93 44-14.72 78.14C51.47 277 74.38 296 94.62 296a30.21 30.21 0 0011.15-2.1z"
                }
            }
        ]
    })(props);
}
function IoPawSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M442.8 361.82c-8.8-25.1-29.31-37.82-49.11-50.12-17.23-10.71-33.5-20.83-44.14-39-29.33-50.33-45.44-80.7-93.49-80.7s-64.21 30.38-93.61 80.69c-10.65 18.21-27 28.35-44.25 39.08-19.8 12.31-40.27 25-49.1 50.05a78.06 78.06 0 00-5.1 28.29C64 430.85 96.45 464 132.4 464s83.31-18.13 123.76-18.13S343.31 464 379.71 464 448 430.85 448 390.11a78.3 78.3 0 00-5.2-28.29z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "72",
                    "cy": "216",
                    "rx": "56",
                    "ry": "72"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "184",
                    "cy": "120",
                    "rx": "56",
                    "ry": "72"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "328",
                    "cy": "120",
                    "rx": "56",
                    "ry": "72"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "440",
                    "cy": "216",
                    "rx": "56",
                    "ry": "72"
                }
            }
        ]
    })(props);
}
function IoPaw(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M490.39 182.75c-5.55-13.19-14.77-22.7-26.67-27.49l-.16-.06a46.46 46.46 0 00-17-3.2h-.64c-27.24.41-55.05 23.56-69.19 57.61-10.37 24.9-11.56 51.68-3.18 71.64 5.54 13.2 14.78 22.71 26.73 27.5l.13.05a46.53 46.53 0 0017 3.2c27.5 0 55.6-23.15 70-57.65 10.24-24.87 11.37-51.63 2.98-71.6zM381.55 329.61c-15.71-9.44-30.56-18.37-40.26-34.41C314.53 250.8 298.37 224 256 224s-58.57 26.8-85.39 71.2c-9.72 16.06-24.6 25-40.36 34.48-18.07 10.86-36.74 22.08-44.8 44.16a66.93 66.93 0 00-4.65 25c0 35.95 28 65.2 62.4 65.2 17.75 0 36.64-6.15 56.63-12.66 19.22-6.26 39.09-12.73 56.27-12.73s37 6.47 56.15 12.73C332.2 457.85 351 464 368.8 464c34.35 0 62.3-29.25 62.3-65.2a67 67 0 00-4.75-25c-8.06-22.1-26.74-33.33-44.8-44.19zM150 188.85c11.9 14.93 27 23.15 42.52 23.15a42.88 42.88 0 006.33-.47c32.37-4.76 52.54-44.26 45.92-90C242 102.3 234.6 84.39 224 71.11 212.12 56.21 197 48 181.49 48a42.88 42.88 0 00-6.33.47c-32.37 4.76-52.54 44.26-45.92 90 2.76 19.2 10.16 37.09 20.76 50.38zm163.16 22.68a42.88 42.88 0 006.33.47c15.53 0 30.62-8.22 42.52-23.15 10.59-13.29 17.95-31.18 20.75-50.4 6.62-45.72-13.55-85.22-45.92-90a42.88 42.88 0 00-6.33-.47C315 48 299.88 56.21 288 71.11c-10.6 13.28-18 31.19-20.76 50.44-6.62 45.72 13.55 85.22 45.92 89.98zM111.59 308.8l.14-.05c11.93-4.79 21.16-14.29 26.69-27.48 8.38-20 7.2-46.75-3.15-71.65C120.94 175.16 92.85 152 65.38 152a46.4 46.4 0 00-17 3.2l-.14.05c-11.9 4.75-21.13 14.29-26.66 27.48-8.38 20-7.2 46.75 3.15 71.65C39.06 288.84 67.15 312 94.62 312a46.4 46.4 0 0016.97-3.2z"
                }
            }
        ]
    })(props);
}
function IoPencilOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M364.13 125.25L87 403l-23 45 44.99-23 277.76-277.13-22.62-22.62zm56.56-56.56l-22.62 22.62 22.62 22.63 22.62-22.63a16 16 0 000-22.62h0a16 16 0 00-22.62 0z"
                }
            }
        ]
    })(props);
}
function IoPencilSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M103 464H48v-55L358.14 98.09l55.77 55.78L103 464zm322.72-322L370 86.28l31.66-30.66C406.55 50.7 414.05 48 421 48a25.91 25.91 0 0118.42 7.62l17 17A25.87 25.87 0 01464 91c0 7-2.71 14.45-7.62 19.36zm-7.52-70.83z"
                }
            }
        ]
    })(props);
}
function IoPencil(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "44",
                    "d": "M358.62 129.28L86.49 402.08 70 442l39.92-16.49 272.8-272.13-24.1-24.1zm54.45-54.44l-11.79 11.78 24.1 24.1 11.79-11.79a16.51 16.51 0 000-23.34l-.75-.75a16.51 16.51 0 00-23.35 0z"
                }
            }
        ]
    })(props);
}
function IoPeopleCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 464c-114.69 0-208-93.31-208-208S141.31 48 256 48s208 93.31 208 208-93.31 208-208 208zm0-384c-97 0-176 79-176 176s79 176 176 176 176-78.95 176-176S353.05 80 256 80z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M323.67 292c-17.4 0-34.21-7.72-47.34-21.73a83.76 83.76 0 01-22-51.32c-1.47-20.7 4.88-39.75 17.88-53.62S303.38 144 323.67 144c20.14 0 38.37 7.62 51.33 21.46s19.47 33 18 53.51a84 84 0 01-22 51.3C357.86 284.28 341.06 292 323.67 292zm55.81-74zm-215.66 77.36c-29.76 0-55.93-27.51-58.33-61.33-1.23-17.32 4.15-33.33 15.17-45.08s26.22-18 43.15-18 32.12 6.44 43.07 18.14 16.5 27.82 15.25 45c-2.44 33.77-28.6 61.27-58.31 61.27zm256.55 59.92c-1.59-4.7-5.46-9.71-13.22-14.46-23.46-14.33-52.32-21.91-83.48-21.91-30.57 0-60.23 7.9-83.53 22.25-26.25 16.17-43.89 39.75-51 68.18-1.68 6.69-4.13 19.14-1.51 26.11a192.18 192.18 0 00232.75-80.17zm-256.74 46.09c7.07-28.21 22.12-51.73 45.47-70.75a8 8 0 00-2.59-13.77c-12-3.83-25.7-5.88-42.69-5.88-23.82 0-49.11 6.45-68.14 18.17-5.4 3.33-10.7 4.61-14.78 5.75a192.84 192.84 0 0077.78 86.64l1.79-.14a102.82 102.82 0 013.16-20.02z"
                }
            }
        ]
    })(props);
}
function IoPeopleCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm69.3 96.17a72.5 72.5 0 11-72.6 72.5 72.55 72.55 0 0172.6-72.5zm-155.1 26.36a59.32 59.32 0 11-59.4 59.32 59.35 59.35 0 0159.4-59.32zm-75.85 155c24.5-13.29 55.87-19.94 75.85-19.94 15 0 34.32 3 53.33 10.2a133.05 133.05 0 00-34 27.11c-13.19 15-20.76 32.92-20.76 50.83v15a177.06 177.06 0 01-74.42-83.15zM256 432a175.12 175.12 0 01-59.4-10.33v-27.05c0-52.59 85.75-79.09 128.7-79.09 23 0 58.38 7.63 86.21 22.81A176.14 176.14 0 01256 432z"
                }
            }
        ]
    })(props);
}
function IoPeopleCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M258.9 48C141.92 46.42 46.42 141.92 48 258.9c1.56 112.19 92.91 203.54 205.1 205.1 117 1.6 212.48-93.9 210.88-210.88C462.44 140.91 371.09 49.56 258.9 48zm-3.68 152.11c.21-1.2.44-2.4.71-3.59a66.46 66.46 0 0116.29-31.21c12.89-13.73 31.16-21.31 51.45-21.31a74.05 74.05 0 0125.06 4.26 66.69 66.69 0 0126.27 17.2 68.15 68.15 0 0118 42.14 78.46 78.46 0 010 11.4 86.19 86.19 0 01-8.2 31q-.76 1.59-1.59 3.15c-1.11 2.07-2.3 4.1-3.58 6.06a79.47 79.47 0 01-8.63 11c-13.12 14-29.92 21.73-47.31 21.73a59.61 59.61 0 01-19.17-3.18 63.47 63.47 0 01-6.1-2.43 70.76 70.76 0 01-22.07-16.12 83.76 83.76 0 01-22-51.32q-.27-3.88-.18-7.68a75.62 75.62 0 011.05-11.08zm-149.73 24.34a59.87 59.87 0 015.2-20.64 56.76 56.76 0 012.78-5.3 54.49 54.49 0 017.19-9.56 55.62 55.62 0 0114-10.82 56.84 56.84 0 018.11-3.64 63.85 63.85 0 0133.35-2.39 57 57 0 0130.78 17 57.86 57.86 0 0115.41 38.62c.05 2.11 0 4.23-.15 6.38a71.58 71.58 0 01-6 23.84 69.49 69.49 0 01-5.73 10.42 65.39 65.39 0 01-15.76 16.57c-1.5 1.07-3.06 2.07-4.67 3.07a54.21 54.21 0 01-10 4.65 49.31 49.31 0 01-16.2 2.76c-.93 0-1.86 0-2.78-.08a47.6 47.6 0 01-5.48-.62 51.19 51.19 0 01-5.35-1.23 53.54 53.54 0 01-7.72-2.89c-.84-.39-1.66-.8-2.48-1.23-18-9.49-31.57-29.16-34.23-52.12-.12-1.05-.22-2.1-.29-3.16a66.59 66.59 0 01.02-9.63zm53.92 178.6a177.27 177.27 0 01-61.94-70.65 4 4 0 011.62-5.26C117.67 316.69 141.4 311 163.82 311c17 0 30.7 2 42.69 5.88a8 8 0 012.59 13.77c-23.35 19-38.4 42.54-45.47 70.75a2.77 2.77 0 01-4.22 1.65zM256 432a175.12 175.12 0 01-65.7-12.72 4 4 0 01-2.4-4.46c.4-2.05.84-3.92 1.23-5.48 7.12-28.43 24.76-52 51-68.18 23.29-14.35 53-22.25 83.52-22.25 31.16 0 60 7.58 83.48 21.91a2.72 2.72 0 01.91 3.67A176.1 176.1 0 01256 432z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M161 295.28a47.6 47.6 0 01-5.48-.62 47.6 47.6 0 005.48.62zm-26.36-117.15a55.62 55.62 0 00-14 10.82 54.49 54.49 0 00-7.19 9.56 54.49 54.49 0 017.19-9.56 55.62 55.62 0 0114-10.82zm81.53 79.76a71.58 71.58 0 006-23.84c.15-2.15.2-4.27.15-6.38q.08 3.15-.15 6.38a71.58 71.58 0 01-6 23.84zm-81.53-79.76a56.84 56.84 0 018.11-3.64 56.84 56.84 0 00-8.11 3.64zm15.57 115.3a53.54 53.54 0 01-7.72-2.89 53.54 53.54 0 007.72 2.89zm-44.43-56.24c2.66 23 16.26 42.63 34.23 52.12-18.01-9.49-31.57-29.16-34.23-52.12zM254.34 219a83.76 83.76 0 0022 51.32 70.76 70.76 0 0022.07 16.12 70.76 70.76 0 01-22.07-16.12 83.76 83.76 0 01-22-51.32q-.27-3.88-.18-7.68-.09 3.75.18 7.68zm50.16 69.82a63.47 63.47 0 01-6.1-2.43 63.47 63.47 0 006.1 2.43zm-48.57-92.28a66.46 66.46 0 0116.29-31.21 66.46 66.46 0 00-16.29 31.21zM375 165.46a68.15 68.15 0 0118 42.14 68.15 68.15 0 00-18-42.14 66.69 66.69 0 00-26.27-17.2 66.69 66.69 0 0126.27 17.2zM393 219a86.19 86.19 0 01-8.2 31 86.19 86.19 0 008.2-31zm-138.84-7.73a75.62 75.62 0 011.06-11.14 75.62 75.62 0 00-1.06 11.14zm129.03 41.89zm-176.31-64.11a57.86 57.86 0 0115.41 38.62 57.86 57.86 0 00-15.41-38.62 57 57 0 00-30.78-17 57 57 0 0130.78 17zM190 288a54.21 54.21 0 01-10 4.65 54.21 54.21 0 0010-4.65zm-84.51-63.55a59.87 59.87 0 015.2-20.64 59.87 59.87 0 00-5.2 20.64zm89.19 60.43C193.17 286 191.61 287 190 288c1.61-1 3.17-2 4.68-3.12zm21.49-26.99a69.49 69.49 0 01-5.73 10.42 69.49 69.49 0 005.73-10.42zm-105.48-54.08a56.76 56.76 0 012.78-5.3 56.76 56.76 0 00-2.78 5.3zm83.99 81.07a65.39 65.39 0 0015.76-16.57 65.39 65.39 0 01-15.76 16.57z"
                }
            }
        ]
    })(props);
}
function IoPeopleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M402 168c-2.93 40.67-33.1 72-66 72s-63.12-31.32-66-72c-3-42.31 26.37-72 66-72s69 30.46 66 72z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M336 304c-65.17 0-127.84 32.37-143.54 95.41-2.08 8.34 3.15 16.59 11.72 16.59h263.65c8.57 0 13.77-8.25 11.72-16.59C463.85 335.36 401.18 304 336 304z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M200 185.94c-2.34 32.48-26.72 58.06-53 58.06s-50.7-25.57-53-58.06C91.61 152.15 115.34 128 147 128s55.39 24.77 53 57.94z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M206 306c-18.05-8.27-37.93-11.45-59-11.45-52 0-102.1 25.85-114.65 76.2-1.65 6.66 2.53 13.25 9.37 13.25H154"
                }
            }
        ]
    })(props);
}
function IoPeopleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "152",
                    "cy": "184",
                    "r": "72"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M234 296c-28.16-14.3-59.24-20-82-20-44.58 0-136 27.34-136 82v42h150v-16.07c0-19 8-38.05 22-53.93 11.17-12.68 26.81-24.45 46-34z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M340 288c-52.07 0-156 32.16-156 96v48h312v-48c0-63.84-103.93-96-156-96z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "340",
                    "cy": "168",
                    "r": "88"
                }
            }
        ]
    })(props);
}
function IoPeople(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 256c-20.56 0-40.44-9.18-56-25.84-15.13-16.25-24.37-37.92-26-61-1.74-24.62 5.77-47.26 21.14-63.76S312 80 336 80c23.83 0 45.38 9.06 60.7 25.52 15.47 16.62 23 39.22 21.26 63.63-1.67 23.11-10.9 44.77-26 61C376.44 246.82 356.57 256 336 256zm66-88zm65.83 264H204.18a27.71 27.71 0 01-22-10.67 30.22 30.22 0 01-5.26-25.79c8.42-33.81 29.28-61.85 60.32-81.08C264.79 297.4 299.86 288 336 288c36.85 0 71 9 98.71 26.05 31.11 19.13 52 47.33 60.38 81.55a30.27 30.27 0 01-5.32 25.78A27.68 27.68 0 01467.83 432zM147 260c-35.19 0-66.13-32.72-69-72.93-1.42-20.6 5-39.65 18-53.62 12.86-13.83 31-21.45 51-21.45s38 7.66 50.93 21.57c13.1 14.08 19.5 33.09 18 53.52-2.87 40.2-33.8 72.91-68.93 72.91zm65.66 31.45c-17.59-8.6-40.42-12.9-65.65-12.9-29.46 0-58.07 7.68-80.57 21.62-25.51 15.83-42.67 38.88-49.6 66.71a27.39 27.39 0 004.79 23.36A25.32 25.32 0 0041.72 400h111a8 8 0 007.87-6.57c.11-.63.25-1.26.41-1.88 8.48-34.06 28.35-62.84 57.71-83.82a8 8 0 00-.63-13.39c-1.57-.92-3.37-1.89-5.42-2.89z"
                }
            }
        ]
    })(props);
}
function IoPersonAddOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M376 144c-3.92 52.87-44 96-88 96s-84.15-43.12-88-96c-4-55 35-96 88-96s92 42 88 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M288 304c-87 0-175.3 48-191.64 138.6-2 10.92 4.21 21.4 15.65 21.4H464c11.44 0 17.62-10.48 15.65-21.4C463.3 352 375 304 288 304z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M88 176v112m56-56H32"
                }
            }
        ]
    })(props);
}
function IoPersonAddSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M106 304v-54h54v-36h-54v-54H70v54H16v36h54v54h36z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "288",
                    "cy": "144",
                    "r": "112"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M288 288c-69.42 0-208 42.88-208 128v64h416v-64c0-85.12-138.58-128-208-128z"
                }
            }
        ]
    })(props);
}
function IoPersonAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 256c52.79 0 99.43-49.71 104-110.82 2.27-30.7-7.36-59.33-27.12-80.6C345.33 43.57 318 32 288 32c-30.24 0-57.59 11.5-77 32.38-19.63 21.11-29.2 49.8-27 80.78C188.49 206.28 235.12 256 288 256zm207.38 183.76c-8.44-46.82-34.79-86.15-76.19-113.75C382.42 301.5 335.83 288 288 288s-94.42 13.5-131.19 38c-41.4 27.6-67.75 66.93-76.19 113.75-1.93 10.73.69 21.34 7.19 29.11A30.94 30.94 0 00112 480h352a30.94 30.94 0 0024.21-11.13c6.48-7.77 9.1-18.38 7.17-29.11zM104 288v-40h40a16 16 0 000-32h-40v-40a16 16 0 00-32 0v40H32a16 16 0 000 32h40v40a16 16 0 0032 0z"
                }
            }
        ]
    })(props);
}
function IoPersonCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M258.9 48C141.92 46.42 46.42 141.92 48 258.9c1.56 112.19 92.91 203.54 205.1 205.1 117 1.6 212.48-93.9 210.88-210.88C462.44 140.91 371.09 49.56 258.9 48zm126.42 327.25a4 4 0 01-6.14-.32 124.27 124.27 0 00-32.35-29.59C321.37 329 289.11 320 256 320s-65.37 9-90.83 25.34a124.24 124.24 0 00-32.35 29.58 4 4 0 01-6.14.32A175.32 175.32 0 0180 259c-1.63-97.31 78.22-178.76 175.57-179S432 158.81 432 256a175.32 175.32 0 01-46.68 119.25z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 144c-19.72 0-37.55 7.39-50.22 20.82s-19 32-17.57 51.93C191.11 256 221.52 288 256 288s64.83-32 67.79-71.24c1.48-19.74-4.8-38.14-17.68-51.82C293.39 151.44 275.59 144 256 144z"
                }
            }
        ]
    })(props);
}
function IoPersonCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm2 96a72 72 0 11-72 72 72 72 0 0172-72zm-2 288a175.55 175.55 0 01-129.18-56.6C135.66 329.62 215.06 320 256 320s120.34 9.62 129.18 55.39A175.52 175.52 0 01256 432z"
                }
            }
        ]
    })(props);
}
function IoPersonCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-50.22 116.82C218.45 151.39 236.28 144 256 144s37.39 7.44 50.11 20.94c12.89 13.68 19.16 32.06 17.68 51.82C320.83 256 290.43 288 256 288s-64.89-32-67.79-71.25c-1.47-19.92 4.79-38.36 17.57-51.93zM256 432a175.49 175.49 0 01-126-53.22 122.91 122.91 0 0135.14-33.44C190.63 329 222.89 320 256 320s65.37 9 90.83 25.34A122.87 122.87 0 01382 378.78 175.45 175.45 0 01256 432z"
                }
            }
        ]
    })(props);
}
function IoPersonOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M344 144c-3.92 52.87-44 96-88 96s-84.15-43.12-88-96c-4-55 35-96 88-96s92 42 88 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 304c-87 0-175.3 48-191.64 138.6C62.39 453.52 68.57 464 80 464h352c11.44 0 17.62-10.48 15.65-21.4C431.3 352 343 304 256 304z"
                }
            }
        ]
    })(props);
}
function IoPersonRemoveOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M376 144c-3.92 52.87-44 96-88 96s-84.15-43.12-88-96c-4-55 35-96 88-96s92 42 88 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M288 304c-87 0-175.3 48-191.64 138.6-2 10.92 4.21 21.4 15.65 21.4H464c11.44 0 17.62-10.48 15.65-21.4C463.3 352 375 304 288 304z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M144 232H32"
                }
            }
        ]
    })(props);
}
function IoPersonRemoveSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 214h144v36H16z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "288",
                    "cy": "144",
                    "r": "112"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M288 288c-69.42 0-208 42.88-208 128v64h416v-64c0-85.12-138.58-128-208-128z"
                }
            }
        ]
    })(props);
}
function IoPersonRemove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 256c52.79 0 99.43-49.71 104-110.82 2.27-30.7-7.36-59.33-27.12-80.6C345.33 43.57 318 32 288 32c-30.24 0-57.59 11.5-77 32.38-19.63 21.11-29.2 49.8-27 80.78C188.49 206.28 235.12 256 288 256zm207.38 183.76c-8.44-46.82-34.79-86.15-76.19-113.75C382.42 301.5 335.83 288 288 288s-94.42 13.5-131.19 38c-41.4 27.6-67.75 66.93-76.19 113.75-1.93 10.73.69 21.34 7.19 29.11A30.94 30.94 0 00112 480h352a30.94 30.94 0 0024.21-11.13c6.48-7.77 9.1-18.38 7.17-29.11zM144 216H32a16 16 0 000 32h112a16 16 0 000-32z"
                }
            }
        ]
    })(props);
}
function IoPersonSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 256a112 112 0 10-112-112 112 112 0 00112 112zm0 32c-69.42 0-208 42.88-208 128v64h416v-64c0-85.12-138.58-128-208-128z"
                }
            }
        ]
    })(props);
}
function IoPerson(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M332.64 64.58C313.18 43.57 286 32 256 32c-30.16 0-57.43 11.5-76.8 32.38-19.58 21.11-29.12 49.8-26.88 80.78C156.76 206.28 203.27 256 256 256s99.16-49.71 103.67-110.82c2.27-30.7-7.33-59.33-27.03-80.6zM432 480H80a31 31 0 01-24.2-11.13c-6.5-7.77-9.12-18.38-7.18-29.11C57.06 392.94 83.4 353.61 124.8 326c36.78-24.51 83.37-38 131.2-38s94.42 13.5 131.2 38c41.4 27.6 67.74 66.93 76.18 113.75 1.94 10.73-.68 21.34-7.18 29.11A31 31 0 01432 480z"
                }
            }
        ]
    })(props);
}
function IoPhoneLandscapeOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "256",
                    "height": "480",
                    "x": "128",
                    "y": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48",
                    "transform": "rotate(-90 256 256)"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M16 336v-24a8 8 0 018-8h0a16 16 0 0016-16v-64a16 16 0 00-16-16h0a8 8 0 01-8-8v-24"
                }
            }
        ]
    })(props);
}
function IoPhoneLandscapeSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 130v252a18 18 0 0018 18h476a18 18 0 0018-18V130a18 18 0 00-18-18H18a18 18 0 00-18 18zm448 234H64V148h384z"
                }
            }
        ]
    })(props);
}
function IoPhoneLandscape(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 176v160a64 64 0 0064 64h384a64 64 0 0064-64V176a64 64 0 00-64-64H64a64 64 0 00-64 64zm448-32a32 32 0 0132 32v160a32 32 0 01-32 32H64a32 32 0 01-32-32v-11.35a7.94 7.94 0 014.75-7.3A32 32 0 0056 288v-64a32 32 0 00-19.25-29.35 7.94 7.94 0 01-4.75-7.3V176a32 32 0 0132-32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M48 176a11.88 11.88 0 004.69 9.53A48 48 0 0172 224v64a48 48 0 01-19.31 38.47A11.88 11.88 0 0048 336a16 16 0 0016 16h384a16 16 0 0016-16V176a16 16 0 00-16-16H64a16 16 0 00-16 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 176v160a64 64 0 0064 64h384a64 64 0 0064-64V176a64 64 0 00-64-64H64a64 64 0 00-64 64zm448-32a32 32 0 0132 32v160a32 32 0 01-32 32H64a32 32 0 01-32-32v-11.35a7.94 7.94 0 014.75-7.3A32 32 0 0056 288v-64a32 32 0 00-19.25-29.35 7.94 7.94 0 01-4.75-7.3V176a32 32 0 0132-32z"
                }
            }
        ]
    })(props);
}
function IoPhonePortraitOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "256",
                    "height": "480",
                    "x": "128",
                    "y": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M176 16h24a8 8 0 018 8h0a16 16 0 0016 16h64a16 16 0 0016-16h0a8 8 0 018-8h24"
                }
            }
        ]
    })(props);
}
function IoPhonePortraitSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M382 0H130a18 18 0 00-18 18v476a18 18 0 0018 18h252a18 18 0 0018-18V18a18 18 0 00-18-18zM148 448V64h216v384z"
                }
            }
        ]
    })(props);
}
function IoPhonePortrait(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 0H176a64 64 0 00-64 64v384a64 64 0 0064 64h160a64 64 0 0064-64V64a64 64 0 00-64-64zm32 448a32 32 0 01-32 32H176a32 32 0 01-32-32V64a32 32 0 0132-32h11.35a7.94 7.94 0 017.3 4.75A32 32 0 00224 56h64a32 32 0 0029.35-19.25 7.94 7.94 0 017.3-4.75H336a32 32 0 0132 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M336 48a11.88 11.88 0 00-9.53 4.69A48 48 0 01288 72h-64a48 48 0 01-38.47-19.31A11.88 11.88 0 00176 48a16 16 0 00-16 16v384a16 16 0 0016 16h160a16 16 0 0016-16V64a16 16 0 00-16-16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M336 0H176a64 64 0 00-64 64v384a64 64 0 0064 64h160a64 64 0 0064-64V64a64 64 0 00-64-64zm32 448a32 32 0 01-32 32H176a32 32 0 01-32-32V64a32 32 0 0132-32h11.35a7.94 7.94 0 017.3 4.75A32 32 0 00224 56h64a32 32 0 0029.35-19.25 7.94 7.94 0 017.3-4.75H336a32 32 0 0132 32z"
                }
            }
        ]
    })(props);
}
function IoPieChartOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256.05 80.65Q263.94 80 272 80c106 0 192 86 192 192s-86 192-192 192A192.09 192.09 0 0189.12 330.65"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 48C141.12 48 48 141.12 48 256a207.29 207.29 0 0018.09 85L256 256z"
                }
            }
        ]
    })(props);
}
function IoPieChartSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M58 362.09l-6.51-14.59A224 224 0 01256 32h16v234.37z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M304 66.46v220.65L94.62 380.78A208.31 208.31 0 00272 480c114.69 0 208-93.31 208-208 0-103.81-76.45-190.1-176-205.54z"
                }
            }
        ]
    })(props);
}
function IoPieChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M66.1 357a16 16 0 01-14.61-9.46A224 224 0 01256 32a16 16 0 0116 16v208a16 16 0 01-9.47 14.61l-189.9 84.95A15.93 15.93 0 0166.1 357z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M313.59 68.18A8 8 0 00304 76v180a48.07 48.07 0 01-28.4 43.82L103.13 377a8 8 0 00-3.35 11.81 208.42 208.42 0 0048.46 50.41A206.32 206.32 0 00272 480c114.69 0 208-93.31 208-208 0-100.45-71.58-184.5-166.41-203.82z"
                }
            }
        ]
    })(props);
}
function IoPinOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "96",
                    "r": "64",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M272 164a9 9 0 00-9-9h-14a9 9 0 00-9 9v293.56a32.09 32.09 0 002.49 12.38l10.07 24a3.92 3.92 0 006.88 0l10.07-24a32.09 32.09 0 002.49-12.38z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "280",
                    "cy": "72",
                    "r": "24"
                }
            }
        ]
    })(props);
}
function IoPinSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M339 99a83 83 0 10-102 80.8V464l19 32 19-32V179.8A83.28 83.28 0 00339 99zm-59-6a21 21 0 1121-21 21 21 0 01-21 21z"
                }
            }
        ]
    })(props);
}
function IoPin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 96a80 80 0 10-96 78.39v283.17a32.09 32.09 0 002.49 12.38l10.07 24a3.92 3.92 0 006.88 0l10.07-24a32.09 32.09 0 002.49-12.38V174.39A80.13 80.13 0 00336 96zm-56 0a24 24 0 1124-24 24 24 0 01-24 24z"
                }
            }
        ]
    })(props);
}
function IoPintOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M132.43 162c-6.24-34-4.49-45.55-3.07-68.39L132.27 47a16 16 0 0115.94-15h215.57a16 16 0 0115.94 15l2.91 46.61c1.43 22.86 3.19 34.39-3.06 68.45-5.93 32.29-43.71 133.27-43.71 238.32V472a8 8 0 01-8 8H184.12a8 8 0 01-8-8v-71.63c.01-92.47-37.46-204.3-43.69-238.37zm2.78-66h241.58"
                }
            }
        ]
    })(props);
}
function IoPintSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M399 99.29L394 16H118.45L113 99.26c-1.29 19.24-2.23 33.14 3.73 65.66 1.67 9.11 5.22 22.66 9.73 39.82 12.61 48 33.71 128.36 33.71 195.63V496h191.68v-95.62c0-77.09 21.31-153.29 34-198.81 4.38-15.63 7.83-28 9.41-36.62 6.01-32.51 5.07-46.42 3.74-65.66zM146.23 80l2-32h215.52l2 32z"
                }
            }
        ]
    })(props);
}
function IoPint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M399 99.29c-.15-2.13-.3-4.35-.44-6.68L395.69 46a32 32 0 00-31.91-30H148.21a32 32 0 00-31.91 30l-2.91 46.63c-.14 2.31-.29 4.51-.43 6.62-1.29 19.24-2.23 33.14 3.73 65.66 1.67 9.11 5.22 22.66 9.73 39.82 12.61 48 33.71 128.36 33.71 195.63V472a24 24 0 0024 24h143.74a24 24 0 0024-24v-71.62c0-77.09 21.31-153.29 34-198.81 4.38-15.63 7.83-28 9.41-36.62 5.99-32.51 5.05-46.42 3.72-65.66zm-35-47.54l1.5 24a4 4 0 01-4 4.25h-211a4 4 0 01-4-4.25l1.48-24A4 4 0 01152 48h208a4 4 0 014 3.75z"
                }
            }
        ]
    })(props);
}
function IoPizzaOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M404.76 123.08C358.37 104.18 309.69 96 256 96s-106.1 9-148.9 26.68c-8.08 3.3-15.26 9-10.07 19.5C101.24 150.71 203 375 241.66 455a15.94 15.94 0 0028.72 0l144.05-312.22c3.19-6.9.9-15.4-9.67-19.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M436.38 82.68C384.31 62.08 320.17 48 256 48S128.65 60.78 75.48 82.08C70.79 84 62 88.43 64.41 95.88L74.09 120c4 8.2 8.67 8.2 15.06 8.2 1.79 0 4.29-1 7.28-2.18A442.46 442.46 0 01256 96c56.76 0 114.91 12 159.6 30 3.59 1.4 5.59 2.18 7.28 2.18 6.58 0 10.38 2.19 15-8.1L447.65 96c2.01-6-4.99-10.82-11.27-13.32z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "192",
                    "cy": "192",
                    "r": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "320",
                    "cy": "208",
                    "r": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "320",
                    "r": "32"
                }
            }
        ]
    })(props);
}
function IoPizzaSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M442.3 67.82C383.92 44.72 317.78 32 256 32c-63.57 0-129.8 12.51-186.56 35.25C49.18 75.48 42 80 42 80l22 44 37.53-16.14C147.58 89.53 199.19 80 256.51 80c57.49 0 108.09 9.23 154.75 28.25L448 124l22-44s-7-4-27.7-12.18z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "320.48",
                    "cy": "207.99",
                    "fill": "none",
                    "rx": "31.97",
                    "ry": "32.03",
                    "transform": "rotate(-44.98 320.503 207.996)"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "192.48",
                    "cy": "191.99",
                    "fill": "none",
                    "rx": "31.97",
                    "ry": "32.03",
                    "transform": "rotate(-44.98 192.49 191.992)"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "256.48",
                    "cy": "319.99",
                    "fill": "none",
                    "rx": "31.97",
                    "ry": "32.03",
                    "transform": "rotate(-44.98 256.505 320)"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M409.66 140.85C364.15 122.52 308.16 112 256 112a425 425 0 00-153.7 28.9c-.25.1-9.24 4.23-19 8.71 7.46 16.22 18 39.16 22.2 48.33L256 480l173.74-330.84-19.92-8.24zm-185.25 53.22a32 32 0 11-34-34 32.12 32.12 0 0134 34zm64 128a32 32 0 11-34-34 32.12 32.12 0 0134 34zm64-112a32 32 0 11-34-34 32.12 32.12 0 0134 34z"
                }
            }
        ]
    })(props);
}
function IoPizza(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M441.82 67.83C383.44 44.73 317.3 32 255.56 32 192 32 125.76 44.53 69 67.26 48.7 75.49 45.21 90 48.71 100.82L52.78 111a16 16 0 0021.31 8.69c10.8-4.76 23.93-10.54 27-11.78C145.1 89.64 198.71 80 256 80c57.47 0 108.09 9.24 154.76 28.25 4.42 1.8 14.88 6.42 26.17 11.46a16 16 0 0021.35-8.59L462 102l.34-.9c3.45-10.21.14-25.05-20.52-33.27z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M409.18 140.86C363.67 122.53 307.68 112 255.56 112a425 425 0 00-153.74 28.89c-.53.21-2.06.88-4.29 1.88a16 16 0 00-8 21.27c4 8.71 9.42 20.58 15.5 33.89C137.94 270 199.21 404 227.26 462A31.74 31.74 0 00256 480a31.73 31.73 0 0028.76-18.06l.06-.13 137.3-297.57a15.94 15.94 0 00-8.31-21.45c-2.26-.95-3.85-1.61-4.5-1.87zm-215.1 83.07a32 32 0 1129.85-29.85 32 32 0 01-29.85 29.85zm64 128a32 32 0 1129.85-29.85 32 32 0 01-29.85 29.85zm64-112a32 32 0 1129.85-29.85 32 32 0 01-29.85 29.85z"
                }
            }
        ]
    })(props);
}
function IoPlanetOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M413.48 284.46c58.87 47.24 91.61 89 80.31 108.55-17.85 30.85-138.78-5.48-270.1-81.15S.37 149.84 18.21 119c11.16-19.28 62.58-12.32 131.64 14.09"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "160",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function IoPlanetSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M81 274.71C90.36 363 165.26 432 256 432a174.91 174.91 0 0071.49-15.19c-40.3-16.53-84.05-38.17-127.77-63.36C157 328.86 115.84 301.5 81 274.71zm411.72 64.8c-8.5-11.31-20-23.8-34-37a205.25 205.25 0 01-11 34c28.72 29.5 33.2 45.34 32.17 48.45-2 2.23-17.05 6.89-58.15-3.53q-8.83-2.24-19.32-5.46-6.76-2.08-13.79-4.49a176.76 176.76 0 0019.54-27.25c.17-.29.35-.58.52-.88A175.39 175.39 0 00432 256a178.87 178.87 0 00-1-19c-9.57-88.17-84.4-157-175-157a175.37 175.37 0 00-106.4 35.89 177.4 177.4 0 00-45.83 51.84c-.16.29-.34.58-.51.87a175.48 175.48 0 00-13.83 30.52q-5.59-4.87-10.79-9.67c-5.39-5-10.17-9.63-14.42-14-29.57-30.26-33.09-45.61-32.16-48.45 2.16-2.43 18.1-6.54 58.13 3.55a209.88 209.88 0 0124-26.56c-18.86-5.61-35.79-9.35-50.05-11C33.41 89.47 13.3 95.52 4.35 111c-3.24 5.58-6.35 15.09-2.72 28.6C7 159.66 26.14 184 53.23 209.5c8.63 8.13 18.06 16.37 28.12 24.64 7.32 6 15 12.06 22.9 18.08q7.91 6 16.15 12T137.1 276c25.41 17.61 52.26 34.52 78.59 49.69q14.34 8.26 28.64 16t28.37 14.81c21.9 11 43.35 20.92 63.86 29.43q13.19 5.48 25.81 10.16c11.89 4.42 23.37 8.31 34.31 11.59l1.1.33c25.73 7.66 47.42 11.69 64.48 12H464c21.64 0 36.3-6.38 43.58-19 9.09-15.62 4.08-36.32-14.86-61.5z"
                }
            }
        ]
    })(props);
}
function IoPlanet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96.85 286.62a8 8 0 00-12.53 8.25C102.07 373.28 172.3 432 256 432a175.31 175.31 0 0052.41-8 8 8 0 00.79-15 1120 1120 0 01-109.48-55.61 1126.24 1126.24 0 01-102.87-66.77zm395.87 52.89c-4.19-5.58-9.11-11.44-14.7-17.53a15.83 15.83 0 00-26.56 5.13c0 .16-.11.31-.17.47a15.75 15.75 0 003.15 16.06c22.74 25 26.42 38.51 25.48 41.36-2 2.23-17.05 6.89-58.15-3.53q-8.83-2.24-19.32-5.46-6.76-2.08-13.79-4.49a176.76 176.76 0 0019.54-27.25c.17-.29.35-.58.52-.88A175.39 175.39 0 00432 256a178.87 178.87 0 00-1-19c-9.57-88.17-84.4-157-175-157a175.37 175.37 0 00-106.4 35.89 177.4 177.4 0 00-45.83 51.84c-.16.29-.34.58-.51.87a175.48 175.48 0 00-13.83 30.52q-5.59-4.87-10.79-9.67c-5.39-5-10.17-9.63-14.42-14-29.57-30.26-33.09-45.61-32.16-48.45 2-2.23 15.54-5.87 48.62 1.31A15.82 15.82 0 0096.22 123l.36-.44a15.74 15.74 0 00-8.67-25.43A237.38 237.38 0 0064.13 93c-30.72-3.53-50.83 2.52-59.78 18-3.24 5.58-6.35 15.09-2.72 28.6C7 159.66 26.14 184 53.23 209.5c8.63 8.13 18.06 16.37 28.12 24.64 7.32 6 15 12.06 22.9 18.08q7.91 6 16.15 12T137.1 276c25.41 17.61 52.26 34.52 78.59 49.69q14.34 8.26 28.64 16t28.37 14.81c21.9 11 43.35 20.92 63.86 29.43q13.19 5.48 25.81 10.16c11.89 4.42 23.37 8.31 34.31 11.59l1.1.33c25.73 7.66 47.42 11.69 64.48 12H464c21.64 0 36.3-6.38 43.58-19 9.09-15.62 4.08-36.32-14.86-61.5z"
                }
            }
        ]
    })(props);
}
function IoPlayBackCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 448c106 0 192-86 192-192S362 64 256 64 64 150 64 256s86 192 192 192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M117.23 246.7l114.45-69.14a10.78 10.78 0 0116.32 9.31v53.32l103.68-62.63a10.78 10.78 0 0116.32 9.31v138.26a10.78 10.78 0 01-16.32 9.31L248 271.81v53.32a10.78 10.78 0 01-16.32 9.31L117.23 265.3a10.89 10.89 0 010-18.6z"
                }
            }
        ]
    })(props);
}
function IoPlayBackCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 256c0 114.69 93.31 208 208 208s208-93.31 208-208S370.69 48 256 48 48 141.31 48 256zm63.47 0L248 168v72.16l120-72.48v176.45l-120-72.32v71.44z"
                }
            }
        ]
    })(props);
}
function IoPlayBackCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 256c0 114.69 93.31 208 208 208s208-93.31 208-208S370.69 48 256 48 48 141.31 48 256zm69.23-9.3l114.45-69.14a10.78 10.78 0 0116.32 9.31v53.32l103.68-62.63a10.78 10.78 0 0116.32 9.31v138.26a10.78 10.78 0 01-16.32 9.31L248 271.81v53.32a10.78 10.78 0 01-16.32 9.31L117.23 265.3a10.89 10.89 0 010-18.6z"
                }
            }
        ]
    })(props);
}
function IoPlayBackOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M480 145.52v221c0 13.28-13 21.72-23.63 15.35L267.5 268.8c-9.24-5.53-9.24-20.07 0-25.6l188.87-113C467 123.8 480 132.24 480 145.52zm-228.57 0v221c0 13.28-13 21.72-23.63 15.35L38.93 268.8c-9.24-5.53-9.24-20.07 0-25.6l188.87-113c10.64-6.4 23.63 2.04 23.63 15.32z"
                }
            }
        ]
    })(props);
}
function IoPlayBackSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 400L256 256l240-144v288zm-240 0L16 256l240-144v288z"
                }
            }
        ]
    })(props);
}
function IoPlayBack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M30.71 229.47l188.87-113a30.54 30.54 0 0131.09-.39 33.74 33.74 0 0116.76 29.47v79.05l180.72-108.16a30.54 30.54 0 0131.09-.39A33.74 33.74 0 01496 145.52v221A33.73 33.73 0 01479.24 396a30.54 30.54 0 01-31.09-.39L267.43 287.4v79.08A33.73 33.73 0 01250.67 396a30.54 30.54 0 01-31.09-.39l-188.87-113a31.27 31.27 0 010-53z"
                }
            }
        ]
    })(props);
}
function IoPlayCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M216.32 334.44l114.45-69.14a10.89 10.89 0 000-18.6l-114.45-69.14a10.78 10.78 0 00-16.32 9.31v138.26a10.78 10.78 0 0016.32 9.31z"
                }
            }
        ]
    })(props);
}
function IoPlayCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-56 296V168l144 88z"
                }
            }
        ]
    })(props);
}
function IoPlayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm74.77 217.3l-114.45 69.14a10.78 10.78 0 01-16.32-9.31V186.87a10.78 10.78 0 0116.32-9.31l114.45 69.14a10.89 10.89 0 010 18.6z"
                }
            }
        ]
    })(props);
}
function IoPlayForwardCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M394.77 246.7l-114.45-69.14a10.78 10.78 0 00-16.32 9.31v53.32l-103.68-62.63a10.78 10.78 0 00-16.32 9.31v138.26a10.78 10.78 0 0016.32 9.31L264 271.81v53.32a10.78 10.78 0 0016.32 9.31l114.45-69.14a10.89 10.89 0 000-18.6z"
                }
            }
        ]
    })(props);
}
function IoPlayForwardCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm8 295.25v-71.44l-120 72.32V167.71l120 72.48V168l136.53 88z"
                }
            }
        ]
    })(props);
}
function IoPlayForwardCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm138.77 217.3l-114.45 69.14a10.78 10.78 0 01-16.32-9.31v-53.32l-103.68 62.63a10.78 10.78 0 01-16.32-9.31V186.87a10.78 10.78 0 0116.32-9.31L264 240.19v-53.32a10.78 10.78 0 0116.32-9.31l114.45 69.14a10.89 10.89 0 010 18.6z"
                }
            }
        ]
    })(props);
}
function IoPlayForwardOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M32 145.52v221c0 13.28 13 21.72 23.63 15.35l188.87-113c9.24-5.53 9.24-20.07 0-25.6l-188.87-113C45 123.8 32 132.24 32 145.52zm228.57 0v221c0 13.28 13 21.72 23.63 15.35l188.87-113c9.24-5.53 9.24-20.07 0-25.6l-188.87-113c-10.64-6.47-23.63 1.97-23.63 15.25z"
                }
            }
        ]
    })(props);
}
function IoPlayForwardSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 400l240-144L16 112v288zm240 0l240-144-240-144v288z"
                }
            }
        ]
    })(props);
}
function IoPlayForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M481.29 229.47l-188.87-113a30.54 30.54 0 00-31.09-.39 33.74 33.74 0 00-16.76 29.47v79.05L63.85 116.44a30.54 30.54 0 00-31.09-.39A33.74 33.74 0 0016 145.52v221A33.74 33.74 0 0032.76 396a30.54 30.54 0 0031.09-.39L244.57 287.4v79.08A33.74 33.74 0 00261.33 396a30.54 30.54 0 0031.09-.39l188.87-113a31.27 31.27 0 000-53z"
                }
            }
        ]
    })(props);
}
function IoPlayOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M112 111v290c0 17.44 17 28.52 31 20.16l247.9-148.37c12.12-7.25 12.12-26.33 0-33.58L143 90.84c-14-8.36-31 2.72-31 20.16z"
                }
            }
        ]
    })(props);
}
function IoPlaySharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 448l320-192L96 64v384z"
                }
            }
        ]
    })(props);
}
function IoPlaySkipBackCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 448c106 0 192-86 192-192S362 64 256 64 64 150 64 256s86 192 192 192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M192 176a16 16 0 0116 16v53l111.68-67.46a10.78 10.78 0 0116.32 9.33v138.26a10.78 10.78 0 01-16.32 9.31L208 267v53a16 16 0 01-32 0V192a16 16 0 0116-16z"
                }
            }
        ]
    })(props);
}
function IoPlaySkipBackCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 256c0 114.69 93.31 208 208 208s208-93.31 208-208S370.69 48 256 48 48 141.31 48 256zm128-80h32v69l128-77.53v176.9L208 267v69h-32z"
                }
            }
        ]
    })(props);
}
function IoPlaySkipBackCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 256c0 114.69 93.31 208 208 208s208-93.31 208-208S370.69 48 256 48 48 141.31 48 256zm128-64a16 16 0 0132 0v53l111.68-67.46a10.78 10.78 0 0116.32 9.33v138.26a10.78 10.78 0 01-16.32 9.31L208 267v53a16 16 0 01-32 0z"
                }
            }
        ]
    })(props);
}
function IoPlaySkipBackOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M400 111v290c0 17.44-17 28.52-31 20.16L121.09 272.79c-12.12-7.25-12.12-26.33 0-33.58L369 90.84c14-8.36 31 2.72 31 20.16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M112 80v352"
                }
            }
        ]
    })(props);
}
function IoPlaySkipBackSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M143.47 64v163.52L416 64v384L143.47 284.48V448H96V64h47.47z"
                }
            }
        ]
    })(props);
}
function IoPlaySkipBack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 64a16 16 0 0116 16v136.43L360.77 77.11a35.13 35.13 0 0135.77-.44c12 6.8 19.46 20 19.46 34.33v290c0 14.37-7.46 27.53-19.46 34.33a35.14 35.14 0 01-35.77-.45L128 295.57V432a16 16 0 01-32 0V80a16 16 0 0116-16z"
                }
            }
        ]
    })(props);
}
function IoPlaySkipForwardCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M320 176a16 16 0 00-16 16v53l-111.68-67.44a10.78 10.78 0 00-16.32 9.31v138.26a10.78 10.78 0 0016.32 9.31L304 267v53a16 16 0 0032 0V192a16 16 0 00-16-16z"
                }
            }
        ]
    })(props);
}
function IoPlaySkipForwardCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm80 288h-32v-69l-128 77.37V167.49L304 245v-69h32z"
                }
            }
        ]
    })(props);
}
function IoPlaySkipForwardCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm80 272a16 16 0 01-32 0v-53l-111.68 67.44a10.78 10.78 0 01-16.32-9.31V186.87a10.78 10.78 0 0116.32-9.31L304 245v-53a16 16 0 0132 0z"
                }
            }
        ]
    })(props);
}
function IoPlaySkipForwardOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M112 111v290c0 17.44 17 28.52 31 20.16l247.9-148.37c12.12-7.25 12.12-26.33 0-33.58L143 90.84c-14-8.36-31 2.72-31 20.16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M400 80v352"
                }
            }
        ]
    })(props);
}
function IoPlaySkipForwardSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368.53 64v163.52L96 64v384l272.53-163.52V448H416V64h-47.47z"
                }
            }
        ]
    })(props);
}
function IoPlaySkipForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 64a16 16 0 00-16 16v136.43L151.23 77.11a35.13 35.13 0 00-35.77-.44C103.46 83.47 96 96.63 96 111v290c0 14.37 7.46 27.53 19.46 34.33a35.14 35.14 0 0035.77-.45L384 295.57V432a16 16 0 0032 0V80a16 16 0 00-16-16z"
                }
            }
        ]
    })(props);
}
function IoPlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M133 440a35.37 35.37 0 01-17.5-4.67c-12-6.8-19.46-20-19.46-34.33V111c0-14.37 7.46-27.53 19.46-34.33a35.13 35.13 0 0135.77.45l247.85 148.36a36 36 0 010 61l-247.89 148.4A35.5 35.5 0 01133 440z"
                }
            }
        ]
    })(props);
}
function IoPodiumOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M32 160v296a8 8 0 008 8h136V160a16 16 0 00-16-16H48a16 16 0 00-16 16zM320 48H192a16 16 0 00-16 16v400h160V64a16 16 0 00-16-16zm144 160H352a16 16 0 00-16 16v240h136a8 8 0 008-8V224a16 16 0 00-16-16z"
                }
            }
        ]
    })(props);
}
function IoPodiumSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 32h192v448H160zm224 160h112v288H384zM16 128h112v352H16z"
                }
            }
        ]
    })(props);
}
function IoPodium(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 32H192a32 32 0 00-32 32v412a4 4 0 004 4h184a4 4 0 004-4V64a32 32 0 00-32-32zm144 160h-72a8 8 0 00-8 8v272a8 8 0 008 8h80a24 24 0 0024-24V224a32 32 0 00-32-32zM48 128a32 32 0 00-32 32v296a24 24 0 0024 24h80a8 8 0 008-8V136a8 8 0 00-8-8z"
                }
            }
        ]
    })(props);
}
function IoPowerOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M378 108a191.41 191.41 0 0170 148c0 106-86 192-192 192S64 362 64 256a192 192 0 0169-148m123-44v192"
                }
            }
        ]
    })(props);
}
function IoPowerSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 464c-114.69 0-208-93.23-208-207.82a207.44 207.44 0 0174.76-160.13l16.9-14 28.17 33.72-16.9 14A163.72 163.72 0 0092 256.18c0 90.39 73.57 163.93 164 163.93s164-73.54 164-163.93a163.38 163.38 0 00-59.83-126.36l-17-14 28-33.82 17 14A207.13 207.13 0 01464 256.18C464 370.77 370.69 464 256 464z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M234 48h44v224h-44z"
                }
            }
        ]
    })(props);
}
function IoPower(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 464c-114.69 0-208-93.47-208-208.35 0-62.45 27.25-121 74.76-160.55a22 22 0 1128.17 33.8C113.48 160.1 92 206.3 92 255.65 92 346.27 165.57 420 256 420s164-73.73 164-164.35A164 164 0 00360.17 129a22 22 0 1128-33.92A207.88 207.88 0 01464 255.65C464 370.53 370.69 464 256 464z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 272a22 22 0 01-22-22V70a22 22 0 0144 0v180a22 22 0 01-22 22z"
                }
            }
        ]
    })(props);
}
function IoPricetagOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M435.25 48h-122.9a14.46 14.46 0 00-10.2 4.2L56.45 297.9a28.85 28.85 0 000 40.7l117 117a28.85 28.85 0 0040.7 0L459.75 210a14.46 14.46 0 004.2-10.2v-123a28.66 28.66 0 00-28.7-28.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M384 160a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function IoPricetagSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 32L16 320l176 176 288-288V32zm80 128a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function IoPricetag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M467 45.2A44.45 44.45 0 00435.29 32H312.36a30.63 30.63 0 00-21.52 8.89L45.09 286.59a44.82 44.82 0 000 63.32l117 117a44.83 44.83 0 0063.34 0l245.65-245.6A30.6 30.6 0 00480 199.8v-123a44.24 44.24 0 00-13-31.6zM384 160a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function IoPricetagsOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M403.29 32H280.36a14.46 14.46 0 00-10.2 4.2L24.4 281.9a28.85 28.85 0 000 40.7l117 117a28.86 28.86 0 0040.71 0L427.8 194a14.46 14.46 0 004.2-10.2v-123A28.66 28.66 0 00403.29 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M352 144a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M230 480l262-262a13.81 13.81 0 004-10V80"
                }
            }
        ]
    })(props);
}
function IoPricetagsSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 16L0 304l176 176 288-288V16zm80 128a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M480 64v144L216.9 471.1 242 496l270-272V64h-32z"
                }
            }
        ]
    })(props);
}
function IoPricetags(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 183.8v-123A44.66 44.66 0 00403.29 16H280.36a30.62 30.62 0 00-21.51 8.89L13.09 270.58a44.86 44.86 0 000 63.34l117 117a44.84 44.84 0 0063.33 0l245.69-245.61A30.6 30.6 0 00448 183.8zM352 144a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M496 64a16 16 0 00-16 16v127.37L218.69 468.69a16 16 0 1022.62 22.62l262-262A29.84 29.84 0 00512 208V80a16 16 0 00-16-16z"
                }
            }
        ]
    })(props);
}
function IoPrintOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M384 368h24a40.12 40.12 0 0040-40V168a40.12 40.12 0 00-40-40H104a40.12 40.12 0 00-40 40v160a40.12 40.12 0 0040 40h24"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "256",
                    "height": "208",
                    "x": "128",
                    "y": "240",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "24.32",
                    "ry": "24.32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M384 128v-24a40.12 40.12 0 00-40-40H168a40.12 40.12 0 00-40 40v24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "392",
                    "cy": "184",
                    "r": "24"
                }
            }
        ]
    })(props);
}
function IoPrintSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 96V56a8 8 0 00-8-8H120a8 8 0 00-8 8v40"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "208",
                    "height": "160",
                    "x": "152",
                    "y": "264",
                    "fill": "none",
                    "rx": "4",
                    "ry": "4"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "208",
                    "height": "160",
                    "x": "152",
                    "y": "264",
                    "fill": "none",
                    "rx": "4",
                    "ry": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M408 112H104a56 56 0 00-56 56v208a8 8 0 008 8h56v72a8 8 0 008 8h272a8 8 0 008-8v-72h56a8 8 0 008-8V168a56 56 0 00-56-56zm-48 308a4 4 0 01-4 4H156a4 4 0 01-4-4V268a4 4 0 014-4h200a4 4 0 014 4zm34-212.08a24 24 0 1122-22 24 24 0 01-22 22z"
                }
            }
        ]
    })(props);
}
function IoPrint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408 112H106a58 58 0 00-58 58v158a56 56 0 0056 56h8v39.68A40.32 40.32 0 00152.32 464h207.36A40.32 40.32 0 00400 423.68V384h8a56 56 0 0056-56V168a56 56 0 00-56-56zm-40 311.68a8.35 8.35 0 01-8.32 8.32H152.32a8.35 8.35 0 01-8.32-8.32V264.32a8.35 8.35 0 018.32-8.32h207.36a8.35 8.35 0 018.32 8.32zm26-215.76a24 24 0 1122-22 24 24 0 01-22 22zM344 48H168a56.09 56.09 0 00-55.42 48h286.84A56.09 56.09 0 00344 48z"
                }
            }
        ]
    })(props);
}
function IoPrismOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M229.73 45.88L37.53 327.79a31.79 31.79 0 0011.31 46L241 476.26a31.77 31.77 0 0029.92 0l192.2-102.51a31.79 31.79 0 0011.31-46L282.27 45.88a31.8 31.8 0 00-52.54 0zM256 32v448"
                }
            }
        ]
    })(props);
}
function IoPrismSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 16L16 352l240 144 240-144zm-20 96.82v324.53L73.73 340z"
                }
            }
        ]
    })(props);
}
function IoPrism(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M487.83 319.44L295.63 36.88a48 48 0 00-79.26 0L24.17 319.44a47.1 47.1 0 0016.93 68.13l192.2 102.75a48.05 48.05 0 0045.4 0l192.2-102.75a47.1 47.1 0 0016.93-68.13zm-431.26 41a16.12 16.12 0 01-8-10.38 16.8 16.8 0 012.37-13.62L232.66 69.26c2.18-3.21 7.34-1.72 7.34 2.13v374c0 5.9-6.54 9.63-11.87 6.78z"
                }
            }
        ]
    })(props);
}
function IoPulseOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 320h64l64-256 64 384 64-224 32 96h64"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "432",
                    "cy": "320",
                    "r": "32",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function IoPulseSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M426 266a54.07 54.07 0 00-49.3 32h-24.84l-27-81a22 22 0 00-42 .92l-37.2 130.2-48-281.74a22 22 0 00-43-1.72L94.82 298H32v44h80a22 22 0 0021.34-16.66L171.69 172l46.61 273.62A22 22 0 00238.76 464H240a22 22 0 0021.15-16l44.47-149.62 9.51 28.62A22 22 0 00336 342h40.7a54 54 0 1049.3-76z"
                }
            }
        ]
    })(props);
}
function IoPulse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 272a48.09 48.09 0 00-45.25 32h-39.22l-28.35-85.06a16 16 0 00-30.56.66l-44.51 155.76-52.33-314a16 16 0 00-31.3-1.25L99.51 304H48a16 16 0 000 32h64a16 16 0 0015.52-12.12l45.34-181.37 51.36 308.12A16 16 0 00239.1 464h.91a16 16 0 0015.37-11.6l49.8-174.28 15.64 46.94A16 16 0 00336 336h50.75A48 48 0 10432 272z"
                }
            }
        ]
    })(props);
}
function IoPushOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M336 336h40a40 40 0 0040-40V88a40 40 0 00-40-40H136a40 40 0 00-40 40v208a40 40 0 0040 40h40"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M176 240l80-80 80 80m-80 224V176"
                }
            }
        ]
    })(props);
}
function IoPushSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 352V204.63l64 64L358.63 246 256 143.37 153.37 246 176 268.63l64-64V352H92a12 12 0 01-12-12V44a12 12 0 0112-12h328a12 12 0 0112 12v296a12 12 0 01-12 12zm-32 0h32v128h-32z"
                }
            }
        ]
    })(props);
}
function IoPush(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M376 352H272V198.63l52.69 52.68a16 16 0 0022.62-22.62l-80-80a16 16 0 00-22.62 0l-80 80a16 16 0 0022.62 22.62L240 198.63V352H136a56.06 56.06 0 01-56-56V88a56.06 56.06 0 0156-56h240a56.06 56.06 0 0156 56v208a56.06 56.06 0 01-56 56zM272 464a16 16 0 01-32 0V352h32z"
                }
            }
        ]
    })(props);
}
function IoQrCodeOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "336",
                    "y": "336",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "64",
                    "height": "64",
                    "x": "272",
                    "y": "272",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "64",
                    "height": "64",
                    "x": "416",
                    "y": "416",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "48",
                    "height": "48",
                    "x": "432",
                    "y": "272",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "48",
                    "height": "48",
                    "x": "272",
                    "y": "432",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "336",
                    "y": "96",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "176",
                    "height": "176",
                    "x": "288",
                    "y": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "16",
                    "ry": "16"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "96",
                    "y": "96",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "176",
                    "height": "176",
                    "x": "48",
                    "y": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "16",
                    "ry": "16"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "96",
                    "y": "336",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "176",
                    "height": "176",
                    "x": "48",
                    "y": "288",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "16",
                    "ry": "16"
                }
            }
        ]
    })(props);
}
function IoQrCodeSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 336h80v80h-80zm-64-64h64v64h-64zm144 144h64v64h-64zm16-144h48v48h-48zM272 432h48v48h-48zm64-336h80v80h-80z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M480 240H272V32h208zm-164-44h120V76H316zM96 96h80v80H96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M240 240H32V32h208zM76 196h120V76H76zm20 140h80v80H96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M240 480H32V272h208zM76 436h120V316H76z"
                }
            }
        ]
    })(props);
}
function IoQrCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "80",
                    "height": "80",
                    "x": "336",
                    "y": "336",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "64",
                    "height": "64",
                    "x": "272",
                    "y": "272",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "64",
                    "height": "64",
                    "x": "416",
                    "y": "416",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "48",
                    "height": "48",
                    "x": "432",
                    "y": "272",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "48",
                    "height": "48",
                    "x": "272",
                    "y": "432",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M448 32H304a32 32 0 00-32 32v144a32 32 0 0032 32h144a32 32 0 0032-32V64a32 32 0 00-32-32zm-32 136a8 8 0 01-8 8h-64a8 8 0 01-8-8v-64a8 8 0 018-8h64a8 8 0 018 8zM208 32H64a32 32 0 00-32 32v144a32 32 0 0032 32h144a32 32 0 0032-32V64a32 32 0 00-32-32zm-32 136a8 8 0 01-8 8h-64a8 8 0 01-8-8v-64a8 8 0 018-8h64a8 8 0 018 8zm32 104H64a32 32 0 00-32 32v144a32 32 0 0032 32h144a32 32 0 0032-32V304a32 32 0 00-32-32zm-32 136a8 8 0 01-8 8h-64a8 8 0 01-8-8v-64a8 8 0 018-8h64a8 8 0 018 8z"
                }
            }
        ]
    })(props);
}
function IoRadioButtonOffOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            }
        ]
    })(props);
}
function IoRadioButtonOffSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            }
        ]
    })(props);
}
function IoRadioButtonOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            }
        ]
    })(props);
}
function IoRadioButtonOnOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "144"
                }
            }
        ]
    })(props);
}
function IoRadioButtonOnSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "144"
                }
            }
        ]
    })(props);
}
function IoRadioButtonOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "144"
                }
            }
        ]
    })(props);
}
function IoRadioOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256.02",
                    "r": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M184.25 192.25a96 96 0 000 127.52m143.52 0a96 96 0 000-127.52m-194.49-50.97a168 168 0 000 229.44m245.44 0a168 168 0 000-229.44M435 416a240.34 240.34 0 000-320M77 96a240.34 240.34 0 000 320"
                }
            }
        ]
    })(props);
}
function IoRadioSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "rx": "36",
                    "ry": "35.99"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M188.4 350.8l-14.62-16.44a117.91 117.91 0 010-156.71l14.62-16.43 32.87 29.24-14.62 16.43a73.93 73.93 0 000 98.25l14.62 16.44zm135.2 0l-32.89-29.22 14.62-16.44a73.93 73.93 0 000-98.25l-14.62-16.43 32.87-29.24 14.62 16.43a117.91 117.91 0 010 156.71z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M138.24 401.76l-15-16.06a189.85 189.85 0 010-259.4l15-16.07 32.14 30.05-15 16.06a145.88 145.88 0 000 199.32l15 16.06zm235.52 0l-32.14-30 15-16.06a145.88 145.88 0 000-199.32l-15-16.06 32.14-30 15 16.07a189.85 189.85 0 010 259.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M430.73 447l-32.79-29.33 14.66-16.39a218.2 218.2 0 000-290.56l-14.67-16.38L430.72 65l14.67 16.39a262.18 262.18 0 010 349.22zm-349.46 0L66.6 430.61a262.18 262.18 0 010-349.22L81.28 65l32.79 29.34-14.68 16.38a218.2 218.2 0 000 290.56l14.66 16.39z"
                }
            }
        ]
    })(props);
}
function IoRadio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "36"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M190.24 341.77a22 22 0 01-16.46-7.38 118 118 0 010-156.76 22 22 0 1132.87 29.24 74 74 0 000 98.29 22 22 0 01-16.43 36.61zm131.52 0a22 22 0 01-16.43-36.61 74 74 0 000-98.29 22 22 0 1132.87-29.24 118 118 0 010 156.76 22 22 0 01-16.44 7.38z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M139.29 392.72a21.92 21.92 0 01-16.08-7 190 190 0 010-259.49 22 22 0 1132.13 30.06 146 146 0 000 199.38 22 22 0 01-16.06 37zm233.42 0a22 22 0 01-16.06-37 146 146 0 000-199.38 22 22 0 1132.13-30.06 190 190 0 010 259.49 21.92 21.92 0 01-16.07 6.95z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M429 438a22 22 0 01-16.39-36.67 218.34 218.34 0 000-290.66 22 22 0 0132.78-29.34 262.34 262.34 0 010 349.34A22 22 0 01429 438zm-346 0a21.94 21.94 0 01-16.41-7.33 262.34 262.34 0 010-349.34 22 22 0 0132.78 29.34 218.34 218.34 0 000 290.66A22 22 0 0183 438z"
                }
            }
        ]
    })(props);
}
function IoRainyOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M114.61 162.85A16.07 16.07 0 00128 149.6C140.09 76.17 193.63 32 256 32c57.93 0 96.62 37.75 112.2 77.74a15.84 15.84 0 0012.2 9.87c50 8.15 91.6 41.54 91.6 99.59 0 59.4-48.6 100.8-108 100.8H130c-49.5 0-90-24.7-90-79.2 0-48.47 38.67-72.22 74.61-77.95z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M144 384l-32 48m112-48l-64 96m144-96l-32 48m112-48l-64 96"
                }
            }
        ]
    })(props);
}
function IoRainySharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M364 336H130c-29.5 0-54.92-7.83-73.53-22.64C35.23 296.44 24 271.35 24 240.8c0-26.66 10.08-49.8 29.14-66.91 15.24-13.68 36.17-23.21 59-26.84.06 0 .08 0 .09-.05 6.44-39 23.83-72.09 50.31-95.68A140.24 140.24 0 01256 16c30.23 0 58.48 9.39 81.71 27.17a142.69 142.69 0 0145.36 60.66c29.41 4.82 54.72 17.11 73.19 35.54C477 160.11 488 187.71 488 219.2c0 32.85-13.13 62.87-37 84.52-22.89 20.82-53.8 32.28-87 32.28zm19-232.18zM93.82 430.422l49.75-74.626 26.626 17.75-49.751 74.627zm47.996 48.007L223.568 355.8l26.625 17.75-81.751 122.628zm111.995-48.005l49.751-74.626 26.626 17.75-49.751 74.627zm47.997 48.006l81.752-122.627 26.625 17.75-81.751 122.628z"
                }
            }
        ]
    })(props);
}
function IoRainy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M456.26 139.37c-16.77-16.73-39.17-28.41-65.17-34a16 16 0 01-11.19-9 142.24 142.24 0 00-42.19-53.21C314.48 25.39 286.23 16 256 16a140.24 140.24 0 00-93.5 35.32c-24.2 21.56-40.91 51.34-48.43 85.83a16.05 16.05 0 01-11.72 12.18c-25 6.3-35.71 12.54-49.21 24.56C34 190.93 24 214.14 24 240.8c0 30.55 11.23 55.64 32.47 72.56C75.08 328.17 100.5 336 130 336h234c33.2 0 64.11-11.46 87-32.28 23.84-21.65 37-51.67 37-84.52 0-31.49-11-59.09-31.74-79.83zM112 448a16 16 0 01-13.3-24.88l32-48a16 16 0 0126.62 17.76l-32 48A16 16 0 01112 448zm48 48a16 16 0 01-13.29-24.88l64-96a16 16 0 0126.62 17.76l-64 96A16 16 0 01160 496zm112-48a16 16 0 01-13.3-24.88l32-48a16 16 0 0126.62 17.76l-32 48A16 16 0 01272 448zm48 48a16 16 0 01-13.3-24.88l64-96a16 16 0 0126.62 17.76l-64 96A16 16 0 01320 496z"
                }
            }
        ]
    })(props);
}
function IoReaderOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "320",
                    "height": "416",
                    "x": "96",
                    "y": "48",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M176 128h160m-160 80h160m-160 80h80"
                }
            }
        ]
    })(props);
}
function IoReaderSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 44v424a12 12 0 0012 12h328a12 12 0 0012-12V44a12 12 0 00-12-12H92a12 12 0 00-12 12zm192 260H160v-32h112zm80-80H160v-32h192zm0-80H160v-32h192z"
                }
            }
        ]
    })(props);
}
function IoReader(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 32H144a64.07 64.07 0 00-64 64v320a64.07 64.07 0 0064 64h224a64.07 64.07 0 0064-64V96a64.07 64.07 0 00-64-64zM256 304h-80a16 16 0 010-32h80a16 16 0 010 32zm80-80H176a16 16 0 010-32h160a16 16 0 010 32zm0-80H176a16 16 0 010-32h160a16 16 0 010 32z"
                }
            }
        ]
    })(props);
}
function IoReceiptOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 336V48l32 16 32-16 31.94 16 32.37-16L320 64l31.79-16 31.93 16L416 48l32.01 16L480 48v224"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M480 272v112a80 80 0 01-80 80h0a80 80 0 01-80-80v-48H48a15.86 15.86 0 00-16 16c0 64 6.74 112 80 112h288"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M224 144h192m-128 80h128"
                }
            }
        ]
    })(props);
}
function IoReceiptSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 48l-32-16-32 16-32-16-32 16-32-16-32 16-32-16-32 16-48-16v256.05h224V424c0 30.93 33.07 56 64 56h12c30.93 0 52-25.07 52-56V32zM272.5 240l-.5-32h159.5l.5 32zm-64-80l-.5-32h223.5l.5 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M336 424V320H16v32c0 50.55 5.78 71.62 14.46 87.63C45.19 466.8 71.86 480 112 480h256s-32-20-32-56z"
                }
            }
        ]
    })(props);
}
function IoReceipt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.82 32.45a16.28 16.28 0 00-11.23 1.37L448 46.1l-24.8-12.4a16 16 0 00-14.31 0l-25.11 12.41L359 33.7a16 16 0 00-14.36 0L320 46.07l-24.45-12.34a16 16 0 00-14.35-.06L256 46.12l-24.8-12.43a16.05 16.05 0 00-14.33 0L192 46.1l-24.84-12.41a16 16 0 00-19.36 3.94 16.25 16.25 0 00-3.8 10.65V288l.05.05H336a32 32 0 0132 32V424c0 30.93 33.07 56 64 56h12a52 52 0 0052-52V48a16 16 0 00-12.18-15.55zM416 240H288.5c-8.64 0-16.1-6.64-16.48-15.28A16 16 0 01288 208h127.5c8.64 0 16.1 6.64 16.48 15.28A16 16 0 01416 240zm0-80H224.5c-8.64 0-16.1-6.64-16.48-15.28A16 16 0 01224 128h191.5c8.64 0 16.1 6.64 16.48 15.28A16 16 0 01416 160z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M336 424v-88a16 16 0 00-16-16H48a32.1 32.1 0 00-32 32.05c0 50.55 5.78 71.57 14.46 87.57C45.19 466.79 71.86 480 112 480h245.68a4 4 0 002.85-6.81C351.07 463.7 336 451 336 424z"
                }
            }
        ]
    })(props);
}
function IoRecordingOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "128",
                    "cy": "256",
                    "r": "96",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "384",
                    "cy": "256",
                    "r": "96",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M128 352h256"
                }
            }
        ]
    })(props);
}
function IoRecordingSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 138a117.93 117.93 0 00-91.84 192h-72.32A118 118 0 10128 374h256a118 118 0 000-236zM54 256a74 74 0 1174 74 74.09 74.09 0 01-74-74zm330 74a74 74 0 1174-74 74.09 74.09 0 01-74 74z"
                }
            }
        ]
    })(props);
}
function IoRecording(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M380.79 144.05c-59.1 1.65-107.12 49.71-108.79 108.81a111.64 111.64 0 0030.36 79.77A2 2 0 01301 336h-90a2 2 0 01-1.44-3.37A111.64 111.64 0 00240 252.86c-1.63-59.1-49.65-107.16-108.75-108.81A112.12 112.12 0 0016 255.53C15.75 317.77 67 368 129.24 368h253.52C445 368 496.25 317.77 496 255.53a112.12 112.12 0 00-115.21-111.48z"
                }
            }
        ]
    })(props);
}
function IoRefreshCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "28",
                    "d": "M288 193s12.18-6-32-6a80 80 0 1080 80"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "28",
                    "d": "M256 149l40 40-40 40"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z"
                }
            }
        ]
    })(props);
}
function IoRefreshCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.32 48 256c0 114.86 93.14 208 208 208 114.69 0 208-93.31 208-208 0-114.87-93.13-208-208-208zm94 219a94 94 0 11-94-94h4.21l-24-24L256 129.2l59.8 59.8-59.8 59.8-19.8-19.8 27.92-27.92c-2.4-.08-5.12-.08-8.12-.08a66 66 0 1066 66v-14h28z"
                }
            }
        ]
    })(props);
}
function IoRefreshCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.32 48 256c0 114.86 93.14 208 208 208 114.69 0 208-93.31 208-208 0-114.87-93.13-208-208-208zm0 313a94 94 0 010-188h4.21l-14.11-14.1a14 14 0 0119.8-19.8l40 40a14 14 0 010 19.8l-40 40a14 14 0 01-19.8-19.8l18-18c-2.38-.1-5.1-.1-8.1-.1a66 66 0 1066 66 14 14 0 0128 0 94.11 94.11 0 01-94 94z"
                }
            }
        ]
    })(props);
}
function IoRefreshOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M320 146s24.36-12-64-12a160 160 0 10160 160"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 58l80 80-80 80"
                }
            }
        ]
    })(props);
}
function IoRefreshSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M320 146s24.36-12-64-12a160 160 0 10160 160"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 58l80 80-80 80"
                }
            }
        ]
    })(props);
}
function IoRefresh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M320 146s24.36-12-64-12a160 160 0 10160 160"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 58l80 80-80 80"
                }
            }
        ]
    })(props);
}
function IoReloadCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M341.54 197.85l-11.37-13.23a103.37 103.37 0 1022.71 105.84"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M367.32 162a8.44 8.44 0 00-6 2.54l-59.54 59.54a8.61 8.61 0 006.09 14.71h59.54a8.62 8.62 0 008.62-8.62v-59.56a8.61 8.61 0 00-8.68-8.63z"
                }
            }
        ]
    })(props);
}
function IoReloadCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm120 190.77h-89l36.88-36.88-5.6-6.51a87.38 87.38 0 10-62.94 148 87.55 87.55 0 0082.42-58.25l5.37-15.13 30.17 10.67-5.3 15.13a119.4 119.4 0 11-112.62-159.18 118.34 118.34 0 0186.36 36.95l.56.62 4.31 5L376 149.81z"
                }
            }
        ]
    })(props);
}
function IoReloadCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm120 182.15a8.62 8.62 0 01-8.62 8.62h-59.54a8.61 8.61 0 01-6.09-14.71l22.17-22.17-5.6-6.51a87.38 87.38 0 10-62.94 148 87.55 87.55 0 0082.42-58.25A16 16 0 11368 295.8a119.4 119.4 0 11-112.62-159.18 118.34 118.34 0 0186.36 36.95l.56.62 4.31 5 14.68-14.68a8.44 8.44 0 016-2.54 8.61 8.61 0 018.68 8.63z"
                }
            }
        ]
    })(props);
}
function IoReloadOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M400 148l-21.12-24.57A191.43 191.43 0 00240 64C134 64 48 150 48 256s86 192 192 192a192.09 192.09 0 00181.07-128"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M464 97.42V208a16 16 0 01-16 16H337.42c-14.26 0-21.4-17.23-11.32-27.31L436.69 86.1C446.77 76 464 83.16 464 97.42z"
                }
            }
        ]
    })(props);
}
function IoReloadSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M400 148l-21.12-24.57A191.43 191.43 0 00240 64C134 64 48 150 48 256s86 192 192 192a192.09 192.09 0 00181.07-128"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M464 68.45V220a4 4 0 01-4 4H308.45a4 4 0 01-2.83-6.83L457.17 65.62a4 4 0 016.83 2.83z"
                }
            }
        ]
    })(props);
}
function IoReload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M400 148l-21.12-24.57A191.43 191.43 0 00240 64C134 64 48 150 48 256s86 192 192 192a192.09 192.09 0 00181.07-128"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M464 97.42V208a16 16 0 01-16 16H337.42c-14.26 0-21.4-17.23-11.32-27.31L436.69 86.1C446.77 76 464 83.16 464 97.42z"
                }
            }
        ]
    })(props);
}
function IoRemoveCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M336 256H176"
                }
            }
        ]
    })(props);
}
function IoRemoveCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm96 224H160v-32h192z"
                }
            }
        ]
    })(props);
}
function IoRemoveCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm80 224H176a16 16 0 010-32h160a16 16 0 010 32z"
                }
            }
        ]
    })(props);
}
function IoRemoveOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M400 256H112"
                }
            }
        ]
    })(props);
}
function IoRemoveSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M400 256H112"
                }
            }
        ]
    })(props);
}
function IoRemove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M400 256H112"
                }
            }
        ]
    })(props);
}
function IoReorderFourOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M96 304h320M96 208h320M96 112h320M96 400h320"
                }
            }
        ]
    })(props);
}
function IoReorderFourSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeLinejoin": "round",
                    "strokeWidth": "44",
                    "d": "M102 304h308m-308-96h308m-308-96h308M102 400h308"
                }
            }
        ]
    })(props);
}
function IoReorderFour(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "44",
                    "d": "M102 304h308m-308-96h308m-308-96h308M102 400h308"
                }
            }
        ]
    })(props);
}
function IoReorderThreeOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M96 256h320M96 176h320M96 336h320"
                }
            }
        ]
    })(props);
}
function IoReorderThreeSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeLinejoin": "round",
                    "strokeWidth": "44",
                    "d": "M102 256h308m-308-80h308M102 336h308"
                }
            }
        ]
    })(props);
}
function IoReorderThree(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "44",
                    "d": "M102 256h308m-308-80h308M102 336h308"
                }
            }
        ]
    })(props);
}
function IoReorderTwoOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M112 304h288m-288-96h288"
                }
            }
        ]
    })(props);
}
function IoReorderTwoSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeLinejoin": "round",
                    "strokeWidth": "44",
                    "d": "M118 304h276m-276-96h276"
                }
            }
        ]
    })(props);
}
function IoReorderTwo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "44",
                    "d": "M118 304h276m-276-96h276"
                }
            }
        ]
    })(props);
}
function IoRepeatOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 120l48 48-48 48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 168H144a80.24 80.24 0 00-80 80v16m128 128l-48-48 48-48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 344h208a80.24 80.24 0 0080-80v-16"
                }
            }
        ]
    })(props);
}
function IoRepeatSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M320 120l48 48-48 48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M352 168H64v96m128 128l-48-48 48-48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M160 344h288v-96"
                }
            }
        ]
    })(props);
}
function IoRepeat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 120l48 48-48 48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 168H144a80.24 80.24 0 00-80 80v16m128 128l-48-48 48-48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M160 344h208a80.24 80.24 0 0080-80v-16"
                }
            }
        ]
    })(props);
}
function IoResizeOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M304 96h112v112m-10.23-101.8L111.98 400.02M208 416H96V304"
                }
            }
        ]
    })(props);
}
function IoResizeSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M304 96h112v112m-10.23-101.8L111.98 400.02M208 416H96V304"
                }
            }
        ]
    })(props);
}
function IoResize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M304 96h112v112m-10.23-101.8L111.98 400.02M208 416H96V304"
                }
            }
        ]
    })(props);
}
function IoRestaurantOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M57.49 47.74l368.43 368.43a37.28 37.28 0 010 52.72h0a37.29 37.29 0 01-52.72 0l-90-91.55a32 32 0 01-9.2-22.43v-5.53a32 32 0 00-9.52-22.78l-11.62-10.73a32 32 0 00-29.8-7.44h0a48.53 48.53 0 01-46.56-12.63l-85.43-85.44C40.39 159.68 21.74 83.15 57.49 47.74z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M400 32l-77.25 77.25A64 64 0 00304 154.51v14.86a16 16 0 01-4.69 11.32L288 192m32 32l11.31-11.31a16 16 0 0111.32-4.69h14.86a64 64 0 0045.26-18.75L480 112m-40-40l-80 80M200 368l-99.72 100.28a40 40 0 01-56.56 0h0a40 40 0 010-56.56L128 328"
                }
            }
        ]
    })(props);
}
function IoRestaurantSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M342.7 223.94h14.87a79.48 79.48 0 0056.58-23.44L496 118l-22.22-22.4-83.58 83.58-17.37-17.37 83.58-83.59-23-22.31-83.27 83.26-17.32-17.37 83.58-83.59L394 16l-82.5 81.85a79.49 79.49 0 00-23.44 56.59v14.86l-43.13 43.13L48 16C3.72 70.87 29.87 171.71 79.72 221.57l85.5 85.5c26.55 26.55 31.82 28.92 61.94 16.8 6.49-2.61 8.85-2.32 14.9 3.72l13 12.13c2.93 3 3 3.88 3 9.62v5.54c0 21.08 13.48 33.2 22.36 42.24L384 496l72-72-156.43-156.93z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M227.37 354.59c-29.82 6.11-48.11 11.74-83.08-23.23-.56-.56-1.14-1.1-1.7-1.66l-19.5-19.5L16 416l80 80 144-144z"
                }
            }
        ]
    })(props);
}
function IoRestaurant(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M357.57 223.94a79.48 79.48 0 0056.58-23.44l77-76.95c6.09-6.09 6.65-16 .85-22.39a16 16 0 00-23.17-.56l-68.63 68.58a12.29 12.29 0 01-17.37 0c-4.79-4.78-4.53-12.86.25-17.64l68.33-68.33a16 16 0 00-.56-23.16A15.62 15.62 0 00440.27 56a16.71 16.71 0 00-11.81 4.9l-68.27 68.26a12.29 12.29 0 01-17.37 0c-4.78-4.78-4.53-12.86.25-17.64l68.33-68.31a16 16 0 00-.56-23.16A15.62 15.62 0 00400.26 16a16.73 16.73 0 00-11.81 4.9L311.5 97.85a79.49 79.49 0 00-23.44 56.59v8.23a16 16 0 01-4.69 11.33l-35.61 35.62a4 4 0 01-5.66 0L68.82 36.33a16 16 0 00-22.58-.06C31.09 51.28 23 72.47 23 97.54c-.1 41.4 21.66 89 56.79 124.08l85.45 85.45A64.79 64.79 0 00211 326a64 64 0 0016.21-2.08 16.24 16.24 0 014.07-.53 15.93 15.93 0 0110.83 4.25l11.39 10.52a16.12 16.12 0 014.6 11.23v5.54a47.73 47.73 0 0013.77 33.65l90.05 91.57.09.1a53.29 53.29 0 0075.36-75.37L302.39 269.9a4 4 0 010-5.66L338 228.63a16 16 0 0111.32-4.69z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M211 358a97.32 97.32 0 01-68.36-28.25l-13.86-13.86a8 8 0 00-11.3 0l-85 84.56c-15.15 15.15-20.56 37.45-13.06 59.29a30.63 30.63 0 001.49 3.6C31 484 50.58 496 72 496a55.68 55.68 0 0039.64-16.44L225 365.66a4.69 4.69 0 001.32-3.72v-.26a4.63 4.63 0 00-5.15-4.27A97.09 97.09 0 01211 358z"
                }
            }
        ]
    })(props);
}
function IoReturnDownBackOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M112 352l-64-64 64-64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M64 288h294c58.76 0 106-49.33 106-108v-20"
                }
            }
        ]
    })(props);
}
function IoReturnDownBackSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M112 352l-64-64 64-64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M64 288h400V160"
                }
            }
        ]
    })(props);
}
function IoReturnDownBack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M112 352l-64-64 64-64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M64 288h294c58.76 0 106-49.33 106-108v-20"
                }
            }
        ]
    })(props);
}
function IoReturnDownForwardOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M400 352l64-64-64-64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M448 288H154c-58.76 0-106-49.33-106-108v-20"
                }
            }
        ]
    })(props);
}
function IoReturnDownForwardSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M400 352l64-64-64-64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 288H48V160"
                }
            }
        ]
    })(props);
}
function IoReturnDownForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M400 352l64-64-64-64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M448 288H154c-58.76 0-106-49.33-106-108v-20"
                }
            }
        ]
    })(props);
}
function IoReturnUpBackOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M112 160l-64 64 64 64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M64 224h294c58.76 0 106 49.33 106 108v20"
                }
            }
        ]
    })(props);
}
function IoReturnUpBackSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M112 160l-64 64 64 64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M64 224h400v128"
                }
            }
        ]
    })(props);
}
function IoReturnUpBack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M112 160l-64 64 64 64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M64 224h294c58.76 0 106 49.33 106 108v20"
                }
            }
        ]
    })(props);
}
function IoReturnUpForwardOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M400 160l64 64-64 64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M448 224H154c-58.76 0-106 49.33-106 108v20"
                }
            }
        ]
    })(props);
}
function IoReturnUpForwardSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M400 160l64 64-64 64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 224H48v128"
                }
            }
        ]
    })(props);
}
function IoReturnUpForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M400 160l64 64-64 64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M448 224H154c-58.76 0-106 49.33-106 108v20"
                }
            }
        ]
    })(props);
}
function IoRibbonOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "160",
                    "r": "128",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M143.65 227.82L48 400l86.86-.42a16 16 0 0113.82 7.8L192 480l88.33-194.32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M366.54 224L464 400l-86.86-.42a16 16 0 00-13.82 7.8L320 480l-64-140.8"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "160",
                    "r": "64",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function IoRibbonSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 336c-5.22 0-10.4-.24-15.51-.69a176.12 176.12 0 01-131.29-78.37L20 416h115l58 96 82.53-177.09A177.53 177.53 0 01256 336zm147-79.26a176.9 176.9 0 01-88.18 69.14L273.7 415.5 319 512l58-96h115z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256.02",
                    "cy": "160",
                    "r": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 16c-79.4 0-144 64.6-144 144s64.6 144 144 144 144-64.6 144-144S335.4 16 256 16zm0 224a80 80 0 1180-80 80.09 80.09 0 01-80 80z"
                }
            }
        ]
    })(props);
}
function IoRibbon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M269 335.61q-6.33.47-12.78.47c-5.23 0-10.4-.24-15.51-.69a176.11 176.11 0 01-127.67-72.94 4 4 0 00-6.77.35l-72 129.4c-2.74 5-3.17 11-.28 15.88A16.78 16.78 0 0048.22 416h78a15.28 15.28 0 0113.62 7.33L178.5 488a16.26 16.26 0 0013.75 8c5.94-.33 12.09-4.19 14.56-9.6l66.11-145.15a4 4 0 00-3.92-5.64zm208.64 56.27l-71.53-129.17a4 4 0 00-6.74-.36 176.5 176.5 0 01-78.31 61.42 16.09 16.09 0 00-8.72 8.25l-36.86 81.1a7.92 7.92 0 000 6.6l30.27 66.59c2.45 5.41 8.59 9.36 14.52 9.69a16.3 16.3 0 0013.7-8.12l38.53-64.58c2.89-4.85 8.13-7.33 13.78-7.3h78.77c6.67 0 11.72-3.48 14-10a16.92 16.92 0 00-1.41-14.12z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "256.26",
                    "cy": "160",
                    "rx": "48.01",
                    "ry": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256.26 16c-79.42 0-144 64.59-144 144s64.61 144 144 144 144-64.6 144-144-64.59-144-144-144zm0 224a80 80 0 1180-80 80.1 80.1 0 01-80 80z"
                }
            }
        ]
    })(props);
}
function IoRocketOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M461.81 53.81a4.4 4.4 0 00-3.3-3.39c-54.38-13.3-180 34.09-248.13 102.17a294.9 294.9 0 00-33.09 39.08c-21-1.9-42-.3-59.88 7.5-50.49 22.2-65.18 80.18-69.28 105.07a9 9 0 009.8 10.4l81.07-8.9a180.29 180.29 0 001.1 18.3 18.15 18.15 0 005.3 11.09l31.39 31.39a18.15 18.15 0 0011.1 5.3 179.91 179.91 0 0018.19 1.1l-8.89 81a9 9 0 0010.39 9.79c24.9-4 83-18.69 105.07-69.17 7.8-17.9 9.4-38.79 7.6-59.69a293.91 293.91 0 0039.19-33.09c68.38-68 115.47-190.86 102.37-247.95zM298.66 213.67a42.7 42.7 0 1160.38 0 42.65 42.65 0 01-60.38 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M109.64 352a45.06 45.06 0 00-26.35 12.84C65.67 382.52 64 448 64 448s65.52-1.67 83.15-19.31A44.73 44.73 0 00160 402.32"
                }
            }
        ]
    })(props);
}
function IoRocketSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M477.64 38.26a4.75 4.75 0 00-3.55-3.66c-58.57-14.32-193.9 36.71-267.22 110a317 317 0 00-35.63 42.1c-22.61-2-45.22-.33-64.49 8.07C52.38 218.7 36.55 281.14 32.14 308a9.64 9.64 0 0010.55 11.2l87.31-9.63a194.1 194.1 0 001.19 19.7 19.53 19.53 0 005.7 12L170.7 375a19.59 19.59 0 0012 5.7 193.53 193.53 0 0019.59 1.19l-9.58 87.2a9.65 9.65 0 0011.2 10.55c26.81-4.3 89.36-20.13 113.15-74.5 8.4-19.27 10.12-41.77 8.18-64.27a317.66 317.66 0 0042.21-35.64C441 232.05 491.74 99.74 477.64 38.26zM294.07 217.93a48 48 0 1167.86 0 47.95 47.95 0 01-67.86 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M168.4 399.43c-5.48 5.49-14.27 7.63-24.85 9.46-23.77 4.05-44.76-16.49-40.49-40.52 1.63-9.11 6.45-21.88 9.45-24.88a4.37 4.37 0 00-3.65-7.45 60 60 0 00-35.13 17.12C50.22 376.69 48 464 48 464s87.36-2.22 110.87-25.75A59.69 59.69 0 00176 403.09c.37-4.18-4.72-6.67-7.6-3.66z"
                }
            }
        ]
    })(props);
}
function IoRocket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M328.85 156.79a26.69 26.69 0 1018.88 7.81 26.6 26.6 0 00-18.88-7.81z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M477.44 50.06a.29.29 0 010-.09 20.4 20.4 0 00-15.13-15.3c-29.8-7.27-76.68.48-128.63 21.28-52.36 21-101.42 52-134.58 85.22A320.7 320.7 0 00169.55 175c-22.33-1-42 2.18-58.57 9.41-57.74 25.41-74.23 90.44-78.62 117.14a25 25 0 0027.19 29h.13l64.32-7.02c.08.82.17 1.57.24 2.26a34.36 34.36 0 009.9 20.72l31.39 31.41a34.27 34.27 0 0020.71 9.91l2.15.23-7 64.24v.13A25 25 0 00206 480a25.25 25.25 0 004.15-.34C237 475.34 302 459.05 327.34 401c7.17-16.46 10.34-36.05 9.45-58.34a314.78 314.78 0 0033.95-29.55c33.43-33.26 64.53-81.92 85.31-133.52 20.69-51.36 28.48-98.59 21.39-129.53zM370.38 224.94a58.77 58.77 0 110-83.07 58.3 58.3 0 010 83.07z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M161.93 386.44a16 16 0 00-11 2.67c-6.39 4.37-12.81 8.69-19.29 12.9-13.11 8.52-28.79-6.44-21-20l12.15-21a16 16 0 00-15.16-24.91A61.25 61.25 0 0072 353.56c-3.66 3.67-14.79 14.81-20.78 57.26A357.94 357.94 0 0048 447.59 16 16 0 0064 464h.4a359.87 359.87 0 0036.8-3.2c42.47-6 53.61-17.14 57.27-20.8a60.49 60.49 0 0017.39-35.74 16 16 0 00-13.93-17.82z"
                }
            }
        ]
    })(props);
}
function IoRoseOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M416 128c-18.9 4.25-36.8 8.94-53.7 13.95-40.5 12-75.5 27.15-105.4 41.65-19.3 9.37-26.2 13.51-51.5 28.23-58.4 33.69-93.4 77.4-93.4 142.81C112 428.55 167.6 480 256 480s144-55.81 144-129.72S339 225.24 416 128z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M264 180.19c-19.69-27-38.2-38.69-52.7-46.59C162.6 107.1 96 96 96 96c41.5 43.7 37.2 90.1 32 128 0 0-3.87 32.88 1.91 58.41"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M372 139.15C356.55 102.6 336 64 336 64s-63.32 0-135.69 64m53.17-40.43C221.25 45.81 176 32 176 32c-15.3 20.8-28.79 51.58-34.87 74.17"
                }
            }
        ]
    })(props);
}
function IoRoseSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 112s-17.62 0-30.51 1.39c-19 2-42.06 8-59.73 13.22-35.06 10.39-69.33 23.92-107.85 42.59-18.62 9.05-26 13.35-48 26.13l-4.5 2.67c-32.95 19-57.09 40-73.79 64.3C105.29 288.89 96 320 96 354.64c0 40.74 15.71 77.1 44.24 102.37C169 482.52 209.06 496 256 496c46.76 0 86.89-14.32 116-41.43 28.35-26.35 44-63.39 44-104.29 0-25-6.19-47-12.17-68.22-12.59-44.69-23.46-83.29 24.71-144.13C432.75 132.62 448 112 448 112zm-229 7.55C168.47 92.08 104.72 80 80 80c0 0 23.23 28.19 29.15 55.4s6.54 48.61 2.91 88.6c17.94-20.48 40.59-37.15 69.32-53.73l4.48-2.6C208 154.8 216.23 150 236 140.41c2.88-1.4 5.74-2.76 8.58-4.11A170.77 170.77 0 00219 119.55zM345.25 48s-42.53.36-86.12 21.3a280.36 280.36 0 00-32.27 18.27q3.73 1.89 7.4 3.88c3.44 1.87 7.09 4 10.9 6.29a189.7 189.7 0 0131.46 24.16c24.57-10.41 73-26.1 90.77-31.28-8-19.15-22.14-42.62-22.14-42.62zM176 16c-16 10.83-33.24 41.1-33.24 41.1a494.22 494.22 0 0148.92 15.25l17.65-11.56c8.18-5.35 16.55-10.29 25-14.77C234.31 46 202.59 24.17 176 16z"
                }
            }
        ]
    })(props);
}
function IoRose(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M429.55 119.49a16 16 0 00-17.06-7.1c-18.64 4.19-37.06 9-54.73 14.22-35.06 10.39-69.33 23.92-107.85 42.59-18.62 9.05-26 13.35-48 26.13l-4.5 2.67c-32.95 19-57.09 40-73.79 64.29C105.29 288.89 96 320 96 354.64c0 40.74 15.71 77.1 44.24 102.37C169 482.52 209.06 496 256 496c46.76 0 86.89-14.33 116-41.43 28.35-26.35 44-63.39 44-104.29 0-25-6.19-47-12.17-68.22-12.59-44.69-23.46-83.29 24.71-144.13a16 16 0 001.01-18.44zm-210.55.06C168.46 92.08 101.46 80.69 98.63 80.22A16 16 0 0081 90.55a16.47 16.47 0 003.79 16.84c31.84 33.78 32.86 68.79 28.65 104.63a4.45 4.45 0 002.5 4.54 4.44 4.44 0 005.08-.9c16.39-16.51 36.37-31.52 60.4-45.39l4.48-2.6C208 154.8 216.23 150 236 140.41l2.69-1.3a4 4 0 00.64-6.83A178.59 178.59 0 00219 119.55zm15.26-28.1c3.44 1.87 7.09 4 10.9 6.29a189.31 189.31 0 0129.57 22.39 4 4 0 004.28.76 672 672 0 0169.65-25q7-2.07 14.08-4a4 4 0 002.53-5.62c-8.27-16.83-14.67-28.9-15.15-29.79A16 16 0 00336 48c-1.91 0-33.28.36-76.87 21.3a279 279 0 00-26.39 14.51 4 4 0 00.22 6.94zm-24.93-30.66c7.3-4.77 14.74-9.22 22.25-13.31a2 2 0 00.24-3.36c-26-19.57-49.73-27-51.15-27.42a16 16 0 00-17.56 5.82 217.63 217.63 0 00-19.28 32.38 2 2 0 001.29 2.81c13.61 3.57 29.4 8.29 45.61 14.29a2 2 0 001.79-.2z"
                }
            }
        ]
    })(props);
}
function IoSadOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "184",
                    "cy": "232",
                    "r": "24"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 288c45.42 0 83.62 29.53 95.71 69.83a8 8 0 01-7.87 10.17H168.15a8 8 0 01-7.82-10.17C172.32 317.53 210.53 288 256 288z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "328",
                    "cy": "232",
                    "r": "24"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "208",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function IoSadSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM328 208a24 24 0 11-24 24 23.94 23.94 0 0124-24zm-144 0a24 24 0 11-24 24 23.94 23.94 0 0124-24zm72 80c45.42 0 83.75 29.49 95.72 69.83 1 3.52 2.33 10.17 2.33 10.17H158s1.31-6.69 2.33-10.17C172.11 317.47 210.53 288 256 288z"
                }
            }
        ]
    })(props);
}
function IoSad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.39 97.61A224 224 0 1097.61 414.39 224 224 0 10414.39 97.61zM184 208a24 24 0 11-24 24 23.94 23.94 0 0124-24zm-23.67 149.83c12-40.3 50.2-69.83 95.62-69.83s83.62 29.53 95.71 69.83a8 8 0 01-7.82 10.17H168.15a8 8 0 01-7.82-10.17zM328 256a24 24 0 1124-24 23.94 23.94 0 01-24 24z"
                }
            }
        ]
    })(props);
}
function IoSaveOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M380.93 57.37A32 32 0 00358.3 48H94.22A46.21 46.21 0 0048 94.22v323.56A46.21 46.21 0 0094.22 464h323.56A46.36 46.36 0 00464 417.78V153.7a32 32 0 00-9.37-22.63zM256 416a64 64 0 1164-64 63.92 63.92 0 01-64 64zm48-224H112a16 16 0 01-16-16v-64a16 16 0 0116-16h192a16 16 0 0116 16v64a16 16 0 01-16 16z"
                }
            }
        ]
    })(props);
}
function IoSaveSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M380.44 32H64a32 32 0 00-32 32v384a32 32 0 0032 32h384a32.09 32.09 0 0032-32V131.56zM112 176v-64h192v64zm223.91 179.76a80 80 0 11-83.66-83.67 80.21 80.21 0 0183.66 83.67z"
                }
            }
        ]
    })(props);
}
function IoSave(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M465.94 119.76l-73.7-73.7A47.68 47.68 0 00358.3 32H96a64 64 0 00-64 64v320a64 64 0 0064 64h320a64 64 0 0064-64V153.7a47.68 47.68 0 00-14.06-33.94zM120 112h176a8 8 0 018 8v48a8 8 0 01-8 8H120a8 8 0 01-8-8v-48a8 8 0 018-8zm139.75 319.91a80 80 0 1176.16-76.16 80.06 80.06 0 01-76.16 76.16z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "352",
                    "r": "48"
                }
            }
        ]
    })(props);
}
function IoScaleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "416",
                    "height": "416",
                    "x": "48",
                    "y": "48",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "96"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M388.94 151.56c-24.46-22.28-68.72-51.4-132.94-51.4s-108.48 29.12-132.94 51.4a34.66 34.66 0 00-3.06 48.08l33.32 39.21a26.07 26.07 0 0033.6 5.21c15.92-9.83 40.91-21.64 69.1-21.64s53.18 11.81 69.1 21.64a26.07 26.07 0 0033.6-5.21L392 199.64a34.66 34.66 0 00-3.06-48.08z"
                }
            }
        ]
    })(props);
}
function IoScaleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 32H80a48.05 48.05 0 00-48 48v352a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V80a48.05 48.05 0 00-48-48zm-16.71 165l-52.46 61.73a27.83 27.83 0 01-37.65 4.62c-13-9.29-39.27-24.89-69.18-24.89s-56.18 15.6-69.18 24.89a27.84 27.84 0 01-37.65-4.62L96.71 197a32.12 32.12 0 01.42-42c18.93-21.31 72.3-70.87 158.87-70.87S395.94 133.72 414.87 155a32.12 32.12 0 01.42 42z"
                }
            }
        ]
    })(props);
}
function IoScale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 32H144A112.12 112.12 0 0032 144v224a112.12 112.12 0 00112 112h224a112.12 112.12 0 00112-112V144A112.12 112.12 0 00368 32zm36.21 178l-33.32 39.21A41.76 41.76 0 01339 264.05a42.32 42.32 0 01-22.29-6.38c-14.22-8.78-36.3-19.25-60.69-19.25s-46.47 10.47-60.69 19.25a41.86 41.86 0 01-54.2-8.46L107.79 210a50.48 50.48 0 014.49-70.27c27.84-25.35 75.37-55.57 143.72-55.57s115.88 30.22 143.72 55.57a50.48 50.48 0 014.49 70.27z"
                }
            }
        ]
    })(props);
}
function IoScanCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M296 352h28a28 28 0 0028-28v-28m0-80v-28a28 28 0 00-28-28h-28m-80 192h-28a28 28 0 01-28-28v-28m0-80v-28a28 28 0 0128-28h28"
                }
            }
        ]
    })(props);
}
function IoScanCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-24 320h-44a44.05 44.05 0 01-44-44v-44h32v44a12 12 0 0012 12h44zm0-192h-44a12 12 0 00-12 12v44h-32v-44a44.05 44.05 0 0144-44h44zm136 148a44.05 44.05 0 01-44 44h-44v-32h44a12 12 0 0012-12v-44h32zm0-92h-32v-44a12 12 0 00-12-12h-44v-32h44a44.05 44.05 0 0144 44z"
                }
            }
        ]
    })(props);
}
function IoScanCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-40 320h-28a44.05 44.05 0 01-44-44v-28a16 16 0 0132 0v28a12 12 0 0012 12h28a16 16 0 010 32zm0-192h-28a12 12 0 00-12 12v28a16 16 0 01-32 0v-28a44.05 44.05 0 0144-44h28a16 16 0 010 32zm152 148a44.05 44.05 0 01-44 44h-28a16 16 0 010-32h28a12 12 0 0012-12v-28a16 16 0 0132 0zm0-108a16 16 0 01-32 0v-28a12 12 0 00-12-12h-28a16 16 0 010-32h28a44.05 44.05 0 0144 44z"
                }
            }
        ]
    })(props);
}
function IoScanOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M336 448h56a56 56 0 0056-56v-56m0-160v-56a56 56 0 00-56-56h-56M176 448h-56a56 56 0 01-56-56v-56m0-160v-56a56 56 0 0156-56h56"
                }
            }
        ]
    })(props);
}
function IoScanSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M388 466h-68v-44h68a34 34 0 0034-34v-68h44v68a78.09 78.09 0 01-78 78zm78-274h-44v-68a34 34 0 00-34-34h-68V46h68a78.09 78.09 0 0178 78zM192 466h-68a78.09 78.09 0 01-78-78v-68h44v68a34 34 0 0034 34h68zM90 192H46v-68a78.09 78.09 0 0178-78h68v44h-68a34 34 0 00-34 34z"
                }
            }
        ]
    })(props);
}
function IoScan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "44",
                    "d": "M342 444h46a56 56 0 0056-56v-46m0-172v-46a56 56 0 00-56-56h-46M170 444h-46a56 56 0 01-56-56v-46m0-172v-46a56 56 0 0156-56h46"
                }
            }
        ]
    })(props);
}
function IoSchoolOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M32 192L256 64l224 128-224 128L32 192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M112 240v128l144 80 144-80V240m80 128V192M256 320v128"
                }
            }
        ]
    })(props);
}
function IoSchoolSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 370.43L96 279v98.42l160 88.88 160-88.88V279l-160 91.43z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512.25 192L256 45.57-.25 192 256 338.43l208-118.86V384h48V192.14l.25-.14z"
                }
            }
        ]
    })(props);
}
function IoSchool(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 368a16 16 0 01-7.94-2.11L108 285.84a8 8 0 00-12 6.94V368a16 16 0 008.23 14l144 80a16 16 0 0015.54 0l144-80a16 16 0 008.23-14v-75.22a8 8 0 00-12-6.94l-140.06 80.05A16 16 0 01256 368z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M495.92 190.5v-.11a16 16 0 00-8-12.28l-224-128a16 16 0 00-15.88 0l-224 128a16 16 0 000 27.78l224 128a16 16 0 0015.88 0L461 221.28a2 2 0 013 1.74v144.53c0 8.61 6.62 16 15.23 16.43A16 16 0 00496 368V192a14.76 14.76 0 00-.08-1.5z"
                }
            }
        ]
    })(props);
}
function IoSearchCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 80a176 176 0 10176 176A176 176 0 00256 80z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M232 160a72 72 0 1072 72 72 72 0 00-72-72z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M283.64 283.64L336 336"
                }
            }
        ]
    })(props);
}
function IoSearchCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 64C150.13 64 64 150.13 64 256s86.13 192 192 192 192-86.13 192-192S361.87 64 256 64zm80 294.63l-54.15-54.15a88.08 88.08 0 1122.63-22.63L358.63 336z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "232",
                    "cy": "232",
                    "r": "56"
                }
            }
        ]
    })(props);
}
function IoSearchCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 64C150.13 64 64 150.13 64 256s86.13 192 192 192 192-86.13 192-192S361.87 64 256 64zm91.31 283.31a16 16 0 01-22.62 0l-42.84-42.83a88.08 88.08 0 1122.63-22.63l42.83 42.84a16 16 0 010 22.62z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "232",
                    "cy": "232",
                    "r": "56"
                }
            }
        ]
    })(props);
}
function IoSearchOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M221.09 64a157.09 157.09 0 10157.09 157.09A157.1 157.1 0 00221.09 64z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M338.29 338.29L448 448"
                }
            }
        ]
    })(props);
}
function IoSearchSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 428L339.92 303.9a160.48 160.48 0 0030.72-94.58C370.64 120.37 298.27 48 209.32 48S48 120.37 48 209.32s72.37 161.32 161.32 161.32a160.48 160.48 0 0094.58-30.72L428 464zM209.32 319.69a110.38 110.38 0 11110.37-110.37 110.5 110.5 0 01-110.37 110.37z"
                }
            }
        ]
    })(props);
}
function IoSearch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M456.69 421.39L362.6 327.3a173.81 173.81 0 0034.84-104.58C397.44 126.38 319.06 48 222.72 48S48 126.38 48 222.72s78.38 174.72 174.72 174.72A173.81 173.81 0 00327.3 362.6l94.09 94.09a25 25 0 0035.3-35.3zM97.92 222.72a124.8 124.8 0 11124.8 124.8 124.95 124.95 0 01-124.8-124.8z"
                }
            }
        ]
    })(props);
}
function IoSendOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M470.3 271.15L43.16 447.31a7.83 7.83 0 01-11.16-7V327a8 8 0 016.51-7.86l247.62-47c17.36-3.29 17.36-28.15 0-31.44l-247.63-47a8 8 0 01-6.5-7.85V72.59c0-5.74 5.88-10.26 11.16-8L470.3 241.76a16 16 0 010 29.39z"
                }
            }
        ]
    })(props);
}
function IoSendSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 464l480-208L16 48v160l320 48-320 48z"
                }
            }
        ]
    })(props);
}
function IoSend(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476.59 227.05l-.16-.07L49.35 49.84A23.56 23.56 0 0027.14 52 24.65 24.65 0 0016 72.59v113.29a24 24 0 0019.52 23.57l232.93 43.07a4 4 0 010 7.86L35.53 303.45A24 24 0 0016 327v113.31A23.57 23.57 0 0026.59 460a23.94 23.94 0 0013.22 4 24.55 24.55 0 009.52-1.93L476.4 285.94l.19-.09a32 32 0 000-58.8z"
                }
            }
        ]
    })(props);
}
function IoServerOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "256",
                    "cy": "128",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "192",
                    "ry": "80"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 214c0 44.18-86 80-192 80S64 258.18 64 214m384 86c0 44.18-86 80-192 80S64 344.18 64 300"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M64 127.24v257.52C64 428.52 150 464 256 464s192-35.48 192-79.24V127.24"
                }
            }
        ]
    })(props);
}
function IoServerSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M409.43 389.87C362 410 305.4 421.05 256 421.05s-105.87-11.3-153.44-31.18S48 353.16 48 353.16v38.2c0 31.15 18 43.64 67.32 64.35C153.13 471.59 203.18 480 256 480s102.87-8.41 140.68-24.29C446 435 464 422.51 464 391.36v-38.2s-7.14 16.59-54.57 36.71zM63.69 173.22c11.23 9.84 27.82 19.49 48 27.92 42.48 17.76 96.45 28.37 144.36 28.37s101.88-10.61 144.36-28.37c20.13-8.43 36.72-18.08 47.95-27.92 6.06-5.31 10.85-10.12 13.47-12.85a8 8 0 002.22-5.54v-26.16c-.84-28.79-24.71-54.41-67.21-72.14C358.83 40.71 308.84 32 256 32s-102.83 8.71-140.74 24.53C72.85 74.22 49 99.78 48.05 128.5v26.33a8 8 0 002.21 5.54c2.58 2.73 7.36 7.54 13.43 12.85z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M409.43 221.91C365 241 305.4 253.09 256 253.09s-108.87-12.27-153.43-31.18S48 185.2 48 185.2v47.36c.08 7.52 5.5 16.2 15.69 25.13 11.24 9.84 27.82 19.5 48 27.92C154.12 303.38 208.09 314 256 314s101.88-10.6 144.36-28.37c20.13-8.42 36.72-18.08 47.95-27.92 10.25-9 15.68-17.71 15.69-25.27V185.2s-10.13 17.62-54.57 36.71z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M409.43 306.38C362 326 305.4 337.56 256 337.56s-109.87-12.8-153.43-31.18S48 269.67 48 269.67v46.25c0 7.55 5.44 16.28 15.69 25.26 11.23 9.84 27.81 19.5 48 27.92 42.48 17.77 96.44 28.37 144.36 28.37s101.88-10.6 144.36-28.37c20.13-8.43 36.72-18.08 47.95-27.92 10.19-8.93 15.61-17.61 15.69-25.13v-46.38s-7.18 17.09-54.62 36.71z"
                }
            }
        ]
    })(props);
}
function IoServer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 428c-52.35 0-111.39-11.61-157.93-31-17.07-7.19-31.69-18.82-43.64-28a4 4 0 00-6.43 3.18v12.58c0 28.07 23.49 53.22 66.14 70.82C152.29 471.33 202.67 480 256 480s103.7-8.67 141.86-24.42C440.51 438 464 412.83 464 384.76v-12.58a4 4 0 00-6.43-3.18c-11.95 9.17-26.57 20.81-43.65 28-46.54 19.39-105.57 31-157.92 31zm208-301.49c-.81-27.65-24.18-52.4-66-69.85C359.74 40.76 309.34 32 256 32s-103.74 8.76-141.91 24.66c-41.78 17.41-65.15 42.11-66 69.69L48 144c0 6.41 5.2 16.48 14.63 24.73 11.13 9.73 27.65 19.33 47.78 27.73C153.24 214.36 207.67 225 256 225s102.76-10.68 145.59-28.58c20.13-8.4 36.65-18 47.78-27.73C458.8 160.49 464 150.42 464 144z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M413.92 226c-46.53 19.43-105.57 31-157.92 31s-111.39-11.57-157.93-31c-17.07-7.15-31.69-18.79-43.64-28a4 4 0 00-6.43 3.22V232c0 6.41 5.2 14.48 14.63 22.73 11.13 9.74 27.65 19.33 47.78 27.74C153.24 300.34 207.67 311 256 311s102.76-10.68 145.59-28.57c20.13-8.41 36.65-18 47.78-27.74C458.8 246.47 464 238.41 464 232v-30.78a4 4 0 00-6.43-3.18c-11.95 9.17-26.57 20.81-43.65 27.96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M413.92 312c-46.54 19.41-105.57 31-157.92 31s-111.39-11.59-157.93-31c-17.07-7.17-31.69-18.81-43.64-28a4 4 0 00-6.43 3.2V317c0 6.41 5.2 14.47 14.62 22.71 11.13 9.74 27.66 19.33 47.79 27.74C153.24 385.32 207.66 396 256 396s102.76-10.68 145.59-28.57c20.13-8.41 36.65-18 47.78-27.74C458.8 331.44 464 323.37 464 317v-29.8a4 4 0 00-6.43-3.18c-11.95 9.17-26.57 20.81-43.65 27.98z"
                }
            }
        ]
    })(props);
}
function IoSettingsOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M262.29 192.31a64 64 0 1057.4 57.4 64.13 64.13 0 00-57.4-57.4zM416.39 256a154.34 154.34 0 01-1.53 20.79l45.21 35.46a10.81 10.81 0 012.45 13.75l-42.77 74a10.81 10.81 0 01-13.14 4.59l-44.9-18.08a16.11 16.11 0 00-15.17 1.75A164.48 164.48 0 01325 400.8a15.94 15.94 0 00-8.82 12.14l-6.73 47.89a11.08 11.08 0 01-10.68 9.17h-85.54a11.11 11.11 0 01-10.69-8.87l-6.72-47.82a16.07 16.07 0 00-9-12.22 155.3 155.3 0 01-21.46-12.57 16 16 0 00-15.11-1.71l-44.89 18.07a10.81 10.81 0 01-13.14-4.58l-42.77-74a10.8 10.8 0 012.45-13.75l38.21-30a16.05 16.05 0 006-14.08c-.36-4.17-.58-8.33-.58-12.5s.21-8.27.58-12.35a16 16 0 00-6.07-13.94l-38.19-30A10.81 10.81 0 0149.48 186l42.77-74a10.81 10.81 0 0113.14-4.59l44.9 18.08a16.11 16.11 0 0015.17-1.75A164.48 164.48 0 01187 111.2a15.94 15.94 0 008.82-12.14l6.73-47.89A11.08 11.08 0 01213.23 42h85.54a11.11 11.11 0 0110.69 8.87l6.72 47.82a16.07 16.07 0 009 12.22 155.3 155.3 0 0121.46 12.57 16 16 0 0015.11 1.71l44.89-18.07a10.81 10.81 0 0113.14 4.58l42.77 74a10.8 10.8 0 01-2.45 13.75l-38.21 30a16.05 16.05 0 00-6.05 14.08c.33 4.14.55 8.3.55 12.47z"
                }
            }
        ]
    })(props);
}
function IoSettingsSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 176a80 80 0 1080 80 80.24 80.24 0 00-80-80zm172.72 80a165.53 165.53 0 01-1.64 22.34l48.69 38.12a11.59 11.59 0 012.63 14.78l-46.06 79.52a11.64 11.64 0 01-14.14 4.93l-57.25-23a176.56 176.56 0 01-38.82 22.67l-8.56 60.78a11.93 11.93 0 01-11.51 9.86h-92.12a12 12 0 01-11.51-9.53l-8.56-60.78A169.3 169.3 0 01151.05 393L93.8 416a11.64 11.64 0 01-14.14-4.92L33.6 331.57a11.59 11.59 0 012.63-14.78l48.69-38.12A174.58 174.58 0 0183.28 256a165.53 165.53 0 011.64-22.34l-48.69-38.12a11.59 11.59 0 01-2.63-14.78l46.06-79.52a11.64 11.64 0 0114.14-4.93l57.25 23a176.56 176.56 0 0138.82-22.67l8.56-60.78A11.93 11.93 0 01209.94 26h92.12a12 12 0 0111.51 9.53l8.56 60.78A169.3 169.3 0 01361 119l57.2-23a11.64 11.64 0 0114.14 4.92l46.06 79.52a11.59 11.59 0 01-2.63 14.78l-48.69 38.12a174.58 174.58 0 011.64 22.66z"
                }
            }
        ]
    })(props);
}
function IoSettings(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M470.39 300l-.47-.38-31.56-24.75a16.11 16.11 0 01-6.1-13.33v-11.56a16 16 0 016.11-13.22L469.92 212l.47-.38a26.68 26.68 0 005.9-34.06l-42.71-73.9a1.59 1.59 0 01-.13-.22A26.86 26.86 0 00401 92.14l-.35.13-37.1 14.93a15.94 15.94 0 01-14.47-1.29q-4.92-3.1-10-5.86a15.94 15.94 0 01-8.19-11.82l-5.59-39.59-.12-.72A27.22 27.22 0 00298.76 26h-85.52a26.92 26.92 0 00-26.45 22.39l-.09.56-5.57 39.67a16 16 0 01-8.13 11.82 175.21 175.21 0 00-10 5.82 15.92 15.92 0 01-14.43 1.27l-37.13-15-.35-.14a26.87 26.87 0 00-32.48 11.34l-.13.22-42.77 73.95a26.71 26.71 0 005.9 34.1l.47.38 31.56 24.75a16.11 16.11 0 016.1 13.33v11.56a16 16 0 01-6.11 13.22L42.08 300l-.47.38a26.68 26.68 0 00-5.9 34.06l42.71 73.9a1.59 1.59 0 01.13.22 26.86 26.86 0 0032.45 11.3l.35-.13 37.07-14.93a15.94 15.94 0 0114.47 1.29q4.92 3.11 10 5.86a15.94 15.94 0 018.19 11.82l5.56 39.59.12.72A27.22 27.22 0 00213.24 486h85.52a26.92 26.92 0 0026.45-22.39l.09-.56 5.57-39.67a16 16 0 018.18-11.82c3.42-1.84 6.76-3.79 10-5.82a15.92 15.92 0 0114.43-1.27l37.13 14.95.35.14a26.85 26.85 0 0032.48-11.34 2.53 2.53 0 01.13-.22l42.71-73.89a26.7 26.7 0 00-5.89-34.11zm-134.48-40.24a80 80 0 11-83.66-83.67 80.21 80.21 0 0183.66 83.67z"
                }
            }
        ]
    })(props);
}
function IoShapesOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M336 320H32L184 48l152 272zm-70.68-125.49A144 144 0 11192 320"
                }
            }
        ]
    })(props);
}
function IoShapesSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M363.27 336H4.73L184 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M336 160a160.54 160.54 0 00-32.55 3.36l87.75 157L417.81 368H183.36C203.8 432.85 264.49 480 336 480c88.22 0 160-71.78 160-160s-71.78-160-160-160z"
                }
            }
        ]
    })(props);
}
function IoShapes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 336H32a16 16 0 01-14-23.81l152-272a16 16 0 0127.94 0l152 272A16 16 0 01336 336z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M336 160a161.07 161.07 0 00-32.57 3.32l74.47 133.27A48 48 0 01336 368H183.33A160 160 0 10336 160z"
                }
            }
        ]
    })(props);
}
function IoShareOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M336 192h40a40 40 0 0140 40v192a40 40 0 01-40 40H136a40 40 0 01-40-40V232a40 40 0 0140-40h40m160-64l-80-80-80 80m80 193V48"
                }
            }
        ]
    })(props);
}
function IoShareSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 176v161h-32V176H92a12 12 0 00-12 12v280a12 12 0 0012 12h328a12 12 0 0012-12V188a12 12 0 00-12-12zm0-83.37l64 64L358.63 134 256 31.37 153.37 134 176 156.63l64-64V176h32V92.63z"
                }
            }
        ]
    })(props);
}
function IoShareSocialOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "128",
                    "cy": "256",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "384",
                    "cy": "112",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "384",
                    "cy": "400",
                    "r": "48",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M169.83 279.53l172.34 96.94m0-240.94l-172.34 96.94"
                }
            }
        ]
    })(props);
}
function IoShareSocialSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M378 324a69.78 69.78 0 00-48.83 19.91L202 272.41a69.68 69.68 0 000-32.82l127.13-71.5A69.76 69.76 0 10308.87 129l-130.13 73.2a70 70 0 100 107.56L308.87 383A70 70 0 10378 324z"
                }
            }
        ]
    })(props);
}
function IoShareSocial(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 336a63.78 63.78 0 00-46.12 19.7l-148-83.27a63.85 63.85 0 000-32.86l148-83.27a63.8 63.8 0 10-15.73-27.87l-148 83.27a64 64 0 100 88.6l148 83.27A64 64 0 10384 336z"
                }
            }
        ]
    })(props);
}
function IoShare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M376 176H272v145a16 16 0 01-32 0V176H136a56.06 56.06 0 00-56 56v192a56.06 56.06 0 0056 56h240a56.06 56.06 0 0056-56V232a56.06 56.06 0 00-56-56zM272 86.63l52.69 52.68a16 16 0 0022.62-22.62l-80-80a16 16 0 00-22.62 0l-80 80a16 16 0 0022.62 22.62L240 86.63V176h32z"
                }
            }
        ]
    })(props);
}
function IoShieldCheckmarkOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M336 176L225.2 304 176 255.8"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M463.1 112.37C373.68 96.33 336.71 84.45 256 48c-80.71 36.45-117.68 48.33-207.1 64.37C32.7 369.13 240.58 457.79 256 464c15.42-6.21 223.3-94.87 207.1-351.63z"
                }
            }
        ]
    })(props);
}
function IoShieldCheckmarkSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M479.07 111.36l-.79-12.53-12.36-2.21c-86.5-15.52-122.61-26.74-203.33-63.2l-6.59-3-6.59 3C168.69 69.88 132.58 81.1 46.08 96.62l-12.36 2.21-.79 12.53c-3.85 61.11 4.36 118.05 24.43 169.24A349.47 349.47 0 00129 393.11c53.47 56.73 110.24 81.37 121.07 85.73l6 2.41 6-2.41c10.83-4.36 67.6-29 121.07-85.73a349.47 349.47 0 0071.5-112.51c20.07-51.19 28.28-108.13 24.43-169.24zm-252.91 216L153.37 256l22.4-22.86 48.47 47.49 110.13-127.2 24.2 20.94z"
                }
            }
        ]
    })(props);
}
function IoShieldCheckmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M479.07 111.36a16 16 0 00-13.15-14.74c-86.5-15.52-122.61-26.74-203.33-63.2a16 16 0 00-13.18 0C168.69 69.88 132.58 81.1 46.08 96.62a16 16 0 00-13.15 14.74c-3.85 61.11 4.36 118.05 24.43 169.24A349.47 349.47 0 00129 393.11c53.47 56.73 110.24 81.37 121.07 85.73a16 16 0 0012 0c10.83-4.36 67.6-29 121.07-85.73a349.47 349.47 0 0071.5-112.51c20.07-51.19 28.28-108.13 24.43-169.24zm-131 75.11l-110.8 128a16 16 0 01-11.41 5.53h-.66a16 16 0 01-11.2-4.57l-49.2-48.2a16 16 0 1122.4-22.86l37 36.29 99.7-115.13a16 16 0 0124.2 20.94z"
                }
            }
        ]
    })(props);
}
function IoShieldHalfOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M463.1 112.37C373.68 96.33 336.71 84.45 256 48c-80.71 36.45-117.68 48.33-207.1 64.37C32.7 369.13 240.58 457.79 256 464c15.42-6.21 223.3-94.87 207.1-351.63z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48c-80.71 36.45-117.68 48.33-207.1 64.37C32.7 369.13 240.58 457.79 256 464z"
                }
            }
        ]
    })(props);
}
function IoShieldHalfSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C174 69.06 121.38 86.46 32 96c0 77.59 5.27 133.36 25.29 184.51a348.86 348.86 0 0071.43 112.41c49.6 52.66 104.17 80.4 127.28 87.08 23.11-6.68 77.68-34.42 127.28-87.08a348.86 348.86 0 0071.43-112.41C474.73 229.36 480 173.59 480 96c-89.38-9.54-142-26.94-224-64zm161.47 233.93a309.18 309.18 0 01-63.31 99.56C316 406 276.65 428.31 256 437.36V75.8c38.75 17 68.73 28.3 97.93 36.89a613.12 613.12 0 0085.6 18.52c-1.72 60.22-8.36 99.69-22.06 134.72z"
                }
            }
        ]
    })(props);
}
function IoShieldHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48.9 112.37C138.32 96.33 175.29 84.45 256 48c80.71 36.45 117.68 48.33 207.1 64.37C479.3 369.13 271.42 457.79 256 464c-15.42-6.21-223.3-94.87-207.1-351.63z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48c80.71 36.45 117.68 48.33 207.1 64.37C479.3 369.13 271.42 457.79 256 464z"
                }
            }
        ]
    })(props);
}
function IoShieldOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M463.1 112.37C373.68 96.33 336.71 84.45 256 48c-80.71 36.45-117.68 48.33-207.1 64.37C32.7 369.13 240.58 457.79 256 464c15.42-6.21 223.3-94.87 207.1-351.63z"
                }
            }
        ]
    })(props);
}
function IoShieldSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C174 69.06 121.38 86.46 32 96c0 77.59 5.27 133.36 25.29 184.51a348.86 348.86 0 0071.43 112.41c49.6 52.66 104.17 80.4 127.28 87.08 23.11-6.68 77.68-34.42 127.28-87.08a348.86 348.86 0 0071.43-112.41C474.73 229.36 480 173.59 480 96c-89.38-9.54-142-26.94-224-64z"
                }
            }
        ]
    })(props);
}
function IoShield(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M479.07 111.35a16 16 0 00-13.15-14.75C379.89 81.18 343.69 69.12 266 34.16c-7.76-2.89-12.57-2.84-20 0-77.69 35-113.89 47-199.92 62.44a16 16 0 00-13.15 14.75c-3.85 61.1 4.34 118 24.36 169.15a348.86 348.86 0 0071.43 112.41c44.67 47.43 94.2 75.12 119.74 85.6a20 20 0 0015.11 0c27-10.92 74.69-37.82 119.71-85.62a348.86 348.86 0 0071.43-112.39c20.02-51.14 28.21-108.05 24.36-169.15z"
                }
            }
        ]
    })(props);
}
function IoShirtOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M314.56 48s-22.78 8-58.56 8-58.56-8-58.56-8a31.94 31.94 0 00-10.57 1.8L32 104l16.63 88 48.88 5.52a24 24 0 0121.29 24.58L112 464h288l-6.8-241.9a24 24 0 0121.29-24.58l48.88-5.52L480 104 325.13 49.8a31.94 31.94 0 00-10.57-1.8zm18.75 4.66a80 80 0 01-154.62 0"
                }
            }
        ]
    })(props);
}
function IoShirtSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 42c-33.88 0-64-10-64-10v2a64 64 0 00128 0v-2s-30.12 10-64 10z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M352 44c-5.49 47.76-46.79 85-96 85s-90.51-37.24-96-85L16 94l18 114 61.71 7.42c7.08.9 7.1.9 7.1 8.19L96 480h320l-6.81-256.39c-.21-7-.21-7 7.1-8.19L478 208l18-114z"
                }
            }
        ]
    })(props);
}
function IoShirt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 96c33.08 0 60.71-25.78 64-58 .3-3-3-6-6-6a13 13 0 00-4.74.9c-.2.08-21.1 8.1-53.26 8.1s-53.1-8-53.26-8.1a16.21 16.21 0 00-5.3-.9h-.06a5.69 5.69 0 00-5.38 6c3.35 32.16 31 58 64 58z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M485.29 89.9L356 44.64a4 4 0 00-5.27 3.16 96 96 0 01-189.38 0 4 4 0 00-5.35-3.16L26.71 89.9A16 16 0 0016.28 108l16.63 88a16 16 0 0013.92 12.9l48.88 5.52a8 8 0 017.1 8.19l-7.33 240.9a16 16 0 009.1 14.94A17.49 17.49 0 00112 480h288a17.49 17.49 0 007.42-1.55 16 16 0 009.1-14.94l-7.33-240.9a8 8 0 017.1-8.19l48.88-5.52a16 16 0 0013.92-12.9l16.63-88a16 16 0 00-10.43-18.1z"
                }
            }
        ]
    })(props);
}
function IoShuffleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M400 304l48 48-48 48m0-288l48 48-48 48M64 352h85.19a80 80 0 0066.56-35.62L256 256"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M64 160h85.19a80 80 0 0166.56 35.62l80.5 120.76A80 80 0 00362.81 352H416m0-192h-53.19a80 80 0 00-66.56 35.62L288 208"
                }
            }
        ]
    })(props);
}
function IoShuffleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M400 304l48 48-48 48m0-288l48 48-48 48M64 352h128l60-92"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M64 160h128l128 192h96m0-192h-96l-32 48"
                }
            }
        ]
    })(props);
}
function IoShuffle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M400 304l48 48-48 48m0-288l48 48-48 48M64 352h85.19a80 80 0 0066.56-35.62L256 256"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M64 160h85.19a80 80 0 0166.56 35.62l80.5 120.76A80 80 0 00362.81 352H416m0-192h-53.19a80 80 0 00-66.56 35.62L288 208"
                }
            }
        ]
    })(props);
}
function IoSkullOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 225.64v99a64 64 0 01-40.23 59.42l-23.68 9.47A32 32 0 00364.6 417l-10 50.14A16 16 0 01338.88 480H173.12a16 16 0 01-15.69-12.86L147.4 417a32 32 0 00-19.49-23.44l-23.68-9.47A64 64 0 0164 324.67V224c0-105.92 85.77-191.81 191.65-192S448 119.85 448 225.64z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "168",
                    "cy": "280",
                    "r": "40",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "344",
                    "cy": "280",
                    "r": "40",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 336l-16 48h32l-16-48zm0 112v32m-48-32v32m96-32v32"
                }
            }
        ]
    })(props);
}
function IoSkullSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 16C141.31 16 48 109.31 48 224v154.83l82 32.81L146.88 496H192v-64h32v64h16v-64h32v64h16v-64h32v64h45.12L382 411.64l82-32.81V224c0-114.69-93.31-208-208-208zm-88 320a56 56 0 1156-56 56.06 56.06 0 01-56 56zm51.51 64L244 320h24l24.49 80zM344 336a56 56 0 1156-56 56.06 56.06 0 01-56 56zm104 32z"
                }
            }
        ]
    })(props);
}
function IoSkull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M402 76.94C362.61 37.63 310.78 16 256 16h-.37A208 208 0 0048 224v100.67A79.62 79.62 0 0098.29 399l23.71 9.42a15.92 15.92 0 019.75 11.72l10 50.13A32.09 32.09 0 00173.12 496H184a8 8 0 008-8v-39.55c0-8.61 6.62-16 15.23-16.43A16 16 0 01224 448v40a8 8 0 008 8 8 8 0 008-8v-39.55c0-8.61 6.62-16 15.23-16.43A16 16 0 01272 448v40a8 8 0 008 8 8 8 0 008-8v-39.55c0-8.61 6.62-16 15.23-16.43A16 16 0 01320 448v40a8 8 0 008 8h10.88a32.09 32.09 0 0031.38-25.72l10-50.14a16 16 0 019.74-11.72l23.71-9.42A79.62 79.62 0 00464 324.67v-99c0-56-22-108.81-62-148.73zM171.66 335.88a56 56 0 1152.22-52.22 56 56 0 01-52.22 52.22zM281 397.25a16.37 16.37 0 01-9.3 2.75h-31.4a16.37 16.37 0 01-9.28-2.75 16 16 0 01-6.6-16.9l15.91-47.6C243 326 247.25 321 254 320.13c8.26-1 14 2.87 17.61 12.22l16 48a16 16 0 01-6.61 16.9zm66.68-61.37a56 56 0 1152.22-52.22 56 56 0 01-52.24 52.22z"
                }
            }
        ]
    })(props);
}
function IoSnowOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 32v448m57.72-400A111.47 111.47 0 01256 96a111.47 111.47 0 01-57.72-16m0 352a112.11 112.11 0 01115.44 0m136.27-288L62.01 368m375.26-150a112.09 112.09 0 01-57.71-100M74.73 294a112.09 112.09 0 0157.71 100M62.01 144l387.98 224M74.73 218a112.09 112.09 0 0057.71-100m304.83 176a112.09 112.09 0 00-57.71 100"
                }
            }
        ]
    })(props);
}
function IoSnowSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M447.88 313.27l19.25-10.64-21.28-38.51-19.25 10.64a133.42 133.42 0 00-38.54 32.1L300 256l88.07-50.86a133.42 133.42 0 0038.54 32.1l19.25 10.64 21.28-38.51-19.25-10.64a89.27 89.27 0 01-20.93-16L480 152.05 458 114l-53 30.58a89.07 89.07 0 01-3.42-26.15l.41-22-44-.82-.41 22a133.62 133.62 0 008.49 49.39L278 217.89V116.18a133.52 133.52 0 0047.06-17.33L343.9 87.5l-22.71-37.69-18.84 11.35A89.5 89.5 0 01278 71.27V16h-44v55.27a89.5 89.5 0 01-24.35-10.11l-18.84-11.35L168.1 87.5l18.84 11.35A133.52 133.52 0 00234 116.18v101.71L145.93 167a133.62 133.62 0 008.53-49.43l-.41-22-44 .82.41 22a89.07 89.07 0 01-3.42 26.15L54 114l-22 38.1 53.05 30.64a89.27 89.27 0 01-20.93 16l-19.25 10.63 21.28 38.51 19.25-10.64a133.42 133.42 0 0038.54-32.1L212 256l-88.07 50.86a133.42 133.42 0 00-38.54-32.1l-19.24-10.64-21.28 38.51 19.25 10.64a89.27 89.27 0 0120.93 16L32 360l22 38.1 53.05-30.63a89.07 89.07 0 013.42 26.15l-.41 22 44 .82.41-22a133.62 133.62 0 00-8.54-49.44L234 294.11v101.71a133.52 133.52 0 00-47.06 17.33L168.1 424.5l22.71 37.69 18.84-11.35A89.5 89.5 0 01234 440.73V496h44v-55.27a89.5 89.5 0 0124.35 10.11l18.84 11.35 22.71-37.69-18.84-11.35A133.52 133.52 0 00278 395.82V294.11L366.07 345a133.62 133.62 0 00-8.53 49.43l.41 22 44-.82-.41-22a89.07 89.07 0 013.46-26.19l53 30.63L480 360l-53-30.69a89.27 89.27 0 0120.88-16.04z"
                }
            }
        ]
    })(props);
}
function IoSnow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M461 349l-34-19.64a89.53 89.53 0 0120.94-16 22 22 0 00-21.28-38.51 133.62 133.62 0 00-38.55 32.1L300 256l88.09-50.86a133.46 133.46 0 0038.55 32.1 22 22 0 1021.28-38.51 89.74 89.74 0 01-20.94-16l34-19.64A22 22 0 10439 125l-34 19.63a89.74 89.74 0 01-3.42-26.15A22 22 0 00380 96h-.41a22 22 0 00-22 21.59 133.61 133.61 0 008.5 49.41L278 217.89V116.18a133.5 133.5 0 0047.07-17.33 22 22 0 00-22.71-37.69A89.56 89.56 0 01278 71.27V38a22 22 0 00-44 0v33.27a89.56 89.56 0 01-24.36-10.11 22 22 0 10-22.71 37.69A133.5 133.5 0 00234 116.18v101.71L145.91 167a133.61 133.61 0 008.52-49.43 22 22 0 00-22-21.59H132a22 22 0 00-21.59 22.41 89.74 89.74 0 01-3.41 26.19L73 125a22 22 0 10-22 38.1l34 19.64a89.74 89.74 0 01-20.94 16 22 22 0 1021.28 38.51 133.62 133.62 0 0038.55-32.1L212 256l-88.09 50.86a133.62 133.62 0 00-38.55-32.1 22 22 0 10-21.28 38.51 89.74 89.74 0 0120.94 16L51 349a22 22 0 1022 38.1l34-19.63a89.74 89.74 0 013.42 26.15A22 22 0 00132 416h.41a22 22 0 0022-21.59 133.61 133.61 0 00-8.5-49.41L234 294.11v101.71a133.5 133.5 0 00-47.07 17.33 22 22 0 1022.71 37.69A89.56 89.56 0 01234 440.73V474a22 22 0 0044 0v-33.27a89.56 89.56 0 0124.36 10.11 22 22 0 0022.71-37.69A133.5 133.5 0 00278 395.82V294.11L366.09 345a133.61 133.61 0 00-8.52 49.43 22 22 0 0022 21.59h.43a22 22 0 0021.59-22.41 89.74 89.74 0 013.41-26.19l34 19.63A22 22 0 10461 349z"
                }
            }
        ]
    })(props);
}
function IoSparklesOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M259.92 262.91L216.4 149.77a9 9 0 00-16.8 0l-43.52 113.14a9 9 0 01-5.17 5.17L37.77 311.6a9 9 0 000 16.8l113.14 43.52a9 9 0 015.17 5.17l43.52 113.14a9 9 0 0016.8 0l43.52-113.14a9 9 0 015.17-5.17l113.14-43.52a9 9 0 000-16.8l-113.14-43.52a9 9 0 01-5.17-5.17zM108 68L88 16 68 68 16 88l52 20 20 52 20-52 52-20-52-20zm318.67 49.33L400 48l-26.67 69.33L304 144l69.33 26.67L400 240l26.67-69.33L496 144l-69.33-26.67z"
                }
            }
        ]
    })(props);
}
function IoSparklesSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 512l-52.38-139.62L16 320l139.62-52.38L208 128l52.38 139.62L400 320l-139.62 52.38zM88 176l-23.57-64.43L0 88l64.43-23.57L88 0l23.57 64.43L176 88l-64.43 23.57zm312 80l-31.11-80.89L288 144l80.89-31.11L400 32l31.11 80.89L512 144l-80.89 31.11z"
                }
            }
        ]
    })(props);
}
function IoSparkles(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 512a24.84 24.84 0 01-23.34-16l-39.84-103.6a16.06 16.06 0 00-9.19-9.19L32 343.34a25 25 0 010-46.68l103.6-39.84a16.06 16.06 0 009.19-9.19L184.66 144a25 25 0 0146.68 0l39.84 103.6a16.06 16.06 0 009.19 9.19l103 39.63a25.49 25.49 0 0116.63 24.1 24.82 24.82 0 01-16 22.82l-103.6 39.84a16.06 16.06 0 00-9.19 9.19L231.34 496A24.84 24.84 0 01208 512zm66.85-254.84zM88 176a14.67 14.67 0 01-13.69-9.4l-16.86-43.84a7.28 7.28 0 00-4.21-4.21L9.4 101.69a14.67 14.67 0 010-27.38l43.84-16.86a7.31 7.31 0 004.21-4.21L74.16 9.79A15 15 0 0186.23.11a14.67 14.67 0 0115.46 9.29l16.86 43.84a7.31 7.31 0 004.21 4.21l43.84 16.86a14.67 14.67 0 010 27.38l-43.84 16.86a7.28 7.28 0 00-4.21 4.21l-16.86 43.84A14.67 14.67 0 0188 176zm312 80a16 16 0 01-14.93-10.26l-22.84-59.37a8 8 0 00-4.6-4.6l-59.37-22.84a16 16 0 010-29.86l59.37-22.84a8 8 0 004.6-4.6l22.67-58.95a16.45 16.45 0 0113.17-10.57 16 16 0 0116.86 10.15l22.84 59.37a8 8 0 004.6 4.6l59.37 22.84a16 16 0 010 29.86l-59.37 22.84a8 8 0 00-4.6 4.6l-22.84 59.37A16 16 0 01400 256z"
                }
            }
        ]
    })(props);
}
function IoSpeedometerOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M326.1 231.9l-47.5 75.5a31 31 0 01-7 7 30.11 30.11 0 01-35-49l75.5-47.5a10.23 10.23 0 0111.7 0 10.06 10.06 0 012.3 14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 64C132.3 64 32 164.2 32 287.9a223.18 223.18 0 0056.3 148.5c1.1 1.2 2.1 2.4 3.2 3.5a25.19 25.19 0 0037.1-.1 173.13 173.13 0 01254.8 0 25.19 25.19 0 0037.1.1l3.2-3.5A223.18 223.18 0 00480 287.9C480 164.2 379.7 64 256 64z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 128v32m160 128h-32m-256 0H96m69.49-90.51l-22.63-22.63m203.65 22.63l22.63-22.63"
                }
            }
        ]
    })(props);
}
function IoSpeedometerSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C123.46 48 16 156.55 16 290.56a243.3 243.3 0 0060.32 160.87c1.18 1.3 2.25 2.6 3.43 3.79C89.2 464 92.07 464 99.57 464s12.43 0 19.93-8.88C152 416.64 202 400 256 400s104.07 16.71 136.5 55.12C400 464 404.82 464 412.43 464s11.3 0 19.82-8.78c1.22-1.25 2.25-2.49 3.43-3.79A243.3 243.3 0 00496 290.56C496 156.55 388.54 48 256 48zm-16 64h32v64h-32zm-96 192H80v-32h64zm21.49-83.88l-45.25-45.26 22.62-22.62 45.26 45.25zM278.6 307.4a31 31 0 01-7 7 30.11 30.11 0 01-35-49L320 224zm45.28-109.91l45.26-45.25 22.62 22.62-45.25 45.26zM432 304h-64v-32h64z"
                }
            }
        ]
    })(props);
}
function IoSpeedometer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M425.7 118.25A240 240 0 0076.32 447l.18.2c.33.35.64.71 1 1.05.74.84 1.58 1.79 2.57 2.78a41.17 41.17 0 0060.36-.42 157.13 157.13 0 01231.26 0 41.18 41.18 0 0060.65.06l3.21-3.5.18-.2a239.93 239.93 0 00-10-328.76zM240 128a16 16 0 0132 0v32a16 16 0 01-32 0zM128 304H96a16 16 0 010-32h32a16 16 0 010 32zm48.8-95.2a16 16 0 01-22.62 0l-22.63-22.62a16 16 0 0122.63-22.63l22.62 22.63a16 16 0 010 22.62zm149.3 23.1l-47.5 75.5a31 31 0 01-7 7 30.11 30.11 0 01-35-49l75.5-47.5a10.23 10.23 0 0111.7 0 10.06 10.06 0 012.3 14zm31.72-23.1a16 16 0 01-22.62-22.62l22.62-22.63a16 16 0 0122.63 22.63zm65.88 227.6zM416 304h-32a16 16 0 010-32h32a16 16 0 010 32z"
                }
            }
        ]
    })(props);
}
function IoSquareOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M416 448H96a32.09 32.09 0 01-32-32V96a32.09 32.09 0 0132-32h320a32.09 32.09 0 0132 32v320a32.09 32.09 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function IoSquareSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 48h416v416H48z"
                }
            }
        ]
    })(props);
}
function IoSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 464H96a48.05 48.05 0 01-48-48V96a48.05 48.05 0 0148-48h320a48.05 48.05 0 0148 48v320a48.05 48.05 0 01-48 48z"
                }
            }
        ]
    })(props);
}
function IoStarHalfOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M480 208H308L256 48l-52 160H32l140 96-54 160 138-100 138 100-54-160z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48v316L118 464l54-160-140-96h172l52-160z"
                }
            }
        ]
    })(props);
}
function IoStarHalfSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 203.3H312.36L256 32l-56.36 171.3H16l150.21 105.4-58.5 171.3L256 373.84 404.29 480l-58.61-171.3zM274.63 347.82L256 334.49v-200.1l26 78.91 7.24 22h105.39l-67.32 47.2-19.69 13.81 7.78 22.75 26.26 76.75z"
                }
            }
        ]
    })(props);
}
function IoStarHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M480 208H308L256 48l-52 160H32l140 96-54 160 138-100 138 100-54-160z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48v316L118 464l54-160-140-96h172l52-160z"
                }
            }
        ]
    })(props);
}
function IoStarOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M480 208H308L256 48l-52 160H32l140 96-54 160 138-100 138 100-54-160z"
                }
            }
        ]
    })(props);
}
function IoStarSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 203.3H312.36L256 32l-56.36 171.3H16l150.21 105.4-58.5 171.3L256 373.84 404.29 480l-58.61-171.3z"
                }
            }
        ]
    })(props);
}
function IoStar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M394 480a16 16 0 01-9.39-3L256 383.76 127.39 477a16 16 0 01-24.55-18.08L153 310.35 23 221.2a16 16 0 019-29.2h160.38l48.4-148.95a16 16 0 0130.44 0l48.4 149H480a16 16 0 019.05 29.2L359 310.35l50.13 148.53A16 16 0 01394 480z"
                }
            }
        ]
    })(props);
}
function IoStatsChartOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "48",
                    "height": "160",
                    "x": "64",
                    "y": "320",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "48",
                    "height": "256",
                    "x": "288",
                    "y": "224",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "48",
                    "height": "368",
                    "x": "400",
                    "y": "112",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "48",
                    "height": "448",
                    "x": "176",
                    "y": "32",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "8",
                    "ry": "8"
                }
            }
        ]
    })(props);
}
function IoStatsChartSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 496H48V304h80zm224 0h-80V208h80zm112 0h-80V96h80zm-224 0h-80V16h80z"
                }
            }
        ]
    })(props);
}
function IoStatsChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104 496H72a24 24 0 01-24-24V328a24 24 0 0124-24h32a24 24 0 0124 24v144a24 24 0 01-24 24zm224 0h-32a24 24 0 01-24-24V232a24 24 0 0124-24h32a24 24 0 0124 24v240a24 24 0 01-24 24zm112 0h-32a24 24 0 01-24-24V120a24 24 0 0124-24h32a24 24 0 0124 24v352a24 24 0 01-24 24zm-224 0h-32a24 24 0 01-24-24V40a24 24 0 0124-24h32a24 24 0 0124 24v432a24 24 0 01-24 24z"
                }
            }
        ]
    })(props);
}
function IoStopCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M310.4 336H201.6a25.62 25.62 0 01-25.6-25.6V201.6a25.62 25.62 0 0125.6-25.6h108.8a25.62 25.62 0 0125.6 25.6v108.8a25.62 25.62 0 01-25.6 25.6z"
                }
            }
        ]
    })(props);
}
function IoStopCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm80 288H176V176h160z"
                }
            }
        ]
    })(props);
}
function IoStopCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm80 262.4a25.62 25.62 0 01-25.6 25.6H201.6a25.62 25.62 0 01-25.6-25.6V201.6a25.62 25.62 0 0125.6-25.6h108.8a25.62 25.62 0 0125.6 25.6z"
                }
            }
        ]
    })(props);
}
function IoStopOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "320",
                    "height": "320",
                    "x": "96",
                    "y": "96",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "24",
                    "ry": "24"
                }
            }
        ]
    })(props);
}
function IoStopSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 80h352v352H80z"
                }
            }
        ]
    })(props);
}
function IoStop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392 432H120a40 40 0 01-40-40V120a40 40 0 0140-40h272a40 40 0 0140 40v272a40 40 0 01-40 40z"
                }
            }
        ]
    })(props);
}
function IoStopwatchOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 232v-80"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M256 88V72m-124 60l-12-12"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "272",
                    "r": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 96a176 176 0 10176 176A176 176 0 00256 96z"
                }
            }
        ]
    })(props);
}
function IoStopwatchSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M280 81.5V48h-48v33.5a191 191 0 00-84.43 32.13L120 86l-34 34 25.59 25.59A191.17 191.17 0 0064 272c0 105.87 86.13 192 192 192s192-86.13 192-192c0-97.74-73.42-178.66-168-190.5zM256 320a48 48 0 01-16-93.25V136h32v90.75A48 48 0 01256 320z"
                }
            }
        ]
    })(props);
}
function IoStopwatch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "272",
                    "r": "16"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M280 81.5V72a24 24 0 00-48 0v9.5a191 191 0 00-84.43 32.13L137 103a24 24 0 00-34 34l8.6 8.6A191.17 191.17 0 0064 272c0 105.87 86.13 192 192 192s192-86.13 192-192c0-97.74-73.42-178.66-168-190.5zM256 320a48 48 0 01-16-93.25V152a16 16 0 0132 0v74.75A48 48 0 01256 320z"
                }
            }
        ]
    })(props);
}
function IoStorefrontOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M448 448V240m-384 0v208M382.47 48H129.53c-21.79 0-41.47 12-49.93 30.46L36.3 173c-14.58 31.81 9.63 67.85 47.19 69h2c31.4 0 56.85-25.18 56.85-52.23 0 27 25.46 52.23 56.86 52.23s56.8-23.38 56.8-52.23c0 27 25.45 52.23 56.85 52.23s56.86-23.38 56.86-52.23c0 28.85 25.45 52.23 56.85 52.23h1.95c37.56-1.17 61.77-37.21 47.19-69l-43.3-94.54C423.94 60 404.26 48 382.47 48zM32 464h448M136 288h80a24 24 0 0124 24v88h0-128 0v-88a24 24 0 0124-24zm152 176V312a24 24 0 0124-24h64a24 24 0 0124 24v152"
                }
            }
        ]
    })(props);
}
function IoStorefrontSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 448V267.85a104.76 104.76 0 01-33.56 6.58c-1.18 0-2.3.05-3.4.05a108 108 0 01-56.86-16 108 108 0 01-56.85 16 106.16 106.16 0 01-56.51-16.2 107.84 107.84 0 01-57.2 16.2 106.14 106.14 0 01-56.85-16.42 106.14 106.14 0 01-56.85 16.42c-1.09 0-2.19 0-3.37-.05h-.06A104.66 104.66 0 0148 267.49V448H16v32h480v-32zm-240-64h-96v-76a4 4 0 014-4h88a4 4 0 014 4zm160 64h-80V308a4 4 0 014-4h72a4 4 0 014 4zm108.57-277.72L445.89 64C432 32 432 32 400 32H112c-32 0-32 0-45.94 32L19.38 170.28c-9 19.41 2.89 39.34 2.9 39.35l.41.66c.42.66 1.13 1.75 1.62 2.37.1.13.19.27.28.4l5.24 6.39 5.31 5.14.42.36a69.65 69.65 0 009.44 6.78v.05a74 74 0 0036 10.67h2.47a76.08 76.08 0 0051.89-20.31 72.38 72.38 0 005.77-6 74.18 74.18 0 005.78 6 76.08 76.08 0 0051.89 20.31c23.28 0 44.07-10 57.63-25.56a.11.11 0 01.15 0l5.66 5.26a76.09 76.09 0 0051.9 20.31c23.29 0 44.11-10 57.66-25.61 13.56 15.61 34.37 25.61 57.67 25.61h2.49a71.35 71.35 0 0035-10.7c.95-.57 1.86-1.17 2.78-1.77A71.33 71.33 0 00488 212.17l2-3c.9-2.04 11.21-20.3 2.57-38.89z"
                }
            }
        ]
    })(props);
}
function IoStorefront(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 448h-12a4 4 0 01-4-4V273.51a4 4 0 00-5.24-3.86 104.92 104.92 0 01-28.32 4.78c-1.18 0-2.3.05-3.4.05a108.22 108.22 0 01-52.85-13.64 8.23 8.23 0 00-8 0 108.18 108.18 0 01-52.84 13.64 106.11 106.11 0 01-52.46-13.79 8.21 8.21 0 00-8.09 0 108.14 108.14 0 01-53.16 13.8 106.19 106.19 0 01-52.77-14 8.25 8.25 0 00-8.16 0 106.19 106.19 0 01-52.77 14c-1.09 0-2.19 0-3.37-.05h-.06a104.91 104.91 0 01-29.28-5.09 4 4 0 00-5.23 3.8V444a4 4 0 01-4 4H32.5c-8.64 0-16.1 6.64-16.48 15.28A16 16 0 0032 480h447.5c8.64 0 16.1-6.64 16.48-15.28A16 16 0 00480 448zm-256-68a4 4 0 01-4 4h-88a4 4 0 01-4-4v-64a12 12 0 0112-12h72a12 12 0 0112 12zm156 68h-72a4 4 0 01-4-4V316a12 12 0 0112-12h56a12 12 0 0112 12v128a4 4 0 01-4 4zm112.57-277.72l-42.92-98.49C438.41 47.62 412.74 32 384.25 32H127.7c-28.49 0-54.16 15.62-65.4 39.79l-42.92 98.49c-9 19.41 2.89 39.34 2.9 39.35l.28.45c.49.78 1.36 2 1.89 2.78.05.06.09.13.14.2l5 6.05a7.45 7.45 0 00.6.65l5 4.83.42.36a69.65 69.65 0 009.39 6.78v.05a74 74 0 0036 10.67h2.47a76.08 76.08 0 0051.89-20.31l.33-.31a7.94 7.94 0 0110.89 0l.33.31a77.3 77.3 0 00104.46 0 8 8 0 0110.87 0 77.31 77.31 0 00104.21.23 7.88 7.88 0 0110.71 0 76.81 76.81 0 0052.31 20.08h2.49a71.35 71.35 0 0035-10.7c.95-.57 1.86-1.17 2.78-1.77A71.33 71.33 0 00488 212.17l1.74-2.63q.26-.4.48-.84c1.66-3.38 10.56-20.76 2.35-38.42z"
                }
            }
        ]
    })(props);
}
function IoSubwayOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "288",
                    "height": "352",
                    "x": "112",
                    "y": "32",
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M208 80h96"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "288",
                    "height": "96",
                    "x": "112",
                    "y": "128",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "32",
                    "ry": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "176",
                    "cy": "320",
                    "r": "16",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "336",
                    "cy": "320",
                    "r": "16",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M144 464h224m-32-32l48 48m-208-48l-48 48"
                }
            }
        ]
    })(props);
}
function IoSubwaySharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392 16H120a24 24 0 00-24 24v336a24 24 0 0024 24h272a24 24 0 0024-24V40a24 24 0 00-24-24zM208 64h95.55c8.61 0 16 6.62 16.43 15.23A16 16 0 01304 96h-95.55c-8.61 0-16-6.62-16.43-15.23A16 16 0 01208 64zm-28.53 287.82a32 32 0 1128.35-28.35 32 32 0 01-28.35 28.35zm160 0a32 32 0 1128.35-28.35 32 32 0 01-28.35 28.35zM384 144v64H128v-64zm-86 272l31.37 32H182.63L214 416h-44l-80.57 80h45.2l16-16h210.74l16 16h45.3L343 416h-45z"
                }
            }
        ]
    })(props);
}
function IoSubway(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 16H160a64.07 64.07 0 00-64 64v256a64.07 64.07 0 0064 64h192a64.07 64.07 0 0064-64V80a64.07 64.07 0 00-64-64zM208 64h96a16 16 0 010 32h-96a16 16 0 010-32zm-32 288a32 32 0 1132-32 32 32 0 01-32 32zm160 0a32 32 0 1132-32 32 32 0 01-32 32zm48-160a16 16 0 01-16 16H144a16 16 0 01-16-16v-32a16 16 0 0116-16h224a16 16 0 0116 16zm-36.69 228.69a16 16 0 00-22.62 22.62l4.68 4.69H182.63l4.68-4.69a16 16 0 00-22.62-22.62l-48 48a16 16 0 1022.62 22.62L150.63 480h210.74l11.32 11.31a16 16 0 0022.62-22.62z"
                }
            }
        ]
    })(props);
}
function IoSunnyOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 48v48m0 320v48m147.08-355.08l-33.94 33.94M142.86 369.14l-33.94 33.94M464 256h-48m-320 0H48m355.08 147.08l-33.94-33.94M142.86 142.86l-33.94-33.94"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "80",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function IoSunnySharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M234 26h44v92h-44zm0 368h44v92h-44zm104.025-251.143l65.054-65.054 31.113 31.113-65.054 65.054zM77.815 403.074l65.054-65.054 31.113 31.113-65.054 65.054zM394 234h92v44h-92zm-368 0h92v44H26zm312.029 135.14l31.112-31.113 65.054 65.054-31.112 31.112zM77.802 108.92l31.113-31.113 65.054 65.054-31.113 31.112zM256 358a102 102 0 11102-102 102.12 102.12 0 01-102 102z"
                }
            }
        ]
    })(props);
}
function IoSunny(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 118a22 22 0 01-22-22V48a22 22 0 0144 0v48a22 22 0 01-22 22zm0 368a22 22 0 01-22-22v-48a22 22 0 0144 0v48a22 22 0 01-22 22zm113.14-321.14a22 22 0 01-15.56-37.55l33.94-33.94a22 22 0 0131.11 31.11l-33.94 33.94a21.93 21.93 0 01-15.55 6.44zM108.92 425.08a22 22 0 01-15.55-37.56l33.94-33.94a22 22 0 1131.11 31.11l-33.94 33.94a21.94 21.94 0 01-15.56 6.45zM464 278h-48a22 22 0 010-44h48a22 22 0 010 44zm-368 0H48a22 22 0 010-44h48a22 22 0 010 44zm307.08 147.08a21.94 21.94 0 01-15.56-6.45l-33.94-33.94a22 22 0 0131.11-31.11l33.94 33.94a22 22 0 01-15.55 37.56zM142.86 164.86a21.89 21.89 0 01-15.55-6.44l-33.94-33.94a22 22 0 0131.11-31.11l33.94 33.94a22 22 0 01-15.56 37.55zM256 358a102 102 0 11102-102 102.12 102.12 0 01-102 102z"
                }
            }
        ]
    })(props);
}
function IoSwapHorizontalOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M304 48l112 112-112 112m94.87-112H96m112 304L96 352l112-112m-94 112h302"
                }
            }
        ]
    })(props);
}
function IoSwapHorizontalSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M304 48l112 112-112 112m94.87-112H96m112 304L96 352l112-112m-94 112h302"
                }
            }
        ]
    })(props);
}
function IoSwapHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M304 48l112 112-112 112m94.87-112H96m112 304L96 352l112-112m-94 112h302"
                }
            }
        ]
    })(props);
}
function IoSwapVerticalOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M464 208L352 96 240 208m112-94.87V416M48 304l112 112 112-112m-112 94V96"
                }
            }
        ]
    })(props);
}
function IoSwapVerticalSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M464 208L352 96 240 208m112-94.87V416M48 304l112 112 112-112m-112 94V96"
                }
            }
        ]
    })(props);
}
function IoSwapVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M464 208L352 96 240 208m112-94.87V416M48 304l112 112 112-112m-112 94V96"
                }
            }
        ]
    })(props);
}
function IoSyncCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M351.82 271.87v-16A96.15 96.15 0 00184.09 192m-24.2 48.17v16A96.22 96.22 0 00327.81 320"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M135.87 256l23.59-23.6 24.67 23.6m192 0l-23.59 23.6-24.67-23.6"
                }
            }
        ]
    })(props);
}
function IoSyncCircleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm0 320a112.19 112.19 0 01-111.27-98.23l-8.86 8.86L113.24 256l46-46 47.55 45.48-22.12 23.12-7.2-6.88a80.26 80.26 0 00138.48 37.5l23.77 21.41A112.82 112.82 0 01256 368zm96.79-66l-47.55-45.5 22.12-23.12 6.86 6.55A80.2 80.2 0 00196 202.64l-23.82-21.37A112.18 112.18 0 01367 242.49l9.11-9.12L398.76 256z"
                }
            }
        ]
    })(props);
}
function IoSyncCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm83.69 282.65a112.24 112.24 0 01-195-61.29 16 16 0 01-20.13-24.67l23.6-23.6a16 16 0 0122.37-.25l24.67 23.6a16 16 0 01-18 26 80.25 80.25 0 00138.72 38.83 16 16 0 0123.77 21.41zm47.76-63.34l-23.6 23.6a16 16 0 01-22.37.25l-24.67-23.6a16 16 0 0117.68-26.11A80.17 80.17 0 00196 202.64a16 16 0 11-23.82-21.37 112.17 112.17 0 01194.88 61.57 16 16 0 0120.39 24.47z"
                }
            }
        ]
    })(props);
}
function IoSyncOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M434.67 285.59v-29.8c0-98.73-80.24-178.79-179.2-178.79a179 179 0 00-140.14 67.36m-38.53 82v29.8C76.8 355 157 435 256 435a180.45 180.45 0 00140-66.92"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M32 256l44-44 46 44m358 0l-44 44-46-44"
                }
            }
        ]
    })(props);
}
function IoSyncSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M434.67 285.59v-29.8c0-98.73-80.24-178.79-179.2-178.79a179 179 0 00-140.14 67.36m-38.53 82v29.8C76.8 355 157 435 256 435a180.45 180.45 0 00140-66.92"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M32 256l44-44 46 44m358 0l-44 44-46-44"
                }
            }
        ]
    })(props);
}
function IoSync(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M434.67 285.59v-29.8c0-98.73-80.24-178.79-179.2-178.79a179 179 0 00-140.14 67.36m-38.53 82v29.8C76.8 355 157 435 256 435a180.45 180.45 0 00140-66.92"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M32 256l44-44 46 44m358 0l-44 44-46-44"
                }
            }
        ]
    })(props);
}
function IoTabletLandscapeOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "352",
                    "height": "480",
                    "x": "80",
                    "y": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48",
                    "transform": "rotate(-90 256 256)"
                }
            }
        ]
    })(props);
}
function IoTabletLandscapeSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 82v348a18 18 0 0018 18h476a18 18 0 0018-18V82a18 18 0 00-18-18H18A18 18 0 000 82zm448 330H64V100h384z"
                }
            }
        ]
    })(props);
}
function IoTabletLandscape(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 128v256a64.07 64.07 0 01-64 64H64a64.07 64.07 0 01-64-64V128a64.07 64.07 0 0164-64h384a64.07 64.07 0 0164 64zM32 384a32 32 0 0032 32h384a32 32 0 0032-32V128a32 32 0 00-32-32H64a32 32 0 00-32 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 128a64.07 64.07 0 0164-64h384a64.07 64.07 0 0164 64v256a64.07 64.07 0 01-64 64H64a64.07 64.07 0 01-64-64V128m480 256V128a32 32 0 00-32-32H64a32 32 0 00-32 32v256a32 32 0 0032 32h384a32 32 0 0032-32m-16 0a16 16 0 01-16 16H64a16 16 0 01-16-16V128a16 16 0 0116-16h384a16 16 0 0116 16v256z"
                }
            }
        ]
    })(props);
}
function IoTabletPortraitOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "352",
                    "height": "480",
                    "x": "80",
                    "y": "16",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48"
                }
            }
        ]
    })(props);
}
function IoTabletPortraitSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M430 0H82a18 18 0 00-18 18v476a18 18 0 0018 18h348a18 18 0 0018-18V18a18 18 0 00-18-18zM100 448V64h312v384z"
                }
            }
        ]
    })(props);
}
function IoTabletPortrait(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 512H128a64.07 64.07 0 01-64-64V64a64.07 64.07 0 0164-64h256a64.07 64.07 0 0164 64v384a64.07 64.07 0 01-64 64zM128 32a32 32 0 00-32 32v384a32 32 0 0032 32h256a32 32 0 0032-32V64a32 32 0 00-32-32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M384 0a64.07 64.07 0 0164 64v384a64.07 64.07 0 01-64 64H128a64.07 64.07 0 01-64-64V64a64.07 64.07 0 0164-64h256M128 480h256a32 32 0 0032-32V64a32 32 0 00-32-32H128a32 32 0 00-32 32v384a32 32 0 0032 32m0-16a16 16 0 01-16-16V64a16 16 0 0116-16h256a16 16 0 0116 16v384a16 16 0 01-16 16z"
                }
            }
        ]
    })(props);
}
function IoTelescopeOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M39.93 327.56l-4.71-8.13A24 24 0 0144 286.64l86.87-50.07a16 16 0 0121.89 5.86l12.71 22a16 16 0 01-5.86 21.85l-86.85 50.07a24.06 24.06 0 01-32.83-8.79z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M170.68 273.72L147.12 233a24 24 0 018.8-32.78l124.46-71.75a16 16 0 0121.89 5.86l31.57 54.59a16 16 0 01-5.84 21.84L203.51 282.5a24 24 0 01-32.83-8.78zm171.17-71.51l-46.51-80.43a24 24 0 018.8-32.78l93.29-53.78A24.07 24.07 0 01430.27 44l46.51 80.43a24 24 0 01-8.8 32.79L374.69 211a24.06 24.06 0 01-32.84-8.79zM127.59 480l96.14-207.99m48.07-15.99L368.55 448"
                }
            }
        ]
    })(props);
}
function IoTelescopeSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.41 292.9l44.82 76.97 98.14-56.38-44.73-77.37L1.41 292.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M287.87 252.34l23.67-13.81-63.42-110-132.92 77C133.75 237.51 176 310 176 310l15.53-8.32c.24-.13.55 0 .83 0L102.65 496h35.16l99.05-214.25 23.24-13.4L358 464h36zM262.08 96c24.81 42.23 60.25 104.25 86.4 148.76L510.79 151 424.07 1.41z"
                }
            }
        ]
    })(props);
}
function IoTelescope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M107.56 250a16 16 0 00-21.85-5.86L36 272.81a39.71 39.71 0 00-18.8 24.91 40.9 40.9 0 004.55 30.35l4.36 7.54a40 40 0 0054.62 14.62l49.67-28.63a16 16 0 005.87-21.86z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M382.84 440.8L288.72 254a2 2 0 01.79-2.63l8.3-4.79a16 16 0 005.86-21.86l-47.53-82.33a16 16 0 00-21.86-5.87l-86.38 49.8a39.73 39.73 0 00-18.65 24.28 34.82 34.82 0 00-1.37 9.76c.06 7.6 9.2 22.7 18.12 38.28 9.59 16.75 19.24 33.88 26.34 38.15 4.52 2.72 12.5 4.9 19.21 4.9h.84l-79.32 171.6a16 16 0 1029.05 13.42l93.68-202.65a7.94 7.94 0 013.26-3.57l19.21-11.08a2 2 0 012.78.84l93.21 185a16 16 0 0028.58-14.4zm107.37-325.06L444.09 36a40.08 40.08 0 00-54.63-14.62l-93.34 53.78a39.69 39.69 0 00-18.65 24.28 32.76 32.76 0 00-1.27 13.25c1.74 12.62 13 30.4 26.41 53.89 13.58 23.73 28.91 50.48 36.93 56.27a40.18 40.18 0 0023.18 7.37 39.77 39.77 0 0019.92-5.34L476 171.07a39.72 39.72 0 0018.79-24.84 41 41 0 00-4.58-30.49z"
                }
            }
        ]
    })(props);
}
function IoTennisballOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "208",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M461.43 271.44c-5.09.37-8.24.56-13.43.56-114.88 0-208-93.12-208-208 0-5.37.2-8.69.6-14M49.65 240.56S58.84 240 64 240c114.88 0 208 93.12 208 208 0 5.38-.61 14-.61 14"
                }
            }
        ]
    })(props);
}
function IoTennisballSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M246.4 480a181 181 0 003.22-22.86c.35-4.61.53-9.31.53-14 0-100-81.34-181.32-181.32-181.32A181.72 181.72 0 0032 265.61 224.2 224.2 0 00246.4 480z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M284.63 227.37A222.73 222.73 0 01219 68.83a227.09 227.09 0 012.62-34.42A224.41 224.41 0 0034.41 221.58 227.09 227.09 0 0168.83 219a222.73 222.73 0 01158.54 65.67A222.73 222.73 0 01293 443.17c0 5.74-.22 11.54-.65 17.23s-1.11 11.51-2 17.2a224.42 224.42 0 00187.24-187.18 227.09 227.09 0 01-34.42 2.58 222.73 222.73 0 01-158.54-65.63z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M443.17 250.15a181.72 181.72 0 0036.83-3.76A224.2 224.2 0 00265.61 32a181.72 181.72 0 00-3.76 36.83c0 99.98 81.34 181.32 181.32 181.32z"
                }
            }
        ]
    })(props);
}
function IoTennisball(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 256a192.55 192.55 0 0032-2.68A224 224 0 00258.68 32 192.55 192.55 0 00256 64c0 105.87 86.13 192 192 192zM253.35 480c.94-5.67 1.65-11.4 2.09-17.18.37-4.88.56-9.86.56-14.79 0-105.87-86.13-192-192-192a192.55 192.55 0 00-32 2.68A224 224 0 00253.35 480z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M289.61 222.39A222.53 222.53 0 01224 64a226.07 226.07 0 012-30A224.1 224.1 0 0034 226a226.07 226.07 0 0130-2 222.53 222.53 0 01158.39 65.61A222.53 222.53 0 01288 448c0 5.74-.22 11.53-.65 17.22q-.5 6.42-1.36 12.79A224.12 224.12 0 00478 286a226.07 226.07 0 01-30 2 222.53 222.53 0 01-158.39-65.61z"
                }
            }
        ]
    })(props);
}
function IoTerminalOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "448",
                    "height": "416",
                    "x": "32",
                    "y": "48",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M96 112l80 64-80 64m96 0h64"
                }
            }
        ]
    })(props);
}
function IoTerminalSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 44v424a12 12 0 0012 12h456a12 12 0 0012-12V44a12 12 0 00-12-12H28a12 12 0 00-12 12zm57.51 193.5l76.88-61.5-76.88-61.5 20-25 108.1 86.5L93.5 262.49zM272 256h-96v-32h96z"
                }
            }
        ]
    })(props);
}
function IoTerminal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 32H80a64.07 64.07 0 00-64 64v320a64.07 64.07 0 0064 64h352a64.07 64.07 0 0064-64V96a64.07 64.07 0 00-64-64zM96 256a16 16 0 01-10-28.49L150.39 176 86 124.49a16 16 0 1120-25l80 64a16 16 0 010 25l-80 64A16 16 0 0196 256zm160 0h-64a16 16 0 010-32h64a16 16 0 010 32z"
                }
            }
        ]
    })(props);
}
function IoTextOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M32 415.5l120-320 120 320m-42-112H74m252-64c12.19-28.69 41-48 74-48h0c46 0 80 32 80 80v144"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 358.5c0 36 26.86 58 60 58 54 0 100-27 100-106v-15c-20 0-58 1-92 5-32.77 3.86-68 19-68 58z"
                }
            }
        ]
    })(props);
}
function IoTextSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M404.42 170c-41.23 0-78.07 24.06-93.85 61.3L304 246.52l40.33 17.18 6.56-15.22c8.9-21 29.91-34.55 53.53-34.55 34.55 0 57.76 23.27 57.76 57.91v2.3c-22.12.59-48.65 2.05-72.27 4.84-54.52 6.43-87.06 36.23-87.06 79.72 0 23.16 8.72 44 24.56 58.59C342.28 431 362.55 438 384.51 438c30.86 0 57.5-7.33 77.67-22.64V438H506V271.84C506 212.83 463.28 170 404.42 170zm-19.91 225.07c-17.46 0-37.85-9.84-37.85-36.37 0-10.65 3.82-18.11 12.38-24.19 8.34-5.92 21.12-10.15 36-11.9 21.78-2.57 46.31-3.95 67-4.52-2.16 51.49-27.57 76.98-77.53 76.98zm-291.26-69.2h125.5L260.94 438H308L155 48 4 438h47.06zM156 160.71L202.25 282h-92.5z"
                }
            }
        ]
    })(props);
}
function IoText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M292.6 407.78l-120-320a22 22 0 00-41.2 0l-120 320a22 22 0 0041.2 15.44l36.16-96.42a2 2 0 011.87-1.3h122.74a2 2 0 011.87 1.3l36.16 96.42a22 22 0 0041.2-15.44zm-185.84-129l43.37-115.65a2 2 0 013.74 0l43.37 115.67a2 2 0 01-1.87 2.7h-86.74a2 2 0 01-1.87-2.7zM400.77 169.5c-41.72-.3-79.08 23.87-95 61.4a22 22 0 0040.5 17.2c8.88-20.89 29.77-34.44 53.32-34.6 32.32-.22 58.41 26.5 58.41 58.85a1.5 1.5 0 01-1.45 1.5c-21.92.61-47.92 2.07-71.12 4.8-54.75 6.44-87.43 36.29-87.43 79.85 0 23.19 8.76 44 24.67 58.68C337.6 430.93 358 438.5 380 438.5c31 0 57.69-8 77.94-23.22h.06a22 22 0 1044 .19v-143c0-56.18-45-102.56-101.23-102.97zM380 394.5c-17.53 0-38-9.43-38-36 0-10.67 3.83-18.14 12.43-24.23 8.37-5.93 21.2-10.16 36.14-11.92 21.12-2.49 44.82-3.86 65.14-4.47a2 2 0 012 2.1C455 370.1 429.46 394.5 380 394.5z"
                }
            }
        ]
    })(props);
}
function IoThermometerOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M307.72 302.27a8 8 0 01-3.72-6.75V80a48 48 0 00-48-48h0a48 48 0 00-48 48v215.52a8 8 0 01-3.71 6.74 97.51 97.51 0 00-44.19 86.07A96 96 0 00352 384a97.49 97.49 0 00-44.28-81.73zM256 112v272"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "384",
                    "r": "48"
                }
            }
        ]
    })(props);
}
function IoThermometerSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 291.24V80a64 64 0 10-128 0v211.24A113.39 113.39 0 00144 384a112 112 0 00224 0 113.39 113.39 0 00-48-92.76zM256 432a48 48 0 01-16-93.26V96h32v242.74A48 48 0 01256 432z"
                }
            }
        ]
    })(props);
}
function IoThermometer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 287.18V81c0-35.12-27.89-64.42-63-64.95a64.08 64.08 0 00-65 64v207.13a8 8 0 01-3.18 6.37A113.48 113.48 0 00144 384a112 112 0 00224 0 113.48 113.48 0 00-44.82-90.45 8 8 0 01-3.18-6.37zM254.07 432a48 48 0 01-22-89.54 16 16 0 008-13.84V112.45c0-8.61 6.62-16 15.23-16.43A16 16 0 01272 112v216.58a16.18 16.18 0 008.15 13.94A48 48 0 01254.07 432z"
                }
            }
        ]
    })(props);
}
function IoThumbsDownOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M192 53.84S208 48 256 48s74 16 96 32h64a64 64 0 0164 64v48a64 64 0 01-64 64h-30a32.34 32.34 0 00-27.37 15.4S350 290.19 324 335.22 248 448 240 464c-29 0-43-22-34-47.71 10.28-29.39 23.71-54.38 27.46-87.09.54-4.78-3.14-12-8-12L96 307"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M96 241l80 2c20 1.84 32 12.4 32 30h0c0 17.6-14 28.84-32 30l-80 4c-17.6 0-32-16.4-32-34v-.17A32 32 0 0196 241zm-32-65l112 2c18 .84 32 12.41 32 30h0c0 17.61-14 28.86-32 30l-112 2a32.1 32.1 0 01-32-32h0a32.1 32.1 0 0132-32zm48-128l64 3c21 1.84 32 11.4 32 29h0c0 17.6-14.4 30-32 30l-64 2a32.09 32.09 0 01-32-32h0a32.09 32.09 0 0132-32zm-32 64l96 2c19 .84 32 12.4 32 30h0c0 17.6-13 28.84-32 30l-96 2a32.09 32.09 0 01-32-32h0a32.09 32.09 0 0132-32z"
                }
            }
        ]
    })(props);
}
function IoThumbsDownSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M56 320l156.05 12-23 89.4c-6.08 26.6.7 41.87 22.39 48.62l34.69 9.85a4 4 0 004.4-1.72l129-202.34a8 8 0 016.81-3.81H496V64H378.39a48 48 0 01-15.18-2.46l-76.3-25.43a80 80 0 00-25.3-4.11H83.68c-19 0-31.5 13.52-35.23 32.16L16 206.42V280c0 22.06 18 38 40 40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M378.45 273.93A15.84 15.84 0 01386 272a15.93 15.93 0 00-7.51 1.91zm-40.59 69.29l-.13.22a2.53 2.53 0 01.13-.22c20.5-35.51 30.36-55 33.82-62-3.47 7.06-13.34 26.51-33.82 62z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M372.66 279.16l-1 2a16.29 16.29 0 016.77-7.26 16.48 16.48 0 00-5.77 5.26z"
                }
            }
        ]
    })(props);
}
function IoThumbsDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M39.94 178l144.16 6.12c4.61.36 23.9 1.22 23.9 25.88 0 23.8-19.16 25.33-24.14 25.88L39.94 242C27.27 241.87 16 227.56 16 210s11.27-31.87 23.94-32zm141.45 131.66L74.65 318C62 318 48 301.31 48 284.12v-.33c0-16.33 11.14-29.63 24.88-29.79l108.45 1.72C208 259 208 275.16 208 282.12c0 22.88-21.8 27.14-26.61 27.54zM90.15 32l89.37 8.93C204 41.86 208 58.18 208 68.4c0 18.39-13.41 24.6-26.67 24.6l-91 3C75.78 95.78 64 81.51 64 64s11.68-31.66 26.15-32zm-34.36 71.5l126.4 6.22c9.39.63 25.81 3 25.81 26.36 0 12-4.35 25.62-25 27.53L55.79 167.5C42.65 167.35 32 154 32 136.08s10.65-32.43 23.79-32.58z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M378.45 273.93A15.84 15.84 0 01386 272a15.93 15.93 0 00-7.51 1.91zm-40.59 69.29l-.13.22a2.53 2.53 0 01.13-.22c20.5-35.51 30.36-55 33.82-62-3.47 7.06-13.34 26.51-33.82 62z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M372.66 279.16l-1 2a16.29 16.29 0 016.77-7.26 16.48 16.48 0 00-5.77 5.26z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M195.94 459.38C205.37 472.67 221 480 240 480a16 16 0 0014.31-8.85c3-6.06 15.25-24 28.19-42.9 18-26.33 40.35-59.08 55.23-84.81l.13-.22c20.48-35.49 30.35-54.94 33.82-62l1-2a16.48 16.48 0 015.79-5.23A15.93 15.93 0 01386 272h25.32A84.7 84.7 0 00496 187.3v-38.6A84.7 84.7 0 00411.31 64h-48.79a17.46 17.46 0 01-9.58-2.89C330 46.13 286.66 32 240 32c-7.45 0-14.19.14-20.27.38a8 8 0 00-6.2 12.68l.1.14C222.2 57.59 224 71 224 80a61.16 61.16 0 01-5.19 24.77 17.38 17.38 0 000 14.06 63.81 63.81 0 010 50.39 17.32 17.32 0 000 14 62.13 62.13 0 010 49.58 18.13 18.13 0 000 14.68A60.41 60.41 0 01224 273c0 8.2-2 21.3-8 31.18a15.66 15.66 0 00-1.14 13.65c.38 1 .76 2.06 1.13 3.17a24.8 24.8 0 01.86 11.57c-3 19.35-9.67 36.3-16.74 54.16-3.08 7.78-6.27 15.82-9.22 24.27-6.14 17.56-4.3 35.2 5.05 48.38z"
                }
            }
        ]
    })(props);
}
function IoThumbsUpOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M320 458.16S304 464 256 464s-74-16-96-32H96a64 64 0 01-64-64v-48a64 64 0 0164-64h30a32.34 32.34 0 0027.37-15.4S162 221.81 188 176.78 264 64 272 48c29 0 43 22 34 47.71-10.28 29.39-23.71 54.38-27.46 87.09-.54 4.78 3.14 12 7.95 12L416 205"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M416 271l-80-2c-20-1.84-32-12.4-32-30h0c0-17.6 14-28.84 32-30l80-4c17.6 0 32 16.4 32 34v.17A32 32 0 01416 271zm32 65l-112-2c-18-.84-32-12.41-32-30h0c0-17.61 14-28.86 32-30l112-2a32.1 32.1 0 0132 32h0a32.1 32.1 0 01-32 32zm-48 128l-64-3c-21-1.84-32-11.4-32-29h0c0-17.6 14.4-30 32-30l64-2a32.09 32.09 0 0132 32h0a32.09 32.09 0 01-32 32zm32-64l-96-2c-19-.84-32-12.4-32-30h0c0-17.6 13-28.84 32-30l96-2a32.09 32.09 0 0132 32h0a32.09 32.09 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function IoThumbsUpSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M456 192l-156-12 23-89.4c6-26.6-.78-41.87-22.47-48.6l-34.69-9.85a4 4 0 00-4.4 1.72l-129 202.34a8 8 0 01-6.81 3.81H16V448h117.61a48 48 0 0115.18 2.46l76.3 25.43a80 80 0 0025.3 4.11h177.93c19 0 31.5-13.52 35.23-32.16L496 305.58V232c0-22.06-18-38-40-40z"
                }
            }
        ]
    })(props);
}
function IoThumbsUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M472.06 334l-144.16-6.13c-4.61-.36-23.9-1.21-23.9-25.87 0-23.81 19.16-25.33 24.14-25.88L472.06 270c12.67.13 23.94 14.43 23.94 32s-11.27 31.87-23.94 32zM330.61 202.33L437.35 194C450 194 464 210.68 464 227.88v.33c0 16.32-11.14 29.62-24.88 29.79l-108.45-1.73C304 253 304 236.83 304 229.88c0-22.88 21.8-27.15 26.61-27.55zM421.85 480l-89.37-8.93C308 470.14 304 453.82 304 443.59c0-18.38 13.41-24.6 26.67-24.6l91-3c14.54.23 26.32 14.5 26.32 32s-11.67 31.67-26.14 32.01zm34.36-71.5l-126.4-6.21c-9.39-.63-25.81-3-25.81-26.37 0-12 4.35-25.61 25-27.53l127.19-3.88c13.16.14 23.81 13.49 23.81 31.4s-10.65 32.43-23.79 32.58z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M133.55 238.06A15.85 15.85 0 01126 240a15.82 15.82 0 007.51-1.92zm40.59-69.28l.13-.23-.13.23c-20.5 35.51-30.36 54.95-33.82 62 3.47-7.07 13.34-26.51 33.82-62z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M139.34 232.84l1-2a16.27 16.27 0 01-6.77 7.25 16.35 16.35 0 005.77-5.25z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M316.06 52.62C306.63 39.32 291 32 272 32a16 16 0 00-14.31 8.84c-3 6.07-15.25 24-28.19 42.91-18 26.33-40.35 59.07-55.23 84.8l-.13.23c-20.48 35.49-30.35 54.93-33.82 62l-1 2a16.35 16.35 0 01-5.79 5.22 15.82 15.82 0 01-7.53 2h-25.31A84.69 84.69 0 0016 324.69v38.61a84.69 84.69 0 0084.69 84.7h48.79a17.55 17.55 0 019.58 2.89C182 465.87 225.34 480 272 480c7.45 0 14.19-.14 20.27-.38a8 8 0 006.2-12.68l-.1-.14C289.8 454.41 288 441 288 432a61.2 61.2 0 015.19-24.77 17.36 17.36 0 000-14.05 63.81 63.81 0 010-50.39 17.32 17.32 0 000-14 62.15 62.15 0 010-49.59 18.13 18.13 0 000-14.68A60.33 60.33 0 01288 239c0-8.2 2-21.3 8-31.19a15.63 15.63 0 001.14-13.64c-.38-1-.76-2.07-1.13-3.17a24.84 24.84 0 01-.86-11.58c3-19.34 9.67-36.29 16.74-54.16 3.08-7.78 6.27-15.82 9.22-24.26 6.14-17.57 4.3-35.2-5.05-48.38z"
                }
            }
        ]
    })(props);
}
function IoThunderstormOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M120 352l-24 48m40 32l-16 32m280-112l-24 48m40 32l-16 32M208 304l-16 96h48v80l80-112h-48l16-64m116.33-151.11H392.2C384.71 84.85 326.14 32 256 32a136.39 136.39 0 00-128.63 90.67h-4.57c-49.94 0-90.8 40.8-90.8 90.66h0C32 263.2 72.86 304 122.8 304h281.53C446 304 480 270 480 228.44h0c0-41.55-34-75.55-75.67-75.55z"
                }
            }
        ]
    })(props);
}
function IoThunderstormSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M405.84 136.9a151.25 151.25 0 00-47.6-81.9 153 153 0 00-241.81 51.86C60.5 110.16 16 156.65 16 213.33 16 272.15 63.91 320 122.8 320h72.31L176 416h48v80l112-144h-43.51l8-32h103.84a91.56 91.56 0 001.51-183.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M74.53 407.177l38.32-76.622 28.62 14.313-38.32 76.623zm23.99 64.012l30.318-60.622 28.62 14.313-30.317 60.622zm256.021-64l38.32-76.623 28.62 14.314-38.32 76.622zm24.001 64.011l30.317-60.622 28.62 14.314-30.317 60.621z"
                }
            }
        ]
    })(props);
}
function IoThunderstorm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 416a16 16 0 01-14.3-23.16l24-48a16 16 0 0128.62 14.32l-24 48A16 16 0 0196 416zm24 64a16 16 0 01-14.3-23.16l16-32a16 16 0 0128.62 14.32l-16 32A16 16 0 01120 480zm256-64a16 16 0 01-14.3-23.16l24-48a16 16 0 0128.62 14.32l-24 48A16 16 0 01376 416zm24 64a16 16 0 01-14.3-23.16l16-32a16 16 0 0128.62 14.32l-16 32A16 16 0 01400 480z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M405.84 136.9a151.25 151.25 0 00-47.6-81.9 153 153 0 00-241.81 51.86C60.5 110.16 16 156.65 16 213.33 16 272.15 63.91 320 122.8 320h66.31l-12.89 77.37A16 16 0 00192 416h32v64a16 16 0 0029 9.3l80-112a16 16 0 00-13-25.3h-27.51l8-32h103.84a91.56 91.56 0 001.51-183.1z"
                }
            }
        ]
    })(props);
}
function IoTicketOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M366.05 146a46.7 46.7 0 01-2.42-63.42 3.87 3.87 0 00-.22-5.26l-44.13-44.18a3.89 3.89 0 00-5.5 0l-70.34 70.34a23.62 23.62 0 00-5.71 9.24h0a23.66 23.66 0 01-14.95 15h0a23.7 23.7 0 00-9.25 5.71L33.14 313.78a3.89 3.89 0 000 5.5l44.13 44.13a3.87 3.87 0 005.26.22 46.69 46.69 0 0165.84 65.84 3.87 3.87 0 00.22 5.26l44.13 44.13a3.89 3.89 0 005.5 0l180.4-180.39a23.7 23.7 0 005.71-9.25h0a23.66 23.66 0 0114.95-15h0a23.62 23.62 0 009.24-5.71l70.34-70.34a3.89 3.89 0 000-5.5l-44.13-44.13a3.87 3.87 0 00-5.26-.22 46.7 46.7 0 01-63.42-2.32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M250.5 140.44l-16.51-16.51m60.53 60.53l-11.01-11m55.03 55.03l-11-11.01m60.53 60.53l-16.51-16.51"
                }
            }
        ]
    })(props);
}
function IoTicketSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M426.24 127.72l-10.94 10.94a29.67 29.67 0 01-42-42l10.94-10.94L314.52 16l-88 88-4 12.09-12.09 4L16 314.52l69.76 69.76 10.94-10.94a29.67 29.67 0 0142 42l-10.94 10.94L197.48 496l194.4-194.4 4-12.09 12.09-4 88-88zm-208.56 5.43l21.87-21.87 33 33-21.88 21.87zm43 43l21.88-21.88 32.52 32.52-21.88 21.88zm42.56 42.56l21.88-21.88 32.52 32.52-21.84 21.93zm75.57 75.56l-33-33 21.87-21.88 33 33z"
                }
            }
        ]
    })(props);
}
function IoTicket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M490.18 181.4l-44.13-44.13a20 20 0 00-27-1 30.81 30.81 0 01-41.68-1.6 30.81 30.81 0 01-1.6-41.67 20 20 0 00-1-27L330.6 21.82a19.91 19.91 0 00-28.13 0l-70.35 70.34a39.87 39.87 0 00-9.57 15.5 7.71 7.71 0 01-4.83 4.83 39.78 39.78 0 00-15.5 9.58l-180.4 180.4a19.91 19.91 0 000 28.13L66 374.73a20 20 0 0027 1 30.69 30.69 0 0143.28 43.28 20 20 0 001 27l44.13 44.13a19.91 19.91 0 0028.13 0l180.4-180.4a39.82 39.82 0 009.58-15.49 7.69 7.69 0 014.84-4.84 39.84 39.84 0 0015.49-9.57l70.34-70.35a19.91 19.91 0 00-.01-28.09zm-228.37-29.65a16 16 0 01-22.63 0l-11.51-11.51a16 16 0 0122.63-22.62l11.51 11.5a16 16 0 010 22.63zm44 44a16 16 0 01-22.62 0l-11-11a16 16 0 1122.63-22.63l11 11a16 16 0 01.01 22.66zm44 44a16 16 0 01-22.63 0l-11-11a16 16 0 0122.63-22.62l11 11a16 16 0 01.05 22.67zm44.43 44.54a16 16 0 01-22.63 0l-11.44-11.5a16 16 0 1122.68-22.57l11.45 11.49a16 16 0 01-.01 22.63z"
                }
            }
        ]
    })(props);
}
function IoTimeOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 128v144h96"
                }
            }
        ]
    })(props);
}
function IoTimeSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256c0 114.69 93.32 208 208 208 114.86 0 208-93.14 208-208 0-114.69-93.31-208-208-208zm108 240H244a4 4 0 01-4-4V116a4 4 0 014-4h24a4 4 0 014 4v140h92a4 4 0 014 4v24a4 4 0 01-4 4z"
                }
            }
        ]
    })(props);
}
function IoTime(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm96 240h-96a16 16 0 01-16-16V128a16 16 0 0132 0v128h80a16 16 0 010 32z"
                }
            }
        ]
    })(props);
}
function IoTimerOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M112.91 128A191.85 191.85 0 0064 254c-1.18 106.35 85.65 193.8 192 194 106.2.2 192-85.83 192-192 0-104.54-83.55-189.61-187.5-192a4.36 4.36 0 00-4.5 4.37V152"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M233.38 278.63l-79-113a8.13 8.13 0 0111.32-11.32l113 79a32.5 32.5 0 01-37.25 53.26 33.21 33.21 0 01-8.07-7.94z"
                }
            }
        ]
    })(props);
}
function IoTimerSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.12 48 48 141.12 48 256s93.12 208 208 208 208-93.12 208-208S370.88 48 256 48zm0 384c-97 0-176-78.95-176-176a174.55 174.55 0 0153.87-126.72L279 233l-19 30-125-91c-13 23-26.7 46-26.7 84 0 81.44 66.26 147.7 147.7 147.7S403.7 337.44 403.7 256c0-76.67-58.72-139.88-133.55-147v55h-28.3V79.89c4.24.07 8.94.11 14.15.11 97.05 0 176 79 176 176s-78.95 176-176 176z"
                }
            }
        ]
    })(props);
}
function IoTimer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.12 48 48 141.12 48 256s93.12 208 208 208 208-93.12 208-208S370.88 48 256 48zm-82.33 114.34l105 71a32.5 32.5 0 01-37.25 53.26 33.21 33.21 0 01-8-8l-71-105a8.13 8.13 0 0111.32-11.32zM256 432c-97 0-176-78.95-176-176a174.55 174.55 0 0153.87-126.72 14.15 14.15 0 1119.64 20.37A146.53 146.53 0 00108.3 256c0 81.44 66.26 147.7 147.7 147.7S403.7 337.44 403.7 256c0-76.67-58.72-139.88-133.55-147v55a14.15 14.15 0 11-28.3 0V94.15A14.15 14.15 0 01256 80c97.05 0 176 79 176 176s-78.95 176-176 176z"
                }
            }
        ]
    })(props);
}
function IoTodayOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "416",
                    "height": "384",
                    "x": "48",
                    "y": "80",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M128 48v32m256-32v32"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "96",
                    "height": "96",
                    "x": "112",
                    "y": "224",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "13"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M464 160H48"
                }
            }
        ]
    })(props);
}
function IoTodaySharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 456a24 24 0 0024 24h400a24 24 0 0024-24V176H32zm80-238.86a9.14 9.14 0 019.14-9.14h109.72a9.14 9.14 0 019.14 9.14v109.72a9.14 9.14 0 01-9.14 9.14H121.14a9.14 9.14 0 01-9.14-9.14zM456 64h-55.92V32h-48v32H159.92V32h-48v32H56a23.8 23.8 0 00-24 23.77V144h448V87.77A23.8 23.8 0 00456 64z"
                }
            }
        ]
    })(props);
}
function IoToday(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 64h-16V48.45c0-8.61-6.62-16-15.23-16.43A16 16 0 00368 48v16H144V48.45c0-8.61-6.62-16-15.23-16.43A16 16 0 00112 48v16H96a64 64 0 00-64 64v12a4 4 0 004 4h440a4 4 0 004-4v-12a64 64 0 00-64-64zm61 112H35a3 3 0 00-3 3v237a64 64 0 0064 64h320a64 64 0 0064-64V179a3 3 0 00-3-3zM224 307.43A28.57 28.57 0 01195.43 336h-70.86A28.57 28.57 0 0196 307.43v-70.86A28.57 28.57 0 01124.57 208h70.86A28.57 28.57 0 01224 236.57z"
                }
            }
        ]
    })(props);
}
function IoToggleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "368",
                    "cy": "256",
                    "r": "128",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "480",
                    "height": "256",
                    "x": "16",
                    "y": "128",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "128",
                    "ry": "128"
                }
            }
        ]
    })(props);
}
function IoToggleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 112H144a144 144 0 000 288h224a144 144 0 000-288zm0 230a86 86 0 1186-86 85.88 85.88 0 01-86 86z"
                }
            }
        ]
    })(props);
}
function IoToggle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 112H144C64.6 112 0 176.6 0 256s64.6 144 144 144h224c79.4 0 144-64.6 144-144s-64.6-144-144-144zm0 256a112 112 0 11112-112 112.12 112.12 0 01-112 112z"
                }
            }
        ]
    })(props);
}
function IoTrailSignOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 400v64m0-256v64m0-224v32m160 128H102.63a16 16 0 01-11.32-4.69L32 144l59.31-59.31A16 16 0 01102.63 80H416a16 16 0 0116 16v96a16 16 0 01-16 16zM96 400h313.37a16 16 0 0011.32-4.69L480 336l-59.31-59.31a16 16 0 00-11.32-4.69H96a16 16 0 00-16 16v96a16 16 0 0016 16z"
                }
            }
        ]
    })(props);
}
function IoTrailSignSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.63 336l-80-80H278v-32h170V64H278V32h-44v32H89.37l-80 80 80 80H234v32H64v160h170v64h44v-64h144.63z"
                }
            }
        ]
    })(props);
}
function IoTrailSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M491.31 324.69L432 265.37a31.8 31.8 0 00-22.63-9.37H272v-32h144a32 32 0 0032-32V96a32 32 0 00-32-32H272V48a16 16 0 00-32 0v16H102.63A31.8 31.8 0 0080 73.37l-59.31 59.32a16 16 0 000 22.62L80 214.63a31.8 31.8 0 0022.63 9.37H240v32H96a32 32 0 00-32 32v96a32 32 0 0032 32h144v48a16 16 0 0032 0v-48h137.37a31.8 31.8 0 0022.63-9.37l59.31-59.32a16 16 0 000-22.62z"
                }
            }
        ]
    })(props);
}
function IoTrainOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M344 48h-24a16 16 0 00-16-16h-96a16 16 0 00-16 16h-24a56.16 56.16 0 00-56 56v247c0 35.3 144 65 144 65s144-29.7 144-65V104a56 56 0 00-56-56zm-88 304a48 48 0 1148-48 48 48 0 01-48 48zm96-160a16 16 0 01-16 16H176a16 16 0 01-16-16v-64a16 16 0 0116-16h160a16 16 0 0116 16zM144 464h224m-32-32l48 48m-208-48l-48 48"
                }
            }
        ]
    })(props);
}
function IoTrainSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32h-64a16 16 0 00-16-16h-96a16 16 0 00-16 16h-64c-16 0-32 16-32 32v288c0 23.92 160 80 160 80s160-56.74 160-80V64c0-16-16-32-32-32zM256 352a48 48 0 1148-48 48 48 0 01-48 48zm112-152a8 8 0 01-8 8H152a8 8 0 01-8-8v-80a8 8 0 018-8h208a8 8 0 018 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M314 432l15.32 16H182.58L198 432l-32-13-76.62 77h45.2l16-16h210.74l16 16h45.3l-76.36-77.75L314 432z"
                }
            }
        ]
    })(props);
}
function IoTrain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "256",
                    "cy": "304",
                    "rx": "32.05",
                    "ry": "31.94",
                    "transform": "rotate(-45 256.001 304)"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M352 32h-15a10 10 0 01-7.87-3.78A31.94 31.94 0 00304 16h-96a32 32 0 00-26.11 13.52A6 6 0 01177 32h-17c-36.81 0-64 28.84-64 64v255c0 23.27 25.6 42.06 83 60.94a753 753 0 0073.77 19.73 16 16 0 006.46 0A753 753 0 00333 411.94c57.4-18.88 83-37.67 83-60.94V96a64 64 0 00-64-64zm-168 96h144a8 8 0 018 8v48a8 8 0 01-8 8H184a8 8 0 01-8-8v-48a8 8 0 018-8zm76.18 239.87a64 64 0 1159.69-59.69 64.07 64.07 0 01-59.69 59.69z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M395.31 468.69L347.63 421c-6.09-6.1-16-6.66-22.38-.86a16 16 0 00-.56 23.16l4.68 4.69H182.63l4.36-4.37c6.1-6.09 6.66-16 .86-22.38a16 16 0 00-23.16-.56l-48 48a16 16 0 1022.62 22.62l11.32-11.3h210.74l11.32 11.31a16 16 0 0022.62-22.62z"
                }
            }
        ]
    })(props);
}
function IoTransgenderOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "256",
                    "r": "128",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M448 352l-96 96M176 80l-95.98 95.98M464 128V48h-80M48 128V48h80m336 0L346.5 165.5M48 48l117.49 117.49M464 464L346.65 346.37"
                }
            }
        ]
    })(props);
}
function IoTransgenderSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 448.94l-48.94-49.08L464 366.92l-31.1-31.11-32.9 32.9-23.55-23.61a149.64 149.64 0 00-.1-178.45l59.55-59.56V144h44V32h-112v44h36.87l-59.55 59.55a149.65 149.65 0 00-178.59 0l-7.55-7.55 33-33L161 63.88l-33 33L107.09 76H144V32H32v112h44v-36.91L96.87 128l-33 33L95 192.05l33-33 7.56 7.57A149.18 149.18 0 00106 255.94c0 82.69 67.27 150 150 150a149.12 149.12 0 0089.44-29.67l23.51 23.58-33.14 33.05 31.11 31.1 33-33 48.9 49zm-330-193a106 106 0 11106 106 106.09 106.09 0 01-106-106z"
                }
            }
        ]
    })(props);
}
function IoTransgender(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M458 32h-68a22 22 0 000 44h14.89l-59.57 59.57a149.69 149.69 0 00-178.64 0l-7.57-7.57 26.45-26.44a22 22 0 00-31.12-31.12L128 96.89 107.11 76H122a22 22 0 000-44H54a22 22 0 00-22 22v68a22 22 0 0044 0v-14.89L96.89 128l-26.42 26.42a22 22 0 1031.11 31.11L128 159.11l7.57 7.57A149.19 149.19 0 00106 256c0 82.71 67.29 150 150 150a149.2 149.2 0 0089.46-29.67L369 399.9l-26.54 26.54a22 22 0 0031.12 31.12l26.49-26.5 42.37 42.48a22 22 0 0031.16-31.08L431.17 400l26.39-26.39a22 22 0 00-31.12-31.12l-26.35 26.35-23.55-23.62a149.68 149.68 0 00-.11-178.49L436 107.11V122a22 22 0 0044 0V54a22 22 0 00-22-22zM150 256a106 106 0 11106 106 106.12 106.12 0 01-106-106z"
                }
            }
        ]
    })(props);
}
function IoTrashBinOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M432 144l-28.67 275.74A32 32 0 01371.55 448H140.46a32 32 0 01-31.78-28.26L80 144"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "448",
                    "height": "80",
                    "x": "32",
                    "y": "64",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "16",
                    "ry": "16"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M312 240L200 352m112 0L200 240"
                }
            }
        ]
    })(props);
}
function IoTrashBinSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M337.46 240L312 214.54l-56 56-56-56L174.54 240l56 56-56 56L200 377.46l56-56 56 56L337.46 352l-56-56 56-56z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M337.46 240L312 214.54l-56 56-56-56L174.54 240l56 56-56 56L200 377.46l56-56 56 56L337.46 352l-56-56 56-56z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M64 160l29.74 282.51A24 24 0 00117.61 464h276.78a24 24 0 0023.87-21.49L448 160zm248 217.46l-56-56-56 56L174.54 352l56-56-56-56L200 214.54l56 56 56-56L337.46 240l-56 56 56 56z"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "448",
                    "height": "80",
                    "x": "32",
                    "y": "48",
                    "rx": "12",
                    "ry": "12"
                }
            }
        ]
    })(props);
}
function IoTrashBin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "448",
                    "height": "80",
                    "x": "32",
                    "y": "48",
                    "rx": "32",
                    "ry": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M74.45 160a8 8 0 00-8 8.83l26.31 252.56a1.5 1.5 0 000 .22A48 48 0 00140.45 464h231.09a48 48 0 0047.67-42.39v-.21l26.27-252.57a8 8 0 00-8-8.83zm248.86 180.69a16 16 0 11-22.63 22.62L256 318.63l-44.69 44.68a16 16 0 01-22.63-22.62L233.37 296l-44.69-44.69a16 16 0 0122.63-22.62L256 273.37l44.68-44.68a16 16 0 0122.63 22.62L278.62 296z"
                }
            }
        ]
    })(props);
}
function IoTrashOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M112 112l20 320c.95 18.49 14.4 32 32 32h184c17.67 0 30.87-13.51 32-32l20-320"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M80 112h352"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M192 112V72h0a23.93 23.93 0 0124-24h80a23.93 23.93 0 0124 24h0v40m-64 64v224m-72-224l8 224m136-224l-8 224"
                }
            }
        ]
    })(props);
}
function IoTrashSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M296 64h-80a7.91 7.91 0 00-8 8v24h96V72a7.91 7.91 0 00-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M292 64h-72a4 4 0 00-4 4v28h80V68a4 4 0 00-4-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M447.55 96H336V48a16 16 0 00-16-16H192a16 16 0 00-16 16v48H64.45L64 136h33l20.09 314A32 32 0 00149 480h214a32 32 0 0031.93-29.95L415 136h33zM176 416l-9-256h33l9 256zm96 0h-32V160h32zm24-320h-80V68a4 4 0 014-4h72a4 4 0 014 4zm40 320h-33l9-256h33z"
                }
            }
        ]
    })(props);
}
function IoTrash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M296 64h-80a7.91 7.91 0 00-8 8v24h96V72a7.91 7.91 0 00-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M432 96h-96V72a40 40 0 00-40-40h-80a40 40 0 00-40 40v24H80a16 16 0 000 32h17l19 304.92c1.42 26.85 22 47.08 48 47.08h184c26.13 0 46.3-19.78 48-47l19-305h17a16 16 0 000-32zM192.57 416H192a16 16 0 01-16-15.43l-8-224a16 16 0 1132-1.14l8 224A16 16 0 01192.57 416zM272 400a16 16 0 01-32 0V176a16 16 0 0132 0zm32-304h-96V72a7.91 7.91 0 018-8h80a7.91 7.91 0 018 8zm32 304.57A16 16 0 01320 416h-.58A16 16 0 01304 399.43l8-224a16 16 0 1132 1.14z"
                }
            }
        ]
    })(props);
}
function IoTrendingDownOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 368h112V256"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 144l121.37 121.37a32 32 0 0045.26 0l50.74-50.74a32 32 0 0145.26 0L448 352"
                }
            }
        ]
    })(props);
}
function IoTrendingDownSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M352 368h112V256"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M48 144l144 144 96-96 160 160"
                }
            }
        ]
    })(props);
}
function IoTrendingDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 368h112V256"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 144l121.37 121.37a32 32 0 0045.26 0l50.74-50.74a32 32 0 0145.26 0L448 352"
                }
            }
        ]
    })(props);
}
function IoTrendingUpOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 144h112v112"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 368l121.37-121.37a32 32 0 0145.26 0l50.74 50.74a32 32 0 0045.26 0L448 160"
                }
            }
        ]
    })(props);
}
function IoTrendingUpSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M352 144h112v112"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M48 368l144-144 96 96 160-160"
                }
            }
        ]
    })(props);
}
function IoTrendingUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 144h112v112"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 368l121.37-121.37a32 32 0 0145.26 0l50.74 50.74a32 32 0 0045.26 0L448 160"
                }
            }
        ]
    })(props);
}
function IoTriangleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M48 448L256 64l208 384H48z"
                }
            }
        ]
    })(props);
}
function IoTriangleSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32L20 464h472L256 32z"
                }
            }
        ]
    })(props);
}
function IoTriangle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 464H48a16 16 0 01-14.07-23.62l208-384a16 16 0 0128.14 0l208 384A16 16 0 01464 464z"
                }
            }
        ]
    })(props);
}
function IoTrophyOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M176 464h160m-80 0V336m128-112c0-50.64-.08-134.63-.12-160a16 16 0 00-16-16l-223.79.26a16 16 0 00-16 15.95c0 30.58-.13 129.17-.13 159.79 0 64.28 83 112 128 112S384 288.28 384 224z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M128 96H48v16c0 55.22 33.55 112 80 112M384 96h80v16c0 55.22-33.55 112-80 112"
                }
            }
        ]
    })(props);
}
function IoTrophySharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M399.9 80V32H112v48H32v38c0 32 9.5 62.79 26.76 86.61 13.33 18.4 34.17 31.1 52.91 37.21 5.44 29.29 20.2 57.13 50.19 79.83 22 16.66 48.45 28.87 72.14 33.86V436h-74v44h192v-44h-74v-80.49c23.69-5 50.13-17.2 72.14-33.86 30-22.7 44.75-50.54 50.19-79.83 18.74-6.11 39.58-18.81 52.91-37.21C470.5 180.79 480 150 480 118V80zM94.4 178.8c-10.68-14.68-17.17-34.4-18.24-54.8H112v67.37c-3.94-1.14-12.92-6.12-17.6-12.57zm323.2 0c-4.6 6.61-11.6 12.58-17.6 12.58 0-22.4 0-46.29-.05-67.38h35.9c-1.08 20.4-7.85 39.9-18.25 54.8z"
                }
            }
        ]
    })(props);
}
function IoTrophy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 80h-60.1a4 4 0 01-4-4V63.92a32 32 0 00-32-31.92l-223.79.26a32 32 0 00-31.94 31.93V76a4 4 0 01-4 4H48a16 16 0 00-16 16v16c0 54.53 30 112.45 76.52 125.35a7.82 7.82 0 015.55 5.9c5.77 26.89 23.52 52.5 51.41 73.61 20.91 15.83 45.85 27.5 68.27 32.48a8 8 0 016.25 7.8V444a4 4 0 01-4 4h-59.55c-8.61 0-16 6.62-16.43 15.23A16 16 0 00176 480h159.55c8.61 0 16-6.62 16.43-15.23A16 16 0 00336 448h-60a4 4 0 01-4-4v-86.86a8 8 0 016.25-7.8c22.42-5 47.36-16.65 68.27-32.48 27.89-21.11 45.64-46.72 51.41-73.61a7.82 7.82 0 015.55-5.9C450 224.45 480 166.53 480 112V96a16 16 0 00-16-16zM112 198.22a4 4 0 01-6 3.45c-10.26-6.11-17.75-15.37-22.14-21.89-11.91-17.69-19-40.67-19.79-63.63a4 4 0 014-4.15h40a4 4 0 014 4c-.02 27.45-.07 58.87-.07 82.22zm316.13-18.44c-4.39 6.52-11.87 15.78-22.13 21.89a4 4 0 01-6-3.46c0-26.51 0-56.63-.05-82.21a4 4 0 014-4h40a4 4 0 014 4.15c-.79 22.96-7.9 45.94-19.81 63.63z"
                }
            }
        ]
    })(props);
}
function IoTvOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "448",
                    "height": "272",
                    "x": "32",
                    "y": "96",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "32.14",
                    "ry": "32.14"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M128 416h256"
                }
            }
        ]
    })(props);
}
function IoTvSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 384H24a8 8 0 01-8-8V88a8 8 0 018-8h464a8 8 0 018 8v288a8 8 0 01-8 8z"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "288",
                    "height": "32",
                    "x": "112",
                    "y": "400",
                    "rx": "4",
                    "ry": "4"
                }
            }
        ]
    })(props);
}
function IoTv(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M447.86 384H64.14A48.2 48.2 0 0116 335.86V128.14A48.2 48.2 0 0164.14 80h383.72A48.2 48.2 0 01496 128.14v207.72A48.2 48.2 0 01447.86 384z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M128 416h256"
                }
            }
        ]
    })(props);
}
function IoUmbrellaOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M256 272v160a32 32 0 01-32 32h0a32 32 0 01-32-32m272-160c0-114.88-93.12-208-208-208S48 157.12 48 272h0a67.88 67.88 0 0196 0h0a78.28 78.28 0 01102.31-7.27L256 272l9.69-7.27A78.28 78.28 0 01368 272h0a67.88 67.88 0 0196 0zM256 64V48"
                }
            }
        ]
    })(props);
}
function IoUmbrellaSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128.93 280l-.26-.3c-.9-.74-1.83-1.43-2.77-2.1zm254.15 0l2.62-2.12c-.79.58-1.57 1.17-2.34 1.79z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M463.14 186.44A224.55 224.55 0 00272 48.57V32h-32v16.57A223.58 223.58 0 0032 272v22.52l12.25-11.21a62.63 62.63 0 0181.43-5.88l.22.17c.94.67 1.87 1.36 2.77 2.1q2.09 1.69 4 3.61L144 294.63l11.31-11.32a62.59 62.59 0 0181.4-5.78L240 280v152a16 16 0 01-32 0v-16h-32v16a48 48 0 0096 0V280l3.29-2.47a62.59 62.59 0 0181.4 5.78L368 294.63l11.31-11.32q1.95-1.94 4.05-3.64c.77-.62 1.55-1.21 2.34-1.79l.26-.21c24.63-18.47 60-16.13 81.81 5.64l12.23 11.2V272a223.62 223.62 0 00-16.86-85.56z"
                }
            }
        ]
    })(props);
}
function IoUmbrella(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.39 113.61a222.26 222.26 0 00-136.33-64.54 8.09 8.09 0 01-6.88-5.62 15.79 15.79 0 00-30.36 0 8.09 8.09 0 01-6.88 5.62A224 224 0 0032 271.52a16.41 16.41 0 007.24 13.87 16 16 0 0020.07-2.08 51.89 51.89 0 0173.31-.06 15.94 15.94 0 0022.6.15 62.59 62.59 0 0181.49-5.87 8.24 8.24 0 013.29 6.59v147.42c0 8.6-6.6 16-15.19 16.44A16 16 0 01208 432a16 16 0 00-16.29-16c-9 .16-15.9 8.11-15.7 17.1a48.06 48.06 0 0047.37 46.9c26.88.34 48.62-21.93 48.62-48.81V284.12a8.24 8.24 0 013.29-6.59 62.59 62.59 0 0181.4 5.78 16 16 0 0022.62 0 51.91 51.91 0 0173.38 0 16 16 0 0019.54 2.41 16.4 16.4 0 007.77-14.21 222.54 222.54 0 00-65.61-157.9z"
                }
            }
        ]
    })(props);
}
function IoUnlinkOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "36",
                    "d": "M208 352h-64a96 96 0 010-192h64m96 0h64a96 96 0 010 192h-64"
                }
            }
        ]
    })(props);
}
function IoUnlinkSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M200.66 352H144a96 96 0 010-192h55.41m113.18 0H368a96 96 0 010 192h-56.66"
                }
            }
        ]
    })(props);
}
function IoUnlink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "48",
                    "d": "M200.66 352H144a96 96 0 010-192h55.41m113.18 0H368a96 96 0 010 192h-56.66"
                }
            }
        ]
    })(props);
}
function IoVideocamOffOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M374.79 308.78L457.5 367a16 16 0 0022.5-14.62V159.62A16 16 0 00457.5 145l-82.71 58.22A16 16 0 00368 216.3v79.4a16 16 0 006.79 13.08z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M50.19 140.57A51.94 51.94 0 0032 180v152a52.15 52.15 0 0052 52h184a51.6 51.6 0 0022-4.9M208 128h60.48A51.68 51.68 0 01320 179.52V248m96 168L80 80"
                }
            }
        ]
    })(props);
}
function IoVideocamOffSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M57.376 79.998l22.627-22.627 358.63 358.63-22.627 22.628zM32 112a16 16 0 00-16 16v256a16 16 0 0016 16h288a15.89 15.89 0 009.34-3l-285-285zm304 96v-80a16 16 0 00-16-16H179.63l245.44 245.44L496 400V112z"
                }
            }
        ]
    })(props);
}
function IoVideocamOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 179.52A67.52 67.52 0 00268.48 112h-79.2a4 4 0 00-2.82 6.83l142.71 142.71a4 4 0 006.83-2.82zM16 180v152a68 68 0 0068 68h184a67.66 67.66 0 0042.84-15.24 4 4 0 00.33-6L54.41 122a4 4 0 00-4.87-.62A68 68 0 0016 180zm448 204.39a32 32 0 01-13-2.77 15.77 15.77 0 01-2.71-1.54l-82.71-58.22A32 32 0 01352 295.7v-79.4a32 32 0 0113.58-26.16l82.71-58.22a15.77 15.77 0 012.71-1.54 32 32 0 0145 29.24v192.76a32 32 0 01-32 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M416 416L80 80"
                }
            }
        ]
    })(props);
}
function IoVideocamOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M374.79 308.78L457.5 367a16 16 0 0022.5-14.62V159.62A16 16 0 00457.5 145l-82.71 58.22A16 16 0 00368 216.3v79.4a16 16 0 006.79 13.08z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M268 384H84a52.15 52.15 0 01-52-52V180a52.15 52.15 0 0152-52h184.48A51.68 51.68 0 01320 179.52V332a52.15 52.15 0 01-52 52z"
                }
            }
        ]
    })(props);
}
function IoVideocamSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 208v-80a16 16 0 00-16-16H32a16 16 0 00-16 16v256a16 16 0 0016 16h288a16 16 0 0016-16v-80l160 96V112z"
                }
            }
        ]
    })(props);
}
function IoVideocam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 384.39a32 32 0 01-13-2.77 15.77 15.77 0 01-2.71-1.54l-82.71-58.22A32 32 0 01352 295.7v-79.4a32 32 0 0113.58-26.16l82.71-58.22a15.77 15.77 0 012.71-1.54 32 32 0 0145 29.24v192.76a32 32 0 01-32 32zM268 400H84a68.07 68.07 0 01-68-68V180a68.07 68.07 0 0168-68h184.48A67.6 67.6 0 01336 179.52V332a68.07 68.07 0 01-68 68z"
                }
            }
        ]
    })(props);
}
function IoVolumeHighOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M126 192H56a8 8 0 00-8 8v112a8 8 0 008 8h69.65a15.93 15.93 0 0110.14 3.54l91.47 74.89A8 8 0 00240 392V120a8 8 0 00-12.74-6.43l-91.47 74.89A15 15 0 01126 192zm194 128c9.74-19.38 16-40.84 16-64 0-23.48-6-44.42-16-64m48 176c19.48-33.92 32-64.06 32-112s-12-77.74-32-112m48 272c30-46 48-91.43 48-160s-18-113-48-160"
                }
            }
        ]
    })(props);
}
function IoVolumeHighSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M320 320c9.74-19.38 16-40.84 16-64 0-23.48-6-44.42-16-64m48 176c19.48-33.92 32-64.06 32-112s-12-77.74-32-112m48 272c30-46 48-91.43 48-160s-18-113-48-160"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M125.65 176.1H32v159.8h93.65L256 440V72L125.65 176.1z"
                }
            }
        ]
    })(props);
}
function IoVolumeHigh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232 416a23.88 23.88 0 01-14.2-4.68 8.27 8.27 0 01-.66-.51L125.76 336H56a24 24 0 01-24-24V200a24 24 0 0124-24h69.75l91.37-74.81a8.27 8.27 0 01.66-.51A24 24 0 01256 120v272a24 24 0 01-24 24zm-106.18-80zm-.27-159.86zM320 336a16 16 0 01-14.29-23.19c9.49-18.87 14.3-38 14.3-56.81 0-19.38-4.66-37.94-14.25-56.73a16 16 0 0128.5-14.54C346.19 208.12 352 231.44 352 256c0 23.86-6 47.81-17.7 71.19A16 16 0 01320 336z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M368 384a16 16 0 01-13.86-24C373.05 327.09 384 299.51 384 256c0-44.17-10.93-71.56-29.82-103.94a16 16 0 0127.64-16.12C402.92 172.11 416 204.81 416 256c0 50.43-13.06 83.29-34.13 120a16 16 0 01-13.87 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M416 432a16 16 0 01-13.39-24.74C429.85 365.47 448 323.76 448 256c0-66.5-18.18-108.62-45.49-151.39a16 16 0 1127-17.22C459.81 134.89 480 181.74 480 256c0 64.75-14.66 113.63-50.6 168.74A16 16 0 01416 432z"
                }
            }
        ]
    })(props);
}
function IoVolumeLowOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M189.65 192H120a8 8 0 00-8 8v112a8 8 0 008 8h69.65a16 16 0 0110.14 3.63l91.47 75a8 8 0 0012.74-6.46V119.83a8 8 0 00-12.74-6.44l-91.47 75a16 16 0 01-10.14 3.61zM384 320c9.74-19.41 16-40.81 16-64 0-23.51-6-44.4-16-64"
                }
            }
        ]
    })(props);
}
function IoVolumeLowSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M391.12 341.48l-28.6-14.36 7.18-14.3c9.49-18.9 14.3-38 14.3-56.82 0-19.36-4.66-37.92-14.25-56.73L362.48 185 391 170.48l7.26 14.25C410.2 208.16 416 231.47 416 256c0 23.83-6 47.78-17.7 71.18zM189.65 176.1H96v159.8h93.65L320 440V72L189.65 176.1z"
                }
            }
        ]
    })(props);
}
function IoVolumeLow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 416.19a23.92 23.92 0 01-14.21-4.69l-.66-.51-91.46-75H120a24 24 0 01-24-24V200a24 24 0 0124-24h69.65l91.46-75 .66-.51A24 24 0 01320 119.83v272.34a24 24 0 01-24 24zM384 336a16 16 0 01-14.29-23.18c9.49-18.9 14.3-38 14.3-56.82 0-19.36-4.66-37.92-14.25-56.73a16 16 0 0128.5-14.54C410.2 208.16 416 231.47 416 256c0 23.83-6 47.78-17.7 71.18A16 16 0 01384 336z"
                }
            }
        ]
    })(props);
}
function IoVolumeMediumOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M157.65 192H88a8 8 0 00-8 8v112a8 8 0 008 8h69.65a16 16 0 0110.14 3.63l91.47 75a8 8 0 0012.74-6.46V119.83a8 8 0 00-12.74-6.44l-91.47 75a16 16 0 01-10.14 3.61zM352 320c9.74-19.41 16-40.81 16-64 0-23.51-6-44.4-16-64m48 176c19.48-34 32-64 32-112s-12-77.7-32-112"
                }
            }
        ]
    })(props);
}
function IoVolumeMediumSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M157.65 176.1H64v159.8h93.65L288 440V72L157.65 176.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 320c9.74-19.41 16-40.81 16-64 0-23.51-6-44.4-16-64m48 176c19.48-34 32-64 32-112s-12-77.7-32-112"
                }
            }
        ]
    })(props);
}
function IoVolumeMedium(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M264 416.19a23.92 23.92 0 01-14.21-4.69l-.66-.51-91.46-75H88a24 24 0 01-24-24V200a24 24 0 0124-24h69.65l91.46-75 .66-.51A24 24 0 01288 119.83v272.34a24 24 0 01-24 24zM352 336a16 16 0 01-14.29-23.18c9.49-18.9 14.3-38 14.3-56.82 0-19.36-4.66-37.92-14.25-56.73a16 16 0 0128.5-14.54C378.2 208.16 384 231.47 384 256c0 23.83-6 47.78-17.7 71.18A16 16 0 01352 336z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M400 384a16 16 0 01-13.87-24C405 327.05 416 299.45 416 256c0-44.12-10.94-71.52-29.83-103.95A16 16 0 01413.83 136C434.92 172.16 448 204.88 448 256c0 50.36-13.06 83.24-34.12 120a16 16 0 01-13.88 8z"
                }
            }
        ]
    })(props);
}
function IoVolumeMuteOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M416 432L64 80"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136.92v33.8a4 4 0 001.17 2.82l24 24a4 4 0 006.83-2.82v-74.15a24.53 24.53 0 00-12.67-21.72 23.91 23.91 0 00-25.55 1.83 8.27 8.27 0 00-.66.51l-31.94 26.15a4 4 0 00-.29 5.92l17.05 17.06a4 4 0 005.37.26zm0 238.16l-78.07-63.92a32 32 0 00-20.28-7.16H64v-96h50.72a4 4 0 002.82-6.83l-24-24a4 4 0 00-2.82-1.17H56a24 24 0 00-24 24v112a24 24 0 0024 24h69.76l91.36 74.8a8.27 8.27 0 00.66.51 23.93 23.93 0 0025.85 1.69A24.49 24.49 0 00256 391.45v-50.17a4 4 0 00-1.17-2.82l-24-24a4 4 0 00-6.83 2.82zM125.82 336zM352 256c0-24.56-5.81-47.88-17.75-71.27a16 16 0 00-28.5 14.54C315.34 218.06 320 236.62 320 256q0 4-.31 8.13a8 8 0 002.32 6.25l19.66 19.67a4 4 0 006.75-2A146.89 146.89 0 00352 256zm64 0c0-51.19-13.08-83.89-34.18-120.06a16 16 0 00-27.64 16.12C373.07 184.44 384 211.83 384 256c0 23.83-3.29 42.88-9.37 60.65a8 8 0 001.9 8.26l16.77 16.76a4 4 0 006.52-1.27C410.09 315.88 416 289.91 416 256z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M480 256c0-74.26-20.19-121.11-50.51-168.61a16 16 0 10-27 17.22C429.82 147.38 448 189.5 448 256c0 47.45-8.9 82.12-23.59 113a4 4 0 00.77 4.55L443 391.39a4 4 0 006.4-1C470.88 348.22 480 307 480 256z"
                }
            }
        ]
    })(props);
}
function IoVolumeMuteSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M416 432L64 80"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M352 256c0-24.56-5.81-47.88-17.75-71.27L327 170.47 298.48 185l7.27 14.25C315.34 218.06 320 236.62 320 256a112.91 112.91 0 01-.63 11.74l27.32 27.32A148.8 148.8 0 00352 256zm64 0c0-51.19-13.08-83.89-34.18-120.06l-8.06-13.82-27.64 16.12 8.06 13.82C373.07 184.44 384 211.83 384 256c0 25.93-3.89 46.21-11 65.33l24.5 24.51C409.19 319.68 416 292.42 416 256z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M480 256c0-74.26-20.19-121.11-50.51-168.61l-8.61-13.49-27 17.22 8.61 13.49C429.82 147.38 448 189.5 448 256c0 48.76-9.4 84-24.82 115.55l23.7 23.7C470.16 351.39 480 309 480 256zM256 72l-73.6 58.78 73.6 73.59V72zM32 176.1v159.8h93.65L256 440V339.63L92.47 176.1H32z"
                }
            }
        ]
    })(props);
}
function IoVolumeMute(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M416 432L64 80"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M243.33 98.86a23.89 23.89 0 00-25.55 1.82l-.66.51-28.52 23.35a8 8 0 00-.59 11.85l54.33 54.33a8 8 0 0013.66-5.66v-64.49a24.51 24.51 0 00-12.67-21.71zm8 236.43L96.69 180.69A16 16 0 0085.38 176H56a24 24 0 00-24 24v112a24 24 0 0024 24h69.76l92 75.31a23.9 23.9 0 0025.87 1.69A24.51 24.51 0 00256 391.45v-44.86a16 16 0 00-4.67-11.3zM352 256c0-24.56-5.81-47.87-17.75-71.27a16 16 0 10-28.5 14.55C315.34 218.06 320 236.62 320 256q0 4-.31 8.13a8 8 0 002.32 6.25l14.36 14.36a8 8 0 0013.55-4.31A146 146 0 00352 256zm64 0c0-51.18-13.08-83.89-34.18-120.06a16 16 0 00-27.64 16.12C373.07 184.44 384 211.83 384 256c0 23.83-3.29 42.88-9.37 60.65a8 8 0 001.9 8.26L389 337.4a8 8 0 0013.13-2.79C411 311.76 416 287.26 416 256z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M480 256c0-74.25-20.19-121.11-50.51-168.61a16 16 0 10-27 17.22C429.82 147.38 448 189.5 448 256c0 46.19-8.43 80.27-22.43 110.53a8 8 0 001.59 9l11.92 11.92a8 8 0 0012.92-2.16C471.6 344.9 480 305 480 256z"
                }
            }
        ]
    })(props);
}
function IoVolumeOffOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M237.65 192H168a8 8 0 00-8 8v112a8 8 0 008 8h69.65a16 16 0 0110.14 3.63l91.47 75a8 8 0 0012.74-6.46V119.83a8 8 0 00-12.74-6.44l-91.47 75a16 16 0 01-10.14 3.61z"
                }
            }
        ]
    })(props);
}
function IoVolumeOffSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M237.65 176.1H144v159.8h93.65L368 440V72L237.65 176.1z"
                }
            }
        ]
    })(props);
}
function IoVolumeOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344 416a23.92 23.92 0 01-14.21-4.69c-.23-.16-.44-.33-.66-.51l-91.46-74.9H168a24 24 0 01-24-24V200.07a24 24 0 0124-24h69.65l91.46-74.9c.22-.18.43-.35.66-.51A24 24 0 01368 120v272a24 24 0 01-24 24z"
                }
            }
        ]
    })(props);
}
function IoWalkOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M314.21 482.32l-56.77-114.74-44.89-57.39a72.82 72.82 0 01-10.13-37.05V144h15.67a40.22 40.22 0 0140.23 40.22v183.36M127.9 293.05v-74.52S165.16 144 202.42 144M370.1 274.42L304 231M170.53 478.36L224 400"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "258.32",
                    "cy": "69.48",
                    "r": "37.26",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32"
                }
            }
        ]
    })(props);
}
function IoWalkSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "square",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M315.09 481.38l-56.95-115.12-45-57.56a73.11 73.11 0 01-10.16-37.17V142h15.73A40.36 40.36 0 01259 182.32v162.52"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M128.18 291.5v-74.77l64.95-65.1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M376.35 295.73l-83.95-56.38v-44.68l104.68 72.95-20.73 28.11zM175.13 498.58l-21.43-26.91 80.33-81.54 15.53 32.07-74.43 76.38z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "259.02",
                    "cy": "67.21",
                    "r": "37.38",
                    "strokeLinecap": "square",
                    "strokeLinejoin": "round",
                    "strokeWidth": "16"
                }
            }
        ]
    })(props);
}
function IoWalk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M312.55 479.9l-56.42-114-44.62-57a72.37 72.37 0 01-10.06-36.9V143.64H217a40 40 0 0140 40v182.21"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M127.38 291.78v-74.07s37-74.07 74.07-74.07"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M368.09 291.78a18.49 18.49 0 01-10.26-3.11L297.7 250a21.18 21.18 0 01-9.7-17.79v-23.7a5.65 5.65 0 018.69-4.77l81.65 54.11a18.52 18.52 0 01-10.29 33.93zM171.91 493.47a18.5 18.5 0 01-14.83-7.41c-6.14-8.18-4-17.18 3.7-25.92l59.95-74.66a7.41 7.41 0 0110.76 2.06c1.56 2.54 3.38 5.65 5.19 9.09 5.24 9.95 6 16.11-1.68 25.7-8 10-52 67.44-52 67.44-2.62 2.98-7.23 3.7-11.09 3.7z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "257",
                    "cy": "69.56",
                    "r": "37.04",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "16"
                }
            }
        ]
    })(props);
}
function IoWalletOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "416",
                    "height": "288",
                    "x": "48",
                    "y": "144",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "48",
                    "ry": "48"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M411.36 144v-30A50 50 0 00352 64.9L88.64 109.85A50 50 0 0048 159v49"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M368 320a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function IoWalletSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M47.5 104H432V51.52a16 16 0 00-19.14-15.69l-368 60.48a16 16 0 00-12 10.47A39.69 39.69 0 0147.5 104zm416 24h-416a16 16 0 00-16 16v288a16 16 0 0016 16h416a16 16 0 0016-16V144a16 16 0 00-16-16zM368 320a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M31.33 259.5V116c0-12.33 5.72-18.48 15.42-20 35.2-5.53 108.58-8.5 108.58-8.5s-8.33 16-27.33 16V128c18.5 0 31.33 23.5 31.33 23.5L84.83 236z"
                }
            }
        ]
    })(props);
}
function IoWallet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M95.5 104h320a87.73 87.73 0 0111.18.71 66 66 0 00-77.51-55.56L86 94.08h-.3a66 66 0 00-41.07 26.13A87.57 87.57 0 0195.5 104zm320 24h-320a64.07 64.07 0 00-64 64v192a64.07 64.07 0 0064 64h320a64.07 64.07 0 0064-64V192a64.07 64.07 0 00-64-64zM368 320a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M32 259.5V160c0-21.67 12-58 53.65-65.87C121 87.5 156 87.5 156 87.5s23 16 4 16-18.5 24.5 0 24.5 0 23.5 0 23.5L85.5 236z"
                }
            }
        ]
    })(props);
}
function IoWarningOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M85.57 446.25h340.86a32 32 0 0028.17-47.17L284.18 82.58c-12.09-22.44-44.27-22.44-56.36 0L57.4 399.08a32 32 0 0028.17 47.17z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M250.26 195.39l5.74 122 5.73-121.95a5.74 5.74 0 00-5.79-6h0a5.74 5.74 0 00-5.68 5.95z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 397.25a20 20 0 1120-20 20 20 0 01-20 20z"
                }
            }
        ]
    })(props);
}
function IoWarningSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M479 447.77L268.43 56.64a8 8 0 00-14.09 0L43.73 447.77a8 8 0 007.05 11.79H472a8 8 0 007-11.79zm-197.62-36.29h-40v-40h40zm-4-63.92h-32l-6-160h44z"
                }
            }
        ]
    })(props);
}
function IoWarning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M449.07 399.08L278.64 82.58c-12.08-22.44-44.26-22.44-56.35 0L51.87 399.08A32 32 0 0080 446.25h340.89a32 32 0 0028.18-47.17zm-198.6-1.83a20 20 0 1120-20 20 20 0 01-20 20zm21.72-201.15l-5.74 122a16 16 0 01-32 0l-5.74-121.95a21.73 21.73 0 0121.5-22.69h.21a21.74 21.74 0 0121.73 22.7z"
                }
            }
        ]
    })(props);
}
function IoWatchOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "288",
                    "height": "288",
                    "x": "112",
                    "y": "112",
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "rx": "64",
                    "ry": "64"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M176 112V40a8 8 0 018-8h144a8 8 0 018 8v72m0 288v72a8 8 0 01-8 8H184a8 8 0 01-8-8v-72"
                }
            }
        ]
    })(props);
}
function IoWatchSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "240",
                    "height": "240",
                    "x": "136",
                    "y": "136",
                    "rx": "8",
                    "ry": "8"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M384 96h-48V16H176v80h-48a32 32 0 00-32 32v256a32 32 0 0032 32h48v80h160v-80h48a32 32 0 0032-32V128a32 32 0 00-32-32zm8 272a24 24 0 01-24 24H144a24 24 0 01-24-24V144a24 24 0 0124-24h224a24 24 0 0124 24z"
                }
            }
        ]
    })(props);
}
function IoWatch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "240",
                    "height": "240",
                    "x": "136",
                    "y": "136",
                    "rx": "56",
                    "ry": "56"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M336 96V32a16 16 0 00-16-16H192a16 16 0 00-16 16v64a80.09 80.09 0 00-80 80v160a80.09 80.09 0 0080 80v64a16 16 0 0016 16h128a16 16 0 0016-16v-64a80.09 80.09 0 0080-80V176a80.09 80.09 0 00-80-80zm56 224a72.08 72.08 0 01-72 72H192a72.08 72.08 0 01-72-72V192a72.08 72.08 0 0172-72h128a72.08 72.08 0 0172 72z"
                }
            }
        ]
    })(props);
}
function IoWaterOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M400 320c0 88.37-55.63 144-144 144s-144-55.63-144-144c0-94.83 103.23-222.85 134.89-259.88a12 12 0 0118.23 0C296.77 97.15 400 225.17 400 320z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M344 328a72 72 0 01-72 72"
                }
            }
        ]
    })(props);
}
function IoWaterSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 43.91s-144 158.3-144 270.3c0 88.36 55.64 144 144 144s144-55.64 144-144c0-112-144-270.3-144-270.3zm16 362.3v-24a60.07 60.07 0 0060-60h24a84.09 84.09 0 01-84 84z"
                }
            }
        ]
    })(props);
}
function IoWater(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M265.12 60.12a12 12 0 00-18.23 0C215.23 97.15 112 225.17 112 320c0 88.37 55.64 144 144 144s144-55.63 144-144c0-94.83-103.23-222.85-134.88-259.88zM272 412a12 12 0 01-11.34-16 11.89 11.89 0 0111.41-8A60.06 60.06 0 00332 328.07a11.89 11.89 0 018-11.41A12 12 0 01356 328a84.09 84.09 0 01-84 84z"
                }
            }
        ]
    })(props);
}
function IoWifiOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M332.41 310.59a115 115 0 00-152.8 0m213.85-61.05a201.26 201.26 0 00-274.92 0m329.18-67.43a288 288 0 00-383.44 0"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256 416a32 32 0 1132-32 32 32 0 01-32 32z"
                }
            }
        ]
    })(props);
}
function IoWifiSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "square",
                    "strokeLinejoin": "round",
                    "strokeWidth": "42",
                    "d": "M332.69 320a115 115 0 00-152.8 0m213.85-61a201.26 201.26 0 00-274.92 0M448 191.52a288 288 0 00-383.44 0"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M300.67 384L256 433l-44.34-49a56.73 56.73 0 0188.92 0z"
                }
            }
        ]
    })(props);
}
function IoWifi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M346.65 304.3a136 136 0 00-180.71 0 21 21 0 1027.91 31.38 94 94 0 01124.89 0 21 21 0 0027.91-31.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M256.28 183.7a221.47 221.47 0 00-151.8 59.92 21 21 0 1028.68 30.67 180.28 180.28 0 01246.24 0 21 21 0 1028.68-30.67 221.47 221.47 0 00-151.8-59.92z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M462 175.86a309 309 0 00-411.44 0 21 21 0 1028 31.29 267 267 0 01355.43 0 21 21 0 0028-31.31z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256.28",
                    "cy": "393.41",
                    "r": "32"
                }
            }
        ]
    })(props);
}
function IoWineOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M398.57 80H113.43v16S87.51 272 256 272 398.57 96 398.57 96zM256 272v160"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M352 432H160"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M112 160h288"
                }
            }
        ]
    })(props);
}
function IoWineSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M453 112V66.33H60.75V112l175.13 176v118H124.75v42H389v-42H277.88V288zm-336.65-3.67h281l-37.81 38H154.16z"
                }
            }
        ]
    })(props);
}
function IoWine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.56 94.92V80a16 16 0 00-16-16H113.44a16 16 0 00-16 16v14.92c-1.46 11.37-9.65 90.74 36.93 144.69 24.87 28.8 60.36 44.85 105.63 47.86V416h-80a16 16 0 000 32h192a16 16 0 000-32h-80V287.47c45.27-3 80.76-19.06 105.63-47.86 46.58-53.95 38.37-133.32 36.93-144.69zm-285.3 3.41a15.14 15.14 0 00.18-2.33h253.12a15.14 15.14 0 00.18 2.33 201.91 201.91 0 010 45.67H129.32a204.29 204.29 0 01-.06-45.67z"
                }
            }
        ]
    })(props);
}
function IoWomanOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M208 368v104a23.73 23.73 0 0024 24h0a23.73 23.73 0 0024-24"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32",
                    "d": "M256 368v104a23.73 23.73 0 0024 24h0a23.73 23.73 0 0024-24V368m-121-94a23.73 23.73 0 01-29.84 16.18h0a23.72 23.72 0 01-16.17-29.84l25-84.28A44.85 44.85 0 01205 144h102a44.85 44.85 0 0143 32.08l25 84.28a23.72 23.72 0 01-16.17 29.84h0a23.73 23.73 0 01-29.78-16.2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "256",
                    "cy": "56",
                    "r": "40",
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeMiterlimit": "10",
                    "strokeWidth": "32"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "32",
                    "d": "M208 192l-48 160h192l-48-160"
                }
            }
        ]
    })(props);
}
function IoWomanSharp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "255.75",
                    "cy": "56",
                    "r": "56"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M310.28 191.4h.05l7.66-2.3 36.79 122.6 46-13.8-16.21-54.16c0-.12 0-.24-.07-.36l-16.84-56.12-4.71-15.74-.9-3H362l-2.51-8.45a44.84 44.84 0 00-43-32.08H195.24a44.84 44.84 0 00-43 32.08l-2.51 8.45h-.06l-.9 3-4.71 15.74-16.84 56.12c0 .12 0 .24-.07.36l-16.21 54.16 46 13.8 36.76-122.6 7.54 2.26L148.25 368h51.5v144h52V368h8v144h52V368h51.51z"
                }
            }
        ]
    })(props);
}
function IoWoman(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "255.75",
                    "cy": "56",
                    "r": "56"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M394.63 277.9l-10.33-34.41v-.11l-22.46-74.86h-.05l-2.51-8.45a44.87 44.87 0 00-43-32.08h-120a44.84 44.84 0 00-43 32.08l-2.51 8.45h-.06l-22.46 74.86v.11l-10.37 34.41c-3.12 10.39 2.3 21.66 12.57 25.14a20 20 0 0025.6-13.18l25.58-85.25 2.17-7.23a8 8 0 0115.53 2.62 7.78 7.78 0 01-.17 1.61L155.43 347.4a16 16 0 0015.32 20.6h29v114.69c0 16.46 10.53 29.31 24 29.31s24-12.85 24-29.31V368h16v114.69c0 16.46 10.53 29.31 24 29.31s24-12.85 24-29.31V368h30a16 16 0 0015.33-20.6l-43.74-145.81a7.52 7.52 0 01-.16-1.59 8 8 0 0115.54-2.63l2.17 7.23 25.57 85.25A20 20 0 00382.05 303c10.27-3.44 15.69-14.71 12.58-25.1z"
                }
            }
        ]
    })(props);
}

},{"../lib":"hOIFC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fL51W":[function(require,module,exports,__globalThis) {
// THIS FILE IS AUTO GENERATED
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BsFill0CircleFill", ()=>BsFill0CircleFill);
parcelHelpers.export(exports, "BsFill0SquareFill", ()=>BsFill0SquareFill);
parcelHelpers.export(exports, "BsFill1CircleFill", ()=>BsFill1CircleFill);
parcelHelpers.export(exports, "BsFill1SquareFill", ()=>BsFill1SquareFill);
parcelHelpers.export(exports, "BsFill2CircleFill", ()=>BsFill2CircleFill);
parcelHelpers.export(exports, "BsFill2SquareFill", ()=>BsFill2SquareFill);
parcelHelpers.export(exports, "BsFill3CircleFill", ()=>BsFill3CircleFill);
parcelHelpers.export(exports, "BsFill3SquareFill", ()=>BsFill3SquareFill);
parcelHelpers.export(exports, "BsFill4CircleFill", ()=>BsFill4CircleFill);
parcelHelpers.export(exports, "BsFill4SquareFill", ()=>BsFill4SquareFill);
parcelHelpers.export(exports, "BsFill5CircleFill", ()=>BsFill5CircleFill);
parcelHelpers.export(exports, "BsFill5SquareFill", ()=>BsFill5SquareFill);
parcelHelpers.export(exports, "BsFill6CircleFill", ()=>BsFill6CircleFill);
parcelHelpers.export(exports, "BsFill6SquareFill", ()=>BsFill6SquareFill);
parcelHelpers.export(exports, "BsFill7CircleFill", ()=>BsFill7CircleFill);
parcelHelpers.export(exports, "BsFill7SquareFill", ()=>BsFill7SquareFill);
parcelHelpers.export(exports, "BsFill8CircleFill", ()=>BsFill8CircleFill);
parcelHelpers.export(exports, "BsFill8SquareFill", ()=>BsFill8SquareFill);
parcelHelpers.export(exports, "BsFill9CircleFill", ()=>BsFill9CircleFill);
parcelHelpers.export(exports, "BsFill9SquareFill", ()=>BsFill9SquareFill);
parcelHelpers.export(exports, "BsFillAirplaneEnginesFill", ()=>BsFillAirplaneEnginesFill);
parcelHelpers.export(exports, "BsFillAirplaneFill", ()=>BsFillAirplaneFill);
parcelHelpers.export(exports, "BsFillAlarmFill", ()=>BsFillAlarmFill);
parcelHelpers.export(exports, "BsFillArchiveFill", ()=>BsFillArchiveFill);
parcelHelpers.export(exports, "BsFillArrowDownCircleFill", ()=>BsFillArrowDownCircleFill);
parcelHelpers.export(exports, "BsFillArrowDownLeftCircleFill", ()=>BsFillArrowDownLeftCircleFill);
parcelHelpers.export(exports, "BsFillArrowDownLeftSquareFill", ()=>BsFillArrowDownLeftSquareFill);
parcelHelpers.export(exports, "BsFillArrowDownRightCircleFill", ()=>BsFillArrowDownRightCircleFill);
parcelHelpers.export(exports, "BsFillArrowDownRightSquareFill", ()=>BsFillArrowDownRightSquareFill);
parcelHelpers.export(exports, "BsFillArrowDownSquareFill", ()=>BsFillArrowDownSquareFill);
parcelHelpers.export(exports, "BsFillArrowLeftCircleFill", ()=>BsFillArrowLeftCircleFill);
parcelHelpers.export(exports, "BsFillArrowLeftSquareFill", ()=>BsFillArrowLeftSquareFill);
parcelHelpers.export(exports, "BsFillArrowRightCircleFill", ()=>BsFillArrowRightCircleFill);
parcelHelpers.export(exports, "BsFillArrowRightSquareFill", ()=>BsFillArrowRightSquareFill);
parcelHelpers.export(exports, "BsFillArrowThroughHeartFill", ()=>BsFillArrowThroughHeartFill);
parcelHelpers.export(exports, "BsFillArrowUpCircleFill", ()=>BsFillArrowUpCircleFill);
parcelHelpers.export(exports, "BsFillArrowUpLeftCircleFill", ()=>BsFillArrowUpLeftCircleFill);
parcelHelpers.export(exports, "BsFillArrowUpLeftSquareFill", ()=>BsFillArrowUpLeftSquareFill);
parcelHelpers.export(exports, "BsFillArrowUpRightCircleFill", ()=>BsFillArrowUpRightCircleFill);
parcelHelpers.export(exports, "BsFillArrowUpRightSquareFill", ()=>BsFillArrowUpRightSquareFill);
parcelHelpers.export(exports, "BsFillArrowUpSquareFill", ()=>BsFillArrowUpSquareFill);
parcelHelpers.export(exports, "BsFillAspectRatioFill", ()=>BsFillAspectRatioFill);
parcelHelpers.export(exports, "BsFillAwardFill", ()=>BsFillAwardFill);
parcelHelpers.export(exports, "BsFillBackpackFill", ()=>BsFillBackpackFill);
parcelHelpers.export(exports, "BsFillBackpack2Fill", ()=>BsFillBackpack2Fill);
parcelHelpers.export(exports, "BsFillBackpack3Fill", ()=>BsFillBackpack3Fill);
parcelHelpers.export(exports, "BsFillBackpack4Fill", ()=>BsFillBackpack4Fill);
parcelHelpers.export(exports, "BsFillBackspaceFill", ()=>BsFillBackspaceFill);
parcelHelpers.export(exports, "BsFillBackspaceReverseFill", ()=>BsFillBackspaceReverseFill);
parcelHelpers.export(exports, "BsFillBadge3DFill", ()=>BsFillBadge3DFill);
parcelHelpers.export(exports, "BsFillBadge4KFill", ()=>BsFillBadge4KFill);
parcelHelpers.export(exports, "BsFillBadge8KFill", ()=>BsFillBadge8KFill);
parcelHelpers.export(exports, "BsFillBadgeAdFill", ()=>BsFillBadgeAdFill);
parcelHelpers.export(exports, "BsFillBadgeArFill", ()=>BsFillBadgeArFill);
parcelHelpers.export(exports, "BsFillBadgeCcFill", ()=>BsFillBadgeCcFill);
parcelHelpers.export(exports, "BsFillBadgeHdFill", ()=>BsFillBadgeHdFill);
parcelHelpers.export(exports, "BsFillBadgeSdFill", ()=>BsFillBadgeSdFill);
parcelHelpers.export(exports, "BsFillBadgeTmFill", ()=>BsFillBadgeTmFill);
parcelHelpers.export(exports, "BsFillBadgeVoFill", ()=>BsFillBadgeVoFill);
parcelHelpers.export(exports, "BsFillBadgeVrFill", ()=>BsFillBadgeVrFill);
parcelHelpers.export(exports, "BsFillBadgeWcFill", ()=>BsFillBadgeWcFill);
parcelHelpers.export(exports, "BsFillBagCheckFill", ()=>BsFillBagCheckFill);
parcelHelpers.export(exports, "BsFillBagDashFill", ()=>BsFillBagDashFill);
parcelHelpers.export(exports, "BsFillBagFill", ()=>BsFillBagFill);
parcelHelpers.export(exports, "BsFillBagHeartFill", ()=>BsFillBagHeartFill);
parcelHelpers.export(exports, "BsFillBagPlusFill", ()=>BsFillBagPlusFill);
parcelHelpers.export(exports, "BsFillBagXFill", ()=>BsFillBagXFill);
parcelHelpers.export(exports, "BsFillBalloonFill", ()=>BsFillBalloonFill);
parcelHelpers.export(exports, "BsFillBalloonHeartFill", ()=>BsFillBalloonHeartFill);
parcelHelpers.export(exports, "BsFillBanFill", ()=>BsFillBanFill);
parcelHelpers.export(exports, "BsFillBandaidFill", ()=>BsFillBandaidFill);
parcelHelpers.export(exports, "BsFillBarChartFill", ()=>BsFillBarChartFill);
parcelHelpers.export(exports, "BsFillBarChartLineFill", ()=>BsFillBarChartLineFill);
parcelHelpers.export(exports, "BsFillBasketFill", ()=>BsFillBasketFill);
parcelHelpers.export(exports, "BsFillBasket2Fill", ()=>BsFillBasket2Fill);
parcelHelpers.export(exports, "BsFillBasket3Fill", ()=>BsFillBasket3Fill);
parcelHelpers.export(exports, "BsFillBellFill", ()=>BsFillBellFill);
parcelHelpers.export(exports, "BsFillBellSlashFill", ()=>BsFillBellSlashFill);
parcelHelpers.export(exports, "BsFillBinocularsFill", ()=>BsFillBinocularsFill);
parcelHelpers.export(exports, "BsFillBookFill", ()=>BsFillBookFill);
parcelHelpers.export(exports, "BsFillBookmarkCheckFill", ()=>BsFillBookmarkCheckFill);
parcelHelpers.export(exports, "BsFillBookmarkDashFill", ()=>BsFillBookmarkDashFill);
parcelHelpers.export(exports, "BsFillBookmarkFill", ()=>BsFillBookmarkFill);
parcelHelpers.export(exports, "BsFillBookmarkHeartFill", ()=>BsFillBookmarkHeartFill);
parcelHelpers.export(exports, "BsFillBookmarkPlusFill", ()=>BsFillBookmarkPlusFill);
parcelHelpers.export(exports, "BsFillBookmarkStarFill", ()=>BsFillBookmarkStarFill);
parcelHelpers.export(exports, "BsFillBookmarkXFill", ()=>BsFillBookmarkXFill);
parcelHelpers.export(exports, "BsFillBookmarksFill", ()=>BsFillBookmarksFill);
parcelHelpers.export(exports, "BsFillBoomboxFill", ()=>BsFillBoomboxFill);
parcelHelpers.export(exports, "BsFillBootstrapFill", ()=>BsFillBootstrapFill);
parcelHelpers.export(exports, "BsFillBoxFill", ()=>BsFillBoxFill);
parcelHelpers.export(exports, "BsFillBoxSeamFill", ()=>BsFillBoxSeamFill);
parcelHelpers.export(exports, "BsFillBox2Fill", ()=>BsFillBox2Fill);
parcelHelpers.export(exports, "BsFillBox2HeartFill", ()=>BsFillBox2HeartFill);
parcelHelpers.export(exports, "BsFillBriefcaseFill", ()=>BsFillBriefcaseFill);
parcelHelpers.export(exports, "BsFillBrightnessAltHighFill", ()=>BsFillBrightnessAltHighFill);
parcelHelpers.export(exports, "BsFillBrightnessAltLowFill", ()=>BsFillBrightnessAltLowFill);
parcelHelpers.export(exports, "BsFillBrightnessHighFill", ()=>BsFillBrightnessHighFill);
parcelHelpers.export(exports, "BsFillBrightnessLowFill", ()=>BsFillBrightnessLowFill);
parcelHelpers.export(exports, "BsFillBrushFill", ()=>BsFillBrushFill);
parcelHelpers.export(exports, "BsFillBucketFill", ()=>BsFillBucketFill);
parcelHelpers.export(exports, "BsFillBugFill", ()=>BsFillBugFill);
parcelHelpers.export(exports, "BsFillBuildingFill", ()=>BsFillBuildingFill);
parcelHelpers.export(exports, "BsFillBuildingsFill", ()=>BsFillBuildingsFill);
parcelHelpers.export(exports, "BsFillBusFrontFill", ()=>BsFillBusFrontFill);
parcelHelpers.export(exports, "BsFillCCircleFill", ()=>BsFillCCircleFill);
parcelHelpers.export(exports, "BsFillCSquareFill", ()=>BsFillCSquareFill);
parcelHelpers.export(exports, "BsFillCakeFill", ()=>BsFillCakeFill);
parcelHelpers.export(exports, "BsFillCake2Fill", ()=>BsFillCake2Fill);
parcelHelpers.export(exports, "BsFillCalculatorFill", ()=>BsFillCalculatorFill);
parcelHelpers.export(exports, "BsFillCalendarCheckFill", ()=>BsFillCalendarCheckFill);
parcelHelpers.export(exports, "BsFillCalendarDateFill", ()=>BsFillCalendarDateFill);
parcelHelpers.export(exports, "BsFillCalendarDayFill", ()=>BsFillCalendarDayFill);
parcelHelpers.export(exports, "BsFillCalendarEventFill", ()=>BsFillCalendarEventFill);
parcelHelpers.export(exports, "BsFillCalendarFill", ()=>BsFillCalendarFill);
parcelHelpers.export(exports, "BsFillCalendarHeartFill", ()=>BsFillCalendarHeartFill);
parcelHelpers.export(exports, "BsFillCalendarMinusFill", ()=>BsFillCalendarMinusFill);
parcelHelpers.export(exports, "BsFillCalendarMonthFill", ()=>BsFillCalendarMonthFill);
parcelHelpers.export(exports, "BsFillCalendarPlusFill", ()=>BsFillCalendarPlusFill);
parcelHelpers.export(exports, "BsFillCalendarRangeFill", ()=>BsFillCalendarRangeFill);
parcelHelpers.export(exports, "BsFillCalendarWeekFill", ()=>BsFillCalendarWeekFill);
parcelHelpers.export(exports, "BsFillCalendarXFill", ()=>BsFillCalendarXFill);
parcelHelpers.export(exports, "BsFillCalendar2CheckFill", ()=>BsFillCalendar2CheckFill);
parcelHelpers.export(exports, "BsFillCalendar2DateFill", ()=>BsFillCalendar2DateFill);
parcelHelpers.export(exports, "BsFillCalendar2DayFill", ()=>BsFillCalendar2DayFill);
parcelHelpers.export(exports, "BsFillCalendar2EventFill", ()=>BsFillCalendar2EventFill);
parcelHelpers.export(exports, "BsFillCalendar2Fill", ()=>BsFillCalendar2Fill);
parcelHelpers.export(exports, "BsFillCalendar2HeartFill", ()=>BsFillCalendar2HeartFill);
parcelHelpers.export(exports, "BsFillCalendar2MinusFill", ()=>BsFillCalendar2MinusFill);
parcelHelpers.export(exports, "BsFillCalendar2MonthFill", ()=>BsFillCalendar2MonthFill);
parcelHelpers.export(exports, "BsFillCalendar2PlusFill", ()=>BsFillCalendar2PlusFill);
parcelHelpers.export(exports, "BsFillCalendar2RangeFill", ()=>BsFillCalendar2RangeFill);
parcelHelpers.export(exports, "BsFillCalendar2WeekFill", ()=>BsFillCalendar2WeekFill);
parcelHelpers.export(exports, "BsFillCalendar2XFill", ()=>BsFillCalendar2XFill);
parcelHelpers.export(exports, "BsFillCalendar3EventFill", ()=>BsFillCalendar3EventFill);
parcelHelpers.export(exports, "BsFillCalendar3Fill", ()=>BsFillCalendar3Fill);
parcelHelpers.export(exports, "BsFillCalendar3RangeFill", ()=>BsFillCalendar3RangeFill);
parcelHelpers.export(exports, "BsFillCalendar3WeekFill", ()=>BsFillCalendar3WeekFill);
parcelHelpers.export(exports, "BsFillCameraFill", ()=>BsFillCameraFill);
parcelHelpers.export(exports, "BsFillCameraReelsFill", ()=>BsFillCameraReelsFill);
parcelHelpers.export(exports, "BsFillCameraVideoFill", ()=>BsFillCameraVideoFill);
parcelHelpers.export(exports, "BsFillCameraVideoOffFill", ()=>BsFillCameraVideoOffFill);
parcelHelpers.export(exports, "BsFillCapslockFill", ()=>BsFillCapslockFill);
parcelHelpers.export(exports, "BsFillCarFrontFill", ()=>BsFillCarFrontFill);
parcelHelpers.export(exports, "BsFillCaretDownFill", ()=>BsFillCaretDownFill);
parcelHelpers.export(exports, "BsFillCaretDownSquareFill", ()=>BsFillCaretDownSquareFill);
parcelHelpers.export(exports, "BsFillCaretLeftFill", ()=>BsFillCaretLeftFill);
parcelHelpers.export(exports, "BsFillCaretLeftSquareFill", ()=>BsFillCaretLeftSquareFill);
parcelHelpers.export(exports, "BsFillCaretRightFill", ()=>BsFillCaretRightFill);
parcelHelpers.export(exports, "BsFillCaretRightSquareFill", ()=>BsFillCaretRightSquareFill);
parcelHelpers.export(exports, "BsFillCaretUpFill", ()=>BsFillCaretUpFill);
parcelHelpers.export(exports, "BsFillCaretUpSquareFill", ()=>BsFillCaretUpSquareFill);
parcelHelpers.export(exports, "BsFillCartCheckFill", ()=>BsFillCartCheckFill);
parcelHelpers.export(exports, "BsFillCartDashFill", ()=>BsFillCartDashFill);
parcelHelpers.export(exports, "BsFillCartFill", ()=>BsFillCartFill);
parcelHelpers.export(exports, "BsFillCartPlusFill", ()=>BsFillCartPlusFill);
parcelHelpers.export(exports, "BsFillCartXFill", ()=>BsFillCartXFill);
parcelHelpers.export(exports, "BsFillCassetteFill", ()=>BsFillCassetteFill);
parcelHelpers.export(exports, "BsFillCcCircleFill", ()=>BsFillCcCircleFill);
parcelHelpers.export(exports, "BsFillCcSquareFill", ()=>BsFillCcSquareFill);
parcelHelpers.export(exports, "BsFillChatDotsFill", ()=>BsFillChatDotsFill);
parcelHelpers.export(exports, "BsFillChatFill", ()=>BsFillChatFill);
parcelHelpers.export(exports, "BsFillChatHeartFill", ()=>BsFillChatHeartFill);
parcelHelpers.export(exports, "BsFillChatLeftDotsFill", ()=>BsFillChatLeftDotsFill);
parcelHelpers.export(exports, "BsFillChatLeftFill", ()=>BsFillChatLeftFill);
parcelHelpers.export(exports, "BsFillChatLeftHeartFill", ()=>BsFillChatLeftHeartFill);
parcelHelpers.export(exports, "BsFillChatLeftQuoteFill", ()=>BsFillChatLeftQuoteFill);
parcelHelpers.export(exports, "BsFillChatLeftTextFill", ()=>BsFillChatLeftTextFill);
parcelHelpers.export(exports, "BsFillChatQuoteFill", ()=>BsFillChatQuoteFill);
parcelHelpers.export(exports, "BsFillChatRightDotsFill", ()=>BsFillChatRightDotsFill);
parcelHelpers.export(exports, "BsFillChatRightFill", ()=>BsFillChatRightFill);
parcelHelpers.export(exports, "BsFillChatRightHeartFill", ()=>BsFillChatRightHeartFill);
parcelHelpers.export(exports, "BsFillChatRightQuoteFill", ()=>BsFillChatRightQuoteFill);
parcelHelpers.export(exports, "BsFillChatRightTextFill", ()=>BsFillChatRightTextFill);
parcelHelpers.export(exports, "BsFillChatSquareDotsFill", ()=>BsFillChatSquareDotsFill);
parcelHelpers.export(exports, "BsFillChatSquareFill", ()=>BsFillChatSquareFill);
parcelHelpers.export(exports, "BsFillChatSquareHeartFill", ()=>BsFillChatSquareHeartFill);
parcelHelpers.export(exports, "BsFillChatSquareQuoteFill", ()=>BsFillChatSquareQuoteFill);
parcelHelpers.export(exports, "BsFillChatSquareTextFill", ()=>BsFillChatSquareTextFill);
parcelHelpers.export(exports, "BsFillChatTextFill", ()=>BsFillChatTextFill);
parcelHelpers.export(exports, "BsFillCheckCircleFill", ()=>BsFillCheckCircleFill);
parcelHelpers.export(exports, "BsFillCheckSquareFill", ()=>BsFillCheckSquareFill);
parcelHelpers.export(exports, "BsFillCircleFill", ()=>BsFillCircleFill);
parcelHelpers.export(exports, "BsFillClipboardCheckFill", ()=>BsFillClipboardCheckFill);
parcelHelpers.export(exports, "BsFillClipboardDataFill", ()=>BsFillClipboardDataFill);
parcelHelpers.export(exports, "BsFillClipboardFill", ()=>BsFillClipboardFill);
parcelHelpers.export(exports, "BsFillClipboardHeartFill", ()=>BsFillClipboardHeartFill);
parcelHelpers.export(exports, "BsFillClipboardMinusFill", ()=>BsFillClipboardMinusFill);
parcelHelpers.export(exports, "BsFillClipboardPlusFill", ()=>BsFillClipboardPlusFill);
parcelHelpers.export(exports, "BsFillClipboardXFill", ()=>BsFillClipboardXFill);
parcelHelpers.export(exports, "BsFillClipboard2CheckFill", ()=>BsFillClipboard2CheckFill);
parcelHelpers.export(exports, "BsFillClipboard2DataFill", ()=>BsFillClipboard2DataFill);
parcelHelpers.export(exports, "BsFillClipboard2Fill", ()=>BsFillClipboard2Fill);
parcelHelpers.export(exports, "BsFillClipboard2HeartFill", ()=>BsFillClipboard2HeartFill);
parcelHelpers.export(exports, "BsFillClipboard2MinusFill", ()=>BsFillClipboard2MinusFill);
parcelHelpers.export(exports, "BsFillClipboard2PlusFill", ()=>BsFillClipboard2PlusFill);
parcelHelpers.export(exports, "BsFillClipboard2PulseFill", ()=>BsFillClipboard2PulseFill);
parcelHelpers.export(exports, "BsFillClipboard2XFill", ()=>BsFillClipboard2XFill);
parcelHelpers.export(exports, "BsFillClockFill", ()=>BsFillClockFill);
parcelHelpers.export(exports, "BsFillCloudArrowDownFill", ()=>BsFillCloudArrowDownFill);
parcelHelpers.export(exports, "BsFillCloudArrowUpFill", ()=>BsFillCloudArrowUpFill);
parcelHelpers.export(exports, "BsFillCloudCheckFill", ()=>BsFillCloudCheckFill);
parcelHelpers.export(exports, "BsFillCloudDownloadFill", ()=>BsFillCloudDownloadFill);
parcelHelpers.export(exports, "BsFillCloudDrizzleFill", ()=>BsFillCloudDrizzleFill);
parcelHelpers.export(exports, "BsFillCloudFill", ()=>BsFillCloudFill);
parcelHelpers.export(exports, "BsFillCloudFogFill", ()=>BsFillCloudFogFill);
parcelHelpers.export(exports, "BsFillCloudFog2Fill", ()=>BsFillCloudFog2Fill);
parcelHelpers.export(exports, "BsFillCloudHailFill", ()=>BsFillCloudHailFill);
parcelHelpers.export(exports, "BsFillCloudHazeFill", ()=>BsFillCloudHazeFill);
parcelHelpers.export(exports, "BsFillCloudHaze2Fill", ()=>BsFillCloudHaze2Fill);
parcelHelpers.export(exports, "BsFillCloudLightningFill", ()=>BsFillCloudLightningFill);
parcelHelpers.export(exports, "BsFillCloudLightningRainFill", ()=>BsFillCloudLightningRainFill);
parcelHelpers.export(exports, "BsFillCloudMinusFill", ()=>BsFillCloudMinusFill);
parcelHelpers.export(exports, "BsFillCloudMoonFill", ()=>BsFillCloudMoonFill);
parcelHelpers.export(exports, "BsFillCloudPlusFill", ()=>BsFillCloudPlusFill);
parcelHelpers.export(exports, "BsFillCloudRainFill", ()=>BsFillCloudRainFill);
parcelHelpers.export(exports, "BsFillCloudRainHeavyFill", ()=>BsFillCloudRainHeavyFill);
parcelHelpers.export(exports, "BsFillCloudSlashFill", ()=>BsFillCloudSlashFill);
parcelHelpers.export(exports, "BsFillCloudSleetFill", ()=>BsFillCloudSleetFill);
parcelHelpers.export(exports, "BsFillCloudSnowFill", ()=>BsFillCloudSnowFill);
parcelHelpers.export(exports, "BsFillCloudSunFill", ()=>BsFillCloudSunFill);
parcelHelpers.export(exports, "BsFillCloudUploadFill", ()=>BsFillCloudUploadFill);
parcelHelpers.export(exports, "BsFillCloudsFill", ()=>BsFillCloudsFill);
parcelHelpers.export(exports, "BsFillCloudyFill", ()=>BsFillCloudyFill);
parcelHelpers.export(exports, "BsFillCollectionFill", ()=>BsFillCollectionFill);
parcelHelpers.export(exports, "BsFillCollectionPlayFill", ()=>BsFillCollectionPlayFill);
parcelHelpers.export(exports, "BsFillCompassFill", ()=>BsFillCompassFill);
parcelHelpers.export(exports, "BsFillCpuFill", ()=>BsFillCpuFill);
parcelHelpers.export(exports, "BsFillCreditCard2BackFill", ()=>BsFillCreditCard2BackFill);
parcelHelpers.export(exports, "BsFillCreditCard2FrontFill", ()=>BsFillCreditCard2FrontFill);
parcelHelpers.export(exports, "BsFillCreditCardFill", ()=>BsFillCreditCardFill);
parcelHelpers.export(exports, "BsFillCupFill", ()=>BsFillCupFill);
parcelHelpers.export(exports, "BsFillCupHotFill", ()=>BsFillCupHotFill);
parcelHelpers.export(exports, "BsFillCursorFill", ()=>BsFillCursorFill);
parcelHelpers.export(exports, "BsFillDashCircleFill", ()=>BsFillDashCircleFill);
parcelHelpers.export(exports, "BsFillDashSquareFill", ()=>BsFillDashSquareFill);
parcelHelpers.export(exports, "BsFillDatabaseFill", ()=>BsFillDatabaseFill);
parcelHelpers.export(exports, "BsFillDeviceHddFill", ()=>BsFillDeviceHddFill);
parcelHelpers.export(exports, "BsFillDeviceSsdFill", ()=>BsFillDeviceSsdFill);
parcelHelpers.export(exports, "BsFillDiagram2Fill", ()=>BsFillDiagram2Fill);
parcelHelpers.export(exports, "BsFillDiagram3Fill", ()=>BsFillDiagram3Fill);
parcelHelpers.export(exports, "BsFillDiamondFill", ()=>BsFillDiamondFill);
parcelHelpers.export(exports, "BsFillDice1Fill", ()=>BsFillDice1Fill);
parcelHelpers.export(exports, "BsFillDice2Fill", ()=>BsFillDice2Fill);
parcelHelpers.export(exports, "BsFillDice3Fill", ()=>BsFillDice3Fill);
parcelHelpers.export(exports, "BsFillDice4Fill", ()=>BsFillDice4Fill);
parcelHelpers.export(exports, "BsFillDice5Fill", ()=>BsFillDice5Fill);
parcelHelpers.export(exports, "BsFillDice6Fill", ()=>BsFillDice6Fill);
parcelHelpers.export(exports, "BsFillDiscFill", ()=>BsFillDiscFill);
parcelHelpers.export(exports, "BsFillDisplayFill", ()=>BsFillDisplayFill);
parcelHelpers.export(exports, "BsFillDisplayportFill", ()=>BsFillDisplayportFill);
parcelHelpers.export(exports, "BsFillDoorClosedFill", ()=>BsFillDoorClosedFill);
parcelHelpers.export(exports, "BsFillDoorOpenFill", ()=>BsFillDoorOpenFill);
parcelHelpers.export(exports, "BsFillDpadFill", ()=>BsFillDpadFill);
parcelHelpers.export(exports, "BsFillDropletFill", ()=>BsFillDropletFill);
parcelHelpers.export(exports, "BsFillDuffleFill", ()=>BsFillDuffleFill);
parcelHelpers.export(exports, "BsFillEarFill", ()=>BsFillEarFill);
parcelHelpers.export(exports, "BsFillEaselFill", ()=>BsFillEaselFill);
parcelHelpers.export(exports, "BsFillEasel2Fill", ()=>BsFillEasel2Fill);
parcelHelpers.export(exports, "BsFillEasel3Fill", ()=>BsFillEasel3Fill);
parcelHelpers.export(exports, "BsFillEggFill", ()=>BsFillEggFill);
parcelHelpers.export(exports, "BsFillEjectFill", ()=>BsFillEjectFill);
parcelHelpers.export(exports, "BsFillEmojiAngryFill", ()=>BsFillEmojiAngryFill);
parcelHelpers.export(exports, "BsFillEmojiAstonishedFill", ()=>BsFillEmojiAstonishedFill);
parcelHelpers.export(exports, "BsFillEmojiDizzyFill", ()=>BsFillEmojiDizzyFill);
parcelHelpers.export(exports, "BsFillEmojiExpressionlessFill", ()=>BsFillEmojiExpressionlessFill);
parcelHelpers.export(exports, "BsFillEmojiFrownFill", ()=>BsFillEmojiFrownFill);
parcelHelpers.export(exports, "BsFillEmojiGrimaceFill", ()=>BsFillEmojiGrimaceFill);
parcelHelpers.export(exports, "BsFillEmojiGrinFill", ()=>BsFillEmojiGrinFill);
parcelHelpers.export(exports, "BsFillEmojiHeartEyesFill", ()=>BsFillEmojiHeartEyesFill);
parcelHelpers.export(exports, "BsFillEmojiKissFill", ()=>BsFillEmojiKissFill);
parcelHelpers.export(exports, "BsFillEmojiLaughingFill", ()=>BsFillEmojiLaughingFill);
parcelHelpers.export(exports, "BsFillEmojiNeutralFill", ()=>BsFillEmojiNeutralFill);
parcelHelpers.export(exports, "BsFillEmojiSmileFill", ()=>BsFillEmojiSmileFill);
parcelHelpers.export(exports, "BsFillEmojiSmileUpsideDownFill", ()=>BsFillEmojiSmileUpsideDownFill);
parcelHelpers.export(exports, "BsFillEmojiSunglassesFill", ()=>BsFillEmojiSunglassesFill);
parcelHelpers.export(exports, "BsFillEmojiSurpriseFill", ()=>BsFillEmojiSurpriseFill);
parcelHelpers.export(exports, "BsFillEmojiTearFill", ()=>BsFillEmojiTearFill);
parcelHelpers.export(exports, "BsFillEmojiWinkFill", ()=>BsFillEmojiWinkFill);
parcelHelpers.export(exports, "BsFillEnvelopeArrowDownFill", ()=>BsFillEnvelopeArrowDownFill);
parcelHelpers.export(exports, "BsFillEnvelopeArrowUpFill", ()=>BsFillEnvelopeArrowUpFill);
parcelHelpers.export(exports, "BsFillEnvelopeAtFill", ()=>BsFillEnvelopeAtFill);
parcelHelpers.export(exports, "BsFillEnvelopeCheckFill", ()=>BsFillEnvelopeCheckFill);
parcelHelpers.export(exports, "BsFillEnvelopeDashFill", ()=>BsFillEnvelopeDashFill);
parcelHelpers.export(exports, "BsFillEnvelopeExclamationFill", ()=>BsFillEnvelopeExclamationFill);
parcelHelpers.export(exports, "BsFillEnvelopeFill", ()=>BsFillEnvelopeFill);
parcelHelpers.export(exports, "BsFillEnvelopeHeartFill", ()=>BsFillEnvelopeHeartFill);
parcelHelpers.export(exports, "BsFillEnvelopeOpenFill", ()=>BsFillEnvelopeOpenFill);
parcelHelpers.export(exports, "BsFillEnvelopeOpenHeartFill", ()=>BsFillEnvelopeOpenHeartFill);
parcelHelpers.export(exports, "BsFillEnvelopePaperFill", ()=>BsFillEnvelopePaperFill);
parcelHelpers.export(exports, "BsFillEnvelopePaperHeartFill", ()=>BsFillEnvelopePaperHeartFill);
parcelHelpers.export(exports, "BsFillEnvelopePlusFill", ()=>BsFillEnvelopePlusFill);
parcelHelpers.export(exports, "BsFillEnvelopeSlashFill", ()=>BsFillEnvelopeSlashFill);
parcelHelpers.export(exports, "BsFillEnvelopeXFill", ()=>BsFillEnvelopeXFill);
parcelHelpers.export(exports, "BsFillEraserFill", ()=>BsFillEraserFill);
parcelHelpers.export(exports, "BsFillEvFrontFill", ()=>BsFillEvFrontFill);
parcelHelpers.export(exports, "BsFillEvStationFill", ()=>BsFillEvStationFill);
parcelHelpers.export(exports, "BsFillExclamationCircleFill", ()=>BsFillExclamationCircleFill);
parcelHelpers.export(exports, "BsFillExclamationDiamondFill", ()=>BsFillExclamationDiamondFill);
parcelHelpers.export(exports, "BsFillExclamationOctagonFill", ()=>BsFillExclamationOctagonFill);
parcelHelpers.export(exports, "BsFillExclamationSquareFill", ()=>BsFillExclamationSquareFill);
parcelHelpers.export(exports, "BsFillExclamationTriangleFill", ()=>BsFillExclamationTriangleFill);
parcelHelpers.export(exports, "BsFillExplicitFill", ()=>BsFillExplicitFill);
parcelHelpers.export(exports, "BsFillEyeFill", ()=>BsFillEyeFill);
parcelHelpers.export(exports, "BsFillEyeSlashFill", ()=>BsFillEyeSlashFill);
parcelHelpers.export(exports, "BsFillFastForwardBtnFill", ()=>BsFillFastForwardBtnFill);
parcelHelpers.export(exports, "BsFillFastForwardCircleFill", ()=>BsFillFastForwardCircleFill);
parcelHelpers.export(exports, "BsFillFastForwardFill", ()=>BsFillFastForwardFill);
parcelHelpers.export(exports, "BsFillFileArrowDownFill", ()=>BsFillFileArrowDownFill);
parcelHelpers.export(exports, "BsFillFileArrowUpFill", ()=>BsFillFileArrowUpFill);
parcelHelpers.export(exports, "BsFillFileBarGraphFill", ()=>BsFillFileBarGraphFill);
parcelHelpers.export(exports, "BsFillFileBinaryFill", ()=>BsFillFileBinaryFill);
parcelHelpers.export(exports, "BsFillFileBreakFill", ()=>BsFillFileBreakFill);
parcelHelpers.export(exports, "BsFillFileCheckFill", ()=>BsFillFileCheckFill);
parcelHelpers.export(exports, "BsFillFileCodeFill", ()=>BsFillFileCodeFill);
parcelHelpers.export(exports, "BsFillFileDiffFill", ()=>BsFillFileDiffFill);
parcelHelpers.export(exports, "BsFillFileEarmarkArrowDownFill", ()=>BsFillFileEarmarkArrowDownFill);
parcelHelpers.export(exports, "BsFillFileEarmarkArrowUpFill", ()=>BsFillFileEarmarkArrowUpFill);
parcelHelpers.export(exports, "BsFillFileEarmarkBarGraphFill", ()=>BsFillFileEarmarkBarGraphFill);
parcelHelpers.export(exports, "BsFillFileEarmarkBinaryFill", ()=>BsFillFileEarmarkBinaryFill);
parcelHelpers.export(exports, "BsFillFileEarmarkBreakFill", ()=>BsFillFileEarmarkBreakFill);
parcelHelpers.export(exports, "BsFillFileEarmarkCheckFill", ()=>BsFillFileEarmarkCheckFill);
parcelHelpers.export(exports, "BsFillFileEarmarkCodeFill", ()=>BsFillFileEarmarkCodeFill);
parcelHelpers.export(exports, "BsFillFileEarmarkDiffFill", ()=>BsFillFileEarmarkDiffFill);
parcelHelpers.export(exports, "BsFillFileEarmarkEaselFill", ()=>BsFillFileEarmarkEaselFill);
parcelHelpers.export(exports, "BsFillFileEarmarkExcelFill", ()=>BsFillFileEarmarkExcelFill);
parcelHelpers.export(exports, "BsFillFileEarmarkFill", ()=>BsFillFileEarmarkFill);
parcelHelpers.export(exports, "BsFillFileEarmarkFontFill", ()=>BsFillFileEarmarkFontFill);
parcelHelpers.export(exports, "BsFillFileEarmarkImageFill", ()=>BsFillFileEarmarkImageFill);
parcelHelpers.export(exports, "BsFillFileEarmarkLockFill", ()=>BsFillFileEarmarkLockFill);
parcelHelpers.export(exports, "BsFillFileEarmarkLock2Fill", ()=>BsFillFileEarmarkLock2Fill);
parcelHelpers.export(exports, "BsFillFileEarmarkMedicalFill", ()=>BsFillFileEarmarkMedicalFill);
parcelHelpers.export(exports, "BsFillFileEarmarkMinusFill", ()=>BsFillFileEarmarkMinusFill);
parcelHelpers.export(exports, "BsFillFileEarmarkMusicFill", ()=>BsFillFileEarmarkMusicFill);
parcelHelpers.export(exports, "BsFillFileEarmarkPdfFill", ()=>BsFillFileEarmarkPdfFill);
parcelHelpers.export(exports, "BsFillFileEarmarkPersonFill", ()=>BsFillFileEarmarkPersonFill);
parcelHelpers.export(exports, "BsFillFileEarmarkPlayFill", ()=>BsFillFileEarmarkPlayFill);
parcelHelpers.export(exports, "BsFillFileEarmarkPlusFill", ()=>BsFillFileEarmarkPlusFill);
parcelHelpers.export(exports, "BsFillFileEarmarkPostFill", ()=>BsFillFileEarmarkPostFill);
parcelHelpers.export(exports, "BsFillFileEarmarkPptFill", ()=>BsFillFileEarmarkPptFill);
parcelHelpers.export(exports, "BsFillFileEarmarkRichtextFill", ()=>BsFillFileEarmarkRichtextFill);
parcelHelpers.export(exports, "BsFillFileEarmarkRuledFill", ()=>BsFillFileEarmarkRuledFill);
parcelHelpers.export(exports, "BsFillFileEarmarkSlidesFill", ()=>BsFillFileEarmarkSlidesFill);
parcelHelpers.export(exports, "BsFillFileEarmarkSpreadsheetFill", ()=>BsFillFileEarmarkSpreadsheetFill);
parcelHelpers.export(exports, "BsFillFileEarmarkTextFill", ()=>BsFillFileEarmarkTextFill);
parcelHelpers.export(exports, "BsFillFileEarmarkWordFill", ()=>BsFillFileEarmarkWordFill);
parcelHelpers.export(exports, "BsFillFileEarmarkXFill", ()=>BsFillFileEarmarkXFill);
parcelHelpers.export(exports, "BsFillFileEarmarkZipFill", ()=>BsFillFileEarmarkZipFill);
parcelHelpers.export(exports, "BsFillFileEaselFill", ()=>BsFillFileEaselFill);
parcelHelpers.export(exports, "BsFillFileExcelFill", ()=>BsFillFileExcelFill);
parcelHelpers.export(exports, "BsFillFileFill", ()=>BsFillFileFill);
parcelHelpers.export(exports, "BsFillFileFontFill", ()=>BsFillFileFontFill);
parcelHelpers.export(exports, "BsFillFileImageFill", ()=>BsFillFileImageFill);
parcelHelpers.export(exports, "BsFillFileLockFill", ()=>BsFillFileLockFill);
parcelHelpers.export(exports, "BsFillFileLock2Fill", ()=>BsFillFileLock2Fill);
parcelHelpers.export(exports, "BsFillFileMedicalFill", ()=>BsFillFileMedicalFill);
parcelHelpers.export(exports, "BsFillFileMinusFill", ()=>BsFillFileMinusFill);
parcelHelpers.export(exports, "BsFillFileMusicFill", ()=>BsFillFileMusicFill);
parcelHelpers.export(exports, "BsFillFilePdfFill", ()=>BsFillFilePdfFill);
parcelHelpers.export(exports, "BsFillFilePersonFill", ()=>BsFillFilePersonFill);
parcelHelpers.export(exports, "BsFillFilePlayFill", ()=>BsFillFilePlayFill);
parcelHelpers.export(exports, "BsFillFilePlusFill", ()=>BsFillFilePlusFill);
parcelHelpers.export(exports, "BsFillFilePostFill", ()=>BsFillFilePostFill);
parcelHelpers.export(exports, "BsFillFilePptFill", ()=>BsFillFilePptFill);
parcelHelpers.export(exports, "BsFillFileRichtextFill", ()=>BsFillFileRichtextFill);
parcelHelpers.export(exports, "BsFillFileRuledFill", ()=>BsFillFileRuledFill);
parcelHelpers.export(exports, "BsFillFileSlidesFill", ()=>BsFillFileSlidesFill);
parcelHelpers.export(exports, "BsFillFileSpreadsheetFill", ()=>BsFillFileSpreadsheetFill);
parcelHelpers.export(exports, "BsFillFileTextFill", ()=>BsFillFileTextFill);
parcelHelpers.export(exports, "BsFillFileWordFill", ()=>BsFillFileWordFill);
parcelHelpers.export(exports, "BsFillFileXFill", ()=>BsFillFileXFill);
parcelHelpers.export(exports, "BsFillFileZipFill", ()=>BsFillFileZipFill);
parcelHelpers.export(exports, "BsFillFilterCircleFill", ()=>BsFillFilterCircleFill);
parcelHelpers.export(exports, "BsFillFilterSquareFill", ()=>BsFillFilterSquareFill);
parcelHelpers.export(exports, "BsFillFlagFill", ()=>BsFillFlagFill);
parcelHelpers.export(exports, "BsFillFloppyFill", ()=>BsFillFloppyFill);
parcelHelpers.export(exports, "BsFillFloppy2Fill", ()=>BsFillFloppy2Fill);
parcelHelpers.export(exports, "BsFillFolderFill", ()=>BsFillFolderFill);
parcelHelpers.export(exports, "BsFillFolderSymlinkFill", ()=>BsFillFolderSymlinkFill);
parcelHelpers.export(exports, "BsFillForwardFill", ()=>BsFillForwardFill);
parcelHelpers.export(exports, "BsFillFuelPumpDieselFill", ()=>BsFillFuelPumpDieselFill);
parcelHelpers.export(exports, "BsFillFuelPumpFill", ()=>BsFillFuelPumpFill);
parcelHelpers.export(exports, "BsFillFunnelFill", ()=>BsFillFunnelFill);
parcelHelpers.export(exports, "BsFillGearFill", ()=>BsFillGearFill);
parcelHelpers.export(exports, "BsFillGeoAltFill", ()=>BsFillGeoAltFill);
parcelHelpers.export(exports, "BsFillGeoFill", ()=>BsFillGeoFill);
parcelHelpers.export(exports, "BsFillGiftFill", ()=>BsFillGiftFill);
parcelHelpers.export(exports, "BsFillGrid1X2Fill", ()=>BsFillGrid1X2Fill);
parcelHelpers.export(exports, "BsFillGrid3X2GapFill", ()=>BsFillGrid3X2GapFill);
parcelHelpers.export(exports, "BsFillGrid3X3GapFill", ()=>BsFillGrid3X3GapFill);
parcelHelpers.export(exports, "BsFillGridFill", ()=>BsFillGridFill);
parcelHelpers.export(exports, "BsFillHCircleFill", ()=>BsFillHCircleFill);
parcelHelpers.export(exports, "BsFillHSquareFill", ()=>BsFillHSquareFill);
parcelHelpers.export(exports, "BsFillHandIndexFill", ()=>BsFillHandIndexFill);
parcelHelpers.export(exports, "BsFillHandIndexThumbFill", ()=>BsFillHandIndexThumbFill);
parcelHelpers.export(exports, "BsFillHandThumbsDownFill", ()=>BsFillHandThumbsDownFill);
parcelHelpers.export(exports, "BsFillHandThumbsUpFill", ()=>BsFillHandThumbsUpFill);
parcelHelpers.export(exports, "BsFillHandbagFill", ()=>BsFillHandbagFill);
parcelHelpers.export(exports, "BsFillHddFill", ()=>BsFillHddFill);
parcelHelpers.export(exports, "BsFillHddNetworkFill", ()=>BsFillHddNetworkFill);
parcelHelpers.export(exports, "BsFillHddRackFill", ()=>BsFillHddRackFill);
parcelHelpers.export(exports, "BsFillHddStackFill", ()=>BsFillHddStackFill);
parcelHelpers.export(exports, "BsFillHdmiFill", ()=>BsFillHdmiFill);
parcelHelpers.export(exports, "BsFillHeartFill", ()=>BsFillHeartFill);
parcelHelpers.export(exports, "BsFillHeartPulseFill", ()=>BsFillHeartPulseFill);
parcelHelpers.export(exports, "BsFillHeartbreakFill", ()=>BsFillHeartbreakFill);
parcelHelpers.export(exports, "BsFillHeptagonFill", ()=>BsFillHeptagonFill);
parcelHelpers.export(exports, "BsFillHexagonFill", ()=>BsFillHexagonFill);
parcelHelpers.export(exports, "BsFillHospitalFill", ()=>BsFillHospitalFill);
parcelHelpers.export(exports, "BsFillHouseAddFill", ()=>BsFillHouseAddFill);
parcelHelpers.export(exports, "BsFillHouseCheckFill", ()=>BsFillHouseCheckFill);
parcelHelpers.export(exports, "BsFillHouseDashFill", ()=>BsFillHouseDashFill);
parcelHelpers.export(exports, "BsFillHouseDoorFill", ()=>BsFillHouseDoorFill);
parcelHelpers.export(exports, "BsFillHouseDownFill", ()=>BsFillHouseDownFill);
parcelHelpers.export(exports, "BsFillHouseExclamationFill", ()=>BsFillHouseExclamationFill);
parcelHelpers.export(exports, "BsFillHouseFill", ()=>BsFillHouseFill);
parcelHelpers.export(exports, "BsFillHouseGearFill", ()=>BsFillHouseGearFill);
parcelHelpers.export(exports, "BsFillHouseHeartFill", ()=>BsFillHouseHeartFill);
parcelHelpers.export(exports, "BsFillHouseLockFill", ()=>BsFillHouseLockFill);
parcelHelpers.export(exports, "BsFillHouseSlashFill", ()=>BsFillHouseSlashFill);
parcelHelpers.export(exports, "BsFillHouseUpFill", ()=>BsFillHouseUpFill);
parcelHelpers.export(exports, "BsFillHouseXFill", ()=>BsFillHouseXFill);
parcelHelpers.export(exports, "BsFillHousesFill", ()=>BsFillHousesFill);
parcelHelpers.export(exports, "BsFillImageFill", ()=>BsFillImageFill);
parcelHelpers.export(exports, "BsFillInboxFill", ()=>BsFillInboxFill);
parcelHelpers.export(exports, "BsFillInboxesFill", ()=>BsFillInboxesFill);
parcelHelpers.export(exports, "BsFillInfoCircleFill", ()=>BsFillInfoCircleFill);
parcelHelpers.export(exports, "BsFillInfoSquareFill", ()=>BsFillInfoSquareFill);
parcelHelpers.export(exports, "BsFillJournalBookmarkFill", ()=>BsFillJournalBookmarkFill);
parcelHelpers.export(exports, "BsFillKanbanFill", ()=>BsFillKanbanFill);
parcelHelpers.export(exports, "BsFillKeyFill", ()=>BsFillKeyFill);
parcelHelpers.export(exports, "BsFillKeyboardFill", ()=>BsFillKeyboardFill);
parcelHelpers.export(exports, "BsFillLampFill", ()=>BsFillLampFill);
parcelHelpers.export(exports, "BsFillLaptopFill", ()=>BsFillLaptopFill);
parcelHelpers.export(exports, "BsFillLayersFill", ()=>BsFillLayersFill);
parcelHelpers.export(exports, "BsFillLightbulbFill", ()=>BsFillLightbulbFill);
parcelHelpers.export(exports, "BsFillLightbulbOffFill", ()=>BsFillLightbulbOffFill);
parcelHelpers.export(exports, "BsFillLightningChargeFill", ()=>BsFillLightningChargeFill);
parcelHelpers.export(exports, "BsFillLightningFill", ()=>BsFillLightningFill);
parcelHelpers.export(exports, "BsFillLockFill", ()=>BsFillLockFill);
parcelHelpers.export(exports, "BsFillLuggageFill", ()=>BsFillLuggageFill);
parcelHelpers.export(exports, "BsFillLungsFill", ()=>BsFillLungsFill);
parcelHelpers.export(exports, "BsFillMagnetFill", ()=>BsFillMagnetFill);
parcelHelpers.export(exports, "BsFillMapFill", ()=>BsFillMapFill);
parcelHelpers.export(exports, "BsFillMarkdownFill", ()=>BsFillMarkdownFill);
parcelHelpers.export(exports, "BsFillMegaphoneFill", ()=>BsFillMegaphoneFill);
parcelHelpers.export(exports, "BsFillMenuAppFill", ()=>BsFillMenuAppFill);
parcelHelpers.export(exports, "BsFillMenuButtonFill", ()=>BsFillMenuButtonFill);
parcelHelpers.export(exports, "BsFillMenuButtonWideFill", ()=>BsFillMenuButtonWideFill);
parcelHelpers.export(exports, "BsFillMicFill", ()=>BsFillMicFill);
parcelHelpers.export(exports, "BsFillMicMuteFill", ()=>BsFillMicMuteFill);
parcelHelpers.export(exports, "BsFillModemFill", ()=>BsFillModemFill);
parcelHelpers.export(exports, "BsFillMoonFill", ()=>BsFillMoonFill);
parcelHelpers.export(exports, "BsFillMoonStarsFill", ()=>BsFillMoonStarsFill);
parcelHelpers.export(exports, "BsFillMortarboardFill", ()=>BsFillMortarboardFill);
parcelHelpers.export(exports, "BsFillMotherboardFill", ()=>BsFillMotherboardFill);
parcelHelpers.export(exports, "BsFillMouseFill", ()=>BsFillMouseFill);
parcelHelpers.export(exports, "BsFillMouse2Fill", ()=>BsFillMouse2Fill);
parcelHelpers.export(exports, "BsFillMouse3Fill", ()=>BsFillMouse3Fill);
parcelHelpers.export(exports, "BsFillMusicPlayerFill", ()=>BsFillMusicPlayerFill);
parcelHelpers.export(exports, "BsFillNodeMinusFill", ()=>BsFillNodeMinusFill);
parcelHelpers.export(exports, "BsFillNodePlusFill", ()=>BsFillNodePlusFill);
parcelHelpers.export(exports, "BsFillNutFill", ()=>BsFillNutFill);
parcelHelpers.export(exports, "BsFillNvmeFill", ()=>BsFillNvmeFill);
parcelHelpers.export(exports, "BsFillOctagonFill", ()=>BsFillOctagonFill);
parcelHelpers.export(exports, "BsFillOpticalAudioFill", ()=>BsFillOpticalAudioFill);
parcelHelpers.export(exports, "BsFillPCircleFill", ()=>BsFillPCircleFill);
parcelHelpers.export(exports, "BsFillPSquareFill", ()=>BsFillPSquareFill);
parcelHelpers.export(exports, "BsFillPaletteFill", ()=>BsFillPaletteFill);
parcelHelpers.export(exports, "BsFillPassFill", ()=>BsFillPassFill);
parcelHelpers.export(exports, "BsFillPassportFill", ()=>BsFillPassportFill);
parcelHelpers.export(exports, "BsFillPatchCheckFill", ()=>BsFillPatchCheckFill);
parcelHelpers.export(exports, "BsFillPatchExclamationFill", ()=>BsFillPatchExclamationFill);
parcelHelpers.export(exports, "BsFillPatchMinusFill", ()=>BsFillPatchMinusFill);
parcelHelpers.export(exports, "BsFillPatchPlusFill", ()=>BsFillPatchPlusFill);
parcelHelpers.export(exports, "BsFillPatchQuestionFill", ()=>BsFillPatchQuestionFill);
parcelHelpers.export(exports, "BsFillPauseBtnFill", ()=>BsFillPauseBtnFill);
parcelHelpers.export(exports, "BsFillPauseCircleFill", ()=>BsFillPauseCircleFill);
parcelHelpers.export(exports, "BsFillPauseFill", ()=>BsFillPauseFill);
parcelHelpers.export(exports, "BsFillPeaceFill", ()=>BsFillPeaceFill);
parcelHelpers.export(exports, "BsFillPenFill", ()=>BsFillPenFill);
parcelHelpers.export(exports, "BsFillPencilFill", ()=>BsFillPencilFill);
parcelHelpers.export(exports, "BsFillPentagonFill", ()=>BsFillPentagonFill);
parcelHelpers.export(exports, "BsFillPeopleFill", ()=>BsFillPeopleFill);
parcelHelpers.export(exports, "BsFillPersonBadgeFill", ()=>BsFillPersonBadgeFill);
parcelHelpers.export(exports, "BsFillPersonCheckFill", ()=>BsFillPersonCheckFill);
parcelHelpers.export(exports, "BsFillPersonDashFill", ()=>BsFillPersonDashFill);
parcelHelpers.export(exports, "BsFillPersonFill", ()=>BsFillPersonFill);
parcelHelpers.export(exports, "BsFillPersonLinesFill", ()=>BsFillPersonLinesFill);
parcelHelpers.export(exports, "BsFillPersonPlusFill", ()=>BsFillPersonPlusFill);
parcelHelpers.export(exports, "BsFillPersonVcardFill", ()=>BsFillPersonVcardFill);
parcelHelpers.export(exports, "BsFillPersonXFill", ()=>BsFillPersonXFill);
parcelHelpers.export(exports, "BsFillPhoneFill", ()=>BsFillPhoneFill);
parcelHelpers.export(exports, "BsFillPhoneLandscapeFill", ()=>BsFillPhoneLandscapeFill);
parcelHelpers.export(exports, "BsFillPhoneVibrateFill", ()=>BsFillPhoneVibrateFill);
parcelHelpers.export(exports, "BsFillPieChartFill", ()=>BsFillPieChartFill);
parcelHelpers.export(exports, "BsFillPiggyBankFill", ()=>BsFillPiggyBankFill);
parcelHelpers.export(exports, "BsFillPinAngleFill", ()=>BsFillPinAngleFill);
parcelHelpers.export(exports, "BsFillPinFill", ()=>BsFillPinFill);
parcelHelpers.export(exports, "BsFillPinMapFill", ()=>BsFillPinMapFill);
parcelHelpers.export(exports, "BsFillPipFill", ()=>BsFillPipFill);
parcelHelpers.export(exports, "BsFillPlayBtnFill", ()=>BsFillPlayBtnFill);
parcelHelpers.export(exports, "BsFillPlayCircleFill", ()=>BsFillPlayCircleFill);
parcelHelpers.export(exports, "BsFillPlayFill", ()=>BsFillPlayFill);
parcelHelpers.export(exports, "BsFillPlugFill", ()=>BsFillPlugFill);
parcelHelpers.export(exports, "BsFillPlusCircleFill", ()=>BsFillPlusCircleFill);
parcelHelpers.export(exports, "BsFillPlusSquareFill", ()=>BsFillPlusSquareFill);
parcelHelpers.export(exports, "BsFillPostageFill", ()=>BsFillPostageFill);
parcelHelpers.export(exports, "BsFillPostageHeartFill", ()=>BsFillPostageHeartFill);
parcelHelpers.export(exports, "BsFillPostcardFill", ()=>BsFillPostcardFill);
parcelHelpers.export(exports, "BsFillPostcardHeartFill", ()=>BsFillPostcardHeartFill);
parcelHelpers.export(exports, "BsFillPrinterFill", ()=>BsFillPrinterFill);
parcelHelpers.export(exports, "BsFillProjectorFill", ()=>BsFillProjectorFill);
parcelHelpers.export(exports, "BsFillPuzzleFill", ()=>BsFillPuzzleFill);
parcelHelpers.export(exports, "BsFillQuestionCircleFill", ()=>BsFillQuestionCircleFill);
parcelHelpers.export(exports, "BsFillQuestionDiamondFill", ()=>BsFillQuestionDiamondFill);
parcelHelpers.export(exports, "BsFillQuestionOctagonFill", ()=>BsFillQuestionOctagonFill);
parcelHelpers.export(exports, "BsFillQuestionSquareFill", ()=>BsFillQuestionSquareFill);
parcelHelpers.export(exports, "BsFillRCircleFill", ()=>BsFillRCircleFill);
parcelHelpers.export(exports, "BsFillRSquareFill", ()=>BsFillRSquareFill);
parcelHelpers.export(exports, "BsFillRecordBtnFill", ()=>BsFillRecordBtnFill);
parcelHelpers.export(exports, "BsFillRecordCircleFill", ()=>BsFillRecordCircleFill);
parcelHelpers.export(exports, "BsFillRecordFill", ()=>BsFillRecordFill);
parcelHelpers.export(exports, "BsFillRecord2Fill", ()=>BsFillRecord2Fill);
parcelHelpers.export(exports, "BsFillReplyAllFill", ()=>BsFillReplyAllFill);
parcelHelpers.export(exports, "BsFillReplyFill", ()=>BsFillReplyFill);
parcelHelpers.export(exports, "BsFillRewindBtnFill", ()=>BsFillRewindBtnFill);
parcelHelpers.export(exports, "BsFillRewindCircleFill", ()=>BsFillRewindCircleFill);
parcelHelpers.export(exports, "BsFillRewindFill", ()=>BsFillRewindFill);
parcelHelpers.export(exports, "BsFillRocketFill", ()=>BsFillRocketFill);
parcelHelpers.export(exports, "BsFillRocketTakeoffFill", ()=>BsFillRocketTakeoffFill);
parcelHelpers.export(exports, "BsFillRouterFill", ()=>BsFillRouterFill);
parcelHelpers.export(exports, "BsFillRssFill", ()=>BsFillRssFill);
parcelHelpers.export(exports, "BsFillSafeFill", ()=>BsFillSafeFill);
parcelHelpers.export(exports, "BsFillSafe2Fill", ()=>BsFillSafe2Fill);
parcelHelpers.export(exports, "BsFillSaveFill", ()=>BsFillSaveFill);
parcelHelpers.export(exports, "BsFillSave2Fill", ()=>BsFillSave2Fill);
parcelHelpers.export(exports, "BsFillSdCardFill", ()=>BsFillSdCardFill);
parcelHelpers.export(exports, "BsFillSearchHeartFill", ()=>BsFillSearchHeartFill);
parcelHelpers.export(exports, "BsFillSendArrowDownFill", ()=>BsFillSendArrowDownFill);
parcelHelpers.export(exports, "BsFillSendArrowUpFill", ()=>BsFillSendArrowUpFill);
parcelHelpers.export(exports, "BsFillSendCheckFill", ()=>BsFillSendCheckFill);
parcelHelpers.export(exports, "BsFillSendDashFill", ()=>BsFillSendDashFill);
parcelHelpers.export(exports, "BsFillSendExclamationFill", ()=>BsFillSendExclamationFill);
parcelHelpers.export(exports, "BsFillSendFill", ()=>BsFillSendFill);
parcelHelpers.export(exports, "BsFillSendPlusFill", ()=>BsFillSendPlusFill);
parcelHelpers.export(exports, "BsFillSendSlashFill", ()=>BsFillSendSlashFill);
parcelHelpers.export(exports, "BsFillSendXFill", ()=>BsFillSendXFill);
parcelHelpers.export(exports, "BsFillShareFill", ()=>BsFillShareFill);
parcelHelpers.export(exports, "BsFillShieldFill", ()=>BsFillShieldFill);
parcelHelpers.export(exports, "BsFillShieldLockFill", ()=>BsFillShieldLockFill);
parcelHelpers.export(exports, "BsFillShieldSlashFill", ()=>BsFillShieldSlashFill);
parcelHelpers.export(exports, "BsFillShiftFill", ()=>BsFillShiftFill);
parcelHelpers.export(exports, "BsFillSignDeadEndFill", ()=>BsFillSignDeadEndFill);
parcelHelpers.export(exports, "BsFillSignDoNotEnterFill", ()=>BsFillSignDoNotEnterFill);
parcelHelpers.export(exports, "BsFillSignIntersectionFill", ()=>BsFillSignIntersectionFill);
parcelHelpers.export(exports, "BsFillSignIntersectionSideFill", ()=>BsFillSignIntersectionSideFill);
parcelHelpers.export(exports, "BsFillSignIntersectionTFill", ()=>BsFillSignIntersectionTFill);
parcelHelpers.export(exports, "BsFillSignIntersectionYFill", ()=>BsFillSignIntersectionYFill);
parcelHelpers.export(exports, "BsFillSignMergeLeftFill", ()=>BsFillSignMergeLeftFill);
parcelHelpers.export(exports, "BsFillSignMergeRightFill", ()=>BsFillSignMergeRightFill);
parcelHelpers.export(exports, "BsFillSignNoLeftTurnFill", ()=>BsFillSignNoLeftTurnFill);
parcelHelpers.export(exports, "BsFillSignNoParkingFill", ()=>BsFillSignNoParkingFill);
parcelHelpers.export(exports, "BsFillSignNoRightTurnFill", ()=>BsFillSignNoRightTurnFill);
parcelHelpers.export(exports, "BsFillSignRailroadFill", ()=>BsFillSignRailroadFill);
parcelHelpers.export(exports, "BsFillSignStopFill", ()=>BsFillSignStopFill);
parcelHelpers.export(exports, "BsFillSignStopLightsFill", ()=>BsFillSignStopLightsFill);
parcelHelpers.export(exports, "BsFillSignTurnLeftFill", ()=>BsFillSignTurnLeftFill);
parcelHelpers.export(exports, "BsFillSignTurnRightFill", ()=>BsFillSignTurnRightFill);
parcelHelpers.export(exports, "BsFillSignTurnSlightLeftFill", ()=>BsFillSignTurnSlightLeftFill);
parcelHelpers.export(exports, "BsFillSignTurnSlightRightFill", ()=>BsFillSignTurnSlightRightFill);
parcelHelpers.export(exports, "BsFillSignYieldFill", ()=>BsFillSignYieldFill);
parcelHelpers.export(exports, "BsFillSignpost2Fill", ()=>BsFillSignpost2Fill);
parcelHelpers.export(exports, "BsFillSignpostFill", ()=>BsFillSignpostFill);
parcelHelpers.export(exports, "BsFillSignpostSplitFill", ()=>BsFillSignpostSplitFill);
parcelHelpers.export(exports, "BsFillSimFill", ()=>BsFillSimFill);
parcelHelpers.export(exports, "BsFillSimSlashFill", ()=>BsFillSimSlashFill);
parcelHelpers.export(exports, "BsFillSkipBackwardBtnFill", ()=>BsFillSkipBackwardBtnFill);
parcelHelpers.export(exports, "BsFillSkipBackwardCircleFill", ()=>BsFillSkipBackwardCircleFill);
parcelHelpers.export(exports, "BsFillSkipBackwardFill", ()=>BsFillSkipBackwardFill);
parcelHelpers.export(exports, "BsFillSkipEndBtnFill", ()=>BsFillSkipEndBtnFill);
parcelHelpers.export(exports, "BsFillSkipEndCircleFill", ()=>BsFillSkipEndCircleFill);
parcelHelpers.export(exports, "BsFillSkipEndFill", ()=>BsFillSkipEndFill);
parcelHelpers.export(exports, "BsFillSkipForwardBtnFill", ()=>BsFillSkipForwardBtnFill);
parcelHelpers.export(exports, "BsFillSkipForwardCircleFill", ()=>BsFillSkipForwardCircleFill);
parcelHelpers.export(exports, "BsFillSkipForwardFill", ()=>BsFillSkipForwardFill);
parcelHelpers.export(exports, "BsFillSkipStartBtnFill", ()=>BsFillSkipStartBtnFill);
parcelHelpers.export(exports, "BsFillSkipStartCircleFill", ()=>BsFillSkipStartCircleFill);
parcelHelpers.export(exports, "BsFillSkipStartFill", ()=>BsFillSkipStartFill);
parcelHelpers.export(exports, "BsFillSlashCircleFill", ()=>BsFillSlashCircleFill);
parcelHelpers.export(exports, "BsFillSlashSquareFill", ()=>BsFillSlashSquareFill);
parcelHelpers.export(exports, "BsFillSpeakerFill", ()=>BsFillSpeakerFill);
parcelHelpers.export(exports, "BsFillSquareFill", ()=>BsFillSquareFill);
parcelHelpers.export(exports, "BsFillStarFill", ()=>BsFillStarFill);
parcelHelpers.export(exports, "BsFillStickiesFill", ()=>BsFillStickiesFill);
parcelHelpers.export(exports, "BsFillStickyFill", ()=>BsFillStickyFill);
parcelHelpers.export(exports, "BsFillStopBtnFill", ()=>BsFillStopBtnFill);
parcelHelpers.export(exports, "BsFillStopCircleFill", ()=>BsFillStopCircleFill);
parcelHelpers.export(exports, "BsFillStopFill", ()=>BsFillStopFill);
parcelHelpers.export(exports, "BsFillStoplightsFill", ()=>BsFillStoplightsFill);
parcelHelpers.export(exports, "BsFillStopwatchFill", ()=>BsFillStopwatchFill);
parcelHelpers.export(exports, "BsFillSuitClubFill", ()=>BsFillSuitClubFill);
parcelHelpers.export(exports, "BsFillSuitDiamondFill", ()=>BsFillSuitDiamondFill);
parcelHelpers.export(exports, "BsFillSuitHeartFill", ()=>BsFillSuitHeartFill);
parcelHelpers.export(exports, "BsFillSuitSpadeFill", ()=>BsFillSuitSpadeFill);
parcelHelpers.export(exports, "BsFillSuitcaseFill", ()=>BsFillSuitcaseFill);
parcelHelpers.export(exports, "BsFillSuitcaseLgFill", ()=>BsFillSuitcaseLgFill);
parcelHelpers.export(exports, "BsFillSuitcase2Fill", ()=>BsFillSuitcase2Fill);
parcelHelpers.export(exports, "BsFillSunFill", ()=>BsFillSunFill);
parcelHelpers.export(exports, "BsFillSunriseFill", ()=>BsFillSunriseFill);
parcelHelpers.export(exports, "BsFillSunsetFill", ()=>BsFillSunsetFill);
parcelHelpers.export(exports, "BsFillTabletFill", ()=>BsFillTabletFill);
parcelHelpers.export(exports, "BsFillTabletLandscapeFill", ()=>BsFillTabletLandscapeFill);
parcelHelpers.export(exports, "BsFillTagFill", ()=>BsFillTagFill);
parcelHelpers.export(exports, "BsFillTagsFill", ()=>BsFillTagsFill);
parcelHelpers.export(exports, "BsFillTaxiFrontFill", ()=>BsFillTaxiFrontFill);
parcelHelpers.export(exports, "BsFillTelephoneFill", ()=>BsFillTelephoneFill);
parcelHelpers.export(exports, "BsFillTelephoneForwardFill", ()=>BsFillTelephoneForwardFill);
parcelHelpers.export(exports, "BsFillTelephoneInboundFill", ()=>BsFillTelephoneInboundFill);
parcelHelpers.export(exports, "BsFillTelephoneMinusFill", ()=>BsFillTelephoneMinusFill);
parcelHelpers.export(exports, "BsFillTelephoneOutboundFill", ()=>BsFillTelephoneOutboundFill);
parcelHelpers.export(exports, "BsFillTelephonePlusFill", ()=>BsFillTelephonePlusFill);
parcelHelpers.export(exports, "BsFillTelephoneXFill", ()=>BsFillTelephoneXFill);
parcelHelpers.export(exports, "BsFillTerminalFill", ()=>BsFillTerminalFill);
parcelHelpers.export(exports, "BsFillThreadsFill", ()=>BsFillThreadsFill);
parcelHelpers.export(exports, "BsFillThunderboltFill", ()=>BsFillThunderboltFill);
parcelHelpers.export(exports, "BsFillTicketDetailedFill", ()=>BsFillTicketDetailedFill);
parcelHelpers.export(exports, "BsFillTicketFill", ()=>BsFillTicketFill);
parcelHelpers.export(exports, "BsFillTicketPerforatedFill", ()=>BsFillTicketPerforatedFill);
parcelHelpers.export(exports, "BsFillTrainFreightFrontFill", ()=>BsFillTrainFreightFrontFill);
parcelHelpers.export(exports, "BsFillTrainFrontFill", ()=>BsFillTrainFrontFill);
parcelHelpers.export(exports, "BsFillTrainLightrailFrontFill", ()=>BsFillTrainLightrailFrontFill);
parcelHelpers.export(exports, "BsFillTrashFill", ()=>BsFillTrashFill);
parcelHelpers.export(exports, "BsFillTrash2Fill", ()=>BsFillTrash2Fill);
parcelHelpers.export(exports, "BsFillTrash3Fill", ()=>BsFillTrash3Fill);
parcelHelpers.export(exports, "BsFillTreeFill", ()=>BsFillTreeFill);
parcelHelpers.export(exports, "BsFillTriangleFill", ()=>BsFillTriangleFill);
parcelHelpers.export(exports, "BsFillTrophyFill", ()=>BsFillTrophyFill);
parcelHelpers.export(exports, "BsFillTruckFrontFill", ()=>BsFillTruckFrontFill);
parcelHelpers.export(exports, "BsFillTvFill", ()=>BsFillTvFill);
parcelHelpers.export(exports, "BsFillUmbrellaFill", ()=>BsFillUmbrellaFill);
parcelHelpers.export(exports, "BsFillUnlockFill", ()=>BsFillUnlockFill);
parcelHelpers.export(exports, "BsFillUsbCFill", ()=>BsFillUsbCFill);
parcelHelpers.export(exports, "BsFillUsbDriveFill", ()=>BsFillUsbDriveFill);
parcelHelpers.export(exports, "BsFillUsbFill", ()=>BsFillUsbFill);
parcelHelpers.export(exports, "BsFillUsbMicroFill", ()=>BsFillUsbMicroFill);
parcelHelpers.export(exports, "BsFillUsbMiniFill", ()=>BsFillUsbMiniFill);
parcelHelpers.export(exports, "BsFillUsbPlugFill", ()=>BsFillUsbPlugFill);
parcelHelpers.export(exports, "BsFillVinylFill", ()=>BsFillVinylFill);
parcelHelpers.export(exports, "BsFillVolumeDownFill", ()=>BsFillVolumeDownFill);
parcelHelpers.export(exports, "BsFillVolumeMuteFill", ()=>BsFillVolumeMuteFill);
parcelHelpers.export(exports, "BsFillVolumeOffFill", ()=>BsFillVolumeOffFill);
parcelHelpers.export(exports, "BsFillVolumeUpFill", ()=>BsFillVolumeUpFill);
parcelHelpers.export(exports, "BsFillWalletFill", ()=>BsFillWalletFill);
parcelHelpers.export(exports, "BsFillWebcamFill", ()=>BsFillWebcamFill);
parcelHelpers.export(exports, "BsFillWrenchAdjustableCircleFill", ()=>BsFillWrenchAdjustableCircleFill);
parcelHelpers.export(exports, "BsFillXCircleFill", ()=>BsFillXCircleFill);
parcelHelpers.export(exports, "BsFillXDiamondFill", ()=>BsFillXDiamondFill);
parcelHelpers.export(exports, "BsFillXOctagonFill", ()=>BsFillXOctagonFill);
parcelHelpers.export(exports, "BsFillXSquareFill", ()=>BsFillXSquareFill);
parcelHelpers.export(exports, "BsReverseBackspaceReverse", ()=>BsReverseBackspaceReverse);
parcelHelpers.export(exports, "BsReverseLayoutSidebarInsetReverse", ()=>BsReverseLayoutSidebarInsetReverse);
parcelHelpers.export(exports, "BsReverseLayoutSidebarReverse", ()=>BsReverseLayoutSidebarReverse);
parcelHelpers.export(exports, "BsReverseLayoutTextSidebarReverse", ()=>BsReverseLayoutTextSidebarReverse);
parcelHelpers.export(exports, "BsReverseLayoutTextWindowReverse", ()=>BsReverseLayoutTextWindowReverse);
parcelHelpers.export(exports, "BsReverseListColumnsReverse", ()=>BsReverseListColumnsReverse);
parcelHelpers.export(exports, "Bs0CircleFill", ()=>Bs0CircleFill);
parcelHelpers.export(exports, "Bs0Circle", ()=>Bs0Circle);
parcelHelpers.export(exports, "Bs0SquareFill", ()=>Bs0SquareFill);
parcelHelpers.export(exports, "Bs0Square", ()=>Bs0Square);
parcelHelpers.export(exports, "Bs1CircleFill", ()=>Bs1CircleFill);
parcelHelpers.export(exports, "Bs1Circle", ()=>Bs1Circle);
parcelHelpers.export(exports, "Bs1SquareFill", ()=>Bs1SquareFill);
parcelHelpers.export(exports, "Bs1Square", ()=>Bs1Square);
parcelHelpers.export(exports, "Bs123", ()=>Bs123);
parcelHelpers.export(exports, "Bs2CircleFill", ()=>Bs2CircleFill);
parcelHelpers.export(exports, "Bs2Circle", ()=>Bs2Circle);
parcelHelpers.export(exports, "Bs2SquareFill", ()=>Bs2SquareFill);
parcelHelpers.export(exports, "Bs2Square", ()=>Bs2Square);
parcelHelpers.export(exports, "Bs3CircleFill", ()=>Bs3CircleFill);
parcelHelpers.export(exports, "Bs3Circle", ()=>Bs3Circle);
parcelHelpers.export(exports, "Bs3SquareFill", ()=>Bs3SquareFill);
parcelHelpers.export(exports, "Bs3Square", ()=>Bs3Square);
parcelHelpers.export(exports, "Bs4CircleFill", ()=>Bs4CircleFill);
parcelHelpers.export(exports, "Bs4Circle", ()=>Bs4Circle);
parcelHelpers.export(exports, "Bs4SquareFill", ()=>Bs4SquareFill);
parcelHelpers.export(exports, "Bs4Square", ()=>Bs4Square);
parcelHelpers.export(exports, "Bs5CircleFill", ()=>Bs5CircleFill);
parcelHelpers.export(exports, "Bs5Circle", ()=>Bs5Circle);
parcelHelpers.export(exports, "Bs5SquareFill", ()=>Bs5SquareFill);
parcelHelpers.export(exports, "Bs5Square", ()=>Bs5Square);
parcelHelpers.export(exports, "Bs6CircleFill", ()=>Bs6CircleFill);
parcelHelpers.export(exports, "Bs6Circle", ()=>Bs6Circle);
parcelHelpers.export(exports, "Bs6SquareFill", ()=>Bs6SquareFill);
parcelHelpers.export(exports, "Bs6Square", ()=>Bs6Square);
parcelHelpers.export(exports, "Bs7CircleFill", ()=>Bs7CircleFill);
parcelHelpers.export(exports, "Bs7Circle", ()=>Bs7Circle);
parcelHelpers.export(exports, "Bs7SquareFill", ()=>Bs7SquareFill);
parcelHelpers.export(exports, "Bs7Square", ()=>Bs7Square);
parcelHelpers.export(exports, "Bs8CircleFill", ()=>Bs8CircleFill);
parcelHelpers.export(exports, "Bs8Circle", ()=>Bs8Circle);
parcelHelpers.export(exports, "Bs8SquareFill", ()=>Bs8SquareFill);
parcelHelpers.export(exports, "Bs8Square", ()=>Bs8Square);
parcelHelpers.export(exports, "Bs9CircleFill", ()=>Bs9CircleFill);
parcelHelpers.export(exports, "Bs9Circle", ()=>Bs9Circle);
parcelHelpers.export(exports, "Bs9SquareFill", ()=>Bs9SquareFill);
parcelHelpers.export(exports, "Bs9Square", ()=>Bs9Square);
parcelHelpers.export(exports, "BsActivity", ()=>BsActivity);
parcelHelpers.export(exports, "BsAirplaneEnginesFill", ()=>BsAirplaneEnginesFill);
parcelHelpers.export(exports, "BsAirplaneEngines", ()=>BsAirplaneEngines);
parcelHelpers.export(exports, "BsAirplaneFill", ()=>BsAirplaneFill);
parcelHelpers.export(exports, "BsAirplane", ()=>BsAirplane);
parcelHelpers.export(exports, "BsAlarmFill", ()=>BsAlarmFill);
parcelHelpers.export(exports, "BsAlarm", ()=>BsAlarm);
parcelHelpers.export(exports, "BsAlexa", ()=>BsAlexa);
parcelHelpers.export(exports, "BsAlignBottom", ()=>BsAlignBottom);
parcelHelpers.export(exports, "BsAlignCenter", ()=>BsAlignCenter);
parcelHelpers.export(exports, "BsAlignEnd", ()=>BsAlignEnd);
parcelHelpers.export(exports, "BsAlignMiddle", ()=>BsAlignMiddle);
parcelHelpers.export(exports, "BsAlignStart", ()=>BsAlignStart);
parcelHelpers.export(exports, "BsAlignTop", ()=>BsAlignTop);
parcelHelpers.export(exports, "BsAlipay", ()=>BsAlipay);
parcelHelpers.export(exports, "BsAlphabetUppercase", ()=>BsAlphabetUppercase);
parcelHelpers.export(exports, "BsAlphabet", ()=>BsAlphabet);
parcelHelpers.export(exports, "BsAlt", ()=>BsAlt);
parcelHelpers.export(exports, "BsAmazon", ()=>BsAmazon);
parcelHelpers.export(exports, "BsAmd", ()=>BsAmd);
parcelHelpers.export(exports, "BsAndroid", ()=>BsAndroid);
parcelHelpers.export(exports, "BsAndroid2", ()=>BsAndroid2);
parcelHelpers.export(exports, "BsAppIndicator", ()=>BsAppIndicator);
parcelHelpers.export(exports, "BsApp", ()=>BsApp);
parcelHelpers.export(exports, "BsApple", ()=>BsApple);
parcelHelpers.export(exports, "BsArchiveFill", ()=>BsArchiveFill);
parcelHelpers.export(exports, "BsArchive", ()=>BsArchive);
parcelHelpers.export(exports, "BsArrow90DegDown", ()=>BsArrow90DegDown);
parcelHelpers.export(exports, "BsArrow90DegLeft", ()=>BsArrow90DegLeft);
parcelHelpers.export(exports, "BsArrow90DegRight", ()=>BsArrow90DegRight);
parcelHelpers.export(exports, "BsArrow90DegUp", ()=>BsArrow90DegUp);
parcelHelpers.export(exports, "BsArrowBarDown", ()=>BsArrowBarDown);
parcelHelpers.export(exports, "BsArrowBarLeft", ()=>BsArrowBarLeft);
parcelHelpers.export(exports, "BsArrowBarRight", ()=>BsArrowBarRight);
parcelHelpers.export(exports, "BsArrowBarUp", ()=>BsArrowBarUp);
parcelHelpers.export(exports, "BsArrowClockwise", ()=>BsArrowClockwise);
parcelHelpers.export(exports, "BsArrowCounterclockwise", ()=>BsArrowCounterclockwise);
parcelHelpers.export(exports, "BsArrowDownCircleFill", ()=>BsArrowDownCircleFill);
parcelHelpers.export(exports, "BsArrowDownCircle", ()=>BsArrowDownCircle);
parcelHelpers.export(exports, "BsArrowDownLeftCircleFill", ()=>BsArrowDownLeftCircleFill);
parcelHelpers.export(exports, "BsArrowDownLeftCircle", ()=>BsArrowDownLeftCircle);
parcelHelpers.export(exports, "BsArrowDownLeftSquareFill", ()=>BsArrowDownLeftSquareFill);
parcelHelpers.export(exports, "BsArrowDownLeftSquare", ()=>BsArrowDownLeftSquare);
parcelHelpers.export(exports, "BsArrowDownLeft", ()=>BsArrowDownLeft);
parcelHelpers.export(exports, "BsArrowDownRightCircleFill", ()=>BsArrowDownRightCircleFill);
parcelHelpers.export(exports, "BsArrowDownRightCircle", ()=>BsArrowDownRightCircle);
parcelHelpers.export(exports, "BsArrowDownRightSquareFill", ()=>BsArrowDownRightSquareFill);
parcelHelpers.export(exports, "BsArrowDownRightSquare", ()=>BsArrowDownRightSquare);
parcelHelpers.export(exports, "BsArrowDownRight", ()=>BsArrowDownRight);
parcelHelpers.export(exports, "BsArrowDownShort", ()=>BsArrowDownShort);
parcelHelpers.export(exports, "BsArrowDownSquareFill", ()=>BsArrowDownSquareFill);
parcelHelpers.export(exports, "BsArrowDownSquare", ()=>BsArrowDownSquare);
parcelHelpers.export(exports, "BsArrowDownUp", ()=>BsArrowDownUp);
parcelHelpers.export(exports, "BsArrowDown", ()=>BsArrowDown);
parcelHelpers.export(exports, "BsArrowLeftCircleFill", ()=>BsArrowLeftCircleFill);
parcelHelpers.export(exports, "BsArrowLeftCircle", ()=>BsArrowLeftCircle);
parcelHelpers.export(exports, "BsArrowLeftRight", ()=>BsArrowLeftRight);
parcelHelpers.export(exports, "BsArrowLeftShort", ()=>BsArrowLeftShort);
parcelHelpers.export(exports, "BsArrowLeftSquareFill", ()=>BsArrowLeftSquareFill);
parcelHelpers.export(exports, "BsArrowLeftSquare", ()=>BsArrowLeftSquare);
parcelHelpers.export(exports, "BsArrowLeft", ()=>BsArrowLeft);
parcelHelpers.export(exports, "BsArrowRepeat", ()=>BsArrowRepeat);
parcelHelpers.export(exports, "BsArrowReturnLeft", ()=>BsArrowReturnLeft);
parcelHelpers.export(exports, "BsArrowReturnRight", ()=>BsArrowReturnRight);
parcelHelpers.export(exports, "BsArrowRightCircleFill", ()=>BsArrowRightCircleFill);
parcelHelpers.export(exports, "BsArrowRightCircle", ()=>BsArrowRightCircle);
parcelHelpers.export(exports, "BsArrowRightShort", ()=>BsArrowRightShort);
parcelHelpers.export(exports, "BsArrowRightSquareFill", ()=>BsArrowRightSquareFill);
parcelHelpers.export(exports, "BsArrowRightSquare", ()=>BsArrowRightSquare);
parcelHelpers.export(exports, "BsArrowRight", ()=>BsArrowRight);
parcelHelpers.export(exports, "BsArrowThroughHeartFill", ()=>BsArrowThroughHeartFill);
parcelHelpers.export(exports, "BsArrowThroughHeart", ()=>BsArrowThroughHeart);
parcelHelpers.export(exports, "BsArrowUpCircleFill", ()=>BsArrowUpCircleFill);
parcelHelpers.export(exports, "BsArrowUpCircle", ()=>BsArrowUpCircle);
parcelHelpers.export(exports, "BsArrowUpLeftCircleFill", ()=>BsArrowUpLeftCircleFill);
parcelHelpers.export(exports, "BsArrowUpLeftCircle", ()=>BsArrowUpLeftCircle);
parcelHelpers.export(exports, "BsArrowUpLeftSquareFill", ()=>BsArrowUpLeftSquareFill);
parcelHelpers.export(exports, "BsArrowUpLeftSquare", ()=>BsArrowUpLeftSquare);
parcelHelpers.export(exports, "BsArrowUpLeft", ()=>BsArrowUpLeft);
parcelHelpers.export(exports, "BsArrowUpRightCircleFill", ()=>BsArrowUpRightCircleFill);
parcelHelpers.export(exports, "BsArrowUpRightCircle", ()=>BsArrowUpRightCircle);
parcelHelpers.export(exports, "BsArrowUpRightSquareFill", ()=>BsArrowUpRightSquareFill);
parcelHelpers.export(exports, "BsArrowUpRightSquare", ()=>BsArrowUpRightSquare);
parcelHelpers.export(exports, "BsArrowUpRight", ()=>BsArrowUpRight);
parcelHelpers.export(exports, "BsArrowUpShort", ()=>BsArrowUpShort);
parcelHelpers.export(exports, "BsArrowUpSquareFill", ()=>BsArrowUpSquareFill);
parcelHelpers.export(exports, "BsArrowUpSquare", ()=>BsArrowUpSquare);
parcelHelpers.export(exports, "BsArrowUp", ()=>BsArrowUp);
parcelHelpers.export(exports, "BsArrowsAngleContract", ()=>BsArrowsAngleContract);
parcelHelpers.export(exports, "BsArrowsAngleExpand", ()=>BsArrowsAngleExpand);
parcelHelpers.export(exports, "BsArrowsCollapseVertical", ()=>BsArrowsCollapseVertical);
parcelHelpers.export(exports, "BsArrowsCollapse", ()=>BsArrowsCollapse);
parcelHelpers.export(exports, "BsArrowsExpandVertical", ()=>BsArrowsExpandVertical);
parcelHelpers.export(exports, "BsArrowsExpand", ()=>BsArrowsExpand);
parcelHelpers.export(exports, "BsArrowsFullscreen", ()=>BsArrowsFullscreen);
parcelHelpers.export(exports, "BsArrowsMove", ()=>BsArrowsMove);
parcelHelpers.export(exports, "BsArrowsVertical", ()=>BsArrowsVertical);
parcelHelpers.export(exports, "BsArrows", ()=>BsArrows);
parcelHelpers.export(exports, "BsAspectRatioFill", ()=>BsAspectRatioFill);
parcelHelpers.export(exports, "BsAspectRatio", ()=>BsAspectRatio);
parcelHelpers.export(exports, "BsAsterisk", ()=>BsAsterisk);
parcelHelpers.export(exports, "BsAt", ()=>BsAt);
parcelHelpers.export(exports, "BsAwardFill", ()=>BsAwardFill);
parcelHelpers.export(exports, "BsAward", ()=>BsAward);
parcelHelpers.export(exports, "BsBack", ()=>BsBack);
parcelHelpers.export(exports, "BsBackpackFill", ()=>BsBackpackFill);
parcelHelpers.export(exports, "BsBackpack", ()=>BsBackpack);
parcelHelpers.export(exports, "BsBackpack2Fill", ()=>BsBackpack2Fill);
parcelHelpers.export(exports, "BsBackpack2", ()=>BsBackpack2);
parcelHelpers.export(exports, "BsBackpack3Fill", ()=>BsBackpack3Fill);
parcelHelpers.export(exports, "BsBackpack3", ()=>BsBackpack3);
parcelHelpers.export(exports, "BsBackpack4Fill", ()=>BsBackpack4Fill);
parcelHelpers.export(exports, "BsBackpack4", ()=>BsBackpack4);
parcelHelpers.export(exports, "BsBackspaceFill", ()=>BsBackspaceFill);
parcelHelpers.export(exports, "BsBackspaceReverseFill", ()=>BsBackspaceReverseFill);
parcelHelpers.export(exports, "BsBackspaceReverse", ()=>BsBackspaceReverse);
parcelHelpers.export(exports, "BsBackspace", ()=>BsBackspace);
parcelHelpers.export(exports, "BsBadge3DFill", ()=>BsBadge3DFill);
parcelHelpers.export(exports, "BsBadge3D", ()=>BsBadge3D);
parcelHelpers.export(exports, "BsBadge4KFill", ()=>BsBadge4KFill);
parcelHelpers.export(exports, "BsBadge4K", ()=>BsBadge4K);
parcelHelpers.export(exports, "BsBadge8KFill", ()=>BsBadge8KFill);
parcelHelpers.export(exports, "BsBadge8K", ()=>BsBadge8K);
parcelHelpers.export(exports, "BsBadgeAdFill", ()=>BsBadgeAdFill);
parcelHelpers.export(exports, "BsBadgeAd", ()=>BsBadgeAd);
parcelHelpers.export(exports, "BsBadgeArFill", ()=>BsBadgeArFill);
parcelHelpers.export(exports, "BsBadgeAr", ()=>BsBadgeAr);
parcelHelpers.export(exports, "BsBadgeCcFill", ()=>BsBadgeCcFill);
parcelHelpers.export(exports, "BsBadgeCc", ()=>BsBadgeCc);
parcelHelpers.export(exports, "BsBadgeHdFill", ()=>BsBadgeHdFill);
parcelHelpers.export(exports, "BsBadgeHd", ()=>BsBadgeHd);
parcelHelpers.export(exports, "BsBadgeSdFill", ()=>BsBadgeSdFill);
parcelHelpers.export(exports, "BsBadgeSd", ()=>BsBadgeSd);
parcelHelpers.export(exports, "BsBadgeTmFill", ()=>BsBadgeTmFill);
parcelHelpers.export(exports, "BsBadgeTm", ()=>BsBadgeTm);
parcelHelpers.export(exports, "BsBadgeVoFill", ()=>BsBadgeVoFill);
parcelHelpers.export(exports, "BsBadgeVo", ()=>BsBadgeVo);
parcelHelpers.export(exports, "BsBadgeVrFill", ()=>BsBadgeVrFill);
parcelHelpers.export(exports, "BsBadgeVr", ()=>BsBadgeVr);
parcelHelpers.export(exports, "BsBadgeWcFill", ()=>BsBadgeWcFill);
parcelHelpers.export(exports, "BsBadgeWc", ()=>BsBadgeWc);
parcelHelpers.export(exports, "BsBagCheckFill", ()=>BsBagCheckFill);
parcelHelpers.export(exports, "BsBagCheck", ()=>BsBagCheck);
parcelHelpers.export(exports, "BsBagDashFill", ()=>BsBagDashFill);
parcelHelpers.export(exports, "BsBagDash", ()=>BsBagDash);
parcelHelpers.export(exports, "BsBagFill", ()=>BsBagFill);
parcelHelpers.export(exports, "BsBagHeartFill", ()=>BsBagHeartFill);
parcelHelpers.export(exports, "BsBagHeart", ()=>BsBagHeart);
parcelHelpers.export(exports, "BsBagPlusFill", ()=>BsBagPlusFill);
parcelHelpers.export(exports, "BsBagPlus", ()=>BsBagPlus);
parcelHelpers.export(exports, "BsBagXFill", ()=>BsBagXFill);
parcelHelpers.export(exports, "BsBagX", ()=>BsBagX);
parcelHelpers.export(exports, "BsBag", ()=>BsBag);
parcelHelpers.export(exports, "BsBalloonFill", ()=>BsBalloonFill);
parcelHelpers.export(exports, "BsBalloonHeartFill", ()=>BsBalloonHeartFill);
parcelHelpers.export(exports, "BsBalloonHeart", ()=>BsBalloonHeart);
parcelHelpers.export(exports, "BsBalloon", ()=>BsBalloon);
parcelHelpers.export(exports, "BsBanFill", ()=>BsBanFill);
parcelHelpers.export(exports, "BsBan", ()=>BsBan);
parcelHelpers.export(exports, "BsBandaidFill", ()=>BsBandaidFill);
parcelHelpers.export(exports, "BsBandaid", ()=>BsBandaid);
parcelHelpers.export(exports, "BsBank", ()=>BsBank);
parcelHelpers.export(exports, "BsBank2", ()=>BsBank2);
parcelHelpers.export(exports, "BsBarChartFill", ()=>BsBarChartFill);
parcelHelpers.export(exports, "BsBarChartLineFill", ()=>BsBarChartLineFill);
parcelHelpers.export(exports, "BsBarChartLine", ()=>BsBarChartLine);
parcelHelpers.export(exports, "BsBarChartSteps", ()=>BsBarChartSteps);
parcelHelpers.export(exports, "BsBarChart", ()=>BsBarChart);
parcelHelpers.export(exports, "BsBasketFill", ()=>BsBasketFill);
parcelHelpers.export(exports, "BsBasket", ()=>BsBasket);
parcelHelpers.export(exports, "BsBasket2Fill", ()=>BsBasket2Fill);
parcelHelpers.export(exports, "BsBasket2", ()=>BsBasket2);
parcelHelpers.export(exports, "BsBasket3Fill", ()=>BsBasket3Fill);
parcelHelpers.export(exports, "BsBasket3", ()=>BsBasket3);
parcelHelpers.export(exports, "BsBatteryCharging", ()=>BsBatteryCharging);
parcelHelpers.export(exports, "BsBatteryFull", ()=>BsBatteryFull);
parcelHelpers.export(exports, "BsBatteryHalf", ()=>BsBatteryHalf);
parcelHelpers.export(exports, "BsBattery", ()=>BsBattery);
parcelHelpers.export(exports, "BsBehance", ()=>BsBehance);
parcelHelpers.export(exports, "BsBellFill", ()=>BsBellFill);
parcelHelpers.export(exports, "BsBellSlashFill", ()=>BsBellSlashFill);
parcelHelpers.export(exports, "BsBellSlash", ()=>BsBellSlash);
parcelHelpers.export(exports, "BsBell", ()=>BsBell);
parcelHelpers.export(exports, "BsBezier", ()=>BsBezier);
parcelHelpers.export(exports, "BsBezier2", ()=>BsBezier2);
parcelHelpers.export(exports, "BsBicycle", ()=>BsBicycle);
parcelHelpers.export(exports, "BsBing", ()=>BsBing);
parcelHelpers.export(exports, "BsBinocularsFill", ()=>BsBinocularsFill);
parcelHelpers.export(exports, "BsBinoculars", ()=>BsBinoculars);
parcelHelpers.export(exports, "BsBlockquoteLeft", ()=>BsBlockquoteLeft);
parcelHelpers.export(exports, "BsBlockquoteRight", ()=>BsBlockquoteRight);
parcelHelpers.export(exports, "BsBluetooth", ()=>BsBluetooth);
parcelHelpers.export(exports, "BsBodyText", ()=>BsBodyText);
parcelHelpers.export(exports, "BsBookFill", ()=>BsBookFill);
parcelHelpers.export(exports, "BsBookHalf", ()=>BsBookHalf);
parcelHelpers.export(exports, "BsBook", ()=>BsBook);
parcelHelpers.export(exports, "BsBookmarkCheckFill", ()=>BsBookmarkCheckFill);
parcelHelpers.export(exports, "BsBookmarkCheck", ()=>BsBookmarkCheck);
parcelHelpers.export(exports, "BsBookmarkDashFill", ()=>BsBookmarkDashFill);
parcelHelpers.export(exports, "BsBookmarkDash", ()=>BsBookmarkDash);
parcelHelpers.export(exports, "BsBookmarkFill", ()=>BsBookmarkFill);
parcelHelpers.export(exports, "BsBookmarkHeartFill", ()=>BsBookmarkHeartFill);
parcelHelpers.export(exports, "BsBookmarkHeart", ()=>BsBookmarkHeart);
parcelHelpers.export(exports, "BsBookmarkPlusFill", ()=>BsBookmarkPlusFill);
parcelHelpers.export(exports, "BsBookmarkPlus", ()=>BsBookmarkPlus);
parcelHelpers.export(exports, "BsBookmarkStarFill", ()=>BsBookmarkStarFill);
parcelHelpers.export(exports, "BsBookmarkStar", ()=>BsBookmarkStar);
parcelHelpers.export(exports, "BsBookmarkXFill", ()=>BsBookmarkXFill);
parcelHelpers.export(exports, "BsBookmarkX", ()=>BsBookmarkX);
parcelHelpers.export(exports, "BsBookmark", ()=>BsBookmark);
parcelHelpers.export(exports, "BsBookmarksFill", ()=>BsBookmarksFill);
parcelHelpers.export(exports, "BsBookmarks", ()=>BsBookmarks);
parcelHelpers.export(exports, "BsBookshelf", ()=>BsBookshelf);
parcelHelpers.export(exports, "BsBoomboxFill", ()=>BsBoomboxFill);
parcelHelpers.export(exports, "BsBoombox", ()=>BsBoombox);
parcelHelpers.export(exports, "BsBootstrapFill", ()=>BsBootstrapFill);
parcelHelpers.export(exports, "BsBootstrapReboot", ()=>BsBootstrapReboot);
parcelHelpers.export(exports, "BsBootstrap", ()=>BsBootstrap);
parcelHelpers.export(exports, "BsBorderAll", ()=>BsBorderAll);
parcelHelpers.export(exports, "BsBorderBottom", ()=>BsBorderBottom);
parcelHelpers.export(exports, "BsBorderCenter", ()=>BsBorderCenter);
parcelHelpers.export(exports, "BsBorderInner", ()=>BsBorderInner);
parcelHelpers.export(exports, "BsBorderLeft", ()=>BsBorderLeft);
parcelHelpers.export(exports, "BsBorderMiddle", ()=>BsBorderMiddle);
parcelHelpers.export(exports, "BsBorderOuter", ()=>BsBorderOuter);
parcelHelpers.export(exports, "BsBorderRight", ()=>BsBorderRight);
parcelHelpers.export(exports, "BsBorderStyle", ()=>BsBorderStyle);
parcelHelpers.export(exports, "BsBorderTop", ()=>BsBorderTop);
parcelHelpers.export(exports, "BsBorderWidth", ()=>BsBorderWidth);
parcelHelpers.export(exports, "BsBorder", ()=>BsBorder);
parcelHelpers.export(exports, "BsBoundingBoxCircles", ()=>BsBoundingBoxCircles);
parcelHelpers.export(exports, "BsBoundingBox", ()=>BsBoundingBox);
parcelHelpers.export(exports, "BsBoxArrowDownLeft", ()=>BsBoxArrowDownLeft);
parcelHelpers.export(exports, "BsBoxArrowDownRight", ()=>BsBoxArrowDownRight);
parcelHelpers.export(exports, "BsBoxArrowDown", ()=>BsBoxArrowDown);
parcelHelpers.export(exports, "BsBoxArrowInDownLeft", ()=>BsBoxArrowInDownLeft);
parcelHelpers.export(exports, "BsBoxArrowInDownRight", ()=>BsBoxArrowInDownRight);
parcelHelpers.export(exports, "BsBoxArrowInDown", ()=>BsBoxArrowInDown);
parcelHelpers.export(exports, "BsBoxArrowInLeft", ()=>BsBoxArrowInLeft);
parcelHelpers.export(exports, "BsBoxArrowInRight", ()=>BsBoxArrowInRight);
parcelHelpers.export(exports, "BsBoxArrowInUpLeft", ()=>BsBoxArrowInUpLeft);
parcelHelpers.export(exports, "BsBoxArrowInUpRight", ()=>BsBoxArrowInUpRight);
parcelHelpers.export(exports, "BsBoxArrowInUp", ()=>BsBoxArrowInUp);
parcelHelpers.export(exports, "BsBoxArrowLeft", ()=>BsBoxArrowLeft);
parcelHelpers.export(exports, "BsBoxArrowRight", ()=>BsBoxArrowRight);
parcelHelpers.export(exports, "BsBoxArrowUpLeft", ()=>BsBoxArrowUpLeft);
parcelHelpers.export(exports, "BsBoxArrowUpRight", ()=>BsBoxArrowUpRight);
parcelHelpers.export(exports, "BsBoxArrowUp", ()=>BsBoxArrowUp);
parcelHelpers.export(exports, "BsBoxFill", ()=>BsBoxFill);
parcelHelpers.export(exports, "BsBoxSeamFill", ()=>BsBoxSeamFill);
parcelHelpers.export(exports, "BsBoxSeam", ()=>BsBoxSeam);
parcelHelpers.export(exports, "BsBox", ()=>BsBox);
parcelHelpers.export(exports, "BsBox2Fill", ()=>BsBox2Fill);
parcelHelpers.export(exports, "BsBox2HeartFill", ()=>BsBox2HeartFill);
parcelHelpers.export(exports, "BsBox2Heart", ()=>BsBox2Heart);
parcelHelpers.export(exports, "BsBox2", ()=>BsBox2);
parcelHelpers.export(exports, "BsBoxes", ()=>BsBoxes);
parcelHelpers.export(exports, "BsBracesAsterisk", ()=>BsBracesAsterisk);
parcelHelpers.export(exports, "BsBraces", ()=>BsBraces);
parcelHelpers.export(exports, "BsBricks", ()=>BsBricks);
parcelHelpers.export(exports, "BsBriefcaseFill", ()=>BsBriefcaseFill);
parcelHelpers.export(exports, "BsBriefcase", ()=>BsBriefcase);
parcelHelpers.export(exports, "BsBrightnessAltHighFill", ()=>BsBrightnessAltHighFill);
parcelHelpers.export(exports, "BsBrightnessAltHigh", ()=>BsBrightnessAltHigh);
parcelHelpers.export(exports, "BsBrightnessAltLowFill", ()=>BsBrightnessAltLowFill);
parcelHelpers.export(exports, "BsBrightnessAltLow", ()=>BsBrightnessAltLow);
parcelHelpers.export(exports, "BsBrightnessHighFill", ()=>BsBrightnessHighFill);
parcelHelpers.export(exports, "BsBrightnessHigh", ()=>BsBrightnessHigh);
parcelHelpers.export(exports, "BsBrightnessLowFill", ()=>BsBrightnessLowFill);
parcelHelpers.export(exports, "BsBrightnessLow", ()=>BsBrightnessLow);
parcelHelpers.export(exports, "BsBrilliance", ()=>BsBrilliance);
parcelHelpers.export(exports, "BsBroadcastPin", ()=>BsBroadcastPin);
parcelHelpers.export(exports, "BsBroadcast", ()=>BsBroadcast);
parcelHelpers.export(exports, "BsBrowserChrome", ()=>BsBrowserChrome);
parcelHelpers.export(exports, "BsBrowserEdge", ()=>BsBrowserEdge);
parcelHelpers.export(exports, "BsBrowserFirefox", ()=>BsBrowserFirefox);
parcelHelpers.export(exports, "BsBrowserSafari", ()=>BsBrowserSafari);
parcelHelpers.export(exports, "BsBrushFill", ()=>BsBrushFill);
parcelHelpers.export(exports, "BsBrush", ()=>BsBrush);
parcelHelpers.export(exports, "BsBucketFill", ()=>BsBucketFill);
parcelHelpers.export(exports, "BsBucket", ()=>BsBucket);
parcelHelpers.export(exports, "BsBugFill", ()=>BsBugFill);
parcelHelpers.export(exports, "BsBug", ()=>BsBug);
parcelHelpers.export(exports, "BsBuildingAdd", ()=>BsBuildingAdd);
parcelHelpers.export(exports, "BsBuildingCheck", ()=>BsBuildingCheck);
parcelHelpers.export(exports, "BsBuildingDash", ()=>BsBuildingDash);
parcelHelpers.export(exports, "BsBuildingDown", ()=>BsBuildingDown);
parcelHelpers.export(exports, "BsBuildingExclamation", ()=>BsBuildingExclamation);
parcelHelpers.export(exports, "BsBuildingFillAdd", ()=>BsBuildingFillAdd);
parcelHelpers.export(exports, "BsBuildingFillCheck", ()=>BsBuildingFillCheck);
parcelHelpers.export(exports, "BsBuildingFillDash", ()=>BsBuildingFillDash);
parcelHelpers.export(exports, "BsBuildingFillDown", ()=>BsBuildingFillDown);
parcelHelpers.export(exports, "BsBuildingFillExclamation", ()=>BsBuildingFillExclamation);
parcelHelpers.export(exports, "BsBuildingFillGear", ()=>BsBuildingFillGear);
parcelHelpers.export(exports, "BsBuildingFillLock", ()=>BsBuildingFillLock);
parcelHelpers.export(exports, "BsBuildingFillSlash", ()=>BsBuildingFillSlash);
parcelHelpers.export(exports, "BsBuildingFillUp", ()=>BsBuildingFillUp);
parcelHelpers.export(exports, "BsBuildingFillX", ()=>BsBuildingFillX);
parcelHelpers.export(exports, "BsBuildingFill", ()=>BsBuildingFill);
parcelHelpers.export(exports, "BsBuildingGear", ()=>BsBuildingGear);
parcelHelpers.export(exports, "BsBuildingLock", ()=>BsBuildingLock);
parcelHelpers.export(exports, "BsBuildingSlash", ()=>BsBuildingSlash);
parcelHelpers.export(exports, "BsBuildingUp", ()=>BsBuildingUp);
parcelHelpers.export(exports, "BsBuildingX", ()=>BsBuildingX);
parcelHelpers.export(exports, "BsBuilding", ()=>BsBuilding);
parcelHelpers.export(exports, "BsBuildingsFill", ()=>BsBuildingsFill);
parcelHelpers.export(exports, "BsBuildings", ()=>BsBuildings);
parcelHelpers.export(exports, "BsBullseye", ()=>BsBullseye);
parcelHelpers.export(exports, "BsBusFrontFill", ()=>BsBusFrontFill);
parcelHelpers.export(exports, "BsBusFront", ()=>BsBusFront);
parcelHelpers.export(exports, "BsCCircleFill", ()=>BsCCircleFill);
parcelHelpers.export(exports, "BsCCircle", ()=>BsCCircle);
parcelHelpers.export(exports, "BsCSquareFill", ()=>BsCSquareFill);
parcelHelpers.export(exports, "BsCSquare", ()=>BsCSquare);
parcelHelpers.export(exports, "BsCakeFill", ()=>BsCakeFill);
parcelHelpers.export(exports, "BsCake", ()=>BsCake);
parcelHelpers.export(exports, "BsCake2Fill", ()=>BsCake2Fill);
parcelHelpers.export(exports, "BsCake2", ()=>BsCake2);
parcelHelpers.export(exports, "BsCalculatorFill", ()=>BsCalculatorFill);
parcelHelpers.export(exports, "BsCalculator", ()=>BsCalculator);
parcelHelpers.export(exports, "BsCalendarCheckFill", ()=>BsCalendarCheckFill);
parcelHelpers.export(exports, "BsCalendarCheck", ()=>BsCalendarCheck);
parcelHelpers.export(exports, "BsCalendarDateFill", ()=>BsCalendarDateFill);
parcelHelpers.export(exports, "BsCalendarDate", ()=>BsCalendarDate);
parcelHelpers.export(exports, "BsCalendarDayFill", ()=>BsCalendarDayFill);
parcelHelpers.export(exports, "BsCalendarDay", ()=>BsCalendarDay);
parcelHelpers.export(exports, "BsCalendarEventFill", ()=>BsCalendarEventFill);
parcelHelpers.export(exports, "BsCalendarEvent", ()=>BsCalendarEvent);
parcelHelpers.export(exports, "BsCalendarFill", ()=>BsCalendarFill);
parcelHelpers.export(exports, "BsCalendarHeartFill", ()=>BsCalendarHeartFill);
parcelHelpers.export(exports, "BsCalendarHeart", ()=>BsCalendarHeart);
parcelHelpers.export(exports, "BsCalendarMinusFill", ()=>BsCalendarMinusFill);
parcelHelpers.export(exports, "BsCalendarMinus", ()=>BsCalendarMinus);
parcelHelpers.export(exports, "BsCalendarMonthFill", ()=>BsCalendarMonthFill);
parcelHelpers.export(exports, "BsCalendarMonth", ()=>BsCalendarMonth);
parcelHelpers.export(exports, "BsCalendarPlusFill", ()=>BsCalendarPlusFill);
parcelHelpers.export(exports, "BsCalendarPlus", ()=>BsCalendarPlus);
parcelHelpers.export(exports, "BsCalendarRangeFill", ()=>BsCalendarRangeFill);
parcelHelpers.export(exports, "BsCalendarRange", ()=>BsCalendarRange);
parcelHelpers.export(exports, "BsCalendarWeekFill", ()=>BsCalendarWeekFill);
parcelHelpers.export(exports, "BsCalendarWeek", ()=>BsCalendarWeek);
parcelHelpers.export(exports, "BsCalendarXFill", ()=>BsCalendarXFill);
parcelHelpers.export(exports, "BsCalendarX", ()=>BsCalendarX);
parcelHelpers.export(exports, "BsCalendar", ()=>BsCalendar);
parcelHelpers.export(exports, "BsCalendar2CheckFill", ()=>BsCalendar2CheckFill);
parcelHelpers.export(exports, "BsCalendar2Check", ()=>BsCalendar2Check);
parcelHelpers.export(exports, "BsCalendar2DateFill", ()=>BsCalendar2DateFill);
parcelHelpers.export(exports, "BsCalendar2Date", ()=>BsCalendar2Date);
parcelHelpers.export(exports, "BsCalendar2DayFill", ()=>BsCalendar2DayFill);
parcelHelpers.export(exports, "BsCalendar2Day", ()=>BsCalendar2Day);
parcelHelpers.export(exports, "BsCalendar2EventFill", ()=>BsCalendar2EventFill);
parcelHelpers.export(exports, "BsCalendar2Event", ()=>BsCalendar2Event);
parcelHelpers.export(exports, "BsCalendar2Fill", ()=>BsCalendar2Fill);
parcelHelpers.export(exports, "BsCalendar2HeartFill", ()=>BsCalendar2HeartFill);
parcelHelpers.export(exports, "BsCalendar2Heart", ()=>BsCalendar2Heart);
parcelHelpers.export(exports, "BsCalendar2MinusFill", ()=>BsCalendar2MinusFill);
parcelHelpers.export(exports, "BsCalendar2Minus", ()=>BsCalendar2Minus);
parcelHelpers.export(exports, "BsCalendar2MonthFill", ()=>BsCalendar2MonthFill);
parcelHelpers.export(exports, "BsCalendar2Month", ()=>BsCalendar2Month);
parcelHelpers.export(exports, "BsCalendar2PlusFill", ()=>BsCalendar2PlusFill);
parcelHelpers.export(exports, "BsCalendar2Plus", ()=>BsCalendar2Plus);
parcelHelpers.export(exports, "BsCalendar2RangeFill", ()=>BsCalendar2RangeFill);
parcelHelpers.export(exports, "BsCalendar2Range", ()=>BsCalendar2Range);
parcelHelpers.export(exports, "BsCalendar2WeekFill", ()=>BsCalendar2WeekFill);
parcelHelpers.export(exports, "BsCalendar2Week", ()=>BsCalendar2Week);
parcelHelpers.export(exports, "BsCalendar2XFill", ()=>BsCalendar2XFill);
parcelHelpers.export(exports, "BsCalendar2X", ()=>BsCalendar2X);
parcelHelpers.export(exports, "BsCalendar2", ()=>BsCalendar2);
parcelHelpers.export(exports, "BsCalendar3EventFill", ()=>BsCalendar3EventFill);
parcelHelpers.export(exports, "BsCalendar3Event", ()=>BsCalendar3Event);
parcelHelpers.export(exports, "BsCalendar3Fill", ()=>BsCalendar3Fill);
parcelHelpers.export(exports, "BsCalendar3RangeFill", ()=>BsCalendar3RangeFill);
parcelHelpers.export(exports, "BsCalendar3Range", ()=>BsCalendar3Range);
parcelHelpers.export(exports, "BsCalendar3WeekFill", ()=>BsCalendar3WeekFill);
parcelHelpers.export(exports, "BsCalendar3Week", ()=>BsCalendar3Week);
parcelHelpers.export(exports, "BsCalendar3", ()=>BsCalendar3);
parcelHelpers.export(exports, "BsCalendar4Event", ()=>BsCalendar4Event);
parcelHelpers.export(exports, "BsCalendar4Range", ()=>BsCalendar4Range);
parcelHelpers.export(exports, "BsCalendar4Week", ()=>BsCalendar4Week);
parcelHelpers.export(exports, "BsCalendar4", ()=>BsCalendar4);
parcelHelpers.export(exports, "BsCameraFill", ()=>BsCameraFill);
parcelHelpers.export(exports, "BsCameraReelsFill", ()=>BsCameraReelsFill);
parcelHelpers.export(exports, "BsCameraReels", ()=>BsCameraReels);
parcelHelpers.export(exports, "BsCameraVideoFill", ()=>BsCameraVideoFill);
parcelHelpers.export(exports, "BsCameraVideoOffFill", ()=>BsCameraVideoOffFill);
parcelHelpers.export(exports, "BsCameraVideoOff", ()=>BsCameraVideoOff);
parcelHelpers.export(exports, "BsCameraVideo", ()=>BsCameraVideo);
parcelHelpers.export(exports, "BsCamera", ()=>BsCamera);
parcelHelpers.export(exports, "BsCamera2", ()=>BsCamera2);
parcelHelpers.export(exports, "BsCapslockFill", ()=>BsCapslockFill);
parcelHelpers.export(exports, "BsCapslock", ()=>BsCapslock);
parcelHelpers.export(exports, "BsCapsulePill", ()=>BsCapsulePill);
parcelHelpers.export(exports, "BsCapsule", ()=>BsCapsule);
parcelHelpers.export(exports, "BsCarFrontFill", ()=>BsCarFrontFill);
parcelHelpers.export(exports, "BsCarFront", ()=>BsCarFront);
parcelHelpers.export(exports, "BsCardChecklist", ()=>BsCardChecklist);
parcelHelpers.export(exports, "BsCardHeading", ()=>BsCardHeading);
parcelHelpers.export(exports, "BsCardImage", ()=>BsCardImage);
parcelHelpers.export(exports, "BsCardList", ()=>BsCardList);
parcelHelpers.export(exports, "BsCardText", ()=>BsCardText);
parcelHelpers.export(exports, "BsCaretDownFill", ()=>BsCaretDownFill);
parcelHelpers.export(exports, "BsCaretDownSquareFill", ()=>BsCaretDownSquareFill);
parcelHelpers.export(exports, "BsCaretDownSquare", ()=>BsCaretDownSquare);
parcelHelpers.export(exports, "BsCaretDown", ()=>BsCaretDown);
parcelHelpers.export(exports, "BsCaretLeftFill", ()=>BsCaretLeftFill);
parcelHelpers.export(exports, "BsCaretLeftSquareFill", ()=>BsCaretLeftSquareFill);
parcelHelpers.export(exports, "BsCaretLeftSquare", ()=>BsCaretLeftSquare);
parcelHelpers.export(exports, "BsCaretLeft", ()=>BsCaretLeft);
parcelHelpers.export(exports, "BsCaretRightFill", ()=>BsCaretRightFill);
parcelHelpers.export(exports, "BsCaretRightSquareFill", ()=>BsCaretRightSquareFill);
parcelHelpers.export(exports, "BsCaretRightSquare", ()=>BsCaretRightSquare);
parcelHelpers.export(exports, "BsCaretRight", ()=>BsCaretRight);
parcelHelpers.export(exports, "BsCaretUpFill", ()=>BsCaretUpFill);
parcelHelpers.export(exports, "BsCaretUpSquareFill", ()=>BsCaretUpSquareFill);
parcelHelpers.export(exports, "BsCaretUpSquare", ()=>BsCaretUpSquare);
parcelHelpers.export(exports, "BsCaretUp", ()=>BsCaretUp);
parcelHelpers.export(exports, "BsCartCheckFill", ()=>BsCartCheckFill);
parcelHelpers.export(exports, "BsCartCheck", ()=>BsCartCheck);
parcelHelpers.export(exports, "BsCartDashFill", ()=>BsCartDashFill);
parcelHelpers.export(exports, "BsCartDash", ()=>BsCartDash);
parcelHelpers.export(exports, "BsCartFill", ()=>BsCartFill);
parcelHelpers.export(exports, "BsCartPlusFill", ()=>BsCartPlusFill);
parcelHelpers.export(exports, "BsCartPlus", ()=>BsCartPlus);
parcelHelpers.export(exports, "BsCartXFill", ()=>BsCartXFill);
parcelHelpers.export(exports, "BsCartX", ()=>BsCartX);
parcelHelpers.export(exports, "BsCart", ()=>BsCart);
parcelHelpers.export(exports, "BsCart2", ()=>BsCart2);
parcelHelpers.export(exports, "BsCart3", ()=>BsCart3);
parcelHelpers.export(exports, "BsCart4", ()=>BsCart4);
parcelHelpers.export(exports, "BsCashCoin", ()=>BsCashCoin);
parcelHelpers.export(exports, "BsCashStack", ()=>BsCashStack);
parcelHelpers.export(exports, "BsCash", ()=>BsCash);
parcelHelpers.export(exports, "BsCassetteFill", ()=>BsCassetteFill);
parcelHelpers.export(exports, "BsCassette", ()=>BsCassette);
parcelHelpers.export(exports, "BsCast", ()=>BsCast);
parcelHelpers.export(exports, "BsCcCircleFill", ()=>BsCcCircleFill);
parcelHelpers.export(exports, "BsCcCircle", ()=>BsCcCircle);
parcelHelpers.export(exports, "BsCcSquareFill", ()=>BsCcSquareFill);
parcelHelpers.export(exports, "BsCcSquare", ()=>BsCcSquare);
parcelHelpers.export(exports, "BsChatDotsFill", ()=>BsChatDotsFill);
parcelHelpers.export(exports, "BsChatDots", ()=>BsChatDots);
parcelHelpers.export(exports, "BsChatFill", ()=>BsChatFill);
parcelHelpers.export(exports, "BsChatHeartFill", ()=>BsChatHeartFill);
parcelHelpers.export(exports, "BsChatHeart", ()=>BsChatHeart);
parcelHelpers.export(exports, "BsChatLeftDotsFill", ()=>BsChatLeftDotsFill);
parcelHelpers.export(exports, "BsChatLeftDots", ()=>BsChatLeftDots);
parcelHelpers.export(exports, "BsChatLeftFill", ()=>BsChatLeftFill);
parcelHelpers.export(exports, "BsChatLeftHeartFill", ()=>BsChatLeftHeartFill);
parcelHelpers.export(exports, "BsChatLeftHeart", ()=>BsChatLeftHeart);
parcelHelpers.export(exports, "BsChatLeftQuoteFill", ()=>BsChatLeftQuoteFill);
parcelHelpers.export(exports, "BsChatLeftQuote", ()=>BsChatLeftQuote);
parcelHelpers.export(exports, "BsChatLeftTextFill", ()=>BsChatLeftTextFill);
parcelHelpers.export(exports, "BsChatLeftText", ()=>BsChatLeftText);
parcelHelpers.export(exports, "BsChatLeft", ()=>BsChatLeft);
parcelHelpers.export(exports, "BsChatQuoteFill", ()=>BsChatQuoteFill);
parcelHelpers.export(exports, "BsChatQuote", ()=>BsChatQuote);
parcelHelpers.export(exports, "BsChatRightDotsFill", ()=>BsChatRightDotsFill);
parcelHelpers.export(exports, "BsChatRightDots", ()=>BsChatRightDots);
parcelHelpers.export(exports, "BsChatRightFill", ()=>BsChatRightFill);
parcelHelpers.export(exports, "BsChatRightHeartFill", ()=>BsChatRightHeartFill);
parcelHelpers.export(exports, "BsChatRightHeart", ()=>BsChatRightHeart);
parcelHelpers.export(exports, "BsChatRightQuoteFill", ()=>BsChatRightQuoteFill);
parcelHelpers.export(exports, "BsChatRightQuote", ()=>BsChatRightQuote);
parcelHelpers.export(exports, "BsChatRightTextFill", ()=>BsChatRightTextFill);
parcelHelpers.export(exports, "BsChatRightText", ()=>BsChatRightText);
parcelHelpers.export(exports, "BsChatRight", ()=>BsChatRight);
parcelHelpers.export(exports, "BsChatSquareDotsFill", ()=>BsChatSquareDotsFill);
parcelHelpers.export(exports, "BsChatSquareDots", ()=>BsChatSquareDots);
parcelHelpers.export(exports, "BsChatSquareFill", ()=>BsChatSquareFill);
parcelHelpers.export(exports, "BsChatSquareHeartFill", ()=>BsChatSquareHeartFill);
parcelHelpers.export(exports, "BsChatSquareHeart", ()=>BsChatSquareHeart);
parcelHelpers.export(exports, "BsChatSquareQuoteFill", ()=>BsChatSquareQuoteFill);
parcelHelpers.export(exports, "BsChatSquareQuote", ()=>BsChatSquareQuote);
parcelHelpers.export(exports, "BsChatSquareTextFill", ()=>BsChatSquareTextFill);
parcelHelpers.export(exports, "BsChatSquareText", ()=>BsChatSquareText);
parcelHelpers.export(exports, "BsChatSquare", ()=>BsChatSquare);
parcelHelpers.export(exports, "BsChatTextFill", ()=>BsChatTextFill);
parcelHelpers.export(exports, "BsChatText", ()=>BsChatText);
parcelHelpers.export(exports, "BsChat", ()=>BsChat);
parcelHelpers.export(exports, "BsCheckAll", ()=>BsCheckAll);
parcelHelpers.export(exports, "BsCheckCircleFill", ()=>BsCheckCircleFill);
parcelHelpers.export(exports, "BsCheckCircle", ()=>BsCheckCircle);
parcelHelpers.export(exports, "BsCheckLg", ()=>BsCheckLg);
parcelHelpers.export(exports, "BsCheckSquareFill", ()=>BsCheckSquareFill);
parcelHelpers.export(exports, "BsCheckSquare", ()=>BsCheckSquare);
parcelHelpers.export(exports, "BsCheck", ()=>BsCheck);
parcelHelpers.export(exports, "BsCheck2All", ()=>BsCheck2All);
parcelHelpers.export(exports, "BsCheck2Circle", ()=>BsCheck2Circle);
parcelHelpers.export(exports, "BsCheck2Square", ()=>BsCheck2Square);
parcelHelpers.export(exports, "BsCheck2", ()=>BsCheck2);
parcelHelpers.export(exports, "BsChevronBarContract", ()=>BsChevronBarContract);
parcelHelpers.export(exports, "BsChevronBarDown", ()=>BsChevronBarDown);
parcelHelpers.export(exports, "BsChevronBarExpand", ()=>BsChevronBarExpand);
parcelHelpers.export(exports, "BsChevronBarLeft", ()=>BsChevronBarLeft);
parcelHelpers.export(exports, "BsChevronBarRight", ()=>BsChevronBarRight);
parcelHelpers.export(exports, "BsChevronBarUp", ()=>BsChevronBarUp);
parcelHelpers.export(exports, "BsChevronCompactDown", ()=>BsChevronCompactDown);
parcelHelpers.export(exports, "BsChevronCompactLeft", ()=>BsChevronCompactLeft);
parcelHelpers.export(exports, "BsChevronCompactRight", ()=>BsChevronCompactRight);
parcelHelpers.export(exports, "BsChevronCompactUp", ()=>BsChevronCompactUp);
parcelHelpers.export(exports, "BsChevronContract", ()=>BsChevronContract);
parcelHelpers.export(exports, "BsChevronDoubleDown", ()=>BsChevronDoubleDown);
parcelHelpers.export(exports, "BsChevronDoubleLeft", ()=>BsChevronDoubleLeft);
parcelHelpers.export(exports, "BsChevronDoubleRight", ()=>BsChevronDoubleRight);
parcelHelpers.export(exports, "BsChevronDoubleUp", ()=>BsChevronDoubleUp);
parcelHelpers.export(exports, "BsChevronDown", ()=>BsChevronDown);
parcelHelpers.export(exports, "BsChevronExpand", ()=>BsChevronExpand);
parcelHelpers.export(exports, "BsChevronLeft", ()=>BsChevronLeft);
parcelHelpers.export(exports, "BsChevronRight", ()=>BsChevronRight);
parcelHelpers.export(exports, "BsChevronUp", ()=>BsChevronUp);
parcelHelpers.export(exports, "BsCircleFill", ()=>BsCircleFill);
parcelHelpers.export(exports, "BsCircleHalf", ()=>BsCircleHalf);
parcelHelpers.export(exports, "BsCircleSquare", ()=>BsCircleSquare);
parcelHelpers.export(exports, "BsCircle", ()=>BsCircle);
parcelHelpers.export(exports, "BsClipboardCheckFill", ()=>BsClipboardCheckFill);
parcelHelpers.export(exports, "BsClipboardCheck", ()=>BsClipboardCheck);
parcelHelpers.export(exports, "BsClipboardDataFill", ()=>BsClipboardDataFill);
parcelHelpers.export(exports, "BsClipboardData", ()=>BsClipboardData);
parcelHelpers.export(exports, "BsClipboardFill", ()=>BsClipboardFill);
parcelHelpers.export(exports, "BsClipboardHeartFill", ()=>BsClipboardHeartFill);
parcelHelpers.export(exports, "BsClipboardHeart", ()=>BsClipboardHeart);
parcelHelpers.export(exports, "BsClipboardMinusFill", ()=>BsClipboardMinusFill);
parcelHelpers.export(exports, "BsClipboardMinus", ()=>BsClipboardMinus);
parcelHelpers.export(exports, "BsClipboardPlusFill", ()=>BsClipboardPlusFill);
parcelHelpers.export(exports, "BsClipboardPlus", ()=>BsClipboardPlus);
parcelHelpers.export(exports, "BsClipboardPulse", ()=>BsClipboardPulse);
parcelHelpers.export(exports, "BsClipboardXFill", ()=>BsClipboardXFill);
parcelHelpers.export(exports, "BsClipboardX", ()=>BsClipboardX);
parcelHelpers.export(exports, "BsClipboard", ()=>BsClipboard);
parcelHelpers.export(exports, "BsClipboard2CheckFill", ()=>BsClipboard2CheckFill);
parcelHelpers.export(exports, "BsClipboard2Check", ()=>BsClipboard2Check);
parcelHelpers.export(exports, "BsClipboard2DataFill", ()=>BsClipboard2DataFill);
parcelHelpers.export(exports, "BsClipboard2Data", ()=>BsClipboard2Data);
parcelHelpers.export(exports, "BsClipboard2Fill", ()=>BsClipboard2Fill);
parcelHelpers.export(exports, "BsClipboard2HeartFill", ()=>BsClipboard2HeartFill);
parcelHelpers.export(exports, "BsClipboard2Heart", ()=>BsClipboard2Heart);
parcelHelpers.export(exports, "BsClipboard2MinusFill", ()=>BsClipboard2MinusFill);
parcelHelpers.export(exports, "BsClipboard2Minus", ()=>BsClipboard2Minus);
parcelHelpers.export(exports, "BsClipboard2PlusFill", ()=>BsClipboard2PlusFill);
parcelHelpers.export(exports, "BsClipboard2Plus", ()=>BsClipboard2Plus);
parcelHelpers.export(exports, "BsClipboard2PulseFill", ()=>BsClipboard2PulseFill);
parcelHelpers.export(exports, "BsClipboard2Pulse", ()=>BsClipboard2Pulse);
parcelHelpers.export(exports, "BsClipboard2XFill", ()=>BsClipboard2XFill);
parcelHelpers.export(exports, "BsClipboard2X", ()=>BsClipboard2X);
parcelHelpers.export(exports, "BsClipboard2", ()=>BsClipboard2);
parcelHelpers.export(exports, "BsClockFill", ()=>BsClockFill);
parcelHelpers.export(exports, "BsClockHistory", ()=>BsClockHistory);
parcelHelpers.export(exports, "BsClock", ()=>BsClock);
parcelHelpers.export(exports, "BsCloudArrowDownFill", ()=>BsCloudArrowDownFill);
parcelHelpers.export(exports, "BsCloudArrowDown", ()=>BsCloudArrowDown);
parcelHelpers.export(exports, "BsCloudArrowUpFill", ()=>BsCloudArrowUpFill);
parcelHelpers.export(exports, "BsCloudArrowUp", ()=>BsCloudArrowUp);
parcelHelpers.export(exports, "BsCloudCheckFill", ()=>BsCloudCheckFill);
parcelHelpers.export(exports, "BsCloudCheck", ()=>BsCloudCheck);
parcelHelpers.export(exports, "BsCloudDownloadFill", ()=>BsCloudDownloadFill);
parcelHelpers.export(exports, "BsCloudDownload", ()=>BsCloudDownload);
parcelHelpers.export(exports, "BsCloudDrizzleFill", ()=>BsCloudDrizzleFill);
parcelHelpers.export(exports, "BsCloudDrizzle", ()=>BsCloudDrizzle);
parcelHelpers.export(exports, "BsCloudFill", ()=>BsCloudFill);
parcelHelpers.export(exports, "BsCloudFogFill", ()=>BsCloudFogFill);
parcelHelpers.export(exports, "BsCloudFog", ()=>BsCloudFog);
parcelHelpers.export(exports, "BsCloudFog2Fill", ()=>BsCloudFog2Fill);
parcelHelpers.export(exports, "BsCloudFog2", ()=>BsCloudFog2);
parcelHelpers.export(exports, "BsCloudHailFill", ()=>BsCloudHailFill);
parcelHelpers.export(exports, "BsCloudHail", ()=>BsCloudHail);
parcelHelpers.export(exports, "BsCloudHazeFill", ()=>BsCloudHazeFill);
parcelHelpers.export(exports, "BsCloudHaze", ()=>BsCloudHaze);
parcelHelpers.export(exports, "BsCloudHaze2Fill", ()=>BsCloudHaze2Fill);
parcelHelpers.export(exports, "BsCloudHaze2", ()=>BsCloudHaze2);
parcelHelpers.export(exports, "BsCloudLightningFill", ()=>BsCloudLightningFill);
parcelHelpers.export(exports, "BsCloudLightningRainFill", ()=>BsCloudLightningRainFill);
parcelHelpers.export(exports, "BsCloudLightningRain", ()=>BsCloudLightningRain);
parcelHelpers.export(exports, "BsCloudLightning", ()=>BsCloudLightning);
parcelHelpers.export(exports, "BsCloudMinusFill", ()=>BsCloudMinusFill);
parcelHelpers.export(exports, "BsCloudMinus", ()=>BsCloudMinus);
parcelHelpers.export(exports, "BsCloudMoonFill", ()=>BsCloudMoonFill);
parcelHelpers.export(exports, "BsCloudMoon", ()=>BsCloudMoon);
parcelHelpers.export(exports, "BsCloudPlusFill", ()=>BsCloudPlusFill);
parcelHelpers.export(exports, "BsCloudPlus", ()=>BsCloudPlus);
parcelHelpers.export(exports, "BsCloudRainFill", ()=>BsCloudRainFill);
parcelHelpers.export(exports, "BsCloudRainHeavyFill", ()=>BsCloudRainHeavyFill);
parcelHelpers.export(exports, "BsCloudRainHeavy", ()=>BsCloudRainHeavy);
parcelHelpers.export(exports, "BsCloudRain", ()=>BsCloudRain);
parcelHelpers.export(exports, "BsCloudSlashFill", ()=>BsCloudSlashFill);
parcelHelpers.export(exports, "BsCloudSlash", ()=>BsCloudSlash);
parcelHelpers.export(exports, "BsCloudSleetFill", ()=>BsCloudSleetFill);
parcelHelpers.export(exports, "BsCloudSleet", ()=>BsCloudSleet);
parcelHelpers.export(exports, "BsCloudSnowFill", ()=>BsCloudSnowFill);
parcelHelpers.export(exports, "BsCloudSnow", ()=>BsCloudSnow);
parcelHelpers.export(exports, "BsCloudSunFill", ()=>BsCloudSunFill);
parcelHelpers.export(exports, "BsCloudSun", ()=>BsCloudSun);
parcelHelpers.export(exports, "BsCloudUploadFill", ()=>BsCloudUploadFill);
parcelHelpers.export(exports, "BsCloudUpload", ()=>BsCloudUpload);
parcelHelpers.export(exports, "BsCloud", ()=>BsCloud);
parcelHelpers.export(exports, "BsCloudsFill", ()=>BsCloudsFill);
parcelHelpers.export(exports, "BsClouds", ()=>BsClouds);
parcelHelpers.export(exports, "BsCloudyFill", ()=>BsCloudyFill);
parcelHelpers.export(exports, "BsCloudy", ()=>BsCloudy);
parcelHelpers.export(exports, "BsCodeSlash", ()=>BsCodeSlash);
parcelHelpers.export(exports, "BsCodeSquare", ()=>BsCodeSquare);
parcelHelpers.export(exports, "BsCode", ()=>BsCode);
parcelHelpers.export(exports, "BsCoin", ()=>BsCoin);
parcelHelpers.export(exports, "BsCollectionFill", ()=>BsCollectionFill);
parcelHelpers.export(exports, "BsCollectionPlayFill", ()=>BsCollectionPlayFill);
parcelHelpers.export(exports, "BsCollectionPlay", ()=>BsCollectionPlay);
parcelHelpers.export(exports, "BsCollection", ()=>BsCollection);
parcelHelpers.export(exports, "BsColumnsGap", ()=>BsColumnsGap);
parcelHelpers.export(exports, "BsColumns", ()=>BsColumns);
parcelHelpers.export(exports, "BsCommand", ()=>BsCommand);
parcelHelpers.export(exports, "BsCompassFill", ()=>BsCompassFill);
parcelHelpers.export(exports, "BsCompass", ()=>BsCompass);
parcelHelpers.export(exports, "BsConeStriped", ()=>BsConeStriped);
parcelHelpers.export(exports, "BsCone", ()=>BsCone);
parcelHelpers.export(exports, "BsController", ()=>BsController);
parcelHelpers.export(exports, "BsCookie", ()=>BsCookie);
parcelHelpers.export(exports, "BsCopy", ()=>BsCopy);
parcelHelpers.export(exports, "BsCpuFill", ()=>BsCpuFill);
parcelHelpers.export(exports, "BsCpu", ()=>BsCpu);
parcelHelpers.export(exports, "BsCreditCard2BackFill", ()=>BsCreditCard2BackFill);
parcelHelpers.export(exports, "BsCreditCard2Back", ()=>BsCreditCard2Back);
parcelHelpers.export(exports, "BsCreditCard2FrontFill", ()=>BsCreditCard2FrontFill);
parcelHelpers.export(exports, "BsCreditCard2Front", ()=>BsCreditCard2Front);
parcelHelpers.export(exports, "BsCreditCardFill", ()=>BsCreditCardFill);
parcelHelpers.export(exports, "BsCreditCard", ()=>BsCreditCard);
parcelHelpers.export(exports, "BsCrop", ()=>BsCrop);
parcelHelpers.export(exports, "BsCrosshair", ()=>BsCrosshair);
parcelHelpers.export(exports, "BsCrosshair2", ()=>BsCrosshair2);
parcelHelpers.export(exports, "BsCupFill", ()=>BsCupFill);
parcelHelpers.export(exports, "BsCupHotFill", ()=>BsCupHotFill);
parcelHelpers.export(exports, "BsCupHot", ()=>BsCupHot);
parcelHelpers.export(exports, "BsCupStraw", ()=>BsCupStraw);
parcelHelpers.export(exports, "BsCup", ()=>BsCup);
parcelHelpers.export(exports, "BsCurrencyBitcoin", ()=>BsCurrencyBitcoin);
parcelHelpers.export(exports, "BsCurrencyDollar", ()=>BsCurrencyDollar);
parcelHelpers.export(exports, "BsCurrencyEuro", ()=>BsCurrencyEuro);
parcelHelpers.export(exports, "BsCurrencyExchange", ()=>BsCurrencyExchange);
parcelHelpers.export(exports, "BsCurrencyPound", ()=>BsCurrencyPound);
parcelHelpers.export(exports, "BsCurrencyRupee", ()=>BsCurrencyRupee);
parcelHelpers.export(exports, "BsCurrencyYen", ()=>BsCurrencyYen);
parcelHelpers.export(exports, "BsCursorFill", ()=>BsCursorFill);
parcelHelpers.export(exports, "BsCursorText", ()=>BsCursorText);
parcelHelpers.export(exports, "BsCursor", ()=>BsCursor);
parcelHelpers.export(exports, "BsDashCircleDotted", ()=>BsDashCircleDotted);
parcelHelpers.export(exports, "BsDashCircleFill", ()=>BsDashCircleFill);
parcelHelpers.export(exports, "BsDashCircle", ()=>BsDashCircle);
parcelHelpers.export(exports, "BsDashLg", ()=>BsDashLg);
parcelHelpers.export(exports, "BsDashSquareDotted", ()=>BsDashSquareDotted);
parcelHelpers.export(exports, "BsDashSquareFill", ()=>BsDashSquareFill);
parcelHelpers.export(exports, "BsDashSquare", ()=>BsDashSquare);
parcelHelpers.export(exports, "BsDash", ()=>BsDash);
parcelHelpers.export(exports, "BsDatabaseAdd", ()=>BsDatabaseAdd);
parcelHelpers.export(exports, "BsDatabaseCheck", ()=>BsDatabaseCheck);
parcelHelpers.export(exports, "BsDatabaseDash", ()=>BsDatabaseDash);
parcelHelpers.export(exports, "BsDatabaseDown", ()=>BsDatabaseDown);
parcelHelpers.export(exports, "BsDatabaseExclamation", ()=>BsDatabaseExclamation);
parcelHelpers.export(exports, "BsDatabaseFillAdd", ()=>BsDatabaseFillAdd);
parcelHelpers.export(exports, "BsDatabaseFillCheck", ()=>BsDatabaseFillCheck);
parcelHelpers.export(exports, "BsDatabaseFillDash", ()=>BsDatabaseFillDash);
parcelHelpers.export(exports, "BsDatabaseFillDown", ()=>BsDatabaseFillDown);
parcelHelpers.export(exports, "BsDatabaseFillExclamation", ()=>BsDatabaseFillExclamation);
parcelHelpers.export(exports, "BsDatabaseFillGear", ()=>BsDatabaseFillGear);
parcelHelpers.export(exports, "BsDatabaseFillLock", ()=>BsDatabaseFillLock);
parcelHelpers.export(exports, "BsDatabaseFillSlash", ()=>BsDatabaseFillSlash);
parcelHelpers.export(exports, "BsDatabaseFillUp", ()=>BsDatabaseFillUp);
parcelHelpers.export(exports, "BsDatabaseFillX", ()=>BsDatabaseFillX);
parcelHelpers.export(exports, "BsDatabaseFill", ()=>BsDatabaseFill);
parcelHelpers.export(exports, "BsDatabaseGear", ()=>BsDatabaseGear);
parcelHelpers.export(exports, "BsDatabaseLock", ()=>BsDatabaseLock);
parcelHelpers.export(exports, "BsDatabaseSlash", ()=>BsDatabaseSlash);
parcelHelpers.export(exports, "BsDatabaseUp", ()=>BsDatabaseUp);
parcelHelpers.export(exports, "BsDatabaseX", ()=>BsDatabaseX);
parcelHelpers.export(exports, "BsDatabase", ()=>BsDatabase);
parcelHelpers.export(exports, "BsDeviceHddFill", ()=>BsDeviceHddFill);
parcelHelpers.export(exports, "BsDeviceHdd", ()=>BsDeviceHdd);
parcelHelpers.export(exports, "BsDeviceSsdFill", ()=>BsDeviceSsdFill);
parcelHelpers.export(exports, "BsDeviceSsd", ()=>BsDeviceSsd);
parcelHelpers.export(exports, "BsDiagram2Fill", ()=>BsDiagram2Fill);
parcelHelpers.export(exports, "BsDiagram2", ()=>BsDiagram2);
parcelHelpers.export(exports, "BsDiagram3Fill", ()=>BsDiagram3Fill);
parcelHelpers.export(exports, "BsDiagram3", ()=>BsDiagram3);
parcelHelpers.export(exports, "BsDiamondFill", ()=>BsDiamondFill);
parcelHelpers.export(exports, "BsDiamondHalf", ()=>BsDiamondHalf);
parcelHelpers.export(exports, "BsDiamond", ()=>BsDiamond);
parcelHelpers.export(exports, "BsDice1Fill", ()=>BsDice1Fill);
parcelHelpers.export(exports, "BsDice1", ()=>BsDice1);
parcelHelpers.export(exports, "BsDice2Fill", ()=>BsDice2Fill);
parcelHelpers.export(exports, "BsDice2", ()=>BsDice2);
parcelHelpers.export(exports, "BsDice3Fill", ()=>BsDice3Fill);
parcelHelpers.export(exports, "BsDice3", ()=>BsDice3);
parcelHelpers.export(exports, "BsDice4Fill", ()=>BsDice4Fill);
parcelHelpers.export(exports, "BsDice4", ()=>BsDice4);
parcelHelpers.export(exports, "BsDice5Fill", ()=>BsDice5Fill);
parcelHelpers.export(exports, "BsDice5", ()=>BsDice5);
parcelHelpers.export(exports, "BsDice6Fill", ()=>BsDice6Fill);
parcelHelpers.export(exports, "BsDice6", ()=>BsDice6);
parcelHelpers.export(exports, "BsDiscFill", ()=>BsDiscFill);
parcelHelpers.export(exports, "BsDisc", ()=>BsDisc);
parcelHelpers.export(exports, "BsDiscord", ()=>BsDiscord);
parcelHelpers.export(exports, "BsDisplayFill", ()=>BsDisplayFill);
parcelHelpers.export(exports, "BsDisplay", ()=>BsDisplay);
parcelHelpers.export(exports, "BsDisplayportFill", ()=>BsDisplayportFill);
parcelHelpers.export(exports, "BsDisplayport", ()=>BsDisplayport);
parcelHelpers.export(exports, "BsDistributeHorizontal", ()=>BsDistributeHorizontal);
parcelHelpers.export(exports, "BsDistributeVertical", ()=>BsDistributeVertical);
parcelHelpers.export(exports, "BsDoorClosedFill", ()=>BsDoorClosedFill);
parcelHelpers.export(exports, "BsDoorClosed", ()=>BsDoorClosed);
parcelHelpers.export(exports, "BsDoorOpenFill", ()=>BsDoorOpenFill);
parcelHelpers.export(exports, "BsDoorOpen", ()=>BsDoorOpen);
parcelHelpers.export(exports, "BsDot", ()=>BsDot);
parcelHelpers.export(exports, "BsDownload", ()=>BsDownload);
parcelHelpers.export(exports, "BsDpadFill", ()=>BsDpadFill);
parcelHelpers.export(exports, "BsDpad", ()=>BsDpad);
parcelHelpers.export(exports, "BsDribbble", ()=>BsDribbble);
parcelHelpers.export(exports, "BsDropbox", ()=>BsDropbox);
parcelHelpers.export(exports, "BsDropletFill", ()=>BsDropletFill);
parcelHelpers.export(exports, "BsDropletHalf", ()=>BsDropletHalf);
parcelHelpers.export(exports, "BsDroplet", ()=>BsDroplet);
parcelHelpers.export(exports, "BsDuffleFill", ()=>BsDuffleFill);
parcelHelpers.export(exports, "BsDuffle", ()=>BsDuffle);
parcelHelpers.export(exports, "BsEarFill", ()=>BsEarFill);
parcelHelpers.export(exports, "BsEar", ()=>BsEar);
parcelHelpers.export(exports, "BsEarbuds", ()=>BsEarbuds);
parcelHelpers.export(exports, "BsEaselFill", ()=>BsEaselFill);
parcelHelpers.export(exports, "BsEasel", ()=>BsEasel);
parcelHelpers.export(exports, "BsEasel2Fill", ()=>BsEasel2Fill);
parcelHelpers.export(exports, "BsEasel2", ()=>BsEasel2);
parcelHelpers.export(exports, "BsEasel3Fill", ()=>BsEasel3Fill);
parcelHelpers.export(exports, "BsEasel3", ()=>BsEasel3);
parcelHelpers.export(exports, "BsEggFill", ()=>BsEggFill);
parcelHelpers.export(exports, "BsEggFried", ()=>BsEggFried);
parcelHelpers.export(exports, "BsEgg", ()=>BsEgg);
parcelHelpers.export(exports, "BsEjectFill", ()=>BsEjectFill);
parcelHelpers.export(exports, "BsEject", ()=>BsEject);
parcelHelpers.export(exports, "BsEmojiAngryFill", ()=>BsEmojiAngryFill);
parcelHelpers.export(exports, "BsEmojiAngry", ()=>BsEmojiAngry);
parcelHelpers.export(exports, "BsEmojiAstonishedFill", ()=>BsEmojiAstonishedFill);
parcelHelpers.export(exports, "BsEmojiAstonished", ()=>BsEmojiAstonished);
parcelHelpers.export(exports, "BsEmojiDizzyFill", ()=>BsEmojiDizzyFill);
parcelHelpers.export(exports, "BsEmojiDizzy", ()=>BsEmojiDizzy);
parcelHelpers.export(exports, "BsEmojiExpressionlessFill", ()=>BsEmojiExpressionlessFill);
parcelHelpers.export(exports, "BsEmojiExpressionless", ()=>BsEmojiExpressionless);
parcelHelpers.export(exports, "BsEmojiFrownFill", ()=>BsEmojiFrownFill);
parcelHelpers.export(exports, "BsEmojiFrown", ()=>BsEmojiFrown);
parcelHelpers.export(exports, "BsEmojiGrimaceFill", ()=>BsEmojiGrimaceFill);
parcelHelpers.export(exports, "BsEmojiGrimace", ()=>BsEmojiGrimace);
parcelHelpers.export(exports, "BsEmojiGrinFill", ()=>BsEmojiGrinFill);
parcelHelpers.export(exports, "BsEmojiGrin", ()=>BsEmojiGrin);
parcelHelpers.export(exports, "BsEmojiHeartEyesFill", ()=>BsEmojiHeartEyesFill);
parcelHelpers.export(exports, "BsEmojiHeartEyes", ()=>BsEmojiHeartEyes);
parcelHelpers.export(exports, "BsEmojiKissFill", ()=>BsEmojiKissFill);
parcelHelpers.export(exports, "BsEmojiKiss", ()=>BsEmojiKiss);
parcelHelpers.export(exports, "BsEmojiLaughingFill", ()=>BsEmojiLaughingFill);
parcelHelpers.export(exports, "BsEmojiLaughing", ()=>BsEmojiLaughing);
parcelHelpers.export(exports, "BsEmojiNeutralFill", ()=>BsEmojiNeutralFill);
parcelHelpers.export(exports, "BsEmojiNeutral", ()=>BsEmojiNeutral);
parcelHelpers.export(exports, "BsEmojiSmileFill", ()=>BsEmojiSmileFill);
parcelHelpers.export(exports, "BsEmojiSmileUpsideDownFill", ()=>BsEmojiSmileUpsideDownFill);
parcelHelpers.export(exports, "BsEmojiSmileUpsideDown", ()=>BsEmojiSmileUpsideDown);
parcelHelpers.export(exports, "BsEmojiSmile", ()=>BsEmojiSmile);
parcelHelpers.export(exports, "BsEmojiSunglassesFill", ()=>BsEmojiSunglassesFill);
parcelHelpers.export(exports, "BsEmojiSunglasses", ()=>BsEmojiSunglasses);
parcelHelpers.export(exports, "BsEmojiSurpriseFill", ()=>BsEmojiSurpriseFill);
parcelHelpers.export(exports, "BsEmojiSurprise", ()=>BsEmojiSurprise);
parcelHelpers.export(exports, "BsEmojiTearFill", ()=>BsEmojiTearFill);
parcelHelpers.export(exports, "BsEmojiTear", ()=>BsEmojiTear);
parcelHelpers.export(exports, "BsEmojiWinkFill", ()=>BsEmojiWinkFill);
parcelHelpers.export(exports, "BsEmojiWink", ()=>BsEmojiWink);
parcelHelpers.export(exports, "BsEnvelopeArrowDownFill", ()=>BsEnvelopeArrowDownFill);
parcelHelpers.export(exports, "BsEnvelopeArrowDown", ()=>BsEnvelopeArrowDown);
parcelHelpers.export(exports, "BsEnvelopeArrowUpFill", ()=>BsEnvelopeArrowUpFill);
parcelHelpers.export(exports, "BsEnvelopeArrowUp", ()=>BsEnvelopeArrowUp);
parcelHelpers.export(exports, "BsEnvelopeAtFill", ()=>BsEnvelopeAtFill);
parcelHelpers.export(exports, "BsEnvelopeAt", ()=>BsEnvelopeAt);
parcelHelpers.export(exports, "BsEnvelopeCheckFill", ()=>BsEnvelopeCheckFill);
parcelHelpers.export(exports, "BsEnvelopeCheck", ()=>BsEnvelopeCheck);
parcelHelpers.export(exports, "BsEnvelopeDashFill", ()=>BsEnvelopeDashFill);
parcelHelpers.export(exports, "BsEnvelopeDash", ()=>BsEnvelopeDash);
parcelHelpers.export(exports, "BsEnvelopeExclamationFill", ()=>BsEnvelopeExclamationFill);
parcelHelpers.export(exports, "BsEnvelopeExclamation", ()=>BsEnvelopeExclamation);
parcelHelpers.export(exports, "BsEnvelopeFill", ()=>BsEnvelopeFill);
parcelHelpers.export(exports, "BsEnvelopeHeartFill", ()=>BsEnvelopeHeartFill);
parcelHelpers.export(exports, "BsEnvelopeHeart", ()=>BsEnvelopeHeart);
parcelHelpers.export(exports, "BsEnvelopeOpenFill", ()=>BsEnvelopeOpenFill);
parcelHelpers.export(exports, "BsEnvelopeOpenHeartFill", ()=>BsEnvelopeOpenHeartFill);
parcelHelpers.export(exports, "BsEnvelopeOpenHeart", ()=>BsEnvelopeOpenHeart);
parcelHelpers.export(exports, "BsEnvelopeOpen", ()=>BsEnvelopeOpen);
parcelHelpers.export(exports, "BsEnvelopePaperFill", ()=>BsEnvelopePaperFill);
parcelHelpers.export(exports, "BsEnvelopePaperHeartFill", ()=>BsEnvelopePaperHeartFill);
parcelHelpers.export(exports, "BsEnvelopePaperHeart", ()=>BsEnvelopePaperHeart);
parcelHelpers.export(exports, "BsEnvelopePaper", ()=>BsEnvelopePaper);
parcelHelpers.export(exports, "BsEnvelopePlusFill", ()=>BsEnvelopePlusFill);
parcelHelpers.export(exports, "BsEnvelopePlus", ()=>BsEnvelopePlus);
parcelHelpers.export(exports, "BsEnvelopeSlashFill", ()=>BsEnvelopeSlashFill);
parcelHelpers.export(exports, "BsEnvelopeSlash", ()=>BsEnvelopeSlash);
parcelHelpers.export(exports, "BsEnvelopeXFill", ()=>BsEnvelopeXFill);
parcelHelpers.export(exports, "BsEnvelopeX", ()=>BsEnvelopeX);
parcelHelpers.export(exports, "BsEnvelope", ()=>BsEnvelope);
parcelHelpers.export(exports, "BsEraserFill", ()=>BsEraserFill);
parcelHelpers.export(exports, "BsEraser", ()=>BsEraser);
parcelHelpers.export(exports, "BsEscape", ()=>BsEscape);
parcelHelpers.export(exports, "BsEthernet", ()=>BsEthernet);
parcelHelpers.export(exports, "BsEvFrontFill", ()=>BsEvFrontFill);
parcelHelpers.export(exports, "BsEvFront", ()=>BsEvFront);
parcelHelpers.export(exports, "BsEvStationFill", ()=>BsEvStationFill);
parcelHelpers.export(exports, "BsEvStation", ()=>BsEvStation);
parcelHelpers.export(exports, "BsExclamationCircleFill", ()=>BsExclamationCircleFill);
parcelHelpers.export(exports, "BsExclamationCircle", ()=>BsExclamationCircle);
parcelHelpers.export(exports, "BsExclamationDiamondFill", ()=>BsExclamationDiamondFill);
parcelHelpers.export(exports, "BsExclamationDiamond", ()=>BsExclamationDiamond);
parcelHelpers.export(exports, "BsExclamationLg", ()=>BsExclamationLg);
parcelHelpers.export(exports, "BsExclamationOctagonFill", ()=>BsExclamationOctagonFill);
parcelHelpers.export(exports, "BsExclamationOctagon", ()=>BsExclamationOctagon);
parcelHelpers.export(exports, "BsExclamationSquareFill", ()=>BsExclamationSquareFill);
parcelHelpers.export(exports, "BsExclamationSquare", ()=>BsExclamationSquare);
parcelHelpers.export(exports, "BsExclamationTriangleFill", ()=>BsExclamationTriangleFill);
parcelHelpers.export(exports, "BsExclamationTriangle", ()=>BsExclamationTriangle);
parcelHelpers.export(exports, "BsExclamation", ()=>BsExclamation);
parcelHelpers.export(exports, "BsExclude", ()=>BsExclude);
parcelHelpers.export(exports, "BsExplicitFill", ()=>BsExplicitFill);
parcelHelpers.export(exports, "BsExplicit", ()=>BsExplicit);
parcelHelpers.export(exports, "BsExposure", ()=>BsExposure);
parcelHelpers.export(exports, "BsEyeFill", ()=>BsEyeFill);
parcelHelpers.export(exports, "BsEyeSlashFill", ()=>BsEyeSlashFill);
parcelHelpers.export(exports, "BsEyeSlash", ()=>BsEyeSlash);
parcelHelpers.export(exports, "BsEye", ()=>BsEye);
parcelHelpers.export(exports, "BsEyedropper", ()=>BsEyedropper);
parcelHelpers.export(exports, "BsEyeglasses", ()=>BsEyeglasses);
parcelHelpers.export(exports, "BsFacebook", ()=>BsFacebook);
parcelHelpers.export(exports, "BsFan", ()=>BsFan);
parcelHelpers.export(exports, "BsFastForwardBtnFill", ()=>BsFastForwardBtnFill);
parcelHelpers.export(exports, "BsFastForwardBtn", ()=>BsFastForwardBtn);
parcelHelpers.export(exports, "BsFastForwardCircleFill", ()=>BsFastForwardCircleFill);
parcelHelpers.export(exports, "BsFastForwardCircle", ()=>BsFastForwardCircle);
parcelHelpers.export(exports, "BsFastForwardFill", ()=>BsFastForwardFill);
parcelHelpers.export(exports, "BsFastForward", ()=>BsFastForward);
parcelHelpers.export(exports, "BsFeather", ()=>BsFeather);
parcelHelpers.export(exports, "BsFeather2", ()=>BsFeather2);
parcelHelpers.export(exports, "BsFileArrowDownFill", ()=>BsFileArrowDownFill);
parcelHelpers.export(exports, "BsFileArrowDown", ()=>BsFileArrowDown);
parcelHelpers.export(exports, "BsFileArrowUpFill", ()=>BsFileArrowUpFill);
parcelHelpers.export(exports, "BsFileArrowUp", ()=>BsFileArrowUp);
parcelHelpers.export(exports, "BsFileBarGraphFill", ()=>BsFileBarGraphFill);
parcelHelpers.export(exports, "BsFileBarGraph", ()=>BsFileBarGraph);
parcelHelpers.export(exports, "BsFileBinaryFill", ()=>BsFileBinaryFill);
parcelHelpers.export(exports, "BsFileBinary", ()=>BsFileBinary);
parcelHelpers.export(exports, "BsFileBreakFill", ()=>BsFileBreakFill);
parcelHelpers.export(exports, "BsFileBreak", ()=>BsFileBreak);
parcelHelpers.export(exports, "BsFileCheckFill", ()=>BsFileCheckFill);
parcelHelpers.export(exports, "BsFileCheck", ()=>BsFileCheck);
parcelHelpers.export(exports, "BsFileCodeFill", ()=>BsFileCodeFill);
parcelHelpers.export(exports, "BsFileCode", ()=>BsFileCode);
parcelHelpers.export(exports, "BsFileDiffFill", ()=>BsFileDiffFill);
parcelHelpers.export(exports, "BsFileDiff", ()=>BsFileDiff);
parcelHelpers.export(exports, "BsFileEarmarkArrowDownFill", ()=>BsFileEarmarkArrowDownFill);
parcelHelpers.export(exports, "BsFileEarmarkArrowDown", ()=>BsFileEarmarkArrowDown);
parcelHelpers.export(exports, "BsFileEarmarkArrowUpFill", ()=>BsFileEarmarkArrowUpFill);
parcelHelpers.export(exports, "BsFileEarmarkArrowUp", ()=>BsFileEarmarkArrowUp);
parcelHelpers.export(exports, "BsFileEarmarkBarGraphFill", ()=>BsFileEarmarkBarGraphFill);
parcelHelpers.export(exports, "BsFileEarmarkBarGraph", ()=>BsFileEarmarkBarGraph);
parcelHelpers.export(exports, "BsFileEarmarkBinaryFill", ()=>BsFileEarmarkBinaryFill);
parcelHelpers.export(exports, "BsFileEarmarkBinary", ()=>BsFileEarmarkBinary);
parcelHelpers.export(exports, "BsFileEarmarkBreakFill", ()=>BsFileEarmarkBreakFill);
parcelHelpers.export(exports, "BsFileEarmarkBreak", ()=>BsFileEarmarkBreak);
parcelHelpers.export(exports, "BsFileEarmarkCheckFill", ()=>BsFileEarmarkCheckFill);
parcelHelpers.export(exports, "BsFileEarmarkCheck", ()=>BsFileEarmarkCheck);
parcelHelpers.export(exports, "BsFileEarmarkCodeFill", ()=>BsFileEarmarkCodeFill);
parcelHelpers.export(exports, "BsFileEarmarkCode", ()=>BsFileEarmarkCode);
parcelHelpers.export(exports, "BsFileEarmarkDiffFill", ()=>BsFileEarmarkDiffFill);
parcelHelpers.export(exports, "BsFileEarmarkDiff", ()=>BsFileEarmarkDiff);
parcelHelpers.export(exports, "BsFileEarmarkEaselFill", ()=>BsFileEarmarkEaselFill);
parcelHelpers.export(exports, "BsFileEarmarkEasel", ()=>BsFileEarmarkEasel);
parcelHelpers.export(exports, "BsFileEarmarkExcelFill", ()=>BsFileEarmarkExcelFill);
parcelHelpers.export(exports, "BsFileEarmarkExcel", ()=>BsFileEarmarkExcel);
parcelHelpers.export(exports, "BsFileEarmarkFill", ()=>BsFileEarmarkFill);
parcelHelpers.export(exports, "BsFileEarmarkFontFill", ()=>BsFileEarmarkFontFill);
parcelHelpers.export(exports, "BsFileEarmarkFont", ()=>BsFileEarmarkFont);
parcelHelpers.export(exports, "BsFileEarmarkImageFill", ()=>BsFileEarmarkImageFill);
parcelHelpers.export(exports, "BsFileEarmarkImage", ()=>BsFileEarmarkImage);
parcelHelpers.export(exports, "BsFileEarmarkLockFill", ()=>BsFileEarmarkLockFill);
parcelHelpers.export(exports, "BsFileEarmarkLock", ()=>BsFileEarmarkLock);
parcelHelpers.export(exports, "BsFileEarmarkLock2Fill", ()=>BsFileEarmarkLock2Fill);
parcelHelpers.export(exports, "BsFileEarmarkLock2", ()=>BsFileEarmarkLock2);
parcelHelpers.export(exports, "BsFileEarmarkMedicalFill", ()=>BsFileEarmarkMedicalFill);
parcelHelpers.export(exports, "BsFileEarmarkMedical", ()=>BsFileEarmarkMedical);
parcelHelpers.export(exports, "BsFileEarmarkMinusFill", ()=>BsFileEarmarkMinusFill);
parcelHelpers.export(exports, "BsFileEarmarkMinus", ()=>BsFileEarmarkMinus);
parcelHelpers.export(exports, "BsFileEarmarkMusicFill", ()=>BsFileEarmarkMusicFill);
parcelHelpers.export(exports, "BsFileEarmarkMusic", ()=>BsFileEarmarkMusic);
parcelHelpers.export(exports, "BsFileEarmarkPdfFill", ()=>BsFileEarmarkPdfFill);
parcelHelpers.export(exports, "BsFileEarmarkPdf", ()=>BsFileEarmarkPdf);
parcelHelpers.export(exports, "BsFileEarmarkPersonFill", ()=>BsFileEarmarkPersonFill);
parcelHelpers.export(exports, "BsFileEarmarkPerson", ()=>BsFileEarmarkPerson);
parcelHelpers.export(exports, "BsFileEarmarkPlayFill", ()=>BsFileEarmarkPlayFill);
parcelHelpers.export(exports, "BsFileEarmarkPlay", ()=>BsFileEarmarkPlay);
parcelHelpers.export(exports, "BsFileEarmarkPlusFill", ()=>BsFileEarmarkPlusFill);
parcelHelpers.export(exports, "BsFileEarmarkPlus", ()=>BsFileEarmarkPlus);
parcelHelpers.export(exports, "BsFileEarmarkPostFill", ()=>BsFileEarmarkPostFill);
parcelHelpers.export(exports, "BsFileEarmarkPost", ()=>BsFileEarmarkPost);
parcelHelpers.export(exports, "BsFileEarmarkPptFill", ()=>BsFileEarmarkPptFill);
parcelHelpers.export(exports, "BsFileEarmarkPpt", ()=>BsFileEarmarkPpt);
parcelHelpers.export(exports, "BsFileEarmarkRichtextFill", ()=>BsFileEarmarkRichtextFill);
parcelHelpers.export(exports, "BsFileEarmarkRichtext", ()=>BsFileEarmarkRichtext);
parcelHelpers.export(exports, "BsFileEarmarkRuledFill", ()=>BsFileEarmarkRuledFill);
parcelHelpers.export(exports, "BsFileEarmarkRuled", ()=>BsFileEarmarkRuled);
parcelHelpers.export(exports, "BsFileEarmarkSlidesFill", ()=>BsFileEarmarkSlidesFill);
parcelHelpers.export(exports, "BsFileEarmarkSlides", ()=>BsFileEarmarkSlides);
parcelHelpers.export(exports, "BsFileEarmarkSpreadsheetFill", ()=>BsFileEarmarkSpreadsheetFill);
parcelHelpers.export(exports, "BsFileEarmarkSpreadsheet", ()=>BsFileEarmarkSpreadsheet);
parcelHelpers.export(exports, "BsFileEarmarkTextFill", ()=>BsFileEarmarkTextFill);
parcelHelpers.export(exports, "BsFileEarmarkText", ()=>BsFileEarmarkText);
parcelHelpers.export(exports, "BsFileEarmarkWordFill", ()=>BsFileEarmarkWordFill);
parcelHelpers.export(exports, "BsFileEarmarkWord", ()=>BsFileEarmarkWord);
parcelHelpers.export(exports, "BsFileEarmarkXFill", ()=>BsFileEarmarkXFill);
parcelHelpers.export(exports, "BsFileEarmarkX", ()=>BsFileEarmarkX);
parcelHelpers.export(exports, "BsFileEarmarkZipFill", ()=>BsFileEarmarkZipFill);
parcelHelpers.export(exports, "BsFileEarmarkZip", ()=>BsFileEarmarkZip);
parcelHelpers.export(exports, "BsFileEarmark", ()=>BsFileEarmark);
parcelHelpers.export(exports, "BsFileEaselFill", ()=>BsFileEaselFill);
parcelHelpers.export(exports, "BsFileEasel", ()=>BsFileEasel);
parcelHelpers.export(exports, "BsFileExcelFill", ()=>BsFileExcelFill);
parcelHelpers.export(exports, "BsFileExcel", ()=>BsFileExcel);
parcelHelpers.export(exports, "BsFileFill", ()=>BsFileFill);
parcelHelpers.export(exports, "BsFileFontFill", ()=>BsFileFontFill);
parcelHelpers.export(exports, "BsFileFont", ()=>BsFileFont);
parcelHelpers.export(exports, "BsFileImageFill", ()=>BsFileImageFill);
parcelHelpers.export(exports, "BsFileImage", ()=>BsFileImage);
parcelHelpers.export(exports, "BsFileLockFill", ()=>BsFileLockFill);
parcelHelpers.export(exports, "BsFileLock", ()=>BsFileLock);
parcelHelpers.export(exports, "BsFileLock2Fill", ()=>BsFileLock2Fill);
parcelHelpers.export(exports, "BsFileLock2", ()=>BsFileLock2);
parcelHelpers.export(exports, "BsFileMedicalFill", ()=>BsFileMedicalFill);
parcelHelpers.export(exports, "BsFileMedical", ()=>BsFileMedical);
parcelHelpers.export(exports, "BsFileMinusFill", ()=>BsFileMinusFill);
parcelHelpers.export(exports, "BsFileMinus", ()=>BsFileMinus);
parcelHelpers.export(exports, "BsFileMusicFill", ()=>BsFileMusicFill);
parcelHelpers.export(exports, "BsFileMusic", ()=>BsFileMusic);
parcelHelpers.export(exports, "BsFilePdfFill", ()=>BsFilePdfFill);
parcelHelpers.export(exports, "BsFilePdf", ()=>BsFilePdf);
parcelHelpers.export(exports, "BsFilePersonFill", ()=>BsFilePersonFill);
parcelHelpers.export(exports, "BsFilePerson", ()=>BsFilePerson);
parcelHelpers.export(exports, "BsFilePlayFill", ()=>BsFilePlayFill);
parcelHelpers.export(exports, "BsFilePlay", ()=>BsFilePlay);
parcelHelpers.export(exports, "BsFilePlusFill", ()=>BsFilePlusFill);
parcelHelpers.export(exports, "BsFilePlus", ()=>BsFilePlus);
parcelHelpers.export(exports, "BsFilePostFill", ()=>BsFilePostFill);
parcelHelpers.export(exports, "BsFilePost", ()=>BsFilePost);
parcelHelpers.export(exports, "BsFilePptFill", ()=>BsFilePptFill);
parcelHelpers.export(exports, "BsFilePpt", ()=>BsFilePpt);
parcelHelpers.export(exports, "BsFileRichtextFill", ()=>BsFileRichtextFill);
parcelHelpers.export(exports, "BsFileRichtext", ()=>BsFileRichtext);
parcelHelpers.export(exports, "BsFileRuledFill", ()=>BsFileRuledFill);
parcelHelpers.export(exports, "BsFileRuled", ()=>BsFileRuled);
parcelHelpers.export(exports, "BsFileSlidesFill", ()=>BsFileSlidesFill);
parcelHelpers.export(exports, "BsFileSlides", ()=>BsFileSlides);
parcelHelpers.export(exports, "BsFileSpreadsheetFill", ()=>BsFileSpreadsheetFill);
parcelHelpers.export(exports, "BsFileSpreadsheet", ()=>BsFileSpreadsheet);
parcelHelpers.export(exports, "BsFileTextFill", ()=>BsFileTextFill);
parcelHelpers.export(exports, "BsFileText", ()=>BsFileText);
parcelHelpers.export(exports, "BsFileWordFill", ()=>BsFileWordFill);
parcelHelpers.export(exports, "BsFileWord", ()=>BsFileWord);
parcelHelpers.export(exports, "BsFileXFill", ()=>BsFileXFill);
parcelHelpers.export(exports, "BsFileX", ()=>BsFileX);
parcelHelpers.export(exports, "BsFileZipFill", ()=>BsFileZipFill);
parcelHelpers.export(exports, "BsFileZip", ()=>BsFileZip);
parcelHelpers.export(exports, "BsFile", ()=>BsFile);
parcelHelpers.export(exports, "BsFilesAlt", ()=>BsFilesAlt);
parcelHelpers.export(exports, "BsFiles", ()=>BsFiles);
parcelHelpers.export(exports, "BsFiletypeAac", ()=>BsFiletypeAac);
parcelHelpers.export(exports, "BsFiletypeAi", ()=>BsFiletypeAi);
parcelHelpers.export(exports, "BsFiletypeBmp", ()=>BsFiletypeBmp);
parcelHelpers.export(exports, "BsFiletypeCs", ()=>BsFiletypeCs);
parcelHelpers.export(exports, "BsFiletypeCss", ()=>BsFiletypeCss);
parcelHelpers.export(exports, "BsFiletypeCsv", ()=>BsFiletypeCsv);
parcelHelpers.export(exports, "BsFiletypeDoc", ()=>BsFiletypeDoc);
parcelHelpers.export(exports, "BsFiletypeDocx", ()=>BsFiletypeDocx);
parcelHelpers.export(exports, "BsFiletypeExe", ()=>BsFiletypeExe);
parcelHelpers.export(exports, "BsFiletypeGif", ()=>BsFiletypeGif);
parcelHelpers.export(exports, "BsFiletypeHeic", ()=>BsFiletypeHeic);
parcelHelpers.export(exports, "BsFiletypeHtml", ()=>BsFiletypeHtml);
parcelHelpers.export(exports, "BsFiletypeJava", ()=>BsFiletypeJava);
parcelHelpers.export(exports, "BsFiletypeJpg", ()=>BsFiletypeJpg);
parcelHelpers.export(exports, "BsFiletypeJs", ()=>BsFiletypeJs);
parcelHelpers.export(exports, "BsFiletypeJson", ()=>BsFiletypeJson);
parcelHelpers.export(exports, "BsFiletypeJsx", ()=>BsFiletypeJsx);
parcelHelpers.export(exports, "BsFiletypeKey", ()=>BsFiletypeKey);
parcelHelpers.export(exports, "BsFiletypeM4P", ()=>BsFiletypeM4P);
parcelHelpers.export(exports, "BsFiletypeMd", ()=>BsFiletypeMd);
parcelHelpers.export(exports, "BsFiletypeMdx", ()=>BsFiletypeMdx);
parcelHelpers.export(exports, "BsFiletypeMov", ()=>BsFiletypeMov);
parcelHelpers.export(exports, "BsFiletypeMp3", ()=>BsFiletypeMp3);
parcelHelpers.export(exports, "BsFiletypeMp4", ()=>BsFiletypeMp4);
parcelHelpers.export(exports, "BsFiletypeOtf", ()=>BsFiletypeOtf);
parcelHelpers.export(exports, "BsFiletypePdf", ()=>BsFiletypePdf);
parcelHelpers.export(exports, "BsFiletypePhp", ()=>BsFiletypePhp);
parcelHelpers.export(exports, "BsFiletypePng", ()=>BsFiletypePng);
parcelHelpers.export(exports, "BsFiletypePpt", ()=>BsFiletypePpt);
parcelHelpers.export(exports, "BsFiletypePptx", ()=>BsFiletypePptx);
parcelHelpers.export(exports, "BsFiletypePsd", ()=>BsFiletypePsd);
parcelHelpers.export(exports, "BsFiletypePy", ()=>BsFiletypePy);
parcelHelpers.export(exports, "BsFiletypeRaw", ()=>BsFiletypeRaw);
parcelHelpers.export(exports, "BsFiletypeRb", ()=>BsFiletypeRb);
parcelHelpers.export(exports, "BsFiletypeSass", ()=>BsFiletypeSass);
parcelHelpers.export(exports, "BsFiletypeScss", ()=>BsFiletypeScss);
parcelHelpers.export(exports, "BsFiletypeSh", ()=>BsFiletypeSh);
parcelHelpers.export(exports, "BsFiletypeSql", ()=>BsFiletypeSql);
parcelHelpers.export(exports, "BsFiletypeSvg", ()=>BsFiletypeSvg);
parcelHelpers.export(exports, "BsFiletypeTiff", ()=>BsFiletypeTiff);
parcelHelpers.export(exports, "BsFiletypeTsx", ()=>BsFiletypeTsx);
parcelHelpers.export(exports, "BsFiletypeTtf", ()=>BsFiletypeTtf);
parcelHelpers.export(exports, "BsFiletypeTxt", ()=>BsFiletypeTxt);
parcelHelpers.export(exports, "BsFiletypeWav", ()=>BsFiletypeWav);
parcelHelpers.export(exports, "BsFiletypeWoff", ()=>BsFiletypeWoff);
parcelHelpers.export(exports, "BsFiletypeXls", ()=>BsFiletypeXls);
parcelHelpers.export(exports, "BsFiletypeXlsx", ()=>BsFiletypeXlsx);
parcelHelpers.export(exports, "BsFiletypeXml", ()=>BsFiletypeXml);
parcelHelpers.export(exports, "BsFiletypeYml", ()=>BsFiletypeYml);
parcelHelpers.export(exports, "BsFilm", ()=>BsFilm);
parcelHelpers.export(exports, "BsFilterCircleFill", ()=>BsFilterCircleFill);
parcelHelpers.export(exports, "BsFilterCircle", ()=>BsFilterCircle);
parcelHelpers.export(exports, "BsFilterLeft", ()=>BsFilterLeft);
parcelHelpers.export(exports, "BsFilterRight", ()=>BsFilterRight);
parcelHelpers.export(exports, "BsFilterSquareFill", ()=>BsFilterSquareFill);
parcelHelpers.export(exports, "BsFilterSquare", ()=>BsFilterSquare);
parcelHelpers.export(exports, "BsFilter", ()=>BsFilter);
parcelHelpers.export(exports, "BsFingerprint", ()=>BsFingerprint);
parcelHelpers.export(exports, "BsFire", ()=>BsFire);
parcelHelpers.export(exports, "BsFlagFill", ()=>BsFlagFill);
parcelHelpers.export(exports, "BsFlag", ()=>BsFlag);
parcelHelpers.export(exports, "BsFloppyFill", ()=>BsFloppyFill);
parcelHelpers.export(exports, "BsFloppy", ()=>BsFloppy);
parcelHelpers.export(exports, "BsFloppy2Fill", ()=>BsFloppy2Fill);
parcelHelpers.export(exports, "BsFloppy2", ()=>BsFloppy2);
parcelHelpers.export(exports, "BsFlower1", ()=>BsFlower1);
parcelHelpers.export(exports, "BsFlower2", ()=>BsFlower2);
parcelHelpers.export(exports, "BsFlower3", ()=>BsFlower3);
parcelHelpers.export(exports, "BsFolderCheck", ()=>BsFolderCheck);
parcelHelpers.export(exports, "BsFolderFill", ()=>BsFolderFill);
parcelHelpers.export(exports, "BsFolderMinus", ()=>BsFolderMinus);
parcelHelpers.export(exports, "BsFolderPlus", ()=>BsFolderPlus);
parcelHelpers.export(exports, "BsFolderSymlinkFill", ()=>BsFolderSymlinkFill);
parcelHelpers.export(exports, "BsFolderSymlink", ()=>BsFolderSymlink);
parcelHelpers.export(exports, "BsFolderX", ()=>BsFolderX);
parcelHelpers.export(exports, "BsFolder", ()=>BsFolder);
parcelHelpers.export(exports, "BsFolder2Open", ()=>BsFolder2Open);
parcelHelpers.export(exports, "BsFolder2", ()=>BsFolder2);
parcelHelpers.export(exports, "BsFonts", ()=>BsFonts);
parcelHelpers.export(exports, "BsForwardFill", ()=>BsForwardFill);
parcelHelpers.export(exports, "BsForward", ()=>BsForward);
parcelHelpers.export(exports, "BsFront", ()=>BsFront);
parcelHelpers.export(exports, "BsFuelPumpDieselFill", ()=>BsFuelPumpDieselFill);
parcelHelpers.export(exports, "BsFuelPumpDiesel", ()=>BsFuelPumpDiesel);
parcelHelpers.export(exports, "BsFuelPumpFill", ()=>BsFuelPumpFill);
parcelHelpers.export(exports, "BsFuelPump", ()=>BsFuelPump);
parcelHelpers.export(exports, "BsFullscreenExit", ()=>BsFullscreenExit);
parcelHelpers.export(exports, "BsFullscreen", ()=>BsFullscreen);
parcelHelpers.export(exports, "BsFunnelFill", ()=>BsFunnelFill);
parcelHelpers.export(exports, "BsFunnel", ()=>BsFunnel);
parcelHelpers.export(exports, "BsGearFill", ()=>BsGearFill);
parcelHelpers.export(exports, "BsGearWideConnected", ()=>BsGearWideConnected);
parcelHelpers.export(exports, "BsGearWide", ()=>BsGearWide);
parcelHelpers.export(exports, "BsGear", ()=>BsGear);
parcelHelpers.export(exports, "BsGem", ()=>BsGem);
parcelHelpers.export(exports, "BsGenderAmbiguous", ()=>BsGenderAmbiguous);
parcelHelpers.export(exports, "BsGenderFemale", ()=>BsGenderFemale);
parcelHelpers.export(exports, "BsGenderMale", ()=>BsGenderMale);
parcelHelpers.export(exports, "BsGenderNeuter", ()=>BsGenderNeuter);
parcelHelpers.export(exports, "BsGenderTrans", ()=>BsGenderTrans);
parcelHelpers.export(exports, "BsGeoAltFill", ()=>BsGeoAltFill);
parcelHelpers.export(exports, "BsGeoAlt", ()=>BsGeoAlt);
parcelHelpers.export(exports, "BsGeoFill", ()=>BsGeoFill);
parcelHelpers.export(exports, "BsGeo", ()=>BsGeo);
parcelHelpers.export(exports, "BsGiftFill", ()=>BsGiftFill);
parcelHelpers.export(exports, "BsGift", ()=>BsGift);
parcelHelpers.export(exports, "BsGit", ()=>BsGit);
parcelHelpers.export(exports, "BsGithub", ()=>BsGithub);
parcelHelpers.export(exports, "BsGitlab", ()=>BsGitlab);
parcelHelpers.export(exports, "BsGlobeAmericas", ()=>BsGlobeAmericas);
parcelHelpers.export(exports, "BsGlobeAsiaAustralia", ()=>BsGlobeAsiaAustralia);
parcelHelpers.export(exports, "BsGlobeCentralSouthAsia", ()=>BsGlobeCentralSouthAsia);
parcelHelpers.export(exports, "BsGlobeEuropeAfrica", ()=>BsGlobeEuropeAfrica);
parcelHelpers.export(exports, "BsGlobe", ()=>BsGlobe);
parcelHelpers.export(exports, "BsGlobe2", ()=>BsGlobe2);
parcelHelpers.export(exports, "BsGooglePlay", ()=>BsGooglePlay);
parcelHelpers.export(exports, "BsGoogle", ()=>BsGoogle);
parcelHelpers.export(exports, "BsGpuCard", ()=>BsGpuCard);
parcelHelpers.export(exports, "BsGraphDownArrow", ()=>BsGraphDownArrow);
parcelHelpers.export(exports, "BsGraphDown", ()=>BsGraphDown);
parcelHelpers.export(exports, "BsGraphUpArrow", ()=>BsGraphUpArrow);
parcelHelpers.export(exports, "BsGraphUp", ()=>BsGraphUp);
parcelHelpers.export(exports, "BsGrid1X2Fill", ()=>BsGrid1X2Fill);
parcelHelpers.export(exports, "BsGrid1X2", ()=>BsGrid1X2);
parcelHelpers.export(exports, "BsGrid3X2GapFill", ()=>BsGrid3X2GapFill);
parcelHelpers.export(exports, "BsGrid3X2Gap", ()=>BsGrid3X2Gap);
parcelHelpers.export(exports, "BsGrid3X2", ()=>BsGrid3X2);
parcelHelpers.export(exports, "BsGrid3X3GapFill", ()=>BsGrid3X3GapFill);
parcelHelpers.export(exports, "BsGrid3X3Gap", ()=>BsGrid3X3Gap);
parcelHelpers.export(exports, "BsGrid3X3", ()=>BsGrid3X3);
parcelHelpers.export(exports, "BsGridFill", ()=>BsGridFill);
parcelHelpers.export(exports, "BsGrid", ()=>BsGrid);
parcelHelpers.export(exports, "BsGripHorizontal", ()=>BsGripHorizontal);
parcelHelpers.export(exports, "BsGripVertical", ()=>BsGripVertical);
parcelHelpers.export(exports, "BsHCircleFill", ()=>BsHCircleFill);
parcelHelpers.export(exports, "BsHCircle", ()=>BsHCircle);
parcelHelpers.export(exports, "BsHSquareFill", ()=>BsHSquareFill);
parcelHelpers.export(exports, "BsHSquare", ()=>BsHSquare);
parcelHelpers.export(exports, "BsHammer", ()=>BsHammer);
parcelHelpers.export(exports, "BsHandIndexFill", ()=>BsHandIndexFill);
parcelHelpers.export(exports, "BsHandIndexThumbFill", ()=>BsHandIndexThumbFill);
parcelHelpers.export(exports, "BsHandIndexThumb", ()=>BsHandIndexThumb);
parcelHelpers.export(exports, "BsHandIndex", ()=>BsHandIndex);
parcelHelpers.export(exports, "BsHandThumbsDownFill", ()=>BsHandThumbsDownFill);
parcelHelpers.export(exports, "BsHandThumbsDown", ()=>BsHandThumbsDown);
parcelHelpers.export(exports, "BsHandThumbsUpFill", ()=>BsHandThumbsUpFill);
parcelHelpers.export(exports, "BsHandThumbsUp", ()=>BsHandThumbsUp);
parcelHelpers.export(exports, "BsHandbagFill", ()=>BsHandbagFill);
parcelHelpers.export(exports, "BsHandbag", ()=>BsHandbag);
parcelHelpers.export(exports, "BsHash", ()=>BsHash);
parcelHelpers.export(exports, "BsHddFill", ()=>BsHddFill);
parcelHelpers.export(exports, "BsHddNetworkFill", ()=>BsHddNetworkFill);
parcelHelpers.export(exports, "BsHddNetwork", ()=>BsHddNetwork);
parcelHelpers.export(exports, "BsHddRackFill", ()=>BsHddRackFill);
parcelHelpers.export(exports, "BsHddRack", ()=>BsHddRack);
parcelHelpers.export(exports, "BsHddStackFill", ()=>BsHddStackFill);
parcelHelpers.export(exports, "BsHddStack", ()=>BsHddStack);
parcelHelpers.export(exports, "BsHdd", ()=>BsHdd);
parcelHelpers.export(exports, "BsHdmiFill", ()=>BsHdmiFill);
parcelHelpers.export(exports, "BsHdmi", ()=>BsHdmi);
parcelHelpers.export(exports, "BsHeadphones", ()=>BsHeadphones);
parcelHelpers.export(exports, "BsHeadsetVr", ()=>BsHeadsetVr);
parcelHelpers.export(exports, "BsHeadset", ()=>BsHeadset);
parcelHelpers.export(exports, "BsHeartArrow", ()=>BsHeartArrow);
parcelHelpers.export(exports, "BsHeartFill", ()=>BsHeartFill);
parcelHelpers.export(exports, "BsHeartHalf", ()=>BsHeartHalf);
parcelHelpers.export(exports, "BsHeartPulseFill", ()=>BsHeartPulseFill);
parcelHelpers.export(exports, "BsHeartPulse", ()=>BsHeartPulse);
parcelHelpers.export(exports, "BsHeart", ()=>BsHeart);
parcelHelpers.export(exports, "BsHeartbreakFill", ()=>BsHeartbreakFill);
parcelHelpers.export(exports, "BsHeartbreak", ()=>BsHeartbreak);
parcelHelpers.export(exports, "BsHearts", ()=>BsHearts);
parcelHelpers.export(exports, "BsHeptagonFill", ()=>BsHeptagonFill);
parcelHelpers.export(exports, "BsHeptagonHalf", ()=>BsHeptagonHalf);
parcelHelpers.export(exports, "BsHeptagon", ()=>BsHeptagon);
parcelHelpers.export(exports, "BsHexagonFill", ()=>BsHexagonFill);
parcelHelpers.export(exports, "BsHexagonHalf", ()=>BsHexagonHalf);
parcelHelpers.export(exports, "BsHexagon", ()=>BsHexagon);
parcelHelpers.export(exports, "BsHighlighter", ()=>BsHighlighter);
parcelHelpers.export(exports, "BsHighlights", ()=>BsHighlights);
parcelHelpers.export(exports, "BsHospitalFill", ()=>BsHospitalFill);
parcelHelpers.export(exports, "BsHospital", ()=>BsHospital);
parcelHelpers.export(exports, "BsHourglassBottom", ()=>BsHourglassBottom);
parcelHelpers.export(exports, "BsHourglassSplit", ()=>BsHourglassSplit);
parcelHelpers.export(exports, "BsHourglassTop", ()=>BsHourglassTop);
parcelHelpers.export(exports, "BsHourglass", ()=>BsHourglass);
parcelHelpers.export(exports, "BsHouseAddFill", ()=>BsHouseAddFill);
parcelHelpers.export(exports, "BsHouseAdd", ()=>BsHouseAdd);
parcelHelpers.export(exports, "BsHouseCheckFill", ()=>BsHouseCheckFill);
parcelHelpers.export(exports, "BsHouseCheck", ()=>BsHouseCheck);
parcelHelpers.export(exports, "BsHouseDashFill", ()=>BsHouseDashFill);
parcelHelpers.export(exports, "BsHouseDash", ()=>BsHouseDash);
parcelHelpers.export(exports, "BsHouseDoorFill", ()=>BsHouseDoorFill);
parcelHelpers.export(exports, "BsHouseDoor", ()=>BsHouseDoor);
parcelHelpers.export(exports, "BsHouseDownFill", ()=>BsHouseDownFill);
parcelHelpers.export(exports, "BsHouseDown", ()=>BsHouseDown);
parcelHelpers.export(exports, "BsHouseExclamationFill", ()=>BsHouseExclamationFill);
parcelHelpers.export(exports, "BsHouseExclamation", ()=>BsHouseExclamation);
parcelHelpers.export(exports, "BsHouseFill", ()=>BsHouseFill);
parcelHelpers.export(exports, "BsHouseGearFill", ()=>BsHouseGearFill);
parcelHelpers.export(exports, "BsHouseGear", ()=>BsHouseGear);
parcelHelpers.export(exports, "BsHouseHeartFill", ()=>BsHouseHeartFill);
parcelHelpers.export(exports, "BsHouseHeart", ()=>BsHouseHeart);
parcelHelpers.export(exports, "BsHouseLockFill", ()=>BsHouseLockFill);
parcelHelpers.export(exports, "BsHouseLock", ()=>BsHouseLock);
parcelHelpers.export(exports, "BsHouseSlashFill", ()=>BsHouseSlashFill);
parcelHelpers.export(exports, "BsHouseSlash", ()=>BsHouseSlash);
parcelHelpers.export(exports, "BsHouseUpFill", ()=>BsHouseUpFill);
parcelHelpers.export(exports, "BsHouseUp", ()=>BsHouseUp);
parcelHelpers.export(exports, "BsHouseXFill", ()=>BsHouseXFill);
parcelHelpers.export(exports, "BsHouseX", ()=>BsHouseX);
parcelHelpers.export(exports, "BsHouse", ()=>BsHouse);
parcelHelpers.export(exports, "BsHousesFill", ()=>BsHousesFill);
parcelHelpers.export(exports, "BsHouses", ()=>BsHouses);
parcelHelpers.export(exports, "BsHr", ()=>BsHr);
parcelHelpers.export(exports, "BsHurricane", ()=>BsHurricane);
parcelHelpers.export(exports, "BsHypnotize", ()=>BsHypnotize);
parcelHelpers.export(exports, "BsImageAlt", ()=>BsImageAlt);
parcelHelpers.export(exports, "BsImageFill", ()=>BsImageFill);
parcelHelpers.export(exports, "BsImage", ()=>BsImage);
parcelHelpers.export(exports, "BsImages", ()=>BsImages);
parcelHelpers.export(exports, "BsInboxFill", ()=>BsInboxFill);
parcelHelpers.export(exports, "BsInbox", ()=>BsInbox);
parcelHelpers.export(exports, "BsInboxesFill", ()=>BsInboxesFill);
parcelHelpers.export(exports, "BsInboxes", ()=>BsInboxes);
parcelHelpers.export(exports, "BsIncognito", ()=>BsIncognito);
parcelHelpers.export(exports, "BsIndent", ()=>BsIndent);
parcelHelpers.export(exports, "BsInfinity", ()=>BsInfinity);
parcelHelpers.export(exports, "BsInfoCircleFill", ()=>BsInfoCircleFill);
parcelHelpers.export(exports, "BsInfoCircle", ()=>BsInfoCircle);
parcelHelpers.export(exports, "BsInfoLg", ()=>BsInfoLg);
parcelHelpers.export(exports, "BsInfoSquareFill", ()=>BsInfoSquareFill);
parcelHelpers.export(exports, "BsInfoSquare", ()=>BsInfoSquare);
parcelHelpers.export(exports, "BsInfo", ()=>BsInfo);
parcelHelpers.export(exports, "BsInputCursorText", ()=>BsInputCursorText);
parcelHelpers.export(exports, "BsInputCursor", ()=>BsInputCursor);
parcelHelpers.export(exports, "BsInstagram", ()=>BsInstagram);
parcelHelpers.export(exports, "BsIntersect", ()=>BsIntersect);
parcelHelpers.export(exports, "BsJournalAlbum", ()=>BsJournalAlbum);
parcelHelpers.export(exports, "BsJournalArrowDown", ()=>BsJournalArrowDown);
parcelHelpers.export(exports, "BsJournalArrowUp", ()=>BsJournalArrowUp);
parcelHelpers.export(exports, "BsJournalBookmarkFill", ()=>BsJournalBookmarkFill);
parcelHelpers.export(exports, "BsJournalBookmark", ()=>BsJournalBookmark);
parcelHelpers.export(exports, "BsJournalCheck", ()=>BsJournalCheck);
parcelHelpers.export(exports, "BsJournalCode", ()=>BsJournalCode);
parcelHelpers.export(exports, "BsJournalMedical", ()=>BsJournalMedical);
parcelHelpers.export(exports, "BsJournalMinus", ()=>BsJournalMinus);
parcelHelpers.export(exports, "BsJournalPlus", ()=>BsJournalPlus);
parcelHelpers.export(exports, "BsJournalRichtext", ()=>BsJournalRichtext);
parcelHelpers.export(exports, "BsJournalText", ()=>BsJournalText);
parcelHelpers.export(exports, "BsJournalX", ()=>BsJournalX);
parcelHelpers.export(exports, "BsJournal", ()=>BsJournal);
parcelHelpers.export(exports, "BsJournals", ()=>BsJournals);
parcelHelpers.export(exports, "BsJoystick", ()=>BsJoystick);
parcelHelpers.export(exports, "BsJustifyLeft", ()=>BsJustifyLeft);
parcelHelpers.export(exports, "BsJustifyRight", ()=>BsJustifyRight);
parcelHelpers.export(exports, "BsJustify", ()=>BsJustify);
parcelHelpers.export(exports, "BsKanbanFill", ()=>BsKanbanFill);
parcelHelpers.export(exports, "BsKanban", ()=>BsKanban);
parcelHelpers.export(exports, "BsKeyFill", ()=>BsKeyFill);
parcelHelpers.export(exports, "BsKey", ()=>BsKey);
parcelHelpers.export(exports, "BsKeyboardFill", ()=>BsKeyboardFill);
parcelHelpers.export(exports, "BsKeyboard", ()=>BsKeyboard);
parcelHelpers.export(exports, "BsLadder", ()=>BsLadder);
parcelHelpers.export(exports, "BsLampFill", ()=>BsLampFill);
parcelHelpers.export(exports, "BsLamp", ()=>BsLamp);
parcelHelpers.export(exports, "BsLaptopFill", ()=>BsLaptopFill);
parcelHelpers.export(exports, "BsLaptop", ()=>BsLaptop);
parcelHelpers.export(exports, "BsLayerBackward", ()=>BsLayerBackward);
parcelHelpers.export(exports, "BsLayerForward", ()=>BsLayerForward);
parcelHelpers.export(exports, "BsLayersFill", ()=>BsLayersFill);
parcelHelpers.export(exports, "BsLayersHalf", ()=>BsLayersHalf);
parcelHelpers.export(exports, "BsLayers", ()=>BsLayers);
parcelHelpers.export(exports, "BsLayoutSidebarInsetReverse", ()=>BsLayoutSidebarInsetReverse);
parcelHelpers.export(exports, "BsLayoutSidebarInset", ()=>BsLayoutSidebarInset);
parcelHelpers.export(exports, "BsLayoutSidebarReverse", ()=>BsLayoutSidebarReverse);
parcelHelpers.export(exports, "BsLayoutSidebar", ()=>BsLayoutSidebar);
parcelHelpers.export(exports, "BsLayoutSplit", ()=>BsLayoutSplit);
parcelHelpers.export(exports, "BsLayoutTextSidebarReverse", ()=>BsLayoutTextSidebarReverse);
parcelHelpers.export(exports, "BsLayoutTextSidebar", ()=>BsLayoutTextSidebar);
parcelHelpers.export(exports, "BsLayoutTextWindowReverse", ()=>BsLayoutTextWindowReverse);
parcelHelpers.export(exports, "BsLayoutTextWindow", ()=>BsLayoutTextWindow);
parcelHelpers.export(exports, "BsLayoutThreeColumns", ()=>BsLayoutThreeColumns);
parcelHelpers.export(exports, "BsLayoutWtf", ()=>BsLayoutWtf);
parcelHelpers.export(exports, "BsLifePreserver", ()=>BsLifePreserver);
parcelHelpers.export(exports, "BsLightbulbFill", ()=>BsLightbulbFill);
parcelHelpers.export(exports, "BsLightbulbOffFill", ()=>BsLightbulbOffFill);
parcelHelpers.export(exports, "BsLightbulbOff", ()=>BsLightbulbOff);
parcelHelpers.export(exports, "BsLightbulb", ()=>BsLightbulb);
parcelHelpers.export(exports, "BsLightningChargeFill", ()=>BsLightningChargeFill);
parcelHelpers.export(exports, "BsLightningCharge", ()=>BsLightningCharge);
parcelHelpers.export(exports, "BsLightningFill", ()=>BsLightningFill);
parcelHelpers.export(exports, "BsLightning", ()=>BsLightning);
parcelHelpers.export(exports, "BsLine", ()=>BsLine);
parcelHelpers.export(exports, "BsLink45Deg", ()=>BsLink45Deg);
parcelHelpers.export(exports, "BsLink", ()=>BsLink);
parcelHelpers.export(exports, "BsLinkedin", ()=>BsLinkedin);
parcelHelpers.export(exports, "BsListCheck", ()=>BsListCheck);
parcelHelpers.export(exports, "BsListColumnsReverse", ()=>BsListColumnsReverse);
parcelHelpers.export(exports, "BsListColumns", ()=>BsListColumns);
parcelHelpers.export(exports, "BsListNested", ()=>BsListNested);
parcelHelpers.export(exports, "BsListOl", ()=>BsListOl);
parcelHelpers.export(exports, "BsListStars", ()=>BsListStars);
parcelHelpers.export(exports, "BsListTask", ()=>BsListTask);
parcelHelpers.export(exports, "BsListUl", ()=>BsListUl);
parcelHelpers.export(exports, "BsList", ()=>BsList);
parcelHelpers.export(exports, "BsLockFill", ()=>BsLockFill);
parcelHelpers.export(exports, "BsLock", ()=>BsLock);
parcelHelpers.export(exports, "BsLuggageFill", ()=>BsLuggageFill);
parcelHelpers.export(exports, "BsLuggage", ()=>BsLuggage);
parcelHelpers.export(exports, "BsLungsFill", ()=>BsLungsFill);
parcelHelpers.export(exports, "BsLungs", ()=>BsLungs);
parcelHelpers.export(exports, "BsMagic", ()=>BsMagic);
parcelHelpers.export(exports, "BsMagnetFill", ()=>BsMagnetFill);
parcelHelpers.export(exports, "BsMagnet", ()=>BsMagnet);
parcelHelpers.export(exports, "BsMailboxFlag", ()=>BsMailboxFlag);
parcelHelpers.export(exports, "BsMailbox", ()=>BsMailbox);
parcelHelpers.export(exports, "BsMailbox2Flag", ()=>BsMailbox2Flag);
parcelHelpers.export(exports, "BsMailbox2", ()=>BsMailbox2);
parcelHelpers.export(exports, "BsMapFill", ()=>BsMapFill);
parcelHelpers.export(exports, "BsMap", ()=>BsMap);
parcelHelpers.export(exports, "BsMarkdownFill", ()=>BsMarkdownFill);
parcelHelpers.export(exports, "BsMarkdown", ()=>BsMarkdown);
parcelHelpers.export(exports, "BsMarkerTip", ()=>BsMarkerTip);
parcelHelpers.export(exports, "BsMask", ()=>BsMask);
parcelHelpers.export(exports, "BsMastodon", ()=>BsMastodon);
parcelHelpers.export(exports, "BsMedium", ()=>BsMedium);
parcelHelpers.export(exports, "BsMegaphoneFill", ()=>BsMegaphoneFill);
parcelHelpers.export(exports, "BsMegaphone", ()=>BsMegaphone);
parcelHelpers.export(exports, "BsMemory", ()=>BsMemory);
parcelHelpers.export(exports, "BsMenuAppFill", ()=>BsMenuAppFill);
parcelHelpers.export(exports, "BsMenuApp", ()=>BsMenuApp);
parcelHelpers.export(exports, "BsMenuButtonFill", ()=>BsMenuButtonFill);
parcelHelpers.export(exports, "BsMenuButtonWideFill", ()=>BsMenuButtonWideFill);
parcelHelpers.export(exports, "BsMenuButtonWide", ()=>BsMenuButtonWide);
parcelHelpers.export(exports, "BsMenuButton", ()=>BsMenuButton);
parcelHelpers.export(exports, "BsMenuDown", ()=>BsMenuDown);
parcelHelpers.export(exports, "BsMenuUp", ()=>BsMenuUp);
parcelHelpers.export(exports, "BsMessenger", ()=>BsMessenger);
parcelHelpers.export(exports, "BsMeta", ()=>BsMeta);
parcelHelpers.export(exports, "BsMicFill", ()=>BsMicFill);
parcelHelpers.export(exports, "BsMicMuteFill", ()=>BsMicMuteFill);
parcelHelpers.export(exports, "BsMicMute", ()=>BsMicMute);
parcelHelpers.export(exports, "BsMic", ()=>BsMic);
parcelHelpers.export(exports, "BsMicrosoftTeams", ()=>BsMicrosoftTeams);
parcelHelpers.export(exports, "BsMicrosoft", ()=>BsMicrosoft);
parcelHelpers.export(exports, "BsMinecartLoaded", ()=>BsMinecartLoaded);
parcelHelpers.export(exports, "BsMinecart", ()=>BsMinecart);
parcelHelpers.export(exports, "BsModemFill", ()=>BsModemFill);
parcelHelpers.export(exports, "BsModem", ()=>BsModem);
parcelHelpers.export(exports, "BsMoisture", ()=>BsMoisture);
parcelHelpers.export(exports, "BsMoonFill", ()=>BsMoonFill);
parcelHelpers.export(exports, "BsMoonStarsFill", ()=>BsMoonStarsFill);
parcelHelpers.export(exports, "BsMoonStars", ()=>BsMoonStars);
parcelHelpers.export(exports, "BsMoon", ()=>BsMoon);
parcelHelpers.export(exports, "BsMortarboardFill", ()=>BsMortarboardFill);
parcelHelpers.export(exports, "BsMortarboard", ()=>BsMortarboard);
parcelHelpers.export(exports, "BsMotherboardFill", ()=>BsMotherboardFill);
parcelHelpers.export(exports, "BsMotherboard", ()=>BsMotherboard);
parcelHelpers.export(exports, "BsMouseFill", ()=>BsMouseFill);
parcelHelpers.export(exports, "BsMouse", ()=>BsMouse);
parcelHelpers.export(exports, "BsMouse2Fill", ()=>BsMouse2Fill);
parcelHelpers.export(exports, "BsMouse2", ()=>BsMouse2);
parcelHelpers.export(exports, "BsMouse3Fill", ()=>BsMouse3Fill);
parcelHelpers.export(exports, "BsMouse3", ()=>BsMouse3);
parcelHelpers.export(exports, "BsMusicNoteBeamed", ()=>BsMusicNoteBeamed);
parcelHelpers.export(exports, "BsMusicNoteList", ()=>BsMusicNoteList);
parcelHelpers.export(exports, "BsMusicNote", ()=>BsMusicNote);
parcelHelpers.export(exports, "BsMusicPlayerFill", ()=>BsMusicPlayerFill);
parcelHelpers.export(exports, "BsMusicPlayer", ()=>BsMusicPlayer);
parcelHelpers.export(exports, "BsNewspaper", ()=>BsNewspaper);
parcelHelpers.export(exports, "BsNintendoSwitch", ()=>BsNintendoSwitch);
parcelHelpers.export(exports, "BsNodeMinusFill", ()=>BsNodeMinusFill);
parcelHelpers.export(exports, "BsNodeMinus", ()=>BsNodeMinus);
parcelHelpers.export(exports, "BsNodePlusFill", ()=>BsNodePlusFill);
parcelHelpers.export(exports, "BsNodePlus", ()=>BsNodePlus);
parcelHelpers.export(exports, "BsNoiseReduction", ()=>BsNoiseReduction);
parcelHelpers.export(exports, "BsNutFill", ()=>BsNutFill);
parcelHelpers.export(exports, "BsNut", ()=>BsNut);
parcelHelpers.export(exports, "BsNvidia", ()=>BsNvidia);
parcelHelpers.export(exports, "BsNvmeFill", ()=>BsNvmeFill);
parcelHelpers.export(exports, "BsNvme", ()=>BsNvme);
parcelHelpers.export(exports, "BsOctagonFill", ()=>BsOctagonFill);
parcelHelpers.export(exports, "BsOctagonHalf", ()=>BsOctagonHalf);
parcelHelpers.export(exports, "BsOctagon", ()=>BsOctagon);
parcelHelpers.export(exports, "BsOpencollective", ()=>BsOpencollective);
parcelHelpers.export(exports, "BsOpticalAudioFill", ()=>BsOpticalAudioFill);
parcelHelpers.export(exports, "BsOpticalAudio", ()=>BsOpticalAudio);
parcelHelpers.export(exports, "BsOption", ()=>BsOption);
parcelHelpers.export(exports, "BsOutlet", ()=>BsOutlet);
parcelHelpers.export(exports, "BsPCircleFill", ()=>BsPCircleFill);
parcelHelpers.export(exports, "BsPCircle", ()=>BsPCircle);
parcelHelpers.export(exports, "BsPSquareFill", ()=>BsPSquareFill);
parcelHelpers.export(exports, "BsPSquare", ()=>BsPSquare);
parcelHelpers.export(exports, "BsPaintBucket", ()=>BsPaintBucket);
parcelHelpers.export(exports, "BsPaletteFill", ()=>BsPaletteFill);
parcelHelpers.export(exports, "BsPalette", ()=>BsPalette);
parcelHelpers.export(exports, "BsPalette2", ()=>BsPalette2);
parcelHelpers.export(exports, "BsPaperclip", ()=>BsPaperclip);
parcelHelpers.export(exports, "BsParagraph", ()=>BsParagraph);
parcelHelpers.export(exports, "BsPassFill", ()=>BsPassFill);
parcelHelpers.export(exports, "BsPass", ()=>BsPass);
parcelHelpers.export(exports, "BsPassportFill", ()=>BsPassportFill);
parcelHelpers.export(exports, "BsPassport", ()=>BsPassport);
parcelHelpers.export(exports, "BsPatchCheckFill", ()=>BsPatchCheckFill);
parcelHelpers.export(exports, "BsPatchCheck", ()=>BsPatchCheck);
parcelHelpers.export(exports, "BsPatchExclamationFill", ()=>BsPatchExclamationFill);
parcelHelpers.export(exports, "BsPatchExclamation", ()=>BsPatchExclamation);
parcelHelpers.export(exports, "BsPatchMinusFill", ()=>BsPatchMinusFill);
parcelHelpers.export(exports, "BsPatchMinus", ()=>BsPatchMinus);
parcelHelpers.export(exports, "BsPatchPlusFill", ()=>BsPatchPlusFill);
parcelHelpers.export(exports, "BsPatchPlus", ()=>BsPatchPlus);
parcelHelpers.export(exports, "BsPatchQuestionFill", ()=>BsPatchQuestionFill);
parcelHelpers.export(exports, "BsPatchQuestion", ()=>BsPatchQuestion);
parcelHelpers.export(exports, "BsPauseBtnFill", ()=>BsPauseBtnFill);
parcelHelpers.export(exports, "BsPauseBtn", ()=>BsPauseBtn);
parcelHelpers.export(exports, "BsPauseCircleFill", ()=>BsPauseCircleFill);
parcelHelpers.export(exports, "BsPauseCircle", ()=>BsPauseCircle);
parcelHelpers.export(exports, "BsPauseFill", ()=>BsPauseFill);
parcelHelpers.export(exports, "BsPause", ()=>BsPause);
parcelHelpers.export(exports, "BsPaypal", ()=>BsPaypal);
parcelHelpers.export(exports, "BsPcDisplayHorizontal", ()=>BsPcDisplayHorizontal);
parcelHelpers.export(exports, "BsPcDisplay", ()=>BsPcDisplay);
parcelHelpers.export(exports, "BsPcHorizontal", ()=>BsPcHorizontal);
parcelHelpers.export(exports, "BsPc", ()=>BsPc);
parcelHelpers.export(exports, "BsPciCardNetwork", ()=>BsPciCardNetwork);
parcelHelpers.export(exports, "BsPciCardSound", ()=>BsPciCardSound);
parcelHelpers.export(exports, "BsPciCard", ()=>BsPciCard);
parcelHelpers.export(exports, "BsPeaceFill", ()=>BsPeaceFill);
parcelHelpers.export(exports, "BsPeace", ()=>BsPeace);
parcelHelpers.export(exports, "BsPenFill", ()=>BsPenFill);
parcelHelpers.export(exports, "BsPen", ()=>BsPen);
parcelHelpers.export(exports, "BsPencilFill", ()=>BsPencilFill);
parcelHelpers.export(exports, "BsPencilSquare", ()=>BsPencilSquare);
parcelHelpers.export(exports, "BsPencil", ()=>BsPencil);
parcelHelpers.export(exports, "BsPentagonFill", ()=>BsPentagonFill);
parcelHelpers.export(exports, "BsPentagonHalf", ()=>BsPentagonHalf);
parcelHelpers.export(exports, "BsPentagon", ()=>BsPentagon);
parcelHelpers.export(exports, "BsPeopleFill", ()=>BsPeopleFill);
parcelHelpers.export(exports, "BsPeople", ()=>BsPeople);
parcelHelpers.export(exports, "BsPercent", ()=>BsPercent);
parcelHelpers.export(exports, "BsPersonAdd", ()=>BsPersonAdd);
parcelHelpers.export(exports, "BsPersonArmsUp", ()=>BsPersonArmsUp);
parcelHelpers.export(exports, "BsPersonBadgeFill", ()=>BsPersonBadgeFill);
parcelHelpers.export(exports, "BsPersonBadge", ()=>BsPersonBadge);
parcelHelpers.export(exports, "BsPersonBoundingBox", ()=>BsPersonBoundingBox);
parcelHelpers.export(exports, "BsPersonCheckFill", ()=>BsPersonCheckFill);
parcelHelpers.export(exports, "BsPersonCheck", ()=>BsPersonCheck);
parcelHelpers.export(exports, "BsPersonCircle", ()=>BsPersonCircle);
parcelHelpers.export(exports, "BsPersonDashFill", ()=>BsPersonDashFill);
parcelHelpers.export(exports, "BsPersonDash", ()=>BsPersonDash);
parcelHelpers.export(exports, "BsPersonDown", ()=>BsPersonDown);
parcelHelpers.export(exports, "BsPersonExclamation", ()=>BsPersonExclamation);
parcelHelpers.export(exports, "BsPersonFillAdd", ()=>BsPersonFillAdd);
parcelHelpers.export(exports, "BsPersonFillCheck", ()=>BsPersonFillCheck);
parcelHelpers.export(exports, "BsPersonFillDash", ()=>BsPersonFillDash);
parcelHelpers.export(exports, "BsPersonFillDown", ()=>BsPersonFillDown);
parcelHelpers.export(exports, "BsPersonFillExclamation", ()=>BsPersonFillExclamation);
parcelHelpers.export(exports, "BsPersonFillGear", ()=>BsPersonFillGear);
parcelHelpers.export(exports, "BsPersonFillLock", ()=>BsPersonFillLock);
parcelHelpers.export(exports, "BsPersonFillSlash", ()=>BsPersonFillSlash);
parcelHelpers.export(exports, "BsPersonFillUp", ()=>BsPersonFillUp);
parcelHelpers.export(exports, "BsPersonFillX", ()=>BsPersonFillX);
parcelHelpers.export(exports, "BsPersonFill", ()=>BsPersonFill);
parcelHelpers.export(exports, "BsPersonGear", ()=>BsPersonGear);
parcelHelpers.export(exports, "BsPersonHeart", ()=>BsPersonHeart);
parcelHelpers.export(exports, "BsPersonHearts", ()=>BsPersonHearts);
parcelHelpers.export(exports, "BsPersonLinesFill", ()=>BsPersonLinesFill);
parcelHelpers.export(exports, "BsPersonLock", ()=>BsPersonLock);
parcelHelpers.export(exports, "BsPersonPlusFill", ()=>BsPersonPlusFill);
parcelHelpers.export(exports, "BsPersonPlus", ()=>BsPersonPlus);
parcelHelpers.export(exports, "BsPersonRaisedHand", ()=>BsPersonRaisedHand);
parcelHelpers.export(exports, "BsPersonRolodex", ()=>BsPersonRolodex);
parcelHelpers.export(exports, "BsPersonSlash", ()=>BsPersonSlash);
parcelHelpers.export(exports, "BsPersonSquare", ()=>BsPersonSquare);
parcelHelpers.export(exports, "BsPersonStandingDress", ()=>BsPersonStandingDress);
parcelHelpers.export(exports, "BsPersonStanding", ()=>BsPersonStanding);
parcelHelpers.export(exports, "BsPersonUp", ()=>BsPersonUp);
parcelHelpers.export(exports, "BsPersonVcardFill", ()=>BsPersonVcardFill);
parcelHelpers.export(exports, "BsPersonVcard", ()=>BsPersonVcard);
parcelHelpers.export(exports, "BsPersonVideo", ()=>BsPersonVideo);
parcelHelpers.export(exports, "BsPersonVideo2", ()=>BsPersonVideo2);
parcelHelpers.export(exports, "BsPersonVideo3", ()=>BsPersonVideo3);
parcelHelpers.export(exports, "BsPersonWalking", ()=>BsPersonWalking);
parcelHelpers.export(exports, "BsPersonWheelchair", ()=>BsPersonWheelchair);
parcelHelpers.export(exports, "BsPersonWorkspace", ()=>BsPersonWorkspace);
parcelHelpers.export(exports, "BsPersonXFill", ()=>BsPersonXFill);
parcelHelpers.export(exports, "BsPersonX", ()=>BsPersonX);
parcelHelpers.export(exports, "BsPerson", ()=>BsPerson);
parcelHelpers.export(exports, "BsPhoneFill", ()=>BsPhoneFill);
parcelHelpers.export(exports, "BsPhoneFlip", ()=>BsPhoneFlip);
parcelHelpers.export(exports, "BsPhoneLandscapeFill", ()=>BsPhoneLandscapeFill);
parcelHelpers.export(exports, "BsPhoneLandscape", ()=>BsPhoneLandscape);
parcelHelpers.export(exports, "BsPhoneVibrateFill", ()=>BsPhoneVibrateFill);
parcelHelpers.export(exports, "BsPhoneVibrate", ()=>BsPhoneVibrate);
parcelHelpers.export(exports, "BsPhone", ()=>BsPhone);
parcelHelpers.export(exports, "BsPieChartFill", ()=>BsPieChartFill);
parcelHelpers.export(exports, "BsPieChart", ()=>BsPieChart);
parcelHelpers.export(exports, "BsPiggyBankFill", ()=>BsPiggyBankFill);
parcelHelpers.export(exports, "BsPiggyBank", ()=>BsPiggyBank);
parcelHelpers.export(exports, "BsPinAngleFill", ()=>BsPinAngleFill);
parcelHelpers.export(exports, "BsPinAngle", ()=>BsPinAngle);
parcelHelpers.export(exports, "BsPinFill", ()=>BsPinFill);
parcelHelpers.export(exports, "BsPinMapFill", ()=>BsPinMapFill);
parcelHelpers.export(exports, "BsPinMap", ()=>BsPinMap);
parcelHelpers.export(exports, "BsPin", ()=>BsPin);
parcelHelpers.export(exports, "BsPinterest", ()=>BsPinterest);
parcelHelpers.export(exports, "BsPipFill", ()=>BsPipFill);
parcelHelpers.export(exports, "BsPip", ()=>BsPip);
parcelHelpers.export(exports, "BsPlayBtnFill", ()=>BsPlayBtnFill);
parcelHelpers.export(exports, "BsPlayBtn", ()=>BsPlayBtn);
parcelHelpers.export(exports, "BsPlayCircleFill", ()=>BsPlayCircleFill);
parcelHelpers.export(exports, "BsPlayCircle", ()=>BsPlayCircle);
parcelHelpers.export(exports, "BsPlayFill", ()=>BsPlayFill);
parcelHelpers.export(exports, "BsPlay", ()=>BsPlay);
parcelHelpers.export(exports, "BsPlaystation", ()=>BsPlaystation);
parcelHelpers.export(exports, "BsPlugFill", ()=>BsPlugFill);
parcelHelpers.export(exports, "BsPlug", ()=>BsPlug);
parcelHelpers.export(exports, "BsPlugin", ()=>BsPlugin);
parcelHelpers.export(exports, "BsPlusCircleDotted", ()=>BsPlusCircleDotted);
parcelHelpers.export(exports, "BsPlusCircleFill", ()=>BsPlusCircleFill);
parcelHelpers.export(exports, "BsPlusCircle", ()=>BsPlusCircle);
parcelHelpers.export(exports, "BsPlusLg", ()=>BsPlusLg);
parcelHelpers.export(exports, "BsPlusSlashMinus", ()=>BsPlusSlashMinus);
parcelHelpers.export(exports, "BsPlusSquareDotted", ()=>BsPlusSquareDotted);
parcelHelpers.export(exports, "BsPlusSquareFill", ()=>BsPlusSquareFill);
parcelHelpers.export(exports, "BsPlusSquare", ()=>BsPlusSquare);
parcelHelpers.export(exports, "BsPlus", ()=>BsPlus);
parcelHelpers.export(exports, "BsPostageFill", ()=>BsPostageFill);
parcelHelpers.export(exports, "BsPostageHeartFill", ()=>BsPostageHeartFill);
parcelHelpers.export(exports, "BsPostageHeart", ()=>BsPostageHeart);
parcelHelpers.export(exports, "BsPostage", ()=>BsPostage);
parcelHelpers.export(exports, "BsPostcardFill", ()=>BsPostcardFill);
parcelHelpers.export(exports, "BsPostcardHeartFill", ()=>BsPostcardHeartFill);
parcelHelpers.export(exports, "BsPostcardHeart", ()=>BsPostcardHeart);
parcelHelpers.export(exports, "BsPostcard", ()=>BsPostcard);
parcelHelpers.export(exports, "BsPower", ()=>BsPower);
parcelHelpers.export(exports, "BsPrescription", ()=>BsPrescription);
parcelHelpers.export(exports, "BsPrescription2", ()=>BsPrescription2);
parcelHelpers.export(exports, "BsPrinterFill", ()=>BsPrinterFill);
parcelHelpers.export(exports, "BsPrinter", ()=>BsPrinter);
parcelHelpers.export(exports, "BsProjectorFill", ()=>BsProjectorFill);
parcelHelpers.export(exports, "BsProjector", ()=>BsProjector);
parcelHelpers.export(exports, "BsPuzzleFill", ()=>BsPuzzleFill);
parcelHelpers.export(exports, "BsPuzzle", ()=>BsPuzzle);
parcelHelpers.export(exports, "BsQrCodeScan", ()=>BsQrCodeScan);
parcelHelpers.export(exports, "BsQrCode", ()=>BsQrCode);
parcelHelpers.export(exports, "BsQuestionCircleFill", ()=>BsQuestionCircleFill);
parcelHelpers.export(exports, "BsQuestionCircle", ()=>BsQuestionCircle);
parcelHelpers.export(exports, "BsQuestionDiamondFill", ()=>BsQuestionDiamondFill);
parcelHelpers.export(exports, "BsQuestionDiamond", ()=>BsQuestionDiamond);
parcelHelpers.export(exports, "BsQuestionLg", ()=>BsQuestionLg);
parcelHelpers.export(exports, "BsQuestionOctagonFill", ()=>BsQuestionOctagonFill);
parcelHelpers.export(exports, "BsQuestionOctagon", ()=>BsQuestionOctagon);
parcelHelpers.export(exports, "BsQuestionSquareFill", ()=>BsQuestionSquareFill);
parcelHelpers.export(exports, "BsQuestionSquare", ()=>BsQuestionSquare);
parcelHelpers.export(exports, "BsQuestion", ()=>BsQuestion);
parcelHelpers.export(exports, "BsQuora", ()=>BsQuora);
parcelHelpers.export(exports, "BsQuote", ()=>BsQuote);
parcelHelpers.export(exports, "BsRCircleFill", ()=>BsRCircleFill);
parcelHelpers.export(exports, "BsRCircle", ()=>BsRCircle);
parcelHelpers.export(exports, "BsRSquareFill", ()=>BsRSquareFill);
parcelHelpers.export(exports, "BsRSquare", ()=>BsRSquare);
parcelHelpers.export(exports, "BsRadar", ()=>BsRadar);
parcelHelpers.export(exports, "BsRadioactive", ()=>BsRadioactive);
parcelHelpers.export(exports, "BsRainbow", ()=>BsRainbow);
parcelHelpers.export(exports, "BsReceiptCutoff", ()=>BsReceiptCutoff);
parcelHelpers.export(exports, "BsReceipt", ()=>BsReceipt);
parcelHelpers.export(exports, "BsReception0", ()=>BsReception0);
parcelHelpers.export(exports, "BsReception1", ()=>BsReception1);
parcelHelpers.export(exports, "BsReception2", ()=>BsReception2);
parcelHelpers.export(exports, "BsReception3", ()=>BsReception3);
parcelHelpers.export(exports, "BsReception4", ()=>BsReception4);
parcelHelpers.export(exports, "BsRecordBtnFill", ()=>BsRecordBtnFill);
parcelHelpers.export(exports, "BsRecordBtn", ()=>BsRecordBtn);
parcelHelpers.export(exports, "BsRecordCircleFill", ()=>BsRecordCircleFill);
parcelHelpers.export(exports, "BsRecordCircle", ()=>BsRecordCircle);
parcelHelpers.export(exports, "BsRecordFill", ()=>BsRecordFill);
parcelHelpers.export(exports, "BsRecord", ()=>BsRecord);
parcelHelpers.export(exports, "BsRecord2Fill", ()=>BsRecord2Fill);
parcelHelpers.export(exports, "BsRecord2", ()=>BsRecord2);
parcelHelpers.export(exports, "BsRecycle", ()=>BsRecycle);
parcelHelpers.export(exports, "BsReddit", ()=>BsReddit);
parcelHelpers.export(exports, "BsRegex", ()=>BsRegex);
parcelHelpers.export(exports, "BsRepeat1", ()=>BsRepeat1);
parcelHelpers.export(exports, "BsRepeat", ()=>BsRepeat);
parcelHelpers.export(exports, "BsReplyAllFill", ()=>BsReplyAllFill);
parcelHelpers.export(exports, "BsReplyAll", ()=>BsReplyAll);
parcelHelpers.export(exports, "BsReplyFill", ()=>BsReplyFill);
parcelHelpers.export(exports, "BsReply", ()=>BsReply);
parcelHelpers.export(exports, "BsRewindBtnFill", ()=>BsRewindBtnFill);
parcelHelpers.export(exports, "BsRewindBtn", ()=>BsRewindBtn);
parcelHelpers.export(exports, "BsRewindCircleFill", ()=>BsRewindCircleFill);
parcelHelpers.export(exports, "BsRewindCircle", ()=>BsRewindCircle);
parcelHelpers.export(exports, "BsRewindFill", ()=>BsRewindFill);
parcelHelpers.export(exports, "BsRewind", ()=>BsRewind);
parcelHelpers.export(exports, "BsRobot", ()=>BsRobot);
parcelHelpers.export(exports, "BsRocketFill", ()=>BsRocketFill);
parcelHelpers.export(exports, "BsRocketTakeoffFill", ()=>BsRocketTakeoffFill);
parcelHelpers.export(exports, "BsRocketTakeoff", ()=>BsRocketTakeoff);
parcelHelpers.export(exports, "BsRocket", ()=>BsRocket);
parcelHelpers.export(exports, "BsRouterFill", ()=>BsRouterFill);
parcelHelpers.export(exports, "BsRouter", ()=>BsRouter);
parcelHelpers.export(exports, "BsRssFill", ()=>BsRssFill);
parcelHelpers.export(exports, "BsRss", ()=>BsRss);
parcelHelpers.export(exports, "BsRulers", ()=>BsRulers);
parcelHelpers.export(exports, "BsSafeFill", ()=>BsSafeFill);
parcelHelpers.export(exports, "BsSafe", ()=>BsSafe);
parcelHelpers.export(exports, "BsSafe2Fill", ()=>BsSafe2Fill);
parcelHelpers.export(exports, "BsSafe2", ()=>BsSafe2);
parcelHelpers.export(exports, "BsSaveFill", ()=>BsSaveFill);
parcelHelpers.export(exports, "BsSave", ()=>BsSave);
parcelHelpers.export(exports, "BsSave2Fill", ()=>BsSave2Fill);
parcelHelpers.export(exports, "BsSave2", ()=>BsSave2);
parcelHelpers.export(exports, "BsScissors", ()=>BsScissors);
parcelHelpers.export(exports, "BsScooter", ()=>BsScooter);
parcelHelpers.export(exports, "BsScrewdriver", ()=>BsScrewdriver);
parcelHelpers.export(exports, "BsSdCardFill", ()=>BsSdCardFill);
parcelHelpers.export(exports, "BsSdCard", ()=>BsSdCard);
parcelHelpers.export(exports, "BsSearchHeartFill", ()=>BsSearchHeartFill);
parcelHelpers.export(exports, "BsSearchHeart", ()=>BsSearchHeart);
parcelHelpers.export(exports, "BsSearch", ()=>BsSearch);
parcelHelpers.export(exports, "BsSegmentedNav", ()=>BsSegmentedNav);
parcelHelpers.export(exports, "BsSendArrowDownFill", ()=>BsSendArrowDownFill);
parcelHelpers.export(exports, "BsSendArrowDown", ()=>BsSendArrowDown);
parcelHelpers.export(exports, "BsSendArrowUpFill", ()=>BsSendArrowUpFill);
parcelHelpers.export(exports, "BsSendArrowUp", ()=>BsSendArrowUp);
parcelHelpers.export(exports, "BsSendCheckFill", ()=>BsSendCheckFill);
parcelHelpers.export(exports, "BsSendCheck", ()=>BsSendCheck);
parcelHelpers.export(exports, "BsSendDashFill", ()=>BsSendDashFill);
parcelHelpers.export(exports, "BsSendDash", ()=>BsSendDash);
parcelHelpers.export(exports, "BsSendExclamationFill", ()=>BsSendExclamationFill);
parcelHelpers.export(exports, "BsSendExclamation", ()=>BsSendExclamation);
parcelHelpers.export(exports, "BsSendFill", ()=>BsSendFill);
parcelHelpers.export(exports, "BsSendPlusFill", ()=>BsSendPlusFill);
parcelHelpers.export(exports, "BsSendPlus", ()=>BsSendPlus);
parcelHelpers.export(exports, "BsSendSlashFill", ()=>BsSendSlashFill);
parcelHelpers.export(exports, "BsSendSlash", ()=>BsSendSlash);
parcelHelpers.export(exports, "BsSendXFill", ()=>BsSendXFill);
parcelHelpers.export(exports, "BsSendX", ()=>BsSendX);
parcelHelpers.export(exports, "BsSend", ()=>BsSend);
parcelHelpers.export(exports, "BsServer", ()=>BsServer);
parcelHelpers.export(exports, "BsShadows", ()=>BsShadows);
parcelHelpers.export(exports, "BsShareFill", ()=>BsShareFill);
parcelHelpers.export(exports, "BsShare", ()=>BsShare);
parcelHelpers.export(exports, "BsShieldCheck", ()=>BsShieldCheck);
parcelHelpers.export(exports, "BsShieldExclamation", ()=>BsShieldExclamation);
parcelHelpers.export(exports, "BsShieldFillCheck", ()=>BsShieldFillCheck);
parcelHelpers.export(exports, "BsShieldFillExclamation", ()=>BsShieldFillExclamation);
parcelHelpers.export(exports, "BsShieldFillMinus", ()=>BsShieldFillMinus);
parcelHelpers.export(exports, "BsShieldFillPlus", ()=>BsShieldFillPlus);
parcelHelpers.export(exports, "BsShieldFillX", ()=>BsShieldFillX);
parcelHelpers.export(exports, "BsShieldFill", ()=>BsShieldFill);
parcelHelpers.export(exports, "BsShieldLockFill", ()=>BsShieldLockFill);
parcelHelpers.export(exports, "BsShieldLock", ()=>BsShieldLock);
parcelHelpers.export(exports, "BsShieldMinus", ()=>BsShieldMinus);
parcelHelpers.export(exports, "BsShieldPlus", ()=>BsShieldPlus);
parcelHelpers.export(exports, "BsShieldShaded", ()=>BsShieldShaded);
parcelHelpers.export(exports, "BsShieldSlashFill", ()=>BsShieldSlashFill);
parcelHelpers.export(exports, "BsShieldSlash", ()=>BsShieldSlash);
parcelHelpers.export(exports, "BsShieldX", ()=>BsShieldX);
parcelHelpers.export(exports, "BsShield", ()=>BsShield);
parcelHelpers.export(exports, "BsShiftFill", ()=>BsShiftFill);
parcelHelpers.export(exports, "BsShift", ()=>BsShift);
parcelHelpers.export(exports, "BsShopWindow", ()=>BsShopWindow);
parcelHelpers.export(exports, "BsShop", ()=>BsShop);
parcelHelpers.export(exports, "BsShuffle", ()=>BsShuffle);
parcelHelpers.export(exports, "BsSignDeadEndFill", ()=>BsSignDeadEndFill);
parcelHelpers.export(exports, "BsSignDeadEnd", ()=>BsSignDeadEnd);
parcelHelpers.export(exports, "BsSignDoNotEnterFill", ()=>BsSignDoNotEnterFill);
parcelHelpers.export(exports, "BsSignDoNotEnter", ()=>BsSignDoNotEnter);
parcelHelpers.export(exports, "BsSignIntersectionFill", ()=>BsSignIntersectionFill);
parcelHelpers.export(exports, "BsSignIntersectionSideFill", ()=>BsSignIntersectionSideFill);
parcelHelpers.export(exports, "BsSignIntersectionSide", ()=>BsSignIntersectionSide);
parcelHelpers.export(exports, "BsSignIntersectionTFill", ()=>BsSignIntersectionTFill);
parcelHelpers.export(exports, "BsSignIntersectionT", ()=>BsSignIntersectionT);
parcelHelpers.export(exports, "BsSignIntersectionYFill", ()=>BsSignIntersectionYFill);
parcelHelpers.export(exports, "BsSignIntersectionY", ()=>BsSignIntersectionY);
parcelHelpers.export(exports, "BsSignIntersection", ()=>BsSignIntersection);
parcelHelpers.export(exports, "BsSignMergeLeftFill", ()=>BsSignMergeLeftFill);
parcelHelpers.export(exports, "BsSignMergeLeft", ()=>BsSignMergeLeft);
parcelHelpers.export(exports, "BsSignMergeRightFill", ()=>BsSignMergeRightFill);
parcelHelpers.export(exports, "BsSignMergeRight", ()=>BsSignMergeRight);
parcelHelpers.export(exports, "BsSignNoLeftTurnFill", ()=>BsSignNoLeftTurnFill);
parcelHelpers.export(exports, "BsSignNoLeftTurn", ()=>BsSignNoLeftTurn);
parcelHelpers.export(exports, "BsSignNoParkingFill", ()=>BsSignNoParkingFill);
parcelHelpers.export(exports, "BsSignNoParking", ()=>BsSignNoParking);
parcelHelpers.export(exports, "BsSignNoRightTurnFill", ()=>BsSignNoRightTurnFill);
parcelHelpers.export(exports, "BsSignNoRightTurn", ()=>BsSignNoRightTurn);
parcelHelpers.export(exports, "BsSignRailroadFill", ()=>BsSignRailroadFill);
parcelHelpers.export(exports, "BsSignRailroad", ()=>BsSignRailroad);
parcelHelpers.export(exports, "BsSignStopFill", ()=>BsSignStopFill);
parcelHelpers.export(exports, "BsSignStopLightsFill", ()=>BsSignStopLightsFill);
parcelHelpers.export(exports, "BsSignStopLights", ()=>BsSignStopLights);
parcelHelpers.export(exports, "BsSignStop", ()=>BsSignStop);
parcelHelpers.export(exports, "BsSignTurnLeftFill", ()=>BsSignTurnLeftFill);
parcelHelpers.export(exports, "BsSignTurnLeft", ()=>BsSignTurnLeft);
parcelHelpers.export(exports, "BsSignTurnRightFill", ()=>BsSignTurnRightFill);
parcelHelpers.export(exports, "BsSignTurnRight", ()=>BsSignTurnRight);
parcelHelpers.export(exports, "BsSignTurnSlightLeftFill", ()=>BsSignTurnSlightLeftFill);
parcelHelpers.export(exports, "BsSignTurnSlightLeft", ()=>BsSignTurnSlightLeft);
parcelHelpers.export(exports, "BsSignTurnSlightRightFill", ()=>BsSignTurnSlightRightFill);
parcelHelpers.export(exports, "BsSignTurnSlightRight", ()=>BsSignTurnSlightRight);
parcelHelpers.export(exports, "BsSignYieldFill", ()=>BsSignYieldFill);
parcelHelpers.export(exports, "BsSignYield", ()=>BsSignYield);
parcelHelpers.export(exports, "BsSignal", ()=>BsSignal);
parcelHelpers.export(exports, "BsSignpost2Fill", ()=>BsSignpost2Fill);
parcelHelpers.export(exports, "BsSignpost2", ()=>BsSignpost2);
parcelHelpers.export(exports, "BsSignpostFill", ()=>BsSignpostFill);
parcelHelpers.export(exports, "BsSignpostSplitFill", ()=>BsSignpostSplitFill);
parcelHelpers.export(exports, "BsSignpostSplit", ()=>BsSignpostSplit);
parcelHelpers.export(exports, "BsSignpost", ()=>BsSignpost);
parcelHelpers.export(exports, "BsSimFill", ()=>BsSimFill);
parcelHelpers.export(exports, "BsSimSlashFill", ()=>BsSimSlashFill);
parcelHelpers.export(exports, "BsSimSlash", ()=>BsSimSlash);
parcelHelpers.export(exports, "BsSim", ()=>BsSim);
parcelHelpers.export(exports, "BsSinaWeibo", ()=>BsSinaWeibo);
parcelHelpers.export(exports, "BsSkipBackwardBtnFill", ()=>BsSkipBackwardBtnFill);
parcelHelpers.export(exports, "BsSkipBackwardBtn", ()=>BsSkipBackwardBtn);
parcelHelpers.export(exports, "BsSkipBackwardCircleFill", ()=>BsSkipBackwardCircleFill);
parcelHelpers.export(exports, "BsSkipBackwardCircle", ()=>BsSkipBackwardCircle);
parcelHelpers.export(exports, "BsSkipBackwardFill", ()=>BsSkipBackwardFill);
parcelHelpers.export(exports, "BsSkipBackward", ()=>BsSkipBackward);
parcelHelpers.export(exports, "BsSkipEndBtnFill", ()=>BsSkipEndBtnFill);
parcelHelpers.export(exports, "BsSkipEndBtn", ()=>BsSkipEndBtn);
parcelHelpers.export(exports, "BsSkipEndCircleFill", ()=>BsSkipEndCircleFill);
parcelHelpers.export(exports, "BsSkipEndCircle", ()=>BsSkipEndCircle);
parcelHelpers.export(exports, "BsSkipEndFill", ()=>BsSkipEndFill);
parcelHelpers.export(exports, "BsSkipEnd", ()=>BsSkipEnd);
parcelHelpers.export(exports, "BsSkipForwardBtnFill", ()=>BsSkipForwardBtnFill);
parcelHelpers.export(exports, "BsSkipForwardBtn", ()=>BsSkipForwardBtn);
parcelHelpers.export(exports, "BsSkipForwardCircleFill", ()=>BsSkipForwardCircleFill);
parcelHelpers.export(exports, "BsSkipForwardCircle", ()=>BsSkipForwardCircle);
parcelHelpers.export(exports, "BsSkipForwardFill", ()=>BsSkipForwardFill);
parcelHelpers.export(exports, "BsSkipForward", ()=>BsSkipForward);
parcelHelpers.export(exports, "BsSkipStartBtnFill", ()=>BsSkipStartBtnFill);
parcelHelpers.export(exports, "BsSkipStartBtn", ()=>BsSkipStartBtn);
parcelHelpers.export(exports, "BsSkipStartCircleFill", ()=>BsSkipStartCircleFill);
parcelHelpers.export(exports, "BsSkipStartCircle", ()=>BsSkipStartCircle);
parcelHelpers.export(exports, "BsSkipStartFill", ()=>BsSkipStartFill);
parcelHelpers.export(exports, "BsSkipStart", ()=>BsSkipStart);
parcelHelpers.export(exports, "BsSkype", ()=>BsSkype);
parcelHelpers.export(exports, "BsSlack", ()=>BsSlack);
parcelHelpers.export(exports, "BsSlashCircleFill", ()=>BsSlashCircleFill);
parcelHelpers.export(exports, "BsSlashCircle", ()=>BsSlashCircle);
parcelHelpers.export(exports, "BsSlashLg", ()=>BsSlashLg);
parcelHelpers.export(exports, "BsSlashSquareFill", ()=>BsSlashSquareFill);
parcelHelpers.export(exports, "BsSlashSquare", ()=>BsSlashSquare);
parcelHelpers.export(exports, "BsSlash", ()=>BsSlash);
parcelHelpers.export(exports, "BsSliders", ()=>BsSliders);
parcelHelpers.export(exports, "BsSliders2Vertical", ()=>BsSliders2Vertical);
parcelHelpers.export(exports, "BsSliders2", ()=>BsSliders2);
parcelHelpers.export(exports, "BsSmartwatch", ()=>BsSmartwatch);
parcelHelpers.export(exports, "BsSnapchat", ()=>BsSnapchat);
parcelHelpers.export(exports, "BsSnow", ()=>BsSnow);
parcelHelpers.export(exports, "BsSnow2", ()=>BsSnow2);
parcelHelpers.export(exports, "BsSnow3", ()=>BsSnow3);
parcelHelpers.export(exports, "BsSortAlphaDownAlt", ()=>BsSortAlphaDownAlt);
parcelHelpers.export(exports, "BsSortAlphaDown", ()=>BsSortAlphaDown);
parcelHelpers.export(exports, "BsSortAlphaUpAlt", ()=>BsSortAlphaUpAlt);
parcelHelpers.export(exports, "BsSortAlphaUp", ()=>BsSortAlphaUp);
parcelHelpers.export(exports, "BsSortDownAlt", ()=>BsSortDownAlt);
parcelHelpers.export(exports, "BsSortDown", ()=>BsSortDown);
parcelHelpers.export(exports, "BsSortNumericDownAlt", ()=>BsSortNumericDownAlt);
parcelHelpers.export(exports, "BsSortNumericDown", ()=>BsSortNumericDown);
parcelHelpers.export(exports, "BsSortNumericUpAlt", ()=>BsSortNumericUpAlt);
parcelHelpers.export(exports, "BsSortNumericUp", ()=>BsSortNumericUp);
parcelHelpers.export(exports, "BsSortUpAlt", ()=>BsSortUpAlt);
parcelHelpers.export(exports, "BsSortUp", ()=>BsSortUp);
parcelHelpers.export(exports, "BsSoundwave", ()=>BsSoundwave);
parcelHelpers.export(exports, "BsSourceforge", ()=>BsSourceforge);
parcelHelpers.export(exports, "BsSpeakerFill", ()=>BsSpeakerFill);
parcelHelpers.export(exports, "BsSpeaker", ()=>BsSpeaker);
parcelHelpers.export(exports, "BsSpeedometer", ()=>BsSpeedometer);
parcelHelpers.export(exports, "BsSpeedometer2", ()=>BsSpeedometer2);
parcelHelpers.export(exports, "BsSpellcheck", ()=>BsSpellcheck);
parcelHelpers.export(exports, "BsSpotify", ()=>BsSpotify);
parcelHelpers.export(exports, "BsSquareFill", ()=>BsSquareFill);
parcelHelpers.export(exports, "BsSquareHalf", ()=>BsSquareHalf);
parcelHelpers.export(exports, "BsSquare", ()=>BsSquare);
parcelHelpers.export(exports, "BsStackOverflow", ()=>BsStackOverflow);
parcelHelpers.export(exports, "BsStack", ()=>BsStack);
parcelHelpers.export(exports, "BsStarFill", ()=>BsStarFill);
parcelHelpers.export(exports, "BsStarHalf", ()=>BsStarHalf);
parcelHelpers.export(exports, "BsStar", ()=>BsStar);
parcelHelpers.export(exports, "BsStars", ()=>BsStars);
parcelHelpers.export(exports, "BsSteam", ()=>BsSteam);
parcelHelpers.export(exports, "BsStickiesFill", ()=>BsStickiesFill);
parcelHelpers.export(exports, "BsStickies", ()=>BsStickies);
parcelHelpers.export(exports, "BsStickyFill", ()=>BsStickyFill);
parcelHelpers.export(exports, "BsSticky", ()=>BsSticky);
parcelHelpers.export(exports, "BsStopBtnFill", ()=>BsStopBtnFill);
parcelHelpers.export(exports, "BsStopBtn", ()=>BsStopBtn);
parcelHelpers.export(exports, "BsStopCircleFill", ()=>BsStopCircleFill);
parcelHelpers.export(exports, "BsStopCircle", ()=>BsStopCircle);
parcelHelpers.export(exports, "BsStopFill", ()=>BsStopFill);
parcelHelpers.export(exports, "BsStop", ()=>BsStop);
parcelHelpers.export(exports, "BsStoplightsFill", ()=>BsStoplightsFill);
parcelHelpers.export(exports, "BsStoplights", ()=>BsStoplights);
parcelHelpers.export(exports, "BsStopwatchFill", ()=>BsStopwatchFill);
parcelHelpers.export(exports, "BsStopwatch", ()=>BsStopwatch);
parcelHelpers.export(exports, "BsStrava", ()=>BsStrava);
parcelHelpers.export(exports, "BsStripe", ()=>BsStripe);
parcelHelpers.export(exports, "BsSubscript", ()=>BsSubscript);
parcelHelpers.export(exports, "BsSubstack", ()=>BsSubstack);
parcelHelpers.export(exports, "BsSubtract", ()=>BsSubtract);
parcelHelpers.export(exports, "BsSuitClubFill", ()=>BsSuitClubFill);
parcelHelpers.export(exports, "BsSuitClub", ()=>BsSuitClub);
parcelHelpers.export(exports, "BsSuitDiamondFill", ()=>BsSuitDiamondFill);
parcelHelpers.export(exports, "BsSuitDiamond", ()=>BsSuitDiamond);
parcelHelpers.export(exports, "BsSuitHeartFill", ()=>BsSuitHeartFill);
parcelHelpers.export(exports, "BsSuitHeart", ()=>BsSuitHeart);
parcelHelpers.export(exports, "BsSuitSpadeFill", ()=>BsSuitSpadeFill);
parcelHelpers.export(exports, "BsSuitSpade", ()=>BsSuitSpade);
parcelHelpers.export(exports, "BsSuitcaseFill", ()=>BsSuitcaseFill);
parcelHelpers.export(exports, "BsSuitcaseLgFill", ()=>BsSuitcaseLgFill);
parcelHelpers.export(exports, "BsSuitcaseLg", ()=>BsSuitcaseLg);
parcelHelpers.export(exports, "BsSuitcase", ()=>BsSuitcase);
parcelHelpers.export(exports, "BsSuitcase2Fill", ()=>BsSuitcase2Fill);
parcelHelpers.export(exports, "BsSuitcase2", ()=>BsSuitcase2);
parcelHelpers.export(exports, "BsSunFill", ()=>BsSunFill);
parcelHelpers.export(exports, "BsSun", ()=>BsSun);
parcelHelpers.export(exports, "BsSunglasses", ()=>BsSunglasses);
parcelHelpers.export(exports, "BsSunriseFill", ()=>BsSunriseFill);
parcelHelpers.export(exports, "BsSunrise", ()=>BsSunrise);
parcelHelpers.export(exports, "BsSunsetFill", ()=>BsSunsetFill);
parcelHelpers.export(exports, "BsSunset", ()=>BsSunset);
parcelHelpers.export(exports, "BsSuperscript", ()=>BsSuperscript);
parcelHelpers.export(exports, "BsSymmetryHorizontal", ()=>BsSymmetryHorizontal);
parcelHelpers.export(exports, "BsSymmetryVertical", ()=>BsSymmetryVertical);
parcelHelpers.export(exports, "BsTable", ()=>BsTable);
parcelHelpers.export(exports, "BsTabletFill", ()=>BsTabletFill);
parcelHelpers.export(exports, "BsTabletLandscapeFill", ()=>BsTabletLandscapeFill);
parcelHelpers.export(exports, "BsTabletLandscape", ()=>BsTabletLandscape);
parcelHelpers.export(exports, "BsTablet", ()=>BsTablet);
parcelHelpers.export(exports, "BsTagFill", ()=>BsTagFill);
parcelHelpers.export(exports, "BsTag", ()=>BsTag);
parcelHelpers.export(exports, "BsTagsFill", ()=>BsTagsFill);
parcelHelpers.export(exports, "BsTags", ()=>BsTags);
parcelHelpers.export(exports, "BsTaxiFrontFill", ()=>BsTaxiFrontFill);
parcelHelpers.export(exports, "BsTaxiFront", ()=>BsTaxiFront);
parcelHelpers.export(exports, "BsTelegram", ()=>BsTelegram);
parcelHelpers.export(exports, "BsTelephoneFill", ()=>BsTelephoneFill);
parcelHelpers.export(exports, "BsTelephoneForwardFill", ()=>BsTelephoneForwardFill);
parcelHelpers.export(exports, "BsTelephoneForward", ()=>BsTelephoneForward);
parcelHelpers.export(exports, "BsTelephoneInboundFill", ()=>BsTelephoneInboundFill);
parcelHelpers.export(exports, "BsTelephoneInbound", ()=>BsTelephoneInbound);
parcelHelpers.export(exports, "BsTelephoneMinusFill", ()=>BsTelephoneMinusFill);
parcelHelpers.export(exports, "BsTelephoneMinus", ()=>BsTelephoneMinus);
parcelHelpers.export(exports, "BsTelephoneOutboundFill", ()=>BsTelephoneOutboundFill);
parcelHelpers.export(exports, "BsTelephoneOutbound", ()=>BsTelephoneOutbound);
parcelHelpers.export(exports, "BsTelephonePlusFill", ()=>BsTelephonePlusFill);
parcelHelpers.export(exports, "BsTelephonePlus", ()=>BsTelephonePlus);
parcelHelpers.export(exports, "BsTelephoneXFill", ()=>BsTelephoneXFill);
parcelHelpers.export(exports, "BsTelephoneX", ()=>BsTelephoneX);
parcelHelpers.export(exports, "BsTelephone", ()=>BsTelephone);
parcelHelpers.export(exports, "BsTencentQq", ()=>BsTencentQq);
parcelHelpers.export(exports, "BsTerminalDash", ()=>BsTerminalDash);
parcelHelpers.export(exports, "BsTerminalFill", ()=>BsTerminalFill);
parcelHelpers.export(exports, "BsTerminalPlus", ()=>BsTerminalPlus);
parcelHelpers.export(exports, "BsTerminalSplit", ()=>BsTerminalSplit);
parcelHelpers.export(exports, "BsTerminalX", ()=>BsTerminalX);
parcelHelpers.export(exports, "BsTerminal", ()=>BsTerminal);
parcelHelpers.export(exports, "BsTextCenter", ()=>BsTextCenter);
parcelHelpers.export(exports, "BsTextIndentLeft", ()=>BsTextIndentLeft);
parcelHelpers.export(exports, "BsTextIndentRight", ()=>BsTextIndentRight);
parcelHelpers.export(exports, "BsTextLeft", ()=>BsTextLeft);
parcelHelpers.export(exports, "BsTextParagraph", ()=>BsTextParagraph);
parcelHelpers.export(exports, "BsTextRight", ()=>BsTextRight);
parcelHelpers.export(exports, "BsTextWrap", ()=>BsTextWrap);
parcelHelpers.export(exports, "BsTextareaResize", ()=>BsTextareaResize);
parcelHelpers.export(exports, "BsTextareaT", ()=>BsTextareaT);
parcelHelpers.export(exports, "BsTextarea", ()=>BsTextarea);
parcelHelpers.export(exports, "BsThermometerHalf", ()=>BsThermometerHalf);
parcelHelpers.export(exports, "BsThermometerHigh", ()=>BsThermometerHigh);
parcelHelpers.export(exports, "BsThermometerLow", ()=>BsThermometerLow);
parcelHelpers.export(exports, "BsThermometerSnow", ()=>BsThermometerSnow);
parcelHelpers.export(exports, "BsThermometerSun", ()=>BsThermometerSun);
parcelHelpers.export(exports, "BsThermometer", ()=>BsThermometer);
parcelHelpers.export(exports, "BsThreadsFill", ()=>BsThreadsFill);
parcelHelpers.export(exports, "BsThreads", ()=>BsThreads);
parcelHelpers.export(exports, "BsThreeDotsVertical", ()=>BsThreeDotsVertical);
parcelHelpers.export(exports, "BsThreeDots", ()=>BsThreeDots);
parcelHelpers.export(exports, "BsThunderboltFill", ()=>BsThunderboltFill);
parcelHelpers.export(exports, "BsThunderbolt", ()=>BsThunderbolt);
parcelHelpers.export(exports, "BsTicketDetailedFill", ()=>BsTicketDetailedFill);
parcelHelpers.export(exports, "BsTicketDetailed", ()=>BsTicketDetailed);
parcelHelpers.export(exports, "BsTicketFill", ()=>BsTicketFill);
parcelHelpers.export(exports, "BsTicketPerforatedFill", ()=>BsTicketPerforatedFill);
parcelHelpers.export(exports, "BsTicketPerforated", ()=>BsTicketPerforated);
parcelHelpers.export(exports, "BsTicket", ()=>BsTicket);
parcelHelpers.export(exports, "BsTiktok", ()=>BsTiktok);
parcelHelpers.export(exports, "BsToggleOff", ()=>BsToggleOff);
parcelHelpers.export(exports, "BsToggleOn", ()=>BsToggleOn);
parcelHelpers.export(exports, "BsToggle2Off", ()=>BsToggle2Off);
parcelHelpers.export(exports, "BsToggle2On", ()=>BsToggle2On);
parcelHelpers.export(exports, "BsToggles", ()=>BsToggles);
parcelHelpers.export(exports, "BsToggles2", ()=>BsToggles2);
parcelHelpers.export(exports, "BsTools", ()=>BsTools);
parcelHelpers.export(exports, "BsTornado", ()=>BsTornado);
parcelHelpers.export(exports, "BsTrainFreightFrontFill", ()=>BsTrainFreightFrontFill);
parcelHelpers.export(exports, "BsTrainFreightFront", ()=>BsTrainFreightFront);
parcelHelpers.export(exports, "BsTrainFrontFill", ()=>BsTrainFrontFill);
parcelHelpers.export(exports, "BsTrainFront", ()=>BsTrainFront);
parcelHelpers.export(exports, "BsTrainLightrailFrontFill", ()=>BsTrainLightrailFrontFill);
parcelHelpers.export(exports, "BsTrainLightrailFront", ()=>BsTrainLightrailFront);
parcelHelpers.export(exports, "BsTranslate", ()=>BsTranslate);
parcelHelpers.export(exports, "BsTransparency", ()=>BsTransparency);
parcelHelpers.export(exports, "BsTrashFill", ()=>BsTrashFill);
parcelHelpers.export(exports, "BsTrash", ()=>BsTrash);
parcelHelpers.export(exports, "BsTrash2Fill", ()=>BsTrash2Fill);
parcelHelpers.export(exports, "BsTrash2", ()=>BsTrash2);
parcelHelpers.export(exports, "BsTrash3Fill", ()=>BsTrash3Fill);
parcelHelpers.export(exports, "BsTrash3", ()=>BsTrash3);
parcelHelpers.export(exports, "BsTreeFill", ()=>BsTreeFill);
parcelHelpers.export(exports, "BsTree", ()=>BsTree);
parcelHelpers.export(exports, "BsTrello", ()=>BsTrello);
parcelHelpers.export(exports, "BsTriangleFill", ()=>BsTriangleFill);
parcelHelpers.export(exports, "BsTriangleHalf", ()=>BsTriangleHalf);
parcelHelpers.export(exports, "BsTriangle", ()=>BsTriangle);
parcelHelpers.export(exports, "BsTrophyFill", ()=>BsTrophyFill);
parcelHelpers.export(exports, "BsTrophy", ()=>BsTrophy);
parcelHelpers.export(exports, "BsTropicalStorm", ()=>BsTropicalStorm);
parcelHelpers.export(exports, "BsTruckFlatbed", ()=>BsTruckFlatbed);
parcelHelpers.export(exports, "BsTruckFrontFill", ()=>BsTruckFrontFill);
parcelHelpers.export(exports, "BsTruckFront", ()=>BsTruckFront);
parcelHelpers.export(exports, "BsTruck", ()=>BsTruck);
parcelHelpers.export(exports, "BsTsunami", ()=>BsTsunami);
parcelHelpers.export(exports, "BsTvFill", ()=>BsTvFill);
parcelHelpers.export(exports, "BsTv", ()=>BsTv);
parcelHelpers.export(exports, "BsTwitch", ()=>BsTwitch);
parcelHelpers.export(exports, "BsTwitterX", ()=>BsTwitterX);
parcelHelpers.export(exports, "BsTwitter", ()=>BsTwitter);
parcelHelpers.export(exports, "BsTypeBold", ()=>BsTypeBold);
parcelHelpers.export(exports, "BsTypeH1", ()=>BsTypeH1);
parcelHelpers.export(exports, "BsTypeH2", ()=>BsTypeH2);
parcelHelpers.export(exports, "BsTypeH3", ()=>BsTypeH3);
parcelHelpers.export(exports, "BsTypeH4", ()=>BsTypeH4);
parcelHelpers.export(exports, "BsTypeH5", ()=>BsTypeH5);
parcelHelpers.export(exports, "BsTypeH6", ()=>BsTypeH6);
parcelHelpers.export(exports, "BsTypeItalic", ()=>BsTypeItalic);
parcelHelpers.export(exports, "BsTypeStrikethrough", ()=>BsTypeStrikethrough);
parcelHelpers.export(exports, "BsTypeUnderline", ()=>BsTypeUnderline);
parcelHelpers.export(exports, "BsType", ()=>BsType);
parcelHelpers.export(exports, "BsUbuntu", ()=>BsUbuntu);
parcelHelpers.export(exports, "BsUiChecksGrid", ()=>BsUiChecksGrid);
parcelHelpers.export(exports, "BsUiChecks", ()=>BsUiChecks);
parcelHelpers.export(exports, "BsUiRadiosGrid", ()=>BsUiRadiosGrid);
parcelHelpers.export(exports, "BsUiRadios", ()=>BsUiRadios);
parcelHelpers.export(exports, "BsUmbrellaFill", ()=>BsUmbrellaFill);
parcelHelpers.export(exports, "BsUmbrella", ()=>BsUmbrella);
parcelHelpers.export(exports, "BsUnindent", ()=>BsUnindent);
parcelHelpers.export(exports, "BsUnion", ()=>BsUnion);
parcelHelpers.export(exports, "BsUnity", ()=>BsUnity);
parcelHelpers.export(exports, "BsUniversalAccessCircle", ()=>BsUniversalAccessCircle);
parcelHelpers.export(exports, "BsUniversalAccess", ()=>BsUniversalAccess);
parcelHelpers.export(exports, "BsUnlockFill", ()=>BsUnlockFill);
parcelHelpers.export(exports, "BsUnlock", ()=>BsUnlock);
parcelHelpers.export(exports, "BsUpcScan", ()=>BsUpcScan);
parcelHelpers.export(exports, "BsUpc", ()=>BsUpc);
parcelHelpers.export(exports, "BsUpload", ()=>BsUpload);
parcelHelpers.export(exports, "BsUsbCFill", ()=>BsUsbCFill);
parcelHelpers.export(exports, "BsUsbC", ()=>BsUsbC);
parcelHelpers.export(exports, "BsUsbDriveFill", ()=>BsUsbDriveFill);
parcelHelpers.export(exports, "BsUsbDrive", ()=>BsUsbDrive);
parcelHelpers.export(exports, "BsUsbFill", ()=>BsUsbFill);
parcelHelpers.export(exports, "BsUsbMicroFill", ()=>BsUsbMicroFill);
parcelHelpers.export(exports, "BsUsbMicro", ()=>BsUsbMicro);
parcelHelpers.export(exports, "BsUsbMiniFill", ()=>BsUsbMiniFill);
parcelHelpers.export(exports, "BsUsbMini", ()=>BsUsbMini);
parcelHelpers.export(exports, "BsUsbPlugFill", ()=>BsUsbPlugFill);
parcelHelpers.export(exports, "BsUsbPlug", ()=>BsUsbPlug);
parcelHelpers.export(exports, "BsUsbSymbol", ()=>BsUsbSymbol);
parcelHelpers.export(exports, "BsUsb", ()=>BsUsb);
parcelHelpers.export(exports, "BsValentine", ()=>BsValentine);
parcelHelpers.export(exports, "BsValentine2", ()=>BsValentine2);
parcelHelpers.export(exports, "BsVectorPen", ()=>BsVectorPen);
parcelHelpers.export(exports, "BsViewList", ()=>BsViewList);
parcelHelpers.export(exports, "BsViewStacked", ()=>BsViewStacked);
parcelHelpers.export(exports, "BsVignette", ()=>BsVignette);
parcelHelpers.export(exports, "BsVimeo", ()=>BsVimeo);
parcelHelpers.export(exports, "BsVinylFill", ()=>BsVinylFill);
parcelHelpers.export(exports, "BsVinyl", ()=>BsVinyl);
parcelHelpers.export(exports, "BsVirus", ()=>BsVirus);
parcelHelpers.export(exports, "BsVirus2", ()=>BsVirus2);
parcelHelpers.export(exports, "BsVoicemail", ()=>BsVoicemail);
parcelHelpers.export(exports, "BsVolumeDownFill", ()=>BsVolumeDownFill);
parcelHelpers.export(exports, "BsVolumeDown", ()=>BsVolumeDown);
parcelHelpers.export(exports, "BsVolumeMuteFill", ()=>BsVolumeMuteFill);
parcelHelpers.export(exports, "BsVolumeMute", ()=>BsVolumeMute);
parcelHelpers.export(exports, "BsVolumeOffFill", ()=>BsVolumeOffFill);
parcelHelpers.export(exports, "BsVolumeOff", ()=>BsVolumeOff);
parcelHelpers.export(exports, "BsVolumeUpFill", ()=>BsVolumeUpFill);
parcelHelpers.export(exports, "BsVolumeUp", ()=>BsVolumeUp);
parcelHelpers.export(exports, "BsVr", ()=>BsVr);
parcelHelpers.export(exports, "BsWalletFill", ()=>BsWalletFill);
parcelHelpers.export(exports, "BsWallet", ()=>BsWallet);
parcelHelpers.export(exports, "BsWallet2", ()=>BsWallet2);
parcelHelpers.export(exports, "BsWatch", ()=>BsWatch);
parcelHelpers.export(exports, "BsWater", ()=>BsWater);
parcelHelpers.export(exports, "BsWebcamFill", ()=>BsWebcamFill);
parcelHelpers.export(exports, "BsWebcam", ()=>BsWebcam);
parcelHelpers.export(exports, "BsWechat", ()=>BsWechat);
parcelHelpers.export(exports, "BsWhatsapp", ()=>BsWhatsapp);
parcelHelpers.export(exports, "BsWifi1", ()=>BsWifi1);
parcelHelpers.export(exports, "BsWifi2", ()=>BsWifi2);
parcelHelpers.export(exports, "BsWifiOff", ()=>BsWifiOff);
parcelHelpers.export(exports, "BsWifi", ()=>BsWifi);
parcelHelpers.export(exports, "BsWikipedia", ()=>BsWikipedia);
parcelHelpers.export(exports, "BsWind", ()=>BsWind);
parcelHelpers.export(exports, "BsWindowDash", ()=>BsWindowDash);
parcelHelpers.export(exports, "BsWindowDesktop", ()=>BsWindowDesktop);
parcelHelpers.export(exports, "BsWindowDock", ()=>BsWindowDock);
parcelHelpers.export(exports, "BsWindowFullscreen", ()=>BsWindowFullscreen);
parcelHelpers.export(exports, "BsWindowPlus", ()=>BsWindowPlus);
parcelHelpers.export(exports, "BsWindowSidebar", ()=>BsWindowSidebar);
parcelHelpers.export(exports, "BsWindowSplit", ()=>BsWindowSplit);
parcelHelpers.export(exports, "BsWindowStack", ()=>BsWindowStack);
parcelHelpers.export(exports, "BsWindowX", ()=>BsWindowX);
parcelHelpers.export(exports, "BsWindow", ()=>BsWindow);
parcelHelpers.export(exports, "BsWindows", ()=>BsWindows);
parcelHelpers.export(exports, "BsWordpress", ()=>BsWordpress);
parcelHelpers.export(exports, "BsWrenchAdjustableCircleFill", ()=>BsWrenchAdjustableCircleFill);
parcelHelpers.export(exports, "BsWrenchAdjustableCircle", ()=>BsWrenchAdjustableCircle);
parcelHelpers.export(exports, "BsWrenchAdjustable", ()=>BsWrenchAdjustable);
parcelHelpers.export(exports, "BsWrench", ()=>BsWrench);
parcelHelpers.export(exports, "BsXCircleFill", ()=>BsXCircleFill);
parcelHelpers.export(exports, "BsXCircle", ()=>BsXCircle);
parcelHelpers.export(exports, "BsXDiamondFill", ()=>BsXDiamondFill);
parcelHelpers.export(exports, "BsXDiamond", ()=>BsXDiamond);
parcelHelpers.export(exports, "BsXLg", ()=>BsXLg);
parcelHelpers.export(exports, "BsXOctagonFill", ()=>BsXOctagonFill);
parcelHelpers.export(exports, "BsXOctagon", ()=>BsXOctagon);
parcelHelpers.export(exports, "BsXSquareFill", ()=>BsXSquareFill);
parcelHelpers.export(exports, "BsXSquare", ()=>BsXSquare);
parcelHelpers.export(exports, "BsX", ()=>BsX);
parcelHelpers.export(exports, "BsXbox", ()=>BsXbox);
parcelHelpers.export(exports, "BsYelp", ()=>BsYelp);
parcelHelpers.export(exports, "BsYinYang", ()=>BsYinYang);
parcelHelpers.export(exports, "BsYoutube", ()=>BsYoutube);
parcelHelpers.export(exports, "BsZoomIn", ()=>BsZoomIn);
parcelHelpers.export(exports, "BsZoomOut", ()=>BsZoomOut);
var _lib = require("../lib");
function BsFill0CircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4.951c-1.008 0-1.629 1.09-1.629 2.895v.31c0 1.81.627 2.895 1.629 2.895s1.623-1.09 1.623-2.895v-.31c0-1.8-.621-2.895-1.623-2.895Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-8.012 4.158c1.858 0 2.96-1.582 2.96-3.99V7.84c0-2.426-1.079-3.996-2.936-3.996-1.864 0-2.965 1.588-2.965 3.996v.328c0 2.42 1.09 3.99 2.941 3.99Z"
                }
            }
        ]
    })(props);
}
function BsFill0SquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4.951c-1.008 0-1.629 1.09-1.629 2.895v.31c0 1.81.627 2.895 1.629 2.895s1.623-1.09 1.623-2.895v-.31c0-1.8-.621-2.895-1.623-2.895Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm5.988 12.158c-1.851 0-2.941-1.57-2.941-3.99V7.84c0-2.408 1.101-3.996 2.965-3.996 1.857 0 2.935 1.57 2.935 3.996v.328c0 2.408-1.101 3.99-2.959 3.99Z"
                }
            }
        ]
    })(props);
}
function BsFill1CircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM9.283 4.002H7.971L6.072 5.385v1.271l1.834-1.318h.065V12h1.312V4.002Z"
                }
            }
        ]
    })(props);
}
function BsFill1SquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm7.283 4.002V12H7.971V5.338h-.065L6.072 6.656V5.385l1.899-1.383h1.312Z"
                }
            }
        ]
    })(props);
}
function BsFill2CircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM6.646 6.24c0-.691.493-1.306 1.336-1.306.756 0 1.313.492 1.313 1.236 0 .697-.469 1.23-.902 1.705l-2.971 3.293V12h5.344v-1.107H7.268v-.077l1.974-2.22.096-.107c.688-.763 1.287-1.428 1.287-2.43 0-1.266-1.031-2.215-2.613-2.215-1.758 0-2.637 1.19-2.637 2.402v.065h1.271v-.07Z"
                }
            }
        ]
    })(props);
}
function BsFill2SquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm4.646 6.24v.07H5.375v-.064c0-1.213.879-2.402 2.637-2.402 1.582 0 2.613.949 2.613 2.215 0 1.002-.6 1.667-1.287 2.43l-.096.107-1.974 2.22v.077h3.498V12H5.422v-.832l2.97-3.293c.434-.475.903-1.008.903-1.705 0-.744-.557-1.236-1.313-1.236-.843 0-1.336.615-1.336 1.306Z"
                }
            }
        ]
    })(props);
}
function BsFill3CircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-8.082.414c.92 0 1.535.54 1.541 1.318.012.791-.615 1.36-1.588 1.354-.861-.006-1.482-.469-1.54-1.066H5.104c.047 1.177 1.05 2.144 2.754 2.144 1.653 0 2.954-.937 2.93-2.396-.023-1.278-1.031-1.846-1.734-1.916v-.07c.597-.1 1.505-.739 1.482-1.876-.03-1.177-1.043-2.074-2.637-2.062-1.675.006-2.59.984-2.625 2.12h1.248c.036-.556.557-1.054 1.348-1.054.785 0 1.348.486 1.348 1.195.006.715-.563 1.237-1.342 1.237h-.838v1.072h.879Z"
                }
            }
        ]
    })(props);
}
function BsFill3SquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm5.918 8.414h-.879V7.342h.838c.78 0 1.348-.522 1.342-1.237 0-.709-.563-1.195-1.348-1.195-.79 0-1.312.498-1.348 1.055H5.275c.036-1.137.95-2.115 2.625-2.121 1.594-.012 2.608.885 2.637 2.062.023 1.137-.885 1.776-1.482 1.875v.07c.703.07 1.71.64 1.734 1.917.024 1.459-1.277 2.396-2.93 2.396-1.705 0-2.707-.967-2.754-2.144H6.33c.059.597.68 1.06 1.541 1.066.973.006 1.6-.563 1.588-1.354-.006-.779-.621-1.318-1.541-1.318Z"
                }
            }
        ]
    })(props);
}
function BsFill4CircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM7.519 5.057c-.886 1.418-1.772 2.838-2.542 4.265v1.12H8.85V12h1.26v-1.559h1.007V9.334H10.11V4.002H8.176c-.218.352-.438.703-.657 1.055ZM6.225 9.281v.053H8.85V5.063h-.065c-.867 1.33-1.787 2.806-2.56 4.218Z"
                }
            }
        ]
    })(props);
}
function BsFill4SquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.225 9.281v.053H8.85V5.063h-.065c-.867 1.33-1.787 2.806-2.56 4.218Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm5.519 5.057c.22-.352.439-.703.657-1.055h1.933v5.332h1.008v1.107H10.11V12H8.85v-1.559H4.978V9.322c.77-1.427 1.656-2.847 2.542-4.265Z"
                }
            }
        ]
    })(props);
}
function BsFill5CircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-8.006 4.158c1.74 0 2.924-1.119 2.924-2.806 0-1.641-1.178-2.584-2.56-2.584-.897 0-1.442.421-1.612.68h-.064l.193-2.344h3.621V4.002H5.791L5.445 8.63h1.149c.193-.358.668-.809 1.435-.809.85 0 1.582.604 1.582 1.57 0 1.085-.779 1.682-1.57 1.682-.697 0-1.389-.31-1.53-1.031H5.276c.065 1.213 1.149 2.115 2.72 2.115Z"
                }
            }
        ]
    })(props);
}
function BsFill5SquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm5.994 12.158c-1.57 0-2.654-.902-2.719-2.115h1.237c.14.72.832 1.031 1.529 1.031.791 0 1.57-.597 1.57-1.681 0-.967-.732-1.57-1.582-1.57-.767 0-1.242.45-1.435.808H5.445L5.791 4h4.705v1.103H6.875l-.193 2.343h.064c.17-.258.715-.68 1.611-.68 1.383 0 2.561.944 2.561 2.585 0 1.687-1.184 2.806-2.924 2.806Z"
                }
            }
        ]
    })(props);
}
function BsFill6CircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM8.21 3.855c-1.868 0-3.116 1.395-3.116 4.407 0 1.183.228 2.039.597 2.642.569.926 1.477 1.254 2.409 1.254 1.629 0 2.847-1.013 2.847-2.783 0-1.676-1.254-2.555-2.508-2.555-1.125 0-1.752.61-1.98 1.155h-.082c-.012-1.946.727-3.036 1.805-3.036.802 0 1.213.457 1.312.815h1.29c-.06-.908-.962-1.899-2.573-1.899Zm-.099 4.008c-.92 0-1.564.65-1.564 1.576 0 1.032.703 1.635 1.558 1.635.868 0 1.553-.533 1.553-1.629 0-1.06-.744-1.582-1.547-1.582Z"
                }
            }
        ]
    })(props);
}
function BsFill6SquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.111 7.863c-.92 0-1.564.65-1.564 1.576 0 1.032.703 1.635 1.558 1.635.868 0 1.553-.533 1.553-1.629 0-1.06-.744-1.582-1.547-1.582Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm6.21 3.855c1.612 0 2.515.99 2.573 1.899H9.494c-.1-.358-.51-.815-1.312-.815-1.078 0-1.817 1.09-1.805 3.036h.082c.229-.545.855-1.155 1.98-1.155 1.254 0 2.508.88 2.508 2.555 0 1.77-1.218 2.783-2.847 2.783-.932 0-1.84-.328-2.409-1.254-.369-.603-.597-1.459-.597-2.642 0-3.012 1.248-4.407 3.117-4.407Z"
                }
            }
        ]
    })(props);
}
function BsFill7CircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM5.37 5.11h3.972v.07L6.025 12H7.42l3.258-6.85V4.002H5.369v1.107Z"
                }
            }
        ]
    })(props);
}
function BsFill7SquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm3.37 5.11V4.001h5.308V5.15L7.42 12H6.025l3.317-6.82v-.07H5.369Z"
                }
            }
        ]
    })(props);
}
function BsFill8CircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-5.03 1.803c0-1.248-.943-1.84-1.646-1.992v-.065c.598-.187 1.336-.72 1.336-1.781 0-1.225-1.084-2.121-2.654-2.121-1.57 0-2.66.896-2.66 2.12 0 1.044.709 1.589 1.33 1.782v.065c-.697.152-1.647.732-1.647 2.003 0 1.39 1.19 2.344 2.953 2.344 1.77 0 2.989-.96 2.989-2.355Zm-4.347-3.71c0 .739.586 1.255 1.383 1.255s1.377-.516 1.377-1.254c0-.733-.58-1.23-1.377-1.23s-1.383.497-1.383 1.23Zm-.281 3.645c0 .838.72 1.412 1.664 1.412.943 0 1.658-.574 1.658-1.412 0-.843-.715-1.424-1.658-1.424-.944 0-1.664.58-1.664 1.424Z"
                }
            }
        ]
    })(props);
}
function BsFill8SquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.623 6.094c0 .738.586 1.254 1.383 1.254s1.377-.516 1.377-1.254c0-.733-.58-1.23-1.377-1.23s-1.383.497-1.383 1.23Zm-.281 3.644c0 .838.72 1.412 1.664 1.412.943 0 1.658-.574 1.658-1.412 0-.843-.715-1.424-1.658-1.424-.944 0-1.664.58-1.664 1.424Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm8.97 9.803c0 1.394-1.218 2.355-2.988 2.355-1.763 0-2.953-.955-2.953-2.344 0-1.271.95-1.851 1.647-2.003v-.065c-.621-.193-1.33-.738-1.33-1.781 0-1.225 1.09-2.121 2.66-2.121s2.654.896 2.654 2.12c0 1.061-.738 1.595-1.336 1.782v.065c.703.152 1.647.744 1.647 1.992Z"
                }
            }
        ]
    })(props);
}
function BsFill9CircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-8.223 4.146c2.104 0 3.123-1.464 3.123-4.3 0-3.147-1.459-4.014-2.97-4.014-1.63 0-2.871 1.02-2.871 2.73 0 1.706 1.171 2.667 2.566 2.667 1.06 0 1.7-.557 1.934-1.184h.076c.047 1.67-.475 3.023-1.834 3.023-.71 0-1.149-.363-1.248-.72H5.258c.094.908.926 1.798 2.52 1.798Zm.118-3.972c.808 0 1.535-.528 1.535-1.594s-.668-1.676-1.56-1.676c-.838 0-1.517.616-1.517 1.659 0 1.072.708 1.61 1.54 1.61Z"
                }
            }
        ]
    })(props);
}
function BsFill9SquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.895 8.174c.808 0 1.535-.528 1.535-1.594s-.668-1.676-1.56-1.676c-.838 0-1.517.616-1.517 1.659 0 1.072.708 1.61 1.54 1.61Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm5.777 12.146c-1.593 0-2.425-.89-2.52-1.798h1.296c.1.357.539.72 1.248.72 1.36 0 1.88-1.353 1.834-3.023h-.076c-.235.627-.873 1.184-1.934 1.184-1.395 0-2.566-.961-2.566-2.666 0-1.711 1.242-2.731 2.87-2.731 1.512 0 2.971.867 2.971 4.014 0 2.836-1.02 4.3-3.123 4.3Z"
                }
            }
        ]
    })(props);
}
function BsFillAirplaneEnginesFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-.787 0-1.292.592-1.572 1.151A4.347 4.347 0 0 0 6 3v3.691l-2 1V7.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.191l-1.17.585A1.5 1.5 0 0 0 0 10.618V12a.5.5 0 0 0 .582.493l1.631-.272.313.937a.5.5 0 0 0 .948 0l.405-1.214 2.21-.369.375 2.253-1.318 1.318A.5.5 0 0 0 5.5 16h5a.5.5 0 0 0 .354-.854l-1.318-1.318.375-2.253 2.21.369.405 1.214a.5.5 0 0 0 .948 0l.313-.937 1.63.272A.5.5 0 0 0 16 12v-1.382a1.5 1.5 0 0 0-.83-1.342L14 8.691V7.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v.191l-2-1V3c0-.568-.14-1.271-.428-1.849C9.292.591 8.787 0 8 0Z"
                }
            }
        ]
    })(props);
}
function BsFillAirplaneFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.428 1.151C6.708.591 7.213 0 8 0s1.292.592 1.572 1.151C9.861 1.73 10 2.431 10 3v3.691l5.17 2.585a1.5 1.5 0 0 1 .83 1.342V12a.5.5 0 0 1-.582.493l-5.507-.918-.375 2.253 1.318 1.318A.5.5 0 0 1 10.5 16h-5a.5.5 0 0 1-.354-.854l1.319-1.318-.376-2.253-5.507.918A.5.5 0 0 1 0 12v-1.382a1.5 1.5 0 0 1 .83-1.342L6 6.691V3c0-.568.14-1.271.428-1.849Z"
                }
            }
        ]
    })(props);
}
function BsFillAlarmFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 .5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1H9v1.07a7.001 7.001 0 0 1 3.274 12.474l.601.602a.5.5 0 0 1-.707.708l-.746-.746A6.97 6.97 0 0 1 8 16a6.97 6.97 0 0 1-3.422-.892l-.746.746a.5.5 0 0 1-.707-.708l.602-.602A7.001 7.001 0 0 1 7 2.07V1h-.5A.5.5 0 0 1 6 .5zm2.5 5a.5.5 0 0 0-1 0v3.362l-1.429 2.38a.5.5 0 1 0 .858.515l1.5-2.5A.5.5 0 0 0 8.5 9V5.5zM.86 5.387A2.5 2.5 0 1 1 4.387 1.86 8.035 8.035 0 0 0 .86 5.387zM11.613 1.86a2.5 2.5 0 1 1 3.527 3.527 8.035 8.035 0 0 0-3.527-3.527z"
                }
            }
        ]
    })(props);
}
function BsFillArchiveFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15h9.286zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8H.8z"
                }
            }
        ]
    })(props);
}
function BsFillArrowDownCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V4.5z"
                }
            }
        ]
    })(props);
}
function BsFillArrowDownLeftCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0zm-5.904-2.803a.5.5 0 1 1 .707.707L6.707 10h2.768a.5.5 0 0 1 0 1H5.5a.5.5 0 0 1-.5-.5V6.525a.5.5 0 0 1 1 0v2.768l4.096-4.096z"
                }
            }
        ]
    })(props);
}
function BsFillArrowDownLeftSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2zm8.096-10.803L6 9.293V6.525a.5.5 0 0 0-1 0V10.5a.5.5 0 0 0 .5.5h3.975a.5.5 0 0 0 0-1H6.707l4.096-4.096a.5.5 0 1 0-.707-.707z"
                }
            }
        ]
    })(props);
}
function BsFillArrowDownRightCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm5.904-2.803a.5.5 0 1 0-.707.707L9.293 10H6.525a.5.5 0 0 0 0 1H10.5a.5.5 0 0 0 .5-.5V6.525a.5.5 0 0 0-1 0v2.768L5.904 5.197z"
                }
            }
        ]
    })(props);
}
function BsFillArrowDownRightSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12zM5.904 5.197 10 9.293V6.525a.5.5 0 0 1 1 0V10.5a.5.5 0 0 1-.5.5H6.525a.5.5 0 0 1 0-1h2.768L5.197 5.904a.5.5 0 0 1 .707-.707z"
                }
            }
        ]
    })(props);
}
function BsFillArrowDownSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5a.5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsFillArrowLeftCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"
                }
            }
        ]
    })(props);
}
function BsFillArrowLeftSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12zm-4.5-6.5H5.707l2.147-2.146a.5.5 0 1 0-.708-.708l-3 3a.5.5 0 0 0 0 .708l3 3a.5.5 0 0 0 .708-.708L5.707 8.5H11.5a.5.5 0 0 0 0-1z"
                }
            }
        ]
    })(props);
}
function BsFillArrowRightCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"
                }
            }
        ]
    })(props);
}
function BsFillArrowRightSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v12zm4.5-6.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsFillArrowThroughHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.854 15.854A.5.5 0 0 1 2 15.5V14H.5a.5.5 0 0 1-.354-.854l1.5-1.5A.5.5 0 0 1 2 11.5h1.793l3.103-3.104a.5.5 0 1 1 .708.708L4.5 12.207V14a.5.5 0 0 1-.146.354l-1.5 1.5ZM16 3.5a.5.5 0 0 1-.854.354L14 2.707l-1.006 1.006c.236.248.44.531.6.845.562 1.096.585 2.517-.213 4.092-.793 1.563-2.395 3.288-5.105 5.08L8 13.912l-.276-.182A23.825 23.825 0 0 1 5.8 12.323L8.31 9.81a1.5 1.5 0 0 0-2.122-2.122L3.657 10.22a8.827 8.827 0 0 1-1.039-1.57c-.798-1.576-.775-2.997-.213-4.093C3.426 2.565 6.18 1.809 8 3.233c1.25-.98 2.944-.928 4.212-.152L13.292 2 12.147.854A.5.5 0 0 1 12.5 0h3a.5.5 0 0 1 .5.5v3Z"
                }
            }
        ]
    })(props);
}
function BsFillArrowUpCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0zm-7.5 3.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11.5z"
                }
            }
        ]
    })(props);
}
function BsFillArrowUpLeftCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-5.904 2.803a.5.5 0 1 0 .707-.707L6.707 6h2.768a.5.5 0 1 0 0-1H5.5a.5.5 0 0 0-.5.5v3.975a.5.5 0 0 0 1 0V6.707l4.096 4.096z"
                }
            }
        ]
    })(props);
}
function BsFillArrowUpLeftSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm8.096 10.803L6 6.707v2.768a.5.5 0 0 1-1 0V5.5a.5.5 0 0 1 .5-.5h3.975a.5.5 0 1 1 0 1H6.707l4.096 4.096a.5.5 0 1 1-.707.707z"
                }
            }
        ]
    })(props);
}
function BsFillArrowUpRightCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 8a8 8 0 1 0 16 0A8 8 0 0 0 0 8zm5.904 2.803a.5.5 0 1 1-.707-.707L9.293 6H6.525a.5.5 0 1 1 0-1H10.5a.5.5 0 0 1 .5.5v3.975a.5.5 0 0 1-1 0V6.707l-4.096 4.096z"
                }
            }
        ]
    })(props);
}
function BsFillArrowUpRightSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12zM5.904 10.803 10 6.707v2.768a.5.5 0 0 0 1 0V5.5a.5.5 0 0 0-.5-.5H6.525a.5.5 0 1 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 .707.707z"
                }
            }
        ]
    })(props);
}
function BsFillArrowUpSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2zm6.5-4.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 1 0z"
                }
            }
        ]
    })(props);
}
function BsFillAspectRatioFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 12.5v-9A1.5 1.5 0 0 1 1.5 2h13A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5zM2.5 4a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 1 0V5h2.5a.5.5 0 0 0 0-1h-3zm11 8a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-1 0V11h-2.5a.5.5 0 0 0 0 1h3z"
                }
            }
        ]
    })(props);
}
function BsFillAwardFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m8 0 1.669.864 1.858.282.842 1.68 1.337 1.32L13.4 6l.306 1.854-1.337 1.32-.842 1.68-1.858.282L8 12l-1.669-.864-1.858-.282-.842-1.68-1.337-1.32L2.6 6l-.306-1.854 1.337-1.32.842-1.68L6.331.864 8 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1 4 11.794z"
                }
            }
        ]
    })(props);
}
function BsFillBackpackFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 13v-3h4v.5a.5.5 0 0 0 1 0V10h1v3H5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2v.341C3.67 3.165 2 5.388 2 8v5.5A2.5 2.5 0 0 0 4.5 16h7a2.5 2.5 0 0 0 2.5-2.5V8a6.002 6.002 0 0 0-4-5.659V2a2 2 0 1 0-4 0Zm2-1a1 1 0 0 1 1 1v.083a6.04 6.04 0 0 0-2 0V2a1 1 0 0 1 1-1Zm0 3a4 4 0 0 1 3.96 3.43.5.5 0 1 1-.99.14 3 3 0 0 0-5.94 0 .5.5 0 1 1-.99-.14A4 4 0 0 1 8 4ZM4.5 9h7a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5Z"
                }
            }
        ]
    })(props);
}
function BsFillBackpack2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 13h6v-3h-1v.5a.5.5 0 0 1-1 0V10H5v3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2v.341C3.67 3.165 2 5.388 2 8v1.191l-1.17.585A1.5 1.5 0 0 0 0 11.118V13.5A1.5 1.5 0 0 0 1.5 15h1c.456.607 1.182 1 2 1h7c.818 0 1.544-.393 2-1h1a1.5 1.5 0 0 0 1.5-1.5v-2.382a1.5 1.5 0 0 0-.83-1.342L14 9.191V8a6.002 6.002 0 0 0-4-5.659V2a2 2 0 1 0-4 0Zm2-1a1 1 0 0 1 1 1v.083a6.04 6.04 0 0 0-2 0V2a1 1 0 0 1 1-1Zm0 3a4 4 0 0 1 3.96 3.43.5.5 0 1 1-.99.14 3 3 0 0 0-5.94 0 .5.5 0 1 1-.99-.14A4 4 0 0 1 8 4ZM4.5 9h7a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5Z"
                }
            }
        ]
    })(props);
}
function BsFillBackpack3Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 10v3h6v-3h-1v.5a.5.5 0 0 1-1 0V10H5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2v.341a5.978 5.978 0 0 0-1.308.653l-.416-1.247a1 1 0 0 0-1.749-.284l-.77 1.027a1 1 0 0 0-.149.917l.803 2.407A5.985 5.985 0 0 0 2 8v5.5A2.5 2.5 0 0 0 4.5 16h7a2.5 2.5 0 0 0 2.5-2.5V8c0-.771-.146-1.509-.41-2.186l.801-2.407a1 1 0 0 0-.148-.917l-.77-1.027a1 1 0 0 0-1.75.284l-.415 1.247A5.976 5.976 0 0 0 10 2.34V2a2 2 0 1 0-4 0Zm1 0a1 1 0 0 1 2 0v.083a6.04 6.04 0 0 0-2 0V2Zm5.941 2.595a6.036 6.036 0 0 0-.8-.937l.531-1.595.77 1.027-.5 1.505ZM3.86 3.658a6.031 6.031 0 0 0-.8.937L2.557 3.09l.77-1.027.532 1.595Zm.18 3.772a4 4 0 0 1 7.92 0 .5.5 0 1 1-.99.142 3 3 0 0 0-5.94 0 .5.5 0 1 1-.99-.142ZM4 9.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-4Z"
                }
            }
        ]
    })(props);
}
function BsFillBackpack4Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a2 2 0 0 0-2 2H3.5a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h4v.5a.5.5 0 0 0 1 0V7h4a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H10a2 2 0 0 0-2-2Zm1 2a1 1 0 0 0-2 0h2Zm-4 9v2h6v-2h-1v.5a.5.5 0 0 1-1 0V11H5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7.599A2.986 2.986 0 0 1 12.5 8H9.415a1.5 1.5 0 0 1-2.83 0H3.5A2.986 2.986 0 0 1 2 7.599V14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.599ZM4 10.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-3Z"
                }
            }
        ]
    })(props);
}
function BsFillBackspaceFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.683 3a2 2 0 0 0-2-2h-7.08a2 2 0 0 0-1.519.698L.241 7.35a1 1 0 0 0 0 1.302l4.843 5.65A2 2 0 0 0 6.603 15h7.08a2 2 0 0 0 2-2V3zM5.829 5.854a.5.5 0 1 1 .707-.708l2.147 2.147 2.146-2.147a.5.5 0 1 1 .707.708L9.39 8l2.146 2.146a.5.5 0 0 1-.707.708L8.683 8.707l-2.147 2.147a.5.5 0 0 1-.707-.708L7.976 8 5.829 5.854z"
                }
            }
        ]
    })(props);
}
function BsFillBackspaceReverseFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3a2 2 0 0 1 2-2h7.08a2 2 0 0 1 1.519.698l4.843 5.651a1 1 0 0 1 0 1.302L10.6 14.3a2 2 0 0 1-1.52.7H2a2 2 0 0 1-2-2V3zm9.854 2.854a.5.5 0 0 0-.708-.708L7 7.293 4.854 5.146a.5.5 0 1 0-.708.708L6.293 8l-2.147 2.146a.5.5 0 0 0 .708.708L7 8.707l2.146 2.147a.5.5 0 0 0 .708-.708L7.707 8l2.147-2.146z"
                }
            }
        ]
    })(props);
}
function BsFillBadge3DFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.157 5.968h-.844v4.06h.844c1.116 0 1.621-.667 1.621-2.02 0-1.354-.51-2.04-1.621-2.04z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm5.184 4.368c.646 0 1.055.378 1.06.9.008.537-.427.919-1.086.919-.598-.004-1.037-.325-1.068-.756H3c.03.914.791 1.688 2.153 1.688 1.24 0 2.285-.66 2.272-1.798-.013-.953-.747-1.38-1.292-1.432v-.062c.44-.07 1.125-.527 1.108-1.375-.013-.906-.8-1.57-2.053-1.565-1.31.005-2.043.734-2.074 1.67h1.103c.022-.391.383-.751.936-.751.532 0 .928.33.928.813.004.479-.383.835-.928.835h-.632v.914h.663zM8.126 11h2.189C12.125 11 13 9.893 13 7.985c0-1.894-.861-2.984-2.685-2.984H8.126V11z"
                }
            }
        ]
    })(props);
}
function BsFillBadge4KFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.577 8.9v.03h1.828V5.898h-.062a46.781 46.781 0 0 0-1.766 3.001z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm2.372 3.715.435-.714h1.71v3.93h.733v.957h-.733V11H5.405V9.888H2.5v-.971c.574-1.077 1.225-2.142 1.872-3.202zm7.73-.714h1.306l-2.14 2.584L13.5 11h-1.428l-1.679-2.624-.615.7V11H8.59V5.001h1.187v2.686h.057L12.102 5z"
                }
            }
        ]
    })(props);
}
function BsFillBadge8KFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.9 6.605c0 .51.405.866.95.866.545 0 .945-.356.945-.866s-.4-.852-.945-.852c-.545 0-.95.343-.95.852zm-.192 2.668c0 .589.492.984 1.142.984.646 0 1.143-.395 1.143-.984S5.496 8.28 4.85 8.28c-.65 0-1.142.404-1.142.993z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm5.17 7.348c0 1.041-.927 1.766-2.333 1.766-1.406 0-2.312-.72-2.312-1.762 0-.954.712-1.384 1.257-1.494v-.053c-.51-.154-1.02-.558-1.02-1.331 0-.914.831-1.587 2.088-1.587 1.253 0 2.083.673 2.083 1.587 0 .782-.523 1.182-1.02 1.331v.053c.545.11 1.257.545 1.257 1.49zM12.102 5h1.306l-2.14 2.584 2.232 3.415h-1.428l-1.679-2.624-.615.699v1.925H8.59V5h1.187v2.685h.057L12.102 5z"
                }
            }
        ]
    })(props);
}
function BsFillBadgeAdFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.35 8.337c0-.699-.42-1.138-1.001-1.138-.584 0-.954.444-.954 1.239v.453c0 .8.374 1.248.972 1.248.588 0 .984-.44.984-1.2v-.602zm-5.413.237-.734-2.426H5.15l-.734 2.426h1.52z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm6.209 6.32c0-1.28.694-2.044 1.753-2.044.655 0 1.156.294 1.336.769h.053v-2.36h1.16V11h-1.138v-.747h-.057c-.145.474-.69.804-1.367.804-1.055 0-1.74-.764-1.74-2.043v-.695zm-4.04 1.138L3.7 11H2.5l2.013-5.999H5.9L7.905 11H6.644l-.47-1.542H4.17z"
                }
            }
        ]
    })(props);
}
function BsFillBadgeArFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m6.031 8.574-.734-2.426h-.052L4.51 8.574h1.52zm3.642-2.641v1.938h1.033c.66 0 1.068-.316 1.068-.95 0-.64-.422-.988-1.05-.988h-1.05z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm4.265 5.458h2.004L6.739 11H8L5.996 5.001H4.607L2.595 11h1.2l.47-1.542zM8.5 5v6h1.173V8.763h1.064L11.787 11h1.327L11.91 8.583C12.455 8.373 13 7.779 13 6.9c0-1.147-.773-1.9-2.105-1.9H8.5z"
                }
            }
        ]
    })(props);
}
function BsFillBadgeCcFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm3.027 4.002c-.83 0-1.319.642-1.319 1.753v.743c0 1.107.48 1.727 1.319 1.727.69 0 1.138-.435 1.186-1.05H7.36v.114c-.057 1.147-1.028 1.938-2.342 1.938-1.613 0-2.518-1.028-2.518-2.729v-.747C2.5 6.051 3.414 5 5.018 5c1.318 0 2.29.813 2.342 2v.11H6.213c-.048-.638-.505-1.108-1.186-1.108zm6.14 0c-.831 0-1.319.642-1.319 1.753v.743c0 1.107.48 1.727 1.318 1.727.69 0 1.139-.435 1.187-1.05H13.5v.114c-.057 1.147-1.028 1.938-2.342 1.938-1.613 0-2.518-1.028-2.518-2.729v-.747c0-1.7.914-2.751 2.518-2.751 1.318 0 2.29.813 2.342 2v.11h-1.147c-.048-.638-.505-1.108-1.187-1.108z"
                }
            }
        ]
    })(props);
}
function BsFillBadgeHdFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.53 5.968h-.843v4.06h.843c1.117 0 1.622-.667 1.622-2.02 0-1.354-.51-2.04-1.622-2.04z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm5.396 3.001V11H6.209V8.43H3.687V11H2.5V5.001h1.187v2.44h2.522V5h1.187zM8.5 11V5.001h2.188c1.824 0 2.685 1.09 2.685 2.984C13.373 9.893 12.5 11 10.69 11H8.5z"
                }
            }
        ]
    })(props);
}
function BsFillBadgeSdFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.338 5.968h-.844v4.06h.844c1.116 0 1.622-.667 1.622-2.02 0-1.354-.51-2.04-1.622-2.04Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm5.077 7.114c1.521 0 2.378-.764 2.378-1.88 0-1.007-.642-1.473-1.613-1.692l-.932-.216c-.527-.114-.821-.351-.821-.712 0-.466.39-.804 1.046-.804.637 0 1.028.33 1.103.76h1.125c-.058-.923-.849-1.692-2.22-1.692-1.322 0-2.24.717-2.24 1.815 0 .91.588 1.446 1.52 1.657l.927.215c.624.145.923.36.923.778 0 .492-.391.83-1.13.83-.707 0-1.155-.342-1.234-.808H2.762c.052.95.79 1.75 2.315 1.75ZM8.307 11h2.19c1.81 0 2.684-1.107 2.684-3.015 0-1.894-.861-2.984-2.685-2.984H8.308V11Z"
                }
            }
        ]
    })(props);
}
function BsFillBadgeTmFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm3.295 3.995V11H4.104V5.995h-1.7V5H7v.994H5.295zM8.692 7.01V11H7.633V5.001h1.209l1.71 3.894h.039l1.71-3.894H13.5V11h-1.072V7.01h-.057l-1.42 3.239h-.773L8.75 7.008h-.058z"
                }
            }
        ]
    })(props);
}
function BsFillBadgeVoFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.296 8.394v-.782c0-1.156-.571-1.736-1.362-1.736-.796 0-1.363.58-1.363 1.736v.782c0 1.156.567 1.732 1.363 1.732.79 0 1.362-.576 1.362-1.732z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm11.5 5.62v.77c0 1.691-.962 2.724-2.566 2.724-1.604 0-2.571-1.033-2.571-2.724v-.77c0-1.704.967-2.733 2.57-2.733 1.605 0 2.567 1.037 2.567 2.734zM5.937 11H4.508L2.5 5.001h1.375L5.22 9.708h.057L6.61 5.001h1.318L5.937 11z"
                }
            }
        ]
    })(props);
}
function BsFillBadgeVrFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.673 5.933v1.938h1.033c.66 0 1.068-.316 1.068-.95 0-.64-.422-.988-1.05-.988h-1.05z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm5.937 7 1.99-5.999H6.61L5.277 9.708H5.22L3.875 5.001H2.5L4.508 11h1.429zM8.5 5.001V11h1.173V8.763h1.064L11.787 11h1.327L11.91 8.583C12.455 8.373 13 7.779 13 6.9c0-1.147-.773-1.9-2.105-1.9H8.5z"
                }
            }
        ]
    })(props);
}
function BsFillBadgeWcFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm11.666 1.89c.682 0 1.139.47 1.187 1.107H14v-.11c-.053-1.187-1.024-2-2.342-2-1.604 0-2.518 1.05-2.518 2.751v.747c0 1.7.905 2.73 2.518 2.73 1.314 0 2.285-.792 2.342-1.939v-.114h-1.147c-.048.615-.497 1.05-1.187 1.05-.839 0-1.318-.62-1.318-1.727v-.742c0-1.112.488-1.754 1.318-1.754zm-6.188.926h.044L6.542 11h1.006L9 5.001H7.818l-.82 4.355h-.056L5.97 5.001h-.94l-.972 4.355h-.053l-.827-4.355H2L3.452 11h1.005l1.02-4.184z"
                }
            }
        ]
    })(props);
}
function BsFillBagCheckFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.5 3.5a2.5 2.5 0 0 0-5 0V4h5v-.5zm1 0V4H15v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4h3.5v-.5a3.5 3.5 0 1 1 7 0zm-.646 5.354a.5.5 0 0 0-.708-.708L7.5 10.793 6.354 9.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z"
                }
            }
        ]
    })(props);
}
function BsFillBagDashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.5 3.5a2.5 2.5 0 0 0-5 0V4h5v-.5zm1 0V4H15v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4h3.5v-.5a3.5 3.5 0 1 1 7 0zM6 9.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H6z"
                }
            }
        ]
    })(props);
}
function BsFillBagFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5z"
                }
            }
        ]
    })(props);
}
function BsFillBagHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 4v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5ZM8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1Zm0 6.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z"
                }
            }
        ]
    })(props);
}
function BsFillBagPlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.5 3.5a2.5 2.5 0 0 0-5 0V4h5v-.5zm1 0V4H15v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4h3.5v-.5a3.5 3.5 0 1 1 7 0zM8.5 8a.5.5 0 0 0-1 0v1.5H6a.5.5 0 0 0 0 1h1.5V12a.5.5 0 0 0 1 0v-1.5H10a.5.5 0 0 0 0-1H8.5V8z"
                }
            }
        ]
    })(props);
}
function BsFillBagXFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.5 3.5a2.5 2.5 0 0 0-5 0V4h5v-.5zm1 0V4H15v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4h3.5v-.5a3.5 3.5 0 1 1 7 0zM6.854 8.146a.5.5 0 1 0-.708.708L7.293 10l-1.147 1.146a.5.5 0 0 0 .708.708L8 10.707l1.146 1.147a.5.5 0 0 0 .708-.708L8.707 10l1.147-1.146a.5.5 0 0 0-.708-.708L8 9.293 6.854 8.146z"
                }
            }
        ]
    })(props);
}
function BsFillBalloonFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.48 10.901C11.211 10.227 13 7.837 13 5A5 5 0 0 0 3 5c0 2.837 1.789 5.227 4.52 5.901l-.244.487a.25.25 0 1 0 .448.224l.04-.08c.009.17.024.315.051.45.068.344.208.622.448 1.102l.013.028c.212.422.182.85.05 1.246-.135.402-.366.751-.534 1.003a.25.25 0 0 0 .416.278l.004-.007c.166-.248.431-.646.588-1.115.16-.479.212-1.051-.076-1.629-.258-.515-.365-.732-.419-1.004a2.376 2.376 0 0 1-.037-.289l.008.017a.25.25 0 1 0 .448-.224l-.244-.487ZM4.352 3.356a4.004 4.004 0 0 1 3.15-2.325C7.774.997 8 1.224 8 1.5c0 .276-.226.496-.498.542-.95.162-1.749.78-2.173 1.617a.595.595 0 0 1-.52.341c-.346 0-.599-.329-.457-.644Z"
                }
            }
        ]
    })(props);
}
function BsFillBalloonHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.49 10.92C19.412 3.382 11.28-2.387 8 .986 4.719-2.387-3.413 3.382 7.51 10.92l-.234.468a.25.25 0 1 0 .448.224l.04-.08c.009.17.024.315.051.45.068.344.208.622.448 1.102l.013.028c.212.422.182.85.05 1.246-.135.402-.366.751-.534 1.003a.25.25 0 0 0 .416.278l.004-.007c.166-.248.431-.646.588-1.115.16-.479.212-1.051-.076-1.629-.258-.515-.365-.732-.419-1.004a2.376 2.376 0 0 1-.037-.289l.008.017a.25.25 0 1 0 .448-.224l-.235-.468ZM6.726 1.269c-1.167-.61-2.8-.142-3.454 1.135-.237.463-.36 1.08-.202 1.85.055.27.467.197.527-.071.285-1.256 1.177-2.462 2.989-2.528.234-.008.348-.278.14-.386Z"
                }
            }
        ]
    })(props);
}
function BsFillBanFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM2.71 12.584c.218.252.454.488.706.707l9.875-9.875a7.034 7.034 0 0 0-.707-.707l-9.875 9.875Z"
                }
            }
        ]
    })(props);
}
function BsFillBandaidFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.68 7.676 6.49-6.504a4 4 0 0 1 5.66 5.653l-1.477 1.529-5.006 5.006-1.523 1.472a4 4 0 0 1-5.653-5.66l.001-.002 1.505-1.492.001-.002Zm5.71-2.858a.5.5 0 1 0-.708.707.5.5 0 0 0 .707-.707ZM6.974 6.939a.5.5 0 1 0-.707-.707.5.5 0 0 0 .707.707ZM5.56 8.354a.5.5 0 1 0-.707-.708.5.5 0 0 0 .707.708Zm2.828 2.828a.5.5 0 1 0-.707-.707.5.5 0 0 0 .707.707Zm1.414-2.121a.5.5 0 1 0-.707.707.5.5 0 0 0 .707-.707Zm1.414-.707a.5.5 0 1 0-.706-.708.5.5 0 0 0 .707.708Zm-4.242.707a.5.5 0 1 0-.707.707.5.5 0 0 0 .707-.707Zm1.414-.707a.5.5 0 1 0-.707-.708.5.5 0 0 0 .707.708Zm1.414-2.122a.5.5 0 1 0-.707.707.5.5 0 0 0 .707-.707ZM8.646 3.354l4 4 .708-.708-4-4-.708.708Zm-1.292 9.292-4-4-.708.708 4 4 .708-.708Z"
                }
            }
        ]
    })(props);
}
function BsFillBarChartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 11a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3zm5-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2z"
                }
            }
        ]
    })(props);
}
function BsFillBarChartLineFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h1V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7h1V2z"
                }
            }
        ]
    })(props);
}
function BsFillBasketFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.071 1.243a.5.5 0 0 1 .858.514L3.383 6h9.234L10.07 1.757a.5.5 0 1 1 .858-.514L13.783 6H15.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H15v5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9H.5a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 .5 6h1.717L5.07 1.243zM3.5 10.5a.5.5 0 1 0-1 0v3a.5.5 0 0 0 1 0v-3zm2.5 0a.5.5 0 1 0-1 0v3a.5.5 0 0 0 1 0v-3zm2.5 0a.5.5 0 1 0-1 0v3a.5.5 0 0 0 1 0v-3zm2.5 0a.5.5 0 1 0-1 0v3a.5.5 0 0 0 1 0v-3zm2.5 0a.5.5 0 1 0-1 0v3a.5.5 0 0 0 1 0v-3z"
                }
            }
        ]
    })(props);
}
function BsFillBasket2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.929 1.757a.5.5 0 1 0-.858-.514L2.217 6H.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h.623l1.844 6.456A.75.75 0 0 0 3.69 15h8.622a.75.75 0 0 0 .722-.544L14.877 8h.623a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1.717L10.93 1.243a.5.5 0 1 0-.858.514L12.617 6H3.383L5.93 1.757zM4 10a1 1 0 0 1 2 0v2a1 1 0 1 1-2 0v-2zm3 0a1 1 0 0 1 2 0v2a1 1 0 1 1-2 0v-2zm4-1a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1z"
                }
            }
        ]
    })(props);
}
function BsFillBasket3Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.757 1.071a.5.5 0 0 1 .172.686L3.383 6h9.234L10.07 1.757a.5.5 0 1 1 .858-.514L13.783 6H15.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-1A.5.5 0 0 1 .5 6h1.717L5.07 1.243a.5.5 0 0 1 .686-.172zM2.468 15.426.943 9h14.114l-1.525 6.426a.75.75 0 0 1-.729.574H3.197a.75.75 0 0 1-.73-.574z"
                }
            }
        ]
    })(props);
}
function BsFillBellFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zm.995-14.901a1 1 0 1 0-1.99 0A5.002 5.002 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901z"
                }
            }
        ]
    })(props);
}
function BsFillBellSlashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.164 14H15c-1.5-1-2-5.902-2-7 0-.264-.02-.523-.06-.776L5.164 14zm6.288-10.617A4.988 4.988 0 0 0 8.995 2.1a1 1 0 1 0-1.99 0A5.002 5.002 0 0 0 3 7c0 .898-.335 4.342-1.278 6.113l9.73-9.73zM10 15a2 2 0 1 1-4 0h4zm-9.375.625a.53.53 0 0 0 .75.75l14.75-14.75a.53.53 0 0 0-.75-.75L.625 15.625z"
                }
            }
        ]
    })(props);
}
function BsFillBinocularsFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 1A1.5 1.5 0 0 0 3 2.5V3h4v-.5A1.5 1.5 0 0 0 5.5 1h-1zM7 4v1h2V4h4v.882a.5.5 0 0 0 .276.447l.895.447A1.5 1.5 0 0 1 15 7.118V13H9v-1.5a.5.5 0 0 1 .146-.354l.854-.853V9.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v.793l.854.853A.5.5 0 0 1 7 11.5V13H1V7.118a1.5 1.5 0 0 1 .83-1.342l.894-.447A.5.5 0 0 0 3 4.882V4h4zM1 14v.5A1.5 1.5 0 0 0 2.5 16h3A1.5 1.5 0 0 0 7 14.5V14H1zm8 0v.5a1.5 1.5 0 0 0 1.5 1.5h3a1.5 1.5 0 0 0 1.5-1.5V14H9zm4-11H9v-.5A1.5 1.5 0 0 1 10.5 1h1A1.5 1.5 0 0 1 13 2.5V3z"
                }
            }
        ]
    })(props);
}
function BsFillBookFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783z"
                }
            }
        ]
    })(props);
}
function BsFillBookmarkCheckFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 15.5V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.74.439L8 13.069l-5.26 2.87A.5.5 0 0 1 2 15.5zm8.854-9.646a.5.5 0 0 0-.708-.708L7.5 7.793 6.354 6.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z"
                }
            }
        ]
    })(props);
}
function BsFillBookmarkDashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 15.5V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.74.439L8 13.069l-5.26 2.87A.5.5 0 0 1 2 15.5zM6 6a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H6z"
                }
            }
        ]
    })(props);
}
function BsFillBookmarkFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2v13.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z"
                }
            }
        ]
    })(props);
}
function BsFillBookmarkHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 15.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v13.5zM8 4.41c1.387-1.425 4.854 1.07 0 4.277C3.146 5.48 6.613 2.986 8 4.412z"
                }
            }
        ]
    })(props);
}
function BsFillBookmarkPlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 15.5V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.74.439L8 13.069l-5.26 2.87A.5.5 0 0 1 2 15.5zm6.5-11a.5.5 0 0 0-1 0V6H6a.5.5 0 0 0 0 1h1.5v1.5a.5.5 0 0 0 1 0V7H10a.5.5 0 0 0 0-1H8.5V4.5z"
                }
            }
        ]
    })(props);
}
function BsFillBookmarkStarFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 15.5V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.74.439L8 13.069l-5.26 2.87A.5.5 0 0 1 2 15.5zM8.16 4.1a.178.178 0 0 0-.32 0l-.634 1.285a.178.178 0 0 1-.134.098l-1.42.206a.178.178 0 0 0-.098.303L6.58 6.993c.042.041.061.1.051.158L6.39 8.565a.178.178 0 0 0 .258.187l1.27-.668a.178.178 0 0 1 .165 0l1.27.668a.178.178 0 0 0 .257-.187L9.368 7.15a.178.178 0 0 1 .05-.158l1.028-1.001a.178.178 0 0 0-.098-.303l-1.42-.206a.178.178 0 0 1-.134-.098L8.16 4.1z"
                }
            }
        ]
    })(props);
}
function BsFillBookmarkXFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 15.5V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.74.439L8 13.069l-5.26 2.87A.5.5 0 0 1 2 15.5zM6.854 5.146a.5.5 0 1 0-.708.708L7.293 7 6.146 8.146a.5.5 0 1 0 .708.708L8 7.707l1.146 1.147a.5.5 0 1 0 .708-.708L8.707 7l1.147-1.146a.5.5 0 0 0-.708-.708L8 6.293 6.854 5.146z"
                }
            }
        ]
    })(props);
}
function BsFillBookmarksFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v11.5a.5.5 0 0 1-.777.416L7 13.101l-4.223 2.815A.5.5 0 0 1 2 15.5V4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.268 1A2 2 0 0 1 6 0h6a2 2 0 0 1 2 2v11.5a.5.5 0 0 1-.777.416L13 13.768V2a1 1 0 0 0-1-1H4.268z"
                }
            }
        ]
    })(props);
}
function BsFillBoomboxFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 0a.5.5 0 0 1 .5.5V2h.5a1 1 0 0 1 1 1v2H0V3a1 1 0 0 1 1-1h12.5V.5A.5.5 0 0 1 14 0ZM2 3.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0Zm2 0a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0Zm7.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm1.5-.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0ZM9.5 3h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1ZM6 10.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-1.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm7 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm.5-1.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 6h16v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V6Zm2 4.5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0Zm7 0a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0Z"
                }
            }
        ]
    })(props);
}
function BsFillBootstrapFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.375 7.125V4.658h1.78c.973 0 1.542.457 1.542 1.237 0 .802-.604 1.23-1.764 1.23H6.375zm0 3.762h1.898c1.184 0 1.81-.48 1.81-1.377 0-.885-.65-1.348-1.886-1.348H6.375v2.725z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.002 0a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4h-8zm1.06 12V3.545h3.399c1.587 0 2.543.809 2.543 2.11 0 .884-.65 1.675-1.483 1.816v.1c1.143.117 1.904.931 1.904 2.033 0 1.488-1.084 2.396-2.888 2.396H5.062z"
                }
            }
        ]
    })(props);
}
function BsFillBoxFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.528 2.973a.75.75 0 0 1 .472.696v8.662a.75.75 0 0 1-.472.696l-7.25 2.9a.75.75 0 0 1-.557 0l-7.25-2.9A.75.75 0 0 1 0 12.331V3.669a.75.75 0 0 1 .471-.696L7.443.184l.004-.001.274-.11a.75.75 0 0 1 .558 0l.274.11.004.001 6.971 2.789Zm-1.374.527L8 5.962 1.846 3.5 1 3.839v.4l6.5 2.6v7.922l.5.2.5-.2V6.84l6.5-2.6v-.4l-.846-.339Z"
                }
            }
        ]
    })(props);
}
function BsFillBoxSeamFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.528 2.973a.75.75 0 0 1 .472.696v8.662a.75.75 0 0 1-.472.696l-7.25 2.9a.75.75 0 0 1-.557 0l-7.25-2.9A.75.75 0 0 1 0 12.331V3.669a.75.75 0 0 1 .471-.696L7.443.184l.01-.003.268-.108a.75.75 0 0 1 .558 0l.269.108.01.003 6.97 2.789ZM10.404 2 4.25 4.461 1.846 3.5 1 3.839v.4l6.5 2.6v7.922l.5.2.5-.2V6.84l6.5-2.6v-.4l-.846-.339L8 5.961 5.596 5l6.154-2.461L10.404 2Z"
                }
            }
        ]
    })(props);
}
function BsFillBox2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.75 0a1 1 0 0 0-.8.4L.1 4.2a.5.5 0 0 0-.1.3V15a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4.5a.5.5 0 0 0-.1-.3L13.05.4a1 1 0 0 0-.8-.4h-8.5ZM15 4.667V5H1v-.333L1.5 4h6V1h1v3h6l.5.667Z"
                }
            }
        ]
    })(props);
}
function BsFillBox2HeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.75 0a1 1 0 0 0-.8.4L.1 4.2a.5.5 0 0 0-.1.3V15a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4.5a.5.5 0 0 0-.1-.3L13.05.4a1 1 0 0 0-.8-.4h-8.5ZM8.5 4h6l.5.667V5H1v-.333L1.5 4h6V1h1v3ZM8 7.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z"
                }
            }
        ]
    })(props);
}
function BsFillBriefcaseFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v1.384l7.614 2.03a1.5 1.5 0 0 0 .772 0L16 5.884V4.5A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1h-3zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 12.5A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5V6.85L8.129 8.947a.5.5 0 0 1-.258 0L0 6.85v5.65z"
                }
            }
        ]
    })(props);
}
function BsFillBrightnessAltHighFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 3zm8 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zm-13.5.5a.5.5 0 0 0 0-1h-2a.5.5 0 0 0 0 1h2zm11.157-6.157a.5.5 0 0 1 0 .707l-1.414 1.414a.5.5 0 1 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm-9.9 2.121a.5.5 0 0 0 .707-.707L3.05 5.343a.5.5 0 1 0-.707.707l1.414 1.414zM8 7a4 4 0 0 0-4 4 .5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5 4 4 0 0 0-4-4z"
                }
            }
        ]
    })(props);
}
function BsFillBrightnessAltLowFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 5.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm5 6a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zM2 11a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0zm10.243-3.536a.5.5 0 1 1-.707-.707.5.5 0 0 1 .707.707zm-8.486-.707a.5.5 0 1 0 .707.707.5.5 0 0 0-.707-.707zM8 7a4 4 0 0 0-4 4 .5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5 4 4 0 0 0-4-4z"
                }
            }
        ]
    })(props);
}
function BsFillBrightnessHighFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z"
                }
            }
        ]
    })(props);
}
function BsFillBrightnessLowFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0zM8.5 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm0 11a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm5-5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm-11 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm9.743-4.036a.5.5 0 1 1-.707-.707.5.5 0 0 1 .707.707zm-7.779 7.779a.5.5 0 1 1-.707-.707.5.5 0 0 1 .707.707zm7.072 0a.5.5 0 1 1 .707-.707.5.5 0 0 1-.707.707zM3.757 4.464a.5.5 0 1 1 .707-.707.5.5 0 0 1-.707.707z"
                }
            }
        ]
    })(props);
}
function BsFillBrushFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.825.12a.5.5 0 0 1 .132.584c-1.53 3.43-4.743 8.17-7.095 10.64a6.067 6.067 0 0 1-2.373 1.534c-.018.227-.06.538-.16.868-.201.659-.667 1.479-1.708 1.74a8.118 8.118 0 0 1-3.078.132 3.659 3.659 0 0 1-.562-.135 1.382 1.382 0 0 1-.466-.247.714.714 0 0 1-.204-.288.622.622 0 0 1 .004-.443c.095-.245.316-.38.461-.452.394-.197.625-.453.867-.826.095-.144.184-.297.287-.472l.117-.198c.151-.255.326-.54.546-.848.528-.739 1.201-.925 1.746-.896.126.007.243.025.348.048.062-.172.142-.38.238-.608.261-.619.658-1.419 1.187-2.069 2.176-2.67 6.18-6.206 9.117-8.104a.5.5 0 0 1 .596.04z"
                }
            }
        ]
    })(props);
}
function BsFillBucketFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.522 5H2a.5.5 0 0 0-.494.574l1.372 9.149A1.5 1.5 0 0 0 4.36 16h7.278a1.5 1.5 0 0 0 1.483-1.277l1.373-9.149A.5.5 0 0 0 14 5h-.522A5.5 5.5 0 0 0 2.522 5zm1.005 0a4.5 4.5 0 0 1 8.945 0H3.527z"
                }
            }
        ]
    })(props);
}
function BsFillBugFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.978.855a.5.5 0 1 0-.956.29l.41 1.352A4.985 4.985 0 0 0 3 6h10a4.985 4.985 0 0 0-1.432-3.503l.41-1.352a.5.5 0 1 0-.956-.29l-.291.956A4.978 4.978 0 0 0 8 1a4.979 4.979 0 0 0-2.731.811l-.29-.956z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6v1H8.5v8.975A5 5 0 0 0 13 11h.5a.5.5 0 0 1 .5.5v.5a.5.5 0 1 0 1 0v-.5a1.5 1.5 0 0 0-1.5-1.5H13V9h1.5a.5.5 0 0 0 0-1H13V7h.5A1.5 1.5 0 0 0 15 5.5V5a.5.5 0 0 0-1 0v.5a.5.5 0 0 1-.5.5H13zm-5.5 9.975V7H3V6h-.5a.5.5 0 0 1-.5-.5V5a.5.5 0 0 0-1 0v.5A1.5 1.5 0 0 0 2.5 7H3v1H1.5a.5.5 0 0 0 0 1H3v1h-.5A1.5 1.5 0 0 0 1 11.5v.5a.5.5 0 1 0 1 0v-.5a.5.5 0 0 1 .5-.5H3a5 5 0 0 0 4.5 4.975z"
                }
            }
        ]
    })(props);
}
function BsFillBuildingFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h3v-3.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V16h3a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H3Zm1 2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5ZM4 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM7.5 5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM4.5 8h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5Z"
                }
            }
        ]
    })(props);
}
function BsFillBuildingsFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 .5a.5.5 0 0 0-.724-.447l-8 4A.5.5 0 0 0 6 4.5v3.14L.342 9.526A.5.5 0 0 0 0 10v5.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V14h1v1.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V.5ZM2 11h1v1H2v-1Zm2 0h1v1H4v-1Zm-1 2v1H2v-1h1Zm1 0h1v1H4v-1Zm9-10v1h-1V3h1ZM8 5h1v1H8V5Zm1 2v1H8V7h1ZM8 9h1v1H8V9Zm2 0h1v1h-1V9Zm-1 2v1H8v-1h1Zm1 0h1v1h-1v-1Zm3-2v1h-1V9h1Zm-1 2h1v1h-1v-1Zm-2-4h1v1h-1V7Zm3 0v1h-1V7h1Zm-2-2v1h-1V5h1Zm1 0h1v1h-1V5Z"
                }
            }
        ]
    })(props);
}
function BsFillBusFrontFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7a1 1 0 0 1-1 1v3.5c0 .818-.393 1.544-1 2v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V14H5v1.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a2.496 2.496 0 0 1-1-2V8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1V2.64C1 1.452 1.845.408 3.064.268A43.608 43.608 0 0 1 8 0c2.1 0 3.792.136 4.936.268C14.155.408 15 1.452 15 2.64V4a1 1 0 0 1 1 1v2ZM3.552 3.22A43.306 43.306 0 0 1 8 3c1.837 0 3.353.107 4.448.22a.5.5 0 0 0 .104-.994A44.304 44.304 0 0 0 8 2c-1.876 0-3.426.109-4.552.226a.5.5 0 1 0 .104.994ZM8 4c-1.876 0-3.426.109-4.552.226A.5.5 0 0 0 3 4.723v3.554a.5.5 0 0 0 .448.497C4.574 8.891 6.124 9 8 9c1.876 0 3.426-.109 4.552-.226A.5.5 0 0 0 13 8.277V4.723a.5.5 0 0 0-.448-.497A44.304 44.304 0 0 0 8 4Zm-3 7a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm8 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-7 0a1 1 0 0 0 1 1h2a1 1 0 1 0 0-2H7a1 1 0 0 0-1 1Z"
                }
            }
        ]
    })(props);
}
function BsFillCCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM8.146 4.992c.961 0 1.641.633 1.729 1.512h1.295v-.088c-.094-1.518-1.348-2.572-3.03-2.572-2.068 0-3.269 1.377-3.269 3.638v1.073c0 2.267 1.178 3.603 3.27 3.603 1.675 0 2.93-1.02 3.029-2.467v-.093H9.875c-.088.832-.75 1.418-1.729 1.418-1.224 0-1.927-.891-1.927-2.461v-1.06c0-1.583.715-2.503 1.927-2.503Z"
                }
            }
        ]
    })(props);
}
function BsFillCSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm6.146 4.992c-1.212 0-1.927.92-1.927 2.502v1.06c0 1.571.703 2.462 1.927 2.462.979 0 1.641-.586 1.729-1.418h1.295v.093c-.1 1.448-1.354 2.467-3.03 2.467-2.091 0-3.269-1.336-3.269-3.603V7.482c0-2.261 1.201-3.638 3.27-3.638 1.681 0 2.935 1.054 3.029 2.572v.088H9.875c-.088-.879-.768-1.512-1.729-1.512Z"
                }
            }
        ]
    })(props);
}
function BsFillCakeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7.399.804.595-.792.598.79A.747.747 0 0 1 8.5 1.806V4H11a2 2 0 0 1 2 2v3h1a2 2 0 0 1 2 2v4a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-4a2 2 0 0 1 2-2h1V6a2 2 0 0 1 2-2h2.5V1.813a.747.747 0 0 1-.101-1.01ZM12 6.414a.911.911 0 0 1-.646-.268 1.914 1.914 0 0 0-2.708 0 .914.914 0 0 1-1.292 0 1.914 1.914 0 0 0-2.708 0A.911.911 0 0 1 4 6.414v1c.49 0 .98-.187 1.354-.56a.914.914 0 0 1 1.292 0c.748.747 1.96.747 2.708 0a.914.914 0 0 1 1.292 0c.374.373.864.56 1.354.56v-1Zm2.646 5.732a.914.914 0 0 1-1.293 0 1.914 1.914 0 0 0-2.707 0 .914.914 0 0 1-1.292 0 1.914 1.914 0 0 0-2.708 0 .914.914 0 0 1-1.292 0 1.914 1.914 0 0 0-2.708 0 .914.914 0 0 1-1.292 0L1 11.793v1.34c.737.452 1.715.36 2.354-.28a.914.914 0 0 1 1.292 0c.748.748 1.96.748 2.708 0a.914.914 0 0 1 1.292 0c.748.748 1.96.748 2.707 0a.914.914 0 0 1 1.293 0 1.915 1.915 0 0 0 2.354.28v-1.34l-.354.354Z"
                }
            }
        ]
    })(props);
}
function BsFillCake2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.899.804.595-.792.598.79A.747.747 0 0 1 4 1.806v4.886c-.354-.06-.689-.127-1-.201V1.813a.747.747 0 0 1-.1-1.01ZM13 1.806v4.685a15.19 15.19 0 0 1-1 .201v-4.88a.747.747 0 0 1-.1-1.007l.595-.792.598.79A.746.746 0 0 1 13 1.806Zm-3 0a.746.746 0 0 0 .092-1.004l-.598-.79-.595.792A.747.747 0 0 0 9 1.813v5.17c.341-.013.675-.031 1-.055V1.806Zm-3 0v5.176c-.341-.012-.675-.03-1-.054V1.813a.747.747 0 0 1-.1-1.01l.595-.79.598.789A.747.747 0 0 1 7 1.806Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 6.988V4.226a22.6 22.6 0 0 1 1-.114V7.16c0 .131.101.24.232.25l.231.017c.332.024.672.043 1.02.055l.258.01a.25.25 0 0 0 .26-.25V4.003a29.015 29.015 0 0 1 1 0V7.24a.25.25 0 0 0 .258.25l.259-.009c.347-.012.687-.03 1.019-.055l.231-.017a.25.25 0 0 0 .232-.25V4.112c.345.031.679.07 1 .114v2.762a.25.25 0 0 0 .292.246l.291-.049c.364-.061.71-.13 1.033-.208l.192-.046a.25.25 0 0 0 .192-.243V4.621c.672.184 1.251.409 1.677.678.415.261.823.655.823 1.2V13.5c0 .546-.408.94-.823 1.201-.44.278-1.043.51-1.745.696-1.41.376-3.33.603-5.432.603-2.102 0-4.022-.227-5.432-.603-.702-.187-1.305-.418-1.745-.696C.408 14.44 0 14.046 0 13.5v-7c0-.546.408-.94.823-1.201.426-.269 1.005-.494 1.677-.678v2.067c0 .116.08.216.192.243l.192.046c.323.077.669.147 1.033.208l.292.05a.25.25 0 0 0 .291-.247ZM1 8.82v1.659a1.935 1.935 0 0 0 2.298.43.935.935 0 0 1 1.08.175l.348.349a2 2 0 0 0 2.615.185l.059-.044a1 1 0 0 1 1.2 0l.06.044a2 2 0 0 0 2.613-.185l.348-.348a.938.938 0 0 1 1.082-.175c.781.39 1.718.208 2.297-.426V8.833l-.68.907a.938.938 0 0 1-1.17.276 1.938 1.938 0 0 0-2.236.363l-.348.348a1 1 0 0 1-1.307.092l-.06-.044a2 2 0 0 0-2.399 0l-.06.044a1 1 0 0 1-1.306-.092l-.35-.35a1.935 1.935 0 0 0-2.233-.362.935.935 0 0 1-1.168-.277L1 8.82Z"
                }
            }
        ]
    })(props);
}
function BsFillCalculatorFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm2 .5v2a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5zm0 4v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zM4.5 9a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zM4 12.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zM7.5 6a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zM7 9.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zm.5 2.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zM10 6.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zm.5 2.5a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-1z"
                }
            }
        ]
    })(props);
}
function BsFillCalendarCheckFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zm-5.146-5.146-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708.708z"
                }
            }
        ]
    })(props);
}
function BsFillCalendarDateFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zm5.402 9.746c.625 0 1.184-.484 1.184-1.18 0-.832-.527-1.23-1.16-1.23-.586 0-1.168.387-1.168 1.21 0 .817.543 1.2 1.144 1.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zm-6.664-1.21c-1.11 0-1.656-.767-1.703-1.407h.683c.043.37.387.82 1.051.82.844 0 1.301-.848 1.305-2.164h-.027c-.153.414-.637.79-1.383.79-.852 0-1.676-.61-1.676-1.77 0-1.137.871-1.809 1.797-1.809 1.172 0 1.953.734 1.953 2.668 0 1.805-.742 2.871-2 2.871zm-2.89-5.435v5.332H5.77V8.079h-.012c-.29.156-.883.52-1.258.777V8.16a12.6 12.6 0 0 1 1.313-.805h.632z"
                }
            }
        ]
    })(props);
}
function BsFillCalendarDayFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5h16v9zm-4.785-6.145a.428.428 0 1 0 0-.855.426.426 0 0 0-.43.43c0 .238.192.425.43.425zm.336.563h-.672v4.105h.672V8.418zm-6.867 4.105v-2.3h2.261v-.61H4.684V7.801h2.464v-.61H4v5.332h.684zm3.296 0h.676V9.98c0-.554.227-1.007.953-1.007.125 0 .258.004.329.015v-.613a1.806 1.806 0 0 0-.254-.02c-.582 0-.891.32-1.012.567h-.02v-.504H7.98v4.105z"
                }
            }
        ]
    })(props);
}
function BsFillCalendarEventFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zm-3.5-7h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsFillCalendarFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5h16V4H0V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsFillCalendarHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5ZM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2ZM8 7.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z"
                }
            }
        ]
    })(props);
}
function BsFillCalendarMinusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM6 10h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsFillCalendarMonthFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zm.104 7.305L4.9 10.18H3.284l.8-2.375h.02zm9.074 2.297c0-.832-.414-1.36-1.062-1.36-.692 0-1.098.492-1.098 1.36v.253c0 .852.406 1.364 1.098 1.364.671 0 1.062-.516 1.062-1.364v-.253z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM2.56 12.332h-.71L3.748 7h.696l1.898 5.332h-.719l-.539-1.602H3.1l-.54 1.602zm7.29-4.105v4.105h-.668v-.539h-.027c-.145.324-.532.605-1.188.605-.847 0-1.453-.484-1.453-1.425V8.227h.676v2.554c0 .766.441 1.012.98 1.012.59 0 1.004-.371 1.004-1.023V8.227h.676zm1.273 4.41c.075.332.422.636.985.636.648 0 1.07-.378 1.07-1.023v-.605h-.02c-.163.355-.613.648-1.171.648-.957 0-1.64-.672-1.64-1.902v-.34c0-1.207.675-1.887 1.64-1.887.558 0 1.004.293 1.195.64h.02v-.577h.648v4.03c0 1.052-.816 1.579-1.746 1.579-1.043 0-1.574-.516-1.668-1.2h.687z"
                }
            }
        ]
    })(props);
}
function BsFillCalendarPlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM8.5 8.5V10H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V11H6a.5.5 0 0 1 0-1h1.5V8.5a.5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsFillCalendarRangeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 7V5H0v5h5a1 1 0 1 1 0 2H0v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9h-6a1 1 0 1 1 0-2h6z"
                }
            }
        ]
    })(props);
}
function BsFillCalendarWeekFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM9.5 7h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm3 0h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zM2 10.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3.5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsFillCalendarXFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM6.854 8.146 8 9.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 10l1.147 1.146a.5.5 0 0 1-.708.708L8 10.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 10 6.146 8.854a.5.5 0 1 1 .708-.708z"
                }
            }
        ]
    })(props);
}
function BsFillCalendar2CheckFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zm-2.6 5.854a.5.5 0 0 0-.708-.708L7.5 10.793 6.354 9.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z"
                }
            }
        ]
    })(props);
}
function BsFillCalendar2DateFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.402 10.246c.625 0 1.184-.484 1.184-1.18 0-.832-.527-1.23-1.16-1.23-.586 0-1.168.387-1.168 1.21 0 .817.543 1.2 1.144 1.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zm-4.118 9.79c1.258 0 2-1.067 2-2.872 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684c.047.64.594 1.406 1.703 1.406zm-2.89-5.435h-.633A12.6 12.6 0 0 0 4.5 8.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675V7.354z"
                }
            }
        ]
    })(props);
}
function BsFillCalendar2DayFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zm-2.24 4.855a.428.428 0 1 0 0-.855.426.426 0 0 0-.429.43c0 .238.192.425.43.425zm.337.563h-.672v4.105h.672V8.418zm-6.867 4.105v-2.3h2.261v-.61H4.684V7.801h2.464v-.61H4v5.332h.684zm3.296 0h.676V9.98c0-.554.227-1.007.953-1.007.125 0 .258.004.329.015v-.613a1.806 1.806 0 0 0-.254-.02c-.582 0-.891.32-1.012.567h-.02v-.504H7.98v4.105z"
                }
            }
        ]
    })(props);
}
function BsFillCalendar2EventFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zM11.5 7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1z"
                }
            }
        ]
    })(props);
}
function BsFillCalendar2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM2.545 3h10.91c.3 0 .545.224.545.5v1c0 .276-.244.5-.546.5H2.545C2.245 5 2 4.776 2 4.5v-1c0-.276.244-.5.545-.5z"
                }
            }
        ]
    })(props);
}
function BsFillCalendar2HeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5Zm-2 4v-1c0-.276.244-.5.545-.5h10.91c.3 0 .545.224.545.5v1c0 .276-.244.5-.546.5H2.545C2.245 5 2 4.776 2 4.5Zm6 3.493c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z"
                }
            }
        ]
    })(props);
}
function BsFillCalendar2MinusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zM6 10a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H6z"
                }
            }
        ]
    })(props);
}
function BsFillCalendar2MonthFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.104 7.805 4.9 10.18H3.284l.8-2.375h.02zm9.074 2.297c0-.832-.414-1.36-1.062-1.36-.692 0-1.098.492-1.098 1.36v.253c0 .852.406 1.364 1.098 1.364.671 0 1.062-.516 1.062-1.364v-.253z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zM2.561 12.332 3.1 10.73h1.984l.54 1.602h.718L4.444 7h-.696L1.85 12.332h.71zM9.85 8.227h-.676v2.543c0 .652-.414 1.023-1.004 1.023-.539 0-.98-.246-.98-1.012V8.227h-.676v2.746c0 .941.606 1.425 1.453 1.425.656 0 1.043-.28 1.188-.605h.027v.539h.668V8.227zm1.273 4.41h-.687c.094.683.625 1.199 1.668 1.199.93 0 1.746-.527 1.746-1.578V8.227h-.649v.578h-.019c-.191-.348-.637-.64-1.195-.64-.965 0-1.64.679-1.64 1.886v.34c0 1.23.683 1.902 1.64 1.902.558 0 1.008-.293 1.172-.648h.02v.605c0 .645-.423 1.023-1.071 1.023-.563 0-.91-.304-.985-.636z"
                }
            }
        ]
    })(props);
}
function BsFillCalendar2PlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 3.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5H2.545c-.3 0-.545.224-.545.5zm6.5 5a.5.5 0 0 0-1 0V10H6a.5.5 0 0 0 0 1h1.5v1.5a.5.5 0 0 0 1 0V11H10a.5.5 0 0 0 0-1H8.5V8.5z"
                }
            }
        ]
    })(props);
}
function BsFillCalendar2RangeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zM10 7a1 1 0 0 0 0 2h5V7h-5zm-4 4a1 1 0 0 0-1-1H1v2h4a1 1 0 0 0 1-1z"
                }
            }
        ]
    })(props);
}
function BsFillCalendar2WeekFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zM8.5 7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zM3 10.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1z"
                }
            }
        ]
    })(props);
}
function BsFillCalendar2XFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zm-6.6 5.146a.5.5 0 1 0-.708.708L7.293 10l-1.147 1.146a.5.5 0 0 0 .708.708L8 10.707l1.146 1.147a.5.5 0 0 0 .708-.708L8.707 10l1.147-1.146a.5.5 0 0 0-.708-.708L8 9.293 6.854 8.146z"
                }
            }
        ]
    })(props);
}
function BsFillCalendar3EventFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 0a2 2 0 0 0-2 2h16a2 2 0 0 0-2-2H2zM0 14V3h16v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm12-8a1 1 0 1 0 2 0 1 1 0 0 0-2 0z"
                }
            }
        ]
    })(props);
}
function BsFillCalendar3Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2H0zm0 1v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3H0z"
                }
            }
        ]
    })(props);
}
function BsFillCalendar3RangeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 0a2 2 0 0 0-2 2h16a2 2 0 0 0-2-2H2zM0 8V3h16v2h-6a1 1 0 1 0 0 2h6v7a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-4h6a1 1 0 1 0 0-2H0z"
                }
            }
        ]
    })(props);
}
function BsFillCalendar3WeekFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 0a2 2 0 0 0-2 2h16a2 2 0 0 0-2-2H2zM0 14V3h16v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm12-8a1 1 0 1 0 2 0 1 1 0 0 0-2 0zM5 9a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm5-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM2 9a1 1 0 1 0 2 0 1 1 0 0 0-2 0z"
                }
            }
        ]
    })(props);
}
function BsFillCameraFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 8.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2zm.5 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm9 2.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0z"
                }
            }
        ]
    })(props);
}
function BsFillCameraReelsFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6h.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 7.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 16H2a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h7z"
                }
            }
        ]
    })(props);
}
function BsFillCameraVideoFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2V5z"
                }
            }
        ]
    })(props);
}
function BsFillCameraVideoOffFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.961 12.365a1.99 1.99 0 0 0 .522-1.103l3.11 1.382A1 1 0 0 0 16 11.731V4.269a1 1 0 0 0-1.406-.913l-3.111 1.382A2 2 0 0 0 9.5 3H4.272l6.69 9.365zm-10.114-9A2.001 2.001 0 0 0 0 5v6a2 2 0 0 0 2 2h5.728L.847 3.366zm9.746 11.925-10-14 .814-.58 10 14-.814.58z"
                }
            }
        ]
    })(props);
}
function BsFillCapslockFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.27 1.047a1 1 0 0 1 1.46 0l6.345 6.77c.6.638.146 1.683-.73 1.683H11.5v1a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-1H1.654C.78 9.5.326 8.455.924 7.816L7.27 1.047zM4.5 13.5a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-1z"
                }
            }
        ]
    })(props);
}
function BsFillCarFrontFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679c.033.161.049.325.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.807.807 0 0 0 .381-.404l.792-1.848ZM3 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2H6ZM2.906 5.189a.51.51 0 0 0 .497.731c.91-.073 3.35-.17 4.597-.17 1.247 0 3.688.097 4.597.17a.51.51 0 0 0 .497-.731l-.956-1.913A.5.5 0 0 0 11.691 3H4.309a.5.5 0 0 0-.447.276L2.906 5.19Z"
                }
            }
        ]
    })(props);
}
function BsFillCaretDownFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
                }
            }
        ]
    })(props);
}
function BsFillCaretDownSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm4 4a.5.5 0 0 0-.374.832l4 4.5a.5.5 0 0 0 .748 0l4-4.5A.5.5 0 0 0 12 6H4z"
                }
            }
        ]
    })(props);
}
function BsFillCaretLeftFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"
                }
            }
        ]
    })(props);
}
function BsFillCaretLeftSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm10.5 10V4a.5.5 0 0 0-.832-.374l-4.5 4a.5.5 0 0 0 0 .748l4.5 4A.5.5 0 0 0 10.5 12z"
                }
            }
        ]
    })(props);
}
function BsFillCaretRightFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"
                }
            }
        ]
    })(props);
}
function BsFillCaretRightSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm5.5 10a.5.5 0 0 0 .832.374l4.5-4a.5.5 0 0 0 0-.748l-4.5-4A.5.5 0 0 0 5.5 4v8z"
                }
            }
        ]
    })(props);
}
function BsFillCaretUpFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"
                }
            }
        ]
    })(props);
}
function BsFillCaretUpSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm4 9h8a.5.5 0 0 0 .374-.832l-4-4.5a.5.5 0 0 0-.748 0l-4 4.5A.5.5 0 0 0 4 11z"
                }
            }
        ]
    })(props);
}
function BsFillCartCheckFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-1.646-7.646-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L8 8.293l2.646-2.647a.5.5 0 0 1 .708.708z"
                }
            }
        ]
    })(props);
}
function BsFillCartDashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM6.5 7h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsFillCartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                }
            }
        ]
    })(props);
}
function BsFillCartPlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM9 5.5V7h1.5a.5.5 0 0 1 0 1H9v1.5a.5.5 0 0 1-1 0V8H6.5a.5.5 0 0 1 0-1H8V5.5a.5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsFillCartXFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7.354 5.646 8.5 6.793l1.146-1.147a.5.5 0 0 1 .708.708L9.207 7.5l1.147 1.146a.5.5 0 0 1-.708.708L8.5 8.207 7.354 9.354a.5.5 0 1 1-.708-.708L7.793 7.5 6.646 6.354a.5.5 0 1 1 .708-.708z"
                }
            }
        ]
    })(props);
}
function BsFillCassetteFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 2A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h.191l1.862-3.724A.5.5 0 0 1 4 10h8a.5.5 0 0 1 .447.276L14.31 14h.191a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13ZM4 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm8 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM6 6a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13.191 14-1.5-3H4.309l-1.5 3h10.382Z"
                }
            }
        ]
    })(props);
}
function BsFillCcCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM5.408 5.89c.681 0 1.138.47 1.187 1.107h1.147v-.11c-.053-1.187-1.024-2-2.343-2-1.604 0-2.518 1.05-2.518 2.751v.747c0 1.7.906 2.73 2.518 2.73 1.314 0 2.285-.792 2.343-1.939v-.114H6.595c-.049.615-.497 1.05-1.187 1.05-.84 0-1.318-.62-1.318-1.727v-.742c0-1.112.488-1.754 1.318-1.754Zm5.404 0c.68 0 1.138.47 1.186 1.107h1.147v-.11c-.053-1.187-1.024-2-2.342-2-1.604 0-2.518 1.05-2.518 2.751v.747c0 1.7.905 2.73 2.518 2.73 1.314 0 2.285-.792 2.342-1.939v-.114h-1.147c-.048.615-.496 1.05-1.186 1.05-.84 0-1.319-.62-1.319-1.727v-.742c0-1.112.488-1.754 1.319-1.754Z"
                }
            }
        ]
    })(props);
}
function BsFillCcSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm3.408 5.89c-.83 0-1.318.64-1.318 1.753v.742c0 1.108.479 1.727 1.318 1.727.69 0 1.138-.435 1.187-1.05h1.147v.114c-.058 1.147-1.029 1.938-2.343 1.938-1.612 0-2.518-1.028-2.518-2.729v-.747c0-1.7.914-2.75 2.518-2.75 1.319 0 2.29.812 2.343 1.999v.11H6.595c-.049-.638-.506-1.108-1.187-1.108Zm5.404 0c-.831 0-1.319.64-1.319 1.753v.742c0 1.108.48 1.727 1.319 1.727.69 0 1.138-.435 1.186-1.05h1.147v.114c-.057 1.147-1.028 1.938-2.342 1.938-1.613 0-2.518-1.028-2.518-2.729v-.747c0-1.7.914-2.75 2.518-2.75 1.318 0 2.29.812 2.342 1.999v.11h-1.147c-.048-.638-.505-1.108-1.186-1.108Z"
                }
            }
        ]
    })(props);
}
function BsFillChatDotsFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8c0 3.866-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7zM5 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                }
            }
        ]
    })(props);
}
function BsFillChatFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6-.097 1.016-.417 2.13-.771 2.966-.079.186.074.394.273.362 2.256-.37 3.597-.938 4.18-1.234A9.06 9.06 0 0 0 8 15z"
                }
            }
        ]
    })(props);
}
function BsFillChatHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6-.097 1.016-.417 2.13-.771 2.966-.079.186.074.394.273.362 2.256-.37 3.597-.938 4.18-1.234A9.06 9.06 0 0 0 8 15Zm0-9.007c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z"
                }
            }
        ]
    })(props);
}
function BsFillChatLeftDotsFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4.414a1 1 0 0 0-.707.293L.854 15.146A.5.5 0 0 1 0 14.793V2zm5 4a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                }
            }
        ]
    })(props);
}
function BsFillChatLeftFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                }
            }
        ]
    })(props);
}
function BsFillChatLeftHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm6 3.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z"
                }
            }
        ]
    })(props);
}
function BsFillChatLeftQuoteFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4.414a1 1 0 0 0-.707.293L.854 15.146A.5.5 0 0 1 0 14.793V2zm7.194 2.766a1.688 1.688 0 0 0-.227-.272 1.467 1.467 0 0 0-.469-.324l-.008-.004A1.785 1.785 0 0 0 5.734 4C4.776 4 4 4.746 4 5.667c0 .92.776 1.666 1.734 1.666.343 0 .662-.095.931-.26-.137.389-.39.804-.81 1.22a.405.405 0 0 0 .011.59c.173.16.447.155.614-.01 1.334-1.329 1.37-2.758.941-3.706a2.461 2.461 0 0 0-.227-.4zM11 7.073c-.136.389-.39.804-.81 1.22a.405.405 0 0 0 .012.59c.172.16.446.155.613-.01 1.334-1.329 1.37-2.758.942-3.706a2.466 2.466 0 0 0-.228-.4 1.686 1.686 0 0 0-.227-.273 1.466 1.466 0 0 0-.469-.324l-.008-.004A1.785 1.785 0 0 0 10.07 4c-.957 0-1.734.746-1.734 1.667 0 .92.777 1.666 1.734 1.666.343 0 .662-.095.931-.26z"
                }
            }
        ]
    })(props);
}
function BsFillChatLeftTextFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4.414a1 1 0 0 0-.707.293L.854 15.146A.5.5 0 0 1 0 14.793V2zm3.5 1a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 2.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5z"
                }
            }
        ]
    })(props);
}
function BsFillChatQuoteFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8c0 3.866-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7zM7.194 6.766a1.688 1.688 0 0 0-.227-.272 1.467 1.467 0 0 0-.469-.324l-.008-.004A1.785 1.785 0 0 0 5.734 6C4.776 6 4 6.746 4 7.667c0 .92.776 1.666 1.734 1.666.343 0 .662-.095.931-.26-.137.389-.39.804-.81 1.22a.405.405 0 0 0 .011.59c.173.16.447.155.614-.01 1.334-1.329 1.37-2.758.941-3.706a2.461 2.461 0 0 0-.227-.4zM11 9.073c-.136.389-.39.804-.81 1.22a.405.405 0 0 0 .012.59c.172.16.446.155.613-.01 1.334-1.329 1.37-2.758.942-3.706a2.466 2.466 0 0 0-.228-.4 1.686 1.686 0 0 0-.227-.273 1.466 1.466 0 0 0-.469-.324l-.008-.004A1.785 1.785 0 0 0 10.07 6c-.957 0-1.734.746-1.734 1.667 0 .92.777 1.666 1.734 1.666.343 0 .662-.095.931-.26z"
                }
            }
        ]
    })(props);
}
function BsFillChatRightDotsFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h9.586a1 1 0 0 1 .707.293l2.853 2.853a.5.5 0 0 0 .854-.353V2zM5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                }
            }
        ]
    })(props);
}
function BsFillChatRightFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 0a2 2 0 0 1 2 2v12.793a.5.5 0 0 1-.854.353l-2.853-2.853a1 1 0 0 0-.707-.293H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12z"
                }
            }
        ]
    })(props);
}
function BsFillChatRightHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h9.586a1 1 0 0 1 .707.293l2.853 2.853a.5.5 0 0 0 .854-.353V2ZM8 3.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z"
                }
            }
        ]
    })(props);
}
function BsFillChatRightQuoteFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h9.586a1 1 0 0 1 .707.293l2.853 2.853a.5.5 0 0 0 .854-.353V2zM7.194 4.766c.087.124.163.26.227.401.428.948.393 2.377-.942 3.706a.446.446 0 0 1-.612.01.405.405 0 0 1-.011-.59c.419-.416.672-.831.809-1.22-.269.165-.588.26-.93.26C4.775 7.333 4 6.587 4 5.667 4 4.747 4.776 4 5.734 4c.271 0 .528.06.756.166l.008.004c.169.07.327.182.469.324.085.083.161.174.227.272zM11 7.073c-.269.165-.588.26-.93.26-.958 0-1.735-.746-1.735-1.666 0-.92.777-1.667 1.734-1.667.271 0 .528.06.756.166l.008.004c.17.07.327.182.469.324.085.083.161.174.227.272.087.124.164.26.228.401.428.948.392 2.377-.942 3.706a.446.446 0 0 1-.613.01.405.405 0 0 1-.011-.59c.42-.416.672-.831.81-1.22z"
                }
            }
        ]
    })(props);
}
function BsFillChatRightTextFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h9.586a1 1 0 0 1 .707.293l2.853 2.853a.5.5 0 0 0 .854-.353V2zM3.5 3h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1zm0 2.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1zm0 2.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsFillChatSquareDotsFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.5a1 1 0 0 0-.8.4l-1.9 2.533a1 1 0 0 1-1.6 0L5.3 12.4a1 1 0 0 0-.8-.4H2a2 2 0 0 1-2-2V2zm5 4a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                }
            }
        ]
    })(props);
}
function BsFillChatSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                }
            }
        ]
    })(props);
}
function BsFillChatSquareHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm6 3.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z"
                }
            }
        ]
    })(props);
}
function BsFillChatSquareQuoteFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.5a1 1 0 0 0-.8.4l-1.9 2.533a1 1 0 0 1-1.6 0L5.3 12.4a1 1 0 0 0-.8-.4H2a2 2 0 0 1-2-2V2zm7.194 2.766a1.688 1.688 0 0 0-.227-.272 1.467 1.467 0 0 0-.469-.324l-.008-.004A1.785 1.785 0 0 0 5.734 4C4.776 4 4 4.746 4 5.667c0 .92.776 1.666 1.734 1.666.343 0 .662-.095.931-.26-.137.389-.39.804-.81 1.22a.405.405 0 0 0 .011.59c.173.16.447.155.614-.01 1.334-1.329 1.37-2.758.941-3.706a2.461 2.461 0 0 0-.227-.4zM11 7.073c-.136.389-.39.804-.81 1.22a.405.405 0 0 0 .012.59c.172.16.446.155.613-.01 1.334-1.329 1.37-2.758.942-3.706a2.466 2.466 0 0 0-.228-.4 1.686 1.686 0 0 0-.227-.273 1.466 1.466 0 0 0-.469-.324l-.008-.004A1.785 1.785 0 0 0 10.07 4c-.957 0-1.734.746-1.734 1.667 0 .92.777 1.666 1.734 1.666.343 0 .662-.095.931-.26z"
                }
            }
        ]
    })(props);
}
function BsFillChatSquareTextFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.5a1 1 0 0 0-.8.4l-1.9 2.533a1 1 0 0 1-1.6 0L5.3 12.4a1 1 0 0 0-.8-.4H2a2 2 0 0 1-2-2V2zm3.5 1a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 2.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5z"
                }
            }
        ]
    })(props);
}
function BsFillChatTextFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8c0 3.866-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7zM4.5 5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7zm0 2.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7zm0 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4z"
                }
            }
        ]
    })(props);
}
function BsFillCheckCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                }
            }
        ]
    })(props);
}
function BsFillCheckSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm10.03 4.97a.75.75 0 0 1 .011 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.75.75 0 0 1 1.08-.022z"
                }
            }
        ]
    })(props);
}
function BsFillCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "8",
                    "r": "8"
                }
            }
        ]
    })(props);
}
function BsFillClipboardCheckFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 0A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3Zm3 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1A2.5 2.5 0 0 1 9.5 5h-3A2.5 2.5 0 0 1 4 2.5v-1Zm6.854 7.354-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708.708Z"
                }
            }
        ]
    })(props);
}
function BsFillClipboardDataFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 0A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3Zm3 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1A2.5 2.5 0 0 1 9.5 5h-3A2.5 2.5 0 0 1 4 2.5v-1ZM10 8a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0V8Zm-6 4a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0v-1Zm4-3a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Z"
                }
            }
        ]
    })(props);
}
function BsFillClipboardFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 1.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1Zm-5 0A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5v1A1.5 1.5 0 0 1 9.5 4h-3A1.5 1.5 0 0 1 5 2.5v-1Zm-2 0h1v1A2.5 2.5 0 0 0 6.5 5h3A2.5 2.5 0 0 0 12 2.5v-1h1a2 2 0 0 1 2 2V14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3.5a2 2 0 0 1 2-2Z"
                }
            }
        ]
    })(props);
}
function BsFillClipboardHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.5 0A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3Zm3 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1A2.5 2.5 0 0 1 9.5 5h-3A2.5 2.5 0 0 1 4 2.5v-1Zm4 5.982c1.664-1.673 5.825 1.254 0 5.018-5.825-3.764-1.664-6.69 0-5.018Z"
                }
            }
        ]
    })(props);
}
function BsFillClipboardMinusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 0A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3Zm3 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1A2.5 2.5 0 0 1 9.5 5h-3A2.5 2.5 0 0 1 4 2.5v-1ZM6 9h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1Z"
                }
            }
        ]
    })(props);
}
function BsFillClipboardPlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 0A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3Zm3 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1A2.5 2.5 0 0 1 9.5 5h-3A2.5 2.5 0 0 1 4 2.5v-1Zm4.5 6V9H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V10H6a.5.5 0 0 1 0-1h1.5V7.5a.5.5 0 0 1 1 0Z"
                }
            }
        ]
    })(props);
}
function BsFillClipboardXFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 0A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3Zm3 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1A2.5 2.5 0 0 1 9.5 5h-3A2.5 2.5 0 0 1 4 2.5v-1Zm4 7.793 1.146-1.147a.5.5 0 1 1 .708.708L8.707 10l1.147 1.146a.5.5 0 0 1-.708.708L8 10.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 10 6.146 8.854a.5.5 0 1 1 .708-.708L8 9.293Z"
                }
            }
        ]
    })(props);
}
function BsFillClipboard2CheckFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 .5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5.5.5 0 0 1-.5.5.5.5 0 0 0-.5.5V2a.5.5 0 0 0 .5.5h5A.5.5 0 0 0 11 2v-.5a.5.5 0 0 0-.5-.5.5.5 0 0 1-.5-.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.085 1H3.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1h-.585c.055.156.085.325.085.5V2a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 2v-.5c0-.175.03-.344.085-.5Zm6.769 6.854-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708.708Z"
                }
            }
        ]
    })(props);
}
function BsFillClipboard2DataFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 .5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5.5.5 0 0 1-.5.5.5.5 0 0 0-.5.5V2a.5.5 0 0 0 .5.5h5A.5.5 0 0 0 11 2v-.5a.5.5 0 0 0-.5-.5.5.5 0 0 1-.5-.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.085 1H3.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1h-.585c.055.156.085.325.085.5V2a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 2v-.5c0-.175.03-.344.085-.5ZM10 7a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0V7Zm-6 4a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0v-1Zm4-3a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1Z"
                }
            }
        ]
    })(props);
}
function BsFillClipboard2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 0a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5.5.5 0 0 1 .5.5V2a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 2v-.5a.5.5 0 0 1 .5-.5.5.5 0 0 0 .5-.5.5.5 0 0 1 .5-.5h3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 1h.585A1.498 1.498 0 0 0 4 1.5V2a1.5 1.5 0 0 0 1.5 1.5h5A1.5 1.5 0 0 0 12 2v-.5c0-.175-.03-.344-.085-.5h.585A1.5 1.5 0 0 1 14 2.5v12a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-12A1.5 1.5 0 0 1 3.5 1Z"
                }
            }
        ]
    })(props);
}
function BsFillClipboard2HeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.058.501a.501.501 0 0 0-.5-.501h-2.98c-.276 0-.5.225-.5.501A.499.499 0 0 1 5.582 1a.497.497 0 0 0-.497.497V2a.5.5 0 0 0 .5.5h4.968a.5.5 0 0 0 .5-.5v-.503A.497.497 0 0 0 10.555 1a.499.499 0 0 1-.497-.499Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.174 1h-.57a1.5 1.5 0 0 0-1.5 1.5v12a1.5 1.5 0 0 0 1.5 1.5h9a1.5 1.5 0 0 0 1.5-1.5v-12a1.5 1.5 0 0 0-1.5-1.5h-.642c.055.156.085.325.085.5V2c0 .828-.668 1.5-1.492 1.5H5.581A1.496 1.496 0 0 1 4.09 2v-.5c0-.175.03-.344.085-.5Zm3.894 5.482c1.656-1.673 5.795 1.254 0 5.018-5.795-3.764-1.656-6.69 0-5.018Z"
                }
            }
        ]
    })(props);
}
function BsFillClipboard2MinusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 .5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5.5.5 0 0 1-.5.5.5.5 0 0 0-.5.5V2a.5.5 0 0 0 .5.5h5A.5.5 0 0 0 11 2v-.5a.5.5 0 0 0-.5-.5.5.5 0 0 1-.5-.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.085 1H3.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1h-.585c.055.156.085.325.085.5V2a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 2v-.5c0-.175.03-.344.085-.5ZM6 8h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1Z"
                }
            }
        ]
    })(props);
}
function BsFillClipboard2PlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 .5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5.5.5 0 0 1-.5.5.5.5 0 0 0-.5.5V2a.5.5 0 0 0 .5.5h5A.5.5 0 0 0 11 2v-.5a.5.5 0 0 0-.5-.5.5.5 0 0 1-.5-.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.085 1H3.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1h-.585c.055.156.085.325.085.5V2a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 2v-.5c0-.175.03-.344.085-.5ZM8.5 6.5V8H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V9H6a.5.5 0 0 1 0-1h1.5V6.5a.5.5 0 0 1 1 0Z"
                }
            }
        ]
    })(props);
}
function BsFillClipboard2PulseFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 .5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5.5.5 0 0 1-.5.5.5.5 0 0 0-.5.5V2a.5.5 0 0 0 .5.5h5A.5.5 0 0 0 11 2v-.5a.5.5 0 0 0-.5-.5.5.5 0 0 1-.5-.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.085 1H3.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1h-.585c.055.156.085.325.085.5V2a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 2v-.5c0-.175.03-.344.085-.5ZM9.98 5.356 11.372 10h.128a.5.5 0 0 1 0 1H11a.5.5 0 0 1-.479-.356l-.94-3.135-1.092 5.096a.5.5 0 0 1-.968.039L6.383 8.85l-.936 1.873A.5.5 0 0 1 5 11h-.5a.5.5 0 0 1 0-1h.191l1.362-2.724a.5.5 0 0 1 .926.08l.94 3.135 1.092-5.096a.5.5 0 0 1 .968-.039Z"
                }
            }
        ]
    })(props);
}
function BsFillClipboard2XFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 .5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5.5.5 0 0 1-.5.5.5.5 0 0 0-.5.5V2a.5.5 0 0 0 .5.5h5A.5.5 0 0 0 11 2v-.5a.5.5 0 0 0-.5-.5.5.5 0 0 1-.5-.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.085 1H3.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1h-.585c.055.156.085.325.085.5V2a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 2v-.5c0-.175.03-.344.085-.5ZM8 8.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 9l1.147 1.146a.5.5 0 0 1-.708.708L8 9.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 9 6.146 7.854a.5.5 0 1 1 .708-.708L8 8.293Z"
                }
            }
        ]
    })(props);
}
function BsFillClockFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"
                }
            }
        ]
    })(props);
}
function BsFillCloudArrowDownFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2zm2.354 6.854-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5a.5.5 0 0 1 1 0v3.793l1.146-1.147a.5.5 0 0 1 .708.708z"
                }
            }
        ]
    })(props);
}
function BsFillCloudArrowUpFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2zm2.354 5.146a.5.5 0 0 1-.708.708L8.5 6.707V10.5a.5.5 0 0 1-1 0V6.707L6.354 7.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2z"
                }
            }
        ]
    })(props);
}
function BsFillCloudCheckFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2zm2.354 4.854-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708.708z"
                }
            }
        ]
    })(props);
}
function BsFillCloudDownloadFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 0a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 4.095 0 5.555 0 7.318 0 9.366 1.708 11 3.781 11H7.5V5.5a.5.5 0 0 1 1 0V11h4.188C14.502 11 16 9.57 16 7.773c0-1.636-1.242-2.969-2.834-3.194C12.923 1.999 10.69 0 8 0zm-.354 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V11h-1v3.293l-2.146-2.147a.5.5 0 0 0-.708.708l3 3z"
                }
            }
        ]
    })(props);
}
function BsFillCloudDrizzleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.158 12.025a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 0 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm6 0a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 0 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm-3.5 1.5a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 0 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm6 0a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm.747-8.498a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 11H13a3 3 0 0 0 .405-5.973z"
                }
            }
        ]
    })(props);
}
function BsFillCloudFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"
                }
            }
        ]
    })(props);
}
function BsFillCloudFogFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm10.405-9.473a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 12H13a3 3 0 0 0 .405-5.973z"
                }
            }
        ]
    })(props);
}
function BsFillCloudFog2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 3a5.001 5.001 0 0 1 4.905 4.027A3 3 0 0 1 13 13h-1.5a.5.5 0 0 0 0-1H1.05a3.51 3.51 0 0 1-.713-1H9.5a.5.5 0 0 0 0-1H.035a3.53 3.53 0 0 1 0-1H7.5a.5.5 0 0 0 0-1H.337a3.5 3.5 0 0 1 3.57-1.977A5.001 5.001 0 0 1 8.5 3z"
                }
            }
        ]
    })(props);
}
function BsFillCloudHailFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.75 15.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm.408-3.724a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zM7.75 15.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm.408-3.724a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zm3.592 3.724a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm.408-3.724a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zm1.247-6.999a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10.5H13a3 3 0 0 0 .405-5.973z"
                }
            }
        ]
    })(props);
}
function BsFillCloudHazeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-3 2a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm2 2a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM13.405 4.027a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10H13a3 3 0 0 0 .405-5.973z"
                }
            }
        ]
    })(props);
}
function BsFillCloudHaze2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 2a5.001 5.001 0 0 1 4.905 4.027A3 3 0 0 1 13 12H3.5A3.5 3.5 0 0 1 .035 9H5.5a.5.5 0 0 0 0-1H.035a3.5 3.5 0 0 1 3.871-2.977A5.001 5.001 0 0 1 8.5 2zm-6 8a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zM0 13.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsFillCloudLightningFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.053 11.276A.5.5 0 0 1 7.5 11h1a.5.5 0 0 1 .474.658l-.28.842H9.5a.5.5 0 0 1 .39.812l-2 2.5a.5.5 0 0 1-.875-.433L7.36 14H6.5a.5.5 0 0 1-.447-.724l1-2zm6.352-7.249a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10H13a3 3 0 0 0 .405-5.973z"
                }
            }
        ]
    })(props);
}
function BsFillCloudLightningRainFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.658 11.026a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zm9.5 0a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 0 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zm-7.5 1.5a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zm9.5 0a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 0 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zm-7.105-1.25A.5.5 0 0 1 7.5 11h1a.5.5 0 0 1 .474.658l-.28.842H9.5a.5.5 0 0 1 .39.812l-2 2.5a.5.5 0 0 1-.875-.433L7.36 14H6.5a.5.5 0 0 1-.447-.724l1-2zm6.352-7.249a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10H13a3 3 0 0 0 .405-5.973z"
                }
            }
        ]
    })(props);
}
function BsFillCloudMinusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2zM6 7.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsFillCloudMoonFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.473 11a4.5 4.5 0 0 0-8.72-.99A3 3 0 0 0 3 16h8.5a2.5 2.5 0 0 0 0-5h-.027z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.286 1.778a.5.5 0 0 0-.565-.755 4.595 4.595 0 0 0-3.18 5.003 5.46 5.46 0 0 1 1.055.209A3.603 3.603 0 0 1 9.83 2.617a4.593 4.593 0 0 0 4.31 5.744 3.576 3.576 0 0 1-2.241.634c.162.317.295.652.394 1a4.59 4.59 0 0 0 3.624-2.04.5.5 0 0 0-.565-.755 3.593 3.593 0 0 1-4.065-5.422z"
                }
            }
        ]
    })(props);
}
function BsFillCloudPlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2zm.5 4v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsFillCloudRainFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.158 12.025a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm3 0a.5.5 0 0 1 .316.633l-1 3a.5.5 0 1 1-.948-.316l1-3a.5.5 0 0 1 .632-.317zm3 0a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm3 0a.5.5 0 0 1 .316.633l-1 3a.5.5 0 1 1-.948-.316l1-3a.5.5 0 0 1 .632-.317zm.247-6.998a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 11H13a3 3 0 0 0 .405-5.973z"
                }
            }
        ]
    })(props);
}
function BsFillCloudRainHeavyFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.176 11.032a.5.5 0 0 1 .292.643l-1.5 4a.5.5 0 0 1-.936-.35l1.5-4a.5.5 0 0 1 .644-.293zm3 0a.5.5 0 0 1 .292.643l-1.5 4a.5.5 0 0 1-.936-.35l1.5-4a.5.5 0 0 1 .644-.293zm3 0a.5.5 0 0 1 .292.643l-1.5 4a.5.5 0 0 1-.936-.35l1.5-4a.5.5 0 0 1 .644-.293zm3 0a.5.5 0 0 1 .292.643l-1.5 4a.5.5 0 0 1-.936-.35l1.5-4a.5.5 0 0 1 .644-.293zm.229-7.005a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10H13a3 3 0 0 0 .405-5.973z"
                }
            }
        ]
    })(props);
}
function BsFillCloudSlashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.112 5.112a3.125 3.125 0 0 0-.17.613C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13H11L3.112 5.112zm11.372 7.372L4.937 2.937A5.512 5.512 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773a3.2 3.2 0 0 1-1.516 2.711zm-.838 1.87-12-12 .708-.708 12 12-.707.707z"
                }
            }
        ]
    })(props);
}
function BsFillCloudSleetFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.375 13.5a.25.25 0 0 1 .25.25v.57l.501-.287a.25.25 0 0 1 .248.434l-.495.283.495.283a.25.25 0 1 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 1 1-.248-.434l.495-.283-.495-.283a.25.25 0 1 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm1.849-2.447a.5.5 0 0 1 .223.67l-.5 1a.5.5 0 0 1-.894-.447l.5-1a.5.5 0 0 1 .67-.223zM6.375 13.5a.25.25 0 0 1 .25.25v.57l.5-.287a.25.25 0 0 1 .249.434l-.495.283.495.283a.25.25 0 1 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 1 1-.248-.434l.495-.283-.495-.283a.25.25 0 1 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm1.849-2.447a.5.5 0 0 1 .223.67l-.5 1a.5.5 0 0 1-.894-.447l.5-1a.5.5 0 0 1 .67-.223zm2.151 2.447a.25.25 0 0 1 .25.25v.57l.5-.287a.25.25 0 0 1 .249.434l-.495.283.495.283a.25.25 0 1 1-.248.434l-.501-.286v.569a.25.25 0 0 1-.5 0v-.57l-.501.287a.25.25 0 1 1-.248-.434l.495-.283-.495-.283a.25.25 0 1 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm1.849-2.447a.5.5 0 0 1 .223.67l-.5 1a.5.5 0 1 1-.894-.447l.5-1a.5.5 0 0 1 .67-.223zm1.181-7.026a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10H13a3 3 0 0 0 .405-5.973z"
                }
            }
        ]
    })(props);
}
function BsFillCloudSnowFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.625 11.5a.25.25 0 0 1 .25.25v.57l.501-.287a.25.25 0 0 1 .248.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 0 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm2.75 2a.25.25 0 0 1 .25.25v.57l.5-.287a.25.25 0 0 1 .249.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 0 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm5.5 0a.25.25 0 0 1 .25.25v.57l.5-.287a.25.25 0 0 1 .249.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 0 1-.5 0v-.57l-.501.287a.25.25 0 0 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm-2.75-2a.25.25 0 0 1 .25.25v.57l.5-.287a.25.25 0 0 1 .249.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 0 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm5.5 0a.25.25 0 0 1 .25.25v.57l.5-.287a.25.25 0 0 1 .249.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 0 1-.5 0v-.57l-.501.287a.25.25 0 1 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm-.22-7.223a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10.25H13a3 3 0 0 0 .405-5.973z"
                }
            }
        ]
    })(props);
}
function BsFillCloudSunFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.473 11a4.5 4.5 0 0 0-8.72-.99A3 3 0 0 0 3 16h8.5a2.5 2.5 0 0 0 0-5h-.027z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 1.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0v-1zm3.743 1.964a.5.5 0 1 0-.707-.707l-.708.707a.5.5 0 0 0 .708.708l.707-.708zm-7.779-.707a.5.5 0 0 0-.707.707l.707.708a.5.5 0 1 0 .708-.708l-.708-.707zm1.734 3.374a2 2 0 1 1 3.296 2.198c.199.281.372.582.516.898a3 3 0 1 0-4.84-3.225c.352.011.696.055 1.028.129zm4.484 4.074c.6.215 1.125.59 1.522 1.072a.5.5 0 0 0 .039-.742l-.707-.707a.5.5 0 0 0-.854.377zM14.5 6.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z"
                }
            }
        ]
    })(props);
}
function BsFillCloudUploadFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 0a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 4.095 0 5.555 0 7.318 0 9.366 1.708 11 3.781 11H7.5V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11h4.188C14.502 11 16 9.57 16 7.773c0-1.636-1.242-2.969-2.834-3.194C12.923 1.999 10.69 0 8 0zm-.5 14.5V11h1v3.5a.5.5 0 0 1-1 0z"
                }
            }
        ]
    })(props);
}
function BsFillCloudsFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.473 9a4.5 4.5 0 0 0-8.72-.99A3 3 0 0 0 3 14h8.5a2.5 2.5 0 1 0-.027-5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.544 9.772a3.506 3.506 0 0 0-2.225-1.676 5.502 5.502 0 0 0-6.337-4.002 4.002 4.002 0 0 1 7.392.91 2.5 2.5 0 0 1 1.17 4.769z"
                }
            }
        ]
    })(props);
}
function BsFillCloudyFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.405 7.027a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 13H13a3 3 0 0 0 .405-5.973z"
                }
            }
        ]
    })(props);
}
function BsFillCollectionFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 13a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 16 13V6a1.5 1.5 0 0 0-1.5-1.5h-13A1.5 1.5 0 0 0 0 6v7zM2 3a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 0-1h-11A.5.5 0 0 0 2 3zm2-2a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7A.5.5 0 0 0 4 1z"
                }
            }
        ]
    })(props);
}
function BsFillCollectionPlayFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 3.5a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-11zm2-2a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1h-7zM0 13a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 16 13V6a1.5 1.5 0 0 0-1.5-1.5h-13A1.5 1.5 0 0 0 0 6v7zm6.258-6.437a.5.5 0 0 1 .507.013l4 2.5a.5.5 0 0 1 0 .848l-4 2.5A.5.5 0 0 1 6 12V7a.5.5 0 0 1 .258-.437z"
                }
            }
        ]
    })(props);
}
function BsFillCompassFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 8.516a7.5 7.5 0 1 1-9.462-7.24A1 1 0 0 1 7 0h2a1 1 0 0 1 .962 1.276 7.503 7.503 0 0 1 5.538 7.24zm-3.61-3.905L6.94 7.439 4.11 12.39l4.95-2.828 2.828-4.95z"
                }
            }
        ]
    })(props);
}
function BsFillCpuFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5.5a.5.5 0 0 0-1 0V2A2.5 2.5 0 0 0 2 4.5H.5a.5.5 0 0 0 0 1H2v1H.5a.5.5 0 0 0 0 1H2v1H.5a.5.5 0 0 0 0 1H2v1H.5a.5.5 0 0 0 0 1H2A2.5 2.5 0 0 0 4.5 14v1.5a.5.5 0 0 0 1 0V14h1v1.5a.5.5 0 0 0 1 0V14h1v1.5a.5.5 0 0 0 1 0V14h1v1.5a.5.5 0 0 0 1 0V14a2.5 2.5 0 0 0 2.5-2.5h1.5a.5.5 0 0 0 0-1H14v-1h1.5a.5.5 0 0 0 0-1H14v-1h1.5a.5.5 0 0 0 0-1H14v-1h1.5a.5.5 0 0 0 0-1H14A2.5 2.5 0 0 0 11.5 2V.5a.5.5 0 0 0-1 0V2h-1V.5a.5.5 0 0 0-1 0V2h-1V.5a.5.5 0 0 0-1 0V2h-1V.5zm1 4.5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5v-3A1.5 1.5 0 0 1 6.5 5z"
                }
            }
        ]
    })(props);
}
function BsFillCreditCard2BackFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5H0V4zm11.5 1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-2zM0 11v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1H0z"
                }
            }
        ]
    })(props);
}
function BsFillCreditCard2FrontFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2.5 1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-2zm0 3a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm3 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm3 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm3 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z"
                }
            }
        ]
    })(props);
}
function BsFillCreditCardFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1H0V4zm0 3v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7H0zm3 2h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1z"
                }
            }
        ]
    })(props);
}
function BsFillCupFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M.11 3.187A.5.5 0 0 1 .5 3h13a.5.5 0 0 1 .488.608l-.22.991a3.001 3.001 0 0 1-1.3 5.854l-.132.59A2.5 2.5 0 0 1 9.896 13H4.104a2.5 2.5 0 0 1-2.44-1.958L.012 3.608a.5.5 0 0 1 .098-.42Zm12.574 6.288a2 2 0 0 0 .866-3.899l-.866 3.9Z"
                }
            }
        ]
    })(props);
}
function BsFillCupHotFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M.5 6a.5.5 0 0 0-.488.608l1.652 7.434A2.5 2.5 0 0 0 4.104 16h5.792a2.5 2.5 0 0 0 2.44-1.958l.131-.59a3 3 0 0 0 1.3-5.854l.221-.99A.5.5 0 0 0 13.5 6H.5ZM13 12.5a2.01 2.01 0 0 1-.316-.025l.867-3.898A2.001 2.001 0 0 1 13 12.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m4.4.8-.003.004-.014.019a4.167 4.167 0 0 0-.204.31 2.327 2.327 0 0 0-.141.267c-.026.06-.034.092-.037.103v.004a.593.593 0 0 0 .091.248c.075.133.178.272.308.445l.01.012c.118.158.26.347.37.543.112.2.22.455.22.745 0 .188-.065.368-.119.494a3.31 3.31 0 0 1-.202.388 5.444 5.444 0 0 1-.253.382l-.018.025-.005.008-.002.002A.5.5 0 0 1 3.6 4.2l.003-.004.014-.019a4.149 4.149 0 0 0 .204-.31 2.06 2.06 0 0 0 .141-.267c.026-.06.034-.092.037-.103a.593.593 0 0 0-.09-.252A4.334 4.334 0 0 0 3.6 2.8l-.01-.012a5.099 5.099 0 0 1-.37-.543A1.53 1.53 0 0 1 3 1.5c0-.188.065-.368.119-.494.059-.138.134-.274.202-.388a5.446 5.446 0 0 1 .253-.382l.025-.035A.5.5 0 0 1 4.4.8Zm3 0-.003.004-.014.019a4.167 4.167 0 0 0-.204.31 2.327 2.327 0 0 0-.141.267c-.026.06-.034.092-.037.103v.004a.593.593 0 0 0 .091.248c.075.133.178.272.308.445l.01.012c.118.158.26.347.37.543.112.2.22.455.22.745 0 .188-.065.368-.119.494a3.31 3.31 0 0 1-.202.388 5.444 5.444 0 0 1-.253.382l-.018.025-.005.008-.002.002A.5.5 0 0 1 6.6 4.2l.003-.004.014-.019a4.149 4.149 0 0 0 .204-.31 2.06 2.06 0 0 0 .141-.267c.026-.06.034-.092.037-.103a.593.593 0 0 0-.09-.252A4.334 4.334 0 0 0 6.6 2.8l-.01-.012a5.099 5.099 0 0 1-.37-.543A1.53 1.53 0 0 1 6 1.5c0-.188.065-.368.119-.494.059-.138.134-.274.202-.388a5.446 5.446 0 0 1 .253-.382l.025-.035A.5.5 0 0 1 7.4.8Zm3 0-.003.004-.014.019a4.077 4.077 0 0 0-.204.31 2.337 2.337 0 0 0-.141.267c-.026.06-.034.092-.037.103v.004a.593.593 0 0 0 .091.248c.075.133.178.272.308.445l.01.012c.118.158.26.347.37.543.112.2.22.455.22.745 0 .188-.065.368-.119.494a3.198 3.198 0 0 1-.202.388 5.385 5.385 0 0 1-.252.382l-.019.025-.005.008-.002.002A.5.5 0 0 1 9.6 4.2l.003-.004.014-.019a4.149 4.149 0 0 0 .204-.31 2.06 2.06 0 0 0 .141-.267c.026-.06.034-.092.037-.103a.593.593 0 0 0-.09-.252A4.334 4.334 0 0 0 9.6 2.8l-.01-.012a5.099 5.099 0 0 1-.37-.543A1.53 1.53 0 0 1 9 1.5c0-.188.065-.368.119-.494.059-.138.134-.274.202-.388a5.446 5.446 0 0 1 .253-.382l.025-.035A.5.5 0 0 1 10.4.8Z"
                }
            }
        ]
    })(props);
}
function BsFillCursorFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.082 2.182a.5.5 0 0 1 .103.557L8.528 15.467a.5.5 0 0 1-.917-.007L5.57 10.694.803 8.652a.5.5 0 0 1-.006-.916l12.728-5.657a.5.5 0 0 1 .556.103z"
                }
            }
        ]
    })(props);
}
function BsFillDashCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7z"
                }
            }
        ]
    })(props);
}
function BsFillDashSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm2.5 7.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsFillDatabaseFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.904 1.777C4.978 1.289 6.427 1 8 1s3.022.289 4.096.777C13.125 2.245 14 2.993 14 4s-.875 1.755-1.904 2.223C11.022 6.711 9.573 7 8 7s-3.022-.289-4.096-.777C2.875 5.755 2 5.007 2 4s.875-1.755 1.904-2.223Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6.161V7c0 1.007.875 1.755 1.904 2.223C4.978 9.71 6.427 10 8 10s3.022-.289 4.096-.777C13.125 8.755 14 8.007 14 7v-.839c-.457.432-1.004.751-1.49.972C11.278 7.693 9.682 8 8 8s-3.278-.307-4.51-.867c-.486-.22-1.033-.54-1.49-.972Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9.161V10c0 1.007.875 1.755 1.904 2.223C4.978 12.711 6.427 13 8 13s3.022-.289 4.096-.777C13.125 11.755 14 11.007 14 10v-.839c-.457.432-1.004.751-1.49.972-1.232.56-2.828.867-4.51.867s-3.278-.307-4.51-.867c-.486-.22-1.033-.54-1.49-.972Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12.161V13c0 1.007.875 1.755 1.904 2.223C4.978 15.711 6.427 16 8 16s3.022-.289 4.096-.777C13.125 14.755 14 14.007 14 13v-.839c-.457.432-1.004.751-1.49.972-1.232.56-2.828.867-4.51.867s-3.278-.307-4.51-.867c-.486-.22-1.033-.54-1.49-.972Z"
                }
            }
        ]
    })(props);
}
function BsFillDeviceHddFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.785 9.896A3.001 3.001 0 0 0 8 4a3 3 0 0 0-.891 5.865c.667-.44 1.396-.91 1.955-1.268.224-.144.483.115.34.34l-.62.96ZM9 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4Zm9 1.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0 13a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-9.5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1ZM4 1.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm2.882 11.177a1.102 1.102 0 0 1-1.56-1.559c.1-.098.396-.314.795-.588a4 4 0 1 1 1.946.47c-.537.813-1.02 1.515-1.181 1.677Z"
                }
            }
        ]
    })(props);
}
function BsFillDeviceSsdFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8V4h6v4H5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4Zm0 1.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm9 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM3.5 11a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm9.5-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM4.75 3h6.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-.75.75h-6.5A.75.75 0 0 1 4 8.25v-4.5A.75.75 0 0 1 4.75 3ZM5 12h6a1 1 0 0 1 1 1v2h-1v-2h-.75v2h-1v-2H8.5v2h-1v-2h-.75v2h-1v-2H5v2H4v-2a1 1 0 0 1 1-1Z"
                }
            }
        ]
    })(props);
}
function BsFillDiagram2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 3.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5v1A1.5 1.5 0 0 1 8.5 6v1H11a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 5 7h2.5V6A1.5 1.5 0 0 1 6 4.5v-1zm-3 8A1.5 1.5 0 0 1 4.5 10h1A1.5 1.5 0 0 1 7 11.5v1A1.5 1.5 0 0 1 5.5 14h-1A1.5 1.5 0 0 1 3 12.5v-1zm6 0a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1A1.5 1.5 0 0 1 9 12.5v-1z"
                }
            }
        ]
    })(props);
}
function BsFillDiagram3Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 3.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5v1A1.5 1.5 0 0 1 8.5 6v1H14a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 2 7h5.5V6A1.5 1.5 0 0 1 6 4.5v-1zm-6 8A1.5 1.5 0 0 1 1.5 10h1A1.5 1.5 0 0 1 4 11.5v1A1.5 1.5 0 0 1 2.5 14h-1A1.5 1.5 0 0 1 0 12.5v-1zm6 0A1.5 1.5 0 0 1 7.5 10h1a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5v-1zm6 0a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5v-1z"
                }
            }
        ]
    })(props);
}
function BsFillDiamondFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.482 1.482 0 0 1 0-2.098L6.95.435z"
                }
            }
        ]
    })(props);
}
function BsFillDice1Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3zm5 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                }
            }
        ]
    })(props);
}
function BsFillDice2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3zm5.5 1a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0zm6.5 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
                }
            }
        ]
    })(props);
}
function BsFillDice3Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3zm2.5 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm8 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM8 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                }
            }
        ]
    })(props);
}
function BsFillDice4Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3zm1 5.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm8 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1.5 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM4 13.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                }
            }
        ]
    })(props);
}
function BsFillDice5Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3zm2.5 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm8 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM12 13.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM5.5 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM8 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                }
            }
        ]
    })(props);
}
function BsFillDice6Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3zm1 5.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm8 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1.5 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM12 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM5.5 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM4 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                }
            }
        ]
    })(props);
}
function BsFillDiscFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-6 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0zM4 8a4 4 0 0 1 4-4 .5.5 0 0 0 0-1 5 5 0 0 0-5 5 .5.5 0 0 0 1 0zm9 0a.5.5 0 1 0-1 0 4 4 0 0 1-4 4 .5.5 0 0 0 0 1 5 5 0 0 0 5-5z"
                }
            }
        ]
    })(props);
}
function BsFillDisplayFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12c0 .667-.083 1.167-.25 1.5H5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-.75c-.167-.333-.25-.833-.25-1.5h4c2 0 2-2 2-2V4c0-2-2-2-2-2H2C0 2 0 4 0 4v6c0 2 2 2 2 2h4z"
                }
            }
        ]
    })(props);
}
function BsFillDisplayportFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5a1 1 0 0 0-1 1v3.191a1 1 0 0 0 .553.894l1.618.81a1 1 0 0 0 .447.105H15a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H1Zm1.5 2h11a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V8H3v.5a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 .5-.5Z"
                }
            }
        ]
    })(props);
}
function BsFillDoorClosedFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1a1 1 0 0 1 1 1v13h1.5a.5.5 0 0 1 0 1h-13a.5.5 0 0 1 0-1H3V2a1 1 0 0 1 1-1h8zm-2 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                }
            }
        ]
    })(props);
}
function BsFillDoorOpenFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 15a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1H13V2.5A1.5 1.5 0 0 0 11.5 1H11V.5a.5.5 0 0 0-.57-.495l-7 1A.5.5 0 0 0 3 1.5V15H1.5zM11 2h.5a.5.5 0 0 1 .5.5V15h-1V2zm-2.5 8c-.276 0-.5-.448-.5-1s.224-1 .5-1 .5.448.5 1-.224 1-.5 1z"
                }
            }
        ]
    })(props);
}
function BsFillDpadFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 0A1.5 1.5 0 0 0 5 1.5v3a.5.5 0 0 1-.5.5h-3A1.5 1.5 0 0 0 0 6.5v3A1.5 1.5 0 0 0 1.5 11h3a.5.5 0 0 1 .5.5v3A1.5 1.5 0 0 0 6.5 16h3a1.5 1.5 0 0 0 1.5-1.5v-3a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 0 16 9.5v-3A1.5 1.5 0 0 0 14.5 5h-3a.5.5 0 0 1-.5-.5v-3A1.5 1.5 0 0 0 9.5 0h-3Zm1.288 2.34a.25.25 0 0 1 .424 0l.799 1.278A.25.25 0 0 1 8.799 4H7.201a.25.25 0 0 1-.212-.382l.799-1.279Zm0 11.32-.799-1.277A.25.25 0 0 1 7.201 12H8.8a.25.25 0 0 1 .212.383l-.799 1.278a.25.25 0 0 1-.424 0Zm-4.17-4.65-1.279-.798a.25.25 0 0 1 0-.424l1.279-.799A.25.25 0 0 1 4 7.201V8.8a.25.25 0 0 1-.382.212Zm10.043-.798-1.278.799A.25.25 0 0 1 12 8.799V7.2a.25.25 0 0 1 .383-.212l1.278.799a.25.25 0 0 1 0 .424Z"
                }
            }
        ]
    })(props);
}
function BsFillDropletFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16a6 6 0 0 0 6-6c0-1.655-1.122-2.904-2.432-4.362C10.254 4.176 8.75 2.503 8 0c0 0-6 5.686-6 10a6 6 0 0 0 6 6ZM6.646 4.646l.708.708c-.29.29-1.128 1.311-1.907 2.87l-.894-.448c.82-1.641 1.717-2.753 2.093-3.13Z"
                }
            }
        ]
    })(props);
}
function BsFillDuffleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.007 4.097c.008-.097.016-.197.027-.298.05-.464.141-.979.313-1.45.169-.465.432-.933.853-1.249 1.115-.836 2.485-.836 3.6 0 .42.316.684.784.853 1.25.171.47.263.985.313 1.449.01.1.02.2.027.298 1.401.194 2.65.531 3.525 1.012 2.126 1.169 1.446 6.095 1.089 8.018a.954.954 0 0 1-.95.772H1.343a.954.954 0 0 1-.95-.772c-.357-1.923-1.037-6.85 1.09-8.018.873-.48 2.123-.818 3.524-1.012ZM4.05 5.633a21.876 21.876 0 0 0-1.565.352l-.091.026-.034.01a.5.5 0 0 0 .282.959l.005-.002.02-.005.08-.023a20.874 20.874 0 0 1 1.486-.334A20.942 20.942 0 0 1 8 6.25c1.439 0 2.781.183 3.767.367a20.854 20.854 0 0 1 1.567.356l.02.005.004.001a.5.5 0 0 0 .283-.959h-.003l-.006-.002-.025-.007a14.787 14.787 0 0 0-.43-.113 21.87 21.87 0 0 0-1.226-.265A21.939 21.939 0 0 0 8 5.25c-1.518 0-2.926.192-3.95.383ZM6.8 1.9c-.203.153-.377.42-.513.791a5.258 5.258 0 0 0-.265 1.292 34.54 34.54 0 0 1 1.374-.076c.866-.022 1.742.003 2.584.076a5.258 5.258 0 0 0-.266-1.292c-.135-.372-.309-.638-.513-.791-.76-.57-1.64-.57-2.4 0Z"
                }
            }
        ]
    })(props);
}
function BsFillEarFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 0A5.5 5.5 0 0 0 3 5.5v7.047a3.453 3.453 0 0 0 6.687 1.212l.51-1.363a4.59 4.59 0 0 1 .67-1.197l2.008-2.581A5.34 5.34 0 0 0 8.66 0H8.5ZM7 5.5v2.695c.112-.06.223-.123.332-.192.327-.208.577-.44.72-.727a.5.5 0 1 1 .895.448c-.256.513-.673.865-1.079 1.123A8.538 8.538 0 0 1 7 9.313V11.5a.5.5 0 0 1-1 0v-6a2.5 2.5 0 0 1 5 0V6a.5.5 0 0 1-1 0v-.5a1.5 1.5 0 1 0-3 0Z"
                }
            }
        ]
    })(props);
}
function BsFillEaselFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.473.337a.5.5 0 0 0-.946 0L6.954 2H2a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h1.85l-1.323 3.837a.5.5 0 1 0 .946.326L4.908 11H7.5v2.5a.5.5 0 0 0 1 0V11h2.592l1.435 4.163a.5.5 0 0 0 .946-.326L12.15 11H14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H9.046L8.473.337z"
                }
            }
        ]
    })(props);
}
function BsFillEasel2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.447.276a.5.5 0 0 0-.894 0L7.19 1H2.5A1.5 1.5 0 0 0 1 2.5V10h14V2.5A1.5 1.5 0 0 0 13.5 1H8.809L8.447.276Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M.5 11a.5.5 0 0 0 0 1h2.86l-.845 3.379a.5.5 0 0 0 .97.242L3.89 14h8.22l.405 1.621a.5.5 0 0 0 .97-.242L12.64 12h2.86a.5.5 0 0 0 0-1H.5Zm3.64 2 .25-1h7.22l.25 1H4.14Z"
                }
            }
        ]
    })(props);
}
function BsFillEasel3Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 12v1.134a1 1 0 1 1-1 0V12h-5A1.5 1.5 0 0 1 1 10.5V3h14v7.5a1.5 1.5 0 0 1-1.5 1.5h-5Zm7-10a.5.5 0 0 0 0-1H.5a.5.5 0 0 0 0 1h15Z"
                }
            }
        ]
    })(props);
}
function BsFillEggFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10a6 6 0 0 1-12 0C2 5.686 5 0 8 0s6 5.686 6 10z"
                }
            }
        ]
    })(props);
}
function BsFillEjectFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.27 1.047a1 1 0 0 1 1.46 0l6.345 6.77c.6.638.146 1.683-.73 1.683H1.656C.78 9.5.326 8.455.926 7.816L7.27 1.047zM.5 11.5a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1v-1z"
                }
            }
        ]
    })(props);
}
function BsFillEmojiAngryFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM4.053 4.276a.5.5 0 0 1 .67-.223l2 1a.5.5 0 0 1 .166.76c.071.206.111.44.111.687C7 7.328 6.552 8 6 8s-1-.672-1-1.5c0-.408.109-.778.285-1.049l-1.009-.504a.5.5 0 0 1-.223-.67zm.232 8.157a.5.5 0 0 1-.183-.683A4.498 4.498 0 0 1 8 9.5a4.5 4.5 0 0 1 3.898 2.25.5.5 0 1 1-.866.5A3.498 3.498 0 0 0 8 10.5a3.498 3.498 0 0 0-3.032 1.75.5.5 0 0 1-.683.183zM10 8c-.552 0-1-.672-1-1.5 0-.247.04-.48.11-.686a.502.502 0 0 1 .166-.761l2-1a.5.5 0 1 1 .448.894l-1.009.504c.176.27.285.64.285 1.049 0 .828-.448 1.5-1 1.5z"
                }
            }
        ]
    })(props);
}
function BsFillEmojiAstonishedFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-4.884-3.978a2.092 2.092 0 0 1 .53.332.5.5 0 0 0 .708-.708h-.001v-.001a1.885 1.885 0 0 0-.237-.197 3.087 3.087 0 0 0-.606-.345 2.996 2.996 0 0 0-2.168-.077.5.5 0 1 0 .316.948 1.997 1.997 0 0 1 1.458.048Zm-4.774-.048a.5.5 0 0 0 .316-.948 2.996 2.996 0 0 0-2.167.077 3.091 3.091 0 0 0-.773.478c-.024.02-.047.042-.07.064l-.002.001a.5.5 0 1 0 .728.689 2.09 2.09 0 0 1 .51-.313 2 2 0 0 1 1.458-.048ZM7 6.5C7 5.672 6.552 5 6 5s-1 .672-1 1.5S5.448 8 6 8s1-.672 1-1.5Zm4 0c0-.828-.448-1.5-1-1.5s-1 .672-1 1.5S9.448 8 10 8s1-.672 1-1.5Zm-5.247 4.746c-.383.478.08 1.06.687.98 1.04-.135 2.08-.135 3.12 0 .606.08 1.07-.502.687-.98C9.747 10.623 8.998 10 8 10c-.998 0-1.747.623-2.247 1.246Z"
                }
            }
        ]
    })(props);
}
function BsFillEmojiDizzyFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM4.146 5.146a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 1 1 .708.708l-.647.646.647.646a.5.5 0 1 1-.708.708L5.5 7.207l-.646.647a.5.5 0 1 1-.708-.708l.647-.646-.647-.646a.5.5 0 0 1 0-.708zm5 0a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708.708l-.647.646.647.646a.5.5 0 0 1-.708.708l-.646-.647-.646.647a.5.5 0 1 1-.708-.708l.647-.646-.647-.646a.5.5 0 0 1 0-.708zM8 13a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
                }
            }
        ]
    })(props);
}
function BsFillEmojiExpressionlessFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM4.5 6h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm5 0h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm-5 4h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsFillEmojiFrownFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zm-2.715 5.933a.5.5 0 0 1-.183-.683A4.498 4.498 0 0 1 8 9.5a4.5 4.5 0 0 1 3.898 2.25.5.5 0 0 1-.866.5A3.498 3.498 0 0 0 8 10.5a3.498 3.498 0 0 0-3.032 1.75.5.5 0 0 1-.683.183zM10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8z"
                }
            }
        ]
    })(props);
}
function BsFillEmojiGrimaceFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM7 6.25C7 5.56 6.552 5 6 5s-1 .56-1 1.25.448 1.25 1 1.25 1-.56 1-1.25Zm3 1.25c.552 0 1-.56 1-1.25S10.552 5 10 5s-1 .56-1 1.25.448 1.25 1 1.25Zm1.5 4.5a1.5 1.5 0 0 0 1.48-1.25v-.003a1.512 1.512 0 0 0 0-.497A1.5 1.5 0 0 0 11.5 9h-7a1.5 1.5 0 0 0-1.48 1.25v.003a1.51 1.51 0 0 0 0 .497A1.5 1.5 0 0 0 4.5 12h7Zm-7.969-1.25a1 1 0 0 0 .969.75h.25v-.75H3.531Zm8.938 0a1 1 0 0 1-.969.75h-.25v-.75h1.219ZM11.5 9.5a1 1 0 0 1 .969.75H11.25V9.5h.25Zm-7.969.75A1 1 0 0 1 4.5 9.5h.25v.75H3.531ZM5.25 11.5h1v-.75h-1v.75Zm2.5 0h-1v-.75h1v.75Zm1.5 0h-1v-.75h1v.75Zm1.5 0h-1v-.75h1v.75Zm-1-2h1v.75h-1V9.5Zm-1.5 0h1v.75h-1V9.5Zm-1.5 0h1v.75h-1V9.5Zm-1.5 0h1v.75h-1V9.5Z"
                }
            }
        ]
    })(props);
}
function BsFillEmojiGrinFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16ZM6.488 7c-.23-.598-.661-1-1.155-1-.493 0-.924.402-1.155 1A2.794 2.794 0 0 1 4 6c0-1.105.597-2 1.333-2 .737 0 1.334.895 1.334 2 0 .364-.065.706-.179 1Zm5.334 0c-.23-.598-.662-1-1.155-1-.494 0-.925.402-1.155 1a2.793 2.793 0 0 1-.179-1c0-1.105.597-2 1.334-2C11.403 4 12 4.895 12 6c0 .364-.065.706-.178 1ZM2.696 8.756a.48.48 0 0 1 .382-.118C4.348 8.786 6.448 9 8 9c1.553 0 3.653-.214 4.922-.362a.48.48 0 0 1 .383.118.3.3 0 0 1 .096.29c-.09.47-.242.921-.445 1.342-.263.035-.576.075-.929.115A36.798 36.798 0 0 1 8 10.75c-1.475 0-2.934-.123-4.027-.247-.353-.04-.666-.08-.93-.115A5.457 5.457 0 0 1 2.6 9.045a.3.3 0 0 1 .097-.29ZM8 13.5a5.49 5.49 0 0 1-4.256-2.017l.116.014c1.115.126 2.615.253 4.14.253 1.525 0 3.025-.127 4.14-.253l.117-.014A5.49 5.49 0 0 1 8 13.5Z"
                }
            }
        ]
    })(props);
}
function BsFillEmojiHeartEyesFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zM4.756 4.566c.763-1.424 4.02-.12.952 3.434-4.496-1.596-2.35-4.298-.952-3.434zm6.559 5.448a.5.5 0 0 1 .548.736A4.498 4.498 0 0 1 7.965 13a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .548-.736h.005l.017.005.067.015.252.055c.215.046.515.108.857.169.693.124 1.522.242 2.152.242.63 0 1.46-.118 2.152-.242a26.58 26.58 0 0 0 1.109-.224l.067-.015.017-.004.005-.002zm-.07-5.448c1.397-.864 3.543 1.838-.953 3.434-3.067-3.554.19-4.858.952-3.434z"
                }
            }
        ]
    })(props);
}
function BsFillEmojiKissFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M16 8a8 8 0 1 0-2.697 5.99c-.972-.665-1.632-1.356-1.99-2.062-.388-.766-.419-1.561-.075-2.23.496-.97 1.73-1.466 2.762-1.05.65-.262 1.38-.162 1.957.19.028-.275.043-.555.043-.838ZM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5Zm1.512 3.647c-.347.08-.737.198-1.107.319a.5.5 0 1 1-.31-.95c.38-.125.802-.254 1.192-.343.37-.086.78-.153 1.103-.108.16.022.394.085.561.286.188.226.187.497.131.705a1.894 1.894 0 0 1-.31.593c-.077.107-.168.22-.275.343.107.124.199.24.276.347.142.197.256.397.31.595.055.208.056.479-.132.706-.168.2-.404.262-.563.284-.323.043-.733-.027-1.102-.113a14.87 14.87 0 0 1-1.191-.345.5.5 0 1 1 .31-.95c.371.12.761.24 1.109.321.176.041.325.069.446.084a5.609 5.609 0 0 0-.502-.584.5.5 0 0 1 .002-.695 5.52 5.52 0 0 0 .5-.577 4.465 4.465 0 0 0-.448.082Zm.766-.086-.006-.002c.004 0 .006.002.006.002Zm.002 1.867h-.001l-.005.001a.038.038 0 0 1 .006-.002Zm.157-4.685a.5.5 0 0 1-.874-.486A1.934 1.934 0 0 1 10.25 5.75c.73 0 1.356.412 1.687 1.007a.5.5 0 1 1-.874.486.934.934 0 0 0-.813-.493.934.934 0 0 0-.813.493ZM14 9.828c1.11-1.14 3.884.856 0 3.422-3.884-2.566-1.11-4.562 0-3.421Z"
                }
            }
        ]
    })(props);
}
function BsFillEmojiLaughingFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5c0 .501-.164.396-.415.235C6.42 6.629 6.218 6.5 6 6.5c-.218 0-.42.13-.585.235C5.164 6.896 5 7 5 6.5 5 5.672 5.448 5 6 5s1 .672 1 1.5zm5.331 3a1 1 0 0 1 0 1A4.998 4.998 0 0 1 8 13a4.998 4.998 0 0 1-4.33-2.5A1 1 0 0 1 4.535 9h6.93a1 1 0 0 1 .866.5zm-1.746-2.765C10.42 6.629 10.218 6.5 10 6.5c-.218 0-.42.13-.585.235C9.164 6.896 9 7 9 6.5c0-.828.448-1.5 1-1.5s1 .672 1 1.5c0 .501-.164.396-.415.235z"
                }
            }
        ]
    })(props);
}
function BsFillEmojiNeutralFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zm-3 4a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8z"
                }
            }
        ]
    })(props);
}
function BsFillEmojiSmileFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zM4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8z"
                }
            }
        ]
    })(props);
}
function BsFillEmojiSmileUpsideDownFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM7 9.5C7 8.672 6.552 8 6 8s-1 .672-1 1.5.448 1.5 1 1.5 1-.672 1-1.5zM4.285 6.433a.5.5 0 0 0 .683-.183A3.498 3.498 0 0 1 8 4.5c1.295 0 2.426.703 3.032 1.75a.5.5 0 0 0 .866-.5A4.498 4.498 0 0 0 8 3.5a4.5 4.5 0 0 0-3.898 2.25.5.5 0 0 0 .183.683zM10 8c-.552 0-1 .672-1 1.5s.448 1.5 1 1.5 1-.672 1-1.5S10.552 8 10 8z"
                }
            }
        ]
    })(props);
}
function BsFillEmojiSunglassesFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM2.31 5.243A1 1 0 0 1 3.28 4H6a1 1 0 0 1 1 1v.116A4.22 4.22 0 0 1 8 5c.35 0 .69.04 1 .116V5a1 1 0 0 1 1-1h2.72a1 1 0 0 1 .97 1.243l-.311 1.242A2 2 0 0 1 11.439 8H11a2 2 0 0 1-1.994-1.839A2.99 2.99 0 0 0 8 6c-.393 0-.74.064-1.006.161A2 2 0 0 1 5 8h-.438a2 2 0 0 1-1.94-1.515L2.31 5.243zM4.969 9.75A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .866-.5z"
                }
            }
        ]
    })(props);
}
function BsFillEmojiSurpriseFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM7 5.5C7 4.672 6.552 4 6 4s-1 .672-1 1.5S5.448 7 6 7s1-.672 1-1.5Zm4 0c0-.828-.448-1.5-1-1.5s-1 .672-1 1.5S9.448 7 10 7s1-.672 1-1.5ZM8 13a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
                }
            }
        ]
    })(props);
}
function BsFillEmojiTearFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM9.5 3.5a.5.5 0 0 0 .5.5c.838 0 1.65.416 2.053 1.224a.5.5 0 1 0 .894-.448C12.351 3.584 11.162 3 10 3a.5.5 0 0 0-.5.5ZM7 6.5C7 5.672 6.552 5 6 5s-1 .672-1 1.5S5.448 8 6 8s1-.672 1-1.5ZM4.5 13c.828 0 1.5-.746 1.5-1.667 0-.706-.882-2.29-1.294-2.99a.238.238 0 0 0-.412 0C3.882 9.044 3 10.628 3 11.334 3 12.253 3.672 13 4.5 13ZM8 11.197c.916 0 1.607.408 2.25.826.212.138.424-.069.282-.277-.564-.83-1.558-2.049-2.532-2.049-.53 0-1.066.361-1.536.824.083.179.162.36.232.535.045.115.092.241.135.373A3.1 3.1 0 0 1 8 11.197ZM10 8c.552 0 1-.672 1-1.5S10.552 5 10 5s-1 .672-1 1.5S9.448 8 10 8ZM6.5 3c-1.162 0-2.35.584-2.947 1.776a.5.5 0 1 0 .894.448C4.851 4.416 5.662 4 6.5 4a.5.5 0 0 0 0-1Z"
                }
            }
        ]
    })(props);
}
function BsFillEmojiWinkFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM7 6.5C7 5.672 6.552 5 6 5s-1 .672-1 1.5S5.448 8 6 8s1-.672 1-1.5zM4.285 9.567a.5.5 0 0 0-.183.683A4.498 4.498 0 0 0 8 12.5a4.5 4.5 0 0 0 3.898-2.25.5.5 0 1 0-.866-.5A3.498 3.498 0 0 1 8 11.5a3.498 3.498 0 0 1-3.032-1.75.5.5 0 0 0-.683-.183zm5.152-3.31a.5.5 0 0 0-.874.486c.33.595.958 1.007 1.687 1.007.73 0 1.356-.412 1.687-1.007a.5.5 0 0 0-.874-.486.934.934 0 0 1-.813.493.934.934 0 0 1-.813-.493z"
                }
            }
        ]
    })(props);
}
function BsFillEnvelopeArrowDownFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697Zm.192 8.159 6.57-4.027L8 9.586l1.239-.757.367.225A4.49 4.49 0 0 0 8 12.5c0 .526.09 1.03.256 1.5H2a2 2 0 0 1-1.808-1.144ZM16 4.697v4.974A4.491 4.491 0 0 0 12.5 8a4.49 4.49 0 0 0-1.965.45l-.338-.207L16 4.697Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.354-1.646a.5.5 0 0 1-.722-.016l-1.149-1.25a.5.5 0 1 1 .737-.676l.28.305V11a.5.5 0 0 1 1 0v1.793l.396-.397a.5.5 0 0 1 .708.708l-1.25 1.25Z"
                }
            }
        ]
    })(props);
}
function BsFillEnvelopeArrowUpFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697Zm.192 8.159 6.57-4.027L8 9.586l1.239-.757.367.225A4.49 4.49 0 0 0 8 12.5c0 .526.09 1.03.256 1.5H2a2 2 0 0 1-1.808-1.144ZM16 4.697v4.974A4.491 4.491 0 0 0 12.5 8a4.49 4.49 0 0 0-1.965.45l-.338-.207L16 4.697Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.354-5.354 1.25 1.25a.5.5 0 0 1-.708.708L13 12.207V14a.5.5 0 0 1-1 0v-1.717l-.28.305a.5.5 0 0 1-.737-.676l1.149-1.25a.5.5 0 0 1 .722-.016Z"
                }
            }
        ]
    })(props);
}
function BsFillEnvelopeAtFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2A2 2 0 0 0 .05 3.555L8 8.414l7.95-4.859A2 2 0 0 0 14 2H2Zm-2 9.8V4.698l5.803 3.546L0 11.801Zm6.761-2.97-6.57 4.026A2 2 0 0 0 2 14h6.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586l-1.239-.757ZM16 9.671V4.697l-5.803 3.546.338.208A4.482 4.482 0 0 1 12.5 8c1.414 0 2.675.652 3.5 1.671Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.834 12.244c0 1.168-.577 2.025-1.587 2.025-.503 0-1.002-.228-1.12-.648h-.043c-.118.416-.543.643-1.015.643-.77 0-1.259-.542-1.259-1.434v-.529c0-.844.481-1.4 1.26-1.4.585 0 .87.333.953.63h.03v-.568h.905v2.19c0 .272.18.42.411.42.315 0 .639-.415.639-1.39v-.118c0-1.277-.95-2.326-2.484-2.326h-.04c-1.582 0-2.64 1.067-2.64 2.724v.157c0 1.867 1.237 2.654 2.57 2.654h.045c.507 0 .935-.07 1.18-.18v.731c-.219.1-.643.175-1.237.175h-.044C10.438 16 9 14.82 9 12.646v-.214C9 10.36 10.421 9 12.485 9h.035c2.12 0 3.314 1.43 3.314 3.034v.21Zm-4.04.21v.227c0 .586.227.8.581.8.31 0 .564-.17.564-.743v-.367c0-.516-.275-.708-.572-.708-.346 0-.573.245-.573.791Z"
                }
            }
        ]
    })(props);
}
function BsFillEnvelopeCheckFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.026A2 2 0 0 0 2 14h6.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586l-1.239-.757ZM16 4.697v4.974A4.491 4.491 0 0 0 12.5 8a4.49 4.49 0 0 0-1.965.45l-.338-.207L16 4.697Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z"
                }
            }
        ]
    })(props);
}
function BsFillEnvelopeDashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.026A2 2 0 0 0 2 14h6.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586l-1.239-.757ZM16 4.697v4.974A4.491 4.491 0 0 0 12.5 8a4.49 4.49 0 0 0-1.965.45l-.338-.207L16 4.697Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-5.5 0a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5Z"
                }
            }
        ]
    })(props);
}
function BsFillEnvelopeExclamationFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.026A2 2 0 0 0 2 14h6.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586l-1.239-.757ZM16 4.697v4.974A4.491 4.491 0 0 0 12.5 8a4.49 4.49 0 0 0-1.965.45l-.338-.207L16 4.697Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.5-5v1.5a.5.5 0 0 1-1 0V11a.5.5 0 0 1 1 0Zm0 3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
                }
            }
        ]
    })(props);
}
function BsFillEnvelopeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757Zm3.436-.586L16 11.801V4.697l-5.803 3.546Z"
                }
            }
        ]
    })(props);
}
function BsFillEnvelopeHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555l-4.2 2.568a2.785 2.785 0 0 0-.051-.105c-.666-1.3-2.363-1.917-3.699-1.25-1.336-.667-3.033-.05-3.699 1.25l-.05.105L.05 3.555ZM11.584 8.91a4.694 4.694 0 0 1-.073.139L16 11.8V4.697l-4.003 2.447c.027.562-.107 1.163-.413 1.767Zm-4.135 3.05c-1.048-.693-1.84-1.39-2.398-2.082L.19 12.856A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144L10.95 9.878c-.559.692-1.35 1.389-2.398 2.081L8 12.324l-.551-.365ZM4.416 8.91c-.306-.603-.44-1.204-.413-1.766L0 4.697v7.104l4.49-2.752a4.742 4.742 0 0 1-.074-.138Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z"
                }
            }
        ]
    })(props);
}
function BsFillEnvelopeOpenFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.941.435a2 2 0 0 0-1.882 0l-6 3.2A2 2 0 0 0 0 5.4v.314l6.709 3.932L8 8.928l1.291.718L16 5.714V5.4a2 2 0 0 0-1.059-1.765l-6-3.2ZM16 6.873l-5.693 3.337L16 13.372v-6.5Zm-.059 7.611L8 10.072.059 14.484A2 2 0 0 0 2 16h12a2 2 0 0 0 1.941-1.516ZM0 13.373l5.693-3.163L0 6.873v6.5Z"
                }
            }
        ]
    })(props);
}
function BsFillEnvelopeOpenHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.941.435a2 2 0 0 0-1.882 0l-6 3.2A2 2 0 0 0 0 5.4v.313l4.222 2.475c.024-.058.05-.114.08-.17.665-1.3 2.362-1.917 3.698-1.25 1.336-.667 3.033-.05 3.699 1.25a3.3 3.3 0 0 1 .08.17L16 5.713V5.4a2 2 0 0 0-1.059-1.765l-6-3.2ZM0 6.873l4 2.344c-.012.542.124 1.117.416 1.694l.004.006L0 13.372v-6.5Zm.059 7.611 4.9-2.723c.563.73 1.383 1.467 2.49 2.198l.551.365.551-.365c1.107-.73 1.927-1.467 2.49-2.198l4.9 2.723A2 2 0 0 1 14 16H2a2 2 0 0 1-1.941-1.516ZM16 13.372l-4.42-2.455.004-.006c.292-.577.428-1.152.415-1.694L16 6.873v6.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z"
                }
            }
        ]
    })(props);
}
function BsFillEnvelopePaperFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.5 9.5 3 7.5v-6A1.5 1.5 0 0 1 4.5 0h7A1.5 1.5 0 0 1 13 1.5v6l-3.5 2L8 8.75l-1.5.75ZM1.059 3.635 2 3.133v3.753L0 5.713V5.4a2 2 0 0 1 1.059-1.765ZM16 5.713l-2 1.173V3.133l.941.502A2 2 0 0 1 16 5.4v.313Zm0 1.16-5.693 3.337L16 13.372v-6.5Zm-8 3.199 7.941 4.412A2 2 0 0 1 14 16H2a2 2 0 0 1-1.941-1.516L8 10.072Zm-8 3.3 5.693-3.162L0 6.873v6.5Z"
                }
            }
        ]
    })(props);
}
function BsFillEnvelopePaperHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "m3 7.5 3.5 2L8 8.75l1.5.75 3.5-2v-6A1.5 1.5 0 0 0 11.5 0h-7A1.5 1.5 0 0 0 3 1.5v6ZM2 3.133l-.941.502A2 2 0 0 0 0 5.4v.313l2 1.173V3.133Zm12 3.753 2-1.173V5.4a2 2 0 0 0-1.059-1.765L14 3.133v3.753Zm-3.693 3.324L16 6.873v6.5l-5.693-3.163Zm5.634 4.274L8 10.072.059 14.484A2 2 0 0 0 2 16h12a2 2 0 0 0 1.941-1.516ZM5.693 10.21 0 13.372v-6.5l5.693 3.338ZM8 1.982C9.664.309 13.825 3.236 8 7 2.175 3.236 6.336.31 8 1.982Z"
                }
            }
        ]
    })(props);
}
function BsFillEnvelopePlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.026A2 2 0 0 0 2 14h6.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586l-1.239-.757ZM16 4.697v4.974A4.491 4.491 0 0 0 12.5 8a4.49 4.49 0 0 0-1.965.45l-.338-.207L16 4.697Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-3.5-2a.5.5 0 0 0-.5.5v1h-1a.5.5 0 0 0 0 1h1v1a.5.5 0 0 0 1 0v-1h1a.5.5 0 0 0 0-1h-1v-1a.5.5 0 0 0-.5-.5Z"
                }
            }
        ]
    })(props);
}
function BsFillEnvelopeSlashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.026A2 2 0 0 0 2 14h6.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586l-1.239-.757ZM16 4.697v4.974A4.491 4.491 0 0 0 12.5 8a4.49 4.49 0 0 0-1.965.45l-.338-.207L16 4.697Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.975 10.025a3.5 3.5 0 1 0-4.95 4.95 3.5 3.5 0 0 0 4.95-4.95Zm-4.243.707a2.501 2.501 0 0 1 3.147-.318l-3.465 3.465a2.501 2.501 0 0 1 .318-3.147Zm.39 3.854 3.464-3.465a2.501 2.501 0 0 1-3.465 3.465Z"
                }
            }
        ]
    })(props);
}
function BsFillEnvelopeXFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.026A2 2 0 0 0 2 14h6.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586l-1.239-.757ZM16 4.697v4.974A4.491 4.491 0 0 0 12.5 8a4.49 4.49 0 0 0-1.965.45l-.338-.207L16 4.697Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-4.854-1.354a.5.5 0 0 0 0 .708l.647.646-.647.646a.5.5 0 0 0 .708.708l.646-.647.646.647a.5.5 0 0 0 .708-.708l-.647-.646.647-.646a.5.5 0 0 0-.708-.708l-.646.647-.646-.647a.5.5 0 0 0-.708 0Z"
                }
            }
        ]
    })(props);
}
function BsFillEraserFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.086 2.207a2 2 0 0 1 2.828 0l3.879 3.879a2 2 0 0 1 0 2.828l-5.5 5.5A2 2 0 0 1 7.879 15H5.12a2 2 0 0 1-1.414-.586l-2.5-2.5a2 2 0 0 1 0-2.828l6.879-6.879zm.66 11.34L3.453 8.254 1.914 9.793a1 1 0 0 0 0 1.414l2.5 2.5a1 1 0 0 0 .707.293H7.88a1 1 0 0 0 .707-.293l.16-.16z"
                }
            }
        ]
    })(props);
}
function BsFillEvFrontFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679c.033.161.049.325.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.807.807 0 0 0 .381-.404l.792-1.848Zm6.75.51a.186.186 0 0 0-.23.034L6.05 7.246a.188.188 0 0 0 .137.316h1.241l-.673 2.195a.188.188 0 0 0 .085.218c.075.043.17.03.23-.034l2.88-3.187a.188.188 0 0 0-.137-.316H8.572l.782-2.195a.188.188 0 0 0-.085-.218Z"
                }
            }
        ]
    })(props);
}
function BsFillEvStationFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v8a2 2 0 0 1 2 2v.5a.5.5 0 0 0 1 0V9c0-.258-.104-.377-.357-.635l-.007-.008C13.379 8.096 13 7.71 13 7V4a.5.5 0 0 1 .146-.354l.5-.5a.5.5 0 0 1 .708 0l.5.5A.5.5 0 0 1 15 4v8.5a1.5 1.5 0 1 1-3 0V12a1 1 0 0 0-1-1v4h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V2Zm2 .5v5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5Zm2.631 9.96H4.14v-.893h1.403v-.505H4.14v-.855h1.49v-.54H3.485V13h2.146v-.54Zm1.316.54h.794l1.106-3.333h-.733l-.74 2.615h-.031l-.747-2.615h-.764L6.947 13Z"
                }
            }
        ]
    })(props);
}
function BsFillExclamationCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
                }
            }
        ]
    })(props);
}
function BsFillExclamationDiamondFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435zM8 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                }
            }
        ]
    })(props);
}
function BsFillExclamationOctagonFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.46.146A.5.5 0 0 0 11.107 0H4.893a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353L11.46.146zM8 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                }
            }
        ]
    })(props);
}
function BsFillExclamationSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                }
            }
        ]
    })(props);
}
function BsFillExclamationTriangleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                }
            }
        ]
    })(props);
}
function BsFillExplicitFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 0A2.5 2.5 0 0 0 0 2.5v11A2.5 2.5 0 0 0 2.5 16h11a2.5 2.5 0 0 0 2.5-2.5v-11A2.5 2.5 0 0 0 13.5 0h-11Zm4.326 10.88H10.5V12h-5V4.002h5v1.12H6.826V7.4h3.457v1.073H6.826v2.408Z"
                }
            }
        ]
    })(props);
}
function BsFillEyeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"
                }
            }
        ]
    })(props);
}
function BsFillEyeSlashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z"
                }
            }
        ]
    })(props);
}
function BsFillFastForwardBtnFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2Zm4.271 1.055a.5.5 0 0 1 .52.038L8 7.386V5.5a.5.5 0 0 1 .79-.407l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 8 10.5V8.614l-3.21 2.293A.5.5 0 0 1 4 10.5v-5a.5.5 0 0 1 .271-.445Z"
                }
            }
        ]
    })(props);
}
function BsFillFastForwardCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16ZM4.79 5.093 8 7.386V5.5a.5.5 0 0 1 .79-.407l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 8 10.5V8.614l-3.21 2.293A.5.5 0 0 1 4 10.5v-5a.5.5 0 0 1 .79-.407Z"
                }
            }
        ]
    })(props);
}
function BsFillFastForwardFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.596 7.304a.802.802 0 0 1 0 1.392l-6.363 3.692C.713 12.69 0 12.345 0 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.596 7.304a.802.802 0 0 1 0 1.392l-6.363 3.692C8.713 12.69 8 12.345 8 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692Z"
                }
            }
        ]
    })(props);
}
function BsFillFileArrowDownFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM8 5a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5A.5.5 0 0 1 8 5z"
                }
            }
        ]
    })(props);
}
function BsFillFileArrowUpFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM7.5 6.707 6.354 7.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 6.707V10.5a.5.5 0 0 1-1 0V6.707z"
                }
            }
        ]
    })(props);
}
function BsFillFileBarGraphFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm-2 11.5v-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm-2.5.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1zm-3 0a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-1z"
                }
            }
        ]
    })(props);
}
function BsFillFileBinaryFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.526 9.273c-.542 0-.832.563-.832 1.612 0 .088.003.173.006.252l1.56-1.143c-.126-.474-.375-.72-.733-.72zm-.732 2.508c.126.472.372.718.732.718.54 0 .83-.563.83-1.614 0-.085-.003-.17-.006-.25l-1.556 1.146z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM7.05 10.885c0 1.415-.548 2.206-1.524 2.206C4.548 13.09 4 12.3 4 10.885c0-1.412.548-2.203 1.526-2.203.976 0 1.524.79 1.524 2.203zm3.805 1.52V13h-3v-.595h1.181V9.5h-.05l-1.136.747v-.688l1.19-.786h.69v3.633h1.125z"
                }
            }
        ]
    })(props);
}
function BsFillFileBreakFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0h8a2 2 0 0 1 2 2v7H2V2a2 2 0 0 1 2-2zM2 12h12v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-2zM.5 10a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1H.5z"
                }
            }
        ]
    })(props);
}
function BsFillFileCheckFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm-1.146 6.854-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 8.793l2.646-2.647a.5.5 0 0 1 .708.708z"
                }
            }
        ]
    })(props);
}
function BsFillFileCodeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM6.646 5.646a.5.5 0 1 1 .708.708L5.707 8l1.647 1.646a.5.5 0 0 1-.708.708l-2-2a.5.5 0 0 1 0-.708l2-2zm2.708 0 2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L10.293 8 8.646 6.354a.5.5 0 1 1 .708-.708z"
                }
            }
        ]
    })(props);
}
function BsFillFileDiffFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM8.5 4.5V6H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V7H6a.5.5 0 0 1 0-1h1.5V4.5a.5.5 0 0 1 1 0zM6 10h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkArrowDownFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm-1 4v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 11.293V7.5a.5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkArrowUpFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM6.354 9.854a.5.5 0 0 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 8.707V12.5a.5.5 0 0 1-1 0V8.707L6.354 9.854z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkBarGraphFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm.5 10v-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm-2.5.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1zm-3 0a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-1z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkBinaryFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.526 10.273c-.542 0-.832.563-.832 1.612 0 .088.003.173.006.252l1.559-1.143c-.126-.474-.375-.72-.733-.72zm-.732 2.508c.126.472.372.718.732.718.54 0 .83-.563.83-1.614 0-.085-.003-.17-.006-.25l-1.556 1.146z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm-2.45 8.385c0 1.415-.548 2.206-1.524 2.206C4.548 14.09 4 13.3 4 11.885c0-1.412.548-2.203 1.526-2.203.976 0 1.524.79 1.524 2.203zm3.805 1.52V14h-3v-.595h1.181V10.5h-.05l-1.136.747v-.688l1.19-.786h.69v3.633h1.125z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkBreakFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V9H2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3zM2 12h12v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-2zM.5 10a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1H.5z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkCheckFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm1.354 4.354-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708.708z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkCodeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM6.646 7.646a.5.5 0 1 1 .708.708L5.707 10l1.647 1.646a.5.5 0 0 1-.708.708l-2-2a.5.5 0 0 1 0-.708l2-2zm2.708 0 2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L10.293 10 8.646 8.354a.5.5 0 1 1 .708-.708z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkDiffFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM8 6a.5.5 0 0 1 .5.5V8H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V9H6a.5.5 0 0 1 0-1h1.5V6.5A.5.5 0 0 1 8 6zm-2.5 6.5A.5.5 0 0 1 6 12h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkEaselFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM8.5 6h2A1.5 1.5 0 0 1 12 7.5v2a1.5 1.5 0 0 1-1.5 1.5h-.473l.447 1.342a.5.5 0 0 1-.948.316L8.973 11H8.5v1a.5.5 0 0 1-1 0v-1h-.473l-.553 1.658a.5.5 0 1 1-.948-.316L5.973 11H5.5A1.5 1.5 0 0 1 4 9.5v-2A1.5 1.5 0 0 1 5.5 6h2a.5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkExcelFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM5.884 6.68 8 9.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 10l2.233 2.68a.5.5 0 0 1-.768.64L8 10.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 10 5.116 7.32a.5.5 0 1 1 .768-.64z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkFontFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM5.057 6h5.886L11 8h-.5c-.18-1.096-.356-1.192-1.694-1.235l-.298-.01v5.09c0 .47.1.582.903.655v.5H6.59v-.5c.799-.073.898-.184.898-.654V6.755l-.293.01C5.856 6.808 5.68 6.905 5.5 8H5l.057-2z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkImageFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707v5.586l-2.73-2.73a1 1 0 0 0-1.52.127l-1.889 2.644-1.769-1.062a1 1 0 0 0-1.222.15L2 12.292V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3zm-1.498 4a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.564 8.27 14 11.708V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-.293l3.578-3.577 2.56 1.536 2.426-3.395z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkLockFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7a1 1 0 0 1 2 0v1H7V7zM6 9.3c0-.042.02-.107.105-.175A.637.637 0 0 1 6.5 9h3a.64.64 0 0 1 .395.125c.085.068.105.133.105.175v2.4c0 .042-.02.107-.105.175A.637.637 0 0 1 9.5 12h-3a.637.637 0 0 1-.395-.125C6.02 11.807 6 11.742 6 11.7V9.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM10 7v1.076c.54.166 1 .597 1 1.224v2.4c0 .816-.781 1.3-1.5 1.3h-3c-.719 0-1.5-.484-1.5-1.3V9.3c0-.627.46-1.058 1-1.224V7a2 2 0 1 1 4 0z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkLock2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7a1 1 0 0 1 2 0v1H7V7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM10 7v1.076c.54.166 1 .597 1 1.224v2.4c0 .816-.781 1.3-1.5 1.3h-3c-.719 0-1.5-.484-1.5-1.3V9.3c0-.627.46-1.058 1-1.224V7a2 2 0 1 1 4 0z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkMedicalFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm-3 2v.634l.549-.317a.5.5 0 1 1 .5.866L7 7l.549.317a.5.5 0 1 1-.5.866L6.5 7.866V8.5a.5.5 0 0 1-1 0v-.634l-.549.317a.5.5 0 1 1-.5-.866L5 7l-.549-.317a.5.5 0 0 1 .5-.866l.549.317V5.5a.5.5 0 1 1 1 0zm-2 4.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm0 2h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkMinusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM6 8.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkMusicFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM11 6.64v1.75l-2 .5v3.61c0 .495-.301.883-.662 1.123C7.974 13.866 7.499 14 7 14c-.5 0-.974-.134-1.338-.377-.36-.24-.662-.628-.662-1.123s.301-.883.662-1.123C6.026 11.134 6.501 11 7 11c.356 0 .7.068 1 .196V6.89a1 1 0 0 1 .757-.97l1-.25A1 1 0 0 1 11 6.64z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkPdfFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.523 12.424c.14-.082.293-.162.459-.238a7.878 7.878 0 0 1-.45.606c-.28.337-.498.516-.635.572a.266.266 0 0 1-.035.012.282.282 0 0 1-.026-.044c-.056-.11-.054-.216.04-.36.106-.165.319-.354.647-.548zm2.455-1.647c-.119.025-.237.05-.356.078a21.148 21.148 0 0 0 .5-1.05 12.045 12.045 0 0 0 .51.858c-.217.032-.436.07-.654.114zm2.525.939a3.881 3.881 0 0 1-.435-.41c.228.005.434.022.612.054.317.057.466.147.518.209a.095.095 0 0 1 .026.064.436.436 0 0 1-.06.2.307.307 0 0 1-.094.124.107.107 0 0 1-.069.015c-.09-.003-.258-.066-.498-.256zM8.278 6.97c-.04.244-.108.524-.2.829a4.86 4.86 0 0 1-.089-.346c-.076-.353-.087-.63-.046-.822.038-.177.11-.248.196-.283a.517.517 0 0 1 .145-.04c.013.03.028.092.032.198.005.122-.007.277-.038.465z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3zM4.165 13.668c.09.18.23.343.438.419.207.075.412.04.58-.03.318-.13.635-.436.926-.786.333-.401.683-.927 1.021-1.51a11.651 11.651 0 0 1 1.997-.406c.3.383.61.713.91.95.28.22.603.403.934.417a.856.856 0 0 0 .51-.138c.155-.101.27-.247.354-.416.09-.181.145-.37.138-.563a.844.844 0 0 0-.2-.518c-.226-.27-.596-.4-.96-.465a5.76 5.76 0 0 0-1.335-.05 10.954 10.954 0 0 1-.98-1.686c.25-.66.437-1.284.52-1.794.036-.218.055-.426.048-.614a1.238 1.238 0 0 0-.127-.538.7.7 0 0 0-.477-.365c-.202-.043-.41 0-.601.077-.377.15-.576.47-.651.823-.073.34-.04.736.046 1.136.088.406.238.848.43 1.295a19.697 19.697 0 0 1-1.062 2.227 7.662 7.662 0 0 0-1.482.645c-.37.22-.699.48-.897.787-.21.326-.275.714-.08 1.103z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkPersonFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm2 5.755V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-.245S4 12 8 12s5 1.755 5 1.755z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkPlayFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM6 6.883a.5.5 0 0 1 .757-.429l3.528 2.117a.5.5 0 0 1 0 .858l-3.528 2.117a.5.5 0 0 1-.757-.43V6.884z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkPlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM8.5 7v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7a.5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkPostFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm-5-.5H7a.5.5 0 0 1 0 1H4.5a.5.5 0 0 1 0-1zm0 3h7a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkPptFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.188 10H7V6.5h1.188a1.75 1.75 0 1 1 0 3.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3zM7 5.5a1 1 0 0 0-1 1V13a.5.5 0 0 0 1 0v-2h1.188a2.75 2.75 0 0 0 0-5.5H7z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkRichtextFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM7 6.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm-.861 1.542 1.33.886 1.854-1.855a.25.25 0 0 1 .289-.047l1.888.974V9.5a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V9s1.54-1.274 1.639-1.208zM5 11h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1zm0 2h3a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkRuledFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM3 9h10v1H6v2h7v1H6v2H5v-2H3v-1h2v-2H3V9z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkSlidesFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9.78V7.22c0-.096.106-.156.19-.106l2.13 1.279a.125.125 0 0 1 0 .214l-2.13 1.28A.125.125 0 0 1 7 9.778z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM5 6h6a.5.5 0 0 1 .496.438l.5 4A.5.5 0 0 1 11.5 11h-3v2.016c.863.055 1.5.251 1.5.484 0 .276-.895.5-2 .5s-2-.224-2-.5c0-.233.637-.429 1.5-.484V11h-3a.5.5 0 0 1-.496-.562l.5-4A.5.5 0 0 1 5 6z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkSpreadsheetFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12v-2h3v2H6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM3 9h10v1h-3v2h3v1h-3v2H9v-2H6v2H5v-2H3v-1h2v-2H3V9z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkTextFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM4.5 9a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1h-7zM4 10.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1h-4z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkWordFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM5.485 6.879l1.036 4.144.997-3.655a.5.5 0 0 1 .964 0l.997 3.655 1.036-4.144a.5.5 0 0 1 .97.242l-1.5 6a.5.5 0 0 1-.967.01L8 9.402l-1.018 3.73a.5.5 0 0 1-.967-.01l-1.5-6a.5.5 0 1 1 .97-.242z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkXFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM6.854 7.146 8 8.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 9l1.147 1.146a.5.5 0 0 1-.708.708L8 9.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 9 6.146 7.854a.5.5 0 1 1 .708-.708z"
                }
            }
        ]
    })(props);
}
function BsFillFileEarmarkZipFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 9.438V8.5h1v.938a1 1 0 0 0 .03.243l.4 1.598-.93.62-.93-.62.4-1.598a1 1 0 0 0 .03-.243z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm-4-.5V2h-1V1H6v1h1v1H6v1h1v1H6v1h1v1H5.5V6h-1V5h1V4h-1V3h1zm0 4.5h1a1 1 0 0 1 1 1v.938l.4 1.599a1 1 0 0 1-.416 1.074l-.93.62a1 1 0 0 1-1.109 0l-.93-.62a1 1 0 0 1-.415-1.074l.4-1.599V8.5a1 1 0 0 1 1-1z"
                }
            }
        ]
    })(props);
}
function BsFillFileEaselFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 6.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM8.5 5h2A1.5 1.5 0 0 1 12 6.5v2a1.5 1.5 0 0 1-1.5 1.5h-.473l.447 1.342a.5.5 0 0 1-.948.316L8.973 10H8.5v1a.5.5 0 0 1-1 0v-1h-.473l-.553 1.658a.5.5 0 1 1-.948-.316L5.973 10H5.5A1.5 1.5 0 0 1 4 8.5v-2A1.5 1.5 0 0 1 5.5 5h2a.5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsFillFileExcelFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM5.884 4.68 8 7.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 8l2.233 2.68a.5.5 0 0 1-.768.64L8 8.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 8 5.116 5.32a.5.5 0 1 1 .768-.64z"
                }
            }
        ]
    })(props);
}
function BsFillFileFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 0h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z"
                }
            }
        ]
    })(props);
}
function BsFillFileFontFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM5.057 4h5.886L11 6h-.5c-.18-1.096-.356-1.192-1.694-1.235l-.298-.01v6.09c0 .47.1.582.903.655v.5H6.59v-.5c.799-.073.898-.184.898-.654V4.755l-.293.01C5.856 4.808 5.68 4.905 5.5 6H5l.057-2z"
                }
            }
        ]
    })(props);
}
function BsFillFileImageFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0h8a2 2 0 0 1 2 2v8.293l-2.73-2.73a1 1 0 0 0-1.52.127l-1.889 2.644-1.769-1.062a1 1 0 0 0-1.222.15L2 12.292V2a2 2 0 0 1 2-2zm4.002 5.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.564 8.27 14 11.708V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-.293l3.578-3.577 2.56 1.536 2.426-3.395z"
                }
            }
        ]
    })(props);
}
function BsFillFileLockFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 6a1 1 0 0 1 2 0v1H7V6zM6 8.3c0-.042.02-.107.105-.175A.637.637 0 0 1 6.5 8h3a.64.64 0 0 1 .395.125c.085.068.105.133.105.175v2.4c0 .042-.02.107-.105.175A.637.637 0 0 1 9.5 11h-3a.637.637 0 0 1-.395-.125C6.02 10.807 6 10.742 6 10.7V8.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm-2 6v1.076c.54.166 1 .597 1 1.224v2.4c0 .816-.781 1.3-1.5 1.3h-3c-.719 0-1.5-.484-1.5-1.3V8.3c0-.627.46-1.058 1-1.224V6a2 2 0 1 1 4 0z"
                }
            }
        ]
    })(props);
}
function BsFillFileLock2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 6a1 1 0 0 1 2 0v1H7V6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm-2 6v1.076c.54.166 1 .597 1 1.224v2.4c0 .816-.781 1.3-1.5 1.3h-3c-.719 0-1.5-.484-1.5-1.3V8.3c0-.627.46-1.058 1-1.224V6a2 2 0 1 1 4 0z"
                }
            }
        ]
    })(props);
}
function BsFillFileMedicalFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM8.5 4.5v.634l.549-.317a.5.5 0 1 1 .5.866L9 6l.549.317a.5.5 0 1 1-.5.866L8.5 6.866V7.5a.5.5 0 0 1-1 0v-.634l-.549.317a.5.5 0 1 1-.5-.866L7 6l-.549-.317a.5.5 0 0 1 .5-.866l.549.317V4.5a.5.5 0 1 1 1 0zM5.5 9h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm0 2h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsFillFileMinusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM6 7.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsFillFileMusicFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm-.5 4.11v1.8l-2.5.5v5.09c0 .495-.301.883-.662 1.123C7.974 12.866 7.499 13 7 13c-.5 0-.974-.134-1.338-.377-.36-.24-.662-.628-.662-1.123s.301-.883.662-1.123C6.026 10.134 6.501 10 7 10c.356 0 .7.068 1 .196V4.41a1 1 0 0 1 .804-.98l1.5-.3a1 1 0 0 1 1.196.98z"
                }
            }
        ]
    })(props);
}
function BsFillFilePdfFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.523 10.424c.14-.082.293-.162.459-.238a7.878 7.878 0 0 1-.45.606c-.28.337-.498.516-.635.572a.266.266 0 0 1-.035.012.282.282 0 0 1-.026-.044c-.056-.11-.054-.216.04-.36.106-.165.319-.354.647-.548zm2.455-1.647c-.119.025-.237.05-.356.078a21.035 21.035 0 0 0 .5-1.05 11.96 11.96 0 0 0 .51.858c-.217.032-.436.07-.654.114zm2.525.939a3.888 3.888 0 0 1-.435-.41c.228.005.434.022.612.054.317.057.466.147.518.209a.095.095 0 0 1 .026.064.436.436 0 0 1-.06.2.307.307 0 0 1-.094.124.107.107 0 0 1-.069.015c-.09-.003-.258-.066-.498-.256zM8.278 4.97c-.04.244-.108.524-.2.829a4.86 4.86 0 0 1-.089-.346c-.076-.353-.087-.63-.046-.822.038-.177.11-.248.196-.283a.517.517 0 0 1 .145-.04c.013.03.028.092.032.198.005.122-.007.277-.038.465z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 0h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm.165 11.668c.09.18.23.343.438.419.207.075.412.04.58-.03.318-.13.635-.436.926-.786.333-.401.683-.927 1.021-1.51a11.64 11.64 0 0 1 1.997-.406c.3.383.61.713.91.95.28.22.603.403.934.417a.856.856 0 0 0 .51-.138c.155-.101.27-.247.354-.416.09-.181.145-.37.138-.563a.844.844 0 0 0-.2-.518c-.226-.27-.596-.4-.96-.465a5.76 5.76 0 0 0-1.335-.05 10.954 10.954 0 0 1-.98-1.686c.25-.66.437-1.284.52-1.794.036-.218.055-.426.048-.614a1.238 1.238 0 0 0-.127-.538.7.7 0 0 0-.477-.365c-.202-.043-.41 0-.601.077-.377.15-.576.47-.651.823-.073.34-.04.736.046 1.136.088.406.238.848.43 1.295a19.707 19.707 0 0 1-1.062 2.227 7.662 7.662 0 0 0-1.482.645c-.37.22-.699.48-.897.787-.21.326-.275.714-.08 1.103z"
                }
            }
        ]
    })(props);
}
function BsFillFilePersonFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm-1 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm-3 4c2.623 0 4.146.826 5 1.755V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-1.245C3.854 11.825 5.377 11 8 11z"
                }
            }
        ]
    })(props);
}
function BsFillFilePlayFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM6 5.883a.5.5 0 0 1 .757-.429l3.528 2.117a.5.5 0 0 1 0 .858l-3.528 2.117a.5.5 0 0 1-.757-.43V5.884z"
                }
            }
        ]
    })(props);
}
function BsFillFilePlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM8.5 6v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsFillFilePostFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM4.5 3h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm0 2h7a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsFillFilePptFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.188 8.5H7V5h1.188a1.75 1.75 0 1 1 0 3.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm3 4a1 1 0 0 0-1 1v6.5a.5.5 0 0 0 1 0v-2h1.188a2.75 2.75 0 0 0 0-5.5H7z"
                }
            }
        ]
    })(props);
}
function BsFillFileRichtextFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM7 4.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm-.861 1.542 1.33.886 1.854-1.855a.25.25 0 0 1 .289-.047l1.888.974V7.5a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V7s1.54-1.274 1.639-1.208zM5 9h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1zm0 2h3a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsFillFileRuledFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v4h12V2a2 2 0 0 0-2-2zm2 7H6v2h8V7zm0 3H6v2h8v-2zm0 3H6v3h6a2 2 0 0 0 2-2v-1zm-9 3v-3H2v1a2 2 0 0 0 2 2h1zm-3-4h3v-2H2v2zm0-3h3V7H2v2z"
                }
            }
        ]
    })(props);
}
function BsFillFileSlidesFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7.78V5.22c0-.096.106-.156.19-.106l2.13 1.279a.125.125 0 0 1 0 .214l-2.13 1.28A.125.125 0 0 1 7 7.778z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM5 4h6a.5.5 0 0 1 .496.438l.5 4A.5.5 0 0 1 11.5 9h-3v2.016c.863.055 1.5.251 1.5.484 0 .276-.895.5-2 .5s-2-.224-2-.5c0-.233.637-.429 1.5-.484V9h-3a.5.5 0 0 1-.496-.562l.5-4A.5.5 0 0 1 5 4z"
                }
            }
        ]
    })(props);
}
function BsFillFileSpreadsheetFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v4h12V2a2 2 0 0 0-2-2zm2 7h-4v2h4V7zm0 3h-4v2h4v-2zm0 3h-4v3h2a2 2 0 0 0 2-2v-1zm-5 3v-3H6v3h3zm-4 0v-3H2v1a2 2 0 0 0 2 2h1zm-3-4h3v-2H2v2zm0-3h3V7H2v2zm4 0V7h3v2H6zm0 1h3v2H6v-2z"
                }
            }
        ]
    })(props);
}
function BsFillFileTextFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM5 4h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zM5 8h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1zm0 2h3a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsFillFileWordFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM5.485 4.879l1.036 4.144.997-3.655a.5.5 0 0 1 .964 0l.997 3.655 1.036-4.144a.5.5 0 0 1 .97.242l-1.5 6a.5.5 0 0 1-.967.01L8 7.402l-1.018 3.73a.5.5 0 0 1-.967-.01l-1.5-6a.5.5 0 1 1 .97-.242z"
                }
            }
        ]
    })(props);
}
function BsFillFileXFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM6.854 6.146 8 7.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 8l1.147 1.146a.5.5 0 0 1-.708.708L8 8.707 6.854 9.854a.5.5 0 0 1-.708-.708L7.293 8 6.146 6.854a.5.5 0 1 1 .708-.708z"
                }
            }
        ]
    })(props);
}
function BsFillFileZipFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 9.438V8.5h-1v.938a1 1 0 0 1-.03.243l-.4 1.598.93.62.93-.62-.4-1.598a1 1 0 0 1-.03-.243z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm2.5 8.5v.938l-.4 1.599a1 1 0 0 0 .416 1.074l.93.62a1 1 0 0 0 1.109 0l.93-.62a1 1 0 0 0 .415-1.074l-.4-1.599V8.5a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1zm1-5.5h-1v1h1v1h-1v1h1v1H9V6H8V5h1V4H8V3h1V2H8V1H6.5v1h1v1z"
                }
            }
        ]
    })(props);
}
function BsFillFilterCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM3.5 5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1zM5 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm2 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsFillFilterSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm.5 5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1zM4 8.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm2 3a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsFillFlagFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12.435 12.435 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A19.626 19.626 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a19.587 19.587 0 0 0 1.349-.476l.019-.007.004-.002h.001"
                }
            }
        ]
    })(props);
}
function BsFillFloppyFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1.5A1.5 1.5 0 0 1 1.5 0H3v5.5A1.5 1.5 0 0 0 4.5 7h7A1.5 1.5 0 0 0 13 5.5V0h.086a1.5 1.5 0 0 1 1.06.44l1.415 1.414A1.5 1.5 0 0 1 16 2.914V14.5a1.5 1.5 0 0 1-1.5 1.5H14v-5.5A1.5 1.5 0 0 0 12.5 9h-9A1.5 1.5 0 0 0 2 10.5V16h-.5A1.5 1.5 0 0 1 0 14.5v-13Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16h10v-5.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5V16Zm9-16H4v5.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V0ZM9 1h2v4H9V1Z"
                }
            }
        ]
    })(props);
}
function BsFillFloppy2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2h-2v3h2V2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 0A1.5 1.5 0 0 0 0 1.5v13A1.5 1.5 0 0 0 1.5 16h13a1.5 1.5 0 0 0 1.5-1.5V2.914a1.5 1.5 0 0 0-.44-1.06L14.147.439A1.5 1.5 0 0 0 13.086 0H1.5ZM4 6a1 1 0 0 1-1-1V1h10v4a1 1 0 0 1-1 1H4ZM3 9h10a1 1 0 0 1 1 1v5H2v-5a1 1 0 0 1 1-1Z"
                }
            }
        ]
    })(props);
}
function BsFillFolderFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.825a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"
                }
            }
        ]
    })(props);
}
function BsFillFolderSymlinkFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2l.04.87a1.99 1.99 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14h10.348a2 2 0 0 0 1.991-1.819l.637-7A2 2 0 0 0 13.81 3zM2.19 3c-.24 0-.47.042-.683.12L1.5 2.98a1 1 0 0 1 1-.98h3.672a1 1 0 0 1 .707.293L7.586 3H2.19zm9.608 5.271-3.182 1.97c-.27.166-.616-.036-.616-.372V9.1s-2.571-.3-4 2.4c.571-4.8 3.143-4.8 4-4.8v-.769c0-.336.346-.538.616-.371l3.182 1.969c.27.166.27.576 0 .742z"
                }
            }
        ]
    })(props);
}
function BsFillForwardFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m9.77 12.11 4.012-2.953a.647.647 0 0 0 0-1.114L9.771 5.09a.644.644 0 0 0-.971.557V6.65H2v3.9h6.8v1.003c0 .505.545.808.97.557z"
                }
            }
        ]
    })(props);
}
function BsFillFuelPumpDieselFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.974 9.806h.692c.306 0 .556.063.75.19.198.127.343.317.437.568.096.252.144.565.144.941 0 .284-.027.53-.083.74-.053.21-.133.386-.241.528a.986.986 0 0 1-.412.315 1.575 1.575 0 0 1-.595.103h-.692V9.806Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v8a2 2 0 0 1 2 2v.5a.5.5 0 0 0 1 0V8h-.5a.5.5 0 0 1-.5-.5V4.375a.5.5 0 0 1 .5-.5h1.495c-.011-.476-.053-.894-.201-1.222a.97.97 0 0 0-.394-.458c-.184-.11-.464-.195-.9-.195a.5.5 0 0 1 0-1c.564 0 1.034.11 1.412.336.383.228.634.551.794.907.295.655.294 1.465.294 2.081V7.5a.5.5 0 0 1-.5.5H15v4.5a1.5 1.5 0 0 1-3 0V12a1 1 0 0 0-1-1v4h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V2Zm2 .5v5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5ZM4 9v5h1.796c.496 0 .906-.099 1.23-.297.327-.197.571-.484.732-.86.161-.377.242-.828.242-1.356 0-.525-.08-.973-.242-1.344a1.775 1.775 0 0 0-.725-.85C6.71 9.098 6.296 9 5.796 9H4Z"
                }
            }
        ]
    })(props);
}
function BsFillFuelPumpFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v8a2 2 0 0 1 2 2v.5a.5.5 0 0 0 1 0V8h-.5a.5.5 0 0 1-.5-.5V4.375a.5.5 0 0 1 .5-.5h1.495c-.011-.476-.053-.894-.201-1.222a.97.97 0 0 0-.394-.458c-.184-.11-.464-.195-.9-.195a.5.5 0 0 1 0-1c.564 0 1.034.11 1.412.336.383.228.634.551.794.907.295.655.294 1.465.294 2.081V7.5a.5.5 0 0 1-.5.5H15v4.5a1.5 1.5 0 0 1-3 0V12a1 1 0 0 0-1-1v4h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V2Zm2.5 0a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-5Z"
                }
            }
        ]
    })(props);
}
function BsFillFunnelFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z"
                }
            }
        ]
    })(props);
}
function BsFillGearFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z"
                }
            }
        ]
    })(props);
}
function BsFillGeoAltFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
                }
            }
        ]
    })(props);
}
function BsFillGeoFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999zm2.493 8.574a.5.5 0 0 1-.411.575c-.712.118-1.28.295-1.655.493a1.319 1.319 0 0 0-.37.265.301.301 0 0 0-.057.09V14l.002.008a.147.147 0 0 0 .016.033.617.617 0 0 0 .145.15c.165.13.435.27.813.395.751.25 1.82.414 3.024.414s2.273-.163 3.024-.414c.378-.126.648-.265.813-.395a.619.619 0 0 0 .146-.15.148.148 0 0 0 .015-.033L12 14v-.004a.301.301 0 0 0-.057-.09 1.318 1.318 0 0 0-.37-.264c-.376-.198-.943-.375-1.655-.493a.5.5 0 1 1 .164-.986c.77.127 1.452.328 1.957.594C12.5 13 13 13.4 13 14c0 .426-.26.752-.544.977-.29.228-.68.413-1.116.558-.878.293-2.059.465-3.34.465-1.281 0-2.462-.172-3.34-.465-.436-.145-.826-.33-1.116-.558C3.26 14.752 3 14.426 3 14c0-.599.5-1 .961-1.243.505-.266 1.187-.467 1.957-.594a.5.5 0 0 1 .575.411z"
                }
            }
        ]
    })(props);
}
function BsFillGiftFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2.5a2.5 2.5 0 0 1 5 0 2.5 2.5 0 0 1 5 0v.006c0 .07 0 .27-.038.494H15a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h2.038A2.968 2.968 0 0 1 3 2.506V2.5zm1.068.5H7v-.5a1.5 1.5 0 1 0-3 0c0 .085.002.274.045.43a.522.522 0 0 0 .023.07zM9 3h2.932a.56.56 0 0 0 .023-.07c.043-.156.045-.345.045-.43a1.5 1.5 0 0 0-3 0V3zm6 4v7.5a1.5 1.5 0 0 1-1.5 1.5H9V7h6zM2.5 16A1.5 1.5 0 0 1 1 14.5V7h6v9H2.5z"
                }
            }
        ]
    })(props);
}
function BsFillGrid1X2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1zm9 0a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1V1zm0 9a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-5z"
                }
            }
        ]
    })(props);
}
function BsFillGrid3X2GapFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V4zM1 9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V9zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V9zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V9z"
                }
            }
        ]
    })(props);
}
function BsFillGrid3X3GapFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2zM1 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V7zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V7zM1 12a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2z"
                }
            }
        ]
    })(props);
}
function BsFillGridFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3z"
                }
            }
        ]
    })(props);
}
function BsFillHCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-5-3.998H9.67v3.322H6.33V4.002H5V12h1.33V8.455h3.34V12H11V4.002Z"
                }
            }
        ]
    })(props);
}
function BsFillHSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm9 4.002V12H9.67V8.455H6.33V12H5V4.002h1.33v3.322h3.34V4.002H11Z"
                }
            }
        ]
    })(props);
}
function BsFillHandIndexFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 4.466V1.75a1.75 1.75 0 1 0-3.5 0v5.34l-1.2.24a1.5 1.5 0 0 0-1.196 1.636l.345 3.106a2.5 2.5 0 0 0 .405 1.11l1.433 2.15A1.5 1.5 0 0 0 6.035 16h6.385a1.5 1.5 0 0 0 1.302-.756l1.395-2.441a3.5 3.5 0 0 0 .444-1.389l.271-2.715a2 2 0 0 0-1.99-2.199h-.581a5.114 5.114 0 0 0-.195-.248c-.191-.229-.51-.568-.88-.716-.364-.146-.846-.132-1.158-.108l-.132.012a1.26 1.26 0 0 0-.56-.642 2.632 2.632 0 0 0-.738-.288c-.31-.062-.739-.058-1.05-.046l-.048.002z"
                }
            }
        ]
    })(props);
}
function BsFillHandIndexThumbFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 1.75v2.716l.047-.002c.312-.012.742-.016 1.051.046.28.056.543.18.738.288.273.152.456.385.56.642l.132-.012c.312-.024.794-.038 1.158.108.37.148.689.487.88.716.075.09.141.175.195.248h.582a2 2 0 0 1 1.99 2.199l-.272 2.715a3.5 3.5 0 0 1-.444 1.389l-1.395 2.441A1.5 1.5 0 0 1 12.42 16H6.118a1.5 1.5 0 0 1-1.342-.83l-1.215-2.43L1.07 8.589a1.517 1.517 0 0 1 2.373-1.852L5 8.293V1.75a1.75 1.75 0 0 1 3.5 0z"
                }
            }
        ]
    })(props);
}
function BsFillHandThumbsDownFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.956 14.534c.065.936.952 1.659 1.908 1.42l.261-.065a1.378 1.378 0 0 0 1.012-.965c.22-.816.533-2.512.062-4.51.136.02.285.037.443.051.713.065 1.669.071 2.516-.211.518-.173.994-.68 1.2-1.272a1.896 1.896 0 0 0-.234-1.734c.058-.118.103-.242.138-.362.077-.27.113-.568.113-.856 0-.29-.036-.586-.113-.857a2.094 2.094 0 0 0-.16-.403c.169-.387.107-.82-.003-1.149a3.162 3.162 0 0 0-.488-.9c.054-.153.076-.313.076-.465a1.86 1.86 0 0 0-.253-.912C13.1.757 12.437.28 11.5.28H8c-.605 0-1.07.08-1.466.217a4.823 4.823 0 0 0-.97.485l-.048.029c-.504.308-.999.61-2.068.723C2.682 1.815 2 2.434 2 3.279v4c0 .851.685 1.433 1.357 1.616.849.232 1.574.787 2.132 1.41.56.626.914 1.28 1.039 1.638.199.575.356 1.54.428 2.591z"
                }
            }
        ]
    })(props);
}
function BsFillHandThumbsUpFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.956 1.745C7.021.81 7.908.087 8.864.325l.261.066c.463.116.874.456 1.012.965.22.816.533 2.511.062 4.51a9.84 9.84 0 0 1 .443-.051c.713-.065 1.669-.072 2.516.21.518.173.994.681 1.2 1.273.184.532.16 1.162-.234 1.733.058.119.103.242.138.363.077.27.113.567.113.856 0 .289-.036.586-.113.856-.039.135-.09.273-.16.404.169.387.107.819-.003 1.148a3.163 3.163 0 0 1-.488.901c.054.152.076.312.076.465 0 .305-.089.625-.253.912C13.1 15.522 12.437 16 11.5 16H8c-.605 0-1.07-.081-1.466-.218a4.82 4.82 0 0 1-.97-.484l-.048-.03c-.504-.307-.999-.609-2.068-.722C2.682 14.464 2 13.846 2 13V9c0-.85.685-1.432 1.357-1.615.849-.232 1.574-.787 2.132-1.41.56-.627.914-1.28 1.039-1.639.199-.575.356-1.539.428-2.59z"
                }
            }
        ]
    })(props);
}
function BsFillHandbagFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1a2 2 0 0 0-2 2v2H5V3a3 3 0 1 1 6 0v2h-1V3a2 2 0 0 0-2-2zM5 5H3.36a1.5 1.5 0 0 0-1.483 1.277L.85 13.13A2.5 2.5 0 0 0 3.322 16h9.355a2.5 2.5 0 0 0 2.473-2.87l-1.028-6.853A1.5 1.5 0 0 0 12.64 5H11v1.5a.5.5 0 0 1-1 0V5H6v1.5a.5.5 0 0 1-1 0V5z"
                }
            }
        ]
    })(props);
}
function BsFillHddFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 10a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-1zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm2 0a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM.91 7.204A2.993 2.993 0 0 1 2 7h12c.384 0 .752.072 1.09.204l-1.867-3.422A1.5 1.5 0 0 0 11.906 3H4.094a1.5 1.5 0 0 0-1.317.782L.91 7.204z"
                }
            }
        ]
    })(props);
}
function BsFillHddNetworkFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h5.5v3A1.5 1.5 0 0 0 6 11.5H.5a.5.5 0 0 0 0 1H6A1.5 1.5 0 0 0 7.5 14h1a1.5 1.5 0 0 0 1.5-1.5h5.5a.5.5 0 0 0 0-1H10A1.5 1.5 0 0 0 8.5 10V7H14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm.5 3a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1z"
                }
            }
        ]
    })(props);
}
function BsFillHddRackFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h1v2H2a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2h-1V7h1a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm.5 3a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm-2 7a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zM12 7v2H4V7h8z"
                }
            }
        ]
    })(props);
}
function BsFillHddStackFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2H2zm.5 3a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zM2 2a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm.5 3a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1z"
                }
            }
        ]
    })(props);
}
function BsFillHdmiFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5a1 1 0 0 0-1 1v3.293c0 .39.317.707.707.707.188 0 .368.075.5.207l.5.5a1 1 0 0 0 .707.293h11.172a1 1 0 0 0 .707-.293l.5-.5a.707.707 0 0 1 .5-.207c.39 0 .707-.317.707-.707V6a1 1 0 0 0-1-1H1Zm1.5 2h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1Z"
                }
            }
        ]
    })(props);
}
function BsFillHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"
                }
            }
        ]
    })(props);
}
function BsFillHeartPulseFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.475 9C2.702 10.84 4.779 12.871 8 15c3.221-2.129 5.298-4.16 6.525-6H12a.5.5 0 0 1-.464-.314l-1.457-3.642-1.598 5.593a.5.5 0 0 1-.945.049L5.889 6.568l-1.473 2.21A.5.5 0 0 1 4 9H1.475Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M.88 8C-2.427 1.68 4.41-2 7.823 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C11.59-2 18.426 1.68 15.12 8h-2.783l-1.874-4.686a.5.5 0 0 0-.945.049L7.921 8.956 6.464 5.314a.5.5 0 0 0-.88-.091L3.732 8H.88Z"
                }
            }
        ]
    })(props);
}
function BsFillHeartbreakFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.931.586 7 3l1.5 4-2 3L8 15C22.534 5.396 13.757-2.21 8.931.586ZM7.358.77 5.5 3 7 7l-1.5 3 1.815 4.537C-6.533 4.96 2.685-2.467 7.358.77Z"
                }
            }
        ]
    })(props);
}
function BsFillHeptagonFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.779.052a.5.5 0 0 1 .442 0l6.015 2.97a.5.5 0 0 1 .267.34l1.485 6.676a.5.5 0 0 1-.093.415l-4.162 5.354a.5.5 0 0 1-.395.193H4.662a.5.5 0 0 1-.395-.193L.105 10.453a.5.5 0 0 1-.093-.415l1.485-6.676a.5.5 0 0 1 .267-.34L7.779.053z"
                }
            }
        ]
    })(props);
}
function BsFillHexagonFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.5.134a1 1 0 0 0-1 0l-6 3.577a1 1 0 0 0-.5.866v6.846a1 1 0 0 0 .5.866l6 3.577a1 1 0 0 0 1 0l6-3.577a1 1 0 0 0 .5-.866V4.577a1 1 0 0 0-.5-.866L8.5.134z"
                }
            }
        ]
    })(props);
}
function BsFillHospitalFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 0a1 1 0 0 0-1 1v1a1 1 0 0 0-1 1v4H1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h6v-2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V16h6a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-3V3a1 1 0 0 0-1-1V1a1 1 0 0 0-1-1H6Zm2.5 5.034v1.1l.953-.55.5.867L9 7l.953.55-.5.866-.953-.55v1.1h-1v-1.1l-.953.55-.5-.866L7 7l-.953-.55.5-.866.953.55v-1.1h1ZM2.25 9h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 2 9.75v-.5A.25.25 0 0 1 2.25 9Zm0 2h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5a.25.25 0 0 1 .25-.25ZM2 13.25a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5ZM13.25 9h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5a.25.25 0 0 1 .25-.25ZM13 11.25a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5Zm.25 1.75h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5a.25.25 0 0 1 .25-.25Z"
                }
            }
        ]
    })(props);
}
function BsFillHouseAddFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 1 1-1 0v-1h-1a.5.5 0 1 1 0-1h1v-1a.5.5 0 0 1 1 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 3.293 4.712 4.712A4.5 4.5 0 0 0 8.758 15H3.5A1.5 1.5 0 0 1 2 13.5V9.293l6-6Z"
                }
            }
        ]
    })(props);
}
function BsFillHouseCheckFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 3.293 4.712 4.712A4.5 4.5 0 0 0 8.758 15H3.5A1.5 1.5 0 0 1 2 13.5V9.293l6-6Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.707l.547.547 1.17-1.951a.5.5 0 1 1 .858.514Z"
                }
            }
        ]
    })(props);
}
function BsFillHouseDashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 3.293 4.712 4.712A4.5 4.5 0 0 0 8.758 15H3.5A1.5 1.5 0 0 1 2 13.5V9.293l6-6Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM11 12h3a.5.5 0 0 1 0 1h-3a.5.5 0 1 1 0-1Z"
                }
            }
        ]
    })(props);
}
function BsFillHouseDoorFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 14.5v-3.505c0-.245.25-.495.5-.495h2c.25 0 .5.25.5.5v3.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5Z"
                }
            }
        ]
    })(props);
}
function BsFillHouseDownFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 9a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm.354 5.854 1.5-1.5a.5.5 0 0 0-.708-.707l-.646.646V10.5a.5.5 0 0 0-1 0v2.793l-.646-.646a.5.5 0 0 0-.708.707l1.5 1.5a.5.5 0 0 0 .708 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 3.293 4.712 4.712A4.5 4.5 0 0 0 8.758 15H3.5A1.5 1.5 0 0 1 2 13.5V9.293l6-6Z"
                }
            }
        ]
    })(props);
}
function BsFillHouseExclamationFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 3.293 4.712 4.712A4.5 4.5 0 0 0 8.758 15H3.5A1.5 1.5 0 0 1 2 13.5V9.293l6-6Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-3.5-2a.5.5 0 0 0-.5.5v1.5a.5.5 0 1 0 1 0V11a.5.5 0 0 0-.5-.5Zm0 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
                }
            }
        ]
    })(props);
}
function BsFillHouseFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6Z"
                }
            }
        ]
    })(props);
}
function BsFillHouseGearFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.293 1.5a1 1 0 0 1 1.414 0L11 3.793V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v3.293l2.354 2.353a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.07 9.047a1.5 1.5 0 0 0-1.742.26l-.02.021a1.5 1.5 0 0 0-.261 1.742 1.5 1.5 0 0 0 0 2.86 1.504 1.504 0 0 0-.12 1.07H3.5A1.5 1.5 0 0 1 2 13.5V9.293l6-6 4.724 4.724a1.5 1.5 0 0 0-1.654 1.03Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13.158 9.608-.043-.148c-.181-.613-1.049-.613-1.23 0l-.043.148a.64.64 0 0 1-.921.382l-.136-.074c-.561-.306-1.175.308-.87.869l.075.136a.64.64 0 0 1-.382.92l-.148.045c-.613.18-.613 1.048 0 1.229l.148.043a.64.64 0 0 1 .382.921l-.074.136c-.306.561.308 1.175.869.87l.136-.075a.64.64 0 0 1 .92.382l.045.149c.18.612 1.048.612 1.229 0l.043-.15a.64.64 0 0 1 .921-.38l.136.074c.561.305 1.175-.309.87-.87l-.075-.136a.64.64 0 0 1 .382-.92l.149-.044c.612-.181.612-1.049 0-1.23l-.15-.043a.64.64 0 0 1-.38-.921l.074-.136c.305-.561-.309-1.175-.87-.87l-.136.075a.64.64 0 0 1-.92-.382ZM12.5 14a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"
                }
            }
        ]
    })(props);
}
function BsFillHouseHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.293 1.5a1 1 0 0 1 1.414 0L11 3.793V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v3.293l2.354 2.353a.5.5 0 0 1-.708.707L8 2.207 1.354 8.853a.5.5 0 1 1-.708-.707L7.293 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 9.293-6-6-6 6V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V9.293Zm-6-.811c1.664-1.673 5.825 1.254 0 5.018-5.825-3.764-1.664-6.691 0-5.018Z"
                }
            }
        ]
    })(props);
}
function BsFillHouseLockFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 3.293 4.72 4.72a3 3 0 0 0-2.709 3.248A2 2 0 0 0 9 13v2H3.5A1.5 1.5 0 0 1 2 13.5V9.293l6-6Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9a2 2 0 0 0-2 2v1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1v-1a2 2 0 0 0-2-2Zm0 1a1 1 0 0 1 1 1v1h-2v-1a1 1 0 0 1 1-1Z"
                }
            }
        ]
    })(props);
}
function BsFillHouseSlashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 3.293 4.712 4.712A4.5 4.5 0 0 0 8.758 15H3.5A1.5 1.5 0 0 1 2 13.5V9.293l6-6Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.879 10.414a2.5 2.5 0 0 0-3.465 3.465l3.465-3.465Zm.707.707-3.465 3.465a2.501 2.501 0 0 0 3.465-3.465Zm-4.56-1.096a3.5 3.5 0 1 1 4.949 4.95 3.5 3.5 0 0 1-4.95-4.95Z"
                }
            }
        ]
    })(props);
}
function BsFillHouseUpFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.354-5.854 1.5 1.5a.5.5 0 0 1-.708.708L13 11.707V14.5a.5.5 0 1 1-1 0v-2.793l-.646.647a.5.5 0 0 1-.708-.707l1.5-1.5a.5.5 0 0 1 .708 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 3.293 4.712 4.712A4.5 4.5 0 0 0 8.758 15H3.5A1.5 1.5 0 0 1 2 13.5V9.293l6-6Z"
                }
            }
        ]
    })(props);
}
function BsFillHouseXFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 3.293 4.712 4.712A4.5 4.5 0 0 0 8.758 15H3.5A1.5 1.5 0 0 1 2 13.5V9.293l6-6Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-.646-4.854.646.647.646-.646a.5.5 0 0 1 .708.707l-.647.646.647.646a.5.5 0 0 1-.708.708l-.646-.647-.646.647a.5.5 0 0 1-.708-.707l.647-.647-.647-.646a.5.5 0 0 1 .708-.707Z"
                }
            }
        ]
    })(props);
}
function BsFillHousesFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.207 1a1 1 0 0 0-1.414 0L.146 6.646a.5.5 0 0 0 .708.708L1 7.207V12.5A1.5 1.5 0 0 0 2.5 14h.55a2.51 2.51 0 0 1-.05-.5V9.415a1.5 1.5 0 0 1-.56-2.475l5.353-5.354L7.207 1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.793 2a1 1 0 0 1 1.414 0L12 3.793V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v3.293l1.854 1.853a.5.5 0 0 1-.708.708L15 8.207V13.5a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 4 13.5V8.207l-.146.147a.5.5 0 1 1-.708-.708L8.793 2Z"
                }
            }
        ]
    })(props);
}
function BsFillImageFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.002 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-12a2 2 0 0 1-2-2V3zm1 9v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12zm5-6.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z"
                }
            }
        ]
    })(props);
}
function BsFillInboxFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.98 4a.5.5 0 0 0-.39.188L1.54 8H6a.5.5 0 0 1 .5.5 1.5 1.5 0 1 0 3 0A.5.5 0 0 1 10 8h4.46l-3.05-3.812A.5.5 0 0 0 11.02 4H4.98zm-1.17-.437A1.5 1.5 0 0 1 4.98 3h6.04a1.5 1.5 0 0 1 1.17.563l3.7 4.625a.5.5 0 0 1 .106.374l-.39 3.124A1.5 1.5 0 0 1 14.117 13H1.883a1.5 1.5 0 0 1-1.489-1.314l-.39-3.124a.5.5 0 0 1 .106-.374l3.7-4.625z"
                }
            }
        ]
    })(props);
}
function BsFillInboxesFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.98 1a.5.5 0 0 0-.39.188L1.54 5H6a.5.5 0 0 1 .5.5 1.5 1.5 0 0 0 3 0A.5.5 0 0 1 10 5h4.46l-3.05-3.812A.5.5 0 0 0 11.02 1H4.98zM3.81.563A1.5 1.5 0 0 1 4.98 0h6.04a1.5 1.5 0 0 1 1.17.563l3.7 4.625a.5.5 0 0 1 .106.374l-.39 3.124A1.5 1.5 0 0 1 14.117 10H1.883A1.5 1.5 0 0 1 .394 8.686l-.39-3.124a.5.5 0 0 1 .106-.374L3.81.563zM.125 11.17A.5.5 0 0 1 .5 11H6a.5.5 0 0 1 .5.5 1.5 1.5 0 0 0 3 0 .5.5 0 0 1 .5-.5h5.5a.5.5 0 0 1 .496.562l-.39 3.124A1.5 1.5 0 0 1 14.117 16H1.883a1.5 1.5 0 0 1-1.489-1.314l-.39-3.124a.5.5 0 0 1 .121-.393z"
                }
            }
        ]
    })(props);
}
function BsFillInfoCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                }
            }
        ]
    })(props);
}
function BsFillInfoSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.93 4.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                }
            }
        ]
    })(props);
}
function BsFillJournalBookmarkFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 1h6v7a.5.5 0 0 1-.757.429L9 7.083 6.757 8.43A.5.5 0 0 1 6 8V1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"
                }
            }
        ]
    })(props);
}
function BsFillKanbanFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2h-11zm5 2h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm-5 1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V3zm9-1h1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z"
                }
            }
        ]
    })(props);
}
function BsFillKeyFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 11.5a3.5 3.5 0 1 1 3.163-5H14L15.5 8 14 9.5l-1-1-1 1-1-1-1 1-1-1-1 1H6.663a3.5 3.5 0 0 1-3.163 2zM2.5 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                }
            }
        ]
    })(props);
}
function BsFillKeyboardFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6zm13 .25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-.5a.25.25 0 0 0-.25.25zM2.25 8a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5A.25.25 0 0 0 3 8.75v-.5A.25.25 0 0 0 2.75 8h-.5zM4 8.25v.5c0 .138.112.25.25.25h.5A.25.25 0 0 0 5 8.75v-.5A.25.25 0 0 0 4.75 8h-.5a.25.25 0 0 0-.25.25zM6.25 8a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5A.25.25 0 0 0 7 8.75v-.5A.25.25 0 0 0 6.75 8h-.5zM8 8.25v.5c0 .138.112.25.25.25h.5A.25.25 0 0 0 9 8.75v-.5A.25.25 0 0 0 8.75 8h-.5a.25.25 0 0 0-.25.25zM13.25 8a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-.5zm0 2a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-.5zm-3-2a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h1.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-1.5zm.75 2.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-.5a.25.25 0 0 0-.25.25zM11.25 6a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-.5zM9 6.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5A.25.25 0 0 0 9.75 6h-.5a.25.25 0 0 0-.25.25zM7.25 6a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5A.25.25 0 0 0 8 6.75v-.5A.25.25 0 0 0 7.75 6h-.5zM5 6.25v.5c0 .138.112.25.25.25h.5A.25.25 0 0 0 6 6.75v-.5A.25.25 0 0 0 5.75 6h-.5a.25.25 0 0 0-.25.25zM2.25 6a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h1.5A.25.25 0 0 0 4 6.75v-.5A.25.25 0 0 0 3.75 6h-1.5zM2 10.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-.5a.25.25 0 0 0-.25.25zM4.25 10a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h5.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-5.5z"
                }
            }
        ]
    })(props);
}
function BsFillLampFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.04.303A.5.5 0 0 1 5.5 0h5c.2 0 .38.12.46.303l3 7a.5.5 0 0 1-.363.687h-.002c-.15.03-.3.056-.45.081a32.731 32.731 0 0 1-4.645.425V13.5a.5.5 0 1 1-1 0V8.495a32.753 32.753 0 0 1-4.645-.425c-.15-.025-.3-.05-.45-.08h-.003a.5.5 0 0 1-.362-.688l3-7Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.493 12.574a.5.5 0 0 1-.411.575c-.712.118-1.28.295-1.655.493a1.319 1.319 0 0 0-.37.265.301.301 0 0 0-.052.075l-.001.004-.004.01V14l.002.008a.147.147 0 0 0 .016.033.62.62 0 0 0 .145.15c.165.13.435.27.813.395.751.25 1.82.414 3.024.414s2.273-.163 3.024-.414c.378-.126.648-.265.813-.395a.62.62 0 0 0 .146-.15.148.148 0 0 0 .015-.033L12 14v-.004a.301.301 0 0 0-.057-.09 1.318 1.318 0 0 0-.37-.264c-.376-.198-.943-.375-1.655-.493a.5.5 0 1 1 .164-.986c.77.127 1.452.328 1.957.594C12.5 13 13 13.4 13 14c0 .426-.26.752-.544.977-.29.228-.68.413-1.116.558-.878.293-2.059.465-3.34.465-1.281 0-2.462-.172-3.34-.465-.436-.145-.826-.33-1.116-.558C3.26 14.752 3 14.426 3 14c0-.599.5-1 .961-1.243.505-.266 1.187-.467 1.957-.594a.5.5 0 0 1 .575.411Z"
                }
            }
        ]
    })(props);
}
function BsFillLaptopFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 2A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z"
                }
            }
        ]
    })(props);
}
function BsFillLayersFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.765 1.559a.5.5 0 0 1 .47 0l7.5 4a.5.5 0 0 1 0 .882l-7.5 4a.5.5 0 0 1-.47 0l-7.5-4a.5.5 0 0 1 0-.882l7.5-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2.125 8.567-1.86.992a.5.5 0 0 0 0 .882l7.5 4a.5.5 0 0 0 .47 0l7.5-4a.5.5 0 0 0 0-.882l-1.86-.992-5.17 2.756a1.5 1.5 0 0 1-1.41 0l-5.17-2.756z"
                }
            }
        ]
    })(props);
}
function BsFillLightbulbFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm3 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsFillLightbulbOffFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6c0-.572.08-1.125.23-1.65l8.558 8.559A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm10.303 4.181L3.818 1.697a6 6 0 0 1 8.484 8.484zM5 14.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1-.5-.5zM2.354 1.646a.5.5 0 1 0-.708.708l12 12a.5.5 0 0 0 .708-.708l-12-12z"
                }
            }
        ]
    })(props);
}
function BsFillLightningChargeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.251.068a.5.5 0 0 1 .227.58L9.677 6.5H13a.5.5 0 0 1 .364.843l-8 8.5a.5.5 0 0 1-.842-.49L6.323 9.5H3a.5.5 0 0 1-.364-.843l8-8.5a.5.5 0 0 1 .615-.09z"
                }
            }
        ]
    })(props);
}
function BsFillLightningFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.52.359A.5.5 0 0 1 6 0h4a.5.5 0 0 1 .474.658L8.694 6H12.5a.5.5 0 0 1 .395.807l-7 9a.5.5 0 0 1-.873-.454L6.823 9.5H3.5a.5.5 0 0 1-.48-.641l2.5-8.5z"
                }
            }
        ]
    })(props);
}
function BsFillLockFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"
                }
            }
        ]
    })(props);
}
function BsFillLuggageFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V5h.5A1.5 1.5 0 0 1 8 6.5V7H7v-.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5H4v1H2.5v.25a.75.75 0 0 1-1.5 0v-.335A1.5 1.5 0 0 1 0 13.5v-7A1.5 1.5 0 0 1 1.5 5H2V1.5ZM3 5h2V2H3v3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 7a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 .5-.5Zm10 1v-.5A1.5 1.5 0 0 0 11 6h-1a1.5 1.5 0 0 0-1.5 1.5V8H8v8h5V8h-.5ZM10 7h1a.5.5 0 0 1 .5.5V8h-2v-.5A.5.5 0 0 1 10 7ZM5 9.5A1.5 1.5 0 0 1 6.5 8H7v8h-.5A1.5 1.5 0 0 1 5 14.5v-5Zm9 6.5V8h.5A1.5 1.5 0 0 1 16 9.5v5a1.5 1.5 0 0 1-1.5 1.5H14Z"
                }
            }
        ]
    })(props);
}
function BsFillLungsFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1a.5.5 0 0 1 .5.5v5.243L9 7.1V4.72C9 3.77 9.77 3 10.72 3c.524 0 1.023.27 1.443.592.431.332.847.773 1.216 1.229.736.908 1.347 1.946 1.58 2.48.176.405.393 1.16.556 2.011.165.857.283 1.857.24 2.759-.04.867-.232 1.79-.837 2.33-.67.6-1.622.556-2.741-.004l-1.795-.897A2.5 2.5 0 0 1 9 11.264V8.329l-1-.715-1 .715V7.214c-.1 0-.202.03-.29.093l-2.5 1.786a.5.5 0 1 0 .58.814L7 8.329v2.935A2.5 2.5 0 0 1 5.618 13.5l-1.795.897c-1.12.56-2.07.603-2.741.004-.605-.54-.798-1.463-.838-2.33-.042-.902.076-1.902.24-2.759.164-.852.38-1.606.558-2.012.232-.533.843-1.571 1.579-2.479.37-.456.785-.897 1.216-1.229C4.257 3.27 4.756 3 5.28 3 6.23 3 7 3.77 7 4.72V7.1l.5-.357V1.5A.5.5 0 0 1 8 1Zm3.21 8.907a.5.5 0 1 0 .58-.814l-2.5-1.786A.498.498 0 0 0 9 7.214V8.33l2.21 1.578Z"
                }
            }
        ]
    })(props);
}
function BsFillMagnetFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 12h-4v3h4v-3ZM5 12H1v3h4v-3ZM0 8a8 8 0 1 1 16 0v8h-6V8a2 2 0 1 0-4 0v8H0V8Z"
                }
            }
        ]
    })(props);
}
function BsFillMapFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M16 .5a.5.5 0 0 0-.598-.49L10.5.99 5.598.01a.5.5 0 0 0-.196 0l-5 1A.5.5 0 0 0 0 1.5v14a.5.5 0 0 0 .598.49l4.902-.98 4.902.98a.502.502 0 0 0 .196 0l5-1A.5.5 0 0 0 16 14.5V.5zM5 14.09V1.11l.5-.1.5.1v12.98l-.402-.08a.498.498 0 0 0-.196 0L5 14.09zm5 .8V1.91l.402.08a.5.5 0 0 0 .196 0L11 1.91v12.98l-.5.1-.5-.1z"
                }
            }
        ]
    })(props);
}
function BsFillMarkdownFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm11.5 1a.5.5 0 0 0-.5.5v3.793L9.854 8.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L12 9.293V5.5a.5.5 0 0 0-.5-.5zM3.56 7.01h.056l1.428 3.239h.774l1.42-3.24h.056V11h1.073V5.001h-1.2l-1.71 3.894h-.039l-1.71-3.894H2.5V11h1.06V7.01z"
                }
            }
        ]
    })(props);
}
function BsFillMegaphoneFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 2.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0v-11zm-1 .724c-2.067.95-4.539 1.481-7 1.656v6.237a25.222 25.222 0 0 1 1.088.085c2.053.204 4.038.668 5.912 1.56V3.224zm-8 7.841V4.934c-.68.027-1.399.043-2.008.053A2.02 2.02 0 0 0 0 7v2c0 1.106.896 1.996 1.994 2.009a68.14 68.14 0 0 1 .496.008 64 64 0 0 1 1.51.048zm1.39 1.081c.285.021.569.047.85.078l.253 1.69a1 1 0 0 1-.983 1.187h-.548a1 1 0 0 1-.916-.599l-1.314-2.48a65.81 65.81 0 0 1 1.692.064c.327.017.65.037.966.06z"
                }
            }
        ]
    })(props);
}
function BsFillMenuAppFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1.5A1.5 1.5 0 0 1 1.5 0h2A1.5 1.5 0 0 1 5 1.5v2A1.5 1.5 0 0 1 3.5 5h-2A1.5 1.5 0 0 1 0 3.5v-2zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2H1zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2h14zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsFillMenuButtonFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 0A1.5 1.5 0 0 0 0 1.5v2A1.5 1.5 0 0 0 1.5 5h8A1.5 1.5 0 0 0 11 3.5v-2A1.5 1.5 0 0 0 9.5 0h-8zm5.927 2.427A.25.25 0 0 1 7.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0l-.396-.396zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2H1zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2h14zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsFillMenuButtonWideFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 0A1.5 1.5 0 0 0 0 1.5v2A1.5 1.5 0 0 0 1.5 5h13A1.5 1.5 0 0 0 16 3.5v-2A1.5 1.5 0 0 0 14.5 0h-13zm1 2h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zm9.927.427A.25.25 0 0 1 12.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0l-.396-.396zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2H1zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2h14zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsFillMicFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3a3 3 0 0 1 6 0v5a3 3 0 0 1-6 0V3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 6.5A.5.5 0 0 1 4 7v1a4 4 0 0 0 8 0V7a.5.5 0 0 1 1 0v1a5 5 0 0 1-4.5 4.975V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsFillMicMuteFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8c0 .564-.094 1.107-.266 1.613l-.814-.814A4.02 4.02 0 0 0 12 8V7a.5.5 0 0 1 1 0v1zm-5 4c.818 0 1.578-.245 2.212-.667l.718.719a4.973 4.973 0 0 1-2.43.923V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 1 0v1a4 4 0 0 0 4 4zm3-9v4.879L5.158 2.037A3.001 3.001 0 0 1 11 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.486 10.607 5 6.12V8a3 3 0 0 0 4.486 2.607zm-7.84-9.253 12 12 .708-.708-12-12-.708.708z"
                }
            }
        ]
    })(props);
}
function BsFillModemFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 0a1.5 1.5 0 0 0-1.5 1.5v11a1.5 1.5 0 0 0 1.404 1.497c-.35.305-.872.678-1.628 1.056A.5.5 0 0 0 5.5 16h5a.5.5 0 0 0 .224-.947c-.756-.378-1.278-.75-1.628-1.056A1.5 1.5 0 0 0 10.5 12.5v-11A1.5 1.5 0 0 0 9 0H7Zm1 3a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm0 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm.5 1.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM8 9a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
                }
            }
        ]
    })(props);
}
function BsFillMoonFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278z"
                }
            }
        ]
    })(props);
}
function BsFillMoonStarsFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.794 3.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387a1.734 1.734 0 0 0-1.097 1.097l-.387 1.162a.217.217 0 0 1-.412 0l-.387-1.162A1.734 1.734 0 0 0 9.31 6.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387a1.734 1.734 0 0 0 1.097-1.097l.387-1.162zM13.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.156 1.156 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.156 1.156 0 0 0-.732-.732l-.774-.258a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732L13.863.1z"
                }
            }
        ]
    })(props);
}
function BsFillMortarboardFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.211 2.047a.5.5 0 0 0-.422 0l-7.5 3.5a.5.5 0 0 0 .025.917l7.5 3a.5.5 0 0 0 .372 0L14 7.14V13a1 1 0 0 0-1 1v2h3v-2a1 1 0 0 0-1-1V6.739l.686-.275a.5.5 0 0 0 .025-.917l-7.5-3.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.176 9.032a.5.5 0 0 0-.656.327l-.5 1.7a.5.5 0 0 0 .294.605l4.5 1.8a.5.5 0 0 0 .372 0l4.5-1.8a.5.5 0 0 0 .294-.605l-.5-1.7a.5.5 0 0 0-.656-.327L8 10.466 4.176 9.032Z"
                }
            }
        ]
    })(props);
}
function BsFillMotherboardFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 7h3V4H5v3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 2a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2H.5a.5.5 0 0 1-.5-.5v-1A.5.5 0 0 1 .5 9H1V8H.5a.5.5 0 0 1-.5-.5v-1A.5.5 0 0 1 .5 6H1V5H.5a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 .5 2H1Zm11 .5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7Zm2 0a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7ZM3.5 10a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6Zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6ZM4 4h-.5a.5.5 0 0 0 0 1H4v1h-.5a.5.5 0 0 0 0 1H4a1 1 0 0 0 1 1v.5a.5.5 0 0 0 1 0V8h1v.5a.5.5 0 0 0 1 0V8a1 1 0 0 0 1-1h.5a.5.5 0 0 0 0-1H9V5h.5a.5.5 0 0 0 0-1H9a1 1 0 0 0-1-1v-.5a.5.5 0 0 0-1 0V3H6v-.5a.5.5 0 0 0-1 0V3a1 1 0 0 0-1 1Zm7 7.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5Z"
                }
            }
        ]
    })(props);
}
function BsFillMouseFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5a5 5 0 0 1 10 0v6a5 5 0 0 1-10 0V5zm5.5-1.5a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0v-2z"
                }
            }
        ]
    })(props);
}
function BsFillMouse2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5.026C4.958.286 3 2.515 3 5.188V5.5h4.5V.026zm1 0V5.5H13v-.312C13 2.515 11.042.286 8.5.026zM13 6.5H3v4.313C3 13.658 5.22 16 8 16s5-2.342 5-5.188V6.5z"
                }
            }
        ]
    })(props);
}
function BsFillMouse3Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5.069A15.328 15.328 0 0 0 7 0c-.593 0-1.104.157-1.527.463-.418.302-.717.726-.93 1.208-.386.873-.522 2.01-.54 3.206l4.497 1V.069zM3.71 5.836 3.381 6A2.5 2.5 0 0 0 2 8.236v2.576C2 13.659 4.22 16 7 16h2c2.78 0 5-2.342 5-5.188V8.123l-9-2v.003l.008.353c.007.3.023.715.053 1.175.063.937.186 2.005.413 2.688a.5.5 0 1 1-.948.316c-.273-.817-.4-2-.462-2.937A30.16 30.16 0 0 1 4 6.003c0-.034.003-.067.01-.1l-.3-.067zM14 7.1V5.187c0-1.13-.272-2.044-.748-2.772-.474-.726-1.13-1.235-1.849-1.59A7.495 7.495 0 0 0 9.5.212v5.887l4.5 1z"
                }
            }
        ]
    })(props);
}
function BsFillMusicPlayerFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm1 2h6a1 1 0 0 1 1 1v2.5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm3 12a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
                }
            }
        ]
    })(props);
}
function BsFillNodeMinusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M16 8a5 5 0 0 1-9.975.5H4A1.5 1.5 0 0 1 2.5 10h-1A1.5 1.5 0 0 1 0 8.5v-1A1.5 1.5 0 0 1 1.5 6h1A1.5 1.5 0 0 1 4 7.5h2.025A5 5 0 0 1 16 8zm-2 0a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5A.5.5 0 0 0 14 8z"
                }
            }
        ]
    })(props);
}
function BsFillNodePlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 13a5 5 0 1 0-4.975-5.5H4A1.5 1.5 0 0 0 2.5 6h-1A1.5 1.5 0 0 0 0 7.5v1A1.5 1.5 0 0 0 1.5 10h1A1.5 1.5 0 0 0 4 8.5h2.025A5 5 0 0 0 11 13zm.5-7.5v2h2a.5.5 0 0 1 0 1h-2v2a.5.5 0 0 1-1 0v-2h-2a.5.5 0 0 1 0-1h2v-2a.5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsFillNutFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.58 1a1 1 0 0 0-.868.504l-3.428 6a1 1 0 0 0 0 .992l3.428 6A1 1 0 0 0 4.58 15h6.84a1 1 0 0 0 .868-.504l3.429-6a1 1 0 0 0 0-.992l-3.429-6A1 1 0 0 0 11.42 1H4.58zm5.018 9.696a3 3 0 1 1-3-5.196 3 3 0 0 1 3 5.196z"
                }
            }
        ]
    })(props);
}
function BsFillNvmeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7H5v2h1V7Zm6 0H9v2h3V7Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4a.5.5 0 0 0-.5.5h-1A.5.5 0 0 0 0 5v1a.5.5 0 0 0 .5.5h1a.25.25 0 0 1 0 .5h-1a.5.5 0 0 0-.5.5V11a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5.5h13.5a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5.5.5 0 0 1 0-1A.5.5 0 0 0 16 7V4.5a.5.5 0 0 0-.5-.5H2Zm2 2.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-3Zm4 0a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-3Z"
                }
            }
        ]
    })(props);
}
function BsFillOctagonFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.107 0a.5.5 0 0 1 .353.146l4.394 4.394a.5.5 0 0 1 .146.353v6.214a.5.5 0 0 1-.146.353l-4.394 4.394a.5.5 0 0 1-.353.146H4.893a.5.5 0 0 1-.353-.146L.146 11.46A.5.5 0 0 1 0 11.107V4.893a.5.5 0 0 1 .146-.353L4.54.146A.5.5 0 0 1 4.893 0h6.214z"
                }
            }
        ]
    })(props);
}
function BsFillOpticalAudioFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm1 3a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 15a.5.5 0 0 1-.5-.5v-3.05a2.5 2.5 0 0 1 0-4.9V4.5a.5.5 0 0 1 .146-.354l2-2A.5.5 0 0 1 4.5 2h7a.5.5 0 0 1 .354.146l2 2A.5.5 0 0 1 14 4.5v2.05a2.5 2.5 0 0 1 0 4.9v3.05a.5.5 0 0 1-.5.5h-11ZM8 5a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z"
                }
            }
        ]
    })(props);
}
function BsFillPCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM5.5 4.002V12h1.283V9.164h1.668C10.033 9.164 11 8.08 11 6.586c0-1.482-.955-2.584-2.538-2.584H5.5Zm2.77 4.072c.893 0 1.419-.545 1.419-1.488s-.526-1.482-1.42-1.482H6.778v2.97H8.27Z"
                }
            }
        ]
    })(props);
}
function BsFillPSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.27 8.074c.893 0 1.419-.545 1.419-1.488s-.526-1.482-1.42-1.482H6.778v2.97H8.27Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm3.5 4.002h2.962C10.045 4.002 11 5.104 11 6.586c0 1.494-.967 2.578-2.55 2.578H6.784V12H5.5V4.002Z"
                }
            }
        ]
    })(props);
}
function BsFillPaletteFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.433 10.07C14.133 10.585 16 11.15 16 8a8 8 0 1 0-8 8c1.996 0 1.826-1.504 1.649-3.08-.124-1.101-.252-2.237.351-2.92.465-.527 1.42-.237 2.433.07zM8 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm4.5 3a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM5 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm.5 6.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                }
            }
        ]
    })(props);
}
function BsFillPassFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 0a2 2 0 1 1-4 0H3.5A1.5 1.5 0 0 0 2 1.5v13A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-13A1.5 1.5 0 0 0 12.5 0H10ZM4.5 5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1Zm0 2h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1Z"
                }
            }
        ]
    })(props);
}
function BsFillPassportFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3.252a1.5 1.5 0 0 1 1.232-1.476l8-1.454A1.5 1.5 0 0 1 13 1.797v.47A2 2 0 0 1 14 4v10a2 2 0 0 1-2 2H4a1.995 1.995 0 0 1-1.51-.688 1.493 1.493 0 0 1-.49-1.11V3.253ZM5 8a3 3 0 1 0 6 0 3 3 0 0 0-6 0Zm0 4.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 0-1h-5a.5.5 0 0 0-.5.5Z"
                }
            }
        ]
    })(props);
}
function BsFillPatchCheckFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01-.622-.636zm.287 5.984-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708.708z"
                }
            }
        ]
    })(props);
}
function BsFillPatchExclamationFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01-.622-.636zM8 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                }
            }
        ]
    })(props);
}
function BsFillPatchMinusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01-.622-.636zM6 7.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsFillPatchPlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01-.622-.636zM8.5 6v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsFillPatchQuestionFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.933.87a2.89 2.89 0 0 1 4.134 0l.622.638.89-.011a2.89 2.89 0 0 1 2.924 2.924l-.01.89.636.622a2.89 2.89 0 0 1 0 4.134l-.637.622.011.89a2.89 2.89 0 0 1-2.924 2.924l-.89-.01-.622.636a2.89 2.89 0 0 1-4.134 0l-.622-.637-.89.011a2.89 2.89 0 0 1-2.924-2.924l.01-.89-.636-.622a2.89 2.89 0 0 1 0-4.134l.637-.622-.011-.89a2.89 2.89 0 0 1 2.924-2.924l.89.01.622-.636zM7.002 11a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm1.602-2.027c.04-.534.198-.815.846-1.26.674-.475 1.05-1.09 1.05-1.986 0-1.325-.92-2.227-2.262-2.227-1.02 0-1.792.492-2.1 1.29A1.71 1.71 0 0 0 6 5.48c0 .393.203.64.545.64.272 0 .455-.147.564-.51.158-.592.525-.915 1.074-.915.61 0 1.03.446 1.03 1.084 0 .563-.208.885-.822 1.325-.619.433-.926.914-.926 1.64v.111c0 .428.208.745.585.745.336 0 .504-.24.554-.627z"
                }
            }
        ]
    })(props);
}
function BsFillPauseBtnFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm6.25-7C5.56 5 5 5.56 5 6.25v3.5a1.25 1.25 0 1 0 2.5 0v-3.5C7.5 5.56 6.94 5 6.25 5zm3.5 0c-.69 0-1.25.56-1.25 1.25v3.5a1.25 1.25 0 1 0 2.5 0v-3.5C11 5.56 10.44 5 9.75 5z"
                }
            }
        ]
    })(props);
}
function BsFillPauseCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.25 5C5.56 5 5 5.56 5 6.25v3.5a1.25 1.25 0 1 0 2.5 0v-3.5C7.5 5.56 6.94 5 6.25 5zm3.5 0c-.69 0-1.25.56-1.25 1.25v3.5a1.25 1.25 0 1 0 2.5 0v-3.5C11 5.56 10.44 5 9.75 5z"
                }
            }
        ]
    })(props);
}
function BsFillPauseFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"
                }
            }
        ]
    })(props);
}
function BsFillPeaceFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 13.292A8 8 0 0 0 8.5.015v7.778l5.5 5.5zm-.708.708L8.5 9.206v6.778a7.967 7.967 0 0 0 4.792-1.986zM7.5 15.985V9.207L2.708 14A7.967 7.967 0 0 0 7.5 15.985zM2 13.292A8 8 0 0 1 7.5.015v7.778l-5.5 5.5z"
                }
            }
        ]
    })(props);
}
function BsFillPenFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001z"
                }
            }
        ]
    })(props);
}
function BsFillPencilFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"
                }
            }
        ]
    })(props);
}
function BsFillPentagonFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.685.256a.5.5 0 0 1 .63 0l7.421 6.03a.5.5 0 0 1 .162.538l-2.788 8.827a.5.5 0 0 1-.476.349H3.366a.5.5 0 0 1-.476-.35L.102 6.825a.5.5 0 0 1 .162-.538l7.42-6.03Z"
                }
            }
        ]
    })(props);
}
function BsFillPeopleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7Zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-5.784 6A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216ZM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
                }
            }
        ]
    })(props);
}
function BsFillPersonBadgeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm4.5 0a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zM8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm5 2.755C12.146 12.825 10.623 12 8 12s-4.146.826-5 1.755V14a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-.245z"
                }
            }
        ]
    })(props);
}
function BsFillPersonCheckFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L12.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                }
            }
        ]
    })(props);
}
function BsFillPersonDashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11 7.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                }
            }
        ]
    })(props);
}
function BsFillPersonFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3Zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                }
            }
        ]
    })(props);
}
function BsFillPersonLinesFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2z"
                }
            }
        ]
    })(props);
}
function BsFillPersonPlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsFillPersonVcardFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm9 1.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5ZM9 8a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 0-1h-4A.5.5 0 0 0 9 8Zm1 2.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5Zm-1 2C9 10.567 7.21 9 5 9c-2.086 0-3.8 1.398-3.984 3.181A1 1 0 0 0 2 13h6.96c.026-.163.04-.33.04-.5ZM7 6a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z"
                }
            }
        ]
    })(props);
}
function BsFillPersonXFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm6.146-2.854a.5.5 0 0 1 .708 0L14 6.293l1.146-1.147a.5.5 0 0 1 .708.708L14.707 7l1.147 1.146a.5.5 0 0 1-.708.708L14 7.707l-1.146 1.147a.5.5 0 0 1-.708-.708L13.293 7l-1.147-1.146a.5.5 0 0 1 0-.708z"
                }
            }
        ]
    })(props);
}
function BsFillPhoneFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V2zm6 11a1 1 0 1 0-2 0 1 1 0 0 0 2 0z"
                }
            }
        ]
    })(props);
}
function BsFillPhoneLandscapeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12.5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H2zm11-6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
                }
            }
        ]
    })(props);
}
function BsFillPhoneVibrateFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4zm5 7a1 1 0 1 0-2 0 1 1 0 0 0 2 0zM1.807 4.734a.5.5 0 1 0-.884-.468A7.967 7.967 0 0 0 0 8c0 1.347.334 2.618.923 3.734a.5.5 0 1 0 .884-.468A6.967 6.967 0 0 1 1 8c0-1.18.292-2.292.807-3.266zm13.27-.468a.5.5 0 0 0-.884.468C14.708 5.708 15 6.819 15 8c0 1.18-.292 2.292-.807 3.266a.5.5 0 0 0 .884.468A7.967 7.967 0 0 0 16 8a7.967 7.967 0 0 0-.923-3.734zM3.34 6.182a.5.5 0 1 0-.93-.364A5.986 5.986 0 0 0 2 8c0 .769.145 1.505.41 2.182a.5.5 0 1 0 .93-.364A4.986 4.986 0 0 1 3 8c0-.642.12-1.255.34-1.818zm10.25-.364a.5.5 0 0 0-.93.364c.22.563.34 1.176.34 1.818 0 .642-.12 1.255-.34 1.818a.5.5 0 0 0 .93.364C13.856 9.505 14 8.769 14 8c0-.769-.145-1.505-.41-2.182z"
                }
            }
        ]
    })(props);
}
function BsFillPieChartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.985 8.5H8.207l-5.5 5.5a8 8 0 0 0 13.277-5.5zM2 13.292A8 8 0 0 1 7.5.015v7.778l-5.5 5.5zM8.5.015V7.5h7.485A8.001 8.001 0 0 0 8.5.015z"
                }
            }
        ]
    })(props);
}
function BsFillPiggyBankFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.964 1.527c-2.977 0-5.571 1.704-6.32 4.125h-.55A1 1 0 0 0 .11 6.824l.254 1.46a1.5 1.5 0 0 0 1.478 1.243h.263c.3.513.688.978 1.145 1.382l-.729 2.477a.5.5 0 0 0 .48.641h2a.5.5 0 0 0 .471-.332l.482-1.351c.635.173 1.31.267 2.011.267.707 0 1.388-.095 2.028-.272l.543 1.372a.5.5 0 0 0 .465.316h2a.5.5 0 0 0 .478-.645l-.761-2.506C13.81 9.895 14.5 8.559 14.5 7.069c0-.145-.007-.29-.02-.431.261-.11.508-.266.705-.444.315.306.815.306.815-.417 0 .223-.5.223-.461-.026a.95.95 0 0 0 .09-.255.7.7 0 0 0-.202-.645.58.58 0 0 0-.707-.098.735.735 0 0 0-.375.562c-.024.243.082.48.32.654a2.112 2.112 0 0 1-.259.153c-.534-2.664-3.284-4.595-6.442-4.595Zm7.173 3.876a.565.565 0 0 1-.098.21.704.704 0 0 1-.044-.025c-.146-.09-.157-.175-.152-.223a.236.236 0 0 1 .117-.173c.049-.027.08-.021.113.012a.202.202 0 0 1 .064.199Zm-8.999-.65a.5.5 0 1 1-.276-.96A7.613 7.613 0 0 1 7.964 3.5c.763 0 1.497.11 2.18.315a.5.5 0 1 1-.287.958A6.602 6.602 0 0 0 7.964 4.5c-.64 0-1.255.09-1.826.254ZM5 6.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
                }
            }
        ]
    })(props);
}
function BsFillPinAngleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.828.722a.5.5 0 0 1 .354.146l4.95 4.95a.5.5 0 0 1 0 .707c-.48.48-1.072.588-1.503.588-.177 0-.335-.018-.46-.039l-3.134 3.134a5.927 5.927 0 0 1 .16 1.013c.046.702-.032 1.687-.72 2.375a.5.5 0 0 1-.707 0l-2.829-2.828-3.182 3.182c-.195.195-1.219.902-1.414.707-.195-.195.512-1.22.707-1.414l3.182-3.182-2.828-2.829a.5.5 0 0 1 0-.707c.688-.688 1.673-.767 2.375-.72a5.922 5.922 0 0 1 1.013.16l3.134-3.133a2.772 2.772 0 0 1-.04-.461c0-.43.108-1.022.589-1.503a.5.5 0 0 1 .353-.146z"
                }
            }
        ]
    })(props);
}
function BsFillPinFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.146.146A.5.5 0 0 1 4.5 0h7a.5.5 0 0 1 .5.5c0 .68-.342 1.174-.646 1.479-.126.125-.25.224-.354.298v4.431l.078.048c.203.127.476.314.751.555C12.36 7.775 13 8.527 13 9.5a.5.5 0 0 1-.5.5h-4v4.5c0 .276-.224 1.5-.5 1.5s-.5-1.224-.5-1.5V10h-4a.5.5 0 0 1-.5-.5c0-.973.64-1.725 1.17-2.189A5.921 5.921 0 0 1 5 6.708V2.277a2.77 2.77 0 0 1-.354-.298C4.342 1.674 4 1.179 4 .5a.5.5 0 0 1 .146-.354z"
                }
            }
        ]
    })(props);
}
function BsFillPinMapFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.1 11.2a.5.5 0 0 1 .4-.2H6a.5.5 0 0 1 0 1H3.75L1.5 15h13l-2.25-3H10a.5.5 0 0 1 0-1h2.5a.5.5 0 0 1 .4.2l3 4a.5.5 0 0 1-.4.8H.5a.5.5 0 0 1-.4-.8l3-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999z"
                }
            }
        ]
    })(props);
}
function BsFillPipFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 2A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13zm7 6h5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsFillPlayBtnFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm6.79-6.907A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z"
                }
            }
        ]
    })(props);
}
function BsFillPlayCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z"
                }
            }
        ]
    })(props);
}
function BsFillPlayFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"
                }
            }
        ]
    })(props);
}
function BsFillPlugFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 0a.5.5 0 0 1 .5.5V3h3V.5a.5.5 0 0 1 1 0V3h1a.5.5 0 0 1 .5.5v3A3.5 3.5 0 0 1 8.5 10c-.002.434-.01.845-.04 1.22-.041.514-.126 1.003-.317 1.424a2.083 2.083 0 0 1-.97 1.028C6.725 13.9 6.169 14 5.5 14c-.998 0-1.61.33-1.974.718A1.922 1.922 0 0 0 3 16H2c0-.616.232-1.367.797-1.968C3.374 13.42 4.261 13 5.5 13c.581 0 .962-.088 1.218-.219.241-.123.4-.3.514-.55.121-.266.193-.621.23-1.09.027-.34.035-.718.037-1.141A3.5 3.5 0 0 1 4 6.5v-3a.5.5 0 0 1 .5-.5h1V.5A.5.5 0 0 1 6 0z"
                }
            }
        ]
    })(props);
}
function BsFillPlusCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z"
                }
            }
        ]
    })(props);
}
function BsFillPlusSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsFillPostageFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 3a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-7Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 1a1 1 0 0 0 1-1h1a1 1 0 0 0 2 0h1a1 1 0 0 0 2 0h1a1 1 0 1 0 2 0H15v1a1 1 0 1 0 0 2v1a1 1 0 1 0 0 2v1a1 1 0 1 0 0 2v1a1 1 0 1 0 0 2v1a1 1 0 1 0 0 2v1h-1.5a1 1 0 1 0-2 0h-1a1 1 0 1 0-2 0h-1a1 1 0 1 0-2 0h-1a1 1 0 1 0-2 0H1v-1a1 1 0 1 0 0-2v-1a1 1 0 1 0 0-2V9a1 1 0 1 0 0-2V6a1 1 0 0 0 0-2V3a1 1 0 0 0 0-2V0h1.5a1 1 0 0 0 1 1ZM3 3v10a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1Z"
                }
            }
        ]
    })(props);
}
function BsFillPostageHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 3a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-7ZM8 11C2.175 7.236 6.336 4.31 8 5.982 9.664 4.309 13.825 7.236 8 11Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 0a1 1 0 0 1-2 0H1v1a1 1 0 0 1 0 2v1a1 1 0 0 1 0 2v1a1 1 0 0 1 0 2v1a1 1 0 1 1 0 2v1a1 1 0 1 1 0 2v1h1.5a1 1 0 1 1 2 0h1a1 1 0 1 1 2 0h1a1 1 0 1 1 2 0h1a1 1 0 1 1 2 0H15v-1a1 1 0 1 1 0-2v-1a1 1 0 1 1 0-2V9a1 1 0 1 1 0-2V6a1 1 0 1 1 0-2V3a1 1 0 1 1 0-2V0h-1.5a1 1 0 1 1-2 0h-1a1 1 0 1 1-2 0h-1a1 1 0 0 1-2 0h-1ZM4 14a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4Z"
                }
            }
        ]
    })(props);
}
function BsFillPostcardFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8h2V6h-2v2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm8.5.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7ZM2 5.5a.5.5 0 0 0 .5.5H6a.5.5 0 0 0 0-1H2.5a.5.5 0 0 0-.5.5ZM2.5 7a.5.5 0 0 0 0 1H6a.5.5 0 0 0 0-1H2.5ZM2 9.5a.5.5 0 0 0 .5.5H6a.5.5 0 0 0 0-1H2.5a.5.5 0 0 0-.5.5Zm8-4v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5Z"
                }
            }
        ]
    })(props);
}
function BsFillPostcardHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2Zm6 2.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0Zm3.5.878c1.482-1.42 4.795 1.392 0 4.622-4.795-3.23-1.482-6.043 0-4.622ZM2 5.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm0 2a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm0 2a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Z"
                }
            }
        ]
    })(props);
}
function BsFillPrinterFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2H5zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2V7zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"
                }
            }
        ]
    })(props);
}
function BsFillProjectorFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2 1 1 0 0 0 1 1h1a1 1 0 0 0 1-1h6a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1 2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H2Zm.5 2h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1ZM14 7.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-12 1a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Z"
                }
            }
        ]
    })(props);
}
function BsFillPuzzleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.112 3.645A1.5 1.5 0 0 1 4.605 2H7a.5.5 0 0 1 .5.5v.382c0 .696-.497 1.182-.872 1.469a.459.459 0 0 0-.115.118.113.113 0 0 0-.012.025L6.5 4.5v.003l.003.01c.004.01.014.028.036.053a.86.86 0 0 0 .27.194C7.09 4.9 7.51 5 8 5c.492 0 .912-.1 1.19-.24a.86.86 0 0 0 .271-.194.213.213 0 0 0 .036-.054l.003-.01v-.008a.112.112 0 0 0-.012-.025.459.459 0 0 0-.115-.118c-.375-.287-.872-.773-.872-1.469V2.5A.5.5 0 0 1 9 2h2.395a1.5 1.5 0 0 1 1.493 1.645L12.645 6.5h.237c.195 0 .42-.147.675-.48.21-.274.528-.52.943-.52.568 0 .947.447 1.154.862C15.877 6.807 16 7.387 16 8s-.123 1.193-.346 1.638c-.207.415-.586.862-1.154.862-.415 0-.733-.246-.943-.52-.255-.333-.48-.48-.675-.48h-.237l.243 2.855A1.5 1.5 0 0 1 11.395 14H9a.5.5 0 0 1-.5-.5v-.382c0-.696.497-1.182.872-1.469a.459.459 0 0 0 .115-.118.113.113 0 0 0 .012-.025L9.5 11.5v-.003l-.003-.01a.214.214 0 0 0-.036-.053.859.859 0 0 0-.27-.194C8.91 11.1 8.49 11 8 11c-.491 0-.912.1-1.19.24a.859.859 0 0 0-.271.194.214.214 0 0 0-.036.054l-.003.01v.002l.001.006a.113.113 0 0 0 .012.025c.016.027.05.068.115.118.375.287.872.773.872 1.469v.382a.5.5 0 0 1-.5.5H4.605a1.5 1.5 0 0 1-1.493-1.645L3.356 9.5h-.238c-.195 0-.42.147-.675.48-.21.274-.528.52-.943.52-.568 0-.947-.447-1.154-.862C.123 9.193 0 8.613 0 8s.123-1.193.346-1.638C.553 5.947.932 5.5 1.5 5.5c.415 0 .733.246.943.52.255.333.48.48.675.48h.238l-.244-2.855z"
                }
            }
        ]
    })(props);
}
function BsFillQuestionCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z"
                }
            }
        ]
    })(props);
}
function BsFillQuestionDiamondFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435zM5.495 6.033a.237.237 0 0 1-.24-.247C5.35 4.091 6.737 3.5 8.005 3.5c1.396 0 2.672.73 2.672 2.24 0 1.08-.635 1.594-1.244 2.057-.737.559-1.01.768-1.01 1.486v.105a.25.25 0 0 1-.25.25h-.81a.25.25 0 0 1-.25-.246l-.004-.217c-.038-.927.495-1.498 1.168-1.987.59-.444.965-.736.965-1.371 0-.825-.628-1.168-1.314-1.168-.803 0-1.253.478-1.342 1.134-.018.137-.128.25-.266.25h-.825zm2.325 6.443c-.584 0-1.009-.394-1.009-.927 0-.552.425-.94 1.01-.94.609 0 1.028.388 1.028.94 0 .533-.42.927-1.029.927z"
                }
            }
        ]
    })(props);
}
function BsFillQuestionOctagonFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.46.146A.5.5 0 0 0 11.107 0H4.893a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353L11.46.146zM5.496 6.033a.237.237 0 0 1-.24-.247C5.35 4.091 6.737 3.5 8.005 3.5c1.396 0 2.672.73 2.672 2.24 0 1.08-.635 1.594-1.244 2.057-.737.559-1.01.768-1.01 1.486v.105a.25.25 0 0 1-.25.25h-.81a.25.25 0 0 1-.25-.246l-.004-.217c-.038-.927.495-1.498 1.168-1.987.59-.444.965-.736.965-1.371 0-.825-.628-1.168-1.314-1.168-.803 0-1.253.478-1.342 1.134-.018.137-.128.25-.266.25h-.825zm2.325 6.443c-.584 0-1.009-.394-1.009-.927 0-.552.425-.94 1.01-.94.609 0 1.028.388 1.028.94 0 .533-.42.927-1.029.927z"
                }
            }
        ]
    })(props);
}
function BsFillQuestionSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm3.496 6.033a.237.237 0 0 1-.24-.247C5.35 4.091 6.737 3.5 8.005 3.5c1.396 0 2.672.73 2.672 2.24 0 1.08-.635 1.594-1.244 2.057-.737.559-1.01.768-1.01 1.486v.105a.25.25 0 0 1-.25.25h-.81a.25.25 0 0 1-.25-.246l-.004-.217c-.038-.927.495-1.498 1.168-1.987.59-.444.965-.736.965-1.371 0-.825-.628-1.168-1.314-1.168-.803 0-1.253.478-1.342 1.134-.018.137-.128.25-.266.25h-.825zm2.325 6.443c-.584 0-1.009-.394-1.009-.927 0-.552.425-.94 1.01-.94.609 0 1.028.388 1.028.94 0 .533-.42.927-1.029.927z"
                }
            }
        ]
    })(props);
}
function BsFillRCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM5.5 4.002V12h1.335V8.924H8.52L9.98 12h1.52L9.856 8.701c.828-.299 1.495-1.101 1.495-2.238 0-1.488-1.03-2.461-2.74-2.461H5.5Zm1.335 1.09v2.777h1.549c.995 0 1.573-.463 1.573-1.36 0-.913-.596-1.417-1.537-1.417H6.835Z"
                }
            }
        ]
    })(props);
}
function BsFillRSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.835 5.092v2.777h1.549c.995 0 1.573-.463 1.573-1.36 0-.913-.596-1.417-1.537-1.417H6.835Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm3.5 4.002h3.11c1.71 0 2.741.973 2.741 2.46 0 1.138-.667 1.94-1.495 2.24L11.5 12H9.98L8.52 8.924H6.836V12H5.5V4.002Z"
                }
            }
        ]
    })(props);
}
function BsFillRecordBtnFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm8-1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                }
            }
        ]
    })(props);
}
function BsFillRecordCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-8 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                }
            }
        ]
    })(props);
}
function BsFillRecordFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 13A5 5 0 1 0 8 3a5 5 0 0 0 0 10z"
                }
            }
        ]
    })(props);
}
function BsFillRecord2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13A5 5 0 1 0 8 3a5 5 0 0 0 0 10zm0-2a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
                }
            }
        ]
    })(props);
}
function BsFillReplyAllFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.021 11.9 3.453 8.62a.719.719 0 0 1 0-1.238L8.021 4.1a.716.716 0 0 1 1.079.619V6c1.5 0 6 0 7 8-2.5-4.5-7-4-7-4v1.281c0 .56-.606.898-1.079.62z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.232 4.293a.5.5 0 0 1-.106.7L1.114 7.945a.5.5 0 0 1-.042.028.147.147 0 0 0 0 .252.503.503 0 0 1 .042.028l4.012 2.954a.5.5 0 1 1-.593.805L.539 9.073a1.147 1.147 0 0 1 0-1.946l3.994-2.94a.5.5 0 0 1 .699.106z"
                }
            }
        ]
    })(props);
}
function BsFillReplyFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.921 11.9 1.353 8.62a.719.719 0 0 1 0-1.238L5.921 4.1A.716.716 0 0 1 7 4.719V6c1.5 0 6 0 7 8-2.5-4.5-7-4-7-4v1.281c0 .56-.606.898-1.079.62z"
                }
            }
        ]
    })(props);
}
function BsFillRewindBtnFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2Zm7.729 1.055A.5.5 0 0 1 8 5.5v1.886l3.21-2.293A.5.5 0 0 1 12 5.5v5a.5.5 0 0 1-.79.407L8 8.614V10.5a.5.5 0 0 1-.79.407l-3.5-2.5a.5.5 0 0 1 0-.814l3.5-2.5a.5.5 0 0 1 .519-.038Z"
                }
            }
        ]
    })(props);
}
function BsFillRewindCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16ZM7.729 5.055A.5.5 0 0 1 8 5.5v1.886l3.21-2.293A.5.5 0 0 1 12 5.5v5a.5.5 0 0 1-.79.407L8 8.614V10.5a.5.5 0 0 1-.79.407l-3.5-2.5a.5.5 0 0 1 0-.814l3.5-2.5a.5.5 0 0 1 .519-.038Z"
                }
            }
        ]
    })(props);
}
function BsFillRewindFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.404 7.304a.802.802 0 0 0 0 1.392l6.363 3.692c.52.302 1.233-.043 1.233-.696V4.308c0-.653-.713-.998-1.233-.696L8.404 7.304Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M.404 7.304a.802.802 0 0 0 0 1.392l6.363 3.692c.52.302 1.233-.043 1.233-.696V4.308c0-.653-.713-.998-1.233-.696L.404 7.304Z"
                }
            }
        ]
    })(props);
}
function BsFillRocketFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.175 1.991c.81 1.312 1.583 3.43 1.778 6.819l1.5 1.83A2.5 2.5 0 0 1 14 12.202V15.5a.5.5 0 0 1-.9.3l-1.125-1.5c-.166-.222-.42-.4-.752-.57-.214-.108-.414-.192-.627-.282l-.196-.083C9.7 13.793 8.85 14 8 14c-.85 0-1.7-.207-2.4-.635-.068.03-.133.057-.198.084-.211.089-.411.173-.625.281-.332.17-.586.348-.752.57L2.9 15.8a.5.5 0 0 1-.9-.3v-3.298a2.5 2.5 0 0 1 .548-1.562l.004-.005L4.049 8.81c.197-3.323.969-5.434 1.774-6.756.466-.767.94-1.262 1.31-1.57a3.67 3.67 0 0 1 .601-.41A.549.549 0 0 1 8 0c.101 0 .17.027.25.064.037.017.086.041.145.075.118.066.277.167.463.315.373.297.85.779 1.317 1.537ZM9.5 6c0-1.105-.672-2-1.5-2s-1.5.895-1.5 2S7.172 8 8 8s1.5-.895 1.5-2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14.5c.5 0 .999-.046 1.479-.139L8.4 15.8a.5.5 0 0 1-.8 0l-1.079-1.439c.48.093.98.139 1.479.139Z"
                }
            }
        ]
    })(props);
}
function BsFillRocketTakeoffFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.17 9.53c2.307-2.592 3.278-4.684 3.641-6.218.21-.887.214-1.58.16-2.065a3.578 3.578 0 0 0-.108-.563 2.22 2.22 0 0 0-.078-.23V.453c-.073-.164-.168-.234-.352-.295a2.35 2.35 0 0 0-.16-.045 3.797 3.797 0 0 0-.57-.093c-.49-.044-1.19-.03-2.08.188-1.536.374-3.618 1.343-6.161 3.604l-2.4.238h-.006a2.552 2.552 0 0 0-1.524.734L.15 7.17a.512.512 0 0 0 .433.868l1.896-.271c.28-.04.592.013.955.132.232.076.437.16.655.248l.203.083c.196.816.66 1.58 1.275 2.195.613.614 1.376 1.08 2.191 1.277l.082.202c.089.218.173.424.249.657.118.363.172.676.132.956l-.271 1.9a.512.512 0 0 0 .867.433l2.382-2.386c.41-.41.668-.949.732-1.526l.24-2.408Zm.11-3.699c-.797.8-1.93.961-2.528.362-.598-.6-.436-1.733.361-2.532.798-.799 1.93-.96 2.528-.361.599.599.437 1.732-.36 2.531Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.205 10.787a7.632 7.632 0 0 0 1.804 1.352c-1.118 1.007-4.929 2.028-5.054 1.903-.126-.127.737-4.189 1.839-5.18.346.69.837 1.35 1.411 1.925Z"
                }
            }
        ]
    })(props);
}
function BsFillRouterFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.525 3.025a3.5 3.5 0 0 1 4.95 0 .5.5 0 1 0 .707-.707 4.5 4.5 0 0 0-6.364 0 .5.5 0 0 0 .707.707Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.94 4.44a1.5 1.5 0 0 1 2.12 0 .5.5 0 0 0 .708-.708 2.5 2.5 0 0 0-3.536 0 .5.5 0 0 0 .707.707Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.974 2.342a.5.5 0 1 0-.948.316L3.806 8H1.5A1.5 1.5 0 0 0 0 9.5v2A1.5 1.5 0 0 0 1.5 13H2a.5.5 0 0 0 .5.5h2A.5.5 0 0 0 5 13h6a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5h.5a1.5 1.5 0 0 0 1.5-1.5v-2A1.5 1.5 0 0 0 14.5 8h-2.306l1.78-5.342a.5.5 0 1 0-.948-.316L11.14 8H4.86L2.974 2.342ZM2.5 11a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm4.5-.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm2.5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm1.5-.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm2 0a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 5.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
                }
            }
        ]
    })(props);
}
function BsFillRssFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm1.5 2.5c5.523 0 10 4.477 10 10a1 1 0 1 1-2 0 8 8 0 0 0-8-8 1 1 0 0 1 0-2zm0 4a6 6 0 0 1 6 6 1 1 0 1 1-2 0 4 4 0 0 0-4-4 1 1 0 0 1 0-2zm.5 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                }
            }
        ]
    })(props);
}
function BsFillSafeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.778 9.414A2 2 0 1 1 6.95 6.586a2 2 0 0 1 2.828 2.828z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 0A1.5 1.5 0 0 0 1 1.5V3H.5a.5.5 0 0 0 0 1H1v3.5H.5a.5.5 0 0 0 0 1H1V12H.5a.5.5 0 0 0 0 1H1v1.5A1.5 1.5 0 0 0 2.5 16h12a1.5 1.5 0 0 0 1.5-1.5v-13A1.5 1.5 0 0 0 14.5 0h-12zm3.036 4.464 1.09 1.09a3.003 3.003 0 0 1 3.476 0l1.09-1.09a.5.5 0 1 1 .707.708l-1.09 1.09c.74 1.037.74 2.44 0 3.476l1.09 1.09a.5.5 0 1 1-.707.708l-1.09-1.09a3.002 3.002 0 0 1-3.476 0l-1.09 1.09a.5.5 0 1 1-.708-.708l1.09-1.09a3.003 3.003 0 0 1 0-3.476l-1.09-1.09a.5.5 0 1 1 .708-.708zM14 6.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsFillSafe2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.563 8H5.035a3.482 3.482 0 0 1 .662-1.596l1.08 1.08c-.094.16-.167.332-.214.516zm.921-1.223-1.08-1.08A3.482 3.482 0 0 1 8 5.035v1.528c-.184.047-.357.12-.516.214zM9 6.563V5.035a3.482 3.482 0 0 1 1.596.662l-1.08 1.08A1.988 1.988 0 0 0 9 6.563zm1.223.921 1.08-1.08c.343.458.577 1.003.662 1.596h-1.528a1.989 1.989 0 0 0-.214-.516zM10.437 9h1.528a3.483 3.483 0 0 1-.662 1.596l-1.08-1.08c.094-.16.167-.332.214-.516zm-.921 1.223 1.08 1.08A3.483 3.483 0 0 1 9 11.965v-1.528c.184-.047.357-.12.516-.214zM8 10.437v1.528a3.483 3.483 0 0 1-1.596-.662l1.08-1.08c.16.094.332.167.516.214zm-1.223-.921-1.08 1.08A3.482 3.482 0 0 1 5.035 9h1.528c.047.184.12.357.214.516zM7.5 8.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 1A1.5 1.5 0 0 0 1 2.5V3H.5a.5.5 0 0 0 0 1H1v4H.5a.5.5 0 0 0 0 1H1v4H.5a.5.5 0 0 0 0 1H1v.5A1.5 1.5 0 0 0 2.5 16h12a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 14.5 1h-12zm6 3a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9z"
                }
            }
        ]
    })(props);
}
function BsFillSaveFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 1.5A1.5 1.5 0 0 1 10 0h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h6c-.314.418-.5.937-.5 1.5v7.793L4.854 6.646a.5.5 0 1 0-.708.708l3.5 3.5a.5.5 0 0 0 .708 0l3.5-3.5a.5.5 0 0 0-.708-.708L8.5 9.293V1.5z"
                }
            }
        ]
    })(props);
}
function BsFillSave2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 1.5A1.5 1.5 0 0 1 10 0h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h6c-.314.418-.5.937-.5 1.5v6h-2a.5.5 0 0 0-.354.854l2.5 2.5a.5.5 0 0 0 .708 0l2.5-2.5A.5.5 0 0 0 10.5 7.5h-2v-6z"
                }
            }
        ]
    })(props);
}
function BsFillSdCardFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 0H5.914a1.5 1.5 0 0 0-1.06.44L2.439 2.853A1.5 1.5 0 0 0 2 3.914V14.5A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-13A1.5 1.5 0 0 0 12.5 0Zm-7 2.75a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75Zm2 0a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75Zm2.75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 1.5 0Zm1.25-.75a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75Z"
                }
            }
        ]
    })(props);
}
function BsFillSearchHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 13a6.474 6.474 0 0 0 3.845-1.258h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.008 1.008 0 0 0-.115-.1A6.471 6.471 0 0 0 13 6.5 6.502 6.502 0 0 0 6.5 0a6.5 6.5 0 1 0 0 13Zm0-8.518c1.664-1.673 5.825 1.254 0 5.018-5.825-3.764-1.664-6.69 0-5.018Z"
                }
            }
        ]
    })(props);
}
function BsFillSendArrowDownFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.854.146a.5.5 0 0 1 .11.54L13.026 8.03A4.5 4.5 0 0 0 8 12.5c0 .5 0 1.5-.773.36l-1.59-2.498L.644 7.184l-.002-.001-.41-.261a.5.5 0 0 1 .083-.886l.452-.18.001-.001L15.314.035a.5.5 0 0 1 .54.111ZM6.637 10.07l7.494-7.494.471-1.178-1.178.471L5.93 9.363l.338.215a.5.5 0 0 1 .154.154l.215.338Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.354-1.646a.5.5 0 0 1-.722-.016l-1.149-1.25a.5.5 0 1 1 .737-.676l.28.305V11a.5.5 0 0 1 1 0v1.793l.396-.397a.5.5 0 0 1 .708.708l-1.25 1.25Z"
                }
            }
        ]
    })(props);
}
function BsFillSendArrowUpFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.854.146a.5.5 0 0 1 .11.54L13.026 8.03A4.5 4.5 0 0 0 8 12.5c0 .5 0 1.5-.773.36l-1.59-2.498L.644 7.184l-.002-.001-.41-.261a.5.5 0 0 1 .083-.886l.452-.18.001-.001L15.314.035a.5.5 0 0 1 .54.111ZM6.637 10.07l7.494-7.494.471-1.178-1.178.471L5.93 9.363l.338.215a.5.5 0 0 1 .154.154l.215.338Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.354-5.354a.5.5 0 0 0-.722.016l-1.149 1.25a.5.5 0 1 0 .737.676l.28-.305V14a.5.5 0 0 0 1 0v-1.793l.396.397a.5.5 0 0 0 .708-.708l-1.25-1.25Z"
                }
            }
        ]
    })(props);
}
function BsFillSendCheckFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z"
                }
            }
        ]
    })(props);
}
function BsFillSendDashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-5.5 0a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5Z"
                }
            }
        ]
    })(props);
}
function BsFillSendExclamationFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.5-5v1.5a.5.5 0 0 1-1 0V11a.5.5 0 0 1 1 0Zm0 3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
                }
            }
        ]
    })(props);
}
function BsFillSendFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083l6-15Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z"
                }
            }
        ]
    })(props);
}
function BsFillSendPlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-3.5-2a.5.5 0 0 0-.5.5v1h-1a.5.5 0 0 0 0 1h1v1a.5.5 0 0 0 1 0v-1h1a.5.5 0 0 0 0-1h-1v-1a.5.5 0 0 0-.5-.5Z"
                }
            }
        ]
    })(props);
}
function BsFillSendSlashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.975 10.025a3.5 3.5 0 1 0-4.95 4.95 3.5 3.5 0 0 0 4.95-4.95Zm-4.243.707a2.501 2.501 0 0 1 3.147-.318l-3.465 3.465a2.501 2.501 0 0 1 .318-3.147Zm.39 3.854 3.464-3.465a2.501 2.501 0 0 1-3.465 3.465Z"
                }
            }
        ]
    })(props);
}
function BsFillSendXFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-4.854-1.354a.5.5 0 0 0 0 .708l.647.646-.647.646a.5.5 0 0 0 .708.708l.646-.647.646.647a.5.5 0 0 0 .708-.708l-.647-.646.647-.646a.5.5 0 0 0-.708-.708l-.646.647-.646-.647a.5.5 0 0 0-.708 0Z"
                }
            }
        ]
    })(props);
}
function BsFillShareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z"
                }
            }
        ]
    })(props);
}
function BsFillShieldFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z"
                }
            }
        ]
    })(props);
}
function BsFillShieldLockFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.775 11.775 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.541 1.541 0 0 0-1.044-1.263 62.467 62.467 0 0 0-2.887-.87C9.843.266 8.69 0 8 0zm0 5a1.5 1.5 0 0 1 .5 2.915l.385 1.99a.5.5 0 0 1-.491.595h-.788a.5.5 0 0 1-.49-.595l.384-1.99A1.5 1.5 0 0 1 8 5z"
                }
            }
        ]
    })(props);
}
function BsFillShieldSlashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.093 3.093c-.465 4.275.885 7.46 2.513 9.589a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.32 11.32 0 0 0 1.733-1.525L1.093 3.093zm12.215 8.215L3.128 1.128A61.369 61.369 0 0 1 5.073.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.483 3.626-.332 6.491-1.551 8.616zm.338 3.046-13-13 .708-.708 13 13-.707.707z"
                }
            }
        ]
    })(props);
}
function BsFillShiftFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.27 2.047a1 1 0 0 1 1.46 0l6.345 6.77c.6.638.146 1.683-.73 1.683H11.5v3a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-3H1.654C.78 10.5.326 9.455.924 8.816L7.27 2.047z"
                }
            }
        ]
    })(props);
}
function BsFillSignDeadEndFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.116 6.28h.32c.395 0 .582.24.582.722 0 .48-.186.718-.581.718h-.321V6.28Zm3.636.066.268.845h-.552l.27-.845h.014Zm1.327-.066h.32c.394 0 .582.24.582.722 0 .48-.186.718-.582.718h-.32V6.28Zm-.792 3h.32c.395 0 .582.24.582.722 0 .48-.186.718-.581.718h-.32V9.28Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435ZM4.782 6h.69c.596 0 .886.355.886.998S6.066 8 5.473 8h-.69V6ZM7.82 7.72V8H6.571V6H7.82v.28h-.917v.57h.863v.268h-.863v.602h.917Zm.397.28h-.34l.688-2h.371l.689 2h-.352l-.177-.554h-.702L8.216 8Zm1.53-2h.69c.596 0 .886.355.886.998S11.03 8 10.436 8h-.69V6Zm-2.923 4.72V11H5.575V9h1.248v.28h-.917v.57h.863v.268h-.863v.602h.917Zm.572.28h-.32V9h.294l.933 1.436h.014V9h.32v2h-.292l-.936-1.44h-.013V11Zm1.56-2h.69c.596 0 .886.355.886.998S10.238 11 9.645 11h-.69V9Z"
                }
            }
        ]
    })(props);
}
function BsFillSignDoNotEnterFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.237 4.28h-.32v1.44h.32c.396 0 .582-.239.582-.718 0-.481-.188-.722-.582-.722Zm2.392.859v-.277c0-.413-.211-.617-.494-.617-.285 0-.495.204-.495.617v.277c0 .414.21.618.495.618.283 0 .494-.204.494-.618Zm4.163 0v-.277c0-.413-.211-.617-.494-.617-.285 0-.495.204-.495.617v.277c0 .414.21.618.495.618.283 0 .494-.204.494-.618Zm.006 5.828v-.694h.39c.231 0 .378.126.378.354 0 .225-.142.34-.387.34h-.38Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16ZM3.584 6V4h.69c.596 0 .886.355.886.998S4.867 6 4.274 6h-.69Zm3.382-1.135v.272c0 .566-.318.903-.83.903-.513 0-.833-.337-.833-.903v-.272c0-.569.32-.904.832-.904.513 0 .83.337.83.904Zm1.021-.305V6h-.319V4h.293l.933 1.436h.015V4h.319v2h-.291L8 4.56h-.013Zm3.142.305v.272c0 .566-.318.903-.83.903-.513 0-.833-.337-.833-.903v-.272c0-.569.32-.904.832-.904.513 0 .83.337.83.904Zm.899-.58V6h-.333V4.285h-.584V4h1.503v.285h-.586ZM5.413 11.72V12H4.165v-2h1.248v.28h-.917v.57h.862v.268h-.862v.602h.917Zm.572.28h-.32v-2h.294l.933 1.436h.014v-1.435h.32V12h-.292l-.936-1.44h-.013V12Zm2.279 0H7.93v-1.715h-.584V10H8.85v.284h-.586V12Zm1.953-.28V12H8.97v-2h1.248v.28H9.3v.57h.863v.268H9.3v.602h.917ZM11.235 10c.42 0 .674.244.674.616a.575.575 0 0 1-.368.56l.404.824h-.373l-.36-.769h-.414V12h-.328v-2h.765ZM3.5 7h9a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5Z"
                }
            }
        ]
    })(props);
}
function BsFillSignIntersectionFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435ZM7.25 4h1.5v3.25H12v1.5H8.75V12h-1.5V8.75H4v-1.5h3.25V4Z"
                }
            }
        ]
    })(props);
}
function BsFillSignIntersectionSideFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435ZM6.25 4h1.5v3.25H11v1.5H7.75V12h-1.5V4Z"
                }
            }
        ]
    })(props);
}
function BsFillSignIntersectionTFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435ZM5 5h6v1.5H8.75V12h-1.5V6.5H5V5Z"
                }
            }
        ]
    })(props);
}
function BsFillSignIntersectionYFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435Zm1.443 4.762 1.014 1.106L8.75 8.83V12h-1.5V8.83L4.493 6.303l1.014-1.106L8 7.483l2.493-2.286Z"
                }
            }
        ]
    })(props);
}
function BsFillSignMergeLeftFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435ZM7.25 6H6.034a.25.25 0 0 1-.192-.41l1.966-2.36a.25.25 0 0 1 .384 0l1.966 2.36a.25.25 0 0 1-.192.41H8.75v6h-1.5V8.823c-.551.686-1.229 1.363-1.88 2.015l-.016.016-.708-.708c.757-.756 1.48-1.48 2.016-2.196.25-.333.448-.649.588-.95V6Z"
                }
            }
        ]
    })(props);
}
function BsFillSignMergeRightFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435ZM8.75 6v1c.14.301.338.617.588.95.537.716 1.259 1.44 2.016 2.196l-.708.708-.015-.016c-.652-.652-1.33-1.33-1.881-2.015V12h-1.5V6H6.034a.25.25 0 0 1-.192-.41l1.966-2.36a.25.25 0 0 1 .384 0l1.966 2.36a.25.25 0 0 1-.192.41H8.75Z"
                }
            }
        ]
    })(props);
}
function BsFillSignNoLeftTurnFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 13.292A8 8 0 0 1 13.293 2L9.195 6.099A2.501 2.501 0 0 0 8.5 6H7V4.534a.25.25 0 0 0-.41-.192L4.23 6.308a.25.25 0 0 0 0 .384l2.36 1.966a.265.265 0 0 0 .026.02L2 13.291Zm.708.708A8 8 0 0 0 14 2.707l-3.885 3.884C10.656 7.05 11 7.735 11 8.5V11h-1V8.5c0-.489-.234-.923-.596-1.197l-6.696 6.696Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.293 7 7 8.293V7h1.293Z"
                }
            }
        ]
    })(props);
}
function BsFillSignNoParkingFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.292 14A8 8 0 0 1 2 2.707l3.5 3.5V12h1.283V9.164h1.674L13.292 14Zm.708-.708-4.37-4.37C10.5 8.524 11 7.662 11 6.587c0-1.482-.955-2.584-2.538-2.584H5.5v.79L2.708 2.002A8 8 0 0 1 14 13.293Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.777 7.485v.59h.59l-.59-.59Zm1.949.535L6.777 6.07v-.966H8.27c.893 0 1.419.539 1.419 1.482 0 .769-.35 1.273-.963 1.433Z"
                }
            }
        ]
    })(props);
}
function BsFillSignNoRightTurnFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 13.292A8 8 0 0 0 2.707 2l4.097 4.098C7.025 6.034 7.259 6 7.5 6H9V4.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L9.41 8.658a.265.265 0 0 1-.026.02L14 13.291Zm-.708.708A8 8 0 0 1 2 2.707l3.885 3.884A2.495 2.495 0 0 0 5 8.5V11h1V8.5c0-.489.234-.923.596-1.197l6.696 6.696Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.707 7 9 8.293V7H7.707Z"
                }
            }
        ]
    })(props);
}
function BsFillSignRailroadFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L4.224 3.162 8 6.94l3.777-3.777L9.049.435Zm3.274 7.425v-.862h.467c.28 0 .467.154.467.44 0 .28-.182.421-.475.421h-.459Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.838 4.223 9.06 8l3.777 3.777 2.727-2.728c.58-.58.58-1.519 0-2.098l-2.727-2.728Zm.03 2.361c.591 0 .935.334.935.844a.79.79 0 0 1-.485.748l.536 1.074h-.59l-.467-.994h-.473v.994h-.521V6.584h1.064Zm-1.091 6.254L8 9.06l-3.777 3.777 2.728 2.727c.58.58 1.519.58 2.098 0l2.728-2.727Zm-8.953-5.84v.861h.46c.292 0 .474-.14.474-.421 0-.286-.188-.44-.467-.44h-.467Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.162 11.777 6.94 8 3.162 4.223.435 6.951c-.58.58-.58 1.519 0 2.098l2.727 2.728Zm-.86-5.193h1.065c.592 0 .936.334.936.844 0 .39-.242.654-.485.748l.536 1.074h-.59l-.467-.994h-.473v.994h-.521V6.584Z"
                }
            }
        ]
    })(props);
}
function BsFillSignStopFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.371 8.277v-.553c0-.827-.422-1.234-.987-1.234-.572 0-.99.407-.99 1.234v.553c0 .83.418 1.237.99 1.237.565 0 .987-.408.987-1.237Zm2.586-.24c.463 0 .735-.272.735-.744s-.272-.741-.735-.741h-.774v1.485h.774Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.893 0a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353L11.46.146A.5.5 0 0 0 11.107 0H4.893ZM3.16 10.08c-.931 0-1.447-.493-1.494-1.132h.653c.065.346.396.583.891.583.524 0 .83-.246.83-.62 0-.303-.203-.467-.637-.572l-.656-.164c-.61-.147-.978-.51-.978-1.078 0-.706.597-1.184 1.444-1.184.853 0 1.386.475 1.436 1.087h-.645c-.064-.32-.352-.542-.797-.542-.472 0-.77.246-.77.6 0 .261.196.437.553.522l.654.161c.673.164 1.06.487 1.06 1.11 0 .736-.574 1.228-1.544 1.228Zm3.427-3.51V10h-.665V6.57H4.753V6h3.006v.568H6.587Zm4.458 1.16v.544c0 1.131-.636 1.805-1.661 1.805-1.026 0-1.664-.674-1.664-1.805V7.73c0-1.136.638-1.807 1.664-1.807 1.025 0 1.66.674 1.66 1.807ZM11.52 6h1.535c.82 0 1.316.55 1.316 1.292 0 .747-.501 1.289-1.321 1.289h-.865V10h-.665V6.001Z"
                }
            }
        ]
    })(props);
}
function BsFillSignStopLightsFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435ZM6 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4Z"
                }
            }
        ]
    })(props);
}
function BsFillSignTurnLeftFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435ZM7 8.466a.25.25 0 0 1-.41.192L4.23 6.692a.25.25 0 0 1 0-.384l2.36-1.966a.25.25 0 0 1 .41.192V6h1.5A2.5 2.5 0 0 1 11 8.5V11h-1V8.5A1.5 1.5 0 0 0 8.5 7H7v1.466Z"
                }
            }
        ]
    })(props);
}
function BsFillSignTurnRightFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435ZM9 8.466V7H7.5A1.5 1.5 0 0 0 6 8.5V11H5V8.5A2.5 2.5 0 0 1 7.5 6H9V4.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L9.41 8.658A.25.25 0 0 1 9 8.466Z"
                }
            }
        ]
    })(props);
}
function BsFillSignTurnSlightLeftFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435ZM6.864 8.368a.25.25 0 0 1-.451-.039l-1.06-2.882a.25.25 0 0 1 .192-.333l3.026-.523a.25.25 0 0 1 .26.371l-.667 1.154.621.373A2.5 2.5 0 0 1 10 8.632V11H9V8.632a1.5 1.5 0 0 0-.728-1.286l-.607-.364-.8 1.386Z"
                }
            }
        ]
    })(props);
}
function BsFillSignTurnSlightRightFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.482 1.482 0 0 1 0-2.098L6.95.435Zm1.385 6.547.8 1.386a.25.25 0 0 0 .451-.039l1.06-2.882a.25.25 0 0 0-.192-.333l-3.026-.523a.25.25 0 0 0-.26.371l.667 1.154-.621.373A2.5 2.5 0 0 0 6 8.632V11h1V8.632a1.5 1.5 0 0 1 .728-1.286l.607-.364Z"
                }
            }
        ]
    })(props);
}
function BsFillSignYieldFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.48 5.323h-.28v1.353h.28c.372 0 .54-.222.54-.674 0-.45-.169-.68-.54-.68Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.022 14.434a1.131 1.131 0 0 0 1.96 0l6.857-11.667c.457-.778-.092-1.767-.98-1.767H1.144c-.889 0-1.437.99-.98 1.767l6.857 11.667ZM5.506 6.232V7H5.11v-.76L4.44 5h.44l.424.849h.016L5.748 5h.428l-.67 1.232ZM6.628 5v2h-.396V5h.396Zm.684 1.676h.895V7H6.919V5h1.288v.324h-.895v.513h.842v.303h-.842v.536Zm1.521-.013h.848V7H8.437V5h.396v1.663Zm.97.337V5h.73c.608 0 .895.364.895.995 0 .636-.291 1.005-.895 1.005h-.73Z"
                }
            }
        ]
    })(props);
}
function BsFillSignpost2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.293.707A1 1 0 0 0 7 1.414V2H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h5v1H2.5a1 1 0 0 0-.8.4L.725 8.7a.5.5 0 0 0 0 .6l.975 1.3a1 1 0 0 0 .8.4H7v5h2v-5h5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H9V6h4.5a1 1 0 0 0 .8-.4l.975-1.3a.5.5 0 0 0 0-.6L14.3 2.4a1 1 0 0 0-.8-.4H9v-.586A1 1 0 0 0 7.293.707z"
                }
            }
        ]
    })(props);
}
function BsFillSignpostFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.293.707A1 1 0 0 0 7 1.414V4H2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5v6h2v-6h3.532a1 1 0 0 0 .768-.36l1.933-2.32a.5.5 0 0 0 0-.64L13.3 4.36a1 1 0 0 0-.768-.36H9V1.414A1 1 0 0 0 7.293.707z"
                }
            }
        ]
    })(props);
}
function BsFillSignpostSplitFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 16h2V6h5a1 1 0 0 0 .8-.4l.975-1.3a.5.5 0 0 0 0-.6L14.8 2.4A1 1 0 0 0 14 2H9v-.586a1 1 0 0 0-2 0V7H2a1 1 0 0 0-.8.4L.225 8.7a.5.5 0 0 0 0 .6l.975 1.3a1 1 0 0 0 .8.4h5v5z"
                }
            }
        ]
    })(props);
}
function BsFillSimFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4.5a.5.5 0 0 1 .5-.5h2v2H5V4.5zM8.5 6V4h2a.5.5 0 0 1 .5.5V6H8.5zM5 7h6v2H5V7zm3.5 3H11v1.5a.5.5 0 0 1-.5.5h-2v-2zm-1 0v2h-2a.5.5 0 0 1-.5-.5V10h2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0A1.5 1.5 0 0 0 2 1.5v13A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5V3.414a1.5 1.5 0 0 0-.44-1.06L11.647.439A1.5 1.5 0 0 0 10.586 0H3.5zm2 3h5A1.5 1.5 0 0 1 12 4.5v7a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 11.5v-7A1.5 1.5 0 0 1 5.5 3z"
                }
            }
        ]
    })(props);
}
function BsFillSimSlashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.646.44.897.896-1.703 1.703A1.506 1.506 0 0 0 10.5 3h-5A1.5 1.5 0 0 0 4 4.5v5.379l-2 2V1.5A1.5 1.5 0 0 1 3.5 0h7.086a1.5 1.5 0 0 1 1.06.44ZM8.5 5.378 9.879 4H8.5v1.379ZM5 8.879 6.879 7H5v1.879Zm6-1.758L9.121 9H11V7.121Zm-3.5 3.5L6.121 12H7.5v-1.379ZM5.5 13c-.117 0-.23-.013-.34-.039L2.502 15.62c.265.236.615.38.998.38h9a1.5 1.5 0 0 0 1.5-1.5V4.121l-2 2V11.5a1.5 1.5 0 0 1-1.5 1.5h-5ZM5 4.5a.5.5 0 0 1 .5-.5h2v2H5V4.5ZM8.5 10H11v1.5a.5.5 0 0 1-.5.5h-2v-2Zm6.354-8.146a.5.5 0 0 0-.708-.708l-13 13a.5.5 0 0 0 .708.708l13-13Z"
                }
            }
        ]
    })(props);
}
function BsFillSkipBackwardBtnFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm11.21-6.907L8.5 7.028V5.5a.5.5 0 0 0-.79-.407L5 7.028V5.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0V8.972l2.71 1.935a.5.5 0 0 0 .79-.407V8.972l2.71 1.935A.5.5 0 0 0 12 10.5v-5a.5.5 0 0 0-.79-.407z"
                }
            }
        ]
    })(props);
}
function BsFillSkipBackwardCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.79-2.907L8.5 7.028V5.5a.5.5 0 0 0-.79-.407L5 7.028V5.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0V8.972l2.71 1.935a.5.5 0 0 0 .79-.407V8.972l2.71 1.935A.5.5 0 0 0 12 10.5v-5a.5.5 0 0 0-.79-.407z"
                }
            }
        ]
    })(props);
}
function BsFillSkipBackwardFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.5 3.5A.5.5 0 0 0 0 4v8a.5.5 0 0 0 1 0V8.753l6.267 3.636c.54.313 1.233-.066 1.233-.697v-2.94l6.267 3.636c.54.314 1.233-.065 1.233-.696V4.308c0-.63-.693-1.01-1.233-.696L8.5 7.248v-2.94c0-.63-.692-1.01-1.233-.696L1 7.248V4a.5.5 0 0 0-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsFillSkipEndBtnFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm6.79-6.907A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407L9.5 8.972V10.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0v1.528L6.79 5.093z"
                }
            }
        ]
    })(props);
}
function BsFillSkipEndCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407L9.5 8.972V10.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0v1.528L6.79 5.093z"
                }
            }
        ]
    })(props);
}
function BsFillSkipEndFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 4a.5.5 0 0 0-1 0v3.248L5.233 3.612C4.693 3.3 4 3.678 4 4.308v7.384c0 .63.692 1.01 1.233.697L11.5 8.753V12a.5.5 0 0 0 1 0V4z"
                }
            }
        ]
    })(props);
}
function BsFillSkipForwardBtnFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2Zm4.79-6.907A.5.5 0 0 0 4 5.5v5a.5.5 0 0 0 .79.407L7.5 8.972V10.5a.5.5 0 0 0 .79.407L11 8.972V10.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0v1.528L8.29 5.093a.5.5 0 0 0-.79.407v1.528L4.79 5.093Z"
                }
            }
        ]
    })(props);
}
function BsFillSkipForwardCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.79 5.093A.5.5 0 0 0 4 5.5v5a.5.5 0 0 0 .79.407L7.5 8.972V10.5a.5.5 0 0 0 .79.407L11 8.972V10.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0v1.528L8.29 5.093a.5.5 0 0 0-.79.407v1.528L4.79 5.093z"
                }
            }
        ]
    })(props);
}
function BsFillSkipForwardFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 3.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V8.753l-6.267 3.636c-.54.313-1.233-.066-1.233-.697v-2.94l-6.267 3.636C.693 12.703 0 12.324 0 11.693V4.308c0-.63.693-1.01 1.233-.696L7.5 7.248v-2.94c0-.63.693-1.01 1.233-.696L15 7.248V4a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsFillSkipStartBtnFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm9.71-6.907L7 7.028V5.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0V8.972l2.71 1.935a.5.5 0 0 0 .79-.407v-5a.5.5 0 0 0-.79-.407z"
                }
            }
        ]
    })(props);
}
function BsFillSkipStartCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM9.71 5.093 7 7.028V5.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0V8.972l2.71 1.935a.5.5 0 0 0 .79-.407v-5a.5.5 0 0 0-.79-.407z"
                }
            }
        ]
    })(props);
}
function BsFillSkipStartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4a.5.5 0 0 1 1 0v3.248l6.267-3.636c.54-.313 1.232.066 1.232.696v7.384c0 .63-.692 1.01-1.232.697L5 8.753V12a.5.5 0 0 1-1 0V4z"
                }
            }
        ]
    })(props);
}
function BsFillSlashCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.646-2.646a.5.5 0 0 0-.708-.708l-6 6a.5.5 0 0 0 .708.708l6-6z"
                }
            }
        ]
    })(props);
}
function BsFillSlashSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm9.354 5.354-6 6a.5.5 0 0 1-.708-.708l6-6a.5.5 0 0 1 .708.708z"
                }
            }
        ]
    })(props);
}
function BsFillSpeakerFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-2.5 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm6 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM8 7a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7z"
                }
            }
        ]
    })(props);
}
function BsFillSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2z"
                }
            }
        ]
    })(props);
}
function BsFillStarFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"
                }
            }
        ]
    })(props);
}
function BsFillStickiesFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1.5V13a1 1 0 0 0 1 1V1.5a.5.5 0 0 1 .5-.5H14a1 1 0 0 0-1-1H1.5A1.5 1.5 0 0 0 0 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 2A1.5 1.5 0 0 0 2 3.5v11A1.5 1.5 0 0 0 3.5 16h6.086a1.5 1.5 0 0 0 1.06-.44l4.915-4.914A1.5 1.5 0 0 0 16 9.586V3.5A1.5 1.5 0 0 0 14.5 2h-11zm6 8.5a1 1 0 0 1 1-1h4.396a.25.25 0 0 1 .177.427l-5.146 5.146a.25.25 0 0 1-.427-.177V10.5z"
                }
            }
        ]
    })(props);
}
function BsFillStickyFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 1A1.5 1.5 0 0 0 1 2.5v11A1.5 1.5 0 0 0 2.5 15h6.086a1.5 1.5 0 0 0 1.06-.44l4.915-4.914A1.5 1.5 0 0 0 15 8.586V2.5A1.5 1.5 0 0 0 13.5 1h-11zm6 8.5a1 1 0 0 1 1-1h4.396a.25.25 0 0 1 .177.427l-5.146 5.146a.25.25 0 0 1-.427-.177V9.5z"
                }
            }
        ]
    })(props);
}
function BsFillStopBtnFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm6.5-7A1.5 1.5 0 0 0 5 6.5v3A1.5 1.5 0 0 0 6.5 11h3A1.5 1.5 0 0 0 11 9.5v-3A1.5 1.5 0 0 0 9.5 5h-3z"
                }
            }
        ]
    })(props);
}
function BsFillStopCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.5 5A1.5 1.5 0 0 0 5 6.5v3A1.5 1.5 0 0 0 6.5 11h3A1.5 1.5 0 0 0 11 9.5v-3A1.5 1.5 0 0 0 9.5 5h-3z"
                }
            }
        ]
    })(props);
}
function BsFillStopFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3.5h6A1.5 1.5 0 0 1 12.5 5v6a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 11V5A1.5 1.5 0 0 1 5 3.5z"
                }
            }
        ]
    })(props);
}
function BsFillStoplightsFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 0a2 2 0 0 0-2 2H2c.167.5.8 1.6 2 2v2H2c.167.5.8 1.6 2 2v2H2c.167.5.8 1.6 2 2v1a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-1c1.2-.4 1.833-1.5 2-2h-2V8c1.2-.4 1.833-1.5 2-2h-2V4c1.2-.4 1.833-1.5 2-2h-2a2 2 0 0 0-2-2H6zm3.5 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM8 13a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                }
            }
        ]
    })(props);
}
function BsFillStopwatchFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 0a.5.5 0 0 0 0 1H7v1.07A7.001 7.001 0 0 0 8 16a7 7 0 0 0 5.29-11.584.531.531 0 0 0 .013-.012l.354-.354.353.354a.5.5 0 1 0 .707-.707l-1.414-1.415a.5.5 0 1 0-.707.707l.354.354-.354.354a.717.717 0 0 0-.012.012A6.973 6.973 0 0 0 9 2.071V1h.5a.5.5 0 0 0 0-1h-3zm2 5.6V9a.5.5 0 0 1-.5.5H4.5a.5.5 0 0 1 0-1h3V5.6a.5.5 0 1 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsFillSuitClubFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 12.5a3.493 3.493 0 0 1-2.684-1.254 19.92 19.92 0 0 0 1.582 2.907c.231.35-.02.847-.438.847H6.04c-.419 0-.67-.497-.438-.847a19.919 19.919 0 0 0 1.582-2.907 3.5 3.5 0 1 1-2.538-5.743 3.5 3.5 0 1 1 6.708 0A3.5 3.5 0 1 1 11.5 12.5z"
                }
            }
        ]
    })(props);
}
function BsFillSuitDiamondFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.45 7.4 7.2 1.067a1 1 0 0 1 1.6 0L13.55 7.4a1 1 0 0 1 0 1.2L8.8 14.933a1 1 0 0 1-1.6 0L2.45 8.6a1 1 0 0 1 0-1.2z"
                }
            }
        ]
    })(props);
}
function BsFillSuitHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 1c2.21 0 4 1.755 4 3.92C8 2.755 9.79 1 12 1s4 1.755 4 3.92c0 3.263-3.234 4.414-7.608 9.608a.513.513 0 0 1-.784 0C3.234 9.334 0 8.183 0 4.92 0 2.755 1.79 1 4 1z"
                }
            }
        ]
    })(props);
}
function BsFillSuitSpadeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.184 11.246A3.5 3.5 0 0 1 1 9c0-1.602 1.14-2.633 2.66-4.008C4.986 3.792 6.602 2.33 8 0c1.398 2.33 3.014 3.792 4.34 4.992C13.86 6.367 15 7.398 15 9a3.5 3.5 0 0 1-6.184 2.246 19.92 19.92 0 0 0 1.582 2.907c.231.35-.02.847-.438.847H6.04c-.419 0-.67-.497-.438-.847a19.919 19.919 0 0 0 1.582-2.907z"
                }
            }
        ]
    })(props);
}
function BsFillSuitcaseFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 .5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V3h1.5A1.5 1.5 0 0 1 13 4.5v9a1.5 1.5 0 0 1-1.004 1.416A1 1 0 1 1 10 15H6a1 1 0 1 1-1.997-.084A1.5 1.5 0 0 1 3 13.5v-9A1.5 1.5 0 0 1 4.5 3H6V.5ZM9 1H7v2h2V1ZM6 5.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7Zm2.5 0a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7Zm2.5 0a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7Z"
                }
            }
        ]
    })(props);
}
function BsFillSuitcaseLgFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 0a2 2 0 0 0-2 2H1.5A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14H2a.5.5 0 0 0 1 0h10a.5.5 0 0 0 1 0h.5a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2H11a2 2 0 0 0-2-2H7ZM6 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1H6ZM3 13V3h1v10H3Zm9 0V3h1v10h-1Z"
                }
            }
        ]
    })(props);
}
function BsFillSuitcase2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 0a.5.5 0 0 0-.5.5V3H4.5A1.5 1.5 0 0 0 3 4.5v9a1.5 1.5 0 0 0 1.003 1.416A1 1 0 1 0 6 15h4a1 1 0 1 0 1.996-.084A1.5 1.5 0 0 0 13 13.5v-9A1.5 1.5 0 0 0 11.5 3H10V.5a.5.5 0 0 0-.5-.5h-3ZM9 3H7V1h2v2ZM4 7V6h8v1H4Z"
                }
            }
        ]
    })(props);
}
function BsFillSunFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z"
                }
            }
        ]
    })(props);
}
function BsFillSunriseFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.646 1.146a.5.5 0 0 1 .708 0l1.5 1.5a.5.5 0 0 1-.708.708L8.5 2.707V4.5a.5.5 0 0 1-1 0V2.707l-.646.647a.5.5 0 1 1-.708-.708l1.5-1.5zM2.343 4.343a.5.5 0 0 1 .707 0l1.414 1.414a.5.5 0 0 1-.707.707L2.343 5.05a.5.5 0 0 1 0-.707zm11.314 0a.5.5 0 0 1 0 .707l-1.414 1.414a.5.5 0 1 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zM11.709 11.5a4 4 0 1 0-7.418 0H.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1h-3.79zM0 10a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 0 10zm13 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsFillSunsetFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.646 4.854a.5.5 0 0 0 .708 0l1.5-1.5a.5.5 0 0 0-.708-.708l-.646.647V1.5a.5.5 0 0 0-1 0v1.793l-.646-.647a.5.5 0 1 0-.708.708l1.5 1.5zm-5.303-.51a.5.5 0 0 1 .707 0l1.414 1.413a.5.5 0 0 1-.707.707L2.343 5.05a.5.5 0 0 1 0-.707zm11.314 0a.5.5 0 0 1 0 .706l-1.414 1.414a.5.5 0 1 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zM11.709 11.5a4 4 0 1 0-7.418 0H.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1h-3.79zM0 10a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 0 10zm13 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsFillTabletFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm7 11a1 1 0 1 0-2 0 1 1 0 0 0 2 0z"
                }
            }
        ]
    })(props);
}
function BsFillTabletLandscapeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 14a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2zm11-7a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
                }
            }
        ]
    })(props);
}
function BsFillTagFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l4.586-4.586a1 1 0 0 0 0-1.414l-7-7A1 1 0 0 0 6.586 1H2zm4 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
                }
            }
        ]
    })(props);
}
function BsFillTagsFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a1 1 0 0 1 1-1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 2 6.586V2zm3.5 4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.293 7.793A1 1 0 0 1 1 7.086V2a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l.043-.043-7.457-7.457z"
                }
            }
        ]
    })(props);
}
function BsFillTaxiFrontFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 1a1 1 0 0 0-1 1v1h-.181A2.5 2.5 0 0 0 2.52 4.515l-.792 1.848a.807.807 0 0 1-.38.404c-.5.25-.855.715-.965 1.262L.05 9.708a2.5 2.5 0 0 0-.049.49v.413c0 .814.39 1.543 1 1.997V14.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1.338c1.292.048 2.745.088 4 .088s2.708-.04 4-.088V14.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1.892c.61-.454 1-1.183 1-1.997v-.413c0-.165-.016-.329-.049-.49l-.335-1.68a1.807 1.807 0 0 0-.964-1.261.807.807 0 0 1-.381-.404l-.792-1.848A2.5 2.5 0 0 0 11.181 3H11V2a1 1 0 0 0-1-1H6ZM4.309 4h7.382a.5.5 0 0 1 .447.276l.956 1.913a.51.51 0 0 1-.497.731c-.91-.073-3.35-.17-4.597-.17-1.247 0-3.688.097-4.597.17a.51.51 0 0 1-.497-.731l.956-1.913A.5.5 0 0 1 4.309 4ZM4 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm10 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-9 0a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Z"
                }
            }
        ]
    })(props);
}
function BsFillTelephoneFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"
                }
            }
        ]
    })(props);
}
function BsFillTelephoneForwardFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm10.761.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708z"
                }
            }
        ]
    })(props);
}
function BsFillTelephoneInboundFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zM15.854.146a.5.5 0 0 1 0 .708L11.707 5H14.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0v2.793L15.146.146a.5.5 0 0 1 .708 0z"
                }
            }
        ]
    })(props);
}
function BsFillTelephoneMinusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zM10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsFillTelephoneOutboundFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsFillTelephonePlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zM12.5 1a.5.5 0 0 1 .5.5V3h1.5a.5.5 0 0 1 0 1H13v1.5a.5.5 0 0 1-1 0V4h-1.5a.5.5 0 0 1 0-1H12V1.5a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsFillTelephoneXFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm9.261 1.135a.5.5 0 0 1 .708 0L13 2.793l1.146-1.147a.5.5 0 0 1 .708.708L13.707 3.5l1.147 1.146a.5.5 0 0 1-.708.708L13 4.207l-1.146 1.147a.5.5 0 0 1-.708-.708L12.293 3.5l-1.147-1.146a.5.5 0 0 1 0-.708z"
                }
            }
        ]
    })(props);
}
function BsFillTerminalFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3zm9.5 5.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm-6.354-.354a.5.5 0 1 0 .708.708l2-2a.5.5 0 0 0 0-.708l-2-2a.5.5 0 1 0-.708.708L4.793 6.5 3.146 8.146z"
                }
            }
        ]
    })(props);
}
function BsFillThreadsFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.81 9.204c0-.41.197-1.062 1.727-1.062.469 0 .758.034 1.146.121-.124 1.606-.91 1.818-1.674 1.818-.418 0-1.2-.218-1.2-.877Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.59 16h10.82A2.59 2.59 0 0 0 16 13.41V2.59A2.59 2.59 0 0 0 13.41 0H2.59A2.59 2.59 0 0 0 0 2.59v10.82A2.59 2.59 0 0 0 2.59 16ZM5.866 5.91c.567-.81 1.315-1.126 2.35-1.126.73 0 1.351.246 1.795.711.443.466.696 1.132.754 1.983.245.103.472.224.678.363.832.559 1.29 1.395 1.29 2.353 0 2.037-1.67 3.806-4.692 3.806-2.595 0-5.291-1.51-5.291-6.004C2.75 3.526 5.361 2 8.033 2c1.234 0 4.129.182 5.217 3.777l-1.02.264c-.842-2.56-2.607-2.968-4.224-2.968-2.675 0-4.187 1.628-4.187 5.093 0 3.107 1.69 4.757 4.222 4.757 2.083 0 3.636-1.082 3.636-2.667 0-1.079-.906-1.595-.953-1.595-.177.925-.651 2.482-2.733 2.482-1.213 0-2.26-.838-2.26-1.936 0-1.568 1.488-2.136 2.663-2.136.44 0 .97.03 1.247.086 0-.478-.404-1.296-1.426-1.296-.911 0-1.16.288-1.45.624l-.024.027c-.202-.135-.875-.601-.875-.601Z"
                }
            }
        ]
    })(props);
}
function BsFillThunderboltFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 3a1 1 0 0 0-1 1v7.293A1 1 0 0 0 .293 12L2 13.707a1 1 0 0 0 .707.293h10.586a1 1 0 0 0 .707-.293L15.707 12a1 1 0 0 0 .293-.707V4a1 1 0 0 0-1-1H1Zm2.5 3h9a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5Z"
                }
            }
        ]
    })(props);
}
function BsFillTicketDetailedFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4.5A1.5 1.5 0 0 1 1.5 3h13A1.5 1.5 0 0 1 16 4.5V6a.5.5 0 0 1-.5.5 1.5 1.5 0 0 0 0 3 .5.5 0 0 1 .5.5v1.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 11.5V10a.5.5 0 0 1 .5-.5 1.5 1.5 0 1 0 0-3A.5.5 0 0 1 0 6V4.5Zm4 1a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5Zm0 5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5ZM4 8a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2H5a1 1 0 0 0-1 1Z"
                }
            }
        ]
    })(props);
}
function BsFillTicketFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 3A1.5 1.5 0 0 0 0 4.5V6a.5.5 0 0 0 .5.5 1.5 1.5 0 1 1 0 3 .5.5 0 0 0-.5.5v1.5A1.5 1.5 0 0 0 1.5 13h13a1.5 1.5 0 0 0 1.5-1.5V10a.5.5 0 0 0-.5-.5 1.5 1.5 0 0 1 0-3A.5.5 0 0 0 16 6V4.5A1.5 1.5 0 0 0 14.5 3h-13Z"
                }
            }
        ]
    })(props);
}
function BsFillTicketPerforatedFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4.5A1.5 1.5 0 0 1 1.5 3h13A1.5 1.5 0 0 1 16 4.5V6a.5.5 0 0 1-.5.5 1.5 1.5 0 0 0 0 3 .5.5 0 0 1 .5.5v1.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 11.5V10a.5.5 0 0 1 .5-.5 1.5 1.5 0 1 0 0-3A.5.5 0 0 1 0 6V4.5Zm4-1v1h1v-1H4Zm1 3v-1H4v1h1Zm7 0v-1h-1v1h1Zm-1-2h1v-1h-1v1Zm-6 3H4v1h1v-1Zm7 1v-1h-1v1h1Zm-7 1H4v1h1v-1Zm7 1v-1h-1v1h1Zm-8 1v1h1v-1H4Zm7 1h1v-1h-1v1Z"
                }
            }
        ]
    })(props);
}
function BsFillTrainFreightFrontFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.736 0a1.5 1.5 0 0 0-.67.158L1.828 1.776A1.5 1.5 0 0 0 1 3.118v5.51l2-.6V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3.028l2 .6v-5.51a1.5 1.5 0 0 0-.83-1.342L10.936.158A1.5 1.5 0 0 0 10.264 0H5.736ZM15 9.672l-5.503-1.65A.5.5 0 0 0 9.353 8H8.5v8h4a2.5 2.5 0 0 0 2.5-2.5V9.672ZM7.5 16V8h-.853a.5.5 0 0 0-.144.021L1 9.672V13.5A2.5 2.5 0 0 0 3.5 16h4Zm-1-14h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1ZM12 5v2.728l-2.216-.665A1.5 1.5 0 0 0 9.354 7H8.5V5H12ZM7.5 5v2h-.853a1.5 1.5 0 0 0-.431.063L4 7.728V5h3.5Zm-4 5a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm9 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1ZM5 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm7 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
                }
            }
        ]
    })(props);
}
function BsFillTrainFrontFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.621.515C8.647.02 7.353.02 5.38.515c-.924.23-1.982.766-2.78 1.22C1.566 2.322 1 3.432 1 4.582V13.5A2.5 2.5 0 0 0 3.5 16h9a2.5 2.5 0 0 0 2.5-2.5V4.583c0-1.15-.565-2.26-1.6-2.849-.797-.453-1.855-.988-2.779-1.22ZM6.5 2h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1Zm-2 2h7A1.5 1.5 0 0 1 13 5.5v2A1.5 1.5 0 0 1 11.5 9h-7A1.5 1.5 0 0 1 3 7.5v-2A1.5 1.5 0 0 1 4.5 4Zm.5 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm8 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-3-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM4 5.5a.5.5 0 0 1 .5-.5h3v3h-3a.5.5 0 0 1-.5-.5v-2ZM8.5 8V5h3a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-3Z"
                }
            }
        ]
    })(props);
}
function BsFillTrainLightrailFrontFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 0a.5.5 0 0 0 0 1h1v1.011c-1.525.064-3.346.394-4.588.655C1.775 2.904 1 3.915 1 5.055V13.5A2.5 2.5 0 0 0 3.5 16h9a2.5 2.5 0 0 0 2.5-2.5V5.055c0-1.14-.775-2.15-1.912-2.39-1.242-.26-3.063-.59-4.588-.654V1h1a.5.5 0 0 0 0-1h-3ZM8 4c1.136 0 2.645.2 3.604.346.825.126 1.356.9 1.244 1.697-.022.16-.046.335-.07.522C12.643 7.596 12.5 8.949 12.5 10c0 .428.024.933.062 1.464.066.93.174 1.92.266 2.682.042.34.08.634.109.854h-1.01a62.703 62.703 0 0 1-.327-3H9.354c-.36 0-.704-.143-.958-.396a.353.353 0 0 0-.25-.104h-.292a.353.353 0 0 0-.25.104 1.354 1.354 0 0 1-.958.396H4.4a62.692 62.692 0 0 1-.328 3H3.064c.029-.22.067-.514.108-.854.092-.761.2-1.752.266-2.682.038-.531.062-1.036.062-1.464 0-1.051-.143-2.404-.278-3.435a51.762 51.762 0 0 0-.07-.522c-.112-.798.42-1.571 1.244-1.697C5.356 4.199 6.864 4 8 4Zm-1.354 7H4.47c.019-.353.03-.692.03-1 0-.927-.104-2.051-.216-3h7.432c-.112.949-.216 2.073-.216 3 0 .308.011.647.03 1H9.354a.353.353 0 0 1-.25-.104 1.354 1.354 0 0 0-.958-.396h-.292c-.36 0-.704.143-.958.396a.353.353 0 0 1-.25.104Zm5.199-5h-7.69l-.013-.096a.497.497 0 0 1 .405-.57C5.505 5.188 6.947 5 8 5s2.495.188 3.453.334a.497.497 0 0 1 .405.57L11.845 6ZM6 13.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0 0a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm4 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0 0a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Z"
                }
            }
        ]
    })(props);
}
function BsFillTrashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsFillTrash2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.037 3.225A.703.703 0 0 1 2 3c0-1.105 2.686-2 6-2s6 .895 6 2a.702.702 0 0 1-.037.225l-1.684 10.104A2 2 0 0 1 10.305 15H5.694a2 2 0 0 1-1.973-1.671L2.037 3.225zm9.89-.69C10.966 2.214 9.578 2 8 2c-1.58 0-2.968.215-3.926.534-.477.16-.795.327-.975.466.18.14.498.307.975.466C5.032 3.786 6.42 4 8 4s2.967-.215 3.926-.534c.477-.16.795-.327.975-.466-.18-.14-.498-.307-.975-.466z"
                }
            }
        ]
    })(props);
}
function BsFillTrash3Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z"
                }
            }
        ]
    })(props);
}
function BsFillTreeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.416.223a.5.5 0 0 0-.832 0l-3 4.5A.5.5 0 0 0 5 5.5h.098L3.076 8.735A.5.5 0 0 0 3.5 9.5h.191l-1.638 3.276a.5.5 0 0 0 .447.724H7V16h2v-2.5h4.5a.5.5 0 0 0 .447-.724L12.31 9.5h.191a.5.5 0 0 0 .424-.765L10.902 5.5H11a.5.5 0 0 0 .416-.777l-3-4.5z"
                }
            }
        ]
    })(props);
}
function BsFillTriangleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.022 1.566a1.13 1.13 0 0 1 1.96 0l6.857 11.667c.457.778-.092 1.767-.98 1.767H1.144c-.889 0-1.437-.99-.98-1.767L7.022 1.566z"
                }
            }
        ]
    })(props);
}
function BsFillTrophyFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5.5A.5.5 0 0 1 3 0h10a.5.5 0 0 1 .5.5c0 .538-.012 1.05-.034 1.536a3 3 0 1 1-1.133 5.89c-.79 1.865-1.878 2.777-2.833 3.011v2.173l1.425.356c.194.048.377.135.537.255L13.3 15.1a.5.5 0 0 1-.3.9H3a.5.5 0 0 1-.3-.9l1.838-1.379c.16-.12.343-.207.537-.255L6.5 13.11v-2.173c-.955-.234-2.043-1.146-2.833-3.012a3 3 0 1 1-1.132-5.89A33.076 33.076 0 0 1 2.5.5zm.099 2.54a2 2 0 0 0 .72 3.935c-.333-1.05-.588-2.346-.72-3.935zm10.083 3.935a2 2 0 0 0 .72-3.935c-.133 1.59-.388 2.885-.72 3.935z"
                }
            }
        ]
    })(props);
}
function BsFillTruckFrontFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0A2.5 2.5 0 0 0 1 2.5v9c0 .818.393 1.544 1 2v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V14h6v1.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2c.607-.456 1-1.182 1-2v-9A2.5 2.5 0 0 0 12.5 0h-9ZM3 3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3.9c0 .625-.562 1.092-1.17.994C10.925 7.747 9.208 7.5 8 7.5c-1.208 0-2.925.247-3.83.394A1.008 1.008 0 0 1 3 6.9V3Zm1 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm8 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm-5-2h2a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2Z"
                }
            }
        ]
    })(props);
}
function BsFillTvFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 13.5A.5.5 0 0 1 3 13h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zM2 2h12s2 0 2 2v6s0 2-2 2H2s-2 0-2-2V4s0-2 2-2z"
                }
            }
        ]
    })(props);
}
function BsFillUmbrellaFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 0a.5.5 0 0 1 .5.5v.514C12.625 1.238 16 4.22 16 8c0 0 0 .5-.5.5-.149 0-.352-.145-.352-.145l-.004-.004-.025-.023a3.484 3.484 0 0 0-.555-.394A3.166 3.166 0 0 0 13 7.5c-.638 0-1.178.213-1.564.434a3.484 3.484 0 0 0-.555.394l-.025.023-.003.003s-.204.146-.353.146-.352-.145-.352-.145l-.004-.004-.025-.023a3.484 3.484 0 0 0-.555-.394 3.3 3.3 0 0 0-1.064-.39V13.5H8h.5v.039l-.005.083a2.958 2.958 0 0 1-.298 1.102 2.257 2.257 0 0 1-.763.88C7.06 15.851 6.587 16 6 16s-1.061-.148-1.434-.396a2.255 2.255 0 0 1-.763-.88 2.958 2.958 0 0 1-.302-1.185v-.025l-.001-.009v-.003s0-.002.5-.002h-.5V13a.5.5 0 0 1 1 0v.506l.003.044a1.958 1.958 0 0 0 .195.726c.095.191.23.367.423.495.19.127.466.229.879.229s.689-.102.879-.229c.193-.128.328-.304.424-.495a1.958 1.958 0 0 0 .197-.77V7.544a3.3 3.3 0 0 0-1.064.39 3.482 3.482 0 0 0-.58.417l-.004.004S5.65 8.5 5.5 8.5c-.149 0-.352-.145-.352-.145l-.004-.004a3.482 3.482 0 0 0-.58-.417A3.166 3.166 0 0 0 3 7.5c-.638 0-1.177.213-1.564.434a3.482 3.482 0 0 0-.58.417l-.004.004S.65 8.5.5 8.5C0 8.5 0 8 0 8c0-3.78 3.375-6.762 7.5-6.986V.5A.5.5 0 0 1 8 0z"
                }
            }
        ]
    })(props);
}
function BsFillUnlockFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 1a2 2 0 0 0-2 2v4a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h5V3a3 3 0 0 1 6 0v4a.5.5 0 0 1-1 0V3a2 2 0 0 0-2-2z"
                }
            }
        ]
    })(props);
}
function BsFillUsbCFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5a3 3 0 0 0 0 6h10a3 3 0 1 0 0-6H3Zm.5 2.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1Z"
                }
            }
        ]
    })(props);
}
function BsFillUsbDriveFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4H6v-4ZM7 1v1h1V1H7Zm2 0v1h1V1H9ZM5.5 5a.5.5 0 0 0-.5.5V15a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V5.5a.5.5 0 0 0-.5-.5h-6Z"
                }
            }
        ]
    })(props);
}
function BsFillUsbFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.5 5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5H.5Zm1.75 1.5h11.5a.25.25 0 0 1 .25.25v1a.25.25 0 0 1-.25.25H2.25A.25.25 0 0 1 2 7.75v-1a.25.25 0 0 1 .25-.25Z"
                }
            }
        ]
    })(props);
}
function BsFillUsbMicroFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.707 4A1 1 0 0 0 2 4.293L.293 6A1 1 0 0 0 0 6.707V11a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V6.707A1 1 0 0 0 15.707 6L14 4.293A1 1 0 0 0 13.293 4H2.707ZM4.5 7h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5Z"
                }
            }
        ]
    })(props);
}
function BsFillUsbMiniFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3a1 1 0 0 0-1 1v1.293L.293 7A1 1 0 0 0 0 7.707V12a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V7.707A1 1 0 0 0 15.707 7L14 5.293V4a1 1 0 0 0-1-1H3Zm.5 5h9a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5Z"
                }
            }
        ]
    })(props);
}
function BsFillUsbPlugFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4H6v-4ZM7 1v1h1V1H7Zm2 0v1h1V1H9ZM5.5 5a.5.5 0 0 0-.5.5v4.894a2 2 0 0 0 .336 1.11l.83 1.245c.544.816.834 1.774.834 2.754 0 .275.222.497.497.497h2.006a.497.497 0 0 0 .497-.497c0-.98.29-1.938.834-2.754l.83-1.245a2 2 0 0 0 .336-1.11V5.5a.5.5 0 0 0-.5-.5h-6Z"
                }
            }
        ]
    })(props);
}
function BsFillVinylFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm0 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4 8a4 4 0 1 0 8 0 4 4 0 0 0-8 0z"
                }
            }
        ]
    })(props);
}
function BsFillVolumeDownFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4a.5.5 0 0 0-.812-.39L5.825 5.5H3.5A.5.5 0 0 0 3 6v4a.5.5 0 0 0 .5.5h2.325l2.363 1.89A.5.5 0 0 0 9 12V4zm3.025 4a4.486 4.486 0 0 1-1.318 3.182L10 10.475A3.489 3.489 0 0 0 11.025 8 3.49 3.49 0 0 0 10 5.525l.707-.707A4.486 4.486 0 0 1 12.025 8z"
                }
            }
        ]
    })(props);
}
function BsFillVolumeMuteFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06zm7.137 2.096a.5.5 0 0 1 0 .708L12.207 8l1.647 1.646a.5.5 0 0 1-.708.708L11.5 8.707l-1.646 1.647a.5.5 0 0 1-.708-.708L10.793 8 9.146 6.354a.5.5 0 1 1 .708-.708L11.5 7.293l1.646-1.647a.5.5 0 0 1 .708 0z"
                }
            }
        ]
    })(props);
}
function BsFillVolumeOffFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.717 3.55A.5.5 0 0 1 11 4v8a.5.5 0 0 1-.812.39L7.825 10.5H5.5A.5.5 0 0 1 5 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06z"
                }
            }
        ]
    })(props);
}
function BsFillVolumeUpFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.536 14.01A8.473 8.473 0 0 0 14.026 8a8.473 8.473 0 0 0-2.49-6.01l-.708.707A7.476 7.476 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303l.708.707z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.483 5.483 0 0 1 11.025 8a5.483 5.483 0 0 1-1.61 3.89l.706.706z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.707 11.182A4.486 4.486 0 0 0 10.025 8a4.486 4.486 0 0 0-1.318-3.182L8 5.525A3.489 3.489 0 0 1 9.025 8 3.49 3.49 0 0 1 8 10.475l.707.707zM6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06z"
                }
            }
        ]
    })(props);
}
function BsFillWalletFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 2A1.5 1.5 0 0 0 0 3.5v2h6a.5.5 0 0 1 .5.5c0 .253.08.644.306.958.207.288.557.542 1.194.542.637 0 .987-.254 1.194-.542.226-.314.306-.705.306-.958a.5.5 0 0 1 .5-.5h6v-2A1.5 1.5 0 0 0 14.5 2h-13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6.5h-5.551a2.678 2.678 0 0 1-.443 1.042C9.613 8.088 8.963 8.5 8 8.5c-.963 0-1.613-.412-2.006-.958A2.679 2.679 0 0 1 5.551 6.5H0v6A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-6z"
                }
            }
        ]
    })(props);
}
function BsFillWebcamFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.644 11.094a.5.5 0 0 1 .356-.15h2a.5.5 0 0 1 .356.15c.175.177.39.347.603.496a7.166 7.166 0 0 0 .752.456l.01.006h.003A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.224-.947l.002-.001.01-.006a3.517 3.517 0 0 0 .214-.116 7.5 7.5 0 0 0 .539-.34c.214-.15.428-.319.603-.496ZM7 6.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H2Zm6 1.5a2 2 0 1 1 0 4 2 2 0 0 1 0-4ZM12.5 7a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
                }
            }
        ]
    })(props);
}
function BsFillWrenchAdjustableCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.705 8.139a.25.25 0 0 0-.288-.376l-1.5.5.159.474.808-.27-.595.894a.25.25 0 0 0 .287.376l.808-.27-.595.894a.25.25 0 0 0 .287.376l1.5-.5-.159-.474-.808.27.596-.894a.25.25 0 0 0-.288-.376l-.808.27.596-.894Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm-6.202-4.751 1.988-1.657a4.5 4.5 0 0 1 7.537-4.623L7.497 6.5l1 2.5 1.333 3.11c-.56.251-1.18.39-1.833.39a4.49 4.49 0 0 1-1.592-.29L4.747 14.2a7.031 7.031 0 0 1-2.949-2.951ZM12.496 8a4.491 4.491 0 0 1-1.703 3.526L9.497 8.5l2.959-1.11c.027.2.04.403.04.61Z"
                }
            }
        ]
    })(props);
}
function BsFillXCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"
                }
            }
        ]
    })(props);
}
function BsFillXDiamondFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L4.047 3.339 8 7.293l3.954-3.954L9.049.435zm3.61 3.611L8.708 8l3.954 3.954 2.904-2.905c.58-.58.58-1.519 0-2.098l-2.904-2.905zm-.706 8.614L8 8.708l-3.954 3.954 2.905 2.904c.58.58 1.519.58 2.098 0l2.905-2.904zm-8.614-.706L7.292 8 3.339 4.046.435 6.951c-.58.58-.58 1.519 0 2.098l2.904 2.905z"
                }
            }
        ]
    })(props);
}
function BsFillXOctagonFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.46.146A.5.5 0 0 0 11.107 0H4.893a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353L11.46.146zm-6.106 4.5L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708z"
                }
            }
        ]
    })(props);
}
function BsFillXSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm3.354 4.646L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708z"
                }
            }
        ]
    })(props);
}
function BsReverseBackspaceReverse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.854 5.146a.5.5 0 0 1 0 .708L7.707 8l2.147 2.146a.5.5 0 0 1-.708.708L7 8.707l-2.146 2.147a.5.5 0 0 1-.708-.708L6.293 8 4.146 5.854a.5.5 0 1 1 .708-.708L7 7.293l2.146-2.147a.5.5 0 0 1 .708 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7.08a2 2 0 0 0 1.519-.698l4.843-5.651a1 1 0 0 0 0-1.302L10.6 1.7A2 2 0 0 0 9.08 1H2zm7.08 1a1 1 0 0 1 .76.35L14.682 8l-4.844 5.65a1 1 0 0 1-.759.35H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h7.08z"
                }
            }
        ]
    })(props);
}
function BsReverseLayoutSidebarInsetReverse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2zm12-1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V4z"
                }
            }
        ]
    })(props);
}
function BsReverseLayoutSidebarReverse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3zm-5-1v12H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h9zm1 0h2a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-2V2z"
                }
            }
        ]
    })(props);
}
function BsReverseLayoutTextSidebarReverse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 3a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h5zm0 3a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h5zm.5 3.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5zm-.5 2.5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2zM4 1v14H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h2zm1 0h9a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5V1z"
                }
            }
        ]
    })(props);
}
function BsReverseLayoutTextWindowReverse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5zm0 3a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5zm-.5 2.5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12zM2 1a1 1 0 0 0-1 1v1h14V2a1 1 0 0 0-1-1H2zM1 4v10a1 1 0 0 0 1 1h2V4H1zm4 0v11h9a1 1 0 0 0 1-1V4H5z"
                }
            }
        ]
    })(props);
}
function BsReverseListColumnsReverse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M0 .5A.5.5 0 0 1 .5 0h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 0 .5Zm4 0a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1h-10A.5.5 0 0 1 4 .5Zm-4 2A.5.5 0 0 1 .5 2h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm4 0a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5Zm-4 2A.5.5 0 0 1 .5 4h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm4 0a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5Zm-4 2A.5.5 0 0 1 .5 6h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm4 0a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5Zm-4 2A.5.5 0 0 1 .5 8h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm4 0a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5Zm-4 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm4 0a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1h-10a.5.5 0 0 1-.5-.5Zm-4 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm4 0a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5Zm-4 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm4 0a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5Z"
                }
            }
        ]
    })(props);
}
function Bs0CircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4.951c-1.008 0-1.629 1.09-1.629 2.895v.31c0 1.81.627 2.895 1.629 2.895s1.623-1.09 1.623-2.895v-.31c0-1.8-.621-2.895-1.623-2.895Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-8.012 4.158c1.858 0 2.96-1.582 2.96-3.99V7.84c0-2.426-1.079-3.996-2.936-3.996-1.864 0-2.965 1.588-2.965 3.996v.328c0 2.42 1.09 3.99 2.941 3.99Z"
                }
            }
        ]
    })(props);
}
function Bs0Circle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.988 12.158c-1.851 0-2.941-1.57-2.941-3.99V7.84c0-2.408 1.101-3.996 2.965-3.996 1.857 0 2.935 1.57 2.935 3.996v.328c0 2.408-1.101 3.99-2.959 3.99ZM8 4.951c-1.008 0-1.629 1.09-1.629 2.895v.31c0 1.81.627 2.895 1.629 2.895s1.623-1.09 1.623-2.895v-.31c0-1.8-.621-2.895-1.623-2.895Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8Z"
                }
            }
        ]
    })(props);
}
function Bs0SquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4.951c-1.008 0-1.629 1.09-1.629 2.895v.31c0 1.81.627 2.895 1.629 2.895s1.623-1.09 1.623-2.895v-.31c0-1.8-.621-2.895-1.623-2.895Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm5.988 12.158c-1.851 0-2.941-1.57-2.941-3.99V7.84c0-2.408 1.101-3.996 2.965-3.996 1.857 0 2.935 1.57 2.935 3.996v.328c0 2.408-1.101 3.99-2.959 3.99Z"
                }
            }
        ]
    })(props);
}
function Bs0Square(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.988 12.158c-1.851 0-2.941-1.57-2.941-3.99V7.84c0-2.408 1.101-3.996 2.965-3.996 1.857 0 2.935 1.57 2.935 3.996v.328c0 2.408-1.101 3.99-2.959 3.99ZM8 4.951c-1.008 0-1.629 1.09-1.629 2.895v.31c0 1.81.627 2.895 1.629 2.895s1.623-1.09 1.623-2.895v-.31c0-1.8-.621-2.895-1.623-2.895Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2Z"
                }
            }
        ]
    })(props);
}
function Bs1CircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM9.283 4.002H7.971L6.072 5.385v1.271l1.834-1.318h.065V12h1.312V4.002Z"
                }
            }
        ]
    })(props);
}
function Bs1Circle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8Zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM9.283 4.002V12H7.971V5.338h-.065L6.072 6.656V5.385l1.899-1.383h1.312Z"
                }
            }
        ]
    })(props);
}
function Bs1SquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm7.283 4.002V12H7.971V5.338h-.065L6.072 6.656V5.385l1.899-1.383h1.312Z"
                }
            }
        ]
    })(props);
}
function Bs1Square(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.283 4.002V12H7.971V5.338h-.065L6.072 6.656V5.385l1.899-1.383h1.312Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2Z"
                }
            }
        ]
    })(props);
}
function Bs123(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.873 11.297V4.142H1.699L0 5.379v1.137l1.64-1.18h.06v5.961h1.174Zm3.213-5.09v-.063c0-.618.44-1.169 1.196-1.169.676 0 1.174.44 1.174 1.106 0 .624-.42 1.101-.807 1.526L4.99 10.553v.744h4.78v-.99H6.643v-.069L8.41 8.252c.65-.724 1.237-1.332 1.237-2.27C9.646 4.849 8.723 4 7.308 4c-1.573 0-2.36 1.064-2.36 2.15v.057h1.138Zm6.559 1.883h.786c.823 0 1.374.481 1.379 1.179.01.707-.55 1.216-1.421 1.21-.77-.005-1.326-.419-1.379-.953h-1.095c.042 1.053.938 1.918 2.464 1.918 1.478 0 2.642-.839 2.62-2.144-.02-1.143-.922-1.651-1.551-1.714v-.063c.535-.09 1.347-.66 1.326-1.678-.026-1.053-.933-1.855-2.359-1.845-1.5.005-2.317.88-2.348 1.898h1.116c.032-.498.498-.944 1.206-.944.703 0 1.206.435 1.206 1.07.005.64-.504 1.106-1.2 1.106h-.75v.96Z"
                }
            }
        ]
    })(props);
}
function Bs2CircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM6.646 6.24c0-.691.493-1.306 1.336-1.306.756 0 1.313.492 1.313 1.236 0 .697-.469 1.23-.902 1.705l-2.971 3.293V12h5.344v-1.107H7.268v-.077l1.974-2.22.096-.107c.688-.763 1.287-1.428 1.287-2.43 0-1.266-1.031-2.215-2.613-2.215-1.758 0-2.637 1.19-2.637 2.402v.065h1.271v-.07Z"
                }
            }
        ]
    })(props);
}
function Bs2Circle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8Zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM6.646 6.24v.07H5.375v-.064c0-1.213.879-2.402 2.637-2.402 1.582 0 2.613.949 2.613 2.215 0 1.002-.6 1.667-1.287 2.43l-.096.107-1.974 2.22v.077h3.498V12H5.422v-.832l2.97-3.293c.434-.475.903-1.008.903-1.705 0-.744-.557-1.236-1.313-1.236-.843 0-1.336.615-1.336 1.306Z"
                }
            }
        ]
    })(props);
}
function Bs2SquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm4.646 6.24v.07H5.375v-.064c0-1.213.879-2.402 2.637-2.402 1.582 0 2.613.949 2.613 2.215 0 1.002-.6 1.667-1.287 2.43l-.096.107-1.974 2.22v.077h3.498V12H5.422v-.832l2.97-3.293c.434-.475.903-1.008.903-1.705 0-.744-.557-1.236-1.313-1.236-.843 0-1.336.615-1.336 1.306Z"
                }
            }
        ]
    })(props);
}
function Bs2Square(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.646 6.24v.07H5.375v-.064c0-1.213.879-2.402 2.637-2.402 1.582 0 2.613.949 2.613 2.215 0 1.002-.6 1.667-1.287 2.43l-.096.107-1.974 2.22v.077h3.498V12H5.422v-.832l2.97-3.293c.434-.475.903-1.008.903-1.705 0-.744-.557-1.236-1.313-1.236-.843 0-1.336.615-1.336 1.306Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2Z"
                }
            }
        ]
    })(props);
}
function Bs3CircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-8.082.414c.92 0 1.535.54 1.541 1.318.012.791-.615 1.36-1.588 1.354-.861-.006-1.482-.469-1.54-1.066H5.104c.047 1.177 1.05 2.144 2.754 2.144 1.653 0 2.954-.937 2.93-2.396-.023-1.278-1.031-1.846-1.734-1.916v-.07c.597-.1 1.505-.739 1.482-1.876-.03-1.177-1.043-2.074-2.637-2.062-1.675.006-2.59.984-2.625 2.12h1.248c.036-.556.557-1.054 1.348-1.054.785 0 1.348.486 1.348 1.195.006.715-.563 1.237-1.342 1.237h-.838v1.072h.879Z"
                }
            }
        ]
    })(props);
}
function Bs3Circle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.918 8.414h-.879V7.342h.838c.78 0 1.348-.522 1.342-1.237 0-.709-.563-1.195-1.348-1.195-.79 0-1.312.498-1.348 1.055H5.275c.036-1.137.95-2.115 2.625-2.121 1.594-.012 2.608.885 2.637 2.062.023 1.137-.885 1.776-1.482 1.875v.07c.703.07 1.71.64 1.734 1.917.024 1.459-1.277 2.396-2.93 2.396-1.705 0-2.707-.967-2.754-2.144H6.33c.059.597.68 1.06 1.541 1.066.973.006 1.6-.563 1.588-1.354-.006-.779-.621-1.318-1.541-1.318Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8Z"
                }
            }
        ]
    })(props);
}
function Bs3SquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm5.918 8.414h-.879V7.342h.838c.78 0 1.348-.522 1.342-1.237 0-.709-.563-1.195-1.348-1.195-.79 0-1.312.498-1.348 1.055H5.275c.036-1.137.95-2.115 2.625-2.121 1.594-.012 2.608.885 2.637 2.062.023 1.137-.885 1.776-1.482 1.875v.07c.703.07 1.71.64 1.734 1.917.024 1.459-1.277 2.396-2.93 2.396-1.705 0-2.707-.967-2.754-2.144H6.33c.059.597.68 1.06 1.541 1.066.973.006 1.6-.563 1.588-1.354-.006-.779-.621-1.318-1.541-1.318Z"
                }
            }
        ]
    })(props);
}
function Bs3Square(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.918 8.414h-.879V7.342h.838c.78 0 1.348-.522 1.342-1.237 0-.709-.563-1.195-1.348-1.195-.79 0-1.312.498-1.348 1.055H5.275c.036-1.137.95-2.115 2.625-2.121 1.594-.012 2.608.885 2.637 2.062.023 1.137-.885 1.776-1.482 1.875v.07c.703.07 1.71.64 1.734 1.917.024 1.459-1.277 2.396-2.93 2.396-1.705 0-2.707-.967-2.754-2.144H6.33c.059.597.68 1.06 1.541 1.066.973.006 1.6-.563 1.588-1.354-.006-.779-.621-1.318-1.541-1.318Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2Z"
                }
            }
        ]
    })(props);
}
function Bs4CircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM7.519 5.057c-.886 1.418-1.772 2.838-2.542 4.265v1.12H8.85V12h1.26v-1.559h1.007V9.334H10.11V4.002H8.176c-.218.352-.438.703-.657 1.055ZM6.225 9.281v.053H8.85V5.063h-.065c-.867 1.33-1.787 2.806-2.56 4.218Z"
                }
            }
        ]
    })(props);
}
function Bs4Circle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.519 5.057c.22-.352.439-.703.657-1.055h1.933v5.332h1.008v1.107H10.11V12H8.85v-1.559H4.978V9.322c.77-1.427 1.656-2.847 2.542-4.265ZM6.225 9.281v.053H8.85V5.063h-.065c-.867 1.33-1.787 2.806-2.56 4.218Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8Z"
                }
            }
        ]
    })(props);
}
function Bs4SquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.225 9.281v.053H8.85V5.063h-.065c-.867 1.33-1.787 2.806-2.56 4.218Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm5.519 5.057c.22-.352.439-.703.657-1.055h1.933v5.332h1.008v1.107H10.11V12H8.85v-1.559H4.978V9.322c.77-1.427 1.656-2.847 2.542-4.265Z"
                }
            }
        ]
    })(props);
}
function Bs4Square(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.519 5.057c.22-.352.439-.703.657-1.055h1.933v5.332h1.008v1.107H10.11V12H8.85v-1.559H4.978V9.322c.77-1.427 1.656-2.847 2.542-4.265ZM6.225 9.281v.053H8.85V5.063h-.065c-.867 1.33-1.787 2.806-2.56 4.218Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2Z"
                }
            }
        ]
    })(props);
}
function Bs5CircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-8.006 4.158c1.74 0 2.924-1.119 2.924-2.806 0-1.641-1.178-2.584-2.56-2.584-.897 0-1.442.421-1.612.68h-.064l.193-2.344h3.621V4.002H5.791L5.445 8.63h1.149c.193-.358.668-.809 1.435-.809.85 0 1.582.604 1.582 1.57 0 1.085-.779 1.682-1.57 1.682-.697 0-1.389-.31-1.53-1.031H5.276c.065 1.213 1.149 2.115 2.72 2.115Z"
                }
            }
        ]
    })(props);
}
function Bs5Circle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8Zm15 0A8 8 0 1 0 0 8a8 8 0 0 0 16 0Zm-8.006 4.158c-1.57 0-2.654-.902-2.719-2.115h1.237c.14.72.832 1.031 1.529 1.031.791 0 1.57-.597 1.57-1.681 0-.967-.732-1.57-1.582-1.57-.767 0-1.242.45-1.435.808H5.445L5.791 4h4.705v1.103H6.875l-.193 2.343h.064c.17-.258.715-.68 1.611-.68 1.383 0 2.561.944 2.561 2.585 0 1.687-1.184 2.806-2.924 2.806Z"
                }
            }
        ]
    })(props);
}
function Bs5SquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm5.994 12.158c-1.57 0-2.654-.902-2.719-2.115h1.237c.14.72.832 1.031 1.529 1.031.791 0 1.57-.597 1.57-1.681 0-.967-.732-1.57-1.582-1.57-.767 0-1.242.45-1.435.808H5.445L5.791 4h4.705v1.103H6.875l-.193 2.343h.064c.17-.258.715-.68 1.611-.68 1.383 0 2.561.944 2.561 2.585 0 1.687-1.184 2.806-2.924 2.806Z"
                }
            }
        ]
    })(props);
}
function Bs5Square(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.994 12.158c-1.57 0-2.654-.902-2.719-2.115h1.237c.14.72.832 1.031 1.529 1.031.791 0 1.57-.597 1.57-1.681 0-.967-.732-1.57-1.582-1.57-.767 0-1.242.45-1.435.808H5.445L5.791 4h4.705v1.103H6.875l-.193 2.343h.064c.17-.258.715-.68 1.611-.68 1.383 0 2.561.944 2.561 2.585 0 1.687-1.184 2.806-2.924 2.806Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2Z"
                }
            }
        ]
    })(props);
}
function Bs6CircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM8.21 3.855c-1.868 0-3.116 1.395-3.116 4.407 0 1.183.228 2.039.597 2.642.569.926 1.477 1.254 2.409 1.254 1.629 0 2.847-1.013 2.847-2.783 0-1.676-1.254-2.555-2.508-2.555-1.125 0-1.752.61-1.98 1.155h-.082c-.012-1.946.727-3.036 1.805-3.036.802 0 1.213.457 1.312.815h1.29c-.06-.908-.962-1.899-2.573-1.899Zm-.099 4.008c-.92 0-1.564.65-1.564 1.576 0 1.032.703 1.635 1.558 1.635.868 0 1.553-.533 1.553-1.629 0-1.06-.744-1.582-1.547-1.582Z"
                }
            }
        ]
    })(props);
}
function Bs6Circle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8Zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM8.21 3.855c1.612 0 2.515.99 2.573 1.899H9.494c-.1-.358-.51-.815-1.312-.815-1.078 0-1.817 1.09-1.805 3.036h.082c.229-.545.855-1.155 1.98-1.155 1.254 0 2.508.88 2.508 2.555 0 1.77-1.218 2.783-2.847 2.783-.932 0-1.84-.328-2.409-1.254-.369-.603-.597-1.459-.597-2.642 0-3.012 1.248-4.407 3.117-4.407Zm-.099 4.008c-.92 0-1.564.65-1.564 1.576 0 1.032.703 1.635 1.558 1.635.868 0 1.553-.533 1.553-1.629 0-1.06-.744-1.582-1.547-1.582Z"
                }
            }
        ]
    })(props);
}
function Bs6SquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.111 7.863c-.92 0-1.564.65-1.564 1.576 0 1.032.703 1.635 1.558 1.635.868 0 1.553-.533 1.553-1.629 0-1.06-.744-1.582-1.547-1.582Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm6.21 3.855c1.612 0 2.515.99 2.573 1.899H9.494c-.1-.358-.51-.815-1.312-.815-1.078 0-1.817 1.09-1.805 3.036h.082c.229-.545.855-1.155 1.98-1.155 1.254 0 2.508.88 2.508 2.555 0 1.77-1.218 2.783-2.847 2.783-.932 0-1.84-.328-2.409-1.254-.369-.603-.597-1.459-.597-2.642 0-3.012 1.248-4.407 3.117-4.407Z"
                }
            }
        ]
    })(props);
}
function Bs6Square(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.21 3.855c1.612 0 2.515.99 2.573 1.899H9.494c-.1-.358-.51-.815-1.312-.815-1.078 0-1.817 1.09-1.805 3.036h.082c.229-.545.855-1.155 1.98-1.155 1.254 0 2.508.88 2.508 2.555 0 1.77-1.218 2.783-2.847 2.783-.932 0-1.84-.328-2.409-1.254-.369-.603-.597-1.459-.597-2.642 0-3.012 1.248-4.407 3.117-4.407Zm-.099 4.008c-.92 0-1.564.65-1.564 1.576 0 1.032.703 1.635 1.558 1.635.868 0 1.553-.533 1.553-1.629 0-1.06-.744-1.582-1.547-1.582Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2Z"
                }
            }
        ]
    })(props);
}
function Bs7CircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM5.37 5.11h3.972v.07L6.025 12H7.42l3.258-6.85V4.002H5.369v1.107Z"
                }
            }
        ]
    })(props);
}
function Bs7Circle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8Zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM5.37 5.11V4.001h5.308V5.15L7.42 12H6.025l3.317-6.82v-.07H5.369Z"
                }
            }
        ]
    })(props);
}
function Bs7SquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm3.37 5.11V4.001h5.308V5.15L7.42 12H6.025l3.317-6.82v-.07H5.369Z"
                }
            }
        ]
    })(props);
}
function Bs7Square(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.37 5.11V4.001h5.308V5.15L7.42 12H6.025l3.317-6.82v-.07H5.369Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2Z"
                }
            }
        ]
    })(props);
}
function Bs8CircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-5.03 1.803c0-1.248-.943-1.84-1.646-1.992v-.065c.598-.187 1.336-.72 1.336-1.781 0-1.225-1.084-2.121-2.654-2.121-1.57 0-2.66.896-2.66 2.12 0 1.044.709 1.589 1.33 1.782v.065c-.697.152-1.647.732-1.647 2.003 0 1.39 1.19 2.344 2.953 2.344 1.77 0 2.989-.96 2.989-2.355Zm-4.347-3.71c0 .739.586 1.255 1.383 1.255s1.377-.516 1.377-1.254c0-.733-.58-1.23-1.377-1.23s-1.383.497-1.383 1.23Zm-.281 3.645c0 .838.72 1.412 1.664 1.412.943 0 1.658-.574 1.658-1.412 0-.843-.715-1.424-1.658-1.424-.944 0-1.664.58-1.664 1.424Z"
                }
            }
        ]
    })(props);
}
function Bs8Circle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8Zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-5.03 1.803c0 1.394-1.218 2.355-2.988 2.355-1.763 0-2.953-.955-2.953-2.344 0-1.271.95-1.851 1.647-2.003v-.065c-.621-.193-1.33-.738-1.33-1.781 0-1.225 1.09-2.121 2.66-2.121s2.654.896 2.654 2.12c0 1.061-.738 1.595-1.336 1.782v.065c.703.152 1.647.744 1.647 1.992Zm-4.347-3.71c0 .739.586 1.255 1.383 1.255s1.377-.516 1.377-1.254c0-.733-.58-1.23-1.377-1.23s-1.383.497-1.383 1.23Zm-.281 3.645c0 .838.72 1.412 1.664 1.412.943 0 1.658-.574 1.658-1.412 0-.843-.715-1.424-1.658-1.424-.944 0-1.664.58-1.664 1.424Z"
                }
            }
        ]
    })(props);
}
function Bs8SquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.623 6.094c0 .738.586 1.254 1.383 1.254s1.377-.516 1.377-1.254c0-.733-.58-1.23-1.377-1.23s-1.383.497-1.383 1.23Zm-.281 3.644c0 .838.72 1.412 1.664 1.412.943 0 1.658-.574 1.658-1.412 0-.843-.715-1.424-1.658-1.424-.944 0-1.664.58-1.664 1.424Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm8.97 9.803c0 1.394-1.218 2.355-2.988 2.355-1.763 0-2.953-.955-2.953-2.344 0-1.271.95-1.851 1.647-2.003v-.065c-.621-.193-1.33-.738-1.33-1.781 0-1.225 1.09-2.121 2.66-2.121s2.654.896 2.654 2.12c0 1.061-.738 1.595-1.336 1.782v.065c.703.152 1.647.744 1.647 1.992Z"
                }
            }
        ]
    })(props);
}
function Bs8Square(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.97 9.803c0 1.394-1.218 2.355-2.988 2.355-1.763 0-2.953-.955-2.953-2.344 0-1.271.95-1.851 1.647-2.003v-.065c-.621-.193-1.33-.738-1.33-1.781 0-1.225 1.09-2.121 2.66-2.121s2.654.896 2.654 2.12c0 1.061-.738 1.595-1.336 1.782v.065c.703.152 1.647.744 1.647 1.992Zm-4.347-3.71c0 .739.586 1.255 1.383 1.255s1.377-.516 1.377-1.254c0-.733-.58-1.23-1.377-1.23s-1.383.497-1.383 1.23Zm-.281 3.645c0 .838.72 1.412 1.664 1.412.943 0 1.658-.574 1.658-1.412 0-.843-.715-1.424-1.658-1.424-.944 0-1.664.58-1.664 1.424Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2Z"
                }
            }
        ]
    })(props);
}
function Bs9CircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-8.223 4.146c2.104 0 3.123-1.464 3.123-4.3 0-3.147-1.459-4.014-2.97-4.014-1.63 0-2.871 1.02-2.871 2.73 0 1.706 1.171 2.667 2.566 2.667 1.06 0 1.7-.557 1.934-1.184h.076c.047 1.67-.475 3.023-1.834 3.023-.71 0-1.149-.363-1.248-.72H5.258c.094.908.926 1.798 2.52 1.798Zm.118-3.972c.808 0 1.535-.528 1.535-1.594s-.668-1.676-1.56-1.676c-.838 0-1.517.616-1.517 1.659 0 1.072.708 1.61 1.54 1.61Z"
                }
            }
        ]
    })(props);
}
function Bs9Circle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8Zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-8.223 4.146c-1.593 0-2.425-.89-2.52-1.798h1.296c.1.357.539.72 1.248.72 1.36 0 1.88-1.353 1.834-3.023h-.076c-.235.627-.873 1.184-1.934 1.184-1.395 0-2.566-.961-2.566-2.666 0-1.711 1.242-2.731 2.87-2.731 1.512 0 2.971.867 2.971 4.014 0 2.836-1.02 4.3-3.123 4.3Zm.118-3.972c.808 0 1.535-.528 1.535-1.594s-.668-1.676-1.56-1.676c-.838 0-1.517.616-1.517 1.659 0 1.072.708 1.61 1.54 1.61Z"
                }
            }
        ]
    })(props);
}
function Bs9SquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.895 8.174c.808 0 1.535-.528 1.535-1.594s-.668-1.676-1.56-1.676c-.838 0-1.517.616-1.517 1.659 0 1.072.708 1.61 1.54 1.61Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm5.777 12.146c-1.593 0-2.425-.89-2.52-1.798h1.296c.1.357.539.72 1.248.72 1.36 0 1.88-1.353 1.834-3.023h-.076c-.235.627-.873 1.184-1.934 1.184-1.395 0-2.566-.961-2.566-2.666 0-1.711 1.242-2.731 2.87-2.731 1.512 0 2.971.867 2.971 4.014 0 2.836-1.02 4.3-3.123 4.3Z"
                }
            }
        ]
    })(props);
}
function Bs9Square(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.777 12.146c-1.593 0-2.425-.89-2.52-1.798h1.296c.1.357.539.72 1.248.72 1.36 0 1.88-1.353 1.834-3.023h-.076c-.235.627-.873 1.184-1.934 1.184-1.395 0-2.566-.961-2.566-2.666 0-1.711 1.242-2.731 2.87-2.731 1.512 0 2.971.867 2.971 4.014 0 2.836-1.02 4.3-3.123 4.3Zm.118-3.972c.808 0 1.535-.528 1.535-1.594s-.668-1.676-1.56-1.676c-.838 0-1.517.616-1.517 1.659 0 1.072.708 1.61 1.54 1.61Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2Z"
                }
            }
        ]
    })(props);
}
function BsActivity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 2a.5.5 0 0 1 .47.33L10 12.036l1.53-4.208A.5.5 0 0 1 12 7.5h3.5a.5.5 0 0 1 0 1h-3.15l-1.88 5.17a.5.5 0 0 1-.94 0L6 3.964 4.47 8.171A.5.5 0 0 1 4 8.5H.5a.5.5 0 0 1 0-1h3.15l1.88-5.17A.5.5 0 0 1 6 2Z"
                }
            }
        ]
    })(props);
}
function BsAirplaneEnginesFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-.787 0-1.292.592-1.572 1.151A4.347 4.347 0 0 0 6 3v3.691l-2 1V7.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.191l-1.17.585A1.5 1.5 0 0 0 0 10.618V12a.5.5 0 0 0 .582.493l1.631-.272.313.937a.5.5 0 0 0 .948 0l.405-1.214 2.21-.369.375 2.253-1.318 1.318A.5.5 0 0 0 5.5 16h5a.5.5 0 0 0 .354-.854l-1.318-1.318.375-2.253 2.21.369.405 1.214a.5.5 0 0 0 .948 0l.313-.937 1.63.272A.5.5 0 0 0 16 12v-1.382a1.5 1.5 0 0 0-.83-1.342L14 8.691V7.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v.191l-2-1V3c0-.568-.14-1.271-.428-1.849C9.292.591 8.787 0 8 0Z"
                }
            }
        ]
    })(props);
}
function BsAirplaneEngines(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-.787 0-1.292.592-1.572 1.151A4.347 4.347 0 0 0 6 3v3.691l-2 1V7.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.191l-1.17.585A1.5 1.5 0 0 0 0 10.618V12a.5.5 0 0 0 .582.493l1.631-.272.313.937a.5.5 0 0 0 .948 0l.405-1.214 2.21-.369.375 2.253-1.318 1.318A.5.5 0 0 0 5.5 16h5a.5.5 0 0 0 .354-.854l-1.318-1.318.375-2.253 2.21.369.405 1.214a.5.5 0 0 0 .948 0l.313-.937 1.63.272A.5.5 0 0 0 16 12v-1.382a1.5 1.5 0 0 0-.83-1.342L14 8.691V7.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v.191l-2-1V3c0-.568-.14-1.271-.428-1.849C9.292.591 8.787 0 8 0ZM7 3c0-.432.11-.979.322-1.401C7.542 1.159 7.787 1 8 1c.213 0 .458.158.678.599C8.889 2.02 9 2.569 9 3v4a.5.5 0 0 0 .276.447l5.448 2.724a.5.5 0 0 1 .276.447v.792l-5.418-.903a.5.5 0 0 0-.575.41l-.5 3a.5.5 0 0 0 .14.437l.646.646H6.707l.647-.646a.5.5 0 0 0 .14-.436l-.5-3a.5.5 0 0 0-.576-.411L1 11.41v-.792a.5.5 0 0 1 .276-.447l5.448-2.724A.5.5 0 0 0 7 7V3Z"
                }
            }
        ]
    })(props);
}
function BsAirplaneFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.428 1.151C6.708.591 7.213 0 8 0s1.292.592 1.572 1.151C9.861 1.73 10 2.431 10 3v3.691l5.17 2.585a1.5 1.5 0 0 1 .83 1.342V12a.5.5 0 0 1-.582.493l-5.507-.918-.375 2.253 1.318 1.318A.5.5 0 0 1 10.5 16h-5a.5.5 0 0 1-.354-.854l1.319-1.318-.376-2.253-5.507.918A.5.5 0 0 1 0 12v-1.382a1.5 1.5 0 0 1 .83-1.342L6 6.691V3c0-.568.14-1.271.428-1.849Z"
                }
            }
        ]
    })(props);
}
function BsAirplane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.428 1.151C6.708.591 7.213 0 8 0s1.292.592 1.572 1.151C9.861 1.73 10 2.431 10 3v3.691l5.17 2.585a1.5 1.5 0 0 1 .83 1.342V12a.5.5 0 0 1-.582.493l-5.507-.918-.375 2.253 1.318 1.318A.5.5 0 0 1 10.5 16h-5a.5.5 0 0 1-.354-.854l1.319-1.318-.376-2.253-5.507.918A.5.5 0 0 1 0 12v-1.382a1.5 1.5 0 0 1 .83-1.342L6 6.691V3c0-.568.14-1.271.428-1.849Zm.894.448C7.111 2.02 7 2.569 7 3v4a.5.5 0 0 1-.276.447l-5.448 2.724a.5.5 0 0 0-.276.447v.792l5.418-.903a.5.5 0 0 1 .575.41l.5 3a.5.5 0 0 1-.14.437L6.708 15h2.586l-.647-.646a.5.5 0 0 1-.14-.436l.5-3a.5.5 0 0 1 .576-.411L15 11.41v-.792a.5.5 0 0 0-.276-.447L9.276 7.447A.5.5 0 0 1 9 7V3c0-.432-.11-.979-.322-1.401C8.458 1.159 8.213 1 8 1c-.213 0-.458.158-.678.599Z"
                }
            }
        ]
    })(props);
}
function BsAlarmFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 .5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1H9v1.07a7.001 7.001 0 0 1 3.274 12.474l.601.602a.5.5 0 0 1-.707.708l-.746-.746A6.97 6.97 0 0 1 8 16a6.97 6.97 0 0 1-3.422-.892l-.746.746a.5.5 0 0 1-.707-.708l.602-.602A7.001 7.001 0 0 1 7 2.07V1h-.5A.5.5 0 0 1 6 .5zm2.5 5a.5.5 0 0 0-1 0v3.362l-1.429 2.38a.5.5 0 1 0 .858.515l1.5-2.5A.5.5 0 0 0 8.5 9V5.5zM.86 5.387A2.5 2.5 0 1 1 4.387 1.86 8.035 8.035 0 0 0 .86 5.387zM11.613 1.86a2.5 2.5 0 1 1 3.527 3.527 8.035 8.035 0 0 0-3.527-3.527z"
                }
            }
        ]
    })(props);
}
function BsAlarm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 5.5a.5.5 0 0 0-1 0v3.362l-1.429 2.38a.5.5 0 1 0 .858.515l1.5-2.5A.5.5 0 0 0 8.5 9V5.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 0a.5.5 0 0 0 0 1H7v1.07a7.001 7.001 0 0 0-3.273 12.474l-.602.602a.5.5 0 0 0 .707.708l.746-.746A6.97 6.97 0 0 0 8 16a6.97 6.97 0 0 0 3.422-.892l.746.746a.5.5 0 0 0 .707-.708l-.601-.602A7.001 7.001 0 0 0 9 2.07V1h.5a.5.5 0 0 0 0-1h-3zm1.038 3.018a6.093 6.093 0 0 1 .924 0 6 6 0 1 1-.924 0zM0 3.5c0 .753.333 1.429.86 1.887A8.035 8.035 0 0 1 4.387 1.86 2.5 2.5 0 0 0 0 3.5zM13.5 1c-.753 0-1.429.333-1.887.86a8.035 8.035 0 0 1 3.527 3.527A2.5 2.5 0 0 0 13.5 1z"
                }
            }
        ]
    })(props);
}
function BsAlexa(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.996 0A7.998 7.998 0 0 0 0 8a8 8 0 0 0 6.93 7.93v-1.613a1.06 1.06 0 0 0-.717-1.008A5.602 5.602 0 0 1 2.4 7.865 5.579 5.579 0 0 1 8.054 2.4a5.599 5.599 0 0 1 5.535 5.81l-.002.046a6.116 6.116 0 0 1-.012.192l-.005.061a4.85 4.85 0 0 1-.033.284l-.01.068c-.685 4.516-6.564 7.054-6.596 7.068A7.998 7.998 0 0 0 15.992 8 7.998 7.998 0 0 0 7.996.001Z"
                }
            }
        ]
    })(props);
}
function BsAlignBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "4",
                    "height": "12",
                    "x": "6",
                    "y": "1",
                    "rx": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 14a.5.5 0 0 0 0 1v-1zm13 1a.5.5 0 0 0 0-1v1zm-13 0h13v-1h-13v1z"
                }
            }
        ]
    })(props);
}
function BsAlignCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1a.5.5 0 0 1 .5.5V6h-1V1.5A.5.5 0 0 1 8 1zm0 14a.5.5 0 0 1-.5-.5V10h1v4.5a.5.5 0 0 1-.5.5zM2 7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7z"
                }
            }
        ]
    })(props);
}
function BsAlignEnd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 1 0v-13a.5.5 0 0 0-.5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7z"
                }
            }
        ]
    })(props);
}
function BsAlignMiddle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 13a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v10zM1 8a.5.5 0 0 0 .5.5H6v-1H1.5A.5.5 0 0 0 1 8zm14 0a.5.5 0 0 1-.5.5H10v-1h4.5a.5.5 0 0 1 .5.5z"
                }
            }
        ]
    })(props);
}
function BsAlignStart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.5 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13a.5.5 0 0 1 .5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7z"
                }
            }
        ]
    })(props);
}
function BsAlignTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "4",
                    "height": "12",
                    "rx": "1",
                    "transform": "matrix(1 0 0 -1 6 15)"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 2a.5.5 0 0 1 0-1v1zm13-1a.5.5 0 0 1 0 1V1zm-13 0h13v1h-13V1z"
                }
            }
        ]
    })(props);
}
function BsAlipay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.541 0H13.5a2.551 2.551 0 0 1 2.54 2.563v8.297c-.006 0-.531-.046-2.978-.813-.412-.14-.916-.327-1.479-.536-.303-.113-.624-.232-.957-.353a12.98 12.98 0 0 0 1.325-3.373H8.822V4.649h3.831v-.634h-3.83V2.121H7.26c-.274 0-.274.273-.274.273v1.621H3.11v.634h3.875v1.136h-3.2v.634H9.99c-.227.789-.532 1.53-.894 2.202-2.013-.67-4.161-1.212-5.51-.878-.864.214-1.42.597-1.746.998-1.499 1.84-.424 4.633 2.741 4.633 1.872 0 3.675-1.053 5.072-2.787 2.08 1.008 6.37 2.738 6.387 2.745v.105A2.551 2.551 0 0 1 13.5 16H2.541A2.552 2.552 0 0 1 0 13.437V2.563A2.552 2.552 0 0 1 2.541 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.309 9.27c-1.22 1.073-.49 3.034 1.978 3.034 1.434 0 2.868-.925 3.994-2.406-1.602-.789-2.959-1.353-4.425-1.207-.397.04-1.14.217-1.547.58Z"
                }
            }
        ]
    })(props);
}
function BsAlphabetUppercase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.226 10.88H0l2.056-6.26h1.42l2.047 6.26h-1.29l-.48-1.61H1.707l-.48 1.61ZM2.76 5.818h-.054l-.75 2.532H3.51l-.75-2.532Zm3.217 5.062V4.62h2.56c1.09 0 1.808.582 1.808 1.54 0 .762-.444 1.22-1.05 1.372v.055c.736.074 1.365.587 1.365 1.528 0 1.119-.89 1.766-2.133 1.766h-2.55ZM7.18 5.55v1.675h.8c.812 0 1.171-.308 1.171-.853 0-.51-.328-.822-.898-.822H7.18Zm0 2.537V9.95h.903c.951 0 1.342-.312 1.342-.909 0-.591-.382-.954-1.095-.954H7.18Zm5.089-.711v.775c0 1.156.49 1.803 1.347 1.803.705 0 1.163-.454 1.212-1.096H16v.12C15.942 10.173 14.95 11 13.607 11c-1.648 0-2.573-1.073-2.573-2.849v-.78c0-1.775.934-2.871 2.573-2.871 1.347 0 2.34.849 2.393 2.087v.115h-1.172c-.05-.665-.516-1.156-1.212-1.156-.849 0-1.347.67-1.347 1.83Z"
                }
            }
        ]
    })(props);
}
function BsAlphabet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.204 11.078c.767 0 1.201-.356 1.406-.737h.059V11h1.216V7.519c0-1.314-.947-1.783-2.11-1.783C1.355 5.736.75 6.42.69 7.27h1.216c.064-.323.313-.552.84-.552.527 0 .864.249.864.771v.464H2.346C1.145 7.953.5 8.568.5 9.496c0 .977.693 1.582 1.704 1.582Zm.42-.947c-.44 0-.845-.235-.845-.718 0-.395.269-.684.84-.684h.991v.538c0 .503-.444.864-.986.864Zm5.593.937c1.216 0 1.948-.869 1.948-2.31v-.702c0-1.44-.727-2.305-1.929-2.305-.742 0-1.328.347-1.499.889h-.063V3.983h-1.29V11h1.27v-.791h.064c.21.532.776.86 1.499.86Zm-.43-1.025c-.66 0-1.113-.518-1.113-1.28V8.12c0-.825.42-1.343 1.098-1.343.684 0 1.075.518 1.075 1.416v.45c0 .888-.386 1.401-1.06 1.401Zm2.834-1.328c0 1.47.87 2.378 2.305 2.378 1.416 0 2.139-.777 2.158-1.763h-1.186c-.06.425-.313.732-.933.732-.66 0-1.05-.512-1.05-1.352v-.625c0-.81.371-1.328 1.045-1.328.635 0 .879.425.918.776h1.187c-.02-.986-.787-1.806-2.14-1.806-1.41 0-2.304.918-2.304 2.338v.65Z"
                }
            }
        ]
    })(props);
}
function BsAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 13.5a.5.5 0 0 0 .5.5h3.797a.5.5 0 0 0 .439-.26L11 3h3.5a.5.5 0 0 0 0-1h-3.797a.5.5 0 0 0-.439.26L5 13H1.5a.5.5 0 0 0-.5.5zm10 0a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5z"
                }
            }
        ]
    })(props);
}
function BsAmazon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.813 11.968c.157.083.36.074.5-.05l.005.005a89.521 89.521 0 0 1 1.623-1.405c.173-.143.143-.372.006-.563l-.125-.17c-.345-.465-.673-.906-.673-1.791v-3.3l.001-.335c.008-1.265.014-2.421-.933-3.305C10.404.274 9.06 0 8.03 0 6.017 0 3.77.75 3.296 3.24c-.047.264.143.404.316.443l2.054.22c.19-.009.33-.196.366-.387.176-.857.896-1.271 1.703-1.271.435 0 .929.16 1.188.55.264.39.26.91.257 1.376v.432c-.199.022-.407.044-.621.065-1.113.114-2.397.246-3.36.67C3.873 5.91 2.94 7.08 2.94 8.798c0 2.2 1.387 3.298 3.168 3.298 1.506 0 2.328-.354 3.489-1.54l.167.246c.274.405.456.675 1.047 1.166ZM6.03 8.431C6.03 6.627 7.647 6.3 9.177 6.3v.57c.001.776.002 1.434-.396 2.133-.336.595-.87.961-1.465.961-.812 0-1.286-.619-1.286-1.533ZM.435 12.174c2.629 1.603 6.698 4.084 13.183.997.28-.116.475.078.199.431C13.538 13.96 11.312 16 7.57 16 3.832 16 .968 13.446.094 12.386c-.24-.275.036-.4.199-.299l.142.087Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.828 11.943c.567-.07 1.468-.027 1.645.204.135.176-.004.966-.233 1.533-.23.563-.572.961-.762 1.115-.191.154-.333.094-.23-.137.105-.23.684-1.663.455-1.963-.213-.278-1.177-.177-1.625-.13l-.09.009c-.095.008-.172.017-.233.024-.193.021-.245.027-.274-.032-.074-.209.779-.556 1.347-.623Z"
                }
            }
        ]
    })(props);
}
function BsAmd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m.334 0 4.358 4.359h7.15v7.15l4.358 4.358V0H.334ZM.2 9.72l4.487-4.488v6.281h6.28L6.48 16H.2V9.72Z"
                }
            }
        ]
    })(props);
}
function BsAndroid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.76 3.061a.5.5 0 0 1 .679.2l1.283 2.352A8.94 8.94 0 0 1 8 5a8.94 8.94 0 0 1 3.278.613l1.283-2.352a.5.5 0 1 1 .878.478l-1.252 2.295C14.475 7.266 16 9.477 16 12H0c0-2.523 1.525-4.734 3.813-5.966L2.56 3.74a.5.5 0 0 1 .2-.678ZM5 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm6 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
                }
            }
        ]
    })(props);
}
function BsAndroid2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10.213 1.471.691-1.26c.046-.083.03-.147-.048-.192-.085-.038-.15-.019-.195.058l-.7 1.27A4.832 4.832 0 0 0 8.005.941c-.688 0-1.34.135-1.956.404l-.7-1.27C5.303 0 5.239-.018 5.154.02c-.078.046-.094.11-.049.193l.691 1.259a4.25 4.25 0 0 0-1.673 1.476A3.697 3.697 0 0 0 3.5 5.02h9c0-.75-.208-1.44-.623-2.072a4.266 4.266 0 0 0-1.664-1.476ZM6.22 3.303a.367.367 0 0 1-.267.11.35.35 0 0 1-.263-.11.366.366 0 0 1-.107-.264.37.37 0 0 1 .107-.265.351.351 0 0 1 .263-.11c.103 0 .193.037.267.11a.36.36 0 0 1 .112.265.36.36 0 0 1-.112.264Zm4.101 0a.351.351 0 0 1-.262.11.366.366 0 0 1-.268-.11.358.358 0 0 1-.112-.264c0-.103.037-.191.112-.265a.367.367 0 0 1 .268-.11c.104 0 .19.037.262.11a.367.367 0 0 1 .107.265c0 .102-.035.19-.107.264ZM3.5 11.77c0 .294.104.544.311.75.208.204.46.307.76.307h.758l.01 2.182c0 .276.097.51.292.703a.961.961 0 0 0 .7.288.973.973 0 0 0 .71-.288.95.95 0 0 0 .292-.703v-2.182h1.343v2.182c0 .276.097.51.292.703a.972.972 0 0 0 .71.288.973.973 0 0 0 .71-.288.95.95 0 0 0 .292-.703v-2.182h.76c.291 0 .54-.103.749-.308.207-.205.311-.455.311-.75V5.365h-9v6.404Zm10.495-6.587a.983.983 0 0 0-.702.278.91.91 0 0 0-.293.685v4.063c0 .271.098.501.293.69a.97.97 0 0 0 .702.284c.28 0 .517-.095.712-.284a.924.924 0 0 0 .293-.69V6.146a.91.91 0 0 0-.293-.685.995.995 0 0 0-.712-.278Zm-12.702.283a.985.985 0 0 1 .712-.283c.273 0 .507.094.702.283a.913.913 0 0 1 .293.68v4.063a.932.932 0 0 1-.288.69.97.97 0 0 1-.707.284.986.986 0 0 1-.712-.284.924.924 0 0 1-.293-.69V6.146c0-.264.098-.491.293-.68Z"
                }
            }
        ]
    })(props);
}
function BsAppIndicator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 2A3.5 3.5 0 0 0 2 5.5v5A3.5 3.5 0 0 0 5.5 14h5a3.5 3.5 0 0 0 3.5-3.5V8a.5.5 0 0 1 1 0v2.5a4.5 4.5 0 0 1-4.5 4.5h-5A4.5 4.5 0 0 1 1 10.5v-5A4.5 4.5 0 0 1 5.5 1H8a.5.5 0 0 1 0 1H5.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"
                }
            }
        ]
    })(props);
}
function BsApp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h6zM5 1a4 4 0 0 0-4 4v6a4 4 0 0 0 4 4h6a4 4 0 0 0 4-4V5a4 4 0 0 0-4-4H5z"
                }
            }
        ]
    })(props);
}
function BsApple(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516.024.034 1.52.087 2.475-1.258.955-1.345.762-2.391.728-2.43Zm3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422.212-2.189 1.675-2.789 1.698-2.854.023-.065-.597-.79-1.254-1.157a3.692 3.692 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56.244.729.625 1.924 1.273 2.796.576.984 1.34 1.667 1.659 1.899.319.232 1.219.386 1.843.067.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758.347-.79.505-1.217.473-1.282Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516.024.034 1.52.087 2.475-1.258.955-1.345.762-2.391.728-2.43Zm3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422.212-2.189 1.675-2.789 1.698-2.854.023-.065-.597-.79-1.254-1.157a3.692 3.692 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56.244.729.625 1.924 1.273 2.796.576.984 1.34 1.667 1.659 1.899.319.232 1.219.386 1.843.067.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758.347-.79.505-1.217.473-1.282Z"
                }
            }
        ]
    })(props);
}
function BsArchiveFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15h9.286zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8H.8z"
                }
            }
        ]
    })(props);
}
function BsArchive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 12.5V5a1 1 0 0 1-1-1V2zm2 3v7.5A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5V5H2zm13-3H1v2h14V2zM5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsArrow90DegDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.854 14.854a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V3.5A2.5 2.5 0 0 1 6.5 1h8a.5.5 0 0 1 0 1h-8A1.5 1.5 0 0 0 5 3.5v9.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4z"
                }
            }
        ]
    })(props);
}
function BsArrow90DegLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.146 4.854a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H12.5A2.5 2.5 0 0 1 15 6.5v8a.5.5 0 0 1-1 0v-8A1.5 1.5 0 0 0 12.5 5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4z"
                }
            }
        ]
    })(props);
}
function BsArrow90DegRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14.854 4.854a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 4H3.5A2.5 2.5 0 0 0 1 6.5v8a.5.5 0 0 0 1 0v-8A1.5 1.5 0 0 1 3.5 5h9.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4z"
                }
            }
        ]
    })(props);
}
function BsArrow90DegUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.854 1.146a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L4 2.707V12.5A2.5 2.5 0 0 0 6.5 15h8a.5.5 0 0 0 0-1h-8A1.5 1.5 0 0 1 5 12.5V2.707l3.146 3.147a.5.5 0 1 0 .708-.708l-4-4z"
                }
            }
        ]
    })(props);
}
function BsArrowBarDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 3.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5zM8 6a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 0 1 .708-.708L7.5 12.293V6.5A.5.5 0 0 1 8 6z"
                }
            }
        ]
    })(props);
}
function BsArrowBarLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.5 15a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5ZM10 8a.5.5 0 0 1-.5.5H3.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L3.707 7.5H9.5a.5.5 0 0 1 .5.5Z"
                }
            }
        ]
    })(props);
}
function BsArrowBarRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 8a.5.5 0 0 0 .5.5h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L12.293 7.5H6.5A.5.5 0 0 0 6 8Zm-2.5 7a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5Z"
                }
            }
        ]
    })(props);
}
function BsArrowBarUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 10a.5.5 0 0 0 .5-.5V3.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 3.707V9.5a.5.5 0 0 0 .5.5zm-7 2.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsArrowClockwise(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"
                }
            }
        ]
    })(props);
}
function BsArrowCounterclockwise(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z"
                }
            }
        ]
    })(props);
}
function BsArrowDownCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V4.5z"
                }
            }
        ]
    })(props);
}
function BsArrowDownCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V4.5z"
                }
            }
        ]
    })(props);
}
function BsArrowDownLeftCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0zm-5.904-2.803a.5.5 0 1 1 .707.707L6.707 10h2.768a.5.5 0 0 1 0 1H5.5a.5.5 0 0 1-.5-.5V6.525a.5.5 0 0 1 1 0v2.768l4.096-4.096z"
                }
            }
        ]
    })(props);
}
function BsArrowDownLeftCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-5.904-2.854a.5.5 0 1 1 .707.708L6.707 9.95h2.768a.5.5 0 1 1 0 1H5.5a.5.5 0 0 1-.5-.5V6.475a.5.5 0 1 1 1 0v2.768l4.096-4.097z"
                }
            }
        ]
    })(props);
}
function BsArrowDownLeftSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2zm8.096-10.803L6 9.293V6.525a.5.5 0 0 0-1 0V10.5a.5.5 0 0 0 .5.5h3.975a.5.5 0 0 0 0-1H6.707l4.096-4.096a.5.5 0 1 0-.707-.707z"
                }
            }
        ]
    })(props);
}
function BsArrowDownLeftSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm10.096 3.146a.5.5 0 1 1 .707.708L6.707 9.95h2.768a.5.5 0 1 1 0 1H5.5a.5.5 0 0 1-.5-.5V6.475a.5.5 0 1 1 1 0v2.768l4.096-4.097z"
                }
            }
        ]
    })(props);
}
function BsArrowDownLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 13.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 0-1H3.707L13.854 2.854a.5.5 0 0 0-.708-.708L3 12.293V7.5a.5.5 0 0 0-1 0v6z"
                }
            }
        ]
    })(props);
}
function BsArrowDownRightCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm5.904-2.803a.5.5 0 1 0-.707.707L9.293 10H6.525a.5.5 0 0 0 0 1H10.5a.5.5 0 0 0 .5-.5V6.525a.5.5 0 0 0-1 0v2.768L5.904 5.197z"
                }
            }
        ]
    })(props);
}
function BsArrowDownRightCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.854 5.146a.5.5 0 1 0-.708.708L9.243 9.95H6.475a.5.5 0 1 0 0 1h3.975a.5.5 0 0 0 .5-.5V6.475a.5.5 0 1 0-1 0v2.768L5.854 5.146z"
                }
            }
        ]
    })(props);
}
function BsArrowDownRightSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12zM5.904 5.197 10 9.293V6.525a.5.5 0 0 1 1 0V10.5a.5.5 0 0 1-.5.5H6.525a.5.5 0 0 1 0-1h2.768L5.197 5.904a.5.5 0 0 1 .707-.707z"
                }
            }
        ]
    })(props);
}
function BsArrowDownRightSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm5.854 3.146a.5.5 0 1 0-.708.708L9.243 9.95H6.475a.5.5 0 1 0 0 1h3.975a.5.5 0 0 0 .5-.5V6.475a.5.5 0 1 0-1 0v2.768L5.854 5.146z"
                }
            }
        ]
    })(props);
}
function BsArrowDownRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 13.5a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1 0-1h4.793L2.146 2.854a.5.5 0 1 1 .708-.708L13 12.293V7.5a.5.5 0 0 1 1 0v6z"
                }
            }
        ]
    })(props);
}
function BsArrowDownShort(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4z"
                }
            }
        ]
    })(props);
}
function BsArrowDownSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5a.5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsArrowDownSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.5 2.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V4.5z"
                }
            }
        ]
    })(props);
}
function BsArrowDownUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"
                }
            }
        ]
    })(props);
}
function BsArrowLeftCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"
                }
            }
        ]
    })(props);
}
function BsArrowLeftCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"
                }
            }
        ]
    })(props);
}
function BsArrowLeftRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5zm14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5z"
                }
            }
        ]
    })(props);
}
function BsArrowLeftShort(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"
                }
            }
        ]
    })(props);
}
function BsArrowLeftSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12zm-4.5-6.5H5.707l2.147-2.146a.5.5 0 1 0-.708-.708l-3 3a.5.5 0 0 0 0 .708l3 3a.5.5 0 0 0 .708-.708L5.707 8.5H11.5a.5.5 0 0 0 0-1z"
                }
            }
        ]
    })(props);
}
function BsArrowLeftSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm11.5 5.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"
                }
            }
        ]
    })(props);
}
function BsArrowLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
                }
            }
        ]
    })(props);
}
function BsArrowRepeat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"
                }
            }
        ]
    })(props);
}
function BsArrowReturnLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsArrowReturnRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.5 1.5A.5.5 0 0 0 1 2v4.8a2.5 2.5 0 0 0 2.5 2.5h9.793l-3.347 3.346a.5.5 0 0 0 .708.708l4.2-4.2a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 8.3H3.5A1.5 1.5 0 0 1 2 6.8V2a.5.5 0 0 0-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsArrowRightCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"
                }
            }
        ]
    })(props);
}
function BsArrowRightCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"
                }
            }
        ]
    })(props);
}
function BsArrowRightShort(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"
                }
            }
        ]
    })(props);
}
function BsArrowRightSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v12zm4.5-6.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsArrowRightSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm4.5 5.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"
                }
            }
        ]
    })(props);
}
function BsArrowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                }
            }
        ]
    })(props);
}
function BsArrowThroughHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.854 15.854A.5.5 0 0 1 2 15.5V14H.5a.5.5 0 0 1-.354-.854l1.5-1.5A.5.5 0 0 1 2 11.5h1.793l3.103-3.104a.5.5 0 1 1 .708.708L4.5 12.207V14a.5.5 0 0 1-.146.354l-1.5 1.5ZM16 3.5a.5.5 0 0 1-.854.354L14 2.707l-1.006 1.006c.236.248.44.531.6.845.562 1.096.585 2.517-.213 4.092-.793 1.563-2.395 3.288-5.105 5.08L8 13.912l-.276-.182A23.825 23.825 0 0 1 5.8 12.323L8.31 9.81a1.5 1.5 0 0 0-2.122-2.122L3.657 10.22a8.827 8.827 0 0 1-1.039-1.57c-.798-1.576-.775-2.997-.213-4.093C3.426 2.565 6.18 1.809 8 3.233c1.25-.98 2.944-.928 4.212-.152L13.292 2 12.147.854A.5.5 0 0 1 12.5 0h3a.5.5 0 0 1 .5.5v3Z"
                }
            }
        ]
    })(props);
}
function BsArrowThroughHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.854 15.854A.5.5 0 0 1 2 15.5V14H.5a.5.5 0 0 1-.354-.854l1.5-1.5A.5.5 0 0 1 2 11.5h1.793l.53-.53c-.771-.802-1.328-1.58-1.704-2.32-.798-1.575-.775-2.996-.213-4.092C3.426 2.565 6.18 1.809 8 3.233c1.25-.98 2.944-.928 4.212-.152L13.292 2 12.147.854A.5.5 0 0 1 12.5 0h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.854.354L14 2.707l-1.006 1.006c.236.248.44.531.6.845.562 1.096.585 2.517-.213 4.092-.793 1.563-2.395 3.288-5.105 5.08L8 13.912l-.276-.182a21.86 21.86 0 0 1-2.685-2.062l-.539.54V14a.5.5 0 0 1-.146.354l-1.5 1.5Zm2.893-4.894A20.419 20.419 0 0 0 8 12.71c2.456-1.666 3.827-3.207 4.489-4.512.679-1.34.607-2.42.215-3.185-.817-1.595-3.087-2.054-4.346-.761L8 4.62l-.358-.368c-1.259-1.293-3.53-.834-4.346.761-.392.766-.464 1.845.215 3.185.323.636.815 1.33 1.519 2.065l1.866-1.867a.5.5 0 1 1 .708.708L5.747 10.96Z"
                }
            }
        ]
    })(props);
}
function BsArrowUpCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0zm-7.5 3.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11.5z"
                }
            }
        ]
    })(props);
}
function BsArrowUpCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-7.5 3.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11.5z"
                }
            }
        ]
    })(props);
}
function BsArrowUpLeftCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-5.904 2.803a.5.5 0 1 0 .707-.707L6.707 6h2.768a.5.5 0 1 0 0-1H5.5a.5.5 0 0 0-.5.5v3.975a.5.5 0 0 0 1 0V6.707l4.096 4.096z"
                }
            }
        ]
    })(props);
}
function BsArrowUpLeftCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-5.904 2.803a.5.5 0 1 0 .707-.707L6.707 6h2.768a.5.5 0 1 0 0-1H5.5a.5.5 0 0 0-.5.5v3.975a.5.5 0 0 0 1 0V6.707l4.096 4.096z"
                }
            }
        ]
    })(props);
}
function BsArrowUpLeftSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm8.096 10.803L6 6.707v2.768a.5.5 0 0 1-1 0V5.5a.5.5 0 0 1 .5-.5h3.975a.5.5 0 1 1 0 1H6.707l4.096 4.096a.5.5 0 1 1-.707.707z"
                }
            }
        ]
    })(props);
}
function BsArrowUpLeftSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm10.096 8.803a.5.5 0 1 0 .707-.707L6.707 6h2.768a.5.5 0 1 0 0-1H5.5a.5.5 0 0 0-.5.5v3.975a.5.5 0 0 0 1 0V6.707l4.096 4.096z"
                }
            }
        ]
    })(props);
}
function BsArrowUpLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 2.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H3.707l10.147 10.146a.5.5 0 0 1-.708.708L3 3.707V8.5a.5.5 0 0 1-1 0v-6z"
                }
            }
        ]
    })(props);
}
function BsArrowUpRightCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 8a8 8 0 1 0 16 0A8 8 0 0 0 0 8zm5.904 2.803a.5.5 0 1 1-.707-.707L9.293 6H6.525a.5.5 0 1 1 0-1H10.5a.5.5 0 0 1 .5.5v3.975a.5.5 0 0 1-1 0V6.707l-4.096 4.096z"
                }
            }
        ]
    })(props);
}
function BsArrowUpRightCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.854 10.803a.5.5 0 1 1-.708-.707L9.243 6H6.475a.5.5 0 1 1 0-1h3.975a.5.5 0 0 1 .5.5v3.975a.5.5 0 1 1-1 0V6.707l-4.096 4.096z"
                }
            }
        ]
    })(props);
}
function BsArrowUpRightSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12zM5.904 10.803 10 6.707v2.768a.5.5 0 0 0 1 0V5.5a.5.5 0 0 0-.5-.5H6.525a.5.5 0 1 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 .707.707z"
                }
            }
        ]
    })(props);
}
function BsArrowUpRightSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm5.854 8.803a.5.5 0 1 1-.708-.707L9.243 6H6.475a.5.5 0 1 1 0-1h3.975a.5.5 0 0 1 .5.5v3.975a.5.5 0 1 1-1 0V6.707l-4.096 4.096z"
                }
            }
        ]
    })(props);
}
function BsArrowUpRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 2.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0 0 1h4.793L2.146 13.146a.5.5 0 0 0 .708.708L13 3.707V8.5a.5.5 0 0 0 1 0v-6z"
                }
            }
        ]
    })(props);
}
function BsArrowUpShort(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5z"
                }
            }
        ]
    })(props);
}
function BsArrowUpSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2zm6.5-4.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 1 0z"
                }
            }
        ]
    })(props);
}
function BsArrowUpSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.5 9.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11.5z"
                }
            }
        ]
    })(props);
}
function BsArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"
                }
            }
        ]
    })(props);
}
function BsArrowsAngleContract(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M.172 15.828a.5.5 0 0 0 .707 0l4.096-4.096V14.5a.5.5 0 1 0 1 0v-3.975a.5.5 0 0 0-.5-.5H1.5a.5.5 0 0 0 0 1h2.768L.172 15.121a.5.5 0 0 0 0 .707zM15.828.172a.5.5 0 0 0-.707 0l-4.096 4.096V1.5a.5.5 0 1 0-1 0v3.975a.5.5 0 0 0 .5.5H14.5a.5.5 0 0 0 0-1h-2.768L15.828.879a.5.5 0 0 0 0-.707z"
                }
            }
        ]
    })(props);
}
function BsArrowsAngleExpand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707zm4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707z"
                }
            }
        ]
    })(props);
}
function BsArrowsCollapseVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5ZM0 8a.5.5 0 0 1 .5-.5h3.793L3.146 6.354a.5.5 0 1 1 .708-.708l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L4.293 8.5H.5A.5.5 0 0 1 0 8Zm11.707.5 1.147 1.146a.5.5 0 0 1-.708.708l-2-2a.5.5 0 0 1 0-.708l2-2a.5.5 0 0 1 .708.708L11.707 7.5H15.5a.5.5 0 0 1 0 1h-3.793Z"
                }
            }
        ]
    })(props);
}
function BsArrowsCollapse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8Zm7-8a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 4.293V.5A.5.5 0 0 1 8 0Zm-.5 11.707-1.146 1.147a.5.5 0 0 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 11.707V15.5a.5.5 0 0 1-1 0v-3.793Z"
                }
            }
        ]
    })(props);
}
function BsArrowsExpandVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5ZM.146 8.354a.5.5 0 0 1 0-.708l2-2a.5.5 0 1 1 .708.708L1.707 7.5H5.5a.5.5 0 0 1 0 1H1.707l1.147 1.146a.5.5 0 0 1-.708.708l-2-2ZM10 8a.5.5 0 0 1 .5-.5h3.793l-1.147-1.146a.5.5 0 0 1 .708-.708l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L14.293 8.5H10.5A.5.5 0 0 1 10 8Z"
                }
            }
        ]
    })(props);
}
function BsArrowsExpand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8ZM7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708l2-2ZM8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10Z"
                }
            }
        ]
    })(props);
}
function BsArrowsFullscreen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707zm4.344 0a.5.5 0 0 1 .707 0l4.096 4.096V11.5a.5.5 0 1 1 1 0v3.975a.5.5 0 0 1-.5.5H11.5a.5.5 0 0 1 0-1h2.768l-4.096-4.096a.5.5 0 0 1 0-.707zm0-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707zm-4.344 0a.5.5 0 0 1-.707 0L1.025 1.732V4.5a.5.5 0 0 1-1 0V.525a.5.5 0 0 1 .5-.5H4.5a.5.5 0 0 1 0 1H1.732l4.096 4.096a.5.5 0 0 1 0 .707z"
                }
            }
        ]
    })(props);
}
function BsArrowsMove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708l2-2zM8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10zM.146 8.354a.5.5 0 0 1 0-.708l2-2a.5.5 0 1 1 .708.708L1.707 7.5H5.5a.5.5 0 0 1 0 1H1.707l1.147 1.146a.5.5 0 0 1-.708.708l-2-2zM10 8a.5.5 0 0 1 .5-.5h3.793l-1.147-1.146a.5.5 0 0 1 .708-.708l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L14.293 8.5H10.5A.5.5 0 0 1 10 8z"
                }
            }
        ]
    })(props);
}
function BsArrowsVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.354 14.854a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 13.293V2.707L6.354 3.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 2.707v10.586l1.146-1.147a.5.5 0 0 1 .708.708l-2 2Z"
                }
            }
        ]
    })(props);
}
function BsArrows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.146 8.354a.5.5 0 0 1 0-.708l2-2a.5.5 0 1 1 .708.708L2.707 7.5h10.586l-1.147-1.146a.5.5 0 0 1 .708-.708l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L13.293 8.5H2.707l1.147 1.146a.5.5 0 0 1-.708.708l-2-2Z"
                }
            }
        ]
    })(props);
}
function BsAspectRatioFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 12.5v-9A1.5 1.5 0 0 1 1.5 2h13A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5zM2.5 4a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 1 0V5h2.5a.5.5 0 0 0 0-1h-3zm11 8a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-1 0V11h-2.5a.5.5 0 0 0 0 1h3z"
                }
            }
        ]
    })(props);
}
function BsAspectRatio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3.5A1.5 1.5 0 0 1 1.5 2h13A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5v-9zM1.5 3a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1H3v2.5a.5.5 0 0 1-1 0v-3zm12 7a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1H13V8.5a.5.5 0 0 1 1 0v3z"
                }
            }
        ]
    })(props);
}
function BsAsterisk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z"
                }
            }
        ]
    })(props);
}
function BsAt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.106 7.222c0-2.967-2.249-5.032-5.482-5.032-3.35 0-5.646 2.318-5.646 5.702 0 3.493 2.235 5.708 5.762 5.708.862 0 1.689-.123 2.304-.335v-.862c-.43.199-1.354.328-2.29.328-2.926 0-4.813-1.88-4.813-4.798 0-2.844 1.921-4.881 4.594-4.881 2.735 0 4.608 1.688 4.608 4.156 0 1.682-.554 2.769-1.416 2.769-.492 0-.772-.28-.772-.76V5.206H8.923v.834h-.11c-.266-.595-.881-.964-1.6-.964-1.4 0-2.378 1.162-2.378 2.823 0 1.737.957 2.906 2.379 2.906.8 0 1.415-.39 1.709-1.087h.11c.081.67.703 1.148 1.503 1.148 1.572 0 2.57-1.415 2.57-3.643zm-7.177.704c0-1.197.54-1.907 1.456-1.907.93 0 1.524.738 1.524 1.907S8.308 9.84 7.371 9.84c-.895 0-1.442-.725-1.442-1.914z"
                }
            }
        ]
    })(props);
}
function BsAwardFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m8 0 1.669.864 1.858.282.842 1.68 1.337 1.32L13.4 6l.306 1.854-1.337 1.32-.842 1.68-1.858.282L8 12l-1.669-.864-1.858-.282-.842-1.68-1.337-1.32L2.6 6l-.306-1.854 1.337-1.32.842-1.68L6.331.864 8 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1 4 11.794z"
                }
            }
        ]
    })(props);
}
function BsAward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.669.864 8 0 6.331.864l-1.858.282-.842 1.68-1.337 1.32L2.6 6l-.306 1.854 1.337 1.32.842 1.68 1.858.282L8 12l1.669-.864 1.858-.282.842-1.68 1.337-1.32L13.4 6l.306-1.854-1.337-1.32-.842-1.68L9.669.864zm1.196 1.193.684 1.365 1.086 1.072L12.387 6l.248 1.506-1.086 1.072-.684 1.365-1.51.229L8 10.874l-1.355-.702-1.51-.229-.684-1.365-1.086-1.072L3.614 6l-.25-1.506 1.087-1.072.684-1.365 1.51-.229L8 1.126l1.356.702 1.509.229z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1 4 11.794z"
                }
            }
        ]
    })(props);
}
function BsBack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H2a2 2 0 0 1-2-2V2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2z"
                }
            }
        ]
    })(props);
}
function BsBackpackFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 13v-3h4v.5a.5.5 0 0 0 1 0V10h1v3H5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2v.341C3.67 3.165 2 5.388 2 8v5.5A2.5 2.5 0 0 0 4.5 16h7a2.5 2.5 0 0 0 2.5-2.5V8a6.002 6.002 0 0 0-4-5.659V2a2 2 0 1 0-4 0Zm2-1a1 1 0 0 1 1 1v.083a6.04 6.04 0 0 0-2 0V2a1 1 0 0 1 1-1Zm0 3a4 4 0 0 1 3.96 3.43.5.5 0 1 1-.99.14 3 3 0 0 0-5.94 0 .5.5 0 1 1-.99-.14A4 4 0 0 1 8 4ZM4.5 9h7a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5Z"
                }
            }
        ]
    })(props);
}
function BsBackpack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.04 7.43a4 4 0 0 1 7.92 0 .5.5 0 1 1-.99.14 3 3 0 0 0-5.94 0 .5.5 0 1 1-.99-.14ZM4 9.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-4Zm1 .5v3h6v-3h-1v.5a.5.5 0 0 1-1 0V10H5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2.341V2a2 2 0 1 1 4 0v.341c2.33.824 4 3.047 4 5.659v5.5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 13.5V8a6.002 6.002 0 0 1 4-5.659ZM7 2v.083a6.04 6.04 0 0 1 2 0V2a1 1 0 0 0-2 0Zm1 1a5 5 0 0 0-5 5v5.5A1.5 1.5 0 0 0 4.5 15h7a1.5 1.5 0 0 0 1.5-1.5V8a5 5 0 0 0-5-5Z"
                }
            }
        ]
    })(props);
}
function BsBackpack2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 13h6v-3h-1v.5a.5.5 0 0 1-1 0V10H5v3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2v.341C3.67 3.165 2 5.388 2 8v1.191l-1.17.585A1.5 1.5 0 0 0 0 11.118V13.5A1.5 1.5 0 0 0 1.5 15h1c.456.607 1.182 1 2 1h7c.818 0 1.544-.393 2-1h1a1.5 1.5 0 0 0 1.5-1.5v-2.382a1.5 1.5 0 0 0-.83-1.342L14 9.191V8a6.002 6.002 0 0 0-4-5.659V2a2 2 0 1 0-4 0Zm2-1a1 1 0 0 1 1 1v.083a6.04 6.04 0 0 0-2 0V2a1 1 0 0 1 1-1Zm0 3a4 4 0 0 1 3.96 3.43.5.5 0 1 1-.99.14 3 3 0 0 0-5.94 0 .5.5 0 1 1-.99-.14A4 4 0 0 1 8 4ZM4.5 9h7a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5Z"
                }
            }
        ]
    })(props);
}
function BsBackpack2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.04 7.43a4 4 0 0 1 7.92 0 .5.5 0 1 1-.99.14 3 3 0 0 0-5.94 0 .5.5 0 1 1-.99-.14Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 9.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-4Zm1 .5v3h6v-3h-1v.5a.5.5 0 0 1-1 0V10H5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2.341V2a2 2 0 1 1 4 0v.341c2.33.824 4 3.047 4 5.659v1.191l1.17.585a1.5 1.5 0 0 1 .83 1.342V13.5a1.5 1.5 0 0 1-1.5 1.5h-1c-.456.607-1.182 1-2 1h-7a2.497 2.497 0 0 1-2-1h-1A1.5 1.5 0 0 1 0 13.5v-2.382a1.5 1.5 0 0 1 .83-1.342L2 9.191V8a6.002 6.002 0 0 1 4-5.659ZM7 2v.083a6.04 6.04 0 0 1 2 0V2a1 1 0 0 0-2 0ZM3 13.5A1.5 1.5 0 0 0 4.5 15h7a1.5 1.5 0 0 0 1.5-1.5V8A5 5 0 0 0 3 8v5.5Zm-1-3.19-.724.362a.5.5 0 0 0-.276.447V13.5a.5.5 0 0 0 .5.5H2v-3.691Zm12 0V14h.5a.5.5 0 0 0 .5-.5v-2.382a.5.5 0 0 0-.276-.447L14 10.309Z"
                }
            }
        ]
    })(props);
}
function BsBackpack3Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 10v3h6v-3h-1v.5a.5.5 0 0 1-1 0V10H5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2v.341a5.978 5.978 0 0 0-1.308.653l-.416-1.247a1 1 0 0 0-1.749-.284l-.77 1.027a1 1 0 0 0-.149.917l.803 2.407A5.985 5.985 0 0 0 2 8v5.5A2.5 2.5 0 0 0 4.5 16h7a2.5 2.5 0 0 0 2.5-2.5V8c0-.771-.146-1.509-.41-2.186l.801-2.407a1 1 0 0 0-.148-.917l-.77-1.027a1 1 0 0 0-1.75.284l-.415 1.247A5.976 5.976 0 0 0 10 2.34V2a2 2 0 1 0-4 0Zm1 0a1 1 0 0 1 2 0v.083a6.04 6.04 0 0 0-2 0V2Zm5.941 2.595a6.036 6.036 0 0 0-.8-.937l.531-1.595.77 1.027-.5 1.505ZM3.86 3.658a6.031 6.031 0 0 0-.8.937L2.557 3.09l.77-1.027.532 1.595Zm.18 3.772a4 4 0 0 1 7.92 0 .5.5 0 1 1-.99.142 3 3 0 0 0-5.94 0 .5.5 0 1 1-.99-.142ZM4 9.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-4Z"
                }
            }
        ]
    })(props);
}
function BsBackpack3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.04 7.43a4 4 0 0 1 7.92 0 .5.5 0 1 1-.99.14 3 3 0 0 0-5.94 0 .5.5 0 1 1-.99-.14ZM4 9.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-4Zm1 .5v3h6v-3h-1v.5a.5.5 0 0 1-1 0V10H5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2.341V2a2 2 0 1 1 4 0v.341c.465.165.904.385 1.308.653l.416-1.247a1 1 0 0 1 1.748-.284l.77 1.027a1 1 0 0 1 .15.917l-.803 2.407C13.854 6.49 14 7.229 14 8v5.5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 13.5V8c0-.771.146-1.509.41-2.186l-.802-2.407a1 1 0 0 1 .15-.917l.77-1.027a1 1 0 0 1 1.748.284l.416 1.247A5.978 5.978 0 0 1 6 2.34ZM7 2v.083a6.04 6.04 0 0 1 2 0V2a1 1 0 1 0-2 0Zm5.941 2.595.502-1.505-.77-1.027-.532 1.595c.297.284.566.598.8.937ZM3.86 3.658l-.532-1.595-.77 1.027.502 1.505c.234-.339.502-.653.8-.937ZM8 3a5 5 0 0 0-5 5v5.5A1.5 1.5 0 0 0 4.5 15h7a1.5 1.5 0 0 0 1.5-1.5V8a5 5 0 0 0-5-5Z"
                }
            }
        ]
    })(props);
}
function BsBackpack4Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a2 2 0 0 0-2 2H3.5a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h4v.5a.5.5 0 0 0 1 0V7h4a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H10a2 2 0 0 0-2-2Zm1 2a1 1 0 0 0-2 0h2Zm-4 9v2h6v-2h-1v.5a.5.5 0 0 1-1 0V11H5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7.599A2.986 2.986 0 0 1 12.5 8H9.415a1.5 1.5 0 0 1-2.83 0H3.5A2.986 2.986 0 0 1 2 7.599V14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.599ZM4 10.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-3Z"
                }
            }
        ]
    })(props);
}
function BsBackpack4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-4Zm1 .5v3h6v-3h-1v.5a.5.5 0 0 1-1 0V10H5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a2 2 0 0 0-2 2H3.5a2 2 0 0 0-2 2v1c0 .52.198.993.523 1.349A.5.5 0 0 0 2 6.5V14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6.5a.5.5 0 0 0-.023-.151c.325-.356.523-.83.523-1.349V4a2 2 0 0 0-2-2H10a2 2 0 0 0-2-2Zm0 1a1 1 0 0 0-1 1h2a1 1 0 0 0-1-1ZM3 14V6.937c.16.041.327.063.5.063h4v.5a.5.5 0 0 0 1 0V7h4c.173 0 .34-.022.5-.063V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Zm9.5-11a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h9Z"
                }
            }
        ]
    })(props);
}
function BsBackspaceFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.683 3a2 2 0 0 0-2-2h-7.08a2 2 0 0 0-1.519.698L.241 7.35a1 1 0 0 0 0 1.302l4.843 5.65A2 2 0 0 0 6.603 15h7.08a2 2 0 0 0 2-2V3zM5.829 5.854a.5.5 0 1 1 .707-.708l2.147 2.147 2.146-2.147a.5.5 0 1 1 .707.708L9.39 8l2.146 2.146a.5.5 0 0 1-.707.708L8.683 8.707l-2.147 2.147a.5.5 0 0 1-.707-.708L7.976 8 5.829 5.854z"
                }
            }
        ]
    })(props);
}
function BsBackspaceReverseFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3a2 2 0 0 1 2-2h7.08a2 2 0 0 1 1.519.698l4.843 5.651a1 1 0 0 1 0 1.302L10.6 14.3a2 2 0 0 1-1.52.7H2a2 2 0 0 1-2-2V3zm9.854 2.854a.5.5 0 0 0-.708-.708L7 7.293 4.854 5.146a.5.5 0 1 0-.708.708L6.293 8l-2.147 2.146a.5.5 0 0 0 .708.708L7 8.707l2.146 2.147a.5.5 0 0 0 .708-.708L7.707 8l2.147-2.146z"
                }
            }
        ]
    })(props);
}
function BsBackspaceReverse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.854 5.146a.5.5 0 0 1 0 .708L7.707 8l2.147 2.146a.5.5 0 0 1-.708.708L7 8.707l-2.146 2.147a.5.5 0 0 1-.708-.708L6.293 8 4.146 5.854a.5.5 0 1 1 .708-.708L7 7.293l2.146-2.147a.5.5 0 0 1 .708 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7.08a2 2 0 0 0 1.519-.698l4.843-5.651a1 1 0 0 0 0-1.302L10.6 1.7A2 2 0 0 0 9.08 1H2zm7.08 1a1 1 0 0 1 .76.35L14.682 8l-4.844 5.65a1 1 0 0 1-.759.35H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h7.08z"
                }
            }
        ]
    })(props);
}
function BsBackspace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.83 5.146a.5.5 0 0 0 0 .708L7.975 8l-2.147 2.146a.5.5 0 0 0 .707.708l2.147-2.147 2.146 2.147a.5.5 0 0 0 .707-.708L9.39 8l2.146-2.146a.5.5 0 0 0-.707-.708L8.683 7.293 6.536 5.146a.5.5 0 0 0-.707 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.683 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-7.08a2 2 0 0 1-1.519-.698L.241 8.65a1 1 0 0 1 0-1.302L5.084 1.7A2 2 0 0 1 6.603 1h7.08zm-7.08 1a1 1 0 0 0-.76.35L1 8l4.844 5.65a1 1 0 0 0 .759.35h7.08a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-7.08z"
                }
            }
        ]
    })(props);
}
function BsBadge3DFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.157 5.968h-.844v4.06h.844c1.116 0 1.621-.667 1.621-2.02 0-1.354-.51-2.04-1.621-2.04z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm5.184 4.368c.646 0 1.055.378 1.06.9.008.537-.427.919-1.086.919-.598-.004-1.037-.325-1.068-.756H3c.03.914.791 1.688 2.153 1.688 1.24 0 2.285-.66 2.272-1.798-.013-.953-.747-1.38-1.292-1.432v-.062c.44-.07 1.125-.527 1.108-1.375-.013-.906-.8-1.57-2.053-1.565-1.31.005-2.043.734-2.074 1.67h1.103c.022-.391.383-.751.936-.751.532 0 .928.33.928.813.004.479-.383.835-.928.835h-.632v.914h.663zM8.126 11h2.189C12.125 11 13 9.893 13 7.985c0-1.894-.861-2.984-2.685-2.984H8.126V11z"
                }
            }
        ]
    })(props);
}
function BsBadge3D(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.52 8.368h.664c.646 0 1.055.378 1.06.9.008.537-.427.919-1.086.919-.598-.004-1.037-.325-1.068-.756H3c.03.914.791 1.688 2.153 1.688 1.24 0 2.285-.66 2.272-1.798-.013-.953-.747-1.38-1.292-1.432v-.062c.44-.07 1.125-.527 1.108-1.375-.013-.906-.8-1.57-2.053-1.565-1.31.005-2.043.734-2.074 1.67h1.103c.022-.391.383-.751.936-.751.532 0 .928.33.928.813.004.479-.383.835-.928.835h-.632v.914zm3.606-3.367V11h2.189C12.125 11 13 9.893 13 7.985c0-1.894-.861-2.984-2.685-2.984H8.126zm1.187.967h.844c1.112 0 1.621.686 1.621 2.04 0 1.353-.505 2.02-1.621 2.02h-.844v-4.06z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"
                }
            }
        ]
    })(props);
}
function BsBadge4KFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.577 8.9v.03h1.828V5.898h-.062a46.781 46.781 0 0 0-1.766 3.001z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm2.372 3.715.435-.714h1.71v3.93h.733v.957h-.733V11H5.405V9.888H2.5v-.971c.574-1.077 1.225-2.142 1.872-3.202zm7.73-.714h1.306l-2.14 2.584L13.5 11h-1.428l-1.679-2.624-.615.7V11H8.59V5.001h1.187v2.686h.057L12.102 5z"
                }
            }
        ]
    })(props);
}
function BsBadge4K(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.807 5.001C4.021 6.298 3.203 7.6 2.5 8.917v.971h2.905V11h1.112V9.888h.733V8.93h-.733V5.001h-1.71zm-1.23 3.93v-.032a46.781 46.781 0 0 1 1.766-3.001h.062V8.93H3.577zm9.831-3.93h-1.306L9.835 7.687h-.057V5H8.59v6h1.187V9.075l.615-.699L12.072 11H13.5l-2.232-3.415 2.14-2.584z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"
                }
            }
        ]
    })(props);
}
function BsBadge8KFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.9 6.605c0 .51.405.866.95.866.545 0 .945-.356.945-.866s-.4-.852-.945-.852c-.545 0-.95.343-.95.852zm-.192 2.668c0 .589.492.984 1.142.984.646 0 1.143-.395 1.143-.984S5.496 8.28 4.85 8.28c-.65 0-1.142.404-1.142.993z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm5.17 7.348c0 1.041-.927 1.766-2.333 1.766-1.406 0-2.312-.72-2.312-1.762 0-.954.712-1.384 1.257-1.494v-.053c-.51-.154-1.02-.558-1.02-1.331 0-.914.831-1.587 2.088-1.587 1.253 0 2.083.673 2.083 1.587 0 .782-.523 1.182-1.02 1.331v.053c.545.11 1.257.545 1.257 1.49zM12.102 5h1.306l-2.14 2.584 2.232 3.415h-1.428l-1.679-2.624-.615.699v1.925H8.59V5h1.187v2.685h.057L12.102 5z"
                }
            }
        ]
    })(props);
}
function BsBadge8K(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.837 11.114c1.406 0 2.333-.725 2.333-1.766 0-.945-.712-1.38-1.256-1.49v-.053c.496-.15 1.02-.55 1.02-1.331 0-.914-.831-1.587-2.084-1.587-1.257 0-2.087.673-2.087 1.587 0 .773.51 1.177 1.02 1.331v.053c-.546.11-1.258.54-1.258 1.494 0 1.042.906 1.762 2.312 1.762zm.013-3.643c-.545 0-.95-.356-.95-.866s.405-.852.95-.852c.545 0 .945.343.945.852 0 .51-.4.866-.945.866zm0 2.786c-.65 0-1.142-.395-1.142-.984S4.2 8.28 4.85 8.28c.646 0 1.143.404 1.143.993s-.497.984-1.143.984zM13.408 5h-1.306L9.835 7.685h-.057V5H8.59v5.998h1.187V9.075l.615-.699 1.679 2.623H13.5l-2.232-3.414L13.408 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"
                }
            }
        ]
    })(props);
}
function BsBadgeAdFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.35 8.337c0-.699-.42-1.138-1.001-1.138-.584 0-.954.444-.954 1.239v.453c0 .8.374 1.248.972 1.248.588 0 .984-.44.984-1.2v-.602zm-5.413.237-.734-2.426H5.15l-.734 2.426h1.52z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm6.209 6.32c0-1.28.694-2.044 1.753-2.044.655 0 1.156.294 1.336.769h.053v-2.36h1.16V11h-1.138v-.747h-.057c-.145.474-.69.804-1.367.804-1.055 0-1.74-.764-1.74-2.043v-.695zm-4.04 1.138L3.7 11H2.5l2.013-5.999H5.9L7.905 11H6.644l-.47-1.542H4.17z"
                }
            }
        ]
    })(props);
}
function BsBadgeAd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3.7 11 .47-1.542h2.004L6.644 11h1.261L5.901 5.001H4.513L2.5 11h1.2zm1.503-4.852.734 2.426H4.416l.734-2.426h.053zm4.759.128c-1.059 0-1.753.765-1.753 2.043v.695c0 1.279.685 2.043 1.74 2.043.677 0 1.222-.33 1.367-.804h.057V11h1.138V4.685h-1.16v2.36h-.053c-.18-.475-.68-.77-1.336-.77zm.387.923c.58 0 1.002.44 1.002 1.138v.602c0 .76-.396 1.2-.984 1.2-.598 0-.972-.449-.972-1.248v-.453c0-.795.37-1.24.954-1.24z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"
                }
            }
        ]
    })(props);
}
function BsBadgeArFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m6.031 8.574-.734-2.426h-.052L4.51 8.574h1.52zm3.642-2.641v1.938h1.033c.66 0 1.068-.316 1.068-.95 0-.64-.422-.988-1.05-.988h-1.05z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm4.265 5.458h2.004L6.739 11H8L5.996 5.001H4.607L2.595 11h1.2l.47-1.542zM8.5 5v6h1.173V8.763h1.064L11.787 11h1.327L11.91 8.583C12.455 8.373 13 7.779 13 6.9c0-1.147-.773-1.9-2.105-1.9H8.5z"
                }
            }
        ]
    })(props);
}
function BsBadgeAr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3.794 11 .47-1.542H6.27L6.739 11H8L5.996 5.001H4.607L2.595 11h1.2zm1.503-4.852.734 2.426h-1.52l.734-2.426h.052zm5.598-1.147H8.5V11h1.173V8.763h1.064L11.787 11h1.327L11.91 8.583C12.455 8.373 13 7.779 13 6.9c0-1.147-.773-1.9-2.105-1.9zm-1.222 2.87V5.933h1.05c.63 0 1.05.347 1.05.989 0 .633-.408.95-1.067.95H9.673z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"
                }
            }
        ]
    })(props);
}
function BsBadgeCcFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm3.027 4.002c-.83 0-1.319.642-1.319 1.753v.743c0 1.107.48 1.727 1.319 1.727.69 0 1.138-.435 1.186-1.05H7.36v.114c-.057 1.147-1.028 1.938-2.342 1.938-1.613 0-2.518-1.028-2.518-2.729v-.747C2.5 6.051 3.414 5 5.018 5c1.318 0 2.29.813 2.342 2v.11H6.213c-.048-.638-.505-1.108-1.186-1.108zm6.14 0c-.831 0-1.319.642-1.319 1.753v.743c0 1.107.48 1.727 1.318 1.727.69 0 1.139-.435 1.187-1.05H13.5v.114c-.057 1.147-1.028 1.938-2.342 1.938-1.613 0-2.518-1.028-2.518-2.729v-.747c0-1.7.914-2.751 2.518-2.751 1.318 0 2.29.813 2.342 2v.11h-1.147c-.048-.638-.505-1.108-1.187-1.108z"
                }
            }
        ]
    })(props);
}
function BsBadgeCc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.708 7.755c0-1.111.488-1.753 1.319-1.753.681 0 1.138.47 1.186 1.107H7.36V7c-.052-1.186-1.024-2-2.342-2C3.414 5 2.5 6.05 2.5 7.751v.747c0 1.7.905 2.73 2.518 2.73 1.314 0 2.285-.792 2.342-1.939v-.114H6.213c-.048.615-.496 1.05-1.186 1.05-.84 0-1.319-.62-1.319-1.727v-.743zm6.14 0c0-1.111.488-1.753 1.318-1.753.682 0 1.139.47 1.187 1.107H13.5V7c-.053-1.186-1.024-2-2.342-2C9.554 5 8.64 6.05 8.64 7.751v.747c0 1.7.905 2.73 2.518 2.73 1.314 0 2.285-.792 2.342-1.939v-.114h-1.147c-.048.615-.497 1.05-1.187 1.05-.839 0-1.318-.62-1.318-1.727v-.743z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"
                }
            }
        ]
    })(props);
}
function BsBadgeHdFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.53 5.968h-.843v4.06h.843c1.117 0 1.622-.667 1.622-2.02 0-1.354-.51-2.04-1.622-2.04z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm5.396 3.001V11H6.209V8.43H3.687V11H2.5V5.001h1.187v2.44h2.522V5h1.187zM8.5 11V5.001h2.188c1.824 0 2.685 1.09 2.685 2.984C13.373 9.893 12.5 11 10.69 11H8.5z"
                }
            }
        ]
    })(props);
}
function BsBadgeHd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.396 11V5.001H6.209v2.44H3.687V5H2.5v6h1.187V8.43h2.522V11h1.187zM8.5 5.001V11h2.188c1.811 0 2.685-1.107 2.685-3.015 0-1.894-.86-2.984-2.684-2.984H8.5zm1.187.967h.843c1.112 0 1.622.686 1.622 2.04 0 1.353-.505 2.02-1.622 2.02h-.843v-4.06z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"
                }
            }
        ]
    })(props);
}
function BsBadgeSdFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.338 5.968h-.844v4.06h.844c1.116 0 1.622-.667 1.622-2.02 0-1.354-.51-2.04-1.622-2.04Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm5.077 7.114c1.521 0 2.378-.764 2.378-1.88 0-1.007-.642-1.473-1.613-1.692l-.932-.216c-.527-.114-.821-.351-.821-.712 0-.466.39-.804 1.046-.804.637 0 1.028.33 1.103.76h1.125c-.058-.923-.849-1.692-2.22-1.692-1.322 0-2.24.717-2.24 1.815 0 .91.588 1.446 1.52 1.657l.927.215c.624.145.923.36.923.778 0 .492-.391.83-1.13.83-.707 0-1.155-.342-1.234-.808H2.762c.052.95.79 1.75 2.315 1.75ZM8.307 11h2.19c1.81 0 2.684-1.107 2.684-3.015 0-1.894-.861-2.984-2.685-2.984H8.308V11Z"
                }
            }
        ]
    })(props);
}
function BsBadgeSd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15 4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4ZM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm5.077 7.114c-1.524 0-2.263-.8-2.315-1.749h1.147c.079.466.527.809 1.234.809.739 0 1.13-.339 1.13-.83 0-.418-.3-.634-.923-.779l-.927-.215c-.932-.21-1.52-.747-1.52-1.657 0-1.098.918-1.815 2.24-1.815 1.371 0 2.162.77 2.22 1.692H6.238c-.075-.43-.466-.76-1.103-.76-.655 0-1.046.338-1.046.804 0 .36.294.598.821.712l.932.216c.971.22 1.613.685 1.613 1.691 0 1.117-.857 1.881-2.378 1.881ZM8.307 11V5.001h2.19c1.823 0 2.684 1.09 2.684 2.984 0 1.908-.874 3.015-2.685 3.015H8.308Zm2.031-5.032h-.844v4.06h.844c1.116 0 1.622-.667 1.622-2.02 0-1.354-.51-2.04-1.622-2.04Z"
                }
            }
        ]
    })(props);
}
function BsBadgeTmFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm3.295 3.995V11H4.104V5.995h-1.7V5H7v.994H5.295zM8.692 7.01V11H7.633V5.001h1.209l1.71 3.894h.039l1.71-3.894H13.5V11h-1.072V7.01h-.057l-1.42 3.239h-.773L8.75 7.008h-.058z"
                }
            }
        ]
    })(props);
}
function BsBadgeTm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.295 11V5.995H7V5H2.403v.994h1.701V11h1.19zm3.397 0V7.01h.058l1.428 3.239h.773l1.42-3.24h.057V11H13.5V5.001h-1.2l-1.71 3.894h-.039l-1.71-3.894H7.634V11h1.06z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"
                }
            }
        ]
    })(props);
}
function BsBadgeVoFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.296 8.394v-.782c0-1.156-.571-1.736-1.362-1.736-.796 0-1.363.58-1.363 1.736v.782c0 1.156.567 1.732 1.363 1.732.79 0 1.362-.576 1.362-1.732z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm11.5 5.62v.77c0 1.691-.962 2.724-2.566 2.724-1.604 0-2.571-1.033-2.571-2.724v-.77c0-1.704.967-2.733 2.57-2.733 1.605 0 2.567 1.037 2.567 2.734zM5.937 11H4.508L2.5 5.001h1.375L5.22 9.708h.057L6.61 5.001h1.318L5.937 11z"
                }
            }
        ]
    })(props);
}
function BsBadgeVo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.508 11h1.429l1.99-5.999H6.61L5.277 9.708H5.22L3.875 5.001H2.5L4.508 11zM13.5 8.39v-.77c0-1.696-.962-2.733-2.566-2.733-1.604 0-2.571 1.029-2.571 2.734v.769c0 1.691.967 2.724 2.57 2.724 1.605 0 2.567-1.033 2.567-2.724zm-1.204-.778v.782c0 1.156-.571 1.732-1.362 1.732-.796 0-1.363-.576-1.363-1.732v-.782c0-1.156.567-1.736 1.363-1.736.79 0 1.362.58 1.362 1.736z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"
                }
            }
        ]
    })(props);
}
function BsBadgeVrFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.673 5.933v1.938h1.033c.66 0 1.068-.316 1.068-.95 0-.64-.422-.988-1.05-.988h-1.05z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm5.937 7 1.99-5.999H6.61L5.277 9.708H5.22L3.875 5.001H2.5L4.508 11h1.429zM8.5 5.001V11h1.173V8.763h1.064L11.787 11h1.327L11.91 8.583C12.455 8.373 13 7.779 13 6.9c0-1.147-.773-1.9-2.105-1.9H8.5z"
                }
            }
        ]
    })(props);
}
function BsBadgeVr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.508 11h1.429l1.99-5.999H6.61L5.277 9.708H5.22L3.875 5.001H2.5L4.508 11zm6.387-5.999H8.5V11h1.173V8.763h1.064L11.787 11h1.327L11.91 8.583C12.455 8.373 13 7.779 13 6.9c0-1.147-.773-1.9-2.105-1.9zm-1.222 2.87V5.933h1.05c.63 0 1.05.347 1.05.989 0 .633-.408.95-1.067.95H9.673z"
                }
            }
        ]
    })(props);
}
function BsBadgeWcFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm11.666 1.89c.682 0 1.139.47 1.187 1.107H14v-.11c-.053-1.187-1.024-2-2.342-2-1.604 0-2.518 1.05-2.518 2.751v.747c0 1.7.905 2.73 2.518 2.73 1.314 0 2.285-.792 2.342-1.939v-.114h-1.147c-.048.615-.497 1.05-1.187 1.05-.839 0-1.318-.62-1.318-1.727v-.742c0-1.112.488-1.754 1.318-1.754zm-6.188.926h.044L6.542 11h1.006L9 5.001H7.818l-.82 4.355h-.056L5.97 5.001h-.94l-.972 4.355h-.053l-.827-4.355H2L3.452 11h1.005l1.02-4.184z"
                }
            }
        ]
    })(props);
}
function BsBadgeWc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.348 7.643c0-1.112.488-1.754 1.318-1.754.682 0 1.139.47 1.187 1.108H14v-.11c-.053-1.187-1.024-2-2.342-2-1.604 0-2.518 1.05-2.518 2.751v.747c0 1.7.905 2.73 2.518 2.73 1.314 0 2.285-.792 2.342-1.939v-.114h-1.147c-.048.615-.497 1.05-1.187 1.05-.839 0-1.318-.62-1.318-1.727v-.742zM4.457 11l1.02-4.184h.045L6.542 11h1.006L9 5.001H7.818l-.82 4.355h-.056L5.97 5.001h-.94l-.972 4.355h-.053l-.827-4.355H2L3.452 11h1.005z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"
                }
            }
        ]
    })(props);
}
function BsBagCheckFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.5 3.5a2.5 2.5 0 0 0-5 0V4h5v-.5zm1 0V4H15v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4h3.5v-.5a3.5 3.5 0 1 1 7 0zm-.646 5.354a.5.5 0 0 0-.708-.708L7.5 10.793 6.354 9.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z"
                }
            }
        ]
    })(props);
}
function BsBagCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.854 8.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5z"
                }
            }
        ]
    })(props);
}
function BsBagDashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.5 3.5a2.5 2.5 0 0 0-5 0V4h5v-.5zm1 0V4H15v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4h3.5v-.5a3.5 3.5 0 1 1 7 0zM6 9.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H6z"
                }
            }
        ]
    })(props);
}
function BsBagDash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.5 10a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5z"
                }
            }
        ]
    })(props);
}
function BsBagFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5z"
                }
            }
        ]
    })(props);
}
function BsBagHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 4v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5ZM8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1Zm0 6.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z"
                }
            }
        ]
    })(props);
}
function BsBagHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.5 3.5a2.5 2.5 0 0 0-5 0V4h5v-.5Zm1 0V4H15v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4h3.5v-.5a3.5 3.5 0 1 1 7 0ZM14 14V5H2v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1ZM8 7.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z"
                }
            }
        ]
    })(props);
}
function BsBagPlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.5 3.5a2.5 2.5 0 0 0-5 0V4h5v-.5zm1 0V4H15v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4h3.5v-.5a3.5 3.5 0 1 1 7 0zM8.5 8a.5.5 0 0 0-1 0v1.5H6a.5.5 0 0 0 0 1h1.5V12a.5.5 0 0 0 1 0v-1.5H10a.5.5 0 0 0 0-1H8.5V8z"
                }
            }
        ]
    })(props);
}
function BsBagPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 7.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0v-1.5H6a.5.5 0 0 1 0-1h1.5V8a.5.5 0 0 1 .5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5z"
                }
            }
        ]
    })(props);
}
function BsBagXFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.5 3.5a2.5 2.5 0 0 0-5 0V4h5v-.5zm1 0V4H15v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4h3.5v-.5a3.5 3.5 0 1 1 7 0zM6.854 8.146a.5.5 0 1 0-.708.708L7.293 10l-1.147 1.146a.5.5 0 0 0 .708.708L8 10.707l1.146 1.147a.5.5 0 0 0 .708-.708L8.707 10l1.147-1.146a.5.5 0 0 0-.708-.708L8 9.293 6.854 8.146z"
                }
            }
        ]
    })(props);
}
function BsBagX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.146 8.146a.5.5 0 0 1 .708 0L8 9.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 10l1.147 1.146a.5.5 0 0 1-.708.708L8 10.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 10 6.146 8.854a.5.5 0 0 1 0-.708z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5z"
                }
            }
        ]
    })(props);
}
function BsBag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5z"
                }
            }
        ]
    })(props);
}
function BsBalloonFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.48 10.901C11.211 10.227 13 7.837 13 5A5 5 0 0 0 3 5c0 2.837 1.789 5.227 4.52 5.901l-.244.487a.25.25 0 1 0 .448.224l.04-.08c.009.17.024.315.051.45.068.344.208.622.448 1.102l.013.028c.212.422.182.85.05 1.246-.135.402-.366.751-.534 1.003a.25.25 0 0 0 .416.278l.004-.007c.166-.248.431-.646.588-1.115.16-.479.212-1.051-.076-1.629-.258-.515-.365-.732-.419-1.004a2.376 2.376 0 0 1-.037-.289l.008.017a.25.25 0 1 0 .448-.224l-.244-.487ZM4.352 3.356a4.004 4.004 0 0 1 3.15-2.325C7.774.997 8 1.224 8 1.5c0 .276-.226.496-.498.542-.95.162-1.749.78-2.173 1.617a.595.595 0 0 1-.52.341c-.346 0-.599-.329-.457-.644Z"
                }
            }
        ]
    })(props);
}
function BsBalloonHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.49 10.92C19.412 3.382 11.28-2.387 8 .986 4.719-2.387-3.413 3.382 7.51 10.92l-.234.468a.25.25 0 1 0 .448.224l.04-.08c.009.17.024.315.051.45.068.344.208.622.448 1.102l.013.028c.212.422.182.85.05 1.246-.135.402-.366.751-.534 1.003a.25.25 0 0 0 .416.278l.004-.007c.166-.248.431-.646.588-1.115.16-.479.212-1.051-.076-1.629-.258-.515-.365-.732-.419-1.004a2.376 2.376 0 0 1-.037-.289l.008.017a.25.25 0 1 0 .448-.224l-.235-.468ZM6.726 1.269c-1.167-.61-2.8-.142-3.454 1.135-.237.463-.36 1.08-.202 1.85.055.27.467.197.527-.071.285-1.256 1.177-2.462 2.989-2.528.234-.008.348-.278.14-.386Z"
                }
            }
        ]
    })(props);
}
function BsBalloonHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "m8 2.42-.717-.737c-1.13-1.161-3.243-.777-4.01.72-.35.685-.451 1.707.236 3.062C4.16 6.753 5.52 8.32 8 10.042c2.479-1.723 3.839-3.29 4.491-4.577.687-1.355.587-2.377.236-3.061-.767-1.498-2.88-1.882-4.01-.721L8 2.42Zm-.49 8.5c-10.78-7.44-3-13.155.359-10.063.045.041.089.084.132.129.043-.045.087-.088.132-.129 3.36-3.092 11.137 2.624.357 10.063l.235.468a.25.25 0 1 1-.448.224l-.008-.017c.008.11.02.202.037.29.054.27.161.488.419 1.003.288.578.235 1.15.076 1.629-.157.469-.422.867-.588 1.115l-.004.007a.25.25 0 1 1-.416-.278c.168-.252.4-.6.533-1.003.133-.396.163-.824-.049-1.246l-.013-.028c-.24-.48-.38-.758-.448-1.102a3.177 3.177 0 0 1-.052-.45l-.04.08a.25.25 0 1 1-.447-.224l.235-.468ZM6.013 2.06c-.649-.18-1.483.083-1.85.798-.131.258-.245.689-.08 1.335.063.244.414.198.487-.043.21-.697.627-1.447 1.359-1.692.217-.073.304-.337.084-.398Z"
                }
            }
        ]
    })(props);
}
function BsBalloon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 9.984C10.403 9.506 12 7.48 12 5a4 4 0 0 0-8 0c0 2.48 1.597 4.506 4 4.984ZM13 5c0 2.837-1.789 5.227-4.52 5.901l.244.487a.25.25 0 1 1-.448.224l-.008-.017c.008.11.02.202.037.29.054.27.161.488.419 1.003.288.578.235 1.15.076 1.629-.157.469-.422.867-.588 1.115l-.004.007a.25.25 0 1 1-.416-.278c.168-.252.4-.6.533-1.003.133-.396.163-.824-.049-1.246l-.013-.028c-.24-.48-.38-.758-.448-1.102a3.177 3.177 0 0 1-.052-.45l-.04.08a.25.25 0 1 1-.447-.224l.244-.487C4.789 10.227 3 7.837 3 5a5 5 0 0 1 10 0Zm-6.938-.495a2.003 2.003 0 0 1 1.443-1.443C7.773 2.994 8 2.776 8 2.5c0-.276-.226-.504-.498-.459a3.003 3.003 0 0 0-2.46 2.461c-.046.272.182.498.458.498s.494-.227.562-.495Z"
                }
            }
        ]
    })(props);
}
function BsBanFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM2.71 12.584c.218.252.454.488.706.707l9.875-9.875a7.034 7.034 0 0 0-.707-.707l-9.875 9.875Z"
                }
            }
        ]
    })(props);
}
function BsBan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 8a6.973 6.973 0 0 0-1.71-4.584l-9.874 9.875A7 7 0 0 0 15 8ZM2.71 12.584l9.874-9.875a7 7 0 0 0-9.874 9.874ZM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Z"
                }
            }
        ]
    })(props);
}
function BsBandaidFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.68 7.676 6.49-6.504a4 4 0 0 1 5.66 5.653l-1.477 1.529-5.006 5.006-1.523 1.472a4 4 0 0 1-5.653-5.66l.001-.002 1.505-1.492.001-.002Zm5.71-2.858a.5.5 0 1 0-.708.707.5.5 0 0 0 .707-.707ZM6.974 6.939a.5.5 0 1 0-.707-.707.5.5 0 0 0 .707.707ZM5.56 8.354a.5.5 0 1 0-.707-.708.5.5 0 0 0 .707.708Zm2.828 2.828a.5.5 0 1 0-.707-.707.5.5 0 0 0 .707.707Zm1.414-2.121a.5.5 0 1 0-.707.707.5.5 0 0 0 .707-.707Zm1.414-.707a.5.5 0 1 0-.706-.708.5.5 0 0 0 .707.708Zm-4.242.707a.5.5 0 1 0-.707.707.5.5 0 0 0 .707-.707Zm1.414-.707a.5.5 0 1 0-.707-.708.5.5 0 0 0 .707.708Zm1.414-2.122a.5.5 0 1 0-.707.707.5.5 0 0 0 .707-.707ZM8.646 3.354l4 4 .708-.708-4-4-.708.708Zm-1.292 9.292-4-4-.708.708 4 4 .708-.708Z"
                }
            }
        ]
    })(props);
}
function BsBandaid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.121 1.879a3 3 0 0 0-4.242 0L8.733 3.026l4.261 4.26 1.127-1.165a3 3 0 0 0 0-4.242ZM12.293 8 8.027 3.734 3.738 8.031 8 12.293 12.293 8Zm-5.006 4.994L3.03 8.737 1.879 9.88a3 3 0 0 0 4.241 4.24l.006-.006 1.16-1.121ZM2.679 7.676l6.492-6.504a4 4 0 0 1 5.66 5.653l-1.477 1.529-5.006 5.006-1.523 1.472a4 4 0 0 1-5.653-5.66l.001-.002 1.505-1.492.001-.002Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.56 7.646a.5.5 0 1 1-.706.708.5.5 0 0 1 .707-.708Zm1.415-1.414a.5.5 0 1 1-.707.707.5.5 0 0 1 .707-.707ZM8.39 4.818a.5.5 0 1 1-.708.707.5.5 0 0 1 .707-.707Zm0 5.657a.5.5 0 1 1-.708.707.5.5 0 0 1 .707-.707ZM9.803 9.06a.5.5 0 1 1-.707.708.5.5 0 0 1 .707-.707Zm1.414-1.414a.5.5 0 1 1-.706.708.5.5 0 0 1 .707-.708ZM6.975 9.06a.5.5 0 1 1-.707.708.5.5 0 0 1 .707-.707ZM8.39 7.646a.5.5 0 1 1-.708.708.5.5 0 0 1 .707-.708Zm1.413-1.414a.5.5 0 1 1-.707.707.5.5 0 0 1 .707-.707Z"
                }
            }
        ]
    })(props);
}
function BsBank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m8 0 6.61 3h.89a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H15v7a.5.5 0 0 1 .485.38l.5 2a.498.498 0 0 1-.485.62H.5a.498.498 0 0 1-.485-.62l.5-2A.501.501 0 0 1 1 13V6H.5a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 .5 3h.89L8 0ZM3.777 3h8.447L8 1 3.777 3ZM2 6v7h1V6H2Zm2 0v7h2.5V6H4Zm3.5 0v7h1V6h-1Zm2 0v7H12V6H9.5ZM13 6v7h1V6h-1Zm2-1V4H1v1h14Zm-.39 9H1.39l-.25 1h13.72l-.25-1Z"
                }
            }
        ]
    })(props);
}
function BsBank2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.277.084a.5.5 0 0 0-.554 0l-7.5 5A.5.5 0 0 0 .5 6h1.875v7H1.5a.5.5 0 0 0 0 1h13a.5.5 0 1 0 0-1h-.875V6H15.5a.5.5 0 0 0 .277-.916l-7.5-5zM12.375 6v7h-1.25V6h1.25zm-2.5 0v7h-1.25V6h1.25zm-2.5 0v7h-1.25V6h1.25zm-2.5 0v7h-1.25V6h1.25zM8 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM.5 15a.5.5 0 0 0 0 1h15a.5.5 0 1 0 0-1H.5z"
                }
            }
        ]
    })(props);
}
function BsBarChartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 11a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3zm5-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2z"
                }
            }
        ]
    })(props);
}
function BsBarChartLineFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h1V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7h1V2z"
                }
            }
        ]
    })(props);
}
function BsBarChartLine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h1V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7h1V2zm1 12h2V2h-2v12zm-3 0V7H7v7h2zm-5 0v-3H2v3h2z"
                }
            }
        ]
    })(props);
}
function BsBarChartSteps(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.5 0a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-1 0V.5A.5.5 0 0 1 .5 0zM2 1.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-1zm2 4a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1zm2 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-1zm2 4a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1z"
                }
            }
        ]
    })(props);
}
function BsBarChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11H2v3h2v-3zm5-4H7v7h2V7zm5-5v12h-2V2h2zm-2-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-2zM6 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm-5 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3z"
                }
            }
        ]
    })(props);
}
function BsBasketFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.071 1.243a.5.5 0 0 1 .858.514L3.383 6h9.234L10.07 1.757a.5.5 0 1 1 .858-.514L13.783 6H15.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H15v5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9H.5a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 .5 6h1.717L5.07 1.243zM3.5 10.5a.5.5 0 1 0-1 0v3a.5.5 0 0 0 1 0v-3zm2.5 0a.5.5 0 1 0-1 0v3a.5.5 0 0 0 1 0v-3zm2.5 0a.5.5 0 1 0-1 0v3a.5.5 0 0 0 1 0v-3zm2.5 0a.5.5 0 1 0-1 0v3a.5.5 0 0 0 1 0v-3zm2.5 0a.5.5 0 1 0-1 0v3a.5.5 0 0 0 1 0v-3z"
                }
            }
        ]
    })(props);
}
function BsBasket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.757 1.071a.5.5 0 0 1 .172.686L3.383 6h9.234L10.07 1.757a.5.5 0 1 1 .858-.514L13.783 6H15a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1v4.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 13.5V9a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h1.217L5.07 1.243a.5.5 0 0 1 .686-.172zM2 9v4.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V9H2zM1 7v1h14V7H1zm3 3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3A.5.5 0 0 1 4 10zm2 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3A.5.5 0 0 1 6 10zm2 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3A.5.5 0 0 1 8 10zm2 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5zm2 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsBasket2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.929 1.757a.5.5 0 1 0-.858-.514L2.217 6H.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h.623l1.844 6.456A.75.75 0 0 0 3.69 15h8.622a.75.75 0 0 0 .722-.544L14.877 8h.623a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1.717L10.93 1.243a.5.5 0 1 0-.858.514L12.617 6H3.383L5.93 1.757zM4 10a1 1 0 0 1 2 0v2a1 1 0 1 1-2 0v-2zm3 0a1 1 0 0 1 2 0v2a1 1 0 1 1-2 0v-2zm4-1a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1z"
                }
            }
        ]
    })(props);
}
function BsBasket2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10a1 1 0 0 1 2 0v2a1 1 0 0 1-2 0v-2zm3 0a1 1 0 0 1 2 0v2a1 1 0 0 1-2 0v-2zm3 0a1 1 0 1 1 2 0v2a1 1 0 0 1-2 0v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.757 1.071a.5.5 0 0 1 .172.686L3.383 6h9.234L10.07 1.757a.5.5 0 1 1 .858-.514L13.783 6H15.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-.623l-1.844 6.456a.75.75 0 0 1-.722.544H3.69a.75.75 0 0 1-.722-.544L1.123 8H.5a.5.5 0 0 1-.5-.5v-1A.5.5 0 0 1 .5 6h1.717L5.07 1.243a.5.5 0 0 1 .686-.172zM2.163 8l1.714 6h8.246l1.714-6H2.163z"
                }
            }
        ]
    })(props);
}
function BsBasket3Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.757 1.071a.5.5 0 0 1 .172.686L3.383 6h9.234L10.07 1.757a.5.5 0 1 1 .858-.514L13.783 6H15.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-1A.5.5 0 0 1 .5 6h1.717L5.07 1.243a.5.5 0 0 1 .686-.172zM2.468 15.426.943 9h14.114l-1.525 6.426a.75.75 0 0 1-.729.574H3.197a.75.75 0 0 1-.73-.574z"
                }
            }
        ]
    })(props);
}
function BsBasket3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.757 1.071a.5.5 0 0 1 .172.686L3.383 6h9.234L10.07 1.757a.5.5 0 1 1 .858-.514L13.783 6H15.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-1A.5.5 0 0 1 .5 6h1.717L5.07 1.243a.5.5 0 0 1 .686-.172zM3.394 15l-1.48-6h-.97l1.525 6.426a.75.75 0 0 0 .729.574h9.606a.75.75 0 0 0 .73-.574L15.056 9h-.972l-1.479 6h-9.21z"
                }
            }
        ]
    })(props);
}
function BsBatteryCharging(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.585 2.568a.5.5 0 0 1 .226.58L8.677 6.832h1.99a.5.5 0 0 1 .364.843l-5.334 5.667a.5.5 0 0 1-.842-.49L5.99 9.167H4a.5.5 0 0 1-.364-.843l5.333-5.667a.5.5 0 0 1 .616-.09z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4h4.332l-.94 1H2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h2.38l-.308 1H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6h2.45L2.908 7.639A1.5 1.5 0 0 0 3.313 10H2V6zm8.595-2-.308 1H12a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H9.276l-.942 1H12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.405z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10h-1.783l1.542-1.639c.097-.103.178-.218.241-.34V10zm0-3.354V6h-.646a1.5 1.5 0 0 1 .646.646zM16 8a1.5 1.5 0 0 1-1.5 1.5v-3A1.5 1.5 0 0 1 16 8z"
                }
            }
        ]
    })(props);
}
function BsBatteryFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6h10v4H2V6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H2zm10 1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h10zm4 3a1.5 1.5 0 0 1-1.5 1.5v-3A1.5 1.5 0 0 1 16 8z"
                }
            }
        ]
    })(props);
}
function BsBatteryHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6h5v4H2V6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H2zm10 1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h10zm4 3a1.5 1.5 0 0 1-1.5 1.5v-3A1.5 1.5 0 0 1 16 8z"
                }
            }
        ]
    })(props);
}
function BsBattery(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6zm2-1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H2zm14 3a1.5 1.5 0 0 1-1.5 1.5v-3A1.5 1.5 0 0 1 16 8z"
                }
            }
        ]
    })(props);
}
function BsBehance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.654 3c.461 0 .887.035 1.278.14.39.07.711.216.996.391.286.176.497.426.641.747.14.32.216.711.216 1.137 0 .496-.106.922-.356 1.242-.215.32-.566.606-.997.817.606.176 1.067.496 1.348.922.281.426.461.957.461 1.563 0 .496-.105.922-.285 1.278a2.317 2.317 0 0 1-.782.887c-.32.215-.711.39-1.137.496a5.329 5.329 0 0 1-1.278.176L0 12.803V3h4.654zm-.285 3.978c.39 0 .71-.105.957-.285.246-.18.355-.497.355-.887 0-.216-.035-.426-.105-.567a.981.981 0 0 0-.32-.355 1.84 1.84 0 0 0-.461-.176c-.176-.035-.356-.035-.567-.035H2.17v2.31c0-.005 2.2-.005 2.2-.005zm.105 4.193c.215 0 .426-.035.606-.07.176-.035.356-.106.496-.216s.25-.215.356-.39c.07-.176.14-.391.14-.641 0-.496-.14-.852-.426-1.102-.285-.215-.676-.32-1.137-.32H2.17v2.734h2.305v.005zm6.858-.035c.286.285.711.426 1.278.426.39 0 .746-.106 1.032-.286.285-.215.46-.426.53-.64h1.74c-.286.851-.712 1.457-1.278 1.848-.566.355-1.243.566-2.06.566a4.135 4.135 0 0 1-1.527-.285 2.827 2.827 0 0 1-1.137-.782 2.851 2.851 0 0 1-.712-1.172c-.175-.461-.25-.957-.25-1.528 0-.531.07-1.032.25-1.493.18-.46.426-.852.747-1.207.32-.32.711-.606 1.137-.782a4.018 4.018 0 0 1 1.493-.285c.606 0 1.137.105 1.598.355.46.25.817.532 1.102.958.285.39.496.851.641 1.348.07.496.105.996.07 1.563h-5.15c0 .58.21 1.11.496 1.396zm2.24-3.732c-.25-.25-.642-.391-1.103-.391-.32 0-.566.07-.781.176-.215.105-.356.25-.496.39a.957.957 0 0 0-.25.497c-.036.175-.07.32-.07.46h3.196c-.07-.526-.25-.882-.497-1.132zm-3.127-3.728h3.978v.957h-3.978v-.957z"
                }
            }
        ]
    })(props);
}
function BsBellFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zm.995-14.901a1 1 0 1 0-1.99 0A5.002 5.002 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901z"
                }
            }
        ]
    })(props);
}
function BsBellSlashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.164 14H15c-1.5-1-2-5.902-2-7 0-.264-.02-.523-.06-.776L5.164 14zm6.288-10.617A4.988 4.988 0 0 0 8.995 2.1a1 1 0 1 0-1.99 0A5.002 5.002 0 0 0 3 7c0 .898-.335 4.342-1.278 6.113l9.73-9.73zM10 15a2 2 0 1 1-4 0h4zm-9.375.625a.53.53 0 0 0 .75.75l14.75-14.75a.53.53 0 0 0-.75-.75L.625 15.625z"
                }
            }
        ]
    })(props);
}
function BsBellSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.164 14H15c-.299-.199-.557-.553-.78-1-.9-1.8-1.22-5.12-1.22-6 0-.264-.02-.523-.06-.776l-.938.938c.02.708.157 2.154.457 3.58.161.767.377 1.566.663 2.258H6.164l-1 1zm5.581-9.91a3.986 3.986 0 0 0-1.948-1.01L8 2.917l-.797.161A4.002 4.002 0 0 0 4 7c0 .628-.134 2.197-.459 3.742-.05.238-.105.479-.166.718l-1.653 1.653c.02-.037.04-.074.059-.113C2.679 11.2 3 7.88 3 7c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0c.942.19 1.788.645 2.457 1.284l-.707.707zM10 15a2 2 0 1 1-4 0h4zm-9.375.625a.53.53 0 0 0 .75.75l14.75-14.75a.53.53 0 0 0-.75-.75L.625 15.625z"
                }
            }
        ]
    })(props);
}
function BsBell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z"
                }
            }
        ]
    })(props);
}
function BsBezier(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M0 10.5A1.5 1.5 0 0 1 1.5 9h1A1.5 1.5 0 0 1 4 10.5v1A1.5 1.5 0 0 1 2.5 13h-1A1.5 1.5 0 0 1 0 11.5v-1zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zm10.5.5A1.5 1.5 0 0 1 13.5 9h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5v-1zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zM6 4.5A1.5 1.5 0 0 1 7.5 3h1A1.5 1.5 0 0 1 10 4.5v1A1.5 1.5 0 0 1 8.5 7h-1A1.5 1.5 0 0 1 6 5.5v-1zM7.5 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4.5H1.866a1 1 0 1 0 0 1h2.668A6.517 6.517 0 0 0 1.814 9H2.5c.123 0 .244.015.358.043a5.517 5.517 0 0 1 3.185-3.185A1.503 1.503 0 0 1 6 5.5v-1zm3.957 1.358A1.5 1.5 0 0 0 10 5.5v-1h4.134a1 1 0 1 1 0 1h-2.668a6.517 6.517 0 0 1 2.72 3.5H13.5c-.123 0-.243.015-.358.043a5.517 5.517 0 0 0-3.185-3.185z"
                }
            }
        ]
    })(props);
}
function BsBezier2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 2.5A1.5 1.5 0 0 1 2.5 1h1A1.5 1.5 0 0 1 5 2.5h4.134a1 1 0 1 1 0 1h-2.01c.18.18.34.381.484.605.638.992.892 2.354.892 3.895 0 1.993.257 3.092.713 3.7.356.476.895.721 1.787.784A1.5 1.5 0 0 1 12.5 11h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5H6.866a1 1 0 1 1 0-1h1.711a2.839 2.839 0 0 1-.165-.2C7.743 11.407 7.5 10.007 7.5 8c0-1.46-.246-2.597-.733-3.355-.39-.605-.952-1-1.767-1.112A1.5 1.5 0 0 1 3.5 5h-1A1.5 1.5 0 0 1 1 3.5v-1zM2.5 2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zm10 10a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1z"
                }
            }
        ]
    })(props);
}
function BsBicycle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4.5a.5.5 0 0 1 .5-.5H6a.5.5 0 0 1 0 1v.5h4.14l.386-1.158A.5.5 0 0 1 11 4h1a.5.5 0 0 1 0 1h-.64l-.311.935.807 1.29a3 3 0 1 1-.848.53l-.508-.812-2.076 3.322A.5.5 0 0 1 8 10.5H5.959a3 3 0 1 1-1.815-3.274L5 5.856V5h-.5a.5.5 0 0 1-.5-.5zm1.5 2.443-.508.814c.5.444.85 1.054.967 1.743h1.139L5.5 6.943zM8 9.057 9.598 6.5H6.402L8 9.057zM4.937 9.5a1.997 1.997 0 0 0-.487-.877l-.548.877h1.035zM3.603 8.092A2 2 0 1 0 4.937 10.5H3a.5.5 0 0 1-.424-.765l1.027-1.643zm7.947.53a2 2 0 1 0 .848-.53l1.026 1.643a.5.5 0 1 1-.848.53L11.55 8.623z"
                }
            }
        ]
    })(props);
}
function BsBing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.35 5.046a.615.615 0 0 0-.54.575c-.009.13-.006.14.289.899.67 1.727.833 2.142.86 2.2.067.142.16.276.277.395.089.092.148.141.247.208.176.117.262.15.944.351.664.197 1.026.327 1.338.482.405.201.688.43.866.7.128.195.242.544.291.896.02.137.02.44 0 .564-.041.27-.124.495-.252.684-.067.1-.044.084.055-.039.278-.346.562-.938.707-1.475a4.42 4.42 0 0 0-2.14-5.028 69.556 69.556 0 0 0-.888-.465 50.419 50.419 0 0 0-.53-.277l-.353-.184c-.16-.082-.266-.138-.345-.18-.368-.192-.523-.27-.568-.283a.93.93 0 0 0-.194-.03l-.063.007Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.152 11.493a2.623 2.623 0 0 0-.135.083 320.256 320.256 0 0 0-1.513.934 164.12 164.12 0 0 0-.8.496c-.012.01-.587.367-.876.543a1.91 1.91 0 0 1-.732.257c-.12.017-.349.017-.47 0a1.891 1.891 0 0 1-.884-.358 2.45 2.45 0 0 1-.365-.364 1.884 1.884 0 0 1-.34-.76 1.441 1.441 0 0 0-.027-.121c-.005-.006.004.092.022.22.018.132.057.324.098.489a4.096 4.096 0 0 0 2.487 2.796c.359.142.72.23 1.114.275.147.016.566.023.72.011a4.103 4.103 0 0 0 1.956-.661l.235-.149a36.314 36.314 0 0 0 .394-.248l.258-.163 1.164-.736c.51-.32.663-.433.9-.665.099-.097.248-.262.255-.283.002-.005.028-.046.059-.091a1.64 1.64 0 0 0 .25-.682c.02-.124.02-.427 0-.565a2.875 2.875 0 0 0-.213-.758c-.15-.314-.47-.6-.928-.83a1.986 1.986 0 0 0-.273-.12c-.006 0-.433.26-.948.58a1699.479 1699.479 0 0 0-1.113.687l-.295.183Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3.004 12.184.03.129c.089.402.245.693.515.963a1.823 1.823 0 0 0 1.312.543c.361 0 .673-.09.994-.287l.472-.29.373-.23V5.334c0-1.537-.003-2.45-.008-2.521a1.817 1.817 0 0 0-.535-1.177c-.097-.096-.18-.16-.427-.33A1192.515 1192.515 0 0 1 4.183.24c-.239-.163-.258-.175-.33-.2a.631.631 0 0 0-.842.464c-.009.042-.01.603-.01 3.646l.003 8.035Z"
                }
            }
        ]
    })(props);
}
function BsBinocularsFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 1A1.5 1.5 0 0 0 3 2.5V3h4v-.5A1.5 1.5 0 0 0 5.5 1h-1zM7 4v1h2V4h4v.882a.5.5 0 0 0 .276.447l.895.447A1.5 1.5 0 0 1 15 7.118V13H9v-1.5a.5.5 0 0 1 .146-.354l.854-.853V9.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v.793l.854.853A.5.5 0 0 1 7 11.5V13H1V7.118a1.5 1.5 0 0 1 .83-1.342l.894-.447A.5.5 0 0 0 3 4.882V4h4zM1 14v.5A1.5 1.5 0 0 0 2.5 16h3A1.5 1.5 0 0 0 7 14.5V14H1zm8 0v.5a1.5 1.5 0 0 0 1.5 1.5h3a1.5 1.5 0 0 0 1.5-1.5V14H9zm4-11H9v-.5A1.5 1.5 0 0 1 10.5 1h1A1.5 1.5 0 0 1 13 2.5V3z"
                }
            }
        ]
    })(props);
}
function BsBinoculars(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2.5A1.5 1.5 0 0 1 4.5 1h1A1.5 1.5 0 0 1 7 2.5V5h2V2.5A1.5 1.5 0 0 1 10.5 1h1A1.5 1.5 0 0 1 13 2.5v2.382a.5.5 0 0 0 .276.447l.895.447A1.5 1.5 0 0 1 15 7.118V14.5a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 14.5v-3a.5.5 0 0 1 .146-.354l.854-.853V9.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v.793l.854.853A.5.5 0 0 1 7 11.5v3A1.5 1.5 0 0 1 5.5 16h-3A1.5 1.5 0 0 1 1 14.5V7.118a1.5 1.5 0 0 1 .83-1.342l.894-.447A.5.5 0 0 0 3 4.882V2.5zM4.5 2a.5.5 0 0 0-.5.5V3h2v-.5a.5.5 0 0 0-.5-.5h-1zM6 4H4v.882a1.5 1.5 0 0 1-.83 1.342l-.894.447A.5.5 0 0 0 2 7.118V13h4v-1.293l-.854-.853A.5.5 0 0 1 5 10.5v-1A1.5 1.5 0 0 1 6.5 8h3A1.5 1.5 0 0 1 11 9.5v1a.5.5 0 0 1-.146.354l-.854.853V13h4V7.118a.5.5 0 0 0-.276-.447l-.895-.447A1.5 1.5 0 0 1 12 4.882V4h-2v1.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V4zm4-1h2v-.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V3zm4 11h-4v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V14zm-8 0H2v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V14z"
                }
            }
        ]
    })(props);
}
function BsBlockquoteLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 3a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1h-11zm5 3a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6zm0 3a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6zm-5 3a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1h-11zm.79-5.373c.112-.078.26-.17.444-.275L3.524 6c-.122.074-.272.17-.452.287-.18.117-.35.26-.51.428a2.425 2.425 0 0 0-.398.562c-.11.207-.164.438-.164.692 0 .36.072.65.217.873.144.219.385.328.72.328.215 0 .383-.07.504-.211a.697.697 0 0 0 .188-.463c0-.23-.07-.404-.211-.521-.137-.121-.326-.182-.568-.182h-.282c.024-.203.065-.37.123-.498a1.38 1.38 0 0 1 .252-.37 1.94 1.94 0 0 1 .346-.298zm2.167 0c.113-.078.262-.17.445-.275L5.692 6c-.122.074-.272.17-.452.287-.18.117-.35.26-.51.428a2.425 2.425 0 0 0-.398.562c-.11.207-.164.438-.164.692 0 .36.072.65.217.873.144.219.385.328.72.328.215 0 .383-.07.504-.211a.697.697 0 0 0 .188-.463c0-.23-.07-.404-.211-.521-.137-.121-.326-.182-.568-.182h-.282a1.75 1.75 0 0 1 .118-.492c.058-.13.144-.254.257-.375a1.94 1.94 0 0 1 .346-.3z"
                }
            }
        ]
    })(props);
}
function BsBlockquoteRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 3a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1h-11zm0 3a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6zm0 3a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6zm0 3a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1h-11zm10.113-5.373a6.59 6.59 0 0 0-.445-.275l.21-.352c.122.074.272.17.452.287.18.117.35.26.51.428.156.164.289.351.398.562.11.207.164.438.164.692 0 .36-.072.65-.216.873-.145.219-.385.328-.721.328-.215 0-.383-.07-.504-.211a.697.697 0 0 1-.188-.463c0-.23.07-.404.211-.521.137-.121.326-.182.569-.182h.281a1.686 1.686 0 0 0-.123-.498 1.379 1.379 0 0 0-.252-.37 1.94 1.94 0 0 0-.346-.298zm-2.168 0A6.59 6.59 0 0 0 10 6.352L10.21 6c.122.074.272.17.452.287.18.117.35.26.51.428.156.164.289.351.398.562.11.207.164.438.164.692 0 .36-.072.65-.216.873-.145.219-.385.328-.721.328-.215 0-.383-.07-.504-.211a.697.697 0 0 1-.188-.463c0-.23.07-.404.211-.521.137-.121.327-.182.569-.182h.281a1.749 1.749 0 0 0-.117-.492 1.402 1.402 0 0 0-.258-.375 1.94 1.94 0 0 0-.346-.3z"
                }
            }
        ]
    })(props);
}
function BsBluetooth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "m8.543 3.948 1.316 1.316L8.543 6.58V3.948Zm0 8.104 1.316-1.316L8.543 9.42v2.632Zm-1.41-4.043L4.275 5.133l.827-.827L7.377 6.58V1.128l4.137 4.136L8.787 8.01l2.745 2.745-4.136 4.137V9.42l-2.294 2.274-.827-.827L7.133 8.01ZM7.903 16c3.498 0 5.904-1.655 5.904-8.01 0-6.335-2.406-7.99-5.903-7.99C4.407 0 2 1.655 2 8.01 2 14.344 4.407 16 7.904 16Z"
                }
            }
        ]
    })(props);
}
function BsBodyText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M0 .5A.5.5 0 0 1 .5 0h4a.5.5 0 0 1 0 1h-4A.5.5 0 0 1 0 .5Zm0 2A.5.5 0 0 1 .5 2h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Zm9 0a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm-9 2A.5.5 0 0 1 .5 4h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm5 0a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm7 0a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm-12 2A.5.5 0 0 1 .5 6h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5Zm8 0a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm-8 2A.5.5 0 0 1 .5 8h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm7 0a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Zm-7 2a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5Zm0 2a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Z"
                }
            }
        ]
    })(props);
}
function BsBookFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783z"
                }
            }
        ]
    })(props);
}
function BsBookHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 2.687c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492V2.687zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783z"
                }
            }
        ]
    })(props);
}
function BsBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 2.828c.885-.37 2.154-.769 3.388-.893 1.33-.134 2.458.063 3.112.752v9.746c-.935-.53-2.12-.603-3.213-.493-1.18.12-2.37.461-3.287.811V2.828zm7.5-.141c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492V2.687zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783z"
                }
            }
        ]
    })(props);
}
function BsBookmarkCheckFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 15.5V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.74.439L8 13.069l-5.26 2.87A.5.5 0 0 1 2 15.5zm8.854-9.646a.5.5 0 0 0-.708-.708L7.5 7.793 6.354 6.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z"
                }
            }
        ]
    })(props);
}
function BsBookmarkCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z"
                }
            }
        ]
    })(props);
}
function BsBookmarkDashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 15.5V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.74.439L8 13.069l-5.26 2.87A.5.5 0 0 1 2 15.5zM6 6a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H6z"
                }
            }
        ]
    })(props);
}
function BsBookmarkDash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.5 6.5A.5.5 0 0 1 6 6h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z"
                }
            }
        ]
    })(props);
}
function BsBookmarkFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2v13.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z"
                }
            }
        ]
    })(props);
}
function BsBookmarkHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 15.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v13.5zM8 4.41c1.387-1.425 4.854 1.07 0 4.277C3.146 5.48 6.613 2.986 8 4.412z"
                }
            }
        ]
    })(props);
}
function BsBookmarkHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 4.41c1.387-1.425 4.854 1.07 0 4.277C3.146 5.48 6.613 2.986 8 4.412z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z"
                }
            }
        ]
    })(props);
}
function BsBookmarkPlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 15.5V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.74.439L8 13.069l-5.26 2.87A.5.5 0 0 1 2 15.5zm6.5-11a.5.5 0 0 0-1 0V6H6a.5.5 0 0 0 0 1h1.5v1.5a.5.5 0 0 0 1 0V7H10a.5.5 0 0 0 0-1H8.5V4.5z"
                }
            }
        ]
    })(props);
}
function BsBookmarkPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4a.5.5 0 0 1 .5.5V6H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V7H6a.5.5 0 0 1 0-1h1.5V4.5A.5.5 0 0 1 8 4z"
                }
            }
        ]
    })(props);
}
function BsBookmarkStarFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 15.5V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.74.439L8 13.069l-5.26 2.87A.5.5 0 0 1 2 15.5zM8.16 4.1a.178.178 0 0 0-.32 0l-.634 1.285a.178.178 0 0 1-.134.098l-1.42.206a.178.178 0 0 0-.098.303L6.58 6.993c.042.041.061.1.051.158L6.39 8.565a.178.178 0 0 0 .258.187l1.27-.668a.178.178 0 0 1 .165 0l1.27.668a.178.178 0 0 0 .257-.187L9.368 7.15a.178.178 0 0 1 .05-.158l1.028-1.001a.178.178 0 0 0-.098-.303l-1.42-.206a.178.178 0 0 1-.134-.098L8.16 4.1z"
                }
            }
        ]
    })(props);
}
function BsBookmarkStar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.84 4.1a.178.178 0 0 1 .32 0l.634 1.285a.178.178 0 0 0 .134.098l1.42.206c.145.021.204.2.098.303L9.42 6.993a.178.178 0 0 0-.051.158l.242 1.414a.178.178 0 0 1-.258.187l-1.27-.668a.178.178 0 0 0-.165 0l-1.27.668a.178.178 0 0 1-.257-.187l.242-1.414a.178.178 0 0 0-.05-.158l-1.03-1.001a.178.178 0 0 1 .098-.303l1.42-.206a.178.178 0 0 0 .134-.098L7.84 4.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z"
                }
            }
        ]
    })(props);
}
function BsBookmarkXFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 15.5V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.74.439L8 13.069l-5.26 2.87A.5.5 0 0 1 2 15.5zM6.854 5.146a.5.5 0 1 0-.708.708L7.293 7 6.146 8.146a.5.5 0 1 0 .708.708L8 7.707l1.146 1.147a.5.5 0 1 0 .708-.708L8.707 7l1.147-1.146a.5.5 0 0 0-.708-.708L8 6.293 6.854 5.146z"
                }
            }
        ]
    })(props);
}
function BsBookmarkX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.146 5.146a.5.5 0 0 1 .708 0L8 6.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 7l1.147 1.146a.5.5 0 0 1-.708.708L8 7.707 6.854 8.854a.5.5 0 1 1-.708-.708L7.293 7 6.146 5.854a.5.5 0 0 1 0-.708z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z"
                }
            }
        ]
    })(props);
}
function BsBookmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z"
                }
            }
        ]
    })(props);
}
function BsBookmarksFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v11.5a.5.5 0 0 1-.777.416L7 13.101l-4.223 2.815A.5.5 0 0 1 2 15.5V4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.268 1A2 2 0 0 1 6 0h6a2 2 0 0 1 2 2v11.5a.5.5 0 0 1-.777.416L13 13.768V2a1 1 0 0 0-1-1H4.268z"
                }
            }
        ]
    })(props);
}
function BsBookmarks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v11.5a.5.5 0 0 1-.777.416L7 13.101l-4.223 2.815A.5.5 0 0 1 2 15.5V4zm2-1a1 1 0 0 0-1 1v10.566l3.723-2.482a.5.5 0 0 1 .554 0L11 14.566V4a1 1 0 0 0-1-1H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.268 1H12a1 1 0 0 1 1 1v11.768l.223.148A.5.5 0 0 0 14 13.5V2a2 2 0 0 0-2-2H6a2 2 0 0 0-1.732 1z"
                }
            }
        ]
    })(props);
}
function BsBookshelf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 0a.5.5 0 0 1 .5.5V2h10V.5a.5.5 0 0 1 1 0v15a.5.5 0 0 1-1 0V15H3v.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 .5-.5zM3 14h10v-3H3v3zm0-4h10V7H3v3zm0-4h10V3H3v3z"
                }
            }
        ]
    })(props);
}
function BsBoomboxFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 0a.5.5 0 0 1 .5.5V2h.5a1 1 0 0 1 1 1v2H0V3a1 1 0 0 1 1-1h12.5V.5A.5.5 0 0 1 14 0ZM2 3.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0Zm2 0a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0Zm7.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm1.5-.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0ZM9.5 3h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1ZM6 10.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-1.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm7 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm.5-1.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 6h16v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V6Zm2 4.5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0Zm7 0a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0Z"
                }
            }
        ]
    })(props);
}
function BsBoombox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm2 0a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm7.5-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm1.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm-7-1a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm5.5 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 13a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm0-1a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM5 10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm-1 0a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 0a.5.5 0 0 1 .5.5V2h.5a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h12.5V.5A.5.5 0 0 1 14 0ZM1 3v3h14V3H1Zm14 4H1v7h14V7Z"
                }
            }
        ]
    })(props);
}
function BsBootstrapFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.375 7.125V4.658h1.78c.973 0 1.542.457 1.542 1.237 0 .802-.604 1.23-1.764 1.23H6.375zm0 3.762h1.898c1.184 0 1.81-.48 1.81-1.377 0-.885-.65-1.348-1.886-1.348H6.375v2.725z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.002 0a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4h-8zm1.06 12V3.545h3.399c1.587 0 2.543.809 2.543 2.11 0 .884-.65 1.675-1.483 1.816v.1c1.143.117 1.904.931 1.904 2.033 0 1.488-1.084 2.396-2.888 2.396H5.062z"
                }
            }
        ]
    })(props);
}
function BsBootstrapReboot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.161 8a6.84 6.84 0 1 0 6.842-6.84.58.58 0 1 1 0-1.16 8 8 0 1 1-6.556 3.412l-.663-.577a.58.58 0 0 1 .227-.997l2.52-.69a.58.58 0 0 1 .728.633l-.332 2.592a.58.58 0 0 1-.956.364l-.643-.56A6.812 6.812 0 0 0 1.16 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.641 11.671V8.843h1.57l1.498 2.828h1.314L9.377 8.665c.897-.3 1.427-1.106 1.427-2.1 0-1.37-.943-2.246-2.456-2.246H5.5v7.352h1.141zm0-3.75V5.277h1.57c.881 0 1.416.499 1.416 1.32 0 .84-.504 1.324-1.386 1.324h-1.6z"
                }
            }
        ]
    })(props);
}
function BsBootstrap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.062 12h3.475c1.804 0 2.888-.908 2.888-2.396 0-1.102-.761-1.916-1.904-2.034v-.1c.832-.14 1.482-.93 1.482-1.816 0-1.3-.955-2.11-2.542-2.11H5.062V12zm1.313-4.875V4.658h1.78c.973 0 1.542.457 1.542 1.237 0 .802-.604 1.23-1.764 1.23H6.375zm0 3.762V8.162h1.822c1.236 0 1.887.463 1.887 1.348 0 .896-.627 1.377-1.811 1.377H6.375z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4zm4-3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3H4z"
                }
            }
        ]
    })(props);
}
function BsBorderAll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 0h16v16H0V0zm1 1v6.5h6.5V1H1zm7.5 0v6.5H15V1H8.5zM15 8.5H8.5V15H15V8.5zM7.5 15V8.5H1V15h6.5z"
                }
            }
        ]
    })(props);
}
function BsBorderBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.969 0H0v.969h.5V1h.469V.969H1V.5H.969V0zm.937 1h.938V0h-.938v1zm1.875 0h.938V0H3.78v1zm1.875 0h.938V0h-.938v1zM7.531.969V1h.938V.969H8.5V.5h-.031V0H7.53v.5H7.5v.469h.031zM9.406 1h.938V0h-.938v1zm1.875 0h.938V0h-.938v1zm1.875 0h.938V0h-.938v1zm1.875 0h.469V.969h.5V0h-.969v.5H15v.469h.031V1zM1 2.844v-.938H0v.938h1zm6.5-.938v.938h1v-.938h-1zm7.5 0v.938h1v-.938h-1zM1 4.719V3.78H0v.938h1zm6.5-.938v.938h1V3.78h-1zm7.5 0v.938h1V3.78h-1zM1 6.594v-.938H0v.938h1zm6.5-.938v.938h1v-.938h-1zm7.5 0v.938h1v-.938h-1zM.5 8.5h.469v-.031H1V7.53H.969V7.5H.5v.031H0v.938h.5V8.5zm1.406 0h.938v-1h-.938v1zm1.875 0h.938v-1H3.78v1zm1.875 0h.938v-1h-.938v1zm2.813 0v-.031H8.5V7.53h-.031V7.5H7.53v.031H7.5v.938h.031V8.5h.938zm.937 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.469v-.031h.5V7.53h-.5V7.5h-.469v.031H15v.938h.031V8.5zM0 9.406v.938h1v-.938H0zm7.5 0v.938h1v-.938h-1zm8.5.938v-.938h-1v.938h1zm-16 .937v.938h1v-.938H0zm7.5 0v.938h1v-.938h-1zm8.5.938v-.938h-1v.938h1zm-16 .937v.938h1v-.938H0zm7.5 0v.938h1v-.938h-1zm8.5.938v-.938h-1v.938h1zM0 15h16v1H0v-1z"
                }
            }
        ]
    })(props);
}
function BsBorderCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.969 0H0v.969h.5V1h.469V.969H1V.5H.969V0zm.937 1h.938V0h-.938v1zm1.875 0h.938V0H3.78v1zm1.875 0h.938V0h-.938v1zM7.531.969V1h.938V.969H8.5V.5h-.031V0H7.53v.5H7.5v.469h.031zM9.406 1h.938V0h-.938v1zm1.875 0h.938V0h-.938v1zm1.875 0h.938V0h-.938v1zm1.875 0h.469V.969h.5V0h-.969v.5H15v.469h.031V1zM1 2.844v-.938H0v.938h1zm6.5-.938v.938h1v-.938h-1zm7.5 0v.938h1v-.938h-1zM1 4.719V3.78H0v.938h1zm6.5-.938v.938h1V3.78h-1zm7.5 0v.938h1V3.78h-1zM1 6.594v-.938H0v.938h1zm6.5-.938v.938h1v-.938h-1zm7.5 0v.938h1v-.938h-1zM0 8.5v-1h16v1H0zm0 .906v.938h1v-.938H0zm7.5 0v.938h1v-.938h-1zm8.5.938v-.938h-1v.938h1zm-16 .937v.938h1v-.938H0zm7.5 0v.938h1v-.938h-1zm8.5.938v-.938h-1v.938h1zm-16 .937v.938h1v-.938H0zm7.5 0v.938h1v-.938h-1zm8.5.938v-.938h-1v.938h1zM0 16h.969v-.5H1v-.469H.969V15H.5v.031H0V16zm1.906 0h.938v-1h-.938v1zm1.875 0h.938v-1H3.78v1zm1.875 0h.938v-1h-.938v1zm1.875-.5v.5h.938v-.5H8.5v-.469h-.031V15H7.53v.031H7.5v.469h.031zm1.875.5h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875-.5v.5H16v-.969h-.5V15h-.469v.031H15v.469h.031z"
                }
            }
        ]
    })(props);
}
function BsBorderInner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.969 0H0v.969h.5V1h.469V.969H1V.5H.969V0zm.937 1h.938V0h-.938v1zm1.875 0h.938V0H3.78v1zm1.875 0h.938V0h-.938v1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 7.5H16v1H8.5V16h-1V8.5H0v-1h7.5V0h1v7.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.406 1h.938V0h-.938v1zm1.875 0h.938V0h-.938v1zm1.875 0h.938V0h-.938v1zm1.875 0h.469V.969h.5V0h-.969v.5H15v.469h.031V1zM1 2.844v-.938H0v.938h1zm14-.938v.938h1v-.938h-1zM1 4.719V3.78H0v.938h1zm14-.938v.938h1V3.78h-1zM1 6.594v-.938H0v.938h1zm14-.938v.938h1v-.938h-1zM0 9.406v.938h1v-.938H0zm16 .938v-.938h-1v.938h1zm-16 .937v.938h1v-.938H0zm16 .938v-.938h-1v.938h1zm-16 .937v.938h1v-.938H0zm16 .938v-.938h-1v.938h1zM0 16h.969v-.5H1v-.469H.969V15H.5v.031H0V16zm1.906 0h.938v-1h-.938v1zm1.875 0h.938v-1H3.78v1zm1.875 0h.938v-1h-.938v1zm3.75 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875-.5v.5H16v-.969h-.5V15h-.469v.031H15v.469h.031z"
                }
            }
        ]
    })(props);
}
function BsBorderLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 0v16h1V0H0zm1.906 1h.938V0h-.938v1zm1.875 0h.938V0H3.78v1zm1.875 0h.938V0h-.938v1zM7.531.969V1h.938V.969H8.5V.5h-.031V0H7.53v.5H7.5v.469h.031zM9.406 1h.938V0h-.938v1zm1.875 0h.938V0h-.938v1zm1.875 0h.938V0h-.938v1zm1.875 0h.469V.969h.5V0h-.969v.5H15v.469h.031V1zM7.5 1.906v.938h1v-.938h-1zm7.5 0v.938h1v-.938h-1zM7.5 3.781v.938h1V3.78h-1zm7.5 0v.938h1V3.78h-1zM7.5 5.656v.938h1v-.938h-1zm7.5 0v.938h1v-.938h-1zM1.906 8.5h.938v-1h-.938v1zm1.875 0h.938v-1H3.78v1zm1.875 0h.938v-1h-.938v1zm2.813 0v-.031H8.5V7.53h-.031V7.5H7.53v.031H7.5v.938h.031V8.5h.938zm.937 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.469v-.031h.5V7.53h-.5V7.5h-.469v.031H15v.938h.031V8.5zM7.5 9.406v.938h1v-.938h-1zm8.5.938v-.938h-1v.938h1zm-8.5.937v.938h1v-.938h-1zm8.5.938v-.938h-1v.938h1zm-8.5.937v.938h1v-.938h-1zm8.5.938v-.938h-1v.938h1zM1.906 16h.938v-1h-.938v1zm1.875 0h.938v-1H3.78v1zm1.875 0h.938v-1h-.938v1zm1.875-.5v.5h.938v-.5H8.5v-.469h-.031V15H7.53v.031H7.5v.469h.031zm1.875.5h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875-.5v.5H16v-.969h-.5V15h-.469v.031H15v.469h.031z"
                }
            }
        ]
    })(props);
}
function BsBorderMiddle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.969 0H0v.969h.5V1h.469V.969H1V.5H.969V0zm.937 1h.938V0h-.938v1zm1.875 0h.938V0H3.78v1zm1.875 0h.938V0h-.938v1zM8.5 16h-1V0h1v16zm.906-15h.938V0h-.938v1zm1.875 0h.938V0h-.938v1zm1.875 0h.938V0h-.938v1zm1.875 0h.469V.969h.5V0h-.969v.5H15v.469h.031V1zM1 2.844v-.938H0v.938h1zm14-.938v.938h1v-.938h-1zM1 4.719V3.78H0v.938h1zm14-.938v.938h1V3.78h-1zM1 6.594v-.938H0v.938h1zm14-.938v.938h1v-.938h-1zM.5 8.5h.469v-.031H1V7.53H.969V7.5H.5v.031H0v.938h.5V8.5zm1.406 0h.938v-1h-.938v1zm1.875 0h.938v-1H3.78v1zm1.875 0h.938v-1h-.938v1zm3.75 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.469v-.031h.5V7.53h-.5V7.5h-.469v.031H15v.938h.031V8.5zM0 9.406v.938h1v-.938H0zm16 .938v-.938h-1v.938h1zm-16 .937v.938h1v-.938H0zm16 .938v-.938h-1v.938h1zm-16 .937v.938h1v-.938H0zm16 .938v-.938h-1v.938h1zM0 16h.969v-.5H1v-.469H.969V15H.5v.031H0V16zm1.906 0h.938v-1h-.938v1zm1.875 0h.938v-1H3.78v1zm1.875 0h.938v-1h-.938v1zm3.75 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875-.5v.5H16v-.969h-.5V15h-.469v.031H15v.469h.031z"
                }
            }
        ]
    })(props);
}
function BsBorderOuter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 1.906v.938h1v-.938h-1zm0 1.875v.938h1V3.78h-1zm0 1.875v.938h1v-.938h-1zM1.906 8.5h.938v-1h-.938v1zm1.875 0h.938v-1H3.78v1zm1.875 0h.938v-1h-.938v1zm2.813 0v-.031H8.5V7.53h-.031V7.5H7.53v.031H7.5v.938h.031V8.5h.938zm.937 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zM7.5 9.406v.938h1v-.938h-1zm0 1.875v.938h1v-.938h-1zm0 1.875v.938h1v-.938h-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 0v16h16V0H0zm1 1h14v14H1V1z"
                }
            }
        ]
    })(props);
}
function BsBorderRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.969 0H0v.969h.5V1h.469V.969H1V.5H.969V0zm.937 1h.938V0h-.938v1zm1.875 0h.938V0H3.78v1zm1.875 0h.938V0h-.938v1zM7.531.969V1h.938V.969H8.5V.5h-.031V0H7.53v.5H7.5v.469h.031zM9.406 1h.938V0h-.938v1zm1.875 0h.938V0h-.938v1zm1.875 0h.938V0h-.938v1zM16 0h-1v16h1V0zM1 2.844v-.938H0v.938h1zm6.5-.938v.938h1v-.938h-1zM1 4.719V3.78H0v.938h1zm6.5-.938v.938h1V3.78h-1zM1 6.594v-.938H0v.938h1zm6.5-.938v.938h1v-.938h-1zM.5 8.5h.469v-.031H1V7.53H.969V7.5H.5v.031H0v.938h.5V8.5zm1.406 0h.938v-1h-.938v1zm1.875 0h.938v-1H3.78v1zm1.875 0h.938v-1h-.938v1zm2.813 0v-.031H8.5V7.53h-.031V7.5H7.53v.031H7.5v.938h.031V8.5h.938zm.937 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zM0 9.406v.938h1v-.938H0zm7.5 0v.938h1v-.938h-1zM0 11.281v.938h1v-.938H0zm7.5 0v.938h1v-.938h-1zM0 13.156v.938h1v-.938H0zm7.5 0v.938h1v-.938h-1zM0 16h.969v-.5H1v-.469H.969V15H.5v.031H0V16zm1.906 0h.938v-1h-.938v1zm1.875 0h.938v-1H3.78v1zm1.875 0h.938v-1h-.938v1zm1.875-.5v.5h.938v-.5H8.5v-.469h-.031V15H7.53v.031H7.5v.469h.031zm1.875.5h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1z"
                }
            }
        ]
    })(props);
}
function BsBorderStyle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 3.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-1zm0 4a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm8 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-4 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm8 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-4-4a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1z"
                }
            }
        ]
    })(props);
}
function BsBorderTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 0v1h16V0H0zm1 2.844v-.938H0v.938h1zm6.5-.938v.938h1v-.938h-1zm7.5 0v.938h1v-.938h-1zM1 4.719V3.78H0v.938h1zm6.5-.938v.938h1V3.78h-1zm7.5 0v.938h1V3.78h-1zM1 6.594v-.938H0v.938h1zm6.5-.938v.938h1v-.938h-1zm7.5 0v.938h1v-.938h-1zM.5 8.5h.469v-.031H1V7.53H.969V7.5H.5v.031H0v.938h.5V8.5zm1.406 0h.938v-1h-.938v1zm1.875 0h.938v-1H3.78v1zm1.875 0h.938v-1h-.938v1zm2.813 0v-.031H8.5V7.53h-.031V7.5H7.53v.031H7.5v.938h.031V8.5h.938zm.937 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.469v-.031h.5V7.53h-.5V7.5h-.469v.031H15v.938h.031V8.5zM0 9.406v.938h1v-.938H0zm7.5 0v.938h1v-.938h-1zm8.5.938v-.938h-1v.938h1zm-16 .937v.938h1v-.938H0zm7.5 0v.938h1v-.938h-1zm8.5.938v-.938h-1v.938h1zm-16 .937v.938h1v-.938H0zm7.5 0v.938h1v-.938h-1zm8.5.938v-.938h-1v.938h1zM0 16h.969v-.5H1v-.469H.969V15H.5v.031H0V16zm1.906 0h.938v-1h-.938v1zm1.875 0h.938v-1H3.78v1zm1.875 0h.938v-1h-.938v1zm1.875-.5v.5h.938v-.5H8.5v-.469h-.031V15H7.53v.031H7.5v.469h.031zm1.875.5h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875-.5v.5H16v-.969h-.5V15h-.469v.031H15v.469h.031z"
                }
            }
        ]
    })(props);
}
function BsBorderWidth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3.5A.5.5 0 0 1 .5 3h15a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-2zm0 5A.5.5 0 0 1 .5 8h15a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-1zm0 4a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsBorder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 0h.969v.5H1v.469H.969V1H.5V.969H0V0zm2.844 1h-.938V0h.938v1zm1.875 0H3.78V0h.938v1zm1.875 0h-.938V0h.938v1zm.937 0V.969H7.5V.5h.031V0h.938v.5H8.5v.469h-.031V1H7.53zm2.813 0h-.938V0h.938v1zm1.875 0h-.938V0h.938v1zm1.875 0h-.938V0h.938v1zM15.5 1h-.469V.969H15V.5h.031V0H16v.969h-.5V1zM1 1.906v.938H0v-.938h1zm6.5.938v-.938h1v.938h-1zm7.5 0v-.938h1v.938h-1zM1 3.78v.938H0V3.78h1zm6.5.938V3.78h1v.938h-1zm7.5 0V3.78h1v.938h-1zM1 5.656v.938H0v-.938h1zm6.5.938v-.938h1v.938h-1zm7.5 0v-.938h1v.938h-1zM.969 8.5H.5v-.031H0V7.53h.5V7.5h.469v.031H1v.938H.969V8.5zm1.875 0h-.938v-1h.938v1zm1.875 0H3.78v-1h.938v1zm1.875 0h-.938v-1h.938v1zm1.875-.031V8.5H7.53v-.031H7.5V7.53h.031V7.5h.938v.031H8.5v.938h-.031zm1.875.031h-.938v-1h.938v1zm1.875 0h-.938v-1h.938v1zm1.875 0h-.938v-1h.938v1zm1.406 0h-.469v-.031H15V7.53h.031V7.5h.469v.031h.5v.938h-.5V8.5zM0 10.344v-.938h1v.938H0zm7.5 0v-.938h1v.938h-1zm8.5-.938v.938h-1v-.938h1zM0 12.22v-.938h1v.938H0zm7.5 0v-.938h1v.938h-1zm8.5-.938v.938h-1v-.938h1zM0 14.094v-.938h1v.938H0zm7.5 0v-.938h1v.938h-1zm8.5-.938v.938h-1v-.938h1zM.969 16H0v-.969h.5V15h.469v.031H1v.469H.969v.5zm1.875 0h-.938v-1h.938v1zm1.875 0H3.78v-1h.938v1zm1.875 0h-.938v-1h.938v1zm.937 0v-.5H7.5v-.469h.031V15h.938v.031H8.5v.469h-.031v.5H7.53zm2.813 0h-.938v-1h.938v1zm1.875 0h-.938v-1h.938v1zm1.875 0h-.938v-1h.938v1zm.937 0v-.5H15v-.469h.031V15h.469v.031h.5V16h-.969z"
                }
            }
        ]
    })(props);
}
function BsBoundingBoxCircles(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM0 2a2 2 0 0 1 3.937-.5h8.126A2 2 0 1 1 14.5 3.937v8.126a2 2 0 1 1-2.437 2.437H3.937A2 2 0 1 1 1.5 12.063V3.937A2 2 0 0 1 0 2zm2.5 1.937v8.126c.703.18 1.256.734 1.437 1.437h8.126a2.004 2.004 0 0 1 1.437-1.437V3.937A2.004 2.004 0 0 1 12.063 2.5H3.937A2.004 2.004 0 0 1 2.5 3.937zM14 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM2 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm12 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
                }
            }
        ]
    })(props);
}
function BsBoundingBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2V0H0v5h2v6H0v5h5v-2h6v2h5v-5h-2V5h2V0h-5v2H5zm6 1v2h2v6h-2v2H5v-2H3V5h2V3h6zm1-2h3v3h-3V1zm3 11v3h-3v-3h3zM4 15H1v-3h3v3zM1 4V1h3v3H1z"
                }
            }
        ]
    })(props);
}
function BsBoxArrowDownLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.364 12.5a.5.5 0 0 0 .5.5H14.5a1.5 1.5 0 0 0 1.5-1.5v-10A1.5 1.5 0 0 0 14.5 0h-10A1.5 1.5 0 0 0 3 1.5v6.636a.5.5 0 1 0 1 0V1.5a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H7.864a.5.5 0 0 0-.5.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M0 15.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 0-1H1.707l8.147-8.146a.5.5 0 0 0-.708-.708L1 14.293V10.5a.5.5 0 0 0-1 0v5z"
                }
            }
        ]
    })(props);
}
function BsBoxArrowDownRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.636 12.5a.5.5 0 0 1-.5.5H1.5A1.5 1.5 0 0 1 0 11.5v-10A1.5 1.5 0 0 1 1.5 0h10A1.5 1.5 0 0 1 13 1.5v6.636a.5.5 0 0 1-1 0V1.5a.5.5 0 0 0-.5-.5h-10a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h6.636a.5.5 0 0 1 .5.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M16 15.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1 0-1h3.793L6.146 6.854a.5.5 0 1 1 .708-.708L15 14.293V10.5a.5.5 0 0 1 1 0v5z"
                }
            }
        ]
    })(props);
}
function BsBoxArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.5 10a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0 0 1h2A1.5 1.5 0 0 0 14 9.5v-8A1.5 1.5 0 0 0 12.5 0h-9A1.5 1.5 0 0 0 2 1.5v8A1.5 1.5 0 0 0 3.5 11h2a.5.5 0 0 0 0-1h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708l3 3z"
                }
            }
        ]
    })(props);
}
function BsBoxArrowInDownLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.636 2.5a.5.5 0 0 0-.5-.5H2.5A1.5 1.5 0 0 0 1 3.5v10A1.5 1.5 0 0 0 2.5 15h10a1.5 1.5 0 0 0 1.5-1.5V6.864a.5.5 0 0 0-1 0V13.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 10.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 0-1H6.707l8.147-8.146a.5.5 0 0 0-.708-.708L6 9.293V5.5a.5.5 0 0 0-1 0v5z"
                }
            }
        ]
    })(props);
}
function BsBoxArrowInDownRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.364 2.5a.5.5 0 0 1 .5-.5H13.5A1.5 1.5 0 0 1 15 3.5v10a1.5 1.5 0 0 1-1.5 1.5h-10A1.5 1.5 0 0 1 2 13.5V6.864a.5.5 0 1 1 1 0V13.5a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5H6.864a.5.5 0 0 1-.5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11 10.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1 0-1h3.793L1.146 1.854a.5.5 0 1 1 .708-.708L10 9.293V5.5a.5.5 0 0 1 1 0v5z"
                }
            }
        ]
    })(props);
}
function BsBoxArrowInDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.5 6a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1 0-1h2A1.5 1.5 0 0 1 14 6.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-8A1.5 1.5 0 0 1 3.5 5h2a.5.5 0 0 1 0 1h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"
                }
            }
        ]
    })(props);
}
function BsBoxArrowInLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 3.5a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 1 0v2A1.5 1.5 0 0 1 9.5 14h-8A1.5 1.5 0 0 1 0 12.5v-9A1.5 1.5 0 0 1 1.5 2h8A1.5 1.5 0 0 1 11 3.5v2a.5.5 0 0 1-1 0v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H14.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3z"
                }
            }
        ]
    })(props);
}
function BsBoxArrowInRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"
                }
            }
        ]
    })(props);
}
function BsBoxArrowInUpLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.636 13.5a.5.5 0 0 1-.5.5H2.5A1.5 1.5 0 0 1 1 12.5v-10A1.5 1.5 0 0 1 2.5 1h10A1.5 1.5 0 0 1 14 2.5v6.636a.5.5 0 0 1-1 0V2.5a.5.5 0 0 0-.5-.5h-10a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h6.636a.5.5 0 0 1 .5.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1H6.707l8.147 8.146a.5.5 0 0 1-.708.708L6 6.707V10.5a.5.5 0 0 1-1 0v-5z"
                }
            }
        ]
    })(props);
}
function BsBoxArrowInUpRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.364 13.5a.5.5 0 0 0 .5.5H13.5a1.5 1.5 0 0 0 1.5-1.5v-10A1.5 1.5 0 0 0 13.5 1h-10A1.5 1.5 0 0 0 2 2.5v6.636a.5.5 0 1 0 1 0V2.5a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H6.864a.5.5 0 0 0-.5.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11 5.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793l-8.147 8.146a.5.5 0 0 0 .708.708L10 6.707V10.5a.5.5 0 0 0 1 0v-5z"
                }
            }
        ]
    })(props);
}
function BsBoxArrowInUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.5 10a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0 0 1h2A1.5 1.5 0 0 0 14 9.5v-8A1.5 1.5 0 0 0 12.5 0h-9A1.5 1.5 0 0 0 2 1.5v8A1.5 1.5 0 0 0 3.5 11h2a.5.5 0 0 0 0-1h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3z"
                }
            }
        ]
    })(props);
}
function BsBoxArrowLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0v2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3z"
                }
            }
        ]
    })(props);
}
function BsBoxArrowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"
                }
            }
        ]
    })(props);
}
function BsBoxArrowUpLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.364 3.5a.5.5 0 0 1 .5-.5H14.5A1.5 1.5 0 0 1 16 4.5v10a1.5 1.5 0 0 1-1.5 1.5h-10A1.5 1.5 0 0 1 3 14.5V7.864a.5.5 0 1 1 1 0V14.5a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5H7.864a.5.5 0 0 1-.5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M0 .5A.5.5 0 0 1 .5 0h5a.5.5 0 0 1 0 1H1.707l8.147 8.146a.5.5 0 0 1-.708.708L1 1.707V5.5a.5.5 0 0 1-1 0v-5z"
                }
            }
        ]
    })(props);
}
function BsBoxArrowUpRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"
                }
            }
        ]
    })(props);
}
function BsBoxArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.5 6a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1 0-1h2A1.5 1.5 0 0 1 14 6.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-8A1.5 1.5 0 0 1 3.5 5h2a.5.5 0 0 1 0 1h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.646.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 1.707V10.5a.5.5 0 0 1-1 0V1.707L5.354 3.854a.5.5 0 1 1-.708-.708l3-3z"
                }
            }
        ]
    })(props);
}
function BsBoxFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.528 2.973a.75.75 0 0 1 .472.696v8.662a.75.75 0 0 1-.472.696l-7.25 2.9a.75.75 0 0 1-.557 0l-7.25-2.9A.75.75 0 0 1 0 12.331V3.669a.75.75 0 0 1 .471-.696L7.443.184l.004-.001.274-.11a.75.75 0 0 1 .558 0l.274.11.004.001 6.971 2.789Zm-1.374.527L8 5.962 1.846 3.5 1 3.839v.4l6.5 2.6v7.922l.5.2.5-.2V6.84l6.5-2.6v-.4l-.846-.339Z"
                }
            }
        ]
    })(props);
}
function BsBoxSeamFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.528 2.973a.75.75 0 0 1 .472.696v8.662a.75.75 0 0 1-.472.696l-7.25 2.9a.75.75 0 0 1-.557 0l-7.25-2.9A.75.75 0 0 1 0 12.331V3.669a.75.75 0 0 1 .471-.696L7.443.184l.01-.003.268-.108a.75.75 0 0 1 .558 0l.269.108.01.003 6.97 2.789ZM10.404 2 4.25 4.461 1.846 3.5 1 3.839v.4l6.5 2.6v7.922l.5.2.5-.2V6.84l6.5-2.6v-.4l-.846-.339L8 5.961 5.596 5l6.154-2.461L10.404 2Z"
                }
            }
        ]
    })(props);
}
function BsBoxSeam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5l2.404.961L10.404 2l-2.218-.887zm3.564 1.426L5.596 5 8 5.961 14.154 3.5l-2.404-.961zm3.25 1.7-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 2.6zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464L7.443.184z"
                }
            }
        ]
    })(props);
}
function BsBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5 8 5.961 14.154 3.5 8.186 1.113zM15 4.239l-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 2.6zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464L7.443.184z"
                }
            }
        ]
    })(props);
}
function BsBox2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.75 0a1 1 0 0 0-.8.4L.1 4.2a.5.5 0 0 0-.1.3V15a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4.5a.5.5 0 0 0-.1-.3L13.05.4a1 1 0 0 0-.8-.4h-8.5ZM15 4.667V5H1v-.333L1.5 4h6V1h1v3h6l.5.667Z"
                }
            }
        ]
    })(props);
}
function BsBox2HeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.75 0a1 1 0 0 0-.8.4L.1 4.2a.5.5 0 0 0-.1.3V15a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4.5a.5.5 0 0 0-.1-.3L13.05.4a1 1 0 0 0-.8-.4h-8.5ZM8.5 4h6l.5.667V5H1v-.333L1.5 4h6V1h1v3ZM8 7.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z"
                }
            }
        ]
    })(props);
}
function BsBox2Heart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7.982C9.664 6.309 13.825 9.236 8 13 2.175 9.236 6.336 6.31 8 7.982Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.75 0a1 1 0 0 0-.8.4L.1 4.2a.5.5 0 0 0-.1.3V15a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4.5a.5.5 0 0 0-.1-.3L13.05.4a1 1 0 0 0-.8-.4h-8.5Zm0 1H7.5v3h-6l2.25-3ZM8.5 4V1h3.75l2.25 3h-6ZM15 5v10H1V5h14Z"
                }
            }
        ]
    })(props);
}
function BsBox2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.95.4a1 1 0 0 1 .8-.4h8.5a1 1 0 0 1 .8.4l2.85 3.8a.5.5 0 0 1 .1.3V15a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4.5a.5.5 0 0 1 .1-.3L2.95.4ZM7.5 1H3.75L1.5 4h6V1Zm1 0v3h6l-2.25-3H8.5ZM15 5H1v10h14V5Z"
                }
            }
        ]
    })(props);
}
function BsBoxes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.752.066a.5.5 0 0 1 .496 0l3.75 2.143a.5.5 0 0 1 .252.434v3.995l3.498 2A.5.5 0 0 1 16 9.07v4.286a.5.5 0 0 1-.252.434l-3.75 2.143a.5.5 0 0 1-.496 0l-3.502-2-3.502 2.001a.5.5 0 0 1-.496 0l-3.75-2.143A.5.5 0 0 1 0 13.357V9.071a.5.5 0 0 1 .252-.434L3.75 6.638V2.643a.5.5 0 0 1 .252-.434L7.752.066ZM4.25 7.504 1.508 9.071l2.742 1.567 2.742-1.567L4.25 7.504ZM7.5 9.933l-2.75 1.571v3.134l2.75-1.571V9.933Zm1 3.134 2.75 1.571v-3.134L8.5 9.933v3.134Zm.508-3.996 2.742 1.567 2.742-1.567-2.742-1.567-2.742 1.567Zm2.242-2.433V3.504L8.5 5.076V8.21l2.75-1.572ZM7.5 8.21V5.076L4.75 3.504v3.134L7.5 8.21ZM5.258 2.643 8 4.21l2.742-1.567L8 1.076 5.258 2.643ZM15 9.933l-2.75 1.571v3.134L15 13.067V9.933ZM3.75 14.638v-3.134L1 9.933v3.134l2.75 1.571Z"
                }
            }
        ]
    })(props);
}
function BsBracesAsterisk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.114 8.063V7.9c1.005-.102 1.497-.615 1.497-1.6V4.503c0-1.094.39-1.538 1.354-1.538h.273V2h-.376C2.25 2 1.49 2.759 1.49 4.352v1.524c0 1.094-.376 1.456-1.49 1.456v1.299c1.114 0 1.49.362 1.49 1.456v1.524c0 1.593.759 2.352 2.372 2.352h.376v-.964h-.273c-.964 0-1.354-.444-1.354-1.538V9.663c0-.984-.492-1.497-1.497-1.6ZM14.886 7.9v.164c-1.005.103-1.497.616-1.497 1.6v1.798c0 1.094-.39 1.538-1.354 1.538h-.273v.964h.376c1.613 0 2.372-.759 2.372-2.352v-1.524c0-1.094.376-1.456 1.49-1.456v-1.3c-1.114 0-1.49-.362-1.49-1.456V4.352C14.51 2.759 13.75 2 12.138 2h-.376v.964h.273c.964 0 1.354.444 1.354 1.538V6.3c0 .984.492 1.497 1.497 1.6ZM7.5 11.5V9.207l-1.621 1.621-.707-.707L6.792 8.5H4.5v-1h2.293L5.172 5.879l.707-.707L7.5 6.792V4.5h1v2.293l1.621-1.621.707.707L9.208 7.5H11.5v1H9.207l1.621 1.621-.707.707L8.5 9.208V11.5h-1Z"
                }
            }
        ]
    })(props);
}
function BsBraces(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.114 8.063V7.9c1.005-.102 1.497-.615 1.497-1.6V4.503c0-1.094.39-1.538 1.354-1.538h.273V2h-.376C3.25 2 2.49 2.759 2.49 4.352v1.524c0 1.094-.376 1.456-1.49 1.456v1.299c1.114 0 1.49.362 1.49 1.456v1.524c0 1.593.759 2.352 2.372 2.352h.376v-.964h-.273c-.964 0-1.354-.444-1.354-1.538V9.663c0-.984-.492-1.497-1.497-1.6zM13.886 7.9v.163c-1.005.103-1.497.616-1.497 1.6v1.798c0 1.094-.39 1.538-1.354 1.538h-.273v.964h.376c1.613 0 2.372-.759 2.372-2.352v-1.524c0-1.094.376-1.456 1.49-1.456V7.332c-1.114 0-1.49-.362-1.49-1.456V4.352C13.51 2.759 12.75 2 11.138 2h-.376v.964h.273c.964 0 1.354.444 1.354 1.538V6.3c0 .984.492 1.497 1.497 1.6z"
                }
            }
        ]
    })(props);
}
function BsBricks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 .5A.5.5 0 0 1 .5 0h15a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H14v2h1.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H14v2h1.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H2v-2H.5a.5.5 0 0 1-.5-.5v-3A.5.5 0 0 1 .5 6H2V4H.5a.5.5 0 0 1-.5-.5v-3zM3 4v2h4.5V4H3zm5.5 0v2H13V4H8.5zM3 10v2h4.5v-2H3zm5.5 0v2H13v-2H8.5zM1 1v2h3.5V1H1zm4.5 0v2h5V1h-5zm6 0v2H15V1h-3.5zM1 7v2h3.5V7H1zm4.5 0v2h5V7h-5zm6 0v2H15V7h-3.5zM1 13v2h3.5v-2H1zm4.5 0v2h5v-2h-5zm6 0v2H15v-2h-3.5z"
                }
            }
        ]
    })(props);
}
function BsBriefcaseFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v1.384l7.614 2.03a1.5 1.5 0 0 0 .772 0L16 5.884V4.5A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1h-3zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 12.5A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5V6.85L8.129 8.947a.5.5 0 0 1-.258 0L0 6.85v5.65z"
                }
            }
        ]
    })(props);
}
function BsBriefcase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1h-3zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5zm1.886 6.914L15 7.151V12.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V7.15l6.614 1.764a1.5 1.5 0 0 0 .772 0zM1.5 4h13a.5.5 0 0 1 .5.5v1.616L8.129 7.948a.5.5 0 0 1-.258 0L1 6.116V4.5a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsBrightnessAltHighFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 3zm8 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zm-13.5.5a.5.5 0 0 0 0-1h-2a.5.5 0 0 0 0 1h2zm11.157-6.157a.5.5 0 0 1 0 .707l-1.414 1.414a.5.5 0 1 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm-9.9 2.121a.5.5 0 0 0 .707-.707L3.05 5.343a.5.5 0 1 0-.707.707l1.414 1.414zM8 7a4 4 0 0 0-4 4 .5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5 4 4 0 0 0-4-4z"
                }
            }
        ]
    })(props);
}
function BsBrightnessAltHigh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 3zm8 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zm-13.5.5a.5.5 0 0 0 0-1h-2a.5.5 0 0 0 0 1h2zm11.157-6.157a.5.5 0 0 1 0 .707l-1.414 1.414a.5.5 0 1 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm-9.9 2.121a.5.5 0 0 0 .707-.707L3.05 5.343a.5.5 0 1 0-.707.707l1.414 1.414zM8 7a4 4 0 0 0-4 4 .5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5 4 4 0 0 0-4-4zm0 1a3 3 0 0 1 2.959 2.5H5.04A3 3 0 0 1 8 8z"
                }
            }
        ]
    })(props);
}
function BsBrightnessAltLowFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 5.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm5 6a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zM2 11a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0zm10.243-3.536a.5.5 0 1 1-.707-.707.5.5 0 0 1 .707.707zm-8.486-.707a.5.5 0 1 0 .707.707.5.5 0 0 0-.707-.707zM8 7a4 4 0 0 0-4 4 .5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5 4 4 0 0 0-4-4z"
                }
            }
        ]
    })(props);
}
function BsBrightnessAltLow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 5.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm5 6a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zM2 11a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0zm10.243-3.536a.5.5 0 1 1-.707-.707.5.5 0 0 1 .707.707zm-8.486-.707a.5.5 0 1 0 .707.707.5.5 0 0 0-.707-.707zM8 7a4 4 0 0 0-4 4 .5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5 4 4 0 0 0-4-4zm0 1a3 3 0 0 1 2.959 2.5H5.04A3 3 0 0 1 8 8z"
                }
            }
        ]
    })(props);
}
function BsBrightnessHighFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z"
                }
            }
        ]
    })(props);
}
function BsBrightnessHigh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z"
                }
            }
        ]
    })(props);
}
function BsBrightnessLowFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0zM8.5 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm0 11a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm5-5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm-11 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm9.743-4.036a.5.5 0 1 1-.707-.707.5.5 0 0 1 .707.707zm-7.779 7.779a.5.5 0 1 1-.707-.707.5.5 0 0 1 .707.707zm7.072 0a.5.5 0 1 1 .707-.707.5.5 0 0 1-.707.707zM3.757 4.464a.5.5 0 1 1 .707-.707.5.5 0 0 1-.707.707z"
                }
            }
        ]
    })(props);
}
function BsBrightnessLow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm.5-9.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm0 11a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm5-5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm-11 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm9.743-4.036a.5.5 0 1 1-.707-.707.5.5 0 0 1 .707.707zm-7.779 7.779a.5.5 0 1 1-.707-.707.5.5 0 0 1 .707.707zm7.072 0a.5.5 0 1 1 .707-.707.5.5 0 0 1-.707.707zM3.757 4.464a.5.5 0 1 1 .707-.707.5.5 0 0 1-.707.707z"
                }
            }
        ]
    })(props);
}
function BsBrilliance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16ZM1 8a7 7 0 0 0 7 7 3.5 3.5 0 1 0 0-7 3.5 3.5 0 1 1 0-7 7 7 0 0 0-7 7Z"
                }
            }
        ]
    })(props);
}
function BsBroadcastPin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.05 3.05a7 7 0 0 0 0 9.9.5.5 0 0 1-.707.707 8 8 0 0 1 0-11.314.5.5 0 0 1 .707.707zm2.122 2.122a4 4 0 0 0 0 5.656.5.5 0 1 1-.708.708 5 5 0 0 1 0-7.072.5.5 0 0 1 .708.708zm5.656-.708a.5.5 0 0 1 .708 0 5 5 0 0 1 0 7.072.5.5 0 1 1-.708-.708 4 4 0 0 0 0-5.656.5.5 0 0 1 0-.708zm2.122-2.12a.5.5 0 0 1 .707 0 8 8 0 0 1 0 11.313.5.5 0 0 1-.707-.707 7 7 0 0 0 0-9.9.5.5 0 0 1 0-.707zM6 8a2 2 0 1 1 2.5 1.937V15.5a.5.5 0 0 1-1 0V9.937A2 2 0 0 1 6 8z"
                }
            }
        ]
    })(props);
}
function BsBroadcast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.05 3.05a7 7 0 0 0 0 9.9.5.5 0 0 1-.707.707 8 8 0 0 1 0-11.314.5.5 0 0 1 .707.707zm2.122 2.122a4 4 0 0 0 0 5.656.5.5 0 1 1-.708.708 5 5 0 0 1 0-7.072.5.5 0 0 1 .708.708zm5.656-.708a.5.5 0 0 1 .708 0 5 5 0 0 1 0 7.072.5.5 0 1 1-.708-.708 4 4 0 0 0 0-5.656.5.5 0 0 1 0-.708zm2.122-2.12a.5.5 0 0 1 .707 0 8 8 0 0 1 0 11.313.5.5 0 0 1-.707-.707 7 7 0 0 0 0-9.9.5.5 0 0 1 0-.707zM10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
                }
            }
        ]
    })(props);
}
function BsBrowserChrome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M16 8a8.001 8.001 0 0 1-7.022 7.94l1.902-7.098a2.995 2.995 0 0 0 .05-1.492A2.977 2.977 0 0 0 10.237 6h5.511A8 8 0 0 1 16 8ZM0 8a8 8 0 0 0 7.927 8l1.426-5.321a2.978 2.978 0 0 1-.723.255 2.979 2.979 0 0 1-1.743-.147 2.986 2.986 0 0 1-1.043-.7L.633 4.876A7.975 7.975 0 0 0 0 8Zm5.004-.167L1.108 3.936A8.003 8.003 0 0 1 15.418 5H8.066a2.979 2.979 0 0 0-1.252.243 2.987 2.987 0 0 0-1.81 2.59ZM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
                }
            }
        ]
    })(props);
}
function BsBrowserEdge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.482 9.341c-.069.062-.17.153-.17.309 0 .162.107.325.3.456.877.613 2.521.54 2.592.538h.002c.667 0 1.32-.18 1.894-.519A3.838 3.838 0 0 0 16 6.819c.018-1.316-.44-2.218-.666-2.664l-.04-.08C13.963 1.487 11.106 0 8 0A8 8 0 0 0 .473 5.29C1.488 4.048 3.183 3.262 5 3.262c2.83 0 5.01 1.885 5.01 4.797h-.004v.002c0 .338-.168.832-.487 1.244l.006-.006a.594.594 0 0 1-.043.041Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M.01 7.753a8.137 8.137 0 0 0 .753 3.641 8 8 0 0 0 6.495 4.564 5.21 5.21 0 0 1-.785-.377h-.01l-.12-.075a5.45 5.45 0 0 1-1.56-1.463A5.543 5.543 0 0 1 6.81 5.8l.01-.004.025-.012c.208-.098.62-.292 1.167-.285.129.001.257.012.384.033a4.037 4.037 0 0 0-.993-.698l-.01-.005C6.348 4.282 5.199 4.263 5 4.263c-2.44 0-4.824 1.634-4.99 3.49Zm10.263 7.912c.088-.027.177-.054.265-.084-.102.032-.204.06-.307.086l.042-.002Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.228 15.667a5.21 5.21 0 0 0 .303-.086l.082-.025a8.019 8.019 0 0 0 4.162-3.3.25.25 0 0 0-.331-.35c-.215.112-.436.21-.663.294a6.367 6.367 0 0 1-2.243.4c-2.957 0-5.532-2.031-5.532-4.644.002-.135.017-.268.046-.399a4.543 4.543 0 0 0-.46 5.898l.003.005c.315.441.707.821 1.158 1.121h.003l.144.09c.877.55 1.721 1.078 3.328.996Z"
                }
            }
        ]
    })(props);
}
function BsBrowserFirefox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.384 3.408c.535.276 1.22 1.152 1.556 1.963a7.98 7.98 0 0 1 .503 3.897l-.009.077a8.533 8.533 0 0 1-.026.224A7.758 7.758 0 0 1 .006 8.257v-.04c.016-.363.055-.724.114-1.082.01-.074.075-.42.09-.489l.01-.051a6.551 6.551 0 0 1 1.041-2.35c.217-.31.46-.6.725-.87.233-.238.487-.456.758-.65a1.5 1.5 0 0 1 .26-.137c-.018.268-.04 1.553.268 1.943h.003a5.744 5.744 0 0 1 1.868-1.443 3.597 3.597 0 0 0 .021 1.896c.07.047.137.098.2.152.107.09.226.207.454.433l.068.066.009.009a1.933 1.933 0 0 0 .213.18c.383.287.943.563 1.306.741.201.1.342.168.359.193l.004.008c-.012.193-.695.858-.933.858-2.206 0-2.564 1.335-2.564 1.335.087.997.714 1.839 1.517 2.357a3.72 3.72 0 0 0 .439.241c.076.034.152.065.228.094.325.115.665.18 1.01.194 3.043.143 4.155-2.804 3.129-4.745v-.001a3.005 3.005 0 0 0-.731-.9 2.945 2.945 0 0 0-.571-.37l-.003-.002a2.679 2.679 0 0 1 1.87.454 3.915 3.915 0 0 0-3.396-1.983c-.078 0-.153.005-.23.01l-.042.003V4.31h-.002a3.882 3.882 0 0 0-.8.14 6.454 6.454 0 0 0-.333-.314 2.321 2.321 0 0 0-.2-.152 3.594 3.594 0 0 1-.088-.383 4.88 4.88 0 0 1 1.352-.289l.05-.003c.052-.004.125-.01.205-.012C7.996 2.212 8.733.843 10.17.002l-.003.005.003-.001.002-.002h.002l.002-.002a.028.028 0 0 1 .015 0 .02.02 0 0 1 .012.007 2.408 2.408 0 0 0 .206.48c.06.103.122.2.183.297.49.774 1.023 1.379 1.543 1.968.771.874 1.512 1.715 2.036 3.02l-.001-.013a8.06 8.06 0 0 0-.786-2.353Z"
                }
            }
        ]
    })(props);
}
function BsBrowserSafari(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm.25-14.75v1.5a.25.25 0 0 1-.5 0v-1.5a.25.25 0 0 1 .5 0Zm0 12v1.5a.25.25 0 1 1-.5 0v-1.5a.25.25 0 1 1 .5 0ZM4.5 1.938a.25.25 0 0 1 .342.091l.75 1.3a.25.25 0 0 1-.434.25l-.75-1.3a.25.25 0 0 1 .092-.341Zm6 10.392a.25.25 0 0 1 .341.092l.75 1.299a.25.25 0 1 1-.432.25l-.75-1.3a.25.25 0 0 1 .091-.34ZM2.28 4.408l1.298.75a.25.25 0 0 1-.25.434l-1.299-.75a.25.25 0 0 1 .25-.434Zm10.392 6 1.299.75a.25.25 0 1 1-.25.434l-1.3-.75a.25.25 0 0 1 .25-.434ZM1 8a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 0 .5h-1.5A.25.25 0 0 1 1 8Zm12 0a.25.25 0 0 1 .25-.25h1.5a.25.25 0 1 1 0 .5h-1.5A.25.25 0 0 1 13 8ZM2.03 11.159l1.298-.75a.25.25 0 0 1 .25.432l-1.299.75a.25.25 0 0 1-.25-.432Zm10.392-6 1.299-.75a.25.25 0 1 1 .25.433l-1.3.75a.25.25 0 0 1-.25-.434ZM4.5 14.061a.25.25 0 0 1-.092-.341l.75-1.3a.25.25 0 0 1 .434.25l-.75 1.3a.25.25 0 0 1-.342.091Zm6-10.392a.25.25 0 0 1-.091-.342l.75-1.299a.25.25 0 1 1 .432.25l-.75 1.3a.25.25 0 0 1-.341.09ZM6.494 1.415l.13.483a.25.25 0 1 1-.483.13l-.13-.483a.25.25 0 0 1 .483-.13ZM9.86 13.972l.13.483a.25.25 0 1 1-.483.13l-.13-.483a.25.25 0 0 1 .483-.13ZM3.05 3.05a.25.25 0 0 1 .354 0l.353.354a.25.25 0 0 1-.353.353l-.354-.353a.25.25 0 0 1 0-.354Zm9.193 9.193a.25.25 0 0 1 .353 0l.354.353a.25.25 0 1 1-.354.354l-.353-.354a.25.25 0 0 1 0-.353ZM1.545 6.01l.483.13a.25.25 0 1 1-.13.483l-.483-.13a.25.25 0 1 1 .13-.482Zm12.557 3.365.483.13a.25.25 0 1 1-.13.483l-.483-.13a.25.25 0 1 1 .13-.483Zm-12.863.436a.25.25 0 0 1 .176-.306l.483-.13a.25.25 0 1 1 .13.483l-.483.13a.25.25 0 0 1-.306-.177Zm12.557-3.365a.25.25 0 0 1 .176-.306l.483-.13a.25.25 0 1 1 .13.483l-.483.13a.25.25 0 0 1-.306-.177ZM3.045 12.944a.299.299 0 0 1-.029-.376l3.898-5.592a.25.25 0 0 1 .062-.062l5.602-3.884a.278.278 0 0 1 .392.392L9.086 9.024a.25.25 0 0 1-.062.062l-5.592 3.898a.299.299 0 0 1-.382-.034l-.005-.006Zm3.143 1.817a.25.25 0 0 1-.176-.306l.129-.483a.25.25 0 0 1 .483.13l-.13.483a.25.25 0 0 1-.306.176ZM9.553 2.204a.25.25 0 0 1-.177-.306l.13-.483a.25.25 0 1 1 .483.13l-.13.483a.25.25 0 0 1-.306.176Z"
                }
            }
        ]
    })(props);
}
function BsBrushFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.825.12a.5.5 0 0 1 .132.584c-1.53 3.43-4.743 8.17-7.095 10.64a6.067 6.067 0 0 1-2.373 1.534c-.018.227-.06.538-.16.868-.201.659-.667 1.479-1.708 1.74a8.118 8.118 0 0 1-3.078.132 3.659 3.659 0 0 1-.562-.135 1.382 1.382 0 0 1-.466-.247.714.714 0 0 1-.204-.288.622.622 0 0 1 .004-.443c.095-.245.316-.38.461-.452.394-.197.625-.453.867-.826.095-.144.184-.297.287-.472l.117-.198c.151-.255.326-.54.546-.848.528-.739 1.201-.925 1.746-.896.126.007.243.025.348.048.062-.172.142-.38.238-.608.261-.619.658-1.419 1.187-2.069 2.176-2.67 6.18-6.206 9.117-8.104a.5.5 0 0 1 .596.04z"
                }
            }
        ]
    })(props);
}
function BsBrush(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.825.12a.5.5 0 0 1 .132.584c-1.53 3.43-4.743 8.17-7.095 10.64a6.067 6.067 0 0 1-2.373 1.534c-.018.227-.06.538-.16.868-.201.659-.667 1.479-1.708 1.74a8.118 8.118 0 0 1-3.078.132 3.659 3.659 0 0 1-.562-.135 1.382 1.382 0 0 1-.466-.247.714.714 0 0 1-.204-.288.622.622 0 0 1 .004-.443c.095-.245.316-.38.461-.452.394-.197.625-.453.867-.826.095-.144.184-.297.287-.472l.117-.198c.151-.255.326-.54.546-.848.528-.739 1.201-.925 1.746-.896.126.007.243.025.348.048.062-.172.142-.38.238-.608.261-.619.658-1.419 1.187-2.069 2.176-2.67 6.18-6.206 9.117-8.104a.5.5 0 0 1 .596.04zM4.705 11.912a1.23 1.23 0 0 0-.419-.1c-.246-.013-.573.05-.879.479-.197.275-.355.532-.5.777l-.105.177c-.106.181-.213.362-.32.528a3.39 3.39 0 0 1-.76.861c.69.112 1.736.111 2.657-.12.559-.139.843-.569.993-1.06a3.122 3.122 0 0 0 .126-.75l-.793-.792zm1.44.026c.12-.04.277-.1.458-.183a5.068 5.068 0 0 0 1.535-1.1c1.9-1.996 4.412-5.57 6.052-8.631-2.59 1.927-5.566 4.66-7.302 6.792-.442.543-.795 1.243-1.042 1.826-.121.288-.214.54-.275.72v.001l.575.575zm-4.973 3.04.007-.005a.031.031 0 0 1-.007.004zm3.582-3.043.002.001h-.002z"
                }
            }
        ]
    })(props);
}
function BsBucketFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.522 5H2a.5.5 0 0 0-.494.574l1.372 9.149A1.5 1.5 0 0 0 4.36 16h7.278a1.5 1.5 0 0 0 1.483-1.277l1.373-9.149A.5.5 0 0 0 14 5h-.522A5.5 5.5 0 0 0 2.522 5zm1.005 0a4.5 4.5 0 0 1 8.945 0H3.527z"
                }
            }
        ]
    })(props);
}
function BsBucket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.522 5H2a.5.5 0 0 0-.494.574l1.372 9.149A1.5 1.5 0 0 0 4.36 16h7.278a1.5 1.5 0 0 0 1.483-1.277l1.373-9.149A.5.5 0 0 0 14 5h-.522A5.5 5.5 0 0 0 2.522 5zm1.005 0a4.5 4.5 0 0 1 8.945 0H3.527zm9.892 1-1.286 8.574a.5.5 0 0 1-.494.426H4.36a.5.5 0 0 1-.494-.426L2.58 6h10.838z"
                }
            }
        ]
    })(props);
}
function BsBugFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.978.855a.5.5 0 1 0-.956.29l.41 1.352A4.985 4.985 0 0 0 3 6h10a4.985 4.985 0 0 0-1.432-3.503l.41-1.352a.5.5 0 1 0-.956-.29l-.291.956A4.978 4.978 0 0 0 8 1a4.979 4.979 0 0 0-2.731.811l-.29-.956z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6v1H8.5v8.975A5 5 0 0 0 13 11h.5a.5.5 0 0 1 .5.5v.5a.5.5 0 1 0 1 0v-.5a1.5 1.5 0 0 0-1.5-1.5H13V9h1.5a.5.5 0 0 0 0-1H13V7h.5A1.5 1.5 0 0 0 15 5.5V5a.5.5 0 0 0-1 0v.5a.5.5 0 0 1-.5.5H13zm-5.5 9.975V7H3V6h-.5a.5.5 0 0 1-.5-.5V5a.5.5 0 0 0-1 0v.5A1.5 1.5 0 0 0 2.5 7H3v1H1.5a.5.5 0 0 0 0 1H3v1h-.5A1.5 1.5 0 0 0 1 11.5v.5a.5.5 0 1 0 1 0v-.5a.5.5 0 0 1 .5-.5H3a5 5 0 0 0 4.5 4.975z"
                }
            }
        ]
    })(props);
}
function BsBug(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.355.522a.5.5 0 0 1 .623.333l.291.956A4.979 4.979 0 0 1 8 1c1.007 0 1.946.298 2.731.811l.29-.956a.5.5 0 1 1 .957.29l-.41 1.352A4.985 4.985 0 0 1 13 6h.5a.5.5 0 0 0 .5-.5V5a.5.5 0 0 1 1 0v.5A1.5 1.5 0 0 1 13.5 7H13v1h1.5a.5.5 0 0 1 0 1H13v1h.5a1.5 1.5 0 0 1 1.5 1.5v.5a.5.5 0 1 1-1 0v-.5a.5.5 0 0 0-.5-.5H13a5 5 0 0 1-10 0h-.5a.5.5 0 0 0-.5.5v.5a.5.5 0 1 1-1 0v-.5A1.5 1.5 0 0 1 2.5 10H3V9H1.5a.5.5 0 0 1 0-1H3V7h-.5A1.5 1.5 0 0 1 1 5.5V5a.5.5 0 0 1 1 0v.5a.5.5 0 0 0 .5.5H3c0-1.364.547-2.601 1.432-3.503l-.41-1.352a.5.5 0 0 1 .333-.623zM4 7v4a4 4 0 0 0 3.5 3.97V7H4zm4.5 0v7.97A4 4 0 0 0 12 11V7H8.5zM12 6a3.989 3.989 0 0 0-1.334-2.982A3.983 3.983 0 0 0 8 2a3.983 3.983 0 0 0-2.667 1.018A3.989 3.989 0 0 0 4 6h8z"
                }
            }
        ]
    })(props);
}
function BsBuildingAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6.5a.5.5 0 0 1-1 0V1H3v14h3v-2.5a.5.5 0 0 1 .5-.5H8v4H3a1 1 0 0 1-1-1V1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm-6 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm-6 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z"
                }
            }
        ]
    })(props);
}
function BsBuildingCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.17-1.951a.5.5 0 1 1 .858.514Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6.5a.5.5 0 0 1-1 0V1H3v14h3v-2.5a.5.5 0 0 1 .5-.5H8v4H3a1 1 0 0 1-1-1V1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm-6 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm-6 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z"
                }
            }
        ]
    })(props);
}
function BsBuildingDash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM11 12h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6.5a.5.5 0 0 1-1 0V1H3v14h3v-2.5a.5.5 0 0 1 .5-.5H8v4H3a1 1 0 0 1-1-1V1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm-6 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm-6 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z"
                }
            }
        ]
    })(props);
}
function BsBuildingDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 9a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm.354 5.854 1.5-1.5a.5.5 0 0 0-.708-.708l-.646.647V10.5a.5.5 0 0 0-1 0v2.793l-.646-.647a.5.5 0 0 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6.5a.5.5 0 0 1-1 0V1H3v14h3v-2.5a.5.5 0 0 1 .5-.5H8v4H3a1 1 0 0 1-1-1V1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm-6 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm-6 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z"
                }
            }
        ]
    })(props);
}
function BsBuildingExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6.5a.5.5 0 0 1-1 0V1H3v14h3v-2.5a.5.5 0 0 1 .5-.5H8v4H3a1 1 0 0 1-1-1V1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm-6 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm-6 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm8.5 4.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-3.5-2a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 1 0V11a.5.5 0 0 0-.5-.5Zm0 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
                }
            }
        ]
    })(props);
}
function BsBuildingFillAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v7.256A4.493 4.493 0 0 0 12.5 8a4.493 4.493 0 0 0-3.59 1.787A.498.498 0 0 0 9 9.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .39-.187A4.476 4.476 0 0 0 8.027 12H6.5a.5.5 0 0 0-.5.5V16H3a1 1 0 0 1-1-1V1Zm2 1.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm3 0v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1ZM4 5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5ZM7.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm2.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5ZM4.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z"
                }
            }
        ]
    })(props);
}
function BsBuildingFillCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.17-1.951a.5.5 0 1 1 .858.514Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v7.256A4.493 4.493 0 0 0 12.5 8a4.493 4.493 0 0 0-3.59 1.787A.498.498 0 0 0 9 9.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .39-.187A4.476 4.476 0 0 0 8.027 12H6.5a.5.5 0 0 0-.5.5V16H3a1 1 0 0 1-1-1V1Zm2 1.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm3 0v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1ZM4 5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5ZM7.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm2.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5ZM4.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z"
                }
            }
        ]
    })(props);
}
function BsBuildingFillDash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM11 12h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v7.256A4.493 4.493 0 0 0 12.5 8a4.493 4.493 0 0 0-3.59 1.787A.498.498 0 0 0 9 9.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .39-.187A4.476 4.476 0 0 0 8.027 12H6.5a.5.5 0 0 0-.5.5V16H3a1 1 0 0 1-1-1V1Zm2 1.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm3 0v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1ZM4 5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5ZM7.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm2.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5ZM4.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z"
                }
            }
        ]
    })(props);
}
function BsBuildingFillDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 9a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm.354 5.854 1.5-1.5a.5.5 0 0 0-.708-.708l-.646.647V10.5a.5.5 0 0 0-1 0v2.793l-.646-.647a.5.5 0 0 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v7.256A4.493 4.493 0 0 0 12.5 8a4.493 4.493 0 0 0-3.59 1.787A.498.498 0 0 0 9 9.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .39-.187A4.476 4.476 0 0 0 8.027 12H6.5a.5.5 0 0 0-.5.5V16H3a1 1 0 0 1-1-1V1Zm2 1.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm3 0v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1ZM4 5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5ZM7.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm2.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5ZM4.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z"
                }
            }
        ]
    })(props);
}
function BsBuildingFillExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v7.256A4.493 4.493 0 0 0 12.5 8a4.493 4.493 0 0 0-3.59 1.787A.498.498 0 0 0 9 9.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .39-.187A4.476 4.476 0 0 0 8.027 12H6.5a.5.5 0 0 0-.5.5V16H3a1 1 0 0 1-1-1V1Zm2 1.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm3 0v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1ZM4 5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5ZM7.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm2.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5ZM4.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-3.5-2a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 1 0V11a.5.5 0 0 0-.5-.5Zm0 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
                }
            }
        ]
    })(props);
}
function BsBuildingFillGear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v7.256A4.493 4.493 0 0 0 12.5 8a4.493 4.493 0 0 0-3.59 1.787A.498.498 0 0 0 9 9.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .39-.187A4.476 4.476 0 0 0 8.027 12H6.5a.5.5 0 0 0-.5.5V16H3a1 1 0 0 1-1-1V1Zm2 1.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm3 0v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1ZM4 5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5ZM7.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm2.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5ZM4.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.886 9.46c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.045c-.613-.18-.613-1.048 0-1.229l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382l.045-.148ZM14 12.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z"
                }
            }
        ]
    })(props);
}
function BsBuildingFillLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v7.764a3 3 0 0 0-4.989 2.497 2.01 2.01 0 0 0-.743.739H6.5a.5.5 0 0 0-.5.5V16H3a1 1 0 0 1-1-1V1Zm2 1.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm3 0v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1ZM4 5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5ZM7.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm2.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5ZM4.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm2.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13a1 1 0 0 1 1-1v-1a2 2 0 1 1 4 0v1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-2Zm3-3a1 1 0 0 0-1 1v1h2v-1a1 1 0 0 0-1-1Z"
                }
            }
        ]
    })(props);
}
function BsBuildingFillSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.879 10.414a2.501 2.501 0 0 0-3.465 3.465l3.465-3.465Zm.707.707-3.465 3.465a2.501 2.501 0 0 0 3.465-3.465Zm-4.56-1.096a3.5 3.5 0 1 1 4.949 4.95 3.5 3.5 0 0 1-4.95-4.95Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v7.256A4.493 4.493 0 0 0 12.5 8a4.493 4.493 0 0 0-3.59 1.787A.498.498 0 0 0 9 9.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .39-.187A4.476 4.476 0 0 0 8.027 12H6.5a.5.5 0 0 0-.5.5V16H3a1 1 0 0 1-1-1V1Zm2 1.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm3 0v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1ZM4 5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5ZM7.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm2.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5ZM4.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z"
                }
            }
        ]
    })(props);
}
function BsBuildingFillUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.354-5.854 1.5 1.5a.5.5 0 0 1-.708.708L13 11.707V14.5a.5.5 0 0 1-1 0v-2.793l-.646.647a.5.5 0 0 1-.708-.708l1.5-1.5a.5.5 0 0 1 .708 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v7.256A4.493 4.493 0 0 0 12.5 8a4.493 4.493 0 0 0-3.59 1.787A.498.498 0 0 0 9 9.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .39-.187A4.476 4.476 0 0 0 8.027 12H6.5a.5.5 0 0 0-.5.5V16H3a1 1 0 0 1-1-1V1Zm2 1.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm3 0v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1ZM4 5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5ZM7.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm2.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5ZM4.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z"
                }
            }
        ]
    })(props);
}
function BsBuildingFillX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v7.256A4.493 4.493 0 0 0 12.5 8a4.493 4.493 0 0 0-3.59 1.787A.498.498 0 0 0 9 9.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .39-.187A4.476 4.476 0 0 0 8.027 12H6.5a.5.5 0 0 0-.5.5V16H3a1 1 0 0 1-1-1V1Zm2 1.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm3 0v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1ZM4 5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5ZM7.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm2.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5ZM4.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-.646-4.854.646.647.646-.647a.5.5 0 0 1 .708.708l-.647.646.647.646a.5.5 0 0 1-.708.708l-.646-.647-.646.647a.5.5 0 0 1-.708-.708l.647-.646-.647-.646a.5.5 0 0 1 .708-.708Z"
                }
            }
        ]
    })(props);
}
function BsBuildingFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h3v-3.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V16h3a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H3Zm1 2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5ZM4 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM7.5 5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM4.5 8h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5Z"
                }
            }
        ]
    })(props);
}
function BsBuildingGear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6.5a.5.5 0 0 1-1 0V1H3v14h3v-2.5a.5.5 0 0 1 .5-.5H8v4H3a1 1 0 0 1-1-1V1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm-6 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm-6 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm4.386 1.46c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.045c-.613-.18-.613-1.048 0-1.229l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382l.045-.148ZM14 12.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z"
                }
            }
        ]
    })(props);
}
function BsBuildingLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6.5a.5.5 0 0 1-1 0V1H3v14h3v-2.5a.5.5 0 0 1 .5-.5H8v4H3a1 1 0 0 1-1-1V1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1ZM4 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM7.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM4.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM9 13a1 1 0 0 1 1-1v-1a2 2 0 1 1 4 0v1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-2Zm3-3a1 1 0 0 0-1 1v1h2v-1a1 1 0 0 0-1-1Z"
                }
            }
        ]
    })(props);
}
function BsBuildingSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.879 10.414a2.501 2.501 0 0 0-3.465 3.465l3.465-3.465Zm.707.707-3.465 3.465a2.501 2.501 0 0 0 3.465-3.465Zm-4.56-1.096a3.5 3.5 0 1 1 4.949 4.95 3.5 3.5 0 0 1-4.95-4.95Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6.5a.5.5 0 0 1-1 0V1H3v14h3v-2.5a.5.5 0 0 1 .5-.5H8v4H3a1 1 0 0 1-1-1V1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm-6 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm-6 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z"
                }
            }
        ]
    })(props);
}
function BsBuildingUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.354-5.854 1.5 1.5a.5.5 0 0 1-.708.708L13 11.707V14.5a.5.5 0 0 1-1 0v-2.793l-.646.647a.5.5 0 0 1-.708-.708l1.5-1.5a.5.5 0 0 1 .708 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6.5a.5.5 0 0 1-1 0V1H3v14h3v-2.5a.5.5 0 0 1 .5-.5H8v4H3a1 1 0 0 1-1-1V1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm-6 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm-6 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z"
                }
            }
        ]
    })(props);
}
function BsBuildingX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6.5a.5.5 0 0 1-1 0V1H3v14h3v-2.5a.5.5 0 0 1 .5-.5H8v4H3a1 1 0 0 1-1-1V1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm-6 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm-6 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm5 8a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-.646-4.854.646.647.646-.647a.5.5 0 0 1 .708.708l-.647.646.647.646a.5.5 0 0 1-.708.708l-.646-.647-.646.647a.5.5 0 0 1-.708-.708l.647-.646-.647-.646a.5.5 0 0 1 .708-.708Z"
                }
            }
        ]
    })(props);
}
function BsBuilding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1ZM4 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM7.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM4.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V1Zm11 0H3v14h3v-2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V15h3V1Z"
                }
            }
        ]
    })(props);
}
function BsBuildingsFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 .5a.5.5 0 0 0-.724-.447l-8 4A.5.5 0 0 0 6 4.5v3.14L.342 9.526A.5.5 0 0 0 0 10v5.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V14h1v1.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V.5ZM2 11h1v1H2v-1Zm2 0h1v1H4v-1Zm-1 2v1H2v-1h1Zm1 0h1v1H4v-1Zm9-10v1h-1V3h1ZM8 5h1v1H8V5Zm1 2v1H8V7h1ZM8 9h1v1H8V9Zm2 0h1v1h-1V9Zm-1 2v1H8v-1h1Zm1 0h1v1h-1v-1Zm3-2v1h-1V9h1Zm-1 2h1v1h-1v-1Zm-2-4h1v1h-1V7Zm3 0v1h-1V7h1Zm-2-2v1h-1V5h1Zm1 0h1v1h-1V5Z"
                }
            }
        ]
    })(props);
}
function BsBuildings(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.763.075A.5.5 0 0 1 15 .5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V14h-1v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V10a.5.5 0 0 1 .342-.474L6 7.64V4.5a.5.5 0 0 1 .276-.447l8-4a.5.5 0 0 1 .487.022ZM6 8.694 1 10.36V15h5V8.694ZM7 15h2v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V15h2V1.309l-7 3.5V15Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 11h1v1H2v-1Zm2 0h1v1H4v-1Zm-2 2h1v1H2v-1Zm2 0h1v1H4v-1Zm4-4h1v1H8V9Zm2 0h1v1h-1V9Zm-2 2h1v1H8v-1Zm2 0h1v1h-1v-1Zm2-2h1v1h-1V9Zm0 2h1v1h-1v-1ZM8 7h1v1H8V7Zm2 0h1v1h-1V7Zm2 0h1v1h-1V7ZM8 5h1v1H8V5Zm2 0h1v1h-1V5Zm2 0h1v1h-1V5Zm0-2h1v1h-1V3Z"
                }
            }
        ]
    })(props);
}
function BsBullseye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13A5 5 0 1 1 8 3a5 5 0 0 1 0 10zm0 1A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
                }
            }
        ]
    })(props);
}
function BsBusFrontFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7a1 1 0 0 1-1 1v3.5c0 .818-.393 1.544-1 2v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V14H5v1.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a2.496 2.496 0 0 1-1-2V8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1V2.64C1 1.452 1.845.408 3.064.268A43.608 43.608 0 0 1 8 0c2.1 0 3.792.136 4.936.268C14.155.408 15 1.452 15 2.64V4a1 1 0 0 1 1 1v2ZM3.552 3.22A43.306 43.306 0 0 1 8 3c1.837 0 3.353.107 4.448.22a.5.5 0 0 0 .104-.994A44.304 44.304 0 0 0 8 2c-1.876 0-3.426.109-4.552.226a.5.5 0 1 0 .104.994ZM8 4c-1.876 0-3.426.109-4.552.226A.5.5 0 0 0 3 4.723v3.554a.5.5 0 0 0 .448.497C4.574 8.891 6.124 9 8 9c1.876 0 3.426-.109 4.552-.226A.5.5 0 0 0 13 8.277V4.723a.5.5 0 0 0-.448-.497A44.304 44.304 0 0 0 8 4Zm-3 7a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm8 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-7 0a1 1 0 0 0 1 1h2a1 1 0 1 0 0-2H7a1 1 0 0 0-1 1Z"
                }
            }
        ]
    })(props);
}
function BsBusFront(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm8 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-6-1a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H7Zm1-6c-1.876 0-3.426.109-4.552.226A.5.5 0 0 0 3 4.723v3.554a.5.5 0 0 0 .448.497C4.574 8.891 6.124 9 8 9c1.876 0 3.426-.109 4.552-.226A.5.5 0 0 0 13 8.277V4.723a.5.5 0 0 0-.448-.497A44.303 44.303 0 0 0 8 4Zm0-1c-1.837 0-3.353.107-4.448.22a.5.5 0 1 1-.104-.994A44.304 44.304 0 0 1 8 2c1.876 0 3.426.109 4.552.226a.5.5 0 1 1-.104.994A43.306 43.306 0 0 0 8 3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 8a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1V2.64c0-1.188-.845-2.232-2.064-2.372A43.61 43.61 0 0 0 8 0C5.9 0 4.208.136 3.064.268 1.845.408 1 1.452 1 2.64V4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1v3.5c0 .818.393 1.544 1 2v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V14h6v1.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2c.607-.456 1-1.182 1-2V8ZM8 1c2.056 0 3.71.134 4.822.261.676.078 1.178.66 1.178 1.379v8.86a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 11.5V2.64c0-.72.502-1.301 1.178-1.379A42.611 42.611 0 0 1 8 1Z"
                }
            }
        ]
    })(props);
}
function BsCCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM8.146 4.992c.961 0 1.641.633 1.729 1.512h1.295v-.088c-.094-1.518-1.348-2.572-3.03-2.572-2.068 0-3.269 1.377-3.269 3.638v1.073c0 2.267 1.178 3.603 3.27 3.603 1.675 0 2.93-1.02 3.029-2.467v-.093H9.875c-.088.832-.75 1.418-1.729 1.418-1.224 0-1.927-.891-1.927-2.461v-1.06c0-1.583.715-2.503 1.927-2.503Z"
                }
            }
        ]
    })(props);
}
function BsCCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8Zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM8.146 4.992c-1.212 0-1.927.92-1.927 2.502v1.06c0 1.571.703 2.462 1.927 2.462.979 0 1.641-.586 1.729-1.418h1.295v.093c-.1 1.448-1.354 2.467-3.03 2.467-2.091 0-3.269-1.336-3.269-3.603V7.482c0-2.261 1.201-3.638 3.27-3.638 1.681 0 2.935 1.054 3.029 2.572v.088H9.875c-.088-.879-.768-1.512-1.729-1.512Z"
                }
            }
        ]
    })(props);
}
function BsCSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm6.146 4.992c-1.212 0-1.927.92-1.927 2.502v1.06c0 1.571.703 2.462 1.927 2.462.979 0 1.641-.586 1.729-1.418h1.295v.093c-.1 1.448-1.354 2.467-3.03 2.467-2.091 0-3.269-1.336-3.269-3.603V7.482c0-2.261 1.201-3.638 3.27-3.638 1.681 0 2.935 1.054 3.029 2.572v.088H9.875c-.088-.879-.768-1.512-1.729-1.512Z"
                }
            }
        ]
    })(props);
}
function BsCSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.146 4.992c-1.212 0-1.927.92-1.927 2.502v1.06c0 1.571.703 2.462 1.927 2.462.979 0 1.641-.586 1.729-1.418h1.295v.093c-.1 1.448-1.354 2.467-3.03 2.467-2.091 0-3.269-1.336-3.269-3.603V7.482c0-2.261 1.201-3.638 3.27-3.638 1.681 0 2.935 1.054 3.029 2.572v.088H9.875c-.088-.879-.768-1.512-1.729-1.512Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2Z"
                }
            }
        ]
    })(props);
}
function BsCakeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7.399.804.595-.792.598.79A.747.747 0 0 1 8.5 1.806V4H11a2 2 0 0 1 2 2v3h1a2 2 0 0 1 2 2v4a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-4a2 2 0 0 1 2-2h1V6a2 2 0 0 1 2-2h2.5V1.813a.747.747 0 0 1-.101-1.01ZM12 6.414a.911.911 0 0 1-.646-.268 1.914 1.914 0 0 0-2.708 0 .914.914 0 0 1-1.292 0 1.914 1.914 0 0 0-2.708 0A.911.911 0 0 1 4 6.414v1c.49 0 .98-.187 1.354-.56a.914.914 0 0 1 1.292 0c.748.747 1.96.747 2.708 0a.914.914 0 0 1 1.292 0c.374.373.864.56 1.354.56v-1Zm2.646 5.732a.914.914 0 0 1-1.293 0 1.914 1.914 0 0 0-2.707 0 .914.914 0 0 1-1.292 0 1.914 1.914 0 0 0-2.708 0 .914.914 0 0 1-1.292 0 1.914 1.914 0 0 0-2.708 0 .914.914 0 0 1-1.292 0L1 11.793v1.34c.737.452 1.715.36 2.354-.28a.914.914 0 0 1 1.292 0c.748.748 1.96.748 2.708 0a.914.914 0 0 1 1.292 0c.748.748 1.96.748 2.707 0a.914.914 0 0 1 1.293 0 1.915 1.915 0 0 0 2.354.28v-1.34l-.354.354Z"
                }
            }
        ]
    })(props);
}
function BsCake(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7.994.013-.595.79a.747.747 0 0 0 .101 1.01V4H5a2 2 0 0 0-2 2v3H2a2 2 0 0 0-2 2v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a2 2 0 0 0-2-2h-1V6a2 2 0 0 0-2-2H8.5V1.806A.747.747 0 0 0 8.592.802l-.598-.79ZM4 6a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v.414a.911.911 0 0 1-.646-.268 1.914 1.914 0 0 0-2.708 0 .914.914 0 0 1-1.292 0 1.914 1.914 0 0 0-2.708 0A.911.911 0 0 1 4 6.414V6Zm0 1.414c.49 0 .98-.187 1.354-.56a.914.914 0 0 1 1.292 0c.748.747 1.96.747 2.708 0a.914.914 0 0 1 1.292 0c.374.373.864.56 1.354.56V9H4V7.414ZM1 11a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.793l-.354.354a.914.914 0 0 1-1.293 0 1.914 1.914 0 0 0-2.707 0 .914.914 0 0 1-1.292 0 1.914 1.914 0 0 0-2.708 0 .914.914 0 0 1-1.292 0 1.914 1.914 0 0 0-2.708 0 .914.914 0 0 1-1.292 0L1 11.793V11Zm11.646 1.854a1.915 1.915 0 0 0 2.354.279V15H1v-1.867c.737.452 1.715.36 2.354-.28a.914.914 0 0 1 1.292 0c.748.748 1.96.748 2.708 0a.914.914 0 0 1 1.292 0c.748.748 1.96.748 2.707 0a.914.914 0 0 1 1.293 0Z"
                }
            }
        ]
    })(props);
}
function BsCake2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.899.804.595-.792.598.79A.747.747 0 0 1 4 1.806v4.886c-.354-.06-.689-.127-1-.201V1.813a.747.747 0 0 1-.1-1.01ZM13 1.806v4.685a15.19 15.19 0 0 1-1 .201v-4.88a.747.747 0 0 1-.1-1.007l.595-.792.598.79A.746.746 0 0 1 13 1.806Zm-3 0a.746.746 0 0 0 .092-1.004l-.598-.79-.595.792A.747.747 0 0 0 9 1.813v5.17c.341-.013.675-.031 1-.055V1.806Zm-3 0v5.176c-.341-.012-.675-.03-1-.054V1.813a.747.747 0 0 1-.1-1.01l.595-.79.598.789A.747.747 0 0 1 7 1.806Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 6.988V4.226a22.6 22.6 0 0 1 1-.114V7.16c0 .131.101.24.232.25l.231.017c.332.024.672.043 1.02.055l.258.01a.25.25 0 0 0 .26-.25V4.003a29.015 29.015 0 0 1 1 0V7.24a.25.25 0 0 0 .258.25l.259-.009c.347-.012.687-.03 1.019-.055l.231-.017a.25.25 0 0 0 .232-.25V4.112c.345.031.679.07 1 .114v2.762a.25.25 0 0 0 .292.246l.291-.049c.364-.061.71-.13 1.033-.208l.192-.046a.25.25 0 0 0 .192-.243V4.621c.672.184 1.251.409 1.677.678.415.261.823.655.823 1.2V13.5c0 .546-.408.94-.823 1.201-.44.278-1.043.51-1.745.696-1.41.376-3.33.603-5.432.603-2.102 0-4.022-.227-5.432-.603-.702-.187-1.305-.418-1.745-.696C.408 14.44 0 14.046 0 13.5v-7c0-.546.408-.94.823-1.201.426-.269 1.005-.494 1.677-.678v2.067c0 .116.08.216.192.243l.192.046c.323.077.669.147 1.033.208l.292.05a.25.25 0 0 0 .291-.247ZM1 8.82v1.659a1.935 1.935 0 0 0 2.298.43.935.935 0 0 1 1.08.175l.348.349a2 2 0 0 0 2.615.185l.059-.044a1 1 0 0 1 1.2 0l.06.044a2 2 0 0 0 2.613-.185l.348-.348a.938.938 0 0 1 1.082-.175c.781.39 1.718.208 2.297-.426V8.833l-.68.907a.938.938 0 0 1-1.17.276 1.938 1.938 0 0 0-2.236.363l-.348.348a1 1 0 0 1-1.307.092l-.06-.044a2 2 0 0 0-2.399 0l-.06.044a1 1 0 0 1-1.306-.092l-.35-.35a1.935 1.935 0 0 0-2.233-.362.935.935 0 0 1-1.168-.277L1 8.82Z"
                }
            }
        ]
    })(props);
}
function BsCake2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3.494.013-.595.79A.747.747 0 0 0 3 1.814v2.683c-.149.034-.293.07-.432.107-.702.187-1.305.418-1.745.696C.408 5.56 0 5.954 0 6.5v7c0 .546.408.94.823 1.201.44.278 1.043.51 1.745.696C3.978 15.773 5.898 16 8 16c2.102 0 4.022-.227 5.432-.603.701-.187 1.305-.418 1.745-.696.415-.261.823-.655.823-1.201v-7c0-.546-.408-.94-.823-1.201-.44-.278-1.043-.51-1.745-.696A12.418 12.418 0 0 0 13 4.496v-2.69a.747.747 0 0 0 .092-1.004l-.598-.79-.595.792A.747.747 0 0 0 12 1.813V4.3a22.03 22.03 0 0 0-2-.23V1.806a.747.747 0 0 0 .092-1.004l-.598-.79-.595.792A.747.747 0 0 0 9 1.813v2.204a28.708 28.708 0 0 0-2 0V1.806A.747.747 0 0 0 7.092.802l-.598-.79-.595.792A.747.747 0 0 0 6 1.813V4.07c-.71.05-1.383.129-2 .23V1.806A.747.747 0 0 0 4.092.802l-.598-.79Zm-.668 5.556L3 5.524v.967c.311.074.646.141 1 .201V5.315a21.05 21.05 0 0 1 2-.242v1.855c.325.024.659.042 1 .054V5.018a27.685 27.685 0 0 1 2 0v1.964c.341-.012.675-.03 1-.054V5.073c.72.054 1.393.137 2 .242v1.377c.354-.06.689-.127 1-.201v-.967l.175.045c.655.175 1.15.374 1.469.575.344.217.356.35.356.356 0 .006-.012.139-.356.356-.319.2-.814.4-1.47.575C11.87 7.78 10.041 8 8 8c-2.04 0-3.87-.221-5.174-.569-.656-.175-1.151-.374-1.47-.575C1.012 6.639 1 6.506 1 6.5c0-.006.012-.139.356-.356.319-.2.814-.4 1.47-.575ZM15 7.806v1.027l-.68.907a.938.938 0 0 1-1.17.276 1.938 1.938 0 0 0-2.236.363l-.348.348a1 1 0 0 1-1.307.092l-.06-.044a2 2 0 0 0-2.399 0l-.06.044a1 1 0 0 1-1.306-.092l-.35-.35a1.935 1.935 0 0 0-2.233-.362.935.935 0 0 1-1.168-.277L1 8.82V7.806c.42.232.956.428 1.568.591C3.978 8.773 5.898 9 8 9c2.102 0 4.022-.227 5.432-.603.612-.163 1.149-.36 1.568-.591Zm0 2.679V13.5c0 .006-.012.139-.356.355-.319.202-.814.401-1.47.576C11.87 14.78 10.041 15 8 15c-2.04 0-3.87-.221-5.174-.569-.656-.175-1.151-.374-1.47-.575-.344-.217-.356-.35-.356-.356v-3.02a1.935 1.935 0 0 0 2.298.43.935.935 0 0 1 1.08.175l.348.349a2 2 0 0 0 2.615.185l.059-.044a1 1 0 0 1 1.2 0l.06.044a2 2 0 0 0 2.613-.185l.348-.348a.938.938 0 0 1 1.082-.175c.781.39 1.718.208 2.297-.426Z"
                }
            }
        ]
    })(props);
}
function BsCalculatorFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm2 .5v2a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5zm0 4v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zM4.5 9a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zM4 12.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zM7.5 6a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zM7 9.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zm.5 2.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zM10 6.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zm.5 2.5a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-1z"
                }
            }
        ]
    })(props);
}
function BsCalculator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h8zM4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-2zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-4z"
                }
            }
        ]
    })(props);
}
function BsCalendarCheckFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zm-5.146-5.146-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708.708z"
                }
            }
        ]
    })(props);
}
function BsCalendarCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"
                }
            }
        ]
    })(props);
}
function BsCalendarDateFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zm5.402 9.746c.625 0 1.184-.484 1.184-1.18 0-.832-.527-1.23-1.16-1.23-.586 0-1.168.387-1.168 1.21 0 .817.543 1.2 1.144 1.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zm-6.664-1.21c-1.11 0-1.656-.767-1.703-1.407h.683c.043.37.387.82 1.051.82.844 0 1.301-.848 1.305-2.164h-.027c-.153.414-.637.79-1.383.79-.852 0-1.676-.61-1.676-1.77 0-1.137.871-1.809 1.797-1.809 1.172 0 1.953.734 1.953 2.668 0 1.805-.742 2.871-2 2.871zm-2.89-5.435v5.332H5.77V8.079h-.012c-.29.156-.883.52-1.258.777V8.16a12.6 12.6 0 0 1 1.313-.805h.632z"
                }
            }
        ]
    })(props);
}
function BsCalendarDate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"
                }
            }
        ]
    })(props);
}
function BsCalendarDayFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5h16v9zm-4.785-6.145a.428.428 0 1 0 0-.855.426.426 0 0 0-.43.43c0 .238.192.425.43.425zm.336.563h-.672v4.105h.672V8.418zm-6.867 4.105v-2.3h2.261v-.61H4.684V7.801h2.464v-.61H4v5.332h.684zm3.296 0h.676V9.98c0-.554.227-1.007.953-1.007.125 0 .258.004.329.015v-.613a1.806 1.806 0 0 0-.254-.02c-.582 0-.891.32-1.012.567h-.02v-.504H7.98v4.105z"
                }
            }
        ]
    })(props);
}
function BsCalendarDay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.684 11.523v-2.3h2.261v-.61H4.684V6.801h2.464v-.61H4v5.332h.684zm3.296 0h.676V8.98c0-.554.227-1.007.953-1.007.125 0 .258.004.329.015v-.613a1.806 1.806 0 0 0-.254-.02c-.582 0-.891.32-1.012.567h-.02v-.504H7.98v4.105zm2.805-5.093c0 .238.192.425.43.425a.428.428 0 1 0 0-.855.426.426 0 0 0-.43.43zm.094 5.093h.672V7.418h-.672v4.105z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"
                }
            }
        ]
    })(props);
}
function BsCalendarEventFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zm-3.5-7h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsCalendarEvent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"
                }
            }
        ]
    })(props);
}
function BsCalendarFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5h16V4H0V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsCalendarHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5ZM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2ZM8 7.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z"
                }
            }
        ]
    })(props);
}
function BsCalendarHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5ZM1 14V4h14v10a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1Zm7-6.507c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z"
                }
            }
        ]
    })(props);
}
function BsCalendarMinusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM6 10h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsCalendarMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 9.5A.5.5 0 0 1 6 9h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"
                }
            }
        ]
    })(props);
}
function BsCalendarMonthFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zm.104 7.305L4.9 10.18H3.284l.8-2.375h.02zm9.074 2.297c0-.832-.414-1.36-1.062-1.36-.692 0-1.098.492-1.098 1.36v.253c0 .852.406 1.364 1.098 1.364.671 0 1.062-.516 1.062-1.364v-.253z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM2.56 12.332h-.71L3.748 7h.696l1.898 5.332h-.719l-.539-1.602H3.1l-.54 1.602zm7.29-4.105v4.105h-.668v-.539h-.027c-.145.324-.532.605-1.188.605-.847 0-1.453-.484-1.453-1.425V8.227h.676v2.554c0 .766.441 1.012.98 1.012.59 0 1.004-.371 1.004-1.023V8.227h.676zm1.273 4.41c.075.332.422.636.985.636.648 0 1.07-.378 1.07-1.023v-.605h-.02c-.163.355-.613.648-1.171.648-.957 0-1.64-.672-1.64-1.902v-.34c0-1.207.675-1.887 1.64-1.887.558 0 1.004.293 1.195.64h.02v-.577h.648v4.03c0 1.052-.816 1.579-1.746 1.579-1.043 0-1.574-.516-1.668-1.2h.687z"
                }
            }
        ]
    })(props);
}
function BsCalendarMonth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.56 11.332 3.1 9.73h1.984l.54 1.602h.718L4.444 6h-.696L1.85 11.332h.71zm1.544-4.527L4.9 9.18H3.284l.8-2.375h.02zm5.746.422h-.676V9.77c0 .652-.414 1.023-1.004 1.023-.539 0-.98-.246-.98-1.012V7.227h-.676v2.746c0 .941.606 1.425 1.453 1.425.656 0 1.043-.28 1.188-.605h.027v.539h.668V7.227zm2.258 5.046c-.563 0-.91-.304-.985-.636h-.687c.094.683.625 1.199 1.668 1.199.93 0 1.746-.527 1.746-1.578V7.227h-.649v.578h-.019c-.191-.348-.637-.64-1.195-.64-.965 0-1.64.679-1.64 1.886v.34c0 1.23.683 1.902 1.64 1.902.558 0 1.008-.293 1.172-.648h.02v.605c0 .645-.423 1.023-1.071 1.023zm.008-4.53c.648 0 1.062.527 1.062 1.359v.253c0 .848-.39 1.364-1.062 1.364-.692 0-1.098-.512-1.098-1.364v-.253c0-.868.406-1.36 1.098-1.36z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"
                }
            }
        ]
    })(props);
}
function BsCalendarPlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM8.5 8.5V10H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V11H6a.5.5 0 0 1 0-1h1.5V8.5a.5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsCalendarPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7a.5.5 0 0 1 .5.5V9H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V10H6a.5.5 0 0 1 0-1h1.5V7.5A.5.5 0 0 1 8 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"
                }
            }
        ]
    })(props);
}
function BsCalendarRangeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 7V5H0v5h5a1 1 0 1 1 0 2H0v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9h-6a1 1 0 1 1 0-2h6z"
                }
            }
        ]
    })(props);
}
function BsCalendarRange(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 7a1 1 0 0 1 1-1h5v2h-5a1 1 0 0 1-1-1zM1 9h4a1 1 0 0 1 0 2H1V9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"
                }
            }
        ]
    })(props);
}
function BsCalendarWeekFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM9.5 7h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm3 0h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zM2 10.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3.5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsCalendarWeek(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-5 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"
                }
            }
        ]
    })(props);
}
function BsCalendarXFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM6.854 8.146 8 9.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 10l1.147 1.146a.5.5 0 0 1-.708.708L8 10.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 10 6.146 8.854a.5.5 0 1 1 .708-.708z"
                }
            }
        ]
    })(props);
}
function BsCalendarX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.146 7.146a.5.5 0 0 1 .708 0L8 8.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 9l1.147 1.146a.5.5 0 0 1-.708.708L8 9.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 9 6.146 7.854a.5.5 0 0 1 0-.708z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"
                }
            }
        ]
    })(props);
}
function BsCalendar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"
                }
            }
        ]
    })(props);
}
function BsCalendar2CheckFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zm-2.6 5.854a.5.5 0 0 0-.708-.708L7.5 10.793 6.354 9.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z"
                }
            }
        ]
    })(props);
}
function BsCalendar2Check(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.854 8.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4z"
                }
            }
        ]
    })(props);
}
function BsCalendar2DateFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.402 10.246c.625 0 1.184-.484 1.184-1.18 0-.832-.527-1.23-1.16-1.23-.586 0-1.168.387-1.168 1.21 0 .817.543 1.2 1.144 1.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zm-4.118 9.79c1.258 0 2-1.067 2-2.872 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684c.047.64.594 1.406 1.703 1.406zm-2.89-5.435h-.633A12.6 12.6 0 0 0 4.5 8.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675V7.354z"
                }
            }
        ]
    })(props);
}
function BsCalendar2Date(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.445 12.688V7.354h-.633A12.6 12.6 0 0 0 4.5 8.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4z"
                }
            }
        ]
    })(props);
}
function BsCalendar2DayFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zm-2.24 4.855a.428.428 0 1 0 0-.855.426.426 0 0 0-.429.43c0 .238.192.425.43.425zm.337.563h-.672v4.105h.672V8.418zm-6.867 4.105v-2.3h2.261v-.61H4.684V7.801h2.464v-.61H4v5.332h.684zm3.296 0h.676V9.98c0-.554.227-1.007.953-1.007.125 0 .258.004.329.015v-.613a1.806 1.806 0 0 0-.254-.02c-.582 0-.891.32-1.012.567h-.02v-.504H7.98v4.105z"
                }
            }
        ]
    })(props);
}
function BsCalendar2Day(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.684 12.523v-2.3h2.261v-.61H4.684V7.801h2.464v-.61H4v5.332h.684zm3.296 0h.676V9.98c0-.554.227-1.007.953-1.007.125 0 .258.004.329.015v-.613a1.806 1.806 0 0 0-.254-.02c-.582 0-.891.32-1.012.567h-.02v-.504H7.98v4.105zm2.805-5.093c0 .238.192.425.43.425a.428.428 0 1 0 0-.855.426.426 0 0 0-.43.43zm.094 5.093h.672V8.418h-.672v4.105z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4z"
                }
            }
        ]
    })(props);
}
function BsCalendar2EventFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zM11.5 7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1z"
                }
            }
        ]
    })(props);
}
function BsCalendar2Event(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4z"
                }
            }
        ]
    })(props);
}
function BsCalendar2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM2.545 3h10.91c.3 0 .545.224.545.5v1c0 .276-.244.5-.546.5H2.545C2.245 5 2 4.776 2 4.5v-1c0-.276.244-.5.545-.5z"
                }
            }
        ]
    })(props);
}
function BsCalendar2HeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5Zm-2 4v-1c0-.276.244-.5.545-.5h10.91c.3 0 .545.224.545.5v1c0 .276-.244.5-.546.5H2.545C2.245 5 2 4.776 2 4.5Zm6 3.493c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z"
                }
            }
        ]
    })(props);
}
function BsCalendar2Heart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5ZM1 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3Zm2 .5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5H3Zm5 4.493c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z"
                }
            }
        ]
    })(props);
}
function BsCalendar2MinusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zM6 10a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H6z"
                }
            }
        ]
    })(props);
}
function BsCalendar2Minus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 10.5A.5.5 0 0 1 6 10h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4z"
                }
            }
        ]
    })(props);
}
function BsCalendar2MonthFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.104 7.805 4.9 10.18H3.284l.8-2.375h.02zm9.074 2.297c0-.832-.414-1.36-1.062-1.36-.692 0-1.098.492-1.098 1.36v.253c0 .852.406 1.364 1.098 1.364.671 0 1.062-.516 1.062-1.364v-.253z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zM2.561 12.332 3.1 10.73h1.984l.54 1.602h.718L4.444 7h-.696L1.85 12.332h.71zM9.85 8.227h-.676v2.543c0 .652-.414 1.023-1.004 1.023-.539 0-.98-.246-.98-1.012V8.227h-.676v2.746c0 .941.606 1.425 1.453 1.425.656 0 1.043-.28 1.188-.605h.027v.539h.668V8.227zm1.273 4.41h-.687c.094.683.625 1.199 1.668 1.199.93 0 1.746-.527 1.746-1.578V8.227h-.649v.578h-.019c-.191-.348-.637-.64-1.195-.64-.965 0-1.64.679-1.64 1.886v.34c0 1.23.683 1.902 1.64 1.902.558 0 1.008-.293 1.172-.648h.02v.605c0 .645-.423 1.023-1.071 1.023-.563 0-.91-.304-.985-.636z"
                }
            }
        ]
    })(props);
}
function BsCalendar2Month(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.56 12.332.54-1.602h1.984l.54 1.602h.718L4.444 7h-.696L1.85 12.332h.71zm1.544-4.527L4.9 10.18H3.284l.8-2.375h.02zm5.746.422h-.676v2.543c0 .652-.414 1.023-1.004 1.023-.539 0-.98-.246-.98-1.012V8.227h-.676v2.746c0 .941.606 1.425 1.453 1.425.656 0 1.043-.28 1.188-.605h.027v.539h.668V8.227zm2.258 5.046c-.563 0-.91-.304-.985-.636h-.687c.094.683.625 1.199 1.668 1.199.93 0 1.746-.527 1.746-1.578V8.227h-.649v.578h-.019c-.191-.348-.637-.64-1.195-.64-.965 0-1.64.679-1.64 1.886v.34c0 1.23.683 1.902 1.64 1.902.558 0 1.008-.293 1.172-.648h.02v.605c0 .645-.423 1.023-1.071 1.023zm.008-4.53c.648 0 1.062.527 1.062 1.359v.253c0 .848-.39 1.364-1.062 1.364-.692 0-1.098-.512-1.098-1.364v-.253c0-.868.406-1.36 1.098-1.36z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4z"
                }
            }
        ]
    })(props);
}
function BsCalendar2PlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 3.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5H2.545c-.3 0-.545.224-.545.5zm6.5 5a.5.5 0 0 0-1 0V10H6a.5.5 0 0 0 0 1h1.5v1.5a.5.5 0 0 0 1 0V11H10a.5.5 0 0 0 0-1H8.5V8.5z"
                }
            }
        ]
    })(props);
}
function BsCalendar2Plus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4zM8 8a.5.5 0 0 1 .5.5V10H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V11H6a.5.5 0 0 1 0-1h1.5V8.5A.5.5 0 0 1 8 8z"
                }
            }
        ]
    })(props);
}
function BsCalendar2RangeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zM10 7a1 1 0 0 0 0 2h5V7h-5zm-4 4a1 1 0 0 0-1-1H1v2h4a1 1 0 0 0 1-1z"
                }
            }
        ]
    })(props);
}
function BsCalendar2Range(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4zM9 8a1 1 0 0 1 1-1h5v2h-5a1 1 0 0 1-1-1zm-8 2h4a1 1 0 1 1 0 2H1v-2z"
                }
            }
        ]
    })(props);
}
function BsCalendar2WeekFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zM8.5 7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zM3 10.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1z"
                }
            }
        ]
    })(props);
}
function BsCalendar2Week(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4zM11 7.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-5 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"
                }
            }
        ]
    })(props);
}
function BsCalendar2XFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zm-6.6 5.146a.5.5 0 1 0-.708.708L7.293 10l-1.147 1.146a.5.5 0 0 0 .708.708L8 10.707l1.146 1.147a.5.5 0 0 0 .708-.708L8.707 10l1.147-1.146a.5.5 0 0 0-.708-.708L8 9.293 6.854 8.146z"
                }
            }
        ]
    })(props);
}
function BsCalendar2X(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.146 8.146a.5.5 0 0 1 .708 0L8 9.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 10l1.147 1.146a.5.5 0 0 1-.708.708L8 10.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 10 6.146 8.854a.5.5 0 0 1 0-.708z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4z"
                }
            }
        ]
    })(props);
}
function BsCalendar2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4z"
                }
            }
        ]
    })(props);
}
function BsCalendar3EventFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 0a2 2 0 0 0-2 2h16a2 2 0 0 0-2-2H2zM0 14V3h16v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm12-8a1 1 0 1 0 2 0 1 1 0 0 0-2 0z"
                }
            }
        ]
    })(props);
}
function BsCalendar3Event(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857V3.857z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                }
            }
        ]
    })(props);
}
function BsCalendar3Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2H0zm0 1v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3H0z"
                }
            }
        ]
    })(props);
}
function BsCalendar3RangeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 0a2 2 0 0 0-2 2h16a2 2 0 0 0-2-2H2zM0 8V3h16v2h-6a1 1 0 1 0 0 2h6v7a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-4h6a1 1 0 1 0 0-2H0z"
                }
            }
        ]
    })(props);
}
function BsCalendar3Range(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857V3.857z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10a1 1 0 0 0 0-2H1v2h6zm2-3h6V5H9a1 1 0 0 0 0 2z"
                }
            }
        ]
    })(props);
}
function BsCalendar3WeekFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 0a2 2 0 0 0-2 2h16a2 2 0 0 0-2-2H2zM0 14V3h16v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm12-8a1 1 0 1 0 2 0 1 1 0 0 0-2 0zM5 9a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm5-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM2 9a1 1 0 1 0 2 0 1 1 0 0 0-2 0z"
                }
            }
        ]
    })(props);
}
function BsCalendar3Week(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857V3.857z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-5 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm2-3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-5 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                }
            }
        ]
    })(props);
}
function BsCalendar3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857V3.857z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                }
            }
        ]
    })(props);
}
function BsCalendar4Event(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1H2zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"
                }
            }
        ]
    })(props);
}
function BsCalendar4Range(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1H2zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 7.5a.5.5 0 0 1 .5-.5H15v2H9.5a.5.5 0 0 1-.5-.5v-1zm-2 3v1a.5.5 0 0 1-.5.5H1v-2h5.5a.5.5 0 0 1 .5.5z"
                }
            }
        ]
    })(props);
}
function BsCalendar4Week(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1H2zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-2 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"
                }
            }
        ]
    })(props);
}
function BsCalendar4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1H2zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5z"
                }
            }
        ]
    })(props);
}
function BsCameraFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 8.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2zm.5 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm9 2.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0z"
                }
            }
        ]
    })(props);
}
function BsCameraReelsFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6h.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 7.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 16H2a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h7z"
                }
            }
        ]
    })(props);
}
function BsCameraReels(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM1 3a2 2 0 1 0 4 0 2 2 0 0 0-4 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6h.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 7.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 16H2a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h7zm6 8.73V7.27l-3.5 1.555v4.35l3.5 1.556zM1 8v6a1 1 0 0 0 1 1h7.5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM7 3a2 2 0 1 1 4 0 2 2 0 0 1-4 0z"
                }
            }
        ]
    })(props);
}
function BsCameraVideoFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2V5z"
                }
            }
        ]
    })(props);
}
function BsCameraVideoOffFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.961 12.365a1.99 1.99 0 0 0 .522-1.103l3.11 1.382A1 1 0 0 0 16 11.731V4.269a1 1 0 0 0-1.406-.913l-3.111 1.382A2 2 0 0 0 9.5 3H4.272l6.69 9.365zm-10.114-9A2.001 2.001 0 0 0 0 5v6a2 2 0 0 0 2 2h5.728L.847 3.366zm9.746 11.925-10-14 .814-.58 10 14-.814.58z"
                }
            }
        ]
    })(props);
}
function BsCameraVideoOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.961 12.365a1.99 1.99 0 0 0 .522-1.103l3.11 1.382A1 1 0 0 0 16 11.731V4.269a1 1 0 0 0-1.406-.913l-3.111 1.382A2 2 0 0 0 9.5 3H4.272l.714 1H9.5a1 1 0 0 1 1 1v6a1 1 0 0 1-.144.518l.605.847zM1.428 4.18A.999.999 0 0 0 1 5v6a1 1 0 0 0 1 1h5.014l.714 1H2a2 2 0 0 1-2-2V5c0-.675.334-1.272.847-1.634l.58.814zM15 11.73l-3.5-1.555v-4.35L15 4.269v7.462zm-4.407 3.56-10-14 .814-.58 10 14-.814.58z"
                }
            }
        ]
    })(props);
}
function BsCameraVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2V5zm11.5 5.175 3.5 1.556V4.269l-3.5 1.556v4.35zM2 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h7.5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H2z"
                }
            }
        ]
    })(props);
}
function BsCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.172a3 3 0 0 0 2.12-.879l.83-.828A1 1 0 0 1 6.827 3h2.344a1 1 0 0 1 .707.293l.828.828A3 3 0 0 0 12.828 5H14a1 1 0 0 1 1 1v6zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsCamera2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8c0-1.657 2.343-3 4-3V4a4 4 0 0 0-4 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.318 3h2.015C15.253 3 16 3.746 16 4.667v6.666c0 .92-.746 1.667-1.667 1.667h-2.015A5.97 5.97 0 0 1 9 14a5.972 5.972 0 0 1-3.318-1H1.667C.747 13 0 12.254 0 11.333V4.667C0 3.747.746 3 1.667 3H2a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1h.682A5.97 5.97 0 0 1 9 2c1.227 0 2.367.368 3.318 1zM2 4.5a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0zM14 8A5 5 0 1 0 4 8a5 5 0 0 0 10 0z"
                }
            }
        ]
    })(props);
}
function BsCapslockFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.27 1.047a1 1 0 0 1 1.46 0l6.345 6.77c.6.638.146 1.683-.73 1.683H11.5v1a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-1H1.654C.78 9.5.326 8.455.924 7.816L7.27 1.047zM4.5 13.5a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-1z"
                }
            }
        ]
    })(props);
}
function BsCapslock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.27 1.047a1 1 0 0 1 1.46 0l6.345 6.77c.6.638.146 1.683-.73 1.683H11.5v1a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-1H1.654C.78 9.5.326 8.455.924 7.816L7.27 1.047zM14.346 8.5 8 1.731 1.654 8.5H4.5a1 1 0 0 1 1 1v1h5v-1a1 1 0 0 1 1-1h2.846zm-9.846 5a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-1zm6 0h-5v1h5v-1z"
                }
            }
        ]
    })(props);
}
function BsCapsulePill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.02 5.364a3 3 0 0 0-4.242-4.243L1.121 6.778a3 3 0 1 0 4.243 4.243l5.657-5.657Zm-6.413-.657 2.878-2.879a2 2 0 1 1 2.829 2.829L7.435 7.536 4.607 4.707ZM12 8a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm-.5 1.042a3 3 0 0 0 0 5.917V9.042Zm1 5.917a3 3 0 0 0 0-5.917v5.917Z"
                }
            }
        ]
    })(props);
}
function BsCapsule(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.828 8.9 8.9 1.827a4 4 0 1 1 5.657 5.657l-7.07 7.071A4 4 0 1 1 1.827 8.9Zm9.128.771 2.893-2.893a3 3 0 1 0-4.243-4.242L6.713 5.429l4.243 4.242Z"
                }
            }
        ]
    })(props);
}
function BsCarFrontFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679c.033.161.049.325.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.807.807 0 0 0 .381-.404l.792-1.848ZM3 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2H6ZM2.906 5.189a.51.51 0 0 0 .497.731c.91-.073 3.35-.17 4.597-.17 1.247 0 3.688.097 4.597.17a.51.51 0 0 0 .497-.731l-.956-1.913A.5.5 0 0 0 11.691 3H4.309a.5.5 0 0 0-.447.276L2.906 5.19Z"
                }
            }
        ]
    })(props);
}
function BsCarFront(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm10 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2H6ZM4.862 4.276 3.906 6.19a.51.51 0 0 0 .497.731c.91-.073 2.35-.17 3.597-.17 1.247 0 2.688.097 3.597.17a.51.51 0 0 0 .497-.731l-.956-1.913A.5.5 0 0 0 10.691 4H5.309a.5.5 0 0 0-.447.276Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679c.033.161.049.325.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.807.807 0 0 0 .381-.404l.792-1.848ZM4.82 3a1.5 1.5 0 0 0-1.379.91l-.792 1.847a1.8 1.8 0 0 1-.853.904.807.807 0 0 0-.43.564L1.03 8.904a1.5 1.5 0 0 0-.03.294v.413c0 .796.62 1.448 1.408 1.484 1.555.07 3.786.155 5.592.155 1.806 0 4.037-.084 5.592-.155A1.479 1.479 0 0 0 15 9.611v-.413c0-.099-.01-.197-.03-.294l-.335-1.68a.807.807 0 0 0-.43-.563 1.807 1.807 0 0 1-.853-.904l-.792-1.848A1.5 1.5 0 0 0 11.18 3H4.82Z"
                }
            }
        ]
    })(props);
}
function BsCardChecklist(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0zM7 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0z"
                }
            }
        ]
    })(props);
}
function BsCardHeading(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm0-5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-1z"
                }
            }
        ]
    })(props);
}
function BsCardImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 2A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13zm13 1a.5.5 0 0 1 .5.5v6l-3.775-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12v.54A.505.505 0 0 1 1 12.5v-9a.5.5 0 0 1 .5-.5h13z"
                }
            }
        ]
    })(props);
}
function BsCardList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 8zm0-2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-1-5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zM4 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm0 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsCardText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 8zm0 2.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsCaretDownFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
                }
            }
        ]
    })(props);
}
function BsCaretDownSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm4 4a.5.5 0 0 0-.374.832l4 4.5a.5.5 0 0 0 .748 0l4-4.5A.5.5 0 0 0 12 6H4z"
                }
            }
        ]
    })(props);
}
function BsCaretDownSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.626 6.832A.5.5 0 0 1 4 6h8a.5.5 0 0 1 .374.832l-4 4.5a.5.5 0 0 1-.748 0l-4-4.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2z"
                }
            }
        ]
    })(props);
}
function BsCaretDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.204 5h9.592L8 10.481 3.204 5zm-.753.659 4.796 5.48a1 1 0 0 0 1.506 0l4.796-5.48c.566-.647.106-1.659-.753-1.659H3.204a1 1 0 0 0-.753 1.659z"
                }
            }
        ]
    })(props);
}
function BsCaretLeftFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"
                }
            }
        ]
    })(props);
}
function BsCaretLeftSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm10.5 10V4a.5.5 0 0 0-.832-.374l-4.5 4a.5.5 0 0 0 0 .748l4.5 4A.5.5 0 0 0 10.5 12z"
                }
            }
        ]
    })(props);
}
function BsCaretLeftSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.205 12.456A.5.5 0 0 0 10.5 12V4a.5.5 0 0 0-.832-.374l-4.5 4a.5.5 0 0 0 0 .748l4.5 4a.5.5 0 0 0 .537.082z"
                }
            }
        ]
    })(props);
}
function BsCaretLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12.796V3.204L4.519 8 10 12.796zm-.659.753-5.48-4.796a1 1 0 0 1 0-1.506l5.48-4.796A1 1 0 0 1 11 3.204v9.592a1 1 0 0 1-1.659.753z"
                }
            }
        ]
    })(props);
}
function BsCaretRightFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"
                }
            }
        ]
    })(props);
}
function BsCaretRightSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm5.5 10a.5.5 0 0 0 .832.374l4.5-4a.5.5 0 0 0 0-.748l-4.5-4A.5.5 0 0 0 5.5 4v8z"
                }
            }
        ]
    })(props);
}
function BsCaretRightSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.795 12.456A.5.5 0 0 1 5.5 12V4a.5.5 0 0 1 .832-.374l4.5 4a.5.5 0 0 1 0 .748l-4.5 4a.5.5 0 0 1-.537.082z"
                }
            }
        ]
    })(props);
}
function BsCaretRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12.796V3.204L11.481 8 6 12.796zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753z"
                }
            }
        ]
    })(props);
}
function BsCaretUpFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"
                }
            }
        ]
    })(props);
}
function BsCaretUpSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm4 9h8a.5.5 0 0 0 .374-.832l-4-4.5a.5.5 0 0 0-.748 0l-4 4.5A.5.5 0 0 0 4 11z"
                }
            }
        ]
    })(props);
}
function BsCaretUpSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.544 10.705A.5.5 0 0 0 4 11h8a.5.5 0 0 0 .374-.832l-4-4.5a.5.5 0 0 0-.748 0l-4 4.5a.5.5 0 0 0-.082.537z"
                }
            }
        ]
    })(props);
}
function BsCaretUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.204 11h9.592L8 5.519 3.204 11zm-.753-.659 4.796-5.48a1 1 0 0 1 1.506 0l4.796 5.48c.566.647.106 1.659-.753 1.659H3.204a1 1 0 0 1-.753-1.659z"
                }
            }
        ]
    })(props);
}
function BsCartCheckFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-1.646-7.646-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L8 8.293l2.646-2.647a.5.5 0 0 1 .708.708z"
                }
            }
        ]
    })(props);
}
function BsCartCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.354 6.354a.5.5 0 0 0-.708-.708L8 8.293 6.854 7.146a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zm3.915 10L3.102 4h10.796l-1.313 7h-8.17zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                }
            }
        ]
    })(props);
}
function BsCartDashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM6.5 7h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsCartDash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 7a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zm3.915 10L3.102 4h10.796l-1.313 7h-8.17zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                }
            }
        ]
    })(props);
}
function BsCartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                }
            }
        ]
    })(props);
}
function BsCartPlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM9 5.5V7h1.5a.5.5 0 0 1 0 1H9v1.5a.5.5 0 0 1-1 0V8H6.5a.5.5 0 0 1 0-1H8V5.5a.5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsCartPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 5.5a.5.5 0 0 0-1 0V7H6.5a.5.5 0 0 0 0 1H8v1.5a.5.5 0 0 0 1 0V8h1.5a.5.5 0 0 0 0-1H9V5.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zm3.915 10L3.102 4h10.796l-1.313 7h-8.17zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                }
            }
        ]
    })(props);
}
function BsCartXFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7.354 5.646 8.5 6.793l1.146-1.147a.5.5 0 0 1 .708.708L9.207 7.5l1.147 1.146a.5.5 0 0 1-.708.708L8.5 8.207 7.354 9.354a.5.5 0 1 1-.708-.708L7.793 7.5 6.646 6.354a.5.5 0 1 1 .708-.708z"
                }
            }
        ]
    })(props);
}
function BsCartX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.354 5.646a.5.5 0 1 0-.708.708L7.793 7.5 6.646 8.646a.5.5 0 1 0 .708.708L8.5 8.207l1.146 1.147a.5.5 0 0 0 .708-.708L9.207 7.5l1.147-1.146a.5.5 0 0 0-.708-.708L8.5 6.793 7.354 5.646z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zm3.915 10L3.102 4h10.796l-1.313 7h-8.17zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                }
            }
        ]
    })(props);
}
function BsCart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM3.102 4l1.313 7h8.17l1.313-7H3.102zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                }
            }
        ]
    })(props);
}
function BsCart2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5zM3.14 5l1.25 5h8.22l1.25-5H3.14zM5 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0z"
                }
            }
        ]
    })(props);
}
function BsCart3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .49.598l-1 5a.5.5 0 0 1-.465.401l-9.397.472L4.415 11H13a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM3.102 4l.84 4.479 9.144-.459L13.89 4H3.102zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                }
            }
        ]
    })(props);
}
function BsCart4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5zM3.14 5l.5 2H5V5H3.14zM6 5v2h2V5H6zm3 0v2h2V5H9zm3 0v2h1.36l.5-2H12zm1.11 3H12v2h.61l.5-2zM11 8H9v2h2V8zM8 8H6v2h2V8zM5 8H3.89l.5 2H5V8zm0 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0z"
                }
            }
        ]
    })(props);
}
function BsCashCoin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm5-4a5 5 0 1 1-10 0 5 5 0 0 1 10 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.438 11.944c.047.596.518 1.06 1.363 1.116v.44h.375v-.443c.875-.061 1.386-.529 1.386-1.207 0-.618-.39-.936-1.09-1.1l-.296-.07v-1.2c.376.043.614.248.671.532h.658c-.047-.575-.54-1.024-1.329-1.073V8.5h-.375v.45c-.747.073-1.255.522-1.255 1.158 0 .562.378.92 1.007 1.066l.248.061v1.272c-.384-.058-.639-.27-.696-.563h-.668zm1.36-1.354c-.369-.085-.569-.26-.569-.522 0-.294.216-.514.572-.578v1.1h-.003zm.432.746c.449.104.655.272.655.569 0 .339-.257.571-.709.614v-1.195l.054.012z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 0a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4.083c.058-.344.145-.678.258-1H3a2 2 0 0 0-2-2V3a2 2 0 0 0 2-2h10a2 2 0 0 0 2 2v3.528c.38.34.717.728 1 1.154V1a1 1 0 0 0-1-1H1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.998 5.083 10 5a2 2 0 1 0-3.132 1.65 5.982 5.982 0 0 1 3.13-1.567z"
                }
            }
        ]
    })(props);
}
function BsCashStack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1H1zm7 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V5zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V7a2 2 0 0 1-2-2H3z"
                }
            }
        ]
    })(props);
}
function BsCash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V6a2 2 0 0 1-2-2H3z"
                }
            }
        ]
    })(props);
}
function BsCassetteFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 2A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h.191l1.862-3.724A.5.5 0 0 1 4 10h8a.5.5 0 0 1 .447.276L14.31 14h.191a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13ZM4 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm8 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM6 6a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13.191 14-1.5-3H4.309l-1.5 3h10.382Z"
                }
            }
        ]
    })(props);
}
function BsCassette(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm9-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM7 6a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2H7Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 2A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13ZM1 3.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-.691l-1.362-2.724A.5.5 0 0 0 12 10H4a.5.5 0 0 0-.447.276L2.19 13H1.5a.5.5 0 0 1-.5-.5v-9ZM11.691 11l1 2H3.309l1-2h7.382Z"
                }
            }
        ]
    })(props);
}
function BsCast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7.646 9.354-3.792 3.792a.5.5 0 0 0 .353.854h7.586a.5.5 0 0 0 .354-.854L8.354 9.354a.5.5 0 0 0-.708 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.414 11H14.5a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-13a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h3.086l-1 1H1.5A1.5 1.5 0 0 1 0 10.5v-7A1.5 1.5 0 0 1 1.5 2h13A1.5 1.5 0 0 1 16 3.5v7a1.5 1.5 0 0 1-1.5 1.5h-2.086l-1-1z"
                }
            }
        ]
    })(props);
}
function BsCcCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM5.408 5.89c.681 0 1.138.47 1.187 1.107h1.147v-.11c-.053-1.187-1.024-2-2.343-2-1.604 0-2.518 1.05-2.518 2.751v.747c0 1.7.906 2.73 2.518 2.73 1.314 0 2.285-.792 2.343-1.939v-.114H6.595c-.049.615-.497 1.05-1.187 1.05-.84 0-1.318-.62-1.318-1.727v-.742c0-1.112.488-1.754 1.318-1.754Zm5.404 0c.68 0 1.138.47 1.186 1.107h1.147v-.11c-.053-1.187-1.024-2-2.342-2-1.604 0-2.518 1.05-2.518 2.751v.747c0 1.7.905 2.73 2.518 2.73 1.314 0 2.285-.792 2.342-1.939v-.114h-1.147c-.048.615-.496 1.05-1.186 1.05-.84 0-1.319-.62-1.319-1.727v-.742c0-1.112.488-1.754 1.319-1.754Z"
                }
            }
        ]
    })(props);
}
function BsCcCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8Zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM5.408 5.89c-.83 0-1.318.64-1.318 1.753v.742c0 1.108.479 1.727 1.318 1.727.69 0 1.138-.435 1.187-1.05h1.147v.114c-.058 1.147-1.029 1.938-2.343 1.938-1.612 0-2.518-1.028-2.518-2.729v-.747c0-1.7.914-2.75 2.518-2.75 1.319 0 2.29.812 2.343 1.999v.11H6.595c-.049-.638-.506-1.108-1.187-1.108Zm5.404 0c-.831 0-1.319.64-1.319 1.753v.742c0 1.108.48 1.727 1.319 1.727.69 0 1.138-.435 1.186-1.05h1.147v.114c-.057 1.147-1.028 1.938-2.342 1.938-1.613 0-2.518-1.028-2.518-2.729v-.747c0-1.7.914-2.75 2.518-2.75 1.318 0 2.29.812 2.342 1.999v.11h-1.147c-.048-.638-.505-1.108-1.186-1.108Z"
                }
            }
        ]
    })(props);
}
function BsCcSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm3.408 5.89c-.83 0-1.318.64-1.318 1.753v.742c0 1.108.479 1.727 1.318 1.727.69 0 1.138-.435 1.187-1.05h1.147v.114c-.058 1.147-1.029 1.938-2.343 1.938-1.612 0-2.518-1.028-2.518-2.729v-.747c0-1.7.914-2.75 2.518-2.75 1.319 0 2.29.812 2.343 1.999v.11H6.595c-.049-.638-.506-1.108-1.187-1.108Zm5.404 0c-.831 0-1.319.64-1.319 1.753v.742c0 1.108.48 1.727 1.319 1.727.69 0 1.138-.435 1.186-1.05h1.147v.114c-.057 1.147-1.028 1.938-2.342 1.938-1.613 0-2.518-1.028-2.518-2.729v-.747c0-1.7.914-2.75 2.518-2.75 1.318 0 2.29.812 2.342 1.999v.11h-1.147c-.048-.638-.505-1.108-1.186-1.108Z"
                }
            }
        ]
    })(props);
}
function BsCcSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2ZM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm5.408 3.89c-.83 0-1.318.64-1.318 1.753v.742c0 1.108.479 1.727 1.318 1.727.69 0 1.138-.435 1.187-1.05h1.147v.114c-.058 1.147-1.029 1.938-2.343 1.938-1.612 0-2.518-1.028-2.518-2.729v-.747c0-1.7.914-2.75 2.518-2.75 1.319 0 2.29.812 2.343 1.999v.11H6.595c-.049-.638-.506-1.108-1.187-1.108Zm5.404 0c-.831 0-1.319.64-1.319 1.753v.742c0 1.108.48 1.727 1.319 1.727.69 0 1.138-.435 1.186-1.05h1.147v.114c-.057 1.147-1.028 1.938-2.342 1.938-1.613 0-2.518-1.028-2.518-2.729v-.747c0-1.7.914-2.75 2.518-2.75 1.318 0 2.29.812 2.342 1.999v.11h-1.147c-.048-.638-.505-1.108-1.186-1.108Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2ZM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm5.408 3.89c-.83 0-1.318.64-1.318 1.753v.742c0 1.108.479 1.727 1.318 1.727.69 0 1.138-.435 1.187-1.05h1.147v.114c-.058 1.147-1.029 1.938-2.343 1.938-1.612 0-2.518-1.028-2.518-2.729v-.747c0-1.7.914-2.75 2.518-2.75 1.319 0 2.29.812 2.343 1.999v.11H6.595c-.049-.638-.506-1.108-1.187-1.108Zm5.404 0c-.831 0-1.319.64-1.319 1.753v.742c0 1.108.48 1.727 1.319 1.727.69 0 1.138-.435 1.186-1.05h1.147v.114c-.057 1.147-1.028 1.938-2.342 1.938-1.613 0-2.518-1.028-2.518-2.729v-.747c0-1.7.914-2.75 2.518-2.75 1.318 0 2.29.812 2.342 1.999v.11h-1.147c-.048-.638-.505-1.108-1.186-1.108Z"
                }
            }
        ]
    })(props);
}
function BsChatDotsFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8c0 3.866-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7zM5 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                }
            }
        ]
    })(props);
}
function BsChatDots(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2.165 15.803.02-.004c1.83-.363 2.948-.842 3.468-1.105A9.06 9.06 0 0 0 8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6a10.437 10.437 0 0 1-.524 2.318l-.003.011a10.722 10.722 0 0 1-.244.637c-.079.186.074.394.273.362a21.673 21.673 0 0 0 .693-.125zm.8-3.108a1 1 0 0 0-.287-.801C1.618 10.83 1 9.468 1 8c0-3.192 3.004-6 7-6s7 2.808 7 6c0 3.193-3.004 6-7 6a8.06 8.06 0 0 1-2.088-.272 1 1 0 0 0-.711.074c-.387.196-1.24.57-2.634.893a10.97 10.97 0 0 0 .398-2z"
                }
            }
        ]
    })(props);
}
function BsChatFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6-.097 1.016-.417 2.13-.771 2.966-.079.186.074.394.273.362 2.256-.37 3.597-.938 4.18-1.234A9.06 9.06 0 0 0 8 15z"
                }
            }
        ]
    })(props);
}
function BsChatHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6-.097 1.016-.417 2.13-.771 2.966-.079.186.074.394.273.362 2.256-.37 3.597-.938 4.18-1.234A9.06 9.06 0 0 0 8 15Zm0-9.007c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z"
                }
            }
        ]
    })(props);
}
function BsChatHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.965 12.695a1 1 0 0 0-.287-.801C1.618 10.83 1 9.468 1 8c0-3.192 3.004-6 7-6s7 2.808 7 6c0 3.193-3.004 6-7 6a8.06 8.06 0 0 1-2.088-.272 1 1 0 0 0-.711.074c-.387.196-1.24.57-2.634.893a10.97 10.97 0 0 0 .398-2Zm-.8 3.108.02-.004c1.83-.363 2.948-.842 3.468-1.105A9.06 9.06 0 0 0 8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6a10.437 10.437 0 0 1-.524 2.318l-.003.011a10.722 10.722 0 0 1-.244.637c-.079.186.074.394.273.362a21.673 21.673 0 0 0 .693-.125ZM8 5.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z"
                }
            }
        ]
    })(props);
}
function BsChatLeftDotsFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4.414a1 1 0 0 0-.707.293L.854 15.146A.5.5 0 0 1 0 14.793V2zm5 4a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                }
            }
        ]
    })(props);
}
function BsChatLeftDots(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                }
            }
        ]
    })(props);
}
function BsChatLeftFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                }
            }
        ]
    })(props);
}
function BsChatLeftHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm6 3.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z"
                }
            }
        ]
    })(props);
}
function BsChatLeftHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12ZM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z"
                }
            }
        ]
    })(props);
}
function BsChatLeftQuoteFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4.414a1 1 0 0 0-.707.293L.854 15.146A.5.5 0 0 1 0 14.793V2zm7.194 2.766a1.688 1.688 0 0 0-.227-.272 1.467 1.467 0 0 0-.469-.324l-.008-.004A1.785 1.785 0 0 0 5.734 4C4.776 4 4 4.746 4 5.667c0 .92.776 1.666 1.734 1.666.343 0 .662-.095.931-.26-.137.389-.39.804-.81 1.22a.405.405 0 0 0 .011.59c.173.16.447.155.614-.01 1.334-1.329 1.37-2.758.941-3.706a2.461 2.461 0 0 0-.227-.4zM11 7.073c-.136.389-.39.804-.81 1.22a.405.405 0 0 0 .012.59c.172.16.446.155.613-.01 1.334-1.329 1.37-2.758.942-3.706a2.466 2.466 0 0 0-.228-.4 1.686 1.686 0 0 0-.227-.273 1.466 1.466 0 0 0-.469-.324l-.008-.004A1.785 1.785 0 0 0 10.07 4c-.957 0-1.734.746-1.734 1.667 0 .92.777 1.666 1.734 1.666.343 0 .662-.095.931-.26z"
                }
            }
        ]
    })(props);
}
function BsChatLeftQuote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.066 4.76A1.665 1.665 0 0 0 4 5.668a1.667 1.667 0 0 0 2.561 1.406c-.131.389-.375.804-.777 1.22a.417.417 0 1 0 .6.58c1.486-1.54 1.293-3.214.682-4.112zm4 0A1.665 1.665 0 0 0 8 5.668a1.667 1.667 0 0 0 2.561 1.406c-.131.389-.375.804-.777 1.22a.417.417 0 1 0 .6.58c1.486-1.54 1.293-3.214.682-4.112z"
                }
            }
        ]
    })(props);
}
function BsChatLeftTextFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4.414a1 1 0 0 0-.707.293L.854 15.146A.5.5 0 0 1 0 14.793V2zm3.5 1a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 2.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5z"
                }
            }
        ]
    })(props);
}
function BsChatLeftText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6zm0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsChatLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                }
            }
        ]
    })(props);
}
function BsChatQuoteFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8c0 3.866-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7zM7.194 6.766a1.688 1.688 0 0 0-.227-.272 1.467 1.467 0 0 0-.469-.324l-.008-.004A1.785 1.785 0 0 0 5.734 6C4.776 6 4 6.746 4 7.667c0 .92.776 1.666 1.734 1.666.343 0 .662-.095.931-.26-.137.389-.39.804-.81 1.22a.405.405 0 0 0 .011.59c.173.16.447.155.614-.01 1.334-1.329 1.37-2.758.941-3.706a2.461 2.461 0 0 0-.227-.4zM11 9.073c-.136.389-.39.804-.81 1.22a.405.405 0 0 0 .012.59c.172.16.446.155.613-.01 1.334-1.329 1.37-2.758.942-3.706a2.466 2.466 0 0 0-.228-.4 1.686 1.686 0 0 0-.227-.273 1.466 1.466 0 0 0-.469-.324l-.008-.004A1.785 1.785 0 0 0 10.07 6c-.957 0-1.734.746-1.734 1.667 0 .92.777 1.666 1.734 1.666.343 0 .662-.095.931-.26z"
                }
            }
        ]
    })(props);
}
function BsChatQuote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.678 11.894a1 1 0 0 1 .287.801 10.97 10.97 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8.06 8.06 0 0 0 8 14c3.996 0 7-2.807 7-6 0-3.192-3.004-6-7-6S1 4.808 1 8c0 1.468.617 2.83 1.678 3.894zm-.493 3.905a21.682 21.682 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a9.68 9.68 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.066 6.76A1.665 1.665 0 0 0 4 7.668a1.667 1.667 0 0 0 2.561 1.406c-.131.389-.375.804-.777 1.22a.417.417 0 0 0 .6.58c1.486-1.54 1.293-3.214.682-4.112zm4 0A1.665 1.665 0 0 0 8 7.668a1.667 1.667 0 0 0 2.561 1.406c-.131.389-.375.804-.777 1.22a.417.417 0 0 0 .6.58c1.486-1.54 1.293-3.214.682-4.112z"
                }
            }
        ]
    })(props);
}
function BsChatRightDotsFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h9.586a1 1 0 0 1 .707.293l2.853 2.853a.5.5 0 0 0 .854-.353V2zM5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                }
            }
        ]
    })(props);
}
function BsChatRightDots(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h9.586a2 2 0 0 1 1.414.586l2 2V2a1 1 0 0 0-1-1H2zm12-1a2 2 0 0 1 2 2v12.793a.5.5 0 0 1-.854.353l-2.853-2.853a1 1 0 0 0-.707-.293H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                }
            }
        ]
    })(props);
}
function BsChatRightFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 0a2 2 0 0 1 2 2v12.793a.5.5 0 0 1-.854.353l-2.853-2.853a1 1 0 0 0-.707-.293H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12z"
                }
            }
        ]
    })(props);
}
function BsChatRightHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h9.586a1 1 0 0 1 .707.293l2.853 2.853a.5.5 0 0 0 .854-.353V2ZM8 3.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z"
                }
            }
        ]
    })(props);
}
function BsChatRightHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h9.586a2 2 0 0 1 1.414.586l2 2V2a1 1 0 0 0-1-1H2Zm12-1a2 2 0 0 1 2 2v12.793a.5.5 0 0 1-.854.353l-2.853-2.853a1 1 0 0 0-.707-.293H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z"
                }
            }
        ]
    })(props);
}
function BsChatRightQuoteFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h9.586a1 1 0 0 1 .707.293l2.853 2.853a.5.5 0 0 0 .854-.353V2zM7.194 4.766c.087.124.163.26.227.401.428.948.393 2.377-.942 3.706a.446.446 0 0 1-.612.01.405.405 0 0 1-.011-.59c.419-.416.672-.831.809-1.22-.269.165-.588.26-.93.26C4.775 7.333 4 6.587 4 5.667 4 4.747 4.776 4 5.734 4c.271 0 .528.06.756.166l.008.004c.169.07.327.182.469.324.085.083.161.174.227.272zM11 7.073c-.269.165-.588.26-.93.26-.958 0-1.735-.746-1.735-1.666 0-.92.777-1.667 1.734-1.667.271 0 .528.06.756.166l.008.004c.17.07.327.182.469.324.085.083.161.174.227.272.087.124.164.26.228.401.428.948.392 2.377-.942 3.706a.446.446 0 0 1-.613.01.405.405 0 0 1-.011-.59c.42-.416.672-.831.81-1.22z"
                }
            }
        ]
    })(props);
}
function BsChatRightQuote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h9.586a2 2 0 0 1 1.414.586l2 2V2a1 1 0 0 0-1-1H2zm12-1a2 2 0 0 1 2 2v12.793a.5.5 0 0 1-.854.353l-2.853-2.853a1 1 0 0 0-.707-.293H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.066 4.76A1.665 1.665 0 0 0 4 5.668a1.667 1.667 0 0 0 2.561 1.406c-.131.389-.375.804-.777 1.22a.417.417 0 1 0 .6.58c1.486-1.54 1.293-3.214.682-4.112zm4 0A1.665 1.665 0 0 0 8 5.668a1.667 1.667 0 0 0 2.561 1.406c-.131.389-.375.804-.777 1.22a.417.417 0 1 0 .6.58c1.486-1.54 1.293-3.214.682-4.112z"
                }
            }
        ]
    })(props);
}
function BsChatRightTextFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h9.586a1 1 0 0 1 .707.293l2.853 2.853a.5.5 0 0 0 .854-.353V2zM3.5 3h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1zm0 2.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1zm0 2.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsChatRightText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h9.586a2 2 0 0 1 1.414.586l2 2V2a1 1 0 0 0-1-1H2zm12-1a2 2 0 0 1 2 2v12.793a.5.5 0 0 1-.854.353l-2.853-2.853a1 1 0 0 0-.707-.293H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6zm0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsChatRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h9.586a2 2 0 0 1 1.414.586l2 2V2a1 1 0 0 0-1-1H2zm12-1a2 2 0 0 1 2 2v12.793a.5.5 0 0 1-.854.353l-2.853-2.853a1 1 0 0 0-.707-.293H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12z"
                }
            }
        ]
    })(props);
}
function BsChatSquareDotsFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.5a1 1 0 0 0-.8.4l-1.9 2.533a1 1 0 0 1-1.6 0L5.3 12.4a1 1 0 0 0-.8-.4H2a2 2 0 0 1-2-2V2zm5 4a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                }
            }
        ]
    })(props);
}
function BsChatSquareDots(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-2.5a2 2 0 0 0-1.6.8L8 14.333 6.1 11.8a2 2 0 0 0-1.6-.8H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                }
            }
        ]
    })(props);
}
function BsChatSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                }
            }
        ]
    })(props);
}
function BsChatSquareHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm6 3.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z"
                }
            }
        ]
    })(props);
}
function BsChatSquareHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-2.5a2 2 0 0 0-1.6.8L8 14.333 6.1 11.8a2 2 0 0 0-1.6-.8H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12ZM2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z"
                }
            }
        ]
    })(props);
}
function BsChatSquareQuoteFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.5a1 1 0 0 0-.8.4l-1.9 2.533a1 1 0 0 1-1.6 0L5.3 12.4a1 1 0 0 0-.8-.4H2a2 2 0 0 1-2-2V2zm7.194 2.766a1.688 1.688 0 0 0-.227-.272 1.467 1.467 0 0 0-.469-.324l-.008-.004A1.785 1.785 0 0 0 5.734 4C4.776 4 4 4.746 4 5.667c0 .92.776 1.666 1.734 1.666.343 0 .662-.095.931-.26-.137.389-.39.804-.81 1.22a.405.405 0 0 0 .011.59c.173.16.447.155.614-.01 1.334-1.329 1.37-2.758.941-3.706a2.461 2.461 0 0 0-.227-.4zM11 7.073c-.136.389-.39.804-.81 1.22a.405.405 0 0 0 .012.59c.172.16.446.155.613-.01 1.334-1.329 1.37-2.758.942-3.706a2.466 2.466 0 0 0-.228-.4 1.686 1.686 0 0 0-.227-.273 1.466 1.466 0 0 0-.469-.324l-.008-.004A1.785 1.785 0 0 0 10.07 4c-.957 0-1.734.746-1.734 1.667 0 .92.777 1.666 1.734 1.666.343 0 .662-.095.931-.26z"
                }
            }
        ]
    })(props);
}
function BsChatSquareQuote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-2.5a2 2 0 0 0-1.6.8L8 14.333 6.1 11.8a2 2 0 0 0-1.6-.8H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.066 4.76A1.665 1.665 0 0 0 4 5.668a1.667 1.667 0 0 0 2.561 1.406c-.131.389-.375.804-.777 1.22a.417.417 0 1 0 .6.58c1.486-1.54 1.293-3.214.682-4.112zm4 0A1.665 1.665 0 0 0 8 5.668a1.667 1.667 0 0 0 2.561 1.406c-.131.389-.375.804-.777 1.22a.417.417 0 1 0 .6.58c1.486-1.54 1.293-3.214.682-4.112z"
                }
            }
        ]
    })(props);
}
function BsChatSquareTextFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.5a1 1 0 0 0-.8.4l-1.9 2.533a1 1 0 0 1-1.6 0L5.3 12.4a1 1 0 0 0-.8-.4H2a2 2 0 0 1-2-2V2zm3.5 1a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 2.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5z"
                }
            }
        ]
    })(props);
}
function BsChatSquareText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-2.5a2 2 0 0 0-1.6.8L8 14.333 6.1 11.8a2 2 0 0 0-1.6-.8H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6zm0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsChatSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-2.5a2 2 0 0 0-1.6.8L8 14.333 6.1 11.8a2 2 0 0 0-1.6-.8H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                }
            }
        ]
    })(props);
}
function BsChatTextFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8c0 3.866-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7zM4.5 5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7zm0 2.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7zm0 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4z"
                }
            }
        ]
    })(props);
}
function BsChatText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.678 11.894a1 1 0 0 1 .287.801 10.97 10.97 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8.06 8.06 0 0 0 8 14c3.996 0 7-2.807 7-6 0-3.192-3.004-6-7-6S1 4.808 1 8c0 1.468.617 2.83 1.678 3.894zm-.493 3.905a21.682 21.682 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a9.68 9.68 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 5.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8zm0 2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsChat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.678 11.894a1 1 0 0 1 .287.801 10.97 10.97 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8.06 8.06 0 0 0 8 14c3.996 0 7-2.807 7-6 0-3.192-3.004-6-7-6S1 4.808 1 8c0 1.468.617 2.83 1.678 3.894zm-.493 3.905a21.682 21.682 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a9.68 9.68 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105z"
                }
            }
        ]
    })(props);
}
function BsCheckAll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992a.252.252 0 0 1 .02-.022zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486-.943 1.179z"
                }
            }
        ]
    })(props);
}
function BsCheckCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
                }
            }
        ]
    })(props);
}
function BsCheckCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"
                }
            }
        ]
    })(props);
}
function BsCheckLg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
                }
            }
        ]
    })(props);
}
function BsCheckSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm10.03 4.97a.75.75 0 0 1 .011 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.75.75 0 0 1 1.08-.022z"
                }
            }
        ]
    })(props);
}
function BsCheckSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.235.235 0 0 1 .02-.022z"
                }
            }
        ]
    })(props);
}
function BsCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"
                }
            }
        ]
    })(props);
}
function BsCheck2All(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.354 4.354a.5.5 0 0 0-.708-.708L5 10.293 1.854 7.146a.5.5 0 1 0-.708.708l3.5 3.5a.5.5 0 0 0 .708 0l7-7zm-4.208 7-.896-.897.707-.707.543.543 6.646-6.647a.5.5 0 0 1 .708.708l-7 7a.5.5 0 0 1-.708 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m5.354 7.146.896.897-.707.707-.897-.896a.5.5 0 1 1 .708-.708z"
                }
            }
        ]
    })(props);
}
function BsCheck2Circle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z"
                }
            }
        ]
    })(props);
}
function BsCheck2Square(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14.5A1.5 1.5 0 0 1 1.5 13V3A1.5 1.5 0 0 1 3 1.5h8a.5.5 0 0 1 0 1H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8a.5.5 0 0 1 1 0v5a1.5 1.5 0 0 1-1.5 1.5H3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8.354 10.354 7-7a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"
                }
            }
        ]
    })(props);
}
function BsCheck2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"
                }
            }
        ]
    })(props);
}
function BsChevronBarContract(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.646 14.854a.5.5 0 0 0 .708 0L8 11.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708zm0-13.708a.5.5 0 0 1 .708 0L8 4.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zM1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8z"
                }
            }
        ]
    })(props);
}
function BsChevronBarDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.646 4.146a.5.5 0 0 1 .708 0L8 7.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zM1 11.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsChevronBarExpand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.646 10.146a.5.5 0 0 1 .708 0L8 13.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-4.292a.5.5 0 0 0 .708 0L8 2.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708zM1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8z"
                }
            }
        ]
    })(props);
}
function BsChevronBarLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.854 3.646a.5.5 0 0 1 0 .708L8.207 8l3.647 3.646a.5.5 0 0 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 0 1 .708 0zM4.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 1 0v-13a.5.5 0 0 0-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsChevronBarRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.146 3.646a.5.5 0 0 0 0 .708L7.793 8l-3.647 3.646a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708 0zM11.5 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsChevronBarUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.646 11.854a.5.5 0 0 0 .708 0L8 8.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708zM2.4 5.2c0 .22.18.4.4.4h10.4a.4.4 0 0 0 0-.8H2.8a.4.4 0 0 0-.4.4z"
                }
            }
        ]
    })(props);
}
function BsChevronCompactDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.553 6.776a.5.5 0 0 1 .67-.223L8 9.44l5.776-2.888a.5.5 0 1 1 .448.894l-6 3a.5.5 0 0 1-.448 0l-6-3a.5.5 0 0 1-.223-.67z"
                }
            }
        ]
    })(props);
}
function BsChevronCompactLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.224 1.553a.5.5 0 0 1 .223.67L6.56 8l2.888 5.776a.5.5 0 1 1-.894.448l-3-6a.5.5 0 0 1 0-.448l3-6a.5.5 0 0 1 .67-.223z"
                }
            }
        ]
    })(props);
}
function BsChevronCompactRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.776 1.553a.5.5 0 0 1 .671.223l3 6a.5.5 0 0 1 0 .448l-3 6a.5.5 0 1 1-.894-.448L9.44 8 6.553 2.224a.5.5 0 0 1 .223-.671z"
                }
            }
        ]
    })(props);
}
function BsChevronCompactUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.776 5.553a.5.5 0 0 1 .448 0l6 3a.5.5 0 1 1-.448.894L8 6.56 2.224 9.447a.5.5 0 1 1-.448-.894l6-3z"
                }
            }
        ]
    })(props);
}
function BsChevronContract(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.646 13.854a.5.5 0 0 0 .708 0L8 10.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708zm0-11.708a.5.5 0 0 1 .708 0L8 5.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708z"
                }
            }
        ]
    })(props);
}
function BsChevronDoubleDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                }
            }
        ]
    })(props);
}
function BsChevronDoubleLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.354 1.646a.5.5 0 0 1 0 .708L2.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.354 1.646a.5.5 0 0 1 0 .708L6.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                }
            }
        ]
    })(props);
}
function BsChevronDoubleRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708z"
                }
            }
        ]
    })(props);
}
function BsChevronDoubleUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.646 2.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 3.707 2.354 9.354a.5.5 0 1 1-.708-.708l6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.646 6.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 7.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
                }
            }
        ]
    })(props);
}
function BsChevronDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                }
            }
        ]
    })(props);
}
function BsChevronExpand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z"
                }
            }
        ]
    })(props);
}
function BsChevronLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                }
            }
        ]
    })(props);
}
function BsChevronRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                }
            }
        ]
    })(props);
}
function BsChevronUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
                }
            }
        ]
    })(props);
}
function BsCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "8",
                    "r": "8"
                }
            }
        ]
    })(props);
}
function BsCircleHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 0 8 1v14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z"
                }
            }
        ]
    })(props);
}
function BsCircleSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.93 5h1.57a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-1.57a6.953 6.953 0 0 1-1-.22v1.79A1.5 1.5 0 0 0 5.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 4h-1.79c.097.324.17.658.22 1z"
                }
            }
        ]
    })(props);
}
function BsCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            }
        ]
    })(props);
}
function BsClipboardCheckFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 0A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3Zm3 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1A2.5 2.5 0 0 1 9.5 5h-3A2.5 2.5 0 0 1 4 2.5v-1Zm6.854 7.354-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708.708Z"
                }
            }
        ]
    })(props);
}
function BsClipboardCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"
                }
            }
        ]
    })(props);
}
function BsClipboardDataFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 0A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3Zm3 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1A2.5 2.5 0 0 1 9.5 5h-3A2.5 2.5 0 0 1 4 2.5v-1ZM10 8a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0V8Zm-6 4a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0v-1Zm4-3a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Z"
                }
            }
        ]
    })(props);
}
function BsClipboardData(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0v-1zm6-4a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0V7zM7 9a1 1 0 0 1 2 0v3a1 1 0 1 1-2 0V9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"
                }
            }
        ]
    })(props);
}
function BsClipboardFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 1.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1Zm-5 0A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5v1A1.5 1.5 0 0 1 9.5 4h-3A1.5 1.5 0 0 1 5 2.5v-1Zm-2 0h1v1A2.5 2.5 0 0 0 6.5 5h3A2.5 2.5 0 0 0 12 2.5v-1h1a2 2 0 0 1 2 2V14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3.5a2 2 0 0 1 2-2Z"
                }
            }
        ]
    })(props);
}
function BsClipboardHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.5 0A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3Zm3 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1A2.5 2.5 0 0 1 9.5 5h-3A2.5 2.5 0 0 1 4 2.5v-1Zm4 5.982c1.664-1.673 5.825 1.254 0 5.018-5.825-3.764-1.664-6.69 0-5.018Z"
                }
            }
        ]
    })(props);
}
function BsClipboardHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 1.5A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5v1A1.5 1.5 0 0 1 9.5 4h-3A1.5 1.5 0 0 1 5 2.5v-1Zm5 0a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 1.5h1v1H3a1 1 0 0 0-1 1V14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3.5a1 1 0 0 0-1-1h-1v-1h1a2 2 0 0 1 2 2V14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3.5a2 2 0 0 1 2-2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6.982C9.664 5.309 13.825 8.236 8 12 2.175 8.236 6.336 5.31 8 6.982Z"
                }
            }
        ]
    })(props);
}
function BsClipboardMinusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 0A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3Zm3 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1A2.5 2.5 0 0 1 9.5 5h-3A2.5 2.5 0 0 1 4 2.5v-1ZM6 9h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1Z"
                }
            }
        ]
    })(props);
}
function BsClipboardMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.5 9.5A.5.5 0 0 1 6 9h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"
                }
            }
        ]
    })(props);
}
function BsClipboardPlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 0A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3Zm3 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1A2.5 2.5 0 0 1 9.5 5h-3A2.5 2.5 0 0 1 4 2.5v-1Zm4.5 6V9H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V10H6a.5.5 0 0 1 0-1h1.5V7.5a.5.5 0 0 1 1 0Z"
                }
            }
        ]
    })(props);
}
function BsClipboardPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 7a.5.5 0 0 1 .5.5V9H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V10H6a.5.5 0 0 1 0-1h1.5V7.5A.5.5 0 0 1 8 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"
                }
            }
        ]
    })(props);
}
function BsClipboardPulse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 1.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1Zm-5 0A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5v1A1.5 1.5 0 0 1 9.5 4h-3A1.5 1.5 0 0 1 5 2.5v-1Zm-2 0h1v1H3a1 1 0 0 0-1 1V14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3.5a1 1 0 0 0-1-1h-1v-1h1a2 2 0 0 1 2 2V14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3.5a2 2 0 0 1 2-2Zm6.979 3.856a.5.5 0 0 0-.968.04L7.92 10.49l-.94-3.135a.5.5 0 0 0-.895-.133L4.232 10H3.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 .416-.223l1.41-2.115 1.195 3.982a.5.5 0 0 0 .968-.04L9.58 7.51l.94 3.135A.5.5 0 0 0 11 11h1.5a.5.5 0 0 0 0-1h-1.128L9.979 5.356Z"
                }
            }
        ]
    })(props);
}
function BsClipboardXFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 0A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3Zm3 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1A2.5 2.5 0 0 1 9.5 5h-3A2.5 2.5 0 0 1 4 2.5v-1Zm4 7.793 1.146-1.147a.5.5 0 1 1 .708.708L8.707 10l1.147 1.146a.5.5 0 0 1-.708.708L8 10.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 10 6.146 8.854a.5.5 0 1 1 .708-.708L8 9.293Z"
                }
            }
        ]
    })(props);
}
function BsClipboardX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.146 7.146a.5.5 0 0 1 .708 0L8 8.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 9l1.147 1.146a.5.5 0 0 1-.708.708L8 9.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 9 6.146 7.854a.5.5 0 0 1 0-.708z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"
                }
            }
        ]
    })(props);
}
function BsClipboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"
                }
            }
        ]
    })(props);
}
function BsClipboard2CheckFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 .5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5.5.5 0 0 1-.5.5.5.5 0 0 0-.5.5V2a.5.5 0 0 0 .5.5h5A.5.5 0 0 0 11 2v-.5a.5.5 0 0 0-.5-.5.5.5 0 0 1-.5-.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.085 1H3.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1h-.585c.055.156.085.325.085.5V2a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 2v-.5c0-.175.03-.344.085-.5Zm6.769 6.854-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708.708Z"
                }
            }
        ]
    })(props);
}
function BsClipboard2Check(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 0a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5.5.5 0 0 1 .5.5V2a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 2v-.5a.5.5 0 0 1 .5-.5.5.5 0 0 0 .5-.5.5.5 0 0 1 .5-.5h3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 0 0-1h-.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1H12a.5.5 0 0 0 0 1h.5a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-12Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.854 7.854a.5.5 0 0 0-.708-.708L7.5 9.793 6.354 8.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3Z"
                }
            }
        ]
    })(props);
}
function BsClipboard2DataFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 .5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5.5.5 0 0 1-.5.5.5.5 0 0 0-.5.5V2a.5.5 0 0 0 .5.5h5A.5.5 0 0 0 11 2v-.5a.5.5 0 0 0-.5-.5.5.5 0 0 1-.5-.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.085 1H3.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1h-.585c.055.156.085.325.085.5V2a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 2v-.5c0-.175.03-.344.085-.5ZM10 7a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0V7Zm-6 4a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0v-1Zm4-3a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1Z"
                }
            }
        ]
    })(props);
}
function BsClipboard2Data(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 0a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5.5.5 0 0 1 .5.5V2a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 2v-.5a.5.5 0 0 1 .5-.5.5.5 0 0 0 .5-.5.5.5 0 0 1 .5-.5h3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 0 0-1h-.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1H12a.5.5 0 0 0 0 1h.5a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-12Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 7a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0V7Zm-6 4a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0v-1Zm4-3a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1Z"
                }
            }
        ]
    })(props);
}
function BsClipboard2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 0a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5.5.5 0 0 1 .5.5V2a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 2v-.5a.5.5 0 0 1 .5-.5.5.5 0 0 0 .5-.5.5.5 0 0 1 .5-.5h3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 1h.585A1.498 1.498 0 0 0 4 1.5V2a1.5 1.5 0 0 0 1.5 1.5h5A1.5 1.5 0 0 0 12 2v-.5c0-.175-.03-.344-.085-.5h.585A1.5 1.5 0 0 1 14 2.5v12a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-12A1.5 1.5 0 0 1 3.5 1Z"
                }
            }
        ]
    })(props);
}
function BsClipboard2HeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.058.501a.501.501 0 0 0-.5-.501h-2.98c-.276 0-.5.225-.5.501A.499.499 0 0 1 5.582 1a.497.497 0 0 0-.497.497V2a.5.5 0 0 0 .5.5h4.968a.5.5 0 0 0 .5-.5v-.503A.497.497 0 0 0 10.555 1a.499.499 0 0 1-.497-.499Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.174 1h-.57a1.5 1.5 0 0 0-1.5 1.5v12a1.5 1.5 0 0 0 1.5 1.5h9a1.5 1.5 0 0 0 1.5-1.5v-12a1.5 1.5 0 0 0-1.5-1.5h-.642c.055.156.085.325.085.5V2c0 .828-.668 1.5-1.492 1.5H5.581A1.496 1.496 0 0 1 4.09 2v-.5c0-.175.03-.344.085-.5Zm3.894 5.482c1.656-1.673 5.795 1.254 0 5.018-5.795-3.764-1.656-6.69 0-5.018Z"
                }
            }
        ]
    })(props);
}
function BsClipboard2Heart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.058.501a.501.501 0 0 0-.5-.501h-2.98c-.276 0-.5.225-.5.501A.499.499 0 0 1 5.582 1a.497.497 0 0 0-.497.497V2a.5.5 0 0 0 .5.5h4.968a.5.5 0 0 0 .5-.5v-.503A.497.497 0 0 0 10.555 1a.499.499 0 0 1-.497-.499Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.605 2a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 1 0-1h.5a1.5 1.5 0 0 1 1.5 1.5v12a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5v-12a1.5 1.5 0 0 1 1.5-1.5h.5a.5.5 0 0 1 0 1h-.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.068 6.482c1.656-1.673 5.795 1.254 0 5.018-5.795-3.764-1.656-6.69 0-5.018Z"
                }
            }
        ]
    })(props);
}
function BsClipboard2MinusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 .5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5.5.5 0 0 1-.5.5.5.5 0 0 0-.5.5V2a.5.5 0 0 0 .5.5h5A.5.5 0 0 0 11 2v-.5a.5.5 0 0 0-.5-.5.5.5 0 0 1-.5-.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.085 1H3.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1h-.585c.055.156.085.325.085.5V2a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 2v-.5c0-.175.03-.344.085-.5ZM6 8h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1Z"
                }
            }
        ]
    })(props);
}
function BsClipboard2Minus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 0a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5.5.5 0 0 1 .5.5V2a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 2v-.5a.5.5 0 0 1 .5-.5.5.5 0 0 0 .5-.5.5.5 0 0 1 .5-.5h3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 0 0-1h-.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1H12a.5.5 0 0 0 0 1h.5a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-12Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H6Z"
                }
            }
        ]
    })(props);
}
function BsClipboard2PlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 .5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5.5.5 0 0 1-.5.5.5.5 0 0 0-.5.5V2a.5.5 0 0 0 .5.5h5A.5.5 0 0 0 11 2v-.5a.5.5 0 0 0-.5-.5.5.5 0 0 1-.5-.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.085 1H3.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1h-.585c.055.156.085.325.085.5V2a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 2v-.5c0-.175.03-.344.085-.5ZM8.5 6.5V8H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V9H6a.5.5 0 0 1 0-1h1.5V6.5a.5.5 0 0 1 1 0Z"
                }
            }
        ]
    })(props);
}
function BsClipboard2Plus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 0a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5.5.5 0 0 1 .5.5V2a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 2v-.5a.5.5 0 0 1 .5-.5.5.5 0 0 0 .5-.5.5.5 0 0 1 .5-.5h3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 0 0-1h-.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1H12a.5.5 0 0 0 0 1h.5a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-12Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 6.5a.5.5 0 0 0-1 0V8H6a.5.5 0 0 0 0 1h1.5v1.5a.5.5 0 0 0 1 0V9H10a.5.5 0 0 0 0-1H8.5V6.5Z"
                }
            }
        ]
    })(props);
}
function BsClipboard2PulseFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 .5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5.5.5 0 0 1-.5.5.5.5 0 0 0-.5.5V2a.5.5 0 0 0 .5.5h5A.5.5 0 0 0 11 2v-.5a.5.5 0 0 0-.5-.5.5.5 0 0 1-.5-.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.085 1H3.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1h-.585c.055.156.085.325.085.5V2a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 2v-.5c0-.175.03-.344.085-.5ZM9.98 5.356 11.372 10h.128a.5.5 0 0 1 0 1H11a.5.5 0 0 1-.479-.356l-.94-3.135-1.092 5.096a.5.5 0 0 1-.968.039L6.383 8.85l-.936 1.873A.5.5 0 0 1 5 11h-.5a.5.5 0 0 1 0-1h.191l1.362-2.724a.5.5 0 0 1 .926.08l.94 3.135 1.092-5.096a.5.5 0 0 1 .968-.039Z"
                }
            }
        ]
    })(props);
}
function BsClipboard2Pulse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 0a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5.5.5 0 0 1 .5.5V2a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 2v-.5a.5.5 0 0 1 .5-.5.5.5 0 0 0 .5-.5.5.5 0 0 1 .5-.5h3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 0 0-1h-.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1H12a.5.5 0 0 0 0 1h.5a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-12Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.979 5.356a.5.5 0 0 0-.968.04L7.92 10.49l-.94-3.135a.5.5 0 0 0-.926-.08L4.69 10H4.5a.5.5 0 0 0 0 1H5a.5.5 0 0 0 .447-.276l.936-1.873 1.138 3.793a.5.5 0 0 0 .968-.04L9.58 7.51l.94 3.135A.5.5 0 0 0 11 11h.5a.5.5 0 0 0 0-1h-.128L9.979 5.356Z"
                }
            }
        ]
    })(props);
}
function BsClipboard2XFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 .5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5.5.5 0 0 1-.5.5.5.5 0 0 0-.5.5V2a.5.5 0 0 0 .5.5h5A.5.5 0 0 0 11 2v-.5a.5.5 0 0 0-.5-.5.5.5 0 0 1-.5-.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.085 1H3.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1h-.585c.055.156.085.325.085.5V2a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 2v-.5c0-.175.03-.344.085-.5ZM8 8.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 9l1.147 1.146a.5.5 0 0 1-.708.708L8 9.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 9 6.146 7.854a.5.5 0 1 1 .708-.708L8 8.293Z"
                }
            }
        ]
    })(props);
}
function BsClipboard2X(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 0a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5.5.5 0 0 1 .5.5V2a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 2v-.5a.5.5 0 0 1 .5-.5.5.5 0 0 0 .5-.5.5.5 0 0 1 .5-.5h3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 0 0-1h-.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1H12a.5.5 0 0 0 0 1h.5a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-12Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8.293 6.854 7.146a.5.5 0 1 0-.708.708L7.293 9l-1.147 1.146a.5.5 0 0 0 .708.708L8 9.707l1.146 1.147a.5.5 0 0 0 .708-.708L8.707 9l1.147-1.146a.5.5 0 0 0-.708-.708L8 8.293Z"
                }
            }
        ]
    })(props);
}
function BsClipboard2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 2a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5H12a.5.5 0 0 1 0-1h.5A1.5 1.5 0 0 1 14 2.5v12a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-12A1.5 1.5 0 0 1 3.5 1H4a.5.5 0 0 1 0 1h-.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 .5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5.5.5 0 0 1-.5.5.5.5 0 0 0-.5.5V2a.5.5 0 0 0 .5.5h5A.5.5 0 0 0 11 2v-.5a.5.5 0 0 0-.5-.5.5.5 0 0 1-.5-.5Z"
                }
            }
        ]
    })(props);
}
function BsClockFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"
                }
            }
        ]
    })(props);
}
function BsClockHistory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022l-.074.997zm2.004.45a7.003 7.003 0 0 0-.985-.299l.219-.976c.383.086.76.2 1.126.342l-.36.933zm1.37.71a7.01 7.01 0 0 0-.439-.27l.493-.87a8.025 8.025 0 0 1 .979.654l-.615.789a6.996 6.996 0 0 0-.418-.302zm1.834 1.79a6.99 6.99 0 0 0-.653-.796l.724-.69c.27.285.52.59.747.91l-.818.576zm.744 1.352a7.08 7.08 0 0 0-.214-.468l.893-.45a7.976 7.976 0 0 1 .45 1.088l-.95.313a7.023 7.023 0 0 0-.179-.483zm.53 2.507a6.991 6.991 0 0 0-.1-1.025l.985-.17c.067.386.106.778.116 1.17l-1 .025zm-.131 1.538c.033-.17.06-.339.081-.51l.993.123a7.957 7.957 0 0 1-.23 1.155l-.964-.267c.046-.165.086-.332.12-.501zm-.952 2.379c.184-.29.346-.594.486-.908l.914.405c-.16.36-.345.706-.555 1.038l-.845-.535zm-.964 1.205c.122-.122.239-.248.35-.378l.758.653a8.073 8.073 0 0 1-.401.432l-.707-.707z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0v1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsClock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"
                }
            }
        ]
    })(props);
}
function BsCloudArrowDownFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2zm2.354 6.854-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5a.5.5 0 0 1 1 0v3.793l1.146-1.147a.5.5 0 0 1 .708.708z"
                }
            }
        ]
    })(props);
}
function BsCloudArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708l2 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z"
                }
            }
        ]
    })(props);
}
function BsCloudArrowUpFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2zm2.354 5.146a.5.5 0 0 1-.708.708L8.5 6.707V10.5a.5.5 0 0 1-1 0V6.707L6.354 7.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2z"
                }
            }
        ]
    })(props);
}
function BsCloudArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.646 5.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 6.707V10.5a.5.5 0 0 1-1 0V6.707L6.354 7.854a.5.5 0 1 1-.708-.708l2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z"
                }
            }
        ]
    })(props);
}
function BsCloudCheckFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2zm2.354 4.854-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708.708z"
                }
            }
        ]
    })(props);
}
function BsCloudCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.354 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z"
                }
            }
        ]
    })(props);
}
function BsCloudDownloadFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 0a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 4.095 0 5.555 0 7.318 0 9.366 1.708 11 3.781 11H7.5V5.5a.5.5 0 0 1 1 0V11h4.188C14.502 11 16 9.57 16 7.773c0-1.636-1.242-2.969-2.834-3.194C12.923 1.999 10.69 0 8 0zm-.354 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V11h-1v3.293l-2.146-2.147a.5.5 0 0 0-.708.708l3 3z"
                }
            }
        ]
    })(props);
}
function BsCloudDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708l3 3z"
                }
            }
        ]
    })(props);
}
function BsCloudDrizzleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.158 12.025a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 0 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm6 0a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 0 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm-3.5 1.5a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 0 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm6 0a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm.747-8.498a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 11H13a3 3 0 0 0 .405-5.973z"
                }
            }
        ]
    })(props);
}
function BsCloudDrizzle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.158 12.025a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 0 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm6 0a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 0 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm-3.5 1.5a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 0 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm6 0a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm.747-8.498a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 11H13a3 3 0 0 0 .405-5.973zM8.5 2a4 4 0 0 1 3.976 3.555.5.5 0 0 0 .5.445H13a2 2 0 0 1 0 4H3.5a2.5 2.5 0 1 1 .605-4.926.5.5 0 0 0 .596-.329A4.002 4.002 0 0 1 8.5 2z"
                }
            }
        ]
    })(props);
}
function BsCloudFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"
                }
            }
        ]
    })(props);
}
function BsCloudFogFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm10.405-9.473a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 12H13a3 3 0 0 0 .405-5.973z"
                }
            }
        ]
    })(props);
}
function BsCloudFog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm10.405-9.473a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 12H13a3 3 0 0 0 .405-5.973zM8.5 3a4 4 0 0 1 3.976 3.555.5.5 0 0 0 .5.445H13a2 2 0 0 1 0 4H3.5a2.5 2.5 0 1 1 .605-4.926.5.5 0 0 0 .596-.329A4.002 4.002 0 0 1 8.5 3z"
                }
            }
        ]
    })(props);
}
function BsCloudFog2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 3a5.001 5.001 0 0 1 4.905 4.027A3 3 0 0 1 13 13h-1.5a.5.5 0 0 0 0-1H1.05a3.51 3.51 0 0 1-.713-1H9.5a.5.5 0 0 0 0-1H.035a3.53 3.53 0 0 1 0-1H7.5a.5.5 0 0 0 0-1H.337a3.5 3.5 0 0 1 3.57-1.977A5.001 5.001 0 0 1 8.5 3z"
                }
            }
        ]
    })(props);
}
function BsCloudFog2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 4a4.002 4.002 0 0 0-3.8 2.745.5.5 0 1 1-.949-.313 5.002 5.002 0 0 1 9.654.595A3 3 0 0 1 13 13H.5a.5.5 0 0 1 0-1H13a2 2 0 0 0 .001-4h-.026a.5.5 0 0 1-.5-.445A4 4 0 0 0 8.5 4zM0 8.5A.5.5 0 0 1 .5 8h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsCloudHailFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.75 15.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm.408-3.724a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zM7.75 15.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm.408-3.724a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zm3.592 3.724a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm.408-3.724a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zm1.247-6.999a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10.5H13a3 3 0 0 0 .405-5.973z"
                }
            }
        ]
    })(props);
}
function BsCloudHail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.405 4.527a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10.5H13a3 3 0 0 0 .405-5.973zM8.5 1.5a4 4 0 0 1 3.976 3.555.5.5 0 0 0 .5.445H13a2 2 0 0 1-.001 4H3.5a2.5 2.5 0 1 1 .605-4.926.5.5 0 0 0 .596-.329A4.002 4.002 0 0 1 8.5 1.5zM3.75 15.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm.408-3.724a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zM7.75 15.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm.408-3.724a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zm3.592 3.724a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm.408-3.724a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316z"
                }
            }
        ]
    })(props);
}
function BsCloudHazeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-3 2a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm2 2a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM13.405 4.027a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10H13a3 3 0 0 0 .405-5.973z"
                }
            }
        ]
    })(props);
}
function BsCloudHaze(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-3 2a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm2 2a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM13.405 4.027a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10H13a3 3 0 0 0 .405-5.973zM8.5 1a4 4 0 0 1 3.976 3.555.5.5 0 0 0 .5.445H13a2 2 0 0 1 0 4H3.5a2.5 2.5 0 1 1 .605-4.926.5.5 0 0 0 .596-.329A4.002 4.002 0 0 1 8.5 1z"
                }
            }
        ]
    })(props);
}
function BsCloudHaze2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 2a5.001 5.001 0 0 1 4.905 4.027A3 3 0 0 1 13 12H3.5A3.5 3.5 0 0 1 .035 9H5.5a.5.5 0 0 0 0-1H.035a3.5 3.5 0 0 1 3.871-2.977A5.001 5.001 0 0 1 8.5 2zm-6 8a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zM0 13.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsCloudHaze2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 3a4.002 4.002 0 0 0-3.8 2.745.5.5 0 1 1-.949-.313 5.002 5.002 0 0 1 9.654.595A3 3 0 0 1 13 12H4.5a.5.5 0 0 1 0-1H13a2 2 0 0 0 .001-4h-.026a.5.5 0 0 1-.5-.445A4 4 0 0 0 8.5 3zM0 7.5A.5.5 0 0 1 .5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm2 2a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-2 4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsCloudLightningFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.053 11.276A.5.5 0 0 1 7.5 11h1a.5.5 0 0 1 .474.658l-.28.842H9.5a.5.5 0 0 1 .39.812l-2 2.5a.5.5 0 0 1-.875-.433L7.36 14H6.5a.5.5 0 0 1-.447-.724l1-2zm6.352-7.249a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10H13a3 3 0 0 0 .405-5.973z"
                }
            }
        ]
    })(props);
}
function BsCloudLightningRainFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.658 11.026a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zm9.5 0a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 0 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zm-7.5 1.5a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zm9.5 0a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 0 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zm-7.105-1.25A.5.5 0 0 1 7.5 11h1a.5.5 0 0 1 .474.658l-.28.842H9.5a.5.5 0 0 1 .39.812l-2 2.5a.5.5 0 0 1-.875-.433L7.36 14H6.5a.5.5 0 0 1-.447-.724l1-2zm6.352-7.249a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10H13a3 3 0 0 0 .405-5.973z"
                }
            }
        ]
    })(props);
}
function BsCloudLightningRain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.658 11.026a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zm9.5 0a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zm-7.5 1.5a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zm9.5 0a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zm-.753-8.499a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10H13a3 3 0 0 0 .405-5.973zM8.5 1a4 4 0 0 1 3.976 3.555.5.5 0 0 0 .5.445H13a2 2 0 0 1 0 4H3.5a2.5 2.5 0 1 1 .605-4.926.5.5 0 0 0 .596-.329A4.002 4.002 0 0 1 8.5 1zM7.053 11.276A.5.5 0 0 1 7.5 11h1a.5.5 0 0 1 .474.658l-.28.842H9.5a.5.5 0 0 1 .39.812l-2 2.5a.5.5 0 0 1-.875-.433L7.36 14H6.5a.5.5 0 0 1-.447-.724l1-2z"
                }
            }
        ]
    })(props);
}
function BsCloudLightning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.405 4.027a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10H13a3 3 0 0 0 .405-5.973zM8.5 1a4 4 0 0 1 3.976 3.555.5.5 0 0 0 .5.445H13a2 2 0 0 1 0 4H3.5a2.5 2.5 0 1 1 .605-4.926.5.5 0 0 0 .596-.329A4.002 4.002 0 0 1 8.5 1zM7.053 11.276A.5.5 0 0 1 7.5 11h1a.5.5 0 0 1 .474.658l-.28.842H9.5a.5.5 0 0 1 .39.812l-2 2.5a.5.5 0 0 1-.875-.433L7.36 14H6.5a.5.5 0 0 1-.447-.724l1-2z"
                }
            }
        ]
    })(props);
}
function BsCloudMinusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2zM6 7.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsCloudMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H6z"
                }
            }
        ]
    })(props);
}
function BsCloudMoonFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.473 11a4.5 4.5 0 0 0-8.72-.99A3 3 0 0 0 3 16h8.5a2.5 2.5 0 0 0 0-5h-.027z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.286 1.778a.5.5 0 0 0-.565-.755 4.595 4.595 0 0 0-3.18 5.003 5.46 5.46 0 0 1 1.055.209A3.603 3.603 0 0 1 9.83 2.617a4.593 4.593 0 0 0 4.31 5.744 3.576 3.576 0 0 1-2.241.634c.162.317.295.652.394 1a4.59 4.59 0 0 0 3.624-2.04.5.5 0 0 0-.565-.755 3.593 3.593 0 0 1-4.065-5.422z"
                }
            }
        ]
    })(props);
}
function BsCloudMoon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 8a3.5 3.5 0 0 1 3.5 3.555.5.5 0 0 0 .625.492A1.503 1.503 0 0 1 13 13.5a1.5 1.5 0 0 1-1.5 1.5H3a2 2 0 1 1 .1-3.998.5.5 0 0 0 .509-.375A3.502 3.502 0 0 1 7 8zm4.473 3a4.5 4.5 0 0 0-8.72-.99A3 3 0 0 0 3 16h8.5a2.5 2.5 0 0 0 0-5h-.027z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.286 1.778a.5.5 0 0 0-.565-.755 4.595 4.595 0 0 0-3.18 5.003 5.46 5.46 0 0 1 1.055.209A3.603 3.603 0 0 1 9.83 2.617a4.593 4.593 0 0 0 4.31 5.744 3.576 3.576 0 0 1-2.241.634c.162.317.295.652.394 1a4.59 4.59 0 0 0 3.624-2.04.5.5 0 0 0-.565-.755 3.593 3.593 0 0 1-4.065-5.422z"
                }
            }
        ]
    })(props);
}
function BsCloudPlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2zm.5 4v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsCloudPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 5.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 .5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z"
                }
            }
        ]
    })(props);
}
function BsCloudRainFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.158 12.025a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm3 0a.5.5 0 0 1 .316.633l-1 3a.5.5 0 1 1-.948-.316l1-3a.5.5 0 0 1 .632-.317zm3 0a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm3 0a.5.5 0 0 1 .316.633l-1 3a.5.5 0 1 1-.948-.316l1-3a.5.5 0 0 1 .632-.317zm.247-6.998a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 11H13a3 3 0 0 0 .405-5.973z"
                }
            }
        ]
    })(props);
}
function BsCloudRainHeavyFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.176 11.032a.5.5 0 0 1 .292.643l-1.5 4a.5.5 0 0 1-.936-.35l1.5-4a.5.5 0 0 1 .644-.293zm3 0a.5.5 0 0 1 .292.643l-1.5 4a.5.5 0 0 1-.936-.35l1.5-4a.5.5 0 0 1 .644-.293zm3 0a.5.5 0 0 1 .292.643l-1.5 4a.5.5 0 0 1-.936-.35l1.5-4a.5.5 0 0 1 .644-.293zm3 0a.5.5 0 0 1 .292.643l-1.5 4a.5.5 0 0 1-.936-.35l1.5-4a.5.5 0 0 1 .644-.293zm.229-7.005a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10H13a3 3 0 0 0 .405-5.973z"
                }
            }
        ]
    })(props);
}
function BsCloudRainHeavy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.176 11.032a.5.5 0 0 1 .292.643l-1.5 4a.5.5 0 1 1-.936-.35l1.5-4a.5.5 0 0 1 .644-.293zm3 0a.5.5 0 0 1 .292.643l-1.5 4a.5.5 0 1 1-.936-.35l1.5-4a.5.5 0 0 1 .644-.293zm3 0a.5.5 0 0 1 .292.643l-1.5 4a.5.5 0 1 1-.936-.35l1.5-4a.5.5 0 0 1 .644-.293zm3 0a.5.5 0 0 1 .292.643l-1.5 4a.5.5 0 0 1-.936-.35l1.5-4a.5.5 0 0 1 .644-.293zm.229-7.005a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10H13a3 3 0 0 0 .405-5.973zM8.5 1a4 4 0 0 1 3.976 3.555.5.5 0 0 0 .5.445H13a2 2 0 0 1 0 4H3.5a2.5 2.5 0 1 1 .605-4.926.5.5 0 0 0 .596-.329A4.002 4.002 0 0 1 8.5 1z"
                }
            }
        ]
    })(props);
}
function BsCloudRain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.158 12.025a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 0 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm3 0a.5.5 0 0 1 .316.633l-1 3a.5.5 0 0 1-.948-.316l1-3a.5.5 0 0 1 .632-.317zm3 0a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 0 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm3 0a.5.5 0 0 1 .316.633l-1 3a.5.5 0 1 1-.948-.316l1-3a.5.5 0 0 1 .632-.317zm.247-6.998a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 11H13a3 3 0 0 0 .405-5.973zM8.5 2a4 4 0 0 1 3.976 3.555.5.5 0 0 0 .5.445H13a2 2 0 0 1 0 4H3.5a2.5 2.5 0 1 1 .605-4.926.5.5 0 0 0 .596-.329A4.002 4.002 0 0 1 8.5 2z"
                }
            }
        ]
    })(props);
}
function BsCloudSlashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.112 5.112a3.125 3.125 0 0 0-.17.613C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13H11L3.112 5.112zm11.372 7.372L4.937 2.937A5.512 5.512 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773a3.2 3.2 0 0 1-1.516 2.711zm-.838 1.87-12-12 .708-.708 12 12-.707.707z"
                }
            }
        ]
    })(props);
}
function BsCloudSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.112 5.112a3.125 3.125 0 0 0-.17.613C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13H11l-1-1H3.781C2.231 12 1 10.785 1 9.318c0-1.365 1.064-2.513 2.46-2.666l.446-.05v-.447c0-.075.006-.152.018-.231l-.812-.812zm2.55-1.45-.725-.725A5.512 5.512 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773a3.2 3.2 0 0 1-1.516 2.711l-.733-.733C14.498 11.378 15 10.626 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3c-.875 0-1.678.26-2.339.661z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13.646 14.354-12-12 .708-.708 12 12-.707.707z"
                }
            }
        ]
    })(props);
}
function BsCloudSleetFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.375 13.5a.25.25 0 0 1 .25.25v.57l.501-.287a.25.25 0 0 1 .248.434l-.495.283.495.283a.25.25 0 1 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 1 1-.248-.434l.495-.283-.495-.283a.25.25 0 1 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm1.849-2.447a.5.5 0 0 1 .223.67l-.5 1a.5.5 0 0 1-.894-.447l.5-1a.5.5 0 0 1 .67-.223zM6.375 13.5a.25.25 0 0 1 .25.25v.57l.5-.287a.25.25 0 0 1 .249.434l-.495.283.495.283a.25.25 0 1 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 1 1-.248-.434l.495-.283-.495-.283a.25.25 0 1 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm1.849-2.447a.5.5 0 0 1 .223.67l-.5 1a.5.5 0 0 1-.894-.447l.5-1a.5.5 0 0 1 .67-.223zm2.151 2.447a.25.25 0 0 1 .25.25v.57l.5-.287a.25.25 0 0 1 .249.434l-.495.283.495.283a.25.25 0 1 1-.248.434l-.501-.286v.569a.25.25 0 0 1-.5 0v-.57l-.501.287a.25.25 0 1 1-.248-.434l.495-.283-.495-.283a.25.25 0 1 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm1.849-2.447a.5.5 0 0 1 .223.67l-.5 1a.5.5 0 1 1-.894-.447l.5-1a.5.5 0 0 1 .67-.223zm1.181-7.026a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10H13a3 3 0 0 0 .405-5.973z"
                }
            }
        ]
    })(props);
}
function BsCloudSleet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.405 4.027a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10H13a3 3 0 0 0 .405-5.973zM8.5 1a4 4 0 0 1 3.976 3.555.5.5 0 0 0 .5.445H13a2 2 0 0 1 0 4H3.5a2.5 2.5 0 1 1 .605-4.926.5.5 0 0 0 .596-.329A4.002 4.002 0 0 1 8.5 1zM2.375 13.5a.25.25 0 0 1 .25.25v.57l.501-.287a.25.25 0 0 1 .248.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 0 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm1.849-2.447a.5.5 0 0 1 .223.67l-.5 1a.5.5 0 1 1-.894-.447l.5-1a.5.5 0 0 1 .67-.223zM6.375 13.5a.25.25 0 0 1 .25.25v.57l.501-.287a.25.25 0 0 1 .248.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 0 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm1.849-2.447a.5.5 0 0 1 .223.67l-.5 1a.5.5 0 1 1-.894-.447l.5-1a.5.5 0 0 1 .67-.223zm2.151 2.447a.25.25 0 0 1 .25.25v.57l.501-.287a.25.25 0 0 1 .248.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 0 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm1.849-2.447a.5.5 0 0 1 .223.67l-.5 1a.5.5 0 1 1-.894-.447l.5-1a.5.5 0 0 1 .67-.223z"
                }
            }
        ]
    })(props);
}
function BsCloudSnowFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.625 11.5a.25.25 0 0 1 .25.25v.57l.501-.287a.25.25 0 0 1 .248.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 0 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm2.75 2a.25.25 0 0 1 .25.25v.57l.5-.287a.25.25 0 0 1 .249.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 0 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm5.5 0a.25.25 0 0 1 .25.25v.57l.5-.287a.25.25 0 0 1 .249.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 0 1-.5 0v-.57l-.501.287a.25.25 0 0 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm-2.75-2a.25.25 0 0 1 .25.25v.57l.5-.287a.25.25 0 0 1 .249.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 0 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm5.5 0a.25.25 0 0 1 .25.25v.57l.5-.287a.25.25 0 0 1 .249.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 0 1-.5 0v-.57l-.501.287a.25.25 0 1 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm-.22-7.223a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10.25H13a3 3 0 0 0 .405-5.973z"
                }
            }
        ]
    })(props);
}
function BsCloudSnow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.405 4.277a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10.25H13a3 3 0 0 0 .405-5.973zM8.5 1.25a4 4 0 0 1 3.976 3.555.5.5 0 0 0 .5.445H13a2 2 0 0 1-.001 4H3.5a2.5 2.5 0 1 1 .605-4.926.5.5 0 0 0 .596-.329A4.002 4.002 0 0 1 8.5 1.25zM2.625 11.5a.25.25 0 0 1 .25.25v.57l.501-.287a.25.25 0 0 1 .248.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 0 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm2.75 2a.25.25 0 0 1 .25.25v.57l.501-.287a.25.25 0 0 1 .248.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 0 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm5.5 0a.25.25 0 0 1 .25.25v.57l.501-.287a.25.25 0 0 1 .248.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 0 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm-2.75-2a.25.25 0 0 1 .25.25v.57l.501-.287a.25.25 0 0 1 .248.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 0 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm5.5 0a.25.25 0 0 1 .25.25v.57l.501-.287a.25.25 0 0 1 .248.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 0 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25z"
                }
            }
        ]
    })(props);
}
function BsCloudSunFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.473 11a4.5 4.5 0 0 0-8.72-.99A3 3 0 0 0 3 16h8.5a2.5 2.5 0 0 0 0-5h-.027z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 1.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0v-1zm3.743 1.964a.5.5 0 1 0-.707-.707l-.708.707a.5.5 0 0 0 .708.708l.707-.708zm-7.779-.707a.5.5 0 0 0-.707.707l.707.708a.5.5 0 1 0 .708-.708l-.708-.707zm1.734 3.374a2 2 0 1 1 3.296 2.198c.199.281.372.582.516.898a3 3 0 1 0-4.84-3.225c.352.011.696.055 1.028.129zm4.484 4.074c.6.215 1.125.59 1.522 1.072a.5.5 0 0 0 .039-.742l-.707-.707a.5.5 0 0 0-.854.377zM14.5 6.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z"
                }
            }
        ]
    })(props);
}
function BsCloudSun(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 8a3.5 3.5 0 0 1 3.5 3.555.5.5 0 0 0 .624.492A1.503 1.503 0 0 1 13 13.5a1.5 1.5 0 0 1-1.5 1.5H3a2 2 0 1 1 .1-3.998.5.5 0 0 0 .51-.375A3.502 3.502 0 0 1 7 8zm4.473 3a4.5 4.5 0 0 0-8.72-.99A3 3 0 0 0 3 16h8.5a2.5 2.5 0 0 0 0-5h-.027z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 1.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0v-1zm3.743 1.964a.5.5 0 1 0-.707-.707l-.708.707a.5.5 0 0 0 .708.708l.707-.708zm-7.779-.707a.5.5 0 0 0-.707.707l.707.708a.5.5 0 1 0 .708-.708l-.708-.707zm1.734 3.374a2 2 0 1 1 3.296 2.198c.199.281.372.582.516.898a3 3 0 1 0-4.84-3.225c.352.011.696.055 1.028.129zm4.484 4.074c.6.215 1.125.59 1.522 1.072a.5.5 0 0 0 .039-.742l-.707-.707a.5.5 0 0 0-.854.377zM14.5 6.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z"
                }
            }
        ]
    })(props);
}
function BsCloudUploadFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 0a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 4.095 0 5.555 0 7.318 0 9.366 1.708 11 3.781 11H7.5V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11h4.188C14.502 11 16 9.57 16 7.773c0-1.636-1.242-2.969-2.834-3.194C12.923 1.999 10.69 0 8 0zm-.5 14.5V11h1v3.5a.5.5 0 0 1-1 0z"
                }
            }
        ]
    })(props);
}
function BsCloudUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3z"
                }
            }
        ]
    })(props);
}
function BsCloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z"
                }
            }
        ]
    })(props);
}
function BsCloudsFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.473 9a4.5 4.5 0 0 0-8.72-.99A3 3 0 0 0 3 14h8.5a2.5 2.5 0 1 0-.027-5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.544 9.772a3.506 3.506 0 0 0-2.225-1.676 5.502 5.502 0 0 0-6.337-4.002 4.002 4.002 0 0 1 7.392.91 2.5 2.5 0 0 1 1.17 4.769z"
                }
            }
        ]
    })(props);
}
function BsClouds(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7.5a2.5 2.5 0 0 1-1.456 2.272 3.513 3.513 0 0 0-.65-.824 1.5 1.5 0 0 0-.789-2.896.5.5 0 0 1-.627-.421 3 3 0 0 0-5.22-1.625 5.587 5.587 0 0 0-1.276.088 4.002 4.002 0 0 1 7.392.91A2.5 2.5 0 0 1 16 7.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5a4.5 4.5 0 0 1 4.473 4h.027a2.5 2.5 0 0 1 0 5H3a3 3 0 0 1-.247-5.99A4.502 4.502 0 0 1 7 5zm3.5 4.5a3.5 3.5 0 0 0-6.89-.873.5.5 0 0 1-.51.375A2 2 0 1 0 3 13h8.5a1.5 1.5 0 1 0-.376-2.953.5.5 0 0 1-.624-.492V9.5z"
                }
            }
        ]
    })(props);
}
function BsCloudyFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.405 7.027a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 13H13a3 3 0 0 0 .405-5.973z"
                }
            }
        ]
    })(props);
}
function BsCloudy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.405 8.527a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 14.5H13a3 3 0 0 0 .405-5.973zM8.5 5.5a4 4 0 0 1 3.976 3.555.5.5 0 0 0 .5.445H13a2 2 0 0 1-.001 4H3.5a2.5 2.5 0 1 1 .605-4.926.5.5 0 0 0 .596-.329A4.002 4.002 0 0 1 8.5 5.5z"
                }
            }
        ]
    })(props);
}
function BsCodeSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.478 1.647a.5.5 0 1 0-.956-.294l-4 13a.5.5 0 0 0 .956.294l4-13zM4.854 4.146a.5.5 0 0 1 0 .708L1.707 8l3.147 3.146a.5.5 0 0 1-.708.708l-3.5-3.5a.5.5 0 0 1 0-.708l3.5-3.5a.5.5 0 0 1 .708 0zm6.292 0a.5.5 0 0 0 0 .708L14.293 8l-3.147 3.146a.5.5 0 0 0 .708.708l3.5-3.5a.5.5 0 0 0 0-.708l-3.5-3.5a.5.5 0 0 0-.708 0z"
                }
            }
        ]
    })(props);
}
function BsCodeSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.854 4.646a.5.5 0 0 1 0 .708L4.207 8l2.647 2.646a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 0 1 .708 0zm2.292 0a.5.5 0 0 0 0 .708L11.793 8l-2.647 2.646a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708 0z"
                }
            }
        ]
    })(props);
}
function BsCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.854 4.854a.5.5 0 1 0-.708-.708l-3.5 3.5a.5.5 0 0 0 0 .708l3.5 3.5a.5.5 0 0 0 .708-.708L2.707 8l3.147-3.146zm4.292 0a.5.5 0 0 1 .708-.708l3.5 3.5a.5.5 0 0 1 0 .708l-3.5 3.5a.5.5 0 0 1-.708-.708L13.293 8l-3.147-3.146z"
                }
            }
        ]
    })(props);
}
function BsCoin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 9.511c.076.954.83 1.697 2.182 1.785V12h.6v-.709c1.4-.098 2.218-.846 2.218-1.932 0-.987-.626-1.496-1.745-1.76l-.473-.112V5.57c.6.068.982.396 1.074.85h1.052c-.076-.919-.864-1.638-2.126-1.716V4h-.6v.719c-1.195.117-2.01.836-2.01 1.853 0 .9.606 1.472 1.613 1.707l.397.098v2.034c-.615-.093-1.022-.43-1.114-.9H5.5zm2.177-2.166c-.59-.137-.91-.416-.91-.836 0-.47.345-.822.915-.925v1.76h-.005zm.692 1.193c.717.166 1.048.435 1.048.91 0 .542-.412.914-1.135.982V8.518l.087.02z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13.5a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11zm0 .5A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"
                }
            }
        ]
    })(props);
}
function BsCollectionFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 13a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 16 13V6a1.5 1.5 0 0 0-1.5-1.5h-13A1.5 1.5 0 0 0 0 6v7zM2 3a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 0-1h-11A.5.5 0 0 0 2 3zm2-2a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7A.5.5 0 0 0 4 1z"
                }
            }
        ]
    })(props);
}
function BsCollectionPlayFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 3.5a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-11zm2-2a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1h-7zM0 13a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 16 13V6a1.5 1.5 0 0 0-1.5-1.5h-13A1.5 1.5 0 0 0 0 6v7zm6.258-6.437a.5.5 0 0 1 .507.013l4 2.5a.5.5 0 0 1 0 .848l-4 2.5A.5.5 0 0 1 6 12V7a.5.5 0 0 1 .258-.437z"
                }
            }
        ]
    })(props);
}
function BsCollectionPlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 0-1h-11A.5.5 0 0 0 2 3zm2-2a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7A.5.5 0 0 0 4 1zm2.765 5.576A.5.5 0 0 0 6 7v5a.5.5 0 0 0 .765.424l4-2.5a.5.5 0 0 0 0-.848l-4-2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 14.5A1.5 1.5 0 0 1 0 13V6a1.5 1.5 0 0 1 1.5-1.5h13A1.5 1.5 0 0 1 16 6v7a1.5 1.5 0 0 1-1.5 1.5h-13zm13-1a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.5-.5h-13A.5.5 0 0 0 1 6v7a.5.5 0 0 0 .5.5h13z"
                }
            }
        ]
    })(props);
}
function BsCollection(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 3.5a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-11zm2-2a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1h-7zM0 13a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 16 13V6a1.5 1.5 0 0 0-1.5-1.5h-13A1.5 1.5 0 0 0 0 6v7zm1.5.5A.5.5 0 0 1 1 13V6a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-13z"
                }
            }
        ]
    })(props);
}
function BsColumnsGap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 1v3H1V1h5zM1 0a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1zm14 12v3h-5v-3h5zm-5-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-5zM6 8v7H1V8h5zM1 7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H1zm14-6v7h-5V1h5zm-5-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1h-5z"
                }
            }
        ]
    })(props);
}
function BsColumns(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V2zm8.5 0v8H15V2H8.5zm0 9v3H15v-3H8.5zm-1-9H1v3h6.5V2zM1 14h6.5V6H1v8z"
                }
            }
        ]
    })(props);
}
function BsCommand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 2A1.5 1.5 0 0 1 5 3.5V5H3.5a1.5 1.5 0 1 1 0-3zM6 5V3.5A2.5 2.5 0 1 0 3.5 6H5v4H3.5A2.5 2.5 0 1 0 6 12.5V11h4v1.5a2.5 2.5 0 1 0 2.5-2.5H11V6h1.5A2.5 2.5 0 1 0 10 3.5V5H6zm4 1v4H6V6h4zm1-1V3.5A1.5 1.5 0 1 1 12.5 5H11zm0 6h1.5a1.5 1.5 0 1 1-1.5 1.5V11zm-6 0v1.5A1.5 1.5 0 1 1 3.5 11H5z"
                }
            }
        ]
    })(props);
}
function BsCompassFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 8.516a7.5 7.5 0 1 1-9.462-7.24A1 1 0 0 1 7 0h2a1 1 0 0 1 .962 1.276 7.503 7.503 0 0 1 5.538 7.24zm-3.61-3.905L6.94 7.439 4.11 12.39l4.95-2.828 2.828-4.95z"
                }
            }
        ]
    })(props);
}
function BsCompass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16.016a7.5 7.5 0 0 0 1.962-14.74A1 1 0 0 0 9 0H7a1 1 0 0 0-.962 1.276A7.5 7.5 0 0 0 8 16.016zm6.5-7.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6.94 7.44 4.95-2.83-2.83 4.95-4.949 2.83 2.828-4.95z"
                }
            }
        ]
    })(props);
}
function BsConeStriped(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m9.97 4.88.953 3.811C10.159 8.878 9.14 9 8 9c-1.14 0-2.158-.122-2.923-.309L6.03 4.88C6.635 4.957 7.3 5 8 5s1.365-.043 1.97-.12zm-.245-.978L8.97.88C8.718-.13 7.282-.13 7.03.88L6.275 3.9C6.8 3.965 7.382 4 8 4c.618 0 1.2-.036 1.725-.098zm4.396 8.613a.5.5 0 0 1 .037.96l-6 2a.5.5 0 0 1-.316 0l-6-2a.5.5 0 0 1 .037-.96l2.391-.598.565-2.257c.862.212 1.964.339 3.165.339s2.303-.127 3.165-.339l.565 2.257 2.391.598z"
                }
            }
        ]
    })(props);
}
function BsCone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.03 1.88c.252-1.01 1.688-1.01 1.94 0l2.905 11.62H14a.5.5 0 0 1 0 1H2a.5.5 0 0 1 0-1h2.125L7.03 1.88z"
                }
            }
        ]
    })(props);
}
function BsController(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 6.027a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-1.5 1.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm2.5-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-1.5 1.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm-6.5-3h1v1h1v1h-1v1h-1v-1h-1v-1h1v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.051 3.26a.5.5 0 0 1 .354-.613l1.932-.518a.5.5 0 0 1 .62.39c.655-.079 1.35-.117 2.043-.117.72 0 1.443.041 2.12.126a.5.5 0 0 1 .622-.399l1.932.518a.5.5 0 0 1 .306.729c.14.09.266.19.373.297.408.408.78 1.05 1.095 1.772.32.733.599 1.591.805 2.466.206.875.34 1.78.364 2.606.024.816-.059 1.602-.328 2.21a1.42 1.42 0 0 1-1.445.83c-.636-.067-1.115-.394-1.513-.773-.245-.232-.496-.526-.739-.808-.126-.148-.25-.292-.368-.423-.728-.804-1.597-1.527-3.224-1.527-1.627 0-2.496.723-3.224 1.527-.119.131-.242.275-.368.423-.243.282-.494.575-.739.808-.398.38-.877.706-1.513.773a1.42 1.42 0 0 1-1.445-.83c-.27-.608-.352-1.395-.329-2.21.024-.826.16-1.73.365-2.606.206-.875.486-1.733.805-2.466.315-.722.687-1.364 1.094-1.772a2.34 2.34 0 0 1 .433-.335.504.504 0 0 1-.028-.079zm2.036.412c-.877.185-1.469.443-1.733.708-.276.276-.587.783-.885 1.465a13.748 13.748 0 0 0-.748 2.295 12.351 12.351 0 0 0-.339 2.406c-.022.755.062 1.368.243 1.776a.42.42 0 0 0 .426.24c.327-.034.61-.199.929-.502.212-.202.4-.423.615-.674.133-.156.276-.323.44-.504C4.861 9.969 5.978 9.027 8 9.027s3.139.942 3.965 1.855c.164.181.307.348.44.504.214.251.403.472.615.674.318.303.601.468.929.503a.42.42 0 0 0 .426-.241c.18-.408.265-1.02.243-1.776a12.354 12.354 0 0 0-.339-2.406 13.753 13.753 0 0 0-.748-2.295c-.298-.682-.61-1.19-.885-1.465-.264-.265-.856-.523-1.733-.708-.85-.179-1.877-.27-2.913-.27-1.036 0-2.063.091-2.913.27z"
                }
            }
        ]
    })(props);
}
function BsCookie(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm4.5.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm-.5 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a7.963 7.963 0 0 0-4.075 1.114c-.162.067-.31.162-.437.28A8 8 0 1 0 8 0Zm3.25 14.201a1.5 1.5 0 0 0-2.13.71A7.014 7.014 0 0 1 8 15a6.967 6.967 0 0 1-3.845-1.15 1.5 1.5 0 1 0-2.005-2.005A6.967 6.967 0 0 1 1 8c0-1.953.8-3.719 2.09-4.989a1.5 1.5 0 1 0 2.469-1.574A6.985 6.985 0 0 1 8 1c1.42 0 2.742.423 3.845 1.15a1.5 1.5 0 1 0 2.005 2.005A6.967 6.967 0 0 1 15 8c0 .596-.074 1.174-.214 1.727a1.5 1.5 0 1 0-1.025 2.25 7.033 7.033 0 0 1-2.51 2.224Z"
                }
            }
        ]
    })(props);
}
function BsCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V2Zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H6ZM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1H2Z"
                }
            }
        ]
    })(props);
}
function BsCpuFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5.5a.5.5 0 0 0-1 0V2A2.5 2.5 0 0 0 2 4.5H.5a.5.5 0 0 0 0 1H2v1H.5a.5.5 0 0 0 0 1H2v1H.5a.5.5 0 0 0 0 1H2v1H.5a.5.5 0 0 0 0 1H2A2.5 2.5 0 0 0 4.5 14v1.5a.5.5 0 0 0 1 0V14h1v1.5a.5.5 0 0 0 1 0V14h1v1.5a.5.5 0 0 0 1 0V14h1v1.5a.5.5 0 0 0 1 0V14a2.5 2.5 0 0 0 2.5-2.5h1.5a.5.5 0 0 0 0-1H14v-1h1.5a.5.5 0 0 0 0-1H14v-1h1.5a.5.5 0 0 0 0-1H14v-1h1.5a.5.5 0 0 0 0-1H14A2.5 2.5 0 0 0 11.5 2V.5a.5.5 0 0 0-1 0V2h-1V.5a.5.5 0 0 0-1 0V2h-1V.5a.5.5 0 0 0-1 0V2h-1V.5zm1 4.5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5v-3A1.5 1.5 0 0 1 6.5 5z"
                }
            }
        ]
    })(props);
}
function BsCpu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 0a.5.5 0 0 1 .5.5V2h1V.5a.5.5 0 0 1 1 0V2h1V.5a.5.5 0 0 1 1 0V2h1V.5a.5.5 0 0 1 1 0V2A2.5 2.5 0 0 1 14 4.5h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14a2.5 2.5 0 0 1-2.5 2.5v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14A2.5 2.5 0 0 1 2 11.5H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2A2.5 2.5 0 0 1 4.5 2V.5A.5.5 0 0 1 5 0zm-.5 3A1.5 1.5 0 0 0 3 4.5v7A1.5 1.5 0 0 0 4.5 13h7a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 11.5 3h-7zM5 6.5A1.5 1.5 0 0 1 6.5 5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5v-3zM6.5 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3z"
                }
            }
        ]
    })(props);
}
function BsCreditCard2BackFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5H0V4zm11.5 1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-2zM0 11v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1H0z"
                }
            }
        ]
    })(props);
}
function BsCreditCard2Back(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm13 2v5H1V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zm-1 9H2a1 1 0 0 1-1-1v-1h14v1a1 1 0 0 1-1 1z"
                }
            }
        ]
    })(props);
}
function BsCreditCard2FrontFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2.5 1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-2zm0 3a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm3 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm3 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm3 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z"
                }
            }
        ]
    })(props);
}
function BsCreditCard2Front(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 5.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsCreditCardFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1H0V4zm0 3v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7H0zm3 2h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1z"
                }
            }
        ]
    })(props);
}
function BsCreditCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1H2zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1z"
                }
            }
        ]
    })(props);
}
function BsCrop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5.5A.5.5 0 0 1 4 1v13h13a.5.5 0 0 1 0 1h-2v2a.5.5 0 0 1-1 0v-2H3.5a.5.5 0 0 1-.5-.5V4H1a.5.5 0 0 1 0-1h2V1a.5.5 0 0 1 .5-.5zm2.5 3a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4H6.5a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsCrosshair(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5.5a.5.5 0 0 0-1 0v.518A7.001 7.001 0 0 0 1.018 7.5H.5a.5.5 0 0 0 0 1h.518A7.001 7.001 0 0 0 7.5 14.982v.518a.5.5 0 0 0 1 0v-.518A7.001 7.001 0 0 0 14.982 8.5h.518a.5.5 0 0 0 0-1h-.518A7.001 7.001 0 0 0 8.5 1.018V.5Zm-6.48 7A6.001 6.001 0 0 1 7.5 2.02v.48a.5.5 0 0 0 1 0v-.48a6.001 6.001 0 0 1 5.48 5.48h-.48a.5.5 0 0 0 0 1h.48a6.002 6.002 0 0 1-5.48 5.48v-.48a.5.5 0 0 0-1 0v.48A6.001 6.001 0 0 1 2.02 8.5h.48a.5.5 0 0 0 0-1h-.48ZM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
                }
            }
        ]
    })(props);
}
function BsCrosshair2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a.5.5 0 0 1 .5.5v.518A7.001 7.001 0 0 1 14.982 7.5h.518a.5.5 0 0 1 0 1h-.518A7.001 7.001 0 0 1 8.5 14.982v.518a.5.5 0 0 1-1 0v-.518A7.001 7.001 0 0 1 1.018 8.5H.5a.5.5 0 0 1 0-1h.518A7.001 7.001 0 0 1 7.5 1.018V.5A.5.5 0 0 1 8 0Zm-.5 2.02A6.001 6.001 0 0 0 2.02 7.5h1.005A5.002 5.002 0 0 1 7.5 3.025V2.02Zm1 1.005A5.002 5.002 0 0 1 12.975 7.5h1.005A6.001 6.001 0 0 0 8.5 2.02v1.005ZM12.975 8.5A5.002 5.002 0 0 1 8.5 12.975v1.005a6.002 6.002 0 0 0 5.48-5.48h-1.005ZM7.5 12.975A5.002 5.002 0 0 1 3.025 8.5H2.02a6.001 6.001 0 0 0 5.48 5.48v-1.005ZM10 8a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z"
                }
            }
        ]
    })(props);
}
function BsCupFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M.11 3.187A.5.5 0 0 1 .5 3h13a.5.5 0 0 1 .488.608l-.22.991a3.001 3.001 0 0 1-1.3 5.854l-.132.59A2.5 2.5 0 0 1 9.896 13H4.104a2.5 2.5 0 0 1-2.44-1.958L.012 3.608a.5.5 0 0 1 .098-.42Zm12.574 6.288a2 2 0 0 0 .866-3.899l-.866 3.9Z"
                }
            }
        ]
    })(props);
}
function BsCupHotFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M.5 6a.5.5 0 0 0-.488.608l1.652 7.434A2.5 2.5 0 0 0 4.104 16h5.792a2.5 2.5 0 0 0 2.44-1.958l.131-.59a3 3 0 0 0 1.3-5.854l.221-.99A.5.5 0 0 0 13.5 6H.5ZM13 12.5a2.01 2.01 0 0 1-.316-.025l.867-3.898A2.001 2.001 0 0 1 13 12.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m4.4.8-.003.004-.014.019a4.167 4.167 0 0 0-.204.31 2.327 2.327 0 0 0-.141.267c-.026.06-.034.092-.037.103v.004a.593.593 0 0 0 .091.248c.075.133.178.272.308.445l.01.012c.118.158.26.347.37.543.112.2.22.455.22.745 0 .188-.065.368-.119.494a3.31 3.31 0 0 1-.202.388 5.444 5.444 0 0 1-.253.382l-.018.025-.005.008-.002.002A.5.5 0 0 1 3.6 4.2l.003-.004.014-.019a4.149 4.149 0 0 0 .204-.31 2.06 2.06 0 0 0 .141-.267c.026-.06.034-.092.037-.103a.593.593 0 0 0-.09-.252A4.334 4.334 0 0 0 3.6 2.8l-.01-.012a5.099 5.099 0 0 1-.37-.543A1.53 1.53 0 0 1 3 1.5c0-.188.065-.368.119-.494.059-.138.134-.274.202-.388a5.446 5.446 0 0 1 .253-.382l.025-.035A.5.5 0 0 1 4.4.8Zm3 0-.003.004-.014.019a4.167 4.167 0 0 0-.204.31 2.327 2.327 0 0 0-.141.267c-.026.06-.034.092-.037.103v.004a.593.593 0 0 0 .091.248c.075.133.178.272.308.445l.01.012c.118.158.26.347.37.543.112.2.22.455.22.745 0 .188-.065.368-.119.494a3.31 3.31 0 0 1-.202.388 5.444 5.444 0 0 1-.253.382l-.018.025-.005.008-.002.002A.5.5 0 0 1 6.6 4.2l.003-.004.014-.019a4.149 4.149 0 0 0 .204-.31 2.06 2.06 0 0 0 .141-.267c.026-.06.034-.092.037-.103a.593.593 0 0 0-.09-.252A4.334 4.334 0 0 0 6.6 2.8l-.01-.012a5.099 5.099 0 0 1-.37-.543A1.53 1.53 0 0 1 6 1.5c0-.188.065-.368.119-.494.059-.138.134-.274.202-.388a5.446 5.446 0 0 1 .253-.382l.025-.035A.5.5 0 0 1 7.4.8Zm3 0-.003.004-.014.019a4.077 4.077 0 0 0-.204.31 2.337 2.337 0 0 0-.141.267c-.026.06-.034.092-.037.103v.004a.593.593 0 0 0 .091.248c.075.133.178.272.308.445l.01.012c.118.158.26.347.37.543.112.2.22.455.22.745 0 .188-.065.368-.119.494a3.198 3.198 0 0 1-.202.388 5.385 5.385 0 0 1-.252.382l-.019.025-.005.008-.002.002A.5.5 0 0 1 9.6 4.2l.003-.004.014-.019a4.149 4.149 0 0 0 .204-.31 2.06 2.06 0 0 0 .141-.267c.026-.06.034-.092.037-.103a.593.593 0 0 0-.09-.252A4.334 4.334 0 0 0 9.6 2.8l-.01-.012a5.099 5.099 0 0 1-.37-.543A1.53 1.53 0 0 1 9 1.5c0-.188.065-.368.119-.494.059-.138.134-.274.202-.388a5.446 5.446 0 0 1 .253-.382l.025-.035A.5.5 0 0 1 10.4.8Z"
                }
            }
        ]
    })(props);
}
function BsCupHot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M.5 6a.5.5 0 0 0-.488.608l1.652 7.434A2.5 2.5 0 0 0 4.104 16h5.792a2.5 2.5 0 0 0 2.44-1.958l.131-.59a3 3 0 0 0 1.3-5.854l.221-.99A.5.5 0 0 0 13.5 6H.5ZM13 12.5a2.01 2.01 0 0 1-.316-.025l.867-3.898A2.001 2.001 0 0 1 13 12.5ZM2.64 13.825 1.123 7h11.754l-1.517 6.825A1.5 1.5 0 0 1 9.896 15H4.104a1.5 1.5 0 0 1-1.464-1.175Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m4.4.8-.003.004-.014.019a4.167 4.167 0 0 0-.204.31 2.327 2.327 0 0 0-.141.267c-.026.06-.034.092-.037.103v.004a.593.593 0 0 0 .091.248c.075.133.178.272.308.445l.01.012c.118.158.26.347.37.543.112.2.22.455.22.745 0 .188-.065.368-.119.494a3.31 3.31 0 0 1-.202.388 5.444 5.444 0 0 1-.253.382l-.018.025-.005.008-.002.002A.5.5 0 0 1 3.6 4.2l.003-.004.014-.019a4.149 4.149 0 0 0 .204-.31 2.06 2.06 0 0 0 .141-.267c.026-.06.034-.092.037-.103a.593.593 0 0 0-.09-.252A4.334 4.334 0 0 0 3.6 2.8l-.01-.012a5.099 5.099 0 0 1-.37-.543A1.53 1.53 0 0 1 3 1.5c0-.188.065-.368.119-.494.059-.138.134-.274.202-.388a5.446 5.446 0 0 1 .253-.382l.025-.035A.5.5 0 0 1 4.4.8Zm3 0-.003.004-.014.019a4.167 4.167 0 0 0-.204.31 2.327 2.327 0 0 0-.141.267c-.026.06-.034.092-.037.103v.004a.593.593 0 0 0 .091.248c.075.133.178.272.308.445l.01.012c.118.158.26.347.37.543.112.2.22.455.22.745 0 .188-.065.368-.119.494a3.31 3.31 0 0 1-.202.388 5.444 5.444 0 0 1-.253.382l-.018.025-.005.008-.002.002A.5.5 0 0 1 6.6 4.2l.003-.004.014-.019a4.149 4.149 0 0 0 .204-.31 2.06 2.06 0 0 0 .141-.267c.026-.06.034-.092.037-.103a.593.593 0 0 0-.09-.252A4.334 4.334 0 0 0 6.6 2.8l-.01-.012a5.099 5.099 0 0 1-.37-.543A1.53 1.53 0 0 1 6 1.5c0-.188.065-.368.119-.494.059-.138.134-.274.202-.388a5.446 5.446 0 0 1 .253-.382l.025-.035A.5.5 0 0 1 7.4.8Zm3 0-.003.004-.014.019a4.077 4.077 0 0 0-.204.31 2.337 2.337 0 0 0-.141.267c-.026.06-.034.092-.037.103v.004a.593.593 0 0 0 .091.248c.075.133.178.272.308.445l.01.012c.118.158.26.347.37.543.112.2.22.455.22.745 0 .188-.065.368-.119.494a3.198 3.198 0 0 1-.202.388 5.385 5.385 0 0 1-.252.382l-.019.025-.005.008-.002.002A.5.5 0 0 1 9.6 4.2l.003-.004.014-.019a4.149 4.149 0 0 0 .204-.31 2.06 2.06 0 0 0 .141-.267c.026-.06.034-.092.037-.103a.593.593 0 0 0-.09-.252A4.334 4.334 0 0 0 9.6 2.8l-.01-.012a5.099 5.099 0 0 1-.37-.543A1.53 1.53 0 0 1 9 1.5c0-.188.065-.368.119-.494.059-.138.134-.274.202-.388a5.446 5.446 0 0 1 .253-.382l.025-.035A.5.5 0 0 1 10.4.8Z"
                }
            }
        ]
    })(props);
}
function BsCupStraw(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.902.334a.5.5 0 0 1-.28.65l-2.254.902-.4 1.927c.376.095.715.215.972.367.228.135.56.396.56.82 0 .046-.004.09-.011.132l-.962 9.068a1.28 1.28 0 0 1-.524.93c-.488.34-1.494.87-3.01.87-1.516 0-2.522-.53-3.01-.87a1.28 1.28 0 0 1-.524-.93L3.51 5.132A.78.78 0 0 1 3.5 5c0-.424.332-.685.56-.82.262-.154.607-.276.99-.372C5.824 3.614 6.867 3.5 8 3.5c.712 0 1.389.045 1.985.127l.464-2.215a.5.5 0 0 1 .303-.356l2.5-1a.5.5 0 0 1 .65.278zM9.768 4.607A13.991 13.991 0 0 0 8 4.5c-1.076 0-2.033.11-2.707.278A3.284 3.284 0 0 0 4.645 5c.146.073.362.15.648.222C5.967 5.39 6.924 5.5 8 5.5c.571 0 1.109-.03 1.588-.085l.18-.808zm.292 1.756C9.445 6.45 8.742 6.5 8 6.5c-1.133 0-2.176-.114-2.95-.308a5.514 5.514 0 0 1-.435-.127l.838 8.03c.013.121.06.186.102.215.357.249 1.168.69 2.438.69 1.27 0 2.081-.441 2.438-.69.042-.029.09-.094.102-.215l.852-8.03a5.517 5.517 0 0 1-.435.127 8.88 8.88 0 0 1-.89.17zM4.467 4.884s.003.002.005.006l-.005-.006zm7.066 0-.005.006c.002-.004.005-.006.005-.006zM11.354 5a3.174 3.174 0 0 0-.604-.21l-.099.445.055-.013c.286-.072.502-.149.648-.222z"
                }
            }
        ]
    })(props);
}
function BsCup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M.11 3.187A.5.5 0 0 1 .5 3h13a.5.5 0 0 1 .488.608l-.22.991a3.001 3.001 0 0 1-1.3 5.854l-.132.59A2.5 2.5 0 0 1 9.896 13H4.104a2.5 2.5 0 0 1-2.44-1.958L.012 3.608a.5.5 0 0 1 .098-.42Zm12.574 6.288a2 2 0 0 0 .866-3.899l-.866 3.9ZM1.124 4l1.516 6.825A1.5 1.5 0 0 0 4.104 12h5.792a1.5 1.5 0 0 0 1.464-1.175L12.877 4H1.123Z"
                }
            }
        ]
    })(props);
}
function BsCurrencyBitcoin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 13v1.25c0 .138.112.25.25.25h1a.25.25 0 0 0 .25-.25V13h.5v1.25c0 .138.112.25.25.25h1a.25.25 0 0 0 .25-.25V13h.084c1.992 0 3.416-1.033 3.416-2.82 0-1.502-1.007-2.323-2.186-2.44v-.088c.97-.242 1.683-.974 1.683-2.19C11.997 3.93 10.847 3 9.092 3H9V1.75a.25.25 0 0 0-.25-.25h-1a.25.25 0 0 0-.25.25V3h-.573V1.75a.25.25 0 0 0-.25-.25H5.75a.25.25 0 0 0-.25.25V3l-1.998.011a.25.25 0 0 0-.25.25v.989c0 .137.11.25.248.25l.755-.005a.75.75 0 0 1 .745.75v5.505a.75.75 0 0 1-.75.75l-.748.011a.25.25 0 0 0-.25.25v1c0 .138.112.25.25.25L5.5 13zm1.427-8.513h1.719c.906 0 1.438.498 1.438 1.312 0 .871-.575 1.362-1.877 1.362h-1.28V4.487zm0 4.051h1.84c1.137 0 1.756.58 1.756 1.524 0 .953-.626 1.45-2.158 1.45H6.927V8.539z"
                }
            }
        ]
    })(props);
}
function BsCurrencyDollar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10.781c.148 1.667 1.513 2.85 3.591 3.003V15h1.043v-1.216c2.27-.179 3.678-1.438 3.678-3.3 0-1.59-.947-2.51-2.956-3.028l-.722-.187V3.467c1.122.11 1.879.714 2.07 1.616h1.47c-.166-1.6-1.54-2.748-3.54-2.875V1H7.591v1.233c-1.939.23-3.27 1.472-3.27 3.156 0 1.454.966 2.483 2.661 2.917l.61.162v4.031c-1.149-.17-1.94-.8-2.131-1.718H4zm3.391-3.836c-1.043-.263-1.6-.825-1.6-1.616 0-.944.704-1.641 1.8-1.828v3.495l-.2-.05zm1.591 1.872c1.287.323 1.852.859 1.852 1.769 0 1.097-.826 1.828-2.2 1.939V8.73l.348.086z"
                }
            }
        ]
    })(props);
}
function BsCurrencyEuro(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9.42h1.063C5.4 12.323 7.317 14 10.34 14c.622 0 1.167-.068 1.659-.185v-1.3c-.484.119-1.045.17-1.659.17-2.1 0-3.455-1.198-3.775-3.264h4.017v-.928H6.497v-.936c0-.11 0-.219.008-.329h4.078v-.927H6.618c.388-1.898 1.719-2.985 3.723-2.985.614 0 1.175.05 1.659.177V2.194A6.617 6.617 0 0 0 10.341 2c-2.928 0-4.82 1.569-5.244 4.3H4v.928h1.01v1.265H4v.928z"
                }
            }
        ]
    })(props);
}
function BsCurrencyExchange(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 5a5.002 5.002 0 0 0 4.027 4.905 6.46 6.46 0 0 1 .544-2.073C3.695 7.536 3.132 6.864 3 5.91h-.5v-.426h.466V5.05c0-.046 0-.093.004-.135H2.5v-.427h.511C3.236 3.24 4.213 2.5 5.681 2.5c.316 0 .59.031.819.085v.733a3.46 3.46 0 0 0-.815-.082c-.919 0-1.538.466-1.734 1.252h1.917v.427h-1.98c-.003.046-.003.097-.003.147v.422h1.983v.427H3.93c.118.602.468 1.03 1.005 1.229a6.5 6.5 0 0 1 4.97-3.113A5.002 5.002 0 0 0 0 5zm16 5.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0zm-7.75 1.322c.069.835.746 1.485 1.964 1.562V14h.54v-.62c1.259-.086 1.996-.74 1.996-1.69 0-.865-.563-1.31-1.57-1.54l-.426-.1V8.374c.54.06.884.347.966.745h.948c-.07-.804-.779-1.433-1.914-1.502V7h-.54v.629c-1.076.103-1.808.732-1.808 1.622 0 .787.544 1.288 1.45 1.493l.358.085v1.78c-.554-.08-.92-.376-1.003-.787H8.25zm1.96-1.895c-.532-.12-.82-.364-.82-.732 0-.41.311-.719.824-.809v1.54h-.005zm.622 1.044c.645.145.943.38.943.796 0 .474-.37.8-1.02.86v-1.674l.077.018z"
                }
            }
        ]
    })(props);
}
function BsCurrencyPound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8.585h1.969c.115.465.186.939.186 1.43 0 1.385-.736 2.496-2.075 2.771V14H12v-1.24H6.492v-.129c.825-.525 1.135-1.446 1.135-2.694 0-.465-.07-.913-.168-1.352h3.29v-.972H7.22c-.186-.723-.372-1.455-.372-2.247 0-1.274 1.047-2.066 2.58-2.066a5.32 5.32 0 0 1 2.103.465V2.456A5.629 5.629 0 0 0 9.348 2C6.865 2 5.322 3.291 5.322 5.366c0 .775.195 1.515.399 2.247H4v.972z"
                }
            }
        ]
    })(props);
}
function BsCurrencyRupee(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3.06h2.726c1.22 0 2.12.575 2.325 1.724H4v1.051h5.051C8.855 7.001 8 7.558 6.788 7.558H4v1.317L8.437 14h2.11L6.095 8.884h.855c2.316-.018 3.465-1.476 3.688-3.049H12V4.784h-1.345c-.08-.778-.357-1.335-.793-1.732H12V2H4v1.06Z"
                }
            }
        ]
    })(props);
}
function BsCurrencyYen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.75 14v-2.629h2.446v-.967H8.75v-1.31h2.445v-.967H9.128L12.5 2h-1.699L8.047 7.327h-.086L5.207 2H3.5l3.363 6.127H4.778v.968H7.25v1.31H4.78v.966h2.47V14h1.502z"
                }
            }
        ]
    })(props);
}
function BsCursorFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.082 2.182a.5.5 0 0 1 .103.557L8.528 15.467a.5.5 0 0 1-.917-.007L5.57 10.694.803 8.652a.5.5 0 0 1-.006-.916l12.728-5.657a.5.5 0 0 1 .556.103z"
                }
            }
        ]
    })(props);
}
function BsCursorText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2a.5.5 0 0 1 .5-.5c.862 0 1.573.287 2.06.566.174.099.321.198.44.286.119-.088.266-.187.44-.286A4.165 4.165 0 0 1 10.5 1.5a.5.5 0 0 1 0 1c-.638 0-1.177.213-1.564.434a3.49 3.49 0 0 0-.436.294V7.5H9a.5.5 0 0 1 0 1h-.5v4.272c.1.08.248.187.436.294.387.221.926.434 1.564.434a.5.5 0 0 1 0 1 4.165 4.165 0 0 1-2.06-.566A4.561 4.561 0 0 1 8 13.65a4.561 4.561 0 0 1-.44.285 4.165 4.165 0 0 1-2.06.566.5.5 0 0 1 0-1c.638 0 1.177-.213 1.564-.434.188-.107.335-.214.436-.294V8.5H7a.5.5 0 0 1 0-1h.5V3.228a3.49 3.49 0 0 0-.436-.294A3.166 3.166 0 0 0 5.5 2.5.5.5 0 0 1 5 2zm3.352 1.355zm-.704 9.29z"
                }
            }
        ]
    })(props);
}
function BsCursor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.082 2.182a.5.5 0 0 1 .103.557L8.528 15.467a.5.5 0 0 1-.917-.007L5.57 10.694.803 8.652a.5.5 0 0 1-.006-.916l12.728-5.657a.5.5 0 0 1 .556.103zM2.25 8.184l3.897 1.67a.5.5 0 0 1 .262.263l1.67 3.897L12.743 3.52 2.25 8.184z"
                }
            }
        ]
    })(props);
}
function BsDashCircleDotted(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-.176 0-.35.006-.523.017l.064.998a7.117 7.117 0 0 1 .918 0l.064-.998A8.113 8.113 0 0 0 8 0zM6.44.152c-.346.069-.684.16-1.012.27l.321.948c.287-.098.582-.177.884-.237L6.44.153zm4.132.271a7.946 7.946 0 0 0-1.011-.27l-.194.98c.302.06.597.14.884.237l.321-.947zm1.873.925a8 8 0 0 0-.906-.524l-.443.896c.275.136.54.29.793.459l.556-.831zM4.46.824c-.314.155-.616.33-.905.524l.556.83a7.07 7.07 0 0 1 .793-.458L4.46.824zM2.725 1.985c-.262.23-.51.478-.74.74l.752.66c.202-.23.418-.446.648-.648l-.66-.752zm11.29.74a8.058 8.058 0 0 0-.74-.74l-.66.752c.23.202.447.418.648.648l.752-.66zm1.161 1.735a7.98 7.98 0 0 0-.524-.905l-.83.556c.169.253.322.518.458.793l.896-.443zM1.348 3.555c-.194.289-.37.591-.524.906l.896.443c.136-.275.29-.54.459-.793l-.831-.556zM.423 5.428a7.945 7.945 0 0 0-.27 1.011l.98.194c.06-.302.14-.597.237-.884l-.947-.321zM15.848 6.44a7.943 7.943 0 0 0-.27-1.012l-.948.321c.098.287.177.582.237.884l.98-.194zM.017 7.477a8.113 8.113 0 0 0 0 1.046l.998-.064a7.117 7.117 0 0 1 0-.918l-.998-.064zM16 8a8.1 8.1 0 0 0-.017-.523l-.998.064a7.11 7.11 0 0 1 0 .918l.998.064A8.1 8.1 0 0 0 16 8zM.152 9.56c.069.346.16.684.27 1.012l.948-.321a6.944 6.944 0 0 1-.237-.884l-.98.194zm15.425 1.012c.112-.328.202-.666.27-1.011l-.98-.194c-.06.302-.14.597-.237.884l.947.321zM.824 11.54a8 8 0 0 0 .524.905l.83-.556a6.999 6.999 0 0 1-.458-.793l-.896.443zm13.828.905c.194-.289.37-.591.524-.906l-.896-.443c-.136.275-.29.54-.459.793l.831.556zm-12.667.83c.23.262.478.51.74.74l.66-.752a7.047 7.047 0 0 1-.648-.648l-.752.66zm11.29.74c.262-.23.51-.478.74-.74l-.752-.66c-.201.23-.418.447-.648.648l.66.752zm-1.735 1.161c.314-.155.616-.33.905-.524l-.556-.83a7.07 7.07 0 0 1-.793.458l.443.896zm-7.985-.524c.289.194.591.37.906.524l.443-.896a6.998 6.998 0 0 1-.793-.459l-.556.831zm1.873.925c.328.112.666.202 1.011.27l.194-.98a6.953 6.953 0 0 1-.884-.237l-.321.947zm4.132.271a7.944 7.944 0 0 0 1.012-.27l-.321-.948a6.954 6.954 0 0 1-.884.237l.194.98zm-2.083.135a8.1 8.1 0 0 0 1.046 0l-.064-.998a7.11 7.11 0 0 1-.918 0l-.064.998zM4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7z"
                }
            }
        ]
    })(props);
}
function BsDashCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7z"
                }
            }
        ]
    })(props);
}
function BsDashCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"
                }
            }
        ]
    })(props);
}
function BsDashLg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8Z"
                }
            }
        ]
    })(props);
}
function BsDashSquareDotted(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 0c-.166 0-.33.016-.487.048l.194.98A1.51 1.51 0 0 1 2.5 1h.458V0H2.5zm2.292 0h-.917v1h.917V0zm1.833 0h-.917v1h.917V0zm1.833 0h-.916v1h.916V0zm1.834 0h-.917v1h.917V0zm1.833 0h-.917v1h.917V0zM13.5 0h-.458v1h.458c.1 0 .199.01.293.029l.194-.981A2.51 2.51 0 0 0 13.5 0zm2.079 1.11a2.511 2.511 0 0 0-.69-.689l-.556.831c.164.11.305.251.415.415l.83-.556zM1.11.421a2.511 2.511 0 0 0-.689.69l.831.556c.11-.164.251-.305.415-.415L1.11.422zM16 2.5c0-.166-.016-.33-.048-.487l-.98.194c.018.094.028.192.028.293v.458h1V2.5zM.048 2.013A2.51 2.51 0 0 0 0 2.5v.458h1V2.5c0-.1.01-.199.029-.293l-.981-.194zM0 3.875v.917h1v-.917H0zm16 .917v-.917h-1v.917h1zM0 5.708v.917h1v-.917H0zm16 .917v-.917h-1v.917h1zM0 7.542v.916h1v-.916H0zm15 .916h1v-.916h-1v.916zM0 9.375v.917h1v-.917H0zm16 .917v-.917h-1v.917h1zm-16 .916v.917h1v-.917H0zm16 .917v-.917h-1v.917h1zm-16 .917v.458c0 .166.016.33.048.487l.98-.194A1.51 1.51 0 0 1 1 13.5v-.458H0zm16 .458v-.458h-1v.458c0 .1-.01.199-.029.293l.981.194c.032-.158.048-.32.048-.487zM.421 14.89c.183.272.417.506.69.689l.556-.831a1.51 1.51 0 0 1-.415-.415l-.83.556zm14.469.689c.272-.183.506-.417.689-.69l-.831-.556c-.11.164-.251.305-.415.415l.556.83zm-12.877.373c.158.032.32.048.487.048h.458v-1H2.5c-.1 0-.199-.01-.293-.029l-.194.981zM13.5 16c.166 0 .33-.016.487-.048l-.194-.98A1.51 1.51 0 0 1 13.5 15h-.458v1h.458zm-9.625 0h.917v-1h-.917v1zm1.833 0h.917v-1h-.917v1zm1.834 0h.916v-1h-.916v1zm1.833 0h.917v-1h-.917v1zm1.833 0h.917v-1h-.917v1zM4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7z"
                }
            }
        ]
    })(props);
}
function BsDashSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm2.5 7.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsDashSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"
                }
            }
        ]
    })(props);
}
function BsDash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"
                }
            }
        ]
    })(props);
}
function BsDatabaseAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.096 6.223A4.92 4.92 0 0 0 13 5.698V7c0 .289-.213.654-.753 1.007a4.493 4.493 0 0 1 1.753.25V4c0-1.007-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1s-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4v9c0 1.007.875 1.755 1.904 2.223C4.978 15.71 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.525 4.525 0 0 1-.813-.927C8.5 14.992 8.252 15 8 15c-1.464 0-2.766-.27-3.682-.687C3.356 13.875 3 13.373 3 13v-1.302c.271.202.58.378.904.525C4.978 12.71 6.427 13 8 13h.027a4.552 4.552 0 0 1 0-1H8c-1.464 0-2.766-.27-3.682-.687C3.356 10.875 3 10.373 3 10V8.698c.271.202.58.378.904.525C4.978 9.71 6.427 10 8 10c.262 0 .52-.008.774-.024a4.525 4.525 0 0 1 1.102-1.132C9.298 8.944 8.666 9 8 9c-1.464 0-2.766-.27-3.682-.687C3.356 7.875 3 7.373 3 7V5.698c.271.202.58.378.904.525C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777ZM3 4c0-.374.356-.875 1.318-1.313C5.234 2.271 6.536 2 8 2s2.766.27 3.682.687C12.644 3.125 13 3.627 13 4c0 .374-.356.875-1.318 1.313C10.766 5.729 9.464 6 8 6s-2.766-.27-3.682-.687C3.356 4.875 3 4.373 3 4Z"
                }
            }
        ]
    })(props);
}
function BsDatabaseCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.17-1.951a.5.5 0 1 1 .858.514Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.096 6.223A4.92 4.92 0 0 0 13 5.698V7c0 .289-.213.654-.753 1.007a4.493 4.493 0 0 1 1.753.25V4c0-1.007-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1s-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4v9c0 1.007.875 1.755 1.904 2.223C4.978 15.71 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.525 4.525 0 0 1-.813-.927C8.5 14.992 8.252 15 8 15c-1.464 0-2.766-.27-3.682-.687C3.356 13.875 3 13.373 3 13v-1.302c.271.202.58.378.904.525C4.978 12.71 6.427 13 8 13h.027a4.552 4.552 0 0 1 0-1H8c-1.464 0-2.766-.27-3.682-.687C3.356 10.875 3 10.373 3 10V8.698c.271.202.58.378.904.525C4.978 9.71 6.427 10 8 10c.262 0 .52-.008.774-.024a4.525 4.525 0 0 1 1.102-1.132C9.298 8.944 8.666 9 8 9c-1.464 0-2.766-.27-3.682-.687C3.356 7.875 3 7.373 3 7V5.698c.271.202.58.378.904.525C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777ZM3 4c0-.374.356-.875 1.318-1.313C5.234 2.271 6.536 2 8 2s2.766.27 3.682.687C12.644 3.125 13 3.627 13 4c0 .374-.356.875-1.318 1.313C10.766 5.729 9.464 6 8 6s-2.766-.27-3.682-.687C3.356 4.875 3 4.373 3 4Z"
                }
            }
        ]
    })(props);
}
function BsDatabaseDash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM11 12h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.096 6.223A4.92 4.92 0 0 0 13 5.698V7c0 .289-.213.654-.753 1.007a4.493 4.493 0 0 1 1.753.25V4c0-1.007-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1s-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4v9c0 1.007.875 1.755 1.904 2.223C4.978 15.71 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.525 4.525 0 0 1-.813-.927C8.5 14.992 8.252 15 8 15c-1.464 0-2.766-.27-3.682-.687C3.356 13.875 3 13.373 3 13v-1.302c.271.202.58.378.904.525C4.978 12.71 6.427 13 8 13h.027a4.552 4.552 0 0 1 0-1H8c-1.464 0-2.766-.27-3.682-.687C3.356 10.875 3 10.373 3 10V8.698c.271.202.58.378.904.525C4.978 9.71 6.427 10 8 10c.262 0 .52-.008.774-.024a4.525 4.525 0 0 1 1.102-1.132C9.298 8.944 8.666 9 8 9c-1.464 0-2.766-.27-3.682-.687C3.356 7.875 3 7.373 3 7V5.698c.271.202.58.378.904.525C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777ZM3 4c0-.374.356-.875 1.318-1.313C5.234 2.271 6.536 2 8 2s2.766.27 3.682.687C12.644 3.125 13 3.627 13 4c0 .374-.356.875-1.318 1.313C10.766 5.729 9.464 6 8 6s-2.766-.27-3.682-.687C3.356 4.875 3 4.373 3 4Z"
                }
            }
        ]
    })(props);
}
function BsDatabaseDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 9a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm.354 5.854 1.5-1.5a.5.5 0 0 0-.708-.708l-.646.647V10.5a.5.5 0 0 0-1 0v2.793l-.646-.647a.5.5 0 0 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.096 6.223A4.92 4.92 0 0 0 13 5.698V7c0 .289-.213.654-.753 1.007a4.493 4.493 0 0 1 1.753.25V4c0-1.007-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1s-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4v9c0 1.007.875 1.755 1.904 2.223C4.978 15.71 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.525 4.525 0 0 1-.813-.927C8.5 14.992 8.252 15 8 15c-1.464 0-2.766-.27-3.682-.687C3.356 13.875 3 13.373 3 13v-1.302c.271.202.58.378.904.525C4.978 12.71 6.427 13 8 13h.027a4.552 4.552 0 0 1 0-1H8c-1.464 0-2.766-.27-3.682-.687C3.356 10.875 3 10.373 3 10V8.698c.271.202.58.378.904.525C4.978 9.71 6.427 10 8 10c.262 0 .52-.008.774-.024a4.525 4.525 0 0 1 1.102-1.132C9.298 8.944 8.666 9 8 9c-1.464 0-2.766-.27-3.682-.687C3.356 7.875 3 7.373 3 7V5.698c.271.202.58.378.904.525C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777ZM3 4c0-.374.356-.875 1.318-1.313C5.234 2.271 6.536 2 8 2s2.766.27 3.682.687C12.644 3.125 13 3.627 13 4c0 .374-.356.875-1.318 1.313C10.766 5.729 9.464 6 8 6s-2.766-.27-3.682-.687C3.356 4.875 3 4.373 3 4Z"
                }
            }
        ]
    })(props);
}
function BsDatabaseExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.096 6.223A4.92 4.92 0 0 0 13 5.698V7c0 .289-.213.654-.753 1.007a4.493 4.493 0 0 1 1.753.25V4c0-1.007-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1s-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4v9c0 1.007.875 1.755 1.904 2.223C4.978 15.71 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.525 4.525 0 0 1-.813-.927C8.5 14.992 8.252 15 8 15c-1.464 0-2.766-.27-3.682-.687C3.356 13.875 3 13.373 3 13v-1.302c.271.202.58.378.904.525C4.978 12.71 6.427 13 8 13h.027a4.552 4.552 0 0 1 0-1H8c-1.464 0-2.766-.27-3.682-.687C3.356 10.875 3 10.373 3 10V8.698c.271.202.58.378.904.525C4.978 9.71 6.427 10 8 10c.262 0 .52-.008.774-.024a4.525 4.525 0 0 1 1.102-1.132C9.298 8.944 8.666 9 8 9c-1.464 0-2.766-.27-3.682-.687C3.356 7.875 3 7.373 3 7V5.698c.271.202.58.378.904.525C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777ZM3 4c0-.374.356-.875 1.318-1.313C5.234 2.271 6.536 2 8 2s2.766.27 3.682.687C12.644 3.125 13 3.627 13 4c0 .374-.356.875-1.318 1.313C10.766 5.729 9.464 6 8 6s-2.766-.27-3.682-.687C3.356 4.875 3 4.373 3 4Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-3.5-2a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 1 0V11a.5.5 0 0 0-.5-.5Zm0 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
                }
            }
        ]
    })(props);
}
function BsDatabaseFillAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0ZM8 1c-1.573 0-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4s.875 1.755 1.904 2.223C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777C13.125 5.755 14 5.007 14 4s-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 7v-.839c.457.432 1.004.751 1.49.972C4.722 7.693 6.318 8 8 8s3.278-.307 4.51-.867c.486-.22 1.033-.54 1.49-.972V7c0 .424-.155.802-.411 1.133a4.51 4.51 0 0 0-4.815 1.843A12.31 12.31 0 0 1 8 10c-1.573 0-3.022-.289-4.096-.777C2.875 8.755 2 8.007 2 7Zm6.257 3.998L8 11c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V10c0 1.007.875 1.755 1.904 2.223C4.978 12.711 6.427 13 8 13h.027a4.552 4.552 0 0 1 .23-2.002Zm-.002 3L8 14c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V13c0 1.007.875 1.755 1.904 2.223C4.978 15.711 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.507 4.507 0 0 1-1.3-1.905Z"
                }
            }
        ]
    })(props);
}
function BsDatabaseFillCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.17-1.951a.5.5 0 1 1 .858.514ZM8 1c-1.573 0-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4s.875 1.755 1.904 2.223C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777C13.125 5.755 14 5.007 14 4s-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 7v-.839c.457.432 1.004.751 1.49.972C4.722 7.693 6.318 8 8 8s3.278-.307 4.51-.867c.486-.22 1.033-.54 1.49-.972V7c0 .424-.155.802-.411 1.133a4.51 4.51 0 0 0-4.815 1.843A12.31 12.31 0 0 1 8 10c-1.573 0-3.022-.289-4.096-.777C2.875 8.755 2 8.007 2 7Zm6.257 3.998L8 11c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V10c0 1.007.875 1.755 1.904 2.223C4.978 12.711 6.427 13 8 13h.027a4.552 4.552 0 0 1 .23-2.002Zm-.002 3L8 14c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V13c0 1.007.875 1.755 1.904 2.223C4.978 15.711 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.507 4.507 0 0 1-1.3-1.905Z"
                }
            }
        ]
    })(props);
}
function BsDatabaseFillDash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM11 12h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1ZM8 1c-1.573 0-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4s.875 1.755 1.904 2.223C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777C13.125 5.755 14 5.007 14 4s-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 7v-.839c.457.432 1.004.751 1.49.972C4.722 7.693 6.318 8 8 8s3.278-.307 4.51-.867c.486-.22 1.033-.54 1.49-.972V7c0 .424-.155.802-.411 1.133a4.51 4.51 0 0 0-4.815 1.843A12.31 12.31 0 0 1 8 10c-1.573 0-3.022-.289-4.096-.777C2.875 8.755 2 8.007 2 7Zm6.257 3.998L8 11c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V10c0 1.007.875 1.755 1.904 2.223C4.978 12.711 6.427 13 8 13h.027a4.552 4.552 0 0 1 .23-2.002Zm-.002 3L8 14c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V13c0 1.007.875 1.755 1.904 2.223C4.978 15.711 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.507 4.507 0 0 1-1.3-1.905Z"
                }
            }
        ]
    })(props);
}
function BsDatabaseFillDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 9a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm.354 5.854 1.5-1.5a.5.5 0 0 0-.708-.708l-.646.647V10.5a.5.5 0 0 0-1 0v2.793l-.646-.647a.5.5 0 0 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0ZM8 1c-1.573 0-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4s.875 1.755 1.904 2.223C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777C13.125 5.755 14 5.007 14 4s-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 7v-.839c.457.432 1.004.751 1.49.972C4.722 7.693 6.318 8 8 8s3.278-.307 4.51-.867c.486-.22 1.033-.54 1.49-.972V7c0 .424-.155.802-.411 1.133a4.51 4.51 0 0 0-4.815 1.843A12.31 12.31 0 0 1 8 10c-1.573 0-3.022-.289-4.096-.777C2.875 8.755 2 8.007 2 7Zm6.257 3.998L8 11c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V10c0 1.007.875 1.755 1.904 2.223C4.978 12.711 6.427 13 8 13h.027a4.552 4.552 0 0 1 .23-2.002Zm-.002 3L8 14c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V13c0 1.007.875 1.755 1.904 2.223C4.978 15.711 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.507 4.507 0 0 1-1.3-1.905Z"
                }
            }
        ]
    })(props);
}
function BsDatabaseFillExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1c-1.573 0-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4s.875 1.755 1.904 2.223C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777C13.125 5.755 14 5.007 14 4s-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 7v-.839c.457.432 1.004.751 1.49.972C4.722 7.693 6.318 8 8 8s3.278-.307 4.51-.867c.486-.22 1.033-.54 1.49-.972V7c0 .424-.155.802-.411 1.133a4.51 4.51 0 0 0-4.815 1.843A12.31 12.31 0 0 1 8 10c-1.573 0-3.022-.289-4.096-.777C2.875 8.755 2 8.007 2 7Zm6.257 3.998L8 11c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V10c0 1.007.875 1.755 1.904 2.223C4.978 12.711 6.427 13 8 13h.027a4.552 4.552 0 0 1 .23-2.002Zm-.002 3L8 14c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V13c0 1.007.875 1.755 1.904 2.223C4.978 15.711 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.507 4.507 0 0 1-1.3-1.905Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-3.5-2a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 1 0V11a.5.5 0 0 0-.5-.5Zm0 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
                }
            }
        ]
    })(props);
}
function BsDatabaseFillGear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1c-1.573 0-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4s.875 1.755 1.904 2.223C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777C13.125 5.755 14 5.007 14 4s-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 7v-.839c.457.432 1.004.751 1.49.972C4.722 7.693 6.318 8 8 8s3.278-.307 4.51-.867c.486-.22 1.033-.54 1.49-.972V7c0 .424-.155.802-.411 1.133a4.51 4.51 0 0 0-4.815 1.843A12.31 12.31 0 0 1 8 10c-1.573 0-3.022-.289-4.096-.777C2.875 8.755 2 8.007 2 7Zm6.257 3.998L8 11c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V10c0 1.007.875 1.755 1.904 2.223C4.978 12.711 6.427 13 8 13h.027a4.552 4.552 0 0 1 .23-2.002Zm-.002 3L8 14c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V13c0 1.007.875 1.755 1.904 2.223C4.978 15.711 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.507 4.507 0 0 1-1.3-1.905Zm3.631-4.538c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.045c-.613-.18-.613-1.048 0-1.229l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382l.045-.148ZM14 12.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z"
                }
            }
        ]
    })(props);
}
function BsDatabaseFillLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1c-1.573 0-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4s.875 1.755 1.904 2.223C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777C13.125 5.755 14 5.007 14 4s-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.904 9.223C2.875 8.755 2 8.007 2 7v-.839c.457.432 1.004.751 1.49.972C4.722 7.693 6.318 8 8 8s3.278-.307 4.51-.867c.486-.22 1.033-.54 1.49-.972V7c0 .424-.155.802-.411 1.133a4.51 4.51 0 0 0-1.364-.125 2.988 2.988 0 0 0-2.197.731 4.525 4.525 0 0 0-1.254 1.237A12.31 12.31 0 0 1 8 10c-1.573 0-3.022-.289-4.096-.777ZM8 14c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V13c0 1.007.875 1.755 1.904 2.223C4.978 15.711 6.427 16 8 16c.09 0 .178 0 .266-.003A1.99 1.99 0 0 1 8 15v-1Zm0-1.5c0 .1.003.201.01.3A1.9 1.9 0 0 0 8 13c-1.573 0-3.022-.289-4.096-.777C2.875 11.755 2 11.007 2 10v-.839c.457.432 1.004.751 1.49.972C4.722 10.693 6.318 11 8 11c.086 0 .172 0 .257-.002A4.5 4.5 0 0 0 8 12.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13a1 1 0 0 1 1-1v-1a2 2 0 1 1 4 0v1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-2Zm3-3a1 1 0 0 0-1 1v1h2v-1a1 1 0 0 0-1-1Z"
                }
            }
        ]
    })(props);
}
function BsDatabaseFillSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.879 10.414a2.501 2.501 0 0 0-3.465 3.465l3.465-3.465Zm.707.707-3.465 3.465a2.501 2.501 0 0 0 3.465-3.465Zm-4.56-1.096a3.5 3.5 0 1 1 4.949 4.95 3.5 3.5 0 0 1-4.95-4.95ZM8 1c-1.573 0-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4s.875 1.755 1.904 2.223C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777C13.125 5.755 14 5.007 14 4s-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 7v-.839c.457.432 1.004.751 1.49.972C4.722 7.693 6.318 8 8 8s3.278-.307 4.51-.867c.486-.22 1.033-.54 1.49-.972V7c0 .424-.155.802-.411 1.133a4.51 4.51 0 0 0-4.815 1.843A12.31 12.31 0 0 1 8 10c-1.573 0-3.022-.289-4.096-.777C2.875 8.755 2 8.007 2 7Zm6.257 3.998L8 11c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V10c0 1.007.875 1.755 1.904 2.223C4.978 12.711 6.427 13 8 13h.027a4.552 4.552 0 0 1 .23-2.002Zm-.002 3L8 14c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V13c0 1.007.875 1.755 1.904 2.223C4.978 15.711 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.507 4.507 0 0 1-1.3-1.905Z"
                }
            }
        ]
    })(props);
}
function BsDatabaseFillUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.354-5.854 1.5 1.5a.5.5 0 0 1-.708.708L13 11.707V14.5a.5.5 0 0 1-1 0v-2.793l-.646.647a.5.5 0 0 1-.708-.708l1.5-1.5a.5.5 0 0 1 .708 0ZM8 1c-1.573 0-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4s.875 1.755 1.904 2.223C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777C13.125 5.755 14 5.007 14 4s-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 7v-.839c.457.432 1.004.751 1.49.972C4.722 7.693 6.318 8 8 8s3.278-.307 4.51-.867c.486-.22 1.033-.54 1.49-.972V7c0 .424-.155.802-.411 1.133a4.51 4.51 0 0 0-4.815 1.843A12.31 12.31 0 0 1 8 10c-1.573 0-3.022-.289-4.096-.777C2.875 8.755 2 8.007 2 7Zm6.257 3.998L8 11c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V10c0 1.007.875 1.755 1.904 2.223C4.978 12.711 6.427 13 8 13h.027a4.552 4.552 0 0 1 .23-2.002Zm-.002 3L8 14c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V13c0 1.007.875 1.755 1.904 2.223C4.978 15.711 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.507 4.507 0 0 1-1.3-1.905Z"
                }
            }
        ]
    })(props);
}
function BsDatabaseFillX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1c-1.573 0-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4s.875 1.755 1.904 2.223C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777C13.125 5.755 14 5.007 14 4s-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 7v-.839c.457.432 1.004.751 1.49.972C4.722 7.693 6.318 8 8 8s3.278-.307 4.51-.867c.486-.22 1.033-.54 1.49-.972V7c0 .424-.155.802-.411 1.133a4.51 4.51 0 0 0-4.815 1.843A12.31 12.31 0 0 1 8 10c-1.573 0-3.022-.289-4.096-.777C2.875 8.755 2 8.007 2 7Zm6.257 3.998L8 11c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V10c0 1.007.875 1.755 1.904 2.223C4.978 12.711 6.427 13 8 13h.027a4.552 4.552 0 0 1 .23-2.002Zm-.002 3L8 14c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V13c0 1.007.875 1.755 1.904 2.223C4.978 15.711 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.507 4.507 0 0 1-1.3-1.905Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-.646-4.854.646.647.646-.647a.5.5 0 0 1 .708.708l-.647.646.647.646a.5.5 0 0 1-.708.708l-.646-.647-.646.647a.5.5 0 0 1-.708-.708l.647-.646-.647-.646a.5.5 0 0 1 .708-.708Z"
                }
            }
        ]
    })(props);
}
function BsDatabaseFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.904 1.777C4.978 1.289 6.427 1 8 1s3.022.289 4.096.777C13.125 2.245 14 2.993 14 4s-.875 1.755-1.904 2.223C11.022 6.711 9.573 7 8 7s-3.022-.289-4.096-.777C2.875 5.755 2 5.007 2 4s.875-1.755 1.904-2.223Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6.161V7c0 1.007.875 1.755 1.904 2.223C4.978 9.71 6.427 10 8 10s3.022-.289 4.096-.777C13.125 8.755 14 8.007 14 7v-.839c-.457.432-1.004.751-1.49.972C11.278 7.693 9.682 8 8 8s-3.278-.307-4.51-.867c-.486-.22-1.033-.54-1.49-.972Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9.161V10c0 1.007.875 1.755 1.904 2.223C4.978 12.711 6.427 13 8 13s3.022-.289 4.096-.777C13.125 11.755 14 11.007 14 10v-.839c-.457.432-1.004.751-1.49.972-1.232.56-2.828.867-4.51.867s-3.278-.307-4.51-.867c-.486-.22-1.033-.54-1.49-.972Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12.161V13c0 1.007.875 1.755 1.904 2.223C4.978 15.711 6.427 16 8 16s3.022-.289 4.096-.777C13.125 14.755 14 14.007 14 13v-.839c-.457.432-1.004.751-1.49.972-1.232.56-2.828.867-4.51.867s-3.278-.307-4.51-.867c-.486-.22-1.033-.54-1.49-.972Z"
                }
            }
        ]
    })(props);
}
function BsDatabaseGear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.096 6.223A4.92 4.92 0 0 0 13 5.698V7c0 .289-.213.654-.753 1.007a4.493 4.493 0 0 1 1.753.25V4c0-1.007-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1s-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4v9c0 1.007.875 1.755 1.904 2.223C4.978 15.71 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.525 4.525 0 0 1-.813-.927C8.5 14.992 8.252 15 8 15c-1.464 0-2.766-.27-3.682-.687C3.356 13.875 3 13.373 3 13v-1.302c.271.202.58.378.904.525C4.978 12.71 6.427 13 8 13h.027a4.552 4.552 0 0 1 0-1H8c-1.464 0-2.766-.27-3.682-.687C3.356 10.875 3 10.373 3 10V8.698c.271.202.58.378.904.525C4.978 9.71 6.427 10 8 10c.262 0 .52-.008.774-.024a4.525 4.525 0 0 1 1.102-1.132C9.298 8.944 8.666 9 8 9c-1.464 0-2.766-.27-3.682-.687C3.356 7.875 3 7.373 3 7V5.698c.271.202.58.378.904.525C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777ZM3 4c0-.374.356-.875 1.318-1.313C5.234 2.271 6.536 2 8 2s2.766.27 3.682.687C12.644 3.125 13 3.627 13 4c0 .374-.356.875-1.318 1.313C10.766 5.729 9.464 6 8 6s-2.766-.27-3.682-.687C3.356 4.875 3 4.373 3 4Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.886 9.46c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.045c-.613-.18-.613-1.048 0-1.229l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382l.045-.148ZM14 12.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
                }
            }
        ]
    })(props);
}
function BsDatabaseLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5.698a4.92 4.92 0 0 1-.904.525C11.022 6.711 9.573 7 8 7s-3.022-.289-4.096-.777A4.92 4.92 0 0 1 3 5.698V7c0 .374.356.875 1.318 1.313C5.234 8.729 6.536 9 8 9c.666 0 1.298-.056 1.876-.156-.43.31-.804.693-1.102 1.132A12.31 12.31 0 0 1 8 10c-1.573 0-3.022-.289-4.096-.777A4.92 4.92 0 0 1 3 8.698V10c0 .374.356.875 1.318 1.313C5.234 11.729 6.536 12 8 12h.027a4.548 4.548 0 0 0-.017.8A1.9 1.9 0 0 0 8 13c-1.573 0-3.022-.289-4.096-.777A4.916 4.916 0 0 1 3 11.698V13c0 .374.356.875 1.318 1.313C5.234 14.729 6.536 15 8 15c0 .363.097.704.266.997C8.178 16 8.089 16 8 16c-1.573 0-3.022-.289-4.096-.777C2.875 14.755 2 14.007 2 13V4c0-1.007.875-1.755 1.904-2.223C4.978 1.289 6.427 1 8 1s3.022.289 4.096.777C13.125 2.245 14 2.993 14 4v4.256a4.493 4.493 0 0 0-1.753-.249C12.787 7.654 13 7.289 13 7V5.698Zm-8.682-3.01C3.356 3.124 3 3.625 3 4c0 .374.356.875 1.318 1.313C5.234 5.729 6.536 6 8 6s2.766-.27 3.682-.687C12.644 4.875 13 4.373 13 4c0-.374-.356-.875-1.318-1.313C10.766 2.271 9.464 2 8 2s-2.766.27-3.682.687Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13a1 1 0 0 1 1-1v-1a2 2 0 1 1 4 0v1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-2Zm3-3a1 1 0 0 0-1 1v1h2v-1a1 1 0 0 0-1-1Z"
                }
            }
        ]
    })(props);
}
function BsDatabaseSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.879 10.414a2.501 2.501 0 0 0-3.465 3.465l3.465-3.465Zm.707.707-3.465 3.465a2.501 2.501 0 0 0 3.465-3.465Zm-4.56-1.096a3.5 3.5 0 1 1 4.949 4.95 3.5 3.5 0 0 1-4.95-4.95Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.096 6.223A4.92 4.92 0 0 0 13 5.698V7c0 .289-.213.654-.753 1.007a4.493 4.493 0 0 1 1.753.25V4c0-1.007-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1s-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4v9c0 1.007.875 1.755 1.904 2.223C4.978 15.71 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.525 4.525 0 0 1-.813-.927C8.5 14.992 8.252 15 8 15c-1.464 0-2.766-.27-3.682-.687C3.356 13.875 3 13.373 3 13v-1.302c.271.202.58.378.904.525C4.978 12.71 6.427 13 8 13h.027a4.552 4.552 0 0 1 0-1H8c-1.464 0-2.766-.27-3.682-.687C3.356 10.875 3 10.373 3 10V8.698c.271.202.58.378.904.525C4.978 9.71 6.427 10 8 10c.262 0 .52-.008.774-.024a4.525 4.525 0 0 1 1.102-1.132C9.298 8.944 8.666 9 8 9c-1.464 0-2.766-.27-3.682-.687C3.356 7.875 3 7.373 3 7V5.698c.271.202.58.378.904.525C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777ZM3 4c0-.374.356-.875 1.318-1.313C5.234 2.271 6.536 2 8 2s2.766.27 3.682.687C12.644 3.125 13 3.627 13 4c0 .374-.356.875-1.318 1.313C10.766 5.729 9.464 6 8 6s-2.766-.27-3.682-.687C3.356 4.875 3 4.373 3 4Z"
                }
            }
        ]
    })(props);
}
function BsDatabaseUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.354-5.854 1.5 1.5a.5.5 0 0 1-.708.708L13 11.707V14.5a.5.5 0 0 1-1 0v-2.793l-.646.647a.5.5 0 0 1-.708-.708l1.5-1.5a.5.5 0 0 1 .708 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.096 6.223A4.92 4.92 0 0 0 13 5.698V7c0 .289-.213.654-.753 1.007a4.493 4.493 0 0 1 1.753.25V4c0-1.007-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1s-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4v9c0 1.007.875 1.755 1.904 2.223C4.978 15.71 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.525 4.525 0 0 1-.813-.927C8.5 14.992 8.252 15 8 15c-1.464 0-2.766-.27-3.682-.687C3.356 13.875 3 13.373 3 13v-1.302c.271.202.58.378.904.525C4.978 12.71 6.427 13 8 13h.027a4.552 4.552 0 0 1 0-1H8c-1.464 0-2.766-.27-3.682-.687C3.356 10.875 3 10.373 3 10V8.698c.271.202.58.378.904.525C4.978 9.71 6.427 10 8 10c.262 0 .52-.008.774-.024a4.525 4.525 0 0 1 1.102-1.132C9.298 8.944 8.666 9 8 9c-1.464 0-2.766-.27-3.682-.687C3.356 7.875 3 7.373 3 7V5.698c.271.202.58.378.904.525C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777ZM3 4c0-.374.356-.875 1.318-1.313C5.234 2.271 6.536 2 8 2s2.766.27 3.682.687C12.644 3.125 13 3.627 13 4c0 .374-.356.875-1.318 1.313C10.766 5.729 9.464 6 8 6s-2.766-.27-3.682-.687C3.356 4.875 3 4.373 3 4Z"
                }
            }
        ]
    })(props);
}
function BsDatabaseX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.096 6.223A4.92 4.92 0 0 0 13 5.698V7c0 .289-.213.654-.753 1.007a4.493 4.493 0 0 1 1.753.25V4c0-1.007-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1s-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4v9c0 1.007.875 1.755 1.904 2.223C4.978 15.71 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.525 4.525 0 0 1-.813-.927C8.5 14.992 8.252 15 8 15c-1.464 0-2.766-.27-3.682-.687C3.356 13.875 3 13.373 3 13v-1.302c.271.202.58.378.904.525C4.978 12.71 6.427 13 8 13h.027a4.552 4.552 0 0 1 0-1H8c-1.464 0-2.766-.27-3.682-.687C3.356 10.875 3 10.373 3 10V8.698c.271.202.58.378.904.525C4.978 9.71 6.427 10 8 10c.262 0 .52-.008.774-.024a4.525 4.525 0 0 1 1.102-1.132C9.298 8.944 8.666 9 8 9c-1.464 0-2.766-.27-3.682-.687C3.356 7.875 3 7.373 3 7V5.698c.271.202.58.378.904.525C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777ZM3 4c0-.374.356-.875 1.318-1.313C5.234 2.271 6.536 2 8 2s2.766.27 3.682.687C12.644 3.125 13 3.627 13 4c0 .374-.356.875-1.318 1.313C10.766 5.729 9.464 6 8 6s-2.766-.27-3.682-.687C3.356 4.875 3 4.373 3 4Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-.646-4.854.646.647.646-.647a.5.5 0 0 1 .708.708l-.647.646.647.646a.5.5 0 0 1-.708.708l-.646-.647-.646.647a.5.5 0 0 1-.708-.708l.647-.646-.647-.646a.5.5 0 0 1 .708-.708Z"
                }
            }
        ]
    })(props);
}
function BsDatabase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.318 2.687C5.234 2.271 6.536 2 8 2s2.766.27 3.682.687C12.644 3.125 13 3.627 13 4c0 .374-.356.875-1.318 1.313C10.766 5.729 9.464 6 8 6s-2.766-.27-3.682-.687C3.356 4.875 3 4.373 3 4c0-.374.356-.875 1.318-1.313ZM13 5.698V7c0 .374-.356.875-1.318 1.313C10.766 8.729 9.464 9 8 9s-2.766-.27-3.682-.687C3.356 7.875 3 7.373 3 7V5.698c.271.202.58.378.904.525C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777A4.92 4.92 0 0 0 13 5.698ZM14 4c0-1.007-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1s-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4v9c0 1.007.875 1.755 1.904 2.223C4.978 15.71 6.427 16 8 16s3.022-.289 4.096-.777C13.125 14.755 14 14.007 14 13V4Zm-1 4.698V10c0 .374-.356.875-1.318 1.313C10.766 11.729 9.464 12 8 12s-2.766-.27-3.682-.687C3.356 10.875 3 10.373 3 10V8.698c.271.202.58.378.904.525C4.978 9.71 6.427 10 8 10s3.022-.289 4.096-.777A4.92 4.92 0 0 0 13 8.698Zm0 3V13c0 .374-.356.875-1.318 1.313C10.766 14.729 9.464 15 8 15s-2.766-.27-3.682-.687C3.356 13.875 3 13.373 3 13v-1.302c.271.202.58.378.904.525C4.978 12.71 6.427 13 8 13s3.022-.289 4.096-.777c.324-.147.633-.323.904-.525Z"
                }
            }
        ]
    })(props);
}
function BsDeviceHddFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.785 9.896A3.001 3.001 0 0 0 8 4a3 3 0 0 0-.891 5.865c.667-.44 1.396-.91 1.955-1.268.224-.144.483.115.34.34l-.62.96ZM9 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4Zm9 1.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0 13a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-9.5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1ZM4 1.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm2.882 11.177a1.102 1.102 0 0 1-1.56-1.559c.1-.098.396-.314.795-.588a4 4 0 1 1 1.946.47c-.537.813-1.02 1.515-1.181 1.677Z"
                }
            }
        ]
    })(props);
}
function BsDeviceHdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0 11a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-7.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM5 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM8 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7a4 4 0 0 1-3.937 4c-.537.813-1.02 1.515-1.181 1.677a1.102 1.102 0 0 1-1.56-1.559c.1-.098.396-.314.795-.588A4 4 0 0 1 8 3a4 4 0 0 1 4 4Zm-1 0a3 3 0 1 0-3.891 2.865c.667-.44 1.396-.91 1.955-1.268.224-.144.483.115.34.34l-.62.96A3.001 3.001 0 0 0 11 7Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2Zm2-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H4Z"
                }
            }
        ]
    })(props);
}
function BsDeviceSsdFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8V4h6v4H5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4Zm0 1.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm9 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM3.5 11a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm9.5-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM4.75 3h6.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-.75.75h-6.5A.75.75 0 0 1 4 8.25v-4.5A.75.75 0 0 1 4.75 3ZM5 12h6a1 1 0 0 1 1 1v2h-1v-2h-.75v2h-1v-2H8.5v2h-1v-2h-.75v2h-1v-2H5v2H4v-2a1 1 0 0 1 1-1Z"
                }
            }
        ]
    })(props);
}
function BsDeviceSsd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.75 4a.75.75 0 0 0-.75.75v3.5c0 .414.336.75.75.75h6.5a.75.75 0 0 0 .75-.75v-3.5a.75.75 0 0 0-.75-.75h-6.5ZM5 8V5h6v3H5Zm0-5.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm7 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM4.5 11a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm7 0a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2Zm11 12V2a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1v-2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2a1 1 0 0 0 1-1Zm-7.25 1v-2H5v2h.75Zm1.75 0v-2h-.75v2h.75Zm1.75 0v-2H8.5v2h.75ZM11 13h-.75v2H11v-2Z"
                }
            }
        ]
    })(props);
}
function BsDiagram2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 3.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5v1A1.5 1.5 0 0 1 8.5 6v1H11a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 5 7h2.5V6A1.5 1.5 0 0 1 6 4.5v-1zm-3 8A1.5 1.5 0 0 1 4.5 10h1A1.5 1.5 0 0 1 7 11.5v1A1.5 1.5 0 0 1 5.5 14h-1A1.5 1.5 0 0 1 3 12.5v-1zm6 0a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1A1.5 1.5 0 0 1 9 12.5v-1z"
                }
            }
        ]
    })(props);
}
function BsDiagram2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 3.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5v1A1.5 1.5 0 0 1 8.5 6v1H11a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 5 7h2.5V6A1.5 1.5 0 0 1 6 4.5v-1zM8.5 5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1zM3 11.5A1.5 1.5 0 0 1 4.5 10h1A1.5 1.5 0 0 1 7 11.5v1A1.5 1.5 0 0 1 5.5 14h-1A1.5 1.5 0 0 1 3 12.5v-1zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zm4.5.5a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1A1.5 1.5 0 0 1 9 12.5v-1zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1z"
                }
            }
        ]
    })(props);
}
function BsDiagram3Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 3.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5v1A1.5 1.5 0 0 1 8.5 6v1H14a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 2 7h5.5V6A1.5 1.5 0 0 1 6 4.5v-1zm-6 8A1.5 1.5 0 0 1 1.5 10h1A1.5 1.5 0 0 1 4 11.5v1A1.5 1.5 0 0 1 2.5 14h-1A1.5 1.5 0 0 1 0 12.5v-1zm6 0A1.5 1.5 0 0 1 7.5 10h1a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5v-1zm6 0a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5v-1z"
                }
            }
        ]
    })(props);
}
function BsDiagram3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 3.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5v1A1.5 1.5 0 0 1 8.5 6v1H14a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 2 7h5.5V6A1.5 1.5 0 0 1 6 4.5v-1zM8.5 5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1zM0 11.5A1.5 1.5 0 0 1 1.5 10h1A1.5 1.5 0 0 1 4 11.5v1A1.5 1.5 0 0 1 2.5 14h-1A1.5 1.5 0 0 1 0 12.5v-1zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zm4.5.5A1.5 1.5 0 0 1 7.5 10h1a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5v-1zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zm4.5.5a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5v-1zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1z"
                }
            }
        ]
    })(props);
}
function BsDiamondFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.482 1.482 0 0 1 0-2.098L6.95.435z"
                }
            }
        ]
    })(props);
}
function BsDiamondHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435zM8 .989c.127 0 .253.049.35.145l6.516 6.516a.495.495 0 0 1 0 .7L8.35 14.866a.493.493 0 0 1-.35.145V.989z"
                }
            }
        ]
    })(props);
}
function BsDiamond(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.482 1.482 0 0 1 0-2.098L6.95.435zm1.4.7a.495.495 0 0 0-.7 0L1.134 7.65a.495.495 0 0 0 0 .7l6.516 6.516a.495.495 0 0 0 .7 0l6.516-6.516a.495.495 0 0 0 0-.7L8.35 1.134z"
                }
            }
        ]
    })(props);
}
function BsDice1Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3zm5 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                }
            }
        ]
    })(props);
}
function BsDice1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "8",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10zM3 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3z"
                }
            }
        ]
    })(props);
}
function BsDice2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3zm5.5 1a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0zm6.5 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
                }
            }
        ]
    })(props);
}
function BsDice2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10zM3 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm8 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
                }
            }
        ]
    })(props);
}
function BsDice3Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3zm2.5 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm8 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM8 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                }
            }
        ]
    })(props);
}
function BsDice3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10zM3 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm8 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm-4-4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
                }
            }
        ]
    })(props);
}
function BsDice4Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3zm1 5.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm8 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1.5 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM4 13.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                }
            }
        ]
    })(props);
}
function BsDice4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10zM3 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm8 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm-8 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
                }
            }
        ]
    })(props);
}
function BsDice5Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3zm2.5 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm8 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM12 13.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM5.5 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM8 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                }
            }
        ]
    })(props);
}
function BsDice5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10zM3 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm8 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm-8 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm4-4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
                }
            }
        ]
    })(props);
}
function BsDice6Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3zm1 5.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm8 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1.5 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM12 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM5.5 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM4 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                }
            }
        ]
    })(props);
}
function BsDice6(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10zM3 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm8 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm-8 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
                }
            }
        ]
    })(props);
}
function BsDiscFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-6 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0zM4 8a4 4 0 0 1 4-4 .5.5 0 0 0 0-1 5 5 0 0 0-5 5 .5.5 0 0 0 1 0zm9 0a.5.5 0 1 0-1 0 4 4 0 0 1-4 4 .5.5 0 0 0 0 1 5 5 0 0 0 5-5z"
                }
            }
        ]
    })(props);
}
function BsDisc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM8 4a4 4 0 0 0-4 4 .5.5 0 0 1-1 0 5 5 0 0 1 5-5 .5.5 0 0 1 0 1zm4.5 3.5a.5.5 0 0 1 .5.5 5 5 0 0 1-5 5 .5.5 0 0 1 0-1 4 4 0 0 0 4-4 .5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsDiscord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.545 2.907a13.227 13.227 0 0 0-3.257-1.011.05.05 0 0 0-.052.025c-.141.25-.297.577-.406.833a12.19 12.19 0 0 0-3.658 0 8.258 8.258 0 0 0-.412-.833.051.051 0 0 0-.052-.025c-1.125.194-2.22.534-3.257 1.011a.041.041 0 0 0-.021.018C.356 6.024-.213 9.047.066 12.032c.001.014.01.028.021.037a13.276 13.276 0 0 0 3.995 2.02.05.05 0 0 0 .056-.019c.308-.42.582-.863.818-1.329a.05.05 0 0 0-.01-.059.051.051 0 0 0-.018-.011 8.875 8.875 0 0 1-1.248-.595.05.05 0 0 1-.02-.066.051.051 0 0 1 .015-.019c.084-.063.168-.129.248-.195a.05.05 0 0 1 .051-.007c2.619 1.196 5.454 1.196 8.041 0a.052.052 0 0 1 .053.007c.08.066.164.132.248.195a.051.051 0 0 1-.004.085 8.254 8.254 0 0 1-1.249.594.05.05 0 0 0-.03.03.052.052 0 0 0 .003.041c.24.465.515.909.817 1.329a.05.05 0 0 0 .056.019 13.235 13.235 0 0 0 4.001-2.02.049.049 0 0 0 .021-.037c.334-3.451-.559-6.449-2.366-9.106a.034.034 0 0 0-.02-.019Zm-8.198 7.307c-.789 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.45.73 1.438 1.613 0 .888-.637 1.612-1.438 1.612Zm5.316 0c-.788 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.451.73 1.438 1.613 0 .888-.631 1.612-1.438 1.612Z"
                }
            }
        ]
    })(props);
}
function BsDisplayFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12c0 .667-.083 1.167-.25 1.5H5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-.75c-.167-.333-.25-.833-.25-1.5h4c2 0 2-2 2-2V4c0-2-2-2-2-2H2C0 2 0 4 0 4v6c0 2 2 2 2 2h4z"
                }
            }
        ]
    })(props);
}
function BsDisplay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4s0-2 2-2h12s2 0 2 2v6s0 2-2 2h-4c0 .667.083 1.167.25 1.5H11a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1h.75c.167-.333.25-.833.25-1.5H2s-2 0-2-2V4zm1.398-.855a.758.758 0 0 0-.254.302A1.46 1.46 0 0 0 1 4.01V10c0 .325.078.502.145.602.07.105.17.188.302.254a1.464 1.464 0 0 0 .538.143L2.01 11H14c.325 0 .502-.078.602-.145a.758.758 0 0 0 .254-.302 1.464 1.464 0 0 0 .143-.538L15 9.99V4c0-.325-.078-.502-.145-.602a.757.757 0 0 0-.302-.254A1.46 1.46 0 0 0 13.99 3H2c-.325 0-.502.078-.602.145z"
                }
            }
        ]
    })(props);
}
function BsDisplayportFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5a1 1 0 0 0-1 1v3.191a1 1 0 0 0 .553.894l1.618.81a1 1 0 0 0 .447.105H15a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H1Zm1.5 2h11a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V8H3v.5a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 .5-.5Z"
                }
            }
        ]
    })(props);
}
function BsDisplayport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0V8h10v.5a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5h-11Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5a1 1 0 0 0-1 1v3.191a1 1 0 0 0 .553.894l1.618.81a1 1 0 0 0 .447.105H15a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H1Zm0 1h14v4H2.618L1 9.191V6Z"
                }
            }
        ]
    })(props);
}
function BsDistributeHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 1 0v-13a.5.5 0 0 0-.5-.5zm-13 0a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 1 0v-13a.5.5 0 0 0-.5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 13a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v10z"
                }
            }
        ]
    })(props);
}
function BsDistributeVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 1.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 0-1h-13a.5.5 0 0 0-.5.5zm0 13a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 0-1h-13a.5.5 0 0 0-.5.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7z"
                }
            }
        ]
    })(props);
}
function BsDoorClosedFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1a1 1 0 0 1 1 1v13h1.5a.5.5 0 0 1 0 1h-13a.5.5 0 0 1 0-1H3V2a1 1 0 0 1 1-1h8zm-2 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                }
            }
        ]
    })(props);
}
function BsDoorClosed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v13h1.5a.5.5 0 0 1 0 1h-13a.5.5 0 0 1 0-1H3V2zm1 13h8V2H4v13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9a1 1 0 1 0 2 0 1 1 0 0 0-2 0z"
                }
            }
        ]
    })(props);
}
function BsDoorOpenFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 15a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1H13V2.5A1.5 1.5 0 0 0 11.5 1H11V.5a.5.5 0 0 0-.57-.495l-7 1A.5.5 0 0 0 3 1.5V15H1.5zM11 2h.5a.5.5 0 0 1 .5.5V15h-1V2zm-2.5 8c-.276 0-.5-.448-.5-1s.224-1 .5-1 .5.448.5 1-.224 1-.5 1z"
                }
            }
        ]
    })(props);
}
function BsDoorOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 10c-.276 0-.5-.448-.5-1s.224-1 .5-1 .5.448.5 1-.224 1-.5 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.828.122A.5.5 0 0 1 11 .5V1h.5A1.5 1.5 0 0 1 13 2.5V15h1.5a.5.5 0 0 1 0 1h-13a.5.5 0 0 1 0-1H3V1.5a.5.5 0 0 1 .43-.495l7-1a.5.5 0 0 1 .398.117zM11.5 2H11v13h1V2.5a.5.5 0 0 0-.5-.5zM4 1.934V15h6V1.077l-6 .857z"
                }
            }
        ]
    })(props);
}
function BsDot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
                }
            }
        ]
    })(props);
}
function BsDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"
                }
            }
        ]
    })(props);
}
function BsDpadFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 0A1.5 1.5 0 0 0 5 1.5v3a.5.5 0 0 1-.5.5h-3A1.5 1.5 0 0 0 0 6.5v3A1.5 1.5 0 0 0 1.5 11h3a.5.5 0 0 1 .5.5v3A1.5 1.5 0 0 0 6.5 16h3a1.5 1.5 0 0 0 1.5-1.5v-3a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 0 16 9.5v-3A1.5 1.5 0 0 0 14.5 5h-3a.5.5 0 0 1-.5-.5v-3A1.5 1.5 0 0 0 9.5 0h-3Zm1.288 2.34a.25.25 0 0 1 .424 0l.799 1.278A.25.25 0 0 1 8.799 4H7.201a.25.25 0 0 1-.212-.382l.799-1.279Zm0 11.32-.799-1.277A.25.25 0 0 1 7.201 12H8.8a.25.25 0 0 1 .212.383l-.799 1.278a.25.25 0 0 1-.424 0Zm-4.17-4.65-1.279-.798a.25.25 0 0 1 0-.424l1.279-.799A.25.25 0 0 1 4 7.201V8.8a.25.25 0 0 1-.382.212Zm10.043-.798-1.278.799A.25.25 0 0 1 12 8.799V7.2a.25.25 0 0 1 .383-.212l1.278.799a.25.25 0 0 1 0 .424Z"
                }
            }
        ]
    })(props);
}
function BsDpad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7.788 2.34-.799 1.278A.25.25 0 0 0 7.201 4h1.598a.25.25 0 0 0 .212-.382l-.799-1.279a.25.25 0 0 0-.424 0Zm0 11.32-.799-1.277A.25.25 0 0 1 7.201 12h1.598a.25.25 0 0 1 .212.383l-.799 1.278a.25.25 0 0 1-.424 0ZM3.617 9.01 2.34 8.213a.25.25 0 0 1 0-.424l1.278-.799A.25.25 0 0 1 4 7.201V8.8a.25.25 0 0 1-.383.212Zm10.043-.798-1.277.799A.25.25 0 0 1 12 8.799V7.2a.25.25 0 0 1 .383-.212l1.278.799a.25.25 0 0 1 0 .424Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 0A1.5 1.5 0 0 0 5 1.5v3a.5.5 0 0 1-.5.5h-3A1.5 1.5 0 0 0 0 6.5v3A1.5 1.5 0 0 0 1.5 11h3a.5.5 0 0 1 .5.5v3A1.5 1.5 0 0 0 6.5 16h3a1.5 1.5 0 0 0 1.5-1.5v-3a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 0 16 9.5v-3A1.5 1.5 0 0 0 14.5 5h-3a.5.5 0 0 1-.5-.5v-3A1.5 1.5 0 0 0 9.5 0h-3ZM6 1.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3A1.5 1.5 0 0 0 11.5 6h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a1.5 1.5 0 0 0-1.5 1.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-3A1.5 1.5 0 0 0 4.5 10h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 0 6 4.5v-3Z"
                }
            }
        ]
    })(props);
}
function BsDribbble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 0C3.584 0 0 3.584 0 8s3.584 8 8 8c4.408 0 8-3.584 8-8s-3.592-8-8-8zm5.284 3.688a6.802 6.802 0 0 1 1.545 4.251c-.226-.043-2.482-.503-4.755-.217-.052-.112-.096-.234-.148-.355-.139-.33-.295-.668-.451-.99 2.516-1.023 3.662-2.498 3.81-2.69zM8 1.18c1.735 0 3.323.65 4.53 1.718-.122.174-1.155 1.553-3.584 2.464-1.12-2.056-2.36-3.74-2.551-4A6.95 6.95 0 0 1 8 1.18zm-2.907.642A43.123 43.123 0 0 1 7.627 5.77c-3.193.85-6.013.833-6.317.833a6.865 6.865 0 0 1 3.783-4.78zM1.163 8.01V7.8c.295.01 3.61.053 7.02-.971.199.381.381.772.555 1.162l-.27.078c-3.522 1.137-5.396 4.243-5.553 4.504a6.817 6.817 0 0 1-1.752-4.564zM8 14.837a6.785 6.785 0 0 1-4.19-1.44c.12-.252 1.509-2.924 5.361-4.269.018-.009.026-.009.044-.017a28.246 28.246 0 0 1 1.457 5.18A6.722 6.722 0 0 1 8 14.837zm3.81-1.171c-.07-.417-.435-2.412-1.328-4.868 2.143-.338 4.017.217 4.251.295a6.774 6.774 0 0 1-2.924 4.573z"
                }
            }
        ]
    })(props);
}
function BsDropbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.01 4.555 4.005 7.11 8.01 9.665 4.005 12.22 0 9.651l4.005-2.555L0 4.555 4.005 2 8.01 4.555Zm-4.026 8.487 4.006-2.555 4.005 2.555-4.005 2.555-4.006-2.555Zm4.026-3.39 4.005-2.556L8.01 4.555 11.995 2 16 4.555 11.995 7.11 16 9.665l-4.005 2.555L8.01 9.651Z"
                }
            }
        ]
    })(props);
}
function BsDropletFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16a6 6 0 0 0 6-6c0-1.655-1.122-2.904-2.432-4.362C10.254 4.176 8.75 2.503 8 0c0 0-6 5.686-6 10a6 6 0 0 0 6 6ZM6.646 4.646l.708.708c-.29.29-1.128 1.311-1.907 2.87l-.894-.448c.82-1.641 1.717-2.753 2.093-3.13Z"
                }
            }
        ]
    })(props);
}
function BsDropletHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.21.8C7.69.295 8 0 8 0c.109.363.234.708.371 1.038.812 1.946 2.073 3.35 3.197 4.6C12.878 7.096 14 8.345 14 10a6 6 0 0 1-12 0C2 6.668 5.58 2.517 7.21.8zm.413 1.021A31.25 31.25 0 0 0 5.794 3.99c-.726.95-1.436 2.008-1.96 3.07C3.304 8.133 3 9.138 3 10c0 0 2.5 1.5 5 .5s5-.5 5-.5c0-1.201-.796-2.157-2.181-3.7l-.03-.032C9.75 5.11 8.5 3.72 7.623 1.82z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.553 7.776c.82-1.641 1.717-2.753 2.093-3.13l.708.708c-.29.29-1.128 1.311-1.907 2.87l-.894-.448z"
                }
            }
        ]
    })(props);
}
function BsDroplet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.21.8C7.69.295 8 0 8 0c.109.363.234.708.371 1.038.812 1.946 2.073 3.35 3.197 4.6C12.878 7.096 14 8.345 14 10a6 6 0 0 1-12 0C2 6.668 5.58 2.517 7.21.8zm.413 1.021A31.25 31.25 0 0 0 5.794 3.99c-.726.95-1.436 2.008-1.96 3.07C3.304 8.133 3 9.138 3 10a5 5 0 0 0 10 0c0-1.201-.796-2.157-2.181-3.7l-.03-.032C9.75 5.11 8.5 3.72 7.623 1.82z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.553 7.776c.82-1.641 1.717-2.753 2.093-3.13l.708.708c-.29.29-1.128 1.311-1.907 2.87l-.894-.448z"
                }
            }
        ]
    })(props);
}
function BsDuffleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.007 4.097c.008-.097.016-.197.027-.298.05-.464.141-.979.313-1.45.169-.465.432-.933.853-1.249 1.115-.836 2.485-.836 3.6 0 .42.316.684.784.853 1.25.171.47.263.985.313 1.449.01.1.02.2.027.298 1.401.194 2.65.531 3.525 1.012 2.126 1.169 1.446 6.095 1.089 8.018a.954.954 0 0 1-.95.772H1.343a.954.954 0 0 1-.95-.772c-.357-1.923-1.037-6.85 1.09-8.018.873-.48 2.123-.818 3.524-1.012ZM4.05 5.633a21.876 21.876 0 0 0-1.565.352l-.091.026-.034.01a.5.5 0 0 0 .282.959l.005-.002.02-.005.08-.023a20.874 20.874 0 0 1 1.486-.334A20.942 20.942 0 0 1 8 6.25c1.439 0 2.781.183 3.767.367a20.854 20.854 0 0 1 1.567.356l.02.005.004.001a.5.5 0 0 0 .283-.959h-.003l-.006-.002-.025-.007a14.787 14.787 0 0 0-.43-.113 21.87 21.87 0 0 0-1.226-.265A21.939 21.939 0 0 0 8 5.25c-1.518 0-2.926.192-3.95.383ZM6.8 1.9c-.203.153-.377.42-.513.791a5.258 5.258 0 0 0-.265 1.292 34.54 34.54 0 0 1 1.374-.076c.866-.022 1.742.003 2.584.076a5.258 5.258 0 0 0-.266-1.292c-.135-.372-.309-.638-.513-.791-.76-.57-1.64-.57-2.4 0Z"
                }
            }
        ]
    })(props);
}
function BsDuffle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5.75c1.388 0 2.673.193 3.609.385a18.404 18.404 0 0 1 1.43.354l.112.034.002.001h.001a.5.5 0 0 1-.308.952l-.004-.002-.018-.005a17.416 17.416 0 0 0-1.417-.354A17.282 17.282 0 0 0 8 6.75a17.3 17.3 0 0 0-3.408.365 17.42 17.42 0 0 0-1.416.354l-.018.005-.003.001a.5.5 0 1 1-.308-.95A17.26 17.26 0 0 1 8 5.75Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.229 2.722c-.126.461-.19.945-.222 1.375-1.401.194-2.65.531-3.525 1.012C-.644 6.278.036 11.204.393 13.127a.954.954 0 0 0 .95.772h13.314a.954.954 0 0 0 .95-.772c.357-1.923 1.037-6.85-1.09-8.018-.873-.48-2.123-.818-3.524-1.012a7.361 7.361 0 0 0-.222-1.375c-.162-.593-.445-1.228-.971-1.622-1.115-.836-2.485-.836-3.6 0-.526.394-.81 1.03-.971 1.622ZM9.2 1.9c.26.195.466.57.606 1.085.088.322.142.667.173.998a23.307 23.307 0 0 0-3.958 0 6.06 6.06 0 0 1 .173-.998c.14-.515.346-.89.606-1.085.76-.57 1.64-.57 2.4 0ZM8 4.9c2.475 0 4.793.402 6.036 1.085.238.13.472.406.655.93.183.522.28 1.195.303 1.952.047 1.486-.189 3.088-.362 4.032H1.368c-.173-.944-.409-2.545-.362-4.032.024-.757.12-1.43.303-1.952.183-.524.417-.8.655-.93C3.207 5.302 5.525 4.9 8 4.9Z"
                }
            }
        ]
    })(props);
}
function BsEarFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 0A5.5 5.5 0 0 0 3 5.5v7.047a3.453 3.453 0 0 0 6.687 1.212l.51-1.363a4.59 4.59 0 0 1 .67-1.197l2.008-2.581A5.34 5.34 0 0 0 8.66 0H8.5ZM7 5.5v2.695c.112-.06.223-.123.332-.192.327-.208.577-.44.72-.727a.5.5 0 1 1 .895.448c-.256.513-.673.865-1.079 1.123A8.538 8.538 0 0 1 7 9.313V11.5a.5.5 0 0 1-1 0v-6a2.5 2.5 0 0 1 5 0V6a.5.5 0 0 1-1 0v-.5a1.5 1.5 0 1 0-3 0Z"
                }
            }
        ]
    })(props);
}
function BsEar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 1A4.5 4.5 0 0 0 4 5.5v7.047a2.453 2.453 0 0 0 4.75.861l.512-1.363a5.553 5.553 0 0 1 .816-1.46l2.008-2.581A4.34 4.34 0 0 0 8.66 1H8.5ZM3 5.5A5.5 5.5 0 0 1 8.5 0h.16a5.34 5.34 0 0 1 4.215 8.618l-2.008 2.581a4.555 4.555 0 0 0-.67 1.197l-.51 1.363A3.453 3.453 0 0 1 3 12.547V5.5ZM8.5 4A1.5 1.5 0 0 0 7 5.5v2.695c.112-.06.223-.123.332-.192.327-.208.577-.44.72-.727a.5.5 0 1 1 .895.448c-.256.513-.673.865-1.079 1.123A8.538 8.538 0 0 1 7 9.313V11.5a.5.5 0 0 1-1 0v-6a2.5 2.5 0 0 1 5 0V6a.5.5 0 0 1-1 0v-.5A1.5 1.5 0 0 0 8.5 4Z"
                }
            }
        ]
    })(props);
}
function BsEarbuds(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.825 4.138c.596 2.141-.36 3.593-2.389 4.117a4.432 4.432 0 0 1-2.018.054c-.048-.01.9 2.778 1.522 4.61l.41 1.205a.52.52 0 0 1-.346.659l-.593.19a.548.548 0 0 1-.69-.34L.184 6.99c-.696-2.137.662-4.309 2.564-4.8 2.029-.523 3.402 0 4.076 1.948zm-.868 2.221c.43-.112.561-.993.292-1.969-.269-.975-.836-1.675-1.266-1.563-.43.112-.561.994-.292 1.969.269.975.836 1.675 1.266 1.563zm3.218-2.221c-.596 2.141.36 3.593 2.389 4.117a4.434 4.434 0 0 0 2.018.054c.048-.01-.9 2.778-1.522 4.61l-.41 1.205a.52.52 0 0 0 .346.659l.593.19c.289.092.6-.06.69-.34l2.536-7.643c.696-2.137-.662-4.309-2.564-4.8-2.029-.523-3.402 0-4.076 1.948zm.868 2.221c-.43-.112-.561-.993-.292-1.969.269-.975.836-1.675 1.266-1.563.43.112.561.994.292 1.969-.269.975-.836 1.675-1.266 1.563z"
                }
            }
        ]
    })(props);
}
function BsEaselFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.473.337a.5.5 0 0 0-.946 0L6.954 2H2a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h1.85l-1.323 3.837a.5.5 0 1 0 .946.326L4.908 11H7.5v2.5a.5.5 0 0 0 1 0V11h2.592l1.435 4.163a.5.5 0 0 0 .946-.326L12.15 11H14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H9.046L8.473.337z"
                }
            }
        ]
    })(props);
}
function BsEasel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a.5.5 0 0 1 .473.337L9.046 2H14a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1.85l1.323 3.837a.5.5 0 1 1-.946.326L11.092 11H8.5v3a.5.5 0 0 1-1 0v-3H4.908l-1.435 4.163a.5.5 0 1 1-.946-.326L3.85 11H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h4.954L7.527.337A.5.5 0 0 1 8 0zM2 3v7h12V3H2z"
                }
            }
        ]
    })(props);
}
function BsEasel2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.447.276a.5.5 0 0 0-.894 0L7.19 1H2.5A1.5 1.5 0 0 0 1 2.5V10h14V2.5A1.5 1.5 0 0 0 13.5 1H8.809L8.447.276Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M.5 11a.5.5 0 0 0 0 1h2.86l-.845 3.379a.5.5 0 0 0 .97.242L3.89 14h8.22l.405 1.621a.5.5 0 0 0 .97-.242L12.64 12h2.86a.5.5 0 0 0 0-1H.5Zm3.64 2 .25-1h7.22l.25 1H4.14Z"
                }
            }
        ]
    })(props);
}
function BsEasel2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 0a.5.5 0 0 1 .447.276L8.81 1h4.69A1.5 1.5 0 0 1 15 2.5V11h.5a.5.5 0 0 1 0 1h-2.86l.845 3.379a.5.5 0 0 1-.97.242L12.11 14H3.89l-.405 1.621a.5.5 0 0 1-.97-.242L3.36 12H.5a.5.5 0 0 1 0-1H1V2.5A1.5 1.5 0 0 1 2.5 1h4.691l.362-.724A.5.5 0 0 1 8 0ZM2 11h12V2.5a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5V11Zm9.61 1H4.39l-.25 1h7.72l-.25-1Z"
                }
            }
        ]
    })(props);
}
function BsEasel3Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 12v1.134a1 1 0 1 1-1 0V12h-5A1.5 1.5 0 0 1 1 10.5V3h14v7.5a1.5 1.5 0 0 1-1.5 1.5h-5Zm7-10a.5.5 0 0 0 0-1H.5a.5.5 0 0 0 0 1h15Z"
                }
            }
        ]
    })(props);
}
function BsEasel3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.5 13.134V12h5a1.5 1.5 0 0 0 1.5-1.5V2h.5a.5.5 0 0 0 0-1H.5a.5.5 0 0 0 0 1H1v8.5A1.5 1.5 0 0 0 2.5 12h5v1.134a1 1 0 1 0 1 0ZM2 2v8.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V2H2Z"
                }
            }
        ]
    })(props);
}
function BsEggFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10a6 6 0 0 1-12 0C2 5.686 5 0 8 0s6 5.686 6 10z"
                }
            }
        ]
    })(props);
}
function BsEggFried(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.997 5.17a5 5 0 0 0-8.101-4.09A5 5 0 0 0 1.28 9.342a5 5 0 0 0 8.336 5.109 3.5 3.5 0 0 0 5.201-4.065 3.001 3.001 0 0 0-.822-5.216zm-1-.034a1 1 0 0 0 .668.977 2.001 2.001 0 0 1 .547 3.478 1 1 0 0 0-.341 1.113 2.5 2.5 0 0 1-3.715 2.905 1 1 0 0 0-1.262.152 4 4 0 0 1-6.67-4.087 1 1 0 0 0-.2-1 4 4 0 0 1 3.693-6.61 1 1 0 0 0 .8-.2 4 4 0 0 1 6.48 3.273z"
                }
            }
        ]
    })(props);
}
function BsEgg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15a5 5 0 0 1-5-5c0-1.956.69-4.286 1.742-6.12.524-.913 1.112-1.658 1.704-2.164C7.044 1.206 7.572 1 8 1c.428 0 .956.206 1.554.716.592.506 1.18 1.251 1.704 2.164C12.31 5.714 13 8.044 13 10a5 5 0 0 1-5 5zm0 1a6 6 0 0 0 6-6c0-4.314-3-10-6-10S2 5.686 2 10a6 6 0 0 0 6 6z"
                }
            }
        ]
    })(props);
}
function BsEjectFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.27 1.047a1 1 0 0 1 1.46 0l6.345 6.77c.6.638.146 1.683-.73 1.683H1.656C.78 9.5.326 8.455.926 7.816L7.27 1.047zM.5 11.5a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1v-1z"
                }
            }
        ]
    })(props);
}
function BsEject(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.27 1.047a1 1 0 0 1 1.46 0l6.345 6.77c.6.638.146 1.683-.73 1.683H1.656C.78 9.5.326 8.455.926 7.816L7.27 1.047zM14.346 8.5 8 1.731 1.654 8.5h12.692zM.5 11.5a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1v-1zm14 0h-13v1h13v-1z"
                }
            }
        ]
    })(props);
}
function BsEmojiAngryFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM4.053 4.276a.5.5 0 0 1 .67-.223l2 1a.5.5 0 0 1 .166.76c.071.206.111.44.111.687C7 7.328 6.552 8 6 8s-1-.672-1-1.5c0-.408.109-.778.285-1.049l-1.009-.504a.5.5 0 0 1-.223-.67zm.232 8.157a.5.5 0 0 1-.183-.683A4.498 4.498 0 0 1 8 9.5a4.5 4.5 0 0 1 3.898 2.25.5.5 0 1 1-.866.5A3.498 3.498 0 0 0 8 10.5a3.498 3.498 0 0 0-3.032 1.75.5.5 0 0 1-.683.183zM10 8c-.552 0-1-.672-1-1.5 0-.247.04-.48.11-.686a.502.502 0 0 1 .166-.761l2-1a.5.5 0 1 1 .448.894l-1.009.504c.176.27.285.64.285 1.049 0 .828-.448 1.5-1 1.5z"
                }
            }
        ]
    })(props);
}
function BsEmojiAngry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.285 12.433a.5.5 0 0 0 .683-.183A3.498 3.498 0 0 1 8 10.5c1.295 0 2.426.703 3.032 1.75a.5.5 0 0 0 .866-.5A4.498 4.498 0 0 0 8 9.5a4.5 4.5 0 0 0-3.898 2.25.5.5 0 0 0 .183.683zm6.991-8.38a.5.5 0 1 1 .448.894l-1.009.504c.176.27.285.64.285 1.049 0 .828-.448 1.5-1 1.5s-1-.672-1-1.5c0-.247.04-.48.11-.686a.502.502 0 0 1 .166-.761l2-1zm-6.552 0a.5.5 0 0 0-.448.894l1.009.504A1.94 1.94 0 0 0 5 6.5C5 7.328 5.448 8 6 8s1-.672 1-1.5c0-.247-.04-.48-.11-.686a.502.502 0 0 0-.166-.761l-2-1z"
                }
            }
        ]
    })(props);
}
function BsEmojiAstonishedFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-4.884-3.978a2.092 2.092 0 0 1 .53.332.5.5 0 0 0 .708-.708h-.001v-.001a1.885 1.885 0 0 0-.237-.197 3.087 3.087 0 0 0-.606-.345 2.996 2.996 0 0 0-2.168-.077.5.5 0 1 0 .316.948 1.997 1.997 0 0 1 1.458.048Zm-4.774-.048a.5.5 0 0 0 .316-.948 2.996 2.996 0 0 0-2.167.077 3.091 3.091 0 0 0-.773.478c-.024.02-.047.042-.07.064l-.002.001a.5.5 0 1 0 .728.689 2.09 2.09 0 0 1 .51-.313 2 2 0 0 1 1.458-.048ZM7 6.5C7 5.672 6.552 5 6 5s-1 .672-1 1.5S5.448 8 6 8s1-.672 1-1.5Zm4 0c0-.828-.448-1.5-1-1.5s-1 .672-1 1.5S9.448 8 10 8s1-.672 1-1.5Zm-5.247 4.746c-.383.478.08 1.06.687.98 1.04-.135 2.08-.135 3.12 0 .606.08 1.07-.502.687-.98C9.747 10.623 8.998 10 8 10c-.998 0-1.747.623-2.247 1.246Z"
                }
            }
        ]
    })(props);
}
function BsEmojiAstonished(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14Zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5Zm4 0c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5ZM4.884 4.022a2 2 0 0 1 1.458-.048.5.5 0 0 0 .316-.948 2.996 2.996 0 0 0-2.167.077 3.091 3.091 0 0 0-.773.478c-.024.02-.047.042-.07.064l-.002.001a.5.5 0 0 0 .707.708l-.001.002.001-.002a1.558 1.558 0 0 1 .122-.1 2.09 2.09 0 0 1 .41-.232Zm6.232 0a1.997 1.997 0 0 0-1.458-.048.5.5 0 1 1-.316-.948 2.996 2.996 0 0 1 2.168.077 3.087 3.087 0 0 1 .773.478l.07.064v.001a.5.5 0 0 1-.706.708l.002.002-.002-.002a1.556 1.556 0 0 0-.122-.1 2.092 2.092 0 0 0-.41-.232ZM8 10c-.998 0-1.747.623-2.247 1.246-.383.478.08 1.06.687.98 1.04-.135 2.08-.135 3.12 0 .606.08 1.07-.502.687-.98C9.747 10.623 8.998 10 8 10Z"
                }
            }
        ]
    })(props);
}
function BsEmojiDizzyFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM4.146 5.146a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 1 1 .708.708l-.647.646.647.646a.5.5 0 1 1-.708.708L5.5 7.207l-.646.647a.5.5 0 1 1-.708-.708l.647-.646-.647-.646a.5.5 0 0 1 0-.708zm5 0a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708.708l-.647.646.647.646a.5.5 0 0 1-.708.708l-.646-.647-.646.647a.5.5 0 1 1-.708-.708l.647-.646-.647-.646a.5.5 0 0 1 0-.708zM8 13a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
                }
            }
        ]
    })(props);
}
function BsEmojiDizzy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.146 5.146a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708.708l-.647.646.647.646a.5.5 0 0 1-.708.708l-.646-.647-.646.647a.5.5 0 1 1-.708-.708l.647-.646-.647-.646a.5.5 0 0 1 0-.708zm-5 0a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 1 1 .708.708l-.647.646.647.646a.5.5 0 1 1-.708.708L5.5 7.207l-.646.647a.5.5 0 1 1-.708-.708l.647-.646-.647-.646a.5.5 0 0 1 0-.708zM10 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
                }
            }
        ]
    })(props);
}
function BsEmojiExpressionlessFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM4.5 6h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm5 0h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm-5 4h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsEmojiExpressionless(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm5 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsEmojiFrownFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zm-2.715 5.933a.5.5 0 0 1-.183-.683A4.498 4.498 0 0 1 8 9.5a4.5 4.5 0 0 1 3.898 2.25.5.5 0 0 1-.866.5A3.498 3.498 0 0 0 8 10.5a3.498 3.498 0 0 0-3.032 1.75.5.5 0 0 1-.683.183zM10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8z"
                }
            }
        ]
    })(props);
}
function BsEmojiFrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.285 12.433a.5.5 0 0 0 .683-.183A3.498 3.498 0 0 1 8 10.5c1.295 0 2.426.703 3.032 1.75a.5.5 0 0 0 .866-.5A4.498 4.498 0 0 0 8 9.5a4.5 4.5 0 0 0-3.898 2.25.5.5 0 0 0 .183.683zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zm4 0c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5z"
                }
            }
        ]
    })(props);
}
function BsEmojiGrimaceFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM7 6.25C7 5.56 6.552 5 6 5s-1 .56-1 1.25.448 1.25 1 1.25 1-.56 1-1.25Zm3 1.25c.552 0 1-.56 1-1.25S10.552 5 10 5s-1 .56-1 1.25.448 1.25 1 1.25Zm1.5 4.5a1.5 1.5 0 0 0 1.48-1.25v-.003a1.512 1.512 0 0 0 0-.497A1.5 1.5 0 0 0 11.5 9h-7a1.5 1.5 0 0 0-1.48 1.25v.003a1.51 1.51 0 0 0 0 .497A1.5 1.5 0 0 0 4.5 12h7Zm-7.969-1.25a1 1 0 0 0 .969.75h.25v-.75H3.531Zm8.938 0a1 1 0 0 1-.969.75h-.25v-.75h1.219ZM11.5 9.5a1 1 0 0 1 .969.75H11.25V9.5h.25Zm-7.969.75A1 1 0 0 1 4.5 9.5h.25v.75H3.531ZM5.25 11.5h1v-.75h-1v.75Zm2.5 0h-1v-.75h1v.75Zm1.5 0h-1v-.75h1v.75Zm1.5 0h-1v-.75h1v.75Zm-1-2h1v.75h-1V9.5Zm-1.5 0h1v.75h-1V9.5Zm-1.5 0h1v.75h-1V9.5Zm-1.5 0h1v.75h-1V9.5Z"
                }
            }
        ]
    })(props);
}
function BsEmojiGrimace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 6.25c0 .69-.448 1.25-1 1.25s-1-.56-1-1.25S5.448 5 6 5s1 .56 1 1.25Zm3 1.25c.552 0 1-.56 1-1.25S10.552 5 10 5s-1 .56-1 1.25.448 1.25 1 1.25Zm2.98 3.25A1.5 1.5 0 0 1 11.5 12h-7a1.5 1.5 0 0 1-1.48-1.747v-.003A1.5 1.5 0 0 1 4.5 9h7a1.5 1.5 0 0 1 1.48 1.747v.003Zm-8.48.75h.25v-.75H3.531a1 1 0 0 0 .969.75Zm7 0a1 1 0 0 0 .969-.75H11.25v.75h.25Zm.969-1.25a1 1 0 0 0-.969-.75h-.25v.75h1.219ZM4.5 9.5a1 1 0 0 0-.969.75H4.75V9.5H4.5Zm1.75 2v-.75h-1v.75h1Zm.5 0h1v-.75h-1v.75Zm1.5 0h1v-.75h-1v.75Zm1.5 0h1v-.75h-1v.75Zm1-2h-1v.75h1V9.5Zm-1.5 0h-1v.75h1V9.5Zm-1.5 0h-1v.75h1V9.5Zm-1.5 0h-1v.75h1V9.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm0-1A7 7 0 1 1 8 1a7 7 0 0 1 0 14Z"
                }
            }
        ]
    })(props);
}
function BsEmojiGrinFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16ZM6.488 7c-.23-.598-.661-1-1.155-1-.493 0-.924.402-1.155 1A2.794 2.794 0 0 1 4 6c0-1.105.597-2 1.333-2 .737 0 1.334.895 1.334 2 0 .364-.065.706-.179 1Zm5.334 0c-.23-.598-.662-1-1.155-1-.494 0-.925.402-1.155 1a2.793 2.793 0 0 1-.179-1c0-1.105.597-2 1.334-2C11.403 4 12 4.895 12 6c0 .364-.065.706-.178 1ZM2.696 8.756a.48.48 0 0 1 .382-.118C4.348 8.786 6.448 9 8 9c1.553 0 3.653-.214 4.922-.362a.48.48 0 0 1 .383.118.3.3 0 0 1 .096.29c-.09.47-.242.921-.445 1.342-.263.035-.576.075-.929.115A36.798 36.798 0 0 1 8 10.75c-1.475 0-2.934-.123-4.027-.247-.353-.04-.666-.08-.93-.115A5.457 5.457 0 0 1 2.6 9.045a.3.3 0 0 1 .097-.29ZM8 13.5a5.49 5.49 0 0 1-4.256-2.017l.116.014c1.115.126 2.615.253 4.14.253 1.525 0 3.025-.127 4.14-.253l.117-.014A5.49 5.49 0 0 1 8 13.5Z"
                }
            }
        ]
    })(props);
}
function BsEmojiGrin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.946 11.398A6.002 6.002 0 0 1 2.108 9.14c-.114-.595.426-1.068 1.028-.997C4.405 8.289 6.48 8.5 8 8.5s3.595-.21 4.864-.358c.602-.07 1.142.402 1.028.998a5.953 5.953 0 0 1-.946 2.258Zm-.078-2.25C11.588 9.295 9.539 9.5 8 9.5c-1.54 0-3.589-.205-4.868-.352.11.468.286.91.517 1.317A36.797 36.797 0 0 0 8 10.75a36.796 36.796 0 0 0 4.351-.285c.231-.407.407-.85.517-1.317Zm-1.36 2.416c-1.02.1-2.255.186-3.508.186-1.253 0-2.488-.086-3.507-.186A4.985 4.985 0 0 0 8 13a4.986 4.986 0 0 0 3.507-1.436ZM6.488 7c.114-.294.179-.636.179-1 0-1.105-.597-2-1.334-2C4.597 4 4 4.895 4 6c0 .364.065.706.178 1 .23-.598.662-1 1.155-1 .494 0 .925.402 1.155 1ZM12 6c0 .364-.065.706-.178 1-.23-.598-.662-1-1.155-1-.494 0-.925.402-1.155 1a2.793 2.793 0 0 1-.179-1c0-1.105.597-2 1.334-2C11.403 4 12 4.895 12 6Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm0-1A7 7 0 1 1 8 1a7 7 0 0 1 0 14Z"
                }
            }
        ]
    })(props);
}
function BsEmojiHeartEyesFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zM4.756 4.566c.763-1.424 4.02-.12.952 3.434-4.496-1.596-2.35-4.298-.952-3.434zm6.559 5.448a.5.5 0 0 1 .548.736A4.498 4.498 0 0 1 7.965 13a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .548-.736h.005l.017.005.067.015.252.055c.215.046.515.108.857.169.693.124 1.522.242 2.152.242.63 0 1.46-.118 2.152-.242a26.58 26.58 0 0 0 1.109-.224l.067-.015.017-.004.005-.002zm-.07-5.448c1.397-.864 3.543 1.838-.953 3.434-3.067-3.554.19-4.858.952-3.434z"
                }
            }
        ]
    })(props);
}
function BsEmojiHeartEyes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.315 10.014a.5.5 0 0 1 .548.736A4.498 4.498 0 0 1 7.965 13a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .548-.736h.005l.017.005.067.015.252.055c.215.046.515.108.857.169.693.124 1.522.242 2.152.242.63 0 1.46-.118 2.152-.242a26.58 26.58 0 0 0 1.109-.224l.067-.015.017-.004.005-.002zM4.756 4.566c.763-1.424 4.02-.12.952 3.434-4.496-1.596-2.35-4.298-.952-3.434zm6.488 0c1.398-.864 3.544 1.838-.952 3.434-3.067-3.554.19-4.858.952-3.434z"
                }
            }
        ]
    })(props);
}
function BsEmojiKissFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M16 8a8 8 0 1 0-2.697 5.99c-.972-.665-1.632-1.356-1.99-2.062-.388-.766-.419-1.561-.075-2.23.496-.97 1.73-1.466 2.762-1.05.65-.262 1.38-.162 1.957.19.028-.275.043-.555.043-.838ZM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5Zm1.512 3.647c-.347.08-.737.198-1.107.319a.5.5 0 1 1-.31-.95c.38-.125.802-.254 1.192-.343.37-.086.78-.153 1.103-.108.16.022.394.085.561.286.188.226.187.497.131.705a1.894 1.894 0 0 1-.31.593c-.077.107-.168.22-.275.343.107.124.199.24.276.347.142.197.256.397.31.595.055.208.056.479-.132.706-.168.2-.404.262-.563.284-.323.043-.733-.027-1.102-.113a14.87 14.87 0 0 1-1.191-.345.5.5 0 1 1 .31-.95c.371.12.761.24 1.109.321.176.041.325.069.446.084a5.609 5.609 0 0 0-.502-.584.5.5 0 0 1 .002-.695 5.52 5.52 0 0 0 .5-.577 4.465 4.465 0 0 0-.448.082Zm.766-.086-.006-.002c.004 0 .006.002.006.002Zm.002 1.867h-.001l-.005.001a.038.038 0 0 1 .006-.002Zm.157-4.685a.5.5 0 0 1-.874-.486A1.934 1.934 0 0 1 10.25 5.75c.73 0 1.356.412 1.687 1.007a.5.5 0 1 1-.874.486.934.934 0 0 0-.813-.493.934.934 0 0 0-.813.493ZM14 9.828c1.11-1.14 3.884.856 0 3.422-3.884-2.566-1.11-4.562 0-3.421Z"
                }
            }
        ]
    })(props);
}
function BsEmojiKiss(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.493 13.368a7 7 0 1 1 2.489-4.858c.344.033.68.147.975.328a8 8 0 1 0-2.654 5.152 8.58 8.58 0 0 1-.81-.622Zm-3.731-3.22a13 13 0 0 0-1.107.318.5.5 0 1 1-.31-.95c.38-.125.802-.254 1.192-.343.37-.086.78-.153 1.103-.108.16.022.394.085.561.286.188.226.187.497.131.705a1.892 1.892 0 0 1-.31.593c-.077.107-.168.22-.275.343.107.124.199.24.276.347.142.197.256.397.31.595.055.208.056.479-.132.706-.168.2-.404.262-.563.284-.323.043-.733-.027-1.102-.113a14.87 14.87 0 0 1-1.191-.345.5.5 0 1 1 .31-.95c.371.12.761.24 1.109.321.176.041.325.069.446.084a5.609 5.609 0 0 0-.502-.584.5.5 0 0 1 .002-.695 5.52 5.52 0 0 0 .5-.577 4.465 4.465 0 0 0-.448.082Zm.766-.087-.003-.001-.003-.001c.004 0 .006.002.006.002Zm.002 1.867-.006.001a.038.038 0 0 1 .006-.002ZM6 8c.552 0 1-.672 1-1.5S6.552 5 6 5s-1 .672-1 1.5S5.448 8 6 8Zm2.757-.563a.5.5 0 0 0 .68-.194.934.934 0 0 1 .813-.493c.339 0 .645.19.813.493a.5.5 0 0 0 .874-.486A1.934 1.934 0 0 0 10.25 5.75c-.73 0-1.356.412-1.687 1.007a.5.5 0 0 0 .194.68ZM14 9.828c1.11-1.14 3.884.856 0 3.422-3.884-2.566-1.11-4.562 0-3.421Z"
                }
            }
        ]
    })(props);
}
function BsEmojiLaughingFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5c0 .501-.164.396-.415.235C6.42 6.629 6.218 6.5 6 6.5c-.218 0-.42.13-.585.235C5.164 6.896 5 7 5 6.5 5 5.672 5.448 5 6 5s1 .672 1 1.5zm5.331 3a1 1 0 0 1 0 1A4.998 4.998 0 0 1 8 13a4.998 4.998 0 0 1-4.33-2.5A1 1 0 0 1 4.535 9h6.93a1 1 0 0 1 .866.5zm-1.746-2.765C10.42 6.629 10.218 6.5 10 6.5c-.218 0-.42.13-.585.235C9.164 6.896 9 7 9 6.5c0-.828.448-1.5 1-1.5s1 .672 1 1.5c0 .501-.164.396-.415.235z"
                }
            }
        ]
    })(props);
}
function BsEmojiLaughing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.331 9.5a1 1 0 0 1 0 1A4.998 4.998 0 0 1 8 13a4.998 4.998 0 0 1-4.33-2.5A1 1 0 0 1 4.535 9h6.93a1 1 0 0 1 .866.5zM7 6.5c0 .828-.448 0-1 0s-1 .828-1 0S5.448 5 6 5s1 .672 1 1.5zm4 0c0 .828-.448 0-1 0s-1 .828-1 0S9.448 5 10 5s1 .672 1 1.5z"
                }
            }
        ]
    })(props);
}
function BsEmojiNeutralFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zm-3 4a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8z"
                }
            }
        ]
    })(props);
}
function BsEmojiNeutral(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5zm3-4C7 5.672 6.552 5 6 5s-1 .672-1 1.5S5.448 8 6 8s1-.672 1-1.5zm4 0c0-.828-.448-1.5-1-1.5s-1 .672-1 1.5S9.448 8 10 8s1-.672 1-1.5z"
                }
            }
        ]
    })(props);
}
function BsEmojiSmileFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zM4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8z"
                }
            }
        ]
    })(props);
}
function BsEmojiSmileUpsideDownFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM7 9.5C7 8.672 6.552 8 6 8s-1 .672-1 1.5.448 1.5 1 1.5 1-.672 1-1.5zM4.285 6.433a.5.5 0 0 0 .683-.183A3.498 3.498 0 0 1 8 4.5c1.295 0 2.426.703 3.032 1.75a.5.5 0 0 0 .866-.5A4.498 4.498 0 0 0 8 3.5a4.5 4.5 0 0 0-3.898 2.25.5.5 0 0 0 .183.683zM10 8c-.552 0-1 .672-1 1.5s.448 1.5 1 1.5 1-.672 1-1.5S10.552 8 10 8z"
                }
            }
        ]
    })(props);
}
function BsEmojiSmileUpsideDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zm0-1a8 8 0 1 1 0 16A8 8 0 0 1 8 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.285 6.433a.5.5 0 0 0 .683-.183A3.498 3.498 0 0 1 8 4.5c1.295 0 2.426.703 3.032 1.75a.5.5 0 0 0 .866-.5A4.498 4.498 0 0 0 8 3.5a4.5 4.5 0 0 0-3.898 2.25.5.5 0 0 0 .183.683zM7 9.5C7 8.672 6.552 8 6 8s-1 .672-1 1.5.448 1.5 1 1.5 1-.672 1-1.5zm4 0c0-.828-.448-1.5-1-1.5s-1 .672-1 1.5.448 1.5 1 1.5 1-.672 1-1.5z"
                }
            }
        ]
    })(props);
}
function BsEmojiSmile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zm4 0c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5z"
                }
            }
        ]
    })(props);
}
function BsEmojiSunglassesFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM2.31 5.243A1 1 0 0 1 3.28 4H6a1 1 0 0 1 1 1v.116A4.22 4.22 0 0 1 8 5c.35 0 .69.04 1 .116V5a1 1 0 0 1 1-1h2.72a1 1 0 0 1 .97 1.243l-.311 1.242A2 2 0 0 1 11.439 8H11a2 2 0 0 1-1.994-1.839A2.99 2.99 0 0 0 8 6c-.393 0-.74.064-1.006.161A2 2 0 0 1 5 8h-.438a2 2 0 0 1-1.94-1.515L2.31 5.243zM4.969 9.75A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .866-.5z"
                }
            }
        ]
    })(props);
}
function BsEmojiSunglasses(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.968 9.75a.5.5 0 1 0-.866.5A4.498 4.498 0 0 0 8 12.5a4.5 4.5 0 0 0 3.898-2.25.5.5 0 1 0-.866-.5A3.498 3.498 0 0 1 8 11.5a3.498 3.498 0 0 1-3.032-1.75zM7 5.116V5a1 1 0 0 0-1-1H3.28a1 1 0 0 0-.97 1.243l.311 1.242A2 2 0 0 0 4.561 8H5a2 2 0 0 0 1.994-1.839A2.99 2.99 0 0 1 8 6c.393 0 .74.064 1.006.161A2 2 0 0 0 11 8h.438a2 2 0 0 0 1.94-1.515l.311-1.242A1 1 0 0 0 12.72 4H10a1 1 0 0 0-1 1v.116A4.22 4.22 0 0 0 8 5c-.35 0-.69.04-1 .116z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-1 0A7 7 0 1 0 1 8a7 7 0 0 0 14 0z"
                }
            }
        ]
    })(props);
}
function BsEmojiSurpriseFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM7 5.5C7 4.672 6.552 4 6 4s-1 .672-1 1.5S5.448 7 6 7s1-.672 1-1.5Zm4 0c0-.828-.448-1.5-1-1.5s-1 .672-1 1.5S9.448 7 10 7s1-.672 1-1.5ZM8 13a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
                }
            }
        ]
    })(props);
}
function BsEmojiSurprise(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14Zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5.5C7 6.328 6.552 7 6 7s-1-.672-1-1.5S5.448 4 6 4s1 .672 1 1.5Zm4 0c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S9.448 4 10 4s1 .672 1 1.5ZM10 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
                }
            }
        ]
    })(props);
}
function BsEmojiTearFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM9.5 3.5a.5.5 0 0 0 .5.5c.838 0 1.65.416 2.053 1.224a.5.5 0 1 0 .894-.448C12.351 3.584 11.162 3 10 3a.5.5 0 0 0-.5.5ZM7 6.5C7 5.672 6.552 5 6 5s-1 .672-1 1.5S5.448 8 6 8s1-.672 1-1.5ZM4.5 13c.828 0 1.5-.746 1.5-1.667 0-.706-.882-2.29-1.294-2.99a.238.238 0 0 0-.412 0C3.882 9.044 3 10.628 3 11.334 3 12.253 3.672 13 4.5 13ZM8 11.197c.916 0 1.607.408 2.25.826.212.138.424-.069.282-.277-.564-.83-1.558-2.049-2.532-2.049-.53 0-1.066.361-1.536.824.083.179.162.36.232.535.045.115.092.241.135.373A3.1 3.1 0 0 1 8 11.197ZM10 8c.552 0 1-.672 1-1.5S10.552 5 10 5s-1 .672-1 1.5S9.448 8 10 8ZM6.5 3c-1.162 0-2.35.584-2.947 1.776a.5.5 0 1 0 .894.448C4.851 4.416 5.662 4 6.5 4a.5.5 0 0 0 0-1Z"
                }
            }
        ]
    })(props);
}
function BsEmojiTear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14Zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.831 11.43A3.1 3.1 0 0 1 8 11.196c.916 0 1.607.408 2.25.826.212.138.424-.069.282-.277-.564-.83-1.558-2.049-2.532-2.049-.53 0-1.066.361-1.536.824.083.179.162.36.232.535.045.115.092.241.135.373ZM6 11.333C6 12.253 5.328 13 4.5 13S3 12.254 3 11.333c0-.706.882-2.29 1.294-2.99a.238.238 0 0 1 .412 0c.412.7 1.294 2.284 1.294 2.99ZM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5Zm4 0c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5Zm-1.5-3A.5.5 0 0 1 10 3c1.162 0 2.35.584 2.947 1.776a.5.5 0 1 1-.894.448C11.649 4.416 10.838 4 10 4a.5.5 0 0 1-.5-.5ZM7 3.5a.5.5 0 0 0-.5-.5c-1.162 0-2.35.584-2.947 1.776a.5.5 0 1 0 .894.448C4.851 4.416 5.662 4 6.5 4a.5.5 0 0 0 .5-.5Z"
                }
            }
        ]
    })(props);
}
function BsEmojiWinkFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM7 6.5C7 5.672 6.552 5 6 5s-1 .672-1 1.5S5.448 8 6 8s1-.672 1-1.5zM4.285 9.567a.5.5 0 0 0-.183.683A4.498 4.498 0 0 0 8 12.5a4.5 4.5 0 0 0 3.898-2.25.5.5 0 1 0-.866-.5A3.498 3.498 0 0 1 8 11.5a3.498 3.498 0 0 1-3.032-1.75.5.5 0 0 0-.683-.183zm5.152-3.31a.5.5 0 0 0-.874.486c.33.595.958 1.007 1.687 1.007.73 0 1.356-.412 1.687-1.007a.5.5 0 0 0-.874-.486.934.934 0 0 1-.813.493.934.934 0 0 1-.813-.493z"
                }
            }
        ]
    })(props);
}
function BsEmojiWink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zm1.757-.437a.5.5 0 0 1 .68.194.934.934 0 0 0 .813.493c.339 0 .645-.19.813-.493a.5.5 0 1 1 .874.486A1.934 1.934 0 0 1 10.25 7.75c-.73 0-1.356-.412-1.687-1.007a.5.5 0 0 1 .194-.68z"
                }
            }
        ]
    })(props);
}
function BsEnvelopeArrowDownFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697Zm.192 8.159 6.57-4.027L8 9.586l1.239-.757.367.225A4.49 4.49 0 0 0 8 12.5c0 .526.09 1.03.256 1.5H2a2 2 0 0 1-1.808-1.144ZM16 4.697v4.974A4.491 4.491 0 0 0 12.5 8a4.49 4.49 0 0 0-1.965.45l-.338-.207L16 4.697Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.354-1.646a.5.5 0 0 1-.722-.016l-1.149-1.25a.5.5 0 1 1 .737-.676l.28.305V11a.5.5 0 0 1 1 0v1.793l.396-.397a.5.5 0 0 1 .708.708l-1.25 1.25Z"
                }
            }
        ]
    })(props);
}
function BsEnvelopeArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4.5a.5.5 0 0 1-1 0V5.383l-7 4.2-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h5.5a.5.5 0 0 1 0 1H2a2 2 0 0 1-2-1.99V4Zm1 7.105 4.708-2.897L1 5.383v5.722ZM1 4v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.354-1.646a.5.5 0 0 1-.722-.016l-1.149-1.25a.5.5 0 1 1 .737-.676l.28.305V11a.5.5 0 0 1 1 0v1.793l.396-.397a.5.5 0 0 1 .708.708l-1.25 1.25Z"
                }
            }
        ]
    })(props);
}
function BsEnvelopeArrowUpFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697Zm.192 8.159 6.57-4.027L8 9.586l1.239-.757.367.225A4.49 4.49 0 0 0 8 12.5c0 .526.09 1.03.256 1.5H2a2 2 0 0 1-1.808-1.144ZM16 4.697v4.974A4.491 4.491 0 0 0 12.5 8a4.49 4.49 0 0 0-1.965.45l-.338-.207L16 4.697Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.354-5.354 1.25 1.25a.5.5 0 0 1-.708.708L13 12.207V14a.5.5 0 0 1-1 0v-1.717l-.28.305a.5.5 0 0 1-.737-.676l1.149-1.25a.5.5 0 0 1 .722-.016Z"
                }
            }
        ]
    })(props);
}
function BsEnvelopeArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4.5a.5.5 0 0 1-1 0V5.383l-7 4.2-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h5.5a.5.5 0 0 1 0 1H2a2 2 0 0 1-2-1.99V4Zm1 7.105 4.708-2.897L1 5.383v5.722ZM1 4v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.354-5.354 1.25 1.25a.5.5 0 0 1-.708.708L13 12.207V14a.5.5 0 0 1-1 0v-1.717l-.28.305a.5.5 0 0 1-.737-.676l1.149-1.25a.5.5 0 0 1 .722-.016Z"
                }
            }
        ]
    })(props);
}
function BsEnvelopeAtFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2A2 2 0 0 0 .05 3.555L8 8.414l7.95-4.859A2 2 0 0 0 14 2H2Zm-2 9.8V4.698l5.803 3.546L0 11.801Zm6.761-2.97-6.57 4.026A2 2 0 0 0 2 14h6.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586l-1.239-.757ZM16 9.671V4.697l-5.803 3.546.338.208A4.482 4.482 0 0 1 12.5 8c1.414 0 2.675.652 3.5 1.671Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.834 12.244c0 1.168-.577 2.025-1.587 2.025-.503 0-1.002-.228-1.12-.648h-.043c-.118.416-.543.643-1.015.643-.77 0-1.259-.542-1.259-1.434v-.529c0-.844.481-1.4 1.26-1.4.585 0 .87.333.953.63h.03v-.568h.905v2.19c0 .272.18.42.411.42.315 0 .639-.415.639-1.39v-.118c0-1.277-.95-2.326-2.484-2.326h-.04c-1.582 0-2.64 1.067-2.64 2.724v.157c0 1.867 1.237 2.654 2.57 2.654h.045c.507 0 .935-.07 1.18-.18v.731c-.219.1-.643.175-1.237.175h-.044C10.438 16 9 14.82 9 12.646v-.214C9 10.36 10.421 9 12.485 9h.035c2.12 0 3.314 1.43 3.314 3.034v.21Zm-4.04.21v.227c0 .586.227.8.581.8.31 0 .564-.17.564-.743v-.367c0-.516-.275-.708-.572-.708-.346 0-.573.245-.573.791Z"
                }
            }
        ]
    })(props);
}
function BsEnvelopeAt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2H2Zm3.708 6.208L1 11.105V5.383l4.708 2.825ZM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2-7-4.2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.247 14.269c1.01 0 1.587-.857 1.587-2.025v-.21C15.834 10.43 14.64 9 12.52 9h-.035C10.42 9 9 10.36 9 12.432v.214C9 14.82 10.438 16 12.358 16h.044c.594 0 1.018-.074 1.237-.175v-.73c-.245.11-.673.18-1.18.18h-.044c-1.334 0-2.571-.788-2.571-2.655v-.157c0-1.657 1.058-2.724 2.64-2.724h.04c1.535 0 2.484 1.05 2.484 2.326v.118c0 .975-.324 1.39-.639 1.39-.232 0-.41-.148-.41-.42v-2.19h-.906v.569h-.03c-.084-.298-.368-.63-.954-.63-.778 0-1.259.555-1.259 1.4v.528c0 .892.49 1.434 1.26 1.434.471 0 .896-.227 1.014-.643h.043c.118.42.617.648 1.12.648Zm-2.453-1.588v-.227c0-.546.227-.791.573-.791.297 0 .572.192.572.708v.367c0 .573-.253.744-.564.744-.354 0-.581-.215-.581-.8Z"
                }
            }
        ]
    })(props);
}
function BsEnvelopeCheckFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.026A2 2 0 0 0 2 14h6.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586l-1.239-.757ZM16 4.697v4.974A4.491 4.491 0 0 0 12.5 8a4.49 4.49 0 0 0-1.965.45l-.338-.207L16 4.697Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z"
                }
            }
        ]
    })(props);
}
function BsEnvelopeCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2H2Zm3.708 6.208L1 11.105V5.383l4.708 2.825ZM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2-7-4.2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z"
                }
            }
        ]
    })(props);
}
function BsEnvelopeDashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.026A2 2 0 0 0 2 14h6.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586l-1.239-.757ZM16 4.697v4.974A4.491 4.491 0 0 0 12.5 8a4.49 4.49 0 0 0-1.965.45l-.338-.207L16 4.697Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-5.5 0a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5Z"
                }
            }
        ]
    })(props);
}
function BsEnvelopeDash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2H2Zm3.708 6.208L1 11.105V5.383l4.708 2.825ZM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2-7-4.2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-5.5 0a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5Z"
                }
            }
        ]
    })(props);
}
function BsEnvelopeExclamationFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.026A2 2 0 0 0 2 14h6.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586l-1.239-.757ZM16 4.697v4.974A4.491 4.491 0 0 0 12.5 8a4.49 4.49 0 0 0-1.965.45l-.338-.207L16 4.697Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.5-5v1.5a.5.5 0 0 1-1 0V11a.5.5 0 0 1 1 0Zm0 3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
                }
            }
        ]
    })(props);
}
function BsEnvelopeExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2H2Zm3.708 6.208L1 11.105V5.383l4.708 2.825ZM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2-7-4.2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.5-5v1.5a.5.5 0 0 1-1 0V11a.5.5 0 0 1 1 0Zm0 3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
                }
            }
        ]
    })(props);
}
function BsEnvelopeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757Zm3.436-.586L16 11.801V4.697l-5.803 3.546Z"
                }
            }
        ]
    })(props);
}
function BsEnvelopeHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555l-4.2 2.568a2.785 2.785 0 0 0-.051-.105c-.666-1.3-2.363-1.917-3.699-1.25-1.336-.667-3.033-.05-3.699 1.25l-.05.105L.05 3.555ZM11.584 8.91a4.694 4.694 0 0 1-.073.139L16 11.8V4.697l-4.003 2.447c.027.562-.107 1.163-.413 1.767Zm-4.135 3.05c-1.048-.693-1.84-1.39-2.398-2.082L.19 12.856A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144L10.95 9.878c-.559.692-1.35 1.389-2.398 2.081L8 12.324l-.551-.365ZM4.416 8.91c-.306-.603-.44-1.204-.413-1.766L0 4.697v7.104l4.49-2.752a4.742 4.742 0 0 1-.074-.138Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z"
                }
            }
        ]
    })(props);
}
function BsEnvelopeHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l3.235 1.94a2.76 2.76 0 0 0-.233 1.027L1 5.384v5.721l3.453-2.124c.146.277.329.556.55.835l-3.97 2.443A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741l-3.968-2.442c.22-.28.403-.56.55-.836L15 11.105V5.383l-3.002 1.801a2.76 2.76 0 0 0-.233-1.026L15 4.217V4a1 1 0 0 0-1-1H2Zm6 2.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z"
                }
            }
        ]
    })(props);
}
function BsEnvelopeOpenFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.941.435a2 2 0 0 0-1.882 0l-6 3.2A2 2 0 0 0 0 5.4v.314l6.709 3.932L8 8.928l1.291.718L16 5.714V5.4a2 2 0 0 0-1.059-1.765l-6-3.2ZM16 6.873l-5.693 3.337L16 13.372v-6.5Zm-.059 7.611L8 10.072.059 14.484A2 2 0 0 0 2 16h12a2 2 0 0 0 1.941-1.516ZM0 13.373l5.693-3.163L0 6.873v6.5Z"
                }
            }
        ]
    })(props);
}
function BsEnvelopeOpenHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.941.435a2 2 0 0 0-1.882 0l-6 3.2A2 2 0 0 0 0 5.4v.313l4.222 2.475c.024-.058.05-.114.08-.17.665-1.3 2.362-1.917 3.698-1.25 1.336-.667 3.033-.05 3.699 1.25a3.3 3.3 0 0 1 .08.17L16 5.713V5.4a2 2 0 0 0-1.059-1.765l-6-3.2ZM0 6.873l4 2.344c-.012.542.124 1.117.416 1.694l.004.006L0 13.372v-6.5Zm.059 7.611 4.9-2.723c.563.73 1.383 1.467 2.49 2.198l.551.365.551-.365c1.107-.73 1.927-1.467 2.49-2.198l4.9 2.723A2 2 0 0 1 14 16H2a2 2 0 0 1-1.941-1.516ZM16 13.372l-4.42-2.455.004-.006c.292-.577.428-1.152.415-1.694L16 6.873v6.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z"
                }
            }
        ]
    })(props);
}
function BsEnvelopeOpenHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.47 1.318a1 1 0 0 0-.94 0l-6 3.2A1 1 0 0 0 1 5.4v.817l3.235 1.94a2.76 2.76 0 0 0-.233 1.027L1 7.384v5.733l3.479-2.087c.15.275.335.553.558.83l-4.002 2.402A1 1 0 0 0 2 15h12a1 1 0 0 0 .965-.738l-4.002-2.401c.223-.278.408-.556.558-.831L15 13.117V7.383l-3.002 1.801a2.76 2.76 0 0 0-.233-1.026L15 6.217V5.4a1 1 0 0 0-.53-.882l-6-3.2ZM7.06.435a2 2 0 0 1 1.882 0l6 3.2A2 2 0 0 1 16 5.4V14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5.4a2 2 0 0 1 1.059-1.765l6-3.2ZM8 7.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132Z"
                }
            }
        ]
    })(props);
}
function BsEnvelopeOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.47 1.318a1 1 0 0 0-.94 0l-6 3.2A1 1 0 0 0 1 5.4v.817l5.75 3.45L8 8.917l1.25.75L15 6.217V5.4a1 1 0 0 0-.53-.882l-6-3.2ZM15 7.383l-4.778 2.867L15 13.117V7.383Zm-.035 6.88L8 10.082l-6.965 4.18A1 1 0 0 0 2 15h12a1 1 0 0 0 .965-.738ZM1 13.116l4.778-2.867L1 7.383v5.734ZM7.059.435a2 2 0 0 1 1.882 0l6 3.2A2 2 0 0 1 16 5.4V14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5.4a2 2 0 0 1 1.059-1.765l6-3.2Z"
                }
            }
        ]
    })(props);
}
function BsEnvelopePaperFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.5 9.5 3 7.5v-6A1.5 1.5 0 0 1 4.5 0h7A1.5 1.5 0 0 1 13 1.5v6l-3.5 2L8 8.75l-1.5.75ZM1.059 3.635 2 3.133v3.753L0 5.713V5.4a2 2 0 0 1 1.059-1.765ZM16 5.713l-2 1.173V3.133l.941.502A2 2 0 0 1 16 5.4v.313Zm0 1.16-5.693 3.337L16 13.372v-6.5Zm-8 3.199 7.941 4.412A2 2 0 0 1 14 16H2a2 2 0 0 1-1.941-1.516L8 10.072Zm-8 3.3 5.693-3.162L0 6.873v6.5Z"
                }
            }
        ]
    })(props);
}
function BsEnvelopePaperHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "m3 7.5 3.5 2L8 8.75l1.5.75 3.5-2v-6A1.5 1.5 0 0 0 11.5 0h-7A1.5 1.5 0 0 0 3 1.5v6ZM2 3.133l-.941.502A2 2 0 0 0 0 5.4v.313l2 1.173V3.133Zm12 3.753 2-1.173V5.4a2 2 0 0 0-1.059-1.765L14 3.133v3.753Zm-3.693 3.324L16 6.873v6.5l-5.693-3.163Zm5.634 4.274L8 10.072.059 14.484A2 2 0 0 0 2 16h12a2 2 0 0 0 1.941-1.516ZM5.693 10.21 0 13.372v-6.5l5.693 3.338ZM8 1.982C9.664.309 13.825 3.236 8 7 2.175 3.236 6.336.31 8 1.982Z"
                }
            }
        ]
    })(props);
}
function BsEnvelopePaperHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v1.133l.941.502A2 2 0 0 1 16 5.4V14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5.4a2 2 0 0 1 1.059-1.765L2 3.133V2Zm0 2.267-.47.25A1 1 0 0 0 1 5.4v.817l1 .6v-2.55Zm1 3.15 3.75 2.25L8 8.917l1.25.75L13 7.417V2a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v5.417Zm11-.6 1-.6V5.4a1 1 0 0 0-.53-.882L14 4.267v2.55ZM8 2.982C9.664 1.309 13.825 4.236 8 8 2.175 4.236 6.336 1.31 8 2.982Zm7 4.401-4.778 2.867L15 13.117V7.383Zm-.035 6.88L8 10.082l-6.965 4.18A1 1 0 0 0 2 15h12a1 1 0 0 0 .965-.738ZM1 13.116l4.778-2.867L1 7.383v5.734Z"
                }
            }
        ]
    })(props);
}
function BsEnvelopePaper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0a2 2 0 0 0-2 2v1.133l-.941.502A2 2 0 0 0 0 5.4V14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5.4a2 2 0 0 0-1.059-1.765L14 3.133V2a2 2 0 0 0-2-2H4Zm10 4.267.47.25A1 1 0 0 1 15 5.4v.817l-1 .6v-2.55Zm-1 3.15-3.75 2.25L8 8.917l-1.25.75L3 7.417V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v5.417Zm-11-.6-1-.6V5.4a1 1 0 0 1 .53-.882L2 4.267v2.55Zm13 .566v5.734l-4.778-2.867L15 7.383Zm-.035 6.88A1 1 0 0 1 14 15H2a1 1 0 0 1-.965-.738L8 10.083l6.965 4.18ZM1 13.116V7.383l4.778 2.867L1 13.117Z"
                }
            }
        ]
    })(props);
}
function BsEnvelopePlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.026A2 2 0 0 0 2 14h6.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586l-1.239-.757ZM16 4.697v4.974A4.491 4.491 0 0 0 12.5 8a4.49 4.49 0 0 0-1.965.45l-.338-.207L16 4.697Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-3.5-2a.5.5 0 0 0-.5.5v1h-1a.5.5 0 0 0 0 1h1v1a.5.5 0 0 0 1 0v-1h1a.5.5 0 0 0 0-1h-1v-1a.5.5 0 0 0-.5-.5Z"
                }
            }
        ]
    })(props);
}
function BsEnvelopePlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2H2Zm3.708 6.208L1 11.105V5.383l4.708 2.825ZM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2-7-4.2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-3.5-2a.5.5 0 0 0-.5.5v1h-1a.5.5 0 0 0 0 1h1v1a.5.5 0 0 0 1 0v-1h1a.5.5 0 0 0 0-1h-1v-1a.5.5 0 0 0-.5-.5Z"
                }
            }
        ]
    })(props);
}
function BsEnvelopeSlashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.026A2 2 0 0 0 2 14h6.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586l-1.239-.757ZM16 4.697v4.974A4.491 4.491 0 0 0 12.5 8a4.49 4.49 0 0 0-1.965.45l-.338-.207L16 4.697Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.975 10.025a3.5 3.5 0 1 0-4.95 4.95 3.5 3.5 0 0 0 4.95-4.95Zm-4.243.707a2.501 2.501 0 0 1 3.147-.318l-3.465 3.465a2.501 2.501 0 0 1 .318-3.147Zm.39 3.854 3.464-3.465a2.501 2.501 0 0 1-3.465 3.465Z"
                }
            }
        ]
    })(props);
}
function BsEnvelopeSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2H2Zm3.708 6.208L1 11.105V5.383l4.708 2.825ZM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2-7-4.2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.975 10.025a3.5 3.5 0 1 0-4.95 4.95 3.5 3.5 0 0 0 4.95-4.95Zm-4.243.707a2.501 2.501 0 0 1 3.147-.318l-3.465 3.465a2.501 2.501 0 0 1 .318-3.147Zm.39 3.854 3.464-3.465a2.501 2.501 0 0 1-3.465 3.465Z"
                }
            }
        ]
    })(props);
}
function BsEnvelopeXFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.026A2 2 0 0 0 2 14h6.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586l-1.239-.757ZM16 4.697v4.974A4.491 4.491 0 0 0 12.5 8a4.49 4.49 0 0 0-1.965.45l-.338-.207L16 4.697Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-4.854-1.354a.5.5 0 0 0 0 .708l.647.646-.647.646a.5.5 0 0 0 .708.708l.646-.647.646.647a.5.5 0 0 0 .708-.708l-.647-.646.647-.646a.5.5 0 0 0-.708-.708l-.646.647-.646-.647a.5.5 0 0 0-.708 0Z"
                }
            }
        ]
    })(props);
}
function BsEnvelopeX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2H2Zm3.708 6.208L1 11.105V5.383l4.708 2.825ZM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2-7-4.2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-4.854-1.354a.5.5 0 0 0 0 .708l.647.646-.647.646a.5.5 0 0 0 .708.708l.646-.647.646.647a.5.5 0 0 0 .708-.708l-.647-.646.647-.646a.5.5 0 0 0-.708-.708l-.646.647-.646-.647a.5.5 0 0 0-.708 0Z"
                }
            }
        ]
    })(props);
}
function BsEnvelope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"
                }
            }
        ]
    })(props);
}
function BsEraserFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.086 2.207a2 2 0 0 1 2.828 0l3.879 3.879a2 2 0 0 1 0 2.828l-5.5 5.5A2 2 0 0 1 7.879 15H5.12a2 2 0 0 1-1.414-.586l-2.5-2.5a2 2 0 0 1 0-2.828l6.879-6.879zm.66 11.34L3.453 8.254 1.914 9.793a1 1 0 0 0 0 1.414l2.5 2.5a1 1 0 0 0 .707.293H7.88a1 1 0 0 0 .707-.293l.16-.16z"
                }
            }
        ]
    })(props);
}
function BsEraser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.086 2.207a2 2 0 0 1 2.828 0l3.879 3.879a2 2 0 0 1 0 2.828l-5.5 5.5A2 2 0 0 1 7.879 15H5.12a2 2 0 0 1-1.414-.586l-2.5-2.5a2 2 0 0 1 0-2.828l6.879-6.879zm2.121.707a1 1 0 0 0-1.414 0L4.16 7.547l5.293 5.293 4.633-4.633a1 1 0 0 0 0-1.414l-3.879-3.879zM8.746 13.547 3.453 8.254 1.914 9.793a1 1 0 0 0 0 1.414l2.5 2.5a1 1 0 0 0 .707.293H7.88a1 1 0 0 0 .707-.293l.16-.16z"
                }
            }
        ]
    })(props);
}
function BsEscape(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.538 1.02a.5.5 0 1 0-.076.998 6 6 0 1 1-6.445 6.444.5.5 0 0 0-.997.076A7 7 0 1 0 8.538 1.02Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.096 7.828a.5.5 0 0 0 .707-.707L2.707 2.025h2.768a.5.5 0 1 0 0-1H1.5a.5.5 0 0 0-.5.5V5.5a.5.5 0 0 0 1 0V2.732l5.096 5.096Z"
                }
            }
        ]
    })(props);
}
function BsEthernet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 13.5v-7a.5.5 0 0 0-.5-.5H12V4.5a.5.5 0 0 0-.5-.5h-1v-.5A.5.5 0 0 0 10 3H6a.5.5 0 0 0-.5.5V4h-1a.5.5 0 0 0-.5.5V6H2.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5ZM3.75 11h.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25Zm2 0h.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25Zm1.75.25a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-1.5ZM9.75 11h.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25Zm1.75.25a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2ZM1 2a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2Z"
                }
            }
        ]
    })(props);
}
function BsEvFrontFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679c.033.161.049.325.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.807.807 0 0 0 .381-.404l.792-1.848Zm6.75.51a.186.186 0 0 0-.23.034L6.05 7.246a.188.188 0 0 0 .137.316h1.241l-.673 2.195a.188.188 0 0 0 .085.218c.075.043.17.03.23-.034l2.88-3.187a.188.188 0 0 0-.137-.316H8.572l.782-2.195a.188.188 0 0 0-.085-.218Z"
                }
            }
        ]
    })(props);
}
function BsEvFront(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.354 4.243a.188.188 0 0 0-.085-.218.186.186 0 0 0-.23.034L6.051 7.246a.188.188 0 0 0 .136.316h1.241l-.673 2.195a.188.188 0 0 0 .085.218c.075.043.17.03.23-.034l2.88-3.187a.188.188 0 0 0-.137-.316H8.572l.782-2.195Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.819 2A2.5 2.5 0 0 0 2.52 3.515l-.792 1.848a.807.807 0 0 1-.38.404c-.5.25-.855.715-.965 1.262L.05 8.708a2.5 2.5 0 0 0-.049.49v.413c0 .814.39 1.543 1 1.997V13.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1.338c1.292.048 2.745.088 4 .088s2.708-.04 4-.088V13.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1.892c.61-.454 1-1.183 1-1.997v-.413c0-.165-.016-.329-.049-.49l-.335-1.68a1.807 1.807 0 0 0-.964-1.261.807.807 0 0 1-.381-.404l-.792-1.848A2.5 2.5 0 0 0 11.181 2H4.82ZM3.44 3.91A1.5 1.5 0 0 1 4.82 3h6.362a1.5 1.5 0 0 1 1.379.91l.792 1.847a1.8 1.8 0 0 0 .853.904c.222.112.381.32.43.564l.336 1.679c.02.097.029.195.029.294v.413a1.48 1.48 0 0 1-1.408 1.484c-1.555.07-3.786.155-5.592.155-1.806 0-4.037-.084-5.592-.155A1.479 1.479 0 0 1 1 9.611v-.413c0-.099.01-.197.03-.294l.335-1.68a.807.807 0 0 1 .43-.563c.383-.19.685-.511.853-.904l.792-1.848Z"
                }
            }
        ]
    })(props);
}
function BsEvStationFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v8a2 2 0 0 1 2 2v.5a.5.5 0 0 0 1 0V9c0-.258-.104-.377-.357-.635l-.007-.008C13.379 8.096 13 7.71 13 7V4a.5.5 0 0 1 .146-.354l.5-.5a.5.5 0 0 1 .708 0l.5.5A.5.5 0 0 1 15 4v8.5a1.5 1.5 0 1 1-3 0V12a1 1 0 0 0-1-1v4h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V2Zm2 .5v5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5Zm2.631 9.96H4.14v-.893h1.403v-.505H4.14v-.855h1.49v-.54H3.485V13h2.146v-.54Zm1.316.54h.794l1.106-3.333h-.733l-.74 2.615h-.031l-.747-2.615h-.764L6.947 13Z"
                }
            }
        ]
    })(props);
}
function BsEvStation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 2a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-5Zm2.131 10.46H4.14v-.893h1.403v-.505H4.14v-.855h1.49v-.54H3.485V13h2.146v-.54Zm1.316.54h.794l1.106-3.333h-.733l-.74 2.615h-.031l-.747-2.615h-.764L6.947 13Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0a2 2 0 0 0-2 2v13H.5a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1H11v-4a1 1 0 0 1 1 1v.5a1.5 1.5 0 0 0 3 0V4a.5.5 0 0 0-.146-.354l-.5-.5a.5.5 0 0 0-.707 0l-.5.5A.5.5 0 0 0 13 4v3c0 .71.38 1.096.636 1.357l.007.008c.253.258.357.377.357.635v3.5a.5.5 0 1 1-1 0V12a2 2 0 0 0-2-2V2a2 2 0 0 0-2-2H3Zm7 2v13H2V2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1Z"
                }
            }
        ]
    })(props);
}
function BsExclamationCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
                }
            }
        ]
    })(props);
}
function BsExclamationCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"
                }
            }
        ]
    })(props);
}
function BsExclamationDiamondFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435zM8 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                }
            }
        ]
    })(props);
}
function BsExclamationDiamond(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.482 1.482 0 0 1 0-2.098L6.95.435zm1.4.7a.495.495 0 0 0-.7 0L1.134 7.65a.495.495 0 0 0 0 .7l6.516 6.516a.495.495 0 0 0 .7 0l6.516-6.516a.495.495 0 0 0 0-.7L8.35 1.134z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"
                }
            }
        ]
    })(props);
}
function BsExclamationLg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.005 3.1a1 1 0 1 1 1.99 0l-.388 6.35a.61.61 0 0 1-1.214 0L7.005 3.1ZM7 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
                }
            }
        ]
    })(props);
}
function BsExclamationOctagonFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.46.146A.5.5 0 0 0 11.107 0H4.893a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353L11.46.146zM8 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                }
            }
        ]
    })(props);
}
function BsExclamationOctagon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.54.146A.5.5 0 0 1 4.893 0h6.214a.5.5 0 0 1 .353.146l4.394 4.394a.5.5 0 0 1 .146.353v6.214a.5.5 0 0 1-.146.353l-4.394 4.394a.5.5 0 0 1-.353.146H4.893a.5.5 0 0 1-.353-.146L.146 11.46A.5.5 0 0 1 0 11.107V4.893a.5.5 0 0 1 .146-.353L4.54.146zM5.1 1 1 5.1v5.8L5.1 15h5.8l4.1-4.1V5.1L10.9 1H5.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"
                }
            }
        ]
    })(props);
}
function BsExclamationSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                }
            }
        ]
    })(props);
}
function BsExclamationSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"
                }
            }
        ]
    })(props);
}
function BsExclamationTriangleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                }
            }
        ]
    })(props);
}
function BsExclamationTriangle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"
                }
            }
        ]
    })(props);
}
function BsExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.553.553 0 0 1-1.1 0L7.1 4.995z"
                }
            }
        ]
    })(props);
}
function BsExclude(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H2a2 2 0 0 1-2-2V2zm12 2H5a1 1 0 0 0-1 1v7h7a1 1 0 0 0 1-1V4z"
                }
            }
        ]
    })(props);
}
function BsExplicitFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 0A2.5 2.5 0 0 0 0 2.5v11A2.5 2.5 0 0 0 2.5 16h11a2.5 2.5 0 0 0 2.5-2.5v-11A2.5 2.5 0 0 0 13.5 0h-11Zm4.326 10.88H10.5V12h-5V4.002h5v1.12H6.826V7.4h3.457v1.073H6.826v2.408Z"
                }
            }
        ]
    })(props);
}
function BsExplicit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.826 10.88H10.5V12h-5V4.002h5v1.12H6.826V7.4h3.457v1.073H6.826v2.408Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 0A2.5 2.5 0 0 0 0 2.5v11A2.5 2.5 0 0 0 2.5 16h11a2.5 2.5 0 0 0 2.5-2.5v-11A2.5 2.5 0 0 0 13.5 0h-11ZM1 2.5A1.5 1.5 0 0 1 2.5 1h11A1.5 1.5 0 0 1 15 2.5v11a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 13.5v-11Z"
                }
            }
        ]
    })(props);
}
function BsExposure(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 4a.5.5 0 0 0-1 0v2h-2a.5.5 0 0 0 0 1h2v2a.5.5 0 0 0 1 0V7h2a.5.5 0 0 0 0-1h-2V4Zm-3 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8Z"
                }
            }
        ]
    })(props);
}
function BsEyeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"
                }
            }
        ]
    })(props);
}
function BsEyeSlashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z"
                }
            }
        ]
    })(props);
}
function BsEyeSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"
                }
            }
        ]
    })(props);
}
function BsEye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"
                }
            }
        ]
    })(props);
}
function BsEyedropper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5 0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207 1.207 0 0 0 0-1.708l-2-2zM2 12.707l7-7L10.293 7l-7 7H2v-1.293z"
                }
            }
        ]
    })(props);
}
function BsEyeglasses(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm2.625.547a3 3 0 0 0-5.584.953H.5a.5.5 0 0 0 0 1h.541A3 3 0 0 0 7 8a1 1 0 0 1 2 0 3 3 0 0 0 5.959.5h.541a.5.5 0 0 0 0-1h-.541a3 3 0 0 0-5.584-.953A1.993 1.993 0 0 0 8 6c-.532 0-1.016.208-1.375.547zM14 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
                }
            }
        ]
    })(props);
}
function BsFacebook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"
                }
            }
        ]
    })(props);
}
function BsFan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3c0 1.313-.304 2.508-.8 3.4a1.991 1.991 0 0 0-1.484-.38c-.28-.982-.91-2.04-1.838-2.969a8.368 8.368 0 0 0-.491-.454A5.976 5.976 0 0 1 8 2c.691 0 1.355.117 1.973.332.018.219.027.442.027.668Zm0 5c0 .073-.004.146-.012.217 1.018-.019 2.2-.353 3.331-1.006a8.39 8.39 0 0 0 .57-.361 6.004 6.004 0 0 0-2.53-3.823 9.02 9.02 0 0 1-.145.64c-.34 1.269-.944 2.346-1.656 3.079.277.343.442.78.442 1.254Zm-.137.728a2.007 2.007 0 0 1-1.07 1.109c.525.87 1.405 1.725 2.535 2.377.2.116.402.222.605.317a5.986 5.986 0 0 0 2.053-4.111c-.208.073-.421.14-.641.199-1.264.339-2.493.356-3.482.11ZM8 10c-.45 0-.866-.149-1.2-.4-.494.89-.796 2.082-.796 3.391 0 .23.01.457.027.678A5.99 5.99 0 0 0 8 14c.94 0 1.83-.216 2.623-.602a8.359 8.359 0 0 1-.497-.458c-.925-.926-1.555-1.981-1.836-2.96-.094.013-.191.02-.29.02ZM6 8c0-.08.005-.16.014-.239-1.02.017-2.205.351-3.34 1.007a8.366 8.366 0 0 0-.568.359 6.003 6.003 0 0 0 2.525 3.839 8.37 8.37 0 0 1 .148-.653c.34-1.267.94-2.342 1.65-3.075A1.988 1.988 0 0 1 6 8Zm-3.347-.632c1.267-.34 2.498-.355 3.488-.107.196-.494.583-.89 1.07-1.1-.524-.874-1.406-1.733-2.541-2.388a8.363 8.363 0 0 0-.594-.312 5.987 5.987 0 0 0-2.06 4.106c.206-.074.418-.14.637-.199ZM8 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14Zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z"
                }
            }
        ]
    })(props);
}
function BsFastForwardBtnFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2Zm4.271 1.055a.5.5 0 0 1 .52.038L8 7.386V5.5a.5.5 0 0 1 .79-.407l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 8 10.5V8.614l-3.21 2.293A.5.5 0 0 1 4 10.5v-5a.5.5 0 0 1 .271-.445Z"
                }
            }
        ]
    })(props);
}
function BsFastForwardBtn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.79 5.093A.5.5 0 0 0 8 5.5v1.886L4.79 5.093A.5.5 0 0 0 4 5.5v5a.5.5 0 0 0 .79.407L8 8.614V10.5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4Z"
                }
            }
        ]
    })(props);
}
function BsFastForwardCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16ZM4.79 5.093 8 7.386V5.5a.5.5 0 0 1 .79-.407l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 8 10.5V8.614l-3.21 2.293A.5.5 0 0 1 4 10.5v-5a.5.5 0 0 1 .79-.407Z"
                }
            }
        ]
    })(props);
}
function BsFastForwardCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14Zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.271 5.055a.5.5 0 0 1 .52.038L8 7.386V5.5a.5.5 0 0 1 .79-.407l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 8 10.5V8.614l-3.21 2.293A.5.5 0 0 1 4 10.5v-5a.5.5 0 0 1 .271-.445Z"
                }
            }
        ]
    })(props);
}
function BsFastForwardFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.596 7.304a.802.802 0 0 1 0 1.392l-6.363 3.692C.713 12.69 0 12.345 0 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.596 7.304a.802.802 0 0 1 0 1.392l-6.363 3.692C8.713 12.69 8 12.345 8 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692Z"
                }
            }
        ]
    })(props);
}
function BsFastForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.804 8 1 4.633v6.734L6.804 8Zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C.713 12.69 0 12.345 0 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.804 8 9 4.633v6.734L14.804 8Zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C8.713 12.69 8 12.345 8 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692Z"
                }
            }
        ]
    })(props);
}
function BsFeather(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.807.531c-.174-.177-.41-.289-.64-.363a3.765 3.765 0 0 0-.833-.15c-.62-.049-1.394 0-2.252.175C10.365.545 8.264 1.415 6.315 3.1c-1.95 1.686-3.168 3.724-3.758 5.423-.294.847-.44 1.634-.429 2.268.005.316.05.62.154.88.017.04.035.082.056.122A68.362 68.362 0 0 0 .08 15.198a.528.528 0 0 0 .157.72.504.504 0 0 0 .705-.16 67.606 67.606 0 0 1 2.158-3.26c.285.141.616.195.958.182.513-.02 1.098-.188 1.723-.49 1.25-.605 2.744-1.787 4.303-3.642l1.518-1.55a.528.528 0 0 0 0-.739l-.729-.744 1.311.209a.504.504 0 0 0 .443-.15c.222-.23.444-.46.663-.684.663-.68 1.292-1.325 1.763-1.892.314-.378.585-.752.754-1.107.163-.345.278-.773.112-1.188a.524.524 0 0 0-.112-.172ZM3.733 11.62C5.385 9.374 7.24 7.215 9.309 5.394l1.21 1.234-1.171 1.196a.526.526 0 0 0-.027.03c-1.5 1.789-2.891 2.867-3.977 3.393-.544.263-.99.378-1.324.39a1.282 1.282 0 0 1-.287-.018Zm6.769-7.22c1.31-1.028 2.7-1.914 4.172-2.6a6.85 6.85 0 0 1-.4.523c-.442.533-1.028 1.134-1.681 1.804l-.51.524-1.581-.25Zm3.346-3.357C9.594 3.147 6.045 6.8 3.149 10.678c.007-.464.121-1.086.37-1.806.533-1.535 1.65-3.415 3.455-4.976 1.807-1.561 3.746-2.36 5.31-2.68a7.97 7.97 0 0 1 1.564-.173Z"
                }
            }
        ]
    })(props);
}
function BsFeather2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 1.063v9.556L6 8.819V3a2 2 0 0 1 1.5-1.937ZM8 0a3 3 0 0 0-3 3v6a.5.5 0 0 0 .116.32L7.5 12.181V15.5a.5.5 0 0 0 1 0v-3.319l2.384-2.86A.5.5 0 0 0 11 9V3a3 3 0 0 0-3-3Zm.5 1.063A2 2 0 0 1 10 3v.293l-1.5 1.5v-3.73ZM10 4.707V8.82l-1.5 1.8V6.207l1.5-1.5Z"
                }
            }
        ]
    })(props);
}
function BsFileArrowDownFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM8 5a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5A.5.5 0 0 1 8 5z"
                }
            }
        ]
    })(props);
}
function BsFileArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5A.5.5 0 0 1 8 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"
                }
            }
        ]
    })(props);
}
function BsFileArrowUpFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM7.5 6.707 6.354 7.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 6.707V10.5a.5.5 0 0 1-1 0V6.707z"
                }
            }
        ]
    })(props);
}
function BsFileArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11a.5.5 0 0 0 .5-.5V6.707l1.146 1.147a.5.5 0 0 0 .708-.708l-2-2a.5.5 0 0 0-.708 0l-2 2a.5.5 0 1 0 .708.708L7.5 6.707V10.5a.5.5 0 0 0 .5.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"
                }
            }
        ]
    })(props);
}
function BsFileBarGraphFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm-2 11.5v-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm-2.5.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1zm-3 0a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-1z"
                }
            }
        ]
    })(props);
}
function BsFileBarGraph(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 12a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-1zm3 0a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1zm3 0a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"
                }
            }
        ]
    })(props);
}
function BsFileBinaryFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.526 9.273c-.542 0-.832.563-.832 1.612 0 .088.003.173.006.252l1.56-1.143c-.126-.474-.375-.72-.733-.72zm-.732 2.508c.126.472.372.718.732.718.54 0 .83-.563.83-1.614 0-.085-.003-.17-.006-.25l-1.556 1.146z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM7.05 10.885c0 1.415-.548 2.206-1.524 2.206C4.548 13.09 4 12.3 4 10.885c0-1.412.548-2.203 1.526-2.203.976 0 1.524.79 1.524 2.203zm3.805 1.52V13h-3v-.595h1.181V9.5h-.05l-1.136.747v-.688l1.19-.786h.69v3.633h1.125z"
                }
            }
        ]
    })(props);
}
function BsFileBinary(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.526 13.09c.976 0 1.524-.79 1.524-2.205 0-1.412-.548-2.203-1.524-2.203-.978 0-1.526.79-1.526 2.203 0 1.415.548 2.206 1.526 2.206zm-.832-2.205c0-1.05.29-1.612.832-1.612.358 0 .607.247.733.721L4.7 11.137a6.749 6.749 0 0 1-.006-.252zm.832 1.614c-.36 0-.606-.246-.732-.718l1.556-1.145c.003.079.005.164.005.249 0 1.052-.29 1.614-.829 1.614zm5.329.501v-.595H9.73V8.772h-.69l-1.19.786v.688L8.986 9.5h.05v2.906h-1.18V13h3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"
                }
            }
        ]
    })(props);
}
function BsFileBreakFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0h8a2 2 0 0 1 2 2v7H2V2a2 2 0 0 1 2-2zM2 12h12v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-2zM.5 10a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1H.5z"
                }
            }
        ]
    })(props);
}
function BsFileBreak(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 10.5a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5zM12 0H4a2 2 0 0 0-2 2v7h1V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v7h1V2a2 2 0 0 0-2-2zm2 12h-1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2H2v2a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-2z"
                }
            }
        ]
    })(props);
}
function BsFileCheckFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm-1.146 6.854-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 8.793l2.646-2.647a.5.5 0 0 1 .708.708z"
                }
            }
        ]
    })(props);
}
function BsFileCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.854 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 8.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"
                }
            }
        ]
    })(props);
}
function BsFileCodeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM6.646 5.646a.5.5 0 1 1 .708.708L5.707 8l1.647 1.646a.5.5 0 0 1-.708.708l-2-2a.5.5 0 0 1 0-.708l2-2zm2.708 0 2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L10.293 8 8.646 6.354a.5.5 0 1 1 .708-.708z"
                }
            }
        ]
    })(props);
}
function BsFileCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.646 5.646a.5.5 0 1 1 .708.708L5.707 8l1.647 1.646a.5.5 0 0 1-.708.708l-2-2a.5.5 0 0 1 0-.708l2-2zm2.708 0a.5.5 0 1 0-.708.708L10.293 8 8.646 9.646a.5.5 0 0 0 .708.708l2-2a.5.5 0 0 0 0-.708l-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function BsFileDiffFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM8.5 4.5V6H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V7H6a.5.5 0 0 1 0-1h1.5V4.5a.5.5 0 0 1 1 0zM6 10h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsFileDiff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4a.5.5 0 0 1 .5.5V6H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V7H6a.5.5 0 0 1 0-1h1.5V4.5A.5.5 0 0 1 8 4zm-2.5 6.5A.5.5 0 0 1 6 10h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkArrowDownFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm-1 4v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 11.293V7.5a.5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 6.5a.5.5 0 0 0-1 0v3.793L6.354 9.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 10.293V6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkArrowUpFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM6.354 9.854a.5.5 0 0 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 8.707V12.5a.5.5 0 0 1-1 0V8.707L6.354 9.854z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 11.5a.5.5 0 0 1-1 0V7.707L6.354 8.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 7.707V11.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkBarGraphFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm.5 10v-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm-2.5.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1zm-3 0a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-1z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkBarGraph(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 13.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v6zm-2.5.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1zm-3 0a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkBinaryFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.526 10.273c-.542 0-.832.563-.832 1.612 0 .088.003.173.006.252l1.559-1.143c-.126-.474-.375-.72-.733-.72zm-.732 2.508c.126.472.372.718.732.718.54 0 .83-.563.83-1.614 0-.085-.003-.17-.006-.25l-1.556 1.146z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm-2.45 8.385c0 1.415-.548 2.206-1.524 2.206C4.548 14.09 4 13.3 4 11.885c0-1.412.548-2.203 1.526-2.203.976 0 1.524.79 1.524 2.203zm3.805 1.52V14h-3v-.595h1.181V10.5h-.05l-1.136.747v-.688l1.19-.786h.69v3.633h1.125z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkBinary(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.05 11.885c0 1.415-.548 2.206-1.524 2.206C4.548 14.09 4 13.3 4 11.885c0-1.412.548-2.203 1.526-2.203.976 0 1.524.79 1.524 2.203zm-1.524-1.612c-.542 0-.832.563-.832 1.612 0 .088.003.173.006.252l1.559-1.143c-.126-.474-.375-.72-.733-.72zm-.732 2.508c.126.472.372.718.732.718.54 0 .83-.563.83-1.614 0-.085-.003-.17-.006-.25l-1.556 1.146zm6.061.624V14h-3v-.595h1.181V10.5h-.05l-1.136.747v-.688l1.19-.786h.69v3.633h1.125z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkBreakFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V9H2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3zM2 12h12v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-2zM.5 10a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1H.5z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkBreak(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4.5V9h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v7H2V2a2 2 0 0 1 2-2h5.5L14 4.5zM13 12h1v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-2h1v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-2zM.5 10a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1H.5z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkCheckFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm1.354 4.354-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708.708z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.854 7.854a.5.5 0 0 0-.708-.708L7.5 9.793 6.354 8.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkCodeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM6.646 7.646a.5.5 0 1 1 .708.708L5.707 10l1.647 1.646a.5.5 0 0 1-.708.708l-2-2a.5.5 0 0 1 0-.708l2-2zm2.708 0 2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L10.293 10 8.646 8.354a.5.5 0 1 1 .708-.708z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.646 6.646a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L10.293 9 8.646 7.354a.5.5 0 0 1 0-.708zm-1.292 0a.5.5 0 0 0-.708 0l-2 2a.5.5 0 0 0 0 .708l2 2a.5.5 0 0 0 .708-.708L5.707 9l1.647-1.646a.5.5 0 0 0 0-.708z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkDiffFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM8 6a.5.5 0 0 1 .5.5V8H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V9H6a.5.5 0 0 1 0-1h1.5V6.5A.5.5 0 0 1 8 6zm-2.5 6.5A.5.5 0 0 1 6 12h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkDiff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5a.5.5 0 0 1 .5.5V7H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V8H6a.5.5 0 0 1 0-1h1.5V5.5A.5.5 0 0 1 8 5zm-2.5 6.5A.5.5 0 0 1 6 11h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkEaselFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM8.5 6h2A1.5 1.5 0 0 1 12 7.5v2a1.5 1.5 0 0 1-1.5 1.5h-.473l.447 1.342a.5.5 0 0 1-.948.316L8.973 11H8.5v1a.5.5 0 0 1-1 0v-1h-.473l-.553 1.658a.5.5 0 1 1-.948-.316L5.973 11H5.5A1.5 1.5 0 0 1 4 9.5v-2A1.5 1.5 0 0 1 5.5 6h2a.5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkEasel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 6a.5.5 0 1 0-1 0h-2A1.5 1.5 0 0 0 4 7.5v2A1.5 1.5 0 0 0 5.5 11h.473l-.447 1.342a.5.5 0 1 0 .948.316L7.027 11H7.5v1a.5.5 0 0 0 1 0v-1h.473l.553 1.658a.5.5 0 1 0 .948-.316L10.027 11h.473A1.5 1.5 0 0 0 12 9.5v-2A1.5 1.5 0 0 0 10.5 6h-2zM5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkExcelFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM5.884 6.68 8 9.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 10l2.233 2.68a.5.5 0 0 1-.768.64L8 10.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 10 5.116 7.32a.5.5 0 1 1 .768-.64z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkExcel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.884 6.68a.5.5 0 1 0-.768.64L7.349 10l-2.233 2.68a.5.5 0 0 0 .768.64L8 10.781l2.116 2.54a.5.5 0 0 0 .768-.641L8.651 10l2.233-2.68a.5.5 0 0 0-.768-.64L8 9.219l-2.116-2.54z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkFontFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM5.057 6h5.886L11 8h-.5c-.18-1.096-.356-1.192-1.694-1.235l-.298-.01v5.09c0 .47.1.582.903.655v.5H6.59v-.5c.799-.073.898-.184.898-.654V6.755l-.293.01C5.856 6.808 5.68 6.905 5.5 8H5l.057-2z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkFont(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.943 6H5.057L5 8h.5c.18-1.096.356-1.192 1.694-1.235l.293-.01v5.09c0 .47-.1.582-.898.655v.5H9.41v-.5c-.803-.073-.903-.184-.903-.654V6.755l.298.01c1.338.043 1.514.14 1.694 1.235h.5l-.057-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkImageFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707v5.586l-2.73-2.73a1 1 0 0 0-1.52.127l-1.889 2.644-1.769-1.062a1 1 0 0 0-1.222.15L2 12.292V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3zm-1.498 4a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.564 8.27 14 11.708V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-.293l3.578-3.577 2.56 1.536 2.426-3.395z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.502 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5V14zM4 1a1 1 0 0 0-1 1v10l2.224-2.224a.5.5 0 0 1 .61-.075L8 11l2.157-3.02a.5.5 0 0 1 .76-.063L13 10V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkLockFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7a1 1 0 0 1 2 0v1H7V7zM6 9.3c0-.042.02-.107.105-.175A.637.637 0 0 1 6.5 9h3a.64.64 0 0 1 .395.125c.085.068.105.133.105.175v2.4c0 .042-.02.107-.105.175A.637.637 0 0 1 9.5 12h-3a.637.637 0 0 1-.395-.125C6.02 11.807 6 11.742 6 11.7V9.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM10 7v1.076c.54.166 1 .597 1 1.224v2.4c0 .816-.781 1.3-1.5 1.3h-3c-.719 0-1.5-.484-1.5-1.3V9.3c0-.627.46-1.058 1-1.224V7a2 2 0 1 1 4 0z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 7v1.076c.54.166 1 .597 1 1.224v2.4c0 .816-.781 1.3-1.5 1.3h-3c-.719 0-1.5-.484-1.5-1.3V9.3c0-.627.46-1.058 1-1.224V7a2 2 0 1 1 4 0zM7 7v1h2V7a1 1 0 0 0-2 0zM6 9.3v2.4c0 .042.02.107.105.175A.637.637 0 0 0 6.5 12h3a.64.64 0 0 0 .395-.125c.085-.068.105-.133.105-.175V9.3c0-.042-.02-.107-.105-.175A.637.637 0 0 0 9.5 9h-3a.637.637 0 0 0-.395.125C6.02 9.193 6 9.258 6 9.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkLock2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7a1 1 0 0 1 2 0v1H7V7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM10 7v1.076c.54.166 1 .597 1 1.224v2.4c0 .816-.781 1.3-1.5 1.3h-3c-.719 0-1.5-.484-1.5-1.3V9.3c0-.627.46-1.058 1-1.224V7a2 2 0 1 1 4 0z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkLock2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 7v1.076c.54.166 1 .597 1 1.224v2.4c0 .816-.781 1.3-1.5 1.3h-3c-.719 0-1.5-.484-1.5-1.3V9.3c0-.627.46-1.058 1-1.224V7a2 2 0 1 1 4 0zM7 7v1h2V7a1 1 0 0 0-2 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkMedicalFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm-3 2v.634l.549-.317a.5.5 0 1 1 .5.866L7 7l.549.317a.5.5 0 1 1-.5.866L6.5 7.866V8.5a.5.5 0 0 1-1 0v-.634l-.549.317a.5.5 0 1 1-.5-.866L5 7l-.549-.317a.5.5 0 0 1 .5-.866l.549.317V5.5a.5.5 0 1 1 1 0zm-2 4.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm0 2h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 5.5a.5.5 0 0 0-1 0v.634l-.549-.317a.5.5 0 1 0-.5.866L6 7l-.549.317a.5.5 0 1 0 .5.866l.549-.317V8.5a.5.5 0 1 0 1 0v-.634l.549.317a.5.5 0 1 0 .5-.866L8 7l.549-.317a.5.5 0 1 0-.5-.866l-.549.317V5.5zm-2 4.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 2a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkMinusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM6 8.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 9a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkMusicFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM11 6.64v1.75l-2 .5v3.61c0 .495-.301.883-.662 1.123C7.974 13.866 7.499 14 7 14c-.5 0-.974-.134-1.338-.377-.36-.24-.662-.628-.662-1.123s.301-.883.662-1.123C6.026 11.134 6.501 11 7 11c.356 0 .7.068 1 .196V6.89a1 1 0 0 1 .757-.97l1-.25A1 1 0 0 1 11 6.64z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkMusic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6.64a1 1 0 0 0-1.243-.97l-1 .25A1 1 0 0 0 8 6.89v4.306A2.572 2.572 0 0 0 7 11c-.5 0-.974.134-1.338.377-.36.24-.662.628-.662 1.123s.301.883.662 1.123c.364.243.839.377 1.338.377.5 0 .974-.134 1.338-.377.36-.24.662-.628.662-1.123V8.89l2-.5V6.64z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkPdfFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.523 12.424c.14-.082.293-.162.459-.238a7.878 7.878 0 0 1-.45.606c-.28.337-.498.516-.635.572a.266.266 0 0 1-.035.012.282.282 0 0 1-.026-.044c-.056-.11-.054-.216.04-.36.106-.165.319-.354.647-.548zm2.455-1.647c-.119.025-.237.05-.356.078a21.148 21.148 0 0 0 .5-1.05 12.045 12.045 0 0 0 .51.858c-.217.032-.436.07-.654.114zm2.525.939a3.881 3.881 0 0 1-.435-.41c.228.005.434.022.612.054.317.057.466.147.518.209a.095.095 0 0 1 .026.064.436.436 0 0 1-.06.2.307.307 0 0 1-.094.124.107.107 0 0 1-.069.015c-.09-.003-.258-.066-.498-.256zM8.278 6.97c-.04.244-.108.524-.2.829a4.86 4.86 0 0 1-.089-.346c-.076-.353-.087-.63-.046-.822.038-.177.11-.248.196-.283a.517.517 0 0 1 .145-.04c.013.03.028.092.032.198.005.122-.007.277-.038.465z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3zM4.165 13.668c.09.18.23.343.438.419.207.075.412.04.58-.03.318-.13.635-.436.926-.786.333-.401.683-.927 1.021-1.51a11.651 11.651 0 0 1 1.997-.406c.3.383.61.713.91.95.28.22.603.403.934.417a.856.856 0 0 0 .51-.138c.155-.101.27-.247.354-.416.09-.181.145-.37.138-.563a.844.844 0 0 0-.2-.518c-.226-.27-.596-.4-.96-.465a5.76 5.76 0 0 0-1.335-.05 10.954 10.954 0 0 1-.98-1.686c.25-.66.437-1.284.52-1.794.036-.218.055-.426.048-.614a1.238 1.238 0 0 0-.127-.538.7.7 0 0 0-.477-.365c-.202-.043-.41 0-.601.077-.377.15-.576.47-.651.823-.073.34-.04.736.046 1.136.088.406.238.848.43 1.295a19.697 19.697 0 0 1-1.062 2.227 7.662 7.662 0 0 0-1.482.645c-.37.22-.699.48-.897.787-.21.326-.275.714-.08 1.103z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkPdf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.603 14.087a.81.81 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.68 7.68 0 0 1 1.482-.645 19.697 19.697 0 0 0 1.062-2.227 7.269 7.269 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a10.954 10.954 0 0 0 .98 1.686 5.753 5.753 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.856.856 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.712 5.712 0 0 1-.911-.95 11.651 11.651 0 0 0-1.997.406 11.307 11.307 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.793.793 0 0 1-.58.029zm1.379-1.901c-.166.076-.32.156-.459.238-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361.01.022.02.036.026.044a.266.266 0 0 0 .035-.012c.137-.056.355-.235.635-.572a8.18 8.18 0 0 0 .45-.606zm1.64-1.33a12.71 12.71 0 0 1 1.01-.193 11.744 11.744 0 0 1-.51-.858 20.801 20.801 0 0 1-.5 1.05zm2.446.45c.15.163.296.3.435.41.24.19.407.253.498.256a.107.107 0 0 0 .07-.015.307.307 0 0 0 .094-.125.436.436 0 0 0 .059-.2.095.095 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a3.876 3.876 0 0 0-.612-.053zM8.078 7.8a6.7 6.7 0 0 0 .2-.828c.031-.188.043-.343.038-.465a.613.613 0 0 0-.032-.198.517.517 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822.024.111.054.227.09.346z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkPersonFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm2 5.755V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-.245S4 12 8 12s5 1.755 5 1.755z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkPerson(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2v9.255S12 12 8 12s-5 1.755-5 1.755V2a1 1 0 0 1 1-1h5.5v2z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkPlayFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM6 6.883a.5.5 0 0 1 .757-.429l3.528 2.117a.5.5 0 0 1 0 .858l-3.528 2.117a.5.5 0 0 1-.757-.43V6.884z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkPlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6.883v4.234a.5.5 0 0 0 .757.429l3.528-2.117a.5.5 0 0 0 0-.858L6.757 6.454a.5.5 0 0 0-.757.43z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkPlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM8.5 7v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7a.5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7a.5.5 0 0 1 .5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkPostFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm-5-.5H7a.5.5 0 0 1 0 1H4.5a.5.5 0 0 1 0-1zm0 3h7a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkPost(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-7zm0-3a.5.5 0 0 1 .5-.5H7a.5.5 0 0 1 0 1H4.5a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkPptFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.188 10H7V6.5h1.188a1.75 1.75 0 1 1 0 3.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3zM7 5.5a1 1 0 0 0-1 1V13a.5.5 0 0 0 1 0v-2h1.188a2.75 2.75 0 0 0 0-5.5H7z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkPpt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5.5a1 1 0 0 0-1 1V13a.5.5 0 0 0 1 0v-2h1.188a2.75 2.75 0 0 0 0-5.5H7zM8.188 10H7V6.5h1.188a1.75 1.75 0 1 1 0 3.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkRichtextFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM7 6.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm-.861 1.542 1.33.886 1.854-1.855a.25.25 0 0 1 .289-.047l1.888.974V9.5a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V9s1.54-1.274 1.639-1.208zM5 11h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1zm0 2h3a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkRichtext(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 12.5A.5.5 0 0 1 5 12h3a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-2A.5.5 0 0 1 5 10h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm1.639-3.708 1.33.886 1.854-1.855a.25.25 0 0 1 .289-.047l1.888.974V8.5a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V8s1.54-1.274 1.639-1.208zM6.25 6a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkRuledFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM3 9h10v1H6v2h7v1H6v2H5v-2H3v-1h2v-2H3V9z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkRuled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V9H3V2a1 1 0 0 1 1-1h5.5v2zM3 12v-2h2v2H3zm0 1h2v2H4a1 1 0 0 1-1-1v-1zm3 2v-2h7v1a1 1 0 0 1-1 1H6zm7-3H6v-2h7v2z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkSlidesFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9.78V7.22c0-.096.106-.156.19-.106l2.13 1.279a.125.125 0 0 1 0 .214l-2.13 1.28A.125.125 0 0 1 7 9.778z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM5 6h6a.5.5 0 0 1 .496.438l.5 4A.5.5 0 0 1 11.5 11h-3v2.016c.863.055 1.5.251 1.5.484 0 .276-.895.5-2 .5s-2-.224-2-.5c0-.233.637-.429 1.5-.484V11h-3a.5.5 0 0 1-.496-.562l.5-4A.5.5 0 0 1 5 6z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkSlides(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 6a.5.5 0 0 0-.496.438l-.5 4A.5.5 0 0 0 4.5 11h3v2.016c-.863.055-1.5.251-1.5.484 0 .276.895.5 2 .5s2-.224 2-.5c0-.233-.637-.429-1.5-.484V11h3a.5.5 0 0 0 .496-.562l-.5-4A.5.5 0 0 0 11 6H5zm2 3.78V7.22c0-.096.106-.156.19-.106l2.13 1.279a.125.125 0 0 1 0 .214l-2.13 1.28A.125.125 0 0 1 7 9.778z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkSpreadsheetFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12v-2h3v2H6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM3 9h10v1h-3v2h3v1h-3v2H9v-2H6v2H5v-2H3v-1h2v-2H3V9z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkSpreadsheet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V9H3V2a1 1 0 0 1 1-1h5.5v2zM3 12v-2h2v2H3zm0 1h2v2H4a1 1 0 0 1-1-1v-1zm3 2v-2h3v2H6zm4 0v-2h3v1a1 1 0 0 1-1 1h-2zm3-3h-3v-2h3v2zm-7 0v-2h3v2H6z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkTextFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM4.5 9a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1h-7zM4 10.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1h-4z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkWordFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM5.485 6.879l1.036 4.144.997-3.655a.5.5 0 0 1 .964 0l.997 3.655 1.036-4.144a.5.5 0 0 1 .97.242l-1.5 6a.5.5 0 0 1-.967.01L8 9.402l-1.018 3.73a.5.5 0 0 1-.967-.01l-1.5-6a.5.5 0 1 1 .97-.242z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkWord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.485 6.879a.5.5 0 1 0-.97.242l1.5 6a.5.5 0 0 0 .967.01L8 9.402l1.018 3.73a.5.5 0 0 0 .967-.01l1.5-6a.5.5 0 0 0-.97-.242l-1.036 4.144-.997-3.655a.5.5 0 0 0-.964 0l-.997 3.655L5.485 6.88z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkXFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM6.854 7.146 8 8.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 9l1.147 1.146a.5.5 0 0 1-.708.708L8 9.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 9 6.146 7.854a.5.5 0 1 1 .708-.708z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.854 7.146a.5.5 0 1 0-.708.708L7.293 9l-1.147 1.146a.5.5 0 0 0 .708.708L8 9.707l1.146 1.147a.5.5 0 0 0 .708-.708L8.707 9l1.147-1.146a.5.5 0 0 0-.708-.708L8 8.293 6.854 7.146z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkZipFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 9.438V8.5h1v.938a1 1 0 0 0 .03.243l.4 1.598-.93.62-.93-.62.4-1.598a1 1 0 0 0 .03-.243z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm-4-.5V2h-1V1H6v1h1v1H6v1h1v1H6v1h1v1H5.5V6h-1V5h1V4h-1V3h1zm0 4.5h1a1 1 0 0 1 1 1v.938l.4 1.599a1 1 0 0 1-.416 1.074l-.93.62a1 1 0 0 1-1.109 0l-.93-.62a1 1 0 0 1-.415-1.074l.4-1.599V8.5a1 1 0 0 1 1-1z"
                }
            }
        ]
    })(props);
}
function BsFileEarmarkZip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 7.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v.938l.4 1.599a1 1 0 0 1-.416 1.074l-.93.62a1 1 0 0 1-1.11 0l-.929-.62a1 1 0 0 1-.415-1.074L5 8.438V7.5zm2 0H6v.938a1 1 0 0 1-.03.243l-.4 1.598.93.62.929-.62-.4-1.598A1 1 0 0 1 7 8.438V7.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1h-2v1h-1v1h1v1h-1v1h1v1H6V5H5V4h1V3H5V2h1V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"
                }
            }
        ]
    })(props);
}
function BsFileEarmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"
                }
            }
        ]
    })(props);
}
function BsFileEaselFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 6.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM8.5 5h2A1.5 1.5 0 0 1 12 6.5v2a1.5 1.5 0 0 1-1.5 1.5h-.473l.447 1.342a.5.5 0 0 1-.948.316L8.973 10H8.5v1a.5.5 0 0 1-1 0v-1h-.473l-.553 1.658a.5.5 0 1 1-.948-.316L5.973 10H5.5A1.5 1.5 0 0 1 4 8.5v-2A1.5 1.5 0 0 1 5.5 5h2a.5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsFileEasel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 5a.5.5 0 1 0-1 0h-2A1.5 1.5 0 0 0 4 6.5v2A1.5 1.5 0 0 0 5.5 10h.473l-.447 1.342a.5.5 0 1 0 .948.316L7.027 10H7.5v1a.5.5 0 0 0 1 0v-1h.473l.553 1.658a.5.5 0 1 0 .948-.316L10.027 10h.473A1.5 1.5 0 0 0 12 8.5v-2A1.5 1.5 0 0 0 10.5 5h-2zM5 6.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function BsFileExcelFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM5.884 4.68 8 7.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 8l2.233 2.68a.5.5 0 0 1-.768.64L8 8.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 8 5.116 5.32a.5.5 0 1 1 .768-.64z"
                }
            }
        ]
    })(props);
}
function BsFileExcel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.18 4.616a.5.5 0 0 1 .704.064L8 7.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 8l2.233 2.68a.5.5 0 0 1-.768.64L8 8.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 8 5.116 5.32a.5.5 0 0 1 .064-.704z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"
                }
            }
        ]
    })(props);
}
function BsFileFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 0h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z"
                }
            }
        ]
    })(props);
}
function BsFileFontFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM5.057 4h5.886L11 6h-.5c-.18-1.096-.356-1.192-1.694-1.235l-.298-.01v6.09c0 .47.1.582.903.655v.5H6.59v-.5c.799-.073.898-.184.898-.654V4.755l-.293.01C5.856 4.808 5.68 4.905 5.5 6H5l.057-2z"
                }
            }
        ]
    })(props);
}
function BsFileFont(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.943 4H5.057L5 6h.5c.18-1.096.356-1.192 1.694-1.235l.293-.01v6.09c0 .47-.1.582-.898.655v.5H9.41v-.5c-.803-.073-.903-.184-.903-.654V4.755l.298.01c1.338.043 1.514.14 1.694 1.235h.5l-.057-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"
                }
            }
        ]
    })(props);
}
function BsFileImageFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0h8a2 2 0 0 1 2 2v8.293l-2.73-2.73a1 1 0 0 0-1.52.127l-1.889 2.644-1.769-1.062a1 1 0 0 0-1.222.15L2 12.292V2a2 2 0 0 1 2-2zm4.002 5.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.564 8.27 14 11.708V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-.293l3.578-3.577 2.56 1.536 2.426-3.395z"
                }
            }
        ]
    })(props);
}
function BsFileImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM3 2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v8l-2.083-2.083a.5.5 0 0 0-.76.063L8 11 5.835 9.7a.5.5 0 0 0-.611.076L3 12V2z"
                }
            }
        ]
    })(props);
}
function BsFileLockFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 6a1 1 0 0 1 2 0v1H7V6zM6 8.3c0-.042.02-.107.105-.175A.637.637 0 0 1 6.5 8h3a.64.64 0 0 1 .395.125c.085.068.105.133.105.175v2.4c0 .042-.02.107-.105.175A.637.637 0 0 1 9.5 11h-3a.637.637 0 0 1-.395-.125C6.02 10.807 6 10.742 6 10.7V8.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm-2 6v1.076c.54.166 1 .597 1 1.224v2.4c0 .816-.781 1.3-1.5 1.3h-3c-.719 0-1.5-.484-1.5-1.3V8.3c0-.627.46-1.058 1-1.224V6a2 2 0 1 1 4 0z"
                }
            }
        ]
    })(props);
}
function BsFileLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5a1 1 0 0 1 1 1v1H7V6a1 1 0 0 1 1-1zm2 2.076V6a2 2 0 1 0-4 0v1.076c-.54.166-1 .597-1 1.224v2.4c0 .816.781 1.3 1.5 1.3h3c.719 0 1.5-.484 1.5-1.3V8.3c0-.627-.46-1.058-1-1.224zM6.105 8.125A.637.637 0 0 1 6.5 8h3a.64.64 0 0 1 .395.125c.085.068.105.133.105.175v2.4c0 .042-.02.107-.105.175A.637.637 0 0 1 9.5 11h-3a.637.637 0 0 1-.395-.125C6.02 10.807 6 10.742 6 10.7V8.3c0-.042.02-.107.105-.175z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"
                }
            }
        ]
    })(props);
}
function BsFileLock2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 6a1 1 0 0 1 2 0v1H7V6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm-2 6v1.076c.54.166 1 .597 1 1.224v2.4c0 .816-.781 1.3-1.5 1.3h-3c-.719 0-1.5-.484-1.5-1.3V8.3c0-.627.46-1.058 1-1.224V6a2 2 0 1 1 4 0z"
                }
            }
        ]
    })(props);
}
function BsFileLock2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5a1 1 0 0 1 1 1v1H7V6a1 1 0 0 1 1-1zm2 2.076V6a2 2 0 1 0-4 0v1.076c-.54.166-1 .597-1 1.224v2.4c0 .816.781 1.3 1.5 1.3h3c.719 0 1.5-.484 1.5-1.3V8.3c0-.627-.46-1.058-1-1.224z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"
                }
            }
        ]
    })(props);
}
function BsFileMedicalFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM8.5 4.5v.634l.549-.317a.5.5 0 1 1 .5.866L9 6l.549.317a.5.5 0 1 1-.5.866L8.5 6.866V7.5a.5.5 0 0 1-1 0v-.634l-.549.317a.5.5 0 1 1-.5-.866L7 6l-.549-.317a.5.5 0 0 1 .5-.866l.549.317V4.5a.5.5 0 1 1 1 0zM5.5 9h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm0 2h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsFileMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 4.5a.5.5 0 0 0-1 0v.634l-.549-.317a.5.5 0 1 0-.5.866L7 6l-.549.317a.5.5 0 1 0 .5.866l.549-.317V7.5a.5.5 0 1 0 1 0v-.634l.549.317a.5.5 0 1 0 .5-.866L9 6l.549-.317a.5.5 0 1 0-.5-.866l-.549.317V4.5zM5.5 9a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 2a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function BsFileMinusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM6 7.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsFileMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"
                }
            }
        ]
    })(props);
}
function BsFileMusicFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm-.5 4.11v1.8l-2.5.5v5.09c0 .495-.301.883-.662 1.123C7.974 12.866 7.499 13 7 13c-.5 0-.974-.134-1.338-.377-.36-.24-.662-.628-.662-1.123s.301-.883.662-1.123C6.026 10.134 6.501 10 7 10c.356 0 .7.068 1 .196V4.41a1 1 0 0 1 .804-.98l1.5-.3a1 1 0 0 1 1.196.98z"
                }
            }
        ]
    })(props);
}
function BsFileMusic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.304 3.13a1 1 0 0 1 1.196.98v1.8l-2.5.5v5.09c0 .495-.301.883-.662 1.123C7.974 12.866 7.499 13 7 13c-.5 0-.974-.134-1.338-.377-.36-.24-.662-.628-.662-1.123s.301-.883.662-1.123C6.026 10.134 6.501 10 7 10c.356 0 .7.068 1 .196V4.41a1 1 0 0 1 .804-.98l1.5-.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"
                }
            }
        ]
    })(props);
}
function BsFilePdfFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.523 10.424c.14-.082.293-.162.459-.238a7.878 7.878 0 0 1-.45.606c-.28.337-.498.516-.635.572a.266.266 0 0 1-.035.012.282.282 0 0 1-.026-.044c-.056-.11-.054-.216.04-.36.106-.165.319-.354.647-.548zm2.455-1.647c-.119.025-.237.05-.356.078a21.035 21.035 0 0 0 .5-1.05 11.96 11.96 0 0 0 .51.858c-.217.032-.436.07-.654.114zm2.525.939a3.888 3.888 0 0 1-.435-.41c.228.005.434.022.612.054.317.057.466.147.518.209a.095.095 0 0 1 .026.064.436.436 0 0 1-.06.2.307.307 0 0 1-.094.124.107.107 0 0 1-.069.015c-.09-.003-.258-.066-.498-.256zM8.278 4.97c-.04.244-.108.524-.2.829a4.86 4.86 0 0 1-.089-.346c-.076-.353-.087-.63-.046-.822.038-.177.11-.248.196-.283a.517.517 0 0 1 .145-.04c.013.03.028.092.032.198.005.122-.007.277-.038.465z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 0h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm.165 11.668c.09.18.23.343.438.419.207.075.412.04.58-.03.318-.13.635-.436.926-.786.333-.401.683-.927 1.021-1.51a11.64 11.64 0 0 1 1.997-.406c.3.383.61.713.91.95.28.22.603.403.934.417a.856.856 0 0 0 .51-.138c.155-.101.27-.247.354-.416.09-.181.145-.37.138-.563a.844.844 0 0 0-.2-.518c-.226-.27-.596-.4-.96-.465a5.76 5.76 0 0 0-1.335-.05 10.954 10.954 0 0 1-.98-1.686c.25-.66.437-1.284.52-1.794.036-.218.055-.426.048-.614a1.238 1.238 0 0 0-.127-.538.7.7 0 0 0-.477-.365c-.202-.043-.41 0-.601.077-.377.15-.576.47-.651.823-.073.34-.04.736.046 1.136.088.406.238.848.43 1.295a19.707 19.707 0 0 1-1.062 2.227 7.662 7.662 0 0 0-1.482.645c-.37.22-.699.48-.897.787-.21.326-.275.714-.08 1.103z"
                }
            }
        ]
    })(props);
}
function BsFilePdf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.603 12.087a.81.81 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.68 7.68 0 0 1 1.482-.645 19.701 19.701 0 0 0 1.062-2.227 7.269 7.269 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.187-.012.395-.047.614-.084.51-.27 1.134-.52 1.794a10.954 10.954 0 0 0 .98 1.686 5.753 5.753 0 0 1 1.334.05c.364.065.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.856.856 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.716 5.716 0 0 1-.911-.95 11.642 11.642 0 0 0-1.997.406 11.311 11.311 0 0 1-1.021 1.51c-.29.35-.608.655-.926.787a.793.793 0 0 1-.58.029zm1.379-1.901c-.166.076-.32.156-.459.238-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361.01.022.02.036.026.044a.27.27 0 0 0 .035-.012c.137-.056.355-.235.635-.572a8.18 8.18 0 0 0 .45-.606zm1.64-1.33a12.647 12.647 0 0 1 1.01-.193 11.666 11.666 0 0 1-.51-.858 20.741 20.741 0 0 1-.5 1.05zm2.446.45c.15.162.296.3.435.41.24.19.407.253.498.256a.107.107 0 0 0 .07-.015.307.307 0 0 0 .094-.125.436.436 0 0 0 .059-.2.095.095 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a3.881 3.881 0 0 0-.612-.053zM8.078 5.8a6.7 6.7 0 0 0 .2-.828c.031-.188.043-.343.038-.465a.613.613 0 0 0-.032-.198.517.517 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822.024.111.054.227.09.346z"
                }
            }
        ]
    })(props);
}
function BsFilePersonFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm-1 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm-3 4c2.623 0 4.146.826 5 1.755V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-1.245C3.854 11.825 5.377 11 8 11z"
                }
            }
        ]
    })(props);
}
function BsFilePerson(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1a1 1 0 0 1 1 1v10.755S12 11 8 11s-5 1.755-5 1.755V2a1 1 0 0 1 1-1h8zM4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                }
            }
        ]
    })(props);
}
function BsFilePlayFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM6 5.883a.5.5 0 0 1 .757-.429l3.528 2.117a.5.5 0 0 1 0 .858l-3.528 2.117a.5.5 0 0 1-.757-.43V5.884z"
                }
            }
        ]
    })(props);
}
function BsFilePlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10.117V5.883a.5.5 0 0 1 .757-.429l3.528 2.117a.5.5 0 0 1 0 .858l-3.528 2.117a.5.5 0 0 1-.757-.43z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"
                }
            }
        ]
    })(props);
}
function BsFilePlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM8.5 6v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsFilePlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 6a.5.5 0 0 0-1 0v1.5H6a.5.5 0 0 0 0 1h1.5V10a.5.5 0 0 0 1 0V8.5H10a.5.5 0 0 0 0-1H8.5V6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function BsFilePostFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM4.5 3h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm0 2h7a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsFilePost(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function BsFilePptFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.188 8.5H7V5h1.188a1.75 1.75 0 1 1 0 3.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm3 4a1 1 0 0 0-1 1v6.5a.5.5 0 0 0 1 0v-2h1.188a2.75 2.75 0 0 0 0-5.5H7z"
                }
            }
        ]
    })(props);
}
function BsFilePpt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 5a1 1 0 0 1 1-1h1.188a2.75 2.75 0 0 1 0 5.5H7v2a.5.5 0 0 1-1 0V5zm1 3.5h1.188a1.75 1.75 0 1 0 0-3.5H7v3.5z"
                }
            }
        ]
    })(props);
}
function BsFileRichtextFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM7 4.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm-.861 1.542 1.33.886 1.854-1.855a.25.25 0 0 1 .289-.047l1.888.974V7.5a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V7s1.54-1.274 1.639-1.208zM5 9h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1zm0 2h3a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsFileRichtext(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 4.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm-.861 1.542 1.33.886 1.854-1.855a.25.25 0 0 1 .289-.047l1.888.974V7.5a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V7s1.54-1.274 1.639-1.208zM5 9a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function BsFileRuledFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v4h12V2a2 2 0 0 0-2-2zm2 7H6v2h8V7zm0 3H6v2h8v-2zm0 3H6v3h6a2 2 0 0 0 2-2v-1zm-9 3v-3H2v1a2 2 0 0 0 2 2h1zm-3-4h3v-2H2v2zm0-3h3V7H2v2z"
                }
            }
        ]
    })(props);
}
function BsFileRuled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm2-1a1 1 0 0 0-1 1v4h10V2a1 1 0 0 0-1-1H4zm9 6H6v2h7V7zm0 3H6v2h7v-2zm0 3H6v2h6a1 1 0 0 0 1-1v-1zm-8 2v-2H3v1a1 1 0 0 0 1 1h1zm-2-3h2v-2H3v2zm0-3h2V7H3v2z"
                }
            }
        ]
    })(props);
}
function BsFileSlidesFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7.78V5.22c0-.096.106-.156.19-.106l2.13 1.279a.125.125 0 0 1 0 .214l-2.13 1.28A.125.125 0 0 1 7 7.778z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM5 4h6a.5.5 0 0 1 .496.438l.5 4A.5.5 0 0 1 11.5 9h-3v2.016c.863.055 1.5.251 1.5.484 0 .276-.895.5-2 .5s-2-.224-2-.5c0-.233.637-.429 1.5-.484V9h-3a.5.5 0 0 1-.496-.562l.5-4A.5.5 0 0 1 5 4z"
                }
            }
        ]
    })(props);
}
function BsFileSlides(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4a.5.5 0 0 0-.496.438l-.5 4A.5.5 0 0 0 4.5 9h3v2.016c-.863.055-1.5.251-1.5.484 0 .276.895.5 2 .5s2-.224 2-.5c0-.233-.637-.429-1.5-.484V9h3a.5.5 0 0 0 .496-.562l-.5-4A.5.5 0 0 0 11 4H5zm2 3.78V5.22c0-.096.106-.156.19-.106l2.13 1.279a.125.125 0 0 1 0 .214l-2.13 1.28A.125.125 0 0 1 7 7.778z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function BsFileSpreadsheetFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v4h12V2a2 2 0 0 0-2-2zm2 7h-4v2h4V7zm0 3h-4v2h4v-2zm0 3h-4v3h2a2 2 0 0 0 2-2v-1zm-5 3v-3H6v3h3zm-4 0v-3H2v1a2 2 0 0 0 2 2h1zm-3-4h3v-2H2v2zm0-3h3V7H2v2zm4 0V7h3v2H6zm0 1h3v2H6v-2z"
                }
            }
        ]
    })(props);
}
function BsFileSpreadsheet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm2-1a1 1 0 0 0-1 1v4h10V2a1 1 0 0 0-1-1H4zm9 6h-3v2h3V7zm0 3h-3v2h3v-2zm0 3h-3v2h2a1 1 0 0 0 1-1v-1zm-4 2v-2H6v2h3zm-4 0v-2H3v1a1 1 0 0 0 1 1h1zm-2-3h2v-2H3v2zm0-3h2V7H3v2zm3-2v2h3V7H6zm3 3H6v2h3v-2z"
                }
            }
        ]
    })(props);
}
function BsFileTextFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM5 4h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zM5 8h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1zm0 2h3a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsFileText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zM5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function BsFileWordFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM5.485 4.879l1.036 4.144.997-3.655a.5.5 0 0 1 .964 0l.997 3.655 1.036-4.144a.5.5 0 0 1 .97.242l-1.5 6a.5.5 0 0 1-.967.01L8 7.402l-1.018 3.73a.5.5 0 0 1-.967-.01l-1.5-6a.5.5 0 1 1 .97-.242z"
                }
            }
        ]
    })(props);
}
function BsFileWord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.879 4.515a.5.5 0 0 1 .606.364l1.036 4.144.997-3.655a.5.5 0 0 1 .964 0l.997 3.655 1.036-4.144a.5.5 0 0 1 .97.242l-1.5 6a.5.5 0 0 1-.967.01L8 7.402l-1.018 3.73a.5.5 0 0 1-.967-.01l-1.5-6a.5.5 0 0 1 .364-.606z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"
                }
            }
        ]
    })(props);
}
function BsFileXFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM6.854 6.146 8 7.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 8l1.147 1.146a.5.5 0 0 1-.708.708L8 8.707 6.854 9.854a.5.5 0 0 1-.708-.708L7.293 8 6.146 6.854a.5.5 0 1 1 .708-.708z"
                }
            }
        ]
    })(props);
}
function BsFileX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.146 6.146a.5.5 0 0 1 .708 0L8 7.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 8l1.147 1.146a.5.5 0 0 1-.708.708L8 8.707 6.854 9.854a.5.5 0 0 1-.708-.708L7.293 8 6.146 6.854a.5.5 0 0 1 0-.708z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"
                }
            }
        ]
    })(props);
}
function BsFileZipFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 9.438V8.5h-1v.938a1 1 0 0 1-.03.243l-.4 1.598.93.62.93-.62-.4-1.598a1 1 0 0 1-.03-.243z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm2.5 8.5v.938l-.4 1.599a1 1 0 0 0 .416 1.074l.93.62a1 1 0 0 0 1.109 0l.93-.62a1 1 0 0 0 .415-1.074l-.4-1.599V8.5a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1zm1-5.5h-1v1h1v1h-1v1h1v1H9V6H8V5h1V4H8V3h1V2H8V1H6.5v1h1v1z"
                }
            }
        ]
    })(props);
}
function BsFileZip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 7.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v.938l.4 1.599a1 1 0 0 1-.416 1.074l-.93.62a1 1 0 0 1-1.109 0l-.93-.62a1 1 0 0 1-.415-1.074l.4-1.599V7.5zm2 0h-1v.938a1 1 0 0 1-.03.243l-.4 1.598.93.62.93-.62-.4-1.598a1 1 0 0 1-.03-.243V7.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm5.5-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9v1H8v1h1v1H8v1h1v1H7.5V5h-1V4h1V3h-1V2h1V1z"
                }
            }
        ]
    })(props);
}
function BsFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"
                }
            }
        ]
    })(props);
}
function BsFilesAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 0H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2 2 2 0 0 0 2-2V4a2 2 0 0 0-2-2 2 2 0 0 0-2-2zm2 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1V3zM2 2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V2z"
                }
            }
        ]
    })(props);
}
function BsFiles(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z"
                }
            }
        ]
    })(props);
}
function BsFiletypeAac(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5Zm-5.808 8.554a1.732 1.732 0 0 0-.103.633v.495c0 .246.035.455.103.627a.834.834 0 0 0 .299.393.845.845 0 0 0 .477.131.872.872 0 0 0 .402-.088.699.699 0 0 0 .272-.248.8.8 0 0 0 .117-.364h.765v.076a1.268 1.268 0 0 1-.226.674c-.136.194-.32.345-.55.454a1.81 1.81 0 0 1-.785.164c-.36 0-.665-.072-.915-.216a1.424 1.424 0 0 1-.57-.627c-.13-.272-.194-.597-.194-.976v-.498c0-.379.065-.705.196-.978.13-.274.321-.485.571-.633.252-.149.556-.223.912-.223.218 0 .42.032.606.097.187.062.35.153.49.272a1.325 1.325 0 0 1 .465.964v.073h-.765a.85.85 0 0 0-.12-.38.7.7 0 0 0-.272-.261.802.802 0 0 0-.399-.097.814.814 0 0 0-.474.138.868.868 0 0 0-.302.398ZM.8 15.925l.313-1.028H2.45l.314 1.028h.84l-1.335-3.999h-.926l-1.342 4h.8Zm1.002-3.234.489 1.617H1.277l.49-1.617h.035Zm2.63 3.234.313-1.028H6.08l.313 1.028h.841L5.9 11.926h-.926l-1.341 4h.8Zm1.001-3.234.49 1.617H4.909l.49-1.617h.034Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeAi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2H6v-1h6a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.113 14.82.8 15.85H0l1.342-3.999h.926l1.336 3.999h-.841l-.314-1.028H1.113Zm1.178-.588-.49-1.617h-.034l-.49 1.617h1.014Zm2.425-2.382v3.999h-.791V11.85h.79Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeBmp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM0 15.849h1.664c.272 0 .512-.044.72-.132.21-.09.374-.219.493-.386.12-.168.179-.372.179-.61a.986.986 0 0 0-.123-.51.846.846 0 0 0-.323-.325 1.084 1.084 0 0 0-.445-.14v-.036a1 1 0 0 0 .352-.16.79.79 0 0 0 .243-.294.932.932 0 0 0 .09-.422c0-.308-.107-.55-.322-.723-.215-.174-.5-.261-.858-.261H0v3.999Zm.785-3.404h.7c.186 0 .33.047.431.14.104.092.155.22.155.384a.52.52 0 0 1-.082.296.497.497 0 0 1-.249.185 1.222 1.222 0 0 1-.433.064H.785v-1.07Zm0 1.62h.75c.154 0 .285.024.393.073a.51.51 0 0 1 .24.211.61.61 0 0 1 .082.325c0 .19-.068.334-.205.434-.137.098-.36.146-.671.146H.785v-1.19Zm3.474 1.784v-2.66h.038l.952 2.16h.515l.947-2.16h.038v2.66h.715V11.85h-.8l-1.14 2.596h-.026l-1.14-2.596h-.805v3.999h.706Zm3.918-3.999h1.6c.289 0 .533.06.732.179.201.117.355.276.46.477.106.201.159.427.159.677 0 .25-.054.476-.162.677-.105.199-.26.357-.462.474a1.452 1.452 0 0 1-.733.173h-.803v1.342h-.79V11.85Zm2.06 1.714a.794.794 0 0 0 .085-.381c0-.226-.062-.4-.185-.521-.123-.122-.294-.182-.512-.182h-.66v1.406h.66a.794.794 0 0 0 .375-.082.574.574 0 0 0 .237-.24Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeCs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2H8v-1h4a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM3.629 15.29a1.176 1.176 0 0 1-.112-.449h.765a.578.578 0 0 0 .255.384c.07.049.153.087.249.114.096.028.202.041.32.041.163 0 .301-.023.412-.07a.559.559 0 0 0 .255-.193.507.507 0 0 0 .085-.29.387.387 0 0 0-.152-.326c-.102-.08-.256-.144-.463-.193l-.618-.143a1.72 1.72 0 0 1-.54-.214 1.001 1.001 0 0 1-.35-.367 1.068 1.068 0 0 1-.124-.524c0-.244.064-.457.19-.639.128-.181.303-.322.528-.422.225-.1.483-.149.776-.149.305 0 .565.05.78.152.216.102.383.239.5.41.12.17.186.359.2.566h-.75a.56.56 0 0 0-.12-.258.624.624 0 0 0-.246-.181.923.923 0 0 0-.37-.068c-.216 0-.387.05-.512.152a.472.472 0 0 0-.185.384c0 .121.048.22.144.3a.97.97 0 0 0 .404.175l.621.143c.217.05.405.12.566.211.16.09.285.21.375.358.09.148.134.335.134.56 0 .247-.062.466-.187.656a1.216 1.216 0 0 1-.54.439c-.234.105-.52.158-.858.158a2.21 2.21 0 0 1-.665-.09 1.404 1.404 0 0 1-.477-.252 1.13 1.13 0 0 1-.29-.375Zm-2.72-2.23a1.732 1.732 0 0 0-.103.633v.495c0 .246.034.455.102.627a.833.833 0 0 0 .299.392.845.845 0 0 0 .478.132.86.86 0 0 0 .4-.088.7.7 0 0 0 .273-.249.799.799 0 0 0 .118-.363h.764v.076a1.27 1.27 0 0 1-.225.674c-.137.193-.32.345-.551.454a1.81 1.81 0 0 1-.785.164c-.36 0-.664-.072-.914-.217a1.424 1.424 0 0 1-.572-.626C.064 14.892 0 14.567 0 14.188v-.498c0-.38.065-.705.196-.979a1.44 1.44 0 0 1 .572-.633c.252-.148.555-.222.91-.222.22 0 .422.032.607.097.188.062.35.153.49.272a1.324 1.324 0 0 1 .465.964v.073h-.764a.85.85 0 0 0-.12-.38.7.7 0 0 0-.273-.261.803.803 0 0 0-.398-.097.814.814 0 0 0-.475.138.868.868 0 0 0-.302.398Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeCss(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM3.397 14.841a1.13 1.13 0 0 0 .401.823c.13.108.289.192.478.252.19.061.411.091.665.091.338 0 .624-.053.859-.158.236-.105.416-.252.539-.44.125-.189.187-.408.187-.656 0-.224-.045-.41-.134-.56a1.001 1.001 0 0 0-.375-.357 2.027 2.027 0 0 0-.566-.21l-.621-.144a.97.97 0 0 1-.404-.176.37.37 0 0 1-.144-.299c0-.156.062-.284.185-.384.125-.101.296-.152.512-.152.143 0 .266.023.37.068a.624.624 0 0 1 .246.181.56.56 0 0 1 .12.258h.75a1.092 1.092 0 0 0-.2-.566 1.21 1.21 0 0 0-.5-.41 1.813 1.813 0 0 0-.78-.152c-.293 0-.551.05-.776.15-.225.099-.4.24-.527.421-.127.182-.19.395-.19.639 0 .201.04.376.122.524.082.149.2.27.352.367.152.095.332.167.539.213l.618.144c.207.049.361.113.463.193a.387.387 0 0 1 .152.326.505.505 0 0 1-.085.29.559.559 0 0 1-.255.193c-.111.047-.249.07-.413.07-.117 0-.223-.013-.32-.04a.838.838 0 0 1-.248-.115.578.578 0 0 1-.255-.384h-.765ZM.806 13.693c0-.248.034-.46.102-.633a.868.868 0 0 1 .302-.399.814.814 0 0 1 .475-.137c.15 0 .283.032.398.097a.7.7 0 0 1 .272.26.85.85 0 0 1 .12.381h.765v-.072a1.33 1.33 0 0 0-.466-.964 1.441 1.441 0 0 0-.489-.272 1.838 1.838 0 0 0-.606-.097c-.356 0-.66.074-.911.223-.25.148-.44.359-.572.632-.13.274-.196.6-.196.979v.498c0 .379.064.704.193.976.131.271.322.48.572.626.25.145.554.217.914.217.293 0 .554-.055.785-.164.23-.11.414-.26.55-.454a1.27 1.27 0 0 0 .226-.674v-.076h-.764a.799.799 0 0 1-.118.363.7.7 0 0 1-.272.25.874.874 0 0 1-.401.087.845.845 0 0 1-.478-.132.833.833 0 0 1-.299-.392 1.699 1.699 0 0 1-.102-.627v-.495ZM6.78 15.29a1.176 1.176 0 0 1-.111-.449h.764a.578.578 0 0 0 .255.384c.07.049.154.087.25.114.095.028.201.041.319.041.164 0 .301-.023.413-.07a.559.559 0 0 0 .255-.193.507.507 0 0 0 .085-.29.387.387 0 0 0-.153-.326c-.101-.08-.256-.144-.463-.193l-.618-.143a1.72 1.72 0 0 1-.539-.214 1 1 0 0 1-.351-.367 1.068 1.068 0 0 1-.123-.524c0-.244.063-.457.19-.639.127-.181.303-.322.527-.422.225-.1.484-.149.777-.149.304 0 .564.05.779.152.217.102.384.239.5.41.12.17.187.359.2.566h-.75a.56.56 0 0 0-.12-.258.624.624 0 0 0-.246-.181.923.923 0 0 0-.37-.068c-.216 0-.387.05-.512.152a.472.472 0 0 0-.184.384c0 .121.047.22.143.3a.97.97 0 0 0 .404.175l.621.143c.217.05.406.12.566.211.16.09.285.21.375.358.09.148.135.335.135.56 0 .247-.063.466-.188.656a1.216 1.216 0 0 1-.539.439c-.234.105-.52.158-.858.158-.254 0-.476-.03-.665-.09a1.404 1.404 0 0 1-.478-.252 1.13 1.13 0 0 1-.29-.375Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeCsv(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM3.517 14.841a1.13 1.13 0 0 0 .401.823c.13.108.289.192.478.252.19.061.411.091.665.091.338 0 .624-.053.859-.158.236-.105.416-.252.539-.44.125-.189.187-.408.187-.656 0-.224-.045-.41-.134-.56a1.001 1.001 0 0 0-.375-.357 2.027 2.027 0 0 0-.566-.21l-.621-.144a.97.97 0 0 1-.404-.176.37.37 0 0 1-.144-.299c0-.156.062-.284.185-.384.125-.101.296-.152.512-.152.143 0 .266.023.37.068a.624.624 0 0 1 .246.181.56.56 0 0 1 .12.258h.75a1.092 1.092 0 0 0-.2-.566 1.21 1.21 0 0 0-.5-.41 1.813 1.813 0 0 0-.78-.152c-.293 0-.551.05-.776.15-.225.099-.4.24-.527.421-.127.182-.19.395-.19.639 0 .201.04.376.122.524.082.149.2.27.352.367.152.095.332.167.539.213l.618.144c.207.049.361.113.463.193a.387.387 0 0 1 .152.326.505.505 0 0 1-.085.29.559.559 0 0 1-.255.193c-.111.047-.249.07-.413.07-.117 0-.223-.013-.32-.04a.838.838 0 0 1-.248-.115.578.578 0 0 1-.255-.384h-.765ZM.806 13.693c0-.248.034-.46.102-.633a.868.868 0 0 1 .302-.399.814.814 0 0 1 .475-.137c.15 0 .283.032.398.097a.7.7 0 0 1 .272.26.85.85 0 0 1 .12.381h.765v-.072a1.33 1.33 0 0 0-.466-.964 1.441 1.441 0 0 0-.489-.272 1.838 1.838 0 0 0-.606-.097c-.356 0-.66.074-.911.223-.25.148-.44.359-.572.632-.13.274-.196.6-.196.979v.498c0 .379.064.704.193.976.131.271.322.48.572.626.25.145.554.217.914.217.293 0 .554-.055.785-.164.23-.11.414-.26.55-.454a1.27 1.27 0 0 0 .226-.674v-.076h-.764a.799.799 0 0 1-.118.363.7.7 0 0 1-.272.25.874.874 0 0 1-.401.087.845.845 0 0 1-.478-.132.833.833 0 0 1-.299-.392 1.699 1.699 0 0 1-.102-.627v-.495Zm8.239 2.238h-.953l-1.338-3.999h.917l.896 3.138h.038l.888-3.138h.879l-1.327 4Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeDoc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5Zm-7.839 9.166v.522c0 .256-.039.47-.117.641a.861.861 0 0 1-.322.387.877.877 0 0 1-.469.126.883.883 0 0 1-.471-.126.868.868 0 0 1-.32-.386 1.55 1.55 0 0 1-.117-.642v-.522c0-.257.04-.471.117-.641a.868.868 0 0 1 .32-.387.868.868 0 0 1 .471-.129c.176 0 .332.043.469.13a.861.861 0 0 1 .322.386c.078.17.117.384.117.641Zm.803.519v-.513c0-.377-.068-.7-.205-.972a1.46 1.46 0 0 0-.589-.63c-.254-.147-.56-.22-.917-.22-.355 0-.662.073-.92.22a1.441 1.441 0 0 0-.589.627c-.136.271-.205.596-.205.975v.513c0 .375.069.7.205.973.137.271.333.48.59.627.257.144.564.216.92.216.357 0 .662-.072.916-.216.256-.147.452-.356.59-.627.136-.274.204-.598.204-.973ZM0 11.926v4h1.459c.402 0 .735-.08.999-.238a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.59-.68c-.263-.156-.598-.234-1.004-.234H0Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.141 1.141 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082H.79V12.57Zm7.422.483a1.732 1.732 0 0 0-.103.633v.495c0 .246.034.455.103.627a.834.834 0 0 0 .298.393.845.845 0 0 0 .478.131.868.868 0 0 0 .401-.088.699.699 0 0 0 .273-.248.8.8 0 0 0 .117-.364h.765v.076a1.268 1.268 0 0 1-.226.674c-.137.194-.32.345-.55.454a1.81 1.81 0 0 1-.786.164c-.36 0-.664-.072-.914-.216a1.424 1.424 0 0 1-.571-.627c-.13-.272-.194-.597-.194-.976v-.498c0-.379.066-.705.197-.978.13-.274.321-.485.571-.633.252-.149.556-.223.911-.223.219 0 .421.032.607.097.187.062.35.153.489.272a1.326 1.326 0 0 1 .466.964v.073H9.78a.85.85 0 0 0-.12-.38.7.7 0 0 0-.273-.261.802.802 0 0 0-.398-.097.814.814 0 0 0-.475.138.868.868 0 0 0-.301.398Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeDocx(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V11h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5Zm-6.839 9.688v-.522a1.54 1.54 0 0 0-.117-.641.861.861 0 0 0-.322-.387.862.862 0 0 0-.469-.129.868.868 0 0 0-.471.13.868.868 0 0 0-.32.386 1.54 1.54 0 0 0-.117.641v.522c0 .256.04.47.117.641a.868.868 0 0 0 .32.387.883.883 0 0 0 .471.126.877.877 0 0 0 .469-.126.861.861 0 0 0 .322-.386 1.55 1.55 0 0 0 .117-.642Zm.803-.516v.513c0 .375-.068.7-.205.973a1.47 1.47 0 0 1-.589.627c-.254.144-.56.216-.917.216a1.86 1.86 0 0 1-.92-.216 1.463 1.463 0 0 1-.589-.627 2.151 2.151 0 0 1-.205-.973v-.513c0-.379.069-.704.205-.975.137-.274.333-.483.59-.627.257-.147.564-.22.92-.22.357 0 .662.073.916.22.256.146.452.356.59.63.136.271.204.595.204.972ZM1 15.925v-3.999h1.459c.406 0 .741.078 1.005.235.264.156.46.382.589.68.13.296.196.655.196 1.074 0 .422-.065.784-.196 1.084-.131.301-.33.53-.595.689-.264.158-.597.237-.999.237H1Zm1.354-3.354H1.79v2.707h.563c.185 0 .346-.028.483-.082a.8.8 0 0 0 .334-.252c.088-.114.153-.254.196-.422a2.3 2.3 0 0 0 .068-.592c0-.3-.04-.552-.118-.753a.89.89 0 0 0-.354-.454c-.158-.102-.361-.152-.61-.152Zm6.756 1.116c0-.248.034-.46.103-.633a.868.868 0 0 1 .301-.398.814.814 0 0 1 .475-.138c.15 0 .283.032.398.097a.7.7 0 0 1 .273.26.85.85 0 0 1 .12.381h.765v-.073a1.33 1.33 0 0 0-.466-.964 1.44 1.44 0 0 0-.49-.272 1.836 1.836 0 0 0-.606-.097c-.355 0-.66.074-.911.223-.25.148-.44.359-.571.633-.131.273-.197.6-.197.978v.498c0 .379.065.704.194.976.13.271.321.48.571.627.25.144.555.216.914.216.293 0 .555-.054.785-.164.23-.11.414-.26.551-.454a1.27 1.27 0 0 0 .226-.674v-.076h-.765a.8.8 0 0 1-.117.364.699.699 0 0 1-.273.248.874.874 0 0 1-.401.088.845.845 0 0 1-.478-.131.834.834 0 0 1-.298-.393 1.7 1.7 0 0 1-.103-.627v-.495Zm5.092-1.76h.894l-1.275 2.006 1.254 1.992h-.908l-.85-1.415h-.035l-.852 1.415h-.862l1.24-2.015-1.228-1.984h.932l.832 1.439h.035l.823-1.439Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeExe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM2.575 15.202H.785v-1.073H2.47v-.606H.785v-1.025h1.79v-.648H0v3.999h2.575v-.647ZM6.31 11.85h-.893l-.823 1.439h-.036l-.832-1.439h-.931l1.227 1.983-1.239 2.016h.861l.853-1.415h.035l.85 1.415h.908l-1.254-1.992L6.31 11.85Zm1.025 3.352h1.79v.647H6.548V11.85h2.576v.648h-1.79v1.025h1.684v.606H7.334v1.073Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeGif(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2H9v-1h3a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM3.278 13.124a1.403 1.403 0 0 0-.14-.492 1.317 1.317 0 0 0-.314-.407 1.447 1.447 0 0 0-.48-.275 1.88 1.88 0 0 0-.636-.1c-.361 0-.67.076-.926.229a1.48 1.48 0 0 0-.583.632 2.136 2.136 0 0 0-.199.95v.506c0 .272.035.52.105.745.07.224.177.417.32.58.142.162.32.288.533.377.215.088.466.132.753.132.268 0 .5-.037.697-.111a1.29 1.29 0 0 0 .788-.77c.065-.174.097-.358.097-.551v-.797H1.717v.589h.823v.255c0 .132-.03.254-.09.363a.67.67 0 0 1-.273.264.967.967 0 0 1-.457.096.87.87 0 0 1-.519-.146.881.881 0 0 1-.305-.413 1.785 1.785 0 0 1-.096-.615v-.499c0-.365.078-.648.234-.85.158-.2.38-.301.665-.301a.96.96 0 0 1 .3.044c.09.03.17.071.236.126a.689.689 0 0 1 .17.19.797.797 0 0 1 .097.25h.776Zm1.353 2.801v-3.999H3.84v4h.79Zm1.493-1.59v1.59h-.791v-3.999H7.88v.653H6.124v1.117h1.605v.638H6.124Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeHeic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V11h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5Zm-4.637 8.554a1.732 1.732 0 0 0-.103.633v.495c0 .246.034.455.103.627a.834.834 0 0 0 .299.393.846.846 0 0 0 .477.131.868.868 0 0 0 .401-.088.698.698 0 0 0 .273-.248.8.8 0 0 0 .117-.364h.765v.076a1.268 1.268 0 0 1-.226.674c-.137.194-.32.345-.55.454a1.81 1.81 0 0 1-.786.164c-.36 0-.664-.072-.914-.216a1.424 1.424 0 0 1-.571-.627c-.129-.272-.194-.597-.194-.976v-.498c0-.379.066-.705.197-.978.13-.274.321-.485.571-.633.252-.149.556-.223.911-.223.219 0 .421.032.607.097.187.062.35.153.489.272a1.324 1.324 0 0 1 .466.964v.073h-.765a.85.85 0 0 0-.12-.38.7.7 0 0 0-.273-.261.802.802 0 0 0-.398-.097.814.814 0 0 0-.475.138.868.868 0 0 0-.301.398Zm-6.1-1.128v4h-.79V14.21H.79v1.714H0v-3.999h.791v1.626h1.682v-1.626h.79Zm1.488 3.352h1.79v.647H3.966v-3.999H6.54v.648H4.75v1.025h1.684v.607H4.751v1.072Zm3.163.647v-3.999h-.791v4h.79Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeHtml(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V11h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5Zm-9.736 7.35v3.999h-.791v-1.714H1.79v1.714H1V11.85h.791v1.626h1.682V11.85h.79Zm2.251.662v3.337h-.794v-3.337H4.588v-.662h3.064v.662H6.515Zm2.176 3.337v-2.66h.038l.952 2.159h.516l.946-2.16h.038v2.661h.715V11.85h-.8l-1.14 2.596H9.93L8.79 11.85h-.805v3.999h.706Zm4.71-.674h1.696v.674H12.61V11.85h.79v3.325Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeJava(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V11h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.521 15.175a1.321 1.321 0 0 1-.082-.466h.765a.577.577 0 0 0 .073.27.499.499 0 0 0 .454.246c.19 0 .33-.055.422-.164.092-.11.138-.265.138-.466V11.85h.79v2.725c0 .44-.118.774-.357 1.005-.236.23-.564.345-.984.345a1.59 1.59 0 0 1-.568-.094 1.144 1.144 0 0 1-.408-.266 1.139 1.139 0 0 1-.243-.39Zm3.972-.354-.314 1.028h-.8l1.342-3.999h.926l1.336 3.999h-.84l-.314-1.028H5.493Zm1.178-.59-.49-1.616h-.035l-.49 1.617h1.015Zm2.342 1.618h.952l1.327-3.999h-.878l-.888 3.138h-.038L8.59 11.85h-.917l1.34 3.999Zm3.087-1.028-.314 1.028h-.8l1.342-3.999h.926l1.336 3.999h-.84l-.314-1.028H12.1Zm1.178-.59-.49-1.616h-.035l-.49 1.617h1.015Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeJpg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5Zm-4.34 8.132c.076.153.123.317.14.492h-.776a.797.797 0 0 0-.097-.249.689.689 0 0 0-.17-.19.707.707 0 0 0-.237-.126.96.96 0 0 0-.299-.044c-.285 0-.507.1-.665.302-.156.201-.234.484-.234.85v.498c0 .234.032.439.097.615a.881.881 0 0 0 .304.413.87.87 0 0 0 .519.146.967.967 0 0 0 .457-.096.67.67 0 0 0 .272-.264c.06-.11.091-.23.091-.363v-.255H8.24v-.59h1.576v.798c0 .193-.032.377-.097.55a1.29 1.29 0 0 1-.293.458 1.37 1.37 0 0 1-.495.313c-.197.074-.43.111-.697.111a1.98 1.98 0 0 1-.753-.132 1.447 1.447 0 0 1-.533-.377 1.58 1.58 0 0 1-.32-.58 2.482 2.482 0 0 1-.105-.745v-.506c0-.362.066-.678.2-.95.134-.271.328-.482.582-.633.256-.152.565-.228.926-.228.238 0 .45.033.636.1.187.066.347.158.48.275.133.117.238.253.314.407ZM0 14.786c0 .164.027.319.082.465.055.147.136.277.243.39.11.113.245.202.407.267.164.062.354.093.569.093.42 0 .748-.115.984-.345.238-.23.358-.566.358-1.005v-2.725h-.791v2.745c0 .202-.046.357-.138.466-.092.11-.233.164-.422.164a.499.499 0 0 1-.454-.246.577.577 0 0 1-.073-.27H0Zm4.92-2.86H3.322v4h.791v-1.343h.803c.287 0 .531-.057.732-.172.203-.118.358-.276.463-.475.108-.201.161-.427.161-.677 0-.25-.052-.475-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.546 1.333a.795.795 0 0 1-.085.381.574.574 0 0 1-.238.24.794.794 0 0 1-.375.082H4.11v-1.406h.66c.218 0 .389.06.512.182.123.12.185.295.185.521Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeJs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2H8v-1h4a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM3.186 15.29a1.176 1.176 0 0 1-.111-.449h.765a.578.578 0 0 0 .255.384c.07.049.153.087.249.114.095.028.202.041.319.041.164 0 .302-.023.413-.07a.559.559 0 0 0 .255-.193.507.507 0 0 0 .085-.29.387.387 0 0 0-.153-.326c-.101-.08-.255-.144-.462-.193l-.619-.143a1.72 1.72 0 0 1-.539-.214 1.001 1.001 0 0 1-.351-.367 1.068 1.068 0 0 1-.123-.524c0-.244.063-.457.19-.639.127-.181.303-.322.528-.422.224-.1.483-.149.776-.149.305 0 .564.05.78.152.216.102.383.239.5.41.12.17.186.359.2.566h-.75a.56.56 0 0 0-.12-.258.624.624 0 0 0-.247-.181.923.923 0 0 0-.369-.068c-.217 0-.388.05-.513.152a.472.472 0 0 0-.184.384c0 .121.048.22.143.3a.97.97 0 0 0 .405.175l.62.143c.218.05.406.12.566.211.16.09.285.21.375.358.09.148.135.335.135.56 0 .247-.063.466-.188.656a1.216 1.216 0 0 1-.539.439c-.234.105-.52.158-.858.158-.254 0-.476-.03-.665-.09a1.404 1.404 0 0 1-.478-.252 1.13 1.13 0 0 1-.29-.375Zm-3.104-.033A1.32 1.32 0 0 1 0 14.791h.765a.576.576 0 0 0 .073.27.499.499 0 0 0 .454.246c.19 0 .33-.055.422-.164.092-.11.138-.265.138-.466v-2.745h.79v2.725c0 .44-.119.774-.357 1.005-.236.23-.564.345-.984.345a1.59 1.59 0 0 1-.569-.094 1.145 1.145 0 0 1-.407-.266 1.14 1.14 0 0 1-.243-.39Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeJson(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V11h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM4.151 15.29a1.176 1.176 0 0 1-.111-.449h.764a.578.578 0 0 0 .255.384c.07.049.154.087.25.114.095.028.201.041.319.041.164 0 .301-.023.413-.07a.559.559 0 0 0 .255-.193.507.507 0 0 0 .084-.29.387.387 0 0 0-.152-.326c-.101-.08-.256-.144-.463-.193l-.618-.143a1.72 1.72 0 0 1-.539-.214 1.001 1.001 0 0 1-.352-.367 1.068 1.068 0 0 1-.123-.524c0-.244.064-.457.19-.639.128-.181.304-.322.528-.422.225-.1.484-.149.777-.149.304 0 .564.05.779.152.217.102.384.239.5.41.12.17.186.359.2.566h-.75a.56.56 0 0 0-.12-.258.624.624 0 0 0-.246-.181.923.923 0 0 0-.37-.068c-.216 0-.387.05-.512.152a.472.472 0 0 0-.185.384c0 .121.048.22.144.3a.97.97 0 0 0 .404.175l.621.143c.217.05.406.12.566.211a1 1 0 0 1 .375.358c.09.148.135.335.135.56 0 .247-.063.466-.188.656a1.216 1.216 0 0 1-.539.439c-.234.105-.52.158-.858.158-.254 0-.476-.03-.665-.09a1.404 1.404 0 0 1-.478-.252 1.13 1.13 0 0 1-.29-.375Zm-3.104-.033a1.32 1.32 0 0 1-.082-.466h.764a.576.576 0 0 0 .074.27.499.499 0 0 0 .454.246c.19 0 .33-.055.422-.164.091-.11.137-.265.137-.466v-2.745h.791v2.725c0 .44-.119.774-.357 1.005-.237.23-.565.345-.985.345a1.59 1.59 0 0 1-.568-.094 1.145 1.145 0 0 1-.407-.266 1.14 1.14 0 0 1-.243-.39Zm9.091-1.585v.522c0 .256-.039.47-.117.641a.862.862 0 0 1-.322.387.877.877 0 0 1-.47.126.883.883 0 0 1-.47-.126.87.87 0 0 1-.32-.387 1.55 1.55 0 0 1-.117-.641v-.522c0-.258.039-.471.117-.641a.87.87 0 0 1 .32-.387.868.868 0 0 1 .47-.129c.177 0 .333.043.47.129a.862.862 0 0 1 .322.387c.078.17.117.383.117.641Zm.803.519v-.513c0-.377-.069-.701-.205-.973a1.46 1.46 0 0 0-.59-.63c-.253-.146-.559-.22-.916-.22-.356 0-.662.074-.92.22a1.441 1.441 0 0 0-.589.628c-.137.271-.205.596-.205.975v.513c0 .375.068.699.205.973.137.271.333.48.589.626.258.145.564.217.92.217.357 0 .663-.072.917-.217.256-.146.452-.355.589-.626.136-.274.205-.598.205-.973Zm1.29-.935v2.675h-.746v-3.999h.662l1.752 2.66h.032v-2.66h.75v4h-.656l-1.761-2.676h-.032Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeJsx(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM3.075 14.841a1.13 1.13 0 0 0 .401.823c.13.108.288.192.478.252.19.061.411.091.665.091.338 0 .624-.053.858-.158.237-.105.416-.252.54-.44a1.17 1.17 0 0 0 .187-.656c0-.224-.045-.41-.135-.56a1.001 1.001 0 0 0-.375-.357 2.027 2.027 0 0 0-.565-.21l-.621-.144a.97.97 0 0 1-.405-.176.37.37 0 0 1-.143-.299c0-.156.061-.284.184-.384.125-.101.296-.152.513-.152.143 0 .266.023.37.068a.624.624 0 0 1 .245.181.56.56 0 0 1 .12.258h.75a1.092 1.092 0 0 0-.199-.566 1.21 1.21 0 0 0-.5-.41 1.813 1.813 0 0 0-.78-.152c-.293 0-.552.05-.776.15-.225.099-.4.24-.528.421-.127.182-.19.395-.19.639 0 .201.04.376.123.524.082.149.199.27.351.367.153.095.332.167.54.213l.618.144c.207.049.36.113.462.193a.387.387 0 0 1 .153.326.512.512 0 0 1-.085.29.559.559 0 0 1-.255.193c-.111.047-.249.07-.413.07-.117 0-.224-.013-.32-.04a.837.837 0 0 1-.248-.115.578.578 0 0 1-.255-.384h-.765ZM0 14.791c0 .165.027.32.082.466.055.147.136.277.243.39.11.113.245.202.407.267.164.062.354.093.569.093.42 0 .748-.115.984-.346.238-.23.358-.565.358-1.004v-2.725h-.791v2.745c0 .201-.046.357-.138.466-.092.11-.233.164-.422.164a.499.499 0 0 1-.454-.246.576.576 0 0 1-.073-.27H0Zm8.907-2.859H9.8l-1.274 2.007L9.78 15.93h-.908l-.85-1.415h-.035l-.853 1.415h-.861l1.24-2.016-1.228-1.983h.931l.832 1.438h.036l.823-1.438Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeKey(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM3.21 11.85h-.87L.83 13.64H.79v-1.79H0v3.999h.791v-1.283l.41-.466 1.12 1.749h.951l-1.488-2.276 1.427-1.723Zm2.903 3.352h-1.79v-1.073h1.685v-.606H4.323v-1.025h1.79v-.648H3.538v3.999h2.575v-.647Zm2.243-.888v1.535h-.794v-1.52L6.223 11.85H7.1l.853 1.696h.032l.855-1.696h.856l-1.339 2.464Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeM4P(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM.706 15.849v-2.66h.038l.952 2.16h.516l.946-2.16h.038v2.66h.715V11.85h-.8l-1.14 2.596h-.026L.805 11.85H0v3.999h.706Zm5.237-3.999c-.262.434-.525.867-.79 1.3-.265.434-.514.87-.748 1.31v.648h1.937v.741h.74v-.741h.49v-.639h-.49V11.85H5.944Zm-.82 2.62v-.021c.18-.34.37-.68.571-1.017.203-.338.405-.666.607-.984h.04v2.021H5.124Zm2.893-2.62h1.6c.289 0 .533.06.732.179.201.117.355.276.46.477.106.201.158.427.158.677 0 .25-.053.476-.16.677-.106.199-.26.357-.464.474a1.452 1.452 0 0 1-.732.173h-.803v1.342h-.79V11.85Zm2.06 1.714a.795.795 0 0 0 .085-.381c0-.226-.062-.4-.185-.521-.123-.122-.294-.182-.513-.182h-.659v1.406h.66a.794.794 0 0 0 .374-.082.574.574 0 0 0 .238-.24Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeMd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2H9v-1h3a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM.706 13.189v2.66H0V11.85h.806l1.14 2.596h.026l1.14-2.596h.8v3.999h-.716v-2.66h-.038l-.946 2.159h-.516l-.952-2.16H.706Zm3.919 2.66V11.85h1.459c.406 0 .741.078 1.005.234.263.157.46.383.589.68.13.297.196.655.196 1.075 0 .422-.066.784-.196 1.084-.131.301-.33.53-.595.689-.264.158-.597.237-1 .237H4.626Zm1.353-3.354h-.562v2.707h.562c.186 0 .347-.028.484-.082a.8.8 0 0 0 .334-.252 1.14 1.14 0 0 0 .196-.422c.045-.168.067-.365.067-.592a2.1 2.1 0 0 0-.117-.753.89.89 0 0 0-.354-.454c-.159-.102-.362-.152-.61-.152Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeMdx(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM.706 15.849v-2.66h.038l.952 2.159h.516l.946-2.16h.038v2.661h.715V11.85h-.8l-1.14 2.596h-.026L.805 11.85H0v3.999h.706Zm3.559-3.999v3.999h1.459c.402 0 .735-.08.999-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.066-.778-.196-1.075a1.426 1.426 0 0 0-.59-.68c-.263-.156-.598-.234-1.004-.234h-1.46Zm.79.645h.563c.248 0 .451.05.61.152a.89.89 0 0 1 .354.454c.078.201.117.452.117.753 0 .227-.022.424-.067.592a1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.484.082h-.562v-2.707Zm4.787-.645h.894L9.46 13.857l1.254 1.992h-.908l-.85-1.415h-.035l-.852 1.415h-.862l1.24-2.016L7.22 11.85h.932l.832 1.439h.035l.823-1.439Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeMov(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5Zm-6.914 9.166v.522c0 .256-.04.47-.117.641a.861.861 0 0 1-.323.387.877.877 0 0 1-.468.126.883.883 0 0 1-.472-.126.869.869 0 0 1-.32-.386 1.55 1.55 0 0 1-.117-.642v-.522c0-.257.04-.471.118-.641a.869.869 0 0 1 .319-.387.868.868 0 0 1 .472-.129c.175 0 .332.043.468.13a.861.861 0 0 1 .323.386c.078.17.117.384.117.641Zm.802.519v-.513c0-.377-.068-.7-.205-.972a1.46 1.46 0 0 0-.588-.63c-.254-.147-.56-.22-.917-.22-.356 0-.663.073-.92.22a1.441 1.441 0 0 0-.59.627c-.136.271-.204.596-.204.975v.513c0 .375.068.7.205.973.136.271.333.48.589.627.257.144.564.216.92.216.357 0 .663-.072.917-.216.255-.147.452-.356.588-.627.137-.274.205-.598.205-.973Zm-7.182 1.74v-2.66h.038l.952 2.16h.516l.946-2.16h.038v2.66h.715v-3.999h-.8l-1.14 2.596h-.026l-1.14-2.596H0v4h.706Zm9.54 0h-.952l-1.34-3.999h.918l.896 3.138h.038l.888-3.138h.879l-1.327 4Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeMp3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5Zm-4.911 9.67h-.443v-.609h.422a.688.688 0 0 0 .322-.073.558.558 0 0 0 .22-.2.505.505 0 0 0 .076-.284.49.49 0 0 0-.176-.392.652.652 0 0 0-.442-.15.74.74 0 0 0-.252.041.625.625 0 0 0-.193.112.496.496 0 0 0-.179.349H7.71c.006-.157.04-.302.102-.437.063-.135.153-.252.27-.352.117-.101.26-.18.428-.237.17-.057.364-.086.583-.088.279-.002.52.042.723.132.203.09.36.214.472.372a.91.91 0 0 1 .173.539.833.833 0 0 1-.12.478.96.96 0 0 1-.619.439v.041a1.008 1.008 0 0 1 .718.434.909.909 0 0 1 .144.521c.002.19-.037.359-.117.507a1.104 1.104 0 0 1-.329.378c-.14.101-.302.18-.486.234-.182.053-.376.08-.583.08-.3 0-.558-.051-.77-.153a1.206 1.206 0 0 1-.487-.41 1.094 1.094 0 0 1-.178-.563h.726a.457.457 0 0 0 .106.258.664.664 0 0 0 .249.179.98.98 0 0 0 .357.067.903.903 0 0 0 .384-.076.598.598 0 0 0 .252-.217.56.56 0 0 0 .088-.319.556.556 0 0 0-.334-.522.81.81 0 0 0-.372-.079ZM.706 15.925v-2.66h.038l.952 2.16h.516l.946-2.16h.038v2.66h.715v-3.999h-.8l-1.14 2.596h-.026l-1.14-2.596H0v4h.706Zm5.458-3.999h-1.6v4h.792v-1.342h.803c.287 0 .53-.058.732-.173.203-.118.357-.276.463-.475a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.475-.158-.677a1.175 1.175 0 0 0-.46-.477 1.4 1.4 0 0 0-.733-.179Zm.545 1.333a.795.795 0 0 1-.085.381.574.574 0 0 1-.237.24.793.793 0 0 1-.375.082h-.66v-1.406h.66c.219 0 .39.06.513.182.123.12.184.295.184.521Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeMp4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM.706 15.849v-2.66h.038l.952 2.16h.516l.946-2.16h.038v2.66h.715V11.85h-.8l-1.14 2.596h-.026L.805 11.85H0v3.999h.706Zm5.278-3.999h-1.6v3.999h.792v-1.342h.803c.287 0 .53-.057.732-.173.203-.117.357-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477 1.4 1.4 0 0 0-.733-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.237.241.794.794 0 0 1-.375.082h-.66V12.48h.66c.219 0 .39.06.513.181.123.122.184.296.184.522Zm1.505-.032c.266-.434.53-.867.791-1.301h1.14v2.62h.49v.638h-.49v.741h-.741v-.741H7.287v-.648c.235-.44.484-.876.747-1.31Zm-.029 1.298v.02h1.219v-2.021h-.041c-.201.318-.404.646-.607.984-.2.338-.391.677-.571 1.017Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeOtf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM2.622 13.666v.522c0 .256-.039.47-.117.641a.861.861 0 0 1-.322.387.877.877 0 0 1-.47.126.883.883 0 0 1-.47-.126.868.868 0 0 1-.32-.386 1.55 1.55 0 0 1-.117-.642v-.522c0-.257.039-.471.117-.641a.868.868 0 0 1 .32-.387.868.868 0 0 1 .47-.129c.177 0 .333.043.47.13a.861.861 0 0 1 .322.386c.078.17.117.384.117.641Zm.803.519v-.513c0-.377-.069-.7-.205-.972a1.46 1.46 0 0 0-.59-.63c-.253-.147-.559-.22-.916-.22-.356 0-.662.073-.92.22a1.441 1.441 0 0 0-.589.627c-.137.271-.205.596-.205.975v.513c0 .375.068.7.205.973.137.271.333.48.589.627.258.144.564.216.92.216.357 0 .663-.072.917-.216a1.47 1.47 0 0 0 .589-.627c.136-.274.205-.598.205-.973Zm2 1.74v-3.337H6.56v-.662H3.497v.662H4.63v3.337h.794Zm2.251-1.59v1.59h-.79v-3.999h2.548v.653H7.676v1.117h1.606v.638H7.676Z"
                }
            }
        ]
    })(props);
}
function BsFiletypePdf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082h-.563v-2.707Zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896Z"
                }
            }
        ]
    })(props);
}
function BsFiletypePhp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.295.185.522Zm4.48 2.666V11.85h-.79v1.626H4.153V11.85h-.79v3.999h.79v-1.714h1.682v1.714h.79Zm.703-3.999h1.6c.288 0 .533.06.732.179.2.117.354.276.46.477.105.201.158.427.158.677 0 .25-.054.476-.161.677-.106.199-.26.357-.463.474a1.452 1.452 0 0 1-.733.173H8.12v1.342h-.791V11.85Zm2.06 1.714a.795.795 0 0 0 .084-.381c0-.227-.061-.4-.184-.521-.123-.122-.294-.182-.513-.182h-.66v1.406h.66a.794.794 0 0 0 .375-.082.574.574 0 0 0 .237-.24Z"
                }
            }
        ]
    })(props);
}
function BsFiletypePng(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5Zm-3.76 8.132c.076.153.123.317.14.492h-.776a.797.797 0 0 0-.097-.249.689.689 0 0 0-.17-.19.707.707 0 0 0-.237-.126.96.96 0 0 0-.299-.044c-.285 0-.506.1-.665.302-.156.201-.234.484-.234.85v.498c0 .234.032.439.097.615a.881.881 0 0 0 .304.413.87.87 0 0 0 .519.146.967.967 0 0 0 .457-.096.67.67 0 0 0 .272-.264c.06-.11.091-.23.091-.363v-.255H8.82v-.59h1.576v.798c0 .193-.032.377-.097.55a1.29 1.29 0 0 1-.293.458 1.37 1.37 0 0 1-.495.313c-.197.074-.43.111-.697.111a1.98 1.98 0 0 1-.753-.132 1.447 1.447 0 0 1-.533-.377 1.58 1.58 0 0 1-.32-.58 2.482 2.482 0 0 1-.105-.745v-.506c0-.362.067-.678.2-.95.134-.271.328-.482.582-.633.256-.152.565-.228.926-.228.238 0 .45.033.636.1.187.066.348.158.48.275.133.117.238.253.314.407Zm-8.64-.706H0v4h.791v-1.343h.803c.287 0 .531-.057.732-.172.203-.118.358-.276.463-.475a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.475-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.381.574.574 0 0 1-.238.24.794.794 0 0 1-.375.082H.788v-1.406h.66c.218 0 .389.06.512.182.123.12.185.295.185.521Zm1.964 2.666V13.25h.032l1.761 2.675h.656v-3.999h-.75v2.66h-.032l-1.752-2.66h-.662v4h.747Z"
                }
            }
        ]
    })(props);
}
function BsFiletypePpt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm2.817-1.333h-1.6v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474.108-.201.161-.427.161-.677 0-.25-.052-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.793.793 0 0 1-.375.082H4.15V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm2.767-.67v3.336H7.48v-3.337H6.346v-.662h3.065v.662H8.274Z"
                }
            }
        ]
    })(props);
}
function BsFiletypePptx(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V11h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.5 11.85h1.6c.289 0 .533.06.732.179.201.117.355.276.46.477.105.201.158.427.158.677 0 .25-.054.476-.16.677-.106.199-.26.357-.464.474a1.452 1.452 0 0 1-.732.173H2.29v1.342H1.5V11.85Zm2.06 1.714a.795.795 0 0 0 .085-.381c0-.226-.062-.4-.185-.521-.123-.122-.294-.182-.513-.182h-.659v1.406h.66a.794.794 0 0 0 .374-.082.574.574 0 0 0 .238-.24Zm1.302-1.714h1.6c.289 0 .533.06.732.179.201.117.355.276.46.477.106.201.158.427.158.677 0 .25-.053.476-.16.677-.106.199-.26.357-.464.474a1.452 1.452 0 0 1-.732.173h-.803v1.342h-.79V11.85Zm2.06 1.714a.795.795 0 0 0 .085-.381c0-.226-.062-.4-.185-.521-.123-.122-.294-.182-.513-.182H5.65v1.406h.66a.793.793 0 0 0 .374-.082.574.574 0 0 0 .238-.24Zm2.852 2.285v-3.337h1.137v-.662H7.846v.662H8.98v3.337h.794Zm3.796-3.999h.893l-1.274 2.007 1.254 1.992h-.908l-.85-1.415h-.035l-.853 1.415h-.861l1.24-2.016-1.228-1.983h.931l.832 1.439h.035l.824-1.439Z"
                }
            }
        ]
    })(props);
}
function BsFiletypePsd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2h-.5v-1h.5a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM3.116 14.841a1.13 1.13 0 0 0 .401.823c.13.108.288.192.478.252.19.061.411.091.665.091.338 0 .624-.053.858-.158.237-.105.416-.252.54-.44a1.17 1.17 0 0 0 .187-.656c0-.224-.045-.41-.135-.56a1 1 0 0 0-.375-.357 2.027 2.027 0 0 0-.565-.21l-.621-.144a.97.97 0 0 1-.405-.176.37.37 0 0 1-.143-.299c0-.156.061-.284.184-.384.125-.101.296-.152.513-.152.143 0 .266.023.37.068a.625.625 0 0 1 .245.181.56.56 0 0 1 .12.258h.75a1.092 1.092 0 0 0-.199-.566 1.21 1.21 0 0 0-.5-.41 1.813 1.813 0 0 0-.78-.152c-.293 0-.552.05-.776.15-.225.099-.4.24-.528.421-.127.182-.19.395-.19.639 0 .201.04.376.123.524.082.149.199.27.351.367.153.095.332.167.54.213l.618.144c.207.049.36.113.462.193a.387.387 0 0 1 .153.326.505.505 0 0 1-.085.29.559.559 0 0 1-.255.193c-.111.047-.249.07-.413.07-.117 0-.224-.013-.32-.04a.837.837 0 0 1-.248-.115.578.578 0 0 1-.255-.384h-.765ZM1.6 11.932H0v4h.791v-1.343h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.793.793 0 0 1-.375.082H.788v-1.406h.66c.218 0 .389.06.512.182.123.12.185.295.185.521Zm4.609 2.666v-3.999h1.459c.406 0 .74.078 1.004.234.264.157.46.383.59.68.13.297.195.655.195 1.075 0 .422-.065.784-.196 1.084-.13.301-.329.53-.594.689-.264.158-.597.237-1 .237H6.755Zm1.353-3.354h-.562v2.707h.562c.186 0 .347-.028.483-.082a.8.8 0 0 0 .334-.252 1.14 1.14 0 0 0 .197-.422c.045-.168.067-.366.067-.592a2.1 2.1 0 0 0-.117-.753.89.89 0 0 0-.355-.454c-.158-.102-.36-.152-.609-.152Z"
                }
            }
        ]
    })(props);
}
function BsFiletypePy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2H7v-1h5a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM0 11.85h1.6c.289 0 .533.06.732.179.201.117.355.276.46.477.105.201.158.427.158.677 0 .25-.054.476-.16.677-.106.199-.26.357-.464.474a1.452 1.452 0 0 1-.732.173H.79v1.342H0V11.85Zm2.06 1.714a.795.795 0 0 0 .085-.381c0-.227-.062-.4-.185-.521-.123-.122-.294-.182-.513-.182H.788v1.406h.66a.794.794 0 0 0 .374-.082.574.574 0 0 0 .238-.24Zm2.963.75v1.535H4.23v-1.52L2.89 11.85h.876l.853 1.696h.032l.856-1.696h.855l-1.339 2.464Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeRaw(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.597 11.85H0v3.999h.782v-1.491h.71l.7 1.491h1.651l.313-1.028h1.336l.314 1.028h.84L5.31 11.85h-.925l-1.329 3.96-.783-1.572A1.18 1.18 0 0 0 3 13.116c0-.256-.056-.479-.167-.668a1.098 1.098 0 0 0-.478-.44 1.669 1.669 0 0 0-.758-.158Zm-.815 1.913v-1.292h.7a.74.74 0 0 1 .507.17c.13.113.194.276.194.49 0 .21-.065.368-.194.474-.127.105-.3.158-.518.158H.782Zm4.063-1.148.489 1.617H4.32l.49-1.617h.035Zm4.006.445-.74 2.789h-.73L6.326 11.85h.855l.601 2.903h.038l.706-2.903h.683l.706 2.903h.04l.596-2.903h.858l-1.055 3.999h-.73l-.74-2.789H8.85Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeRb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2H8v-1h4a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM0 11.85h1.597c.297 0 .55.053.758.158.21.104.369.25.478.44.111.19.167.412.167.668a1.18 1.18 0 0 1-.727 1.122l.803 1.611h-.885l-.7-1.491H.782v1.491H0V11.85Zm.782.621v1.292h.689c.218 0 .391-.053.518-.158.13-.106.194-.264.194-.475 0-.213-.065-.376-.194-.489a.74.74 0 0 0-.507-.17h-.7Zm4.426 3.378H3.544V11.85h1.67c.357 0 .643.087.858.26.215.175.322.416.322.724a.94.94 0 0 1-.09.422.79.79 0 0 1-.244.293 1.002 1.002 0 0 1-.351.161v.035c.162.016.31.063.445.141a.846.846 0 0 1 .322.325.986.986 0 0 1 .123.51c0 .238-.06.441-.178.61-.12.167-.284.296-.492.386a1.85 1.85 0 0 1-.721.132Zm-.179-3.404h-.7v1.07h.521c.178 0 .323-.022.434-.065a.497.497 0 0 0 .249-.185.52.52 0 0 0 .082-.296.486.486 0 0 0-.155-.384c-.102-.093-.245-.14-.43-.14Zm.05 1.62h-.75v1.19h.589c.31 0 .534-.05.67-.147a.503.503 0 0 0 .206-.434.614.614 0 0 0-.082-.325.51.51 0 0 0-.24-.21.946.946 0 0 0-.393-.074Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeSass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V11h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.41 15.29a1.176 1.176 0 0 1-.111-.449h.764a.578.578 0 0 0 .255.384.81.81 0 0 0 .25.114c.095.028.201.041.319.041.164 0 .301-.023.413-.07a.559.559 0 0 0 .255-.193.506.506 0 0 0 .084-.29.387.387 0 0 0-.152-.326c-.101-.08-.256-.144-.463-.193l-.618-.143a1.72 1.72 0 0 1-.539-.214 1.001 1.001 0 0 1-.352-.367 1.068 1.068 0 0 1-.123-.524c0-.244.064-.457.19-.639.128-.181.304-.322.528-.422.225-.1.484-.149.777-.149.304 0 .564.05.779.152.217.102.384.239.5.41.12.17.186.359.2.566h-.75a.56.56 0 0 0-.12-.258.624.624 0 0 0-.246-.181.923.923 0 0 0-.37-.068c-.216 0-.387.05-.512.152a.472.472 0 0 0-.185.384c0 .121.048.22.144.3a.97.97 0 0 0 .404.175l.621.143c.217.05.406.12.566.211.16.09.285.21.375.358.09.148.135.335.135.56 0 .247-.063.466-.188.656a1.216 1.216 0 0 1-.539.439c-.234.105-.52.158-.858.158-.254 0-.476-.03-.665-.09a1.404 1.404 0 0 1-.478-.252 1.13 1.13 0 0 1-.29-.375Zm4.188-.387-.313 1.028h-.8l1.342-3.999h.926l1.335 4h-.84l-.314-1.03H5.598Zm1.178-.59-.49-1.616h-.034l-.49 1.617h1.014Zm1.352.528a1.13 1.13 0 0 0 .401.823c.13.108.289.192.478.252.19.061.411.091.665.091.338 0 .624-.053.859-.158.236-.105.416-.252.539-.44.125-.189.187-.408.187-.656 0-.224-.045-.41-.134-.56a1.002 1.002 0 0 0-.375-.357 2.028 2.028 0 0 0-.566-.21l-.621-.144a.97.97 0 0 1-.404-.176.37.37 0 0 1-.144-.299c0-.156.062-.284.185-.384.125-.101.296-.152.512-.152.143 0 .266.023.37.068a.623.623 0 0 1 .246.181.56.56 0 0 1 .12.258h.75a1.093 1.093 0 0 0-.2-.566 1.21 1.21 0 0 0-.5-.41 1.813 1.813 0 0 0-.78-.152c-.293 0-.552.05-.776.15-.225.099-.4.24-.527.421-.127.182-.19.395-.19.639 0 .201.04.376.122.524.082.149.2.27.352.367.152.095.332.167.539.213l.618.144c.207.049.361.113.463.193a.387.387 0 0 1 .152.326.505.505 0 0 1-.085.29.558.558 0 0 1-.255.193c-.111.047-.249.07-.413.07-.117 0-.223-.013-.32-.04a.838.838 0 0 1-.248-.115.578.578 0 0 1-.255-.384h-.765Zm3.503.449a1.178 1.178 0 0 1-.111-.449h.764a.58.58 0 0 0 .255.384c.07.049.154.087.25.114.095.028.201.041.319.041.164 0 .301-.023.413-.07a.558.558 0 0 0 .255-.193.507.507 0 0 0 .085-.29.387.387 0 0 0-.153-.326c-.101-.08-.256-.144-.463-.193l-.618-.143a1.72 1.72 0 0 1-.539-.214 1.002 1.002 0 0 1-.351-.367 1.068 1.068 0 0 1-.123-.524c0-.244.063-.457.19-.639.127-.181.303-.322.527-.422.225-.1.484-.149.777-.149.304 0 .564.05.779.152.217.102.384.239.5.41.12.17.186.359.2.566h-.75a.56.56 0 0 0-.12-.258.623.623 0 0 0-.246-.181.923.923 0 0 0-.37-.068c-.216 0-.387.05-.512.152a.472.472 0 0 0-.184.384c0 .121.047.22.143.3a.97.97 0 0 0 .404.175l.621.143c.217.05.406.12.566.211.16.09.285.21.375.358.09.148.135.335.135.56 0 .247-.063.466-.188.656a1.216 1.216 0 0 1-.539.439c-.234.105-.52.158-.858.158a2.19 2.19 0 0 1-.665-.09 1.404 1.404 0 0 1-.478-.252 1.131 1.131 0 0 1-.29-.375Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeScss(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V11h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.356 15.29a1.176 1.176 0 0 1-.111-.449h.765a.578.578 0 0 0 .255.384c.07.049.153.087.249.114.095.028.202.041.319.041.164 0 .302-.023.413-.07a.559.559 0 0 0 .255-.193.506.506 0 0 0 .085-.29.387.387 0 0 0-.153-.326c-.101-.08-.255-.144-.462-.193l-.619-.143a1.72 1.72 0 0 1-.539-.214 1.001 1.001 0 0 1-.351-.367 1.068 1.068 0 0 1-.123-.524c0-.244.063-.457.19-.639.127-.181.303-.322.528-.422.224-.1.483-.149.776-.149.305 0 .564.05.78.152.216.102.383.239.5.41.12.17.186.359.2.566h-.75a.56.56 0 0 0-.12-.258.624.624 0 0 0-.247-.181.923.923 0 0 0-.369-.068c-.217 0-.388.05-.513.152a.472.472 0 0 0-.184.384c0 .121.048.22.143.3a.97.97 0 0 0 .405.175l.62.143c.217.05.406.12.566.211.16.09.285.21.375.358.09.148.135.335.135.56 0 .247-.063.466-.188.656a1.216 1.216 0 0 1-.539.439c-.234.105-.52.158-.858.158-.254 0-.476-.03-.665-.09a1.404 1.404 0 0 1-.478-.252 1.13 1.13 0 0 1-.29-.375Zm4.274-2.23a1.732 1.732 0 0 0-.103.633v.495c0 .246.034.455.103.627a.833.833 0 0 0 .298.392.846.846 0 0 0 .478.132.868.868 0 0 0 .401-.088.7.7 0 0 0 .273-.249.798.798 0 0 0 .117-.363h.765v.076a1.27 1.27 0 0 1-.226.674 1.39 1.39 0 0 1-.55.454 1.81 1.81 0 0 1-.786.164c-.36 0-.664-.072-.914-.217a1.424 1.424 0 0 1-.571-.626c-.13-.272-.194-.597-.194-.976v-.498c0-.38.066-.705.197-.979a1.44 1.44 0 0 1 .57-.633c.253-.148.557-.222.912-.222.219 0 .421.032.607.097.187.062.35.153.489.272a1.324 1.324 0 0 1 .466.964v.073h-.765a.85.85 0 0 0-.12-.38.7.7 0 0 0-.273-.261.803.803 0 0 0-.398-.097.814.814 0 0 0-.475.138.868.868 0 0 0-.301.398Zm2.609 1.781a1.13 1.13 0 0 0 .401.823c.129.108.288.192.478.252.19.061.41.091.665.091.338 0 .624-.053.858-.158.236-.105.416-.252.54-.44a1.17 1.17 0 0 0 .187-.656c0-.224-.045-.41-.135-.56a1.002 1.002 0 0 0-.375-.357 2.028 2.028 0 0 0-.566-.21l-.62-.144a.97.97 0 0 1-.405-.176.37.37 0 0 1-.143-.299c0-.156.061-.284.184-.384.125-.101.296-.152.513-.152.142 0 .265.023.369.068a.623.623 0 0 1 .246.181.56.56 0 0 1 .12.258h.75a1.091 1.091 0 0 0-.2-.566 1.21 1.21 0 0 0-.5-.41 1.813 1.813 0 0 0-.78-.152c-.292 0-.551.05-.776.15-.224.099-.4.24-.527.421-.127.182-.19.395-.19.639 0 .201.04.376.123.524.082.149.199.27.351.367.152.095.332.167.54.213l.617.144c.207.049.362.113.463.193a.387.387 0 0 1 .153.326.512.512 0 0 1-.085.29.558.558 0 0 1-.255.193 1.07 1.07 0 0 1-.413.07c-.118 0-.224-.013-.32-.04a.837.837 0 0 1-.249-.115.578.578 0 0 1-.255-.384H8.24Zm3.502.449a1.176 1.176 0 0 1-.11-.449h.764a.578.578 0 0 0 .255.384c.07.049.153.087.249.114.095.028.202.041.319.041.164 0 .302-.023.413-.07a.558.558 0 0 0 .255-.193.506.506 0 0 0 .085-.29.387.387 0 0 0-.152-.326c-.102-.08-.256-.144-.463-.193l-.618-.143a1.72 1.72 0 0 1-.54-.214 1.002 1.002 0 0 1-.351-.367 1.068 1.068 0 0 1-.123-.524c0-.244.063-.457.19-.639.127-.181.303-.322.528-.422.224-.1.483-.149.776-.149.305 0 .565.05.78.152.216.102.383.239.5.41.12.17.186.359.2.566h-.75a.56.56 0 0 0-.12-.258.623.623 0 0 0-.247-.181.923.923 0 0 0-.369-.068c-.217 0-.387.05-.512.152a.472.472 0 0 0-.185.384c0 .121.048.22.143.3a.97.97 0 0 0 .405.175l.62.143c.218.05.406.12.566.211.16.09.285.21.375.358.09.148.135.335.135.56 0 .247-.062.466-.187.656a1.217 1.217 0 0 1-.54.439c-.234.105-.52.158-.858.158-.254 0-.476-.03-.665-.09a1.404 1.404 0 0 1-.478-.252 1.131 1.131 0 0 1-.29-.375Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeSh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2H8v-1h4a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM.111 15.29A1.176 1.176 0 0 1 0 14.84h.765a.578.578 0 0 0 .255.384c.07.049.153.087.249.114.095.028.202.041.319.041.164 0 .302-.023.413-.07a.559.559 0 0 0 .255-.193.507.507 0 0 0 .085-.29.387.387 0 0 0-.153-.326c-.101-.08-.255-.144-.462-.193l-.619-.143a1.72 1.72 0 0 1-.539-.214 1.001 1.001 0 0 1-.351-.367 1.068 1.068 0 0 1-.123-.524c0-.244.063-.457.19-.639.127-.181.303-.322.528-.422.224-.1.483-.149.776-.149.305 0 .564.05.78.152.216.102.383.239.5.41.12.17.186.359.2.566h-.75a.56.56 0 0 0-.12-.258.624.624 0 0 0-.247-.181.923.923 0 0 0-.369-.068c-.217 0-.388.05-.513.152a.472.472 0 0 0-.184.384c0 .121.048.22.143.3a.97.97 0 0 0 .405.175l.62.143c.218.05.406.12.566.211.16.09.285.21.375.358.09.148.135.335.135.56 0 .247-.063.466-.188.656a1.216 1.216 0 0 1-.539.439c-.234.105-.52.158-.858.158-.254 0-.476-.03-.665-.09a1.404 1.404 0 0 1-.478-.252 1.13 1.13 0 0 1-.29-.375Zm6.67-3.358v4h-.79v-1.715H4.308v1.714h-.792v-3.999h.792v1.626H5.99v-1.626h.791Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeSql(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM0 14.841a1.129 1.129 0 0 0 .401.823c.13.108.288.192.478.252s.411.091.665.091c.338 0 .624-.053.858-.158.237-.106.416-.252.54-.44a1.17 1.17 0 0 0 .187-.656c0-.224-.045-.41-.135-.56a1 1 0 0 0-.375-.357 2.027 2.027 0 0 0-.565-.21l-.621-.144a.97.97 0 0 1-.405-.176.369.369 0 0 1-.143-.299c0-.156.061-.284.184-.384.125-.101.296-.152.513-.152.143 0 .266.022.37.068a.624.624 0 0 1 .245.181.56.56 0 0 1 .12.258h.75a1.092 1.092 0 0 0-.199-.566 1.21 1.21 0 0 0-.5-.41 1.813 1.813 0 0 0-.78-.152c-.293 0-.552.05-.776.15-.225.099-.4.24-.528.421-.127.182-.19.395-.19.639 0 .201.04.376.123.524.082.149.199.27.351.367.153.095.332.167.54.213l.618.144c.207.049.36.113.462.193a.387.387 0 0 1 .153.325c0 .11-.029.207-.085.29A.558.558 0 0 1 2 15.31c-.111.047-.249.07-.413.07-.117 0-.224-.013-.32-.04a.835.835 0 0 1-.248-.115.579.579 0 0 1-.255-.384H0Zm6.878 1.489-.507-.739c.176-.162.31-.362.401-.6.092-.239.138-.507.138-.806v-.501c0-.371-.07-.693-.208-.967a1.495 1.495 0 0 0-.589-.636c-.256-.15-.561-.225-.917-.225-.351 0-.656.075-.914.225-.256.149-.453.36-.592.636a2.138 2.138 0 0 0-.205.967v.5c0 .37.069.691.205.965.139.273.336.485.592.636a1.8 1.8 0 0 0 .914.222 1.8 1.8 0 0 0 .6-.1l.294.422h.788ZM4.262 14.2v-.522c0-.246.038-.456.114-.63a.91.91 0 0 1 .325-.398.885.885 0 0 1 .495-.138c.192 0 .357.046.495.138a.88.88 0 0 1 .325.398c.077.174.115.384.115.63v.522c0 .164-.018.312-.053.445-.035.13-.087.244-.155.34l-.106-.14-.105-.147h-.733l.451.65a.638.638 0 0 1-.251.047.872.872 0 0 1-.487-.147.916.916 0 0 1-.32-.404 1.67 1.67 0 0 1-.11-.644Zm3.986 1.057h1.696v.674H7.457v-3.999h.79v3.325Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeSvg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM0 14.841a1.13 1.13 0 0 0 .401.823c.13.108.288.192.478.252.19.061.411.091.665.091.338 0 .624-.053.858-.158.237-.105.416-.252.54-.44a1.17 1.17 0 0 0 .187-.656c0-.224-.045-.41-.135-.56a1 1 0 0 0-.375-.357 2.027 2.027 0 0 0-.565-.21l-.621-.144a.97.97 0 0 1-.405-.176.37.37 0 0 1-.143-.299c0-.156.061-.284.184-.384.125-.101.296-.152.513-.152.143 0 .266.023.37.068a.625.625 0 0 1 .245.181.56.56 0 0 1 .12.258h.75a1.092 1.092 0 0 0-.199-.566 1.21 1.21 0 0 0-.5-.41 1.813 1.813 0 0 0-.78-.152c-.293 0-.552.05-.776.15-.225.099-.4.24-.528.421-.127.182-.19.395-.19.639 0 .201.04.376.123.524.082.149.199.27.351.367.153.095.332.167.54.213l.618.144c.207.049.36.113.462.193a.387.387 0 0 1 .153.326.512.512 0 0 1-.085.29.559.559 0 0 1-.256.193c-.111.047-.249.07-.413.07-.117 0-.224-.013-.32-.04a.837.837 0 0 1-.248-.115.578.578 0 0 1-.255-.384H0Zm4.575 1.09h.952l1.327-3.999h-.879l-.887 3.138H5.05l-.897-3.138h-.917l1.339 4Zm5.483-3.293c.076.152.123.316.14.492h-.776a.797.797 0 0 0-.096-.249.689.689 0 0 0-.17-.19.707.707 0 0 0-.237-.126.963.963 0 0 0-.3-.044c-.284 0-.506.1-.664.302-.157.2-.235.484-.235.85v.497c0 .235.033.44.097.616a.881.881 0 0 0 .305.413.87.87 0 0 0 .518.146.965.965 0 0 0 .457-.097.67.67 0 0 0 .273-.263c.06-.11.09-.23.09-.364v-.254h-.823v-.59h1.576v.798c0 .193-.032.377-.096.55a1.29 1.29 0 0 1-.293.457 1.37 1.37 0 0 1-.495.314c-.198.074-.43.111-.698.111a1.98 1.98 0 0 1-.752-.132 1.447 1.447 0 0 1-.534-.377 1.58 1.58 0 0 1-.319-.58 2.482 2.482 0 0 1-.105-.745v-.507c0-.36.066-.677.199-.949.134-.271.329-.482.583-.633.256-.152.564-.228.926-.228.238 0 .45.033.635.1.188.066.348.158.48.275.134.117.238.253.314.407Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeTiff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.928 12.512v3.337h-.794v-3.337H0v-.662h3.064v.662H1.928Zm2.131-.662v3.999h-.79V11.85h.79Zm1.373 3.999v-1.59h1.606v-.64H5.432v-1.116H7.19v-.653H4.641v3.999h.791Zm2.868-1.59v1.59h-.791V11.85h2.548v.653H8.3v1.117h1.605v.638H8.3Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeTsx(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM3.172 14.841a1.13 1.13 0 0 0 .401.823c.129.108.288.192.478.252.189.061.41.091.665.091.338 0 .624-.053.858-.158.236-.105.416-.252.54-.44a1.17 1.17 0 0 0 .187-.656c0-.224-.045-.41-.135-.56a1.001 1.001 0 0 0-.375-.357 2.027 2.027 0 0 0-.566-.21l-.62-.144a.97.97 0 0 1-.405-.176.37.37 0 0 1-.144-.299c0-.156.062-.284.185-.384.125-.101.296-.152.513-.152.142 0 .265.023.369.068a.624.624 0 0 1 .246.181.56.56 0 0 1 .12.258h.75a1.092 1.092 0 0 0-.2-.566 1.21 1.21 0 0 0-.5-.41 1.813 1.813 0 0 0-.78-.152c-.292 0-.551.05-.776.15-.224.099-.4.24-.527.421-.127.182-.19.395-.19.639 0 .201.04.376.122.524.083.149.2.27.352.367.152.095.332.167.54.213l.617.144c.207.049.362.113.463.193a.387.387 0 0 1 .152.326.511.511 0 0 1-.084.29.559.559 0 0 1-.255.193 1.07 1.07 0 0 1-.413.07c-.118 0-.224-.013-.32-.04a.837.837 0 0 1-.249-.115.578.578 0 0 1-.255-.384h-.764Zm-1.244 1.09v-3.337h1.136v-.662H0v.662h1.134v3.337h.794Zm7.076-3.999h.893l-1.274 2.007 1.254 1.992h-.909l-.85-1.415h-.034l-.853 1.415H6.37l1.239-2.016-1.228-1.983h.932l.832 1.438h.035l.824-1.438Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeTtf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2h-2v-1h2a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.928 15.849v-3.337h2.269v3.337h.794v-3.337h1.137v-.662H0v.662h1.134v3.337h.794Zm5.315-1.59v1.59h-.791V11.85H9v.653H7.243v1.117h1.605v.638H7.243Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeTxt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2h-2v-1h2a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.928 15.849v-3.337h1.136v-.662H0v.662h1.134v3.337h.794Zm4.689-3.999h-.894L4.9 13.289h-.035l-.832-1.439h-.932l1.228 1.983-1.24 2.016h.862l.853-1.415h.035l.85 1.415h.907l-1.253-1.992 1.274-2.007Zm1.93.662v3.337h-.794v-3.337H6.619v-.662h3.064v.662H8.546Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeWav(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.784 15.849l.741-2.789h.033l.74 2.789h.73l1.055-3.999h-.858l-.595 2.903h-.041l-.706-2.903H2.2l-.706 2.903h-.038l-.6-2.903H0l1.055 3.999h.73Zm3.715 0 .314-1.028h1.336l.313 1.028h.841L6.967 11.85h-.926L4.7 15.849h.8Zm1.002-3.234.49 1.617H5.977l.49-1.617H6.5Zm3.604 3.234h-.952L7.814 11.85h.917l.897 3.138h.038l.888-3.138h.879l-1.328 3.999Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeWoff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V11h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5Zm-5.464 9.688v-.522c0-.257-.04-.471-.117-.641a.861.861 0 0 0-.323-.387.862.862 0 0 0-.468-.129.868.868 0 0 0-.472.13.868.868 0 0 0-.32.386c-.077.17-.116.384-.116.641v.522c0 .256.039.47.117.641a.866.866 0 0 0 .319.387.883.883 0 0 0 .472.126.877.877 0 0 0 .468-.126.861.861 0 0 0 .323-.386 1.55 1.55 0 0 0 .117-.642Zm.803-.516v.513c0 .375-.069.7-.205.973-.137.271-.333.48-.59.627-.253.144-.559.216-.916.216-.356 0-.662-.072-.92-.216a1.463 1.463 0 0 1-.59-.627 2.151 2.151 0 0 1-.204-.973v-.513c0-.379.068-.704.205-.975.137-.274.333-.483.589-.627.258-.147.564-.22.92-.22.357 0 .663.073.917.22.256.146.452.356.589.63.136.271.205.595.205.972Zm-6.064-.536-.74 2.79h-.73l-1.055-4h.855l.601 2.903h.038l.706-2.903h.683l.706 2.903h.04l.596-2.903h.858l-1.055 4h-.73l-.74-2.79h-.033Zm7.398 2.79v-1.592h1.606v-.638h-1.606v-1.117h1.758v-.653H9.882v4h.791Zm2.988-1.592v1.591h-.791v-3.999h2.548v.653h-1.757v1.117h1.605v.638h-1.605Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeXls(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM6.472 15.29a1.176 1.176 0 0 1-.111-.449h.765a.578.578 0 0 0 .254.384c.07.049.154.087.25.114.095.028.202.041.319.041.164 0 .302-.023.413-.07a.559.559 0 0 0 .255-.193.507.507 0 0 0 .085-.29.387.387 0 0 0-.153-.326c-.101-.08-.255-.144-.462-.193l-.619-.143a1.72 1.72 0 0 1-.539-.214 1.001 1.001 0 0 1-.351-.367 1.068 1.068 0 0 1-.123-.524c0-.244.063-.457.19-.639.127-.181.303-.322.527-.422.225-.1.484-.149.777-.149.305 0 .564.05.78.152.216.102.383.239.5.41.12.17.186.359.2.566h-.75a.56.56 0 0 0-.12-.258.625.625 0 0 0-.247-.181.923.923 0 0 0-.369-.068c-.217 0-.388.05-.513.152a.472.472 0 0 0-.184.384c0 .121.048.22.143.3a.97.97 0 0 0 .405.175l.62.143c.217.05.406.12.566.211a1 1 0 0 1 .375.358c.09.148.135.335.135.56 0 .247-.063.466-.188.656a1.216 1.216 0 0 1-.539.439c-.234.105-.52.158-.858.158-.254 0-.476-.03-.665-.09a1.404 1.404 0 0 1-.478-.252 1.13 1.13 0 0 1-.29-.375Zm-2.945-3.358h-.893L1.81 13.37h-.036l-.832-1.438h-.93l1.227 1.983L0 15.931h.861l.853-1.415h.035l.85 1.415h.908L2.253 13.94l1.274-2.007Zm2.727 3.325H4.557v-3.325h-.79v4h2.487v-.675Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeXlsx(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V11h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM7.86 14.841a1.13 1.13 0 0 0 .401.823c.13.108.29.192.479.252.19.061.411.091.665.091.338 0 .624-.053.858-.158.237-.105.416-.252.54-.44a1.17 1.17 0 0 0 .187-.656c0-.224-.045-.41-.135-.56a1.002 1.002 0 0 0-.375-.357 2.028 2.028 0 0 0-.565-.21l-.621-.144a.97.97 0 0 1-.405-.176.37.37 0 0 1-.143-.299c0-.156.061-.284.184-.384.125-.101.296-.152.513-.152.143 0 .266.023.37.068a.624.624 0 0 1 .245.181.56.56 0 0 1 .12.258h.75a1.093 1.093 0 0 0-.199-.566 1.21 1.21 0 0 0-.5-.41 1.813 1.813 0 0 0-.78-.152c-.293 0-.552.05-.777.15-.224.099-.4.24-.527.421-.127.182-.19.395-.19.639 0 .201.04.376.123.524.082.149.199.27.351.367.153.095.332.167.54.213l.618.144c.207.049.36.113.462.193a.387.387 0 0 1 .153.326.512.512 0 0 1-.085.29.558.558 0 0 1-.255.193c-.111.047-.25.07-.413.07-.117 0-.224-.013-.32-.04a.837.837 0 0 1-.249-.115.578.578 0 0 1-.255-.384h-.764Zm-3.726-2.909h.893l-1.274 2.007 1.254 1.992h-.908l-.85-1.415h-.035l-.853 1.415H1.5l1.24-2.016-1.228-1.983h.931l.832 1.438h.036l.823-1.438Zm1.923 3.325h1.697v.674H5.266v-3.999h.791v3.325Zm7.636-3.325h.893l-1.274 2.007 1.254 1.992h-.908l-.85-1.415h-.035l-.853 1.415h-.861l1.24-2.016-1.228-1.983h.931l.832 1.438h.036l.823-1.438Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeXml(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM3.527 11.85h-.893l-.823 1.439h-.036L.943 11.85H.012l1.227 1.983L0 15.85h.861l.853-1.415h.035l.85 1.415h.908l-1.254-1.992 1.274-2.007Zm.954 3.999v-2.66h.038l.952 2.159h.516l.946-2.16h.038v2.661h.715V11.85h-.8l-1.14 2.596h-.025L4.58 11.85h-.806v3.999h.706Zm4.71-.674h1.696v.674H8.4V11.85h.791v3.325Z"
                }
            }
        ]
    })(props);
}
function BsFiletypeYml(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 4.5V14a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM2.133 15.849v-1.535l1.339-2.464h-.856l-.855 1.696h-.032L.876 11.85H0l1.339 2.479v1.52h.794Zm2.287 0v-2.66h.038l.952 2.159h.516l.946-2.16h.038v2.661h.715V11.85h-.8l-1.14 2.596H5.66L4.52 11.85h-.805v3.999h.706Zm4.71-.674h1.696v.674H8.338V11.85h.791v3.325Z"
                }
            }
        ]
    })(props);
}
function BsFilm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1zm4 0v6h8V1H4zm8 8H4v6h8V9zM1 1v2h2V1H1zm2 3H1v2h2V4zM1 7v2h2V7H1zm2 3H1v2h2v-2zm-2 3v2h2v-2H1zM15 1h-2v2h2V1zm-2 3v2h2V4h-2zm2 3h-2v2h2V7zm-2 3v2h2v-2h-2zm2 3h-2v2h2v-2z"
                }
            }
        ]
    })(props);
}
function BsFilterCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM3.5 5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1zM5 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm2 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsFilterCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsFilterLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsFilterRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5zm0-3a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0 0 1h7a.5.5 0 0 0 .5-.5zm0-3a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0 0 1h11a.5.5 0 0 0 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsFilterSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm.5 5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1zM4 8.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm2 3a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsFilterSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 11.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsFilter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsFingerprint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.06 6.5a.5.5 0 0 1 .5.5v.776a11.5 11.5 0 0 1-.552 3.519l-1.331 4.14a.5.5 0 0 1-.952-.305l1.33-4.141a10.5 10.5 0 0 0 .504-3.213V7a.5.5 0 0 1 .5-.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.06 7a2 2 0 1 1 4 0 .5.5 0 1 1-1 0 1 1 0 1 0-2 0v.332c0 .409-.022.816-.066 1.221A.5.5 0 0 1 6 8.447c.04-.37.06-.742.06-1.115V7Zm3.509 1a.5.5 0 0 1 .487.513 11.5 11.5 0 0 1-.587 3.339l-1.266 3.8a.5.5 0 0 1-.949-.317l1.267-3.8a10.5 10.5 0 0 0 .535-3.048A.5.5 0 0 1 9.569 8Zm-3.356 2.115a.5.5 0 0 1 .33.626L5.24 14.939a.5.5 0 1 1-.955-.296l1.303-4.199a.5.5 0 0 1 .625-.329Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.759 5.833A3.501 3.501 0 0 1 11.559 7a.5.5 0 0 1-1 0 2.5 2.5 0 0 0-4.857-.833.5.5 0 1 1-.943-.334Zm.3 1.67a.5.5 0 0 1 .449.546 10.72 10.72 0 0 1-.4 2.031l-1.222 4.072a.5.5 0 1 1-.958-.287L4.15 9.793a9.72 9.72 0 0 0 .363-1.842.5.5 0 0 1 .546-.449Zm6 .647a.5.5 0 0 1 .5.5c0 1.28-.213 2.552-.632 3.762l-1.09 3.145a.5.5 0 0 1-.944-.327l1.089-3.145c.382-1.105.578-2.266.578-3.435a.5.5 0 0 1 .5-.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.902 4.222a4.996 4.996 0 0 1 5.202-2.113.5.5 0 0 1-.208.979 3.996 3.996 0 0 0-4.163 1.69.5.5 0 0 1-.831-.556Zm6.72-.955a.5.5 0 0 1 .705-.052A4.99 4.99 0 0 1 13.059 7v1.5a.5.5 0 1 1-1 0V7a3.99 3.99 0 0 0-1.386-3.028.5.5 0 0 1-.051-.705ZM3.68 5.842a.5.5 0 0 1 .422.568c-.029.192-.044.39-.044.59 0 .71-.1 1.417-.298 2.1l-1.14 3.923a.5.5 0 1 1-.96-.279L2.8 8.821A6.531 6.531 0 0 0 3.058 7c0-.25.019-.496.054-.736a.5.5 0 0 1 .568-.422Zm8.882 3.66a.5.5 0 0 1 .456.54c-.084 1-.298 1.986-.64 2.934l-.744 2.068a.5.5 0 0 1-.941-.338l.745-2.07a10.51 10.51 0 0 0 .584-2.678.5.5 0 0 1 .54-.456Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.81 1.37A6.5 6.5 0 0 1 14.56 7a.5.5 0 1 1-1 0 5.5 5.5 0 0 0-8.25-4.765.5.5 0 0 1-.5-.865Zm-.89 1.257a.5.5 0 0 1 .04.706A5.478 5.478 0 0 0 2.56 7a.5.5 0 0 1-1 0c0-1.664.626-3.184 1.655-4.333a.5.5 0 0 1 .706-.04ZM1.915 8.02a.5.5 0 0 1 .346.616l-.779 2.767a.5.5 0 1 1-.962-.27l.778-2.767a.5.5 0 0 1 .617-.346Zm12.15.481a.5.5 0 0 1 .49.51c-.03 1.499-.161 3.025-.727 4.533l-.07.187a.5.5 0 0 1-.936-.351l.07-.187c.506-1.35.634-2.74.663-4.202a.5.5 0 0 1 .51-.49Z"
                }
            }
        ]
    })(props);
}
function BsFire(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16c3.314 0 6-2 6-5.5 0-1.5-.5-4-2.5-6 .25 1.5-1.25 2-1.25 2C11 4 9 .5 6 0c.357 2 .5 4-2 6-1.25 1-2 2.729-2 4.5C2 14 4.686 16 8 16Zm0-1c-1.657 0-3-1-3-2.75 0-.75.25-2 1.25-3C6.125 10 7 10.5 7 10.5c-.375-1.25.5-3.25 2-3.5-.179 1-.25 2 1 3 .625.5 1 1.364 1 2.25C11 14 9.657 15 8 15Z"
                }
            }
        ]
    })(props);
}
function BsFlagFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12.435 12.435 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A19.626 19.626 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a19.587 19.587 0 0 0 1.349-.476l.019-.007.004-.002h.001"
                }
            }
        ]
    })(props);
}
function BsFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12.435 12.435 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A19.626 19.626 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a19.587 19.587 0 0 0 1.349-.476l.019-.007.004-.002h.001M14 1.221c-.22.078-.48.167-.766.255-.81.252-1.872.523-2.734.523-.886 0-1.592-.286-2.203-.534l-.008-.003C7.662 1.21 7.139 1 6.5 1c-.669 0-1.606.229-2.415.478A21.294 21.294 0 0 0 3 1.845v6.433c.22-.078.48-.167.766-.255C4.576 7.77 5.638 7.5 6.5 7.5c.847 0 1.548.28 2.158.525l.028.01C9.32 8.29 9.86 8.5 10.5 8.5c.668 0 1.606-.229 2.415-.478A21.317 21.317 0 0 0 14 7.655V1.222z"
                }
            }
        ]
    })(props);
}
function BsFloppyFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1.5A1.5 1.5 0 0 1 1.5 0H3v5.5A1.5 1.5 0 0 0 4.5 7h7A1.5 1.5 0 0 0 13 5.5V0h.086a1.5 1.5 0 0 1 1.06.44l1.415 1.414A1.5 1.5 0 0 1 16 2.914V14.5a1.5 1.5 0 0 1-1.5 1.5H14v-5.5A1.5 1.5 0 0 0 12.5 9h-9A1.5 1.5 0 0 0 2 10.5V16h-.5A1.5 1.5 0 0 1 0 14.5v-13Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16h10v-5.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5V16Zm9-16H4v5.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V0ZM9 1h2v4H9V1Z"
                }
            }
        ]
    })(props);
}
function BsFloppy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2H9v3h2V2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 0h11.586a1.5 1.5 0 0 1 1.06.44l1.415 1.414A1.5 1.5 0 0 1 16 2.914V14.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5v-13A1.5 1.5 0 0 1 1.5 0ZM1 1.5v13a.5.5 0 0 0 .5.5H2v-4.5A1.5 1.5 0 0 1 3.5 9h9a1.5 1.5 0 0 1 1.5 1.5V15h.5a.5.5 0 0 0 .5-.5V2.914a.5.5 0 0 0-.146-.353l-1.415-1.415A.5.5 0 0 0 13.086 1H13v4.5A1.5 1.5 0 0 1 11.5 7h-7A1.5 1.5 0 0 1 3 5.5V1H1.5a.5.5 0 0 0-.5.5Zm3 4a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V1H4v4.5ZM3 15h10v-4.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5V15Z"
                }
            }
        ]
    })(props);
}
function BsFloppy2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2h-2v3h2V2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 0A1.5 1.5 0 0 0 0 1.5v13A1.5 1.5 0 0 0 1.5 16h13a1.5 1.5 0 0 0 1.5-1.5V2.914a1.5 1.5 0 0 0-.44-1.06L14.147.439A1.5 1.5 0 0 0 13.086 0H1.5ZM4 6a1 1 0 0 1-1-1V1h10v4a1 1 0 0 1-1 1H4ZM3 9h10a1 1 0 0 1 1 1v5H2v-5a1 1 0 0 1 1-1Z"
                }
            }
        ]
    })(props);
}
function BsFloppy2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 0h11.586a1.5 1.5 0 0 1 1.06.44l1.415 1.414A1.5 1.5 0 0 1 16 2.914V14.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5v-13A1.5 1.5 0 0 1 1.5 0ZM1 1.5v13a.5.5 0 0 0 .5.5H2v-4.5A1.5 1.5 0 0 1 3.5 9h9a1.5 1.5 0 0 1 1.5 1.5V15h.5a.5.5 0 0 0 .5-.5V2.914a.5.5 0 0 0-.146-.353l-1.415-1.415A.5.5 0 0 0 13.086 1H13v3.5A1.5 1.5 0 0 1 11.5 6h-7A1.5 1.5 0 0 1 3 4.5V1H1.5a.5.5 0 0 0-.5.5Zm9.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-1Z"
                }
            }
        ]
    })(props);
}
function BsFlower1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.174 1.184a2 2 0 0 1 3.652 0A2 2 0 0 1 12.99 3.01a2 2 0 0 1 1.826 3.164 2 2 0 0 1 0 3.652 2 2 0 0 1-1.826 3.164 2 2 0 0 1-3.164 1.826 2 2 0 0 1-3.652 0A2 2 0 0 1 3.01 12.99a2 2 0 0 1-1.826-3.164 2 2 0 0 1 0-3.652A2 2 0 0 1 3.01 3.01a2 2 0 0 1 3.164-1.826zM8 1a1 1 0 0 0-.998 1.03l.01.091c.012.077.029.176.054.296.049.241.122.542.213.887.182.688.428 1.513.676 2.314L8 5.762l.045-.144c.248-.8.494-1.626.676-2.314.091-.345.164-.646.213-.887a4.997 4.997 0 0 0 .064-.386L9 2a1 1 0 0 0-1-1zM2 9l.03-.002.091-.01a4.99 4.99 0 0 0 .296-.054c.241-.049.542-.122.887-.213a60.59 60.59 0 0 0 2.314-.676L5.762 8l-.144-.045a60.59 60.59 0 0 0-2.314-.676 16.705 16.705 0 0 0-.887-.213 4.99 4.99 0 0 0-.386-.064L2 7a1 1 0 1 0 0 2zm7 5-.002-.03a5.005 5.005 0 0 0-.064-.386 16.398 16.398 0 0 0-.213-.888 60.582 60.582 0 0 0-.676-2.314L8 10.238l-.045.144c-.248.8-.494 1.626-.676 2.314-.091.345-.164.646-.213.887a4.996 4.996 0 0 0-.064.386L7 14a1 1 0 1 0 2 0zm-5.696-2.134.025-.017a5.001 5.001 0 0 0 .303-.248c.184-.164.408-.377.661-.629A60.614 60.614 0 0 0 5.96 9.23l.103-.111-.147.033a60.88 60.88 0 0 0-2.343.572c-.344.093-.64.18-.874.258a5.063 5.063 0 0 0-.367.138l-.027.014a1 1 0 1 0 1 1.732zM4.5 14.062a1 1 0 0 0 1.366-.366l.014-.027c.01-.02.021-.048.036-.084a5.09 5.09 0 0 0 .102-.283c.078-.233.165-.53.258-.874a60.6 60.6 0 0 0 .572-2.343l.033-.147-.11.102a60.848 60.848 0 0 0-1.743 1.667 17.07 17.07 0 0 0-.629.66 5.06 5.06 0 0 0-.248.304l-.017.025a1 1 0 0 0 .366 1.366zm9.196-8.196a1 1 0 0 0-1-1.732l-.025.017a4.951 4.951 0 0 0-.303.248 16.69 16.69 0 0 0-.661.629A60.72 60.72 0 0 0 10.04 6.77l-.102.111.147-.033a60.6 60.6 0 0 0 2.342-.572c.345-.093.642-.18.875-.258a4.993 4.993 0 0 0 .367-.138.53.53 0 0 0 .027-.014zM11.5 1.938a1 1 0 0 0-1.366.366l-.014.027c-.01.02-.021.048-.036.084a5.09 5.09 0 0 0-.102.283c-.078.233-.165.53-.258.875a60.62 60.62 0 0 0-.572 2.342l-.033.147.11-.102a60.848 60.848 0 0 0 1.743-1.667c.252-.253.465-.477.629-.66a5.001 5.001 0 0 0 .248-.304l.017-.025a1 1 0 0 0-.366-1.366zM14 9a1 1 0 0 0 0-2l-.03.002a4.996 4.996 0 0 0-.386.064c-.242.049-.543.122-.888.213-.688.182-1.513.428-2.314.676L10.238 8l.144.045c.8.248 1.626.494 2.314.676.345.091.646.164.887.213a4.996 4.996 0 0 0 .386.064L14 9zM1.938 4.5a1 1 0 0 0 .393 1.38l.084.035c.072.03.166.064.283.103.233.078.53.165.874.258a60.88 60.88 0 0 0 2.343.572l.147.033-.103-.111a60.584 60.584 0 0 0-1.666-1.742 16.705 16.705 0 0 0-.66-.629 4.996 4.996 0 0 0-.304-.248l-.025-.017a1 1 0 0 0-1.366.366zm2.196-1.196.017.025a4.996 4.996 0 0 0 .248.303c.164.184.377.408.629.661A60.597 60.597 0 0 0 6.77 5.96l.111.102-.033-.147a60.602 60.602 0 0 0-.572-2.342c-.093-.345-.18-.642-.258-.875a5.006 5.006 0 0 0-.138-.367l-.014-.027a1 1 0 1 0-1.732 1zm9.928 8.196a1 1 0 0 0-.366-1.366l-.027-.014a5 5 0 0 0-.367-.138c-.233-.078-.53-.165-.875-.258a60.619 60.619 0 0 0-2.342-.572l-.147-.033.102.111a60.73 60.73 0 0 0 1.667 1.742c.253.252.477.465.66.629a4.946 4.946 0 0 0 .304.248l.025.017a1 1 0 0 0 1.366-.366zm-3.928 2.196a1 1 0 0 0 1.732-1l-.017-.025a5.065 5.065 0 0 0-.248-.303 16.705 16.705 0 0 0-.629-.661A60.462 60.462 0 0 0 9.23 10.04l-.111-.102.033.147a60.6 60.6 0 0 0 .572 2.342c.093.345.18.642.258.875a4.985 4.985 0 0 0 .138.367.575.575 0 0 0 .014.027zM8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
                }
            }
        ]
    })(props);
}
function BsFlower2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16a4 4 0 0 0 4-4 4 4 0 0 0 0-8 4 4 0 0 0-8 0 4 4 0 1 0 0 8 4 4 0 0 0 4 4zm3-12c0 .073-.01.155-.03.247-.544.241-1.091.638-1.598 1.084A2.987 2.987 0 0 0 8 5c-.494 0-.96.12-1.372.331-.507-.446-1.054-.843-1.597-1.084A1.117 1.117 0 0 1 5 4a3 3 0 0 1 6 0zm-.812 6.052A2.99 2.99 0 0 0 11 8a2.99 2.99 0 0 0-.812-2.052c.215-.18.432-.346.647-.487C11.34 5.131 11.732 5 12 5a3 3 0 1 1 0 6c-.268 0-.66-.13-1.165-.461a6.833 6.833 0 0 1-.647-.487zm-3.56.617a3.001 3.001 0 0 0 2.744 0c.507.446 1.054.842 1.598 1.084.02.091.03.174.03.247a3 3 0 1 1-6 0c0-.073.01-.155.03-.247.544-.242 1.091-.638 1.598-1.084zm-.816-4.721A2.99 2.99 0 0 0 5 8c0 .794.308 1.516.812 2.052a6.83 6.83 0 0 1-.647.487C4.66 10.869 4.268 11 4 11a3 3 0 0 1 0-6c.268 0 .66.13 1.165.461.215.141.432.306.647.487zM8 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                }
            }
        ]
    })(props);
}
function BsFlower3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.424 8c.437-.052.811-.136 1.04-.268a2 2 0 0 0-2-3.464c-.229.132-.489.414-.752.767C9.886 4.63 10 4.264 10 4a2 2 0 1 0-4 0c0 .264.114.63.288 1.035-.263-.353-.523-.635-.752-.767a2 2 0 0 0-2 3.464c.229.132.603.216 1.04.268-.437.052-.811.136-1.04.268a2 2 0 1 0 2 3.464c.229-.132.489-.414.752-.767C6.114 11.37 6 11.736 6 12a2 2 0 1 0 4 0c0-.264-.114-.63-.288-1.035.263.353.523.635.752.767a2 2 0 1 0 2-3.464c-.229-.132-.603-.216-1.04-.268zM9 4a1.468 1.468 0 0 1-.045.205c-.039.132-.1.295-.183.484a12.88 12.88 0 0 1-.637 1.223L8 6.142a21.73 21.73 0 0 1-.135-.23 12.88 12.88 0 0 1-.637-1.223 4.216 4.216 0 0 1-.183-.484A1.473 1.473 0 0 1 7 4a1 1 0 1 1 2 0zM3.67 5.5a1 1 0 0 1 1.366-.366 1.472 1.472 0 0 1 .156.142c.094.1.204.233.326.4.245.333.502.747.742 1.163l.13.232a21.86 21.86 0 0 1-.265.002 12.88 12.88 0 0 1-1.379-.06 4.214 4.214 0 0 1-.51-.083 1.47 1.47 0 0 1-.2-.064A1 1 0 0 1 3.67 5.5zm1.366 5.366a1 1 0 0 1-1-1.732c.001 0 .016-.008.047-.02.037-.013.087-.028.153-.044.134-.032.305-.06.51-.083a12.88 12.88 0 0 1 1.379-.06c.09 0 .178 0 .266.002a21.82 21.82 0 0 1-.131.232c-.24.416-.497.83-.742 1.163a4.1 4.1 0 0 1-.327.4 1.483 1.483 0 0 1-.155.142zM9 12a1 1 0 0 1-2 0 1.476 1.476 0 0 1 .045-.206c.039-.131.1-.294.183-.483.166-.378.396-.808.637-1.223L8 9.858l.135.23c.241.415.47.845.637 1.223.083.19.144.352.183.484A1.338 1.338 0 0 1 9 12zm3.33-6.5a1 1 0 0 1-.366 1.366 1.478 1.478 0 0 1-.2.064c-.134.032-.305.06-.51.083-.412.045-.898.061-1.379.06-.09 0-.178 0-.266-.002l.131-.232c.24-.416.497-.83.742-1.163a4.1 4.1 0 0 1 .327-.4c.046-.05.085-.086.114-.11.026-.022.04-.03.041-.032a1 1 0 0 1 1.366.366zm-1.366 5.366a1.494 1.494 0 0 1-.155-.141 4.225 4.225 0 0 1-.327-.4A12.88 12.88 0 0 1 9.74 9.16a22 22 0 0 1-.13-.232l.265-.002c.48-.001.967.015 1.379.06.205.023.376.051.51.083.066.016.116.031.153.044l.048.02a1 1 0 1 1-1 1.732zM8 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                }
            }
        ]
    })(props);
}
function BsFolderCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m.5 3 .04.87a1.99 1.99 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14H9v-1H2.826a1 1 0 0 1-.995-.91l-.637-7A1 1 0 0 1 2.19 4h11.62a1 1 0 0 1 .996 1.09L14.54 8h1.005l.256-2.819A2 2 0 0 0 13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2zm5.672-1a1 1 0 0 1 .707.293L7.586 3H2.19c-.24 0-.47.042-.683.12L1.5 2.98a1 1 0 0 1 1-.98h3.672z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.854 10.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.707 0l-1.5-1.5a.5.5 0 0 1 .707-.708l1.146 1.147 2.646-2.647a.5.5 0 0 1 .708 0z"
                }
            }
        ]
    })(props);
}
function BsFolderFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.825a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"
                }
            }
        ]
    })(props);
}
function BsFolderMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m.5 3 .04.87a1.99 1.99 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14H9v-1H2.826a1 1 0 0 1-.995-.91l-.637-7A1 1 0 0 1 2.19 4h11.62a1 1 0 0 1 .996 1.09L14.54 8h1.005l.256-2.819A2 2 0 0 0 13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2zm5.672-1a1 1 0 0 1 .707.293L7.586 3H2.19c-.24 0-.47.042-.683.12L1.5 2.98a1 1 0 0 1 1-.98h3.672z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11.5a.5.5 0 0 1 .5-.5h4a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsFolderPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m.5 3 .04.87a1.99 1.99 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14H9v-1H2.826a1 1 0 0 1-.995-.91l-.637-7A1 1 0 0 1 2.19 4h11.62a1 1 0 0 1 .996 1.09L14.54 8h1.005l.256-2.819A2 2 0 0 0 13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2Zm5.672-1a1 1 0 0 1 .707.293L7.586 3H2.19c-.24 0-.47.042-.683.12L1.5 2.98a1 1 0 0 1 1-.98h3.672Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 9a.5.5 0 0 1 .5.5V11h1.5a.5.5 0 1 1 0 1H14v1.5a.5.5 0 1 1-1 0V12h-1.5a.5.5 0 0 1 0-1H13V9.5a.5.5 0 0 1 .5-.5Z"
                }
            }
        ]
    })(props);
}
function BsFolderSymlinkFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2l.04.87a1.99 1.99 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14h10.348a2 2 0 0 0 1.991-1.819l.637-7A2 2 0 0 0 13.81 3zM2.19 3c-.24 0-.47.042-.683.12L1.5 2.98a1 1 0 0 1 1-.98h3.672a1 1 0 0 1 .707.293L7.586 3H2.19zm9.608 5.271-3.182 1.97c-.27.166-.616-.036-.616-.372V9.1s-2.571-.3-4 2.4c.571-4.8 3.143-4.8 4-4.8v-.769c0-.336.346-.538.616-.371l3.182 1.969c.27.166.27.576 0 .742z"
                }
            }
        ]
    })(props);
}
function BsFolderSymlink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.798 8.271-3.182 1.97c-.27.166-.616-.036-.616-.372V9.1s-2.571-.3-4 2.4c.571-4.8 3.143-4.8 4-4.8v-.769c0-.336.346-.538.616-.371l3.182 1.969c.27.166.27.576 0 .742z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m.5 3 .04.87a1.99 1.99 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14h10.348a2 2 0 0 0 1.991-1.819l.637-7A2 2 0 0 0 13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2zm.694 2.09A1 1 0 0 1 2.19 4h11.62a1 1 0 0 1 .996 1.09l-.636 7a1 1 0 0 1-.996.91H2.826a1 1 0 0 1-.995-.91l-.637-7zM6.172 2a1 1 0 0 1 .707.293L7.586 3H2.19c-.24 0-.47.042-.683.12L1.5 2.98a1 1 0 0 1 1-.98h3.672z"
                }
            }
        ]
    })(props);
}
function BsFolderX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.54 3.87.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3h3.982a2 2 0 0 1 1.992 2.181L15.546 8H14.54l.265-2.91A1 1 0 0 0 13.81 4H2.19a1 1 0 0 0-.996 1.09l.637 7a1 1 0 0 0 .995.91H9v1H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31zm6.339-1.577A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.854 10.146a.5.5 0 0 0-.707.708L12.293 12l-1.146 1.146a.5.5 0 0 0 .707.708L13 12.707l1.146 1.147a.5.5 0 0 0 .708-.708L13.707 12l1.147-1.146a.5.5 0 0 0-.707-.708L13 11.293l-1.146-1.147z"
                }
            }
        ]
    })(props);
}
function BsFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.54 3.87.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31zM2.19 4a1 1 0 0 0-.996 1.09l.637 7a1 1 0 0 0 .995.91h10.348a1 1 0 0 0 .995-.91l.637-7A1 1 0 0 0 13.81 4H2.19zm4.69-1.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707z"
                }
            }
        ]
    })(props);
}
function BsFolder2Open(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 3.5A1.5 1.5 0 0 1 2.5 2h2.764c.958 0 1.76.56 2.311 1.184C7.985 3.648 8.48 4 9 4h4.5A1.5 1.5 0 0 1 15 5.5v.64c.57.265.94.876.856 1.546l-.64 5.124A2.5 2.5 0 0 1 12.733 15H3.266a2.5 2.5 0 0 1-2.481-2.19l-.64-5.124A1.5 1.5 0 0 1 1 6.14V3.5zM2 6h12v-.5a.5.5 0 0 0-.5-.5H9c-.964 0-1.71-.629-2.174-1.154C6.374 3.334 5.82 3 5.264 3H2.5a.5.5 0 0 0-.5.5V6zm-.367 1a.5.5 0 0 0-.496.562l.64 5.124A1.5 1.5 0 0 0 3.266 14h9.468a1.5 1.5 0 0 0 1.489-1.314l.64-5.124A.5.5 0 0 0 14.367 7H1.633z"
                }
            }
        ]
    })(props);
}
function BsFolder2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 3.5A1.5 1.5 0 0 1 2.5 2h2.764c.958 0 1.76.56 2.311 1.184C7.985 3.648 8.48 4 9 4h4.5A1.5 1.5 0 0 1 15 5.5v7a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 12.5v-9zM2.5 3a.5.5 0 0 0-.5.5V6h12v-.5a.5.5 0 0 0-.5-.5H9c-.964 0-1.71-.629-2.174-1.154C6.374 3.334 5.82 3 5.264 3H2.5zM14 7H2v5.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V7z"
                }
            }
        ]
    })(props);
}
function BsFonts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.258 3h-8.51l-.083 2.46h.479c.26-1.544.758-1.783 2.693-1.845l.424-.013v7.827c0 .663-.144.82-1.3.923v.52h4.082v-.52c-1.162-.103-1.306-.26-1.306-.923V3.602l.431.013c1.934.062 2.434.301 2.693 1.846h.479L12.258 3z"
                }
            }
        ]
    })(props);
}
function BsForwardFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m9.77 12.11 4.012-2.953a.647.647 0 0 0 0-1.114L9.771 5.09a.644.644 0 0 0-.971.557V6.65H2v3.9h6.8v1.003c0 .505.545.808.97.557z"
                }
            }
        ]
    })(props);
}
function BsForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.502 5.513a.144.144 0 0 0-.202.134V6.65a.5.5 0 0 1-.5.5H2.5v2.9h6.3a.5.5 0 0 1 .5.5v1.003c0 .108.11.176.202.134l3.984-2.933a.51.51 0 0 1 .042-.028.147.147 0 0 0 0-.252.51.51 0 0 1-.042-.028L9.502 5.513zM8.3 5.647a1.144 1.144 0 0 1 1.767-.96l3.994 2.94a1.147 1.147 0 0 1 0 1.946l-3.994 2.94a1.144 1.144 0 0 1-1.767-.96v-.503H2a.5.5 0 0 1-.5-.5v-3.9a.5.5 0 0 1 .5-.5h6.3v-.503z"
                }
            }
        ]
    })(props);
}
function BsFront(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H2a2 2 0 0 1-2-2V2zm5 10v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2v5a2 2 0 0 1-2 2H5z"
                }
            }
        ]
    })(props);
}
function BsFuelPumpDieselFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.974 9.806h.692c.306 0 .556.063.75.19.198.127.343.317.437.568.096.252.144.565.144.941 0 .284-.027.53-.083.74-.053.21-.133.386-.241.528a.986.986 0 0 1-.412.315 1.575 1.575 0 0 1-.595.103h-.692V9.806Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v8a2 2 0 0 1 2 2v.5a.5.5 0 0 0 1 0V8h-.5a.5.5 0 0 1-.5-.5V4.375a.5.5 0 0 1 .5-.5h1.495c-.011-.476-.053-.894-.201-1.222a.97.97 0 0 0-.394-.458c-.184-.11-.464-.195-.9-.195a.5.5 0 0 1 0-1c.564 0 1.034.11 1.412.336.383.228.634.551.794.907.295.655.294 1.465.294 2.081V7.5a.5.5 0 0 1-.5.5H15v4.5a1.5 1.5 0 0 1-3 0V12a1 1 0 0 0-1-1v4h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V2Zm2 .5v5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5ZM4 9v5h1.796c.496 0 .906-.099 1.23-.297.327-.197.571-.484.732-.86.161-.377.242-.828.242-1.356 0-.525-.08-.973-.242-1.344a1.775 1.775 0 0 0-.725-.85C6.71 9.098 6.296 9 5.796 9H4Z"
                }
            }
        ]
    })(props);
}
function BsFuelPumpDiesel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 2a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-5ZM4 14V9h1.796c.5 0 .913.098 1.237.293.325.195.567.479.725.85.161.371.242.82.242 1.344 0 .528-.08.98-.242 1.355a1.805 1.805 0 0 1-.732.861c-.324.198-.734.297-1.23.297H4Zm1.666-4.194h-.692v3.385h.692c.229 0 .427-.035.595-.103a.986.986 0 0 0 .412-.315c.108-.142.188-.318.241-.528.056-.21.083-.456.083-.74 0-.376-.048-.69-.144-.94a1.11 1.11 0 0 0-.436-.569c-.195-.127-.445-.19-.75-.19Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0a2 2 0 0 0-2 2v13H.5a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1H11v-4a1 1 0 0 1 1 1v.5a1.5 1.5 0 0 0 3 0V8h.5a.5.5 0 0 0 .5-.5V4.324c0-.616 0-1.426-.294-2.081a1.969 1.969 0 0 0-.794-.907C14.534 1.111 14.064 1 13.5 1a.5.5 0 0 0 0 1c.436 0 .716.086.9.195a.97.97 0 0 1 .394.458c.147.328.19.746.201 1.222H13.5a.5.5 0 0 0-.5.5V7.5a.5.5 0 0 0 .5.5h.5v4.5a.5.5 0 0 1-1 0V12a2 2 0 0 0-2-2V2a2 2 0 0 0-2-2H3Zm7 2v13H2V2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1Z"
                }
            }
        ]
    })(props);
}
function BsFuelPumpFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v8a2 2 0 0 1 2 2v.5a.5.5 0 0 0 1 0V8h-.5a.5.5 0 0 1-.5-.5V4.375a.5.5 0 0 1 .5-.5h1.495c-.011-.476-.053-.894-.201-1.222a.97.97 0 0 0-.394-.458c-.184-.11-.464-.195-.9-.195a.5.5 0 0 1 0-1c.564 0 1.034.11 1.412.336.383.228.634.551.794.907.295.655.294 1.465.294 2.081V7.5a.5.5 0 0 1-.5.5H15v4.5a1.5 1.5 0 0 1-3 0V12a1 1 0 0 0-1-1v4h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V2Zm2.5 0a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-5Z"
                }
            }
        ]
    })(props);
}
function BsFuelPump(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v8a2 2 0 0 1 2 2v.5a.5.5 0 0 0 1 0V8h-.5a.5.5 0 0 1-.5-.5V4.375a.5.5 0 0 1 .5-.5h1.495c-.011-.476-.053-.894-.201-1.222a.97.97 0 0 0-.394-.458c-.184-.11-.464-.195-.9-.195a.5.5 0 0 1 0-1c.564 0 1.034.11 1.412.336.383.228.634.551.794.907.295.655.294 1.465.294 2.081v3.175a.5.5 0 0 1-.5.501H15v4.5a1.5 1.5 0 0 1-3 0V12a1 1 0 0 0-1-1v4h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V2Zm9 0a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v13h8V2Z"
                }
            }
        ]
    })(props);
}
function BsFullscreenExit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 0a.5.5 0 0 1 .5.5v4A1.5 1.5 0 0 1 4.5 6h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5zm5 0a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 10 4.5v-4a.5.5 0 0 1 .5-.5zM0 10.5a.5.5 0 0 1 .5-.5h4A1.5 1.5 0 0 1 6 11.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 1-.5-.5zm10 1a1.5 1.5 0 0 1 1.5-1.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0v-4z"
                }
            }
        ]
    })(props);
}
function BsFullscreen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 1a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0v-4A1.5 1.5 0 0 1 1.5 0h4a.5.5 0 0 1 0 1h-4zM10 .5a.5.5 0 0 1 .5-.5h4A1.5 1.5 0 0 1 16 1.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 1-.5-.5zM.5 10a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 0 14.5v-4a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v4a1.5 1.5 0 0 1-1.5 1.5h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsFunnelFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z"
                }
            }
        ]
    })(props);
}
function BsFunnel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2h-11z"
                }
            }
        ]
    })(props);
}
function BsGearFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z"
                }
            }
        ]
    })(props);
}
function BsGearWideConnected(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.068.727c.243-.97 1.62-.97 1.864 0l.071.286a.96.96 0 0 0 1.622.434l.205-.211c.695-.719 1.888-.03 1.613.931l-.08.284a.96.96 0 0 0 1.187 1.187l.283-.081c.96-.275 1.65.918.931 1.613l-.211.205a.96.96 0 0 0 .434 1.622l.286.071c.97.243.97 1.62 0 1.864l-.286.071a.96.96 0 0 0-.434 1.622l.211.205c.719.695.03 1.888-.931 1.613l-.284-.08a.96.96 0 0 0-1.187 1.187l.081.283c.275.96-.918 1.65-1.613.931l-.205-.211a.96.96 0 0 0-1.622.434l-.071.286c-.243.97-1.62.97-1.864 0l-.071-.286a.96.96 0 0 0-1.622-.434l-.205.211c-.695.719-1.888.03-1.613-.931l.08-.284a.96.96 0 0 0-1.186-1.187l-.284.081c-.96.275-1.65-.918-.931-1.613l.211-.205a.96.96 0 0 0-.434-1.622l-.286-.071c-.97-.243-.97-1.62 0-1.864l.286-.071a.96.96 0 0 0 .434-1.622l-.211-.205c-.719-.695-.03-1.888.931-1.613l.284.08a.96.96 0 0 0 1.187-1.186l-.081-.284c-.275-.96.918-1.65 1.613-.931l.205.211a.96.96 0 0 0 1.622-.434l.071-.286zM12.973 8.5H8.25l-2.834 3.779A4.998 4.998 0 0 0 12.973 8.5zm0-1a4.998 4.998 0 0 0-7.557-3.779l2.834 3.78h4.723zM5.048 3.967c-.03.021-.058.043-.087.065l.087-.065zm-.431.355A4.984 4.984 0 0 0 3.002 8c0 1.455.622 2.765 1.615 3.678L7.375 8 4.617 4.322zm.344 7.646.087.065-.087-.065z"
                }
            }
        ]
    })(props);
}
function BsGearWide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.932.727c-.243-.97-1.62-.97-1.864 0l-.071.286a.96.96 0 0 1-1.622.434l-.205-.211c-.695-.719-1.888-.03-1.613.931l.08.284a.96.96 0 0 1-1.186 1.187l-.284-.081c-.96-.275-1.65.918-.931 1.613l.211.205a.96.96 0 0 1-.434 1.622l-.286.071c-.97.243-.97 1.62 0 1.864l.286.071a.96.96 0 0 1 .434 1.622l-.211.205c-.719.695-.03 1.888.931 1.613l.284-.08a.96.96 0 0 1 1.187 1.187l-.081.283c-.275.96.918 1.65 1.613.931l.205-.211a.96.96 0 0 1 1.622.434l.071.286c.243.97 1.62.97 1.864 0l.071-.286a.96.96 0 0 1 1.622-.434l.205.211c.695.719 1.888.03 1.613-.931l-.08-.284a.96.96 0 0 1 1.187-1.187l.283.081c.96.275 1.65-.918.931-1.613l-.211-.205a.96.96 0 0 1 .434-1.622l.286-.071c.97-.243.97-1.62 0-1.864l-.286-.071a.96.96 0 0 1-.434-1.622l.211-.205c.719-.695.03-1.888-.931-1.613l-.284.08a.96.96 0 0 1-1.187-1.186l.081-.284c.275-.96-.918-1.65-1.613-.931l-.205.211a.96.96 0 0 1-1.622-.434L8.932.727zM8 12.997a4.998 4.998 0 1 1 0-9.995 4.998 4.998 0 0 1 0 9.996z"
                }
            }
        ]
    })(props);
}
function BsGear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z"
                }
            }
        ]
    })(props);
}
function BsGem(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.1.7a.5.5 0 0 1 .4-.2h9a.5.5 0 0 1 .4.2l2.976 3.974c.149.185.156.45.01.644L8.4 15.3a.5.5 0 0 1-.8 0L.1 5.3a.5.5 0 0 1 0-.6l3-4zm11.386 3.785-1.806-2.41-.776 2.413 2.582-.003zm-3.633.004.961-2.989H4.186l.963 2.995 5.704-.006zM5.47 5.495 8 13.366l2.532-7.876-5.062.005zm-1.371-.999-.78-2.422-1.818 2.425 2.598-.003zM1.499 5.5l5.113 6.817-2.192-6.82L1.5 5.5zm7.889 6.817 5.123-6.83-2.928.002-2.195 6.828z"
                }
            }
        ]
    })(props);
}
function BsGenderAmbiguous(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.5 1a.5.5 0 0 1 0-1h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-3.45 3.45A4 4 0 0 1 8.5 10.97V13H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V14H6a.5.5 0 0 1 0-1h1.5v-2.03a4 4 0 1 1 3.471-6.648L14.293 1H11.5zm-.997 4.346a3 3 0 1 0-5.006 3.309 3 3 0 0 0 5.006-3.31z"
                }
            }
        ]
    })(props);
}
function BsGenderFemale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 1a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM3 5a5 5 0 1 1 5.5 4.975V12h2a.5.5 0 0 1 0 1h-2v2.5a.5.5 0 0 1-1 0V13h-2a.5.5 0 0 1 0-1h2V9.975A5 5 0 0 1 3 5z"
                }
            }
        ]
    })(props);
}
function BsGenderMale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.5 2a.5.5 0 0 1 0-1h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0V2.707L9.871 6.836a5 5 0 1 1-.707-.707L13.293 2H9.5zM6 6a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"
                }
            }
        ]
    })(props);
}
function BsGenderNeuter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 1a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM3 5a5 5 0 1 1 5.5 4.975V15.5a.5.5 0 0 1-1 0V9.975A5 5 0 0 1 3 5Z"
                }
            }
        ]
    })(props);
}
function BsGenderTrans(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M0 .5A.5.5 0 0 1 .5 0h3a.5.5 0 0 1 0 1H1.707L3.5 2.793l.646-.647a.5.5 0 1 1 .708.708l-.647.646.822.822A3.99 3.99 0 0 1 8 3c1.18 0 2.239.51 2.971 1.322L14.293 1H11.5a.5.5 0 0 1 0-1h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-3.45 3.45A4 4 0 0 1 8.5 10.97V13H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V14H6a.5.5 0 0 1 0-1h1.5v-2.03a4 4 0 0 1-3.05-5.814l-.95-.949-.646.647a.5.5 0 1 1-.708-.708l.647-.646L1 1.707V3.5a.5.5 0 0 1-1 0v-3zm5.49 4.856a3 3 0 1 0 5.02 3.288 3 3 0 0 0-5.02-3.288z"
                }
            }
        ]
    })(props);
}
function BsGeoAltFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
                }
            }
        ]
    })(props);
}
function BsGeoAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                }
            }
        ]
    })(props);
}
function BsGeoFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999zm2.493 8.574a.5.5 0 0 1-.411.575c-.712.118-1.28.295-1.655.493a1.319 1.319 0 0 0-.37.265.301.301 0 0 0-.057.09V14l.002.008a.147.147 0 0 0 .016.033.617.617 0 0 0 .145.15c.165.13.435.27.813.395.751.25 1.82.414 3.024.414s2.273-.163 3.024-.414c.378-.126.648-.265.813-.395a.619.619 0 0 0 .146-.15.148.148 0 0 0 .015-.033L12 14v-.004a.301.301 0 0 0-.057-.09 1.318 1.318 0 0 0-.37-.264c-.376-.198-.943-.375-1.655-.493a.5.5 0 1 1 .164-.986c.77.127 1.452.328 1.957.594C12.5 13 13 13.4 13 14c0 .426-.26.752-.544.977-.29.228-.68.413-1.116.558-.878.293-2.059.465-3.34.465-1.281 0-2.462-.172-3.34-.465-.436-.145-.826-.33-1.116-.558C3.26 14.752 3 14.426 3 14c0-.599.5-1 .961-1.243.505-.266 1.187-.467 1.957-.594a.5.5 0 0 1 .575.411z"
                }
            }
        ]
    })(props);
}
function BsGeo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999zm2.493 8.574a.5.5 0 0 1-.411.575c-.712.118-1.28.295-1.655.493a1.319 1.319 0 0 0-.37.265.301.301 0 0 0-.057.09V14l.002.008a.147.147 0 0 0 .016.033.617.617 0 0 0 .145.15c.165.13.435.27.813.395.751.25 1.82.414 3.024.414s2.273-.163 3.024-.414c.378-.126.648-.265.813-.395a.619.619 0 0 0 .146-.15.148.148 0 0 0 .015-.033L12 14v-.004a.301.301 0 0 0-.057-.09 1.318 1.318 0 0 0-.37-.264c-.376-.198-.943-.375-1.655-.493a.5.5 0 1 1 .164-.986c.77.127 1.452.328 1.957.594C12.5 13 13 13.4 13 14c0 .426-.26.752-.544.977-.29.228-.68.413-1.116.558-.878.293-2.059.465-3.34.465-1.281 0-2.462-.172-3.34-.465-.436-.145-.826-.33-1.116-.558C3.26 14.752 3 14.426 3 14c0-.599.5-1 .961-1.243.505-.266 1.187-.467 1.957-.594a.5.5 0 0 1 .575.411z"
                }
            }
        ]
    })(props);
}
function BsGiftFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2.5a2.5 2.5 0 0 1 5 0 2.5 2.5 0 0 1 5 0v.006c0 .07 0 .27-.038.494H15a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h2.038A2.968 2.968 0 0 1 3 2.506V2.5zm1.068.5H7v-.5a1.5 1.5 0 1 0-3 0c0 .085.002.274.045.43a.522.522 0 0 0 .023.07zM9 3h2.932a.56.56 0 0 0 .023-.07c.043-.156.045-.345.045-.43a1.5 1.5 0 0 0-3 0V3zm6 4v7.5a1.5 1.5 0 0 1-1.5 1.5H9V7h6zM2.5 16A1.5 1.5 0 0 1 1 14.5V7h6v9H2.5z"
                }
            }
        ]
    })(props);
}
function BsGift(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2.5a2.5 2.5 0 0 1 5 0 2.5 2.5 0 0 1 5 0v.006c0 .07 0 .27-.038.494H15a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 14.5V7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h2.038A2.968 2.968 0 0 1 3 2.506V2.5zm1.068.5H7v-.5a1.5 1.5 0 1 0-3 0c0 .085.002.274.045.43a.522.522 0 0 0 .023.07zM9 3h2.932a.56.56 0 0 0 .023-.07c.043-.156.045-.345.045-.43a1.5 1.5 0 0 0-3 0V3zM1 4v2h6V4H1zm8 0v2h6V4H9zm5 3H9v8h4.5a.5.5 0 0 0 .5-.5V7zm-7 8V7H2v7.5a.5.5 0 0 0 .5.5H7z"
                }
            }
        ]
    })(props);
}
function BsGit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.698 7.287 8.712.302a1.03 1.03 0 0 0-1.457 0l-1.45 1.45 1.84 1.84a1.223 1.223 0 0 1 1.55 1.56l1.773 1.774a1.224 1.224 0 0 1 1.267 2.025 1.226 1.226 0 0 1-2.002-1.334L8.58 5.963v4.353a1.226 1.226 0 1 1-1.008-.036V5.887a1.226 1.226 0 0 1-.666-1.608L5.093 2.465l-4.79 4.79a1.03 1.03 0 0 0 0 1.457l6.986 6.986a1.03 1.03 0 0 0 1.457 0l6.953-6.953a1.031 1.031 0 0 0 0-1.457"
                }
            }
        ]
    })(props);
}
function BsGithub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.012 8.012 0 0 0 16 8c0-4.42-3.58-8-8-8z"
                }
            }
        ]
    })(props);
}
function BsGitlab(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m15.734 6.1-.022-.058L13.534.358a.568.568 0 0 0-.563-.356.583.583 0 0 0-.328.122.582.582 0 0 0-.193.294l-1.47 4.499H5.025l-1.47-4.5A.572.572 0 0 0 2.47.358L.289 6.04l-.022.057A4.044 4.044 0 0 0 1.61 10.77l.007.006.02.014 3.318 2.485 1.64 1.242 1 .755a.673.673 0 0 0 .814 0l1-.755 1.64-1.242 3.338-2.5.009-.007a4.046 4.046 0 0 0 1.34-4.668Z"
                }
            }
        ]
    })(props);
}
function BsGlobeAmericas(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM2.04 4.326c.325 1.329 2.532 2.54 3.717 3.19.48.263.793.434.743.484-.08.08-.162.158-.242.234-.416.396-.787.749-.758 1.266.035.634.618.824 1.214 1.017.577.188 1.168.38 1.286.983.082.417-.075.988-.22 1.52-.215.782-.406 1.48.22 1.48 1.5-.5 3.798-3.186 4-5 .138-1.243-2-2-3.5-2.5-.478-.16-.755.081-.99.284-.172.15-.322.279-.51.216-.445-.148-2.5-2-1.5-2.5.78-.39.952-.171 1.227.182.078.099.163.208.273.318.609.304.662-.132.723-.633.039-.322.081-.671.277-.867.434-.434 1.265-.791 2.028-1.12.712-.306 1.365-.587 1.579-.88A7 7 0 1 1 2.04 4.327Z"
                }
            }
        ]
    })(props);
}
function BsGlobeAsiaAustralia(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10.495 6.92 1.278-.619a.483.483 0 0 0 .126-.782c-.252-.244-.682-.139-.932.107-.23.226-.513.373-.816.53l-.102.054c-.338.178-.264.626.1.736a.476.476 0 0 0 .346-.027ZM7.741 9.808V9.78a.413.413 0 1 1 .783.183l-.22.443a.602.602 0 0 1-.12.167l-.193.185a.36.36 0 1 1-.5-.516l.112-.108a.453.453 0 0 0 .138-.326ZM5.672 12.5l.482.233A.386.386 0 1 0 6.32 12h-.416a.702.702 0 0 1-.419-.139l-.277-.206a.302.302 0 1 0-.298.52l.761.325Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM1.612 10.867l.756-1.288a1 1 0 0 1 1.545-.225l1.074 1.005a.986.986 0 0 0 1.36-.011l.038-.037a.882.882 0 0 0 .26-.755c-.075-.548.37-1.033.92-1.099.728-.086 1.587-.324 1.728-.957.086-.386-.114-.83-.361-1.2-.207-.312 0-.8.374-.8.123 0 .24-.055.318-.15l.393-.474c.196-.237.491-.368.797-.403.554-.064 1.407-.277 1.583-.973.098-.391-.192-.634-.484-.88-.254-.212-.51-.426-.515-.741a6.998 6.998 0 0 1 3.425 7.692 1.015 1.015 0 0 0-.087-.063l-.316-.204a1 1 0 0 0-.977-.06l-.169.082a1 1 0 0 1-.741.051l-1.021-.329A1 1 0 0 0 11.205 9h-.165a1 1 0 0 0-.945.674l-.172.499a1 1 0 0 1-.404.514l-.802.518a1 1 0 0 0-.458.84v.455a1 1 0 0 0 1 1h.257a1 1 0 0 1 .542.16l.762.49a.998.998 0 0 0 .283.126 7.001 7.001 0 0 1-9.49-3.409Z"
                }
            }
        ]
    })(props);
}
function BsGlobeCentralSouthAsia(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM4.882 1.731a.482.482 0 0 0 .14.291.487.487 0 0 1-.126.78l-.291.146a.721.721 0 0 0-.188.135l-.48.48a1 1 0 0 1-1.023.242l-.02-.007a.996.996 0 0 0-.462-.04 7.03 7.03 0 0 1 2.45-2.027Zm-3 9.674.86-.216a1 1 0 0 0 .758-.97v-.184a1 1 0 0 1 .445-.832l.04-.026a1 1 0 0 0 .152-1.54L3.121 6.621a.414.414 0 0 1 .542-.624l1.09.818a.5.5 0 0 0 .523.047.5.5 0 0 1 .724.447v.455a.78.78 0 0 0 .131.433l.795 1.192a1 1 0 0 1 .116.238l.73 2.19a1 1 0 0 0 .949.683h.058a1 1 0 0 0 .949-.684l.73-2.189a1 1 0 0 1 .116-.238l.791-1.187A.454.454 0 0 1 11.743 8c.16 0 .306.084.392.218.557.875 1.63 2.282 2.365 2.282a.61.61 0 0 0 .04-.001 7.003 7.003 0 0 1-12.658.905Z"
                }
            }
        ]
    })(props);
}
function BsGlobeEuropeAfrica(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM3.668 2.501l-.288.646a.847.847 0 0 0 1.479.815l.245-.368a.809.809 0 0 1 1.034-.275.809.809 0 0 0 .724 0l.261-.13a1 1 0 0 1 .775-.05l.984.34c.078.028.16.044.243.054.784.093.855.377.694.801-.155.41-.616.617-1.035.487l-.01-.003C8.274 4.663 7.748 4.5 6 4.5 4.8 4.5 3.5 5.62 3.5 7c0 1.96.826 2.166 1.696 2.382.46.115.935.233 1.304.618.449.467.393 1.181.339 1.877C6.755 12.96 6.674 14 8.5 14c1.75 0 3-3.5 3-4.5 0-.262.208-.468.444-.7.396-.392.87-.86.556-1.8-.097-.291-.396-.568-.641-.756-.174-.133-.207-.396-.052-.551a.333.333 0 0 1 .42-.042l1.085.724c.11.072.255.058.348-.035.15-.15.415-.083.489.117.16.43.445 1.05.849 1.357L15 8A7 7 0 1 1 3.668 2.501Z"
                }
            }
        ]
    })(props);
}
function BsGlobe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm7.5-6.923c-.67.204-1.335.82-1.887 1.855A7.97 7.97 0 0 0 5.145 4H7.5V1.077zM4.09 4a9.267 9.267 0 0 1 .64-1.539 6.7 6.7 0 0 1 .597-.933A7.025 7.025 0 0 0 2.255 4H4.09zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a6.958 6.958 0 0 0-.656 2.5h2.49zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5H4.847zM8.5 5v2.5h2.99a12.495 12.495 0 0 0-.337-2.5H8.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5H4.51zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5H8.5zM5.145 12c.138.386.295.744.468 1.068.552 1.035 1.218 1.65 1.887 1.855V12H5.145zm.182 2.472a6.696 6.696 0 0 1-.597-.933A9.268 9.268 0 0 1 4.09 12H2.255a7.024 7.024 0 0 0 3.072 2.472zM3.82 11a13.652 13.652 0 0 1-.312-2.5h-2.49c.062.89.291 1.733.656 2.5H3.82zm6.853 3.472A7.024 7.024 0 0 0 13.745 12H11.91a9.27 9.27 0 0 1-.64 1.539 6.688 6.688 0 0 1-.597.933zM8.5 12v2.923c.67-.204 1.335-.82 1.887-1.855.173-.324.33-.682.468-1.068H8.5zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.65 13.65 0 0 1-.312 2.5zm2.802-3.5a6.959 6.959 0 0 0-.656-2.5H12.18c.174.782.282 1.623.312 2.5h2.49zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7.024 7.024 0 0 0-3.072-2.472c.218.284.418.598.597.933zM10.855 4a7.966 7.966 0 0 0-.468-1.068C9.835 1.897 9.17 1.282 8.5 1.077V4h2.355z"
                }
            }
        ]
    })(props);
}
function BsGlobe2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm7.5-6.923c-.67.204-1.335.82-1.887 1.855-.143.268-.276.56-.395.872.705.157 1.472.257 2.282.287V1.077zM4.249 3.539c.142-.384.304-.744.481-1.078a6.7 6.7 0 0 1 .597-.933A7.01 7.01 0 0 0 3.051 3.05c.362.184.763.349 1.198.49zM3.509 7.5c.036-1.07.188-2.087.436-3.008a9.124 9.124 0 0 1-1.565-.667A6.964 6.964 0 0 0 1.018 7.5h2.49zm1.4-2.741a12.344 12.344 0 0 0-.4 2.741H7.5V5.091c-.91-.03-1.783-.145-2.591-.332zM8.5 5.09V7.5h2.99a12.342 12.342 0 0 0-.399-2.741c-.808.187-1.681.301-2.591.332zM4.51 8.5c.035.987.176 1.914.399 2.741A13.612 13.612 0 0 1 7.5 10.91V8.5H4.51zm3.99 0v2.409c.91.03 1.783.145 2.591.332.223-.827.364-1.754.4-2.741H8.5zm-3.282 3.696c.12.312.252.604.395.872.552 1.035 1.218 1.65 1.887 1.855V11.91c-.81.03-1.577.13-2.282.287zm.11 2.276a6.696 6.696 0 0 1-.598-.933 8.853 8.853 0 0 1-.481-1.079 8.38 8.38 0 0 0-1.198.49 7.01 7.01 0 0 0 2.276 1.522zm-1.383-2.964A13.36 13.36 0 0 1 3.508 8.5h-2.49a6.963 6.963 0 0 0 1.362 3.675c.47-.258.995-.482 1.565-.667zm6.728 2.964a7.009 7.009 0 0 0 2.275-1.521 8.376 8.376 0 0 0-1.197-.49 8.853 8.853 0 0 1-.481 1.078 6.688 6.688 0 0 1-.597.933zM8.5 11.909v3.014c.67-.204 1.335-.82 1.887-1.855.143-.268.276-.56.395-.872A12.63 12.63 0 0 0 8.5 11.91zm3.555-.401c.57.185 1.095.409 1.565.667A6.963 6.963 0 0 0 14.982 8.5h-2.49a13.36 13.36 0 0 1-.437 3.008zM14.982 7.5a6.963 6.963 0 0 0-1.362-3.675c-.47.258-.995.482-1.565.667.248.92.4 1.938.437 3.008h2.49zM11.27 2.461c.177.334.339.694.482 1.078a8.368 8.368 0 0 0 1.196-.49 7.01 7.01 0 0 0-2.275-1.52c.218.283.418.597.597.932zm-.488 1.343a7.765 7.765 0 0 0-.395-.872C9.835 1.897 9.17 1.282 8.5 1.077V4.09c.81-.03 1.577-.13 2.282-.287z"
                }
            }
        ]
    })(props);
}
function BsGooglePlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.222 9.374c1.037-.61 1.037-2.137 0-2.748L11.528 5.04 8.32 8l3.207 2.96 2.694-1.586Zm-3.595 2.116L7.583 8.68 1.03 14.73c.201 1.029 1.36 1.61 2.303 1.055l7.294-4.295ZM1 13.396V2.603L6.846 8 1 13.396ZM1.03 1.27l6.553 6.05 3.044-2.81L3.333.215C2.39-.341 1.231.24 1.03 1.27Z"
                }
            }
        ]
    })(props);
}
function BsGoogle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.545 6.558a9.42 9.42 0 0 1 .139 1.626c0 2.434-.87 4.492-2.384 5.885h.002C11.978 15.292 10.158 16 8 16A8 8 0 1 1 8 0a7.689 7.689 0 0 1 5.352 2.082l-2.284 2.284A4.347 4.347 0 0 0 8 3.166c-2.087 0-3.86 1.408-4.492 3.304a4.792 4.792 0 0 0 0 3.063h.003c.635 1.893 2.405 3.301 4.492 3.301 1.078 0 2.004-.276 2.722-.764h-.003a3.702 3.702 0 0 0 1.599-2.431H8v-3.08h7.545z"
                }
            }
        ]
    })(props);
}
function BsGpuCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm7.5-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1.5A.5.5 0 0 1 .5 1h1a.5.5 0 0 1 .5.5V4h13.5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5H2v2.5a.5.5 0 0 1-1 0V2H.5a.5.5 0 0 1-.5-.5Zm5.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM9 8a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12.5h3.5v1a.5.5 0 0 1-.5.5H3.5a.5.5 0 0 1-.5-.5v-1Zm4 1v-1h4v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5Z"
                }
            }
        ]
    })(props);
}
function BsGraphDownArrow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M0 0h1v15h15v1H0V0Zm10 11.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-1 0v2.6l-3.613-4.417a.5.5 0 0 0-.74-.037L7.06 8.233 3.404 3.206a.5.5 0 0 0-.808.588l4 5.5a.5.5 0 0 0 .758.06l2.609-2.61L13.445 11H10.5a.5.5 0 0 0-.5.5Z"
                }
            }
        ]
    })(props);
}
function BsGraphDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M0 0h1v15h15v1H0V0Zm14.817 11.887a.5.5 0 0 0 .07-.704l-4.5-5.5a.5.5 0 0 0-.74-.037L7.06 8.233 3.404 3.206a.5.5 0 0 0-.808.588l4 5.5a.5.5 0 0 0 .758.06l2.609-2.61 4.15 5.073a.5.5 0 0 0 .704.07Z"
                }
            }
        ]
    })(props);
}
function BsGraphUpArrow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M0 0h1v15h15v1H0V0Zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.9l-3.613 4.417a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61L13.445 4H10.5a.5.5 0 0 1-.5-.5Z"
                }
            }
        ]
    })(props);
}
function BsGraphUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M0 0h1v15h15v1H0V0Zm14.817 3.113a.5.5 0 0 1 .07.704l-4.5 5.5a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61 4.15-5.073a.5.5 0 0 1 .704-.07Z"
                }
            }
        ]
    })(props);
}
function BsGrid1X2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1zm9 0a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1V1zm0 9a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-5z"
                }
            }
        ]
    })(props);
}
function BsGrid1X2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 1H1v14h5V1zm9 0h-5v5h5V1zm0 9v5h-5v-5h5zM0 1a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1zm9 0a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1V1zm1 8a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1h-5z"
                }
            }
        ]
    })(props);
}
function BsGrid3X2GapFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V4zM1 9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V9zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V9zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V9z"
                }
            }
        ]
    })(props);
}
function BsGrid3X2Gap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4v2H2V4h2zm1 7V9a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm5 5V9a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V4a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zM9 4v2H7V4h2zm5 0h-2v2h2V4zM4 9v2H2V9h2zm5 0v2H7V9h2zm5 0v2h-2V9h2zm-3-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V4zm1 4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-2z"
                }
            }
        ]
    })(props);
}
function BsGrid3X2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3.5A1.5 1.5 0 0 1 1.5 2h13A1.5 1.5 0 0 1 16 3.5v8a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 11.5v-8zM1.5 3a.5.5 0 0 0-.5.5V7h4V3H1.5zM5 8H1v3.5a.5.5 0 0 0 .5.5H5V8zm1 0v4h4V8H6zm4-1V3H6v4h4zm1 1v4h3.5a.5.5 0 0 0 .5-.5V8h-4zm0-1h4V3.5a.5.5 0 0 0-.5-.5H11v4z"
                }
            }
        ]
    })(props);
}
function BsGrid3X3GapFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2zM1 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V7zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V7zM1 12a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2z"
                }
            }
        ]
    })(props);
}
function BsGrid3X3Gap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 2v2H2V2h2zm1 12v-2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V7a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm5 10v-2a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V7a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V2a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zM9 2v2H7V2h2zm5 0v2h-2V2h2zM4 7v2H2V7h2zm5 0v2H7V7h2zm5 0h-2v2h2V7zM4 12v2H2v-2h2zm5 0v2H7v-2h2zm5 0v2h-2v-2h2zM12 1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-2zm-1 6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V7zm1 4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-2z"
                }
            }
        ]
    })(props);
}
function BsGrid3X3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v13a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5v-13zM1.5 1a.5.5 0 0 0-.5.5V5h4V1H1.5zM5 6H1v4h4V6zm1 4h4V6H6v4zm-1 1H1v3.5a.5.5 0 0 0 .5.5H5v-4zm1 0v4h4v-4H6zm5 0v4h3.5a.5.5 0 0 0 .5-.5V11h-4zm0-1h4V6h-4v4zm0-5h4V1.5a.5.5 0 0 0-.5-.5H11v4zm-1 0V1H6v4h4z"
                }
            }
        ]
    })(props);
}
function BsGridFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3z"
                }
            }
        ]
    })(props);
}
function BsGrid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zM2.5 2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zM1 10.5A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3z"
                }
            }
        ]
    })(props);
}
function BsGripHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                }
            }
        ]
    })(props);
}
function BsGripVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                }
            }
        ]
    })(props);
}
function BsHCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-5-3.998H9.67v3.322H6.33V4.002H5V12h1.33V8.455h3.34V12H11V4.002Z"
                }
            }
        ]
    })(props);
}
function BsHCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8Zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-5-3.998V12H9.67V8.455H6.33V12H5V4.002h1.33v3.322h3.34V4.002H11Z"
                }
            }
        ]
    })(props);
}
function BsHSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm9 4.002V12H9.67V8.455H6.33V12H5V4.002h1.33v3.322h3.34V4.002H11Z"
                }
            }
        ]
    })(props);
}
function BsHSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 4.002V12H9.67V8.455H6.33V12H5V4.002h1.33v3.322h3.34V4.002H11Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2Z"
                }
            }
        ]
    })(props);
}
function BsHammer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.972 2.508a.5.5 0 0 0-.16-.556l-.178-.129a5.009 5.009 0 0 0-2.076-.783C6.215.862 4.504 1.229 2.84 3.133H1.786a.5.5 0 0 0-.354.147L.146 4.567a.5.5 0 0 0 0 .706l2.571 2.579a.5.5 0 0 0 .708 0l1.286-1.29a.5.5 0 0 0 .146-.353V5.57l8.387 8.873A.5.5 0 0 0 14 14.5l1.5-1.5a.5.5 0 0 0 .017-.689l-9.129-8.63c.747-.456 1.772-.839 3.112-.839a.5.5 0 0 0 .472-.334z"
                }
            }
        ]
    })(props);
}
function BsHandIndexFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 4.466V1.75a1.75 1.75 0 1 0-3.5 0v5.34l-1.2.24a1.5 1.5 0 0 0-1.196 1.636l.345 3.106a2.5 2.5 0 0 0 .405 1.11l1.433 2.15A1.5 1.5 0 0 0 6.035 16h6.385a1.5 1.5 0 0 0 1.302-.756l1.395-2.441a3.5 3.5 0 0 0 .444-1.389l.271-2.715a2 2 0 0 0-1.99-2.199h-.581a5.114 5.114 0 0 0-.195-.248c-.191-.229-.51-.568-.88-.716-.364-.146-.846-.132-1.158-.108l-.132.012a1.26 1.26 0 0 0-.56-.642 2.632 2.632 0 0 0-.738-.288c-.31-.062-.739-.058-1.05-.046l-.048.002z"
                }
            }
        ]
    })(props);
}
function BsHandIndexThumbFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 1.75v2.716l.047-.002c.312-.012.742-.016 1.051.046.28.056.543.18.738.288.273.152.456.385.56.642l.132-.012c.312-.024.794-.038 1.158.108.37.148.689.487.88.716.075.09.141.175.195.248h.582a2 2 0 0 1 1.99 2.199l-.272 2.715a3.5 3.5 0 0 1-.444 1.389l-1.395 2.441A1.5 1.5 0 0 1 12.42 16H6.118a1.5 1.5 0 0 1-1.342-.83l-1.215-2.43L1.07 8.589a1.517 1.517 0 0 1 2.373-1.852L5 8.293V1.75a1.75 1.75 0 0 1 3.5 0z"
                }
            }
        ]
    })(props);
}
function BsHandIndexThumb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.75 1a.75.75 0 0 1 .75.75V8a.5.5 0 0 0 1 0V5.467l.086-.004c.317-.012.637-.008.816.027.134.027.294.096.448.182.077.042.15.147.15.314V8a.5.5 0 0 0 1 0V6.435l.106-.01c.316-.024.584-.01.708.04.118.046.3.207.486.43.081.096.15.19.2.259V8.5a.5.5 0 1 0 1 0v-1h.342a1 1 0 0 1 .995 1.1l-.271 2.715a2.5 2.5 0 0 1-.317.991l-1.395 2.442a.5.5 0 0 1-.434.252H6.118a.5.5 0 0 1-.447-.276l-1.232-2.465-2.512-4.185a.517.517 0 0 1 .809-.631l2.41 2.41A.5.5 0 0 0 6 9.5V1.75A.75.75 0 0 1 6.75 1zM8.5 4.466V1.75a1.75 1.75 0 1 0-3.5 0v6.543L3.443 6.736A1.517 1.517 0 0 0 1.07 8.588l2.491 4.153 1.215 2.43A1.5 1.5 0 0 0 6.118 16h6.302a1.5 1.5 0 0 0 1.302-.756l1.395-2.441a3.5 3.5 0 0 0 .444-1.389l.271-2.715a2 2 0 0 0-1.99-2.199h-.581a5.114 5.114 0 0 0-.195-.248c-.191-.229-.51-.568-.88-.716-.364-.146-.846-.132-1.158-.108l-.132.012a1.26 1.26 0 0 0-.56-.642 2.632 2.632 0 0 0-.738-.288c-.31-.062-.739-.058-1.05-.046l-.048.002zm2.094 2.025z"
                }
            }
        ]
    })(props);
}
function BsHandIndex(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.75 1a.75.75 0 0 1 .75.75V8a.5.5 0 0 0 1 0V5.467l.086-.004c.317-.012.637-.008.816.027.134.027.294.096.448.182.077.042.15.147.15.314V8a.5.5 0 1 0 1 0V6.435a4.9 4.9 0 0 1 .106-.01c.316-.024.584-.01.708.04.118.046.3.207.486.43.081.096.15.19.2.259V8.5a.5.5 0 0 0 1 0v-1h.342a1 1 0 0 1 .995 1.1l-.271 2.715a2.5 2.5 0 0 1-.317.991l-1.395 2.442a.5.5 0 0 1-.434.252H6.035a.5.5 0 0 1-.416-.223l-1.433-2.15a1.5 1.5 0 0 1-.243-.666l-.345-3.105a.5.5 0 0 1 .399-.546L5 8.11V9a.5.5 0 0 0 1 0V1.75A.75.75 0 0 1 6.75 1zM8.5 4.466V1.75a1.75 1.75 0 1 0-3.5 0v5.34l-1.2.24a1.5 1.5 0 0 0-1.196 1.636l.345 3.106a2.5 2.5 0 0 0 .405 1.11l1.433 2.15A1.5 1.5 0 0 0 6.035 16h6.385a1.5 1.5 0 0 0 1.302-.756l1.395-2.441a3.5 3.5 0 0 0 .444-1.389l.271-2.715a2 2 0 0 0-1.99-2.199h-.581a5.114 5.114 0 0 0-.195-.248c-.191-.229-.51-.568-.88-.716-.364-.146-.846-.132-1.158-.108l-.132.012a1.26 1.26 0 0 0-.56-.642 2.632 2.632 0 0 0-.738-.288c-.31-.062-.739-.058-1.05-.046l-.048.002zm2.094 2.025z"
                }
            }
        ]
    })(props);
}
function BsHandThumbsDownFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.956 14.534c.065.936.952 1.659 1.908 1.42l.261-.065a1.378 1.378 0 0 0 1.012-.965c.22-.816.533-2.512.062-4.51.136.02.285.037.443.051.713.065 1.669.071 2.516-.211.518-.173.994-.68 1.2-1.272a1.896 1.896 0 0 0-.234-1.734c.058-.118.103-.242.138-.362.077-.27.113-.568.113-.856 0-.29-.036-.586-.113-.857a2.094 2.094 0 0 0-.16-.403c.169-.387.107-.82-.003-1.149a3.162 3.162 0 0 0-.488-.9c.054-.153.076-.313.076-.465a1.86 1.86 0 0 0-.253-.912C13.1.757 12.437.28 11.5.28H8c-.605 0-1.07.08-1.466.217a4.823 4.823 0 0 0-.97.485l-.048.029c-.504.308-.999.61-2.068.723C2.682 1.815 2 2.434 2 3.279v4c0 .851.685 1.433 1.357 1.616.849.232 1.574.787 2.132 1.41.56.626.914 1.28 1.039 1.638.199.575.356 1.54.428 2.591z"
                }
            }
        ]
    })(props);
}
function BsHandThumbsDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.864 15.674c-.956.24-1.843-.484-1.908-1.42-.072-1.05-.23-2.015-.428-2.59-.125-.36-.479-1.012-1.04-1.638-.557-.624-1.282-1.179-2.131-1.41C2.685 8.432 2 7.85 2 7V3c0-.845.682-1.464 1.448-1.546 1.07-.113 1.564-.415 2.068-.723l.048-.029c.272-.166.578-.349.97-.484C6.931.08 7.395 0 8 0h3.5c.937 0 1.599.478 1.934 1.064.164.287.254.607.254.913 0 .152-.023.312-.077.464.201.262.38.577.488.9.11.33.172.762.004 1.15.069.13.12.268.159.403.077.27.113.567.113.856 0 .289-.036.586-.113.856-.035.12-.08.244-.138.363.394.571.418 1.2.234 1.733-.206.592-.682 1.1-1.2 1.272-.847.283-1.803.276-2.516.211a9.877 9.877 0 0 1-.443-.05 9.364 9.364 0 0 1-.062 4.51c-.138.508-.55.848-1.012.964l-.261.065zM11.5 1H8c-.51 0-.863.068-1.14.163-.281.097-.506.229-.776.393l-.04.025c-.555.338-1.198.73-2.49.868-.333.035-.554.29-.554.55V7c0 .255.226.543.62.65 1.095.3 1.977.997 2.614 1.709.635.71 1.064 1.475 1.238 1.977.243.7.407 1.768.482 2.85.025.362.36.595.667.518l.262-.065c.16-.04.258-.144.288-.255a8.34 8.34 0 0 0-.145-4.726.5.5 0 0 1 .595-.643h.003l.014.004.058.013a8.912 8.912 0 0 0 1.036.157c.663.06 1.457.054 2.11-.163.175-.059.45-.301.57-.651.107-.308.087-.67-.266-1.021L12.793 7l.353-.354c.043-.042.105-.14.154-.315.048-.167.075-.37.075-.581 0-.211-.027-.414-.075-.581-.05-.174-.111-.273-.154-.315l-.353-.354.353-.354c.047-.047.109-.176.005-.488a2.224 2.224 0 0 0-.505-.804l-.353-.354.353-.354c.006-.005.041-.05.041-.17a.866.866 0 0 0-.121-.415C12.4 1.272 12.063 1 11.5 1z"
                }
            }
        ]
    })(props);
}
function BsHandThumbsUpFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.956 1.745C7.021.81 7.908.087 8.864.325l.261.066c.463.116.874.456 1.012.965.22.816.533 2.511.062 4.51a9.84 9.84 0 0 1 .443-.051c.713-.065 1.669-.072 2.516.21.518.173.994.681 1.2 1.273.184.532.16 1.162-.234 1.733.058.119.103.242.138.363.077.27.113.567.113.856 0 .289-.036.586-.113.856-.039.135-.09.273-.16.404.169.387.107.819-.003 1.148a3.163 3.163 0 0 1-.488.901c.054.152.076.312.076.465 0 .305-.089.625-.253.912C13.1 15.522 12.437 16 11.5 16H8c-.605 0-1.07-.081-1.466-.218a4.82 4.82 0 0 1-.97-.484l-.048-.03c-.504-.307-.999-.609-2.068-.722C2.682 14.464 2 13.846 2 13V9c0-.85.685-1.432 1.357-1.615.849-.232 1.574-.787 2.132-1.41.56-.627.914-1.28 1.039-1.639.199-.575.356-1.539.428-2.59z"
                }
            }
        ]
    })(props);
}
function BsHandThumbsUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.864.046C7.908-.193 7.02.53 6.956 1.466c-.072 1.051-.23 2.016-.428 2.59-.125.36-.479 1.013-1.04 1.639-.557.623-1.282 1.178-2.131 1.41C2.685 7.288 2 7.87 2 8.72v4.001c0 .845.682 1.464 1.448 1.545 1.07.114 1.564.415 2.068.723l.048.03c.272.165.578.348.97.484.397.136.861.217 1.466.217h3.5c.937 0 1.599-.477 1.934-1.064a1.86 1.86 0 0 0 .254-.912c0-.152-.023-.312-.077-.464.201-.263.38-.578.488-.901.11-.33.172-.762.004-1.149.069-.13.12-.269.159-.403.077-.27.113-.568.113-.857 0-.288-.036-.585-.113-.856a2.144 2.144 0 0 0-.138-.362 1.9 1.9 0 0 0 .234-1.734c-.206-.592-.682-1.1-1.2-1.272-.847-.282-1.803-.276-2.516-.211a9.84 9.84 0 0 0-.443.05 9.365 9.365 0 0 0-.062-4.509A1.38 1.38 0 0 0 9.125.111L8.864.046zM11.5 14.721H8c-.51 0-.863-.069-1.14-.164-.281-.097-.506-.228-.776-.393l-.04-.024c-.555-.339-1.198-.731-2.49-.868-.333-.036-.554-.29-.554-.55V8.72c0-.254.226-.543.62-.65 1.095-.3 1.977-.996 2.614-1.708.635-.71 1.064-1.475 1.238-1.978.243-.7.407-1.768.482-2.85.025-.362.36-.594.667-.518l.262.066c.16.04.258.143.288.255a8.34 8.34 0 0 1-.145 4.725.5.5 0 0 0 .595.644l.003-.001.014-.003.058-.014a8.908 8.908 0 0 1 1.036-.157c.663-.06 1.457-.054 2.11.164.175.058.45.3.57.65.107.308.087.67-.266 1.022l-.353.353.353.354c.043.043.105.141.154.315.048.167.075.37.075.581 0 .212-.027.414-.075.582-.05.174-.111.272-.154.315l-.353.353.353.354c.047.047.109.177.005.488a2.224 2.224 0 0 1-.505.805l-.353.353.353.354c.006.005.041.05.041.17a.866.866 0 0 1-.121.416c-.165.288-.503.56-1.066.56z"
                }
            }
        ]
    })(props);
}
function BsHandbagFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1a2 2 0 0 0-2 2v2H5V3a3 3 0 1 1 6 0v2h-1V3a2 2 0 0 0-2-2zM5 5H3.36a1.5 1.5 0 0 0-1.483 1.277L.85 13.13A2.5 2.5 0 0 0 3.322 16h9.355a2.5 2.5 0 0 0 2.473-2.87l-1.028-6.853A1.5 1.5 0 0 0 12.64 5H11v1.5a.5.5 0 0 1-1 0V5H6v1.5a.5.5 0 0 1-1 0V5z"
                }
            }
        ]
    })(props);
}
function BsHandbag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1a2 2 0 0 1 2 2v2H6V3a2 2 0 0 1 2-2zm3 4V3a3 3 0 1 0-6 0v2H3.36a1.5 1.5 0 0 0-1.483 1.277L.85 13.13A2.5 2.5 0 0 0 3.322 16h9.355a2.5 2.5 0 0 0 2.473-2.87l-1.028-6.853A1.5 1.5 0 0 0 12.64 5H11zm-1 1v1.5a.5.5 0 0 0 1 0V6h1.639a.5.5 0 0 1 .494.426l1.028 6.851A1.5 1.5 0 0 1 12.678 15H3.322a1.5 1.5 0 0 1-1.483-1.723l1.028-6.851A.5.5 0 0 1 3.36 6H5v1.5a.5.5 0 1 0 1 0V6h4z"
                }
            }
        ]
    })(props);
}
function BsHash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.39 12.648a1.32 1.32 0 0 0-.015.18c0 .305.21.508.5.508.266 0 .492-.172.555-.477l.554-2.703h1.204c.421 0 .617-.234.617-.547 0-.312-.188-.53-.617-.53h-.985l.516-2.524h1.265c.43 0 .618-.227.618-.547 0-.313-.188-.524-.618-.524h-1.046l.476-2.304a1.06 1.06 0 0 0 .016-.164.51.51 0 0 0-.516-.516.54.54 0 0 0-.539.43l-.523 2.554H7.617l.477-2.304c.008-.04.015-.118.015-.164a.512.512 0 0 0-.523-.516.539.539 0 0 0-.531.43L6.53 5.484H5.414c-.43 0-.617.22-.617.532 0 .312.187.539.617.539h.906l-.515 2.523H4.609c-.421 0-.609.219-.609.531 0 .313.188.547.61.547h.976l-.516 2.492c-.008.04-.015.125-.015.18 0 .305.21.508.5.508.265 0 .492-.172.554-.477l.555-2.703h2.242l-.515 2.492zm-1-6.109h2.266l-.515 2.563H6.859l.532-2.563z"
                }
            }
        ]
    })(props);
}
function BsHddFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 10a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-1zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm2 0a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM.91 7.204A2.993 2.993 0 0 1 2 7h12c.384 0 .752.072 1.09.204l-1.867-3.422A1.5 1.5 0 0 0 11.906 3H4.094a1.5 1.5 0 0 0-1.317.782L.91 7.204z"
                }
            }
        ]
    })(props);
}
function BsHddNetworkFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h5.5v3A1.5 1.5 0 0 0 6 11.5H.5a.5.5 0 0 0 0 1H6A1.5 1.5 0 0 0 7.5 14h1a1.5 1.5 0 0 0 1.5-1.5h5.5a.5.5 0 0 0 0-1H10A1.5 1.5 0 0 0 8.5 10V7H14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm.5 3a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1z"
                }
            }
        ]
    })(props);
}
function BsHddNetwork(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM3 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H8.5v3a1.5 1.5 0 0 1 1.5 1.5h5.5a.5.5 0 0 1 0 1H10A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5H.5a.5.5 0 0 1 0-1H6A1.5 1.5 0 0 1 7.5 10V7H2a2 2 0 0 1-2-2V4zm1 0v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1zm6 7.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5z"
                }
            }
        ]
    })(props);
}
function BsHddRackFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h1v2H2a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2h-1V7h1a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm.5 3a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm-2 7a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zM12 7v2H4V7h8z"
                }
            }
        ]
    })(props);
}
function BsHddRack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM3 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm2 7a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-2.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h1v2H2a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2h-1V7h1a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm13 2v1a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zm0 7v1a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zm-3-4v2H4V7h8z"
                }
            }
        ]
    })(props);
}
function BsHddStackFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2H2zm.5 3a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zM2 2a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm.5 3a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1z"
                }
            }
        ]
    })(props);
}
function BsHddStack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h12zM2 9a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-2 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zM14 3a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-2 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsHdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 11a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM3 10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V9.51c0-.418.105-.83.305-1.197l2.472-4.531A1.5 1.5 0 0 1 4.094 3h7.812a1.5 1.5 0 0 1 1.317.782l2.472 4.53c.2.368.305.78.305 1.198V11zM3.655 4.26 1.592 8.043C1.724 8.014 1.86 8 2 8h12c.14 0 .276.014.408.042L12.345 4.26a.5.5 0 0 0-.439-.26H4.094a.5.5 0 0 0-.44.26zM1 10v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1z"
                }
            }
        ]
    })(props);
}
function BsHdmiFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5a1 1 0 0 0-1 1v3.293c0 .39.317.707.707.707.188 0 .368.075.5.207l.5.5a1 1 0 0 0 .707.293h11.172a1 1 0 0 0 .707-.293l.5-.5a.707.707 0 0 1 .5-.207c.39 0 .707-.317.707-.707V6a1 1 0 0 0-1-1H1Zm1.5 2h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1Z"
                }
            }
        ]
    })(props);
}
function BsHdmi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 7a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1h-11Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h.293l.707.707a1 1 0 0 0 .707.293h10.586a1 1 0 0 0 .707-.293l.707-.707H15a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H1Zm0 1h14v3h-.293a1 1 0 0 0-.707.293l-.707.707H2.707L2 9.293A1 1 0 0 0 1.293 9H1V6Z"
                }
            }
        ]
    })(props);
}
function BsHeadphones(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a6 6 0 1 1 12 0v5a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h1V8a5 5 0 0 0-5-5z"
                }
            }
        ]
    })(props);
}
function BsHeadsetVr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1.248c1.857 0 3.526.641 4.65 1.794a4.978 4.978 0 0 1 2.518 1.09C13.907 1.482 11.295 0 8 0 4.75 0 2.12 1.48.844 4.122a4.979 4.979 0 0 1 2.289-1.047C4.236 1.872 5.974 1.248 8 1.248z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12a3.988 3.988 0 0 1-2.786-1.13l-.002-.002a1.612 1.612 0 0 0-.276-.167A2.164 2.164 0 0 0 8 10.5c-.414 0-.729.103-.935.201a1.612 1.612 0 0 0-.277.167l-.002.002A4 4 0 1 1 4 4h8a4 4 0 0 1 0 8z"
                }
            }
        ]
    })(props);
}
function BsHeadset(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a6 6 0 1 1 12 0v6a2.5 2.5 0 0 1-2.5 2.5H9.366a1 1 0 0 1-.866.5h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 .866.5H11.5A1.5 1.5 0 0 0 13 12h-1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6a5 5 0 0 0-5-5z"
                }
            }
        ]
    })(props);
}
function BsHeartArrow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.707 9h4.364c-.536 1.573 2.028 3.806 4.929-.5-2.9-4.306-5.465-2.073-4.929-.5H6.707L4.854 6.146a.5.5 0 1 0-.708.708L5.293 8h-.586L2.854 6.146a.5.5 0 1 0-.708.708L3.293 8h-.586L.854 6.146a.5.5 0 1 0-.708.708L1.793 8.5.146 10.146a.5.5 0 0 0 .708.708L2.707 9h.586l-1.147 1.146a.5.5 0 0 0 .708.708L4.707 9h.586l-1.147 1.146a.5.5 0 0 0 .708.708L6.707 9Z"
                }
            }
        ]
    })(props);
}
function BsHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"
                }
            }
        ]
    })(props);
}
function BsHeartHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2.748v11.047c3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15z"
                }
            }
        ]
    })(props);
}
function BsHeartPulseFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.475 9C2.702 10.84 4.779 12.871 8 15c3.221-2.129 5.298-4.16 6.525-6H12a.5.5 0 0 1-.464-.314l-1.457-3.642-1.598 5.593a.5.5 0 0 1-.945.049L5.889 6.568l-1.473 2.21A.5.5 0 0 1 4 9H1.475Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M.88 8C-2.427 1.68 4.41-2 7.823 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C11.59-2 18.426 1.68 15.12 8h-2.783l-1.874-4.686a.5.5 0 0 0-.945.049L7.921 8.956 6.464 5.314a.5.5 0 0 0-.88-.091L3.732 8H.88Z"
                }
            }
        ]
    })(props);
}
function BsHeartPulse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053.918 3.995.78 5.323 1.508 7H.43c-2.128-5.697 4.165-8.83 7.394-5.857.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17c3.23-2.974 9.522.159 7.394 5.856h-1.078c.728-1.677.59-3.005.108-3.947C13.486.878 10.4.28 8.717 2.01L8 2.748ZM2.212 10h1.315C4.593 11.183 6.05 12.458 8 13.795c1.949-1.337 3.407-2.612 4.473-3.795h1.315c-1.265 1.566-3.14 3.25-5.788 5-2.648-1.75-4.523-3.434-5.788-5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.464 3.314a.5.5 0 0 0-.945.049L7.921 8.956 6.464 5.314a.5.5 0 0 0-.88-.091L3.732 8H.5a.5.5 0 0 0 0 1H4a.5.5 0 0 0 .416-.223l1.473-2.209 1.647 4.118a.5.5 0 0 0 .945-.049l1.598-5.593 1.457 3.642A.5.5 0 0 0 12 9h3.5a.5.5 0 0 0 0-1h-3.162l-1.874-4.686Z"
                }
            }
        ]
    })(props);
}
function BsHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15z"
                }
            }
        ]
    })(props);
}
function BsHeartbreakFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.931.586 7 3l1.5 4-2 3L8 15C22.534 5.396 13.757-2.21 8.931.586ZM7.358.77 5.5 3 7 7l-1.5 3 1.815 4.537C-6.533 4.96 2.685-2.467 7.358.77Z"
                }
            }
        ]
    })(props);
}
function BsHeartbreak(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.867 14.41c13.308-9.322 4.79-16.563.064-13.824L7 3l1.5 4-2 3L8 15a38.094 38.094 0 0 0 .867-.59Zm-.303-1.01-.971-3.237 1.74-2.608a1 1 0 0 0 .103-.906l-1.3-3.468 1.45-1.813c1.861-.948 4.446.002 5.197 2.11.691 1.94-.055 5.521-6.219 9.922Zm-1.25 1.137a36.027 36.027 0 0 1-1.522-1.116C-5.077 4.97 1.842-1.472 6.454.293c.314.12.618.279.904.477L5.5 3 7 7l-1.5 3 1.815 4.537Zm-2.3-3.06-.442-1.106a1 1 0 0 1 .034-.818l1.305-2.61L4.564 3.35a1 1 0 0 1 .168-.991l1.032-1.24c-1.688-.449-3.7.398-4.456 2.128-.711 1.627-.413 4.55 3.706 8.229Z"
                }
            }
        ]
    })(props);
}
function BsHearts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.931.481c1.627-1.671 5.692 1.254 0 5.015-5.692-3.76-1.626-6.686 0-5.015Zm6.84 1.794c1.084-1.114 3.795.836 0 3.343-3.795-2.507-1.084-4.457 0-3.343ZM7.84 7.642c2.71-2.786 9.486 2.09 0 8.358-9.487-6.268-2.71-11.144 0-8.358Z"
                }
            }
        ]
    })(props);
}
function BsHeptagonFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.779.052a.5.5 0 0 1 .442 0l6.015 2.97a.5.5 0 0 1 .267.34l1.485 6.676a.5.5 0 0 1-.093.415l-4.162 5.354a.5.5 0 0 1-.395.193H4.662a.5.5 0 0 1-.395-.193L.105 10.453a.5.5 0 0 1-.093-.415l1.485-6.676a.5.5 0 0 1 .267-.34L7.779.053z"
                }
            }
        ]
    })(props);
}
function BsHeptagonHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.779.052a.5.5 0 0 1 .442 0l6.015 2.97a.5.5 0 0 1 .267.34l1.485 6.676a.5.5 0 0 1-.093.415l-4.162 5.354a.5.5 0 0 1-.395.193H4.662a.5.5 0 0 1-.395-.193L.105 10.453a.5.5 0 0 1-.093-.415l1.485-6.676a.5.5 0 0 1 .267-.34L7.779.053zM8 15h3.093l3.868-4.975-1.383-6.212L8 1.058V15z"
                }
            }
        ]
    })(props);
}
function BsHeptagon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.779.052a.5.5 0 0 1 .442 0l6.015 2.97a.5.5 0 0 1 .267.34l1.485 6.676a.5.5 0 0 1-.093.415l-4.162 5.354a.5.5 0 0 1-.395.193H4.662a.5.5 0 0 1-.395-.193L.105 10.453a.5.5 0 0 1-.093-.415l1.485-6.676a.5.5 0 0 1 .267-.34L7.779.053zM2.422 3.813l-1.383 6.212L4.907 15h6.186l3.868-4.975-1.383-6.212L8 1.058 2.422 3.813z"
                }
            }
        ]
    })(props);
}
function BsHexagonFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.5.134a1 1 0 0 0-1 0l-6 3.577a1 1 0 0 0-.5.866v6.846a1 1 0 0 0 .5.866l6 3.577a1 1 0 0 0 1 0l6-3.577a1 1 0 0 0 .5-.866V4.577a1 1 0 0 0-.5-.866L8.5.134z"
                }
            }
        ]
    })(props);
}
function BsHexagonHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4.577v6.846L8 15V1l6 3.577zM8.5.134a1 1 0 0 0-1 0l-6 3.577a1 1 0 0 0-.5.866v6.846a1 1 0 0 0 .5.866l6 3.577a1 1 0 0 0 1 0l6-3.577a1 1 0 0 0 .5-.866V4.577a1 1 0 0 0-.5-.866L8.5.134z"
                }
            }
        ]
    })(props);
}
function BsHexagon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4.577v6.846L8 15l-6-3.577V4.577L8 1l6 3.577zM8.5.134a1 1 0 0 0-1 0l-6 3.577a1 1 0 0 0-.5.866v6.846a1 1 0 0 0 .5.866l6 3.577a1 1 0 0 0 1 0l6-3.577a1 1 0 0 0 .5-.866V4.577a1 1 0 0 0-.5-.866L8.5.134z"
                }
            }
        ]
    })(props);
}
function BsHighlighter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.096.644a2 2 0 0 1 2.791.036l1.433 1.433a2 2 0 0 1 .035 2.791l-.413.435-8.07 8.995a.5.5 0 0 1-.372.166h-3a.5.5 0 0 1-.234-.058l-.412.412A.5.5 0 0 1 2.5 15h-2a.5.5 0 0 1-.354-.854l1.412-1.412A.5.5 0 0 1 1.5 12.5v-3a.5.5 0 0 1 .166-.372l8.995-8.07.435-.414Zm-.115 1.47L2.727 9.52l3.753 3.753 7.406-8.254-2.905-2.906Zm3.585 2.17.064-.068a1 1 0 0 0-.017-1.396L13.18 1.387a1 1 0 0 0-1.396-.018l-.068.065 2.85 2.85ZM5.293 13.5 2.5 10.707v1.586L3.707 13.5h1.586Z"
                }
            }
        ]
    })(props);
}
function BsHighlights(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0Zm-8 5v1H4.5a.502.502 0 0 0-.093.009A7.029 7.029 0 0 1 3.1 13H8Zm0-1H2.255a6.998 6.998 0 0 1-.581-1H8v1Zm-6.71-2a6.96 6.96 0 0 1-.22-1H8v1H1.29ZM1 8c0-.34.024-.673.07-1H8v1H1Zm.29-2c.103-.345.231-.68.384-1H8v1H1.29Zm.965-2c.25-.36.534-.694.846-1H8v1H2.255Zm2.137-2A6.967 6.967 0 0 1 8 1v1H4.392Z"
                }
            }
        ]
    })(props);
}
function BsHospitalFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 0a1 1 0 0 0-1 1v1a1 1 0 0 0-1 1v4H1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h6v-2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V16h6a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-3V3a1 1 0 0 0-1-1V1a1 1 0 0 0-1-1H6Zm2.5 5.034v1.1l.953-.55.5.867L9 7l.953.55-.5.866-.953-.55v1.1h-1v-1.1l-.953.55-.5-.866L7 7l-.953-.55.5-.866.953.55v-1.1h1ZM2.25 9h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 2 9.75v-.5A.25.25 0 0 1 2.25 9Zm0 2h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5a.25.25 0 0 1 .25-.25ZM2 13.25a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5ZM13.25 9h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5a.25.25 0 0 1 .25-.25ZM13 11.25a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5Zm.25 1.75h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5a.25.25 0 0 1 .25-.25Z"
                }
            }
        ]
    })(props);
}
function BsHospital(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 5.034v1.1l.953-.55.5.867L9 7l.953.55-.5.866-.953-.55v1.1h-1v-1.1l-.953.55-.5-.866L7 7l-.953-.55.5-.866.953.55v-1.1h1ZM13.25 9a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-.5ZM13 11.25a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5Zm.25 1.75a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-.5Zm-11-4a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5A.25.25 0 0 0 3 9.75v-.5A.25.25 0 0 0 2.75 9h-.5Zm0 2a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-.5ZM2 13.25a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1a1 1 0 0 1 1 1v4h3a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h3V3a1 1 0 0 1 1-1V1Zm2 14h2v-3H7v3Zm3 0h1V3H5v12h1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3Zm0-14H6v1h4V1Zm2 7v7h3V8h-3Zm-8 7V8H1v7h3Z"
                }
            }
        ]
    })(props);
}
function BsHourglassBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1h-11a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1-.5-.5zm2.5.5v1a3.5 3.5 0 0 0 1.989 3.158c.533.256 1.011.791 1.011 1.491v.702s.18.149.5.149.5-.15.5-.15v-.7c0-.701.478-1.236 1.011-1.492A3.5 3.5 0 0 0 11.5 3V2h-7z"
                }
            }
        ]
    })(props);
}
function BsHourglassSplit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1h-11zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2h-7zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48V8.35zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z"
                }
            }
        ]
    })(props);
}
function BsHourglassTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 14.5a.5.5 0 0 0 .5.5h11a.5.5 0 1 0 0-1h-1v-1a4.5 4.5 0 0 0-2.557-4.06c-.29-.139-.443-.377-.443-.59v-.7c0-.213.154-.451.443-.59A4.5 4.5 0 0 0 12.5 3V2h1a.5.5 0 0 0 0-1h-11a.5.5 0 0 0 0 1h1v1a4.5 4.5 0 0 0 2.557 4.06c.29.139.443.377.443.59v.7c0 .213-.154.451-.443.59A4.5 4.5 0 0 0 3.5 13v1h-1a.5.5 0 0 0-.5.5zm2.5-.5v-1a3.5 3.5 0 0 1 1.989-3.158c.533-.256 1.011-.79 1.011-1.491v-.702s.18.101.5.101.5-.1.5-.1v.7c0 .701.478 1.236 1.011 1.492A3.5 3.5 0 0 1 11.5 13v1h-7z"
                }
            }
        ]
    })(props);
}
function BsHourglass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1h-11a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1-.5-.5zm2.5.5v1a3.5 3.5 0 0 0 1.989 3.158c.533.256 1.011.791 1.011 1.491v.702c0 .7-.478 1.235-1.011 1.491A3.5 3.5 0 0 0 4.5 13v1h7v-1a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351v-.702c0-.7.478-1.235 1.011-1.491A3.5 3.5 0 0 0 11.5 3V2h-7z"
                }
            }
        ]
    })(props);
}
function BsHouseAddFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 1 1-1 0v-1h-1a.5.5 0 1 1 0-1h1v-1a.5.5 0 0 1 1 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 3.293 4.712 4.712A4.5 4.5 0 0 0 8.758 15H3.5A1.5 1.5 0 0 1 2 13.5V9.293l6-6Z"
                }
            }
        ]
    })(props);
}
function BsHouseAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h4a.5.5 0 1 0 0-1h-4a.5.5 0 0 1-.5-.5V7.207l5-5 6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-3.5-2a.5.5 0 0 0-.5.5v1h-1a.5.5 0 0 0 0 1h1v1a.5.5 0 1 0 1 0v-1h1a.5.5 0 1 0 0-1h-1v-1a.5.5 0 0 0-.5-.5Z"
                }
            }
        ]
    })(props);
}
function BsHouseCheckFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 3.293 4.712 4.712A4.5 4.5 0 0 0 8.758 15H3.5A1.5 1.5 0 0 1 2 13.5V9.293l6-6Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.707l.547.547 1.17-1.951a.5.5 0 1 1 .858.514Z"
                }
            }
        ]
    })(props);
}
function BsHouseCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.293 1.5a1 1 0 0 1 1.414 0L11 3.793V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v3.293l2.354 2.353a.5.5 0 0 1-.708.708L8 2.207l-5 5V13.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 2 13.5V8.207l-.646.647a.5.5 0 1 1-.708-.708L7.293 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.707l.547.547 1.17-1.951a.5.5 0 1 1 .858.514Z"
                }
            }
        ]
    })(props);
}
function BsHouseDashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 3.293 4.712 4.712A4.5 4.5 0 0 0 8.758 15H3.5A1.5 1.5 0 0 1 2 13.5V9.293l6-6Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM11 12h3a.5.5 0 0 1 0 1h-3a.5.5 0 1 1 0-1Z"
                }
            }
        ]
    })(props);
}
function BsHouseDash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM11 12h3a.5.5 0 0 1 0 1h-3a.5.5 0 1 1 0-1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.293 1.5a1 1 0 0 1 1.414 0L11 3.793V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v3.293l2.354 2.353a.5.5 0 0 1-.708.708L8 2.207l-5 5V13.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 2 13.5V8.207l-.646.647a.5.5 0 1 1-.708-.708L7.293 1.5Z"
                }
            }
        ]
    })(props);
}
function BsHouseDoorFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 14.5v-3.505c0-.245.25-.495.5-.495h2c.25 0 .5.25.5.5v3.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5Z"
                }
            }
        ]
    })(props);
}
function BsHouseDoor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4h2v4a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146ZM2.5 14V7.707l5.5-5.5 5.5 5.5V14H10v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4H2.5Z"
                }
            }
        ]
    })(props);
}
function BsHouseDownFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 9a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm.354 5.854 1.5-1.5a.5.5 0 0 0-.708-.707l-.646.646V10.5a.5.5 0 0 0-1 0v2.793l-.646-.646a.5.5 0 0 0-.708.707l1.5 1.5a.5.5 0 0 0 .708 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 3.293 4.712 4.712A4.5 4.5 0 0 0 8.758 15H3.5A1.5 1.5 0 0 1 2 13.5V9.293l6-6Z"
                }
            }
        ]
    })(props);
}
function BsHouseDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.293 1.5a1 1 0 0 1 1.414 0L11 3.793V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v3.293l2.354 2.353a.5.5 0 0 1-.708.708L8 2.207l-5 5V13.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 2 13.5V8.207l-.646.647a.5.5 0 1 1-.708-.708L7.293 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 9a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm.354 5.854 1.5-1.5a.5.5 0 0 0-.708-.707l-.646.646V10.5a.5.5 0 0 0-1 0v2.793l-.646-.646a.5.5 0 0 0-.708.707l1.5 1.5a.5.5 0 0 0 .708 0Z"
                }
            }
        ]
    })(props);
}
function BsHouseExclamationFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 3.293 4.712 4.712A4.5 4.5 0 0 0 8.758 15H3.5A1.5 1.5 0 0 1 2 13.5V9.293l6-6Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-3.5-2a.5.5 0 0 0-.5.5v1.5a.5.5 0 1 0 1 0V11a.5.5 0 0 0-.5-.5Zm0 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
                }
            }
        ]
    })(props);
}
function BsHouseExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.293 1.5a1 1 0 0 1 1.414 0L11 3.793V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v3.293l2.354 2.353a.5.5 0 0 1-.708.708L8 2.207l-5 5V13.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 2 13.5V8.207l-.646.647a.5.5 0 1 1-.708-.708L7.293 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-3.5-2a.5.5 0 0 0-.5.5v1.5a.5.5 0 1 0 1 0V11a.5.5 0 0 0-.5-.5Zm0 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
                }
            }
        ]
    })(props);
}
function BsHouseFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6Z"
                }
            }
        ]
    })(props);
}
function BsHouseGearFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.293 1.5a1 1 0 0 1 1.414 0L11 3.793V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v3.293l2.354 2.353a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.07 9.047a1.5 1.5 0 0 0-1.742.26l-.02.021a1.5 1.5 0 0 0-.261 1.742 1.5 1.5 0 0 0 0 2.86 1.504 1.504 0 0 0-.12 1.07H3.5A1.5 1.5 0 0 1 2 13.5V9.293l6-6 4.724 4.724a1.5 1.5 0 0 0-1.654 1.03Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13.158 9.608-.043-.148c-.181-.613-1.049-.613-1.23 0l-.043.148a.64.64 0 0 1-.921.382l-.136-.074c-.561-.306-1.175.308-.87.869l.075.136a.64.64 0 0 1-.382.92l-.148.045c-.613.18-.613 1.048 0 1.229l.148.043a.64.64 0 0 1 .382.921l-.074.136c-.306.561.308 1.175.869.87l.136-.075a.64.64 0 0 1 .92.382l.045.149c.18.612 1.048.612 1.229 0l.043-.15a.64.64 0 0 1 .921-.38l.136.074c.561.305 1.175-.309.87-.87l-.075-.136a.64.64 0 0 1 .382-.92l.149-.044c.612-.181.612-1.049 0-1.23l-.15-.043a.64.64 0 0 1-.38-.921l.074-.136c.305-.561-.309-1.175-.87-.87l-.136.075a.64.64 0 0 1-.92-.382ZM12.5 14a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"
                }
            }
        ]
    })(props);
}
function BsHouseGear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.293 1.5a1 1 0 0 1 1.414 0L11 3.793V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v3.293l2.354 2.353a.5.5 0 0 1-.708.708L8 2.207l-5 5V13.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 2 13.5V8.207l-.646.647a.5.5 0 1 1-.708-.708L7.293 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.886 9.46c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.044c-.613-.181-.613-1.049 0-1.23l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382l.045-.148ZM14 12.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z"
                }
            }
        ]
    })(props);
}
function BsHouseHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.293 1.5a1 1 0 0 1 1.414 0L11 3.793V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v3.293l2.354 2.353a.5.5 0 0 1-.708.707L8 2.207 1.354 8.853a.5.5 0 1 1-.708-.707L7.293 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 9.293-6-6-6 6V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V9.293Zm-6-.811c1.664-1.673 5.825 1.254 0 5.018-5.825-3.764-1.664-6.691 0-5.018Z"
                }
            }
        ]
    })(props);
}
function BsHouseHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6.982C9.664 5.309 13.825 8.236 8 12 2.175 8.236 6.336 5.309 8 6.982Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.707L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.646a.5.5 0 0 0 .708-.707L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5ZM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5 5 5Z"
                }
            }
        ]
    })(props);
}
function BsHouseLockFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 3.293 4.72 4.72a3 3 0 0 0-2.709 3.248A2 2 0 0 0 9 13v2H3.5A1.5 1.5 0 0 1 2 13.5V9.293l6-6Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9a2 2 0 0 0-2 2v1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1v-1a2 2 0 0 0-2-2Zm0 1a1 1 0 0 1 1 1v1h-2v-1a1 1 0 0 1 1-1Z"
                }
            }
        ]
    })(props);
}
function BsHouseLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.293 1.5a1 1 0 0 1 1.414 0L11 3.793V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v3.293l2.354 2.353a.5.5 0 0 1-.708.708L8 2.207l-5 5V13.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 2 13.5V8.207l-.646.647a.5.5 0 1 1-.708-.708L7.293 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 13a1 1 0 0 1 1-1v-1a2 2 0 0 1 4 0v1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-2Zm3-3a1 1 0 0 0-1 1v1h2v-1a1 1 0 0 0-1-1Z"
                }
            }
        ]
    })(props);
}
function BsHouseSlashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 3.293 4.712 4.712A4.5 4.5 0 0 0 8.758 15H3.5A1.5 1.5 0 0 1 2 13.5V9.293l6-6Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.879 10.414a2.5 2.5 0 0 0-3.465 3.465l3.465-3.465Zm.707.707-3.465 3.465a2.501 2.501 0 0 0 3.465-3.465Zm-4.56-1.096a3.5 3.5 0 1 1 4.949 4.95 3.5 3.5 0 0 1-4.95-4.95Z"
                }
            }
        ]
    })(props);
}
function BsHouseSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.879 10.414a2.5 2.5 0 0 0-3.465 3.465l3.465-3.465Zm.707.707-3.465 3.465a2.501 2.501 0 0 0 3.465-3.465Zm-4.56-1.096a3.5 3.5 0 1 1 4.949 4.95 3.5 3.5 0 0 1-4.95-4.95Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.293 1.5a1 1 0 0 1 1.414 0L11 3.793V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v3.293l2.354 2.353a.5.5 0 0 1-.708.708L8 2.207l-5 5V13.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 2 13.5V8.207l-.646.647a.5.5 0 1 1-.708-.708L7.293 1.5Z"
                }
            }
        ]
    })(props);
}
function BsHouseUpFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.354-5.854 1.5 1.5a.5.5 0 0 1-.708.708L13 11.707V14.5a.5.5 0 1 1-1 0v-2.793l-.646.647a.5.5 0 0 1-.708-.707l1.5-1.5a.5.5 0 0 1 .708 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 3.293 4.712 4.712A4.5 4.5 0 0 0 8.758 15H3.5A1.5 1.5 0 0 1 2 13.5V9.293l6-6Z"
                }
            }
        ]
    })(props);
}
function BsHouseUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.293 1.5a1 1 0 0 1 1.414 0L11 3.793V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v3.293l2.354 2.353a.5.5 0 0 1-.708.708L8 2.207l-5 5V13.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 2 13.5V8.207l-.646.647a.5.5 0 1 1-.708-.708L7.293 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.354-5.854 1.5 1.5a.5.5 0 0 1-.708.708L13 11.707V14.5a.5.5 0 1 1-1 0v-2.793l-.646.647a.5.5 0 0 1-.708-.707l1.5-1.5a.5.5 0 0 1 .708 0Z"
                }
            }
        ]
    })(props);
}
function BsHouseXFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 3.293 4.712 4.712A4.5 4.5 0 0 0 8.758 15H3.5A1.5 1.5 0 0 1 2 13.5V9.293l6-6Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-.646-4.854.646.647.646-.646a.5.5 0 0 1 .708.707l-.647.646.647.646a.5.5 0 0 1-.708.708l-.646-.647-.646.647a.5.5 0 0 1-.708-.707l.647-.647-.647-.646a.5.5 0 0 1 .708-.707Z"
                }
            }
        ]
    })(props);
}
function BsHouseX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.293 1.5a1 1 0 0 1 1.414 0L11 3.793V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v3.293l2.354 2.353a.5.5 0 0 1-.708.708L8 2.207l-5 5V13.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 2 13.5V8.207l-.646.647a.5.5 0 1 1-.708-.708L7.293 1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-.646-4.854.646.647.646-.646a.5.5 0 0 1 .708.707l-.647.646.647.646a.5.5 0 0 1-.708.708l-.646-.647-.646.647a.5.5 0 0 1-.708-.707l.647-.647-.647-.646a.5.5 0 0 1 .708-.707Z"
                }
            }
        ]
    })(props);
}
function BsHouse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5ZM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5 5 5Z"
                }
            }
        ]
    })(props);
}
function BsHousesFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.207 1a1 1 0 0 0-1.414 0L.146 6.646a.5.5 0 0 0 .708.708L1 7.207V12.5A1.5 1.5 0 0 0 2.5 14h.55a2.51 2.51 0 0 1-.05-.5V9.415a1.5 1.5 0 0 1-.56-2.475l5.353-5.354L7.207 1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.793 2a1 1 0 0 1 1.414 0L12 3.793V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v3.293l1.854 1.853a.5.5 0 0 1-.708.708L15 8.207V13.5a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 4 13.5V8.207l-.146.147a.5.5 0 1 1-.708-.708L8.793 2Z"
                }
            }
        ]
    })(props);
}
function BsHouses(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.793 1a1 1 0 0 1 1.414 0l.647.646a.5.5 0 1 1-.708.708L6.5 1.707 2 6.207V12.5a.5.5 0 0 0 .5.5.5.5 0 0 1 0 1A1.5 1.5 0 0 1 1 12.5V7.207l-.146.147a.5.5 0 0 1-.708-.708L5.793 1Zm3 1a1 1 0 0 1 1.414 0L12 3.793V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v3.293l1.854 1.853a.5.5 0 0 1-.708.708L15 8.207V13.5a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 4 13.5V8.207l-.146.147a.5.5 0 1 1-.708-.708L8.793 2Zm.707.707L5 7.207V13.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V7.207l-4.5-4.5Z"
                }
            }
        ]
    })(props);
}
function BsHr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3H4a1 1 0 0 0-1 1v2.5H2V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2.5h-1V4a1 1 0 0 0-1-1zM2 9.5h1V12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V9.5h1V12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.5zm-1.5-2a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1H.5z"
                }
            }
        ]
    })(props);
}
function BsHurricane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.999 2.6A5.5 5.5 0 0 1 15 7.5a.5.5 0 0 0 1 0 6.5 6.5 0 1 0-13 0 5 5 0 0 0 6.001 4.9A5.5 5.5 0 0 1 1 7.5a.5.5 0 0 0-1 0 6.5 6.5 0 1 0 13 0 5 5 0 0 0-6.001-4.9zM10 7.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
                }
            }
        ]
    })(props);
}
function BsHypnotize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7.949 7.998.006-.003.003.009-.01-.006Zm.025-.028v-.03l.018.01-.018.02Zm0 .015.04-.022.01.006v.04l-.029.016-.021-.012v-.028Zm.049.057v-.014l-.008.01.008.004Zm-.05-.008h.006l-.006.004v-.004Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM4.965 1.69a6.972 6.972 0 0 1 3.861-.642c.722.767 1.177 1.887 1.177 3.135 0 1.656-.802 3.088-1.965 3.766 1.263.24 2.655-.815 3.406-2.742.38-.975.537-2.023.492-2.996a7.027 7.027 0 0 1 2.488 3.003c-.303 1.01-1.046 1.966-2.128 2.59-1.44.832-3.09.85-4.26.173l.008.021.012-.006-.01.01c.42 1.218 2.032 1.9 4.08 1.586a7.415 7.415 0 0 0 2.856-1.081 6.963 6.963 0 0 1-1.358 3.662c-1.03.248-2.235.084-3.322-.544-1.433-.827-2.272-2.236-2.279-3.58l-.012-.003c-.845.972-.63 2.71.666 4.327a7.415 7.415 0 0 0 2.37 1.935 6.972 6.972 0 0 1-3.86.65c-.727-.767-1.186-1.892-1.186-3.146 0-1.658.804-3.091 1.969-3.768l-.002-.007c-1.266-.25-2.666.805-3.42 2.74a7.415 7.415 0 0 0-.49 3.012 7.026 7.026 0 0 1-2.49-3.018C1.87 9.757 2.613 8.8 3.696 8.174c1.438-.83 3.084-.85 4.253-.176l.005-.006C7.538 6.77 5.924 6.085 3.872 6.4c-1.04.16-2.03.55-2.853 1.08a6.962 6.962 0 0 1 1.372-3.667l-.002.003c1.025-.243 2.224-.078 3.306.547 1.43.826 2.269 2.23 2.28 3.573L8 7.941c.837-.974.62-2.706-.673-4.319a7.415 7.415 0 0 0-2.362-1.931Z"
                }
            }
        ]
    })(props);
}
function BsImageAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0zm4.225 4.053a.5.5 0 0 0-.577.093l-3.71 4.71-2.66-2.772a.5.5 0 0 0-.63.062L.002 13v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4.5l-4.777-3.947z"
                }
            }
        ]
    })(props);
}
function BsImageFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.002 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-12a2 2 0 0 1-2-2V3zm1 9v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12zm5-6.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z"
                }
            }
        ]
    })(props);
}
function BsImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-12zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1h12z"
                }
            }
        ]
    })(props);
}
function BsImages(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.502 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.002 13a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2V5A2 2 0 0 1 2 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-1.998 2zM14 2H4a1 1 0 0 0-1 1h9.002a2 2 0 0 1 2 2v7A1 1 0 0 0 15 11V3a1 1 0 0 0-1-1zM2.002 4a1 1 0 0 0-1 1v8l2.646-2.354a.5.5 0 0 1 .63-.062l2.66 1.773 3.71-3.71a.5.5 0 0 1 .577-.094l1.777 1.947V5a1 1 0 0 0-1-1h-10z"
                }
            }
        ]
    })(props);
}
function BsInboxFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.98 4a.5.5 0 0 0-.39.188L1.54 8H6a.5.5 0 0 1 .5.5 1.5 1.5 0 1 0 3 0A.5.5 0 0 1 10 8h4.46l-3.05-3.812A.5.5 0 0 0 11.02 4H4.98zm-1.17-.437A1.5 1.5 0 0 1 4.98 3h6.04a1.5 1.5 0 0 1 1.17.563l3.7 4.625a.5.5 0 0 1 .106.374l-.39 3.124A1.5 1.5 0 0 1 14.117 13H1.883a1.5 1.5 0 0 1-1.489-1.314l-.39-3.124a.5.5 0 0 1 .106-.374l3.7-4.625z"
                }
            }
        ]
    })(props);
}
function BsInbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.98 4a.5.5 0 0 0-.39.188L1.54 8H6a.5.5 0 0 1 .5.5 1.5 1.5 0 1 0 3 0A.5.5 0 0 1 10 8h4.46l-3.05-3.812A.5.5 0 0 0 11.02 4H4.98zm9.954 5H10.45a2.5 2.5 0 0 1-4.9 0H1.066l.32 2.562a.5.5 0 0 0 .497.438h12.234a.5.5 0 0 0 .496-.438L14.933 9zM3.809 3.563A1.5 1.5 0 0 1 4.981 3h6.038a1.5 1.5 0 0 1 1.172.563l3.7 4.625a.5.5 0 0 1 .105.374l-.39 3.124A1.5 1.5 0 0 1 14.117 13H1.883a1.5 1.5 0 0 1-1.489-1.314l-.39-3.124a.5.5 0 0 1 .106-.374l3.7-4.625z"
                }
            }
        ]
    })(props);
}
function BsInboxesFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.98 1a.5.5 0 0 0-.39.188L1.54 5H6a.5.5 0 0 1 .5.5 1.5 1.5 0 0 0 3 0A.5.5 0 0 1 10 5h4.46l-3.05-3.812A.5.5 0 0 0 11.02 1H4.98zM3.81.563A1.5 1.5 0 0 1 4.98 0h6.04a1.5 1.5 0 0 1 1.17.563l3.7 4.625a.5.5 0 0 1 .106.374l-.39 3.124A1.5 1.5 0 0 1 14.117 10H1.883A1.5 1.5 0 0 1 .394 8.686l-.39-3.124a.5.5 0 0 1 .106-.374L3.81.563zM.125 11.17A.5.5 0 0 1 .5 11H6a.5.5 0 0 1 .5.5 1.5 1.5 0 0 0 3 0 .5.5 0 0 1 .5-.5h5.5a.5.5 0 0 1 .496.562l-.39 3.124A1.5 1.5 0 0 1 14.117 16H1.883a1.5 1.5 0 0 1-1.489-1.314l-.39-3.124a.5.5 0 0 1 .121-.393z"
                }
            }
        ]
    })(props);
}
function BsInboxes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.98 1a.5.5 0 0 0-.39.188L1.54 5H6a.5.5 0 0 1 .5.5 1.5 1.5 0 0 0 3 0A.5.5 0 0 1 10 5h4.46l-3.05-3.812A.5.5 0 0 0 11.02 1H4.98zm9.954 5H10.45a2.5 2.5 0 0 1-4.9 0H1.066l.32 2.562A.5.5 0 0 0 1.884 9h12.234a.5.5 0 0 0 .496-.438L14.933 6zM3.809.563A1.5 1.5 0 0 1 4.981 0h6.038a1.5 1.5 0 0 1 1.172.563l3.7 4.625a.5.5 0 0 1 .105.374l-.39 3.124A1.5 1.5 0 0 1 14.117 10H1.883A1.5 1.5 0 0 1 .394 8.686l-.39-3.124a.5.5 0 0 1 .106-.374L3.81.563zM.125 11.17A.5.5 0 0 1 .5 11H6a.5.5 0 0 1 .5.5 1.5 1.5 0 0 0 3 0 .5.5 0 0 1 .5-.5h5.5a.5.5 0 0 1 .496.562l-.39 3.124A1.5 1.5 0 0 1 14.117 16H1.883a1.5 1.5 0 0 1-1.489-1.314l-.39-3.124a.5.5 0 0 1 .121-.393zm.941.83.32 2.562a.5.5 0 0 0 .497.438h12.234a.5.5 0 0 0 .496-.438l.32-2.562H10.45a2.5 2.5 0 0 1-4.9 0H1.066z"
                }
            }
        ]
    })(props);
}
function BsIncognito(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "m4.736 1.968-.892 3.269-.014.058C2.113 5.568 1 6.006 1 6.5 1 7.328 4.134 8 8 8s7-.672 7-1.5c0-.494-1.113-.932-2.83-1.205a1.032 1.032 0 0 0-.014-.058l-.892-3.27c-.146-.533-.698-.849-1.239-.734C9.411 1.363 8.62 1.5 8 1.5c-.62 0-1.411-.136-2.025-.267-.541-.115-1.093.2-1.239.735Zm.015 3.867a.25.25 0 0 1 .274-.224c.9.092 1.91.143 2.975.143a29.58 29.58 0 0 0 2.975-.143.25.25 0 0 1 .05.498c-.918.093-1.944.145-3.025.145s-2.107-.052-3.025-.145a.25.25 0 0 1-.224-.274ZM3.5 10h2a.5.5 0 0 1 .5.5v1a1.5 1.5 0 0 1-3 0v-1a.5.5 0 0 1 .5-.5Zm-1.5.5c0-.175.03-.344.085-.5H2a.5.5 0 0 1 0-1h3.5a1.5 1.5 0 0 1 1.488 1.312 3.5 3.5 0 0 1 2.024 0A1.5 1.5 0 0 1 10.5 9H14a.5.5 0 0 1 0 1h-.085c.055.156.085.325.085.5v1a2.5 2.5 0 0 1-5 0v-.14l-.21-.07a2.5 2.5 0 0 0-1.58 0l-.21.07v.14a2.5 2.5 0 0 1-5 0v-1Zm8.5-.5h2a.5.5 0 0 1 .5.5v1a1.5 1.5 0 0 1-3 0v-1a.5.5 0 0 1 .5-.5Z"
                }
            }
        ]
    })(props);
}
function BsIndent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 8a.5.5 0 0 1 .5-.5h6.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H3.5A.5.5 0 0 1 3 8Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.5 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5Z"
                }
            }
        ]
    })(props);
}
function BsInfinity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.68 5.792 7.345 7.75 5.681 9.708a2.75 2.75 0 1 1 0-3.916ZM8 6.978 6.416 5.113l-.014-.015a3.75 3.75 0 1 0 0 5.304l.014-.015L8 8.522l1.584 1.865.014.015a3.75 3.75 0 1 0 0-5.304l-.014.015L8 6.978Zm.656.772 1.663-1.958a2.75 2.75 0 1 1 0 3.916L8.656 7.75Z"
                }
            }
        ]
    })(props);
}
function BsInfoCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                }
            }
        ]
    })(props);
}
function BsInfoCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                }
            }
        ]
    })(props);
}
function BsInfoLg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m9.708 6.075-3.024.379-.108.502.595.108c.387.093.464.232.38.619l-.975 4.577c-.255 1.183.14 1.74 1.067 1.74.72 0 1.554-.332 1.933-.789l.116-.549c-.263.232-.65.325-.905.325-.363 0-.494-.255-.402-.704l1.323-6.208Zm.091-2.755a1.32 1.32 0 1 1-2.64 0 1.32 1.32 0 0 1 2.64 0Z"
                }
            }
        ]
    })(props);
}
function BsInfoSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.93 4.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                }
            }
        ]
    })(props);
}
function BsInfoSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                }
            }
        ]
    })(props);
}
function BsInfo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                }
            }
        ]
    })(props);
}
function BsInputCursorText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 2a.5.5 0 0 1 .5-.5c.862 0 1.573.287 2.06.566.174.099.321.198.44.286.119-.088.266-.187.44-.286A4.165 4.165 0 0 1 10.5 1.5a.5.5 0 0 1 0 1c-.638 0-1.177.213-1.564.434a3.49 3.49 0 0 0-.436.294V7.5H9a.5.5 0 0 1 0 1h-.5v4.272c.1.08.248.187.436.294.387.221.926.434 1.564.434a.5.5 0 0 1 0 1 4.165 4.165 0 0 1-2.06-.566A4.561 4.561 0 0 1 8 13.65a4.561 4.561 0 0 1-.44.285 4.165 4.165 0 0 1-2.06.566.5.5 0 0 1 0-1c.638 0 1.177-.213 1.564-.434.188-.107.335-.214.436-.294V8.5H7a.5.5 0 0 1 0-1h.5V3.228a3.49 3.49 0 0 0-.436-.294A3.166 3.166 0 0 0 5.5 2.5.5.5 0 0 1 5 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"
                }
            }
        ]
    })(props);
}
function BsInputCursor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13A.5.5 0 0 1 8 1z"
                }
            }
        ]
    })(props);
}
function BsInstagram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z"
                }
            }
        ]
    })(props);
}
function BsIntersect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H2a2 2 0 0 1-2-2V2zm5 10v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2v5a2 2 0 0 1-2 2H5zm6-8V2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2V6a2 2 0 0 1 2-2h5z"
                }
            }
        ]
    })(props);
}
function BsJournalAlbum(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 4a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-5zm1 7a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"
                }
            }
        ]
    })(props);
}
function BsJournalArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 5a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5A.5.5 0 0 1 8 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"
                }
            }
        ]
    })(props);
}
function BsJournalArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 11a.5.5 0 0 0 .5-.5V6.707l1.146 1.147a.5.5 0 0 0 .708-.708l-2-2a.5.5 0 0 0-.708 0l-2 2a.5.5 0 1 0 .708.708L7.5 6.707V10.5a.5.5 0 0 0 .5.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"
                }
            }
        ]
    })(props);
}
function BsJournalBookmarkFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 1h6v7a.5.5 0 0 1-.757.429L9 7.083 6.757 8.43A.5.5 0 0 1 6 8V1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"
                }
            }
        ]
    })(props);
}
function BsJournalBookmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 8V1h1v6.117L8.743 6.07a.5.5 0 0 1 .514 0L11 7.117V1h1v7a.5.5 0 0 1-.757.429L9 7.083 6.757 8.43A.5.5 0 0 1 6 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"
                }
            }
        ]
    })(props);
}
function BsJournalCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.854 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 8.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"
                }
            }
        ]
    })(props);
}
function BsJournalCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.646 5.646a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L10.293 8 8.646 6.354a.5.5 0 0 1 0-.708zm-1.292 0a.5.5 0 0 0-.708 0l-2 2a.5.5 0 0 0 0 .708l2 2a.5.5 0 0 0 .708-.708L5.707 8l1.647-1.646a.5.5 0 0 0 0-.708z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"
                }
            }
        ]
    })(props);
}
function BsJournalMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 4a.5.5 0 0 1 .5.5v.634l.549-.317a.5.5 0 1 1 .5.866L9 6l.549.317a.5.5 0 1 1-.5.866L8.5 6.866V7.5a.5.5 0 0 1-1 0v-.634l-.549.317a.5.5 0 1 1-.5-.866L7 6l-.549-.317a.5.5 0 0 1 .5-.866l.549.317V4.5A.5.5 0 0 1 8 4zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"
                }
            }
        ]
    })(props);
}
function BsJournalMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"
                }
            }
        ]
    })(props);
}
function BsJournalPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 5.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 .5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"
                }
            }
        ]
    })(props);
}
function BsJournalRichtext(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 3.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm-.861 1.542 1.33.886 1.854-1.855a.25.25 0 0 1 .289-.047L11 4.75V7a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 7v-.5s1.54-1.274 1.639-1.208zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"
                }
            }
        ]
    })(props);
}
function BsJournalText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 10.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"
                }
            }
        ]
    })(props);
}
function BsJournalX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.146 6.146a.5.5 0 0 1 .708 0L8 7.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 8l1.147 1.146a.5.5 0 0 1-.708.708L8 8.707 6.854 9.854a.5.5 0 0 1-.708-.708L7.293 8 6.146 6.854a.5.5 0 0 1 0-.708z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"
                }
            }
        ]
    })(props);
}
function BsJournal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"
                }
            }
        ]
    })(props);
}
function BsJournals(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 0h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2 2 2 0 0 1-2 2H3a2 2 0 0 1-2-2h1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1H1a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v9a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1H3a2 2 0 0 1 2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 6v-.5a.5.5 0 0 1 1 0V6h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V9h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 2.5v.5H.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H2v-.5a.5.5 0 0 0-1 0z"
                }
            }
        ]
    })(props);
}
function BsJoystick(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2a2 2 0 0 1-1.5 1.937v5.087c.863.083 1.5.377 1.5.726 0 .414-.895.75-2 .75s-2-.336-2-.75c0-.35.637-.643 1.5-.726V3.937A2 2 0 1 1 10 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 9.665v1.717a1 1 0 0 0 .553.894l6.553 3.277a2 2 0 0 0 1.788 0l6.553-3.277a1 1 0 0 0 .553-.894V9.665c0-.1-.06-.19-.152-.23L9.5 6.715v.993l5.227 2.178a.125.125 0 0 1 .001.23l-5.94 2.546a2 2 0 0 1-1.576 0l-5.94-2.546a.125.125 0 0 1 .001-.23L6.5 7.708l-.013-.988L.152 9.435a.25.25 0 0 0-.152.23z"
                }
            }
        ]
    })(props);
}
function BsJustifyLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsJustifyRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-4-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsJustify(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 12.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsKanbanFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2h-11zm5 2h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm-5 1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V3zm9-1h1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z"
                }
            }
        ]
    })(props);
}
function BsKanban(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h11zm-11-1a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2h-11z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 3a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V3zm-4 0a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V3zm8 0a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V3z"
                }
            }
        ]
    })(props);
}
function BsKeyFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 11.5a3.5 3.5 0 1 1 3.163-5H14L15.5 8 14 9.5l-1-1-1 1-1-1-1 1-1-1-1 1H6.663a3.5 3.5 0 0 1-3.163 2zM2.5 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                }
            }
        ]
    })(props);
}
function BsKey(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 8a4 4 0 0 1 7.465-2H14a.5.5 0 0 1 .354.146l1.5 1.5a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0L13 9.207l-.646.647a.5.5 0 0 1-.708 0L11 9.207l-.646.647a.5.5 0 0 1-.708 0L9 9.207l-.646.647A.5.5 0 0 1 8 10h-.535A4 4 0 0 1 0 8zm4-3a3 3 0 1 0 2.712 4.285A.5.5 0 0 1 7.163 9h.63l.853-.854a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.793-.793-1-1h-6.63a.5.5 0 0 1-.451-.285A3 3 0 0 0 4 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                }
            }
        ]
    })(props);
}
function BsKeyboardFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6zm13 .25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-.5a.25.25 0 0 0-.25.25zM2.25 8a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5A.25.25 0 0 0 3 8.75v-.5A.25.25 0 0 0 2.75 8h-.5zM4 8.25v.5c0 .138.112.25.25.25h.5A.25.25 0 0 0 5 8.75v-.5A.25.25 0 0 0 4.75 8h-.5a.25.25 0 0 0-.25.25zM6.25 8a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5A.25.25 0 0 0 7 8.75v-.5A.25.25 0 0 0 6.75 8h-.5zM8 8.25v.5c0 .138.112.25.25.25h.5A.25.25 0 0 0 9 8.75v-.5A.25.25 0 0 0 8.75 8h-.5a.25.25 0 0 0-.25.25zM13.25 8a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-.5zm0 2a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-.5zm-3-2a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h1.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-1.5zm.75 2.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-.5a.25.25 0 0 0-.25.25zM11.25 6a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-.5zM9 6.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5A.25.25 0 0 0 9.75 6h-.5a.25.25 0 0 0-.25.25zM7.25 6a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5A.25.25 0 0 0 8 6.75v-.5A.25.25 0 0 0 7.75 6h-.5zM5 6.25v.5c0 .138.112.25.25.25h.5A.25.25 0 0 0 6 6.75v-.5A.25.25 0 0 0 5.75 6h-.5a.25.25 0 0 0-.25.25zM2.25 6a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h1.5A.25.25 0 0 0 4 6.75v-.5A.25.25 0 0 0 3.75 6h-1.5zM2 10.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-.5a.25.25 0 0 0-.25.25zM4.25 10a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h5.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-5.5z"
                }
            }
        ]
    })(props);
}
function BsKeyboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h12zM2 4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10.25a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm0-2a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm-5 0A.25.25 0 0 1 8.25 8h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 8 8.75v-.5zm2 0a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-.5zm1 2a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm-5-2A.25.25 0 0 1 6.25 8h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 6 8.75v-.5zm-2 0A.25.25 0 0 1 4.25 8h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 4 8.75v-.5zm-2 0A.25.25 0 0 1 2.25 8h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 2 8.75v-.5zm11-2a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm-2 0a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm-2 0A.25.25 0 0 1 9.25 6h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 9 6.75v-.5zm-2 0A.25.25 0 0 1 7.25 6h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 7 6.75v-.5zm-2 0A.25.25 0 0 1 5.25 6h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 5 6.75v-.5zm-3 0A.25.25 0 0 1 2.25 6h1.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-1.5A.25.25 0 0 1 2 6.75v-.5zm0 4a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm2 0a.25.25 0 0 1 .25-.25h5.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-5.5a.25.25 0 0 1-.25-.25v-.5z"
                }
            }
        ]
    })(props);
}
function BsLadder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 1a.5.5 0 0 1 .5.5V2h6v-.5a.5.5 0 0 1 1 0v14a.5.5 0 0 1-1 0V15H5v.5a.5.5 0 0 1-1 0v-14a.5.5 0 0 1 .5-.5zM5 14h6v-2H5v2zm0-3h6V9H5v2zm0-3h6V6H5v2zm0-3h6V3H5v2z"
                }
            }
        ]
    })(props);
}
function BsLampFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.04.303A.5.5 0 0 1 5.5 0h5c.2 0 .38.12.46.303l3 7a.5.5 0 0 1-.363.687h-.002c-.15.03-.3.056-.45.081a32.731 32.731 0 0 1-4.645.425V13.5a.5.5 0 1 1-1 0V8.495a32.753 32.753 0 0 1-4.645-.425c-.15-.025-.3-.05-.45-.08h-.003a.5.5 0 0 1-.362-.688l3-7Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.493 12.574a.5.5 0 0 1-.411.575c-.712.118-1.28.295-1.655.493a1.319 1.319 0 0 0-.37.265.301.301 0 0 0-.052.075l-.001.004-.004.01V14l.002.008a.147.147 0 0 0 .016.033.62.62 0 0 0 .145.15c.165.13.435.27.813.395.751.25 1.82.414 3.024.414s2.273-.163 3.024-.414c.378-.126.648-.265.813-.395a.62.62 0 0 0 .146-.15.148.148 0 0 0 .015-.033L12 14v-.004a.301.301 0 0 0-.057-.09 1.318 1.318 0 0 0-.37-.264c-.376-.198-.943-.375-1.655-.493a.5.5 0 1 1 .164-.986c.77.127 1.452.328 1.957.594C12.5 13 13 13.4 13 14c0 .426-.26.752-.544.977-.29.228-.68.413-1.116.558-.878.293-2.059.465-3.34.465-1.281 0-2.462-.172-3.34-.465-.436-.145-.826-.33-1.116-.558C3.26 14.752 3 14.426 3 14c0-.599.5-1 .961-1.243.505-.266 1.187-.467 1.957-.594a.5.5 0 0 1 .575.411Z"
                }
            }
        ]
    })(props);
}
function BsLamp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.04.303A.5.5 0 0 1 5.5 0h5c.2 0 .38.12.46.303l3 7a.5.5 0 0 1-.363.687h-.002c-.15.03-.3.056-.45.081a32.731 32.731 0 0 1-4.645.425V13.5a.5.5 0 1 1-1 0V8.495a32.753 32.753 0 0 1-4.645-.425c-.15-.025-.3-.05-.45-.08h-.003a.5.5 0 0 1-.362-.688l3-7ZM3.21 7.116A31.27 31.27 0 0 0 8 7.5a31.27 31.27 0 0 0 4.791-.384L10.171 1H5.83L3.209 7.116Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.493 12.574a.5.5 0 0 1-.411.575c-.712.118-1.28.295-1.655.493a1.319 1.319 0 0 0-.37.265.301.301 0 0 0-.052.075l-.001.004-.004.01V14l.002.008a.147.147 0 0 0 .016.033.62.62 0 0 0 .145.15c.165.13.435.27.813.395.751.25 1.82.414 3.024.414s2.273-.163 3.024-.414c.378-.126.648-.265.813-.395a.62.62 0 0 0 .146-.15.148.148 0 0 0 .015-.033L12 14v-.004a.301.301 0 0 0-.057-.09 1.318 1.318 0 0 0-.37-.264c-.376-.198-.943-.375-1.655-.493a.5.5 0 1 1 .164-.986c.77.127 1.452.328 1.957.594C12.5 13 13 13.4 13 14c0 .426-.26.752-.544.977-.29.228-.68.413-1.116.558-.878.293-2.059.465-3.34.465-1.281 0-2.462-.172-3.34-.465-.436-.145-.826-.33-1.116-.558C3.26 14.752 3 14.426 3 14c0-.599.5-1 .961-1.243.505-.266 1.187-.467 1.957-.594a.5.5 0 0 1 .575.411Z"
                }
            }
        ]
    })(props);
}
function BsLaptopFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 2A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z"
                }
            }
        ]
    })(props);
}
function BsLaptop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z"
                }
            }
        ]
    })(props);
}
function BsLayerBackward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.354 15.854a.5.5 0 0 1-.708 0l-3-3a.5.5 0 0 1 0-.708l1-1a.5.5 0 0 1 .708 0l.646.647V4H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9v7.793l.646-.647a.5.5 0 0 1 .708 0l1 1a.5.5 0 0 1 0 .708l-3 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 9a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4.5a.5.5 0 0 1 0 1H1v2h4.5a.5.5 0 0 1 0 1H1zm9.5 0a.5.5 0 0 1 0-1H15V6h-4.5a.5.5 0 0 1 0-1H15a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-4.5z"
                }
            }
        ]
    })(props);
}
function BsLayerForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.354.146a.5.5 0 0 0-.708 0l-3 3a.5.5 0 0 0 0 .708l1 1a.5.5 0 0 0 .708 0L7 4.207V12H1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H9V4.207l.646.647a.5.5 0 0 0 .708 0l1-1a.5.5 0 0 0 0-.708l-3-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h4.5a.5.5 0 0 0 0-1H1V8h4.5a.5.5 0 0 0 0-1H1zm9.5 0a.5.5 0 0 0 0 1H15v2h-4.5a.5.5 0 0 0 0 1H15a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-4.5z"
                }
            }
        ]
    })(props);
}
function BsLayersFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.765 1.559a.5.5 0 0 1 .47 0l7.5 4a.5.5 0 0 1 0 .882l-7.5 4a.5.5 0 0 1-.47 0l-7.5-4a.5.5 0 0 1 0-.882l7.5-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2.125 8.567-1.86.992a.5.5 0 0 0 0 .882l7.5 4a.5.5 0 0 0 .47 0l7.5-4a.5.5 0 0 0 0-.882l-1.86-.992-5.17 2.756a1.5 1.5 0 0 1-1.41 0l-5.17-2.756z"
                }
            }
        ]
    })(props);
}
function BsLayersHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.235 1.559a.5.5 0 0 0-.47 0l-7.5 4a.5.5 0 0 0 0 .882L3.188 8 .264 9.559a.5.5 0 0 0 0 .882l7.5 4a.5.5 0 0 0 .47 0l7.5-4a.5.5 0 0 0 0-.882L12.813 8l2.922-1.559a.5.5 0 0 0 0-.882l-7.5-4zM8 9.433 1.562 6 8 2.567 14.438 6 8 9.433z"
                }
            }
        ]
    })(props);
}
function BsLayers(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.235 1.559a.5.5 0 0 0-.47 0l-7.5 4a.5.5 0 0 0 0 .882L3.188 8 .264 9.559a.5.5 0 0 0 0 .882l7.5 4a.5.5 0 0 0 .47 0l7.5-4a.5.5 0 0 0 0-.882L12.813 8l2.922-1.559a.5.5 0 0 0 0-.882l-7.5-4zm3.515 7.008L14.438 10 8 13.433 1.562 10 4.25 8.567l3.515 1.874a.5.5 0 0 0 .47 0l3.515-1.874zM8 9.433 1.562 6 8 2.567 14.438 6 8 9.433z"
                }
            }
        ]
    })(props);
}
function BsLayoutSidebarInsetReverse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2zm12-1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V4z"
                }
            }
        ]
    })(props);
}
function BsLayoutSidebarInset(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h12zM2 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z"
                }
            }
        ]
    })(props);
}
function BsLayoutSidebarReverse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3zm-5-1v12H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h9zm1 0h2a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-2V2z"
                }
            }
        ]
    })(props);
}
function BsLayoutSidebar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3zm5-1v12h9a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H5zM4 2H2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h2V2z"
                }
            }
        ]
    })(props);
}
function BsLayoutSplit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3zm8.5-1v12H14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H8.5zm-1 0H2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h5.5V2z"
                }
            }
        ]
    })(props);
}
function BsLayoutTextSidebarReverse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 3a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h5zm0 3a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h5zm.5 3.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5zm-.5 2.5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2zM4 1v14H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h2zm1 0h9a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5V1z"
                }
            }
        ]
    })(props);
}
function BsLayoutTextSidebar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 3a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 3a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM3 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm12-1v14h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-2zm-1 0H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h9V1z"
                }
            }
        ]
    })(props);
}
function BsLayoutTextWindowReverse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5zm0 3a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5zm-.5 2.5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12zM2 1a1 1 0 0 0-1 1v1h14V2a1 1 0 0 0-1-1H2zM1 4v10a1 1 0 0 0 1 1h2V4H1zm4 0v11h9a1 1 0 0 0 1-1V4H5z"
                }
            }
        ]
    })(props);
}
function BsLayoutTextWindow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 6.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 3a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm12 1a1 1 0 0 1 1 1v1H1V2a1 1 0 0 1 1-1h12zm1 3v10a1 1 0 0 1-1 1h-2V4h3zm-4 0v11H2a1 1 0 0 1-1-1V4h10z"
                }
            }
        ]
    })(props);
}
function BsLayoutThreeColumns(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v13a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5v-13zM1.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5H5V1H1.5zM10 15V1H6v14h4zm1 0h3.5a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5H11v14z"
                }
            }
        ]
    })(props);
}
function BsLayoutWtf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 1v8H1V1h4zM1 0a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1zm13 2v5H9V2h5zM9 1a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9zM5 13v2H3v-2h2zm-2-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H3zm12-1v2H9v-2h6zm-6-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H9z"
                }
            }
        ]
    })(props);
}
function BsLifePreserver(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm6.43-5.228a7.025 7.025 0 0 1-3.658 3.658l-1.115-2.788a4.015 4.015 0 0 0 1.985-1.985l2.788 1.115zM5.228 14.43a7.025 7.025 0 0 1-3.658-3.658l2.788-1.115a4.015 4.015 0 0 0 1.985 1.985L5.228 14.43zm9.202-9.202-2.788 1.115a4.015 4.015 0 0 0-1.985-1.985l1.115-2.788a7.025 7.025 0 0 1 3.658 3.658zm-8.087-.87a4.015 4.015 0 0 0-1.985 1.985L1.57 5.228A7.025 7.025 0 0 1 5.228 1.57l1.115 2.788zM8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
                }
            }
        ]
    })(props);
}
function BsLightbulbFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm3 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsLightbulbOffFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6c0-.572.08-1.125.23-1.65l8.558 8.559A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm10.303 4.181L3.818 1.697a6 6 0 0 1 8.484 8.484zM5 14.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1-.5-.5zM2.354 1.646a.5.5 0 1 0-.708.708l12 12a.5.5 0 0 0 .708-.708l-12-12z"
                }
            }
        ]
    })(props);
}
function BsLightbulbOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.23 4.35A6.004 6.004 0 0 0 2 6c0 1.691.7 3.22 1.826 4.31.203.196.359.4.453.619l.762 1.769A.5.5 0 0 0 5.5 13a.5.5 0 0 0 0 1 .5.5 0 0 0 0 1l.224.447a1 1 0 0 0 .894.553h2.764a1 1 0 0 0 .894-.553L10.5 15a.5.5 0 0 0 0-1 .5.5 0 0 0 0-1 .5.5 0 0 0 .288-.091L9.878 12H5.83l-.632-1.467a2.954 2.954 0 0 0-.676-.941 4.984 4.984 0 0 1-1.455-4.405l-.837-.836zm1.588-2.653.708.707a5 5 0 0 1 7.07 7.07l.707.707a6 6 0 0 0-8.484-8.484zm-2.172-.051a.5.5 0 0 1 .708 0l12 12a.5.5 0 0 1-.708.708l-12-12a.5.5 0 0 1 0-.708z"
                }
            }
        ]
    })(props);
}
function BsLightbulb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13a.5.5 0 0 1 0 1 .5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1 0-1 .5.5 0 0 1 0-1 .5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm6-5a5 5 0 0 0-3.479 8.592c.263.254.514.564.676.941L5.83 12h4.342l.632-1.467c.162-.377.413-.687.676-.941A5 5 0 0 0 8 1z"
                }
            }
        ]
    })(props);
}
function BsLightningChargeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.251.068a.5.5 0 0 1 .227.58L9.677 6.5H13a.5.5 0 0 1 .364.843l-8 8.5a.5.5 0 0 1-.842-.49L6.323 9.5H3a.5.5 0 0 1-.364-.843l8-8.5a.5.5 0 0 1 .615-.09z"
                }
            }
        ]
    })(props);
}
function BsLightningCharge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.251.068a.5.5 0 0 1 .227.58L9.677 6.5H13a.5.5 0 0 1 .364.843l-8 8.5a.5.5 0 0 1-.842-.49L6.323 9.5H3a.5.5 0 0 1-.364-.843l8-8.5a.5.5 0 0 1 .615-.09zM4.157 8.5H7a.5.5 0 0 1 .478.647L6.11 13.59l5.732-6.09H9a.5.5 0 0 1-.478-.647L9.89 2.41 4.157 8.5z"
                }
            }
        ]
    })(props);
}
function BsLightningFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.52.359A.5.5 0 0 1 6 0h4a.5.5 0 0 1 .474.658L8.694 6H12.5a.5.5 0 0 1 .395.807l-7 9a.5.5 0 0 1-.873-.454L6.823 9.5H3.5a.5.5 0 0 1-.48-.641l2.5-8.5z"
                }
            }
        ]
    })(props);
}
function BsLightning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.52.359A.5.5 0 0 1 6 0h4a.5.5 0 0 1 .474.658L8.694 6H12.5a.5.5 0 0 1 .395.807l-7 9a.5.5 0 0 1-.873-.454L6.823 9.5H3.5a.5.5 0 0 1-.48-.641l2.5-8.5zM6.374 1 4.168 8.5H7.5a.5.5 0 0 1 .478.647L6.78 13.04 11.478 7H8a.5.5 0 0 1-.474-.658L9.306 1H6.374z"
                }
            }
        ]
    })(props);
}
function BsLine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c4.411 0 8 2.912 8 6.492 0 1.433-.555 2.723-1.715 3.994-1.678 1.932-5.431 4.285-6.285 4.645-.83.35-.734-.197-.696-.413l.003-.018.114-.685c.027-.204.055-.521-.026-.723-.09-.223-.444-.339-.704-.395C2.846 12.39 0 9.701 0 6.492 0 2.912 3.59 0 8 0ZM5.022 7.686H3.497V4.918a.156.156 0 0 0-.155-.156H2.78a.156.156 0 0 0-.156.156v3.486c0 .041.017.08.044.107v.001l.002.002.002.002a.154.154 0 0 0 .108.043h2.242c.086 0 .155-.07.155-.156v-.56a.156.156 0 0 0-.155-.157Zm.791-2.924a.156.156 0 0 0-.156.156v3.486c0 .086.07.155.156.155h.562c.086 0 .155-.07.155-.155V4.918a.156.156 0 0 0-.155-.156h-.562Zm3.863 0a.156.156 0 0 0-.156.156v2.07L7.923 4.832a.17.17 0 0 0-.013-.015v-.001a.139.139 0 0 0-.01-.01l-.003-.003a.092.092 0 0 0-.011-.009h-.001L7.88 4.79l-.003-.002a.029.029 0 0 0-.005-.003l-.008-.005h-.002l-.003-.002-.01-.004-.004-.002a.093.093 0 0 0-.01-.003h-.002l-.003-.001-.009-.002h-.006l-.003-.001h-.004l-.002-.001h-.574a.156.156 0 0 0-.156.155v3.486c0 .086.07.155.156.155h.56c.087 0 .157-.07.157-.155v-2.07l1.6 2.16a.154.154 0 0 0 .039.038l.001.001.01.006.004.002a.066.066 0 0 0 .008.004l.007.003.005.002a.168.168 0 0 0 .01.003h.003a.155.155 0 0 0 .04.006h.56c.087 0 .157-.07.157-.155V4.918a.156.156 0 0 0-.156-.156h-.561Zm3.815.717v-.56a.156.156 0 0 0-.155-.157h-2.242a.155.155 0 0 0-.108.044h-.001l-.001.002-.002.003a.155.155 0 0 0-.044.107v3.486c0 .041.017.08.044.107l.002.003.002.002a.155.155 0 0 0 .108.043h2.242c.086 0 .155-.07.155-.156v-.56a.156.156 0 0 0-.155-.157H11.81v-.589h1.525c.086 0 .155-.07.155-.156v-.56a.156.156 0 0 0-.155-.157H11.81v-.589h1.525c.086 0 .155-.07.155-.156Z"
                }
            }
        ]
    })(props);
}
function BsLink45Deg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"
                }
            }
        ]
    })(props);
}
function BsLink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.354 5.5H4a3 3 0 0 0 0 6h3a3 3 0 0 0 2.83-4H9c-.086 0-.17.01-.25.031A2 2 0 0 1 7 10.5H4a2 2 0 1 1 0-4h1.535c.218-.376.495-.714.82-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 5.5a3 3 0 0 0-2.83 4h1.098A2 2 0 0 1 9 6.5h3a2 2 0 1 1 0 4h-1.535a4.02 4.02 0 0 1-.82 1H12a3 3 0 1 0 0-6H9z"
                }
            }
        ]
    })(props);
}
function BsLinkedin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"
                }
            }
        ]
    })(props);
}
function BsListCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3.854 2.146a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708L2 3.293l1.146-1.147a.5.5 0 0 1 .708 0zm0 4a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708L2 7.293l1.146-1.147a.5.5 0 0 1 .708 0zm0 4a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0z"
                }
            }
        ]
    })(props);
}
function BsListColumnsReverse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M0 .5A.5.5 0 0 1 .5 0h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 0 .5Zm4 0a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1h-10A.5.5 0 0 1 4 .5Zm-4 2A.5.5 0 0 1 .5 2h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm4 0a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5Zm-4 2A.5.5 0 0 1 .5 4h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm4 0a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5Zm-4 2A.5.5 0 0 1 .5 6h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm4 0a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5Zm-4 2A.5.5 0 0 1 .5 8h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm4 0a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5Zm-4 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm4 0a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1h-10a.5.5 0 0 1-.5-.5Zm-4 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm4 0a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5Zm-4 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm4 0a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5Z"
                }
            }
        ]
    })(props);
}
function BsListColumns(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M0 .5A.5.5 0 0 1 .5 0h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 0 .5Zm13 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm-13 2A.5.5 0 0 1 .5 2h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5Zm13 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm-13 2A.5.5 0 0 1 .5 4h10a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5Zm13 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm-13 2A.5.5 0 0 1 .5 6h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Zm13 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm-13 2A.5.5 0 0 1 .5 8h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Zm13 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm-13 2a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5Zm13 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm-13 2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm13 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm-13 2a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5Zm13 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Z"
                }
            }
        ]
    })(props);
}
function BsListNested(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.5 11.5A.5.5 0 0 1 5 11h10a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm-2-4A.5.5 0 0 1 3 7h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm-2-4A.5.5 0 0 1 1 3h10a.5.5 0 0 1 0 1H1a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsListOl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.713 11.865v-.474H2c.217 0 .363-.137.363-.317 0-.185-.158-.31-.361-.31-.223 0-.367.152-.373.31h-.59c.016-.467.373-.787.986-.787.588-.002.954.291.957.703a.595.595 0 0 1-.492.594v.033a.615.615 0 0 1 .569.631c.003.533-.502.8-1.051.8-.656 0-1-.37-1.008-.794h.582c.008.178.186.306.422.309.254 0 .424-.145.422-.35-.002-.195-.155-.348-.414-.348h-.3zm-.004-4.699h-.604v-.035c0-.408.295-.844.958-.844.583 0 .96.326.96.756 0 .389-.257.617-.476.848l-.537.572v.03h1.054V9H1.143v-.395l.957-.99c.138-.142.293-.304.293-.508 0-.18-.147-.32-.342-.32a.33.33 0 0 0-.342.338v.041zM2.564 5h-.635V2.924h-.031l-.598.42v-.567l.629-.443h.635V5z"
                }
            }
        ]
    })(props);
}
function BsListStars(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.242 2.194a.27.27 0 0 1 .516 0l.162.53c.035.115.14.194.258.194h.551c.259 0 .37.333.164.493l-.468.363a.277.277 0 0 0-.094.3l.173.569c.078.256-.213.462-.423.3l-.417-.324a.267.267 0 0 0-.328 0l-.417.323c-.21.163-.5-.043-.423-.299l.173-.57a.277.277 0 0 0-.094-.299l-.468-.363c-.206-.16-.095-.493.164-.493h.55a.271.271 0 0 0 .259-.194l.162-.53zm0 4a.27.27 0 0 1 .516 0l.162.53c.035.115.14.194.258.194h.551c.259 0 .37.333.164.493l-.468.363a.277.277 0 0 0-.094.3l.173.569c.078.255-.213.462-.423.3l-.417-.324a.267.267 0 0 0-.328 0l-.417.323c-.21.163-.5-.043-.423-.299l.173-.57a.277.277 0 0 0-.094-.299l-.468-.363c-.206-.16-.095-.493.164-.493h.55a.271.271 0 0 0 .259-.194l.162-.53zm0 4a.27.27 0 0 1 .516 0l.162.53c.035.115.14.194.258.194h.551c.259 0 .37.333.164.493l-.468.363a.277.277 0 0 0-.094.3l.173.569c.078.255-.213.462-.423.3l-.417-.324a.267.267 0 0 0-.328 0l-.417.323c-.21.163-.5-.043-.423-.299l.173-.57a.277.277 0 0 0-.094-.299l-.468-.363c-.206-.16-.095-.493.164-.493h.55a.271.271 0 0 0 .259-.194l.162-.53z"
                }
            }
        ]
    })(props);
}
function BsListTask(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 2.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H2zM3 3H2v1h1V3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM5.5 7a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 4a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.5 7a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V7zM2 7h1v1H2V7zm0 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H2zm1 .5H2v1h1v-1z"
                }
            }
        ]
    })(props);
}
function BsListUl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                }
            }
        ]
    })(props);
}
function BsList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsLockFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"
                }
            }
        ]
    })(props);
}
function BsLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z"
                }
            }
        ]
    })(props);
}
function BsLuggageFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V5h.5A1.5 1.5 0 0 1 8 6.5V7H7v-.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5H4v1H2.5v.25a.75.75 0 0 1-1.5 0v-.335A1.5 1.5 0 0 1 0 13.5v-7A1.5 1.5 0 0 1 1.5 5H2V1.5ZM3 5h2V2H3v3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 7a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 .5-.5Zm10 1v-.5A1.5 1.5 0 0 0 11 6h-1a1.5 1.5 0 0 0-1.5 1.5V8H8v8h5V8h-.5ZM10 7h1a.5.5 0 0 1 .5.5V8h-2v-.5A.5.5 0 0 1 10 7ZM5 9.5A1.5 1.5 0 0 1 6.5 8H7v8h-.5A1.5 1.5 0 0 1 5 14.5v-5Zm9 6.5V8h.5A1.5 1.5 0 0 1 16 9.5v5a1.5 1.5 0 0 1-1.5 1.5H14Z"
                }
            }
        ]
    })(props);
}
function BsLuggage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 1a.5.5 0 0 0-.5.5V5h-.5A1.5 1.5 0 0 0 0 6.5v7a1.5 1.5 0 0 0 1 1.415v.335a.75.75 0 0 0 1.5 0V15H4v-1H1.5a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5V7h1v-.5A1.5 1.5 0 0 0 6.5 5H6V1.5a.5.5 0 0 0-.5-.5h-3ZM5 5H3V2h2v3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0v-5ZM11 6a1.5 1.5 0 0 1 1.5 1.5V8h2A1.5 1.5 0 0 1 16 9.5v5a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 14.5v-5A1.5 1.5 0 0 1 6.5 8h2v-.5A1.5 1.5 0 0 1 10 6h1ZM9.5 7.5V8h2v-.5A.5.5 0 0 0 11 7h-1a.5.5 0 0 0-.5.5ZM6 9.5v5a.5.5 0 0 0 .5.5H7V9h-.5a.5.5 0 0 0-.5.5Zm7 5.5V9H8v6h5Zm1.5 0a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5H14v6h.5Z"
                }
            }
        ]
    })(props);
}
function BsLungsFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1a.5.5 0 0 1 .5.5v5.243L9 7.1V4.72C9 3.77 9.77 3 10.72 3c.524 0 1.023.27 1.443.592.431.332.847.773 1.216 1.229.736.908 1.347 1.946 1.58 2.48.176.405.393 1.16.556 2.011.165.857.283 1.857.24 2.759-.04.867-.232 1.79-.837 2.33-.67.6-1.622.556-2.741-.004l-1.795-.897A2.5 2.5 0 0 1 9 11.264V8.329l-1-.715-1 .715V7.214c-.1 0-.202.03-.29.093l-2.5 1.786a.5.5 0 1 0 .58.814L7 8.329v2.935A2.5 2.5 0 0 1 5.618 13.5l-1.795.897c-1.12.56-2.07.603-2.741.004-.605-.54-.798-1.463-.838-2.33-.042-.902.076-1.902.24-2.759.164-.852.38-1.606.558-2.012.232-.533.843-1.571 1.579-2.479.37-.456.785-.897 1.216-1.229C4.257 3.27 4.756 3 5.28 3 6.23 3 7 3.77 7 4.72V7.1l.5-.357V1.5A.5.5 0 0 1 8 1Zm3.21 8.907a.5.5 0 1 0 .58-.814l-2.5-1.786A.498.498 0 0 0 9 7.214V8.33l2.21 1.578Z"
                }
            }
        ]
    })(props);
}
function BsLungs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 1.5a.5.5 0 1 0-1 0v5.243L7 7.1V4.72C7 3.77 6.23 3 5.28 3c-.524 0-1.023.27-1.443.592-.431.332-.847.773-1.216 1.229-.736.908-1.347 1.946-1.58 2.48-.176.405-.393 1.16-.556 2.011-.165.857-.283 1.857-.241 2.759.04.867.233 1.79.838 2.33.67.6 1.622.556 2.741-.004l1.795-.897A2.5 2.5 0 0 0 7 11.264V10.5a.5.5 0 0 0-1 0v.764a1.5 1.5 0 0 1-.83 1.342l-1.794.897c-.978.489-1.415.343-1.628.152-.28-.25-.467-.801-.505-1.63-.037-.795.068-1.71.224-2.525.157-.82.357-1.491.491-1.8.19-.438.75-1.4 1.44-2.25.342-.422.703-.799 1.049-1.065.358-.276.639-.385.833-.385a.72.72 0 0 1 .72.72v3.094l-1.79 1.28a.5.5 0 0 0 .58.813L8 7.614l3.21 2.293a.5.5 0 1 0 .58-.814L10 7.814V4.72a.72.72 0 0 1 .72-.72c.194 0 .475.11.833.385.346.266.706.643 1.05 1.066.688.85 1.248 1.811 1.439 2.249.134.309.334.98.491 1.8.156.814.26 1.73.224 2.525-.038.829-.224 1.38-.505 1.63-.213.19-.65.337-1.628-.152l-1.795-.897A1.5 1.5 0 0 1 10 11.264V10.5a.5.5 0 0 0-1 0v.764a2.5 2.5 0 0 0 1.382 2.236l1.795.897c1.12.56 2.07.603 2.741.004.605-.54.798-1.463.838-2.33.042-.902-.076-1.902-.24-2.759-.164-.852-.38-1.606-.558-2.012-.232-.533-.843-1.571-1.579-2.479-.37-.456-.785-.897-1.216-1.229C11.743 3.27 11.244 3 10.72 3 9.77 3 9 3.77 9 4.72V7.1l-.5-.357V1.5Z"
                }
            }
        ]
    })(props);
}
function BsMagic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 2.672a.5.5 0 1 0 1 0V.843a.5.5 0 0 0-1 0v1.829Zm4.5.035A.5.5 0 0 0 13.293 2L12 3.293a.5.5 0 1 0 .707.707L14 2.707ZM7.293 4A.5.5 0 1 0 8 3.293L6.707 2A.5.5 0 0 0 6 2.707L7.293 4Zm-.621 2.5a.5.5 0 1 0 0-1H4.843a.5.5 0 1 0 0 1h1.829Zm8.485 0a.5.5 0 1 0 0-1h-1.829a.5.5 0 0 0 0 1h1.829ZM13.293 10A.5.5 0 1 0 14 9.293L12.707 8a.5.5 0 1 0-.707.707L13.293 10ZM9.5 11.157a.5.5 0 0 0 1 0V9.328a.5.5 0 0 0-1 0v1.829Zm1.854-5.097a.5.5 0 0 0 0-.706l-.708-.708a.5.5 0 0 0-.707 0L8.646 5.94a.5.5 0 0 0 0 .707l.708.708a.5.5 0 0 0 .707 0l1.293-1.293Zm-3 3a.5.5 0 0 0 0-.706l-.708-.708a.5.5 0 0 0-.707 0L.646 13.94a.5.5 0 0 0 0 .707l.708.708a.5.5 0 0 0 .707 0L8.354 9.06Z"
                }
            }
        ]
    })(props);
}
function BsMagnetFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 12h-4v3h4v-3ZM5 12H1v3h4v-3ZM0 8a8 8 0 1 1 16 0v8h-6V8a2 2 0 1 0-4 0v8H0V8Z"
                }
            }
        ]
    })(props);
}
function BsMagnet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1a7 7 0 0 0-7 7v3h4V8a3 3 0 0 1 6 0v3h4V8a7 7 0 0 0-7-7Zm7 11h-4v3h4v-3ZM5 12H1v3h4v-3ZM0 8a8 8 0 1 1 16 0v8h-6V8a2 2 0 1 0-4 0v8H0V8Z"
                }
            }
        ]
    })(props);
}
function BsMailboxFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 8.5V3.707l.854-.853A.5.5 0 0 0 11.5 2.5v-2A.5.5 0 0 0 11 0H9.5a.5.5 0 0 0-.5.5v8h1.5ZM5 7c0 .334-.164.264-.415.157C4.42 7.087 4.218 7 4 7c-.218 0-.42.086-.585.157C3.164 7.264 3 7.334 3 7a1 1 0 0 1 2 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3h4v1H6.646A3.99 3.99 0 0 1 8 7v6h7V7a3 3 0 0 0-3-3V3a4 4 0 0 1 4 4v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a4 4 0 0 1 4-4Zm0 1a3 3 0 0 0-3 3v6h6V7a3 3 0 0 0-3-3Z"
                }
            }
        ]
    })(props);
}
function BsMailbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4a3 3 0 0 0-3 3v6h6V7a3 3 0 0 0-3-3zm0-1h8a4 4 0 0 1 4 4v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a4 4 0 0 1 4-4zm2.646 1A3.99 3.99 0 0 1 8 7v6h7V7a3 3 0 0 0-3-3H6.646z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.793 8.5H9v-1h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.354-.146l-.853-.854zM5 7c0 .552-.448 0-1 0s-1 .552-1 0a1 1 0 0 1 2 0z"
                }
            }
        ]
    })(props);
}
function BsMailbox2Flag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 8.5V3.707l.854-.853A.5.5 0 0 0 11.5 2.5v-2A.5.5 0 0 0 11 0H9.5a.5.5 0 0 0-.5.5v8h1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3h4v1H6.646A3.99 3.99 0 0 1 8 7v6h7V7a3 3 0 0 0-3-3V3a4 4 0 0 1 4 4v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a4 4 0 0 1 4-4Zm.585 4.157C4.836 7.264 5 7.334 5 7a1 1 0 0 0-2 0c0 .334.164.264.415.157C3.58 7.087 3.782 7 4 7c.218 0 .42.086.585.157Z"
                }
            }
        ]
    })(props);
}
function BsMailbox2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 8.5h2.793l.853.854A.5.5 0 0 0 13 9.5h1a.5.5 0 0 0 .5-.5V8a.5.5 0 0 0-.5-.5H9v1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3H4a4 4 0 0 0-4 4v6a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V7a4 4 0 0 0-4-4zM8 7a3.99 3.99 0 0 0-1.354-3H12a3 3 0 0 1 3 3v6H8V7zm-3.415.157C4.42 7.087 4.218 7 4 7c-.218 0-.42.086-.585.157C3.164 7.264 3 7.334 3 7a1 1 0 0 1 2 0c0 .334-.164.264-.415.157z"
                }
            }
        ]
    })(props);
}
function BsMapFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M16 .5a.5.5 0 0 0-.598-.49L10.5.99 5.598.01a.5.5 0 0 0-.196 0l-5 1A.5.5 0 0 0 0 1.5v14a.5.5 0 0 0 .598.49l4.902-.98 4.902.98a.502.502 0 0 0 .196 0l5-1A.5.5 0 0 0 16 14.5V.5zM5 14.09V1.11l.5-.1.5.1v12.98l-.402-.08a.498.498 0 0 0-.196 0L5 14.09zm5 .8V1.91l.402.08a.5.5 0 0 0 .196 0L11 1.91v12.98l-.5.1-.5-.1z"
                }
            }
        ]
    })(props);
}
function BsMap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.817.113A.5.5 0 0 1 16 .5v14a.5.5 0 0 1-.402.49l-5 1a.502.502 0 0 1-.196 0L5.5 15.01l-4.902.98A.5.5 0 0 1 0 15.5v-14a.5.5 0 0 1 .402-.49l5-1a.5.5 0 0 1 .196 0L10.5.99l4.902-.98a.5.5 0 0 1 .415.103zM10 1.91l-4-.8v12.98l4 .8V1.91zm1 12.98 4-.8V1.11l-4 .8v12.98zm-6-.8V1.11l-4 .8v12.98l4-.8z"
                }
            }
        ]
    })(props);
}
function BsMarkdownFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm11.5 1a.5.5 0 0 0-.5.5v3.793L9.854 8.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L12 9.293V5.5a.5.5 0 0 0-.5-.5zM3.56 7.01h.056l1.428 3.239h.774l1.42-3.24h.056V11h1.073V5.001h-1.2l-1.71 3.894h-.039l-1.71-3.894H2.5V11h1.06V7.01z"
                }
            }
        ]
    })(props);
}
function BsMarkdown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.146 8.146a.5.5 0 0 1 .708 0L11.5 9.793l1.646-1.647a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 0-.708z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.5 5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 1 .5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.56 11V7.01h.056l1.428 3.239h.774l1.42-3.24h.056V11h1.073V5.001h-1.2l-1.71 3.894h-.039l-1.71-3.894H2.5V11h1.06z"
                }
            }
        ]
    })(props);
}
function BsMarkerTip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-4.5 6.064-1.281-4.696A.5.5 0 0 0 9.736 9H6.264a.5.5 0 0 0-.483.368l-1.28 4.696A6.968 6.968 0 0 0 8 15c1.275 0 2.47-.34 3.5-.936Zm.873-.598a7 7 0 1 0-8.746 0l1.19-4.36a1.5 1.5 0 0 1 1.31-1.1l1.155-3.851c.213-.713 1.223-.713 1.436 0l1.156 3.851a1.5 1.5 0 0 1 1.31 1.1l1.189 4.36Z"
                }
            }
        ]
    })(props);
}
function BsMask(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.225 1.227A7.5 7.5 0 0 1 10.5 8a7.5 7.5 0 0 1-4.275 6.773 7 7 0 1 0 0-13.546zM4.187.966a8 8 0 1 1 7.627 14.069A8 8 0 0 1 4.186.964z"
                }
            }
        ]
    })(props);
}
function BsMastodon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.19 12.195c2.016-.24 3.77-1.475 3.99-2.603.348-1.778.32-4.339.32-4.339 0-3.47-2.286-4.488-2.286-4.488C12.062.238 10.083.017 8.027 0h-.05C5.92.017 3.942.238 2.79.765c0 0-2.285 1.017-2.285 4.488l-.002.662c-.004.64-.007 1.35.011 2.091.083 3.394.626 6.74 3.78 7.57 1.454.383 2.703.463 3.709.408 1.823-.1 2.847-.647 2.847-.647l-.06-1.317s-1.303.41-2.767.36c-1.45-.05-2.98-.156-3.215-1.928a3.614 3.614 0 0 1-.033-.496s1.424.346 3.228.428c1.103.05 2.137-.064 3.188-.189zm1.613-2.47H11.13v-4.08c0-.859-.364-1.295-1.091-1.295-.804 0-1.207.517-1.207 1.541v2.233H7.168V5.89c0-1.024-.403-1.541-1.207-1.541-.727 0-1.091.436-1.091 1.296v4.079H3.197V5.522c0-.859.22-1.541.66-2.046.456-.505 1.052-.764 1.793-.764.856 0 1.504.328 1.933.983L8 4.39l.417-.695c.429-.655 1.077-.983 1.934-.983.74 0 1.336.259 1.791.764.442.505.661 1.187.661 2.046v4.203z"
                }
            }
        ]
    })(props);
}
function BsMedium(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.025 8c0 2.485-2.02 4.5-4.513 4.5A4.506 4.506 0 0 1 0 8c0-2.486 2.02-4.5 4.512-4.5A4.506 4.506 0 0 1 9.025 8zm4.95 0c0 2.34-1.01 4.236-2.256 4.236-1.246 0-2.256-1.897-2.256-4.236 0-2.34 1.01-4.236 2.256-4.236 1.246 0 2.256 1.897 2.256 4.236zM16 8c0 2.096-.355 3.795-.794 3.795-.438 0-.793-1.7-.793-3.795 0-2.096.355-3.795.794-3.795.438 0 .793 1.699.793 3.795z"
                }
            }
        ]
    })(props);
}
function BsMegaphoneFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 2.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0v-11zm-1 .724c-2.067.95-4.539 1.481-7 1.656v6.237a25.222 25.222 0 0 1 1.088.085c2.053.204 4.038.668 5.912 1.56V3.224zm-8 7.841V4.934c-.68.027-1.399.043-2.008.053A2.02 2.02 0 0 0 0 7v2c0 1.106.896 1.996 1.994 2.009a68.14 68.14 0 0 1 .496.008 64 64 0 0 1 1.51.048zm1.39 1.081c.285.021.569.047.85.078l.253 1.69a1 1 0 0 1-.983 1.187h-.548a1 1 0 0 1-.916-.599l-1.314-2.48a65.81 65.81 0 0 1 1.692.064c.327.017.65.037.966.06z"
                }
            }
        ]
    })(props);
}
function BsMegaphone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 2.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0v-.214c-2.162-1.241-4.49-1.843-6.912-2.083l.405 2.712A1 1 0 0 1 5.51 15.1h-.548a1 1 0 0 1-.916-.599l-1.85-3.49a68.14 68.14 0 0 0-.202-.003A2.014 2.014 0 0 1 0 9V7a2.02 2.02 0 0 1 1.992-2.013 74.663 74.663 0 0 0 2.483-.075c3.043-.154 6.148-.849 8.525-2.199V2.5zm1 0v11a.5.5 0 0 0 1 0v-11a.5.5 0 0 0-1 0zm-1 1.35c-2.344 1.205-5.209 1.842-8 2.033v4.233c.18.01.359.022.537.036 2.568.189 5.093.744 7.463 1.993V3.85zm-9 6.215v-4.13a95.09 95.09 0 0 1-1.992.052A1.02 1.02 0 0 0 1 7v2c0 .55.448 1.002 1.006 1.009A60.49 60.49 0 0 1 4 10.065zm-.657.975 1.609 3.037.01.024h.548l-.002-.014-.443-2.966a68.019 68.019 0 0 0-1.722-.082z"
                }
            }
        ]
    })(props);
}
function BsMemory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4.586a1 1 0 0 0 .707-.293l.353-.353a.5.5 0 0 1 .708 0l.353.353a1 1 0 0 0 .707.293H15a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H1Zm.5 1h3a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5Zm5 0h3a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5Zm4.5.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-4ZM2 10v2H1v-2h1Zm2 0v2H3v-2h1Zm2 0v2H5v-2h1Zm3 0v2H8v-2h1Zm2 0v2h-1v-2h1Zm2 0v2h-1v-2h1Zm2 0v2h-1v-2h1Z"
                }
            }
        ]
    })(props);
}
function BsMenuAppFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1.5A1.5 1.5 0 0 1 1.5 0h2A1.5 1.5 0 0 1 5 1.5v2A1.5 1.5 0 0 1 3.5 5h-2A1.5 1.5 0 0 1 0 3.5v-2zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2H1zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2h14zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsMenuApp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1.5A1.5 1.5 0 0 1 1.5 0h2A1.5 1.5 0 0 1 5 1.5v2A1.5 1.5 0 0 1 3.5 5h-2A1.5 1.5 0 0 1 0 3.5v-2zM1.5 1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-2zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2H1zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2h14zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsMenuButtonFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 0A1.5 1.5 0 0 0 0 1.5v2A1.5 1.5 0 0 0 1.5 5h8A1.5 1.5 0 0 0 11 3.5v-2A1.5 1.5 0 0 0 9.5 0h-8zm5.927 2.427A.25.25 0 0 1 7.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0l-.396-.396zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2H1zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2h14zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsMenuButtonWideFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 0A1.5 1.5 0 0 0 0 1.5v2A1.5 1.5 0 0 0 1.5 5h13A1.5 1.5 0 0 0 16 3.5v-2A1.5 1.5 0 0 0 14.5 0h-13zm1 2h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zm9.927.427A.25.25 0 0 1 12.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0l-.396-.396zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2H1zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2h14zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsMenuButtonWide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v2A1.5 1.5 0 0 1 14.5 5h-13A1.5 1.5 0 0 1 0 3.5v-2zM1.5 1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm10.823.323-.396-.396A.25.25 0 0 1 12.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2H1zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2h14zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsMenuButton(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1.5A1.5 1.5 0 0 1 1.5 0h8A1.5 1.5 0 0 1 11 1.5v2A1.5 1.5 0 0 1 9.5 5h-8A1.5 1.5 0 0 1 0 3.5v-2zM1.5 1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7.823 2.823-.396-.396A.25.25 0 0 1 7.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2H1zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2h14zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsMenuDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.646.146a.5.5 0 0 1 .708 0L10.207 2H14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h3.793L7.646.146zM1 7v3h14V7H1zm14-1V4a1 1 0 0 0-1-1h-3.793a1 1 0 0 1-.707-.293L8 1.207l-1.5 1.5A1 1 0 0 1 5.793 3H2a1 1 0 0 0-1 1v2h14zm0 5H1v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2zM2 4.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsMenuUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.646 15.854a.5.5 0 0 0 .708 0L10.207 14H14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h3.793l1.853 1.854zM1 9V6h14v3H1zm14 1v2a1 1 0 0 1-1 1h-3.793a1 1 0 0 0-.707.293l-1.5 1.5-1.5-1.5A1 1 0 0 0 5.793 13H2a1 1 0 0 1-1-1v-2h14zm0-5H1V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v2zM2 11.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 0-1h-8a.5.5 0 0 0-.5.5zm0-4a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 0-1h-11a.5.5 0 0 0-.5.5zm0-4a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 0-1h-6a.5.5 0 0 0-.5.5z"
                }
            }
        ]
    })(props);
}
function BsMessenger(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 7.76C0 3.301 3.493 0 8 0s8 3.301 8 7.76-3.493 7.76-8 7.76c-.81 0-1.586-.107-2.316-.307a.639.639 0 0 0-.427.03l-1.588.702a.64.64 0 0 1-.898-.566l-.044-1.423a.639.639 0 0 0-.215-.456C.956 12.108 0 10.092 0 7.76zm5.546-1.459-2.35 3.728c-.225.358.214.761.551.506l2.525-1.916a.48.48 0 0 1 .578-.002l1.869 1.402a1.2 1.2 0 0 0 1.735-.32l2.35-3.728c.226-.358-.214-.761-.551-.506L9.728 7.381a.48.48 0 0 1-.578.002L7.281 5.98a1.2 1.2 0 0 0-1.735.32z"
                }
            }
        ]
    })(props);
}
function BsMeta(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.217 5.243C9.145 3.988 10.171 3 11.483 3 13.96 3 16 6.153 16.001 9.907c0 2.29-.986 3.725-2.757 3.725-1.543 0-2.395-.866-3.924-3.424l-.667-1.123-.118-.197a54.944 54.944 0 0 0-.53-.877l-1.178 2.08c-1.673 2.925-2.615 3.541-3.923 3.541C1.086 13.632 0 12.217 0 9.973 0 6.388 1.995 3 4.598 3c.319 0 .625.039.924.122.31.086.611.22.913.407.577.359 1.154.915 1.782 1.714Zm1.516 2.224c-.252-.41-.494-.787-.727-1.133L9 6.326c.845-1.305 1.543-1.954 2.372-1.954 1.723 0 3.102 2.537 3.102 5.653 0 1.188-.39 1.877-1.195 1.877-.773 0-1.142-.51-2.61-2.87l-.937-1.565ZM4.846 4.756c.725.1 1.385.634 2.34 2.001A212.13 212.13 0 0 0 5.551 9.3c-1.357 2.126-1.826 2.603-2.581 2.603-.777 0-1.24-.682-1.24-1.9 0-2.602 1.298-5.264 2.846-5.264.091 0 .181.006.27.018Z"
                }
            }
        ]
    })(props);
}
function BsMicFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3a3 3 0 0 1 6 0v5a3 3 0 0 1-6 0V3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 6.5A.5.5 0 0 1 4 7v1a4 4 0 0 0 8 0V7a.5.5 0 0 1 1 0v1a5 5 0 0 1-4.5 4.975V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsMicMuteFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8c0 .564-.094 1.107-.266 1.613l-.814-.814A4.02 4.02 0 0 0 12 8V7a.5.5 0 0 1 1 0v1zm-5 4c.818 0 1.578-.245 2.212-.667l.718.719a4.973 4.973 0 0 1-2.43.923V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 1 0v1a4 4 0 0 0 4 4zm3-9v4.879L5.158 2.037A3.001 3.001 0 0 1 11 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.486 10.607 5 6.12V8a3 3 0 0 0 4.486 2.607zm-7.84-9.253 12 12 .708-.708-12-12-.708.708z"
                }
            }
        ]
    })(props);
}
function BsMicMute(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8c0 .564-.094 1.107-.266 1.613l-.814-.814A4.02 4.02 0 0 0 12 8V7a.5.5 0 0 1 1 0v1zm-5 4c.818 0 1.578-.245 2.212-.667l.718.719a4.973 4.973 0 0 1-2.43.923V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 1 0v1a4 4 0 0 0 4 4zm3-9v4.879l-1-1V3a2 2 0 0 0-3.997-.118l-.845-.845A3.001 3.001 0 0 1 11 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9.486 10.607-.748-.748A2 2 0 0 1 6 8v-.878l-1-1V8a3 3 0 0 0 4.486 2.607zm-7.84-9.253 12 12 .708-.708-12-12-.708.708z"
                }
            }
        ]
    })(props);
}
function BsMic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 6.5A.5.5 0 0 1 4 7v1a4 4 0 0 0 8 0V7a.5.5 0 0 1 1 0v1a5 5 0 0 1-4.5 4.975V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 .5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8a2 2 0 1 1-4 0V3a2 2 0 1 1 4 0v5zM8 0a3 3 0 0 0-3 3v5a3 3 0 0 0 6 0V3a3 3 0 0 0-3-3z"
                }
            }
        ]
    })(props);
}
function BsMicrosoftTeams(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.186 4.797a2.42 2.42 0 1 0-2.86-2.448h1.178c.929 0 1.682.753 1.682 1.682v.766Zm-4.295 7.738h2.613c.929 0 1.682-.753 1.682-1.682V5.58h2.783a.7.7 0 0 1 .682.716v4.294a4.197 4.197 0 0 1-4.093 4.293c-1.618-.04-3-.99-3.667-2.35Zm10.737-9.372a1.674 1.674 0 1 1-3.349 0 1.674 1.674 0 0 1 3.349 0Zm-2.238 9.488c-.04 0-.08 0-.12-.002a5.19 5.19 0 0 0 .381-2.07V6.306a1.692 1.692 0 0 0-.15-.725h1.792c.39 0 .707.317.707.707v3.765a2.598 2.598 0 0 1-2.598 2.598h-.013Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M.682 3.349h6.822c.377 0 .682.305.682.682v6.822a.682.682 0 0 1-.682.682H.682A.682.682 0 0 1 0 10.853V4.03c0-.377.305-.682.682-.682Zm5.206 2.596v-.72h-3.59v.72h1.357V9.66h.87V5.945h1.363Z"
                }
            }
        ]
    })(props);
}
function BsMicrosoft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.462 0H0v7.19h7.462V0zM16 0H8.538v7.19H16V0zM7.462 8.211H0V16h7.462V8.211zm8.538 0H8.538V16H16V8.211z"
                }
            }
        ]
    })(props);
}
function BsMinecartLoaded(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 15a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0 1a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm8-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0 1a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM.115 3.18A.5.5 0 0 1 .5 3h15a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 14 12H2a.5.5 0 0 1-.491-.408l-1.5-8a.5.5 0 0 1 .106-.411zm.987.82 1.313 7h11.17l1.313-7H1.102z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 1a2.498 2.498 0 0 1 4 0c.818 0 1.545.394 2 1 .67 0 1.552.57 2 1h-2c-.314 0-.611-.15-.8-.4-.274-.365-.71-.6-1.2-.6-.314 0-.611-.15-.8-.4a1.497 1.497 0 0 0-2.4 0c-.189.25-.486.4-.8.4-.507 0-.955.251-1.228.638-.09.13-.194.25-.308.362H3c.13-.147.401-.432.562-.545a1.63 1.63 0 0 0 .393-.393A2.498 2.498 0 0 1 6 1z"
                }
            }
        ]
    })(props);
}
function BsMinecart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 15a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0 1a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm8-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0 1a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM.115 3.18A.5.5 0 0 1 .5 3h15a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 14 12H2a.5.5 0 0 1-.491-.408l-1.5-8a.5.5 0 0 1 .106-.411zm.987.82 1.313 7h11.17l1.313-7H1.102z"
                }
            }
        ]
    })(props);
}
function BsModemFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 0a1.5 1.5 0 0 0-1.5 1.5v11a1.5 1.5 0 0 0 1.404 1.497c-.35.305-.872.678-1.628 1.056A.5.5 0 0 0 5.5 16h5a.5.5 0 0 0 .224-.947c-.756-.378-1.278-.75-1.628-1.056A1.5 1.5 0 0 0 10.5 12.5v-11A1.5 1.5 0 0 0 9 0H7Zm1 3a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm0 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm.5 1.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM8 9a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
                }
            }
        ]
    })(props);
}
function BsModem(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 1.5A1.5 1.5 0 0 1 7 0h2a1.5 1.5 0 0 1 1.5 1.5v11a1.5 1.5 0 0 1-1.404 1.497c.35.305.872.678 1.628 1.056A.5.5 0 0 1 10.5 16h-5a.5.5 0 0 1-.224-.947c.756-.378 1.277-.75 1.628-1.056A1.5 1.5 0 0 1 5.5 12.5v-11ZM7 1a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-11A.5.5 0 0 0 9 1H7Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0 2a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0 2a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0 2a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
                }
            }
        ]
    })(props);
}
function BsMoisture(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 0a.5.5 0 0 0 0 1H15v2.75h-.5a.5.5 0 0 0 0 1h.5V7.5h-1.5a.5.5 0 0 0 0 1H15v2.75h-.5a.5.5 0 0 0 0 1h.5V15h-1.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 .5-.5V.5a.5.5 0 0 0-.5-.5h-2zM7 1.5l.364-.343a.5.5 0 0 0-.728 0l-.002.002-.006.007-.022.023-.08.088a28.458 28.458 0 0 0-1.274 1.517c-.769.983-1.714 2.325-2.385 3.727C2.368 7.564 2 8.682 2 9.733 2 12.614 4.212 15 7 15s5-2.386 5-5.267c0-1.05-.368-2.169-.867-3.212-.671-1.402-1.616-2.744-2.385-3.727a28.458 28.458 0 0 0-1.354-1.605l-.022-.023-.006-.007-.002-.001L7 1.5zm0 0-.364-.343L7 1.5zm-.016.766L7 2.247l.016.019c.24.274.572.667.944 1.144.611.781 1.32 1.776 1.901 2.827H4.14c.58-1.051 1.29-2.046 1.9-2.827.373-.477.706-.87.945-1.144zM3 9.733c0-.755.244-1.612.638-2.496h6.724c.395.884.638 1.741.638 2.496C11 12.117 9.182 14 7 14s-4-1.883-4-4.267z"
                }
            }
        ]
    })(props);
}
function BsMoonFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278z"
                }
            }
        ]
    })(props);
}
function BsMoonStarsFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.794 3.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387a1.734 1.734 0 0 0-1.097 1.097l-.387 1.162a.217.217 0 0 1-.412 0l-.387-1.162A1.734 1.734 0 0 0 9.31 6.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387a1.734 1.734 0 0 0 1.097-1.097l.387-1.162zM13.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.156 1.156 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.156 1.156 0 0 0-.732-.732l-.774-.258a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732L13.863.1z"
                }
            }
        ]
    })(props);
}
function BsMoonStars(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278zM4.858 1.311A7.269 7.269 0 0 0 1.025 7.71c0 4.02 3.279 7.276 7.319 7.276a7.316 7.316 0 0 0 5.205-2.162c-.337.042-.68.063-1.029.063-4.61 0-8.343-3.714-8.343-8.29 0-1.167.242-2.278.681-3.286z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.794 3.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387a1.734 1.734 0 0 0-1.097 1.097l-.387 1.162a.217.217 0 0 1-.412 0l-.387-1.162A1.734 1.734 0 0 0 9.31 6.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387a1.734 1.734 0 0 0 1.097-1.097l.387-1.162zM13.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.156 1.156 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.156 1.156 0 0 0-.732-.732l-.774-.258a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732L13.863.1z"
                }
            }
        ]
    })(props);
}
function BsMoon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278zM4.858 1.311A7.269 7.269 0 0 0 1.025 7.71c0 4.02 3.279 7.276 7.319 7.276a7.316 7.316 0 0 0 5.205-2.162c-.337.042-.68.063-1.029.063-4.61 0-8.343-3.714-8.343-8.29 0-1.167.242-2.278.681-3.286z"
                }
            }
        ]
    })(props);
}
function BsMortarboardFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.211 2.047a.5.5 0 0 0-.422 0l-7.5 3.5a.5.5 0 0 0 .025.917l7.5 3a.5.5 0 0 0 .372 0L14 7.14V13a1 1 0 0 0-1 1v2h3v-2a1 1 0 0 0-1-1V6.739l.686-.275a.5.5 0 0 0 .025-.917l-7.5-3.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.176 9.032a.5.5 0 0 0-.656.327l-.5 1.7a.5.5 0 0 0 .294.605l4.5 1.8a.5.5 0 0 0 .372 0l4.5-1.8a.5.5 0 0 0 .294-.605l-.5-1.7a.5.5 0 0 0-.656-.327L8 10.466 4.176 9.032Z"
                }
            }
        ]
    })(props);
}
function BsMortarboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.211 2.047a.5.5 0 0 0-.422 0l-7.5 3.5a.5.5 0 0 0 .025.917l7.5 3a.5.5 0 0 0 .372 0L14 7.14V13a1 1 0 0 0-1 1v2h3v-2a1 1 0 0 0-1-1V6.739l.686-.275a.5.5 0 0 0 .025-.917l-7.5-3.5ZM8 8.46 1.758 5.965 8 3.052l6.242 2.913L8 8.46Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.176 9.032a.5.5 0 0 0-.656.327l-.5 1.7a.5.5 0 0 0 .294.605l4.5 1.8a.5.5 0 0 0 .372 0l4.5-1.8a.5.5 0 0 0 .294-.605l-.5-1.7a.5.5 0 0 0-.656-.327L8 10.466 4.176 9.032Zm-.068 1.873.22-.748 3.496 1.311a.5.5 0 0 0 .352 0l3.496-1.311.22.748L8 12.46l-3.892-1.556Z"
                }
            }
        ]
    })(props);
}
function BsMotherboardFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 7h3V4H5v3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 2a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2H.5a.5.5 0 0 1-.5-.5v-1A.5.5 0 0 1 .5 9H1V8H.5a.5.5 0 0 1-.5-.5v-1A.5.5 0 0 1 .5 6H1V5H.5a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 .5 2H1Zm11 .5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7Zm2 0a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7ZM3.5 10a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6Zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6ZM4 4h-.5a.5.5 0 0 0 0 1H4v1h-.5a.5.5 0 0 0 0 1H4a1 1 0 0 0 1 1v.5a.5.5 0 0 0 1 0V8h1v.5a.5.5 0 0 0 1 0V8a1 1 0 0 0 1-1h.5a.5.5 0 0 0 0-1H9V5h.5a.5.5 0 0 0 0-1H9a1 1 0 0 0-1-1v-.5a.5.5 0 0 0-1 0V3H6v-.5a.5.5 0 0 0-1 0V3a1 1 0 0 0-1 1Zm7 7.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5Z"
                }
            }
        ]
    })(props);
}
function BsMotherboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 2a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5Zm2 0a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5Zm-10 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6Zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6ZM5 3a1 1 0 0 0-1 1h-.5a.5.5 0 0 0 0 1H4v1h-.5a.5.5 0 0 0 0 1H4a1 1 0 0 0 1 1v.5a.5.5 0 0 0 1 0V8h1v.5a.5.5 0 0 0 1 0V8a1 1 0 0 0 1-1h.5a.5.5 0 0 0 0-1H9V5h.5a.5.5 0 0 0 0-1H9a1 1 0 0 0-1-1v-.5a.5.5 0 0 0-1 0V3H6v-.5a.5.5 0 0 0-1 0V3Zm0 1h3v3H5V4Zm6.5 7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 2a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2H.5a.5.5 0 0 1-.5-.5v-1A.5.5 0 0 1 .5 9H1V8H.5a.5.5 0 0 1-.5-.5v-1A.5.5 0 0 1 .5 6H1V5H.5a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 .5 2H1Zm1 11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v11Z"
                }
            }
        ]
    })(props);
}
function BsMouseFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5a5 5 0 0 1 10 0v6a5 5 0 0 1-10 0V5zm5.5-1.5a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0v-2z"
                }
            }
        ]
    })(props);
}
function BsMouse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 3zm4 8a4 4 0 0 1-8 0V5a4 4 0 1 1 8 0v6zM8 0a5 5 0 0 0-5 5v6a5 5 0 0 0 10 0V5a5 5 0 0 0-5-5z"
                }
            }
        ]
    })(props);
}
function BsMouse2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5.026C4.958.286 3 2.515 3 5.188V5.5h4.5V.026zm1 0V5.5H13v-.312C13 2.515 11.042.286 8.5.026zM13 6.5H3v4.313C3 13.658 5.22 16 8 16s5-2.342 5-5.188V6.5z"
                }
            }
        ]
    })(props);
}
function BsMouse2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5.188C3 2.341 5.22 0 8 0s5 2.342 5 5.188v5.625C13 13.658 10.78 16 8 16s-5-2.342-5-5.188V5.189zm4.5-4.155C5.541 1.289 4 3.035 4 5.188V5.5h3.5V1.033zm1 0V5.5H12v-.313c0-2.152-1.541-3.898-3.5-4.154zM12 6.5H4v4.313C4 13.145 5.81 15 8 15s4-1.855 4-4.188V6.5z"
                }
            }
        ]
    })(props);
}
function BsMouse3Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5.069A15.328 15.328 0 0 0 7 0c-.593 0-1.104.157-1.527.463-.418.302-.717.726-.93 1.208-.386.873-.522 2.01-.54 3.206l4.497 1V.069zM3.71 5.836 3.381 6A2.5 2.5 0 0 0 2 8.236v2.576C2 13.659 4.22 16 7 16h2c2.78 0 5-2.342 5-5.188V8.123l-9-2v.003l.008.353c.007.3.023.715.053 1.175.063.937.186 2.005.413 2.688a.5.5 0 1 1-.948.316c-.273-.817-.4-2-.462-2.937A30.16 30.16 0 0 1 4 6.003c0-.034.003-.067.01-.1l-.3-.067zM14 7.1V5.187c0-1.13-.272-2.044-.748-2.772-.474-.726-1.13-1.235-1.849-1.59A7.495 7.495 0 0 0 9.5.212v5.887l4.5 1z"
                }
            }
        ]
    })(props);
}
function BsMouse3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 0c-.593 0-1.104.157-1.527.463-.418.302-.717.726-.93 1.208C4.123 2.619 4 3.879 4 5.187v.504L3.382 6A2.5 2.5 0 0 0 2 8.236v2.576C2 13.659 4.22 16 7 16h2c2.78 0 5-2.342 5-5.188V7.51a.71.71 0 0 0 0-.02V5.186c0-1.13-.272-2.044-.748-2.772-.474-.726-1.13-1.235-1.849-1.59C9.981.123 8.26 0 7 0zm2.5 6.099V1.232c.51.11 1.008.267 1.46.49.596.293 1.099.694 1.455 1.24.355.543.585 1.262.585 2.225v1.69l-3.5-.778zm-1-5.025v4.803L5 5.099c.006-1.242.134-2.293.457-3.024.162-.366.363-.63.602-.801C6.292 1.105 6.593 1 7 1c.468 0 .98.018 1.5.074zM5 6.124 13 7.9v2.912C13 13.145 11.19 15 9 15H7c-2.19 0-4-1.855-4-4.188V8.236a1.5 1.5 0 0 1 .83-1.342l.187-.093c.01.265.024.58.047.92.062.938.19 2.12.462 2.937a.5.5 0 1 0 .948-.316c-.227-.683-.35-1.75-.413-2.688a29.17 29.17 0 0 1-.06-1.528v-.002z"
                }
            }
        ]
    })(props);
}
function BsMusicNoteBeamed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 13c0 1.105-1.12 2-2.5 2S1 14.105 1 13c0-1.104 1.12-2 2.5-2s2.5.896 2.5 2zm9-2c0 1.105-1.12 2-2.5 2s-2.5-.895-2.5-2 1.12-2 2.5-2 2.5.895 2.5 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 11V2h1v9h-1zM6 3v10H5V3h1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2.905a1 1 0 0 1 .9-.995l8-.8a1 1 0 0 1 1.1.995V3L5 4V2.905z"
                }
            }
        ]
    })(props);
}
function BsMusicNoteList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13c0 1.105-1.12 2-2.5 2S7 14.105 7 13s1.12-2 2.5-2 2.5.895 2.5 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 3v10h-1V3h1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2.82a1 1 0 0 1 .804-.98l3-.6A1 1 0 0 1 16 2.22V4l-5 1V2.82z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M0 11.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 .5 7H8a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 .5 3H8a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsMusicNote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13c0 1.105-1.12 2-2.5 2S4 14.105 4 13s1.12-2 2.5-2 2.5.895 2.5 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9 3v10H8V3h1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2.82a1 1 0 0 1 .804-.98l3-.6A1 1 0 0 1 13 2.22V4L8 5V2.82z"
                }
            }
        ]
    })(props);
}
function BsMusicPlayerFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm1 2h6a1 1 0 0 1 1 1v2.5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm3 12a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
                }
            }
        ]
    })(props);
}
function BsMusicPlayer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3zm1 0v3h6V3H5zm3 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm-3 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm2-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H4z"
                }
            }
        ]
    })(props);
}
function BsNewspaper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2.5A1.5 1.5 0 0 1 1.5 1h11A1.5 1.5 0 0 1 14 2.5v10.528c0 .3-.05.654-.238.972h.738a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 1 1 0v9a1.5 1.5 0 0 1-1.5 1.5H1.497A1.497 1.497 0 0 1 0 13.5v-11zM12 14c.37 0 .654-.211.853-.441.092-.106.147-.279.147-.531V2.5a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5v11c0 .278.223.5.497.5H12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3h10v2H2V3zm0 3h4v3H2V6zm0 4h4v1H2v-1zm0 2h4v1H2v-1zm5-6h2v1H7V6zm3 0h2v1h-2V6zM7 8h2v1H7V8zm3 0h2v1h-2V8zm-3 2h2v1H7v-1zm3 0h2v1h-2v-1zm-3 2h2v1H7v-1zm3 0h2v1h-2v-1z"
                }
            }
        ]
    })(props);
}
function BsNintendoSwitch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.34 8.005c0-4.38.01-7.972.023-7.982C9.373.01 10.036 0 10.831 0c1.153 0 1.51.01 1.743.05 1.73.298 3.045 1.6 3.373 3.326.046.242.053.809.053 4.61 0 4.06.005 4.537-.123 4.976-.022.076-.048.15-.08.242a4.136 4.136 0 0 1-3.426 2.767c-.317.033-2.889.046-2.978.013-.05-.02-.053-.752-.053-7.979Zm4.675.269a1.621 1.621 0 0 0-1.113-1.034 1.609 1.609 0 0 0-1.938 1.073 1.9 1.9 0 0 0-.014.935 1.632 1.632 0 0 0 1.952 1.107c.51-.136.908-.504 1.11-1.028.11-.285.113-.742.003-1.053ZM3.71 3.317c-.208.04-.526.199-.695.348-.348.301-.52.729-.494 1.232.013.262.03.332.136.544.155.321.39.556.712.715.222.11.278.123.567.133.261.01.354 0 .53-.06.719-.242 1.153-.94 1.03-1.656-.142-.852-.95-1.422-1.786-1.256Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.425.053a4.136 4.136 0 0 0-3.28 3.015C0 3.628-.01 3.956.005 8.3c.01 3.99.014 4.082.08 4.39.368 1.66 1.548 2.844 3.224 3.235.22.05.497.06 2.29.07 1.856.012 2.048.009 2.097-.04.05-.05.053-.69.053-7.94 0-5.374-.01-7.906-.033-7.952-.033-.06-.09-.063-2.03-.06-1.578.004-2.052.014-2.26.05Zm3 14.665-1.35-.016c-1.242-.013-1.375-.02-1.623-.083a2.81 2.81 0 0 1-2.08-2.167c-.074-.335-.074-8.579-.004-8.907a2.845 2.845 0 0 1 1.716-2.05c.438-.176.64-.196 2.058-.2l1.282-.003v13.426Z"
                }
            }
        ]
    })(props);
}
function BsNodeMinusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M16 8a5 5 0 0 1-9.975.5H4A1.5 1.5 0 0 1 2.5 10h-1A1.5 1.5 0 0 1 0 8.5v-1A1.5 1.5 0 0 1 1.5 6h1A1.5 1.5 0 0 1 4 7.5h2.025A5 5 0 0 1 16 8zm-2 0a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5A.5.5 0 0 0 14 8z"
                }
            }
        ]
    })(props);
}
function BsNodeMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM6.025 7.5a5 5 0 1 1 0 1H4A1.5 1.5 0 0 1 2.5 10h-1A1.5 1.5 0 0 1 0 8.5v-1A1.5 1.5 0 0 1 1.5 6h1A1.5 1.5 0 0 1 4 7.5h2.025zM1.5 7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zM8 8a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5A.5.5 0 0 1 8 8z"
                }
            }
        ]
    })(props);
}
function BsNodePlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 13a5 5 0 1 0-4.975-5.5H4A1.5 1.5 0 0 0 2.5 6h-1A1.5 1.5 0 0 0 0 7.5v1A1.5 1.5 0 0 0 1.5 10h1A1.5 1.5 0 0 0 4 8.5h2.025A5 5 0 0 0 11 13zm.5-7.5v2h2a.5.5 0 0 1 0 1h-2v2a.5.5 0 0 1-1 0v-2h-2a.5.5 0 0 1 0-1h2v-2a.5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsNodePlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM6.025 7.5a5 5 0 1 1 0 1H4A1.5 1.5 0 0 1 2.5 10h-1A1.5 1.5 0 0 1 0 8.5v-1A1.5 1.5 0 0 1 1.5 6h1A1.5 1.5 0 0 1 4 7.5h2.025zM11 5a.5.5 0 0 1 .5.5v2h2a.5.5 0 0 1 0 1h-2v2a.5.5 0 0 1-1 0v-2h-2a.5.5 0 0 1 0-1h2v-2A.5.5 0 0 1 11 5zM1.5 7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1z"
                }
            }
        ]
    })(props);
}
function BsNoiseReduction(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-1 1a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-1 1a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-1 1a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-1 1a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-1 1a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-1 1a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-1 1a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm1 1a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm.5-.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm1-1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm1-1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm1-1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm1-1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm1-1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm1-1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm-5 7a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm1.5-1.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm1-1a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm1-1a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm1-1a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm1-1a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-3 5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm.5-.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm1-1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm1-1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM1 8a7 7 0 0 1 12.83-3.875.5.5 0 1 0 .15.235c.131.214.251.437.359.667a.5.5 0 1 0 .359.932c.133.438.225.894.27 1.364a.5.5 0 1 0 .021.282 7.096 7.096 0 0 1-.091 1.592.5.5 0 1 0-.172.75 6.95 6.95 0 0 1-.418 1.091.5.5 0 0 0-.3.555 7.056 7.056 0 0 1-.296.454.499.499 0 0 0-.712.453c0 .111.036.214.098.297a6.99 6.99 0 0 1-.3.3.5.5 0 0 0-.75.614 7.056 7.056 0 0 1-.455.298.503.503 0 0 0-.555.3 6.95 6.95 0 0 1-1.092.417.5.5 0 1 0-.749.172 7.04 7.04 0 0 1-1.592.091.5.5 0 1 0-.282-.021 6.971 6.971 0 0 1-1.364-.27A.498.498 0 0 0 5.5 14a.5.5 0 0 0-.473.339 6.976 6.976 0 0 1-.668-.36A.499.499 0 0 0 5 13.5a.5.5 0 1 0-.875.33A6.993 6.993 0 0 1 1 8Z"
                }
            }
        ]
    })(props);
}
function BsNutFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.58 1a1 1 0 0 0-.868.504l-3.428 6a1 1 0 0 0 0 .992l3.428 6A1 1 0 0 0 4.58 15h6.84a1 1 0 0 0 .868-.504l3.429-6a1 1 0 0 0 0-.992l-3.429-6A1 1 0 0 0 11.42 1H4.58zm5.018 9.696a3 3 0 1 1-3-5.196 3 3 0 0 1 3 5.196z"
                }
            }
        ]
    })(props);
}
function BsNut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.42 2 3.428 6-3.428 6H4.58L1.152 8 4.58 2h6.84zM4.58 1a1 1 0 0 0-.868.504l-3.428 6a1 1 0 0 0 0 .992l3.428 6A1 1 0 0 0 4.58 15h6.84a1 1 0 0 0 .868-.504l3.429-6a1 1 0 0 0 0-.992l-3.429-6A1 1 0 0 0 11.42 1H4.58z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.848 5.933a2.5 2.5 0 1 0 2.5 4.33 2.5 2.5 0 0 0-2.5-4.33zm-1.78 3.915a3.5 3.5 0 1 1 6.061-3.5 3.5 3.5 0 0 1-6.062 3.5z"
                }
            }
        ]
    })(props);
}
function BsNvidia(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.635 7.146S3.08 5.012 5.97 4.791v-.774C2.77 4.273 0 6.983 0 6.983s1.57 4.536 5.97 4.952v-.824c-3.23-.406-4.335-3.965-4.335-3.965ZM5.97 9.475v.753c-2.44-.435-3.118-2.972-3.118-2.972S4.023 5.958 5.97 5.747v.828h-.004c-1.021-.123-1.82.83-1.82.83s.448 1.607 1.824 2.07ZM6 2l-.03 2.017A6.64 6.64 0 0 1 6.252 4c3.637-.123 6.007 2.983 6.007 2.983s-2.722 3.31-5.557 3.31c-.26 0-.504-.024-.732-.065v.883c.195.025.398.04.61.04 2.638 0 4.546-1.348 6.394-2.943.307.246 1.561.842 1.819 1.104-1.757 1.47-5.852 2.657-8.173 2.657a6.84 6.84 0 0 1-.65-.034V14H16l.03-12H6Zm-.03 3.747v-.956a6.4 6.4 0 0 1 .282-.015c2.616-.082 4.332 2.248 4.332 2.248S8.73 9.598 6.743 9.598c-.286 0-.542-.046-.773-.123v-2.9c1.018.123 1.223.572 1.835 1.593L9.167 7.02s-.994-1.304-2.67-1.304a4.9 4.9 0 0 0-.527.031Z"
                }
            }
        ]
    })(props);
}
function BsNvmeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7H5v2h1V7Zm6 0H9v2h3V7Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4a.5.5 0 0 0-.5.5h-1A.5.5 0 0 0 0 5v1a.5.5 0 0 0 .5.5h1a.25.25 0 0 1 0 .5h-1a.5.5 0 0 0-.5.5V11a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5.5h13.5a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5.5.5 0 0 1 0-1A.5.5 0 0 0 16 7V4.5a.5.5 0 0 0-.5-.5H2Zm2 2.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-3Zm4 0a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-3Z"
                }
            }
        ]
    })(props);
}
function BsNvme(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 4.5A.5.5 0 0 1 2 4h13.5a.5.5 0 0 1 .5.5V7a.5.5 0 0 1-.5.5.5.5 0 0 0 0 1 .5.5 0 0 1 .5.5v2.5a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5h-1A.5.5 0 0 1 0 11V7.5A.5.5 0 0 1 .5 7h1a.25.25 0 0 0 0-.5h-1A.5.5 0 0 1 0 6V5a.5.5 0 0 1 .5-.5h1Zm1 .5a.5.5 0 0 1-.5.5h-.5a1.25 1.25 0 1 1 0 2.5H1v2.5h1a.5.5 0 0 1 .5.5H15V9.415a1.5 1.5 0 0 1 0-2.83V5H2.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-3ZM5 7v2h1V7H5Zm3-.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-3ZM9 7v2h3V7H9Z"
                }
            }
        ]
    })(props);
}
function BsOctagonFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.107 0a.5.5 0 0 1 .353.146l4.394 4.394a.5.5 0 0 1 .146.353v6.214a.5.5 0 0 1-.146.353l-4.394 4.394a.5.5 0 0 1-.353.146H4.893a.5.5 0 0 1-.353-.146L.146 11.46A.5.5 0 0 1 0 11.107V4.893a.5.5 0 0 1 .146-.353L4.54.146A.5.5 0 0 1 4.893 0h6.214z"
                }
            }
        ]
    })(props);
}
function BsOctagonHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.54.146A.5.5 0 0 1 4.893 0h6.214a.5.5 0 0 1 .353.146l4.394 4.394a.5.5 0 0 1 .146.353v6.214a.5.5 0 0 1-.146.353l-4.394 4.394a.5.5 0 0 1-.353.146H4.893a.5.5 0 0 1-.353-.146L.146 11.46A.5.5 0 0 1 0 11.107V4.893a.5.5 0 0 1 .146-.353L4.54.146zM8 15h2.9l4.1-4.1V5.1L10.9 1H8v14z"
                }
            }
        ]
    })(props);
}
function BsOctagon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.54.146A.5.5 0 0 1 4.893 0h6.214a.5.5 0 0 1 .353.146l4.394 4.394a.5.5 0 0 1 .146.353v6.214a.5.5 0 0 1-.146.353l-4.394 4.394a.5.5 0 0 1-.353.146H4.893a.5.5 0 0 1-.353-.146L.146 11.46A.5.5 0 0 1 0 11.107V4.893a.5.5 0 0 1 .146-.353L4.54.146zM5.1 1 1 5.1v5.8L5.1 15h5.8l4.1-4.1V5.1L10.9 1H5.1z"
                }
            }
        ]
    })(props);
}
function BsOpencollective(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".4",
                    "d": "M12.995 8.195c0 .937-.312 1.912-.78 2.693l1.99 1.99c.976-1.327 1.6-2.966 1.6-4.683 0-1.795-.624-3.434-1.561-4.76l-2.068 2.028c.468.781.78 1.679.78 2.732h.04Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13.151a4.995 4.995 0 1 1 0-9.99c1.015 0 1.951.273 2.732.82l1.95-2.03a7.805 7.805 0 1 0 .04 12.449l-1.951-2.03a5.072 5.072 0 0 1-2.732.781H8Z"
                }
            }
        ]
    })(props);
}
function BsOpticalAudioFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm1 3a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 15a.5.5 0 0 1-.5-.5v-3.05a2.5 2.5 0 0 1 0-4.9V4.5a.5.5 0 0 1 .146-.354l2-2A.5.5 0 0 1 4.5 2h7a.5.5 0 0 1 .354.146l2 2A.5.5 0 0 1 14 4.5v2.05a2.5 2.5 0 0 1 0 4.9v3.05a.5.5 0 0 1-.5.5h-11ZM8 5a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z"
                }
            }
        ]
    })(props);
}
function BsOpticalAudio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 9a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0ZM8 6.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 14.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-3.05a2.5 2.5 0 0 0 0-4.9V4.5a.5.5 0 0 0-.146-.354l-2-2A.5.5 0 0 0 11.5 2h-7a.5.5 0 0 0-.354.146l-2 2A.5.5 0 0 0 2 4.5v2.05a2.5 2.5 0 0 0 0 4.9v3.05Zm1-.5v-3a.5.5 0 0 0-.5-.5 1.5 1.5 0 1 1 0-3A.5.5 0 0 0 3 7V4.707L4.707 3h6.586L13 4.707V7a.5.5 0 0 0 .5.5 1.5 1.5 0 0 1 0 3 .5.5 0 0 0-.5.5v3H3Z"
                }
            }
        ]
    })(props);
}
function BsOption(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 2.5a.5.5 0 0 1 .5-.5h3.797a.5.5 0 0 1 .439.26L11 13h3.5a.5.5 0 0 1 0 1h-3.797a.5.5 0 0 1-.439-.26L5 3H1.5a.5.5 0 0 1-.5-.5zm10 0a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsOutlet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.34 2.994c.275-.338.68-.494 1.074-.494h7.172c.393 0 .798.156 1.074.494.578.708 1.84 2.534 1.84 5.006 0 2.472-1.262 4.297-1.84 5.006-.276.338-.68.494-1.074.494H4.414c-.394 0-.799-.156-1.074-.494C2.762 12.297 1.5 10.472 1.5 8c0-2.472 1.262-4.297 1.84-5.006zm1.074.506a.376.376 0 0 0-.299.126C3.599 4.259 2.5 5.863 2.5 8c0 2.137 1.099 3.74 1.615 4.374.06.073.163.126.3.126h7.17c.137 0 .24-.053.3-.126.516-.633 1.615-2.237 1.615-4.374 0-2.137-1.099-3.74-1.615-4.374a.376.376 0 0 0-.3-.126h-7.17z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 5.5a.5.5 0 0 1 .5.5v1.5a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm4 0a.5.5 0 0 1 .5.5v1.5a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zM7 10v1h2v-1a1 1 0 0 0-2 0z"
                }
            }
        ]
    })(props);
}
function BsPCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM5.5 4.002V12h1.283V9.164h1.668C10.033 9.164 11 8.08 11 6.586c0-1.482-.955-2.584-2.538-2.584H5.5Zm2.77 4.072c.893 0 1.419-.545 1.419-1.488s-.526-1.482-1.42-1.482H6.778v2.97H8.27Z"
                }
            }
        ]
    })(props);
}
function BsPCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8Zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM5.5 4.002h2.962C10.045 4.002 11 5.104 11 6.586c0 1.494-.967 2.578-2.55 2.578H6.784V12H5.5V4.002Zm2.77 4.072c.893 0 1.419-.545 1.419-1.488s-.526-1.482-1.42-1.482H6.778v2.97H8.27Z"
                }
            }
        ]
    })(props);
}
function BsPSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.27 8.074c.893 0 1.419-.545 1.419-1.488s-.526-1.482-1.42-1.482H6.778v2.97H8.27Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm3.5 4.002h2.962C10.045 4.002 11 5.104 11 6.586c0 1.494-.967 2.578-2.55 2.578H6.784V12H5.5V4.002Z"
                }
            }
        ]
    })(props);
}
function BsPSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 4.002h2.962C10.045 4.002 11 5.104 11 6.586c0 1.494-.967 2.578-2.55 2.578H6.784V12H5.5V4.002Zm2.77 4.072c.893 0 1.419-.545 1.419-1.488s-.526-1.482-1.42-1.482H6.778v2.97H8.27Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2Z"
                }
            }
        ]
    })(props);
}
function BsPaintBucket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.192 2.78c-.458-.677-.927-1.248-1.35-1.643a2.972 2.972 0 0 0-.71-.515c-.217-.104-.56-.205-.882-.02-.367.213-.427.63-.43.896-.003.304.064.664.173 1.044.196.687.556 1.528 1.035 2.402L.752 8.22c-.277.277-.269.656-.218.918.055.283.187.593.36.903.348.627.92 1.361 1.626 2.068.707.707 1.441 1.278 2.068 1.626.31.173.62.305.903.36.262.05.64.059.918-.218l5.615-5.615c.118.257.092.512.05.939-.03.292-.068.665-.073 1.176v.123h.003a1 1 0 0 0 1.993 0H14v-.057a1.01 1.01 0 0 0-.004-.117c-.055-1.25-.7-2.738-1.86-3.494a4.322 4.322 0 0 0-.211-.434c-.349-.626-.92-1.36-1.627-2.067-.707-.707-1.441-1.279-2.068-1.627-.31-.172-.62-.304-.903-.36-.262-.05-.64-.058-.918.219l-.217.216zM4.16 1.867c.381.356.844.922 1.311 1.632l-.704.705c-.382-.727-.66-1.402-.813-1.938a3.283 3.283 0 0 1-.131-.673c.091.061.204.15.337.274zm.394 3.965c.54.852 1.107 1.567 1.607 2.033a.5.5 0 1 0 .682-.732c-.453-.422-1.017-1.136-1.564-2.027l1.088-1.088c.054.12.115.243.183.365.349.627.92 1.361 1.627 2.068.706.707 1.44 1.278 2.068 1.626.122.068.244.13.365.183l-4.861 4.862a.571.571 0 0 1-.068-.01c-.137-.027-.342-.104-.608-.252-.524-.292-1.186-.8-1.846-1.46-.66-.66-1.168-1.32-1.46-1.846-.147-.265-.225-.47-.251-.607a.573.573 0 0 1-.01-.068l3.048-3.047zm2.87-1.935a2.44 2.44 0 0 1-.241-.561c.135.033.324.11.562.241.524.292 1.186.8 1.846 1.46.45.45.83.901 1.118 1.31a3.497 3.497 0 0 0-1.066.091 11.27 11.27 0 0 1-.76-.694c-.66-.66-1.167-1.322-1.458-1.847z"
                }
            }
        ]
    })(props);
}
function BsPaletteFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.433 10.07C14.133 10.585 16 11.15 16 8a8 8 0 1 0-8 8c1.996 0 1.826-1.504 1.649-3.08-.124-1.101-.252-2.237.351-2.92.465-.527 1.42-.237 2.433.07zM8 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm4.5 3a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM5 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm.5 6.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                }
            }
        ]
    })(props);
}
function BsPalette(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm4 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM5.5 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm.5 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8c0 3.15-1.866 2.585-3.567 2.07C11.42 9.763 10.465 9.473 10 10c-.603.683-.475 1.819-.351 2.92C9.826 14.495 9.996 16 8 16a8 8 0 1 1 8-8zm-8 7c.611 0 .654-.171.655-.176.078-.146.124-.464.07-1.119-.014-.168-.037-.37-.061-.591-.052-.464-.112-1.005-.118-1.462-.01-.707.083-1.61.704-2.314.369-.417.845-.578 1.272-.618.404-.038.812.026 1.16.104.343.077.702.186 1.025.284l.028.008c.346.105.658.199.953.266.653.148.904.083.991.024C14.717 9.38 15 9.161 15 8a7 7 0 1 0-7 7z"
                }
            }
        ]
    })(props);
}
function BsPalette2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 .5A.5.5 0 0 1 .5 0h5a.5.5 0 0 1 .5.5v5.277l4.147-4.131a.5.5 0 0 1 .707 0l3.535 3.536a.5.5 0 0 1 0 .708L10.261 10H15.5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5H3a2.99 2.99 0 0 1-2.121-.879A2.99 2.99 0 0 1 0 13.044m6-.21 7.328-7.3-2.829-2.828L6 7.188v5.647zM4.5 13a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0zM15 15v-4H9.258l-4.015 4H15zM0 .5v12.495V.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 12.995V13a3.07 3.07 0 0 0 0-.005z"
                }
            }
        ]
    })(props);
}
function BsPaperclip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z"
                }
            }
        ]
    })(props);
}
function BsParagraph(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 15a.5.5 0 0 1-.5-.5V2H9v12.5a.5.5 0 0 1-1 0V9H7a4 4 0 1 1 0-8h5.5a.5.5 0 0 1 0 1H11v12.5a.5.5 0 0 1-.5.5z"
                }
            }
        ]
    })(props);
}
function BsPassFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 0a2 2 0 1 1-4 0H3.5A1.5 1.5 0 0 0 2 1.5v13A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-13A1.5 1.5 0 0 0 12.5 0H10ZM4.5 5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1Zm0 2h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1Z"
                }
            }
        ]
    })(props);
}
function BsPass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2a2 2 0 0 0 2-2h2.5A1.5 1.5 0 0 1 14 1.5v13a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-13A1.5 1.5 0 0 1 3.5 0H6a2 2 0 0 0 2 2Zm0 1a3.001 3.001 0 0 1-2.83-2H3.5a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5h-1.67A3.001 3.001 0 0 1 8 3Z"
                }
            }
        ]
    })(props);
}
function BsPassportFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3.252a1.5 1.5 0 0 1 1.232-1.476l8-1.454A1.5 1.5 0 0 1 13 1.797v.47A2 2 0 0 1 14 4v10a2 2 0 0 1-2 2H4a1.995 1.995 0 0 1-1.51-.688 1.493 1.493 0 0 1-.49-1.11V3.253ZM5 8a3 3 0 1 0 6 0 3 3 0 0 0-6 0Zm0 4.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 0-1h-5a.5.5 0 0 0-.5.5Z"
                }
            }
        ]
    })(props);
}
function BsPassport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm-.5 4a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.232 1.776A1.5 1.5 0 0 0 2 3.252v10.95c0 .445.191.838.49 1.11.367.422.908.688 1.51.688h8a2 2 0 0 0 2-2V4a2 2 0 0 0-1-1.732v-.47A1.5 1.5 0 0 0 11.232.321l-8 1.454ZM4 3h8a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z"
                }
            }
        ]
    })(props);
}
function BsPatchCheckFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01-.622-.636zm.287 5.984-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708.708z"
                }
            }
        ]
    })(props);
}
function BsPatchCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.354 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10.273 2.513-.921-.944.715-.698.622.637.89-.011a2.89 2.89 0 0 1 2.924 2.924l-.01.89.636.622a2.89 2.89 0 0 1 0 4.134l-.637.622.011.89a2.89 2.89 0 0 1-2.924 2.924l-.89-.01-.622.636a2.89 2.89 0 0 1-4.134 0l-.622-.637-.89.011a2.89 2.89 0 0 1-2.924-2.924l.01-.89-.636-.622a2.89 2.89 0 0 1 0-4.134l.637-.622-.011-.89a2.89 2.89 0 0 1 2.924-2.924l.89.01.622-.636a2.89 2.89 0 0 1 4.134 0l-.715.698a1.89 1.89 0 0 0-2.704 0l-.92.944-1.32-.016a1.89 1.89 0 0 0-1.911 1.912l.016 1.318-.944.921a1.89 1.89 0 0 0 0 2.704l.944.92-.016 1.32a1.89 1.89 0 0 0 1.912 1.911l1.318-.016.921.944a1.89 1.89 0 0 0 2.704 0l.92-.944 1.32.016a1.89 1.89 0 0 0 1.911-1.912l-.016-1.318.944-.921a1.89 1.89 0 0 0 0-2.704l-.944-.92.016-1.32a1.89 1.89 0 0 0-1.912-1.911l-1.318.016z"
                }
            }
        ]
    })(props);
}
function BsPatchExclamationFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01-.622-.636zM8 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                }
            }
        ]
    })(props);
}
function BsPatchExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.001 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.553.553 0 0 1-1.1 0L7.1 4.995z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10.273 2.513-.921-.944.715-.698.622.637.89-.011a2.89 2.89 0 0 1 2.924 2.924l-.01.89.636.622a2.89 2.89 0 0 1 0 4.134l-.637.622.011.89a2.89 2.89 0 0 1-2.924 2.924l-.89-.01-.622.636a2.89 2.89 0 0 1-4.134 0l-.622-.637-.89.011a2.89 2.89 0 0 1-2.924-2.924l.01-.89-.636-.622a2.89 2.89 0 0 1 0-4.134l.637-.622-.011-.89a2.89 2.89 0 0 1 2.924-2.924l.89.01.622-.636a2.89 2.89 0 0 1 4.134 0l-.715.698a1.89 1.89 0 0 0-2.704 0l-.92.944-1.32-.016a1.89 1.89 0 0 0-1.911 1.912l.016 1.318-.944.921a1.89 1.89 0 0 0 0 2.704l.944.92-.016 1.32a1.89 1.89 0 0 0 1.912 1.911l1.318-.016.921.944a1.89 1.89 0 0 0 2.704 0l.92-.944 1.32.016a1.89 1.89 0 0 0 1.911-1.912l-.016-1.318.944-.921a1.89 1.89 0 0 0 0-2.704l-.944-.92.016-1.32a1.89 1.89 0 0 0-1.912-1.911l-1.318.016z"
                }
            }
        ]
    })(props);
}
function BsPatchMinusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01-.622-.636zM6 7.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1z"
                }
            }
        ]
    })(props);
}
function BsPatchMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10.273 2.513-.921-.944.715-.698.622.637.89-.011a2.89 2.89 0 0 1 2.924 2.924l-.01.89.636.622a2.89 2.89 0 0 1 0 4.134l-.637.622.011.89a2.89 2.89 0 0 1-2.924 2.924l-.89-.01-.622.636a2.89 2.89 0 0 1-4.134 0l-.622-.637-.89.011a2.89 2.89 0 0 1-2.924-2.924l.01-.89-.636-.622a2.89 2.89 0 0 1 0-4.134l.637-.622-.011-.89a2.89 2.89 0 0 1 2.924-2.924l.89.01.622-.636a2.89 2.89 0 0 1 4.134 0l-.715.698a1.89 1.89 0 0 0-2.704 0l-.92.944-1.32-.016a1.89 1.89 0 0 0-1.911 1.912l.016 1.318-.944.921a1.89 1.89 0 0 0 0 2.704l.944.92-.016 1.32a1.89 1.89 0 0 0 1.912 1.911l1.318-.016.921.944a1.89 1.89 0 0 0 2.704 0l.92-.944 1.32.016a1.89 1.89 0 0 0 1.911-1.912l-.016-1.318.944-.921a1.89 1.89 0 0 0 0-2.704l-.944-.92.016-1.32a1.89 1.89 0 0 0-1.912-1.911l-1.318.016z"
                }
            }
        ]
    })(props);
}
function BsPatchPlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01-.622-.636zM8.5 6v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsPatchPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 5.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 .5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10.273 2.513-.921-.944.715-.698.622.637.89-.011a2.89 2.89 0 0 1 2.924 2.924l-.01.89.636.622a2.89 2.89 0 0 1 0 4.134l-.637.622.011.89a2.89 2.89 0 0 1-2.924 2.924l-.89-.01-.622.636a2.89 2.89 0 0 1-4.134 0l-.622-.637-.89.011a2.89 2.89 0 0 1-2.924-2.924l.01-.89-.636-.622a2.89 2.89 0 0 1 0-4.134l.637-.622-.011-.89a2.89 2.89 0 0 1 2.924-2.924l.89.01.622-.636a2.89 2.89 0 0 1 4.134 0l-.715.698a1.89 1.89 0 0 0-2.704 0l-.92.944-1.32-.016a1.89 1.89 0 0 0-1.911 1.912l.016 1.318-.944.921a1.89 1.89 0 0 0 0 2.704l.944.92-.016 1.32a1.89 1.89 0 0 0 1.912 1.911l1.318-.016.921.944a1.89 1.89 0 0 0 2.704 0l.92-.944 1.32.016a1.89 1.89 0 0 0 1.911-1.912l-.016-1.318.944-.921a1.89 1.89 0 0 0 0-2.704l-.944-.92.016-1.32a1.89 1.89 0 0 0-1.912-1.911l-1.318.016z"
                }
            }
        ]
    })(props);
}
function BsPatchQuestionFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.933.87a2.89 2.89 0 0 1 4.134 0l.622.638.89-.011a2.89 2.89 0 0 1 2.924 2.924l-.01.89.636.622a2.89 2.89 0 0 1 0 4.134l-.637.622.011.89a2.89 2.89 0 0 1-2.924 2.924l-.89-.01-.622.636a2.89 2.89 0 0 1-4.134 0l-.622-.637-.89.011a2.89 2.89 0 0 1-2.924-2.924l.01-.89-.636-.622a2.89 2.89 0 0 1 0-4.134l.637-.622-.011-.89a2.89 2.89 0 0 1 2.924-2.924l.89.01.622-.636zM7.002 11a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm1.602-2.027c.04-.534.198-.815.846-1.26.674-.475 1.05-1.09 1.05-1.986 0-1.325-.92-2.227-2.262-2.227-1.02 0-1.792.492-2.1 1.29A1.71 1.71 0 0 0 6 5.48c0 .393.203.64.545.64.272 0 .455-.147.564-.51.158-.592.525-.915 1.074-.915.61 0 1.03.446 1.03 1.084 0 .563-.208.885-.822 1.325-.619.433-.926.914-.926 1.64v.111c0 .428.208.745.585.745.336 0 .504-.24.554-.627z"
                }
            }
        ]
    })(props);
}
function BsPatchQuestion(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.05 9.6c.336 0 .504-.24.554-.627.04-.534.198-.815.847-1.26.673-.475 1.049-1.09 1.049-1.986 0-1.325-.92-2.227-2.262-2.227-1.02 0-1.792.492-2.1 1.29A1.71 1.71 0 0 0 6 5.48c0 .393.203.64.545.64.272 0 .455-.147.564-.51.158-.592.525-.915 1.074-.915.61 0 1.03.446 1.03 1.084 0 .563-.208.885-.822 1.325-.619.433-.926.914-.926 1.64v.111c0 .428.208.745.585.745z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10.273 2.513-.921-.944.715-.698.622.637.89-.011a2.89 2.89 0 0 1 2.924 2.924l-.01.89.636.622a2.89 2.89 0 0 1 0 4.134l-.637.622.011.89a2.89 2.89 0 0 1-2.924 2.924l-.89-.01-.622.636a2.89 2.89 0 0 1-4.134 0l-.622-.637-.89.011a2.89 2.89 0 0 1-2.924-2.924l.01-.89-.636-.622a2.89 2.89 0 0 1 0-4.134l.637-.622-.011-.89a2.89 2.89 0 0 1 2.924-2.924l.89.01.622-.636a2.89 2.89 0 0 1 4.134 0l-.715.698a1.89 1.89 0 0 0-2.704 0l-.92.944-1.32-.016a1.89 1.89 0 0 0-1.911 1.912l.016 1.318-.944.921a1.89 1.89 0 0 0 0 2.704l.944.92-.016 1.32a1.89 1.89 0 0 0 1.912 1.911l1.318-.016.921.944a1.89 1.89 0 0 0 2.704 0l.92-.944 1.32.016a1.89 1.89 0 0 0 1.911-1.912l-.016-1.318.944-.921a1.89 1.89 0 0 0 0-2.704l-.944-.92.016-1.32a1.89 1.89 0 0 0-1.912-1.911l-1.318.016z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.001 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0z"
                }
            }
        ]
    })(props);
}
function BsPauseBtnFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm6.25-7C5.56 5 5 5.56 5 6.25v3.5a1.25 1.25 0 1 0 2.5 0v-3.5C7.5 5.56 6.94 5 6.25 5zm3.5 0c-.69 0-1.25.56-1.25 1.25v3.5a1.25 1.25 0 1 0 2.5 0v-3.5C11 5.56 10.44 5 9.75 5z"
                }
            }
        ]
    })(props);
}
function BsPauseBtn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.25 5C5.56 5 5 5.56 5 6.25v3.5a1.25 1.25 0 1 0 2.5 0v-3.5C7.5 5.56 6.94 5 6.25 5zm3.5 0c-.69 0-1.25.56-1.25 1.25v3.5a1.25 1.25 0 1 0 2.5 0v-3.5C11 5.56 10.44 5 9.75 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"
                }
            }
        ]
    })(props);
}
function BsPauseCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.25 5C5.56 5 5 5.56 5 6.25v3.5a1.25 1.25 0 1 0 2.5 0v-3.5C7.5 5.56 6.94 5 6.25 5zm3.5 0c-.69 0-1.25.56-1.25 1.25v3.5a1.25 1.25 0 1 0 2.5 0v-3.5C11 5.56 10.44 5 9.75 5z"
                }
            }
        ]
    })(props);
}
function BsPauseCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 6.25a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0v-3.5zm3.5 0a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0v-3.5z"
                }
            }
        ]
    })(props);
}
function BsPauseFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"
                }
            }
        ]
    })(props);
}
function BsPause(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5zm4 0a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsPaypal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.06 3.713c.12-1.071-.093-1.832-.702-2.526C12.628.356 11.312 0 9.626 0H4.734a.7.7 0 0 0-.691.59L2.005 13.509a.42.42 0 0 0 .415.486h2.756l-.202 1.28a.628.628 0 0 0 .62.726H8.14c.429 0 .793-.31.862-.731l.025-.13.48-3.043.03-.164.001-.007a.351.351 0 0 1 .348-.297h.38c1.266 0 2.425-.256 3.345-.91.379-.27.712-.603.993-1.005a4.942 4.942 0 0 0 .88-2.195c.242-1.246.13-2.356-.57-3.154a2.687 2.687 0 0 0-.76-.59l-.094-.061ZM6.543 8.82a.695.695 0 0 1 .321-.079H8.3c2.82 0 5.027-1.144 5.672-4.456l.003-.016c.217.124.4.27.548.438.546.623.679 1.535.45 2.71-.272 1.397-.866 2.307-1.663 2.874-.802.57-1.842.815-3.043.815h-.38a.873.873 0 0 0-.863.734l-.03.164-.48 3.043-.024.13-.001.004a.352.352 0 0 1-.348.296H5.595a.106.106 0 0 1-.105-.123l.208-1.32.845-5.214Z"
                }
            }
        ]
    })(props);
}
function BsPcDisplayHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 0A1.5 1.5 0 0 0 0 1.5v7A1.5 1.5 0 0 0 1.5 10H6v1H1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-5v-1h4.5A1.5 1.5 0 0 0 16 8.5v-7A1.5 1.5 0 0 0 14.5 0h-13Zm0 1h13a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5ZM12 12.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm2 0a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0ZM1.5 12h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1ZM1 14.25a.25.25 0 0 1 .25-.25h5.5a.25.25 0 1 1 0 .5h-5.5a.25.25 0 0 1-.25-.25Z"
                }
            }
        ]
    })(props);
}
function BsPcDisplay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V1Zm1 13.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0Zm2 0a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0ZM9.5 1a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5ZM9 3.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 0-1h-5a.5.5 0 0 0-.5.5ZM1.5 2A1.5 1.5 0 0 0 0 3.5v7A1.5 1.5 0 0 0 1.5 12H6v2h-.5a.5.5 0 0 0 0 1H7v-4H1.5a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5H7V2H1.5Z"
                }
            }
        ]
    })(props);
}
function BsPcHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 6a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H1Zm11.5 1a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm2 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1ZM1 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5ZM1.25 9h5.5a.25.25 0 0 1 0 .5h-5.5a.25.25 0 0 1 0-.5Z"
                }
            }
        ]
    })(props);
}
function BsPc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 0a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H5Zm.5 14a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm2 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1ZM5 1.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5ZM5.5 3h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1Z"
                }
            }
        ]
    })(props);
}
function BsPciCardNetwork(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 9.5v-2h.214a.5.5 0 0 0 .5-.5v-.5h2.572V7a.5.5 0 0 0 .5.5h.214v2h-4Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1.5A.5.5 0 0 1 .5 1h1a.5.5 0 0 1 .5.5V4h13.5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5H2v2.5a.5.5 0 0 1-1 0V2H.5a.5.5 0 0 1-.5-.5Zm6.714 4a.5.5 0 0 0-.5.5v.5H6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5V7a.5.5 0 0 0-.5-.5h-.214V6a.5.5 0 0 0-.5-.5H6.714Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12.5h3.5v1a.5.5 0 0 1-.5.5H3.5a.5.5 0 0 1-.5-.5v-1Zm8 0H7v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1Z"
                }
            }
        ]
    })(props);
}
function BsPciCardSound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.562 7.39 8 7.04v1.92l-.438-.35a.5.5 0 0 0-.312-.11H6.5v-1h.75a.5.5 0 0 0 .312-.11Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M.5 1a.5.5 0 0 0 0 1H1v12.5a.5.5 0 0 0 1 0V12h13.5a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5H2V1.5a.5.5 0 0 0-.5-.5h-1Zm11.619 3.881c.1.115.194.238.28.367.484.726.768 1.7.768 2.752 0 1.051-.284 2.026-.768 2.752-.086.13-.18.252-.28.367l-.71-.71c.055-.064.107-.135.158-.212.36-.54.6-1.315.6-2.197 0-.882-.24-1.657-.6-2.198a2.57 2.57 0 0 0-.157-.212l.709-.709Zm-1.375 4.863L10 9c.057 0 .17-.035.291-.217.12-.178.209-.454.209-.783 0-.33-.09-.605-.209-.783C10.17 7.035 10.057 7 10 7l.744-.744c.15.113.278.254.38.406.242.364.376.839.376 1.338 0 .5-.134.974-.377 1.338a1.653 1.653 0 0 1-.379.406ZM9 6v4a.5.5 0 0 1-.812.39L7.075 9.5H6a.5.5 0 0 1-.5-.5V7a.5.5 0 0 1 .5-.5h1.075l1.113-.89A.5.5 0 0 1 9 6Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 12.5H3v1a.5.5 0 0 0 .5.5H6a.5.5 0 0 0 .5-.5v-1Zm.5 1v-1h4v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5Z"
                }
            }
        ]
    })(props);
}
function BsPciCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1.5A.5.5 0 0 1 .5 1h1a.5.5 0 0 1 .5.5V4h13.5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5H2v2.5a.5.5 0 0 1-1 0V2H.5a.5.5 0 0 1-.5-.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12.5h3.5v1a.5.5 0 0 1-.5.5H3.5a.5.5 0 0 1-.5-.5v-1Zm4 0h4v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1Z"
                }
            }
        ]
    })(props);
}
function BsPeaceFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 13.292A8 8 0 0 0 8.5.015v7.778l5.5 5.5zm-.708.708L8.5 9.206v6.778a7.967 7.967 0 0 0 4.792-1.986zM7.5 15.985V9.207L2.708 14A7.967 7.967 0 0 0 7.5 15.985zM2 13.292A8 8 0 0 1 7.5.015v7.778l-5.5 5.5z"
                }
            }
        ]
    })(props);
}
function BsPeace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 1.018a7 7 0 0 0-4.79 11.566L7.5 7.793V1.018zm1 0v6.775l4.79 4.79A7 7 0 0 0 8.5 1.018zm4.084 12.273L8.5 9.207v5.775a6.97 6.97 0 0 0 4.084-1.691zM7.5 14.982V9.207l-4.084 4.084A6.97 6.97 0 0 0 7.5 14.982zM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8z"
                }
            }
        ]
    })(props);
}
function BsPenFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001z"
                }
            }
        ]
    })(props);
}
function BsPen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001zm-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708l-1.585-1.585z"
                }
            }
        ]
    })(props);
}
function BsPencilFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"
                }
            }
        ]
    })(props);
}
function BsPencilSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                }
            }
        ]
    })(props);
}
function BsPencil(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"
                }
            }
        ]
    })(props);
}
function BsPentagonFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.685.256a.5.5 0 0 1 .63 0l7.421 6.03a.5.5 0 0 1 .162.538l-2.788 8.827a.5.5 0 0 1-.476.349H3.366a.5.5 0 0 1-.476-.35L.102 6.825a.5.5 0 0 1 .162-.538l7.42-6.03Z"
                }
            }
        ]
    })(props);
}
function BsPentagonHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m8 1.288 6.578 5.345a.5.5 0 0 1 .161.539l-2.362 7.479a.5.5 0 0 1-.476.349H8V1.288Zm7.898 5.536a.5.5 0 0 0-.162-.538L8.316.256a.5.5 0 0 0-.631 0L.264 6.286a.5.5 0 0 0-.162.538l2.788 8.827a.5.5 0 0 0 .476.349h9.268a.5.5 0 0 0 .476-.35l2.788-8.826Z"
                }
            }
        ]
    })(props);
}
function BsPentagon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.685 1.545a.5.5 0 0 1 .63 0l6.263 5.088a.5.5 0 0 1 .161.539l-2.362 7.479a.5.5 0 0 1-.476.349H4.099a.5.5 0 0 1-.476-.35L1.26 7.173a.5.5 0 0 1 .161-.54l6.263-5.087Zm8.213 5.28a.5.5 0 0 0-.162-.54L8.316.257a.5.5 0 0 0-.631 0L.264 6.286a.5.5 0 0 0-.162.538l2.788 8.827a.5.5 0 0 0 .476.349h9.268a.5.5 0 0 0 .476-.35l2.788-8.826Z"
                }
            }
        ]
    })(props);
}
function BsPeopleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7Zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-5.784 6A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216ZM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
                }
            }
        ]
    })(props);
}
function BsPeople(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8Zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022ZM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816ZM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
                }
            }
        ]
    })(props);
}
function BsPercent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.442 2.558a.625.625 0 0 1 0 .884l-10 10a.625.625 0 1 1-.884-.884l10-10a.625.625 0 0 1 .884 0zM4.5 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm7 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
                }
            }
        ]
    })(props);
}
function BsPersonAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0Zm-2-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.256 14a4.474 4.474 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10c.26 0 .507.009.74.025.226-.341.496-.65.804-.918C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4s1 1 1 1h5.256Z"
                }
            }
        ]
    })(props);
}
function BsPersonArmsUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m5.93 6.704-.846 8.451a.768.768 0 0 0 1.523.203l.81-4.865a.59.59 0 0 1 1.165 0l.81 4.865a.768.768 0 0 0 1.523-.203l-.845-8.451A1.492 1.492 0 0 1 10.5 5.5L13 2.284a.796.796 0 0 0-1.239-.998L9.634 3.84a.72.72 0 0 1-.33.235c-.23.074-.665.176-1.304.176-.64 0-1.074-.102-1.305-.176a.72.72 0 0 1-.329-.235L4.239 1.286a.796.796 0 0 0-1.24.998l2.5 3.216c.317.316.475.758.43 1.204Z"
                }
            }
        ]
    })(props);
}
function BsPersonBadgeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm4.5 0a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zM8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm5 2.755C12.146 12.825 10.623 12 8 12s-4.146.826-5 1.755V14a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-.245z"
                }
            }
        ]
    })(props);
}
function BsPersonBadge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zM11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 0A2.5 2.5 0 0 0 2 2.5V14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2.5A2.5 2.5 0 0 0 11.5 0h-7zM3 2.5A1.5 1.5 0 0 1 4.5 1h7A1.5 1.5 0 0 1 13 2.5v10.795a4.2 4.2 0 0 0-.776-.492C11.392 12.387 10.063 12 8 12s-3.392.387-4.224.803a4.2 4.2 0 0 0-.776.492V2.5z"
                }
            }
        ]
    })(props);
}
function BsPersonBoundingBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"
                }
            }
        ]
    })(props);
}
function BsPersonCheckFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L12.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                }
            }
        ]
    })(props);
}
function BsPersonCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.17-1.951a.5.5 0 1 1 .858.514ZM11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.256 14a4.474 4.474 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10c.26 0 .507.009.74.025.226-.341.496-.65.804-.918C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4s1 1 1 1h5.256Z"
                }
            }
        ]
    })(props);
}
function BsPersonCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
                }
            }
        ]
    })(props);
}
function BsPersonDashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11 7.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                }
            }
        ]
    })(props);
}
function BsPersonDash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM11 12h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1Zm0-7a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.256 14a4.474 4.474 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10c.26 0 .507.009.74.025.226-.341.496-.65.804-.918C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4s1 1 1 1h5.256Z"
                }
            }
        ]
    })(props);
}
function BsPersonDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 9a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm.354 5.854 1.5-1.5a.5.5 0 0 0-.708-.708l-.646.647V10.5a.5.5 0 0 0-1 0v2.793l-.646-.647a.5.5 0 0 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0ZM11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.256 14a4.474 4.474 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10c.26 0 .507.009.74.025.226-.341.496-.65.804-.918C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4s1 1 1 1h5.256Z"
                }
            }
        ]
    })(props);
}
function BsPersonExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm.256 7a4.474 4.474 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10c.26 0 .507.009.74.025.226-.341.496-.65.804-.918C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4s1 1 1 1h5.256Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-3.5-2a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 1 0V11a.5.5 0 0 0-.5-.5Zm0 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
                }
            }
        ]
    })(props);
}
function BsPersonFillAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0Zm-2-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 13c0 1 1 1 1 1h5.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.544-3.393C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Z"
                }
            }
        ]
    })(props);
}
function BsPersonFillCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.17-1.951a.5.5 0 1 1 .858.514ZM11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 13c0 1 1 1 1 1h5.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.544-3.393C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Z"
                }
            }
        ]
    })(props);
}
function BsPersonFillDash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM11 12h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1Zm0-7a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 13c0 1 1 1 1 1h5.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.544-3.393C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Z"
                }
            }
        ]
    })(props);
}
function BsPersonFillDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 9a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm.354 5.854 1.5-1.5a.5.5 0 0 0-.708-.708l-.646.647V10.5a.5.5 0 0 0-1 0v2.793l-.646-.647a.5.5 0 0 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0ZM11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 13c0 1 1 1 1 1h5.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.544-3.393C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Z"
                }
            }
        ]
    })(props);
}
function BsPersonFillExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-9 8c0 1 1 1 1 1h5.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.544-3.393C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-3.5-2a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 1 0V11a.5.5 0 0 0-.5-.5Zm0 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
                }
            }
        ]
    })(props);
}
function BsPersonFillGear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-9 8c0 1 1 1 1 1h5.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.544-3.393C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Zm9.886-3.54c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.045c-.613-.18-.613-1.048 0-1.229l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382l.045-.148ZM14 12.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z"
                }
            }
        ]
    })(props);
}
function BsPersonFillLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-9 8c0 1 1 1 1 1h5v-1a1.9 1.9 0 0 1 .01-.2 4.49 4.49 0 0 1 1.534-3.693C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Zm7 0a1 1 0 0 1 1-1v-1a2 2 0 1 1 4 0v1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-2Zm3-3a1 1 0 0 0-1 1v1h2v-1a1 1 0 0 0-1-1Z"
                }
            }
        ]
    })(props);
}
function BsPersonFillSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.879 10.414a2.501 2.501 0 0 0-3.465 3.465l3.465-3.465Zm.707.707-3.465 3.465a2.501 2.501 0 0 0 3.465-3.465Zm-4.56-1.096a3.5 3.5 0 1 1 4.949 4.95 3.5 3.5 0 0 1-4.95-4.95ZM11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-9 8c0 1 1 1 1 1h5.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.544-3.393C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Z"
                }
            }
        ]
    })(props);
}
function BsPersonFillUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.354-5.854 1.5 1.5a.5.5 0 0 1-.708.708L13 11.707V14.5a.5.5 0 0 1-1 0v-2.793l-.646.647a.5.5 0 0 1-.708-.708l1.5-1.5a.5.5 0 0 1 .708 0ZM11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 13c0 1 1 1 1 1h5.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.544-3.393C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Z"
                }
            }
        ]
    })(props);
}
function BsPersonFillX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-9 8c0 1 1 1 1 1h5.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.544-3.393C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-.646-4.854.646.647.646-.647a.5.5 0 0 1 .708.708l-.647.646.647.646a.5.5 0 0 1-.708.708l-.646-.647-.646.647a.5.5 0 0 1-.708-.708l.647-.646-.647-.646a.5.5 0 0 1 .708-.708Z"
                }
            }
        ]
    })(props);
}
function BsPersonFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3Zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                }
            }
        ]
    })(props);
}
function BsPersonGear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm.256 7a4.474 4.474 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10c.26 0 .507.009.74.025.226-.341.496-.65.804-.918C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4s1 1 1 1h5.256Zm3.63-4.54c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.045c-.613-.18-.613-1.048 0-1.229l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382l.045-.148ZM14 12.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z"
                }
            }
        ]
    })(props);
}
function BsPersonHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-9 8c0 1 1 1 1 1h10s1 0 1-1-1-4-6-4-6 3-6 4Zm13.5-8.09c1.387-1.425 4.855 1.07 0 4.277-4.854-3.207-1.387-5.702 0-4.276Z"
                }
            }
        ]
    })(props);
}
function BsPersonHearts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.5 1.246c.832-.855 2.913.642 0 2.566-2.913-1.924-.832-3.421 0-2.566ZM9 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-9 8c0 1 1 1 1 1h10s1 0 1-1-1-4-6-4-6 3-6 4Zm13.5-8.09c1.387-1.425 4.855 1.07 0 4.277-4.854-3.207-1.387-5.702 0-4.276ZM15 2.165c.555-.57 1.942.428 0 1.711-1.942-1.283-.555-2.281 0-1.71Z"
                }
            }
        ]
    })(props);
}
function BsPersonLinesFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2z"
                }
            }
        ]
    })(props);
}
function BsPersonLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 5.996V14H3s-1 0-1-1 1-4 6-4c.564 0 1.077.038 1.544.107a4.524 4.524 0 0 0-.803.918A10.46 10.46 0 0 0 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h5ZM9 13a1 1 0 0 1 1-1v-1a2 2 0 1 1 4 0v1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-2Zm3-3a1 1 0 0 0-1 1v1h2v-1a1 1 0 0 0-1-1Z"
                }
            }
        ]
    })(props);
}
function BsPersonPlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsPersonPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsPersonRaisedHand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6.207v9.043a.75.75 0 0 0 1.5 0V10.5a.5.5 0 0 1 1 0v4.75a.75.75 0 0 0 1.5 0v-8.5a.25.25 0 1 1 .5 0v2.5a.75.75 0 0 0 1.5 0V6.5a3 3 0 0 0-3-3H6.236a.998.998 0 0 1-.447-.106l-.33-.165A.83.83 0 0 1 5 2.488V.75a.75.75 0 0 0-1.5 0v2.083c0 .715.404 1.37 1.044 1.689L5.5 5c.32.32.5.754.5 1.207Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
                }
            }
        ]
    })(props);
}
function BsPersonRolodex(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9.05a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 1a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h.5a.5.5 0 0 0 .5-.5.5.5 0 0 1 1 0 .5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5.5.5 0 0 1 1 0 .5.5 0 0 0 .5.5h.5a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H6.707L6 1.293A1 1 0 0 0 5.293 1H1Zm0 1h4.293L6 2.707A1 1 0 0 0 6.707 3H15v10h-.085a1.5 1.5 0 0 0-2.4-.63C11.885 11.223 10.554 10 8 10c-2.555 0-3.886 1.224-4.514 2.37a1.5 1.5 0 0 0-2.4.63H1V2Z"
                }
            }
        ]
    })(props);
}
function BsPersonSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.879 10.414a2.501 2.501 0 0 0-3.465 3.465l3.465-3.465Zm.707.707-3.465 3.465a2.501 2.501 0 0 0 3.465-3.465Zm-4.56-1.096a3.5 3.5 0 1 1 4.949 4.95 3.5 3.5 0 0 1-4.95-4.95ZM11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm.256 7a4.474 4.474 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10c.26 0 .507.009.74.025.226-.341.496-.65.804-.918C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4s1 1 1 1h5.256Z"
                }
            }
        ]
    })(props);
}
function BsPersonSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm12 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1v-1c0-1-1-4-6-4s-6 3-6 4v1a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12z"
                }
            }
        ]
    })(props);
}
function BsPersonStandingDress(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm-.5 12.25V12h1v3.25a.75.75 0 0 0 1.5 0V12h1l-1-5v-.215a.285.285 0 0 1 .56-.078l.793 2.777a.711.711 0 1 0 1.364-.405l-1.065-3.461A3 3 0 0 0 8.784 3.5H7.216a3 3 0 0 0-2.868 2.118L3.283 9.079a.711.711 0 1 0 1.365.405l.793-2.777a.285.285 0 0 1 .56.078V7l-1 5h1v3.25a.75.75 0 0 0 1.5 0Z"
                }
            }
        ]
    })(props);
}
function BsPersonStanding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM6 6.75v8.5a.75.75 0 0 0 1.5 0V10.5a.5.5 0 0 1 1 0v4.75a.75.75 0 0 0 1.5 0v-8.5a.25.25 0 1 1 .5 0v2.5a.75.75 0 0 0 1.5 0V6.5a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v2.75a.75.75 0 0 0 1.5 0v-2.5a.25.25 0 0 1 .5 0Z"
                }
            }
        ]
    })(props);
}
function BsPersonUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.354-5.854 1.5 1.5a.5.5 0 0 1-.708.708L13 11.707V14.5a.5.5 0 0 1-1 0v-2.793l-.646.647a.5.5 0 0 1-.708-.708l1.5-1.5a.5.5 0 0 1 .708 0ZM11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.256 14a4.474 4.474 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10c.26 0 .507.009.74.025.226-.341.496-.65.804-.918C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4s1 1 1 1h5.256Z"
                }
            }
        ]
    })(props);
}
function BsPersonVcardFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm9 1.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5ZM9 8a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 0-1h-4A.5.5 0 0 0 9 8Zm1 2.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5Zm-1 2C9 10.567 7.21 9 5 9c-2.086 0-3.8 1.398-3.984 3.181A1 1 0 0 0 2 13h6.96c.026-.163.04-.33.04-.5ZM7 6a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z"
                }
            }
        ]
    })(props);
}
function BsPersonVcard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm4-2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM9 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4A.5.5 0 0 1 9 8Zm1 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2ZM1 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8.96c.026-.163.04-.33.04-.5C9 10.567 7.21 9 5 9c-2.086 0-3.8 1.398-3.984 3.181A1.006 1.006 0 0 1 1 12V4Z"
                }
            }
        ]
    })(props);
}
function BsPersonVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9.05a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2Zm10.798 11c-.453-1.27-1.76-3-4.798-3-3.037 0-4.345 1.73-4.798 3H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-1.202Z"
                }
            }
        ]
    })(props);
}
function BsPersonVideo2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9.05a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2ZM1 3a1 1 0 0 1 1-1h2v2H1V3Zm4 10V2h9a1 1 0 0 1 1 1v9c0 .285-.12.543-.31.725C14.15 11.494 12.822 10 10 10c-3.037 0-4.345 1.73-4.798 3H5Zm-4-2h3v2H2a1 1 0 0 1-1-1v-1Zm3-1H1V8h3v2Zm0-3H1V5h3v2Z"
                }
            }
        ]
    })(props);
}
function BsPersonVideo3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-6 5.7c0 .8.8.8.8.8h6.4s.8 0 .8-.8-.8-3.2-4-3.2-4 2.4-4 3.2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h5.243c.122-.326.295-.668.526-1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v7.81c.353.23.656.496.91.783.059-.187.09-.386.09-.593V4a2 2 0 0 0-2-2H2Z"
                }
            }
        ]
    })(props);
}
function BsPersonWalking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM6.44 3.752A.75.75 0 0 1 7 3.5h1.445c.742 0 1.32.643 1.243 1.38l-.43 4.083a1.75 1.75 0 0 1-.088.395l-.318.906.213.242a.75.75 0 0 1 .114.175l2 4.25a.75.75 0 1 1-1.357.638l-1.956-4.154-1.68-1.921A.75.75 0 0 1 6 8.96l.138-2.613-.435.489-.464 2.786a.75.75 0 1 1-1.48-.246l.5-3a.75.75 0 0 1 .18-.375l2-2.25Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.25 11.745v-1.418l1.204 1.375.261.524a.75.75 0 0 1-.12.231l-2.5 3.25a.75.75 0 1 1-1.19-.914l2.345-3.048Zm4.22-4.215-.494-.494.205-1.843a1.93 1.93 0 0 0 .006-.067l1.124 1.124h1.44a.75.75 0 0 1 0 1.5H11a.75.75 0 0 1-.531-.22Z"
                }
            }
        ]
    })(props);
}
function BsPersonWheelchair(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm-.663 2.146a1.5 1.5 0 0 0-.47-2.115l-2.5-1.508a1.5 1.5 0 0 0-1.676.086l-2.329 1.75a.866.866 0 0 0 1.051 1.375L7.361 3.37l.922.71-2.038 2.445A4.732 4.732 0 0 0 2.628 7.67l1.064 1.065a3.25 3.25 0 0 1 4.574 4.574l1.064 1.063a4.732 4.732 0 0 0 1.09-3.998l1.043-.292-.187 2.991a.872.872 0 1 0 1.741.098l.206-4.121A1 1 0 0 0 12.224 8h-2.79l1.903-2.854ZM3.023 9.48a3.25 3.25 0 0 0 4.496 4.496l1.077 1.077a4.75 4.75 0 0 1-6.65-6.65l1.077 1.078Z"
                }
            }
        ]
    })(props);
}
function BsPersonWorkspace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 16s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H4Zm4-5.95a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a2 2 0 0 0-2 2v9.5A1.5 1.5 0 0 0 1.5 14h.653a5.373 5.373 0 0 1 1.066-2H1V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v9h-2.219c.554.654.89 1.373 1.066 2h.653a1.5 1.5 0 0 0 1.5-1.5V3a2 2 0 0 0-2-2H2Z"
                }
            }
        ]
    })(props);
}
function BsPersonXFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm6.146-2.854a.5.5 0 0 1 .708 0L14 6.293l1.146-1.147a.5.5 0 0 1 .708.708L14.707 7l1.147 1.146a.5.5 0 0 1-.708.708L14 7.707l-1.146 1.147a.5.5 0 0 1-.708-.708L13.293 7l-1.147-1.146a.5.5 0 0 1 0-.708z"
                }
            }
        ]
    })(props);
}
function BsPersonX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm.256 7a4.474 4.474 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10c.26 0 .507.009.74.025.226-.341.496-.65.804-.918C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4s1 1 1 1h5.256Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-.646-4.854.646.647.646-.647a.5.5 0 0 1 .708.708l-.647.646.647.646a.5.5 0 0 1-.708.708l-.646-.647-.646.647a.5.5 0 0 1-.708-.708l.647-.646-.647-.646a.5.5 0 0 1 .708-.708Z"
                }
            }
        ]
    })(props);
}
function BsPerson(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z"
                }
            }
        ]
    })(props);
}
function BsPhoneFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V2zm6 11a1 1 0 1 0-2 0 1 1 0 0 0 2 0z"
                }
            }
        ]
    })(props);
}
function BsPhoneFlip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11 1H5a1 1 0 0 0-1 1v6a.5.5 0 0 1-1 0V2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v6a.5.5 0 0 1-1 0V2a1 1 0 0 0-1-1Zm1 13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2a.5.5 0 0 0-1 0v2a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2a.5.5 0 0 0-1 0v2ZM1.713 7.954a.5.5 0 1 0-.419-.908c-.347.16-.654.348-.882.57C.184 7.842 0 8.139 0 8.5c0 .546.408.94.823 1.201.44.278 1.043.51 1.745.696C3.978 10.773 5.898 11 8 11c.099 0 .197 0 .294-.002l-1.148 1.148a.5.5 0 0 0 .708.708l2-2a.5.5 0 0 0 0-.708l-2-2a.5.5 0 1 0-.708.708l1.145 1.144L8 10c-2.04 0-3.87-.221-5.174-.569-.656-.175-1.151-.374-1.47-.575C1.012 8.639 1 8.506 1 8.5c0-.003 0-.059.112-.17.115-.112.31-.242.6-.376Zm12.993-.908a.5.5 0 0 0-.419.908c.292.134.486.264.6.377.113.11.113.166.113.169 0 .003 0 .065-.13.187-.132.122-.352.26-.677.4-.645.28-1.596.523-2.763.687a.5.5 0 0 0 .14.99c1.212-.17 2.26-.43 3.02-.758.38-.164.713-.357.96-.587.246-.229.45-.537.45-.919 0-.362-.184-.66-.412-.883-.228-.223-.535-.411-.882-.571ZM7.5 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Z"
                }
            }
        ]
    })(props);
}
function BsPhoneLandscapeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12.5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H2zm11-6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
                }
            }
        ]
    })(props);
}
function BsPhoneLandscape(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 4.5a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-6zm-1 6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7.5a1 1 0 1 0-2 0 1 1 0 0 0 2 0z"
                }
            }
        ]
    })(props);
}
function BsPhoneVibrateFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4zm5 7a1 1 0 1 0-2 0 1 1 0 0 0 2 0zM1.807 4.734a.5.5 0 1 0-.884-.468A7.967 7.967 0 0 0 0 8c0 1.347.334 2.618.923 3.734a.5.5 0 1 0 .884-.468A6.967 6.967 0 0 1 1 8c0-1.18.292-2.292.807-3.266zm13.27-.468a.5.5 0 0 0-.884.468C14.708 5.708 15 6.819 15 8c0 1.18-.292 2.292-.807 3.266a.5.5 0 0 0 .884.468A7.967 7.967 0 0 0 16 8a7.967 7.967 0 0 0-.923-3.734zM3.34 6.182a.5.5 0 1 0-.93-.364A5.986 5.986 0 0 0 2 8c0 .769.145 1.505.41 2.182a.5.5 0 1 0 .93-.364A4.986 4.986 0 0 1 3 8c0-.642.12-1.255.34-1.818zm10.25-.364a.5.5 0 0 0-.93.364c.22.563.34 1.176.34 1.818 0 .642-.12 1.255-.34 1.818a.5.5 0 0 0 .93.364C13.856 9.505 14 8.769 14 8c0-.769-.145-1.505-.41-2.182z"
                }
            }
        ]
    })(props);
}
function BsPhoneVibrate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4zM6 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM1.599 4.058a.5.5 0 0 1 .208.676A6.967 6.967 0 0 0 1 8c0 1.18.292 2.292.807 3.266a.5.5 0 0 1-.884.468A7.968 7.968 0 0 1 0 8c0-1.347.334-2.619.923-3.734a.5.5 0 0 1 .676-.208zm12.802 0a.5.5 0 0 1 .676.208A7.967 7.967 0 0 1 16 8a7.967 7.967 0 0 1-.923 3.734.5.5 0 0 1-.884-.468A6.967 6.967 0 0 0 15 8c0-1.18-.292-2.292-.807-3.266a.5.5 0 0 1 .208-.676zM3.057 5.534a.5.5 0 0 1 .284.648A4.986 4.986 0 0 0 3 8c0 .642.12 1.255.34 1.818a.5.5 0 1 1-.93.364A5.986 5.986 0 0 1 2 8c0-.769.145-1.505.41-2.182a.5.5 0 0 1 .647-.284zm9.886 0a.5.5 0 0 1 .648.284C13.855 6.495 14 7.231 14 8c0 .769-.145 1.505-.41 2.182a.5.5 0 0 1-.93-.364C12.88 9.255 13 8.642 13 8c0-.642-.12-1.255-.34-1.818a.5.5 0 0 1 .283-.648z"
                }
            }
        ]
    })(props);
}
function BsPhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                }
            }
        ]
    })(props);
}
function BsPieChartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.985 8.5H8.207l-5.5 5.5a8 8 0 0 0 13.277-5.5zM2 13.292A8 8 0 0 1 7.5.015v7.778l-5.5 5.5zM8.5.015V7.5h7.485A8.001 8.001 0 0 0 8.5.015z"
                }
            }
        ]
    })(props);
}
function BsPieChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 1.018a7 7 0 0 0-4.79 11.566L7.5 7.793V1.018zm1 0V7.5h6.482A7.001 7.001 0 0 0 8.5 1.018zM14.982 8.5H8.207l-4.79 4.79A7 7 0 0 0 14.982 8.5zM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8z"
                }
            }
        ]
    })(props);
}
function BsPiggyBankFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.964 1.527c-2.977 0-5.571 1.704-6.32 4.125h-.55A1 1 0 0 0 .11 6.824l.254 1.46a1.5 1.5 0 0 0 1.478 1.243h.263c.3.513.688.978 1.145 1.382l-.729 2.477a.5.5 0 0 0 .48.641h2a.5.5 0 0 0 .471-.332l.482-1.351c.635.173 1.31.267 2.011.267.707 0 1.388-.095 2.028-.272l.543 1.372a.5.5 0 0 0 .465.316h2a.5.5 0 0 0 .478-.645l-.761-2.506C13.81 9.895 14.5 8.559 14.5 7.069c0-.145-.007-.29-.02-.431.261-.11.508-.266.705-.444.315.306.815.306.815-.417 0 .223-.5.223-.461-.026a.95.95 0 0 0 .09-.255.7.7 0 0 0-.202-.645.58.58 0 0 0-.707-.098.735.735 0 0 0-.375.562c-.024.243.082.48.32.654a2.112 2.112 0 0 1-.259.153c-.534-2.664-3.284-4.595-6.442-4.595Zm7.173 3.876a.565.565 0 0 1-.098.21.704.704 0 0 1-.044-.025c-.146-.09-.157-.175-.152-.223a.236.236 0 0 1 .117-.173c.049-.027.08-.021.113.012a.202.202 0 0 1 .064.199Zm-8.999-.65a.5.5 0 1 1-.276-.96A7.613 7.613 0 0 1 7.964 3.5c.763 0 1.497.11 2.18.315a.5.5 0 1 1-.287.958A6.602 6.602 0 0 0 7.964 4.5c-.64 0-1.255.09-1.826.254ZM5 6.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
                }
            }
        ]
    })(props);
}
function BsPiggyBank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 6.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm1.138-1.496A6.613 6.613 0 0 1 7.964 4.5c.666 0 1.303.097 1.893.273a.5.5 0 0 0 .286-.958A7.602 7.602 0 0 0 7.964 3.5c-.734 0-1.441.103-2.102.292a.5.5 0 1 0 .276.962z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.964 1.527c-2.977 0-5.571 1.704-6.32 4.125h-.55A1 1 0 0 0 .11 6.824l.254 1.46a1.5 1.5 0 0 0 1.478 1.243h.263c.3.513.688.978 1.145 1.382l-.729 2.477a.5.5 0 0 0 .48.641h2a.5.5 0 0 0 .471-.332l.482-1.351c.635.173 1.31.267 2.011.267.707 0 1.388-.095 2.028-.272l.543 1.372a.5.5 0 0 0 .465.316h2a.5.5 0 0 0 .478-.645l-.761-2.506C13.81 9.895 14.5 8.559 14.5 7.069c0-.145-.007-.29-.02-.431.261-.11.508-.266.705-.444.315.306.815.306.815-.417 0 .223-.5.223-.461-.026a.95.95 0 0 0 .09-.255.7.7 0 0 0-.202-.645.58.58 0 0 0-.707-.098.735.735 0 0 0-.375.562c-.024.243.082.48.32.654a2.112 2.112 0 0 1-.259.153c-.534-2.664-3.284-4.595-6.442-4.595zM2.516 6.26c.455-2.066 2.667-3.733 5.448-3.733 3.146 0 5.536 2.114 5.536 4.542 0 1.254-.624 2.41-1.67 3.248a.5.5 0 0 0-.165.535l.66 2.175h-.985l-.59-1.487a.5.5 0 0 0-.629-.288c-.661.23-1.39.359-2.157.359a6.558 6.558 0 0 1-2.157-.359.5.5 0 0 0-.635.304l-.525 1.471h-.979l.633-2.15a.5.5 0 0 0-.17-.534 4.649 4.649 0 0 1-1.284-1.541.5.5 0 0 0-.446-.275h-.56a.5.5 0 0 1-.492-.414l-.254-1.46h.933a.5.5 0 0 0 .488-.393zm12.621-.857a.565.565 0 0 1-.098.21.704.704 0 0 1-.044-.025c-.146-.09-.157-.175-.152-.223a.236.236 0 0 1 .117-.173c.049-.027.08-.021.113.012a.202.202 0 0 1 .064.199z"
                }
            }
        ]
    })(props);
}
function BsPinAngleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.828.722a.5.5 0 0 1 .354.146l4.95 4.95a.5.5 0 0 1 0 .707c-.48.48-1.072.588-1.503.588-.177 0-.335-.018-.46-.039l-3.134 3.134a5.927 5.927 0 0 1 .16 1.013c.046.702-.032 1.687-.72 2.375a.5.5 0 0 1-.707 0l-2.829-2.828-3.182 3.182c-.195.195-1.219.902-1.414.707-.195-.195.512-1.22.707-1.414l3.182-3.182-2.828-2.829a.5.5 0 0 1 0-.707c.688-.688 1.673-.767 2.375-.72a5.922 5.922 0 0 1 1.013.16l3.134-3.133a2.772 2.772 0 0 1-.04-.461c0-.43.108-1.022.589-1.503a.5.5 0 0 1 .353-.146z"
                }
            }
        ]
    })(props);
}
function BsPinAngle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.828.722a.5.5 0 0 1 .354.146l4.95 4.95a.5.5 0 0 1 0 .707c-.48.48-1.072.588-1.503.588-.177 0-.335-.018-.46-.039l-3.134 3.134a5.927 5.927 0 0 1 .16 1.013c.046.702-.032 1.687-.72 2.375a.5.5 0 0 1-.707 0l-2.829-2.828-3.182 3.182c-.195.195-1.219.902-1.414.707-.195-.195.512-1.22.707-1.414l3.182-3.182-2.828-2.829a.5.5 0 0 1 0-.707c.688-.688 1.673-.767 2.375-.72a5.922 5.922 0 0 1 1.013.16l3.134-3.133a2.772 2.772 0 0 1-.04-.461c0-.43.108-1.022.589-1.503a.5.5 0 0 1 .353-.146zm.122 2.112v-.002.002zm0-.002v.002a.5.5 0 0 1-.122.51L6.293 6.878a.5.5 0 0 1-.511.12H5.78l-.014-.004a4.507 4.507 0 0 0-.288-.076 4.922 4.922 0 0 0-.765-.116c-.422-.028-.836.008-1.175.15l5.51 5.509c.141-.34.177-.753.149-1.175a4.924 4.924 0 0 0-.192-1.054l-.004-.013v-.001a.5.5 0 0 1 .12-.512l3.536-3.535a.5.5 0 0 1 .532-.115l.096.022c.087.017.208.034.344.034.114 0 .23-.011.343-.04L9.927 2.028c-.029.113-.04.23-.04.343a1.779 1.779 0 0 0 .062.46z"
                }
            }
        ]
    })(props);
}
function BsPinFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.146.146A.5.5 0 0 1 4.5 0h7a.5.5 0 0 1 .5.5c0 .68-.342 1.174-.646 1.479-.126.125-.25.224-.354.298v4.431l.078.048c.203.127.476.314.751.555C12.36 7.775 13 8.527 13 9.5a.5.5 0 0 1-.5.5h-4v4.5c0 .276-.224 1.5-.5 1.5s-.5-1.224-.5-1.5V10h-4a.5.5 0 0 1-.5-.5c0-.973.64-1.725 1.17-2.189A5.921 5.921 0 0 1 5 6.708V2.277a2.77 2.77 0 0 1-.354-.298C4.342 1.674 4 1.179 4 .5a.5.5 0 0 1 .146-.354z"
                }
            }
        ]
    })(props);
}
function BsPinMapFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.1 11.2a.5.5 0 0 1 .4-.2H6a.5.5 0 0 1 0 1H3.75L1.5 15h13l-2.25-3H10a.5.5 0 0 1 0-1h2.5a.5.5 0 0 1 .4.2l3 4a.5.5 0 0 1-.4.8H.5a.5.5 0 0 1-.4-.8l3-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999z"
                }
            }
        ]
    })(props);
}
function BsPinMap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.1 11.2a.5.5 0 0 1 .4-.2H6a.5.5 0 0 1 0 1H3.75L1.5 15h13l-2.25-3H10a.5.5 0 0 1 0-1h2.5a.5.5 0 0 1 .4.2l3 4a.5.5 0 0 1-.4.8H.5a.5.5 0 0 1-.4-.8l3-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999z"
                }
            }
        ]
    })(props);
}
function BsPin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.146.146A.5.5 0 0 1 4.5 0h7a.5.5 0 0 1 .5.5c0 .68-.342 1.174-.646 1.479-.126.125-.25.224-.354.298v4.431l.078.048c.203.127.476.314.751.555C12.36 7.775 13 8.527 13 9.5a.5.5 0 0 1-.5.5h-4v4.5c0 .276-.224 1.5-.5 1.5s-.5-1.224-.5-1.5V10h-4a.5.5 0 0 1-.5-.5c0-.973.64-1.725 1.17-2.189A5.921 5.921 0 0 1 5 6.708V2.277a2.77 2.77 0 0 1-.354-.298C4.342 1.674 4 1.179 4 .5a.5.5 0 0 1 .146-.354zm1.58 1.408-.002-.001.002.001zm-.002-.001.002.001A.5.5 0 0 1 6 2v5a.5.5 0 0 1-.276.447h-.002l-.012.007-.054.03a4.922 4.922 0 0 0-.827.58c-.318.278-.585.596-.725.936h7.792c-.14-.34-.407-.658-.725-.936a4.915 4.915 0 0 0-.881-.61l-.012-.006h-.002A.5.5 0 0 1 10 7V2a.5.5 0 0 1 .295-.458 1.775 1.775 0 0 0 .351-.271c.08-.08.155-.17.214-.271H5.14c.06.1.133.191.214.271a1.78 1.78 0 0 0 .37.282z"
                }
            }
        ]
    })(props);
}
function BsPinterest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a8 8 0 0 0-2.915 15.452c-.07-.633-.134-1.606.027-2.297.146-.625.938-3.977.938-3.977s-.239-.479-.239-1.187c0-1.113.645-1.943 1.448-1.943.682 0 1.012.512 1.012 1.127 0 .686-.437 1.712-.663 2.663-.188.796.4 1.446 1.185 1.446 1.422 0 2.515-1.5 2.515-3.664 0-1.915-1.377-3.254-3.342-3.254-2.276 0-3.612 1.707-3.612 3.471 0 .688.265 1.425.595 1.826a.24.24 0 0 1 .056.23c-.061.252-.196.796-.222.907-.035.146-.116.177-.268.107-1-.465-1.624-1.926-1.624-3.1 0-2.523 1.834-4.84 5.286-4.84 2.775 0 4.932 1.977 4.932 4.62 0 2.757-1.739 4.976-4.151 4.976-.811 0-1.573-.421-1.834-.919l-.498 1.902c-.181.695-.669 1.566-.995 2.097A8 8 0 1 0 8 0z"
                }
            }
        ]
    })(props);
}
function BsPipFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 2A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13zm7 6h5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsPip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3.5A1.5 1.5 0 0 1 1.5 2h13A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5v-9zM1.5 3a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-3z"
                }
            }
        ]
    })(props);
}
function BsPlayBtnFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm6.79-6.907A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z"
                }
            }
        ]
    })(props);
}
function BsPlayBtn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"
                }
            }
        ]
    })(props);
}
function BsPlayCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z"
                }
            }
        ]
    })(props);
}
function BsPlayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445z"
                }
            }
        ]
    })(props);
}
function BsPlayFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"
                }
            }
        ]
    })(props);
}
function BsPlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.804 8 5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z"
                }
            }
        ]
    })(props);
}
function BsPlaystation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.858 11.451c-.313.395-1.079.676-1.079.676l-5.696 2.046v-1.509l4.192-1.493c.476-.17.549-.412.162-.538-.386-.127-1.085-.09-1.56.08l-2.794.984v-1.566l.161-.054s.807-.286 1.942-.412c1.135-.125 2.525.017 3.616.43 1.23.39 1.368.962 1.056 1.356ZM9.625 8.883v-3.86c0-.453-.083-.87-.508-.988-.326-.105-.528.198-.528.65v9.664l-2.606-.827V2c1.108.206 2.722.692 3.59.985 2.207.757 2.955 1.7 2.955 3.825 0 2.071-1.278 2.856-2.903 2.072Zm-8.424 3.625C-.061 12.15-.271 11.41.304 10.984c.532-.394 1.436-.69 1.436-.69l3.737-1.33v1.515l-2.69.963c-.474.17-.547.411-.161.538.386.126 1.085.09 1.56-.08l1.29-.469v1.356l-.257.043a8.454 8.454 0 0 1-4.018-.323Z"
                }
            }
        ]
    })(props);
}
function BsPlugFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 0a.5.5 0 0 1 .5.5V3h3V.5a.5.5 0 0 1 1 0V3h1a.5.5 0 0 1 .5.5v3A3.5 3.5 0 0 1 8.5 10c-.002.434-.01.845-.04 1.22-.041.514-.126 1.003-.317 1.424a2.083 2.083 0 0 1-.97 1.028C6.725 13.9 6.169 14 5.5 14c-.998 0-1.61.33-1.974.718A1.922 1.922 0 0 0 3 16H2c0-.616.232-1.367.797-1.968C3.374 13.42 4.261 13 5.5 13c.581 0 .962-.088 1.218-.219.241-.123.4-.3.514-.55.121-.266.193-.621.23-1.09.027-.34.035-.718.037-1.141A3.5 3.5 0 0 1 4 6.5v-3a.5.5 0 0 1 .5-.5h1V.5A.5.5 0 0 1 6 0z"
                }
            }
        ]
    })(props);
}
function BsPlug(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 0a.5.5 0 0 1 .5.5V3h3V.5a.5.5 0 0 1 1 0V3h1a.5.5 0 0 1 .5.5v3A3.5 3.5 0 0 1 8.5 10c-.002.434-.01.845-.04 1.22-.041.514-.126 1.003-.317 1.424a2.083 2.083 0 0 1-.97 1.028C6.725 13.9 6.169 14 5.5 14c-.998 0-1.61.33-1.974.718A1.922 1.922 0 0 0 3 16H2c0-.616.232-1.367.797-1.968C3.374 13.42 4.261 13 5.5 13c.581 0 .962-.088 1.218-.219.241-.123.4-.3.514-.55.121-.266.193-.621.23-1.09.027-.34.035-.718.037-1.141A3.5 3.5 0 0 1 4 6.5v-3a.5.5 0 0 1 .5-.5h1V.5A.5.5 0 0 1 6 0zM5 4v2.5A2.5 2.5 0 0 0 7.5 9h1A2.5 2.5 0 0 0 11 6.5V4H5z"
                }
            }
        ]
    })(props);
}
function BsPlugin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1 8a7 7 0 1 1 2.898 5.673c-.167-.121-.216-.406-.002-.62l1.8-1.8a3.5 3.5 0 0 0 4.572-.328l1.414-1.415a.5.5 0 0 0 0-.707l-.707-.707 1.559-1.563a.5.5 0 1 0-.708-.706l-1.559 1.562-1.414-1.414 1.56-1.562a.5.5 0 1 0-.707-.706l-1.56 1.56-.707-.706a.5.5 0 0 0-.707 0L5.318 5.975a3.5 3.5 0 0 0-.328 4.571l-1.8 1.8c-.58.58-.62 1.6.121 2.137A8 8 0 1 0 0 8a.5.5 0 0 0 1 0Z"
                }
            }
        ]
    })(props);
}
function BsPlusCircleDotted(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-.176 0-.35.006-.523.017l.064.998a7.117 7.117 0 0 1 .918 0l.064-.998A8.113 8.113 0 0 0 8 0zM6.44.152c-.346.069-.684.16-1.012.27l.321.948c.287-.098.582-.177.884-.237L6.44.153zm4.132.271a7.946 7.946 0 0 0-1.011-.27l-.194.98c.302.06.597.14.884.237l.321-.947zm1.873.925a8 8 0 0 0-.906-.524l-.443.896c.275.136.54.29.793.459l.556-.831zM4.46.824c-.314.155-.616.33-.905.524l.556.83a7.07 7.07 0 0 1 .793-.458L4.46.824zM2.725 1.985c-.262.23-.51.478-.74.74l.752.66c.202-.23.418-.446.648-.648l-.66-.752zm11.29.74a8.058 8.058 0 0 0-.74-.74l-.66.752c.23.202.447.418.648.648l.752-.66zm1.161 1.735a7.98 7.98 0 0 0-.524-.905l-.83.556c.169.253.322.518.458.793l.896-.443zM1.348 3.555c-.194.289-.37.591-.524.906l.896.443c.136-.275.29-.54.459-.793l-.831-.556zM.423 5.428a7.945 7.945 0 0 0-.27 1.011l.98.194c.06-.302.14-.597.237-.884l-.947-.321zM15.848 6.44a7.943 7.943 0 0 0-.27-1.012l-.948.321c.098.287.177.582.237.884l.98-.194zM.017 7.477a8.113 8.113 0 0 0 0 1.046l.998-.064a7.117 7.117 0 0 1 0-.918l-.998-.064zM16 8a8.1 8.1 0 0 0-.017-.523l-.998.064a7.11 7.11 0 0 1 0 .918l.998.064A8.1 8.1 0 0 0 16 8zM.152 9.56c.069.346.16.684.27 1.012l.948-.321a6.944 6.944 0 0 1-.237-.884l-.98.194zm15.425 1.012c.112-.328.202-.666.27-1.011l-.98-.194c-.06.302-.14.597-.237.884l.947.321zM.824 11.54a8 8 0 0 0 .524.905l.83-.556a6.999 6.999 0 0 1-.458-.793l-.896.443zm13.828.905c.194-.289.37-.591.524-.906l-.896-.443c-.136.275-.29.54-.459.793l.831.556zm-12.667.83c.23.262.478.51.74.74l.66-.752a7.047 7.047 0 0 1-.648-.648l-.752.66zm11.29.74c.262-.23.51-.478.74-.74l-.752-.66c-.201.23-.418.447-.648.648l.66.752zm-1.735 1.161c.314-.155.616-.33.905-.524l-.556-.83a7.07 7.07 0 0 1-.793.458l.443.896zm-7.985-.524c.289.194.591.37.906.524l.443-.896a6.998 6.998 0 0 1-.793-.459l-.556.831zm1.873.925c.328.112.666.202 1.011.27l.194-.98a6.953 6.953 0 0 1-.884-.237l-.321.947zm4.132.271a7.944 7.944 0 0 0 1.012-.27l-.321-.948a6.954 6.954 0 0 1-.884.237l.194.98zm-2.083.135a8.1 8.1 0 0 0 1.046 0l-.064-.998a7.11 7.11 0 0 1-.918 0l-.064.998zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z"
                }
            }
        ]
    })(props);
}
function BsPlusCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z"
                }
            }
        ]
    })(props);
}
function BsPlusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
                }
            }
        ]
    })(props);
}
function BsPlusLg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"
                }
            }
        ]
    })(props);
}
function BsPlusSlashMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m1.854 14.854 13-13a.5.5 0 0 0-.708-.708l-13 13a.5.5 0 0 0 .708.708ZM4 1a.5.5 0 0 1 .5.5v2h2a.5.5 0 0 1 0 1h-2v2a.5.5 0 0 1-1 0v-2h-2a.5.5 0 0 1 0-1h2v-2A.5.5 0 0 1 4 1Zm5 11a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5A.5.5 0 0 1 9 12Z"
                }
            }
        ]
    })(props);
}
function BsPlusSquareDotted(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 0c-.166 0-.33.016-.487.048l.194.98A1.51 1.51 0 0 1 2.5 1h.458V0H2.5zm2.292 0h-.917v1h.917V0zm1.833 0h-.917v1h.917V0zm1.833 0h-.916v1h.916V0zm1.834 0h-.917v1h.917V0zm1.833 0h-.917v1h.917V0zM13.5 0h-.458v1h.458c.1 0 .199.01.293.029l.194-.981A2.51 2.51 0 0 0 13.5 0zm2.079 1.11a2.511 2.511 0 0 0-.69-.689l-.556.831c.164.11.305.251.415.415l.83-.556zM1.11.421a2.511 2.511 0 0 0-.689.69l.831.556c.11-.164.251-.305.415-.415L1.11.422zM16 2.5c0-.166-.016-.33-.048-.487l-.98.194c.018.094.028.192.028.293v.458h1V2.5zM.048 2.013A2.51 2.51 0 0 0 0 2.5v.458h1V2.5c0-.1.01-.199.029-.293l-.981-.194zM0 3.875v.917h1v-.917H0zm16 .917v-.917h-1v.917h1zM0 5.708v.917h1v-.917H0zm16 .917v-.917h-1v.917h1zM0 7.542v.916h1v-.916H0zm15 .916h1v-.916h-1v.916zM0 9.375v.917h1v-.917H0zm16 .917v-.917h-1v.917h1zm-16 .916v.917h1v-.917H0zm16 .917v-.917h-1v.917h1zm-16 .917v.458c0 .166.016.33.048.487l.98-.194A1.51 1.51 0 0 1 1 13.5v-.458H0zm16 .458v-.458h-1v.458c0 .1-.01.199-.029.293l.981.194c.032-.158.048-.32.048-.487zM.421 14.89c.183.272.417.506.69.689l.556-.831a1.51 1.51 0 0 1-.415-.415l-.83.556zm14.469.689c.272-.183.506-.417.689-.69l-.831-.556c-.11.164-.251.305-.415.415l.556.83zm-12.877.373c.158.032.32.048.487.048h.458v-1H2.5c-.1 0-.199-.01-.293-.029l-.194.981zM13.5 16c.166 0 .33-.016.487-.048l-.194-.98A1.51 1.51 0 0 1 13.5 15h-.458v1h.458zm-9.625 0h.917v-1h-.917v1zm1.833 0h.917v-1h-.917v1zm1.834-1v1h.916v-1h-.916zm1.833 1h.917v-1h-.917v1zm1.833 0h.917v-1h-.917v1zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z"
                }
            }
        ]
    })(props);
}
function BsPlusSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsPlusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
                }
            }
        ]
    })(props);
}
function BsPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
                }
            }
        ]
    })(props);
}
function BsPostageFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 3a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-7Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 1a1 1 0 0 0 1-1h1a1 1 0 0 0 2 0h1a1 1 0 0 0 2 0h1a1 1 0 1 0 2 0H15v1a1 1 0 1 0 0 2v1a1 1 0 1 0 0 2v1a1 1 0 1 0 0 2v1a1 1 0 1 0 0 2v1a1 1 0 1 0 0 2v1h-1.5a1 1 0 1 0-2 0h-1a1 1 0 1 0-2 0h-1a1 1 0 1 0-2 0h-1a1 1 0 1 0-2 0H1v-1a1 1 0 1 0 0-2v-1a1 1 0 1 0 0-2V9a1 1 0 1 0 0-2V6a1 1 0 0 0 0-2V3a1 1 0 0 0 0-2V0h1.5a1 1 0 0 0 1 1ZM3 3v10a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1Z"
                }
            }
        ]
    })(props);
}
function BsPostageHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 3a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-7ZM8 11C2.175 7.236 6.336 4.31 8 5.982 9.664 4.309 13.825 7.236 8 11Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 0a1 1 0 0 1-2 0H1v1a1 1 0 0 1 0 2v1a1 1 0 0 1 0 2v1a1 1 0 0 1 0 2v1a1 1 0 1 1 0 2v1a1 1 0 1 1 0 2v1h1.5a1 1 0 1 1 2 0h1a1 1 0 1 1 2 0h1a1 1 0 1 1 2 0h1a1 1 0 1 1 2 0H15v-1a1 1 0 1 1 0-2v-1a1 1 0 1 1 0-2V9a1 1 0 1 1 0-2V6a1 1 0 1 1 0-2V3a1 1 0 1 1 0-2V0h-1.5a1 1 0 1 1-2 0h-1a1 1 0 1 1-2 0h-1a1 1 0 0 1-2 0h-1ZM4 14a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4Z"
                }
            }
        ]
    })(props);
}
function BsPostageHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 1a1 1 0 0 0 1-1h1a1 1 0 0 0 2 0h1a1 1 0 0 0 2 0h1a1 1 0 1 0 2 0H15v1a1 1 0 1 0 0 2v1a1 1 0 1 0 0 2v1a1 1 0 1 0 0 2v1a1 1 0 1 0 0 2v1a1 1 0 1 0 0 2v1h-1.5a1 1 0 1 0-2 0h-1a1 1 0 1 0-2 0h-1a1 1 0 1 0-2 0h-1a1 1 0 1 0-2 0H1v-1a1 1 0 1 0 0-2v-1a1 1 0 1 0 0-2V9a1 1 0 1 0 0-2V6a1 1 0 0 0 0-2V3a1 1 0 0 0 0-2V0h1.5a1 1 0 0 0 1 1ZM3 3v10a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11C2.175 7.236 6.336 4.31 8 5.982 9.664 4.309 13.825 7.236 8 11Z"
                }
            }
        ]
    })(props);
}
function BsPostage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.75 3a.75.75 0 0 0-.75.75v8.5c0 .414.336.75.75.75h6.5a.75.75 0 0 0 .75-.75v-8.5a.75.75 0 0 0-.75-.75h-6.5ZM11 12H5V4h6v8Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 1a1 1 0 0 0 1-1h1a1 1 0 0 0 2 0h1a1 1 0 0 0 2 0h1a1 1 0 1 0 2 0H15v1a1 1 0 1 0 0 2v1a1 1 0 1 0 0 2v1a1 1 0 1 0 0 2v1a1 1 0 1 0 0 2v1a1 1 0 1 0 0 2v1h-1.5a1 1 0 1 0-2 0h-1a1 1 0 1 0-2 0h-1a1 1 0 1 0-2 0h-1a1 1 0 1 0-2 0H1v-1a1 1 0 1 0 0-2v-1a1 1 0 1 0 0-2V9a1 1 0 1 0 0-2V6a1 1 0 0 0 0-2V3a1 1 0 0 0 0-2V0h1.5a1 1 0 0 0 1 1ZM3 3v10a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1Z"
                }
            }
        ]
    })(props);
}
function BsPostcardFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8h2V6h-2v2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm8.5.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7ZM2 5.5a.5.5 0 0 0 .5.5H6a.5.5 0 0 0 0-1H2.5a.5.5 0 0 0-.5.5ZM2.5 7a.5.5 0 0 0 0 1H6a.5.5 0 0 0 0-1H2.5ZM2 9.5a.5.5 0 0 0 .5.5H6a.5.5 0 0 0 0-1H2.5a.5.5 0 0 0-.5.5Zm8-4v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5Z"
                }
            }
        ]
    })(props);
}
function BsPostcardHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2Zm6 2.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0Zm3.5.878c1.482-1.42 4.795 1.392 0 4.622-4.795-3.23-1.482-6.043 0-4.622ZM2 5.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm0 2a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm0 2a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Z"
                }
            }
        ]
    })(props);
}
function BsPostcardHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7Zm3.5.878c1.482-1.42 4.795 1.392 0 4.622-4.795-3.23-1.482-6.043 0-4.622ZM2.5 5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2Z"
                }
            }
        ]
    })(props);
}
function BsPostcard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2ZM1 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4Zm7.5.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7ZM2 5.5a.5.5 0 0 1 .5-.5H6a.5.5 0 0 1 0 1H2.5a.5.5 0 0 1-.5-.5Zm0 2a.5.5 0 0 1 .5-.5H6a.5.5 0 0 1 0 1H2.5a.5.5 0 0 1-.5-.5Zm0 2a.5.5 0 0 1 .5-.5H6a.5.5 0 0 1 0 1H2.5a.5.5 0 0 1-.5-.5ZM10.5 5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3ZM13 8h-2V6h2v2Z"
                }
            }
        ]
    })(props);
}
function BsPower(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 1v7h1V1h-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 8.812a4.999 4.999 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812z"
                }
            }
        ]
    })(props);
}
function BsPrescription(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 6a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0V9h.293l2 2-1.147 1.146a.5.5 0 0 0 .708.708L9 11.707l1.146 1.147a.5.5 0 0 0 .708-.708L9.707 11l1.147-1.146a.5.5 0 0 0-.708-.708L9 10.293 7.695 8.987A1.5 1.5 0 0 0 7.5 6h-2ZM6 7h1.5a.5.5 0 0 1 0 1H6V7Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v10.5a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 3 14.5V4a1 1 0 0 1-1-1V1Zm2 3v10.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V4H4ZM3 3h10V1H3v2Z"
                }
            }
        ]
    })(props);
}
function BsPrescription2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 6h2v2h2v2H9v2H7v-2H5V8h2V6Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v10.5a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 3 14.5V4a1 1 0 0 1-1-1V1Zm2 3v10.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V4H4ZM3 3h10V1H3v2Z"
                }
            }
        ]
    })(props);
}
function BsPrinterFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2H5zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2V7zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"
                }
            }
        ]
    })(props);
}
function BsPrinter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z"
                }
            }
        ]
    })(props);
}
function BsProjectorFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2 1 1 0 0 0 1 1h1a1 1 0 0 0 1-1h6a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1 2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H2Zm.5 2h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1ZM14 7.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-12 1a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Z"
                }
            }
        ]
    })(props);
}
function BsProjector(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM2.5 6a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Zm0 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2 1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1H5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1 2 2 0 0 1-2-2V6Zm2-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H2Z"
                }
            }
        ]
    })(props);
}
function BsPuzzleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.112 3.645A1.5 1.5 0 0 1 4.605 2H7a.5.5 0 0 1 .5.5v.382c0 .696-.497 1.182-.872 1.469a.459.459 0 0 0-.115.118.113.113 0 0 0-.012.025L6.5 4.5v.003l.003.01c.004.01.014.028.036.053a.86.86 0 0 0 .27.194C7.09 4.9 7.51 5 8 5c.492 0 .912-.1 1.19-.24a.86.86 0 0 0 .271-.194.213.213 0 0 0 .036-.054l.003-.01v-.008a.112.112 0 0 0-.012-.025.459.459 0 0 0-.115-.118c-.375-.287-.872-.773-.872-1.469V2.5A.5.5 0 0 1 9 2h2.395a1.5 1.5 0 0 1 1.493 1.645L12.645 6.5h.237c.195 0 .42-.147.675-.48.21-.274.528-.52.943-.52.568 0 .947.447 1.154.862C15.877 6.807 16 7.387 16 8s-.123 1.193-.346 1.638c-.207.415-.586.862-1.154.862-.415 0-.733-.246-.943-.52-.255-.333-.48-.48-.675-.48h-.237l.243 2.855A1.5 1.5 0 0 1 11.395 14H9a.5.5 0 0 1-.5-.5v-.382c0-.696.497-1.182.872-1.469a.459.459 0 0 0 .115-.118.113.113 0 0 0 .012-.025L9.5 11.5v-.003l-.003-.01a.214.214 0 0 0-.036-.053.859.859 0 0 0-.27-.194C8.91 11.1 8.49 11 8 11c-.491 0-.912.1-1.19.24a.859.859 0 0 0-.271.194.214.214 0 0 0-.036.054l-.003.01v.002l.001.006a.113.113 0 0 0 .012.025c.016.027.05.068.115.118.375.287.872.773.872 1.469v.382a.5.5 0 0 1-.5.5H4.605a1.5 1.5 0 0 1-1.493-1.645L3.356 9.5h-.238c-.195 0-.42.147-.675.48-.21.274-.528.52-.943.52-.568 0-.947-.447-1.154-.862C.123 9.193 0 8.613 0 8s.123-1.193.346-1.638C.553 5.947.932 5.5 1.5 5.5c.415 0 .733.246.943.52.255.333.48.48.675.48h.238l-.244-2.855z"
                }
            }
        ]
    })(props);
}
function BsPuzzle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.112 3.645A1.5 1.5 0 0 1 4.605 2H7a.5.5 0 0 1 .5.5v.382c0 .696-.497 1.182-.872 1.469a.459.459 0 0 0-.115.118.113.113 0 0 0-.012.025L6.5 4.5v.003l.003.01c.004.01.014.028.036.053a.86.86 0 0 0 .27.194C7.09 4.9 7.51 5 8 5c.492 0 .912-.1 1.19-.24a.86.86 0 0 0 .271-.194.213.213 0 0 0 .039-.063v-.009a.112.112 0 0 0-.012-.025.459.459 0 0 0-.115-.118c-.375-.287-.872-.773-.872-1.469V2.5A.5.5 0 0 1 9 2h2.395a1.5 1.5 0 0 1 1.493 1.645L12.645 6.5h.237c.195 0 .42-.147.675-.48.21-.274.528-.52.943-.52.568 0 .947.447 1.154.862C15.877 6.807 16 7.387 16 8s-.123 1.193-.346 1.638c-.207.415-.586.862-1.154.862-.415 0-.733-.246-.943-.52-.255-.333-.48-.48-.675-.48h-.237l.243 2.855A1.5 1.5 0 0 1 11.395 14H9a.5.5 0 0 1-.5-.5v-.382c0-.696.497-1.182.872-1.469a.459.459 0 0 0 .115-.118.113.113 0 0 0 .012-.025L9.5 11.5v-.003a.214.214 0 0 0-.039-.064.859.859 0 0 0-.27-.193C8.91 11.1 8.49 11 8 11c-.491 0-.912.1-1.19.24a.859.859 0 0 0-.271.194.214.214 0 0 0-.039.063v.003l.001.006a.113.113 0 0 0 .012.025c.016.027.05.068.115.118.375.287.872.773.872 1.469v.382a.5.5 0 0 1-.5.5H4.605a1.5 1.5 0 0 1-1.493-1.645L3.356 9.5h-.238c-.195 0-.42.147-.675.48-.21.274-.528.52-.943.52-.568 0-.947-.447-1.154-.862C.123 9.193 0 8.613 0 8s.123-1.193.346-1.638C.553 5.947.932 5.5 1.5 5.5c.415 0 .733.246.943.52.255.333.48.48.675.48h.238l-.244-2.855zM4.605 3a.5.5 0 0 0-.498.55l.001.007.29 3.4A.5.5 0 0 1 3.9 7.5h-.782c-.696 0-1.182-.497-1.469-.872a.459.459 0 0 0-.118-.115.112.112 0 0 0-.025-.012L1.5 6.5h-.003a.213.213 0 0 0-.064.039.86.86 0 0 0-.193.27C1.1 7.09 1 7.51 1 8c0 .491.1.912.24 1.19.07.14.14.225.194.271a.213.213 0 0 0 .063.039H1.5l.006-.001a.112.112 0 0 0 .025-.012.459.459 0 0 0 .118-.115c.287-.375.773-.872 1.469-.872H3.9a.5.5 0 0 1 .498.542l-.29 3.408a.5.5 0 0 0 .497.55h1.878c-.048-.166-.195-.352-.463-.557-.274-.21-.52-.528-.52-.943 0-.568.447-.947.862-1.154C6.807 10.123 7.387 10 8 10s1.193.123 1.638.346c.415.207.862.586.862 1.154 0 .415-.246.733-.52.943-.268.205-.415.39-.463.557h1.878a.5.5 0 0 0 .498-.55l-.001-.007-.29-3.4A.5.5 0 0 1 12.1 8.5h.782c.696 0 1.182.497 1.469.872.05.065.091.099.118.115.013.008.021.01.025.012a.02.02 0 0 0 .006.001h.003a.214.214 0 0 0 .064-.039.86.86 0 0 0 .193-.27c.14-.28.24-.7.24-1.191 0-.492-.1-.912-.24-1.19a.86.86 0 0 0-.194-.271.215.215 0 0 0-.063-.039H14.5l-.006.001a.113.113 0 0 0-.025.012.459.459 0 0 0-.118.115c-.287.375-.773.872-1.469.872H12.1a.5.5 0 0 1-.498-.543l.29-3.407a.5.5 0 0 0-.497-.55H9.517c.048.166.195.352.463.557.274.21.52.528.52.943 0 .568-.447.947-.862 1.154C9.193 5.877 8.613 6 8 6s-1.193-.123-1.638-.346C5.947 5.447 5.5 5.068 5.5 4.5c0-.415.246-.733.52-.943.268-.205.415-.39.463-.557H4.605z"
                }
            }
        ]
    })(props);
}
function BsQrCodeScan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 .5A.5.5 0 0 1 .5 0h3a.5.5 0 0 1 0 1H1v2.5a.5.5 0 0 1-1 0v-3Zm12 0a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V1h-2.5a.5.5 0 0 1-.5-.5ZM.5 12a.5.5 0 0 1 .5.5V15h2.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5Zm15 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1H15v-2.5a.5.5 0 0 1 .5-.5ZM4 4h1v1H4V4Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2H2v5h5V2ZM3 3h3v3H3V3Zm2 8H4v1h1v-1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9H2v5h5V9Zm-4 1h3v3H3v-3Zm8-6h1v1h-1V4Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2h5v5H9V2Zm1 1v3h3V3h-3ZM8 8v2h1v1H8v1h2v-2h1v2h1v-1h2v-1h-3V8H8Zm2 2H9V9h1v1Zm4 2h-1v1h-2v1h3v-2Zm-4 2v-1H8v1h2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9h2V8h-2v1Z"
                }
            }
        ]
    })(props);
}
function BsQrCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2h2v2H2V2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 0v6H0V0h6ZM5 1H1v4h4V1ZM4 12H2v2h2v-2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10v6H0v-6h6Zm-5 1v4h4v-4H1Zm11-9h2v2h-2V2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 0v6h6V0h-6Zm5 1v4h-4V1h4ZM8 1V0h1v2H8v2H7V1h1Zm0 5V4h1v2H8ZM6 8V7h1V6h1v2h1V7h5v1h-4v1H7V8H6Zm0 0v1H2V8H1v1H0V7h3v1h3Zm10 1h-1V7h1v2Zm-1 0h-1v2h2v-1h-1V9Zm-4 0h2v1h-1v1h-1V9Zm2 3v-1h-1v1h-1v1H9v1h3v-2h1Zm0 0h3v1h-2v1h-1v-2Zm-4-1v1h1v-2H7v1h2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12h1v3h4v1H7v-4Zm9 2v2h-3v-1h2v-1h1Z"
                }
            }
        ]
    })(props);
}
function BsQuestionCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z"
                }
            }
        ]
    })(props);
}
function BsQuestionCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"
                }
            }
        ]
    })(props);
}
function BsQuestionDiamondFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435zM5.495 6.033a.237.237 0 0 1-.24-.247C5.35 4.091 6.737 3.5 8.005 3.5c1.396 0 2.672.73 2.672 2.24 0 1.08-.635 1.594-1.244 2.057-.737.559-1.01.768-1.01 1.486v.105a.25.25 0 0 1-.25.25h-.81a.25.25 0 0 1-.25-.246l-.004-.217c-.038-.927.495-1.498 1.168-1.987.59-.444.965-.736.965-1.371 0-.825-.628-1.168-1.314-1.168-.803 0-1.253.478-1.342 1.134-.018.137-.128.25-.266.25h-.825zm2.325 6.443c-.584 0-1.009-.394-1.009-.927 0-.552.425-.94 1.01-.94.609 0 1.028.388 1.028.94 0 .533-.42.927-1.029.927z"
                }
            }
        ]
    })(props);
}
function BsQuestionDiamond(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.482 1.482 0 0 1 0-2.098L6.95.435zm1.4.7a.495.495 0 0 0-.7 0L1.134 7.65a.495.495 0 0 0 0 .7l6.516 6.516a.495.495 0 0 0 .7 0l6.516-6.516a.495.495 0 0 0 0-.7L8.35 1.134z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"
                }
            }
        ]
    })(props);
}
function BsQuestionLg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.475 5.458c-.284 0-.514-.237-.47-.517C4.28 3.24 5.576 2 7.825 2c2.25 0 3.767 1.36 3.767 3.215 0 1.344-.665 2.288-1.79 2.973-1.1.659-1.414 1.118-1.414 2.01v.03a.5.5 0 0 1-.5.5h-.77a.5.5 0 0 1-.5-.495l-.003-.2c-.043-1.221.477-2.001 1.645-2.712 1.03-.632 1.397-1.135 1.397-2.028 0-.979-.758-1.698-1.926-1.698-1.009 0-1.71.529-1.938 1.402-.066.254-.278.461-.54.461h-.777ZM7.496 14c.622 0 1.095-.474 1.095-1.09 0-.618-.473-1.092-1.095-1.092-.606 0-1.087.474-1.087 1.091S6.89 14 7.496 14Z"
                }
            }
        ]
    })(props);
}
function BsQuestionOctagonFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.46.146A.5.5 0 0 0 11.107 0H4.893a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353L11.46.146zM5.496 6.033a.237.237 0 0 1-.24-.247C5.35 4.091 6.737 3.5 8.005 3.5c1.396 0 2.672.73 2.672 2.24 0 1.08-.635 1.594-1.244 2.057-.737.559-1.01.768-1.01 1.486v.105a.25.25 0 0 1-.25.25h-.81a.25.25 0 0 1-.25-.246l-.004-.217c-.038-.927.495-1.498 1.168-1.987.59-.444.965-.736.965-1.371 0-.825-.628-1.168-1.314-1.168-.803 0-1.253.478-1.342 1.134-.018.137-.128.25-.266.25h-.825zm2.325 6.443c-.584 0-1.009-.394-1.009-.927 0-.552.425-.94 1.01-.94.609 0 1.028.388 1.028.94 0 .533-.42.927-1.029.927z"
                }
            }
        ]
    })(props);
}
function BsQuestionOctagon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.54.146A.5.5 0 0 1 4.893 0h6.214a.5.5 0 0 1 .353.146l4.394 4.394a.5.5 0 0 1 .146.353v6.214a.5.5 0 0 1-.146.353l-4.394 4.394a.5.5 0 0 1-.353.146H4.893a.5.5 0 0 1-.353-.146L.146 11.46A.5.5 0 0 1 0 11.107V4.893a.5.5 0 0 1 .146-.353L4.54.146zM5.1 1 1 5.1v5.8L5.1 15h5.8l4.1-4.1V5.1L10.9 1H5.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"
                }
            }
        ]
    })(props);
}
function BsQuestionSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm3.496 6.033a.237.237 0 0 1-.24-.247C5.35 4.091 6.737 3.5 8.005 3.5c1.396 0 2.672.73 2.672 2.24 0 1.08-.635 1.594-1.244 2.057-.737.559-1.01.768-1.01 1.486v.105a.25.25 0 0 1-.25.25h-.81a.25.25 0 0 1-.25-.246l-.004-.217c-.038-.927.495-1.498 1.168-1.987.59-.444.965-.736.965-1.371 0-.825-.628-1.168-1.314-1.168-.803 0-1.253.478-1.342 1.134-.018.137-.128.25-.266.25h-.825zm2.325 6.443c-.584 0-1.009-.394-1.009-.927 0-.552.425-.94 1.01-.94.609 0 1.028.388 1.028.94 0 .533-.42.927-1.029.927z"
                }
            }
        ]
    })(props);
}
function BsQuestionSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"
                }
            }
        ]
    })(props);
}
function BsQuestion(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"
                }
            }
        ]
    })(props);
}
function BsQuora(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.73 12.476c-.554-1.091-1.204-2.193-2.473-2.193-.242 0-.484.04-.707.142l-.43-.863c.525-.45 1.373-.808 2.464-.808 1.697 0 2.568.818 3.26 1.86.41-.89.605-2.093.605-3.584 0-3.724-1.165-5.636-3.885-5.636-2.68 0-3.839 1.912-3.839 5.636 0 3.704 1.159 5.596 3.84 5.596.425 0 .811-.046 1.166-.15Zm.665 1.3a7.127 7.127 0 0 1-1.83.244C3.994 14.02.5 11.172.5 7.03.5 2.849 3.995 0 7.564 0c3.63 0 7.09 2.828 7.09 7.03 0 2.337-1.09 4.236-2.675 5.464.512.767 1.04 1.277 1.773 1.277.802 0 1.125-.62 1.179-1.105h1.043c.061.647-.262 3.334-3.178 3.334-1.767 0-2.7-1.024-3.4-2.224Z"
                }
            }
        ]
    })(props);
}
function BsQuote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12a1 1 0 0 0 1-1V8.558a1 1 0 0 0-1-1h-1.388c0-.351.021-.703.062-1.054.062-.372.166-.703.31-.992.145-.29.331-.517.559-.683.227-.186.516-.279.868-.279V3c-.579 0-1.085.124-1.52.372a3.322 3.322 0 0 0-1.085.992 4.92 4.92 0 0 0-.62 1.458A7.712 7.712 0 0 0 9 7.558V11a1 1 0 0 0 1 1h2Zm-6 0a1 1 0 0 0 1-1V8.558a1 1 0 0 0-1-1H4.612c0-.351.021-.703.062-1.054.062-.372.166-.703.31-.992.145-.29.331-.517.559-.683.227-.186.516-.279.868-.279V3c-.579 0-1.085.124-1.52.372a3.322 3.322 0 0 0-1.085.992 4.92 4.92 0 0 0-.62 1.458A7.712 7.712 0 0 0 3 7.558V11a1 1 0 0 0 1 1h2Z"
                }
            }
        ]
    })(props);
}
function BsRCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM5.5 4.002V12h1.335V8.924H8.52L9.98 12h1.52L9.856 8.701c.828-.299 1.495-1.101 1.495-2.238 0-1.488-1.03-2.461-2.74-2.461H5.5Zm1.335 1.09v2.777h1.549c.995 0 1.573-.463 1.573-1.36 0-.913-.596-1.417-1.537-1.417H6.835Z"
                }
            }
        ]
    })(props);
}
function BsRCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8Zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM5.5 4.002h3.11c1.71 0 2.741.973 2.741 2.46 0 1.138-.667 1.94-1.495 2.24L11.5 12H9.98L8.52 8.924H6.836V12H5.5V4.002Zm1.335 1.09v2.777h1.549c.995 0 1.573-.463 1.573-1.36 0-.913-.596-1.417-1.537-1.417H6.835Z"
                }
            }
        ]
    })(props);
}
function BsRSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.835 5.092v2.777h1.549c.995 0 1.573-.463 1.573-1.36 0-.913-.596-1.417-1.537-1.417H6.835Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm3.5 4.002h3.11c1.71 0 2.741.973 2.741 2.46 0 1.138-.667 1.94-1.495 2.24L11.5 12H9.98L8.52 8.924H6.836V12H5.5V4.002Z"
                }
            }
        ]
    })(props);
}
function BsRSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 4.002h3.11c1.71 0 2.741.973 2.741 2.46 0 1.138-.667 1.94-1.495 2.24L11.5 12H9.98L8.52 8.924H6.836V12H5.5V4.002Zm1.335 1.09v2.777h1.549c.995 0 1.573-.463 1.573-1.36 0-.913-.596-1.417-1.537-1.417H6.835Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2Z"
                }
            }
        ]
    })(props);
}
function BsRadar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.634 1.135A7 7 0 0 1 15 8a.5.5 0 0 1-1 0 6 6 0 1 0-6.5 5.98v-1.005A5 5 0 1 1 13 8a.5.5 0 0 1-1 0 4 4 0 1 0-4.5 3.969v-1.011A2.999 2.999 0 1 1 11 8a.5.5 0 0 1-1 0 2 2 0 1 0-2.5 1.936v-1.07a1 1 0 1 1 1 0V15.5a.5.5 0 0 1-1 0v-.518a7 7 0 0 1-.866-13.847Z"
                }
            }
        ]
    })(props);
}
function BsRadioactive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1ZM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.653 5.496A2.986 2.986 0 0 0 8 5c-.61 0-1.179.183-1.653.496L4.694 2.992A5.972 5.972 0 0 1 8 2c1.222 0 2.358.365 3.306.992L9.653 5.496Zm1.342 2.324a2.986 2.986 0 0 1-.884 2.312 3.01 3.01 0 0 1-.769.552l1.342 2.683c.57-.286 1.09-.66 1.538-1.103a5.986 5.986 0 0 0 1.767-4.624l-2.994.18Zm-5.679 5.548 1.342-2.684A3 3 0 0 1 5.005 7.82l-2.994-.18a6 6 0 0 0 3.306 5.728ZM10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
                }
            }
        ]
    })(props);
}
function BsRainbow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4.5a7 7 0 0 0-7 7 .5.5 0 0 1-1 0 8 8 0 1 1 16 0 .5.5 0 0 1-1 0 7 7 0 0 0-7-7zm0 2a5 5 0 0 0-5 5 .5.5 0 0 1-1 0 6 6 0 1 1 12 0 .5.5 0 0 1-1 0 5 5 0 0 0-5-5zm0 2a3 3 0 0 0-3 3 .5.5 0 0 1-1 0 4 4 0 1 1 8 0 .5.5 0 0 1-1 0 3 3 0 0 0-3-3zm0 2a1 1 0 0 0-1 1 .5.5 0 0 1-1 0 2 2 0 1 1 4 0 .5.5 0 0 1-1 0 1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function BsReceiptCutoff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zM11.5 4a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.354.646a.5.5 0 0 0-.801.13l-.5 1A.5.5 0 0 0 1 2v13H.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1H15V2a.5.5 0 0 0-.053-.224l-.5-1a.5.5 0 0 0-.8-.13L13 1.293l-.646-.647a.5.5 0 0 0-.708 0L11 1.293l-.646-.647a.5.5 0 0 0-.708 0L9 1.293 8.354.646a.5.5 0 0 0-.708 0L7 1.293 6.354.646a.5.5 0 0 0-.708 0L5 1.293 4.354.646a.5.5 0 0 0-.708 0L3 1.293 2.354.646zm-.217 1.198.51.51a.5.5 0 0 0 .707 0L4 1.707l.646.647a.5.5 0 0 0 .708 0L6 1.707l.646.647a.5.5 0 0 0 .708 0L8 1.707l.646.647a.5.5 0 0 0 .708 0L10 1.707l.646.647a.5.5 0 0 0 .708 0L12 1.707l.646.647a.5.5 0 0 0 .708 0l.509-.51.137.274V15H2V2.118l.137-.274z"
                }
            }
        ]
    })(props);
}
function BsReceipt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.92.506a.5.5 0 0 1 .434.14L3 1.293l.646-.647a.5.5 0 0 1 .708 0L5 1.293l.646-.647a.5.5 0 0 1 .708 0L7 1.293l.646-.647a.5.5 0 0 1 .708 0L9 1.293l.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .801.13l.5 1A.5.5 0 0 1 15 2v12a.5.5 0 0 1-.053.224l-.5 1a.5.5 0 0 1-.8.13L13 14.707l-.646.647a.5.5 0 0 1-.708 0L11 14.707l-.646.647a.5.5 0 0 1-.708 0L9 14.707l-.646.647a.5.5 0 0 1-.708 0L7 14.707l-.646.647a.5.5 0 0 1-.708 0L5 14.707l-.646.647a.5.5 0 0 1-.708 0L3 14.707l-.646.647a.5.5 0 0 1-.801-.13l-.5-1A.5.5 0 0 1 1 14V2a.5.5 0 0 1 .053-.224l.5-1a.5.5 0 0 1 .367-.27zm.217 1.338L2 2.118v11.764l.137.274.51-.51a.5.5 0 0 1 .707 0l.646.647.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.509.509.137-.274V2.118l-.137-.274-.51.51a.5.5 0 0 1-.707 0L12 1.707l-.646.647a.5.5 0 0 1-.708 0L10 1.707l-.646.647a.5.5 0 0 1-.708 0L8 1.707l-.646.647a.5.5 0 0 1-.708 0L6 1.707l-.646.647a.5.5 0 0 1-.708 0L4 1.707l-.646.647a.5.5 0 0 1-.708 0l-.509-.51z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm8-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsReception0(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 13.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm4 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm4 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm4 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsReception1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 11.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2zm4 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm4 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm4 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsReception2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 11.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2zm4-3a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-5zm4 5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm4 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsReception3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 11.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2zm4-3a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-5zm4-3a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-8zm4 8a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsReception4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 11.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2zm4-3a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-5zm4-3a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-8zm4-3a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-11z"
                }
            }
        ]
    })(props);
}
function BsRecordBtnFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm8-1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                }
            }
        ]
    })(props);
}
function BsRecordBtn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"
                }
            }
        ]
    })(props);
}
function BsRecordCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-8 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                }
            }
        ]
    })(props);
}
function BsRecordCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"
                }
            }
        ]
    })(props);
}
function BsRecordFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 13A5 5 0 1 0 8 3a5 5 0 0 0 0 10z"
                }
            }
        ]
    })(props);
}
function BsRecord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0 1A5 5 0 1 0 8 3a5 5 0 0 0 0 10z"
                }
            }
        ]
    })(props);
}
function BsRecord2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13A5 5 0 1 0 8 3a5 5 0 0 0 0 10zm0-2a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
                }
            }
        ]
    })(props);
}
function BsRecord2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0 1A5 5 0 1 0 8 3a5 5 0 0 0 0 10z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
                }
            }
        ]
    })(props);
}
function BsRecycle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.302 1.256a1.5 1.5 0 0 0-2.604 0l-1.704 2.98a.5.5 0 0 0 .869.497l1.703-2.981a.5.5 0 0 1 .868 0l2.54 4.444-1.256-.337a.5.5 0 1 0-.26.966l2.415.647a.5.5 0 0 0 .613-.353l.647-2.415a.5.5 0 1 0-.966-.259l-.333 1.242-2.532-4.431zM2.973 7.773l-1.255.337a.5.5 0 1 1-.26-.966l2.416-.647a.5.5 0 0 1 .612.353l.647 2.415a.5.5 0 0 1-.966.259l-.333-1.242-2.545 4.454a.5.5 0 0 0 .434.748H5a.5.5 0 0 1 0 1H1.723A1.5 1.5 0 0 1 .421 12.24l2.552-4.467zm10.89 1.463a.5.5 0 1 0-.868.496l1.716 3.004a.5.5 0 0 1-.434.748h-5.57l.647-.646a.5.5 0 1 0-.708-.707l-1.5 1.5a.498.498 0 0 0 0 .707l1.5 1.5a.5.5 0 1 0 .708-.707l-.647-.647h5.57a1.5 1.5 0 0 0 1.302-2.244l-1.716-3.004z"
                }
            }
        ]
    })(props);
}
function BsReddit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.167 8a.831.831 0 0 0-.83.83c0 .459.372.84.83.831a.831.831 0 0 0 0-1.661zm1.843 3.647c.315 0 1.403-.038 1.976-.611a.232.232 0 0 0 0-.306.213.213 0 0 0-.306 0c-.353.363-1.126.487-1.67.487-.545 0-1.308-.124-1.671-.487a.213.213 0 0 0-.306 0 .213.213 0 0 0 0 .306c.564.563 1.652.61 1.977.61zm.992-2.807c0 .458.373.83.831.83.458 0 .83-.381.83-.83a.831.831 0 0 0-1.66 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.828-1.165c-.315 0-.602.124-.812.325-.801-.573-1.9-.945-3.121-.993l.534-2.501 1.738.372a.83.83 0 1 0 .83-.869.83.83 0 0 0-.744.468l-1.938-.41a.203.203 0 0 0-.153.028.186.186 0 0 0-.086.134l-.592 2.788c-1.24.038-2.358.41-3.17.992-.21-.2-.496-.324-.81-.324a1.163 1.163 0 0 0-.478 2.224c-.02.115-.029.23-.029.353 0 1.795 2.091 3.256 4.669 3.256 2.577 0 4.668-1.451 4.668-3.256 0-.114-.01-.238-.029-.353.401-.181.688-.592.688-1.069 0-.65-.525-1.165-1.165-1.165z"
                }
            }
        ]
    })(props);
}
function BsRegex(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.05 3.05a7 7 0 0 0 0 9.9.5.5 0 0 1-.707.707 8 8 0 0 1 0-11.314.5.5 0 1 1 .707.707Zm9.9-.707a.5.5 0 0 1 .707 0 8 8 0 0 1 0 11.314.5.5 0 0 1-.707-.707 7 7 0 0 0 0-9.9.5.5 0 0 1 0-.707ZM6 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm5-6.5a.5.5 0 0 0-1 0v2.117L8.257 5.57a.5.5 0 0 0-.514.858L9.528 7.5 7.743 8.571a.5.5 0 1 0 .514.858L10 8.383V10.5a.5.5 0 1 0 1 0V8.383l1.743 1.046a.5.5 0 0 0 .514-.858L11.472 7.5l1.785-1.071a.5.5 0 1 0-.514-.858L11 6.617V4.5Z"
                }
            }
        ]
    })(props);
}
function BsRepeat1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 4v1.466a.25.25 0 0 0 .41.192l2.36-1.966a.25.25 0 0 0 0-.384l-2.36-1.966a.25.25 0 0 0-.41.192V3H5a5 5 0 0 0-4.48 7.223.5.5 0 0 0 .896-.446A4 4 0 0 1 5 4h6Zm4.48 1.777a.5.5 0 0 0-.896.446A4 4 0 0 1 11 12H5.001v-1.466a.25.25 0 0 0-.41-.192l-2.36 1.966a.25.25 0 0 0 0 .384l2.36 1.966a.25.25 0 0 0 .41-.192V13h6a5 5 0 0 0 4.48-7.223Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 5.5a.5.5 0 0 0-.854-.354l-1.75 1.75a.5.5 0 1 0 .708.708L8 6.707V10.5a.5.5 0 0 0 1 0v-5Z"
                }
            }
        ]
    })(props);
}
function BsRepeat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5.466V4H5a4 4 0 0 0-3.584 5.777.5.5 0 1 1-.896.446A5 5 0 0 1 5 3h6V1.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192Zm3.81.086a.5.5 0 0 1 .67.225A5 5 0 0 1 11 13H5v1.466a.25.25 0 0 1-.41.192l-2.36-1.966a.25.25 0 0 1 0-.384l2.36-1.966a.25.25 0 0 1 .41.192V12h6a4 4 0 0 0 3.585-5.777.5.5 0 0 1 .225-.67Z"
                }
            }
        ]
    })(props);
}
function BsReplyAllFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.021 11.9 3.453 8.62a.719.719 0 0 1 0-1.238L8.021 4.1a.716.716 0 0 1 1.079.619V6c1.5 0 6 0 7 8-2.5-4.5-7-4-7-4v1.281c0 .56-.606.898-1.079.62z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.232 4.293a.5.5 0 0 1-.106.7L1.114 7.945a.5.5 0 0 1-.042.028.147.147 0 0 0 0 .252.503.503 0 0 1 .042.028l4.012 2.954a.5.5 0 1 1-.593.805L.539 9.073a1.147 1.147 0 0 1 0-1.946l3.994-2.94a.5.5 0 0 1 .699.106z"
                }
            }
        ]
    })(props);
}
function BsReplyAll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.098 5.013a.144.144 0 0 1 .202.134V6.3a.5.5 0 0 0 .5.5c.667 0 2.013.005 3.3.822.984.624 1.99 1.76 2.595 3.876-1.02-.983-2.185-1.516-3.205-1.799a8.74 8.74 0 0 0-1.921-.306 7.404 7.404 0 0 0-.798.008h-.013l-.005.001h-.001L8.8 9.9l-.05-.498a.5.5 0 0 0-.45.498v1.153c0 .108-.11.176-.202.134L4.114 8.254a.502.502 0 0 0-.042-.028.147.147 0 0 1 0-.252.497.497 0 0 0 .042-.028l3.984-2.933zM9.3 10.386c.068 0 .143.003.223.006.434.02 1.034.086 1.7.271 1.326.368 2.896 1.202 3.94 3.08a.5.5 0 0 0 .933-.305c-.464-3.71-1.886-5.662-3.46-6.66-1.245-.79-2.527-.942-3.336-.971v-.66a1.144 1.144 0 0 0-1.767-.96l-3.994 2.94a1.147 1.147 0 0 0 0 1.946l3.994 2.94a1.144 1.144 0 0 0 1.767-.96v-.667z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.232 4.293a.5.5 0 0 0-.7-.106L.54 7.127a1.147 1.147 0 0 0 0 1.946l3.994 2.94a.5.5 0 1 0 .593-.805L1.114 8.254a.503.503 0 0 0-.042-.028.147.147 0 0 1 0-.252.5.5 0 0 0 .042-.028l4.012-2.954a.5.5 0 0 0 .106-.699z"
                }
            }
        ]
    })(props);
}
function BsReplyFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.921 11.9 1.353 8.62a.719.719 0 0 1 0-1.238L5.921 4.1A.716.716 0 0 1 7 4.719V6c1.5 0 6 0 7 8-2.5-4.5-7-4-7-4v1.281c0 .56-.606.898-1.079.62z"
                }
            }
        ]
    })(props);
}
function BsReply(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.598 5.013a.144.144 0 0 1 .202.134V6.3a.5.5 0 0 0 .5.5c.667 0 2.013.005 3.3.822.984.624 1.99 1.76 2.595 3.876-1.02-.983-2.185-1.516-3.205-1.799a8.74 8.74 0 0 0-1.921-.306 7.404 7.404 0 0 0-.798.008h-.013l-.005.001h-.001L7.3 9.9l-.05-.498a.5.5 0 0 0-.45.498v1.153c0 .108-.11.176-.202.134L2.614 8.254a.503.503 0 0 0-.042-.028.147.147 0 0 1 0-.252.499.499 0 0 0 .042-.028l3.984-2.933zM7.8 10.386c.068 0 .143.003.223.006.434.02 1.034.086 1.7.271 1.326.368 2.896 1.202 3.94 3.08a.5.5 0 0 0 .933-.305c-.464-3.71-1.886-5.662-3.46-6.66-1.245-.79-2.527-.942-3.336-.971v-.66a1.144 1.144 0 0 0-1.767-.96l-3.994 2.94a1.147 1.147 0 0 0 0 1.946l3.994 2.94a1.144 1.144 0 0 0 1.767-.96v-.667z"
                }
            }
        ]
    })(props);
}
function BsRewindBtnFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2Zm7.729 1.055A.5.5 0 0 1 8 5.5v1.886l3.21-2.293A.5.5 0 0 1 12 5.5v5a.5.5 0 0 1-.79.407L8 8.614V10.5a.5.5 0 0 1-.79.407l-3.5-2.5a.5.5 0 0 1 0-.814l3.5-2.5a.5.5 0 0 1 .519-.038Z"
                }
            }
        ]
    })(props);
}
function BsRewindBtn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.21 5.093A.5.5 0 0 1 8 5.5v1.886l3.21-2.293A.5.5 0 0 1 12 5.5v5a.5.5 0 0 1-.79.407L8 8.614V10.5a.5.5 0 0 1-.79.407l-3.5-2.5a.5.5 0 0 1 0-.814l3.5-2.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4Z"
                }
            }
        ]
    })(props);
}
function BsRewindCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16ZM7.729 5.055A.5.5 0 0 1 8 5.5v1.886l3.21-2.293A.5.5 0 0 1 12 5.5v5a.5.5 0 0 1-.79.407L8 8.614V10.5a.5.5 0 0 1-.79.407l-3.5-2.5a.5.5 0 0 1 0-.814l3.5-2.5a.5.5 0 0 1 .519-.038Z"
                }
            }
        ]
    })(props);
}
function BsRewindCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.729 5.055a.5.5 0 0 0-.52.038l-3.5 2.5a.5.5 0 0 0 0 .814l3.5 2.5A.5.5 0 0 0 8 10.5V8.614l3.21 2.293A.5.5 0 0 0 12 10.5v-5a.5.5 0 0 0-.79-.407L8 7.386V5.5a.5.5 0 0 0-.271-.445Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8Z"
                }
            }
        ]
    })(props);
}
function BsRewindFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.404 7.304a.802.802 0 0 0 0 1.392l6.363 3.692c.52.302 1.233-.043 1.233-.696V4.308c0-.653-.713-.998-1.233-.696L8.404 7.304Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M.404 7.304a.802.802 0 0 0 0 1.392l6.363 3.692c.52.302 1.233-.043 1.233-.696V4.308c0-.653-.713-.998-1.233-.696L.404 7.304Z"
                }
            }
        ]
    })(props);
}
function BsRewind(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.196 8 15 4.633v6.734L9.196 8Zm-.792-.696a.802.802 0 0 0 0 1.392l6.363 3.692c.52.302 1.233-.043 1.233-.696V4.308c0-.653-.713-.998-1.233-.696L8.404 7.304Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.196 8 7 4.633v6.734L1.196 8Zm-.792-.696a.802.802 0 0 0 0 1.392l6.363 3.692c.52.302 1.233-.043 1.233-.696V4.308c0-.653-.713-.998-1.233-.696L.404 7.304Z"
                }
            }
        ]
    })(props);
}
function BsRobot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM3 8.062C3 6.76 4.235 5.765 5.53 5.886a26.58 26.58 0 0 0 4.94 0C11.765 5.765 13 6.76 13 8.062v1.157a.933.933 0 0 1-.765.935c-.845.147-2.34.346-4.235.346-1.895 0-3.39-.2-4.235-.346A.933.933 0 0 1 3 9.219V8.062Zm4.542-.827a.25.25 0 0 0-.217.068l-.92.9a24.767 24.767 0 0 1-1.871-.183.25.25 0 0 0-.068.495c.55.076 1.232.149 2.02.193a.25.25 0 0 0 .189-.071l.754-.736.847 1.71a.25.25 0 0 0 .404.062l.932-.97a25.286 25.286 0 0 0 1.922-.188.25.25 0 0 0-.068-.495c-.538.074-1.207.145-1.98.189a.25.25 0 0 0-.166.076l-.754.785-.842-1.7a.25.25 0 0 0-.182-.135Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 1.866a1 1 0 1 0-1 0V3h-2A4.5 4.5 0 0 0 1 7.5V8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1v-.5A4.5 4.5 0 0 0 10.5 3h-2V1.866ZM14 7.5V13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.5A3.5 3.5 0 0 1 5.5 4h5A3.5 3.5 0 0 1 14 7.5Z"
                }
            }
        ]
    })(props);
}
function BsRocketFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.175 1.991c.81 1.312 1.583 3.43 1.778 6.819l1.5 1.83A2.5 2.5 0 0 1 14 12.202V15.5a.5.5 0 0 1-.9.3l-1.125-1.5c-.166-.222-.42-.4-.752-.57-.214-.108-.414-.192-.627-.282l-.196-.083C9.7 13.793 8.85 14 8 14c-.85 0-1.7-.207-2.4-.635-.068.03-.133.057-.198.084-.211.089-.411.173-.625.281-.332.17-.586.348-.752.57L2.9 15.8a.5.5 0 0 1-.9-.3v-3.298a2.5 2.5 0 0 1 .548-1.562l.004-.005L4.049 8.81c.197-3.323.969-5.434 1.774-6.756.466-.767.94-1.262 1.31-1.57a3.67 3.67 0 0 1 .601-.41A.549.549 0 0 1 8 0c.101 0 .17.027.25.064.037.017.086.041.145.075.118.066.277.167.463.315.373.297.85.779 1.317 1.537ZM9.5 6c0-1.105-.672-2-1.5-2s-1.5.895-1.5 2S7.172 8 8 8s1.5-.895 1.5-2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14.5c.5 0 .999-.046 1.479-.139L8.4 15.8a.5.5 0 0 1-.8 0l-1.079-1.439c.48.093.98.139 1.479.139Z"
                }
            }
        ]
    })(props);
}
function BsRocketTakeoffFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.17 9.53c2.307-2.592 3.278-4.684 3.641-6.218.21-.887.214-1.58.16-2.065a3.578 3.578 0 0 0-.108-.563 2.22 2.22 0 0 0-.078-.23V.453c-.073-.164-.168-.234-.352-.295a2.35 2.35 0 0 0-.16-.045 3.797 3.797 0 0 0-.57-.093c-.49-.044-1.19-.03-2.08.188-1.536.374-3.618 1.343-6.161 3.604l-2.4.238h-.006a2.552 2.552 0 0 0-1.524.734L.15 7.17a.512.512 0 0 0 .433.868l1.896-.271c.28-.04.592.013.955.132.232.076.437.16.655.248l.203.083c.196.816.66 1.58 1.275 2.195.613.614 1.376 1.08 2.191 1.277l.082.202c.089.218.173.424.249.657.118.363.172.676.132.956l-.271 1.9a.512.512 0 0 0 .867.433l2.382-2.386c.41-.41.668-.949.732-1.526l.24-2.408Zm.11-3.699c-.797.8-1.93.961-2.528.362-.598-.6-.436-1.733.361-2.532.798-.799 1.93-.96 2.528-.361.599.599.437 1.732-.36 2.531Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.205 10.787a7.632 7.632 0 0 0 1.804 1.352c-1.118 1.007-4.929 2.028-5.054 1.903-.126-.127.737-4.189 1.839-5.18.346.69.837 1.35 1.411 1.925Z"
                }
            }
        ]
    })(props);
}
function BsRocketTakeoff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.752 6.193c.599.6 1.73.437 2.528-.362.798-.799.96-1.932.362-2.531-.599-.6-1.73-.438-2.528.361-.798.8-.96 1.933-.362 2.532Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.811 3.312c-.363 1.534-1.334 3.626-3.64 6.218l-.24 2.408a2.56 2.56 0 0 1-.732 1.526L8.817 15.85a.51.51 0 0 1-.867-.434l.27-1.899c.04-.28-.013-.593-.131-.956a9.42 9.42 0 0 0-.249-.657l-.082-.202c-.815-.197-1.578-.662-2.191-1.277-.614-.615-1.079-1.379-1.275-2.195l-.203-.083a9.556 9.556 0 0 0-.655-.248c-.363-.119-.675-.172-.955-.132l-1.896.27A.51.51 0 0 1 .15 7.17l2.382-2.386c.41-.41.947-.67 1.524-.734h.006l2.4-.238C9.005 1.55 11.087.582 12.623.208c.89-.217 1.59-.232 2.08-.188.244.023.435.06.57.093.067.017.12.033.16.045.184.06.279.13.351.295l.029.073a3.475 3.475 0 0 1 .157.721c.055.485.051 1.178-.159 2.065Zm-4.828 7.475.04-.04-.107 1.081a1.536 1.536 0 0 1-.44.913l-1.298 1.3.054-.38c.072-.506-.034-.993-.172-1.418a8.548 8.548 0 0 0-.164-.45c.738-.065 1.462-.38 2.087-1.006ZM5.205 5c-.625.626-.94 1.351-1.004 2.09a8.497 8.497 0 0 0-.45-.164c-.424-.138-.91-.244-1.416-.172l-.38.054 1.3-1.3c.245-.246.566-.401.91-.44l1.08-.107-.04.039Zm9.406-3.961c-.38-.034-.967-.027-1.746.163-1.558.38-3.917 1.496-6.937 4.521-.62.62-.799 1.34-.687 2.051.107.676.483 1.362 1.048 1.928.564.565 1.25.941 1.924 1.049.71.112 1.429-.067 2.048-.688 3.079-3.083 4.192-5.444 4.556-6.987.183-.771.18-1.345.138-1.713a2.835 2.835 0 0 0-.045-.283 3.078 3.078 0 0 0-.3-.041Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.009 12.139a7.632 7.632 0 0 1-1.804-1.352A7.568 7.568 0 0 1 3.794 8.86c-1.102.992-1.965 5.054-1.839 5.18.125.126 3.936-.896 5.054-1.902Z"
                }
            }
        ]
    })(props);
}
function BsRocket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8c.828 0 1.5-.895 1.5-2S8.828 4 8 4s-1.5.895-1.5 2S7.172 8 8 8Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.953 8.81c-.195-3.388-.968-5.507-1.777-6.819C9.707 1.233 9.23.751 8.857.454a3.495 3.495 0 0 0-.463-.315A2.19 2.19 0 0 0 8.25.064.546.546 0 0 0 8 0a.549.549 0 0 0-.266.073 2.312 2.312 0 0 0-.142.08 3.67 3.67 0 0 0-.459.33c-.37.308-.844.803-1.31 1.57-.805 1.322-1.577 3.433-1.774 6.756l-1.497 1.826-.004.005A2.5 2.5 0 0 0 2 12.202V15.5a.5.5 0 0 0 .9.3l1.125-1.5c.166-.222.42-.4.752-.57.214-.108.414-.192.625-.281l.198-.084c.7.428 1.55.635 2.4.635.85 0 1.7-.207 2.4-.635.067.03.132.056.196.083.213.09.413.174.627.282.332.17.586.348.752.57l1.125 1.5a.5.5 0 0 0 .9-.3v-3.298a2.5 2.5 0 0 0-.548-1.562l-1.499-1.83ZM12 10.445v.055c0 .866-.284 1.585-.75 2.14.146.064.292.13.425.199.39.197.8.46 1.1.86L13 14v-1.798a1.5 1.5 0 0 0-.327-.935L12 10.445ZM4.75 12.64C4.284 12.085 4 11.366 4 10.5v-.054l-.673.82a1.5 1.5 0 0 0-.327.936V14l.225-.3c.3-.4.71-.664 1.1-.861.133-.068.279-.135.425-.199ZM8.009 1.073c.063.04.14.094.226.163.284.226.683.621 1.09 1.28C10.137 3.836 11 6.237 11 10.5c0 .858-.374 1.48-.943 1.893C9.517 12.786 8.781 13 8 13c-.781 0-1.517-.214-2.057-.607C5.373 11.979 5 11.358 5 10.5c0-4.182.86-6.586 1.677-7.928.409-.67.81-1.082 1.096-1.32.09-.076.17-.135.236-.18Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.479 14.361c-.48.093-.98.139-1.479.139-.5 0-.999-.046-1.479-.139L7.6 15.8a.5.5 0 0 0 .8 0l1.079-1.439Z"
                }
            }
        ]
    })(props);
}
function BsRouterFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.525 3.025a3.5 3.5 0 0 1 4.95 0 .5.5 0 1 0 .707-.707 4.5 4.5 0 0 0-6.364 0 .5.5 0 0 0 .707.707Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.94 4.44a1.5 1.5 0 0 1 2.12 0 .5.5 0 0 0 .708-.708 2.5 2.5 0 0 0-3.536 0 .5.5 0 0 0 .707.707Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.974 2.342a.5.5 0 1 0-.948.316L3.806 8H1.5A1.5 1.5 0 0 0 0 9.5v2A1.5 1.5 0 0 0 1.5 13H2a.5.5 0 0 0 .5.5h2A.5.5 0 0 0 5 13h6a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5h.5a1.5 1.5 0 0 0 1.5-1.5v-2A1.5 1.5 0 0 0 14.5 8h-2.306l1.78-5.342a.5.5 0 1 0-.948-.316L11.14 8H4.86L2.974 2.342ZM2.5 11a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm4.5-.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm2.5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm1.5-.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm2 0a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 5.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
                }
            }
        ]
    })(props);
}
function BsRouter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.525 3.025a3.5 3.5 0 0 1 4.95 0 .5.5 0 1 0 .707-.707 4.5 4.5 0 0 0-6.364 0 .5.5 0 0 0 .707.707Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.94 4.44a1.5 1.5 0 0 1 2.12 0 .5.5 0 0 0 .708-.708 2.5 2.5 0 0 0-3.536 0 .5.5 0 0 0 .707.707ZM2.5 11a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm4.5-.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0Zm2.5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm1.5-.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0Zm2 0a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.974 2.342a.5.5 0 1 0-.948.316L3.806 8H1.5A1.5 1.5 0 0 0 0 9.5v2A1.5 1.5 0 0 0 1.5 13H2a.5.5 0 0 0 .5.5h2A.5.5 0 0 0 5 13h6a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5h.5a1.5 1.5 0 0 0 1.5-1.5v-2A1.5 1.5 0 0 0 14.5 8h-2.306l1.78-5.342a.5.5 0 1 0-.948-.316L11.14 8H4.86L2.974 2.342ZM14.5 9a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h13Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 5.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
                }
            }
        ]
    })(props);
}
function BsRssFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm1.5 2.5c5.523 0 10 4.477 10 10a1 1 0 1 1-2 0 8 8 0 0 0-8-8 1 1 0 0 1 0-2zm0 4a6 6 0 0 1 6 6 1 1 0 1 1-2 0 4 4 0 0 0-4-4 1 1 0 0 1 0-2zm.5 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                }
            }
        ]
    })(props);
}
function BsRss(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm-3-8.5a1 1 0 0 1 1-1c5.523 0 10 4.477 10 10a1 1 0 1 1-2 0 8 8 0 0 0-8-8 1 1 0 0 1-1-1zm0 4a1 1 0 0 1 1-1 6 6 0 0 1 6 6 1 1 0 1 1-2 0 4 4 0 0 0-4-4 1 1 0 0 1-1-1z"
                }
            }
        ]
    })(props);
}
function BsRulers(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 0a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h5v-1H2v-1h4v-1H4v-1h2v-1H2v-1h4V9H4V8h2V7H2V6h4V2h1v4h1V4h1v2h1V2h1v4h1V4h1v2h1V2h1v4h1V1a1 1 0 0 0-1-1H1z"
                }
            }
        ]
    })(props);
}
function BsSafeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.778 9.414A2 2 0 1 1 6.95 6.586a2 2 0 0 1 2.828 2.828z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 0A1.5 1.5 0 0 0 1 1.5V3H.5a.5.5 0 0 0 0 1H1v3.5H.5a.5.5 0 0 0 0 1H1V12H.5a.5.5 0 0 0 0 1H1v1.5A1.5 1.5 0 0 0 2.5 16h12a1.5 1.5 0 0 0 1.5-1.5v-13A1.5 1.5 0 0 0 14.5 0h-12zm3.036 4.464 1.09 1.09a3.003 3.003 0 0 1 3.476 0l1.09-1.09a.5.5 0 1 1 .707.708l-1.09 1.09c.74 1.037.74 2.44 0 3.476l1.09 1.09a.5.5 0 1 1-.707.708l-1.09-1.09a3.002 3.002 0 0 1-3.476 0l-1.09 1.09a.5.5 0 1 1-.708-.708l1.09-1.09a3.003 3.003 0 0 1 0-3.476l-1.09-1.09a.5.5 0 1 1 .708-.708zM14 6.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsSafe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 1.5A1.5 1.5 0 0 1 2.5 0h12A1.5 1.5 0 0 1 16 1.5v13a1.5 1.5 0 0 1-1.5 1.5h-12A1.5 1.5 0 0 1 1 14.5V13H.5a.5.5 0 0 1 0-1H1V8.5H.5a.5.5 0 0 1 0-1H1V4H.5a.5.5 0 0 1 0-1H1V1.5zM2.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5h-12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 6a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5zM4.828 4.464a.5.5 0 0 1 .708 0l1.09 1.09a3.003 3.003 0 0 1 3.476 0l1.09-1.09a.5.5 0 1 1 .707.708l-1.09 1.09c.74 1.037.74 2.44 0 3.476l1.09 1.09a.5.5 0 1 1-.707.708l-1.09-1.09a3.002 3.002 0 0 1-3.476 0l-1.09 1.09a.5.5 0 1 1-.708-.708l1.09-1.09a3.003 3.003 0 0 1 0-3.476l-1.09-1.09a.5.5 0 0 1 0-.708zM6.95 6.586a2 2 0 1 0 2.828 2.828A2 2 0 0 0 6.95 6.586z"
                }
            }
        ]
    })(props);
}
function BsSafe2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.563 8H5.035a3.482 3.482 0 0 1 .662-1.596l1.08 1.08c-.094.16-.167.332-.214.516zm.921-1.223-1.08-1.08A3.482 3.482 0 0 1 8 5.035v1.528c-.184.047-.357.12-.516.214zM9 6.563V5.035a3.482 3.482 0 0 1 1.596.662l-1.08 1.08A1.988 1.988 0 0 0 9 6.563zm1.223.921 1.08-1.08c.343.458.577 1.003.662 1.596h-1.528a1.989 1.989 0 0 0-.214-.516zM10.437 9h1.528a3.483 3.483 0 0 1-.662 1.596l-1.08-1.08c.094-.16.167-.332.214-.516zm-.921 1.223 1.08 1.08A3.483 3.483 0 0 1 9 11.965v-1.528c.184-.047.357-.12.516-.214zM8 10.437v1.528a3.483 3.483 0 0 1-1.596-.662l1.08-1.08c.16.094.332.167.516.214zm-1.223-.921-1.08 1.08A3.482 3.482 0 0 1 5.035 9h1.528c.047.184.12.357.214.516zM7.5 8.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 1A1.5 1.5 0 0 0 1 2.5V3H.5a.5.5 0 0 0 0 1H1v4H.5a.5.5 0 0 0 0 1H1v4H.5a.5.5 0 0 0 0 1H1v.5A1.5 1.5 0 0 0 2.5 16h12a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 14.5 1h-12zm6 3a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9z"
                }
            }
        ]
    })(props);
}
function BsSafe2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 2.5A1.5 1.5 0 0 1 2.5 1h12A1.5 1.5 0 0 1 16 2.5v12a1.5 1.5 0 0 1-1.5 1.5h-12A1.5 1.5 0 0 1 1 14.5V14H.5a.5.5 0 0 1 0-1H1V9H.5a.5.5 0 0 1 0-1H1V4H.5a.5.5 0 0 1 0-1H1v-.5zM2.5 2a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5h-12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.035 8h1.528c.047-.184.12-.357.214-.516l-1.08-1.08A3.482 3.482 0 0 0 5.035 8zm1.369-2.303 1.08 1.08c.16-.094.332-.167.516-.214V5.035a3.482 3.482 0 0 0-1.596.662zM9 5.035v1.528c.184.047.357.12.516.214l1.08-1.08A3.482 3.482 0 0 0 9 5.035zm2.303 1.369-1.08 1.08c.094.16.167.332.214.516h1.528a3.483 3.483 0 0 0-.662-1.596zM11.965 9h-1.528c-.047.184-.12.357-.214.516l1.08 1.08A3.483 3.483 0 0 0 11.965 9zm-1.369 2.303-1.08-1.08c-.16.094-.332.167-.516.214v1.528a3.483 3.483 0 0 0 1.596-.662zM8 11.965v-1.528a1.989 1.989 0 0 1-.516-.214l-1.08 1.08A3.483 3.483 0 0 0 8 11.965zm-2.303-1.369 1.08-1.08A1.988 1.988 0 0 1 6.563 9H5.035c.085.593.319 1.138.662 1.596zM4 8.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0zm4.5-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
                }
            }
        ]
    })(props);
}
function BsSaveFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 1.5A1.5 1.5 0 0 1 10 0h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h6c-.314.418-.5.937-.5 1.5v7.793L4.854 6.646a.5.5 0 1 0-.708.708l3.5 3.5a.5.5 0 0 0 .708 0l3.5-3.5a.5.5 0 0 0-.708-.708L8.5 9.293V1.5z"
                }
            }
        ]
    })(props);
}
function BsSave(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v7.293l2.646-2.647a.5.5 0 0 1 .708.708l-3.5 3.5a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L7.5 9.293V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1H2z"
                }
            }
        ]
    })(props);
}
function BsSave2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 1.5A1.5 1.5 0 0 1 10 0h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h6c-.314.418-.5.937-.5 1.5v6h-2a.5.5 0 0 0-.354.854l2.5 2.5a.5.5 0 0 0 .708 0l2.5-2.5A.5.5 0 0 0 10.5 7.5h-2v-6z"
                }
            }
        ]
    })(props);
}
function BsSave2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v4.5h2a.5.5 0 0 1 .354.854l-2.5 2.5a.5.5 0 0 1-.708 0l-2.5-2.5A.5.5 0 0 1 5.5 6.5h2V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1H2z"
                }
            }
        ]
    })(props);
}
function BsScissors(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 3.5c-.614-.884-.074-1.962.858-2.5L8 7.226 11.642 1c.932.538 1.472 1.616.858 2.5L8.81 8.61l1.556 2.661a2.5 2.5 0 1 1-.794.637L8 9.73l-1.572 2.177a2.5 2.5 0 1 1-.794-.637L7.19 8.61 3.5 3.5zm2.5 10a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0zm7 0a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z"
                }
            }
        ]
    })(props);
}
function BsScooter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-.39l1.4 7a2.5 2.5 0 1 1-.98.195l-.189-.938-2.43 3.527A.5.5 0 0 1 9.5 13H4.95a2.5 2.5 0 1 1 0-1h4.287l2.831-4.11L11.09 3H9.5a.5.5 0 0 1-.5-.5ZM3.915 12a1.5 1.5 0 1 0 0 1H2.5a.5.5 0 0 1 0-1h1.415Zm8.817-.789A1.499 1.499 0 0 0 13.5 14a1.5 1.5 0 0 0 .213-2.985l.277 1.387a.5.5 0 0 1-.98.196l-.278-1.387Z"
                }
            }
        ]
    })(props);
}
function BsScrewdriver(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 .995.995 0l3.064 2.19a.995.995 0 0 1 .417.809v.07c0 .264.105.517.291.704l5.677 5.676.909-.303a.995.995 0 0 1 1.018.24l3.338 3.339a.995.995 0 0 1 0 1.406L14.13 15.71a.995.995 0 0 1-1.406 0l-3.337-3.34a.995.995 0 0 1-.24-1.018l.302-.909-5.676-5.677a.995.995 0 0 0-.704-.291H3a.995.995 0 0 1-.81-.417L0 .995Zm11.293 9.595a.497.497 0 1 0-.703.703l2.984 2.984a.497.497 0 0 0 .703-.703l-2.984-2.984Z"
                }
            }
        ]
    })(props);
}
function BsSdCardFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 0H5.914a1.5 1.5 0 0 0-1.06.44L2.439 2.853A1.5 1.5 0 0 0 2 3.914V14.5A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-13A1.5 1.5 0 0 0 12.5 0Zm-7 2.75a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75Zm2 0a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75Zm2.75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 1.5 0Zm1.25-.75a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75Z"
                }
            }
        ]
    })(props);
}
function BsSdCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.25 3.5a.75.75 0 0 0-1.5 0v2a.75.75 0 0 0 1.5 0v-2zm2 0a.75.75 0 0 0-1.5 0v2a.75.75 0 0 0 1.5 0v-2zm2 0a.75.75 0 0 0-1.5 0v2a.75.75 0 0 0 1.5 0v-2zm2 0a.75.75 0 0 0-1.5 0v2a.75.75 0 0 0 1.5 0v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.914 0H12.5A1.5 1.5 0 0 1 14 1.5v13a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5V3.914c0-.398.158-.78.44-1.06L4.853.439A1.5 1.5 0 0 1 5.914 0zM13 1.5a.5.5 0 0 0-.5-.5H5.914a.5.5 0 0 0-.353.146L3.146 3.561A.5.5 0 0 0 3 3.914V14.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-13z"
                }
            }
        ]
    })(props);
}
function BsSearchHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 13a6.474 6.474 0 0 0 3.845-1.258h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.008 1.008 0 0 0-.115-.1A6.471 6.471 0 0 0 13 6.5 6.502 6.502 0 0 0 6.5 0a6.5 6.5 0 1 0 0 13Zm0-8.518c1.664-1.673 5.825 1.254 0 5.018-5.825-3.764-1.664-6.69 0-5.018Z"
                }
            }
        ]
    })(props);
}
function BsSearchHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 4.482c1.664-1.673 5.825 1.254 0 5.018-5.825-3.764-1.664-6.69 0-5.018Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6.5a6.471 6.471 0 0 1-1.258 3.844c.04.03.078.062.115.098l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1.007 1.007 0 0 1-.1-.115h.002A6.5 6.5 0 1 1 13 6.5ZM6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z"
                }
            }
        ]
    })(props);
}
function BsSearch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
                }
            }
        ]
    })(props);
}
function BsSegmentedNav(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6zm6 3h4V5H6v4zm9-1V6a1 1 0 0 0-1-1h-3v4h3a1 1 0 0 0 1-1z"
                }
            }
        ]
    })(props);
}
function BsSendArrowDownFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.854.146a.5.5 0 0 1 .11.54L13.026 8.03A4.5 4.5 0 0 0 8 12.5c0 .5 0 1.5-.773.36l-1.59-2.498L.644 7.184l-.002-.001-.41-.261a.5.5 0 0 1 .083-.886l.452-.18.001-.001L15.314.035a.5.5 0 0 1 .54.111ZM6.637 10.07l7.494-7.494.471-1.178-1.178.471L5.93 9.363l.338.215a.5.5 0 0 1 .154.154l.215.338Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.354-1.646a.5.5 0 0 1-.722-.016l-1.149-1.25a.5.5 0 1 1 .737-.676l.28.305V11a.5.5 0 0 1 1 0v1.793l.396-.397a.5.5 0 0 1 .708.708l-1.25 1.25Z"
                }
            }
        ]
    })(props);
}
function BsSendArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.854.146a.5.5 0 0 1 .11.54l-2.8 7a.5.5 0 1 1-.928-.372l1.895-4.738-7.494 7.494 1.376 2.162a.5.5 0 1 1-.844.537l-1.531-2.407L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM5.93 9.363l7.494-7.494L1.591 6.602l4.339 2.76Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.354-1.646a.5.5 0 0 1-.722-.016l-1.149-1.25a.5.5 0 1 1 .737-.676l.28.305V11a.5.5 0 0 1 1 0v1.793l.396-.397a.5.5 0 0 1 .708.708l-1.25 1.25Z"
                }
            }
        ]
    })(props);
}
function BsSendArrowUpFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.854.146a.5.5 0 0 1 .11.54L13.026 8.03A4.5 4.5 0 0 0 8 12.5c0 .5 0 1.5-.773.36l-1.59-2.498L.644 7.184l-.002-.001-.41-.261a.5.5 0 0 1 .083-.886l.452-.18.001-.001L15.314.035a.5.5 0 0 1 .54.111ZM6.637 10.07l7.494-7.494.471-1.178-1.178.471L5.93 9.363l.338.215a.5.5 0 0 1 .154.154l.215.338Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.354-5.354a.5.5 0 0 0-.722.016l-1.149 1.25a.5.5 0 1 0 .737.676l.28-.305V14a.5.5 0 0 0 1 0v-1.793l.396.397a.5.5 0 0 0 .708-.708l-1.25-1.25Z"
                }
            }
        ]
    })(props);
}
function BsSendArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.854.146a.5.5 0 0 1 .11.54l-2.8 7a.5.5 0 1 1-.928-.372l1.895-4.738-7.494 7.494 1.376 2.162a.5.5 0 1 1-.844.537l-1.531-2.407L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM5.93 9.363l7.494-7.494L1.591 6.602l4.339 2.76Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.354-5.354a.5.5 0 0 0-.722.016l-1.149 1.25a.5.5 0 1 0 .737.676l.28-.305V14a.5.5 0 0 0 1 0v-1.793l.396.397a.5.5 0 0 0 .708-.708l-1.25-1.25Z"
                }
            }
        ]
    })(props);
}
function BsSendCheckFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z"
                }
            }
        ]
    })(props);
}
function BsSendCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855a.75.75 0 0 0-.124 1.329l4.995 3.178 1.531 2.406a.5.5 0 0 0 .844-.536L6.637 10.07l7.494-7.494-1.895 4.738a.5.5 0 1 0 .928.372l2.8-7Zm-2.54 1.183L5.93 9.363 1.591 6.602l11.833-4.733Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z"
                }
            }
        ]
    })(props);
}
function BsSendDashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-5.5 0a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5Z"
                }
            }
        ]
    })(props);
}
function BsSendDash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855a.75.75 0 0 0-.124 1.329l4.995 3.178 1.531 2.406a.5.5 0 0 0 .844-.536L6.637 10.07l7.494-7.494-1.895 4.738a.5.5 0 1 0 .928.372l2.8-7Zm-2.54 1.183L5.93 9.363 1.591 6.602l11.833-4.733Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-5.5 0a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5Z"
                }
            }
        ]
    })(props);
}
function BsSendExclamationFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.5-5v1.5a.5.5 0 0 1-1 0V11a.5.5 0 0 1 1 0Zm0 3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
                }
            }
        ]
    })(props);
}
function BsSendExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855a.75.75 0 0 0-.124 1.329l4.995 3.178 1.531 2.406a.5.5 0 0 0 .844-.536L6.637 10.07l7.494-7.494-1.895 4.738a.5.5 0 1 0 .928.372l2.8-7Zm-2.54 1.183L5.93 9.363 1.591 6.602l11.833-4.733Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.5-5v1.5a.5.5 0 0 1-1 0V11a.5.5 0 0 1 1 0Zm0 3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
                }
            }
        ]
    })(props);
}
function BsSendFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083l6-15Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z"
                }
            }
        ]
    })(props);
}
function BsSendPlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-3.5-2a.5.5 0 0 0-.5.5v1h-1a.5.5 0 0 0 0 1h1v1a.5.5 0 0 0 1 0v-1h1a.5.5 0 0 0 0-1h-1v-1a.5.5 0 0 0-.5-.5Z"
                }
            }
        ]
    })(props);
}
function BsSendPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855a.75.75 0 0 0-.124 1.329l4.995 3.178 1.531 2.406a.5.5 0 0 0 .844-.536L6.637 10.07l7.494-7.494-1.895 4.738a.5.5 0 1 0 .928.372l2.8-7Zm-2.54 1.183L5.93 9.363 1.591 6.602l11.833-4.733Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-3.5-2a.5.5 0 0 0-.5.5v1h-1a.5.5 0 0 0 0 1h1v1a.5.5 0 0 0 1 0v-1h1a.5.5 0 0 0 0-1h-1v-1a.5.5 0 0 0-.5-.5Z"
                }
            }
        ]
    })(props);
}
function BsSendSlashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.975 10.025a3.5 3.5 0 1 0-4.95 4.95 3.5 3.5 0 0 0 4.95-4.95Zm-4.243.707a2.501 2.501 0 0 1 3.147-.318l-3.465 3.465a2.501 2.501 0 0 1 .318-3.147Zm.39 3.854 3.464-3.465a2.501 2.501 0 0 1-3.465 3.465Z"
                }
            }
        ]
    })(props);
}
function BsSendSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855a.75.75 0 0 0-.124 1.329l4.995 3.178 1.531 2.406a.5.5 0 0 0 .844-.536L6.637 10.07l7.494-7.494-1.895 4.738a.5.5 0 1 0 .928.372l2.8-7Zm-2.54 1.183L5.93 9.363 1.591 6.602l11.833-4.733Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.975 10.025a3.5 3.5 0 1 0-4.95 4.95 3.5 3.5 0 0 0 4.95-4.95Zm-4.243.707a2.501 2.501 0 0 1 3.147-.318l-3.465 3.465a2.501 2.501 0 0 1 .318-3.147Zm.39 3.854 3.464-3.465a2.501 2.501 0 0 1-3.465 3.465Z"
                }
            }
        ]
    })(props);
}
function BsSendXFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47L15.964.686Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-4.854-1.354a.5.5 0 0 0 0 .708l.647.646-.647.646a.5.5 0 0 0 .708.708l.646-.647.646.647a.5.5 0 0 0 .708-.708l-.647-.646.647-.646a.5.5 0 0 0-.708-.708l-.646.647-.646-.647a.5.5 0 0 0-.708 0Z"
                }
            }
        ]
    })(props);
}
function BsSendX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855a.75.75 0 0 0-.124 1.329l4.995 3.178 1.531 2.406a.5.5 0 0 0 .844-.536L6.637 10.07l7.494-7.494-1.895 4.738a.5.5 0 1 0 .928.372l2.8-7Zm-2.54 1.183L5.93 9.363 1.591 6.602l11.833-4.733Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-4.854-1.354a.5.5 0 0 0 0 .708l.647.646-.647.646a.5.5 0 0 0 .708.708l.646-.647.646.647a.5.5 0 0 0 .708-.708l-.647-.646.647-.646a.5.5 0 0 0-.708-.708l-.646.647-.646-.647a.5.5 0 0 0-.708 0Z"
                }
            }
        ]
    })(props);
}
function BsSend(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576 6.636 10.07Zm6.787-8.201L1.591 6.602l4.339 2.76 7.494-7.493Z"
                }
            }
        ]
    })(props);
}
function BsServer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.333 2.667C1.333 1.194 4.318 0 8 0s6.667 1.194 6.667 2.667V4c0 1.473-2.985 2.667-6.667 2.667S1.333 5.473 1.333 4V2.667z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.333 6.334v3C1.333 10.805 4.318 12 8 12s6.667-1.194 6.667-2.667V6.334a6.51 6.51 0 0 1-1.458.79C11.81 7.684 9.967 8 8 8c-1.966 0-3.809-.317-5.208-.876a6.508 6.508 0 0 1-1.458-.79z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.667 11.668a6.51 6.51 0 0 1-1.458.789c-1.4.56-3.242.876-5.21.876-1.966 0-3.809-.316-5.208-.876a6.51 6.51 0 0 1-1.458-.79v1.666C1.333 14.806 4.318 16 8 16s6.667-1.194 6.667-2.667v-1.665z"
                }
            }
        ]
    })(props);
}
function BsShadows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-8 7a.5.5 0 0 1 0-1h3.5c.032 0 .063.003.093.009A7.032 7.032 0 0 0 12.9 13H8a.5.5 0 0 1 0-1h5.745c.22-.315.415-.65.581-1H8a.5.5 0 0 1 0-1h6.71a7.03 7.03 0 0 0 .22-1H8a.5.5 0 0 1 0-1h7c0-.34-.024-.673-.07-1H8a.5.5 0 0 1 0-1h6.71a6.949 6.949 0 0 0-.384-1H8a.5.5 0 0 1 0-1h5.745a7.035 7.035 0 0 0-.846-1H8a.5.5 0 0 1 0-1h3.608A7 7 0 1 0 8 15Z"
                }
            }
        ]
    })(props);
}
function BsShareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z"
                }
            }
        ]
    })(props);
}
function BsShare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5zm-8.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm11 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z"
                }
            }
        ]
    })(props);
}
function BsShieldCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                }
            }
        ]
    })(props);
}
function BsShieldExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.001 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.553.553 0 0 1-1.1 0L7.1 4.995z"
                }
            }
        ]
    })(props);
}
function BsShieldFillCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.775 11.775 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.541 1.541 0 0 0-1.044-1.263 62.467 62.467 0 0 0-2.887-.87C9.843.266 8.69 0 8 0zm2.146 5.146a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647z"
                }
            }
        ]
    })(props);
}
function BsShieldFillExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.775 11.775 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.541 1.541 0 0 0-1.044-1.263 62.467 62.467 0 0 0-2.887-.87C9.843.266 8.69 0 8 0zm-.55 8.502L7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0zM8.002 12a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                }
            }
        ]
    })(props);
}
function BsShieldFillMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.775 11.775 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.541 1.541 0 0 0-1.044-1.263 62.467 62.467 0 0 0-2.887-.87C9.843.266 8.69 0 8 0zM6 7.5a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1H6z"
                }
            }
        ]
    })(props);
}
function BsShieldFillPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.775 11.775 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.541 1.541 0 0 0-1.044-1.263 62.467 62.467 0 0 0-2.887-.87C9.843.266 8.69 0 8 0zm-.5 5a.5.5 0 0 1 1 0v1.5H10a.5.5 0 0 1 0 1H8.5V9a.5.5 0 0 1-1 0V7.5H6a.5.5 0 0 1 0-1h1.5V5z"
                }
            }
        ]
    })(props);
}
function BsShieldFillX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.775 11.775 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.541 1.541 0 0 0-1.044-1.263 62.467 62.467 0 0 0-2.887-.87C9.843.266 8.69 0 8 0zM6.854 5.146 8 6.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 7l1.147 1.146a.5.5 0 0 1-.708.708L8 7.707 6.854 8.854a.5.5 0 1 1-.708-.708L7.293 7 6.146 5.854a.5.5 0 1 1 .708-.708z"
                }
            }
        ]
    })(props);
}
function BsShieldFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z"
                }
            }
        ]
    })(props);
}
function BsShieldLockFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.775 11.775 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.541 1.541 0 0 0-1.044-1.263 62.467 62.467 0 0 0-2.887-.87C9.843.266 8.69 0 8 0zm0 5a1.5 1.5 0 0 1 .5 2.915l.385 1.99a.5.5 0 0 1-.491.595h-.788a.5.5 0 0 1-.49-.595l.384-1.99A1.5 1.5 0 0 1 8 5z"
                }
            }
        ]
    })(props);
}
function BsShieldLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 6.5a1.5 1.5 0 0 1-1 1.415l.385 1.99a.5.5 0 0 1-.491.595h-.788a.5.5 0 0 1-.49-.595l.384-1.99a1.5 1.5 0 1 1 2-1.415z"
                }
            }
        ]
    })(props);
}
function BsShieldMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 7a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsShieldPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V9a.5.5 0 0 1-1 0V7.5H6a.5.5 0 0 1 0-1h1.5V5a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsShieldShaded(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 14.933a.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067v13.866zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z"
                }
            }
        ]
    })(props);
}
function BsShieldSlashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.093 3.093c-.465 4.275.885 7.46 2.513 9.589a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.32 11.32 0 0 0 1.733-1.525L1.093 3.093zm12.215 8.215L3.128 1.128A61.369 61.369 0 0 1 5.073.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.483 3.626-.332 6.491-1.551 8.616zm.338 3.046-13-13 .708-.708 13 13-.707.707z"
                }
            }
        ]
    })(props);
}
function BsShieldSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.093 3.093c-.465 4.275.885 7.46 2.513 9.589a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.32 11.32 0 0 0 1.733-1.525l-.745-.745a10.27 10.27 0 0 1-1.578 1.392c-.346.244-.652.42-.893.533-.12.057-.218.095-.293.118a.55.55 0 0 1-.101.025.615.615 0 0 1-.1-.025 2.348 2.348 0 0 1-.294-.118 6.141 6.141 0 0 1-.893-.533 10.725 10.725 0 0 1-2.287-2.233C3.053 10.228 1.879 7.594 2.06 4.06l-.967-.967zM3.98 1.98l-.852-.852A58.935 58.935 0 0 1 5.072.559C6.157.266 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.483 3.626-.332 6.491-1.551 8.616l-.77-.77c1.042-1.915 1.72-4.469 1.29-7.702a.48.48 0 0 0-.33-.39c-.65-.213-1.75-.56-2.836-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524a49.7 49.7 0 0 0-1.357.39zm9.666 12.374-13-13 .708-.708 13 13-.707.707z"
                }
            }
        ]
    })(props);
}
function BsShieldX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.146 5.146a.5.5 0 0 1 .708 0L8 6.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 7l1.147 1.146a.5.5 0 0 1-.708.708L8 7.707 6.854 8.854a.5.5 0 1 1-.708-.708L7.293 7 6.146 5.854a.5.5 0 0 1 0-.708z"
                }
            }
        ]
    })(props);
}
function BsShield(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z"
                }
            }
        ]
    })(props);
}
function BsShiftFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.27 2.047a1 1 0 0 1 1.46 0l6.345 6.77c.6.638.146 1.683-.73 1.683H11.5v3a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-3H1.654C.78 10.5.326 9.455.924 8.816L7.27 2.047z"
                }
            }
        ]
    })(props);
}
function BsShift(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.27 2.047a1 1 0 0 1 1.46 0l6.345 6.77c.6.638.146 1.683-.73 1.683H11.5v3a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-3H1.654C.78 10.5.326 9.455.924 8.816L7.27 2.047zM14.346 9.5 8 2.731 1.654 9.5H4.5a1 1 0 0 1 1 1v3h5v-3a1 1 0 0 1 1-1h2.846z"
                }
            }
        ]
    })(props);
}
function BsShopWindow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.97 1.35A1 1 0 0 1 3.73 1h8.54a1 1 0 0 1 .76.35l2.609 3.044A1.5 1.5 0 0 1 16 5.37v.255a2.375 2.375 0 0 1-4.25 1.458A2.371 2.371 0 0 1 9.875 8 2.37 2.37 0 0 1 8 7.083 2.37 2.37 0 0 1 6.125 8a2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.625V5.37a1.5 1.5 0 0 1 .361-.976l2.61-3.045zm1.78 4.275a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 1 0 2.75 0V5.37a.5.5 0 0 0-.12-.325L12.27 2H3.73L1.12 5.045A.5.5 0 0 0 1 5.37v.255a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0zM1.5 8.5A.5.5 0 0 1 2 9v6h12V9a.5.5 0 0 1 1 0v6h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V9a.5.5 0 0 1 .5-.5zm2 .5a.5.5 0 0 1 .5.5V13h8V9.5a.5.5 0 0 1 1 0V13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsShop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.97 1.35A1 1 0 0 1 3.73 1h8.54a1 1 0 0 1 .76.35l2.609 3.044A1.5 1.5 0 0 1 16 5.37v.255a2.375 2.375 0 0 1-4.25 1.458A2.371 2.371 0 0 1 9.875 8 2.37 2.37 0 0 1 8 7.083 2.37 2.37 0 0 1 6.125 8a2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.625V5.37a1.5 1.5 0 0 1 .361-.976l2.61-3.045zm1.78 4.275a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 1 0 2.75 0V5.37a.5.5 0 0 0-.12-.325L12.27 2H3.73L1.12 5.045A.5.5 0 0 0 1 5.37v.255a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0zM1.5 8.5A.5.5 0 0 1 2 9v6h1v-5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5h6V9a.5.5 0 0 1 1 0v6h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V9a.5.5 0 0 1 .5-.5zM4 15h3v-5H4v5zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3zm3 0h-2v3h2v-3z"
                }
            }
        ]
    })(props);
}
function BsShuffle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M0 3.5A.5.5 0 0 1 .5 3H1c2.202 0 3.827 1.24 4.874 2.418.49.552.865 1.102 1.126 1.532.26-.43.636-.98 1.126-1.532C9.173 4.24 10.798 3 13 3v1c-1.798 0-3.173 1.01-4.126 2.082A9.624 9.624 0 0 0 7.556 8a9.624 9.624 0 0 0 1.317 1.918C9.828 10.99 11.204 12 13 12v1c-2.202 0-3.827-1.24-4.874-2.418A10.595 10.595 0 0 1 7 9.05c-.26.43-.636.98-1.126 1.532C4.827 11.76 3.202 13 1 13H.5a.5.5 0 0 1 0-1H1c1.798 0 3.173-1.01 4.126-2.082A9.624 9.624 0 0 0 6.444 8a9.624 9.624 0 0 0-1.317-1.918C4.172 5.01 2.796 4 1 4H.5a.5.5 0 0 1-.5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5.466V1.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192zm0 9v-3.932a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192z"
                }
            }
        ]
    })(props);
}
function BsSignDeadEndFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.116 6.28h.32c.395 0 .582.24.582.722 0 .48-.186.718-.581.718h-.321V6.28Zm3.636.066.268.845h-.552l.27-.845h.014Zm1.327-.066h.32c.394 0 .582.24.582.722 0 .48-.186.718-.582.718h-.32V6.28Zm-.792 3h.32c.395 0 .582.24.582.722 0 .48-.186.718-.581.718h-.32V9.28Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435ZM4.782 6h.69c.596 0 .886.355.886.998S6.066 8 5.473 8h-.69V6ZM7.82 7.72V8H6.571V6H7.82v.28h-.917v.57h.863v.268h-.863v.602h.917Zm.397.28h-.34l.688-2h.371l.689 2h-.352l-.177-.554h-.702L8.216 8Zm1.53-2h.69c.596 0 .886.355.886.998S11.03 8 10.436 8h-.69V6Zm-2.923 4.72V11H5.575V9h1.248v.28h-.917v.57h.863v.268h-.863v.602h.917Zm.572.28h-.32V9h.294l.933 1.436h.014V9h.32v2h-.292l-.936-1.44h-.013V11Zm1.56-2h.69c.596 0 .886.355.886.998S10.238 11 9.645 11h-.69V9Z"
                }
            }
        ]
    })(props);
}
function BsSignDeadEnd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.783 6v2h.69c.593 0 .886-.359.886-1.002S6.07 6 5.473 6h-.69Zm.333.28h.32c.395 0 .582.24.582.722 0 .48-.186.718-.581.718h-.321V6.28ZM7.82 7.72h-.918v-.602h.863V6.85h-.863v-.57h.917V6H6.571v2H7.82v-.28Zm.573-.274L8.216 8h-.34l.688-2h.371l.689 2h-.352l-.177-.554h-.702Zm.627-.255-.268-.845h-.015l-.27.845h.553ZM9.746 6v2h.69c.593 0 .886-.359.886-1.002S11.032 6 10.436 6h-.69Zm.333.28h.32c.394 0 .582.24.582.722 0 .48-.186.718-.582.718h-.32V6.28Zm-4.173 4.44h.917V11H5.575V9h1.248v.28h-.917v.57h.863v.268h-.863v.602Zm1.489.28V9.56h.013L8.344 11h.292V9h-.32v1.436h-.014L7.369 9h-.293v2h.319Zm1.56 0V9h.69c.596 0 .886.355.886.998S10.238 11 9.645 11h-.69Zm.653-1.72h-.32v1.44h.32c.395 0 .581-.239.581-.718 0-.481-.187-.722-.581-.722Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435Zm-1.4.7a.495.495 0 0 1 .7 0l6.516 6.515a.495.495 0 0 1 0 .7L8.35 14.866a.495.495 0 0 1-.7 0L1.134 8.35a.495.495 0 0 1 0-.7L7.65 1.134Z"
                }
            }
        ]
    })(props);
}
function BsSignDoNotEnterFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.237 4.28h-.32v1.44h.32c.396 0 .582-.239.582-.718 0-.481-.188-.722-.582-.722Zm2.392.859v-.277c0-.413-.211-.617-.494-.617-.285 0-.495.204-.495.617v.277c0 .414.21.618.495.618.283 0 .494-.204.494-.618Zm4.163 0v-.277c0-.413-.211-.617-.494-.617-.285 0-.495.204-.495.617v.277c0 .414.21.618.495.618.283 0 .494-.204.494-.618Zm.006 5.828v-.694h.39c.231 0 .378.126.378.354 0 .225-.142.34-.387.34h-.38Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16ZM3.584 6V4h.69c.596 0 .886.355.886.998S4.867 6 4.274 6h-.69Zm3.382-1.135v.272c0 .566-.318.903-.83.903-.513 0-.833-.337-.833-.903v-.272c0-.569.32-.904.832-.904.513 0 .83.337.83.904Zm1.021-.305V6h-.319V4h.293l.933 1.436h.015V4h.319v2h-.291L8 4.56h-.013Zm3.142.305v.272c0 .566-.318.903-.83.903-.513 0-.833-.337-.833-.903v-.272c0-.569.32-.904.832-.904.513 0 .83.337.83.904Zm.899-.58V6h-.333V4.285h-.584V4h1.503v.285h-.586ZM5.413 11.72V12H4.165v-2h1.248v.28h-.917v.57h.862v.268h-.862v.602h.917Zm.572.28h-.32v-2h.294l.933 1.436h.014v-1.435h.32V12h-.292l-.936-1.44h-.013V12Zm2.279 0H7.93v-1.715h-.584V10H8.85v.284h-.586V12Zm1.953-.28V12H8.97v-2h1.248v.28H9.3v.57h.863v.268H9.3v.602h.917ZM11.235 10c.42 0 .674.244.674.616a.575.575 0 0 1-.368.56l.404.824h-.373l-.36-.769h-.414V12h-.328v-2h.765ZM3.5 7h9a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5Z"
                }
            }
        ]
    })(props);
}
function BsSignDoNotEnter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.584 6V4h.69c.596 0 .886.355.886.998S4.867 6 4.274 6h-.69Zm.653-1.72h-.32v1.44h.32c.396 0 .582-.239.582-.718 0-.481-.188-.722-.582-.722Zm2.729.585v.272c0 .566-.318.903-.83.903-.513 0-.833-.337-.833-.903v-.272c0-.569.32-.904.832-.904.513 0 .83.337.83.904Zm-.337.274v-.277c0-.413-.211-.617-.494-.617-.285 0-.495.204-.495.617v.277c0 .414.21.618.495.618.283 0 .494-.204.494-.618Zm1.358-.579V6h-.319V4h.293l.933 1.436h.015V4h.319v2h-.291L8 4.56h-.013Zm3.142.305v.272c0 .566-.318.903-.83.903-.513 0-.833-.337-.833-.903v-.272c0-.569.32-.904.832-.904.513 0 .83.337.83.904Zm-.337.274v-.277c0-.413-.211-.617-.494-.617-.285 0-.495.204-.495.617v.277c0 .414.21.618.495.618.283 0 .494-.204.494-.618Zm1.236-.854V6h-.333V4.285h-.584V4h1.503v.285h-.586ZM4.496 11.72h.917V12H4.165v-2h1.248v.28h-.917v.57h.862v.268h-.862v.602Zm1.489-1.16V12h-.32v-2h.294l.933 1.436h.014v-1.435h.32V12h-.292l-.936-1.44h-.013Zm2.279-.275V12H7.93v-1.715h-.584V10H8.85v.284h-.586ZM9.3 11.72h.917V12H8.97v-2h1.248v.28H9.3v.57h.863v.268H9.3v.602ZM10.47 10h.765c.42 0 .674.244.674.616a.575.575 0 0 1-.368.56l.404.824h-.373l-.36-.769h-.414V12h-.328v-2Zm.328.273v.694h.381c.245 0 .387-.115.387-.34 0-.228-.147-.354-.378-.354h-.39ZM3.5 7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-9Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm0-1A7 7 0 1 1 8 1a7 7 0 0 1 0 14Z"
                }
            }
        ]
    })(props);
}
function BsSignIntersectionFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435ZM7.25 4h1.5v3.25H12v1.5H8.75V12h-1.5V8.75H4v-1.5h3.25V4Z"
                }
            }
        ]
    })(props);
}
function BsSignIntersectionSideFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435ZM6.25 4h1.5v3.25H11v1.5H7.75V12h-1.5V4Z"
                }
            }
        ]
    })(props);
}
function BsSignIntersectionSide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.25 4v8h1.5V8.75H11v-1.5H7.75V4h-1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435Zm-1.4.7a.495.495 0 0 1 .7 0l6.516 6.515a.495.495 0 0 1 0 .7L8.35 14.866a.495.495 0 0 1-.7 0L1.134 8.35a.495.495 0 0 1 0-.7L7.65 1.134Z"
                }
            }
        ]
    })(props);
}
function BsSignIntersectionTFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435ZM5 5h6v1.5H8.75V12h-1.5V6.5H5V5Z"
                }
            }
        ]
    })(props);
}
function BsSignIntersectionT(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5v1.5h2.25V12h1.5V6.5H11V5H5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435Zm-1.4.7a.495.495 0 0 1 .7 0l6.516 6.515a.495.495 0 0 1 0 .7L8.35 14.866a.495.495 0 0 1-.7 0L1.134 8.35a.495.495 0 0 1 0-.7L7.65 1.134Z"
                }
            }
        ]
    })(props);
}
function BsSignIntersectionYFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435Zm1.443 4.762 1.014 1.106L8.75 8.83V12h-1.5V8.83L4.493 6.303l1.014-1.106L8 7.483l2.493-2.286Z"
                }
            }
        ]
    })(props);
}
function BsSignIntersectionY(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.493 5.197 8 7.483 5.507 5.197 4.493 6.303 7.25 8.83V12h1.5V8.83l2.757-2.527-1.014-1.106Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435Zm-1.4.7a.495.495 0 0 1 .7 0l6.516 6.515a.495.495 0 0 1 0 .7L8.35 14.866a.495.495 0 0 1-.7 0L1.134 8.35a.495.495 0 0 1 0-.7L7.65 1.134Z"
                }
            }
        ]
    })(props);
}
function BsSignIntersection(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.25 4v3.25H4v1.5h3.25V12h1.5V8.75H12v-1.5H8.75V4h-1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435Zm-1.4.7a.495.495 0 0 1 .7 0l6.516 6.515a.495.495 0 0 1 0 .7L8.35 14.866a.495.495 0 0 1-.7 0L1.134 8.35a.495.495 0 0 1 0-.7L7.65 1.134Z"
                }
            }
        ]
    })(props);
}
function BsSignMergeLeftFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435ZM7.25 6H6.034a.25.25 0 0 1-.192-.41l1.966-2.36a.25.25 0 0 1 .384 0l1.966 2.36a.25.25 0 0 1-.192.41H8.75v6h-1.5V8.823c-.551.686-1.229 1.363-1.88 2.015l-.016.016-.708-.708c.757-.756 1.48-1.48 2.016-2.196.25-.333.448-.649.588-.95V6Z"
                }
            }
        ]
    })(props);
}
function BsSignMergeLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.25 6v1c-.14.301-.338.617-.588.95-.537.716-1.259 1.44-2.016 2.196l.708.708.015-.016c.652-.652 1.33-1.33 1.881-2.015V12h1.5V6h1.216a.25.25 0 0 0 .192-.41L8.192 3.23a.25.25 0 0 0-.384 0L5.842 5.59a.25.25 0 0 0 .192.41H7.25Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435Zm-1.4.7a.495.495 0 0 1 .7 0l6.516 6.515a.495.495 0 0 1 0 .7L8.35 14.866a.495.495 0 0 1-.7 0L1.134 8.35a.495.495 0 0 1 0-.7L7.65 1.134Z"
                }
            }
        ]
    })(props);
}
function BsSignMergeRightFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435ZM8.75 6v1c.14.301.338.617.588.95.537.716 1.259 1.44 2.016 2.196l-.708.708-.015-.016c-.652-.652-1.33-1.33-1.881-2.015V12h-1.5V6H6.034a.25.25 0 0 1-.192-.41l1.966-2.36a.25.25 0 0 1 .384 0l1.966 2.36a.25.25 0 0 1-.192.41H8.75Z"
                }
            }
        ]
    })(props);
}
function BsSignMergeRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.75 6v1c.14.301.338.617.588.95.537.716 1.259 1.44 2.016 2.196l-.708.708-.015-.016c-.652-.652-1.33-1.33-1.881-2.015V12h-1.5V6H6.034a.25.25 0 0 1-.192-.41l1.966-2.36a.25.25 0 0 1 .384 0l1.966 2.36a.25.25 0 0 1-.192.41H8.75Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435Zm-1.4.7a.495.495 0 0 1 .7 0l6.516 6.515a.495.495 0 0 1 0 .7L8.35 14.866a.495.495 0 0 1-.7 0L1.134 8.35a.495.495 0 0 1 0-.7L7.65 1.134Z"
                }
            }
        ]
    })(props);
}
function BsSignNoLeftTurnFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 13.292A8 8 0 0 1 13.293 2L9.195 6.099A2.501 2.501 0 0 0 8.5 6H7V4.534a.25.25 0 0 0-.41-.192L4.23 6.308a.25.25 0 0 0 0 .384l2.36 1.966a.265.265 0 0 0 .026.02L2 13.291Zm.708.708A8 8 0 0 0 14 2.707l-3.885 3.884C10.656 7.05 11 7.735 11 8.5V11h-1V8.5c0-.489-.234-.923-.596-1.197l-6.696 6.696Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.293 7 7 8.293V7h1.293Z"
                }
            }
        ]
    })(props);
}
function BsSignNoLeftTurn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 8a8 8 0 1 0 16 0A8 8 0 0 0 0 8Zm3.416 5.29 5.988-5.987c.362.274.596.708.596 1.197V11h1V8.5c0-.765-.344-1.45-.885-1.908l3.176-3.176a7 7 0 0 1-9.874 9.874Zm-.707-.706a7 7 0 0 1 9.874-9.874L9.196 6.097A2.501 2.501 0 0 0 8.5 6H7V4.534a.25.25 0 0 0-.41-.192L4.23 6.308a.25.25 0 0 0 0 .384l2.36 1.966a.265.265 0 0 0 .026.02l-3.907 3.906ZM8.293 7 7 8.293V7h1.293Z"
                }
            }
        ]
    })(props);
}
function BsSignNoParkingFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.292 14A8 8 0 0 1 2 2.707l3.5 3.5V12h1.283V9.164h1.674L13.292 14Zm.708-.708-4.37-4.37C10.5 8.524 11 7.662 11 6.587c0-1.482-.955-2.584-2.538-2.584H5.5v.79L2.708 2.002A8 8 0 0 1 14 13.293Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.777 7.485v.59h.59l-.59-.59Zm1.949.535L6.777 6.07v-.966H8.27c.893 0 1.419.539 1.419 1.482 0 .769-.35 1.273-.963 1.433Z"
                }
            }
        ]
    })(props);
}
function BsSignNoParking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm5.29-3.416L9.63 8.923C10.5 8.523 11 7.66 11 6.586c0-1.482-.955-2.584-2.538-2.584H5.5v.79L3.416 2.71a7 7 0 0 1 9.874 9.874Zm-.706.707A7 7 0 0 1 2.71 3.417l2.79 2.79V12h1.283V9.164h1.674l4.127 4.127ZM8.726 8.019 6.777 6.07v-.966H8.27c.893 0 1.419.539 1.419 1.482 0 .769-.35 1.273-.963 1.433Zm-1.949-.534.59.59h-.59v-.59Z"
                }
            }
        ]
    })(props);
}
function BsSignNoRightTurnFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 13.292A8 8 0 0 0 2.707 2l4.097 4.098C7.025 6.034 7.259 6 7.5 6H9V4.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L9.41 8.658a.265.265 0 0 1-.026.02L14 13.291Zm-.708.708A8 8 0 0 1 2 2.707l3.885 3.884A2.495 2.495 0 0 0 5 8.5V11h1V8.5c0-.489.234-.923.596-1.197l6.696 6.696Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.707 7 9 8.293V7H7.707Z"
                }
            }
        ]
    })(props);
}
function BsSignNoRightTurn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-3.416 5.29L6.596 7.304A1.498 1.498 0 0 0 6 8.5V11H5V8.5c0-.765.344-1.45.885-1.908L2.709 3.416a7 7 0 0 0 9.874 9.874Zm.707-.706A7 7 0 0 0 3.417 2.71l3.388 3.388C7.025 6.034 7.259 6 7.5 6H9V4.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L9.41 8.658a.265.265 0 0 1-.026.02l3.907 3.906ZM7.707 7 9 8.293V7H7.707Z"
                }
            }
        ]
    })(props);
}
function BsSignRailroadFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L4.224 3.162 8 6.94l3.777-3.777L9.049.435Zm3.274 7.425v-.862h.467c.28 0 .467.154.467.44 0 .28-.182.421-.475.421h-.459Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.838 4.223 9.06 8l3.777 3.777 2.727-2.728c.58-.58.58-1.519 0-2.098l-2.727-2.728Zm.03 2.361c.591 0 .935.334.935.844a.79.79 0 0 1-.485.748l.536 1.074h-.59l-.467-.994h-.473v.994h-.521V6.584h1.064Zm-1.091 6.254L8 9.06l-3.777 3.777 2.728 2.727c.58.58 1.519.58 2.098 0l2.728-2.727Zm-8.953-5.84v.861h.46c.292 0 .474-.14.474-.421 0-.286-.188-.44-.467-.44h-.467Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.162 11.777 6.94 8 3.162 4.223.435 6.951c-.58.58-.58 1.519 0 2.098l2.727 2.728Zm-.86-5.193h1.065c.592 0 .936.334.936.844 0 .39-.242.654-.485.748l.536 1.074h-.59l-.467-.994h-.473v.994h-.521V6.584Z"
                }
            }
        ]
    })(props);
}
function BsSignRailroad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.303 6.584h1.064c.592 0 .936.334.936.844a.79.79 0 0 1-.485.748l.536 1.074h-.59l-.467-.994h-.473v.994h-.521V6.584Zm.521.414v.861h.46c.292 0 .474-.14.474-.421 0-.286-.188-.44-.467-.44h-.467Zm-8.771-.414h1.064c.592 0 .936.334.936.844 0 .39-.242.654-.485.748l.536 1.074h-.59l-.467-.994h-.473v.994h-.521V6.584Zm.521.414v.861h.46c.292 0 .474-.14.474-.421 0-.286-.188-.44-.467-.44h-.467Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.482 1.482 0 0 1 0-2.098L6.95.435Zm1.4.7a.495.495 0 0 0-.7 0L4.923 3.861 8 6.939l3.078-3.077L8.35 1.134Zm3.788 3.788L9.061 8l3.077 3.078 2.728-2.728a.495.495 0 0 0 0-.7l-2.728-2.727Zm-1.06 7.215L8 9.061l-3.077 3.077 2.727 2.728a.495.495 0 0 0 .7 0l2.727-2.728Zm-7.216-1.06L6.939 8 3.862 4.923 1.134 7.65a.495.495 0 0 0 0 .7l2.728 2.728Z"
                }
            }
        ]
    })(props);
}
function BsSignStopFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.371 8.277v-.553c0-.827-.422-1.234-.987-1.234-.572 0-.99.407-.99 1.234v.553c0 .83.418 1.237.99 1.237.565 0 .987-.408.987-1.237Zm2.586-.24c.463 0 .735-.272.735-.744s-.272-.741-.735-.741h-.774v1.485h.774Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.893 0a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353L11.46.146A.5.5 0 0 0 11.107 0H4.893ZM3.16 10.08c-.931 0-1.447-.493-1.494-1.132h.653c.065.346.396.583.891.583.524 0 .83-.246.83-.62 0-.303-.203-.467-.637-.572l-.656-.164c-.61-.147-.978-.51-.978-1.078 0-.706.597-1.184 1.444-1.184.853 0 1.386.475 1.436 1.087h-.645c-.064-.32-.352-.542-.797-.542-.472 0-.77.246-.77.6 0 .261.196.437.553.522l.654.161c.673.164 1.06.487 1.06 1.11 0 .736-.574 1.228-1.544 1.228Zm3.427-3.51V10h-.665V6.57H4.753V6h3.006v.568H6.587Zm4.458 1.16v.544c0 1.131-.636 1.805-1.661 1.805-1.026 0-1.664-.674-1.664-1.805V7.73c0-1.136.638-1.807 1.664-1.807 1.025 0 1.66.674 1.66 1.807ZM11.52 6h1.535c.82 0 1.316.55 1.316 1.292 0 .747-.501 1.289-1.321 1.289h-.865V10h-.665V6.001Z"
                }
            }
        ]
    })(props);
}
function BsSignStopLightsFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435ZM6 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4Z"
                }
            }
        ]
    })(props);
}
function BsSignStopLights(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4Zm2 2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 2a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435Zm-1.4.7a.495.495 0 0 1 .7 0l6.516 6.515a.495.495 0 0 1 0 .7L8.35 14.866a.495.495 0 0 1-.7 0L1.134 8.35a.495.495 0 0 1 0-.7L7.65 1.134Z"
                }
            }
        ]
    })(props);
}
function BsSignStop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.16 10.08c-.931 0-1.447-.493-1.494-1.132h.653c.065.346.396.583.891.583.524 0 .83-.246.83-.62 0-.303-.203-.467-.637-.572l-.656-.164c-.61-.147-.978-.51-.978-1.078 0-.706.597-1.184 1.444-1.184.853 0 1.386.475 1.436 1.087h-.645c-.064-.32-.352-.542-.797-.542-.472 0-.77.246-.77.6 0 .261.196.437.553.522l.654.161c.673.164 1.06.487 1.06 1.11 0 .736-.574 1.228-1.544 1.228Zm3.427-3.51V10h-.665V6.57H4.753V6h3.006v.568H6.587Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.045 7.73v.544c0 1.131-.636 1.805-1.661 1.805-1.026 0-1.664-.674-1.664-1.805V7.73c0-1.136.638-1.807 1.664-1.807 1.025 0 1.66.674 1.66 1.807Zm-.674.547v-.553c0-.827-.422-1.234-.987-1.234-.572 0-.99.407-.99 1.234v.553c0 .83.418 1.237.99 1.237.565 0 .987-.408.987-1.237Zm1.15-2.276h1.535c.82 0 1.316.55 1.316 1.292 0 .747-.501 1.289-1.321 1.289h-.865V10h-.665V6.001Zm1.436 2.036c.463 0 .735-.272.735-.744s-.272-.741-.735-.741h-.774v1.485h.774Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.893 0a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353L11.46.146A.5.5 0 0 0 11.107 0H4.893ZM1 5.1 5.1 1h5.8L15 5.1v5.8L10.9 15H5.1L1 10.9V5.1Z"
                }
            }
        ]
    })(props);
}
function BsSignTurnLeftFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435ZM7 8.466a.25.25 0 0 1-.41.192L4.23 6.692a.25.25 0 0 1 0-.384l2.36-1.966a.25.25 0 0 1 .41.192V6h1.5A2.5 2.5 0 0 1 11 8.5V11h-1V8.5A1.5 1.5 0 0 0 8.5 7H7v1.466Z"
                }
            }
        ]
    })(props);
}
function BsSignTurnLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8.5A2.5 2.5 0 0 0 8.5 6H7V4.534a.25.25 0 0 0-.41-.192L4.23 6.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 7 8.466V7h1.5A1.5 1.5 0 0 1 10 8.5V11h1V8.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.482 1.482 0 0 1 0-2.098L6.95.435Zm1.4.7a.495.495 0 0 0-.7 0L1.134 7.65a.495.495 0 0 0 0 .7l6.516 6.516a.495.495 0 0 0 .7 0l6.516-6.516a.495.495 0 0 0 0-.7L8.35 1.134Z"
                }
            }
        ]
    })(props);
}
function BsSignTurnRightFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435ZM9 8.466V7H7.5A1.5 1.5 0 0 0 6 8.5V11H5V8.5A2.5 2.5 0 0 1 7.5 6H9V4.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L9.41 8.658A.25.25 0 0 1 9 8.466Z"
                }
            }
        ]
    })(props);
}
function BsSignTurnRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8.5A2.5 2.5 0 0 1 7.5 6H9V4.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L9.41 8.658A.25.25 0 0 1 9 8.466V7H7.5A1.5 1.5 0 0 0 6 8.5V11H5V8.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.482 1.482 0 0 1 0-2.098L6.95.435Zm1.4.7a.495.495 0 0 0-.7 0L1.134 7.65a.495.495 0 0 0 0 .7l6.516 6.516a.495.495 0 0 0 .7 0l6.516-6.516a.495.495 0 0 0 0-.7L8.35 1.134Z"
                }
            }
        ]
    })(props);
}
function BsSignTurnSlightLeftFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435ZM6.864 8.368a.25.25 0 0 1-.451-.039l-1.06-2.882a.25.25 0 0 1 .192-.333l3.026-.523a.25.25 0 0 1 .26.371l-.667 1.154.621.373A2.5 2.5 0 0 1 10 8.632V11H9V8.632a1.5 1.5 0 0 0-.728-1.286l-.607-.364-.8 1.386Z"
                }
            }
        ]
    })(props);
}
function BsSignTurnSlightLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7.665 6.982-.8 1.386a.25.25 0 0 1-.451-.039l-1.06-2.882a.25.25 0 0 1 .192-.333l3.026-.523a.25.25 0 0 1 .26.371l-.667 1.154.621.373A2.5 2.5 0 0 1 10 8.632V11H9V8.632a1.5 1.5 0 0 0-.728-1.286l-.607-.364Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.482 1.482 0 0 1 0-2.098L6.95.435Zm1.4.7a.495.495 0 0 0-.7 0L1.134 7.65a.495.495 0 0 0 0 .7l6.516 6.516a.495.495 0 0 0 .7 0l6.516-6.516a.495.495 0 0 0 0-.7L8.35 1.134Z"
                }
            }
        ]
    })(props);
}
function BsSignTurnSlightRightFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.482 1.482 0 0 1 0-2.098L6.95.435Zm1.385 6.547.8 1.386a.25.25 0 0 0 .451-.039l1.06-2.882a.25.25 0 0 0-.192-.333l-3.026-.523a.25.25 0 0 0-.26.371l.667 1.154-.621.373A2.5 2.5 0 0 0 6 8.632V11h1V8.632a1.5 1.5 0 0 1 .728-1.286l.607-.364Z"
                }
            }
        ]
    })(props);
}
function BsSignTurnSlightRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m8.335 6.982.8 1.386a.25.25 0 0 0 .451-.039l1.06-2.882a.25.25 0 0 0-.192-.333l-3.026-.523a.25.25 0 0 0-.26.371l.667 1.154-.621.373A2.5 2.5 0 0 0 6 8.632V11h1V8.632a1.5 1.5 0 0 1 .728-1.286l.607-.364Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.482 1.482 0 0 1 0-2.098L6.95.435Zm1.4.7a.495.495 0 0 0-.7 0L1.134 7.65a.495.495 0 0 0 0 .7l6.516 6.516a.495.495 0 0 0 .7 0l6.516-6.516a.495.495 0 0 0 0-.7L8.35 1.134Z"
                }
            }
        ]
    })(props);
}
function BsSignYieldFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.48 5.323h-.28v1.353h.28c.372 0 .54-.222.54-.674 0-.45-.169-.68-.54-.68Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.022 14.434a1.131 1.131 0 0 0 1.96 0l6.857-11.667c.457-.778-.092-1.767-.98-1.767H1.144c-.889 0-1.437.99-.98 1.767l6.857 11.667ZM5.506 6.232V7H5.11v-.76L4.44 5h.44l.424.849h.016L5.748 5h.428l-.67 1.232ZM6.628 5v2h-.396V5h.396Zm.684 1.676h.895V7H6.919V5h1.288v.324h-.895v.513h.842v.303h-.842v.536Zm1.521-.013h.848V7H8.437V5h.396v1.663Zm.97.337V5h.73c.608 0 .895.364.895.995 0 .636-.291 1.005-.895 1.005h-.73Z"
                }
            }
        ]
    })(props);
}
function BsSignYield(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.506 6.232V7H5.11v-.76L4.44 5h.44l.424.849h.016L5.748 5h.428l-.67 1.232ZM6.628 5v2h-.396V5h.396Zm.684 1.676h.895V7H6.919V5h1.288v.324h-.895v.513h.842v.303h-.842v.536Zm1.521-.013h.848V7H8.437V5h.396v1.663Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.804 7V5h.73c.607 0 .894.364.894.995 0 .636-.291 1.005-.895 1.005h-.73Zm.676-1.677h-.28v1.353h.28c.372 0 .54-.222.54-.674 0-.45-.169-.68-.54-.68Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.022 14.434a1.131 1.131 0 0 0 1.96 0l6.857-11.667c.457-.778-.092-1.767-.98-1.767H1.144c-.889 0-1.437.99-.98 1.767l6.857 11.667Zm.98-.434a.13.13 0 0 1-.064-.016.146.146 0 0 1-.054-.057L1.027 2.26a.177.177 0 0 1-.002-.183.164.164 0 0 1 .054-.06A.116.116 0 0 1 1.145 2h13.713a.12.12 0 0 1 .066.017c.018.01.038.03.055.06a.176.176 0 0 1-.003.183L8.12 13.927a.146.146 0 0 1-.054.057.13.13 0 0 1-.063.016Z"
                }
            }
        ]
    })(props);
}
function BsSignal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m6.08.234.179.727a7.264 7.264 0 0 0-2.01.832l-.383-.643A7.9 7.9 0 0 1 6.079.234zm3.84 0L9.742.96a7.265 7.265 0 0 1 2.01.832l.388-.643A7.957 7.957 0 0 0 9.92.234zm-8.77 3.63a7.944 7.944 0 0 0-.916 2.215l.727.18a7.264 7.264 0 0 1 .832-2.01l-.643-.386zM.75 8a7.3 7.3 0 0 1 .081-1.086L.091 6.8a8 8 0 0 0 0 2.398l.74-.112A7.262 7.262 0 0 1 .75 8zm11.384 6.848-.384-.64a7.23 7.23 0 0 1-2.007.831l.18.728a7.965 7.965 0 0 0 2.211-.919zM15.251 8c0 .364-.028.727-.082 1.086l.74.112a7.966 7.966 0 0 0 0-2.398l-.74.114c.054.36.082.722.082 1.086zm.516 1.918-.728-.18a7.252 7.252 0 0 1-.832 2.012l.643.387a7.933 7.933 0 0 0 .917-2.219zm-6.68 5.25c-.72.11-1.453.11-2.173 0l-.112.742a7.99 7.99 0 0 0 2.396 0l-.112-.741zm4.75-2.868a7.229 7.229 0 0 1-1.537 1.534l.446.605a8.07 8.07 0 0 0 1.695-1.689l-.604-.45zM12.3 2.163c.587.432 1.105.95 1.537 1.537l.604-.45a8.06 8.06 0 0 0-1.69-1.691l-.45.604zM2.163 3.7A7.242 7.242 0 0 1 3.7 2.163l-.45-.604a8.06 8.06 0 0 0-1.691 1.69l.604.45zm12.688.163-.644.387c.377.623.658 1.3.832 2.007l.728-.18a7.931 7.931 0 0 0-.916-2.214zM6.913.831a7.254 7.254 0 0 1 2.172 0l.112-.74a7.985 7.985 0 0 0-2.396 0l.112.74zM2.547 14.64 1 15l.36-1.549-.729-.17-.361 1.548a.75.75 0 0 0 .9.902l1.548-.357-.17-.734zM.786 12.612l.732.168.25-1.073A7.187 7.187 0 0 1 .96 9.74l-.727.18a8 8 0 0 0 .736 1.902l-.184.79zm3.5 1.623-1.073.25.17.731.79-.184c.6.327 1.239.574 1.902.737l.18-.728a7.197 7.197 0 0 1-1.962-.811l-.007.005zM8 1.5a6.502 6.502 0 0 0-6.498 6.502 6.516 6.516 0 0 0 .998 3.455l-.625 2.668L4.54 13.5a6.502 6.502 0 0 0 6.93-11A6.516 6.516 0 0 0 8 1.5"
                }
            }
        ]
    })(props);
}
function BsSignpost2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.293.707A1 1 0 0 0 7 1.414V2H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h5v1H2.5a1 1 0 0 0-.8.4L.725 8.7a.5.5 0 0 0 0 .6l.975 1.3a1 1 0 0 0 .8.4H7v5h2v-5h5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H9V6h4.5a1 1 0 0 0 .8-.4l.975-1.3a.5.5 0 0 0 0-.6L14.3 2.4a1 1 0 0 0-.8-.4H9v-.586A1 1 0 0 0 7.293.707z"
                }
            }
        ]
    })(props);
}
function BsSignpost2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 1.414V2H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h5v1H2.5a1 1 0 0 0-.8.4L.725 8.7a.5.5 0 0 0 0 .6l.975 1.3a1 1 0 0 0 .8.4H7v5h2v-5h5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H9V6h4.5a1 1 0 0 0 .8-.4l.975-1.3a.5.5 0 0 0 0-.6L14.3 2.4a1 1 0 0 0-.8-.4H9v-.586a1 1 0 0 0-2 0zM13.5 3l.75 1-.75 1H2V3h11.5zm.5 5v2H2.5l-.75-1 .75-1H14z"
                }
            }
        ]
    })(props);
}
function BsSignpostFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.293.707A1 1 0 0 0 7 1.414V4H2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5v6h2v-6h3.532a1 1 0 0 0 .768-.36l1.933-2.32a.5.5 0 0 0 0-.64L13.3 4.36a1 1 0 0 0-.768-.36H9V1.414A1 1 0 0 0 7.293.707z"
                }
            }
        ]
    })(props);
}
function BsSignpostSplitFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 16h2V6h5a1 1 0 0 0 .8-.4l.975-1.3a.5.5 0 0 0 0-.6L14.8 2.4A1 1 0 0 0 14 2H9v-.586a1 1 0 0 0-2 0V7H2a1 1 0 0 0-.8.4L.225 8.7a.5.5 0 0 0 0 .6l.975 1.3a1 1 0 0 0 .8.4h5v5z"
                }
            }
        ]
    })(props);
}
function BsSignpostSplit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7V1.414a1 1 0 0 1 2 0V2h5a1 1 0 0 1 .8.4l.975 1.3a.5.5 0 0 1 0 .6L14.8 5.6a1 1 0 0 1-.8.4H9v10H7v-5H2a1 1 0 0 1-.8-.4L.225 9.3a.5.5 0 0 1 0-.6L1.2 7.4A1 1 0 0 1 2 7h5zm1 3V8H2l-.75 1L2 10h6zm0-5h6l.75-1L14 3H8v2z"
                }
            }
        ]
    })(props);
}
function BsSignpost(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 1.414V4H2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5v6h2v-6h3.532a1 1 0 0 0 .768-.36l1.933-2.32a.5.5 0 0 0 0-.64L13.3 4.36a1 1 0 0 0-.768-.36H9V1.414a1 1 0 0 0-2 0zM12.532 5l1.666 2-1.666 2H2V5h10.532z"
                }
            }
        ]
    })(props);
}
function BsSimFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4.5a.5.5 0 0 1 .5-.5h2v2H5V4.5zM8.5 6V4h2a.5.5 0 0 1 .5.5V6H8.5zM5 7h6v2H5V7zm3.5 3H11v1.5a.5.5 0 0 1-.5.5h-2v-2zm-1 0v2h-2a.5.5 0 0 1-.5-.5V10h2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0A1.5 1.5 0 0 0 2 1.5v13A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5V3.414a1.5 1.5 0 0 0-.44-1.06L11.647.439A1.5 1.5 0 0 0 10.586 0H3.5zm2 3h5A1.5 1.5 0 0 1 12 4.5v7a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 11.5v-7A1.5 1.5 0 0 1 5.5 3z"
                }
            }
        ]
    })(props);
}
function BsSimSlashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.646.44.897.896-1.703 1.703A1.506 1.506 0 0 0 10.5 3h-5A1.5 1.5 0 0 0 4 4.5v5.379l-2 2V1.5A1.5 1.5 0 0 1 3.5 0h7.086a1.5 1.5 0 0 1 1.06.44ZM8.5 5.378 9.879 4H8.5v1.379ZM5 8.879 6.879 7H5v1.879Zm6-1.758L9.121 9H11V7.121Zm-3.5 3.5L6.121 12H7.5v-1.379ZM5.5 13c-.117 0-.23-.013-.34-.039L2.502 15.62c.265.236.615.38.998.38h9a1.5 1.5 0 0 0 1.5-1.5V4.121l-2 2V11.5a1.5 1.5 0 0 1-1.5 1.5h-5ZM5 4.5a.5.5 0 0 1 .5-.5h2v2H5V4.5ZM8.5 10H11v1.5a.5.5 0 0 1-.5.5h-2v-2Zm6.354-8.146a.5.5 0 0 0-.708-.708l-13 13a.5.5 0 0 0 .708.708l13-13Z"
                }
            }
        ]
    })(props);
}
function BsSimSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.646.44.897.896-.707.707-.897-.897A.5.5 0 0 0 10.586 1H3.5a.5.5 0 0 0-.5.5v9.379l-1 1V1.5A1.5 1.5 0 0 1 3.5 0h7.086a1.5 1.5 0 0 1 1.06.44ZM10.5 3c.117 0 .23.013.34.039L9.879 4H8.5v1.379L6.879 7H5v1.879l-1 1V4.5A1.5 1.5 0 0 1 5.5 3h5ZM12 6.121l-1 1V9H9.121L7.5 10.621V12H6.121l-.961.961c.11.026.223.039.34.039h5a1.5 1.5 0 0 0 1.5-1.5V6.121ZM3.5 15a.498.498 0 0 1-.288-.091l-.71.71c.265.237.615.381.998.381h9a1.5 1.5 0 0 0 1.5-1.5V4.121l-1 1V14.5a.5.5 0 0 1-.5.5h-9Zm2-11a.5.5 0 0 0-.5.5V6h2.5V4h-2Zm5.5 6v1.5a.5.5 0 0 1-.5.5h-2v-2H11Zm3.854-8.146a.5.5 0 0 0-.708-.708l-13 13a.5.5 0 0 0 .708.708l13-13Z"
                }
            }
        ]
    })(props);
}
function BsSim(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1.5A1.5 1.5 0 0 1 3.5 0h7.086a1.5 1.5 0 0 1 1.06.44l1.915 1.914A1.5 1.5 0 0 1 14 3.414V14.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-13zM3.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V3.414a.5.5 0 0 0-.146-.353l-1.915-1.915A.5.5 0 0 0 10.586 1H3.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 4a.5.5 0 0 0-.5.5V6h2.5V4h-2zm3 0v2H11V4.5a.5.5 0 0 0-.5-.5h-2zM11 7H5v2h6V7zm0 3H8.5v2h2a.5.5 0 0 0 .5-.5V10zm-3.5 2v-2H5v1.5a.5.5 0 0 0 .5.5h2zM4 4.5A1.5 1.5 0 0 1 5.5 3h5A1.5 1.5 0 0 1 12 4.5v7a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 11.5v-7z"
                }
            }
        ]
    })(props);
}
function BsSinaWeibo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.878 1.093a4.23 4.23 0 0 1 4.031 1.305 4.225 4.225 0 0 1 .886 4.14v.001a.612.612 0 0 1-1.166-.377 3.01 3.01 0 0 0-3.495-3.873.611.611 0 1 1-.256-1.196ZM3.753 9.465c.548-1.11 1.972-1.74 3.233-1.411 1.304.338 1.971 1.568 1.437 2.764-.541 1.221-2.095 1.875-3.416 1.449-1.271-.411-1.812-1.67-1.254-2.802Zm2.658.567c.16.066.365-.009.458-.168.088-.16.03-.34-.129-.397-.156-.062-.353.013-.446.168-.09.154-.041.333.117.397Zm-1.607 1.314c.413.188.963.009 1.219-.4.252-.413.12-.883-.296-1.062-.41-.172-.94.005-1.194.402-.256.4-.135.874.271 1.06Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12.014 7.238.005.001c.919.285 1.941.974 1.939 2.188 0 2.007-2.895 4.535-7.246 4.535C3.393 13.962 0 12.352 0 9.708c0-1.385.876-2.985 2.384-4.493C4.4 3.199 6.751 2.28 7.634 3.165c.39.392.427 1.065.177 1.87-.132.405.38.182.38.182 1.63-.682 3.051-.722 3.57.02.278.397.252.951-.004 1.594-.116.293.035.34.257.407Zm-10.4 3.101c.172 1.738 2.46 2.936 5.109 2.674 2.647-.26 4.656-1.883 4.482-3.623-.17-1.738-2.458-2.937-5.107-2.674-2.647.263-4.656 1.883-4.484 3.623Zm11.681-6.484a2.056 2.056 0 0 0-1.962-.634.526.526 0 1 0 .219 1.031 1.008 1.008 0 0 1 1.17 1.296.528.528 0 0 0 1.005.325 2.062 2.062 0 0 0-.432-2.018Z"
                }
            }
        ]
    })(props);
}
function BsSkipBackwardBtnFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm11.21-6.907L8.5 7.028V5.5a.5.5 0 0 0-.79-.407L5 7.028V5.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0V8.972l2.71 1.935a.5.5 0 0 0 .79-.407V8.972l2.71 1.935A.5.5 0 0 0 12 10.5v-5a.5.5 0 0 0-.79-.407z"
                }
            }
        ]
    })(props);
}
function BsSkipBackwardBtn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.21 5.093A.5.5 0 0 1 12 5.5v5a.5.5 0 0 1-.79.407L8.5 8.972V10.5a.5.5 0 0 1-.79.407L5 8.972V10.5a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 1 0v1.528l2.71-1.935a.5.5 0 0 1 .79.407v1.528l2.71-1.935z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"
                }
            }
        ]
    })(props);
}
function BsSkipBackwardCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.79-2.907L8.5 7.028V5.5a.5.5 0 0 0-.79-.407L5 7.028V5.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0V8.972l2.71 1.935a.5.5 0 0 0 .79-.407V8.972l2.71 1.935A.5.5 0 0 0 12 10.5v-5a.5.5 0 0 0-.79-.407z"
                }
            }
        ]
    })(props);
}
function BsSkipBackwardCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.729 5.055a.5.5 0 0 0-.52.038L8.5 7.028V5.5a.5.5 0 0 0-.79-.407L5 7.028V5.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0V8.972l2.71 1.935a.5.5 0 0 0 .79-.407V8.972l2.71 1.935A.5.5 0 0 0 12 10.5v-5a.5.5 0 0 0-.271-.445z"
                }
            }
        ]
    })(props);
}
function BsSkipBackwardFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.5 3.5A.5.5 0 0 0 0 4v8a.5.5 0 0 0 1 0V8.753l6.267 3.636c.54.313 1.233-.066 1.233-.697v-2.94l6.267 3.636c.54.314 1.233-.065 1.233-.696V4.308c0-.63-.693-1.01-1.233-.696L8.5 7.248v-2.94c0-.63-.692-1.01-1.233-.696L1 7.248V4a.5.5 0 0 0-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsSkipBackward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.5 3.5A.5.5 0 0 1 1 4v3.248l6.267-3.636c.52-.302 1.233.043 1.233.696v2.94l6.267-3.636c.52-.302 1.233.043 1.233.696v7.384c0 .653-.713.998-1.233.696L8.5 8.752v2.94c0 .653-.713.998-1.233.696L1 8.752V12a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5zm7 1.133L1.696 8 7.5 11.367V4.633zm7.5 0L9.196 8 15 11.367V4.633z"
                }
            }
        ]
    })(props);
}
function BsSkipEndBtnFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm6.79-6.907A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407L9.5 8.972V10.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0v1.528L6.79 5.093z"
                }
            }
        ]
    })(props);
}
function BsSkipEndBtn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.79 5.093 9.5 7.028V5.5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0V8.972l-2.71 1.935A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .79-.407z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"
                }
            }
        ]
    })(props);
}
function BsSkipEndCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407L9.5 8.972V10.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0v1.528L6.79 5.093z"
                }
            }
        ]
    })(props);
}
function BsSkipEndCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.271 5.055a.5.5 0 0 1 .52.038L9.5 7.028V5.5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0V8.972l-2.71 1.935A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445z"
                }
            }
        ]
    })(props);
}
function BsSkipEndFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 4a.5.5 0 0 0-1 0v3.248L5.233 3.612C4.693 3.3 4 3.678 4 4.308v7.384c0 .63.692 1.01 1.233.697L11.5 8.753V12a.5.5 0 0 0 1 0V4z"
                }
            }
        ]
    })(props);
}
function BsSkipEnd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 4a.5.5 0 0 0-1 0v3.248L5.233 3.612C4.713 3.31 4 3.655 4 4.308v7.384c0 .653.713.998 1.233.696L11.5 8.752V12a.5.5 0 0 0 1 0V4zM5 4.633 10.804 8 5 11.367V4.633z"
                }
            }
        ]
    })(props);
}
function BsSkipForwardBtnFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2Zm4.79-6.907A.5.5 0 0 0 4 5.5v5a.5.5 0 0 0 .79.407L7.5 8.972V10.5a.5.5 0 0 0 .79.407L11 8.972V10.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0v1.528L8.29 5.093a.5.5 0 0 0-.79.407v1.528L4.79 5.093Z"
                }
            }
        ]
    })(props);
}
function BsSkipForwardBtn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.79 5.093A.5.5 0 0 0 4 5.5v5a.5.5 0 0 0 .79.407L7.5 8.972V10.5a.5.5 0 0 0 .79.407L11 8.972V10.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0v1.528L8.29 5.093a.5.5 0 0 0-.79.407v1.528L4.79 5.093z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"
                }
            }
        ]
    })(props);
}
function BsSkipForwardCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.79 5.093A.5.5 0 0 0 4 5.5v5a.5.5 0 0 0 .79.407L7.5 8.972V10.5a.5.5 0 0 0 .79.407L11 8.972V10.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0v1.528L8.29 5.093a.5.5 0 0 0-.79.407v1.528L4.79 5.093z"
                }
            }
        ]
    })(props);
}
function BsSkipForwardCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.271 5.055a.5.5 0 0 1 .52.038L7.5 7.028V5.5a.5.5 0 0 1 .79-.407L11 7.028V5.5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0V8.972l-2.71 1.935a.5.5 0 0 1-.79-.407V8.972l-2.71 1.935A.5.5 0 0 1 4 10.5v-5a.5.5 0 0 1 .271-.445z"
                }
            }
        ]
    })(props);
}
function BsSkipForwardFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 3.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V8.753l-6.267 3.636c-.54.313-1.233-.066-1.233-.697v-2.94l-6.267 3.636C.693 12.703 0 12.324 0 11.693V4.308c0-.63.693-1.01 1.233-.696L7.5 7.248v-2.94c0-.63.693-1.01 1.233-.696L15 7.248V4a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsSkipForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 3.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V8.752l-6.267 3.636c-.52.302-1.233-.043-1.233-.696v-2.94l-6.267 3.636C.713 12.69 0 12.345 0 11.692V4.308c0-.653.713-.998 1.233-.696L7.5 7.248v-2.94c0-.653.713-.998 1.233-.696L15 7.248V4a.5.5 0 0 1 .5-.5zM1 4.633v6.734L6.804 8 1 4.633zm7.5 0v6.734L14.304 8 8.5 4.633z"
                }
            }
        ]
    })(props);
}
function BsSkipStartBtnFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm9.71-6.907L7 7.028V5.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0V8.972l2.71 1.935a.5.5 0 0 0 .79-.407v-5a.5.5 0 0 0-.79-.407z"
                }
            }
        ]
    })(props);
}
function BsSkipStartBtn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.71 5.093a.5.5 0 0 1 .79.407v5a.5.5 0 0 1-.79.407L7 8.972V10.5a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 1 0v1.528l2.71-1.935z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"
                }
            }
        ]
    })(props);
}
function BsSkipStartCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM9.71 5.093 7 7.028V5.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0V8.972l2.71 1.935a.5.5 0 0 0 .79-.407v-5a.5.5 0 0 0-.79-.407z"
                }
            }
        ]
    })(props);
}
function BsSkipStartCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.229 5.055a.5.5 0 0 0-.52.038L7 7.028V5.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0V8.972l2.71 1.935a.5.5 0 0 0 .79-.407v-5a.5.5 0 0 0-.271-.445z"
                }
            }
        ]
    })(props);
}
function BsSkipStartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4a.5.5 0 0 1 1 0v3.248l6.267-3.636c.54-.313 1.232.066 1.232.696v7.384c0 .63-.692 1.01-1.232.697L5 8.753V12a.5.5 0 0 1-1 0V4z"
                }
            }
        ]
    })(props);
}
function BsSkipStart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4a.5.5 0 0 1 1 0v3.248l6.267-3.636c.52-.302 1.233.043 1.233.696v7.384c0 .653-.713.998-1.233.696L5 8.752V12a.5.5 0 0 1-1 0V4zm7.5.633L5.696 8l5.804 3.367V4.633z"
                }
            }
        ]
    })(props);
}
function BsSkype(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.671 0c.88 0 1.733.247 2.468.702a7.423 7.423 0 0 1 6.02 2.118 7.372 7.372 0 0 1 2.167 5.215c0 .344-.024.687-.072 1.026a4.662 4.662 0 0 1 .6 2.281 4.645 4.645 0 0 1-1.37 3.294A4.673 4.673 0 0 1 11.18 16c-.84 0-1.658-.226-2.37-.644a7.423 7.423 0 0 1-6.114-2.107A7.374 7.374 0 0 1 .529 8.035c0-.363.026-.724.08-1.081a4.644 4.644 0 0 1 .76-5.59A4.68 4.68 0 0 1 4.67 0zm.447 7.01c.18.309.43.572.729.769a7.07 7.07 0 0 0 1.257.653c.492.205.873.38 1.145.523.229.112.437.264.615.448.135.142.21.331.21.528a.872.872 0 0 1-.335.723c-.291.196-.64.289-.99.264a2.618 2.618 0 0 1-1.048-.206 11.44 11.44 0 0 1-.532-.253 1.284 1.284 0 0 0-.587-.15.717.717 0 0 0-.501.176.63.63 0 0 0-.195.491.796.796 0 0 0 .148.482 1.2 1.2 0 0 0 .456.354 5.113 5.113 0 0 0 2.212.419 4.554 4.554 0 0 0 1.624-.265 2.296 2.296 0 0 0 1.08-.801c.267-.39.402-.855.386-1.327a2.09 2.09 0 0 0-.279-1.101 2.53 2.53 0 0 0-.772-.792A7.198 7.198 0 0 0 8.486 7.3a1.05 1.05 0 0 0-.145-.058 18.182 18.182 0 0 1-1.013-.447 1.827 1.827 0 0 1-.54-.387.727.727 0 0 1-.2-.508.805.805 0 0 1 .385-.723 1.76 1.76 0 0 1 .968-.247c.26-.003.52.03.772.096.274.079.542.177.802.293.105.049.22.075.336.076a.6.6 0 0 0 .453-.19.69.69 0 0 0 .18-.496.717.717 0 0 0-.17-.476 1.374 1.374 0 0 0-.556-.354 3.69 3.69 0 0 0-.708-.183 5.963 5.963 0 0 0-1.022-.078 4.53 4.53 0 0 0-1.536.258 2.71 2.71 0 0 0-1.174.784 1.91 1.91 0 0 0-.45 1.287c-.01.37.076.736.25 1.063z"
                }
            }
        ]
    })(props);
}
function BsSlack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.362 10.11c0 .926-.756 1.681-1.681 1.681S0 11.036 0 10.111C0 9.186.756 8.43 1.68 8.43h1.682v1.68zm.846 0c0-.924.756-1.68 1.681-1.68s1.681.756 1.681 1.68v4.21c0 .924-.756 1.68-1.68 1.68a1.685 1.685 0 0 1-1.682-1.68v-4.21zM5.89 3.362c-.926 0-1.682-.756-1.682-1.681S4.964 0 5.89 0s1.68.756 1.68 1.68v1.682H5.89zm0 .846c.924 0 1.68.756 1.68 1.681S6.814 7.57 5.89 7.57H1.68C.757 7.57 0 6.814 0 5.89c0-.926.756-1.682 1.68-1.682h4.21zm6.749 1.682c0-.926.755-1.682 1.68-1.682.925 0 1.681.756 1.681 1.681s-.756 1.681-1.68 1.681h-1.681V5.89zm-.848 0c0 .924-.755 1.68-1.68 1.68A1.685 1.685 0 0 1 8.43 5.89V1.68C8.43.757 9.186 0 10.11 0c.926 0 1.681.756 1.681 1.68v4.21zm-1.681 6.748c.926 0 1.682.756 1.682 1.681S11.036 16 10.11 16s-1.681-.756-1.681-1.68v-1.682h1.68zm0-.847c-.924 0-1.68-.755-1.68-1.68 0-.925.756-1.681 1.68-1.681h4.21c.924 0 1.68.756 1.68 1.68 0 .926-.756 1.681-1.68 1.681h-4.21z"
                }
            }
        ]
    })(props);
}
function BsSlashCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.646-2.646a.5.5 0 0 0-.708-.708l-6 6a.5.5 0 0 0 .708.708l6-6z"
                }
            }
        ]
    })(props);
}
function BsSlashCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.354 4.646a.5.5 0 0 0-.708 0l-6 6a.5.5 0 0 0 .708.708l6-6a.5.5 0 0 0 0-.708z"
                }
            }
        ]
    })(props);
}
function BsSlashLg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"
                }
            }
        ]
    })(props);
}
function BsSlashSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm9.354 5.354-6 6a.5.5 0 0 1-.708-.708l6-6a.5.5 0 0 1 .708.708z"
                }
            }
        ]
    })(props);
}
function BsSlashSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.354 4.646a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708l6-6a.5.5 0 0 1 .708 0z"
                }
            }
        ]
    })(props);
}
function BsSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.354 4.646a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708l6-6a.5.5 0 0 1 .708 0z"
                }
            }
        ]
    })(props);
}
function BsSliders(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM9.05 3a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0V3h9.05zM4.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM2.05 8a2.5 2.5 0 0 1 4.9 0H16v1H6.95a2.5 2.5 0 0 1-4.9 0H0V8h2.05zm9.45 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-2.45 1a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0v-1h9.05z"
                }
            }
        ]
    })(props);
}
function BsSliders2Vertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M0 10.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 0-1H3V1.5a.5.5 0 0 0-1 0V10H.5a.5.5 0 0 0-.5.5ZM2.5 12a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5Zm3-6.5A.5.5 0 0 0 6 6h1.5v8.5a.5.5 0 0 0 1 0V6H10a.5.5 0 0 0 0-1H6a.5.5 0 0 0-.5.5ZM8 1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2A.5.5 0 0 0 8 1Zm3 9.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 0-1H14V1.5a.5.5 0 0 0-1 0V10h-1.5a.5.5 0 0 0-.5.5Zm2.5 1.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5Z"
                }
            }
        ]
    })(props);
}
function BsSliders2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.5 1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4H1.5a.5.5 0 0 1 0-1H10V1.5a.5.5 0 0 1 .5-.5ZM12 3.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm-6.5 2A.5.5 0 0 1 6 6v1.5h8.5a.5.5 0 0 1 0 1H6V10a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5ZM1 8a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 1 8Zm9.5 2a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V13H1.5a.5.5 0 0 1 0-1H10v-1.5a.5.5 0 0 1 .5-.5Zm1.5 2.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Z"
                }
            }
        ]
    })(props);
}
function BsSmartwatch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 5a.5.5 0 0 0-1 0v3H6a.5.5 0 0 0 0 1h2.5a.5.5 0 0 0 .5-.5V5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 1.667v.383A2.5 2.5 0 0 0 2 4.5v7a2.5 2.5 0 0 0 2 2.45v.383C4 15.253 4.746 16 5.667 16h4.666c.92 0 1.667-.746 1.667-1.667v-.383a2.5 2.5 0 0 0 2-2.45V8h.5a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5H14v-.5a2.5 2.5 0 0 0-2-2.45v-.383C12 .747 11.254 0 10.333 0H5.667C4.747 0 4 .746 4 1.667zM4.5 3h7A1.5 1.5 0 0 1 13 4.5v7a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 3 11.5v-7A1.5 1.5 0 0 1 4.5 3z"
                }
            }
        ]
    })(props);
}
function BsSnapchat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.943 11.526c-.111-.303-.323-.465-.564-.599a1.416 1.416 0 0 0-.123-.064l-.219-.111c-.752-.399-1.339-.902-1.746-1.498a3.387 3.387 0 0 1-.3-.531c-.034-.1-.032-.156-.008-.207a.338.338 0 0 1 .097-.1c.129-.086.262-.173.352-.231.162-.104.289-.187.371-.245.309-.216.525-.446.66-.702a1.397 1.397 0 0 0 .069-1.16c-.205-.538-.713-.872-1.329-.872a1.829 1.829 0 0 0-.487.065c.006-.368-.002-.757-.035-1.139-.116-1.344-.587-2.048-1.077-2.61a4.294 4.294 0 0 0-1.095-.881C9.764.216 8.92 0 7.999 0c-.92 0-1.76.216-2.505.641-.412.232-.782.53-1.097.883-.49.562-.96 1.267-1.077 2.61-.033.382-.04.772-.036 1.138a1.83 1.83 0 0 0-.487-.065c-.615 0-1.124.335-1.328.873a1.398 1.398 0 0 0 .067 1.161c.136.256.352.486.66.701.082.058.21.14.371.246l.339.221a.38.38 0 0 1 .109.11c.026.053.027.11-.012.217a3.363 3.363 0 0 1-.295.52c-.398.583-.968 1.077-1.696 1.472-.385.204-.786.34-.955.8-.128.348-.044.743.28 1.075.119.125.257.23.409.31a4.43 4.43 0 0 0 1 .4.66.66 0 0 1 .202.09c.118.104.102.26.259.488.079.118.18.22.296.3.33.229.701.243 1.095.258.355.014.758.03 1.217.18.19.064.389.186.618.328.55.338 1.305.802 2.566.802 1.262 0 2.02-.466 2.576-.806.227-.14.424-.26.609-.321.46-.152.863-.168 1.218-.181.393-.015.764-.03 1.095-.258a1.14 1.14 0 0 0 .336-.368c.114-.192.11-.327.217-.42a.625.625 0 0 1 .19-.087 4.446 4.446 0 0 0 1.014-.404c.16-.087.306-.2.429-.336l.004-.005c.304-.325.38-.709.256-1.047Zm-1.121.602c-.684.378-1.139.337-1.493.565-.3.193-.122.61-.34.76-.269.186-1.061-.012-2.085.326-.845.279-1.384 1.082-2.903 1.082-1.519 0-2.045-.801-2.904-1.084-1.022-.338-1.816-.14-2.084-.325-.218-.15-.041-.568-.341-.761-.354-.228-.809-.187-1.492-.563-.436-.24-.189-.39-.044-.46 2.478-1.199 2.873-3.05 2.89-3.188.022-.166.045-.297-.138-.466-.177-.164-.962-.65-1.18-.802-.36-.252-.52-.503-.402-.812.082-.214.281-.295.49-.295a.93.93 0 0 1 .197.022c.396.086.78.285 1.002.338.027.007.054.01.082.011.118 0 .16-.06.152-.195-.026-.433-.087-1.277-.019-2.066.094-1.084.444-1.622.859-2.097.2-.229 1.137-1.22 2.93-1.22 1.792 0 2.732.987 2.931 1.215.416.475.766 1.013.859 2.098.068.788.009 1.632-.019 2.065-.01.142.034.195.152.195a.35.35 0 0 0 .082-.01c.222-.054.607-.253 1.002-.338a.912.912 0 0 1 .197-.023c.21 0 .409.082.49.295.117.309-.04.56-.401.812-.218.152-1.003.638-1.18.802-.184.169-.16.3-.139.466.018.14.413 1.991 2.89 3.189.147.073.394.222-.041.464Z"
                }
            }
        ]
    })(props);
}
function BsSnow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16a.5.5 0 0 1-.5-.5v-1.293l-.646.647a.5.5 0 0 1-.707-.708L7.5 12.793V8.866l-3.4 1.963-.496 1.85a.5.5 0 1 1-.966-.26l.237-.882-1.12.646a.5.5 0 0 1-.5-.866l1.12-.646-.884-.237a.5.5 0 1 1 .26-.966l1.848.495L7 8 3.6 6.037l-1.85.495a.5.5 0 0 1-.258-.966l.883-.237-1.12-.646a.5.5 0 1 1 .5-.866l1.12.646-.237-.883a.5.5 0 1 1 .966-.258l.495 1.849L7.5 7.134V3.207L6.147 1.854a.5.5 0 1 1 .707-.708l.646.647V.5a.5.5 0 1 1 1 0v1.293l.647-.647a.5.5 0 1 1 .707.708L8.5 3.207v3.927l3.4-1.963.496-1.85a.5.5 0 1 1 .966.26l-.236.882 1.12-.646a.5.5 0 0 1 .5.866l-1.12.646.883.237a.5.5 0 1 1-.26.966l-1.848-.495L9 8l3.4 1.963 1.849-.495a.5.5 0 0 1 .259.966l-.883.237 1.12.646a.5.5 0 0 1-.5.866l-1.12-.646.236.883a.5.5 0 1 1-.966.258l-.495-1.849-3.4-1.963v3.927l1.353 1.353a.5.5 0 0 1-.707.708l-.647-.647V15.5a.5.5 0 0 1-.5.5z"
                }
            }
        ]
    })(props);
}
function BsSnow2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16a.5.5 0 0 1-.5-.5v-1.293l-.646.647a.5.5 0 0 1-.707-.708L7.5 12.793v-1.086l-.646.647a.5.5 0 0 1-.707-.708L7.5 10.293V8.866l-1.236.713-.495 1.85a.5.5 0 1 1-.966-.26l.237-.882-.94.542-.496 1.85a.5.5 0 1 1-.966-.26l.237-.882-1.12.646a.5.5 0 0 1-.5-.866l1.12-.646-.884-.237a.5.5 0 1 1 .26-.966l1.848.495.94-.542-.882-.237a.5.5 0 1 1 .258-.966l1.85.495L7 8l-1.236-.713-1.849.495a.5.5 0 1 1-.258-.966l.883-.237-.94-.542-1.85.495a.5.5 0 0 1-.258-.966l.883-.237-1.12-.646a.5.5 0 1 1 .5-.866l1.12.646-.237-.883a.5.5 0 0 1 .966-.258l.495 1.849.94.542-.236-.883a.5.5 0 0 1 .966-.258l.495 1.849 1.236.713V5.707L6.147 4.354a.5.5 0 1 1 .707-.708l.646.647V3.207L6.147 1.854a.5.5 0 1 1 .707-.708l.646.647V.5a.5.5 0 0 1 1 0v1.293l.647-.647a.5.5 0 1 1 .707.708L8.5 3.207v1.086l.647-.647a.5.5 0 1 1 .707.708L8.5 5.707v1.427l1.236-.713.495-1.85a.5.5 0 1 1 .966.26l-.236.882.94-.542.495-1.85a.5.5 0 1 1 .966.26l-.236.882 1.12-.646a.5.5 0 0 1 .5.866l-1.12.646.883.237a.5.5 0 1 1-.26.966l-1.848-.495-.94.542.883.237a.5.5 0 1 1-.26.966l-1.848-.495L9 8l1.236.713 1.849-.495a.5.5 0 0 1 .259.966l-.883.237.94.542 1.849-.495a.5.5 0 0 1 .259.966l-.883.237 1.12.646a.5.5 0 0 1-.5.866l-1.12-.646.236.883a.5.5 0 1 1-.966.258l-.495-1.849-.94-.542.236.883a.5.5 0 0 1-.966.258L9.736 9.58 8.5 8.866v1.427l1.354 1.353a.5.5 0 0 1-.707.708l-.647-.647v1.086l1.354 1.353a.5.5 0 0 1-.707.708l-.647-.647V15.5a.5.5 0 0 1-.5.5z"
                }
            }
        ]
    })(props);
}
function BsSnow3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16a.5.5 0 0 1-.5-.5v-1.293l-.646.647a.5.5 0 0 1-.707-.708L7.5 12.793v-1.51l-2.053-1.232-1.348.778-.495 1.85a.5.5 0 1 1-.966-.26l.237-.882-1.12.646a.5.5 0 0 1-.5-.866l1.12-.646-.883-.237a.5.5 0 1 1 .258-.966l1.85.495L5 9.155v-2.31l-1.4-.808-1.85.495a.5.5 0 1 1-.259-.966l.884-.237-1.12-.646a.5.5 0 0 1 .5-.866l1.12.646-.237-.883a.5.5 0 1 1 .966-.258l.495 1.849 1.348.778L7.5 4.717v-1.51L6.147 1.854a.5.5 0 1 1 .707-.708l.646.647V.5a.5.5 0 0 1 1 0v1.293l.647-.647a.5.5 0 1 1 .707.708L8.5 3.207v1.51l2.053 1.232 1.348-.778.495-1.85a.5.5 0 1 1 .966.26l-.236.882 1.12-.646a.5.5 0 0 1 .5.866l-1.12.646.883.237a.5.5 0 1 1-.26.966l-1.848-.495-1.4.808v2.31l1.4.808 1.849-.495a.5.5 0 1 1 .259.966l-.883.237 1.12.646a.5.5 0 0 1-.5.866l-1.12-.646.236.883a.5.5 0 1 1-.966.258l-.495-1.849-1.348-.778L8.5 11.283v1.51l1.354 1.353a.5.5 0 0 1-.707.708l-.647-.647V15.5a.5.5 0 0 1-.5.5zm2-6.783V6.783l-2-1.2-2 1.2v2.434l2 1.2 2-1.2z"
                }
            }
        ]
    })(props);
}
function BsSortAlphaDownAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.96 7H9.028v-.691l2.579-3.72v-.054H9.098v-.867h3.785v.691l-2.567 3.72v.054h2.645V7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.082 12.629 9.664 14H8.598l1.789-5.332h1.234L13.402 14h-1.12l-.419-1.371h-1.781zm1.57-.785L11 9.688h-.047l-.652 2.156h1.351z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 2.5a.5.5 0 0 0-1 0v9.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L4.5 12.293V2.5z"
                }
            }
        ]
    })(props);
}
function BsSortAlphaDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.082 5.629 9.664 7H8.598l1.789-5.332h1.234L13.402 7h-1.12l-.419-1.371h-1.781zm1.57-.785L11 2.687h-.047l-.652 2.157h1.351z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.96 14H9.028v-.691l2.579-3.72v-.054H9.098v-.867h3.785v.691l-2.567 3.72v.054h2.645V14zM4.5 2.5a.5.5 0 0 0-1 0v9.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L4.5 12.293V2.5z"
                }
            }
        ]
    })(props);
}
function BsSortAlphaUpAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.96 7H9.028v-.691l2.579-3.72v-.054H9.098v-.867h3.785v.691l-2.567 3.72v.054h2.645V7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.082 12.629 9.664 14H8.598l1.789-5.332h1.234L13.402 14h-1.12l-.419-1.371h-1.781zm1.57-.785L11 9.688h-.047l-.652 2.156h1.351z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 13.5a.5.5 0 0 1-1 0V3.707L2.354 4.854a.5.5 0 1 1-.708-.708l2-1.999.007-.007a.498.498 0 0 1 .7.006l2 2a.5.5 0 1 1-.707.708L4.5 3.707V13.5z"
                }
            }
        ]
    })(props);
}
function BsSortAlphaUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.082 5.629 9.664 7H8.598l1.789-5.332h1.234L13.402 7h-1.12l-.419-1.371h-1.781zm1.57-.785L11 2.687h-.047l-.652 2.157h1.351z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.96 14H9.028v-.691l2.579-3.72v-.054H9.098v-.867h3.785v.691l-2.567 3.72v.054h2.645V14zm-8.46-.5a.5.5 0 0 1-1 0V3.707L2.354 4.854a.5.5 0 1 1-.708-.708l2-1.999.007-.007a.498.498 0 0 1 .7.006l2 2a.5.5 0 1 1-.707.708L4.5 3.707V13.5z"
                }
            }
        ]
    })(props);
}
function BsSortDownAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 3.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 12.293V3.5zm4 .5a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1h-1zm0 3a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1h-3zm0 3a.5.5 0 0 1 0-1h5a.5.5 0 0 1 0 1h-5zM7 12.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5z"
                }
            }
        ]
    })(props);
}
function BsSortDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 2.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 11.293V2.5zm3.5 1a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z"
                }
            }
        ]
    })(props);
}
function BsSortNumericDownAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.36 7.098c-1.137 0-1.708-.657-1.762-1.278h1.004c.058.223.343.45.773.45.824 0 1.164-.829 1.133-1.856h-.059c-.148.39-.57.742-1.261.742-.91 0-1.72-.613-1.72-1.758 0-1.148.848-1.836 1.973-1.836 1.09 0 2.063.637 2.063 2.688 0 1.867-.723 2.848-2.145 2.848zm.062-2.735c.504 0 .933-.336.933-.972 0-.633-.398-1.008-.94-1.008-.52 0-.927.375-.927 1 0 .64.418.98.934.98z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.438 8.668V14H11.39V9.684h-.051l-1.211.859v-.969l1.262-.906h1.046zM4.5 2.5a.5.5 0 0 0-1 0v9.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L4.5 12.293V2.5z"
                }
            }
        ]
    })(props);
}
function BsSortNumericDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.438 1.668V7H11.39V2.684h-.051l-1.211.859v-.969l1.262-.906h1.046z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.36 14.098c-1.137 0-1.708-.657-1.762-1.278h1.004c.058.223.343.45.773.45.824 0 1.164-.829 1.133-1.856h-.059c-.148.39-.57.742-1.261.742-.91 0-1.72-.613-1.72-1.758 0-1.148.848-1.835 1.973-1.835 1.09 0 2.063.636 2.063 2.687 0 1.867-.723 2.848-2.145 2.848zm.062-2.735c.504 0 .933-.336.933-.972 0-.633-.398-1.008-.94-1.008-.52 0-.927.375-.927 1 0 .64.418.98.934.98z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 2.5a.5.5 0 0 0-1 0v9.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L4.5 12.293V2.5z"
                }
            }
        ]
    })(props);
}
function BsSortNumericUpAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.36 7.098c-1.137 0-1.708-.657-1.762-1.278h1.004c.058.223.343.45.773.45.824 0 1.164-.829 1.133-1.856h-.059c-.148.39-.57.742-1.261.742-.91 0-1.72-.613-1.72-1.758 0-1.148.848-1.836 1.973-1.836 1.09 0 2.063.637 2.063 2.688 0 1.867-.723 2.848-2.145 2.848zm.062-2.735c.504 0 .933-.336.933-.972 0-.633-.398-1.008-.94-1.008-.52 0-.927.375-.927 1 0 .64.418.98.934.98z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.438 8.668V14H11.39V9.684h-.051l-1.211.859v-.969l1.262-.906h1.046zM4.5 13.5a.5.5 0 0 1-1 0V3.707L2.354 4.854a.5.5 0 1 1-.708-.708l2-1.999.007-.007a.498.498 0 0 1 .7.006l2 2a.5.5 0 1 1-.707.708L4.5 3.707V13.5z"
                }
            }
        ]
    })(props);
}
function BsSortNumericUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.438 1.668V7H11.39V2.684h-.051l-1.211.859v-.969l1.262-.906h1.046z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.36 14.098c-1.137 0-1.708-.657-1.762-1.278h1.004c.058.223.343.45.773.45.824 0 1.164-.829 1.133-1.856h-.059c-.148.39-.57.742-1.261.742-.91 0-1.72-.613-1.72-1.758 0-1.148.848-1.835 1.973-1.835 1.09 0 2.063.636 2.063 2.687 0 1.867-.723 2.848-2.145 2.848zm.062-2.735c.504 0 .933-.336.933-.972 0-.633-.398-1.008-.94-1.008-.52 0-.927.375-.927 1 0 .64.418.98.934.98z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 13.5a.5.5 0 0 1-1 0V3.707L2.354 4.854a.5.5 0 1 1-.708-.708l2-1.999.007-.007a.498.498 0 0 1 .7.006l2 2a.5.5 0 1 1-.707.708L4.5 3.707V13.5z"
                }
            }
        ]
    })(props);
}
function BsSortUpAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 13.5a.5.5 0 0 1-1 0V4.707L1.354 5.854a.5.5 0 1 1-.708-.708l2-1.999.007-.007a.498.498 0 0 1 .7.006l2 2a.5.5 0 1 1-.707.708L3.5 4.707V13.5zm4-9.5a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1h-1zm0 3a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1h-3zm0 3a.5.5 0 0 1 0-1h5a.5.5 0 0 1 0 1h-5zM7 12.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5z"
                }
            }
        ]
    })(props);
}
function BsSortUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 12.5a.5.5 0 0 1-1 0V3.707L1.354 4.854a.5.5 0 1 1-.708-.708l2-1.999.007-.007a.498.498 0 0 1 .7.006l2 2a.5.5 0 1 1-.707.708L3.5 3.707V12.5zm3.5-9a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z"
                }
            }
        ]
    })(props);
}
function BsSoundwave(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.5 2a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-1 0v-11a.5.5 0 0 1 .5-.5zm-2 2a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zm4 0a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zm-6 1.5A.5.5 0 0 1 5 6v4a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm8 0a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm-10 1A.5.5 0 0 1 3 7v2a.5.5 0 0 1-1 0V7a.5.5 0 0 1 .5-.5zm12 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0V7a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsSourceforge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.13 8.43c0-2.604-.929-3.79-1.42-4.24a.14.14 0 0 0-.232.123c.095 1.472-1.762 1.84-1.762 4.144v.013c0 1.404 1.065 2.55 2.376 2.55s2.377-1.146 2.377-2.55v-.013c0-.655-.246-1.282-.492-1.745-.055-.096-.191-.055-.178.027.451 1.99-.669 3.217-.669 1.69Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.303 13.923a.252.252 0 0 1-.164-.068L.061 7.789c-.081-.082-.081-.232 0-.327l6.42-6.407A.287.287 0 0 1 6.63 1h1.844c.109 0 .177.068.204.136a.22.22 0 0 1-.054.246L2.602 7.407a.304.304 0 0 0 0 .436l4.766 4.771c.082.082.082.232 0 .328l-.915.927a.287.287 0 0 1-.15.054Zm1.216 1.063a.22.22 0 0 1-.15-.382l6.036-6.025a.321.321 0 0 0 .096-.218.271.271 0 0 0-.096-.218l-4.78-4.771c-.082-.082-.082-.232 0-.327l.929-.927a.226.226 0 0 1 .163-.068c.069 0 .11.04.15.081l6.065 6.067c.04.04.068.095.068.163a.225.225 0 0 1-.068.164l-6.42 6.407A.226.226 0 0 1 9.35 15H7.52v-.014Z"
                }
            }
        ]
    })(props);
}
function BsSpeakerFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-2.5 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm6 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM8 7a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7z"
                }
            }
        ]
    })(props);
}
function BsSpeaker(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h8zM4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zM8 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-3.5 1.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"
                }
            }
        ]
    })(props);
}
function BsSpeedometer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 2a.5.5 0 0 1 .5.5V4a.5.5 0 0 1-1 0V2.5A.5.5 0 0 1 8 2zM3.732 3.732a.5.5 0 0 1 .707 0l.915.914a.5.5 0 1 1-.708.708l-.914-.915a.5.5 0 0 1 0-.707zM2 8a.5.5 0 0 1 .5-.5h1.586a.5.5 0 0 1 0 1H2.5A.5.5 0 0 1 2 8zm9.5 0a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 0 1H12a.5.5 0 0 1-.5-.5zm.754-4.246a.389.389 0 0 0-.527-.02L7.547 7.31A.91.91 0 1 0 8.85 8.569l3.434-4.297a.389.389 0 0 0-.029-.518z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.664 15.889A8 8 0 1 1 9.336.11a8 8 0 0 1-2.672 15.78zm-4.665-4.283A11.945 11.945 0 0 1 8 10c2.186 0 4.236.585 6.001 1.606a7 7 0 1 0-12.002 0z"
                }
            }
        ]
    })(props);
}
function BsSpeedometer2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4a.5.5 0 0 1 .5.5V6a.5.5 0 0 1-1 0V4.5A.5.5 0 0 1 8 4zM3.732 5.732a.5.5 0 0 1 .707 0l.915.914a.5.5 0 1 1-.708.708l-.914-.915a.5.5 0 0 1 0-.707zM2 10a.5.5 0 0 1 .5-.5h1.586a.5.5 0 0 1 0 1H2.5A.5.5 0 0 1 2 10zm9.5 0a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 0 1H12a.5.5 0 0 1-.5-.5zm.754-4.246a.389.389 0 0 0-.527-.02L7.547 9.31a.91.91 0 1 0 1.302 1.258l3.434-4.297a.389.389 0 0 0-.029-.518z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M0 10a8 8 0 1 1 15.547 2.661c-.442 1.253-1.845 1.602-2.932 1.25C11.309 13.488 9.475 13 8 13c-1.474 0-3.31.488-4.615.911-1.087.352-2.49.003-2.932-1.25A7.988 7.988 0 0 1 0 10zm8-7a7 7 0 0 0-6.603 9.329c.203.575.923.876 1.68.63C4.397 12.533 6.358 12 8 12s3.604.532 4.923.96c.757.245 1.477-.056 1.68-.631A7 7 0 0 0 8 3z"
                }
            }
        ]
    })(props);
}
function BsSpellcheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.217 11.068c1.216 0 1.948-.869 1.948-2.31v-.702c0-1.44-.727-2.305-1.929-2.305-.742 0-1.328.347-1.499.889h-.063V3.983h-1.29V11h1.27v-.791h.064c.21.532.776.86 1.499.86zm-.43-1.025c-.66 0-1.113-.518-1.113-1.28V8.12c0-.825.42-1.343 1.098-1.343.684 0 1.075.518 1.075 1.416v.45c0 .888-.386 1.401-1.06 1.401zm-5.583 1.035c.767 0 1.201-.356 1.406-.737h.059V11h1.216V7.519c0-1.314-.947-1.783-2.11-1.783C1.355 5.736.75 6.42.69 7.27h1.216c.064-.323.313-.552.84-.552.527 0 .864.249.864.771v.464H2.346C1.145 7.953.5 8.568.5 9.496c0 .977.693 1.582 1.704 1.582zm.42-.947c-.44 0-.845-.235-.845-.718 0-.395.269-.684.84-.684h.991v.538c0 .503-.444.864-.986.864zm8.897.567c-.577-.4-.9-1.088-.9-1.983v-.65c0-1.42.894-2.338 2.305-2.338 1.352 0 2.119.82 2.139 1.806h-1.187c-.04-.351-.283-.776-.918-.776-.674 0-1.045.517-1.045 1.328v.625c0 .468.121.834.343 1.067l-.737.92z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.469 9.414a.75.75 0 0 1 .117 1.055l-4 5a.75.75 0 0 1-1.116.061l-2.5-2.5a.75.75 0 1 1 1.06-1.06l1.908 1.907 3.476-4.346a.75.75 0 0 1 1.055-.117z"
                }
            }
        ]
    })(props);
}
function BsSpotify(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.669 11.538a.498.498 0 0 1-.686.165c-1.879-1.147-4.243-1.407-7.028-.77a.499.499 0 0 1-.222-.973c3.048-.696 5.662-.397 7.77.892a.5.5 0 0 1 .166.686zm.979-2.178a.624.624 0 0 1-.858.205c-2.15-1.321-5.428-1.704-7.972-.932a.625.625 0 0 1-.362-1.194c2.905-.881 6.517-.454 8.986 1.063a.624.624 0 0 1 .206.858zm.084-2.268C10.154 5.56 5.9 5.419 3.438 6.166a.748.748 0 1 1-.434-1.432c2.825-.857 7.523-.692 10.492 1.07a.747.747 0 1 1-.764 1.288z"
                }
            }
        ]
    })(props);
}
function BsSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2z"
                }
            }
        ]
    })(props);
}
function BsSquareHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15V1h6a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H8zm6 1a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12z"
                }
            }
        ]
    })(props);
}
function BsSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                }
            }
        ]
    })(props);
}
function BsStackOverflow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.412 14.572V10.29h1.428V16H1v-5.71h1.428v4.282h9.984z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.857 13.145h7.137v-1.428H3.857v1.428zM10.254 0 9.108.852l4.26 5.727 1.146-.852L10.254 0zm-3.54 3.377 5.484 4.567.913-1.097L7.627 2.28l-.914 1.097zM4.922 6.55l6.47 3.013.603-1.294-6.47-3.013-.603 1.294zm-.925 3.344 6.985 1.469.294-1.398-6.985-1.468-.294 1.397z"
                }
            }
        ]
    })(props);
}
function BsStack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m14.12 10.163 1.715.858c.22.11.22.424 0 .534L8.267 15.34a.598.598 0 0 1-.534 0L.165 11.555a.299.299 0 0 1 0-.534l1.716-.858 5.317 2.659c.505.252 1.1.252 1.604 0l5.317-2.66zM7.733.063a.598.598 0 0 1 .534 0l7.568 3.784a.3.3 0 0 1 0 .535L8.267 8.165a.598.598 0 0 1-.534 0L.165 4.382a.299.299 0 0 1 0-.535L7.733.063z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14.12 6.576 1.715.858c.22.11.22.424 0 .534l-7.568 3.784a.598.598 0 0 1-.534 0L.165 7.968a.299.299 0 0 1 0-.534l1.716-.858 5.317 2.659c.505.252 1.1.252 1.604 0l5.317-2.659z"
                }
            }
        ]
    })(props);
}
function BsStarFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"
                }
            }
        ]
    })(props);
}
function BsStarHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.354 5.119 7.538.792A.516.516 0 0 1 8 .5c.183 0 .366.097.465.292l2.184 4.327 4.898.696A.537.537 0 0 1 16 6.32a.548.548 0 0 1-.17.445l-3.523 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256a.52.52 0 0 1-.146.05c-.342.06-.668-.254-.6-.642l.83-4.73L.173 6.765a.55.55 0 0 1-.172-.403.58.58 0 0 1 .085-.302.513.513 0 0 1 .37-.245l4.898-.696zM8 12.027a.5.5 0 0 1 .232.056l3.686 1.894-.694-3.957a.565.565 0 0 1 .162-.505l2.907-2.77-4.052-.576a.525.525 0 0 1-.393-.288L8.001 2.223 8 2.226v9.8z"
                }
            }
        ]
    })(props);
}
function BsStar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.565.565 0 0 0-.163-.505L1.71 6.745l4.052-.576a.525.525 0 0 0 .393-.288L8 2.223l1.847 3.658a.525.525 0 0 0 .393.288l4.052.575-2.906 2.77a.565.565 0 0 0-.163.506l.694 3.957-3.686-1.894a.503.503 0 0 0-.461 0z"
                }
            }
        ]
    })(props);
}
function BsStars(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.657 6.247c.11-.33.576-.33.686 0l.645 1.937a2.89 2.89 0 0 0 1.829 1.828l1.936.645c.33.11.33.576 0 .686l-1.937.645a2.89 2.89 0 0 0-1.828 1.829l-.645 1.936a.361.361 0 0 1-.686 0l-.645-1.937a2.89 2.89 0 0 0-1.828-1.828l-1.937-.645a.361.361 0 0 1 0-.686l1.937-.645a2.89 2.89 0 0 0 1.828-1.828l.645-1.937zM3.794 1.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387A1.734 1.734 0 0 0 4.593 5.69l-.387 1.162a.217.217 0 0 1-.412 0L3.407 5.69A1.734 1.734 0 0 0 2.31 4.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387A1.734 1.734 0 0 0 3.407 2.31l.387-1.162zM10.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.156 1.156 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.156 1.156 0 0 0-.732-.732L9.1 2.137a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732L10.863.1z"
                }
            }
        ]
    })(props);
}
function BsSteam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.329 10.333A8.01 8.01 0 0 0 7.99 16C12.414 16 16 12.418 16 8s-3.586-8-8.009-8A8.006 8.006 0 0 0 0 7.468l.003.006 4.304 1.769A2.198 2.198 0 0 1 5.62 8.88l1.96-2.844-.001-.04a3.046 3.046 0 0 1 3.042-3.043 3.046 3.046 0 0 1 3.042 3.043 3.047 3.047 0 0 1-3.111 3.044l-2.804 2a2.223 2.223 0 0 1-3.075 2.11 2.217 2.217 0 0 1-1.312-1.568L.33 10.333Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.868 12.683a1.715 1.715 0 0 0 1.318-3.165 1.705 1.705 0 0 0-1.263-.02l1.023.424a1.261 1.261 0 1 1-.97 2.33l-.99-.41a1.7 1.7 0 0 0 .882.84Zm3.726-6.687a2.03 2.03 0 0 0 2.027 2.029 2.03 2.03 0 0 0 2.027-2.029 2.03 2.03 0 0 0-2.027-2.027 2.03 2.03 0 0 0-2.027 2.027Zm2.03-1.527a1.524 1.524 0 1 1-.002 3.048 1.524 1.524 0 0 1 .002-3.048Z"
                }
            }
        ]
    })(props);
}
function BsStickiesFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 1.5V13a1 1 0 0 0 1 1V1.5a.5.5 0 0 1 .5-.5H14a1 1 0 0 0-1-1H1.5A1.5 1.5 0 0 0 0 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 2A1.5 1.5 0 0 0 2 3.5v11A1.5 1.5 0 0 0 3.5 16h6.086a1.5 1.5 0 0 0 1.06-.44l4.915-4.914A1.5 1.5 0 0 0 16 9.586V3.5A1.5 1.5 0 0 0 14.5 2h-11zm6 8.5a1 1 0 0 1 1-1h4.396a.25.25 0 0 1 .177.427l-5.146 5.146a.25.25 0 0 1-.427-.177V10.5z"
                }
            }
        ]
    })(props);
}
function BsStickies(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 0A1.5 1.5 0 0 0 0 1.5V13a1 1 0 0 0 1 1V1.5a.5.5 0 0 1 .5-.5H14a1 1 0 0 0-1-1H1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 2A1.5 1.5 0 0 0 2 3.5v11A1.5 1.5 0 0 0 3.5 16h6.086a1.5 1.5 0 0 0 1.06-.44l4.915-4.914A1.5 1.5 0 0 0 16 9.586V3.5A1.5 1.5 0 0 0 14.5 2h-11zM3 3.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5V9h-4.5A1.5 1.5 0 0 0 9 10.5V15H3.5a.5.5 0 0 1-.5-.5v-11zm7 11.293V10.5a.5.5 0 0 1 .5-.5h4.293L10 14.793z"
                }
            }
        ]
    })(props);
}
function BsStickyFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 1A1.5 1.5 0 0 0 1 2.5v11A1.5 1.5 0 0 0 2.5 15h6.086a1.5 1.5 0 0 0 1.06-.44l4.915-4.914A1.5 1.5 0 0 0 15 8.586V2.5A1.5 1.5 0 0 0 13.5 1h-11zm6 8.5a1 1 0 0 1 1-1h4.396a.25.25 0 0 1 .177.427l-5.146 5.146a.25.25 0 0 1-.427-.177V9.5z"
                }
            }
        ]
    })(props);
}
function BsSticky(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 1A1.5 1.5 0 0 0 1 2.5v11A1.5 1.5 0 0 0 2.5 15h6.086a1.5 1.5 0 0 0 1.06-.44l4.915-4.914A1.5 1.5 0 0 0 15 8.586V2.5A1.5 1.5 0 0 0 13.5 1h-11zM2 2.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5V8H9.5A1.5 1.5 0 0 0 8 9.5V14H2.5a.5.5 0 0 1-.5-.5v-11zm7 11.293V9.5a.5.5 0 0 1 .5-.5h4.293L9 13.793z"
                }
            }
        ]
    })(props);
}
function BsStopBtnFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm6.5-7A1.5 1.5 0 0 0 5 6.5v3A1.5 1.5 0 0 0 6.5 11h3A1.5 1.5 0 0 0 11 9.5v-3A1.5 1.5 0 0 0 9.5 5h-3z"
                }
            }
        ]
    })(props);
}
function BsStopBtn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 5A1.5 1.5 0 0 0 5 6.5v3A1.5 1.5 0 0 0 6.5 11h3A1.5 1.5 0 0 0 11 9.5v-3A1.5 1.5 0 0 0 9.5 5h-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"
                }
            }
        ]
    })(props);
}
function BsStopCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.5 5A1.5 1.5 0 0 0 5 6.5v3A1.5 1.5 0 0 0 6.5 11h3A1.5 1.5 0 0 0 11 9.5v-3A1.5 1.5 0 0 0 9.5 5h-3z"
                }
            }
        ]
    })(props);
}
function BsStopCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 6.5A1.5 1.5 0 0 1 6.5 5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5v-3z"
                }
            }
        ]
    })(props);
}
function BsStopFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3.5h6A1.5 1.5 0 0 1 12.5 5v6a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 11V5A1.5 1.5 0 0 1 5 3.5z"
                }
            }
        ]
    })(props);
}
function BsStop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 5A1.5 1.5 0 0 1 5 3.5h6A1.5 1.5 0 0 1 12.5 5v6a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 11V5zM5 4.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5H5z"
                }
            }
        ]
    })(props);
}
function BsStoplightsFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 0a2 2 0 0 0-2 2H2c.167.5.8 1.6 2 2v2H2c.167.5.8 1.6 2 2v2H2c.167.5.8 1.6 2 2v1a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-1c1.2-.4 1.833-1.5 2-2h-2V8c1.2-.4 1.833-1.5 2-2h-2V4c1.2-.4 1.833-1.5 2-2h-2a2 2 0 0 0-2-2H6zm3.5 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM8 13a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                }
            }
        ]
    })(props);
}
function BsStoplights(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm0 4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm1.5 2.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 2a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2h2c-.167.5-.8 1.6-2 2v2h2c-.167.5-.8 1.6-2 2v2h2c-.167.5-.8 1.6-2 2v1a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-1c-1.2-.4-1.833-1.5-2-2h2V8c-1.2-.4-1.833-1.5-2-2h2V4c-1.2-.4-1.833-1.5-2-2h2zm2-1a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H6z"
                }
            }
        ]
    })(props);
}
function BsStopwatchFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 0a.5.5 0 0 0 0 1H7v1.07A7.001 7.001 0 0 0 8 16a7 7 0 0 0 5.29-11.584.531.531 0 0 0 .013-.012l.354-.354.353.354a.5.5 0 1 0 .707-.707l-1.414-1.415a.5.5 0 1 0-.707.707l.354.354-.354.354a.717.717 0 0 0-.012.012A6.973 6.973 0 0 0 9 2.071V1h.5a.5.5 0 0 0 0-1h-3zm2 5.6V9a.5.5 0 0 1-.5.5H4.5a.5.5 0 0 1 0-1h3V5.6a.5.5 0 1 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsStopwatch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 5.6a.5.5 0 1 0-1 0v2.9h-3a.5.5 0 0 0 0 1H8a.5.5 0 0 0 .5-.5V5.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 1A.5.5 0 0 1 7 .5h2a.5.5 0 0 1 0 1v.57c1.36.196 2.594.78 3.584 1.64a.715.715 0 0 1 .012-.013l.354-.354-.354-.353a.5.5 0 0 1 .707-.708l1.414 1.415a.5.5 0 1 1-.707.707l-.353-.354-.354.354a.512.512 0 0 1-.013.012A7 7 0 1 1 7 2.071V1.5a.5.5 0 0 1-.5-.5zM8 3a6 6 0 1 0 .001 12A6 6 0 0 0 8 3z"
                }
            }
        ]
    })(props);
}
function BsStrava(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.731 0 2 9.125h2.788L6.73 5.497l1.93 3.628h2.766L6.731 0zm4.694 9.125-1.372 2.756L8.66 9.125H6.547L10.053 16l3.484-6.875h-2.112z"
                }
            }
        ]
    })(props);
}
function BsStripe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm6.226 5.385c-.584 0-.937.164-.937.593 0 .468.607.674 1.36.93 1.228.415 2.844.963 2.851 2.993C11.5 11.868 9.924 13 7.63 13a7.662 7.662 0 0 1-3.009-.626V9.758c.926.506 2.095.88 3.01.88.617 0 1.058-.165 1.058-.671 0-.518-.658-.755-1.453-1.041C6.026 8.49 4.5 7.94 4.5 6.11 4.5 4.165 5.988 3 8.226 3a7.29 7.29 0 0 1 2.734.505v2.583c-.838-.45-1.896-.703-2.734-.703Z"
                }
            }
        ]
    })(props);
}
function BsSubscript(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3.266 12.496.96-2.853H7.76l.96 2.853H10L6.62 3H5.38L2 12.496h1.266Zm2.748-8.063 1.419 4.23h-2.88l1.426-4.23h.035Zm6.132 7.203v-.075c0-.332.234-.618.619-.618.354 0 .618.256.618.58 0 .362-.271.649-.52.898l-1.788 1.832V15h3.59v-.958h-1.923v-.045l.973-1.04c.415-.438.867-.845.867-1.547 0-.8-.701-1.41-1.787-1.41-1.23 0-1.795.8-1.795 1.576v.06h1.146Z"
                }
            }
        ]
    })(props);
}
function BsSubstack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3.604H1v1.891h14v-1.89ZM1 7.208V16l7-3.926L15 16V7.208H1ZM15 0H1v1.89h14V0Z"
                }
            }
        ]
    })(props);
}
function BsSubtract(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H2a2 2 0 0 1-2-2V2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2z"
                }
            }
        ]
    })(props);
}
function BsSuitClubFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 12.5a3.493 3.493 0 0 1-2.684-1.254 19.92 19.92 0 0 0 1.582 2.907c.231.35-.02.847-.438.847H6.04c-.419 0-.67-.497-.438-.847a19.919 19.919 0 0 0 1.582-2.907 3.5 3.5 0 1 1-2.538-5.743 3.5 3.5 0 1 1 6.708 0A3.5 3.5 0 1 1 11.5 12.5z"
                }
            }
        ]
    })(props);
}
function BsSuitClub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1a3.25 3.25 0 0 0-3.25 3.25c0 .186 0 .29.016.41.014.12.045.27.12.527l.19.665-.692-.028a3.25 3.25 0 1 0 2.357 5.334.5.5 0 0 1 .844.518l-.003.005-.006.015-.024.055a21.893 21.893 0 0 1-.438.92 22.38 22.38 0 0 1-1.266 2.197c-.013.018-.02.05.001.09.01.02.021.03.03.036A.036.036 0 0 0 5.9 15h4.2c.01 0 .016-.002.022-.006a.092.092 0 0 0 .029-.035c.02-.04.014-.073.001-.091a22.875 22.875 0 0 1-1.704-3.117l-.024-.054-.006-.015-.002-.004a.5.5 0 0 1 .838-.524c.601.7 1.516 1.168 2.496 1.168a3.25 3.25 0 1 0-.139-6.498l-.699.03.199-.671c.14-.47.14-.745.139-.927V4.25A3.25 3.25 0 0 0 8 1zm2.207 12.024c.225.405.487.848.78 1.294C11.437 15 10.975 16 10.1 16H5.9c-.876 0-1.338-1-.887-1.683.291-.442.552-.88.776-1.283a4.25 4.25 0 1 1-2.007-8.187 2.79 2.79 0 0 1-.009-.064c-.023-.187-.023-.348-.023-.52V4.25a4.25 4.25 0 0 1 8.5 0c0 .14 0 .333-.04.596a4.25 4.25 0 0 1-.46 8.476 4.186 4.186 0 0 1-1.543-.298z"
                }
            }
        ]
    })(props);
}
function BsSuitDiamondFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.45 7.4 7.2 1.067a1 1 0 0 1 1.6 0L13.55 7.4a1 1 0 0 1 0 1.2L8.8 14.933a1 1 0 0 1-1.6 0L2.45 8.6a1 1 0 0 1 0-1.2z"
                }
            }
        ]
    })(props);
}
function BsSuitDiamond(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.384 1.226a.463.463 0 0 0-.768 0l-4.56 6.468a.537.537 0 0 0 0 .612l4.56 6.469a.463.463 0 0 0 .768 0l4.56-6.469a.537.537 0 0 0 0-.612l-4.56-6.468zM6.848.613a1.39 1.39 0 0 1 2.304 0l4.56 6.468a1.61 1.61 0 0 1 0 1.838l-4.56 6.468a1.39 1.39 0 0 1-2.304 0L2.288 8.92a1.61 1.61 0 0 1 0-1.838L6.848.613z"
                }
            }
        ]
    })(props);
}
function BsSuitHeartFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 1c2.21 0 4 1.755 4 3.92C8 2.755 9.79 1 12 1s4 1.755 4 3.92c0 3.263-3.234 4.414-7.608 9.608a.513.513 0 0 1-.784 0C3.234 9.334 0 8.183 0 4.92 0 2.755 1.79 1 4 1z"
                }
            }
        ]
    })(props);
}
function BsSuitHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m8 6.236-.894-1.789c-.222-.443-.607-1.08-1.152-1.595C5.418 2.345 4.776 2 4 2 2.324 2 1 3.326 1 4.92c0 1.211.554 2.066 1.868 3.37.337.334.721.695 1.146 1.093C5.122 10.423 6.5 11.717 8 13.447c1.5-1.73 2.878-3.024 3.986-4.064.425-.398.81-.76 1.146-1.093C14.446 6.986 15 6.131 15 4.92 15 3.326 13.676 2 12 2c-.777 0-1.418.345-1.954.852-.545.515-.93 1.152-1.152 1.595L8 6.236zm.392 8.292a.513.513 0 0 1-.784 0c-1.601-1.902-3.05-3.262-4.243-4.381C1.3 8.208 0 6.989 0 4.92 0 2.755 1.79 1 4 1c1.6 0 2.719 1.05 3.404 2.008.26.365.458.716.596.992a7.55 7.55 0 0 1 .596-.992C9.281 2.049 10.4 1 12 1c2.21 0 4 1.755 4 3.92 0 2.069-1.3 3.288-3.365 5.227-1.193 1.12-2.642 2.48-4.243 4.38z"
                }
            }
        ]
    })(props);
}
function BsSuitSpadeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.184 11.246A3.5 3.5 0 0 1 1 9c0-1.602 1.14-2.633 2.66-4.008C4.986 3.792 6.602 2.33 8 0c1.398 2.33 3.014 3.792 4.34 4.992C13.86 6.367 15 7.398 15 9a3.5 3.5 0 0 1-6.184 2.246 19.92 19.92 0 0 0 1.582 2.907c.231.35-.02.847-.438.847H6.04c-.419 0-.67-.497-.438-.847a19.919 19.919 0 0 0 1.582-2.907z"
                }
            }
        ]
    })(props);
}
function BsSuitSpade(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a.5.5 0 0 1 .429.243c1.359 2.265 2.925 3.682 4.25 4.882.096.086.19.17.282.255C14.308 6.604 15.5 7.747 15.5 9.5a4 4 0 0 1-5.406 3.746c.235.39.491.782.722 1.131.434.659-.01 1.623-.856 1.623H6.04c-.845 0-1.29-.964-.856-1.623.263-.397.51-.777.728-1.134A4 4 0 0 1 .5 9.5c0-1.753 1.192-2.896 2.539-4.12l.281-.255c1.326-1.2 2.892-2.617 4.251-4.882A.5.5 0 0 1 8 0zM3.711 6.12C2.308 7.396 1.5 8.253 1.5 9.5a3 3 0 0 0 5.275 1.956.5.5 0 0 1 .868.43c-.094.438-.33.932-.611 1.428a29.247 29.247 0 0 1-1.013 1.614.03.03 0 0 0-.005.018.074.074 0 0 0 .024.054h3.924a.074.074 0 0 0 .024-.054.03.03 0 0 0-.005-.018c-.3-.455-.658-1.005-.96-1.535-.294-.514-.57-1.064-.664-1.507a.5.5 0 0 1 .868-.43A3 3 0 0 0 14.5 9.5c0-1.247-.808-2.104-2.211-3.38L12 5.86c-1.196-1.084-2.668-2.416-4-4.424-1.332 2.008-2.804 3.34-4 4.422l-.289.261z"
                }
            }
        ]
    })(props);
}
function BsSuitcaseFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 .5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V3h1.5A1.5 1.5 0 0 1 13 4.5v9a1.5 1.5 0 0 1-1.004 1.416A1 1 0 1 1 10 15H6a1 1 0 1 1-1.997-.084A1.5 1.5 0 0 1 3 13.5v-9A1.5 1.5 0 0 1 4.5 3H6V.5ZM9 1H7v2h2V1ZM6 5.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7Zm2.5 0a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7Zm2.5 0a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7Z"
                }
            }
        ]
    })(props);
}
function BsSuitcaseLgFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 0a2 2 0 0 0-2 2H1.5A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14H2a.5.5 0 0 0 1 0h10a.5.5 0 0 0 1 0h.5a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2H11a2 2 0 0 0-2-2H7ZM6 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1H6ZM3 13V3h1v10H3Zm9 0V3h1v10h-1Z"
                }
            }
        ]
    })(props);
}
function BsSuitcaseLg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2h3.5A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5H14a.5.5 0 0 1-1 0H3a.5.5 0 0 1-1 0h-.5A1.5 1.5 0 0 1 0 12.5v-9A1.5 1.5 0 0 1 1.5 2H5Zm1 0h4a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1ZM1.5 3a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5H3V3H1.5ZM15 12.5v-9a.5.5 0 0 0-.5-.5H13v10h1.5a.5.5 0 0 0 .5-.5Zm-3 .5V3H4v10h8Z"
                }
            }
        ]
    })(props);
}
function BsSuitcase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 6 5Zm2 0a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5Zm2 0a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 10 5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 0a.5.5 0 0 0-.5.5V3H5a2 2 0 0 0-2 2v8a2 2 0 0 0 1.031 1.75A1.003 1.003 0 0 0 5 16a1 1 0 0 0 1-1h4a1 1 0 1 0 1.969-.25A2 2 0 0 0 13 13V5a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-.5-.5h-3ZM9 3H7V1h2v2Zm3 10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v8Z"
                }
            }
        ]
    })(props);
}
function BsSuitcase2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 0a.5.5 0 0 0-.5.5V3H4.5A1.5 1.5 0 0 0 3 4.5v9a1.5 1.5 0 0 0 1.003 1.416A1 1 0 1 0 6 15h4a1 1 0 1 0 1.996-.084A1.5 1.5 0 0 0 13 13.5v-9A1.5 1.5 0 0 0 11.5 3H10V.5a.5.5 0 0 0-.5-.5h-3ZM9 3H7V1h2v2ZM4 7V6h8v1H4Z"
                }
            }
        ]
    })(props);
}
function BsSuitcase2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 0a.5.5 0 0 0-.5.5V3H5a2 2 0 0 0-2 2v8a2 2 0 0 0 1.031 1.75A1.003 1.003 0 0 0 5 16a1 1 0 0 0 1-1h4a1 1 0 1 0 1.969-.25A2 2 0 0 0 13 13V5a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-.5-.5h-3ZM9 3H7V1h2v2Zm3 10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7h8v6ZM5 4h6a1 1 0 0 1 1 1v1H4V5a1 1 0 0 1 1-1Z"
                }
            }
        ]
    })(props);
}
function BsSunFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z"
                }
            }
        ]
    })(props);
}
function BsSun(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z"
                }
            }
        ]
    })(props);
}
function BsSunglasses(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5a2 2 0 0 0-2 2v.5H.5a.5.5 0 0 0 0 1H1V9a2 2 0 0 0 2 2h1a3 3 0 0 0 3-3 1 1 0 1 1 2 0 3 3 0 0 0 3 3h1a2 2 0 0 0 2-2v-.5h.5a.5.5 0 0 0 0-1H15V7a2 2 0 0 0-2-2h-2a2 2 0 0 0-1.888 1.338A1.99 1.99 0 0 0 8 6a1.99 1.99 0 0 0-1.112.338A2 2 0 0 0 5 5H3zm0 1h.941c.264 0 .348.356.112.474l-.457.228a2 2 0 0 0-.894.894l-.228.457C2.356 8.289 2 8.205 2 7.94V7a1 1 0 0 1 1-1z"
                }
            }
        ]
    })(props);
}
function BsSunriseFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.646 1.146a.5.5 0 0 1 .708 0l1.5 1.5a.5.5 0 0 1-.708.708L8.5 2.707V4.5a.5.5 0 0 1-1 0V2.707l-.646.647a.5.5 0 1 1-.708-.708l1.5-1.5zM2.343 4.343a.5.5 0 0 1 .707 0l1.414 1.414a.5.5 0 0 1-.707.707L2.343 5.05a.5.5 0 0 1 0-.707zm11.314 0a.5.5 0 0 1 0 .707l-1.414 1.414a.5.5 0 1 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zM11.709 11.5a4 4 0 1 0-7.418 0H.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1h-3.79zM0 10a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 0 10zm13 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsSunrise(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.646 1.146a.5.5 0 0 1 .708 0l1.5 1.5a.5.5 0 0 1-.708.708L8.5 2.707V4.5a.5.5 0 0 1-1 0V2.707l-.646.647a.5.5 0 1 1-.708-.708l1.5-1.5zM2.343 4.343a.5.5 0 0 1 .707 0l1.414 1.414a.5.5 0 0 1-.707.707L2.343 5.05a.5.5 0 0 1 0-.707zm11.314 0a.5.5 0 0 1 0 .707l-1.414 1.414a.5.5 0 1 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zM8 7a3 3 0 0 1 2.599 4.5H5.4A3 3 0 0 1 8 7zm3.71 4.5a4 4 0 1 0-7.418 0H.499a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1h-3.79zM0 10a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 0 10zm13 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsSunsetFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.646 4.854a.5.5 0 0 0 .708 0l1.5-1.5a.5.5 0 0 0-.708-.708l-.646.647V1.5a.5.5 0 0 0-1 0v1.793l-.646-.647a.5.5 0 1 0-.708.708l1.5 1.5zm-5.303-.51a.5.5 0 0 1 .707 0l1.414 1.413a.5.5 0 0 1-.707.707L2.343 5.05a.5.5 0 0 1 0-.707zm11.314 0a.5.5 0 0 1 0 .706l-1.414 1.414a.5.5 0 1 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zM11.709 11.5a4 4 0 1 0-7.418 0H.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1h-3.79zM0 10a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 0 10zm13 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsSunset(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.646 4.854a.5.5 0 0 0 .708 0l1.5-1.5a.5.5 0 0 0-.708-.708l-.646.647V1.5a.5.5 0 0 0-1 0v1.793l-.646-.647a.5.5 0 1 0-.708.708l1.5 1.5zm-5.303-.51a.5.5 0 0 1 .707 0l1.414 1.413a.5.5 0 0 1-.707.707L2.343 5.05a.5.5 0 0 1 0-.707zm11.314 0a.5.5 0 0 1 0 .706l-1.414 1.414a.5.5 0 1 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zM8 7a3 3 0 0 1 2.599 4.5H5.4A3 3 0 0 1 8 7zm3.71 4.5a4 4 0 1 0-7.418 0H.499a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1h-3.79zM0 10a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 0 10zm13 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsSuperscript(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m4.266 12.496.96-2.853H8.76l.96 2.853H11L7.62 3H6.38L3 12.496h1.266Zm2.748-8.063 1.419 4.23h-2.88l1.426-4.23h.035Zm5.132-1.797v-.075c0-.332.234-.618.619-.618.354 0 .618.256.618.58 0 .362-.271.649-.52.898l-1.788 1.832V6h3.59v-.958h-1.923v-.045l.973-1.04c.415-.438.867-.845.867-1.547 0-.8-.701-1.41-1.787-1.41C11.565 1 11 1.8 11 2.576v.06h1.146Z"
                }
            }
        ]
    })(props);
}
function BsSymmetryHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 7a.5.5 0 0 0 .24-.939l-11-6A.5.5 0 0 0 2 .5v6a.5.5 0 0 0 .5.5h11zm.485 2.376a.5.5 0 0 1-.246.563l-11 6A.5.5 0 0 1 2 15.5v-6a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .485.376zM11.539 10H3v4.658L11.54 10z"
                }
            }
        ]
    })(props);
}
function BsSymmetryVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2.5a.5.5 0 0 0-.939-.24l-6 11A.5.5 0 0 0 .5 14h6a.5.5 0 0 0 .5-.5v-11zm2.376-.484a.5.5 0 0 1 .563.245l6 11A.5.5 0 0 1 15.5 14h-6a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .376-.484zM10 4.46V13h4.658L10 4.46z"
                }
            }
        ]
    })(props);
}
function BsTable(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm15 2h-4v3h4V4zm0 4h-4v3h4V8zm0 4h-4v3h3a1 1 0 0 0 1-1v-2zm-5 3v-3H6v3h4zm-5 0v-3H1v2a1 1 0 0 0 1 1h3zm-4-4h4V8H1v3zm0-4h4V4H1v3zm5-3v3h4V4H6zm4 4H6v3h4V8z"
                }
            }
        ]
    })(props);
}
function BsTabletFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm7 11a1 1 0 1 0-2 0 1 1 0 0 0 2 0z"
                }
            }
        ]
    })(props);
}
function BsTabletLandscapeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 14a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2zm11-7a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
                }
            }
        ]
    })(props);
}
function BsTabletLandscape(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4zm-1 8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0z"
                }
            }
        ]
    })(props);
}
function BsTablet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h8zM4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                }
            }
        ]
    })(props);
}
function BsTagFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l4.586-4.586a1 1 0 0 0 0-1.414l-7-7A1 1 0 0 0 6.586 1H2zm4 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
                }
            }
        ]
    })(props);
}
function BsTag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm-1 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 1 6.586V2a1 1 0 0 1 1-1zm0 5.586 7 7L13.586 9l-7-7H2v4.586z"
                }
            }
        ]
    })(props);
}
function BsTagsFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2a1 1 0 0 1 1-1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 2 6.586V2zm3.5 4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.293 7.793A1 1 0 0 1 1 7.086V2a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l.043-.043-7.457-7.457z"
                }
            }
        ]
    })(props);
}
function BsTags(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2v4.586l7 7L14.586 9l-7-7H3zM2 2a1 1 0 0 1 1-1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 2 6.586V2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm0 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM1 7.086a1 1 0 0 0 .293.707L8.75 15.25l-.043.043a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 0 7.586V3a1 1 0 0 1 1-1v5.086z"
                }
            }
        ]
    })(props);
}
function BsTaxiFrontFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 1a1 1 0 0 0-1 1v1h-.181A2.5 2.5 0 0 0 2.52 4.515l-.792 1.848a.807.807 0 0 1-.38.404c-.5.25-.855.715-.965 1.262L.05 9.708a2.5 2.5 0 0 0-.049.49v.413c0 .814.39 1.543 1 1.997V14.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1.338c1.292.048 2.745.088 4 .088s2.708-.04 4-.088V14.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1.892c.61-.454 1-1.183 1-1.997v-.413c0-.165-.016-.329-.049-.49l-.335-1.68a1.807 1.807 0 0 0-.964-1.261.807.807 0 0 1-.381-.404l-.792-1.848A2.5 2.5 0 0 0 11.181 3H11V2a1 1 0 0 0-1-1H6ZM4.309 4h7.382a.5.5 0 0 1 .447.276l.956 1.913a.51.51 0 0 1-.497.731c-.91-.073-3.35-.17-4.597-.17-1.247 0-3.688.097-4.597.17a.51.51 0 0 1-.497-.731l.956-1.913A.5.5 0 0 1 4.309 4ZM4 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm10 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-9 0a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Z"
                }
            }
        ]
    })(props);
}
function BsTaxiFront(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.862 5.276 3.906 7.19a.51.51 0 0 0 .497.731c.91-.073 2.35-.17 3.597-.17 1.247 0 2.688.097 3.597.17a.51.51 0 0 0 .497-.731l-.956-1.913A.5.5 0 0 0 10.691 5H5.309a.5.5 0 0 0-.447.276ZM4 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm10 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-9 0a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 1a1 1 0 0 0-1 1v1h-.181A2.5 2.5 0 0 0 2.52 4.515l-.792 1.848a.807.807 0 0 1-.38.404c-.5.25-.855.715-.965 1.262L.05 9.708a2.5 2.5 0 0 0-.049.49v.413c0 .814.39 1.543 1 1.997V14.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1.338c1.292.048 2.745.088 4 .088s2.708-.04 4-.088V14.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1.892c.61-.454 1-1.183 1-1.997v-.413c0-.165-.016-.329-.049-.49l-.335-1.68a1.807 1.807 0 0 0-.964-1.261.807.807 0 0 1-.381-.404l-.792-1.848A2.5 2.5 0 0 0 11.181 3H11V2a1 1 0 0 0-1-1H6ZM4.819 4h6.362a1.5 1.5 0 0 1 1.379.91l.792 1.847a1.8 1.8 0 0 0 .853.904c.222.112.381.32.43.564l.336 1.679c.02.097.029.195.029.294v.413a1.48 1.48 0 0 1-1.408 1.484c-1.555.07-3.786.155-5.592.155-1.806 0-4.037-.084-5.592-.155A1.479 1.479 0 0 1 1 10.611v-.413c0-.099.01-.197.03-.294l.335-1.68a.807.807 0 0 1 .43-.563c.383-.19.685-.511.853-.904l.792-1.848A1.5 1.5 0 0 1 4.82 4Z"
                }
            }
        ]
    })(props);
}
function BsTelegram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.287 5.906c-.778.324-2.334.994-4.666 2.01-.378.15-.577.298-.595.442-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294.26.006.549-.1.868-.32 2.179-1.471 3.304-2.214 3.374-2.23.05-.012.12-.026.166.016.047.041.042.12.037.141-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8.154 8.154 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629.093.06.183.125.27.187.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.426 1.426 0 0 0-.013-.315.337.337 0 0 0-.114-.217.526.526 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09z"
                }
            }
        ]
    })(props);
}
function BsTelephoneFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"
                }
            }
        ]
    })(props);
}
function BsTelephoneForwardFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm10.761.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708z"
                }
            }
        ]
    })(props);
}
function BsTelephoneForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm10.762.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708z"
                }
            }
        ]
    })(props);
}
function BsTelephoneInboundFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zM15.854.146a.5.5 0 0 1 0 .708L11.707 5H14.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0v2.793L15.146.146a.5.5 0 0 1 .708 0z"
                }
            }
        ]
    })(props);
}
function BsTelephoneInbound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.854.146a.5.5 0 0 1 0 .708L11.707 5H14.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0v2.793L15.146.146a.5.5 0 0 1 .708 0zm-12.2 1.182a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"
                }
            }
        ]
    })(props);
}
function BsTelephoneMinusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zM10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsTelephoneMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"
                }
            }
        ]
    })(props);
}
function BsTelephoneOutboundFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsTelephoneOutbound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsTelephonePlusFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zM12.5 1a.5.5 0 0 1 .5.5V3h1.5a.5.5 0 0 1 0 1H13v1.5a.5.5 0 0 1-1 0V4h-1.5a.5.5 0 0 1 0-1H12V1.5a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsTelephonePlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.5 1a.5.5 0 0 1 .5.5V3h1.5a.5.5 0 0 1 0 1H13v1.5a.5.5 0 0 1-1 0V4h-1.5a.5.5 0 0 1 0-1H12V1.5a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsTelephoneXFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm9.261 1.135a.5.5 0 0 1 .708 0L13 2.793l1.146-1.147a.5.5 0 0 1 .708.708L13.707 3.5l1.147 1.146a.5.5 0 0 1-.708.708L13 4.207l-1.146 1.147a.5.5 0 0 1-.708-.708L12.293 3.5l-1.147-1.146a.5.5 0 0 1 0-.708z"
                }
            }
        ]
    })(props);
}
function BsTelephoneX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.146 1.646a.5.5 0 0 1 .708 0L13 2.793l1.146-1.147a.5.5 0 0 1 .708.708L13.707 3.5l1.147 1.146a.5.5 0 0 1-.708.708L13 4.207l-1.146 1.147a.5.5 0 0 1-.708-.708L12.293 3.5l-1.147-1.146a.5.5 0 0 1 0-.708z"
                }
            }
        ]
    })(props);
}
function BsTelephone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"
                }
            }
        ]
    })(props);
}
function BsTencentQq(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.048 3.323c.022.277-.13.523-.338.55-.21.026-.397-.176-.419-.453-.022-.277.13-.523.338-.55.21-.026.397.176.42.453Zm2.265-.24c-.603-.146-.894.256-.936.333-.027.048-.008.117.037.15.045.035.092.025.119-.003.361-.39.751-.172.829-.129l.011.007c.053.024.147.028.193-.098.023-.063.017-.11-.006-.142-.016-.023-.089-.08-.247-.118Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.727 6.719c0-.022.01-.375.01-.557 0-3.07-1.45-6.156-5.015-6.156-3.564 0-5.014 3.086-5.014 6.156 0 .182.01.535.01.557l-.72 1.795a25.85 25.85 0 0 0-.534 1.508c-.68 2.187-.46 3.093-.292 3.113.36.044 1.401-1.647 1.401-1.647 0 .979.504 2.256 1.594 3.179-.408.126-.907.319-1.228.556-.29.213-.253.43-.201.518.228.386 3.92.246 4.985.126 1.065.12 4.756.26 4.984-.126.052-.088.088-.305-.2-.518-.322-.237-.822-.43-1.23-.557 1.09-.922 1.594-2.2 1.594-3.178 0 0 1.041 1.69 1.401 1.647.168-.02.388-.926-.292-3.113a25.78 25.78 0 0 0-.534-1.508l-.72-1.795ZM9.773 5.53a.095.095 0 0 1-.009.096c-.109.159-1.554.943-3.033.943h-.017c-1.48 0-2.925-.784-3.034-.943a.098.098 0 0 1-.018-.055c0-.015.004-.028.01-.04.13-.287 1.43-.606 3.042-.606h.017c1.611 0 2.912.319 3.042.605Zm-4.32-.989c-.483.022-.896-.529-.922-1.229-.026-.7.344-1.286.828-1.308.483-.022.896.529.922 1.23.027.7-.344 1.286-.827 1.307Zm2.538 0c-.484-.022-.854-.607-.828-1.308.027-.7.44-1.25.923-1.23.483.023.853.608.827 1.309-.026.7-.439 1.251-.922 1.23ZM2.928 8.99c.213.042.426.081.639.117v2.336s1.104.222 2.21.068V9.363c.326.018.64.026.937.023h.017c1.117.013 2.474-.136 3.786-.396.097.622.151 1.386.097 2.284-.146 2.45-1.6 3.99-3.846 4.012h-.091c-2.245-.023-3.7-1.562-3.846-4.011-.054-.9 0-1.663.097-2.285Z"
                }
            }
        ]
    })(props);
}
function BsTerminalDash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5.5a.5.5 0 0 1 0 1H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v4a.5.5 0 0 1-1 0V4a1 1 0 0 0-1-1H2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.146 5.146a.5.5 0 0 1 .708 0L5.177 6.47a.75.75 0 0 1 0 1.06L3.854 8.854a.5.5 0 1 1-.708-.708L4.293 7 3.146 5.854a.5.5 0 0 1 0-.708ZM5.5 9a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5ZM16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-5.5 0a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5Z"
                }
            }
        ]
    })(props);
}
function BsTerminalFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3zm9.5 5.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm-6.354-.354a.5.5 0 1 0 .708.708l2-2a.5.5 0 0 0 0-.708l-2-2a.5.5 0 1 0-.708.708L4.793 6.5 3.146 8.146z"
                }
            }
        ]
    })(props);
}
function BsTerminalPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5.5a.5.5 0 0 1 0 1H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v4a.5.5 0 0 1-1 0V4a1 1 0 0 0-1-1H2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.146 5.146a.5.5 0 0 1 .708 0L5.177 6.47a.75.75 0 0 1 0 1.06L3.854 8.854a.5.5 0 1 1-.708-.708L4.293 7 3.146 5.854a.5.5 0 0 1 0-.708ZM5.5 9a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5ZM16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-3.5-2a.5.5 0 0 0-.5.5v1h-1a.5.5 0 0 0 0 1h1v1a.5.5 0 0 0 1 0v-1h1a.5.5 0 0 0 0-1h-1v-1a.5.5 0 0 0-.5-.5Z"
                }
            }
        ]
    })(props);
}
function BsTerminalSplit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.146 3.146a.5.5 0 0 1 .708 0l.823.824a.75.75 0 0 1 0 1.06l-.823.824a.5.5 0 1 1-.708-.708l.647-.646-.647-.646a.5.5 0 0 1 0-.708ZM4 6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1A.5.5 0 0 1 4 6Zm6.354-2.854a.5.5 0 0 0-.708.708l.647.646-.647.646a.5.5 0 1 0 .708.708l.823-.824a.75.75 0 0 0 0-1.06l-.823-.824ZM12 5.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3Zm2-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h5.5V2H2Zm6.5 0v12H14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H8.5Z"
                }
            }
        ]
    })(props);
}
function BsTerminalX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5.5a.5.5 0 0 1 0 1H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v4a.5.5 0 0 1-1 0V4a1 1 0 0 0-1-1H2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.146 5.146a.5.5 0 0 1 .708 0L5.177 6.47a.75.75 0 0 1 0 1.06L3.854 8.854a.5.5 0 1 1-.708-.708L4.293 7 3.146 5.854a.5.5 0 0 1 0-.708ZM5.5 9a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5ZM16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-4.854-1.354a.5.5 0 0 0 0 .708l.647.646-.647.646a.5.5 0 0 0 .708.708l.646-.647.646.647a.5.5 0 0 0 .708-.708l-.647-.646.647-.646a.5.5 0 0 0-.708-.708l-.646.647-.646-.647a.5.5 0 0 0-.708 0Z"
                }
            }
        ]
    })(props);
}
function BsTerminal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 9a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3A.5.5 0 0 1 6 9zM3.854 4.146a.5.5 0 1 0-.708.708L4.793 6.5 3.146 8.146a.5.5 0 1 0 .708.708l2-2a.5.5 0 0 0 0-.708l-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2zm12 1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h12z"
                }
            }
        ]
    })(props);
}
function BsTextCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsTextIndentLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm.646 2.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L4.293 8 2.646 6.354a.5.5 0 0 1 0-.708zM7 6.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm-5 3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsTextIndentRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm10.646 2.146a.5.5 0 0 1 .708.708L11.707 8l1.647 1.646a.5.5 0 0 1-.708.708l-2-2a.5.5 0 0 1 0-.708l2-2zM2 6.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsTextLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsTextParagraph(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm4-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsTextRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-4-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm4-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-4-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsTextWrap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 3.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5Zm0 4a.5.5 0 0 1 .5-.5h9a2.5 2.5 0 0 1 0 5h-1.293l.647.646a.5.5 0 0 1-.708.708l-1.5-1.5a.5.5 0 0 1 0-.708l1.5-1.5a.5.5 0 0 1 .708.708l-.647.646H11.5a1.5 1.5 0 0 0 0-3h-9a.5.5 0 0 1-.5-.5Zm0 4a.5.5 0 0 1 .5-.5H7a.5.5 0 0 1 0 1H2.5a.5.5 0 0 1-.5-.5Z"
                }
            }
        ]
    })(props);
}
function BsTextareaResize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4.5A2.5 2.5 0 0 1 2.5 2h11A2.5 2.5 0 0 1 16 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 0 11.5v-7zM2.5 3A1.5 1.5 0 0 0 1 4.5v7A1.5 1.5 0 0 0 2.5 13h11a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 13.5 3h-11zm10.854 4.646a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708l3-3a.5.5 0 0 1 .708 0zm0 2.5a.5.5 0 0 1 0 .708l-.5.5a.5.5 0 0 1-.708-.708l.5-.5a.5.5 0 0 1 .708 0z"
                }
            }
        ]
    })(props);
}
function BsTextareaT(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 2.5A1.5 1.5 0 0 1 3 1h10a1.5 1.5 0 0 1 1.5 1.5v3.563a2 2 0 0 1 0 3.874V13.5A1.5 1.5 0 0 1 13 15H3a1.5 1.5 0 0 1-1.5-1.5V9.937a2 2 0 0 1 0-3.874V2.5zm1 3.563a2 2 0 0 1 0 3.874V13.5a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9.937a2 2 0 0 1 0-3.874V2.5A.5.5 0 0 0 13 2H3a.5.5 0 0 0-.5.5v3.563zM2 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm12 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.434 4H4.566L4.5 5.994h.386c.21-1.252.612-1.446 2.173-1.495l.343-.011v6.343c0 .537-.116.665-1.049.748V12h3.294v-.421c-.938-.083-1.054-.21-1.054-.748V4.488l.348.01c1.56.05 1.963.244 2.173 1.496h.386L11.434 4z"
                }
            }
        ]
    })(props);
}
function BsTextarea(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 2.5A1.5 1.5 0 0 1 3 1h10a1.5 1.5 0 0 1 1.5 1.5v3.563a2 2 0 0 1 0 3.874V13.5A1.5 1.5 0 0 1 13 15H3a1.5 1.5 0 0 1-1.5-1.5V9.937a2 2 0 0 1 0-3.874V2.5zm1 3.563a2 2 0 0 1 0 3.874V13.5a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9.937a2 2 0 0 1 0-3.874V2.5A.5.5 0 0 0 13 2H3a.5.5 0 0 0-.5.5v3.563zM2 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm12 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
                }
            }
        ]
    })(props);
}
function BsThermometerHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 12.5a1.5 1.5 0 1 1-2-1.415V6.5a.5.5 0 0 1 1 0v4.585a1.5 1.5 0 0 1 1 1.415z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 2.5a2.5 2.5 0 0 1 5 0v7.55a3.5 3.5 0 1 1-5 0V2.5zM8 1a1.5 1.5 0 0 0-1.5 1.5v7.987l-.167.15a2.5 2.5 0 1 0 3.333 0l-.166-.15V2.5A1.5 1.5 0 0 0 8 1z"
                }
            }
        ]
    })(props);
}
function BsThermometerHigh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 12.5a1.5 1.5 0 1 1-2-1.415V2.5a.5.5 0 0 1 1 0v8.585a1.5 1.5 0 0 1 1 1.415z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 2.5a2.5 2.5 0 0 1 5 0v7.55a3.5 3.5 0 1 1-5 0V2.5zM8 1a1.5 1.5 0 0 0-1.5 1.5v7.987l-.167.15a2.5 2.5 0 1 0 3.333 0l-.166-.15V2.5A1.5 1.5 0 0 0 8 1z"
                }
            }
        ]
    })(props);
}
function BsThermometerLow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 12.5a1.5 1.5 0 1 1-2-1.415V9.5a.5.5 0 0 1 1 0v1.585a1.5 1.5 0 0 1 1 1.415z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 2.5a2.5 2.5 0 0 1 5 0v7.55a3.5 3.5 0 1 1-5 0V2.5zM8 1a1.5 1.5 0 0 0-1.5 1.5v7.987l-.167.15a2.5 2.5 0 1 0 3.333 0l-.166-.15V2.5A1.5 1.5 0 0 0 8 1z"
                }
            }
        ]
    })(props);
}
function BsThermometerSnow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12.5a1.5 1.5 0 1 1-2-1.415V9.5a.5.5 0 0 1 1 0v1.585A1.5 1.5 0 0 1 5 12.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 2.5a2.5 2.5 0 0 1 5 0v7.55a3.5 3.5 0 1 1-5 0V2.5zM3.5 1A1.5 1.5 0 0 0 2 2.5v7.987l-.167.15a2.5 2.5 0 1 0 3.333 0L5 10.486V2.5A1.5 1.5 0 0 0 3.5 1zm5 1a.5.5 0 0 1 .5.5v1.293l.646-.647a.5.5 0 0 1 .708.708L9 5.207v1.927l1.669-.963.495-1.85a.5.5 0 1 1 .966.26l-.237.882 1.12-.646a.5.5 0 0 1 .5.866l-1.12.646.884.237a.5.5 0 1 1-.26.966l-1.848-.495L9.5 8l1.669.963 1.849-.495a.5.5 0 1 1 .258.966l-.883.237 1.12.646a.5.5 0 0 1-.5.866l-1.12-.646.237.883a.5.5 0 1 1-.966.258L10.67 9.83 9 8.866v1.927l1.354 1.353a.5.5 0 0 1-.708.708L9 12.207V13.5a.5.5 0 0 1-1 0v-11a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsThermometerSun(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12.5a1.5 1.5 0 1 1-2-1.415V2.5a.5.5 0 0 1 1 0v8.585A1.5 1.5 0 0 1 5 12.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 2.5a2.5 2.5 0 0 1 5 0v7.55a3.5 3.5 0 1 1-5 0V2.5zM3.5 1A1.5 1.5 0 0 0 2 2.5v7.987l-.167.15a2.5 2.5 0 1 0 3.333 0L5 10.486V2.5A1.5 1.5 0 0 0 3.5 1zm5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 .5-.5zm4.243 1.757a.5.5 0 0 1 0 .707l-.707.708a.5.5 0 1 1-.708-.708l.708-.707a.5.5 0 0 1 .707 0zM8 5.5a.5.5 0 0 1 .5-.5 3 3 0 1 1 0 6 .5.5 0 0 1 0-1 2 2 0 0 0 0-4 .5.5 0 0 1-.5-.5zM12.5 8a.5.5 0 0 1 .5-.5h1a.5.5 0 1 1 0 1h-1a.5.5 0 0 1-.5-.5zm-1.172 2.828a.5.5 0 0 1 .708 0l.707.708a.5.5 0 0 1-.707.707l-.708-.707a.5.5 0 0 1 0-.708zM8.5 12a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsThermometer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a2.5 2.5 0 0 0-2.5 2.5v7.55a3.5 3.5 0 1 0 5 0V2.5A2.5 2.5 0 0 0 8 0zM6.5 2.5a1.5 1.5 0 1 1 3 0v7.987l.167.15a2.5 2.5 0 1 1-3.333 0l.166-.15V2.5z"
                }
            }
        ]
    })(props);
}
function BsThreadsFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.81 9.204c0-.41.197-1.062 1.727-1.062.469 0 .758.034 1.146.121-.124 1.606-.91 1.818-1.674 1.818-.418 0-1.2-.218-1.2-.877Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.59 16h10.82A2.59 2.59 0 0 0 16 13.41V2.59A2.59 2.59 0 0 0 13.41 0H2.59A2.59 2.59 0 0 0 0 2.59v10.82A2.59 2.59 0 0 0 2.59 16ZM5.866 5.91c.567-.81 1.315-1.126 2.35-1.126.73 0 1.351.246 1.795.711.443.466.696 1.132.754 1.983.245.103.472.224.678.363.832.559 1.29 1.395 1.29 2.353 0 2.037-1.67 3.806-4.692 3.806-2.595 0-5.291-1.51-5.291-6.004C2.75 3.526 5.361 2 8.033 2c1.234 0 4.129.182 5.217 3.777l-1.02.264c-.842-2.56-2.607-2.968-4.224-2.968-2.675 0-4.187 1.628-4.187 5.093 0 3.107 1.69 4.757 4.222 4.757 2.083 0 3.636-1.082 3.636-2.667 0-1.079-.906-1.595-.953-1.595-.177.925-.651 2.482-2.733 2.482-1.213 0-2.26-.838-2.26-1.936 0-1.568 1.488-2.136 2.663-2.136.44 0 .97.03 1.247.086 0-.478-.404-1.296-1.426-1.296-.911 0-1.16.288-1.45.624l-.024.027c-.202-.135-.875-.601-.875-.601Z"
                }
            }
        ]
    })(props);
}
function BsThreads(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.321 6.016c-.27-.18-1.166-.802-1.166-.802.756-1.081 1.753-1.502 3.132-1.502.975 0 1.803.327 2.394.948.591.621.928 1.509 1.005 2.644.328.138.63.299.905.484 1.109.745 1.719 1.86 1.719 3.137 0 2.716-2.226 5.075-6.256 5.075C4.594 16 1 13.987 1 7.994 1 2.034 4.482 0 8.044 0 9.69 0 13.55.243 15 5.036l-1.36.353C12.516 1.974 10.163 1.43 8.006 1.43c-3.565 0-5.582 2.171-5.582 6.79 0 4.143 2.254 6.343 5.63 6.343 2.777 0 4.847-1.443 4.847-3.556 0-1.438-1.208-2.127-1.27-2.127-.236 1.234-.868 3.31-3.644 3.31-1.618 0-3.013-1.118-3.013-2.582 0-2.09 1.984-2.847 3.55-2.847.586 0 1.294.04 1.663.114 0-.637-.54-1.728-1.9-1.728-1.25 0-1.566.405-1.967.868ZM8.716 8.19c-2.04 0-2.304.87-2.304 1.416 0 .878 1.043 1.168 1.6 1.168 1.02 0 2.067-.282 2.232-2.423a6.217 6.217 0 0 0-1.528-.161Z"
                }
            }
        ]
    })(props);
}
function BsThreeDotsVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
                }
            }
        ]
    })(props);
}
function BsThreeDots(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                }
            }
        ]
    })(props);
}
function BsThunderboltFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 3a1 1 0 0 0-1 1v7.293A1 1 0 0 0 .293 12L2 13.707a1 1 0 0 0 .707.293h10.586a1 1 0 0 0 .707-.293L15.707 12a1 1 0 0 0 .293-.707V4a1 1 0 0 0-1-1H1Zm2.5 3h9a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5Z"
                }
            }
        ]
    })(props);
}
function BsThunderbolt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-9Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 3a1 1 0 0 0-1 1v7.293A1 1 0 0 0 .293 12L2 13.707a1 1 0 0 0 .707.293h10.586a1 1 0 0 0 .707-.293L15.707 12a1 1 0 0 0 .293-.707V4a1 1 0 0 0-1-1H1Zm0 1h14v7.293L13.293 13H2.707L1 11.293V4Z"
                }
            }
        ]
    })(props);
}
function BsTicketDetailedFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4.5A1.5 1.5 0 0 1 1.5 3h13A1.5 1.5 0 0 1 16 4.5V6a.5.5 0 0 1-.5.5 1.5 1.5 0 0 0 0 3 .5.5 0 0 1 .5.5v1.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 11.5V10a.5.5 0 0 1 .5-.5 1.5 1.5 0 1 0 0-3A.5.5 0 0 1 0 6V4.5Zm4 1a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5Zm0 5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5ZM4 8a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2H5a1 1 0 0 0-1 1Z"
                }
            }
        ]
    })(props);
}
function BsTicketDetailed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 5.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Zm0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5ZM5 7a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4.5A1.5 1.5 0 0 1 1.5 3h13A1.5 1.5 0 0 1 16 4.5V6a.5.5 0 0 1-.5.5 1.5 1.5 0 0 0 0 3 .5.5 0 0 1 .5.5v1.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 11.5V10a.5.5 0 0 1 .5-.5 1.5 1.5 0 1 0 0-3A.5.5 0 0 1 0 6V4.5ZM1.5 4a.5.5 0 0 0-.5.5v1.05a2.5 2.5 0 0 1 0 4.9v1.05a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-1.05a2.5 2.5 0 0 1 0-4.9V4.5a.5.5 0 0 0-.5-.5h-13Z"
                }
            }
        ]
    })(props);
}
function BsTicketFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 3A1.5 1.5 0 0 0 0 4.5V6a.5.5 0 0 0 .5.5 1.5 1.5 0 1 1 0 3 .5.5 0 0 0-.5.5v1.5A1.5 1.5 0 0 0 1.5 13h13a1.5 1.5 0 0 0 1.5-1.5V10a.5.5 0 0 0-.5-.5 1.5 1.5 0 0 1 0-3A.5.5 0 0 0 16 6V4.5A1.5 1.5 0 0 0 14.5 3h-13Z"
                }
            }
        ]
    })(props);
}
function BsTicketPerforatedFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4.5A1.5 1.5 0 0 1 1.5 3h13A1.5 1.5 0 0 1 16 4.5V6a.5.5 0 0 1-.5.5 1.5 1.5 0 0 0 0 3 .5.5 0 0 1 .5.5v1.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 11.5V10a.5.5 0 0 1 .5-.5 1.5 1.5 0 1 0 0-3A.5.5 0 0 1 0 6V4.5Zm4-1v1h1v-1H4Zm1 3v-1H4v1h1Zm7 0v-1h-1v1h1Zm-1-2h1v-1h-1v1Zm-6 3H4v1h1v-1Zm7 1v-1h-1v1h1Zm-7 1H4v1h1v-1Zm7 1v-1h-1v1h1Zm-8 1v1h1v-1H4Zm7 1h1v-1h-1v1Z"
                }
            }
        ]
    })(props);
}
function BsTicketPerforated(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4.85v.9h1v-.9H4Zm7 0v.9h1v-.9h-1Zm-7 1.8v.9h1v-.9H4Zm7 0v.9h1v-.9h-1Zm-7 1.8v.9h1v-.9H4Zm7 0v.9h1v-.9h-1Zm-7 1.8v.9h1v-.9H4Zm7 0v.9h1v-.9h-1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 3A1.5 1.5 0 0 0 0 4.5V6a.5.5 0 0 0 .5.5 1.5 1.5 0 1 1 0 3 .5.5 0 0 0-.5.5v1.5A1.5 1.5 0 0 0 1.5 13h13a1.5 1.5 0 0 0 1.5-1.5V10a.5.5 0 0 0-.5-.5 1.5 1.5 0 0 1 0-3A.5.5 0 0 0 16 6V4.5A1.5 1.5 0 0 0 14.5 3h-13ZM1 4.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v1.05a2.5 2.5 0 0 0 0 4.9v1.05a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-1.05a2.5 2.5 0 0 0 0-4.9V4.5Z"
                }
            }
        ]
    })(props);
}
function BsTicket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4.5A1.5 1.5 0 0 1 1.5 3h13A1.5 1.5 0 0 1 16 4.5V6a.5.5 0 0 1-.5.5 1.5 1.5 0 0 0 0 3 .5.5 0 0 1 .5.5v1.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 11.5V10a.5.5 0 0 1 .5-.5 1.5 1.5 0 1 0 0-3A.5.5 0 0 1 0 6V4.5ZM1.5 4a.5.5 0 0 0-.5.5v1.05a2.5 2.5 0 0 1 0 4.9v1.05a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-1.05a2.5 2.5 0 0 1 0-4.9V4.5a.5.5 0 0 0-.5-.5h-13Z"
                }
            }
        ]
    })(props);
}
function BsTiktok(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3V0Z"
                }
            }
        ]
    })(props);
}
function BsToggleOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 4a4 4 0 0 1 0 8H8a4.992 4.992 0 0 0 2-4 4.992 4.992 0 0 0-2-4h3zm-6 8a4 4 0 1 1 0-8 4 4 0 0 1 0 8zM0 8a5 5 0 0 0 5 5h6a5 5 0 0 0 0-10H5a5 5 0 0 0-5 5z"
                }
            }
        ]
    })(props);
}
function BsToggleOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3a5 5 0 0 0 0 10h6a5 5 0 0 0 0-10H5zm6 9a4 4 0 1 1 0-8 4 4 0 0 1 0 8z"
                }
            }
        ]
    })(props);
}
function BsToggle2Off(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 11c.628-.836 1-1.874 1-3a4.978 4.978 0 0 0-1-3h4a3 3 0 1 1 0 6H9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0 1A5 5 0 1 0 5 3a5 5 0 0 0 0 10z"
                }
            }
        ]
    })(props);
}
function BsToggle2On(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5H3a3 3 0 0 0 0 6h4a4.995 4.995 0 0 1-.584-1H3a2 2 0 1 1 0-4h3.416c.156-.357.352-.692.584-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A5 5 0 1 1 6 8a5 5 0 0 1 10 0z"
                }
            }
        ]
    })(props);
}
function BsToggles(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 9a3.5 3.5 0 1 0 0 7h7a3.5 3.5 0 1 0 0-7h-7zm7 6a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm-7-14a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm2.45 0A3.49 3.49 0 0 1 8 3.5 3.49 3.49 0 0 1 6.95 6h4.55a2.5 2.5 0 0 0 0-5H6.95zM4.5 0h7a3.5 3.5 0 1 1 0 7h-7a3.5 3.5 0 1 1 0-7z"
                }
            }
        ]
    })(props);
}
function BsToggles2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.465 10H12a2 2 0 1 1 0 4H9.465c.34-.588.535-1.271.535-2 0-.729-.195-1.412-.535-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 1a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm.535-10a3.975 3.975 0 0 1-.409-1H4a1 1 0 0 1 0-2h2.126c.091-.355.23-.69.41-1H4a2 2 0 1 0 0 4h2.535z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4a4 4 0 1 1-8 0 4 4 0 0 1 8 0z"
                }
            }
        ]
    })(props);
}
function BsTools(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 0 0 1l2.2 3.081a1 1 0 0 0 .815.419h.07a1 1 0 0 1 .708.293l2.675 2.675-2.617 2.654A3.003 3.003 0 0 0 0 13a3 3 0 1 0 5.878-.851l2.654-2.617.968.968-.305.914a1 1 0 0 0 .242 1.023l3.27 3.27a.997.997 0 0 0 1.414 0l1.586-1.586a.997.997 0 0 0 0-1.414l-3.27-3.27a1 1 0 0 0-1.023-.242L10.5 9.5l-.96-.96 2.68-2.643A3.005 3.005 0 0 0 16 3c0-.269-.035-.53-.102-.777l-2.14 2.141L12 4l-.364-1.757L13.777.102a3 3 0 0 0-3.675 3.68L7.462 6.46 4.793 3.793a1 1 0 0 1-.293-.707v-.071a1 1 0 0 0-.419-.814L1 0Zm9.646 10.646a.5.5 0 0 1 .708 0l2.914 2.915a.5.5 0 0 1-.707.707l-2.915-2.914a.5.5 0 0 1 0-.708ZM3 11l.471.242.529.026.287.445.445.287.026.529L5 13l-.242.471-.026.529-.445.287-.287.445-.529.026L3 15l-.471-.242L2 14.732l-.287-.445L1.268 14l-.026-.529L1 13l.242-.471.026-.529.445-.287.287-.445.529-.026L3 11Z"
                }
            }
        ]
    })(props);
}
function BsTornado(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.125 2.45A.892.892 0 0 1 1 2c0-.26.116-.474.258-.634a1.9 1.9 0 0 1 .513-.389c.387-.21.913-.385 1.52-.525C4.514.17 6.18 0 8 0c1.821 0 3.486.17 4.709.452.607.14 1.133.314 1.52.525.193.106.374.233.513.389.141.16.258.374.258.634 0 1.011-.35 1.612-.634 2.102-.04.07-.08.137-.116.203a2.55 2.55 0 0 0-.313.809 2.938 2.938 0 0 0-.011.891.5.5 0 0 1 .428.849c-.06.06-.133.126-.215.195.204 1.116.088 1.99-.3 2.711-.453.84-1.231 1.383-2.02 1.856-.204.123-.412.243-.62.364-1.444.832-2.928 1.689-3.735 3.706a.5.5 0 0 1-.748.226l-.001-.001-.002-.001-.004-.003-.01-.008a2.142 2.142 0 0 1-.147-.115 4.095 4.095 0 0 1-1.179-1.656 3.786 3.786 0 0 1-.247-1.296A.498.498 0 0 1 5 12.5v-.018a.62.62 0 0 1 .008-.079.728.728 0 0 1 .188-.386c.09-.489.272-1.014.573-1.574a.5.5 0 0 1 .073-.918 3.29 3.29 0 0 1 .617-.144l.15-.193c.285-.356.404-.639.437-.861a.948.948 0 0 0-.122-.619c-.249-.455-.815-.903-1.613-1.43-.193-.127-.398-.258-.609-.394l-.119-.076a12.307 12.307 0 0 1-1.241-.334.5.5 0 0 1-.285-.707l-.23-.18C2.117 4.01 1.463 3.32 1.125 2.45zm1.973 1.051c.113.104.233.207.358.308.472.381.99.722 1.515 1.06 1.54.317 3.632.5 5.43.14a.5.5 0 0 1 .197.981c-1.216.244-2.537.26-3.759.157.399.326.744.682.963 1.081.203.373.302.79.233 1.247-.05.33-.182.657-.39.985.075.017.148.035.22.053l.006.002c.481.12.863.213 1.47.01a.5.5 0 1 1 .317.95c-.888.295-1.505.141-2.023.012l-.006-.002a3.894 3.894 0 0 0-.644-.123c-.37.55-.598 1.05-.726 1.497.142.045.296.11.465.194a.5.5 0 1 1-.448.894 3.11 3.11 0 0 0-.148-.07c.012.345.084.643.18.895.14.369.342.666.528.886.992-1.903 2.583-2.814 3.885-3.56.203-.116.399-.228.584-.34.775-.464 1.34-.89 1.653-1.472.212-.393.33-.9.26-1.617A6.74 6.74 0 0 1 10 8.5a.5.5 0 0 1 0-1 5.76 5.76 0 0 0 3.017-.872.515.515 0 0 1-.007-.03c-.135-.673-.14-1.207-.056-1.665.084-.46.253-.81.421-1.113l.131-.23c.065-.112.126-.22.182-.327-.29.107-.62.202-.98.285C11.487 3.83 9.822 4 8 4c-1.821 0-3.486-.17-4.709-.452-.065-.015-.13-.03-.193-.047zM13.964 2a1.12 1.12 0 0 0-.214-.145c-.272-.148-.697-.297-1.266-.428C11.354 1.166 9.769 1 8 1c-1.769 0-3.354.166-4.484.427-.569.13-.994.28-1.266.428A1.12 1.12 0 0 0 2.036 2c.04.038.109.087.214.145.272.148.697.297 1.266.428C4.646 2.834 6.231 3 8 3c1.769 0 3.354-.166 4.484-.427.569-.13.994-.28 1.266-.428A1.12 1.12 0 0 0 13.964 2z"
                }
            }
        ]
    })(props);
}
function BsTrainFreightFrontFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.736 0a1.5 1.5 0 0 0-.67.158L1.828 1.776A1.5 1.5 0 0 0 1 3.118v5.51l2-.6V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3.028l2 .6v-5.51a1.5 1.5 0 0 0-.83-1.342L10.936.158A1.5 1.5 0 0 0 10.264 0H5.736ZM15 9.672l-5.503-1.65A.5.5 0 0 0 9.353 8H8.5v8h4a2.5 2.5 0 0 0 2.5-2.5V9.672ZM7.5 16V8h-.853a.5.5 0 0 0-.144.021L1 9.672V13.5A2.5 2.5 0 0 0 3.5 16h4Zm-1-14h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1ZM12 5v2.728l-2.216-.665A1.5 1.5 0 0 0 9.354 7H8.5V5H12ZM7.5 5v2h-.853a1.5 1.5 0 0 0-.431.063L4 7.728V5h3.5Zm-4 5a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm9 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1ZM5 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm7 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
                }
            }
        ]
    })(props);
}
function BsTrainFreightFront(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.065.158A1.5 1.5 0 0 1 5.736 0h4.528a1.5 1.5 0 0 1 .67.158l3.237 1.618a1.5 1.5 0 0 1 .83 1.342V13.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 13.5V3.118a1.5 1.5 0 0 1 .828-1.342L5.065.158ZM2 9.372V13.5A1.5 1.5 0 0 0 3.5 15h4V8h-.853a.5.5 0 0 0-.144.021L2 9.372ZM8.5 15h4a1.5 1.5 0 0 0 1.5-1.5V9.372l-4.503-1.35A.5.5 0 0 0 9.353 8H8.5v7ZM14 8.328v-5.21a.5.5 0 0 0-.276-.447l-3.236-1.618A.5.5 0 0 0 10.264 1H5.736a.5.5 0 0 0-.223.053L2.277 2.67A.5.5 0 0 0 2 3.118v5.21l1-.3V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3.028l1 .3Zm-2-.6V5H8.5v2h.853a1.5 1.5 0 0 1 .431.063L12 7.728ZM7.5 7V5H4v2.728l2.216-.665A1.5 1.5 0 0 1 6.646 7H7.5Zm-1-5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm-3 8a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm9 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1ZM5 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm7 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
                }
            }
        ]
    })(props);
}
function BsTrainFrontFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.621.515C8.647.02 7.353.02 5.38.515c-.924.23-1.982.766-2.78 1.22C1.566 2.322 1 3.432 1 4.582V13.5A2.5 2.5 0 0 0 3.5 16h9a2.5 2.5 0 0 0 2.5-2.5V4.583c0-1.15-.565-2.26-1.6-2.849-.797-.453-1.855-.988-2.779-1.22ZM6.5 2h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1Zm-2 2h7A1.5 1.5 0 0 1 13 5.5v2A1.5 1.5 0 0 1 11.5 9h-7A1.5 1.5 0 0 1 3 7.5v-2A1.5 1.5 0 0 1 4.5 4Zm.5 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm8 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-3-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM4 5.5a.5.5 0 0 1 .5-.5h3v3h-3a.5.5 0 0 1-.5-.5v-2ZM8.5 8V5h3a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-3Z"
                }
            }
        ]
    })(props);
}
function BsTrainFront(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.621 1.485c1.815-.454 2.943-.454 4.758 0 .784.196 1.743.673 2.527 1.119.688.39 1.094 1.148 1.094 1.979V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V4.583c0-.831.406-1.588 1.094-1.98.784-.445 1.744-.922 2.527-1.118Zm5-.97C8.647.02 7.353.02 5.38.515c-.924.23-1.982.766-2.78 1.22C1.566 2.322 1 3.432 1 4.582V13.5A2.5 2.5 0 0 0 3.5 16h9a2.5 2.5 0 0 0 2.5-2.5V4.583c0-1.15-.565-2.26-1.6-2.849-.797-.453-1.855-.988-2.779-1.22ZM5 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm7 1a1 1 0 1 0-1-1 1 1 0 1 0-2 0 1 1 0 0 0 2 0 1 1 0 0 0 1 1ZM4.5 5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h3V5h-3Zm4 0v3h3a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-3ZM3 5.5A1.5 1.5 0 0 1 4.5 4h7A1.5 1.5 0 0 1 13 5.5v2A1.5 1.5 0 0 1 11.5 9h-7A1.5 1.5 0 0 1 3 7.5v-2ZM6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Z"
                }
            }
        ]
    })(props);
}
function BsTrainLightrailFrontFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 0a.5.5 0 0 0 0 1h1v1.011c-1.525.064-3.346.394-4.588.655C1.775 2.904 1 3.915 1 5.055V13.5A2.5 2.5 0 0 0 3.5 16h9a2.5 2.5 0 0 0 2.5-2.5V5.055c0-1.14-.775-2.15-1.912-2.39-1.242-.26-3.063-.59-4.588-.654V1h1a.5.5 0 0 0 0-1h-3ZM8 4c1.136 0 2.645.2 3.604.346.825.126 1.356.9 1.244 1.697-.022.16-.046.335-.07.522C12.643 7.596 12.5 8.949 12.5 10c0 .428.024.933.062 1.464.066.93.174 1.92.266 2.682.042.34.08.634.109.854h-1.01a62.703 62.703 0 0 1-.327-3H9.354c-.36 0-.704-.143-.958-.396a.353.353 0 0 0-.25-.104h-.292a.353.353 0 0 0-.25.104 1.354 1.354 0 0 1-.958.396H4.4a62.692 62.692 0 0 1-.328 3H3.064c.029-.22.067-.514.108-.854.092-.761.2-1.752.266-2.682.038-.531.062-1.036.062-1.464 0-1.051-.143-2.404-.278-3.435a51.762 51.762 0 0 0-.07-.522c-.112-.798.42-1.571 1.244-1.697C5.356 4.199 6.864 4 8 4Zm-1.354 7H4.47c.019-.353.03-.692.03-1 0-.927-.104-2.051-.216-3h7.432c-.112.949-.216 2.073-.216 3 0 .308.011.647.03 1H9.354a.353.353 0 0 1-.25-.104 1.354 1.354 0 0 0-.958-.396h-.292c-.36 0-.704.143-.958.396a.353.353 0 0 1-.25.104Zm5.199-5h-7.69l-.013-.096a.497.497 0 0 1 .405-.57C5.505 5.188 6.947 5 8 5s2.495.188 3.453.334a.497.497 0 0 1 .405.57L11.845 6ZM6 13.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0 0a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm4 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0 0a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Z"
                }
            }
        ]
    })(props);
}
function BsTrainLightrailFront(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 0a.5.5 0 0 0 0 1h1v1.011c-1.525.064-3.346.394-4.588.655C1.775 2.904 1 3.915 1 5.055V13.5A2.5 2.5 0 0 0 3.5 16h9a2.5 2.5 0 0 0 2.5-2.5V5.055c0-1.14-.775-2.15-1.912-2.39-1.242-.26-3.063-.59-4.588-.654V1h1a.5.5 0 0 0 0-1h-3ZM8 3c1.497 0 3.505.356 4.883.644.653.137 1.117.722 1.117 1.411V13.5a1.5 1.5 0 0 1-1.072 1.438 75.999 75.999 0 0 1-.1-.792c-.092-.761-.2-1.752-.266-2.682A21.26 21.26 0 0 1 12.5 10c0-1.051.143-2.404.278-3.435.024-.187.048-.362.07-.522.112-.798-.42-1.571-1.244-1.697C10.644 4.199 9.136 4 8 4c-1.136 0-2.645.2-3.604.346-.825.126-1.356.9-1.244 1.697.022.16.046.335.07.522C3.357 7.596 3.5 8.949 3.5 10c0 .428-.024.933-.062 1.464a57.32 57.32 0 0 1-.266 2.682c-.038.31-.072.58-.1.792A1.5 1.5 0 0 1 2 13.5V5.055c0-.69.464-1.274 1.117-1.41C4.495 3.354 6.503 3 8 3Zm3.835 11.266c.034.28.066.53.093.734H4.072a62.692 62.692 0 0 0 .328-3h2.246c.36 0 .704-.143.958-.396a.353.353 0 0 1 .25-.104h.292a.35.35 0 0 1 .25.104c.254.253.599.396.958.396H11.6c.068.808.158 1.621.236 2.266ZM6 13.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0 0a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm3.5.5a.5.5 0 0 0 .5-.5.5.5 0 1 0 1 0 .5.5 0 0 0-1 0 .5.5 0 1 0-.5.5Zm-5.03-3c.019-.353.03-.692.03-1 0-.927-.104-2.051-.216-3h7.432c-.112.949-.216 2.073-.216 3 0 .308.011.647.03 1H9.354a.353.353 0 0 1-.25-.104 1.354 1.354 0 0 0-.958-.396h-.292c-.36 0-.704.143-.958.396a.353.353 0 0 1-.25.104H4.47Zm-.315-5-.013-.096a.497.497 0 0 1 .405-.57C5.505 5.188 6.947 5 8 5s2.495.188 3.453.334a.497.497 0 0 1 .405.57L11.845 6h-7.69Z"
                }
            }
        ]
    })(props);
}
function BsTranslate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.545 6.714 4.11 8H3l1.862-5h1.284L8 8H6.833l-.435-1.286H4.545zm1.634-.736L5.5 3.956h-.049l-.679 2.022H6.18z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v3h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-3H2a2 2 0 0 1-2-2V2zm2-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2zm7.138 9.995c.193.301.402.583.63.846-.748.575-1.673 1.001-2.768 1.292.178.217.451.635.555.867 1.125-.359 2.08-.844 2.886-1.494.777.665 1.739 1.165 2.93 1.472.133-.254.414-.673.629-.89-1.125-.253-2.057-.694-2.82-1.284.681-.747 1.222-1.651 1.621-2.757H14V8h-3v1.047h.765c-.318.844-.74 1.546-1.272 2.13a6.066 6.066 0 0 1-.415-.492 1.988 1.988 0 0 1-.94.31z"
                }
            }
        ]
    })(props);
}
function BsTransparency(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 6.5a6.5 6.5 0 0 1 12.346-2.846 6.5 6.5 0 1 1-8.691 8.691A6.5 6.5 0 0 1 0 6.5Zm5.144 6.358a5.5 5.5 0 1 0 7.714-7.714 6.5 6.5 0 0 1-7.714 7.714Zm-.733-1.269c.363.15.746.261 1.144.33l-1.474-1.474c.069.398.18.78.33 1.144Zm2.614.386a5.47 5.47 0 0 0 1.173-.242L4.374 7.91a5.958 5.958 0 0 0-.296 1.118l2.947 2.947Zm2.157-.672c.297-.166.577-.36.838-.576L5.418 6.126a6.016 6.016 0 0 0-.587.826l4.35 4.351Zm1.545-1.284c.216-.26.41-.54.576-.837L6.953 4.83a5.97 5.97 0 0 0-.827.587l4.6 4.602Zm1.006-1.822c.121-.374.204-.766.242-1.172L9.028 4.078c-.386.063-.76.163-1.118.296l3.823 3.824Zm.186-2.642a5.463 5.463 0 0 0-.33-1.144 5.46 5.46 0 0 0-1.144-.33l1.474 1.474Z"
                }
            }
        ]
    })(props);
}
function BsTrashFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"
                }
            }
        ]
    })(props);
}
function BsTrash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z"
                }
            }
        ]
    })(props);
}
function BsTrash2Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.037 3.225A.703.703 0 0 1 2 3c0-1.105 2.686-2 6-2s6 .895 6 2a.702.702 0 0 1-.037.225l-1.684 10.104A2 2 0 0 1 10.305 15H5.694a2 2 0 0 1-1.973-1.671L2.037 3.225zm9.89-.69C10.966 2.214 9.578 2 8 2c-1.58 0-2.968.215-3.926.534-.477.16-.795.327-.975.466.18.14.498.307.975.466C5.032 3.786 6.42 4 8 4s2.967-.215 3.926-.534c.477-.16.795-.327.975-.466-.18-.14-.498-.307-.975-.466z"
                }
            }
        ]
    })(props);
}
function BsTrash2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3a.702.702 0 0 1-.037.225l-1.684 10.104A2 2 0 0 1 10.305 15H5.694a2 2 0 0 1-1.973-1.671L2.037 3.225A.703.703 0 0 1 2 3c0-1.105 2.686-2 6-2s6 .895 6 2zM3.215 4.207l1.493 8.957a1 1 0 0 0 .986.836h4.612a1 1 0 0 0 .986-.836l1.493-8.957C11.69 4.689 9.954 5 8 5c-1.954 0-3.69-.311-4.785-.793z"
                }
            }
        ]
    })(props);
}
function BsTrash3Fill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z"
                }
            }
        ]
    })(props);
}
function BsTrash3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"
                }
            }
        ]
    })(props);
}
function BsTreeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.416.223a.5.5 0 0 0-.832 0l-3 4.5A.5.5 0 0 0 5 5.5h.098L3.076 8.735A.5.5 0 0 0 3.5 9.5h.191l-1.638 3.276a.5.5 0 0 0 .447.724H7V16h2v-2.5h4.5a.5.5 0 0 0 .447-.724L12.31 9.5h.191a.5.5 0 0 0 .424-.765L10.902 5.5H11a.5.5 0 0 0 .416-.777l-3-4.5z"
                }
            }
        ]
    })(props);
}
function BsTree(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.416.223a.5.5 0 0 0-.832 0l-3 4.5A.5.5 0 0 0 5 5.5h.098L3.076 8.735A.5.5 0 0 0 3.5 9.5h.191l-1.638 3.276a.5.5 0 0 0 .447.724H7V16h2v-2.5h4.5a.5.5 0 0 0 .447-.724L12.31 9.5h.191a.5.5 0 0 0 .424-.765L10.902 5.5H11a.5.5 0 0 0 .416-.777l-3-4.5zM6.437 4.758A.5.5 0 0 0 6 4.5h-.066L8 1.401 10.066 4.5H10a.5.5 0 0 0-.424.765L11.598 8.5H11.5a.5.5 0 0 0-.447.724L12.69 12.5H3.309l1.638-3.276A.5.5 0 0 0 4.5 8.5h-.098l2.022-3.235a.5.5 0 0 0 .013-.507z"
                }
            }
        ]
    })(props);
}
function BsTrello(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.1 0H1.903C.852 0 .002.85 0 1.9v12.19A1.902 1.902 0 0 0 1.902 16h12.199A1.902 1.902 0 0 0 16 14.09V1.9A1.902 1.902 0 0 0 14.1 0ZM7 11.367a.636.636 0 0 1-.64.633H3.593a.633.633 0 0 1-.63-.633V3.583c0-.348.281-.631.63-.633h2.765c.35.002.632.284.633.633L7 11.367Zm6.052-3.5a.633.633 0 0 1-.64.633h-2.78A.636.636 0 0 1 9 7.867V3.583a.636.636 0 0 1 .633-.633h2.778c.35.002.631.285.631.633l.01 4.284Z"
                }
            }
        ]
    })(props);
}
function BsTriangleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.022 1.566a1.13 1.13 0 0 1 1.96 0l6.857 11.667c.457.778-.092 1.767-.98 1.767H1.144c-.889 0-1.437-.99-.98-1.767L7.022 1.566z"
                }
            }
        ]
    })(props);
}
function BsTriangleHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.065 2.016A.13.13 0 0 0 8.002 2v11.983l6.856.017a.12.12 0 0 0 .066-.017.162.162 0 0 0 .054-.06.176.176 0 0 0-.002-.183L8.12 2.073a.146.146 0 0 0-.054-.057zm-1.043-.45a1.13 1.13 0 0 1 1.96 0l6.856 11.667c.458.778-.091 1.767-.98 1.767H1.146c-.889 0-1.437-.99-.98-1.767L7.022 1.566z"
                }
            }
        ]
    })(props);
}
function BsTriangle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"
                }
            }
        ]
    })(props);
}
function BsTrophyFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5.5A.5.5 0 0 1 3 0h10a.5.5 0 0 1 .5.5c0 .538-.012 1.05-.034 1.536a3 3 0 1 1-1.133 5.89c-.79 1.865-1.878 2.777-2.833 3.011v2.173l1.425.356c.194.048.377.135.537.255L13.3 15.1a.5.5 0 0 1-.3.9H3a.5.5 0 0 1-.3-.9l1.838-1.379c.16-.12.343-.207.537-.255L6.5 13.11v-2.173c-.955-.234-2.043-1.146-2.833-3.012a3 3 0 1 1-1.132-5.89A33.076 33.076 0 0 1 2.5.5zm.099 2.54a2 2 0 0 0 .72 3.935c-.333-1.05-.588-2.346-.72-3.935zm10.083 3.935a2 2 0 0 0 .72-3.935c-.133 1.59-.388 2.885-.72 3.935z"
                }
            }
        ]
    })(props);
}
function BsTrophy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5.5A.5.5 0 0 1 3 0h10a.5.5 0 0 1 .5.5c0 .538-.012 1.05-.034 1.536a3 3 0 1 1-1.133 5.89c-.79 1.865-1.878 2.777-2.833 3.011v2.173l1.425.356c.194.048.377.135.537.255L13.3 15.1a.5.5 0 0 1-.3.9H3a.5.5 0 0 1-.3-.9l1.838-1.379c.16-.12.343-.207.537-.255L6.5 13.11v-2.173c-.955-.234-2.043-1.146-2.833-3.012a3 3 0 1 1-1.132-5.89A33.076 33.076 0 0 1 2.5.5zm.099 2.54a2 2 0 0 0 .72 3.935c-.333-1.05-.588-2.346-.72-3.935zm10.083 3.935a2 2 0 0 0 .72-3.935c-.133 1.59-.388 2.885-.72 3.935zM3.504 1c.007.517.026 1.006.056 1.469.13 2.028.457 3.546.87 4.667C5.294 9.48 6.484 10 7 10a.5.5 0 0 1 .5.5v2.61a1 1 0 0 1-.757.97l-1.426.356a.5.5 0 0 0-.179.085L4.5 15h7l-.638-.479a.501.501 0 0 0-.18-.085l-1.425-.356a1 1 0 0 1-.757-.97V10.5A.5.5 0 0 1 9 10c.516 0 1.706-.52 2.57-2.864.413-1.12.74-2.64.87-4.667.03-.463.049-.952.056-1.469H3.504z"
                }
            }
        ]
    })(props);
}
function BsTropicalStorm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 2c-.9 0-1.75.216-2.501.6A5 5 0 0 1 13 7.5a6.5 6.5 0 1 1-13 0 .5.5 0 0 1 1 0 5.5 5.5 0 0 0 8.001 4.9A5 5 0 0 1 3 7.5a6.5 6.5 0 0 1 13 0 .5.5 0 0 1-1 0A5.5 5.5 0 0 0 9.5 2zM8 3.5a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"
                }
            }
        ]
    })(props);
}
function BsTruckFlatbed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 4a.5.5 0 0 1 .5.5V5h1.02a1.5 1.5 0 0 1 1.17.563l1.481 1.85a1.5 1.5 0 0 1 .329.938V10.5a1.5 1.5 0 0 1-1.5 1.5H14a2 2 0 1 1-4 0H5a2 2 0 1 1-4 0 1 1 0 0 1-1-1v-1h11V4.5a.5.5 0 0 1 .5-.5zM3 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm1.732 0h.768a.5.5 0 0 0 .5-.5V8.35a.5.5 0 0 0-.11-.312l-1.48-1.85A.5.5 0 0 0 13.02 6H12v4a2 2 0 0 1 1.732 1z"
                }
            }
        ]
    })(props);
}
function BsTruckFrontFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 0A2.5 2.5 0 0 0 1 2.5v9c0 .818.393 1.544 1 2v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V14h6v1.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2c.607-.456 1-1.182 1-2v-9A2.5 2.5 0 0 0 12.5 0h-9ZM3 3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3.9c0 .625-.562 1.092-1.17.994C10.925 7.747 9.208 7.5 8 7.5c-1.208 0-2.925.247-3.83.394A1.008 1.008 0 0 1 3 6.9V3Zm1 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm8 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm-5-2h2a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2Z"
                }
            }
        ]
    })(props);
}
function BsTruckFront(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm8 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-6-1a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H7ZM4 2a1 1 0 0 0-1 1v3.9c0 .625.562 1.092 1.17.994C5.075 7.747 6.792 7.5 8 7.5c1.208 0 2.925.247 3.83.394A1.008 1.008 0 0 0 13 6.9V3a1 1 0 0 0-1-1H4Zm0 1h8v3.9c0 .002 0 .001 0 0l-.002.004a.013.013 0 0 1-.005.002h-.004C11.088 6.761 9.299 6.5 8 6.5s-3.088.26-3.99.406h-.003a.013.013 0 0 1-.005-.002L4 6.9c0 .001 0 .002 0 0V3Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 2.5A2.5 2.5 0 0 1 3.5 0h9A2.5 2.5 0 0 1 15 2.5v9c0 .818-.393 1.544-1 2v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V14H5v1.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a2.496 2.496 0 0 1-1-2v-9ZM3.5 1A1.5 1.5 0 0 0 2 2.5v9A1.5 1.5 0 0 0 3.5 13h9a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 12.5 1h-9Z"
                }
            }
        ]
    })(props);
}
function BsTruck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3.5A1.5 1.5 0 0 1 1.5 2h9A1.5 1.5 0 0 1 12 3.5V5h1.02a1.5 1.5 0 0 1 1.17.563l1.481 1.85a1.5 1.5 0 0 1 .329.938V10.5a1.5 1.5 0 0 1-1.5 1.5H14a2 2 0 1 1-4 0H5a2 2 0 1 1-3.998-.085A1.5 1.5 0 0 1 0 10.5v-7zm1.294 7.456A1.999 1.999 0 0 1 4.732 11h5.536a2.01 2.01 0 0 1 .732-.732V3.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .294.456zM12 10a2 2 0 0 1 1.732 1h.768a.5.5 0 0 0 .5-.5V8.35a.5.5 0 0 0-.11-.312l-1.48-1.85A.5.5 0 0 0 13.02 6H12v4zm-9 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
                }
            }
        ]
    })(props);
}
function BsTsunami(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.036 12.314a.5.5 0 0 1 .65-.278l1.757.703a1.5 1.5 0 0 0 1.114 0l1.014-.406a2.5 2.5 0 0 1 1.857 0l1.015.406a1.5 1.5 0 0 0 1.114 0l1.014-.406a2.5 2.5 0 0 1 1.857 0l1.015.406a1.5 1.5 0 0 0 1.114 0l1.757-.703a.5.5 0 1 1 .372.928l-1.758.703a2.5 2.5 0 0 1-1.857 0l-1.014-.406a1.5 1.5 0 0 0-1.114 0l-1.015.406a2.5 2.5 0 0 1-1.857 0l-1.014-.406a1.5 1.5 0 0 0-1.114 0l-1.015.406a2.5 2.5 0 0 1-1.857 0l-1.757-.703a.5.5 0 0 1-.278-.65zm0 2a.5.5 0 0 1 .65-.278l1.757.703a1.5 1.5 0 0 0 1.114 0l1.014-.406a2.5 2.5 0 0 1 1.857 0l1.015.406a1.5 1.5 0 0 0 1.114 0l1.014-.406a2.5 2.5 0 0 1 1.857 0l1.015.406a1.5 1.5 0 0 0 1.114 0l1.757-.703a.5.5 0 1 1 .372.928l-1.758.703a2.5 2.5 0 0 1-1.857 0l-1.014-.406a1.5 1.5 0 0 0-1.114 0l-1.015.406a2.5 2.5 0 0 1-1.857 0l-1.014-.406a1.5 1.5 0 0 0-1.114 0l-1.015.406a2.5 2.5 0 0 1-1.857 0l-1.757-.703a.5.5 0 0 1-.278-.65zM2.662 8.08c-.456 1.063-.994 2.098-1.842 2.804a.5.5 0 0 1-.64-.768c.652-.544 1.114-1.384 1.564-2.43.14-.328.281-.68.427-1.044.302-.754.624-1.559 1.01-2.308C3.763 3.2 4.528 2.105 5.7 1.299 6.877.49 8.418 0 10.5 0c1.463 0 2.511.4 3.179 1.058.67.66.893 1.518.819 2.302-.074.771-.441 1.516-1.02 1.965a1.878 1.878 0 0 1-1.904.27c-.65.642-.907 1.679-.71 2.614C11.076 9.215 11.784 10 13 10h2.5a.5.5 0 0 1 0 1H13c-1.784 0-2.826-1.215-3.114-2.585-.232-1.1.005-2.373.758-3.284L10.5 5.06l-.777.388a.5.5 0 0 1-.447 0l-1-.5a.5.5 0 0 1 .447-.894l.777.388.776-.388a.5.5 0 0 1 .447 0l1 .5a.493.493 0 0 1 .034.018c.44.264.81.195 1.108-.036.328-.255.586-.729.637-1.27.05-.529-.1-1.076-.525-1.495-.426-.42-1.19-.77-2.477-.77-1.918 0-3.252.448-4.232 1.123C5.283 2.8 4.61 3.738 4.07 4.79c-.365.71-.655 1.433-.945 2.16-.15.376-.301.753-.463 1.13z"
                }
            }
        ]
    })(props);
}
function BsTvFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 13.5A.5.5 0 0 1 3 13h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zM2 2h12s2 0 2 2v6s0 2-2 2H2s-2 0-2-2V4s0-2 2-2z"
                }
            }
        ]
    })(props);
}
function BsTv(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 13.5A.5.5 0 0 1 3 13h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zM13.991 3l.024.001a1.46 1.46 0 0 1 .538.143.757.757 0 0 1 .302.254c.067.1.145.277.145.602v5.991l-.001.024a1.464 1.464 0 0 1-.143.538.758.758 0 0 1-.254.302c-.1.067-.277.145-.602.145H2.009l-.024-.001a1.464 1.464 0 0 1-.538-.143.758.758 0 0 1-.302-.254C1.078 10.502 1 10.325 1 10V4.009l.001-.024a1.46 1.46 0 0 1 .143-.538.758.758 0 0 1 .254-.302C1.498 3.078 1.675 3 2 3h11.991zM14 2H2C0 2 0 4 0 4v6c0 2 2 2 2 2h12c2 0 2-2 2-2V4c0-2-2-2-2-2z"
                }
            }
        ]
    })(props);
}
function BsTwitch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.857 0 1 2.857v10.286h3.429V16l2.857-2.857H9.57L14.714 8V0H3.857zm9.714 7.429-2.285 2.285H9l-2 2v-2H4.429V1.143h9.142v6.286z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.857 3.143h-1.143V6.57h1.143V3.143zm-3.143 0H7.571V6.57h1.143V3.143z"
                }
            }
        ]
    })(props);
}
function BsTwitterX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865l8.875 11.633Z"
                }
            }
        ]
    })(props);
}
function BsTwitter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z"
                }
            }
        ]
    })(props);
}
function BsTypeBold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.21 13c2.106 0 3.412-1.087 3.412-2.823 0-1.306-.984-2.283-2.324-2.386v-.055a2.176 2.176 0 0 0 1.852-2.14c0-1.51-1.162-2.46-3.014-2.46H3.843V13H8.21zM5.908 4.674h1.696c.963 0 1.517.451 1.517 1.244 0 .834-.629 1.32-1.73 1.32H5.908V4.673zm0 6.788V8.598h1.73c1.217 0 1.88.492 1.88 1.415 0 .943-.643 1.449-1.832 1.449H5.907z"
                }
            }
        ]
    })(props);
}
function BsTypeH1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.648 13V3H6.3v4.234H1.348V3H0v10h1.348V8.421H6.3V13h1.348ZM14 13V3h-1.333l-2.381 1.766V6.12L12.6 4.443h.066V13H14Z"
                }
            }
        ]
    })(props);
}
function BsTypeH2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.495 13V3.201H6.174v4.15H1.32V3.2H0V13h1.32V8.513h4.854V13h1.32Zm3.174-7.071v-.05c0-.934.66-1.752 1.801-1.752 1.005 0 1.76.639 1.76 1.651 0 .898-.582 1.58-1.12 2.19l-3.69 4.2V13h6.331v-1.149h-4.458v-.079L13.9 8.786c.919-1.048 1.666-1.874 1.666-3.101C15.565 4.149 14.35 3 12.499 3 10.46 3 9.384 4.393 9.384 5.879v.05h1.285Z"
                }
            }
        ]
    })(props);
}
function BsTypeH3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.07 8.4h1.049c1.174 0 1.99.69 2.004 1.724.014 1.034-.802 1.786-2.068 1.779-1.11-.007-1.905-.605-1.99-1.357h-1.21C8.926 11.91 10.116 13 12.028 13c1.99 0 3.439-1.188 3.404-2.87-.028-1.553-1.287-2.221-2.096-2.313v-.07c.724-.127 1.814-.935 1.772-2.293-.035-1.392-1.21-2.468-3.038-2.454-1.927.007-2.94 1.196-2.981 2.426h1.23c.064-.71.732-1.336 1.744-1.336 1.027 0 1.744.64 1.744 1.568.007.95-.738 1.639-1.744 1.639h-.991V8.4ZM7.495 13V3.201H6.174v4.15H1.32V3.2H0V13h1.32V8.513h4.854V13h1.32Z"
                }
            }
        ]
    })(props);
}
function BsTypeH4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.007 3H15v10h-1.29v-2.051H8.854v-1.18C10.1 7.513 11.586 5.256 13.007 3Zm-2.82 6.777h3.524v-5.62h-.074a95.078 95.078 0 0 0-3.45 5.554v.066ZM7.495 13V3.201H6.174v4.15H1.32V3.2H0V13h1.32V8.513h4.854V13h1.32Z"
                }
            }
        ]
    })(props);
}
function BsTypeH5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 10.516h1.264c.193.976 1.112 1.364 2.01 1.364 1.005 0 2.067-.782 2.067-2.247 0-1.292-.983-2.082-2.089-2.082-1.012 0-1.658.596-1.924 1.077h-1.12L9.646 3h5.535v1.141h-4.415L10.5 7.28h.072c.201-.316.883-.84 1.967-.84 1.709 0 3.13 1.177 3.13 3.158 0 2.025-1.407 3.403-3.475 3.403-1.809 0-3.1-1.048-3.194-2.484ZM7.495 13V3.201H6.174v4.15H1.32V3.2H0V13h1.32V8.512h4.854V13h1.32Z"
                }
            }
        ]
    })(props);
}
function BsTypeH6(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.596 5.178H14.3c-.106-.444-.62-1.072-1.706-1.072-1.332 0-2.325 1.269-2.325 3.947h.07c.268-.67 1.043-1.445 2.445-1.445 1.494 0 3.017 1.064 3.017 3.073C15.8 11.795 14.37 13 12.48 13c-1.036 0-2.093-.36-2.77-1.452C9.276 10.836 9 9.808 9 8.37 9 4.656 10.494 3 12.636 3c1.812 0 2.883 1.113 2.96 2.178Zm-5.151 4.566c0 1.367.944 2.15 2.043 2.15 1.128 0 2.037-.684 2.037-2.136 0-1.41-1-2.065-2.03-2.065-1.19 0-2.05.853-2.05 2.051ZM7.495 13V3.201H6.174v4.15H1.32V3.2H0V13h1.32V8.513h4.854V13h1.32Z"
                }
            }
        ]
    })(props);
}
function BsTypeItalic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.991 11.674 9.53 4.455c.123-.595.246-.71 1.347-.807l.11-.52H7.211l-.11.52c1.06.096 1.128.212 1.005.807L6.57 11.674c-.123.595-.246.71-1.346.806l-.11.52h3.774l.11-.52c-1.06-.095-1.129-.211-1.006-.806z"
                }
            }
        ]
    })(props);
}
function BsTypeStrikethrough(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.333 5.686c0 .31.083.581.27.814H5.166a2.776 2.776 0 0 1-.099-.76c0-1.627 1.436-2.768 3.48-2.768 1.969 0 3.39 1.175 3.445 2.85h-1.23c-.11-1.08-.964-1.743-2.25-1.743-1.23 0-2.18.602-2.18 1.607zm2.194 7.478c-2.153 0-3.589-1.107-3.705-2.81h1.23c.144 1.06 1.129 1.703 2.544 1.703 1.34 0 2.31-.705 2.31-1.675 0-.827-.547-1.374-1.914-1.675L8.046 8.5H1v-1h14v1h-3.504c.468.437.675.994.675 1.697 0 1.826-1.436 2.967-3.644 2.967z"
                }
            }
        ]
    })(props);
}
function BsTypeUnderline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.313 3.136h-1.23V9.54c0 2.105 1.47 3.623 3.917 3.623s3.917-1.518 3.917-3.623V3.136h-1.23v6.323c0 1.49-.978 2.57-2.687 2.57-1.709 0-2.687-1.08-2.687-2.57V3.136zM12.5 15h-9v-1h9v1z"
                }
            }
        ]
    })(props);
}
function BsType(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.244 13.081.943-2.803H6.66l.944 2.803H8.86L5.54 3.75H4.322L1 13.081h1.244zm2.7-7.923L6.34 9.314H3.51l1.4-4.156h.034zm9.146 7.027h.035v.896h1.128V8.125c0-1.51-1.114-2.345-2.646-2.345-1.736 0-2.59.916-2.666 2.174h1.108c.068-.718.595-1.19 1.517-1.19.971 0 1.518.52 1.518 1.464v.731H12.19c-1.647.007-2.522.8-2.522 2.058 0 1.319.957 2.18 2.345 2.18 1.06 0 1.716-.43 2.078-1.011zm-1.763.035c-.752 0-1.456-.397-1.456-1.244 0-.65.424-1.115 1.408-1.115h1.805v.834c0 .896-.752 1.525-1.757 1.525z"
                }
            }
        ]
    })(props);
}
function BsUbuntu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.273 9.53a2.273 2.273 0 1 0 0-4.546 2.273 2.273 0 0 0 0 4.547Zm9.467-4.984a2.273 2.273 0 1 0 0-4.546 2.273 2.273 0 0 0 0 4.546ZM7.4 13.108a5.535 5.535 0 0 1-3.775-2.88 3.273 3.273 0 0 1-1.944.24 7.4 7.4 0 0 0 5.328 4.465c.53.113 1.072.169 1.614.166a3.253 3.253 0 0 1-.666-1.9 5.639 5.639 0 0 1-.557-.091Zm3.828 2.285a2.273 2.273 0 1 0 0-4.546 2.273 2.273 0 0 0 0 4.546Zm3.163-3.108a7.436 7.436 0 0 0 .373-8.726 3.276 3.276 0 0 1-1.278 1.498 5.573 5.573 0 0 1-.183 5.535 3.26 3.26 0 0 1 1.088 1.693ZM2.098 3.998a3.28 3.28 0 0 1 1.897.486 5.544 5.544 0 0 1 4.464-2.388c.037-.67.277-1.313.69-1.843a7.472 7.472 0 0 0-7.051 3.745Z"
                }
            }
        ]
    })(props);
}
function BsUiChecksGrid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 10h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm9-9h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zm0 9a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-3zm0-10a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2h-3zM2 9a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H2zm7 2a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-3zM0 2a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm5.354.854a.5.5 0 1 0-.708-.708L3 3.793l-.646-.647a.5.5 0 1 0-.708.708l1 1a.5.5 0 0 0 .708 0l2-2z"
                }
            }
        ]
    })(props);
}
function BsUiChecks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1zM2 1a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2zm0 8a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2H2zm.854-3.646a.5.5 0 0 1-.708 0l-1-1a.5.5 0 1 1 .708-.708l.646.647 1.646-1.647a.5.5 0 1 1 .708.708l-2 2zm0 8a.5.5 0 0 1-.708 0l-1-1a.5.5 0 0 1 .708-.708l.646.647 1.646-1.647a.5.5 0 0 1 .708.708l-2 2zM7 10.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1zm0-5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 8a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsUiRadiosGrid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 15a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm9-9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm0 9a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zM16 3.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zm-9 9a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zm5.5 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zm-9-11a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 2a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"
                }
            }
        ]
    })(props);
}
function BsUiRadios(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1zM0 12a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm7-1.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1zm0-5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 8a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zM3 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0 4.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                }
            }
        ]
    })(props);
}
function BsUmbrellaFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8 0a.5.5 0 0 1 .5.5v.514C12.625 1.238 16 4.22 16 8c0 0 0 .5-.5.5-.149 0-.352-.145-.352-.145l-.004-.004-.025-.023a3.484 3.484 0 0 0-.555-.394A3.166 3.166 0 0 0 13 7.5c-.638 0-1.178.213-1.564.434a3.484 3.484 0 0 0-.555.394l-.025.023-.003.003s-.204.146-.353.146-.352-.145-.352-.145l-.004-.004-.025-.023a3.484 3.484 0 0 0-.555-.394 3.3 3.3 0 0 0-1.064-.39V13.5H8h.5v.039l-.005.083a2.958 2.958 0 0 1-.298 1.102 2.257 2.257 0 0 1-.763.88C7.06 15.851 6.587 16 6 16s-1.061-.148-1.434-.396a2.255 2.255 0 0 1-.763-.88 2.958 2.958 0 0 1-.302-1.185v-.025l-.001-.009v-.003s0-.002.5-.002h-.5V13a.5.5 0 0 1 1 0v.506l.003.044a1.958 1.958 0 0 0 .195.726c.095.191.23.367.423.495.19.127.466.229.879.229s.689-.102.879-.229c.193-.128.328-.304.424-.495a1.958 1.958 0 0 0 .197-.77V7.544a3.3 3.3 0 0 0-1.064.39 3.482 3.482 0 0 0-.58.417l-.004.004S5.65 8.5 5.5 8.5c-.149 0-.352-.145-.352-.145l-.004-.004a3.482 3.482 0 0 0-.58-.417A3.166 3.166 0 0 0 3 7.5c-.638 0-1.177.213-1.564.434a3.482 3.482 0 0 0-.58.417l-.004.004S.65 8.5.5 8.5C0 8.5 0 8 0 8c0-3.78 3.375-6.762 7.5-6.986V.5A.5.5 0 0 1 8 0z"
                }
            }
        ]
    })(props);
}
function BsUmbrella(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a.5.5 0 0 1 .5.5v.514C12.625 1.238 16 4.22 16 8c0 0 0 .5-.5.5-.149 0-.352-.145-.352-.145l-.004-.004-.025-.023a3.484 3.484 0 0 0-.555-.394A3.166 3.166 0 0 0 13 7.5c-.638 0-1.178.213-1.564.434a3.484 3.484 0 0 0-.555.394l-.025.023-.003.003s-.204.146-.353.146-.352-.145-.352-.145l-.004-.004-.025-.023a3.484 3.484 0 0 0-.555-.394 3.3 3.3 0 0 0-1.064-.39V13.5H8h.5v.039l-.005.083a2.958 2.958 0 0 1-.298 1.102 2.257 2.257 0 0 1-.763.88C7.06 15.851 6.587 16 6 16s-1.061-.148-1.434-.396a2.255 2.255 0 0 1-.763-.88 2.958 2.958 0 0 1-.302-1.185v-.025l-.001-.009v-.003s0-.002.5-.002h-.5V13a.5.5 0 0 1 1 0v.506l.003.044a1.958 1.958 0 0 0 .195.726c.095.191.23.367.423.495.19.127.466.229.879.229s.689-.102.879-.229c.193-.128.328-.304.424-.495a1.958 1.958 0 0 0 .197-.77V7.544a3.3 3.3 0 0 0-1.064.39 3.482 3.482 0 0 0-.58.417l-.004.004S5.65 8.5 5.5 8.5c-.149 0-.352-.145-.352-.145l-.004-.004a3.482 3.482 0 0 0-.58-.417A3.166 3.166 0 0 0 3 7.5c-.638 0-1.177.213-1.564.434a3.482 3.482 0 0 0-.58.417l-.004.004S.65 8.5.5 8.5C0 8.5 0 8 0 8c0-3.78 3.375-6.762 7.5-6.986V.5A.5.5 0 0 1 8 0zM6.577 2.123c-2.833.5-4.99 2.458-5.474 4.854A4.124 4.124 0 0 1 3 6.5c.806 0 1.48.25 1.962.511a9.706 9.706 0 0 1 .344-2.358c.242-.868.64-1.765 1.271-2.53zm-.615 4.93A4.16 4.16 0 0 1 8 6.5a4.16 4.16 0 0 1 2.038.553 8.688 8.688 0 0 0-.307-2.13C9.434 3.858 8.898 2.83 8 2.117c-.898.712-1.434 1.74-1.731 2.804a8.687 8.687 0 0 0-.307 2.131zm3.46-4.93c.631.765 1.03 1.662 1.272 2.53.233.833.328 1.66.344 2.358A4.14 4.14 0 0 1 13 6.5c.77 0 1.42.23 1.897.477-.484-2.396-2.641-4.355-5.474-4.854z"
                }
            }
        ]
    })(props);
}
function BsUnindent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M13 8a.5.5 0 0 0-.5-.5H5.707l2.147-2.146a.5.5 0 1 0-.708-.708l-3 3a.5.5 0 0 0 0 .708l3 3a.5.5 0 0 0 .708-.708L5.707 8.5H12.5A.5.5 0 0 0 13 8Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3.5 4a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 1 0v-7a.5.5 0 0 0-.5-.5Z"
                }
            }
        ]
    })(props);
}
function BsUnion(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H2a2 2 0 0 1-2-2V2z"
                }
            }
        ]
    })(props);
}
function BsUnity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11.2V3.733L8.61 0v2.867l2.503 1.466c.099.067.099.2 0 .234L8.148 6.3c-.099.067-.197.033-.263 0L4.92 4.567c-.099-.034-.099-.2 0-.234l2.504-1.466V0L1 3.733V11.2v-.033.033l2.438-1.433V6.833c0-.1.131-.166.197-.133L6.6 8.433c.099.067.132.134.132.234v3.466c0 .1-.132.167-.198.134L4.031 10.8l-2.438 1.433L7.983 16l6.391-3.733-2.438-1.434L9.434 12.3c-.099.067-.198 0-.198-.133V8.7c0-.1.066-.2.132-.233l2.965-1.734c.099-.066.197 0 .197.134V9.8L15 11.2Z"
                }
            }
        ]
    })(props);
}
function BsUniversalAccessCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4.143A1.071 1.071 0 1 0 8 2a1.071 1.071 0 0 0 0 2.143Zm-4.668 1.47 3.24.316v2.5l-.323 4.585A.383.383 0 0 0 7 13.14l.826-4.017c.045-.18.301-.18.346 0L9 13.139a.383.383 0 0 0 .752-.125L9.43 8.43v-2.5l3.239-.316a.38.38 0 0 0-.047-.756H3.379a.38.38 0 0 0-.047.756Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8Z"
                }
            }
        ]
    })(props);
}
function BsUniversalAccess(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM6 5.5l-4.535-.442A.531.531 0 0 1 1.531 4H14.47a.531.531 0 0 1 .066 1.058L10 5.5V9l.452 6.42a.535.535 0 0 1-1.053.174L8.243 9.97c-.064-.252-.422-.252-.486 0l-1.156 5.624a.535.535 0 0 1-1.053-.174L6 9V5.5Z"
                }
            }
        ]
    })(props);
}
function BsUnlockFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 1a2 2 0 0 0-2 2v4a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h5V3a3 3 0 0 1 6 0v4a.5.5 0 0 1-1 0V3a2 2 0 0 0-2-2z"
                }
            }
        ]
    })(props);
}
function BsUnlock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 1a2 2 0 0 0-2 2v4a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h5V3a3 3 0 0 1 6 0v4a.5.5 0 0 1-1 0V3a2 2 0 0 0-2-2zM3 8a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H3z"
                }
            }
        ]
    })(props);
}
function BsUpcScan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5zM3 4.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-7zm3 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7z"
                }
            }
        ]
    })(props);
}
function BsUpc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-7zm3 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7z"
                }
            }
        ]
    })(props);
}
function BsUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z"
                }
            }
        ]
    })(props);
}
function BsUsbCFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5a3 3 0 0 0 0 6h10a3 3 0 1 0 0-6H3Zm.5 2.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1Z"
                }
            }
        ]
    })(props);
}
function BsUsbC(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 7.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 8a3 3 0 0 1 3-3h10a3 3 0 1 1 0 6H3a3 3 0 0 1-3-3Zm3-2a2 2 0 1 0 0 4h10a2 2 0 1 0 0-4H3Z"
                }
            }
        ]
    })(props);
}
function BsUsbDriveFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4H6v-4ZM7 1v1h1V1H7Zm2 0v1h1V1H9ZM5.5 5a.5.5 0 0 0-.5.5V15a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V5.5a.5.5 0 0 0-.5-.5h-6Z"
                }
            }
        ]
    })(props);
}
function BsUsbDrive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4H6v-4ZM7 1v1h1V1H7Zm2 0v1h1V1H9ZM6 5a1 1 0 0 0-1 1v8.5A1.5 1.5 0 0 0 6.5 16h4a1.5 1.5 0 0 0 1.5-1.5V6a1 1 0 0 0-1-1H6Zm0 1h5v8.5a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5V6Z"
                }
            }
        ]
    })(props);
}
function BsUsbFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.5 5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5H.5Zm1.75 1.5h11.5a.25.25 0 0 1 .25.25v1a.25.25 0 0 1-.25.25H2.25A.25.25 0 0 1 2 7.75v-1a.25.25 0 0 1 .25-.25Z"
                }
            }
        ]
    })(props);
}
function BsUsbMicroFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.707 4A1 1 0 0 0 2 4.293L.293 6A1 1 0 0 0 0 6.707V11a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V6.707A1 1 0 0 0 15.707 6L14 4.293A1 1 0 0 0 13.293 4H2.707ZM4.5 7h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5Z"
                }
            }
        ]
    })(props);
}
function BsUsbMicro(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-7Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.707 4A1 1 0 0 0 2 4.293L.293 6A1 1 0 0 0 0 6.707V11a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V6.707A1 1 0 0 0 15.707 6L14 4.293A1 1 0 0 0 13.293 4H2.707Zm0 1h10.586L15 6.707V11H1V6.707L2.707 5Z"
                }
            }
        ]
    })(props);
}
function BsUsbMiniFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3a1 1 0 0 0-1 1v1.293L.293 7A1 1 0 0 0 0 7.707V12a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V7.707A1 1 0 0 0 15.707 7L14 5.293V4a1 1 0 0 0-1-1H3Zm.5 5h9a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5Z"
                }
            }
        ]
    })(props);
}
function BsUsbMini(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-9Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3a1 1 0 0 0-1 1v1.293L.293 7A1 1 0 0 0 0 7.707V12a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V7.707A1 1 0 0 0 15.707 7L14 5.293V4a1 1 0 0 0-1-1H3Zm0 1h10v1.293a1 1 0 0 0 .293.707L15 7.707V12H1V7.707L2.707 6A1 1 0 0 0 3 5.293V4Z"
                }
            }
        ]
    })(props);
}
function BsUsbPlugFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4H6v-4ZM7 1v1h1V1H7Zm2 0v1h1V1H9ZM5.5 5a.5.5 0 0 0-.5.5v4.894a2 2 0 0 0 .336 1.11l.83 1.245c.544.816.834 1.774.834 2.754 0 .275.222.497.497.497h2.006a.497.497 0 0 0 .497-.497c0-.98.29-1.938.834-2.754l.83-1.245a2 2 0 0 0 .336-1.11V5.5a.5.5 0 0 0-.5-.5h-6Z"
                }
            }
        ]
    })(props);
}
function BsUsbPlug(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4H6v-4ZM7 1v1h1V1H7Zm2 0v1h1V1H9ZM6 5a1 1 0 0 0-1 1v4.394c0 .494.146.976.42 1.387l1.038 1.558c.354.53.542 1.152.542 1.789 0 .481.39.872.872.872h1.256c.481 0 .872-.39.872-.872 0-.637.188-1.26.541-1.789l1.04-1.558A2.5 2.5 0 0 0 12 10.394V6a1 1 0 0 0-1-1H6Zm0 1h5v4.394a1.5 1.5 0 0 1-.252.832L9.71 12.784A4.224 4.224 0 0 0 9.002 15H7.998a4.224 4.224 0 0 0-.707-2.216l-1.04-1.558A1.5 1.5 0 0 1 6 10.394V6Z"
                }
            }
        ]
    })(props);
}
function BsUsbSymbol(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7.792.312-1.533 2.3A.25.25 0 0 0 6.467 3H7.5v7.319a2.5 2.5 0 0 0-.515-.298L5.909 9.56A1.5 1.5 0 0 1 5 8.18v-.266a1.5 1.5 0 1 0-1 0v.266a2.5 2.5 0 0 0 1.515 2.298l1.076.461a1.5 1.5 0 0 1 .888 1.129 2.001 2.001 0 1 0 1.021-.006v-.902a1.5 1.5 0 0 1 .756-1.303l1.484-.848A2.5 2.5 0 0 0 11.995 7h.755a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h.741a1.5 1.5 0 0 1-.747 1.142L8.76 8.99a2.584 2.584 0 0 0-.26.17V3h1.033a.25.25 0 0 0 .208-.389L8.208.312a.25.25 0 0 0-.416 0Z"
                }
            }
        ]
    })(props);
}
function BsUsb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.25 7a.25.25 0 0 0-.25.25v1c0 .138.112.25.25.25h11.5a.25.25 0 0 0 .25-.25v-1a.25.25 0 0 0-.25-.25H2.25Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 5.5A.5.5 0 0 1 .5 5h15a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-5ZM1 10h14V6H1v4Z"
                }
            }
        ]
    })(props);
}
function BsValentine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132ZM2.25 4a.25.25 0 0 0-.25.25v1.5a.25.25 0 0 0 .5 0V4.5h1.25a.25.25 0 0 0 0-.5h-1.5Zm10 0a.25.25 0 1 0 0 .5h1.25v1.25a.25.25 0 1 0 .5 0v-1.5a.25.25 0 0 0-.25-.25h-1.5ZM2.5 10.25a.25.25 0 1 0-.5 0v1.5c0 .138.112.25.25.25h1.5a.25.25 0 1 0 0-.5H2.5v-1.25Zm11.5 0a.25.25 0 1 0-.5 0v1.25h-1.25a.25.25 0 1 0 0 .5h1.5a.25.25 0 0 0 .25-.25v-1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M0 2.994v-.06a1 1 0 0 1 .859-.99l13-1.857a1 1 0 0 1 1.141.99V2a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V2.994ZM1 3v10h14V3H1Z"
                }
            }
        ]
    })(props);
}
function BsValentine2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6.493c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132ZM4.25 3a.25.25 0 0 0-.25.25v1.5a.25.25 0 0 0 .5 0V3.5h1.25a.25.25 0 0 0 0-.5h-1.5Zm6 0a.25.25 0 1 0 0 .5h1.25v1.25a.25.25 0 1 0 .5 0v-1.5a.25.25 0 0 0-.25-.25h-1.5ZM4.5 12.25a.25.25 0 1 0-.5 0v1.5c0 .138.112.25.25.25h1.5a.25.25 0 0 0 0-.5H4.5v-1.25Zm7.5 0a.25.25 0 1 0-.5 0v1.25h-1.25a.25.25 0 1 0 0 .5h1.5a.25.25 0 0 0 .25-.25v-1.5Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2 1.994v-.042a1 1 0 0 1 .9-.995l9-.9A1 1 0 0 1 13 1a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V1.994ZM3 2v13h10V2H3Z"
                }
            }
        ]
    })(props);
}
function BsVectorPen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.646.646a.5.5 0 0 1 .708 0l4 4a.5.5 0 0 1 0 .708l-1.902 1.902-.829 3.313a1.5 1.5 0 0 1-1.024 1.073L1.254 14.746 4.358 4.4A1.5 1.5 0 0 1 5.43 3.377l3.313-.828L10.646.646zm-1.8 2.908-3.173.793a.5.5 0 0 0-.358.342l-2.57 8.565 8.567-2.57a.5.5 0 0 0 .34-.357l.794-3.174-3.6-3.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.832 13.228 8 9a1 1 0 1 0-1-1l-4.228 5.168-.026.086.086-.026z"
                }
            }
        ]
    })(props);
}
function BsViewList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4.5h10a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H3zM1 2a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 2zm0 12a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 14z"
                }
            }
        ]
    })(props);
}
function BsViewStacked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 0h10a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3zm0 8h10a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H3z"
                }
            }
        ]
    })(props);
}
function BsVignette(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1ZM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0 7a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm1.683-6.281a.5.5 0 1 1-.866-.5.5.5 0 0 1 .866.5Zm-3.5 6.062a.5.5 0 1 1-.866-.5.5.5 0 0 1 .866.5Zm4.598-4.598a.5.5 0 1 1-.5-.866.5.5 0 0 1 .5.866Zm-6.062 3.5a.5.5 0 1 1-.5-.866.5.5 0 0 1 .5.866ZM11.5 8.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-7 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm6.281 1.683a.5.5 0 1 1 .5-.866.5.5 0 0 1-.5.866Zm-6.062-3.5a.5.5 0 1 1 .5-.866.5.5 0 0 1-.5.866Zm4.598 4.598a.5.5 0 1 1 .866-.5.5.5 0 0 1-.866.5Zm-3.5-6.062a.5.5 0 1 1 .866-.5.5.5 0 0 1-.866.5Z"
                }
            }
        ]
    })(props);
}
function BsVimeo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.992 4.204c-.071 1.556-1.158 3.687-3.262 6.393-2.175 2.829-4.016 4.243-5.522 4.243-.933 0-1.722-.861-2.367-2.583L3.55 7.523C3.07 5.8 2.556 4.94 2.007 4.94c-.118 0-.537.253-1.254.754L0 4.724a209.56 209.56 0 0 0 2.334-2.081c1.054-.91 1.845-1.388 2.373-1.437 1.243-.123 2.01.728 2.298 2.553.31 1.968.526 3.19.646 3.666.36 1.631.756 2.446 1.186 2.445.334 0 .836-.53 1.508-1.587.671-1.058 1.03-1.863 1.077-2.415.096-.913-.263-1.37-1.077-1.37a3.022 3.022 0 0 0-1.185.261c.789-2.573 2.291-3.825 4.508-3.756 1.644.05 2.419 1.117 2.324 3.2z"
                }
            }
        ]
    })(props);
}
function BsVinylFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm0 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4 8a4 4 0 1 0 8 0 4 4 0 0 0-8 0z"
                }
            }
        ]
    })(props);
}
function BsVinyl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM4 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                }
            }
        ]
    })(props);
}
function BsVirus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a1 1 0 0 1 1 1v1.402c0 .511.677.693.933.25l.7-1.214a1 1 0 0 1 1.733 1l-.701 1.214c-.256.443.24.939.683.683l1.214-.701a1 1 0 0 1 1 1.732l-1.214.701c-.443.256-.262.933.25.933H15a1 1 0 1 1 0 2h-1.402c-.512 0-.693.677-.25.933l1.214.701a1 1 0 1 1-1 1.732l-1.214-.7c-.443-.257-.939.24-.683.682l.701 1.214a1 1 0 1 1-1.732 1l-.701-1.214c-.256-.443-.933-.262-.933.25V15a1 1 0 1 1-2 0v-1.402c0-.512-.677-.693-.933-.25l-.701 1.214a1 1 0 0 1-1.732-1l.7-1.214c.257-.443-.24-.939-.682-.683l-1.214.701a1 1 0 1 1-1-1.732l1.214-.701c.443-.256.261-.933-.25-.933H1a1 1 0 1 1 0-2h1.402c.511 0 .693-.677.25-.933l-1.214-.701a1 1 0 1 1 1-1.732l1.214.701c.443.256.939-.24.683-.683l-.701-1.214a1 1 0 0 1 1.732-1l.701 1.214c.256.443.933.261.933-.25V1a1 1 0 0 1 1-1Zm2 5a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM6 7a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm1 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm5-3a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"
                }
            }
        ]
    })(props);
}
function BsVirus2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a1 1 0 0 0-1 1v1.143c0 .557-.407 1.025-.921 1.24-.514.214-1.12.162-1.513-.231l-.809-.809a1 1 0 1 0-1.414 1.414l.809.809c.394.394.445.999.23 1.513C3.169 6.593 2.7 7 2.144 7H1a1 1 0 0 0 0 2h1.143c.557 0 1.025.407 1.24.921.214.514.163 1.12-.231 1.513l-.809.809a1 1 0 0 0 1.414 1.414l.809-.809c.394-.394.999-.445 1.513-.23.514.214.921.682.921 1.24V15a1 1 0 1 0 2 0v-1.143c0-.557.407-1.025.921-1.24.514-.214 1.12-.162 1.513.231l.809.809a1 1 0 0 0 1.414-1.414l-.809-.809c-.393-.394-.445-.999-.23-1.513.214-.514.682-.921 1.24-.921H15a1 1 0 1 0 0-2h-1.143c-.557 0-1.025-.407-1.24-.921-.214-.514-.162-1.12.231-1.513l.809-.809a1 1 0 0 0-1.414-1.414l-.809.809c-.394.393-.999.445-1.513.23-.514-.214-.92-.682-.92-1.24V1a1 1 0 0 0-1-1Zm2 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM7 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm1 5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm4-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
                }
            }
        ]
    })(props);
}
function BsVoicemail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 8.5A3.49 3.49 0 0 1 5.95 11h4.1a3.5 3.5 0 1 1 2.45 1h-9A3.5 3.5 0 1 1 7 8.5zm-6 0a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0zm14 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0z"
                }
            }
        ]
    })(props);
}
function BsVolumeDownFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4a.5.5 0 0 0-.812-.39L5.825 5.5H3.5A.5.5 0 0 0 3 6v4a.5.5 0 0 0 .5.5h2.325l2.363 1.89A.5.5 0 0 0 9 12V4zm3.025 4a4.486 4.486 0 0 1-1.318 3.182L10 10.475A3.489 3.489 0 0 0 11.025 8 3.49 3.49 0 0 0 10 5.525l.707-.707A4.486 4.486 0 0 1 12.025 8z"
                }
            }
        ]
    })(props);
}
function BsVolumeDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4a.5.5 0 0 0-.812-.39L5.825 5.5H3.5A.5.5 0 0 0 3 6v4a.5.5 0 0 0 .5.5h2.325l2.363 1.89A.5.5 0 0 0 9 12V4zM6.312 6.39 8 5.04v5.92L6.312 9.61A.5.5 0 0 0 6 9.5H4v-3h2a.5.5 0 0 0 .312-.11zM12.025 8a4.486 4.486 0 0 1-1.318 3.182L10 10.475A3.489 3.489 0 0 0 11.025 8 3.49 3.49 0 0 0 10 5.525l.707-.707A4.486 4.486 0 0 1 12.025 8z"
                }
            }
        ]
    })(props);
}
function BsVolumeMuteFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06zm7.137 2.096a.5.5 0 0 1 0 .708L12.207 8l1.647 1.646a.5.5 0 0 1-.708.708L11.5 8.707l-1.646 1.647a.5.5 0 0 1-.708-.708L10.793 8 9.146 6.354a.5.5 0 1 1 .708-.708L11.5 7.293l1.646-1.647a.5.5 0 0 1 .708 0z"
                }
            }
        ]
    })(props);
}
function BsVolumeMute(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06zM6 5.04 4.312 6.39A.5.5 0 0 1 4 6.5H2v3h2a.5.5 0 0 1 .312.11L6 10.96V5.04zm7.854.606a.5.5 0 0 1 0 .708L12.207 8l1.647 1.646a.5.5 0 0 1-.708.708L11.5 8.707l-1.646 1.647a.5.5 0 0 1-.708-.708L10.793 8 9.146 6.354a.5.5 0 1 1 .708-.708L11.5 7.293l1.646-1.647a.5.5 0 0 1 .708 0z"
                }
            }
        ]
    })(props);
}
function BsVolumeOffFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.717 3.55A.5.5 0 0 1 11 4v8a.5.5 0 0 1-.812.39L7.825 10.5H5.5A.5.5 0 0 1 5 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06z"
                }
            }
        ]
    })(props);
}
function BsVolumeOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.717 3.55A.5.5 0 0 1 11 4v8a.5.5 0 0 1-.812.39L7.825 10.5H5.5A.5.5 0 0 1 5 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06zM10 5.04 8.312 6.39A.5.5 0 0 1 8 6.5H6v3h2a.5.5 0 0 1 .312.11L10 10.96V5.04z"
                }
            }
        ]
    })(props);
}
function BsVolumeUpFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.536 14.01A8.473 8.473 0 0 0 14.026 8a8.473 8.473 0 0 0-2.49-6.01l-.708.707A7.476 7.476 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303l.708.707z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.483 5.483 0 0 1 11.025 8a5.483 5.483 0 0 1-1.61 3.89l.706.706z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.707 11.182A4.486 4.486 0 0 0 10.025 8a4.486 4.486 0 0 0-1.318-3.182L8 5.525A3.489 3.489 0 0 1 9.025 8 3.49 3.49 0 0 1 8 10.475l.707.707zM6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06z"
                }
            }
        ]
    })(props);
}
function BsVolumeUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.536 14.01A8.473 8.473 0 0 0 14.026 8a8.473 8.473 0 0 0-2.49-6.01l-.708.707A7.476 7.476 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303l.708.707z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.483 5.483 0 0 1 11.025 8a5.483 5.483 0 0 1-1.61 3.89l.706.706z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.025 8a4.486 4.486 0 0 1-1.318 3.182L8 10.475A3.489 3.489 0 0 0 9.025 8c0-.966-.392-1.841-1.025-2.475l.707-.707A4.486 4.486 0 0 1 10.025 8zM7 4a.5.5 0 0 0-.812-.39L3.825 5.5H1.5A.5.5 0 0 0 1 6v4a.5.5 0 0 0 .5.5h2.325l2.363 1.89A.5.5 0 0 0 7 12V4zM4.312 6.39 6 5.04v5.92L4.312 9.61A.5.5 0 0 0 4 9.5H2v-3h2a.5.5 0 0 0 .312-.11z"
                }
            }
        ]
    })(props);
}
function BsVr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12V4a1 1 0 0 1 1-1h2.5V2H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5v-1H4a1 1 0 0 1-1-1zm6.5 1v1H12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H9.5v1H12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H9.5zM8 16a.5.5 0 0 1-.5-.5V.5a.5.5 0 0 1 1 0v15a.5.5 0 0 1-.5.5z"
                }
            }
        ]
    })(props);
}
function BsWalletFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.5 2A1.5 1.5 0 0 0 0 3.5v2h6a.5.5 0 0 1 .5.5c0 .253.08.644.306.958.207.288.557.542 1.194.542.637 0 .987-.254 1.194-.542.226-.314.306-.705.306-.958a.5.5 0 0 1 .5-.5h6v-2A1.5 1.5 0 0 0 14.5 2h-13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6.5h-5.551a2.678 2.678 0 0 1-.443 1.042C9.613 8.088 8.963 8.5 8 8.5c-.963 0-1.613-.412-2.006-.958A2.679 2.679 0 0 1 5.551 6.5H0v6A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-6z"
                }
            }
        ]
    })(props);
}
function BsWallet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 3a2 2 0 0 1 2-2h13.5a.5.5 0 0 1 0 1H15v2a1 1 0 0 1 1 1v8.5a1.5 1.5 0 0 1-1.5 1.5h-12A2.5 2.5 0 0 1 0 12.5V3zm1 1.732V12.5A1.5 1.5 0 0 0 2.5 14h12a.5.5 0 0 0 .5-.5V5H2a1.99 1.99 0 0 1-1-.268zM1 3a1 1 0 0 0 1 1h12V2H2a1 1 0 0 0-1 1z"
                }
            }
        ]
    })(props);
}
function BsWallet2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.136.326A1.5 1.5 0 0 1 14 1.78V3h.5A1.5 1.5 0 0 1 16 4.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 13.5v-9a1.5 1.5 0 0 1 1.432-1.499L12.136.326zM5.562 3H13V1.78a.5.5 0 0 0-.621-.484L5.562 3zM1.5 4a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-13z"
                }
            }
        ]
    })(props);
}
function BsWatch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 5a.5.5 0 0 0-1 0v2.5H6a.5.5 0 0 0 0 1h2a.5.5 0 0 0 .5-.5V5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.667 16C4.747 16 4 15.254 4 14.333v-1.86A5.985 5.985 0 0 1 2 8c0-1.777.772-3.374 2-4.472V1.667C4 .747 4.746 0 5.667 0h4.666C11.253 0 12 .746 12 1.667v1.86a5.99 5.99 0 0 1 1.918 3.48.502.502 0 0 1 .582.493v1a.5.5 0 0 1-.582.493A5.99 5.99 0 0 1 12 12.473v1.86c0 .92-.746 1.667-1.667 1.667H5.667zM13 8A5 5 0 1 0 3 8a5 5 0 0 0 10 0z"
                }
            }
        ]
    })(props);
}
function BsWater(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.036 3.314a.5.5 0 0 1 .65-.278l1.757.703a1.5 1.5 0 0 0 1.114 0l1.014-.406a2.5 2.5 0 0 1 1.857 0l1.015.406a1.5 1.5 0 0 0 1.114 0l1.014-.406a2.5 2.5 0 0 1 1.857 0l1.015.406a1.5 1.5 0 0 0 1.114 0l1.757-.703a.5.5 0 1 1 .372.928l-1.758.703a2.5 2.5 0 0 1-1.857 0l-1.014-.406a1.5 1.5 0 0 0-1.114 0l-1.015.406a2.5 2.5 0 0 1-1.857 0l-1.014-.406a1.5 1.5 0 0 0-1.114 0l-1.015.406a2.5 2.5 0 0 1-1.857 0L.314 3.964a.5.5 0 0 1-.278-.65zm0 3a.5.5 0 0 1 .65-.278l1.757.703a1.5 1.5 0 0 0 1.114 0l1.014-.406a2.5 2.5 0 0 1 1.857 0l1.015.406a1.5 1.5 0 0 0 1.114 0l1.014-.406a2.5 2.5 0 0 1 1.857 0l1.015.406a1.5 1.5 0 0 0 1.114 0l1.757-.703a.5.5 0 1 1 .372.928l-1.758.703a2.5 2.5 0 0 1-1.857 0l-1.014-.406a1.5 1.5 0 0 0-1.114 0l-1.015.406a2.5 2.5 0 0 1-1.857 0l-1.014-.406a1.5 1.5 0 0 0-1.114 0l-1.015.406a2.5 2.5 0 0 1-1.857 0L.314 6.964a.5.5 0 0 1-.278-.65zm0 3a.5.5 0 0 1 .65-.278l1.757.703a1.5 1.5 0 0 0 1.114 0l1.014-.406a2.5 2.5 0 0 1 1.857 0l1.015.406a1.5 1.5 0 0 0 1.114 0l1.014-.406a2.5 2.5 0 0 1 1.857 0l1.015.406a1.5 1.5 0 0 0 1.114 0l1.757-.703a.5.5 0 1 1 .372.928l-1.758.703a2.5 2.5 0 0 1-1.857 0l-1.014-.406a1.5 1.5 0 0 0-1.114 0l-1.015.406a2.5 2.5 0 0 1-1.857 0l-1.014-.406a1.5 1.5 0 0 0-1.114 0l-1.015.406a2.5 2.5 0 0 1-1.857 0L.314 9.964a.5.5 0 0 1-.278-.65zm0 3a.5.5 0 0 1 .65-.278l1.757.703a1.5 1.5 0 0 0 1.114 0l1.014-.406a2.5 2.5 0 0 1 1.857 0l1.015.406a1.5 1.5 0 0 0 1.114 0l1.014-.406a2.5 2.5 0 0 1 1.857 0l1.015.406a1.5 1.5 0 0 0 1.114 0l1.757-.703a.5.5 0 1 1 .372.928l-1.758.703a2.5 2.5 0 0 1-1.857 0l-1.014-.406a1.5 1.5 0 0 0-1.114 0l-1.015.406a2.5 2.5 0 0 1-1.857 0l-1.014-.406a1.5 1.5 0 0 0-1.114 0l-1.015.406a2.5 2.5 0 0 1-1.857 0l-1.757-.703a.5.5 0 0 1-.278-.65z"
                }
            }
        ]
    })(props);
}
function BsWebcamFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.644 11.094a.5.5 0 0 1 .356-.15h2a.5.5 0 0 1 .356.15c.175.177.39.347.603.496a7.166 7.166 0 0 0 .752.456l.01.006h.003A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.224-.947l.002-.001.01-.006a3.517 3.517 0 0 0 .214-.116 7.5 7.5 0 0 0 .539-.34c.214-.15.428-.319.603-.496ZM7 6.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H2Zm6 1.5a2 2 0 1 1 0 4 2 2 0 0 1 0-4ZM12.5 7a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
                }
            }
        ]
    })(props);
}
function BsWebcam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H9.269c.144.162.33.324.531.475a6.785 6.785 0 0 0 .907.57l.014.006.003.002A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.224-.947l.003-.002.014-.007a4.473 4.473 0 0 0 .268-.148 6.75 6.75 0 0 0 .639-.421c.2-.15.387-.313.531-.475H2a2 2 0 0 1-2-2V6Zm2-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm7 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
                }
            }
        ]
    })(props);
}
function BsWechat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.176 14.429c-2.665 0-4.826-1.8-4.826-4.018 0-2.22 2.159-4.02 4.824-4.02S16 8.191 16 10.411c0 1.21-.65 2.301-1.666 3.036a.324.324 0 0 0-.12.366l.218.81a.616.616 0 0 1 .029.117.166.166 0 0 1-.162.162.177.177 0 0 1-.092-.03l-1.057-.61a.519.519 0 0 0-.256-.074.509.509 0 0 0-.142.021 5.668 5.668 0 0 1-1.576.22ZM9.064 9.542a.647.647 0 1 0 .557-1 .645.645 0 0 0-.646.647.615.615 0 0 0 .09.353Zm3.232.001a.646.646 0 1 0 .546-1 .645.645 0 0 0-.644.644.627.627 0 0 0 .098.356Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 6.826c0 1.455.781 2.765 2.001 3.656a.385.385 0 0 1 .143.439l-.161.6-.1.373a.499.499 0 0 0-.032.14.192.192 0 0 0 .193.193c.039 0 .077-.01.111-.029l1.268-.733a.622.622 0 0 1 .308-.088c.058 0 .116.009.171.025a6.83 6.83 0 0 0 1.625.26 4.45 4.45 0 0 1-.177-1.251c0-2.936 2.785-5.02 5.824-5.02.05 0 .1 0 .15.002C10.587 3.429 8.392 2 5.796 2 2.596 2 0 4.16 0 6.826Zm4.632-1.555a.77.77 0 1 1-1.54 0 .77.77 0 0 1 1.54 0Zm3.875 0a.77.77 0 1 1-1.54 0 .77.77 0 0 1 1.54 0Z"
                }
            }
        ]
    })(props);
}
function BsWhatsapp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"
                }
            }
        ]
    })(props);
}
function BsWifi1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.046 10.454c.226-.226.185-.605-.1-.75A6.473 6.473 0 0 0 8 9c-1.06 0-2.062.254-2.946.704-.285.145-.326.524-.1.75l.015.015c.16.16.407.19.611.09A5.478 5.478 0 0 1 8 10c.868 0 1.69.201 2.42.56.203.1.45.07.611-.091l.015-.015zM9.06 12.44c.196-.196.198-.52-.04-.66A1.99 1.99 0 0 0 8 11.5a1.99 1.99 0 0 0-1.02.28c-.238.14-.236.464-.04.66l.706.706a.5.5 0 0 0 .707 0l.708-.707z"
                }
            }
        ]
    })(props);
}
function BsWifi2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.229 8.271c.216-.216.194-.578-.063-.745A9.456 9.456 0 0 0 8 6c-1.905 0-3.68.56-5.166 1.526a.48.48 0 0 0-.063.745.525.525 0 0 0 .652.065A8.46 8.46 0 0 1 8 7a8.46 8.46 0 0 1 4.577 1.336c.205.132.48.108.652-.065zm-2.183 2.183c.226-.226.185-.605-.1-.75A6.473 6.473 0 0 0 8 9c-1.06 0-2.062.254-2.946.704-.285.145-.326.524-.1.75l.015.015c.16.16.408.19.611.09A5.478 5.478 0 0 1 8 10c.868 0 1.69.201 2.42.56.203.1.45.07.611-.091l.015-.015zM9.06 12.44c.196-.196.198-.52-.04-.66A1.99 1.99 0 0 0 8 11.5a1.99 1.99 0 0 0-1.02.28c-.238.14-.236.464-.04.66l.706.706a.5.5 0 0 0 .708 0l.707-.707z"
                }
            }
        ]
    })(props);
}
function BsWifiOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.706 3.294A12.545 12.545 0 0 0 8 3C5.259 3 2.723 3.882.663 5.379a.485.485 0 0 0-.048.736.518.518 0 0 0 .668.05A11.448 11.448 0 0 1 8 4c.63 0 1.249.05 1.852.148l.854-.854zM8 6c-1.905 0-3.68.56-5.166 1.526a.48.48 0 0 0-.063.745.525.525 0 0 0 .652.065 8.448 8.448 0 0 1 3.51-1.27L8 6zm2.596 1.404.785-.785c.63.24 1.227.545 1.785.907a.482.482 0 0 1 .063.745.525.525 0 0 1-.652.065 8.462 8.462 0 0 0-1.98-.932zM8 10l.933-.933a6.455 6.455 0 0 1 2.013.637c.285.145.326.524.1.75l-.015.015a.532.532 0 0 1-.611.09A5.478 5.478 0 0 0 8 10zm4.905-4.905.747-.747c.59.3 1.153.645 1.685 1.03a.485.485 0 0 1 .047.737.518.518 0 0 1-.668.05 11.493 11.493 0 0 0-1.811-1.07zM9.02 11.78c.238.14.236.464.04.66l-.707.706a.5.5 0 0 1-.707 0l-.707-.707c-.195-.195-.197-.518.04-.66A1.99 1.99 0 0 1 8 11.5c.374 0 .723.102 1.021.28zm4.355-9.905a.53.53 0 0 1 .75.75l-10.75 10.75a.53.53 0 0 1-.75-.75l10.75-10.75z"
                }
            }
        ]
    })(props);
}
function BsWifi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.384 6.115a.485.485 0 0 0-.047-.736A12.444 12.444 0 0 0 8 3C5.259 3 2.723 3.882.663 5.379a.485.485 0 0 0-.048.736.518.518 0 0 0 .668.05A11.448 11.448 0 0 1 8 4c2.507 0 4.827.802 6.716 2.164.205.148.49.13.668-.049z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.229 8.271a.482.482 0 0 0-.063-.745A9.455 9.455 0 0 0 8 6c-1.905 0-3.68.56-5.166 1.526a.48.48 0 0 0-.063.745.525.525 0 0 0 .652.065A8.46 8.46 0 0 1 8 7a8.46 8.46 0 0 1 4.576 1.336c.206.132.48.108.653-.065zm-2.183 2.183c.226-.226.185-.605-.1-.75A6.473 6.473 0 0 0 8 9c-1.06 0-2.062.254-2.946.704-.285.145-.326.524-.1.75l.015.015c.16.16.407.19.611.09A5.478 5.478 0 0 1 8 10c.868 0 1.69.201 2.42.56.203.1.45.07.61-.091l.016-.015zM9.06 12.44c.196-.196.198-.52-.04-.66A1.99 1.99 0 0 0 8 11.5a1.99 1.99 0 0 0-1.02.28c-.238.14-.236.464-.04.66l.706.706a.5.5 0 0 0 .707 0l.707-.707z"
                }
            }
        ]
    })(props);
}
function BsWikipedia(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.835 3.003c.828-.006 2.688 0 2.688 0l.033.03v.288c0 .08-.045.12-.133.12-.433.02-.522.063-.68.29-.087.126-.258.393-.435.694l-1.52 2.843-.043.089 1.858 3.801.113.031 2.926-6.946c.102-.28.086-.478-.044-.595-.132-.114-.224-.18-.563-.195l-.275-.014a.161.161 0 0 1-.096-.035.1.1 0 0 1-.046-.084v-.289l.042-.03h3.306l.034.03v.29c0 .078-.045.117-.133.117-.433.02-.754.113-.962.281a1.64 1.64 0 0 0-.488.704s-2.691 6.16-3.612 8.208c-.353.672-.7.61-1.004-.019A224.05 224.05 0 0 1 8.044 8.81c-.623 1.285-1.475 3.026-1.898 3.81-.411.715-.75.622-1.02.019-.45-1.065-1.131-2.519-1.817-3.982-.735-1.569-1.475-3.149-1.943-4.272-.167-.4-.293-.657-.412-.759-.12-.1-.368-.16-.746-.18C.069 3.429 0 3.395 0 3.341v-.303l.034-.03c.615-.003 3.594 0 3.594 0l.034.03v.288c0 .08-.05.118-.15.118l-.375.016c-.322.013-.483.11-.483.288 0 .083.034.217.109.4.72 1.753 3.207 6.998 3.207 6.998l.091.023 1.603-3.197-.32-.71L6.24 5.095s-.213-.433-.286-.577l-.098-.196c-.387-.77-.411-.82-.865-.88-.137-.017-.208-.035-.208-.102v-.304l.041-.03h2.853l.075.024v.303c0 .069-.05.104-.15.104l-.206.03c-.523.04-.438.254-.09.946l1.057 2.163 1.17-2.332c.195-.427.155-.534.074-.633-.046-.055-.202-.144-.54-.158l-.133-.015a.159.159 0 0 1-.096-.034.099.099 0 0 1-.045-.085v-.288l.041-.03Z"
                }
            }
        ]
    })(props);
}
function BsWind(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 2A2.5 2.5 0 0 0 10 4.5a.5.5 0 0 1-1 0A3.5 3.5 0 1 1 12.5 8H.5a.5.5 0 0 1 0-1h12a2.5 2.5 0 0 0 0-5zm-7 1a1 1 0 0 0-1 1 .5.5 0 0 1-1 0 2 2 0 1 1 2 2h-5a.5.5 0 0 1 0-1h5a1 1 0 0 0 0-2zM0 9.5A.5.5 0 0 1 .5 9h10.042a3 3 0 1 1-3 3 .5.5 0 0 1 1 0 2 2 0 1 0 2-2H.5a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}
function BsWindowDash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM4 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm2-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v4a.5.5 0 0 1-1 0V7H1v5a1 1 0 0 0 1 1h5.5a.5.5 0 0 1 0 1H2a2 2 0 0 1-2-2V4Zm1 2h13V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-5.5 0a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5Z"
                }
            }
        ]
    })(props);
}
function BsWindowDesktop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 11a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-9Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.375 1A2.366 2.366 0 0 0 0 3.357v9.286A2.366 2.366 0 0 0 2.375 15h11.25A2.366 2.366 0 0 0 16 12.643V3.357A2.366 2.366 0 0 0 13.625 1H2.375ZM1 3.357C1 2.612 1.611 2 2.375 2h11.25C14.389 2 15 2.612 15 3.357V4H1v-.643ZM1 5h14v7.643c0 .745-.611 1.357-1.375 1.357H2.375A1.366 1.366 0 0 1 1 12.643V5Z"
                }
            }
        ]
    })(props);
}
function BsWindowDock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 11a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm3.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm4.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h12ZM2 14h12a1 1 0 0 0 1-1V5H1v8a1 1 0 0 0 1 1ZM2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1H2Z"
                }
            }
        ]
    })(props);
}
function BsWindowFullscreen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm1.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm1 .5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5H.5ZM1 5V2h14v3H1Zm0 1h14v8H1V6Z"
                }
            }
        ]
    })(props);
}
function BsWindowPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM4 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm2-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v4a.5.5 0 0 1-1 0V7H1v5a1 1 0 0 0 1 1h5.5a.5.5 0 0 1 0 1H2a2 2 0 0 1-2-2V4Zm1 2h13V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-3.5-2a.5.5 0 0 0-.5.5v1h-1a.5.5 0 0 0 0 1h1v1a.5.5 0 0 0 1 0v-1h1a.5.5 0 0 0 0-1h-1v-1a.5.5 0 0 0-.5-.5Z"
                }
            }
        ]
    })(props);
}
function BsWindowSidebar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm2-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm1 .5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2zm12 1a1 1 0 0 1 1 1v2H1V3a1 1 0 0 1 1-1h12zM1 13V6h4v8H2a1 1 0 0 1-1-1zm5 1V6h9v7a1 1 0 0 1-1 1H6z"
                }
            }
        ]
    })(props);
}
function BsWindowSplit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm2-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm1 .5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2Zm12 1a1 1 0 0 1 1 1v2H1V3a1 1 0 0 1 1-1h12ZM1 13V6h6.5v8H2a1 1 0 0 1-1-1Zm7.5 1V6H15v7a1 1 0 0 1-1 1H8.5Z"
                }
            }
        ]
    })(props);
}
function BsWindowStack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 6a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM6 6a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm2-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1a2 2 0 0 1 2 2 2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2 2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10ZM2 12V5a2 2 0 0 1 2-2h9a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1Zm1-4v5a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V8H3Zm12-1V5a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v2h12Z"
                }
            }
        ]
    })(props);
}
function BsWindowX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM4 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm2-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 4a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v4a.5.5 0 0 1-1 0V7H1v5a1 1 0 0 0 1 1h5.5a.5.5 0 0 1 0 1H2a2 2 0 0 1-2-2V4Zm1 2h13V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-4.854-1.354a.5.5 0 0 0 0 .708l.647.646-.647.646a.5.5 0 0 0 .708.708l.646-.647.646.647a.5.5 0 0 0 .708-.708l-.647-.646.647-.646a.5.5 0 0 0-.708-.708l-.646.647-.646-.647a.5.5 0 0 0-.708 0Z"
                }
            }
        ]
    })(props);
}
function BsWindow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm2-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm1 .5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2zm13 2v2H1V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zM2 14a1 1 0 0 1-1-1V6h14v7a1 1 0 0 1-1 1H2z"
                }
            }
        ]
    })(props);
}
function BsWindows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.555 1.375 0 2.237v5.45h6.555V1.375zM0 13.795l6.555.933V8.313H0v5.482zm7.278-5.4.026 6.378L16 16V8.395H7.278zM16 0 7.33 1.244v6.414H16V0z"
                }
            }
        ]
    })(props);
}
function BsWordpress(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.633 7.653c0-.848-.305-1.435-.566-1.892l-.08-.13c-.317-.51-.594-.958-.594-1.48 0-.63.478-1.218 1.152-1.218.02 0 .039.002.058.003l.031.003A6.838 6.838 0 0 0 8 1.137 6.855 6.855 0 0 0 2.266 4.23c.16.005.313.009.442.009.717 0 1.828-.087 1.828-.087.37-.022.414.521.044.565 0 0-.371.044-.785.065l2.5 7.434 1.5-4.506-1.07-2.929c-.369-.022-.719-.065-.719-.065-.37-.022-.326-.588.043-.566 0 0 1.134.087 1.808.087.718 0 1.83-.087 1.83-.087.37-.022.413.522.043.566 0 0-.372.043-.785.065l2.48 7.377.684-2.287.054-.173c.27-.86.469-1.495.469-2.046zM1.137 8a6.864 6.864 0 0 0 3.868 6.176L1.73 5.206A6.837 6.837 0 0 0 1.137 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.061 14.583 8.121 8.6l2.109 5.78c.014.033.03.064.049.094a6.854 6.854 0 0 1-4.218.109zm7.96-9.876c.03.219.047.453.047.706 0 .696-.13 1.479-.522 2.458l-2.096 6.06a6.86 6.86 0 0 0 2.572-9.224z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M0 8c0-4.411 3.589-8 8-8 4.41 0 8 3.589 8 8s-3.59 8-8 8c-4.411 0-8-3.589-8-8zm.367 0c0 4.209 3.424 7.633 7.633 7.633 4.208 0 7.632-3.424 7.632-7.633C15.632 3.79 12.208.367 8 .367 3.79.367.367 3.79.367 8z"
                }
            }
        ]
    })(props);
}
function BsWrenchAdjustableCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.705 8.139a.25.25 0 0 0-.288-.376l-1.5.5.159.474.808-.27-.595.894a.25.25 0 0 0 .287.376l.808-.27-.595.894a.25.25 0 0 0 .287.376l1.5-.5-.159-.474-.808.27.596-.894a.25.25 0 0 0-.288-.376l-.808.27.596-.894Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm-6.202-4.751 1.988-1.657a4.5 4.5 0 0 1 7.537-4.623L7.497 6.5l1 2.5 1.333 3.11c-.56.251-1.18.39-1.833.39a4.49 4.49 0 0 1-1.592-.29L4.747 14.2a7.031 7.031 0 0 1-2.949-2.951ZM12.496 8a4.491 4.491 0 0 1-1.703 3.526L9.497 8.5l2.959-1.11c.027.2.04.403.04.61Z"
                }
            }
        ]
    })(props);
}
function BsWrenchAdjustableCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.496 8a4.491 4.491 0 0 1-1.703 3.526L9.497 8.5l2.959-1.11c.027.2.04.403.04.61Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-1 0a7 7 0 1 0-13.202 3.249l1.988-1.657a4.5 4.5 0 0 1 7.537-4.623L7.497 6.5l1 2.5 1.333 3.11c-.56.251-1.18.39-1.833.39a4.49 4.49 0 0 1-1.592-.29L4.747 14.2A7 7 0 0 0 15 8Zm-8.295.139a.25.25 0 0 0-.288-.376l-1.5.5.159.474.808-.27-.595.894a.25.25 0 0 0 .287.376l.808-.27-.595.894a.25.25 0 0 0 .287.376l1.5-.5-.159-.474-.808.27.596-.894a.25.25 0 0 0-.288-.376l-.808.27.596-.894Z"
                }
            }
        ]
    })(props);
}
function BsWrenchAdjustable(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4.5a4.492 4.492 0 0 1-1.703 3.526L13 5l2.959-1.11c.027.2.041.403.041.61Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 9c.653 0 1.273-.139 1.833-.39L12 5.5 11 3l3.826-1.53A4.5 4.5 0 0 0 7.29 6.092l-6.116 5.096a2.583 2.583 0 1 0 3.638 3.638L9.908 8.71A4.49 4.49 0 0 0 11.5 9Zm-1.292-4.361-.596.893.809-.27a.25.25 0 0 1 .287.377l-.596.893.809-.27.158.475-1.5.5a.25.25 0 0 1-.287-.376l.596-.893-.809.27a.25.25 0 0 1-.287-.377l.596-.893-.809.27-.158-.475 1.5-.5a.25.25 0 0 1 .287.376ZM3 14a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
                }
            }
        ]
    })(props);
}
function BsWrench(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.102 2.223A3.004 3.004 0 0 0 3.78 5.897l6.341 6.252A3.003 3.003 0 0 0 13 16a3 3 0 1 0-.851-5.878L5.897 3.781A3.004 3.004 0 0 0 2.223.1l2.141 2.142L4 4l-1.757.364L.102 2.223zm13.37 9.019.528.026.287.445.445.287.026.529L15 13l-.242.471-.026.529-.445.287-.287.445-.529.026L13 15l-.471-.242-.529-.026-.287-.445-.445-.287-.026-.529L11 13l.242-.471.026-.529.445-.287.287-.445.529-.026L13 11l.471.242z"
                }
            }
        ]
    })(props);
}
function BsXCircleFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"
                }
            }
        ]
    })(props);
}
function BsXCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                }
            }
        ]
    })(props);
}
function BsXDiamondFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.05.435c-.58-.58-1.52-.58-2.1 0L4.047 3.339 8 7.293l3.954-3.954L9.049.435zm3.61 3.611L8.708 8l3.954 3.954 2.904-2.905c.58-.58.58-1.519 0-2.098l-2.904-2.905zm-.706 8.614L8 8.708l-3.954 3.954 2.905 2.904c.58.58 1.519.58 2.098 0l2.905-2.904zm-8.614-.706L7.292 8 3.339 4.046.435 6.951c-.58.58-.58 1.519 0 2.098l2.904 2.905z"
                }
            }
        ]
    })(props);
}
function BsXDiamond(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.987 16a1.526 1.526 0 0 1-1.07-.448L.45 9.082a1.531 1.531 0 0 1 0-2.165L6.917.45a1.531 1.531 0 0 1 2.166 0l6.469 6.468A1.526 1.526 0 0 1 16 8.013a1.526 1.526 0 0 1-.448 1.07l-6.47 6.469A1.526 1.526 0 0 1 7.988 16zM7.639 1.17 4.766 4.044 8 7.278l3.234-3.234L8.361 1.17a.51.51 0 0 0-.722 0zM8.722 8l3.234 3.234 2.873-2.873c.2-.2.2-.523 0-.722l-2.873-2.873L8.722 8zM8 8.722l-3.234 3.234 2.873 2.873c.2.2.523.2.722 0l2.873-2.873L8 8.722zM7.278 8 4.044 4.766 1.17 7.639a.511.511 0 0 0 0 .722l2.874 2.873L7.278 8z"
                }
            }
        ]
    })(props);
}
function BsXLg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"
                }
            }
        ]
    })(props);
}
function BsXOctagonFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.46.146A.5.5 0 0 0 11.107 0H4.893a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353L11.46.146zm-6.106 4.5L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708z"
                }
            }
        ]
    })(props);
}
function BsXOctagon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.54.146A.5.5 0 0 1 4.893 0h6.214a.5.5 0 0 1 .353.146l4.394 4.394a.5.5 0 0 1 .146.353v6.214a.5.5 0 0 1-.146.353l-4.394 4.394a.5.5 0 0 1-.353.146H4.893a.5.5 0 0 1-.353-.146L.146 11.46A.5.5 0 0 1 0 11.107V4.893a.5.5 0 0 1 .146-.353L4.54.146zM5.1 1 1 5.1v5.8L5.1 15h5.8l4.1-4.1V5.1L10.9 1H5.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                }
            }
        ]
    })(props);
}
function BsXSquareFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm3.354 4.646L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708z"
                }
            }
        ]
    })(props);
}
function BsXSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                }
            }
        ]
    })(props);
}
function BsX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                }
            }
        ]
    })(props);
}
function BsXbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.202 15.967a7.987 7.987 0 0 1-3.552-1.26c-.898-.585-1.101-.826-1.101-1.306 0-.965 1.062-2.656 2.879-4.583C6.459 7.723 7.897 6.44 8.052 6.475c.302.068 2.718 2.423 3.622 3.531 1.43 1.753 2.088 3.189 1.754 3.829-.254.486-1.83 1.437-2.987 1.802-.954.301-2.207.429-3.239.33Zm-5.866-3.57C.589 11.253.212 10.127.03 8.497c-.06-.539-.038-.846.137-1.95.218-1.377 1.002-2.97 1.945-3.95.401-.417.437-.427.926-.263.595.2 1.23.638 2.213 1.528l.574.519-.313.385C4.056 6.553 2.52 9.086 1.94 10.653c-.315.852-.442 1.707-.306 2.063.091.24.007.15-.3-.319Zm13.101.195c.074-.36-.019-1.02-.238-1.687-.473-1.443-2.055-4.128-3.508-5.953l-.457-.575.494-.454c.646-.593 1.095-.948 1.58-1.25.381-.237.927-.448 1.161-.448.145 0 .654.528 1.065 1.104a8.372 8.372 0 0 1 1.343 3.102c.153.728.166 2.286.024 3.012a9.495 9.495 0 0 1-.6 1.893c-.179.393-.624 1.156-.82 1.404-.1.128-.1.127-.043-.148ZM7.335 1.952c-.67-.34-1.704-.705-2.276-.803a4.171 4.171 0 0 0-.759-.043c-.471.024-.45 0 .306-.358A7.778 7.778 0 0 1 6.47.128c.8-.169 2.306-.17 3.094-.005.85.18 1.853.552 2.418.9l.168.103-.385-.02c-.766-.038-1.88.27-3.078.853-.361.176-.676.316-.699.312a12.246 12.246 0 0 1-.654-.319Z"
                }
            }
        ]
    })(props);
}
function BsYelp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m4.188 10.095.736-.17a.824.824 0 0 0 .073-.02.813.813 0 0 0 .453-1.255 1.025 1.025 0 0 0-.3-.258 2.782 2.782 0 0 0-.428-.198l-.808-.295a76.035 76.035 0 0 0-1.364-.493C2.253 7.3 2 7.208 1.783 7.14c-.041-.013-.087-.025-.124-.038a2.143 2.143 0 0 0-.606-.116.723.723 0 0 0-.572.245 1.625 1.625 0 0 0-.105.132 1.555 1.555 0 0 0-.155.309c-.15.443-.225.908-.22 1.376.002.423.013.966.246 1.334a.785.785 0 0 0 .22.24c.166.114.333.129.507.141.26.019.513-.045.764-.103l2.447-.566.003.001Zm8.219-3.911a4.185 4.185 0 0 0-.8-1.14 1.602 1.602 0 0 0-.275-.21 1.591 1.591 0 0 0-.15-.073.723.723 0 0 0-.621.031c-.142.07-.294.182-.496.37-.028.028-.063.06-.094.089-.167.156-.353.35-.574.575-.34.345-.677.691-1.01 1.042l-.598.62a2.79 2.79 0 0 0-.298.365 1 1 0 0 0-.157.364.813.813 0 0 0 .007.301c0 .005.002.009.003.013a.812.812 0 0 0 .945.616.774.774 0 0 0 .074-.014l3.185-.736c.251-.058.506-.112.732-.242.151-.088.295-.175.394-.35a.787.787 0 0 0 .093-.313c.05-.434-.178-.927-.36-1.308ZM6.706 7.523c.23-.29.23-.722.25-1.075.07-1.181.143-2.362.201-3.543.022-.448.07-.89.044-1.34-.022-.372-.025-.799-.26-1.104C6.528-.077 5.644-.033 5.04.05c-.185.025-.37.06-.553.104a7.589 7.589 0 0 0-.543.149c-.58.19-1.393.537-1.53 1.204-.078.377.106.763.249 1.107.173.417.41.792.625 1.185.57 1.036 1.15 2.066 1.728 3.097.172.308.36.697.695.857.022.01.045.018.068.025.15.057.313.068.469.032l.028-.007a.809.809 0 0 0 .377-.226.732.732 0 0 0 .053-.055Zm-.276 3.161a.737.737 0 0 0-.923-.234.976.976 0 0 0-.145.09 1.909 1.909 0 0 0-.346.354c-.026.033-.05.077-.08.104l-.512.705c-.29.395-.577.791-.861 1.193-.185.26-.346.479-.472.673l-.072.11c-.152.235-.238.406-.282.559a.73.73 0 0 0-.03.314c.013.11.05.217.108.312.031.047.064.093.1.138a1.548 1.548 0 0 0 .257.237 4.482 4.482 0 0 0 2.196.76 1.593 1.593 0 0 0 .349-.027 1.57 1.57 0 0 0 .163-.048.797.797 0 0 0 .278-.178.731.731 0 0 0 .17-.266c.059-.147.098-.335.123-.613l.012-.13c.02-.231.03-.502.045-.821.025-.49.044-.98.06-1.469l.033-.87a2.09 2.09 0 0 0-.055-.623.93.93 0 0 0-.117-.27Zm5.783 1.362a2.199 2.199 0 0 0-.498-.378l-.112-.067c-.199-.12-.438-.246-.719-.398-.43-.236-.86-.466-1.295-.695l-.767-.407c-.04-.012-.08-.04-.118-.059a1.908 1.908 0 0 0-.466-.166.993.993 0 0 0-.17-.018.738.738 0 0 0-.725.616.946.946 0 0 0 .01.293c.038.204.13.406.224.583l.41.768c.228.434.459.864.696 1.294.152.28.28.52.398.719.023.037.048.077.068.112.145.239.261.39.379.497a.73.73 0 0 0 .596.201 1.55 1.55 0 0 0 .168-.029 1.584 1.584 0 0 0 .325-.129 4.06 4.06 0 0 0 .855-.64c.306-.3.577-.63.788-1.006.03-.053.055-.109.076-.165a1.58 1.58 0 0 0 .051-.161c.013-.056.022-.111.029-.168a.792.792 0 0 0-.038-.327.73.73 0 0 0-.165-.27Z"
                }
            }
        ]
    })(props);
}
function BsYinYang(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.167 4.5a1.167 1.167 0 1 1-2.334 0 1.167 1.167 0 0 1 2.334 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM1 8a7 7 0 0 1 7-7 3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 0 0 7 7 7 0 0 1-7-7Zm7 4.667a1.167 1.167 0 1 1 0-2.334 1.167 1.167 0 0 1 0 2.334Z"
                }
            }
        ]
    })(props);
}
function BsYoutube(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z"
                }
            }
        ]
    })(props);
}
function BsZoomIn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.344 11.742c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1 6.538 6.538 0 0 1-1.398 1.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.5 3a.5.5 0 0 1 .5.5V6h2.5a.5.5 0 0 1 0 1H7v2.5a.5.5 0 0 1-1 0V7H3.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5z"
                }
            }
        ]
    })(props);
}
function BsZoomOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "currentColor",
            "viewBox": "0 0 16 16"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.344 11.742c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1 6.538 6.538 0 0 1-1.398 1.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M3 6.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"
                }
            }
        ]
    })(props);
}

},{"../lib":"hOIFC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3QrVY":[function(require,module,exports,__globalThis) {
// THIS FILE IS AUTO GENERATED
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GrAccessibility", ()=>GrAccessibility);
parcelHelpers.export(exports, "GrAchievement", ()=>GrAchievement);
parcelHelpers.export(exports, "GrAction", ()=>GrAction);
parcelHelpers.export(exports, "GrActions", ()=>GrActions);
parcelHelpers.export(exports, "GrAd", ()=>GrAd);
parcelHelpers.export(exports, "GrAddCircle", ()=>GrAddCircle);
parcelHelpers.export(exports, "GrAdd", ()=>GrAdd);
parcelHelpers.export(exports, "GrAdobeCreativeCloud", ()=>GrAdobeCreativeCloud);
parcelHelpers.export(exports, "GrAed", ()=>GrAed);
parcelHelpers.export(exports, "GrAggregate", ()=>GrAggregate);
parcelHelpers.export(exports, "GrAidOption", ()=>GrAidOption);
parcelHelpers.export(exports, "GrAid", ()=>GrAid);
parcelHelpers.export(exports, "GrAlarm", ()=>GrAlarm);
parcelHelpers.export(exports, "GrAlert", ()=>GrAlert);
parcelHelpers.export(exports, "GrAmazon", ()=>GrAmazon);
parcelHelpers.export(exports, "GrAmex", ()=>GrAmex);
parcelHelpers.export(exports, "GrAnalytics", ()=>GrAnalytics);
parcelHelpers.export(exports, "GrAnchor", ()=>GrAnchor);
parcelHelpers.export(exports, "GrAndroid", ()=>GrAndroid);
parcelHelpers.export(exports, "GrAnnounce", ()=>GrAnnounce);
parcelHelpers.export(exports, "GrAppleAppStore", ()=>GrAppleAppStore);
parcelHelpers.export(exports, "GrAppleMusic", ()=>GrAppleMusic);
parcelHelpers.export(exports, "GrApplePodcasts", ()=>GrApplePodcasts);
parcelHelpers.export(exports, "GrApple", ()=>GrApple);
parcelHelpers.export(exports, "GrAppsRounded", ()=>GrAppsRounded);
parcelHelpers.export(exports, "GrApps", ()=>GrApps);
parcelHelpers.export(exports, "GrArchive", ()=>GrArchive);
parcelHelpers.export(exports, "GrArchlinux", ()=>GrArchlinux);
parcelHelpers.export(exports, "GrArticle", ()=>GrArticle);
parcelHelpers.export(exports, "GrAruba", ()=>GrAruba);
parcelHelpers.export(exports, "GrAscend", ()=>GrAscend);
parcelHelpers.export(exports, "GrAscending", ()=>GrAscending);
parcelHelpers.export(exports, "GrAssistListening", ()=>GrAssistListening);
parcelHelpers.export(exports, "GrAtm", ()=>GrAtm);
parcelHelpers.export(exports, "GrAttachment", ()=>GrAttachment);
parcelHelpers.export(exports, "GrAttraction", ()=>GrAttraction);
parcelHelpers.export(exports, "GrBaby", ()=>GrBaby);
parcelHelpers.export(exports, "GrBackTen", ()=>GrBackTen);
parcelHelpers.export(exports, "GrBarChart", ()=>GrBarChart);
parcelHelpers.export(exports, "GrBar", ()=>GrBar);
parcelHelpers.export(exports, "GrBasket", ()=>GrBasket);
parcelHelpers.export(exports, "GrBeacon", ()=>GrBeacon);
parcelHelpers.export(exports, "GrBike", ()=>GrBike);
parcelHelpers.export(exports, "GrBitcoin", ()=>GrBitcoin);
parcelHelpers.export(exports, "GrBladesHorizontal", ()=>GrBladesHorizontal);
parcelHelpers.export(exports, "GrBladesVertical", ()=>GrBladesVertical);
parcelHelpers.export(exports, "GrBlockQuote", ()=>GrBlockQuote);
parcelHelpers.export(exports, "GrBlog", ()=>GrBlog);
parcelHelpers.export(exports, "GrBluetooth", ()=>GrBluetooth);
parcelHelpers.export(exports, "GrBold", ()=>GrBold);
parcelHelpers.export(exports, "GrBook", ()=>GrBook);
parcelHelpers.export(exports, "GrBookmark", ()=>GrBookmark);
parcelHelpers.export(exports, "GrBottomCorner", ()=>GrBottomCorner);
parcelHelpers.export(exports, "GrBraille", ()=>GrBraille);
parcelHelpers.export(exports, "GrBriefcase", ()=>GrBriefcase);
parcelHelpers.export(exports, "GrBrush", ()=>GrBrush);
parcelHelpers.export(exports, "GrBucket", ()=>GrBucket);
parcelHelpers.export(exports, "GrBug", ()=>GrBug);
parcelHelpers.export(exports, "GrBundle", ()=>GrBundle);
parcelHelpers.export(exports, "GrBus", ()=>GrBus);
parcelHelpers.export(exports, "GrBusinessService", ()=>GrBusinessService);
parcelHelpers.export(exports, "GrCafeteria", ()=>GrCafeteria);
parcelHelpers.export(exports, "GrCalculator", ()=>GrCalculator);
parcelHelpers.export(exports, "GrCalendar", ()=>GrCalendar);
parcelHelpers.export(exports, "GrCamera", ()=>GrCamera);
parcelHelpers.export(exports, "GrCapacity", ()=>GrCapacity);
parcelHelpers.export(exports, "GrCar", ()=>GrCar);
parcelHelpers.export(exports, "GrCaretDownFill", ()=>GrCaretDownFill);
parcelHelpers.export(exports, "GrCaretDown", ()=>GrCaretDown);
parcelHelpers.export(exports, "GrCaretLeftFill", ()=>GrCaretLeftFill);
parcelHelpers.export(exports, "GrCaretNext", ()=>GrCaretNext);
parcelHelpers.export(exports, "GrCaretPrevious", ()=>GrCaretPrevious);
parcelHelpers.export(exports, "GrCaretRightFill", ()=>GrCaretRightFill);
parcelHelpers.export(exports, "GrCaretUpFill", ()=>GrCaretUpFill);
parcelHelpers.export(exports, "GrCaretUp", ()=>GrCaretUp);
parcelHelpers.export(exports, "GrCart", ()=>GrCart);
parcelHelpers.export(exports, "GrCatalogOption", ()=>GrCatalogOption);
parcelHelpers.export(exports, "GrCatalog", ()=>GrCatalog);
parcelHelpers.export(exports, "GrCentos", ()=>GrCentos);
parcelHelpers.export(exports, "GrCertificate", ()=>GrCertificate);
parcelHelpers.export(exports, "GrChannel", ()=>GrChannel);
parcelHelpers.export(exports, "GrChapterAdd", ()=>GrChapterAdd);
parcelHelpers.export(exports, "GrChapterNext", ()=>GrChapterNext);
parcelHelpers.export(exports, "GrChapterPrevious", ()=>GrChapterPrevious);
parcelHelpers.export(exports, "GrChatOption", ()=>GrChatOption);
parcelHelpers.export(exports, "GrChat", ()=>GrChat);
parcelHelpers.export(exports, "GrCheckboxSelected", ()=>GrCheckboxSelected);
parcelHelpers.export(exports, "GrCheckbox", ()=>GrCheckbox);
parcelHelpers.export(exports, "GrCheckmark", ()=>GrCheckmark);
parcelHelpers.export(exports, "GrChrome", ()=>GrChrome);
parcelHelpers.export(exports, "GrCircleAlert", ()=>GrCircleAlert);
parcelHelpers.export(exports, "GrCircleInformation", ()=>GrCircleInformation);
parcelHelpers.export(exports, "GrCirclePlay", ()=>GrCirclePlay);
parcelHelpers.export(exports, "GrCircleQuestion", ()=>GrCircleQuestion);
parcelHelpers.export(exports, "GrClearOption", ()=>GrClearOption);
parcelHelpers.export(exports, "GrClear", ()=>GrClear);
parcelHelpers.export(exports, "GrCli", ()=>GrCli);
parcelHelpers.export(exports, "GrClipboard", ()=>GrClipboard);
parcelHelpers.export(exports, "GrClock", ()=>GrClock);
parcelHelpers.export(exports, "GrClone", ()=>GrClone);
parcelHelpers.export(exports, "GrClose", ()=>GrClose);
parcelHelpers.export(exports, "GrClosedCaption", ()=>GrClosedCaption);
parcelHelpers.export(exports, "GrCloudComputer", ()=>GrCloudComputer);
parcelHelpers.export(exports, "GrCloudDownload", ()=>GrCloudDownload);
parcelHelpers.export(exports, "GrCloudSoftware", ()=>GrCloudSoftware);
parcelHelpers.export(exports, "GrCloudUpload", ()=>GrCloudUpload);
parcelHelpers.export(exports, "GrCloud", ()=>GrCloud);
parcelHelpers.export(exports, "GrCloudlinux", ()=>GrCloudlinux);
parcelHelpers.export(exports, "GrCluster", ()=>GrCluster);
parcelHelpers.export(exports, "GrCoatCheck", ()=>GrCoatCheck);
parcelHelpers.export(exports, "GrCodeSandbox", ()=>GrCodeSandbox);
parcelHelpers.export(exports, "GrCode", ()=>GrCode);
parcelHelpers.export(exports, "GrCodepen", ()=>GrCodepen);
parcelHelpers.export(exports, "GrCoffee", ()=>GrCoffee);
parcelHelpers.export(exports, "GrColumns", ()=>GrColumns);
parcelHelpers.export(exports, "GrCommand", ()=>GrCommand);
parcelHelpers.export(exports, "GrCompare", ()=>GrCompare);
parcelHelpers.export(exports, "GrCompass", ()=>GrCompass);
parcelHelpers.export(exports, "GrCompliance", ()=>GrCompliance);
parcelHelpers.export(exports, "GrConfigure", ()=>GrConfigure);
parcelHelpers.export(exports, "GrConnect", ()=>GrConnect);
parcelHelpers.export(exports, "GrConnectivity", ()=>GrConnectivity);
parcelHelpers.export(exports, "GrConsole", ()=>GrConsole);
parcelHelpers.export(exports, "GrContactInfo", ()=>GrContactInfo);
parcelHelpers.export(exports, "GrContact", ()=>GrContact);
parcelHelpers.export(exports, "GrContract", ()=>GrContract);
parcelHelpers.export(exports, "GrCopy", ()=>GrCopy);
parcelHelpers.export(exports, "GrCpu", ()=>GrCpu);
parcelHelpers.export(exports, "GrCreativeCommons", ()=>GrCreativeCommons);
parcelHelpers.export(exports, "GrCreditCard", ()=>GrCreditCard);
parcelHelpers.export(exports, "GrCss3", ()=>GrCss3);
parcelHelpers.export(exports, "GrCube", ()=>GrCube);
parcelHelpers.export(exports, "GrCubes", ()=>GrCubes);
parcelHelpers.export(exports, "GrCurrency", ()=>GrCurrency);
parcelHelpers.export(exports, "GrCursor", ()=>GrCursor);
parcelHelpers.export(exports, "GrCut", ()=>GrCut);
parcelHelpers.export(exports, "GrCycle", ()=>GrCycle);
parcelHelpers.export(exports, "GrDashboard", ()=>GrDashboard);
parcelHelpers.export(exports, "GrDatabase", ()=>GrDatabase);
parcelHelpers.export(exports, "GrDebian", ()=>GrDebian);
parcelHelpers.export(exports, "GrDeliver", ()=>GrDeliver);
parcelHelpers.export(exports, "GrDeploy", ()=>GrDeploy);
parcelHelpers.export(exports, "GrDescend", ()=>GrDescend);
parcelHelpers.export(exports, "GrDescending", ()=>GrDescending);
parcelHelpers.export(exports, "GrDesktop", ()=>GrDesktop);
parcelHelpers.export(exports, "GrDetach", ()=>GrDetach);
parcelHelpers.export(exports, "GrDevice", ()=>GrDevice);
parcelHelpers.export(exports, "GrDiamond", ()=>GrDiamond);
parcelHelpers.export(exports, "GrDirections", ()=>GrDirections);
parcelHelpers.export(exports, "GrDisabledOutline", ()=>GrDisabledOutline);
parcelHelpers.export(exports, "GrDisc", ()=>GrDisc);
parcelHelpers.export(exports, "GrDislikeFill", ()=>GrDislikeFill);
parcelHelpers.export(exports, "GrDislike", ()=>GrDislike);
parcelHelpers.export(exports, "GrDocker", ()=>GrDocker);
parcelHelpers.export(exports, "GrDocumentCloud", ()=>GrDocumentCloud);
parcelHelpers.export(exports, "GrDocumentConfig", ()=>GrDocumentConfig);
parcelHelpers.export(exports, "GrDocumentCsv", ()=>GrDocumentCsv);
parcelHelpers.export(exports, "GrDocumentDownload", ()=>GrDocumentDownload);
parcelHelpers.export(exports, "GrDocumentExcel", ()=>GrDocumentExcel);
parcelHelpers.export(exports, "GrDocumentImage", ()=>GrDocumentImage);
parcelHelpers.export(exports, "GrDocumentLocked", ()=>GrDocumentLocked);
parcelHelpers.export(exports, "GrDocumentMissing", ()=>GrDocumentMissing);
parcelHelpers.export(exports, "GrDocumentNotes", ()=>GrDocumentNotes);
parcelHelpers.export(exports, "GrDocumentOutlook", ()=>GrDocumentOutlook);
parcelHelpers.export(exports, "GrDocumentPdf", ()=>GrDocumentPdf);
parcelHelpers.export(exports, "GrDocumentPerformance", ()=>GrDocumentPerformance);
parcelHelpers.export(exports, "GrDocumentPpt", ()=>GrDocumentPpt);
parcelHelpers.export(exports, "GrDocumentRtf", ()=>GrDocumentRtf);
parcelHelpers.export(exports, "GrDocumentSound", ()=>GrDocumentSound);
parcelHelpers.export(exports, "GrDocumentStore", ()=>GrDocumentStore);
parcelHelpers.export(exports, "GrDocumentTest", ()=>GrDocumentTest);
parcelHelpers.export(exports, "GrDocumentText", ()=>GrDocumentText);
parcelHelpers.export(exports, "GrDocumentThreat", ()=>GrDocumentThreat);
parcelHelpers.export(exports, "GrDocumentTime", ()=>GrDocumentTime);
parcelHelpers.export(exports, "GrDocumentTransfer", ()=>GrDocumentTransfer);
parcelHelpers.export(exports, "GrDocumentTxt", ()=>GrDocumentTxt);
parcelHelpers.export(exports, "GrDocumentUpdate", ()=>GrDocumentUpdate);
parcelHelpers.export(exports, "GrDocumentUpload", ()=>GrDocumentUpload);
parcelHelpers.export(exports, "GrDocumentUser", ()=>GrDocumentUser);
parcelHelpers.export(exports, "GrDocumentVerified", ()=>GrDocumentVerified);
parcelHelpers.export(exports, "GrDocumentVideo", ()=>GrDocumentVideo);
parcelHelpers.export(exports, "GrDocumentWindows", ()=>GrDocumentWindows);
parcelHelpers.export(exports, "GrDocumentWord", ()=>GrDocumentWord);
parcelHelpers.export(exports, "GrDocumentZip", ()=>GrDocumentZip);
parcelHelpers.export(exports, "GrDocument", ()=>GrDocument);
parcelHelpers.export(exports, "GrDomain", ()=>GrDomain);
parcelHelpers.export(exports, "GrDos", ()=>GrDos);
parcelHelpers.export(exports, "GrDown", ()=>GrDown);
parcelHelpers.export(exports, "GrDownloadOption", ()=>GrDownloadOption);
parcelHelpers.export(exports, "GrDownload", ()=>GrDownload);
parcelHelpers.export(exports, "GrDrag", ()=>GrDrag);
parcelHelpers.export(exports, "GrDrawer", ()=>GrDrawer);
parcelHelpers.export(exports, "GrDribbble", ()=>GrDribbble);
parcelHelpers.export(exports, "GrDriveCage", ()=>GrDriveCage);
parcelHelpers.export(exports, "GrDropbox", ()=>GrDropbox);
parcelHelpers.export(exports, "GrDuplicate", ()=>GrDuplicate);
parcelHelpers.export(exports, "GrDxc", ()=>GrDxc);
parcelHelpers.export(exports, "GrEbay", ()=>GrEbay);
parcelHelpers.export(exports, "GrEdge", ()=>GrEdge);
parcelHelpers.export(exports, "GrEdit", ()=>GrEdit);
parcelHelpers.export(exports, "GrEject", ()=>GrEject);
parcelHelpers.export(exports, "GrElevator", ()=>GrElevator);
parcelHelpers.export(exports, "GrEmergency", ()=>GrEmergency);
parcelHelpers.export(exports, "GrEmoji", ()=>GrEmoji);
parcelHelpers.export(exports, "GrEmptyCircle", ()=>GrEmptyCircle);
parcelHelpers.export(exports, "GrErase", ()=>GrErase);
parcelHelpers.export(exports, "GrEscalator", ()=>GrEscalator);
parcelHelpers.export(exports, "GrExpand", ()=>GrExpand);
parcelHelpers.export(exports, "GrEzmeral", ()=>GrEzmeral);
parcelHelpers.export(exports, "GrFacebookOption", ()=>GrFacebookOption);
parcelHelpers.export(exports, "GrFacebook", ()=>GrFacebook);
parcelHelpers.export(exports, "GrFanOption", ()=>GrFanOption);
parcelHelpers.export(exports, "GrFan", ()=>GrFan);
parcelHelpers.export(exports, "GrFastForward", ()=>GrFastForward);
parcelHelpers.export(exports, "GrFavorite", ()=>GrFavorite);
parcelHelpers.export(exports, "GrFedora", ()=>GrFedora);
parcelHelpers.export(exports, "GrFigma", ()=>GrFigma);
parcelHelpers.export(exports, "GrFilter", ()=>GrFilter);
parcelHelpers.export(exports, "GrFingerPrint", ()=>GrFingerPrint);
parcelHelpers.export(exports, "GrFireball", ()=>GrFireball);
parcelHelpers.export(exports, "GrFirefox", ()=>GrFirefox);
parcelHelpers.export(exports, "GrFirewall", ()=>GrFirewall);
parcelHelpers.export(exports, "GrFlagFill", ()=>GrFlagFill);
parcelHelpers.export(exports, "GrFlag", ()=>GrFlag);
parcelHelpers.export(exports, "GrFlows", ()=>GrFlows);
parcelHelpers.export(exports, "GrFolderCycle", ()=>GrFolderCycle);
parcelHelpers.export(exports, "GrFolderOpen", ()=>GrFolderOpen);
parcelHelpers.export(exports, "GrFolder", ()=>GrFolder);
parcelHelpers.export(exports, "GrFormAdd", ()=>GrFormAdd);
parcelHelpers.export(exports, "GrFormAttachment", ()=>GrFormAttachment);
parcelHelpers.export(exports, "GrFormCalendar", ()=>GrFormCalendar);
parcelHelpers.export(exports, "GrFormCheckmark", ()=>GrFormCheckmark);
parcelHelpers.export(exports, "GrFormClock", ()=>GrFormClock);
parcelHelpers.export(exports, "GrFormClose", ()=>GrFormClose);
parcelHelpers.export(exports, "GrFormCut", ()=>GrFormCut);
parcelHelpers.export(exports, "GrFormDown", ()=>GrFormDown);
parcelHelpers.export(exports, "GrFormEdit", ()=>GrFormEdit);
parcelHelpers.export(exports, "GrFormFilter", ()=>GrFormFilter);
parcelHelpers.export(exports, "GrFormFolder", ()=>GrFormFolder);
parcelHelpers.export(exports, "GrFormLocation", ()=>GrFormLocation);
parcelHelpers.export(exports, "GrFormLock", ()=>GrFormLock);
parcelHelpers.export(exports, "GrFormNextLink", ()=>GrFormNextLink);
parcelHelpers.export(exports, "GrFormNext", ()=>GrFormNext);
parcelHelpers.export(exports, "GrFormPin", ()=>GrFormPin);
parcelHelpers.export(exports, "GrFormPreviousLink", ()=>GrFormPreviousLink);
parcelHelpers.export(exports, "GrFormPrevious", ()=>GrFormPrevious);
parcelHelpers.export(exports, "GrFormRefresh", ()=>GrFormRefresh);
parcelHelpers.export(exports, "GrFormSchedule", ()=>GrFormSchedule);
parcelHelpers.export(exports, "GrFormSearch", ()=>GrFormSearch);
parcelHelpers.export(exports, "GrFormSubtract", ()=>GrFormSubtract);
parcelHelpers.export(exports, "GrFormTrash", ()=>GrFormTrash);
parcelHelpers.export(exports, "GrFormUp", ()=>GrFormUp);
parcelHelpers.export(exports, "GrFormUpload", ()=>GrFormUpload);
parcelHelpers.export(exports, "GrFormViewHide", ()=>GrFormViewHide);
parcelHelpers.export(exports, "GrFormView", ()=>GrFormView);
parcelHelpers.export(exports, "GrForwardTen", ()=>GrForwardTen);
parcelHelpers.export(exports, "GrFreebsd", ()=>GrFreebsd);
parcelHelpers.export(exports, "GrGallery", ()=>GrGallery);
parcelHelpers.export(exports, "GrGamepad", ()=>GrGamepad);
parcelHelpers.export(exports, "GrGateway", ()=>GrGateway);
parcelHelpers.export(exports, "GrGatsbyjs", ()=>GrGatsbyjs);
parcelHelpers.export(exports, "GrGem", ()=>GrGem);
parcelHelpers.export(exports, "GrGift", ()=>GrGift);
parcelHelpers.export(exports, "GrGithub", ()=>GrGithub);
parcelHelpers.export(exports, "GrGlobe", ()=>GrGlobe);
parcelHelpers.export(exports, "GrGolang", ()=>GrGolang);
parcelHelpers.export(exports, "GrGooglePay", ()=>GrGooglePay);
parcelHelpers.export(exports, "GrGooglePlay", ()=>GrGooglePlay);
parcelHelpers.export(exports, "GrGooglePlus", ()=>GrGooglePlus);
parcelHelpers.export(exports, "GrGoogleWallet", ()=>GrGoogleWallet);
parcelHelpers.export(exports, "GrGoogle", ()=>GrGoogle);
parcelHelpers.export(exports, "GrGraphQl", ()=>GrGraphQl);
parcelHelpers.export(exports, "GrGremlin", ()=>GrGremlin);
parcelHelpers.export(exports, "GrGrid", ()=>GrGrid);
parcelHelpers.export(exports, "GrGrommet", ()=>GrGrommet);
parcelHelpers.export(exports, "GrGroup", ()=>GrGroup);
parcelHelpers.export(exports, "GrGrow", ()=>GrGrow);
parcelHelpers.export(exports, "GrHadoop", ()=>GrHadoop);
parcelHelpers.export(exports, "GrHalt", ()=>GrHalt);
parcelHelpers.export(exports, "GrHelpBook", ()=>GrHelpBook);
parcelHelpers.export(exports, "GrHelpOption", ()=>GrHelpOption);
parcelHelpers.export(exports, "GrHelp", ()=>GrHelp);
parcelHelpers.export(exports, "GrHeroku", ()=>GrHeroku);
parcelHelpers.export(exports, "GrHide", ()=>GrHide);
parcelHelpers.export(exports, "GrHistory", ()=>GrHistory);
parcelHelpers.export(exports, "GrHomeOption", ()=>GrHomeOption);
parcelHelpers.export(exports, "GrHomeRounded", ()=>GrHomeRounded);
parcelHelpers.export(exports, "GrHome", ()=>GrHome);
parcelHelpers.export(exports, "GrHorton", ()=>GrHorton);
parcelHelpers.export(exports, "GrHostMaintenance", ()=>GrHostMaintenance);
parcelHelpers.export(exports, "GrHost", ()=>GrHost);
parcelHelpers.export(exports, "GrHp", ()=>GrHp);
parcelHelpers.export(exports, "GrHpeLabs", ()=>GrHpeLabs);
parcelHelpers.export(exports, "GrHpe", ()=>GrHpe);
parcelHelpers.export(exports, "GrHpi", ()=>GrHpi);
parcelHelpers.export(exports, "GrHtml5", ()=>GrHtml5);
parcelHelpers.export(exports, "GrIceCream", ()=>GrIceCream);
parcelHelpers.export(exports, "GrImage", ()=>GrImage);
parcelHelpers.export(exports, "GrImpact", ()=>GrImpact);
parcelHelpers.export(exports, "GrInProgress", ()=>GrInProgress);
parcelHelpers.export(exports, "GrInbox", ()=>GrInbox);
parcelHelpers.export(exports, "GrIndicator", ()=>GrIndicator);
parcelHelpers.export(exports, "GrInfo", ()=>GrInfo);
parcelHelpers.export(exports, "GrInherit", ()=>GrInherit);
parcelHelpers.export(exports, "GrInsecure", ()=>GrInsecure);
parcelHelpers.export(exports, "GrInspect", ()=>GrInspect);
parcelHelpers.export(exports, "GrInstagram", ()=>GrInstagram);
parcelHelpers.export(exports, "GrInstallOption", ()=>GrInstallOption);
parcelHelpers.export(exports, "GrInstall", ()=>GrInstall);
parcelHelpers.export(exports, "GrIntegration", ()=>GrIntegration);
parcelHelpers.export(exports, "GrInternetExplorer", ()=>GrInternetExplorer);
parcelHelpers.export(exports, "GrItalic", ()=>GrItalic);
parcelHelpers.export(exports, "GrIteration", ()=>GrIteration);
parcelHelpers.export(exports, "GrJava", ()=>GrJava);
parcelHelpers.export(exports, "GrJs", ()=>GrJs);
parcelHelpers.export(exports, "GrKey", ()=>GrKey);
parcelHelpers.export(exports, "GrKeyboard", ()=>GrKeyboard);
parcelHelpers.export(exports, "GrKubernetes", ()=>GrKubernetes);
parcelHelpers.export(exports, "GrLanguage", ()=>GrLanguage);
parcelHelpers.export(exports, "GrLastfm", ()=>GrLastfm);
parcelHelpers.export(exports, "GrLaunch", ()=>GrLaunch);
parcelHelpers.export(exports, "GrLayer", ()=>GrLayer);
parcelHelpers.export(exports, "GrLicense", ()=>GrLicense);
parcelHelpers.export(exports, "GrLikeFill", ()=>GrLikeFill);
parcelHelpers.export(exports, "GrLike", ()=>GrLike);
parcelHelpers.export(exports, "GrLineChart", ()=>GrLineChart);
parcelHelpers.export(exports, "GrLinkBottom", ()=>GrLinkBottom);
parcelHelpers.export(exports, "GrLinkDown", ()=>GrLinkDown);
parcelHelpers.export(exports, "GrLinkNext", ()=>GrLinkNext);
parcelHelpers.export(exports, "GrLinkPrevious", ()=>GrLinkPrevious);
parcelHelpers.export(exports, "GrLinkTop", ()=>GrLinkTop);
parcelHelpers.export(exports, "GrLinkUp", ()=>GrLinkUp);
parcelHelpers.export(exports, "GrLink", ()=>GrLink);
parcelHelpers.export(exports, "GrLinkedinOption", ()=>GrLinkedinOption);
parcelHelpers.export(exports, "GrLinkedin", ()=>GrLinkedin);
parcelHelpers.export(exports, "GrList", ()=>GrList);
parcelHelpers.export(exports, "GrLocal", ()=>GrLocal);
parcelHelpers.export(exports, "GrLocationPin", ()=>GrLocationPin);
parcelHelpers.export(exports, "GrLocation", ()=>GrLocation);
parcelHelpers.export(exports, "GrLock", ()=>GrLock);
parcelHelpers.export(exports, "GrLogin", ()=>GrLogin);
parcelHelpers.export(exports, "GrLogout", ()=>GrLogout);
parcelHelpers.export(exports, "GrLounge", ()=>GrLounge);
parcelHelpers.export(exports, "GrMagic", ()=>GrMagic);
parcelHelpers.export(exports, "GrMailOption", ()=>GrMailOption);
parcelHelpers.export(exports, "GrMail", ()=>GrMail);
parcelHelpers.export(exports, "GrMandriva", ()=>GrMandriva);
parcelHelpers.export(exports, "GrManual", ()=>GrManual);
parcelHelpers.export(exports, "GrMapLocation", ()=>GrMapLocation);
parcelHelpers.export(exports, "GrMap", ()=>GrMap);
parcelHelpers.export(exports, "GrMastercard", ()=>GrMastercard);
parcelHelpers.export(exports, "GrMedium", ()=>GrMedium);
parcelHelpers.export(exports, "GrMemory", ()=>GrMemory);
parcelHelpers.export(exports, "GrMenu", ()=>GrMenu);
parcelHelpers.export(exports, "GrMeta", ()=>GrMeta);
parcelHelpers.export(exports, "GrMicrofocus", ()=>GrMicrofocus);
parcelHelpers.export(exports, "GrMicrophone", ()=>GrMicrophone);
parcelHelpers.export(exports, "GrMoney", ()=>GrMoney);
parcelHelpers.export(exports, "GrMonitor", ()=>GrMonitor);
parcelHelpers.export(exports, "GrMonospace", ()=>GrMonospace);
parcelHelpers.export(exports, "GrMoon", ()=>GrMoon);
parcelHelpers.export(exports, "GrMoreVertical", ()=>GrMoreVertical);
parcelHelpers.export(exports, "GrMore", ()=>GrMore);
parcelHelpers.export(exports, "GrMouse", ()=>GrMouse);
parcelHelpers.export(exports, "GrMultimedia", ()=>GrMultimedia);
parcelHelpers.export(exports, "GrMultiple", ()=>GrMultiple);
parcelHelpers.export(exports, "GrMusic", ()=>GrMusic);
parcelHelpers.export(exports, "GrMysql", ()=>GrMysql);
parcelHelpers.export(exports, "GrNavigate", ()=>GrNavigate);
parcelHelpers.export(exports, "GrNetworkDrive", ()=>GrNetworkDrive);
parcelHelpers.export(exports, "GrNetwork", ()=>GrNetwork);
parcelHelpers.export(exports, "GrNewWindow", ()=>GrNewWindow);
parcelHelpers.export(exports, "GrNew", ()=>GrNew);
parcelHelpers.export(exports, "GrNext", ()=>GrNext);
parcelHelpers.export(exports, "GrNode", ()=>GrNode);
parcelHelpers.export(exports, "GrNodes", ()=>GrNodes);
parcelHelpers.export(exports, "GrNorton", ()=>GrNorton);
parcelHelpers.export(exports, "GrNote", ()=>GrNote);
parcelHelpers.export(exports, "GrNotes", ()=>GrNotes);
parcelHelpers.export(exports, "GrNotification", ()=>GrNotification);
parcelHelpers.export(exports, "GrNpm", ()=>GrNpm);
parcelHelpers.export(exports, "GrObjectGroup", ()=>GrObjectGroup);
parcelHelpers.export(exports, "GrObjectUngroup", ()=>GrObjectUngroup);
parcelHelpers.export(exports, "GrOfflineStorage", ()=>GrOfflineStorage);
parcelHelpers.export(exports, "GrOnedrive", ()=>GrOnedrive);
parcelHelpers.export(exports, "GrOpera", ()=>GrOpera);
parcelHelpers.export(exports, "GrOptimize", ()=>GrOptimize);
parcelHelpers.export(exports, "GrOracle", ()=>GrOracle);
parcelHelpers.export(exports, "GrOrderedList", ()=>GrOrderedList);
parcelHelpers.export(exports, "GrOrganization", ()=>GrOrganization);
parcelHelpers.export(exports, "GrOverview", ()=>GrOverview);
parcelHelpers.export(exports, "GrPackage", ()=>GrPackage);
parcelHelpers.export(exports, "GrPaint", ()=>GrPaint);
parcelHelpers.export(exports, "GrPan", ()=>GrPan);
parcelHelpers.export(exports, "GrPauseFill", ()=>GrPauseFill);
parcelHelpers.export(exports, "GrPause", ()=>GrPause);
parcelHelpers.export(exports, "GrPaypal", ()=>GrPaypal);
parcelHelpers.export(exports, "GrPerformance", ()=>GrPerformance);
parcelHelpers.export(exports, "GrPersonalComputer", ()=>GrPersonalComputer);
parcelHelpers.export(exports, "GrPhoneFlip", ()=>GrPhoneFlip);
parcelHelpers.export(exports, "GrPhoneHorizontal", ()=>GrPhoneHorizontal);
parcelHelpers.export(exports, "GrPhoneVertical", ()=>GrPhoneVertical);
parcelHelpers.export(exports, "GrPhone", ()=>GrPhone);
parcelHelpers.export(exports, "GrPieChart", ()=>GrPieChart);
parcelHelpers.export(exports, "GrPiedPiper", ()=>GrPiedPiper);
parcelHelpers.export(exports, "GrPin", ()=>GrPin);
parcelHelpers.export(exports, "GrPinterest", ()=>GrPinterest);
parcelHelpers.export(exports, "GrPlan", ()=>GrPlan);
parcelHelpers.export(exports, "GrPlayFill", ()=>GrPlayFill);
parcelHelpers.export(exports, "GrPlay", ()=>GrPlay);
parcelHelpers.export(exports, "GrPlug", ()=>GrPlug);
parcelHelpers.export(exports, "GrPocket", ()=>GrPocket);
parcelHelpers.export(exports, "GrPowerCycle", ()=>GrPowerCycle);
parcelHelpers.export(exports, "GrPowerForceShutdown", ()=>GrPowerForceShutdown);
parcelHelpers.export(exports, "GrPowerReset", ()=>GrPowerReset);
parcelHelpers.export(exports, "GrPowerShutdown", ()=>GrPowerShutdown);
parcelHelpers.export(exports, "GrPower", ()=>GrPower);
parcelHelpers.export(exports, "GrPrevious", ()=>GrPrevious);
parcelHelpers.export(exports, "GrPrint", ()=>GrPrint);
parcelHelpers.export(exports, "GrProductHunt", ()=>GrProductHunt);
parcelHelpers.export(exports, "GrProjects", ()=>GrProjects);
parcelHelpers.export(exports, "GrQr", ()=>GrQr);
parcelHelpers.export(exports, "GrRadialSelected", ()=>GrRadialSelected);
parcelHelpers.export(exports, "GrRadial", ()=>GrRadial);
parcelHelpers.export(exports, "GrRaspberry", ()=>GrRaspberry);
parcelHelpers.export(exports, "GrReactjs", ()=>GrReactjs);
parcelHelpers.export(exports, "GrReddit", ()=>GrReddit);
parcelHelpers.export(exports, "GrRedhat", ()=>GrRedhat);
parcelHelpers.export(exports, "GrRedo", ()=>GrRedo);
parcelHelpers.export(exports, "GrRefresh", ()=>GrRefresh);
parcelHelpers.export(exports, "GrResources", ()=>GrResources);
parcelHelpers.export(exports, "GrRestaurant", ()=>GrRestaurant);
parcelHelpers.export(exports, "GrRestroomMen", ()=>GrRestroomMen);
parcelHelpers.export(exports, "GrRestroomWomen", ()=>GrRestroomWomen);
parcelHelpers.export(exports, "GrRestroom", ()=>GrRestroom);
parcelHelpers.export(exports, "GrResume", ()=>GrResume);
parcelHelpers.export(exports, "GrReturn", ()=>GrReturn);
parcelHelpers.export(exports, "GrRevert", ()=>GrRevert);
parcelHelpers.export(exports, "GrRewind", ()=>GrRewind);
parcelHelpers.export(exports, "GrRisk", ()=>GrRisk);
parcelHelpers.export(exports, "GrRobot", ()=>GrRobot);
parcelHelpers.export(exports, "GrRotateLeft", ()=>GrRotateLeft);
parcelHelpers.export(exports, "GrRotateRight", ()=>GrRotateRight);
parcelHelpers.export(exports, "GrRss", ()=>GrRss);
parcelHelpers.export(exports, "GrRun", ()=>GrRun);
parcelHelpers.export(exports, "GrSafariOption", ()=>GrSafariOption);
parcelHelpers.export(exports, "GrSamsungPay", ()=>GrSamsungPay);
parcelHelpers.export(exports, "GrSans", ()=>GrSans);
parcelHelpers.export(exports, "GrSatellite", ()=>GrSatellite);
parcelHelpers.export(exports, "GrSave", ()=>GrSave);
parcelHelpers.export(exports, "GrScan", ()=>GrScan);
parcelHelpers.export(exports, "GrScheduleNew", ()=>GrScheduleNew);
parcelHelpers.export(exports, "GrSchedulePlay", ()=>GrSchedulePlay);
parcelHelpers.export(exports, "GrSchedule", ()=>GrSchedule);
parcelHelpers.export(exports, "GrSchedules", ()=>GrSchedules);
parcelHelpers.export(exports, "GrSco", ()=>GrSco);
parcelHelpers.export(exports, "GrScorecard", ()=>GrScorecard);
parcelHelpers.export(exports, "GrScript", ()=>GrScript);
parcelHelpers.export(exports, "GrSd", ()=>GrSd);
parcelHelpers.export(exports, "GrSearchAdvanced", ()=>GrSearchAdvanced);
parcelHelpers.export(exports, "GrSearch", ()=>GrSearch);
parcelHelpers.export(exports, "GrSecure", ()=>GrSecure);
parcelHelpers.export(exports, "GrSelect", ()=>GrSelect);
parcelHelpers.export(exports, "GrSelection", ()=>GrSelection);
parcelHelpers.export(exports, "GrSemantics", ()=>GrSemantics);
parcelHelpers.export(exports, "GrSend", ()=>GrSend);
parcelHelpers.export(exports, "GrServerCluster", ()=>GrServerCluster);
parcelHelpers.export(exports, "GrServer", ()=>GrServer);
parcelHelpers.export(exports, "GrServers", ()=>GrServers);
parcelHelpers.export(exports, "GrServicePlay", ()=>GrServicePlay);
parcelHelpers.export(exports, "GrServices", ()=>GrServices);
parcelHelpers.export(exports, "GrSettingsOption", ()=>GrSettingsOption);
parcelHelpers.export(exports, "GrShareOption", ()=>GrShareOption);
parcelHelpers.export(exports, "GrShareRounded", ()=>GrShareRounded);
parcelHelpers.export(exports, "GrShare", ()=>GrShare);
parcelHelpers.export(exports, "GrShieldSecurity", ()=>GrShieldSecurity);
parcelHelpers.export(exports, "GrShield", ()=>GrShield);
parcelHelpers.export(exports, "GrShift", ()=>GrShift);
parcelHelpers.export(exports, "GrShop", ()=>GrShop);
parcelHelpers.export(exports, "GrSidebar", ()=>GrSidebar);
parcelHelpers.export(exports, "GrSign", ()=>GrSign);
parcelHelpers.export(exports, "GrSkype", ()=>GrSkype);
parcelHelpers.export(exports, "GrSlack", ()=>GrSlack);
parcelHelpers.export(exports, "GrSnapchat", ()=>GrSnapchat);
parcelHelpers.export(exports, "GrSolaris", ()=>GrSolaris);
parcelHelpers.export(exports, "GrSort", ()=>GrSort);
parcelHelpers.export(exports, "GrSoundcloud", ()=>GrSoundcloud);
parcelHelpers.export(exports, "GrSpa", ()=>GrSpa);
parcelHelpers.export(exports, "GrSpectrum", ()=>GrSpectrum);
parcelHelpers.export(exports, "GrSplit", ()=>GrSplit);
parcelHelpers.export(exports, "GrSplits", ()=>GrSplits);
parcelHelpers.export(exports, "GrSpotify", ()=>GrSpotify);
parcelHelpers.export(exports, "GrSquare", ()=>GrSquare);
parcelHelpers.export(exports, "GrStackOverflow", ()=>GrStackOverflow);
parcelHelpers.export(exports, "GrStakeholder", ()=>GrStakeholder);
parcelHelpers.export(exports, "GrStarHalf", ()=>GrStarHalf);
parcelHelpers.export(exports, "GrStarOutline", ()=>GrStarOutline);
parcelHelpers.export(exports, "GrStar", ()=>GrStar);
parcelHelpers.export(exports, "GrStatusCriticalSmall", ()=>GrStatusCriticalSmall);
parcelHelpers.export(exports, "GrStatusCritical", ()=>GrStatusCritical);
parcelHelpers.export(exports, "GrStatusDisabledSmall", ()=>GrStatusDisabledSmall);
parcelHelpers.export(exports, "GrStatusDisabled", ()=>GrStatusDisabled);
parcelHelpers.export(exports, "GrStatusGoodSmall", ()=>GrStatusGoodSmall);
parcelHelpers.export(exports, "GrStatusGood", ()=>GrStatusGood);
parcelHelpers.export(exports, "GrStatusInfoSmall", ()=>GrStatusInfoSmall);
parcelHelpers.export(exports, "GrStatusInfo", ()=>GrStatusInfo);
parcelHelpers.export(exports, "GrStatusPlaceholderSmall", ()=>GrStatusPlaceholderSmall);
parcelHelpers.export(exports, "GrStatusPlaceholder", ()=>GrStatusPlaceholder);
parcelHelpers.export(exports, "GrStatusUnknownSmall", ()=>GrStatusUnknownSmall);
parcelHelpers.export(exports, "GrStatusUnknown", ()=>GrStatusUnknown);
parcelHelpers.export(exports, "GrStatusWarningSmall", ()=>GrStatusWarningSmall);
parcelHelpers.export(exports, "GrStatusWarning", ()=>GrStatusWarning);
parcelHelpers.export(exports, "GrStepsOption", ()=>GrStepsOption);
parcelHelpers.export(exports, "GrSteps", ()=>GrSteps);
parcelHelpers.export(exports, "GrStopFill", ()=>GrStopFill);
parcelHelpers.export(exports, "GrStop", ()=>GrStop);
parcelHelpers.export(exports, "GrStorage", ()=>GrStorage);
parcelHelpers.export(exports, "GrStreetView", ()=>GrStreetView);
parcelHelpers.export(exports, "GrStrikeThrough", ()=>GrStrikeThrough);
parcelHelpers.export(exports, "GrStripe", ()=>GrStripe);
parcelHelpers.export(exports, "GrSubscript", ()=>GrSubscript);
parcelHelpers.export(exports, "GrSubtractCircle", ()=>GrSubtractCircle);
parcelHelpers.export(exports, "GrSubtract", ()=>GrSubtract);
parcelHelpers.export(exports, "GrSun", ()=>GrSun);
parcelHelpers.export(exports, "GrSuperscript", ()=>GrSuperscript);
parcelHelpers.export(exports, "GrSupport", ()=>GrSupport);
parcelHelpers.export(exports, "GrSuse", ()=>GrSuse);
parcelHelpers.export(exports, "GrSwift", ()=>GrSwift);
parcelHelpers.export(exports, "GrSwim", ()=>GrSwim);
parcelHelpers.export(exports, "GrSwitch", ()=>GrSwitch);
parcelHelpers.export(exports, "GrSync", ()=>GrSync);
parcelHelpers.export(exports, "GrSystem", ()=>GrSystem);
parcelHelpers.export(exports, "GrTableAdd", ()=>GrTableAdd);
parcelHelpers.export(exports, "GrTable", ()=>GrTable);
parcelHelpers.export(exports, "GrTag", ()=>GrTag);
parcelHelpers.export(exports, "GrTapeOption", ()=>GrTapeOption);
parcelHelpers.export(exports, "GrTape", ()=>GrTape);
parcelHelpers.export(exports, "GrTarget", ()=>GrTarget);
parcelHelpers.export(exports, "GrTask", ()=>GrTask);
parcelHelpers.export(exports, "GrTasks", ()=>GrTasks);
parcelHelpers.export(exports, "GrTechnology", ()=>GrTechnology);
parcelHelpers.export(exports, "GrTemplate", ()=>GrTemplate);
parcelHelpers.export(exports, "GrTerminal", ()=>GrTerminal);
parcelHelpers.export(exports, "GrTestDesktop", ()=>GrTestDesktop);
parcelHelpers.export(exports, "GrTest", ()=>GrTest);
parcelHelpers.export(exports, "GrTextAlignCenter", ()=>GrTextAlignCenter);
parcelHelpers.export(exports, "GrTextAlignFull", ()=>GrTextAlignFull);
parcelHelpers.export(exports, "GrTextAlignLeft", ()=>GrTextAlignLeft);
parcelHelpers.export(exports, "GrTextAlignRight", ()=>GrTextAlignRight);
parcelHelpers.export(exports, "GrTextWrap", ()=>GrTextWrap);
parcelHelpers.export(exports, "GrThreads", ()=>GrThreads);
parcelHelpers.export(exports, "GrThreats", ()=>GrThreats);
parcelHelpers.export(exports, "GrThreeDEffects", ()=>GrThreeDEffects);
parcelHelpers.export(exports, "GrThreeD", ()=>GrThreeD);
parcelHelpers.export(exports, "GrTicket", ()=>GrTicket);
parcelHelpers.export(exports, "GrTiktok", ()=>GrTiktok);
parcelHelpers.export(exports, "GrTime", ()=>GrTime);
parcelHelpers.export(exports, "GrTip", ()=>GrTip);
parcelHelpers.export(exports, "GrToast", ()=>GrToast);
parcelHelpers.export(exports, "GrTools", ()=>GrTools);
parcelHelpers.export(exports, "GrTooltip", ()=>GrTooltip);
parcelHelpers.export(exports, "GrTopCorner", ()=>GrTopCorner);
parcelHelpers.export(exports, "GrTrain", ()=>GrTrain);
parcelHelpers.export(exports, "GrTransaction", ()=>GrTransaction);
parcelHelpers.export(exports, "GrTrash", ()=>GrTrash);
parcelHelpers.export(exports, "GrTreeOption", ()=>GrTreeOption);
parcelHelpers.export(exports, "GrTree", ()=>GrTree);
parcelHelpers.export(exports, "GrTrigger", ()=>GrTrigger);
parcelHelpers.export(exports, "GrTrophy", ()=>GrTrophy);
parcelHelpers.export(exports, "GrTroubleshoot", ()=>GrTroubleshoot);
parcelHelpers.export(exports, "GrTty", ()=>GrTty);
parcelHelpers.export(exports, "GrTumblr", ()=>GrTumblr);
parcelHelpers.export(exports, "GrTurbolinux", ()=>GrTurbolinux);
parcelHelpers.export(exports, "GrTwitch", ()=>GrTwitch);
parcelHelpers.export(exports, "GrTwitter", ()=>GrTwitter);
parcelHelpers.export(exports, "GrUbuntu", ()=>GrUbuntu);
parcelHelpers.export(exports, "GrUnderline", ()=>GrUnderline);
parcelHelpers.export(exports, "GrUndo", ()=>GrUndo);
parcelHelpers.export(exports, "GrUnlink", ()=>GrUnlink);
parcelHelpers.export(exports, "GrUnlock", ()=>GrUnlock);
parcelHelpers.export(exports, "GrUnorderedList", ()=>GrUnorderedList);
parcelHelpers.export(exports, "GrUnsorted", ()=>GrUnsorted);
parcelHelpers.export(exports, "GrUp", ()=>GrUp);
parcelHelpers.export(exports, "GrUpdate", ()=>GrUpdate);
parcelHelpers.export(exports, "GrUpgrade", ()=>GrUpgrade);
parcelHelpers.export(exports, "GrUploadOption", ()=>GrUploadOption);
parcelHelpers.export(exports, "GrUpload", ()=>GrUpload);
parcelHelpers.export(exports, "GrUsbKey", ()=>GrUsbKey);
parcelHelpers.export(exports, "GrUserAdd", ()=>GrUserAdd);
parcelHelpers.export(exports, "GrUserAdmin", ()=>GrUserAdmin);
parcelHelpers.export(exports, "GrUserExpert", ()=>GrUserExpert);
parcelHelpers.export(exports, "GrUserFemale", ()=>GrUserFemale);
parcelHelpers.export(exports, "GrUserManager", ()=>GrUserManager);
parcelHelpers.export(exports, "GrUserNew", ()=>GrUserNew);
parcelHelpers.export(exports, "GrUserPolice", ()=>GrUserPolice);
parcelHelpers.export(exports, "GrUserSettings", ()=>GrUserSettings);
parcelHelpers.export(exports, "GrUserWorker", ()=>GrUserWorker);
parcelHelpers.export(exports, "GrUser", ()=>GrUser);
parcelHelpers.export(exports, "GrValidate", ()=>GrValidate);
parcelHelpers.export(exports, "GrVend", ()=>GrVend);
parcelHelpers.export(exports, "GrVenmo", ()=>GrVenmo);
parcelHelpers.export(exports, "GrVideo", ()=>GrVideo);
parcelHelpers.export(exports, "GrView", ()=>GrView);
parcelHelpers.export(exports, "GrVimeo", ()=>GrVimeo);
parcelHelpers.export(exports, "GrVirtualMachine", ()=>GrVirtualMachine);
parcelHelpers.export(exports, "GrVirtualStorage", ()=>GrVirtualStorage);
parcelHelpers.export(exports, "GrVisa", ()=>GrVisa);
parcelHelpers.export(exports, "GrVmMaintenance", ()=>GrVmMaintenance);
parcelHelpers.export(exports, "GrVmware", ()=>GrVmware);
parcelHelpers.export(exports, "GrVolumeControl", ()=>GrVolumeControl);
parcelHelpers.export(exports, "GrVolumeLow", ()=>GrVolumeLow);
parcelHelpers.export(exports, "GrVolumeMute", ()=>GrVolumeMute);
parcelHelpers.export(exports, "GrVolume", ()=>GrVolume);
parcelHelpers.export(exports, "GrVulnerability", ()=>GrVulnerability);
parcelHelpers.export(exports, "GrWaypoint", ()=>GrWaypoint);
parcelHelpers.export(exports, "GrWebcam", ()=>GrWebcam);
parcelHelpers.export(exports, "GrWechat", ()=>GrWechat);
parcelHelpers.export(exports, "GrWhatsapp", ()=>GrWhatsapp);
parcelHelpers.export(exports, "GrWheelchairActive", ()=>GrWheelchairActive);
parcelHelpers.export(exports, "GrWheelchair", ()=>GrWheelchair);
parcelHelpers.export(exports, "GrWifiLow", ()=>GrWifiLow);
parcelHelpers.export(exports, "GrWifiMedium", ()=>GrWifiMedium);
parcelHelpers.export(exports, "GrWifiNone", ()=>GrWifiNone);
parcelHelpers.export(exports, "GrWifi", ()=>GrWifi);
parcelHelpers.export(exports, "GrWindowsLegacy", ()=>GrWindowsLegacy);
parcelHelpers.export(exports, "GrWindows", ()=>GrWindows);
parcelHelpers.export(exports, "GrWordpress", ()=>GrWordpress);
parcelHelpers.export(exports, "GrWorkshop", ()=>GrWorkshop);
parcelHelpers.export(exports, "GrX", ()=>GrX);
parcelHelpers.export(exports, "GrXing", ()=>GrXing);
parcelHelpers.export(exports, "GrYoga", ()=>GrYoga);
parcelHelpers.export(exports, "GrYoutube", ()=>GrYoutube);
parcelHelpers.export(exports, "GrZoomIn", ()=>GrZoomIn);
parcelHelpers.export(exports, "GrZoomOut", ()=>GrZoomOut);
parcelHelpers.export(exports, "GrZoom", ()=>GrZoom);
var _lib = require("../lib");
function GrAccessibility(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "2",
                    "d": "M4,8 L11,8 L11,14 L7,21 M20,8 L13,8 L13,14 L17,21 M12,5 C12.5522847,5 13,4.55228475 13,4 C13,3.44771525 12.5522847,3 12,3 C11.4477153,3 11,3.44771525 11,4 C11,4.55228475 11.4477153,5 12,5 Z M11,8 L13,8 L13,13 L11,13 L11,8 Z"
                }
            }
        ]
    })(props);
}
function GrAchievement(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M10.3248685,14.7630919 C7.82620532,14.038202 6,11.7325889 6,9 L6,1 L18,1 L18,10 M6,3 L1,3 L1,7 C1,9.509 2.791,11 5,11 L6,11 M20.0335555,10.884915 C21.7416567,10.4908882 23,9.10306372 23,7 L23,3 L18,3 M10,19 L5,19 L5,23 L16.5,23 M16.5,10 C12.9101429,10 10,12.9101429 10,16.5 C10,20.0898571 12.9101429,23 16.5,23 C20.0898571,23 23,20.0898571 23,16.5 C23,12.9101429 20.0898571,10 16.5,10 L16.5,10 Z M20,14 L15.5,18.5 L13,16 M10.2056405,15.4240751 C8.89754812,16.0817472 8,17.4360568 8,19"
                }
            }
        ]
    })(props);
}
function GrAction(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,23 L4,20 L1,23 Z M20,4 L23,1 L20,4 Z M9,11 L12,8 L9,11 Z M13,15 L16,12 L13,15 Z M10,5 L19,14 L20,13 C22,11 24.0533047,8.00000006 20,4 C15.9466953,-5.91784286e-08 13,2 11,4 L10,5 Z M4,11 L5,10 L14,19 L13,20 C11.0000005,22 7.9999999,24.0873857 4,20 C9.84858655e-08,15.9126143 2,13 4,11 Z"
                }
            }
        ]
    })(props);
}
function GrActions(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,17.5 C15.0375661,17.5 17.5,15.0375661 17.5,12 C17.5,8.96243388 15.0375661,6.5 12,6.5 C8.96243388,6.5 6.5,8.96243388 6.5,12 C6.5,15.0375661 8.96243388,17.5 12,17.5 Z M12,6.5 L12,1 M12,23 L12,17.5 M1,12 L6.5,12 M17.5,12 L23,12 M4.4375,4.4375 L8.5625,8.5625 M15.4375,15.4375 L19.5625,19.5625 M19.5625,4.4375 L15.4375,8.5625 M8.5625,15.4375 L4.4375,19.5625"
                }
            }
        ]
    })(props);
}
function GrAd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "2",
                    "d": "M10,10 L14,10 L14,14 L10,14 L10,10 Z M14,18 L10,18 C7.790861,18 6,16.209139 6,14 L6,10 C6,7.790861 7.790861,6 10,6 L10,6 L14,6 C16.209139,6 18,7.790861 18,10 L18,14 M14,22 L10,22 C5.581722,22 2,18.418278 2,14 L2,10 C2,5.581722 5.581722,2 10,2 L10,2 L14,2 C18.418278,2 22,5.581722 22,10 L22,14"
                }
            }
        ]
    })(props);
}
function GrAddCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M12,18 L12,6 M6,12 L18,12"
                }
            }
        ]
    })(props);
}
function GrAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,22 L12,2 M2,12 L22,12"
                }
            }
        ]
    })(props);
}
function GrAdobeCreativeCloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M24 11.456v.79c-.008.043-.017.085-.022.128-.04.343-.067.69-.124 1.03a8.433 8.433 0 0 1-1.176 3.093 8.793 8.793 0 0 1-3.645 3.303 8.527 8.527 0 0 1-2.812.83c-.217.025-.434.047-.652.071H7.138c-.043-.008-.085-.02-.128-.023a7.19 7.19 0 0 1-2.448-.588C2.865 19.347 1.6 18.143.771 16.486a7.088 7.088 0 0 1-.7-2.33L0 13.563v-.767c.008-.043.02-.085.023-.128a7.062 7.062 0 0 1 .461-2.139C1.2 8.68 2.45 7.31 4.222 6.42a7.323 7.323 0 0 1 2.928-.756 8.132 8.132 0 0 1 1.503.069.19.19 0 0 0 .142-.046 8.892 8.892 0 0 1 2.457-1.781 8.6 8.6 0 0 1 2.826-.833c.234-.027.467-.049.7-.073h.72c.046.007.094.016.14.021.357.042.715.068 1.068.127a8.46 8.46 0 0 1 3.073 1.166 8.794 8.794 0 0 1 3.319 3.652c.438.883.719 1.835.83 2.814.026.226.048.45.072.676ZM10.58 6.343c.015.02.019.028.025.031.493.243.965.529 1.41.853.028.02.098.012.132-.01 1.222-.774 2.547-1.041 3.97-.789 1.395.247 2.53.944 3.397 2.057.982 1.26 1.357 2.684 1.085 4.27-.181 1.061-.607 2.014-1.33 2.812-1.32 1.456-2.972 2.057-4.917 1.803a5.191 5.191 0 0 1-3.086-1.538c-1.098-1.11-2.204-2.211-3.305-3.318-.147-.147-.31-.265-.521-.291a.829.829 0 0 0-.864.47c-.142.296-.124.63.185.934 1.227 1.205 2.444 2.421 3.67 3.627.21.208.435.4.674.573.896.65 1.906 1.01 3 1.155a7.22 7.22 0 0 0 2.555-.1 7.082 7.082 0 0 0 4-2.455 7.034 7.034 0 0 0 1.576-3.609 7.072 7.072 0 0 0-.065-2.32c-.244-1.251-.773-2.37-1.62-3.322-1.618-1.816-3.653-2.627-6.074-2.446a6.747 6.747 0 0 0-2.641.777 6.97 6.97 0 0 0-1.255.836ZM9.989 19.02l-.1-.093c-.501-.474-1.006-.945-1.502-1.425a.407.407 0 0 0-.32-.135c-.502.012-1.005.015-1.5-.097-2.461-.557-3.89-3.233-2.983-5.587.715-1.857 2.696-2.988 4.649-2.639.875.156 1.644.527 2.275 1.177.769.794 1.56 1.566 2.338 2.352.177.179.38.26.626.225.316-.045.569-.196.683-.507a.749.749 0 0 0-.173-.83c-.816-.826-1.613-1.673-2.462-2.465-1.647-1.536-3.588-1.992-5.736-1.34-2.888.878-4.579 3.86-3.919 6.804a5.816 5.816 0 0 0 5.691 4.566h2.299c.038 0 .076-.003.134-.006Z"
                }
            }
        ]
    })(props);
}
function GrAed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2,8.4 C2,4 5,3 7,3 C9,3 11,5 12,6.5 C13,5 15,3 17,3 C19,3 22,4 22,8.4 C22,15 12,21 12,21 C12,21 2,15 2,8.4 Z M12,6 C11.5,5.5 10,10 10,10 L12,10 L12,12.5 L14,9 L12,9 C12,9 13,3 17,3 C13,3 12,6 12,6 Z"
                }
            }
        ]
    })(props);
}
function GrAggregate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M16,9 L9,9 L9,16 L9,16 C9,19.8659932 12.1340068,23 16,23 L16,23 C19.8659932,23 23,19.8659932 23,16 C23,12.1340068 19.8659932,9 16,9 L16,9 Z M8,15 L15,15 L15,8 L15,8 C15,4.13400675 11.8659932,1 8,1 L8,1 C4.13400675,1 1,4.13400675 1,8 C1,11.8659932 4.13400675,15 8,15 L8,15 Z",
                    "transform": "rotate(180 12 12)"
                }
            }
        ]
    })(props);
}
function GrAidOption(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,9 L12,19 L12,9 Z M17,14 L7,14 L17,14 Z M1,6.99508929 C1,5.8932319 1.88967395,5 2.991155,5 L21.008845,5 C22.1085295,5 23,5.8926228 23,6.99508929 L23,21.0049107 C23,22.1067681 22.1103261,23 21.008845,23 L2.991155,23 C1.89147046,23 1,22.1073772 1,21.0049107 L1,6.99508929 Z M7,5 L7,2.0093689 C7,1.45190985 7.4556644,1 7.99539757,1 L16.0046024,1 C16.5543453,1 17,1.44335318 17,2.0093689 L17,5"
                }
            }
        ]
    })(props);
}
function GrAid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,22 L23,22 L23,6 L1,6 L1,22 Z M8,6 L16,6 L16,2 L8,2 L8,6 Z M8,14 L16,14 M12,10 L12,18"
                }
            }
        ]
    })(props);
}
function GrAlarm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M21,13 C21,17.971 16.971,22 12,22 C7.029,22 3,17.971 3,13 C3,8.029 7.029,4 12,4 C16.971,4 21,8.029 21,13 L21,13 Z M5.5,19.5 L2,23 L5.5,19.5 Z M18.5,19.5 L22,23 L18.5,19.5 Z M9,4 C8.29078014,2.90780142 6.88179669,2 5,2 C2.90070922,2 1,3.90070922 1,6 C1,7.88179669 1.90780142,9.29078014 3,10 M21,10 C22.0921986,9.29078014 23,7.88179669 23,6 C23,3.90070922 21.0992908,2 19,2 C17.1182033,2 15.7092199,2.90780142 15,4 M12,8 L12,13 L15,16"
                }
            }
        ]
    })(props);
}
function GrAlert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,17 L12,19 M12,10 L12,16 M12,3 L2,22 L22,22 L12,3 Z"
                }
            }
        ]
    })(props);
}
function GrAmazon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.9924596,23.9397465 C8.83711397,23.9185077 6.03567124,22.8789612 3.53203329,20.9850151 C2.63838806,20.3088366 1.82646601,19.5437784 1.08564773,18.7032301 C1.0593301,18.6732188 1.01408224,18.6445926 1.01108111,18.6122727 C0.999538287,18.4963828 1.00253942,18.3793386 1,18.2627561 C1.10019169,18.278916 1.21815932,18.2662189 1.29780479,18.3156222 C1.96751928,18.7327798 2.61183957,19.1935692 3.29817573,19.5802537 C5.2872347,20.7005999 7.41480753,21.4266434 9.67581537,21.7720046 C10.8557226,21.9520726 12.0409395,22.0114027 13.2256946,21.9426075 C15.4894728,21.8114811 17.6530592,21.2481914 19.7120677,20.2936001 C20.0373444,20.1428508 20.3561571,19.9780193 20.6756624,19.8152656 C20.8303362,19.7363127 20.9829323,19.7039928 21.1142896,19.8425066 C21.2530343,19.9886387 21.247032,20.165013 21.1503032,20.3279977 C21.0948977,20.4217254 21.0106351,20.5020634 20.9279885,20.5757066 C19.0869085,22.2092467 16.9334797,23.2123179 14.5316495,23.6788787 C13.7001046,23.8404782 12.8480135,23.8958838 12.0051567,24 C12.0010013,23.9799155 11.996615,23.959831 11.9924596,23.9397465 M20.882048,18.8454608 C20.4263375,18.8890927 19.9207619,18.9387268 19.4149554,18.9848981 C19.3041444,18.9950558 19.1914864,19.0015197 19.0806753,18.9948249 C18.9532426,18.9872066 18.9329272,18.9087155 19.0026459,18.8159112 C19.0442,18.7605056 19.1065313,18.718028 19.1653996,18.6783207 C19.7005248,18.3191081 20.3062921,18.1618949 20.9339907,18.0787866 C21.5298312,17.9998337 22.124979,18.0183022 22.7074298,18.1743612 C23.1005783,18.2796317 23.186226,18.3269573 23.1569073,18.7845147 C23.0793395,19.9902778 22.691039,21.086615 21.8167857,21.9673322 C21.7719996,22.0125801 21.7297528,22.0707559 21.6743473,22.0926873 C21.6004732,22.1217752 21.5148255,22.1213135 21.4342566,22.1335489 C21.4361035,22.0601365 21.4208669,21.9809528 21.4427983,21.9142353 C21.6512617,21.2800727 21.8689593,20.6489112 22.0762683,20.0145177 C22.1178225,19.8873158 22.1335207,19.750418 22.1494498,19.6165213 C22.2002382,19.1887443 22.0291736,18.9735861 21.575079,18.9070995 C21.3631528,18.8761647 21.1479946,18.8683156 20.882048,18.8454608 M13.9965473,9.42010077 C13.1377614,9.41525279 12.3166051,9.45242067 11.5310007,9.71582785 C11.142931,9.84603088 10.7495517,10.0110932 10.4155024,10.2426422 C9.49276931,10.8818837 9.25267863,11.8334739 9.32863039,12.8935666 C9.36879941,13.4550094 9.53755546,13.9746672 9.95171189,14.381898 C10.5401649,14.9604242 11.5307698,15.0363759 12.3260702,14.5663522 C13.0193321,14.1565821 13.4325651,13.5242663 13.7008203,12.7873726 C14.0960465,11.7021166 13.9716148,10.5713818 13.9965473,9.42010077 M14.6290939,15.7725771 C14.3204389,16.0535293 14.0353312,16.3183217 13.744683,16.5768809 C12.627107,17.5707178 11.3066083,18.0146547 9.82427914,18.0444352 C9.01951364,18.0605951 8.22929209,17.9998799 7.47600757,17.7023059 C6.13427002,17.1720287 5.2787161,16.1915815 4.93173889,14.8002098 C4.5009608,13.0722494 4.64640035,11.4084672 5.66886346,9.89797358 C6.4246874,8.7815519 7.51779258,8.11783967 8.77988467,7.71153236 C9.86283216,7.36293915 10.983871,7.2101122 12.1092961,7.08406459 C12.726837,7.01480766 13.3450705,6.953169 13.9928536,6.88506635 C13.9734617,6.11169732 14.0833494,5.33578887 13.8116313,4.5880449 C13.5708481,3.92571782 13.0622714,3.58520459 12.3976357,3.43283935 C11.3913326,3.20221378 10.250671,3.57758633 9.70977435,4.37103986 C9.52624349,4.64044931 9.41404727,4.9684963 9.31547158,5.28407703 C9.17649601,5.72870651 8.97195721,5.87345349 8.51024436,5.81850966 C7.60782659,5.71162313 6.70333111,5.62297427 5.80091334,5.51747288 C5.35328272,5.46483761 5.17575413,5.20997212 5.26301786,4.77503861 C5.65986006,2.79567561 6.80629307,1.4123839 8.67207471,0.684262729 C10.8742142,-0.174984891 13.1252952,-0.241702398 15.3569843,0.578992199 C17.2063751,1.25909523 18.2221434,2.61445331 18.3574252,4.59243118 C18.402904,5.26006796 18.4093679,5.9311676 18.4121382,6.60088209 C18.4192948,8.33299786 18.4276056,10.0651136 18.4093679,11.7969985 C18.3992103,12.7615167 18.6667729,13.6175323 19.2531482,14.3791277 C19.3939706,14.5624277 19.5366399,14.7461894 19.6559926,14.9433408 C19.8538366,15.2702335 19.8009705,15.5181733 19.5149394,15.7649588 C18.7780456,16.4007374 18.0425371,17.0383629 17.3074902,17.67645 C16.9027989,18.0275826 16.6223083,18.0227347 16.2153085,17.6799129 C15.679029,17.2281268 15.2385549,16.6964645 14.8583344,16.1110126 C14.7890775,16.0043569 14.715896,15.9002407 14.6290939,15.7725771"
                }
            }
        ]
    })(props);
}
function GrAmex(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.31351102,11.9651322 L3.49408345,9.96838176 L2.67933919,11.9651322 L4.31351102,11.9651322 Z M12.1730058,14.1264026 L12.1684736,10.2036046 L10.4324776,14.1264026 L9.38130189,14.1264026 L7.64077369,10.2001299 L7.64077369,14.1264026 L5.20575645,14.1264026 L4.74573489,13.0092074 L2.25300723,13.0092074 L1.78830236,14.1264026 L0.488004966,14.1264026 L2.63190183,9.11768179 L4.41065186,9.11768179 L6.44683267,13.8599073 L6.44683267,9.11768179 L8.40082901,9.11768179 L9.96762165,12.5154962 L11.4069075,9.11768179 L13.4001832,9.11768179 L13.4001832,14.1264026 L12.1730058,14.1264026 Z M15.3055732,13.1015049 L15.3055732,12.104716 L17.9339657,12.104716 L17.9339657,11.0825466 L15.3055732,11.0825466 L15.3055732,10.171719 L18.3071194,10.171719 L19.6166324,11.6317021 L18.2491069,13.1015049 L15.3055732,13.1015049 Z M23.4171068,14.1455801 L21.8614469,14.1455801 L20.3872629,12.4870853 L18.8552174,14.1455801 L14.1129918,14.1455801 L14.1129918,9.13565077 L18.9281863,9.13565077 L20.4011617,10.7778295 L21.9239917,9.13565077 L23.488005,9.13565077 L21.1613628,11.6406155 L23.4171068,14.1455801 Z"
                }
            }
        ]
    })(props);
}
function GrAnalytics(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M20,7 C21.25,8.67 22,10.75 22,13 C22,18.52 17.52,23 12,23 C6.48,23 2,18.52 2,13 C2,7.48 6.48,3 12,3 M12,1 L12,13 L21.6,5.8 C19.41,2.89 15.92,1 12,1 L12,1 Z"
                }
            }
        ]
    })(props);
}
function GrAnchor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,6 C13.1045695,6 14,5.1045695 14,4 C14,2.8954305 13.1045695,2 12,2 C10.8954305,2 10,2.8954305 10,4 C10,5.1045695 10.8954305,6 12,6 Z M20,17 C20.5522847,17 21,16.5522847 21,16 C21,15.4477153 20.5522847,15 20,15 C19.4477153,15 19,15.4477153 19,16 C19,16.5522847 19.4477153,17 20,17 Z M4,17 C4.55228475,17 5,16.5522847 5,16 C5,15.4477153 4.55228475,15 4,15 C3.44771525,15 3,15.4477153 3,16 C3,16.5522847 3.44771525,17 4,17 Z M12,6 L12,21 L12,21 M4,15.9733241 C6.19364176,19.3244414 8.86035276,21 12.000133,21 C15.1399132,21 17.8065356,19.3244414 20,15.9733241 M16,10 L8,10"
                }
            }
        ]
    })(props);
}
function GrAndroid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.68524564,7.91390616 L18.4032637,7.91390616 L18.4032637,18.2777185 C18.4032637,18.8934049 17.9041016,19.392567 17.2891666,19.392567 L16.0152889,19.392567 L16.0152889,22.54887 C16.0152889,23.3504036 15.3759782,24 14.5867968,24 C13.7955958,24 13.1572245,23.3504036 13.1572245,22.54887 L13.1572245,19.392567 L10.9323651,19.392567 L10.9323651,22.54887 C10.9323651,23.3504036 10.2917863,24 9.50265183,24 C8.71365828,24 8.07312646,23.3504036 8.07312646,22.54887 L8.07312646,19.392567 L6.80037593,19.392567 C6.18530006,19.392567 5.68519867,18.8934049 5.68519867,18.2777185 L5.68519867,7.91390616 L5.68524564,7.91390616 Z M3.19295784,7.82931914 C2.39574512,7.82931914 1.75,8.48511514 1.75,9.2946801 L1.75,15.0216583 C1.75,15.8302839 2.39574512,16.4872071 3.19295784,16.4872071 C3.99031146,16.4872071 4.63591568,15.8302839 4.63591568,15.0216583 L4.63591568,9.2946801 C4.63591568,8.48511514 3.99031146,7.82931914 3.19295784,7.82931914 L3.19295784,7.82931914 Z M18.4033106,6.86955468 L5.68524564,6.86955468 C5.84220834,5.05767343 7.01754994,3.49847301 8.70952521,2.59567916 L7.50032062,0.820150132 C7.33725225,0.580713909 7.39877862,0.254013563 7.63868451,0.0909921564 C7.8783086,-0.07202925 8.20435141,-0.0100332096 8.36821822,0.229215147 L9.68615071,2.16574601 C10.4168586,1.91306518 11.2100322,1.76798505 12.0442547,1.76798505 C12.8794634,1.76798505 13.672684,1.91306518 14.4033449,2.16607478 L15.7212774,0.229919647 C15.8831246,-0.00998624287 16.2102007,-0.0719822833 16.4498248,0.0910391231 C16.6897307,0.25406053 16.7512571,0.580760876 16.5881887,0.820197099 L15.3799704,2.59572613 C17.0718987,3.49795638 18.2464419,5.0571568 18.4033106,6.86955468 L18.4033106,6.86955468 Z M10.0653129,4.40760737 C10.0653129,4.01905189 9.75068296,3.70390535 9.36226837,3.70390535 C8.97286748,3.70390535 8.65823758,4.01905189 8.65823758,4.40760737 C8.65823758,4.79597499 8.97390075,5.11098063 9.36226837,5.11098063 C9.75063599,5.11098063 10.0653129,4.79597499 10.0653129,4.40760737 L10.0653129,4.40760737 Z M15.5194145,4.40760737 C15.5194145,4.01905189 15.2037044,3.70390535 14.8153837,3.70390535 C14.4259828,3.70390535 14.1122923,4.01905189 14.1122923,4.40760737 C14.1122923,4.79597499 14.4259828,5.11098063 14.8153837,5.11098063 C15.2037514,5.11098063 15.5194145,4.79597499 15.5194145,4.40760737 L15.5194145,4.40760737 Z M20.8965378,7.82729957 C20.1001704,7.82729957 19.4525936,8.48408187 19.4525936,9.2936938 L19.4525936,15.0226915 C19.4525936,15.8323035 20.1001704,16.4892736 20.8965378,16.4892736 C21.6939384,16.4892736 22.3384623,15.8323504 22.3384623,15.0226915 L22.3384623,9.2936938 C22.3385093,8.48408187 21.6939384,7.82729957 20.8965378,7.82729957 L20.8965378,7.82729957 Z"
                }
            }
        ]
    })(props);
}
function GrAnnounce(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M11,15 C14,15 19,19 19,19 L19,3 C19,3 14,7 11,7 C11,7 11,15 11,15 Z M5,15 L8,23 L12,23 L9,15 M19,14 C20.657,14 22,12.657 22,11 C22,9.343 20.657,8 19,8 M11,19 C11.9999997,18.9999994 14,18 14,16 M2,11 C2,7.88888889 3.7912,7 6,7 L11,7 L11,15 L6,15 C3.7912,15 2,14.1111111 2,11 Z"
                }
            }
        ]
    })(props);
}
function GrAppleAppStore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3,17 C2.44771525,17 2,16.5522847 2,16 C2,15.4477153 2.44771525,15 3,15 L13.5,15 C14.5,15 15.5,17 15,17 L3,17 Z M17,17 C16.4477153,17 16,16.5522847 16,16 C16,15.4477153 16.4477153,15 17,15 L21,15 C21.5522847,15 22,15.4477153 22,16 C22,16.5522847 21.5522847,17 21,17 L17,17 Z M12.6333775,3.50103556 C12.908948,3.02241319 13.5203421,2.85780709 13.9989644,3.13337754 C14.4775868,3.408948 14.6421929,4.02034208 14.3666225,4.49896444 L7.45953351,16.4954873 C7.18396306,16.9741097 6.57256898,17.1387158 6.09394661,16.8631454 C5.61532424,16.5875749 5.45071815,15.9761808 5.7262886,15.4975585 L12.6333775,3.50103556 Z M4,18.5 C4.5,17.5 7.5,16.5 6.5,18.2208385 C6.32221095,18.5267848 5.77775177,19.4528267 4.86662246,20.9989644 C4.591052,21.4775868 3.97965792,21.6421929 3.50103556,21.3666225 C3.02241319,21.091052 2.85780709,20.4796579 3.13337754,20.0010356 L4,18.5 Z M9.13337754,4.49896444 C8.85780709,4.02034208 9.02241319,3.408948 9.50103556,3.13337754 C9.97965792,2.85780709 10.591052,3.02241319 10.8666225,3.50103556 L12.6104584,6.52980328 C12.8860289,7.00842564 12.7214228,7.61981972 12.2428004,7.89539018 C11.764178,8.17096063 11.152784,8.00635453 10.8772135,7.52773217 L9.13337754,4.49896444 Z M13,11.5 C12.1018662,10 13,7 13.7163439,8.49589818 L20.3666225,20.0010356 C20.6421929,20.4796579 20.4775868,21.091052 19.9989644,21.3666225 C19.5203421,21.6421929 18.908948,21.4775868 18.6333775,20.9989644 L13,11.5 Z"
                }
            }
        ]
    })(props);
}
function GrAppleMusic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "clipPath": "url(#a)"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "fillRule": "evenodd",
                            "d": "M21.992 22.816c.768-.592 1.304-1.424 1.536-2.016.464-1.192.472-2.544.472-3.4V6.6c0-.848 0-2.208-.472-3.4-.232-.592-.776-1.432-1.536-2.016a4.99 4.99 0 0 0-1.688-.88C19.528.08 18.584 0 17.4 0H6.6C5.416 0 4.472.08 3.696.304a5.137 5.137 0 0 0-1.688.88C1.24 1.776.704 2.608.472 3.2.008 4.392 0 5.744 0 6.6v10.8c0 .856.008 2.208.472 3.4.232.592.776 1.432 1.536 2.016.44.344.968.664 1.688.88.776.224 1.72.304 2.904.304h10.8c1.184 0 2.136-.072 2.904-.304a5.137 5.137 0 0 0 1.688-.88Zm-5.706-19.05c.062-.013.576-.104.634-.11.385-.033.6.22.6.63v11.289c0 .303-.003.577-.067.881a2.212 2.212 0 0 1-.348.821 2.087 2.087 0 0 1-.655.606 2.605 2.605 0 0 1-.831.303c-.552.11-.93.136-1.284.065a1.791 1.791 0 0 1-.864-.44 1.88 1.88 0 0 1-.604-1.184 1.886 1.886 0 0 1 .51-1.488c.197-.207.445-.37.776-.499.347-.134.729-.215 1.317-.333l.464-.094c.205-.041.379-.093.52-.265.142-.173.144-.384.144-.593V8.084c0-.404-.182-.514-.566-.44-.276.054-6.19 1.247-6.19 1.247-.333.08-.45.19-.45.603v7.722c0 .303-.015.578-.08.882a2.213 2.213 0 0 1-.348.82 2.088 2.088 0 0 1-.654.606 2.613 2.613 0 0 1-.831.307c-.552.112-.93.136-1.284.065a1.792 1.792 0 0 1-.864-.443 1.863 1.863 0 0 1-.59-1.184 1.874 1.874 0 0 1 .496-1.488c.197-.208.445-.371.776-.5.347-.134.729-.214 1.317-.333l.464-.093c.204-.042.379-.094.52-.266.14-.172.157-.374.157-.582V6.104c0-.12.01-.201.016-.241a.724.724 0 0 1 .24-.462.992.992 0 0 1 .443-.2h.003l7.113-1.435Z",
                            "clipRule": "evenodd"
                        }
                    }
                ]
            },
            {
                "tag": "defs",
                "attr": {},
                "child": [
                    {
                        "tag": "linearGradient",
                        "attr": {
                            "id": "b",
                            "x1": "12",
                            "x2": "12",
                            "y1": "23.907",
                            "y2": ".517",
                            "gradientUnits": "userSpaceOnUse"
                        },
                        "child": [
                            {
                                "tag": "stop",
                                "attr": {
                                    "stopColor": "#FA233B"
                                }
                            },
                            {
                                "tag": "stop",
                                "attr": {
                                    "offset": "1",
                                    "stopColor": "#FB5C74"
                                }
                            }
                        ]
                    },
                    {
                        "tag": "clipPath",
                        "attr": {
                            "id": "a"
                        },
                        "child": [
                            {
                                "tag": "path",
                                "attr": {
                                    "d": "M0 0h24v24H0z"
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    })(props);
}
function GrApplePodcasts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "clipPath": "url(#a)"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "fillRule": "evenodd",
                            "d": "M21.992 22.816c.768-.592 1.304-1.424 1.536-2.016.464-1.192.472-2.544.472-3.4V6.6c0-.848 0-2.208-.472-3.4-.232-.592-.776-1.432-1.536-2.016a4.99 4.99 0 0 0-1.688-.88C19.528.08 18.584 0 17.4 0H6.6C5.416 0 4.472.08 3.696.304a5.137 5.137 0 0 0-1.688.88C1.24 1.776.704 2.608.472 3.2.008 4.392 0 5.744 0 6.6v10.8c0 .856.008 2.208.472 3.4.232.592.776 1.432 1.536 2.016.44.344.968.664 1.688.88.776.224 1.72.304 2.904.304h10.8c1.184 0 2.136-.072 2.904-.304a5.137 5.137 0 0 0 1.688-.88ZM3.56 10.992c.064-4.592 3.824-8.32 8.416-8.336 4.664-.008 8.464 3.784 8.48 8.44 0 3.68-2.36 6.816-5.648 7.968-.08.032-.168-.032-.152-.12l.12-.864a.272.272 0 0 1 .168-.232c2.6-1.144 4.424-3.736 4.424-6.752 0-4.08-3.336-7.392-7.424-7.36-3.992.032-7.256 3.288-7.296 7.288a7.365 7.365 0 0 0 4.424 6.824.317.317 0 0 1 .168.232c.021.192.05.384.078.576l.042.288c.008.08-.072.152-.152.12-3.32-1.168-5.696-4.352-5.648-8.072Zm10.408-.584c0 1.088-.88 1.968-1.968 1.968a1.967 1.967 0 0 1-1.968-1.968c0-1.088.88-1.968 1.968-1.968s1.968.888 1.968 1.968Zm.088 4.08a1.069 1.069 0 0 0-.32-.688c-.36-.376-.992-.624-1.736-.624s-1.376.24-1.736.624c-.184.2-.288.4-.32.688-.064.558-.024 1.037.04 1.807v.009c.064.736.184 1.72.336 2.712.112.712.2 1.096.28 1.368.136.448.624.832 1.4.832.776 0 1.272-.392 1.4-.832.08-.272.168-.656.28-1.368.152-1 .272-1.976.336-2.712.072-.776.104-1.256.04-1.816Zm-2.272-9.032c-2.992.112-5.392 2.584-5.432 5.576a5.65 5.65 0 0 0 2.472 4.744c.072.048.176-.008.176-.096a7.853 7.853 0 0 1-.008-.968.326.326 0 0 0-.112-.272 4.574 4.574 0 0 1-1.448-3.456 4.585 4.585 0 0 1 4.392-4.448 4.574 4.574 0 0 1 4.752 4.568c0 1.312-.56 2.496-1.448 3.336a.381.381 0 0 0-.112.272c.016.312.008.616-.008.96-.008.088.096.152.176.096a5.661 5.661 0 0 0 2.472-4.672c.008-3.184-2.656-5.768-5.872-5.64Z",
                            "clipRule": "evenodd"
                        }
                    }
                ]
            },
            {
                "tag": "defs",
                "attr": {},
                "child": [
                    {
                        "tag": "linearGradient",
                        "attr": {
                            "id": "b",
                            "x1": "12",
                            "x2": "12",
                            "y1": "0",
                            "y2": "24",
                            "gradientUnits": "userSpaceOnUse"
                        },
                        "child": [
                            {
                                "tag": "stop",
                                "attr": {
                                    "stopColor": "#F452FF"
                                }
                            },
                            {
                                "tag": "stop",
                                "attr": {
                                    "offset": "1",
                                    "stopColor": "#832BC1"
                                }
                            }
                        ]
                    },
                    {
                        "tag": "clipPath",
                        "attr": {
                            "id": "a"
                        },
                        "child": [
                            {
                                "tag": "path",
                                "attr": {
                                    "d": "M0 0h24v24H0z"
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    })(props);
}
function GrApple(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.3007013,3.832 C16.1387013,2.818 16.7027013,1.405 16.5487013,0 C15.3407013,0.049 13.8797013,0.805 13.0137013,1.819 C12.2367013,2.717 11.5567013,4.154 11.7407013,5.531 C13.0867013,5.636 14.4627013,4.847 15.3007013,3.832 M18.3207013,12.75 C18.3547013,16.382 21.5067013,17.591 21.5417013,17.607 C21.5157013,17.692 21.0387013,19.329 19.8807013,21.02 C18.8807013,22.482 17.8427013,23.939 16.2067013,23.969 C14.5997013,23.998 14.0837013,23.016 12.2457013,23.016 C10.4097013,23.016 9.83570131,23.939 8.31370131,23.998 C6.73570131,24.058 5.53370131,22.417 4.52470131,20.961 C2.46370131,17.981 0.888701307,12.541 3.00370131,8.869 C4.05470131,7.045 5.93170131,5.89 7.96970131,5.861 C9.51970131,5.831 10.9827013,6.904 11.9307013,6.904 C12.8777013,6.904 14.6557013,5.614 16.5247013,5.803 C17.3077013,5.836 19.5037013,6.119 20.9147013,8.184 C20.8007013,8.254 18.2937013,9.714 18.3207013,12.75"
                }
            }
        ]
    })(props);
}
function GrAppsRounded(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinejoin": "round",
                    "strokeWidth": "2",
                    "d": "M3 6.2c0-1.12 0-1.68.218-2.108a2 2 0 01.874-.874C4.52 3 5.08 3 6.2 3h.6c1.12 0 1.68 0 2.108.218a2 2 0 01.874.874C10 4.52 10 5.08 10 6.2v.6c0 1.12 0 1.68-.218 2.108a2 2 0 01-.874.874C8.48 10 7.92 10 6.8 10h-.6c-1.12 0-1.68 0-2.108-.218a2 2 0 01-.874-.874C3 8.48 3 7.92 3 6.8v-.6zM14 6.2c0-1.12 0-1.68.218-2.108a2 2 0 01.874-.874C15.52 3 16.08 3 17.2 3h.6c1.12 0 1.68 0 2.108.218a2 2 0 01.874.874C21 4.52 21 5.08 21 6.2v.6c0 1.12 0 1.68-.218 2.108a2 2 0 01-.874.874C19.48 10 18.92 10 17.8 10h-.6c-1.12 0-1.68 0-2.108-.218a2 2 0 01-.874-.874C14 8.48 14 7.92 14 6.8v-.6zM3 17.2c0-1.12 0-1.68.218-2.108a2 2 0 01.874-.874C4.52 14 5.08 14 6.2 14h.6c1.12 0 1.68 0 2.108.218a2 2 0 01.874.874C10 15.52 10 16.08 10 17.2v.6c0 1.12 0 1.68-.218 2.108a2 2 0 01-.874.874C8.48 21 7.92 21 6.8 21h-.6c-1.12 0-1.68 0-2.108-.218a2 2 0 01-.874-.874C3 19.48 3 18.92 3 17.8v-.6zM14 17.2c0-1.12 0-1.68.218-2.108a2 2 0 01.874-.874C15.52 14 16.08 14 17.2 14h.6c1.12 0 1.68 0 2.108.218a2 2 0 01.874.874C21 15.52 21 16.08 21 17.2v.6c0 1.12 0 1.68-.218 2.108a2 2 0 01-.874.874C19.48 21 18.92 21 17.8 21h-.6c-1.12 0-1.68 0-2.108-.218a2 2 0 01-.874-.874C14 19.48 14 18.92 14 17.8v-.6z"
                }
            }
        ]
    })(props);
}
function GrApps(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M19,5 L21,5 L21,3 L19,3 L19,5 Z M11,5 L13,5 L13,3 L11,3 L11,5 Z M3,5 L5,5 L5,3 L3,3 L3,5 Z M19,13 L21,13 L21,11 L19,11 L19,13 Z M11,13 L13,13 L13,11 L11,11 L11,13 Z M3,13 L5,13 L5,11 L3,11 L3,13 Z M19,21 L21,21 L21,19 L19,19 L19,21 Z M11,21 L13,21 L13,19 L11,19 L11,21 Z M3,21 L5,21 L5,19 L3,19 L3,21 Z"
                }
            }
        ]
    })(props);
}
function GrArchive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M3,23 L21,23 L21,6 L3,6 L3,23 Z M9,14 L15,14 L15,10 L9,10 L9,14 Z M1,6 L23,6 L23,1 L1,1 L1,6 Z"
                }
            }
        ]
    })(props);
}
function GrArchlinux(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.995499,0 C10.9272763,2.61898783 10.2829772,4.33212022 9.09364861,6.87325951 C9.82285899,7.64621596 10.7179267,8.54636058 12.1714997,9.56299285 C10.6087581,8.91993273 9.54277553,8.27431817 8.74615646,7.60436135 C7.22404876,10.7804724 4.83934636,15.3047005 0,24 C3.8035621,21.8041428 6.75200705,20.4503725 9.49981901,19.9338097 C9.38183641,19.4263273 9.31474077,18.8773854 9.31929729,18.3046251 L9.32381903,18.1827747 C9.38418076,15.7459387 10.6518189,13.8720119 12.1534614,13.9992474 C13.6551031,14.1264836 14.8223099,16.2062608 14.7619552,18.6430989 C14.7506091,19.1016345 14.6988943,19.5427398 14.6085152,19.9518612 C17.3264906,20.483546 20.2434156,21.8338506 23.9955134,24 C23.2556658,22.6379048 22.5952972,21.4100753 21.9646676,20.2406911 C20.9713321,19.4707837 19.9352208,18.4687462 17.8217601,17.3839783 C19.2744348,17.7614433 20.3145182,18.1969375 21.1252451,18.6837145 C14.7134752,6.74608943 14.1942543,5.15982659 11.995499,0 L11.995499,0 Z"
                }
            }
        ]
    })(props);
}
function GrArticle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M16,7 L19,7 L19,11 L16,11 L16,7 Z M9,15 L20,15 M9,11 L13,11 M9,7 L13,7 M6,18.5 C6,19.8807119 4.88071187,21 3.5,21 C2.11928813,21 1,19.8807119 1,18.5 L1,7 L6.02493781,7 M6,18.5 L6,3 L23,3 L23,18.5 C23,19.8807119 21.8807119,21 20.5,21 L3.5,21"
                }
            }
        ]
    })(props);
}
function GrAruba(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.1099561,17.3015551 C9.03598293,17.3015551 6.50849391,14.8423766 6.50849391,11.836714 C6.50849391,8.83105139 9.03598293,6.37187289 12.1099561,6.37187289 C15.1839292,6.37187289 17.7114182,8.83105139 17.7114182,11.836714 C17.7114182,14.8423766 15.1839292,17.3015551 12.1099561,17.3015551 L12.1099561,17.3015551 Z M12.1099561,2 C6.50849391,2 2,6.4401834 2,11.836714 C2,17.3015551 6.50849391,21.673428 12.1099561,21.673428 C14.4325135,21.673428 16.5501395,20.9220123 18.2579023,19.6241126 C19.28256,21.3318754 22.2199121,21.673428 22.2199121,21.673428 L22.2199121,11.836714 C22.2199121,6.4401834 17.7114182,2 12.1099561,2 L12.1099561,2 Z"
                }
            }
        ]
    })(props);
}
function GrAscend(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2,8 L8,2 L14,8 M11,21 L22,21 M11,17 L19,17 M11,13 L16,13 M8,2 L8,22"
                }
            }
        ]
    })(props);
}
function GrAscending(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.0809 7.28641L12.4345 6.93286L12.788 7.28641L17 11.4984L16.2929 12.2055L12.9345 8.84707V16.9999H11.9345V8.84707L8.57605 12.2055L7.86895 11.4984L12.0809 7.28641Z"
                }
            }
        ]
    })(props);
}
function GrAssistListening(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "2",
                    "d": "M11,21 C11.7572165,21.6666667 12.4238831,22 13,22 C15,22 16,21 16,19 C16,17.6666667 16.6666667,16.3333333 18,15 C19.2667508,13.7332492 20,11.9329966 20,10 C20,6.13400675 16.8659932,3 13,3 C9.13400675,3 6,6.13400675 6,10 M17,10 C17,7.790861 15.209139,6 13,6 C10.790861,6 9,7.790861 9,10 M3,20 L8,14 L9,18 L14,12"
                }
            }
        ]
    })(props);
}
function GrAtm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4,10 L1,10 L1,6 L23,6 L23,10 L20,10 M6,6 L18,6 L18,20.0059397 C18,21.1072288 17.0980496,22 15.9914698,22 L8.0085302,22 C6.8992496,22 6,21.1054862 6,20.0059397 L6,6 Z M13,18 L16,18 M13,15 L16,15 M13,12 L16,12 M10,22 L10,6 M3,2 L6,2 M8,2 L11,2 M13,2 L16,2 M18,2 L21,2"
                }
            }
        ]
    })(props);
}
function GrAttachment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M22,12 C22,12 19.0000009,15.0000004 13.0000004,21.0000004 C6.99999996,27.0000004 -2.00000007,18.0000004 3.99999994,12.0000004 C9.99999996,6.00000037 9,7.00000011 13,3.00000008 C17,-0.999999955 23,4.99999994 19,9.00000005 C15,13.0000002 12.0000004,16.0000007 9.99999995,18.0000004 C7.99999952,20 5,17 6.99999995,15.0000004 C8.99999991,13.0000007 16,6 16,6"
                }
            }
        ]
    })(props);
}
function GrAttraction(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M13,2 L14.5,2.5 L13,3 L13,2 Z M14,18 L15,23 L13,23 L14,18 Z M14,16.5 L16,23 L12,23 L14,16.5 Z M12,6 L21,11 L21,13 L3,13 L3,11 L12,6 Z M4.5,13 L19.5,13 C19.5,17.1666667 21,23 21,23 L3,23 C3,23 4.5,17.1666667 4.5,13 Z M4.5,13 L19.5,13 C19.5,17.1666667 21,23 21,23 L3,23 C3,23 4.5,17.1666667 4.5,13 Z"
                }
            }
        ]
    })(props);
}
function GrBaby(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "2",
                    "d": "M10,15 L14,15 C14,15 13,16.5 12,16.5 C11,16.5 10,15 10,15 Z M12,6 C12.5522847,6 13,5.55228475 13,5 C13,4.44771525 12.5522847,4 12,4 C11.4477153,4 11,4.44771525 11,5 C11,5.55228475 11.4477153,6 12,6 Z M18,12 L14,9 M14,15 L17,17.5 L14.5,20 M6,12 L10,9 M10,15 L7.5,17.75 L10,20 M10,9 L14,9 L14,12 L10,12 L10,9 Z"
                }
            }
        ]
    })(props);
}
function GrBackTen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M3.11111111,7.55555556 C4.66955145,4.26701301 8.0700311,2 12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 L12,22 C6.4771525,22 2,17.5228475 2,12 M2,4 L2,8 L6,8 M9,16 L9,9 L7,9.53333333 M17,12 C17,10 15.9999999,8.5 14.5,8.5 C13.0000001,8.5 12,10 12,12 C12,14 13,15.5000001 14.5,15.5 C16,15.4999999 17,14 17,12 Z M14.5,8.5 C16.9253741,8.5 17,11 17,12 C17,13 17,15.5 14.5,15.5 C12,15.5 12,13 12,12 C12,11 12.059,8.5 14.5,8.5 Z"
                }
            }
        ]
    })(props);
}
function GrBarChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M0,22 L24,22 M22,2 L18,2 L18,18 L22,18 L22,2 Z M6,6 L2,6 L2,18 L6,18 L6,6 Z M14,18 L10,18 L10,10 L14,10 L14,18 Z"
                }
            }
        ]
    })(props);
}
function GrBar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M7,5 L23,5 L23,23 L7,23 L7,5 Z M7,5 L23,5 L23,3 C23,1.8954305 22.1054862,1 21.0059397,1 L8.99406028,1 C7.8927712,1 7,1.88772964 7,3 L7,5 Z M1,8.0085302 C1,6.8992496 1.89826062,6 2.99791312,6 L7,6 L7,18 L2.99791312,18 C1.89449617,18 1,17.0980496 1,15.9914698 L1,8.0085302 Z M11,8 L11,18 M15,8 L15,18 M19,8 L19,18"
                }
            }
        ]
    })(props);
}
function GrBasket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2,12 L22,12 L20,23 L4,23 L2,12 Z M20,8 L14,1 M4,8 L10,1 M1,8 L23,8 L23,12 L1,12 L1,8 Z M8,15 L8,20 M16,15 L16,20 M12,15 L12,20"
                }
            }
        ]
    })(props);
}
function GrBeacon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeWidth": "2",
                    "d": "M12 12a3 3 0 100-6 3 3 0 000 6zm0 0v11M7.05 4.05A6.978 6.978 0 005 9c0 1.933.784 3.683 2.05 4.95m9.9 0A6.978 6.978 0 0019 9a6.978 6.978 0 00-2.05-4.95M4.222 1.222A10.966 10.966 0 001 9c0 3.037 1.231 5.787 3.222 7.778m15.556 0A10.966 10.966 0 0023 9c0-3.038-1.231-5.788-3.222-7.778"
                }
            }
        ]
    })(props);
}
function GrBike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M5,19 C7.209139,19 9,17.209139 9,15 C9,12.790861 7.209139,11 5,11 C2.790861,11 1,12.790861 1,15 C1,17.209139 2.790861,19 5,19 Z M19,19 C21.209139,19 23,17.209139 23,15 C23,12.790861 21.209139,11 19,11 C16.790861,11 15,12.790861 15,15 C15,17.209139 16.790861,19 19,19 Z M5,6 L10,6 M19,15 L16,5 L13,5 M9,9 L5,15 L12,15 C12,12 14,9 17,9 L16,9 L9,9 Z M9,9 L7,6"
                }
            }
        ]
    })(props);
}
function GrBitcoin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M23.6408156,14.9046858 C22.0378949,21.3339956 15.5260763,25.2467873 9.09601649,23.6434916 C2.66858193,22.0405708 -1.24420981,15.5283772 0.359460996,9.09944253 C1.96163164,2.66938268 8.47345019,-1.24378409 14.9016348,0.359136628 C21.3313196,1.96205735 25.2437363,8.47500102 23.6408156,14.9046858 L23.6408156,14.9046858 Z M17.2913894,10.2916945 C17.5302898,8.69477443 16.3144103,7.83630799 14.6518582,7.263622 L15.1911657,5.1003916 L13.8744004,4.77223165 L13.3493445,6.87845598 C13.0031826,6.79219679 12.6476448,6.71081312 12.2943571,6.63017953 L12.8231635,4.51007873 L11.5071483,4.18191878 L10.9674658,6.3443991 C10.6809353,6.27914215 10.3996553,6.21463528 10.1266263,6.14675305 L10.1281264,6.14000233 L8.31218301,5.68657903 L7.9618957,7.09297883 C7.9618957,7.09297883 8.93887476,7.31687767 8.91824756,7.33075415 C9.45155436,7.46389333 9.54793963,7.81680592 9.53181291,8.09658572 L8.91749748,10.5609732 C8.9542514,10.5703492 9.00188147,10.5838506 9.05438706,10.6048529 C9.01050739,10.5939767 8.96362739,10.5819754 8.91524724,10.5703492 L8.05415553,14.0225919 C7.98889858,14.1846091 7.82350596,14.427635 7.45071626,14.3353752 C7.46384266,14.3545022 6.49361432,14.0964747 6.49361432,14.0964747 L5.8399197,15.6037603 L7.5534772,16.0309308 C7.87226116,16.1108143 8.18466943,16.1944482 8.49220218,16.2732066 L7.94726915,18.4611896 L9.26253423,18.7893496 L9.80221671,16.624619 C10.161505,16.7221294 10.5102921,16.812139 10.8515785,16.896898 L10.3137712,19.0515025 L11.6305364,19.3796624 L12.1754695,17.1958048 C14.4208336,17.6207251 16.1092634,17.4493318 16.8199641,15.4184905 C17.3926501,13.7833164 16.7914611,12.8400909 15.6100853,12.2250254 C16.4704269,12.0266293 17.1184959,11.460694 17.2913894,10.2916945 L17.2913894,10.2916945 Z M14.2828189,14.5105188 C13.8759006,16.145693 11.1227324,15.2617238 10.2301373,15.0400752 L10.9532143,12.1413915 C11.8458094,12.3641652 14.7081142,12.8052122 14.2828189,14.5105188 L14.2828189,14.5105188 Z M14.6901123,10.268067 C14.3188228,11.7554754 12.0273287,10.9997699 11.2839995,10.8145002 L11.9395694,8.18547018 C12.6828985,8.37073991 15.0767785,8.71652674 14.6901123,10.268067 L14.6901123,10.268067 Z"
                }
            }
        ]
    })(props);
}
function GrBladesHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeWidth": "2",
                    "d": "M3 17h4m3 0h4m3 0h4M4 21h2a1 1 0 001-1V4a1 1 0 00-1-1H4a1 1 0 00-1 1v16a1 1 0 001 1zm7 0h2a1 1 0 001-1V4a1 1 0 00-1-1h-2a1 1 0 00-1 1v16a1 1 0 001 1zm7 0h2a1 1 0 001-1V4a1 1 0 00-1-1h-2a1 1 0 00-1 1v16a1 1 0 001 1z"
                }
            }
        ]
    })(props);
}
function GrBladesVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeWidth": "2",
                    "d": "M17 3v4m0 3v4m0 3v4m4-17v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1h16a1 1 0 011 1zm0 7v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2a1 1 0 011-1h16a1 1 0 011 1zm0 7v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2a1 1 0 011-1h16a1 1 0 011 1z"
                }
            }
        ]
    })(props);
}
function GrBlockQuote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.78,8.89c0-3.07,1.53-4.3,4.3-4.34L5.38,6C3.78,6.17,3,7,3.1,8.31H4.54V12H.78Zm5.9,0c0-3.07,1.53-4.3,4.3-4.34L11.28,6C9.68,6.17,8.89,7,9,8.31h1.44V12H6.68Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.94,15.11c0,3.07-1.53,4.3-4.3,4.34L12.35,18c1.6-.16,2.39-1,2.28-2.3H13.18V12h3.76Zm5.9,0c0,3.07-1.53,4.3-4.3,4.34L18.24,18c1.6-.16,2.39-1,2.28-2.3H19.08V12h3.76Z"
                }
            }
        ]
    })(props);
}
function GrBlog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M5,16 C3.343,16 2,17.343 2,19 C2,20.657 3.343,22 5,22 C6.657,22 8,20.657 8,19 C8,17.343 6.657,16 5,16 L5,16 L5,16 Z M5,1 C14.925,1 23,9.075 23,19 L23,19 M18,19 C18,11.832 12.168,6 5,6 M13,19 C13,14.589 9.411,11 5,11 M2,11 L2,19 L2,19"
                }
            }
        ]
    })(props);
}
function GrBluetooth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "points": "7 7 17 16 12 20 12 4 17 8 7 16"
                }
            }
        ]
    })(props);
}
function GrBold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14,11.57a7.93,7.93,0,0,1,3.11,1.25,3.32,3.32,0,0,1,1.28,2.71A3.58,3.58,0,0,1,17,18.42a7.9,7.9,0,0,1-5,1.39H4.07v-.42a3.57,3.57,0,0,0,1.46-.2,1.17,1.17,0,0,0,.54-.52,4.75,4.75,0,0,0,.15-1.58V7A4.81,4.81,0,0,0,6.07,5.4a1.13,1.13,0,0,0-.54-.52,3.67,3.67,0,0,0-1.46-.2V4.26h7.45a10.57,10.57,0,0,1,3.78.48,3.94,3.94,0,0,1,1.75,1.42,3.52,3.52,0,0,1,.64,2,2.86,2.86,0,0,1-.81,2A5.84,5.84,0,0,1,14,11.57Zm-4.17.58v5.56a1.27,1.27,0,0,0,.32.93,1.27,1.27,0,0,0,.93.31,3.57,3.57,0,0,0,1.69-.41A2.79,2.79,0,0,0,14,17.37a3.61,3.61,0,0,0,.41-1.73,3.81,3.81,0,0,0-.5-2,2.72,2.72,0,0,0-1.39-1.21A7.52,7.52,0,0,0,9.85,12.15Zm0-.89a5.92,5.92,0,0,0,2.4-.37,2.73,2.73,0,0,0,1.19-1,3.17,3.17,0,0,0,.41-1.7,3.18,3.18,0,0,0-.41-1.69,2.59,2.59,0,0,0-1.16-1,6.2,6.2,0,0,0-2.43-.33Z"
                }
            }
        ]
    })(props);
}
function GrBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M10,1 L10,11 L13,9 L16,11 L16,1 M5.5,18 C4.11928813,18 3,19.1192881 3,20.5 C3,21.8807119 4.11928813,23 5.5,23 L22,23 M3,20.5 L3,3.5 C3,2.11928813 4.11928813,1 5.5,1 L21,1 L21,18.0073514 L5.49217286,18.0073514 M20.5,18 C19.1192881,18 18,19.1192881 18,20.5 C18,21.8807119 19.1192881,23 20.5,23 L20.5,23"
                }
            }
        ]
    })(props);
}
function GrBookmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "points": "5 1 5 22 12 17 19 22 19 1"
                }
            }
        ]
    })(props);
}
function GrBottomCorner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "points": "8 20 20 20 20 8"
                }
            }
        ]
    })(props);
}
function GrBraille(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none",
                    "fillRule": "evenodd",
                    "strokeWidth": "2"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M7 10C8.65685425 10 10 8.65685425 10 7 10 5.34314575 8.65685425 4 7 4 5.34314575 4 4 5.34314575 4 7 4 8.65685425 5.34314575 10 7 10zM17 20C18.6568542 20 20 18.6568542 20 17 20 15.3431458 18.6568542 14 17 14 15.3431458 14 14 15.3431458 14 17 14 18.6568542 15.3431458 20 17 20zM7 8C7.55228475 8 8 7.55228475 8 7 8 6.44771525 7.55228475 6 7 6 6.44771525 6 6 6.44771525 6 7 6 7.55228475 6.44771525 8 7 8zM17 18C17.5522847 18 18 17.5522847 18 17 18 16.4477153 17.5522847 16 17 16 16.4477153 16 16 16.4477153 16 17 16 17.5522847 16.4477153 18 17 18zM7 20C5.34314575 20 4 18.6568542 4 17 4 15.3431458 5.34314575 14 7 14 8.65685425 14 10 15.3431458 10 17 10 18.6568542 8.65685425 20 7 20zM17 10C15.3431458 10 14 8.65685425 14 7 14 5.34314575 15.3431458 4 17 4 18.6568542 4 20 5.34314575 20 7 20 8.65685425 18.6568542 10 17 10z"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function GrBriefcase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,6 L23,6 L23,21 L1,21 L1,6 Z M6,6 L6,21 M18,6 L18,21 M8,6 L8,3 L16,3 L16,6"
                }
            }
        ]
    })(props);
}
function GrBrush(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M10.4350288,13.8510725 C8.66912406,14.6226292 7.43502884,16.3847098 7.43502884,18.4350288 C7.43502884,21.1964526 12.4350288,25.4350288 12.4350288,25.4350288 C12.4350288,25.4350288 17.4350288,21.1964526 17.4350288,18.4350288 C17.4350288,16.3847098 16.2009336,14.6226292 14.4350288,13.8510725 L14.4350288,-0.564864977 C14.4350288,-1.67491274 13.5395983,-2.56497116 12.4350288,-2.56497116 C11.3227585,-2.56497116 10.4350288,-1.66949312 10.4350288,-0.564864977 L10.4350288,13.8510725 Z M10,12 L12.6000977,12 L15,12",
                    "transform": "rotate(45 12.435 11.435)"
                }
            }
        ]
    })(props);
}
function GrBucket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4,10 L2,10 C2,4.4771525 2,1 12,1 C22,1 22,4.4771525 22,10 L20,10 M12,10 C16.418278,10 20,9.1045695 20,8 C20,6.8954305 16.418278,6 12,6 C7.581722,6 4,6.8954305 4,8 C4,9.1045695 7.581722,10 12,10 Z M4,20 C4,21.6568542 7.581722,23 12,23 C16.418278,23 20,21.6568542 20,20 M20,8 L20,20 L20,8 Z M4,20 L4,8 L4,20 Z"
                }
            }
        ]
    })(props);
}
function GrBug(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M23,20 C21.62,17.91 20,17 19,17 M5,17 C4,17 2.38,17.91 1,20 M19,9 C22,9 23,6 23,6 M1,6 C1,6 2,9 5,9 M19,13 L24,13 L19,13 Z M5,13 L0,13 L5,13 Z M12,23 L12,12 L12,23 L12,23 Z M12,23 C8,22.9999998 5,20.0000002 5,16 L5,9 C5,9 8,6.988 12,7 C16,7.012 19,9 19,9 C19,9 19,11.9999998 19,16 C19,20.0000002 16,23.0000002 12,23 L12,23 Z M7,8 L7,6 C7,3.24 9.24,1 12,1 C14.76,1 17,3.24 17,6 L17,8"
                }
            }
        ]
    })(props);
}
function GrBundle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M17,14 L7,14 L17,14 Z M17,3 L23,3 L23,13 L17,13 M1,13 L1,17 L7,17 M17,17 L23,17 L23,13 M1,17 L1,21 L7,21 M23,17 L23,21 L17,21 M7,22 L17,22 L17,2 L7,2 L7,22 Z M7,13 L1,13 L1,3 L7,3"
                }
            }
        ]
    })(props);
}
function GrBus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M3,12 L21,12 L21,20 L3,20 L3,12 Z M3,3.99961498 C3,2.89525812 3.8926228,2 4.99508929,2 L19.0049107,2 C20.1067681,2 21,2.88743329 21,3.99961498 L21,12 L3,12 L3,3.99961498 Z M3,20 L6,20 L6,22.0010434 C6,22.5527519 5.55733967,23 5.00104344,23 L3.99895656,23 C3.44724809,23 3,22.5573397 3,22.0010434 L3,20 Z M18,20 L21,20 L21,22.0010434 C21,22.5527519 20.5573397,23 20.0010434,23 L18.9989566,23 C18.4472481,23 18,22.5573397 18,22.0010434 L18,20 Z M7,17 C7.55228475,17 8,16.5522847 8,16 C8,15.4477153 7.55228475,15 7,15 C6.44771525,15 6,15.4477153 6,16 C6,16.5522847 6.44771525,17 7,17 Z M17,17 C17.5522847,17 18,16.5522847 18,16 C18,15.4477153 17.5522847,15 17,15 C16.4477153,15 16,15.4477153 16,16 C16,16.5522847 16.4477153,17 17,17 Z M12,6 L12,12 M1,5 L1,13 M23,5 L23,13 M10,16 L14,16 M3,5.99975586 L21,6"
                }
            }
        ]
    })(props);
}
function GrBusinessService(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4,23 L1,23 L1,5 L1,5 L23,5 L23,23 L16,23 M8,5 L8,1 L8,1 L16,1 L16,5 M9,16 C11.209139,16 13,14.209139 13,12 C13,9.790861 11.209139,8 9,8 C6.790861,8 5,9.790861 5,12 C5,14.209139 6.790861,16 9,16 Z M14.0084967,17.8761594 C14.3255566,17.9570186 14.6577589,18 15,18 C17.209139,18 19,16.209139 19,14 C19,11.790861 17.209139,10 15,10 C14.1717747,10 13.4023412,10.2517171 12.7640287,10.6828219 M7.70199467,15.7255728 C6.67265121,16.4493031 6,17.6460985 6,19 C6,21.209139 7.790861,23 10,23 L10,23 C12.209139,23 14,21.209139 14,19 C14,17.2838286 12.9192205,15.8200868 11.4011657,15.2522789"
                }
            }
        ]
    })(props);
}
function GrCafeteria(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,1 L12,7.99967027 C12,9.65670662 10.6526091,11 9.00313032,11 L5.99686968,11 C4.34174426,11 3,9.6513555 3,7.99967027 L3,1 M6,7 C6,7 6,6.54902482 6,6.00922203 L6,1 M9,7 C9,7 9,6.54902482 9,6.00922203 L9,1 M6,11 L6,21.5044548 C6,22.3304216 6.66579723,23 7.5,23 L7.5,23 C8.32842712,23 9,22.3204455 9,21.5044548 L9,11 M15,18 L15,21.4998351 C15,22.3283533 15.6657972,23 16.5,23 L16.5,23 C17.3284271,23 18,22.3316845 18,21.4952612 L18,15 C18,15 21,15 21,12 C21,9 21,10 21,7 C21,4 19,2 15,2 C15,2 15,9.99456145 15,18 L15,18 Z"
                }
            }
        ]
    })(props);
}
function GrCalculator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M22,23 L2,23 L2,1 L22,1 L22,23 Z M16,17 L18,17 L18,19 L16,19 L16,17 Z M11,17 L13,17 L13,19 L11,19 L11,17 Z M16,12 L18,12 L18,14 L16,14 L16,12 Z M11,12 L13,12 L13,14 L11,14 L11,12 Z M6,17 L8,17 L8,19 L6,19 L6,17 Z M6,12 L8,12 L8,14 L6,14 L6,12 Z M18,9 L6,9 L6,5 L18,5 L18,9 Z"
                }
            }
        ]
    })(props);
}
function GrCalendar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2,5 L22,5 L22,22 L2,22 L2,5 Z M18,5 L18,1 M6,5 L6,1 M2,10 L22,10"
                }
            }
        ]
    })(props);
}
function GrCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,21 L1,7 L6,7 L8,3 L16,3 L18,7 L23,7 L23,21 L1,21 Z M12,18 C14.7614237,18 17,15.7614237 17,13 C17,10.2385763 14.7614237,8 12,8 C9.23857625,8 7,10.2385763 7,13 C7,15.7614237 9.23857625,18 12,18 Z"
                }
            }
        ]
    })(props);
}
function GrCapacity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeWidth": "2",
                    "d": "M1,19 L23,19 L23,5 L1,5 L1,19 Z M4,16 L7,16 L7,8 L4,8 L4,16 Z M10,16 L13,16 L13,8 L10,8 L10,16 Z"
                }
            }
        ]
    })(props);
}
function GrCar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,10.9970301 C1,10.4463856 1.43945834,10 2.00246167,10 L21.9975383,10 C22.5511826,10 23,10.4530363 23,10.9970301 L23,17.0029699 C23,17.5536144 22.5605417,18 21.9975383,18 L2.00246167,18 C1.44881738,18 1,17.5469637 1,17.0029699 L1,10.9970301 Z M6,2 L18,2 L22,10 L2,10 L6,2 Z M12,10.5 L15,5 M3,18 L6,18 L6,20.9906311 C6,21.5480902 5.55733967,22 5.00104344,22 L3.99895656,22 C3.44724809,22 3,21.5566468 3,20.9906311 L3,18 Z M18,18 L21,18 L21,20.9906311 C21,21.5480902 20.5573397,22 20.0010434,22 L18.9989566,22 C18.4472481,22 18,21.5566468 18,20.9906311 L18,18 Z M5,15 C5.55228475,15 6,14.5522847 6,14 C6,13.4477153 5.55228475,13 5,13 C4.44771525,13 4,13.4477153 4,14 C4,14.5522847 4.44771525,15 5,15 Z M19,15 C19.5522847,15 20,14.5522847 20,14 C20,13.4477153 19.5522847,13 19,13 C18.4477153,13 18,13.4477153 18,14 C18,14.5522847 18.4477153,15 19,15 Z M12,13 L12,15 M14,13 L14,15 M10,13 L10,15"
                }
            }
        ]
    })(props);
}
function GrCaretDownFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9H6L12 15L18 9Z"
                }
            }
        ]
    })(props);
}
function GrCaretDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "points": "22 8 12 20 2 8"
                }
            }
        ]
    })(props);
}
function GrCaretLeftFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 18V6l-6 6z"
                }
            }
        ]
    })(props);
}
function GrCaretNext(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "points": "6 2 18 12 6 22"
                }
            }
        ]
    })(props);
}
function GrCaretPrevious(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "points": "6 2 18 12 6 22",
                    "transform": "matrix(-1 0 0 1 24 0)"
                }
            }
        ]
    })(props);
}
function GrCaretRightFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6v12l6-6z"
                }
            }
        ]
    })(props);
}
function GrCaretUpFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 15H18L12 9L6 15Z"
                }
            }
        ]
    })(props);
}
function GrCaretUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "points": "22 4 12 16 2 4",
                    "transform": "matrix(1 0 0 -1 0 20)"
                }
            }
        ]
    })(props);
}
function GrCart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M5,5 L22,5 L20,14 L7,14 L4,2 L0,2 M7,14 L8,18 L21,18 M19,23 C18.4475,23 18,22.5525 18,22 C18,21.4475 18.4475,21 19,21 C19.5525,21 20,21.4475 20,22 C20,22.5525 19.5525,23 19,23 Z M9,23 C8.4475,23 8,22.5525 8,22 C8,21.4475 8.4475,21 9,21 C9.5525,21 10,21.4475 10,22 C10,22.5525 9.5525,23 9,23 Z"
                }
            }
        ]
    })(props);
}
function GrCatalogOption(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M5.5,18 C4.11928813,18 3,19.1192881 3,20.5 C3,21.8807119 4.11928813,23 5.5,23 L22,23 M3,20.5 L3,3.5 C3,2.11928813 4.11928813,1 5.5,1 L21,1 L21,18.0073514 L5.49217286,18.0073514 M20.5,18 C19.1192881,18 18,19.1192881 18,20.5 C18,21.8807119 19.1192881,23 20.5,23 L20.5,23"
                }
            }
        ]
    })(props);
}
function GrCatalog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M5,6 L1,4.5 L1,18.443038 L12,23 L23,18.443038 L23,4 L19,6 M5,16 L5,2 L12,5 L19,2 L19,16 L12,19 L5,16 Z M11.95,5 L11.95,19"
                }
            }
        ]
    })(props);
}
function GrCentos(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.1609863,6.25070841 L3.24873581,8.1633816 L3.24873581,3.22722505 L8.18367123,3.22722505 L6.23953033,5.17169472 L6.093182,5.31809002 L6.23953033,5.46453229 L10.7544892,9.98066536 L10.7544892,10.7189824 L9.92411742,10.7189824 L5.45678278,6.25066145 L5.30719374,6.10102544 L5.1609863,6.25070841 L5.1609863,6.25070841 Z M10.7545362,9.39193738 L10.7545362,3.22722505 L8.77239922,3.22722505 L6.68190998,5.31813699 L10.7545362,9.39193738 L10.7545362,9.39193738 Z M5.30728767,6.6930411 L3.24873581,8.75225049 L3.24873581,10.7190294 L9.33224266,10.7190294 L5.30728767,6.6930411 L5.30728767,6.6930411 Z M13.2714364,9.36319374 L17.3154599,5.31809002 L15.1964149,3.19848141 L13.2714364,3.19848141 L13.2714364,9.36319374 L13.2714364,9.36319374 Z M17.9071937,5.31809002 L17.7576047,5.46453229 L13.2713894,9.95516243 L13.2713894,10.7189824 L14.0572368,10.7189824 L18.5340117,6.24108023 L18.680454,6.09463796 L18.8299022,6.24108023 L20.7899648,8.20147162 L20.7899648,3.19852838 L15.785002,3.19852838 L17.7576047,5.17174168 L17.9071937,5.31809002 L17.9071937,5.31809002 Z M11.1714129,2.80720157 L11.1714129,3.01723679 L11.1714129,9.80886106 L11.998638,10.636274 L12.8545127,9.78011742 L12.8545127,2.99168689 L12.8545127,2.78155773 L13.064454,2.78155773 L14.7794912,2.78155773 L11.998638,-1.77635684e-15 L9.19223483,2.80720157 L10.9613777,2.80720157 L11.1714129,2.80720157 L11.1714129,2.80720157 Z M14.6490176,10.7190294 L20.7900587,10.7190294 L20.7900587,8.79358121 L18.6805479,6.68355382 L14.6490176,10.7190294 L14.6490176,10.7190294 Z M10.6241096,12.011225 L9.75231311,11.1391468 L3.03870059,11.1391468 L2.83190607,11.1391468 L2.83190607,10.9291115 L2.83190607,9.16917417 L0,12.0015499 L2.8318591,14.8342544 L2.8318591,13.0167358 L2.8318591,12.8101292 L3.03865362,12.8101292 L9.82539335,12.8101292 L10.6241096,12.011225 L10.6241096,12.011225 Z M13.2714364,14.6909589 L13.2714364,20.747225 L15.2345049,20.747225 L17.2803757,18.7008376 L13.2714364,14.6909589 L13.2714364,14.6909589 Z M5.31691585,17.3197808 L9.40861057,13.226865 L3.24873581,13.226865 L3.24873581,15.2508493 L5.31691585,17.3197808 L5.31691585,17.3197808 Z M18.6805479,17.3197808 L20.7900587,15.2098474 L20.7900587,13.226865 L14.5918121,13.226865 L18.6805479,17.3197808 L18.6805479,17.3197808 Z M21.2099413,14.789589 L23.9970881,12.0015969 L21.2099413,9.21365166 L21.2099413,10.9291585 L21.2099413,11.1391937 L20.9997652,11.1391937 L14.229135,11.1391937 L13.3667319,12.0015969 L14.1750294,12.8101761 L20.9998121,12.8101761 L21.2099883,12.8101761 L21.2099883,13.0167828 L21.2099883,14.789589 L21.2099413,14.789589 Z M18.6805479,17.9083679 L18.5341057,17.7623014 L14.0000783,13.2269119 L13.2714364,13.2269119 L13.2714364,14.1022309 L17.7226614,18.5543953 L17.8689159,18.7008845 L17.7226614,18.8504736 L15.8261918,20.747319 L20.7900117,20.747319 L20.7900117,15.8015342 L18.8299491,17.7622544 L18.6805479,17.9083679 L18.6805479,17.9083679 Z M12.8545127,21.1643836 L12.8545127,20.9542544 L12.8545127,14.2738004 L11.9827162,13.4020509 L11.184,14.2005793 L11.184,20.9542544 L11.184,21.1643836 L10.9741526,21.1643836 L9.14461057,21.1643836 L11.9827162,24 L14.8177221,21.1643836 L13.064407,21.1643836 L12.8545127,21.1643836 L12.8545127,21.1643836 Z M6.09322896,18.7008376 L6.2395773,18.5543483 L10.7672642,14.0256282 L10.7672642,13.226865 L9.99733855,13.226865 L5.46321722,17.7622544 L5.31691585,17.9083209 L5.17047358,17.7622544 L3.24873581,15.8398121 L3.24873581,20.7471781 L8.13590607,20.7471781 L6.2395773,18.8503327 L6.09322896,18.7008376 L6.09322896,18.7008376 Z M10.7672642,14.6176908 L6.68190998,18.7008376 L8.72768689,20.747225 L10.7672642,20.747225 L10.7672642,14.6176908 L10.7672642,14.6176908 Z"
                }
            }
        ]
    })(props);
}
function GrCertificate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeWidth": "2",
                    "d": "M15 19H2V1h16v4m0 0a5 5 0 110 10 5 5 0 010-10zm-3 9v8l3-2 3 2v-8M5 8h6m-6 3h5m-5 3h2M5 5h2"
                }
            }
        ]
    })(props);
}
function GrChannel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2,9 L22,9 L22,22 L2,22 L2,9 Z M21,2 L13,9 L11,9 L3,2"
                }
            }
        ]
    })(props);
}
function GrChapterAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M5,14 L5,5 L19,5 L19,20 L11,20 M19,16 L23,16 L23,1 L9,1 L9,5 M5,16 L5,24 M9,20 L1,20"
                }
            }
        ]
    })(props);
}
function GrChapterNext(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,3.5 L1,20 L10,14 L10,20 L21,12 L10,4 L10,10 L1,3.5 Z M22,2 L22,22 L22,2 Z"
                }
            }
        ]
    })(props);
}
function GrChapterPrevious(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M23,3.5 L23,20 L14,14 L14,20 L3,12 L14,4 L14,10 L23,3.5 Z M2,2 L2,22 L2,2 Z"
                }
            }
        ]
    })(props);
}
function GrChatOption(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M9,7 L9,1 L23,1 L23,11 L20,11 L20,16 L15,12 M1,7 L15,7 L15,18 L9,18 L4,22 L4,18 L1,18 L1,7 Z"
                }
            }
        ]
    })(props);
}
function GrChat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M5,1 L19,1 L19,1 C21.209139,1 23,2.790861 23,5 L23,13 L23,13 C23,15.209139 21.209139,17 19,17 L7,17 L1,22 L1,5 L1,5 C1,2.790861 2.790861,1 5,1 Z M5,7 L18,7 M5,11 L14,11",
                    "transform": "matrix(-1 0 0 1 24 0)"
                }
            }
        ]
    })(props);
}
function GrCheckboxSelected(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2,2 L22,2 L22,22 L2,22 L2,2 Z M5,13 L10,17 L19,6"
                }
            }
        ]
    })(props);
}
function GrCheckbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "20",
                    "x": "2",
                    "y": "2",
                    "fill": "none",
                    "strokeWidth": "2"
                }
            }
        ]
    })(props);
}
function GrCheckmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "points": "2 14 9 20 22 4"
                }
            }
        ]
    })(props);
}
function GrChrome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none",
                    "fillRule": "evenodd"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M11.9733005,16.4144516 C9.59429509,16.4144516 7.65884342,14.4788121 7.65884342,12.0999945 C7.65884342,9.72075429 9.59429509,7.78530262 11.9733005,7.78530262 C14.3523059,7.78530262 16.2879454,9.72075429 16.2879454,12.0999945 C16.2879924,14.4788121 14.3523529,16.4144516 11.9733005,16.4144516 L11.9733005,16.4144516 Z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M13.7910066,17.1810894 C13.1872494,17.4007528 12.5549364,17.5116882 11.9068426,17.5116882 C10.6352186,17.5116882 9.39370022,17.0652225 8.41129728,16.2548117 C7.61431896,15.5972306 7.02033082,14.7318218 6.69297277,13.7500294 L6.691235,13.7442055 L1.93641793,5.50854377 C0.228238232,8.1357683 -0.377867323,11.2684017 0.230163868,14.3493248 C0.849467072,17.4870306 2.65331799,20.1955546 5.30970885,21.9764857 C6.69353637,22.9040785 8.22657716,23.5227711 9.86735961,23.8160783 L13.7910066,17.1810894 L13.7910066,17.1810894 Z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M22.7599128,6.70666487 C19.7903479,0.731840215 12.5393434,-1.70437065 6.56465968,1.26519432 C5.01832731,2.03375777 3.65958002,3.12347966 2.57441389,4.45616042 L6.59105498,11.413435 C6.85172029,9.39264477 8.25048322,7.60626547 10.3219975,6.95469613 C10.8217704,6.79763941 11.341739,6.71403864 11.865371,6.70666487 L22.7599128,6.70666487 Z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M11.9264747,24 C14.936431,24 17.8171819,22.8712018 20.0368292,20.8218558 C22.2681243,18.7619893 23.6231612,15.9588274 23.8523118,12.9290041 C23.983349,11.1937716 23.7261592,9.41711443 23.1082181,7.78530262 L15.2520944,7.78530262 C16.5738788,8.83162726 17.3494403,10.4306093 17.3416908,12.1250278 C17.3360548,13.3449884 16.9177692,14.5439079 16.1598672,15.5064909 L11.1518525,23.9751076 C11.4097938,23.9916399 11.6696606,24 11.926052,24 L11.9264747,24 L11.9264747,24 Z"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function GrCircleAlert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeWidth": "2",
                    "d": "M12 14V6m0 12v-2m0-14C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z"
                }
            }
        ]
    })(props);
}
function GrCircleInformation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M12,10 L12,18 M12,6 L12,8"
                }
            }
        ]
    })(props);
}
function GrCirclePlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M9.5,15.5 L15.5,12 L9.5,8.5 L9.5,15.5 Z M10.5,13.5 L12.5,12 L10.5,10.5 L10.5,13.5 Z"
                }
            }
        ]
    })(props);
}
function GrCircleQuestion(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M12,15 L12,14 C12,13 12,12.5 13,12 C14,11.5 15,11 15,9.5 C15,8.5 14,7 12,7 C10,7 9,8.26413718 9,10 M12,16 L12,18"
                }
            }
        ]
    })(props);
}
function GrClearOption(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M10,4 C10,2.8954305 10.8954305,2 12,2 C13.1045695,2 14,2.8954305 14,4 L14,10 L20,10 L20,14 L4,14 L4,10 L10,10 L10,4 Z M4,14 L20,14 L20,22 L12,22 L4,22 L4,14 Z M16,22 L16,16.3646005 M8,22 L8,16.3646005 M12,22 L12,16.3646005"
                }
            }
        ]
    })(props);
}
function GrClear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M5,5 L19,19"
                }
            }
        ]
    })(props);
}
function GrCli(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,1 L23,1 L23,23 L1,23 L1,1 Z M1,5 L23,5 M5,1 L5,5 M11,16 L19,16 M5,10 L8,13 L5,16"
                }
            }
        ]
    })(props);
}
function GrClipboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M16,3 L21,3 L21,23 L3,23 L3,3 L3,3 L8,3 M8,1 L16,1 L16,6 L8,6 L8,1 Z"
                }
            }
        ]
    })(props);
}
function GrClock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7a1 1 0 10-2 0v5a1 1 0 00.4.8l4 3a1 1 0 001.2-1.6L13 11.5V7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM3 12a9 9 0 1118 0 9 9 0 01-18 0z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function GrClone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M7,23 L23,23 L23,7 L7,7 L7,23 Z M17,3.9997 L17,0.9997 L14,0.9997 M1,13.9997 L1,16.9997 L4,16.9997 M1,11.9997 L1,5.9997 L1,11.9997 Z M4,0.9997 L1,0.9997 L1,3.9997 M6,0.9997 L12,0.9997 L6,0.9997 Z"
                }
            }
        ]
    })(props);
}
function GrClose(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M3,3 L21,21 M3,21 L21,3"
                }
            }
        ]
    })(props);
}
function GrClosedCaption(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,12 C1,5 2.5,4 12,4 C21.5,4 23,5 23,12 C23,19 21.5,20 12,20 C2.5,20 1,19 1,12 Z M5.25,14 C5.25,15.5 6,16 7.75,16 C9.5,16 10.25,15.5 10.25,14 L9.97861679,14 C9.97861671,15.25 8.97905547,16 7.75,16 C6.52094453,16 5.52138329,15.25 5.52138321,14 L5.52138321,10 C5.5,8.75 6.5,8 7.75,8 C9,8 10,8.75 9.97861679,10 L10.25,10 C10.25,8.75 9.2286998,8 7.75,8 C6.2713002,8 5.25,8.75 5.25,10 L5.25,14 Z M13.25,14 C13.25,15.5 14,16 15.75,16 C17.5,16 18.25,15.5 18.25,14 L17.9786168,14 C17.9786167,15.25 16.9790555,16 15.75,16 C14.5209445,16 13.5213833,15.25 13.5213832,14 L13.5213832,10 C13.5,8.75 14.5,8 15.75,8 C17,8 18,8.75 17.9786168,10 L18.25,10 C18.25,8.75 17.2286998,8 15.75,8 C14.2713002,8 13.25,8.75 13.25,10 L13.25,14 Z"
                }
            }
        ]
    })(props);
}
function GrCloudComputer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M6,6 L6,5 C6,2 7.5,1 10,1 L14,1 C16.5,1 18,2.5 18,5 L18,6 C21,6 23,8 23,11 C23,14 21,16 18,16 M14,6 L6,6 C3,6 1,7.5 1,11 C1,14.5 3,16 6,16 M8,19 L16,19 L16,12 L8,12 L8,19 Z M12,19 L12,23 L12,19 Z M9,23 L15,23 L9,23 Z"
                }
            }
        ]
    })(props);
}
function GrCloudDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M6,17 C3.23857625,17 1,14.7614237 1,12 C1,9.23857625 3.23857625,7 6,7 L12,7 M6,7 L6,6 C6,3 8,2 11,2 L13,2 C16,2 18,3 18,6 L18,7 C20.7614237,7 23,9.23857625 23,12 C23,14.7614237 20.7614237,17 18,17 M12,12 L12,21 M8,17 L12,21 L16,17"
                }
            }
        ]
    })(props);
}
function GrCloudSoftware(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M8,23 L16,23 L16,12 L8,12 L8,23 Z M8,16 L16,16 M12,12 L12,16 M6,6 L6,5 C6,2 7.5,1 10,1 L14,1 C16.5,1 18,2.5 18,5 L18,6 C21,6 23,8 23,11 C23,14 21,16 18,16 M14,6 L6,6 C3,6 1,7.5 1,11 C1,14.5 3,16 6,16"
                }
            }
        ]
    })(props);
}
function GrCloudUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M6,17 C3.23857625,17 1,14.7614237 1,12 C1,9.23857625 3.23857625,7 6,7 L12,7 M6,7 L6,6 C6,3 8,2 11,2 L13,2 C16,2 18,3 18,6 L18,7 C20.7614237,7 23,9.23857625 23,12 C23,14.7614237 20.7614237,17 18,17 M12,13 L12,22 M8,16.0000004 L11.9653427,11.9653429 L16,16.0000002"
                }
            }
        ]
    })(props);
}
function GrCloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M18,17 L18,18 C18,21 16,22 13,22 L11,22 C8,22 6,21 6,18 L6,17 C3.23857625,17 1,14.7614237 1,12 C1,9.23857625 3.23857625,7 6,7 L12,7 M6,7 L6,6 C6,3 8,2 11,2 L13,2 C16,2 18,3 18,6 L18,7 C20.7614237,7 23,9.23857625 23,12 C23,14.7614237 20.7614237,17 18,17 L12,17"
                }
            }
        ]
    })(props);
}
function GrCloudlinux(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14.0684356,5.79034617 C14.1171022,5.83554613 14.1629688,5.88247942 14.2099021,5.92887939 C14.5235019,6.25221246 14.818835,6.60341217 15.0909681,6.98367853 C15.0913681,6.98407853 15.0919014,6.98487853 15.0923014,6.98527852 C15.3575012,7.36634488 15.601101,7.77674455 15.8359008,8.21887752 C15.8816341,6.72327874 15.5928343,5.40847981 14.9224349,4.18328081 C14.6147018,3.61968127 14.3036354,3.04168174 13.7816358,2.65061539 C13.0331031,2.08901585 12.1863038,1.70701616 11.2797712,1.46634969 C10.8748382,1.35914978 10.4656385,1.28181651 10.0377722,1.23701654 C6.91657474,0.808616892 3.77031064,2.36541562 2.09297867,5.47701309 C2.28097852,5.52674638 2.36111178,5.36594651 2.4687117,5.27861325 C5.99870882,2.40754892 10.8748382,2.70048202 14.0080356,5.73047955 C14.0285689,5.75007953 14.0473689,5.77061285 14.0684356,5.79034617 L14.0684356,5.79034617 Z M10.5404385,16.6888706 C9.96470559,16.3543376 9.44097268,15.9496712 8.90203979,15.5039382 C9.44683934,17.0628703 11.539371,18.9363355 13.3229695,19.4235351 C13.2501696,19.3640684 13.1824363,19.2966018 13.1037697,19.2462019 C12.1952371,18.661269 11.4491044,17.9083363 10.8137716,17.039937 C10.725505,16.9196704 10.659505,16.7579372 10.5404385,16.6888706 L10.5404385,16.6888706 Z M23.5932278,9.59820973 C23.6076278,9.53420978 23.6110945,9.47607649 23.5250945,9.46247651 C23.5210945,9.5082098 23.5160279,9.5543431 23.5120279,9.59994306 C23.5028279,9.70900964 23.4937612,9.81780955 23.4842946,9.92674279 C22.999495,15.3279384 17.8578992,18.9307355 12.6175034,17.5406033 C12.4443036,17.49447 12.271637,17.4443367 12.0989705,17.3963367 C13.2500362,18.6898023 14.6673684,19.466735 16.3432337,19.7827348 C16.9057666,19.889268 17.4509662,19.8734014 18.005099,19.7220681 C20.0790973,19.1556686 21.710696,17.9739362 22.8168284,16.1399377 C24.0517608,14.0920727 24.3364272,11.8972745 23.5932278,9.59820973 L23.5932278,9.59820973 Z M14.4687019,20.5306008 C11.6479042,20.0162012 9.61323921,18.3820692 8.21937368,15.8934046 C8.15030707,17.4810033 8.53657342,18.9334021 9.37977273,20.260201 C9.63537252,20.6626007 9.87683899,21.092467 10.286972,21.3592668 C12.9656365,23.1032654 15.7536342,23.2813986 18.6061652,21.8432664 C20.097364,21.092067 21.1962964,19.9155347 21.9305625,18.4039359 C19.7645643,20.2555344 17.2865663,21.0442004 14.4687019,20.5306008 L14.4687019,20.5306008 Z M9.76577242,0.501683809 C15.4967011,1.01008339 19.0562982,6.22261248 17.4562995,11.762608 C17.4377662,11.8264746 17.3944329,11.8899412 17.5026994,11.9311412 C18.811365,10.6480755 19.6242977,9.11274346 19.8604309,7.28074495 C19.9009642,6.96447854 19.8916308,6.65661213 19.8198976,6.34554571 C19.2596313,3.91008103 17.8805658,2.07994919 15.6775009,0.921950133 C13.7555025,-0.0879157105 11.7263042,-0.27724889 9.63990585,0.398883893 C9.57470591,0.387283902 9.51323929,0.382483906 9.50257263,0.472750499 C9.54990593,0.477017162 9.59710589,0.481683825 9.64417252,0.485950488 C9.68457248,0.491550484 9.72510578,0.498217145 9.76577242,0.501683809 L9.76577242,0.501683809 Z M16.7349667,11.7272747 C16.7345667,11.7143413 16.7336334,11.7019413 16.7331001,11.689408 C16.7325667,11.6836747 16.7316334,11.6783414 16.7313667,11.6728747 C16.7288334,11.6780747 16.7268334,11.6835414 16.7245667,11.688608 C16.7280334,11.701808 16.7316334,11.714208 16.7349667,11.7272747 L16.7349667,11.7272747 Z M20.5508303,9.56420976 C20.0362974,12.3826075 18.3973654,14.4124725 15.8035008,15.8174047 C17.3804329,15.8550046 18.7462984,15.5355382 20.0061641,14.8024722 C20.513897,14.5070057 21.0434966,14.219406 21.3880296,13.726473 C24.159494,9.76794292 22.7444285,4.21368078 18.398432,2.06848253 C20.2738972,4.2370141 21.0689632,6.72927873 20.5508303,9.56420976 L20.5508303,9.56420976 Z M19.4572312,10.7603421 C19.3869646,10.7772754 19.3341646,10.8144754 19.3016313,10.8648754 C18.6622985,11.8550079 17.8510992,12.6742072 16.8687,13.3250067 C16.8020333,13.3692733 16.7323001,13.4259399 16.6949668,13.4938066 C16.3799004,14.0710061 15.963634,14.5762057 15.5736343,15.1023386 C17.4404328,14.1660727 18.7374984,12.7223405 19.4572312,10.7603421 L19.4572312,10.7603421 Z M16.3596337,5.66701293 C16.2429671,5.76541285 16.3189671,5.84594612 16.3360337,5.9144794 C16.5713669,6.85367863 16.6712335,7.81794451 16.4891003,8.75834375 C16.2929671,9.77220959 16.6508335,10.7030088 16.7313667,11.6728747 C16.9784332,11.1238085 17.0598998,10.5355423 17.1194998,9.94634278 C17.2697663,8.45394399 17.0036332,7.03394515 16.3596337,5.66701293 L16.3596337,5.66701293 Z M14.5243019,16.3692709 C14.4153686,16.3479376 14.310702,16.3484709 14.2012355,16.3782042 C13.6208359,16.5352707 13.0252364,16.6068707 12.4288369,16.671804 C12.3929703,16.6548706 12.352037,16.641804 12.3429703,16.6934039 C12.340437,16.7066039 12.3952369,16.7299372 12.4237703,16.7487372 C14.4160353,17.39167 16.3536337,17.2172702 18.2773655,16.3792709 C18.2242989,16.3431376 18.2036322,16.3178043 18.1813656,16.3158043 C18.1412323,16.3115376 18.0993656,16.3174043 18.059899,16.3263376 C16.8842999,16.5972707 15.7055009,16.6047374 14.5243019,16.3692709 L14.5243019,16.3692709 Z M8.87430648,15.5143382 C8.86243982,15.5076716 8.8511065,15.5012716 8.8395065,15.4944716 C8.84897316,15.5032716 8.85830649,15.5114049 8.86750648,15.5202049 L8.87430648,15.5143382 Z M8.38790687,8.95341025 C8.42537351,8.9399436 8.46377348,8.91994361 8.43364017,8.87701032 C8.42617351,8.86607699 8.37084022,8.88847697 8.33737358,8.8954103 C8.3523069,8.91621028 8.36924022,8.93567694 8.38790687,8.95341025 L8.38790687,8.95341025 Z M5.49564256,21.8493997 C5.53044254,21.9048664 5.56937584,21.9484663 5.63937578,21.8973997 C5.6101758,21.8619331 5.58097583,21.8261998 5.55164252,21.7907331 C5.53124253,21.8085998 5.51257588,21.8280664 5.49564256,21.8493997 L5.49564256,21.8493997 Z M10.6501717,4.51008054 C11.6171042,5.12061338 12.4753702,5.86181277 13.0968364,6.81714533 C13.4443028,7.35114489 13.8263024,7.41181151 14.3977686,7.21701167 C13.3940361,5.92421272 12.1791038,4.99848014 10.6501717,4.51008054 L10.6501717,4.51008054 Z M8.33737358,8.8954103 C6.47404177,9.84940952 5.22724278,11.342875 4.45951007,13.29554 C4.52271002,13.2838067 4.55471,13.2871401 4.57230998,13.2723401 C4.60337662,13.2472734 4.6289766,13.2134068 4.65057659,13.1792735 C5.29017606,12.156341 6.11844206,11.317675 7.12044124,10.6487422 C7.21270783,10.5868756 7.2860411,10.512609 7.34244106,10.4142091 C7.64177415,9.89274282 8.01230718,9.42074321 8.38790687,8.95341025 C8.36924022,8.93567694 8.3523069,8.91621028 8.33737358,8.8954103 L8.33737358,8.8954103 Z M7.59857418,18.1031361 C7.63617415,18.0415362 7.64710748,17.9778029 7.63457415,17.9192696 C7.38657436,16.7668706 7.38084103,15.6142048 7.6151075,14.4595391 C7.63084082,14.3810058 7.64057415,14.2915392 7.6187075,14.2168726 C7.43337432,13.5863398 7.37057437,12.934607 7.27444111,12.2867409 C6.61577498,14.2688726 6.71990823,16.2067377 7.59857418,18.1031361 L7.59857418,18.1031361 Z M6.09044208,7.61007802 C7.14644122,7.38141154 8.20657369,7.3864782 9.26990615,7.55074473 C9.41723937,7.57354471 9.57817257,7.64114466 9.71123913,7.60594469 C10.3548386,7.43514482 11.0113714,7.35114489 11.7076375,7.28527828 C10.2203054,6.56794553 7.41577433,6.72301207 5.81017564,7.64007799 C5.90364223,7.630478 5.99937549,7.63034467 6.09044208,7.61007802 L6.09044208,7.61007802 Z M5.55164252,21.7907331 C5.48124258,21.7072665 5.4103093,21.6240666 5.34017602,21.5400667 C1.86364552,17.3782034 2.9519113,11.1947418 7.64044082,8.47221065 C7.79537402,8.38221072 7.95297389,8.29567746 8.10937377,8.20781086 C6.38030851,8.10701094 4.82870977,8.55981057 3.42044425,9.52127646 C2.94751131,9.84394286 2.57311161,10.2408759 2.28831184,10.7392755 C1.22244605,12.6063406 0.903912972,14.5956723 1.41871255,16.6748706 C1.99351208,18.9960687 3.34431098,20.749134 5.49564256,21.8493997 C5.51257588,21.8280664 5.53124253,21.8085998 5.55164252,21.7907331 L5.55164252,21.7907331 Z M7.67084079,19.7224681 C6.04190878,17.3651367 5.76524234,14.7710055 6.60604166,11.9434078 C5.46470926,13.0320736 4.72470986,14.2236726 4.35217683,15.6330048 C4.20191028,16.2007377 4.03097709,16.7784705 4.13564367,17.3708701 C4.97497632,22.1296662 9.90310564,25.0569971 14.4929686,23.5001984 C11.6336376,23.2932652 9.30910612,22.0932662 7.67084079,19.7224681 L7.67084079,19.7224681 Z M0.444580013,14.4472724 C-0.105152872,12.8590071 -0.159819494,11.250075 0.363246746,9.66447634 C1.3635126,6.63074548 3.46084422,4.78501365 6.58804167,4.12408086 C7.06657462,4.02288094 7.54150756,4.15621416 8.00670718,4.25981408 C9.54083927,4.6018138 10.8412382,5.35567985 11.9152373,6.5268789 C9.16990624,5.75301286 6.57550835,6.0360793 4.21751027,7.6670113 C1.86151219,9.29634331 0.666979832,11.6062081 0.444580013,14.4472724 L0.444580013,14.4472724 Z"
                }
            }
        ]
    })(props);
}
function GrCluster(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M8,9 L16,9 L16,1 L8,1 L8,9 Z M1,23 L9,23 L9,15 L1,15 L1,23 Z M15,23 L23,23 L23,15 L15,15 L15,23 Z M5,15 L8,9 L5,15 Z M10,19 L14,19 L10,19 Z M16,9 L19,15 L16,9 Z"
                }
            }
        ]
    })(props);
}
function GrCoatCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "2",
                    "d": "M12,11 L22.1551134,17.4623449 C22.6217314,17.7592836 23,18.4433532 23,19.0093689 L23,20.9906311 C23,21.5480902 22.5605417,22 21.9975383,22 L2.00246167,22 C1.44881738,22 1,21.5566468 1,20.9906311 L1,19.0093689 C1,18.4519098 1.3786449,17.7590442 1.84488659,17.4623449 L12,11 Z M15,5 C15,3.34314575 13.6568542,2 12,2 C10.3431458,2 9,3.34314575 9,5 C9,5.93157601 9.41137234,6.80169553 10.0908534,7.31422922 C11,8 12,8 12,9.5 L12,11"
                }
            }
        ]
    })(props);
}
function GrCodeSandbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,1.5 L3,6.5 L3,17.5 L12,22.5 L21,17.5 L21,6.5 L12,1.5 Z M12,22.5 L12,11.5 M21,6.5 L12,11.5 M12,11.5 L3,6.5 M21,17.5 L21,12 L16.5,14.5 L16.5,20 L21,17.5 Z M3,17.5 L3,12 L7.5,14.5 L7.5,20 L3,17.5 Z M12,1.5 L7.5,4 L12,6.5 L16.5,4 L12,1.5 Z"
                }
            }
        ]
    })(props);
}
function GrCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M9,22 L15,2 M17,17 L22,12 L17,7 M7,17 L2,12 L7,7"
                }
            }
        ]
    })(props);
}
function GrCodepen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.0001023,22.0293246 C6.46990155,22.0293246 1.97088004,17.5301496 1.97088004,12.0001023 C1.97088004,6.4701062 6.46990155,1.97088004 12.0001023,1.97088004 C17.5300984,1.97088004 22.02912,6.4701062 22.02912,12.0001023 C22.02912,17.5301496 17.5300984,22.0293246 12.0001023,22.0293246 M12.0001023,0 C5.37246693,0 0,5.37251809 0,12.0001023 C0,18.6277377 5.37246693,24.0000512 12.0001023,24.0000512 C18.6275331,24.0000512 24,18.6277377 24,12.0001023 C24,5.37251809 18.6275331,0 12.0001023,0 M18.1444674,13.0672488 L16.5492221,12.0001023 L18.1444674,10.933007 L18.1444674,13.0672488 Z M12.6376991,17.5906236 L12.6376991,14.6163967 L15.4022622,12.767488 L17.6339173,14.2599991 L12.6376991,17.5906236 Z M12.0001126,13.5086784 L9.74466695,12.0001023 L12.0001126,10.4915262 L14.2553535,12.0001023 L12.0001126,13.5086784 Z M11.3623214,17.5906236 L6.36605201,14.2599991 L8.59791172,12.767488 L11.3623214,14.6163967 L11.3623214,17.5906236 Z M5.85555304,10.933007 L7.45095183,12.0001023 L5.85555304,13.0672488 L5.85555304,10.933007 Z M11.3623214,6.40958102 L11.3623214,9.38380794 L8.59791172,11.233126 L6.36605201,9.74015443 L11.3623214,6.40958102 Z M12.6376991,6.40958102 L17.6339173,9.74015443 L15.4022622,11.233126 L12.6376991,9.38380794 L12.6376991,6.40958102 Z M19.414166,9.656248 C19.4128358,9.64688527 19.4104823,9.63793184 19.4089475,9.62856911 C19.4057754,9.61055993 19.402501,9.59260191 19.397794,9.57505319 C19.3950313,9.56451372 19.3911429,9.55438356 19.3878685,9.54425339 C19.3827523,9.52859768 19.3776872,9.51299313 19.3714454,9.49779788 C19.3670966,9.48725842 19.3620827,9.47671895 19.3572222,9.46658879 C19.3505199,9.45210981 19.3435618,9.43804014 19.3355293,9.42443092 C19.3296968,9.4142496 19.323455,9.40447757 19.3174178,9.3947567 C19.3088225,9.38145446 19.3000226,9.36856152 19.2904041,9.35607789 C19.283446,9.34671516 19.2760274,9.33735243 19.2686089,9.32834784 C19.2584275,9.3166828 19.2478881,9.3049666 19.2367858,9.29401783 C19.2284463,9.2854737 19.220158,9.27687841 19.2114092,9.26905055 C19.199693,9.25851109 19.1876187,9.24832976 19.1752885,9.23860889 C19.1657723,9.23119034 19.1563584,9.22377178 19.1464329,9.21676253 C19.1426981,9.21440905 19.1394237,9.21128814 19.1358934,9.20893467 L12.3536963,4.687504 C12.1394791,4.54465843 11.8605414,4.54465843 11.646273,4.687504 L4.86412702,9.20893467 C4.86059681,9.21128814 4.85727125,9.21440905 4.85358755,9.21676253 C4.84361088,9.22377178 4.83424815,9.23119034 4.82488542,9.23860889 C4.81240178,9.24832976 4.80027628,9.25851109 4.78881589,9.26905055 C4.7798113,9.27687841 4.7716253,9.2854737 4.76323466,9.29401783 C4.75213241,9.3049666 4.74159294,9.3166828 4.73161626,9.32834784 C4.72399306,9.33735243 4.7165745,9.34671516 4.70956525,9.35607789 C4.70020252,9.36856152 4.69119793,9.38145446 4.68280728,9.3947567 C4.67636081,9.40447757 4.67032365,9.4142496 4.66449113,9.42443092 C4.65666327,9.43804014 4.64965401,9.45210981 4.64279825,9.46658879 C4.63793781,9.47671895 4.63287273,9.48725842 4.62857508,9.49779788 C4.62233326,9.51299313 4.61726818,9.52859768 4.61215194,9.54425339 C4.60882638,9.55438356 4.60514268,9.56451372 4.60222642,9.57505319 C4.59751947,9.59260191 4.59439856,9.61055993 4.591073,9.62856911 C4.58953813,9.63793184 4.58718466,9.64688527 4.58600792,9.656248 C4.58227306,9.68356875 4.5801754,9.7112988 4.5801754,9.73938699 L4.5801754,14.2608177 C4.5801754,14.2889058 4.58227306,14.3166359 4.58600792,14.3443659 C4.58718466,14.3533705 4.58953813,14.3626821 4.591073,14.3716355 C4.59439856,14.3896447 4.59751947,14.4075516 4.60222642,14.4251515 C4.60514268,14.4356909 4.60882638,14.4458211 4.61215194,14.4560024 C4.61726818,14.4715558 4.62233326,14.4872115 4.62857508,14.5028161 C4.63287273,14.5134067 4.63793781,14.5235369 4.64279825,14.533667 C4.64965401,14.5480437 4.65666327,14.5621134 4.66449113,14.576183 C4.67032365,14.5860062 4.67636081,14.5956759 4.68280728,14.6054479 C4.69119793,14.6187502 4.70020252,14.6316431 4.70956525,14.6441268 C4.7165745,14.6538988 4.72399306,14.6628522 4.73161626,14.6718057 C4.74159294,14.6835219 4.75213241,14.6952381 4.76323466,14.7061868 C4.7716253,14.7147309 4.7798113,14.7233262 4.78881589,14.7311029 C4.80027628,14.7417447 4.81240178,14.7518749 4.82488542,14.7615958 C4.83424815,14.7690655 4.84361088,14.7764329 4.85358755,14.7834421 C4.85727125,14.7857956 4.86059681,14.7889165 4.86412702,14.7912188 L11.646273,19.3127007 C11.7534072,19.3841234 11.8767599,19.4200395 12.0001126,19.4200395 C12.1232606,19.4200395 12.2465621,19.3841234 12.3536963,19.3127007 L19.1358934,14.7912188 C19.1394237,14.7889165 19.1426981,14.7857956 19.1464329,14.7834421 C19.1563584,14.7764329 19.1657723,14.7690655 19.1752885,14.7615958 C19.1876187,14.7518749 19.199693,14.7417447 19.2114092,14.7311029 C19.220158,14.7233262 19.2284463,14.7147309 19.2367858,14.7061868 C19.2478881,14.6952381 19.2584275,14.6835219 19.2686089,14.6718057 C19.2760274,14.6628522 19.283446,14.6538988 19.2904041,14.6441268 C19.3000226,14.6316431 19.3088225,14.6187502 19.3174178,14.6054479 C19.323455,14.5956759 19.3296968,14.5860062 19.3355293,14.576183 C19.3435618,14.5621134 19.3505199,14.5480437 19.3572222,14.533667 C19.3620827,14.5235369 19.3670966,14.5134067 19.3714454,14.5028161 C19.3776872,14.4872115 19.3827523,14.4715558 19.3878685,14.4560024 C19.3911429,14.4458211 19.3950313,14.4356909 19.397794,14.4251515 C19.402501,14.4075516 19.4057754,14.3896447 19.4089475,14.3716355 C19.4104823,14.3626821 19.4128358,14.3533705 19.414166,14.3443659 C19.4176962,14.3166359 19.4198962,14.2889058 19.4198962,14.2608177 L19.4198962,9.73938699 C19.4198962,9.7112988 19.4176962,9.68356875 19.414166,9.656248 L19.414166,9.656248 Z"
                }
            }
        ]
    })(props);
}
function GrCoffee(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none",
                    "transform": "rotate(35 6.328 18.929)"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "strokeWidth": "2",
                            "d": "M7,20 C12,20 14,15 14,10 C14,5 12,0 7,0 C2,8.74747714e-16 0,5 0,10 C2.1431319e-16,15 2,20 7,20 Z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M7,2 C6,3 4,7 6,10 C8,13 7.5,17 7,18 C8.5,17 10,13 8,10 C6,7 6.5,3 7,2 Z"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function GrColumns(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M17,2 L17,22 L17,2 Z M12,2 L12,22 L12,2 Z M7,2 L7,22 L7,2 Z M2,22 L22,22 L22,2 L2,2 L2,22 Z"
                }
            }
        ]
    })(props);
}
function GrCommand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,9 C9,9 6.83333333,9 5.5,9 C3.5,9 2,7.5 2,5.5 C2,3.5 3.5,2 5.5,2 C7.5,2 9,3.5 9,5.5 C9,6.83333333 9,9 9,12 C9,15 9,17.1666667 9,18.5 C9,20.5 7.5,22 5.5,22 C3.5,22 2,20.5 2,18.5 C2,16.5 3.5,15 5.5,15 C6.83333333,15 9,15 12,15 C15,15 17.1666667,15 18.5,15 C20.5,15 22,16.5 22,18.5 C22,20.5 20.5,22 18.5,22 C16.5,22 15,20.5 15,18.5 C15,17.1666667 15,15 15,12 L15,5.5 C15,3.5 16.5,2 18.5,2 C20.5,2 22,3.5 22,5.5 C22,7.5 20.5,9 18.5,9 L12,9 Z"
                }
            }
        ]
    })(props);
}
function GrCompare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M11,7 L1,7 L1,17 L7,17 L7,8 M10.9997,5 L10.9997,9 L12.9997,7 L10.9997,5 Z M10.9999,16.99965 L12.9999,18.9994 L12.9999,14.9994 L10.9999,16.99965 Z M13,17 L23,17 L23,7 L17,7 L17,16"
                }
            }
        ]
    })(props);
}
function GrCompass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M10,10 L15,9 L14,14 L9,15 L10,10 Z M12,14 C13.1045695,14 14,13.1045695 14,12 C14,10.8954305 13.1045695,10 12,10 C10.8954305,10 10,10.8954305 10,12 C10,13.1045695 10.8954305,14 12,14 Z"
                }
            }
        ]
    })(props);
}
function GrCompliance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M8,6 L16,6 L16,1 L8,1 L8,6 L8,6 L8,6 Z M16,3 L21,3 L21,23 L3,23 L3,3 L8,3 M8,14 L11,17 L17,11"
                }
            }
        ]
    })(props);
}
function GrConfigure(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M16,15 C20.0089021,14.9354541 23,11.9673591 23,8 C23,4.98813056 22.0029673,5.9851632 21,7 C20.0089021,7.97922849 18,10 18,10 L14,6 C14,6 16.0207715,3.99109792 17,3 C18.0148368,1.99703264 18.0148368,1 16,1 C12.0326409,0.999999999 9.05307486,3.99109792 9,8 C9.04154304,8.97626113 9,11 9,11 C7.11486635,12.8970031 4.65923194,15.3526375 3,17 C0.0682492584,19.9436202 4.05637975,23.9317507 7,21 C8.65052042,19.3376102 11.1126942,16.8754364 13,15 C13,15 15.0237389,14.958457 16,15 Z"
                }
            }
        ]
    })(props);
}
function GrConnect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M10,21 C7.50000053,23.5 5.00000002,23 3,21 C0.999999977,19 0.500000114,16.5 3.00000004,14 C5.49999997,11.5 5.99999998,11 5.99999998,11 L13.0000005,18 C13.0000005,18 12.4999995,18.5 10,21 Z M14.0003207,3 C16.5,0.499999776 19,0.999999776 21.001068,3 C23.002136,5.00000022 23.5,7.49999978 21.001068,10 C18.5021359,12.5000002 18.0007478,13 18.0007478,13 L11,6 C11,6 11.5006414,5.50000022 14.0003207,3 Z M11,9.9999 L8.5,12.4999999 L11,9.9999 Z M14,13 L11.5,15.5 L14,13 Z"
                }
            }
        ]
    })(props);
}
function GrConnectivity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "2",
                    "d": "M6,8 L6,12 L9,15 L15,9 L11,5 L5,5 L2.5,3 M17,7 L20,10 L20,17 M13,11 L16,14 M11,13 L14,16 M7,17 L10,20 L20,20"
                }
            }
        ]
    })(props);
}
function GrConsole(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 18a1 1 0 100-2v2zm-8-2a1 1 0 100 2v-2zm.707-8.707a1 1 0 10-1.414 1.414l1.414-1.414zM11 11l.707.707a1 1 0 000-1.414L11 11zm-3.707 2.293a1 1 0 101.414 1.414l-1.414-1.414zM7 4h10V2H7v2zm13 3v10h2V7h-2zm-3 13H7v2h10v-2zM4 17V7H2v10h2zm3 3a3 3 0 01-3-3H2a5 5 0 005 5v-2zm13-3a3 3 0 01-3 3v2a5 5 0 005-5h-2zM17 4a3 3 0 013 3h2a5 5 0 00-5-5v2zM7 2a5 5 0 00-5 5h2a3 3 0 013-3V2zm9 14H8v2h8v-2zM7.293 8.707l3 3 1.414-1.414-3-3-1.414 1.414zm3 1.586l-3 3 1.414 1.414 3-3-1.414-1.414z"
                }
            }
        ]
    })(props);
}
function GrContactInfo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M5,12 C3.343,12 2,10.657 2,9 C2,7.343 3.343,6 5,6 C6.657,6 8,7.343 8,9 C8,10.657 6.657,12 5,12 Z M9,18 L9,16 C9,13.7504 7.2128,12 4.964,12 L5.0184,12 C2.7688,12 1,13.7504 1,16 L1,18 M12,7 L24,7 M12,17 L22,17 M12,12 L19,12"
                }
            }
        ]
    })(props);
}
function GrContact(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,2 L22,2 L22,18 L14,18 L6,22 L6,18 L1,18 L1,2 Z M6,10 L7,10 L7,11 L6,11 L6,10 Z M11,10 L12,10 L12,11 L11,11 L11,10 Z M16,10 L17,10 L17,11 L16,11 L16,10 Z"
                }
            }
        ]
    })(props);
}
function GrContract(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2,14 L10,14 L10,22 M1,23 L10,14 M23,1 L14,10 M22,10 L14,10 L14,2"
                }
            }
        ]
    })(props);
}
function GrCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M9,15 L17,15 L9,15 Z M9,11 L19,11 L9,11 Z M9,7 L13,7 L9,7 Z M16,1 L16,7 L22,7 M6,5 L2,5 L2,23 L18,23 L18,19 M22,19 L6,19 L6,1 L17,1 L22,6 L22,19 L22,19 Z"
                }
            }
        ]
    })(props);
}
function GrCpu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeWidth": "2",
                    "d": "M1 18h3m-3-4h3m-3-4h3M1 6h3m16 12h3m-3-4h3m-3-4h3m-3-4h3M6 1v3m4-3v3m4-3v3m4-3v3M6 20v3m4-3v3m4-3v3m4-3v3M5 20h14a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v14a1 1 0 001 1zm8-13h4v4h-4V7z"
                }
            }
        ]
    })(props);
}
function GrCreativeCommons(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.9836946,0 C8.691525,0 5.7944764,1.21835303 3.55571004,3.48973014 C1.25096379,5.82708715 0,8.85609556 0,12.0163054 C0,15.2098843 1.21797384,18.1729128 3.52272009,20.4772799 C5.82746635,22.7820262 8.82310561,24.03299 11.9836946,24.03299 C15.1439044,24.03299 18.2059028,22.7820262 20.5762498,20.4446692 C22.8150161,18.2388928 24,15.3088542 24,12.0163054 C24,8.7571257 22.8150161,5.7944764 20.5432598,3.52272009 C18.2388928,1.21797384 15.2758642,0 11.9836946,0 L11.9836946,0 Z M12.0163054,2.17278645 C14.7161727,2.17278645 17.1195096,3.19319977 18.9957657,5.07021425 C20.839411,6.91348038 21.8268344,9.34980724 21.8268344,12.0163054 C21.8268344,14.7157935 20.8720217,17.0865196 19.0287556,18.897175 C17.0861404,20.806421 14.5842129,21.8272135 12.0163054,21.8272135 C9.41578715,21.8272135 6.97946028,20.8068002 5.102825,18.9297858 C3.22618972,17.0531505 2.17278645,14.5842129 2.17278645,12.0163054 C2.17278645,9.41578715 3.22618972,6.94684952 5.102825,5.0368451 C6.94647033,3.16058902 9.31681729,2.17278645 12.0163054,2.17278645 L12.0163054,2.17278645 Z M11.8615939,10.0194653 C11.1828351,8.78177337 10.0247741,8.28919927 8.68052834,8.28919927 C6.72388296,8.28919927 5.16652974,9.67326044 5.16652974,12.0159262 C5.16652974,14.3984074 6.63060102,15.7430323 8.74688744,15.7430323 C10.1047842,15.7430323 11.2628452,14.9975352 11.9014093,13.866397 L10.4107944,13.1076281 C10.0778613,13.9058333 9.57201542,14.1458636 8.93345131,14.1458636 C7.82847753,14.1458636 7.32263161,13.2274537 7.32263161,12.0159262 C7.32263161,10.805157 7.74884662,9.88636795 8.93345131,9.88636795 C9.25273336,9.88636795 9.89167667,10.0592808 10.2644252,10.8582443 L11.8615939,10.0194653 L11.8615939,10.0194653 Z M18.7936548,10.0194653 C18.114896,8.78177337 16.956835,8.28919927 15.6125893,8.28919927 C13.6559439,8.28919927 12.0985907,9.67326044 12.0985907,12.0159262 C12.0985907,14.3984074 13.5626619,15.7430323 15.6789484,15.7430323 C17.0368451,15.7430323 18.1949061,14.9975352 18.8334703,13.866397 L17.3428553,13.1076281 C17.0099223,13.9058333 16.5040763,14.1458636 15.8655122,14.1458636 C14.7605385,14.1458636 14.2546925,13.2274537 14.2546925,12.0159262 C14.2546925,10.805157 14.6809075,9.88636795 15.8655122,9.88636795 C16.1847943,9.88636795 16.8237376,10.0592808 17.1964861,10.8582443 L18.7936548,10.0194653 L18.7936548,10.0194653 Z"
                }
            }
        ]
    })(props);
}
function GrCreditCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,5.00087166 C1,4.4481055 1.43945834,4 2.00246167,4 L21.9975383,4 C22.5511826,4 23,4.44463086 23,5.00087166 L23,18.9991283 C23,19.5518945 22.5605417,20 21.9975383,20 L2.00246167,20 C1.44881738,20 1,19.5553691 1,18.9991283 L1,5.00087166 Z M1,8 L23,8 L23,10 L1,10 L1,8 Z M5,15 L7,15 L7,15.5 L5,15.5 L5,15 Z M10,15 L16,15 L16,15.5 L10,15.5 L10,15 Z"
                }
            }
        ]
    })(props);
}
function GrCss3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "2",
                    "d": "M7,3 L21,3 L18,18 L10,22 L3,18 L4,14 M5,9 L19,9"
                }
            }
        ]
    })(props);
}
function GrCube(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,2 L22,7 L22,17 L12,22 L2,17 L2,7 L12,2 Z M2,7 L12,12 L22,7 M12,12 L12,21.9999998 L12,12 Z"
                }
            }
        ]
    })(props);
}
function GrCubes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M6.5,10.5 L12,13.5 L17.5,10.5 L17.5,4.5 L12,1.5 L6.5,4.5 L6.5,10.5 Z M6.5,4.5 L12,7.5 L17.5,4.5 M12,7.5 L12,13.5 L12,7.5 Z M1,19.5 L6.5,22.5 L12,19.5 L12,13.5 L6.5,10.5 L1,13.5 L1,19.5 Z M1,13.5 L6.5,16.5 L12,13.5 M6.5,16.5 L6.5,22.5 L6.5,16.5 Z M12,19.5 L17.5,22.5 L23,19.5 L23,13.5 L17.5,10.5 L12,13.5 L12,19.5 Z M12,13.5 L17.5,16.5 L23,13.5 M17.5,16.5 L17.5,22.5 L17.5,16.5 Z"
                }
            }
        ]
    })(props);
}
function GrCurrency(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,5 L23,5 L23,19 L1,19 L1,5 Z M2,9 L2,9 C3.65685425,9 5,7.65685425 5,6 M2,15 L2,15 C3.65685425,15 5,16.3431458 5,18 M22,9 L22,9 C20.3431458,9 19,7.65685425 19,6 M22,15 L22,15 C20.3431458,15 19,16.3431458 19,18 M12,16 C13.6568542,16 15,14.209139 15,12 C15,9.790861 13.6568542,8 12,8 C10.3431458,8 9,9.790861 9,12 C9,14.209139 10.3431458,16 12,16 Z"
                }
            }
        ]
    })(props);
}
function GrCursor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "points": "6 3 18 14 13 15 16 20.5 13 22 10 16 6 19"
                }
            }
        ]
    })(props);
}
function GrCut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M23,4 L8,16 L23,4 Z M23,20 L8,8 L23,20 Z M5,9 C6.65685425,9 8,7.65685425 8,6 C8,4.34314575 6.65685425,3 5,3 C3.34314575,3 2,4.34314575 2,6 C2,7.65685425 3.34314575,9 5,9 Z M5,21 C6.65685425,21 8,19.6568542 8,18 C8,16.3431458 6.65685425,15 5,15 C3.34314575,15 2,16.3431458 2,18 C2,19.6568542 3.34314575,21 5,21 Z"
                }
            }
        ]
    })(props);
}
function GrCycle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M13,20 C19,19 21,14 21,10 M14,16 L12,20 L16,23 M0,9 L4,6 L7,10 M9.00000008,20 C3,17 2.00000006,12 3.99999998,6 M20,6.99999999 C16,0.99999995 10,1 6,4.00609254 M20,2 L20,7 L15,7"
                }
            }
        ]
    })(props);
}
function GrDashboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M15,16 C15,14.3431458 13.6568542,13 12,13 C10.3431458,13 9,14.3431458 9,16 M5,5 L7,7 M12,7 L12,13 M12,3 L12,5 M19,12 L21,12 M3,12 L5,12 M17,7 L19,5 M3,17 L21,17"
                }
            }
        ]
    })(props);
}
function GrDatabase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,2 L23,2 L23,9 L1,9 L1,2 Z M4,12 L5,12 L5,13 L4,13 L4,12 Z M4,5 L5,5 L5,6 L4,6 L4,5 Z M4,19 L5,19 L5,20 L4,20 L4,19 Z M1,16 L23,16 L23,23 L1,23 L1,16 Z M1,9 L23,9 L23,16 L1,16 L1,9 Z"
                }
            }
        ]
    })(props);
}
function GrDebian(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.65603874,5.16700815 C2.68642627,5.33364645 3.03933499,4.93419361 2.7631231,5.55645706 C2.23136472,5.92819947 2.69882551,5.71915014 2.65603874,5.16700815 L2.65603874,5.16700815 Z M2.65866423,5.19930536 C2.65706423,5.17900536 2.65606423,5.15910536 2.65376423,5.13840536 C2.65336423,5.16220536 2.65536423,5.18170536 2.65866423,5.19930536 L2.65866423,5.19930536 Z M2.21290675,6.95977879 C1.868546,7.39990489 2.05448766,7.49365067 2.0181823,7.79306417 C2.14278529,7.41066029 2.16532936,7.18103949 2.21290675,6.95977879 L2.21290675,6.95977879 Z M13.0395111,0 C12.6680035,0.0312799047 12.297905,0.0498318001 11.9324561,0.0968925575 L12.0934114,0.118873031 C12.3623434,0.0203366347 12.7543286,0.0648611837 13.0395111,0 L13.0395111,0 Z M12.4285197,0.467238997 L12.4387115,0.427538997 L12.2886995,0.493438997 L12.4285197,0.467238997 L12.4285197,0.467238997 Z M12.0148829,0.309558336 C12.227032,0.34764843 12.4735139,0.376861794 12.4387115,0.427538997 C12.6709155,0.376673927 12.7236592,0.32975407 12.0148829,0.309558336 L12.0148829,0.309558336 Z M9.80002141,13.2015757 C9.66175108,13.0486518 9.57979397,12.8644479 9.48820866,12.6809015 C9.57580179,13.0035166 9.75530899,13.280527 9.92236998,13.5623279 L9.80002141,13.2015757 L9.80002141,13.2015757 Z M14.1172119,12.9648629 C14.2606016,12.8527531 14.3906527,12.7394692 14.5066608,12.629285 C14.1832002,12.7084241 13.8542916,12.7101619 13.5228937,12.6798683 C13.1252256,12.6855982 13.5980875,12.8847845 14.1172119,12.9648629 L14.1172119,12.9648629 Z M15.6571131,12.147875 C15.8942016,11.8210799 16.0668986,11.4631927 16.1274389,11.0931411 C16.0742724,11.3569068 15.9313054,11.5847428 15.7963697,11.8249781 C15.0532137,12.2929556 15.726671,11.5471224 15.795947,11.2635367 C14.9967126,12.269754 15.6861856,11.8669195 15.6571131,12.147875 L15.6571131,12.147875 Z M16.4451694,10.0977732 C16.4930286,9.38167002 16.3039402,9.60800315 16.240488,9.88135006 C16.3145077,9.91995679 16.3734511,10.3861495 16.4451694,10.0977732 L16.4451694,10.0977732 Z M11.8867574,15.2447735 C11.3145606,14.9767808 10.7906457,14.5723025 10.3596781,14.0769904 C10.5883126,14.4117699 10.8349823,14.7369682 11.153934,14.9926086 C10.6143792,14.8097668 9.89357932,13.6851931 9.68312098,13.6393065 C10.6132989,15.3047501 13.4566704,16.5598445 14.9457536,15.9369705 C14.2566564,15.9625674 13.3814766,15.9512484 12.6074633,15.6651265 C12.3129343,15.5135646 11.9222173,15.2147147 11.9101938,15.1117165 C11.8954932,15.1495717 11.871728,15.1878027 11.8867574,15.2447735 L11.8867574,15.2447735 Z M11.9266054,15.0880452 C11.9135054,15.1006452 11.9080054,15.1174452 11.9105054,15.1383452 C11.9171054,15.1216452 11.9226054,15.1049452 11.9266054,15.0880452 L11.9266054,15.0880452 Z M9.12642322,13.5046996 C9.38774663,13.8598158 9.59505819,14.2443332 9.9288514,14.5219071 C9.68871003,14.0531782 9.510377,13.8593931 9.18217284,13.2257637 L9.12642322,13.5046996 L9.12642322,13.5046996 Z M20.4597996,8.57609506 C20.4664689,8.21097497 20.5613419,8.38475222 20.5982578,8.29485772 C20.5265864,8.25366782 20.3385313,7.97374555 20.2238383,7.43682082 C20.3068756,7.31071489 20.4457565,7.76394474 20.5586178,7.78249664 C20.4859601,7.35556821 20.3609344,7.03004115 20.355909,6.70249453 C20.0262019,6.01335032 20.2392904,6.7944086 19.9717204,6.40669747 C19.6206903,5.31185384 20.2629147,6.15251302 20.3062651,5.65513435 C20.8383052,6.42595387 21.1418049,7.6204611 21.2808736,8.11530355 C21.1746347,7.51196773 21.0029709,6.92760651 20.793358,6.36217292 C20.9550648,6.43013391 20.5332088,5.12083977 21.0035345,5.98794127 C20.5010365,4.13960888 18.8535812,2.41254484 17.337727,1.60217926 C17.523058,1.77182343 17.7574695,1.98509978 17.6732579,2.01849319 C16.9195813,1.56953732 17.0519808,1.53468793 16.9441919,1.3450359 C16.3299598,1.09521936 16.2898971,1.36518467 15.8830705,1.34541163 C14.7254322,0.731555248 14.5023868,0.796792166 13.4371322,0.412086912 L13.4859777,0.638560937 C12.7187747,0.383155349 12.5924339,0.735500461 11.7637043,0.639453306 C11.7133089,0.600095108 12.0293017,0.496955963 12.2892631,0.459194636 C11.5478448,0.556979564 11.5825533,0.313080848 10.8571507,0.48605966 C11.0359534,0.36065824 11.2250418,0.277667862 11.4156332,0.171006205 C10.8111232,0.207734262 9.97238965,0.522740749 10.2312708,0.236243124 C9.24524928,0.676275296 7.49385642,1.29388903 6.5109817,2.21547205 L6.4801245,2.00891195 C6.02975963,2.54954706 4.51625373,3.62358439 4.39564292,4.3237658 L4.27526696,4.35189893 C4.0409025,4.74867465 3.88934056,5.19838199 3.70349284,5.60657066 C3.39694038,6.12884174 3.25420821,5.8075417 3.29784038,5.88940487 C2.6950212,7.11176343 2.3956077,8.13874 2.13691443,8.98099605 C2.32116528,9.25659737 2.14132932,10.6396764 2.21102808,11.7466375 C1.908186,17.2136227 6.04793579,22.5218601 10.5729544,23.7472715 C11.236032,23.9847827 12.2225702,23.9755773 13.0613977,24 C12.0715718,23.7167901 11.9434463,23.8500349 10.9793584,23.5137055 C10.2838267,23.1863467 10.1313254,22.8121151 9.63873733,22.3848109 L9.83364965,22.7293126 C8.86754209,22.3873471 9.27173857,22.3060476 8.48579574,22.0570764 L8.69399967,21.7851855 C8.38082489,21.7615612 7.86447163,21.2572784 7.72328936,20.9783424 L7.38071335,20.9918219 C6.96919004,20.4838287 6.74985497,20.1180041 6.76577672,19.8343715 L6.65512288,20.0314443 C6.52972146,19.8161953 5.14067765,18.1269396 5.86138356,18.519911 C5.72748115,18.3976094 5.54947689,18.3208656 5.35649021,17.9703052 L5.50326153,17.8027276 C5.15650547,17.3564488 4.86507633,16.7845338 4.88715074,16.5941303 C5.07210609,16.8439469 5.20041945,16.8906319 5.32755864,16.9332308 C4.45181525,14.7605455 4.40268795,16.8135124 3.7393755,14.7218918 L3.8798063,14.7101971 C3.77211137,14.5484903 3.70682749,14.3725056 3.62040853,14.1998556 L3.6814654,13.5912595 C3.05098276,12.8623344 3.50501104,10.4917309 3.59603275,9.19164225 C3.65910919,8.66293672 4.12229601,8.10013327 4.47464112,7.21762665 L4.2599088,7.18061679 C4.67025794,6.46488936 6.60256701,4.30638808 7.49751984,4.41741765 C7.93111755,3.87279036 7.41157055,4.41544504 7.3267015,4.27825495 C8.27904778,3.29279705 8.57846129,3.58206572 9.22110834,3.40471899 C9.91429169,2.99328962 8.62617958,3.56515766 8.95490038,3.24775587 C10.1529301,2.94181398 9.80401359,2.55213024 11.3671164,2.39667005 C11.53197,2.49050977 10.9844308,2.5415627 10.8470058,2.66339464 C11.8453326,2.17503361 14.0060883,2.28601622 15.4094101,2.93439322 C17.0381256,3.6956315 18.8678121,5.94534236 18.9399062,8.06204317 L19.0220982,8.08411758 C18.9804856,8.92562216 19.1508342,9.89868082 18.8556947,10.7925534 L19.0566657,10.3693823 C19.0801022,11.012546 18.8683757,11.3244527 18.6775965,11.8769234 L18.3338463,12.0486811 C18.052609,12.5948113 18.3609932,12.3953902 18.1598342,12.8297394 C17.7207414,13.2203625 16.8271976,14.0514404 16.5414514,14.1274327 C16.332496,14.1227361 16.6826807,13.8809508 16.7285673,13.7864066 C16.1408714,14.1898986 16.2568794,14.3922317 15.3580284,14.6371637 L15.331633,14.5789718 C13.1144702,15.621964 10.0350434,13.555142 10.0755758,10.7347372 C10.0517636,10.9137278 10.0081784,10.8690154 9.95905107,10.9414852 C9.84468686,9.49030429 10.6292676,8.03287678 11.9523231,7.43776015 C13.2464469,6.79713268 14.7636162,7.06005296 15.6907883,7.92400768 C15.181621,7.25703181 14.1681239,6.54999325 12.9667595,6.61612254 C11.7901936,6.63467443 10.6894321,7.38252717 10.3220577,8.19425478 C9.71914454,8.57384065 9.64921094,9.65736528 9.38652549,9.85561224 C9.03319407,12.4530655 10.0513878,13.5751499 11.7738491,14.8952464 C11.9110392,14.987818 11.9288397,15.0405617 11.9177085,15.0881391 C11.9182721,15.0875755 11.9185539,15.0869649 11.9191175,15.0864483 C13.9511372,15.8454322 16.0503663,15.6614631 17.8083815,14.2520827 C18.2556466,13.9036358 18.7443364,13.3110554 18.8855656,13.3028362 C18.6728998,13.6223985 18.921871,13.4565117 18.7584264,13.7389701 C19.2043294,13.020002 18.5648761,13.4462259 19.219171,12.497543 L19.4609562,12.83035 C19.3711086,12.2338713 20.2019517,11.5092671 20.1175993,10.5657037 C20.3082377,10.2770925 20.3300772,10.8761544 20.127932,11.5401243 C20.4084179,10.8035906 20.2019517,10.6852342 20.2739989,10.0775305 C20.3519638,10.2817422 20.4541166,10.4988229 20.5066255,10.7144476 C20.3237837,10.0027123 20.6941171,9.51580727 20.7857024,9.10221742 C20.6957609,9.06210775 20.5037606,9.41684817 20.4597996,8.57609506 L20.4597996,8.57609506 Z"
                }
            }
        ]
    })(props);
}
function GrDeliver(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M3,18 L1,18 L1,3 L14,3 L14,17 M14,18 L9,18 M6,21 C7.65685425,21 9,19.6568542 9,18 C9,16.3431458 7.65685425,15 6,15 C4.34314575,15 3,16.3431458 3,18 C3,19.6568542 4.34314575,21 6,21 Z M17,21 C18.6568542,21 20,19.6568542 20,18 C20,16.3431458 18.6568542,15 17,15 C15.3431458,15 14,16.3431458 14,18 C14,19.6568542 15.3431458,21 17,21 Z M14,8 L19,8 L23,13 L23,18 L20,18"
                }
            }
        ]
    })(props);
}
function GrDeploy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M23,1 C23,1 16.471872,0.541707069 14,3 C13.9767216,3.03685748 10,7 10,7 L5,8 L2,10 L10,14 L14,22 L16,19 L17,14 C17,14 20.9631426,10.0232786 21,10 C23.4582929,7.5281282 23,1 23,1 Z M17,8 C16.4475,8 16,7.5525 16,7 C16,6.4475 16.4475,6 17,6 C17.5525,6 18,6.4475 18,7 C18,7.5525 17.5525,8 17,8 Z M7,17 C6,16 4,16 3,17 C2,18 2,22 2,22 C2,22 6,22 7,21 C8,20 8,18 7,17 Z"
                }
            }
        ]
    })(props);
}
function GrDescend(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2,8 L8,2 L14,8 M11,21 L22,21 M11,17 L19,17 M11,13 L16,13 M8,2 L8,22",
                    "transform": "matrix(1 0 0 -1 0 24)"
                }
            }
        ]
    })(props);
}
function GrDescending(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11.9191 16.7136L11.5655 17.0671L11.212 16.7136L7 12.5016L7.70711 11.7945L11.0655 15.1529V7.00009H12.0655V15.1529L15.4239 11.7945L16.1311 12.5016L11.9191 16.7136Z"
                }
            }
        ]
    })(props);
}
function GrDesktop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,1 L23,1 L23,19 L1,19 L1,1 Z M5,23 L19,23 L5,23 Z M10,19 L10,23 L10,19 Z M14,19 L14,23 L14,19 Z"
                }
            }
        ]
    })(props);
}
function GrDetach(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4,4 L20,20 M22,12 C22,12 16.7200572,17.2799437 16.7200572,17.2799437 M15,19 C15,19 13.7932491,20.2067517 13.0000004,21.0000004 C6.99999996,27.0000004 -2.00000007,18.0000004 3.99999994,12.0000004 C4.88551518,11.1144851 6,10 6,10 M8,8 C8,8 10.1615592,5.83844087 13,3.00000008 C17,-0.999999955 23,4.99999994 19,9.00000005 C16.9873313,11.0126688 14,14 14,14 M12,16 C12,16 10.6478339,17.3521667 9.99999995,18.0000004 C7.99999952,20 5,17 6.99999995,15.0000004 C7.50049504,14.4995054 9,13 9,13 M11,11 C10.7388543,11.261146 16,6 16,6"
                }
            }
        ]
    })(props);
}
function GrDevice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "2",
                    "d": "M2,7 L22,7 L22,21 L16,21 L12,17 L8,21 L2,21 L2,7 Z M6,2 L11,7 L12,7 L13,7 L18,2"
                }
            }
        ]
    })(props);
}
function GrDiamond(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M6,3 L18,3 L22,9 L12,21 L2,9 L6,3 Z M2,9 L22,9 M11,3 L7,9 L12,20 M13,3 L17,9 L12,20"
                }
            }
        ]
    })(props);
}
function GrDirections(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M17,11 L22,6 L17,1 M22,6 L18,6 C14.686,6 12,8.686 12,12 L12,24 M7,6 L2,11 L7,16 M2,11 L6,11 C9.314,11 12,13.686 12,17 L12,24"
                }
            }
        ]
    })(props);
}
function GrDisabledOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeWidth": "2",
                    "d": "M18 12H6M4 22h16a2 2 0 002-2V4a2 2 0 00-2-2H4a2 2 0 00-2 2v16a2 2 0 002 2z"
                }
            }
        ]
    })(props);
}
function GrDisc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,21 C16.9705627,21 21,16.9705627 21,12 C21,7.02943725 16.9705627,3 12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 Z M12,14 C13.1045695,14 14,13.1045695 14,12 C14,10.8954305 13.1045695,10 12,10 C10.8954305,10 10,10.8954305 10,12 C10,13.1045695 10.8954305,14 12,14 Z"
                }
            }
        ]
    })(props);
}
function GrDislikeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M13 24h.997l.003-.997L13 23l1 .003v-.261l.002-.698.006-2.207c.004-1.665.008-3.498.008-4.163 0-.42.155-.83.454-1.132.287-.291.767-.542 1.53-.542h6.999L23 13v1h1V0h-1v1-1H4C2.846 0 1.797.29 1.043 1.043.289 1.797 0 2.846 0 4v9.999L1 14H0v1h7v5c0 1.154.29 2.203 1.043 2.957C8.797 23.711 9.846 24 11 24h2Zm6-12V2h3v10h-3Z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function GrDislike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,23 L20,23 C22,23 23,22 23,20 L23,10 L16,10 L16,4 C16,2 15,1 13,1 L11,1 C11,1 10.9842682,7 10.9842677,8.32575545 C10.9842672,9.65151089 10,11 8,11 L1,11 L1,23 Z M6,23 L6,11",
                    "transform": "rotate(180 12 12)"
                }
            }
        ]
    })(props);
}
function GrDocker(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.94221099,14.9002344 C6.9980621,14.9002344 7.05128211,14.9107588 7.10043586,14.9297745 C7.04721586,14.9606302 7.01109801,15.018335 7.01109801,15.0842919 C7.01109801,15.1828984 7.09098782,15.2626686 7.18959432,15.2626686 C7.25710599,15.2626686 7.31570779,15.2251754 7.34608506,15.1698027 C7.36743286,15.2214082 7.37939241,15.2780367 7.37939241,15.3374756 C7.37939241,15.578939 7.18361455,15.774657 6.94221099,15.774657 C6.70080744,15.774657 6.50496978,15.578939 6.50496978,15.3374756 C6.50496978,15.0959525 6.70080744,14.9002344 6.94221099,14.9002344 L6.94221099,14.9002344 Z M6.94221099,16.0853662 C6.52978585,16.0853662 6.19420083,15.7499008 6.19420083,15.3374756 C6.19420083,14.9250505 6.52978585,14.5895253 6.94221099,14.5895253 C7.35457634,14.5895253 7.69010156,14.9250505 7.69010156,15.3374756 C7.69010156,15.7499008 7.35457634,16.0853662 6.94221099,16.0853662 L6.94221099,16.0853662 Z M20.3859431,11.1838037 C18.2619865,16.8117894 13.4653093,19.318631 7.81023526,19.318631 C5.13823222,19.318631 3.00656172,18.3995992 1.64323262,16.8672219 L1.65327865,16.8605843 C2.04609012,16.880497 2.39758135,16.8872541 2.75439457,16.8872541 C3.08065114,16.8872541 3.39979178,16.8838457 3.6953721,16.8672219 C3.72108514,16.8657867 3.75325633,16.8621989 3.77878997,16.8605843 C3.77902916,16.8605245 3.86998155,16.8546046 3.82549202,16.853887 C4.57667146,16.8075437 5.15892224,16.7031368 5.70188589,16.5482008 C5.70200548,16.548141 5.70212508,16.548141 5.70224467,16.5480812 C5.80091098,16.5198567 5.89658739,16.4901372 5.98825735,16.4583846 C6.09081051,16.4228049 6.14510687,16.3108635 6.109587,16.2083104 C6.07406714,16.1056974 5.96218553,16.0512815 5.85957258,16.0869807 C5.16992503,16.3259326 4.26010213,16.4574876 3.14505333,16.4821841 L3.14475434,16.4821841 C2.57739321,16.4947416 1.95717085,16.4797922 1.28450587,16.4365584 L1.28444607,16.4365584 C1.14529669,16.2507668 1.01649231,16.0576798 0.89869073,15.8577161 L0.71248051,15.5172277 C0.149903198,14.4112083 -0.0964037696,13.1191582 0.0343141305,11.7160038 L16.3965356,11.7160038 C17.7407294,11.7160038 19.0534696,11.2143604 19.6764427,10.6609919 C18.5601381,9.75332174 18.670764,7.59731356 19.3822377,6.774616 C19.9997093,7.270758 20.9954018,8.31584342 20.824141,9.64622396 C21.6011531,9.255625 22.9506091,9.06259783 24,9.66816973 C23.3411483,10.9541803 21.8929064,11.3383809 20.3859431,11.1838037 L20.3859431,11.1838037 Z M2.25508329,11.3188869 L4.46771995,11.3188869 L4.46771995,9.1061306 L2.25508329,9.1061306 L2.25508329,11.3188869 Z M4.80808879,11.3188869 L7.02096464,11.3188869 L7.02096464,9.1061306 L4.80808879,9.1061306 L4.80808879,11.3188869 Z M4.80808879,8.76576176 L7.02096464,8.76576176 L7.02096464,6.5530653 L4.80808879,6.5530653 L4.80808879,8.76576176 Z M7.36127369,11.3188869 L9.57402994,11.3188869 L9.57402994,9.1061306 L7.36127369,9.1061306 L7.36127369,11.3188869 Z M7.36127369,8.76576176 L9.57402994,8.76576176 L9.57402994,6.5530653 L7.36127369,6.5530653 L7.36127369,8.76576176 Z M9.91433899,11.3188869 L12.1270952,11.3188869 L12.1270952,9.1061306 L9.91433899,9.1061306 L9.91433899,11.3188869 Z M9.91433899,8.76576176 L12.1270952,8.76576176 L12.1270952,6.5530653 L9.91433899,6.5530653 L9.91433899,8.76576176 Z M9.91433899,6.21275626 L12.1270952,6.21275626 L12.1270952,4 L9.91433899,4 L9.91433899,6.21275626 Z M12.4674043,11.3188869 L14.6801605,11.3188869 L14.6801605,9.1061306 L12.4674043,9.1061306 L12.4674043,11.3188869 Z"
                }
            }
        ]
    })(props);
}
function GrDocumentCloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4.99787498,6.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L19,23 M18,1 L18,6 L23,6 M11,13 L6.00166547,13 C4.34389141,13 3,14.3465171 3,16 L3,16 C3,17.6568542 4.34306961,19 5.9906311,19 L7,19 L7,20.0093689 C7,21.6610488 8.33902013,23 10.0016655,23 L11.9983345,23 C13.6561086,23 15,21.6569304 15,20.0093689 L15,19 M11,19 L15.9983345,19 C17.6561086,19 19,17.6534829 19,16 L19,16 C19,14.3431458 17.6569304,13 16.0093689,13 L15,13 L15,11.9906311 C15,10.3389512 13.6609799,9 11.9983345,9 L10.0016655,9 C8.34389141,9 7,10.3430696 7,11.9906311 L7,13"
                }
            }
        ]
    })(props);
}
function GrDocumentConfig(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L16,23 M18,1 L18,6 L23,6 M9,14 L9,11 M9,20 C10.6568542,20 12,18.6568542 12,17 C12,15.3431458 10.6568542,14 9,14 C7.34314575,14 6,15.3431458 6,17 C6,18.6568542 7.34314575,20 9,20 Z M9,23 L9,20 M12,17 L15,17 M3,17 L6,17 M5,13 L7,15 M11,19 L13,21 M13,13 L11,15 M7,19 L5,21"
                }
            }
        ]
    })(props);
}
function GrDocumentCsv(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L4,23 M18,1 L18,6 L23,6 M7,13 C7,13 6.00000004,13 5,13 C3.99999996,13 3,13.5 3,14.5 L3,16 C3,16 3.00000001,16.5 3,17.5 C2.99999999,18.5 4,19 5,19 L7,19 M13.25,13 C13.25,13 12.25,13 10.75,13 C9.25,13 8.75,13.5 8.75,14.5 C8.75,15.5 9.25,16 10.75,16 C12.25,16 12.75,16.5 12.75,17.5 C12.75,18.5 12.25,19 10.75,19 C9.25,19 8.25,19 8.25,19 M20.5,12 C20.5,12 20.5,12 20.5,12.5 C20.5,13 18,19 18,19 L17.5,19 C17.5,19 15,13 15,12.5 L15,12"
                }
            }
        ]
    })(props);
}
function GrDocumentDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2.99787498,0.999999992 L17.4999998,0.999999992 L20.9999998,4.50000005 L21,23 L3,23 L2.99787498,0.999999992 Z M16,1 L16,6 L21,6 M12,9 L12,18 M8,15 L12,19 L16,15"
                }
            }
        ]
    })(props);
}
function GrDocumentExcel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L4,23 M18,1 L18,6 L23,6 M9.25,12 L7.25,15.25 L5.25,12 L5,12 L7.25,15.5 L4.75,19 L5,19 L7.25,15.75 L9.5,19 L9.75,19 L7.25,15.5 L9.5,12 L9.25,12 Z"
                }
            }
        ]
    })(props);
}
function GrDocumentImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4.99787498,6.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L19.9999998,23 M18,1 L18,6 L23,6 M3,11 L16,11 L16,23 L3,23 L3,11 Z M7,16 C7.55228475,16 8,15.5522847 8,15 C8,14.4477153 7.55228475,14 7,14 C6.44771525,14 6,14.4477153 6,15 C6,15.5522847 6.44771525,16 7,16 Z M5,23 L7,20 L9,22 L13,16 L16,20"
                }
            }
        ]
    })(props);
}
function GrDocumentLocked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4.99787498,6.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L17,23 M18,1 L18,6 L23,6 M4,15 L14,15 L14,23 L4,23 L4,15 Z M6,15 L6,13 C6,11.3431458 7.34314575,10 9,10 C10.6568542,10 12,11.3431458 12,13 L12,15 M8,19 L10,19"
                }
            }
        ]
    })(props);
}
function GrDocumentMissing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2.99787498,0.999999992 L17.4999998,0.999999992 L20.9999998,4.50000005 L21,23 L3,23 L2.99787498,0.999999992 Z M16,1 L16,6 L21,6 M9,12 L15,18 M15,12 L9,18"
                }
            }
        ]
    })(props);
}
function GrDocumentNotes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L4,23 M18,1 L18,6 L23,6 M9.75,12 L9.75,18.5 L9.5,18.5 L4.5,12 L4,12 L4,19 L4.25,19 L4.25,12.5 L4.5,12.5 L9.5,19 L10,19 L10,12 L9.75,12 Z"
                }
            }
        ]
    })(props);
}
function GrDocumentOutlook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2.99787498,8.99999999 L2.99787498,0.999999992 L17.4999998,0.999999992 L20.9999998,4.50000005 L21,23 L2,23 M16,1 L16,6 L21,6 M7.75,15.75 C7.75,13.5 6.49999991,12 5,12 C3.50000009,12 2.25,13.5 2.25,15.75 C2.25,18 3.50000006,19.5000002 5.00000003,19.5000001 C6.5,19.5 7.75,18 7.75,15.75 Z M5,12 C7.42537405,12 8,14.5 8,15.75 C8,17 7.5,19.5 5,19.5 C2.5,19.5 2,17 2,15.75 C2,14.5 2.559,12 5,12 Z"
                }
            }
        ]
    })(props);
}
function GrDocumentPdf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L4,23 M18,1 L18,6 L23,6 M3,12 L3.24999995,12 L4.49999995,12 C6.5,12 6.75,13.25 6.75,14 C6.75,14.75 6.5,16 4.49999995,16 L3.24999995,16 L3.24999995,18 L3,17.9999999 L3,12 Z M9.5,18 L9.5,12 C9.5,12 10.4473684,12 11.2052633,12 C12.3421053,12 13.5,12.5 13.5,15 C13.5,17.5 12.3421053,18 11.2052633,18 C10.4473684,18 9.5,18 9.5,18 Z M16.5,19 L16.5,12 L20.5,12 M16.5,15.5 L19.5,15.5"
                }
            }
        ]
    })(props);
}
function GrDocumentPerformance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L4,23 M18,1 L18,6 L23,6 M3,19 L8,14 L12,18 L18.5,11.5 M19,17.0003099 L19,11 L13,11"
                }
            }
        ]
    })(props);
}
function GrDocumentPpt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L4,23 M18,1 L18,6 L23,6 M4,12 L4.24999995,12 L5.49999995,12 C7.5,12 9,12.5 8.99999995,14.25 C8.9999999,16 7.5,16.5 5.49999995,16.5 L4.24999995,16.5 L4.24999995,19 L4,18.9999999 L4,12 Z"
                }
            }
        ]
    })(props);
}
function GrDocumentRtf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L4,23 M18,1 L18,6 L23,6 M20.5,12 L16.5,12 L16.5,19 M19.5,15.5 L16.5,15.5 M8.5,12 L14.5,12 M11.5,12 L11.5,19 M3,19 L3,12 L4.5,12 C5,12 7,12 7,14 C7,16 5,16 4.5,16 C4,16 3,16 3,16 M5.25,16 L7.5,19"
                }
            }
        ]
    })(props);
}
function GrDocumentSound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2.99787498,8.99999999 L2.99787498,0.999999992 L17.4999998,0.999999992 L20.9999998,4.50000005 L21,23 L18,23 M16,1 L16,6 L21,6 M1,14.0104121 L1,18.0104121 L4,18.0104121 L8,21.0104121 L8,11 L4,14.0104121 L1,14.0104121 Z M11,18 L11,18 C12.1045695,18 13,17.1045695 13,16 C13,14.8954305 12.1045695,14 11,14 M11,22 L11,22 C14.3137085,22 17,19.3137085 17,16 C17,12.6862915 14.3137085,10 11,10"
                }
            }
        ]
    })(props);
}
function GrDocumentStore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4.99787498,6.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L17,23 M18,1 L18,6 L23,6 M3,12 C3,12 4,10 9,10 C14,10 15,12 15,12 L15,21 C15,21 14,23 9,23 C4,23 3,21 3,21 L3,12 Z M3,17 C3,17 5,19 9,19 C13,19 15,17 15,17 M3,13 C3,13 5,15 9,15 C13,15 15,13 15,13"
                }
            }
        ]
    })(props);
}
function GrDocumentTest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4.99787498,5.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L20,23 M18,1 L18,6 L23,6 M6,9 L14,9 M8,9 L8,13.5 L3,21.5 L3,23 L17,23 L17,21.4188612 L12,13.5 L12,9 M5.5,17.5 C5.5,17.5 7.5,19.0000002 10,17.5000001 C12.5,16 14.5,17.5000001 14.5,17.5000001"
                }
            }
        ]
    })(props);
}
function GrDocumentText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M6,16 L16,16 L6,16 L6,16 Z M6,12 L18,12 L6,12 L6,12 Z M6,8 L11,8 L6,8 L6,8 Z M14,1 L14,8 L21,8 M3,23 L3,1 L15,1 L21,7 L21,23 L3,23 Z"
                }
            }
        ]
    })(props);
}
function GrDocumentThreat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4.99787498,6.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L17,23 M18,1 L18,6 L23,6 M9,23 C11.7614237,23 14,20.7614237 14,18 C14,15.2385763 11.7614237,13 9,13 C6.23857625,13 4,15.2385763 4,18 C4,20.7614237 6.23857625,23 9,23 Z M9,11 C9,11 9,10 9,9 C9,8 9,7 11,7 C13,7 13.0000001,8 13,9 C12.9999999,10 13,10.9999998 15,10.9999999 C17,11.0000001 17,11 17,11 M8,11 L10,11 L10,13 L8,13 L8,11 Z"
                }
            }
        ]
    })(props);
}
function GrDocumentTime(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4.99787498,6.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L17,23 M18,1 L18,6 L23,6 M10,23 C13.8659932,23 17,19.8659932 17,16 C17,12.1340068 13.8659932,9 10,9 C6.13400675,9 3,12.1340068 3,16 C3,19.8659932 6.13400675,23 10,23 Z M10,12 L10,16 L13,19"
                }
            }
        ]
    })(props);
}
function GrDocumentTransfer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L4,23 M18,1 L18,6 L23,6 M8,12 L4,16 L8,20 M4,16 L15,16"
                }
            }
        ]
    })(props);
}
function GrDocumentTxt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L4,23 M18,1 L18,6 L23,6 M2,12 L7,12 M4.5,12 L4.5,19 M16,12 L21,12 M18.5,12 L18.5,19 M14.5,11.5 L8.5,18.5 M8.5,11.5 L14.5,18.5"
                }
            }
        ]
    })(props);
}
function GrDocumentUpdate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2.99787498,6.99999999 L2.99787498,0.999999992 L17.4999998,0.999999992 L20.9999998,4.50000005 L21,23 L15,23 M16,1 L16,6 L21,6 M8,23 C11.8659932,23 15,19.8659932 15,16 C15,12.1340068 11.8659932,9 8,9 C4.13400675,9 1,12.1340068 1,16 C1,19.8659932 4.13400675,23 8,23 Z M4.5,16.5 L8,13 L11.5,16.5 M8,13.5 L8,20"
                }
            }
        ]
    })(props);
}
function GrDocumentUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2.99787498,0.999999992 L17.4999998,0.999999992 L20.9999998,4.50000005 L21,23 L3,23 L2.99787498,0.999999992 Z M16,1 L16,6 L21,6 M12,20 L12,11 M8,14 L12,10 L16,14"
                }
            }
        ]
    })(props);
}
function GrDocumentUser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L16,23 M18,1 L18,6 L23,6 M8,11 C6.34325,11 5,12.34325 5,14 C5,15.65675 6.34325,17 8,17 C9.65675,17 11,15.65675 11,14 C11,12.34325 9.65675,11 8,11 L8,11 Z M3,23 L3,22 C3,18 6,17 8,17 C10,17 13,18 13,22 L13,23 L3,23 Z"
                }
            }
        ]
    })(props);
}
function GrDocumentVerified(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2.99787498,0.999999992 L17.4999998,0.999999992 L20.9999998,4.50000005 L21,23 L3,23 L2.99787498,0.999999992 Z M16,1 L16,6 L21,6 M7.5,15 L10.5,18 L16.5,12"
                }
            }
        ]
    })(props);
}
function GrDocumentVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4.99787498,6.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L22.9999998,23 L4,23 M18,1 L18,6 L23,6 M3,10 L12,10 L12,19 L3,19 L3,10 Z M12,13 L17,10.5 L17,18.5 L12,16 L12,13 Z"
                }
            }
        ]
    })(props);
}
function GrDocumentWindows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L4,23 M18,1 L18,6 L23,6 M14.25,11.5 L8.25,18.5 M8.25,11.5 L14.25,18.5 M20.5,12 L16.5,12 L16.5,18 L20.5,18 M19.5,15 L16.5,15 M7,12 L3,12 L3,18 L7,18 M6,15 L3,15"
                }
            }
        ]
    })(props);
}
function GrDocumentWord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L4,23 M18,1 L18,6 L23,6 M14,12 L12.5,18.75 L12.25,18.75 L9.5,12 L9,12 L6.25,18.75 L6,18.75 L4.5,12 L4,12 L6,19 L6.5,19 L9,12.5 L9.5,12.5 L12,19 L12.5,19 L14.5,12 L14,12 Z"
                }
            }
        ]
    })(props);
}
function GrDocumentZip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L4,23 M18,1 L18,6 L23,6 M2,13 L7,13 L7,14 L3,18 L3,19 L8,19 M11,12 L11,20 L11,12 Z M15,13 L15,20 L15,13 Z M20,15 C20,13.895 19.105,13 18,13 L15,13 L15,17 L18,17 C19.105,17 20,16.105 20,15 Z"
                }
            }
        ]
    })(props);
}
function GrDocument(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M14,1 L14,8 L21,8 M21,23 L3,23 L3,1 L15,1 L18,4 L21,7 L21,23 L21,23 L21,23 Z"
                }
            }
        ]
    })(props);
}
function GrDomain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M13,3 L13,7 L13,3 Z M9,3 L9,7 L9,3 Z M5,3 L5,7 L5,3 Z M1,7 L23,7 L1,7 Z M1,21 L23,21 L23,3 L1,3 L1,21 Z"
                }
            }
        ]
    })(props);
}
function GrDos(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M0,4.54603675 L4.93388435,4.42224753 C5.89173496,4.40127916 6.77758573,4.50447894 7.67366806,4.81357302 L7.67366806,4.98877266 C6.90124863,5.64776074 6.34520769,6.43066436 5.84032455,7.30628357 L2.84298349,7.32712563 L2.8634466,15.8248762 L4.63514814,15.9481601 L6.44802853,15.9275707 C7.52954204,15.9169602 8.52857152,14.1868164 8.62153974,13.2494289 L8.88907602,10.2935194 C9.00263368,8.99562738 9.75446367,7.9965979 10.9183349,7.46076745 C11.6497018,8.68653329 11.9689011,10.0461936 11.9689011,11.4778537 C11.9689011,15.9794864 9.17795963,18.8219646 4.77927415,18.6572491 L0,18.4719443 L0,4.54603675 Z M20.7035438,8.71765744 C20.4667022,7.34751295 19.3235467,6.66780912 17.9531496,6.66780912 C17.0163936,6.66780912 15.4814074,7.0793451 15.4301233,8.25382683 C15.4193865,8.31584776 15.4301233,8.36700554 15.4505864,8.41904754 L16.0066274,10.0154231 C16.1200587,10.344854 16.1406481,10.7052322 16.1406481,11.0556315 C16.1406481,11.4570622 16.0891114,11.8588719 16.0378273,12.2606816 C14.0602315,11.7045143 12.6693712,10.74679 12.6693712,8.52174206 C12.6693712,5.52427469 15.0900819,4.12305658 17.8504551,4.12305658 C20.9199223,4.12305658 23.3199172,5.55547462 23.5158326,8.71765744 L20.7035438,8.71765744 Z M12.4634769,14.0839198 L15.2136185,14.1046356 C15.5019968,15.8658529 16.6658681,16.3501466 18.3963907,16.3501466 C19.4779043,16.3501466 21.0949956,16.0927156 21.0949956,14.7123396 C21.0949956,13.9913305 20.5284705,13.6202155 19.9517138,13.3011425 L20.0957135,10.5511273 C22.2896878,11.1480944 24,11.9723032 24,14.5472452 C24,17.5965019 21.0949956,18.8839097 18.4169802,18.8839097 C16.5012789,18.8839097 14.0189263,18.3276162 12.9989284,16.5149884 C12.6797291,15.9585685 12.3812455,15.2376858 12.3812455,14.5886767 C12.3812455,14.5372662 12.3912244,14.4857295 12.4017086,14.4343191 L12.4634769,14.0839198 Z M19.7047038,11.4570369 C19.7047038,13.033202 19.282431,14.506041 18.561422,15.8864171 C18.3757382,15.8965223 18.1904333,15.9169854 18.0050021,15.9169854 C17.4075297,15.9169854 15.9552801,15.515681 15.9552801,14.7844405 C15.9552801,14.6610302 15.9757432,14.537241 16.0170484,14.4236833 L16.5627314,12.600824 C16.6762891,12.2401932 16.6351102,11.8074362 16.6351102,11.4471843 C16.6351102,10.0357347 15.996459,9.15001021 15.9447959,8.18180172 C15.9141012,7.50235052 17.2016354,7.18251962 17.6549818,7.18251962 C17.9639495,7.18251962 18.2726647,7.18251962 18.5816325,7.2133406 C19.3234835,8.52184311 19.7047038,9.9432717 19.7047038,11.4570369 Z M10.6096071,17.0296989 L11.2583637,16.1030482 L12.3397509,16.1232587 C12.8549919,17.2460774 13.6995375,18.0083916 14.7295143,18.6676323 C13.9775579,18.9149581 13.2359595,19.0383683 12.4530559,19.0383683 C11.3097741,19.0383683 10.2383658,18.780811 9.17769436,18.3791276 L10.6096071,17.0296989 Z M12.5356662,6.70871009 C12.3705719,6.69847853 12.2058564,6.68837329 12.0412673,6.68837329 C10.3003867,6.68837329 8.71411639,8.21249639 8.50822209,9.92242964 L8.05487567,13.640906 C7.99310738,14.1663786 7.53976097,14.7018301 7.19971958,15.0830504 C6.91159387,15.3917655 6.5716788,15.4536601 6.14927969,15.4536601 L6.09774295,15.4536601 C5.56216513,14.2179153 5.28401835,12.9406128 5.28401835,11.591184 C5.28401835,7.35784556 7.65306599,4 12.0617304,4 C12.9269917,4 13.7508216,4.16471544 14.5644199,4.39132549 C13.6995375,5.02985046 13.019581,5.74075423 12.5356662,6.70871009 Z"
                }
            }
        ]
    })(props);
}
function GrDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "points": "7.086 3.174 17.086 13.174 7.086 23.174",
                    "transform": "scale(1 -1) rotate(-89 -1.32 0)"
                }
            }
        ]
    })(props);
}
function GrDownloadOption(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24ZM2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM16.2929 11.2929L13 14.5858V6H11V14.5858L7.70711 11.2929L6.29289 12.7071L11.2929 17.7071L12 18.4142L12.7071 17.7071L17.7071 12.7071L16.2929 11.2929Z"
                }
            }
        ]
    })(props);
}
function GrDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,17 L1,23 L23,23 L23,17 M12,2 L12,19 M5,12 L12,19 L19,12"
                }
            }
        ]
    })(props);
}
function GrDrag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M15,5 L17,5 L17,3 L15,3 L15,5 Z M7,5 L9,5 L9,3 L7,3 L7,5 Z M15,13 L17,13 L17,11 L15,11 L15,13 Z M7,13 L9,13 L9,11 L7,11 L7,13 Z M15,21 L17,21 L17,19 L15,19 L15,21 Z M7,21 L9,21 L9,19 L7,19 L7,21 Z"
                }
            }
        ]
    })(props);
}
function GrDrawer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,14 L6,2 L18,2 L23,14 L21,22 L3,22 L1,14 Z M1,14 L23,14"
                }
            }
        ]
    })(props);
}
function GrDribbble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.4318367,8.63510204 C9.66122449,5.48571429 7.76571429,2.91918367 7.62857143,2.73061224 C4.77061224,4.08 2.63755102,6.71265306 1.97142857,9.88653061 C2.24081633,9.89142857 6.51183673,9.94285714 11.4318367,8.63510204 Z M12.7102041,12.0783673 C12.844898,12.0367347 12.9795918,11.995102 13.1142857,11.9559184 C12.8571429,11.3730612 12.5755102,10.7902041 12.2816327,10.2146939 C7.00408163,11.7942857 1.93959184,11.6791837 1.76081633,11.6742857 C1.75836735,11.7820408 1.75346939,11.8897959 1.75346939,12 C1.75346939,14.635102 2.7477551,17.037551 4.38367347,18.8522449 C4.38122449,18.8497959 4.37632653,18.842449 4.37632653,18.842449 C4.37632653,18.842449 7.18040816,13.8661224 12.7102041,12.0783673 Z M5.70122449,20.0791837 L5.70367347,20.0742857 C5.6277551,20.0155102 5.54693878,19.9591837 5.47102041,19.8979592 C5.60816327,20.0081633 5.70122449,20.0791837 5.70122449,20.0791837 Z M9.61918367,2.07622449 C9.58282004,2.08622449 9.55554731,2.09622449 9.51918367,2.10622449 C9.57372913,2.08622449 9.61009276,2.07622449 9.61918367,2.07622449 L9.61918367,2.07622449 Z M18.7689796,4.31020408 C16.9640816,2.71836735 14.5959184,1.75102041 12,1.75102041 C11.1673469,1.75102041 10.3591837,1.85387755 9.58530612,2.04 C9.74204082,2.24571429 11.6644898,4.80244898 13.4155102,8.01795918 C17.28,6.57061224 18.7420408,4.35183673 18.7689796,4.31020408 Z M12,24 C5.37306122,24 0,18.6269388 0,12 C0,5.37306122 5.37306122,0 12,0 C18.6269388,0 24,5.37306122 24,12 C24,18.6269388 18.6269388,24 12,24 Z M13.7436735,13.677551 C7.72897959,15.7738776 5.74285714,19.9885714 5.70367347,20.0742857 C7.44244898,21.4310204 9.6244898,22.2465306 12,22.2465306 C13.4204082,22.2465306 14.7722449,21.957551 16.0016327,21.4359184 C15.8497959,20.5371429 15.2546939,17.397551 13.8122449,13.6530612 C13.7877551,13.6628571 13.7657143,13.6677551 13.7436735,13.677551 Z M14.2040816,9.54612245 C14.4440816,10.0359184 14.6718367,10.5306122 14.884898,11.0326531 C14.9608163,11.2089796 15.0342857,11.3853061 15.1053061,11.5616327 C18.6440816,11.1159184 22.1289796,11.8726531 22.2440816,11.8971429 C22.2195918,9.46530612 21.3502041,7.23673469 19.9126531,5.49061224 C19.8930612,5.52 18.2497959,7.8955102 14.2040816,9.54612245 Z M15.7322449,13.1804082 C17.0791837,16.8783673 17.6228571,19.8881633 17.7257143,20.5004082 C20.0277551,18.9477551 21.6612245,16.4840816 22.1167347,13.6261224 C21.9134694,13.56 19.0457143,12.6489796 15.7322449,13.1804082 Z"
                }
            }
        ]
    })(props);
}
function GrDriveCage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,23 L1,2 L23,2 L23,23 M1,8 L23,8 L1,8 Z M1,14 L23,14 L1,14 Z M1,20 L23,20 L1,20 Z M4,5 L16,5 L4,5 Z M18,5 L20,5 L18,5 Z M18,11 L20,11 L18,11 Z M18,17 L20,17 L18,17 Z M4,11 L16,11 L4,11 Z M4,17 L16,17 L4,17 Z"
                }
            }
        ]
    })(props);
}
function GrDropbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.0599,1 L0.00015,5.6095 L4.8819,9.5185 L12.00015,5.1235 L7.0599,1 Z M0,13.4281 L7.05975,18.0376 L12,13.9141 L4.88175,9.5191 L0,13.4281 Z M11.99985,13.914175 L16.9401,18.037675 L23.99985,13.428175 L19.1181,9.518425 L11.99985,13.914175 Z M24,5.609575 L16.94025,1.000075 L12,5.123575 L19.11825,9.518575 L24,5.609575 Z M12.014475,14.801275 L7.059975,18.912775 L4.939725,17.528275 L4.939725,19.080025 L12.014475,23.322775 L19.089225,19.080025 L19.089225,17.528275 L16.968975,18.912775 L12.014475,14.801275 Z"
                }
            }
        ]
    })(props);
}
function GrDuplicate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4.5,17 L1,17 L1,1 L1,1 L17,1 L17,4.5 M7,7 L23,7 L23,23 L7,23 L7,7 Z M15,11 L15,19 L15,11 Z M11,15 L19,15 L11,15 Z"
                }
            }
        ]
    })(props);
}
function GrDxc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12,14 L16,21 L8,21 L12,14 Z M12,10 L8,3 L16,3 L12,10 Z M2,18 C0.65763624,18 -0.00903042669,18 1.01172597e-13,18 L1.01172597e-13,6 L2,6 C5.3137085,6 8,8.6862915 8,12 C8,15.3137085 5.3137085,18 2,18 Z M22,18 C18.6862915,18 16,15.3137085 16,12 C16,8.6862915 18.6862915,6 22,6 L24,6 L24,18 C24.0090304,18 23.3423638,18 22,18 Z"
                }
            }
        ]
    })(props);
}
function GrEbay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 60 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none",
                    "fillRule": "evenodd"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "fillRule": "nonzero",
                            "d": "M7.7732896,5.21819068 C3.5441438,5.21819068 0.019999394,6.99757845 0.019999394,12.3659101 C0.019999394,16.6188107 2.3897314,19.297032 7.8824908,19.297032 C14.3477258,19.297032 14.7621708,15.0733795 14.7621708,15.0733795 L11.6294594,15.0733795 C11.6294594,15.0733795 10.9577798,17.347654 7.6913886,17.347654 C5.0310022,17.347654 3.117548,15.5653377 3.117548,13.067162 L15.0897746,13.067162 L15.0897746,11.4995199 C15.0897746,9.02803874 13.5077606,5.21819068 7.7732896,5.21819068 L7.7732896,5.21819068 Z M7.6640882,7.22171802 C10.1965006,7.22171802 11.9229378,8.76030585 11.9229378,11.0663246 L3.1868362,11.0663246 C3.1868362,8.61820364 5.4402766,7.22171802 7.6640882,7.22171802 L7.6640882,7.22171802 Z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "fillRule": "nonzero",
                            "d": "M15.0875524,0.0198491484 L15.0875524,16.6010769 C15.0875524,17.5422799 15.019817,18.863837 15.019817,18.863837 L18.0077636,18.863837 C18.0077636,18.863837 18.1150112,17.914676 18.1150112,17.0472353 C18.1150112,17.0472353 19.5912498,19.337644 23.605252,19.337644 C27.832158,19.337644 30.703334,16.4272941 30.703334,12.2576112 C30.703334,8.3786154 28.066066,5.25880264 23.612076,5.25880264 C19.441229,5.25880264 18.145188,7.49246499 18.145188,7.49246499 L18.145188,0.0198491484 L15.0875524,0.0198491484 Z M22.840842,7.30971074 C25.71124,7.30971074 27.536498,9.42243689 27.536498,12.2576112 C27.536498,15.2978212 25.428386,17.2867359 22.861318,17.2867359 C19.7977472,17.2867359 18.145188,14.9144815 18.145188,12.284686 C18.145188,9.83422909 19.6280778,7.30971074 22.840842,7.30971074 Z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "fillRule": "nonzero",
                            "d": "M38.12902,5.21819068 C31.76659,5.21819068 31.358542,8.67315451 31.358542,9.22524555 L34.525378,9.22524555 C34.525378,9.22524555 34.691446,7.20818063 37.910618,7.20818063 C40.002488,7.20818063 41.623462,8.15774975 41.623462,9.98333693 L41.623462,10.6331296 L37.910618,10.6331296 C32.981554,10.6331296 30.37573,12.0631587 30.37573,14.9650808 C30.37573,17.820989 32.783428,19.3748717 36.037134,19.3748717 C40.47143,19.3748717 41.899876,16.944918 41.899876,16.944918 C41.899876,17.9114206 41.975012,18.863837 41.975012,18.863837 L44.790298,18.863837 C44.790298,18.863837 44.681096,17.6832871 44.681096,16.9279962 L44.681096,10.3996104 C44.681096,6.11903722 41.199594,5.21819068 38.12902,5.21819068 L38.12902,5.21819068 Z M41.623462,12.5825076 L41.623462,13.4488979 C41.623462,14.5789069 40.920356,17.388266 36.781068,17.388266 C34.514408,17.388266 33.542568,16.2663838 33.542568,14.9650808 C33.542568,12.5977539 36.815324,12.5825076 41.623462,12.5825076 L41.623462,12.5825076 Z"
                        }
                    },
                    {
                        "tag": "polygon",
                        "attr": {
                            "fillRule": "nonzero",
                            "points": "42.976 5.76 46.538 5.76 51.651 15.919 56.753 5.76 59.98 5.76 50.688 23.846 47.303 23.846 49.984 18.804"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function GrEdge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "clipPath": "url(#a)"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M21.666 17.873c-.32.165-.65.308-.991.44a9.628 9.628 0 0 1-3.369.606c-4.437 0-8.3-3.05-8.3-6.97 0-1.102.638-2.06 1.54-2.556-4.018.166-5.042 4.35-5.042 6.795 0 6.927 6.386 7.632 7.762 7.632.737 0 1.86-.22 2.532-.43a.539.539 0 0 0 .12-.044 12.066 12.066 0 0 0 6.243-4.956c.21-.319-.154-.704-.495-.517Z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M9.908 22.641a7.411 7.411 0 0 1-2.136-2.004 7.623 7.623 0 0 1-1.42-4.449 7.616 7.616 0 0 1 2.896-6.002 7.658 7.658 0 0 1 1.288-.804c.297-.143.792-.385 1.453-.374 1.1.011 1.937.573 2.41 1.211a3.02 3.02 0 0 1 .595 1.751c0-.022 2.29-7.466-7.508-7.466C3.391 4.504 0 8.414 0 11.849c0 2.17.506 3.91 1.134 5.253a12.065 12.065 0 0 0 7.21 6.343 11.88 11.88 0 0 0 3.667.573c1.32 0 2.598-.22 3.798-.617a7.14 7.14 0 0 1-2.136.33 7.2 7.2 0 0 1-3.765-1.09Z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M14.279 13.964c-.077.099-.309.23-.309.528 0 .242.154.485.44.683 1.355.936 3.887.815 3.898.815 1.046 0 1.992-.297 2.84-.782.386-.22.738-.496 1.057-.793 1.101-1.046 1.773-2.522 1.795-4.163.022-2.103-.75-3.502-1.068-4.118C20.95 2.235 16.668 0 12 0 5.427 0 .088 5.286 0 11.838c.044-3.425 3.446-6.2 7.497-6.2.33 0 2.202.033 3.941.947 1.53.804 2.334 1.773 2.896 2.742.583 1.002.682 2.269.682 2.764 0 .496-.264 1.256-.737 1.873Z"
                        }
                    }
                ]
            },
            {
                "tag": "defs",
                "attr": {},
                "child": [
                    {
                        "tag": "linearGradient",
                        "attr": {
                            "id": "b",
                            "x1": "5.501",
                            "x2": "22.225",
                            "y1": "16.605",
                            "y2": "16.605",
                            "gradientUnits": "userSpaceOnUse"
                        },
                        "child": [
                            {
                                "tag": "stop",
                                "attr": {
                                    "stopColor": "#0C59A4"
                                }
                            },
                            {
                                "tag": "stop",
                                "attr": {
                                    "offset": "1",
                                    "stopColor": "#114A8B"
                                }
                            }
                        ]
                    },
                    {
                        "tag": "linearGradient",
                        "attr": {
                            "id": "c",
                            "x1": "14.318",
                            "x2": "3.868",
                            "y1": "9.347",
                            "y2": "20.726",
                            "gradientUnits": "userSpaceOnUse"
                        },
                        "child": [
                            {
                                "tag": "stop",
                                "attr": {
                                    "stopColor": "#1B9DE2"
                                }
                            },
                            {
                                "tag": "stop",
                                "attr": {
                                    "offset": ".162",
                                    "stopColor": "#1595DF"
                                }
                            },
                            {
                                "tag": "stop",
                                "attr": {
                                    "offset": ".667",
                                    "stopColor": "#0680D7"
                                }
                            },
                            {
                                "tag": "stop",
                                "attr": {
                                    "offset": "1",
                                    "stopColor": "#0078D4"
                                }
                            }
                        ]
                    },
                    {
                        "tag": "radialGradient",
                        "attr": {
                            "id": "d",
                            "cx": "0",
                            "cy": "0",
                            "r": "1",
                            "gradientTransform": "rotate(92.128 -.93 3.333) scale(18.9898 40.4341)",
                            "gradientUnits": "userSpaceOnUse"
                        },
                        "child": [
                            {
                                "tag": "stop",
                                "attr": {
                                    "stopColor": "#35C1F1"
                                }
                            },
                            {
                                "tag": "stop",
                                "attr": {
                                    "offset": ".111",
                                    "stopColor": "#34C1ED"
                                }
                            },
                            {
                                "tag": "stop",
                                "attr": {
                                    "offset": ".232",
                                    "stopColor": "#2FC2DF"
                                }
                            },
                            {
                                "tag": "stop",
                                "attr": {
                                    "offset": ".315",
                                    "stopColor": "#2BC3D2"
                                }
                            },
                            {
                                "tag": "stop",
                                "attr": {
                                    "offset": ".673",
                                    "stopColor": "#36C752"
                                }
                            },
                            {
                                "tag": "stop",
                                "attr": {
                                    "offset": "1",
                                    "stopColor": "#36C752"
                                }
                            }
                        ]
                    },
                    {
                        "tag": "clipPath",
                        "attr": {
                            "id": "a"
                        },
                        "child": [
                            {
                                "tag": "path",
                                "attr": {
                                    "d": "M0 0h24v24H0z"
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    })(props);
}
function GrEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M14,4 L20,10 L14,4 Z M22.2942268,5.29422684 C22.6840146,5.68401459 22.6812861,6.3187139 22.2864907,6.71350932 L9,20 L2,22 L4,15 L17.2864907,1.71350932 C17.680551,1.319449 18.3127724,1.31277239 18.7057732,1.70577316 L22.2942268,5.29422684 Z M3,19 L5,21 M7,17 L15,9"
                }
            }
        ]
    })(props);
}
function GrEject(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M21,14 L12,2 L3,14 L21,14 Z M2,22 L22,22 L22,18 L2,18 L2,22 Z"
                }
            }
        ]
    })(props);
}
function GrElevator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeWidth": "2",
                    "d": "M1,2.991155 C1,1.89147046 1.88967395,1 2.991155,1 L21.008845,1 C22.1085295,1 23,1.88967395 23,2.991155 L23,21.008845 C23,22.1085295 22.1103261,23 21.008845,23 L2.991155,23 C1.89147046,23 1,22.1103261 1,21.008845 L1,2.991155 Z M16.5,8 L18,10 L15,10 L16.5,8 Z M16.5,16 L18,14 L15,14 L16.5,16 Z M5,13 L6.55613518,9.88772964 C6.80127495,9.3974501 7.44386482,9 8,9 L8,9 C8.55228475,9 9.19907951,9.39815903 9.44386482,9.88772964 L11,13 M6.5,18 L7.75,10 L8,10 L8.25,10 L9.5,18 M8,7 C8.55228475,7 9,6.55228475 9,6 C9,5.44771525 8.55228475,5 8,5 C7.44771525,5 7,5.44771525 7,6 C7,6.55228475 7.44771525,7 8,7 Z"
                }
            }
        ]
    })(props);
}
function GrEmergency(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10,7.17157288 L10,2 L14,2 L14,7.17157288 L17.6568542,3.51471863 L20.4852814,6.34314575 L16.8284271,10 L22,10 L22,14 L16.8284271,14 L20.4852814,17.6568542 L17.6568542,20.4852814 L14,16.8284271 L14,22 L10,22 L10,16.8284271 L6.34314575,20.4852814 L3.51471863,17.6568542 L7.17157288,14 L2,14 L2,10 L7.17157288,10 L3.51471863,6.34314575 L6.34314575,3.51471863 L10,7.17157288 Z"
                }
            }
        ]
    })(props);
}
function GrEmoji(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12,1.73A10.27,10.27,0,1,0,22.24,12,10.25,10.25,0,0,0,12,1.73ZM21,12a9,9,0,1,1-9-9A9,9,0,0,1,21,12Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.8,11.05a1.55,1.55,0,1,0-1.51-1.5A1.56,1.56,0,0,0,8.8,11.05Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.44,11.05a1.55,1.55,0,1,0,0-3.09,1.53,1.53,0,0,0-1.51,1.59A1.51,1.51,0,0,0,15.44,11.05Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.19,16.35A6.58,6.58,0,0,1,6.9,13.5a5.71,5.71,0,0,0,5.3,4,5.54,5.54,0,0,0,5.31-4A6.27,6.27,0,0,1,12.19,16.35Z"
                }
            }
        ]
    })(props);
}
function GrEmptyCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M12,16 C14.209139,16 16,14.209139 16,12 C16,9.790861 14.209139,8 12,8 C9.790861,8 8,9.790861 8,12 C8,14.209139 9.790861,16 12,16 Z"
                }
            }
        ]
    })(props);
}
function GrErase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M7,21 L22,6 L18,2 L2,18 L5,21 L19,21 M6,14 L10,18"
                }
            }
        ]
    })(props);
}
function GrEscalator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeWidth": "2",
                    "d": "M22,9 C22,7.8954305 21.1017394,7 20.0020869,7 L16,7 L6,17 L4,17 C2.8954305,17 2,17.8877296 2,19 L2,19 C2,20.1045695 2.89826062,21 3.99791312,21 L8,21 L18,11 L20,11 C21.1045695,11 22,10.1122704 22,9 L22,9 Z M7,9 C7.55228475,9 8,8.55228475 8,8 C8,7.44771525 7.55228475,7 7,7 C6.44771525,7 6,7.44771525 6,8 C6,8.55228475 6.44771525,9 7,9 Z M7,15 L7,12.495389 C7,12.2217932 7.23193359,12 7.5,12 L7.5,12 C7.77614237,12 8,12.214035 8,12.5046844 L8,14 L7,15 Z M12,4 C12.5522847,4 13,3.55228475 13,3 C13,2.44771525 12.5522847,2 12,2 C11.4477153,2 11,2.44771525 11,3 C11,3.55228475 11.4477153,4 12,4 Z M12,10 L12,7.49538898 C12,7.2217932 12.2319336,7 12.5,7 L12.5,7 C12.7761424,7 13,7.21403503 13,7.50468445 L13,9 L12,10 Z"
                }
            }
        ]
    })(props);
}
function GrExpand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M10,14 L2,22 M1,15 L1,23 L9,23 M22,2 L14,10 M15,1 L23,1 L23,9"
                }
            }
        ]
    })(props);
}
function GrEzmeral(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 48 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 8H41V16H7V8Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 8H7V16H1V8Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M41 8H47V16H41V8Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 16H41V22H7V16Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2H41V8H7V2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 8L7 2V8H1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 16L7 22V16H1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M47 8L41 2V8H47Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M47 16L41 22V16H47Z"
                }
            }
        ]
    })(props);
}
function GrFacebookOption(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.94474914,22 L9.94474914,13.1657526 L7,13.1657526 L7,9.48481614 L9.94474914,9.48481614 L9.94474914,6.54006699 C9.94474914,3.49740494 11.8713513,2 14.5856738,2 C15.8857805,2 17.0033128,2.09717672 17.3287076,2.13987558 L17.3287076,5.32020466 L15.4462767,5.32094085 C13.9702212,5.32094085 13.6256856,6.02252733 13.6256856,7.05171716 L13.6256856,9.48481614 L17.306622,9.48481614 L16.5704347,13.1657526 L13.6256856,13.1657526 L13.6845806,22"
                }
            }
        ]
    })(props);
}
function GrFacebook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "clipPath": "url(#a)"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M12 0C5.373 0 0 5.373 0 12c0 6.016 4.432 10.984 10.207 11.852V15.18h-2.97v-3.155h2.97V9.927c0-3.475 1.693-5 4.58-5 1.384 0 2.115.102 2.462.149v2.753h-1.97c-1.226 0-1.655 1.163-1.655 2.473v1.724h3.594l-.488 3.155h-3.106v8.696C19.481 23.083 24 18.075 24 12c0-6.627-5.373-12-12-12Z"
                        }
                    }
                ]
            },
            {
                "tag": "defs",
                "attr": {},
                "child": [
                    {
                        "tag": "clipPath",
                        "attr": {
                            "id": "a"
                        },
                        "child": [
                            {
                                "tag": "path",
                                "attr": {
                                    "d": "M0 0h24v24H0z"
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    })(props);
}
function GrFanOption(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "2",
                    "width": "20",
                    "height": "20",
                    "rx": "1",
                    "strokeWidth": "2"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "2",
                    "width": "20",
                    "height": "20",
                    "rx": "10",
                    "strokeWidth": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.9999 9.50009C15.4999 9.16675 15.8999 7.80009 15.4999 7.00009C15.0999 6.20009 13.3334 5.66674 13.0001 5.50007M14 10.5001C15.5001 8.5001 14.0001 7.00006 11.5 5.5001C9.95405 4.57263 13.4999 4.00009 16.0001 6.00009C17.8751 7.49994 17 8.50009 14 11.5001V10.5001Z",
                    "strokeWidth": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.98522 14.402C8.48522 14.7353 8.08522 16.102 8.48522 16.902C8.88522 17.702 10.6517 18.2354 10.9851 18.402M9.98516 13.402C8.48509 15.402 9.98504 16.902 12.4852 18.402C14.0311 19.3295 10.4852 19.902 7.98502 17.902C6.11005 16.4022 6.98516 15.402 9.98516 12.402V13.402Z",
                    "strokeWidth": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.54159 8.94372C9.20826 8.44372 7.84159 8.04372 7.04159 8.44372C6.24159 8.84372 5.70824 10.6102 5.54157 10.9435M10.5416 9.94366C8.54161 8.44359 7.04156 9.94354 5.54161 12.4437C4.61413 13.9896 4.04159 10.4437 6.04159 7.94352C7.54145 6.06854 8.5416 6.94366 11.5416 9.94366H10.5416Z",
                    "strokeWidth": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.4436 14.9584C14.7769 15.4584 16.1436 15.8584 16.9436 15.4584C17.7436 15.0584 18.2769 13.2919 18.4436 12.9586M13.4436 13.9584C15.4436 15.4585 16.9436 13.9586 18.4436 11.4584C19.371 9.91249 19.9436 13.4584 17.9436 15.9586C16.4437 17.8336 15.4436 16.9584 12.4436 13.9584H13.4436Z",
                    "strokeWidth": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.5 5C4.32843 5 5 4.32843 5 3.5C5 2.67157 4.32843 2 3.5 2C2.67157 2 2 2.67157 2 3.5C2 4.32843 2.67157 5 3.5 5Z",
                    "strokeWidth": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.5 22C4.32843 22 5 21.3284 5 20.5C5 19.6716 4.32843 19 3.5 19C2.67157 19 2 19.6716 2 20.5C2 21.3284 2.67157 22 3.5 22Z",
                    "strokeWidth": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M20.5 22C21.3284 22 22 21.3284 22 20.5C22 19.6716 21.3284 19 20.5 19C19.6716 19 19 19.6716 19 20.5C19 21.3284 19.6716 22 20.5 22Z",
                    "strokeWidth": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M20.5 5C21.3284 5 22 4.32843 22 3.5C22 2.67157 21.3284 2 20.5 2C19.6716 2 19 2.67157 19 3.5C19 4.32843 19.6716 5 20.5 5Z",
                    "strokeWidth": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
                    "strokeWidth": "2"
                }
            }
        ]
    })(props);
}
function GrFan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,15 C13.6568542,15 15,13.6568542 15,12 C15,10.3431458 13.6568542,9 12,9 C10.3431458,9 9,10.3431458 9,12 C9,13.6568542 10.3431458,15 12,15 Z M15,12 C19,15 20,19 20,19 M12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 Z M12,9 C15,4 19,3 19,3 M12,15 C9,19 5,20 5,20 M9,12 C5,9 4,5 4,5"
                }
            }
        ]
    })(props);
}
function GrFastForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "points": "9 2.059 9 8 1 2.059 1 22.059 9 16 9 22.059 22 12.059"
                }
            }
        ]
    })(props);
}
function GrFavorite(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,8.4 C1,4 4.5,3 6.5,3 C9,3 11,5 12,6.5 C13,5 15,3 17.5,3 C19.5,3 23,4 23,8.4 C23,15 12,21 12,21 C12,21 1,15 1,8.4 Z"
                }
            }
        ]
    })(props);
}
function GrFedora(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.9998121,0 C5.3752955,0 0.00469667319,5.36825049 0,11.9918748 L0,21.278137 C0.00352250489,22.7820587 1.22334247,23.9996243 2.72820352,23.9996243 L12.0046967,23.9996243 C18.6300587,23.9970411 24,18.6261605 24,12.0002818 C24,5.37285323 18.6273346,0 11.9998121,0 L11.9998121,0 Z M16.595319,5.57654795 C16.2162505,5.57654795 16.0784971,5.50370254 15.5230685,5.50370254 C13.883225,5.50370254 12.5531742,6.83187476 12.5504031,8.4717182 L12.5504031,11.0548415 C12.5504031,11.2862935 12.7382701,11.4738787 12.9702857,11.4738787 L14.9232094,11.4743014 C15.650771,11.4743014 16.2386536,12.0546693 16.2386536,12.7841566 C16.2390763,13.5183875 15.6447123,14.096454 14.9093542,14.096454 L12.5503562,14.096454 L12.5503562,17.0814247 C12.5503562,20.1916086 10.0288063,22.7134873 6.91852838,22.7134873 C6.44665362,22.7134873 6.11112329,22.6601331 5.67428571,22.5460978 C5.03736986,22.379319 4.51688454,21.8570489 4.51669667,21.2496282 C4.51669667,20.5156791 5.04962818,19.9814795 5.84627789,19.9814795 C6.22548728,19.9814795 6.3629589,20.0543249 6.91857534,20.0543249 C8.55832485,20.0543249 9.88837573,18.7260587 9.89133464,17.0864031 L9.89133464,14.5031389 C9.89133464,14.271499 9.70313894,14.0840078 9.47140509,14.0840078 L7.51848141,14.083773 C6.79082583,14.083773 6.20294325,13.5033581 6.20294325,12.7738239 C6.20256751,12.039499 6.79688454,11.4616204 7.53233659,11.4616204 L9.89100587,11.4616204 L9.89100587,8.47646184 C9.89100587,5.36627789 12.4128845,2.84449315 15.5230685,2.84449315 C15.9949432,2.84449315 16.3304736,2.89775342 16.7671703,3.01197652 C17.404274,3.17856751 17.9246184,3.70083757 17.9249941,4.30825832 C17.9249941,5.04248924 17.3920157,5.57654795 16.595319,5.57654795 L16.595319,5.57654795 Z"
                }
            }
        ]
    })(props);
}
function GrFigma(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none",
                    "fillRule": "evenodd",
                    "transform": "translate(4)"
                },
                "child": [
                    {
                        "tag": "circle",
                        "attr": {
                            "cx": "12",
                            "cy": "12",
                            "r": "4"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M4,24 C6.209139,24 8,22.209139 8,20 C8,19.3969461 8,18.0636128 8,16 C6.20303877,16 4.86970543,16 4,16 C1.790861,16 0,17.790861 0,20 C0,22.209139 1.790861,24 4,24 Z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M4,16 C4.73637967,16 6.069713,16 8,16 L8,8 C6.069713,8 4.73637967,8 4,8 C1.790861,8 0,9.790861 0,12 C0,14.209139 1.790861,16 4,16 Z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M4,8 C4.73637967,8 6.069713,8 8,8 L8,0 C6.069713,0 4.73637967,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M12,8 L8,8 L8,8 L8,0 L12,0 L12,0 C14.209139,0 16,1.790861 16,4 C16,6.209139 14.209139,8 12,8 Z"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function GrFilter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "points": "3 6 10 13 10 21 14 21 14 13 21 6 21 3 3 3"
                }
            }
        ]
    })(props);
}
function GrFingerPrint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeWidth": "2",
                    "d": "M14,15 C14,13.8954305 13.1045695,13 12,13 C10.8954305,13 10,13.8954305 10,15 C10,16.1045695 10.8954305,17 12,17 L12,17 M12,20 C9.23857625,20 7,17.7614237 7,15 C7,12.2385763 9.23857625,10 12,10 C14.7614237,10 17,12.2385763 17,15 C17,15.8284271 17.6715729,16.5 18.5,16.5 C19.3284271,16.5 20,15.8284271 20,15 C20,10.581722 16.418278,7 12,7 C7.581722,7 4,10.581722 4,15 C4,19.418278 7.581722,23 12,23 L14,23 M1,15 C1,17.6720798 1.95275656,20.1216314 3.53708682,22.0274719 M20.5202529,8.04207866 C18.5030558,5.574886 15.4354451,4 12,4 C8.59642702,4 5.55389491,5.54579976 3.53616098,7.97364199 M18.5259055,2.61083013 C16.577286,1.58228463 14.3566429,1 12,1 C9.66126395,1 7.45646883,1.57346929 5.51856118,2.58746134"
                }
            }
        ]
    })(props);
}
function GrFireball(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M12,13 L10.25,14 L11,12 L9.75,11 L11.25,11 L12,9.25 L12.75,11 L14.25,11 L13,12 L13.75,14 L12,13 Z"
                }
            }
        ]
    })(props);
}
function GrFirefox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4.24954645,1 C4.20019837,2.2660337 4.15311916,3.47137493 4.10547273,4.68409001 C4.72941407,4.52980633 5.34030936,4.43848401 5.93475529,4.69429995 C7.22631387,2.92627708 9.08339018,2.31821789 11.1293506,2.093599 C11.1418294,2.1140189 11.1548754,2.1344388 11.1673543,2.1548587 C11.1265145,2.19853459 11.0868091,2.24277771 11.0448349,2.28531916 C10.2252028,3.11799724 9.56609389,4.0641192 9.09700345,5.13219333 C8.96257245,5.43792459 8.93137538,5.78960062 8.8587713,6.12142397 C8.83041033,6.25074999 8.89564056,6.31995076 9.02666824,6.33810178 C9.633593,6.42091581 10.2393833,6.51791033 10.848577,6.58767831 C11.2308828,6.63135421 11.6177265,6.63929528 12.0028684,6.65517742 C12.1832442,6.66255127 12.2609533,6.75217194 12.2649238,6.92233776 C12.2802387,7.60640436 12.0516493,8.192342 11.5059842,8.61265157 C10.9801719,9.01707901 10.3760832,9.27573105 9.72491533,9.41640146 C9.65741622,9.43114917 9.59048433,9.45100185 9.51674581,9.47028731 C9.58197604,10.3023982 9.64663905,11.1191941 9.7152726,11.9847709 C9.08339018,11.6818757 8.4787343,11.3925939 7.86103238,11.0970725 C7.67498441,11.4890212 7.66137115,11.8769992 7.77878556,12.2729184 C8.09529399,13.3455303 9.21044733,13.9677699 10.3647388,13.6824586 C10.7691662,13.582628 11.1599804,13.4124621 11.5411518,13.2394602 C11.9172183,13.06816 12.2700288,12.8480788 12.6370197,12.6563587 C13.2592594,12.3319092 13.8860368,12.3602702 14.5111126,12.649552 C14.6001661,12.6909591 14.690354,12.7454121 14.7595547,12.8146129 C14.9943836,13.0494417 15.1770282,13.3177365 15.0828698,13.6716814 C14.9915475,14.0137147 14.7431054,14.2116743 14.4056098,14.2831439 C14.2116208,14.3245509 14.0096907,14.3421347 13.8117311,14.3415675 C13.6801362,14.3410003 13.609801,14.384109 13.5377641,14.490179 C12.8582353,15.4986951 11.9762091,16.2417525 10.7476119,16.4544598 C10.2314423,16.5435132 9.69768879,16.5287655 9.17187641,16.5582609 C9.10210842,16.5622315 9.03234044,16.5520215 8.91662768,16.5457821 C8.98639567,16.6104451 9.02156327,16.6501505 9.06353751,16.6813475 C10.4537923,17.7080147 11.9909568,18.0585562 13.6784345,17.654696 C15.0590466,17.3251416 16.2870766,16.7063052 17.3006976,15.6904153 C18.2666723,14.7216045 18.7085362,13.5400865 18.7227167,12.1940749 C18.7368972,10.8412566 18.4345692,9.56047519 17.7425616,8.38689825 C17.6217438,8.18156483 17.4640568,7.99778574 17.288786,7.75615028 C18.4799468,8.29614315 19.5298699,8.90987454 20.0159769,10.1764755 C20.1594834,8.59450055 19.8679326,7.09704134 19.2576046,5.6517663 C18.6478437,4.20762571 17.7726242,2.95747415 16.5763585,1.92059709 C16.6262738,1.93137426 16.6767563,1.93931533 16.7249699,1.95463025 C19.4192621,2.79865272 21.4879113,4.40445084 22.7806043,6.94616097 C23.4068145,8.17645985 23.7272934,9.49751384 23.8923543,10.8588404 C24.0693267,12.316027 24.0483396,13.7647054 23.6762437,15.1969344 C23.054004,17.5945708 21.7408911,19.5560155 19.9229529,21.2100272 C18.1929338,22.7840611 16.1776032,23.805056 13.8707219,24.097174 C8.73171416,24.7483419 4.68120042,22.8986394 1.80823415,18.5707554 C0.665287063,16.8486773 0.125861413,14.921833 0.022627482,12.8594232 C-0.144135022,9.50942545 0.61140122,6.38518099 2.2716524,3.47761434 C2.75492333,2.63018856 3.33745766,1.85423242 4.04875079,1.18094299 C4.09923331,1.13329656 4.1514175,1.08791901 4.24954645,1"
                }
            }
        ]
    })(props);
}
function GrFirewall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6.00562 2.01929C5.45333 2.01929 5.00562 2.467 5.00562 3.01929C5.00562 3.57157 5.45333 4.01929 6.00562 4.01929H12.0056C12.5579 4.01929 13.0056 3.57157 13.0056 3.01929C13.0056 2.467 12.5579 2.01929 12.0056 2.01929H6.00562ZM11.9225 4.99564C11.315 4.99564 10.8225 5.48812 10.8225 6.09564V7.89564C10.8225 8.50315 11.315 8.99564 11.9225 8.99564H17.7225C18.33 8.99564 18.8225 8.50315 18.8225 7.89564V6.09564C18.8225 5.48812 18.33 4.99564 17.7225 4.99564H11.9225ZM3.1 4.99597C2.49249 4.99597 2 5.48846 2 6.09597V7.89597C2 8.50348 2.49249 8.99597 3.1 8.99597H8.9C9.50751 8.99597 10 8.50348 10 7.89597V6.09597C10 5.48846 9.50751 4.99597 8.9 4.99597H3.1ZM3.1 14.9884C2.49249 14.9884 2 15.4809 2 16.0884V17.8884C2 18.4959 2.49249 18.9884 3.1 18.9884H8.9C9.50751 18.9884 10 18.4959 10 17.8884V16.0884C10 15.4809 9.50751 14.9884 8.9 14.9884H3.1ZM10.8225 16.0884C10.8225 15.4809 11.315 14.9884 11.9225 14.9884H17.7225C18.33 14.9884 18.8225 15.4809 18.8225 16.0884V17.8884C18.8225 18.4959 18.33 18.9884 17.7225 18.9884H11.9225C11.315 18.9884 10.8225 18.4959 10.8225 17.8884V16.0884ZM4.8479 11.0726C4.8479 10.4651 5.34039 9.97263 5.9479 9.97263H11.7479C12.3554 9.97263 12.8479 10.4651 12.8479 11.0726V12.8726C12.8479 13.4801 12.3554 13.9726 11.7479 13.9726H5.9479C5.34039 13.9726 4.8479 13.4801 4.8479 12.8726V11.0726ZM14.7135 10.0117C14.106 10.0117 13.6135 10.5042 13.6135 11.1117V12.9117C13.6135 13.5192 14.106 14.0117 14.7135 14.0117H20.5135C21.121 14.0117 21.6135 13.5192 21.6135 12.9117V11.1117C21.6135 10.5042 21.121 10.0117 20.5135 10.0117H14.7135ZM14 3.01929C14 2.467 14.4477 2.01929 15 2.01929H21C21.5523 2.01929 22 2.467 22 3.01929C22 3.57157 21.5523 4.01929 21 4.01929H15C14.4477 4.01929 14 3.57157 14 3.01929ZM15 19.9807C14.4477 19.9807 14 20.4285 14 20.9807C14 21.533 14.4477 21.9807 15 21.9807H21C21.5523 21.9807 22 21.533 22 20.9807C22 20.4285 21.5523 19.9807 21 19.9807H15ZM5.01196 20.9807C5.01196 20.4284 5.45968 19.9807 6.01196 19.9807H12.012C12.5642 19.9807 13.012 20.4284 13.012 20.9807C13.012 21.5329 12.5642 21.9807 12.012 21.9807H6.01196C5.45968 21.9807 5.01196 21.5329 5.01196 20.9807ZM3 9.97263C2.44772 9.97263 2 10.4203 2 10.9726V12.9726C2 13.5249 2.44772 13.9726 3 13.9726C3.55228 13.9726 4 13.5249 4 12.9726V10.9726C4 10.4203 3.55228 9.97263 3 9.97263ZM19.6292 5.99564C19.6292 5.44335 20.0769 4.99564 20.6292 4.99564C21.1814 4.99564 21.6292 5.44335 21.6292 5.99564V7.99564C21.6292 8.54792 21.1814 8.99564 20.6292 8.99564C20.0769 8.99564 19.6292 8.54792 19.6292 7.99564V5.99564ZM20.6448 14.9884C20.0925 14.9884 19.6448 15.4361 19.6448 15.9884V17.9884C19.6448 18.5407 20.0925 18.9884 20.6448 18.9884C21.1971 18.9884 21.6448 18.5407 21.6448 17.9884V15.9884C21.6448 15.4361 21.1971 14.9884 20.6448 14.9884ZM2 20.9807C2 20.4284 2.44772 19.9807 3 19.9807C3.55228 19.9807 4 20.4284 4 20.9807C4 21.5329 3.55228 21.9807 3 21.9807C2.44772 21.9807 2 21.5329 2 20.9807ZM3.01123 2.01929C2.45895 2.01929 2.01123 2.467 2.01123 3.01929C2.01123 3.57157 2.45895 4.01929 3.01123 4.01929C3.56352 4.01929 4.01123 3.57157 4.01123 3.01929C4.01123 2.467 3.56352 2.01929 3.01123 2.01929Z"
                }
            }
        ]
    })(props);
}
function GrFlagFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "strokeWidth": "2",
                    "d": "M2,24 L2,2 C10,-1.5238864 13,6.64375708 22,2 L22,14 C14,18.895222 9,9.89651097 2,14"
                }
            }
        ]
    })(props);
}
function GrFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2,24 L2,2 C10,-1.5238864 13,6.64375708 22,2 L22,14 C14,18.895222 9,9.89651097 2,14"
                }
            }
        ]
    })(props);
}
function GrFlows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeWidth": "2",
                    "d": "M3 5a2 2 0 012-2h14a2 2 0 012 2v3a2 2 0 01-2 2H5a2 2 0 01-2-2V5zM3 16a2 2 0 012-2h14a2 2 0 012 2v3a2 2 0 01-2 2H5a2 2 0 01-2-2v-3z"
                }
            }
        ]
    })(props);
}
function GrFolderCycle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M7.0001,18 C7.0001,15.239 9.2391,13 12.0001,13 C13.9851,13 15.6991,14.156 16.5,16 M17.0001,18 C17.0001,20.761 14.7611,23 12.0001,23 C10.0151,23 8.3011,21.844 7.5,20 M13.0001,16 L17.0001,16 L17.0001,12 M11.0001,20 L7.0001,20 L7.0001,24 M4.0001,23 L1.0001,23 L1.0001,5 L1.0001,1 L9.0001,1 L12.0001,5 L23.0001,5 L23.0001,23 L19.0001,23 M1.0001,9 L23.0001,9 M4,23 L1,23 L1,1 L9,1 L12,5 L23,5 L23,23 L19,23 M1,9 L23,9"
                }
            }
        ]
    })(props);
}
function GrFolderOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M5,2 L11,1.99999998 L13,6 L19,6 L19,10 L5,10 L5,2 Z M2,10 L22,10 L19,22 L5,22 L2,10 Z"
                }
            }
        ]
    })(props);
}
function GrFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2,10 L2,6 L2,2 L10,2 L13,6 L22,6 L22,10 L2,10 Z M2,10 L22,10 L22,22 L2,22 L2,10 Z"
                }
            }
        ]
    })(props);
}
function GrFormAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,18 L12,6 M6,12 L18,12"
                }
            }
        ]
    })(props);
}
function GrFormAttachment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M6,13.2932321 C7.63138164,11.6618504 10.6214284,8.67180351 12.3609131,6.93231878 C15.1879856,4.10524628 19.4285943,8.34585492 16.6015218,11.1729275 C13.7744493,14 11.6541453,16.1203048 10.2406087,17.5338408 C8.82707218,18.9473767 6.70676816,16.8270724 8.12030436,15.4135364 C9.53384056,14.0000004 14.4812175,9.05262308 14.4812175,9.05262308"
                }
            }
        ]
    })(props);
}
function GrFormCalendar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M6,19 L18,19 L18,8 L6,8 L6,19 Z M15,8 L15,5 L15,8 Z M9,8 L9,5 L9,8 Z M6,11.5 L18,11.5 L6,11.5 Z"
                }
            }
        ]
    })(props);
}
function GrFormCheckmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "points": "6 13 10.2 16.6 18 7"
                }
            }
        ]
    })(props);
}
function GrFormClock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,18 C15.3137085,18 18,15.3137085 18,12 C18,8.6862915 15.3137085,6 12,6 C8.6862915,6 6,8.6862915 6,12 C6,15.3137085 8.6862915,18 12,18 Z M12,8 L12,12 L15,13"
                }
            }
        ]
    })(props);
}
function GrFormClose(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M7,7 L17,17 M7,17 L17,7"
                }
            }
        ]
    })(props);
}
function GrFormCut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M18,7.52380952 L10.1428571,13.8095238 L18,7.52380952 Z M18,15.9047619 L10.1428571,9.61904762 L18,15.9047619 Z M8.57142857,10.1428571 C9.43930461,10.1428571 10.1428571,9.43930461 10.1428571,8.57142857 C10.1428571,7.70355254 9.43930461,7 8.57142857,7 C7.70355254,7 7,7.70355254 7,8.57142857 C7,9.43930461 7.70355254,10.1428571 8.57142857,10.1428571 Z M8.57142857,16.4285714 C9.43930461,16.4285714 10.1428571,15.7250189 10.1428571,14.8571429 C10.1428571,13.9892668 9.43930461,13.2857143 8.57142857,13.2857143 C7.70355254,13.2857143 7,13.9892668 7,14.8571429 C7,15.7250189 7.70355254,16.4285714 8.57142857,16.4285714 Z"
                }
            }
        ]
    })(props);
}
function GrFormDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "points": "18 9 12 15 6 9"
                }
            }
        ]
    })(props);
}
function GrFormEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M11.9955241,8.33576576 L15.4932862,11.8335278 L11.9955241,8.33576576 Z M17.5365751,7.79609426 C17.9262629,8.18578207 17.9321949,8.81165877 17.5321697,9.21168397 L10.0807224,16.6631313 L6,17.829052 L7.16592069,13.7483296 L14.617368,6.29688224 C15.0094888,5.90476144 15.6393004,5.89881957 16.0329577,6.29247691 L17.5365751,7.79609426 Z"
                }
            }
        ]
    })(props);
}
function GrFormFilter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "points": "6 8 11.667 12.667 11.667 18 12.333 18 12.333 12.667 18 8 18 6 6 6"
                }
            }
        ]
    })(props);
}
function GrFormFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "points": "6 18 6 6 10.8 6 12.6 8.4 18 8.4 18 18"
                }
            }
        ]
    })(props);
}
function GrFormLocation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,17 C12,17 8,14 8,11 C8,8.5 10,7 12,7 C14,7 16,8.5 16,11 C16,14 12,17 12,17 Z M12,12 C12.5523333,12 13,11.5523333 13,11 C13,10.4476667 12.5523333,10 12,10 C11.4476667,10 11,10.4476667 11,11 C11,11.5523333 11.4476667,12 12,12 L12,12 Z"
                }
            }
        ]
    })(props);
}
function GrFormLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M9,11 C9,11 9,8 9,8 C9,6.34314575 10.3431458,5 12,5 C13.6568542,5 15,6.34314575 15,8 L15,11 M12,13 L12,16 M17,18 L17,11 L7,11 L7,18 L17,18 Z"
                }
            }
        ]
    })(props);
}
function GrFormNextLink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M6,12.4 L18,12.4 M12.6,7 L18,12.4 L12.6,17.8"
                }
            }
        ]
    })(props);
}
function GrFormNext(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "points": "9 6 15 12 9 18"
                }
            }
        ]
    })(props);
}
function GrFormPin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "m4 19 4.455-4.454M12.273 5 18 10.727m-4.454-4.454L9.727 10.09s-2.545-.636-4.454 1.273l6.363 6.363c1.91-1.909 1.273-4.454 1.273-4.454l3.818-3.818-3.181-3.182Z"
                }
            }
        ]
    })(props);
}
function GrFormPreviousLink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M6,12.4 L18,12.4 M12.6,7 L18,12.4 L12.6,17.8",
                    "transform": "matrix(-1 0 0 1 24 0)"
                }
            }
        ]
    })(props);
}
function GrFormPrevious(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "points": "9 6 15 12 9 18",
                    "transform": "matrix(-1 0 0 1 24 0)"
                }
            }
        ]
    })(props);
}
function GrFormRefresh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M17.3333333,9.33333333 C16.3982691,7.36020781 14.3579813,6 12,6 C8.6862915,6 6,8.6862915 6,12 C6,15.3137085 8.6862915,18 12,18 C15.3137085,18 18,15.3137085 18,12 M18.5,6 L18.5,10 L14.5,10"
                }
            }
        ]
    })(props);
}
function GrFormSchedule(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M6,19 L18,19 L18,8 L6,8 L6,19 Z M8,15 L10,15 L8,15 Z M11,15 L16,15 L11,15 Z M15,8 L15,5 L15,8 Z M9,8 L9,5 L9,8 Z M6,11.5 L18,11.5 L6,11.5 Z"
                }
            }
        ]
    })(props);
}
function GrFormSearch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M13.8,13.8 L18,18 L13.8,13.8 Z M10.5,15 C12.9852814,15 15,12.9852814 15,10.5 C15,8.01471863 12.9852814,6 10.5,6 C8.01471863,6 6,8.01471863 6,10.5 C6,12.9852814 8.01471863,15 10.5,15 Z"
                }
            }
        ]
    })(props);
}
function GrFormSubtract(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M6,12 L18,12"
                }
            }
        ]
    })(props);
}
function GrFormTrash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M7.5,9 L16.5,9 L16.5,19 L7.5,19 L7.5,9 Z M5,9 L19,9 M9.36363636,6 L14.3636364,6 L14.3636364,9 L9.36363636,9 L9.36363636,6 Z M10.5455,11 L10.5455,17 M13.5455,11 L13.5455,17"
                }
            }
        ]
    })(props);
}
function GrFormUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "points": "18 9 12 15 6 9",
                    "transform": "matrix(1 0 0 -1 0 24)"
                }
            }
        ]
    })(props);
}
function GrFormUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M6,14.1818182 L6,17.4545455 L18,17.4545455 L18,14.1818182 M12,6 L12,14 M8.18181818,9.81818182 L12,6 L15.8181818,9.81818182"
                }
            }
        ]
    })(props);
}
function GrFormViewHide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M3,12 L6,12 C6.5,14.5 9.27272727,17 12,17 C14.7272727,17 17.5,14.5 18,12 L21,12 M12,17 L12,20 M7.5,15.5 L5.5,17.5 M16.5,15.5 L18.5,17.5"
                }
            }
        ]
    })(props);
}
function GrFormView(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,17 C9.27272727,17 6,14.2222222 6,12 C6,9.77777778 9.27272727,7 12,7 C14.7272727,7 18,9.77777778 18,12 C18,14.2222222 14.7272727,17 12,17 Z M11,12 C11,12.55225 11.44775,13 12,13 C12.55225,13 13,12.55225 13,12 C13,11.44775 12.55225,11 12,11 C11.44775,11 11,11.44775 11,12 Z"
                }
            }
        ]
    })(props);
}
function GrForwardTen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M20.8888889,7.55555556 C19.3304485,4.26701301 15.9299689,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 L12,22 C17.5228475,22 22,17.5228475 22,12 M22,4 L22,8 L18,8 M9,16 L9,9 L7,9.53333333 M17,12 C17,10 15.9999999,8.5 14.5,8.5 C13.0000001,8.5 12,10 12,12 C12,14 13,15.5000001 14.5,15.5 C16,15.4999999 17,14 17,12 Z M14.5,8.5 C16.9253741,8.5 17,11 17,12 C17,13 17,15.5 14.5,15.5 C12,15.5 12,13 12,12 C12,11 12.059,8.5 14.5,8.5 Z"
                }
            }
        ]
    })(props);
}
function GrFreebsd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M23.7253418,0.403330656 C24.9975688,1.67496208 21.4706794,7.26490597 20.8744345,7.86115088 C20.2781896,8.45650302 18.7637754,7.90875554 17.4918461,6.63682558 C16.2196191,5.36519416 15.6715737,3.85048208 16.2678187,3.25423717 C16.8640636,2.65769514 22.4534125,-0.868896418 23.7253418,0.403330656 L23.7253418,0.403330656 Z M5.88500669,1.74874919 C3.94274831,0.64670772 1.17931401,-0.579104582 0.300120884,0.300088547 C-0.590973233,1.19058772 0.680063246,4.01650237 1.79341076,5.96233113 C2.78417662,4.23935071 4.19415887,2.78890453 5.88500669,1.74874919 L5.88500669,1.74874919 Z M21.785166,7.42259564 C21.9639794,8.02925383 21.9315489,8.53058725 21.6417578,8.81978414 C20.9639901,9.49755113 19.1338994,8.77634479 17.4844083,7.20599597 C17.3689674,7.10275387 17.2550141,6.99564356 17.1428465,6.88317878 C16.5466016,6.28633892 16.0821617,5.65081997 15.785527,5.06617893 C15.2077288,4.02989107 15.0631307,3.11410221 15.4999004,2.67762963 C15.7379223,2.43960776 16.1187574,2.37474692 16.583198,2.45864948 C16.8863778,2.2673395 17.2437081,2.05371455 17.6358493,1.83503223 C16.0414007,1.00344305 14.2288637,0.533647279 12.305647,0.533647279 C5.92785039,0.533647279 0.757122899,5.70348271 0.757122899,12.0821714 C0.757122899,18.4596702 5.92785039,23.6301005 12.305647,23.6301005 C18.683741,23.6301005 23.8544685,18.4596702 23.8544685,12.0821714 C23.8544685,10.0223894 23.313861,8.09084213 22.3692121,6.41635843 C22.1648105,6.78856511 21.9663598,7.12982838 21.785166,7.42259564 L21.785166,7.42259564 Z"
                }
            }
        ]
    })(props);
}
function GrGallery(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,1 L19,1 L19,19 L1,19 L1,1 Z M5,19 L5,23 L23,23 L23,5.97061363 L18.9998921,5.97061363 M6,8 C6.55228475,8 7,7.55228475 7,7 C7,6.44771525 6.55228475,6 6,6 C5.44771525,6 5,6.44771525 5,7 C5,7.55228475 5.44771525,8 6,8 Z M2,18 L7,12 L10,15 L14,10 L19,16"
                }
            }
        ]
    })(props);
}
function GrGamepad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,6 L12,2 M12,6 C14.4983324,6.0444148 16.0056152,6 17,6 C19,6 21,6.5 22,10 C23,13.5 23,15.5 23,18 C23,20.5 21,21 19,21 C17,21 15.9456522,17 12,17 C8.05434783,17 7,21 5,21 C3,21 1,20.5 1,18 C1,15.5 1,13.5 2,10 C3,6.5 5,6 7,6 C7.99438477,6 9.50166757,6.0444148 12,6 L12,6 L12,6 Z M18,15 C18.5522847,15 19,14.5522847 19,14 C19,13.4477153 18.5522847,13 18,13 C17.4477153,13 17,13.4477153 17,14 C17,14.5522847 17.4477153,15 18,15 Z M14,12 C14.5522847,12 15,11.5522847 15,11 C15,10.4477153 14.5522847,10 14,10 C13.4477153,10 13,10.4477153 13,11 C13,11.5522847 13.4477153,12 14,12 Z M4,12 L10,12 M7,9 L7,15"
                }
            }
        ]
    })(props);
}
function GrGateway(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeWidth": "2",
                    "d": "M12 20v-5m0-6V4m-7 8h5m9 0h-5m-.969-4.031L12 9.344l-1.031-1.375h2.062zm-2.062 8.07L12 14.664l1.031 1.375H10.97zM6 13.031L4.625 12 6 10.969v2.062zm12-2.062L19.375 12 18 13.031V10.97zM12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1z"
                }
            }
        ]
    })(props);
}
function GrGatsbyjs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 Z M22,12.0921187 L15.5483871,12.0921187 L15.5483871,13.9264656 L19.9717742,13.9264656 C19.3266129,16.6787886 17.2983871,18.9719229 14.6262097,19.8898991 L4.02701613,9.33979569 C5.13306452,6.12868525 8.26653226,3.83514962 11.8616935,3.83514962 C14.6266129,3.83514962 17.1157258,5.21191322 18.6818548,7.32161278 L20.0649194,6.12948803 C18.2205645,3.65091216 15.2717742,2 11.8616935,2 C7.06895161,2 3.01370968,5.39454513 2,9.89009975 L14.1653226,22 C18.5887097,20.8989905 22,16.8622233 22,12.091316 L22,12.0921187 Z M2,12 C2,14.5927726 3.01847351,17.0923675 4.96305299,19.036947 C6.90763247,20.9815265 9.50040512,22 12,22 L2,12 Z"
                }
            }
        ]
    })(props);
}
function GrGem(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7 1H6.58579L6.29289 1.29289L3.29289 4.29289L3 4.58579V5V19V19.4142L3.29289 19.7071L6.29289 22.7071L6.58579 23H7H17H17.4142L17.7071 22.7071L20.7071 19.7071L21 19.4142V19V5V4.58579L20.7071 4.29289L17.7071 1.29289L17.4142 1H17H7ZM5 6V18H6V6H5ZM8 21H16V20H8V21ZM19 18V6H18V18H19ZM16 3H8V4H16V3ZM16 6V18H8V6H16Z"
                }
            }
        ]
    })(props);
}
function GrGift(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M3,11 L21,11 L21,23 L3,23 L3,11 Z M2,11 L2,7 L22,7 L22,11 L2,11 Z M12,23 L12,7 L12,23 Z M7,7 L12,7 C12,7 10,2 7,2 C3.5,2 3,7 7,7 Z M17.1843819,7 L12.1843819,7 C12.1843819,7 14,2 17.1843819,2 C20.5,2 21.1843819,7 17.1843819,7 Z"
                }
            }
        ]
    })(props);
}
function GrGithub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11.9989871,1 C5.92550416,1 1,5.92482888 1,12.0003376 C1,16.8603395 4.15153934,20.9829338 8.52263728,22.4374904 C9.0729918,22.5387827 9.27355045,22.199116 9.27355045,21.9073943 C9.27355045,21.6467356 9.2640965,20.954572 9.25869425,20.0368642 C6.19899322,20.7013414 5.55342398,18.5620492 5.55342398,18.5620492 C5.0530403,17.2911692 4.33183953,16.9528531 4.33183953,16.9528531 C3.33309801,16.2708186 4.40747107,16.2843243 4.40747107,16.2843243 C5.51155652,16.3619816 6.09229872,17.4181221 6.09229872,17.4181221 C7.07348292,19.0988981 8.66714755,18.6133706 9.2938089,18.3317781 C9.39375058,17.6213819 9.67804414,17.1365297 9.99205009,16.86169 C7.54955646,16.5841493 4.98146045,15.6401056 4.98146045,11.4249977 C4.98146045,10.224347 5.41026428,9.24181221 6.11390773,8.47334172 C6.00046042,8.19512569 5.62297799,7.07618404 6.22195279,5.56220265 C6.22195279,5.56220265 7.14506277,5.26642929 9.24653918,6.68992296 C10.12373,6.44547101 11.0650726,6.32392032 12.0003376,6.31919335 C12.9349274,6.32392032 13.8755947,6.44547101 14.7541361,6.68992296 C16.8542619,5.26642929 17.7760214,5.56220265 17.7760214,5.56220265 C18.3763467,7.07618404 17.9988643,8.19512569 17.8860923,8.47334172 C18.5910863,9.24181221 19.0165137,10.224347 19.0165137,11.4249977 C19.0165137,15.6509101 16.444366,16.5807729 13.9944443,16.8529114 C14.3888087,17.192578 14.7406305,17.863808 14.7406305,18.890236 C14.7406305,20.3603241 14.7271248,21.5467939 14.7271248,21.9073943 C14.7271248,22.2018171 14.9256576,22.5441849 15.4834403,22.4368151 C19.8511618,20.9788821 23,16.8589889 23,12.0003376 C23,5.92482888 18.0744958,1 11.9989871,1"
                }
            }
        ]
    })(props);
}
function GrGlobe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2,8 C2,8 5.5,9 7,10 C8.5,11 7.56437103,12.4191614 8,13 C8.43562897,13.5808386 10,12 10,15 C10,18 13,16 13,19 C13,22 15.5,21.5 16,20 C16.5,18.5 18.2333023,16.8664183 18,15 C17.7666977,13.1335817 17,12 15,12 C13,12 11.5,11.5 11,10 C10.5,8.5 14,8 13,5 C12,2 13,1 13,1 M23,12 C23,18.075 18.075,23 12,23 C5.925,23 1,18.075 1,12 C1,5.925 5.925,1 12,1 C18.075,1 23,5.925 23,12 L23,12 Z"
                }
            }
        ]
    })(props);
}
function GrGolang(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M21.4679537,3.20617761 C22.1814672,4.67953668 20.0131274,4.83706564 20.1243243,5.49498069 C20.3281853,6.68108108 20.1891892,8.44169884 20.0316602,10.1745174 C19.7629344,13.1119691 21.9590734,20.1451737 17.3814672,22.9714286 C16.5196911,23.5088803 14.4718147,23.8054054 12.4517375,23.8517375 C12.4517375,23.8517375 12.442471,23.8517375 12.442471,23.8517375 C12.442471,23.8517375 12.4332046,23.8517375 12.4332046,23.8517375 C10.4131274,23.8054054 8.08725869,23.5088803 7.22548263,22.9714286 C2.65714286,20.1451737 4.85328185,13.1119691 4.59382239,10.1745174 C4.42702703,8.44169884 4.28803089,6.68108108 4.5011583,5.49498069 C4.61235521,4.83706564 2.44401544,4.68880309 3.15752896,3.20617761 C3.76911197,1.93667954 5.27953668,3.05791506 5.65945946,2.65945946 C7.596139,0.648648649 9.94980695,0.111196911 11.8030888,0.0648648649 C11.988417,0.0648648649 12.8223938,0.0648648649 12.8223938,0.0648648649 C14.6664093,0.157528958 17.0200772,0.657915058 18.9660232,2.65945946 C19.3459459,3.05791506 20.8471042,1.93667954 21.4679537,3.20617761 Z M11.4324324,10.9065637 C11.3490347,10.9436293 11.2100386,11.8517375 11.6362934,11.8980695 C11.9235521,11.9258687 12.7111969,12.0185328 12.8965251,11.8980695 C13.2579151,11.6664093 13.2208494,11.1104247 13.0169884,10.9714286 C12.6741313,10.7490347 11.5250965,10.8602317 11.4324324,10.9065637 Z M9.07876448,4.10501931 C8.12432432,3.99382239 6.52123552,4.88339768 6.28030888,6.77374517 C6.02084942,8.73822394 8.33745174,10.6841699 10.56139,8.73822394 C11.7567568,7.69111969 12.1737452,4.46640927 9.07876448,4.10501931 Z M15.5281853,4.10501931 C12.4332046,4.46640927 12.8501931,7.69111969 14.0455598,8.73822394 C16.2694981,10.6841699 18.5861004,8.73822394 18.3266409,6.77374517 C18.0949807,4.88339768 16.4918919,3.99382239 15.5281853,4.10501931 Z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M12.3127413,8.98841699 C12.8965251,8.90501931 14.2957529,9.57220077 14.2030888,10.3598456 C14.0918919,11.2772201 10.5984556,11.3976834 10.4131274,10.3042471 C10.3019305,9.63706564 10.8301158,9.21081081 12.3127413,8.98841699 Z M20.1984556,16.3737452 C19.9111969,16.3644788 19.7258687,15.984556 19.7258687,15.7528958 C19.7258687,15.3359073 19.7814672,14.8447876 20.0872587,14.6316602 C20.7173745,14.196139 21.2177606,16.3830116 20.1984556,16.3737452 Z M4.41776062,16.3737452 C3.3984556,16.3830116 3.8988417,14.196139 4.52895753,14.6316602 C4.83474903,14.8447876 4.89034749,15.3359073 4.89034749,15.7528958 C4.89034749,15.984556 4.70501931,16.3644788 4.41776062,16.3737452 Z M18.2617761,23.0918919 C18.4471042,23.3606178 18.4563707,23.5459459 18.1598456,23.6849421 C17.0293436,24.203861 16.019305,23.5088803 16.3992278,23.3142857 C17.2054054,22.9065637 17.7057915,22.2671815 18.2617761,23.0918919 Z M6.35444015,23.184556 C6.91042471,22.3598456 7.41081081,22.9992278 8.21698842,23.4069498 C8.5969112,23.6015444 7.58687259,24.2965251 6.45637066,23.7776062 C6.15984556,23.63861 6.16911197,23.4532819 6.35444015,23.184556 Z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M19.7351351,3.42857143 C19.7814672,3.23397683 20.2633205,3.14131274 20.5320463,3.47490347 C20.8563707,3.87335907 20.0594595,4.42007722 20.0223938,4.1976834 C19.9297297,3.5953668 19.6795367,3.62316602 19.7351351,3.42857143 Z M4.88108108,3.42857143 C4.93667954,3.62316602 4.68648649,3.5953668 4.59382239,4.1976834 C4.55675676,4.42007722 3.75984556,3.87335907 4.08416988,3.47490347 C4.34362934,3.14131274 4.82548263,3.23397683 4.88108108,3.42857143 Z M15.7413127,7.94131274 C15.1578953,7.94131274 14.6849421,7.46835949 14.6849421,6.88494208 C14.6849421,6.30152468 15.1578953,5.82857143 15.7413127,5.82857143 C16.3247301,5.82857143 16.7976834,6.30152468 16.7976834,6.88494208 C16.7976834,7.46835949 16.3247301,7.94131274 15.7413127,7.94131274 Z M15.4633205,6.76447876 C15.6475575,6.76447876 15.7969112,6.61512511 15.7969112,6.43088803 C15.7969112,6.24665096 15.6475575,6.0972973 15.4633205,6.0972973 C15.2790834,6.0972973 15.1297297,6.24665096 15.1297297,6.43088803 C15.1297297,6.61512511 15.2790834,6.76447876 15.4633205,6.76447876 Z M11.3583012,9.43320463 C11.4694981,9.00694981 11.8586873,8.86795367 12.1737452,8.85868726 C12.9799228,8.84015444 13.2857143,9.27567568 13.3135135,9.61853282 C13.369112,10.2023166 11.1081081,10.3413127 11.3583012,9.43320463 Z M8.87490347,7.94131274 C8.29148607,7.94131274 7.81853282,7.46835949 7.81853282,6.88494208 C7.81853282,6.30152468 8.29148607,5.82857143 8.87490347,5.82857143 C9.45832088,5.82857143 9.93127413,6.30152468 9.93127413,6.88494208 C9.93127413,7.46835949 9.45832088,7.94131274 8.87490347,7.94131274 Z M9.15289575,6.76447876 C9.33713283,6.76447876 9.48648649,6.61512511 9.48648649,6.43088803 C9.48648649,6.24665096 9.33713283,6.0972973 9.15289575,6.0972973 C8.96865868,6.0972973 8.81930502,6.24665096 8.81930502,6.43088803 C8.81930502,6.61512511 8.96865868,6.76447876 9.15289575,6.76447876 Z"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function GrGooglePay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "clipPath": "url(#a)"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "m12.645 14.34 5.937-10.285 3.234 1.867a4.366 4.366 0 0 1 1.598 5.964l-3.344 5.791a2.732 2.732 0 0 1-3.728 1l-3.002-1.732a1.909 1.909 0 0 1-.695-2.606Z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M12.012 7.2 4.625 19.991l3.235 1.867a4.367 4.367 0 0 0 5.964-1.598l4.791-8.298a2.729 2.729 0 0 0-1-3.729l-3.002-1.732a1.903 1.903 0 0 0-2.601.697Z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "m18.582 4.053-2.29-1.32A5.456 5.456 0 0 0 8.839 4.73l-4.246 7.352a2.729 2.729 0 0 0 1 3.728l2.289 1.32a2.729 2.729 0 0 0 3.728-1l5.069-8.779a3.81 3.81 0 0 1 5.206-1.394l-3.302-1.904Z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M9.496 6.885 6.971 5.43a2.357 2.357 0 0 0-3.215.86L.725 11.524a5.383 5.383 0 0 0 1.977 7.363l1.923 1.108 2.332 1.343 1.012.582a4.138 4.138 0 0 1-1.27-5.51l.786-1.355 2.872-4.964a2.343 2.343 0 0 0-.86-3.207Z"
                        }
                    }
                ]
            },
            {
                "tag": "defs",
                "attr": {},
                "child": [
                    {
                        "tag": "clipPath",
                        "attr": {
                            "id": "a"
                        },
                        "child": [
                            {
                                "tag": "path",
                                "attr": {
                                    "d": "M0 0h24v24H0z"
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    })(props);
}
function GrGooglePlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.128 12.003 1.09 22.011a2.73 2.73 0 0 0 3.999 1.62l11.29-6.377-5.251-5.25Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21.338 9.67-4.899-2.806-5.311 5.14 5.251 5.25 4.944-2.865a2.663 2.663 0 0 0 0-4.719h.015Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.09 1.995c-.06.225-.091.457-.09.69V21.32c0 .233.03.465.09.69l10.038-10.007L1.09 1.995Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11.128 12.003 5.311-5.139L5.126.383A2.79 2.79 0 0 0 3.723 0 2.73 2.73 0 0 0 1.09 1.988l10.038 10.015Z"
                }
            }
        ]
    })(props);
}
function GrGooglePlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M0.0202537528,11.2032618 C0.0858884305,7.29693926 3.69605513,3.87603603 7.62298049,4.00635861 C9.5045944,3.91939087 11.2733582,4.73384249 12.7144674,5.87784249 C12.0993693,6.57306829 11.4624794,7.24274571 10.7820061,7.86906829 C9.04956189,6.67810055 6.58579693,6.33771345 4.85335275,7.71345539 C2.37505996,9.41848765 2.26220982,13.4442941 4.64607169,15.2796489 C6.96429889,17.3722941 11.3459973,16.3333264 11.9865191,13.1291973 C10.534514,13.1075199 9.07861756,13.1291973 7.62661245,13.0822296 C7.62298049,12.2205522 7.61934853,11.3588747 7.62298049,10.4974554 C10.0504259,10.4902296 12.4778712,10.4863586 14.9089486,10.5046812 C15.0544863,12.532036 14.7852026,14.6897135 13.5332146,16.3658425 C11.6370729,19.0195199 7.83052098,19.7942296 4.86061667,18.6574554 C1.88007591,17.527907 -0.230870232,14.3962941 0.0202537528,11.2032618 M19.6437253,8.32145539 L21.8091508,8.32145539 C21.8127827,9.04197152 21.8164147,9.76610055 21.8236786,10.4863586 C22.5479949,10.4938425 23.2759431,10.4938425 24,10.5010683 L24,12.6551328 C23.2759431,12.6623586 22.5516269,12.6659715 21.8236786,12.6731973 C21.8164147,13.3970683 21.8127827,14.1175844 21.8091508,14.8381005 L19.6400933,14.8381005 C19.6328294,14.1175844 19.6328294,13.3970683 19.6255655,12.6768102 C18.9012492,12.6695844 18.1735604,12.6623586 17.4492441,12.6551328 L17.4492441,10.5010683 C18.1735604,10.4938425 18.8976172,10.4902296 19.6255655,10.4863586 C19.6291974,9.76248765 19.6364613,9.04197152 19.6437253,8.32145539"
                }
            }
        ]
    })(props);
}
function GrGoogleWallet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.3007772,20.2064516 C11.8620675,20.9290323 11.1007772,21.3548387 10.2620675,21.3548387 C10.0298095,21.3548387 9.79755139,21.316129 9.57819655,21.2516129 C9.39755139,21.1870968 9.204003,21.1096774 9.03626107,21.0064516 C8.36529333,20.5935484 7.96529333,19.9096774 7.9007772,19.1870968 C7.89140409,19.0839926 7.88808323,18.9793754 7.89136416,18.8743442 C7.55009449,15.0742313 5.43254085,11.8144954 2.19755139,10.0774194 C1.1007772,9.49677419 0.674970747,8.11612903 1.26851913,7.01935484 C1.66851913,6.27096774 2.42980946,5.81935484 3.26851913,5.81935484 C3.64271268,5.81935484 4.01690623,5.90967742 4.33948688,6.09032258 C6.48434923,7.23339294 8.37353109,8.87504028 9.73981084,10.748043 C9.55437093,9.20494486 9.06580772,7.70138229 8.2491643,6.38709677 C7.86206752,5.74193548 7.82335784,4.95483871 8.05561591,4.3483871 C8.17174494,4.03870968 8.32658365,3.75483871 8.59755139,3.47096774 C8.86851913,3.18709677 9.16529333,3.03225806 9.4491643,2.91612903 C9.72013204,2.81290323 9.91368042,2.76129032 10.3007772,2.76129032 C10.7652933,2.76129032 11.2169062,2.90322581 11.5910998,3.1483871 C11.6256625,3.16950877 11.659368,3.19148766 11.6922588,3.21432378 C11.6556159,3.17419355 11.5910998,3.13548387 11.5910998,3.13548387 C14.3738522,4.83605479 16.7449876,7.17977729 18.3834315,9.79420491 C18.1429112,7.64929068 17.5519189,5.57240342 16.6104546,3.57419355 C16.0169062,2.33548387 16.5459385,0.838709677 17.7975514,0.24516129 C18.1330353,0.0774193548 18.4943256,0 18.8685191,0 C19.8233578,0 20.7136804,0.567741935 21.1265836,1.43225806 C21.9007772,3.05806452 22.4943256,4.76129032 22.8943256,6.51612903 C23.2943256,8.29677419 23.5136804,10.1677419 23.5265836,12.0258065 C23.5265836,13.9096774 23.3072288,15.7419355 22.9072288,17.5354839 C22.804003,18.0129032 22.687874,18.4645161 22.5459385,18.9419355 C22.1072288,20.5290323 21.604003,21.7548387 21.1007772,22.6967742 C20.6620675,23.4967742 19.8233578,24 18.9072288,24 C18.5330353,24 18.1717449,23.9096774 17.8362611,23.7548387 C17.087874,23.4064516 16.6362611,22.7612903 16.4685191,22.0516129 C16.4169062,21.8451613 16.404003,21.6258065 16.404003,21.4709677 C16.404003,20.9290323 16.3781966,20.5677419 16.3781966,20.5677419 C16.3781966,17.8729043 15.7339615,15.3069136 14.548495,13.0500263 C14.3781966,15.6 13.6169062,18.0516129 12.3007772,20.2064516 Z"
                }
            }
        ]
    })(props);
}
function GrGoogle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.26620003,9.76452941 C6.19878754,6.93863203 8.85444915,4.90909091 12,4.90909091 C13.6909091,4.90909091 15.2181818,5.50909091 16.4181818,6.49090909 L19.9090909,3 C17.7818182,1.14545455 15.0545455,0 12,0 C7.27006974,0 3.1977497,2.69829785 1.23999023,6.65002441 L5.26620003,9.76452941 Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.0407269,18.0125889 C14.9509167,18.7163016 13.5660892,19.0909091 12,19.0909091 C8.86648613,19.0909091 6.21911939,17.076871 5.27698177,14.2678769 L1.23746264,17.3349879 C3.19279051,21.2936293 7.26500293,24 12,24 C14.9328362,24 17.7353462,22.9573905 19.834192,20.9995801 L16.0407269,18.0125889 Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.834192,20.9995801 C22.0291676,18.9520994 23.4545455,15.903663 23.4545455,12 C23.4545455,11.2909091 23.3454545,10.5272727 23.1818182,9.81818182 L12,9.81818182 L12,14.4545455 L18.4363636,14.4545455 C18.1187732,16.013626 17.2662994,17.2212117 16.0407269,18.0125889 L19.834192,20.9995801 Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.27698177,14.2678769 C5.03832634,13.556323 4.90909091,12.7937589 4.90909091,12 C4.90909091,11.2182781 5.03443647,10.4668121 5.26620003,9.76452941 L1.23999023,6.65002441 C0.43658717,8.26043162 0,10.0753848 0,12 C0,13.9195484 0.444780743,15.7301709 1.23746264,17.3349879 L5.27698177,14.2678769 Z"
                }
            }
        ]
    })(props);
}
function GrGraphQl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.3335126,2.85206923 L19.0436746,5.57156232 C19.1861408,5.42269933 19.3517561,5.29107777 19.5390336,5.18229987 C20.6054985,4.56924218 21.9657203,4.93324518 22.585164,5.99971013 C23.1982217,7.06617507 22.8342187,8.42639682 21.7677537,9.04584053 C21.5354003,9.17940894 21.2887997,9.26659782 21.038849,9.31024708 L21.038849,14.6900096 C21.2856344,14.7341019 21.5290274,14.8207365 21.7585099,14.9526546 C22.8303433,15.5715108 23.1940011,16.9304425 22.5751449,17.9958959 C21.9626686,19.0613494 20.597357,19.4250072 19.5319036,18.8125309 C19.2675499,18.6605671 19.046399,18.4622584 18.8726413,18.2336837 L14.2472483,20.9042339 C14.359389,21.1704807 14.4213527,21.4632106 14.4213527,21.770637 C14.4213527,22.997106 13.4248466,24 12.1919896,24 C10.9591327,24 9.96262662,23.0034939 9.96262662,21.770637 C9.96262662,21.5276826 10.001326,21.293907 10.0729072,21.0751276 L5.39448212,18.3739583 C5.24136397,18.5447862 5.05910975,18.6948998 4.84979559,18.8164775 C3.77694463,19.4295352 2.41672287,19.0655322 1.80366518,17.9990673 C1.19060749,16.9326023 1.55461049,15.5723806 2.62107544,14.9529369 C2.78345801,14.8595912 2.95265101,14.7888975 3.12500248,14.7398866 L3.12500248,9.26050018 C2.95045269,9.21143227 2.77917162,9.14021295 2.61500295,9.04584053 C1.548538,8.43278284 1.184535,7.06617507 1.79759269,5.99971013 C2.41065038,4.93324518 3.77725815,4.56924218 4.8437231,5.18229987 C4.99574654,5.27060092 5.13349582,5.37395472 5.25617553,5.48936462 L10.0208088,2.73842163 C9.98274768,2.57496174 9.96262662,2.40454853 9.96262662,2.22936302 C9.96262662,0.996506107 10.9591327,4.6629367e-14 12.1919896,4.6629367e-14 C13.4248466,4.6629367e-14 14.4213527,0.996506107 14.4213527,2.22936302 C14.4213527,2.44556708 14.3907061,2.6545024 14.3335126,2.85206923 Z M13.8405544,3.73141097 C13.7908242,3.78597435 13.7384158,3.8380524 13.6835353,3.88743909 L19.9624322,14.7624885 C19.9851165,14.7552188 20.0079142,14.7483109 20.0308156,14.7417672 L20.0308156,9.25474103 C19.4969015,9.10015188 19.0200076,8.74749468 18.7216233,8.22843028 C18.396599,7.66302338 18.3462063,7.01504748 18.5295247,6.43866863 L13.8405544,3.73141097 Z M10.5612952,3.75078761 C10.5290822,3.71626947 10.4979547,3.6807246 10.4679668,3.64420691 L5.81568405,6.33028239 C6.04182311,6.93281226 6.00669953,7.62728911 5.66113335,8.22843028 C5.32249418,8.81752134 4.75393127,9.19227671 4.13303588,9.30641503 L4.13303588,14.6916383 C4.16637437,14.6977154 4.19956458,14.7045461 4.23257942,14.7121233 L10.5612952,3.75078761 Z M12.8009687,4.3748119 C12.60746,4.42948073 12.403193,4.45872604 12.1919896,4.45872604 C11.9129003,4.45872604 11.645923,4.40765895 11.3998763,4.31434325 L5.14116232,15.1544358 C5.34676617,15.3211714 5.52618301,15.5275552 5.66720584,15.7703471 C5.76055152,15.9327297 5.83124515,16.1019227 5.8802561,16.2742741 L18.5020915,16.2742741 C18.5510684,16.101457 18.6218024,15.9318817 18.7152686,15.7692896 C18.8216025,15.5843129 18.950628,15.4204894 19.0968364,15.2792547 L12.8009687,4.3748119 Z M13.7498392,20.1747099 L18.4885766,17.4387184 C18.4752977,17.3870257 18.4638585,17.3348529 18.454287,17.2823075 L5.92850441,17.2823075 C5.91572246,17.3524283 5.89960649,17.4218931 5.88022341,17.4904498 L10.5957921,20.2130645 C11.0004395,19.7984186 11.5657199,19.541274 12.1919896,19.541274 C12.7987163,19.541274 13.3482006,19.7826203 13.7498392,20.1747099 Z"
                }
            }
        ]
    })(props);
}
function GrGremlin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M7,14 C7.55228475,14 8,13.5522847 8,13 C8,12.4477153 7.55228475,12 7,12 C6.44771525,12 6,12.4477153 6,13 C6,13.5522847 6.44771525,14 7,14 Z M17,14 C17.5522847,14 18,13.5522847 18,13 C18,12.4477153 17.5522847,12 17,12 C16.4477153,12 16,12.4477153 16,13 C16,13.5522847 16.4477153,14 17,14 Z M12,16 C12.5,16 13,15.6790227 13,15 C13,14.8871314 11,14.9246156 11,15 C11,15.6790227 11.5,16 12,16 Z M3,24 C3,24 3.00341148,16 3,12 C3.00341148,8 2.55309359,4 12,4 C21.4469064,4 20.9965885,8 21,12 C20.9965885,16 21,24 21,24 M20.0682179,7 C23.3272228,7 23.6478055,3.42041241 22.1136966,1.88630344 C20.5795876,0.352194472 17,0.672777193 17,3.93178206 M7,19 C7,18.7966267 9.50000016,20.1517845 12,20 C14.4999998,20.1517846 17,18.5013715 17,19 C17,19.8021982 15.5,21 12,21 C8.5,21 7,19.5069424 7,19 Z M3.94464295,7 C0.604407067,7 0.38005973,3.42041241 1.90773825,1.88630344 C3.43541678,0.352194472 7,0.672777193 7,3.93178206"
                }
            }
        ]
    })(props);
}
function GrGrid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M8,1 L8,23 M16,1 L16,23 M1,8 L23,8 M1,16 L23,16 M1,1 L23,1 L23,23 L1,23 L1,1 Z"
                }
            }
        ]
    })(props);
}
function GrGrommet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "4",
                    "d": "M12,2 C6.485,2 2,6.485 2,12 C2,17.515 6.485,22 12,22 C17.515,22 22,17.515 22,12 C22,6.485 17.515,2 12,2 Z"
                }
            }
        ]
    })(props);
}
function GrGroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,13 C14.209139,13 16,11.209139 16,9 C16,6.790861 14.209139,5 12,5 C9.790861,5 8,6.790861 8,9 C8,11.209139 9.790861,13 12,13 Z M6,22 L6,19 C6,15.6862915 8.6862915,13 12,13 C15.3137085,13 18,15.6862915 18,19 L18,22 M13,5 C13.4037285,3.33566165 15.0151447,2 17,2 C19.172216,2 20.98052,3.790861 21,6 C20.98052,8.209139 19.172216,10 17,10 L16,10 L17,10 C20.287544,10 23,12.6862915 23,16 L23,18 M11,5 C10.5962715,3.33566165 8.98485529,2 7,2 C4.82778404,2 3.01948003,3.790861 3,6 C3.01948003,8.209139 4.82778404,10 7,10 L8,10 L7,10 C3.71245602,10 1,12.6862915 1,16 L1,18"
                }
            }
        ]
    })(props);
}
function GrGrow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,16 L12,7 M12.0000002,11 C12,8 12,5 5,5 C5,8 5,11 12.0000002,11 Z M4,16 L20,16 M18,16 L16,23 L8,23 L6,16 L6,16 M12,7 C12,4 12,1 19,1 C19,4 19,7 12,7 Z"
                }
            }
        ]
    })(props);
}
function GrHadoop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M22.6148786,8.51458809 C22.4527967,9.15577678 22.1254391,9.70110654 21.4473346,9.94260905 C21.1149047,10.060965 20.9000793,9.93918049 20.561027,9.84144289 C20.8938327,9.87309841 21.0852218,9.92424509 21.3832721,9.77672285 C21.939686,9.50159222 22.3496579,9.05202745 22.6148786,8.51458809 L22.6148786,8.51458809 Z M23.9697255,12.7295161 C23.8906337,13.5066732 23.683182,14.2616621 23.3136953,14.9015827 C22.9828153,15.4754212 22.5216967,15.9578157 21.9074669,16.2867231 C21.4900743,16.5086405 21.0050967,16.6371413 20.5037277,16.68965 C19.9832433,16.7437556 19.4459448,16.7148241 18.9445759,16.6297205 C18.9211395,16.7074034 18.8969047,16.7863543 18.8738441,16.8635205 C18.8445369,16.9605536 18.814854,17.0582442 18.7855468,17.1547137 C18.6832065,17.4910419 18.4386981,17.7941647 18.1340254,18.0187592 C17.8195837,18.2507744 17.436195,18.4023358 17.0787318,18.4183984 C16.7372843,18.4349776 16.4734256,18.3545238 16.2394847,18.2163948 C16.0129176,18.0831974 15.8191802,17.897867 15.6078303,17.69375 L15.3309149,17.4273551 C15.268825,17.3668151 15.2066881,17.306463 15.1438468,17.2464866 C15.1371775,17.2900247 15.1309779,17.3316371 15.1243086,17.3696801 C15.2219523,17.5671749 15.2910872,17.7523174 15.3613963,17.9421566 L15.3613963,17.9427202 C15.4057328,18.061264 15.4512435,18.1831425 15.5061475,18.3152127 C15.5879634,18.5105 15.6497245,18.6734273 15.692699,18.8423663 C15.7356265,19.0129022 15.7592977,19.1863031 15.764558,19.3988272 C15.7695834,19.5798836 15.7745149,19.7605643 15.7795403,19.941245 C15.7840491,20.111734 15.7883701,20.2822699 15.7938182,20.4527588 C15.8691997,20.5894787 15.913771,20.6832241 15.9359863,20.7867386 C15.9609725,20.8971103 15.9584833,21.0047109 15.9457553,21.1800843 C15.918045,21.5742754 15.7877595,21.7939384 15.568848,21.9185879 C15.3633689,22.0350182 15.0912911,22.0523959 14.754775,22.050799 C14.7035814,22.0500006 14.6206383,22.0500006 14.5199888,22.0500006 C14.1934766,22.0500006 13.6883973,22.050799 13.533877,22.0398558 C13.3262844,22.0248265 13.153588,22.0089987 13.0086959,21.9742434 C12.8969623,21.9477072 12.8051425,21.9089598 12.728399,21.8527407 C12.6168532,21.9427757 12.5188338,22.0242159 12.4203447,22.1052803 C12.1304196,22.3441527 11.8361266,22.5875339 11.7175827,22.6663909 C11.672166,22.7363242 11.6310702,22.8068212 11.593356,22.8722927 C11.4716654,23.0855682 11.3816303,23.2433292 11.094711,23.3990237 C10.5312052,23.7033206 10.0951198,23.6767844 9.71257649,23.4419981 C9.3481153,23.218343 9.04705907,22.8074318 8.73228859,22.3218905 C8.58255892,22.0914252 8.34349867,21.7117468 8.22711532,21.3394422 C8.0984267,20.9273568 8.11627402,20.5265434 8.5268095,20.3156162 C8.54634763,20.3054714 8.56616756,20.2952796 8.58471938,20.2855106 C8.627506,20.2632484 8.66785035,20.2429588 8.70814774,20.2221995 C8.55254723,20.2304187 8.39614829,20.2367122 8.24054778,20.2347396 C7.93507669,20.232767 7.62814964,20.211726 7.31516389,20.1714286 C7.32023629,20.2087671 7.32455722,20.2386379 7.32695252,20.2579881 C7.35090551,20.4655807 7.36748474,20.6015022 7.34775875,20.7376585 C7.32793882,20.8780888 7.27218941,21.003067 7.15350469,21.1800374 C7.14561429,21.191779 7.11903117,21.2302447 7.09629931,21.2624638 C6.98625645,21.4245927 6.92120764,21.5210622 6.76983413,21.8560283 C6.78476953,22.0211161 6.78965406,22.1538908 6.77871083,22.2861019 C6.76668737,22.4285048 6.73672264,22.5733969 6.68604563,22.7628604 C6.55684038,23.2406052 6.07646549,23.3507419 5.54423942,23.3173487 C5.05588021,23.2869143 4.52121188,23.1331924 4.21231223,23.0492161 C4.14524385,23.0314157 4.09085647,23.0173257 4.03801899,23.0034705 C3.77735409,22.9355098 3.49649353,22.862054 3.26011038,22.7546412 C2.78678049,22.5385947 2.48342291,22.1995894 2.77884313,21.5505103 C2.82642035,21.4476064 2.8678919,21.3429177 2.90560612,21.2374306 C2.92007184,21.1999512 2.92955911,21.1640217 2.9418174,21.1265424 C2.70083153,21.1640217 2.44481632,21.1183232 2.19551735,21.0235915 C1.75938505,20.8577992 1.342603,20.5410091 1.08762107,20.2859333 C0.883738843,20.0815814 0.725132469,19.8617305 0.606447747,19.6359148 C0.478040929,19.3913595 0.395896259,19.1378805 0.354095942,18.8882528 C0.285242834,18.4796899 0.333289716,18.4331929 0.574792225,18.2013185 C0.610815645,18.1659996 0.651159997,18.1275339 0.661022993,18.1179527 C0.780365248,17.9999725 0.89890907,17.8816635 1.01796953,17.7642469 C1.14501431,17.6382824 1.27351506,17.5113315 1.40009018,17.3847564 C1.45828186,17.2273242 1.51619174,17.0703147 1.57457128,16.9115204 C1.61209764,16.8101664 1.64929522,16.7080139 1.68639887,16.6070826 C1.66855155,16.5129145 1.65239502,16.4182297 1.63882166,16.3213375 C1.6231348,16.2082418 1.61078257,16.1043516 1.60261037,16.0106062 C1.56588245,15.5787948 1.55357719,15.2074295 1.56639909,14.8711483 C1.57607422,14.6146634 1.59998024,14.37875 1.63933829,14.1529813 C1.4399179,14.1974117 1.23678714,14.1939832 1.05272485,14.1356036 C0.825265365,14.0621478 0.626737339,13.9051383 0.503778652,13.6470096 C0.457704369,13.5522778 0.421446116,13.4564659 0.387160463,13.3483017 C0.357007874,13.2528654 0.329156651,13.1463451 0.299285862,13.0256408 C0.13617069,12.8575941 0.0437403251,12.6812344 0.0130711032,12.5006476 C-0.0233750164,12.2933838 0.0186131678,12.0866835 0.111419266,11.8886252 C0.200280166,11.6982694 0.336718282,11.5172129 0.494620156,11.3529706 C0.919903162,10.9112492 1.5244109,10.579242 1.80574113,10.5303967 L2.01676228,10.4934809 L1.94654714,10.6956253 C1.91005406,10.7979657 1.86736137,10.9051905 1.82607769,11.0107246 C1.81442996,11.0413938 1.80264133,11.0723448 1.7898664,11.1056442 C1.91925952,11.2079845 1.99680146,11.3499647 2.03301274,11.5115769 C2.08956059,11.7614865 2.05302054,12.049392 2.00478579,12.264828 L1.94725164,12.5227219 L1.7838077,12.3159747 C1.74426179,12.2672233 1.71133817,12.2164524 1.67968264,12.1672314 C1.65046939,12.1222843 1.62275906,12.0800143 1.59443818,12.045259 C1.57194115,12.3807417 1.53112713,12.7171638 1.29206689,12.946502 C1.29883009,12.9753395 1.30202382,12.9907446 1.30681442,12.9940792 C1.31061872,12.9960518 1.35124487,12.9738835 1.44931123,12.9356997 C1.6176397,12.8714493 1.76736938,12.7642244 1.90822236,12.6381659 C2.05302054,12.5077865 2.18546649,12.3589492 2.31946234,12.2116618 C2.47092978,11.9175097 2.64428368,11.6392792 2.84670994,11.3746691 C3.05247083,11.1046579 3.28796161,10.8493941 3.55980457,10.6085492 C4.22513412,10.0193056 4.87238151,9.62689924 5.6070808,9.34261011 C6.32623413,9.06470845 7.12795483,8.88956982 8.11284546,8.73166794 C8.23679045,8.60316719 8.36256713,8.47588757 8.49153755,8.35001695 C8.6299013,8.21719527 8.77286778,8.08437358 8.92259746,7.95159887 C9.13296108,7.7666442 9.30875724,7.65354851 9.48361408,7.58356821 C9.64151595,7.51931783 9.79730433,7.49419067 9.97239599,7.48141574 C10.2730765,7.0805554 10.5472208,6.73661862 10.8697408,6.4386622 C11.207431,6.12638095 11.5952346,5.86646752 12.1173629,5.6469454 C13.1987699,5.19080531 14.1156059,4.95320103 14.9827981,5.00768234 C15.8562369,5.06230455 16.6734096,5.41197126 17.5491967,6.13455315 C17.7144724,6.2710852 17.8828008,6.41856048 18.0505657,6.56589486 C18.4175631,6.88855573 18.7777034,7.20450038 19.2007789,7.46911048 C19.3601368,7.56783438 19.494931,7.65359548 19.6281285,7.75457378 C19.759776,7.8550824 19.8812787,7.96737966 20.0078069,8.11678057 C20.1607303,8.29985657 20.3003621,8.48269774 20.4228511,8.67850169 C20.5257551,8.84208653 20.6156023,9.01572223 20.6949289,9.20621896 C20.8742006,9.13393729 21.0640398,9.05428185 21.2160239,8.92582807 C21.3472957,8.81324901 21.456634,8.65337454 21.5656436,8.4940167 C21.6632873,8.35053358 21.7613067,8.20836554 21.877737,8.09118375 C21.9156861,8.0518257 21.9589893,8.01970051 22.005909,7.99607628 C22.1844292,7.90181422 22.4103858,7.91736018 22.6242719,7.99119175 C22.8262285,8.06032666 23.0211401,8.18319141 23.153586,8.31385263 C23.2145018,8.37335938 23.2633471,8.43709312 23.2953784,8.49890123 C23.5613975,9.00750307 23.7527865,9.71463294 23.8684184,10.4424281 C23.9972949,11.2597887 24.032426,12.1066913 23.9697255,12.7295161 L23.9697255,12.7295161 Z M20.2449884,9.38187423 C20.2063349,9.38286053 20.1684328,9.38384683 20.1317049,9.38520886 C20.1867968,9.43931444 20.2299591,9.50356482 20.2616146,9.57457839 C20.2772076,9.559643 20.2950079,9.54517727 20.3141233,9.53212054 C20.2914384,9.48139656 20.2684248,9.43109528 20.2449884,9.38187423 L20.2449884,9.38187423 Z M1.49914284,11.6538859 C1.59749101,11.6428487 1.65864158,11.694512 1.73472756,11.7702692 C1.72096633,11.5887431 1.68658674,11.4539958 1.55911926,11.379084 C1.54996076,11.4085791 1.5427279,11.438262 1.53422693,11.4682267 C1.5177886,11.5266063 1.50764381,11.5886962 1.49914284,11.6538859 L1.49914284,11.6538859 Z M1.88995233,13.6347043 C1.89915779,13.6020625 1.90878596,13.5699373 1.91935345,13.5371076 C1.98116156,13.3420081 2.04738454,13.1526386 2.11839811,12.969046 C1.9698426,13.1033236 1.80278223,13.2172647 1.60012114,13.2984231 C1.07606727,13.5080822 1.0867287,13.3269318 0.861147885,12.8719659 C1.34072434,12.4889529 1.11875995,12.0185349 1.27140156,11.4898314 C1.30695532,11.3683287 1.35843076,11.249597 1.43127604,11.0930571 C0.929014692,11.3954284 0.00597913924,12.2399357 0.622792141,12.8799502 C0.689672649,13.1214528 0.741335963,13.3093663 0.833155762,13.5003327 C1.02196169,13.8947586 1.51515847,13.7935925 1.88995233,13.6347043 L1.88995233,13.6347043 Z M3.27852131,20.0330179 C2.74235004,19.2215281 2.25798299,18.2554711 1.97374083,17.2730697 C1.92127909,17.4138757 1.86867644,17.5535545 1.81649649,17.6941727 C1.57616815,17.9367084 1.33593374,18.1800896 1.0956054,18.4236117 C0.91755483,18.6042924 0.88279951,18.610539 0.91882293,18.8658027 C0.967386445,19.2162209 1.17413363,19.5886664 1.48298632,19.9039065 C1.76549071,20.1924227 2.74070621,20.9449223 3.1241889,20.4320465 C3.20581694,20.3226612 3.24423566,20.1874912 3.27852131,20.0480472 L3.27852131,20.0330179 L3.27852131,20.0330179 Z M15.0621717,18.4968797 C14.9773969,18.2953458 14.9305242,18.106305 14.8715341,17.9154326 C14.7439727,18.3717136 14.5718869,18.8011766 14.4156758,19.294937 C14.2676369,19.7621142 13.507059,21.1168203 13.0602183,21.4461034 C13.1472945,21.5109644 13.307075,21.5359506 13.5918338,21.5606081 C13.7934147,21.5777509 14.5869632,21.5824476 14.7869472,21.5853595 C15.2259914,21.5933908 15.3926291,21.5599976 15.4371535,21.0603663 C15.4586172,20.8152474 15.4390791,20.7697367 15.316778,20.5550991 C15.3062574,20.1726497 15.2957369,19.7894488 15.2851694,19.4070464 C15.2740853,19.0447456 15.2043868,18.8351804 15.0621717,18.4968797 L15.0621717,18.4968797 Z M22.9516294,8.87327239 C22.849477,8.62589905 22.441055,8.25519129 22.1816582,8.50716736 C21.91996,8.7621493 21.7230758,9.12102146 21.4379413,9.34660228 C21.0492923,9.65207336 20.3809099,9.54700897 20.5019899,10.196229 C20.5904751,10.6690892 20.6156492,11.1983563 20.5144831,11.6389035 C20.4180136,12.0620261 20.3176458,12.6633401 20.0969026,12.9465959 C20.1621393,12.7068781 20.2719003,12.0801082 20.3025695,11.6572675 C20.3191957,11.4259098 20.2932232,11.146693 20.2500139,10.8656916 C20.2012155,10.8666779 20.152605,10.8678051 20.1027734,10.869308 C19.9246289,10.8729244 19.634375,11.128376 19.5562695,11.2877808 C19.3382973,11.7317096 19.3234558,12.1442177 19.0793232,12.5667766 C19.2758316,12.094433 19.1652721,11.6684455 19.3447317,11.1618163 C19.4078549,10.9831082 19.568199,10.8290106 19.7535294,10.7352182 C19.6503907,10.7198132 19.5472519,10.7649011 19.3948921,10.8004549 C18.742948,10.9555388 18.7722552,11.4679449 18.3713009,11.9572904 C18.7577895,11.248188 18.5605296,10.7780048 19.3986025,10.5867097 C19.6743906,10.5241971 19.8757366,10.4991169 20.0570279,10.644009 C20.0609261,10.644009 20.0648713,10.644009 20.0683469,10.6432106 C20.116018,10.6395941 20.1632665,10.6356959 20.2113133,10.6323613 C20.1875013,10.5022167 20.1620923,10.3739977 20.1367303,10.2531525 C19.7535294,10.2029452 19.4003872,10.2136066 19.0074172,10.2729725 C19.0923799,10.2360567 19.1749942,10.2019589 19.2550724,10.1729805 C19.3800506,10.1270941 19.5015533,10.0908358 19.6223985,10.0701705 C19.6343281,10.0462644 19.6413261,10.0198692 19.6447077,9.99145437 C19.6572008,9.85905538 19.5591814,9.74079336 19.4269233,9.72768967 C19.2941017,9.71510261 19.1812408,9.81274627 19.168325,9.94556795 C19.1636283,9.99770093 19.1819923,10.0600257 19.2112995,10.111689 C19.2048181,10.1000413 19.1985715,10.0885344 19.1928885,10.0762292 L19.1923249,10.0754307 C19.1417418,9.97788101 19.1186812,9.86534892 19.1290139,9.74868376 C19.1381724,9.66062129 19.1656948,9.57941596 19.20773,9.50746305 C19.1948611,9.51056285 19.1819453,9.51469591 19.1690764,9.51925168 C19.0759416,9.55663713 18.8772726,9.54466064 18.7874254,9.51389748 C18.9635973,9.48468423 19.2260939,9.39103273 19.3956436,9.30841839 C19.4003402,9.30644579 19.404802,9.30452016 19.4085124,9.30217183 C19.5143752,9.23693515 19.6412791,9.20480996 19.7737251,9.21711523 C19.8409344,9.22383146 19.9041515,9.24120912 19.9620144,9.26877854 C20.0409183,9.29202703 20.1292156,9.32340075 20.2354072,9.36158464 C20.0740768,9.02445803 19.8918932,8.71969145 19.6725589,8.41393856 C19.4651542,8.1253285 19.2909079,8.02566527 18.9842627,7.84451491 C18.9174761,7.80487506 18.8522394,7.76528217 18.7878012,7.72371669 C18.5612341,7.68219817 18.3085065,7.64138415 18.0904873,7.68290267 C18.2701817,7.61221786 18.4053518,7.58370911 18.562784,7.57069934 C18.1288121,7.25954529 17.754394,6.91034826 17.3260582,6.55011406 C15.6731609,5.16027698 14.3356447,5.25900088 12.2307873,6.17287794 C11.3766049,6.54475986 11.070852,6.91866136 10.5453421,7.5914586 C10.5499449,7.5914586 10.5554869,7.59098894 10.5617805,7.59098894 C11.096214,7.57750951 11.6275946,7.55914555 12.1770105,7.50748223 C11.608761,7.63978729 11.0654038,7.74555618 10.507487,7.83004918 C9.89184819,7.92398248 9.70280743,7.90834258 9.23844817,8.36025568 C8.38276279,9.19269257 7.66600476,10.1335754 6.88278892,10.977801 C6.42956076,11.4670525 6.20416781,11.9573844 5.93805478,12.5147376 C5.67410221,13.0692258 5.71064226,13.2792607 6.06481776,13.7584614 C6.42664883,14.2489811 6.64537251,14.4708516 6.79876559,14.9063733 C7.19887447,14.2888088 7.68089319,13.7767784 8.1891193,13.1629243 C7.77416895,13.8279721 7.39575866,14.4563858 7.05280819,15.1325647 C6.8391569,15.5532919 6.73423341,15.7676947 6.74109054,16.2329933 C7.14213876,16.6950981 7.39364516,16.9415791 7.76599676,17.0439194 C8.16709194,17.1541032 8.54507953,17.1357392 8.90761509,16.9478257 C9.80956262,16.4810711 10.6668918,15.8720546 11.667939,15.7953111 C12.184713,14.8742481 12.0395391,13.7160036 11.8540678,12.6683655 C11.7004399,11.7977447 11.7394222,11.0299809 11.946827,10.15673 C11.9987721,11.0048538 12.0666389,11.7923905 12.2348734,12.6238881 C12.4799924,13.8419681 12.5315617,14.8935044 12.0192965,16.1521167 C10.9129501,16.1786528 10.0049439,16.8268865 9.02371665,17.3286782 C8.58251195,17.5544939 8.169816,17.5771318 7.67614956,17.4597152 C7.17285495,17.3399972 6.78697696,16.9517239 6.26912269,16.3846955 C6.31989363,15.955984 6.37583091,15.6895891 6.52847252,15.3747717 C6.34379966,14.8184987 6.11479028,14.5626714 5.69147987,13.9937174 C5.20053749,13.3341647 5.19208349,13.0484196 5.56344878,12.297329 C5.83111172,11.7527976 6.08200756,11.2504424 6.50536493,10.7536761 C6.92214697,10.2615126 7.3054418,9.80339991 7.69286968,9.3703674 C6.08271206,9.61478184 5.05489391,10.0030551 3.95516982,10.9676092 C3.13982879,11.6834279 2.63127392,12.5722248 2.26845656,13.5985869 C2.03855481,14.246257 1.97411657,14.8987647 2.08251559,15.9575339 C2.22186564,17.3221968 2.94656103,18.8618575 3.72695887,19.984877 C3.63175748,20.6841165 3.50832912,21.2108945 3.3131827,21.7106666 C3.09196978,22.2774601 3.97226568,22.4509079 4.39754869,22.5672913 C4.74289446,22.662023 6.0544851,23.0219754 6.18416002,22.5571465 C6.26142016,22.2785873 6.26142016,22.0840984 6.2420699,21.790322 C6.47586987,21.324131 6.54688345,21.2618063 6.71375595,20.9860651 C6.89227618,20.6909267 6.90721158,20.5731343 6.90866755,20.2264735 C6.90937204,19.779398 6.89781825,18.9809649 6.91665188,18.6923079 C6.97719189,18.9504836 7.04919176,19.3098724 7.1088394,19.6547954 C8.04108042,19.821574 8.96627644,19.8094566 9.89790689,19.6192417 C9.90974248,19.5541929 9.93130018,19.4832732 9.95544103,19.3961971 C10.0177188,19.1781779 10.142838,18.9602526 10.2058202,18.7418577 C10.1882077,18.956918 10.1718164,19.1713677 10.1543448,19.3858174 C10.1369671,19.6071243 10.1362626,19.7856445 10.1635033,20.0063408 C10.1785326,20.1277966 10.1939846,20.2489235 10.2084504,20.3701914 C10.1410532,20.2590683 10.0360828,20.1524071 9.97474433,20.0406734 C9.55979398,20.3136906 9.33158303,20.4682578 8.92414735,20.6832711 C8.49374498,20.9110124 8.98741143,21.7258368 9.16513323,22.0090927 C9.55584878,22.6291933 10.0224624,23.3643153 10.7482381,22.980363 C10.986312,22.8547741 11.1256621,22.563393 11.2845502,22.353593 C11.497544,22.228239 12.62836,21.27491 12.8080544,21.1709728 C13.0615804,21.0254701 13.9750817,19.5287839 14.0908545,19.15554 C14.3463061,18.3289739 14.646329,17.6999026 14.7311038,16.8375949 C14.1494689,16.5930396 13.8666827,16.3213845 13.4498537,15.8313345 C14.0358096,16.265682 14.5416404,16.4978852 15.1732948,16.6979161 C15.4035254,16.900812 15.6358224,17.1059624 15.8773719,17.3209757 C16.2275552,17.6328812 16.5490889,17.9508454 17.0568453,17.9600039 C17.6060733,17.9693972 18.2271603,17.5494684 18.3869408,17.0287492 C18.4482793,16.8285773 18.5101344,16.6277949 18.5712849,16.4273882 C18.462698,16.4011808 18.3560837,16.3719206 18.2533207,16.3404529 C18.1394266,16.6142685 18.1484442,16.7203662 18.0947143,16.9215243 C18.0021431,17.265649 17.5284844,17.5045213 17.0322348,17.3847564 C16.8558281,17.3422046 16.7521257,17.3175941 16.6892374,17.2722713 C16.7388811,17.407817 16.8361021,17.523261 17.0165949,17.5562316 C17.2166259,17.5933353 17.364242,17.6093979 17.6548717,17.5433628 C17.2955298,17.7297264 17.179898,17.7377108 16.9251978,17.6808811 C16.2550777,17.5320438 16.4910381,16.7250159 16.6371044,16.2314903 C16.7288772,15.920759 16.6978323,15.5910531 16.6282747,15.2797112 C16.8821764,15.4402432 17.0833345,15.5816598 17.3722264,15.6793504 C18.7255234,16.1352087 20.3314071,16.5998498 21.6935338,15.8388961 C22.7618842,15.2426075 23.3476522,13.9201206 23.4792528,12.7087098 C23.5965285,11.6287587 23.3941962,9.94411199 22.9516294,8.87327239 L22.9516294,8.87327239 Z M16.0434459,15.3758049 C16.0168628,15.5439925 15.9807455,15.7515851 15.9541623,15.9197727 C16.0256456,15.7299335 16.1106083,15.5101765 16.1932696,15.3289322 C16.2809563,15.1373553 16.3299425,15.1199776 16.5149441,15.0187645 C16.6470144,14.9469055 16.8860276,14.8484634 17.0174873,14.7773559 C16.8821294,14.7999938 16.6393588,14.8494027 16.5045645,14.8722755 C16.1430152,14.9334261 16.1000408,15.0199386 16.0434459,15.3758049 L16.0434459,15.3758049 Z M9.86540597,8.90807468 C9.44618166,9.32340075 9.03874598,10.7473356 8.90855443,11.3167593 C9.11314115,10.8429127 9.62709719,9.52000315 10.0206777,9.18315834 C10.1293585,9.08988257 10.2059142,9.03267719 10.2868847,8.99106474 C10.0050848,9.46448857 10.0255622,9.58176429 10.1245679,10.2151096 C10.2085443,9.57124376 10.4319647,9.32194479 10.7968955,8.84218047 C11.1974741,8.74092037 11.5732542,8.62115542 11.9837897,8.46081128 C11.5201349,8.51346089 11.0579362,8.56099114 10.593436,8.60476406 C10.2045052,8.64144501 10.1417108,8.63590294 9.86540597,8.90807468 L9.86540597,8.90807468 Z M16.8285874,10.4872343 C16.7385524,10.2980996 16.5803687,10.1626478 16.3973396,10.0959082 C16.5639304,10.006061 16.7266228,9.9133958 16.8543251,9.79766997 C16.4808933,9.97064814 16.0465457,9.92814333 15.7269847,10.1449414 C15.4437758,10.3347806 15.0545632,10.9391004 14.7680196,11.194552 C14.9754243,11.1140982 15.1754083,10.9747012 15.3594237,10.828447 C15.3607857,10.9371278 15.3852084,11.048157 15.4340537,11.1529866 C15.4852004,11.2597887 15.5594077,11.3477103 15.6457793,11.4172209 C15.6211688,11.3926104 15.5998459,11.3645713 15.5840652,11.3319765 C15.5075095,11.1718202 15.575846,10.979163 15.7360023,10.9033588 C15.8965343,10.8260517 16.0900838,10.8945761 16.1666395,11.0545445 C16.1734966,11.0699965 16.1801189,11.0854016 16.1844398,11.1008536 C16.0309059,11.2154052 15.8902877,11.3492132 15.7726832,11.5041562 C15.6699672,11.6393732 15.5840182,11.7920148 15.5227267,11.9610947 C16.0684322,11.3139413 16.8600551,10.8243609 17.6043356,10.6159699 C17.3961324,10.6135276 17.1496514,10.6526039 16.8988495,10.7342319 C16.8898789,10.6514297 16.8670531,10.5676412 16.8285874,10.4872343 L16.8285874,10.4872343 Z M14.1629483,9.9039555 C14.2885371,9.34810521 14.5118166,8.81235664 15.3754393,8.39750023 C14.230909,8.68413769 14.0160836,9.16479438 14.1629483,9.9039555 L14.1629483,9.9039555 Z"
                }
            }
        ]
    })(props);
}
function GrHalt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M8,23 C10,23 12.9996892,23 15,23 C18,23 19,21 19,18 L19,6 C19,4.00000008 18,3.99999992 17.5,4 C17,4.00000008 15.9998779,4.00000008 15.9998779,5.99999984 C15.9998779,7.9999996 15.9998782,13 15.9998782,13 C15.9998782,13 15.9998784,5.00000004 15.9998782,4 C15.9998779,2.99999996 15.9998779,2 14.5,2 C13.0001221,2 12.9996891,2.99999994 12.9996891,4.00000006 C12.9996891,5.00000017 12.9996892,13 12.9996892,13 C12.9996892,13 12.9996891,4.00000006 12.9996891,3.00000006 C12.9996891,2.00000006 13,1.00000001 11.5,0.999999996 C10,0.999999981 10,2.00000006 10,3 L10,13 L10,4 C10,3 10.029402,2 8.5,2 C7,2 7,3 7,4 L7,18 L7,14 C7,13 6.44999986,12 5.00000005,12 C5,12 4,12 4,12 C4,12 4.00000001,14.0384045 4,18 C3.99999999,21.9615955 6,23.023861 8,23 Z"
                }
            }
        ]
    })(props);
}
function GrHelpBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M11.937 12.136v-.864c0-.864 0-1.296.797-1.728.798-.432 1.595-.864 1.595-2.16 0-.865-.797-2.16-2.392-2.16-1.594 0-2.391 1.092-2.391 2.592",
                    "strokeWidth": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.938 13v1.728",
                    "strokeWidth": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M5.5 18a2.5 2.5 0 1 0 0 5H22M3 20.5v-17A2.5 2.5 0 0 1 5.5 1H21v17.007H5.492M20.5 18a2.5 2.5 0 1 0 0 5"
                }
            }
        ]
    })(props);
}
function GrHelpOption(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 7C2 4.23858 4.23858 2 7 2H17C19.7614 2 22 4.23858 22 7V17C22 19.7614 19.7614 22 17 22H7C4.23858 22 2 19.7614 2 17V7ZM7 4C5.34315 4 4 5.34315 4 7V17C4 18.6569 5.34315 20 7 20H17C18.6569 20 20 18.6569 20 17V7C20 5.34315 18.6569 4 17 4H7ZM12 7.5C10.5523 7.5 10 8.55229 10 9C10 9.55229 9.55228 10 9 10C8.44772 10 8 9.55229 8 9C8 7.44772 9.44771 5.5 12 5.5C13.1557 5.5 14.1702 5.78891 14.9085 6.43492C15.6643 7.09623 16 8.01748 16 9C16 10.1875 15.6945 11.0279 15.1178 11.6677C14.8502 11.9645 14.5539 12.1844 14.2896 12.3608C14.1648 12.4442 14.0375 12.524 13.9223 12.5962L13.9043 12.6075C13.7803 12.6853 13.6678 12.7561 13.5575 12.8302C13.2061 13.0662 13.0643 13.2421 13.0061 13.3563C12.9615 13.4436 12.9296 13.5614 12.9786 13.7942C13.0922 14.3347 12.7462 14.865 12.2058 14.9786C11.6653 15.0922 11.135 14.7462 11.0214 14.2058C10.8952 13.6054 10.938 13.0088 11.2247 12.4472C11.4975 11.9124 11.9434 11.505 12.4425 11.1698C12.5822 11.076 12.7197 10.9896 12.8418 10.9131L12.851 10.9073C12.9733 10.8306 13.0787 10.7646 13.1791 10.6975C13.3836 10.561 13.5248 10.4478 13.6322 10.3286C13.8055 10.1363 14 9.81253 14 9C14 8.48252 13.8357 8.15377 13.5915 7.94008C13.3298 7.71109 12.8443 7.5 12 7.5ZM12 15.7812C11.4477 15.7812 11 16.229 11 16.7812C11 17.3335 11.4477 17.7812 12 17.7812C12.5523 17.7812 13 17.3335 13 16.7812C13 16.229 12.5523 15.7812 12 15.7812Z"
                }
            }
        ]
    })(props);
}
function GrHelp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,23 C12.5522847,23 13,22.5522847 13,22 C13,21.4477153 12.5522847,21 12,21 C11.4477153,21 11,21.4477153 11,22 C11,22.5522847 11.4477153,23 12,23 Z M12,18 L12,15 C12,13 13,13 15,12 C17,11 18,9.15767339 18,7 C18,3.6862915 15.3137085,1 12,1 C8.6862915,1 6,3.6862915 6,7"
                }
            }
        ]
    })(props);
}
function GrHeroku(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M20.4425631,0 L3.16168659,0 C1.96912351,0 1,0.966467463 1,2.16168659 L1,21.8403054 C1,23.0335325 1.96912351,24 3.16168659,24 L20.4425631,24 C21.6354582,24 22.6015936,23.0335325 22.6015936,21.8403054 L22.6015936,2.16168659 C22.6015936,0.966467463 21.6354582,0 20.4425631,0 L20.4425631,0 Z M21.4013944,21.8403054 C21.4013944,22.3701859 20.9721116,22.7991368 20.4425631,22.7991368 L3.16168659,22.7991368 C2.63247012,22.7991368 2.2001992,22.3701859 2.2001992,21.8403054 L2.2001992,2.16168659 C2.2001992,1.62981408 2.63247012,1.2001992 3.16168659,1.2001992 L20.4425631,1.2001992 C20.9721116,1.2001992 21.4013944,1.62981408 21.4013944,2.16168659 L21.4013944,21.8403054 Z M6.40036521,20.4013612 L9.10222444,18.0002988 L6.40036521,15.5999004 L6.40036521,20.4013612 L6.40036521,20.4013612 Z M16.1577357,10.6722776 C15.672012,10.1838977 14.7852258,9.60056441 13.302158,9.60056441 C11.675,9.60056441 9.99903718,10.0245352 8.80116202,10.4126494 L8.80116202,3.60122842 L6.40043161,3.60122842 L6.40043161,14.0085989 L8.09697875,13.2400066 C8.1251992,13.2273904 10.860259,12.0012948 13.302158,12.0012948 C14.5202855,12.0012948 14.7902058,12.6719456 14.8031541,13.2323705 L14.8031541,20.4013612 L17.2012284,20.4013612 L17.2012284,13.201494 C17.2038845,13.0474436 17.1886122,11.7157703 16.1577357,10.6722776 M13.0012948,7.50039841 L15.4020252,7.50039841 C16.4866866,6.27164675 17.0394754,4.96354582 17.201494,3.60099602 L14.8030876,3.60099602 C14.5358234,4.96088977 13.9445219,6.26135458 13.0012948,7.50039841"
                }
            }
        ]
    })(props);
}
function GrHide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,17 C9.27272727,17 6,14.2222222 6,12 C6,9.77777778 9.27272727,7 12,7 C14.7272727,7 18,9.77777778 18,12 C18,14.2222222 14.7272727,17 12,17 Z M11,12 C11,12.55225 11.44775,13 12,13 C12.55225,13 13,12.55225 13,12 C13,11.44775 12.55225,11 12,11 C11.44775,11 11,11.44775 11,12 Z M20,5 L4,19"
                }
            }
        ]
    })(props);
}
function GrHistory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,12 C1,18.075 5.925,23 12,23 C18.075,23 23,18.075 23,12 C23,5.925 18.075,1 12,1 C7.563,1 4,4 2,7.5 M1,1 L1,8 L8,8 M16,17 L12,13 L12,6"
                }
            }
        ]
    })(props);
}
function GrHomeOption(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "4",
                    "strokeWidth": "2"
                }
            }
        ]
    })(props);
}
function GrHomeRounded(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeWidth": "2",
                    "d": "M1 22V9.76a2 2 0 01.851-1.636l9.575-6.72a1 1 0 011.149 0l9.574 6.72A2 2 0 0123 9.76V22a1 1 0 01-1 1h-5.333a1 1 0 01-1-1v-5.674a1 1 0 00-1-1H9.333a1 1 0 00-1 1V22a1 1 0 01-1 1H2a1 1 0 01-1-1z"
                }
            }
        ]
    })(props);
}
function GrHome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,11 L12,2 L23,11 M15,23 L15,15 L15,15 L9,15 L9,23 M4,23 L4,9 M20,23 L20,9"
                }
            }
        ]
    })(props);
}
function GrHorton(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M2.30070636,12.9767911 L2.14328961,12.9767911 C1.82441978,13.9656912 1.38849647,14.9344097 1.21089808,15.9475277 C0.988900101,17.2391524 0.972754793,18.5711403 0.87184662,19.8829465 C0.843592331,20.221998 0.996972755,20.3995964 1.33602422,20.4036327 C2.8617558,20.4238143 2.68819374,20.4843592 2.93844601,19.2048436 C2.95459132,19.1160444 2.9667003,19.0272452 2.99495459,18.938446 C3.51564077,17.2795156 3.53985873,15.6528759 2.72452069,14.0625631 C2.5469223,13.7194753 2.4419778,13.3400605 2.30070636,12.9767911 L2.30070636,12.9767911 Z M18.9061554,7.0554995 C18.9061554,6.77699294 18.6801211,6.55499495 18.4056509,6.55499495 C18.1271443,6.55499495 17.9051463,6.77699294 17.9051463,7.0554995 C17.9051463,7.32996973 18.1271443,7.55600404 18.4056509,7.55600404 C18.6801211,7.55600404 18.9061554,7.32996973 18.9061554,7.0554995 L18.9061554,7.0554995 Z M21.0817356,9.79212916 C21.2875883,10.2320888 21.235116,10.8133199 21.2310797,11.3299697 C21.2270434,12.2542886 21.1745711,13.1786075 21.1342079,14.1029263 C21.0978809,15.0191726 21.0575177,15.9354188 21.0090817,17.025227 C20.431887,16.6700303 19.9717457,16.419778 19.5519677,16.1170535 C19.4106963,16.0161453 19.3097881,15.7820383 19.2976791,15.6004036 C19.2008073,14.5025227 19.1039354,13.4006054 19.0716448,12.2986882 C19.0554995,11.60444 18.8698285,11.0918264 18.1473259,10.8940464 C17.7638749,10.7931382 17.5660949,10.5267407 17.4207871,10.1594349 C16.8072654,8.63370333 16.1695257,7.11200807 15.4914228,5.47325933 C16.653885,5.68718466 17.7275479,5.86074672 18.7891019,6.09081736 C18.9788093,6.13118063 19.1644803,6.36932392 19.2774975,6.56306761 C19.8990918,7.62865792 20.5529768,8.67810293 21.0817356,9.79212916 L21.0817356,9.79212916 Z M21.6508577,17.0171544 C21.6508577,17.0332997 21.667003,17.0454087 21.691221,17.0978809 C22.4621594,17.1543895 23.3057518,17.4490414 23.8627649,16.3794147 C23.4994955,16.2744702 23.1765893,16.1775984 22.8536831,16.0928355 C21.6508577,15.778002 21.6508577,15.778002 21.6508577,17.0171544 L21.6508577,17.0171544 Z M15.3501514,13.8123108 C15.2532795,13.4651867 15.0797175,13.3158426 14.7204844,13.2633703 C14.284561,13.1947528 13.7880928,13.1463169 13.4490414,12.9041372 C11.9515641,11.8183653 10.506559,10.6599395 9.02522704,9.54994955 C8.62563068,9.24722503 8.52875883,8.93239152 8.69424823,8.46821393 C8.94046418,7.77396569 9.15035318,7.06760848 9.41271443,6.26034309 C9.18668012,6.28456105 9.08173562,6.28859738 8.98082745,6.30877901 C7.67305752,6.59939455 6.37739657,6.95459132 5.05348133,7.16851665 C4.19374369,7.30978809 3.67305752,7.7457114 3.15237134,8.419778 C1.88900101,10.0544904 0.920282543,11.790111 0.565085772,13.8486377 C0.43592331,14.6034309 0.193743693,15.3380424 0,16.0807265 C0.0605449041,16.1210898 0.125126135,16.1614531 0.185671039,16.2018163 C0.310797175,16.0565086 0.48839556,15.9313824 0.552976791,15.765893 C0.956609485,14.6760848 1.33198789,13.5782038 1.72754793,12.4883956 C1.93340061,11.9233098 2.11503532,11.8789102 2.49041372,12.3592331 C2.73259334,12.6659939 2.95459132,13.0171544 3.08375378,13.3804238 C3.77396569,15.3299697 4.43592331,17.2875883 5.10998991,19.2411705 C5.51765893,20.431887 5.52169526,20.4117053 6.79313824,20.4157417 C7.27346115,20.4157417 7.44702321,20.2462159 7.40665994,19.778002 C7.32189707,18.764884 7.26942482,17.7517659 7.1765893,16.7426842 C7.13218971,16.2260343 7.36226034,15.987891 7.83854692,15.8587286 C9.01311806,15.5438951 10.1796165,15.2048436 11.346115,14.8698285 C12.0807265,14.6639758 12.1533804,14.6881937 12.5166498,15.3420787 C13.2795156,16.7023209 14.0787084,18.0464178 14.7769929,19.4429869 C15.1564077,20.209889 15.6609485,20.5045409 16.4924319,20.4157417 C17.1019173,20.3511604 17.1503532,20.3430878 16.9848638,19.7336024 C16.4399596,17.7598385 15.8829465,15.7860747 15.3501514,13.8123108 L15.3501514,13.8123108 Z M15.2330979,6.27245207 C14.8536831,5.23107972 14.3047427,4.66195762 13.1786075,4.55297679 C12.4601413,4.48435923 11.7618567,4.19374369 11.0514632,4 L10.8335015,4 C10.7366297,4.21392533 10.6195762,4.419778 10.5469223,4.63773966 C10.1392533,5.86074672 9.75983855,7.09182644 9.34006054,8.30676085 C9.18264379,8.75882947 9.28355197,9.04944501 9.66700303,9.32795156 C10.728557,10.1150353 11.7941473,10.9061554 12.815338,11.7497477 C14.4500505,12.7386478 15.0554995,12.7386478 15.790111,12.7346115 C16.5247225,12.7305752 17.1099899,12.7346115 17.8486377,12.7346115 C17.7558022,12.4722503 17.6992936,12.2865792 17.6266398,12.1089808 C16.8193744,10.1675076 15.9475277,8.25025227 15.2330979,6.27245207 L15.2330979,6.27245207 Z M11.4470232,15.4510595 C11.160444,15.4873865 10.7891019,15.5035318 10.764884,15.987891 C10.7124117,17.0696266 10.6155399,18.1513623 10.530777,19.3420787 C10.5509586,19.592331 10.4581231,20.1210898 10.6437941,20.2542886 C10.9182644,20.443996 11.4026236,20.407669 11.7820383,20.3551968 C11.9354188,20.3350151 12.1210898,20.0484359 12.1735621,19.8466196 C12.3148335,19.3259334 12.3269425,18.764884 12.5005045,18.2563068 C12.8193744,17.3118063 12.6215943,16.4803229 12.0484359,15.7255298 C11.9273461,15.5640767 11.6367306,15.4268416 11.4470232,15.4510595 L11.4470232,15.4510595 Z M24,15.7255298 C23.9071645,15.160444 23.8546922,14.6437941 23.7255298,14.1473259 C23.6932392,14.0221998 23.4349142,13.9091826 23.2653885,13.889001 C23.1564077,13.8728557 22.9465187,14.0020182 22.9061554,14.110999 C22.6195762,14.8617558 23.0958628,15.6165489 24,15.7255298 L24,15.7255298 Z"
                }
            }
        ]
    })(props);
}
function GrHostMaintenance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M14,23 L20,17 M21,14 C19.8954305,14 19,14.8954305 19,16 C19,17.1045695 19.8954305,18 21,18 C22.1045695,18 23,17.1045695 23,16 M17,4 L18,4 L18,5 L17,5 L17,4 Z M10,23 L3,23 L3,1 L3,1 L21,1 L21,11 M3,13 L17,13 M3,18 L13,18 M3,8 L21,8"
                }
            }
        ]
    })(props);
}
function GrHost(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M17,4 L18,4 L18,5 L17,5 L17,4 Z M3,1 L21,1 L21,23 L3,23 L3,1 Z M3,13 L21,13 L3,13 Z M3,18 L21,18 L3,18 Z M3,8 L21,8 L3,8 Z"
                }
            }
        ]
    })(props);
}
function GrHp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.4210347,0.00016035599 L5,15.127022 L7.13818677,15.127022 L10.5590611,0.00016035599 L8.4210347,0.00016035599 Z M17.4142797,8.87313837 L15.9176772,15.0979976 L18.0557037,15.0979976 L19.5523061,8.87313837 L17.4142797,8.87313837 Z M13.7794905,8.87313837 L10.3586161,24 L12.4966425,24 L15.9176772,8.87313837 L13.7794905,8.87313837 Z M10.131552,8.87313837 L8.63478923,15.0979976 L10.7728157,15.0979976 L12.2694181,8.87313837 L10.131552,8.87313837 Z"
                }
            }
        ]
    })(props);
}
function GrHpeLabs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "points": "14 23 5 23 5 2 17 2 17 15 13 15 13 6 9 6 9 19 20 19"
                }
            }
        ]
    })(props);
}
function GrHpe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 48 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 6H46V18H2V6ZM5 9H43V15H5V9Z"
                }
            }
        ]
    })(props);
}
function GrHpi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.7928421,15.3333704 C15.9768442,15.3333704 16.1755131,15.1915021 16.2349804,15.0183002 L18.4310048,8.64836276 C18.4908721,8.47529417 18.3902043,8.33315926 18.2063356,8.33315926 L17.2052578,8.33315926 C17.0219225,8.33315926 16.8228536,8.47529417 16.7629863,8.64836276 L14.5570951,15.0183002 C14.4973611,15.1915021 14.5981622,15.3333704 14.7821642,15.3333704 L15.7928421,15.3333704 Z M24.0002667,12 C24.0002667,18.627007 18.6267403,24 12,24 C11.8170646,24 11.6393293,23.9803998 11.4581273,23.9727997 L13.8777542,16.981922 C13.9382882,16.8085868 14.1365571,16.6668519 14.3205591,16.6668519 L16.0003111,16.6668519 C18.6083401,16.6668519 18.632207,15.8021756 18.9066101,15.0079001 C19.5488839,13.1445461 20.6560962,9.93424371 20.8714319,9.30583673 C21.1779686,8.40956011 21.2793031,7.00007778 19.0002111,7.00007778 L15.0000333,7.00007778 C14.816698,7.00007778 14.6177624,7.14194602 14.5570951,7.31528128 L8.92489917,23.5871954 C3.79030878,22.2271803 0,17.5617951 0,12 C0,6.69394104 3.44790498,2.20055778 8.22275803,0.615473505 L2.77589751,16.3513817 C2.71523017,16.5248503 2.81643129,16.6668519 3.00003333,16.6668519 L4.99965555,16.6668519 C5.1836576,16.6668519 5.38232647,16.5248503 5.44272714,16.3513817 L8.1092901,8.64836276 C8.16915744,8.47529417 8.36755964,8.33315926 8.55102834,8.33315926 L9.539706,8.33315926 C9.72330804,8.33315926 9.82410916,8.47529417 9.76424182,8.64836276 L7.10847898,16.3513817 C7.04914499,16.5248503 7.14994611,16.6668519 7.33328148,16.6668519 L9.33357037,16.6668519 C9.51690574,16.6668519 9.71570795,16.5248503 9.77544195,16.3513817 C9.77544195,16.3513817 11.6389293,10.9485217 12.2016022,9.3149035 C12.7649418,7.68155202 12.3125368,7.00007778 10.3462483,7.00007778 L9.01290014,7.00007778 C8.82956477,7.00007778 8.72889699,6.8580762 8.78916432,6.68514095 L11.0862565,0.0464005156 C11.3887932,0.0234669274 11.6913299,0 12,0 C18.6267403,0 24.0002667,5.37299303 24.0002667,12 L24.0002667,12 Z"
                }
            }
        ]
    })(props);
}
function GrHtml5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M3,2 L21,2 L21,18 L12,22 L3,18 L3,2 Z M17,6 L8,6 L8,11 L16,11 L16,16 L12,17.5 L8,16 L8,14"
                }
            }
        ]
    })(props);
}
function GrIceCream(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M17,8 C19,8 19,6.5 17.5,6.5 C17.5,3.5 15.5,1 12,1 C8.5,1 6.5,3.5 6.5,6.5 C5,6.5 5,8 7,8 M7,8 L17,8 L12,21 L7,8 Z"
                }
            }
        ]
    })(props);
}
function GrImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,3 L23,3 L23,21 L1,21 L1,3 Z M6,9 C6.55228475,9 7,8.55228475 7,8 C7,7.44771525 6.55228475,7 6,7 C5.44771525,7 5,7.44771525 5,8 C5,8.55228475 5.44771525,9 6,9 Z M23,15 L18,9 L12,16 L9,13 L1,21"
                }
            }
        ]
    })(props);
}
function GrImpact(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M13,2 L22,6 L22,17 L13,22 L13,2 Z M22,6 L13,11 L22,6 Z M9,22 L9,2 L9,22 Z M9,12 L3,5 L9,12 Z M9,12 L1,12 L9,12 Z M9,12 L3,19 L9,12 Z"
                }
            }
        ]
    })(props);
}
function GrInProgress(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,1 L23,1 M10,4.5 L14,4.5 C14,4.5 14,6 14,6 C14,7 12,8 12,8 C12,8 10,7 10,6 C10,6 10,4.5 10,4.5 Z M5,1 C5,1 5,3 5,6 C5,9 10,9.23530084 10,12 C10,14.7646992 5.00000001,15 5,18 C4.99999999,21 5,23 5,23 M19,1 C19,1 19,3 19,6 C19,9 14,9.23530084 14,12 C14,14.7646992 19,15 19,18 C19,21 19,23 19,23 M1,23 L23,23 M8,21 C8,19 12,17 12,17 C12,17 16,19 16,21 C16,21 16,23 16,23 L8,23 L8,21 Z"
                }
            }
        ]
    })(props);
}
function GrInbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,13 L6,2 L18,2 L23,13 L23,22 L1,22 L1,13 Z M1,13 L8,13 L8,16 L16,16 L16,13 L23,13"
                }
            }
        ]
    })(props);
}
function GrIndicator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,11 C13.6568542,11 15,9.65685425 15,8 C15,6.34314575 13.6568542,5 12,5 C10.3431458,5 9,6.34314575 9,8 C9,9.65685425 10.3431458,11 12,11 Z M19,8 C19,4.13400675 15.8659932,1 12,1 C8.13400675,1 5,4.13400675 5,8 C5,9.93299662 5.5,11 7,13 C8.5,15 10,16.5 10,19 L10,23 L14,23 L14,19 C14,16.5 15.5,15 17,13 C18.5,11 19,9.93299662 19,8 Z"
                }
            }
        ]
    })(props);
}
function GrInfo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M15,17.0002864 C15,14.0000003 19,12.0005727 19,8.00028636 C19,4.00000002 16,1.00028636 12,1.00028636 C8,1.00028636 5,4.00000002 5,8.00028636 C5,12.0005727 9,14.0000003 9,17.0002864 C9,20.0005725 9,20 9,20 C9,22.0000003 10,22.9999997 12,23 C14,23.0000003 15,22.0000003 15,20 C15,20 15,20.0005725 15,17.0002864 Z M9,18 L15,18"
                }
            }
        ]
    })(props);
}
function GrInherit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M17,18 L12,15 L17,18 Z M7,18 L12,15 L12,11 M17,20 C17,21.657 18.343,23 20,23 C21.657,23 23,21.657 23,20 C23,18.343 21.657,17 20,17 C18.343,17 17,18.343 17,20 L17,20 L17,20 Z M4,17 C2.343,17 1,18.343 1,20 C1,21.657 2.343,23 4,23 C5.657,23 7,21.657 7,20 C7,18.343 5.657,17 4,17 L4,17 L4,17 Z M17,6 C17,8.761 14.761,11 12,11 C9.239,11 7,8.761 7,6 C7,3.239 9.239,1 12,1 C14.761,1 17,3.239 17,6 L17,6 L17,6 Z"
                }
            }
        ]
    })(props);
}
function GrInsecure(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M7 6.919V6a4.724 4.724 0 015-5 4.724 4.724 0 015 5v5.052M12 23a7 7 0 10-7-7 7 7 0 007 7zm2.985-7h-5.97"
                }
            }
        ]
    })(props);
}
function GrInspect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M5.5,21 C7.98528137,21 10,18.9852814 10,16.5 C10,14.0147186 7.98528137,12 5.5,12 C3.01471863,12 1,14.0147186 1,16.5 C1,18.9852814 3.01471863,21 5.5,21 Z M1,16 L1,7 L1,6.5 C1,4.01471863 3.01471863,2 5.5,2 L6,2 M23,16 L23,7 L23,6.5 C23,4.01471863 20.9852814,2 18.5,2 L18,2 M18.5,21 C20.9852814,21 23,18.9852814 23,16.5 C23,14.0147186 20.9852814,12 18.5,12 C16.0147186,12 14,14.0147186 14,16.5 C14,18.9852814 16.0147186,21 18.5,21 Z M10,17 C10,17 10,15 12,15 C14,15 14,17 14,17"
                }
            }
        ]
    })(props);
}
function GrInstagram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.3183118,0.0772036939 C18.5358869,0.132773211 19.3775594,0.311686093 20.156489,0.614412318 C20.9357539,0.917263935 21.5259307,1.30117806 22.1124276,1.88767349 C22.6988355,2.47414659 23.0827129,3.06422396 23.3856819,3.84361655 C23.688357,4.62263666 23.8672302,5.46418415 23.9227984,6.68172489 C23.9916356,8.19170553 24,8.72394829 24,11.9999742 C24,15.2760524 23.9916355,15.808302 23.9227954,17.3182896 C23.8672306,18.5358038 23.6883589,19.3773584 23.3855877,20.1566258 C23.0826716,20.9358162 22.6987642,21.5259396 22.1124276,22.1122749 C21.5259871,22.6987804 20.9357958,23.0827198 20.1563742,23.3856323 C19.3772192,23.6883583 18.5357324,23.8672318 17.3183209,23.9227442 C15.8086874,23.9916325 15.2765626,24 12,24 C8.72343739,24 8.19131258,23.9916325 6.68172382,23.9227463 C5.46426077,23.8672314 4.62270711,23.6883498 3.84342369,23.3855738 C3.0641689,23.0827004 2.47399369,22.6987612 1.88762592,22.1123283 C1.30117312,21.525877 0.91721975,20.9357071 0.614318116,20.1563835 C0.311643016,19.3773633 0.132769821,18.5358159 0.0772038909,17.3183251 C0.0083529426,15.8092887 0,15.2774634 0,11.9999742 C0,8.7225328 0.00835296697,8.19071076 0.0772047368,6.68165632 C0.132769821,5.46418415 0.311643016,4.62263666 0.614362729,3.84350174 C0.91719061,3.06430165 1.30113536,2.4741608 1.88757245,1.88772514 C2.47399369,1.30123879 3.0641689,0.917299613 3.84345255,0.614414972 C4.62236201,0.311696581 5.46409415,0.132773979 6.68163888,0.0772035898 C8.19074867,0.00835221992 8.72252573,0 12,0 C15.2774788,0 15.8092594,0.00835235053 17.3183118,0.0772036939 Z M12,2.66666667 C8.75959504,2.66666667 8.26400713,2.67445049 6.80319929,2.74109814 C5.87614637,2.78341009 5.31952221,2.90172878 4.80947575,3.09995521 C4.37397765,3.26922052 4.09725505,3.44924273 3.77324172,3.77329203 C3.44916209,4.09737087 3.26913181,4.37408574 3.09996253,4.80937168 C2.90169965,5.31965737 2.78340891,5.87618164 2.74109927,6.80321713 C2.67445122,8.26397158 2.66666667,8.75960374 2.66666667,11.9999742 C2.66666667,15.2403924 2.67445121,15.7360281 2.74109842,17.1967643 C2.78340891,18.1238184 2.90169965,18.6803426 3.09990404,19.1904778 C3.26914133,19.6259017 3.44919889,19.9026659 3.77329519,20.2267614 C4.09725505,20.5507573 4.37397765,20.7307795 4.80932525,20.8999863 C5.31971515,21.0982887 5.87621193,21.2165784 6.80323907,21.2588497 C8.26460439,21.3255353 8.76051223,21.3333333 12,21.3333333 C15.2394878,21.3333333 15.7353956,21.3255353 17.1968056,21.2588476 C18.123775,21.216579 18.6802056,21.0982995 19.1905083,20.9000309 C19.6260288,20.7307713 19.9027426,20.5507596 20.2267583,20.226708 C20.5507492,19.9027179 20.7308046,19.6259456 20.9000375,19.1906283 C21.0983009,18.6803412 21.2165908,18.1238118 21.2588986,17.196779 C21.3255376,15.7350718 21.3333333,15.2390126 21.3333333,11.9999742 C21.3333333,8.76098665 21.3255376,8.26493375 21.2589016,6.80323567 C21.2165911,5.87618164 21.0983004,5.31965737 20.9001178,4.80957831 C20.7308131,4.37403932 20.550774,4.09729207 20.2267583,3.77324038 C19.9027658,3.44924868 19.6260264,3.26922777 19.1905015,3.09996643 C18.6803988,2.90171817 18.1238378,2.78341062 17.1967608,2.74109868 C15.7359966,2.67445057 15.2404012,2.66666667 12,2.66666667 Z M12,18.2222222 C8.56356156,18.2222222 5.77777778,15.4364384 5.77777778,12 C5.77777778,8.56356156 8.56356156,5.77777778 12,5.77777778 C15.4364384,5.77777778 18.2222222,8.56356156 18.2222222,12 C18.2222222,15.4364384 15.4364384,18.2222222 12,18.2222222 Z M12,15.5555556 C13.9636791,15.5555556 15.5555556,13.9636791 15.5555556,12 C15.5555556,10.0363209 13.9636791,8.44444444 12,8.44444444 C10.0363209,8.44444444 8.44444444,10.0363209 8.44444444,12 C8.44444444,13.9636791 10.0363209,15.5555556 12,15.5555556 Z M18.2222222,7.11111111 C17.4858426,7.11111111 16.8888889,6.51415744 16.8888889,5.77777778 C16.8888889,5.04139811 17.4858426,4.44444444 18.2222222,4.44444444 C18.9586019,4.44444444 19.5555556,5.04139811 19.5555556,5.77777778 C19.5555556,6.51415744 18.9586019,7.11111111 18.2222222,7.11111111 Z"
                }
            }
        ]
    })(props);
}
function GrInstallOption(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,18 L12,8 L12,18 Z M12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 Z M17,12 L12,7 L7,12",
                    "transform": "matrix(1 0 0 -1 0 24)"
                }
            }
        ]
    })(props);
}
function GrInstall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M19,13.5 L19,17.5 L12,22 L5,17.5 L5,13.5 M12,22 L12,13.5 M18.5,8.5 L12,4.5 L15.5,2 L22,6 L18.5,8.5 L18.5,8.5 L18.5,8.5 Z M5.5,8.5 L12,4.5 L8.5,2 L2,6 L5.5,8.5 L5.5,8.5 L5.5,8.5 Z M18.5,9 L12,13 L15.5,15.5 L22,11.5 L18.5,9 L18.5,9 L18.5,9 Z M5.5,9 L12,13 L8.5,15.5 L2,11.5 L5.5,9 L5.5,9 Z"
                }
            }
        ]
    })(props);
}
function GrIntegration(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M5,21 L23,21 L23,9 L5,9 M19,15 L1,15 L1,3 L19,3"
                }
            }
        ]
    })(props);
}
function GrInternetExplorer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M23.9995527,12.3365818 C23.9995527,10.4393317 23.5090273,8.656914 22.6488466,7.1080745 C26.3153205,-1.18993486 18.7201703,0.0254770168 18.2972919,0.108218948 C16.688185,0.423085539 15.1995011,0.928594013 13.8263205,1.56939672 C13.6238264,1.55799176 13.4201024,1.5517302 13.2148129,1.5517302 C8.09006842,1.5517302 3.80034655,5.12618162 2.70245058,9.91794575 C5.40352737,6.88769025 7.29384506,5.6650105 8.42584412,5.17571497 C8.24515364,5.33717355 8.06826481,5.50042114 7.89428312,5.66489868 C7.83636377,5.71957545 7.78056888,5.7750349 7.72343222,5.83004711 C7.60871165,5.94040695 7.49421471,6.05087861 7.38240129,6.16235659 C7.3158723,6.22866195 7.25113233,6.29552637 7.18560967,6.36227899 C7.08643116,6.4632465 6.98747629,6.56410221 6.89064586,6.6656288 C6.82188061,6.73774845 6.75479256,6.81009173 6.68725725,6.8823232 C6.59680019,6.97915363 6.5069022,7.07609586 6.41868142,7.17337354 C6.35013979,7.24895941 6.2827163,7.32454528 6.21540462,7.40035478 C6.13176818,7.49450168 6.04891444,7.58864858 5.96717882,7.68301911 C5.89941989,7.7612885 5.83222003,7.8395579 5.76580285,7.9179391 C5.68831615,8.00940248 5.61183578,8.10086586 5.53613809,8.19232924 C5.46916185,8.27328215 5.40240924,8.35412326 5.33688657,8.43496436 C5.26599687,8.52240245 5.19667255,8.60972873 5.12746004,8.6969432 C5.06037199,8.78147415 4.99328393,8.86589328 4.92776127,8.95031241 C4.86536938,9.03070626 4.80476651,9.11076467 4.74371638,9.19093489 C4.67483931,9.28150376 4.60540318,9.37207263 4.53831513,9.46219425 C4.49034717,9.52671059 4.44428004,9.59055606 4.39720659,9.65484877 C3.97108565,10.2362786 3.58175132,10.806527 3.23009811,11.3543009 C3.2292036,11.3556427 3.22830909,11.3569845 3.2275264,11.3583262 C3.13494489,11.5025655 3.04560597,11.6446804 2.95805606,11.7855653 C2.95335989,11.7931686 2.9484401,11.8008838 2.94374394,11.8085989 C2.85608222,11.9500429 2.77143946,12.0890269 2.68892115,12.2265574 C2.68601401,12.2313654 2.68299504,12.2362852 2.68008789,12.2410932 C2.45825007,12.6113074 2.25251338,12.9682159 2.06723854,13.3039916 C1.09591536,15.0642702 0.623056401,16.294106 0.602594545,16.3671202 C-2.4646712,27.332886 7.10834659,22.7021332 8.44418153,22.0109026 C9.88254936,22.7214769 11.5018313,23.1214335 13.2148129,23.1214335 C17.9042678,23.1214335 21.894106,20.1280764 23.3792119,15.9479317 L17.7125077,15.9479317 C16.8740189,17.3644959 15.2597686,18.3239669 13.4052312,18.3239669 C10.6880532,18.3239669 8.48544068,16.2652582 8.48544068,13.72564 L23.9112201,13.72564 C23.9696986,13.270783 24,12.8072045 24,12.3365818 L23.9995527,12.3365818 Z M21.9848985,1.72369924 C22.9136208,2.35052528 23.6585218,3.33493063 22.3792645,6.65008673 C21.1523358,4.6769153 19.3064081,3.12908212 17.1124051,2.27829381 C18.1104517,1.79626615 20.5820874,0.776751388 21.9848985,1.72369924 L21.9848985,1.72369924 Z M2.24759358,21.9887635 C1.4911758,21.213002 1.35744695,19.3235789 3.02659768,15.88062 C3.86899999,18.3026105 5.55000295,20.3320241 7.72276134,21.6200029 C6.64219644,22.2147385 3.77351133,23.553816 2.24759358,21.9887635 L2.24759358,21.9887635 Z M8.46117717,10.7761138 C8.54738531,8.3078325 10.6955447,6.3315303 13.3349005,6.3315303 C15.9741445,6.3315303 18.1224157,8.3078325 18.2086239,10.7761138 L8.46117717,10.7761138 L8.46117717,10.7761138 Z"
                }
            }
        ]
    })(props);
}
function GrItalic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13,19.56l-.13.43H6.3l.16-.43a4.05,4.05,0,0,0,1.3-.17,1.6,1.6,0,0,0,.76-.55,7.22,7.22,0,0,0,.8-2l2.77-9.61a7.07,7.07,0,0,0,.35-1.81.86.86,0,0,0-.15-.52.94.94,0,0,0-.46-.32,4.28,4.28,0,0,0-1.22-.11l.14-.43h6.16l-.13.43a2.6,2.6,0,0,0-1.12.17,1.78,1.78,0,0,0-.81.67,9.08,9.08,0,0,0-.71,1.93L11.4,16.87A8.76,8.76,0,0,0,11,18.56a.83.83,0,0,0,.15.5.92.92,0,0,0,.47.32A6.35,6.35,0,0,0,13,19.56Z"
                }
            }
        ]
    })(props);
}
function GrIteration(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,9 L1,23 L15,23 M5,5 L5,19 L19,19 M9,15 L23,15 L23,1 L9,1 L9,15 L9,15 L9,15 Z"
                }
            }
        ]
    })(props);
}
function GrJava(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,18 L1,9 L17,9 L17,18 C17,22 15,23 9,23 C3,23 1,22 1,18 Z M17,9 L17,12 C17,13.657 18.343,15 20,15 C21.657,15 23,13.657 23,12 C23,10.343 21.657,9 20,9 L17,9 Z M13,6 L13,2 M5,6 L5,4 M9,6 L9,0"
                }
            }
        ]
    })(props);
}
function GrJs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none",
                    "fillRule": "evenodd"
                },
                "child": [
                    {
                        "tag": "rect",
                        "attr": {
                            "width": "24",
                            "height": "24"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "strokeWidth": "2",
                            "d": "M12,11 C12,15.749205 12,18.4158717 12,19 C12,19.8761925 11.4771235,21 10,21 C7.61461794,21 7.5,19 7.5,19 M20.7899648,13.51604 C20.1898831,12.5053467 19.3944074,12 18.4035378,12 C16.8563489,12 16,13 16,14 C16,15 16.5,16 18.5084196,16.5 C19.7864643,16.8181718 21,17.5 21,19 C21,20.5 19.6845401,21 18.5,21 C16.9861609,21 15.9861609,20.3333333 15.5,19"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function GrKey(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M10,13 L10,16 L13,16 L13,19 L16,19 L16,21 L18,23 L23,23 L23,19 L12.74,8.74 C12.91,8.19 13,7.6 13,7 C13,3.69 10.31,1 7,1 C3.69,1 1,3.69 1,7 C1,10.31 3.69,13 7,13 C7.88,13 8.72,12.81 9.47,12.47 L10,13 Z M6,7 C5.4475,7 5,6.5525 5,6 C5,5.4475 5.4475,5 6,5 C6.5525,5 7,5.4475 7,6 C7,6.5525 6.5525,7 6,7 Z"
                }
            }
        ]
    })(props);
}
function GrKeyboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeWidth": "2",
                    "d": "M3 9h3m-3 3h2m-2 3h1m3 0h10m1 0h1m1 0h1m-3-3h3m-2-3h2m-5 0h2M7 9h2m1 0h2m1 0h2M5 15h1m0-3h2m1 0h2m1 0h2m1 0h2M1 7v10a1 1 0 001 1h20a1 1 0 001-1V7a1 1 0 00-1-1H2a1 1 0 00-1 1z"
                }
            }
        ]
    })(props);
}
function GrKubernetes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "clipPath": "url(#a)"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M14.27 13.385h-.268c-.21.129-.302.373-.21.582l1.002 2.457a5.15 5.15 0 0 0 2.084-2.62l-2.596-.419h-.012Zm-4.016.338a.483.483 0 0 0-.443-.338h-.093l-2.584.431a5.143 5.143 0 0 0 2.084 2.596l.99-2.41v-.035c.046-.058.046-.162.046-.244Zm2.13.943a.44.44 0 0 0-.594-.175c-.081.059-.14.094-.174.175h-.012l-1.269 2.293a5.195 5.195 0 0 0 2.83.14c.162-.035.337-.081.5-.14l-1.27-2.293h-.01Zm4.017-5.32-1.956 1.711.011.035a.43.43 0 0 0-.046.617c.058.07.128.116.21.14l.011.011 2.526.722c.082-1.13-.163-2.27-.756-3.236Zm-3.621.186c.012.244.21.43.454.419a.54.54 0 0 0 .245-.058h.011l2.13-1.525a5.182 5.182 0 0 0-2.991-1.444l.151 2.608Zm-2.258.36a.442.442 0 0 0 .605-.104.45.45 0 0 0 .093-.244h.012l.14-2.62c-.175.023-.35.058-.536.093a5.064 5.064 0 0 0-2.468 1.35l2.142 1.526h.011ZM9.368 11.86a.426.426 0 0 0 .303-.535c0-.093-.059-.163-.128-.221v-.012L7.588 9.31a5.194 5.194 0 0 0-.734 3.283l2.515-.722v-.012Zm1.91.769.721.349.722-.35.174-.78-.5-.616h-.804l-.5.617.186.78Zm12.677 1.536-2.06-8.929a1.588 1.588 0 0 0-.862-1.094L12.687.148a1.69 1.69 0 0 0-1.385 0L2.966 4.142c-.431.21-.757.605-.862 1.094l-2.06 8.93a1.373 1.373 0 0 0 0 .686c.011.07.035.14.058.21.035.105.093.221.151.314.035.047.058.093.105.128L6.121 22.7c.023 0 .058.047.058.07.116.105.221.186.326.256.14.093.303.163.466.198.128.058.267.058.372.058h9.454c.081 0 .162-.035.232-.058.059-.012.117-.035.163-.047.047-.023.082-.035.128-.058.059-.023.117-.058.175-.093.14-.093.268-.21.384-.326l.175-.233 5.588-6.962c.116-.14.198-.29.256-.442a1.4 1.4 0 0 0 .058-.21 1.37 1.37 0 0 0 0-.687Zm-8.65 3.481c.024.07.047.14.082.198a.392.392 0 0 0-.035.303c.14.28.268.536.442.792.093.128.187.267.28.395 0 .035.035.094.046.14a.5.5 0 0 1-.174.687.495.495 0 0 1-.687-.175c-.012-.035-.024-.058-.035-.093-.023-.035-.047-.105-.07-.105a5.205 5.205 0 0 1-.14-.477c-.104-.29-.198-.57-.349-.838a.437.437 0 0 0-.245-.163l-.093-.186a6.517 6.517 0 0 1-4.621-.012l-.117.21a.394.394 0 0 0-.221.104c-.163.28-.28.57-.384.897a4.155 4.155 0 0 1-.14.465c-.023 0-.047.082-.07.117a.501.501 0 0 1-.943-.338c.012-.035.035-.058.047-.093.046-.035.046-.093.046-.128.105-.14.187-.268.28-.407.186-.245.337-.524.454-.804a.628.628 0 0 0-.035-.29l.081-.21a6.532 6.532 0 0 1-2.875-3.598l-.233.035a.451.451 0 0 0-.268-.104 6.044 6.044 0 0 0-.896.256c-.128.07-.28.128-.431.174a1.01 1.01 0 0 1-.151.035.51.51 0 0 1-.63-.314.504.504 0 0 1 .327-.64c.023 0 .058-.012.093-.012v-.012h.012l.128-.023c.163-.047.326-.047.477-.047.303 0 .605-.07.896-.14a.67.67 0 0 0 .222-.22l.22-.059a6.35 6.35 0 0 1 1.002-4.505l-.163-.14a.51.51 0 0 0-.093-.29 4.765 4.765 0 0 0-.745-.525c-.14-.07-.28-.151-.42-.244-.022-.024-.07-.059-.092-.082l-.012-.011c-.233-.187-.291-.49-.128-.734a.528.528 0 0 1 .407-.175.655.655 0 0 1 .35.14l.104.082c.117.104.222.233.326.349.21.221.431.43.676.605a.45.45 0 0 0 .302.035l.175.128a6.398 6.398 0 0 1 3.26-1.862c.29-.07.605-.117.908-.14l.011-.21a.524.524 0 0 0 .163-.267 4.583 4.583 0 0 0-.058-.897 3.14 3.14 0 0 1-.07-.477v-.14a.517.517 0 0 1 .454-.559.497.497 0 0 1 .548.443v.256a3.14 3.14 0 0 1-.07.477c-.047.291-.07.594-.058.897a.397.397 0 0 0 .163.256l.011.22A6.49 6.49 0 0 1 16.692 7.6l.186-.14a.45.45 0 0 0 .303-.034 4.18 4.18 0 0 0 .675-.606c.105-.116.21-.233.326-.349.035-.023.081-.07.116-.07.198-.21.513-.21.687 0 .221.186.21.5 0 .699 0 .023-.035.046-.07.07a2.907 2.907 0 0 1-.512.326 4.274 4.274 0 0 0-.745.523.357.357 0 0 0-.093.28l-.186.163a6.333 6.333 0 0 1 1.024 4.494l.221.058a.483.483 0 0 0 .222.21c.29.08.593.127.896.162h.477c.035.035.093.047.14.059a.5.5 0 0 1 .43.57c-.058.268-.279.466-.558.43-.035-.01-.082-.01-.082-.023v-.011a.605.605 0 0 1-.163-.023 2.27 2.27 0 0 1-.419-.175 4.101 4.101 0 0 0-.896-.245c-.105 0-.198 0-.268.094a8.755 8.755 0 0 1-.221-.035c-.477 1.525-1.525 2.805-2.876 3.62Z"
                        }
                    }
                ]
            },
            {
                "tag": "defs",
                "attr": {},
                "child": [
                    {
                        "tag": "clipPath",
                        "attr": {
                            "id": "a"
                        },
                        "child": [
                            {
                                "tag": "path",
                                "attr": {
                                    "d": "M0 0h24v24H0z"
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    })(props);
}
function GrLanguage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 Z M12,23 C15,23 16,18 16,12 C16,6 15,1 12,1 C9,1 8,6 8,12 C8,18 9,23 12,23 Z M2,16 L22,16 M2,8 L22,8"
                }
            }
        ]
    })(props);
}
function GrLastfm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.2973911,10.9243705 C20.0872375,10.8554597 19.8839266,10.7919248 19.688435,10.7298553 C18.1943918,10.2601877 17.2936635,9.97672434 17.2936635,8.81403954 C17.2936635,7.87079223 18.0208923,7.18706171 19.0242528,7.18706171 C19.7925339,7.18706171 20.3653248,7.50571246 20.8789776,8.22463246 C20.9268734,8.29158903 21.0172889,8.31553554 21.0920633,8.27594857 L22.5993031,7.5066896 C22.6403568,7.48665166 22.6706571,7.44950857 22.6833641,7.40552274 C22.6965593,7.3615376 22.6921611,7.31461966 22.6691911,7.27454377 C21.8618119,5.83963589 20.6971701,5.14222057 19.1088027,5.14222057 C16.6920391,5.14222057 15.1290843,6.60449737 15.1290843,8.86731063 C15.1290843,11.1809525 16.6402347,12.117357 19.4274535,13.0347001 C21.0427015,13.57328 21.7567344,13.8586969 21.7567344,15.0076983 C21.7567344,16.2994078 20.5920946,17.2279931 19.001771,17.1737435 C17.336184,17.1175403 16.8313269,16.2344075 16.1964679,14.7882587 C15.1227312,12.3387509 13.9009097,9.47919886 13.8891806,9.45134171 C12.6624706,6.6216032 10.2315353,5 7.21852183,5 C3.23831589,5 0,8.23880549 0,12.2204782 C0,16.2001959 3.23831589,19.4390007 7.21852183,19.4390007 C9.38945417,19.4390007 11.4245211,18.4766933 12.8007813,16.7979111 C12.8408585,16.7490375 12.8506313,16.6835477 12.8257063,16.6248999 L11.9152059,14.5248327 C11.8893017,14.4666745 11.8311429,14.4275771 11.7671198,14.4246437 C11.701141,14.4217088 11.642005,14.4578782 11.6126825,14.5145696 C10.7534976,16.1562094 9.06982697,17.1756971 7.21754537,17.1756971 C4.48603954,17.1756971 2.26428,14.953448 2.26428,12.2204775 C2.26428,9.48750629 4.48652846,7.26525783 7.2180336,7.26525783 C9.20667086,7.26525783 11.0286514,8.44553669 11.7524578,10.206427 L14.0030537,15.3400325 L14.2625685,15.9167326 C15.2801019,18.2870679 16.7751237,19.3490754 19.1166226,19.3578725 C21.9009093,19.3578725 24,17.5129205 24,15.0673225 C24,12.6099954 22.6418215,11.6892299 20.2973911,10.9243698 L20.2973911,10.9243705 Z"
                }
            }
        ]
    })(props);
}
function GrLaunch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M7,9 L7,14 C7,14 4,16 4,19 L4,20 L8,20 L10,23 L14,23 L16,20 L20,20 L20,19 C20,16 17,14 17,14 L17,9 C17,5 14,1 12,1 C10,1 7,5 7,9 Z M8,20 L16,20 M12,9 C12.5522847,9 13,8.55228475 13,8 C13,7.44771525 12.5522847,7 12,7 C11.4477153,7 11,7.44771525 11,8 C11,8.55228475 11.4477153,9 12,9 Z"
                }
            }
        ]
    })(props);
}
function GrLayer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,1 L17,1 L17,17 L1,17 L1,1 Z M20,7 L23,7 L23,23 L7,23 L7,20 L7,20"
                }
            }
        ]
    })(props);
}
function GrLicense(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M10,13 L10,16 L13,16 L13,19 L16,19 L16,21 L18,23 L23,23 L23,19 L12.74,8.74 C12.91,8.19 13,7.6 13,7 C13,3.69 10.31,1 7,1 C3.69,1 1,3.69 1,7 C1,10.31 3.69,13 7,13 C7.88,13 8.72,12.81 9.47,12.47 L10,13 Z M6,7 C5.4475,7 5,6.5525 5,6 C5,5.4475 5.4475,5 6,5 C6.5525,5 7,5.4475 7,6 C7,6.5525 6.5525,7 6,7 Z"
                }
            }
        ]
    })(props);
}
function GrLikeFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M11 0h-.997L10 .997 11 1l-1-.003v.261l-.002.698-.006 2.207a2728.4 2728.4 0 0 0-.008 4.163c0 .42-.155.83-.454 1.132C9.243 9.749 8.763 10 8 10H1.001L1 11v-1H0v14h1v-1 1h19c1.154 0 2.203-.29 2.957-1.043C23.711 22.203 24 21.154 24 20v-9.999L23 10h1V9h-7V4c0-1.154-.29-2.203-1.043-2.957C15.203.289 14.154 0 13 0h-2ZM5 12v10H2V12h3Z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function GrLike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,23 L20,23 C22,23 23,22 23,20 L23,10 L16,10 L16,4 C16,2 15,1 13,1 L11,1 C11,1 10.9842682,7 10.9842677,8.32575545 C10.9842672,9.65151089 10,11 8,11 L1,11 L1,23 Z M6,23 L6,11"
                }
            }
        ]
    })(props);
}
function GrLineChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,16 L8,9 L13,14 L23,4 M0,22 L23.999,22 M16,4 L23,4 L23,11"
                }
            }
        ]
    })(props);
}
function GrLinkBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,5 L12,23 M4,13 L12,5 L20,13 M2,2 L22,2",
                    "transform": "matrix(1 0 0 -1 0 24)"
                }
            }
        ]
    })(props);
}
function GrLinkDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,2 L12,22 M3,11 L12,2 L21,11",
                    "transform": "matrix(1 0 0 -1 0 24)"
                }
            }
        ]
    })(props);
}
function GrLinkNext(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2,12 L22,12 M13,3 L22,12 L13,21"
                }
            }
        ]
    })(props);
}
function GrLinkPrevious(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2,12 L22,12 M13,3 L22,12 L13,21",
                    "transform": "matrix(-1 0 0 1 24 0)"
                }
            }
        ]
    })(props);
}
function GrLinkTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,5 L12,23 M4,13 L12,5 L20,13 M2,2 L22,2"
                }
            }
        ]
    })(props);
}
function GrLinkUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,2 L12,22 M3,11 L12,2 L21,11"
                }
            }
        ]
    })(props);
}
function GrLink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M16.1251884,2.42026615 C16.9095797,1.63587482 18.1818354,1.63638083 18.9643331,2.41887857 L21.5811214,5.03566688 C22.3647464,5.81929188 22.3723943,7.08215115 21.5797338,7.87481161 L17.8748116,11.5797338 C17.0904203,12.3641252 15.8181646,12.3636192 15.0356669,11.5811214 L12.4188786,8.96433312 C11.6352536,8.18070812 11.6276057,6.91784885 12.4202662,6.12518839 L16.1251884,2.42026615 Z M6.12518839,12.4202662 C6.90957973,11.6358748 8.18183538,11.6363808 8.96433312,12.4188786 L11.5811214,15.0356669 C12.3647464,15.8192919 12.3723943,17.0821512 11.5797338,17.8748116 L7.87481161,21.5797338 C7.09042027,22.3641252 5.81816462,22.3636192 5.03566688,21.5811214 L2.41887857,18.9643331 C1.63525357,18.1807081 1.6276057,16.9178488 2.42026615,16.1251884 L6.12518839,12.4202662 Z M7,17 L17,7"
                }
            }
        ]
    })(props);
}
function GrLinkedinOption(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M22.0367422,22 L17.8848745,22 L17.8848745,15.5036305 C17.8848745,13.9543347 17.85863,11.9615082 15.7275829,11.9615082 C13.5676669,11.9615082 13.237862,13.6498994 13.237862,15.3925291 L13.237862,22 L9.0903683,22 L9.0903683,8.64071385 L13.0707725,8.64071385 L13.0707725,10.4673257 L13.1276354,10.4673257 C13.6813927,9.41667396 15.0356049,8.3091593 17.0555507,8.3091593 C21.2599073,8.3091593 22.0367422,11.0753215 22.0367422,14.6734319 L22.0367422,22 Z M4.40923804,6.81585163 C3.07514653,6.81585163 2,5.73720584 2,4.40748841 C2,3.07864579 3.07514653,2 4.40923804,2 C5.73720584,2 6.81585163,3.07864579 6.81585163,4.40748841 C6.81585163,5.73720584 5.73720584,6.81585163 4.40923804,6.81585163 L4.40923804,6.81585163 Z M6.48604672,22 L2.32980492,22 L2.32980492,8.64071385 L6.48604672,8.64071385 L6.48604672,22 Z"
                }
            }
        ]
    })(props);
}
function GrLinkedin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M20.45175,20.45025 L16.89225,20.45025 L16.89225,14.88075 C16.89225,13.5525 16.86975,11.844 15.04275,11.844 C13.191,11.844 12.90825,13.2915 12.90825,14.7855 L12.90825,20.45025 L9.3525,20.45025 L9.3525,8.997 L12.765,8.997 L12.765,10.563 L12.81375,10.563 C13.2885,9.66225 14.4495,8.71275 16.18125,8.71275 C19.78575,8.71275 20.45175,11.08425 20.45175,14.169 L20.45175,20.45025 Z M5.33925,7.4325 C4.1955,7.4325 3.27375,6.50775 3.27375,5.36775 C3.27375,4.2285 4.1955,3.30375 5.33925,3.30375 C6.47775,3.30375 7.4025,4.2285 7.4025,5.36775 C7.4025,6.50775 6.47775,7.4325 5.33925,7.4325 L5.33925,7.4325 Z M7.11975,20.45025 L3.5565,20.45025 L3.5565,8.997 L7.11975,8.997 L7.11975,20.45025 Z M23.00025,0 L1.0005,0 C0.44775,0 0,0.44775 0,0.99975 L0,22.9995 C0,23.55225 0.44775,24 1.0005,24 L23.00025,24 C23.55225,24 24,23.55225 24,22.9995 L24,0.99975 C24,0.44775 23.55225,0 23.00025,0 L23.00025,0 Z"
                }
            }
        ]
    })(props);
}
function GrList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeWidth": "2",
                    "d": "M9,6 L21,6 M9,12 L21,12 M9,18 L17,18 M4,7 C4.55228475,7 5,6.55228475 5,6 C5,5.44771525 4.55228475,5 4,5 C3.44771525,5 3,5.44771525 3,6 C3,6.55228475 3.44771525,7 4,7 Z M4,13 C4.55228475,13 5,12.5522847 5,12 C5,11.4477153 4.55228475,11 4,11 C3.44771525,11 3,11.4477153 3,12 C3,12.5522847 3.44771525,13 4,13 Z M4,19 C4.55228475,19 5,18.5522847 5,18 C5,17.4477153 4.55228475,17 4,17 C3.44771525,17 3,17.4477153 3,18 C3,18.5522847 3.44771525,19 4,19 Z"
                }
            }
        ]
    })(props);
}
function GrLocal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,4 L23,4 L23,20 L1,20 L1,4 Z M11,8 L23,8 M1,16 L23,16 M1,12 L23,12 M11,4 L11,12"
                }
            }
        ]
    })(props);
}
function GrLocationPin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,10 C14.209139,10 16,8.209139 16,6 C16,3.790861 14.209139,2 12,2 C9.790861,2 8,3.790861 8,6 C8,8.209139 9.790861,10 12,10 Z M12,10 L12,22"
                }
            }
        ]
    })(props);
}
function GrLocation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,22 C12,22 4,16 4,10 C4,5 8,2 12,2 C16,2 20,5 20,10 C20,16 12,22 12,22 Z M12,13 C13.657,13 15,11.657 15,10 C15,8.343 13.657,7 12,7 C10.343,7 9,8.343 9,10 C9,11.657 10.343,13 12,13 L12,13 Z"
                }
            }
        ]
    })(props);
}
function GrLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M19,23 L19,11 L5,11 L5,23 L19,23 Z M12,15 L12,19 M17,11 L17,7 C17,4 17,1 12,1 C7,1 7,4 7,7 L7,11"
                }
            }
        ]
    })(props);
}
function GrLogin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M9,15 L9,22 L22,22 L22,2 L9,2 L9,9 M18,12 L0,12 M13,7 L18,12 L13,17"
                }
            }
        ]
    })(props);
}
function GrLogout(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M13,9 L13,2 L1,2 L1,22 L13,22 L13,15 M22,12 L5,12 M17,7 L22,12 L17,17"
                }
            }
        ]
    })(props);
}
function GrLounge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M5,5.99703014 C5,5.4463856 5.44994876,5 6.00684547,5 L17.9931545,5 C18.5492199,5 19,5.45303631 19,5.99703014 L19,13 L5,13 L5,5.99703014 Z M22,8 L22,15.0029699 C22,15.5536144 21.5446944,16 21.0081969,16 L2.99180311,16 C2.44404538,16 2,15.5469637 2,15.0029699 L2,8 M5,16 L5,18 L5,16 Z M19,16 L19,18 L19,16 Z"
                }
            }
        ]
    })(props);
}
function GrMagic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2.5,19.5 L19.5,2.5 L21.5,4.5 L4.5,21.5 L2.5,19.5 Z M3,20 L15,8 L16,9 L4,21 L3,20 Z M5.5,3 L5,3.5 L5.5,4 L6,3.5 L5.5,3 Z M11.5,3 L11,3.5 L11.5,4 L12,3.5 L11.5,3 Z M8.5,6 L8,6.5 L8.5,7 L9,6.5 L8.5,6 Z M20.5,12 L20,12.5 L20.5,13 L21,12.5 L20.5,12 Z M20.5,17 L20,17.5 L20.5,18 L21,17.5 L20.5,17 Z"
                }
            }
        ]
    })(props);
}
function GrMailOption(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,4 L23,4 L23,20 L1,20 L1,4 Z M1,5 L12,13.5 L23,5"
                }
            }
        ]
    })(props);
}
function GrMail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M23,20 L23,6 L12,15 L1,6 L1,20 L23,20 Z M12,12 L22,4 L2,4 L12,12 Z"
                }
            }
        ]
    })(props);
}
function GrMandriva(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14.5570931,17.2000288 C11.5359885,19.9198072 8.20256657,21.3464829 5.48168143,21.3477982 L5.47448141,21.3477982 C3.53623738,21.3469582 1.90939399,20.6221567 0.929831949,19.1255136 C-1.43057297,15.5191461 0.857831799,8.79721207 6.0417226,4.11132231 C6.48248351,3.71304149 6.93008445,3.34272071 7.38104539,3 C3.03835634,7.58232954 1.26883266,13.546462 3.44275718,16.8678289 C5.39538971,19.8509662 9.91672716,19.7668791 14.3554206,16.9971815 L13.0316172,15.6656664 C12.8748968,15.5090661 12.6040563,15.4076658 12.3402957,15.4076658 C12.2337355,15.4076658 12.1324553,15.4249459 12.0478551,15.4574659 L7.76936619,17.1139494 C7.66772598,17.1534295 7.57496579,17.1731095 7.49408562,17.1731095 C7.31780525,17.1731095 7.23512508,17.0811893 7.20176501,17.0262292 C7.1495649,16.940789 7.11452483,16.7857487 7.2444851,16.5305082 L9.33848946,12.4490597 C9.48608977,12.1594991 9.43796967,11.7014581 9.23264924,11.4486176 L6.33584321,7.89157019 C6.1409628,7.65300969 6.15512283,7.48608934 6.20168293,7.38816914 C6.235163,7.31748899 6.32816319,7.19892875 6.5736837,7.19892875 C6.6216838,7.19892875 6.67364391,7.20360876 6.72884403,7.21260877 L11.2574135,7.94185029 C11.2922135,7.9476103 11.3294136,7.95037031 11.3676937,7.95037031 C11.6742943,7.95037031 12.0216951,7.77084994 12.1756554,7.53348944 L14.6625406,3.67956142 C14.8154209,3.44304092 14.9649412,3.39336082 15.0633414,3.39336082 C15.1529816,3.39336082 15.368742,3.43704091 15.4313822,3.84156175 L16.1365036,8.3750512 C16.1864237,8.69701187 16.4945844,9.03925258 16.808865,9.12241275 L21.2429943,10.2967352 C21.5752749,10.3851754 21.6415151,10.5556957 21.6513551,10.6492959 C21.6613151,10.7426561 21.6323951,10.9227765 21.3261544,11.0781768 L17.2318659,13.1493811 C16.9415853,13.2957814 16.7119048,13.6941823 16.7297849,14.019503 L16.9825054,18.6005125 C16.9935454,18.7941929 16.9555053,18.9384332 16.8698251,19.0291534 C16.811985,19.0899935 16.7372249,19.1222736 16.6528647,19.1222736 C16.5299844,19.1222736 16.3999042,19.0537534 16.2657439,18.9186332 L14.5570935,17.2000293 L14.5570931,17.2000288 Z M24,11.4025855 C22.7552374,10.7310641 22.576677,10.7632242 21.6445151,11.8272664 C22.3162765,10.5826238 22.2838764,10.4035834 21.2195942,9.47142148 C22.4647168,10.1433029 22.6436372,10.1110228 23.5756791,9.04710059 C22.9040377,10.2918632 22.9364378,10.4706636 24,11.4025855 Z"
                }
            }
        ]
    })(props);
}
function GrManual(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M14,9 L14,17 L14,9 Z M10,9 L10,17 L10,9 Z M8,5 C8,7.209 9.791,9 12,9 C14.209,9 16,7.209 16,5 C16,2.791 14.209,1 12,1 C9.791,1 8,2.791 8,5 Z M4,23 L20,23 L20,20 L4,20 L4,23 Z M7,20 L17,20 L17,17 L7,17 L7,20 Z"
                }
            }
        ]
    })(props);
}
function GrMapLocation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M17.5,6.5 L23,9 L23,22 L16,19 L8,22 L1,19 L1,6 L6,8 M16,19 L16,12 M8,22 L8,12 M12,16.2727273 C12,16.2727273 6,11.5 6,7 C6,3.25 9,1 12,1 C15,1 18,3.25 18,7 C18,11.5 12,16.2727273 12,16.2727273 Z M13,7 C13,6.44766667 12.5523333,6 12,6 C11.4476667,6 11,6.44766667 11,7 C11,7.55233333 11.4476667,8 12,8 C12.5523333,8 13,7.55233333 13,7 Z"
                }
            }
        ]
    })(props);
}
function GrMap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M15,15 L19,15 L22,22 L2,22 L5,15 L9,15 M13,8 C13,8.5525 12.5525,9 12,9 C11.4475,9 11,8.5525 11,8 C11,7.4475 11.4475,7 12,7 C12.5525,7 13,7.4475 13,8 M6,8 C6,13 12,18 12,18 C12,18 18,13 18,8 C18,4.58317221 15.3135725,2 12,2 C8.68642746,2 6,4.58317221 6,8 Z"
                }
            }
        ]
    })(props);
}
function GrMastercard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none",
                    "fillRule": "evenodd"
                },
                "child": [
                    {
                        "tag": "circle",
                        "attr": {
                            "cx": "7",
                            "cy": "12",
                            "r": "7"
                        }
                    },
                    {
                        "tag": "circle",
                        "attr": {
                            "cx": "17",
                            "cy": "12",
                            "r": "7",
                            "fillOpacity": ".8"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function GrMedium(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.783 5a6.783 6.783 0 1 0 0 13.565A6.783 6.783 0 0 0 6.783 5Zm10.695.522c-1.873 0-3.391 2.803-3.391 6.26 0 .65.053 1.274.152 1.862.132.784.346 1.502.622 2.121.138.31.292.594.46.849.335.51.724.904 1.149 1.148.319.183.657.282 1.008.282s.69-.1 1.009-.282c.425-.244.814-.638 1.149-1.148.167-.255.321-.54.46-.849.276-.618.49-1.337.621-2.12.1-.589.153-1.214.153-1.862 0-3.458-1.519-6.261-3.392-6.261Zm5.218.521c-.136 0-.266.09-.388.259-.082.111-.16.257-.234.434a4.007 4.007 0 0 0-.107.288c-.07.206-.134.441-.193.7-.118.52-.214 1.138-.28 1.825a22.61 22.61 0 0 0-.103 2.234 24.502 24.502 0 0 0 .103 2.234c.066.686.162 1.305.28 1.824.059.26.123.495.193.7.034.104.07.2.107.288.074.177.153.323.234.435.122.168.253.258.388.258.72 0 1.304-2.57 1.304-5.74 0-3.169-.584-5.739-1.304-5.739Z"
                }
            }
        ]
    })(props);
}
function GrMemory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeWidth": "2",
                    "d": "M10 18h4m-4-4h4m-4-4h4m-4-4h4m6 12h3m-3-4h3m-3-4h3m-3-4h3M1 18h3m-3-4h3m-3-4h3M1 6h3m11 14h4a1 1 0 001-1V5a1 1 0 00-1-1h-4a1 1 0 00-1 1v14a1 1 0 001 1zM5 20h4a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v14a1 1 0 001 1z"
                }
            }
        ]
    })(props);
}
function GrMenu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2,19 L22,19 M2,5 L22,5 M2,12 L22,12"
                }
            }
        ]
    })(props);
}
function GrMeta(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.562 14.676c0-3.929 1.965-8.028 4.27-8.028 1.282 0 2.307.768 3.93 3.074a1702.683 1702.683 0 0 1-2.477 3.844c-2.05 3.245-2.733 3.929-3.844 3.929-1.11.085-1.879-.94-1.879-2.819Zm13.41-1.452-1.452-2.391c-.342-.598-.77-1.196-1.11-1.708 1.28-1.965 2.305-2.99 3.586-2.99 2.563 0 4.613 3.844 4.613 8.627 0 1.793-.598 2.818-1.794 2.818-1.196 0-1.623-.769-3.844-4.356Zm-3.673-5.808C10.419 4.94 8.797 4 6.919 4 2.988 4 0 9.21 0 14.676c0 3.417 1.623 5.552 4.356 5.552 1.964 0 3.33-.94 5.893-5.381 0 0 1.025-1.879 1.794-3.16.256.427.512.854.768 1.366l1.196 2.05c2.306 3.929 3.587 5.21 5.893 5.21 2.648 0 4.1-2.22 4.1-5.722C23.915 8.783 20.84 4 17.167 4c-1.964 0-3.502 1.537-4.868 3.416Z"
                }
            }
        ]
    })(props);
}
function GrMicrofocus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1,5 L5,5 L5,19 L19,19 L19,23 L1,23 L1,5 Z M5,1 L23,1 L23,19 L19,19 L19,5 L5,5 L5,1 Z"
                }
            }
        ]
    })(props);
}
function GrMicrophone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M8,11 C8,14 9.790861,15 12,15 C14.209139,15 16,14 16,11 L16,5 C16,2 14.209139,1 12,1 C9.790861,1 8,2 8,5 L8,11 Z M4,9 L4,11 C4,16 7.581722,19 12,19 C16.418278,19 20,16 20,11 L20,9 M12,24 L12,19"
                }
            }
        ]
    })(props);
}
function GrMoney(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M16,16 C16,14.8954305 12.8659932,14 9,14 C5.13400675,14 2,14.8954305 2,16 C2,17.1045695 5.13400675,18 9,18 C12.8659932,18 16,17.1045695 16,16 Z M2,16 L2,20.9367547 C2,22.0762536 5.13400675,23 9,23 C12.8659932,23 16,22.0762537 16,20.9367548 L16,16 M9,5 C4.581722,5 1,5.8954305 1,7 C1,8.1045695 4.581722,9 9,9 M1,7 L1,12.0000002 C1,13.0128881 4.581722,14 9,14 M23,4 C23,2.8954305 19.9004329,2 16.0769231,2 C12.2534133,2 9.15384615,2.8954305 9.15384615,4 C9.15384615,5.1045695 12.2534133,6 16.0769231,6 C19.9004329,6 23,5.1045695 23,4 Z M16,16 C19.8235098,16 23.0000002,15.0128879 23.0000002,14 L23,4 M9.15384615,3.99999999 L9.15384615,14.1660042 M8.99999999,9.00000001 C8.99999999,10.0128879 12.2534135,11 16.0769233,11 C19.9004331,11 23.0000004,10.0128879 23.0000004,9.00000001"
                }
            }
        ]
    })(props);
}
function GrMonitor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,16 L23,16 L23,2 L1,2 L1,16 Z M5,22 L19,22 L5,22 Z M9,22 L15,22 L15,16 L9,16 L9,22 Z"
                }
            }
        ]
    })(props);
}
function GrMonospace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.88,17H9.58L8.65,14.1H4.44L3.57,17H1.32L5.41,4.17H7.66ZM8,11.93,6.52,7.17,5.09,11.93Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.13,17,12.22,4.17h1.66L15.07,13l1.46-8.82h1.92l1.4,9,1.23-9h1.62L20.78,17H19.06l-1.6-9.6L15.88,17Z"
                }
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "11.36 17.95 11.36 19.34 1.89 19.34 1.89 17.95 1.38 17.95 1.38 19.86 1.64 19.86 1.89 19.86 11.36 19.86 11.87 19.86 11.87 19.86 11.87 17.95 11.36 17.95"
                }
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "22.17 18 22.17 19.39 12.69 19.39 12.69 18 12.19 18 12.19 19.91 12.45 19.91 12.69 19.91 22.17 19.91 22.67 19.91 22.68 19.91 22.68 18 22.17 18"
                }
            }
        ]
    })(props);
}
function GrMoon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinejoin": "round",
                    "strokeWidth": "2",
                    "d": "M9.874 5.008c2.728-1.68 6.604-1.014 8.25.197-2.955.84-5.11 3.267-5.242 6.415-.18 4.28 3.006 6.588 5.24 7.152-1.964 1.343-4.36 1.293-5.235 1.172-3.568-.492-6.902-3.433-7.007-7.711-.106-4.278 2.573-6.35 3.994-7.225z"
                }
            }
        ]
    })(props);
}
function GrMoreVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14,14 L10,14 L10,10 L14,10 L14,14 Z M14,7 L10,7 L10,3 L14,3 L14,7 Z M14,21 L10,21 L10,17 L14,17 L14,21 Z"
                }
            }
        ]
    })(props);
}
function GrMore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M3,13 L3,11 L5,11 L5,13 L3,13 Z M11,12.9995001 L11,11 L12.9995001,11 L12.9995001,12.9995001 L11,12.9995001 Z M19,12.9995001 L19,11 L20.9995001,11 L20.9995001,12.9995001 L19,12.9995001 Z"
                }
            }
        ]
    })(props);
}
function GrMouse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeWidth": "2",
                    "d": "M12 4a5 5 0 015 5v6a5 5 0 01-10 0V9a5 5 0 015-5zm0 0v6m-6 0h12"
                }
            }
        ]
    })(props);
}
function GrMultimedia(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "2",
                    "d": "M2,8 L2,22 L22,22 L22,9 M11,4 L7,8 M2,4 L2,8 L17,8 L21,4 L2,4 Z M16,4 L12,8"
                }
            }
        ]
    })(props);
}
function GrMultiple(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M19,15 L23,15 L23,1 L9,1 L9,5 M15,19 L19,19 L19,5 L5,5 L5,9 M1,23 L15,23 L15,9 L1,9 L1,23 L1,23 L1,23 Z"
                }
            }
        ]
    })(props);
}
function GrMusic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,17.9979131 C1,16.8944962 1.88670635,16 2.99810135,16 L9,16 L9,20.0020869 C9,21.1055038 8.11329365,22 7.00189865,22 L2.99810135,22 C1.89458045,22 1,21.1017394 1,20.0020869 L1,17.9979131 Z M15,17.9979131 C15,16.8944962 15.8867064,16 16.9981014,16 L23,16 L23,20.0020869 C23,21.1055038 22.1132936,22 21.0018986,22 L16.9981014,22 C15.8945804,22 15,21.1017394 15,20.0020869 L15,17.9979131 Z M9,16 L9,2 L23,2 L23,15.5 M9,6 L23,6"
                }
            }
        ]
    })(props);
}
function GrMysql(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.46192862,4.04007684 C5.18892668,4.03501656 4.99575061,4.06967946 4.79169495,4.11446291 L4.79169495,4.15152944 L4.82901449,4.15152944 C4.95944313,4.41909158 5.18943271,4.591394 5.35034952,4.82188962 C5.47407329,5.08262038 5.59817658,5.34297163 5.72227987,5.60332288 C5.73493056,5.5909252 5.74745474,5.57865403 5.75959941,5.56625635 C5.99047454,5.40394797 6.0957283,5.14410275 6.09471625,4.74737704 C6.00211318,4.64996671 5.98832392,4.52826705 5.90837155,4.4122602 C5.80235875,4.25754224 5.59615247,4.17012595 5.46192862,4.04007684 L5.46192862,4.04007684 Z M23.478665,23.1369293 C23.6543831,23.2658398 23.772161,23.4657208 24,23.5466852 L24,23.5093657 C23.8800714,23.3573044 23.8495833,23.1474294 23.7395222,22.9880306 C23.5786054,22.8271138 23.4164236,22.6655645 23.2555068,22.5040152 C22.7821179,21.8759083 22.1818425,21.3245911 21.5432356,20.8663831 C21.0345512,20.5006515 19.8944709,20.0072745 19.6819392,19.4148426 C19.6697946,19.4021919 19.6571439,19.3896677 19.6444932,19.3770171 C20.0054174,19.3365348 20.4283301,19.2059797 20.7614228,19.1165393 C21.3210894,18.9665021 21.8214243,19.0054662 22.3990549,18.8560615 C22.6600387,18.781296 22.9203899,18.7066569 23.1808677,18.6329033 L23.1808677,18.4834987 C22.8887632,18.1836773 22.6805328,17.7869515 22.3622414,17.5155942 C21.5283078,16.8061434 20.6188495,16.0966926 19.6818127,15.5056522 C19.1626283,15.1774933 18.5200996,14.9645821 17.969415,14.6865199 C17.7842089,14.5931578 17.4590861,14.5444526 17.3365009,14.3887226 C17.0476856,14.0198284 16.8899314,13.5523853 16.6667732,13.1228943 C16.1997097,12.2230506 15.740363,11.2403448 15.3263059,10.293567 C15.044322,9.6481287 14.8597484,9.01154587 14.5076796,8.43227067 C12.8174206,5.65329311 10.9976185,3.97581132 8.17942382,2.3270466 C7.57927498,1.97649592 6.85742648,1.83809735 6.09471625,1.65719245 C5.68546635,1.6325236 5.27545742,1.60734872 4.86620752,1.58267987 C4.61635635,1.47831166 4.35651113,1.17267094 4.12184079,1.02427832 C3.18796669,0.434503045 0.792811133,-0.848656668 0.10157731,0.838313141 C-0.335124586,1.90286889 0.753847001,2.94174374 1.14361483,3.48142227 C1.4172493,3.85980447 1.76704094,4.2842352 1.96287366,4.70967798 C2.09127818,4.98938478 2.11316388,5.27010364 2.22385744,5.56600333 C2.49432924,6.29518923 2.7293791,7.08838764 3.07929725,7.76241652 C3.25653344,8.10322617 3.45173363,8.46263233 3.67539786,8.76738751 C3.81265788,8.95449125 4.04720171,9.03684725 4.08401522,9.32578906 C3.85465817,9.64749617 3.84150145,10.1466925 3.7125909,10.5541713 C3.13065906,12.3887747 3.35014857,14.6686824 4.19660638,16.0266077 C4.45594557,16.443195 5.06773305,17.3374725 5.90837155,16.9942592 C6.64375629,16.6946908 6.47980332,15.76613 6.69018433,14.9469976 C6.73749792,14.760906 6.70865434,14.624405 6.80176344,14.5003017 L6.80176344,14.5373682 C7.02542767,14.9840642 7.2488389,15.4307601 7.47199711,15.8773296 C7.96815726,16.6759678 8.84826592,17.5111665 9.59415073,18.0739958 C9.98037636,18.3659737 10.2848785,18.8709894 10.7852134,19.0419002 L10.7852134,19.0040746 L10.7478939,19.0040746 C10.6504835,18.8536579 10.4989282,18.790531 10.3759635,18.6694638 C10.0844916,18.3836847 9.76050733,18.0287063 9.51938514,17.7014329 C8.84080201,16.780589 8.24153872,15.7725818 7.69553484,14.7235864 C7.43455106,14.2224925 7.20785066,13.6697838 6.98785512,13.1600874 C6.90322199,12.9633691 6.90423404,12.6662043 6.72737736,12.5643663 C6.48650818,12.9378147 6.13190928,13.2401663 5.94556458,13.6811694 C5.64776729,14.386319 5.60943569,15.2461865 5.49899515,16.1379338 C5.43371758,16.1614641 5.46268766,16.1453977 5.42422956,16.1750003 C4.90555118,16.0502645 4.72350772,15.5164053 4.53096418,15.0584502 C4.04378602,13.9006589 3.95333357,12.0360734 4.38206553,10.7030699 C4.4930121,10.3583386 4.99499157,9.27202362 4.79131543,8.95347919 C4.69441112,8.63544079 4.37510765,8.45187925 4.19635337,8.20885945 C3.97420721,7.90853201 3.75332613,7.5134509 3.59974672,7.16644241 C3.20150293,6.26368901 3.01528474,5.25024206 2.59540827,4.33749461 C2.39451528,3.90142525 2.0550972,3.45966308 1.77627595,3.07166635 C1.46759906,2.64204884 1.12185564,2.32578153 0.882884062,1.80583808 C0.797744903,1.62126448 0.681991069,1.32587082 0.808244978,1.13598393 C0.848094658,1.00783242 0.905022773,0.954446496 1.03190922,0.912572704 C1.24810955,0.746089595 1.84889092,0.967982736 2.07394674,1.06147135 C2.67055338,1.30929841 3.16924367,1.54548684 3.67489184,1.88035066 C3.91740561,2.04126747 4.16295554,2.35272751 4.45607208,2.43887872 L4.79118892,2.43887872 C5.31568662,2.5591868 5.90280525,2.47645128 6.39200751,2.62509691 C7.25744137,2.8881048 8.0329288,3.29722819 8.73719284,3.74202653 C10.8826237,5.09653615 12.6370217,7.02526068 13.8370664,9.32578906 C14.030116,9.69620133 14.1138635,10.0496617 14.2836358,10.4427187 C14.6265961,11.2350315 15.0591233,12.0501156 15.4004389,12.825097 C15.7408691,13.5978013 16.0728232,14.3779695 16.5541821,15.0213837 C16.8071959,15.3594102 17.7850944,15.5408211 18.2297663,15.7288104 C18.5412263,15.8602511 19.0514287,15.9976376 19.3460633,16.1750003 C19.9100312,16.5151775 20.4556556,16.9197466 20.9842015,17.292183 C21.2483479,17.4785277 22.0606489,17.886639 22.1006251,18.2223884 C20.7916579,18.1877255 19.7916207,18.3092986 18.9366869,18.6695903 C18.6936671,18.7716814 18.3064295,18.7747176 18.2664533,19.0787137 C18.4000446,19.2186304 18.4211712,19.4281259 18.527437,19.6000488 C18.7309867,19.9304848 19.0755915,20.3728795 19.3833829,20.6053993 C19.7195118,20.8590456 20.0657612,21.130403 20.4255469,21.3498925 C21.0663045,21.7407989 21.7818276,21.9638306 22.3984224,22.3551165 C22.7632683,22.5861182 23.1241926,22.8764515 23.478665,23.1369293 L23.478665,23.1369293 Z"
                }
            }
        ]
    })(props);
}
function GrNavigate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M20,11 L22,8 L20,5 L12,5 L12,11 L20,11 Z M12,24 L12,0 M4,2 L2,5 L4,8 L12,8 L12,2 L4,2 Z"
                }
            }
        ]
    })(props);
}
function GrNetworkDrive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeWidth": "2",
                    "d": "M12 14v4M22 6v6a1 1 0 01-1 1H3a1 1 0 01-1-1V6a1 1 0 011-1h18a1 1 0 011 1zM12 21a2 2 0 100-4 2 2 0 000 4zM6 10a1 1 0 100-2 1 1 0 000 2z"
                }
            }
        ]
    })(props);
}
function GrNetwork(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M7.5,7 L7.5,15.5142857 C7.5,19.7571429 13,18.3428571 13,22.1142857 L13,24 M11,10 L7.5,7 L4,10 M16.5,2 L16.5,10.440516 C16.5,14.5083612 13,13.1524128 13,16.7682752 L13,24 M13,5 L16.5,2 L20,5"
                }
            }
        ]
    })(props);
}
function GrNewWindow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M11,9 L19,9 M15,13 L15,5 M17,17 L17,23 L1,23 L1,7 L1,7 L7,7 M7,1 L23,1 L23,17 L7,17 L7,1 Z"
                }
            }
        ]
    })(props);
}
function GrNew(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,1 L12,23 M2,6 L22,18 M22.0000001,6 L2.00000008,18"
                }
            }
        ]
    })(props);
}
function GrNext(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "points": "7 2 17 12 7 22"
                }
            }
        ]
    })(props);
}
function GrNode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.8988601,24 C11.5774615,24 11.2582643,23.9156879 10.9764902,23.7534477 L8.04053599,22.0152536 C7.60202502,21.7700221 7.81599724,21.6832885 7.96062661,21.6333176 C8.54530789,21.4285911 8.66396121,21.3823625 9.28804684,21.0279435 C9.35364738,20.9905204 9.43950043,21.0037286 9.50664192,21.043353 L11.7621556,22.3817801 C11.843606,22.4258073 11.9591774,22.4258073 12.034684,22.3817801 L20.8291183,17.3054433 C20.9105686,17.2592148 20.9634012,17.1645563 20.9634012,17.0676964 L20.9634012,6.91942563 C20.9634012,6.81816306 20.9105686,6.72790729 20.8273572,6.677276 L12.0364451,1.60534197 C11.9549948,1.55691204 11.8471281,1.55691204 11.7656778,1.60534197 L2.97652685,6.677276 C2.89133421,6.72570593 2.83718075,6.82036442 2.83718075,6.91722427 L2.83718075,17.0654951 C2.83718075,17.1623549 2.89001339,17.254812 2.97366508,17.3010406 L5.3819532,18.6923003 C6.6895612,19.3461043 7.48865497,18.5756282 7.48865497,17.8007494 L7.48865497,7.78456021 C7.48865497,7.64147179 7.60092434,7.53140378 7.74401276,7.53140378 L8.85790105,7.53140378 C8.99658675,7.53140378 9.11105748,7.64147179 9.11105748,7.78456021 L9.11105748,17.8051521 C9.11105748,19.5486294 8.16006985,20.5502483 6.50684829,20.5502483 C5.99833407,20.5502483 5.59768651,20.5502483 4.4793955,19.9999083 L2.17236995,18.6702867 C1.60221764,18.3400826 1.25,17.7237018 1.25,17.0654951 L1.25,6.91722427 C1.25,6.25681619 1.60221764,5.64043532 2.17236995,5.314634 L10.9756096,0.236095888 C11.5325538,-0.0786986292 12.2722108,-0.0786986292 12.8247522,0.236095888 L21.6169851,5.31683536 C22.184936,5.64483804 22.539355,6.25901755 22.539355,6.91942563 L22.539355,17.0676964 C22.539355,17.7259031 22.184936,18.3400826 21.6169851,18.6702867 L12.8247522,23.7488248 C12.5429781,23.9117255 12.2237809,23.9953771 11.8979796,23.9953771 L11.8988601,24 Z M14.6153387,17.007159 C10.7673609,17.007159 9.9605624,15.2407875 9.9605624,13.7592721 C9.9605624,13.618385 10.0741526,13.5061157 10.2152598,13.5061157 L11.3511617,13.5061157 C11.4766392,13.5061157 11.5823045,13.5974721 11.6021167,13.7214087 C11.7738228,14.8788839 12.2845384,15.4626847 14.6113762,15.4626847 C16.4649216,15.4626847 17.2530085,15.0439859 17.2530085,14.0610786 C17.2530085,13.495329 17.0284698,13.0748692 14.1490906,12.7930951 C11.7408024,12.5553482 10.2526829,12.0248203 10.2526829,10.0986301 C10.2526829,8.32433374 11.7496079,7.26768082 14.2569572,7.26768082 C17.072497,7.26768082 18.4681594,8.24508478 18.6442682,10.3451825 C18.6508723,10.4178273 18.624456,10.4882709 18.576026,10.5411035 C18.5275961,10.5917348 18.4593539,10.6225539 18.3889104,10.6225539 L17.2464044,10.6225539 C17.127531,10.6225539 17.0240671,10.5389022 16.9998521,10.4244314 C16.7246821,9.20707921 16.0598713,8.81743844 14.2525545,8.81743844 C12.2295044,8.81743844 11.9939589,9.52187372 11.9939589,10.0502002 C11.9939589,10.690796 12.2713303,10.8779116 15.001017,11.2389347 C17.7042874,11.5977564 18.9876804,12.1040693 18.9876804,14.0038432 C18.9876804,15.9190266 17.3894929,17.0175054 14.6025708,17.0175054 L14.6153387,17.007159 Z"
                }
            }
        ]
    })(props);
}
function GrNodes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M14,4 C14,5.1048 13.1048,6 12,6 C10.8952,6 10,5.1048 10,4 C10,2.8952 10.8952,2 12,2 C13.1048,2 14,2.8952 14,4 Z M14,20 C14,21.1048 13.1048,22 12,22 C10.8952,22 10,21.1048 10,20 C10,18.8952 10.8952,18 12,18 C13.1048,18 14,18.8952 14,20 Z M7,8 C7,9.1048 6.1048,10 5,10 C3.8952,10 3,9.1048 3,8 C3,6.8952 3.8952,6 5,6 C6.1048,6 7,6.8952 7,8 Z M7,16 C7,17.1048 6.1048,18 5,18 C3.8952,18 3,17.1048 3,16 C3,14.8952 3.8952,14 5,14 C6.1048,14 7,14.8952 7,16 Z M21,8 C21,9.1048 20.1048,10 19,10 C17.8952,10 17,9.1048 17,8 C17,6.8952 17.8952,6 19,6 C20.1048,6 21,6.8952 21,8 Z M21,16 C21,17.1048 20.1048,18 19,18 C17.8952,18 17,17.1048 17,16 C17,14.8952 17.8952,14 19,14 C20.1048,14 21,14.8952 21,16 Z"
                }
            }
        ]
    })(props);
}
function GrNorton(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.9101215,0.816194332 L22.7068826,0.816194332 L22.7068826,1.61295547 L21.9101215,1.61295547 L21.9101215,0.816194332 Z M21.9101215,1.61295547 L20.4331984,1.61295547 L20.4331984,2.4097166 L21.9101215,2.4097166 L21.9101215,1.61295547 Z M20.4331984,2.4097166 L20.4331984,3.96437247 L19.6947368,3.96437247 L19.6947368,2.4097166 L20.4331984,2.4097166 Z M20.4331984,3.96437247 L21.1910931,3.96437247 L21.1910931,4.72226721 L20.4331984,4.72226721 L20.4331984,3.96437247 Z M21.1910931,3.96437247 L21.1910931,3.21619433 L22.0267206,3.21619433 L22.0267206,3.96437247 L21.1910931,3.96437247 Z M20.4331984,4.72226721 L20.4331984,6.33522267 L19.7821862,6.33522267 L19.7821862,6.96680162 L19.0923077,6.96680162 L19.0923077,7.88987854 L18.4995951,7.88987854 L18.4995951,8.67692308 L17.7417004,8.67692308 L17.7417004,7.89959514 L16.9838057,7.89959514 L16.9740891,8.67692308 L17.7417004,8.67692308 L17.7417004,9.50283401 L16.9838057,9.50283401 L16.9935223,10.4064777 L16.3425101,10.4064777 L16.3522267,11.1643725 L15.7497976,11.1643725 L15.740081,12.0194332 C14.6042656,13.6541793 13.8165786,15.3703291 13.1068826,17.0817814 C13.0166656,17.2993424 12.9843157,17.4767392 12.8736842,17.6064777 C12.6350495,17.886327 12.2792569,17.974147 11.9894737,17.9659919 C11.4470717,17.9507255 10.9697158,17.6983044 10.7165992,17.1109312 C9.86728944,15.1400551 9.44710048,13.7603465 7.11174089,11.1740891 C6.73552723,10.7574572 6.82323501,10.2253563 7.12145749,10.0566802 C7.40843204,9.89436507 7.80877956,10.0107768 8.2582996,10.2607287 C9.51609859,10.9601153 10.2158747,11.6755026 11.7076923,13.6615385 C12.2511882,12.3496564 13.19015,10.5765708 14.3603239,8.65748988 L14.9044534,8.65748988 L14.9044534,7.89959514 L15.4194332,7.89959514 L15.4194332,7.151417 L16.1773279,7.151417 L16.1773279,5.9562753 L16.9935223,5.9562753 L16.9838057,6.71417004 L17.7417004,6.71417004 L17.7417004,5.9562753 L16.9935223,5.9562753 L16.9935223,5.27611336 L17.6736842,5.27611336 L17.6736842,4.72226721 L18.9271255,4.72226721 L18.9271255,5.49959514 L19.6947368,5.49959514 L19.6947368,4.72226721 L20.4331984,4.72226721 Z M18.9271255,4.72226721 L18.9271255,3.96437247 L19.6947368,3.96437247 L19.6947368,4.72226721 L18.9271255,4.72226721 Z M18.9271255,3.96437247 L18.1595142,3.96437247 L18.1595142,3.23562753 L18.9271255,3.23562753 L18.9271255,3.96437247 Z M20.4331999,2.41353172 L21.1897089,2.41353172 L21.1897089,3.21168583 L20.4331999,3.21168583 L20.4331999,2.41353172 Z M22.7027248,1.61537762 L23.5216979,1.61537762 L23.5216979,2.41353172 L22.7027248,2.41353172 L22.7027248,1.61537762 Z M16.5465587,4.54360314 L16.5465587,5.28582996 L15.6137652,5.28582996 L15.6137652,6.52955466 L14.6809717,6.52955466 L14.6809717,7.26441847 C13.6908876,6.74537522 12.5637461,6.45182186 11.3676113,6.45182186 C7.42126355,6.45182186 4.21619433,9.64716515 4.21619433,13.5935223 C4.21619433,17.5398576 7.42126355,20.7352227 11.3676113,20.7352227 C15.3139591,20.7352227 18.5093117,17.5398576 18.5093117,13.5935223 C18.5093117,12.3895534 18.2119011,11.2554858 17.6864896,10.2607287 L18.4121457,10.2607287 L18.4121457,9.32793522 L19.0340081,9.32793522 L19.0340081,8.3951417 L19.6558704,8.3951417 L19.6558704,7.61781377 L19.9265337,7.61781377 C21.1151026,9.30906076 21.8129555,11.3700091 21.8129555,13.5935223 C21.8129555,19.3395646 17.1525368,24 11.4064777,24 C5.66041864,24 1,19.3395646 1,13.5935223 C1,7.84746131 5.66041864,3.18704453 11.4064777,3.18704453 C13.2757551,3.18704453 15.0301395,3.68025475 16.5465587,4.54360314 L16.5465587,4.54360314 Z M22.7027248,0 L23.5216979,0 L23.5216979,0.817223514 L22.7027248,0.817223514 L22.7027248,0 Z"
                }
            }
        ]
    })(props);
}
function GrNote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,23 L16,23 L23,16 L23,1 L1,1 L1,23 Z M15,23 L15,15 L23,15"
                }
            }
        ]
    })(props);
}
function GrNotes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M3,1 L3,23 L16,23 L21,18 L21,1 L3,1 Z M6,17 L11,17 M6,13 L18,13 M6,9 L16,9 M3,5 L21,5 M21,17 L15,17 L15,23"
                }
            }
        ]
    })(props);
}
function GrNotification(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4,19 L4,9 C4,4.582 7.582,1 12,1 C16.418,1 20,4.582 20,9 L20,19 M1,19 L23,19 M15,19 L15,20 C15,21.657 13.657,23 12,23 C10.343,23 9,21.657 9,20 L9,19"
                }
            }
        ]
    })(props);
}
function GrNpm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none",
                    "fillRule": "evenodd"
                },
                "child": [
                    {
                        "tag": "rect",
                        "attr": {
                            "width": "24",
                            "height": "24"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M16.7179487,7.92840493 L12.2051282,7.92840493 L12.2051282,20.2494172 L4,20.2494172 L4,3 L12.2051282,3 L20,3 L20,7.92840493 L20,20.2494172 L16.7179487,20.2494172 L16.7179487,7.92840493 Z"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function GrObjectGroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,1 L4,1 L4,4 L1,4 L1,1 Z M20,1 L23,1 L23,4 L20,4 L20,1 Z M4,2 L20,2 M4,22 L20,22 M1,20 L4,20 L4,23 L1,23 L1,20 Z M20,20 L23,20 L23,23 L20,23 L20,20 Z M2,4 L2,20 M22,4 L22,20 M7,7 L14,7 L14,13 L7,13 L7,7 Z M17,10 L17,17 L10,17 L10,15"
                }
            }
        ]
    })(props);
}
function GrObjectUngroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,1 L4,1 L4,4 L1,4 L1,1 Z M13,1 L16,1 L16,4 L13,4 L13,1 Z M4,2 L13,2 M15,9 L20,9 M4,15 L13,15 M1,13 L4,13 L4,16 L1,16 L1,13 Z M13,13 L16,13 L16,16 L13,16 L13,13 Z M2,4 L2,13 M15,4 L15,13 M20,8 L23,8 L23,11 L20,11 L20,8 Z M11,22 L20,22 M8,20 L11,20 L11,23 L8,23 L8,20 Z M20,20 L23,20 L23,23 L20,23 L20,20 Z M9,16 L9,20 M22,11 L22,20"
                }
            }
        ]
    })(props);
}
function GrOfflineStorage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,21 C15.5230211,21 18.5732537,18.9757518 20.0510587,16.0268945 C20.6582603,14.8152657 21,13.4475416 21,12 C21,10.5673224 20.6652426,9.21283165 20.0696798,8.01047964 C18.5989839,5.04136538 15.5378852,3 12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 Z M20,9 L12,9 C10.3431458,9 9,10.3431458 9,12 C9,13.6568542 10.3431458,15 12,15 L20,15"
                }
            }
        ]
    })(props);
}
function GrOnedrive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M21.6924215,13.986674 C22.9997233,14.1908343 24,15.3216239 24,16.6862741 C24,17.7522298 23.3892094,18.6751163 22.4988002,19.1254521 C22.4321553,19.1592575 22.3639409,19.1904067 22.294157,19.2186583 L8.59404885,19.2186583 L8.59404885,19.2181754 C6.85476268,19.2073094 5.44797646,17.7943658 5.44797646,16.0524235 C5.44797646,14.3037201 6.86550796,12.8860679 8.61421133,12.8860679 C8.70222602,12.8860679 8.78903338,12.8906557 8.87511633,12.8976583 C8.87028699,12.8172498 8.86702719,12.7364791 8.86702719,12.6548633 C8.86702719,10.4662072 10.6413261,8.69190834 12.8299821,8.69190834 C14.3676434,8.69190834 15.6998164,9.5683125 16.3568479,10.8482079 C16.9002691,10.4918027 17.5498151,10.283779 18.2483789,10.283779 C20.1559675,10.283779 21.7023216,11.8301331 21.7023216,13.7377217 C21.7023216,13.8215107 21.6982167,13.9043338 21.6924215,13.986674 Z M8.18741857,12.2086324 C6.25507961,12.421727 4.74711875,14.0641849 4.74711875,16.0524235 C4.74711875,16.8619413 4.9992102,17.6150766 5.42841764,18.2378198 L3.27887919,18.2378198 C1.46799809,18.2378198 -1.77635684e-15,16.7698217 -1.77635684e-15,14.9589406 C-1.77635684e-15,13.2281057 1.34134869,11.8115401 3.04103428,11.6894786 C2.98428956,11.4324371 2.95350253,11.1656161 2.95350253,10.8915512 C2.95350253,8.85248384 4.60646427,7.19964283 6.64541087,7.19964283 C7.40977438,7.19964283 8.11980783,7.43181327 8.70886636,7.82963 C9.54542848,6.15252157 11.276867,5 13.2783862,5 C15.9223281,5 18.0967377,7.01021204 18.3569183,9.58557738 C18.3206982,9.58461151 18.2847197,9.58292125 18.2483789,9.58292125 C17.6798451,9.58292125 17.1232638,9.6982217 16.6079734,9.92012979 C15.7386926,8.71545137 14.3462736,7.99105063 12.8299821,7.99105063 C10.4089142,7.99105063 8.41282793,9.84563725 8.18741857,12.2086324 Z"
                }
            }
        ]
    })(props);
}
function GrOpera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.124775,0 C5.56831311,0 1,4.75571037 1,11.888501 C1,18.2355851 5.43849706,24 12.1251037,24 C18.8774638,24 23.3506693,18.2369941 23.3506693,11.888501 C23.3506223,4.69859883 18.621683,0 12.124775,0 L12.124775,0 Z M12.1251037,21.3207828 C11.5820274,21.3207828 11.1100117,21.2149198 10.6996164,21.0221213 C9.55884149,20.4469667 8.87181213,19.1728532 8.46982387,17.6127593 C8.03491194,15.803319 7.98578474,13.6079061 7.98578474,11.6864031 C7.98578474,8.2547319 8.23625832,5.15403523 9.63680626,3.60648141 C10.2479843,2.95679061 11.0537456,2.57222701 12.1121409,2.56936204 C12.1165088,2.56936204 12.1208767,2.5689863 12.1250098,2.5689863 C13.5037182,2.5689863 14.4704814,3.24413307 15.1409315,4.30276321 C16.1404305,5.99107632 16.3679843,8.72707632 16.3679843,11.6711389 C16.3680783,15.8502857 16.0902701,21.3207828 12.1251037,21.3207828 L12.1251037,21.3207828 Z"
                }
            }
        ]
    })(props);
}
function GrOptimize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2,22 L6,22 L6,18 L2,18 L2,22 Z M22,2 L12,12 M22,10 L22,2 L14,2 M22,13 L18,13 L18,22 L22,22 L22,13 Z M10,22 L14,22 L14,16 L10,16 L10,22 Z"
                }
            }
        ]
    })(props);
}
function GrOracle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M7.957359,18.9123664 C4.11670252,18.9123664 1,15.803458 1,11.9617373 C1,8.12000773 4.11670252,5 7.957359,5 L16.0437948,5 C19.8855156,5 23,8.12000773 23,11.9617373 C23,15.803458 19.8855156,18.9123664 16.0437948,18.9123664 L7.957359,18.9123664 L7.957359,18.9123664 Z M15.8639176,16.4585488 C18.352201,16.4585488 20.3674397,14.448858 20.3674397,11.9617373 C20.3674397,9.47460595 18.352201,7.45381934 15.8639176,7.45381934 L8.1360824,7.45381934 C5.64895285,7.45381934 3.63255855,9.47460595 3.63255855,11.9617373 C3.63255855,14.448858 5.64895285,16.4585488 8.1360824,16.4585488 L15.8639176,16.4585488 L15.8639176,16.4585488 Z"
                }
            }
        ]
    })(props);
}
function GrOrderedList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "5.77",
                    "y": "6.42",
                    "width": "18.06",
                    "height": "1.75"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "5.77",
                    "y": "11.71",
                    "width": "18.06",
                    "height": "1.75"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "5.77",
                    "y": "16.99",
                    "width": "18.06",
                    "height": "1.75"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.13,4.87V8a2,2,0,0,0,0,.45.3.3,0,0,0,.13.16.62.62,0,0,0,.32.06H3.7v.11h-2V8.71h.1a.79.79,0,0,0,.35-.06.29.29,0,0,0,.14-.16A1.75,1.75,0,0,0,2.3,8V6a1.28,1.28,0,0,0,0-.33.24.24,0,0,0-.1-.11.28.28,0,0,0-.16,0,.91.91,0,0,0-.35.09l-.05-.1L3,4.87Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.65,14.3H1.37v-.06a12.51,12.51,0,0,0,1.27-1.67,1.81,1.81,0,0,0,.22-.84.7.7,0,0,0-.18-.5.6.6,0,0,0-.45-.2.75.75,0,0,0-.68.44l-.11,0a1.58,1.58,0,0,1,.47-.81,1.09,1.09,0,0,1,.72-.26,1.06,1.06,0,0,1,.54.14,1,1,0,0,1,.38.37.9.9,0,0,1,.14.45,1.6,1.6,0,0,1-.21.77,7.28,7.28,0,0,1-1.25,1.47h.83a1.87,1.87,0,0,0,.4,0,.33.33,0,0,0,.15-.09,1.16,1.16,0,0,0,.16-.26h.1Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.09,18v-.1a1.88,1.88,0,0,0,.45-.17.67.67,0,0,0,.22-.25.69.69,0,0,0,.09-.34.55.55,0,0,0-.17-.41.58.58,0,0,0-.43-.17.8.8,0,0,0-.68.42l-.11,0A1.72,1.72,0,0,1,2,16.19a1.16,1.16,0,0,1,.71-.24.93.93,0,0,1,.66.24.76.76,0,0,1,.26.57.78.78,0,0,1-.12.41,1,1,0,0,1-.38.35,1.34,1.34,0,0,1,.51.4,1,1,0,0,1,.17.6,1.38,1.38,0,0,1-.44,1A1.62,1.62,0,0,1,2.2,20a1.24,1.24,0,0,1-.71-.16.34.34,0,0,1-.16-.29.32.32,0,0,1,.31-.32.41.41,0,0,1,.18,0l.32.25a.84.84,0,0,0,.52.23A.47.47,0,0,0,3,19.55a.61.61,0,0,0,.15-.42,1.1,1.1,0,0,0-.27-.72A1.42,1.42,0,0,0,2.09,18Z"
                }
            }
        ]
    })(props);
}
function GrOrganization(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M20,3 L20,23 L4,23 L4,3 L20,3 Z M8.042,9 L10.042,9 L10.042,7 L8.042,7 L8.042,9 Z M14,9 L16,9 L16,7 L14,7 L14,9 Z M8.042,15 L10.042,15 L10.042,13 L8.042,13 L8.042,15 Z M10.042,23 L14.042,23 L14.042,19 L10.042,19 L10.042,23 Z M14,15 L16,15 L16,13 L14,13 L14,15 Z M2,3 L22,3 L22,1 L2,1 L2,3 Z"
                }
            }
        ]
    })(props);
}
function GrOverview(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M18.5,21 C20.9852814,21 23,18.9852814 23,16.5 C23,14.0147186 20.9852814,12 18.5,12 C16.0147186,12 14,14.0147186 14,16.5 C14,18.9852814 16.0147186,21 18.5,21 L18.5,21 Z M10,7 L14,7 M1.5,14.5 C1.5,14.5 5.5,5 6,4 C6.5,3 7.5,3 8,3 C8.5,3 10,3 10,5 L10,16 M5.5,21 C3.01471863,21 1,18.9852814 1,16.5 C1,14.0147186 3.01471863,12 5.5,12 C7.98528137,12 10,14.0147186 10,16.5 C10,18.9852814 7.98528137,21 5.5,21 L5.5,21 L5.5,21 Z M22.5,14.5 C22.5,14.5 18.5,5 18,4 C17.5,3 16.5,3 16,3 C15.5,3 14,3 14,5 L14,16 M10,16 L14,16"
                }
            }
        ]
    })(props);
}
function GrPackage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.3714 0.571408L12 0.422852L11.6286 0.571408L1.62861 4.57141L1 4.82285V5.49988V18.4999V19.1769L1.62861 19.4284L11.6286 23.4284L12 23.5769L12.3714 23.4284L22.3714 19.4284L23 19.1769V18.4999V5.49988V4.82285L22.3714 4.57141L12.3714 0.571408ZM3 6.97692V17.8229L11 21.0229V10.1769L3 6.97692ZM13 10.1769V21.0229L21 17.8229V6.97692L13 10.1769ZM19.3074 5.49988L12 2.57692L9.94258 3.39988L17.25 6.32285L19.3074 5.49988ZM4.69258 5.49988L7.25 4.47692L14.5574 7.39988L12 8.42285L4.69258 5.49988Z"
                }
            }
        ]
    })(props);
}
function GrPaint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4,10 L2,10 C2,4.4771525 2,1 12,1 C22,1 22,4.4771525 22,10 L20,10 M12,10 C16.418278,10 20,9.1045695 20,8 C20,6.8954305 16.418278,6 12,6 C7.581722,6 4,6.8954305 4,8 C4,9.1045695 7.581722,10 12,10 Z M4,20 C4,21.6568542 7.581722,23 12,23 C16.418278,23 20,21.6568542 20,20 M20,8 L20,20 L20,8 Z M4,20 L4,8 L4,20 Z M8,13 L8,17 M13,13 L13,17 M7,12 C5.5,12 4,11 4,8 M18,13.5 C18,13.5 18,14 18,12 C18,10 20,11 20,8 M8,13 C8,12.4477153 7.55228475,12 7,12 M13,13 C13,12.4477153 13.4477153,12 14,12 C14.5522847,12 15,12.4477153 15,13 L15,13.5 M15,13.5 C15,14.3284271 15.6715729,15 16.5,15 C17.3284271,15 18,14.3284271 18,13.5 M8,17 C8,18.3807119 9.11928813,19.5 10.5,19.5 C11.8807119,19.5 13,18.3807119 13,17"
                }
            }
        ]
    })(props);
}
function GrPan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M8.5,5.5 L12,2 L15.5,5.5 M22,12 L2,12 M5.5,8.5 L2,12 L5.5,15.5 M18.5,15.5 L22,12 L18.5,8.5 M12,22 L12,2 M8.5,18.5 L12,22 L15.5,18.5"
                }
            }
        ]
    })(props);
}
function GrPauseFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M3,21 L9,21 L9,3 L3,3 L3,21 Z M4,19 L8,19 L8,5 L4,5 L4,19 Z M5,17 L7,17 L7,7 L5,7 L5,17 Z M15,21 L21,21 L21,3 L15,3 L15,21 Z M16,19 L20,19 L20,5 L16,5 L16,19 Z M17,17 L19,17 L19,7 L17,7 L17,17 Z"
                }
            }
        ]
    })(props);
}
function GrPause(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M3,21 L9,21 L9,3 L3,3 L3,21 Z M15,21 L21,21 L21,3 L15,3 L15,21 Z"
                }
            }
        ]
    })(props);
}
function GrPaypal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M21.4945038,7.054125 C20.4250038,12.026625 17.0155038,14.658375 11.6050038,14.658375 L9.64300376,14.658375 L8.17975376,24.000375 L11.3620038,24.000375 C11.8217538,24.000375 12.2125038,23.665875 12.2845038,23.212125 L12.3220038,23.014125 L13.0540038,18.377625 L13.1012538,18.121875 C13.1725038,17.668125 13.5640038,17.333625 14.0230038,17.333625 L14.6042538,17.333625 C18.3640038,17.333625 21.3085038,15.805875 22.1687538,11.388375 C22.5137538,9.615375 22.3480038,8.128875 21.4945038,7.054125 M19.3172538,1.80975 C18.2057538,0.543 16.1972538,0 13.6270038,0 L6.16900376,0 C5.64325376,0 5.19625376,0.3825 5.11375376,0.90075 L2.00800376,20.59725 C1.94650376,20.98575 2.24725376,21.3375 2.64100376,21.3375 L7.24525376,21.3375 L8.40175376,14.0025 L8.36575376,14.232 C8.44825376,13.71375 8.89225376,13.33125 9.41725376,13.33125 L11.6050038,13.33125 C15.9040038,13.33125 19.2692538,11.58525 20.2525038,6.53475 C20.2817538,6.38475 20.3290038,6.0975 20.3290038,6.0975 C20.6080038,4.2285 20.3267538,2.96025 19.3172538,1.80975"
                }
            }
        ]
    })(props);
}
function GrPerformance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "2",
                    "d": "M12,19 L10,22 L7,21 L6.5,17.5 L3,17 L2,14 L5,12 L2,10 L3,7 L6.5,6.5 L7,3 L10,2 L12,5 L14,2 L17,3 L17.5,6.5 L21,7 L22,10 L19,12 L22,14 L21,17 L17.5,17.5 L17,21 L14,22 L12,19 Z M12,16 C14.209139,16 16,14.209139 16,12 C16,9.790861 14.209139,8 12,8 C9.790861,8 8,9.790861 8,12 C8,14.209139 9.790861,16 12,16 Z"
                }
            }
        ]
    })(props);
}
function GrPersonalComputer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M3,18 L21,18 L21,5 L21,5 C21,4.44771525 20.5522847,4 20,4 L4,4 L4,4 C3.44771525,4 3,4.44771525 3,5 L3,18 Z M2,20 L22,20 C23,20 23,19 23,19 L1,19 C1,19 1,20 2,20 Z"
                }
            }
        ]
    })(props);
}
function GrPhoneFlip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8 1C7.5911 1 7.22339 1.24895 7.07152 1.62861L3.07152 11.6286C2.97616 11.867 2.97616 12.133 3.07152 12.3714L7.07152 22.3714C7.22339 22.751 7.5911 23 8 23H18C18.3318 23 18.642 22.8354 18.8281 22.5606C19.0141 22.2859 19.0517 21.9367 18.9285 21.6286L15.077 12L18.9285 2.37139C19.0517 2.0633 19.0141 1.71414 18.8281 1.43937C18.642 1.1646 18.3318 1 18 1H8ZM5.47703 11L8.67703 3H11.4706C11.47 3.53001 11.8983 4 12.4715 4H12.5285C12.9453 4 13.3185 3.74143 13.4648 3.35112C13.5087 3.23406 13.5293 3.1156 13.5294 3H16.523L13.323 11H5.47703ZM5.47703 13L8.67703 21H16.523L13.323 13H5.47703ZM11.0352 19.773C10.79 19.1192 11.2733 18.4219 11.9715 18.4219H12.0285C12.4453 18.4219 12.8185 18.6804 12.9648 19.0708C13.21 19.7245 12.7267 20.4219 12.0285 20.4219H11.9715C11.5547 20.4219 11.1815 20.1633 11.0352 19.773Z"
                }
            }
        ]
    })(props);
}
function GrPhoneHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M23 7C23 5.89543 22.1046 5 21 5H3C1.89543 5 1 5.89543 1 7V17C1 18.1046 1.89543 19 3 19H21C22.1046 19 23 18.1046 23 17V7ZM21 12.9957V17H3V7H21V11.0043C20.9691 11.0015 20.9379 11 20.9062 11H19.9062C19.354 11 18.9062 11.4477 18.9062 12C18.9062 12.5523 19.354 13 19.9062 13H20.9062C20.9379 13 20.9691 12.9985 21 12.9957Z"
                }
            }
        ]
    })(props);
}
function GrPhoneVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M17 23C18.1046 23 19 22.1046 19 21L19 3C19 1.89543 18.1046 1 17 1L7 0.999999C5.89543 0.999999 5 1.89543 5 3L5 21C5 22.1046 5.89543 23 7 23L17 23ZM11.0005 21L7 21L7 3L17 3L17 21L12.9995 21C12.9998 20.9896 13 20.9792 13 20.9687L13 19.9687C13 19.4165 12.5523 18.9687 12 18.9687C11.4477 18.9687 11 19.4165 11 19.9687L11 20.9687C11 20.9792 11.0002 20.9896 11.0005 21Z"
                }
            }
        ]
    })(props);
}
function GrPhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M6.375,2 C5,2 3,3.5 2.5,4.5 C1.78539513,5.92920973 1.9033374,6.49067969 2.375,8 C3,10 4.83244154,13.545116 7.375,16 C11,19.5 14.375,21 15.875,21.5 C17.375,22 19,21.5 20,20.5 C21,19.5 22,18.5 20.875,17 C20.077805,15.9370734 18.9164827,14.7082413 17.5,14 C16.2120164,13.3560082 15.444427,13.5904184 15,14.5 C14.7543142,15.0028302 14.6780041,15.9659877 14.5,16.5 C14.2754227,17.173732 13.375,17 12.375,16.5 C11.4176235,16.0213117 9,14 7,11 C5.76086515,9.14129772 7.74150655,9.12924672 9,8.5 C10,8 10.3099909,6.84998476 9.5,5.5 C8,3 7.5,2 6.375,2 Z"
                }
            }
        ]
    })(props);
}
function GrPieChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M10,23 C5.02943725,23 1,18.9705627 1,14 C1,9.02943725 5.02943725,5 10,5 L10,14 C10,14 10.7746374,14.7746374 11.1619561,15.1619561 L16.363961,20.363961 C14.7352814,21.9926407 12.4852814,23 10,23 Z M14,10 L14,1 C18.9705627,1 23,5.02943725 23,10 L14,10 Z M14,13 L22,13 C22,15.2037225 21.2079601,17.2224541 19.8930183,18.7870568 L14,13 Z"
                }
            }
        ]
    })(props);
}
function GrPiedPiper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M0,19.4210526 C2.2736843,19.4210526 4.04210525,18.6631579 4.04210525,18.6631579 C4.04210525,18.6631579 7.0736842,11.0842105 11.368421,11.0842105 C14.6526316,11.0842105 15.1578947,13.6105264 15.1578947,13.6105264 C15.1578947,13.6105264 19.9578947,4.26315788 24,3 C20.2105263,6.03157895 20.7157895,9.31578948 18.9473684,10.831579 C17.1789474,12.3473684 17.1789477,10.8381579 15.1578951,14.375 C10.6105267,14.8802632 9.125,16.3894739 6.06315789,18.1578947 C11.3684206,15.6315794 12.3789474,15.3789474 17.1789474,15.631579 C17.6828892,15.6581022 17.9368421,15.8842105 17.6842105,16.3894737 C16.951256,17.8553827 16.4037001,20.0617486 15.4105263,19.9263158 C9.85263157,19.1684211 6.56842104,20.431579 3.78947367,20.431579 C1.0105263,20.431579 0,19.9263158 0,19.4210526 Z"
                }
            }
        ]
    })(props);
}
function GrPin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M16,3 L10,9 C10,9 6,8 3,11 C3,11 13,21 13,21 C16,18 15,14 15,14 L21,8 L16,3 Z M1,23 L8,16 M14,1 L23,10"
                }
            }
        ]
    })(props);
}
function GrPinterest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12,0 C5.37225,0 0,5.37225 0,12 C0,17.0835 3.16275,21.426 7.62675,23.17425 C7.52175,22.22475 7.42725,20.76825 7.66875,19.73175 C7.88625,18.79575 9.07575,13.767 9.07575,13.767 C9.07575,13.767 8.7165,13.0485 8.7165,11.98575 C8.7165,10.317 9.684,9.07125 10.88775,9.07125 C11.9115,9.07125 12.4065,9.84 12.4065,10.76175 C12.4065,11.7915 11.751,13.3305 11.41275,14.757 C11.13,15.95175 12.01125,16.926 13.1895,16.926 C15.3225,16.926 16.962,14.67675 16.962,11.43075 C16.962,8.5575 14.89725,6.54825 11.949,6.54825 C8.535,6.54825 6.531,9.1095 6.531,11.75625 C6.531,12.7875 6.92775,13.89375 7.4235,14.4945 C7.52175,14.61375 7.536,14.71725 7.50675,14.83875 C7.416,15.21825 7.2135,16.03275 7.17375,16.2 C7.12125,16.419 6.99975,16.46625 6.7725,16.3605 C5.27325,15.66225 4.3365,13.4715 4.3365,11.71125 C4.3365,7.926 7.08675,4.44975 12.2655,4.44975 C16.428,4.44975 19.6635,7.416 19.6635,11.3805 C19.6635,15.516 17.05575,18.8445 13.43625,18.8445 C12.2205,18.8445 11.0775,18.21225 10.686,17.466 C10.686,17.466 10.0845,19.75725 9.93825,20.319 C9.6675,21.36075 8.93625,22.66725 8.4465,23.4645 C9.57,23.8125 10.76325,24 12,24 C18.62775,24 24,18.627 24,12 C24,5.37225 18.62775,0 12,0"
                }
            }
        ]
    })(props);
}
function GrPlan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M18,4 L18,0 L18,4 Z M7,18 L5,18 L7,18 Z M19,18 L9,18 L19,18 Z M7,14 L5,14 L7,14 Z M19,14 L9,14 L19,14 Z M6,4 L6,0 L6,4 Z M1,9 L23,9 L1,9 Z M1,23 L23,23 L23,4 L1,4 L1,23 Z"
                }
            }
        ]
    })(props);
}
function GrPlayFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M3,22.0000002 L21,12 L3,2 L3,22.0000002 Z M5,19 L17.5999998,11.9999999 L5,5 L5,19 Z M7,16 L14.1999999,12 L7,8 L7,16 Z M9,13 L10.8,12 L9,11 L9,13 Z"
                }
            }
        ]
    })(props);
}
function GrPlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "points": "3 22 21 12 3 2"
                }
            }
        ]
    })(props);
}
function GrPlug(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeWidth": "2",
                    "d": "M15 6V1m-3 23v-9M9 6V1M6 6h12v7a2 2 0 01-2 2H8a2 2 0 01-2-2V6z"
                }
            }
        ]
    })(props);
}
function GrPocket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none",
                    "fillRule": "evenodd"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M12,2 L2,2 C0.8954305,2 0,2.8954305 0,4 C0,7 0,9 0,12 C0,17.9821415 6,23 12,23 C18,23 24,17.9821415 24,12 C24,9 24,7 24,4 C24,2.8954305 23.1045695,2 22,2 L12,2 Z"
                        }
                    },
                    {
                        "tag": "polyline",
                        "attr": {
                            "strokeLinecap": "round",
                            "strokeLinejoin": "round",
                            "strokeWidth": "3",
                            "points": "6 9 12.404 15 18 9"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function GrPowerCycle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M20,8 C18.5343681,5.03213345 15.4860999,3 11.9637942,3 C7.01333514,3 3,7.02954545 3,12 M4,16 C5.4656319,18.9678666 8.51390007,21 12.0362058,21 C16.9866649,21 21,16.9704545 21,12 M9,16 L3,16 L3,22 M21,2 L21,8 L15,8"
                }
            }
        ]
    })(props);
}
function GrPowerForceShutdown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,21 C16.9705627,21 21,16.9705627 21,12 C21,7.02943725 16.9705627,3 12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 Z M12,8 L12,16"
                }
            }
        ]
    })(props);
}
function GrPowerReset(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M20,8 C18.5974037,5.04031171 15.536972,3 12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 L12,21 C16.9705627,21 21,16.9705627 21,12 M21,3 L21,9 L15,9"
                }
            }
        ]
    })(props);
}
function GrPowerShutdown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12 1L12 9M6.99426725 4.51938959C6.50550683 4.84709741 6.05064133 5.22143661 5.63603897 5.63603897 4.00735931 7.26471863 3 9.51471863 3 12 3 16.9705627 7.02943725 21 12 21 16.9705627 21 21 16.9705627 21 12 21 9.51471863 19.9926407 7.26471863 18.363961 5.63603897 17.9493587 5.22143661 17.4944932 4.84709741 17.0057327 4.51938959"
                }
            }
        ]
    })(props);
}
function GrPower(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M16,4 C19.3637732,5.43018182 22,8.98935065 22,13 C22,18.6008831 17.5273457,23 12,23 C6.47265429,23 2,18.6008831 2,13 C2,8.98935065 4.63622679,5.43018182 8,4 M12,1 L12,11"
                }
            }
        ]
    })(props);
}
function GrPrevious(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "points": "7 2 17 12 7 22",
                    "transform": "matrix(-1 0 0 1 24 0)"
                }
            }
        ]
    })(props);
}
function GrPrint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M6,19 L1,19 L1,7 L23,7 L23,19 L18,19 M3,16 L21,16 M6,16 L6,23 L6,23 L18,23 L18,16 M18,7 L18,1 L6,1 L6,7 L6,7 M17,12 L19,12 L19,11 L17,11 L17,12 Z"
                }
            }
        ]
    })(props);
}
function GrProductHunt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M13.59975,8.4 L13.59975,8.4 L10.2,8.4 L10.2,12 L13.59975,12 C14.59425,12 15.39975,11.19375 15.39975,10.2 C15.39975,9.20625 14.59425,8.4 13.59975,8.4 M13.59975,14.4 L13.59975,14.4 L10.2,14.4 L10.2,18 L7.8,18 L7.8,6 L13.59975,6 C15.9195,6 17.79975,7.88025 17.79975,10.2 C17.79975,12.51975 15.9195,14.4 13.59975,14.4 M12,0 C5.37225,0 0,5.37225 0,12 C0,18.62775 5.37225,24 12,24 C18.627,24 24,18.62775 24,12 C24,5.37225 18.627,0 12,0"
                }
            }
        ]
    })(props);
}
function GrProjects(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M9,15 L9,23 L1,23 L1,15 L9,15 Z M23,15 L23,23 L15,23 L15,15 L23,15 Z M9,1 L9,9 L1,9 L1,1 L9,1 Z M23,1 L23,9 L15,9 L15,1 L23,1 Z"
                }
            }
        ]
    })(props);
}
function GrQr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none",
                    "fillRule": "evenodd"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M13,14 L14,14 L14,15 L13,15 L13,14 Z M14,15 L15,15 L15,16 L14,16 L14,15 Z M14,16 L15,16 L15,17 L14,17 L14,16 Z M16,16 L17,16 L17,17 L16,17 L16,16 Z M16,17 L17,17 L17,18 L16,18 L16,17 Z M13,16 L14,16 L14,17 L13,17 L13,16 Z M15,16 L16,16 L16,17 L15,17 L15,16 Z M15,17 L16,17 L16,18 L15,18 L15,17 Z M18,16 L19,16 L19,17 L18,17 L18,16 Z M18,15 L19,15 L19,16 L18,16 L18,15 Z M19,14 L20,14 L20,15 L19,15 L19,14 Z M17,16 L18,16 L18,17 L17,17 L17,16 Z M17,17 L18,17 L18,18 L17,18 L17,17 Z M16,18 L17,18 L17,19 L16,19 L16,18 Z M15,18 L16,18 L16,19 L15,19 L15,18 Z M17,18 L18,18 L18,19 L17,19 L17,18 Z M18,18 L19,18 L19,19 L18,19 L18,18 Z M16,19 L17,19 L17,20 L16,20 L16,19 Z M14,19 L15,19 L15,20 L14,20 L14,19 Z M15,19 L16,19 L16,20 L15,20 L15,19 Z M13,19 L14,19 L14,20 L13,20 L13,19 Z M13,20 L14,20 L14,21 L13,21 L13,20 Z M14,21 L15,21 L15,22 L14,22 L14,21 Z M15,21 L16,21 L16,22 L15,22 L15,21 Z M17,21 L18,21 L18,22 L17,22 L17,21 Z M18,21 L19,21 L19,22 L18,22 L18,21 Z M17,19 L18,19 L18,20 L17,20 L17,19 Z M18,19 L19,19 L19,20 L18,20 L18,19 Z M19,18 L20,18 L20,19 L19,19 L19,18 Z M19,17 L20,17 L20,18 L19,18 L19,17 Z M19,20 L20,20 L20,21 L19,21 L19,20 Z M19,19 L20,19 L20,20 L19,20 L19,19 Z M20,18 L21,18 L21,19 L20,19 L20,18 Z M20,17 L21,17 L21,18 L20,18 L20,17 Z M21,20 L22,20 L22,21 L21,21 L21,20 Z M21,18 L22,18 L22,19 L21,19 L21,18 Z M21,19 L22,19 L22,20 L21,20 L21,19 Z M19,16 L20,16 L20,17 L19,17 L19,16 Z M13,17 L14,17 L14,18 L13,18 L13,17 Z M12,17 L13,17 L13,18 L12,18 L12,17 Z M12,18 L13,18 L13,19 L12,19 L12,18 Z M14,18 L15,18 L15,19 L14,19 L14,18 Z M11,18 L12,18 L12,19 L11,19 L11,18 Z M13,18 L14,18 L14,19 L13,19 L13,18 Z M11,19 L12,19 L12,20 L11,20 L11,19 Z M11,20 L12,20 L12,21 L11,21 L11,20 Z M11,1 L12,1 L12,2 L11,2 L11,1 Z M12,2 L13,2 L13,3 L12,3 L12,2 Z M11,4 L12,4 L12,5 L11,5 L11,4 Z M12,5 L13,5 L13,6 L12,6 L12,5 Z M11,6 L12,6 L12,7 L11,7 L11,6 Z M12,6 L13,6 L13,7 L12,7 L12,6 Z M12,7 L13,7 L13,8 L12,8 L12,7 Z M12,8 L13,8 L13,9 L12,9 L12,8 Z M11,9 L12,9 L12,10 L11,10 L11,9 Z M12,9 L13,9 L13,10 L12,10 L12,9 Z M11,10 L12,10 L12,11 L11,11 L11,10 Z M1,11 L2,11 L2,12 L1,12 L1,11 Z M2,12 L3,12 L3,13 L2,13 L2,12 Z M4,11 L5,11 L5,12 L4,12 L4,11 Z M4,12 L5,12 L5,13 L4,13 L4,12 Z M5,11 L6,11 L6,12 L5,12 L5,11 Z M6,12 L7,12 L7,13 L6,13 L6,12 Z M7,11 L8,11 L8,12 L7,12 L7,11 Z M8,12 L9,12 L9,13 L8,13 L8,12 Z M8,11 L9,11 L9,12 L8,12 L8,11 Z M9,11 L10,11 L10,12 L9,12 L9,11 Z M10,11 L11,11 L11,12 L10,12 L10,11 Z M11,12 L12,12 L12,13 L11,13 L11,12 Z M13,12 L14,12 L14,13 L13,13 L13,12 Z M14,11 L15,11 L15,12 L14,12 L14,11 Z M15,11 L16,11 L16,12 L15,12 L15,11 Z M16,11 L17,11 L17,12 L16,12 L16,11 Z M15,13 L16,13 L16,14 L15,14 L15,13 Z M13,22 L14,22 L14,23 L13,23 L13,22 Z M12,22 L13,22 L13,23 L12,23 L12,22 Z M12,13 L13,13 L13,14 L12,14 L12,13 Z M11,13 L12,13 L12,14 L11,14 L11,13 Z M11,14 L12,14 L12,15 L11,15 L11,14 Z M11,15 L12,15 L12,16 L11,16 L11,15 Z M22,14 L23,14 L23,15 L22,15 L22,14 Z M21,15 L22,15 L22,16 L21,16 L21,15 Z M22,17 L23,17 L23,18 L22,18 L22,17 Z M17,13 L18,13 L18,14 L17,14 L17,13 Z M18,12 L19,12 L19,13 L18,13 L18,12 Z M22,12 L23,12 L23,13 L22,13 L22,12 Z M22,13 L23,13 L23,14 L22,14 L22,13 Z M21,13 L22,13 L22,14 L21,14 L21,13 Z M22,21 L23,21 L23,22 L22,22 L22,21 Z M21,22 L22,22 L22,23 L21,23 L21,22 Z M19,22 L20,22 L20,23 L19,23 L19,22 Z M22,22 L23,22 L23,23 L22,23 L22,22 Z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "strokeWidth": "2",
                            "d": "M15,2 L22,2 L22,9 L15,9 L15,2 Z M2,2 L9,2 L9,9 L2,9 L2,2 Z M2,15 L9,15 L9,22 L2,22 L2,15 Z M18,5 L19,5 L19,6 L18,6 L18,5 Z M5,5 L6,5 L6,6 L5,6 L5,5 Z M5,18 L6,18 L6,19 L5,19 L5,18 Z"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function GrRadialSelected(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 Z M12,13 C12.5522847,13 13,12.5522847 13,12 C13,11.4477153 12.5522847,11 12,11 C11.4477153,11 11,11.4477153 11,12 C11,12.5522847 11.4477153,13 12,13 Z M12,15 C13.6568542,15 15,13.6568542 15,12 C15,10.3431458 13.6568542,9 12,9 C10.3431458,9 9,10.3431458 9,12 C9,13.6568542 10.3431458,15 12,15 Z M12,17 C14.7614237,17 17,14.7614237 17,12 C17,9.23857625 14.7614237,7 12,7 C9.23857625,7 7,9.23857625 7,12 C7,14.7614237 9.23857625,17 12,17 Z"
                }
            }
        ]
    })(props);
}
function GrRadial(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "11",
                    "fill": "none",
                    "strokeWidth": "2"
                }
            }
        ]
    })(props);
}
function GrRaspberry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.08672829,0.000264753559 C7.96534395,0.00402127507 7.836217,0.0481047507 7.68796657,0.165057787 C7.32481529,0.0250230129 6.97132662,-0.0244169841 6.65646751,0.260682129 C6.17026232,0.197621263 6.01323276,0.328417777 5.89352494,0.480410812 C5.78679799,0.478115159 5.09388673,0.371256036 4.77657197,0.844591729 C3.97915982,0.750226517 3.7280781,1.31407319 4.01363634,1.83946446 C3.85077722,2.09159662 3.68159462,2.33945747 4.06246416,2.82009742 C3.9277233,3.08780523 4.01160503,3.37809391 4.32898241,3.72952345 C4.24521198,4.10585734 4.41005371,4.37099819 4.70536499,4.57791992 C4.65013021,5.09291119 5.1765302,5.39291118 5.3340328,5.4995616 C5.3945128,5.79964506 5.52094757,6.08354835 6.12342406,6.24011878 C6.22279101,6.6872631 6.58455099,6.76475179 6.93518749,6.85861613 C5.77626582,7.53228566 4.78203284,8.41722473 4.78878066,10.5919375 L4.61991804,10.8950888 C3.29104858,11.703207 2.09522952,14.3014816 3.96480852,16.4126885 C4.08692329,17.0735093 4.29107632,17.5474988 4.47343457,18.072856 C4.74617195,20.1897463 6.52675621,21.1823654 6.99623096,21.2995897 C7.68421005,21.8236175 8.41761523,22.3205844 9.40915603,22.668814 C10.3438551,23.6328278 11.3552638,23.9999583 12.4141375,24 C13.4730105,24.0000348 14.4844191,23.6328278 15.4191182,22.668814 C16.410659,22.3205844 17.1440781,21.8236175 17.8320432,21.2995897 C18.301518,21.1823654 20.0821022,20.1897463 20.3548396,18.072856 C20.5371909,17.5474988 20.741337,17.0735093 20.8634726,16.4126885 C22.7330377,14.3014816 21.5372187,11.703207 20.2083492,10.8950888 L20.0394935,10.5919375 C20.0462414,8.41722473 19.0520014,7.53228566 17.8930867,6.85861613 C18.2437093,6.76475179 18.6054832,6.6872631 18.7048571,6.24011878 C19.3073266,6.08354835 19.4337614,5.79964506 19.4942414,5.4995616 C19.651744,5.39291118 20.1781509,5.09291119 20.1229092,4.57791992 C20.4182135,4.37099819 20.5830553,4.10585734 20.4992918,3.72952345 C20.8166692,3.37809391 20.9005509,3.08780523 20.765817,2.82009742 C21.1466865,2.33945747 20.9775039,2.09159662 20.8146448,1.83946446 C21.1001891,1.31407319 20.8491213,0.750226517 20.0516953,0.844591729 C19.7343944,0.371256036 19.0414832,0.478129073 18.9347562,0.480410812 C18.8150414,0.328417777 18.6580189,0.197621263 18.1718067,0.260682129 C17.8569406,-0.0244169841 17.5034589,0.0250230129 17.1403076,0.165057787 C16.9920572,0.0481047507 16.8629164,0.00404214463 16.7415459,0.000264753559 C16.5099007,-0.00692133296 16.312572,0.133996919 16.0986381,0.201683872 C15.5762243,0.0310751865 15.4578869,0.26317952 15.2014208,0.358337775 C14.6320504,0.237996913 14.45948,0.500981245 14.186193,0.777454341 L13.8667774,0.771332603 C13.0081548,1.27731493 12.5837723,2.30648356 12.4141375,2.30648356 C12.244502,2.30648356 11.8201194,1.27731493 10.9614968,0.771332603 L10.6420812,0.777454341 C10.3687873,0.500981245 10.1962238,0.237996913 9.62685341,0.358337775 C9.37038734,0.26317952 9.25204996,0.0310751865 8.72963608,0.201683872 C8.51569522,0.133996919 8.31836654,-0.00692133296 8.08672829,0.000264753559 L8.08672829,0.000264753559 Z M8.11723959,0.608584717 C8.55334391,0.770163907 8.78002912,0.978497808 9.01650215,1.18435494 C9.09674562,1.07614653 9.21854039,0.995833459 9.06939258,0.734720431 C9.37908995,0.913196942 9.61296124,1.12368739 9.78554558,1.3593184 C9.97706557,1.2373358 9.89847774,1.07156913 9.89947948,0.917836942 C10.2213229,1.17960363 10.4266934,1.45753057 10.676662,1.72960012 C10.7270273,1.6928836 10.7699838,1.56820187 10.8089055,1.3715271 C11.5766551,2.11633401 12.661247,3.99280691 11.0876325,4.73661208 C9.74914906,3.63272346 8.15102046,2.83019829 6.37977187,2.2280627 C8.65689869,3.40221217 9.98173339,4.35076863 10.7071873,5.15979119 C10.3355282,6.64922484 8.39685001,6.7193257 7.68796657,6.67753788 C7.83314917,6.60997615 7.95432482,6.52719354 7.99721177,6.40288051 C7.81933352,6.27641095 7.18837008,6.38981616 6.74801533,6.14246313 C6.91716314,6.10741618 6.99650922,6.0740527 7.07557009,5.94918245 C6.65961881,5.81650767 6.21198753,5.70103637 5.94845364,5.48123813 C6.09067971,5.48297726 6.22252666,5.51436508 6.40825882,5.3856277 C6.03566059,5.1847651 5.63886757,5.02516859 5.32996324,4.71830252 C5.52261714,4.71357209 5.72937191,4.7159373 5.78976843,4.64506426 C5.44871801,4.43378776 5.16123977,4.19811473 4.92306239,3.941113 C5.19265542,3.97365561 5.30546933,3.94744344 5.37065193,3.90041735 C5.11287803,3.63638259 4.78767457,3.41396173 4.63212674,3.08865392 C4.8322937,3.15760001 5.01483282,3.18202435 5.14686064,3.08051479 C5.05925021,2.88290785 4.68341021,2.76718612 4.46732675,2.30536356 C4.67805369,2.32579487 4.90277718,2.35134617 4.94747283,2.30536356 C4.84966414,1.90687315 4.68279804,1.68304708 4.51819283,1.45086622 C4.96919109,1.44418796 5.65184844,1.45239666 5.62089887,1.41425405 L5.34217193,1.12942652 C5.7827006,1.01081085 6.23361536,1.14928711 6.56084316,1.25149232 C6.70777881,1.1355413 6.55701708,0.988174329 6.37774057,0.838483903 C6.75211967,0.888466509 7.09125704,0.974170851 7.39702398,1.09279348 C7.5604118,0.945287375 7.28933008,0.798831731 7.15898574,0.651304714 C7.73737874,0.76107869 7.98362569,0.914003898 8.22711089,1.06838305 C8.40385523,0.899019551 8.23647437,0.756063038 8.11723959,0.608584717 L8.11723959,0.608584717 Z M16.7110277,0.608584717 C16.5917929,0.756063038 16.4244259,0.899019551 16.6011633,1.06838305 C16.8446485,0.914003898 17.0908955,0.76107869 17.6692815,0.651304714 C17.5389511,0.798831731 17.2678624,0.945287375 17.4312433,1.09279348 C17.7370172,0.974170851 18.0761476,0.888466509 18.4505336,0.838483903 C18.271271,0.988174329 18.1204954,1.1355413 18.267438,1.25149232 C18.5946658,1.14928711 19.0455736,1.01081085 19.4861092,1.12942652 L19.2073753,1.41425405 C19.1764258,1.45236188 19.8590762,1.44422275 20.3100883,1.45086622 C20.1454692,1.68304708 19.9786101,1.90687315 19.8808014,2.30536356 C19.925497,2.35134617 20.1502205,2.32579487 20.3609474,2.30536356 C20.144864,2.76718612 19.769024,2.88290785 19.6814205,3.08051479 C19.8134414,3.18202435 19.9959805,3.15760001 20.1961544,3.08865392 C20.0405927,3.41396173 19.7154031,3.63638259 19.4576223,3.90041735 C19.5228049,3.94743648 19.6356188,3.97365561 19.9052118,3.941113 C19.6670414,4.19811473 19.3795562,4.43378776 19.0385127,4.64506426 C19.0989023,4.71589556 19.305664,4.71355122 19.498311,4.71830252 C19.1894136,5.02516859 18.7926206,5.1847651 18.4200223,5.3856277 C18.6057545,5.51436508 18.7376015,5.48299813 18.8798206,5.48123813 C18.6162867,5.70103637 18.1686554,5.81650767 17.7527041,5.94918245 C17.831765,6.0740527 17.911118,6.10741618 18.0802589,6.14246313 C17.6399041,6.38981616 17.0089337,6.27641095 16.8310624,6.40288051 C16.8739494,6.52719354 16.995125,6.60997615 17.1403076,6.67753788 C16.4314312,6.7193257 14.4927461,6.64922484 14.121087,5.15979119 C14.8465339,4.35076863 16.1713755,3.40221217 18.4485023,2.2280627 C16.6772538,2.83019829 15.0791182,3.63272346 13.7406418,4.73661208 C12.1670203,3.99280691 13.2516053,2.11633401 14.0193687,1.3715271 C14.0582835,1.56820187 14.101247,1.6928836 14.1516122,1.72960012 C14.4015878,1.45753057 14.6069513,1.17960363 14.9287947,0.917836942 C14.9297686,1.07156913 14.8512017,1.2373358 15.0427286,1.3593184 C15.2153199,1.12368739 15.4491843,0.913196942 15.7588816,0.734720431 C15.6097269,0.995833459 15.7315216,1.07614653 15.8117721,1.18435494 C16.0482451,0.978497808 16.2749233,0.770163907 16.7110277,0.608584717 L16.7110277,0.608584717 Z M12.4141375,6.77007353 C13.7727322,6.77007353 14.9056504,7.69321086 14.9084539,8.23597257 C14.9120017,8.91685587 13.9141096,9.61605583 12.4324471,9.63369061 C12.4262557,9.63371843 12.4203218,9.63366278 12.4141375,9.63369061 C12.4079462,9.63366278 12.4019907,9.63371843 12.3958272,9.63369061 C10.9141577,9.61605583 9.91632122,8.91685587 9.91982035,8.23597257 C9.92267253,7.69321086 11.0555421,6.77007353 12.4141375,6.77007353 L12.4141375,6.77007353 Z M8.60146217,7.21668915 C8.62928826,7.2159935 8.65689869,7.2159935 8.68487086,7.21668915 C8.90498911,7.2178022 9.13188996,7.23677263 9.36236647,7.27568741 C10.1386029,7.40612218 5.64137887,11.3335235 5.57207105,10.4576627 C5.51003975,8.4547969 6.85024141,7.24467524 8.60146217,7.21668915 L8.60146217,7.21668915 Z M16.1434033,7.21668915 C16.1713755,7.2159935 16.198986,7.2159935 16.226812,7.21668915 C17.9780328,7.24467524 19.3182414,8.4547969 19.2562032,10.4576627 C19.1868953,11.3335235 14.6896643,7.40612218 15.4659077,7.27568741 C15.6963773,7.23677263 15.9232851,7.21785785 16.1434033,7.21668915 L16.1434033,7.21668915 Z M9.31760821,9.71710625 C9.57666211,9.71515843 9.83913166,9.75334277 10.0947908,9.83917233 C11.4583247,10.2968767 12.1474377,11.8915618 11.6349229,13.3995756 C11.1223943,14.9075685 9.60082211,15.7595407 8.23728132,15.3018364 C6.87374054,14.8441251 6.18464145,13.24944 6.6971562,11.74144 C7.11358052,10.5161879 8.19509698,9.72545408 9.31760821,9.71710625 L9.31760821,9.71710625 Z M15.510666,9.71710625 C16.6331842,9.72545408 17.7146937,10.5161879 18.131125,11.74144 C18.6436328,13.24944 17.9545337,14.8441251 16.5909929,15.3018364 C15.2274591,15.7595407 13.70588,14.9075685 13.1933514,13.3995756 C12.6808366,11.8915618 13.3699496,10.2968767 14.7334834,9.83917233 C14.9891426,9.75334277 15.2516191,9.71521408 15.510666,9.71710625 L15.510666,9.71710625 Z M5.32996324,11.3996453 C6.39246752,11.4152557 5.60278409,16.4517006 4.64025891,16.0240902 C3.54755637,15.145252 3.19627293,12.5727583 5.22213716,11.4159235 C5.25074933,11.4082505 5.27710759,11.4032627 5.30351454,11.4016835 C5.31211976,11.4009879 5.32159454,11.399527 5.32996324,11.3996662 L5.32996324,11.3996453 Z M19.498311,11.3996453 C19.5066797,11.3996453 19.5161475,11.4010366 19.5247597,11.4016627 C19.5511736,11.4031931 19.5775318,11.4082714 19.6061371,11.4159166 C21.6319943,12.5727443 21.2807039,15.1452381 20.1880153,16.0240833 C19.2254832,16.4516867 18.4358067,11.4152418 19.498311,11.3996383 L19.498311,11.3996453 Z M12.4141298,14.8822955 C13.1302557,14.8822955 13.8011496,15.1418364 14.2879252,15.5826085 C14.80716,16.0527511 15.1097686,16.7222954 15.1057965,17.3933145 C15.1057965,18.0521743 14.8114591,18.7056142 14.3062348,19.1714925 C13.8097478,19.6292942 13.1160435,19.9007933 12.4141375,19.9100176 C11.7122238,19.9007933 11.0185333,19.6292942 10.5220394,19.1714925 C10.0168151,18.7056142 9.72247776,18.0521743 9.72247776,17.3933145 C9.71851254,16.7222954 10.0211073,16.0527511 10.540349,15.5826085 C11.0271177,15.1418364 11.6980047,14.8822955 12.4141298,14.8822955 L12.4141298,14.8822955 Z M6.14784145,16.1990606 C6.8512988,16.184598 7.71643962,16.739951 8.41631436,17.5520136 C9.19689866,18.4924177 9.55193863,20.1452246 8.90053694,20.6322576 C8.28421002,21.0040767 6.78638054,20.8502124 5.72262408,19.3220385 C5.00519108,18.0397082 5.09887456,16.734998 5.60258931,16.351645 C5.76736147,16.251318 5.9508745,16.2030676 6.14784145,16.1990606 L6.14784145,16.1990606 Z M18.6132954,16.1990606 C18.635591,16.198365 18.6584502,16.198365 18.6804397,16.1990606 C18.8774067,16.2030259 19.0609127,16.251318 19.2256919,16.351645 C19.7294066,16.734998 19.8230831,18.0397082 19.1056571,19.3220385 C18.0418798,20.8502124 16.5440503,21.0040767 15.9277373,20.6322576 C15.2763356,20.1452246 15.6313547,18.4924177 16.4119599,17.5520136 C17.0899563,16.7653284 17.9223389,16.2192554 18.6132954,16.1990606 L18.6132954,16.1990606 Z M12.4141375,20.7034715 C13.5040226,20.691068 15.1237165,21.1498297 15.1037652,21.7349775 C15.1211634,22.1401114 13.7921409,23.3091896 12.4365097,23.2506853 C12.4290036,23.2506853 12.4216366,23.2506296 12.4141375,23.2506853 C12.4066307,23.2506296 12.3992568,23.2506853 12.3917646,23.2506853 C11.0361264,23.3091896 9.70711776,22.1401114 9.72450906,21.7349775 C9.70455776,21.1498297 11.3242516,20.691068 12.4141375,20.7034715 L12.4141375,20.7034715 Z"
                }
            }
        ]
    })(props);
}
function GrReactjs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fillRule": "evenodd"
                },
                "child": [
                    {
                        "tag": "circle",
                        "attr": {
                            "cx": "11.996",
                            "cy": "11.653",
                            "r": "2.142"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "fillRule": "nonzero",
                            "d": "M11.9957722,7.80914159 C14.763782,7.80914159 17.3932297,8.19939152 19.3922491,8.88758063 C21.6123871,9.6518808 22.9666335,10.7818833 22.9666335,11.652558 C22.9666335,12.5799965 21.5040812,13.7840336 19.1293161,14.5708627 C17.2387355,15.1972602 14.7092455,15.538679 11.9957722,15.538679 C9.14520032,15.538679 6.58717845,15.203913 4.71853163,14.565185 C3.54866968,14.1653247 2.58256656,13.6456709 1.92037292,13.0785821 C1.32532838,12.5689984 1.02491103,12.0630628 1.02491103,11.652558 C1.02491103,10.7789546 2.32734001,9.66464781 4.49959681,8.90729393 C6.49945246,8.21010004 9.19325759,7.80914159 11.9957722,7.80914159 L11.9957722,7.80914159 L11.9957722,7.80914159 L11.9957722,7.80914159 L11.9957722,7.80914159 M11.9957722,6.78423056 C9.08437994,6.78423056 6.2777499,7.20198239 4.1621939,7.93951199 C1.62214541,8.82509585 0,10.2129394 0,11.652558 C0,13.1394248 1.74140227,14.6307252 4.38703934,15.5350074 C6.37567236,16.2147483 9.04125041,16.56359 11.9957722,16.56359 C14.8115523,16.56359 17.4474553,16.2078081 19.4516644,15.5437626 C22.2020573,14.632477 23.9915445,13.1592927 23.9915445,11.652558 C23.9915445,10.2077356 22.3170688,8.81052922 19.7258695,7.91848823 C17.6128656,7.19105846 14.871718,6.78423056 11.9957722,6.78423056 L11.9957722,6.78423056 L11.9957722,6.78423056 L11.9957722,6.78423056 L11.9957722,6.78423056 M8.64782576,9.74318674 C10.0306294,7.34537922 11.6822995,5.26251432 13.2771145,3.87459857 C15.0483324,2.33318986 16.7037652,1.72455661 17.4580053,2.15950561 C18.2614273,2.62281187 18.5738182,4.49132292 18.0690455,6.94154209 C17.6671734,8.89223963 16.6992742,11.2540339 15.3437168,13.6046372 C13.9196524,16.0740185 12.3517605,18.1226845 10.8648902,19.4223695 C9.93407029,20.2360369 9.00127666,20.8133347 8.17921011,21.1036655 C7.44050831,21.3645543 6.85214323,21.3720417 6.49651234,21.1669615 C5.73974814,20.7305244 5.42512511,19.045619 5.85426462,16.7855049 C6.24932455,14.7048419 7.24772098,12.1710157 8.64782671,9.74318508 L8.64782576,9.74318674 L8.64782576,9.74318674 L8.64782576,9.74318674 L8.64782576,9.74318674 M7.759974,9.23116928 C6.30547459,11.7533204 5.26525979,14.3932772 4.84734364,16.5943171 C4.34554839,19.2370813 4.73740525,21.3355983 5.98449631,22.0548141 C7.2725788,22.7976074 9.43439148,22.0341158 11.5394159,20.1940284 C13.121755,18.8108935 14.7555742,16.6760844 16.2315707,14.1166508 C17.6382359,11.6774242 18.6468519,9.21627599 19.0728759,7.1483441 C19.6574939,4.31054745 19.2752706,2.02434609 17.9700071,1.27164481 C16.7184046,0.549880923 14.6715337,1.30242953 12.6042836,3.1014613 C10.9185312,4.56851694 9.19669947,6.73986025 7.75997496,9.23116762 L7.759974,9.23116928 L7.759974,9.23116928 L7.759974,9.23116928 L7.759974,9.23116928 M8.65102932,13.6102163 C7.26423584,11.2147037 6.28457878,8.74353725 5.87862056,6.66870559 C5.42774955,4.36439699 5.72720706,2.6262057 6.48072727,2.18999639 C7.28337846,1.72531755 9.05821175,2.38783711 10.9288592,4.04883669 C12.4181905,5.37119379 13.9809502,7.38921897 15.3404734,9.7376059 C16.7686644,12.2045881 17.7605533,14.5861039 18.1440168,16.5233658 C18.384086,17.7361541 18.4183857,18.8326057 18.2593637,19.6898062 C18.1164684,20.4600771 17.8291151,20.9735449 17.473831,21.1792215 C16.7177635,21.6169189 15.1008664,21.0480332 13.3571194,19.5474962 C11.7518336,18.1661133 10.0552117,16.0356933 8.65102599,13.6102105 L8.65102932,13.6102163 L8.65102932,13.6102163 L8.65102932,13.6102163 L8.65102932,13.6102163 M7.76403451,14.1237168 C9.2227685,16.6434222 10.9904487,18.863069 12.6886037,20.3243677 C14.727583,22.0789594 16.7414064,22.7874988 17.9873239,22.0662207 C19.2741476,21.3212689 19.6923336,19.0670565 19.1494202,16.3243517 C18.741335,14.2627011 17.7077401,11.7810493 16.2274688,9.22410641 C14.8166895,6.78718171 13.1881856,4.68425955 11.6093526,3.2824351 C9.4428116,1.3587035 7.27122101,0.548080175 5.96723274,1.30299809 C4.71682218,2.02685487 4.34655386,4.17606524 4.87278214,6.8655093 C5.30188762,9.05864543 6.32316039,11.6347867 7.76403118,14.1237111 L7.76403451,14.1237168 L7.76403451,14.1237168 L7.76403451,14.1237168 L7.76403451,14.1237168"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function GrReddit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15.57,15.284 C14.673,15.284 13.91925,14.5565 13.91925,13.6595 C13.91925,12.7625 14.673,12.011 15.57,12.011 C16.467,12.011 17.1945,12.7625 17.1945,13.6595 C17.1945,14.5565 16.467,15.284 15.57,15.284 M15.951,18.437 C15.1155,19.27175 13.827,19.6775 12.012,19.6775 C12.00825,19.6775 12.00375,19.67675 11.99925,19.67675 C11.9955,19.67675 11.991,19.6775 11.9865,19.6775 C10.1715,19.6775 8.88375,19.27175 8.049,18.437 C7.7925,18.1805 7.7925,17.76575 8.049,17.51 C8.30475,17.25425 8.7195,17.25425 8.976,17.51 C9.552,18.086 10.53675,18.3665 11.9865,18.3665 C11.991,18.3665 11.9955,18.36725 11.99925,18.36725 C12.00375,18.36725 12.00825,18.3665 12.012,18.3665 C13.46175,18.3665 14.44725,18.086 15.024,17.51 C15.2805,17.2535 15.69525,17.25425 15.951,17.51 C16.20675,17.7665 16.20675,18.18125 15.951,18.437 M6.8055,13.6595 C6.8055,12.76325 7.55775,12.011 8.454,12.011 C9.351,12.011 10.0785,12.76325 10.0785,13.6595 C10.0785,14.5565 9.351,15.284 8.454,15.284 C7.55775,15.284 6.8055,14.5565 6.8055,13.6595 M19.998,3.311 C20.6055,3.311 21.09975,3.80525 21.09975,4.412 C21.09975,5.0195 20.6055,5.51375 19.998,5.51375 C19.3905,5.51375 18.89625,5.0195 18.89625,4.412 C18.89625,3.80525 19.3905,3.311 19.998,3.311 M24,11.87525 C24,10.2845 22.70625,8.99075 21.1155,8.99075 C20.427,8.99075 19.79475,9.23375 19.29825,9.638 C17.5395,8.5325 15.3075,7.8665 12.915,7.7255 L14.163,3.77975 L17.59275,4.5875 C17.68275,5.83625 18.72675,6.82475 19.998,6.82475 C21.32775,6.82475 22.41,5.7425 22.41,4.412 C22.41,3.08225 21.32775,2 19.998,2 C19.068,2 18.2595,2.5295 17.85675,3.30275 L13.87125,2.3645 C13.5375,2.28575 13.2,2.47775 13.0965,2.80475 L11.547,7.70225 C8.96925,7.76525 6.546,8.4335 4.65825,9.6035 C4.1685,9.22025 3.55275,8.99075 2.8845,8.99075 C1.29375,8.99075 0,10.2845 0,11.87525 C0,12.8585 0.495,13.72775 1.24875,14.24825 C1.21725,14.477 1.20075,14.70725 1.20075,14.9405 C1.20075,16.92875 2.3565,18.77825 4.455,20.14775 C6.4665,21.461 9.129,22.184 11.95125,22.184 C14.7735,22.184 17.436,21.461 19.4475,20.14775 C21.546,18.77825 22.70175,16.92875 22.70175,14.9405 C22.70175,14.72825 22.6875,14.5175 22.66125,14.30825 C23.46525,13.796 24,12.89675 24,11.87525"
                }
            }
        ]
    })(props);
}
function GrRedhat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none",
                    "fillRule": "evenodd",
                    "transform": "translate(0 3)"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M5.83245745,3.12541039 C6.47698077,0.721248552 7.36320033,-0.240416184 8.49111613,0.240416184 C10.1829898,0.961664736 10.9080786,0.721248552 11.6331673,0.240416184 C12.1165598,-0.080138728 12.8416485,-0.080138728 13.8084335,0.240416184 L17.1921809,1.68291329 C18.1589659,2.0034682 18.8034892,3.12541039 19.1257509,5.04873986 C19.4480125,6.97206934 19.6897088,8.25428898 19.8508396,8.89539881 C22.267802,9.85706354 23.6374141,11.2995606 23.9596758,13.2228901 C24.4430682,16.1078843 20.5759283,18.9928785 12.5999523,17.5503814 C4.62397623,16.1078843 -0.451644897,11.5399768 0.0317475914,8.89539881 C0.35400925,7.13234679 1.88475213,6.25082078 4.62397623,6.25082078 L5.83245745,3.12541039 Z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M4.88723097,5.53846154 C6.34892389,8.04517453 9.02869424,9.61187015 12.926542,10.2385484 C16.8243898,10.8652266 19.0981343,10.2385484 19.7477756,8.35851365 C20.0254081,9.7752343 20.0254081,10.7152517 19.7477756,11.1785658 C18.8331342,12.7049226 16.3357442,13.1465566 13.6573885,12.8235962 C9.7595407,12.3535875 6.91736002,11.100231 5.13084646,9.06352668 C4.64361549,8.43684843 4.4,7.88850497 4.4,7.41849628 C4.4,6.9484876 4.56241032,6.32180935 4.88723097,5.53846154 Z"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function GrRedo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.82,4,15.4,5.44,17.94,8H8.23a6,6,0,0,0,0,12h2V18h-2a4,4,0,0,1,0-8h9.71L15.4,12.51l1.41,1.41L21.77,9Z"
                }
            }
        ]
    })(props);
}
function GrRefresh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M20,8 C18.5974037,5.04031171 15.536972,3 12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 L12,21 C16.9705627,21 21,16.9705627 21,12 M21,3 L21,9 L15,9"
                }
            }
        ]
    })(props);
}
function GrResources(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,3 L21,7.5 L12,12 L3,7.5 L12,3 Z M16.5,10.25 L21,12.5 L12,17 L3,12.5 L7.5,10.25 L7.5,10.25 M16.5,15.25 L21,17.5 L12,22 L3,17.5 L7.5,15.25 L7.5,15.25"
                }
            }
        ]
    })(props);
}
function GrRestaurant(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M19,18 L5,18 L19,18 Z M12,18 L12,12 L12,18 Z M15,18 L15,14 L15,18 Z M9,18 L9,14 L9,18 Z M19,22 L19,11.3292943 C20.1651924,10.9174579 21,9.80621883 21,8.5 C21,6.84314575 19.6568542,5.5 18,5.5 C17.6192862,5.5 17.2551359,5.57091725 16.9200387,5.7002623 C16.5495238,3.87433936 14.4600194,2 12,2 C9.53998063,2 7.45047616,3.87433936 7.07996126,5.7002623 C6.74486408,5.57091725 6.38071384,5.5 6,5.5 C4.34314575,5.5 3,6.84314575 3,8.5 C3,9.80621883 3.83480763,10.9174579 5,11.3292943 L5,22 L19,22 Z"
                }
            }
        ]
    })(props);
}
function GrRestroomMen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "2",
                    "d": "M7,13.5 L11,8 L10,21 M17,13.5 L13,8 L14,21 M12,5 C12.5522847,5 13,4.55228475 13,4 C13,3.44771525 12.5522847,3 12,3 C11.4477153,3 11,3.44771525 11,4 C11,4.55228475 11.4477153,5 12,5 Z M11,8 L13,8 L13,13.5 L11,13.5 L11,8 Z"
                }
            }
        ]
    })(props);
}
function GrRestroomWomen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "2",
                    "d": "M7,13.5 L11,8 L12,21 M17,13.5 L13,8 L12,21 M12,5 C12.5522847,5 13,4.55228475 13,4 C13,3.44771525 12.5522847,3 12,3 C11.4477153,3 11,3.44771525 11,4 C11,4.55228475 11.4477153,5 12,5 Z M11,8 L13,8 L14.5,16.5 L9.5,16.5 L11,8 Z"
                }
            }
        ]
    })(props);
}
function GrRestroom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeWidth": "2",
                    "d": "M6,11 L18,11 M6,3 L18,3 M12,16 C14.7614237,16 17,13.7614237 17,11 C17,11 7,11 7,11 C7,13.7614237 9.23857625,16 12,16 Z M7,3 L17,3 L17,11 L7,11 L7,3 Z M7,6 L9.5,6 M14.5,15.5 L16,21.5 L8,21.5 L9.5,15.5"
                }
            }
        ]
    })(props);
}
function GrResume(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,20 L6,20 L6,4 L1,4 L1,20 Z M11,19.0000002 L22,12 L11,5 L11,19.0000002 Z"
                }
            }
        ]
    })(props);
}
function GrReturn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M9,4 L4,9 L9,14 M18,19 L18,9 L5,9",
                    "transform": "matrix(1 0 0 -1 0 23)"
                }
            }
        ]
    })(props);
}
function GrRevert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M8,3 L3,8 L8,13 M12,20 L15,20 C18.3137085,20 21,17.3137085 21,14 C21,10.6862915 18.3137085,8 15,8 L4,8"
                }
            }
        ]
    })(props);
}
function GrRewind(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "points": "22 3.5 22 20 13 14 13 20 2 12 13 4 13 10"
                }
            }
        ]
    })(props);
}
function GrRisk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M14,10 L15,10 L15,9 L14,9 L14,10 Z M18,10 L19,10 L19,9 L18,9 L18,10 Z M18,6 L19,6 L19,5 L18,5 L18,6 Z M14,6 L15,6 L15,5 L14,5 L14,6 Z M9,19 L10,19 L10,18 L9,18 L9,19 Z M5,15 L6,15 L6,14 L5,14 L5,15 Z M10,10 L1,10 L1,23 L14,23 L14,14 M10,14 L23,14 L23,1 L10,1 L10,14 Z"
                }
            }
        ]
    })(props);
}
function GrRobot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M18.3482396,15.9535197 C18.7664592,15.0561341 19,14.0553403 19,13 C19,9.13400675 15.8659932,6 12,6 C8.13400675,6 5,9.13400675 5,13 C5,14.1167756 5.2615228,15.1724692 5.72666673,16.1091793 L5.72666673,16.1091793 M12,3 C12.5522847,3 13,2.55228475 13,2 C13,1.44771525 12.5522847,1 12,1 C11.4477153,1 11,1.44771525 11,2 C11,2.55228475 11.4477153,3 12,3 Z M12,23 C12.5522847,23 13,22.5522847 13,22 C13,21.4477153 12.5522847,21 12,21 C11.4477153,21 11,21.4477153 11,22 C11,22.5522847 11.4477153,23 12,23 Z M12,6 L12,3 M9,14 C9.55228475,14 10,13.5522847 10,13 C10,12.4477153 9.55228475,12 9,12 C8.44771525,12 8,12.4477153 8,13 C8,13.5522847 8.44771525,14 9,14 Z M15,14 C15.5522847,14 16,13.5522847 16,13 C16,12.4477153 15.5522847,12 15,12 C14.4477153,12 14,12.4477153 14,13 C14,13.5522847 14.4477153,14 15,14 Z M6,18.9876876 L5,16 C5,16 5.07242747,15.2283988 5.5,15.5 C6.43069361,16.0911921 8.57396448,17 12,17 C15.5536669,17 17.6181635,16.0844828 18.5,15.5 C18.8589052,15.262117 19,16 19,16 L18,18.9876876 C18,18.9876876 17.0049249,20.9999997 12,21 C6.99507512,21.0000003 6,18.9876876 6,18.9876876 Z"
                }
            }
        ]
    })(props);
}
function GrRotateLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.52,3.43A9.09,9.09,0,0,0,5.7,5.55V2.35H4.07v6.5h6.5V7.21H6.3a7.46,7.46,0,1,1-1.47,8.65l-1.46.73A9.11,9.11,0,1,0,11.52,3.43Z"
                }
            }
        ]
    })(props);
}
function GrRotateRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.48,3.43A9.09,9.09,0,0,1,18.3,5.55V2.35h1.64v6.5h-6.5V7.21H17.7a7.46,7.46,0,1,0,1.47,8.65l1.46.73A9.11,9.11,0,1,1,12.48,3.43Z"
                }
            }
        ]
    })(props);
}
function GrRss(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M22,21 C22,10.5065898 13.4934102,2 3,2 M17,21 C17,13.2680135 10.7319865,7 3,7 M12,21 C12,16.0294373 7.97056275,12 3,12 M4,23 C5.65685425,23 7,21.6568542 7,20 C7,18.3431458 5.65685425,17 4,17 C2.34314575,17 1,18.3431458 1,20 C1,21.6568542 2.34314575,23 4,23 Z"
                }
            }
        ]
    })(props);
}
function GrRun(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "2",
                    "d": "M15,11 L18,13 M18,5 C18.5522847,5 19,4.55228475 19,4 C19,3.44771525 18.5522847,3 18,3 C17.4477153,3 17,3.44771525 17,4 C17,4.55228475 17.4477153,5 18,5 Z M9.5,9.5 L9.52493781,6 L14.0249378,6 L15,6 L8,17 L4,17 M15,8 L12,13 L12.5,14 L17,7.5 L15,6 M11,13 L16,16.5 L16,21.5"
                }
            }
        ]
    })(props);
}
function GrSafariOption(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.5410065,11.8438452 C12.5626839,11.4304258 12.2112,11.0719742 11.7660387,11.0541677 C11.2961032,11.0348129 10.9392,11.3785548 10.9314581,11.8562323 C10.9244903,12.2789419 11.2682323,12.6141677 11.7219097,12.6281032 C12.1717161,12.6420387 12.5162323,12.3114581 12.5410065,11.8438452 M17.2140387,5.12152258 C17.1962323,5.1075871 17.1784258,5.09442581 17.1613935,5.08126452 C17.1079742,5.12616774 17.0522323,5.16874839 17.0019097,5.21674839 C15.0865548,7.0035871 13.1696516,8.78810323 11.2597161,10.5811355 C11.0398452,10.7886194 10.8277161,11.0208774 10.6721032,11.2771355 C9.2708129,13.5842323 7.88345806,15.8998452 6.49300645,18.2131355 C6.43649032,18.3068129 6.3908129,18.4074581 6.33971613,18.5050065 C6.42565161,18.5019097 6.47287742,18.4732645 6.51236129,18.4361032 C8.45171613,16.6237161 10.3949419,14.8152 12.3257806,12.9927484 C12.5773935,12.755071 12.7949419,12.4662968 12.975329,12.1690065 C14.3472,9.91300645 15.7066839,7.64771613 17.0684903,5.38552258 C17.1203613,5.2995871 17.1660387,5.20978065 17.2140387,5.12152258 M17.1443613,4.02836129 C19.1425548,5.42190968 20.3952,7.28461935 21.0339097,9.63507097 C20.8008774,9.69236129 20.5841032,9.72797419 20.3820387,9.80152258 C20.295329,9.83403871 20.2372645,9.94552258 20.1660387,10.0206194 C20.2604903,10.0624258 20.3588129,10.1452645 20.4486194,10.1375226 C20.6545548,10.1181677 20.8573935,10.0546839 21.1043613,9.99971613 C21.5533935,12.4066839 21.1717161,14.6286194 19.9206194,16.7290065 C19.7255226,16.6105548 19.5644903,16.4874581 19.3841032,16.4123613 C19.2648774,16.3620387 19.1177806,16.379071 18.983071,16.3666839 C19.0488774,16.4758452 19.0937806,16.6090065 19.1859097,16.6895226 C19.3337806,16.8188129 19.5126194,16.9140387 19.7185548,17.0502968 C18.3443613,19.0608774 16.5041032,20.3739097 14.1188129,21.011071 C14.0491355,20.7447484 13.9980387,20.4846194 13.9074581,20.2384258 C13.8741677,20.1478452 13.7495226,20.0905548 13.6659097,20.0177806 C13.6395871,20.1184258 13.5792,20.2237161 13.5923613,20.3181677 C13.6272,20.5604903 13.6945548,20.7981677 13.7611355,21.0915871 C11.3309419,21.5452645 9.07339355,21.1868129 6.92732903,19.9024258 C7.09145806,19.6461677 7.25636129,19.4185548 7.38487742,19.1715871 C7.43752258,19.0709419 7.40965161,18.9277161 7.41894194,18.8038452 C7.30590968,18.8642323 7.16036129,18.899071 7.0868129,18.9912 C6.92036129,19.1994581 6.78874839,19.4371355 6.61610323,19.7042323 C4.57842581,18.3075871 3.27545806,16.4293935 2.63442581,14.0247484 C2.94410323,13.9519742 3.20810323,13.9047484 3.45971613,13.8211355 C3.54487742,13.7932645 3.60061935,13.6748129 3.66952258,13.5973935 C3.56965161,13.5641032 3.46590968,13.4928774 3.37145806,13.5052645 C3.11829677,13.5377806 2.86900645,13.6051355 2.57403871,13.6686194 C2.12578065,11.2299097 2.51210323,8.97313548 3.82513548,6.84023226 C4.0148129,6.96023226 4.17894194,7.09029677 4.36474839,7.17390968 C4.50874839,7.23971613 4.67907097,7.24823226 4.83778065,7.28152258 C4.74178065,7.14216774 4.66590968,6.98113548 4.5435871,6.86965161 C4.3988129,6.7388129 4.21455484,6.65132903 4.01945806,6.52668387 C5.44397419,4.53545806 7.3035871,3.22552258 9.7268129,2.63249032 C9.78255484,2.87326452 9.81429677,3.1032 9.89249032,3.31532903 C9.93661935,3.43378065 10.0573935,3.5228129 10.143329,3.62578065 C10.1727484,3.50423226 10.2354581,3.3795871 10.2238452,3.26268387 C10.2013935,3.0435871 10.1363613,2.82913548 10.0782968,2.56513548 C12.4930065,2.14242581 14.7250065,2.53726452 16.8292645,3.82010323 C16.6798452,4.06165161 16.5265548,4.27997419 16.4088774,4.51532903 C16.367071,4.59739355 16.4119742,4.7228129 16.4173935,4.82810323 C16.5064258,4.78861935 16.6248774,4.77236129 16.679071,4.70500645 C16.8385548,4.50371613 16.9724903,4.28307097 17.1443613,4.02836129 M11.8450065,22.4201032 C17.7211355,22.4061677 22.431329,17.6595871 22.4220387,11.7610065 C22.4135226,5.98861935 17.639071,1.25442581 11.8333935,1.26216774 C5.9355871,1.26990968 1.24939355,6.00874839 1.26410323,11.9499097 C1.2788129,17.7021677 6.06100645,22.4340387 11.8450065,22.4201032 M11.8364903,0.000232258065 C18.3420387,-0.00673548387 23.6808774,5.30732903 23.6862968,11.7942968 C23.6917161,18.3532645 18.4217806,23.6502968 11.8604903,23.6828129 C5.32784516,23.7145548 0.000619354838,18.3780387 -0.00015483871,11.8012645 C-0.00015483871,5.30345806 5.3115871,0.0072 11.8364903,0.000232258065"
                }
            }
        ]
    })(props);
}
function GrSamsungPay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "clipPath": "url(#a)"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "fillRule": "evenodd",
                            "d": "M21.33 2.688c1.395 1.48 2.192 3.502 2.477 5.723.284 2.135.17 3.587.17 3.587s.086 1.452-.199 3.587c-.284 2.22-1.082 4.243-2.477 5.723-1.48 1.395-3.502 2.192-5.722 2.477-2.136.256-3.588.2-3.588.2s-1.451.084-3.587-.2c-2.22-.285-4.242-1.082-5.722-2.477-1.395-1.48-2.193-3.502-2.477-5.723-.257-2.135-.2-3.587-.2-3.587s-.057-1.452.228-3.587C.518 6.19 1.315 4.169 2.71 2.688 4.19 1.293 6.212.496 8.433.211 10.568-.045 12.02.012 12.02.012s1.452-.085 3.587.2c2.22.284 4.242 1.081 5.723 2.476ZM6.582 8.496H4.447v6.292h1.167v-1.793h.968c.342 0 .655-.058.911-.172.256-.113.513-.284.712-.483a2.1 2.1 0 0 0 .484-.712c.114-.285.17-.57.17-.883a2.32 2.32 0 0 0-.17-.882 2.103 2.103 0 0 0-.484-.712 2.1 2.1 0 0 0-.712-.484 2.36 2.36 0 0 0-.91-.17Zm-.996 3.388V9.55h.91c.172 0 .342.028.485.085a1.1 1.1 0 0 1 .37.256c.085.114.17.228.228.37.057.143.085.285.085.456 0 .17-.028.313-.085.456a1.082 1.082 0 0 1-.598.626 1.329 1.329 0 0 1-.484.085h-.911Zm5.067 2.733c.314.114.598.171.912.171.341 0 .626-.057.91-.171.285-.142.542-.313.712-.541v.712h1.168V9.72h-1.168v.655c-.199-.2-.427-.37-.711-.484a2.261 2.261 0 0 0-.912-.17c-.341 0-.626.056-.939.17-.285.114-.57.256-.797.484a2.707 2.707 0 0 0-.57.797c-.142.313-.199.684-.199 1.082 0 .399.086.769.228 1.082.142.313.342.57.57.797.227.2.512.37.796.484Zm1.709-.996c-.171.085-.37.114-.598.114a1.87 1.87 0 0 1-.598-.114l-.004-.002c-.17-.085-.339-.17-.48-.311a2.801 2.801 0 0 1-.313-.484 1.273 1.273 0 0 1-.114-.57c0-.199.028-.398.114-.569.057-.17.17-.313.313-.456a1.42 1.42 0 0 1 .484-.313c.2-.085.399-.114.598-.114.2 0 .398.029.598.143.199.085.341.17.484.313.142.114.227.285.313.456.085.17.114.37.114.569 0 .199-.029.398-.114.57a1.63 1.63 0 0 1-.313.455c-.143.142-.313.228-.484.313Zm5.039-.427-1.424-3.445h-1.224l2.05 4.812-1.053 2.533h1.195l2.99-7.345H18.71l-1.31 3.445Z",
                            "clipRule": "evenodd"
                        }
                    }
                ]
            },
            {
                "tag": "defs",
                "attr": {},
                "child": [
                    {
                        "tag": "clipPath",
                        "attr": {
                            "id": "a"
                        },
                        "child": [
                            {
                                "tag": "path",
                                "attr": {
                                    "d": "M0 0h24v24H0z"
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    })(props);
}
function GrSans(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeWidth": "2",
                    "d": "M1 12h22M2 22h20a1 1 0 001-1V3a1 1 0 00-1-1H2a1 1 0 00-1 1v18a1 1 0 001 1zM5 8a1 1 0 100-2 1 1 0 000 2zm0 10a1 1 0 100-2 1 1 0 000 2z"
                }
            }
        ]
    })(props);
}
function GrSatellite(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M7,17 C2.97059067,12.7941347 2.97059067,6.11763731 7,2 L22,17 C17.8823627,21.0294093 11.2058653,21.0294093 7,17 Z M7,17 C3.705,17 1,19.9491525 1,23 L13,23 C13,21.8610169 12.63,20.9661017 12,20 M15,9 L19,5 L15,9 Z M20.5,1 C19.119,1 18,2.119 18,3.5 C18,4.881 19.119,6 20.5,6 C21.881,6 23,4.881 23,3.5 C23,2.119 21.881,1 20.5,1 L20.5,1 Z"
                }
            }
        ]
    })(props);
}
function GrSave(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M3,2 L3,21 L21,21 L21,3 L12,3 L12,14 M8,11 L12,15 L16,11"
                }
            }
        ]
    })(props);
}
function GrScan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M20,14 L20,21 L4,21 L4,14 L4,14 M1,12 L23,12 L1,12 Z M4,11 L4,8 L4,11 Z M20,8 L20,11 L20,8 Z M7,3 L4,3 L4,6 M20,6 L20,3 L17,3 M9,3 L15,3 L9,3 Z",
                    "transform": "matrix(1 0 0 -1 0 24)"
                }
            }
        ]
    })(props);
}
function GrScheduleNew(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M14,0 L14,3 M1,7 L19,7 M6,0 L6,3 M4,11 L6,11 M8,11 L16,11 M4,15 L6,15 M8,15 L14,15 M12,19 L1,19 L1,3 L19,3 L19,13 M19,15 L19,24 M15,17 L23,22 M23,17 L15,22"
                }
            }
        ]
    })(props);
}
function GrSchedulePlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M14,0 L14,3 M1,7 L19,7 M6,0 L6,3 M4,11 L6,11 M8,11 L16,11 M4,15 L6,15 M8,15 L14,15 M13,19 L1,19 L1,3 L19,3 L19,13 M18,23 C20.7614237,23 23,20.7614237 23,18 C23,15.2385763 20.7614237,13 18,13 C15.2385763,13 13,15.2385763 13,18 C13,20.7614237 15.2385763,23 18,23 Z M17.5,17 L19,18 L17.5,19 L17.5,17 Z"
                }
            }
        ]
    })(props);
}
function GrSchedule(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,23 L23,23 L23,4 L1,4 L1,23 Z M18,4 L18,0 L18,4 Z M6,4 L6,0 L6,4 Z M1,8.5 L23,8.5 L1,8.5 Z M6,14 C6.55643465,12.6666667 7.38976798,12 8.5,12 C9.7998158,12 10.5,13 10.5,14 C10.5,15 9.5,16 8.5,17 C8.11410094,17.3858991 7.44743428,18.0525657 6.5,19 L6.5,19.5 L11.9045742,19.5 M16.984409,20.5 L17,12 L16.5,12 C16,13.5 14.5,14 13.7573,14"
                }
            }
        ]
    })(props);
}
function GrSchedules(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M17,7 L23,7 L23,23 L7,23 L7,19 M23,11 L17,11 M13,0 L13,3 M1,7 L17,7 M1,3 L17,3 L17,19 L1,19 L1,3 Z M5,0 L5,3 M4,11 L6,11 M8,11 L14,11 M4,15 L6,15 M8,15 L14,15"
                }
            }
        ]
    })(props);
}
function GrSco(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M16.1601041,16.1052616 L24,16.1052616 C23.7531246,16.8514638 23.0107679,17.4724977 22.2065,17.4724977 L1.27284858,17.4724977 C0.469157559,17.4724977 -0.0563179315,16.8514638 0.00482411239,16.1052616 L14.7072237,16.1052616 C14.4878705,15.5269428 14.3890063,14.8374216 14.5068517,14.1475626 L14.5068517,14.1479472 L15.4658973,14.1479472 C15.4658973,14.3350264 15.4658973,14.4905733 15.4968529,14.6453511 C15.8058317,14.5517154 16.1153874,14.3657897 16.3934106,14.1479472 L17.0117528,14.1479472 C16.4862773,14.7072623 15.9915651,15.1733261 15.7439206,15.3600209 C15.8577181,15.6369483 16.0052874,15.8883615 16.1601041,16.1052616 L16.1601041,16.1052616 L16.1601041,16.1052616 Z M21.7427242,7.71466974 C20.6915809,7.27975369 19.3616453,7 17.8469377,7 C16.3012746,7 14.8167534,7.27975369 13.6414034,7.71466974 L13.6725512,7.77696541 L21.6817744,7.77696541 L21.7427242,7.71466974 L21.7427242,7.71466974 L21.7427242,7.71466974 Z M15.1260976,12.6562543 C15.1570531,12.5939587 15.1882009,12.531663 15.2189642,12.4384118 L4.42700896,12.4695596 L4.39605339,12.3449683 C7.0557323,11.816801 10.3641321,11.5060917 13.9203688,11.5060917 C14.4767998,11.5060917 15.0643787,11.5060917 15.5898542,11.5372396 C15.6208097,11.4126482 15.651573,11.3195893 15.6827209,11.1951902 L7.02554582,11.1951902 L6.99459026,11.101939 C9.31375797,10.6049195 12.2203123,10.2944025 15.3427865,10.2944025 L15.6832977,10.2944025 C15.6525344,10.2321069 15.6215788,10.1077078 15.5906233,10.0142643 L9.71541121,10.0142643 L9.68445565,9.92101308 C11.2301188,9.57915599 13.0547666,9.2994023 15.0651478,9.23710663 C14.9718965,9.11270757 14.8484588,9.01964861 14.7244443,8.92678192 L11.8486533,8.92678192 L11.7869344,8.83333842 C13.2714556,8.36727454 15.0651478,8.08771311 17.0134255,8.08771311 C18.8995999,8.08771311 20.5692776,8.39842237 21.8984441,8.83333842 L21.8676808,8.89563408 L15.3127923,8.92678192 C15.4048899,8.98888531 15.4977566,9.08232882 15.5906233,9.2059588 C15.9615132,9.17500323 16.3320186,9.17500323 16.7036776,9.17500323 C19.0536087,9.17500323 21.2179986,9.4549492 22.9493951,9.82795412 L22.9184395,10.0142643 L16.0232321,10.0142643 C16.0541876,10.1077078 16.0541876,10.2321069 16.0851432,10.3253581 C18.5902366,10.3566982 20.8780642,10.6358751 22.7948096,11.0084955 L22.7640463,11.1951902 L16.1472466,11.1951902 C16.1472466,11.3195893 16.1472466,11.4437961 16.1159065,11.536855 C18.5279409,11.6608695 20.7542419,11.9098599 22.6098453,12.2824803 L22.5786974,12.4380272 L18.4352665,12.4380272 C18.4043109,12.5314707 18.3425921,12.5935741 18.2802964,12.6558698 L17.7857765,12.6558698 C17.816732,12.5935741 17.8786431,12.5314707 17.909791,12.4380272 L15.9615132,12.4380272 C15.9305576,12.5314707 15.9305576,12.5935741 15.8992175,12.6558698 L15.1260976,12.6558698 L15.1260976,12.6562543 L15.1260976,12.6562543 L15.1260976,12.6562543 Z M14.5068517,14.1475626 C14.5378073,13.9920157 14.5689551,13.8374302 14.6308662,13.6814987 L6.83890877,13.6814987 L6.77718992,13.5570997 C9.09616536,13.0906512 11.9719564,12.779942 15.0642441,12.779942 C15.0642441,12.7487942 15.0951997,12.6872676 15.1261552,12.656312 L15.8986984,12.656312 C15.8986984,12.6872676 15.8675506,12.7487942 15.8675506,12.779942 C16.4553217,12.8110898 17.0738562,12.8110898 17.6302872,12.8733855 C17.6920061,12.8110898 17.7535327,12.7176463 17.784296,12.656312 L18.2790082,12.656312 C18.2480526,12.7487942 18.1861415,12.8110898 18.0930825,12.9045333 C19.7016182,12.9974 21.1544147,13.2152426 22.4533947,13.4636562 L22.4224391,13.6814987 L17.4435925,13.6814987 C17.289007,13.8372379 17.1649924,13.9914389 17.0109837,14.1475626 L16.3926415,14.1475626 C16.6095227,14.0231635 16.7950639,13.8374302 16.9498417,13.6814987 L15.5272317,13.6814987 C15.4962761,13.8372379 15.4651283,14.022779 15.4651283,14.1475626 L14.5068517,14.1475626 L14.5068517,14.1475626 L14.5068517,14.1475626 Z"
                }
            }
        ]
    })(props);
}
function GrScorecard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M9,18 L9,12 M12,18 L12,13 M15,18 L15,10 M17,3 L21,3 L21,23 L3,23 L3,3 L7,3 M7,1 L17,1 L17,5 L7,5 L7,1 Z"
                }
            }
        ]
    })(props);
}
function GrScript(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 1C1.79086 1 0 2.79086 0 5V6H1H5.84699L4.01005 18.8586L4 18.9289V19C4 21.2091 5.79086 23 8 23H20C22.2091 23 24 21.2091 24 19V18H23H18.153L19.99 5.14142L20 5.07107V5C20 2.79086 18.2091 1 16 1H4ZM4 3C3.25972 3 2.61337 3.4022 2.26756 4H5.73244C5.38663 3.4022 4.74028 3 4 3ZM7.46487 3H16C17.0831 3 17.9652 3.86103 17.999 4.93597L16.1327 18H11H10V19C10 20.1046 9.10457 21 8 21C6.91685 21 6.03481 20.139 6.00101 19.064L7.98995 5.14142L8 5.07107V5C8 4.27143 7.80521 3.58835 7.46487 3ZM20 21H11.4649C11.6439 20.6905 11.7827 20.3548 11.874 20H21.7324C21.3866 20.5978 20.7403 21 20 21Z"
                }
            }
        ]
    })(props);
}
function GrSd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 2C2 0.895431 2.89543 0 4 0H17C17.2652 0 17.5196 0.105357 17.7071 0.292893L21.7071 4.29289C21.8946 4.48043 22 4.73478 22 5V22C22 23.1046 21.1046 24 20 24H4C2.89543 24 2 23.1046 2 22V2ZM16.5858 2L4 2V22H20V5.41421L16.5858 2ZM5 7V3H7V7H5ZM8 3V7H10V3H8ZM11 7V3H13V7H11ZM14 5V7H16V5H14Z"
                }
            }
        ]
    })(props);
}
function GrSearchAdvanced(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M15,16 L21,22 L15,16 Z M10,18 C13.8659932,18 17,14.8659932 17,11 C17,7.13400675 13.8659932,4 10,4 C6.13400675,4 3,7.13400675 3,11 C3,14.8659932 6.13400675,18 10,18 Z M20,1 L20,7 M17,4 L23,4"
                }
            }
        ]
    })(props);
}
function GrSearch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M15,15 L22,22 L15,15 Z M9.5,17 C13.6421356,17 17,13.6421356 17,9.5 C17,5.35786438 13.6421356,2 9.5,2 C5.35786438,2 2,5.35786438 2,9.5 C2,13.6421356 5.35786438,17 9.5,17 Z"
                }
            }
        ]
    })(props);
}
function GrSecure(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M7,11 L7,6 C7,3 9,1 12,1 C15,1 17,3 17,6 L17,11 M12,23 C15.8659932,23 19,19.8659932 19,16 C19,12.1340068 15.8659932,9 12,9 C8.13400675,9 5,12.1340068 5,16 C5,19.8659932 8.13400675,23 12,23 Z M12,15 L12,19 M12,16 C12.5522847,16 13,15.5522847 13,15 C13,14.4477153 12.5522847,14 12,14 C11.4477153,14 11,14.4477153 11,15 C11,15.5522847 11.4477153,16 12,16 Z"
                }
            }
        ]
    })(props);
}
function GrSelect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M8,1 L14,1 L8,1 Z M19.188,19.472 L16,22 L12.5,17.5 L9.5,21 L7,7 L20,13.5 L15.5,15 L19.188,19.472 Z M19,4 L19,1 L16,1 M6,1 L3,1 L3,4 M3,14 L3,17 L6,17 M19,6 L19,10 L19,6 Z M3,12 L3,6 L3,12 Z"
                }
            }
        ]
    })(props);
}
function GrSelection(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M5,18 L8,18 L8,6 L5,6 L5,18 Z M12,2 L12,22 L12,2 Z M1,22 L23,22 L23,2 L1,2 L1,22 Z"
                }
            }
        ]
    })(props);
}
function GrSemantics(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2,17 L12,12 L22,17 L22,21 L12,16 L2,21 L2,17 Z M2,8 L12,3 L22,8 L22,12 L12,7 L2,12 L2,8 Z"
                }
            }
        ]
    })(props);
}
function GrSend(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M22,3 L2,11 L20.5,19 L22,3 Z M10,20.5 L13,16 M15.5,9.5 L9,14 L9.85884537,20.0119176 C9.93680292,20.5576204 10.0751625,20.5490248 10.1651297,20.009222 L11,15 L15.5,9.5 Z"
                }
            }
        ]
    })(props);
}
function GrServerCluster(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,8 L23,8 L23,1 L1,1 L1,8 Z M11,5 L12,5 L12,4 L11,4 L11,5 Z M19,5 L20,5 L20,4 L19,4 L19,5 Z M15,5 L16,5 L16,4 L15,4 L15,5 Z M11,12 L12,12 L12,11 L11,11 L11,12 Z M19,12 L20,12 L20,11 L19,11 L19,12 Z M15,12 L16,12 L16,11 L15,11 L15,12 Z M11,19 L12,19 L12,18 L11,18 L11,19 Z M19,19 L20,19 L20,18 L19,18 L19,19 Z M15,19 L16,19 L16,18 L15,18 L15,19 Z M1,15 L23,15 L23,8 L1,8 L1,15 Z M1,22 L23,22 L23,15 L1,15 L1,22 Z M21,23 L3,23"
                }
            }
        ]
    })(props);
}
function GrServer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M14,19 L15,19 L15,18 L14,18 L14,19 Z M5,23 L19,23 L19,1 L5,1 L5,23 Z M8,5 L16,5 L8,5 Z M8,9 L16,9 L8,9 Z M8,13 L16,13 L8,13 Z"
                }
            }
        ]
    })(props);
}
function GrServers(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M7,19 L8,19 L8,18 L7,18 L7,19 Z M18,19 L19,19 L19,18 L18,18 L18,19 Z M1,23 L12,23 L12,1 L1,1 L1,23 Z M12,23 L23,23 L23,1 L12,1 L12,23 Z M4,5 L9,5 L4,5 Z M15,5 L20,5 L15,5 Z M4,9 L9,9 L4,9 Z M15,9 L20,9 L15,9 Z M4,13 L9,13 L4,13 Z M15,13 L20,13 L15,13 Z"
                }
            }
        ]
    })(props);
}
function GrServicePlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M7,13 C10.3137085,13 13,10.3137085 13,7 C13,3.6862915 10.3137085,1 7,1 C3.6862915,1 1,3.6862915 1,7 C1,10.3137085 3.6862915,13 7,13 Z M14.995457,16.6569808 L14.995457,16.6569808 C15.6222982,16.8791083 16.2970312,17 17,17 C20.3137085,17 23,14.3137085 23,11 C23,7.6862915 20.3137085,5 17,5 C15.5133616,5 14.1530044,5.54067366 13.1048383,6.43611087 M4.82356548,12.6921643 C3.69893809,13.7826979 3,15.3097261 3,17 C3,20.3137085 5.6862915,23 9,23 L9,23 C12.3137085,23 15,20.3137085 15,17 C15,14.4351166 13.3906156,12.2461251 11.1265973,11.3877758 M6.5,6 L8,7 L6.5,8 L6.5,6 Z"
                }
            }
        ]
    })(props);
}
function GrServices(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M6,9 C7.65685425,9 9,7.65685425 9,6 C9,4.34314575 7.65685425,3 6,3 C4.34314575,3 3,4.34314575 3,6 C3,7.65685425 4.34314575,9 6,9 Z M6,3 L6,0 M6,12 L6,9 M0,6 L3,6 M9,6 L12,6 M2,2 L4,4 M8,8 L10,10 M10,2 L8,4 M4,8 L2,10 M18,12 C19.6568542,12 21,10.6568542 21,9 C21,7.34314575 19.6568542,6 18,6 C16.3431458,6 15,7.34314575 15,9 C15,10.6568542 16.3431458,12 18,12 Z M18,6 L18,3 M18,15 L18,12 M12,9 L15,9 M21,9 L24,9 M14,5 L16,7 M20,11 L22,13 M22,5 L20,7 M16,11 L14,13 M9,21 C10.6568542,21 12,19.6568542 12,18 C12,16.3431458 10.6568542,15 9,15 C7.34314575,15 6,16.3431458 6,18 C6,19.6568542 7.34314575,21 9,21 Z M9,15 L9,12 M9,24 L9,21 M3,18 L6,18 M12,18 L15,18 M5,14 L7,16 M11,20 L13,22 M13,14 L11,16 M7,20 L5,22"
                }
            }
        ]
    })(props);
}
function GrSettingsOption(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,9 L12,0 M15,12 L24,12 M0,12 L9,12 M12,24 L12,15 M12,21 C16.9705627,21 21,16.9705627 21,12 C21,7.02943725 16.9705627,3 12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 Z M3.5,8.5 L1,7.5 M20.5,15.5 L23,16.5 M3,3 L5.5,5.5 M3,3 L5.5,5.5 M18,18 L20.5,20.5 M20.5,3 L18,5.5 M5.5,18 L3,20.5 M12,15 C13.6568542,15 15,13.6568542 15,12 C15,10.3431458 13.6568542,9 12,9 C10.3431458,9 9,10.3431458 9,12 C9,13.6568542 10.3431458,15 12,15 Z M20.5,8.5 L23,7.5 M15.5,3.5 L16.5,1 M15.5,20.5 L16.5,23 M8.5,20.5 L7.5,23 M3.5,15.5 L1,16.5 M8.5,3.5 L7.5,1"
                }
            }
        ]
    })(props);
}
function GrShareOption(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M18,8 C19.6568542,8 21,6.65685425 21,5 C21,3.34314575 19.6568542,2 18,2 C16.3431458,2 15,3.34314575 15,5 C15,6.65685425 16.3431458,8 18,8 Z M6,15 C7.65685425,15 9,13.6568542 9,12 C9,10.3431458 7.65685425,9 6,9 C4.34314575,9 3,10.3431458 3,12 C3,13.6568542 4.34314575,15 6,15 Z M18,22 C19.6568542,22 21,20.6568542 21,19 C21,17.3431458 19.6568542,16 18,16 C16.3431458,16 15,17.3431458 15,19 C15,20.6568542 16.3431458,22 18,22 Z M16,18 L8,13 M16,6 L8,11"
                }
            }
        ]
    })(props);
}
function GrShareRounded(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M20.9241 3.61722C20.8757 3.50014 20.804 3.3904 20.7092 3.29502C20.7078 3.2936 20.7064 3.29219 20.705 3.29078C20.5242 3.11106 20.2751 3 20 3H19.9998H14C13.4477 3 13 3.44772 13 4C13 4.55228 13.4477 5 14 5H17.5858L10.2929 12.2929C9.90237 12.6834 9.90237 13.3166 10.2929 13.7071C10.6834 14.0976 11.3166 14.0976 11.7071 13.7071L19 6.41421V10C19 10.5523 19.4477 11 20 11C20.5523 11 21 10.5523 21 10V4.00069C21 3.99946 21 3.99823 21 3.997C20.9996 3.86774 20.9743 3.73854 20.9241 3.61722ZM3 8C3 5.23858 5.23858 3 8 3H9C9.55228 3 10 3.44772 10 4C10 4.55228 9.55228 5 9 5H8C6.34315 5 5 6.34315 5 8V16C5 17.6569 6.34315 19 8 19H16C17.6569 19 19 17.6569 19 16V15C19 14.4477 19.4477 14 20 14C20.5523 14 21 14.4477 21 15V16C21 18.7614 18.7614 21 16 21H8C5.23858 21 3 18.7614 3 16V8Z"
                }
            }
        ]
    })(props);
}
function GrShare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M19,13 L19,23 L1,23 L1,5 L1,5 L11,5 M14,1 L23,1 L23,10 M10,14 L22.9999998,1 L10,14 Z"
                }
            }
        ]
    })(props);
}
function GrShieldSecurity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,22 C12,22 2.99999999,18 3,11 L3,5 L12,2 L21,5 C21,5 21,11 21,11 C21,18 12,22 12,22 Z M12,14 C13.6568542,14 15,12.6568542 15,11 C15,9.34314575 13.6568542,8 12,8 C10.3431458,8 9,9.34314575 9,11 C9,12.6568542 10.3431458,14 12,14 Z M12,8 L12,5 M12,17 L12,14 M6,11 L9,11 M15,11 L18,11 M8,7 L10,9 M14,13 L16,15 M16,7 L14,9 M10,13 L8,15"
                }
            }
        ]
    })(props);
}
function GrShield(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,22 C12,22 3,18 3,5 C3,5 12,2 12,2 C12,2 21,5 21,5 C21,18 12,22 12,22 Z M4,11 L20,11 M12,2 L12,22"
                }
            }
        ]
    })(props);
}
function GrShift(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,0 L12,24 M2,12 L12,12 M22,12 L12,12 M6,8 L2,12 L6,16 M18,8 L22,12 L18,16"
                }
            }
        ]
    })(props);
}
function GrShop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeWidth": "2",
                    "d": "M4,7 L20,7 L20,23 L4,23 L4,7 Z M8,9 L8,5 C8,2.790861 9.79535615,1 12,1 L12,1 C14.209139,1 16,2.79535615 16,5 L16,9"
                }
            }
        ]
    })(props);
}
function GrSidebar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,22 L23,22 L23,2 L1,2 L1,22 Z M16,2 L16,22 L16,2 Z"
                }
            }
        ]
    })(props);
}
function GrSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M8,23 C10,23 12.9996892,23 15,23 C18,23 19,21 19,18 L19,6 C19,4.00000008 18,3.99999992 17.5,4 C17,4.00000008 15.9998779,4.00000008 15.9998779,5.99999984 L15.9998779,13 C15.9998777,12 16.0001888,10.9999999 14.5003109,10.9999999 C13.000433,10.9999999 13,13 13,13 C13,12 13,11 11.5,10.9999999 C10,10.9999999 10,12 10,12.9999999 L10,4 C10,3 10.029402,2 8.5,2 C7,2 7,3 7,4 L7,18 L7,14 C7,13 6.44999986,12 5.00000005,12 C5,12 4,12 4,12 C4,12 4.00000001,14.0384045 4,18 C3.99999999,21.9615955 6,23.023861 8,23 Z"
                }
            }
        ]
    })(props);
}
function GrSkype(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.05175,18.85575 C8.025,18.85575 6.22425,16.8765 6.22425,15.393 C6.22425,14.63175 6.786,14.0985 7.56,14.0985 C9.2835,14.0985 8.83725,16.57275 12.05175,16.57275 C13.69725,16.57275 14.60625,15.67875 14.60625,14.7645 C14.60625,14.21475 14.33475,13.605 13.251,13.338 L9.66975,12.444 C6.786,11.721 6.2625,10.16175 6.2625,8.69625 C6.2625,5.65275 9.1275,4.5105 11.8185,4.5105 C14.2965,4.5105 17.2185,5.88 17.2185,7.7055 C17.2185,8.48775 16.54125,8.943 15.76725,8.943 C14.2965,8.943 14.56725,6.9075 11.6055,6.9075 C10.1355,6.9075 9.32175,7.5735 9.32175,8.526 C9.32175,9.47625 10.48275,9.78 11.49,10.0095 L14.14125,10.59825 C17.0445,11.24475 17.78025,12.93975 17.78025,14.5365 C17.78025,17.00925 15.88275,18.85575 12.05175,18.85575 M23.15025,13.9695 C23.14275,14.0115 23.1375,14.05425 23.12925,14.09625 L23.08875,13.85475 C23.1105,13.89225 23.12925,13.93125 23.15025,13.9695 C23.274,13.29525 23.33925,12.60525 23.33925,11.91525 C23.33925,10.38525 23.03925,8.901 22.44825,7.50375 C21.87675,6.1545 21.06075,4.9425 20.019,3.9015 C18.97875,2.8605 17.766,2.04375 16.41675,1.473 C15.02025,0.882 13.536,0.58275 12.00675,0.58275 C11.28525,0.58275 10.563,0.65025 9.86025,0.78525 C9.85875,0.78525 9.85725,0.78525 9.855,0.786 C9.89475,0.807 9.9345,0.82575 9.9735,0.8475 L9.735,0.81 C9.77475,0.8025 9.81525,0.79425 9.855,0.786 C8.8905,0.27375 7.80675,0 6.70875,0 C4.917,0 3.23175,0.6975 1.965,1.965 C0.69825,3.23175 0,4.917 0,6.7095 C0,7.8495 0.29325,8.97075 0.84375,9.96225 C0.8505,9.921 0.85575,9.879 0.864,9.8385 L0.90525,10.07625 C0.8835,10.03875 0.86475,9.99975 0.84375,9.96225 C0.732,10.6035 0.67275,11.25975 0.67275,11.91525 C0.67275,13.44525 0.97275,14.9295 1.5645,16.32675 C2.1345,17.67675 2.952,18.888 3.99225,19.929 C5.03325,20.96925 6.2445,21.7875 7.59525,22.35675 C8.99175,22.94925 10.47675,23.2485 12.00675,23.2485 C12.672,23.2485 13.3395,23.18775 13.99125,23.07225 C13.953,23.05125 13.914,23.03175 13.87575,23.00925 L14.118,23.052 C14.076,23.0595 14.034,23.06475 13.99125,23.07225 C14.99475,23.64075 16.131,23.94225 17.29125,23.94225 C19.08375,23.94225 20.7675,23.2455 22.035,21.97725 C23.3025,20.71125 24,19.026 24,17.2335 C24,16.089 23.70525,14.964 23.15025,13.9695"
                }
            }
        ]
    })(props);
}
function GrSlack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none",
                    "fillRule": "evenodd"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M5.04765714 15.1238095C5.04765714 16.5142857 3.92384762 17.6380952 2.53337143 17.6380952 1.14289524 17.6380952.0190857143 16.5142857.0190857143 15.1238095.0190857143 13.7333333 1.14289524 12.6095238 2.53337143 12.6095238L5.04765714 12.6095238 5.04765714 15.1238095zM6.30472381 15.1238095C6.30472381 13.7333333 7.42853333 12.6095238 8.81900952 12.6095238 10.2094857 12.6095238 11.3332952 13.7333333 11.3332952 15.1238095L11.3332952 21.4095238C11.3332952 22.8 10.2094857 23.9238095 8.81900952 23.9238095 7.42853333 23.9238095 6.30472381 22.8 6.30472381 21.4095238L6.30472381 15.1238095z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M8.81904762 5.02857143C7.42857143 5.02857143 6.3047619 3.9047619 6.3047619 2.51428571 6.3047619 1.12380952 7.42857143 0 8.81904762 0 10.2095238 0 11.3333333 1.12380952 11.3333333 2.51428571L11.3333333 5.02857143 8.81904762 5.02857143zM8.81904762 6.3048C10.2095238 6.3048 11.3333333 7.42860952 11.3333333 8.81908571 11.3333333 10.2095619 10.2095238 11.3333714 8.81904762 11.3333714L2.51428571 11.3333714C1.12380952 11.3333714 0 10.2095619 0 8.81908571 0 7.42860952 1.12380952 6.3048 2.51428571 6.3048L8.81904762 6.3048z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M18.895219 8.81902857C18.895219 7.42855238 20.0190286 6.30474286 21.4095048 6.30474286 22.799981 6.30474286 23.9237905 7.42855238 23.9237905 8.81902857 23.9237905 10.2095048 22.799981 11.3333143 21.4095048 11.3333143L18.895219 11.3333143 18.895219 8.81902857zM17.6380571 8.81902857C17.6380571 10.2095048 16.5142476 11.3333143 15.1237714 11.3333143 13.7332952 11.3333143 12.6094857 10.2095048 12.6094857 8.81902857L12.6094857 2.51426667C12.6094857 1.12379048 13.7332952-.0000190476191 15.1237714-.0000190476191 16.5142476-.0000190476191 17.6380571 1.12379048 17.6380571 2.51426667L17.6380571 8.81902857z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M15.1238286 18.8952C16.5143048 18.8952 17.6381143 20.0190095 17.6381143 21.4094857 17.6381143 22.7999619 16.5143048 23.9237714 15.1238286 23.9237714 13.7333524 23.9237714 12.6095429 22.7999619 12.6095429 21.4094857L12.6095429 18.8952 15.1238286 18.8952zM15.1238286 17.6381333C13.7333524 17.6381333 12.6095429 16.5143238 12.6095429 15.1238476 12.6095429 13.7333714 13.7333524 12.6095619 15.1238286 12.6095619L21.4285905 12.6095619C22.8190667 12.6095619 23.9428762 13.7333714 23.9428762 15.1238476 23.9428762 16.5143238 22.8190667 17.6381333 21.4285905 17.6381333L15.1238286 17.6381333z"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function GrSnapchat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12.1511006,22.5316101 C12.0830801,22.5316101 12.0181804,22.5291262 11.9688209,22.5267697 C11.9296518,22.5301452 11.8892088,22.5316101 11.8487022,22.5316101 C10.4196979,22.5316101 9.46422593,21.8560541 8.62103883,21.259537 C8.01668787,20.8326253 7.44672931,20.4295973 6.77900716,20.3185226 C6.45106922,20.2641317 6.12485091,20.236554 5.8096509,20.236554 C5.24173041,20.236554 4.79290954,20.3246368 4.46522636,20.3887086 C4.26358497,20.4280051 4.08971226,20.4618243 3.95532713,20.4618243 C3.81457303,20.4618243 3.64356636,20.4306164 3.57229765,20.1872583 C3.51580495,19.9952977 3.47529834,19.809324 3.4361929,19.6302287 C3.33836562,19.1826816 3.26741536,18.9095168 3.09984793,18.8835951 C1.30755787,18.6070547 0.248590282,18.1996958 0.0376502063,17.7063558 C0.0155499024,17.6545125 0.00319411295,17.6023507 0.00045545858,17.5507621 C-0.00776050453,17.4037027 0.096053603,17.2747312 0.241011216,17.2507202 C1.66434721,17.0163423 2.92992398,16.2640403 4.00277591,15.0140038 C4.83386197,14.0462398 5.24198516,13.1215937 5.28580363,13.0194992 C5.28771432,13.0149135 5.28994346,13.0100731 5.29223629,13.0056785 C5.49903654,12.5860912 5.54018004,12.2235061 5.41490253,11.9283046 C5.18396391,11.3836946 4.41911506,11.141037 3.9131009,10.9804755 C3.78725018,10.9406695 3.66821425,10.9029652 3.57338038,10.8653246 C3.12481427,10.68814 2.38709721,10.3137724 2.48537032,9.79705834 C2.55695747,9.42027045 3.05532887,9.15786915 3.45810214,9.15786915 C3.56994114,9.15786915 3.66904221,9.17748555 3.75247564,9.21665468 C4.20760178,9.42988758 4.61706245,9.5379689 4.96920245,9.5379689 C5.40713239,9.5379689 5.61864568,9.37122943 5.66978845,9.32384434 C5.65717791,9.09023075 5.64176501,8.84324234 5.62686164,8.60962875 C5.62686164,8.609374 5.62654319,8.60657165 5.62654319,8.60657165 C5.52374812,6.97134023 5.39554088,4.93632897 5.91607628,3.76934376 C7.47405217,0.276158264 10.7780794,0.00452196419 11.7532952,0.00452196419 C11.7792805,0.00452196419 12.1783598,0.000573206729 12.1783598,0.000573206729 C12.196384,0.000254758546 12.2159367,0 12.23619,0 C13.2140807,0 16.5249864,0.271954748 18.0839176,3.767242 C18.604453,4.93499149 18.4761184,6.97172237 18.3730049,8.60867341 L18.3681645,8.68701166 C18.3540254,8.90928849 18.340969,9.11965536 18.3299507,9.32358958 C18.3781001,9.36791757 18.5716529,9.52077269 18.9654459,9.53624928 C19.301154,9.52338397 19.6869221,9.41581217 20.111732,9.21690944 C20.24306,9.15525787 20.3884635,9.14245625 20.4871824,9.14245625 C20.6364072,9.14245625 20.7882433,9.17149873 20.9147946,9.22429744 L20.9215457,9.22690871 C21.2820291,9.35486119 21.5181265,9.61057508 21.5232217,9.87921797 C21.5277437,10.1296456 21.3416426,10.5039496 20.4262951,10.865452 C20.332544,10.902583 20.2129348,10.9405421 20.0865746,10.9806029 C19.5801146,11.1413555 18.8159026,11.3838856 18.584964,11.9281773 C18.4594954,12.2233787 18.5007663,12.5858365 18.7076303,13.0052964 C18.7099231,13.0098821 18.7118975,13.0145314 18.7141266,13.0193718 C18.7778162,13.1686603 20.3194239,16.683755 23.758919,17.2504017 C23.9038129,17.2745401 24.0078181,17.403639 23.9995385,17.5504436 C23.9964814,17.6031786 23.9837434,17.6559137 23.9614521,17.7074386 C23.7519768,18.1980398 22.693073,18.6048256 20.9002734,18.8817481 C20.7320054,18.9077335 20.6611188,19.1796882 20.5641832,19.6248788 C20.5240587,19.8087507 20.4832336,19.9889924 20.4275052,20.1784054 C20.3753434,20.3565453 20.2593009,20.443609 20.072945,20.443609 L20.0448579,20.443609 C19.9235291,20.443609 19.7516308,20.4215724 19.5348313,20.3791551 C19.1558779,20.3054025 18.730877,20.2367451 18.1904067,20.2367451 C17.8752704,20.2367451 17.5491158,20.2643864 17.2207957,20.3187137 C16.5537741,20.4297884 15.9838793,20.8321795 15.380611,21.2586453 C14.535768,21.8559904 13.5799776,22.5316101 12.1511006,22.5316101"
                }
            }
        ]
    })(props);
}
function GrSolaris(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M10.1802464,4.7643196 C9.30783675,4.45498283 8.90876565,3.63737375 8.90876565,3.63737375 C8.84089823,3.54283936 8.5558284,2.85816509 8.5562284,2.85789842 C8.25689174,2.06482294 7.71088568,1.82242025 7.71088568,1.82242025 C7.03954488,1.42788253 6.21046901,1.41801576 6.21046901,1.41801576 C6.24620274,1.4132157 6.70394115,1.62521806 6.70394115,1.62521806 C7.78395316,2.13989044 7.46048289,3.3691041 7.46048289,3.3691041 C7.39021545,3.70004111 7.37381526,4.33911488 7.37381526,4.33911488 C7.35914843,5.19085768 7.96582184,5.60659563 8.03302259,5.65099612 C8.3674263,5.44779386 8.7239636,5.26739186 9.09756775,5.1147235 C9.45570506,4.96832187 9.81744242,4.85138724 10.1802464,4.7643196 M5.59699552,8.17022411 C4.76098623,8.56862854 3.90111001,8.27249192 3.90111001,8.27249192 C3.78604207,8.25382504 3.10043445,7.97115524 3.10043445,7.97115524 C2.32802587,7.62208469 1.77081968,7.83648707 1.77081968,7.83648707 C1.0168113,8.03182258 0.423738042,8.61142902 0.423738042,8.61142902 C0.445338282,8.58276203 0.919076879,8.40889343 0.919076879,8.40889343 C2.04668941,8.00915566 2.68682985,9.10716786 2.68682985,9.10716786 C2.87149857,9.39063767 3.31177013,9.85410949 3.31177013,9.85410949 C3.9033767,10.4670496 4.62685141,10.3319815 4.70538562,10.3161146 C4.79818665,9.93531039 4.9228547,9.55610618 5.0791231,9.18383538 C5.2288581,8.82703141 5.40166002,8.48876099 5.59699552,8.17022411 M4.76458627,13.8196202 C4.45511617,14.6924299 3.63764042,15.0916344 3.63764042,15.0916344 C3.54310603,15.1592351 2.85843176,15.4444383 2.85816509,15.4443049 C2.06508961,15.7436416 1.82268692,16.2895143 1.82268692,16.2895143 C1.42788253,16.9605885 1.41854909,17.7897977 1.41854909,17.7897977 C1.41361571,17.7540639 1.62535139,17.2963255 1.62535139,17.2963255 C2.14002378,16.2163135 3.36950411,16.5401838 3.36950411,16.5401838 C3.70004111,16.6097846 4.33898154,16.6264514 4.33898154,16.6264514 C5.19085768,16.6415182 5.6068623,16.0343115 5.65099612,15.9676441 C5.4479272,15.6325737 5.26765853,15.2763031 5.1151235,14.9026989 C4.96832187,14.5444283 4.8512539,14.1826909 4.76458627,13.8196202 M8.17075745,18.4032711 C8.56889521,19.2391471 8.27315859,20.0994233 8.27315859,20.0994233 C8.25435838,20.2138246 7.97155524,20.9000989 7.97128857,20.8999656 C7.62195136,21.6722408 7.83675374,22.2297137 7.83675374,22.2297137 C8.03195591,22.9835887 8.61169569,23.5767953 8.61169569,23.5767953 C8.5830287,23.5549284 8.40902677,23.0813231 8.40902677,23.0813231 C8.00942233,21.9535773 9.1077012,21.3135702 9.1077012,21.3135702 C9.39103768,21.1287681 9.85464283,20.6884965 9.85464283,20.6884965 C10.4673163,20.09689 10.3325148,19.3735486 10.3163813,19.2951477 C9.9357104,19.2019467 9.55610618,19.077412 9.18370204,18.9211436 C8.82703141,18.7716752 8.48876099,18.5984733 8.17075745,18.4032711 M13.8200202,19.2359471 C14.6929633,19.5448838 15.0917677,20.3626263 15.0917677,20.3626263 C15.1596351,20.4571606 15.4445716,21.1421016 15.4441716,21.1423682 C15.7435083,21.9353104 16.289781,22.1777131 16.289781,22.1777131 C16.9609885,22.5727841 17.7900643,22.5822509 17.7900643,22.5822509 C17.7545973,22.5869176 17.2967255,22.3749153 17.2967255,22.3749153 C16.2163135,21.8602429 16.5403171,20.6311626 16.5403171,20.6311626 C16.6103179,20.3000922 16.6264514,19.6612851 16.6264514,19.6612851 C16.6416516,18.8092757 16.0344448,18.393271 15.9680441,18.3492705 C15.6328404,18.5524728 15.2767031,18.7326081 14.9026989,18.8852765 C14.5448283,19.0319448 14.1833576,19.1488794 13.8200202,19.2359471 M18.4035378,15.8299092 C19.2394138,15.4312381 20.09969,15.7275081 20.09969,15.7275081 C20.2146246,15.7463083 20.9002322,16.0291114 20.8999656,16.0293781 C21.6726408,16.3783153 22.2299803,16.1636463 22.2299803,16.1636463 C22.984122,15.9681774 23.5769286,15.3887043 23.5769286,15.3887043 C23.5551951,15.4175046 23.0818565,15.5911066 23.0818565,15.5911066 C21.9538439,15.990711 21.3135702,14.8928321 21.3135702,14.8928321 C21.1287681,14.6093623 20.6887632,14.1460238 20.6887632,14.1460238 C20.0970233,13.532817 19.3736819,13.6680185 19.2952811,13.6838854 C19.2023467,14.0645563 19.0775453,14.4441605 18.9214102,14.816298 C18.7720752,15.1731019 18.5988733,15.5113723 18.4035378,15.8299092 M19.2364804,10.1802464 C19.5455505,9.30757008 20.3628929,8.90849898 20.3628929,8.90849898 C20.4574273,8.84063156 21.1426349,8.55542839 21.1429016,8.55596173 C21.9351771,8.25662507 22.1777131,7.71101901 22.1777131,7.71101901 C22.5726508,7.03927821 22.5826509,6.21046901 22.5826509,6.21046901 C22.587051,6.24593607 22.3753153,6.70367449 22.3753153,6.70367449 C21.8606429,7.78368649 20.6312959,7.46021622 20.6312959,7.46021622 C20.3003589,7.39034878 19.6615518,7.37368193 19.6615518,7.37368193 C18.809409,7.35848176 18.393671,7.96582184 18.3492705,8.03235592 C18.5527395,8.36729297 18.7330081,8.72383026 18.8854098,9.09756775 C19.0323448,9.45557173 19.1488794,9.81730908 19.2364804,10.1802464 M15.8303092,5.59659552 C15.4316381,4.76111957 15.7273747,3.90084334 15.7273747,3.90084334 C15.7464416,3.78604207 16.0289781,3.09990111 16.0296448,3.10030111 C16.378582,2.32789253 16.1639129,1.77055301 16.1639129,1.77055301 C15.9681774,1.01641129 15.3892377,0.423471372 15.3892377,0.423471372 C15.417638,0.445338282 15.5916399,0.918810209 15.5916399,0.918810209 C15.9909777,2.04642274 14.8928321,2.68669652 14.8928321,2.68669652 C14.609629,2.87163191 14.1464238,3.31150346 14.1464238,3.31150346 C13.5330837,3.9029767 13.6684185,4.62658474 13.6844187,4.70525228 C14.0649563,4.79791998 14.4445605,4.92298803 14.8164313,5.07885643 C15.1732353,5.22819142 15.511639,5.40139335 15.8301759,5.59659552 M7.58741764,5.98366649 C6.66234069,6.02633363 5.98473316,5.41926021 5.98473316,5.41926021 C5.88633207,5.35752619 5.36419294,4.83058701 5.36432627,4.830187 C4.78831987,4.2085801 4.19124657,4.19017989 4.19124657,4.19017989 C3.42070467,4.07711197 2.64896277,4.38084868 2.64896277,4.38084868 C2.68016311,4.36271514 3.18416871,4.38658207 3.18416871,4.38658207 C4.37844865,4.45618285 4.5417838,5.71699686 4.5417838,5.71699686 C4.60205113,6.04966722 4.82752031,6.6478072 4.82752031,6.6478072 C5.13472372,7.44248269 5.85366504,7.5987511 5.93233258,7.61448461 C6.16580184,7.30021445 6.42793809,6.99874443 6.71660796,6.71660796 C6.99314437,6.44580495 7.2839476,6.20113557 7.58741764,5.98366649 M4.6256514,10.8662541 C4.00151113,11.5502617 3.0933677,11.6003956 3.0933677,11.6003956 C2.97989978,11.6261292 2.23829154,11.6227958 2.23829154,11.6223958 C1.39108212,11.5899954 0.955743953,11.9990667 0.955743953,11.9990667 C0.331337015,12.4642718 0,13.2248136 0,13.2248136 C0.00946677185,13.1897466 0.382670919,12.8502761 0.382670919,12.8502761 C1.27641418,12.0552006 2.2833587,12.8309426 2.2833587,12.8309426 C2.56109512,13.0237447 3.14363493,13.2873476 3.14363493,13.2873476 C3.92271025,13.6320181 4.5417838,13.234147 4.60845121,13.1896132 C4.5513839,12.8021422 4.52338359,12.4037378 4.52805031,12.0002667 C4.53218369,11.612929 4.56498406,11.2343915 4.6256514,10.8662541 M5.98393315,16.4127157 C6.02646696,17.3377926 5.41952688,18.0155335 5.41952688,18.0155335 C5.35752619,18.1140679 4.83058701,18.6360737 4.83032034,18.6359404 C4.2085801,19.2119468 4.19004656,19.8090201 4.19004656,19.8090201 C4.07711197,20.5794287 4.38084868,21.3513039 4.38084868,21.3513039 C4.36284848,21.3201036 4.38658207,20.8162313 4.38658207,20.8162313 C4.45631618,19.6216847 5.71673019,19.4584829 5.71673019,19.4584829 C6.04966722,19.3982155 6.6478072,19.1728797 6.6478072,19.1728797 C7.44248269,18.8658096 7.59901777,18.1466016 7.61461794,18.0680674 C7.30021445,17.8343315 6.9990111,17.5721952 6.7167413,17.2836587 C6.44580495,17.007389 6.2012689,16.7163191 5.98393315,16.4127157 M10.8663874,19.3746153 C11.550395,19.9987555 11.6002622,20.906899 11.6002622,20.906899 C11.6262625,21.0203669 11.6227958,21.7622418 11.6225291,21.7622418 C11.5902621,22.6090512 11.9993333,23.0446561 11.9993333,23.0446561 C12.4644052,23.6693297 13.2248136,24 13.2248136,24 C13.1900132,23.9905332 12.8504094,23.6175958 12.8504094,23.6175958 C12.0552006,22.7237192 12.8310759,21.7170413 12.8310759,21.7170413 C13.023878,21.4391715 13.2873476,20.8566317 13.2873476,20.8566317 C13.6320181,20.0775564 13.2340137,19.4584829 13.1900132,19.3916821 C12.8022756,19.4491494 12.4038712,19.4767497 12.0001333,19.4722164 C11.6131957,19.4679496 11.2345248,19.4354159 10.8663874,19.3746153 M16.4129824,18.0166002 C17.3380593,17.9740664 18.0155335,18.5810065 18.0155335,18.5810065 C18.1140679,18.6427405 18.6363404,19.1696797 18.6359404,19.1699463 C19.2119468,19.7916866 19.8092868,19.8104868 19.8092868,19.8104868 C20.5798287,19.923288 21.3514372,19.6195513 21.3514372,19.6195513 C21.3202369,19.6372849 20.8162313,19.6136846 20.8162313,19.6136846 C19.621818,19.5439505 19.4584829,18.2834031 19.4584829,18.2834031 C19.3983489,17.9505995 19.1727464,17.3525928 19.1727464,17.3525928 C18.8656763,16.557784 18.1466016,16.4012489 18.0682008,16.3855154 C17.8345982,16.7001856 17.5723286,17.0013889 17.2836587,17.2835254 C17.007389,17.5544617 16.7164524,17.7989978 16.4129824,18.0166002 M19.3748819,13.1341459 C19.9988889,12.4497383 20.9070323,12.3998711 20.9070323,12.3998711 C21.0206336,12.3740042 21.7625085,12.3772042 21.7625085,12.3780042 C22.6093179,12.4098712 23.0446561,12.0008 23.0446561,12.0008 C23.669463,11.5355948 24.0004,10.7755864 24.0004,10.7755864 C23.9907999,10.8102534 23.6177291,11.1498572 23.6177291,11.1498572 C22.7239858,11.9451994 21.7167746,11.1693241 21.7167746,11.1693241 C21.4391715,10.9763886 20.8568984,10.7130524 20.8568984,10.7130524 C20.0775564,10.3682485 19.4584829,10.7659863 19.3919488,10.8102534 C19.4491494,11.1978578 19.4767497,11.5965289 19.472083,12 C19.4683496,12.3869376 19.4354159,12.7654752 19.3748819,13.1341459 M18.0167335,7.5872843 C17.973933,6.66220736 18.5808731,5.98473316 18.5808731,5.98473316 C18.6430071,5.88619874 19.1699463,5.36379293 19.170213,5.3640596 C19.7916866,4.78831987 19.8104868,4.19124657 19.8104868,4.19124657 C19.9231547,3.42030467 19.619818,2.64896277 19.619818,2.64896277 C19.6375515,2.68002978 19.6136846,3.18416871 19.6136846,3.18416871 C19.5439505,4.37844865 18.2835365,4.54165046 18.2835365,4.54165046 C17.9505995,4.6019178 17.3527261,4.82752031 17.3527261,4.82752031 C16.557784,5.13445705 16.4013822,5.85366504 16.3853821,5.93206591 C16.7000522,6.16553517 17.0013889,6.42820476 17.2835254,6.71647463 C17.5547284,6.9928777 17.7989978,7.28354759 18.0167335,7.5872843 M13.1341459,4.62551806 C12.450005,4.00164446 12.3997378,3.09323437 12.3997378,3.09323437 C12.3742708,2.97963311 12.3773375,2.23789153 12.3778709,2.23789153 C12.4101379,1.39094879 12.0012,0.955743953 12.0012,0.955743953 C11.5358615,0.330803676 10.7757197,0 10.7757197,0 C10.8103868,0.00946677185 11.1499906,0.382537584 11.1499906,0.382537584 C11.9451994,1.27654752 11.1693241,2.2833587 11.1693241,2.2833587 C10.976522,2.56122846 10.713319,3.14336826 10.713319,3.14336826 C10.3681152,3.92271025 10.766253,4.54165046 10.8103868,4.60858454 C11.1979911,4.5509839 11.5965289,4.52365026 12,4.52818365 C12.3869376,4.53191702 12.7656085,4.56485072 13.1340126,4.62551806"
                }
            }
        ]
    })(props);
}
function GrSort(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M7,3 L22,3 M7,9 L16,9 M7,15 L22,15 M2,2 L4,2 L4,4 L2,4 L2,2 Z M2,8 L4,8 L4,10 L2,10 L2,8 Z M2,14 L4,14 L4,16 L2,16 L2,14 Z M2,20 L4,20 L4,22 L2,22 L2,20 Z M7,21 L16,21"
                }
            }
        ]
    })(props);
}
function GrSoundcloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 15.922c0 .298.108.523.324.676a.885.885 0 0 0 .692.162c.231-.045.393-.127.486-.246.093-.119.14-.316.14-.592v-3.238a.799.799 0 0 0-.24-.587.798.798 0 0 0-.587-.24.785.785 0 0 0-.575.24.797.797 0 0 0-.24.587v3.238Zm2.569 1.385c0 .216.076.378.229.486.152.108.348.162.586.162.246 0 .445-.054.597-.162.153-.108.23-.27.23-.486v-7.55a.785.785 0 0 0-.24-.575.798.798 0 0 0-.587-.24.785.785 0 0 0-.575.24.785.785 0 0 0-.24.576v7.55Zm2.557.358c0 .215.078.377.235.485.156.108.357.162.603.162.238 0 .433-.054.586-.162.153-.108.229-.27.229-.485v-6.891c0-.23-.08-.428-.24-.592a.776.776 0 0 0-.575-.246.807.807 0 0 0-.592.246.807.807 0 0 0-.246.592v6.89Zm2.569.033c0 .41.275.614.826.614.551 0 .827-.204.827-.614V6.53c0-.625-.19-.979-.57-1.06-.246-.06-.488.01-.726.211-.238.201-.357.484-.357.849v11.168Zm2.613.324V5.872c0-.388.116-.619.346-.693a6.542 6.542 0 0 1 4.668.625A6.556 6.556 0 0 1 17.707 8a6.543 6.543 0 0 1 1.055 3.065c.454-.193.938-.29 1.452-.29 1.042 0 1.934.368 2.675 1.106.74.737 1.111 1.623 1.111 2.657 0 1.043-.37 1.933-1.111 2.67-.741.737-1.629 1.105-2.664 1.105l-9.716-.01a.261.261 0 0 1-.15-.124.33.33 0 0 1-.05-.156Z"
                }
            },
            {
                "tag": "defs",
                "attr": {},
                "child": [
                    {
                        "tag": "linearGradient",
                        "attr": {
                            "id": "a",
                            "x1": "30064.2",
                            "x2": "30064.2",
                            "y1": "507.299",
                            "y2": "18096.6",
                            "gradientUnits": "userSpaceOnUse"
                        },
                        "child": [
                            {
                                "tag": "stop",
                                "attr": {
                                    "stopColor": "#F80"
                                }
                            },
                            {
                                "tag": "stop",
                                "attr": {
                                    "offset": "1",
                                    "stopColor": "#F30"
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    })(props);
}
function GrSpa(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,22 C13.5,22 16,21 16,16.5 C16,12 12,6 12,6 C12,6 8,12 8,16.5 C8,21 10.5,22 12,22 Z M12,22 C10.5,22 9.04678627,21.7792414 7,20.5 C3,18 2.5,10 2.5,10 C2.5,10 7,10.5 9,12 M12,22 C13.5,22 14.9532137,21.7792414 17,20.5 C21,18 21.5,10 21.5,10 C21.5,10 17,10.5 15,12"
                }
            }
        ]
    })(props);
}
function GrSpectrum(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M22.131075,23.3986125 L13.12545,23.3986125 C12.3297,23.3986125 11.6187,22.7794875 11.6217,21.9822375 C11.64045,17.0236125 10.7442,15.3979875 8.8692,13.7584875 C6.900075,12.0372375 3.455325,11.7034875 1.49445,11.6641125 C0.6732,11.6476125 0.01695,10.9801125 0.01545,10.1573625 L7.5e-05,1.5331125 C-0.001425,0.7279875 0.627825,0.0582375 1.431075,0.0222375 C4.380825,-0.1097625 11.063325,0.2063625 16.521825,4.9786125 C20.9547,8.8538625 23.345325,14.5204875 23.639325,21.8378625 C23.67345,22.6906125 22.983075,23.3986125 22.131075,23.3986125"
                }
            }
        ]
    })(props);
}
function GrSplit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,22 L23,22 L23,2 L1,2 L1,22 Z M12,2 L12,22 L12,2 Z"
                }
            }
        ]
    })(props);
}
function GrSplits(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,22 L23,22 L23,2 L1,2 L1,22 Z M8,2 L8,22 L8,2 Z M16,2 L16,22 L16,2 Z"
                }
            }
        ]
    })(props);
}
function GrSpotify(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M19.0983701,10.6382791 C15.230178,8.34118115 8.85003755,8.12986439 5.15729493,9.25058527 C4.56433588,9.43062856 3.93727638,9.09580812 3.75758647,8.50284907 C3.57789655,7.90953664 3.91236362,7.28283051 4.50585273,7.10261054 C8.74455585,5.81598127 15.7909802,6.06440214 20.2440037,8.70780512 C20.7774195,9.02442687 20.9525156,9.71332656 20.6362472,10.2456822 C20.3198021,10.779098 19.6305491,10.9549008 19.0983701,10.6382791 M18.971686,14.0407262 C18.7004726,14.4810283 18.1246521,14.6190203 17.6848801,14.3486903 C14.4600027,12.3664473 9.54264764,11.792217 5.72728477,12.9503953 C5.23256328,13.0998719 4.70992535,12.8208843 4.55974204,12.3270462 C4.41061884,11.8323247 4.68978312,11.3107469 5.18362118,11.1602103 C9.5419409,9.83771368 14.9600247,10.4782013 18.6638986,12.7544503 C19.1036707,13.0253103 19.242016,13.6013075 18.971686,14.0407262 M17.5034233,17.308185 C17.2876894,17.6617342 16.827245,17.7725165 16.4749326,17.5571359 C13.6571403,15.8347984 10.1101639,15.4459119 5.93312425,16.4000177 C5.53063298,16.4922479 5.12937851,16.2399399 5.03767834,15.8376253 C4.94544812,15.4351341 5.19669597,15.0338796 5.60024736,14.9420027 C10.1712973,13.8970803 14.0923186,14.3467468 17.2551791,16.2796943 C17.6078449,16.4948982 17.7189805,16.9556959 17.5034233,17.308185 M12,0 C5.37267547,0 0,5.37249879 0,11.9998233 C0,18.6278546 5.37267547,24 12,24 C18.6275012,24 24,18.6278546 24,11.9998233 C24,5.37249879 18.6275012,0 12,0"
                }
            }
        ]
    })(props);
}
function GrSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14.4444444,8.33333333 L9.55555556,8.33333333 C8.88088889,8.33333333 8.33333333,8.88088889 8.33333333,9.55555556 L8.33333333,14.4444444 C8.33333333,15.1191111 8.88088889,15.6666667 9.55555556,15.6666667 L14.4444444,15.6666667 C15.1191111,15.6666667 15.6666667,15.1191111 15.6666667,14.4444444 L15.6666667,9.55555556 C15.6666667,8.88088889 15.1191111,8.33333333 14.4444444,8.33333333 M18.1111111,22 L5.88888889,22 C3.74128475,22 2,20.2587153 2,18.1111111 L2,5.88888889 C2,3.74128475 3.74128475,2 5.88888889,2 L18.1111111,2 C20.2587153,2 22,3.74128475 22,5.88888889 L22,18.1111111 C22,20.2587153 20.2587153,22 18.1111111,22 L18.1111111,22 Z M18.1111111,24 C21.3632847,24 24,21.3632847 24,18.1111111 L24,5.88888889 C24,2.63671525 21.3632847,0 18.1111111,0 L5.88888889,0 C2.63671525,0 0,2.63671525 0,5.88888889 L0,18.1111111 C0,21.3632847 2.63671525,24 5.88888889,24 L18.1111111,24 L18.1111111,24 Z"
                }
            }
        ]
    })(props);
}
function GrStackOverflow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.127 21.866v-6.43h2.134V24H2v-8.563h2.134v6.43h14.993Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6.49 14.827 10.475 2.19.444-2.107-10.476-2.19-.443 2.107Zm1.385-4.989 9.7 4.518.887-1.94-9.7-4.545-.887 1.967Zm2.688-4.766 8.231 6.845 1.358-1.635-8.23-6.846-1.359 1.636ZM15.884 0l-1.718 1.275 6.374 8.591 1.719-1.275L15.884 0ZM6.268 19.704h10.697V17.57H6.268v2.134Z"
                }
            }
        ]
    })(props);
}
function GrStakeholder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M14,9 L18.5,11 L23,9 L23,4 L18.5,2 L14,4 L14,9 Z M7,7 C4.791,7 3,8.791 3,11 C3,13.209 4.791,15 7,15 C9.209,15 11,13.209 11,11 C11,8.791 9.209,7 7,7 L7,7 Z M1,23 L1,21 C1,17 3.5,15 7,15 C10.5,15 13,17 13,21 L13,23 L1,23 Z M14,4 L18.5,6 L23,4 M18.5,6 L18.5,11 L18.5,6 Z"
                }
            }
        ]
    })(props);
}
function GrStarHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none",
                    "fillRule": "evenodd"
                },
                "child": [
                    {
                        "tag": "polygon",
                        "attr": {
                            "fillOpacity": ".2",
                            "points": "12 16.667 12 2 14.5 9.5 22 9.5 16 14 19 22"
                        }
                    },
                    {
                        "tag": "polygon",
                        "attr": {
                            "points": "12 16.667 5 22 8 14 2 9.5 9.5 9.5 12 2"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function GrStarOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12.606 16.805 12 16.343l-.606.462L5.755 21.1l2.381-6.35.263-.701-.599-.45L3 10h6.72l.229-.684L12 3.162l2.051 6.154.228.684H21l-4.8 3.6-.6.45.264.701 2.38 6.35-5.638-4.296Z"
                }
            }
        ]
    })(props);
}
function GrStar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "fillRule": "evenodd",
                    "points": "12 16.667 5 22 8 14 2 9.5 9.5 9.5 12 2 14.5 9.5 22 9.5 16 14 19 22"
                }
            }
        ]
    })(props);
}
function GrStatusCriticalSmall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 12 12"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M6.71239638,1.26313029 C6.31895072,0.869684641 5.68347072,0.867263198 5.28760362,1.26313029 L1.26313029,5.28760362 C0.869684641,5.68104928 0.867263198,6.31652928 1.26313029,6.71239638 L5.28760362,10.7368697 C5.68104928,11.1303154 6.31652928,11.1327368 6.71239638,10.7368697 L10.7368697,6.71239638 C11.1303154,6.31895072 11.1327368,5.68347072 10.7368697,5.28760362 L6.71239638,1.26313029 Z"
                }
            }
        ]
    })(props);
}
function GrStatusCritical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12.7031806,2.70318058 C12.3148247,2.31482467 11.6897542,2.31024575 11.2968194,2.70318058 L2.70318058,11.2968194 C2.31482467,11.6851753 2.31024575,12.3102458 2.70318058,12.7031806 L11.2968194,21.2968194 C11.6851753,21.6851753 12.3102458,21.6897542 12.7031806,21.2968194 L21.2968194,12.7031806 C21.6851753,12.3148247 21.6897542,11.6897542 21.2968194,11.2968194 L12.7031806,2.70318058 Z M8.98264552,14.7001725 L14.7001725,8.98264552 M8.98264552,8.98264552 L14.7001725,14.7001725"
                }
            }
        ]
    })(props);
}
function GrStatusDisabledSmall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 12 12"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "10",
                    "height": "10",
                    "x": "1",
                    "y": "1",
                    "fillRule": "evenodd",
                    "rx": "1"
                }
            }
        ]
    })(props);
}
function GrStatusDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2,3.99079514 C2,2.89130934 2.89821238,2 3.99079514,2 L20.0092049,2 C21.1086907,2 22,2.89821238 22,3.99079514 L22,20.0092049 C22,21.1086907 21.1017876,22 20.0092049,22 L3.99079514,22 C2.89130934,22 2,21.1017876 2,20.0092049 L2,3.99079514 Z M18,12 L6,12"
                }
            }
        ]
    })(props);
}
function GrStatusGoodSmall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 12 12"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "6",
                    "r": "5",
                    "fillRule": "evenodd"
                }
            }
        ]
    })(props);
}
function GrStatusGood(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M7,12 L11,15 L16,8"
                }
            }
        ]
    })(props);
}
function GrStatusInfoSmall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 12 12"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "10",
                    "height": "10",
                    "x": "1",
                    "y": "1",
                    "fillRule": "evenodd",
                    "rx": "1"
                }
            }
        ]
    })(props);
}
function GrStatusInfo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2,3.99079514 C2,2.89130934 2.89821238,2 3.99079514,2 L20.0092049,2 C21.1086907,2 22,2.89821238 22,3.99079514 L22,20.0092049 C22,21.1086907 21.1017876,22 20.0092049,22 L3.99079514,22 C2.89130934,22 2,21.1017876 2,20.0092049 L2,3.99079514 Z M12,10 L12,18 M12,6 L12,8"
                }
            }
        ]
    })(props);
}
function GrStatusPlaceholderSmall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 12 12"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "10",
                    "height": "10",
                    "x": "1",
                    "y": "1",
                    "fillRule": "evenodd",
                    "rx": "1"
                }
            }
        ]
    })(props);
}
function GrStatusPlaceholder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "20",
                    "height": "20",
                    "x": "2",
                    "y": "2",
                    "fill": "none",
                    "strokeWidth": "2",
                    "rx": "2"
                }
            }
        ]
    })(props);
}
function GrStatusUnknownSmall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 12 12"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "10",
                    "height": "10",
                    "x": "1",
                    "y": "1",
                    "fillRule": "evenodd",
                    "rx": "1"
                }
            }
        ]
    })(props);
}
function GrStatusUnknown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2,3.99079514 C2,2.89130934 2.89821238,2 3.99079514,2 L20.0092049,2 C21.1086907,2 22,2.89821238 22,3.99079514 L22,20.0092049 C22,21.1086907 21.1017876,22 20.0092049,22 L3.99079514,22 C2.89130934,22 2,21.1017876 2,20.0092049 L2,3.99079514 Z M12,15 L12,14 C12,13 12,12.5 13,12 C14,11.5 15,11 15,9.5 C15,8.5 14,7 12,7 C10,7 9,8.26413718 9,10 M12,16 L12,18"
                }
            }
        ]
    })(props);
}
function GrStatusWarningSmall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 12 12"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "fillRule": "evenodd",
                    "strokeLinejoin": "round",
                    "points": "6 1 11 10 1 10"
                }
            }
        ]
    })(props);
}
function GrStatusWarning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinejoin": "round",
                    "strokeWidth": "2",
                    "d": "M12,3 L22,21 L2,21 L12,3 Z M12,9 L12,15 M12,16 L12,18"
                }
            }
        ]
    })(props);
}
function GrStepsOption(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M24,9 L19,9 L19,14 L14,14 L14,19 L9,19 L9,24 M1,24 L1,16.9970301 C1,16.4463856 1.31329632,15.6867037 1.70336215,15.2966378 L15.2966378,1.70336215 C15.685094,1.31490596 16.4530363,1 16.9970301,1 L24,1"
                }
            }
        ]
    })(props);
}
function GrSteps(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "points": "16 6 11 6 11 11 6 11 6 16 1 16 1 23 23 23 23 1 16 1"
                }
            }
        ]
    })(props);
}
function GrStopFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4,4 L20,4 L20,20 L4,20 L4,4 Z M6,6 L18,6 L18,18 L6,18 L6,6 Z M8,8 L16,8 L16,16 L8,16 L8,8 Z M10,10 L14,10 L14,14 L10,14 L10,10 Z M11,11 L13,11 L13,13 L11,13 L11,11 Z"
                }
            }
        ]
    })(props);
}
function GrStop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "width": "16",
                    "height": "16",
                    "x": "4",
                    "y": "4",
                    "fill": "none",
                    "strokeWidth": "2"
                }
            }
        ]
    })(props);
}
function GrStorage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2,5.07692308 C2,5.07692308 3.66666667,2 12,2 C20.3333333,2 22,5.07692308 22,5.07692308 L22,18.9230769 C22,18.9230769 20.3333333,22 12,22 C3.66666667,22 2,18.9230769 2,18.9230769 L2,5.07692308 Z M2,13 C2,13 5.33333333,16 12,16 C18.6666667,16 22,13 22,13 M2,7 C2,7 5.33333333,10 12,10 C18.6666667,10 22,7 22,7"
                }
            }
        ]
    })(props);
}
function GrStreetView(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M16,5 C16,7.209 14.209,9 12,9 C9.791,9 8,7.209 8,5 C8,2.791 9.791,1 12,1 C14.209,1 16,2.791 16,5 L16,5 Z M15,23 L15,17 L18,17 L18,15 C18,11.66 15.24,9.03 12,9 C8.79,9.03 6,11.66 6,15 L6,17 L9,17 L9,23 M3.5,23 L20.5,23 L3.5,23 Z"
                }
            }
        ]
    })(props);
}
function GrStrikeThrough(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "5.77",
                    "y": "12.17",
                    "width": "12.46",
                    "height": "1.09"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.7,13.65H12.89c.59.34,1,.6,1.18.74a3.39,3.39,0,0,1,1,1.07,2.38,2.38,0,0,1,.31,1.14,2.3,2.3,0,0,1-.82,1.76,3.18,3.18,0,0,1-2.22.74,4.7,4.7,0,0,1-2.23-.54A3.77,3.77,0,0,1,8.56,17.2a7.41,7.41,0,0,1-.79-2.46H7.36V20h.41a1.35,1.35,0,0,1,.24-.7.59.59,0,0,1,.44-.17,6.5,6.5,0,0,1,1.39.35,12.63,12.63,0,0,0,1.45.41,7.26,7.26,0,0,0,1.25.1A4.87,4.87,0,0,0,16,18.72a4,4,0,0,0,1.34-3A3.8,3.8,0,0,0,16.92,14C16.86,13.87,16.78,13.77,16.7,13.65Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.89,11.21c.21.17.49.36.81.57h4.87c-.48-.29-1.07-.62-1.76-1A12.49,12.49,0,0,1,9.48,8.54,1.93,1.93,0,0,1,9,7.26a2.18,2.18,0,0,1,.77-1.63,2.72,2.72,0,0,1,1.93-.71,4.14,4.14,0,0,1,2,.53,3.78,3.78,0,0,1,1.49,1.43,6.6,6.6,0,0,1,.73,2.42h.41V4h-.41a1.39,1.39,0,0,1-.3.7.67.67,0,0,1-.48.17,2.64,2.64,0,0,1-.89-.28A6.45,6.45,0,0,0,11.68,4,4.49,4.49,0,0,0,8.47,5.21,3.75,3.75,0,0,0,7.21,8a3.57,3.57,0,0,0,.43,1.73A4.72,4.72,0,0,0,8.89,11.21Z"
                }
            }
        ]
    })(props);
}
function GrStripe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M1,1 L23,1 L23,23 L1,23 L1,1 Z M11.1196337,9.18908425 C11.1196337,8.58622711 11.6142857,8.35435897 12.4335531,8.35435897 C13.6083516,8.35435897 15.0923077,8.70989011 16.2671062,9.343663 L16.2671062,5.71106227 C14.9841026,5.20095238 13.7165568,5 12.4335531,5 C9.2956044,5 7.20879121,6.6385348 7.20879121,9.37457875 C7.20879121,13.6409524 13.0827839,12.9608059 13.0827839,14.800293 C13.0827839,15.5113553 12.4644689,15.7432234 11.5988278,15.7432234 C10.3158242,15.7432234 8.67728938,15.2176557 7.37882784,14.5065934 L7.37882784,18.1855678 C8.81641026,18.8038828 10.2694505,19.0666667 11.5988278,19.0666667 C14.8140659,19.0666667 17.0245421,17.4745055 17.0245421,14.7075458 C17.0090842,10.1010989 11.1196337,10.9203663 11.1196337,9.18908425 L11.1196337,9.18908425 Z"
                }
            }
        ]
    })(props);
}
function GrSubscript(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.74,3.63l.19,4.07h-.49a4.92,4.92,0,0,0-.38-1.54A2.58,2.58,0,0,0,17,5.07a3.68,3.68,0,0,0-1.73-.35H12.83V18a3.54,3.54,0,0,0,.35,2,1.92,1.92,0,0,0,1.5.54h.6V21H7.92V20.5h.61a1.76,1.76,0,0,0,1.56-.67A3.88,3.88,0,0,0,10.38,18V4.72H8.29a5.79,5.79,0,0,0-1.73.18,2.37,2.37,0,0,0-1.14.93A3.78,3.78,0,0,0,4.86,7.7H4.38l.21-4.07Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.48,16.68h.33v5.59a1.13,1.13,0,0,0,.06.4.41.41,0,0,0,.17.21.63.63,0,0,0,.28.08h.4v.27H20.76V23l.45,0a.62.62,0,0,0,.29-.1.38.38,0,0,0,.15-.22,1.4,1.4,0,0,0,0-.37V18.42a4.45,4.45,0,0,0,0-.64c0-.15-.1-.23-.24-.23a.82.82,0,0,0-.28,0l-.3.13-.18-.25Z"
                }
            }
        ]
    })(props);
}
function GrSubtractCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M6,12 L18,12"
                }
            }
        ]
    })(props);
}
function GrSubtract(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2,12 L22,12"
                }
            }
        ]
    })(props);
}
function GrSun(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "2",
                    "d": "M12 4V2m0 20v-2m8-8h2M2 12h2m13.657-5.657L19.07 4.93M4.93 19.07l1.414-1.414m0-11.314L4.93 4.93M19.07 19.07l-1.414-1.414M12 17a5 5 0 100-10 5 5 0 000 10z"
                }
            }
        ]
    })(props);
}
function GrSuperscript(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.74,3.63l.19,4.07h-.49a4.9,4.9,0,0,0-.38-1.54A2.57,2.57,0,0,0,17,5.07a3.68,3.68,0,0,0-1.73-.35H12.83V18a3.56,3.56,0,0,0,.34,2,1.92,1.92,0,0,0,1.5.54h.6V21H7.92V20.5h.61a1.76,1.76,0,0,0,1.56-.67A3.88,3.88,0,0,0,10.38,18V4.72H8.29a5.82,5.82,0,0,0-1.73.18,2.37,2.37,0,0,0-1.14.93A3.78,3.78,0,0,0,4.86,7.7H4.38l.21-4.07Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.48,1h.33V6.62a1.13,1.13,0,0,0,.06.4.41.41,0,0,0,.17.21.63.63,0,0,0,.28.08h.4V7.6H20.76V7.33l.45,0a.62.62,0,0,0,.29-.1A.38.38,0,0,0,21.65,7a1.4,1.4,0,0,0,0-.37V2.77a4.45,4.45,0,0,0,0-.64c0-.15-.1-.23-.24-.23a.82.82,0,0,0-.28,0l-.3.13-.18-.25Z"
                }
            }
        ]
    })(props);
}
function GrSupport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 Z M15,23 L15,17 M9,23 L9,17 M15,7 L15,1 M9,7 L9,1 M12,18 C15.3137085,18 18,15.3137085 18,12 C18,8.6862915 15.3137085,6 12,6 C8.6862915,6 6,8.6862915 6,12 C6,15.3137085 8.6862915,18 12,18 Z M1,15 L7,15 M1,9 L7,9 M17,15 L23,15 M17,9 L23,9",
                    "transform": "rotate(45 12 12)"
                }
            }
        ]
    })(props);
}
function GrSuse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M24,8.28528691 C22.5804639,5.99050902 20.3366451,4.34898102 17.9130991,3.93053502 C15.8761713,3.57729259 12.1607377,3.53965483 10.1932153,7.25267133 C9.3714001,8.80307066 9.42181398,10.8206616 10.3230483,12.5212667 C11.241893,14.2615813 12.8841423,15.3796644 14.8274936,15.5927148 C16.7549611,15.8023122 18.2031515,15.3565292 19.0170248,14.3047439 C19.8367683,13.2419089 19.9887005,11.7961356 19.4075597,10.6179702 C18.7825658,9.35278909 17.8402407,8.68083428 16.531897,8.56964751 C15.5332879,8.48125058 14.7950354,8.8966471 14.5267369,9.32033084 C14.4504255,9.45292624 14.3098881,9.69739901 14.3085069,10.0565116 C14.3085069,11.0067786 15.1759018,11.2667899 15.3523504,11.2785301 C15.4062173,11.2764583 15.6676098,11.2712788 16.0139462,11.1839178 L16.1817623,11.1276338 L16.381346,11.0720404 C17.0132459,10.9570553 17.6199389,11.3299799 17.7970781,11.9439242 C17.8281551,12.0575281 17.8454202,12.1704413 17.8454202,12.2819734 C17.8454202,12.6897733 17.6375493,13.0709851 17.2138655,13.3534409 C17.0315468,13.4677354 16.8644214,13.5319613 16.6890087,13.5868641 C16.1928119,13.7481194 15.7546255,13.8227043 15.3157486,13.8227043 C13.8112742,13.8209778 11.7163359,12.5278274 11.6900931,10.0989835 C11.6759358,8.72779515 12.3627385,7.48091497 13.5747433,6.67705536 C14.9690668,5.75475767 17.377538,5.4419154 19.61474,6.81379436 C22.365404,8.4957532 23.0836291,11.7950997 22.365404,14.0447326 C21.3219058,17.3022977 18.3851249,19.0436482 14.5118889,18.6973118 C11.7667498,18.4531843 9.21705077,17.003958 7.70014558,14.8233852 C7.02715487,13.8575797 6.52888622,12.7805874 6.25920651,11.7042856 C5.63939208,9.24816303 6.26645782,6.6380364 6.73192292,5.48231556 C7.53228768,3.50084082 8.72510717,1.66935452 10.2982381,6.09512441e-14 L1.0005,-1.26217745e-29 C0.44775,-1.26217745e-29 0,0.44775 0,0.99975 L0,23.00025 C0,23.55225 0.44775,24 1.0005,24 L23.00025,24 C23.55225,24 24,23.55225 24,23.00025 L24,8.28528691 Z"
                }
            }
        ]
    })(props);
}
function GrSwift(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18.1029473,21.0182797 C15.2758951,22.6513915 11.388774,22.8191853 7.4780286,21.143065 C4.31157263,19.7958689 1.6842374,17.43767 -1.77635684e-15,14.7432778 C0.808438798,15.4168759 1.7515972,15.9559966 2.76211541,16.4272729 C6.80079604,18.320253 10.8386286,18.1906218 13.6802189,16.432119 C13.6784016,16.4303017 13.6771901,16.4290902 13.6759786,16.4272729 C9.63378462,13.3282374 6.19795002,9.28604337 3.63803517,5.98529182 C3.09885386,5.44629224 2.69463446,4.77257305 2.29041506,4.16627424 C5.38939007,6.99574946 10.3075644,10.5660614 12.0587981,11.5770642 C8.35400892,7.6693475 5.05265163,2.81907816 5.18712893,2.95355547 C11.0484011,8.88206627 16.5056356,12.2506622 16.5056356,12.2506622 C16.6861501,12.3524288 16.8254735,12.4372343 16.9375379,12.5129535 C17.0556599,12.2124997 17.1592437,11.9005366 17.2464723,11.5770642 C18.1896307,8.14122958 17.1119949,4.23351289 14.7537961,1 C20.2104248,4.30105442 23.4445434,10.4988227 22.0967416,15.6864968 C22.0616079,15.8264259 22.0234454,15.9645377 21.9822542,16.1002266 C21.9980037,16.1190049 22.0137533,16.138389 22.0295029,16.1583789 C24.7238951,19.5269749 23.9830584,23.0972868 23.6462594,22.4236887 C22.1845759,19.5633201 19.4786744,20.4380283 18.1030079,21.0183403 L18.1029473,21.0182797 Z"
                }
            }
        ]
    })(props);
}
function GrSwim(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "2",
                    "d": "M11,13 C11.5,13.5 13.1299859,12.8876287 14.2620192,12.5 C15.7222222,12 17.5,12.5 17,12 C15.3609614,10.3609614 15,10 15,10 C15,10 10.5,12.5 11,13 Z M2,20 C4,20 5,19 7,19 C9,19 10,20 12,20 C14,20 15,19 17,19 C19,19 20,20 22,20 M2,16 C4,16 5,15 7,15 C9,15 10,16 12,16 C14,16 15,15 17,15 C19,15 20,16 22,16 M17.5,4 L12.2222222,7 L15.5,10.5 L12,12 M19.2222222,10 C19.774507,10 20.2222222,9.55228475 20.2222222,9 C20.2222222,8.44771525 19.774507,8 19.2222222,8 C18.6699375,8 18.2222222,8.44771525 18.2222222,9 C18.2222222,9.55228475 18.6699375,10 19.2222222,10 Z"
                }
            }
        ]
    })(props);
}
function GrSwitch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5 1H6H6.5H7.5H12H16.8229H17.8229H18H19V2V22V23H18H6H5V22V2V1ZM7.5 11H12H16.8229H17V21H7V11H7.5ZM15 6C15 7.65685 13.6569 9 12 9C10.3431 9 9 7.65685 9 6C9 4.34315 10.3431 3 12 3C13.6569 3 15 4.34315 15 6ZM11 19V14H13V19H11ZM12 5.00195C11.4477 5.00195 11 5.44967 11 6.00195C11 6.55424 11.4477 7.00195 12 7.00195C12.5523 7.00195 13 6.55424 13 6.00195C13 5.44967 12.5523 5.00195 12 5.00195Z"
                }
            }
        ]
    })(props);
}
function GrSync(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M5,19 L16,19 C19.866,19 23,15.866 23,12 L23,9 M8,15 L4,19 L8,23 M19,5 L8,5 C4.134,5 1,8.134 1,12 L1,15 M16,1 L20,5 L16,9"
                }
            }
        ]
    })(props);
}
function GrSystem(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,19 L23,19 L23,1 L1,1 L1,19 Z M5,23 L19,23 L5,23 Z M8,23 L16,23 L16,19 L8,19 L8,23 Z M7.757,5.757 L9.879,7.879 L7.757,5.757 Z M9,10 L6,10 L9,10 Z M9.879,12.121 L7.757,14.243 L9.879,12.121 Z M12,13 L12,16 L12,13 Z M14.121,12.121 L16.243,14.243 L14.121,12.121 Z M18,10 L15,10 L18,10 Z M16.243,5.757 L14.121,7.879 L16.243,5.757 Z M12,7 L12,4 L12,7 Z M12,7 C10.343,7 9,8.343 9,10 C9,11.657 10.343,13 12,13 C13.657,13 15,11.657 15,10 C15,8.343 13.657,7 12,7 L12,7 Z"
                }
            }
        ]
    })(props);
}
function GrTableAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M8,5 L8,23 M16,5 L16,11 M1,11 L17,11 M1,5 L23,5 M1,17 L11,17 M17,23 L1,23 L1,1 L23,1 L23,17 M17,23 C20.3137085,23 23,20.3137085 23,17 C23,13.6862915 20.3137085,11 17,11 C13.6862915,11 11,13.6862915 11,17 C11,20.3137085 13.6862915,23 17,23 Z M17,14 L17,20 M17,14 L17,20 M14,17 L20,17"
                }
            }
        ]
    })(props);
}
function GrTable(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M8,5 L8,23 M16,5 L16,23 M1,11 L23,11 M1,5 L23,5 M1,17 L23,17 M1,1 L23,1 L23,23 L1,23 L1,1 Z"
                }
            }
        ]
    })(props);
}
function GrTag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M11.7058543,22.2941457 C11.3160217,22.6839783 10.6897542,22.6897542 10.2968194,22.2968194 L1.70318058,13.7031806 C1.31482467,13.3148247 1.32097101,12.679029 1.70585426,12.2941457 L13,1 L23,1 L23,11 L11.7058543,22.2941457 Z M6,12 L12,18 M9,9 L15,15 M17,6 C17,5.4475 17.4475,5 18,5 C18.5525,5 19,5.4475 19,6 C19,6.5525 18.5525,7 18,7 C17.4475,7 17,6.5525 17,6"
                }
            }
        ]
    })(props);
}
function GrTapeOption(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,2 L22,2 L22,22 L2,22 L2,7 M12,19 C8.13409091,19 5,15.8659091 5,12 M12,19 C15.8659091,19 19,15.8659091 19,12 C19,8.13409091 15.8659091,5 12,5 L1,5 M12,9 C10.3455,9 9,10.3455 9,12 C9,13.6545 10.3455,15 12,15 C13.6545,15 15,13.6545 15,12 C15,10.3455 13.6545,9 12,9 Z"
                }
            }
        ]
    })(props);
}
function GrTape(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2,2 L22,2 L22,22 L2,22 L2,2 Z M19,12 C19,15.8659091 15.8659091,19 12,19 C8.13409091,19 5,15.8659091 5,12 C5,8.13409091 8.13409091,5 12,5 C15.8659091,5 19,8.13409091 19,12 L19,12 Z M12,9 C10.3455,9 9,10.3455 9,12 C9,13.6545 10.3455,15 12,15 C13.6545,15 15,13.6545 15,12 C15,10.3455 13.6545,9 12,9 Z"
                }
            }
        ]
    })(props);
}
function GrTarget(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M23,12 C23,18.075 18.075,23 12,23 C5.925,23 1,18.075 1,12 C1,5.925 5.925,1 12,1 C18.075,1 23,5.925 23,12 L23,12 Z M18,12 C18,8.691 15.309,6 12,6 C8.691,6 6,8.691 6,12 C6,15.309 8.691,18 12,18 C15.309,18 18,15.309 18,12 L18,12 Z M13,12 C13,11.448 12.552,11 12,11 C11.448,11 11,11.448 11,12 C11,12.552 11.448,13 12,13 C12.552,13 13,12.552 13,12 L13,12 Z"
                }
            }
        ]
    })(props);
}
function GrTask(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,20 L24,20 M12,12 L24,12 M12,4 L24,4 M1,19 L4,22 L9,17 M1,11 L4,14 L9,9 M9,1 L4,6 L1,3"
                }
            }
        ]
    })(props);
}
function GrTasks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,3 L23,3 L23,7 L1,7 L1,3 Z M1,10 L23,10 L23,14 L1,14 L1,10 Z M1,17 L23,17 L23,21 L1,21 L1,17 Z M1,4 L16,4 L16,6 L1,6 L1,4 Z M1,11 L6,11 L6,13 L1,13 L1,11 Z M1,18 L11,18 L11,20 L1,20 L1,18 Z"
                }
            }
        ]
    })(props);
}
function GrTechnology(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "2",
                    "d": "M16.5,19 C17.8807119,19 19,17.8807119 19,16.5 C19,15.1192881 17.8807119,14 16.5,14 C15.1192881,14 14,15.1192881 14,16.5 C14,17.8807119 15.1192881,19 16.5,19 Z M10,5 L12,3 M7.5,10 C8.88071187,10 10,8.88071187 10,7.5 C10,6.11928813 8.88071187,5 7.5,5 C6.11928813,5 5,6.11928813 5,7.5 C5,8.88071187 6.11928813,10 7.5,10 Z M8,16 L16,8 M5.5,21 C6.88071187,21 8,19.8807119 8,18.5 C8,17.1192881 6.88071187,16 5.5,16 C4.11928813,16 3,17.1192881 3,18.5 C3,19.8807119 4.11928813,21 5.5,21 Z M18.5,8 C19.8807119,8 21,6.88071187 21,5.5 C21,4.11928813 19.8807119,3 18.5,3 C17.1192881,3 16,4.11928813 16,5.5 C16,6.88071187 17.1192881,8 18.5,8 Z M12,21 L14,19"
                }
            }
        ]
    })(props);
}
function GrTemplate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,3 L23,3 L23,21 L1,21 L1,3 Z M1,8 L23,8 M7,8 L7,21"
                }
            }
        ]
    })(props);
}
function GrTerminal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2,5 L8,11 L2,17 M9,17 L23,17"
                }
            }
        ]
    })(props);
}
function GrTestDesktop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M18.218,1 L23,1 L23,19 L1,19 L1,1 L6,1 M16.9999996,9.99999996 C13,6.99999996 11,13 7.00000002,9.99999996 M5,23 L19,23 L5,23 Z M10,1 L10,5.773 L5,12.955 L5,15 L19,15 L19,12.955 L14,5.773 L14,1 M8,1 L16,1 L8,1 Z M8,23 L16,23 L16,19 L8,19 L8,23 Z"
                }
            }
        ]
    })(props);
}
function GrTest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M8.9997,0.99999995 L8.9997,8.0003 L1.9997,20.0003 L1.9997,23.0003 L21.9997,23.0003 L21.9997,20.0003 L14.9997,8.0003 L14.9997,0.99999995 M15,18 C15.5522847,18 16,17.5522847 16,17 C16,16.4477153 15.5522847,16 15,16 C14.4477153,16 14,16.4477153 14,17 C14,17.5522847 14.4477153,18 15,18 Z M9,20 C9.55228475,20 10,19.5522847 10,19 C10,18.4477153 9.55228475,18 9,18 C8.44771525,18 8,18.4477153 8,19 C8,19.5522847 8.44771525,20 9,20 Z M18,13 C11,9.99999996 12,17.0000002 6,14 M5.9997,1.0003 L17.9997,1.0003"
                }
            }
        ]
    })(props);
}
function GrTextAlignCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "0.46",
                    "y": "3.06",
                    "width": "23.08",
                    "height": "2.18"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "4.1",
                    "y": "8.29",
                    "width": "15.81",
                    "height": "2.18"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "0.46",
                    "y": "13.53",
                    "width": "23.08",
                    "height": "2.18"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "4.1",
                    "y": "18.76",
                    "width": "15.81",
                    "height": "2.18"
                }
            }
        ]
    })(props);
}
function GrTextAlignFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "0.46",
                    "y": "3.06",
                    "width": "23.08",
                    "height": "2.18"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "0.46",
                    "y": "8.29",
                    "width": "23.08",
                    "height": "2.18"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "0.46",
                    "y": "13.53",
                    "width": "23.08",
                    "height": "2.18"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "0.46",
                    "y": "18.76",
                    "width": "15.81",
                    "height": "2.18"
                }
            }
        ]
    })(props);
}
function GrTextAlignLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "0.46",
                    "y": "3.06",
                    "width": "23.08",
                    "height": "2.18"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "0.46",
                    "y": "8.29",
                    "width": "15.81",
                    "height": "2.18"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "0.46",
                    "y": "13.53",
                    "width": "23.08",
                    "height": "2.18"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "0.46",
                    "y": "18.76",
                    "width": "15.81",
                    "height": "2.18"
                }
            }
        ]
    })(props);
}
function GrTextAlignRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "0.46",
                    "y": "3.06",
                    "width": "23.08",
                    "height": "2.18"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7.73",
                    "y": "8.29",
                    "width": "15.81",
                    "height": "2.18"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "0.46",
                    "y": "13.53",
                    "width": "23.08",
                    "height": "2.18"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7.73",
                    "y": "18.76",
                    "width": "15.81",
                    "height": "2.18"
                }
            }
        ]
    })(props);
}
function GrTextWrap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M17,10 L24,10 L17,10 L17,10 Z M1,14 L14,14 L14,2 L1,2 L1,14 Z M6,6 C6,6.5525 5.5525,7 5,7 C4.4475,7 4,6.5525 4,6 C4,5.4475 4.4475,5 5,5 C5.5525,5 6,5.4475 6,6 M17,6 L24,6 L17,6 L17,6 Z M17,2 L24,2 L17,2 L17,2 Z M17,14 L24,14 L17,14 L17,14 Z M0,18 L24,18 L0,18 L0,18 Z M0,22 L24,22 L0,22 L0,22 Z M14,14 L14,13 L10,8 L7,11 L6,10 L2,14 L14,14 Z"
                }
            }
        ]
    })(props);
}
function GrThreads(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.067 11.123a8.547 8.547 0 0 0-.315-.142c-.185-3.414-2.05-5.368-5.182-5.388h-.042c-1.873 0-3.431.8-4.39 2.255L9.86 9.029c.716-1.087 1.84-1.318 2.669-1.318h.028c1.031.006 1.81.306 2.313.89.367.426.612 1.015.733 1.757a13.176 13.176 0 0 0-2.96-.143c-2.977.172-4.892 1.909-4.763 4.322.065 1.223.675 2.277 1.717 2.964.88.582 2.015.866 3.194.802 1.558-.085 2.78-.68 3.632-1.766.647-.825 1.056-1.894 1.237-3.241.742.448 1.292 1.037 1.596 1.745.516 1.205.546 3.184-1.068 4.797-1.415 1.414-3.116 2.025-5.686 2.044-2.851-.02-5.008-.935-6.41-2.717-1.313-1.67-1.991-4.08-2.016-7.165.025-3.085.703-5.496 2.016-7.165 1.402-1.782 3.558-2.696 6.41-2.717 2.871.02 5.065.94 6.521 2.73.714.879 1.252 1.983 1.607 3.27l2.018-.538c-.43-1.585-1.107-2.95-2.027-4.083C18.755 1.2 16.025.024 12.509 0h-.014c-3.51.024-6.208 1.205-8.021 3.51C2.86 5.56 2.028 8.414 2 11.992v.016c.028 3.578.86 6.431 2.474 8.482 1.813 2.305 4.511 3.486 8.02 3.51h.015c3.12-.022 5.319-.838 7.13-2.649 2.371-2.368 2.3-5.336 1.518-7.158-.56-1.307-1.629-2.368-3.09-3.07Zm-5.387 5.065c-1.305.074-2.66-.512-2.728-1.766-.05-.93.662-1.969 2.808-2.092.246-.015.487-.021.724-.021.78 0 1.508.075 2.171.22-.247 3.088-1.697 3.59-2.975 3.66Z"
                }
            }
        ]
    })(props);
}
function GrThreats(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M9,23 C12.8659932,23 16,19.8659932 16,16 C16,12.1340068 12.8659932,9 9,9 C5.13400675,9 2,12.1340068 2,16 C2,19.8659932 5.13400675,23 9,23 Z M9,6 C9,6 9,8 9,5 C9,2 11,1 13,1 C15,1 17,2 17,5 L17,8 C17,9 17,11 19,11 C21,11 21,9 21,8 C21,6 22,6 23,6 M12,13 L6,19 M6,13 L12,19 M6,10 L6,6 L12,6 L12,10"
                }
            }
        ]
    })(props);
}
function GrThreeDEffects(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "points": "11 3 13 3 22 6 22 17 12 20.5 2 17 2 6.5 4 6 13 8.5 11 9 2 6.5"
                }
            }
        ]
    })(props);
}
function GrThreeD(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2,5.5 L2,18.5 L12,22.5 L22,18.5 L22,5.5 L12,1.5 L2,5.5 Z M13,12 L18,12 L18,17 M2,5.5 L12,9.5 L22,5.5 M6,14 C6,14 12,20.5 18,12"
                }
            }
        ]
    })(props);
}
function GrTicket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M7,16 L17,16 L17,8 L7,8 L7,16 Z M20,12 C20,14 21,15 23,15 L23,20 L1,20 L1,15 C3,15 4,14 4,12 C4,10 3,9 1,9 L1,4 L23,4 L23,9 C21,9 20,10 20,12 Z"
                }
            }
        ]
    })(props);
}
function GrTiktok(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.459 6.846v3.659c-.197 0-.433.04-.669.04a7.295 7.295 0 01-4.682-1.732v7.79a6.987 6.987 0 01-1.416 4.25 7.02 7.02 0 01-5.626 2.832 6.993 6.993 0 01-5.941-3.305c1.259 1.18 2.95 1.928 4.8 1.928a6.893 6.893 0 005.586-2.833c.866-1.18 1.417-2.636 1.417-4.249v-7.83c1.259 1.102 2.872 1.732 4.682 1.732.236 0 .433 0 .669-.04v-2.36c.354.079.669.118 1.023.118h.157z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.05 9.56v4.053a3.277 3.277 0 00-.866-.118c-1.732 0-3.148 1.456-3.148 3.226 0 .394.079.748.197 1.102-.787-.59-1.338-1.535-1.338-2.597 0-1.77 1.416-3.226 3.148-3.226.314 0 .59.04.865.118V9.521h.236c.315 0 .63 0 .905.04zM17.698 3.934c-.708-.63-1.22-1.495-1.495-2.4h.945v.551a6.25 6.25 0 00.55 1.85z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.318 6.767v2.36c-.197.04-.433.04-.669.04a7.295 7.295 0 01-4.682-1.73v7.79a6.987 6.987 0 01-1.416 4.248c-1.299 1.732-3.305 2.833-5.587 2.833-1.85 0-3.541-.747-4.8-1.928a7.136 7.136 0 01-1.062-3.737c0-3.817 3.03-6.925 6.806-7.043v2.597a3.277 3.277 0 00-.865-.118c-1.732 0-3.148 1.455-3.148 3.226 0 1.062.512 2.046 1.338 2.597.433 1.22 1.613 2.124 2.95 2.124 1.732 0 3.148-1.456 3.148-3.226V1.534h2.872c.276.945.787 1.77 1.495 2.4a5.397 5.397 0 003.62 2.833z"
                }
            },
            {
                "tag": "g",
                "attr": {},
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M9.908 8.184V9.52c-3.777.118-6.806 3.226-6.806 7.043 0 1.377.393 2.636 1.062 3.738A7.122 7.122 0 012 15.148c0-3.896 3.148-7.043 7.003-7.043.315 0 .63.04.905.079z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M16.203 1.534h-2.872v15.187c0 1.77-1.416 3.227-3.147 3.227-1.377 0-2.518-.866-2.951-2.125.511.354 1.14.59 1.81.59 1.73 0 3.147-1.416 3.147-3.187V0h3.817v.079c0 .157 0 .314.039.472 0 .315.079.669.157.983zM21.318 5.311v1.417c-1.574-.315-2.911-1.377-3.659-2.794a5.11 5.11 0 003.659 1.377z"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function GrTime(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 13H5L7.5 4L12.5 20.5L17 9L19 13H23",
                    "strokeWidth": "2"
                }
            }
        ]
    })(props);
}
function GrTip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M16.0073529,18 L22,18 L22,2 L2,2 L2,18 L8.24264706,18 L12.125,22 L16.0073529,18 Z"
                }
            }
        ]
    })(props);
}
function GrToast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M8,2 C5.790861,2 4,3.790861 4,6 C4,7.48056471 4.80439726,8.77325238 6,9.46487122 L6,16 L18,16 L18,9.46487122 C19.1956027,8.77325238 20,7.48056471 20,6 C20,3.790861 18.209139,2 16,2 L8,2 Z M11.3212774,6.87413911 C11.600007,6.39136541 12.209917,6.22167659 12.700101,6.50468445 L14.4159244,7.49531555 C14.8986981,7.77404508 15.0683869,8.38395511 14.7853791,8.87413911 L13.794748,10.5899625 C13.5160184,11.0727362 12.9061084,11.242425 12.4159244,10.9594172 L10.700101,9.96878606 C10.2173273,9.69005654 10.0476385,9.0801465 10.3306463,8.58996251 L11.3212774,6.87413911 Z M8,18 L8,20 M12,18 L12,23 M16,18 L16,21"
                }
            }
        ]
    })(props);
}
function GrTools(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M11,2 L22,13 L17.5,17.5 L6.5,6.5 L11,2 Z M16,6 L17,5 L19,7 L18,8 M13,13 L4,22 L2,20 L11,11 M5,18 L6,19"
                }
            }
        ]
    })(props);
}
function GrTooltip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M16.5,18 L12,22.5 L7.5,18 L1,18 L1,1 L23,1 L23,18 L16.5,18 Z M6,10 L7,10 L7,9 L6,9 L6,10 Z M11.5,10 L12.5,10 L12.5,9 L11.5,9 L11.5,10 Z M17,10 L18,10 L18,9 L17,9 L17,10 Z"
                }
            }
        ]
    })(props);
}
function GrTopCorner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "points": "4 16 16 16 16 4",
                    "transform": "rotate(180 10 10)"
                }
            }
        ]
    })(props);
}
function GrTrain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M5,1 L19,1 L19,1 C20.1045695,1 21,1.8954305 21,3 L21,18 L21,18 C21,19.1045695 20.1045695,20 19,20 L5,20 L5,20 C3.8954305,20 3,19.1045695 3,18 L3,3 L3,3 C3,1.8954305 3.8954305,1 5,1 Z M9,2 L15,2 M3,5 L21,5 M4,23 L20,23 M3,12 L21,12 M7,17 C7.55228475,17 8,16.5522847 8,16 C8,15.4477153 7.55228475,15 7,15 C6.44771525,15 6,15.4477153 6,16 C6,16.5522847 6.44771525,17 7,17 Z M17,17 C17.5522847,17 18,16.5522847 18,16 C18,15.4477153 17.5522847,15 17,15 C16.4477153,15 16,15.4477153 16,16 C16,16.5522847 16.4477153,17 17,17 Z M12,5 L12,12 M9,20 L7,23 M15,20 L17,23"
                }
            }
        ]
    })(props);
}
function GrTransaction(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M2,7 L20,7 M16,2 L21,7 L16,12 M22,17 L4,17 M8,12 L3,17 L8,22"
                }
            }
        ]
    })(props);
}
function GrTrash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4,5 L20,5 L20,23 L4,23 L4,5 Z M1,5 L23,5 M9,1 L15,1 L15,5 L9,5 L9,1 Z M9,1 L15,1 L15,5 L9,5 L9,1 Z M15,9 L15,19 M9,9 L9,19"
                }
            }
        ]
    })(props);
}
function GrTreeOption(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M7,13 L11.375,6 L9,6 L12,2 L15,6 L12.625,6 L17,13 L15,13 L19,19.6666667 L5,19.6666667 L9,13 L7,13 Z M12,24 L12,20"
                }
            }
        ]
    })(props);
}
function GrTree(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M4,1 L10,1 L10,7 L4,7 L4,1 Z M16,11 L20,11 L20,15 L16,15 L16,11 Z M16,19 L20,19 L20,23 L16,23 L16,19 Z M7,7 L7,21 L16,21 M7,13 L16,13"
                }
            }
        ]
    })(props);
}
function GrTrigger(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "points": "4 14 10 14 7 23 9 23 20 9 14 9 18 1 7 1"
                }
            }
        ]
    })(props);
}
function GrTrophy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,15 C8.686,15 6,12.314 6,9 L6,1 L18,1 L18,9 C18,12.314 15.314,15 12,15 Z M6,3 L1,3 L1,7 C1,9.509 2.791,11 5,11 L6,11 L6,3 Z M18,11 L19,11 C21.209,11 23,9.509 23,7 L23,3 L18,3 L18,11 Z M5,23 L19,23 L19,19 L5,19 L5,23 Z M16,19 C16,16.790861 14.209139,15 12,15 C9.790861,15 8,16.790861 8,19"
                }
            }
        ]
    })(props);
}
function GrTroubleshoot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,5 C1,3.00000024 2,1 3,1 C3,1 5,5 5,5 L7,5 C7,5 9,1 9,1 C10,1 11,3.00000006 11,5 C11,7.25400025 10,9.0000003 8,10 L8,21 C8,22 8,23 6,23 C4,23 4,22 4,21 L4,10 C2,9.0000003 1,7.25400042 1,5 Z M19,12 L19,18 M17,18 L18,23 L20,23 L21,18 L17,18 Z M14,12 L24,12 L14,12 Z M21,12 L21,3 C21,1.895 20.105,1 19,1 C17.895,1 17,1.895 17,3 L17,12"
                }
            }
        ]
    })(props);
}
function GrTty(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeWidth": "2",
                    "d": "M7,19 L17,19 L17,19 C17.5522847,19 18,19.4477153 18,20 L18,20 L18,20 C18,20.5522847 17.5522847,21 17,21 L7,21 L7,21 C6.44771525,21 6,20.5522847 6,20 L6,20 L6,20 C6,19.4477153 6.44771525,19 7,19 Z M7,10 C7.55228475,10 8,9.55228475 8,9 C8,8.44771525 7.55228475,8 7,8 C6.44771525,8 6,8.44771525 6,9 C6,9.55228475 6.44771525,10 7,10 Z M7,5 C7.55228475,5 8,4.55228475 8,4 C8,3.44771525 7.55228475,3 7,3 C6.44771525,3 6,3.44771525 6,4 C6,4.55228475 6.44771525,5 7,5 Z M7,15 C7.55228475,15 8,14.5522847 8,14 C8,13.4477153 7.55228475,13 7,13 C6.44771525,13 6,13.4477153 6,14 C6,14.5522847 6.44771525,15 7,15 Z M12,10 C12.5522847,10 13,9.55228475 13,9 C13,8.44771525 12.5522847,8 12,8 C11.4477153,8 11,8.44771525 11,9 C11,9.55228475 11.4477153,10 12,10 Z M12,5 C12.5522847,5 13,4.55228475 13,4 C13,3.44771525 12.5522847,3 12,3 C11.4477153,3 11,3.44771525 11,4 C11,4.55228475 11.4477153,5 12,5 Z M12,15 C12.5522847,15 13,14.5522847 13,14 C13,13.4477153 12.5522847,13 12,13 C11.4477153,13 11,13.4477153 11,14 C11,14.5522847 11.4477153,15 12,15 Z M17,10 C17.5522847,10 18,9.55228475 18,9 C18,8.44771525 17.5522847,8 17,8 C16.4477153,8 16,8.44771525 16,9 C16,9.55228475 16.4477153,10 17,10 Z M17,5 C17.5522847,5 18,4.55228475 18,4 C18,3.44771525 17.5522847,3 17,3 C16.4477153,3 16,3.44771525 16,4 C16,4.55228475 16.4477153,5 17,5 Z M17,15 C17.5522847,15 18,14.5522847 18,14 C18,13.4477153 17.5522847,13 17,13 C16.4477153,13 16,13.4477153 16,14 C16,14.5522847 16.4477153,15 17,15 Z"
                }
            }
        ]
    })(props);
}
function GrTumblr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M17.6389798,19.1699694 C17.1927306,19.3822191 16.3392319,19.5682188 15.7024829,19.5847188 C13.781736,19.6357187 13.4089866,18.2354709 13.3924866,17.2184725 L13.3924866,9.74773446 L18.2119789,9.74773446 L18.2119789,6.11399025 L13.4104866,6.11399025 L13.4104866,0 L9.8944922,0 C9.83674229,0 9.73624245,0.0509999187 9.72199247,0.179999713 C9.5164928,2.05124673 8.6404942,5.33474149 5,6.6472394 L5,9.74773446 L7.42849613,9.74773446 L7.42849613,17.588972 C7.42849613,20.2739677 9.40924297,24.0877116 14.6374846,23.9984617 C16.4014818,23.9677118 18.3597287,23.229713 18.793228,22.592964 L17.6389798,19.1699694 Z"
                }
            }
        ]
    })(props);
}
function GrTurbolinux(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.41886316,6.22224 L9.96581053,7.45268211 L6.61541053,7.45268211 L6,6.22224 L9.41886316,6.22224 Z M13.1110105,12.1706526 L7.09383158,0 L14.1364421,4.17056842 L14.5465895,6.15397895 L17.8971158,6.15397895 L17.1449053,8.20509474 L14.9569895,8.20509474 L16.7346316,16.4785263 L12.5636842,14.4267789 L14.6833895,24 L8.18785263,10.8034105 L13.1110105,12.1706526 Z"
                }
            }
        ]
    })(props);
}
function GrTwitch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "m16.673 16.163 3.43-3.429V1.959H3.939v14.204h4.408v2.939l2.94-2.939h5.386ZM1 3.92 1.98 0h20.08v13.715l-7.836 7.835h-3.917L7.857 24H5.409v-2.45H1V3.92Zm10.286 7.836h-1.96V5.877h1.96v5.878Zm5.387 0h-1.959V5.877h1.96v5.878Z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function GrTwitter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M24,4.3086 C23.117,4.7006 22.168,4.9646 21.172,5.0836 C22.188,4.4746 22.969,3.5096 23.337,2.3596 C22.386,2.9246 21.332,3.3336 20.21,3.5556 C19.312,2.5976 18.032,1.9996 16.616,1.9996 C13.897,1.9996 11.692,4.2046 11.692,6.9236 C11.692,7.3096 11.736,7.6856 11.82,8.0456 C7.728,7.8406 4.099,5.8806 1.671,2.9006 C1.247,3.6286 1.004,4.4736 1.004,5.3766 C1.004,7.0846 1.873,8.5926 3.195,9.4756 C2.388,9.4486 1.628,9.2276 0.964,8.8596 L0.964,8.9206 C0.964,11.3066 2.661,13.2966 4.914,13.7486 C4.501,13.8626 4.065,13.9216 3.617,13.9216 C3.299,13.9216 2.991,13.8906 2.69,13.8336 C3.317,15.7896 5.135,17.2136 7.29,17.2536 C5.604,18.5736 3.481,19.3606 1.175,19.3606 C0.777,19.3606 0.385,19.3376 0,19.2926 C2.179,20.6886 4.767,21.5046 7.548,21.5046 C16.605,21.5046 21.557,14.0016 21.557,7.4946 C21.557,7.2816 21.552,7.0696 21.543,6.8586 C22.505,6.1636 23.34,5.2966 24,4.3086"
                }
            }
        ]
    })(props);
}
function GrUbuntu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M24,12.000127 C24,18.6272309 18.6273155,23.9999153 11.999873,23.9999153 C5.37243046,23.9999153 0,18.6273155 0,12.000127 C0,5.37251513 5.37234579,0 11.9997883,0 C18.6272309,0 24,5.37251513 24,12.000127 L24,12.000127 Z M3.84013547,10.3980668 C2.95511615,10.3980668 2.23799058,11.1151924 2.23799058,12.0002117 C2.23799058,12.8848923 2.95511615,13.6021026 3.84013547,13.6021026 C4.72481611,13.6021026 5.44202635,12.8848923 5.44202635,12.0002117 C5.44202635,11.1151077 4.72490078,10.3980668 3.84013547,10.3980668 L3.84013547,10.3980668 Z M15.2791773,17.6795583 C14.5128605,18.121941 14.2505636,19.1013635 14.6927769,19.8673416 C15.1352442,20.6336585 16.114582,20.8961247 16.8808989,20.4537421 C17.6469617,20.0114441 17.909428,19.0320216 17.4670453,18.2657894 C17.0247473,17.4998113 16.0452402,17.2372603 15.2791773,17.6795583 L15.2791773,17.6795583 Z M7.32009948,11.9999577 C7.32009948,10.4166088 8.10690561,9.01808689 9.31010178,8.17125218 L8.1388249,6.20927451 C6.73674704,7.14602508 5.69382463,8.57807489 5.26058596,10.255319 C5.76663786,10.6678144 6.08997936,11.2959554 6.08997936,12.000127 C6.08997936,12.7041293 5.76663786,13.3322703 5.2605013,13.744681 C5.6936553,15.4220944 6.73666237,16.8541443 8.13874023,17.7908102 L9.31010178,15.8286632 C8.10690561,14.9819978 7.32009948,13.5835606 7.32009948,11.9999577 L7.32009948,11.9999577 Z M12.0000423,7.32001482 C14.4449579,7.32001482 16.4504542,9.19461662 16.6606812,11.5849223 L18.9439684,11.5515637 C18.8316159,9.78677438 18.0607271,8.20198614 16.8759882,7.03722858 C16.2668971,7.26735223 15.5632336,7.23246962 14.9550738,6.88127282 C14.3461521,6.52973736 13.964052,5.93673293 13.8594042,5.29318258 C13.2674157,5.12935283 12.6443547,5.04002963 12.000127,5.04002963 C10.8921807,5.04002963 9.84544829,5.30012524 8.91564038,5.7607112 L10.0286667,7.75545482 C10.6278518,7.47664791 11.2955321,7.32001482 12.0000423,7.32001482 L12.0000423,7.32001482 Z M12.0000423,16.6799852 C11.2954474,16.6799852 10.6278518,16.5233521 10.028582,16.2445452 L8.91538638,18.2394581 C9.84527896,18.6998748 10.892096,18.960055 12.0000423,18.960055 C12.64427,18.960055 13.2673311,18.8707318 13.8594042,18.7069021 C13.964052,18.0633517 14.3462367,17.4703473 14.9552432,17.1185578 C15.5634029,16.7675304 16.2670665,16.7326478 16.8761576,16.9628561 C18.0608117,15.7980139 18.8317006,14.2132256 18.9438837,12.4484363 L16.6605965,12.4150777 C16.4505389,14.805722 14.4449579,16.6799852 12.0000423,16.6799852 L12.0000423,16.6799852 Z M15.2789233,6.32027234 C16.0451555,6.76282433 17.0246627,6.5002734 17.466876,5.73429524 C17.9093433,4.96797841 17.6470464,3.98855591 16.8807295,3.54608858 C16.114582,3.10379059 15.1351595,3.36625686 14.6926922,4.13257369 C14.2503942,4.89855185 14.5128605,5.87805902 15.2789233,6.32027234 L15.2789233,6.32027234 Z"
                }
            }
        ]
    })(props);
}
function GrUnderline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.41,4.53V4.18h4.66v.36h-.49a1.34,1.34,0,0,0-1.19.65,3,3,0,0,0-.2,1.4v5.33A9.45,9.45,0,0,1,16.78,15a3.85,3.85,0,0,1-1.54,1.87,5.49,5.49,0,0,1-3.13.78,5.89,5.89,0,0,1-3.27-.75,4,4,0,0,1-1.58-2A11.14,11.14,0,0,1,7,11.64V6.5a2.58,2.58,0,0,0-.33-1.59,1.38,1.38,0,0,0-1.08-.38H5V4.18h5.68v.36h-.5A1.3,1.3,0,0,0,9.06,5,2.87,2.87,0,0,0,8.81,6.5v5.73A12.52,12.52,0,0,0,9,14a3.71,3.71,0,0,0,.51,1.54,2.77,2.77,0,0,0,1.06.91,3.68,3.68,0,0,0,1.7.36,4.69,4.69,0,0,0,2.31-.56,3,3,0,0,0,1.39-1.44,8.33,8.33,0,0,0,.37-3V6.5A2.72,2.72,0,0,0,16,5a1.43,1.43,0,0,0-1.12-.43Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.93,20V19H19v1Z"
                }
            }
        ]
    })(props);
}
function GrUndo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.18,4,8.6,5.44,6.06,8h9.71a6,6,0,0,1,0,12h-2V18h2a4,4,0,0,0,0-8H6.06L8.6,12.51,7.18,13.92,2.23,9Z"
                }
            }
        ]
    })(props);
}
function GrUnlink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M17,11 L21.5856815,15.5856815 C22.366788,16.366788 22.3692352,17.6307648 21.5856815,18.4143185 L18.4143185,21.5856815 C17.633212,22.366788 16.3692352,22.3692352 15.5856815,21.5856815 L11,17 M17,8 L21,8 M16,7 L16,3 M8,21 L8,17 M3,16 L7,16 M7,13 L2.4143185,8.4143185 C1.63321196,7.63321196 1.63076481,6.36923519 2.4143185,5.5856815 L5.5856815,2.4143185 C6.36678804,1.63321196 7.63076481,1.63076481 8.4143185,2.4143185 L13,7"
                }
            }
        ]
    })(props);
}
function GrUnlock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M23,23 L23,11 L9,11 L9,23 L23,23 Z M14,17 L18,17 M11,11 L11,7 C11,4 11,1 6,1 C1,1 1,4 1,7 L1,11"
                }
            }
        ]
    })(props);
}
function GrUnorderedList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "5.94",
                    "y": "6.42",
                    "width": "18.06",
                    "height": "1.75"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "5.94",
                    "y": "11.71",
                    "width": "18.06",
                    "height": "1.75"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "5.94",
                    "y": "16.99",
                    "width": "18.06",
                    "height": "1.75"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "1.85",
                    "cy": "7.29",
                    "r": "1.52"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "1.85",
                    "cy": "12.58",
                    "r": "1.52"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "1.85",
                    "cy": "17.87",
                    "r": "1.52"
                }
            }
        ]
    })(props);
}
function GrUnsorted(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M15.2044 15.3211L16.8012 13.7243L17.5083 14.4314L15.058 16.8817L14.7044 17.2353L14.3509 16.8817L11.9006 14.4314L12.6077 13.7243L14.2044 15.3211V7.21705H15.2044V15.3211ZM9.30385 8.91421V17.0182H10.3038V8.91421L11.9006 10.511L12.6077 9.80385L10.1574 7.35355L9.80385 7L9.45029 7.35355L6.99999 9.80385L7.7071 10.511L9.30385 8.91421Z"
                }
            }
        ]
    })(props);
}
function GrUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "points": "7.086 1.174 17.086 11.174 7.086 21.174",
                    "transform": "rotate(-89 12.086 11.174)"
                }
            }
        ]
    })(props);
}
function GrUpdate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1.7507,16.0022 C3.3517,20.0982 7.3367,23.0002 11.9997,23.0002 C18.0747,23.0002 22.9997,18.0752 22.9997,12.0002 M22.2497,7.9982 C20.6487,3.9012 16.6627,1.0002 11.9997,1.0002 C5.9247,1.0002 0.9997,5.9252 0.9997,12.0002 M8.9997,16.0002 L0.9997,16.0002 L0.9997,24.0002 M22.9997,0.0002 L22.9997,8.0002 L14.9997,8.0002"
                }
            }
        ]
    })(props);
}
function GrUpgrade(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,18 L12,8 L12,18 Z M12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 Z M17,12 L12,7 L7,12"
                }
            }
        ]
    })(props);
}
function GrUploadOption(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "strokeWidth": "2",
                    "d": "M17 12l-5-5-5 5m5-4v10m0 5c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11z"
                }
            }
        ]
    })(props);
}
function GrUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,17 L1,23 L23,23 L23,17 M12,2 L12,19 M5,9 L12,2 L19,9"
                }
            }
        ]
    })(props);
}
function GrUsbKey(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 6C1.34315 6 0 7.34315 0 9V14C0 15.6569 1.34315 17 3 17H16H17V16H23H24V15V8V7H23H17V6H16H3ZM17 9V14H22V9H17ZM15 15V8H3C2.44772 8 2 8.44772 2 9V14C2 14.5523 2.44772 15 3 15H15ZM19 11.0078H19.5H19.51H20.01V10.5078V10.4978V9.99781H19.51H19.5H19V10.4978V10.5078V11.0078ZM19.51 13.0078H19.01V12.5078V12.4978V11.9978H19.51H19.52H20.02V12.4978V12.5078V13.0078H19.52H19.51Z"
                }
            }
        ]
    })(props);
}
function GrUserAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M5,24 L5,19 M11,24 L11,19 M1,24 L1,18 C1,13.0294373 4.13400675,11 8,11 C11.8659932,11 15,13 15,18 L15,24 M8,11 C10.7614237,11 13,8.76142375 13,6 C13,3.23857625 10.7614237,1 8,1 C5.23857625,1 3,3.23857625 3,6 C3,8.76142375 5.23857625,11 8,11 Z M16,11 L24,11 M20,7 L20,15"
                }
            }
        ]
    })(props);
}
function GrUserAdmin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M8,11 C10.7614237,11 13,8.76142375 13,6 C13,3.23857625 10.7614237,1 8,1 C5.23857625,1 3,3.23857625 3,6 C3,8.76142375 5.23857625,11 8,11 Z M13.0233822,13.0234994 C11.7718684,11.7594056 10.0125018,11 8,11 C4,11 1,14 1,18 L1,23 L8,23 M10,19.5 C10,20.88 11.12,22 12.5,22 C13.881,22 15,20.88 15,19.5 C15,18.119 13.881,17 12.5,17 C11.12,17 10,18.119 10,19.5 L10,19.5 Z M23,15 L20,12 L14,18 M17.5,14.5 L20.5,17.5 L17.5,14.5 Z"
                }
            }
        ]
    })(props);
}
function GrUserExpert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M8,11 C10.7614237,11 13,8.76142375 13,6 C13,3.23857625 10.7614237,1 8,1 C5.23857625,1 3,3.23857625 3,6 C3,8.76142375 5.23857625,11 8,11 Z M14.6431888,15.6961461 C14.3091703,14.6675626 13.7524493,13.7598949 13.0233822,13.0234994 C11.7718684,11.7594056 10.0125018,11 8,11 C4,11 1,14 1,18 L1,23 L11,23 M12,18.8235294 L16.1904762,22 L23,13"
                }
            }
        ]
    })(props);
}
function GrUserFemale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M20,24 L20,19 C19.9999999,15 15.9403581,14 15,14 C18.9475,14 20,12 20,12 C20,12 16.942739,10.031 17,6 C16.942739,3 14.8497684,1 12,1 C9.01190309,1 6.91893246,3 7,6 C6.91893246,9.969 4,12 4,12 C4,12 4.91417116,14 9,14 C7.92131306,14 4,15 4,19 L4,24 M16,19 L16,24 M8,19 L8,24"
                }
            }
        ]
    })(props);
}
function GrUserManager(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M16,12 C18.3736719,13.1826446 20,15.6506255 20,19 L20,23 L4,23 L4,19 C4,15.6457258 5.6310898,13.1754259 8,12 M12,13 C15.3137085,13 18,10.3137085 18,7 C18,3.6862915 15.3137085,1 12,1 C8.6862915,1 6,3.6862915 6,7 C6,10.3137085 8.6862915,13 12,13 Z M18,7 C16.5,7 15,7.3599999 13,5 C11,7.3599999 8.5,8 6,7 M7,13 L12.0249378,18.2571942 L17,13 M12,18 L12,23"
                }
            }
        ]
    })(props);
}
function GrUserNew(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M18,24 L18,12 M23,22 L13,15 M23,15 L13,22 M8,11 C10.7614237,11 13,8.76142375 13,6 C13,3.23857625 10.7614237,1 8,1 C5.23857625,1 3,3.23857625 3,6 C3,8.76142375 5.23857625,11 8,11 Z M13.0233822,13.0234994 C11.7718684,11.7594056 10.0125018,11 8,11 C4,11 1,14 1,18 L1,23 L11,23"
                }
            }
        ]
    })(props);
}
function GrUserPolice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M16,14 C18.3736719,15.1826446 20,17.6506255 20,21 L20,23 L4,23 L4,21 C4,17.6457258 5.6310898,15.1754259 8,14 M12,15 C15.2602409,15 17.9031883,12.3141492 17.9031883,9.00098429 C17.9031883,8.29933805 18.1210147,7.62582606 17.9031883,7 M6.09318017,7 C5.88352479,7.61511425 6.09318017,8.31344562 6.09318017,9.00098429 C6.09318017,12.3141492 8.73775349,15 12,15 L12,15 M6,8 L18,8 L21,4 C19.0884181,2.26537447 15.7904958,1 12,1 C8.16364606,1 4.83185613,2.29617718 3,4 L6,8 L6,8 L6,8 Z M12,5 C12.5522847,5 13,4.55228475 13,4 C13,4 11,4 11,4 C11,4.55228475 11.4477153,5 12,5 L12,5 L12,5 Z"
                }
            }
        ]
    })(props);
}
function GrUserSettings(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M18.0003,20.9998 C16.3453,20.9998 15.0003,19.6538 15.0003,17.9998 C15.0003,16.3458 16.3453,14.9998 18.0003,14.9998 C19.6543,14.9998 21.0003,16.3458 21.0003,17.9998 C21.0003,19.6538 19.6543,20.9998 18.0003,20.9998 L18.0003,20.9998 Z M24.0003,17.9998 L21.0003,17.9998 L24.0003,17.9998 Z M20.1213,20.1218 L22.2423,22.2428 L20.1213,20.1218 Z M18.0003,23.9998 L18.0003,20.9998 L18.0003,23.9998 Z M13.7573,22.2428 L15.8783,20.1208 L13.7573,22.2428 Z M12.0003,17.9998 L15.0003,17.9998 L12.0003,17.9998 Z M15.8783,15.8788 L13.7573,13.7578 L15.8783,15.8788 Z M18.0003,14.9998 L18.0003,11.9998 L18.0003,14.9998 Z M20.1213,15.8788 L22.2423,13.7578 L20.1213,15.8788 Z M12.5,12.5 C11.2660678,11.4458897 9.77508483,11 8,11 C4.13400675,11 1,13.0294373 1,18 L1,23 L11,23 M8,11 C10.7614237,11 13,8.76142375 13,6 C13,3.23857625 10.7614237,1 8,1 C5.23857625,1 3,3.23857625 3,6 C3,8.76142375 5.23857625,11 8,11 Z"
                }
            }
        ]
    })(props);
}
function GrUserWorker(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M3,6 L21,6 L3,6 Z M10,2 L10,4 M14,2 L14,4 M16,12 C18.3736719,13.1826446 20,15.6506255 20,19 L20,23 L4,23 L4,19 C4,15.6457258 5.6310898,13.1754259 8,12 M12,16.5 L12,23 M12,13 C15.3137085,13 18,10.3137085 18,7 C18,3.6862915 15.3137085,1 12,1 C8.6862915,1 6,3.6862915 6,7 C6,10.3137085 8.6862915,13 12,13 Z M8,12 C8,14.209139 9.790861,16 12,16 L12,16 C14.209139,16 16,14.209139 16,12"
                }
            }
        ]
    })(props);
}
function GrUser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M8,24 L8,19 M16,24 L16,19 M3,24 L3,19 C3,14.0294373 7.02943725,11 12,11 C16.9705627,11 21,14.0294373 21,19 L21,24 M12,11 C14.7614237,11 17,8.76142375 17,6 C17,3.23857625 14.7614237,1 12,1 C9.23857625,1 7,3.23857625 7,6 C7,8.76142375 9.23857625,11 12,11 Z"
                }
            }
        ]
    })(props);
}
function GrValidate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M20,15 C19,16 21.25,18.75 20,20 C18.75,21.25 16,19 15,20 C14,21 13.5,23 12,23 C10.5,23 10,21 9,20 C8,19 5.25,21.25 4,20 C2.75,18.75 5,16 4,15 C3,14 1,13.5 1,12 C1,10.5 3,10 4,9 C5,8 2.75,5.25 4,4 C5.25,2.75 8,5 9,4 C10,3 10.5,1 12,1 C13.5,1 14,3 15,4 C16,5 18.75,2.75 20,4 C21.25,5.25 19,8 20,9 C21,10 23,10.5 23,12 C23,13.5 21,14 20,15 Z M7,12 L10,15 L17,8"
                }
            }
        ]
    })(props);
}
function GrVend(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M3,2.00246167 C3,1.44881738 3.44494629,1 3.99339768,1 L20.0066023,1 C20.5552407,1 21,1.43945834 21,2.00246167 L21,23 L3,23 L3,2.00246167 Z M15,1 L15,23 M3,16 L15,16 M8,17 L10,17 M7,16 L7,12 M7,9 L7,5 M11,16 L11,12 M11,9 L11,5 M17,12 L18,12 M17,9 L19,8.99999994 M17,20 L19,19.9999999 M3,9 L15,9"
                }
            }
        ]
    })(props);
}
function GrVenmo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "clipPath": "url(#a)"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "fillRule": "evenodd",
                            "d": "M24 12c0 6.628-5.372 12-12 12-6.627 0-12-5.372-12-12C0 5.373 5.373 0 12 0c6.628 0 12 5.373 12 12Zm-5.982-3.571c0-1-.21-1.79-.677-2.558l-4.035.814c.256.535.42 1.185.42 2.14 0 1.744-1.237 4.303-2.24 5.93L10.413 6.15l-4.431.42 2.03 12.094h5.06c2.216-2.907 4.946-7.047 4.946-10.234Z",
                            "clipRule": "evenodd"
                        }
                    }
                ]
            },
            {
                "tag": "defs",
                "attr": {},
                "child": [
                    {
                        "tag": "clipPath",
                        "attr": {
                            "id": "a"
                        },
                        "child": [
                            {
                                "tag": "path",
                                "attr": {
                                    "d": "M0 0h24v24H0z"
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    })(props);
}
function GrVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M15,9 L23,5 L23,19 L15,15 L15,9 Z M1,5 L15,5 L15,19 L1,19 L1,5 Z"
                }
            }
        ]
    })(props);
}
function GrView(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,21 C7,21 1,16 1,12 C1,8 7,3 12,3 C17,3 23,8 23,12 C23,16 17,21 12,21 Z M12,7 C9.23875,7 7,9.23875 7,12 C7,14.76125 9.23875,17 12,17 C14.76125,17 17,14.76125 17,12 C17,9.23875 14.76125,7 12,7 L12,7 Z"
                }
            }
        ]
    })(props);
}
function GrVimeo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M23.9883358,6.80210856 C23.8810843,9.13839127 22.2498115,12.336436 19.0937673,16.3969929 C15.8304716,20.6368022 13.069683,22.7570819 10.8121514,22.7570819 C9.41263176,22.7570819 8.22836518,21.4663138 7.26160165,18.8840277 C6.61584261,16.5162445 5.97083358,14.1484614 5.32432453,11.7806783 C4.60581447,9.19914212 3.8363037,7.90687403 3.01204216,7.90687403 C2.83203964,7.90687403 2.20428086,8.28487932 1.12801579,9.03713985 L0,7.58286949 C1.18426658,6.54260493 2.35203292,5.50234037 3.50179902,4.45982578 C5.08132113,3.09555668 6.26858775,2.37779663 7.0583488,2.30504561 C8.92587495,2.1257931 10.075641,3.40231097 10.5068971,6.13459922 C10.9734036,9.08289049 11.2966581,10.9166662 11.4774107,11.6344262 C12.0166682,14.0809605 12.6091765,15.3027276 13.2556856,15.3027276 C13.7574426,15.3027276 14.5127032,14.5092164 15.5184672,12.9214442 C16.5234813,11.335172 17.0619888,10.1284051 17.1339898,9.2981435 C17.2779919,7.92937434 16.7394843,7.24311474 15.5184672,7.24311474 C14.9439592,7.24311474 14.3514509,7.37511658 13.7424424,7.63612024 C14.9222089,3.77356617 17.1752404,1.89778991 20.501537,2.0042914 C22.9675715,2.07704242 24.1308378,3.6760648 23.9883358,6.80210856"
                }
            }
        ]
    })(props);
}
function GrVirtualMachine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,23 L14,23 L14,10 L1,10 L1,23 Z M10,19 L23,19 L23,6 L10,6 L10,19 Z M5,14 L18,14 L18,1 L5,1 L5,14 Z"
                }
            }
        ]
    })(props);
}
function GrVirtualStorage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,22 C16.9705627,22 21,19.7614237 21,17 C21,14.2385763 16.9705627,12 12,12 C7.02943725,12 3,14.2385763 3,17 C3,19.7614237 7.02943725,22 12,22 Z M12,17.5 C16.9705627,17.5 21,15.2614237 21,12.5 C21,9.73857625 16.9705627,7.5 12,7.5 C7.02943725,7.5 3,9.73857625 3,12.5 C3,15.2614237 7.02943725,17.5 12,17.5 Z M12,12 C16.9705627,12 21,9.76142375 21,7 C21,4.23857625 16.9705627,2 12,2 C7.02943725,2 3,4.23857625 3,7 C3,9.76142375 7.02943725,12 12,12 Z"
                }
            }
        ]
    })(props);
}
function GrVisa(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.75604904,6.3421103 C4.34405863,5.55921989 2.73289927,4.92988052 0.93115208,4.49372953 L0.98977571,4.14310685 L8.39658295,4.14310685 C9.39421768,4.18029541 10.2006584,4.49872244 10.4787118,5.56582745 L12.0890953,13.309165 C12.0891819,13.3094435 12.0892685,13.3097219 12.0893551,13.3100003 L12.5685021,15.6453901 L17.065563,4.15352309 L21.9311521,4.15352309 L14.6996992,20.9731676 L9.8397917,20.9787631 L5.75604904,6.3421103 L5.75604904,6.3421103 Z"
                }
            }
        ]
    })(props);
}
function GrVmMaintenance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M19,9.9999 L19,1.9999 L7,1.9999 L7,13.9999 L14,13.9999 L14,6.9999 L2,6.9999 L2,18.9999 L10,18.9999 M14,23 L20,17 M21,14 C19.8954305,14 19,14.8954305 19,16 C19,17.1045695 19.8954305,18 21,18 C22.1045695,18 23,17.1045695 23,16"
                }
            }
        ]
    })(props);
}
function GrVmware(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.57403651,0 C4.61501014,0 3.84584178,0.753590264 3.84584178,1.67951318 L3.84584178,7.42393509 L1.72819473,7.42393509 C0.769168365,7.42393486 0,8.18044625 0,9.10344828 L0,21.5415822 C0,22.4675058 0.769168357,23.2210953 1.72819473,23.2210953 L14.5801217,23.2210953 C15.5391481,23.2210946 16.3326572,22.4675051 16.3326572,21.5415822 L16.3326572,19.4969574 L22.2718053,19.4969574 C23.229858,19.4969582 24,18.7404462 24,17.8174442 L24,5.37931034 C24,4.45533461 23.229858,3.72413793 22.2718053,3.72413793 L20.1541582,3.72413793 L20.1541582,1.67951318 C20.1541582,0.753590287 19.3830426,0 18.4259635,0 L5.57403651,0 L5.57403651,0 Z M5.57403651,0.949290061 L18.4259635,0.949290061 C18.8455976,0.949290139 19.1805274,1.2725355 19.1805274,1.67951318 L19.1805274,3.72413793 L9.4198783,3.72413793 C8.46279919,3.72413785 7.6673428,4.45533469 7.6673428,5.37931034 L7.6673428,7.42393509 L4.81947262,7.42393509 L4.81947262,1.67951318 C4.81947246,1.2725355 5.15148073,0.949290061 5.57403651,0.949290061 L5.57403651,0.949290061 Z M9.4198783,4.64908722 L19.1805274,4.64908722 L19.1805274,14.0933063 C19.1805274,14.5002848 18.8455984,14.8478702 18.4259635,14.8478702 L16.3326572,14.8478702 L16.3326572,9.10344828 C16.332658,8.18044625 15.5391481,7.42393509 14.5801217,7.42393509 L8.64097363,7.42393509 L8.64097363,5.37931034 C8.64097363,4.97330621 9.00024341,4.64908722 9.4198783,4.64908722 L9.4198783,4.64908722 Z M20.1541582,4.64908722 L22.2718053,4.64908722 C22.6924138,4.64908707 23.0263692,4.97330629 23.0263692,5.37931034 L23.0263692,17.8174442 C23.0263692,18.2234483 22.6924138,18.5476673 22.2718053,18.5476673 L16.3326572,18.5476673 L16.3326572,15.7971602 L18.4259635,15.7971602 C19.3830418,15.7971595 20.1541582,15.0192292 20.1541582,14.0933063 L20.1541582,4.64908722 L20.1541582,4.64908722 Z M1.72819473,8.37322515 L3.84584178,8.37322515 L3.84584178,14.0933063 C3.84584178,15.01923 4.61501014,15.7971602 5.57403651,15.7971602 L7.6673428,15.7971602 L7.6673428,17.8174442 C7.66734295,18.7404462 8.46279919,19.4969574 9.4198783,19.4969574 L15.3590264,19.4969574 L15.3590264,21.5415822 C15.3590271,21.947587 15.0026775,22.2718053 14.5801217,22.2718053 L1.72819473,22.2718053 C1.30271805,22.2718045 0.973630832,21.9475862 0.973630832,21.5415822 L0.973630832,9.10344828 C0.97363091,8.69841785 1.30271805,8.37322515 1.72819473,8.37322515 L1.72819473,8.37322515 Z M4.81947262,8.37322515 L7.6673428,8.37322515 L7.6673428,14.8478702 L5.57403651,14.8478702 C5.15148073,14.8478702 4.81947262,14.500284 4.81947262,14.0933063 L4.81947262,8.37322515 L4.81947262,8.37322515 Z M8.64097363,8.37322515 L14.5801217,8.37322515 C15.0026775,8.37322515 15.3590264,8.69841785 15.3590264,9.10344828 L15.3590264,14.8478702 L8.64097363,14.8478702 L8.64097363,8.37322515 L8.64097363,8.37322515 Z M8.64097363,15.7971602 L15.3590264,15.7971602 L15.3590264,18.5476673 L9.4198783,18.5476673 C9.00024341,18.5476673 8.64097363,18.2234483 8.64097363,17.8174442 L8.64097363,15.7971602 L8.64097363,15.7971602 Z"
                }
            }
        ]
    })(props);
}
function GrVolumeControl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,18 C15.3137085,18 18,15.3137085 18,12 C18,8.6862915 15.3137085,6 12,6 C8.6862915,6 6,8.6862915 6,12 C6,15.3137085 8.6862915,18 12,18 Z M8,8 L11,11 M12,22 C15.4612937,22 18.5118579,20.2414583 20.3069882,17.5690793 C21.3761716,15.9774047 22,14.0615538 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12"
                }
            }
        ]
    })(props);
}
function GrVolumeLow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,8 L1,16 L6.09901951,16 L12,21 L12,3 L6,8 L1,8 Z M15,16 L15,16 C17.209139,16 19,14.209139 19,12 C19,9.790861 17.209139,8 15,8"
                }
            }
        ]
    })(props);
}
function GrVolumeMute(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M1,8 L1,16 L6.09901951,16 L12,21 L12,3 L6,8 L1,8 Z M15,9 L21,15 M21,9 L15,15"
                }
            }
        ]
    })(props);
}
function GrVolume(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M15,16 C17.209,16 19,14.209 19,12 C19,9.791 17.209,8 15,8 M15,20 C20,20 23,16.411 23,12 C23,7.589 19.411,4 15,4 M1,12 L1,8 L6,8 L12,3 L12,21 L6,16 L1,16 L1,12"
                }
            }
        ]
    })(props);
}
function GrVulnerability(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,0 L12,24 L12,0 Z M0,12 L24,12 L0,12 Z M17,12 C17,9.243 14.757,7 12,7 C9.243,7 7,9.243 7,12 C7,14.757 9.243,17 12,17 C14.757,17 17,14.757 17,12 L17,12 Z M12,21 C7.038,21 3,16.963 3,12 C3,7.037 7.038,3 12,3 C16.962,3 21,7.037 21,12 C21,16.963 16.962,21 12,21 L12,21 Z"
                }
            }
        ]
    })(props);
}
function GrWaypoint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "points": "3 11 11 13 13 21 21 3"
                }
            }
        ]
    })(props);
}
function GrWebcam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22H4",
                    "strokeWidth": "2",
                    "strokeLinecap": "round"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 18V21",
                    "strokeWidth": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 21.5V18",
                    "strokeWidth": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 19C16.9706 19 21 14.9706 21 10C21 5.02944 16.9706 1 12 1C7.02944 1 3 5.02944 3 10C3 14.9706 7.02944 19 12 19Z",
                    "strokeWidth": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 16C15.3137 16 18 13.3137 18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10C6 13.3137 8.68629 16 12 16Z",
                    "strokeWidth": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 14C14.2091 14 16 12.2091 16 10C16 7.79086 14.2091 6 12 6C9.79086 6 8 7.79086 8 10C8 12.2091 9.79086 14 12 14Z",
                    "strokeWidth": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 11C12.5523 11 13 10.5523 13 10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10C11 10.5523 11.4477 11 12 11Z",
                    "strokeWidth": "2"
                }
            }
        ]
    })(props);
}
function GrWechat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M21.502 19.228C23.026 18.123 24 16.49 24 14.674c0-3.326-3.237-6.023-7.229-6.023s-7.229 2.697-7.229 6.023c0 3.327 3.237 6.024 7.229 6.024.825 0 1.621-.117 2.36-.33l.212-.032c.139 0 .265.043.384.111l1.583.914.139.045a.241.241 0 0 0 .241-.241l-.039-.176-.326-1.215-.025-.154a.48.48 0 0 1 .202-.392ZM8.675 2C3.884 2 0 5.236 0 9.229c0 2.178 1.168 4.139 2.997 5.464a.575.575 0 0 1 .243.471l-.03.184-.391 1.458-.047.211c0 .16.13.29.289.29l.168-.054 1.899-1.097a.908.908 0 0 1 .46-.133l.255.038c.886.255 1.842.397 2.832.397l.476-.012a5.586 5.586 0 0 1-.291-1.771c0-3.641 3.542-6.593 7.911-6.593l.471.012C16.589 4.641 13.002 2 8.675 2Zm5.686 11.711a.964.964 0 1 1 .001-1.927.964.964 0 0 1-.001 1.927Zm4.82 0a.964.964 0 1 1 0-1.928.964.964 0 0 1 0 1.928ZM5.783 8.072a1.156 1.156 0 1 1 0-2.312 1.156 1.156 0 0 1 0 2.312Zm5.783 0a1.156 1.156 0 1 1 0-2.312 1.156 1.156 0 0 1 0 2.312Z",
                    "clipRule": "evenodd"
                }
            }
        ]
    })(props);
}
function GrWhatsapp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "clipPath": "url(#a)"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "m.057 24 1.687-6.163a11.867 11.867 0 0 1-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.817 11.817 0 0 1 8.413 3.488 11.824 11.824 0 0 1 3.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 0 1-5.688-1.448L.057 24Zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.89 9.884 0 2.225.652 3.891 1.747 5.634l-1 3.648 3.743-.981Zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.67.149-.197.297-.767.967-.94 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.15-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.67-1.611-.916-2.206-.242-.579-.487-.501-.67-.51l-.57-.01c-.197 0-.52.074-.791.372-.272.298-1.04 1.016-1.04 2.479s1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.57-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414Z"
                        }
                    }
                ]
            },
            {
                "tag": "defs",
                "attr": {},
                "child": [
                    {
                        "tag": "clipPath",
                        "attr": {
                            "id": "a"
                        },
                        "child": [
                            {
                                "tag": "path",
                                "attr": {
                                    "d": "M0 0h24v24H0z"
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    })(props);
}
function GrWheelchairActive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "2",
                    "d": "M7,6 L10,3 L17,6 L17,8 L14,11 M9,22 C12.3137085,22 15,19.3137085 15,16 C15,12.6862915 12.3137085,10 9,10 C5.6862915,10 3,12.6862915 3,16 C3,19.3137085 5.6862915,22 9,22 Z M9,17 C9.55228475,17 10,16.5522847 10,16 C10,15.4477153 9.55228475,15 9,15 C8.44771525,15 8,15.4477153 8,16 C8,16.5522847 8.44771525,17 9,17 Z M14,12 L19,15 L17,21 M19,4 C19.5522847,4 20,3.55228475 20,3 C20,2.44771525 19.5522847,2 19,2 C18.4477153,2 18,2.44771525 18,3 C18,3.55228475 18.4477153,4 19,4 Z M13,10 L17,6 M11,10 L15,6"
                }
            }
        ]
    })(props);
}
function GrWheelchair(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "2",
                    "d": "M10,3 L10,12 L17,12 L19,18 L21,18 M15,9 L9,9 C5.6862915,9 3,11.6862915 3,15 C3,18.3137085 5.6862915,21 9,21 C12.3137085,21 15,18.3137085 15,15 M11,4 C11.5522847,4 12,3.55228475 12,3 C12,2.44771525 11.5522847,2 11,2 C10.4477153,2 10,2.44771525 10,3 C10,3.55228475 10.4477153,4 11,4 Z"
                }
            }
        ]
    })(props);
}
function GrWifiLow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none",
                    "fillRule": "evenodd"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "strokeWidth": "2",
                            "d": "M12,20 C13.1045695,20 14,19.1045695 14,18 C14,16.8954305 13.1045695,16 12,16 C10.8954305,16 10,16.8954305 10,18 C10,19.1045695 10.8954305,20 12,20 Z M7.75735931,13.7573593 C10.1005051,11.4142136 13.8994949,11.4142136 16.2426407,13.7573593"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "strokeOpacity": ".2",
                            "strokeWidth": "2",
                            "d": "M4.92893219,10.9289322 C8.83417511,7.02368927 15.1658249,7.02368927 19.0710678,10.9289322 M2.10050506,8.10050506 C7.56784515,2.63316498 16.4321549,2.63316498 21.8994949,8.10050506",
                            "opacity": ".8"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function GrWifiMedium(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "strokeWidth": "2",
                            "d": "M12,20 C13.1045695,20 14,19.1045695 14,18 C14,16.8954305 13.1045695,16 12,16 C10.8954305,16 10,16.8954305 10,18 C10,19.1045695 10.8954305,20 12,20 Z M7.75735931,13.7573593 C10.1005051,11.4142136 13.8994949,11.4142136 16.2426407,13.7573593 M4.92893219,10.9289322 C8.83417511,7.02368927 15.1658249,7.02368927 19.0710678,10.9289322"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "strokeOpacity": ".2",
                            "strokeWidth": "2",
                            "d": "M2.10050506,8.10050506 C7.56784515,2.63316498 16.4321549,2.63316498 21.8994949,8.10050506",
                            "opacity": ".8"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function GrWifiNone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "circle",
                        "attr": {
                            "cx": "12",
                            "cy": "18",
                            "r": "2",
                            "strokeWidth": "2"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "strokeOpacity": ".2",
                            "strokeWidth": "2",
                            "d": "M7.75735931,13.7573593 C10.1005051,11.4142136 13.8994949,11.4142136 16.2426407,13.7573593 M4.92893219,10.9289322 C8.83417511,7.02368927 15.1658249,7.02368927 19.0710678,10.9289322 M2.10050506,8.10050506 C7.56784515,2.63316498 16.4321549,2.63316498 21.8994949,8.10050506",
                            "opacity": ".8"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function GrWifi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M12,20 C13.1045695,20 14,19.1045695 14,18 C14,16.8954305 13.1045695,16 12,16 C10.8954305,16 10,16.8954305 10,18 C10,19.1045695 10.8954305,20 12,20 Z M7.75735931,13.7573593 C10.1005051,11.4142136 13.8994949,11.4142136 16.2426407,13.7573593 M4.92893219,10.9289322 C8.83417511,7.02368927 15.1658249,7.02368927 19.0710678,10.9289322 M2.10050506,8.10050506 C7.56784515,2.63316498 16.4321549,2.63316498 21.8994949,8.10050506"
                }
            }
        ]
    })(props);
}
function GrWindowsLegacy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none",
                    "fillRule": "evenodd",
                    "transform": "translate(0 1)"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M2.61341757,9.09629841 C2.7158178,8.7382976 2.805018,8.42456355 2.89541821,8.11136284 C3.56075305,5.80989096 4.22662122,3.50828575 4.8912894,1.2065472 C4.91715612,1.11628032 4.94488952,1.04348016 5.04795642,1.0020134 C6.19889236,0.54067902 7.37476169,0.176944863 8.61343117,0.0430778925 C10.2790349,-0.137189183 11.8078384,0.252278367 13.2198416,1.13694704 C13.4037087,1.25228063 13.5815758,1.37681425 13.7695762,1.48414783 C13.8894431,1.55294798 13.9063765,1.62561481 13.8678431,1.75601511 C13.3153085,3.65268607 12.7681072,5.55149038 12.2195727,7.44962801 C12.0282389,8.11136284 11.8315718,8.77229768 11.6463714,9.43629918 C11.6051713,9.58403285 11.5710379,9.60896624 11.4346376,9.51576603 C10.6210357,8.96309811 9.7627671,8.49949706 8.80209826,8.25256316 C7.58996218,7.94109579 6.3794261,8.00362927 5.1699567,8.26842987 C4.30822141,8.45709696 3.47768619,8.74189761 2.61341757,9.09629841"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M17.2771841,12.0252117 C15.748114,12.0356117 14.3994443,11.4986772 13.1433081,10.673742 C12.7882406,10.4397415 12.7886406,10.4422748 12.9053076,10.0392072 C13.6165092,7.58053497 14.3261108,5.12119607 15.0394457,2.66292383 C15.1090459,2.42198995 15.0575791,2.37798985 15.3281131,2.5593236 C16.2241151,3.15892495 17.1677172,3.65252607 18.2365196,3.8690599 C19.3649222,4.09746041 20.4851914,4.01946024 21.5987939,3.77025967 C22.2990622,3.61345932 22.9791971,3.39345882 23.6470652,3.13545823 C23.7433321,3.09852482 23.841999,3.03665801 23.9410659,3.12825822 C24.0378661,3.21772509 23.993066,3.31839198 23.9631993,3.42092555 C23.2499977,5.88613113 22.5371961,8.35133672 21.8289278,10.8178756 C21.7963944,10.9330759 21.7361276,10.9893427 21.629594,11.0320095 C20.4671914,11.4973439 19.2778553,11.8633447 18.0245192,11.982945 C17.7765186,12.0066783 17.5266514,12.0116117 17.2771841,12.0252117"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M21.3774601,12.3517725 C21.2214597,12.8916403 21.0781261,13.3883081 20.9345258,13.8851093 C20.3333244,15.9657806 19.7294564,18.0467187 19.133855,20.1296567 C19.0849216,20.2995238 18.999188,20.3868573 18.8355877,20.4499241 C17.8101187,20.8453917 16.767183,21.1704591 15.6730472,21.3241928 C13.9798433,21.5615267 12.4050398,21.2415259 10.9429031,20.3605906 C10.7010359,20.2151236 10.4675687,20.0545899 10.2238348,19.9119229 C10.1034345,19.8412561 10.0921012,19.7668559 10.1301013,19.638989 C10.6530358,17.8428516 11.1705036,16.0445808 11.6902381,14.2472434 C11.9013053,13.5156418 12.1131724,12.7837734 12.3247729,12.0528384 C12.3922397,11.8223046 12.3930397,11.8233713 12.6042402,11.9623049 C13.3642419,12.4640394 14.1561104,12.8985737 15.0387791,13.1489743 C16.3118486,13.5093751 17.5858515,13.4499083 18.8613211,13.1671076 C19.7098563,12.9795072 20.5285248,12.6953732 21.3774601,12.3517725"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M11.1789303,11.0465695 C11.0506634,11.4885705 10.9317298,11.8983048 10.8131962,12.3081724 C10.1897281,14.4641772 9.56425999,16.6203155 8.94679192,18.7783204 C8.8931918,18.9633874 8.84385836,18.9676541 8.69425802,18.8655205 C7.83718941,18.2809859 6.92972068,17.8009848 5.9074517,17.5680509 C4.74984908,17.3036503 3.5983798,17.3749838 2.44904386,17.6268511 C1.72917556,17.7844514 1.03050731,18.0113853 0.342905756,18.2757859 C0.252505551,18.3104526 0.159972008,18.3605861 0.0658384616,18.2835192 C-0.0394951104,18.1976524 0.00623832657,18.0928521 0.0351717255,17.9928519 C0.746506671,15.5340463 1.45837495,13.0755074 2.16810989,10.6163019 C2.19837663,10.5137683 2.24971008,10.4544348 2.35291031,10.4131014 C3.53371299,9.93803365 4.74171573,9.56909948 6.01571861,9.45123255 C7.58705551,9.30656555 9.0422588,9.66336636 10.3882619,10.4799015 C10.618129,10.6195019 10.8451962,10.7648355 11.0723967,10.9100359 C11.1302635,10.9475026 11.2103971,10.980036 11.1789303,11.0465695"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function GrWindows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M23.923,0 L10.959,1.893 L10.959,11.481 L23.923,11.379 L23.923,0 Z M0,3.398 L0.009,11.553 L9.782,11.498 L9.778,2.066 L0,3.398 Z M0.008,20.681 L9.781,22.025 L9.773,12.585 L0.007,12.522 L0.008,20.681 Z M10.959,22.171 L23.923,24 L23.927,12.674 L10.941,12.652 L10.959,22.171 Z"
                }
            }
        ]
    })(props);
}
function GrWordpress(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M0,11.99925 C0,16.749 2.76,20.85375 6.76275,22.7985 L1.03875,7.116 C0.3735,8.60775 0,10.25925 0,11.99925 M20.10015,11.394 C20.10015,9.9105 19.5669,8.88375 19.1109,8.085 C18.50265,7.09575 17.9319,6.25875 17.9319,5.27025 C17.9319,4.167 18.76815,3.14025 19.94715,3.14025 C20.0004,3.14025 20.05065,3.147 20.1024,3.15 C17.9679,1.194 15.12315,0 11.9994,0 C7.8069,0 4.11915,2.151 1.9734,5.40825 C2.2554,5.41725 2.5209,5.4225 2.7459,5.4225 C4.00065,5.4225 5.9439,5.27025 5.9439,5.27025 C6.5904,5.232 6.6669,6.183 6.0204,6.25875 C6.0204,6.25875 5.37015,6.33525 4.64715,6.3735 L9.01665,19.371 L11.64315,11.49525 L9.77415,6.3735 C9.12765,6.33525 8.5149,6.25875 8.5149,6.25875 C7.8684,6.2205 7.94415,5.232 8.5914,5.27025 C8.5914,5.27025 10.5729,5.4225 11.7519,5.4225 C13.00665,5.4225 14.9499,5.27025 14.9499,5.27025 C15.59715,5.232 15.6729,6.183 15.0264,6.25875 C15.0264,6.25875 14.3754,6.33525 13.65315,6.3735 L17.98965,19.272 L19.1874,15.273 C19.7049,13.6125 20.10015,12.42075 20.10015,11.394 M12.21015,13.04895 L8.6094,23.5107 C9.6849,23.8272 10.8219,23.9997 11.9994,23.9997 C13.39665,23.9997 14.7369,23.7582 15.98415,23.31945 C15.95265,23.2677 15.92265,23.2137 15.89865,23.15445 L12.21015,13.04895 Z M22.52925,6.242475 C22.581,6.624975 22.61025,7.034475 22.61025,7.476225 C22.61025,8.693475 22.38225,10.062225 21.6975,11.774475 L18.03225,22.371225 C21.6,20.291475 23.99925,16.425975 23.99925,11.999475 C23.99925,9.912975 23.466,7.951725 22.52925,6.242475"
                }
            }
        ]
    })(props);
}
function GrWorkshop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M19,7 C19,7 14,14 6.5,14 C4.5,14 1,15 1,19 L1,23 L12,23 L12,19 C12,16.5 15,18 19,11 L17.5,9.5 M3,5 L3,2 L23,2 L23,16 L20,16 M11,1 L15,1 L15,3 L11,3 L11,1 Z M6.5,14 C8.43299662,14 10,12.4329966 10,10.5 C10,8.56700338 8.43299662,7 6.5,7 C4.56700338,7 3,8.56700338 3,10.5 C3,12.4329966 4.56700338,14 6.5,14 Z"
                }
            }
        ]
    })(props);
}
function GrX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m.058 1 9.267 12.39L0 23.462h2.099l8.163-8.82 6.596 8.82H24l-9.788-13.087L22.892 1h-2.1l-7.517 8.122L7.2 1H.058Zm3.087 1.546h3.28l14.488 19.37h-3.28L3.145 2.547Z"
                }
            }
        ]
    })(props);
}
function GrXing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "fill": "none",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "clipPath": "url(#a)"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M3.86 4.74c-.209 0-.384.074-.472.217-.092.147-.078.338.02.53l2.34 4.052c.004.008.004.013 0 .02l-3.678 6.49c-.096.19-.091.383 0 .53a.51.51 0 0 0 .453.237h3.461c.517 0 .767-.35.944-.669l3.737-6.608-2.38-4.15c-.172-.306-.433-.649-.963-.649H3.86Z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M18.401 0c-.517 0-.74.326-.927.66 0 0-7.456 13.224-7.702 13.658l4.918 9.023c.172.307.437.659.967.659h3.457c.209 0 .372-.078.46-.221.092-.148.09-.343-.007-.535l-4.88-8.915a.02.02 0 0 1 0-.023L22.351.756c.096-.192.098-.387.007-.535C22.27.08 22.106 0 21.898 0H18.4Z"
                        }
                    }
                ]
            },
            {
                "tag": "defs",
                "attr": {},
                "child": [
                    {
                        "tag": "clipPath",
                        "attr": {
                            "id": "a"
                        },
                        "child": [
                            {
                                "tag": "path",
                                "attr": {
                                    "d": "M0 0h24v24H0z"
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    })(props);
}
function GrYoga(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeLinecap": "round",
                    "strokeLinejoin": "round",
                    "strokeWidth": "2",
                    "d": "M12,11 L11,14 L12,17 L10.5,17 L9,14 L9.5,9.5 L12,11 Z M13,2 L9,6 L9,11 L9,14 L10,17 L6,17 L3,22 M20.5,22 L15.5,18.5 L12,17 L11,14 L12,11 L15.5,13 L15.5,18.5 M14,8.5 C13.4477153,8.5 13,8.05228475 13,7.5 C13,6.94771525 13.4477153,6.5 14,6.5 C14.5522847,6.5 15,6.94771525 15,7.5 C15,8.05228475 14.5522847,8.5 14,8.5 Z M11,10.5 L10,17 L10,13.5 L11,10.5 Z"
                }
            }
        ]
    })(props);
}
function GrYoutube(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M9.522,15.553 L9.52125,8.80975 L16.00575,12.193 L9.522,15.553 Z M23.76,7.64125 C23.76,7.64125 23.52525,5.9875 22.806,5.25925 C21.89325,4.303 20.87025,4.2985 20.4015,4.243 C17.043,4 12.00525,4 12.00525,4 L11.99475,4 C11.99475,4 6.957,4 3.5985,4.243 C3.129,4.2985 2.10675,4.303 1.19325,5.25925 C0.474,5.9875 0.24,7.64125 0.24,7.64125 C0.24,7.64125 0,9.58375 0,11.5255 L0,13.3465 C0,15.289 0.24,17.23075 0.24,17.23075 C0.24,17.23075 0.474,18.8845 1.19325,19.61275 C2.10675,20.569 3.306,20.539 3.84,20.63875 C5.76,20.82325 12,20.88025 12,20.88025 C12,20.88025 17.043,20.87275 20.4015,20.62975 C20.87025,20.5735 21.89325,20.569 22.806,19.61275 C23.52525,18.8845 23.76,17.23075 23.76,17.23075 C23.76,17.23075 24,15.289 24,13.3465 L24,11.5255 C24,9.58375 23.76,7.64125 23.76,7.64125 L23.76,7.64125 Z"
                }
            }
        ]
    })(props);
}
function GrZoomIn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M16,16 L23,23 L16,16 Z M10,18 C14.418278,18 18,14.418278 18,10 C18,5.581722 14.418278,2 10,2 C5.581722,2 2,5.581722 2,10 C2,14.418278 5.581722,18 10,18 Z M10,15 L10,5 M5,10 L15,10"
                }
            }
        ]
    })(props);
}
function GrZoomOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "strokeWidth": "2",
                    "d": "M16,16 L23,23 L16,16 Z M10,18 C14.418278,18 18,14.418278 18,10 C18,5.581722 14.418278,2 10,2 C5.581722,2 2,5.581722 2,10 C2,14.418278 5.581722,18 10,18 Z M5,10 L15,10"
                }
            }
        ]
    })(props);
}
function GrZoom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 8C0 3.58172 3.58172 0 8 0H16C20.4183 0 24 3.58172 24 8V16C24 20.4183 20.4183 24 16 24H8C3.58172 24 0 20.4183 0 16V8Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 9C5 8.44772 5.44772 8 6 8H12C13.6569 8 15 9.34315 15 11V15C15 15.5523 14.5523 16 14 16H8C6.34315 16 5 14.6569 5 13V9Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 11.7515C15.5 11.2671 15.6758 10.7991 15.9948 10.4345L17.6856 8.50226C18.1416 7.98108 19 8.30361 19 8.99613V15.004C19 15.6965 18.1416 16.019 17.6856 15.4978L15.9948 13.5656C15.6758 13.201 15.5 12.733 15.5 12.2486V11.7515Z"
                }
            }
        ]
    })(props);
}

},{"../lib":"hOIFC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7CN5B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_OPTIONS", ()=>(0, _mainGhVJz9TKJs.D));
parcelHelpers.export(exports, "ExpressionAtlasHeatmap", ()=>(0, _mainGhVJz9TKJs.E));
parcelHelpers.export(exports, "ExpressionFactorGrid", ()=>(0, _mainGhVJz9TKJs.a));
parcelHelpers.export(exports, "HEATMAP_CSS", ()=>(0, _mainGhVJz9TKJs.H));
parcelHelpers.export(exports, "STYLE_ELEMENT_ID", ()=>(0, _mainGhVJz9TKJs.S));
parcelHelpers.export(exports, "default", ()=>(0, _mainGhVJz9TKJs.E));
parcelHelpers.export(exports, "ensureStylesInjected", ()=>(0, _mainGhVJz9TKJs.e));
parcelHelpers.export(exports, "render", ()=>(0, _mainGhVJz9TKJs.r));
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _propTypes = require("prop-types");
var _client = require("react-dom/client");
var _mainGhVJz9TKJs = require("./Main-GhVJz9tK.js");

},{"react/jsx-runtime":"gonF6","react":"bmhQu","prop-types":"gLXGb","react-dom/client":"5eZdG","./Main-GhVJz9tK.js":"gGZSH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gGZSH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "D", ()=>ka);
parcelHelpers.export(exports, "E", ()=>mr);
parcelHelpers.export(exports, "H", ()=>ta);
parcelHelpers.export(exports, "S", ()=>Bt);
parcelHelpers.export(exports, "a", ()=>Sa);
parcelHelpers.export(exports, "b", ()=>Es);
parcelHelpers.export(exports, "e", ()=>na);
parcelHelpers.export(exports, "i", ()=>Lo);
parcelHelpers.export(exports, "r", ()=>Za);
parcelHelpers.export(exports, "u", ()=>Kn);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _client = require("react-dom/client");
var _reactBootstrap = require("react-bootstrap");
var _urijs = require("urijs");
var _urijsDefault = parcelHelpers.interopDefault(_urijs);
var _uncontrollable = require("uncontrollable");
var _rangeJs = require("lodash/range.js");
var _rangeJsDefault = parcelHelpers.interopDefault(_rangeJs);
var _downloadjs = require("downloadjs");
var _downloadjsDefault = parcelHelpers.interopDefault(_downloadjs);
var _xorJs = require("lodash/xor.js");
var _xorJsDefault = parcelHelpers.interopDefault(_xorJs);
var _sortByJs = require("lodash/sortBy.js");
var _sortByJsDefault = parcelHelpers.interopDefault(_sortByJs);
var _groupByJs = require("lodash/groupBy.js");
var _groupByJsDefault = parcelHelpers.interopDefault(_groupByJs);
var _server = require("react-dom/server");
var _serverDefault = parcelHelpers.interopDefault(_server);
var _debounceJs = require("lodash/debounce.js");
var _debounceJsDefault = parcelHelpers.interopDefault(_debounceJs);
var _grameneAnatomogram = require("gramene-anatomogram");
var _grameneAnatomogramDefault = parcelHelpers.interopDefault(_grameneAnatomogram);
var _highchartsReactOfficial = require("highcharts-react-official");
var _highchartsReactOfficialDefault = parcelHelpers.interopDefault(_highchartsReactOfficial);
var _highcharts = require("highcharts");
var _highchartsDefault = parcelHelpers.interopDefault(_highcharts);
var _heatmapJs = require("highcharts/modules/heatmap.js");
var _heatmapJsDefault = parcelHelpers.interopDefault(_heatmapJs);
var _highchartsCustomEvents = require("highcharts-custom-events");
var _highchartsCustomEventsDefault = parcelHelpers.interopDefault(_highchartsCustomEvents);
var _lodash = require("lodash");
var _lodashDefault = parcelHelpers.interopDefault(_lodash);
var _color = require("color");
var _colorDefault = parcelHelpers.interopDefault(_color);
const J = (e = "_blank")=>e ? {
        target: e,
        rel: e === "_blank" ? "noopener noreferrer" : void 0
    } : {}, zt = (e, t = "_blank")=>window.open(e, t || "_self", t === "_blank" ? "noopener,noreferrer" : void 0), Ut = "https://www.ebi.ac.uk/support/gxa", se = (e, t)=>t, $r = (e, t, n, s)=>{
    if (typeof e != "function") return n;
    const o = e(t, n, s);
    return o === void 0 ? n : o === null ? null : String(o);
}, me = ({ error: e, variant: t = "danger", linkTarget: n, urlFor: s = se })=>{
    if (t !== "danger") return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Alert), {
        variant: t,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Alert).Heading, {
                as: "h5",
                children: "No results"
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                className: "mb-0",
                children: e.description
            })
        ]
    });
    const o = s("support", Ut, {});
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Alert), {
        variant: t,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Alert).Heading, {
                as: "h5",
                children: "Oops!"
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                children: e.description
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                children: "You may also try reloading the page."
            }),
            o && /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "If the error persists, in order to help us debug the issue, please copy the URL from your browser and the error message below and send it to us via ",
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("a", {
                        ...J(n),
                        href: o,
                        children: "the EBI Support & Feedback system"
                    }),
                    ":"
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("code", {
                className: "small",
                children: `${e.name}: ${e.message}`
            })
        ]
    });
};
me.propTypes = {
    error: (0, _propTypesDefault.default).shape({
        description: (0, _propTypesDefault.default).string.isRequired,
        name: (0, _propTypesDefault.default).string,
        message: (0, _propTypesDefault.default).string
    }).isRequired,
    variant: (0, _propTypesDefault.default).string,
    linkTarget: (0, _propTypesDefault.default).string,
    urlFor: (0, _propTypesDefault.default).func
};
const Wt = ({ experimentUrl: e, description: t, linkTarget: n })=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        style: {
            marginBottom: "1rem",
            clear: "both",
            width: "100%"
        },
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
            children: e ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("a", {
                ...J(n),
                href: e,
                style: {
                    textDecoration: "none"
                },
                children: t
            }) : t
        })
    });
Wt.propTypes = {
    experimentUrl: (0, _propTypesDefault.default).string,
    description: (0, _propTypesDefault.default).string.isRequired,
    linkTarget: (0, _propTypesDefault.default).string
};
const Kt = (e)=>{
    const t = (n, s)=>n ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("a", {
            ...J(e.linkTarget),
            href: n,
            style: {
                textDecoration: "none"
            },
            children: s
        }) : s;
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        style: {
            marginBottom: "2rem",
            clear: "both",
            width: "100%"
        },
        children: [
            "This page is a summary of the data held in ",
            t(e.atlasUrl, "Expression Atlas"),
            " for this gene",
            e.moreInformationUrl ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    "; click ",
                    t(e.moreInformationUrl, "here"),
                    " for the full record."
                ]
            }) : ".",
            e.supportUrl && /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("br", {}),
                    "Please send any queries or feedback via ",
                    t(e.supportUrl, "the EBI Support & feedback form"),
                    "."
                ]
            })
        ]
    });
};
Kt.propTypes = {
    atlasUrl: (0, _propTypesDefault.default).string,
    moreInformationUrl: (0, _propTypesDefault.default).string,
    supportUrl: (0, _propTypesDefault.default).string,
    linkTarget: (0, _propTypesDefault.default).string
};
const ge = "evenodd", P = (e, t)=>{
    const n = ({ className: s, style: o, ...a })=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "1em",
            height: "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-hidden": "true",
            focusable: "false",
            className: [
                "gxa-icon",
                `gxa-icon-${e}`,
                s
            ].filter(Boolean).join(" "),
            style: {
                verticalAlign: "-0.125em",
                ...o
            },
            ...a,
            children: t.map(([i, c], d)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("path", {
                    d: i,
                    fillRule: c
                }, d))
        });
    return n.displayName = `Icon(${e})`, n.propTypes = {
        className: (0, _propTypesDefault.default).string,
        style: (0, _propTypesDefault.default).object
    }, n;
}, _r = P("eye", [
    [
        "M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"
    ],
    [
        "M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"
    ]
]), Dr = P("eye-slash", [
    [
        "M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z"
    ],
    [
        "M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829"
    ],
    [
        "M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z"
    ]
]), Vr = P("sort-alpha-down", [
    [
        "M10.082 5.629 9.664 7H8.598l1.789-5.332h1.234L13.402 7h-1.12l-.419-1.371zm1.57-.785L11 2.687h-.047l-.652 2.157z",
        ge
    ],
    [
        "M12.96 14H9.028v-.691l2.579-3.72v-.054H9.098v-.867h3.785v.691l-2.567 3.72v.054h2.645zM4.5 2.5a.5.5 0 0 0-1 0v9.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L4.5 12.293z"
    ]
]), jr = P("sort-down", [
    [
        "M3.5 2.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 11.293zm3.5 1a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"
    ]
]), Rt = P("sort-numeric-down", [
    [
        "M12.438 1.668V7H11.39V2.684h-.051l-1.211.859v-.969l1.262-.906h1.046z"
    ],
    [
        "M11.36 14.098c-1.137 0-1.708-.657-1.762-1.278h1.004c.058.223.343.45.773.45.824 0 1.164-.829 1.133-1.856h-.059c-.148.39-.57.742-1.261.742-.91 0-1.72-.613-1.72-1.758 0-1.148.848-1.835 1.973-1.835 1.09 0 2.063.636 2.063 2.687 0 1.867-.723 2.848-2.145 2.848zm.062-2.735c.504 0 .933-.336.933-.972 0-.633-.398-1.008-.94-1.008-.52 0-.927.375-.927 1 0 .64.418.98.934.98",
        ge
    ],
    [
        "M4.5 2.5a.5.5 0 0 0-1 0v9.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L4.5 12.293z"
    ]
]), Qt = P("download", [
    [
        "M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"
    ],
    [
        "M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z"
    ]
]), Gr = P("sliders", [
    [
        "M11.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9.05 3a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0V3zM4.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M2.05 8a2.5 2.5 0 0 1 4.9 0H16v1H6.95a2.5 2.5 0 0 1-4.9 0H0V8zm9.45 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-2.45 1a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0v-1z",
        ge
    ]
]), zr = P("chevron-up", [
    [
        "M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z",
        ge
    ]
]), Ur = P("chevron-down", [
    [
        "M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708",
        ge
    ]
]), Wr = P("grid-3x3-gap", [
    [
        "M4 2v2H2V2zm1 12v-2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1m0-5V7a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1m0-5V2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1m5 10v-2a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1m0-5V7a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1m0-5V2a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1M9 2v2H7V2zm5 0v2h-2V2zM4 7v2H2V7zm5 0v2H7V7zm5 0h-2v2h2zM4 12v2H2v-2zm5 0v2H7v-2zm5 0v2h-2v-2zM12 1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zm-1 6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zm1 4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1z"
    ]
]), Kr = P("info-circle", [
    [
        "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
    ],
    [
        "m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
    ]
]), Qr = {
    textTransform: "unset",
    letterSpacing: "unset",
    height: "unset"
}, Xr = (e)=>e === "none" ? Dr : _r, Xt = ({ genomeBrowsers: e, selected: t, onSelect: n })=>{
    const s = e.map((i)=>({
            id: i.replace(/\s+/g, "").toLowerCase(),
            label: `${i} genome browser`
        })), o = s.find((i)=>t === i.id), a = Xr(t);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        title: "Choose genome browser",
        children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Dropdown), {
            onSelect: (i)=>n && n(i),
            children: [
                /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Dropdown).Toggle, {
                    size: "sm",
                    variant: "outline-secondary",
                    style: Qr,
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)(a, {}),
                        "\xa0",
                        o ? o.label : "Choose genome browser"
                    ]
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Dropdown).Menu, {
                    children: s.map((i)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Dropdown).Item, {
                            as: "button",
                            type: "button",
                            eventKey: i.id,
                            active: i.id === t,
                            children: i.label
                        }, i.id))
                })
            ]
        })
    });
};
Xt.propTypes = {
    genomeBrowsers: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string).isRequired,
    selected: (0, _propTypesDefault.default).string,
    onSelect: (0, _propTypesDefault.default).func
};
const Jr = {
    textTransform: "unset",
    letterSpacing: "unset",
    height: "unset"
}, Zr = (e)=>{
    switch(e){
        case "Alphabetical order":
            return Vr;
        case "Expression rank":
            return jr;
        case "By experiment type":
            return Rt;
        default:
            return Rt;
    }
}, Jt = ({ allOptions: e, currentOption: t, onChangeCurrentOption: n, title: s, disabled: o })=>{
    const a = Zr(t);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        title: s || void 0,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Dropdown), {
            onSelect: (i)=>n(i),
            children: [
                /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Dropdown).Toggle, {
                    size: "sm",
                    variant: "outline-secondary",
                    disabled: o,
                    style: Jr,
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)(a, {}),
                        " ",
                        t
                    ]
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Dropdown).Menu, {
                    children: e.map((i)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Dropdown).Item, {
                            as: "button",
                            type: "button",
                            eventKey: i,
                            active: i === t,
                            children: i
                        }, i))
                })
            ]
        })
    });
};
Jt.propTypes = {
    allOptions: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string).isRequired,
    currentOption: (0, _propTypesDefault.default).string.isRequired,
    onChangeCurrentOption: (0, _propTypesDefault.default).func.isRequired,
    title: (0, _propTypesDefault.default).string.isRequired,
    disabled: (0, _propTypesDefault.default).bool.isRequired
};
const Yr = ({ linkTarget: e })=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("h3", {
                children: "The Blueprint Project Data Reuse Statement"
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                children: "This document refers to the reuse of data generated by the EC funded FP7 High Impact Project, Blueprint."
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                children: "Blueprint regularly released analysis results via its ftp site and makes the raw sequence data available through the sequence archives at the EMBL-EBI. Much Blueprint data is generated from samples whose data must be released through a managed access process. For these data sets external users must apply for permission to access the data from the European Genome-phenome Archive (EGA) through the Blueprint Data Access Committee."
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                children: "The Blueprint consortium expects this data to be valuable to other researchers and in keeping with Fort Lauderdale principles data users may use the data for many studies, but are expected to allow the data producers to make the first presentations and to publish the first paper with global analyses of the data."
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("h4", {
                children: "Global analyses of Project data"
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                children: "Blueprint plans to publish global analyses of the sequencing data, epigenetic marks, expression levels and variation both in the context of normal hematopoietic cells and of those neoplastic and non-neoplastic diseases studied within the consortium. Talks, posters, and papers on all such analyses are to be published first by the Blueprint project, by approved presenters on behalf of the Project, with the Project as author. When the first major Project paper on these analyses is published, then researchers inside and outside the Project are free to present and publish using the Project data for these and other analyses."
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("h4", {
                children: "Large-scale analyses of Project data"
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                children: "Groups within the Project may make presentations and publish papers on more extensive analyses of topics to be included in the main analysis presentations and papers, coincident with the main project analysis presentations and papers. The major points would be included in the main Project presentations and papers, but these additional presentations and papers allow more focused discussion of methods and results. The author list would include the Consortium."
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("h4", {
                children: "Methods development using Project data"
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                children: "Researchers who have used small amounts of Project data (&lt= one chromosome) may present methods development posters, talks, and papers that include these data prior to the first major Project paper, without needing Project approval or authorship, although the Project should be acknowledged. Methods presentations or papers on global analyses or analyses using large amounts of Project data, on topics that the Consortium plans to examine, would be similar to large-scale analyses of Project data: researchers within the Project may make presentations or submit papers at the same time as the main Project presentations and papers, and others could do so after the Project publishes the first major analysis paper."
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("h4", {
                children: "Disease studies using Project data"
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                children: "Researchers may present and publish on use of Project data in specific chromosome regions (that are not of general interest) or as summaries (such as number of differentially expressed genes in cell types assayed by Blueprint) for studies on diseases not studied by BLUEPRINT without Project approval, prior to the first major Project paper being published. The Project should not be listed as an author."
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("h4", {
                children: "Authors who use data from the project must acknowledge Blueprint using the following wording"
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "This study makes use of data generated by the Blueprint Consortium. A full list of the investigators who contributed to the generation of the data is available from ",
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("a", {
                        ...J(e),
                        href: "http://www.blueprint-epigenome.eu",
                        children: "www.blueprint-epigenome.eu"
                    }),
                    ". Funding for the project was provided by the European Union's Seventh Framework Programme (FP7/2007-2013) under grant agreement no 282510 \u2013 BLUEPRINT."
                ]
            })
        ]
    }), es = ({ linkTarget: e })=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("h3", {
                children: "Fort Lauderdale Data Reuse Statement"
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "This is a pre-publication release in accordance with ",
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("a", {
                        ...J(e),
                        href: "http://www.sanger.ac.uk/datasharing/",
                        children: "the Fort Lauderdale Agreement"
                    }),
                    ". Feel free to search and download data on your genes of interest."
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                children: "Equally, you can use the dataset to show developmental expression profiles for specific genes in your publications."
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                children: "However, we ask that you refrain from publishing larger scale or genome-wide analyses of this dataset for 12 months from the time of deposition in Expression Atlas or until we have published our transcriptional time-course paper, whichever comes first."
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "For citations in publications before the paper is out please use this link to the Expression Atlas site (",
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("a", {
                        ...J(e),
                        href: "https://www.ebi.ac.uk/gxa/experiments/E-ERAD-475",
                        children: "http://www.ebi.ac.uk/gxa/experiments/E-ERAD-475"
                    }),
                    ") and acknowledge us: \u201CWe would like to thank the Busch-Nentwich lab for providing RNA-seq data.\u201D"
                ]
            })
        ]
    }), ts = ()=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("h3", {
                children: "PCAWG Publication and Embargo Policy"
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                children: 'The PanCancer Analysis of Whole Genomes (PCAWG) project is committed to the principle of rapid distribution of primary data, alignments files, and secondary analysis data (such as mutation calls) to all members of the research community that have applied for (and have become approved for) data access. The primary data contributed to the project will fall under any publication/embargo policy of the contributing institute or consortia. The community resource for the PCAWG project comprises newly generated files produced by this collaboration (unified alignments, mutation calls and any secondary analysis data). As is the case for similar "community resource projects", users of data generated and distributed by the PCAWG project are asked to respect the desire of the PCAWG Consortium to publish reports on the generation and analysis of their data. Hence, scientific works with a primary focus on pan-cancer (across entity) analysis that made use of the WGS pan cancer community resource will be under publication embargo until the WGS pan-cancer consortium publishes its main paper (anticipated end of 2017). Methodology papers may be published prior to this embargo, with agreement from the full scientific working group.'
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "Please write to ",
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("a", {
                        href: "mailto:jennifer.jennings@oicr.on.ca",
                        children: "Jennifer Jennings <jennifer.jennings@oicr.on.ca>"
                    }),
                    " for further information."
                ]
            })
        ]
    }), Zt = {
    blueprint: Yr,
    lauderdale: es,
    pcawg: ts
}, de = Object.freeze({
    tsv: Object.freeze({
        label: "Tab-delimited text (.tsv)",
        extension: ".tsv",
        mimeType: "text/tab-separated-values"
    }),
    json: Object.freeze({
        label: "JSON (.json)",
        extension: ".json",
        mimeType: "application/json"
    })
}), Oe = "tsv", qt = "expression-data", ns = /[/\\:*?"<>|\p{Cc}\p{Cf}\p{Cs}\p{Noncharacter_Code_Point}]/gu, rs = /^(?:con|prn|aux|nul|com[1-9]|lpt[1-9]|clock\$)(?:\.|$)/i, ss = 200, os = (e)=>e < 128 ? 1 : e < 2048 ? 2 : e < 65536 ? 3 : 4, is = (e)=>{
    let t = 0, n = 0;
    for (const s of e){
        if (t += os(s.codePointAt(0)), t > ss) return e.slice(0, n);
        n += s.length;
    }
    return e;
}, ze = (e, t = qt)=>{
    const n = (o)=>o.trim().replace(/^[.~\s]+/, "").replace(/[.\s]+$/, ""), s = (o)=>{
        const a = n(is(n(String(o ?? "").replace(ns, "").replace(/\s+/g, " "))));
        return rs.test(a) ? `_${a}` : a;
    };
    return s(e) || s(t) || qt;
}, as = (e, t)=>{
    const { extension: n } = de[t] || de[Oe];
    return e.toLowerCase().endsWith(n) ? e : `${e}${n}`;
}, ls = (e, t, n)=>as(ze(e, n), t), cs = (e, t, n)=>{
    const { mimeType: s } = de[n] || de[Oe];
    (0, _downloadjsDefault.default)(new Blob([
        e
    ], {
        type: `${s};charset=utf-8`
    }), t, s);
}, Yt = (e)=>e == null ? "" : String(e).replace(/[\t\r\n]+/g, " "), ds = (e)=>e.map((t)=>`${t.map(Yt).join("	")}
`).join(""), en = (e)=>`${JSON.stringify(e, null, 2)}
`, tn = ()=>({
        downloadedFrom: typeof window < "u" && window.location ? window.location.href : "",
        downloadedAt: /* @__PURE__ */ new Date().toISOString()
    }), Se = (e, t, n = `${t}s`)=>`${e} ${e === 1 ? t : n}`, us = (e, t)=>{
    const n = (0, _rangeJsDefault.default)(e.yAxisCategories.length).map(()=>(0, _rangeJsDefault.default)(e.xAxisCategories.length).map(()=>t));
    return e.dataSeries.forEach((s)=>{
        s.data.forEach((o)=>{
            n[o.y][o.x] = o.value;
        });
    }), [
        [
            ""
        ].concat(e.xAxisCategories.map((s)=>s.label))
    ].concat(e.yAxisCategories.map((s, o)=>[].concat.apply([
            s.label
        ], n[o]))).map((s)=>s.map(Yt).join("	"));
}, tt = (e, t)=>{
    const n = e.xAxisCategories.length;
    if (!t || n === 0) return e;
    const s = Math.max(0, Math.min(n - 1, t.from)), o = Math.max(s, Math.min(n - 1, t.to));
    return s === 0 && o === n - 1 ? e : {
        ...e,
        xAxisCategories: e.xAxisCategories.slice(s, o + 1),
        dataSeries: e.dataSeries.map((a)=>({
                ...a,
                data: a.data.filter((i)=>i.x >= s && i.x <= o).map((i)=>({
                        ...i,
                        x: i.x - s
                    }))
            }))
    };
}, nn = (e, t)=>{
    const n = tt(e, t);
    if (n === e) return null;
    const s = Math.max(0, t.from) + 1;
    return {
        from: s,
        to: s + n.xAxisCategories.length - 1,
        of: e.xAxisCategories.length
    };
}, ps = (e)=>{
    const t = e.yAxisCategories.map(()=>e.xAxisCategories.map(()=>null));
    return e.dataSeries.forEach((n)=>n.data.forEach((s)=>{
            t[s.y] && s.x >= 0 && s.x < t[s.y].length && (t[s.y][s.x] = s);
        })), t;
}, At = (e)=>typeof e == "number" && Number.isFinite(e) ? e : null, ms = (e)=>{
    const t = e.find((n)=>n && n.info && n.info.unit);
    return t ? t.info.unit : null;
}, gs = (e)=>{
    const t = [
        ...new Set(e.map((n)=>n.unit).filter(Boolean))
    ];
    return t.length === 1 ? t[0] : null;
}, rn = (e, { range: t, isDifferential: n = !1 } = {})=>{
    const s = tt(e, t), o = ps(s), a = s.xAxisCategories.map((c)=>{
        const d = c.info && c.info.trackId;
        return {
            label: c.label,
            id: c.id || null,
            ...d && d !== c.id ? {
                assayGroupId: d
            } : {}
        };
    }), i = s.yAxisCategories.map((c, d)=>({
            label: c.label,
            id: c.id || null,
            unit: ms(o[d]),
            values: o[d].map((m)=>m ? At(m.value) : null),
            ...n ? {
                pValues: o[d].map((m)=>m && m.info ? At(m.info.pValue) : null)
            } : {}
        }));
    return {
        columns: a,
        rows: i,
        unit: gs(i),
        zoom: nn(e, t)
    };
}, sn = "Expression Atlas", Tt = (e, t)=>{
    try {
        return new URL(e, t || void 0).hostname.toLowerCase() || null;
    } catch  {
        return null;
    }
}, St = (e, t)=>{
    const n = e ? Tt(e, t) : null;
    return !n || n === "ebi.ac.uk" || n.endsWith(".ebi.ac.uk") || n === Tt(t) ? sn : n;
}, hs = (e)=>e.urls ? e.urls.main_page || e.urls.download : null, fs = (e)=>e.info ? e.info.uri || e.info.url : null, xs = (e, { experiment: t, atlasUrl: n })=>{
    if (t) return {
        source: St(hs(t), n),
        rows: null
    };
    const s = e.yAxisCategories.map((a)=>St(fs(a), n)), o = [
        ...new Set(s)
    ];
    return {
        source: o.length === 0 ? sn : o.length === 1 ? o[0] : null,
        rows: s
    };
}, ys = ({ heatmapData: e, range: t, descriptionLines: n = [], isSingleExperiment: s, downloadedFrom: o, downloadedAt: a })=>{
    const { unit: i, zoom: c } = rn(e, {
        range: t
    });
    return [
        `# Downloaded from: ${o}`,
        `# Timestamp: ${a}`,
        ...n.map((d)=>`# ${d}`),
        ...i ? [
            `# Unit: ${i}`
        ] : [],
        ...c ? [
            `# Zoomed in: columns ${c.from} to ${c.to} of ${c.of}`
        ] : [],
        ...us(tt(e, t), s ? "" : "NA")
    ].map((d)=>`${d.replace(/[\r\n]+/g, " ")}
`).join("");
}, bs = ({ heatmapData: e, range: t, experiment: n, query: s, atlasUrl: o, isDifferential: a, downloadedFrom: i, downloadedAt: c })=>{
    const { columns: d, rows: m, unit: u, zoom: p } = rn(e, {
        range: t,
        isDifferential: a
    }), h = xs(e, {
        experiment: n,
        atlasUrl: o
    });
    return en({
        source: h.source,
        atlasUrl: o || null,
        experiment: n ? {
            accession: n.accession,
            description: n.description || null,
            type: n.type || null
        } : null,
        query: s || null,
        unit: u,
        zoom: p,
        columns: d,
        rows: h.rows ? m.map(({ label: x, id: f, ...y }, R)=>({
                label: x,
                id: f,
                source: h.rows[R],
                ...y
            })) : m,
        downloadedFrom: i,
        downloadedAt: c
    });
}, on = (e)=>e.yAxisCategories.length === 0 || e.xAxisCategories.length === 0, Cs = (e, t)=>{
    if (on(e)) return "Nothing to download: the heatmap shows no data.";
    const n = nn(e, t), s = Se(e.yAxisCategories.length, "row");
    return n ? `${s} \xd7 ${n.to - n.from + 1} of ${Se(n.of, "column")} (zoomed in), as shown` : `${s} \xd7 ${Se(e.xAxisCategories.length, "column")}, as shown`;
}, ws = (e)=>typeof e == "string" ? e.split(/\s+/).filter(Boolean) : Array.isArray(e) ? e.map((t)=>t && typeof t == "object" ? t.value : t).filter(Boolean).map(String) : [], vs = (e)=>{
    const { geneQuery: t, conditionQuery: n, ...s } = e && e.params || {};
    return {
        genes: ws(t),
        ...n ? {
            condition: n
        } : {},
        ...s
    };
}, Rs = ({ experiment: e, genes: t = [] })=>[
        "expression",
        e && e.accession ? e.accession : "studies",
        t[0]
    ].filter(Boolean).join("-"), qs = (e, t)=>e.map((n)=>{
        const s = n.replace(/, in conditions \[\]/, "");
        return t.length ? s.replace(/^(Gene query: |Query results for: )\[(?:null,?)*\]/, (o, a)=>`${a}${t.join(" ")}`) : s;
    }), As = {
    textTransform: "unset",
    letterSpacing: "unset",
    height: "unset"
}, an = ({ show: e, onHide: t, defaultFileName: n, summary: s, nothingToSave: o = !1, buildContent: a, disclaimer: i, fullDatasetUrl: c, linkTarget: d, returnFocusRef: m, onDownload: u })=>{
    const p = (0, _react.useId)(), h = (0, _react.useRef)(null), [x, f] = (0, _react.useState)(()=>ze(n)), [y, R] = (0, _react.useState)(Oe), [S, k] = (0, _react.useState)(!1), [b, v] = (0, _react.useState)(e);
    e !== b && (v(e), e && (f(ze(n)), R(Oe), k(!1)));
    const N = (0, _react.useRef)(!1);
    (0, _react.useEffect)(()=>{
        e && (N.current = !1);
    }, [
        e
    ]);
    const D = (A)=>!e || N.current ? !1 : (N.current = !0, A(), !0), q = !!i && !S, G = e && !o && x.trim() !== "" && !q, z = ls(x, y, n), ee = (A)=>{
        A.preventDefault(), G && D(()=>cs(a(y), z, y)) && (t(), u && u({
            fileName: z,
            format: y
        }));
    }, ie = ()=>{
        D(()=>zt(c, d)) && t();
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Modal), {
        show: e,
        onHide: t,
        onShow: ()=>{
            const A = h.current;
            A && (A.focus(), A.select());
        },
        onExited: ()=>{
            const A = m && m.current;
            A && typeof A.focus == "function" && A.focus();
        },
        restoreFocus: !m,
        size: i ? "lg" : void 0,
        "aria-labelledby": `${p}-title`,
        "aria-describedby": `${p}-summary`,
        className: "gxa-heatmap-modal gxa-download-modal",
        children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Form), {
            noValidate: !0,
            onSubmit: ee,
            children: [
                /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Modal).Header, {
                    closeButton: !0,
                    children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Modal).Title, {
                        id: `${p}-title`,
                        children: "Download"
                    })
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Modal).Body, {
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                            id: `${p}-summary`,
                            className: "gxa-download-summary",
                            children: s
                        }),
                        !o && /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Form).Group, {
                                    controlId: `${p}-name`,
                                    className: "mb-3",
                                    children: [
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Form).Label, {
                                            children: "File name"
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Form).Control, {
                                            ref: h,
                                            type: "text",
                                            value: x,
                                            onChange: (A)=>f(A.target.value),
                                            autoComplete: "off",
                                            spellCheck: !1,
                                            "aria-describedby": `${p}-saved-as`
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Form).Text, {
                                            id: `${p}-saved-as`,
                                            className: "gxa-download-saved-as",
                                            "aria-live": "polite",
                                            children: x.trim() === "" ? "Enter a file name." : /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                children: [
                                                    "Saved as ",
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("code", {
                                                        children: z
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("fieldset", {
                                    className: "mb-3",
                                    children: [
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("legend", {
                                            className: "form-label fs-6 mb-2",
                                            children: "Format"
                                        }),
                                        Object.entries(de).map(([A, { label: te }])=>/* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Form).Check, {
                                                type: "radio",
                                                id: `${p}-format-${A}`,
                                                name: `${p}-format`,
                                                value: A,
                                                label: te,
                                                checked: y === A,
                                                onChange: ()=>R(A)
                                            }, A))
                                    ]
                                })
                            ]
                        }),
                        i && /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                            className: "mb-3",
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                                    className: "gxa-download-disclaimer",
                                    role: "region",
                                    "aria-label": "Data reuse statement",
                                    tabIndex: 0,
                                    children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(i, {
                                        linkTarget: d
                                    })
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Form).Check, {
                                    type: "checkbox",
                                    id: `${p}-accept`,
                                    className: "mt-2",
                                    label: "I agree to the data reuse statement above",
                                    checked: S,
                                    onChange: (A)=>k(A.target.checked)
                                })
                            ]
                        }),
                        c && /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                            className: "gxa-download-full mb-0",
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Button), {
                                    variant: "link",
                                    size: "sm",
                                    className: "p-0 align-baseline",
                                    disabled: !e || q,
                                    onClick: ie,
                                    children: "Full experiment data on Expression Atlas"
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                    className: "form-text",
                                    children: " (every gene of the experiment, not only what is shown)"
                                })
                            ]
                        })
                    ]
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Modal).Footer, {
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Button), {
                            variant: "secondary",
                            onClick: t,
                            children: "Cancel"
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Button), {
                            variant: "primary",
                            type: "submit",
                            disabled: !G,
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)(Qt, {}),
                                " Download"
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
an.propTypes = {
    show: (0, _propTypesDefault.default).bool.isRequired,
    onHide: (0, _propTypesDefault.default).func.isRequired,
    defaultFileName: (0, _propTypesDefault.default).string,
    summary: (0, _propTypesDefault.default).node,
    // There is nothing to save (the widget shows no data): the summary says so, and Download is disabled
    nothingToSave: (0, _propTypesDefault.default).bool,
    buildContent: (0, _propTypesDefault.default).func.isRequired,
    disclaimer: (0, _propTypesDefault.default).elementType,
    fullDatasetUrl: (0, _propTypesDefault.default).string,
    linkTarget: (0, _propTypesDefault.default).string,
    returnFocusRef: (0, _propTypesDefault.default).shape({
        current: (0, _propTypesDefault.default).any
    }),
    onDownload: (0, _propTypesDefault.default).func
};
const nt = ({ className: e, ...t })=>{
    const [n, s] = (0, _react.useState)(!1), o = (0, _react.useRef)(null);
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Button), {
                ref: o,
                size: "sm",
                variant: "outline-secondary",
                className: e,
                "aria-haspopup": "dialog",
                onClick: ()=>s(!0),
                style: As,
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(Qt, {}),
                    " Download"
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(an, {
                ...t,
                show: n,
                onHide: ()=>s(!1),
                returnFocusRef: o
            })
        ]
    });
};
nt.propTypes = {
    className: (0, _propTypesDefault.default).string
};
const ln = (0, _propTypesDefault.default).shape({
    accession: (0, _propTypesDefault.default).string.isRequired,
    // Is it worth to enumerate the experiment types?
    type: (0, _propTypesDefault.default).string.isRequired,
    description: (0, _propTypesDefault.default).string.isRequired,
    species: (0, _propTypesDefault.default).string.isRequired
}), _ = (e)=>!e, Fe = (e)=>!_(e) && e.type.toUpperCase().endsWith("DIFFERENTIAL"), rt = (e)=>!_(e) && e.type.toUpperCase().includes("BASELINE"), Ts = (0, _propTypesDefault.default).shape({
    contrastDescription: (0, _propTypesDefault.default).string.isRequired,
    experimentDescription: (0, _propTypesDefault.default).string.isRequired,
    properties: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        contrastPropertyType: (0, _propTypesDefault.default).oneOf([
            "FACTOR",
            "SAMPLE"
        ]),
        propertyName: (0, _propTypesDefault.default).string.isRequired,
        referenceValue: (0, _propTypesDefault.default).string.isRequired,
        testValue: (0, _propTypesDefault.default).string.isRequired
    })).isRequired,
    referenceReplicates: (0, _propTypesDefault.default).number.isRequired,
    resources: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        icon: (0, _propTypesDefault.default).string.isRequired,
        type: (0, _propTypesDefault.default).string.isRequired,
        url: (0, _propTypesDefault.default).string.isRequired
    })).isRequired,
    testReplicates: (0, _propTypesDefault.default).number.isRequired
}), Ss = (0, _propTypesDefault.default).shape({
    properties: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        contrastPropertyType: (0, _propTypesDefault.default).oneOf([
            "FACTOR",
            "SAMPLE"
        ]),
        propertyName: (0, _propTypesDefault.default).string.isRequired,
        testValue: (0, _propTypesDefault.default).string.isRequired
    })).isRequired,
    replicates: (0, _propTypesDefault.default).number.isRequired
}), ks = (0, _propTypesDefault.default).shape({}), Ne = (e, t, n)=>{
    const s = e[t], o = (a)=>[].concat(a).sort((i, c)=>i - c).map((i, c)=>i === c).reduce((i, c)=>i && c);
    if (!s.name) return new Error(`Ordering with no name in '${n}'`);
    if (!o(s.columns)) return new Error(`Column ordering invalid: '${s.name}' in '${n}'`);
    if (!o(s.rows)) return new Error(`Row ordering invalid: '${s.name}' in '${n}'`);
}, cn = (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
    data: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        info: (0, _propTypesDefault.default).shape({
            unit: (0, _propTypesDefault.default).string.isRequired,
            foldChange: (0, _propTypesDefault.default).number,
            // These three only in diff experiments
            pValue: (0, _propTypesDefault.default).number,
            tStat: (0, _propTypesDefault.default).number
        }).isRequired,
        value: (0, _propTypesDefault.default).number.isRequired,
        x: (0, _propTypesDefault.default).number.isRequired,
        y: (0, _propTypesDefault.default).number.isRequired
    })).isRequired,
    info: (0, _propTypesDefault.default).shape({
        colour: (0, _propTypesDefault.default).string.isRequired,
        name: (0, _propTypesDefault.default).string.isRequired
    }).isRequired
})), Os = (0, _propTypesDefault.default).shape({
    memberName: (0, _propTypesDefault.default).string.isRequired,
    name: (0, _propTypesDefault.default).string.isRequired,
    values: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        id: (0, _propTypesDefault.default).string.isRequired,
        label: (0, _propTypesDefault.default).string.isRequired
    })).isRequired
}), Z = (0, _propTypesDefault.default).shape({
    value: (0, _propTypesDefault.default).string.isRequired,
    categories: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string.isRequired).isRequired,
    groupings: (0, _propTypesDefault.default).arrayOf(Os).isRequired
}), Ee = (0, _propTypesDefault.default).shape({
    name: (0, _propTypesDefault.default).string.isRequired,
    disabled: (0, _propTypesDefault.default).bool.isRequired
}), Ns = (0, _propTypesDefault.default).shape({
    groupingNames: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string.isRequired).isRequired,
    categories: (0, _propTypesDefault.default).arrayOf(Ee).isRequired,
    data: (0, _propTypesDefault.default).arrayOf(Z.isRequired).isRequired
}), oe = (0, _propTypesDefault.default).shape({
    dataSeries: cn.isRequired,
    xAxisCategories: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        id: (0, _propTypesDefault.default).string.isRequired,
        info: (0, _propTypesDefault.default).shape({
            tooltip: (0, _propTypesDefault.default).oneOfType([
                Ts,
                Ss,
                ks
            ]).isRequired,
            trackId: (0, _propTypesDefault.default).string.isRequired
        }).isRequired,
        label: (0, _propTypesDefault.default).string.isRequired
    })).isRequired,
    yAxisCategories: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        id: (0, _propTypesDefault.default).string.isRequired,
        info: (0, _propTypesDefault.default).shape({
            designElement: (0, _propTypesDefault.default).string.isRequired,
            trackId: (0, _propTypesDefault.default).string.isRequired
        }).isRequired,
        label: (0, _propTypesDefault.default).string.isRequired
    })).isRequired
}), Es = {
    boxplotSeries: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        x: (0, _propTypesDefault.default).number,
        low: (0, _propTypesDefault.default).number,
        q1: (0, _propTypesDefault.default).number,
        median: (0, _propTypesDefault.default).number,
        q3: (0, _propTypesDefault.default).number,
        high: (0, _propTypesDefault.default).number
    })).isRequired,
    loosePointsSeries: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        x: (0, _propTypesDefault.default).number,
        y: (0, _propTypesDefault.default).number
    })).isRequired,
    xAxisCategories: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string).isRequired,
    unit: (0, _propTypesDefault.default).string.isRequired
}, Is = (0, _propTypesDefault.default).shape(Es), he = (0, _propTypesDefault.default).shape({
    inProxy: (0, _propTypesDefault.default).string.isRequired,
    outProxy: (0, _propTypesDefault.default).string.isRequired,
    atlasUrl: (0, _propTypesDefault.default).string.isRequired,
    linkTarget: (0, _propTypesDefault.default).string,
    urlFor: (0, _propTypesDefault.default).func,
    description: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string).isRequired,
    genomeBrowsers: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string).isRequired,
    introductoryMessage: (0, _propTypesDefault.default).string.isRequired,
    shortDescription: (0, _propTypesDefault.default).string.isRequired,
    xAxisLegendName: (0, _propTypesDefault.default).string.isRequired,
    yAxisLegendName: (0, _propTypesDefault.default).string.isRequired,
    experiment: ln,
    showControlMenu: (0, _propTypesDefault.default).bool.isRequired,
    disclaimer: (0, _propTypesDefault.default).string.isRequired,
    coexpressionsAvailable: (0, _propTypesDefault.default).bool.isRequired,
    isMultiExperiment: (0, _propTypesDefault.default).bool.isRequired,
    isBaseline: (0, _propTypesDefault.default).bool.isRequired,
    isDifferential: (0, _propTypesDefault.default).bool.isRequired
});
(0, _propTypesDefault.default).shape({
    name: (0, _propTypesDefault.default).string.isRequired,
    values: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        name: (0, _propTypesDefault.default).string.isRequired,
        disabled: (0, _propTypesDefault.default).bool.isRequired
    })).isRequired,
    valueGroupings: (0, _propTypesDefault.default).array
});
const fe = (0, _propTypesDefault.default).shape({
    unit: (0, _propTypesDefault.default).string.isRequired,
    dataClasses: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        color: (0, _propTypesDefault.default).string.isRequired,
        from: (0, _propTypesDefault.default).number.isRequired,
        to: (0, _propTypesDefault.default).number.isRequired
    })).isRequired
}), Ls = (0, _propTypesDefault.default).shape({
    heatmapConfig: he.isRequired,
    colourAxis: fe,
    orderings: (0, _propTypesDefault.default).arrayOf(Ne),
    heatmapData: oe.isRequired,
    boxplotData: Is,
    columnGroups: (0, _propTypesDefault.default).object.isRequired
}), dn = ({ currentlyShownContent: { heatmapData: e, descriptionLines: t, visibleColumns: n = null }, experiment: s = null, query: o = null, atlasUrl: a = "", isDifferential: i = !1, defaultFileName: c, fullDatasetUrl: d, disclaimer: m, linkTarget: u, isSingleExperiment: p = !!s })=>{
    const h = (x)=>{
        const f = tn();
        return x === "json" ? bs({
            heatmapData: e,
            range: n,
            experiment: s,
            query: o,
            atlasUrl: a,
            isDifferential: i,
            ...f
        }) : ys({
            heatmapData: e,
            range: n,
            descriptionLines: t,
            isSingleExperiment: p,
            ...f
        });
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(nt, {
        defaultFileName: c || Rs({
            experiment: s,
            genes: o ? o.genes : []
        }),
        summary: Cs(e, n),
        nothingToSave: on(e),
        buildContent: h,
        disclaimer: Zt[m],
        fullDatasetUrl: d || void 0,
        linkTarget: u
    });
};
dn.propTypes = {
    currentlyShownContent: (0, _propTypesDefault.default).shape({
        descriptionLines: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string).isRequired,
        heatmapData: oe,
        // The columns in view when zoomed in: indexes of heatmapData.xAxisCategories, both included
        visibleColumns: (0, _propTypesDefault.default).shape({
            from: (0, _propTypesDefault.default).number.isRequired,
            to: (0, _propTypesDefault.default).number.isRequired
        })
    }).isRequired,
    experiment: (0, _propTypesDefault.default).shape({
        accession: (0, _propTypesDefault.default).string.isRequired,
        description: (0, _propTypesDefault.default).string,
        type: (0, _propTypesDefault.default).string
    }),
    query: (0, _propTypesDefault.default).shape({
        genes: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string).isRequired
    }),
    atlasUrl: (0, _propTypesDefault.default).string,
    isDifferential: (0, _propTypesDefault.default).bool,
    defaultFileName: (0, _propTypesDefault.default).string,
    fullDatasetUrl: (0, _propTypesDefault.default).string.isRequired,
    disclaimer: (0, _propTypesDefault.default).string.isRequired,
    linkTarget: (0, _propTypesDefault.default).string,
    isSingleExperiment: (0, _propTypesDefault.default).bool
};
const un = ({ name: e, allValues: t, currentValues: n, isOpen: s, onChangeIsOpen: o, onChangeCurrentValues: a })=>{
    const i = t.every((u)=>n.includes(u)), c = t.every((u)=>!n.includes(u)), d = t.length !== 1 || t[0] !== e, m = /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
        className: "gxa-filter-option-label",
        children: e
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                type: "checkbox",
                style: {
                    margin: "10px 0 0 "
                },
                value: e,
                "aria-label": e,
                onChange: ()=>a((0, _xorJsDefault.default)(t, n).length ? t : []),
                checked: i,
                ref: (u)=>{
                    u && (u.indeterminate = !i && !c);
                }
            }),
            d ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("button", {
                type: "button",
                className: "gxa-filter-option-name",
                "aria-expanded": s,
                onClick: ()=>o(!s),
                children: [
                    m,
                    " ",
                    s ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(zr, {
                        style: {
                            fontSize: "x-small",
                            marginLeft: "5px"
                        }
                    }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ur, {
                        style: {
                            fontSize: "x-small",
                            marginLeft: "5px"
                        }
                    })
                ]
            }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                className: "gxa-filter-option-name",
                children: m
            }),
            d && s && /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                children: t.map((u)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                        style: {
                            marginLeft: "20px",
                            fontSize: "smaller"
                        },
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                                type: "checkbox",
                                value: u,
                                "aria-label": u,
                                onChange: ()=>a((0, _xorJsDefault.default)([
                                        u
                                    ], n)),
                                checked: n.includes(u),
                                style: {
                                    margin: "0"
                                }
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                children: [
                                    " ",
                                    u
                                ]
                            })
                        ]
                    }, u))
            })
        ]
    });
};
un.propTypes = {
    name: (0, _propTypesDefault.default).string.isRequired,
    allValues: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string).isRequired,
    currentValues: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string).isRequired,
    onChangeCurrentValues: (0, _propTypesDefault.default).func.isRequired,
    isOpen: (0, _propTypesDefault.default).bool.isRequired,
    onChangeIsOpen: (0, _propTypesDefault.default).func.isRequired
};
const Ms = (0, _uncontrollable.uncontrollable)(un, {
    isOpen: "onChangeIsOpen"
});
class pn extends (0, _react.Component) {
    constructor(t){
        super(t), this.state = {
            isChecked: t.value
        };
    }
    componentDidMount() {
        this.setState({
            isChecked: this.props.value
        });
    }
    toggleCheckboxChange() {
        const { handleCheckboxChange: t, label: n } = this.props;
        this.setState(({ isChecked: s })=>({
                isChecked: !s
            })), t(n);
    }
    render() {
        const { id: t, label: n, actualValue: s, indeterminate: o } = this.props;
        return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
            className: "form-check form-check-inline",
            children: [
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                    className: "form-check-input",
                    type: "checkbox",
                    id: t,
                    value: n,
                    checked: s,
                    onChange: this.toggleCheckboxChange.bind(this),
                    ref: (a)=>{
                        a && (a.indeterminate = o);
                    }
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("label", {
                    className: "form-check-label",
                    htmlFor: t,
                    children: n
                })
            ]
        });
    }
}
pn.propTypes = {
    id: (0, _propTypesDefault.default).string.isRequired,
    label: (0, _propTypesDefault.default).string.isRequired,
    value: (0, _propTypesDefault.default).bool.isRequired,
    actualValue: (0, _propTypesDefault.default).bool.isRequired,
    indeterminate: (0, _propTypesDefault.default).bool.isRequired,
    handleCheckboxChange: (0, _propTypesDefault.default).func.isRequired
};
let Fs = 0;
class mn extends (0, _reactDefault.default).Component {
    constructor(t){
        super(t), this.state = {
            selected: [],
            unselected: [],
            indeterminate: []
        }, this.selectedCheckboxes = /* @__PURE__ */ new Set(), this.idPrefix = `gxa-category-checkbox-${++Fs}`;
    }
    componentDidMount() {
        this.handleCurrentCheckboxSelection();
    }
    _updateFiltersSelected(t, n) {
        this.setState({
            selected: t,
            unselected: n
        });
    }
    toggleCheckbox(t) {
        const { selected: n } = this.state;
        this.selectedCheckboxes.size === 0 && n.forEach((s)=>this.selectedCheckboxes.add(s)), this.selectedCheckboxes.has(t) ? this.selectedCheckboxes.delete(t) : this.selectedCheckboxes.add(t), this.handleFiltersSelection();
    }
    handleFiltersSelection() {
        const { onChangeCurrentValues: t, allValues: n } = this.props;
        let s = [];
        for (const a of this.selectedCheckboxes)s.includes(a) || s.push(a);
        this._updateFiltersSelected(s);
        const o = n.filter((a)=>s.length > 0 ? s.map((i)=>a.categories.indexOf(i)).map((i)=>i > -1).reduce((i, c)=>i || c) : "");
        t(o);
    }
    _manageCheckedCategories(t, n) {
        const s = [];
        let o = !1;
        return n.forEach((a)=>{
            t.forEach((i)=>{
                i.categories.includes(a.name) && (o = !0);
            }), o && s.push(a.name), o = !1;
        }), s;
    }
    _manageUncheckedCategories(t, n) {
        let s = [];
        return t.forEach((o)=>{
            n.includes(o) || o.categories.forEach((a)=>{
                s.includes(a) || s.push(a);
            });
        }), s;
    }
    handleCurrentCheckboxSelection() {
        const { currentValues: t, allValues: n, categories: s, currentTab: o } = this.props, a = this._manageCheckedCategories(t, s), i = this._manageUncheckedCategories(n, t), c = [];
        a.forEach((d)=>{
            !i.includes(d) && o === "" && c.push(d);
        }), this._updateFiltersSelected(c, i);
    }
    _manageIndeterminates(t, n, s, o) {
        const a = this._manageCheckedCategories(n, s), i = this._manageUncheckedCategories(t, n), c = a.filter((m)=>o.includes(m));
        let d = [];
        return c.forEach((m)=>{
            i.includes(m) && d.push(m);
        }), d;
    }
    createCheckbox(t, n) {
        const { selected: s } = this.state, { currentTab: o } = this.props, { categories: a, allValues: i, currentValues: c } = this.props, d = o === "All" ? !0 : o === "None" ? !1 : s ? s.includes(t) : !1, u = this._manageIndeterminates(i, c, a, s).includes(t);
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(pn, {
            id: `${this.idPrefix}-${n}`,
            label: t,
            value: d,
            actualValue: d,
            indeterminate: u,
            handleCheckboxChange: this.toggleCheckbox.bind(this)
        }, t);
    }
    createCheckboxes() {
        const { categories: t } = this.props;
        return t.map((s)=>s.name).map(this.createCheckbox.bind(this));
    }
    render() {
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
            children: this.createCheckboxes()
        });
    }
}
mn.propTypes = {
    categories: (0, _propTypesDefault.default).arrayOf(Ee).isRequired,
    allValues: (0, _propTypesDefault.default).arrayOf(Z).isRequired,
    currentValues: (0, _propTypesDefault.default).arrayOf(Z).isRequired,
    currentTab: (0, _propTypesDefault.default).string.isRequired,
    onChangeCurrentValues: (0, _propTypesDefault.default).func.isRequired
};
const Ps = (e, t)=>Object.entries((0, _groupByJsDefault.default)(e, t)), Hs = (e)=>e.charAt(0).toUpperCase() + e.substr(1), Ie = (e)=>{
    const t = e.toString().split(".");
    return t[0] = t[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","), t.join(".");
}, gn = {
    textTransform: "unset",
    letterSpacing: "unset",
    height: "unset"
}, hn = (e)=>({ allTabs: t, disabledTabs: n = [], currentTab: s, onChangeCurrentTab: o })=>/* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Nav), {
            variant: e,
            className: e === "pills" ? "flex-column" : void 0,
            activeKey: s,
            onSelect: o,
            style: {
                fontSize: "medium"
            },
            children: t.map((a)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Nav).Item, {
                    children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Nav).Link, {
                        eventKey: a,
                        disabled: n.includes(a),
                        children: a
                    })
                }, a))
        }), Bs = hn("tabs"), $s = hn("pills"), _s = ({ showModal: e, onCloseModal: t, tabNames: n, currentTopTab: s, onChangeCurrentTopTab: o, categories: a, categoryCheckboxes: i, currentValues: c, allValues: d, onChangeCurrentValues: m })=>// Rendered in a portal outside .gxaHeatmapContainer: .gxa-heatmap-modal scopes its styles (src/styles/heatmap.css)
    /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Modal), {
        show: e,
        onHide: t,
        size: "lg",
        className: "gxa-heatmap-modal",
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Modal).Header, {
                closeButton: !0,
                children: n.length > 1 ? Bs({
                    allTabs: n,
                    currentTab: s,
                    onChangeCurrentTab: o
                }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Modal).Title, {
                    children: " Filters "
                })
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Modal).Body, {
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Row), {
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                                sm: 9,
                                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(mn, {
                                    categories: i,
                                    allValues: d,
                                    currentValues: c,
                                    currentTab: (a.find((u)=>d.every((p)=>c.some((h)=>h.value === p.value) === p.categories.includes(u.name)) && !u.disabled) || {
                                        name: ""
                                    }).name,
                                    onChangeCurrentValues: m
                                })
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                                sm: 3,
                                children: $s({
                                    allTabs: a.map((u)=>u.name),
                                    disabledTabs: a.filter((u)=>u.disabled).map((u)=>u.name),
                                    currentTab: (a.find((u)=>d.every((p)=>c.some((h)=>h.value === p.value) === p.categories.includes(u.name)) && !u.disabled) || {
                                        name: ""
                                    }).name,
                                    onChangeCurrentTab: (u)=>m(d.filter((p)=>p.categories.includes(u)))
                                })
                            })
                        ]
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            marginLeft: "20px",
                            columnCount: "2"
                        },
                        children: (0, _sortByJsDefault.default)(Ps([].concat.apply([], d.map((u)=>(u.groupings.find((p)=>p.name === s) || {
                                values: []
                            }).values.map((p)=>[
                                    p.label,
                                    u.value
                                ]))), "0").map((u)=>[
                                u[0],
                                [].concat.apply([], u[1].map((p)=>p[1]))
                            ]), (u)=>u[0] === "Unmapped" ? "_" : ` ${u[0]}`).map((u)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)(Ms, {
                                defaultIsOpen: !1,
                                name: u[0],
                                allValues: u[1],
                                currentValues: u[1].filter((p)=>c.some((h)=>h.value === p)),
                                onChangeCurrentValues: (p)=>m(d.filter((h)=>u[1].includes(h.value) ? p.includes(h.value) : c.some((x)=>x.value === h.value)))
                            }, u[0]))
                    })
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Modal).Footer, {
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Button), {
                    variant: "secondary",
                    onClick: t,
                    style: gn,
                    children: "Close"
                })
            })
        ]
    }), Ds = (0, _uncontrollable.uncontrollable)(_s, {
    currentTopTab: "onChangeCurrentTopTab"
}), Vs = ({ disabled: e, onClickButton: t })=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
        title: e ? "Reset zoom to enable filters" : void 0,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Button), {
            size: "sm",
            variant: "outline-secondary",
            onClick: t,
            disabled: e,
            style: gn,
            children: [
                /* @__PURE__ */ (0, _jsxRuntime.jsx)(Gr, {}),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                    style: {
                        verticalAlign: "middle"
                    },
                    children: " Filters"
                })
            ]
        })
    }), fn = (e)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(Vs, {
                disabled: e.disabled,
                onClickButton: ()=>e.onChangeShowModal(!0)
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ds, {
                ...e,
                onCloseModal: ()=>e.onChangeShowModal(!1),
                defaultCurrentTopTab: e.tabNames[0] || "",
                defaultCurrentCategory: e.categories.find((t)=>!t.disabled)
            })
        ]
    });
fn.propTypes = {
    categories: (0, _propTypesDefault.default).arrayOf(Ee).isRequired,
    categoryCheckboxes: (0, _propTypesDefault.default).arrayOf(Ee).isRequired,
    allValues: (0, _propTypesDefault.default).arrayOf(Z).isRequired,
    currentValues: (0, _propTypesDefault.default).arrayOf(Z).isRequired,
    disabled: (0, _propTypesDefault.default).bool.isRequired,
    onChangeCurrentValues: (0, _propTypesDefault.default).func.isRequired,
    tabNames: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string).isRequired,
    onChangeShowModal: (0, _propTypesDefault.default).func.isRequired,
    showModal: (0, _propTypesDefault.default).bool.isRequired
};
const js = (0, _uncontrollable.uncontrollable)(fn, {
    showModal: "onChangeShowModal"
}), Gs = (e)=>e.replace(/(\d)0+$/, "$1"), zs = (e)=>e.replace(/^\+/, ""), xn = ({ value: e, accuracy: t = 4, style: n = {} })=>{
    if (e >= 0.1 && e < 1e5 || e === 0) return /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
        children: e
    });
    const o = e.toExponential(t).split("e"), a = Gs(o[0]), i = zs(o[1]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
        style: n,
        children: [
            +a != 1 ? `${a} \xd7 ` : "",
            "10",
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                style: {
                    verticalAlign: "super"
                },
                children: i
            })
        ]
    });
};
xn.propTypes = {
    value: (0, _propTypesDefault.default).number.isRequired,
    accuracy: (0, _propTypesDefault.default).number,
    style: (0, _propTypesDefault.default).object
};
const Ue = (e, t)=>{
    if (e.length > t) {
        const n = e.slice(0, t).split(" ");
        return n.length > 1 ? `${n.slice(0, -1).join(" ")} \u{2026}` : `${n[0].slice(0, -1)}\u{2026}`;
    }
    return e;
}, Us = (e)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)(xn, {
        value: e,
        style: {
            fontWeight: "bold"
        }
    }), Ws = (e)=>e ? +e.toFixed(4) : "", yn = (e)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
        style: {
            border: "1px rgb(192, 192, 192) solid",
            marginRight: "0.25rem",
            width: "0.6rem",
            height: "0.6rem",
            display: "inline-block",
            backgroundColor: e
        }
    }, `Tiny ${e} square`), We = (e)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("b", {
        children: e
    }), bn = (e, t, n, s)=>!!(t && n) && /* @__PURE__ */ (0, _jsxRuntime.jsxs)(e, {
        children: [
            typeof t == "string" ? `${t}: ` : t,
            n.length > 50 && /* @__PURE__ */ (0, _jsxRuntime.jsx)("br", {}),
            (s || We)(n)
        ]
    }, `${t} ${n}`), re = bn.bind(void 0, "div"), Cn = bn.bind(void 0, "span"), Ks = ({ config: e, yLabel: t })=>re(e.yAxisLegendName, t), Qs = ({ xAxisLegendName: e, config: t, xLabel: n })=>re(e || t.xAxisLegendName, n), De = 30, Xs = (e, t, n, s)=>e && t && n ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        children: [
            `${e}: `,
            t.length + n.length > De * 2 ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("br", {}) : null,
            We(Ue(t, De)),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("i", {
                style: {
                    margin: "0.25rem"
                },
                children: "vs"
            }),
            We(Ue(n, De))
        ]
    }, `${e} ${t} ${n}`) : null, wn = (e)=>e.toLowerCase().replace(/\w\S*/, (t)=>t.charAt(0).toUpperCase() + t.substr(1).toLowerCase()), Js = ({ xProperties: e })=>e.filter((t)=>t.contrastPropertyType !== "SAMPLE").map((t)=>re(wn(t.propertyName), t.testValue)), Zs = ({ xProperties: e })=>e.filter((t)=>t.testValue !== t.referenceValue).map((t)=>Xs(wn(t.propertyName), t.testValue, t.referenceValue)), Ys = ({ colour: e, foldChange: t, pValue: n, tStat: s })=>[
        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
            children: [
                yn(e),
                Cn(/* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                    children: [
                        "Log",
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("sub", {
                            children: "2"
                        }),
                        "-fold change: "
                    ]
                }), t)
            ]
        }, ""),
        re("Adjusted p-value", n, Us),
        re("T-statistic", Ws(s))
    ], eo = ({ colour: e, value: t, unit: n, replicates: s })=>[
        yn(e),
        Cn("Expression level", t ? `${t} ${n}` : "Below cutoff")
    ].concat(s ? re("Number of biological replicates", s) : []), vn = (e)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        style: {
            whiteSpace: "pre",
            background: "rgba(255, 255, 255, .85)",
            padding: "5px",
            border: "1px solid darkgray",
            borderRadius: "3px",
            boxShadow: "2px 2px 2px darkslategray"
        },
        children: [
            Ks(e),
            e.config.isMultiExperiment ? Qs(e) : e.config.isDifferential ? Zs(e) : Js(e),
            e.config.isDifferential ? Ys(e) : eo(e)
        ]
    });
vn.propTypes = {
    config: (0, _propTypesDefault.default).shape({
        isDifferential: (0, _propTypesDefault.default).bool.isRequired,
        isMultiExperiment: (0, _propTypesDefault.default).bool.isRequired,
        xAxisLegendName: (0, _propTypesDefault.default).string.isRequired,
        yAxisLegendName: (0, _propTypesDefault.default).string.isRequired
    }).isRequired,
    colour: (0, _propTypesDefault.default).string.isRequired,
    xLabel: (0, _propTypesDefault.default).string.isRequired,
    xProperties: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        propertyName: (0, _propTypesDefault.default).string.isRequired,
        referenceValue: (0, _propTypesDefault.default).string,
        // present iff differential
        testValue: (0, _propTypesDefault.default).string.isRequired
    })),
    yLabel: (0, _propTypesDefault.default).string.isRequired,
    value: (0, _propTypesDefault.default).number.isRequired,
    unit: (0, _propTypesDefault.default).string.isRequired,
    replicates: (0, _propTypesDefault.default).number,
    foldChange: (0, _propTypesDefault.default).number,
    pValue: (0, _propTypesDefault.default).number,
    tStat: (0, _propTypesDefault.default).number,
    xAxisLegendName: (0, _propTypesDefault.default).string
};
const to = (e)=>(0, _serverDefault.default).renderToStaticMarkup(e), no = '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif', ro = (e)=>function(t, n) {
        const s = {
            colour: n.color,
            xLabel: n.options.info.xLabel || t.xAxis.categories[n.x].label,
            xProperties: t.xAxis.categories[n.x].info.tooltip.properties,
            yLabel: t.yAxis.categories[n.y].label,
            value: n.value,
            replicates: t.xAxis.categories[n.x].info.tooltip.replicates || void 0
        };
        return Object.keys(n.options.info).forEach((o)=>s[o] = n.options.info[o]), to(/* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
            style: {
                fontFamily: no
            },
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(vn, {
                ...s,
                config: e
            })
        }));
    }, so = {
    boxSizing: "border-box",
    color: "white",
    borderRadius: "50%",
    fontSize: "16px",
    lineHeight: "18px",
    height: "20px",
    width: "20px",
    textAlign: "center",
    verticalAlign: "middle",
    marginRight: "6px",
    opacity: 0.4,
    display: "inline-block"
}, oo = {
    axis: {
        paddingTop: "1px"
    },
    legend: {
        paddingLeft: "1px",
        marginLeft: "10px"
    }
}, ue = ({ background: e, variant: t = "axis", title: n, children: s })=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
        title: n,
        style: {
            ...so,
            ...oo[t],
            backgroundColor: e
        },
        children: s
    });
ue.propTypes = {
    background: (0, _propTypesDefault.default).string.isRequired,
    variant: (0, _propTypesDefault.default).oneOf([
        "axis",
        "legend"
    ]),
    title: (0, _propTypesDefault.default).string,
    children: (0, _propTypesDefault.default).node
};
const io = 15, ao = (e, t)=>{
    let n = 0;
    for(; n < e.length && n < t.length && e[n] === t[n];)n++;
    return e.slice(0, n);
}, lo = (e)=>{
    if (e.length < 2) return "";
    const t = e.reduce(ao), n = t.slice(0, t.lastIndexOf(" ") + 1);
    return n.trim().length >= io && e.every((s)=>s.slice(n.length).trim()) ? n : "";
}, co = (e)=>{
    const t = lo(e.map((n)=>n.label));
    return t ? e.map((n)=>({
            ...n,
            shortLabel: n.label.slice(t.length).trim()
        })) : e;
}, Ke = (e)=>{
    const t = e.find((n)=>n.shortLabel);
    return t ? t.label.slice(0, t.label.length - t.shortLabel.length).trim() : "";
}, st = (e)=>e.shortLabel || e.label, uo = (e)=>(0, _serverDefault.default).renderToStaticMarkup(e), Rn = (e)=>{
    const t = e.experimentType === "PROTEOMICS_BASELINE" || e.experimentType === "PROTEOMICS_BASELINE_DIA" ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(ue, {
        variant: "axis",
        background: "green",
        title: "Proteomics experiment",
        children: "P"
    }) : e.experimentType && /* @__PURE__ */ (0, _jsxRuntime.jsx)(ue, {
        variant: "axis",
        background: "orangered",
        title: "Transcriptomics experiment",
        children: "T"
    }), n = /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            t,
            Ue(e.labelText, 40)
        ]
    }), s = e.url ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("a", {
        ...J(e.config.linkTarget),
        href: e.url,
        style: {
            border: "none",
            color: "#148ff3",
            textDecoration: "none"
        },
        children: n
    }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
        style: {
            color: "#148ff3"
        },
        children: n
    });
    return e.extra ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
        "data-gxa-y": e.pos,
        title: e.labelText.length > 40 ? e.labelText : "",
        children: [
            s,
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("em", {
                style: {
                    color: "black"
                },
                children: `	${e.extra}`
            })
        ]
    }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
        "data-gxa-y": e.pos,
        title: e.labelText.length > 40 ? e.labelText : "",
        children: s
    });
};
Rn.propTypes = {
    config: (0, _propTypesDefault.default).shape({
        atlasUrl: (0, _propTypesDefault.default).string.isRequired,
        outProxy: (0, _propTypesDefault.default).string.isRequired,
        linkTarget: (0, _propTypesDefault.default).string,
        isMultiExperiment: (0, _propTypesDefault.default).bool.isRequired,
        isDifferential: (0, _propTypesDefault.default).bool.isRequired,
        experiment: (0, _propTypesDefault.default).shape({
            accession: (0, _propTypesDefault.default).string.isRequired,
            type: (0, _propTypesDefault.default).string.isRequired,
            description: (0, _propTypesDefault.default).string.isRequired,
            species: (0, _propTypesDefault.default).string.isRequired
        })
    }).isRequired,
    labelText: (0, _propTypesDefault.default).string.isRequired,
    resourceId: (0, _propTypesDefault.default).string.isRequired,
    url: (0, _propTypesDefault.default).string,
    pos: (0, _propTypesDefault.default).number,
    extra: (0, _propTypesDefault.default).string,
    experimentType: (0, _propTypesDefault.default).string
};
const po = (e)=>({
        // A label without the text every column shares (the axis title shows that once)
        xAxisFormatter: (t)=>st(t),
        xAxisStyle: {
            fontSize: e.isDifferential ? "9px" : "smaller",
            cursor: "default",
            textOverflow: e.experiment ? "none" : "ellipsis",
            whiteSpace: e.isDifferential ? "normal" : "nowrap"
        },
        // pos: the label's tick position (`this.pos` in a Highcharts label formatter), i.e. its row index
        yAxisFormatter: (t, n)=>uo(/* @__PURE__ */ (0, _jsxRuntime.jsx)(Rn, {
                config: e,
                labelText: t.label,
                resourceId: t.id,
                url: (e.urlFor || se)("row", e.outProxy + t.info.url, {
                    row: {
                        id: t.id,
                        label: t.label,
                        uri: t.info.uri,
                        experimentType: t.info.experimentType,
                        index: n
                    }
                }),
                pos: n,
                experimentType: t.info.experimentType,
                extra: t.info.designElement || ""
            })),
        yAxisStyle: {
            fontSize: e.isMultiExperiment ? "smaller" : "small",
            color: "#148ff3"
        }
    }), Le = (e)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: e.on ? "gxa-legend-item" : "gxa-legend-item gxa-legend-item--off",
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                className: "gxa-legend-swatch",
                style: {
                    background: e.colour
                }
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                className: "gxa-va-middle",
                children: e.name
            })
        ]
    });
Le.propTypes = {
    name: (0, _propTypesDefault.default).string.isRequired,
    colour: (0, _propTypesDefault.default).string.isRequired,
    on: (0, _propTypesDefault.default).bool.isRequired
};
const mo = "Baseline expression levels in RNA-seq experiments are in FPKM or TPM. Low: 0.5-10, Medium: 11-1,000, High: >1,000. Proteomics expression levels are mapped to low, medium, high per experiment basis.", qn = ({ legendItems: e, title: t = mo, missingValueColour: n = "white", missingValueLabel: s = "No data available" })=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: "gxa-legend",
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(ue, {
                variant: "legend",
                background: "green",
                children: "P"
            }),
            "Proteomics",
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(ue, {
                variant: "legend",
                background: "orangered",
                children: "T"
            }),
            "Transcriptomics",
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("br", {}),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                className: "gxa-legend-item",
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                    title: t,
                    children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Kr, {
                        className: "gxa-info-icon"
                    })
                })
            }),
            e.map(({ key: o, ...a })=>/* @__PURE__ */ (0, _jsxRuntime.jsx)(Le, {
                    ...a
                }, o)),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(Le, {
                name: s,
                colour: n,
                on: !0
            }, s)
        ]
    });
qn.propTypes = {
    legendItems: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape(Le.propTypes)).isRequired,
    title: (0, _propTypesDefault.default).string,
    missingValueColour: (0, _propTypesDefault.default).string,
    missingValueLabel: (0, _propTypesDefault.default).string
};
const go = {
    overflow: "auto",
    height: "15px",
    margin: "2px 6px 2px 6px",
    verticalAlign: "middle",
    width: "200px",
    display: "inline-block"
}, kt = {
    whiteSpace: "nowrap",
    fontSize: "10px",
    verticalAlign: "middle",
    display: "table-cell"
}, ho = {
    textAlign: "right"
}, fo = {
    textAlign: "left"
}, xo = ({ fromValue: e, toValue: t, colours: n }, s)=>{
    const o = {
        backgroundImage: `linear-gradient(to right, ${n.join(", ")})`
    };
    return e < t ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        style: {
            display: "table-row"
        },
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                style: {
                    ...kt,
                    ...ho
                },
                children: Ie(e)
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                style: {
                    display: "table-cell",
                    verticalAlign: "middle"
                },
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                    style: {
                        ...go,
                        ...o
                    }
                })
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                style: {
                    ...kt,
                    ...fo
                },
                children: Ie(t)
            })
        ]
    }, `gradient_${s}`) : null;
}, yo = {
    fontSize: "12px",
    padding: "12px 0",
    marginLeft: "10px",
    textAlign: "center",
    display: "inline-block"
}, An = ({ gradients: e, unit: t })=>e.some((n)=>n.fromValue !== 0 || n.toValue !== 0) && /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        style: yo,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                children: t ? t.includes("fold change") ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                    children: [
                        "Log",
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("sub", {
                            children: "2"
                        }),
                        "-fold change"
                    ]
                }) : /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                    children: [
                        "Expression level in ",
                        t
                    ]
                }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                    children: "Expression level"
                })
            }),
            e.map(xo)
        ]
    });
An.propTypes = {
    gradients: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        fromValue: (0, _propTypesDefault.default).number,
        toValue: (0, _propTypesDefault.default).number,
        colours: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)
    })).isRequired,
    unit: (0, _propTypesDefault.default).string.isRequired
};
const Tn = ({ dataSeries: e })=>{
    const t = e.map((n)=>({
            key: n.info.name,
            name: n.info.name,
            colour: n.info.colour,
            on: !!n.data.length
        })).reverse();
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(qn, {
        legendItems: t
    });
};
Tn.propTypes = {
    dataSeries: cn.isRequired
};
const ot = ({ colourAxis: e })=>{
    const t = Math.min(...e.dataClasses.filter((c)=>c.from <= 0).map((c)=>c.from)), n = Math.max(...e.dataClasses.filter((c)=>c.to <= 0).map((c)=>c.to)), s = e.dataClasses.filter((c)=>c.from <= 0).map((c)=>c.color), o = Math.min(...e.dataClasses.filter((c)=>c.from >= 0).map((c)=>c.from)), a = Math.max(...e.dataClasses.filter((c)=>c.to >= 0).map((c)=>c.to)), i = e.dataClasses.filter((c)=>c.from >= 0).map((c)=>c.color);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(An, {
        gradients: [
            {
                fromValue: t,
                toValue: n,
                colours: s
            },
            {
                fromValue: o,
                toValue: a,
                colours: i
            }
        ],
        unit: e.unit
    });
};
ot.propTypes = {
    heatmapConfig: he.isRequired,
    colourAxis: fe.isRequired
};
const it = ({ showCoexpressionsCallback: e })=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Button), {
        size: "sm",
        variant: "outline-secondary",
        onClick: ()=>e(10),
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(Wr, {}),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                className: "gxa-va-middle",
                children: " Add similarly expressed genes"
            })
        ]
    });
it.propTypes = {
    showCoexpressionsCallback: (0, _propTypesDefault.default).func.isRequired
};
const bo = {
    width: "250px",
    margin: "15px",
    paddingBottom: "20px"
}, Sn = ({ max: e })=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        className: "gxa-range-marks",
        "aria-hidden": "true",
        children: [
            [
                0,
                "off"
            ],
            ...e > 10 ? [
                [
                    10,
                    "10"
                ]
            ] : [],
            ...e > 0 ? [
                [
                    e,
                    String(e)
                ]
            ] : []
        ].map(([t, n])=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                className: "gxa-range-mark",
                style: {
                    left: `${e > 0 ? 100 * t / e : 0}%`
                },
                children: n
            }, t))
    });
Sn.propTypes = {
    max: (0, _propTypesDefault.default).number.isRequired
};
const at = ({ geneName: e, numCoexpressionsAvailable: t, numCoexpressionsVisible: n, showCoexpressionsCallback: s })=>{
    const [o, a] = (0, _react.useState)(n), i = ()=>{
        o !== n && s(o);
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                style: {
                    fontSize: "0.75rem"
                },
                children: [
                    "Display genes with similar expression to ",
                    e,
                    ":"
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                style: bo,
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Form).Range, {
                        min: 0,
                        max: t,
                        step: 1,
                        value: o,
                        "aria-label": `Genes with similar expression to ${e}`,
                        "aria-valuetext": o ? String(o) : "off",
                        onChange: (c)=>a(Number(c.target.value)),
                        onMouseUp: i,
                        onTouchEnd: i,
                        onKeyUp: i
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(Sn, {
                        max: t
                    })
                ]
            })
        ]
    });
};
at.propTypes = {
    geneName: (0, _propTypesDefault.default).string.isRequired,
    numCoexpressionsVisible: (0, _propTypesDefault.default).number.isRequired,
    numCoexpressionsAvailable: (0, _propTypesDefault.default).number.isRequired,
    ...it.propTypes
};
const kn = ({ geneName: e, numCoexpressionsVisible: t, numCoexpressionsAvailable: n, showCoexpressionsCallback: s })=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        style: {
            marginTop: "30px"
        },
        children: n ? t ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(at, {
                geneName: e,
                numCoexpressionsVisible: t,
                numCoexpressionsAvailable: n,
                showCoexpressionsCallback: s
            })
        }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)(it, {
            showCoexpressionsCallback: s
        }) : /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
            children: [
                "No genes with similar expression to ",
                e,
                " could be found"
            ]
        })
    });
kn.propTypes = {
    ...at.propTypes
};
const Co = (e)=>typeof DOMParser == "function" ? new DOMParser().parseFromString(String(e), "text/html").body.textContent : String(e).replace(/<[^>]*>/g, "").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#x27;|&#39;/g, "'").replace(/&amp;/g, "&"), wo = (e, t)=>{
    const n = /\bdata-gxa-y="(\d+)"/.exec(String(e)), s = n ? Number(n[1]) : -1;
    if (s >= 0 && s < t.length) return s;
    const o = Co(e);
    return t.findIndex((a)=>a.label === o);
}, vo = (e, t, n)=>n.indexOf(e) === t, Qe = (e, t)=>[
        e.xAxisCategories[t].id
    ], Ro = (e, t)=>[].concat.apply([], [].concat.apply([], e.dataSeries.map((n)=>n.data)).filter((n)=>n.y === t && !!n.value).map((n)=>Qe(e, n.x)).map((n)=>Array.isArray(n) ? n : [
            n
        ])).filter(vo), qo = ({ heatmapData: e, heatmapConfig: { experiment: t, atlasUrl: n, outProxy: s, linkTarget: o, urlFor: a = se } })=>t ? (i, c, d)=>{
        const m = e.yAxisCategories[c].info.trackId, u = e.xAxisCategories[i].info.trackId, p = a("genomeBrowser", s + (0, _urijsDefault.default)(t.urls.genome_browsers, n).addSearch({
            experimentAccession: t.accession,
            name: d,
            geneId: m,
            trackId: u
        }).toString(), {
            genomeBrowser: d,
            geneId: m,
            trackId: u
        });
        p && zt(p, o);
    } : void 0, Ao = ({ heatmapData: e, onSelectOntologyIds: t, heatmapConfig: n })=>({
        onHoverRowLabel: (s)=>{
            const o = wo(s, e.yAxisCategories);
            t(Ro(e, o));
        },
        onHoverColumnLabel: (s)=>{
            const o = e.xAxisCategories.findIndex((a)=>a.label === s);
            t(Qe(e, o));
        },
        onHoverPoint: (s)=>{
            t(Qe(e, s));
        },
        onHoverOff: ()=>{
            t([]);
        },
        onClick: qo({
            heatmapData: e,
            heatmapConfig: n
        })
    }), To = (e, t)=>{
    const n = (i)=>e.columns.indexOf(i), s = (i)=>e.rows.indexOf(i), o = (i)=>({
            x: n(i.x),
            y: s(i.y),
            value: i.value,
            info: i.info
        }), a = (i, c)=>i.map((d, m)=>[
                d,
                c(m)
            ]).sort((d, m)=>d[1] - m[1]).map((d)=>d[0]);
    return {
        dataSeries: t.dataSeries.map((i)=>({
                info: i.info,
                data: i.data.map(o)
            })),
        xAxisCategories: a(t.xAxisCategories, n),
        yAxisCategories: a(t.yAxisCategories, s)
    };
}, Ot = (e, t, n, s)=>s.filter(t).map((o)=>o.data).reduce((o, a)=>o.concat(a), []).filter(n).map((o)=>o[e]).filter((o, a, i)=>i.indexOf(o) === a).sort((o, a)=>o - a), So = (e, t, n)=>{
    const s = Ot("x", e, t, n.dataSeries), o = Ot("y", e, t, n.dataSeries), a = n.dataSeries.map((i, c)=>e(i, c) ? i.data.filter(t) : []).map((i)=>i.map((c)=>({
                x: s.indexOf(c.x),
                y: o.indexOf(c.y),
                value: c.value,
                info: c.info
            })).filter((c)=>c.x > -1 && c.y > -1));
    return {
        dataSeries: n.dataSeries.map((i, c)=>({
                info: i.info,
                data: a[c]
            })),
        xAxisCategories: n.xAxisCategories.filter((i, c)=>s.includes(c)),
        yAxisCategories: n.yAxisCategories.filter((i, c)=>o.includes(c))
    };
}, ko = (e, t, n, s)=>So(e, (o)=>t(s.yAxisCategories[o.y]) && n(s.xAxisCategories[o.x]), s), Oo = (e, t)=>{
    const n = [];
    let s = 0, o = 0;
    for(; s < e.length && o < t.length;)e.length > s && t.length > o && e[s] === t[o] ? (n.push(""), s++, o++) : e.length > s ? (n.push(e[s]), s++) : t[o].length > o && (n.push(""), o++);
    return n;
}, No = (e)=>{
    let t = -1;
    return e.map((n)=>(!n && t++, t));
}, Eo = (e, t)=>{
    const n = e.concat(t.xAxisCategories.filter((o)=>e.findIndex((a)=>a.label === o.label) === -1)), s = No(Oo(n.map((o)=>o.label), t.xAxisCategories.map((o)=>o.label)));
    return {
        dataSeries: t.dataSeries.map((o)=>({
                info: o.info,
                data: o.data.map((a)=>({
                        ...a,
                        x: s.indexOf(a.x)
                    }))
            })),
        xAxisCategories: n,
        yAxisCategories: t.yAxisCategories
    };
}, Io = (e, t)=>{
    const n = To(e.ordering, t);
    return Eo(e.allowEmptyColumns ? n.xAxisCategories : [], ko(e.keepSeries, e.keepRow, e.keepColumn, n));
}, On = (e, t = 0, n)=>{
    class s extends (0, _reactDefault.default).Component {
        constructor(a){
            super(a), this.mounted = !1, this.updateDebounced = (0, _debounceJsDefault.default)(()=>this.mounted && this.forceUpdate(), t, n);
        }
        componentDidMount() {
            this.mounted = !0;
        }
        shouldComponentUpdate() {
            return this.updateDebounced(), !1;
        }
        componentWillUnmount() {
            this.mounted = !1, this.updateDebounced.cancel();
        }
        render() {
            return /* @__PURE__ */ (0, _jsxRuntime.jsx)(e, {
                ...this.props
            });
        }
    }
    return s.displayName = `debounceRender(${e.displayName || e.name || "Component"})`, s;
}, Lo = (e, t, n)=>(e[t] || (n(e), Object.defineProperty(e, t, {
        value: !0
    })), e), Nt = ()=>Lo((0, _highchartsDefault.default), "__gxaHeatmapInit", (e)=>{
        (0, _heatmapJsDefault.default)(e), (0, _highchartsCustomEventsDefault.default)(e);
    }), Mo = (e = 100)=>{
    const t = (0, _react.useRef)(null), [n, s] = (0, _react.useState)(0);
    return (0, _react.useEffect)(()=>{
        const o = t.current;
        if (!o) return;
        const a = ()=>{
            const c = Math.round(o.clientWidth);
            c > 0 && s(c);
        }, i = (0, _debounceJsDefault.default)(a, e);
        if (a(), typeof ResizeObserver == "function") {
            const c = new ResizeObserver(i);
            return c.observe(o), ()=>{
                c.disconnect(), i.cancel();
            };
        }
        return window.addEventListener("resize", i), ()=>{
            window.removeEventListener("resize", i), i.cancel();
        };
    }, [
        e
    ]), [
        t,
        n
    ];
}, Nn = (e, t, n)=>e * t * Math.cos(n * Math.PI / 180), Fo = (e, t, n)=>e * t * Math.sin(n * Math.PI / 180), Et = (e)=>e.xAxisCategories.length, Po = 300, Ho = 450, En = (e)=>Math.min(Ho, Math.max(Po, e.yAxisCategories.length * 40)), lt = 6, In = (e)=>En(e) / lt, Bo = 24, ct = (e)=>e.xAxisCategories.map((t)=>st(t).length), Ln = (e)=>e.xAxisCategories.map(st).slice(-4).some((s)=>s.length > 30) ? [
        -90
    ] : [
        -45
    ], Mn = (e, t)=>{
    const n = Math.max(...e.yAxisCategories.map((i)=>i.label.length));
    return (t - Nn(n, 8.75, 0) - 12) / e.xAxisCategories.length;
}, Fn = (e, t)=>{
    const n = Mn(e, t);
    return Math.max(...ct(e)) / n < 0.2 ? 0 : Ln(e)[0];
}, $o = (e, t)=>{
    const s = Fn(e, t);
    if (s === 0 || s === -90) return 20;
    {
        const o = Mn(e, t), a = Nn(Math.min(Math.max(...ct(e).slice(-4)), In(e)), lt, 45);
        return Math.max(20, a - o / 2);
    }
}, _o = (e, t)=>{
    const s = Fn(e, t), o = Math.min(Math.max(...ct(e)), In(e));
    return (Ke(e.xAxisCategories) ? Bo : 0) + (s === 0 ? 30 : Fo(o, lt, Math.abs(s)));
}, Do = (e, t, n)=>e.yAxisCategories.length * 40 + _o(e, t) + n, Vo = (e, t)=>({
        marginBottom: 10,
        marginRight: Math.ceil($o(e, t) / 10) * 10,
        height: Do(e, t, 10),
        autoRotation: Ln(e)
    }), jo = (e, t = [])=>{
    const n = e.getSelectedPoints();
    n.length > 0 && n.forEach((s)=>s.select(!1)), e.series.forEach((s)=>{
        s.points.forEach((o)=>{
            t.includes(o.series.xAxis.categories[o.x].id) && o.select(!0, !0);
        });
    });
}, Go = (e)=>{
    const t = e.xAxis && e.xAxis[0];
    t && t.tickPositions.forEach((n)=>{
        const s = t.ticks[n], o = t.categories && t.categories[n];
        s && s.label && o && o.label && s.label.attr({
            title: o.label
        });
    });
}, zo = (e)=>{
    if (!(e.userMin !== void 0 && e.userMin !== null && e.userMax !== void 0 && e.userMax !== null)) return null;
    const n = (e.categories ? e.categories.length : 0) - 1, s = Math.max(0, Math.ceil(e.min - 0.5));
    return {
        from: s,
        to: Math.max(s, Math.min(n, Math.floor(e.max + 0.5)))
    };
}, Uo = (e, { marginBottom: t, marginRight: n, height: s, autoRotation: o }, { onSetExtremes: a } = {})=>{
    const { heatmapData: i, colourAxis: c, xAxisStyle: d, yAxisStyle: m, noDataCellsColour: u = "white", events: p = {} } = e.current, h = ()=>e.current;
    return {
        chart: {
            marginBottom: t,
            marginRight: n,
            height: s,
            type: "heatmap",
            plotBackgroundColor: u,
            spacingTop: 0,
            plotBorderWidth: 1,
            events: {
                // Fired by HeatmapCanvas when the anatomogram highlights tissues
                handleGxaAnatomogramTissueMouseEnter: function(x) {
                    jo(this, x.svgPathIds);
                },
                render: function() {
                    Go(this);
                }
            },
            zoomType: "x"
        },
        plotOptions: {
            heatmap: {
                turboThreshold: 0
            },
            series: {
                cursor: p.onClick ? "pointer" : void 0,
                point: {
                    events: {
                        click: function() {
                            const { events: x, currentGenomeBrowser: f } = h();
                            x.onClick && x.onClick(this.x, this.y, f);
                        },
                        mouseOver: function() {
                            h().events.onHoverPoint(this.x);
                        },
                        mouseOut: function() {
                            h().events.onHoverOff();
                        }
                    }
                },
                states: {
                    hover: {
                        color: "#eeec38"
                    },
                    select: {
                        color: "#eeec38"
                    }
                }
            }
        },
        credits: {
            enabled: !1
        },
        legend: {
            enabled: !1
        },
        title: null,
        colorAxis: c,
        xAxis: {
            //assay groups, contrasts, or factors across experiments
            tickLength: 5,
            tickColor: "rgb(192, 192, 192)",
            lineColor: "rgb(192, 192, 192)",
            // The text every column label starts with, shown once (the labels leave it out)
            title: Ke(i.xAxisCategories) ? {
                text: `${Ke(i.xAxisCategories)} \u{2026}`,
                align: "low",
                style: {
                    fontSize: "12px",
                    color: "#555"
                }
            } : {
                text: null
            },
            labels: {
                // No longer than maxColumnLabelPx, with an ellipsis (upstream showed experiments' labels in full)
                style: {
                    ...d,
                    width: `${En(i)}px`,
                    textOverflow: "ellipsis"
                },
                // Events in labels enabled by 'highcharts-custom-events'
                events: {
                    mouseover: function() {
                        h().events.onHoverColumnLabel(this.value);
                    },
                    mouseout: function() {
                        h().events.onHoverOff();
                    }
                },
                autoRotation: o,
                // Highcharts only auto-rotates while a column is under 80 px wide; wider, it word-wraps instead, which the
                // nowrap style of baseline labels prevents, so long labels overlapped on wide screens. Rotate whenever a label
                // is wider than its column, as the layout (marginTop, height) already assumes.
                autoRotationLimit: 1 / 0,
                formatter: function() {
                    return h().xAxisFormatter(this.value);
                }
            },
            opposite: "true",
            categories: i.xAxisCategories,
            min: 0,
            max: Et(i) - 1,
            events: {
                setExtremes: function(x) {
                    const f = x.min !== void 0 && x.max !== void 0;
                    a && a(f ? {
                        min: x.min,
                        max: x.max
                    } : null), h().onZoom(f);
                },
                // Once the zoom is applied: the columns in view, for the download
                afterSetExtremes: function() {
                    const { onVisibleColumns: x } = h();
                    x && x(zo(this));
                }
            }
        },
        yAxis: {
            //experiments or bioentities
            useHTML: !0,
            reversed: !0,
            labels: {
                useHTML: !0,
                style: m,
                events: {
                    mouseover: function() {
                        h().events.onHoverRowLabel(this.value);
                    },
                    mouseout: function() {
                        h().events.onHoverOff();
                    }
                },
                formatter: function() {
                    return h().yAxisFormatter(this.value, this.pos);
                }
            },
            categories: i.yAxisCategories,
            title: null,
            gridLineWidth: 0,
            minorGridLineWidth: 0,
            endOnTick: !1
        },
        tooltip: {
            useHTML: !0,
            shared: !1,
            borderRadius: 0,
            borderWidth: 0,
            shadow: !1,
            enabled: !0,
            backgroundColor: "none",
            outside: !0,
            formatter: function() {
                return h().cellTooltipFormatter(this.series, this.point);
            }
        },
        series: i.dataSeries.map((x)=>({
                name: x.info.name,
                color: x.info.colour,
                borderWidth: Et(i) > 200 ? 0 : 1,
                borderColor: "white",
                // Copies: Highcharts writes the selection state into point options
                data: x.data.map((f)=>({
                        ...f
                    }))
            }))
    };
}, Pn = (e)=>{
    const [t, n] = Mo(), s = (0, _react.useRef)(e);
    s.current = e;
    const o = (0, _react.useRef)(null), a = ()=>o.current && o.current.chart, i = JSON.stringify([
        e.heatmapData,
        e.colourAxis,
        e.noDataCellsColour,
        e.xAxisStyle,
        e.yAxisStyle,
        !!(e.events && e.events.onClick)
    ]), c = (0, _react.useRef)(i);
    c.current = i;
    const d = n > 0 ? Vo(e.heatmapData, n) : null, m = d && JSON.stringify(d), u = e.labelsKey, p = (0, _react.useRef)(null), h = (0, _react.useMemo)(()=>d && Uo(s, d, {
            onSetExtremes: (f)=>{
                p.current = f && {
                    ...f,
                    dataKey: c.current
                };
            }
        }), [
        i,
        m,
        u
    ]), x = (0, _react.useCallback)((f)=>{
        const y = p.current;
        y && y.dataKey === c.current && f.xAxis[0] && (f.xAxis[0].zoom(y.min, y.max), f.resetZoomButton || f.showResetZoom(), f.redraw(!1));
    }, []);
    return (0, _react.useEffect)(()=>{
        const f = p.current;
        f && f.dataKey !== i && (p.current = null, s.current.onZoom(!1), s.current.onVisibleColumns && s.current.onVisibleColumns(null));
    }, [
        i
    ]), (0, _react.useEffect)(()=>{
        const f = a();
        f && f.reflow();
    }, [
        n
    ]), (0, _react.useEffect)(()=>{
        const f = a();
        f && Nt().fireEvent(f, "handleGxaAnatomogramTissueMouseEnter", {
            svgPathIds: e.ontologyIdsToHighlight
        });
    }, [
        e.ontologyIdsToHighlight,
        h
    ]), (0, _react.useEffect)(()=>{
        const f = ()=>{
            const y = a();
            y && y.pointer && (y.pointer.chartPosition = null);
        };
        return document.addEventListener("scroll", f, {
            capture: !0,
            passive: !0
        }), ()=>document.removeEventListener("scroll", f, {
                capture: !0
            });
    }, []), /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        ref: t,
        children: h && /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _highchartsReactOfficialDefault.default), {
            ref: o,
            highcharts: Nt(),
            options: h,
            immutable: !0,
            callback: x
        })
    });
};
Pn.propTypes = {
    heatmapData: oe.isRequired,
    noDataCellsColour: (0, _propTypesDefault.default).string,
    colourAxis: fe,
    // Only for experiment heatmap
    cellTooltipFormatter: (0, _propTypesDefault.default).func.isRequired,
    xAxisFormatter: (0, _propTypesDefault.default).func.isRequired,
    xAxisStyle: (0, _propTypesDefault.default).object.isRequired,
    yAxisFormatter: (0, _propTypesDefault.default).func.isRequired,
    yAxisStyle: (0, _propTypesDefault.default).object.isRequired,
    ontologyIdsToHighlight: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string).isRequired,
    events: (0, _propTypesDefault.default).shape({
        onHoverRowLabel: (0, _propTypesDefault.default).func.isRequired,
        onHoverColumnLabel: (0, _propTypesDefault.default).func.isRequired,
        onHoverPoint: (0, _propTypesDefault.default).func.isRequired,
        onHoverOff: (0, _propTypesDefault.default).func.isRequired,
        onClick: (0, _propTypesDefault.default).func
    }),
    onZoom: (0, _propTypesDefault.default).func.isRequired,
    // ({from, to} | null): the columns in view after each zoom, null when the chart is not zoomed
    onVisibleColumns: (0, _propTypesDefault.default).func,
    labelsKey: (0, _propTypesDefault.default).string,
    withAnatomogram: (0, _propTypesDefault.default).bool.isRequired,
    currentGenomeBrowser: (0, _propTypesDefault.default).string
};
const Wo = (e)=>e.heatmapData.yAxisCategories.length < 1 ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        style: {
            padding: "50px 0"
        },
        children: "No data match your filtering criteria or your original query. Please, change your query or your filters and try again."
    }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)(Pn, {
        ...e
    }), Ko = On((0, _grameneAnatomogramDefault.default), 50), Qo = On(Wo, 50), Xo = ({ allGenomeBrowsers: e, currentGenomeBrowser: t, onChangeCurrentGenomeBrowser: n })=>e.length ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        style: {
            display: "inline-block",
            padding: "5px"
        },
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Xt, {
            genomeBrowsers: e,
            selected: t,
            onSelect: n
        })
    }) : null, Jo = ({ heatmapData: e, heatmapConfig: t, allOrderings: n, currentOrdering: s, onChangeCurrentOrdering: o, currentZoom: a })=>{
    const i = e.yAxisCategories.length > 1;
    return t.isMultiExperiment ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        style: {
            display: "inline-block",
            padding: "5px"
        },
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Jt, {
            allOptions: n.map((c)=>c.name),
            currentOption: s.name,
            onChangeCurrentOption: (c)=>o(n.find((d)=>d.name === c)),
            title: a ? "Reset zoom to enable sorting options" : "",
            disabled: a || !i
        })
    }) : null;
}, Zo = ({ heatmapConfig: { description: e, disclaimer: t, experiment: n, atlasUrl: s, outProxy: o, linkTarget: a, isDifferential: i, urlFor: c = se }, download: { query: d = {
    genes: []
}, fileName: m, show: u = !0 } = {}, currentOrdering: p, currentZoom: h, zoomedColumns: x, allNumCoexpressions: f, currentNumCoexpressions: y }, R)=>u && /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        style: {
            display: "inline-block",
            padding: "5px"
        },
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(dn, {
            disclaimer: t,
            linkTarget: a,
            isSingleExperiment: !!n,
            experiment: n || null,
            query: d,
            atlasUrl: s,
            isDifferential: i,
            defaultFileName: m,
            currentlyShownContent: {
                descriptionLines: qs(e, d.genes).concat(n ? [] : [
                    `Ordering: ${p.name}`
                ], f && y ? [
                    `Including ${y} genes with similar expression pattern`
                ] : [], n ? [
                    "Results as shown on page"
                ] : []),
                heatmapData: R,
                visibleColumns: h ? x : null
            },
            fullDatasetUrl: n && c("download", new (0, _urijsDefault.default)(o + (0, _urijsDefault.default)(n.urls.download, s).toString()).setSearch({
                cutoff: "0.0"
            }).removeSearch("heatmapMatrixSize").toString(), {}) || ""
        })
    }), Yo = ({ heatmapConfig: e, columnGroups: { groupingNames: t, categories: n, categoryCheckboxes: s }, currentZoom: o, allGroupedColumns: a, currentGroupedColumns: i, onChangeCurrentGroupedColumns: c })=>e.isMultiExperiment && /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        style: {
            display: "inline-block",
            padding: "5px"
        },
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(js, {
            defaultShowModal: !1,
            categories: n,
            categoryCheckboxes: s,
            allValues: a,
            currentValues: i,
            disabled: o,
            onChangeCurrentValues: c,
            tabNames: t
        })
    }), ei = ({ heatmapConfig: e, heatmapData: t, allNumCoexpressions: n, currentNumCoexpressions: s, onChangeCurrentNumCoexpressions: o })=>e.coexpressionsAvailable && !e.isWidget ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(kn, {
        geneName: t.yAxisCategories[0].label,
        numCoexpressionsVisible: s,
        numCoexpressionsAvailable: n,
        showCoexpressionsCallback: o
    }) : null, ti = ({ currentGenomeBrowser: e })=>e && /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
        style: {
            clear: "both",
            float: "right",
            fontSize: "small",
            margin: "0",
            display: " block"
        },
        children: "Click on a cell to open the selected genome browser with attached tracks if available"
    }), Hn = ({ heatmapData: e, heatmapConfig: t, colourAxis: n, children: s })=>t.isMultiExperiment ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        children: [
            s,
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(Tn, {
                dataSeries: e.dataSeries
            })
        ]
    }) : /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(ot, {
                heatmapConfig: t,
                colourAxis: n
            }),
            s
        ]
    });
Hn.propTypes = {
    heatmapConfig: he.isRequired,
    heatmapData: oe.isRequired,
    colourAxis: fe
};
const ni = ({ heatmapData: e, onOntologyIdIsUnderFocus: t, heatmapConfig: n, onChangeCurrentZoom: s, onVisibleColumns: o, ontologyIdsToHighlight: a })=>({
        noDataCellsColour: n.isMultiExperiment ? "white" : "rgb(235, 235, 235)",
        ontologyIdsToHighlight: a,
        onZoom: s,
        onVisibleColumns: o,
        // The row labels' links depend on these as well as on the data
        labelsKey: JSON.stringify([
            n.linkTarget,
            n.outProxy
        ]),
        events: Ao({
            heatmapData: e,
            onSelectOntologyIds: t,
            heatmapConfig: n
        }),
        cellTooltipFormatter: ro(n),
        ...po(n)
    }), ri = ({ heatmapConfig: e, heatmapData: t, currentNumCoexpressions: n, currentGroupedColumns: s, currentOrdering: o })=>Io({
        keepSeries: ()=>!0,
        keepRow: e.coexpressionsAvailable ? (a)=>t.yAxisCategories.slice(0, n + 1).map((i)=>i.label).includes(a.label) : ()=>!0,
        keepColumn: (a)=>s.some((i)=>i.value === a.label),
        ordering: o,
        allowEmptyColumns: !!e.experiment
    }, t), si = (e, t, n)=>{
    const s = {
        ...e,
        heatmapData: t
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Hn, {
        ...s,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Qo, {
            ...ni(s),
            heatmapData: t,
            withAnatomogram: n,
            currentGenomeBrowser: e.currentGenomeBrowser
        })
    });
}, oi = (e, t, n)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        style: {
            clear: "both",
            width: "100%"
        },
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    clear: "both"
                },
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            display: "inline-block",
                            width: "30%"
                        },
                        children: e.heatmapConfig.introductoryMessage
                    }),
                    e.heatmapConfig.showControlMenu && /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                        className: "gxa-controls",
                        style: {
                            display: "inline-block",
                            width: "70%",
                            textAlign: "right"
                        },
                        children: [
                            Xo(e),
                            Jo(e),
                            Yo(e),
                            Zo(e, t)
                        ]
                    })
                ]
            }),
            ti(e),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    clear: "both"
                },
                children: [
                    !!n && /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            width: "17%",
                            marginRight: "3%",
                            display: "inline-block",
                            verticalAlign: "top"
                        },
                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ko, {
                            ...n
                        })
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                        style: {
                            width: n ? "80%" : "100%",
                            display: "inline-block",
                            verticalAlign: "top"
                        },
                        children: [
                            si(e, t, !!n),
                            ei(e)
                        ]
                    })
                ]
            })
        ]
    });
class Bn extends (0, _reactDefault.default).Component {
    constructor(t){
        super(t), this.state = {
            highlightIds: [],
            highlightColumns: [],
            // The columns in view while the chart is zoomed in ({from, to}), for the download
            zoomedColumns: null
        }, this.onOntologyIdIsUnderFocus = this._onOntologyIdIsUnderFocus.bind(this), this.onTissueIdIsUnderFocus = this._onTissueIdIsUnderFocus.bind(this), this.onTissueIdIsNotUnderFocus = this._onTissueIdIsNotUnderFocus.bind(this), this.onVisibleColumns = this._onVisibleColumns.bind(this);
    }
    _onVisibleColumns(t) {
        this.setState(({ zoomedColumns: n })=>n && t && n.from === t.from && n.to === t.to || !n && !t ? null : {
                zoomedColumns: t
            });
    }
    _onOntologyIdIsUnderFocus(t) {
        this.setState({
            highlightIds: t
        });
    }
    _onTissueIdIsUnderFocus(t) {
        this.setState({
            highlightColumns: t
        });
    }
    _onTissueIdIsNotUnderFocus() {
        this.setState({
            highlightColumns: []
        });
    }
    render() {
        const t = Object.assign({}, this.state, this.props, {
            onOntologyIdIsUnderFocus: this.onOntologyIdIsUnderFocus,
            onVisibleColumns: this.onVisibleColumns,
            ontologyIdsToHighlight: this.state.highlightColumns
        }), n = ri(t), s = this.props.anatomogramConfig.show ? {
            species: this.props.anatomogramConfig.species,
            showIds: n.xAxisCategories.map((o)=>o.id),
            highlightIds: n.xAxisCategories.map((o)=>o.id).filter((o)=>this.state.highlightIds.includes(o)),
            selectIds: [],
            onMouseOver: this.onTissueIdIsUnderFocus,
            onMouseOut: this.onTissueIdIsNotUnderFocus,
            // The SVG's EBI licence link; a falsy linkTarget leaves it as it is
            linkTarget: this.props.heatmapConfig.linkTarget || null
        } : null;
        return oi(t, n, s);
    }
}
Bn.propTypes = {
    allGenomeBrowsers: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string).isRequired,
    currentGenomeBrowser: (0, _propTypesDefault.default).string,
    // null when there are no genome browsers
    onChangeCurrentGenomeBrowser: (0, _propTypesDefault.default).func.isRequired,
    allOrderings: (0, _propTypesDefault.default).arrayOf(Ne),
    currentOrdering: Ne,
    onChangeCurrentOrdering: (0, _propTypesDefault.default).func.isRequired,
    allGroupedColumns: (0, _propTypesDefault.default).arrayOf(Z).isRequired,
    currentGroupedColumns: (0, _propTypesDefault.default).arrayOf(Z).isRequired,
    onChangeCurrentGroupedColumns: (0, _propTypesDefault.default).func.isRequired,
    allNumCoexpressions: (0, _propTypesDefault.default).number.isRequired,
    currentNumCoexpressions: (0, _propTypesDefault.default).number.isRequired,
    onChangeCurrentNumCoexpressions: (0, _propTypesDefault.default).func.isRequired,
    currentZoom: (0, _propTypesDefault.default).bool.isRequired,
    onChangeCurrentZoom: (0, _propTypesDefault.default).func.isRequired,
    //and also props that aren't controls, in particular:
    heatmapConfig: he.isRequired,
    heatmapData: oe.isRequired,
    colourAxis: fe,
    // Only available in experiment heatmap
    columnGroups: Ns,
    // The Download button: the query's genes, the default file name, and whether to show it
    download: (0, _propTypesDefault.default).shape({
        query: (0, _propTypesDefault.default).shape({
            genes: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string).isRequired
        }),
        fileName: (0, _propTypesDefault.default).string,
        show: (0, _propTypesDefault.default).bool
    })
};
const ii = (0, _uncontrollable.uncontrollable)(Bn, {
    currentGenomeBrowser: "onChangeCurrentGenomeBrowser",
    currentOrdering: "onChangeCurrentOrdering",
    currentGroupedColumns: "onChangeCurrentGroupedColumns",
    currentNumCoexpressions: "onChangeCurrentNumCoexpressions",
    currentZoom: "onChangeCurrentZoom"
}), $n = (e)=>{
    const { heatmapData: { yAxisCategories: t }, orderings: n, heatmapConfig: s, columnGroups: { data: o } } = e, a = Array.isArray(s.genomeBrowsers) && s.genomeBrowsers[0] ? s.genomeBrowsers[0].replace(/\s+/g, "").toLowerCase() : null;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(ii, {
        ...e,
        allGenomeBrowsers: s.genomeBrowsers,
        allOrderings: n,
        allGroupedColumns: o,
        allNumCoexpressions: s.coexpressionsAvailable ? t.length - 1 : 0,
        defaultCurrentGenomeBrowser: a,
        defaultCurrentOrdering: n[0],
        defaultCurrentGroupedColumns: o,
        defaultCurrentNumCoexpressions: 0,
        defaultCurrentZoom: !1
    });
};
$n.propTypes = {
    heatmapConfig: he.isRequired,
    heatmapData: oe.isRequired,
    orderings: (0, _propTypesDefault.default).arrayOf(Ne)
};
const ai = (0, _reactDefault.default).lazy(()=>require("8e2c54584eff9a0a"));
class _n extends (0, _reactDefault.default).Component {
    constructor(t){
        super(t), this.state = {
            chartType: "heatmap"
        }, this.handleClick = this._handleClick.bind(this);
    }
    _theOtherChartType() {
        return this.state.chartType === "heatmap" ? "boxplot and transcripts" : "heatmap";
    }
    _handleClick(t) {
        t.preventDefault(), this.setState({
            chartType: this._theOtherChartType()
        });
    }
    render() {
        return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
            style: {
                width: "100%"
            },
            children: [
                this.props.chartData.geneSpecificResults && /* @__PURE__ */ (0, _jsxRuntime.jsx)("a", {
                    href: "#",
                    onClick: this.handleClick,
                    children: `Show ${this._theOtherChartType()} view`
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        display: this.state.chartType === "heatmap" ? "block" : "none",
                        width: "100%"
                    },
                    children: /* @__PURE__ */ (0, _jsxRuntime.jsx)($n, {
                        ...this.props.chartData,
                        download: this.props.download
                    })
                }),
                this.props.chartData.geneSpecificResults && /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        display: this.state.chartType === "boxplot and transcripts" ? "block" : "none",
                        width: "100%"
                    },
                    children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                        fallback: null,
                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(ai, {
                            ...this.props.chartData.geneSpecificResults
                        })
                    })
                })
            ]
        });
    }
}
_n.propTypes = {
    chartData: Ls.isRequired,
    // The Download button's {query, fileName, show}
    download: (0, _propTypesDefault.default).object
};
const li = (0, _propTypesDefault.default).shape({
    assayGroupId: (0, _propTypesDefault.default).string.isRequired,
    factorValue: (0, _propTypesDefault.default).string.isRequired,
    factorValueOntologyTermId: (0, _propTypesDefault.default).string,
    // Some factors don’t have an ontology term... yet
    assayGroupSummary: (0, _propTypesDefault.default).shape({
        // Present when rows are genes
        replicates: (0, _propTypesDefault.default).number.isRequired,
        properties: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            propertyName: (0, _propTypesDefault.default).string.isRequired,
            testValue: (0, _propTypesDefault.default).string.isRequired,
            contrastPropertyType: (0, _propTypesDefault.default).oneOf([
                "FACTOR",
                "SAMPLE"
            ]).isRequired
        })).isRequired
    })
}), It = (0, _propTypesDefault.default).shape({
    id: (0, _propTypesDefault.default).string.isRequired,
    assayAccessions: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string).isRequired,
    replicates: (0, _propTypesDefault.default).number.isRequired
}), ci = (0, _propTypesDefault.default).shape({
    id: (0, _propTypesDefault.default).string.isRequired,
    arrayDesignAccession: (0, _propTypesDefault.default).string,
    // Present in microarray experiments
    referenceAssayGroup: It.isRequired,
    testAssayGroup: It.isRequired,
    displayName: (0, _propTypesDefault.default).string.isRequired,
    contrastSummary: (0, _propTypesDefault.default).shape({
        properties: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            propertyName: (0, _propTypesDefault.default).string.isRequired,
            testValue: (0, _propTypesDefault.default).string.isRequired,
            contrastPropertyType: (0, _propTypesDefault.default).oneOf([
                "FACTOR",
                "SAMPLE"
            ]).isRequired,
            referenceValue: (0, _propTypesDefault.default).string.isRequired
        })).isRequired,
        experimentDescription: (0, _propTypesDefault.default).string.isRequired,
        contrastDescription: (0, _propTypesDefault.default).string.isRequired,
        testReplicates: (0, _propTypesDefault.default).number.isRequired,
        referenceReplicates: (0, _propTypesDefault.default).number.isRequired
    }).isRequired,
    resources: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        type: (0, _propTypesDefault.default).string.isRequired,
        uri: (0, _propTypesDefault.default).string.isRequired
    })).isRequired
}), di = (0, _propTypesDefault.default).shape({
    id: (0, _propTypesDefault.default).string.isRequired,
    // Experiment accession
    experimentType: (0, _propTypesDefault.default).string.isRequired,
    name: (0, _propTypesDefault.default).string.isRequired,
    // Human-friendly exp. name with slice
    expressions: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        value: (0, _propTypesDefault.default).number
    })).isRequired,
    uri: (0, _propTypesDefault.default).string.isRequired
}), ui = (0, _propTypesDefault.default).shape({
    value: (0, _propTypesDefault.default).number,
    quartiles: (0, _propTypesDefault.default).shape({
        min: (0, _propTypesDefault.default).number.isRequired,
        lower: (0, _propTypesDefault.default).number.isRequired,
        median: (0, _propTypesDefault.default).number.isRequired,
        upper: (0, _propTypesDefault.default).number.isRequired,
        max: (0, _propTypesDefault.default).number.isRequired
    })
}), pi = (0, _propTypesDefault.default).shape({
    id: (0, _propTypesDefault.default).string.isRequired,
    // Gene ID
    name: (0, _propTypesDefault.default).string.isRequired,
    // Gene name
    expressions: (0, _propTypesDefault.default).arrayOf(ui).isRequired,
    uri: (0, _propTypesDefault.default).string.isRequired
}), Lt = (0, _propTypesDefault.default).shape({
    searchResultTotal: (0, _propTypesDefault.default).string.isRequired,
    rows: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOfType([
        di,
        pi
    ]))
}), mi = (0, _propTypesDefault.default).shape({
    maxDownLevel: (0, _propTypesDefault.default).number,
    maxUpLevel: (0, _propTypesDefault.default).number,
    minDownLevel: (0, _propTypesDefault.default).number,
    minUpLevel: (0, _propTypesDefault.default).number,
    rows: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        id: (0, _propTypesDefault.default).string.isRequired,
        name: (0, _propTypesDefault.default).string.isRequired,
        designElement: (0, _propTypesDefault.default).string,
        // Present but empty in RNA-seq differential exps; absent from Warelab payloads
        expressions: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            contrastName: (0, _propTypesDefault.default).string,
            // Absent from Warelab payloads
            color: (0, _propTypesDefault.default).string,
            foldChange: (0, _propTypesDefault.default).number,
            pValue: (0, _propTypesDefault.default).number,
            tStat: (0, _propTypesDefault.default).number
        })).isRequired
    })).isRequired,
    searchResultTotal: (0, _propTypesDefault.default).number
}), gi = (0, _propTypesDefault.default).shape({
    config: (0, _propTypesDefault.default).shape({
        geneQuery: (0, _propTypesDefault.default).string.isRequired,
        conditionQuery: (0, _propTypesDefault.default).string.isRequired,
        species: (0, _propTypesDefault.default).string.isRequired,
        genomeBrowsers: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string).isRequired,
        columnType: (0, _propTypesDefault.default).string.isRequired,
        disclaimer: (0, _propTypesDefault.default).string.isRequired
    }).isRequired,
    columnHeaders: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOfType([
        li,
        ci
    ])).isRequired,
    columnGroupings: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        name: (0, _propTypesDefault.default).string.isRequired,
        memberName: (0, _propTypesDefault.default).string.isRequired,
        groups: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            id: (0, _propTypesDefault.default).string.isRequired,
            name: (0, _propTypesDefault.default).string.isRequired,
            values: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string).isRequired
        }))
    })).isRequired,
    profiles: (0, _propTypesDefault.default).oneOfType([
        Lt,
        mi
    ]).isRequired,
    anatomogram: (0, _propTypesDefault.default).shape({
        allSvgPathIds: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string).isRequired,
        species: (0, _propTypesDefault.default).string.isRequired
    }),
    coexpressions: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        // Only present in baseline, single result
        geneName: (0, _propTypesDefault.default).string.isRequired,
        geneId: (0, _propTypesDefault.default).string.isRequired,
        jsonProfiles: Lt
    })),
    experiment: ln
}), hi = (e, t)=>{
    const n = t.rows.length, s = +(t.searchResultTotal || n), o = (e ? e.type.toUpperCase().includes("PROTEOMICS") ? "protein" : "gene" : "experiment") + (s > 1 ? "s" : "");
    return n > 0 ? `Showing ${Ie(n)} ` + (s === n ? o + ":" : `of ${Ie(s)} ${o} found:`) : "";
}, ke = (e)=>decodeURIComponent(e.replace(/\+/g, "%20")), fi = ({ geneQuery: e, conditionQuery: t, species: n })=>{
    const s = ke(e), o = ke(t), a = ke(n);
    return [
        `Query results for: ${s}` + (o ? `, in conditions ${o}` : "") + (a ? `, in species ${a[0].toUpperCase() + a.slice(1).toLowerCase()}` : "")
    ];
}, xi = ({ geneQuery: e, experiment: { description: t, accession: n } })=>{
    const s = ke(e);
    return [].concat([
        `Experiment accession: ${n}`
    ], // description can be empty, see ExperimentsCacheLoader.java or BaselineExperimentsBuilder.java
    t ? [
        t
    ] : [], s ? [
        `Gene query: ${s}`
    ] : []);
}, yi = (e, t, n, s, o, a, { linkTarget: i = "_blank", urlFor: c = se } = {})=>{
    const { experiment: d, profiles: m } = e, { species: u, disclaimer: p, columnType: h } = e.config, x = {
        introductoryMessage: hi(d, m),
        xAxisLegendName: Hs(h) || "Experimental condition",
        yAxisLegendName: _(d) ? "Experiment" : "Gene name"
    }, f = (_(d) ? fi : xi)(Object.assign({}, e, e.config)), y = _(d) ? `expression_atlas-${u.replace(/ +/, "_")}` : d.accession;
    return Object.freeze({
        inProxy: t,
        outProxy: n,
        atlasUrl: s,
        linkTarget: i,
        urlFor: c,
        experiment: d,
        isWidget: o,
        showControlMenu: a,
        description: f,
        shortDescription: y,
        disclaimer: p,
        ...x,
        genomeBrowsers: e.config.genomeBrowsers,
        coexpressionsAvailable: !!e.coexpressions,
        isMultiExperiment: _(d),
        isBaseline: rt(d),
        isDifferential: Fe(d)
    });
}, bi = ({ rowInfo: e, rowIndex: t, expression: n, expressionIndex: s })=>n.hasOwnProperty("value") ? {
        x: s,
        y: t,
        value: n.value,
        info: e
    } : n.hasOwnProperty("foldChange") ? {
        x: s,
        y: t,
        value: n.foldChange,
        info: {
            pValue: n.pValue,
            foldChange: n.foldChange,
            tStat: n.tStat,
            ...e
        }
    } : null, Dn = ({ rowInfo: e, row: { expressions: t }, rowIndex: n })=>t.map((s, o)=>bi({
            rowInfo: e,
            rowIndex: n,
            expression: s,
            expressionIndex: o
        })).filter((s)=>s), Ci = (e)=>e.map((t, n)=>[
            t.experimentType,
            Dn({
                rowInfo: {
                    type: t.experimentType,
                    description: t.name,
                    unit: t.expressionUnit
                },
                row: t,
                rowIndex: n
            })
        ]).groupBy((t)=>t[0]).mapValues((t)=>t.map((n)=>n[1])).mapValues((0, _lodashDefault.default).flatten).toPairs(), wi = (e)=>(t, n)=>n.map((s)=>[
                (0, _lodashDefault.default).sortedIndex(e[t] || e.DEFAULT, s.value),
                s
            ]), vi = (e, t, n, s)=>Vn(t, n)(// Get lodash wrapper of the experiment type / data points array
    Ci((0, _lodashDefault.default).chain(s)).map((0, _lodashDefault.default).spread(wi(e))).flatten()).value();
function Ri(e, t, n) {
    if (!e.length) return [];
    const s = e.map((m)=>Math.log(m.value + 1)), o = Math.min(...s), a = Math.max(...s), i = Math.min(t.length, n.length), c = (a + 1 - o) / i, d = t.slice(0, i).map((m, u)=>({
            info: {
                name: m,
                colour: n[u],
                thresholds: []
            },
            data: []
        }));
    return e.forEach((m, u)=>{
        const p = Math.log(m.value + 1);
        let h = Math.floor((p - o) / c);
        h >= i && (h = i - 1), d[h].data.push(m);
    }), d;
}
const qi = (e, t, n)=>{
    const s = e.map((i)=>i.value).sort((i, c)=>i - c), o = e.length, a = t.length;
    return Vn(t, n)((0, _lodashDefault.default).chain(e).map((i)=>[
            Math.floor((0, _lodashDefault.default).sortedIndex(s, i.value) / o * a),
            i
        ])).value();
}, Mt = (e, t, n, s, o, a)=>{
    const i = (0, _lodashDefault.default).flatten(e.map((c, d)=>Dn({
            rowInfo: {
                unit: c.expressionUnit
            },
            row: c,
            rowIndex: d
        })));
    return a ? (0, _lodashDefault.default).flatten((0, _lodashDefault.default).range(n.length).map((c)=>qi(i.filter(n[c]), s[c], o[c]))) : (0, _lodashDefault.default).flatten((0, _lodashDefault.default).range(n.length).map((c)=>Ri(i.filter(n[c]), s[c], o[c])));
}, Vn = (0, _lodashDefault.default).curry((e, t, n)=>n.groupBy((s)=>s[0]).mapValues((s)=>s.map((o)=>o[1])).transform((s, o, a)=>{
        s[a].data = o;
    }, // The _bucketsIntoSeriesempty with the series info but no data points
    (0, _lodashDefault.default).range(e.length).map((s)=>({
            info: {
                name: e[s],
                colour: t[s]
            },
            data: []
        })))), Ai = (e, t)=>{
    const n = [
        (0, _lodashDefault.default).lt,
        (0, _lodashDefault.default).eq,
        (0, _lodashDefault.default).gt
    ].map((o)=>(a)=>o(a.value, 0)), s = n[1];
    return Fe(t) ? Mt(e, t, n, [
        [
            "High down",
            "Down"
        ],
        [
            "Below cutoff"
        ],
        [
            "Up",
            "High up"
        ]
    ], [
        [
            "#0000ff",
            "#8cc6ff"
        ],
        [
            "gainsboro"
        ],
        [
            "#e9967a",
            "#b22222"
        ]
    ], !0) : rt(t) ? Mt(e, t, [
        s,
        (0, _lodashDefault.default).negate(s)
    ], [
        [
            "Below cutoff"
        ],
        [
            "Low",
            "Low-Medium",
            "Medium",
            "Medium-High",
            "High"
        ]
    ], [
        [
            "gainsboro"
        ],
        [
            "#e3f2fd",
            "#90caf9",
            "#42a5f5",
            "#1976d2",
            "#0d47a1"
        ]
    ], !1) : _(t) ? vi({
        RNASEQ_MRNA_BASELINE: [
            0,
            10,
            1e3
        ],
        PROTEOMICS_BASELINE: [
            0,
            1e-3,
            8
        ],
        DEFAULT: [
            0,
            10,
            1e3
        ]
    }, [
        "Below cutoff",
        "Low",
        "Medium",
        "High"
    ], [
        "#eaeaea",
        "#45affd",
        "#1E74CA",
        "#024990"
    ], e) : null;
}, Ti = ({ columnHeaders: e, experiment: t })=>_(t) ? e.map((n)=>({
            label: n.factorValue,
            id: n.factorValueOntologyTermId || "",
            info: {
                trackId: "",
                tooltip: {}
            }
        })) : Fe(t) ? e.map((n)=>({
            label: n.displayName,
            id: n.id,
            info: {
                trackId: n.id,
                tooltip: {
                    ...n.contrastSummary
                }
            }
        })) : e.map((n)=>({
            label: n.factorValue,
            id: n.factorValueOntologyTermId || "",
            info: {
                trackId: n.assayGroupId,
                tooltip: {
                    properties: n.assayGroupSummary.properties,
                    replicates: n.assayGroupSummary.replicates
                }
            }
        })), Si = ({ rows: e, inProxy: t, atlasUrl: n })=>e.map((s)=>({
            label: s.name,
            id: s.id,
            info: {
                trackId: s.id,
                designElement: s.designElement || "",
                url: (0, _urijsDefault.default)(s.uri, t + n).toString(),
                uri: s.uri,
                experimentType: s.experimentType
            }
        })), ki = ({ allRows: e, geneQuery: t, columnHeaders: n, experiment: s, inProxy: o, atlasUrl: a })=>({
        xAxisCategories: co(Ti({
            columnHeaders: n,
            experiment: s
        })),
        yAxisCategories: Si({
            rows: e,
            inProxy: o,
            atlasUrl: a
        }),
        dataSeries: Ai(e, s)
    }), Xe = (e, t, n)=>n.map((s, o)=>[
            s,
            o
        ]).sort((s, o)=>e[s[1]] - e[o[1]] || t(s[0], o[0])).map((s)=>s[1]), Ve = (e, t)=>Xe(t.map((0, _lodashDefault.default).constant(0)), Je(e), t), Je = (0, _lodashDefault.default).curry((e, t, n)=>t[e].localeCompare(n[e])), Oi = (e)=>(0, _lodashDefault.default).chain(e).map((t)=>t.map((n)=>+n.hasOwnProperty("value"))).thru((0, _lodashDefault.default).spread((0, _lodashDefault.default).zip)).map((t)=>t.map((n, s)=>n * (s + 1)).filter((0, _lodashDefault.default).identity)).map((0, _lodashDefault.default).min).value(), jn = (e)=>e.length ? e[0].length : Number.MAX_VALUE, Ni = (e)=>Ze(e, 0).map((t)=>t === jn(e) ? 1 : 0), Ze = (e, t)=>{
    const n = typeof t == "number" ? (s)=>s.hasOwnProperty("value") && !isNaN(s.value) && Math.abs(s.value) > t : (s)=>s.hasOwnProperty("value") && !isNaN(s.value);
    return (0, _lodashDefault.default).chain(e).map((s)=>{
        const o = (0, _lodashDefault.default).uniq(s.filter(n).map((a)=>a.value).sort((a, i)=>i - a));
        return s.map((a)=>n(a) ? o.indexOf(a.value) : "missing");
    }).thru((0, _lodashDefault.default).spread((0, _lodashDefault.default).zip)).map((s)=>s.filter((0, _lodashDefault.default).negate(isNaN))).map((s)=>s.length ? (0, _lodashDefault.default).sum(s) / s.length : jn(e)).value();
}, Ft = (e, t)=>t.map((n)=>n.map((s)=>+(s.hasOwnProperty("value") && s.value !== 0))).reduce(function(n, s) {
        return n.map((o, a)=>o + s[a], (0, _lodashDefault.default).fill(Array(t.length ? t[0].length : 0), 0));
    }, []).map((n)=>n > t.length * e ? 0 : 1), je = (e)=>e.map((t, n)=>n), Pt = (e)=>(0, _lodashDefault.default).chain(e).map((t)=>t[0].map((n)=>n * t[1])).thru((0, _lodashDefault.default).spread((0, _lodashDefault.default).zip)).map((0, _lodashDefault.default).sum).value(), Ei = (e, t, n, s)=>{
    const o = (0, _lodashDefault.default).zip.apply((0, _lodashDefault.default), e);
    return _(s) ? [
        {
            name: "By experiment type",
            columns: Ve("factorValue", t),
            rows: je(n)
        },
        {
            name: "Alphabetical order",
            columns: Ve("factorValue", t),
            rows: Ve("name", n)
        },
        {
            name: "Expression rank",
            columns: Xe(Pt([
                [
                    Oi(e),
                    1
                ],
                [
                    Ze(e),
                    1e3
                ],
                [
                    Ft(0.05 + 0.4 / Math.pow(1 + o.length / 8, 0.4), e),
                    1e6
                ],
                [
                    Ni(e),
                    1e7
                ]
            ]), Je("factorValue"), t),
            rows: Xe(Pt([
                [
                    Ze(o),
                    1e3
                ],
                [
                    Ft(0.05 + 0.4 / (1 + e.length / 5), o),
                    1e6
                ]
            ]), Je("name"), n)
        }
    ] : [
        {
            name: "Default",
            columns: je(t),
            rows: je(n)
        }
    ];
}, Ii = (e, t)=>{
    const n = (s)=>(o)=>o.hasOwnProperty(s) ? {
                value: o[s]
            } : {};
    return e.map((s)=>s.expressions.map(n(Fe(t) ? "foldChange" : "value")));
}, Li = (e, t, n)=>Ei(Ii(t, e), n, t, e), Ht = (e)=>e.isLight() ? (0, _colorDefault.default)(e).lighten(0.5) : (0, _colorDefault.default)(e).saturate(0.3).darken(0.5), Mi = (e)=>{
    let t = e.map((i)=>i.data.length === 0 && i.info.name === "Below cutoff" ? {
            data: [
                {
                    value: 0
                }
            ],
            colour: i.info.colour
        } : {
            data: i.data,
            colour: i.info.colour
        }).filter((i)=>i.data.length > 0).map((i, c, d)=>{
        const m = i.data.map((u)=>u.value);
        return m.sort((u, p)=>u - p), {
            min: m[0],
            minColour: c === 0 ? Ht((0, _colorDefault.default)(d[c].colour)) : (0, _colorDefault.default)(d[c].colour).mix((0, _colorDefault.default)(d[c - 1].colour)),
            max: m[m.length - 1],
            maxColour: c === d.length - 1 ? Ht((0, _colorDefault.default)(d[c].colour)) : (0, _colorDefault.default)(d[c].colour).mix((0, _colorDefault.default)(d[c + 1].colour)),
            median: m[Math.floor(i.data.length / 2)],
            medianColour: (0, _colorDefault.default)(d[c].colour),
            sortedValues: m
        };
    });
    const n = (i)=>i.sortedValues.length > 3 && i.sortedValues[0] !== i.sortedValues[i.sortedValues.length - 1] && i.minColour.rgb().string() !== i.maxColour.rgb().string(), s = (i)=>[
            {
                min: i.min,
                minColour: i.minColour,
                max: i.median,
                maxColour: i.medianColour,
                median: i.sortedValues[Math.floor(i.sortedValues.length / 4)],
                medianColour: (0, _colorDefault.default)(i.minColour).mix(i.medianColour),
                sortedValues: i.sortedValues.slice(0, Math.floor(i.sortedValues.length / 2))
            },
            {
                min: i.median,
                minColour: i.medianColour,
                max: i.max,
                maxColour: i.maxColour,
                median: i.sortedValues[Math.floor(3 * i.sortedValues.length / 4)],
                medianColour: (0, _colorDefault.default)(i.medianColour).mix(i.maxColour),
                sortedValues: i.sortedValues.slice(Math.floor(i.sortedValues.length / 2))
            }
        ];
    let o = Number.MIN_VALUE, a = t.length;
    for(; o < a;)t = [].concat.apply([], t.map(function(i) {
        return n(i) ? s(i) : [
            i
        ];
    })), o = a, a = t.length;
    return t.map((i)=>({
            from: i.min,
            to: i.max,
            color: i.medianColour.hex()
        }));
}, Fi = (e)=>[].concat.apply([], e.map((t)=>t.data)).map((t)=>t.info.unit).filter((t)=>t).filter((t, n, s)=>s.indexOf(t) === n).join(), Pi = (e, t)=>_(e) ? null : {
        dataClasses: Mi(t),
        unit: Fi(t)
    }, Hi = ({ columnGroupings: e, id: t })=>e.map((n)=>{
        const s = n.groups.filter((o)=>o.values.includes(t)).map((o)=>({
                label: o.name,
                id: o.id
            }));
        return {
            name: n.name,
            memberName: n.memberName,
            values: s.length ? s : [
                {
                    label: "Unmapped",
                    id: ""
                }
            ]
        };
    }), Gn = {
    name: "All",
    disabled: !1
}, Bi = {
    name: "None",
    disabled: !1
}, $i = ({ xAxisCategories: e, dataSeries: t, columnGroupings: n })=>e.map((s, o)=>({
            value: s.label,
            categories: [].concat.apply([
                Gn.name
            ], t.filter((a)=>a.data.some((i)=>i.x === o)).map((a)=>a.info.name)),
            groupings: Hi({
                columnGroupings: n,
                id: s.id
            })
        })), _i = ({ heatmapData: { xAxisCategories: e, dataSeries: t }, columnGroupings: n })=>({
        //this could be inferred but is convenient to pass through
        groupingNames: n.map((s)=>s.name),
        //This can't be inferred from the data later, because there might not be any columns with some category
        //(Happens when there's an empty data series)
        categories: [].concat([
            Gn
        ], [
            Bi
        ]),
        categoryCheckboxes: [].concat.apply([], t.map((s)=>({
                name: s.info.name,
                disabled: !s.data.length
            })).reverse()),
        data: $i({
            xAxisCategories: e,
            dataSeries: t,
            columnGroupings: n
        })
    });
function zn({ data: e, inProxy: t, outProxy: n, atlasUrl: s, showAnatomogram: o, showControlMenu: a, isWidget: i, linkTarget: c, urlFor: d }) {
    const m = e.coexpressions ? e.profiles.rows.concat(e.coexpressions[0].jsonProfiles.rows) : e.profiles.rows, u = ki(Object.assign({}, e, {
        allRows: m,
        geneQuery: e.config.geneQuery,
        inProxy: t,
        atlasUrl: s
    })), p = e.anatomogram ? (0, _grameneAnatomogram.normaliseSpecies)(e.anatomogram.species) : "", h = {
        show: o && !!e.anatomogram && (0, _grameneAnatomogram.anatomogramSpecies).includes(p),
        species: p,
        anatomogramData: e.anatomogram,
        expressedTissueColour: e.experiment ? "gray" : "red",
        hoveredTissueColour: e.experiment ? "red" : "purple"
    }, x = e.experiment && e.experiment.urls && e.experiment.urls.gene_specific_results ? {
        url: t + (0, _urijsDefault.default)(e.experiment.urls.gene_specific_results, s).toString(),
        keepOnlyTheseColumnIds: e.columnHeaders.map((f)=>f.assayGroupId).filter((f, y, R)=>R.indexOf(f) === y).filter((f)=>f)
    } : null;
    return {
        anatomogramConfig: h,
        heatmapData: u,
        geneSpecificResults: x,
        heatmapConfig: yi(e, t, n, s, i, a, {
            linkTarget: c,
            urlFor: d
        }),
        colourAxis: Pi(e.experiment, u.dataSeries),
        orderings: Li(e.experiment, m, e.columnHeaders),
        columnGroups: _i({
            heatmapData: u,
            columnGroupings: e.columnGroupings
        })
    };
}
const Un = (e)=>{
    const { data: t, inProxy: n, outProxy: s, atlasUrl: o, showAnatomogram: a, showControlMenu: i, isWidget: c, linkTarget: d, source: m } = e, { geneQuery: u, conditionQuery: p, species: h } = t.config, x = e.urlFor || se, f = t.experiment ? t.experiment.accession : null, y = (0, _react.useCallback)((v, N, D)=>x(v, N, {
            experiment: f,
            ...D
        }), [
        x,
        f
    ]), R = (0, _react.useMemo)(()=>zn({
            data: t,
            inProxy: n,
            outProxy: s,
            atlasUrl: o,
            showAnatomogram: a,
            showControlMenu: i,
            isWidget: c,
            linkTarget: d,
            urlFor: y
        }), [
        t,
        n,
        s,
        o,
        a,
        i,
        c,
        d,
        y
    ]), S = JSON.stringify(m || null), k = (0, _react.useMemo)(()=>({
            query: vs(m),
            fileName: e.downloadFileName,
            show: e.showDownload !== !1
        }), [
        S,
        e.downloadFileName,
        e.showDownload
    ]), b = t.experiment ? // single experiment?
    (0, _urijsDefault.default)(t.experiment.urls.main_page, o) : (0, _urijsDefault.default)(o).segment("query").search({
        geneQuery: u,
        conditionQuery: p,
        species: h
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        style: {
            width: "100%"
        },
        children: [
            c && t.experiment && /* @__PURE__ */ (0, _jsxRuntime.jsx)(Wt, {
                linkTarget: d,
                experimentUrl: y("experiment", s + (0, _urijsDefault.default)(t.experiment.urls.main_page, o).toString(), {}),
                description: t.experiment.description
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(_n, {
                chartData: R,
                download: k
            }),
            c && /* @__PURE__ */ (0, _jsxRuntime.jsx)(Kt, {
                linkTarget: d,
                atlasUrl: y("atlas", s + o, {}),
                moreInformationUrl: y("moreInformation", s + b.toString(), {
                    config: t.config
                }),
                supportUrl: y("support", Ut, {})
            })
        ]
    });
};
Un.propTypes = {
    inProxy: (0, _propTypesDefault.default).string.isRequired,
    outProxy: (0, _propTypesDefault.default).string.isRequired,
    atlasUrl: (0, _propTypesDefault.default).string.isRequired,
    showAnatomogram: (0, _propTypesDefault.default).bool.isRequired,
    isWidget: (0, _propTypesDefault.default).bool.isRequired,
    linkTarget: (0, _propTypesDefault.default).string,
    urlFor: (0, _propTypesDefault.default).func,
    source: (0, _propTypesDefault.default).shape({
        endpoint: (0, _propTypesDefault.default).string.isRequired,
        params: (0, _propTypesDefault.default).object.isRequired
    }),
    downloadFileName: (0, _propTypesDefault.default).string,
    showDownload: (0, _propTypesDefault.default).bool,
    data: gi.isRequired
};
const Di = (e)=>!!e && (e.value !== void 0 && e.value !== null || e.foldChange !== void 0 && e.foldChange !== null), Vi = (e, t)=>{
    if (typeof t != "function" || !e || !e.profiles || !Array.isArray(e.profiles.rows)) return null;
    const n = e.profiles.rows, s = n.reduce((i, c, d)=>t(c) ? i.concat(d) : i, []);
    if (s.length === n.length) return null;
    const a = (e.columnHeaders || []).map((i, c)=>c).filter((i)=>s.some((c)=>Di((n[c].expressions || [])[i])));
    return {
        rows: s,
        columns: a
    };
}, ji = (e, t)=>{
    if (e == null || e === "") return e;
    const n = Math.max(0, Number(e) - t);
    return Number.isNaN(n) ? e : typeof e == "number" ? n : String(n);
}, Gi = (e, { rows: t, columns: n })=>{
    const s = e.profiles.rows, o = e.columnHeaders || [], a = n.length === o.length, i = (c)=>a || !Array.isArray(c) ? c : n.map((d)=>c[d]);
    return {
        ...e,
        columnHeaders: i(o),
        profiles: {
            ...e.profiles,
            rows: t.map((c)=>{
                const d = s[c];
                return a ? d : {
                    ...d,
                    expressions: i(d.expressions)
                };
            }),
            searchResultTotal: ji(e.profiles.searchResultTotal, s.length - t.length)
        }
    };
}, zi = (e, t)=>{
    const n = Vi(e, t), s = n ? JSON.stringify(n) : "";
    return {
        data: (0, _react.useMemo)(()=>n ? Gi(e, n) : e, [
            e,
            s
        ]),
        key: s,
        filtered: !!n
    };
}, Ui = (e)=>e ? e === "reference" ? "json/baseline_refexperiment" : `json/experiments/${e}` : "json/baseline_experiments", Wn = ({ query: e, experiment: t })=>typeof e == "string" ? {
        endpoint: e,
        params: {}
    } : {
        endpoint: Ui(t),
        params: e ? Object.entries(e).map((n)=>[
                "gene",
                "condition"
            ].includes(n[0]) ? [
                n[0] + "Query",
                n[1]
            ] : n).reduce((n, s)=>(n[s[0]] = s[1], n), {}) : {}
    }, Wi = (e)=>Object.entries(e).map((t)=>`${t[0]}=${typeof t[1] == "string" ? t[1] : JSON.stringify(t[1])}`).join("&"), dt = ({ inProxy: e = "", atlasUrl: t, source: n })=>({
        url: e + (0, _urijsDefault.default)(n.endpoint, t).toString(),
        method: "POST",
        //the webapp also supports GET - we do POST in case the parameters get very large
        headers: {
            // react-refetch's default Accept header
            Accept: "application/json",
            //the Atlas webapp is based on Spring; given this header it'll understand the body content to be equivalent to query parameters
            "Content-Type": "application/x-www-form-urlencoded"
        },
        body: Wi(n.params)
    }), xe = ({ method: e, url: t, body: n })=>`${e} ${t}
${n || ""}`, Ki = Object.freeze({
    credentials: "same-origin",
    mode: "cors",
    redirect: "follow"
}), Qi = (e)=>e.headers.get("content-length") === "0" || e.status === 204 ? Promise.resolve(null) : e.status >= 200 && e.status < 300 ? e.json() : e.json().then((t)=>{
        throw new Error(t && (t.error || t.message) || "");
    }, ()=>{
        throw new Error(`${e.status} ${e.statusText || ""}`.trim());
    }), Xi = (e, t)=>({
        pending: !0,
        fulfilled: !1,
        rejected: !1,
        settled: !1,
        value: null,
        reason: null,
        key: e,
        meta: {
            request: t
        }
    }), Ji = (e)=>!!e && e.name === "AbortError", Kn = (e)=>{
    const t = e ? xe(e) : null, [n, s] = (0, _react.useState)(null);
    return (0, _react.useEffect)(()=>{
        if (!e) return;
        let o = !0;
        const a = typeof AbortController == "function" ? new AbortController() : null;
        return fetch(e.url, {
            ...Ki,
            method: e.method || "GET",
            headers: e.headers,
            body: e.body,
            signal: a ? a.signal : void 0
        }).then((i)=>Qi(i).then((c)=>({
                    response: i,
                    value: c
                }))).then(({ response: i, value: c })=>{
            o && s({
                pending: !1,
                fulfilled: !0,
                rejected: !1,
                settled: !0,
                value: c,
                reason: null,
                key: t,
                meta: {
                    request: e,
                    response: i
                }
            });
        }, (i)=>{
            o && !Ji(i) && s({
                pending: !1,
                fulfilled: !1,
                rejected: !0,
                settled: !0,
                value: null,
                reason: i,
                key: t,
                meta: {
                    request: e
                }
            });
        }), ()=>{
            o = !1, a && a.abort();
        };
    }, [
        t
    ]), n && n.key === t ? n : Xi(t, e);
}, Qn = ()=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        role: "status",
        style: {
            padding: "1rem 0"
        },
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Spinner), {
                animation: "border",
                size: "sm",
                "aria-hidden": "true",
                style: {
                    marginRight: "0.5rem",
                    verticalAlign: "middle"
                }
            }),
            "Loading expression data\u2026"
        ]
    }), Zi = "There was a problem contacting the Expression Atlas server. Please try again in a few seconds.", Yi = "Sorry, no results could be found matching your query.", Xn = (e)=>e.pending ? {
        loading: !0
    } : e.value === null ? {
        // It’s interesting to note that on an empty response Firefox reports the promise as rejected but Chrome does not
        failure: e.rejected ? e.reason.message : `request to ${e.meta.request.url} failed`
    } : e.value.error ? {
        failure: String(e.value.error)
    } : e.value.profiles ? {
        data: e.value
    } : {
        noResults: !0
    }, Jn = ({ fail: e, request: t, key: n, failure: s })=>{
    const o = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        s === void 0 || o.current === n || (o.current = n, e && e({
            url: t.url,
            method: t.method,
            message: s
        }));
    }, [
        n,
        s
    ]);
}, ut = ({ failure: e, linkTarget: t, urlFor: n })=>/* @__PURE__ */ (0, _jsxRuntime.jsx)(me, {
        error: {
            description: Zi,
            name: "Error",
            message: e
        },
        linkTarget: t,
        urlFor: n
    });
ut.propTypes = {
    failure: (0, _propTypesDefault.default).string.isRequired,
    linkTarget: (0, _propTypesDefault.default).string,
    urlFor: (0, _propTypesDefault.default).func
};
const Zn = ()=>/* @__PURE__ */ (0, _jsxRuntime.jsx)(me, {
        variant: "info",
        error: {
            description: Yi
        }
    }), Yn = (e)=>{
    const { inProxy: t, atlasUrl: n, source: s, fail: o, linkTarget: a, urlFor: i, filterRows: c, ...d } = e, m = dt({
        inProxy: t,
        atlasUrl: n,
        source: s
    }), u = (0, _react.useMemo)(()=>m, [
        xe(m)
    ]), p = Kn(u), h = Xn(p), x = zi(h.data, c);
    return Jn({
        fail: o,
        request: u,
        key: p.key,
        failure: h.failure
    }), h.loading ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(Qn, {}) : h.failure !== void 0 ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(ut, {
        failure: h.failure,
        linkTarget: a,
        urlFor: i
    }) : h.noResults || x.filtered && x.data.profiles.rows.length === 0 ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(Zn, {}) : /* @__PURE__ */ (0, _jsxRuntime.jsx)(Un, {
        ...d,
        inProxy: t,
        atlasUrl: n,
        source: s,
        fail: o,
        linkTarget: a,
        urlFor: i,
        data: x.data
    }, `${p.key}
${x.key}`);
};
Yn.propTypes = {
    inProxy: (0, _propTypesDefault.default).string.isRequired,
    atlasUrl: (0, _propTypesDefault.default).string.isRequired,
    source: (0, _propTypesDefault.default).shape({
        endpoint: (0, _propTypesDefault.default).string.isRequired,
        params: (0, _propTypesDefault.default).object.isRequired
    }).isRequired,
    fail: (0, _propTypesDefault.default).func,
    linkTarget: (0, _propTypesDefault.default).string,
    urlFor: (0, _propTypesDefault.default).func,
    filterRows: (0, _propTypesDefault.default).func,
    downloadFileName: (0, _propTypesDefault.default).string,
    showDownload: (0, _propTypesDefault.default).bool
};
class pt extends (0, _reactDefault.default).Component {
    constructor(t){
        super(t), this.state = {
            error: null
        }, this.reported = !1;
    }
    static getDerivedStateFromError(t) {
        return {
            error: t
        };
    }
    componentDidCatch(t) {
        if (this.reported) return;
        this.reported = !0;
        const { fail: n, request: s } = this.props;
        n && n({
            url: s ? s.url : "",
            method: s ? s.method : "",
            message: t && t.message !== void 0 ? t.message : String(t)
        });
    }
    render() {
        const { error: t } = this.state;
        return t ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(me, {
            error: {
                description: "There was a problem displaying the expression data.",
                name: t && t.name || "Error",
                message: t && t.message !== void 0 ? t.message : String(t)
            },
            linkTarget: this.props.linkTarget,
            urlFor: this.props.urlFor
        }) : this.props.children;
    }
}
pt.propTypes = {
    fail: (0, _propTypesDefault.default).func,
    request: (0, _propTypesDefault.default).shape({
        url: (0, _propTypesDefault.default).string,
        method: (0, _propTypesDefault.default).string
    }),
    linkTarget: (0, _propTypesDefault.default).string,
    urlFor: (0, _propTypesDefault.default).func,
    children: (0, _propTypesDefault.default).node
};
const er = "https://www.ebi.ac.uk/gxa/", tr = (e, t)=>Object.entries(t).reduce((n, [s, o])=>(o !== void 0 && (n[s] = o), n), {
        ...e
    }), nr = (e)=>e && !e.endsWith("/") ? `${e}/` : e, rr = (e, t)=>{
    const n = (0, _react.useRef)(null);
    return n.current = {
        resolveUrl: e,
        baseContext: t
    }, (0, _react.useCallback)((s, o, a)=>{
        const { resolveUrl: i, baseContext: c } = n.current;
        return $r(i, s, o, {
            ...c,
            ...a
        });
    }, []);
}, ea = ".gxaHeatmapContainer .highcharts-container,.gxaHeatmapContainer svg{overflow:visible!important}.gxaHeatmapContainer a{text-decoration:none}.gxaHeatmapContainer .gxa-legend{color:#606060;text-align:right}.gxaHeatmapContainer .gxa-legend-item{display:inline-block;margin-left:8px;padding:4px;vertical-align:middle;cursor:default}.gxaHeatmapContainer .gxa-legend-item--off{color:#ccc}.gxaHeatmapContainer .gxa-legend-swatch{display:inline-block;width:12px;height:12px;margin-right:4px;border:1px solid rgba(0,0,0,.2);vertical-align:middle}.gxaHeatmapContainer .gxa-va-middle{vertical-align:middle}.gxaHeatmapContainer .gxa-info-icon{color:#7e7e7e;font-size:150%;vertical-align:middle}.gxa-heatmap-modal .gxa-filter-option-name{display:inline-block;padding:0 0 0 5px;background:none;border:0;color:inherit;font:inherit;text-align:left}.gxa-heatmap-modal button.gxa-filter-option-name{cursor:pointer}.gxa-heatmap-modal .gxa-filter-option-label{display:inline-block}.gxa-heatmap-modal .gxa-filter-option-label:first-letter{text-transform:capitalize}.gxa-heatmap-modal .gxa-download-disclaimer{max-height:40vh;overflow-y:auto;padding:.5rem .75rem;border:1px solid #dee2e6;border-radius:.375rem;font-size:.875rem}.gxa-heatmap-modal .gxa-download-disclaimer h3{font-size:1.1rem}.gxa-heatmap-modal .gxa-download-disclaimer h4{font-size:1rem}.gxa-heatmap-modal .gxa-download-saved-as code{word-break:break-all}.gxaHeatmapContainer .gxa-range-marks{position:relative;height:1.5em;font-size:.75rem;color:#606060}.gxaHeatmapContainer .gxa-range-mark{position:absolute;top:0;transform:translate(-50%)}.gxaHeatmapContainer .gxa-visually-hidden{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important}.gxaHeatmapContainer .gxa-grid{position:relative;display:inline-block;max-width:100%;vertical-align:top;font-size:12px;color:#333}.gxaHeatmapContainer .gxa-grid-toolbar{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:.25rem 1rem;margin-bottom:.25rem}.gxaHeatmapContainer .gxa-grid-controls{display:flex;flex-wrap:wrap;align-items:center;gap:.5rem .75rem}.gxaHeatmapContainer .gxa-grid-axis-choice{display:flex;align-items:center;gap:.375rem}.gxaHeatmapContainer .gxa-grid-axis-choice .form-select{width:auto;max-width:16rem}.gxaHeatmapContainer .gxa-grid-legend{display:flex;flex-wrap:wrap;align-items:center;margin-left:auto;color:#606060}.gxaHeatmapContainer .gxa-grid-scroll{max-width:100%;overflow-x:auto}.gxaHeatmapContainer .gxa-grid-table{border-collapse:separate;border-spacing:2px}.gxaHeatmapContainer .gxa-grid-table :where(th),.gxaHeatmapContainer .gxa-grid-table :where(td){border:0}.gxaHeatmapContainer .gxa-grid-table caption{caption-side:top;padding:0 2px .25rem;color:#555;text-align:left}.gxaHeatmapContainer .gxa-grid-axis{padding:0 2px 2px;color:#555;font-weight:600;white-space:nowrap}.gxaHeatmapContainer .gxa-grid-axis--columns{text-align:left;border-bottom:1px solid rgb(192,192,192)}.gxaHeatmapContainer .gxa-grid-axis--rows{text-align:right;vertical-align:bottom;padding-right:6px}.gxaHeatmapContainer .gxa-grid-col{padding:2px 0;font-weight:400;text-align:center;vertical-align:bottom;white-space:nowrap}.gxaHeatmapContainer .gxa-grid-col--vertical .gxa-grid-col-label{display:inline-block;max-height:12rem;overflow:hidden;text-overflow:ellipsis;writing-mode:vertical-rl;transform:rotate(180deg)}.gxaHeatmapContainer .gxa-grid-row{padding:0 6px 0 0;font-weight:400;text-align:right;white-space:nowrap}.gxaHeatmapContainer .gxa-grid-row-label{display:inline-block;max-width:20rem;overflow:hidden;text-overflow:ellipsis;vertical-align:middle}.gxaHeatmapContainer .gxa-grid-cell{position:relative;height:32px;padding:0;background:#fff}.gxaHeatmapContainer .gxa-grid-bands{position:absolute;inset:0;display:flex;gap:1px}.gxaHeatmapContainer .gxa-grid-band{flex:1 1 0;min-width:4px;cursor:default}.gxaHeatmapContainer .gxa-grid-no-data{background:repeating-linear-gradient(135deg,#ebebeb 0 3px,#fafafa 3px 6px)}.gxaHeatmapContainer .gxa-grid-band:hover,.gxaHeatmapContainer .gxa-grid-band:focus-visible,.gxaHeatmapContainer .gxa-grid-band--active{outline:2px solid #333;outline-offset:-2px}.gxaHeatmapContainer .gxa-grid-tooltip{position:absolute;z-index:1100;width:max-content;max-width:26rem;padding:5px 7px;background:#fffffff2;border:1px solid darkgray;border-radius:3px;box-shadow:2px 2px 2px #2f4f4f;color:#333;font-size:12px;line-height:1.4;pointer-events:none}.gxaHeatmapContainer .gxa-grid-tooltip dl{display:grid;grid-template-columns:auto 1fr;gap:0 .5rem;margin:0}.gxaHeatmapContainer .gxa-grid-tooltip dt{color:#555;font-weight:400}.gxaHeatmapContainer .gxa-grid-tooltip dd{margin:0;font-weight:700;overflow-wrap:anywhere}.gxaHeatmapContainer .gxa-grid-swatch{display:inline-block;width:.6rem;height:.6rem;margin-right:.25rem;border:1px solid rgb(192,192,192)}body>.highcharts-tooltip-container{z-index:1100}", Bt = "gramene-atlas-heatmap-styles", ta = ea, $t = (e)=>typeof e.host < "u" && !e.createElement;
function na(e) {
    const t = e || (typeof document < "u" ? document : null);
    if (!t || t.getElementById(Bt)) return !1;
    const n = $t(t) ? t.ownerDocument : t;
    if (!n) return !1;
    const s = n.createElement("style");
    if (s.id = Bt, s.setAttribute("data-gramene-atlas-heatmap", ""), s.textContent = ta, $t(t)) t.insertBefore(s, t.firstChild);
    else {
        const o = t.head || t.documentElement;
        o.insertBefore(s, o.firstChild);
    }
    return !0;
}
function sr(e) {
    (0, _react.useInsertionEffect)(()=>{
        e && na();
    }, [
        e
    ]);
}
const ra = ({ heatmapData: e }, t)=>{
    const n = [];
    return e.dataSeries.forEach((s)=>{
        s.data.forEach((o)=>{
            o.y === t && (n[o.x] = s.info.colour);
        });
    }), n;
}, I = "\u2014", sa = "sample id", _t = "organism part", mt = " \xb7 ", or = "FACTOR", oa = "SAMPLE", ia = "condition", aa = new Intl.Collator("en", {
    numeric: !0
}), pe = (e, t)=>{
    if (e === t) return 0;
    if (e === I) return 1;
    if (t === I) return -1;
    const n = String(e), s = String(t);
    return aa.compare(n, s) || (n < s ? -1 : n > s ? 1 : 0);
}, la = (e, t)=>{
    for(let n = 0; n < Math.min(e.length, t.length); n++){
        const s = pe(e[n], t[n]);
        if (s !== 0) return s;
    }
    return e.length - t.length;
}, ir = (e)=>e && e.assayGroupSummary && Array.isArray(e.assayGroupSummary.properties) ? e.assayGroupSummary.properties : [], ca = (e)=>e.reduce((t, n)=>ir(n).reduce((s, { propertyName: o, contrastPropertyType: a })=>a === or && o && !s.includes(o) ? s.concat(o) : s, t), []), X = (e)=>e != null && String(e) !== "", da = (e, t)=>{
    if (e.length === 0) return -1;
    if (t) {
        const n = String(t), s = e.findIndex((i)=>i.id === n || i.name === n);
        if (s >= 0) return s;
        const o = n.toLowerCase(), a = e.findIndex((i)=>String(i.id || "").toLowerCase() === o || String(i.name || "").toLowerCase() === o);
        if (a >= 0) return a;
    }
    return 0;
}, ua = (e, { gene: t } = {})=>{
    const n = e && Array.isArray(e.columnHeaders) ? e.columnHeaders : [], s = e && e.profiles && Array.isArray(e.profiles.rows) ? e.profiles.rows : [], o = da(s, t), a = o >= 0 ? s[o] : null, i = ca(n), c = i.length === 0 && n.some((p)=>X(p.factorValue)), d = c ? [
        ia
    ] : i, m = n.map((p, h)=>{
        const x = ir(p), f = {};
        d.forEach((b)=>{
            if (c) f[b] = X(p.factorValue) ? String(p.factorValue) : I;
            else {
                const v = x.find((N)=>N.contrastPropertyType === or && N.propertyName === b);
                f[b] = v && X(v.testValue) ? String(v.testValue) : I;
            }
        });
        const y = x.find((b)=>b.contrastPropertyType === oa && b.propertyName === sa), R = a && Array.isArray(a.expressions) ? a.expressions[h] : void 0, S = p && p.assayGroupSummary ? p.assayGroupSummary.replicates : void 0, k = p && X(p.assayGroupId) ? String(p.assayGroupId) : String(h);
        return {
            index: h,
            assayGroupId: k,
            sampleId: y && X(y.testValue) ? String(y.testValue) : k,
            replicates: typeof S == "number" ? S : null,
            factorValues: f,
            value: R && typeof R.value == "number" ? R.value : null,
            ontologyTermId: p && p.factorValueOntologyTermId || null
        };
    }), u = d.map((p)=>{
        const h = [
            ...new Set(m.map((x)=>x.factorValues[p]))
        ].sort(pe);
        return {
            name: p,
            values: h,
            count: h.filter((x)=>x !== I).length
        };
    });
    return {
        gene: {
            id: a && X(a.id) ? String(a.id) : String(t || ""),
            name: a && X(a.name) ? String(a.name) : String(t || "")
        },
        profileIndex: o,
        unit: a && a.expressionUnit || "",
        samples: m,
        factors: u,
        varyingFactors: u.filter((p)=>p.values.length > 1).map((p)=>p.name),
        constantFactors: u.filter((p)=>p.values.length === 1 && p.values[0] !== I).map((p)=>({
                name: p.name,
                value: p.values[0]
            }))
    };
}, pa = ({ factors: e, varyingFactors: t }, { rowFactor: n, columnFactor: s } = {})=>{
    if (t.length === 0) return {
        rowFactor: null,
        columnFactor: null
    };
    if (t.length === 1) return {
        rowFactor: null,
        columnFactor: t[0]
    };
    const o = (m)=>e.find((u)=>u.name === m).count, a = (m)=>m.reduce((u, p)=>u === null || o(p) > o(u) ? p : u, null), i = (m)=>typeof m == "string" && t.includes(m);
    let c = i(s) ? s : null, d = i(n) && n !== c ? n : null;
    if (c === null) {
        const m = t.filter((u)=>u !== d);
        c = m.includes(_t) ? _t : a(m);
    }
    return d === null && (d = a(t.filter((m)=>m !== c))), {
        rowFactor: d,
        columnFactor: c
    };
}, ma = ({ rowFactor: e, columnFactor: t })=>({
        rowFactor: t,
        columnFactor: e
    }), Dt = ({ rowFactor: e, columnFactor: t }, n, s)=>n === "row" ? s === t ? {
        rowFactor: s,
        columnFactor: e
    } : {
        rowFactor: s,
        columnFactor: t
    } : s === e ? {
        rowFactor: t,
        columnFactor: s
    } : {
        rowFactor: e,
        columnFactor: s
    }, ga = (e)=>e.filter((t)=>t !== I).join(mt) || I, ha = (e, t)=>pe(e.sampleId, t.sampleId) || e.index - t.index, fa = (e, t = {})=>{
    const { factors: n, varyingFactors: s, constantFactors: o, samples: a, gene: i } = e, { rowFactor: c, columnFactor: d } = pa(e, t), m = s.filter((b)=>b !== c && b !== d), u = c === null ? [] : [
        c,
        ...m
    ], h = (d === null ? [
        null
    ] : n.find((b)=>b.name === d).values).map((b)=>({
            key: b === null ? "" : b,
            value: b,
            label: b === null ? o.map((v)=>v.value).join(mt) || "all samples" : b
        })), x = (b)=>JSON.stringify(u.map((v)=>b.factorValues[v])), f = /* @__PURE__ */ new Map();
    a.forEach((b)=>{
        const v = x(b);
        f.has(v) || f.set(v, u.map((N)=>b.factorValues[N]));
    });
    const y = [
        ...f.entries()
    ].sort(([, b], [, v])=>la(b, v)).map(([b, v])=>({
            key: b,
            label: u.length === 0 ? i.id || i.name : ga(v),
            values: u.reduce((N, D, q)=>({
                    ...N,
                    [D]: v[q]
                }), {})
        })), R = new Map(y.map((b, v)=>[
            b.key,
            v
        ])), S = new Map(h.map((b, v)=>[
            b.value,
            v
        ])), k = y.map(()=>h.map(()=>[]));
    return a.forEach((b)=>{
        const v = d === null ? 0 : S.get(b.factorValues[d]);
        k[R.get(x(b))][v].push(b);
    }), k.forEach((b)=>b.forEach((v)=>v.sort(ha))), {
        ...e,
        rowFactor: c,
        columnFactor: d,
        foldedFactors: m,
        rows: y,
        columns: h,
        cells: k,
        maxSamplesPerCell: k.reduce((b, v)=>Math.max(b, ...v.map((N)=>N.length)), 0)
    };
}, ar = ({ samples: e, factors: t })=>[
        ...e
    ].sort((n, s)=>{
        for (const { name: o } of t){
            const a = pe(n.factorValues[o], s.factorValues[o]);
            if (a !== 0) return a;
        }
        return pe(n.sampleId, s.sampleId) || n.index - s.index;
    }), lr = (e, t)=>e.factorValues[t] === I ? null : e.factorValues[t], xa = (e, { accession: t })=>{
    const { factors: n, gene: s, unit: o } = e;
    return ds([
        [
            "gene",
            "study",
            ...n.map(({ name: a })=>a),
            "sample id",
            "replicates",
            o ? `expression (${o})` : "expression"
        ],
        ...ar(e).map((a)=>[
                s.id,
                t,
                ...n.map(({ name: i })=>lr(a, i)),
                a.sampleId,
                a.replicates,
                a.value
            ])
    ]);
}, ya = (e, { experiment: t, accession: n, downloadedFrom: s, downloadedAt: o })=>{
    const { factors: a, varyingFactors: i, gene: c, unit: d } = e;
    return en({
        gene: c.id,
        study: {
            accession: t && t.accession || n,
            description: t && t.description || null
        },
        factors: a.map(({ name: m, values: u })=>({
                name: m,
                values: u.filter((p)=>p !== I),
                varies: i.includes(m)
            })),
        rowFactor: e.rowFactor === void 0 ? null : e.rowFactor,
        columnFactor: e.columnFactor === void 0 ? null : e.columnFactor,
        unit: d || null,
        samples: ar(e).map((m)=>({
                factors: a.reduce((u, { name: p })=>({
                        ...u,
                        [p]: lr(m, p)
                    }), {}),
                sampleId: m.sampleId,
                assayGroupId: m.assayGroupId,
                replicates: m.replicates,
                value: m.value
            })),
        downloadedFrom: s,
        downloadedAt: o
    });
}, ba = (e, { accession: t })=>e.samples.length === 0 ? "Nothing to download: the study has no samples." : `${Se(e.samples.length, "sample")}${t ? ` of ${t}` : ""}${e.gene.id ? ` for ${e.gene.id}` : ""}`, Ca = ({ gene: e, accession: t })=>[
        e,
        t
    ].filter(Boolean).join("-"), wa = 40, va = 14, Ra = 8, Ae = 6, cr = (e, t)=>e === null ? "No data" : `${e}${t ? ` ${t}` : ""}${e === 0 ? " (below cutoff)" : ""}`, dr = ({ onClick: e })=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Button), {
        size: "sm",
        variant: "outline-secondary",
        className: "gxa-grid-swap",
        onClick: e,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                "aria-hidden": "true",
                children: "\u21C4"
            }),
            " Swap rows and columns"
        ]
    });
dr.propTypes = {
    onClick: (0, _propTypesDefault.default).func.isRequired
};
const Ye = ({ id: e, label: t, value: n, factors: s, onChange: o })=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Form).Group, {
        controlId: e,
        className: "gxa-grid-axis-choice",
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Form).Label, {
                className: "mb-0",
                children: t
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Form).Select, {
                size: "sm",
                value: n,
                onChange: (a)=>o(a.target.value),
                children: s.map((a)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("option", {
                        value: a,
                        children: a
                    }, a))
            })
        ]
    });
Ye.propTypes = {
    id: (0, _propTypesDefault.default).string.isRequired,
    label: (0, _propTypesDefault.default).string.isRequired,
    value: (0, _propTypesDefault.default).string.isRequired,
    factors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string).isRequired,
    onChange: (0, _propTypesDefault.default).func.isRequired
};
const gt = (0, _reactDefault.default).forwardRef(({ id: e, sample: t, factors: n, colour: s, unit: o }, a)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        ref: a,
        id: e,
        role: "tooltip",
        className: "gxa-grid-tooltip",
        style: {
            visibility: "hidden"
        },
        children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("dl", {
            children: [
                n.filter(({ name: i })=>t.factorValues[i] !== I).map(({ name: i })=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("dt", {
                                children: i
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("dd", {
                                children: t.factorValues[i]
                            })
                        ]
                    }, i)),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("dt", {
                    children: "sample id"
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("dd", {
                    children: t.sampleId
                }),
                t.replicates !== null && /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("dt", {
                            children: "replicates"
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("dd", {
                            children: t.replicates
                        })
                    ]
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("dt", {
                    children: "expression"
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("dd", {
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                            className: s ? "gxa-grid-swatch" : "gxa-grid-swatch gxa-grid-no-data",
                            style: s ? {
                                background: s
                            } : void 0
                        }),
                        cr(t.value, o)
                    ]
                })
            ]
        })
    }));
gt.displayName = "FactorGridTooltip";
gt.propTypes = {
    id: (0, _propTypesDefault.default).string.isRequired,
    sample: (0, _propTypesDefault.default).object.isRequired,
    factors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        name: (0, _propTypesDefault.default).string.isRequired
    })).isRequired,
    colour: (0, _propTypesDefault.default).string,
    unit: (0, _propTypesDefault.default).string
};
const ur = ({ payload: e, gene: t, experiment: n, inProxy: s, atlasUrl: o, linkTarget: a, urlFor: i, rowFactor: c, columnFactor: d, onChangeFactors: m, downloadFileName: u, showDownload: p = !0 })=>{
    const h = (0, _react.useId)(), x = (0, _react.useRef)(null), f = (0, _react.useRef)(null), y = (0, _react.useMemo)(()=>zn({
            data: e,
            inProxy: s,
            outProxy: "",
            atlasUrl: o,
            showAnatomogram: !1,
            showControlMenu: !1,
            isWidget: !1,
            linkTarget: a,
            urlFor: i
        }), [
        e,
        s,
        o,
        a,
        i
    ]), R = (0, _react.useMemo)(()=>ua(e, {
            gene: t
        }), [
        e,
        t
    ]), S = (0, _react.useMemo)(()=>ra(y, R.profileIndex), [
        y,
        R.profileIndex
    ]), [k, b] = (0, _react.useState)({
        rowFactor: null,
        columnFactor: null
    }), v = (C)=>R.varyingFactors.includes(C), N = v(c) ? c : k.rowFactor, D = v(d) ? d : k.columnFactor, q = (0, _react.useMemo)(()=>fa(R, {
            rowFactor: N,
            columnFactor: D
        }), [
        R,
        N,
        D
    ]), [G, z] = (0, _react.useState)(null), ee = (0, _react.useRef)(null), ie = (C)=>{
        ee.current = null, z(null), b(C), m && m(C);
    }, ye = {
        rowFactor: q.rowFactor,
        columnFactor: q.columnFactor
    }, Pe = (C)=>{
        const T = x.current.getBoundingClientRect(), O = C.getBoundingClientRect();
        return {
            left: O.left - T.left,
            top: O.top - T.top,
            width: O.width,
            height: O.height
        };
    }, A = (C, T)=>{
        x.current && (ee.current = T, z({
            index: C.index,
            anchor: Pe(T)
        }));
    }, te = ()=>{
        ee.current = null, z(null);
    }, gr = ()=>{
        const C = ee.current;
        if (C && C === document.activeElement && x.current) {
            const T = Pe(C);
            z((O)=>O && {
                    ...O,
                    anchor: T
                });
        } else C && te();
    };
    (0, _react.useLayoutEffect)(()=>{
        const C = f.current, T = x.current;
        if (!G || !C || !T) return;
        const { left: O, top: ve, width: ce, height: H } = G.anchor, U = T.getBoundingClientRect(), Re = document.documentElement.clientWidth || window.innerWidth, Q = U.left + O + ce / 2 - C.offsetWidth / 2, Cr = Math.max(Ae, Math.min(Q, Re - C.offsetWidth - Ae)) - U.left, yt = ve + H + Ae, bt = ve - Ae - C.offsetHeight, wr = U.top + yt + C.offsetHeight <= window.innerHeight || U.top + bt < 0 ? yt : bt;
        C.style.left = `${Cr}px`, C.style.top = `${wr}px`, C.style.visibility = "visible";
    }, [
        G
    ]);
    const { rows: hr, columns: ae, cells: He, unit: be, varyingFactors: le, constantFactors: ht, foldedFactors: fr } = q, Ce = G && q.samples[G.index], ft = `${h}-tooltip`, xr = ae.some((C)=>C.label.length > Ra), xt = ae.map((C, T)=>Math.max(wa, va * Math.max(...He.map((O)=>O[T].length)))), yr = He.some((C)=>C.some((T)=>T.length === 0 || T.some((O)=>!S[O.index]))), Be = q.rowFactor === null ? "" : [
        q.rowFactor,
        ...fr
    ].join(mt), $e = e.experiment ? e.experiment.accession : "", we = $e || n || "", br = (C)=>{
        const T = tn();
        return C === "json" ? ya(q, {
            experiment: e.experiment,
            accession: we,
            ...T
        }) : xa(q, {
            accession: we
        });
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        ref: x,
        className: "gxa-grid",
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                className: "gxa-grid-toolbar",
                children: [
                    (le.length >= 2 || p) && /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                        className: "gxa-grid-controls",
                        children: [
                            le.length > 2 && /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                                children: [
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ye, {
                                        id: `${h}-rows`,
                                        label: "Rows",
                                        value: q.rowFactor,
                                        factors: le,
                                        onChange: (C)=>ie(Dt(ye, "row", C))
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ye, {
                                        id: `${h}-columns`,
                                        label: "Columns",
                                        value: q.columnFactor,
                                        factors: le,
                                        onChange: (C)=>ie(Dt(ye, "column", C))
                                    })
                                ]
                            }),
                            le.length >= 2 && /* @__PURE__ */ (0, _jsxRuntime.jsx)(dr, {
                                onClick: ()=>ie(ma(ye))
                            }),
                            p && /* @__PURE__ */ (0, _jsxRuntime.jsx)(nt, {
                                className: "gxa-grid-download",
                                defaultFileName: u || Ca({
                                    gene: t || q.gene.id,
                                    accession: we
                                }),
                                summary: ba(q, {
                                    accession: we
                                }),
                                nothingToSave: q.samples.length === 0,
                                buildContent: br,
                                disclaimer: Zt[e.config && e.config.disclaimer],
                                linkTarget: a
                            })
                        ]
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                        className: "gxa-grid-legend",
                        children: [
                            y.colourAxis && /* @__PURE__ */ (0, _jsxRuntime.jsx)(ot, {
                                heatmapConfig: y.heatmapConfig,
                                colourAxis: y.colourAxis
                            }),
                            yr && /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                                className: "gxa-legend-item",
                                children: [
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                                        className: "gxa-legend-swatch gxa-grid-no-data"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                        className: "gxa-va-middle",
                                        children: "No data"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                className: "gxa-grid-scroll",
                onScroll: gr,
                children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("table", {
                    className: "gxa-grid-table",
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("caption", {
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                    className: "gxa-visually-hidden",
                                    children: `Expression of ${q.gene.id}${$e ? ` in ${$e}` : ""}${be ? `, in ${be}` : ""}` + (q.rowFactor ? `; rows: ${Be}` : "") + (q.columnFactor ? `; columns: ${q.columnFactor}` : "") + ". "
                                }),
                                ht.length > 0 && /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                    className: "gxa-grid-constant",
                                    children: ht.map(({ name: C, value: T })=>`${C}: ${T}`).join("; ")
                                })
                            ]
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("thead", {
                            children: [
                                q.columnFactor !== null && /* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                    children: [
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {}),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                            colSpan: ae.length,
                                            className: "gxa-grid-axis gxa-grid-axis--columns",
                                            children: q.columnFactor
                                        })
                                    ]
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                    children: [
                                        Be ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                            scope: "col",
                                            className: "gxa-grid-axis gxa-grid-axis--rows",
                                            children: Be
                                        }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {}),
                                        ae.map((C, T)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                                scope: "col",
                                                className: xr ? "gxa-grid-col gxa-grid-col--vertical" : "gxa-grid-col",
                                                style: {
                                                    width: `${xt[T]}px`,
                                                    minWidth: `${xt[T]}px`
                                                },
                                                title: C.value === I ? `no ${q.columnFactor}` : C.label,
                                                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                    className: "gxa-grid-col-label",
                                                    children: C.label
                                                })
                                            }, C.key))
                                    ]
                                })
                            ]
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("tbody", {
                            children: hr.map((C, T)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                    children: [
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                            scope: "row",
                                            className: "gxa-grid-row",
                                            title: C.label,
                                            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                className: "gxa-grid-row-label",
                                                children: C.label
                                            })
                                        }),
                                        ae.map((O, ve)=>{
                                            const ce = He[T][ve];
                                            return ce.length === 0 ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                className: "gxa-grid-cell gxa-grid-cell--empty gxa-grid-no-data",
                                                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                    className: "gxa-visually-hidden",
                                                    children: "No data"
                                                })
                                            }, O.key) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                className: "gxa-grid-cell",
                                                "data-samples": ce.length,
                                                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                                                    className: "gxa-grid-bands",
                                                    children: ce.map((H)=>{
                                                        const U = S[H.index], Re = Ce === H;
                                                        return /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                            role: "img",
                                                            tabIndex: 0,
                                                            className: [
                                                                "gxa-grid-band",
                                                                U ? null : "gxa-grid-no-data",
                                                                Re ? "gxa-grid-band--active" : null
                                                            ].filter(Boolean).join(" "),
                                                            style: U ? {
                                                                background: U
                                                            } : void 0,
                                                            "data-assay-group": H.assayGroupId,
                                                            "aria-label": `${C.label}${O.value === null ? "" : `, ${O.label}`}: sample ${H.sampleId}, ${cr(H.value, be)}`,
                                                            "aria-describedby": Re ? ft : void 0,
                                                            onMouseEnter: (Q)=>A(H, Q.currentTarget),
                                                            onMouseLeave: te,
                                                            onFocus: (Q)=>A(H, Q.currentTarget),
                                                            onBlur: te,
                                                            onKeyDown: (Q)=>Q.key === "Escape" && te()
                                                        }, H.index);
                                                    })
                                                })
                                            }, O.key);
                                        })
                                    ]
                                }, C.key))
                        })
                    ]
                })
            }),
            Ce && /* @__PURE__ */ (0, _jsxRuntime.jsx)(gt, {
                ref: f,
                id: ft,
                sample: Ce,
                factors: q.factors,
                colour: S[Ce.index],
                unit: be
            })
        ]
    });
};
ur.propTypes = {
    payload: (0, _propTypesDefault.default).shape({
        columnHeaders: (0, _propTypesDefault.default).array.isRequired,
        profiles: (0, _propTypesDefault.default).shape({
            rows: (0, _propTypesDefault.default).array.isRequired
        }).isRequired,
        experiment: (0, _propTypesDefault.default).object
    }).isRequired,
    gene: (0, _propTypesDefault.default).string.isRequired,
    experiment: (0, _propTypesDefault.default).string,
    inProxy: (0, _propTypesDefault.default).string.isRequired,
    atlasUrl: (0, _propTypesDefault.default).string.isRequired,
    linkTarget: (0, _propTypesDefault.default).string,
    urlFor: (0, _propTypesDefault.default).func.isRequired,
    rowFactor: (0, _propTypesDefault.default).string,
    columnFactor: (0, _propTypesDefault.default).string,
    onChangeFactors: (0, _propTypesDefault.default).func,
    downloadFileName: (0, _propTypesDefault.default).string,
    showDownload: (0, _propTypesDefault.default).bool
};
const qa = Object.freeze({
    atlasUrl: er,
    inProxy: "",
    linkTarget: "_blank",
    injectStyles: !0,
    showDownload: !0
}), Aa = "The factor grid shows baseline experiments only.", Ta = (e)=>{
    const t = Xn(e);
    if (!t.data) return t;
    const { profiles: n, columnHeaders: s, experiment: o } = t.data;
    return !Array.isArray(n.rows) || n.rows.length === 0 || !Array.isArray(s) || s.length === 0 ? {
        noResults: !0
    } : o && !rt(o) ? {
        unsupported: !0
    } : t;
}, pr = ({ request: e, fail: t, linkTarget: n, urlFor: s, ...o })=>{
    const a = (0, _react.useMemo)(()=>e, [
        xe(e)
    ]), i = Kn(a), c = Ta(i);
    return Jn({
        fail: t,
        request: a,
        key: i.key,
        failure: c.failure
    }), c.loading ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(Qn, {}) : c.failure !== void 0 ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(ut, {
        failure: c.failure,
        linkTarget: n,
        urlFor: s
    }) : c.noResults ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(Zn, {}) : c.unsupported ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(me, {
        variant: "info",
        error: {
            description: Aa
        }
    }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)(ur, {
        ...o,
        linkTarget: n,
        urlFor: s,
        payload: c.data
    }, i.key);
};
pr.propTypes = {
    request: (0, _propTypesDefault.default).shape({
        url: (0, _propTypesDefault.default).string.isRequired,
        method: (0, _propTypesDefault.default).string
    }).isRequired,
    fail: (0, _propTypesDefault.default).func,
    linkTarget: (0, _propTypesDefault.default).string,
    urlFor: (0, _propTypesDefault.default).func.isRequired
};
const Sa = (e)=>{
    const t = tr(qa, e), { experiment: n, gene: s, inProxy: o, fail: a, linkTarget: i, className: c, style: d, rowFactor: m, columnFactor: u, onChangeFactors: p, downloadFileName: h, showDownload: x } = t, f = nr(t.atlasUrl);
    sr(t.injectStyles !== !1);
    const y = (0, _react.useMemo)(()=>({
            gene: s
        }), [
        s
    ]), R = rr(t.resolveUrl, {
        query: y,
        experiment: n || null
    }), S = n && s ? dt({
        inProxy: o,
        atlasUrl: f,
        source: Wn({
            query: y,
            experiment: n
        })
    }) : null;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        className: [
            "gxaHeatmapContainer",
            "gxaFactorGrid",
            c
        ].filter(Boolean).join(" "),
        style: d,
        children: S && /* @__PURE__ */ (0, _jsxRuntime.jsx)(pt, {
            request: S,
            fail: a,
            linkTarget: i,
            urlFor: R,
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(pr, {
                request: S,
                gene: s,
                experiment: n,
                inProxy: o,
                atlasUrl: f,
                fail: a,
                linkTarget: i,
                urlFor: R,
                rowFactor: m,
                columnFactor: u,
                onChangeFactors: p,
                downloadFileName: h,
                showDownload: x
            })
        }, xe(S))
    });
};
Sa.propTypes = {
    experiment: (0, _propTypesDefault.default).string.isRequired,
    gene: (0, _propTypesDefault.default).string.isRequired,
    atlasUrl: (0, _propTypesDefault.default).string,
    rowFactor: (0, _propTypesDefault.default).string,
    columnFactor: (0, _propTypesDefault.default).string,
    onChangeFactors: (0, _propTypesDefault.default).func,
    downloadFileName: (0, _propTypesDefault.default).string,
    showDownload: (0, _propTypesDefault.default).bool,
    inProxy: (0, _propTypesDefault.default).string,
    linkTarget: (0, _propTypesDefault.default).string,
    resolveUrl: (0, _propTypesDefault.default).func,
    fail: (0, _propTypesDefault.default).func,
    className: (0, _propTypesDefault.default).string,
    style: (0, _propTypesDefault.default).object,
    injectStyles: (0, _propTypesDefault.default).bool
};
const ka = Object.freeze({
    showAnatomogram: !0,
    isWidget: !0,
    showControlMenu: !0,
    atlasUrl: er,
    inProxy: "",
    outProxy: "",
    experiment: "",
    linkTarget: "_blank",
    injectStyles: !0,
    showDownload: !0
}), mr = (e)=>{
    const t = tr(ka, e), { query: n, experiment: s, inProxy: o, outProxy: a, showAnatomogram: i, isWidget: c, showControlMenu: d, fail: m, linkTarget: u, className: p, style: h, filterRows: x, downloadFileName: f, showDownload: y } = t, R = nr(t.atlasUrl);
    sr(t.injectStyles !== !1);
    const S = rr(t.resolveUrl, {
        query: n,
        experiment: s || null
    }), k = Wn({
        query: n,
        experiment: s
    }), b = dt({
        inProxy: o,
        atlasUrl: R,
        source: k
    });
    return(// The wrapping div is important to determine the width of the heatmap and know if the labels are going to be
    // rotated, so that we can set sensible margin sizes. See HeatmapCanvas.js
    /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        className: [
            "gxaHeatmapContainer",
            p
        ].filter(Boolean).join(" "),
        style: h,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(pt, {
            request: b,
            fail: m,
            linkTarget: u,
            urlFor: S,
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Yn, {
                inProxy: o,
                outProxy: a,
                atlasUrl: R,
                showAnatomogram: i,
                isWidget: c,
                showControlMenu: d,
                fail: m,
                linkTarget: u,
                urlFor: S,
                filterRows: x,
                downloadFileName: f,
                showDownload: y,
                source: k
            })
        }, xe(b))
    }));
};
mr.propTypes = {
    query: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).string
    ]),
    experiment: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).bool
    ]),
    atlasUrl: (0, _propTypesDefault.default).string,
    inProxy: (0, _propTypesDefault.default).string,
    outProxy: (0, _propTypesDefault.default).string,
    showAnatomogram: (0, _propTypesDefault.default).bool,
    isWidget: (0, _propTypesDefault.default).bool,
    showControlMenu: (0, _propTypesDefault.default).bool,
    fail: (0, _propTypesDefault.default).func,
    linkTarget: (0, _propTypesDefault.default).string,
    resolveUrl: (0, _propTypesDefault.default).func,
    className: (0, _propTypesDefault.default).string,
    style: (0, _propTypesDefault.default).object,
    injectStyles: (0, _propTypesDefault.default).bool,
    filterRows: (0, _propTypesDefault.default).func,
    downloadFileName: (0, _propTypesDefault.default).string,
    showDownload: (0, _propTypesDefault.default).bool,
    disableGoogleAnalytics: (0, _propTypesDefault.default).bool
};
const Oa = ({ callback: e, children: t })=>((0, _react.useEffect)(()=>{
        typeof e == "function" && e();
    }), t), Te = /* @__PURE__ */ new WeakMap(), Za = (e = {})=>{
    const { target: t, render: n, disableGoogleAnalytics: s, ...o } = e, a = typeof t == "string" ? document.getElementById(t) : t;
    if (!a || a.nodeType !== 1) throw new Error(`gramene-atlas-heatmap render(): target ${typeof t == "string" ? `#${t}` : String(t)} is not an element or the id of one`);
    let i = Te.get(a);
    return i || (i = (0, _client.createRoot)(a), Te.set(a, i)), i.render(/* @__PURE__ */ (0, _jsxRuntime.jsx)(Oa, {
        callback: n,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(mr, {
            ...o
        })
    })), {
        unmount () {
            Te.get(a) === i && (Te.delete(a), i.unmount());
        }
    };
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","prop-types":"gLXGb","react-dom/client":"5eZdG","react-bootstrap":[["Alert","eF7kW","default"],["Button","6Xv8z","default"],["Col","ii9A3","default"],["Dropdown","7uokG","default"],["Form","iMBBh","default"],["Modal","92IrJ","default"],["Nav","axkz0","default"],["Row","3Fk66","default"],["Spinner","4RdUY","default"]],"urijs":"i2SSz","uncontrollable":"1yRhe","lodash/range.js":"18kUy","downloadjs":"g2hJW","lodash/xor.js":"3l4am","lodash/sortBy.js":"cWbub","lodash/groupBy.js":"43qze","react-dom/server":"hRNim","lodash/debounce.js":"jteyB","gramene-anatomogram":"7UWv5","highcharts-react-official":"7VCTY","highcharts":"kyYpV","highcharts/modules/heatmap.js":"a6fXn","highcharts-custom-events":"fO8tz","lodash":"L2GyB","color":"7TySC","8e2c54584eff9a0a":"j5i8h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i2SSz":[function(require,module,exports,__globalThis) {
/*!
 * URI.js - Mutating URLs
 *
 * Version: 1.19.11
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */ (function(root, factory) {
    'use strict';
    // https://github.com/umdjs/umd/blob/master/returnExports.js
    if (module.exports) // Node
    module.exports = factory(require("c0c01881d6d80b64"), require("a7a250f099ff4d9b"), require("847a203e5519704d"));
    else if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define([
        './punycode',
        './IPv6',
        './SecondLevelDomains'
    ], factory);
    else // Browser globals (root is window)
    root.URI = factory(root.punycode, root.IPv6, root.SecondLevelDomains, root);
})(this, function(punycode, IPv6, SLD, root) {
    'use strict';
    /*global location, escape, unescape */ // FIXME: v2.0.0 renamce non-camelCase properties to uppercase
    /*jshint camelcase: false */ // save current URI variable, if any
    var _URI = root && root.URI;
    function URI(url, base) {
        var _urlSupplied = arguments.length >= 1;
        var _baseSupplied = arguments.length >= 2;
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof URI)) {
            if (_urlSupplied) {
                if (_baseSupplied) return new URI(url, base);
                return new URI(url);
            }
            return new URI();
        }
        if (url === undefined) {
            if (_urlSupplied) throw new TypeError('undefined is not a valid argument for URI');
            if (typeof location !== 'undefined') url = location.href + '';
            else url = '';
        }
        if (url === null) {
            if (_urlSupplied) throw new TypeError('null is not a valid argument for URI');
        }
        this.href(url);
        // resolve to base according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#constructor
        if (base !== undefined) return this.absoluteTo(base);
        return this;
    }
    function isInteger(value) {
        return /^[0-9]+$/.test(value);
    }
    URI.version = '1.19.11';
    var p = URI.prototype;
    var hasOwn = Object.prototype.hasOwnProperty;
    function escapeRegEx(string) {
        // https://github.com/medialize/URI.js/commit/85ac21783c11f8ccab06106dba9735a31a86924d#commitcomment-821963
        return string.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
    }
    function getType(value) {
        // IE8 doesn't return [Object Undefined] but [Object Object] for undefined value
        if (value === undefined) return 'Undefined';
        return String(Object.prototype.toString.call(value)).slice(8, -1);
    }
    function isArray(obj) {
        return getType(obj) === 'Array';
    }
    function filterArrayValues(data, value) {
        var lookup = {};
        var i, length;
        if (getType(value) === 'RegExp') lookup = null;
        else if (isArray(value)) for(i = 0, length = value.length; i < length; i++)lookup[value[i]] = true;
        else lookup[value] = true;
        for(i = 0, length = data.length; i < length; i++){
            /*jshint laxbreak: true */ var _match = lookup && lookup[data[i]] !== undefined || !lookup && value.test(data[i]);
            /*jshint laxbreak: false */ if (_match) {
                data.splice(i, 1);
                length--;
                i--;
            }
        }
        return data;
    }
    function arrayContains(list, value) {
        var i, length;
        // value may be string, number, array, regexp
        if (isArray(value)) {
            // Note: this can be optimized to O(n) (instead of current O(m * n))
            for(i = 0, length = value.length; i < length; i++){
                if (!arrayContains(list, value[i])) return false;
            }
            return true;
        }
        var _type = getType(value);
        for(i = 0, length = list.length; i < length; i++){
            if (_type === 'RegExp') {
                if (typeof list[i] === 'string' && list[i].match(value)) return true;
            } else if (list[i] === value) return true;
        }
        return false;
    }
    function arraysEqual(one, two) {
        if (!isArray(one) || !isArray(two)) return false;
        // arrays can't be equal if they have different amount of content
        if (one.length !== two.length) return false;
        one.sort();
        two.sort();
        for(var i = 0, l = one.length; i < l; i++){
            if (one[i] !== two[i]) return false;
        }
        return true;
    }
    function trimSlashes(text) {
        var trim_expression = /^\/+|\/+$/g;
        return text.replace(trim_expression, '');
    }
    URI._parts = function() {
        return {
            protocol: null,
            username: null,
            password: null,
            hostname: null,
            urn: null,
            port: null,
            path: null,
            query: null,
            fragment: null,
            // state
            preventInvalidHostname: URI.preventInvalidHostname,
            duplicateQueryParameters: URI.duplicateQueryParameters,
            escapeQuerySpace: URI.escapeQuerySpace
        };
    };
    // state: throw on invalid hostname
    // see https://github.com/medialize/URI.js/pull/345
    // and https://github.com/medialize/URI.js/issues/354
    URI.preventInvalidHostname = false;
    // state: allow duplicate query parameters (a=1&a=1)
    URI.duplicateQueryParameters = false;
    // state: replaces + with %20 (space in query strings)
    URI.escapeQuerySpace = true;
    // static properties
    URI.protocol_expression = /^[a-z][a-z0-9.+-]*$/i;
    URI.idn_expression = /[^a-z0-9\._-]/i;
    URI.punycode_expression = /(xn--)/i;
    // well, 333.444.555.666 matches, but it sure ain't no IPv4 - do we care?
    URI.ip4_expression = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
    // credits to Rich Brown
    // source: http://forums.intermapper.com/viewtopic.php?p=1096#1096
    // specification: http://www.ietf.org/rfc/rfc4291.txt
    URI.ip6_expression = /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;
    // expression used is "gruber revised" (@gruber v2) determined to be the
    // best solution in a regex-golf we did a couple of ages ago at
    // * http://mathiasbynens.be/demo/url-regex
    // * http://rodneyrehm.de/t/url-regex.html
    URI.find_uri_expression = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/ig;
    URI.findUri = {
        // valid "scheme://" or "www."
        start: /\b(?:([a-z][a-z0-9.+-]*:\/\/)|www\.)/gi,
        // everything up to the next whitespace
        end: /[\s\r\n]|$/,
        // trim trailing punctuation captured by end RegExp
        trim: /[`!()\[\]{};:'".,<>?«»“”„‘’]+$/,
        // balanced parens inclusion (), [], {}, <>
        parens: /(\([^\)]*\)|\[[^\]]*\]|\{[^}]*\}|<[^>]*>)/g
    };
    URI.leading_whitespace_expression = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/;
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    URI.ascii_tab_whitespace = /[\u0009\u000A\u000D]+/g;
    // http://www.iana.org/assignments/uri-schemes.html
    // http://en.wikipedia.org/wiki/List_of_TCP_and_UDP_port_numbers#Well-known_ports
    URI.defaultPorts = {
        http: '80',
        https: '443',
        ftp: '21',
        gopher: '70',
        ws: '80',
        wss: '443'
    };
    // list of protocols which always require a hostname
    URI.hostProtocols = [
        'http',
        'https'
    ];
    // allowed hostname characters according to RFC 3986
    // ALPHA DIGIT "-" "." "_" "~" "!" "$" "&" "'" "(" ")" "*" "+" "," ";" "=" %encoded
    // I've never seen a (non-IDN) hostname other than: ALPHA DIGIT . - _
    URI.invalid_hostname_characters = /[^a-zA-Z0-9\.\-:_]/;
    // map DOM Elements to their URI attribute
    URI.domAttributes = {
        'a': 'href',
        'blockquote': 'cite',
        'link': 'href',
        'base': 'href',
        'script': 'src',
        'form': 'action',
        'img': 'src',
        'area': 'href',
        'iframe': 'src',
        'embed': 'src',
        'source': 'src',
        'track': 'src',
        'input': 'src',
        'audio': 'src',
        'video': 'src'
    };
    URI.getDomAttribute = function(node) {
        if (!node || !node.nodeName) return undefined;
        var nodeName = node.nodeName.toLowerCase();
        // <input> should only expose src for type="image"
        if (nodeName === 'input' && node.type !== 'image') return undefined;
        return URI.domAttributes[nodeName];
    };
    function escapeForDumbFirefox36(value) {
        // https://github.com/medialize/URI.js/issues/91
        return escape(value);
    }
    // encoding / decoding according to RFC3986
    function strictEncodeURIComponent(string) {
        // see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/encodeURIComponent
        return encodeURIComponent(string).replace(/[!'()*]/g, escapeForDumbFirefox36).replace(/\*/g, '%2A');
    }
    URI.encode = strictEncodeURIComponent;
    URI.decode = decodeURIComponent;
    URI.iso8859 = function() {
        URI.encode = escape;
        URI.decode = unescape;
    };
    URI.unicode = function() {
        URI.encode = strictEncodeURIComponent;
        URI.decode = decodeURIComponent;
    };
    URI.characters = {
        pathname: {
            encode: {
                // RFC3986 2.1: For consistency, URI producers and normalizers should
                // use uppercase hexadecimal digits for all percent-encodings.
                expression: /%(24|26|2B|2C|3B|3D|3A|40)/ig,
                map: {
                    // -._~!'()*
                    '%24': '$',
                    '%26': '&',
                    '%2B': '+',
                    '%2C': ',',
                    '%3B': ';',
                    '%3D': '=',
                    '%3A': ':',
                    '%40': '@'
                }
            },
            decode: {
                expression: /[\/\?#]/g,
                map: {
                    '/': '%2F',
                    '?': '%3F',
                    '#': '%23'
                }
            }
        },
        reserved: {
            encode: {
                // RFC3986 2.1: For consistency, URI producers and normalizers should
                // use uppercase hexadecimal digits for all percent-encodings.
                expression: /%(21|23|24|26|27|28|29|2A|2B|2C|2F|3A|3B|3D|3F|40|5B|5D)/ig,
                map: {
                    // gen-delims
                    '%3A': ':',
                    '%2F': '/',
                    '%3F': '?',
                    '%23': '#',
                    '%5B': '[',
                    '%5D': ']',
                    '%40': '@',
                    // sub-delims
                    '%21': '!',
                    '%24': '$',
                    '%26': '&',
                    '%27': '\'',
                    '%28': '(',
                    '%29': ')',
                    '%2A': '*',
                    '%2B': '+',
                    '%2C': ',',
                    '%3B': ';',
                    '%3D': '='
                }
            }
        },
        urnpath: {
            // The characters under `encode` are the characters called out by RFC 2141 as being acceptable
            // for usage in a URN. RFC2141 also calls out "-", ".", and "_" as acceptable characters, but
            // these aren't encoded by encodeURIComponent, so we don't have to call them out here. Also
            // note that the colon character is not featured in the encoding map; this is because URI.js
            // gives the colons in URNs semantic meaning as the delimiters of path segements, and so it
            // should not appear unencoded in a segment itself.
            // See also the note above about RFC3986 and capitalalized hex digits.
            encode: {
                expression: /%(21|24|27|28|29|2A|2B|2C|3B|3D|40)/ig,
                map: {
                    '%21': '!',
                    '%24': '$',
                    '%27': '\'',
                    '%28': '(',
                    '%29': ')',
                    '%2A': '*',
                    '%2B': '+',
                    '%2C': ',',
                    '%3B': ';',
                    '%3D': '=',
                    '%40': '@'
                }
            },
            // These characters are the characters called out by RFC2141 as "reserved" characters that
            // should never appear in a URN, plus the colon character (see note above).
            decode: {
                expression: /[\/\?#:]/g,
                map: {
                    '/': '%2F',
                    '?': '%3F',
                    '#': '%23',
                    ':': '%3A'
                }
            }
        }
    };
    URI.encodeQuery = function(string, escapeQuerySpace) {
        var escaped = URI.encode(string + '');
        if (escapeQuerySpace === undefined) escapeQuerySpace = URI.escapeQuerySpace;
        return escapeQuerySpace ? escaped.replace(/%20/g, '+') : escaped;
    };
    URI.decodeQuery = function(string, escapeQuerySpace) {
        string += '';
        if (escapeQuerySpace === undefined) escapeQuerySpace = URI.escapeQuerySpace;
        try {
            return URI.decode(escapeQuerySpace ? string.replace(/\+/g, '%20') : string);
        } catch (e) {
            // we're not going to mess with weird encodings,
            // give up and return the undecoded original string
            // see https://github.com/medialize/URI.js/issues/87
            // see https://github.com/medialize/URI.js/issues/92
            return string;
        }
    };
    // generate encode/decode path functions
    var _parts = {
        'encode': 'encode',
        'decode': 'decode'
    };
    var _part;
    var generateAccessor = function(_group, _part) {
        return function(string) {
            try {
                return URI[_part](string + '').replace(URI.characters[_group][_part].expression, function(c) {
                    return URI.characters[_group][_part].map[c];
                });
            } catch (e) {
                // we're not going to mess with weird encodings,
                // give up and return the undecoded original string
                // see https://github.com/medialize/URI.js/issues/87
                // see https://github.com/medialize/URI.js/issues/92
                return string;
            }
        };
    };
    for(_part in _parts){
        URI[_part + 'PathSegment'] = generateAccessor('pathname', _parts[_part]);
        URI[_part + 'UrnPathSegment'] = generateAccessor('urnpath', _parts[_part]);
    }
    var generateSegmentedPathFunction = function(_sep, _codingFuncName, _innerCodingFuncName) {
        return function(string) {
            // Why pass in names of functions, rather than the function objects themselves? The
            // definitions of some functions (but in particular, URI.decode) will occasionally change due
            // to URI.js having ISO8859 and Unicode modes. Passing in the name and getting it will ensure
            // that the functions we use here are "fresh".
            var actualCodingFunc;
            if (!_innerCodingFuncName) actualCodingFunc = URI[_codingFuncName];
            else actualCodingFunc = function(string) {
                return URI[_codingFuncName](URI[_innerCodingFuncName](string));
            };
            var segments = (string + '').split(_sep);
            for(var i = 0, length = segments.length; i < length; i++)segments[i] = actualCodingFunc(segments[i]);
            return segments.join(_sep);
        };
    };
    // This takes place outside the above loop because we don't want, e.g., encodeUrnPath functions.
    URI.decodePath = generateSegmentedPathFunction('/', 'decodePathSegment');
    URI.decodeUrnPath = generateSegmentedPathFunction(':', 'decodeUrnPathSegment');
    URI.recodePath = generateSegmentedPathFunction('/', 'encodePathSegment', 'decode');
    URI.recodeUrnPath = generateSegmentedPathFunction(':', 'encodeUrnPathSegment', 'decode');
    URI.encodeReserved = generateAccessor('reserved', 'encode');
    URI.parse = function(string, parts) {
        var pos;
        if (!parts) parts = {
            preventInvalidHostname: URI.preventInvalidHostname
        };
        string = string.replace(URI.leading_whitespace_expression, '');
        // https://infra.spec.whatwg.org/#ascii-tab-or-newline
        string = string.replace(URI.ascii_tab_whitespace, '');
        // [protocol"://"[username[":"password]"@"]hostname[":"port]"/"?][path]["?"querystring]["#"fragment]
        // extract fragment
        pos = string.indexOf('#');
        if (pos > -1) {
            // escaping?
            parts.fragment = string.substring(pos + 1) || null;
            string = string.substring(0, pos);
        }
        // extract query
        pos = string.indexOf('?');
        if (pos > -1) {
            // escaping?
            parts.query = string.substring(pos + 1) || null;
            string = string.substring(0, pos);
        }
        // slashes and backslashes have lost all meaning for the web protocols (https, http, wss, ws)
        string = string.replace(/^(https?|ftp|wss?)?:+[/\\]*/i, '$1://');
        // slashes and backslashes have lost all meaning for scheme relative URLs
        string = string.replace(/^[/\\]{2,}/i, '//');
        // extract protocol
        if (string.substring(0, 2) === '//') {
            // relative-scheme
            parts.protocol = null;
            string = string.substring(2);
            // extract "user:pass@host:port"
            string = URI.parseAuthority(string, parts);
        } else {
            pos = string.indexOf(':');
            if (pos > -1) {
                parts.protocol = string.substring(0, pos) || null;
                if (parts.protocol && !parts.protocol.match(URI.protocol_expression)) // : may be within the path
                parts.protocol = undefined;
                else if (string.substring(pos + 1, pos + 3).replace(/\\/g, '/') === '//') {
                    string = string.substring(pos + 3);
                    // extract "user:pass@host:port"
                    string = URI.parseAuthority(string, parts);
                } else {
                    string = string.substring(pos + 1);
                    parts.urn = true;
                }
            }
        }
        // what's left must be the path
        parts.path = string;
        // and we're done
        return parts;
    };
    URI.parseHost = function(string, parts) {
        if (!string) string = '';
        // Copy chrome, IE, opera backslash-handling behavior.
        // Back slashes before the query string get converted to forward slashes
        // See: https://github.com/joyent/node/blob/386fd24f49b0e9d1a8a076592a404168faeecc34/lib/url.js#L115-L124
        // See: https://code.google.com/p/chromium/issues/detail?id=25916
        // https://github.com/medialize/URI.js/pull/233
        string = string.replace(/\\/g, '/');
        // extract host:port
        var pos = string.indexOf('/');
        var bracketPos;
        var t;
        if (pos === -1) pos = string.length;
        if (string.charAt(0) === '[') {
            // IPv6 host - http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04#section-6
            // I claim most client software breaks on IPv6 anyways. To simplify things, URI only accepts
            // IPv6+port in the format [2001:db8::1]:80 (for the time being)
            bracketPos = string.indexOf(']');
            parts.hostname = string.substring(1, bracketPos) || null;
            parts.port = string.substring(bracketPos + 2, pos) || null;
            if (parts.port === '/') parts.port = null;
        } else {
            var firstColon = string.indexOf(':');
            var firstSlash = string.indexOf('/');
            var nextColon = string.indexOf(':', firstColon + 1);
            if (nextColon !== -1 && (firstSlash === -1 || nextColon < firstSlash)) {
                // IPv6 host contains multiple colons - but no port
                // this notation is actually not allowed by RFC 3986, but we're a liberal parser
                parts.hostname = string.substring(0, pos) || null;
                parts.port = null;
            } else {
                t = string.substring(0, pos).split(':');
                parts.hostname = t[0] || null;
                parts.port = t[1] || null;
            }
        }
        if (parts.hostname && string.substring(pos).charAt(0) !== '/') {
            pos++;
            string = '/' + string;
        }
        if (parts.preventInvalidHostname) URI.ensureValidHostname(parts.hostname, parts.protocol);
        if (parts.port) URI.ensureValidPort(parts.port);
        return string.substring(pos) || '/';
    };
    URI.parseAuthority = function(string, parts) {
        string = URI.parseUserinfo(string, parts);
        return URI.parseHost(string, parts);
    };
    URI.parseUserinfo = function(string, parts) {
        // extract username:password
        var _string = string;
        var firstBackSlash = string.indexOf('\\');
        if (firstBackSlash !== -1) string = string.replace(/\\/g, '/');
        var firstSlash = string.indexOf('/');
        var pos = string.lastIndexOf('@', firstSlash > -1 ? firstSlash : string.length - 1);
        var t;
        // authority@ must come before /path or \path
        if (pos > -1 && (firstSlash === -1 || pos < firstSlash)) {
            t = string.substring(0, pos).split(':');
            parts.username = t[0] ? URI.decode(t[0]) : null;
            t.shift();
            parts.password = t[0] ? URI.decode(t.join(':')) : null;
            string = _string.substring(pos + 1);
        } else {
            parts.username = null;
            parts.password = null;
        }
        return string;
    };
    URI.parseQuery = function(string, escapeQuerySpace) {
        if (!string) return {};
        // throw out the funky business - "?"[name"="value"&"]+
        string = string.replace(/&+/g, '&').replace(/^\?*&*|&+$/g, '');
        if (!string) return {};
        var items = {};
        var splits = string.split('&');
        var length = splits.length;
        var v, name, value;
        for(var i = 0; i < length; i++){
            v = splits[i].split('=');
            name = URI.decodeQuery(v.shift(), escapeQuerySpace);
            // no "=" is null according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#collect-url-parameters
            value = v.length ? URI.decodeQuery(v.join('='), escapeQuerySpace) : null;
            if (name === '__proto__') continue;
            else if (hasOwn.call(items, name)) {
                if (typeof items[name] === 'string' || items[name] === null) items[name] = [
                    items[name]
                ];
                items[name].push(value);
            } else items[name] = value;
        }
        return items;
    };
    URI.build = function(parts) {
        var t = '';
        var requireAbsolutePath = false;
        if (parts.protocol) t += parts.protocol + ':';
        if (!parts.urn && (t || parts.hostname)) {
            t += '//';
            requireAbsolutePath = true;
        }
        t += URI.buildAuthority(parts) || '';
        if (typeof parts.path === 'string') {
            if (parts.path.charAt(0) !== '/' && requireAbsolutePath) t += '/';
            t += parts.path;
        }
        if (typeof parts.query === 'string' && parts.query) t += '?' + parts.query;
        if (typeof parts.fragment === 'string' && parts.fragment) t += '#' + parts.fragment;
        return t;
    };
    URI.buildHost = function(parts) {
        var t = '';
        if (!parts.hostname) return '';
        else if (URI.ip6_expression.test(parts.hostname)) t += '[' + parts.hostname + ']';
        else t += parts.hostname;
        if (parts.port) t += ':' + parts.port;
        return t;
    };
    URI.buildAuthority = function(parts) {
        return URI.buildUserinfo(parts) + URI.buildHost(parts);
    };
    URI.buildUserinfo = function(parts) {
        var t = '';
        if (parts.username) t += URI.encode(parts.username);
        if (parts.password) t += ':' + URI.encode(parts.password);
        if (t) t += '@';
        return t;
    };
    URI.buildQuery = function(data, duplicateQueryParameters, escapeQuerySpace) {
        // according to http://tools.ietf.org/html/rfc3986 or http://labs.apache.org/webarch/uri/rfc/rfc3986.html
        // being »-._~!$&'()*+,;=:@/?« %HEX and alnum are allowed
        // the RFC explicitly states ?/foo being a valid use case, no mention of parameter syntax!
        // URI.js treats the query string as being application/x-www-form-urlencoded
        // see http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type
        var t = '';
        var unique, key, i, length;
        for(key in data){
            if (key === '__proto__') continue;
            else if (hasOwn.call(data, key)) {
                if (isArray(data[key])) {
                    unique = {};
                    for(i = 0, length = data[key].length; i < length; i++)if (data[key][i] !== undefined && unique[data[key][i] + ''] === undefined) {
                        t += '&' + URI.buildQueryParameter(key, data[key][i], escapeQuerySpace);
                        if (duplicateQueryParameters !== true) unique[data[key][i] + ''] = true;
                    }
                } else if (data[key] !== undefined) t += '&' + URI.buildQueryParameter(key, data[key], escapeQuerySpace);
            }
        }
        return t.substring(1);
    };
    URI.buildQueryParameter = function(name, value, escapeQuerySpace) {
        // http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type -- application/x-www-form-urlencoded
        // don't append "=" for null values, according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#url-parameter-serialization
        return URI.encodeQuery(name, escapeQuerySpace) + (value !== null ? '=' + URI.encodeQuery(value, escapeQuerySpace) : '');
    };
    URI.addQuery = function(data, name, value) {
        if (typeof name === 'object') {
            for(var key in name)if (hasOwn.call(name, key)) URI.addQuery(data, key, name[key]);
        } else if (typeof name === 'string') {
            if (data[name] === undefined) {
                data[name] = value;
                return;
            } else if (typeof data[name] === 'string') data[name] = [
                data[name]
            ];
            if (!isArray(value)) value = [
                value
            ];
            data[name] = (data[name] || []).concat(value);
        } else throw new TypeError('URI.addQuery() accepts an object, string as the name parameter');
    };
    URI.setQuery = function(data, name, value) {
        if (typeof name === 'object') {
            for(var key in name)if (hasOwn.call(name, key)) URI.setQuery(data, key, name[key]);
        } else if (typeof name === 'string') data[name] = value === undefined ? null : value;
        else throw new TypeError('URI.setQuery() accepts an object, string as the name parameter');
    };
    URI.removeQuery = function(data, name, value) {
        var i, length, key;
        if (isArray(name)) for(i = 0, length = name.length; i < length; i++)data[name[i]] = undefined;
        else if (getType(name) === 'RegExp') {
            for(key in data)if (name.test(key)) data[key] = undefined;
        } else if (typeof name === 'object') {
            for(key in name)if (hasOwn.call(name, key)) URI.removeQuery(data, key, name[key]);
        } else if (typeof name === 'string') {
            if (value !== undefined) {
                if (getType(value) === 'RegExp') {
                    if (!isArray(data[name]) && value.test(data[name])) data[name] = undefined;
                    else data[name] = filterArrayValues(data[name], value);
                } else if (data[name] === String(value) && (!isArray(value) || value.length === 1)) data[name] = undefined;
                else if (isArray(data[name])) data[name] = filterArrayValues(data[name], value);
            } else data[name] = undefined;
        } else throw new TypeError('URI.removeQuery() accepts an object, string, RegExp as the first parameter');
    };
    URI.hasQuery = function(data, name, value, withinArray) {
        switch(getType(name)){
            case 'String':
                break;
            case 'RegExp':
                for(var key in data)if (hasOwn.call(data, key)) {
                    if (name.test(key) && (value === undefined || URI.hasQuery(data, key, value))) return true;
                }
                return false;
            case 'Object':
                for(var _key in name)if (hasOwn.call(name, _key)) {
                    if (!URI.hasQuery(data, _key, name[_key])) return false;
                }
                return true;
            default:
                throw new TypeError('URI.hasQuery() accepts a string, regular expression or object as the name parameter');
        }
        switch(getType(value)){
            case 'Undefined':
                // true if exists (but may be empty)
                return name in data; // data[name] !== undefined;
            case 'Boolean':
                // true if exists and non-empty
                var _booly = Boolean(isArray(data[name]) ? data[name].length : data[name]);
                return value === _booly;
            case 'Function':
                // allow complex comparison
                return !!value(data[name], name, data);
            case 'Array':
                if (!isArray(data[name])) return false;
                var op = withinArray ? arrayContains : arraysEqual;
                return op(data[name], value);
            case 'RegExp':
                if (!isArray(data[name])) return Boolean(data[name] && data[name].match(value));
                if (!withinArray) return false;
                return arrayContains(data[name], value);
            case 'Number':
                value = String(value);
            /* falls through */ case 'String':
                if (!isArray(data[name])) return data[name] === value;
                if (!withinArray) return false;
                return arrayContains(data[name], value);
            default:
                throw new TypeError('URI.hasQuery() accepts undefined, boolean, string, number, RegExp, Function as the value parameter');
        }
    };
    URI.joinPaths = function() {
        var input = [];
        var segments = [];
        var nonEmptySegments = 0;
        for(var i = 0; i < arguments.length; i++){
            var url = new URI(arguments[i]);
            input.push(url);
            var _segments = url.segment();
            for(var s = 0; s < _segments.length; s++){
                if (typeof _segments[s] === 'string') segments.push(_segments[s]);
                if (_segments[s]) nonEmptySegments++;
            }
        }
        if (!segments.length || !nonEmptySegments) return new URI('');
        var uri = new URI('').segment(segments);
        if (input[0].path() === '' || input[0].path().slice(0, 1) === '/') uri.path('/' + uri.path());
        return uri.normalize();
    };
    URI.commonPath = function(one, two) {
        var length = Math.min(one.length, two.length);
        var pos;
        // find first non-matching character
        for(pos = 0; pos < length; pos++)if (one.charAt(pos) !== two.charAt(pos)) {
            pos--;
            break;
        }
        if (pos < 1) return one.charAt(0) === two.charAt(0) && one.charAt(0) === '/' ? '/' : '';
        // revert to last /
        if (one.charAt(pos) !== '/' || two.charAt(pos) !== '/') pos = one.substring(0, pos).lastIndexOf('/');
        return one.substring(0, pos + 1);
    };
    URI.withinString = function(string, callback, options) {
        options || (options = {});
        var _start = options.start || URI.findUri.start;
        var _end = options.end || URI.findUri.end;
        var _trim = options.trim || URI.findUri.trim;
        var _parens = options.parens || URI.findUri.parens;
        var _attributeOpen = /[a-z0-9-]=["']?$/i;
        _start.lastIndex = 0;
        while(true){
            var match = _start.exec(string);
            if (!match) break;
            var start = match.index;
            if (options.ignoreHtml) {
                // attribut(e=["']?$)
                var attributeOpen = string.slice(Math.max(start - 3, 0), start);
                if (attributeOpen && _attributeOpen.test(attributeOpen)) continue;
            }
            var end = start + string.slice(start).search(_end);
            var slice = string.slice(start, end);
            // make sure we include well balanced parens
            var parensEnd = -1;
            while(true){
                var parensMatch = _parens.exec(slice);
                if (!parensMatch) break;
                var parensMatchEnd = parensMatch.index + parensMatch[0].length;
                parensEnd = Math.max(parensEnd, parensMatchEnd);
            }
            if (parensEnd > -1) slice = slice.slice(0, parensEnd) + slice.slice(parensEnd).replace(_trim, '');
            else slice = slice.replace(_trim, '');
            if (slice.length <= match[0].length) continue;
            if (options.ignore && options.ignore.test(slice)) continue;
            end = start + slice.length;
            var result = callback(slice, start, end, string);
            if (result === undefined) {
                _start.lastIndex = end;
                continue;
            }
            result = String(result);
            string = string.slice(0, start) + result + string.slice(end);
            _start.lastIndex = start + result.length;
        }
        _start.lastIndex = 0;
        return string;
    };
    URI.ensureValidHostname = function(v, protocol) {
        // Theoretically URIs allow percent-encoding in Hostnames (according to RFC 3986)
        // they are not part of DNS and therefore ignored by URI.js
        var hasHostname = !!v; // not null and not an empty string
        var hasProtocol = !!protocol;
        var rejectEmptyHostname = false;
        if (hasProtocol) rejectEmptyHostname = arrayContains(URI.hostProtocols, protocol);
        if (rejectEmptyHostname && !hasHostname) throw new TypeError('Hostname cannot be empty, if protocol is ' + protocol);
        else if (v && v.match(URI.invalid_hostname_characters)) {
            // test punycode
            if (!punycode) throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-:_] and Punycode.js is not available');
            if (punycode.toASCII(v).match(URI.invalid_hostname_characters)) throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-:_]');
        }
    };
    URI.ensureValidPort = function(v) {
        if (!v) return;
        var port = Number(v);
        if (isInteger(port) && port > 0 && port < 65536) return;
        throw new TypeError('Port "' + v + '" is not a valid port');
    };
    // noConflict
    URI.noConflict = function(removeAll) {
        if (removeAll) {
            var unconflicted = {
                URI: this.noConflict()
            };
            if (root.URITemplate && typeof root.URITemplate.noConflict === 'function') unconflicted.URITemplate = root.URITemplate.noConflict();
            if (root.IPv6 && typeof root.IPv6.noConflict === 'function') unconflicted.IPv6 = root.IPv6.noConflict();
            if (root.SecondLevelDomains && typeof root.SecondLevelDomains.noConflict === 'function') unconflicted.SecondLevelDomains = root.SecondLevelDomains.noConflict();
            return unconflicted;
        } else if (root.URI === this) root.URI = _URI;
        return this;
    };
    p.build = function(deferBuild) {
        if (deferBuild === true) this._deferred_build = true;
        else if (deferBuild === undefined || this._deferred_build) {
            this._string = URI.build(this._parts);
            this._deferred_build = false;
        }
        return this;
    };
    p.clone = function() {
        return new URI(this);
    };
    p.valueOf = p.toString = function() {
        return this.build(false)._string;
    };
    function generateSimpleAccessor(_part) {
        return function(v, build) {
            if (v === undefined) return this._parts[_part] || '';
            else {
                this._parts[_part] = v || null;
                this.build(!build);
                return this;
            }
        };
    }
    function generatePrefixAccessor(_part, _key) {
        return function(v, build) {
            if (v === undefined) return this._parts[_part] || '';
            else {
                if (v !== null) {
                    v = v + '';
                    if (v.charAt(0) === _key) v = v.substring(1);
                }
                this._parts[_part] = v;
                this.build(!build);
                return this;
            }
        };
    }
    p.protocol = generateSimpleAccessor('protocol');
    p.username = generateSimpleAccessor('username');
    p.password = generateSimpleAccessor('password');
    p.hostname = generateSimpleAccessor('hostname');
    p.port = generateSimpleAccessor('port');
    p.query = generatePrefixAccessor('query', '?');
    p.fragment = generatePrefixAccessor('fragment', '#');
    p.search = function(v, build) {
        var t = this.query(v, build);
        return typeof t === 'string' && t.length ? '?' + t : t;
    };
    p.hash = function(v, build) {
        var t = this.fragment(v, build);
        return typeof t === 'string' && t.length ? '#' + t : t;
    };
    p.pathname = function(v, build) {
        if (v === undefined || v === true) {
            var res = this._parts.path || (this._parts.hostname ? '/' : '');
            return v ? (this._parts.urn ? URI.decodeUrnPath : URI.decodePath)(res) : res;
        } else {
            if (this._parts.urn) this._parts.path = v ? URI.recodeUrnPath(v) : '';
            else this._parts.path = v ? URI.recodePath(v) : '/';
            this.build(!build);
            return this;
        }
    };
    p.path = p.pathname;
    p.href = function(href, build) {
        var key;
        if (href === undefined) return this.toString();
        this._string = '';
        this._parts = URI._parts();
        var _URI = href instanceof URI;
        var _object = typeof href === 'object' && (href.hostname || href.path || href.pathname);
        if (href.nodeName) {
            var attribute = URI.getDomAttribute(href);
            href = href[attribute] || '';
            _object = false;
        }
        // window.location is reported to be an object, but it's not the sort
        // of object we're looking for:
        // * location.protocol ends with a colon
        // * location.query != object.search
        // * location.hash != object.fragment
        // simply serializing the unknown object should do the trick
        // (for location, not for everything...)
        if (!_URI && _object && href.pathname !== undefined) href = href.toString();
        if (typeof href === 'string' || href instanceof String) this._parts = URI.parse(String(href), this._parts);
        else if (_URI || _object) {
            var src = _URI ? href._parts : href;
            for(key in src){
                if (key === 'query') continue;
                if (hasOwn.call(this._parts, key)) this._parts[key] = src[key];
            }
            if (src.query) this.query(src.query, false);
        } else throw new TypeError('invalid input');
        this.build(!build);
        return this;
    };
    // identification accessors
    p.is = function(what) {
        var ip = false;
        var ip4 = false;
        var ip6 = false;
        var name = false;
        var sld = false;
        var idn = false;
        var punycode = false;
        var relative = !this._parts.urn;
        if (this._parts.hostname) {
            relative = false;
            ip4 = URI.ip4_expression.test(this._parts.hostname);
            ip6 = URI.ip6_expression.test(this._parts.hostname);
            ip = ip4 || ip6;
            name = !ip;
            sld = name && SLD && SLD.has(this._parts.hostname);
            idn = name && URI.idn_expression.test(this._parts.hostname);
            punycode = name && URI.punycode_expression.test(this._parts.hostname);
        }
        switch(what.toLowerCase()){
            case 'relative':
                return relative;
            case 'absolute':
                return !relative;
            // hostname identification
            case 'domain':
            case 'name':
                return name;
            case 'sld':
                return sld;
            case 'ip':
                return ip;
            case 'ip4':
            case 'ipv4':
            case 'inet4':
                return ip4;
            case 'ip6':
            case 'ipv6':
            case 'inet6':
                return ip6;
            case 'idn':
                return idn;
            case 'url':
                return !this._parts.urn;
            case 'urn':
                return !!this._parts.urn;
            case 'punycode':
                return punycode;
        }
        return null;
    };
    // component specific input validation
    var _protocol = p.protocol;
    var _port = p.port;
    var _hostname = p.hostname;
    p.protocol = function(v, build) {
        if (v) {
            // accept trailing ://
            v = v.replace(/:(\/\/)?$/, '');
            if (!v.match(URI.protocol_expression)) throw new TypeError('Protocol "' + v + '" contains characters other than [A-Z0-9.+-] or doesn\'t start with [A-Z]');
        }
        return _protocol.call(this, v, build);
    };
    p.scheme = p.protocol;
    p.port = function(v, build) {
        if (this._parts.urn) return v === undefined ? '' : this;
        if (v !== undefined) {
            if (v === 0) v = null;
            if (v) {
                v += '';
                if (v.charAt(0) === ':') v = v.substring(1);
                URI.ensureValidPort(v);
            }
        }
        return _port.call(this, v, build);
    };
    p.hostname = function(v, build) {
        if (this._parts.urn) return v === undefined ? '' : this;
        if (v !== undefined) {
            var x = {
                preventInvalidHostname: this._parts.preventInvalidHostname
            };
            var res = URI.parseHost(v, x);
            if (res !== '/') throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
            v = x.hostname;
            if (this._parts.preventInvalidHostname) URI.ensureValidHostname(v, this._parts.protocol);
        }
        return _hostname.call(this, v, build);
    };
    // compound accessors
    p.origin = function(v, build) {
        if (this._parts.urn) return v === undefined ? '' : this;
        if (v === undefined) {
            var protocol = this.protocol();
            var authority = this.authority();
            if (!authority) return '';
            return (protocol ? protocol + '://' : '') + this.authority();
        } else {
            var origin = URI(v);
            this.protocol(origin.protocol()).authority(origin.authority()).build(!build);
            return this;
        }
    };
    p.host = function(v, build) {
        if (this._parts.urn) return v === undefined ? '' : this;
        if (v === undefined) return this._parts.hostname ? URI.buildHost(this._parts) : '';
        else {
            var res = URI.parseHost(v, this._parts);
            if (res !== '/') throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
            this.build(!build);
            return this;
        }
    };
    p.authority = function(v, build) {
        if (this._parts.urn) return v === undefined ? '' : this;
        if (v === undefined) return this._parts.hostname ? URI.buildAuthority(this._parts) : '';
        else {
            var res = URI.parseAuthority(v, this._parts);
            if (res !== '/') throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
            this.build(!build);
            return this;
        }
    };
    p.userinfo = function(v, build) {
        if (this._parts.urn) return v === undefined ? '' : this;
        if (v === undefined) {
            var t = URI.buildUserinfo(this._parts);
            return t ? t.substring(0, t.length - 1) : t;
        } else {
            if (v[v.length - 1] !== '@') v += '@';
            URI.parseUserinfo(v, this._parts);
            this.build(!build);
            return this;
        }
    };
    p.resource = function(v, build) {
        var parts;
        if (v === undefined) return this.path() + this.search() + this.hash();
        parts = URI.parse(v);
        this._parts.path = parts.path;
        this._parts.query = parts.query;
        this._parts.fragment = parts.fragment;
        this.build(!build);
        return this;
    };
    // fraction accessors
    p.subdomain = function(v, build) {
        if (this._parts.urn) return v === undefined ? '' : this;
        // convenience, return "www" from "www.example.org"
        if (v === undefined) {
            if (!this._parts.hostname || this.is('IP')) return '';
            // grab domain and add another segment
            var end = this._parts.hostname.length - this.domain().length - 1;
            return this._parts.hostname.substring(0, end) || '';
        } else {
            var e = this._parts.hostname.length - this.domain().length;
            var sub = this._parts.hostname.substring(0, e);
            var replace = new RegExp('^' + escapeRegEx(sub));
            if (v && v.charAt(v.length - 1) !== '.') v += '.';
            if (v.indexOf(':') !== -1) throw new TypeError('Domains cannot contain colons');
            if (v) URI.ensureValidHostname(v, this._parts.protocol);
            this._parts.hostname = this._parts.hostname.replace(replace, v);
            this.build(!build);
            return this;
        }
    };
    p.domain = function(v, build) {
        if (this._parts.urn) return v === undefined ? '' : this;
        if (typeof v === 'boolean') {
            build = v;
            v = undefined;
        }
        // convenience, return "example.org" from "www.example.org"
        if (v === undefined) {
            if (!this._parts.hostname || this.is('IP')) return '';
            // if hostname consists of 1 or 2 segments, it must be the domain
            var t = this._parts.hostname.match(/\./g);
            if (t && t.length < 2) return this._parts.hostname;
            // grab tld and add another segment
            var end = this._parts.hostname.length - this.tld(build).length - 1;
            end = this._parts.hostname.lastIndexOf('.', end - 1) + 1;
            return this._parts.hostname.substring(end) || '';
        } else {
            if (!v) throw new TypeError('cannot set domain empty');
            if (v.indexOf(':') !== -1) throw new TypeError('Domains cannot contain colons');
            URI.ensureValidHostname(v, this._parts.protocol);
            if (!this._parts.hostname || this.is('IP')) this._parts.hostname = v;
            else {
                var replace = new RegExp(escapeRegEx(this.domain()) + '$');
                this._parts.hostname = this._parts.hostname.replace(replace, v);
            }
            this.build(!build);
            return this;
        }
    };
    p.tld = function(v, build) {
        if (this._parts.urn) return v === undefined ? '' : this;
        if (typeof v === 'boolean') {
            build = v;
            v = undefined;
        }
        // return "org" from "www.example.org"
        if (v === undefined) {
            if (!this._parts.hostname || this.is('IP')) return '';
            var pos = this._parts.hostname.lastIndexOf('.');
            var tld = this._parts.hostname.substring(pos + 1);
            if (build !== true && SLD && SLD.list[tld.toLowerCase()]) return SLD.get(this._parts.hostname) || tld;
            return tld;
        } else {
            var replace;
            if (!v) throw new TypeError('cannot set TLD empty');
            else if (v.match(/[^a-zA-Z0-9-]/)) {
                if (SLD && SLD.is(v)) {
                    replace = new RegExp(escapeRegEx(this.tld()) + '$');
                    this._parts.hostname = this._parts.hostname.replace(replace, v);
                } else throw new TypeError('TLD "' + v + '" contains characters other than [A-Z0-9]');
            } else if (!this._parts.hostname || this.is('IP')) throw new ReferenceError('cannot set TLD on non-domain host');
            else {
                replace = new RegExp(escapeRegEx(this.tld()) + '$');
                this._parts.hostname = this._parts.hostname.replace(replace, v);
            }
            this.build(!build);
            return this;
        }
    };
    p.directory = function(v, build) {
        if (this._parts.urn) return v === undefined ? '' : this;
        if (v === undefined || v === true) {
            if (!this._parts.path && !this._parts.hostname) return '';
            if (this._parts.path === '/') return '/';
            var end = this._parts.path.length - this.filename().length - 1;
            var res = this._parts.path.substring(0, end) || (this._parts.hostname ? '/' : '');
            return v ? URI.decodePath(res) : res;
        } else {
            var e = this._parts.path.length - this.filename().length;
            var directory = this._parts.path.substring(0, e);
            var replace = new RegExp('^' + escapeRegEx(directory));
            // fully qualifier directories begin with a slash
            if (!this.is('relative')) {
                if (!v) v = '/';
                if (v.charAt(0) !== '/') v = '/' + v;
            }
            // directories always end with a slash
            if (v && v.charAt(v.length - 1) !== '/') v += '/';
            v = URI.recodePath(v);
            this._parts.path = this._parts.path.replace(replace, v);
            this.build(!build);
            return this;
        }
    };
    p.filename = function(v, build) {
        if (this._parts.urn) return v === undefined ? '' : this;
        if (typeof v !== 'string') {
            if (!this._parts.path || this._parts.path === '/') return '';
            var pos = this._parts.path.lastIndexOf('/');
            var res = this._parts.path.substring(pos + 1);
            return v ? URI.decodePathSegment(res) : res;
        } else {
            var mutatedDirectory = false;
            if (v.charAt(0) === '/') v = v.substring(1);
            if (v.match(/\.?\//)) mutatedDirectory = true;
            var replace = new RegExp(escapeRegEx(this.filename()) + '$');
            v = URI.recodePath(v);
            this._parts.path = this._parts.path.replace(replace, v);
            if (mutatedDirectory) this.normalizePath(build);
            else this.build(!build);
            return this;
        }
    };
    p.suffix = function(v, build) {
        if (this._parts.urn) return v === undefined ? '' : this;
        if (v === undefined || v === true) {
            if (!this._parts.path || this._parts.path === '/') return '';
            var filename = this.filename();
            var pos = filename.lastIndexOf('.');
            var s, res;
            if (pos === -1) return '';
            // suffix may only contain alnum characters (yup, I made this up.)
            s = filename.substring(pos + 1);
            res = /^[a-z0-9%]+$/i.test(s) ? s : '';
            return v ? URI.decodePathSegment(res) : res;
        } else {
            if (v.charAt(0) === '.') v = v.substring(1);
            var suffix = this.suffix();
            var replace;
            if (!suffix) {
                if (!v) return this;
                this._parts.path += '.' + URI.recodePath(v);
            } else if (!v) replace = new RegExp(escapeRegEx('.' + suffix) + '$');
            else replace = new RegExp(escapeRegEx(suffix) + '$');
            if (replace) {
                v = URI.recodePath(v);
                this._parts.path = this._parts.path.replace(replace, v);
            }
            this.build(!build);
            return this;
        }
    };
    p.segment = function(segment, v, build) {
        var separator = this._parts.urn ? ':' : '/';
        var path = this.path();
        var absolute = path.substring(0, 1) === '/';
        var segments = path.split(separator);
        if (segment !== undefined && typeof segment !== 'number') {
            build = v;
            v = segment;
            segment = undefined;
        }
        if (segment !== undefined && typeof segment !== 'number') throw new Error('Bad segment "' + segment + '", must be 0-based integer');
        if (absolute) segments.shift();
        if (segment < 0) // allow negative indexes to address from the end
        segment = Math.max(segments.length + segment, 0);
        if (v === undefined) /*jshint laxbreak: true */ return segment === undefined ? segments : segments[segment];
        else if (segment === null || segments[segment] === undefined) {
            if (isArray(v)) {
                segments = [];
                // collapse empty elements within array
                for(var i = 0, l = v.length; i < l; i++){
                    if (!v[i].length && (!segments.length || !segments[segments.length - 1].length)) continue;
                    if (segments.length && !segments[segments.length - 1].length) segments.pop();
                    segments.push(trimSlashes(v[i]));
                }
            } else if (v || typeof v === 'string') {
                v = trimSlashes(v);
                if (segments[segments.length - 1] === '') // empty trailing elements have to be overwritten
                // to prevent results such as /foo//bar
                segments[segments.length - 1] = v;
                else segments.push(v);
            }
        } else if (v) segments[segment] = trimSlashes(v);
        else segments.splice(segment, 1);
        if (absolute) segments.unshift('');
        return this.path(segments.join(separator), build);
    };
    p.segmentCoded = function(segment, v, build) {
        var segments, i, l;
        if (typeof segment !== 'number') {
            build = v;
            v = segment;
            segment = undefined;
        }
        if (v === undefined) {
            segments = this.segment(segment, v, build);
            if (!isArray(segments)) segments = segments !== undefined ? URI.decode(segments) : undefined;
            else for(i = 0, l = segments.length; i < l; i++)segments[i] = URI.decode(segments[i]);
            return segments;
        }
        if (!isArray(v)) v = typeof v === 'string' || v instanceof String ? URI.encode(v) : v;
        else for(i = 0, l = v.length; i < l; i++)v[i] = URI.encode(v[i]);
        return this.segment(segment, v, build);
    };
    // mutating query string
    var q = p.query;
    p.query = function(v, build) {
        if (v === true) return URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
        else if (typeof v === 'function') {
            var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
            var result = v.call(this, data);
            this._parts.query = URI.buildQuery(result || data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
            this.build(!build);
            return this;
        } else if (v !== undefined && typeof v !== 'string') {
            this._parts.query = URI.buildQuery(v, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
            this.build(!build);
            return this;
        } else return q.call(this, v, build);
    };
    p.setQuery = function(name, value, build) {
        var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
        if (typeof name === 'string' || name instanceof String) data[name] = value !== undefined ? value : null;
        else if (typeof name === 'object') {
            for(var key in name)if (hasOwn.call(name, key)) data[key] = name[key];
        } else throw new TypeError('URI.addQuery() accepts an object, string as the name parameter');
        this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
        if (typeof name !== 'string') build = value;
        this.build(!build);
        return this;
    };
    p.addQuery = function(name, value, build) {
        var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
        URI.addQuery(data, name, value === undefined ? null : value);
        this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
        if (typeof name !== 'string') build = value;
        this.build(!build);
        return this;
    };
    p.removeQuery = function(name, value, build) {
        var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
        URI.removeQuery(data, name, value);
        this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
        if (typeof name !== 'string') build = value;
        this.build(!build);
        return this;
    };
    p.hasQuery = function(name, value, withinArray) {
        var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
        return URI.hasQuery(data, name, value, withinArray);
    };
    p.setSearch = p.setQuery;
    p.addSearch = p.addQuery;
    p.removeSearch = p.removeQuery;
    p.hasSearch = p.hasQuery;
    // sanitizing URLs
    p.normalize = function() {
        if (this._parts.urn) return this.normalizeProtocol(false).normalizePath(false).normalizeQuery(false).normalizeFragment(false).build();
        return this.normalizeProtocol(false).normalizeHostname(false).normalizePort(false).normalizePath(false).normalizeQuery(false).normalizeFragment(false).build();
    };
    p.normalizeProtocol = function(build) {
        if (typeof this._parts.protocol === 'string') {
            this._parts.protocol = this._parts.protocol.toLowerCase();
            this.build(!build);
        }
        return this;
    };
    p.normalizeHostname = function(build) {
        if (this._parts.hostname) {
            if (this.is('IDN') && punycode) this._parts.hostname = punycode.toASCII(this._parts.hostname);
            else if (this.is('IPv6') && IPv6) this._parts.hostname = IPv6.best(this._parts.hostname);
            this._parts.hostname = this._parts.hostname.toLowerCase();
            this.build(!build);
        }
        return this;
    };
    p.normalizePort = function(build) {
        // remove port of it's the protocol's default
        if (typeof this._parts.protocol === 'string' && this._parts.port === URI.defaultPorts[this._parts.protocol]) {
            this._parts.port = null;
            this.build(!build);
        }
        return this;
    };
    p.normalizePath = function(build) {
        var _path = this._parts.path;
        if (!_path) return this;
        if (this._parts.urn) {
            this._parts.path = URI.recodeUrnPath(this._parts.path);
            this.build(!build);
            return this;
        }
        if (this._parts.path === '/') return this;
        _path = URI.recodePath(_path);
        var _was_relative;
        var _leadingParents = '';
        var _parent, _pos;
        // handle relative paths
        if (_path.charAt(0) !== '/') {
            _was_relative = true;
            _path = '/' + _path;
        }
        // handle relative files (as opposed to directories)
        if (_path.slice(-3) === '/..' || _path.slice(-2) === '/.') _path += '/';
        // resolve simples
        _path = _path.replace(/(\/(\.\/)+)|(\/\.$)/g, '/').replace(/\/{2,}/g, '/');
        // remember leading parents
        if (_was_relative) {
            _leadingParents = _path.substring(1).match(/^(\.\.\/)+/) || '';
            if (_leadingParents) _leadingParents = _leadingParents[0];
        }
        // resolve parents
        while(true){
            _parent = _path.search(/\/\.\.(\/|$)/);
            if (_parent === -1) break;
            else if (_parent === 0) {
                // top level cannot be relative, skip it
                _path = _path.substring(3);
                continue;
            }
            _pos = _path.substring(0, _parent).lastIndexOf('/');
            if (_pos === -1) _pos = _parent;
            _path = _path.substring(0, _pos) + _path.substring(_parent + 3);
        }
        // revert to relative
        if (_was_relative && this.is('relative')) _path = _leadingParents + _path.substring(1);
        this._parts.path = _path;
        this.build(!build);
        return this;
    };
    p.normalizePathname = p.normalizePath;
    p.normalizeQuery = function(build) {
        if (typeof this._parts.query === 'string') {
            if (!this._parts.query.length) this._parts.query = null;
            else this.query(URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace));
            this.build(!build);
        }
        return this;
    };
    p.normalizeFragment = function(build) {
        if (!this._parts.fragment) {
            this._parts.fragment = null;
            this.build(!build);
        }
        return this;
    };
    p.normalizeSearch = p.normalizeQuery;
    p.normalizeHash = p.normalizeFragment;
    p.iso8859 = function() {
        // expect unicode input, iso8859 output
        var e = URI.encode;
        var d = URI.decode;
        URI.encode = escape;
        URI.decode = decodeURIComponent;
        try {
            this.normalize();
        } finally{
            URI.encode = e;
            URI.decode = d;
        }
        return this;
    };
    p.unicode = function() {
        // expect iso8859 input, unicode output
        var e = URI.encode;
        var d = URI.decode;
        URI.encode = strictEncodeURIComponent;
        URI.decode = unescape;
        try {
            this.normalize();
        } finally{
            URI.encode = e;
            URI.decode = d;
        }
        return this;
    };
    p.readable = function() {
        var uri = this.clone();
        // removing username, password, because they shouldn't be displayed according to RFC 3986
        uri.username('').password('').normalize();
        var t = '';
        if (uri._parts.protocol) t += uri._parts.protocol + '://';
        if (uri._parts.hostname) {
            if (uri.is('punycode') && punycode) {
                t += punycode.toUnicode(uri._parts.hostname);
                if (uri._parts.port) t += ':' + uri._parts.port;
            } else t += uri.host();
        }
        if (uri._parts.hostname && uri._parts.path && uri._parts.path.charAt(0) !== '/') t += '/';
        t += uri.path(true);
        if (uri._parts.query) {
            var q = '';
            for(var i = 0, qp = uri._parts.query.split('&'), l = qp.length; i < l; i++){
                var kv = (qp[i] || '').split('=');
                q += '&' + URI.decodeQuery(kv[0], this._parts.escapeQuerySpace).replace(/&/g, '%26');
                if (kv[1] !== undefined) q += '=' + URI.decodeQuery(kv[1], this._parts.escapeQuerySpace).replace(/&/g, '%26');
            }
            t += '?' + q.substring(1);
        }
        t += URI.decodeQuery(uri.hash(), true);
        return t;
    };
    // resolving relative and absolute URLs
    p.absoluteTo = function(base) {
        var resolved = this.clone();
        var properties = [
            'protocol',
            'username',
            'password',
            'hostname',
            'port'
        ];
        var basedir, i, p;
        if (this._parts.urn) throw new Error('URNs do not have any generally defined hierarchical components');
        if (!(base instanceof URI)) base = new URI(base);
        if (resolved._parts.protocol) // Directly returns even if this._parts.hostname is empty.
        return resolved;
        else resolved._parts.protocol = base._parts.protocol;
        if (this._parts.hostname) return resolved;
        for(i = 0; p = properties[i]; i++)resolved._parts[p] = base._parts[p];
        if (!resolved._parts.path) {
            resolved._parts.path = base._parts.path;
            if (!resolved._parts.query) resolved._parts.query = base._parts.query;
        } else {
            if (resolved._parts.path.substring(-2) === '..') resolved._parts.path += '/';
            if (resolved.path().charAt(0) !== '/') {
                basedir = base.directory();
                basedir = basedir ? basedir : base.path().indexOf('/') === 0 ? '/' : '';
                resolved._parts.path = (basedir ? basedir + '/' : '') + resolved._parts.path;
                resolved.normalizePath();
            }
        }
        resolved.build();
        return resolved;
    };
    p.relativeTo = function(base) {
        var relative = this.clone().normalize();
        var relativeParts, baseParts, common, relativePath, basePath;
        if (relative._parts.urn) throw new Error('URNs do not have any generally defined hierarchical components');
        base = new URI(base).normalize();
        relativeParts = relative._parts;
        baseParts = base._parts;
        relativePath = relative.path();
        basePath = base.path();
        if (relativePath.charAt(0) !== '/') throw new Error('URI is already relative');
        if (basePath.charAt(0) !== '/') throw new Error('Cannot calculate a URI relative to another relative URI');
        if (relativeParts.protocol === baseParts.protocol) relativeParts.protocol = null;
        if (relativeParts.username !== baseParts.username || relativeParts.password !== baseParts.password) return relative.build();
        if (relativeParts.protocol !== null || relativeParts.username !== null || relativeParts.password !== null) return relative.build();
        if (relativeParts.hostname === baseParts.hostname && relativeParts.port === baseParts.port) {
            relativeParts.hostname = null;
            relativeParts.port = null;
        } else return relative.build();
        if (relativePath === basePath) {
            relativeParts.path = '';
            return relative.build();
        }
        // determine common sub path
        common = URI.commonPath(relativePath, basePath);
        // If the paths have nothing in common, return a relative URL with the absolute path.
        if (!common) return relative.build();
        var parents = baseParts.path.substring(common.length).replace(/[^\/]*$/, '').replace(/.*?\//g, '../');
        relativeParts.path = parents + relativeParts.path.substring(common.length) || './';
        return relative.build();
    };
    // comparing URIs
    p.equals = function(uri) {
        var one = this.clone();
        var two = new URI(uri);
        var one_map = {};
        var two_map = {};
        var checked = {};
        var one_query, two_query, key;
        one.normalize();
        two.normalize();
        // exact match
        if (one.toString() === two.toString()) return true;
        // extract query string
        one_query = one.query();
        two_query = two.query();
        one.query('');
        two.query('');
        // definitely not equal if not even non-query parts match
        if (one.toString() !== two.toString()) return false;
        // query parameters have the same length, even if they're permuted
        if (one_query.length !== two_query.length) return false;
        one_map = URI.parseQuery(one_query, this._parts.escapeQuerySpace);
        two_map = URI.parseQuery(two_query, this._parts.escapeQuerySpace);
        for(key in one_map)if (hasOwn.call(one_map, key)) {
            if (!isArray(one_map[key])) {
                if (one_map[key] !== two_map[key]) return false;
            } else if (!arraysEqual(one_map[key], two_map[key])) return false;
            checked[key] = true;
        }
        for(key in two_map)if (hasOwn.call(two_map, key)) {
            if (!checked[key]) // two contains a parameter not present in one
            return false;
        }
        return true;
    };
    // state
    p.preventInvalidHostname = function(v) {
        this._parts.preventInvalidHostname = !!v;
        return this;
    };
    p.duplicateQueryParameters = function(v) {
        this._parts.duplicateQueryParameters = !!v;
        return this;
    };
    p.escapeQuerySpace = function(v) {
        this._parts.escapeQuerySpace = !!v;
        return this;
    };
    return URI;
});

},{"c0c01881d6d80b64":"k0AUp","a7a250f099ff4d9b":"hLocp","847a203e5519704d":"8pkDu"}],"k0AUp":[function(require,module,exports,__globalThis) {
/*! https://mths.be/punycode v1.4.0 by @mathias */ var global = arguments[3];
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof global == 'object' && global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = '';
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join('');
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error('not-basic');
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error('invalid-input');
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error('overflow');
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error('overflow');
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error('overflow');
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ 'version': '1.3.2',
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ 'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define('punycode', function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

},{}],"hLocp":[function(require,module,exports,__globalThis) {
/*!
 * URI.js - Mutating URLs
 * IPv6 Support
 *
 * Version: 1.19.11
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */ (function(root, factory) {
    'use strict';
    // https://github.com/umdjs/umd/blob/master/returnExports.js
    if (module.exports) // Node
    module.exports = factory();
    else if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(factory);
    else // Browser globals (root is window)
    root.IPv6 = factory(root);
})(this, function(root) {
    'use strict';
    /*
  var _in = "fe80:0000:0000:0000:0204:61ff:fe9d:f156";
  var _out = IPv6.best(_in);
  var _expected = "fe80::204:61ff:fe9d:f156";

  console.log(_in, _out, _expected, _out === _expected);
  */ // save current IPv6 variable, if any
    var _IPv6 = root && root.IPv6;
    function bestPresentation(address) {
        // based on:
        // Javascript to test an IPv6 address for proper format, and to
        // present the "best text representation" according to IETF Draft RFC at
        // http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04
        // 8 Feb 2010 Rich Brown, Dartware, LLC
        // Please feel free to use this code as long as you provide a link to
        // http://www.intermapper.com
        // http://intermapper.com/support/tools/IPV6-Validator.aspx
        // http://download.dartware.com/thirdparty/ipv6validator.js
        var _address = address.toLowerCase();
        var segments = _address.split(':');
        var length = segments.length;
        var total = 8;
        // trim colons (:: or ::a:b:c… or …a:b:c::)
        if (segments[0] === '' && segments[1] === '' && segments[2] === '') {
            // must have been ::
            // remove first two items
            segments.shift();
            segments.shift();
        } else if (segments[0] === '' && segments[1] === '') // must have been ::xxxx
        // remove the first item
        segments.shift();
        else if (segments[length - 1] === '' && segments[length - 2] === '') // must have been xxxx::
        segments.pop();
        length = segments.length;
        // adjust total segments for IPv4 trailer
        if (segments[length - 1].indexOf('.') !== -1) // found a "." which means IPv4
        total = 7;
        // fill empty segments them with "0000"
        var pos;
        for(pos = 0; pos < length; pos++){
            if (segments[pos] === '') break;
        }
        if (pos < total) {
            segments.splice(pos, 1, '0000');
            while(segments.length < total)segments.splice(pos, 0, '0000');
        }
        // strip leading zeros
        var _segments;
        for(var i = 0; i < total; i++){
            _segments = segments[i].split('');
            for(var j = 0; j < 3; j++){
                if (_segments[0] === '0' && _segments.length > 1) _segments.splice(0, 1);
                else break;
            }
            segments[i] = _segments.join('');
        }
        // find longest sequence of zeroes and coalesce them into one segment
        var best = -1;
        var _best = 0;
        var _current = 0;
        var current = -1;
        var inzeroes = false;
        // i; already declared
        for(i = 0; i < total; i++){
            if (inzeroes) {
                if (segments[i] === '0') _current += 1;
                else {
                    inzeroes = false;
                    if (_current > _best) {
                        best = current;
                        _best = _current;
                    }
                }
            } else if (segments[i] === '0') {
                inzeroes = true;
                current = i;
                _current = 1;
            }
        }
        if (_current > _best) {
            best = current;
            _best = _current;
        }
        if (_best > 1) segments.splice(best, _best, '');
        length = segments.length;
        // assemble remaining segments
        var result = '';
        if (segments[0] === '') result = ':';
        for(i = 0; i < length; i++){
            result += segments[i];
            if (i === length - 1) break;
            result += ':';
        }
        if (segments[length - 1] === '') result += ':';
        return result;
    }
    function noConflict() {
        /*jshint validthis: true */ if (root.IPv6 === this) root.IPv6 = _IPv6;
        return this;
    }
    return {
        best: bestPresentation,
        noConflict: noConflict
    };
});

},{}],"8pkDu":[function(require,module,exports,__globalThis) {
/*!
 * URI.js - Mutating URLs
 * Second Level Domain (SLD) Support
 *
 * Version: 1.19.11
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */ (function(root, factory) {
    'use strict';
    // https://github.com/umdjs/umd/blob/master/returnExports.js
    if (module.exports) // Node
    module.exports = factory();
    else if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(factory);
    else // Browser globals (root is window)
    root.SecondLevelDomains = factory(root);
})(this, function(root) {
    'use strict';
    // save current SecondLevelDomains variable, if any
    var _SecondLevelDomains = root && root.SecondLevelDomains;
    var SLD = {
        // list of known Second Level Domains
        // converted list of SLDs from https://github.com/gavingmiller/second-level-domains
        // ----
        // publicsuffix.org is more current and actually used by a couple of browsers internally.
        // downside is it also contains domains like "dyndns.org" - which is fine for the security
        // issues browser have to deal with (SOP for cookies, etc) - but is way overboard for URI.js
        // ----
        list: {
            'ac': ' com gov mil net org ',
            'ae': ' ac co gov mil name net org pro sch ',
            'af': ' com edu gov net org ',
            'al': ' com edu gov mil net org ',
            'ao': ' co ed gv it og pb ',
            'ar': ' com edu gob gov int mil net org tur ',
            'at': ' ac co gv or ',
            'au': ' asn com csiro edu gov id net org ',
            'ba': ' co com edu gov mil net org rs unbi unmo unsa untz unze ',
            'bb': ' biz co com edu gov info net org store tv ',
            'bh': ' biz cc com edu gov info net org ',
            'bn': ' com edu gov net org ',
            'bo': ' com edu gob gov int mil net org tv ',
            'br': ' adm adv agr am arq art ato b bio blog bmd cim cng cnt com coop ecn edu eng esp etc eti far flog fm fnd fot fst g12 ggf gov imb ind inf jor jus lel mat med mil mus net nom not ntr odo org ppg pro psc psi qsl rec slg srv tmp trd tur tv vet vlog wiki zlg ',
            'bs': ' com edu gov net org ',
            'bz': ' du et om ov rg ',
            'ca': ' ab bc mb nb nf nl ns nt nu on pe qc sk yk ',
            'ck': ' biz co edu gen gov info net org ',
            'cn': ' ac ah bj com cq edu fj gd gov gs gx gz ha hb he hi hl hn jl js jx ln mil net nm nx org qh sc sd sh sn sx tj tw xj xz yn zj ',
            'co': ' com edu gov mil net nom org ',
            'cr': ' ac c co ed fi go or sa ',
            'cy': ' ac biz com ekloges gov ltd name net org parliament press pro tm ',
            'do': ' art com edu gob gov mil net org sld web ',
            'dz': ' art asso com edu gov net org pol ',
            'ec': ' com edu fin gov info med mil net org pro ',
            'eg': ' com edu eun gov mil name net org sci ',
            'er': ' com edu gov ind mil net org rochest w ',
            'es': ' com edu gob nom org ',
            'et': ' biz com edu gov info name net org ',
            'fj': ' ac biz com info mil name net org pro ',
            'fk': ' ac co gov net nom org ',
            'fr': ' asso com f gouv nom prd presse tm ',
            'gg': ' co net org ',
            'gh': ' com edu gov mil org ',
            'gn': ' ac com gov net org ',
            'gr': ' com edu gov mil net org ',
            'gt': ' com edu gob ind mil net org ',
            'gu': ' com edu gov net org ',
            'hk': ' com edu gov idv net org ',
            'hu': ' 2000 agrar bolt casino city co erotica erotika film forum games hotel info ingatlan jogasz konyvelo lakas media news org priv reklam sex shop sport suli szex tm tozsde utazas video ',
            'id': ' ac co go mil net or sch web ',
            'il': ' ac co gov idf k12 muni net org ',
            'in': ' ac co edu ernet firm gen gov i ind mil net nic org res ',
            'iq': ' com edu gov i mil net org ',
            'ir': ' ac co dnssec gov i id net org sch ',
            'it': ' edu gov ',
            'je': ' co net org ',
            'jo': ' com edu gov mil name net org sch ',
            'jp': ' ac ad co ed go gr lg ne or ',
            'ke': ' ac co go info me mobi ne or sc ',
            'kh': ' com edu gov mil net org per ',
            'ki': ' biz com de edu gov info mob net org tel ',
            'km': ' asso com coop edu gouv k medecin mil nom notaires pharmaciens presse tm veterinaire ',
            'kn': ' edu gov net org ',
            'kr': ' ac busan chungbuk chungnam co daegu daejeon es gangwon go gwangju gyeongbuk gyeonggi gyeongnam hs incheon jeju jeonbuk jeonnam k kg mil ms ne or pe re sc seoul ulsan ',
            'kw': ' com edu gov net org ',
            'ky': ' com edu gov net org ',
            'kz': ' com edu gov mil net org ',
            'lb': ' com edu gov net org ',
            'lk': ' assn com edu gov grp hotel int ltd net ngo org sch soc web ',
            'lr': ' com edu gov net org ',
            'lv': ' asn com conf edu gov id mil net org ',
            'ly': ' com edu gov id med net org plc sch ',
            'ma': ' ac co gov m net org press ',
            'mc': ' asso tm ',
            'me': ' ac co edu gov its net org priv ',
            'mg': ' com edu gov mil nom org prd tm ',
            'mk': ' com edu gov inf name net org pro ',
            'ml': ' com edu gov net org presse ',
            'mn': ' edu gov org ',
            'mo': ' com edu gov net org ',
            'mt': ' com edu gov net org ',
            'mv': ' aero biz com coop edu gov info int mil museum name net org pro ',
            'mw': ' ac co com coop edu gov int museum net org ',
            'mx': ' com edu gob net org ',
            'my': ' com edu gov mil name net org sch ',
            'nf': ' arts com firm info net other per rec store web ',
            'ng': ' biz com edu gov mil mobi name net org sch ',
            'ni': ' ac co com edu gob mil net nom org ',
            'np': ' com edu gov mil net org ',
            'nr': ' biz com edu gov info net org ',
            'om': ' ac biz co com edu gov med mil museum net org pro sch ',
            'pe': ' com edu gob mil net nom org sld ',
            'ph': ' com edu gov i mil net ngo org ',
            'pk': ' biz com edu fam gob gok gon gop gos gov net org web ',
            'pl': ' art bialystok biz com edu gda gdansk gorzow gov info katowice krakow lodz lublin mil net ngo olsztyn org poznan pwr radom slupsk szczecin torun warszawa waw wroc wroclaw zgora ',
            'pr': ' ac biz com edu est gov info isla name net org pro prof ',
            'ps': ' com edu gov net org plo sec ',
            'pw': ' belau co ed go ne or ',
            'ro': ' arts com firm info nom nt org rec store tm www ',
            'rs': ' ac co edu gov in org ',
            'sb': ' com edu gov net org ',
            'sc': ' com edu gov net org ',
            'sh': ' co com edu gov net nom org ',
            'sl': ' com edu gov net org ',
            'st': ' co com consulado edu embaixada gov mil net org principe saotome store ',
            'sv': ' com edu gob org red ',
            'sz': ' ac co org ',
            'tr': ' av bbs bel biz com dr edu gen gov info k12 name net org pol tel tsk tv web ',
            'tt': ' aero biz cat co com coop edu gov info int jobs mil mobi museum name net org pro tel travel ',
            'tw': ' club com ebiz edu game gov idv mil net org ',
            'mu': ' ac co com gov net or org ',
            'mz': ' ac co edu gov org ',
            'na': ' co com ',
            'nz': ' ac co cri geek gen govt health iwi maori mil net org parliament school ',
            'pa': ' abo ac com edu gob ing med net nom org sld ',
            'pt': ' com edu gov int net nome org publ ',
            'py': ' com edu gov mil net org ',
            'qa': ' com edu gov mil net org ',
            're': ' asso com nom ',
            'ru': ' ac adygeya altai amur arkhangelsk astrakhan bashkiria belgorod bir bryansk buryatia cbg chel chelyabinsk chita chukotka chuvashia com dagestan e-burg edu gov grozny int irkutsk ivanovo izhevsk jar joshkar-ola kalmykia kaluga kamchatka karelia kazan kchr kemerovo khabarovsk khakassia khv kirov koenig komi kostroma kranoyarsk kuban kurgan kursk lipetsk magadan mari mari-el marine mil mordovia mosreg msk murmansk nalchik net nnov nov novosibirsk nsk omsk orenburg org oryol penza perm pp pskov ptz rnd ryazan sakhalin samara saratov simbirsk smolensk spb stavropol stv surgut tambov tatarstan tom tomsk tsaritsyn tsk tula tuva tver tyumen udm udmurtia ulan-ude vladikavkaz vladimir vladivostok volgograd vologda voronezh vrn vyatka yakutia yamal yekaterinburg yuzhno-sakhalinsk ',
            'rw': ' ac co com edu gouv gov int mil net ',
            'sa': ' com edu gov med net org pub sch ',
            'sd': ' com edu gov info med net org tv ',
            'se': ' a ac b bd c d e f g h i k l m n o org p parti pp press r s t tm u w x y z ',
            'sg': ' com edu gov idn net org per ',
            'sn': ' art com edu gouv org perso univ ',
            'sy': ' com edu gov mil net news org ',
            'th': ' ac co go in mi net or ',
            'tj': ' ac biz co com edu go gov info int mil name net nic org test web ',
            'tn': ' agrinet com defense edunet ens fin gov ind info intl mincom nat net org perso rnrt rns rnu tourism ',
            'tz': ' ac co go ne or ',
            'ua': ' biz cherkassy chernigov chernovtsy ck cn co com crimea cv dn dnepropetrovsk donetsk dp edu gov if in ivano-frankivsk kh kharkov kherson khmelnitskiy kiev kirovograd km kr ks kv lg lugansk lutsk lviv me mk net nikolaev od odessa org pl poltava pp rovno rv sebastopol sumy te ternopil uzhgorod vinnica vn zaporizhzhe zhitomir zp zt ',
            'ug': ' ac co go ne or org sc ',
            'uk': ' ac bl british-library co cym gov govt icnet jet lea ltd me mil mod national-library-scotland nel net nhs nic nls org orgn parliament plc police sch scot soc ',
            'us': ' dni fed isa kids nsn ',
            'uy': ' com edu gub mil net org ',
            've': ' co com edu gob info mil net org web ',
            'vi': ' co com k12 net org ',
            'vn': ' ac biz com edu gov health info int name net org pro ',
            'ye': ' co com gov ltd me net org plc ',
            'yu': ' ac co edu gov org ',
            'za': ' ac agric alt bourse city co cybernet db edu gov grondar iaccess imt inca landesign law mil net ngo nis nom olivetti org pix school tm web ',
            'zm': ' ac co com edu gov net org sch ',
            // https://en.wikipedia.org/wiki/CentralNic#Second-level_domains
            'com': 'ar br cn de eu gb gr hu jpn kr no qc ru sa se uk us uy za ',
            'net': 'gb jp se uk ',
            'org': 'ae',
            'de': 'com '
        },
        // gorhill 2013-10-25: Using indexOf() instead Regexp(). Significant boost
        // in both performance and memory footprint. No initialization required.
        // http://jsperf.com/uri-js-sld-regex-vs-binary-search/4
        // Following methods use lastIndexOf() rather than array.split() in order
        // to avoid any memory allocations.
        has: function(domain) {
            var tldOffset = domain.lastIndexOf('.');
            if (tldOffset <= 0 || tldOffset >= domain.length - 1) return false;
            var sldOffset = domain.lastIndexOf('.', tldOffset - 1);
            if (sldOffset <= 0 || sldOffset >= tldOffset - 1) return false;
            var sldList = SLD.list[domain.slice(tldOffset + 1)];
            if (!sldList) return false;
            return sldList.indexOf(' ' + domain.slice(sldOffset + 1, tldOffset) + ' ') >= 0;
        },
        is: function(domain) {
            var tldOffset = domain.lastIndexOf('.');
            if (tldOffset <= 0 || tldOffset >= domain.length - 1) return false;
            var sldOffset = domain.lastIndexOf('.', tldOffset - 1);
            if (sldOffset >= 0) return false;
            var sldList = SLD.list[domain.slice(tldOffset + 1)];
            if (!sldList) return false;
            return sldList.indexOf(' ' + domain.slice(0, tldOffset) + ' ') >= 0;
        },
        get: function(domain) {
            var tldOffset = domain.lastIndexOf('.');
            if (tldOffset <= 0 || tldOffset >= domain.length - 1) return null;
            var sldOffset = domain.lastIndexOf('.', tldOffset - 1);
            if (sldOffset <= 0 || sldOffset >= tldOffset - 1) return null;
            var sldList = SLD.list[domain.slice(tldOffset + 1)];
            if (!sldList) return null;
            if (sldList.indexOf(' ' + domain.slice(sldOffset + 1, tldOffset) + ' ') < 0) return null;
            return domain.slice(sldOffset + 1);
        },
        noConflict: function() {
            if (root.SecondLevelDomains === this) root.SecondLevelDomains = _SecondLevelDomains;
            return this;
        }
    };
    return SLD;
});

},{}],"18kUy":[function(require,module,exports,__globalThis) {
var createRange = require("1232c42be39f64d6");
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var range = createRange();
module.exports = range;

},{"1232c42be39f64d6":"coC0k"}],"coC0k":[function(require,module,exports,__globalThis) {
var baseRange = require("f5c6552fbc38341a"), isIterateeCall = require("ae36f017fbc9946"), toFinite = require("c59818521cb53c6a");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = toFinite(end);
        step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
        return baseRange(start, end, step, fromRight);
    };
}
module.exports = createRange;

},{"f5c6552fbc38341a":"aebmU","ae36f017fbc9946":"aZ0Hj","c59818521cb53c6a":"jDMw4"}],"aebmU":[function(require,module,exports,__globalThis) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function baseRange(start, end, step, fromRight) {
    var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
module.exports = baseRange;

},{}],"aZ0Hj":[function(require,module,exports,__globalThis) {
var eq = require("a8ec2a011d2eca69"), isArrayLike = require("616bc732534dffe0"), isIndex = require("e781332a36d1bd7"), isObject = require("c8548bf6929b8a5d");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
    return false;
}
module.exports = isIterateeCall;

},{"a8ec2a011d2eca69":"jOpKa","616bc732534dffe0":"f6382","e781332a36d1bd7":"f4t28","c8548bf6929b8a5d":"b5XR2"}],"jOpKa":[function(require,module,exports,__globalThis) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = eq;

},{}],"f6382":[function(require,module,exports,__globalThis) {
var isFunction = require("bb060d4356645330"), isLength = require("f3db08d4d1110aaf");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"bb060d4356645330":"bHqi4","f3db08d4d1110aaf":"hnKdL"}],"bHqi4":[function(require,module,exports,__globalThis) {
var baseGetTag = require("5419308bd9194e11"), isObject = require("3cba3c966459d528");
/** `Object#toString` result references. */ var asyncTag = '[object AsyncFunction]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"5419308bd9194e11":"7W5wu","3cba3c966459d528":"b5XR2"}],"7W5wu":[function(require,module,exports,__globalThis) {
var Symbol = require("68a84eb98c5d3fa2"), getRawTag = require("9b2aaf31b7bdd837"), objectToString = require("46d5beb3375f8a28");
/** `Object#toString` result references. */ var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"68a84eb98c5d3fa2":"dpC1Y","9b2aaf31b7bdd837":"lpH2j","46d5beb3375f8a28":"7jwXs"}],"dpC1Y":[function(require,module,exports,__globalThis) {
var root = require("9ff1abd51ad45ac0");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"9ff1abd51ad45ac0":"63oqc"}],"63oqc":[function(require,module,exports,__globalThis) {
var freeGlobal = require("cd92e8811deaabf5");
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
module.exports = root;

},{"cd92e8811deaabf5":"k9HNM"}],"k9HNM":[function(require,module,exports,__globalThis) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"lpH2j":[function(require,module,exports,__globalThis) {
var Symbol = require("e9b4533b2a68f814");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"e9b4533b2a68f814":"dpC1Y"}],"7jwXs":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"b5XR2":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = isObject;

},{}],"hnKdL":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"f4t28":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{}],"jDMw4":[function(require,module,exports,__globalThis) {
var toNumber = require("90c5878489629896");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = toNumber(value);
    if (value === INFINITY || value === -INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = toFinite;

},{"90c5878489629896":"90hUs"}],"90hUs":[function(require,module,exports,__globalThis) {
var baseTrim = require("261e89907fb89d78"), isObject = require("faaa289d287a34a5"), isSymbol = require("47b3bd23f771891");
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == 'number') return value;
    if (isSymbol(value)) return NAN;
    if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = baseTrim(value);
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = toNumber;

},{"261e89907fb89d78":"dWEaL","faaa289d287a34a5":"b5XR2","47b3bd23f771891":"b0ZB5"}],"dWEaL":[function(require,module,exports,__globalThis) {
var trimmedEndIndex = require("985d3c9be7b51937");
/** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function baseTrim(string) {
    return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
}
module.exports = baseTrim;

},{"985d3c9be7b51937":"d0Vs0"}],"d0Vs0":[function(require,module,exports,__globalThis) {
/** Used to match a single whitespace character. */ var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = trimmedEndIndex;

},{}],"b0ZB5":[function(require,module,exports,__globalThis) {
var baseGetTag = require("6118c0d5630f51ce"), isObjectLike = require("74644060ad1a1d3c");
/** `Object#toString` result references. */ var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
module.exports = isSymbol;

},{"6118c0d5630f51ce":"7W5wu","74644060ad1a1d3c":"anjMx"}],"anjMx":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = isObjectLike;

},{}],"g2hJW":[function(require,module,exports,__globalThis) {
//download.js v4.2, by dandavis; 2008-2016. [MIT] see http://danml.com/download.html for tests/usage
// v1 landed a FF+Chrome compat way of downloading strings to local un-named files, upgraded to use a hidden frame and optional mime
// v2 added named files via a[download], msSaveBlob, IE (10+) support, and window.URL support for larger+faster saves than dataURLs
// v3 added dataURL and Blob Input, bind-toggle arity, and legacy dataURL fallback was improved with force-download mime and base64 support. 3.1 improved safari handling.
// v4 adds AMD/UMD, commonJS, and plain browser support
// v4.1 adds url download capability via solo URL argument (same domain/CORS only)
// v4.2 adds semantic variable names, long (over 2MB) dataURL support, and hidden by default temp anchors
// https://github.com/rndme/download
(function(root, factory) {
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define([], factory);
    else // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
})(this, function() {
    return function download(data, strFileName, strMimeType) {
        var self = window, defaultMime = "application/octet-stream", mimeType = strMimeType || defaultMime, payload = data, url = !strFileName && !strMimeType && payload, anchor = document.createElement("a"), toString = function(a) {
            return String(a);
        }, myBlob = self.Blob || self.MozBlob || self.WebKitBlob || toString, fileName = strFileName || "download", blob, reader;
        myBlob = myBlob.call ? myBlob.bind(self) : Blob;
        if (String(this) === "true") {
            payload = [
                payload,
                mimeType
            ];
            mimeType = payload[0];
            payload = payload[1];
        }
        if (url && url.length < 2048) {
            fileName = url.split("/").pop().split("?")[0];
            anchor.href = url; // assign href prop to temp anchor
            if (anchor.href.indexOf(url) !== -1) {
                var ajax = new XMLHttpRequest();
                ajax.open("GET", url, true);
                ajax.responseType = 'blob';
                ajax.onload = function(e) {
                    download(e.target.response, fileName, defaultMime);
                };
                setTimeout(function() {
                    ajax.send();
                }, 0); // allows setting custom ajax headers using the return:
                return ajax;
            } // end if valid url?
        } // end if url?
        //go ahead and download dataURLs right away
        if (/^data:([\w+-]+\/[\w+.-]+)?[,;]/.test(payload)) {
            if (payload.length > 2096103.424 && myBlob !== toString) {
                payload = dataUrlToBlob(payload);
                mimeType = payload.type || defaultMime;
            } else return navigator.msSaveBlob ? navigator.msSaveBlob(dataUrlToBlob(payload), fileName) : saver(payload); // everyone else can save dataURLs un-processed
        } else if (/([\x80-\xff])/.test(payload)) {
            var i = 0, tempUiArr = new Uint8Array(payload.length), mx = tempUiArr.length;
            for(i; i < mx; ++i)tempUiArr[i] = payload.charCodeAt(i);
            payload = new myBlob([
                tempUiArr
            ], {
                type: mimeType
            });
        }
        blob = payload instanceof myBlob ? payload : new myBlob([
            payload
        ], {
            type: mimeType
        });
        function dataUrlToBlob(strUrl) {
            var parts = strUrl.split(/[:;,]/), type = parts[1], decoder = parts[2] == "base64" ? atob : decodeURIComponent, binData = decoder(parts.pop()), mx = binData.length, i = 0, uiArr = new Uint8Array(mx);
            for(i; i < mx; ++i)uiArr[i] = binData.charCodeAt(i);
            return new myBlob([
                uiArr
            ], {
                type: type
            });
        }
        function saver(url, winMode) {
            if ('download' in anchor) {
                anchor.href = url;
                anchor.setAttribute("download", fileName);
                anchor.className = "download-js-link";
                anchor.innerHTML = "downloading...";
                anchor.style.display = "none";
                document.body.appendChild(anchor);
                setTimeout(function() {
                    anchor.click();
                    document.body.removeChild(anchor);
                    if (winMode === true) setTimeout(function() {
                        self.URL.revokeObjectURL(anchor.href);
                    }, 250);
                }, 66);
                return true;
            }
            // handle non-a[download] safari as best we can:
            if (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
                if (/^data:/.test(url)) url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
                if (!window.open(url)) {
                    if (confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")) location.href = url;
                }
                return true;
            }
            //do iframe dataURL download (old ch+FF):
            var f = document.createElement("iframe");
            document.body.appendChild(f);
            if (!winMode && /^data:/.test(url)) url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
            f.src = url;
            setTimeout(function() {
                document.body.removeChild(f);
            }, 333);
        } //end saver
        if (navigator.msSaveBlob) return navigator.msSaveBlob(blob, fileName);
        if (self.URL) saver(self.URL.createObjectURL(blob), true);
        else {
            // handle non-Blob()+non-URL browsers:
            if (typeof blob === "string" || blob.constructor === toString) try {
                return saver("data:" + mimeType + ";base64," + self.btoa(blob));
            } catch (y) {
                return saver("data:" + mimeType + "," + encodeURIComponent(blob));
            }
            // Blob but not URL support:
            reader = new FileReader();
            reader.onload = function(e) {
                saver(this.result);
            };
            reader.readAsDataURL(blob);
        }
        return true;
    }; /* end download() */ 
});

},{}],"3l4am":[function(require,module,exports,__globalThis) {
var arrayFilter = require("6ac5a622705039a5"), baseRest = require("87ce455c857e3ffe"), baseXor = require("1cb1ea2eb275f4bc"), isArrayLikeObject = require("33c1804c238679a8");
/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */ var xor = baseRest(function(arrays) {
    return baseXor(arrayFilter(arrays, isArrayLikeObject));
});
module.exports = xor;

},{"6ac5a622705039a5":"2hRJc","87ce455c857e3ffe":"1fVZL","1cb1ea2eb275f4bc":"4AByQ","33c1804c238679a8":"6vQ3T"}],"2hRJc":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = arrayFilter;

},{}],"1fVZL":[function(require,module,exports,__globalThis) {
var identity = require("3b2979bd51a0f85f"), overRest = require("ff7d23ff2a2ea6f8"), setToString = require("a11d545e809d14f7");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + '');
}
module.exports = baseRest;

},{"3b2979bd51a0f85f":"f1xGx","ff7d23ff2a2ea6f8":"hIcTa","a11d545e809d14f7":"876oX"}],"f1xGx":[function(require,module,exports,__globalThis) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
module.exports = identity;

},{}],"hIcTa":[function(require,module,exports,__globalThis) {
var apply = require("6f683b05f63ed25a");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
module.exports = overRest;

},{"6f683b05f63ed25a":"gn9Hb"}],"gn9Hb":[function(require,module,exports,__globalThis) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = apply;

},{}],"876oX":[function(require,module,exports,__globalThis) {
var baseSetToString = require("eebd487fbab521b6"), shortOut = require("9114f59293388d49");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
module.exports = setToString;

},{"eebd487fbab521b6":"jJW3O","9114f59293388d49":"4a4SE"}],"jJW3O":[function(require,module,exports,__globalThis) {
var constant = require("706929c7b4749485"), defineProperty = require("eff1240bc0447727"), identity = require("b00d1e57326793e1");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
    });
};
module.exports = baseSetToString;

},{"706929c7b4749485":"hqZFj","eff1240bc0447727":"avMUX","b00d1e57326793e1":"f1xGx"}],"hqZFj":[function(require,module,exports,__globalThis) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
module.exports = constant;

},{}],"avMUX":[function(require,module,exports,__globalThis) {
var getNative = require("7565accd8c33cb8b");
var defineProperty = function() {
    try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = defineProperty;

},{"7565accd8c33cb8b":"aNiUF"}],"aNiUF":[function(require,module,exports,__globalThis) {
var baseIsNative = require("63e3f1300cdc459f"), getValue = require("16db51a0e009bd8c");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;

},{"63e3f1300cdc459f":"59yCg","16db51a0e009bd8c":"kRRoe"}],"59yCg":[function(require,module,exports,__globalThis) {
var isFunction = require("2f9b4543c84c6692"), isMasked = require("cabbc2adfaeb27d9"), isObject = require("cbb5703fe1562e7f"), toSource = require("388b819f47a43aa5");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;

},{"2f9b4543c84c6692":"bHqi4","cabbc2adfaeb27d9":"kafWX","cbb5703fe1562e7f":"b5XR2","388b819f47a43aa5":"6S6xj"}],"kafWX":[function(require,module,exports,__globalThis) {
var coreJsData = require("2fa6c734b0792bcf");
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
module.exports = isMasked;

},{"2fa6c734b0792bcf":"jcsqv"}],"jcsqv":[function(require,module,exports,__globalThis) {
var root = require("2f0959b2c20d7fb0");
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
module.exports = coreJsData;

},{"2f0959b2c20d7fb0":"63oqc"}],"6S6xj":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = toSource;

},{}],"kRRoe":[function(require,module,exports,__globalThis) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;

},{}],"4a4SE":[function(require,module,exports,__globalThis) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = shortOut;

},{}],"4AByQ":[function(require,module,exports,__globalThis) {
var baseDifference = require("48f1605e1a9757a5"), baseFlatten = require("febbf95731bdaf04"), baseUniq = require("28f843bbe47d0752");
/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */ function baseXor(arrays, iteratee, comparator) {
    var length = arrays.length;
    if (length < 2) return length ? baseUniq(arrays[0]) : [];
    var index = -1, result = Array(length);
    while(++index < length){
        var array = arrays[index], othIndex = -1;
        while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
    }
    return baseUniq(baseFlatten(result, 1), iteratee, comparator);
}
module.exports = baseXor;

},{"48f1605e1a9757a5":"gaC8y","febbf95731bdaf04":"LCj6J","28f843bbe47d0752":"81vJ8"}],"gaC8y":[function(require,module,exports,__globalThis) {
var SetCache = require("24f4b9cbc81696e0"), arrayIncludes = require("81e4fe535468d831"), arrayIncludesWith = require("90bb2140eaac029e"), arrayMap = require("7436ea7dfb9a8bab"), baseUnary = require("c466a3eeaa8c48da"), cacheHas = require("aea8a6a021670ce5");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = arrayMap(values, baseUnary(iteratee));
    if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
    } else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = baseDifference;

},{"24f4b9cbc81696e0":"eYiqn","81e4fe535468d831":"DgrAw","90bb2140eaac029e":"3VKLq","7436ea7dfb9a8bab":"eDg3z","c466a3eeaa8c48da":"infZD","aea8a6a021670ce5":"9fAC8"}],"eYiqn":[function(require,module,exports,__globalThis) {
var MapCache = require("10fe37252553d0bd"), setCacheAdd = require("9a831e81e9a1f98c"), setCacheHas = require("1a2b6c8a7399c39f");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
module.exports = SetCache;

},{"10fe37252553d0bd":"kzsm2","9a831e81e9a1f98c":"7G1qP","1a2b6c8a7399c39f":"ihf1p"}],"kzsm2":[function(require,module,exports,__globalThis) {
var mapCacheClear = require("a5ffecfb6a8bdac1"), mapCacheDelete = require("d2967b0e32ccfa56"), mapCacheGet = require("ca21409ea89624c0"), mapCacheHas = require("f88fd07f8dd1f67d"), mapCacheSet = require("dbf3eae765642a3b");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;

},{"a5ffecfb6a8bdac1":"khR1f","d2967b0e32ccfa56":"grz0B","ca21409ea89624c0":"gQckk","f88fd07f8dd1f67d":"3qapz","dbf3eae765642a3b":"7mwaN"}],"khR1f":[function(require,module,exports,__globalThis) {
var Hash = require("4ae82d88051cc92b"), ListCache = require("a07dcf3fd3097a0c"), Map = require("92c01c953ef00ded");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
module.exports = mapCacheClear;

},{"4ae82d88051cc92b":"bzS4y","a07dcf3fd3097a0c":"fqUvy","92c01c953ef00ded":"koCkS"}],"bzS4y":[function(require,module,exports,__globalThis) {
var hashClear = require("f47a1723b6e2d79b"), hashDelete = require("bc25d439ccd1fb47"), hashGet = require("f096b37295a92ab0"), hashHas = require("d88173cbc6a133c8"), hashSet = require("afb9b3bae0461cbf");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;

},{"f47a1723b6e2d79b":"f3UHe","bc25d439ccd1fb47":"50EWR","f096b37295a92ab0":"jaqJo","d88173cbc6a133c8":"7KDxC","afb9b3bae0461cbf":"4boiL"}],"f3UHe":[function(require,module,exports,__globalThis) {
var nativeCreate = require("dc294230a47ca365");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;

},{"dc294230a47ca365":"4Kf0F"}],"4Kf0F":[function(require,module,exports,__globalThis) {
var getNative = require("12f496acdffb7cf7");
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, 'create');
module.exports = nativeCreate;

},{"12f496acdffb7cf7":"aNiUF"}],"50EWR":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;

},{}],"jaqJo":[function(require,module,exports,__globalThis) {
var nativeCreate = require("627211fa3e1596e1");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;

},{"627211fa3e1596e1":"4Kf0F"}],"7KDxC":[function(require,module,exports,__globalThis) {
var nativeCreate = require("52b3f0bfeddceb45");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
module.exports = hashHas;

},{"52b3f0bfeddceb45":"4Kf0F"}],"4boiL":[function(require,module,exports,__globalThis) {
var nativeCreate = require("67b7d10f53ccd515");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;

},{"67b7d10f53ccd515":"4Kf0F"}],"fqUvy":[function(require,module,exports,__globalThis) {
var listCacheClear = require("4b1a0d54aed80a7b"), listCacheDelete = require("b700cb849df2c166"), listCacheGet = require("d76dd90eead6cced"), listCacheHas = require("3d210628ba60ec8"), listCacheSet = require("76026bf2d4cfff93");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;

},{"4b1a0d54aed80a7b":"hxcMS","b700cb849df2c166":"lEMcE","d76dd90eead6cced":"jQQdO","3d210628ba60ec8":"7MlYo","76026bf2d4cfff93":"7f5T8"}],"hxcMS":[function(require,module,exports,__globalThis) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;

},{}],"lEMcE":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("173cad7d48c35f4f");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = listCacheDelete;

},{"173cad7d48c35f4f":"haKw5"}],"haKw5":[function(require,module,exports,__globalThis) {
var eq = require("b38bfe408564f7a5");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = assocIndexOf;

},{"b38bfe408564f7a5":"jOpKa"}],"jQQdO":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("c0bae780ed176e2c");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;

},{"c0bae780ed176e2c":"haKw5"}],"7MlYo":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("7ed3d4e3adbd64a4");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;

},{"7ed3d4e3adbd64a4":"haKw5"}],"7f5T8":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("5be4035c2d7ca432");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = listCacheSet;

},{"5be4035c2d7ca432":"haKw5"}],"koCkS":[function(require,module,exports,__globalThis) {
var getNative = require("ed0752fe9f482107"), root = require("29224713b8d411e6");
/* Built-in method references that are verified to be native. */ var Map = getNative(root, 'Map');
module.exports = Map;

},{"ed0752fe9f482107":"aNiUF","29224713b8d411e6":"63oqc"}],"grz0B":[function(require,module,exports,__globalThis) {
var getMapData = require("656d8c5510e0af84");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;

},{"656d8c5510e0af84":"1pboz"}],"1pboz":[function(require,module,exports,__globalThis) {
var isKeyable = require("adfdd2b4101370ed");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = getMapData;

},{"adfdd2b4101370ed":"l0fiB"}],"l0fiB":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = isKeyable;

},{}],"gQckk":[function(require,module,exports,__globalThis) {
var getMapData = require("d345cdfee2b4007d");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;

},{"d345cdfee2b4007d":"1pboz"}],"3qapz":[function(require,module,exports,__globalThis) {
var getMapData = require("29ebabd55e2d6074");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;

},{"29ebabd55e2d6074":"1pboz"}],"7mwaN":[function(require,module,exports,__globalThis) {
var getMapData = require("21c5ffca56eeb737");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;

},{"21c5ffca56eeb737":"1pboz"}],"7G1qP":[function(require,module,exports,__globalThis) {
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
module.exports = setCacheAdd;

},{}],"ihf1p":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = setCacheHas;

},{}],"DgrAw":[function(require,module,exports,__globalThis) {
var baseIndexOf = require("277b2d1a618f2b2f");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
}
module.exports = arrayIncludes;

},{"277b2d1a618f2b2f":"bR4po"}],"bR4po":[function(require,module,exports,__globalThis) {
var baseFindIndex = require("badcebec79c8cd4"), baseIsNaN = require("c991ed2b82d165b"), strictIndexOf = require("c0bb8190b05a00a5");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseIndexOf(array, value, fromIndex) {
    return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}
module.exports = baseIndexOf;

},{"badcebec79c8cd4":"h2XE9","c991ed2b82d165b":"28rIh","c0bb8190b05a00a5":"fuK9i"}],"h2XE9":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = baseFindIndex;

},{}],"28rIh":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function baseIsNaN(value) {
    return value !== value;
}
module.exports = baseIsNaN;

},{}],"fuK9i":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = strictIndexOf;

},{}],"3VKLq":[function(require,module,exports,__globalThis) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = arrayIncludesWith;

},{}],"eDg3z":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = arrayMap;

},{}],"infZD":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"9fAC8":[function(require,module,exports,__globalThis) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = cacheHas;

},{}],"LCj6J":[function(require,module,exports,__globalThis) {
var arrayPush = require("d752582e5b174691"), isFlattenable = require("ec5f080ebf5764e8");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = isFlattenable);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
            else arrayPush(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = baseFlatten;

},{"d752582e5b174691":"h6Wmb","ec5f080ebf5764e8":"gV3Ng"}],"h6Wmb":[function(require,module,exports,__globalThis) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = arrayPush;

},{}],"gV3Ng":[function(require,module,exports,__globalThis) {
var Symbol = require("dde07f6ab8ba5eb5"), isArguments = require("ee6f325d7f5309b1"), isArray = require("ff8d93236e335297");
/** Built-in value references. */ var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function isFlattenable(value) {
    return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
module.exports = isFlattenable;

},{"dde07f6ab8ba5eb5":"dpC1Y","ee6f325d7f5309b1":"lGymi","ff8d93236e335297":"bCmB4"}],"lGymi":[function(require,module,exports,__globalThis) {
var baseIsArguments = require("b56e5b7d86069686"), isObjectLike = require("bead821d6af018b5");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
module.exports = isArguments;

},{"b56e5b7d86069686":"dmb35","bead821d6af018b5":"anjMx"}],"dmb35":[function(require,module,exports,__globalThis) {
var baseGetTag = require("7e8612a4a451f2cc"), isObjectLike = require("b6cdbe52dcf709f8");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"7e8612a4a451f2cc":"7W5wu","b6cdbe52dcf709f8":"anjMx"}],"bCmB4":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"81vJ8":[function(require,module,exports,__globalThis) {
var SetCache = require("56c8470806d11628"), arrayIncludes = require("a1d85be956e037a9"), arrayIncludesWith = require("8cd18f86a4a2c118"), cacheHas = require("3acf9f4a3a78c511"), createSet = require("19b77385b4f7775a"), setToArray = require("4568580f7416eb83");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function baseUniq(array, iteratee, comparator) {
    var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
    } else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) return setToArray(set);
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = baseUniq;

},{"56c8470806d11628":"eYiqn","a1d85be956e037a9":"DgrAw","8cd18f86a4a2c118":"3VKLq","3acf9f4a3a78c511":"9fAC8","19b77385b4f7775a":"afaEz","4568580f7416eb83":"1fGvU"}],"afaEz":[function(require,module,exports,__globalThis) {
var Set = require("17777365baf8e16"), noop = require("a02c367b3608ccee"), setToArray = require("cd8d0af6a14b2f7d");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var createSet = !(Set && 1 / setToArray(new Set([
    ,
    -0
]))[1] == INFINITY) ? noop : function(values) {
    return new Set(values);
};
module.exports = createSet;

},{"17777365baf8e16":"oaIQr","a02c367b3608ccee":"gtREm","cd8d0af6a14b2f7d":"1fGvU"}],"oaIQr":[function(require,module,exports,__globalThis) {
var getNative = require("56b792d64741a4ff"), root = require("ca486d41cdf819d4");
/* Built-in method references that are verified to be native. */ var Set = getNative(root, 'Set');
module.exports = Set;

},{"56b792d64741a4ff":"aNiUF","ca486d41cdf819d4":"63oqc"}],"gtREm":[function(require,module,exports,__globalThis) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function noop() {
// No operation performed.
}
module.exports = noop;

},{}],"1fGvU":[function(require,module,exports,__globalThis) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = setToArray;

},{}],"6vQ3T":[function(require,module,exports,__globalThis) {
var isArrayLike = require("9ce7efb3ed8cb283"), isObjectLike = require("639a4883b097af28");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
module.exports = isArrayLikeObject;

},{"9ce7efb3ed8cb283":"f6382","639a4883b097af28":"anjMx"}],"cWbub":[function(require,module,exports,__globalThis) {
var baseFlatten = require("7dd3b18d381f1f29"), baseOrderBy = require("2553e45e897c3cba"), baseRest = require("9df1e918b0eea173"), isIterateeCall = require("36218471fd8f4dda");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var sortBy = baseRest(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});
module.exports = sortBy;

},{"7dd3b18d381f1f29":"LCj6J","2553e45e897c3cba":"6mNFv","9df1e918b0eea173":"1fVZL","36218471fd8f4dda":"aZ0Hj"}],"6mNFv":[function(require,module,exports,__globalThis) {
var arrayMap = require("8b3be8ab05c5c021"), baseGet = require("56eb179604ce4d19"), baseIteratee = require("41950d167c7e12b5"), baseMap = require("b09740a39499ec43"), baseSortBy = require("35a9013ca73ef017"), baseUnary = require("b387a5b76e29e664"), compareMultiple = require("2ab709818f44804c"), identity = require("5cb379329c706719"), isArray = require("8acdbb462385356c");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
        if (isArray(iteratee)) return function(value) {
            return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        identity
    ];
    var index = -1;
    iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
    var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
    });
}
module.exports = baseOrderBy;

},{"8b3be8ab05c5c021":"eDg3z","56eb179604ce4d19":"421JF","41950d167c7e12b5":"e8N0c","b09740a39499ec43":"8U7lG","35a9013ca73ef017":"hCGW1","b387a5b76e29e664":"infZD","2ab709818f44804c":"hjWoR","5cb379329c706719":"f1xGx","8acdbb462385356c":"bCmB4"}],"421JF":[function(require,module,exports,__globalThis) {
var castPath = require("434ba191fc1dcf09"), toKey = require("c3296f04fad32769");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = baseGet;

},{"434ba191fc1dcf09":"f3wws","c3296f04fad32769":"RBtZh"}],"f3wws":[function(require,module,exports,__globalThis) {
var isArray = require("26a856890198f45b"), isKey = require("e823e604d75f975b"), stringToPath = require("f5fff1c342107fbd"), toString = require("b04e8cc634273c23");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if (isArray(value)) return value;
    return isKey(value, object) ? [
        value
    ] : stringToPath(toString(value));
}
module.exports = castPath;

},{"26a856890198f45b":"bCmB4","e823e604d75f975b":"jwsgR","f5fff1c342107fbd":"fyi4X","b04e8cc634273c23":"hiC1E"}],"jwsgR":[function(require,module,exports,__globalThis) {
var isArray = require("1efcc081e9a448a8"), isSymbol = require("4cdff6c9e9ff5d38");
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = isKey;

},{"1efcc081e9a448a8":"bCmB4","4cdff6c9e9ff5d38":"b0ZB5"}],"fyi4X":[function(require,module,exports,__globalThis) {
var memoizeCapped = require("55f565a895f455e5");
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = stringToPath;

},{"55f565a895f455e5":"971Q6"}],"971Q6":[function(require,module,exports,__globalThis) {
var memoize = require("cb456550b1f5dd0a");
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = memoizeCapped;

},{"cb456550b1f5dd0a":"6LVZz"}],"6LVZz":[function(require,module,exports,__globalThis) {
var MapCache = require("b34b26bf235f1cdd");
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
module.exports = memoize;

},{"b34b26bf235f1cdd":"kzsm2"}],"hiC1E":[function(require,module,exports,__globalThis) {
var baseToString = require("81fca33832a744d9");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? '' : baseToString(value);
}
module.exports = toString;

},{"81fca33832a744d9":"iarts"}],"iarts":[function(require,module,exports,__globalThis) {
var Symbol = require("16af83505444e42a"), arrayMap = require("8439a3a1551d0706"), isArray = require("4b12c9f502d3288a"), isSymbol = require("a0ebd327d618908a");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
module.exports = baseToString;

},{"16af83505444e42a":"dpC1Y","8439a3a1551d0706":"eDg3z","4b12c9f502d3288a":"bCmB4","a0ebd327d618908a":"b0ZB5"}],"RBtZh":[function(require,module,exports,__globalThis) {
var isSymbol = require("2aed9f6fd4b7386");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
module.exports = toKey;

},{"2aed9f6fd4b7386":"b0ZB5"}],"e8N0c":[function(require,module,exports,__globalThis) {
var baseMatches = require("30aeab910fab669"), baseMatchesProperty = require("4f010869f7b63154"), identity = require("28f06147d1eb9502"), isArray = require("3c56f88c4debf449"), property = require("aee920e0ef5bf111");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return identity;
    if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
module.exports = baseIteratee;

},{"30aeab910fab669":"iDV2P","4f010869f7b63154":"hK8v8","28f06147d1eb9502":"f1xGx","3c56f88c4debf449":"bCmB4","aee920e0ef5bf111":"5OhK3"}],"iDV2P":[function(require,module,exports,__globalThis) {
var baseIsMatch = require("e45515c903dc8f87"), getMatchData = require("89e9034a8071e297"), matchesStrictComparable = require("782598b150762386");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
module.exports = baseMatches;

},{"e45515c903dc8f87":"3atKA","89e9034a8071e297":"fYqFL","782598b150762386":"g1Vc7"}],"3atKA":[function(require,module,exports,__globalThis) {
var Stack = require("ae43062900bf7e4d"), baseIsEqual = require("9003c0cc8ac007b6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = baseIsMatch;

},{"ae43062900bf7e4d":"igtgH","9003c0cc8ac007b6":"KbWXx"}],"igtgH":[function(require,module,exports,__globalThis) {
var ListCache = require("cfb30a39eead9e7e"), stackClear = require("ceda2a63c77c915"), stackDelete = require("91ee1b348d9d7172"), stackGet = require("3fe28318f65b9332"), stackHas = require("724ca4def8b84e06"), stackSet = require("e9ceacb40d9582bd");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
module.exports = Stack;

},{"cfb30a39eead9e7e":"fqUvy","ceda2a63c77c915":"dvReD","91ee1b348d9d7172":"fYqUe","3fe28318f65b9332":"aWAsX","724ca4def8b84e06":"cbYvU","e9ceacb40d9582bd":"7Zr3m"}],"dvReD":[function(require,module,exports,__globalThis) {
var ListCache = require("8a0350213da984ae");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
module.exports = stackClear;

},{"8a0350213da984ae":"fqUvy"}],"fYqUe":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = stackDelete;

},{}],"aWAsX":[function(require,module,exports,__globalThis) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
module.exports = stackGet;

},{}],"cbYvU":[function(require,module,exports,__globalThis) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
module.exports = stackHas;

},{}],"7Zr3m":[function(require,module,exports,__globalThis) {
var ListCache = require("4737651e99b917d2"), Map = require("1494efbafafa9552"), MapCache = require("6049e8027fe9407f");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = stackSet;

},{"4737651e99b917d2":"fqUvy","1494efbafafa9552":"koCkS","6049e8027fe9407f":"kzsm2"}],"KbWXx":[function(require,module,exports,__globalThis) {
var baseIsEqualDeep = require("bd1d38ebd4028e5a"), isObjectLike = require("809bbb0c20650dbc");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
module.exports = baseIsEqual;

},{"bd1d38ebd4028e5a":"43ilA","809bbb0c20650dbc":"anjMx"}],"43ilA":[function(require,module,exports,__globalThis) {
var Stack = require("60c73bca87468e58"), equalArrays = require("96bc8a1825db53a5"), equalByTag = require("8bdece495e87fb69"), equalObjects = require("bb94920432a68eca"), getTag = require("45495edff98e5837"), isArray = require("18256411ae9e2858"), isBuffer = require("e5ba7abf54247fc5"), isTypedArray = require("50d786bb5c7366af");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', objectTag = '[object Object]';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = baseIsEqualDeep;

},{"60c73bca87468e58":"igtgH","96bc8a1825db53a5":"52sMm","8bdece495e87fb69":"f6wak","bb94920432a68eca":"6ZS6r","45495edff98e5837":"iqJCK","18256411ae9e2858":"bCmB4","e5ba7abf54247fc5":"bs8mk","50d786bb5c7366af":"geCZt"}],"52sMm":[function(require,module,exports,__globalThis) {
var SetCache = require("9b110ce138e67ce5"), arraySome = require("1ee20de911db0cb0"), cacheHas = require("defff3d81be91b23");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = equalArrays;

},{"9b110ce138e67ce5":"eYiqn","1ee20de911db0cb0":"4Dzv0","defff3d81be91b23":"9fAC8"}],"4Dzv0":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = arraySome;

},{}],"f6wak":[function(require,module,exports,__globalThis) {
var Symbol = require("474c1df4fc722b40"), Uint8Array = require("dbf6aa5033a0f48"), eq = require("539966708f906e61"), equalArrays = require("8142d4017f0a425f"), mapToArray = require("48cddf732eff33ba"), setToArray = require("9dc78b26c5daba20");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', mapTag = '[object Map]', numberTag = '[object Number]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
module.exports = equalByTag;

},{"474c1df4fc722b40":"dpC1Y","dbf6aa5033a0f48":"kuXZd","539966708f906e61":"jOpKa","8142d4017f0a425f":"52sMm","48cddf732eff33ba":"fWrEH","9dc78b26c5daba20":"1fGvU"}],"kuXZd":[function(require,module,exports,__globalThis) {
var root = require("f755339301d6568f");
/** Built-in value references. */ var Uint8Array = root.Uint8Array;
module.exports = Uint8Array;

},{"f755339301d6568f":"63oqc"}],"fWrEH":[function(require,module,exports,__globalThis) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = mapToArray;

},{}],"6ZS6r":[function(require,module,exports,__globalThis) {
var getAllKeys = require("b911593d305cf4a2");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = equalObjects;

},{"b911593d305cf4a2":"e2oxc"}],"e2oxc":[function(require,module,exports,__globalThis) {
var baseGetAllKeys = require("c3dbe402f6996a21"), getSymbols = require("aa79b69a13f924db"), keys = require("e3ad83e53433bc8a");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
module.exports = getAllKeys;

},{"c3dbe402f6996a21":"1cDSE","aa79b69a13f924db":"a0y7B","e3ad83e53433bc8a":"kYKDj"}],"1cDSE":[function(require,module,exports,__globalThis) {
var arrayPush = require("abfc70b400ed76c2"), isArray = require("148b85918856c33a");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
module.exports = baseGetAllKeys;

},{"abfc70b400ed76c2":"h6Wmb","148b85918856c33a":"bCmB4"}],"a0y7B":[function(require,module,exports,__globalThis) {
var arrayFilter = require("7fe025254f0b7e4a"), stubArray = require("6b1c62cea92cdb9");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = getSymbols;

},{"7fe025254f0b7e4a":"2hRJc","6b1c62cea92cdb9":"dvCCe"}],"dvCCe":[function(require,module,exports,__globalThis) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
module.exports = stubArray;

},{}],"kYKDj":[function(require,module,exports,__globalThis) {
var arrayLikeKeys = require("4c73ca42c789e5ab"), baseKeys = require("e8453365fdacc8da"), isArrayLike = require("7760b47b02971dfa");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;

},{"4c73ca42c789e5ab":"fcdyL","e8453365fdacc8da":"beZEn","7760b47b02971dfa":"f6382"}],"fcdyL":[function(require,module,exports,__globalThis) {
var baseTimes = require("7ed875a0e67be76f"), isArguments = require("9cdb51ffa56f149b"), isArray = require("38cd49f1e493b3d7"), isBuffer = require("b379831fe1873fed"), isIndex = require("f362a34cd8321bb7"), isTypedArray = require("c019db5297494469");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
module.exports = arrayLikeKeys;

},{"7ed875a0e67be76f":"5PiEx","9cdb51ffa56f149b":"lGymi","38cd49f1e493b3d7":"bCmB4","b379831fe1873fed":"bs8mk","f362a34cd8321bb7":"f4t28","c019db5297494469":"geCZt"}],"5PiEx":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = baseTimes;

},{}],"bs8mk":[function(require,module,exports,__globalThis) {
var root = require("cef5ec6f0da1ab00"), stubFalse = require("a1e87b138cf75d1d");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"cef5ec6f0da1ab00":"63oqc","a1e87b138cf75d1d":"1n2Pf"}],"1n2Pf":[function(require,module,exports,__globalThis) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"geCZt":[function(require,module,exports,__globalThis) {
var baseIsTypedArray = require("75a26f037e65be61"), baseUnary = require("903f50eb1c16d257"), nodeUtil = require("fa49853a82034c30");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"75a26f037e65be61":"aTorW","903f50eb1c16d257":"infZD","fa49853a82034c30":"42cL5"}],"aTorW":[function(require,module,exports,__globalThis) {
var baseGetTag = require("67544c3df364a802"), isLength = require("f661b3a120d7a4cb"), isObjectLike = require("cdd86c83797c0618");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"67544c3df364a802":"7W5wu","f661b3a120d7a4cb":"hnKdL","cdd86c83797c0618":"anjMx"}],"42cL5":[function(require,module,exports,__globalThis) {
var freeGlobal = require("94e753dfbe54816e");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"94e753dfbe54816e":"k9HNM"}],"beZEn":[function(require,module,exports,__globalThis) {
var isPrototype = require("7da6298814f9bd95"), nativeKeys = require("3ec652610d8dd5d3");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = baseKeys;

},{"7da6298814f9bd95":"9hPlj","3ec652610d8dd5d3":"VyX7D"}],"9hPlj":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"VyX7D":[function(require,module,exports,__globalThis) {
var overArg = require("aa3357c7a3889df");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

},{"aa3357c7a3889df":"acc6S"}],"acc6S":[function(require,module,exports,__globalThis) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"iqJCK":[function(require,module,exports,__globalThis) {
var DataView = require("7f038695b2fdb86e"), Map = require("28e3344aae951f13"), Promise = require("b286298be5b1d9a4"), Set = require("3ae50c158f89813"), WeakMap = require("9f458755f627d456"), baseGetTag = require("8e9160b373d7fe66"), toSource = require("b210627dd951641f");
/** `Object#toString` result references. */ var mapTag = '[object Map]', objectTag = '[object Object]', promiseTag = '[object Promise]', setTag = '[object Set]', weakMapTag = '[object WeakMap]';
var dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
module.exports = getTag;

},{"7f038695b2fdb86e":"jTHlh","28e3344aae951f13":"koCkS","b286298be5b1d9a4":"3G5PG","3ae50c158f89813":"oaIQr","9f458755f627d456":"4rBqe","8e9160b373d7fe66":"7W5wu","b210627dd951641f":"6S6xj"}],"jTHlh":[function(require,module,exports,__globalThis) {
var getNative = require("a6517d0448dad786"), root = require("f83c375075418382");
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView');
module.exports = DataView;

},{"a6517d0448dad786":"aNiUF","f83c375075418382":"63oqc"}],"3G5PG":[function(require,module,exports,__globalThis) {
var getNative = require("6940648d854355b5"), root = require("a5c6637bac681a0");
/* Built-in method references that are verified to be native. */ var Promise = getNative(root, 'Promise');
module.exports = Promise;

},{"6940648d854355b5":"aNiUF","a5c6637bac681a0":"63oqc"}],"4rBqe":[function(require,module,exports,__globalThis) {
var getNative = require("4507415bd8810d3c"), root = require("7a9a6581834a8452");
/* Built-in method references that are verified to be native. */ var WeakMap = getNative(root, 'WeakMap');
module.exports = WeakMap;

},{"4507415bd8810d3c":"aNiUF","7a9a6581834a8452":"63oqc"}],"fYqFL":[function(require,module,exports,__globalThis) {
var isStrictComparable = require("8ba18052e16e94fb"), keys = require("94ffded3a85af2f6");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
module.exports = getMatchData;

},{"8ba18052e16e94fb":"ls1Vb","94ffded3a85af2f6":"kYKDj"}],"ls1Vb":[function(require,module,exports,__globalThis) {
var isObject = require("be1941f960bbf057");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
module.exports = isStrictComparable;

},{"be1941f960bbf057":"b5XR2"}],"g1Vc7":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = matchesStrictComparable;

},{}],"hK8v8":[function(require,module,exports,__globalThis) {
var baseIsEqual = require("cebe22f5ca0827a7"), get = require("d5ca180f7d6f956a"), hasIn = require("3462bb3f546fa1f7"), isKey = require("f5fef07966a1c4ee"), isStrictComparable = require("2a1cd212d48516"), matchesStrictComparable = require("885e72ee7fc6d296"), toKey = require("cd65eaf4a3af29f6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
module.exports = baseMatchesProperty;

},{"cebe22f5ca0827a7":"KbWXx","d5ca180f7d6f956a":"joon0","3462bb3f546fa1f7":"4QIVe","f5fef07966a1c4ee":"jwsgR","2a1cd212d48516":"ls1Vb","885e72ee7fc6d296":"g1Vc7","cd65eaf4a3af29f6":"RBtZh"}],"joon0":[function(require,module,exports,__globalThis) {
var baseGet = require("446ba3c1be7939a3");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = get;

},{"446ba3c1be7939a3":"421JF"}],"4QIVe":[function(require,module,exports,__globalThis) {
var baseHasIn = require("9fbd4bb192f3f572"), hasPath = require("b0aefd36de99e579");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
module.exports = hasIn;

},{"9fbd4bb192f3f572":"6bFxV","b0aefd36de99e579":"1l5ST"}],"6bFxV":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = baseHasIn;

},{}],"1l5ST":[function(require,module,exports,__globalThis) {
var castPath = require("bdbd2cfd212d36f7"), isArguments = require("47ffafdab3ba0d6f"), isArray = require("93ebd263ff0131c1"), isIndex = require("252ef74480e01958"), isLength = require("23c2f64e75e90a2"), toKey = require("af5ade297cb685ee");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
module.exports = hasPath;

},{"bdbd2cfd212d36f7":"f3wws","47ffafdab3ba0d6f":"lGymi","93ebd263ff0131c1":"bCmB4","252ef74480e01958":"f4t28","23c2f64e75e90a2":"hnKdL","af5ade297cb685ee":"RBtZh"}],"5OhK3":[function(require,module,exports,__globalThis) {
var baseProperty = require("c7f2d79ee4b1c16a"), basePropertyDeep = require("abf31da39349df22"), isKey = require("a387ef4a4373de2c"), toKey = require("9315973458389ae7");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = property;

},{"c7f2d79ee4b1c16a":"dAR2V","abf31da39349df22":"4gSJp","a387ef4a4373de2c":"jwsgR","9315973458389ae7":"RBtZh"}],"dAR2V":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = baseProperty;

},{}],"4gSJp":[function(require,module,exports,__globalThis) {
var baseGet = require("f0f9f03bc3030d02");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
module.exports = basePropertyDeep;

},{"f0f9f03bc3030d02":"421JF"}],"8U7lG":[function(require,module,exports,__globalThis) {
var baseEach = require("488df795cf6fe570"), isArrayLike = require("2924e2db4bb5430d");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function baseMap(collection, iteratee) {
    var index = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
    baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = baseMap;

},{"488df795cf6fe570":"8f5we","2924e2db4bb5430d":"f6382"}],"8f5we":[function(require,module,exports,__globalThis) {
var baseForOwn = require("ee57d32bcdc873cb"), createBaseEach = require("f1e3fc84161ef3ec");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
module.exports = baseEach;

},{"ee57d32bcdc873cb":"3ymA5","f1e3fc84161ef3ec":"3SKDS"}],"3ymA5":[function(require,module,exports,__globalThis) {
var baseFor = require("c7da20818a5fe3d6"), keys = require("1fb77c53defe5720");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
module.exports = baseForOwn;

},{"c7da20818a5fe3d6":"6uMGX","1fb77c53defe5720":"kYKDj"}],"6uMGX":[function(require,module,exports,__globalThis) {
var createBaseFor = require("178c767a7be60d59");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
module.exports = baseFor;

},{"178c767a7be60d59":"bqMdu"}],"bqMdu":[function(require,module,exports,__globalThis) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = createBaseFor;

},{}],"3SKDS":[function(require,module,exports,__globalThis) {
var isArrayLike = require("49bbd11cbf093bb1");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = createBaseEach;

},{"49bbd11cbf093bb1":"f6382"}],"hCGW1":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = baseSortBy;

},{}],"hjWoR":[function(require,module,exports,__globalThis) {
var compareAscending = require("dd5e23e02b1cd726");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = compareMultiple;

},{"dd5e23e02b1cd726":"l4VS8"}],"l4VS8":[function(require,module,exports,__globalThis) {
var isSymbol = require("a51b63ee8daeecee");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = compareAscending;

},{"a51b63ee8daeecee":"b0ZB5"}],"43qze":[function(require,module,exports,__globalThis) {
var baseAssignValue = require("45224c2cbc26a385"), createAggregator = require("54112449397fdfd2");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var groupBy = createAggregator(function(result, value, key) {
    if (hasOwnProperty.call(result, key)) result[key].push(value);
    else baseAssignValue(result, key, [
        value
    ]);
});
module.exports = groupBy;

},{"45224c2cbc26a385":"kIeTG","54112449397fdfd2":"g9n00"}],"kIeTG":[function(require,module,exports,__globalThis) {
var defineProperty = require("57c6267f904aee0a");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == '__proto__' && defineProperty) defineProperty(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = baseAssignValue;

},{"57c6267f904aee0a":"avMUX"}],"g9n00":[function(require,module,exports,__globalThis) {
var arrayAggregator = require("64738ab87169df22"), baseAggregator = require("d5eaf98cd48e9d0f"), baseIteratee = require("161d63ee0d95ee81"), isArray = require("3ebefba2225c8b9e");
/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
        return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
    };
}
module.exports = createAggregator;

},{"64738ab87169df22":"bNRLL","d5eaf98cd48e9d0f":"3Vyr6","161d63ee0d95ee81":"e8N0c","3ebefba2225c8b9e":"bCmB4"}],"bNRLL":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = arrayAggregator;

},{}],"3Vyr6":[function(require,module,exports,__globalThis) {
var baseEach = require("b2d4f581dd6625d8");
/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function baseAggregator(collection, setter, iteratee, accumulator) {
    baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = baseAggregator;

},{"b2d4f581dd6625d8":"8f5we"}],"jteyB":[function(require,module,exports,__globalThis) {
var isObject = require("3b174a999d6a40ac"), now = require("575b2317167ce20d"), toNumber = require("a13332670c5c0f63");
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    wait = toNumber(wait) || 0;
    if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge(now());
    }
    function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = debounce;

},{"3b174a999d6a40ac":"b5XR2","575b2317167ce20d":"3KUao","a13332670c5c0f63":"90hUs"}],"3KUao":[function(require,module,exports,__globalThis) {
var root = require("6439589d9d88d885");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var now = function() {
    return root.Date.now();
};
module.exports = now;

},{"6439589d9d88d885":"63oqc"}],"7UWv5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "anatomogramSpecies", ()=>supportedSpecies);
parcelHelpers.export(exports, "default", ()=>AnatomogramContainer);
parcelHelpers.export(exports, "getAnatomogramViews", ()=>getAnatomogramViews);
parcelHelpers.export(exports, "getDefaultView", ()=>getDefaultView);
parcelHelpers.export(exports, "isSupportedSpecies", ()=>isSupportedSpecies);
parcelHelpers.export(exports, "normaliseSpecies", ()=>normaliseSpecies);
parcelHelpers.export(exports, "render", ()=>render);
parcelHelpers.export(exports, "supportedSpecies", ()=>supportedSpecies);
parcelHelpers.export(exports, "svgsMetadata", ()=>svgsMetadata);
var _jsxRuntime = require("react/jsx-runtime");
var _client = require("react-dom/client");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
const __vite_glob_0_0 = "data:image/png;base64,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";
const __vite_glob_0_1 = "data:image/png;base64,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";
const __vite_glob_0_2 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEkAAABJCAYAAABxcwvcAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAz1AAAM9QEISxjmAAAAB3RJTUUH3wcIDgwSDbrj6wAACBBJREFUeNrtnEtsW1kZx//34Wdsx04cxx7nbTttkiZp+oiaJnQGRlQMMDAzQoBgwcCAKjFixZYVK1iwAaQu0EiDWICQmEEzBUFGHWimtEQ0TabJNE+nsZM2TpzYju34eR8sPM00vcchra/vNRN/UhY5vrrn+Ofzfec7//vdQ4miKKJqBxpb7AM+xyO/m8VRYEhRFLQmHWgNczhIO4EIVkZnEfOHIQpHZ5JRNAWb14G2i8dhaanb/9mj7rY+voKFt6eOFBwSrM5XBuAabN1rox+dQUcdEACIgoiFtyYRD0al7rYyOqsoIK1FD5unAZbWOhgbTNDbjGANWlA0BVEUwaXzyMZSSIWTiAejiPnDyERTioFaeW8Wfa+d/wSSwAmI+cNl75zRsmg81YzG0y2oba078FqNUQtDfQ2sngY8c64dAJBc30HoVhAbE0HkU7myjjW6FIbA8aAZpgApn8iUdRYxWgbNF3xwj3igMWqf+j4mVy28L/ai/WIX7t+8h+A/5sGl8+WZTbyAXCJbmOEAIJQRUH23E76X+qG3GuWDrmPR8pwPzjMt8F+Zxsbt1bK53YF5UqlGszQ8XzoB97CnfHHNpEPXN8+g7lgjFv40BT7HKZtMlnRTPYsT3xmC1WM/8Do+xyHm30I8EEEqnEAukf04DtDQmHQw2E2wtNTB6rEf6KaNA82ocZhx540byCWzlQ+J1WvQf2kEZre16DWJ1SjWrvsRnnkAIc//79yFoVF3zIGmYQ9sPgc5XrmtGHj9WUxdHkM2nqlcSDTL4MSr54oCykRTWHrnDrY+Wn/iILp9N4TtuyHUttXD93I/TK5ayXWG+hr0vnYeU5c/AJeRL6DTckLyfqUX1g6yi21MruI/v7j6xIAk26aVbUz88p9YvbYIiOQV8Pg3TgMUKg9SQ697L5953O79/S5mf39LtsAq8gL8f5nB3B8niKmLvccF93lPZUFidCy8X+0jA/rbXQSuzpdl1QlNBDH7h1tEpaLjC93Q1RoqB1Lr88ehs+ilX+JWEIH3ywPooW1OrWHlvTniD9fxQk9lQNIYtXAPSd0sFU5i8e0pRfZagavziC1vSdodJ5tgqK9RH5JrsBWMTrpILv75Q/CHWN7lCVIiFt6agsgLEtmj6TNe9SE1nmqRtMX8YUQXNxWVOFKbCYQI2xPHySbQLK0eJKPDjBqnRdK+Orakiha0NrZIDAdWT4N6kGxeaee5ZBaR+Q1VIO1uJJBYix1qnIpBqm2rl+owC5uqqpuRudChxqmcuzWYiBmxmkbq3+gwqwdJT1heU5sJVSHtEvpnDZqSxL6nh0SBuPTnEhlVIeWKKACsXqM8JEbDgKIogkbEqwpJFEQIHE/MwBWHJHAC+YYMrSokUAX9STpeXnlIoiASBTO2RqsqI41BS5zhXJZTHhIAZGJp6UpiN6kKyUBYcQVOQL4EWbckSOmtpKTN3GRVFZKl2SYd53aypNytJEjx1ag0uy2iQStlpP7jgah6edIOQZ6ocVqI+rMi8cioha1TCokkoygHaWWb+AjnmaF2VSC5Btskq6vAC9ieXVcPkiiICH+4Jml3nmmF3mZUFBCrZ9F0wUvYy22U/Ci85KTm/o1licZMs3RRzbtc1naxG1qTTiqfXPeXfO+SIaXCSWzNSKezvdsF12CbYsHaPdwhDQeBiCzVMrKkx8t/nYHASzNw30t9JcsUh1Eiur91VppAioD/yrQsfcgCKb29iyDhqQjNMuj97pCkBlG2xNFuQt/3h6EhZPkPxu8hHohUDiQACLy/sK+E7lGZov/SCBz9blkBWT12DPzwAnGBSIWTss0iWSGJvICPfjdOLFZgNAy6vz2I418/VZKuAxQKwjq+2IP+H4wQAzWXzmPmzZuyqhGyFkxkd9KYfuMG+i+NEGE4z7SivtuFtet+PLix/EQlfYyWgfNsG1qe8xV9MsvnOEy/eROpcFLe9ELuOJFc38Gd3/wLvd8bgtasJ2bF7Re70Pq5Y4jMbyAyF8JOIIL0VnKf/ELRFAz1NbC01MHW6YC9xwVGW3y4XDqPmd/+Gzv35JePy1LElbgfw+1fX8OJV88V3aLQLA17jwv2HtdeYspl8uAyebA6DVg9S9SFiqUhM2WYQWWFBBRqkW7/6ho6XuiGe8RD1HgeNYqmoDFqnyxmiYVVzH9luqyKaNkgFXQcHkvvTmNjchXeF/tQ2y5fzhQPRrH07h3ZlnnVIO2531oMk5fHYO2wo2nEg7ou51PJvCIvIDK/ibXrS4guhaGUsVDQYstbiC1vQWPUor7LCau3AZZmGwx2EyiaIm6g09u7SKxGEF3awvZsCPndLJQ2FipYPpVDaCKI0ESwEMQZGsM//TKYx16l+uAn7xR94KCk0agAE3iBWP9I2g8eWUiVblVIVUhVSFVIVUhVSFVIR9JUybjNzTZ0vnxy/6+lkf5ep3/02X3/+69Ml/w09v8GEqtjD1VY8fg1rEFTdbdqTKpCqgZu2W0nEMH4z0b3tZ398fOSU2fGfz66Tx1Qq7JXFUhCnkc6sruvjXQCUTqyS5RQVHE3mqaqPkWwh2opDQAas44onx5pQAwNrVkHiA9nEsuU/CbPp81svgbQLFOoC394yFQ8EMHk5THV3jAiJYrlOqzlMG526vVnYf64kncvBbC01qHzlQHV3I5L5yV/agE69rWBPUDAY8eVAUA8GMHK6Byi/rDkndZPewyy+RrQ/vmuAiARewcwUMWOUBQ5AdlEpno64EGQqvaJ/Rfn1RmI44pFNwAAAABJRU5ErkJggg==";
const __vite_glob_0_3 = "data:image/png;base64,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";
const __vite_glob_0_4 = "data:image/png;base64,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";
const __vite_glob_0_5 = "data:image/png;base64,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";
const __vite_glob_0_6 = "data:image/png;base64,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";
const __vite_glob_0_7 = "data:image/png;base64,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";
const __vite_glob_0_8 = "data:image/png;base64,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";
const __vite_glob_0_9 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEkAAABJCAYAAABxcwvcAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAEzlAABM5QF1zvCVAAAAB3RJTUUH3wgTCRUamGaTCwAACtRJREFUeNrtnGlwW9UVx3/3PUlPqy3L+4IdO4uDY5yEACWkQEPYQwNdYFKYtEOnlBYKhWEYCtNS2k473VKm0IHhA01JS0LblDRMQyAJS0MgbXAScLPZcWxjx7ssy5Ks5Unv3X6wcWywoQvEItb55nl6V1c/n3vuOf+7CCmlZNRSZoL+cAOHezZyYnA3w3ofkrHHp60JBC5bAaXeC1hQfBMFnoWoiu3k83chxZNB/nbwK/SG9qMbw9hUN1mOChShnPaQpDQJxTtIpELYVBcFnoWsqtuAZsk6CSmeHGT93mXoqRB57gVcOPshSr1LmWnWGdzDrubvEYg2oQqNNee9hksrQqSMuNz89g30hPaxpPxbnD/rXoRQmakmpcGu5gc52LWespxPc23dRpS+cAO9of3kuRfMeEAAQqhcPPfHeJ1VtPi30TX0Jsqhng3oxjAXzn5oxgMabytrf4cQFl4//gOUzsHXsVncaRWDWga2Y8okSSMybX3Ispfjc86jP/IvlGG9j2x7RVr9F18+eg+vNH2HZ/ZdQYv/hWlKC8Bh9QECZSQPEmkDSDeGiSUHONq7iXC8k7aBHdMYn0a4pF0SZFNdzC1YhWnq6KkwTlvhtPfJko5Bs9S7lHC8g+vP3poW/UnLdDocP4FmzUmb/qQRJMmLR25nX/uj1Lc/ik11p03P0mK4pcw4fzlwHX3hBnodFajChhAKncE9dA39k3Mr7sp4kkDg1kpQFCuRRDdCKBzvf54tDV+iL/x2xpMAVEVjZe1vOdT9NDaLh4Nd6+kZ2k+572JWVK+d2TFpYPgI9e88ymDsOAALim9ibv4qHNZcZudfxcradditPjqDb7DjyJ1seHP5zPKktsDLPHvgWiyqiz1tP2Fh6de4aM6PADBMHa+rajS5jLD5reuRSBTFSneonuKsc2aGJx3oeBy71YcqbOQ6q2nsfXbsWTwZwKWNJJFdwX8iFBVVsSEQWBXHzBluVblXoBvDGFInGGsDJKF420ielOjCrZWMetxOBAourYjynIvIcy+YOcOttuTLzC+6AUWonAi+ztaDN9Pi38GisluI6v3kOOcSjLZwqPtpBIIlZ9xGTfGNMysmqYptTGyvzL2cK2ueYMfRb1PoWYgQKk5bPlsabsSiOFhU9nVqS9ZMWyGeNrXbnPxrONj1FPs6HkOgEIq30xd6i6trn6Qy97JMMvmunVN+F63+7Qgh2Nv2SzRrFhW+z2Rqt/FWmLUIr7MKw9Q51vccV575OIqwZiBNGPuKA6+jCpCcW3E3ZTkXZlSA99VwQsGqOpCA11GZkUqmMrdWDNJESjMDaSo7b9Y9qIqNlNQzkKYym+rhrNKbSSQH0ydWkoamp4aQqjH2t5RybOUi40ljkIaJJwMc6fkTv3m1lEf+Xog/cjjjSeMtaQzTFniDg11/QFXtFLkXY7N4MpDeC8miOFh51jrm5q/KBO5Jh5sxzPmV96UFoLSFlDJjqIqWmd0+DJIiTnYtMNxE68B24slBziy6Hp9rfgZSyogiUEgaUXYcvYPm/udRhAUhFGLJAS6d/zCnUltKC0hDsTaO9m7CacvnrJKvkDRimDLFpgOr6A7VMyfvaoqyzyHHUUVx9nmcavFt2iHt73iM15ofwqI6QJp0Dr4BCPa0/oSYHuDy+Y9QW/LlmRuTDDPBoe6NuLUiaopvpCe0j8a+zVhVJ+F4JyuqH6amePXMDtyqonH94i1YVAcWxYGUJi8cuZUW/3YuqHogLQClRQpgt/qwjK6lCaGwfO7PQJqUepdlVICpTYJQsCj2DKQPQDQydwmRgTQlpFFFUqRRn9IOkilTaYYoDSGlzFjaRcm0g5Q0YmnnSWlVu/WE9rGn9aeowoIqbKe3J0kk8WSAcPwEwVgrwWgLoXg7seTA6Pw1uf2j7eecGNyNIZNsqL+U7qH608uT+sJv0dz/NzoGdzGc6MPEQEpz9HiqRCAQQkWg4nPOZXb+SuYVXIt93H5tq+IcOymVMmN0De2lOPucTzakgeFGGns3cbh7IxG9B1XYUBQr4gNiikTSOfQG7YOv8lLj3eS7a5mdfzVVeVdOPEomJQ5bDq0DOwlGmxmKtxPVe9FTYQyZREHFqrpw2HJxacVk2yvwaCU4bfm4tOKxo6HTCmnHkTs57t+GIRMIlA/cnG7KFKZMIaWBWyvBoxVjUZ2YMkkiFeFfneupb38Uq+IcE9ssqp1XGu/DlMnRVgRCKAiUseUlOQ4ogCJUVNWORXHg0YqZX3QDC4pvmiDgnTJIWw99lVb/9hEh7D1hTUoDUxpolmw89hI89jMoy15KiXcpBZ66SdtLpEK8E3iJFw/fNibburVSlpTfjiKsmFInacSI6n5C8TYiiW7C8U4iejcK6pgHSiQpI0bKiBFLDtDdtI9Xm+6nrvRmzi6/DY9WemogdQzu5nj/1rGi9N1BZJg6IKjKu5KaotXke2rRLNlYVdeUbR3t/TNvn3iSSKKLqO7HYctHT4UAidcxiwXFN03hmUkSqTDB6HHq2x+h1b8dVdEQ406eC8RY/Xewaz0ngrv5wqLN2K2+jx9SMHYcUxqYMoUiVNxaCTnOOVQXfp55BZ/70PcTqSHaBnawq/n7xHQ/FnXkh9SWrKHAU8fLjfeiKjZaB3YSGbfBdMKULKw4rD4c2T4+e9bvCSc62du2lo7BXYQT3ajCMiHXEkJlONFLLBk4NZCqC79AJN6JVXVRkXsJHq30P/7iVv92drf8gKHYOyhCxaI6MGWSmqIbWT7vZzyxex6qMrJpy6JovHD4G3xx8XMf2q5HK2VF9a+I6X5aAzt5rflB9FR4woqLqtixqs5TM9xsqpulVQ/8V+/oRoTXmr9LQ+d6NEvWhEBqUexcUv0Lmvu3oqciY5tNhVDxRw7hjxz6j7clO2x51BStpqZoNQ2d6zjS8wyRRC+m1JnlWz6pV6ZFxh1LDrBp/ypC8fb3TctSGtSV3QrAsb4tE66+GIk9Bk39z/1Pe7frSm+mtmQNw3ovpqmT9X+cM/5Ya7d4KsjG+hWEE52THqe3KHaqC68jaUQZirVO2kZT71//9x8nLHi0UrIdlROCelpBqn/n18SSgSnTSp+rmlzXmRhmgngqOOmnBqNNp7cKcKDjifflUSclkQQXzfvxaPxRpkz40kHG/dggtfi3jcuW35+B15asodC9cGQysGSR76kbFdwmWoFn0ekLKar7p4wDDquP8yrunpD4XVXzBGXeZSjCimREwrVbvVw456HpL3BHitGP/iKpOfnX8FLjPZOIalE+NeueSafj6xb+kb5wA6F4O6qiUehZiNNWMG1w3r1/S3HZCgjFOz7yL7Bbc1hRvXbUm0bkEilNKnKXs6T8jinfK/DUMSf/GipzL5teQEAsGRgpb8q8y2joeorO4J6P/FKX2pI1ZNnLOdr7J1JGnDx3DYvP+CafBAvF2hiMHqPEuxTRFdwrn33r8/hc1axe8mLmeqBR2/DmJfRFGvji4i0oBZ6FFHgWEYg2sav5wQwd4JWm+whEj1GZexll3mUjd7olUiHW7VmCYcbxOqtYWbuOLHtFmq1ZfPwxKBRr4/lDtxCIHsOmuvjSuS/h0UpP3g44nOhhZ+PdtPi3IYQFn3MeDmvutG4yP3WzmEksGWAwegyJpDL3Ui6pXjsm0onx90wCdIfq2d38Q/ojb8MM8iWBIM+zgKWV91P2nh0t/wbgHSxwS07/3AAAAABJRU5ErkJggg==";
const svgsMetadata = /* @__PURE__ */ JSON.parse('[{"filename":"anolis_carolinensis.svg","species":"anolis_carolinensis","view":"","ids":["UBERON_0000955","UBERON_0000948","UBERON_0002113","UBERON_0014892"]},{"filename":"arabidopsis_thaliana.svg","species":"arabidopsis_thaliana","view":"","ids":["PO_0025034","PO_0009005","PO_0009046","PO_0009001"]},{"filename":"bos_taurus.svg","species":"bos_taurus","view":"","ids":["UBERON_0001013","UBERON_0014892","UBERON_0002114","UBERON_0000955","UBERON_0002113","UBERON_0002048","UBERON_0001155","UBERON_0000948","UBERON_0002107","UBERON_0002016","UBERON_0001898"]},{"filename":"brachypodium_distachyon.flower_parts.svg","species":"brachypodium_distachyon","view":"flower_parts","ids":["PO_0009066","PO_0009030","PO_0009001","PO_0009009","PO_0009089"]},{"filename":"brachypodium_distachyon.whole_plant.svg","species":"brachypodium_distachyon","view":"whole_plant","ids":["PO_0009010","PO_0009049","PO_0025034"]},{"filename":"gallus_gallus.svg","species":"gallus_gallus","view":"","ids":["UBERON_0000955","UBERON_0000948","UBERON_0002113","UBERON_0002107","UBERON_0001155","UBERON_0002106","UBERON_0002048","UBERON_0014892"]},{"filename":"homo_sapiens.brain.svg","species":"homo_sapiens","view":"brain","ids":["UBERON_0002148","UBERON_0001894","UBERON_0001896","UBERON_0002771","UBERON_0002702","UBERON_0002021","UBERON_0001905","UBERON_0001897","UBERON_0001898","UBERON_0002421","UBERON_0003027","UBERON_0001876","UBERON_0001870","UBERON_0001871","UBERON_0001882","UBERON_0002285","UBERON_0001873","UBERON_0001872","UBERON_0002038","UBERON_0001874","UBERON_0001875","UBERON_0002360","UBERON_0000451","UBERON_0000956","UBERON_0002037","UBERON_0002363","UBERON_0001954","UBERON_0002245"]},{"filename":"homo_sapiens.female.svg","species":"homo_sapiens","view":"female","ids":["UBERON_0001981","UBERON_0000178","UBERON_0001637","CL_0000236","CL_0000084","CL_0000623","CL_0000576","CL_0000233","UBERON_0000966","UBERON_0001831","UBERON_0001013","UBERON_0000948","UBERON_0001135","UBERON_0000955","UBERON_0000310","UBERON_0002369","UBERON_0000029","UBERON_0001134","UBERON_0000992","CL_0000738","UBERON_0001044","UBERON_0003889","UBERON_0000995","UBERON_0000002","UBERON_0001021","UBERON_0006618","UBERON_0012249","UBERON_0002421","UBERON_0000977","UBERON_0002185","UBERON_0003126","UBERON_0002048","UBERON_0002372","UBERON_0000970","UBERON_0001876","UBERON_0001736","UBERON_0001264","UBERON_0002107","UBERON_0001155","UBERON_0002371","UBERON_0001255","UBERON_0000945","UBERON_0002114","UBERON_0001043","UBERON_0002110","UBERON_0002106","UBERON_0002108","UBERON_0001987","UBERON_0001295","UBERON_0000996","UBERON_0000947","UBERON_0000007","UBERON_0007650","UBERON_0001153","UBERON_0001154","UBERON_0002116","UBERON_0002079","UBERON_0002084","UBERON_0002146","UBERON_0002135","UBERON_0001103","UBERON_0002481","UBERON_0007844","UBERON_0000341","UBERON_0001052","UBERON_0001706","UBERON_0001728","UBERON_0002037","UBERON_0002245","UBERON_0000451","UBERON_0001870","UBERON_0000004","UBERON_0001871","UBERON_0000956","UBERON_0002113","UBERON_0001225","UBERON_0001621","UBERON_0002134","UBERON_0002046","UBERON_0000014","UBERON_0000167","UBERON_0001723"]},{"filename":"homo_sapiens.male.svg","species":"homo_sapiens","view":"male","ids":["UBERON_0000956","UBERON_0000977","UBERON_0000955","UBERON_0000948","UBERON_0000310","UBERON_0002369","UBERON_0000029","UBERON_0001013","UBERON_0001134","CL_0000738","UBERON_0001871","UBERON_0006618","UBERON_0001621","UBERON_0002421","UBERON_0001000","UBERON_0000998","UBERON_0000473","UBERON_0001301","UBERON_0000970","UBERON_0002372","UBERON_0002048","UBERON_0001876","UBERON_0003126","UBERON_0002185","UBERON_0001021","UBERON_0002037","UBERON_0002245","UBERON_0002113","UBERON_0001225","UBERON_0002046","UBERON_0002371","UBERON_0001870","UBERON_0000451","UBERON_0000007","UBERON_0000947","UBERON_0007650","UBERON_0002084","UBERON_0001153","UBERON_0002116","UBERON_0001052","UBERON_0000004","UBERON_0001723","UBERON_0002079","UBERON_0002146","UBERON_0002135","UBERON_0000989","UBERON_0001728","UBERON_0002240","UBERON_0000341","UBERON_0002134","UBERON_0001103","UBERON_0002107","UBERON_0000945","UBERON_0002106","UBERON_0002114","UBERON_0002110","UBERON_0001264","UBERON_0001155","UBERON_0002108","UBERON_0001154","UBERON_0001135","UBERON_0001255","UBERON_00024818","UBERON_0007844","UBERON_0001043","UBERON_0001044","UBERON_0001831","UBERON_0001736","UBERON_0000014","UBERON_0000178","UBERON_0001981","UBERON_0001637","CL_0000236","CL_0000084","CL_0000623","CL_0000576","CL_0000233","UBERON_0001954","UBERON_0000966","UBERON_0001706","UBERON_0000167","UBERON_0002367"]},{"filename":"hordeum_vulgare.flower_parts.svg","species":"hordeum_vulgare","view":"flower_parts","ids":["PO_0009001","PO_0009030","PO_0009073","PO_0009072","PO_0009009","PO_0009066"]},{"filename":"hordeum_vulgare.whole_plant.svg","species":"hordeum_vulgare","view":"whole_plant","ids":["PO_0020142","PO_0009005","PO_0009006","PO_0009049","PO_0025034"]},{"filename":"macaca_mulatta.svg","species":"macaca_mulatta","view":"","ids":["UBERON_0000955","UBERON_0000451","UBERON_0002037","UBERON_0000948","UBERON_0002113","UBERON_0002107","UBERON_0000473"]},{"filename":"monodelphis_domestica.svg","species":"monodelphis_domestica","view":"","ids":["UBERON_0000955","UBERON_0002037","UBERON_0000948","UBERON_0002113","UBERON_0002107","UBERON_0000473"]},{"filename":"mus_musculus.brain.svg","species":"mus_musculus","view":"brain","ids":["UBERON_0001896","UBERON_0000956","UBERON_0000369","UBERON_0001894","UBERON_0000007","UBERON_0002037","UBERON_0002298","UBERON_0001891","UBERON_0001897","UBERON_0001898","UBERON_0000004","UBERON_0002259","EFO_0000530"]},{"filename":"mus_musculus.female.svg","species":"mus_musculus","view":"female","ids":["UBERON_0000947","UBERON_0001009","UBERON_0001348","UBERON_0001347","UBERON_0000945","UBERON_0002114","UBERON_0001264","UBERON_0002106","UBERON_0002369","UBERON_0002113","UBERON_0001155","UBERON_0002108","UBERON_0001153","UBERON_0002115","UBERON_0002116","UBERON_0001043","UBERON_0002110","UBERON_0000996","UBERON_0000995","UBERON_0001255","UBERON_0001831","UBERON_0001736","UBERON_0001723","UBERON_0001211","UBERON_0000981","UBERON_0002371","UBERON_0007844","UBERON_0001377","UBERON_0014892","UBERON_0002240","UBERON_0001103","UBERON_0002103","UBERON_0001645","UBERON_0000970","UBERON_0001242","UBERON_0000955","UBERON_0000948","UBERON_0002107","UBERON_0001322","UBERON_0001981","UBERON_0000014","UBERON_0001911","UBERON_0003134","UBERON_0000990","UBERON_0000029","UBERON_0001132","UBERON_0002370","UBERON_0002046","UBERON_0002048","UBERON_0000010","UBERON_0003126"]},{"filename":"mus_musculus.male.svg","species":"mus_musculus","view":"male","ids":["UBERON_0000947","UBERON_0001348","UBERON_0001347","UBERON_0000945","UBERON_0002114","UBERON_0001264","UBERON_0002106","UBERON_0002369","UBERON_0002113","UBERON_0001155","UBERON_0002108","UBERON_0001153","UBERON_0002115","UBERON_0002116","UBERON_0001043","UBERON_0002110","UBERON_0001831","UBERON_0001736","UBERON_0000029","UBERON_0000998","UBERON_0000989","UBERON_0000981","UBERON_0002371","UBERON_0007844","UBERON_0001377","UBERON_0002240","UBERON_0002048","UBERON_0001103","UBERON_0003126","UBERON_0002103","UBERON_0001645","UBERON_0001322","UBERON_0001242","UBERON_0002107","UBERON_0000948","UBERON_0000955","UBERON_0014892","UBERON_0001009","UBERON_0001981","UBERON_0000014","UBERON_0001132","UBERON_0001211","UBERON_0002367","UBERON_0001000","UBERON_0001301","UBERON_0000473","UBERON_0001255","UBERON_0002370","UBERON_0000010","UBERON_0000970","UBERON_0001723"]},{"filename":"oryza_sativa.flower_parts.svg","species":"oryza_sativa","view":"flower_parts","ids":["PO_0009010","PO_0009009","PO_0009089","PO_0009030","PO_0009066"]},{"filename":"oryza_sativa.whole_plant.svg","species":"oryza_sativa","view":"whole_plant","ids":["PO_0025034","PO_0009005","PO_0009049","PO_0009006","PO_0005052"]},{"filename":"papio_anubis.svg","species":"papio_anubis","view":"","ids":["UBERON_0000948","UBERON_0002107","UBERON_0000945","UBERON_0001155","UBERON_0002371","UBERON_0002113","UBERON_0002106","UBERON_0014892","UBERON_0002370","UBERON_0000955","UBERON_0001871","UBERON_0001870","UBERON_0000007","UBERON_0002048","UBERON_0000029","UBERON_0002037"]},{"filename":"rattus_norvegicus.svg","species":"rattus_norvegicus","view":"","ids":["UBERON_0000955","UBERON_0002113","CL_0000336","UBERON_0001388","UBERON_0000948","UBERON_0002107","UBERON_0002048","UBERON_0002106","UBERON_0002370","UBERON_0000995","UBERON_0000473","UBERON_0001155"]},{"filename":"solanum_lycopersicum.flower_parts.svg","species":"solanum_lycopersicum","view":"flower_parts","ids":["PO_0009084","PO_0009030","PO_0009072","PO_0009073","PO_0009074","PO_0009066","PO_0009010"]},{"filename":"solanum_lycopersicum.whole_plant.svg","species":"solanum_lycopersicum","view":"whole_plant","ids":["PO_0025034","PO_0000056","PO_0009046","PO_0009001","PO_0009005"]},{"filename":"solanum_tuberosum.svg","species":"solanum_tuberosum","view":"","ids":[]},{"filename":"sorghum_bicolor.flower_parts.svg","species":"sorghum_bicolor","view":"flower_parts","ids":["PO_0009049","PO_0009051","PO_0009001","PO_0009009","PO_0009089","PO_0009066","PO_0009030"]},{"filename":"sorghum_bicolor.whole_plant.svg","species":"sorghum_bicolor","view":"whole_plant","ids":["PO_0009006","PO_0006079","PO_0009047","PO_0000230","PO_0009049","PO_0025034","PO_0009005"]},{"filename":"tetraodon_nigroviridis.svg","species":"tetraodon_nigroviridis","view":"","ids":["UBERON_0000955","UBERON_0000948","UBERON_0002113","UBERON_0014892"]},{"filename":"triticum_aestivum.flower_parts.svg","species":"triticum_aestivum","view":"flower_parts","ids":["PO_0020033","PO_0020031","PO_0009089","PO_0009085","PO_0009086","PO_0009084","PO_0009009","PO_0009001","PO_0009088","PO_0009030","PO_0009066"]},{"filename":"triticum_aestivum.whole_plant.svg","species":"triticum_aestivum","view":"whole_plant","ids":["PO_0009047","PO_0009005","PO_0009049","PO_0025034"]},{"filename":"xenopus_tropicalis.svg","species":"xenopus_tropicalis","view":"","ids":["UBERON_0000955","UBERON_0002113","UBERON_0014892","UBERON_0000948","UBERON_0002107"]},{"filename":"zea_mays.flower_parts.svg","species":"zea_mays","view":"flower_parts","ids":["PO_0009001","PO_0020033","PO_0020031","PO_0020136","PO_0025597","PO_0009066","PO_0009009","PO_0009089","PO_0009084"]},{"filename":"zea_mays.whole_plant.svg","species":"zea_mays","view":"whole_plant","ids":["PO_0020126","PO_0020136","PO_0020142","PO_0020127","PO_0009005","PO_0009074","PO_0025034"]}]');
const unique = (element, index, array)=>array.indexOf(element) === index;
const isNotBlank = (str)=>typeof str === `string` && str.trim() !== ``;
const supportedSpecies = svgsMetadata.map((svgMetadata)=>svgMetadata.species).filter(unique);
const multipleViewsSpecies = svgsMetadata.filter((svgMetadata)=>svgMetadata.view !== ``).map((svgMetadata)=>svgMetadata.species).filter(unique);
const anatomogramViews = multipleViewsSpecies.reduce((acc, species)=>{
    acc[species] = svgsMetadata.filter((svgMetadata)=>svgMetadata.species === species).map((svgMetadata)=>svgMetadata.view).filter(isNotBlank).sort().reverse();
    return acc;
}, {});
const getAnatomogramViews = (species)=>{
    if (supportedSpecies.includes(species)) return anatomogramViews[species] || [];
};
const getDefaultView = (species)=>{
    if (supportedSpecies.includes(species)) return getAnatomogramViews(species)[0] || null;
};
const icons = /* @__PURE__ */ Object.assign({
    "./img/brain.selected.png": __vite_glob_0_0,
    "./img/brain.unselected.png": __vite_glob_0_1,
    "./img/female.selected.png": __vite_glob_0_2,
    "./img/female.unselected.png": __vite_glob_0_3,
    "./img/flower_parts.selected.png": __vite_glob_0_4,
    "./img/flower_parts.unselected.png": __vite_glob_0_5,
    "./img/male.selected.png": __vite_glob_0_6,
    "./img/male.unselected.png": __vite_glob_0_7,
    "./img/whole_plant.selected.png": __vite_glob_0_8,
    "./img/whole_plant.unselected.png": __vite_glob_0_9
});
const loadIcon = (view, selectedView)=>icons[`./img/${view}.${view === selectedView ? `` : `un`}selected.png`];
const iconWrapperStyle = {
    display: `inline-block`,
    verticalAlign: `top`,
    width: `10%`,
    maxWidth: `44px`,
    lineHeight: 0
};
const iconStyle = {
    border: `1px solid #ccc`,
    borderRadius: `4px`,
    width: `100%`,
    height: `auto`,
    padding: `2px`,
    cursor: `pointer`
};
const iconActiveStyle = {
    ...iconStyle,
    border: `1px solid orange`,
    background: `lightgoldenrodyellow`
};
const SwitcherIcon = ({ view, selectedView, onChangeView })=>{
    const [active, setActive] = (0, _react.useState)(false);
    const label = view.replace(/_/g, ` `);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("img", {
        src: loadIcon(view, selectedView),
        alt: label,
        title: label,
        role: `button`,
        tabIndex: 0,
        "aria-pressed": view === selectedView,
        style: active ? iconActiveStyle : iconStyle,
        onClick: ()=>onChangeView(view),
        onKeyDown: (event)=>{
            if (event.key === `Enter` || event.key === ` `) {
                event.preventDefault();
                onChangeView(view);
            }
        },
        onMouseEnter: ()=>setActive(true),
        onMouseLeave: ()=>setActive(false),
        onFocus: ()=>setActive(true),
        onBlur: ()=>setActive(false)
    });
};
SwitcherIcon.propTypes = {
    view: (0, _propTypesDefault.default).string.isRequired,
    selectedView: (0, _propTypesDefault.default).string,
    onChangeView: (0, _propTypesDefault.default).func.isRequired
};
const Switcher = ({ species, selectedView, onChangeView })=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        className: `gxa-anatomogram-switcher`,
        style: iconWrapperStyle,
        children: (getAnatomogramViews(species) || []).map((view)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)(SwitcherIcon, {
                view,
                selectedView,
                onChangeView
            }, view))
    });
Switcher.propTypes = {
    species: (0, _propTypesDefault.default).string.isRequired,
    selectedView: (0, _propTypesDefault.default).string,
    onChangeView: (0, _propTypesDefault.default).func.isRequired
};
const svgLoaders = /* @__PURE__ */ Object.assign({
    "./svg/anolis_carolinensis.svg": ()=>require("d89fe6e0a079318b").then((m)=>m["default"]),
    "./svg/arabidopsis_thaliana.svg": ()=>require("bc5818463524082f").then((m)=>m["default"]),
    "./svg/bos_taurus.svg": ()=>require("a007c5279ecf88e").then((m)=>m["default"]),
    "./svg/brachypodium_distachyon.flower_parts.svg": ()=>require("95403352ede053").then((m)=>m["default"]),
    "./svg/brachypodium_distachyon.whole_plant.svg": ()=>require("a6df26768e161898").then((m)=>m["default"]),
    "./svg/gallus_gallus.svg": ()=>require("3c0f6b99e344d6e8").then((m)=>m["default"]),
    "./svg/homo_sapiens.brain.svg": ()=>require("289a79c7b7a78a5c").then((m)=>m["default"]),
    "./svg/homo_sapiens.female.svg": ()=>require("cec2ae4ee1f1eacb").then((m)=>m["default"]),
    "./svg/homo_sapiens.male.svg": ()=>require("e3483c447a9cf0fe").then((m)=>m["default"]),
    "./svg/hordeum_vulgare.flower_parts.svg": ()=>require("15e56c2e3ff028ed").then((m)=>m["default"]),
    "./svg/hordeum_vulgare.whole_plant.svg": ()=>require("151e5f2d6fd1309d").then((m)=>m["default"]),
    "./svg/macaca_mulatta.svg": ()=>require("bd8513edd0a0df44").then((m)=>m["default"]),
    "./svg/monodelphis_domestica.svg": ()=>require("668f9db299efb77d").then((m)=>m["default"]),
    "./svg/mus_musculus.brain.svg": ()=>require("c97f98eae2a99360").then((m)=>m["default"]),
    "./svg/mus_musculus.female.svg": ()=>require("9bbe119ac2efa16c").then((m)=>m["default"]),
    "./svg/mus_musculus.male.svg": ()=>require("53009f3e2b586349").then((m)=>m["default"]),
    "./svg/oryza_sativa.flower_parts.svg": ()=>require("89d321388a989ead").then((m)=>m["default"]),
    "./svg/oryza_sativa.whole_plant.svg": ()=>require("3e1730205efc7a8c").then((m)=>m["default"]),
    "./svg/papio_anubis.svg": ()=>require("b6b0a691dd9893c").then((m)=>m["default"]),
    "./svg/rattus_norvegicus.svg": ()=>require("69a06ab3229d3298").then((m)=>m["default"]),
    "./svg/solanum_lycopersicum.flower_parts.svg": ()=>require("525f64b917fbb795").then((m)=>m["default"]),
    "./svg/solanum_lycopersicum.whole_plant.svg": ()=>require("de3d1b395e1565cb").then((m)=>m["default"]),
    "./svg/solanum_tuberosum.svg": ()=>require("2f1e50e66782ac51").then((m)=>m["default"]),
    "./svg/sorghum_bicolor.flower_parts.svg": ()=>require("2232ef72f8395305").then((m)=>m["default"]),
    "./svg/sorghum_bicolor.whole_plant.svg": ()=>require("fc45704f69b39fa8").then((m)=>m["default"]),
    "./svg/tetraodon_nigroviridis.svg": ()=>require("389638331927bcdf").then((m)=>m["default"]),
    "./svg/triticum_aestivum.flower_parts.svg": ()=>require("606173bfdcfc2eb4").then((m)=>m["default"]),
    "./svg/triticum_aestivum.whole_plant.svg": ()=>require("a7ea86ae8886204a").then((m)=>m["default"]),
    "./svg/xenopus_tropicalis.svg": ()=>require("5b6158095797bf22").then((m)=>m["default"]),
    "./svg/zea_mays.flower_parts.svg": ()=>require("f13d29ff16fd6194").then((m)=>m["default"]),
    "./svg/zea_mays.whole_plant.svg": ()=>require("8ca2f0ca8599d156").then((m)=>m["default"])
});
const SVG_NS = `http://www.w3.org/2000/svg`;
const XLINK_NS = `http://www.w3.org/1999/xlink`;
const XMLNS_NS = `http://www.w3.org/2000/xmlns/`;
const svgPath = (species, view)=>`./svg/${species}${view ? `.${view}` : ``}.svg`;
const hasSvg = (species, view)=>Object.prototype.hasOwnProperty.call(svgLoaders, svgPath(species, view));
const defaultLoadSvg = (species, view)=>hasSvg(species, view) ? svgLoaders[svgPath(species, view)]() : Promise.reject(new Error(`No anatomogram SVG for ${species}${view ? ` (${view})` : ``}`));
const parseSvg = (text)=>{
    if (typeof text !== `string`) throw new TypeError(`Expected the SVG as a string, got ${typeof text}`);
    const doc = new DOMParser().parseFromString(text, `image/svg+xml`);
    const svg = doc.documentElement;
    if (!svg || doc.getElementsByTagName(`parsererror`).length > 0) throw new Error(`Invalid SVG: the document could not be parsed as XML`);
    if (svg.localName !== `svg` || svg.namespaceURI !== SVG_NS) throw new Error(`Invalid SVG: the root element is not an <svg> in the SVG namespace`);
    return svg;
};
const cache = /* @__PURE__ */ new WeakMap();
const loadPristineSvg = (species, view, loadSvg = defaultLoadSvg)=>{
    let byPath = cache.get(loadSvg);
    if (!byPath) {
        byPath = /* @__PURE__ */ new Map();
        cache.set(loadSvg, byPath);
    }
    const key = svgPath(species, view);
    let promise = byPath.get(key);
    if (!promise) {
        promise = new Promise((resolve)=>resolve(loadSvg(species, view || null))).then(parseSvg);
        byPath.set(key, promise);
        promise.catch(()=>{
            if (byPath.get(key) === promise) byPath.delete(key);
        });
    }
    return promise;
};
const iriElementsAndProperties = {
    clipPath: [
        `clip-path`
    ],
    "color-profile": [
        `color-profile`
    ],
    cursor: [
        `cursor`
    ],
    filter: [
        `filter`
    ],
    linearGradient: [
        `fill`,
        `stroke`
    ],
    marker: [
        `marker`,
        `marker-start`,
        `marker-mid`,
        `marker-end`
    ],
    mask: [
        `mask`
    ],
    pattern: [
        `fill`,
        `stroke`
    ],
    radialGradient: [
        `fill`,
        `stroke`
    ]
};
let injectCount = 0;
const allElements = (svg)=>[
        svg,
        ...svg.getElementsByTagName(`*`)
    ];
const renumberIriElements = (svg)=>{
    const defsDescendants = [];
    Array.from(svg.getElementsByTagNameNS(SVG_NS, `defs`)).forEach((defs)=>{
        Array.from(defs.getElementsByTagName(`*`)).forEach((element)=>{
            if (!defsDescendants.includes(element)) defsDescendants.push(element);
        });
    });
    Object.keys(iriElementsAndProperties).forEach((elementName)=>{
        const properties = iriElementsAndProperties[elementName];
        defsDescendants.filter((element)=>element.localName === elementName && element.hasAttribute(`id`)).forEach((element)=>{
            const currentId = element.getAttribute(`id`);
            const newId = `${currentId}-${injectCount}`;
            properties.forEach((property)=>{
                allElements(svg).filter((referencing)=>(referencing.getAttribute(property) || ``).includes(currentId)).forEach((referencing)=>referencing.setAttribute(property, `url(#${newId})`));
            });
            allElements(svg).forEach((link)=>{
                if (link.getAttributeNS(XLINK_NS, `href`) === `#${currentId}`) link.setAttributeNS(XLINK_NS, `xlink:href`, `#${newId}`);
                if (link.getAttributeNS(null, `href`) === `#${currentId}`) link.setAttributeNS(null, `href`, `#${newId}`);
            });
            element.setAttribute(`id`, newId);
        });
    });
    injectCount++;
};
const stripActiveContent = (svg)=>{
    Array.from(svg.getElementsByTagName(`*`)).filter((element)=>element.localName === `script` || element.localName === `foreignObject`).forEach((element)=>element.remove());
    allElements(svg).forEach((element)=>{
        Array.from(element.attributes).forEach((attribute)=>{
            const value = attribute.value.replace(/[\s\u0000-\u001f]+/g, ``).toLowerCase();
            if (/^on/i.test(attribute.localName) || value.includes(`javascript:`)) element.removeAttributeNode(attribute);
        });
    });
};
const prepareSvg = (pristine, doc, { paddingLeft = ``, linkTarget } = {})=>{
    const svg = doc.importNode(pristine, true);
    stripActiveContent(svg);
    svg.removeAttribute(`xmlns:a`);
    if (!svg.hasAttribute(`xmlns`)) svg.setAttributeNS(XMLNS_NS, `xmlns`, SVG_NS);
    if (!svg.hasAttribute(`xmlns:xlink`)) svg.setAttributeNS(XMLNS_NS, `xmlns:xlink`, XLINK_NS);
    renumberIriElements(svg);
    const classes = (svg.getAttribute(`class`) || ``).split(/\s+/).filter(Boolean);
    svg.setAttribute(`class`, [
        ...classes.filter((c)=>c !== `injected-svg`),
        `injected-svg`
    ].join(` `));
    svg.setAttribute(`style`, `width: 100%; height: auto;${paddingLeft ? ` padding-left: ${paddingLeft};` : ``}`);
    if (linkTarget != null) Array.from(svg.getElementsByTagNameNS(SVG_NS, `a`)).forEach((a)=>{
        a.setAttribute(`target`, linkTarget);
        if (linkTarget === `_blank`) a.setAttribute(`rel`, `noopener noreferrer`);
    });
    return svg;
};
const getSvgElementById = (svgDomNode)=>{
    const getEfoLayerGroup = (svgDomNode2)=>{
        const svgGroups = svgDomNode2.getElementsByTagName(`g`);
        for(let i = 0; i < svgGroups.length; i++){
            if (svgGroups[i].id === `LAYER_EFO`) return svgGroups[i];
        }
    };
    const efoLayerGroup = getEfoLayerGroup(svgDomNode);
    function _getSvgElementById(id, visited = []) {
        if (efoLayerGroup && !visited.includes(id)) {
            for(let i = 0; i < efoLayerGroup.children.length; i++)if (efoLayerGroup.children[i].id === id) {
                const href = efoLayerGroup.children[i].attributes[`xlink:href`] || efoLayerGroup.children[i].attributes[`href`];
                if (href) return _getSvgElementById(href.value.substring(1), [
                    ...visited,
                    id
                ]);
                else return efoLayerGroup.children[i];
            }
        }
    }
    return _getSvgElementById;
};
const paintSvgElement = (element, elementMarkup2)=>element && elementMarkup2 && Object.keys(elementMarkup2).forEach((property)=>element.style.setProperty(property, String(elementMarkup2[property])));
const registerEvent = (element, eventType, elementMarkup2, callback)=>{
    if (!element) return ()=>{};
    const listener = ()=>{
        paintSvgElement(element, elementMarkup2);
        callback();
    };
    element.addEventListener(eventType, listener);
    return ()=>element.removeEventListener(eventType, listener);
};
const initialiseSvgElements = (getSvgElementById2, { idsWithMarkup, onMouseOver, onMouseOut, onClick, hovered = {
    current: null
} })=>{
    const idsByElement = /* @__PURE__ */ new Map();
    idsWithMarkup.map((e)=>e.id).filter((e, ix, self)=>self.indexOf(e) === ix).forEach((id)=>{
        const element = getSvgElementById2(id);
        if (element) idsByElement.set(element, [
            ...idsByElement.get(element) || [],
            id
        ]);
    });
    const disposers = [];
    idsByElement.forEach((ids, element)=>{
        const markupNormalAndUnderFocus = idsWithMarkup.find((m)=>ids.includes(m.id));
        const originalStyle = element.getAttribute(`style`);
        paintSvgElement(element, element === hovered.current ? markupNormalAndUnderFocus.markupUnderFocus : markupNormalAndUnderFocus.markupNormal);
        disposers.push(registerEvent(element, `mouseover`, markupNormalAndUnderFocus.markupUnderFocus, ()=>{
            hovered.current = element;
            onMouseOver(ids);
        }), registerEvent(element, `mouseout`, markupNormalAndUnderFocus.markupNormal, ()=>{
            hovered.current = null;
            onMouseOut(ids);
        }), registerEvent(element, `click`, {}, ()=>onClick(ids)), ()=>originalStyle === null ? element.removeAttribute(`style`) : element.setAttribute(`style`, originalStyle));
    });
    if (!idsByElement.has(hovered.current)) hovered.current = null;
    return ()=>disposers.forEach((dispose)=>dispose());
};
const useIsomorphicLayoutEffect = typeof window !== `undefined` ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
const AnatomogramSvg = ({ species, selectedView, idsWithMarkup, onMouseOver, onMouseOut, onClick, onInjected = ()=>{}, linkTarget = `_blank`, loadSvg })=>{
    const containerRef = (0, _react.useRef)(null);
    const latest = (0, _react.useRef)({
        onMouseOver,
        onMouseOut,
        onClick,
        onInjected,
        loadSvg
    });
    useIsomorphicLayoutEffect(()=>{
        latest.current = {
            onMouseOver,
            onMouseOut,
            onClick,
            onInjected,
            loadSvg
        };
    });
    const key = `${species}.${selectedView}`;
    const [pristine, setPristine] = (0, _react.useState)(null);
    (0, _react.useEffect)(()=>{
        let active = true;
        loadPristineSvg(species, selectedView, latest.current.loadSvg || defaultLoadSvg).then((el)=>{
            if (active) setPristine({
                key,
                el
            });
        }, (error)=>{
            if (active) {
                console.warn(`gramene-anatomogram: could not load the SVG for ${species}${selectedView ? ` (${selectedView})` : ``}: ${error}`);
                latest.current.onInjected(error);
            }
        });
        return ()=>{
            active = false;
        };
    }, [
        species,
        selectedView
    ]);
    const current = pristine && pristine.key === key ? pristine.el : null;
    const [svg, setSvg] = (0, _react.useState)(null);
    useIsomorphicLayoutEffect(()=>{
        if (!current) return void 0;
        const container = containerRef.current;
        const el = prepareSvg(current, container.ownerDocument, {
            paddingLeft: selectedView ? `10px` : ``,
            linkTarget
        });
        container.replaceChildren(el);
        setSvg(el);
        return ()=>{
            container.replaceChildren();
            setSvg(null);
        };
    }, [
        current,
        selectedView,
        linkTarget
    ]);
    const hovered = (0, _react.useRef)(null);
    useIsomorphicLayoutEffect(()=>{
        if (!svg) return void 0;
        return initialiseSvgElements(getSvgElementById(svg), {
            idsWithMarkup,
            onMouseOver: (ids)=>latest.current.onMouseOver(ids),
            onMouseOut: (ids)=>latest.current.onMouseOut(ids),
            onClick: (ids)=>latest.current.onClick(ids),
            hovered
        });
    }, [
        svg,
        idsWithMarkup
    ]);
    (0, _react.useEffect)(()=>{
        if (svg) latest.current.onInjected(null, svg);
    }, [
        svg
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        className: `gxa-anatomogram-svg`,
        style: {
            display: `inline-block`,
            verticalAlign: `top`,
            width: `90%`
        },
        ref: containerRef
    });
};
AnatomogramSvg.propTypes = {
    species: (0, _propTypesDefault.default).string.isRequired,
    selectedView: (0, _propTypesDefault.default).string,
    idsWithMarkup: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        id: (0, _propTypesDefault.default).string.isRequired,
        markupNormal: (0, _propTypesDefault.default).object.isRequired,
        markupUnderFocus: (0, _propTypesDefault.default).object.isRequired
    })).isRequired,
    onMouseOver: (0, _propTypesDefault.default).func.isRequired,
    onMouseOut: (0, _propTypesDefault.default).func.isRequired,
    onClick: (0, _propTypesDefault.default).func.isRequired,
    onInjected: (0, _propTypesDefault.default).func,
    linkTarget: (0, _propTypesDefault.default).string,
    loadSvg: (0, _propTypesDefault.default).func
};
class Anatomogram extends (0, _reactDefault.default).PureComponent {
    constructor(props){
        super(props);
        this.state = {
            selectedView: getDefaultView(props.species)
        };
        this._switchAnatomogramView = this._switchAnatomogramView.bind(this);
    }
    _switchAnatomogramView(anatomogramView) {
        this.setState({
            selectedView: anatomogramView
        });
    }
    static getDerivedStateFromProps(props, state) {
        if (props.species !== state.species) return {
            species: props.species,
            selectedView: getDefaultView(props.species)
        };
        return null;
    }
    render() {
        return supportedSpecies.includes(this.props.species) && /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
            className: `gxa-anatomogram`,
            children: [
                /* @__PURE__ */ (0, _jsxRuntime.jsx)(Switcher, {
                    species: this.props.species,
                    selectedView: this.state.selectedView,
                    onChangeView: this._switchAnatomogramView
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)(AnatomogramSvg, {
                    ...this.props,
                    selectedView: this.state.selectedView
                })
            ]
        });
    }
}
Anatomogram.propTypes = {
    species: (0, _propTypesDefault.default).string.isRequired
};
const arrayDifference = (arr1, arr2)=>Array.isArray(arr1) && Array.isArray(arr2) ? arr1.filter((e)=>!arr2.includes(e)) : arr1;
const elementMarkup = (colour, opacity)=>({
        fill: colour,
        opacity
    });
const idsWithMarkupAccordingToCurrentColoringScheme = ({ showIds, showColour, showOpacity, highlightIds, highlightColour, highlightOpacity, selectIds, selectColour, selectOpacity })=>{
    const uniqueShowIds = arrayDifference(showIds, [
        ...highlightIds,
        ...selectIds
    ]);
    const uniqueHighlightIds = arrayDifference(highlightIds, selectIds);
    return [].concat(selectIds.map((id)=>({
            id,
            markupNormal: elementMarkup(selectColour, selectOpacity),
            markupUnderFocus: elementMarkup(selectColour, selectOpacity + 0.2)
        })), uniqueHighlightIds.map((id)=>({
            id,
            markupNormal: elementMarkup(highlightColour, highlightOpacity),
            markupUnderFocus: elementMarkup(highlightColour, highlightOpacity + 0.2)
        })), uniqueShowIds.map((id)=>({
            id,
            markupNormal: elementMarkup(showColour, showOpacity),
            markupUnderFocus: elementMarkup(highlightColour, highlightOpacity + 0.2)
        })));
};
const normaliseSpecies = (species)=>typeof species === `string` ? species.toLowerCase().replace(/\s+/g, `_`) : ``;
const isSupportedSpecies = (species)=>supportedSpecies.includes(normaliseSpecies(species));
const EMPTY = Object.freeze([]);
const noop = ()=>{};
const AnatomogramContainer = ({ species, showIds = EMPTY, highlightIds = EMPTY, selectIds = EMPTY, showColour = `grey`, highlightColour = `red`, selectColour = `purple`, showOpacity = 0.4, highlightOpacity = 0.4, selectOpacity = 0.4, onMouseOver = noop, onMouseOut = noop, onClick = noop, onInjected = noop, linkTarget = `_blank`, loadSvg })=>{
    const markupKey = JSON.stringify([
        showIds,
        highlightIds,
        selectIds,
        showColour,
        highlightColour,
        selectColour,
        showOpacity,
        highlightOpacity,
        selectOpacity
    ]);
    const idsWithMarkup = (0, _react.useMemo)(()=>idsWithMarkupAccordingToCurrentColoringScheme({
            showIds,
            showColour,
            showOpacity,
            highlightIds,
            highlightColour,
            highlightOpacity,
            selectIds,
            selectColour,
            selectOpacity
        }), [
        markupKey
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Anatomogram, {
        species: normaliseSpecies(species),
        idsWithMarkup,
        onMouseOver,
        onMouseOut,
        onClick,
        onInjected,
        linkTarget,
        loadSvg
    });
};
AnatomogramContainer.displayName = `Anatomogram`;
AnatomogramContainer.propTypes = {
    species: (0, _propTypesDefault.default).string.isRequired,
    showIds: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    highlightIds: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    selectIds: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    showColour: (0, _propTypesDefault.default).string,
    highlightColour: (0, _propTypesDefault.default).string,
    selectColour: (0, _propTypesDefault.default).string,
    showOpacity: (0, _propTypesDefault.default).number,
    highlightOpacity: (0, _propTypesDefault.default).number,
    selectOpacity: (0, _propTypesDefault.default).number,
    onMouseOver: (0, _propTypesDefault.default).func,
    onMouseOut: (0, _propTypesDefault.default).func,
    onClick: (0, _propTypesDefault.default).func,
    onInjected: (0, _propTypesDefault.default).func,
    // Deprecated and ignored
    atlasUrl: (0, _propTypesDefault.default).string,
    // target for the links in the SVG (EBI licence attribution); null leaves them untouched
    linkTarget: (0, _propTypesDefault.default).string,
    // (species, view) => Promise<string>: SVG text from a trusted source instead of the bundled SVGs
    loadSvg: (0, _propTypesDefault.default).func
};
const roots = /* @__PURE__ */ new WeakMap();
const render = function(options, target) {
    const container = typeof target === `string` ? document.getElementById(target) : target;
    if (!container) throw new Error(`gramene-anatomogram: render target ${target} not found`);
    let root = roots.get(container);
    if (!root) {
        root = (0, _client.createRoot)(container);
        const unmount = root.unmount.bind(root);
        root.unmount = ()=>{
            roots.delete(container);
            unmount();
        };
        roots.set(container, root);
    }
    root.render(/* @__PURE__ */ (0, _jsxRuntime.jsx)(AnatomogramContainer, {
        ...options
    }));
    return root;
};

},{"react/jsx-runtime":"gonF6","react-dom/client":"5eZdG","react":"bmhQu","prop-types":"gLXGb","d89fe6e0a079318b":"9tRb9","bc5818463524082f":"hUovy","a007c5279ecf88e":"m85pb","95403352ede053":"iUrm8","a6df26768e161898":"KGnCJ","3c0f6b99e344d6e8":"aoTIc","289a79c7b7a78a5c":"5aIKZ","cec2ae4ee1f1eacb":"eGiws","e3483c447a9cf0fe":"9grvS","15e56c2e3ff028ed":"4JpnO","151e5f2d6fd1309d":"pGzwY","bd8513edd0a0df44":"6RjN9","668f9db299efb77d":"eYV9p","c97f98eae2a99360":"lj4qA","9bbe119ac2efa16c":"fMjoe","53009f3e2b586349":"ljjOl","89d321388a989ead":"g3us5","3e1730205efc7a8c":"euqVx","b6b0a691dd9893c":"fzr2P","69a06ab3229d3298":"4Ppeq","525f64b917fbb795":"aO5UZ","de3d1b395e1565cb":"jf07B","2f1e50e66782ac51":"hRS8a","2232ef72f8395305":"8o2Z4","fc45704f69b39fa8":"03aR9","389638331927bcdf":"7ang5","606173bfdcfc2eb4":"h8PIx","a7ea86ae8886204a":"gnDgb","5b6158095797bf22":"k3OAD","f13d29ff16fd6194":"6mIzd","8ca2f0ca8599d156":"gxjdI","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9tRb9":[function(require,module,exports,__globalThis) {
module.exports = import("4PNkb").then(()=>module.bundle.root('ijEwE'));

},{}],"hUovy":[function(require,module,exports,__globalThis) {
module.exports = import("legW7").then(()=>module.bundle.root('8Jmv8'));

},{}],"m85pb":[function(require,module,exports,__globalThis) {
module.exports = import("eUvJM").then(()=>module.bundle.root('4yaXp'));

},{}],"iUrm8":[function(require,module,exports,__globalThis) {
module.exports = import("gWI5l").then(()=>module.bundle.root('hv80L'));

},{}],"KGnCJ":[function(require,module,exports,__globalThis) {
module.exports = import("2dHzK").then(()=>module.bundle.root('8aFam'));

},{}],"aoTIc":[function(require,module,exports,__globalThis) {
module.exports = import("9PSra").then(()=>module.bundle.root('gY5qN'));

},{}],"5aIKZ":[function(require,module,exports,__globalThis) {
module.exports = import("gAGGF").then(()=>module.bundle.root('4wING'));

},{}],"eGiws":[function(require,module,exports,__globalThis) {
module.exports = import("13hsy").then(()=>module.bundle.root('kuBi1'));

},{}],"9grvS":[function(require,module,exports,__globalThis) {
module.exports = import("hxujp").then(()=>module.bundle.root('gA567'));

},{}],"4JpnO":[function(require,module,exports,__globalThis) {
module.exports = import("f6hQI").then(()=>module.bundle.root('1Fxv0'));

},{}],"pGzwY":[function(require,module,exports,__globalThis) {
module.exports = import("lvkJd").then(()=>module.bundle.root('85dPG'));

},{}],"6RjN9":[function(require,module,exports,__globalThis) {
module.exports = import("4wdWp").then(()=>module.bundle.root('a8N0F'));

},{}],"eYV9p":[function(require,module,exports,__globalThis) {
module.exports = import("gliiA").then(()=>module.bundle.root('aSjN4'));

},{}],"lj4qA":[function(require,module,exports,__globalThis) {
module.exports = import("qITUJ").then(()=>module.bundle.root('cC0pD'));

},{}],"fMjoe":[function(require,module,exports,__globalThis) {
module.exports = import("9dL01").then(()=>module.bundle.root('jQm0Y'));

},{}],"ljjOl":[function(require,module,exports,__globalThis) {
module.exports = import("cw60Z").then(()=>module.bundle.root('1hu43'));

},{}],"g3us5":[function(require,module,exports,__globalThis) {
module.exports = import("ittQ7").then(()=>module.bundle.root('1r7vU'));

},{}],"euqVx":[function(require,module,exports,__globalThis) {
module.exports = import("bbsXe").then(()=>module.bundle.root('1aUiY'));

},{}],"fzr2P":[function(require,module,exports,__globalThis) {
module.exports = import("2cvL5").then(()=>module.bundle.root('ke4iO'));

},{}],"4Ppeq":[function(require,module,exports,__globalThis) {
module.exports = import("2LeZu").then(()=>module.bundle.root('1RMnC'));

},{}],"aO5UZ":[function(require,module,exports,__globalThis) {
module.exports = import("kpWwQ").then(()=>module.bundle.root('c0Gu4'));

},{}],"jf07B":[function(require,module,exports,__globalThis) {
module.exports = import("1RVB2").then(()=>module.bundle.root('5paiP'));

},{}],"hRS8a":[function(require,module,exports,__globalThis) {
module.exports = import("hvHV9").then(()=>module.bundle.root('bR2Ve'));

},{}],"8o2Z4":[function(require,module,exports,__globalThis) {
module.exports = import("4IKi2").then(()=>module.bundle.root('2xEjv'));

},{}],"03aR9":[function(require,module,exports,__globalThis) {
module.exports = import("jkU4a").then(()=>module.bundle.root('4reYB'));

},{}],"7ang5":[function(require,module,exports,__globalThis) {
module.exports = import("1G3ix").then(()=>module.bundle.root('dqxW2'));

},{}],"h8PIx":[function(require,module,exports,__globalThis) {
module.exports = import("f3N2V").then(()=>module.bundle.root('aCuQV'));

},{}],"gnDgb":[function(require,module,exports,__globalThis) {
module.exports = import("aXJOP").then(()=>module.bundle.root('1h4cN'));

},{}],"k3OAD":[function(require,module,exports,__globalThis) {
module.exports = import("ltwIB").then(()=>module.bundle.root('6jVMb'));

},{}],"6mIzd":[function(require,module,exports,__globalThis) {
module.exports = import("fiv7W").then(()=>module.bundle.root('1NlH5'));

},{}],"gxjdI":[function(require,module,exports,__globalThis) {
module.exports = import("fd8JE").then(()=>module.bundle.root('9TGFl'));

},{}],"7VCTY":[function(require,module,exports,__globalThis) {
!function(t, e) {
    module.exports = e(require("c68f15e3563eab3b"));
}("undefined" != typeof self ? self : this, function(t) {
    return function(t) {
        function e(n) {
            if (r[n]) return r[n].exports;
            var o = r[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return t[n].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
        }
        var r = {};
        return e.m = t, e.c = r, e.d = function(t, r, n) {
            e.o(t, r) || Object.defineProperty(t, r, {
                configurable: !1,
                enumerable: !0,
                get: n
            });
        }, e.n = function(t) {
            var r = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return e.d(r, "a", r), r;
        }, e.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }, e.p = "", e(e.s = 0);
    }([
        function(t, e, r) {
            "use strict";
            function n() {
                return n = Object.assign ? Object.assign.bind() : function(t) {
                    for(var e = 1; e < arguments.length; e++){
                        var r = arguments[e];
                        for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
                    }
                    return t;
                }, n.apply(this, arguments);
            }
            function o(t) {
                return a(t) || i(t) || u(t) || c();
            }
            function c() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function u(t, e) {
                if (t) {
                    if ("string" == typeof t) return f(t, e);
                    var r = Object.prototype.toString.call(t).slice(8, -1);
                    return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? f(t, e) : void 0;
                }
            }
            function i(t) {
                if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
            }
            function a(t) {
                if (Array.isArray(t)) return f(t);
            }
            function f(t, e) {
                (null == e || e > t.length) && (e = t.length);
                for(var r = 0, n = new Array(e); r < e; r++)n[r] = t[r];
                return n;
            }
            function s(t) {
                "@babel/helpers - typeof";
                return (s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                    return typeof t;
                } : function(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), r.d(e, "HighchartsReact", function() {
                return d;
            });
            var p = r(1), l = r.n(p), y = "undefined" != typeof window ? p.useLayoutEffect : p.useEffect, d = Object(p.memo)(Object(p.forwardRef)(function(t, e) {
                var r = Object(p.useRef)(), c = Object(p.useRef)(), u = Object(p.useRef)(t.constructorType), i = Object(p.useRef)(t.highcharts);
                return y(function() {
                    function e() {
                        var e = t.highcharts || "object" === ("undefined" == typeof window ? "undefined" : s(window)) && window.Highcharts, n = t.constructorType || "chart";
                        e ? e[n] ? t.options ? c.current = e[n](r.current, t.options, t.callback) : console.warn('The "options" property was not passed.') : console.warn('The "constructorType" property is incorrect or some required module is not imported.') : console.warn('The "highcharts" property was not passed.');
                    }
                    if (c.current) {
                        if (!1 !== t.allowChartUpdate) {
                            if (t.constructorType !== u.current || t.highcharts !== i.current) u.current = t.constructorType, i.current = t.highcharts, e();
                            else if (!t.immutable && c.current) {
                                var n;
                                (n = c.current).update.apply(n, [
                                    t.options
                                ].concat(o(t.updateArgs || [
                                    !0,
                                    !0
                                ])));
                            } else e();
                        }
                    } else e();
                }, [
                    t.options,
                    t.allowChartUpdate,
                    t.updateArgs,
                    t.containerProps,
                    t.highcharts,
                    t.constructorType
                ]), y(function() {
                    return function() {
                        c.current && (c.current.destroy(), c.current = null);
                    };
                }, []), Object(p.useImperativeHandle)(e, function() {
                    return {
                        get chart () {
                            return c.current;
                        },
                        container: r
                    };
                }, []), l.a.createElement("div", n({}, t.containerProps, {
                    ref: r
                }));
            }));
            e.default = d;
        },
        function(e, r) {
            e.exports = t;
        }
    ]);
});

},{"c68f15e3563eab3b":"bmhQu"}],"kyYpV":[function(require,module,exports,__globalThis) {
/*
 Highcharts JS v6.2.0 (2018-10-17)

 (c) 2009-2016 Torstein Honsi

 License: www.highcharts.com/license
*/ (function(S, K) {
    module.exports ? module.exports = S.document ? K(S) : K : "function" === typeof define && define.amd ? define(function() {
        return K(S);
    }) : S.Highcharts = K(S);
})("undefined" !== typeof window ? window : this, function(S) {
    var K = function() {
        var a = "undefined" === typeof S ? window : S, C = a.document, F = a.navigator && a.navigator.userAgent || "", I = C && C.createElementNS && !!C.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect, n = /(edge|msie|trident)/i.test(F) && !a.opera, f = -1 !== F.indexOf("Firefox"), e = -1 !== F.indexOf("Chrome"), u = f && 4 > parseInt(F.split("Firefox/")[1], 10);
        return a.Highcharts ? a.Highcharts.error(16, !0) : {
            product: "Highcharts",
            version: "6.2.0",
            deg2rad: 2 * Math.PI / 360,
            doc: C,
            hasBidiBug: u,
            hasTouch: C && void 0 !== C.documentElement.ontouchstart,
            isMS: n,
            isWebKit: -1 !== F.indexOf("AppleWebKit"),
            isFirefox: f,
            isChrome: e,
            isSafari: !e && -1 !== F.indexOf("Safari"),
            isTouchDevice: /(Mobile|Android|Windows Phone)/.test(F),
            SVG_NS: "http://www.w3.org/2000/svg",
            chartCount: 0,
            seriesTypes: {},
            symbolSizes: {},
            svg: I,
            win: a,
            marginNames: [
                "plotTop",
                "marginRight",
                "marginBottom",
                "plotLeft"
            ],
            noop: function() {},
            charts: []
        };
    }();
    (function(a) {
        a.timers = [];
        var C = a.charts, F = a.doc, I = a.win;
        a.error = function(n, f) {
            n = a.isNumber(n) ? "Highcharts error #" + n + ": www.highcharts.com/errors/" + n : n;
            if (f) throw Error(n);
            I.console && console.log(n);
        };
        a.Fx = function(a, f, e) {
            this.options = f;
            this.elem = a;
            this.prop = e;
        };
        a.Fx.prototype = {
            dSetter: function() {
                var a = this.paths[0], f = this.paths[1], e = [], u = this.now, x = a.length, t;
                if (1 === u) e = this.toD;
                else if (x === f.length && 1 > u) for(; x--;)t = parseFloat(a[x]), e[x] = isNaN(t) ? f[x] : u * parseFloat(f[x] - t) + t;
                else e = f;
                this.elem.attr("d", e, null, !0);
            },
            update: function() {
                var a = this.elem, f = this.prop, e = this.now, u = this.options.step;
                if (this[f + "Setter"]) this[f + "Setter"]();
                else a.attr ? a.element && a.attr(f, e, null, !0) : a.style[f] = e + this.unit;
                u && u.call(a, e, this);
            },
            run: function(n, f, e) {
                var u = this, x = u.options, t = function(a) {
                    return t.stopped ? !1 : u.step(a);
                }, w = I.requestAnimationFrame || function(a) {
                    setTimeout(a, 13);
                }, y = function() {
                    for(var c = 0; c < a.timers.length; c++)a.timers[c]() || a.timers.splice(c--, 1);
                    a.timers.length && w(y);
                };
                n !== f || this.elem["forceAnimate:" + this.prop] ? (this.startTime = +new Date, this.start = n, this.end = f, this.unit = e, this.now = this.start, this.pos = 0, t.elem = this.elem, t.prop = this.prop, t() && 1 === a.timers.push(t) && w(y)) : (delete x.curAnim[this.prop], x.complete && 0 === a.keys(x.curAnim).length && x.complete.call(this.elem));
            },
            step: function(n) {
                var f = +new Date, e, u = this.options, x = this.elem, t = u.complete, w = u.duration, y = u.curAnim;
                x.attr && !x.element ? n = !1 : n || f >= w + this.startTime ? (this.now = this.end, this.pos = 1, this.update(), e = y[this.prop] = !0, a.objectEach(y, function(a) {
                    !0 !== a && (e = !1);
                }), e && t && t.call(x), n = !1) : (this.pos = u.easing((f - this.startTime) / w), this.now = this.start + (this.end - this.start) * this.pos, this.update(), n = !0);
                return n;
            },
            initPath: function(n, f, e) {
                function u(a) {
                    var b, k;
                    for(d = a.length; d--;)b = "M" === a[d] || "L" === a[d], k = /[a-zA-Z]/.test(a[d + 3]), b && k && a.splice(d + 1, 0, a[d + 1], a[d + 2], a[d + 1], a[d + 2]);
                }
                function x(a, h) {
                    for(; a.length < k;){
                        a[0] = h[k - a.length];
                        var c = a.slice(0, p);
                        [].splice.apply(a, [
                            0,
                            0
                        ].concat(c));
                        b && (c = a.slice(a.length - p), [].splice.apply(a, [
                            a.length,
                            0
                        ].concat(c)), d--);
                    }
                    a[0] = "M";
                }
                function t(a, d) {
                    for(var c = (k - a.length) / p; 0 < c && c--;)q = a.slice().splice(a.length / v - p, p * v), q[0] = d[k - p - c * p], h && (q[p - 6] = q[p - 2], q[p - 5] = q[p - 1]), [].splice.apply(a, [
                        a.length / v,
                        0
                    ].concat(q)), b && c--;
                }
                f = f || "";
                var w, y = n.startX, c = n.endX, h = -1 < f.indexOf("C"), p = h ? 7 : 3, k, q, d;
                f = f.split(" ");
                e = e.slice();
                var b = n.isArea, v = b ? 2 : 1, J;
                h && (u(f), u(e));
                if (y && c) {
                    for(d = 0; d < y.length; d++)if (y[d] === c[0]) {
                        w = d;
                        break;
                    } else if (y[0] === c[c.length - y.length + d]) {
                        w = d;
                        J = !0;
                        break;
                    }
                    void 0 === w && (f = []);
                }
                f.length && a.isNumber(w) && (k = e.length + w * v * p, J ? (x(f, e), t(e, f)) : (x(e, f), t(f, e)));
                return [
                    f,
                    e
                ];
            },
            fillSetter: function() {
                a.Fx.prototype.strokeSetter.apply(this, arguments);
            },
            strokeSetter: function() {
                this.elem.attr(this.prop, a.color(this.start).tweenTo(a.color(this.end), this.pos), null, !0);
            }
        };
        a.merge = function() {
            var n, f = arguments, e, u = {}, x = function(e, n) {
                "object" !== typeof e && (e = {});
                a.objectEach(n, function(y, c) {
                    !a.isObject(y, !0) || a.isClass(y) || a.isDOMElement(y) ? e[c] = n[c] : e[c] = x(e[c] || {}, y);
                });
                return e;
            };
            !0 === f[0] && (u = f[1], f = Array.prototype.slice.call(f, 2));
            e = f.length;
            for(n = 0; n < e; n++)u = x(u, f[n]);
            return u;
        };
        a.pInt = function(a, f) {
            return parseInt(a, f || 10);
        };
        a.isString = function(a) {
            return "string" === typeof a;
        };
        a.isArray = function(a) {
            a = Object.prototype.toString.call(a);
            return "[object Array]" === a || "[object Array Iterator]" === a;
        };
        a.isObject = function(n, f) {
            return !!n && "object" === typeof n && (!f || !a.isArray(n));
        };
        a.isDOMElement = function(n) {
            return a.isObject(n) && "number" === typeof n.nodeType;
        };
        a.isClass = function(n) {
            var f = n && n.constructor;
            return !(!a.isObject(n, !0) || a.isDOMElement(n) || !f || !f.name || "Object" === f.name);
        };
        a.isNumber = function(a) {
            return "number" === typeof a && !isNaN(a) && Infinity > a && -Infinity < a;
        };
        a.erase = function(a, f) {
            for(var e = a.length; e--;)if (a[e] === f) {
                a.splice(e, 1);
                break;
            }
        };
        a.defined = function(a) {
            return void 0 !== a && null !== a;
        };
        a.attr = function(n, f, e) {
            var u;
            a.isString(f) ? a.defined(e) ? n.setAttribute(f, e) : n && n.getAttribute && ((u = n.getAttribute(f)) || "class" !== f || (u = n.getAttribute(f + "Name"))) : a.defined(f) && a.isObject(f) && a.objectEach(f, function(a, e) {
                n.setAttribute(e, a);
            });
            return u;
        };
        a.splat = function(n) {
            return a.isArray(n) ? n : [
                n
            ];
        };
        a.syncTimeout = function(a, f, e) {
            if (f) return setTimeout(a, f, e);
            a.call(0, e);
        };
        a.clearTimeout = function(n) {
            a.defined(n) && clearTimeout(n);
        };
        a.extend = function(a, f) {
            var e;
            a || (a = {});
            for(e in f)a[e] = f[e];
            return a;
        };
        a.pick = function() {
            var a = arguments, f, e, u = a.length;
            for(f = 0; f < u; f++)if (e = a[f], void 0 !== e && null !== e) return e;
        };
        a.css = function(n, f) {
            a.isMS && !a.svg && f && void 0 !== f.opacity && (f.filter = "alpha(opacity\x3d" + 100 * f.opacity + ")");
            a.extend(n.style, f);
        };
        a.createElement = function(n, f, e, u, x) {
            n = F.createElement(n);
            var t = a.css;
            f && a.extend(n, f);
            x && t(n, {
                padding: 0,
                border: "none",
                margin: 0
            });
            e && t(n, e);
            u && u.appendChild(n);
            return n;
        };
        a.extendClass = function(n, f) {
            var e = function() {};
            e.prototype = new n;
            a.extend(e.prototype, f);
            return e;
        };
        a.pad = function(a, f, e) {
            return Array((f || 2) + 1 - String(a).replace("-", "").length).join(e || 0) + a;
        };
        a.relativeLength = function(a, f, e) {
            return /%$/.test(a) ? f * parseFloat(a) / 100 + (e || 0) : parseFloat(a);
        };
        a.wrap = function(a, f, e) {
            var n = a[f];
            a[f] = function() {
                var a = Array.prototype.slice.call(arguments), t = arguments, w = this;
                w.proceed = function() {
                    n.apply(w, arguments.length ? arguments : t);
                };
                a.unshift(n);
                a = e.apply(this, a);
                w.proceed = null;
                return a;
            };
        };
        a.datePropsToTimestamps = function(n) {
            a.objectEach(n, function(f, e) {
                a.isObject(f) && "function" === typeof f.getTime ? n[e] = f.getTime() : (a.isObject(f) || a.isArray(f)) && a.datePropsToTimestamps(f);
            });
        };
        a.formatSingle = function(n, f, e) {
            var u = /\.([0-9])/, x = a.defaultOptions.lang;
            /f$/.test(n) ? (e = (e = n.match(u)) ? e[1] : -1, null !== f && (f = a.numberFormat(f, e, x.decimalPoint, -1 < n.indexOf(",") ? x.thousandsSep : ""))) : f = (e || a.time).dateFormat(n, f);
            return f;
        };
        a.format = function(n, f, e) {
            for(var u = "{", x = !1, t, w, y, c, h = [], p; n;){
                u = n.indexOf(u);
                if (-1 === u) break;
                t = n.slice(0, u);
                if (x) {
                    t = t.split(":");
                    w = t.shift().split(".");
                    c = w.length;
                    p = f;
                    for(y = 0; y < c; y++)p && (p = p[w[y]]);
                    t.length && (p = a.formatSingle(t.join(":"), p, e));
                    h.push(p);
                } else h.push(t);
                n = n.slice(u + 1);
                u = (x = !x) ? "}" : "{";
            }
            h.push(n);
            return h.join("");
        };
        a.getMagnitude = function(a) {
            return Math.pow(10, Math.floor(Math.log(a) / Math.LN10));
        };
        a.normalizeTickInterval = function(n, f, e, u, x) {
            var t, w = n;
            e = a.pick(e, 1);
            t = n / e;
            f || (f = x ? [
                1,
                1.2,
                1.5,
                2,
                2.5,
                3,
                4,
                5,
                6,
                8,
                10
            ] : [
                1,
                2,
                2.5,
                5,
                10
            ], !1 === u && (1 === e ? f = a.grep(f, function(a) {
                return 0 === a % 1;
            }) : .1 >= e && (f = [
                1 / e
            ])));
            for(u = 0; u < f.length && !(w = f[u], x && w * e >= n || !x && t <= (f[u] + (f[u + 1] || f[u])) / 2); u++);
            return w = a.correctFloat(w * e, -Math.round(Math.log(.001) / Math.LN10));
        };
        a.stableSort = function(a, f) {
            var e = a.length, n, x;
            for(x = 0; x < e; x++)a[x].safeI = x;
            a.sort(function(a, e) {
                n = f(a, e);
                return 0 === n ? a.safeI - e.safeI : n;
            });
            for(x = 0; x < e; x++)delete a[x].safeI;
        };
        a.arrayMin = function(a) {
            for(var f = a.length, e = a[0]; f--;)a[f] < e && (e = a[f]);
            return e;
        };
        a.arrayMax = function(a) {
            for(var f = a.length, e = a[0]; f--;)a[f] > e && (e = a[f]);
            return e;
        };
        a.destroyObjectProperties = function(n, f) {
            a.objectEach(n, function(a, u) {
                a && a !== f && a.destroy && a.destroy();
                delete n[u];
            });
        };
        a.discardElement = function(n) {
            var f = a.garbageBin;
            f || (f = a.createElement("div"));
            n && f.appendChild(n);
            f.innerHTML = "";
        };
        a.correctFloat = function(a, f) {
            return parseFloat(a.toPrecision(f || 14));
        };
        a.setAnimation = function(n, f) {
            f.renderer.globalAnimation = a.pick(n, f.options.chart.animation, !0);
        };
        a.animObject = function(n) {
            return a.isObject(n) ? a.merge(n) : {
                duration: n ? 500 : 0
            };
        };
        a.timeUnits = {
            millisecond: 1,
            second: 1E3,
            minute: 6E4,
            hour: 36E5,
            day: 864E5,
            week: 6048E5,
            month: 24192E5,
            year: 314496E5
        };
        a.numberFormat = function(n, f, e, u) {
            n = +n || 0;
            f = +f;
            var x = a.defaultOptions.lang, t = (n.toString().split(".")[1] || "").split("e")[0].length, w, y, c = n.toString().split("e");
            -1 === f ? f = Math.min(t, 20) : a.isNumber(f) ? f && c[1] && 0 > c[1] && (w = f + +c[1], 0 <= w ? (c[0] = (+c[0]).toExponential(w).split("e")[0], f = w) : (c[0] = c[0].split(".")[0] || 0, n = 20 > f ? (c[0] * Math.pow(10, c[1])).toFixed(f) : 0, c[1] = 0)) : f = 2;
            y = (Math.abs(c[1] ? c[0] : n) + Math.pow(10, -Math.max(f, t) - 1)).toFixed(f);
            t = String(a.pInt(y));
            w = 3 < t.length ? t.length % 3 : 0;
            e = a.pick(e, x.decimalPoint);
            u = a.pick(u, x.thousandsSep);
            n = (0 > n ? "-" : "") + (w ? t.substr(0, w) + u : "");
            n += t.substr(w).replace(/(\d{3})(?=\d)/g, "$1" + u);
            f && (n += e + y.slice(-f));
            c[1] && 0 !== +n && (n += "e" + c[1]);
            return n;
        };
        Math.easeInOutSine = function(a) {
            return -0.5 * (Math.cos(Math.PI * a) - 1);
        };
        a.getStyle = function(n, f, e) {
            if ("width" === f) return Math.max(0, Math.min(n.offsetWidth, n.scrollWidth) - a.getStyle(n, "padding-left") - a.getStyle(n, "padding-right"));
            if ("height" === f) return Math.max(0, Math.min(n.offsetHeight, n.scrollHeight) - a.getStyle(n, "padding-top") - a.getStyle(n, "padding-bottom"));
            I.getComputedStyle || a.error(27, !0);
            if (n = I.getComputedStyle(n, void 0)) n = n.getPropertyValue(f), a.pick(e, "opacity" !== f) && (n = a.pInt(n));
            return n;
        };
        a.inArray = function(n, f, e) {
            return (a.indexOfPolyfill || Array.prototype.indexOf).call(f, n, e);
        };
        a.grep = function(n, f) {
            return (a.filterPolyfill || Array.prototype.filter).call(n, f);
        };
        a.find = Array.prototype.find ? function(a, f) {
            return a.find(f);
        } : function(a, f) {
            var e, u = a.length;
            for(e = 0; e < u; e++)if (f(a[e], e)) return a[e];
        };
        a.some = function(n, f, e) {
            return (a.somePolyfill || Array.prototype.some).call(n, f, e);
        };
        a.map = function(a, f) {
            for(var e = [], u = 0, x = a.length; u < x; u++)e[u] = f.call(a[u], a[u], u, a);
            return e;
        };
        a.keys = function(n) {
            return (a.keysPolyfill || Object.keys).call(void 0, n);
        };
        a.reduce = function(n, f, e) {
            return (a.reducePolyfill || Array.prototype.reduce).apply(n, 2 < arguments.length ? [
                f,
                e
            ] : [
                f
            ]);
        };
        a.offset = function(a) {
            var f = F.documentElement;
            a = a.parentElement || a.parentNode ? a.getBoundingClientRect() : {
                top: 0,
                left: 0
            };
            return {
                top: a.top + (I.pageYOffset || f.scrollTop) - (f.clientTop || 0),
                left: a.left + (I.pageXOffset || f.scrollLeft) - (f.clientLeft || 0)
            };
        };
        a.stop = function(n, f) {
            for(var e = a.timers.length; e--;)a.timers[e].elem !== n || f && f !== a.timers[e].prop || (a.timers[e].stopped = !0);
        };
        a.each = function(n, f, e) {
            return (a.forEachPolyfill || Array.prototype.forEach).call(n, f, e);
        };
        a.objectEach = function(a, f, e) {
            for(var u in a)a.hasOwnProperty(u) && f.call(e || a[u], a[u], u, a);
        };
        a.addEvent = function(n, f, e, u) {
            var x, t = n.addEventListener || a.addEventListenerPolyfill;
            x = "function" === typeof n && n.prototype ? n.prototype.protoEvents = n.prototype.protoEvents || {} : n.hcEvents = n.hcEvents || {};
            a.Point && n instanceof a.Point && n.series && n.series.chart && (n.series.chart.runTrackerClick = !0);
            t && t.call(n, f, e, !1);
            x[f] || (x[f] = []);
            x[f].push(e);
            u && a.isNumber(u.order) && (e.order = u.order, x[f].sort(function(a, e) {
                return a.order - e.order;
            }));
            return function() {
                a.removeEvent(n, f, e);
            };
        };
        a.removeEvent = function(n, f, e) {
            function u(e, c) {
                var h = n.removeEventListener || a.removeEventListenerPolyfill;
                h && h.call(n, e, c, !1);
            }
            function x(e) {
                var c, h;
                n.nodeName && (f ? (c = {}, c[f] = !0) : c = e, a.objectEach(c, function(a, k) {
                    if (e[k]) for(h = e[k].length; h--;)u(k, e[k][h]);
                }));
            }
            var t, w;
            a.each([
                "protoEvents",
                "hcEvents"
            ], function(y) {
                var c = n[y];
                c && (f ? (t = c[f] || [], e ? (w = a.inArray(e, t), -1 < w && (t.splice(w, 1), c[f] = t), u(f, e)) : (x(c), c[f] = [])) : (x(c), n[y] = {}));
            });
        };
        a.fireEvent = function(n, f, e, u) {
            var x, t, w, y, c;
            e = e || {};
            F.createEvent && (n.dispatchEvent || n.fireEvent) ? (x = F.createEvent("Events"), x.initEvent(f, !0, !0), a.extend(x, e), n.dispatchEvent ? n.dispatchEvent(x) : n.fireEvent(f, x)) : a.each([
                "protoEvents",
                "hcEvents"
            ], function(h) {
                if (n[h]) for(t = n[h][f] || [], w = t.length, e.target || a.extend(e, {
                    preventDefault: function() {
                        e.defaultPrevented = !0;
                    },
                    target: n,
                    type: f
                }), y = 0; y < w; y++)(c = t[y]) && !1 === c.call(n, e) && e.preventDefault();
            });
            u && !e.defaultPrevented && u.call(n, e);
        };
        a.animate = function(n, f, e) {
            var u, x = "", t, w, y;
            a.isObject(e) || (y = arguments, e = {
                duration: y[2],
                easing: y[3],
                complete: y[4]
            });
            a.isNumber(e.duration) || (e.duration = 400);
            e.easing = "function" === typeof e.easing ? e.easing : Math[e.easing] || Math.easeInOutSine;
            e.curAnim = a.merge(f);
            a.objectEach(f, function(c, h) {
                a.stop(n, h);
                w = new a.Fx(n, e, h);
                t = null;
                "d" === h ? (w.paths = w.initPath(n, n.d, f.d), w.toD = f.d, u = 0, t = 1) : n.attr ? u = n.attr(h) : (u = parseFloat(a.getStyle(n, h)) || 0, "opacity" !== h && (x = "px"));
                t || (t = c);
                t && t.match && t.match("px") && (t = t.replace(/px/g, ""));
                w.run(u, t, x);
            });
        };
        a.seriesType = function(n, f, e, u, x) {
            var t = a.getOptions(), w = a.seriesTypes;
            t.plotOptions[n] = a.merge(t.plotOptions[f], e);
            w[n] = a.extendClass(w[f] || function() {}, u);
            w[n].prototype.type = n;
            x && (w[n].prototype.pointClass = a.extendClass(a.Point, x));
            return w[n];
        };
        a.uniqueKey = function() {
            var a = Math.random().toString(36).substring(2, 9), f = 0;
            return function() {
                return "highcharts-" + a + "-" + f++;
            };
        }();
        I.jQuery && (I.jQuery.fn.highcharts = function() {
            var n = [].slice.call(arguments);
            if (this[0]) return n[0] ? (new a[a.isString(n[0]) ? n.shift() : "Chart"](this[0], n[0], n[1]), this) : C[a.attr(this[0], "data-highcharts-chart")];
        });
    })(K);
    (function(a) {
        var C = a.each, F = a.isNumber, I = a.map, n = a.merge, f = a.pInt;
        a.Color = function(e) {
            if (!(this instanceof a.Color)) return new a.Color(e);
            this.init(e);
        };
        a.Color.prototype = {
            parsers: [
                {
                    regex: /rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,
                    parse: function(a) {
                        return [
                            f(a[1]),
                            f(a[2]),
                            f(a[3]),
                            parseFloat(a[4], 10)
                        ];
                    }
                },
                {
                    regex: /rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,
                    parse: function(a) {
                        return [
                            f(a[1]),
                            f(a[2]),
                            f(a[3]),
                            1
                        ];
                    }
                }
            ],
            names: {
                white: "#ffffff",
                black: "#000000"
            },
            init: function(e) {
                var f, x, t, w;
                if ((this.input = e = this.names[e && e.toLowerCase ? e.toLowerCase() : ""] || e) && e.stops) this.stops = I(e.stops, function(e) {
                    return new a.Color(e[1]);
                });
                else if (e && e.charAt && "#" === e.charAt() && (f = e.length, e = parseInt(e.substr(1), 16), 7 === f ? x = [
                    (e & 16711680) >> 16,
                    (e & 65280) >> 8,
                    e & 255,
                    1
                ] : 4 === f && (x = [
                    (e & 3840) >> 4 | (e & 3840) >> 8,
                    (e & 240) >> 4 | e & 240,
                    (e & 15) << 4 | e & 15,
                    1
                ])), !x) for(t = this.parsers.length; t-- && !x;)w = this.parsers[t], (f = w.regex.exec(e)) && (x = w.parse(f));
                this.rgba = x || [];
            },
            get: function(a) {
                var e = this.input, f = this.rgba, t;
                this.stops ? (t = n(e), t.stops = [].concat(t.stops), C(this.stops, function(e, y) {
                    t.stops[y] = [
                        t.stops[y][0],
                        e.get(a)
                    ];
                })) : t = f && F(f[0]) ? "rgb" === a || !a && 1 === f[3] ? "rgb(" + f[0] + "," + f[1] + "," + f[2] + ")" : "a" === a ? f[3] : "rgba(" + f.join(",") + ")" : e;
                return t;
            },
            brighten: function(a) {
                var e, x = this.rgba;
                if (this.stops) C(this.stops, function(e) {
                    e.brighten(a);
                });
                else if (F(a) && 0 !== a) for(e = 0; 3 > e; e++)x[e] += f(255 * a), 0 > x[e] && (x[e] = 0), 255 < x[e] && (x[e] = 255);
                return this;
            },
            setOpacity: function(a) {
                this.rgba[3] = a;
                return this;
            },
            tweenTo: function(a, f) {
                var e = this.rgba, t = a.rgba;
                t.length && e && e.length ? (a = 1 !== t[3] || 1 !== e[3], f = (a ? "rgba(" : "rgb(") + Math.round(t[0] + (e[0] - t[0]) * (1 - f)) + "," + Math.round(t[1] + (e[1] - t[1]) * (1 - f)) + "," + Math.round(t[2] + (e[2] - t[2]) * (1 - f)) + (a ? "," + (t[3] + (e[3] - t[3]) * (1 - f)) : "") + ")") : f = a.input || "none";
                return f;
            }
        };
        a.color = function(e) {
            return new a.Color(e);
        };
    })(K);
    (function(a) {
        var C, F, I = a.addEvent, n = a.animate, f = a.attr, e = a.charts, u = a.color, x = a.css, t = a.createElement, w = a.defined, y = a.deg2rad, c = a.destroyObjectProperties, h = a.doc, p = a.each, k = a.extend, q = a.erase, d = a.grep, b = a.hasTouch, v = a.inArray, J = a.isArray, l = a.isFirefox, L = a.isMS, B = a.isObject, D = a.isString, m = a.isWebKit, G = a.merge, A = a.noop, N = a.objectEach, E = a.pick, g = a.pInt, r = a.removeEvent, M = a.stop, O = a.svg, H = a.SVG_NS, R = a.symbolSizes, Q = a.win;
        C = a.SVGElement = function() {
            return this;
        };
        k(C.prototype, {
            opacity: 1,
            SVG_NS: H,
            textProps: "direction fontSize fontWeight fontFamily fontStyle color lineHeight width textAlign textDecoration textOverflow textOutline cursor".split(" "),
            init: function(a, g) {
                this.element = "span" === g ? t(g) : h.createElementNS(this.SVG_NS, g);
                this.renderer = a;
            },
            animate: function(z, g, r) {
                g = a.animObject(E(g, this.renderer.globalAnimation, !0));
                0 !== g.duration ? (r && (g.complete = r), n(this, z, g)) : (this.attr(z, null, r), g.step && g.step.call(this));
                return this;
            },
            complexColor: function(z, g, r) {
                var b = this.renderer, k, m, d, H, c, h, q, A, v, P, l, O = [], M;
                a.fireEvent(this.renderer, "complexColor", {
                    args: arguments
                }, function() {
                    z.radialGradient ? m = "radialGradient" : z.linearGradient && (m = "linearGradient");
                    m && (d = z[m], c = b.gradients, q = z.stops, P = r.radialReference, J(d) && (z[m] = d = {
                        x1: d[0],
                        y1: d[1],
                        x2: d[2],
                        y2: d[3],
                        gradientUnits: "userSpaceOnUse"
                    }), "radialGradient" === m && P && !w(d.gradientUnits) && (H = d, d = G(d, b.getRadialAttr(P, H), {
                        gradientUnits: "userSpaceOnUse"
                    })), N(d, function(a, z) {
                        "id" !== z && O.push(z, a);
                    }), N(q, function(a) {
                        O.push(a);
                    }), O = O.join(","), c[O] ? l = c[O].attr("id") : (d.id = l = a.uniqueKey(), c[O] = h = b.createElement(m).attr(d).add(b.defs), h.radAttr = H, h.stops = [], p(q, function(z) {
                        0 === z[1].indexOf("rgba") ? (k = a.color(z[1]), A = k.get("rgb"), v = k.get("a")) : (A = z[1], v = 1);
                        z = b.createElement("stop").attr({
                            offset: z[0],
                            "stop-color": A,
                            "stop-opacity": v
                        }).add(h);
                        h.stops.push(z);
                    })), M = "url(" + b.url + "#" + l + ")", r.setAttribute(g, M), r.gradient = O, z.toString = function() {
                        return M;
                    });
                });
            },
            applyTextOutline: function(z) {
                var g = this.element, r, b, d, m, k;
                -1 !== z.indexOf("contrast") && (z = z.replace(/contrast/g, this.renderer.getContrast(g.style.fill)));
                z = z.split(" ");
                b = z[z.length - 1];
                if ((d = z[0]) && "none" !== d && a.svg) {
                    this.fakeTS = !0;
                    z = [].slice.call(g.getElementsByTagName("tspan"));
                    this.ySetter = this.xSetter;
                    d = d.replace(/(^[\d\.]+)(.*?)$/g, function(a, z, g) {
                        return 2 * z + g;
                    });
                    for(k = z.length; k--;)r = z[k], "highcharts-text-outline" === r.getAttribute("class") && q(z, g.removeChild(r));
                    m = g.firstChild;
                    p(z, function(a, z) {
                        0 === z && (a.setAttribute("x", g.getAttribute("x")), z = g.getAttribute("y"), a.setAttribute("y", z || 0), null === z && g.setAttribute("y", 0));
                        a = a.cloneNode(1);
                        f(a, {
                            "class": "highcharts-text-outline",
                            fill: b,
                            stroke: b,
                            "stroke-width": d,
                            "stroke-linejoin": "round"
                        });
                        g.insertBefore(a, m);
                    });
                }
            },
            attr: function(a, g, r, b) {
                var z, d = this.element, m, k = this, c, H;
                "string" === typeof a && void 0 !== g && (z = a, a = {}, a[z] = g);
                "string" === typeof a ? k = (this[a + "Getter"] || this._defaultGetter).call(this, a, d) : (N(a, function(z, g) {
                    c = !1;
                    b || M(this, g);
                    this.symbolName && /^(x|y|width|height|r|start|end|innerR|anchorX|anchorY)$/.test(g) && (m || (this.symbolAttr(a), m = !0), c = !0);
                    !this.rotation || "x" !== g && "y" !== g || (this.doTransform = !0);
                    c || (H = this[g + "Setter"] || this._defaultSetter, H.call(this, z, g, d), this.shadows && /^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(g) && this.updateShadows(g, z, H));
                }, this), this.afterSetters());
                r && r.call(this);
                return k;
            },
            afterSetters: function() {
                this.doTransform && (this.updateTransform(), this.doTransform = !1);
            },
            updateShadows: function(a, g, r) {
                for(var z = this.shadows, d = z.length; d--;)r.call(z[d], "height" === a ? Math.max(g - (z[d].cutHeight || 0), 0) : "d" === a ? this.d : g, a, z[d]);
            },
            addClass: function(a, g) {
                var z = this.attr("class") || "";
                -1 === z.indexOf(a) && (g || (a = (z + (z ? " " : "") + a).replace("  ", " ")), this.attr("class", a));
                return this;
            },
            hasClass: function(a) {
                return -1 !== v(a, (this.attr("class") || "").split(" "));
            },
            removeClass: function(a) {
                return this.attr("class", (this.attr("class") || "").replace(a, ""));
            },
            symbolAttr: function(a) {
                var z = this;
                p("x y r start end width height innerR anchorX anchorY".split(" "), function(g) {
                    z[g] = E(a[g], z[g]);
                });
                z.attr({
                    d: z.renderer.symbols[z.symbolName](z.x, z.y, z.width, z.height, z)
                });
            },
            clip: function(a) {
                return this.attr("clip-path", a ? "url(" + this.renderer.url + "#" + a.id + ")" : "none");
            },
            crisp: function(a, g) {
                var z;
                g = g || a.strokeWidth || 0;
                z = Math.round(g) % 2 / 2;
                a.x = Math.floor(a.x || this.x || 0) + z;
                a.y = Math.floor(a.y || this.y || 0) + z;
                a.width = Math.floor((a.width || this.width || 0) - 2 * z);
                a.height = Math.floor((a.height || this.height || 0) - 2 * z);
                w(a.strokeWidth) && (a.strokeWidth = g);
                return a;
            },
            css: function(a) {
                var z = this.styles, r = {}, d = this.element, b, m = "", c, H = !z, h = [
                    "textOutline",
                    "textOverflow",
                    "width"
                ];
                a && a.color && (a.fill = a.color);
                z && N(a, function(a, g) {
                    a !== z[g] && (r[g] = a, H = !0);
                });
                H && (z && (a = k(z, r)), a && (null === a.width || "auto" === a.width ? delete this.textWidth : "text" === d.nodeName.toLowerCase() && a.width && (b = this.textWidth = g(a.width))), this.styles = a, b && !O && this.renderer.forExport && delete a.width, d.namespaceURI === this.SVG_NS ? (c = function(a, z) {
                    return "-" + z.toLowerCase();
                }, N(a, function(a, z) {
                    -1 === v(z, h) && (m += z.replace(/([A-Z])/g, c) + ":" + a + ";");
                }), m && f(d, "style", m)) : x(d, a), this.added && ("text" === this.element.nodeName && this.renderer.buildText(this), a && a.textOutline && this.applyTextOutline(a.textOutline)));
                return this;
            },
            strokeWidth: function() {
                return this["stroke-width"] || 0;
            },
            on: function(a, g) {
                var z = this, r = z.element;
                b && "click" === a ? (r.ontouchstart = function(a) {
                    z.touchEventFired = Date.now();
                    a.preventDefault();
                    g.call(r, a);
                }, r.onclick = function(a) {
                    (-1 === Q.navigator.userAgent.indexOf("Android") || 1100 < Date.now() - (z.touchEventFired || 0)) && g.call(r, a);
                }) : r["on" + a] = g;
                return this;
            },
            setRadialReference: function(a) {
                var z = this.renderer.gradients[this.element.gradient];
                this.element.radialReference = a;
                z && z.radAttr && z.animate(this.renderer.getRadialAttr(a, z.radAttr));
                return this;
            },
            translate: function(a, g) {
                return this.attr({
                    translateX: a,
                    translateY: g
                });
            },
            invert: function(a) {
                this.inverted = a;
                this.updateTransform();
                return this;
            },
            updateTransform: function() {
                var a = this.translateX || 0, g = this.translateY || 0, r = this.scaleX, d = this.scaleY, b = this.inverted, m = this.rotation, k = this.matrix, c = this.element;
                b && (a += this.width, g += this.height);
                a = [
                    "translate(" + a + "," + g + ")"
                ];
                w(k) && a.push("matrix(" + k.join(",") + ")");
                b ? a.push("rotate(90) scale(-1,1)") : m && a.push("rotate(" + m + " " + E(this.rotationOriginX, c.getAttribute("x"), 0) + " " + E(this.rotationOriginY, c.getAttribute("y") || 0) + ")");
                (w(r) || w(d)) && a.push("scale(" + E(r, 1) + " " + E(d, 1) + ")");
                a.length && c.setAttribute("transform", a.join(" "));
            },
            toFront: function() {
                var a = this.element;
                a.parentNode.appendChild(a);
                return this;
            },
            align: function(a, g, r) {
                var z, d, b, m, k = {};
                d = this.renderer;
                b = d.alignedObjects;
                var c, H;
                if (a) {
                    if (this.alignOptions = a, this.alignByTranslate = g, !r || D(r)) this.alignTo = z = r || "renderer", q(b, this), b.push(this), r = null;
                } else a = this.alignOptions, g = this.alignByTranslate, z = this.alignTo;
                r = E(r, d[z], d);
                z = a.align;
                d = a.verticalAlign;
                b = (r.x || 0) + (a.x || 0);
                m = (r.y || 0) + (a.y || 0);
                "right" === z ? c = 1 : "center" === z && (c = 2);
                c && (b += (r.width - (a.width || 0)) / c);
                k[g ? "translateX" : "x"] = Math.round(b);
                "bottom" === d ? H = 1 : "middle" === d && (H = 2);
                H && (m += (r.height - (a.height || 0)) / H);
                k[g ? "translateY" : "y"] = Math.round(m);
                this[this.placed ? "animate" : "attr"](k);
                this.placed = !0;
                this.alignAttr = k;
                return this;
            },
            getBBox: function(a, g) {
                var z, r = this.renderer, d, b = this.element, m = this.styles, c, H = this.textStr, h, q = r.cache, A = r.cacheKeys, v = b.namespaceURI === this.SVG_NS, l;
                g = E(g, this.rotation);
                d = g * y;
                c = m && m.fontSize;
                w(H) && (l = H.toString(), -1 === l.indexOf("\x3c") && (l = l.replace(/[0-9]/g, "0")), l += [
                    "",
                    g || 0,
                    c,
                    this.textWidth,
                    m && m.textOverflow
                ].join());
                l && !a && (z = q[l]);
                if (!z) {
                    if (v || r.forExport) {
                        try {
                            (h = this.fakeTS && function(a) {
                                p(b.querySelectorAll(".highcharts-text-outline"), function(g) {
                                    g.style.display = a;
                                });
                            }) && h("none"), z = b.getBBox ? k({}, b.getBBox()) : {
                                width: b.offsetWidth,
                                height: b.offsetHeight
                            }, h && h("");
                        } catch (X) {}
                        if (!z || 0 > z.width) z = {
                            width: 0,
                            height: 0
                        };
                    } else z = this.htmlGetBBox();
                    r.isSVG && (a = z.width, r = z.height, v && (z.height = r = ({
                        "11px,17": 14,
                        "13px,20": 16
                    })[m && m.fontSize + "," + Math.round(r)] || r), g && (z.width = Math.abs(r * Math.sin(d)) + Math.abs(a * Math.cos(d)), z.height = Math.abs(r * Math.cos(d)) + Math.abs(a * Math.sin(d))));
                    if (l && 0 < z.height) {
                        for(; 250 < A.length;)delete q[A.shift()];
                        q[l] || A.push(l);
                        q[l] = z;
                    }
                }
                return z;
            },
            show: function(a) {
                return this.attr({
                    visibility: a ? "inherit" : "visible"
                });
            },
            hide: function() {
                return this.attr({
                    visibility: "hidden"
                });
            },
            fadeOut: function(a) {
                var g = this;
                g.animate({
                    opacity: 0
                }, {
                    duration: a || 150,
                    complete: function() {
                        g.attr({
                            y: -9999
                        });
                    }
                });
            },
            add: function(a) {
                var g = this.renderer, z = this.element, r;
                a && (this.parentGroup = a);
                this.parentInverted = a && a.inverted;
                void 0 !== this.textStr && g.buildText(this);
                this.added = !0;
                if (!a || a.handleZ || this.zIndex) r = this.zIndexSetter();
                r || (a ? a.element : g.box).appendChild(z);
                if (this.onAdd) this.onAdd();
                return this;
            },
            safeRemoveChild: function(a) {
                var g = a.parentNode;
                g && g.removeChild(a);
            },
            destroy: function() {
                var a = this, g = a.element || {}, r = a.renderer.isSVG && "SPAN" === g.nodeName && a.parentGroup, d = g.ownerSVGElement, b = a.clipPath;
                g.onclick = g.onmouseout = g.onmouseover = g.onmousemove = g.point = null;
                M(a);
                b && d && (p(d.querySelectorAll("[clip-path],[CLIP-PATH]"), function(a) {
                    var g = a.getAttribute("clip-path"), z = b.element.id;
                    (-1 < g.indexOf("(#" + z + ")") || -1 < g.indexOf('("#' + z + '")')) && a.removeAttribute("clip-path");
                }), a.clipPath = b.destroy());
                if (a.stops) {
                    for(d = 0; d < a.stops.length; d++)a.stops[d] = a.stops[d].destroy();
                    a.stops = null;
                }
                a.safeRemoveChild(g);
                for(a.destroyShadows(); r && r.div && 0 === r.div.childNodes.length;)g = r.parentGroup, a.safeRemoveChild(r.div), delete r.div, r = g;
                a.alignTo && q(a.renderer.alignedObjects, a);
                N(a, function(g, z) {
                    delete a[z];
                });
                return null;
            },
            shadow: function(a, g, r) {
                var z = [], d, b, m = this.element, k, c, H, h;
                if (!a) this.destroyShadows();
                else if (!this.shadows) {
                    c = E(a.width, 3);
                    H = (a.opacity || .15) / c;
                    h = this.parentInverted ? "(-1,-1)" : "(" + E(a.offsetX, 1) + ", " + E(a.offsetY, 1) + ")";
                    for(d = 1; d <= c; d++)b = m.cloneNode(0), k = 2 * c + 1 - 2 * d, f(b, {
                        stroke: a.color || "#000000",
                        "stroke-opacity": H * d,
                        "stroke-width": k,
                        transform: "translate" + h,
                        fill: "none"
                    }), b.setAttribute("class", (b.getAttribute("class") || "") + " highcharts-shadow"), r && (f(b, "height", Math.max(f(b, "height") - k, 0)), b.cutHeight = k), g ? g.element.appendChild(b) : m.parentNode && m.parentNode.insertBefore(b, m), z.push(b);
                    this.shadows = z;
                }
                return this;
            },
            destroyShadows: function() {
                p(this.shadows || [], function(a) {
                    this.safeRemoveChild(a);
                }, this);
                this.shadows = void 0;
            },
            xGetter: function(a) {
                "circle" === this.element.nodeName && ("x" === a ? a = "cx" : "y" === a && (a = "cy"));
                return this._defaultGetter(a);
            },
            _defaultGetter: function(a) {
                a = E(this[a + "Value"], this[a], this.element ? this.element.getAttribute(a) : null, 0);
                /^[\-0-9\.]+$/.test(a) && (a = parseFloat(a));
                return a;
            },
            dSetter: function(a, g, r) {
                a && a.join && (a = a.join(" "));
                /(NaN| {2}|^$)/.test(a) && (a = "M 0 0");
                this[g] !== a && (r.setAttribute(g, a), this[g] = a);
            },
            dashstyleSetter: function(a) {
                var r, z = this["stroke-width"];
                "inherit" === z && (z = 1);
                if (a = a && a.toLowerCase()) {
                    a = a.replace("shortdashdotdot", "3,1,1,1,1,1,").replace("shortdashdot", "3,1,1,1").replace("shortdot", "1,1,").replace("shortdash", "3,1,").replace("longdash", "8,3,").replace(/dot/g, "1,3,").replace("dash", "4,3,").replace(/,$/, "").split(",");
                    for(r = a.length; r--;)a[r] = g(a[r]) * z;
                    a = a.join(",").replace(/NaN/g, "none");
                    this.element.setAttribute("stroke-dasharray", a);
                }
            },
            alignSetter: function(a) {
                this.alignValue = a;
                this.element.setAttribute("text-anchor", {
                    left: "start",
                    center: "middle",
                    right: "end"
                }[a]);
            },
            opacitySetter: function(a, g, r) {
                this[g] = a;
                r.setAttribute(g, a);
            },
            titleSetter: function(a) {
                var g = this.element.getElementsByTagName("title")[0];
                g || (g = h.createElementNS(this.SVG_NS, "title"), this.element.appendChild(g));
                g.firstChild && g.removeChild(g.firstChild);
                g.appendChild(h.createTextNode(String(E(a), "").replace(/<[^>]*>/g, "").replace(/&lt;/g, "\x3c").replace(/&gt;/g, "\x3e")));
            },
            textSetter: function(a) {
                a !== this.textStr && (delete this.bBox, this.textStr = a, this.added && this.renderer.buildText(this));
            },
            fillSetter: function(a, g, r) {
                "string" === typeof a ? r.setAttribute(g, a) : a && this.complexColor(a, g, r);
            },
            visibilitySetter: function(a, g, r) {
                "inherit" === a ? r.removeAttribute(g) : this[g] !== a && r.setAttribute(g, a);
                this[g] = a;
            },
            zIndexSetter: function(a, r) {
                var z = this.renderer, d = this.parentGroup, b = (d || z).element || z.box, m, k = this.element, c, H, z = b === z.box;
                m = this.added;
                var h;
                w(a) ? (k.setAttribute("data-z-index", a), a = +a, this[r] === a && (m = !1)) : w(this[r]) && k.removeAttribute("data-z-index");
                this[r] = a;
                if (m) {
                    (a = this.zIndex) && d && (d.handleZ = !0);
                    r = b.childNodes;
                    for(h = r.length - 1; 0 <= h && !c; h--)if (d = r[h], m = d.getAttribute("data-z-index"), H = !w(m), d !== k) {
                        if (0 > a && H && !z && !h) b.insertBefore(k, r[h]), c = !0;
                        else if (g(m) <= a || H && (!w(a) || 0 <= a)) b.insertBefore(k, r[h + 1] || null), c = !0;
                    }
                    c || (b.insertBefore(k, r[z ? 3 : 0] || null), c = !0);
                }
                return c;
            },
            _defaultSetter: function(a, g, r) {
                r.setAttribute(g, a);
            }
        });
        C.prototype.yGetter = C.prototype.xGetter;
        C.prototype.translateXSetter = C.prototype.translateYSetter = C.prototype.rotationSetter = C.prototype.verticalAlignSetter = C.prototype.rotationOriginXSetter = C.prototype.rotationOriginYSetter = C.prototype.scaleXSetter = C.prototype.scaleYSetter = C.prototype.matrixSetter = function(a, g) {
            this[g] = a;
            this.doTransform = !0;
        };
        C.prototype["stroke-widthSetter"] = C.prototype.strokeSetter = function(a, g, r) {
            this[g] = a;
            this.stroke && this["stroke-width"] ? (C.prototype.fillSetter.call(this, this.stroke, "stroke", r), r.setAttribute("stroke-width", this["stroke-width"]), this.hasStroke = !0) : "stroke-width" === g && 0 === a && this.hasStroke && (r.removeAttribute("stroke"), this.hasStroke = !1);
        };
        F = a.SVGRenderer = function() {
            this.init.apply(this, arguments);
        };
        k(F.prototype, {
            Element: C,
            SVG_NS: H,
            init: function(a, g, r, d, b, k) {
                var z;
                d = this.createElement("svg").attr({
                    version: "1.1",
                    "class": "highcharts-root"
                }).css(this.getStyle(d));
                z = d.element;
                a.appendChild(z);
                f(a, "dir", "ltr");
                -1 === a.innerHTML.indexOf("xmlns") && f(z, "xmlns", this.SVG_NS);
                this.isSVG = !0;
                this.box = z;
                this.boxWrapper = d;
                this.alignedObjects = [];
                this.url = (l || m) && h.getElementsByTagName("base").length ? Q.location.href.split("#")[0].replace(/<[^>]*>/g, "").replace(/([\('\)])/g, "\\$1").replace(/ /g, "%20") : "";
                this.createElement("desc").add().element.appendChild(h.createTextNode("Created with Highcharts 6.2.0"));
                this.defs = this.createElement("defs").add();
                this.allowHTML = k;
                this.forExport = b;
                this.gradients = {};
                this.cache = {};
                this.cacheKeys = [];
                this.imgCount = 0;
                this.setSize(g, r, !1);
                var c;
                l && a.getBoundingClientRect && (g = function() {
                    x(a, {
                        left: 0,
                        top: 0
                    });
                    c = a.getBoundingClientRect();
                    x(a, {
                        left: Math.ceil(c.left) - c.left + "px",
                        top: Math.ceil(c.top) - c.top + "px"
                    });
                }, g(), this.unSubPixelFix = I(Q, "resize", g));
            },
            getStyle: function(a) {
                return this.style = k({
                    fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',
                    fontSize: "12px"
                }, a);
            },
            setStyle: function(a) {
                this.boxWrapper.css(this.getStyle(a));
            },
            isHidden: function() {
                return !this.boxWrapper.getBBox().width;
            },
            destroy: function() {
                var a = this.defs;
                this.box = null;
                this.boxWrapper = this.boxWrapper.destroy();
                c(this.gradients || {});
                this.gradients = null;
                a && (this.defs = a.destroy());
                this.unSubPixelFix && this.unSubPixelFix();
                return this.alignedObjects = null;
            },
            createElement: function(a) {
                var g = new this.Element;
                g.init(this, a);
                return g;
            },
            draw: A,
            getRadialAttr: function(a, g) {
                return {
                    cx: a[0] - a[2] / 2 + g.cx * a[2],
                    cy: a[1] - a[2] / 2 + g.cy * a[2],
                    r: g.r * a[2]
                };
            },
            truncate: function(a, g, r, d, b, m, k) {
                var z = this, c = a.rotation, H, q = d ? 1 : 0, A = (r || d).length, v = A, p = [], l = function(a) {
                    g.firstChild && g.removeChild(g.firstChild);
                    a && g.appendChild(h.createTextNode(a));
                }, O = function(m, c) {
                    c = c || m;
                    if (void 0 === p[c]) {
                        if (g.getSubStringLength) try {
                            p[c] = b + g.getSubStringLength(0, d ? c + 1 : c);
                        } catch (Y) {}
                        else z.getSpanWidth && (l(k(r || d, m)), p[c] = b + z.getSpanWidth(a, g));
                    }
                    return p[c];
                }, G, M;
                a.rotation = 0;
                G = O(g.textContent.length);
                if (M = b + G > m) {
                    for(; q <= A;)v = Math.ceil((q + A) / 2), d && (H = k(d, v)), G = O(v, H && H.length - 1), q === A ? q = A + 1 : G > m ? A = v - 1 : q = v;
                    0 === A ? l("") : r && A === r.length - 1 || l(H || k(r || d, v));
                }
                d && d.splice(0, v);
                a.actualWidth = G;
                a.rotation = c;
                return M;
            },
            escapes: {
                "\x26": "\x26amp;",
                "\x3c": "\x26lt;",
                "\x3e": "\x26gt;",
                "'": "\x26#39;",
                '"': "\x26quot;"
            },
            buildText: function(a) {
                var r = a.element, b = this, m = b.forExport, c = E(a.textStr, "").toString(), z = -1 !== c.indexOf("\x3c"), k = r.childNodes, q, A = f(r, "x"), l = a.styles, G = a.textWidth, M = l && l.lineHeight, e = l && l.textOutline, B = l && "ellipsis" === l.textOverflow, R = l && "nowrap" === l.whiteSpace, y = l && l.fontSize, t, D, J = k.length, l = G && !a.added && this.box, w = function(a) {
                    var d;
                    d = /(px|em)$/.test(a && a.style.fontSize) ? a.style.fontSize : y || b.style.fontSize || 12;
                    return M ? g(M) : b.fontMetrics(d, a.getAttribute("style") ? a : r).h;
                }, Q = function(a, g) {
                    N(b.escapes, function(r, d) {
                        g && -1 !== v(r, g) || (a = a.toString().replace(new RegExp(r, "g"), d));
                    });
                    return a;
                }, u = function(a, g) {
                    var r;
                    r = a.indexOf("\x3c");
                    a = a.substring(r, a.indexOf("\x3e") - r);
                    r = a.indexOf(g + "\x3d");
                    if (-1 !== r && (r = r + g.length + 1, g = a.charAt(r), '"' === g || "'" === g)) return a = a.substring(r + 1), a.substring(0, a.indexOf(g));
                };
                t = [
                    c,
                    B,
                    R,
                    M,
                    e,
                    y,
                    G
                ].join();
                if (t !== a.textCache) {
                    for(a.textCache = t; J--;)r.removeChild(k[J]);
                    z || e || B || G || -1 !== c.indexOf(" ") ? (l && l.appendChild(r), c = z ? c.replace(/<(b|strong)>/g, '\x3cspan style\x3d"font-weight:bold"\x3e').replace(/<(i|em)>/g, '\x3cspan style\x3d"font-style:italic"\x3e').replace(/<a/g, "\x3cspan").replace(/<\/(b|strong|i|em|a)>/g, "\x3c/span\x3e").split(/<br.*?>/g) : [
                        c
                    ], c = d(c, function(a) {
                        return "" !== a;
                    }), p(c, function(g, d) {
                        var c, z = 0, k = 0;
                        g = g.replace(/^\s+|\s+$/g, "").replace(/<span/g, "|||\x3cspan").replace(/<\/span>/g, "\x3c/span\x3e|||");
                        c = g.split("|||");
                        p(c, function(g) {
                            if ("" !== g || 1 === c.length) {
                                var v = {}, l = h.createElementNS(b.SVG_NS, "tspan"), p, M;
                                (p = u(g, "class")) && f(l, "class", p);
                                if (p = u(g, "style")) p = p.replace(/(;| |^)color([ :])/, "$1fill$2"), f(l, "style", p);
                                (M = u(g, "href")) && !m && (f(l, "onclick", 'location.href\x3d"' + M + '"'), f(l, "class", "highcharts-anchor"), x(l, {
                                    cursor: "pointer"
                                }));
                                g = Q(g.replace(/<[a-zA-Z\/](.|\n)*?>/g, "") || " ");
                                if (" " !== g) {
                                    l.appendChild(h.createTextNode(g));
                                    z ? v.dx = 0 : d && null !== A && (v.x = A);
                                    f(l, v);
                                    r.appendChild(l);
                                    !z && D && (!O && m && x(l, {
                                        display: "block"
                                    }), f(l, "dy", w(l)));
                                    if (G) {
                                        var e = g.replace(/([^\^])-/g, "$1- ").split(" "), v = !R && (1 < c.length || d || 1 < e.length);
                                        M = 0;
                                        var t = w(l);
                                        if (B) q = b.truncate(a, l, g, void 0, 0, Math.max(0, G - parseInt(y || 12, 10)), function(a, g) {
                                            return a.substring(0, g) + "\u2026";
                                        });
                                        else if (v) for(; e.length;)e.length && !R && 0 < M && (l = h.createElementNS(H, "tspan"), f(l, {
                                            dy: t,
                                            x: A
                                        }), p && f(l, "style", p), l.appendChild(h.createTextNode(e.join(" ").replace(/- /g, "-"))), r.appendChild(l)), b.truncate(a, l, null, e, 0 === M ? k : 0, G, function(a, g) {
                                            return e.slice(0, g).join(" ").replace(/- /g, "-");
                                        }), k = a.actualWidth, M++;
                                    }
                                    z++;
                                }
                            }
                        });
                        D = D || r.childNodes.length;
                    }), B && q && a.attr("title", Q(a.textStr, [
                        "\x26lt;",
                        "\x26gt;"
                    ])), l && l.removeChild(r), e && a.applyTextOutline && a.applyTextOutline(e)) : r.appendChild(h.createTextNode(Q(c)));
                }
            },
            getContrast: function(a) {
                a = u(a).rgba;
                a[0] *= 1;
                a[1] *= 1.2;
                a[2] *= .5;
                return 459 < a[0] + a[1] + a[2] ? "#000000" : "#FFFFFF";
            },
            button: function(a, g, r, d, b, c, m, H, h) {
                var z = this.label(a, g, r, h, null, null, null, null, "button"), q = 0;
                z.attr(G({
                    padding: 8,
                    r: 2
                }, b));
                var A, v, l, p;
                b = G({
                    fill: "#f7f7f7",
                    stroke: "#cccccc",
                    "stroke-width": 1,
                    style: {
                        color: "#333333",
                        cursor: "pointer",
                        fontWeight: "normal"
                    }
                }, b);
                A = b.style;
                delete b.style;
                c = G(b, {
                    fill: "#e6e6e6"
                }, c);
                v = c.style;
                delete c.style;
                m = G(b, {
                    fill: "#e6ebf5",
                    style: {
                        color: "#000000",
                        fontWeight: "bold"
                    }
                }, m);
                l = m.style;
                delete m.style;
                H = G(b, {
                    style: {
                        color: "#cccccc"
                    }
                }, H);
                p = H.style;
                delete H.style;
                I(z.element, L ? "mouseover" : "mouseenter", function() {
                    3 !== q && z.setState(1);
                });
                I(z.element, L ? "mouseout" : "mouseleave", function() {
                    3 !== q && z.setState(q);
                });
                z.setState = function(a) {
                    1 !== a && (z.state = q = a);
                    z.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-" + [
                        "normal",
                        "hover",
                        "pressed",
                        "disabled"
                    ][a || 0]);
                    z.attr([
                        b,
                        c,
                        m,
                        H
                    ][a || 0]).css([
                        A,
                        v,
                        l,
                        p
                    ][a || 0]);
                };
                z.attr(b).css(k({
                    cursor: "default"
                }, A));
                return z.on("click", function(a) {
                    3 !== q && d.call(z, a);
                });
            },
            crispLine: function(a, g) {
                a[1] === a[4] && (a[1] = a[4] = Math.round(a[1]) - g % 2 / 2);
                a[2] === a[5] && (a[2] = a[5] = Math.round(a[2]) + g % 2 / 2);
                return a;
            },
            path: function(a) {
                var g = {
                    fill: "none"
                };
                J(a) ? g.d = a : B(a) && k(g, a);
                return this.createElement("path").attr(g);
            },
            circle: function(a, g, r) {
                a = B(a) ? a : {
                    x: a,
                    y: g,
                    r: r
                };
                g = this.createElement("circle");
                g.xSetter = g.ySetter = function(a, g, r) {
                    r.setAttribute("c" + g, a);
                };
                return g.attr(a);
            },
            arc: function(a, g, r, d, b, c) {
                B(a) ? (d = a, g = d.y, r = d.r, a = d.x) : d = {
                    innerR: d,
                    start: b,
                    end: c
                };
                a = this.symbol("arc", a, g, r, r, d);
                a.r = r;
                return a;
            },
            rect: function(a, g, r, d, b, c) {
                b = B(a) ? a.r : b;
                var m = this.createElement("rect");
                a = B(a) ? a : void 0 === a ? {} : {
                    x: a,
                    y: g,
                    width: Math.max(r, 0),
                    height: Math.max(d, 0)
                };
                void 0 !== c && (a.strokeWidth = c, a = m.crisp(a));
                a.fill = "none";
                b && (a.r = b);
                m.rSetter = function(a, g, r) {
                    f(r, {
                        rx: a,
                        ry: a
                    });
                };
                return m.attr(a);
            },
            setSize: function(a, g, r) {
                var d = this.alignedObjects, b = d.length;
                this.width = a;
                this.height = g;
                for(this.boxWrapper.animate({
                    width: a,
                    height: g
                }, {
                    step: function() {
                        this.attr({
                            viewBox: "0 0 " + this.attr("width") + " " + this.attr("height")
                        });
                    },
                    duration: E(r, !0) ? void 0 : 0
                }); b--;)d[b].align();
            },
            g: function(a) {
                var g = this.createElement("g");
                return a ? g.attr({
                    "class": "highcharts-" + a
                }) : g;
            },
            image: function(a, g, r, d, b, c) {
                var m = {
                    preserveAspectRatio: "none"
                }, H, h = function(a, g) {
                    a.setAttributeNS ? a.setAttributeNS("http://www.w3.org/1999/xlink", "href", g) : a.setAttribute("hc-svg-href", g);
                }, q = function(g) {
                    h(H.element, a);
                    c.call(H, g);
                };
                1 < arguments.length && k(m, {
                    x: g,
                    y: r,
                    width: d,
                    height: b
                });
                H = this.createElement("image").attr(m);
                c ? (h(H.element, "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw\x3d\x3d"), m = new Q.Image, I(m, "load", q), m.src = a, m.complete && q({})) : h(H.element, a);
                return H;
            },
            symbol: function(a, g, r, d, b, c) {
                var m = this, H, q = /^url\((.*?)\)$/, A = q.test(a), v = !A && (this.symbols[a] ? a : "circle"), z = v && this.symbols[v], l = w(g) && z && z.call(this.symbols, Math.round(g), Math.round(r), d, b, c), G, M;
                z ? (H = this.path(l), H.attr("fill", "none"), k(H, {
                    symbolName: v,
                    x: g,
                    y: r,
                    width: d,
                    height: b
                }), c && k(H, c)) : A && (G = a.match(q)[1], H = this.image(G), H.imgwidth = E(R[G] && R[G].width, c && c.width), H.imgheight = E(R[G] && R[G].height, c && c.height), M = function() {
                    H.attr({
                        width: H.width,
                        height: H.height
                    });
                }, p([
                    "width",
                    "height"
                ], function(a) {
                    H[a + "Setter"] = function(a, g) {
                        var r = {}, d = this["img" + g], b = "width" === g ? "translateX" : "translateY";
                        this[g] = a;
                        w(d) && (this.element && this.element.setAttribute(g, d), this.alignByTranslate || (r[b] = ((this[g] || 0) - d) / 2, this.attr(r)));
                    };
                }), w(g) && H.attr({
                    x: g,
                    y: r
                }), H.isImg = !0, w(H.imgwidth) && w(H.imgheight) ? M() : (H.attr({
                    width: 0,
                    height: 0
                }), t("img", {
                    onload: function() {
                        var a = e[m.chartIndex];
                        0 === this.width && (x(this, {
                            position: "absolute",
                            top: "-999em"
                        }), h.body.appendChild(this));
                        R[G] = {
                            width: this.width,
                            height: this.height
                        };
                        H.imgwidth = this.width;
                        H.imgheight = this.height;
                        H.element && M();
                        this.parentNode && this.parentNode.removeChild(this);
                        m.imgCount--;
                        if (!m.imgCount && a && a.onload) a.onload();
                    },
                    src: G
                }), this.imgCount++));
                return H;
            },
            symbols: {
                circle: function(a, g, r, d) {
                    return this.arc(a + r / 2, g + d / 2, r / 2, d / 2, {
                        start: 0,
                        end: 2 * Math.PI,
                        open: !1
                    });
                },
                square: function(a, g, r, d) {
                    return [
                        "M",
                        a,
                        g,
                        "L",
                        a + r,
                        g,
                        a + r,
                        g + d,
                        a,
                        g + d,
                        "Z"
                    ];
                },
                triangle: function(a, g, r, d) {
                    return [
                        "M",
                        a + r / 2,
                        g,
                        "L",
                        a + r,
                        g + d,
                        a,
                        g + d,
                        "Z"
                    ];
                },
                "triangle-down": function(a, g, r, d) {
                    return [
                        "M",
                        a,
                        g,
                        "L",
                        a + r,
                        g,
                        a + r / 2,
                        g + d,
                        "Z"
                    ];
                },
                diamond: function(a, g, r, d) {
                    return [
                        "M",
                        a + r / 2,
                        g,
                        "L",
                        a + r,
                        g + d / 2,
                        a + r / 2,
                        g + d,
                        a,
                        g + d / 2,
                        "Z"
                    ];
                },
                arc: function(a, g, r, d, b) {
                    var c = b.start, m = b.r || r, H = b.r || d || r, k = b.end - .001;
                    r = b.innerR;
                    d = E(b.open, .001 > Math.abs(b.end - b.start - 2 * Math.PI));
                    var h = Math.cos(c), q = Math.sin(c), A = Math.cos(k), k = Math.sin(k);
                    b = .001 > b.end - c - Math.PI ? 0 : 1;
                    m = [
                        "M",
                        a + m * h,
                        g + H * q,
                        "A",
                        m,
                        H,
                        0,
                        b,
                        1,
                        a + m * A,
                        g + H * k
                    ];
                    w(r) && m.push(d ? "M" : "L", a + r * A, g + r * k, "A", r, r, 0, b, 0, a + r * h, g + r * q);
                    m.push(d ? "" : "Z");
                    return m;
                },
                callout: function(a, g, r, d, b) {
                    var c = Math.min(b && b.r || 0, r, d), m = c + 6, H = b && b.anchorX;
                    b = b && b.anchorY;
                    var k;
                    k = [
                        "M",
                        a + c,
                        g,
                        "L",
                        a + r - c,
                        g,
                        "C",
                        a + r,
                        g,
                        a + r,
                        g,
                        a + r,
                        g + c,
                        "L",
                        a + r,
                        g + d - c,
                        "C",
                        a + r,
                        g + d,
                        a + r,
                        g + d,
                        a + r - c,
                        g + d,
                        "L",
                        a + c,
                        g + d,
                        "C",
                        a,
                        g + d,
                        a,
                        g + d,
                        a,
                        g + d - c,
                        "L",
                        a,
                        g + c,
                        "C",
                        a,
                        g,
                        a,
                        g,
                        a + c,
                        g
                    ];
                    H && H > r ? b > g + m && b < g + d - m ? k.splice(13, 3, "L", a + r, b - 6, a + r + 6, b, a + r, b + 6, a + r, g + d - c) : k.splice(13, 3, "L", a + r, d / 2, H, b, a + r, d / 2, a + r, g + d - c) : H && 0 > H ? b > g + m && b < g + d - m ? k.splice(33, 3, "L", a, b + 6, a - 6, b, a, b - 6, a, g + c) : k.splice(33, 3, "L", a, d / 2, H, b, a, d / 2, a, g + c) : b && b > d && H > a + m && H < a + r - m ? k.splice(23, 3, "L", H + 6, g + d, H, g + d + 6, H - 6, g + d, a + c, g + d) : b && 0 > b && H > a + m && H < a + r - m && k.splice(3, 3, "L", H - 6, g, H, g - 6, H + 6, g, r - c, g);
                    return k;
                }
            },
            clipRect: function(g, r, d, b) {
                var c = a.uniqueKey(), m = this.createElement("clipPath").attr({
                    id: c
                }).add(this.defs);
                g = this.rect(g, r, d, b, 0).add(m);
                g.id = c;
                g.clipPath = m;
                g.count = 0;
                return g;
            },
            text: function(a, g, r, d) {
                var b = {};
                if (d && (this.allowHTML || !this.forExport)) return this.html(a, g, r);
                b.x = Math.round(g || 0);
                r && (b.y = Math.round(r));
                w(a) && (b.text = a);
                a = this.createElement("text").attr(b);
                d || (a.xSetter = function(a, g, r) {
                    var d = r.getElementsByTagName("tspan"), b, c = r.getAttribute(g), m;
                    for(m = 0; m < d.length; m++)b = d[m], b.getAttribute(g) === c && b.setAttribute(g, a);
                    r.setAttribute(g, a);
                });
                return a;
            },
            fontMetrics: function(a, r) {
                a = a || r && r.style && r.style.fontSize || this.style && this.style.fontSize;
                a = /px/.test(a) ? g(a) : /em/.test(a) ? parseFloat(a) * (r ? this.fontMetrics(null, r.parentNode).f : 16) : 12;
                r = 24 > a ? a + 3 : Math.round(1.2 * a);
                return {
                    h: r,
                    b: Math.round(.8 * r),
                    f: a
                };
            },
            rotCorr: function(a, g, r) {
                var d = a;
                g && r && (d = Math.max(d * Math.cos(g * y), 4));
                return {
                    x: -a / 3 * Math.sin(g * y),
                    y: d
                };
            },
            label: function(g, d, b, c, m, H, h, q, A) {
                var v = this, l = v.g("button" !== A && "label"), M = l.text = v.text("", 0, 0, h).attr({
                    zIndex: 1
                }), O, z, e = 0, B = 3, R = 0, f, y, t, D, J, E = {}, N, x, Q = /^url\((.*?)\)$/.test(c), u = Q, L, n, P, T;
                A && l.addClass("highcharts-" + A);
                u = Q;
                L = function() {
                    return (N || 0) % 2 / 2;
                };
                n = function() {
                    var a = M.element.style, g = {};
                    z = (void 0 === f || void 0 === y || J) && w(M.textStr) && M.getBBox();
                    l.width = (f || z.width || 0) + 2 * B + R;
                    l.height = (y || z.height || 0) + 2 * B;
                    x = B + v.fontMetrics(a && a.fontSize, M).b;
                    u && (O || (l.box = O = v.symbols[c] || Q ? v.symbol(c) : v.rect(), O.addClass(("button" === A ? "" : "highcharts-label-box") + (A ? " highcharts-" + A + "-box" : "")), O.add(l), a = L(), g.x = a, g.y = (q ? -x : 0) + a), g.width = Math.round(l.width), g.height = Math.round(l.height), O.attr(k(g, E)), E = {});
                };
                P = function() {
                    var a = R + B, g;
                    g = q ? 0 : x;
                    w(f) && z && ("center" === J || "right" === J) && (a += ({
                        center: .5,
                        right: 1
                    })[J] * (f - z.width));
                    if (a !== M.x || g !== M.y) M.attr("x", a), M.hasBoxWidthChanged && (z = M.getBBox(!0), n()), void 0 !== g && M.attr("y", g);
                    M.x = a;
                    M.y = g;
                };
                T = function(a, g) {
                    O ? O.attr(a, g) : E[a] = g;
                };
                l.onAdd = function() {
                    M.add(l);
                    l.attr({
                        text: g || 0 === g ? g : "",
                        x: d,
                        y: b
                    });
                    O && w(m) && l.attr({
                        anchorX: m,
                        anchorY: H
                    });
                };
                l.widthSetter = function(g) {
                    f = a.isNumber(g) ? g : null;
                };
                l.heightSetter = function(a) {
                    y = a;
                };
                l["text-alignSetter"] = function(a) {
                    J = a;
                };
                l.paddingSetter = function(a) {
                    w(a) && a !== B && (B = l.padding = a, P());
                };
                l.paddingLeftSetter = function(a) {
                    w(a) && a !== R && (R = a, P());
                };
                l.alignSetter = function(a) {
                    a = ({
                        left: 0,
                        center: .5,
                        right: 1
                    })[a];
                    a !== e && (e = a, z && l.attr({
                        x: t
                    }));
                };
                l.textSetter = function(a) {
                    void 0 !== a && M.textSetter(a);
                    n();
                    P();
                };
                l["stroke-widthSetter"] = function(a, g) {
                    a && (u = !0);
                    N = this["stroke-width"] = a;
                    T(g, a);
                };
                l.strokeSetter = l.fillSetter = l.rSetter = function(a, g) {
                    "r" !== g && ("fill" === g && a && (u = !0), l[g] = a);
                    T(g, a);
                };
                l.anchorXSetter = function(a, g) {
                    m = l.anchorX = a;
                    T(g, Math.round(a) - L() - t);
                };
                l.anchorYSetter = function(a, g) {
                    H = l.anchorY = a;
                    T(g, a - D);
                };
                l.xSetter = function(a) {
                    l.x = a;
                    e && (a -= e * ((f || z.width) + 2 * B), l["forceAnimate:x"] = !0);
                    t = Math.round(a);
                    l.attr("translateX", t);
                };
                l.ySetter = function(a) {
                    D = l.y = Math.round(a);
                    l.attr("translateY", D);
                };
                var V = l.css;
                return k(l, {
                    css: function(a) {
                        if (a) {
                            var g = {};
                            a = G(a);
                            p(l.textProps, function(r) {
                                void 0 !== a[r] && (g[r] = a[r], delete a[r]);
                            });
                            M.css(g);
                            "width" in g && n();
                        }
                        return V.call(l, a);
                    },
                    getBBox: function() {
                        return {
                            width: z.width + 2 * B,
                            height: z.height + 2 * B,
                            x: z.x - B,
                            y: z.y - B
                        };
                    },
                    shadow: function(a) {
                        a && (n(), O && O.shadow(a));
                        return l;
                    },
                    destroy: function() {
                        r(l.element, "mouseenter");
                        r(l.element, "mouseleave");
                        M && (M = M.destroy());
                        O && (O = O.destroy());
                        C.prototype.destroy.call(l);
                        l = v = n = P = T = null;
                    }
                });
            }
        });
        a.Renderer = F;
    })(K);
    (function(a) {
        var C = a.attr, F = a.createElement, I = a.css, n = a.defined, f = a.each, e = a.extend, u = a.isFirefox, x = a.isMS, t = a.isWebKit, w = a.pick, y = a.pInt, c = a.SVGRenderer, h = a.win, p = a.wrap;
        e(a.SVGElement.prototype, {
            htmlCss: function(a) {
                var c = "SPAN" === this.element.tagName && a && "width" in a, d = w(c && a.width, void 0);
                c && (delete a.width, this.textWidth = d, this.htmlUpdateTransform());
                a && "ellipsis" === a.textOverflow && (a.whiteSpace = "nowrap", a.overflow = "hidden");
                this.styles = e(this.styles, a);
                I(this.element, a);
                return this;
            },
            htmlGetBBox: function() {
                var a = this.element;
                return {
                    x: a.offsetLeft,
                    y: a.offsetTop,
                    width: a.offsetWidth,
                    height: a.offsetHeight
                };
            },
            htmlUpdateTransform: function() {
                if (this.added) {
                    var a = this.renderer, c = this.element, d = this.translateX || 0, b = this.translateY || 0, h = this.x || 0, p = this.y || 0, l = this.textAlign || "left", e = {
                        left: 0,
                        center: .5,
                        right: 1
                    }[l], B = this.styles, t = B && B.whiteSpace;
                    I(c, {
                        marginLeft: d,
                        marginTop: b
                    });
                    this.shadows && f(this.shadows, function(a) {
                        I(a, {
                            marginLeft: d + 1,
                            marginTop: b + 1
                        });
                    });
                    this.inverted && f(c.childNodes, function(d) {
                        a.invertChild(d, c);
                    });
                    if ("SPAN" === c.tagName) {
                        var B = this.rotation, m = this.textWidth && y(this.textWidth), G = [
                            B,
                            l,
                            c.innerHTML,
                            this.textWidth,
                            this.textAlign
                        ].join(), A;
                        (A = m !== this.oldTextWidth) && !(A = m > this.oldTextWidth) && ((A = this.textPxLength) || (I(c, {
                            width: "",
                            whiteSpace: t || "nowrap"
                        }), A = c.offsetWidth), A = A > m);
                        A && /[ \-]/.test(c.textContent || c.innerText) ? (I(c, {
                            width: m + "px",
                            display: "block",
                            whiteSpace: t || "normal"
                        }), this.oldTextWidth = m, this.hasBoxWidthChanged = !0) : this.hasBoxWidthChanged = !1;
                        G !== this.cTT && (t = a.fontMetrics(c.style.fontSize).b, !n(B) || B === (this.oldRotation || 0) && l === this.oldAlign || this.setSpanRotation(B, e, t), this.getSpanCorrection(!n(B) && this.textPxLength || c.offsetWidth, t, e, B, l));
                        I(c, {
                            left: h + (this.xCorr || 0) + "px",
                            top: p + (this.yCorr || 0) + "px"
                        });
                        this.cTT = G;
                        this.oldRotation = B;
                        this.oldAlign = l;
                    }
                } else this.alignOnAdd = !0;
            },
            setSpanRotation: function(a, c, d) {
                var b = {}, k = this.renderer.getTransformKey();
                b[k] = b.transform = "rotate(" + a + "deg)";
                b[k + (u ? "Origin" : "-origin")] = b.transformOrigin = 100 * c + "% " + d + "px";
                I(this.element, b);
            },
            getSpanCorrection: function(a, c, d) {
                this.xCorr = -a * d;
                this.yCorr = -c;
            }
        });
        e(c.prototype, {
            getTransformKey: function() {
                return x && !/Edge/.test(h.navigator.userAgent) ? "-ms-transform" : t ? "-webkit-transform" : u ? "MozTransform" : h.opera ? "-o-transform" : "";
            },
            html: function(a, c, d) {
                var b = this.createElement("span"), k = b.element, h = b.renderer, l = h.isSVG, q = function(a, d) {
                    f([
                        "opacity",
                        "visibility"
                    ], function(b) {
                        p(a, b + "Setter", function(a, b, c, m) {
                            a.call(this, b, c, m);
                            d[c] = b;
                        });
                    });
                    a.addedSetters = !0;
                };
                b.textSetter = function(a) {
                    a !== k.innerHTML && delete this.bBox;
                    this.textStr = a;
                    k.innerHTML = w(a, "");
                    b.doTransform = !0;
                };
                l && q(b, b.element.style);
                b.xSetter = b.ySetter = b.alignSetter = b.rotationSetter = function(a, d) {
                    "align" === d && (d = "textAlign");
                    b[d] = a;
                    b.doTransform = !0;
                };
                b.afterSetters = function() {
                    this.doTransform && (this.htmlUpdateTransform(), this.doTransform = !1);
                };
                b.attr({
                    text: a,
                    x: Math.round(c),
                    y: Math.round(d)
                }).css({
                    fontFamily: this.style.fontFamily,
                    fontSize: this.style.fontSize,
                    position: "absolute"
                });
                k.style.whiteSpace = "nowrap";
                b.css = b.htmlCss;
                l && (b.add = function(a) {
                    var d, c = h.box.parentNode, l = [];
                    if (this.parentGroup = a) {
                        if (d = a.div, !d) {
                            for(; a;)l.push(a), a = a.parentGroup;
                            f(l.reverse(), function(a) {
                                function m(g, d) {
                                    a[d] = g;
                                    "translateX" === d ? k.left = g + "px" : k.top = g + "px";
                                    a.doTransform = !0;
                                }
                                var k, g = C(a.element, "class");
                                g && (g = {
                                    className: g
                                });
                                d = a.div = a.div || F("div", g, {
                                    position: "absolute",
                                    left: (a.translateX || 0) + "px",
                                    top: (a.translateY || 0) + "px",
                                    display: a.display,
                                    opacity: a.opacity,
                                    pointerEvents: a.styles && a.styles.pointerEvents
                                }, d || c);
                                k = d.style;
                                e(a, {
                                    classSetter: function(a) {
                                        return function(g) {
                                            this.element.setAttribute("class", g);
                                            a.className = g;
                                        };
                                    }(d),
                                    on: function() {
                                        l[0].div && b.on.apply({
                                            element: l[0].div
                                        }, arguments);
                                        return a;
                                    },
                                    translateXSetter: m,
                                    translateYSetter: m
                                });
                                a.addedSetters || q(a, k);
                            });
                        }
                    } else d = c;
                    d.appendChild(k);
                    b.added = !0;
                    b.alignOnAdd && b.htmlUpdateTransform();
                    return b;
                });
                return b;
            }
        });
    })(K);
    (function(a) {
        var C = a.defined, F = a.each, I = a.extend, n = a.merge, f = a.pick, e = a.timeUnits, u = a.win;
        a.Time = function(a) {
            this.update(a, !1);
        };
        a.Time.prototype = {
            defaultOptions: {},
            update: function(a) {
                var e = f(a && a.useUTC, !0), w = this;
                this.options = a = n(!0, this.options || {}, a);
                this.Date = a.Date || u.Date;
                this.timezoneOffset = (this.useUTC = e) && a.timezoneOffset;
                this.getTimezoneOffset = this.timezoneOffsetFunction();
                (this.variableTimezone = !(e && !a.getTimezoneOffset && !a.timezone)) || this.timezoneOffset ? (this.get = function(a, c) {
                    var h = c.getTime(), p = h - w.getTimezoneOffset(c);
                    c.setTime(p);
                    a = c["getUTC" + a]();
                    c.setTime(h);
                    return a;
                }, this.set = function(a, c, h) {
                    var p;
                    if ("Milliseconds" === a || "Seconds" === a || "Minutes" === a && 0 === c.getTimezoneOffset() % 60) c["set" + a](h);
                    else p = w.getTimezoneOffset(c), p = c.getTime() - p, c.setTime(p), c["setUTC" + a](h), a = w.getTimezoneOffset(c), p = c.getTime() + a, c.setTime(p);
                }) : e ? (this.get = function(a, c) {
                    return c["getUTC" + a]();
                }, this.set = function(a, c, h) {
                    return c["setUTC" + a](h);
                }) : (this.get = function(a, c) {
                    return c["get" + a]();
                }, this.set = function(a, c, h) {
                    return c["set" + a](h);
                });
            },
            makeTime: function(e, t, w, y, c, h) {
                var p, k, q;
                this.useUTC ? (p = this.Date.UTC.apply(0, arguments), k = this.getTimezoneOffset(p), p += k, q = this.getTimezoneOffset(p), k !== q ? p += q - k : k - 36E5 !== this.getTimezoneOffset(p - 36E5) || a.isSafari || (p -= 36E5)) : p = new this.Date(e, t, f(w, 1), f(y, 0), f(c, 0), f(h, 0)).getTime();
                return p;
            },
            timezoneOffsetFunction: function() {
                var e = this, f = this.options, w = u.moment;
                if (!this.useUTC) return function(a) {
                    return 6E4 * new Date(a).getTimezoneOffset();
                };
                if (f.timezone) {
                    if (w) return function(a) {
                        return 6E4 * -w.tz(a, f.timezone).utcOffset();
                    };
                    a.error(25);
                }
                return this.useUTC && f.getTimezoneOffset ? function(a) {
                    return 6E4 * f.getTimezoneOffset(a);
                } : function() {
                    return 6E4 * (e.timezoneOffset || 0);
                };
            },
            dateFormat: function(e, f, w) {
                if (!a.defined(f) || isNaN(f)) return a.defaultOptions.lang.invalidDate || "";
                e = a.pick(e, "%Y-%m-%d %H:%M:%S");
                var t = this, c = new this.Date(f), h = this.get("Hours", c), p = this.get("Day", c), k = this.get("Date", c), q = this.get("Month", c), d = this.get("FullYear", c), b = a.defaultOptions.lang, v = b.weekdays, J = b.shortWeekdays, l = a.pad, c = a.extend({
                    a: J ? J[p] : v[p].substr(0, 3),
                    A: v[p],
                    d: l(k),
                    e: l(k, 2, " "),
                    w: p,
                    b: b.shortMonths[q],
                    B: b.months[q],
                    m: l(q + 1),
                    o: q + 1,
                    y: d.toString().substr(2, 2),
                    Y: d,
                    H: l(h),
                    k: h,
                    I: l(h % 12 || 12),
                    l: h % 12 || 12,
                    M: l(t.get("Minutes", c)),
                    p: 12 > h ? "AM" : "PM",
                    P: 12 > h ? "am" : "pm",
                    S: l(c.getSeconds()),
                    L: l(Math.floor(f % 1E3), 3)
                }, a.dateFormats);
                a.objectEach(c, function(a, d) {
                    for(; -1 !== e.indexOf("%" + d);)e = e.replace("%" + d, "function" === typeof a ? a.call(t, f) : a);
                });
                return w ? e.substr(0, 1).toUpperCase() + e.substr(1) : e;
            },
            resolveDTLFormat: function(e) {
                return a.isObject(e, !0) ? e : (e = a.splat(e), {
                    main: e[0],
                    from: e[1],
                    to: e[2]
                });
            },
            getTimeTicks: function(a, t, w, y) {
                var c = this, h = [], p, k = {}, q;
                p = new c.Date(t);
                var d = a.unitRange, b = a.count || 1, v;
                y = f(y, 1);
                if (C(t)) {
                    c.set("Milliseconds", p, d >= e.second ? 0 : b * Math.floor(c.get("Milliseconds", p) / b));
                    d >= e.second && c.set("Seconds", p, d >= e.minute ? 0 : b * Math.floor(c.get("Seconds", p) / b));
                    d >= e.minute && c.set("Minutes", p, d >= e.hour ? 0 : b * Math.floor(c.get("Minutes", p) / b));
                    d >= e.hour && c.set("Hours", p, d >= e.day ? 0 : b * Math.floor(c.get("Hours", p) / b));
                    d >= e.day && c.set("Date", p, d >= e.month ? 1 : b * Math.floor(c.get("Date", p) / b));
                    d >= e.month && (c.set("Month", p, d >= e.year ? 0 : b * Math.floor(c.get("Month", p) / b)), q = c.get("FullYear", p));
                    d >= e.year && c.set("FullYear", p, q - q % b);
                    d === e.week && (q = c.get("Day", p), c.set("Date", p, c.get("Date", p) - q + y + (q < y ? -7 : 0)));
                    q = c.get("FullYear", p);
                    y = c.get("Month", p);
                    var J = c.get("Date", p), l = c.get("Hours", p);
                    t = p.getTime();
                    c.variableTimezone && (v = w - t > 4 * e.month || c.getTimezoneOffset(t) !== c.getTimezoneOffset(w));
                    t = p.getTime();
                    for(p = 1; t < w;)h.push(t), t = d === e.year ? c.makeTime(q + p * b, 0) : d === e.month ? c.makeTime(q, y + p * b) : !v || d !== e.day && d !== e.week ? v && d === e.hour && 1 < b ? c.makeTime(q, y, J, l + p * b) : t + d * b : c.makeTime(q, y, J + p * b * (d === e.day ? 1 : 7)), p++;
                    h.push(t);
                    d <= e.hour && 1E4 > h.length && F(h, function(a) {
                        0 === a % 18E5 && "000000000" === c.dateFormat("%H%M%S%L", a) && (k[a] = "day");
                    });
                }
                h.info = I(a, {
                    higherRanks: k,
                    totalRange: d * b
                });
                return h;
            }
        };
    })(K);
    (function(a) {
        var C = a.color, F = a.merge;
        a.defaultOptions = {
            colors: "#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" "),
            symbols: [
                "circle",
                "diamond",
                "square",
                "triangle",
                "triangle-down"
            ],
            lang: {
                loading: "Loading...",
                months: "January February March April May June July August September October November December".split(" "),
                shortMonths: "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),
                weekdays: "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),
                decimalPoint: ".",
                numericSymbols: "kMGTPE".split(""),
                resetZoom: "Reset zoom",
                resetZoomTitle: "Reset zoom level 1:1",
                thousandsSep: " "
            },
            global: {},
            time: a.Time.prototype.defaultOptions,
            chart: {
                borderRadius: 0,
                defaultSeriesType: "line",
                ignoreHiddenSeries: !0,
                spacing: [
                    10,
                    10,
                    15,
                    10
                ],
                resetZoomButton: {
                    theme: {
                        zIndex: 6
                    },
                    position: {
                        align: "right",
                        x: -10,
                        y: 10
                    }
                },
                width: null,
                height: null,
                borderColor: "#335cad",
                backgroundColor: "#ffffff",
                plotBorderColor: "#cccccc"
            },
            title: {
                text: "Chart title",
                align: "center",
                margin: 15,
                widthAdjust: -44
            },
            subtitle: {
                text: "",
                align: "center",
                widthAdjust: -44
            },
            plotOptions: {},
            labels: {
                style: {
                    position: "absolute",
                    color: "#333333"
                }
            },
            legend: {
                enabled: !0,
                align: "center",
                alignColumns: !0,
                layout: "horizontal",
                labelFormatter: function() {
                    return this.name;
                },
                borderColor: "#999999",
                borderRadius: 0,
                navigation: {
                    activeColor: "#003399",
                    inactiveColor: "#cccccc"
                },
                itemStyle: {
                    color: "#333333",
                    fontSize: "12px",
                    fontWeight: "bold",
                    textOverflow: "ellipsis"
                },
                itemHoverStyle: {
                    color: "#000000"
                },
                itemHiddenStyle: {
                    color: "#cccccc"
                },
                shadow: !1,
                itemCheckboxStyle: {
                    position: "absolute",
                    width: "13px",
                    height: "13px"
                },
                squareSymbol: !0,
                symbolPadding: 5,
                verticalAlign: "bottom",
                x: 0,
                y: 0,
                title: {
                    style: {
                        fontWeight: "bold"
                    }
                }
            },
            loading: {
                labelStyle: {
                    fontWeight: "bold",
                    position: "relative",
                    top: "45%"
                },
                style: {
                    position: "absolute",
                    backgroundColor: "#ffffff",
                    opacity: .5,
                    textAlign: "center"
                }
            },
            tooltip: {
                enabled: !0,
                animation: a.svg,
                borderRadius: 3,
                dateTimeLabelFormats: {
                    millisecond: "%A, %b %e, %H:%M:%S.%L",
                    second: "%A, %b %e, %H:%M:%S",
                    minute: "%A, %b %e, %H:%M",
                    hour: "%A, %b %e, %H:%M",
                    day: "%A, %b %e, %Y",
                    week: "Week from %A, %b %e, %Y",
                    month: "%B %Y",
                    year: "%Y"
                },
                footerFormat: "",
                padding: 8,
                snap: a.isTouchDevice ? 25 : 10,
                backgroundColor: C("#f7f7f7").setOpacity(.85).get(),
                borderWidth: 1,
                headerFormat: '\x3cspan style\x3d"font-size: 10px"\x3e{point.key}\x3c/span\x3e\x3cbr/\x3e',
                pointFormat: '\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e {series.name}: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e',
                shadow: !0,
                style: {
                    color: "#333333",
                    cursor: "default",
                    fontSize: "12px",
                    pointerEvents: "none",
                    whiteSpace: "nowrap"
                }
            },
            credits: {
                enabled: !0,
                href: "https://www.highcharts.com",
                position: {
                    align: "right",
                    x: -10,
                    verticalAlign: "bottom",
                    y: -5
                },
                style: {
                    cursor: "pointer",
                    color: "#999999",
                    fontSize: "9px"
                },
                text: "Highcharts.com"
            }
        };
        a.setOptions = function(C) {
            a.defaultOptions = F(!0, a.defaultOptions, C);
            a.time.update(F(a.defaultOptions.global, a.defaultOptions.time), !1);
            return a.defaultOptions;
        };
        a.getOptions = function() {
            return a.defaultOptions;
        };
        a.defaultPlotOptions = a.defaultOptions.plotOptions;
        a.time = new a.Time(F(a.defaultOptions.global, a.defaultOptions.time));
        a.dateFormat = function(C, n, f) {
            return a.time.dateFormat(C, n, f);
        };
    })(K);
    (function(a) {
        var C = a.correctFloat, F = a.defined, I = a.destroyObjectProperties, n = a.fireEvent, f = a.isNumber, e = a.merge, u = a.pick, x = a.deg2rad;
        a.Tick = function(a, e, f, c, h) {
            this.axis = a;
            this.pos = e;
            this.type = f || "";
            this.isNewLabel = this.isNew = !0;
            this.parameters = h || {};
            this.tickmarkOffset = this.parameters.tickmarkOffset;
            this.options = this.parameters.options;
            f || c || this.addLabel();
        };
        a.Tick.prototype = {
            addLabel: function() {
                var f = this, w = f.axis, y = w.options, c = w.chart, h = w.categories, p = w.names, k = f.pos, q = u(f.options && f.options.labels, y.labels), d = w.tickPositions, b = k === d[0], v = k === d[d.length - 1], h = this.parameters.category || (h ? u(h[k], p[k], k) : k), J = f.label, d = d.info, l, n, B, D;
                w.isDatetimeAxis && d && (n = c.time.resolveDTLFormat(y.dateTimeLabelFormats[!y.grid && d.higherRanks[k] || d.unitName]), l = n.main);
                f.isFirst = b;
                f.isLast = v;
                f.formatCtx = {
                    axis: w,
                    chart: c,
                    isFirst: b,
                    isLast: v,
                    dateTimeLabelFormat: l,
                    tickPositionInfo: d,
                    value: w.isLog ? C(w.lin2log(h)) : h,
                    pos: k
                };
                y = w.labelFormatter.call(f.formatCtx, this.formatCtx);
                if (D = n && n.list) f.shortenLabel = function() {
                    for(B = 0; B < D.length; B++)if (J.attr({
                        text: w.labelFormatter.call(a.extend(f.formatCtx, {
                            dateTimeLabelFormat: D[B]
                        }))
                    }), J.getBBox().width < w.getSlotWidth(f) - 2 * u(q.padding, 5)) return;
                    J.attr({
                        text: ""
                    });
                };
                if (F(J)) J && J.textStr !== y && (!J.textWidth || q.style && q.style.width || J.styles.width || J.css({
                    width: null
                }), J.attr({
                    text: y
                }));
                else {
                    if (f.label = J = F(y) && q.enabled ? c.renderer.text(y, 0, 0, q.useHTML).css(e(q.style)).add(w.labelGroup) : null) J.textPxLength = J.getBBox().width;
                    f.rotation = 0;
                }
            },
            getLabelSize: function() {
                return this.label ? this.label.getBBox()[this.axis.horiz ? "height" : "width"] : 0;
            },
            handleOverflow: function(a) {
                var e = this.axis, f = e.options.labels, c = a.x, h = e.chart.chartWidth, p = e.chart.spacing, k = u(e.labelLeft, Math.min(e.pos, p[3])), p = u(e.labelRight, Math.max(e.isRadial ? 0 : e.pos + e.len, h - p[1])), q = this.label, d = this.rotation, b = {
                    left: 0,
                    center: .5,
                    right: 1
                }[e.labelAlign || q.attr("align")], v = q.getBBox().width, J = e.getSlotWidth(this), l = J, t = 1, B, D = {};
                if (d || "justify" !== u(f.overflow, "justify")) 0 > d && c - b * v < k ? B = Math.round(c / Math.cos(d * x) - k) : 0 < d && c + b * v > p && (B = Math.round((h - c) / Math.cos(d * x)));
                else if (h = c + (1 - b) * v, c - b * v < k ? l = a.x + l * (1 - b) - k : h > p && (l = p - a.x + l * b, t = -1), l = Math.min(J, l), l < J && "center" === e.labelAlign && (a.x += t * (J - l - b * (J - Math.min(v, l)))), v > l || e.autoRotation && (q.styles || {}).width) B = l;
                B && (this.shortenLabel ? this.shortenLabel() : (D.width = B, (f.style || {}).textOverflow || (D.textOverflow = "ellipsis"), q.css(D)));
            },
            getPosition: function(e, f, y, c) {
                var h = this.axis, p = h.chart, k = c && p.oldChartHeight || p.chartHeight;
                e = {
                    x: e ? a.correctFloat(h.translate(f + y, null, null, c) + h.transB) : h.left + h.offset + (h.opposite ? (c && p.oldChartWidth || p.chartWidth) - h.right - h.left : 0),
                    y: e ? k - h.bottom + h.offset - (h.opposite ? h.height : 0) : a.correctFloat(k - h.translate(f + y, null, null, c) - h.transB)
                };
                n(this, "afterGetPosition", {
                    pos: e
                });
                return e;
            },
            getLabelPosition: function(a, e, f, c, h, p, k, q) {
                var d = this.axis, b = d.transA, v = d.reversed, J = d.staggerLines, l = d.tickRotCorr || {
                    x: 0,
                    y: 0
                }, t = h.y, B = c || d.reserveSpaceDefault ? 0 : -d.labelOffset * ("center" === d.labelAlign ? .5 : 1), D = {};
                F(t) || (t = 0 === d.side ? f.rotation ? -8 : -f.getBBox().height : 2 === d.side ? l.y + 8 : Math.cos(f.rotation * x) * (l.y - f.getBBox(!1, 0).height / 2));
                a = a + h.x + B + l.x - (p && c ? p * b * (v ? -1 : 1) : 0);
                e = e + t - (p && !c ? p * b * (v ? 1 : -1) : 0);
                J && (f = k / (q || 1) % J, d.opposite && (f = J - f - 1), e += d.labelOffset / J * f);
                D.x = a;
                D.y = Math.round(e);
                n(this, "afterGetLabelPosition", {
                    pos: D
                });
                return D;
            },
            getMarkPath: function(a, e, f, c, h, p) {
                return p.crispLine([
                    "M",
                    a,
                    e,
                    "L",
                    a + (h ? 0 : -f),
                    e + (h ? f : 0)
                ], c);
            },
            renderGridLine: function(a, e, f) {
                var c = this.axis, h = c.options, p = this.gridLine, k = {}, q = this.pos, d = this.type, b = u(this.tickmarkOffset, c.tickmarkOffset), v = c.chart.renderer, J = d ? d + "Grid" : "grid", l = h[J + "LineWidth"], t = h[J + "LineColor"], h = h[J + "LineDashStyle"];
                p || (k.stroke = t, k["stroke-width"] = l, h && (k.dashstyle = h), d || (k.zIndex = 1), a && (e = 0), this.gridLine = p = v.path().attr(k).addClass("highcharts-" + (d ? d + "-" : "") + "grid-line").add(c.gridGroup));
                if (p && (f = c.getPlotLinePath(q + b, p.strokeWidth() * f, a, "pass"))) p[a || this.isNew ? "attr" : "animate"]({
                    d: f,
                    opacity: e
                });
            },
            renderMark: function(a, e, f) {
                var c = this.axis, h = c.options, p = c.chart.renderer, k = this.type, q = k ? k + "Tick" : "tick", d = c.tickSize(q), b = this.mark, v = !b, J = a.x;
                a = a.y;
                var l = u(h[q + "Width"], !k && c.isXAxis ? 1 : 0), h = h[q + "Color"];
                d && (c.opposite && (d[0] = -d[0]), v && (this.mark = b = p.path().addClass("highcharts-" + (k ? k + "-" : "") + "tick").add(c.axisGroup), b.attr({
                    stroke: h,
                    "stroke-width": l
                })), b[v ? "attr" : "animate"]({
                    d: this.getMarkPath(J, a, d[0], b.strokeWidth() * f, c.horiz, p),
                    opacity: e
                }));
            },
            renderLabel: function(a, e, y, c) {
                var h = this.axis, p = h.horiz, k = h.options, q = this.label, d = k.labels, b = d.step, h = u(this.tickmarkOffset, h.tickmarkOffset), v = !0, J = a.x;
                a = a.y;
                q && f(J) && (q.xy = a = this.getLabelPosition(J, a, q, p, d, h, c, b), this.isFirst && !this.isLast && !u(k.showFirstLabel, 1) || this.isLast && !this.isFirst && !u(k.showLastLabel, 1) ? v = !1 : !p || d.step || d.rotation || e || 0 === y || this.handleOverflow(a), b && c % b && (v = !1), v && f(a.y) ? (a.opacity = y, q[this.isNewLabel ? "attr" : "animate"](a), this.isNewLabel = !1) : (q.attr("y", -9999), this.isNewLabel = !0));
            },
            render: function(e, f, y) {
                var c = this.axis, h = c.horiz, p = this.pos, k = u(this.tickmarkOffset, c.tickmarkOffset), p = this.getPosition(h, p, k, f), k = p.x, q = p.y, c = h && k === c.pos + c.len || !h && q === c.pos ? -1 : 1;
                y = u(y, 1);
                this.isActive = !0;
                this.renderGridLine(f, y, c);
                this.renderMark(p, y, c);
                this.renderLabel(p, f, y, e);
                this.isNew = !1;
                a.fireEvent(this, "afterRender");
            },
            destroy: function() {
                I(this, this.axis);
            }
        };
    })(K);
    var W = function(a) {
        var C = a.addEvent, F = a.animObject, I = a.arrayMax, n = a.arrayMin, f = a.color, e = a.correctFloat, u = a.defaultOptions, x = a.defined, t = a.deg2rad, w = a.destroyObjectProperties, y = a.each, c = a.extend, h = a.fireEvent, p = a.format, k = a.getMagnitude, q = a.grep, d = a.inArray, b = a.isArray, v = a.isNumber, J = a.isString, l = a.merge, L = a.normalizeTickInterval, B = a.objectEach, D = a.pick, m = a.removeEvent, G = a.splat, A = a.syncTimeout, N = a.Tick, E = function() {
            this.init.apply(this, arguments);
        };
        a.extend(E.prototype, {
            defaultOptions: {
                dateTimeLabelFormats: {
                    millisecond: {
                        main: "%H:%M:%S.%L",
                        range: !1
                    },
                    second: {
                        main: "%H:%M:%S",
                        range: !1
                    },
                    minute: {
                        main: "%H:%M",
                        range: !1
                    },
                    hour: {
                        main: "%H:%M",
                        range: !1
                    },
                    day: {
                        main: "%e. %b"
                    },
                    week: {
                        main: "%e. %b"
                    },
                    month: {
                        main: "%b '%y"
                    },
                    year: {
                        main: "%Y"
                    }
                },
                endOnTick: !1,
                labels: {
                    enabled: !0,
                    indentation: 10,
                    x: 0,
                    style: {
                        color: "#666666",
                        cursor: "default",
                        fontSize: "11px"
                    }
                },
                maxPadding: .01,
                minorTickLength: 2,
                minorTickPosition: "outside",
                minPadding: .01,
                startOfWeek: 1,
                startOnTick: !1,
                tickLength: 10,
                tickPixelInterval: 100,
                tickmarkPlacement: "between",
                tickPosition: "outside",
                title: {
                    align: "middle",
                    style: {
                        color: "#666666"
                    }
                },
                type: "linear",
                minorGridLineColor: "#f2f2f2",
                minorGridLineWidth: 1,
                minorTickColor: "#999999",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                gridLineColor: "#e6e6e6",
                tickColor: "#ccd6eb"
            },
            defaultYAxisOptions: {
                endOnTick: !0,
                maxPadding: .05,
                minPadding: .05,
                tickPixelInterval: 72,
                showLastLabel: !0,
                labels: {
                    x: -8
                },
                startOnTick: !0,
                title: {
                    rotation: 270,
                    text: "Values"
                },
                stackLabels: {
                    allowOverlap: !1,
                    enabled: !1,
                    formatter: function() {
                        return a.numberFormat(this.total, -1);
                    },
                    style: {
                        color: "#000000",
                        fontSize: "11px",
                        fontWeight: "bold",
                        textOutline: "1px contrast"
                    }
                },
                gridLineWidth: 1,
                lineWidth: 0
            },
            defaultLeftAxisOptions: {
                labels: {
                    x: -15
                },
                title: {
                    rotation: 270
                }
            },
            defaultRightAxisOptions: {
                labels: {
                    x: 15
                },
                title: {
                    rotation: 90
                }
            },
            defaultBottomAxisOptions: {
                labels: {
                    autoRotation: [
                        -45
                    ],
                    x: 0
                },
                title: {
                    rotation: 0
                }
            },
            defaultTopAxisOptions: {
                labels: {
                    autoRotation: [
                        -45
                    ],
                    x: 0
                },
                title: {
                    rotation: 0
                }
            },
            init: function(a, r) {
                var g = r.isX, b = this;
                b.chart = a;
                b.horiz = a.inverted && !b.isZAxis ? !g : g;
                b.isXAxis = g;
                b.coll = b.coll || (g ? "xAxis" : "yAxis");
                h(this, "init", {
                    userOptions: r
                });
                b.opposite = r.opposite;
                b.side = r.side || (b.horiz ? b.opposite ? 0 : 2 : b.opposite ? 1 : 3);
                b.setOptions(r);
                var c = this.options, m = c.type;
                b.labelFormatter = c.labels.formatter || b.defaultLabelFormatter;
                b.userOptions = r;
                b.minPixelPadding = 0;
                b.reversed = c.reversed;
                b.visible = !1 !== c.visible;
                b.zoomEnabled = !1 !== c.zoomEnabled;
                b.hasNames = "category" === m || !0 === c.categories;
                b.categories = c.categories || b.hasNames;
                b.names || (b.names = [], b.names.keys = {});
                b.plotLinesAndBandsGroups = {};
                b.isLog = "logarithmic" === m;
                b.isDatetimeAxis = "datetime" === m;
                b.positiveValuesOnly = b.isLog && !b.allowNegativeLog;
                b.isLinked = x(c.linkedTo);
                b.ticks = {};
                b.labelEdge = [];
                b.minorTicks = {};
                b.plotLinesAndBands = [];
                b.alternateBands = {};
                b.len = 0;
                b.minRange = b.userMinRange = c.minRange || c.maxZoom;
                b.range = c.range;
                b.offset = c.offset || 0;
                b.stacks = {};
                b.oldStacks = {};
                b.stacksTouched = 0;
                b.max = null;
                b.min = null;
                b.crosshair = D(c.crosshair, G(a.options.tooltip.crosshairs)[g ? 0 : 1], !1);
                r = b.options.events;
                -1 === d(b, a.axes) && (g ? a.axes.splice(a.xAxis.length, 0, b) : a.axes.push(b), a[b.coll].push(b));
                b.series = b.series || [];
                a.inverted && !b.isZAxis && g && void 0 === b.reversed && (b.reversed = !0);
                B(r, function(a, g) {
                    C(b, g, a);
                });
                b.lin2log = c.linearToLogConverter || b.lin2log;
                b.isLog && (b.val2lin = b.log2lin, b.lin2val = b.lin2log);
                h(this, "afterInit");
            },
            setOptions: function(a) {
                this.options = l(this.defaultOptions, "yAxis" === this.coll && this.defaultYAxisOptions, [
                    this.defaultTopAxisOptions,
                    this.defaultRightAxisOptions,
                    this.defaultBottomAxisOptions,
                    this.defaultLeftAxisOptions
                ][this.side], l(u[this.coll], a));
                h(this, "afterSetOptions", {
                    userOptions: a
                });
            },
            defaultLabelFormatter: function() {
                var g = this.axis, r = this.value, b = g.chart.time, d = g.categories, c = this.dateTimeLabelFormat, m = u.lang, k = m.numericSymbols, m = m.numericSymbolMagnitude || 1E3, h = k && k.length, l, q = g.options.labels.format, g = g.isLog ? Math.abs(r) : g.tickInterval;
                if (q) l = p(q, this, b);
                else if (d) l = r;
                else if (c) l = b.dateFormat(c, r);
                else if (h && 1E3 <= g) for(; h-- && void 0 === l;)b = Math.pow(m, h + 1), g >= b && 0 === 10 * r % b && null !== k[h] && 0 !== r && (l = a.numberFormat(r / b, -1) + k[h]);
                void 0 === l && (l = 1E4 <= Math.abs(r) ? a.numberFormat(r, -1) : a.numberFormat(r, -1, void 0, ""));
                return l;
            },
            getSeriesExtremes: function() {
                var a = this, r = a.chart;
                h(this, "getSeriesExtremes", null, function() {
                    a.hasVisibleSeries = !1;
                    a.dataMin = a.dataMax = a.threshold = null;
                    a.softThreshold = !a.isXAxis;
                    a.buildStacks && a.buildStacks();
                    y(a.series, function(g) {
                        if (g.visible || !r.options.chart.ignoreHiddenSeries) {
                            var b = g.options, d = b.threshold, c;
                            a.hasVisibleSeries = !0;
                            a.positiveValuesOnly && 0 >= d && (d = null);
                            if (a.isXAxis) b = g.xData, b.length && (g = n(b), c = I(b), v(g) || g instanceof Date || (b = q(b, v), g = n(b), c = I(b)), b.length && (a.dataMin = Math.min(D(a.dataMin, b[0], g), g), a.dataMax = Math.max(D(a.dataMax, b[0], c), c)));
                            else if (g.getExtremes(), c = g.dataMax, g = g.dataMin, x(g) && x(c) && (a.dataMin = Math.min(D(a.dataMin, g), g), a.dataMax = Math.max(D(a.dataMax, c), c)), x(d) && (a.threshold = d), !b.softThreshold || a.positiveValuesOnly) a.softThreshold = !1;
                        }
                    });
                });
                h(this, "afterGetSeriesExtremes");
            },
            translate: function(a, r, b, d, c, m) {
                var g = this.linkedParent || this, k = 1, H = 0, l = d ? g.oldTransA : g.transA;
                d = d ? g.oldMin : g.min;
                var h = g.minPixelPadding;
                c = (g.isOrdinal || g.isBroken || g.isLog && c) && g.lin2val;
                l || (l = g.transA);
                b && (k *= -1, H = g.len);
                g.reversed && (k *= -1, H -= k * (g.sector || g.len));
                r ? (a = (a * k + H - h) / l + d, c && (a = g.lin2val(a))) : (c && (a = g.val2lin(a)), a = v(d) ? k * (a - d) * l + H + k * h + (v(m) ? l * m : 0) : void 0);
                return a;
            },
            toPixels: function(a, r) {
                return this.translate(a, !1, !this.horiz, null, !0) + (r ? 0 : this.pos);
            },
            toValue: function(a, r) {
                return this.translate(a - (r ? 0 : this.pos), !0, !this.horiz, null, !0);
            },
            getPlotLinePath: function(a, r, b, d, c) {
                var g = this.chart, m = this.left, k = this.top, H, l, h = b && g.oldChartHeight || g.chartHeight, q = b && g.oldChartWidth || g.chartWidth, A;
                H = this.transB;
                var e = function(a, g, r) {
                    if ("pass" !== d && a < g || a > r) d ? a = Math.min(Math.max(g, a), r) : A = !0;
                    return a;
                };
                c = D(c, this.translate(a, null, null, b));
                c = Math.min(Math.max(-100000, c), 1E5);
                a = b = Math.round(c + H);
                H = l = Math.round(h - c - H);
                v(c) ? this.horiz ? (H = k, l = h - this.bottom, a = b = e(a, m, m + this.width)) : (a = m, b = q - this.right, H = l = e(H, k, k + this.height)) : (A = !0, d = !1);
                return A && !d ? null : g.renderer.crispLine([
                    "M",
                    a,
                    H,
                    "L",
                    b,
                    l
                ], r || 1);
            },
            getLinearTickPositions: function(a, r, b) {
                var g, d = e(Math.floor(r / a) * a);
                b = e(Math.ceil(b / a) * a);
                var c = [], m;
                e(d + a) === d && (m = 20);
                if (this.single) return [
                    r
                ];
                for(r = d; r <= b;){
                    c.push(r);
                    r = e(r + a, m);
                    if (r === g) break;
                    g = r;
                }
                return c;
            },
            getMinorTickInterval: function() {
                var a = this.options;
                return !0 === a.minorTicks ? D(a.minorTickInterval, "auto") : !1 === a.minorTicks ? null : a.minorTickInterval;
            },
            getMinorTickPositions: function() {
                var a = this, r = a.options, b = a.tickPositions, d = a.minorTickInterval, c = [], m = a.pointRangePadding || 0, k = a.min - m, m = a.max + m, l = m - k;
                if (l && l / d < a.len / 3) {
                    if (a.isLog) y(this.paddedTicks, function(g, r, b) {
                        r && c.push.apply(c, a.getLogTickPositions(d, b[r - 1], b[r], !0));
                    });
                    else if (a.isDatetimeAxis && "auto" === this.getMinorTickInterval()) c = c.concat(a.getTimeTicks(a.normalizeTimeTickInterval(d), k, m, r.startOfWeek));
                    else for(r = k + (b[0] - k) % d; r <= m && r !== c[0]; r += d)c.push(r);
                }
                0 !== c.length && a.trimTicks(c);
                return c;
            },
            adjustForMinRange: function() {
                var a = this.options, r = this.min, b = this.max, d, c, m, k, l, h, q, v;
                this.isXAxis && void 0 === this.minRange && !this.isLog && (x(a.min) || x(a.max) ? this.minRange = null : (y(this.series, function(a) {
                    h = a.xData;
                    for(k = q = a.xIncrement ? 1 : h.length - 1; 0 < k; k--)if (l = h[k] - h[k - 1], void 0 === m || l < m) m = l;
                }), this.minRange = Math.min(5 * m, this.dataMax - this.dataMin)));
                b - r < this.minRange && (c = this.dataMax - this.dataMin >= this.minRange, v = this.minRange, d = (v - b + r) / 2, d = [
                    r - d,
                    D(a.min, r - d)
                ], c && (d[2] = this.isLog ? this.log2lin(this.dataMin) : this.dataMin), r = I(d), b = [
                    r + v,
                    D(a.max, r + v)
                ], c && (b[2] = this.isLog ? this.log2lin(this.dataMax) : this.dataMax), b = n(b), b - r < v && (d[0] = b - v, d[1] = D(a.min, b - v), r = I(d)));
                this.min = r;
                this.max = b;
            },
            getClosest: function() {
                var a;
                this.categories ? a = 1 : y(this.series, function(g) {
                    var r = g.closestPointRange, b = g.visible || !g.chart.options.chart.ignoreHiddenSeries;
                    !g.noSharedTooltip && x(r) && b && (a = x(a) ? Math.min(a, r) : r);
                });
                return a;
            },
            nameToX: function(a) {
                var g = b(this.categories), c = g ? this.categories : this.names, m = a.options.x, k;
                a.series.requireSorting = !1;
                x(m) || (m = !1 === this.options.uniqueNames ? a.series.autoIncrement() : g ? d(a.name, c) : D(c.keys[a.name], -1));
                -1 === m ? g || (k = c.length) : k = m;
                void 0 !== k && (this.names[k] = a.name, this.names.keys[a.name] = k);
                return k;
            },
            updateNames: function() {
                var g = this, r = this.names;
                0 < r.length && (y(a.keys(r.keys), function(a) {
                    delete r.keys[a];
                }), r.length = 0, this.minRange = this.userMinRange, y(this.series || [], function(a) {
                    a.xIncrement = null;
                    if (!a.points || a.isDirtyData) a.processData(), a.generatePoints();
                    y(a.points, function(r, b) {
                        var d;
                        r.options && (d = g.nameToX(r), void 0 !== d && d !== r.x && (r.x = d, a.xData[b] = d));
                    });
                }));
            },
            setAxisTranslation: function(a) {
                var g = this, b = g.max - g.min, d = g.axisPointRange || 0, c, m = 0, k = 0, l = g.linkedParent, q = !!g.categories, v = g.transA, A = g.isXAxis;
                if (A || q || d) c = g.getClosest(), l ? (m = l.minPointOffset, k = l.pointRangePadding) : y(g.series, function(a) {
                    var b = q ? 1 : A ? D(a.options.pointRange, c, 0) : g.axisPointRange || 0;
                    a = a.options.pointPlacement;
                    d = Math.max(d, b);
                    g.single || (m = Math.max(m, J(a) ? 0 : b / 2), k = Math.max(k, "on" === a ? 0 : b));
                }), l = g.ordinalSlope && c ? g.ordinalSlope / c : 1, g.minPointOffset = m *= l, g.pointRangePadding = k *= l, g.pointRange = Math.min(d, b), A && (g.closestPointRange = c);
                a && (g.oldTransA = v);
                g.translationSlope = g.transA = v = g.staticScale || g.len / (b + k || 1);
                g.transB = g.horiz ? g.left : g.bottom;
                g.minPixelPadding = v * m;
                h(this, "afterSetAxisTranslation");
            },
            minFromRange: function() {
                return this.max - this.range;
            },
            setTickInterval: function(g) {
                var b = this, d = b.chart, c = b.options, m = b.isLog, l = b.isDatetimeAxis, q = b.isXAxis, A = b.isLinked, p = c.maxPadding, f = c.minPadding, G = c.tickInterval, B = c.tickPixelInterval, J = b.categories, E = v(b.threshold) ? b.threshold : null, N = b.softThreshold, w, t, u, n;
                l || J || A || this.getTickAmount();
                u = D(b.userMin, c.min);
                n = D(b.userMax, c.max);
                A ? (b.linkedParent = d[b.coll][c.linkedTo], d = b.linkedParent.getExtremes(), b.min = D(d.min, d.dataMin), b.max = D(d.max, d.dataMax), c.type !== b.linkedParent.options.type && a.error(11, 1)) : (!N && x(E) && (b.dataMin >= E ? (w = E, f = 0) : b.dataMax <= E && (t = E, p = 0)), b.min = D(u, w, b.dataMin), b.max = D(n, t, b.dataMax));
                m && (b.positiveValuesOnly && !g && 0 >= Math.min(b.min, D(b.dataMin, b.min)) && a.error(10, 1), b.min = e(b.log2lin(b.min), 15), b.max = e(b.log2lin(b.max), 15));
                b.range && x(b.max) && (b.userMin = b.min = u = Math.max(b.dataMin, b.minFromRange()), b.userMax = n = b.max, b.range = null);
                h(b, "foundExtremes");
                b.beforePadding && b.beforePadding();
                b.adjustForMinRange();
                !(J || b.axisPointRange || b.usePercentage || A) && x(b.min) && x(b.max) && (d = b.max - b.min) && (!x(u) && f && (b.min -= d * f), !x(n) && p && (b.max += d * p));
                v(c.softMin) && !v(b.userMin) && (b.min = Math.min(b.min, c.softMin));
                v(c.softMax) && !v(b.userMax) && (b.max = Math.max(b.max, c.softMax));
                v(c.floor) && (b.min = Math.max(b.min, c.floor));
                v(c.ceiling) && (b.max = Math.min(b.max, c.ceiling));
                N && x(b.dataMin) && (E = E || 0, !x(u) && b.min < E && b.dataMin >= E ? b.min = E : !x(n) && b.max > E && b.dataMax <= E && (b.max = E));
                b.tickInterval = b.min === b.max || void 0 === b.min || void 0 === b.max ? 1 : A && !G && B === b.linkedParent.options.tickPixelInterval ? G = b.linkedParent.tickInterval : D(G, this.tickAmount ? (b.max - b.min) / Math.max(this.tickAmount - 1, 1) : void 0, J ? 1 : (b.max - b.min) * B / Math.max(b.len, B));
                q && !g && y(b.series, function(a) {
                    a.processData(b.min !== b.oldMin || b.max !== b.oldMax);
                });
                b.setAxisTranslation(!0);
                b.beforeSetTickPositions && b.beforeSetTickPositions();
                b.postProcessTickInterval && (b.tickInterval = b.postProcessTickInterval(b.tickInterval));
                b.pointRange && !G && (b.tickInterval = Math.max(b.pointRange, b.tickInterval));
                g = D(c.minTickInterval, b.isDatetimeAxis && b.closestPointRange);
                !G && b.tickInterval < g && (b.tickInterval = g);
                l || m || G || (b.tickInterval = L(b.tickInterval, null, k(b.tickInterval), D(c.allowDecimals, !(.5 < b.tickInterval && 5 > b.tickInterval && 1E3 < b.max && 9999 > b.max)), !!this.tickAmount));
                this.tickAmount || (b.tickInterval = b.unsquish());
                this.setTickPositions();
            },
            setTickPositions: function() {
                var g = this.options, b, d = g.tickPositions;
                b = this.getMinorTickInterval();
                var c = g.tickPositioner, m = g.startOnTick, k = g.endOnTick;
                this.tickmarkOffset = this.categories && "between" === g.tickmarkPlacement && 1 === this.tickInterval ? .5 : 0;
                this.minorTickInterval = "auto" === b && this.tickInterval ? this.tickInterval / 5 : b;
                this.single = this.min === this.max && x(this.min) && !this.tickAmount && (parseInt(this.min, 10) === this.min || !1 !== g.allowDecimals);
                this.tickPositions = b = d && d.slice();
                !b && (!this.ordinalPositions && (this.max - this.min) / this.tickInterval > Math.max(2 * this.len, 200) ? (b = [
                    this.min,
                    this.max
                ], a.error(19)) : b = this.isDatetimeAxis ? this.getTimeTicks(this.normalizeTimeTickInterval(this.tickInterval, g.units), this.min, this.max, g.startOfWeek, this.ordinalPositions, this.closestPointRange, !0) : this.isLog ? this.getLogTickPositions(this.tickInterval, this.min, this.max) : this.getLinearTickPositions(this.tickInterval, this.min, this.max), b.length > this.len && (b = [
                    b[0],
                    b.pop()
                ], b[0] === b[1] && (b.length = 1)), this.tickPositions = b, c && (c = c.apply(this, [
                    this.min,
                    this.max
                ]))) && (this.tickPositions = b = c);
                this.paddedTicks = b.slice(0);
                this.trimTicks(b, m, k);
                this.isLinked || (this.single && 2 > b.length && (this.min -= .5, this.max += .5), d || c || this.adjustTickAmount());
                h(this, "afterSetTickPositions");
            },
            trimTicks: function(a, b, d) {
                var g = a[0], c = a[a.length - 1], m = this.minPointOffset || 0;
                if (!this.isLinked) {
                    if (b && -Infinity !== g) this.min = g;
                    else for(; this.min - m > a[0];)a.shift();
                    if (d) this.max = c;
                    else for(; this.max + m < a[a.length - 1];)a.pop();
                    0 === a.length && x(g) && !this.options.tickPositions && a.push((c + g) / 2);
                }
            },
            alignToOthers: function() {
                var a = {}, b, d = this.options;
                !1 === this.chart.options.chart.alignTicks || !1 === d.alignTicks || !1 === d.startOnTick || !1 === d.endOnTick || this.isLog || y(this.chart[this.coll], function(g) {
                    var d = g.options, d = [
                        g.horiz ? d.left : d.top,
                        d.width,
                        d.height,
                        d.pane
                    ].join();
                    g.series.length && (a[d] ? b = !0 : a[d] = 1);
                });
                return b;
            },
            getTickAmount: function() {
                var a = this.options, b = a.tickAmount, d = a.tickPixelInterval;
                !x(a.tickInterval) && this.len < d && !this.isRadial && !this.isLog && a.startOnTick && a.endOnTick && (b = 2);
                !b && this.alignToOthers() && (b = Math.ceil(this.len / d) + 1);
                4 > b && (this.finalTickAmt = b, b = 5);
                this.tickAmount = b;
            },
            adjustTickAmount: function() {
                var a = this.tickInterval, b = this.tickPositions, d = this.tickAmount, c = this.finalTickAmt, m = b && b.length, k = D(this.threshold, this.softThreshold ? 0 : null);
                if (this.hasData()) {
                    if (m < d) {
                        for(; b.length < d;)b.length % 2 || this.min === k ? b.push(e(b[b.length - 1] + a)) : b.unshift(e(b[0] - a));
                        this.transA *= (m - 1) / (d - 1);
                        this.min = b[0];
                        this.max = b[b.length - 1];
                    } else m > d && (this.tickInterval *= 2, this.setTickPositions());
                    if (x(c)) {
                        for(a = d = b.length; a--;)(3 === c && 1 === a % 2 || 2 >= c && 0 < a && a < d - 1) && b.splice(a, 1);
                        this.finalTickAmt = void 0;
                    }
                }
            },
            setScale: function() {
                var a, b;
                this.oldMin = this.min;
                this.oldMax = this.max;
                this.oldAxisLength = this.len;
                this.setAxisSize();
                b = this.len !== this.oldAxisLength;
                y(this.series, function(b) {
                    if (b.isDirtyData || b.isDirty || b.xAxis.isDirty) a = !0;
                });
                b || a || this.isLinked || this.forceRedraw || this.userMin !== this.oldUserMin || this.userMax !== this.oldUserMax || this.alignToOthers() ? (this.resetStacks && this.resetStacks(), this.forceRedraw = !1, this.getSeriesExtremes(), this.setTickInterval(), this.oldUserMin = this.userMin, this.oldUserMax = this.userMax, this.isDirty || (this.isDirty = b || this.min !== this.oldMin || this.max !== this.oldMax)) : this.cleanStacks && this.cleanStacks();
                h(this, "afterSetScale");
            },
            setExtremes: function(a, b, d, m, k) {
                var g = this, r = g.chart;
                d = D(d, !0);
                y(g.series, function(a) {
                    delete a.kdTree;
                });
                k = c(k, {
                    min: a,
                    max: b
                });
                h(g, "setExtremes", k, function() {
                    g.userMin = a;
                    g.userMax = b;
                    g.eventArgs = k;
                    d && r.redraw(m);
                });
            },
            zoom: function(a, b) {
                var g = this.dataMin, d = this.dataMax, c = this.options, m = Math.min(g, D(c.min, g)), c = Math.max(d, D(c.max, d));
                if (a !== this.min || b !== this.max) this.allowZoomOutside || (x(g) && (a < m && (a = m), a > c && (a = c)), x(d) && (b < m && (b = m), b > c && (b = c))), this.displayBtn = void 0 !== a || void 0 !== b, this.setExtremes(a, b, !1, void 0, {
                    trigger: "zoom"
                });
                return !0;
            },
            setAxisSize: function() {
                var b = this.chart, d = this.options, c = d.offsets || [
                    0,
                    0,
                    0,
                    0
                ], m = this.horiz, k = this.width = Math.round(a.relativeLength(D(d.width, b.plotWidth - c[3] + c[1]), b.plotWidth)), l = this.height = Math.round(a.relativeLength(D(d.height, b.plotHeight - c[0] + c[2]), b.plotHeight)), h = this.top = Math.round(a.relativeLength(D(d.top, b.plotTop + c[0]), b.plotHeight, b.plotTop)), d = this.left = Math.round(a.relativeLength(D(d.left, b.plotLeft + c[3]), b.plotWidth, b.plotLeft));
                this.bottom = b.chartHeight - l - h;
                this.right = b.chartWidth - k - d;
                this.len = Math.max(m ? k : l, 0);
                this.pos = m ? d : h;
            },
            getExtremes: function() {
                var a = this.isLog;
                return {
                    min: a ? e(this.lin2log(this.min)) : this.min,
                    max: a ? e(this.lin2log(this.max)) : this.max,
                    dataMin: this.dataMin,
                    dataMax: this.dataMax,
                    userMin: this.userMin,
                    userMax: this.userMax
                };
            },
            getThreshold: function(a) {
                var b = this.isLog, g = b ? this.lin2log(this.min) : this.min, b = b ? this.lin2log(this.max) : this.max;
                null === a || -Infinity === a ? a = g : Infinity === a ? a = b : g > a ? a = g : b < a && (a = b);
                return this.translate(a, 0, 1, 0, 1);
            },
            autoLabelAlign: function(a) {
                a = (D(a, 0) - 90 * this.side + 720) % 360;
                return 15 < a && 165 > a ? "right" : 195 < a && 345 > a ? "left" : "center";
            },
            tickSize: function(a) {
                var b = this.options, g = b[a + "Length"], d = D(b[a + "Width"], "tick" === a && this.isXAxis ? 1 : 0);
                if (d && g) return "inside" === b[a + "Position"] && (g = -g), [
                    g,
                    d
                ];
            },
            labelMetrics: function() {
                var a = this.tickPositions && this.tickPositions[0] || 0;
                return this.chart.renderer.fontMetrics(this.options.labels.style && this.options.labels.style.fontSize, this.ticks[a] && this.ticks[a].label);
            },
            unsquish: function() {
                var a = this.options.labels, b = this.horiz, d = this.tickInterval, c = d, m = this.len / (((this.categories ? 1 : 0) + this.max - this.min) / d), k, l = a.rotation, h = this.labelMetrics(), q, v = Number.MAX_VALUE, A, p = function(a) {
                    a /= m || 1;
                    a = 1 < a ? Math.ceil(a) : 1;
                    return e(a * d);
                };
                b ? (A = !a.staggerLines && !a.step && (x(l) ? [
                    l
                ] : m < D(a.autoRotationLimit, 80) && a.autoRotation)) && y(A, function(a) {
                    var b;
                    if (a === l || a && -90 <= a && 90 >= a) q = p(Math.abs(h.h / Math.sin(t * a))), b = q + Math.abs(a / 360), b < v && (v = b, k = a, c = q);
                }) : a.step || (c = p(h.h));
                this.autoRotation = A;
                this.labelRotation = D(k, l);
                return c;
            },
            getSlotWidth: function(a) {
                var b = this.chart, g = this.horiz, d = this.options.labels, c = Math.max(this.tickPositions.length - (this.categories ? 0 : 1), 1), m = b.margin[3];
                return a && a.slotWidth || g && 2 > (d.step || 0) && !d.rotation && (this.staggerLines || 1) * this.len / c || !g && (d.style && parseInt(d.style.width, 10) || m && m - b.spacing[3] || .33 * b.chartWidth);
            },
            renderUnsquish: function() {
                var a = this.chart, b = a.renderer, d = this.tickPositions, c = this.ticks, m = this.options.labels, k = m && m.style || {}, l = this.horiz, h = this.getSlotWidth(), q = Math.max(1, Math.round(h - 2 * (m.padding || 5))), v = {}, A = this.labelMetrics(), e = m.style && m.style.textOverflow, p, f, G = 0, B;
                J(m.rotation) || (v.rotation = m.rotation || 0);
                y(d, function(a) {
                    (a = c[a]) && a.label && a.label.textPxLength > G && (G = a.label.textPxLength);
                });
                this.maxLabelLength = G;
                if (this.autoRotation) G > q && G > A.h ? v.rotation = this.labelRotation : this.labelRotation = 0;
                else if (h && (p = q, !e)) {
                    for(f = "clip", q = d.length; !l && q--;)if (B = d[q], B = c[B].label) B.styles && "ellipsis" === B.styles.textOverflow ? B.css({
                        textOverflow: "clip"
                    }) : B.textPxLength > h && B.css({
                        width: h + "px"
                    }), B.getBBox().height > this.len / d.length - (A.h - A.f) && (B.specificTextOverflow = "ellipsis");
                }
                v.rotation && (p = G > .5 * a.chartHeight ? .33 * a.chartHeight : G, e || (f = "ellipsis"));
                if (this.labelAlign = m.align || this.autoLabelAlign(this.labelRotation)) v.align = this.labelAlign;
                y(d, function(a) {
                    var b = (a = c[a]) && a.label, g = k.width, d = {};
                    b && (b.attr(v), a.shortenLabel ? a.shortenLabel() : p && !g && "nowrap" !== k.whiteSpace && (p < b.textPxLength || "SPAN" === b.element.tagName) ? (d.width = p, e || (d.textOverflow = b.specificTextOverflow || f), b.css(d)) : b.styles && b.styles.width && !d.width && !g && b.css({
                        width: null
                    }), delete b.specificTextOverflow, a.rotation = v.rotation);
                }, this);
                this.tickRotCorr = b.rotCorr(A.b, this.labelRotation || 0, 0 !== this.side);
            },
            hasData: function() {
                return this.hasVisibleSeries || x(this.min) && x(this.max) && this.tickPositions && 0 < this.tickPositions.length;
            },
            addTitle: function(a) {
                var b = this.chart.renderer, g = this.horiz, d = this.opposite, c = this.options.title, m;
                this.axisTitle || ((m = c.textAlign) || (m = (g ? {
                    low: "left",
                    middle: "center",
                    high: "right"
                } : {
                    low: d ? "right" : "left",
                    middle: "center",
                    high: d ? "left" : "right"
                })[c.align]), this.axisTitle = b.text(c.text, 0, 0, c.useHTML).attr({
                    zIndex: 7,
                    rotation: c.rotation || 0,
                    align: m
                }).addClass("highcharts-axis-title").css(l(c.style)).add(this.axisGroup), this.axisTitle.isNew = !0);
                c.style.width || this.isRadial || this.axisTitle.css({
                    width: this.len
                });
                this.axisTitle[a ? "show" : "hide"](!0);
            },
            generateTick: function(a) {
                var b = this.ticks;
                b[a] ? b[a].addLabel() : b[a] = new N(this, a);
            },
            getOffset: function() {
                var a = this, b = a.chart, d = b.renderer, c = a.options, m = a.tickPositions, k = a.ticks, l = a.horiz, q = a.side, v = b.inverted && !a.isZAxis ? [
                    1,
                    0,
                    3,
                    2
                ][q] : q, A, e, p = 0, G, f = 0, J = c.title, E = c.labels, N = 0, w = b.axisOffset, b = b.clipOffset, t = [
                    -1,
                    1,
                    1,
                    -1
                ][q], u = c.className, n = a.axisParent;
                A = a.hasData();
                a.showAxis = e = A || D(c.showEmpty, !0);
                a.staggerLines = a.horiz && E.staggerLines;
                a.axisGroup || (a.gridGroup = d.g("grid").attr({
                    zIndex: c.gridZIndex || 1
                }).addClass("highcharts-" + this.coll.toLowerCase() + "-grid " + (u || "")).add(n), a.axisGroup = d.g("axis").attr({
                    zIndex: c.zIndex || 2
                }).addClass("highcharts-" + this.coll.toLowerCase() + " " + (u || "")).add(n), a.labelGroup = d.g("axis-labels").attr({
                    zIndex: E.zIndex || 7
                }).addClass("highcharts-" + a.coll.toLowerCase() + "-labels " + (u || "")).add(n));
                A || a.isLinked ? (y(m, function(b, g) {
                    a.generateTick(b, g);
                }), a.renderUnsquish(), a.reserveSpaceDefault = 0 === q || 2 === q || ({
                    1: "left",
                    3: "right"
                })[q] === a.labelAlign, D(E.reserveSpace, "center" === a.labelAlign ? !0 : null, a.reserveSpaceDefault) && y(m, function(a) {
                    N = Math.max(k[a].getLabelSize(), N);
                }), a.staggerLines && (N *= a.staggerLines), a.labelOffset = N * (a.opposite ? -1 : 1)) : B(k, function(a, b) {
                    a.destroy();
                    delete k[b];
                });
                J && J.text && !1 !== J.enabled && (a.addTitle(e), e && !1 !== J.reserveSpace && (a.titleOffset = p = a.axisTitle.getBBox()[l ? "height" : "width"], G = J.offset, f = x(G) ? 0 : D(J.margin, l ? 5 : 10)));
                a.renderLine();
                a.offset = t * D(c.offset, w[q]);
                a.tickRotCorr = a.tickRotCorr || {
                    x: 0,
                    y: 0
                };
                d = 0 === q ? -a.labelMetrics().h : 2 === q ? a.tickRotCorr.y : 0;
                f = Math.abs(N) + f;
                N && (f = f - d + t * (l ? D(E.y, a.tickRotCorr.y + 8 * t) : E.x));
                a.axisTitleMargin = D(G, f);
                a.getMaxLabelDimensions && (a.maxLabelDimensions = a.getMaxLabelDimensions(k, m));
                l = this.tickSize("tick");
                w[q] = Math.max(w[q], a.axisTitleMargin + p + t * a.offset, f, A && m.length && l ? l[0] + t * a.offset : 0);
                c = c.offset ? 0 : 2 * Math.floor(a.axisLine.strokeWidth() / 2);
                b[v] = Math.max(b[v], c);
                h(this, "afterGetOffset");
            },
            getLinePath: function(a) {
                var b = this.chart, g = this.opposite, d = this.offset, c = this.horiz, m = this.left + (g ? this.width : 0) + d, d = b.chartHeight - this.bottom - (g ? this.height : 0) + d;
                g && (a *= -1);
                return b.renderer.crispLine([
                    "M",
                    c ? this.left : m,
                    c ? d : this.top,
                    "L",
                    c ? b.chartWidth - this.right : m,
                    c ? d : b.chartHeight - this.bottom
                ], a);
            },
            renderLine: function() {
                this.axisLine || (this.axisLine = this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup), this.axisLine.attr({
                    stroke: this.options.lineColor,
                    "stroke-width": this.options.lineWidth,
                    zIndex: 7
                }));
            },
            getTitlePosition: function() {
                var a = this.horiz, b = this.left, d = this.top, c = this.len, m = this.options.title, k = a ? b : d, l = this.opposite, h = this.offset, q = m.x || 0, v = m.y || 0, A = this.axisTitle, e = this.chart.renderer.fontMetrics(m.style && m.style.fontSize, A), A = Math.max(A.getBBox(null, 0).height - e.h - 1, 0), c = {
                    low: k + (a ? 0 : c),
                    middle: k + c / 2,
                    high: k + (a ? c : 0)
                }[m.align], b = (a ? d + this.height : b) + (a ? 1 : -1) * (l ? -1 : 1) * this.axisTitleMargin + [
                    -A,
                    A,
                    e.f,
                    -A
                ][this.side];
                return {
                    x: a ? c + q : b + (l ? this.width : 0) + h + q,
                    y: a ? b + v - (l ? this.height : 0) + h : c + v
                };
            },
            renderMinorTick: function(a) {
                var b = this.chart.hasRendered && v(this.oldMin), d = this.minorTicks;
                d[a] || (d[a] = new N(this, a, "minor"));
                b && d[a].isNew && d[a].render(null, !0);
                d[a].render(null, !1, 1);
            },
            renderTick: function(a, b) {
                var d = this.isLinked, g = this.ticks, c = this.chart.hasRendered && v(this.oldMin);
                if (!d || a >= this.min && a <= this.max) g[a] || (g[a] = new N(this, a)), c && g[a].isNew && g[a].render(b, !0, -1), g[a].render(b);
            },
            render: function() {
                var b = this, d = b.chart, c = b.options, m = b.isLog, k = b.isLinked, l = b.tickPositions, q = b.axisTitle, e = b.ticks, p = b.minorTicks, f = b.alternateBands, G = c.stackLabels, J = c.alternateGridColor, E = b.tickmarkOffset, D = b.axisLine, t = b.showAxis, w = F(d.renderer.globalAnimation), u, n;
                b.labelEdge.length = 0;
                b.overlap = !1;
                y([
                    e,
                    p,
                    f
                ], function(a) {
                    B(a, function(a) {
                        a.isActive = !1;
                    });
                });
                if (b.hasData() || k) b.minorTickInterval && !b.categories && y(b.getMinorTickPositions(), function(a) {
                    b.renderMinorTick(a);
                }), l.length && (y(l, function(a, d) {
                    b.renderTick(a, d);
                }), E && (0 === b.min || b.single) && (e[-1] || (e[-1] = new N(b, -1, null, !0)), e[-1].render(-1))), J && y(l, function(c, g) {
                    n = void 0 !== l[g + 1] ? l[g + 1] + E : b.max - E;
                    0 === g % 2 && c < b.max && n <= b.max + (d.polar ? -E : E) && (f[c] || (f[c] = new a.PlotLineOrBand(b)), u = c + E, f[c].options = {
                        from: m ? b.lin2log(u) : u,
                        to: m ? b.lin2log(n) : n,
                        color: J
                    }, f[c].render(), f[c].isActive = !0);
                }), b._addedPlotLB || (y((c.plotLines || []).concat(c.plotBands || []), function(a) {
                    b.addPlotBandOrLine(a);
                }), b._addedPlotLB = !0);
                y([
                    e,
                    p,
                    f
                ], function(a) {
                    var b, c = [], g = w.duration;
                    B(a, function(a, b) {
                        a.isActive || (a.render(b, !1, 0), a.isActive = !1, c.push(b));
                    });
                    A(function() {
                        for(b = c.length; b--;)a[c[b]] && !a[c[b]].isActive && (a[c[b]].destroy(), delete a[c[b]]);
                    }, a !== f && d.hasRendered && g ? g : 0);
                });
                D && (D[D.isPlaced ? "animate" : "attr"]({
                    d: this.getLinePath(D.strokeWidth())
                }), D.isPlaced = !0, D[t ? "show" : "hide"](!0));
                q && t && (c = b.getTitlePosition(), v(c.y) ? (q[q.isNew ? "attr" : "animate"](c), q.isNew = !1) : (q.attr("y", -9999), q.isNew = !0));
                G && G.enabled && b.renderStackTotals();
                b.isDirty = !1;
                h(this, "afterRender");
            },
            redraw: function() {
                this.visible && (this.render(), y(this.plotLinesAndBands, function(a) {
                    a.render();
                }));
                y(this.series, function(a) {
                    a.isDirty = !0;
                });
            },
            keepProps: "extKey hcEvents names series userMax userMin".split(" "),
            destroy: function(a) {
                var b = this, c = b.stacks, g = b.plotLinesAndBands, k;
                h(this, "destroy", {
                    keepEvents: a
                });
                a || m(b);
                B(c, function(a, b) {
                    w(a);
                    c[b] = null;
                });
                y([
                    b.ticks,
                    b.minorTicks,
                    b.alternateBands
                ], function(a) {
                    w(a);
                });
                if (g) for(a = g.length; a--;)g[a].destroy();
                y("stackTotalGroup axisLine axisTitle axisGroup gridGroup labelGroup cross scrollbar".split(" "), function(a) {
                    b[a] && (b[a] = b[a].destroy());
                });
                for(k in b.plotLinesAndBandsGroups)b.plotLinesAndBandsGroups[k] = b.plotLinesAndBandsGroups[k].destroy();
                B(b, function(a, c) {
                    -1 === d(c, b.keepProps) && delete b[c];
                });
            },
            drawCrosshair: function(a, b) {
                var d, c = this.crosshair, g = D(c.snap, !0), m, k = this.cross;
                h(this, "drawCrosshair", {
                    e: a,
                    point: b
                });
                a || (a = this.cross && this.cross.e);
                if (this.crosshair && !1 !== (x(b) || !g)) {
                    g ? x(b) && (m = D(b.crosshairPos, this.isXAxis ? b.plotX : this.len - b.plotY)) : m = a && (this.horiz ? a.chartX - this.pos : this.len - a.chartY + this.pos);
                    x(m) && (d = this.getPlotLinePath(b && (this.isXAxis ? b.x : D(b.stackY, b.y)), null, null, null, m) || null);
                    if (!x(d)) {
                        this.hideCrosshair();
                        return;
                    }
                    g = this.categories && !this.isRadial;
                    k || (this.cross = k = this.chart.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-" + (g ? "category " : "thin ") + c.className).attr({
                        zIndex: D(c.zIndex, 2)
                    }).add(), k.attr({
                        stroke: c.color || (g ? f("#ccd6eb").setOpacity(.25).get() : "#cccccc"),
                        "stroke-width": D(c.width, 1)
                    }).css({
                        "pointer-events": "none"
                    }), c.dashStyle && k.attr({
                        dashstyle: c.dashStyle
                    }));
                    k.show().attr({
                        d: d
                    });
                    g && !c.width && k.attr({
                        "stroke-width": this.transA
                    });
                    this.cross.e = a;
                } else this.hideCrosshair();
                h(this, "afterDrawCrosshair", {
                    e: a,
                    point: b
                });
            },
            hideCrosshair: function() {
                this.cross && this.cross.hide();
            }
        });
        return a.Axis = E;
    }(K);
    (function(a) {
        var C = a.Axis, F = a.getMagnitude, I = a.normalizeTickInterval, n = a.timeUnits;
        C.prototype.getTimeTicks = function() {
            return this.chart.time.getTimeTicks.apply(this.chart.time, arguments);
        };
        C.prototype.normalizeTimeTickInterval = function(a, e) {
            var f = e || [
                [
                    "millisecond",
                    [
                        1,
                        2,
                        5,
                        10,
                        20,
                        25,
                        50,
                        100,
                        200,
                        500
                    ]
                ],
                [
                    "second",
                    [
                        1,
                        2,
                        5,
                        10,
                        15,
                        30
                    ]
                ],
                [
                    "minute",
                    [
                        1,
                        2,
                        5,
                        10,
                        15,
                        30
                    ]
                ],
                [
                    "hour",
                    [
                        1,
                        2,
                        3,
                        4,
                        6,
                        8,
                        12
                    ]
                ],
                [
                    "day",
                    [
                        1,
                        2
                    ]
                ],
                [
                    "week",
                    [
                        1,
                        2
                    ]
                ],
                [
                    "month",
                    [
                        1,
                        2,
                        3,
                        4,
                        6
                    ]
                ],
                [
                    "year",
                    null
                ]
            ];
            e = f[f.length - 1];
            var x = n[e[0]], t = e[1], w;
            for(w = 0; w < f.length && !(e = f[w], x = n[e[0]], t = e[1], f[w + 1] && a <= (x * t[t.length - 1] + n[f[w + 1][0]]) / 2); w++);
            x === n.year && a < 5 * x && (t = [
                1,
                2,
                5
            ]);
            a = I(a / x, t, "year" === e[0] ? Math.max(F(a / x), 1) : 1);
            return {
                unitRange: x,
                count: a,
                unitName: e[0]
            };
        };
    })(K);
    (function(a) {
        var C = a.Axis, F = a.getMagnitude, I = a.map, n = a.normalizeTickInterval, f = a.pick;
        C.prototype.getLogTickPositions = function(a, u, x, t) {
            var e = this.options, y = this.len, c = [];
            t || (this._minorAutoInterval = null);
            if (.5 <= a) a = Math.round(a), c = this.getLinearTickPositions(a, u, x);
            else if (.08 <= a) for(var y = Math.floor(u), h, p, k, q, d, e = .3 < a ? [
                1,
                2,
                4
            ] : .15 < a ? [
                1,
                2,
                4,
                6,
                8
            ] : [
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9
            ]; y < x + 1 && !d; y++)for(p = e.length, h = 0; h < p && !d; h++)k = this.log2lin(this.lin2log(y) * e[h]), k > u && (!t || q <= x) && void 0 !== q && c.push(q), q > x && (d = !0), q = k;
            else u = this.lin2log(u), x = this.lin2log(x), a = t ? this.getMinorTickInterval() : e.tickInterval, a = f("auto" === a ? null : a, this._minorAutoInterval, e.tickPixelInterval / (t ? 5 : 1) * (x - u) / ((t ? y / this.tickPositions.length : y) || 1)), a = n(a, null, F(a)), c = I(this.getLinearTickPositions(a, u, x), this.log2lin), t || (this._minorAutoInterval = a / 5);
            t || (this.tickInterval = a);
            return c;
        };
        C.prototype.log2lin = function(a) {
            return Math.log(a) / Math.LN10;
        };
        C.prototype.lin2log = function(a) {
            return Math.pow(10, a);
        };
    })(K);
    (function(a, C) {
        var F = a.arrayMax, I = a.arrayMin, n = a.defined, f = a.destroyObjectProperties, e = a.each, u = a.erase, x = a.merge, t = a.pick;
        a.PlotLineOrBand = function(a, e) {
            this.axis = a;
            e && (this.options = e, this.id = e.id);
        };
        a.PlotLineOrBand.prototype = {
            render: function() {
                a.fireEvent(this, "render");
                var e = this, f = e.axis, c = f.horiz, h = e.options, p = h.label, k = e.label, q = h.to, d = h.from, b = h.value, v = n(d) && n(q), J = n(b), l = e.svgElem, u = !l, B = [], D = h.color, m = t(h.zIndex, 0), G = h.events, B = {
                    "class": "highcharts-plot-" + (v ? "band " : "line ") + (h.className || "")
                }, A = {}, N = f.chart.renderer, E = v ? "bands" : "lines";
                f.isLog && (d = f.log2lin(d), q = f.log2lin(q), b = f.log2lin(b));
                J ? (B.stroke = D, B["stroke-width"] = h.width, h.dashStyle && (B.dashstyle = h.dashStyle)) : v && (D && (B.fill = D), h.borderWidth && (B.stroke = h.borderColor, B["stroke-width"] = h.borderWidth));
                A.zIndex = m;
                E += "-" + m;
                (D = f.plotLinesAndBandsGroups[E]) || (f.plotLinesAndBandsGroups[E] = D = N.g("plot-" + E).attr(A).add());
                u && (e.svgElem = l = N.path().attr(B).add(D));
                if (J) B = f.getPlotLinePath(b, l.strokeWidth());
                else if (v) B = f.getPlotBandPath(d, q, h);
                else return;
                u && B && B.length ? (l.attr({
                    d: B
                }), G && a.objectEach(G, function(a, b) {
                    l.on(b, function(a) {
                        G[b].apply(e, [
                            a
                        ]);
                    });
                })) : l && (B ? (l.show(), l.animate({
                    d: B
                })) : (l.hide(), k && (e.label = k = k.destroy())));
                p && n(p.text) && B && B.length && 0 < f.width && 0 < f.height && !B.isFlat ? (p = x({
                    align: c && v && "center",
                    x: c ? !v && 4 : 10,
                    verticalAlign: !c && v && "middle",
                    y: c ? v ? 16 : 10 : v ? 6 : -4,
                    rotation: c && !v && 90
                }, p), this.renderLabel(p, B, v, m)) : k && k.hide();
                return e;
            },
            renderLabel: function(a, e, c, h) {
                var p = this.label, k = this.axis.chart.renderer;
                p || (p = {
                    align: a.textAlign || a.align,
                    rotation: a.rotation,
                    "class": "highcharts-plot-" + (c ? "band" : "line") + "-label " + (a.className || "")
                }, p.zIndex = h, this.label = p = k.text(a.text, 0, 0, a.useHTML).attr(p).add(), p.css(a.style));
                h = e.xBounds || [
                    e[1],
                    e[4],
                    c ? e[6] : e[1]
                ];
                e = e.yBounds || [
                    e[2],
                    e[5],
                    c ? e[7] : e[2]
                ];
                c = I(h);
                k = I(e);
                p.align(a, !1, {
                    x: c,
                    y: k,
                    width: F(h) - c,
                    height: F(e) - k
                });
                p.show();
            },
            destroy: function() {
                u(this.axis.plotLinesAndBands, this);
                delete this.axis;
                f(this);
            }
        };
        a.extend(C.prototype, {
            getPlotBandPath: function(a, e) {
                var c = this.getPlotLinePath(e, null, null, !0), h = this.getPlotLinePath(a, null, null, !0), p = [], k = this.horiz, q = 1, d;
                a = a < this.min && e < this.min || a > this.max && e > this.max;
                if (h && c) for(a && (d = h.toString() === c.toString(), q = 0), a = 0; a < h.length; a += 6)k && c[a + 1] === h[a + 1] ? (c[a + 1] += q, c[a + 4] += q) : k || c[a + 2] !== h[a + 2] || (c[a + 2] += q, c[a + 5] += q), p.push("M", h[a + 1], h[a + 2], "L", h[a + 4], h[a + 5], c[a + 4], c[a + 5], c[a + 1], c[a + 2], "z"), p.isFlat = d;
                return p;
            },
            addPlotBand: function(a) {
                return this.addPlotBandOrLine(a, "plotBands");
            },
            addPlotLine: function(a) {
                return this.addPlotBandOrLine(a, "plotLines");
            },
            addPlotBandOrLine: function(e, f) {
                var c = new a.PlotLineOrBand(this, e).render(), h = this.userOptions;
                c && (f && (h[f] = h[f] || [], h[f].push(e)), this.plotLinesAndBands.push(c));
                return c;
            },
            removePlotBandOrLine: function(a) {
                for(var f = this.plotLinesAndBands, c = this.options, h = this.userOptions, p = f.length; p--;)f[p].id === a && f[p].destroy();
                e([
                    c.plotLines || [],
                    h.plotLines || [],
                    c.plotBands || [],
                    h.plotBands || []
                ], function(c) {
                    for(p = c.length; p--;)c[p].id === a && u(c, c[p]);
                });
            },
            removePlotBand: function(a) {
                this.removePlotBandOrLine(a);
            },
            removePlotLine: function(a) {
                this.removePlotBandOrLine(a);
            }
        });
    })(K, W);
    (function(a) {
        var C = a.doc, F = a.each, I = a.extend, n = a.format, f = a.isNumber, e = a.map, u = a.merge, x = a.pick, t = a.splat, w = a.syncTimeout, y = a.timeUnits;
        a.Tooltip = function() {
            this.init.apply(this, arguments);
        };
        a.Tooltip.prototype = {
            init: function(a, h) {
                this.chart = a;
                this.options = h;
                this.crosshairs = [];
                this.now = {
                    x: 0,
                    y: 0
                };
                this.isHidden = !0;
                this.split = h.split && !a.inverted;
                this.shared = h.shared || this.split;
                this.outside = h.outside && !this.split;
            },
            cleanSplit: function(a) {
                F(this.chart.series, function(c) {
                    var h = c && c.tt;
                    h && (!h.isActive || a ? c.tt = h.destroy() : h.isActive = !1);
                });
            },
            getLabel: function() {
                var c = this.chart.renderer, h = this.options, e;
                this.label || (this.outside && (this.container = e = a.doc.createElement("div"), e.className = "highcharts-tooltip-container", a.css(e, {
                    position: "absolute",
                    top: "1px",
                    pointerEvents: h.style && h.style.pointerEvents
                }), a.doc.body.appendChild(e), this.renderer = c = new a.Renderer(e, 0, 0)), this.split ? this.label = c.g("tooltip") : (this.label = c.label("", 0, 0, h.shape || "callout", null, null, h.useHTML, null, "tooltip").attr({
                    padding: h.padding,
                    r: h.borderRadius
                }), this.label.attr({
                    fill: h.backgroundColor,
                    "stroke-width": h.borderWidth
                }).css(h.style).shadow(h.shadow)), this.outside && (this.label.attr({
                    x: this.distance,
                    y: this.distance
                }), this.label.xSetter = function(a) {
                    e.style.left = a + "px";
                }, this.label.ySetter = function(a) {
                    e.style.top = a + "px";
                }), this.label.attr({
                    zIndex: 8
                }).add());
                return this.label;
            },
            update: function(a) {
                this.destroy();
                u(!0, this.chart.options.tooltip.userOptions, a);
                this.init(this.chart, u(!0, this.options, a));
            },
            destroy: function() {
                this.label && (this.label = this.label.destroy());
                this.split && this.tt && (this.cleanSplit(this.chart, !0), this.tt = this.tt.destroy());
                this.renderer && (this.renderer = this.renderer.destroy(), a.discardElement(this.container));
                a.clearTimeout(this.hideTimer);
                a.clearTimeout(this.tooltipTimeout);
            },
            move: function(c, h, e, k) {
                var q = this, d = q.now, b = !1 !== q.options.animation && !q.isHidden && (1 < Math.abs(c - d.x) || 1 < Math.abs(h - d.y)), v = q.followPointer || 1 < q.len;
                I(d, {
                    x: b ? (2 * d.x + c) / 3 : c,
                    y: b ? (d.y + h) / 2 : h,
                    anchorX: v ? void 0 : b ? (2 * d.anchorX + e) / 3 : e,
                    anchorY: v ? void 0 : b ? (d.anchorY + k) / 2 : k
                });
                q.getLabel().attr(d);
                b && (a.clearTimeout(this.tooltipTimeout), this.tooltipTimeout = setTimeout(function() {
                    q && q.move(c, h, e, k);
                }, 32));
            },
            hide: function(c) {
                var h = this;
                a.clearTimeout(this.hideTimer);
                c = x(c, this.options.hideDelay, 500);
                this.isHidden || (this.hideTimer = w(function() {
                    h.getLabel()[c ? "fadeOut" : "hide"]();
                    h.isHidden = !0;
                }, c));
            },
            getAnchor: function(a, h) {
                var c = this.chart, k = c.pointer, q = c.inverted, d = c.plotTop, b = c.plotLeft, v = 0, f = 0, l, n;
                a = t(a);
                this.followPointer && h ? (void 0 === h.chartX && (h = k.normalize(h)), a = [
                    h.chartX - c.plotLeft,
                    h.chartY - d
                ]) : a[0].tooltipPos ? a = a[0].tooltipPos : (F(a, function(a) {
                    l = a.series.yAxis;
                    n = a.series.xAxis;
                    v += a.plotX + (!q && n ? n.left - b : 0);
                    f += (a.plotLow ? (a.plotLow + a.plotHigh) / 2 : a.plotY) + (!q && l ? l.top - d : 0);
                }), v /= a.length, f /= a.length, a = [
                    q ? c.plotWidth - f : v,
                    this.shared && !q && 1 < a.length && h ? h.chartY - d : q ? c.plotHeight - v : f
                ]);
                return e(a, Math.round);
            },
            getPosition: function(a, h, e) {
                var c = this.chart, q = this.distance, d = {}, b = c.inverted && e.h || 0, v, f = this.outside, l = f ? C.documentElement.clientWidth - 2 * q : c.chartWidth, p = f ? Math.max(C.body.scrollHeight, C.documentElement.scrollHeight, C.body.offsetHeight, C.documentElement.offsetHeight, C.documentElement.clientHeight) : c.chartHeight, B = c.pointer.chartPosition, D = [
                    "y",
                    p,
                    h,
                    (f ? B.top - q : 0) + e.plotY + c.plotTop,
                    f ? 0 : c.plotTop,
                    f ? p : c.plotTop + c.plotHeight
                ], m = [
                    "x",
                    l,
                    a,
                    (f ? B.left - q : 0) + e.plotX + c.plotLeft,
                    f ? 0 : c.plotLeft,
                    f ? l : c.plotLeft + c.plotWidth
                ], G = !this.followPointer && x(e.ttBelow, !c.inverted === !!e.negative), A = function(a, c, g, m, k, l) {
                    var h = g < m - q, v = m + q + g < c, A = m - q - g;
                    m += q;
                    if (G && v) d[a] = m;
                    else if (!G && h) d[a] = A;
                    else if (h) d[a] = Math.min(l - g, 0 > A - b ? A : A - b);
                    else if (v) d[a] = Math.max(k, m + b + g > c ? m : m + b);
                    else return !1;
                }, N = function(a, b, c, g) {
                    var m;
                    g < q || g > b - q ? m = !1 : d[a] = g < c / 2 ? 1 : g > b - c / 2 ? b - c - 2 : g - c / 2;
                    return m;
                }, E = function(a) {
                    var b = D;
                    D = m;
                    m = b;
                    v = a;
                }, g = function() {
                    !1 !== A.apply(0, D) ? !1 !== N.apply(0, m) || v || (E(!0), g()) : v ? d.x = d.y = 0 : (E(!0), g());
                };
                (c.inverted || 1 < this.len) && E();
                g();
                return d;
            },
            defaultFormatter: function(a) {
                var c = this.points || t(this), e;
                e = [
                    a.tooltipFooterHeaderFormatter(c[0])
                ];
                e = e.concat(a.bodyFormatter(c));
                e.push(a.tooltipFooterHeaderFormatter(c[0], !0));
                return e;
            },
            refresh: function(c, h) {
                var e, k = this.options, q, d = c, b, v = {}, f = [];
                e = k.formatter || this.defaultFormatter;
                var v = this.shared, l;
                k.enabled && (a.clearTimeout(this.hideTimer), this.followPointer = t(d)[0].series.tooltipOptions.followPointer, b = this.getAnchor(d, h), h = b[0], q = b[1], !v || d.series && d.series.noSharedTooltip ? v = d.getLabelConfig() : (F(d, function(a) {
                    a.setState("hover");
                    f.push(a.getLabelConfig());
                }), v = {
                    x: d[0].category,
                    y: d[0].y
                }, v.points = f, d = d[0]), this.len = f.length, v = e.call(v, this), l = d.series, this.distance = x(l.tooltipOptions.distance, 16), !1 === v ? this.hide() : (e = this.getLabel(), this.isHidden && e.attr({
                    opacity: 1
                }).show(), this.split ? this.renderSplit(v, t(c)) : (k.style.width || e.css({
                    width: this.chart.spacingBox.width
                }), e.attr({
                    text: v && v.join ? v.join("") : v
                }), e.removeClass(/highcharts-color-[\d]+/g).addClass("highcharts-color-" + x(d.colorIndex, l.colorIndex)), e.attr({
                    stroke: k.borderColor || d.color || l.color || "#666666"
                }), this.updatePosition({
                    plotX: h,
                    plotY: q,
                    negative: d.negative,
                    ttBelow: d.ttBelow,
                    h: b[2] || 0
                })), this.isHidden = !1));
            },
            renderSplit: function(c, h) {
                var e = this, k = [], q = this.chart, d = q.renderer, b = !0, v = this.options, f = 0, l, t = this.getLabel(), B = q.plotTop;
                a.isString(c) && (c = [
                    !1,
                    c
                ]);
                F(c.slice(0, h.length + 1), function(a, c) {
                    if (!1 !== a) {
                        c = h[c - 1] || {
                            isHeader: !0,
                            plotX: h[0].plotX
                        };
                        var m = c.series || e, A = m.tt, p = c.series || {}, E = "highcharts-color-" + x(c.colorIndex, p.colorIndex, "none");
                        A || (m.tt = A = d.label(null, null, null, "callout", null, null, v.useHTML).addClass("highcharts-tooltip-box " + E + (c.isHeader ? " highcharts-tooltip-header" : "")).attr({
                            padding: v.padding,
                            r: v.borderRadius,
                            fill: v.backgroundColor,
                            stroke: v.borderColor || c.color || p.color || "#333333",
                            "stroke-width": v.borderWidth
                        }).add(t));
                        A.isActive = !0;
                        A.attr({
                            text: a
                        });
                        A.css(v.style).shadow(v.shadow);
                        a = A.getBBox();
                        p = a.width + A.strokeWidth();
                        c.isHeader ? (f = a.height, q.xAxis[0].opposite && (l = !0, B -= f), p = Math.max(0, Math.min(c.plotX + q.plotLeft - p / 2, q.chartWidth + (q.scrollablePixels ? q.scrollablePixels - q.marginRight : 0) - p))) : p = c.plotX + q.plotLeft - x(v.distance, 16) - p;
                        0 > p && (b = !1);
                        a = (c.series && c.series.yAxis && c.series.yAxis.pos) + (c.plotY || 0);
                        a -= B;
                        c.isHeader && (a = l ? -f : q.plotHeight + f);
                        k.push({
                            target: a,
                            rank: c.isHeader ? 1 : 0,
                            size: m.tt.getBBox().height + 1,
                            point: c,
                            x: p,
                            tt: A
                        });
                    }
                });
                this.cleanSplit();
                a.distribute(k, q.plotHeight + f);
                F(k, function(a) {
                    var c = a.point, d = c.series;
                    a.tt.attr({
                        visibility: void 0 === a.pos ? "hidden" : "inherit",
                        x: b || c.isHeader ? a.x : c.plotX + q.plotLeft + x(v.distance, 16),
                        y: a.pos + B,
                        anchorX: c.isHeader ? c.plotX + q.plotLeft : c.plotX + d.xAxis.pos,
                        anchorY: c.isHeader ? q.plotTop + q.plotHeight / 2 : c.plotY + d.yAxis.pos
                    });
                });
            },
            updatePosition: function(a) {
                var c = this.chart, e = this.getLabel(), k = (this.options.positioner || this.getPosition).call(this, e.width, e.height, a), q = a.plotX + c.plotLeft;
                a = a.plotY + c.plotTop;
                var d;
                this.outside && (d = (this.options.borderWidth || 0) + 2 * this.distance, this.renderer.setSize(e.width + d, e.height + d, !1), q += c.pointer.chartPosition.left - k.x, a += c.pointer.chartPosition.top - k.y);
                this.move(Math.round(k.x), Math.round(k.y || 0), q, a);
            },
            getDateFormat: function(a, h, e, k) {
                var c = this.chart.time, d = c.dateFormat("%m-%d %H:%M:%S.%L", h), b, v, f = {
                    millisecond: 15,
                    second: 12,
                    minute: 9,
                    hour: 6,
                    day: 3
                }, l = "millisecond";
                for(v in y){
                    if (a === y.week && +c.dateFormat("%w", h) === e && "00:00:00.000" === d.substr(6)) {
                        v = "week";
                        break;
                    }
                    if (y[v] > a) {
                        v = l;
                        break;
                    }
                    if (f[v] && d.substr(f[v]) !== "01-01 00:00:00.000".substr(f[v])) break;
                    "week" !== v && (l = v);
                }
                v && (b = c.resolveDTLFormat(k[v]).main);
                return b;
            },
            getXDateFormat: function(a, h, e) {
                h = h.dateTimeLabelFormats;
                var c = e && e.closestPointRange;
                return (c ? this.getDateFormat(c, a.x, e.options.startOfWeek, h) : h.day) || h.year;
            },
            tooltipFooterHeaderFormatter: function(a, h) {
                h = h ? "footer" : "header";
                var c = a.series, k = c.tooltipOptions, e = k.xDateFormat, d = c.xAxis, b = d && "datetime" === d.options.type && f(a.key), v = k[h + "Format"];
                b && !e && (e = this.getXDateFormat(a, k, d));
                b && e && F(a.point && a.point.tooltipDateKeys || [
                    "key"
                ], function(a) {
                    v = v.replace("{point." + a + "}", "{point." + a + ":" + e + "}");
                });
                return n(v, {
                    point: a,
                    series: c
                }, this.chart.time);
            },
            bodyFormatter: function(a) {
                return e(a, function(a) {
                    var c = a.series.tooltipOptions;
                    return (c[(a.point.formatPrefix || "point") + "Formatter"] || a.point.tooltipFormatter).call(a.point, c[(a.point.formatPrefix || "point") + "Format"]);
                });
            }
        };
    })(K);
    (function(a) {
        var C = a.addEvent, F = a.attr, I = a.charts, n = a.color, f = a.css, e = a.defined, u = a.each, x = a.extend, t = a.find, w = a.fireEvent, y = a.isNumber, c = a.isObject, h = a.offset, p = a.pick, k = a.splat, q = a.Tooltip;
        a.Pointer = function(a, b) {
            this.init(a, b);
        };
        a.Pointer.prototype = {
            init: function(a, b) {
                this.options = b;
                this.chart = a;
                this.runChartClick = b.chart.events && !!b.chart.events.click;
                this.pinchDown = [];
                this.lastValidTouch = {};
                q && (a.tooltip = new q(a, b.tooltip), this.followTouchMove = p(b.tooltip.followTouchMove, !0));
                this.setDOMEvents();
            },
            zoomOption: function(a) {
                var b = this.chart, c = b.options.chart, d = c.zoomType || "", b = b.inverted;
                /touch/.test(a.type) && (d = p(c.pinchType, d));
                this.zoomX = a = /x/.test(d);
                this.zoomY = d = /y/.test(d);
                this.zoomHor = a && !b || d && b;
                this.zoomVert = d && !b || a && b;
                this.hasZoom = a || d;
            },
            normalize: function(a, b) {
                var c;
                c = a.touches ? a.touches.length ? a.touches.item(0) : a.changedTouches[0] : a;
                b || (this.chartPosition = b = h(this.chart.container));
                return x(a, {
                    chartX: Math.round(c.pageX - b.left),
                    chartY: Math.round(c.pageY - b.top)
                });
            },
            getCoordinates: function(a) {
                var b = {
                    xAxis: [],
                    yAxis: []
                };
                u(this.chart.axes, function(c) {
                    b[c.isXAxis ? "xAxis" : "yAxis"].push({
                        axis: c,
                        value: c.toValue(a[c.horiz ? "chartX" : "chartY"])
                    });
                });
                return b;
            },
            findNearestKDPoint: function(a, b, k) {
                var d;
                u(a, function(a) {
                    var l = !(a.noSharedTooltip && b) && 0 > a.options.findNearestPointBy.indexOf("y");
                    a = a.searchPoint(k, l);
                    if ((l = c(a, !0)) && !(l = !c(d, !0))) var l = d.distX - a.distX, e = d.dist - a.dist, h = (a.series.group && a.series.group.zIndex) - (d.series.group && d.series.group.zIndex), l = 0 < (0 !== l && b ? l : 0 !== e ? e : 0 !== h ? h : d.series.index > a.series.index ? -1 : 1);
                    l && (d = a);
                });
                return d;
            },
            getPointFromEvent: function(a) {
                a = a.target;
                for(var b; a && !b;)b = a.point, a = a.parentNode;
                return b;
            },
            getChartCoordinatesFromPoint: function(a, b) {
                var c = a.series, d = c.xAxis, c = c.yAxis, k = p(a.clientX, a.plotX), e = a.shapeArgs;
                if (d && c) return b ? {
                    chartX: d.len + d.pos - k,
                    chartY: c.len + c.pos - a.plotY
                } : {
                    chartX: k + d.pos,
                    chartY: a.plotY + c.pos
                };
                if (e && e.x && e.y) return {
                    chartX: e.x,
                    chartY: e.y
                };
            },
            getHoverData: function(d, b, k, e, l, h, q) {
                var v, m = [], f = q && q.isBoosting;
                e = !(!e || !d);
                q = b && !b.stickyTracking ? [
                    b
                ] : a.grep(k, function(a) {
                    return a.visible && !(!l && a.directTouch) && p(a.options.enableMouseTracking, !0) && a.stickyTracking;
                });
                b = (v = e ? d : this.findNearestKDPoint(q, l, h)) && v.series;
                v && (l && !b.noSharedTooltip ? (q = a.grep(k, function(a) {
                    return a.visible && !(!l && a.directTouch) && p(a.options.enableMouseTracking, !0) && !a.noSharedTooltip;
                }), u(q, function(a) {
                    var b = t(a.points, function(a) {
                        return a.x === v.x && !a.isNull;
                    });
                    c(b) && (f && (b = a.getPoint(b)), m.push(b));
                })) : m.push(v));
                return {
                    hoverPoint: v,
                    hoverSeries: b,
                    hoverPoints: m
                };
            },
            runPointActions: function(c, b) {
                var d = this.chart, k = d.tooltip && d.tooltip.options.enabled ? d.tooltip : void 0, l = k ? k.shared : !1, e = b || d.hoverPoint, h = e && e.series || d.hoverSeries, h = this.getHoverData(e, h, d.series, "touchmove" !== c.type && (!!b || h && h.directTouch && this.isDirectTouch), l, c, {
                    isBoosting: d.isBoosting
                }), q, e = h.hoverPoint;
                q = h.hoverPoints;
                b = (h = h.hoverSeries) && h.tooltipOptions.followPointer;
                l = l && h && !h.noSharedTooltip;
                if (e && (e !== d.hoverPoint || k && k.isHidden)) {
                    u(d.hoverPoints || [], function(b) {
                        -1 === a.inArray(b, q) && b.setState();
                    });
                    u(q || [], function(a) {
                        a.setState("hover");
                    });
                    if (d.hoverSeries !== h) h.onMouseOver();
                    d.hoverPoint && d.hoverPoint.firePointEvent("mouseOut");
                    if (!e.series) return;
                    e.firePointEvent("mouseOver");
                    d.hoverPoints = q;
                    d.hoverPoint = e;
                    k && k.refresh(l ? q : e, c);
                } else b && k && !k.isHidden && (e = k.getAnchor([
                    {}
                ], c), k.updatePosition({
                    plotX: e[0],
                    plotY: e[1]
                }));
                this.unDocMouseMove || (this.unDocMouseMove = C(d.container.ownerDocument, "mousemove", function(b) {
                    var c = I[a.hoverChartIndex];
                    if (c) c.pointer.onDocumentMouseMove(b);
                }));
                u(d.axes, function(b) {
                    var d = p(b.crosshair.snap, !0), m = d ? a.find(q, function(a) {
                        return a.series[b.coll] === b;
                    }) : void 0;
                    m || !d ? b.drawCrosshair(c, m) : b.hideCrosshair();
                });
            },
            reset: function(a, b) {
                var c = this.chart, d = c.hoverSeries, l = c.hoverPoint, e = c.hoverPoints, h = c.tooltip, q = h && h.shared ? e : l;
                a && q && u(k(q), function(b) {
                    b.series.isCartesian && void 0 === b.plotX && (a = !1);
                });
                if (a) h && q && (h.refresh(q), h.shared && e ? u(e, function(a) {
                    a.setState(a.state, !0);
                    a.series.isCartesian && (a.series.xAxis.crosshair && a.series.xAxis.drawCrosshair(null, a), a.series.yAxis.crosshair && a.series.yAxis.drawCrosshair(null, a));
                }) : l && (l.setState(l.state, !0), u(c.axes, function(a) {
                    a.crosshair && a.drawCrosshair(null, l);
                })));
                else {
                    if (l) l.onMouseOut();
                    e && u(e, function(a) {
                        a.setState();
                    });
                    if (d) d.onMouseOut();
                    h && h.hide(b);
                    this.unDocMouseMove && (this.unDocMouseMove = this.unDocMouseMove());
                    u(c.axes, function(a) {
                        a.hideCrosshair();
                    });
                    this.hoverX = c.hoverPoints = c.hoverPoint = null;
                }
            },
            scaleGroups: function(a, b) {
                var c = this.chart, d;
                u(c.series, function(k) {
                    d = a || k.getPlotBox();
                    k.xAxis && k.xAxis.zoomEnabled && k.group && (k.group.attr(d), k.markerGroup && (k.markerGroup.attr(d), k.markerGroup.clip(b ? c.clipRect : null)), k.dataLabelsGroup && k.dataLabelsGroup.attr(d));
                });
                c.clipRect.attr(b || c.clipBox);
            },
            dragStart: function(a) {
                var b = this.chart;
                b.mouseIsDown = a.type;
                b.cancelClick = !1;
                b.mouseDownX = this.mouseDownX = a.chartX;
                b.mouseDownY = this.mouseDownY = a.chartY;
            },
            drag: function(a) {
                var b = this.chart, c = b.options.chart, d = a.chartX, k = a.chartY, e = this.zoomHor, h = this.zoomVert, q = b.plotLeft, m = b.plotTop, f = b.plotWidth, A = b.plotHeight, p, E = this.selectionMarker, g = this.mouseDownX, r = this.mouseDownY, t = c.panKey && a[c.panKey + "Key"];
                E && E.touch || (d < q ? d = q : d > q + f && (d = q + f), k < m ? k = m : k > m + A && (k = m + A), this.hasDragged = Math.sqrt(Math.pow(g - d, 2) + Math.pow(r - k, 2)), 10 < this.hasDragged && (p = b.isInsidePlot(g - q, r - m), b.hasCartesianSeries && (this.zoomX || this.zoomY) && p && !t && !E && (this.selectionMarker = E = b.renderer.rect(q, m, e ? 1 : f, h ? 1 : A, 0).attr({
                    fill: c.selectionMarkerFill || n("#335cad").setOpacity(.25).get(),
                    "class": "highcharts-selection-marker",
                    zIndex: 7
                }).add()), E && e && (d -= g, E.attr({
                    width: Math.abs(d),
                    x: (0 < d ? 0 : d) + g
                })), E && h && (d = k - r, E.attr({
                    height: Math.abs(d),
                    y: (0 < d ? 0 : d) + r
                })), p && !E && c.panning && b.pan(a, c.panning)));
            },
            drop: function(a) {
                var b = this, c = this.chart, d = this.hasPinched;
                if (this.selectionMarker) {
                    var k = {
                        originalEvent: a,
                        xAxis: [],
                        yAxis: []
                    }, h = this.selectionMarker, q = h.attr ? h.attr("x") : h.x, p = h.attr ? h.attr("y") : h.y, m = h.attr ? h.attr("width") : h.width, G = h.attr ? h.attr("height") : h.height, A;
                    if (this.hasDragged || d) u(c.axes, function(c) {
                        if (c.zoomEnabled && e(c.min) && (d || b[({
                            xAxis: "zoomX",
                            yAxis: "zoomY"
                        })[c.coll]])) {
                            var h = c.horiz, g = "touchend" === a.type ? c.minPixelPadding : 0, l = c.toValue((h ? q : p) + g), h = c.toValue((h ? q + m : p + G) - g);
                            k[c.coll].push({
                                axis: c,
                                min: Math.min(l, h),
                                max: Math.max(l, h)
                            });
                            A = !0;
                        }
                    }), A && w(c, "selection", k, function(a) {
                        c.zoom(x(a, d ? {
                            animation: !1
                        } : null));
                    });
                    y(c.index) && (this.selectionMarker = this.selectionMarker.destroy());
                    d && this.scaleGroups();
                }
                c && y(c.index) && (f(c.container, {
                    cursor: c._cursor
                }), c.cancelClick = 10 < this.hasDragged, c.mouseIsDown = this.hasDragged = this.hasPinched = !1, this.pinchDown = []);
            },
            onContainerMouseDown: function(a) {
                a = this.normalize(a);
                2 !== a.button && (this.zoomOption(a), a.preventDefault && a.preventDefault(), this.dragStart(a));
            },
            onDocumentMouseUp: function(c) {
                I[a.hoverChartIndex] && I[a.hoverChartIndex].pointer.drop(c);
            },
            onDocumentMouseMove: function(a) {
                var b = this.chart, c = this.chartPosition;
                a = this.normalize(a, c);
                !c || this.inClass(a.target, "highcharts-tracker") || b.isInsidePlot(a.chartX - b.plotLeft, a.chartY - b.plotTop) || this.reset();
            },
            onContainerMouseLeave: function(c) {
                var b = I[a.hoverChartIndex];
                b && (c.relatedTarget || c.toElement) && (b.pointer.reset(), b.pointer.chartPosition = null);
            },
            onContainerMouseMove: function(c) {
                var b = this.chart;
                e(a.hoverChartIndex) && I[a.hoverChartIndex] && I[a.hoverChartIndex].mouseIsDown || (a.hoverChartIndex = b.index);
                c = this.normalize(c);
                c.returnValue = !1;
                "mousedown" === b.mouseIsDown && this.drag(c);
                !this.inClass(c.target, "highcharts-tracker") && !b.isInsidePlot(c.chartX - b.plotLeft, c.chartY - b.plotTop) || b.openMenu || this.runPointActions(c);
            },
            inClass: function(a, b) {
                for(var c; a;){
                    if (c = F(a, "class")) {
                        if (-1 !== c.indexOf(b)) return !0;
                        if (-1 !== c.indexOf("highcharts-container")) return !1;
                    }
                    a = a.parentNode;
                }
            },
            onTrackerMouseOut: function(a) {
                var b = this.chart.hoverSeries;
                a = a.relatedTarget || a.toElement;
                this.isDirectTouch = !1;
                if (!(!b || !a || b.stickyTracking || this.inClass(a, "highcharts-tooltip") || this.inClass(a, "highcharts-series-" + b.index) && this.inClass(a, "highcharts-tracker"))) b.onMouseOut();
            },
            onContainerClick: function(a) {
                var b = this.chart, c = b.hoverPoint, d = b.plotLeft, k = b.plotTop;
                a = this.normalize(a);
                b.cancelClick || (c && this.inClass(a.target, "highcharts-tracker") ? (w(c.series, "click", x(a, {
                    point: c
                })), b.hoverPoint && c.firePointEvent("click", a)) : (x(a, this.getCoordinates(a)), b.isInsidePlot(a.chartX - d, a.chartY - k) && w(b, "click", a)));
            },
            setDOMEvents: function() {
                var c = this, b = c.chart.container, k = b.ownerDocument;
                b.onmousedown = function(a) {
                    c.onContainerMouseDown(a);
                };
                b.onmousemove = function(a) {
                    c.onContainerMouseMove(a);
                };
                b.onclick = function(a) {
                    c.onContainerClick(a);
                };
                this.unbindContainerMouseLeave = C(b, "mouseleave", c.onContainerMouseLeave);
                a.unbindDocumentMouseUp || (a.unbindDocumentMouseUp = C(k, "mouseup", c.onDocumentMouseUp));
                a.hasTouch && (b.ontouchstart = function(a) {
                    c.onContainerTouchStart(a);
                }, b.ontouchmove = function(a) {
                    c.onContainerTouchMove(a);
                }, a.unbindDocumentTouchEnd || (a.unbindDocumentTouchEnd = C(k, "touchend", c.onDocumentTouchEnd)));
            },
            destroy: function() {
                var c = this;
                c.unDocMouseMove && c.unDocMouseMove();
                this.unbindContainerMouseLeave();
                a.chartCount || (a.unbindDocumentMouseUp && (a.unbindDocumentMouseUp = a.unbindDocumentMouseUp()), a.unbindDocumentTouchEnd && (a.unbindDocumentTouchEnd = a.unbindDocumentTouchEnd()));
                clearInterval(c.tooltipTimeout);
                a.objectEach(c, function(a, d) {
                    c[d] = null;
                });
            }
        };
    })(K);
    (function(a) {
        var C = a.charts, F = a.each, I = a.extend, n = a.map, f = a.noop, e = a.pick;
        I(a.Pointer.prototype, {
            pinchTranslate: function(a, e, f, n, y, c) {
                this.zoomHor && this.pinchTranslateDirection(!0, a, e, f, n, y, c);
                this.zoomVert && this.pinchTranslateDirection(!1, a, e, f, n, y, c);
            },
            pinchTranslateDirection: function(a, e, f, n, y, c, h, p) {
                var k = this.chart, q = a ? "x" : "y", d = a ? "X" : "Y", b = "chart" + d, v = a ? "width" : "height", t = k["plot" + (a ? "Left" : "Top")], l, u, B = p || 1, D = k.inverted, m = k.bounds[a ? "h" : "v"], G = 1 === e.length, A = e[0][b], N = f[0][b], E = !G && e[1][b], g = !G && f[1][b], r;
                f = function() {
                    !G && 20 < Math.abs(A - E) && (B = p || Math.abs(N - g) / Math.abs(A - E));
                    u = (t - N) / B + A;
                    l = k["plot" + (a ? "Width" : "Height")] / B;
                };
                f();
                e = u;
                e < m.min ? (e = m.min, r = !0) : e + l > m.max && (e = m.max - l, r = !0);
                r ? (N -= .8 * (N - h[q][0]), G || (g -= .8 * (g - h[q][1])), f()) : h[q] = [
                    N,
                    g
                ];
                D || (c[q] = u - t, c[v] = l);
                c = D ? 1 / B : B;
                y[v] = l;
                y[q] = e;
                n[D ? a ? "scaleY" : "scaleX" : "scale" + d] = B;
                n["translate" + d] = c * t + (N - c * A);
            },
            pinch: function(a) {
                var u = this, t = u.chart, w = u.pinchDown, y = a.touches, c = y.length, h = u.lastValidTouch, p = u.hasZoom, k = u.selectionMarker, q = {}, d = 1 === c && (u.inClass(a.target, "highcharts-tracker") && t.runTrackerClick || u.runChartClick), b = {};
                1 < c && (u.initiated = !0);
                p && u.initiated && !d && a.preventDefault();
                n(y, function(a) {
                    return u.normalize(a);
                });
                "touchstart" === a.type ? (F(y, function(a, b) {
                    w[b] = {
                        chartX: a.chartX,
                        chartY: a.chartY
                    };
                }), h.x = [
                    w[0].chartX,
                    w[1] && w[1].chartX
                ], h.y = [
                    w[0].chartY,
                    w[1] && w[1].chartY
                ], F(t.axes, function(a) {
                    if (a.zoomEnabled) {
                        var b = t.bounds[a.horiz ? "h" : "v"], c = a.minPixelPadding, d = a.toPixels(e(a.options.min, a.dataMin)), k = a.toPixels(e(a.options.max, a.dataMax)), h = Math.max(d, k);
                        b.min = Math.min(a.pos, Math.min(d, k) - c);
                        b.max = Math.max(a.pos + a.len, h + c);
                    }
                }), u.res = !0) : u.followTouchMove && 1 === c ? this.runPointActions(u.normalize(a)) : w.length && (k || (u.selectionMarker = k = I({
                    destroy: f,
                    touch: !0
                }, t.plotBox)), u.pinchTranslate(w, y, q, k, b, h), u.hasPinched = p, u.scaleGroups(q, b), u.res && (u.res = !1, this.reset(!1, 0)));
            },
            touch: function(f, n) {
                var t = this.chart, u, y;
                if (t.index !== a.hoverChartIndex) this.onContainerMouseLeave({
                    relatedTarget: !0
                });
                a.hoverChartIndex = t.index;
                1 === f.touches.length ? (f = this.normalize(f), (y = t.isInsidePlot(f.chartX - t.plotLeft, f.chartY - t.plotTop)) && !t.openMenu ? (n && this.runPointActions(f), "touchmove" === f.type && (n = this.pinchDown, u = n[0] ? 4 <= Math.sqrt(Math.pow(n[0].chartX - f.chartX, 2) + Math.pow(n[0].chartY - f.chartY, 2)) : !1), e(u, !0) && this.pinch(f)) : n && this.reset()) : 2 === f.touches.length && this.pinch(f);
            },
            onContainerTouchStart: function(a) {
                this.zoomOption(a);
                this.touch(a, !0);
            },
            onContainerTouchMove: function(a) {
                this.touch(a);
            },
            onDocumentTouchEnd: function(e) {
                C[a.hoverChartIndex] && C[a.hoverChartIndex].pointer.drop(e);
            }
        });
    })(K);
    (function(a) {
        var C = a.addEvent, F = a.charts, I = a.css, n = a.doc, f = a.extend, e = a.noop, u = a.Pointer, x = a.removeEvent, t = a.win, w = a.wrap;
        if (!a.hasTouch && (t.PointerEvent || t.MSPointerEvent)) {
            var y = {}, c = !!t.PointerEvent, h = function() {
                var c = [];
                c.item = function(a) {
                    return this[a];
                };
                a.objectEach(y, function(a) {
                    c.push({
                        pageX: a.pageX,
                        pageY: a.pageY,
                        target: a.target
                    });
                });
                return c;
            }, p = function(c, q, d, b) {
                "touch" !== c.pointerType && c.pointerType !== c.MSPOINTER_TYPE_TOUCH || !F[a.hoverChartIndex] || (b(c), b = F[a.hoverChartIndex].pointer, b[q]({
                    type: d,
                    target: c.currentTarget,
                    preventDefault: e,
                    touches: h()
                }));
            };
            f(u.prototype, {
                onContainerPointerDown: function(a) {
                    p(a, "onContainerTouchStart", "touchstart", function(a) {
                        y[a.pointerId] = {
                            pageX: a.pageX,
                            pageY: a.pageY,
                            target: a.currentTarget
                        };
                    });
                },
                onContainerPointerMove: function(a) {
                    p(a, "onContainerTouchMove", "touchmove", function(a) {
                        y[a.pointerId] = {
                            pageX: a.pageX,
                            pageY: a.pageY
                        };
                        y[a.pointerId].target || (y[a.pointerId].target = a.currentTarget);
                    });
                },
                onDocumentPointerUp: function(a) {
                    p(a, "onDocumentTouchEnd", "touchend", function(a) {
                        delete y[a.pointerId];
                    });
                },
                batchMSEvents: function(a) {
                    a(this.chart.container, c ? "pointerdown" : "MSPointerDown", this.onContainerPointerDown);
                    a(this.chart.container, c ? "pointermove" : "MSPointerMove", this.onContainerPointerMove);
                    a(n, c ? "pointerup" : "MSPointerUp", this.onDocumentPointerUp);
                }
            });
            w(u.prototype, "init", function(a, c, d) {
                a.call(this, c, d);
                this.hasZoom && I(c.container, {
                    "-ms-touch-action": "none",
                    "touch-action": "none"
                });
            });
            w(u.prototype, "setDOMEvents", function(a) {
                a.apply(this);
                (this.hasZoom || this.followTouchMove) && this.batchMSEvents(C);
            });
            w(u.prototype, "destroy", function(a) {
                this.batchMSEvents(x);
                a.call(this);
            });
        }
    })(K);
    (function(a) {
        var C = a.addEvent, F = a.css, I = a.discardElement, n = a.defined, f = a.each, e = a.fireEvent, u = a.isFirefox, x = a.marginNames, t = a.merge, w = a.pick, y = a.setAnimation, c = a.stableSort, h = a.win, p = a.wrap;
        a.Legend = function(a, c) {
            this.init(a, c);
        };
        a.Legend.prototype = {
            init: function(a, c) {
                this.chart = a;
                this.setOptions(c);
                c.enabled && (this.render(), C(this.chart, "endResize", function() {
                    this.legend.positionCheckboxes();
                }), this.proximate ? this.unchartrender = C(this.chart, "render", function() {
                    this.legend.proximatePositions();
                    this.legend.positionItems();
                }) : this.unchartrender && this.unchartrender());
            },
            setOptions: function(a) {
                var c = w(a.padding, 8);
                this.options = a;
                this.itemStyle = a.itemStyle;
                this.itemHiddenStyle = t(this.itemStyle, a.itemHiddenStyle);
                this.itemMarginTop = a.itemMarginTop || 0;
                this.padding = c;
                this.initialItemY = c - 5;
                this.symbolWidth = w(a.symbolWidth, 16);
                this.pages = [];
                this.proximate = "proximate" === a.layout && !this.chart.inverted;
            },
            update: function(a, c) {
                var d = this.chart;
                this.setOptions(t(!0, this.options, a));
                this.destroy();
                d.isDirtyLegend = d.isDirtyBox = !0;
                w(c, !0) && d.redraw();
                e(this, "afterUpdate");
            },
            colorizeItem: function(a, c) {
                a.legendGroup[c ? "removeClass" : "addClass"]("highcharts-legend-item-hidden");
                var d = this.options, b = a.legendItem, k = a.legendLine, h = a.legendSymbol, l = this.itemHiddenStyle.color, d = c ? d.itemStyle.color : l, q = c ? a.color || l : l, f = a.options && a.options.marker, p = {
                    fill: q
                };
                b && b.css({
                    fill: d,
                    color: d
                });
                k && k.attr({
                    stroke: q
                });
                h && (f && h.isMarker && (p = a.pointAttribs(), c || (p.stroke = p.fill = l)), h.attr(p));
                e(this, "afterColorizeItem", {
                    item: a,
                    visible: c
                });
            },
            positionItems: function() {
                f(this.allItems, this.positionItem, this);
                this.chart.isResizing || this.positionCheckboxes();
            },
            positionItem: function(a) {
                var c = this.options, d = c.symbolPadding, c = !c.rtl, b = a._legendItemPos, e = b[0], b = b[1], h = a.checkbox;
                if ((a = a.legendGroup) && a.element) a[n(a.translateY) ? "animate" : "attr"]({
                    translateX: c ? e : this.legendWidth - e - 2 * d - 4,
                    translateY: b
                });
                h && (h.x = e, h.y = b);
            },
            destroyItem: function(a) {
                var c = a.checkbox;
                f([
                    "legendItem",
                    "legendLine",
                    "legendSymbol",
                    "legendGroup"
                ], function(c) {
                    a[c] && (a[c] = a[c].destroy());
                });
                c && I(a.checkbox);
            },
            destroy: function() {
                function a(a) {
                    this[a] && (this[a] = this[a].destroy());
                }
                f(this.getAllItems(), function(c) {
                    f([
                        "legendItem",
                        "legendGroup"
                    ], a, c);
                });
                f("clipRect up down pager nav box title group".split(" "), a, this);
                this.display = null;
            },
            positionCheckboxes: function() {
                var a = this.group && this.group.alignAttr, c, d = this.clipHeight || this.legendHeight, b = this.titleHeight;
                a && (c = a.translateY, f(this.allItems, function(e) {
                    var h = e.checkbox, k;
                    h && (k = c + b + h.y + (this.scrollOffset || 0) + 3, F(h, {
                        left: a.translateX + e.checkboxOffset + h.x - 20 + "px",
                        top: k + "px",
                        display: this.proximate || k > c - 6 && k < c + d - 6 ? "" : "none"
                    }));
                }, this));
            },
            renderTitle: function() {
                var a = this.options, c = this.padding, d = a.title, b = 0;
                d.text && (this.title || (this.title = this.chart.renderer.label(d.text, c - 3, c - 4, null, null, null, a.useHTML, null, "legend-title").attr({
                    zIndex: 1
                }).css(d.style).add(this.group)), a = this.title.getBBox(), b = a.height, this.offsetWidth = a.width, this.contentGroup.attr({
                    translateY: b
                }));
                this.titleHeight = b;
            },
            setText: function(c) {
                var h = this.options;
                c.legendItem.attr({
                    text: h.labelFormat ? a.format(h.labelFormat, c, this.chart.time) : h.labelFormatter.call(c)
                });
            },
            renderItem: function(a) {
                var c = this.chart, d = c.renderer, b = this.options, h = this.symbolWidth, e = b.symbolPadding, l = this.itemStyle, k = this.itemHiddenStyle, f = "horizontal" === b.layout ? w(b.itemDistance, 20) : 0, p = !b.rtl, m = a.legendItem, G = !a.series, A = !G && a.series.drawLegendSymbol ? a.series : a, n = A.options, n = this.createCheckboxForItem && n && n.showCheckbox, f = h + e + f + (n ? 20 : 0), E = b.useHTML, g = a.options.className;
                m || (a.legendGroup = d.g("legend-item").addClass("highcharts-" + A.type + "-series highcharts-color-" + a.colorIndex + (g ? " " + g : "") + (G ? " highcharts-series-" + a.index : "")).attr({
                    zIndex: 1
                }).add(this.scrollGroup), a.legendItem = m = d.text("", p ? h + e : -e, this.baseline || 0, E).css(t(a.visible ? l : k)).attr({
                    align: p ? "left" : "right",
                    zIndex: 2
                }).add(a.legendGroup), this.baseline || (h = l.fontSize, this.fontMetrics = d.fontMetrics(h, m), this.baseline = this.fontMetrics.f + 3 + this.itemMarginTop, m.attr("y", this.baseline)), this.symbolHeight = b.symbolHeight || this.fontMetrics.f, A.drawLegendSymbol(this, a), this.setItemEvents && this.setItemEvents(a, m, E), n && this.createCheckboxForItem(a));
                this.colorizeItem(a, a.visible);
                l.width || m.css({
                    width: (b.itemWidth || b.width || c.spacingBox.width) - f
                });
                this.setText(a);
                c = m.getBBox();
                a.itemWidth = a.checkboxOffset = b.itemWidth || a.legendItemWidth || c.width + f;
                this.maxItemWidth = Math.max(this.maxItemWidth, a.itemWidth);
                this.totalItemWidth += a.itemWidth;
                this.itemHeight = a.itemHeight = Math.round(a.legendItemHeight || c.height || this.symbolHeight);
            },
            layoutItem: function(a) {
                var c = this.options, d = this.padding, b = "horizontal" === c.layout, h = a.itemHeight, e = c.itemMarginBottom || 0, l = this.itemMarginTop, k = b ? w(c.itemDistance, 20) : 0, f = c.width, p = f || this.chart.spacingBox.width - 2 * d - c.x, c = c.alignColumns && this.totalItemWidth > p ? this.maxItemWidth : a.itemWidth;
                b && this.itemX - d + c > p && (this.itemX = d, this.itemY += l + this.lastLineHeight + e, this.lastLineHeight = 0);
                this.lastItemY = l + this.itemY + e;
                this.lastLineHeight = Math.max(h, this.lastLineHeight);
                a._legendItemPos = [
                    this.itemX,
                    this.itemY
                ];
                b ? this.itemX += c : (this.itemY += l + h + e, this.lastLineHeight = h);
                this.offsetWidth = f || Math.max((b ? this.itemX - d - (a.checkbox ? 0 : k) : c) + d, this.offsetWidth);
            },
            getAllItems: function() {
                var a = [];
                f(this.chart.series, function(c) {
                    var d = c && c.options;
                    c && w(d.showInLegend, n(d.linkedTo) ? !1 : void 0, !0) && (a = a.concat(c.legendItems || ("point" === d.legendType ? c.data : c)));
                });
                e(this, "afterGetAllItems", {
                    allItems: a
                });
                return a;
            },
            getAlignment: function() {
                var a = this.options;
                return this.proximate ? a.align.charAt(0) + "tv" : a.floating ? "" : a.align.charAt(0) + a.verticalAlign.charAt(0) + a.layout.charAt(0);
            },
            adjustMargins: function(a, c) {
                var d = this.chart, b = this.options, h = this.getAlignment();
                h && f([
                    /(lth|ct|rth)/,
                    /(rtv|rm|rbv)/,
                    /(rbh|cb|lbh)/,
                    /(lbv|lm|ltv)/
                ], function(e, l) {
                    e.test(h) && !n(a[l]) && (d[x[l]] = Math.max(d[x[l]], d.legend[(l + 1) % 2 ? "legendHeight" : "legendWidth"] + [
                        1,
                        -1,
                        -1,
                        1
                    ][l] * b[l % 2 ? "x" : "y"] + w(b.margin, 12) + c[l] + (0 === l && void 0 !== d.options.title.margin ? d.titleOffset + d.options.title.margin : 0)));
                });
            },
            proximatePositions: function() {
                var c = this.chart, h = [], d = "left" === this.options.align;
                f(this.allItems, function(b) {
                    var e, k;
                    e = d;
                    b.xAxis && b.points && (b.xAxis.options.reversed && (e = !e), e = a.find(e ? b.points : b.points.slice(0).reverse(), function(b) {
                        return a.isNumber(b.plotY);
                    }), k = b.legendGroup.getBBox().height, h.push({
                        target: b.visible ? (e ? e.plotY : b.xAxis.height) - .3 * k : c.plotHeight,
                        size: k,
                        item: b
                    }));
                }, this);
                a.distribute(h, c.plotHeight);
                f(h, function(a) {
                    a.item._legendItemPos[1] = c.plotTop - c.spacing[0] + a.pos;
                });
            },
            render: function() {
                var a = this.chart, h = a.renderer, d = this.group, b, e, p, l = this.box, n = this.options, B = this.padding;
                this.itemX = B;
                this.itemY = this.initialItemY;
                this.lastItemY = this.offsetWidth = 0;
                d || (this.group = d = h.g("legend").attr({
                    zIndex: 7
                }).add(), this.contentGroup = h.g().attr({
                    zIndex: 1
                }).add(d), this.scrollGroup = h.g().add(this.contentGroup));
                this.renderTitle();
                b = this.getAllItems();
                c(b, function(a, b) {
                    return (a.options && a.options.legendIndex || 0) - (b.options && b.options.legendIndex || 0);
                });
                n.reversed && b.reverse();
                this.allItems = b;
                this.display = e = !!b.length;
                this.itemHeight = this.totalItemWidth = this.maxItemWidth = this.lastLineHeight = 0;
                f(b, this.renderItem, this);
                f(b, this.layoutItem, this);
                b = (n.width || this.offsetWidth) + B;
                p = this.lastItemY + this.lastLineHeight + this.titleHeight;
                p = this.handleOverflow(p);
                p += B;
                l || (this.box = l = h.rect().addClass("highcharts-legend-box").attr({
                    r: n.borderRadius
                }).add(d), l.isNew = !0);
                l.attr({
                    stroke: n.borderColor,
                    "stroke-width": n.borderWidth || 0,
                    fill: n.backgroundColor || "none"
                }).shadow(n.shadow);
                0 < b && 0 < p && (l[l.isNew ? "attr" : "animate"](l.crisp.call({}, {
                    x: 0,
                    y: 0,
                    width: b,
                    height: p
                }, l.strokeWidth())), l.isNew = !1);
                l[e ? "show" : "hide"]();
                this.legendWidth = b;
                this.legendHeight = p;
                e && (h = a.spacingBox, /(lth|ct|rth)/.test(this.getAlignment()) && (h = t(h, {
                    y: h.y + a.titleOffset + a.options.title.margin
                })), d.align(t(n, {
                    width: b,
                    height: p,
                    verticalAlign: this.proximate ? "top" : n.verticalAlign
                }), !0, h));
                this.proximate || this.positionItems();
            },
            handleOverflow: function(a) {
                var c = this, d = this.chart, b = d.renderer, h = this.options, e = h.y, l = this.padding, d = d.spacingBox.height + ("top" === h.verticalAlign ? -e : e) - l, e = h.maxHeight, k, p = this.clipRect, n = h.navigation, m = w(n.animation, !0), G = n.arrowSize || 12, A = this.nav, t = this.pages, E, g = this.allItems, r = function(a) {
                    "number" === typeof a ? p.attr({
                        height: a
                    }) : p && (c.clipRect = p.destroy(), c.contentGroup.clip());
                    c.contentGroup.div && (c.contentGroup.div.style.clip = a ? "rect(" + l + "px,9999px," + (l + a) + "px,0)" : "auto");
                };
                "horizontal" !== h.layout || "middle" === h.verticalAlign || h.floating || (d /= 2);
                e && (d = Math.min(d, e));
                t.length = 0;
                a > d && !1 !== n.enabled ? (this.clipHeight = k = Math.max(d - 20 - this.titleHeight - l, 0), this.currentPage = w(this.currentPage, 1), this.fullHeight = a, f(g, function(a, b) {
                    var c = a._legendItemPos[1], d = Math.round(a.legendItem.getBBox().height), m = t.length;
                    if (!m || c - t[m - 1] > k && (E || c) !== t[m - 1]) t.push(E || c), m++;
                    a.pageIx = m - 1;
                    E && (g[b - 1].pageIx = m - 1);
                    b === g.length - 1 && c + d - t[m - 1] > k && (t.push(c), a.pageIx = m);
                    c !== E && (E = c);
                }), p || (p = c.clipRect = b.clipRect(0, l, 9999, 0), c.contentGroup.clip(p)), r(k), A || (this.nav = A = b.g().attr({
                    zIndex: 1
                }).add(this.group), this.up = b.symbol("triangle", 0, 0, G, G).on("click", function() {
                    c.scroll(-1, m);
                }).add(A), this.pager = b.text("", 15, 10).addClass("highcharts-legend-navigation").css(n.style).add(A), this.down = b.symbol("triangle-down", 0, 0, G, G).on("click", function() {
                    c.scroll(1, m);
                }).add(A)), c.scroll(0), a = d) : A && (r(), this.nav = A.destroy(), this.scrollGroup.attr({
                    translateY: 1
                }), this.clipHeight = 0);
                return a;
            },
            scroll: function(a, c) {
                var d = this.pages, b = d.length;
                a = this.currentPage + a;
                var h = this.clipHeight, e = this.options.navigation, l = this.pager, f = this.padding;
                a > b && (a = b);
                0 < a && (void 0 !== c && y(c, this.chart), this.nav.attr({
                    translateX: f,
                    translateY: h + this.padding + 7 + this.titleHeight,
                    visibility: "visible"
                }), this.up.attr({
                    "class": 1 === a ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active"
                }), l.attr({
                    text: a + "/" + b
                }), this.down.attr({
                    x: 18 + this.pager.getBBox().width,
                    "class": a === b ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active"
                }), this.up.attr({
                    fill: 1 === a ? e.inactiveColor : e.activeColor
                }).css({
                    cursor: 1 === a ? "default" : "pointer"
                }), this.down.attr({
                    fill: a === b ? e.inactiveColor : e.activeColor
                }).css({
                    cursor: a === b ? "default" : "pointer"
                }), this.scrollOffset = -d[a - 1] + this.initialItemY, this.scrollGroup.animate({
                    translateY: this.scrollOffset
                }), this.currentPage = a, this.positionCheckboxes());
            }
        };
        a.LegendSymbolMixin = {
            drawRectangle: function(a, c) {
                var d = a.symbolHeight, b = a.options.squareSymbol;
                c.legendSymbol = this.chart.renderer.rect(b ? (a.symbolWidth - d) / 2 : 0, a.baseline - d + 1, b ? d : a.symbolWidth, d, w(a.options.symbolRadius, d / 2)).addClass("highcharts-point").attr({
                    zIndex: 3
                }).add(c.legendGroup);
            },
            drawLineMarker: function(a) {
                var c = this.options, d = c.marker, b = a.symbolWidth, h = a.symbolHeight, e = h / 2, l = this.chart.renderer, f = this.legendGroup;
                a = a.baseline - Math.round(.3 * a.fontMetrics.b);
                var k;
                k = {
                    "stroke-width": c.lineWidth || 0
                };
                c.dashStyle && (k.dashstyle = c.dashStyle);
                this.legendLine = l.path([
                    "M",
                    0,
                    a,
                    "L",
                    b,
                    a
                ]).addClass("highcharts-graph").attr(k).add(f);
                d && !1 !== d.enabled && b && (c = Math.min(w(d.radius, e), e), 0 === this.symbol.indexOf("url") && (d = t(d, {
                    width: h,
                    height: h
                }), c = 0), this.legendSymbol = d = l.symbol(this.symbol, b / 2 - c, a - c, 2 * c, 2 * c, d).addClass("highcharts-point").add(f), d.isMarker = !0);
            }
        };
        (/Trident\/7\.0/.test(h.navigator.userAgent) || u) && p(a.Legend.prototype, "positionItem", function(a, c) {
            var d = this, b = function() {
                c._legendItemPos && a.call(d, c);
            };
            b();
            setTimeout(b);
        });
    })(K);
    (function(a) {
        var C = a.addEvent, F = a.animate, I = a.animObject, n = a.attr, f = a.doc, e = a.Axis, u = a.createElement, x = a.defaultOptions, t = a.discardElement, w = a.charts, y = a.css, c = a.defined, h = a.each, p = a.extend, k = a.find, q = a.fireEvent, d = a.grep, b = a.isNumber, v = a.isObject, J = a.isString, l = a.Legend, L = a.marginNames, B = a.merge, D = a.objectEach, m = a.Pointer, G = a.pick, A = a.pInt, N = a.removeEvent, E = a.seriesTypes, g = a.splat, r = a.syncTimeout, M = a.win, O = a.Chart = function() {
            this.getArgs.apply(this, arguments);
        };
        a.chart = function(a, b, c) {
            return new O(a, b, c);
        };
        p(O.prototype, {
            callbacks: [],
            getArgs: function() {
                var a = [].slice.call(arguments);
                if (J(a[0]) || a[0].nodeName) this.renderTo = a.shift();
                this.init(a[0], a[1]);
            },
            init: function(b, c) {
                var d, g, m = b.series, h = b.plotOptions || {};
                q(this, "init", {
                    args: arguments
                }, function() {
                    b.series = null;
                    d = B(x, b);
                    for(g in d.plotOptions)d.plotOptions[g].tooltip = h[g] && B(h[g].tooltip) || void 0;
                    d.tooltip.userOptions = b.chart && b.chart.forExport && b.tooltip.userOptions || b.tooltip;
                    d.series = b.series = m;
                    this.userOptions = b;
                    var e = d.chart, l = e.events;
                    this.margin = [];
                    this.spacing = [];
                    this.bounds = {
                        h: {},
                        v: {}
                    };
                    this.labelCollectors = [];
                    this.callback = c;
                    this.isResizing = 0;
                    this.options = d;
                    this.axes = [];
                    this.series = [];
                    this.time = b.time && a.keys(b.time).length ? new a.Time(b.time) : a.time;
                    this.hasCartesianSeries = e.showAxes;
                    var f = this;
                    f.index = w.length;
                    w.push(f);
                    a.chartCount++;
                    l && D(l, function(a, b) {
                        C(f, b, a);
                    });
                    f.xAxis = [];
                    f.yAxis = [];
                    f.pointCount = f.colorCounter = f.symbolCounter = 0;
                    q(f, "afterInit");
                    f.firstRender();
                });
            },
            initSeries: function(b) {
                var c = this.options.chart;
                (c = E[b.type || c.type || c.defaultSeriesType]) || a.error(17, !0);
                c = new c;
                c.init(this, b);
                return c;
            },
            orderSeries: function(a) {
                var b = this.series;
                for(a = a || 0; a < b.length; a++)b[a] && (b[a].index = a, b[a].name = b[a].getName());
            },
            isInsidePlot: function(a, b, c) {
                var d = c ? b : a;
                a = c ? a : b;
                return 0 <= d && d <= this.plotWidth && 0 <= a && a <= this.plotHeight;
            },
            redraw: function(b) {
                q(this, "beforeRedraw");
                var c = this.axes, d = this.series, g = this.pointer, m = this.legend, e = this.userOptions.legend, l = this.isDirtyLegend, f, A, k = this.hasCartesianSeries, r = this.isDirtyBox, G, v = this.renderer, H = v.isHidden(), E = [];
                this.setResponsive && this.setResponsive(!1);
                a.setAnimation(b, this);
                H && this.temporaryDisplay();
                this.layOutTitles();
                for(b = d.length; b--;)if (G = d[b], G.options.stacking && (f = !0, G.isDirty)) {
                    A = !0;
                    break;
                }
                if (A) for(b = d.length; b--;)G = d[b], G.options.stacking && (G.isDirty = !0);
                h(d, function(a) {
                    a.isDirty && ("point" === a.options.legendType ? (a.updateTotals && a.updateTotals(), l = !0) : e && (e.labelFormatter || e.labelFormat) && (l = !0));
                    a.isDirtyData && q(a, "updatedData");
                });
                l && m && m.options.enabled && (m.render(), this.isDirtyLegend = !1);
                f && this.getStacks();
                k && h(c, function(a) {
                    a.updateNames();
                    a.updateYNames && a.updateYNames();
                    a.setScale();
                });
                this.getMargins();
                k && (h(c, function(a) {
                    a.isDirty && (r = !0);
                }), h(c, function(a) {
                    var b = a.min + "," + a.max;
                    a.extKey !== b && (a.extKey = b, E.push(function() {
                        q(a, "afterSetExtremes", p(a.eventArgs, a.getExtremes()));
                        delete a.eventArgs;
                    }));
                    (r || f) && a.redraw();
                }));
                r && this.drawChartBox();
                q(this, "predraw");
                h(d, function(a) {
                    (r || a.isDirty) && a.visible && a.redraw();
                    a.isDirtyData = !1;
                });
                g && g.reset(!0);
                v.draw();
                q(this, "redraw");
                q(this, "render");
                H && this.temporaryDisplay(!0);
                h(E, function(a) {
                    a.call();
                });
            },
            get: function(a) {
                function b(b) {
                    return b.id === a || b.options && b.options.id === a;
                }
                var c, d = this.series, g;
                c = k(this.axes, b) || k(this.series, b);
                for(g = 0; !c && g < d.length; g++)c = k(d[g].points || [], b);
                return c;
            },
            getAxes: function() {
                var a = this, b = this.options, c = b.xAxis = g(b.xAxis || {}), b = b.yAxis = g(b.yAxis || {});
                q(this, "getAxes");
                h(c, function(a, b) {
                    a.index = b;
                    a.isX = !0;
                });
                h(b, function(a, b) {
                    a.index = b;
                });
                c = c.concat(b);
                h(c, function(b) {
                    new e(a, b);
                });
                q(this, "afterGetAxes");
            },
            getSelectedPoints: function() {
                var a = [];
                h(this.series, function(b) {
                    a = a.concat(d(b.data || [], function(a) {
                        return a.selected;
                    }));
                });
                return a;
            },
            getSelectedSeries: function() {
                return d(this.series, function(a) {
                    return a.selected;
                });
            },
            setTitle: function(a, b, c) {
                var d = this, g = d.options, m;
                m = g.title = B({
                    style: {
                        color: "#333333",
                        fontSize: g.isStock ? "16px" : "18px"
                    }
                }, g.title, a);
                g = g.subtitle = B({
                    style: {
                        color: "#666666"
                    }
                }, g.subtitle, b);
                h([
                    [
                        "title",
                        a,
                        m
                    ],
                    [
                        "subtitle",
                        b,
                        g
                    ]
                ], function(a, b) {
                    var c = a[0], g = d[c], m = a[1];
                    a = a[2];
                    g && m && (d[c] = g = g.destroy());
                    a && !g && (d[c] = d.renderer.text(a.text, 0, 0, a.useHTML).attr({
                        align: a.align,
                        "class": "highcharts-" + c,
                        zIndex: a.zIndex || 4
                    }).add(), d[c].update = function(a) {
                        d.setTitle(!b && a, b && a);
                    }, d[c].css(a.style));
                });
                d.layOutTitles(c);
            },
            layOutTitles: function(a) {
                var b = 0, c, d = this.renderer, g = this.spacingBox;
                h([
                    "title",
                    "subtitle"
                ], function(a) {
                    var c = this[a], m = this.options[a];
                    a = "title" === a ? -3 : m.verticalAlign ? 0 : b + 2;
                    var h;
                    c && (h = m.style.fontSize, h = d.fontMetrics(h, c).b, c.css({
                        width: (m.width || g.width + m.widthAdjust) + "px"
                    }).align(p({
                        y: a + h
                    }, m), !1, "spacingBox"), m.floating || m.verticalAlign || (b = Math.ceil(b + c.getBBox(m.useHTML).height)));
                }, this);
                c = this.titleOffset !== b;
                this.titleOffset = b;
                !this.isDirtyBox && c && (this.isDirtyBox = this.isDirtyLegend = c, this.hasRendered && G(a, !0) && this.isDirtyBox && this.redraw());
            },
            getChartSize: function() {
                var b = this.options.chart, d = b.width, b = b.height, g = this.renderTo;
                c(d) || (this.containerWidth = a.getStyle(g, "width"));
                c(b) || (this.containerHeight = a.getStyle(g, "height"));
                this.chartWidth = Math.max(0, d || this.containerWidth || 600);
                this.chartHeight = Math.max(0, a.relativeLength(b, this.chartWidth) || (1 < this.containerHeight ? this.containerHeight : 400));
            },
            temporaryDisplay: function(b) {
                var c = this.renderTo;
                if (b) for(; c && c.style;)c.hcOrigStyle && (a.css(c, c.hcOrigStyle), delete c.hcOrigStyle), c.hcOrigDetached && (f.body.removeChild(c), c.hcOrigDetached = !1), c = c.parentNode;
                else for(; c && c.style;){
                    f.body.contains(c) || c.parentNode || (c.hcOrigDetached = !0, f.body.appendChild(c));
                    if ("none" === a.getStyle(c, "display", !1) || c.hcOricDetached) c.hcOrigStyle = {
                        display: c.style.display,
                        height: c.style.height,
                        overflow: c.style.overflow
                    }, b = {
                        display: "block",
                        overflow: "hidden"
                    }, c !== this.renderTo && (b.height = 0), a.css(c, b), c.offsetWidth || c.style.setProperty("display", "block", "important");
                    c = c.parentNode;
                    if (c === f.body) break;
                }
            },
            setClassName: function(a) {
                this.container.className = "highcharts-container " + (a || "");
            },
            getContainer: function() {
                var c, d = this.options, g = d.chart, m, h;
                c = this.renderTo;
                var e = a.uniqueKey(), l;
                c || (this.renderTo = c = g.renderTo);
                J(c) && (this.renderTo = c = f.getElementById(c));
                c || a.error(13, !0);
                m = A(n(c, "data-highcharts-chart"));
                b(m) && w[m] && w[m].hasRendered && w[m].destroy();
                n(c, "data-highcharts-chart", this.index);
                c.innerHTML = "";
                g.skipClone || c.offsetWidth || this.temporaryDisplay();
                this.getChartSize();
                m = this.chartWidth;
                h = this.chartHeight;
                l = p({
                    position: "relative",
                    overflow: "hidden",
                    width: m + "px",
                    height: h + "px",
                    textAlign: "left",
                    lineHeight: "normal",
                    zIndex: 0,
                    "-webkit-tap-highlight-color": "rgba(0,0,0,0)"
                }, g.style);
                this.container = c = u("div", {
                    id: e
                }, l, c);
                this._cursor = c.style.cursor;
                this.renderer = new (a[g.renderer] || a.Renderer)(c, m, h, null, g.forExport, d.exporting && d.exporting.allowHTML);
                this.setClassName(g.className);
                this.renderer.setStyle(g.style);
                this.renderer.chartIndex = this.index;
                q(this, "afterGetContainer");
            },
            getMargins: function(a) {
                var b = this.spacing, d = this.margin, g = this.titleOffset;
                this.resetMargins();
                g && !c(d[0]) && (this.plotTop = Math.max(this.plotTop, g + this.options.title.margin + b[0]));
                this.legend && this.legend.display && this.legend.adjustMargins(d, b);
                q(this, "getMargins");
                a || this.getAxisMargins();
            },
            getAxisMargins: function() {
                var a = this, b = a.axisOffset = [
                    0,
                    0,
                    0,
                    0
                ], d = a.margin;
                a.hasCartesianSeries && h(a.axes, function(a) {
                    a.visible && a.getOffset();
                });
                h(L, function(g, m) {
                    c(d[m]) || (a[g] += b[m]);
                });
                a.setChartSize();
            },
            reflow: function(b) {
                var d = this, g = d.options.chart, m = d.renderTo, h = c(g.width) && c(g.height), e = g.width || a.getStyle(m, "width"), g = g.height || a.getStyle(m, "height"), m = b ? b.target : M;
                if (!h && !d.isPrinting && e && g && (m === M || m === f)) {
                    if (e !== d.containerWidth || g !== d.containerHeight) a.clearTimeout(d.reflowTimeout), d.reflowTimeout = r(function() {
                        d.container && d.setSize(void 0, void 0, !1);
                    }, b ? 100 : 0);
                    d.containerWidth = e;
                    d.containerHeight = g;
                }
            },
            setReflow: function(a) {
                var b = this;
                !1 === a || this.unbindReflow ? !1 === a && this.unbindReflow && (this.unbindReflow = this.unbindReflow()) : (this.unbindReflow = C(M, "resize", function(a) {
                    b.reflow(a);
                }), C(this, "destroy", this.unbindReflow));
            },
            setSize: function(b, c, d) {
                var g = this, m = g.renderer;
                g.isResizing += 1;
                a.setAnimation(d, g);
                g.oldChartHeight = g.chartHeight;
                g.oldChartWidth = g.chartWidth;
                void 0 !== b && (g.options.chart.width = b);
                void 0 !== c && (g.options.chart.height = c);
                g.getChartSize();
                b = m.globalAnimation;
                (b ? F : y)(g.container, {
                    width: g.chartWidth + "px",
                    height: g.chartHeight + "px"
                }, b);
                g.setChartSize(!0);
                m.setSize(g.chartWidth, g.chartHeight, d);
                h(g.axes, function(a) {
                    a.isDirty = !0;
                    a.setScale();
                });
                g.isDirtyLegend = !0;
                g.isDirtyBox = !0;
                g.layOutTitles();
                g.getMargins();
                g.redraw(d);
                g.oldChartHeight = null;
                q(g, "resize");
                r(function() {
                    g && q(g, "endResize", null, function() {
                        --g.isResizing;
                    });
                }, I(b).duration);
            },
            setChartSize: function(a) {
                var b = this.inverted, c = this.renderer, g = this.chartWidth, d = this.chartHeight, m = this.options.chart, e = this.spacing, l = this.clipOffset, f, A, k, r;
                this.plotLeft = f = Math.round(this.plotLeft);
                this.plotTop = A = Math.round(this.plotTop);
                this.plotWidth = k = Math.max(0, Math.round(g - f - this.marginRight));
                this.plotHeight = r = Math.max(0, Math.round(d - A - this.marginBottom));
                this.plotSizeX = b ? r : k;
                this.plotSizeY = b ? k : r;
                this.plotBorderWidth = m.plotBorderWidth || 0;
                this.spacingBox = c.spacingBox = {
                    x: e[3],
                    y: e[0],
                    width: g - e[3] - e[1],
                    height: d - e[0] - e[2]
                };
                this.plotBox = c.plotBox = {
                    x: f,
                    y: A,
                    width: k,
                    height: r
                };
                g = 2 * Math.floor(this.plotBorderWidth / 2);
                b = Math.ceil(Math.max(g, l[3]) / 2);
                c = Math.ceil(Math.max(g, l[0]) / 2);
                this.clipBox = {
                    x: b,
                    y: c,
                    width: Math.floor(this.plotSizeX - Math.max(g, l[1]) / 2 - b),
                    height: Math.max(0, Math.floor(this.plotSizeY - Math.max(g, l[2]) / 2 - c))
                };
                a || h(this.axes, function(a) {
                    a.setAxisSize();
                    a.setAxisTranslation();
                });
                q(this, "afterSetChartSize", {
                    skipAxes: a
                });
            },
            resetMargins: function() {
                var a = this, b = a.options.chart;
                h([
                    "margin",
                    "spacing"
                ], function(c) {
                    var g = b[c], d = v(g) ? g : [
                        g,
                        g,
                        g,
                        g
                    ];
                    h([
                        "Top",
                        "Right",
                        "Bottom",
                        "Left"
                    ], function(g, m) {
                        a[c][m] = G(b[c + g], d[m]);
                    });
                });
                h(L, function(b, c) {
                    a[b] = G(a.margin[c], a.spacing[c]);
                });
                a.axisOffset = [
                    0,
                    0,
                    0,
                    0
                ];
                a.clipOffset = [
                    0,
                    0,
                    0,
                    0
                ];
            },
            drawChartBox: function() {
                var a = this.options.chart, b = this.renderer, c = this.chartWidth, g = this.chartHeight, d = this.chartBackground, m = this.plotBackground, h = this.plotBorder, e, l = this.plotBGImage, f = a.backgroundColor, A = a.plotBackgroundColor, k = a.plotBackgroundImage, r, p = this.plotLeft, G = this.plotTop, v = this.plotWidth, E = this.plotHeight, n = this.plotBox, B = this.clipRect, t = this.clipBox, u = "animate";
                d || (this.chartBackground = d = b.rect().addClass("highcharts-background").add(), u = "attr");
                e = a.borderWidth || 0;
                r = e + (a.shadow ? 8 : 0);
                f = {
                    fill: f || "none"
                };
                if (e || d["stroke-width"]) f.stroke = a.borderColor, f["stroke-width"] = e;
                d.attr(f).shadow(a.shadow);
                d[u]({
                    x: r / 2,
                    y: r / 2,
                    width: c - r - e % 2,
                    height: g - r - e % 2,
                    r: a.borderRadius
                });
                u = "animate";
                m || (u = "attr", this.plotBackground = m = b.rect().addClass("highcharts-plot-background").add());
                m[u](n);
                m.attr({
                    fill: A || "none"
                }).shadow(a.plotShadow);
                k && (l ? l.animate(n) : this.plotBGImage = b.image(k, p, G, v, E).add());
                B ? B.animate({
                    width: t.width,
                    height: t.height
                }) : this.clipRect = b.clipRect(t);
                u = "animate";
                h || (u = "attr", this.plotBorder = h = b.rect().addClass("highcharts-plot-border").attr({
                    zIndex: 1
                }).add());
                h.attr({
                    stroke: a.plotBorderColor,
                    "stroke-width": a.plotBorderWidth || 0,
                    fill: "none"
                });
                h[u](h.crisp({
                    x: p,
                    y: G,
                    width: v,
                    height: E
                }, -h.strokeWidth()));
                this.isDirtyBox = !1;
                q(this, "afterDrawChartBox");
            },
            propFromSeries: function() {
                var a = this, b = a.options.chart, c, g = a.options.series, d, m;
                h([
                    "inverted",
                    "angular",
                    "polar"
                ], function(h) {
                    c = E[b.type || b.defaultSeriesType];
                    m = b[h] || c && c.prototype[h];
                    for(d = g && g.length; !m && d--;)(c = E[g[d].type]) && c.prototype[h] && (m = !0);
                    a[h] = m;
                });
            },
            linkSeries: function() {
                var a = this, b = a.series;
                h(b, function(a) {
                    a.linkedSeries.length = 0;
                });
                h(b, function(b) {
                    var c = b.options.linkedTo;
                    J(c) && (c = ":previous" === c ? a.series[b.index - 1] : a.get(c)) && c.linkedParent !== b && (c.linkedSeries.push(b), b.linkedParent = c, b.visible = G(b.options.visible, c.options.visible, b.visible));
                });
                q(this, "afterLinkSeries");
            },
            renderSeries: function() {
                h(this.series, function(a) {
                    a.translate();
                    a.render();
                });
            },
            renderLabels: function() {
                var a = this, b = a.options.labels;
                b.items && h(b.items, function(c) {
                    var g = p(b.style, c.style), d = A(g.left) + a.plotLeft, m = A(g.top) + a.plotTop + 12;
                    delete g.left;
                    delete g.top;
                    a.renderer.text(c.html, d, m).attr({
                        zIndex: 2
                    }).css(g).add();
                });
            },
            render: function() {
                var a = this.axes, b = this.renderer, c = this.options, g, d, m;
                this.setTitle();
                this.legend = new l(this, c.legend);
                this.getStacks && this.getStacks();
                this.getMargins(!0);
                this.setChartSize();
                c = this.plotWidth;
                g = this.plotHeight = Math.max(this.plotHeight - 21, 0);
                h(a, function(a) {
                    a.setScale();
                });
                this.getAxisMargins();
                d = 1.1 < c / this.plotWidth;
                m = 1.05 < g / this.plotHeight;
                if (d || m) h(a, function(a) {
                    (a.horiz && d || !a.horiz && m) && a.setTickInterval(!0);
                }), this.getMargins();
                this.drawChartBox();
                this.hasCartesianSeries && h(a, function(a) {
                    a.visible && a.render();
                });
                this.seriesGroup || (this.seriesGroup = b.g("series-group").attr({
                    zIndex: 3
                }).add());
                this.renderSeries();
                this.renderLabels();
                this.addCredits();
                this.setResponsive && this.setResponsive();
                this.hasRendered = !0;
            },
            addCredits: function(a) {
                var b = this;
                a = B(!0, this.options.credits, a);
                a.enabled && !this.credits && (this.credits = this.renderer.text(a.text + (this.mapCredits || ""), 0, 0).addClass("highcharts-credits").on("click", function() {
                    a.href && (M.location.href = a.href);
                }).attr({
                    align: a.position.align,
                    zIndex: 8
                }).css(a.style).add().align(a.position), this.credits.update = function(a) {
                    b.credits = b.credits.destroy();
                    b.addCredits(a);
                });
            },
            destroy: function() {
                var b = this, c = b.axes, g = b.series, d = b.container, m, e = d && d.parentNode;
                q(b, "destroy");
                b.renderer.forExport ? a.erase(w, b) : w[b.index] = void 0;
                a.chartCount--;
                b.renderTo.removeAttribute("data-highcharts-chart");
                N(b);
                for(m = c.length; m--;)c[m] = c[m].destroy();
                this.scroller && this.scroller.destroy && this.scroller.destroy();
                for(m = g.length; m--;)g[m] = g[m].destroy();
                h("title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" "), function(a) {
                    var c = b[a];
                    c && c.destroy && (b[a] = c.destroy());
                });
                d && (d.innerHTML = "", N(d), e && t(d));
                D(b, function(a, c) {
                    delete b[c];
                });
            },
            firstRender: function() {
                var a = this, b = a.options;
                if (!a.isReadyToRender || a.isReadyToRender()) {
                    a.getContainer();
                    a.resetMargins();
                    a.setChartSize();
                    a.propFromSeries();
                    a.getAxes();
                    h(b.series || [], function(b) {
                        a.initSeries(b);
                    });
                    a.linkSeries();
                    q(a, "beforeRender");
                    m && (a.pointer = new m(a, b));
                    a.render();
                    if (!a.renderer.imgCount && a.onload) a.onload();
                    a.temporaryDisplay(!0);
                }
            },
            onload: function() {
                h([
                    this.callback
                ].concat(this.callbacks), function(a) {
                    a && void 0 !== this.index && a.apply(this, [
                        this
                    ]);
                }, this);
                q(this, "load");
                q(this, "render");
                c(this.index) && this.setReflow(this.options.chart.reflow);
                this.onload = null;
            }
        });
    })(K);
    (function(a) {
        var C = a.addEvent, F = a.Chart, I = a.each;
        C(F, "afterSetChartSize", function(n) {
            var f = this.options.chart.scrollablePlotArea;
            (f = f && f.minWidth) && !this.renderer.forExport && (this.scrollablePixels = f = Math.max(0, f - this.chartWidth)) && (this.plotWidth += f, this.clipBox.width += f, n.skipAxes || I(this.axes, function(e) {
                1 === e.side ? e.getPlotLinePath = function() {
                    var f = this.right, n;
                    this.right = f - e.chart.scrollablePixels;
                    n = a.Axis.prototype.getPlotLinePath.apply(this, arguments);
                    this.right = f;
                    return n;
                } : (e.setAxisSize(), e.setAxisTranslation());
            }));
        });
        C(F, "render", function() {
            this.scrollablePixels ? (this.setUpScrolling && this.setUpScrolling(), this.applyFixed()) : this.fixedDiv && this.applyFixed();
        });
        F.prototype.setUpScrolling = function() {
            this.scrollingContainer = a.createElement("div", {
                className: "highcharts-scrolling"
            }, {
                overflowX: "auto",
                WebkitOverflowScrolling: "touch"
            }, this.renderTo);
            this.innerContainer = a.createElement("div", {
                className: "highcharts-inner-container"
            }, null, this.scrollingContainer);
            this.innerContainer.appendChild(this.container);
            this.setUpScrolling = null;
        };
        F.prototype.applyFixed = function() {
            var n = this.container, f, e, u = !this.fixedDiv;
            u && (this.fixedDiv = a.createElement("div", {
                className: "highcharts-fixed"
            }, {
                position: "absolute",
                overflow: "hidden",
                pointerEvents: "none",
                zIndex: 2
            }, null, !0), this.renderTo.insertBefore(this.fixedDiv, this.renderTo.firstChild), this.fixedRenderer = f = new a.Renderer(this.fixedDiv, 0, 0), this.scrollableMask = f.path().attr({
                fill: a.color(this.options.chart.backgroundColor || "#fff").setOpacity(.85).get(),
                zIndex: -1
            }).addClass("highcharts-scrollable-mask").add(), a.each([
                this.inverted ? ".highcharts-xaxis" : ".highcharts-yaxis",
                this.inverted ? ".highcharts-xaxis-labels" : ".highcharts-yaxis-labels",
                ".highcharts-contextbutton",
                ".highcharts-credits",
                ".highcharts-legend",
                ".highcharts-subtitle",
                ".highcharts-title",
                ".highcharts-legend-checkbox"
            ], function(e) {
                a.each(n.querySelectorAll(e), function(a) {
                    (a.namespaceURI === f.SVG_NS ? f.box : f.box.parentNode).appendChild(a);
                    a.style.pointerEvents = "auto";
                });
            }));
            this.fixedRenderer.setSize(this.chartWidth, this.chartHeight);
            e = this.chartWidth + this.scrollablePixels;
            a.stop(this.container);
            this.container.style.width = e + "px";
            this.renderer.boxWrapper.attr({
                width: e,
                height: this.chartHeight,
                viewBox: [
                    0,
                    0,
                    e,
                    this.chartHeight
                ].join(" ")
            });
            this.chartBackground.attr({
                width: e
            });
            u && (e = this.options.chart.scrollablePlotArea, e.scrollPositionX && (this.scrollingContainer.scrollLeft = this.scrollablePixels * e.scrollPositionX));
            u = this.axisOffset;
            e = this.plotTop - u[0] - 1;
            var u = this.plotTop + this.plotHeight + u[2], x = this.plotLeft + this.plotWidth - this.scrollablePixels;
            this.scrollableMask.attr({
                d: this.scrollablePixels ? [
                    "M",
                    0,
                    e,
                    "L",
                    this.plotLeft - 1,
                    e,
                    "L",
                    this.plotLeft - 1,
                    u,
                    "L",
                    0,
                    u,
                    "Z",
                    "M",
                    x,
                    e,
                    "L",
                    this.chartWidth,
                    e,
                    "L",
                    this.chartWidth,
                    u,
                    "L",
                    x,
                    u,
                    "Z"
                ] : [
                    "M",
                    0,
                    0
                ]
            });
        };
    })(K);
    (function(a) {
        var C, F = a.each, I = a.extend, n = a.erase, f = a.fireEvent, e = a.format, u = a.isArray, x = a.isNumber, t = a.pick, w = a.uniqueKey, y = a.defined, c = a.removeEvent;
        a.Point = C = function() {};
        a.Point.prototype = {
            init: function(a, c, e) {
                this.series = a;
                this.color = a.color;
                this.applyOptions(c, e);
                this.id = y(this.id) ? this.id : w();
                a.options.colorByPoint ? (c = a.options.colors || a.chart.options.colors, this.color = this.color || c[a.colorCounter], c = c.length, e = a.colorCounter, a.colorCounter++, a.colorCounter === c && (a.colorCounter = 0)) : e = a.colorIndex;
                this.colorIndex = t(this.colorIndex, e);
                a.chart.pointCount++;
                f(this, "afterInit");
                return this;
            },
            applyOptions: function(a, c) {
                var e = this.series, h = e.options.pointValKey || e.pointValKey;
                a = C.prototype.optionsToObject.call(this, a);
                I(this, a);
                this.options = this.options ? I(this.options, a) : a;
                a.group && delete this.group;
                a.dataLabels && delete this.dataLabels;
                h && (this.y = this[h]);
                this.isNull = t(this.isValid && !this.isValid(), null === this.x || !x(this.y, !0));
                this.selected && (this.state = "select");
                "name" in this && void 0 === c && e.xAxis && e.xAxis.hasNames && (this.x = e.xAxis.nameToX(this));
                void 0 === this.x && e && (this.x = void 0 === c ? e.autoIncrement(this) : c);
                return this;
            },
            setNestedProperty: function(c, e, f) {
                f = f.split(".");
                a.reduce(f, function(c, d, b, h) {
                    c[d] = h.length - 1 === b ? e : a.isObject(c[d], !0) ? c[d] : {};
                    return c[d];
                }, c);
                return c;
            },
            optionsToObject: function(c) {
                var e = {}, h = this.series, f = h.options.keys, d = f || h.pointArrayMap || [
                    "y"
                ], b = d.length, v = 0, n = 0;
                if (x(c) || null === c) e[d[0]] = c;
                else if (u(c)) for(!f && c.length > b && (h = typeof c[0], "string" === h ? e.name = c[0] : "number" === h && (e.x = c[0]), v++); n < b;)f && void 0 === c[v] || (0 < d[n].indexOf(".") ? a.Point.prototype.setNestedProperty(e, c[v], d[n]) : e[d[n]] = c[v]), v++, n++;
                else "object" === typeof c && (e = c, c.dataLabels && (h._hasPointLabels = !0), c.marker && (h._hasPointMarkers = !0));
                return e;
            },
            getClassName: function() {
                return "highcharts-point" + (this.selected ? " highcharts-point-select" : "") + (this.negative ? " highcharts-negative" : "") + (this.isNull ? " highcharts-null-point" : "") + (void 0 !== this.colorIndex ? " highcharts-color-" + this.colorIndex : "") + (this.options.className ? " " + this.options.className : "") + (this.zone && this.zone.className ? " " + this.zone.className.replace("highcharts-negative", "") : "");
            },
            getZone: function() {
                var a = this.series, c = a.zones, a = a.zoneAxis || "y", e = 0, f;
                for(f = c[e]; this[a] >= f.value;)f = c[++e];
                this.nonZonedColor || (this.nonZonedColor = this.color);
                this.color = f && f.color && !this.options.color ? f.color : this.nonZonedColor;
                return f;
            },
            destroy: function() {
                var a = this.series.chart, e = a.hoverPoints, f;
                a.pointCount--;
                e && (this.setState(), n(e, this), e.length || (a.hoverPoints = null));
                if (this === a.hoverPoint) this.onMouseOut();
                if (this.graphic || this.dataLabel || this.dataLabels) c(this), this.destroyElements();
                this.legendItem && a.legend.destroyItem(this);
                for(f in this)this[f] = null;
            },
            destroyElements: function() {
                for(var a = [
                    "graphic",
                    "dataLabel",
                    "dataLabelUpper",
                    "connector",
                    "shadowGroup"
                ], c, e = 6; e--;)c = a[e], this[c] && (this[c] = this[c].destroy());
                this.dataLabels && (F(this.dataLabels, function(a) {
                    a.element && a.destroy();
                }), delete this.dataLabels);
                this.connectors && (F(this.connectors, function(a) {
                    a.element && a.destroy();
                }), delete this.connectors);
            },
            getLabelConfig: function() {
                return {
                    x: this.category,
                    y: this.y,
                    color: this.color,
                    colorIndex: this.colorIndex,
                    key: this.name || this.category,
                    series: this.series,
                    point: this,
                    percentage: this.percentage,
                    total: this.total || this.stackTotal
                };
            },
            tooltipFormatter: function(a) {
                var c = this.series, h = c.tooltipOptions, f = t(h.valueDecimals, ""), d = h.valuePrefix || "", b = h.valueSuffix || "";
                F(c.pointArrayMap || [
                    "y"
                ], function(c) {
                    c = "{point." + c;
                    if (d || b) a = a.replace(RegExp(c + "}", "g"), d + c + "}" + b);
                    a = a.replace(RegExp(c + "}", "g"), c + ":,." + f + "f}");
                });
                return e(a, {
                    point: this,
                    series: this.series
                }, c.chart.time);
            },
            firePointEvent: function(a, c, e) {
                var h = this, d = this.series.options;
                (d.point.events[a] || h.options && h.options.events && h.options.events[a]) && this.importEvents();
                "click" === a && d.allowPointSelect && (e = function(a) {
                    h.select && h.select(null, a.ctrlKey || a.metaKey || a.shiftKey);
                });
                f(this, a, c, e);
            },
            visible: !0
        };
    })(K);
    (function(a) {
        var C = a.addEvent, F = a.animObject, I = a.arrayMax, n = a.arrayMin, f = a.correctFloat, e = a.defaultOptions, u = a.defaultPlotOptions, x = a.defined, t = a.each, w = a.erase, y = a.extend, c = a.fireEvent, h = a.grep, p = a.isArray, k = a.isNumber, q = a.isString, d = a.merge, b = a.objectEach, v = a.pick, J = a.removeEvent, l = a.splat, L = a.SVGElement, B = a.syncTimeout, D = a.win;
        a.Series = a.seriesType("line", null, {
            lineWidth: 2,
            allowPointSelect: !1,
            showCheckbox: !1,
            animation: {
                duration: 1E3
            },
            events: {},
            marker: {
                lineWidth: 0,
                lineColor: "#ffffff",
                enabledThreshold: 2,
                radius: 4,
                states: {
                    normal: {
                        animation: !0
                    },
                    hover: {
                        animation: {
                            duration: 50
                        },
                        enabled: !0,
                        radiusPlus: 2,
                        lineWidthPlus: 1
                    },
                    select: {
                        fillColor: "#cccccc",
                        lineColor: "#000000",
                        lineWidth: 2
                    }
                }
            },
            point: {
                events: {}
            },
            dataLabels: {
                align: "center",
                formatter: function() {
                    return null === this.y ? "" : a.numberFormat(this.y, -1);
                },
                style: {
                    fontSize: "11px",
                    fontWeight: "bold",
                    color: "contrast",
                    textOutline: "1px contrast"
                },
                verticalAlign: "bottom",
                x: 0,
                y: 0,
                padding: 5
            },
            cropThreshold: 300,
            pointRange: 0,
            softThreshold: !0,
            states: {
                normal: {
                    animation: !0
                },
                hover: {
                    animation: {
                        duration: 50
                    },
                    lineWidthPlus: 1,
                    marker: {},
                    halo: {
                        size: 10,
                        opacity: .25
                    }
                },
                select: {}
            },
            stickyTracking: !0,
            turboThreshold: 1E3,
            findNearestPointBy: "x"
        }, {
            isCartesian: !0,
            pointClass: a.Point,
            sorted: !0,
            requireSorting: !0,
            directTouch: !1,
            axisTypes: [
                "xAxis",
                "yAxis"
            ],
            colorCounter: 0,
            parallelArrays: [
                "x",
                "y"
            ],
            coll: "series",
            init: function(a, d) {
                var m = this, e, h = a.series, g;
                m.chart = a;
                m.options = d = m.setOptions(d);
                m.linkedSeries = [];
                m.bindAxes();
                y(m, {
                    name: d.name,
                    state: "",
                    visible: !1 !== d.visible,
                    selected: !0 === d.selected
                });
                e = d.events;
                b(e, function(a, b) {
                    C(m, b, a);
                });
                if (e && e.click || d.point && d.point.events && d.point.events.click || d.allowPointSelect) a.runTrackerClick = !0;
                m.getColor();
                m.getSymbol();
                t(m.parallelArrays, function(a) {
                    m[a + "Data"] = [];
                });
                m.setData(d.data, !1);
                m.isCartesian && (a.hasCartesianSeries = !0);
                h.length && (g = h[h.length - 1]);
                m._i = v(g && g._i, -1) + 1;
                a.orderSeries(this.insert(h));
                c(this, "afterInit");
            },
            insert: function(a) {
                var b = this.options.index, c;
                if (k(b)) {
                    for(c = a.length; c--;)if (b >= v(a[c].options.index, a[c]._i)) {
                        a.splice(c + 1, 0, this);
                        break;
                    }
                    -1 === c && a.unshift(this);
                    c += 1;
                } else a.push(this);
                return v(c, a.length - 1);
            },
            bindAxes: function() {
                var b = this, c = b.options, d = b.chart, e;
                t(b.axisTypes || [], function(m) {
                    t(d[m], function(a) {
                        e = a.options;
                        if (c[m] === e.index || void 0 !== c[m] && c[m] === e.id || void 0 === c[m] && 0 === e.index) b.insert(a.series), b[m] = a, a.isDirty = !0;
                    });
                    b[m] || b.optionalAxis === m || a.error(18, !0);
                });
            },
            updateParallelArrays: function(a, b) {
                var c = a.series, d = arguments, m = k(b) ? function(g) {
                    var d = "y" === g && c.toYData ? c.toYData(a) : a[g];
                    c[g + "Data"][b] = d;
                } : function(a) {
                    Array.prototype[b].apply(c[a + "Data"], Array.prototype.slice.call(d, 2));
                };
                t(c.parallelArrays, m);
            },
            autoIncrement: function() {
                var a = this.options, b = this.xIncrement, c, d = a.pointIntervalUnit, e = this.chart.time, b = v(b, a.pointStart, 0);
                this.pointInterval = c = v(this.pointInterval, a.pointInterval, 1);
                d && (a = new e.Date(b), "day" === d ? e.set("Date", a, e.get("Date", a) + c) : "month" === d ? e.set("Month", a, e.get("Month", a) + c) : "year" === d && e.set("FullYear", a, e.get("FullYear", a) + c), c = a.getTime() - b);
                this.xIncrement = b + c;
                return b;
            },
            setOptions: function(a) {
                var b = this.chart, m = b.options, h = m.plotOptions, f = (b.userOptions || {}).plotOptions || {}, g = h[this.type];
                this.userOptions = a;
                b = d(g, h.series, a);
                this.tooltipOptions = d(e.tooltip, e.plotOptions.series && e.plotOptions.series.tooltip, e.plotOptions[this.type].tooltip, m.tooltip.userOptions, h.series && h.series.tooltip, h[this.type].tooltip, a.tooltip);
                this.stickyTracking = v(a.stickyTracking, f[this.type] && f[this.type].stickyTracking, f.series && f.series.stickyTracking, this.tooltipOptions.shared && !this.noSharedTooltip ? !0 : b.stickyTracking);
                null === g.marker && delete b.marker;
                this.zoneAxis = b.zoneAxis;
                a = this.zones = (b.zones || []).slice();
                !b.negativeColor && !b.negativeFillColor || b.zones || a.push({
                    value: b[this.zoneAxis + "Threshold"] || b.threshold || 0,
                    className: "highcharts-negative",
                    color: b.negativeColor,
                    fillColor: b.negativeFillColor
                });
                a.length && x(a[a.length - 1].value) && a.push({
                    color: this.color,
                    fillColor: this.fillColor
                });
                c(this, "afterSetOptions", {
                    options: b
                });
                return b;
            },
            getName: function() {
                return this.name || "Series " + (this.index + 1);
            },
            getCyclic: function(a, b, c) {
                var d, e = this.chart, g = this.userOptions, m = a + "Index", h = a + "Counter", f = c ? c.length : v(e.options.chart[a + "Count"], e[a + "Count"]);
                b || (d = v(g[m], g["_" + m]), x(d) || (e.series.length || (e[h] = 0), g["_" + m] = d = e[h] % f, e[h] += 1), c && (b = c[d]));
                void 0 !== d && (this[m] = d);
                this[a] = b;
            },
            getColor: function() {
                this.options.colorByPoint ? this.options.color = null : this.getCyclic("color", this.options.color || u[this.type].color, this.chart.options.colors);
            },
            getSymbol: function() {
                this.getCyclic("symbol", this.options.marker.symbol, this.chart.options.symbols);
            },
            drawLegendSymbol: a.LegendSymbolMixin.drawLineMarker,
            updateData: function(b) {
                var c = this.options, d = this.points, e = [], m, g, h, f = this.requireSorting;
                t(b, function(b) {
                    var g;
                    g = a.defined(b) && this.pointClass.prototype.optionsToObject.call({
                        series: this
                    }, b).x;
                    k(g) && (g = a.inArray(g, this.xData, h), -1 === g || d[g].touched ? e.push(b) : b !== c.data[g] ? (d[g].update(b, !1, null, !1), d[g].touched = !0, f && (h = g + 1)) : d[g] && (d[g].touched = !0), m = !0);
                }, this);
                if (m) for(b = d.length; b--;)g = d[b], g.touched || g.remove(!1), g.touched = !1;
                else if (b.length === d.length) t(b, function(a, b) {
                    d[b].update && a !== c.data[b] && d[b].update(a, !1, null, !1);
                });
                else return !1;
                t(e, function(a) {
                    this.addPoint(a, !1);
                }, this);
                return !0;
            },
            setData: function(b, c, d, e) {
                var m = this, g = m.points, h = g && g.length || 0, f, l = m.options, A = m.chart, G = null, n = m.xAxis, B = l.turboThreshold, u = this.xData, D = this.yData, y = (f = m.pointArrayMap) && f.length, N;
                b = b || [];
                f = b.length;
                c = v(c, !0);
                !1 !== e && f && h && !m.cropped && !m.hasGroupedData && m.visible && !m.isSeriesBoosting && (N = this.updateData(b));
                if (!N) {
                    m.xIncrement = null;
                    m.colorCounter = 0;
                    t(this.parallelArrays, function(a) {
                        m[a + "Data"].length = 0;
                    });
                    if (B && f > B) {
                        for(d = 0; null === G && d < f;)G = b[d], d++;
                        if (k(G)) for(d = 0; d < f; d++)u[d] = this.autoIncrement(), D[d] = b[d];
                        else if (p(G)) {
                            if (y) for(d = 0; d < f; d++)G = b[d], u[d] = G[0], D[d] = G.slice(1, y + 1);
                            else for(d = 0; d < f; d++)G = b[d], u[d] = G[0], D[d] = G[1];
                        } else a.error(12);
                    } else for(d = 0; d < f; d++)void 0 !== b[d] && (G = {
                        series: m
                    }, m.pointClass.prototype.applyOptions.apply(G, [
                        b[d]
                    ]), m.updateParallelArrays(G, d));
                    D && q(D[0]) && a.error(14, !0);
                    m.data = [];
                    m.options.data = m.userOptions.data = b;
                    for(d = h; d--;)g[d] && g[d].destroy && g[d].destroy();
                    n && (n.minRange = n.userMinRange);
                    m.isDirty = A.isDirtyBox = !0;
                    m.isDirtyData = !!g;
                    d = !1;
                }
                "point" === l.legendType && (this.processData(), this.generatePoints());
                c && A.redraw(d);
            },
            processData: function(b) {
                var c = this.xData, d = this.yData, e = c.length, m;
                m = 0;
                var g, h, f = this.xAxis, l, k = this.options;
                l = k.cropThreshold;
                var p = this.getExtremesFromAll || k.getExtremesFromAll, q = this.isCartesian, k = f && f.val2lin, v = f && f.isLog, n = this.requireSorting, B, t;
                if (q && !this.isDirty && !f.isDirty && !this.yAxis.isDirty && !b) return !1;
                f && (b = f.getExtremes(), B = b.min, t = b.max);
                q && this.sorted && !p && (!l || e > l || this.forceCrop) && (c[e - 1] < B || c[0] > t ? (c = [], d = []) : this.yData && (c[0] < B || c[e - 1] > t) && (m = this.cropData(this.xData, this.yData, B, t), c = m.xData, d = m.yData, m = m.start, g = !0));
                for(l = c.length || 1; --l;)e = v ? k(c[l]) - k(c[l - 1]) : c[l] - c[l - 1], 0 < e && (void 0 === h || e < h) ? h = e : 0 > e && n && (a.error(15), n = !1);
                this.cropped = g;
                this.cropStart = m;
                this.processedXData = c;
                this.processedYData = d;
                this.closestPointRange = h;
            },
            cropData: function(a, b, c, d, e) {
                var g = a.length, m = 0, h = g, f;
                e = v(e, this.cropShoulder, 1);
                for(f = 0; f < g; f++)if (a[f] >= c) {
                    m = Math.max(0, f - e);
                    break;
                }
                for(c = f; c < g; c++)if (a[c] > d) {
                    h = c + e;
                    break;
                }
                return {
                    xData: a.slice(m, h),
                    yData: b.slice(m, h),
                    start: m,
                    end: h
                };
            },
            generatePoints: function() {
                var a = this.options, b = a.data, c = this.data, d, e = this.processedXData, g = this.processedYData, h = this.pointClass, f = e.length, k = this.cropStart || 0, p, q = this.hasGroupedData, a = a.keys, v, n = [], B;
                c || q || (c = [], c.length = b.length, c = this.data = c);
                a && q && (this.options.keys = !1);
                for(B = 0; B < f; B++)p = k + B, q ? (v = (new h).init(this, [
                    e[B]
                ].concat(l(g[B]))), v.dataGroup = this.groupMap[B], v.dataGroup.options && (v.options = v.dataGroup.options, y(v, v.dataGroup.options))) : (v = c[p]) || void 0 === b[p] || (c[p] = v = (new h).init(this, b[p], e[B])), v && (v.index = p, n[B] = v);
                this.options.keys = a;
                if (c && (f !== (d = c.length) || q)) for(B = 0; B < d; B++)B !== k || q || (B += f), c[B] && (c[B].destroyElements(), c[B].plotX = void 0);
                this.data = c;
                this.points = n;
            },
            getExtremes: function(a) {
                var b = this.yAxis, c = this.processedXData, d, e = [], g = 0;
                d = this.xAxis.getExtremes();
                var m = d.min, h = d.max, f, l, q = this.requireSorting ? 1 : 0, v, B;
                a = a || this.stackedYData || this.processedYData || [];
                d = a.length;
                for(B = 0; B < d; B++)if (l = c[B], v = a[B], f = (k(v, !0) || p(v)) && (!b.positiveValuesOnly || v.length || 0 < v), l = this.getExtremesFromAll || this.options.getExtremesFromAll || this.cropped || (c[B + q] || l) >= m && (c[B - q] || l) <= h, f && l) {
                    if (f = v.length) for(; f--;)"number" === typeof v[f] && (e[g++] = v[f]);
                    else e[g++] = v;
                }
                this.dataMin = n(e);
                this.dataMax = I(e);
            },
            translate: function() {
                this.processedXData || this.processData();
                this.generatePoints();
                var a = this.options, b = a.stacking, d = this.xAxis, e = d.categories, h = this.yAxis, g = this.points, l = g.length, p = !!this.modifyValue, q = a.pointPlacement, B = "between" === q || k(q), n = a.threshold, t = a.startFromThreshold ? n : 0, u, D, y, w, J = Number.MAX_VALUE;
                "between" === q && (q = .5);
                k(q) && (q *= v(a.pointRange || d.pointRange));
                for(a = 0; a < l; a++){
                    var L = g[a], C = L.x, F = L.y;
                    D = L.low;
                    var I = b && h.stacks[(this.negStacks && F < (t ? 0 : n) ? "-" : "") + this.stackKey], K;
                    h.positiveValuesOnly && null !== F && 0 >= F && (L.isNull = !0);
                    L.plotX = u = f(Math.min(Math.max(-100000, d.translate(C, 0, 0, 0, 1, q, "flags" === this.type)), 1E5));
                    b && this.visible && !L.isNull && I && I[C] && (w = this.getStackIndicator(w, C, this.index), K = I[C], F = K.points[w.key], D = F[0], F = F[1], D === t && w.key === I[C].base && (D = v(k(n) && n, h.min)), h.positiveValuesOnly && 0 >= D && (D = null), L.total = L.stackTotal = K.total, L.percentage = K.total && L.y / K.total * 100, L.stackY = F, K.setOffset(this.pointXOffset || 0, this.barW || 0));
                    L.yBottom = x(D) ? Math.min(Math.max(-100000, h.translate(D, 0, 1, 0, 1)), 1E5) : null;
                    p && (F = this.modifyValue(F, L));
                    L.plotY = D = "number" === typeof F && Infinity !== F ? Math.min(Math.max(-100000, h.translate(F, 0, 1, 0, 1)), 1E5) : void 0;
                    L.isInside = void 0 !== D && 0 <= D && D <= h.len && 0 <= u && u <= d.len;
                    L.clientX = B ? f(d.translate(C, 0, 0, 0, 1, q)) : u;
                    L.negative = L.y < (n || 0);
                    L.category = e && void 0 !== e[L.x] ? e[L.x] : L.x;
                    L.isNull || (void 0 !== y && (J = Math.min(J, Math.abs(u - y))), y = u);
                    L.zone = this.zones.length && L.getZone();
                }
                this.closestPointRangePx = J;
                c(this, "afterTranslate");
            },
            getValidPoints: function(a, b) {
                var c = this.chart;
                return h(a || this.points || [], function(a) {
                    return b && !c.isInsidePlot(a.plotX, a.plotY, c.inverted) ? !1 : !a.isNull;
                });
            },
            setClip: function(a) {
                var b = this.chart, c = this.options, d = b.renderer, e = b.inverted, g = this.clipBox, m = g || b.clipBox, h = this.sharedClipKey || [
                    "_sharedClip",
                    a && a.duration,
                    a && a.easing,
                    m.height,
                    c.xAxis,
                    c.yAxis
                ].join(), f = b[h], l = b[h + "m"];
                f || (a && (m.width = 0, e && (m.x = b.plotSizeX), b[h + "m"] = l = d.clipRect(e ? b.plotSizeX + 99 : -99, e ? -b.plotLeft : -b.plotTop, 99, e ? b.chartWidth : b.chartHeight)), b[h] = f = d.clipRect(m), f.count = {
                    length: 0
                });
                a && !f.count[this.index] && (f.count[this.index] = !0, f.count.length += 1);
                !1 !== c.clip && (this.group.clip(a || g ? f : b.clipRect), this.markerGroup.clip(l), this.sharedClipKey = h);
                a || (f.count[this.index] && (delete f.count[this.index], --f.count.length), 0 === f.count.length && h && b[h] && (g || (b[h] = b[h].destroy()), b[h + "m"] && (b[h + "m"] = b[h + "m"].destroy())));
            },
            animate: function(a) {
                var b = this.chart, c = F(this.options.animation), d;
                a ? this.setClip(c) : (d = this.sharedClipKey, (a = b[d]) && a.animate({
                    width: b.plotSizeX,
                    x: 0
                }, c), b[d + "m"] && b[d + "m"].animate({
                    width: b.plotSizeX + 99,
                    x: 0
                }, c), this.animate = null);
            },
            afterAnimate: function() {
                this.setClip();
                c(this, "afterAnimate");
                this.finishedAnimating = !0;
            },
            drawPoints: function() {
                var a = this.points, b = this.chart, c, d, e, g, h = this.options.marker, f, l, k, p = this[this.specialGroup] || this.markerGroup, q, n = v(h.enabled, this.xAxis.isRadial ? !0 : null, this.closestPointRangePx >= h.enabledThreshold * h.radius);
                if (!1 !== h.enabled || this._hasPointMarkers) for(c = 0; c < a.length; c++)d = a[c], g = d.graphic, f = d.marker || {}, l = !!d.marker, e = n && void 0 === f.enabled || f.enabled, k = d.isInside, e && !d.isNull ? (e = v(f.symbol, this.symbol), q = this.markerAttribs(d, d.selected && "select"), g ? g[k ? "show" : "hide"](!0).animate(q) : k && (0 < q.width || d.hasImage) && (d.graphic = g = b.renderer.symbol(e, q.x, q.y, q.width, q.height, l ? f : h).add(p)), g && g.attr(this.pointAttribs(d, d.selected && "select")), g && g.addClass(d.getClassName(), !0)) : g && (d.graphic = g.destroy());
            },
            markerAttribs: function(a, b) {
                var c = this.options.marker, d = a.marker || {}, e = d.symbol || c.symbol, g = v(d.radius, c.radius);
                b && (c = c.states[b], b = d.states && d.states[b], g = v(b && b.radius, c && c.radius, g + (c && c.radiusPlus || 0)));
                a.hasImage = e && 0 === e.indexOf("url");
                a.hasImage && (g = 0);
                a = {
                    x: Math.floor(a.plotX) - g,
                    y: a.plotY - g
                };
                g && (a.width = a.height = 2 * g);
                return a;
            },
            pointAttribs: function(a, b) {
                var c = this.options.marker, d = a && a.options, e = d && d.marker || {}, g = this.color, h = d && d.color, m = a && a.color, d = v(e.lineWidth, c.lineWidth);
                a = a && a.zone && a.zone.color;
                g = h || a || m || g;
                a = e.fillColor || c.fillColor || g;
                g = e.lineColor || c.lineColor || g;
                b && (c = c.states[b], b = e.states && e.states[b] || {}, d = v(b.lineWidth, c.lineWidth, d + v(b.lineWidthPlus, c.lineWidthPlus, 0)), a = b.fillColor || c.fillColor || a, g = b.lineColor || c.lineColor || g);
                return {
                    stroke: g,
                    "stroke-width": d,
                    fill: a
                };
            },
            destroy: function() {
                var d = this, e = d.chart, h = /AppleWebKit\/533/.test(D.navigator.userAgent), f, l, g = d.data || [], k, p;
                c(d, "destroy");
                J(d);
                t(d.axisTypes || [], function(a) {
                    (p = d[a]) && p.series && (w(p.series, d), p.isDirty = p.forceRedraw = !0);
                });
                d.legendItem && d.chart.legend.destroyItem(d);
                for(l = g.length; l--;)(k = g[l]) && k.destroy && k.destroy();
                d.points = null;
                a.clearTimeout(d.animationTimeout);
                b(d, function(a, b) {
                    a instanceof L && !a.survive && (f = h && "group" === b ? "hide" : "destroy", a[f]());
                });
                e.hoverSeries === d && (e.hoverSeries = null);
                w(e.series, d);
                e.orderSeries();
                b(d, function(a, b) {
                    delete d[b];
                });
            },
            getGraphPath: function(a, b, c) {
                var d = this, e = d.options, g = e.step, h, m = [], f = [], l;
                a = a || d.points;
                (h = a.reversed) && a.reverse();
                (g = ({
                    right: 1,
                    center: 2
                })[g] || g && 3) && h && (g = 4 - g);
                !e.connectNulls || b || c || (a = this.getValidPoints(a));
                t(a, function(h, k) {
                    var r = h.plotX, p = h.plotY, q = a[k - 1];
                    (h.leftCliff || q && q.rightCliff) && !c && (l = !0);
                    h.isNull && !x(b) && 0 < k ? l = !e.connectNulls : h.isNull && !b ? l = !0 : (0 === k || l ? k = [
                        "M",
                        h.plotX,
                        h.plotY
                    ] : d.getPointSpline ? k = d.getPointSpline(a, h, k) : g ? (k = 1 === g ? [
                        "L",
                        q.plotX,
                        p
                    ] : 2 === g ? [
                        "L",
                        (q.plotX + r) / 2,
                        q.plotY,
                        "L",
                        (q.plotX + r) / 2,
                        p
                    ] : [
                        "L",
                        r,
                        q.plotY
                    ], k.push("L", r, p)) : k = [
                        "L",
                        r,
                        p
                    ], f.push(h.x), g && (f.push(h.x), 2 === g && f.push(h.x)), m.push.apply(m, k), l = !1);
                });
                m.xMap = f;
                return d.graphPath = m;
            },
            drawGraph: function() {
                var a = this, b = this.options, c = (this.gappedPath || this.getGraphPath).call(this), d = [
                    [
                        "graph",
                        "highcharts-graph",
                        b.lineColor || this.color,
                        b.dashStyle
                    ]
                ], d = a.getZonesGraphs(d);
                t(d, function(d, g) {
                    var e = d[0], h = a[e];
                    h ? (h.endX = a.preventGraphAnimation ? null : c.xMap, h.animate({
                        d: c
                    })) : c.length && (a[e] = a.chart.renderer.path(c).addClass(d[1]).attr({
                        zIndex: 1
                    }).add(a.group), h = {
                        stroke: d[2],
                        "stroke-width": b.lineWidth,
                        fill: a.fillGraph && a.color || "none"
                    }, d[3] ? h.dashstyle = d[3] : "square" !== b.linecap && (h["stroke-linecap"] = h["stroke-linejoin"] = "round"), h = a[e].attr(h).shadow(2 > g && b.shadow));
                    h && (h.startX = c.xMap, h.isArea = c.isArea);
                });
            },
            getZonesGraphs: function(a) {
                t(this.zones, function(b, c) {
                    a.push([
                        "zone-graph-" + c,
                        "highcharts-graph highcharts-zone-graph-" + c + " " + (b.className || ""),
                        b.color || this.color,
                        b.dashStyle || this.options.dashStyle
                    ]);
                }, this);
                return a;
            },
            applyZones: function() {
                var a = this, b = this.chart, c = b.renderer, d = this.zones, e, g, h = this.clips || [], f, l = this.graph, k = this.area, p = Math.max(b.chartWidth, b.chartHeight), q = this[(this.zoneAxis || "y") + "Axis"], n, B, u = b.inverted, D, y, w, x, J = !1;
                d.length && (l || k) && q && void 0 !== q.min && (B = q.reversed, D = q.horiz, l && !this.showLine && l.hide(), k && k.hide(), n = q.getExtremes(), t(d, function(d, m) {
                    e = B ? D ? b.plotWidth : 0 : D ? 0 : q.toPixels(n.min);
                    e = Math.min(Math.max(v(g, e), 0), p);
                    g = Math.min(Math.max(Math.round(q.toPixels(v(d.value, n.max), !0)), 0), p);
                    J && (e = g = q.toPixels(n.max));
                    y = Math.abs(e - g);
                    w = Math.min(e, g);
                    x = Math.max(e, g);
                    q.isXAxis ? (f = {
                        x: u ? x : w,
                        y: 0,
                        width: y,
                        height: p
                    }, D || (f.x = b.plotHeight - f.x)) : (f = {
                        x: 0,
                        y: u ? x : w,
                        width: p,
                        height: y
                    }, D && (f.y = b.plotWidth - f.y));
                    u && c.isVML && (f = q.isXAxis ? {
                        x: 0,
                        y: B ? w : x,
                        height: f.width,
                        width: b.chartWidth
                    } : {
                        x: f.y - b.plotLeft - b.spacingBox.x,
                        y: 0,
                        width: f.height,
                        height: b.chartHeight
                    });
                    h[m] ? h[m].animate(f) : (h[m] = c.clipRect(f), l && a["zone-graph-" + m].clip(h[m]), k && a["zone-area-" + m].clip(h[m]));
                    J = d.value > n.max;
                    a.resetZones && 0 === g && (g = void 0);
                }), this.clips = h);
            },
            invertGroups: function(a) {
                function b() {
                    t([
                        "group",
                        "markerGroup"
                    ], function(b) {
                        c[b] && (d.renderer.isVML && c[b].attr({
                            width: c.yAxis.len,
                            height: c.xAxis.len
                        }), c[b].width = c.yAxis.len, c[b].height = c.xAxis.len, c[b].invert(a));
                    });
                }
                var c = this, d = c.chart, e;
                c.xAxis && (e = C(d, "resize", b), C(c, "destroy", e), b(a), c.invertGroups = b);
            },
            plotGroup: function(a, b, c, d, e) {
                var g = this[a], h = !g;
                h && (this[a] = g = this.chart.renderer.g().attr({
                    zIndex: d || .1
                }).add(e));
                g.addClass("highcharts-" + b + " highcharts-series-" + this.index + " highcharts-" + this.type + "-series " + (x(this.colorIndex) ? "highcharts-color-" + this.colorIndex + " " : "") + (this.options.className || "") + (g.hasClass("highcharts-tracker") ? " highcharts-tracker" : ""), !0);
                g.attr({
                    visibility: c
                })[h ? "attr" : "animate"](this.getPlotBox());
                return g;
            },
            getPlotBox: function() {
                var a = this.chart, b = this.xAxis, c = this.yAxis;
                a.inverted && (b = c, c = this.xAxis);
                return {
                    translateX: b ? b.left : a.plotLeft,
                    translateY: c ? c.top : a.plotTop,
                    scaleX: 1,
                    scaleY: 1
                };
            },
            render: function() {
                var a = this, b = a.chart, d, e = a.options, h = !!a.animate && b.renderer.isSVG && F(e.animation).duration, g = a.visible ? "inherit" : "hidden", f = e.zIndex, l = a.hasRendered, k = b.seriesGroup, p = b.inverted;
                d = a.plotGroup("group", "series", g, f, k);
                a.markerGroup = a.plotGroup("markerGroup", "markers", g, f, k);
                h && a.animate(!0);
                d.inverted = a.isCartesian ? p : !1;
                a.drawGraph && (a.drawGraph(), a.applyZones());
                a.drawDataLabels && a.drawDataLabels();
                a.visible && a.drawPoints();
                a.drawTracker && !1 !== a.options.enableMouseTracking && a.drawTracker();
                a.invertGroups(p);
                !1 === e.clip || a.sharedClipKey || l || d.clip(b.clipRect);
                h && a.animate();
                l || (a.animationTimeout = B(function() {
                    a.afterAnimate();
                }, h));
                a.isDirty = !1;
                a.hasRendered = !0;
                c(a, "afterRender");
            },
            redraw: function() {
                var a = this.chart, b = this.isDirty || this.isDirtyData, c = this.group, d = this.xAxis, e = this.yAxis;
                c && (a.inverted && c.attr({
                    width: a.plotWidth,
                    height: a.plotHeight
                }), c.animate({
                    translateX: v(d && d.left, a.plotLeft),
                    translateY: v(e && e.top, a.plotTop)
                }));
                this.translate();
                this.render();
                b && delete this.kdTree;
            },
            kdAxisArray: [
                "clientX",
                "plotY"
            ],
            searchPoint: function(a, b) {
                var c = this.xAxis, d = this.yAxis, e = this.chart.inverted;
                return this.searchKDTree({
                    clientX: e ? c.len - a.chartY + c.pos : a.chartX - c.pos,
                    plotY: e ? d.len - a.chartX + d.pos : a.chartY - d.pos
                }, b);
            },
            buildKDTree: function() {
                function a(c, d, g) {
                    var e, h;
                    if (h = c && c.length) return e = b.kdAxisArray[d % g], c.sort(function(a, b) {
                        return a[e] - b[e];
                    }), h = Math.floor(h / 2), {
                        point: c[h],
                        left: a(c.slice(0, h), d + 1, g),
                        right: a(c.slice(h + 1), d + 1, g)
                    };
                }
                this.buildingKdTree = !0;
                var b = this, c = -1 < b.options.findNearestPointBy.indexOf("y") ? 2 : 1;
                delete b.kdTree;
                B(function() {
                    b.kdTree = a(b.getValidPoints(null, !b.directTouch), c, c);
                    b.buildingKdTree = !1;
                }, b.options.kdNow ? 0 : 1);
            },
            searchKDTree: function(a, b) {
                function c(a, b, f, l) {
                    var m = b.point, k = d.kdAxisArray[f % l], p, q, r = m;
                    q = x(a[e]) && x(m[e]) ? Math.pow(a[e] - m[e], 2) : null;
                    p = x(a[g]) && x(m[g]) ? Math.pow(a[g] - m[g], 2) : null;
                    p = (q || 0) + (p || 0);
                    m.dist = x(p) ? Math.sqrt(p) : Number.MAX_VALUE;
                    m.distX = x(q) ? Math.sqrt(q) : Number.MAX_VALUE;
                    k = a[k] - m[k];
                    p = 0 > k ? "left" : "right";
                    q = 0 > k ? "right" : "left";
                    b[p] && (p = c(a, b[p], f + 1, l), r = p[h] < r[h] ? p : m);
                    b[q] && Math.sqrt(k * k) < r[h] && (a = c(a, b[q], f + 1, l), r = a[h] < r[h] ? a : r);
                    return r;
                }
                var d = this, e = this.kdAxisArray[0], g = this.kdAxisArray[1], h = b ? "distX" : "dist";
                b = -1 < d.options.findNearestPointBy.indexOf("y") ? 2 : 1;
                this.kdTree || this.buildingKdTree || this.buildKDTree();
                if (this.kdTree) return c(a, this.kdTree, b, b);
            }
        });
    })(K);
    (function(a) {
        var C = a.Axis, F = a.Chart, I = a.correctFloat, n = a.defined, f = a.destroyObjectProperties, e = a.each, u = a.format, x = a.objectEach, t = a.pick, w = a.Series;
        a.StackItem = function(a, c, e, f, k) {
            var h = a.chart.inverted;
            this.axis = a;
            this.isNegative = e;
            this.options = c;
            this.x = f;
            this.total = null;
            this.points = {};
            this.stack = k;
            this.rightCliff = this.leftCliff = 0;
            this.alignOptions = {
                align: c.align || (h ? e ? "left" : "right" : "center"),
                verticalAlign: c.verticalAlign || (h ? "middle" : e ? "bottom" : "top"),
                y: t(c.y, h ? 4 : e ? 14 : -6),
                x: t(c.x, h ? e ? -6 : 6 : 0)
            };
            this.textAlign = c.textAlign || (h ? e ? "right" : "left" : "center");
        };
        a.StackItem.prototype = {
            destroy: function() {
                f(this, this.axis);
            },
            render: function(a) {
                var c = this.axis.chart, e = this.options, f = e.format, f = f ? u(f, this, c.time) : e.formatter.call(this);
                this.label ? this.label.attr({
                    text: f,
                    visibility: "hidden"
                }) : this.label = c.renderer.text(f, null, null, e.useHTML).css(e.style).attr({
                    align: this.textAlign,
                    rotation: e.rotation,
                    visibility: "hidden"
                }).add(a);
                this.label.labelrank = c.plotHeight;
            },
            setOffset: function(a, c) {
                var e = this.axis, f = e.chart, k = e.translate(e.usePercentage ? 100 : this.total, 0, 0, 0, 1), q = e.translate(0), q = n(k) && Math.abs(k - q);
                a = f.xAxis[0].translate(this.x) + a;
                e = n(k) && this.getStackBox(f, this, a, k, c, q, e);
                (c = this.label) && e && (c.align(this.alignOptions, null, e), e = c.alignAttr, c[!1 === this.options.crop || f.isInsidePlot(e.x, e.y) ? "show" : "hide"](!0));
            },
            getStackBox: function(a, c, e, f, k, q, d) {
                var b = c.axis.reversed, h = a.inverted;
                a = d.height + d.pos - (h ? a.plotLeft : a.plotTop);
                c = c.isNegative && !b || !c.isNegative && b;
                return {
                    x: h ? c ? f : f - q : e,
                    y: h ? a - e - k : c ? a - f - q : a - f,
                    width: h ? q : k,
                    height: h ? k : q
                };
            }
        };
        F.prototype.getStacks = function() {
            var a = this;
            e(a.yAxis, function(a) {
                a.stacks && a.hasVisibleSeries && (a.oldStacks = a.stacks);
            });
            e(a.series, function(c) {
                !c.options.stacking || !0 !== c.visible && !1 !== a.options.chart.ignoreHiddenSeries || (c.stackKey = c.type + t(c.options.stack, ""));
            });
        };
        C.prototype.buildStacks = function() {
            var a = this.series, c = t(this.options.reversedStacks, !0), e = a.length, f;
            if (!this.isXAxis) {
                this.usePercentage = !1;
                for(f = e; f--;)a[c ? f : e - f - 1].setStackedPoints();
                for(f = 0; f < e; f++)a[f].modifyStacks();
            }
        };
        C.prototype.renderStackTotals = function() {
            var a = this.chart, c = a.renderer, e = this.stacks, f = this.stackTotalGroup;
            f || (this.stackTotalGroup = f = c.g("stack-labels").attr({
                visibility: "visible",
                zIndex: 6
            }).add());
            f.translate(a.plotLeft, a.plotTop);
            x(e, function(a) {
                x(a, function(a) {
                    a.render(f);
                });
            });
        };
        C.prototype.resetStacks = function() {
            var a = this, c = a.stacks;
            a.isXAxis || x(c, function(c) {
                x(c, function(e, h) {
                    e.touched < a.stacksTouched ? (e.destroy(), delete c[h]) : (e.total = null, e.cumulative = null);
                });
            });
        };
        C.prototype.cleanStacks = function() {
            var a;
            this.isXAxis || (this.oldStacks && (a = this.stacks = this.oldStacks), x(a, function(a) {
                x(a, function(a) {
                    a.cumulative = a.total;
                });
            }));
        };
        w.prototype.setStackedPoints = function() {
            if (this.options.stacking && (!0 === this.visible || !1 === this.chart.options.chart.ignoreHiddenSeries)) {
                var e = this.processedXData, c = this.processedYData, h = [], f = c.length, k = this.options, q = k.threshold, d = t(k.startFromThreshold && q, 0), b = k.stack, k = k.stacking, v = this.stackKey, u = "-" + v, l = this.negStacks, w = this.yAxis, B = w.stacks, D = w.oldStacks, m, G, A, x, E, g, r;
                w.stacksTouched += 1;
                for(E = 0; E < f; E++)g = e[E], r = c[E], m = this.getStackIndicator(m, g, this.index), x = m.key, A = (G = l && r < (d ? 0 : q)) ? u : v, B[A] || (B[A] = {}), B[A][g] || (D[A] && D[A][g] ? (B[A][g] = D[A][g], B[A][g].total = null) : B[A][g] = new a.StackItem(w, w.options.stackLabels, G, g, b)), A = B[A][g], null !== r ? (A.points[x] = A.points[this.index] = [
                    t(A.cumulative, d)
                ], n(A.cumulative) || (A.base = x), A.touched = w.stacksTouched, 0 < m.index && !1 === this.singleStacks && (A.points[x][0] = A.points[this.index + "," + g + ",0"][0])) : A.points[x] = A.points[this.index] = null, "percent" === k ? (G = G ? v : u, l && B[G] && B[G][g] ? (G = B[G][g], A.total = G.total = Math.max(G.total, A.total) + Math.abs(r) || 0) : A.total = I(A.total + (Math.abs(r) || 0))) : A.total = I(A.total + (r || 0)), A.cumulative = t(A.cumulative, d) + (r || 0), null !== r && (A.points[x].push(A.cumulative), h[E] = A.cumulative);
                "percent" === k && (w.usePercentage = !0);
                this.stackedYData = h;
                w.oldStacks = {};
            }
        };
        w.prototype.modifyStacks = function() {
            var a = this, c = a.stackKey, h = a.yAxis.stacks, f = a.processedXData, k, q = a.options.stacking;
            a[q + "Stacker"] && e([
                c,
                "-" + c
            ], function(c) {
                for(var b = f.length, d, e; b--;)if (d = f[b], k = a.getStackIndicator(k, d, a.index, c), e = (d = h[c] && h[c][d]) && d.points[k.key]) a[q + "Stacker"](e, d, b);
            });
        };
        w.prototype.percentStacker = function(a, c, e) {
            c = c.total ? 100 / c.total : 0;
            a[0] = I(a[0] * c);
            a[1] = I(a[1] * c);
            this.stackedYData[e] = a[1];
        };
        w.prototype.getStackIndicator = function(a, c, e, f) {
            !n(a) || a.x !== c || f && a.key !== f ? a = {
                x: c,
                index: 0,
                key: f
            } : a.index++;
            a.key = [
                e,
                c,
                a.index
            ].join();
            return a;
        };
    })(K);
    (function(a) {
        var C = a.addEvent, F = a.animate, I = a.Axis, n = a.createElement, f = a.css, e = a.defined, u = a.each, x = a.erase, t = a.extend, w = a.fireEvent, y = a.inArray, c = a.isNumber, h = a.isObject, p = a.isArray, k = a.merge, q = a.objectEach, d = a.pick, b = a.Point, v = a.Series, J = a.seriesTypes, l = a.setAnimation, L = a.splat;
        t(a.Chart.prototype, {
            addSeries: function(a, b, c) {
                var e, h = this;
                a && (b = d(b, !0), w(h, "addSeries", {
                    options: a
                }, function() {
                    e = h.initSeries(a);
                    h.isDirtyLegend = !0;
                    h.linkSeries();
                    w(h, "afterAddSeries");
                    b && h.redraw(c);
                }));
                return e;
            },
            addAxis: function(a, b, c, e) {
                var h = b ? "xAxis" : "yAxis", f = this.options;
                a = k(a, {
                    index: this[h].length,
                    isX: b
                });
                b = new I(this, a);
                f[h] = L(f[h] || {});
                f[h].push(a);
                d(c, !0) && this.redraw(e);
                return b;
            },
            showLoading: function(a) {
                var b = this, c = b.options, d = b.loadingDiv, e = c.loading, h = function() {
                    d && f(d, {
                        left: b.plotLeft + "px",
                        top: b.plotTop + "px",
                        width: b.plotWidth + "px",
                        height: b.plotHeight + "px"
                    });
                };
                d || (b.loadingDiv = d = n("div", {
                    className: "highcharts-loading highcharts-loading-hidden"
                }, null, b.container), b.loadingSpan = n("span", {
                    className: "highcharts-loading-inner"
                }, null, d), C(b, "redraw", h));
                d.className = "highcharts-loading";
                b.loadingSpan.innerHTML = a || c.lang.loading;
                f(d, t(e.style, {
                    zIndex: 10
                }));
                f(b.loadingSpan, e.labelStyle);
                b.loadingShown || (f(d, {
                    opacity: 0,
                    display: ""
                }), F(d, {
                    opacity: e.style.opacity || .5
                }, {
                    duration: e.showDuration || 0
                }));
                b.loadingShown = !0;
                h();
            },
            hideLoading: function() {
                var a = this.options, b = this.loadingDiv;
                b && (b.className = "highcharts-loading highcharts-loading-hidden", F(b, {
                    opacity: 0
                }, {
                    duration: a.loading.hideDuration || 100,
                    complete: function() {
                        f(b, {
                            display: "none"
                        });
                    }
                }));
                this.loadingShown = !1;
            },
            propsRequireDirtyBox: "backgroundColor borderColor borderWidth margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),
            propsRequireUpdateSeries: "chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions time tooltip".split(" "),
            update: function(a, b, h, f) {
                var l = this, m = {
                    credits: "addCredits",
                    title: "setTitle",
                    subtitle: "setSubtitle"
                }, p = a.chart, g, r, v = [];
                w(l, "update", {
                    options: a
                });
                if (p) {
                    k(!0, l.options.chart, p);
                    "className" in p && l.setClassName(p.className);
                    "reflow" in p && l.setReflow(p.reflow);
                    if ("inverted" in p || "polar" in p || "type" in p) l.propFromSeries(), g = !0;
                    "alignTicks" in p && (g = !0);
                    q(p, function(a, b) {
                        -1 !== y("chart." + b, l.propsRequireUpdateSeries) && (r = !0);
                        -1 !== y(b, l.propsRequireDirtyBox) && (l.isDirtyBox = !0);
                    });
                    "style" in p && l.renderer.setStyle(p.style);
                }
                a.colors && (this.options.colors = a.colors);
                a.plotOptions && k(!0, this.options.plotOptions, a.plotOptions);
                q(a, function(a, b) {
                    if (l[b] && "function" === typeof l[b].update) l[b].update(a, !1);
                    else if ("function" === typeof l[m[b]]) l[m[b]](a);
                    "chart" !== b && -1 !== y(b, l.propsRequireUpdateSeries) && (r = !0);
                });
                u("xAxis yAxis zAxis series colorAxis pane".split(" "), function(b) {
                    var c;
                    a[b] && ("series" === b && (c = [], u(l[b], function(a, b) {
                        a.options.isInternal || c.push(b);
                    })), u(L(a[b]), function(a, d) {
                        (d = e(a.id) && l.get(a.id) || l[b][c ? c[d] : d]) && d.coll === b && (d.update(a, !1), h && (d.touched = !0));
                        if (!d && h) {
                            if ("series" === b) l.addSeries(a, !1).touched = !0;
                            else if ("xAxis" === b || "yAxis" === b) l.addAxis(a, "xAxis" === b, !1).touched = !0;
                        }
                    }), h && u(l[b], function(a) {
                        a.touched || a.options.isInternal ? delete a.touched : v.push(a);
                    }));
                });
                u(v, function(a) {
                    a.remove && a.remove(!1);
                });
                g && u(l.axes, function(a) {
                    a.update({}, !1);
                });
                r && u(l.series, function(a) {
                    a.update({}, !1);
                });
                a.loading && k(!0, l.options.loading, a.loading);
                g = p && p.width;
                p = p && p.height;
                c(g) && g !== l.chartWidth || c(p) && p !== l.chartHeight ? l.setSize(g, p, f) : d(b, !0) && l.redraw(f);
                w(l, "afterUpdate", {
                    options: a
                });
            },
            setSubtitle: function(a) {
                this.setTitle(void 0, a);
            }
        });
        t(b.prototype, {
            update: function(a, b, c, e) {
                function f() {
                    l.applyOptions(a);
                    null === l.y && g && (l.graphic = g.destroy());
                    h(a, !0) && (g && g.element && a && a.marker && void 0 !== a.marker.symbol && (l.graphic = g.destroy()), a && a.dataLabels && l.dataLabel && (l.dataLabel = l.dataLabel.destroy()), l.connector && (l.connector = l.connector.destroy()));
                    k = l.index;
                    m.updateParallelArrays(l, k);
                    p.data[k] = h(p.data[k], !0) || h(a, !0) ? l.options : d(a, p.data[k]);
                    m.isDirty = m.isDirtyData = !0;
                    !m.fixedBox && m.hasCartesianSeries && (q.isDirtyBox = !0);
                    "point" === p.legendType && (q.isDirtyLegend = !0);
                    b && q.redraw(c);
                }
                var l = this, m = l.series, g = l.graphic, k, q = m.chart, p = m.options;
                b = d(b, !0);
                !1 === e ? f() : l.firePointEvent("update", {
                    options: a
                }, f);
            },
            remove: function(a, b) {
                this.series.removePoint(y(this, this.series.data), a, b);
            }
        });
        t(v.prototype, {
            addPoint: function(a, b, c, e) {
                var h = this.options, f = this.data, l = this.chart, g = this.xAxis, g = g && g.hasNames && g.names, m = h.data, k, p, q = this.xData, v, n;
                b = d(b, !0);
                k = {
                    series: this
                };
                this.pointClass.prototype.applyOptions.apply(k, [
                    a
                ]);
                n = k.x;
                v = q.length;
                if (this.requireSorting && n < q[v - 1]) for(p = !0; v && q[v - 1] > n;)v--;
                this.updateParallelArrays(k, "splice", v, 0, 0);
                this.updateParallelArrays(k, v);
                g && k.name && (g[n] = k.name);
                m.splice(v, 0, a);
                p && (this.data.splice(v, 0, null), this.processData());
                "point" === h.legendType && this.generatePoints();
                c && (f[0] && f[0].remove ? f[0].remove(!1) : (f.shift(), this.updateParallelArrays(k, "shift"), m.shift()));
                this.isDirtyData = this.isDirty = !0;
                b && l.redraw(e);
            },
            removePoint: function(a, b, c) {
                var e = this, h = e.data, f = h[a], m = e.points, g = e.chart, k = function() {
                    m && m.length === h.length && m.splice(a, 1);
                    h.splice(a, 1);
                    e.options.data.splice(a, 1);
                    e.updateParallelArrays(f || {
                        series: e
                    }, "splice", a, 1);
                    f && f.destroy();
                    e.isDirty = !0;
                    e.isDirtyData = !0;
                    b && g.redraw();
                };
                l(c, g);
                b = d(b, !0);
                f ? f.firePointEvent("remove", null, k) : k();
            },
            remove: function(a, b, c) {
                function e() {
                    h.destroy();
                    h.remove = null;
                    f.isDirtyLegend = f.isDirtyBox = !0;
                    f.linkSeries();
                    d(a, !0) && f.redraw(b);
                }
                var h = this, f = h.chart;
                !1 !== c ? w(h, "remove", null, e) : e();
            },
            update: function(b, c) {
                var e = this, h = e.chart, f = e.userOptions, l = e.oldType || e.type, q = b.type || f.type || h.options.chart.type, g = J[l].prototype, p, v = [
                    "group",
                    "markerGroup",
                    "dataLabelsGroup"
                ], n = [
                    "navigatorSeries",
                    "baseSeries"
                ], B = e.finishedAnimating && {
                    animation: !1
                }, D = [
                    "data",
                    "name",
                    "turboThreshold"
                ], x = a.keys(b), L = 0 < x.length;
                u(x, function(a) {
                    -1 === y(a, D) && (L = !1);
                });
                if (L) b.data && this.setData(b.data, !1), b.name && this.setName(b.name, !1);
                else {
                    n = v.concat(n);
                    u(n, function(a) {
                        n[a] = e[a];
                        delete e[a];
                    });
                    b = k(f, B, {
                        index: e.index,
                        pointStart: d(f.pointStart, e.xData[0])
                    }, {
                        data: e.options.data
                    }, b);
                    e.remove(!1, null, !1);
                    for(p in g)e[p] = void 0;
                    J[q || l] ? t(e, J[q || l].prototype) : a.error(17, !0);
                    u(n, function(a) {
                        e[a] = n[a];
                    });
                    e.init(h, b);
                    b.zIndex !== f.zIndex && u(v, function(a) {
                        e[a] && e[a].attr({
                            zIndex: b.zIndex
                        });
                    });
                    e.oldType = l;
                    h.linkSeries();
                }
                w(this, "afterUpdate");
                d(c, !0) && h.redraw(L ? void 0 : !1);
            },
            setName: function(a) {
                this.name = this.options.name = this.userOptions.name = a;
                this.chart.isDirtyLegend = !0;
            }
        });
        t(I.prototype, {
            update: function(a, b) {
                var c = this.chart, e = a && a.events || {};
                a = k(this.userOptions, a);
                c.options[this.coll].indexOf && (c.options[this.coll][c.options[this.coll].indexOf(this.userOptions)] = a);
                q(c.options[this.coll].events, function(a, b) {
                    "undefined" === typeof e[b] && (e[b] = void 0);
                });
                this.destroy(!0);
                this.init(c, t(a, {
                    events: e
                }));
                c.isDirtyBox = !0;
                d(b, !0) && c.redraw();
            },
            remove: function(a) {
                for(var b = this.chart, c = this.coll, e = this.series, h = e.length; h--;)e[h] && e[h].remove(!1);
                x(b.axes, this);
                x(b[c], this);
                p(b.options[c]) ? b.options[c].splice(this.options.index, 1) : delete b.options[c];
                u(b[c], function(a, b) {
                    a.options.index = a.userOptions.index = b;
                });
                this.destroy();
                b.isDirtyBox = !0;
                d(a, !0) && b.redraw();
            },
            setTitle: function(a, b) {
                this.update({
                    title: a
                }, b);
            },
            setCategories: function(a, b) {
                this.update({
                    categories: a
                }, b);
            }
        });
    })(K);
    (function(a) {
        var C = a.color, F = a.each, I = a.map, n = a.pick, f = a.Series, e = a.seriesType;
        e("area", "line", {
            softThreshold: !1,
            threshold: 0
        }, {
            singleStacks: !1,
            getStackPoints: function(e) {
                var f = [], t = [], u = this.xAxis, y = this.yAxis, c = y.stacks[this.stackKey], h = {}, p = this.index, k = y.series, q = k.length, d, b = n(y.options.reversedStacks, !0) ? 1 : -1, v;
                e = e || this.points;
                if (this.options.stacking) {
                    for(v = 0; v < e.length; v++)e[v].leftNull = e[v].rightNull = null, h[e[v].x] = e[v];
                    a.objectEach(c, function(a, b) {
                        null !== a.total && t.push(b);
                    });
                    t.sort(function(a, b) {
                        return a - b;
                    });
                    d = I(k, function() {
                        return this.visible;
                    });
                    F(t, function(a, e) {
                        var l = 0, k, n;
                        if (h[a] && !h[a].isNull) f.push(h[a]), F([
                            -1,
                            1
                        ], function(f) {
                            var l = 1 === f ? "rightNull" : "leftNull", m = 0, u = c[t[e + f]];
                            if (u) for(v = p; 0 <= v && v < q;)k = u.points[v], k || (v === p ? h[a][l] = !0 : d[v] && (n = c[a].points[v]) && (m -= n[1] - n[0])), v += b;
                            h[a][1 === f ? "rightCliff" : "leftCliff"] = m;
                        });
                        else {
                            for(v = p; 0 <= v && v < q;){
                                if (k = c[a].points[v]) {
                                    l = k[1];
                                    break;
                                }
                                v += b;
                            }
                            l = y.translate(l, 0, 1, 0, 1);
                            f.push({
                                isNull: !0,
                                plotX: u.translate(a, 0, 0, 0, 1),
                                x: a,
                                plotY: l,
                                yBottom: l
                            });
                        }
                    });
                }
                return f;
            },
            getGraphPath: function(a) {
                var e = f.prototype.getGraphPath, t = this.options, u = t.stacking, y = this.yAxis, c, h, p = [], k = [], q = this.index, d, b = y.stacks[this.stackKey], v = t.threshold, J = y.getThreshold(t.threshold), l, t = t.connectNulls || "percent" === u, L = function(c, e, h) {
                    var f = a[c];
                    c = u && b[f.x].points[q];
                    var l = f[h + "Null"] || 0;
                    h = f[h + "Cliff"] || 0;
                    var m, n, f = !0;
                    h || l ? (m = (l ? c[0] : c[1]) + h, n = c[0] + h, f = !!l) : !u && a[e] && a[e].isNull && (m = n = v);
                    void 0 !== m && (k.push({
                        plotX: d,
                        plotY: null === m ? J : y.getThreshold(m),
                        isNull: f,
                        isCliff: !0
                    }), p.push({
                        plotX: d,
                        plotY: null === n ? J : y.getThreshold(n),
                        doCurve: !1
                    }));
                };
                a = a || this.points;
                u && (a = this.getStackPoints(a));
                for(c = 0; c < a.length; c++)if (h = a[c].isNull, d = n(a[c].rectPlotX, a[c].plotX), l = n(a[c].yBottom, J), !h || t) t || L(c, c - 1, "left"), h && !u && t || (k.push(a[c]), p.push({
                    x: c,
                    plotX: d,
                    plotY: l
                })), t || L(c, c + 1, "right");
                c = e.call(this, k, !0, !0);
                p.reversed = !0;
                h = e.call(this, p, !0, !0);
                h.length && (h[0] = "L");
                h = c.concat(h);
                e = e.call(this, k, !1, t);
                h.xMap = c.xMap;
                this.areaPath = h;
                return e;
            },
            drawGraph: function() {
                this.areaPath = [];
                f.prototype.drawGraph.apply(this);
                var a = this, e = this.areaPath, t = this.options, w = [
                    [
                        "area",
                        "highcharts-area",
                        this.color,
                        t.fillColor
                    ]
                ];
                F(this.zones, function(e, c) {
                    w.push([
                        "zone-area-" + c,
                        "highcharts-area highcharts-zone-area-" + c + " " + e.className,
                        e.color || a.color,
                        e.fillColor || t.fillColor
                    ]);
                });
                F(w, function(f) {
                    var c = f[0], h = a[c];
                    h ? (h.endX = a.preventGraphAnimation ? null : e.xMap, h.animate({
                        d: e
                    })) : (h = a[c] = a.chart.renderer.path(e).addClass(f[1]).attr({
                        fill: n(f[3], C(f[2]).setOpacity(n(t.fillOpacity, .75)).get()),
                        zIndex: 0
                    }).add(a.group), h.isArea = !0);
                    h.startX = e.xMap;
                    h.shiftUnit = t.step ? 2 : 1;
                });
            },
            drawLegendSymbol: a.LegendSymbolMixin.drawRectangle
        });
    })(K);
    (function(a) {
        var C = a.pick;
        a = a.seriesType;
        a("spline", "line", {}, {
            getPointSpline: function(a, I, n) {
                var f = I.plotX, e = I.plotY, u = a[n - 1];
                n = a[n + 1];
                var x, t, w, y;
                if (u && !u.isNull && !1 !== u.doCurve && !I.isCliff && n && !n.isNull && !1 !== n.doCurve && !I.isCliff) {
                    a = u.plotY;
                    w = n.plotX;
                    n = n.plotY;
                    var c = 0;
                    x = (1.5 * f + u.plotX) / 2.5;
                    t = (1.5 * e + a) / 2.5;
                    w = (1.5 * f + w) / 2.5;
                    y = (1.5 * e + n) / 2.5;
                    w !== x && (c = (y - t) * (w - f) / (w - x) + e - y);
                    t += c;
                    y += c;
                    t > a && t > e ? (t = Math.max(a, e), y = 2 * e - t) : t < a && t < e && (t = Math.min(a, e), y = 2 * e - t);
                    y > n && y > e ? (y = Math.max(n, e), t = 2 * e - y) : y < n && y < e && (y = Math.min(n, e), t = 2 * e - y);
                    I.rightContX = w;
                    I.rightContY = y;
                }
                I = [
                    "C",
                    C(u.rightContX, u.plotX),
                    C(u.rightContY, u.plotY),
                    C(x, f),
                    C(t, e),
                    f,
                    e
                ];
                u.rightContX = u.rightContY = null;
                return I;
            }
        });
    })(K);
    (function(a) {
        var C = a.seriesTypes.area.prototype, F = a.seriesType;
        F("areaspline", "spline", a.defaultPlotOptions.area, {
            getStackPoints: C.getStackPoints,
            getGraphPath: C.getGraphPath,
            drawGraph: C.drawGraph,
            drawLegendSymbol: a.LegendSymbolMixin.drawRectangle
        });
    })(K);
    (function(a) {
        var C = a.animObject, F = a.color, I = a.each, n = a.extend, f = a.defined, e = a.isNumber, u = a.merge, x = a.pick, t = a.Series, w = a.seriesType, y = a.svg;
        w("column", "line", {
            borderRadius: 0,
            crisp: !0,
            groupPadding: .2,
            marker: null,
            pointPadding: .1,
            minPointLength: 0,
            cropThreshold: 50,
            pointRange: null,
            states: {
                hover: {
                    halo: !1,
                    brightness: .1
                },
                select: {
                    color: "#cccccc",
                    borderColor: "#000000"
                }
            },
            dataLabels: {
                align: null,
                verticalAlign: null,
                y: null
            },
            softThreshold: !1,
            startFromThreshold: !0,
            stickyTracking: !1,
            tooltip: {
                distance: 6
            },
            threshold: 0,
            borderColor: "#ffffff"
        }, {
            cropShoulder: 0,
            directTouch: !0,
            trackerGroups: [
                "group",
                "dataLabelsGroup"
            ],
            negStacks: !0,
            init: function() {
                t.prototype.init.apply(this, arguments);
                var a = this, e = a.chart;
                e.hasRendered && I(e.series, function(c) {
                    c.type === a.type && (c.isDirty = !0);
                });
            },
            getColumnMetrics: function() {
                var a = this, e = a.options, f = a.xAxis, k = a.yAxis, q = f.options.reversedStacks, q = f.reversed && !q || !f.reversed && q, d, b = {}, v = 0;
                !1 === e.grouping ? v = 1 : I(a.chart.series, function(c) {
                    var e = c.options, f = c.yAxis, h;
                    c.type !== a.type || !c.visible && a.chart.options.chart.ignoreHiddenSeries || k.len !== f.len || k.pos !== f.pos || (e.stacking ? (d = c.stackKey, void 0 === b[d] && (b[d] = v++), h = b[d]) : !1 !== e.grouping && (h = v++), c.columnIndex = h);
                });
                var n = Math.min(Math.abs(f.transA) * (f.ordinalSlope || e.pointRange || f.closestPointRange || f.tickInterval || 1), f.len), l = n * e.groupPadding, t = (n - 2 * l) / (v || 1), e = Math.min(e.maxPointWidth || f.len, x(e.pointWidth, t * (1 - 2 * e.pointPadding)));
                a.columnMetrics = {
                    width: e,
                    offset: (t - e) / 2 + (l + ((a.columnIndex || 0) + (q ? 1 : 0)) * t - n / 2) * (q ? -1 : 1)
                };
                return a.columnMetrics;
            },
            crispCol: function(a, e, f, k) {
                var c = this.chart, d = this.borderWidth, b = -(d % 2 ? .5 : 0), d = d % 2 ? .5 : 1;
                c.inverted && c.renderer.isVML && (d += 1);
                this.options.crisp && (f = Math.round(a + f) + b, a = Math.round(a) + b, f -= a);
                k = Math.round(e + k) + d;
                b = .5 >= Math.abs(e) && .5 < k;
                e = Math.round(e) + d;
                k -= e;
                b && k && (--e, k += 1);
                return {
                    x: a,
                    y: e,
                    width: f,
                    height: k
                };
            },
            translate: function() {
                var a = this, e = a.chart, p = a.options, k = a.dense = 2 > a.closestPointRange * a.xAxis.transA, k = a.borderWidth = x(p.borderWidth, k ? 0 : 1), q = a.yAxis, d = p.threshold, b = a.translatedThreshold = q.getThreshold(d), v = x(p.minPointLength, 5), n = a.getColumnMetrics(), l = n.width, u = a.barW = Math.max(l, 1 + 2 * k), B = a.pointXOffset = n.offset;
                e.inverted && (b -= .5);
                p.pointPadding && (u = Math.ceil(u));
                t.prototype.translate.apply(a);
                I(a.points, function(c) {
                    var h = x(c.yBottom, b), k = 999 + Math.abs(h), p = l, k = Math.min(Math.max(-k, c.plotY), q.len + k), n = c.plotX + B, t = u, g = Math.min(k, h), r, w = Math.max(k, h) - g;
                    v && Math.abs(w) < v && (w = v, r = !q.reversed && !c.negative || q.reversed && c.negative, c.y === d && a.dataMax <= d && q.min < d && (r = !r), g = Math.abs(g - b) > v ? h - v : b - (r ? v : 0));
                    f(c.options.pointWidth) && (p = t = Math.ceil(c.options.pointWidth), n -= Math.round((p - l) / 2));
                    c.barX = n;
                    c.pointWidth = p;
                    c.tooltipPos = e.inverted ? [
                        q.len + q.pos - e.plotLeft - k,
                        a.xAxis.len - n - t / 2,
                        w
                    ] : [
                        n + t / 2,
                        k + q.pos - e.plotTop,
                        w
                    ];
                    c.shapeType = "rect";
                    c.shapeArgs = a.crispCol.apply(a, c.isNull ? [
                        n,
                        b,
                        t,
                        0
                    ] : [
                        n,
                        g,
                        t,
                        w
                    ]);
                });
            },
            getSymbol: a.noop,
            drawLegendSymbol: a.LegendSymbolMixin.drawRectangle,
            drawGraph: function() {
                this.group[this.dense ? "addClass" : "removeClass"]("highcharts-dense-data");
            },
            pointAttribs: function(a, e) {
                var c = this.options, f, h = this.pointAttrToOptions || {};
                f = h.stroke || "borderColor";
                var d = h["stroke-width"] || "borderWidth", b = a && a.color || this.color, n = a && a[f] || c[f] || this.color || b, t = a && a[d] || c[d] || this[d] || 0, h = c.dashStyle;
                a && this.zones.length && (b = a.getZone(), b = a.options.color || b && b.color || this.color);
                e && (a = u(c.states[e], a.options.states && a.options.states[e] || {}), e = a.brightness, b = a.color || void 0 !== e && F(b).brighten(a.brightness).get() || b, n = a[f] || n, t = a[d] || t, h = a.dashStyle || h);
                f = {
                    fill: b,
                    stroke: n,
                    "stroke-width": t
                };
                h && (f.dashstyle = h);
                return f;
            },
            drawPoints: function() {
                var a = this, f = this.chart, p = a.options, k = f.renderer, q = p.animationLimit || 250, d;
                I(a.points, function(b) {
                    var c = b.graphic, h = c && f.pointCount < q ? "animate" : "attr";
                    if (e(b.plotY) && null !== b.y) {
                        d = b.shapeArgs;
                        if (c) c[h](u(d));
                        else b.graphic = c = k[b.shapeType](d).add(b.group || a.group);
                        p.borderRadius && c.attr({
                            r: p.borderRadius
                        });
                        c[h](a.pointAttribs(b, b.selected && "select")).shadow(p.shadow, null, p.stacking && !p.borderRadius);
                        c.addClass(b.getClassName(), !0);
                    } else c && (b.graphic = c.destroy());
                });
            },
            animate: function(a) {
                var c = this, e = this.yAxis, f = c.options, q = this.chart.inverted, d = {}, b = q ? "translateX" : "translateY", v;
                y && (a ? (d.scaleY = .001, a = Math.min(e.pos + e.len, Math.max(e.pos, e.toPixels(f.threshold))), q ? d.translateX = a - e.len : d.translateY = a, c.group.attr(d)) : (v = c.group.attr(b), c.group.animate({
                    scaleY: 1
                }, n(C(c.options.animation), {
                    step: function(a, f) {
                        d[b] = v + f.pos * (e.pos - v);
                        c.group.attr(d);
                    }
                })), c.animate = null));
            },
            remove: function() {
                var a = this, e = a.chart;
                e.hasRendered && I(e.series, function(c) {
                    c.type === a.type && (c.isDirty = !0);
                });
                t.prototype.remove.apply(a, arguments);
            }
        });
    })(K);
    (function(a) {
        a = a.seriesType;
        a("bar", "column", null, {
            inverted: !0
        });
    })(K);
    (function(a) {
        var C = a.Series;
        a = a.seriesType;
        a("scatter", "line", {
            lineWidth: 0,
            findNearestPointBy: "xy",
            marker: {
                enabled: !0
            },
            tooltip: {
                headerFormat: '\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e \x3cspan style\x3d"font-size: 0.85em"\x3e {series.name}\x3c/span\x3e\x3cbr/\x3e',
                pointFormat: "x: \x3cb\x3e{point.x}\x3c/b\x3e\x3cbr/\x3ey: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e"
            }
        }, {
            sorted: !1,
            requireSorting: !1,
            noSharedTooltip: !0,
            trackerGroups: [
                "group",
                "markerGroup",
                "dataLabelsGroup"
            ],
            takeOrdinalPosition: !1,
            drawGraph: function() {
                this.options.lineWidth && C.prototype.drawGraph.call(this);
            }
        });
    })(K);
    (function(a) {
        var C = a.deg2rad, F = a.isNumber, I = a.pick, n = a.relativeLength;
        a.CenteredSeriesMixin = {
            getCenter: function() {
                var a = this.options, e = this.chart, u = 2 * (a.slicedOffset || 0), x = e.plotWidth - 2 * u, e = e.plotHeight - 2 * u, t = a.center, t = [
                    I(t[0], "50%"),
                    I(t[1], "50%"),
                    a.size || "100%",
                    a.innerSize || 0
                ], w = Math.min(x, e), y, c;
                for(y = 0; 4 > y; ++y)c = t[y], a = 2 > y || 2 === y && /%$/.test(c), t[y] = n(c, [
                    x,
                    e,
                    w,
                    t[2]
                ][y]) + (a ? u : 0);
                t[3] > t[2] && (t[3] = t[2]);
                return t;
            },
            getStartAndEndRadians: function(a, e) {
                a = F(a) ? a : 0;
                e = F(e) && e > a && 360 > e - a ? e : a + 360;
                return {
                    start: C * (a + -90),
                    end: C * (e + -90)
                };
            }
        };
    })(K);
    (function(a) {
        var C = a.addEvent, F = a.CenteredSeriesMixin, I = a.defined, n = a.each, f = a.extend, e = F.getStartAndEndRadians, u = a.inArray, x = a.noop, t = a.pick, w = a.Point, y = a.Series, c = a.seriesType, h = a.setAnimation;
        c("pie", "line", {
            center: [
                null,
                null
            ],
            clip: !1,
            colorByPoint: !0,
            dataLabels: {
                allowOverlap: !0,
                distance: 30,
                enabled: !0,
                formatter: function() {
                    return this.point.isNull ? void 0 : this.point.name;
                },
                x: 0
            },
            ignoreHiddenPoint: !0,
            legendType: "point",
            marker: null,
            size: null,
            showInLegend: !1,
            slicedOffset: 10,
            stickyTracking: !1,
            tooltip: {
                followPointer: !0
            },
            borderColor: "#ffffff",
            borderWidth: 1,
            states: {
                hover: {
                    brightness: .1
                }
            }
        }, {
            isCartesian: !1,
            requireSorting: !1,
            directTouch: !0,
            noSharedTooltip: !0,
            trackerGroups: [
                "group",
                "dataLabelsGroup"
            ],
            axisTypes: [],
            pointAttribs: a.seriesTypes.column.prototype.pointAttribs,
            animate: function(a) {
                var c = this, e = c.points, d = c.startAngleRad;
                a || (n(e, function(a) {
                    var b = a.graphic, e = a.shapeArgs;
                    b && (b.attr({
                        r: a.startR || c.center[3] / 2,
                        start: d,
                        end: d
                    }), b.animate({
                        r: e.r,
                        start: e.start,
                        end: e.end
                    }, c.options.animation));
                }), c.animate = null);
            },
            updateTotals: function() {
                var a, c = 0, e = this.points, d = e.length, b, f = this.options.ignoreHiddenPoint;
                for(a = 0; a < d; a++)b = e[a], c += f && !b.visible ? 0 : b.isNull ? 0 : b.y;
                this.total = c;
                for(a = 0; a < d; a++)b = e[a], b.percentage = 0 < c && (b.visible || !f) ? b.y / c * 100 : 0, b.total = c;
            },
            generatePoints: function() {
                y.prototype.generatePoints.call(this);
                this.updateTotals();
            },
            translate: function(a) {
                this.generatePoints();
                var c = 0, f = this.options, d = f.slicedOffset, b = d + (f.borderWidth || 0), h, n, l, p = e(f.startAngle, f.endAngle), u = this.startAngleRad = p.start, p = (this.endAngleRad = p.end) - u, w = this.points, m, x = f.dataLabels.distance, f = f.ignoreHiddenPoint, A, y = w.length, E;
                a || (this.center = a = this.getCenter());
                this.getX = function(b, c, d) {
                    l = Math.asin(Math.min((b - a[1]) / (a[2] / 2 + d.labelDistance), 1));
                    return a[0] + (c ? -1 : 1) * Math.cos(l) * (a[2] / 2 + d.labelDistance);
                };
                for(A = 0; A < y; A++){
                    E = w[A];
                    E.labelDistance = t(E.options.dataLabels && E.options.dataLabels.distance, x);
                    this.maxLabelDistance = Math.max(this.maxLabelDistance || 0, E.labelDistance);
                    h = u + c * p;
                    if (!f || E.visible) c += E.percentage / 100;
                    n = u + c * p;
                    E.shapeType = "arc";
                    E.shapeArgs = {
                        x: a[0],
                        y: a[1],
                        r: a[2] / 2,
                        innerR: a[3] / 2,
                        start: Math.round(1E3 * h) / 1E3,
                        end: Math.round(1E3 * n) / 1E3
                    };
                    l = (n + h) / 2;
                    l > 1.5 * Math.PI ? l -= 2 * Math.PI : l < -Math.PI / 2 && (l += 2 * Math.PI);
                    E.slicedTranslation = {
                        translateX: Math.round(Math.cos(l) * d),
                        translateY: Math.round(Math.sin(l) * d)
                    };
                    n = Math.cos(l) * a[2] / 2;
                    m = Math.sin(l) * a[2] / 2;
                    E.tooltipPos = [
                        a[0] + .7 * n,
                        a[1] + .7 * m
                    ];
                    E.half = l < -Math.PI / 2 || l > Math.PI / 2 ? 1 : 0;
                    E.angle = l;
                    h = Math.min(b, E.labelDistance / 5);
                    E.labelPos = [
                        a[0] + n + Math.cos(l) * E.labelDistance,
                        a[1] + m + Math.sin(l) * E.labelDistance,
                        a[0] + n + Math.cos(l) * h,
                        a[1] + m + Math.sin(l) * h,
                        a[0] + n,
                        a[1] + m,
                        0 > E.labelDistance ? "center" : E.half ? "right" : "left",
                        l
                    ];
                }
            },
            drawGraph: null,
            drawPoints: function() {
                var a = this, c = a.chart.renderer, e, d, b, h, t = a.options.shadow;
                t && !a.shadowGroup && (a.shadowGroup = c.g("shadow").add(a.group));
                n(a.points, function(l) {
                    d = l.graphic;
                    if (l.isNull) d && (l.graphic = d.destroy());
                    else {
                        h = l.shapeArgs;
                        e = l.getTranslate();
                        var k = l.shadowGroup;
                        t && !k && (k = l.shadowGroup = c.g("shadow").add(a.shadowGroup));
                        k && k.attr(e);
                        b = a.pointAttribs(l, l.selected && "select");
                        d ? d.setRadialReference(a.center).attr(b).animate(f(h, e)) : (l.graphic = d = c[l.shapeType](h).setRadialReference(a.center).attr(e).add(a.group), d.attr(b).attr({
                            "stroke-linejoin": "round"
                        }).shadow(t, k));
                        d.attr({
                            visibility: l.visible ? "inherit" : "hidden"
                        });
                        d.addClass(l.getClassName());
                    }
                });
            },
            searchPoint: x,
            sortByAngle: function(a, c) {
                a.sort(function(a, d) {
                    return void 0 !== a.angle && (d.angle - a.angle) * c;
                });
            },
            drawLegendSymbol: a.LegendSymbolMixin.drawRectangle,
            getCenter: F.getCenter,
            getSymbol: x
        }, {
            init: function() {
                w.prototype.init.apply(this, arguments);
                var a = this, c;
                a.name = t(a.name, "Slice");
                c = function(c) {
                    a.slice("select" === c.type);
                };
                C(a, "select", c);
                C(a, "unselect", c);
                return a;
            },
            isValid: function() {
                return a.isNumber(this.y, !0) && 0 <= this.y;
            },
            setVisible: function(a, c) {
                var e = this, d = e.series, b = d.chart, f = d.options.ignoreHiddenPoint;
                c = t(c, f);
                a !== e.visible && (e.visible = e.options.visible = a = void 0 === a ? !e.visible : a, d.options.data[u(e, d.data)] = e.options, n([
                    "graphic",
                    "dataLabel",
                    "connector",
                    "shadowGroup"
                ], function(b) {
                    if (e[b]) e[b][a ? "show" : "hide"](!0);
                }), e.legendItem && b.legend.colorizeItem(e, a), a || "hover" !== e.state || e.setState(""), f && (d.isDirty = !0), c && b.redraw());
            },
            slice: function(a, c, e) {
                var d = this.series;
                h(e, d.chart);
                t(c, !0);
                this.sliced = this.options.sliced = I(a) ? a : !this.sliced;
                d.options.data[u(this, d.data)] = this.options;
                this.graphic.animate(this.getTranslate());
                this.shadowGroup && this.shadowGroup.animate(this.getTranslate());
            },
            getTranslate: function() {
                return this.sliced ? this.slicedTranslation : {
                    translateX: 0,
                    translateY: 0
                };
            },
            haloPath: function(a) {
                var c = this.shapeArgs;
                return this.sliced || !this.visible ? [] : this.series.chart.renderer.symbols.arc(c.x, c.y, c.r + a, c.r + a, {
                    innerR: this.shapeArgs.r - 1,
                    start: c.start,
                    end: c.end
                });
            }
        });
    })(K);
    (function(a) {
        var C = a.addEvent, F = a.arrayMax, I = a.defined, n = a.each, f = a.extend, e = a.format, u = a.map, x = a.merge, t = a.noop, w = a.pick, y = a.relativeLength, c = a.Series, h = a.seriesTypes, p = a.some, k = a.stableSort, q = a.isArray, d = a.splat;
        a.distribute = function(b, c, d) {
            function e(a, b) {
                return a.target - b.target;
            }
            var f, h = !0, q = b, m = [], v;
            v = 0;
            var t = q.reducedLen || c;
            for(f = b.length; f--;)v += b[f].size;
            if (v > t) {
                k(b, function(a, b) {
                    return (b.rank || 0) - (a.rank || 0);
                });
                for(v = f = 0; v <= t;)v += b[f].size, f++;
                m = b.splice(f - 1, b.length);
            }
            k(b, e);
            for(b = u(b, function(a) {
                return {
                    size: a.size,
                    targets: [
                        a.target
                    ],
                    align: w(a.align, .5)
                };
            }); h;){
                for(f = b.length; f--;)h = b[f], v = (Math.min.apply(0, h.targets) + Math.max.apply(0, h.targets)) / 2, h.pos = Math.min(Math.max(0, v - h.size * h.align), c - h.size);
                f = b.length;
                for(h = !1; f--;)0 < f && b[f - 1].pos + b[f - 1].size > b[f].pos && (b[f - 1].size += b[f].size, b[f - 1].targets = b[f - 1].targets.concat(b[f].targets), b[f - 1].align = .5, b[f - 1].pos + b[f - 1].size > c && (b[f - 1].pos = c - b[f - 1].size), b.splice(f, 1), h = !0);
            }
            q.push.apply(q, m);
            f = 0;
            p(b, function(b) {
                var e = 0;
                if (p(b.targets, function() {
                    q[f].pos = b.pos + e;
                    if (Math.abs(q[f].pos - q[f].target) > d) return n(q.slice(0, f + 1), function(a) {
                        delete a.pos;
                    }), q.reducedLen = (q.reducedLen || c) - .1 * c, q.reducedLen > .1 * c && a.distribute(q, c, d), !0;
                    e += q[f].size;
                    f++;
                })) return !0;
            });
            k(q, e);
        };
        c.prototype.drawDataLabels = function() {
            function b(a, b) {
                var c = b.filter;
                return c ? (b = c.operator, a = a[c.property], c = c.value, "\x3e" === b && a > c || "\x3c" === b && a < c || "\x3e\x3d" === b && a >= c || "\x3c\x3d" === b && a <= c || "\x3d\x3d" === b && a == c || "\x3d\x3d\x3d" === b && a === c ? !0 : !1) : !0;
            }
            function c(a, b) {
                var c = [], d;
                if (q(a) && !q(b)) c = u(a, function(a) {
                    return x(a, b);
                });
                else if (q(b) && !q(a)) c = u(b, function(b) {
                    return x(a, b);
                });
                else if (q(a) || q(b)) for(d = Math.max(a.length, b.length); d--;)c[d] = x(a[d], b[d]);
                else c = x(a, b);
                return c;
            }
            var f = this, h = f.chart, k = f.options, p = k.dataLabels, t = f.points, m, y = f.hasRendered || 0, A, F = w(p.defer, !!k.animation), E = h.renderer, p = c(c(h.options.plotOptions && h.options.plotOptions.series && h.options.plotOptions.series.dataLabels, h.options.plotOptions && h.options.plotOptions[f.type] && h.options.plotOptions[f.type].dataLabels), p);
            if (q(p) || p.enabled || f._hasPointLabels) A = f.plotGroup("dataLabelsGroup", "data-labels", F && !y ? "hidden" : "visible", p.zIndex || 6), F && (A.attr({
                opacity: +y
            }), y || C(f, "afterAnimate", function() {
                f.visible && A.show(!0);
                A[k.animation ? "animate" : "attr"]({
                    opacity: 1
                }, {
                    duration: 200
                });
            })), n(t, function(g) {
                m = d(c(p, g.dlOptions || g.options && g.options.dataLabels));
                n(m, function(c, d) {
                    var l = c.enabled && !g.isNull && b(g, c), m, n, q, r, p = g.dataLabels ? g.dataLabels[d] : g.dataLabel, v = g.connectors ? g.connectors[d] : g.connector, t = !p;
                    l && (m = g.getLabelConfig(), n = c[g.formatPrefix + "Format"] || c.format, m = I(n) ? e(n, m, h.time) : (c[g.formatPrefix + "Formatter"] || c.formatter).call(m, c), n = c.style, q = c.rotation, n.color = w(c.color, n.color, f.color, "#000000"), "contrast" === n.color && (g.contrastColor = E.getContrast(g.color || f.color), n.color = c.inside || 0 > w(c.distance, g.labelDistance) || k.stacking ? g.contrastColor : "#000000"), k.cursor && (n.cursor = k.cursor), r = {
                        fill: c.backgroundColor,
                        stroke: c.borderColor,
                        "stroke-width": c.borderWidth,
                        r: c.borderRadius || 0,
                        rotation: q,
                        padding: c.padding,
                        zIndex: 1
                    }, a.objectEach(r, function(a, b) {
                        void 0 === a && delete r[b];
                    }));
                    !p || l && I(m) ? l && I(m) && (p ? r.text = m : (g.dataLabels = g.dataLabels || [], p = g.dataLabels[d] = q ? E.text(m, 0, -9999).addClass("highcharts-data-label") : E.label(m, 0, -9999, c.shape, null, null, c.useHTML, null, "data-label"), d || (g.dataLabel = p), p.addClass(" highcharts-data-label-color-" + g.colorIndex + " " + (c.className || "") + (c.useHTML ? " highcharts-tracker" : ""))), p.options = c, p.attr(r), p.css(n).shadow(c.shadow), p.added || p.add(A), f.alignDataLabel(g, p, c, null, t)) : (g.dataLabel = g.dataLabel.destroy(), g.dataLabels && (1 === g.dataLabels.length ? delete g.dataLabels : delete g.dataLabels[d]), d || delete g.dataLabel, v && (g.connector = g.connector.destroy(), g.connectors && (1 === g.connectors.length ? delete g.connectors : delete g.connectors[d])));
                });
            });
            a.fireEvent(this, "afterDrawDataLabels");
        };
        c.prototype.alignDataLabel = function(a, c, d, e, h) {
            var b = this.chart, l = b.inverted, m = w(a.dlBox && a.dlBox.centerX, a.plotX, -9999), k = w(a.plotY, -9999), n = c.getBBox(), q, p = d.rotation, g = d.align, r = this.visible && (a.series.forceDL || b.isInsidePlot(m, Math.round(k), l) || e && b.isInsidePlot(m, l ? e.x + 1 : e.y + e.height - 1, l)), v = "justify" === w(d.overflow, "justify");
            if (r && (q = d.style.fontSize, q = b.renderer.fontMetrics(q, c).b, e = f({
                x: l ? this.yAxis.len - k : m,
                y: Math.round(l ? this.xAxis.len - m : k),
                width: 0,
                height: 0
            }, e), f(d, {
                width: n.width,
                height: n.height
            }), p ? (v = !1, m = b.renderer.rotCorr(q, p), m = {
                x: e.x + d.x + e.width / 2 + m.x,
                y: e.y + d.y + ({
                    top: 0,
                    middle: .5,
                    bottom: 1
                })[d.verticalAlign] * e.height
            }, c[h ? "attr" : "animate"](m).attr({
                align: g
            }), k = (p + 720) % 360, k = 180 < k && 360 > k, "left" === g ? m.y -= k ? n.height : 0 : "center" === g ? (m.x -= n.width / 2, m.y -= n.height / 2) : "right" === g && (m.x -= n.width, m.y -= k ? 0 : n.height), c.placed = !0, c.alignAttr = m) : (c.align(d, null, e), m = c.alignAttr), v && 0 <= e.height ? a.isLabelJustified = this.justifyDataLabel(c, d, m, n, e, h) : w(d.crop, !0) && (r = b.isInsidePlot(m.x, m.y) && b.isInsidePlot(m.x + n.width, m.y + n.height)), d.shape && !p)) c[h ? "attr" : "animate"]({
                anchorX: l ? b.plotWidth - a.plotY : a.plotX,
                anchorY: l ? b.plotHeight - a.plotX : a.plotY
            });
            r || (c.attr({
                y: -9999
            }), c.placed = !1);
        };
        c.prototype.justifyDataLabel = function(a, c, d, e, f, h) {
            var b = this.chart, l = c.align, k = c.verticalAlign, n, q, p = a.box ? 0 : a.padding || 0;
            n = d.x + p;
            0 > n && ("right" === l ? c.align = "left" : c.x = -n, q = !0);
            n = d.x + e.width - p;
            n > b.plotWidth && ("left" === l ? c.align = "right" : c.x = b.plotWidth - n, q = !0);
            n = d.y + p;
            0 > n && ("bottom" === k ? c.verticalAlign = "top" : c.y = -n, q = !0);
            n = d.y + e.height - p;
            n > b.plotHeight && ("top" === k ? c.verticalAlign = "bottom" : c.y = b.plotHeight - n, q = !0);
            q && (a.placed = !h, a.align(c, null, f));
            return q;
        };
        h.pie && (h.pie.prototype.drawDataLabels = function() {
            var b = this, d = b.data, e, f = b.chart, h = b.options.dataLabels, k = w(h.connectorPadding, 10), q = w(h.connectorWidth, 1), m = f.plotWidth, p = f.plotHeight, t = Math.round(f.chartWidth / 3), u, x = b.center, g = x[2] / 2, r = x[1], y, C, H, K, Q = [
                [],
                []
            ], z, P, T, S, U = [
                0,
                0,
                0,
                0
            ];
            b.visible && (h.enabled || b._hasPointLabels) && (n(d, function(a) {
                a.dataLabel && a.visible && a.dataLabel.shortened && (a.dataLabel.attr({
                    width: "auto"
                }).css({
                    width: "auto",
                    textOverflow: "clip"
                }), a.dataLabel.shortened = !1);
            }), c.prototype.drawDataLabels.apply(b), n(d, function(a) {
                a.dataLabel && (a.visible ? (Q[a.half].push(a), a.dataLabel._pos = null, !I(h.style.width) && !I(a.options.dataLabels && a.options.dataLabels.style && a.options.dataLabels.style.width) && a.dataLabel.getBBox().width > t && (a.dataLabel.css({
                    width: .7 * t
                }), a.dataLabel.shortened = !0)) : (a.dataLabel = a.dataLabel.destroy(), a.dataLabels && 1 === a.dataLabels.length && delete a.dataLabels));
            }), n(Q, function(c, d) {
                var l, q, t = c.length, v = [], u;
                if (t) for(b.sortByAngle(c, d - .5), 0 < b.maxLabelDistance && (l = Math.max(0, r - g - b.maxLabelDistance), q = Math.min(r + g + b.maxLabelDistance, f.plotHeight), n(c, function(a) {
                    0 < a.labelDistance && a.dataLabel && (a.top = Math.max(0, r - g - a.labelDistance), a.bottom = Math.min(r + g + a.labelDistance, f.plotHeight), u = a.dataLabel.getBBox().height || 21, a.distributeBox = {
                        target: a.labelPos[1] - a.top + u / 2,
                        size: u,
                        rank: a.y
                    }, v.push(a.distributeBox));
                }), l = q + u - l, a.distribute(v, l, l / 5)), S = 0; S < t; S++)e = c[S], H = e.labelPos, y = e.dataLabel, T = !1 === e.visible ? "hidden" : "inherit", P = l = H[1], v && I(e.distributeBox) && (void 0 === e.distributeBox.pos ? T = "hidden" : (K = e.distributeBox.size, P = e.top + e.distributeBox.pos)), delete e.positionIndex, z = h.justify ? x[0] + (d ? -1 : 1) * (g + e.labelDistance) : b.getX(P < e.top + 2 || P > e.bottom - 2 ? l : P, d, e), y._attr = {
                    visibility: T,
                    align: H[6]
                }, y._pos = {
                    x: z + h.x + (({
                        left: k,
                        right: -k
                    })[H[6]] || 0),
                    y: P + h.y - 10
                }, H.x = z, H.y = P, w(h.crop, !0) && (C = y.getBBox().width, l = null, z - C < k && 1 === d ? (l = Math.round(C - z + k), U[3] = Math.max(l, U[3])) : z + C > m - k && 0 === d && (l = Math.round(z + C - m + k), U[1] = Math.max(l, U[1])), 0 > P - K / 2 ? U[0] = Math.max(Math.round(-P + K / 2), U[0]) : P + K / 2 > p && (U[2] = Math.max(Math.round(P + K / 2 - p), U[2])), y.sideOverflow = l);
            }), 0 === F(U) || this.verifyDataLabelOverflow(U)) && (this.placeDataLabels(), q && n(this.points, function(a) {
                var c;
                u = a.connector;
                if ((y = a.dataLabel) && y._pos && a.visible && 0 < a.labelDistance) {
                    T = y._attr.visibility;
                    if (c = !u) a.connector = u = f.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-" + a.colorIndex + (a.className ? " " + a.className : "")).add(b.dataLabelsGroup), u.attr({
                        "stroke-width": q,
                        stroke: h.connectorColor || a.color || "#666666"
                    });
                    u[c ? "attr" : "animate"]({
                        d: b.connectorPath(a.labelPos)
                    });
                    u.attr("visibility", T);
                } else u && (a.connector = u.destroy());
            }));
        }, h.pie.prototype.connectorPath = function(a) {
            var b = a.x, c = a.y;
            return w(this.options.dataLabels.softConnector, !0) ? [
                "M",
                b + ("left" === a[6] ? 5 : -5),
                c,
                "C",
                b,
                c,
                2 * a[2] - a[4],
                2 * a[3] - a[5],
                a[2],
                a[3],
                "L",
                a[4],
                a[5]
            ] : [
                "M",
                b + ("left" === a[6] ? 5 : -5),
                c,
                "L",
                a[2],
                a[3],
                "L",
                a[4],
                a[5]
            ];
        }, h.pie.prototype.placeDataLabels = function() {
            n(this.points, function(a) {
                var b = a.dataLabel;
                b && a.visible && ((a = b._pos) ? (b.sideOverflow && (b._attr.width = b.getBBox().width - b.sideOverflow, b.css({
                    width: b._attr.width + "px",
                    textOverflow: (this.options.dataLabels.style || {}).textOverflow || "ellipsis"
                }), b.shortened = !0), b.attr(b._attr), b[b.moved ? "animate" : "attr"](a), b.moved = !0) : b && b.attr({
                    y: -9999
                }));
            }, this);
        }, h.pie.prototype.alignDataLabel = t, h.pie.prototype.verifyDataLabelOverflow = function(a) {
            var b = this.center, c = this.options, d = c.center, e = c.minSize || 80, f, h = null !== c.size;
            h || (null !== d[0] ? f = Math.max(b[2] - Math.max(a[1], a[3]), e) : (f = Math.max(b[2] - a[1] - a[3], e), b[0] += (a[3] - a[1]) / 2), null !== d[1] ? f = Math.max(Math.min(f, b[2] - Math.max(a[0], a[2])), e) : (f = Math.max(Math.min(f, b[2] - a[0] - a[2]), e), b[1] += (a[0] - a[2]) / 2), f < b[2] ? (b[2] = f, b[3] = Math.min(y(c.innerSize || 0, f), f), this.translate(b), this.drawDataLabels && this.drawDataLabels()) : h = !0);
            return h;
        });
        h.column && (h.column.prototype.alignDataLabel = function(a, d, e, f, h) {
            var b = this.chart.inverted, l = a.series, m = a.dlBox || a.shapeArgs, k = w(a.below, a.plotY > w(this.translatedThreshold, l.yAxis.len)), n = w(e.inside, !!this.options.stacking);
            m && (f = x(m), 0 > f.y && (f.height += f.y, f.y = 0), m = f.y + f.height - l.yAxis.len, 0 < m && (f.height -= m), b && (f = {
                x: l.yAxis.len - f.y - f.height,
                y: l.xAxis.len - f.x - f.width,
                width: f.height,
                height: f.width
            }), n || (b ? (f.x += k ? 0 : f.width, f.width = 0) : (f.y += k ? f.height : 0, f.height = 0)));
            e.align = w(e.align, !b || n ? "center" : k ? "right" : "left");
            e.verticalAlign = w(e.verticalAlign, b || n ? "middle" : k ? "top" : "bottom");
            c.prototype.alignDataLabel.call(this, a, d, e, f, h);
            a.isLabelJustified && a.contrastColor && d.css({
                color: a.contrastColor
            });
        });
    })(K);
    (function(a) {
        var C = a.Chart, F = a.each, I = a.isArray, n = a.objectEach, f = a.pick;
        a = a.addEvent;
        a(C, "render", function() {
            var a = [];
            F(this.labelCollectors || [], function(e) {
                a = a.concat(e());
            });
            F(this.yAxis || [], function(e) {
                e.options.stackLabels && !e.options.stackLabels.allowOverlap && n(e.stacks, function(e) {
                    n(e, function(e) {
                        a.push(e.label);
                    });
                });
            });
            F(this.series || [], function(e) {
                var n = e.options.dataLabels;
                e.visible && (!1 !== n.enabled || e._hasPointLabels) && F(e.points, function(e) {
                    if (e.visible) {
                        var n = I(e.dataLabels) ? e.dataLabels : e.dataLabel ? [
                            e.dataLabel
                        ] : [];
                        F(n, function(n) {
                            var c = n.options;
                            n.labelrank = f(c.labelrank, e.labelrank, e.shapeArgs && e.shapeArgs.height);
                            c.allowOverlap || a.push(n);
                        });
                    }
                });
            });
            this.hideOverlappingLabels(a);
        });
        C.prototype.hideOverlappingLabels = function(a) {
            var e = a.length, f = this.renderer, n, w, y, c, h, p, k = function(a, c, b, e, f, h, k, n) {
                return !(f > a + b || f + k < a || h > c + e || h + n < c);
            };
            y = function(a) {
                var c, b, e, h = a.box ? 0 : a.padding || 0;
                e = 0;
                if (a && (!a.alignAttr || a.placed)) return c = a.alignAttr || {
                    x: a.attr("x"),
                    y: a.attr("y")
                }, b = a.parentGroup, a.width || (e = a.getBBox(), a.width = e.width, a.height = e.height, e = f.fontMetrics(null, a.element).h), {
                    x: c.x + (b.translateX || 0) + h,
                    y: c.y + (b.translateY || 0) + h - e,
                    width: a.width - 2 * h,
                    height: a.height - 2 * h
                };
            };
            for(w = 0; w < e; w++)if (n = a[w]) n.oldOpacity = n.opacity, n.newOpacity = 1, n.absoluteBox = y(n);
            a.sort(function(a, c) {
                return (c.labelrank || 0) - (a.labelrank || 0);
            });
            for(w = 0; w < e; w++)for(p = (y = a[w]) && y.absoluteBox, n = w + 1; n < e; ++n)if (h = (c = a[n]) && c.absoluteBox, p && h && y !== c && 0 !== y.newOpacity && 0 !== c.newOpacity && (h = k(p.x, p.y, p.width, p.height, h.x, h.y, h.width, h.height))) (y.labelrank < c.labelrank ? y : c).newOpacity = 0;
            F(a, function(a) {
                var c, b;
                a && (b = a.newOpacity, a.oldOpacity !== b && (a.alignAttr && a.placed ? (b ? a.show(!0) : c = function() {
                    a.hide();
                }, a.alignAttr.opacity = b, a[a.isOld ? "animate" : "attr"](a.alignAttr, null, c)) : a.attr({
                    opacity: b
                })), a.isOld = !0);
            });
        };
    })(K);
    (function(a) {
        var C = a.addEvent, F = a.Chart, I = a.createElement, n = a.css, f = a.defaultOptions, e = a.defaultPlotOptions, u = a.each, x = a.extend, t = a.fireEvent, w = a.hasTouch, y = a.inArray, c = a.isObject, h = a.Legend, p = a.merge, k = a.pick, q = a.Point, d = a.Series, b = a.seriesTypes, v = a.svg, J;
        J = a.TrackerMixin = {
            drawTrackerPoint: function() {
                var a = this, b = a.chart.pointer, c = function(a) {
                    var c = b.getPointFromEvent(a);
                    void 0 !== c && (b.isDirectTouch = !0, c.onMouseOver(a));
                };
                u(a.points, function(a) {
                    a.graphic && (a.graphic.element.point = a);
                    a.dataLabel && (a.dataLabel.div ? a.dataLabel.div.point = a : a.dataLabel.element.point = a);
                });
                a._hasTracking || (u(a.trackerGroups, function(d) {
                    if (a[d]) {
                        a[d].addClass("highcharts-tracker").on("mouseover", c).on("mouseout", function(a) {
                            b.onTrackerMouseOut(a);
                        });
                        if (w) a[d].on("touchstart", c);
                        a.options.cursor && a[d].css(n).css({
                            cursor: a.options.cursor
                        });
                    }
                }), a._hasTracking = !0);
                t(this, "afterDrawTracker");
            },
            drawTrackerGraph: function() {
                var a = this, b = a.options, c = b.trackByArea, d = [].concat(c ? a.areaPath : a.graphPath), e = d.length, f = a.chart, h = f.pointer, k = f.renderer, n = f.options.tooltip.snap, g = a.tracker, q, p = function() {
                    if (f.hoverSeries !== a) a.onMouseOver();
                }, x = "rgba(192,192,192," + (v ? .0001 : .002) + ")";
                if (e && !c) for(q = e + 1; q--;)"M" === d[q] && d.splice(q + 1, 0, d[q + 1] - n, d[q + 2], "L"), (q && "M" === d[q] || q === e) && d.splice(q, 0, "L", d[q - 2] + n, d[q - 1]);
                g ? g.attr({
                    d: d
                }) : a.graph && (a.tracker = k.path(d).attr({
                    "stroke-linejoin": "round",
                    stroke: x,
                    fill: c ? x : "none",
                    "stroke-width": a.graph.strokeWidth() + (c ? 0 : 2 * n),
                    visibility: a.visible ? "visible" : "hidden",
                    zIndex: 2
                }).addClass(c ? "highcharts-tracker-area" : "highcharts-tracker-line").add(a.group), u([
                    a.tracker,
                    a.markerGroup
                ], function(a) {
                    a.addClass("highcharts-tracker").on("mouseover", p).on("mouseout", function(a) {
                        h.onTrackerMouseOut(a);
                    });
                    b.cursor && a.css({
                        cursor: b.cursor
                    });
                    if (w) a.on("touchstart", p);
                }));
                t(this, "afterDrawTracker");
            }
        };
        b.column && (b.column.prototype.drawTracker = J.drawTrackerPoint);
        b.pie && (b.pie.prototype.drawTracker = J.drawTrackerPoint);
        b.scatter && (b.scatter.prototype.drawTracker = J.drawTrackerPoint);
        f.legend.itemStyle.cursor = "pointer";
        x(h.prototype, {
            setItemEvents: function(a, b, c) {
                var d = this, e = d.chart.renderer.boxWrapper, f = "highcharts-legend-" + (a instanceof q ? "point" : "series") + "-active";
                (c ? b : a.legendGroup).on("mouseover", function() {
                    a.setState("hover");
                    e.addClass(f);
                    b.css(d.options.itemHoverStyle);
                }).on("mouseout", function() {
                    b.css(p(a.visible ? d.itemStyle : d.itemHiddenStyle));
                    e.removeClass(f);
                    a.setState();
                }).on("click", function(b) {
                    var c = function() {
                        a.setVisible && a.setVisible();
                    };
                    e.removeClass(f);
                    b = {
                        browserEvent: b
                    };
                    a.firePointEvent ? a.firePointEvent("legendItemClick", b, c) : t(a, "legendItemClick", b, c);
                });
            },
            createCheckboxForItem: function(a) {
                a.checkbox = I("input", {
                    type: "checkbox",
                    className: "highcharts-legend-checkbox",
                    checked: a.selected,
                    defaultChecked: a.selected
                }, this.options.itemCheckboxStyle, this.chart.container);
                C(a.checkbox, "click", function(b) {
                    t(a.series || a, "checkboxClick", {
                        checked: b.target.checked,
                        item: a
                    }, function() {
                        a.select();
                    });
                });
            }
        });
        x(F.prototype, {
            showResetZoom: function() {
                function a() {
                    b.zoomOut();
                }
                var b = this, c = f.lang, d = b.options.chart.resetZoomButton, e = d.theme, h = e.states, k = "chart" === d.relativeTo ? null : "plotBox";
                t(this, "beforeShowResetZoom", null, function() {
                    b.resetZoomButton = b.renderer.button(c.resetZoom, null, null, a, e, h && h.hover).attr({
                        align: d.position.align,
                        title: c.resetZoomTitle
                    }).addClass("highcharts-reset-zoom").add().align(d.position, !1, k);
                });
            },
            zoomOut: function() {
                t(this, "selection", {
                    resetSelection: !0
                }, this.zoom);
            },
            zoom: function(a) {
                var b, d = this.pointer, e = !1, f;
                !a || a.resetSelection ? (u(this.axes, function(a) {
                    b = a.zoom();
                }), d.initiated = !1) : u(a.xAxis.concat(a.yAxis), function(a) {
                    var c = a.axis;
                    d[c.isXAxis ? "zoomX" : "zoomY"] && (b = c.zoom(a.min, a.max), c.displayBtn && (e = !0));
                });
                f = this.resetZoomButton;
                e && !f ? this.showResetZoom() : !e && c(f) && (this.resetZoomButton = f.destroy());
                b && this.redraw(k(this.options.chart.animation, a && a.animation, 100 > this.pointCount));
            },
            pan: function(a, b) {
                var c = this, d = c.hoverPoints, e;
                d && u(d, function(a) {
                    a.setState();
                });
                u("xy" === b ? [
                    1,
                    0
                ] : [
                    1
                ], function(b) {
                    b = c[b ? "xAxis" : "yAxis"][0];
                    var d = b.horiz, f = a[d ? "chartX" : "chartY"], d = d ? "mouseDownX" : "mouseDownY", h = c[d], g = (b.pointRange || 0) / 2, l = b.reversed && !c.inverted || !b.reversed && c.inverted ? -1 : 1, m = b.getExtremes(), k = b.toValue(h - f, !0) + g * l, l = b.toValue(h + b.len - f, !0) - g * l, n = l < k, h = n ? l : k, k = n ? k : l, l = Math.min(m.dataMin, g ? m.min : b.toValue(b.toPixels(m.min) - b.minPixelPadding)), g = Math.max(m.dataMax, g ? m.max : b.toValue(b.toPixels(m.max) + b.minPixelPadding)), n = l - h;
                    0 < n && (k += n, h = l);
                    n = k - g;
                    0 < n && (k = g, h -= n);
                    b.series.length && h !== m.min && k !== m.max && (b.setExtremes(h, k, !1, !1, {
                        trigger: "pan"
                    }), e = !0);
                    c[d] = f;
                });
                e && c.redraw(!1);
                n(c.container, {
                    cursor: "move"
                });
            }
        });
        x(q.prototype, {
            select: function(a, b) {
                var c = this, d = c.series, e = d.chart;
                a = k(a, !c.selected);
                c.firePointEvent(a ? "select" : "unselect", {
                    accumulate: b
                }, function() {
                    c.selected = c.options.selected = a;
                    d.options.data[y(c, d.data)] = c.options;
                    c.setState(a && "select");
                    b || u(e.getSelectedPoints(), function(a) {
                        a.selected && a !== c && (a.selected = a.options.selected = !1, d.options.data[y(a, d.data)] = a.options, a.setState(""), a.firePointEvent("unselect"));
                    });
                });
            },
            onMouseOver: function(a) {
                var b = this.series.chart, c = b.pointer;
                a = a ? c.normalize(a) : c.getChartCoordinatesFromPoint(this, b.inverted);
                c.runPointActions(a, this);
            },
            onMouseOut: function() {
                var a = this.series.chart;
                this.firePointEvent("mouseOut");
                u(a.hoverPoints || [], function(a) {
                    a.setState();
                });
                a.hoverPoints = a.hoverPoint = null;
            },
            importEvents: function() {
                if (!this.hasImportedEvents) {
                    var b = this, c = p(b.series.options.point, b.options).events;
                    b.events = c;
                    a.objectEach(c, function(a, c) {
                        C(b, c, a);
                    });
                    this.hasImportedEvents = !0;
                }
            },
            setState: function(a, b) {
                var c = Math.floor(this.plotX), d = this.plotY, f = this.series, h = f.options.states[a || "normal"] || {}, l = e[f.type].marker && f.options.marker, n = l && !1 === l.enabled, q = l && l.states && l.states[a || "normal"] || {}, g = !1 === q.enabled, p = f.stateMarkerGraphic, v = this.marker || {}, u = f.chart, w = f.halo, y, C = l && f.markerAttribs;
                a = a || "";
                if (!(a === this.state && !b || this.selected && "select" !== a || !1 === h.enabled || a && (g || n && !1 === q.enabled) || a && v.states && v.states[a] && !1 === v.states[a].enabled)) {
                    C && (y = f.markerAttribs(this, a));
                    if (this.graphic) this.state && this.graphic.removeClass("highcharts-point-" + this.state), a && this.graphic.addClass("highcharts-point-" + a), this.graphic.animate(f.pointAttribs(this, a), k(u.options.chart.animation, h.animation)), y && this.graphic.animate(y, k(u.options.chart.animation, q.animation, l.animation)), p && p.hide();
                    else {
                        if (a && q) {
                            l = v.symbol || f.symbol;
                            p && p.currentSymbol !== l && (p = p.destroy());
                            if (p) p[b ? "animate" : "attr"]({
                                x: y.x,
                                y: y.y
                            });
                            else l && (f.stateMarkerGraphic = p = u.renderer.symbol(l, y.x, y.y, y.width, y.height).add(f.markerGroup), p.currentSymbol = l);
                            p && p.attr(f.pointAttribs(this, a));
                        }
                        p && (p[a && u.isInsidePlot(c, d, u.inverted) ? "show" : "hide"](), p.element.point = this);
                    }
                    (c = h.halo) && c.size ? (w || (f.halo = w = u.renderer.path().add((this.graphic || p).parentGroup)), w.show()[b ? "animate" : "attr"]({
                        d: this.haloPath(c.size)
                    }), w.attr({
                        "class": "highcharts-halo highcharts-color-" + k(this.colorIndex, f.colorIndex) + (this.className ? " " + this.className : ""),
                        zIndex: -1
                    }), w.point = this, w.attr(x({
                        fill: this.color || f.color,
                        "fill-opacity": c.opacity
                    }, c.attributes))) : w && w.point && w.point.haloPath && w.animate({
                        d: w.point.haloPath(0)
                    }, null, w.hide);
                    this.state = a;
                    t(this, "afterSetState");
                }
            },
            haloPath: function(a) {
                return this.series.chart.renderer.symbols.circle(Math.floor(this.plotX) - a, this.plotY - a, 2 * a, 2 * a);
            }
        });
        x(d.prototype, {
            onMouseOver: function() {
                var a = this.chart, b = a.hoverSeries;
                if (b && b !== this) b.onMouseOut();
                this.options.events.mouseOver && t(this, "mouseOver");
                this.setState("hover");
                a.hoverSeries = this;
            },
            onMouseOut: function() {
                var a = this.options, b = this.chart, c = b.tooltip, d = b.hoverPoint;
                b.hoverSeries = null;
                if (d) d.onMouseOut();
                this && a.events.mouseOut && t(this, "mouseOut");
                !c || this.stickyTracking || c.shared && !this.noSharedTooltip || c.hide();
                this.setState();
            },
            setState: function(a) {
                var b = this, c = b.options, d = b.graph, e = c.states, f = c.lineWidth, c = 0;
                a = a || "";
                if (b.state !== a && (u([
                    b.group,
                    b.markerGroup,
                    b.dataLabelsGroup
                ], function(c) {
                    c && (b.state && c.removeClass("highcharts-series-" + b.state), a && c.addClass("highcharts-series-" + a));
                }), b.state = a, !e[a] || !1 !== e[a].enabled) && (a && (f = e[a].lineWidth || f + (e[a].lineWidthPlus || 0)), d && !d.dashstyle)) for(f = {
                    "stroke-width": f
                }, d.animate(f, k(e[a || "normal"] && e[a || "normal"].animation, b.chart.options.chart.animation)); b["zone-graph-" + c];)b["zone-graph-" + c].attr(f), c += 1;
            },
            setVisible: function(a, b) {
                var c = this, d = c.chart, e = c.legendItem, f, h = d.options.chart.ignoreHiddenSeries, k = c.visible;
                f = (c.visible = a = c.options.visible = c.userOptions.visible = void 0 === a ? !k : a) ? "show" : "hide";
                u([
                    "group",
                    "dataLabelsGroup",
                    "markerGroup",
                    "tracker",
                    "tt"
                ], function(a) {
                    if (c[a]) c[a][f]();
                });
                if (d.hoverSeries === c || (d.hoverPoint && d.hoverPoint.series) === c) c.onMouseOut();
                e && d.legend.colorizeItem(c, a);
                c.isDirty = !0;
                c.options.stacking && u(d.series, function(a) {
                    a.options.stacking && a.visible && (a.isDirty = !0);
                });
                u(c.linkedSeries, function(b) {
                    b.setVisible(a, !1);
                });
                h && (d.isDirtyBox = !0);
                t(c, f);
                !1 !== b && d.redraw();
            },
            show: function() {
                this.setVisible(!0);
            },
            hide: function() {
                this.setVisible(!1);
            },
            select: function(a) {
                this.selected = a = void 0 === a ? !this.selected : a;
                this.checkbox && (this.checkbox.checked = a);
                t(this, a ? "select" : "unselect");
            },
            drawTracker: J.drawTrackerGraph
        });
    })(K);
    (function(a) {
        var C = a.Chart, F = a.each, I = a.inArray, n = a.isArray, f = a.isObject, e = a.pick, u = a.splat;
        C.prototype.setResponsive = function(e) {
            var f = this.options.responsive, n = [], u = this.currentResponsive;
            f && f.rules && F(f.rules, function(c) {
                void 0 === c._id && (c._id = a.uniqueKey());
                this.matchResponsiveRule(c, n, e);
            }, this);
            var c = a.merge.apply(0, a.map(n, function(c) {
                return a.find(f.rules, function(a) {
                    return a._id === c;
                }).chartOptions;
            })), n = n.toString() || void 0;
            n !== (u && u.ruleIds) && (u && this.update(u.undoOptions, e), n ? (this.currentResponsive = {
                ruleIds: n,
                mergedOptions: c,
                undoOptions: this.currentOptions(c)
            }, this.update(c, e)) : this.currentResponsive = void 0);
        };
        C.prototype.matchResponsiveRule = function(a, f) {
            var n = a.condition;
            (n.callback || function() {
                return this.chartWidth <= e(n.maxWidth, Number.MAX_VALUE) && this.chartHeight <= e(n.maxHeight, Number.MAX_VALUE) && this.chartWidth >= e(n.minWidth, 0) && this.chartHeight >= e(n.minHeight, 0);
            }).call(this) && f.push(a._id);
        };
        C.prototype.currentOptions = function(e) {
            function t(e, c, h, p) {
                var k;
                a.objectEach(e, function(a, d) {
                    if (!p && -1 < I(d, [
                        "series",
                        "xAxis",
                        "yAxis"
                    ])) for(a = u(a), h[d] = [], k = 0; k < a.length; k++)c[d][k] && (h[d][k] = {}, t(a[k], c[d][k], h[d][k], p + 1));
                    else f(a) ? (h[d] = n(a) ? [] : {}, t(a, c[d] || {}, h[d], p + 1)) : h[d] = c[d] || null;
                });
            }
            var w = {};
            t(e, this.options, w, 0);
            return w;
        };
    })(K);
    return K;
});

},{}],"a6fXn":[function(require,module,exports,__globalThis) {
/*
 Highcharts JS v6.2.0 (2018-10-17)

 (c) 2009-2018 Torstein Honsi

 License: www.highcharts.com/license
*/ (function(k) {
    module.exports ? module.exports = k : "function" === typeof define && define.amd ? define(function() {
        return k;
    }) : k(Highcharts);
})(function(k) {
    (function(b) {
        var t = b.addEvent, h = b.Axis, k = b.Chart, m = b.color, q, g = b.each, r = b.extend, p = b.isNumber, e = b.Legend, c = b.LegendSymbolMixin, x = b.noop, w = b.merge, u = b.pick;
        b.ColorAxis || (q = b.ColorAxis = function() {
            this.init.apply(this, arguments);
        }, r(q.prototype, h.prototype), r(q.prototype, {
            defaultColorAxisOptions: {
                lineWidth: 0,
                minPadding: 0,
                maxPadding: 0,
                gridLineWidth: 1,
                tickPixelInterval: 72,
                startOnTick: !0,
                endOnTick: !0,
                offset: 0,
                marker: {
                    animation: {
                        duration: 50
                    },
                    width: .01,
                    color: "#999999"
                },
                labels: {
                    overflow: "justify",
                    rotation: 0
                },
                minColor: "#e6ebf5",
                maxColor: "#003399",
                tickLength: 5,
                showInLegend: !0
            },
            keepProps: [
                "legendGroup",
                "legendItemHeight",
                "legendItemWidth",
                "legendItem",
                "legendSymbol"
            ].concat(h.prototype.keepProps),
            init: function(a, d) {
                var f = "vertical" !== a.options.legend.layout, n;
                this.coll = "colorAxis";
                n = w(this.defaultColorAxisOptions, {
                    side: f ? 2 : 1,
                    reversed: !f
                }, d, {
                    opposite: !f,
                    showEmpty: !1,
                    title: null,
                    visible: a.options.legend.enabled
                });
                h.prototype.init.call(this, a, n);
                d.dataClasses && this.initDataClasses(d);
                this.initStops();
                this.horiz = f;
                this.zoomEnabled = !1;
                this.defaultLegendLength = 200;
            },
            initDataClasses: function(a) {
                var d = this.chart, f, n = 0, l = d.options.chart.colorCount, b = this.options, e = a.dataClasses.length;
                this.dataClasses = f = [];
                this.legendItems = [];
                g(a.dataClasses, function(a, c) {
                    a = w(a);
                    f.push(a);
                    a.color || ("category" === b.dataClassColor ? (c = d.options.colors, l = c.length, a.color = c[n], a.colorIndex = n, n++, n === l && (n = 0)) : a.color = m(b.minColor).tweenTo(m(b.maxColor), 2 > e ? .5 : c / (e - 1)));
                });
            },
            setTickPositions: function() {
                if (!this.dataClasses) return h.prototype.setTickPositions.call(this);
            },
            initStops: function() {
                this.stops = this.options.stops || [
                    [
                        0,
                        this.options.minColor
                    ],
                    [
                        1,
                        this.options.maxColor
                    ]
                ];
                g(this.stops, function(a) {
                    a.color = m(a[1]);
                });
            },
            setOptions: function(a) {
                h.prototype.setOptions.call(this, a);
                this.options.crosshair = this.options.marker;
            },
            setAxisSize: function() {
                var a = this.legendSymbol, d = this.chart, f = d.options.legend || {}, n, l;
                a ? (this.left = f = a.attr("x"), this.top = n = a.attr("y"), this.width = l = a.attr("width"), this.height = a = a.attr("height"), this.right = d.chartWidth - f - l, this.bottom = d.chartHeight - n - a, this.len = this.horiz ? l : a, this.pos = this.horiz ? f : n) : this.len = (this.horiz ? f.symbolWidth : f.symbolHeight) || this.defaultLegendLength;
            },
            normalizedValue: function(a) {
                this.isLog && (a = this.val2lin(a));
                return 1 - (this.max - a) / (this.max - this.min || 1);
            },
            toColor: function(a, d) {
                var f = this.stops, n, l, b = this.dataClasses, e, c;
                if (b) {
                    for(c = b.length; c--;)if (e = b[c], n = e.from, f = e.to, (void 0 === n || a >= n) && (void 0 === f || a <= f)) {
                        l = e.color;
                        d && (d.dataClass = c, d.colorIndex = e.colorIndex);
                        break;
                    }
                } else {
                    a = this.normalizedValue(a);
                    for(c = f.length; c-- && !(a > f[c][0]););
                    n = f[c] || f[c + 1];
                    f = f[c + 1] || n;
                    a = 1 - (f[0] - a) / (f[0] - n[0] || 1);
                    l = n.color.tweenTo(f.color, a);
                }
                return l;
            },
            getOffset: function() {
                var a = this.legendGroup, d = this.chart.axisOffset[this.side];
                a && (this.axisParent = a, h.prototype.getOffset.call(this), this.added || (this.added = !0, this.labelLeft = 0, this.labelRight = this.width), this.chart.axisOffset[this.side] = d);
            },
            setLegendColor: function() {
                var a, d = this.reversed;
                a = d ? 1 : 0;
                d = d ? 0 : 1;
                a = this.horiz ? [
                    a,
                    0,
                    d,
                    0
                ] : [
                    0,
                    d,
                    0,
                    a
                ];
                this.legendColor = {
                    linearGradient: {
                        x1: a[0],
                        y1: a[1],
                        x2: a[2],
                        y2: a[3]
                    },
                    stops: this.stops
                };
            },
            drawLegendSymbol: function(a, d) {
                var f = a.padding, b = a.options, l = this.horiz, c = u(b.symbolWidth, l ? this.defaultLegendLength : 12), e = u(b.symbolHeight, l ? 12 : this.defaultLegendLength), g = u(b.labelPadding, l ? 16 : 30), b = u(b.itemDistance, 10);
                this.setLegendColor();
                d.legendSymbol = this.chart.renderer.rect(0, a.baseline - 11, c, e).attr({
                    zIndex: 1
                }).add(d.legendGroup);
                this.legendItemWidth = c + f + (l ? b : g);
                this.legendItemHeight = e + f + (l ? g : 0);
            },
            setState: function(a) {
                g(this.series, function(d) {
                    d.setState(a);
                });
            },
            visible: !0,
            setVisible: x,
            getSeriesExtremes: function() {
                var a = this.series, d = a.length;
                this.dataMin = Infinity;
                for(this.dataMax = -Infinity; d--;)a[d].getExtremes(), void 0 !== a[d].valueMin && (this.dataMin = Math.min(this.dataMin, a[d].valueMin), this.dataMax = Math.max(this.dataMax, a[d].valueMax));
            },
            drawCrosshair: function(a, d) {
                var f = d && d.plotX, b = d && d.plotY, c, e = this.pos, g = this.len;
                d && (c = this.toPixels(d[d.series.colorKey]), c < e ? c = e - 2 : c > e + g && (c = e + g + 2), d.plotX = c, d.plotY = this.len - c, h.prototype.drawCrosshair.call(this, a, d), d.plotX = f, d.plotY = b, this.cross && !this.cross.addedToColorAxis && this.legendGroup && (this.cross.addClass("highcharts-coloraxis-marker").add(this.legendGroup), this.cross.addedToColorAxis = !0, this.cross.attr({
                    fill: this.crosshair.color
                })));
            },
            getPlotLinePath: function(a, d, f, b, c) {
                return p(c) ? this.horiz ? [
                    "M",
                    c - 4,
                    this.top - 6,
                    "L",
                    c + 4,
                    this.top - 6,
                    c,
                    this.top,
                    "Z"
                ] : [
                    "M",
                    this.left,
                    c,
                    "L",
                    this.left - 6,
                    c + 6,
                    this.left - 6,
                    c - 6,
                    "Z"
                ] : h.prototype.getPlotLinePath.call(this, a, d, f, b);
            },
            update: function(a, d) {
                var c = this.chart, b = c.legend;
                g(this.series, function(a) {
                    a.isDirtyData = !0;
                });
                a.dataClasses && b.allItems && (g(b.allItems, function(a) {
                    a.isDataClass && a.legendGroup && a.legendGroup.destroy();
                }), c.isDirtyLegend = !0);
                c.options[this.coll] = w(this.userOptions, a);
                h.prototype.update.call(this, a, d);
                this.legendItem && (this.setLegendColor(), b.colorizeItem(this, !0));
            },
            remove: function() {
                this.legendItem && this.chart.legend.destroyItem(this);
                h.prototype.remove.call(this);
            },
            getDataClassLegendSymbols: function() {
                var a = this, d = this.chart, f = this.legendItems, e = d.options.legend, l = e.valueDecimals, q = e.valueSuffix || "", h;
                f.length || g(this.dataClasses, function(e, n) {
                    var m = !0, p = e.from, k = e.to;
                    h = "";
                    void 0 === p ? h = "\x3c " : void 0 === k && (h = "\x3e ");
                    void 0 !== p && (h += b.numberFormat(p, l) + q);
                    void 0 !== p && void 0 !== k && (h += " - ");
                    void 0 !== k && (h += b.numberFormat(k, l) + q);
                    f.push(r({
                        chart: d,
                        name: h,
                        options: {},
                        drawLegendSymbol: c.drawRectangle,
                        visible: !0,
                        setState: x,
                        isDataClass: !0,
                        setVisible: function() {
                            m = this.visible = !m;
                            g(a.series, function(a) {
                                g(a.points, function(a) {
                                    a.dataClass === n && a.setVisible(m);
                                });
                            });
                            d.legend.colorizeItem(this, m);
                        }
                    }, e));
                });
                return f;
            },
            name: ""
        }), g([
            "fill",
            "stroke"
        ], function(a) {
            b.Fx.prototype[a + "Setter"] = function() {
                this.elem.attr(a, m(this.start).tweenTo(m(this.end), this.pos), null, !0);
            };
        }), t(k, "afterGetAxes", function() {
            var a = this.options.colorAxis;
            this.colorAxis = [];
            a && new q(this, a);
        }), t(e, "afterGetAllItems", function(a) {
            var d = [], c = this.chart.colorAxis[0];
            c && c.options && c.options.showInLegend && (c.options.dataClasses ? d = c.getDataClassLegendSymbols() : d.push(c), g(c.series, function(c) {
                b.erase(a.allItems, c);
            }));
            for(c = d.length; c--;)a.allItems.unshift(d[c]);
        }), t(e, "afterColorizeItem", function(a) {
            a.visible && a.item.legendColor && a.item.legendSymbol.attr({
                fill: a.item.legendColor
            });
        }), t(e, "afterUpdate", function(a, c, b) {
            this.chart.colorAxis[0] && this.chart.colorAxis[0].update({}, b);
        }));
    })(k);
    (function(b) {
        var k = b.defined, h = b.each, v = b.noop, m = b.seriesTypes;
        b.colorPointMixin = {
            isValid: function() {
                return null !== this.value && Infinity !== this.value && -Infinity !== this.value;
            },
            setVisible: function(b) {
                var g = this, q = b ? "show" : "hide";
                g.visible = !!b;
                h([
                    "graphic",
                    "dataLabel"
                ], function(b) {
                    if (g[b]) g[b][q]();
                });
            },
            setState: function(h) {
                b.Point.prototype.setState.call(this, h);
                this.graphic && this.graphic.attr({
                    zIndex: "hover" === h ? 1 : 0
                });
            }
        };
        b.colorSeriesMixin = {
            pointArrayMap: [
                "value"
            ],
            axisTypes: [
                "xAxis",
                "yAxis",
                "colorAxis"
            ],
            optionalAxis: "colorAxis",
            trackerGroups: [
                "group",
                "markerGroup",
                "dataLabelsGroup"
            ],
            getSymbol: v,
            parallelArrays: [
                "x",
                "y",
                "value"
            ],
            colorKey: "value",
            pointAttribs: m.column.prototype.pointAttribs,
            translateColors: function() {
                var b = this, g = this.options.nullColor, k = this.colorAxis, m = this.colorKey;
                h(this.data, function(e) {
                    var c = e[m];
                    if (c = e.options.color || (e.isNull ? g : k && void 0 !== c ? k.toColor(c, e) : e.color || b.color)) e.color = c;
                });
            },
            colorAttribs: function(b) {
                var g = {};
                k(b.color) && (g[this.colorProp || "fill"] = b.color);
                return g;
            }
        };
    })(k);
    (function(b) {
        var k = b.colorPointMixin, h = b.each, v = b.merge, m = b.noop, q = b.pick, g = b.Series, r = b.seriesType, p = b.seriesTypes;
        r("heatmap", "scatter", {
            animation: !1,
            borderWidth: 0,
            nullColor: "#f7f7f7",
            dataLabels: {
                formatter: function() {
                    return this.point.value;
                },
                inside: !0,
                verticalAlign: "middle",
                crop: !1,
                overflow: !1,
                padding: 0
            },
            marker: null,
            pointRange: null,
            tooltip: {
                pointFormat: "{point.x}, {point.y}: {point.value}\x3cbr/\x3e"
            },
            states: {
                hover: {
                    halo: !1,
                    brightness: .2
                }
            }
        }, v(b.colorSeriesMixin, {
            pointArrayMap: [
                "y",
                "value"
            ],
            hasPointSpecificOptions: !0,
            getExtremesFromAll: !0,
            directTouch: !0,
            init: function() {
                var b;
                p.scatter.prototype.init.apply(this, arguments);
                b = this.options;
                b.pointRange = q(b.pointRange, b.colsize || 1);
                this.yAxis.axisPointRange = b.rowsize || 1;
            },
            translate: function() {
                var b = this.options, c = this.xAxis, g = this.yAxis, k = b.pointPadding || 0, m = function(a, b, c) {
                    return Math.min(Math.max(b, a), c);
                };
                this.generatePoints();
                h(this.points, function(a) {
                    var d = (b.colsize || 1) / 2, e = (b.rowsize || 1) / 2, h = m(Math.round(c.len - c.translate(a.x - d, 0, 1, 0, 1)), -c.len, 2 * c.len), d = m(Math.round(c.len - c.translate(a.x + d, 0, 1, 0, 1)), -c.len, 2 * c.len), l = m(Math.round(g.translate(a.y - e, 0, 1, 0, 1)), -g.len, 2 * g.len), e = m(Math.round(g.translate(a.y + e, 0, 1, 0, 1)), -g.len, 2 * g.len), p = q(a.pointPadding, k);
                    a.plotX = a.clientX = (h + d) / 2;
                    a.plotY = (l + e) / 2;
                    a.shapeType = "rect";
                    a.shapeArgs = {
                        x: Math.min(h, d) + p,
                        y: Math.min(l, e) + p,
                        width: Math.abs(d - h) - 2 * p,
                        height: Math.abs(e - l) - 2 * p
                    };
                });
                this.translateColors();
            },
            drawPoints: function() {
                p.column.prototype.drawPoints.call(this);
                h(this.points, function(b) {
                    b.graphic.attr(this.colorAttribs(b));
                }, this);
            },
            animate: m,
            getBox: m,
            drawLegendSymbol: b.LegendSymbolMixin.drawRectangle,
            alignDataLabel: p.column.prototype.alignDataLabel,
            getExtremes: function() {
                g.prototype.getExtremes.call(this, this.valueData);
                this.valueMin = this.dataMin;
                this.valueMax = this.dataMax;
                g.prototype.getExtremes.call(this);
            }
        }), b.extend({
            haloPath: function(b) {
                if (!b) return [];
                var c = this.shapeArgs;
                return [
                    "M",
                    c.x - b,
                    c.y - b,
                    "L",
                    c.x - b,
                    c.y + c.height + b,
                    c.x + c.width + b,
                    c.y + c.height + b,
                    c.x + c.width + b,
                    c.y - b,
                    "Z"
                ];
            }
        }, k));
    })(k);
});

},{}],"fO8tz":[function(require,module,exports,__globalThis) {
/**
* Custom events v3.0.10 (2020-12-21)
*
* (c) 2012-2020 Black Label
*
* License: Creative Commons Attribution (CC)
*/ /* global Highcharts setTimeout clearTimeout module:true */ /* eslint no-loop-func: 0 */ /**
 * @namespace customEvents
 **/ (function(factory) {
    if (module.exports) {
        factory['default'] = factory;
        module.exports = factory;
    } else if (typeof define === 'function' && define.amd) define('highcharts-custom-events', [
        'highcharts'
    ], function(Highcharts1) {
        factory(Highcharts1);
        factory.Highcharts = Highcharts1;
        return factory;
    });
    else factory(Highcharts);
})(function(HC) {
    /* global Highcharts :true, window */ 'use strict';
    var UNDEFINED, DBLCLICK = 'dblclick', TOUCHSTART = 'touchstart', CLICK = 'click', pick = HC.pick, wrap = HC.wrap, merge = HC.merge, addEvent = HC.addEvent, isTouchDevice = HC.isTouchDevice, defaultOptions = HC.getOptions().plotOptions, axisProto = HC.Axis && HC.Axis.prototype, plotLineOrBandProto = HC.PlotLineOrBand && HC.PlotLineOrBand.prototype, seriesTypes = HC.seriesTypes, seriesProto = HC.Series && HC.Series.prototype, isObject, isNumber, isArray, objectEach, customEvents, proto, methods;
    /*
	 * Back compatibility
	 */ isArray = HC.isArray || function(obj) {
        var str = Object.prototype.toString.call(obj);
        return str === '[object Array]' || str === '[object Array Iterator]';
    };
    objectEach = HC.objectEach || function(obj, fn, ctx) {
        for(var key in obj)if (obj.hasOwnProperty(key)) fn.call(ctx, obj[key], key, obj);
    };
    isNumber = HC.isNumber || function(n) {
        return typeof n === 'number' && !isNaN(n);
    };
    isObject = HC.isObject || function(obj) {
        return obj && typeof obj === 'object';
    };
    /**
	 * WRAPPED FUNCTIONS
	 */ // reset exis events
    if (plotLineOrBandProto) wrap(plotLineOrBandProto, 'render', function(proceed) {
        var defaultEvents = this.options && this.options.events;
        // reset default events on plot lines or bands
        if (defaultEvents) defaultEvents = false;
        return proceed.apply(this, Array.prototype.slice.call(arguments, 1));
    });
    if (seriesProto) wrap(seriesProto, 'init', function(proceed, chart, options) {
        var chartOptions = chart.options, plotOptions = chartOptions.plotOptions, seriesOptions = chartOptions.plotOptions.series, userOptions = merge(seriesOptions, plotOptions[this.type], options), userOptionsEvents = userOptions && userOptions.events, userOptionsPointEvents = userOptions && userOptions.point && userOptions.point.events; // Fixed #70
        // reset default events on series and series point
        options.events = {};
        options.point = {
            events: {}
        };
        // Add support for legendItemClick
        if (userOptionsEvents) options.events = {
            legendItemClick: userOptionsEvents && userOptionsEvents.legendItemClick
        };
        // Add support for legendItemClick in pie chart
        if (userOptionsPointEvents) options.point.events = {
            legendItemClick: userOptionsPointEvents && userOptionsPointEvents.legendItemClick,
            select: userOptionsPointEvents && userOptionsPointEvents.select,
            unselect: userOptionsPointEvents && userOptionsPointEvents.unselect,
            click: userOptionsPointEvents && userOptionsPointEvents.click,
            mouseOut: userOptionsPointEvents && userOptionsPointEvents.mouseOut,
            mouseOver: userOptionsPointEvents && userOptionsPointEvents.mouseOver
        };
        // attach events to custom object, which is used in attach event
        options.customEvents = {
            series: userOptionsEvents,
            point: userOptionsPointEvents
        };
        // call default action
        proceed.apply(this, Array.prototype.slice.call(arguments, 1));
    });
    HC.Chart.prototype.customEvent = {
        /**
		 * @description Example: [HC.Series, ['drawPoints', 'drawDataLabels']]
		 * @memberof customEvents
		 * @returns {Array} array of pairs: prototype, array of methods to wrap
		 **/ getEventsProtoMethods: function() {
            var protoMethods = [
                [
                    HC.Tick,
                    [
                        'addLabel'
                    ]
                ],
                [
                    HC.Axis,
                    [
                        'render'
                    ]
                ],
                [
                    HC.Axis,
                    [
                        'drawCrosshair'
                    ]
                ],
                [
                    HC.Chart,
                    [
                        'setTitle'
                    ]
                ],
                [
                    HC.Legend,
                    [
                        'renderItem'
                    ]
                ],
                [
                    HC.PlotLineOrBand,
                    [
                        'render'
                    ]
                ],
                [
                    HC.Series,
                    [
                        'drawPoints',
                        'drawDataLabels'
                    ]
                ]
            ];
            // support for extra series
            objectEach(seriesTypes, function(fn, seriesType) {
                protoMethods.push([
                    seriesTypes[seriesType],
                    [
                        'drawPoints',
                        'drawDataLabels'
                    ]
                ]);
            });
            return protoMethods;
        },
        /**
		 * @description Init method, based on getEventsProtoMethods() array. Iterates on array of prototypes and methods to wrap
		 * @memberof customEvents
		 **/ init: function() {
            var eventsProtoMethods = this.getEventsProtoMethods(); // array of pairs [object, [methods]]
            eventsProtoMethods.forEach(function(protoMethod) {
                if (isArray(protoMethod)) {
                    proto = protoMethod[0] && protoMethod[0].prototype;
                    methods = protoMethod[1];
                    if (proto) methods.forEach(function(method) {
                        customEvents.attach(proto, method);
                    });
                }
            });
        },
        /**
		 * @description Wraps methods i.e drawPoints to extract SVG element and set an event by calling customEvents.add()
		 * @param {Object} proto Highcharts prototype i.e Highcharts.Series.prototype
		 * @param {Object} hcMethod name of wrapped method i.e drawPoints
		 * @memberof customEvents
		 **/ attach: function(proto, hcMethod) {
            wrap(proto, hcMethod, function(proceed, param) {
                var eventElement = {
                    events: UNDEFINED,
                    element: UNDEFINED
                }, proceedObject, len, j;
                //  call default actions
                proceedObject = proceed.apply(this, Array.prototype.slice.call(arguments, 1));
                //	call
                eventElement = customEvents.eventElement[hcMethod].call(this, param);
                //  stop, when events and SVG element do not exist
                if (!eventElement.events && !eventElement.eventsSubtitle && !eventElement.eventsPoint) return proceedObject;
                if (eventElement.eventsPoint) {
                    len = eventElement.elementPoint.length;
                    // attach events per each point
                    for(j = 0; j < len; j++)if (eventElement.elementPoint[j]) {
                        var elemPoint = pick(eventElement.elementPoint[j].graphic, eventElement.elementPoint[j]);
                        if (elemPoint && elemPoint !== UNDEFINED) customEvents.add(elemPoint, eventElement.eventsPoint, eventElement.elementPoint[j], eventElement, true);
                    }
                }
                // attach event to subtitle
                if (eventElement.eventsSubtitle) customEvents.add(eventElement.elementSubtitle, eventElement.eventsSubtitle, eventElement, this);
                // attach event to each datalabal and add reference to each point
                if (eventElement.dataLabelsPoints) {
                    var dataLabelsPoints = eventElement.dataLabelsPoints;
                    len = dataLabelsPoints.length;
                    for(j = 0; j < len; j++)customEvents.add(dataLabelsPoints[j].dataLabel, eventElement.events, {
                        dataLabel: dataLabelsPoints[j].dataLabel,
                        point: dataLabelsPoints[j]
                    }, this);
                }
                // attach event to stackLabels
                if (eventElement.eventsStackLabel) customEvents.add(eventElement.elementStackLabel, eventElement.eventsStackLabel, eventElement, this);
                customEvents.add(eventElement.element, eventElement.events, eventElement, this);
                return proceedObject;
            });
        },
        /**
		 * @description adds event on a SVG element
		 * @param {Object} SVGelem graphic element
		 * @param {Object} events object with all events
		 * @param {Object} elemObj "this" object, which is available in the event
		 * @param {Object} series chart series
		 * @memberof customEvents
		 **/ add: function(SVGelem, events, elemObj, eventElement, isPoint) {
            var eventObject = eventElement.eventObject || elemObj.eventObject, isSeries = elemObj.isSeries || eventElement.isSeries;
            // stop when SVG element does not exist
            if (!SVGelem || !SVGelem.element) return false;
            for(var action in events)(function(event) {
                if (events.hasOwnProperty(event) && !SVGelem[event]) {
                    if (isTouchDevice && event === DBLCLICK) {
                        var tapped = false;
                        addEvent(SVGelem.element, TOUCHSTART, function(e) {
                            e.preventDefault();
                            if (isSeries) {
                                var chart = eventObject.chart, normalizedEvent = chart.pointer.normalize(e);
                                if (!eventObject.directTouch) elemObj = eventObject.searchPoint(normalizedEvent, eventObject.kdDimensions === 1);
                                e.point = elemObj; //	#89 point reference in mouse event
                            }
                            if (eventObject && !isPoint || eventObject && isNumber(eventObject.value)) {
                                eventObject.value = elemObj.textStr;
                                elemObj = eventObject;
                            }
                            if (elemObj && elemObj.textStr) elemObj.value = elemObj.textStr;
                            if (elemObj && elemObj.drilldown) elemObj.doDrilldown(undefined, undefined, e);
                            if (!tapped) tapped = setTimeout(function() {
                                tapped = null;
                                if (events[CLICK] && elemObj && elemObj.drilldown === undefined) events[CLICK].call(elemObj, e); //	call single click action
                            }, 300);
                            else {
                                clearTimeout(tapped);
                                tapped = null;
                                if (elemObj && elemObj.drilldown === undefined) events[event].call(elemObj, e);
                            }
                            return false;
                        });
                    } else addEvent(SVGelem.element, event, function(e) {
                        e.stopPropagation();
                        if (isSeries) {
                            var chart = eventObject.chart, normalizedEvent = chart.pointer.normalize(e);
                            if (!eventObject.directTouch) elemObj = eventObject.searchPoint(normalizedEvent, eventObject.kdDimensions === 1);
                            e.point = elemObj; //	#89 point reference in mouse event
                        }
                        if (eventObject && !isPoint || eventObject && isNumber(eventObject.value)) {
                            eventObject.value = elemObj.textStr || eventObject.value; // #95, #98 wrong reference for axis labels
                            elemObj = eventObject;
                        }
                        if (elemObj && elemObj.textStr) elemObj.value = elemObj.textStr;
                        if (isPoint && event === 'click' && elemObj.series && elemObj.series.options && elemObj.series.options.allowPointSelect) {
                            var defaultFunction = function(event) {
                                // Control key is for Windows, meta (= Cmd key) for Mac, Shift
                                // for Opera.
                                if (elemObj.select) elemObj.select(null, e.ctrlKey || e.metaKey || e.shiftKey);
                            };
                            HC.fireEvent(elemObj, event, e, defaultFunction);
                        }
                        if (elemObj && elemObj.drilldown) elemObj.doDrilldown(undefined, undefined, e);
                        else if (events && events[event]) events[event].call(elemObj, e);
                        return false;
                    });
                    SVGelem[event] = function() {
                        return true;
                    };
                }
            })(action);
        },
        eventElement: {
            /**
			* @typedef {Object} eventElement
			**/ /**
			 * @description Extracts SVG elements from points
			 * @property {Object} eventsPoint events for point
			 * @property {Array} elementPoint array of SVG point elements
			 * @property {Object} eventObject object kept in this on i.e click
			 * @return {Object} { events: object, element: object }
			 * @memberof customEvents
			 **/ addLabel: function() {
                var parent = this.parent, axis = this.axis, axisOptions = axis.options, eventsPoint = axisOptions.labels && axisOptions.labels.events, elementPoint = [
                    this.label
                ], len, i;
                if (parent) {
                    var step = this; // current label
                    while(step){
                        if (isArray(step)) {
                            len = step.length;
                            for(i = 0; i < len; i++)elementPoint.push(step[i].label);
                        } else elementPoint.push(step.label);
                        step = step.parent;
                    }
                }
                return {
                    eventsPoint: eventsPoint,
                    elementPoint: elementPoint,
                    eventObject: {
                        axis: axis,
                        isFirst: this.isFirst,
                        isLast: this.isLast,
                        chart: axis.chart,
                        dateTimeLabelFormat: axisOptions.dateTimeLabelFormats,
                        value: this.pos,
                        pos: this.pos
                    }
                };
            },
            /**
			 * @description Extracts SVG elements from title and subtitle
			 * @property {Object} events events for title
			 * @property {Array} elementPoint title SVG element
			 * @property {Object} eventsSubtitle events for subtitle
			 * @property {Array} elementSubtitle subtitle SVG element
			 * @return {Object} {event: object, element: object, eventsSubtitle: object, elementSubtitle: object }
			 * @memberof customEvents
			 **/ setTitle: function() {
                var events = this.options.title && this.options.title.events, element = this.title, eventsSubtitle = this.options.subtitle && this.options.subtitle.events, elementSubtitle = this.subtitle;
                return {
                    events: events,
                    element: element,
                    eventsSubtitle: eventsSubtitle,
                    elementSubtitle: elementSubtitle
                };
            },
            /**
			 * @description Extracts SVG elements from dataLabels
			 * @property {Object} events events for dataLabels
			 * @property {Array} element dataLabels SVG element
			 * @return {Object} { events: object, element: object }
			 * @memberof customEvents
			 **/ drawDataLabels: function() {
                var dataLabelsGroup = this.dataLabelsGroup, dataLabelEvents = dataLabelsGroup && this.options.dataLabels.events;
                return {
                    events: dataLabelEvents,
                    element: dataLabelsGroup,
                    dataLabelsPoints: this.points
                };
            },
            /**
			 * @description Extracts SVG elements from axis title and stackLabels
			 * @property {Object} events events for axis title
			 * @property {Array} element axis title SVG element
			 * @property {Object} eventsPoint events for stacklabels
			 * @property {Array} elementPoint stacklabels SVG element
			 * @property {Object} eventsStackLabel events for stacklabels
			 * @property {Array} elementStackLabel stacklabels group SVG element
			 * @return {Object} { events: object, element: object, eventsPoint: object, elementPoint: object, eventsStackLabel: object, elementStackLabel: object }
			 * @memberof customEvents
			 **/ render: function() {
                var stackLabels = this.options.stackLabels, events, element, eventsPoint, elementPoint, eventsStackLabel, elementStackLabel;
                if (this.axisTitle) {
                    events = this.options.title.events;
                    element = this.axisTitle;
                }
                if (stackLabels && stackLabels.enabled) {
                    eventsPoint = stackLabels.events;
                    elementPoint = this.stacks || this.stacking.stacks;
                    eventsStackLabel = stackLabels.events;
                    elementStackLabel = this.stackTotalGroup || this.stacking.stackTotalGroup;
                }
                return {
                    events: events,
                    element: element,
                    eventsPoint: eventsPoint,
                    elementPoint: elementPoint,
                    eventsStackLabel: eventsStackLabel,
                    elementStackLabel: elementStackLabel
                };
            },
            /**
			 * @description Extracts SVG elements from series and series points
			 * @property {Object} events events for series
			 * @property {Array} element series SVG element
			 * @property {Object} events events for series points
			 * @property {Array} element series points SVG element
			 * @return {Object} { events: object, element: object, eventsPoint: object, elementPoint: object }
			 * @memberof customEvents
			 **/ drawPoints: function() {
                var op = this.options, type = this.type, events = op.customEvents ? op.customEvents.series : op.events, element = this.group, eventsPoint = op.customEvents ? op.customEvents.point : op.point.events, elementPoint;
                if (defaultOptions[type] && defaultOptions[type].marker && !this.bubblePadding) elementPoint = [
                    this.markerGroup
                ]; //	get markers when enabled
                else elementPoint = this.points; //	extract points
                if (!this.kdTree && !this.buildingKdTree) this.buildKDTree(); //	#86, missing reference to point on first mouseover
                return {
                    events: events,
                    element: element,
                    eventsPoint: eventsPoint,
                    elementPoint: elementPoint,
                    eventObject: this,
                    isSeries: true
                };
            },
            /**
			 * @description Extracts SVG elements from legend item
			 * @property {Object} events events for legend item
			 * @property {Array} element legend item SVG element
			 * @return {Object} { events: object, element: object }
			 * @memberof customEvents
			 **/ renderItem: function(item) {
                return {
                    events: this.options.itemEvents,
                    element: item.legendGroup,
                    eventObject: item
                };
            },
            /**
			 * @description Extracts SVG elements from crosshair
			 * @property {Object} events events for crosshair
			 * @property {Array} element crosshair SVG element
			 * @return {Object} { events: object, element: object }
			 * @memberof customEvents
			 **/ drawCrosshair: function() {
                var cross = this.cross, crosshairOptions = this.options.crosshair;
                if (cross) cross.css({
                    'pointer-events': 'auto'
                });
                return {
                    events: crosshairOptions && crosshairOptions.events,
                    element: cross
                };
            }
        }
    };
    customEvents = HC.Chart.prototype.customEvent;
    customEvents.init();
});

},{}],"7TySC":[function(require,module,exports,__globalThis) {
'use strict';
var colorString = require("71b6e3b39cf59f9f");
var convert = require("c094f2fb379d5867");
var _slice = [].slice;
var skippedModels = [
    // to be honest, I don't really feel like keyword belongs in color convert, but eh.
    'keyword',
    // gray conflicts with some method names, and has its own method defined.
    'gray',
    // shouldn't really be in color-convert either...
    'hex'
];
var hashedModelKeys = {};
Object.keys(convert).forEach(function(model) {
    hashedModelKeys[_slice.call(convert[model].labels).sort().join('')] = model;
});
var limiters = {};
function Color(obj, model) {
    if (!(this instanceof Color)) return new Color(obj, model);
    if (model && model in skippedModels) model = null;
    if (model && !(model in convert)) throw new Error('Unknown model: ' + model);
    var i;
    var channels;
    if (obj == null) {
        this.model = 'rgb';
        this.color = [
            0,
            0,
            0
        ];
        this.valpha = 1;
    } else if (obj instanceof Color) {
        this.model = obj.model;
        this.color = obj.color.slice();
        this.valpha = obj.valpha;
    } else if (typeof obj === 'string') {
        var result = colorString.get(obj);
        if (result === null) throw new Error('Unable to parse color from string: ' + obj);
        this.model = result.model;
        channels = convert[this.model].channels;
        this.color = result.value.slice(0, channels);
        this.valpha = typeof result.value[channels] === 'number' ? result.value[channels] : 1;
    } else if (obj.length) {
        this.model = model || 'rgb';
        channels = convert[this.model].channels;
        var newArr = _slice.call(obj, 0, channels);
        this.color = zeroArray(newArr, channels);
        this.valpha = typeof obj[channels] === 'number' ? obj[channels] : 1;
    } else if (typeof obj === 'number') {
        // this is always RGB - can be converted later on.
        obj &= 0xFFFFFF;
        this.model = 'rgb';
        this.color = [
            obj >> 16 & 0xFF,
            obj >> 8 & 0xFF,
            obj & 0xFF
        ];
        this.valpha = 1;
    } else {
        this.valpha = 1;
        var keys = Object.keys(obj);
        if ('alpha' in obj) {
            keys.splice(keys.indexOf('alpha'), 1);
            this.valpha = typeof obj.alpha === 'number' ? obj.alpha : 0;
        }
        var hashedKeys = keys.sort().join('');
        if (!(hashedKeys in hashedModelKeys)) throw new Error('Unable to parse color from object: ' + JSON.stringify(obj));
        this.model = hashedModelKeys[hashedKeys];
        var labels = convert[this.model].labels;
        var color = [];
        for(i = 0; i < labels.length; i++)color.push(obj[labels[i]]);
        this.color = zeroArray(color);
    }
    // perform limitations (clamping, etc.)
    if (limiters[this.model]) {
        channels = convert[this.model].channels;
        for(i = 0; i < channels; i++){
            var limit = limiters[this.model][i];
            if (limit) this.color[i] = limit(this.color[i]);
        }
    }
    this.valpha = Math.max(0, Math.min(1, this.valpha));
    if (Object.freeze) Object.freeze(this);
}
Color.prototype = {
    toString: function() {
        return this.string();
    },
    toJSON: function() {
        return this[this.model]();
    },
    string: function(places) {
        var self = this.model in colorString.to ? this : this.rgb();
        self = self.round(typeof places === 'number' ? places : 1);
        var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
        return colorString.to[self.model](args);
    },
    percentString: function(places) {
        var self = this.rgb().round(typeof places === 'number' ? places : 1);
        var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
        return colorString.to.rgb.percent(args);
    },
    array: function() {
        return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
    },
    object: function() {
        var result = {};
        var channels = convert[this.model].channels;
        var labels = convert[this.model].labels;
        for(var i = 0; i < channels; i++)result[labels[i]] = this.color[i];
        if (this.valpha !== 1) result.alpha = this.valpha;
        return result;
    },
    unitArray: function() {
        var rgb = this.rgb().color;
        rgb[0] /= 255;
        rgb[1] /= 255;
        rgb[2] /= 255;
        if (this.valpha !== 1) rgb.push(this.valpha);
        return rgb;
    },
    unitObject: function() {
        var rgb = this.rgb().object();
        rgb.r /= 255;
        rgb.g /= 255;
        rgb.b /= 255;
        if (this.valpha !== 1) rgb.alpha = this.valpha;
        return rgb;
    },
    round: function(places) {
        places = Math.max(places || 0, 0);
        return new Color(this.color.map(roundToPlace(places)).concat(this.valpha), this.model);
    },
    alpha: function(val) {
        if (arguments.length) return new Color(this.color.concat(Math.max(0, Math.min(1, val))), this.model);
        return this.valpha;
    },
    // rgb
    red: getset('rgb', 0, maxfn(255)),
    green: getset('rgb', 1, maxfn(255)),
    blue: getset('rgb', 2, maxfn(255)),
    hue: getset([
        'hsl',
        'hsv',
        'hsl',
        'hwb',
        'hcg'
    ], 0, function(val) {
        return (val % 360 + 360) % 360;
    }),
    saturationl: getset('hsl', 1, maxfn(100)),
    lightness: getset('hsl', 2, maxfn(100)),
    saturationv: getset('hsv', 1, maxfn(100)),
    value: getset('hsv', 2, maxfn(100)),
    chroma: getset('hcg', 1, maxfn(100)),
    gray: getset('hcg', 2, maxfn(100)),
    white: getset('hwb', 1, maxfn(100)),
    wblack: getset('hwb', 2, maxfn(100)),
    cyan: getset('cmyk', 0, maxfn(100)),
    magenta: getset('cmyk', 1, maxfn(100)),
    yellow: getset('cmyk', 2, maxfn(100)),
    black: getset('cmyk', 3, maxfn(100)),
    x: getset('xyz', 0, maxfn(100)),
    y: getset('xyz', 1, maxfn(100)),
    z: getset('xyz', 2, maxfn(100)),
    l: getset('lab', 0, maxfn(100)),
    a: getset('lab', 1),
    b: getset('lab', 2),
    keyword: function(val) {
        if (arguments.length) return new Color(val);
        return convert[this.model].keyword(this.color);
    },
    hex: function(val) {
        if (arguments.length) return new Color(val);
        return colorString.to.hex(this.rgb().round().color);
    },
    rgbNumber: function() {
        var rgb = this.rgb().color;
        return (rgb[0] & 0xFF) << 16 | (rgb[1] & 0xFF) << 8 | rgb[2] & 0xFF;
    },
    luminosity: function() {
        // http://www.w3.org/TR/WCAG20/#relativeluminancedef
        var rgb = this.rgb().color;
        var lum = [];
        for(var i = 0; i < rgb.length; i++){
            var chan = rgb[i] / 255;
            lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
        }
        return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
    },
    contrast: function(color2) {
        // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
        var lum1 = this.luminosity();
        var lum2 = color2.luminosity();
        if (lum1 > lum2) return (lum1 + 0.05) / (lum2 + 0.05);
        return (lum2 + 0.05) / (lum1 + 0.05);
    },
    level: function(color2) {
        var contrastRatio = this.contrast(color2);
        if (contrastRatio >= 7.1) return 'AAA';
        return contrastRatio >= 4.5 ? 'AA' : '';
    },
    isDark: function() {
        // YIQ equation from http://24ways.org/2010/calculating-color-contrast
        var rgb = this.rgb().color;
        var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
        return yiq < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    negate: function() {
        var rgb = this.rgb();
        for(var i = 0; i < 3; i++)rgb.color[i] = 255 - rgb.color[i];
        return rgb;
    },
    lighten: function(ratio) {
        var hsl = this.hsl();
        hsl.color[2] += hsl.color[2] * ratio;
        return hsl;
    },
    darken: function(ratio) {
        var hsl = this.hsl();
        hsl.color[2] -= hsl.color[2] * ratio;
        return hsl;
    },
    saturate: function(ratio) {
        var hsl = this.hsl();
        hsl.color[1] += hsl.color[1] * ratio;
        return hsl;
    },
    desaturate: function(ratio) {
        var hsl = this.hsl();
        hsl.color[1] -= hsl.color[1] * ratio;
        return hsl;
    },
    whiten: function(ratio) {
        var hwb = this.hwb();
        hwb.color[1] += hwb.color[1] * ratio;
        return hwb;
    },
    blacken: function(ratio) {
        var hwb = this.hwb();
        hwb.color[2] += hwb.color[2] * ratio;
        return hwb;
    },
    grayscale: function() {
        // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
        var rgb = this.rgb().color;
        var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
        return Color.rgb(val, val, val);
    },
    fade: function(ratio) {
        return this.alpha(this.valpha - this.valpha * ratio);
    },
    opaquer: function(ratio) {
        return this.alpha(this.valpha + this.valpha * ratio);
    },
    rotate: function(degrees) {
        var hsl = this.hsl();
        var hue = hsl.color[0];
        hue = (hue + degrees) % 360;
        hue = hue < 0 ? 360 + hue : hue;
        hsl.color[0] = hue;
        return hsl;
    },
    mix: function(mixinColor, weight) {
        // ported from sass implementation in C
        // https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
        if (!mixinColor || !mixinColor.rgb) throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof mixinColor);
        var color1 = mixinColor.rgb();
        var color2 = this.rgb();
        var p = weight === undefined ? 0.5 : weight;
        var w = 2 * p - 1;
        var a = color1.alpha() - color2.alpha();
        var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
        var w2 = 1 - w1;
        return Color.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue(), color1.alpha() * p + color2.alpha() * (1 - p));
    }
};
// model conversion methods and static constructors
Object.keys(convert).forEach(function(model) {
    if (skippedModels.indexOf(model) !== -1) return;
    var channels = convert[model].channels;
    // conversion methods
    Color.prototype[model] = function() {
        if (this.model === model) return new Color(this);
        if (arguments.length) return new Color(arguments, model);
        var newAlpha = typeof arguments[channels] === 'number' ? channels : this.valpha;
        return new Color(assertArray(convert[this.model][model].raw(this.color)).concat(newAlpha), model);
    };
    // 'static' construction methods
    Color[model] = function(color) {
        if (typeof color === 'number') color = zeroArray(_slice.call(arguments), channels);
        return new Color(color, model);
    };
});
function roundTo(num, places) {
    return Number(num.toFixed(places));
}
function roundToPlace(places) {
    return function(num) {
        return roundTo(num, places);
    };
}
function getset(model, channel, modifier) {
    model = Array.isArray(model) ? model : [
        model
    ];
    model.forEach(function(m) {
        (limiters[m] || (limiters[m] = []))[channel] = modifier;
    });
    model = model[0];
    return function(val) {
        var result;
        if (arguments.length) {
            if (modifier) val = modifier(val);
            result = this[model]();
            result.color[channel] = val;
            return result;
        }
        result = this[model]().color[channel];
        if (modifier) result = modifier(result);
        return result;
    };
}
function maxfn(max) {
    return function(v) {
        return Math.max(0, Math.min(max, v));
    };
}
function assertArray(val) {
    return Array.isArray(val) ? val : [
        val
    ];
}
function zeroArray(arr, length) {
    for(var i = 0; i < length; i++)if (typeof arr[i] !== 'number') arr[i] = 0;
    return arr;
}
module.exports = Color;

},{"71b6e3b39cf59f9f":"3esLr","c094f2fb379d5867":"7hcvn"}],"3esLr":[function(require,module,exports,__globalThis) {
/* MIT license */ var colorNames = require("d7a6eeb7388b4bb");
var swizzle = require("248ce9e419a8df53");
var hasOwnProperty = Object.hasOwnProperty;
var reverseNames = Object.create(null);
// create a list of reverse color names
for(var name in colorNames)if (hasOwnProperty.call(colorNames, name)) reverseNames[colorNames[name]] = name;
var cs = module.exports = {
    to: {},
    get: {}
};
cs.get = function(string) {
    var prefix = string.substring(0, 3).toLowerCase();
    var val;
    var model;
    switch(prefix){
        case 'hsl':
            val = cs.get.hsl(string);
            model = 'hsl';
            break;
        case 'hwb':
            val = cs.get.hwb(string);
            model = 'hwb';
            break;
        default:
            val = cs.get.rgb(string);
            model = 'rgb';
            break;
    }
    if (!val) return null;
    return {
        model: model,
        value: val
    };
};
cs.get.rgb = function(string) {
    if (!string) return null;
    var abbr = /^#([a-f0-9]{3,4})$/i;
    var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
    var rgba = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var keyword = /^(\w+)$/;
    var rgb = [
        0,
        0,
        0,
        1
    ];
    var match;
    var i;
    var hexAlpha;
    if (match = string.match(hex)) {
        hexAlpha = match[2];
        match = match[1];
        for(i = 0; i < 3; i++){
            // https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
            var i2 = i * 2;
            rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
        }
        if (hexAlpha) rgb[3] = parseInt(hexAlpha, 16) / 255;
    } else if (match = string.match(abbr)) {
        match = match[1];
        hexAlpha = match[3];
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i] + match[i], 16);
        if (hexAlpha) rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
    } else if (match = string.match(rgba)) {
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i + 1], 0);
        if (match[4]) {
            if (match[5]) rgb[3] = parseFloat(match[4]) * 0.01;
            else rgb[3] = parseFloat(match[4]);
        }
    } else if (match = string.match(per)) {
        for(i = 0; i < 3; i++)rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
        if (match[4]) {
            if (match[5]) rgb[3] = parseFloat(match[4]) * 0.01;
            else rgb[3] = parseFloat(match[4]);
        }
    } else if (match = string.match(keyword)) {
        if (match[1] === 'transparent') return [
            0,
            0,
            0,
            0
        ];
        if (!hasOwnProperty.call(colorNames, match[1])) return null;
        rgb = colorNames[match[1]];
        rgb[3] = 1;
        return rgb;
    } else return null;
    for(i = 0; i < 3; i++)rgb[i] = clamp(rgb[i], 0, 255);
    rgb[3] = clamp(rgb[3], 0, 1);
    return rgb;
};
cs.get.hsl = function(string) {
    if (!string) return null;
    var hsl = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hsl);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var s = clamp(parseFloat(match[2]), 0, 100);
        var l = clamp(parseFloat(match[3]), 0, 100);
        var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            s,
            l,
            a
        ];
    }
    return null;
};
cs.get.hwb = function(string) {
    if (!string) return null;
    var hwb = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hwb);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var w = clamp(parseFloat(match[2]), 0, 100);
        var b = clamp(parseFloat(match[3]), 0, 100);
        var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            w,
            b,
            a
        ];
    }
    return null;
};
cs.to.hex = function() {
    var rgba = swizzle(arguments);
    return '#' + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (rgba[3] < 1 ? hexDouble(Math.round(rgba[3] * 255)) : '');
};
cs.to.rgb = function() {
    var rgba = swizzle(arguments);
    return rgba.length < 4 || rgba[3] === 1 ? 'rgb(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ')' : 'rgba(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ', ' + rgba[3] + ')';
};
cs.to.rgb.percent = function() {
    var rgba = swizzle(arguments);
    var r = Math.round(rgba[0] / 255 * 100);
    var g = Math.round(rgba[1] / 255 * 100);
    var b = Math.round(rgba[2] / 255 * 100);
    return rgba.length < 4 || rgba[3] === 1 ? 'rgb(' + r + '%, ' + g + '%, ' + b + '%)' : 'rgba(' + r + '%, ' + g + '%, ' + b + '%, ' + rgba[3] + ')';
};
cs.to.hsl = function() {
    var hsla = swizzle(arguments);
    return hsla.length < 4 || hsla[3] === 1 ? 'hsl(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%)' : 'hsla(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%, ' + hsla[3] + ')';
};
// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
cs.to.hwb = function() {
    var hwba = swizzle(arguments);
    var a = '';
    if (hwba.length >= 4 && hwba[3] !== 1) a = ', ' + hwba[3];
    return 'hwb(' + hwba[0] + ', ' + hwba[1] + '%, ' + hwba[2] + '%' + a + ')';
};
cs.to.keyword = function(rgb) {
    return reverseNames[rgb.slice(0, 3)];
};
// helpers
function clamp(num, min, max) {
    return Math.min(Math.max(min, num), max);
}
function hexDouble(num) {
    var str = Math.round(num).toString(16).toUpperCase();
    return str.length < 2 ? '0' + str : str;
}

},{"d7a6eeb7388b4bb":"76oE9","248ce9e419a8df53":"50W8m"}],"76oE9":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};

},{}],"50W8m":[function(require,module,exports,__globalThis) {
'use strict';
var isArrayish = require("ce0bf6d0bc000d24");
var concat = Array.prototype.concat;
var slice = Array.prototype.slice;
var swizzle = module.exports = function swizzle(args) {
    var results = [];
    for(var i = 0, len = args.length; i < len; i++){
        var arg = args[i];
        if (isArrayish(arg)) // http://jsperf.com/javascript-array-concat-vs-push/98
        results = concat.call(results, slice.call(arg));
        else results.push(arg);
    }
    return results;
};
swizzle.wrap = function(fn) {
    return function() {
        return fn(swizzle(arguments));
    };
};

},{"ce0bf6d0bc000d24":"dHQGt"}],"dHQGt":[function(require,module,exports,__globalThis) {
module.exports = function isArrayish(obj) {
    if (!obj || typeof obj === 'string') return false;
    return obj instanceof Array || Array.isArray(obj) || obj.length >= 0 && (obj.splice instanceof Function || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== 'String');
};

},{}],"7hcvn":[function(require,module,exports,__globalThis) {
var conversions = require("6663911e9245af69");
var route = require("2726cbcae99c335b");
var convert = {};
var models = Object.keys(conversions);
function wrapRaw(fn) {
    var wrappedFn = function(args) {
        if (args === undefined || args === null) return args;
        if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
        return fn(args);
    };
    // preserve .conversion property if there is one
    if ('conversion' in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
function wrapRounded(fn) {
    var wrappedFn = function(args) {
        if (args === undefined || args === null) return args;
        if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
        var result = fn(args);
        // we're assuming the result is an array here.
        // see notice in conversions.js; don't use box types
        // in conversion functions.
        if (typeof result === 'object') for(var len = result.length, i = 0; i < len; i++)result[i] = Math.round(result[i]);
        return result;
    };
    // preserve .conversion property if there is one
    if ('conversion' in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
models.forEach(function(fromModel) {
    convert[fromModel] = {};
    Object.defineProperty(convert[fromModel], 'channels', {
        value: conversions[fromModel].channels
    });
    Object.defineProperty(convert[fromModel], 'labels', {
        value: conversions[fromModel].labels
    });
    var routes = route(fromModel);
    var routeModels = Object.keys(routes);
    routeModels.forEach(function(toModel) {
        var fn = routes[toModel];
        convert[fromModel][toModel] = wrapRounded(fn);
        convert[fromModel][toModel].raw = wrapRaw(fn);
    });
});
module.exports = convert;

},{"6663911e9245af69":"6Xx8d","2726cbcae99c335b":"9qSPA"}],"6Xx8d":[function(require,module,exports,__globalThis) {
/* MIT license */ var cssKeywords = require("7de42b7de951386e");
// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)
var reverseKeywords = {};
for(var key in cssKeywords)if (cssKeywords.hasOwnProperty(key)) reverseKeywords[cssKeywords[key]] = key;
var convert = module.exports = {
    rgb: {
        channels: 3,
        labels: 'rgb'
    },
    hsl: {
        channels: 3,
        labels: 'hsl'
    },
    hsv: {
        channels: 3,
        labels: 'hsv'
    },
    hwb: {
        channels: 3,
        labels: 'hwb'
    },
    cmyk: {
        channels: 4,
        labels: 'cmyk'
    },
    xyz: {
        channels: 3,
        labels: 'xyz'
    },
    lab: {
        channels: 3,
        labels: 'lab'
    },
    lch: {
        channels: 3,
        labels: 'lch'
    },
    hex: {
        channels: 1,
        labels: [
            'hex'
        ]
    },
    keyword: {
        channels: 1,
        labels: [
            'keyword'
        ]
    },
    ansi16: {
        channels: 1,
        labels: [
            'ansi16'
        ]
    },
    ansi256: {
        channels: 1,
        labels: [
            'ansi256'
        ]
    },
    hcg: {
        channels: 3,
        labels: [
            'h',
            'c',
            'g'
        ]
    },
    apple: {
        channels: 3,
        labels: [
            'r16',
            'g16',
            'b16'
        ]
    },
    gray: {
        channels: 1,
        labels: [
            'gray'
        ]
    }
};
// hide .channels and .labels properties
for(var model in convert)if (convert.hasOwnProperty(model)) {
    if (!('channels' in convert[model])) throw new Error('missing channels property: ' + model);
    if (!('labels' in convert[model])) throw new Error('missing channel labels property: ' + model);
    if (convert[model].labels.length !== convert[model].channels) throw new Error('channel and label counts mismatch: ' + model);
    var channels = convert[model].channels;
    var labels = convert[model].labels;
    delete convert[model].channels;
    delete convert[model].labels;
    Object.defineProperty(convert[model], 'channels', {
        value: channels
    });
    Object.defineProperty(convert[model], 'labels', {
        value: labels
    });
}
convert.rgb.hsl = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var min = Math.min(r, g, b);
    var max = Math.max(r, g, b);
    var delta = max - min;
    var h;
    var s;
    var l;
    if (max === min) h = 0;
    else if (r === max) h = (g - b) / delta;
    else if (g === max) h = 2 + (b - r) / delta;
    else if (b === max) h = 4 + (r - g) / delta;
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    l = (min + max) / 2;
    if (max === min) s = 0;
    else if (l <= 0.5) s = delta / (max + min);
    else s = delta / (2 - max - min);
    return [
        h,
        s * 100,
        l * 100
    ];
};
convert.rgb.hsv = function(rgb) {
    var rdif;
    var gdif;
    var bdif;
    var h;
    var s;
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var v = Math.max(r, g, b);
    var diff = v - Math.min(r, g, b);
    var diffc = function(c) {
        return (v - c) / 6 / diff + 0.5;
    };
    if (diff === 0) h = s = 0;
    else {
        s = diff / v;
        rdif = diffc(r);
        gdif = diffc(g);
        bdif = diffc(b);
        if (r === v) h = bdif - gdif;
        else if (g === v) h = 1 / 3 + rdif - bdif;
        else if (b === v) h = 2 / 3 + gdif - rdif;
        if (h < 0) h += 1;
        else if (h > 1) h -= 1;
    }
    return [
        h * 360,
        s * 100,
        v * 100
    ];
};
convert.rgb.hwb = function(rgb) {
    var r = rgb[0];
    var g = rgb[1];
    var b = rgb[2];
    var h = convert.rgb.hsl(rgb)[0];
    var w = 1 / 255 * Math.min(r, Math.min(g, b));
    b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
    return [
        h,
        w * 100,
        b * 100
    ];
};
convert.rgb.cmyk = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var c;
    var m;
    var y;
    var k;
    k = Math.min(1 - r, 1 - g, 1 - b);
    c = (1 - r - k) / (1 - k) || 0;
    m = (1 - g - k) / (1 - k) || 0;
    y = (1 - b - k) / (1 - k) || 0;
    return [
        c * 100,
        m * 100,
        y * 100,
        k * 100
    ];
};
/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */ function comparativeDistance(x, y) {
    return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
}
convert.rgb.keyword = function(rgb) {
    var reversed = reverseKeywords[rgb];
    if (reversed) return reversed;
    var currentClosestDistance = Infinity;
    var currentClosestKeyword;
    for(var keyword in cssKeywords)if (cssKeywords.hasOwnProperty(keyword)) {
        var value = cssKeywords[keyword];
        // Compute comparative distance
        var distance = comparativeDistance(rgb, value);
        // Check if its less, if so set as closest
        if (distance < currentClosestDistance) {
            currentClosestDistance = distance;
            currentClosestKeyword = keyword;
        }
    }
    return currentClosestKeyword;
};
convert.keyword.rgb = function(keyword) {
    return cssKeywords[keyword];
};
convert.rgb.xyz = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    // assume sRGB
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
    var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
    var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
    return [
        x * 100,
        y * 100,
        z * 100
    ];
};
convert.rgb.lab = function(rgb) {
    var xyz = convert.rgb.xyz(rgb);
    var x = xyz[0];
    var y = xyz[1];
    var z = xyz[2];
    var l;
    var a;
    var b;
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    l = 116 * y - 16;
    a = 500 * (x - y);
    b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
convert.hsl.rgb = function(hsl) {
    var h = hsl[0] / 360;
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var t1;
    var t2;
    var t3;
    var rgb;
    var val;
    if (s === 0) {
        val = l * 255;
        return [
            val,
            val,
            val
        ];
    }
    if (l < 0.5) t2 = l * (1 + s);
    else t2 = l + s - l * s;
    t1 = 2 * l - t2;
    rgb = [
        0,
        0,
        0
    ];
    for(var i = 0; i < 3; i++){
        t3 = h + 1 / 3 * -(i - 1);
        if (t3 < 0) t3++;
        if (t3 > 1) t3--;
        if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
        else if (2 * t3 < 1) val = t2;
        else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
        else val = t1;
        rgb[i] = val * 255;
    }
    return rgb;
};
convert.hsl.hsv = function(hsl) {
    var h = hsl[0];
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var smin = s;
    var lmin = Math.max(l, 0.01);
    var sv;
    var v;
    l *= 2;
    s *= l <= 1 ? l : 2 - l;
    smin *= lmin <= 1 ? lmin : 2 - lmin;
    v = (l + s) / 2;
    sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
    return [
        h,
        sv * 100,
        v * 100
    ];
};
convert.hsv.rgb = function(hsv) {
    var h = hsv[0] / 60;
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var hi = Math.floor(h) % 6;
    var f = h - Math.floor(h);
    var p = 255 * v * (1 - s);
    var q = 255 * v * (1 - s * f);
    var t = 255 * v * (1 - s * (1 - f));
    v *= 255;
    switch(hi){
        case 0:
            return [
                v,
                t,
                p
            ];
        case 1:
            return [
                q,
                v,
                p
            ];
        case 2:
            return [
                p,
                v,
                t
            ];
        case 3:
            return [
                p,
                q,
                v
            ];
        case 4:
            return [
                t,
                p,
                v
            ];
        case 5:
            return [
                v,
                p,
                q
            ];
    }
};
convert.hsv.hsl = function(hsv) {
    var h = hsv[0];
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var vmin = Math.max(v, 0.01);
    var lmin;
    var sl;
    var l;
    l = (2 - s) * v;
    lmin = (2 - s) * vmin;
    sl = s * vmin;
    sl /= lmin <= 1 ? lmin : 2 - lmin;
    sl = sl || 0;
    l /= 2;
    return [
        h,
        sl * 100,
        l * 100
    ];
};
// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert.hwb.rgb = function(hwb) {
    var h = hwb[0] / 360;
    var wh = hwb[1] / 100;
    var bl = hwb[2] / 100;
    var ratio = wh + bl;
    var i;
    var v;
    var f;
    var n;
    // wh + bl cant be > 1
    if (ratio > 1) {
        wh /= ratio;
        bl /= ratio;
    }
    i = Math.floor(6 * h);
    v = 1 - bl;
    f = 6 * h - i;
    if ((i & 0x01) !== 0) f = 1 - f;
    n = wh + f * (v - wh); // linear interpolation
    var r;
    var g;
    var b;
    switch(i){
        default:
        case 6:
        case 0:
            r = v;
            g = n;
            b = wh;
            break;
        case 1:
            r = n;
            g = v;
            b = wh;
            break;
        case 2:
            r = wh;
            g = v;
            b = n;
            break;
        case 3:
            r = wh;
            g = n;
            b = v;
            break;
        case 4:
            r = n;
            g = wh;
            b = v;
            break;
        case 5:
            r = v;
            g = wh;
            b = n;
            break;
    }
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
convert.cmyk.rgb = function(cmyk) {
    var c = cmyk[0] / 100;
    var m = cmyk[1] / 100;
    var y = cmyk[2] / 100;
    var k = cmyk[3] / 100;
    var r;
    var g;
    var b;
    r = 1 - Math.min(1, c * (1 - k) + k);
    g = 1 - Math.min(1, m * (1 - k) + k);
    b = 1 - Math.min(1, y * (1 - k) + k);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
convert.xyz.rgb = function(xyz) {
    var x = xyz[0] / 100;
    var y = xyz[1] / 100;
    var z = xyz[2] / 100;
    var r;
    var g;
    var b;
    r = x * 3.2406 + y * -1.5372 + z * -0.4986;
    g = x * -0.9689 + y * 1.8758 + z * 0.0415;
    b = x * 0.0557 + y * -0.204 + z * 1.0570;
    // assume sRGB
    r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
    g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
    b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
    r = Math.min(Math.max(0, r), 1);
    g = Math.min(Math.max(0, g), 1);
    b = Math.min(Math.max(0, b), 1);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
convert.xyz.lab = function(xyz) {
    var x = xyz[0];
    var y = xyz[1];
    var z = xyz[2];
    var l;
    var a;
    var b;
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    l = 116 * y - 16;
    a = 500 * (x - y);
    b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
convert.lab.xyz = function(lab) {
    var l = lab[0];
    var a = lab[1];
    var b = lab[2];
    var x;
    var y;
    var z;
    y = (l + 16) / 116;
    x = a / 500 + y;
    z = y - b / 200;
    var y2 = Math.pow(y, 3);
    var x2 = Math.pow(x, 3);
    var z2 = Math.pow(z, 3);
    y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
    x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
    z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
    x *= 95.047;
    y *= 100;
    z *= 108.883;
    return [
        x,
        y,
        z
    ];
};
convert.lab.lch = function(lab) {
    var l = lab[0];
    var a = lab[1];
    var b = lab[2];
    var hr;
    var h;
    var c;
    hr = Math.atan2(b, a);
    h = hr * 360 / 2 / Math.PI;
    if (h < 0) h += 360;
    c = Math.sqrt(a * a + b * b);
    return [
        l,
        c,
        h
    ];
};
convert.lch.lab = function(lch) {
    var l = lch[0];
    var c = lch[1];
    var h = lch[2];
    var a;
    var b;
    var hr;
    hr = h / 360 * 2 * Math.PI;
    a = c * Math.cos(hr);
    b = c * Math.sin(hr);
    return [
        l,
        a,
        b
    ];
};
convert.rgb.ansi16 = function(args) {
    var r = args[0];
    var g = args[1];
    var b = args[2];
    var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
    value = Math.round(value / 50);
    if (value === 0) return 30;
    var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
    if (value === 2) ansi += 60;
    return ansi;
};
convert.hsv.ansi16 = function(args) {
    // optimization here; we already know the value and don't need to get
    // it converted for us.
    return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
};
convert.rgb.ansi256 = function(args) {
    var r = args[0];
    var g = args[1];
    var b = args[2];
    // we use the extended greyscale palette here, with the exception of
    // black and white. normal palette only has 4 greyscale shades.
    if (r === g && g === b) {
        if (r < 8) return 16;
        if (r > 248) return 231;
        return Math.round((r - 8) / 247 * 24) + 232;
    }
    var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
    return ansi;
};
convert.ansi16.rgb = function(args) {
    var color = args % 10;
    // handle greyscale
    if (color === 0 || color === 7) {
        if (args > 50) color += 3.5;
        color = color / 10.5 * 255;
        return [
            color,
            color,
            color
        ];
    }
    var mult = (~~(args > 50) + 1) * 0.5;
    var r = (color & 1) * mult * 255;
    var g = (color >> 1 & 1) * mult * 255;
    var b = (color >> 2 & 1) * mult * 255;
    return [
        r,
        g,
        b
    ];
};
convert.ansi256.rgb = function(args) {
    // handle greyscale
    if (args >= 232) {
        var c = (args - 232) * 10 + 8;
        return [
            c,
            c,
            c
        ];
    }
    args -= 16;
    var rem;
    var r = Math.floor(args / 36) / 5 * 255;
    var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
    var b = rem % 6 / 5 * 255;
    return [
        r,
        g,
        b
    ];
};
convert.rgb.hex = function(args) {
    var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
    var string = integer.toString(16).toUpperCase();
    return '000000'.substring(string.length) + string;
};
convert.hex.rgb = function(args) {
    var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!match) return [
        0,
        0,
        0
    ];
    var colorString = match[0];
    if (match[0].length === 3) colorString = colorString.split('').map(function(char) {
        return char + char;
    }).join('');
    var integer = parseInt(colorString, 16);
    var r = integer >> 16 & 0xFF;
    var g = integer >> 8 & 0xFF;
    var b = integer & 0xFF;
    return [
        r,
        g,
        b
    ];
};
convert.rgb.hcg = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var max = Math.max(Math.max(r, g), b);
    var min = Math.min(Math.min(r, g), b);
    var chroma = max - min;
    var grayscale;
    var hue;
    if (chroma < 1) grayscale = min / (1 - chroma);
    else grayscale = 0;
    if (chroma <= 0) hue = 0;
    else if (max === r) hue = (g - b) / chroma % 6;
    else if (max === g) hue = 2 + (b - r) / chroma;
    else hue = 4 + (r - g) / chroma + 4;
    hue /= 6;
    hue %= 1;
    return [
        hue * 360,
        chroma * 100,
        grayscale * 100
    ];
};
convert.hsl.hcg = function(hsl) {
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var c = 1;
    var f = 0;
    if (l < 0.5) c = 2.0 * s * l;
    else c = 2.0 * s * (1.0 - l);
    if (c < 1.0) f = (l - 0.5 * c) / (1.0 - c);
    return [
        hsl[0],
        c * 100,
        f * 100
    ];
};
convert.hsv.hcg = function(hsv) {
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var c = s * v;
    var f = 0;
    if (c < 1.0) f = (v - c) / (1 - c);
    return [
        hsv[0],
        c * 100,
        f * 100
    ];
};
convert.hcg.rgb = function(hcg) {
    var h = hcg[0] / 360;
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    if (c === 0.0) return [
        g * 255,
        g * 255,
        g * 255
    ];
    var pure = [
        0,
        0,
        0
    ];
    var hi = h % 1 * 6;
    var v = hi % 1;
    var w = 1 - v;
    var mg = 0;
    switch(Math.floor(hi)){
        case 0:
            pure[0] = 1;
            pure[1] = v;
            pure[2] = 0;
            break;
        case 1:
            pure[0] = w;
            pure[1] = 1;
            pure[2] = 0;
            break;
        case 2:
            pure[0] = 0;
            pure[1] = 1;
            pure[2] = v;
            break;
        case 3:
            pure[0] = 0;
            pure[1] = w;
            pure[2] = 1;
            break;
        case 4:
            pure[0] = v;
            pure[1] = 0;
            pure[2] = 1;
            break;
        default:
            pure[0] = 1;
            pure[1] = 0;
            pure[2] = w;
    }
    mg = (1.0 - c) * g;
    return [
        (c * pure[0] + mg) * 255,
        (c * pure[1] + mg) * 255,
        (c * pure[2] + mg) * 255
    ];
};
convert.hcg.hsv = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var v = c + g * (1.0 - c);
    var f = 0;
    if (v > 0.0) f = c / v;
    return [
        hcg[0],
        f * 100,
        v * 100
    ];
};
convert.hcg.hsl = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var l = g * (1.0 - c) + 0.5 * c;
    var s = 0;
    if (l > 0.0 && l < 0.5) s = c / (2 * l);
    else if (l >= 0.5 && l < 1.0) s = c / (2 * (1 - l));
    return [
        hcg[0],
        s * 100,
        l * 100
    ];
};
convert.hcg.hwb = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var v = c + g * (1.0 - c);
    return [
        hcg[0],
        (v - c) * 100,
        (1 - v) * 100
    ];
};
convert.hwb.hcg = function(hwb) {
    var w = hwb[1] / 100;
    var b = hwb[2] / 100;
    var v = 1 - b;
    var c = v - w;
    var g = 0;
    if (c < 1) g = (v - c) / (1 - c);
    return [
        hwb[0],
        c * 100,
        g * 100
    ];
};
convert.apple.rgb = function(apple) {
    return [
        apple[0] / 65535 * 255,
        apple[1] / 65535 * 255,
        apple[2] / 65535 * 255
    ];
};
convert.rgb.apple = function(rgb) {
    return [
        rgb[0] / 255 * 65535,
        rgb[1] / 255 * 65535,
        rgb[2] / 255 * 65535
    ];
};
convert.gray.rgb = function(args) {
    return [
        args[0] / 100 * 255,
        args[0] / 100 * 255,
        args[0] / 100 * 255
    ];
};
convert.gray.hsl = convert.gray.hsv = function(args) {
    return [
        0,
        0,
        args[0]
    ];
};
convert.gray.hwb = function(gray) {
    return [
        0,
        100,
        gray[0]
    ];
};
convert.gray.cmyk = function(gray) {
    return [
        0,
        0,
        0,
        gray[0]
    ];
};
convert.gray.lab = function(gray) {
    return [
        gray[0],
        0,
        0
    ];
};
convert.gray.hex = function(gray) {
    var val = Math.round(gray[0] / 100 * 255) & 0xFF;
    var integer = (val << 16) + (val << 8) + val;
    var string = integer.toString(16).toUpperCase();
    return '000000'.substring(string.length) + string;
};
convert.rgb.gray = function(rgb) {
    var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
    return [
        val / 255 * 100
    ];
};

},{"7de42b7de951386e":"gXJ7d"}],"gXJ7d":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};

},{}],"9qSPA":[function(require,module,exports,__globalThis) {
var conversions = require("b3ae1485254efca");
/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function buildGraph() {
    var graph = {};
    // https://jsperf.com/object-keys-vs-for-in-with-closure/3
    var models = Object.keys(conversions);
    for(var len = models.length, i = 0; i < len; i++)graph[models[i]] = {
        // http://jsperf.com/1-vs-infinity
        // micro-opt, but this is simple.
        distance: -1,
        parent: null
    };
    return graph;
}
// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
    var graph = buildGraph();
    var queue = [
        fromModel
    ]; // unshift -> queue -> pop
    graph[fromModel].distance = 0;
    while(queue.length){
        var current = queue.pop();
        var adjacents = Object.keys(conversions[current]);
        for(var len = adjacents.length, i = 0; i < len; i++){
            var adjacent = adjacents[i];
            var node = graph[adjacent];
            if (node.distance === -1) {
                node.distance = graph[current].distance + 1;
                node.parent = current;
                queue.unshift(adjacent);
            }
        }
    }
    return graph;
}
function link(from, to) {
    return function(args) {
        return to(from(args));
    };
}
function wrapConversion(toModel, graph) {
    var path = [
        graph[toModel].parent,
        toModel
    ];
    var fn = conversions[graph[toModel].parent][toModel];
    var cur = graph[toModel].parent;
    while(graph[cur].parent){
        path.unshift(graph[cur].parent);
        fn = link(conversions[graph[cur].parent][cur], fn);
        cur = graph[cur].parent;
    }
    fn.conversion = path;
    return fn;
}
module.exports = function(fromModel) {
    var graph = deriveBFS(fromModel);
    var conversion = {};
    var models = Object.keys(graph);
    for(var len = models.length, i = 0; i < len; i++){
        var toModel = models[i];
        var node = graph[toModel];
        if (node.parent === null) continue;
        conversion[toModel] = wrapConversion(toModel, graph);
    }
    return conversion;
};

},{"b3ae1485254efca":"6Xx8d"}],"j5i8h":[function(require,module,exports,__globalThis) {
module.exports = import("lR9Pa").then(()=>module.bundle.root('1uoQC'));

},{}],"3x9TR":[function(require,module,exports,__globalThis) {
require("9881da4c2fe51e9a");
var $1i38n$reactjsxruntime = require("341aa39c7cadebd3");
var $1i38n$react = require("29d511aaa59e31be");
var $1i38n$reactdom = require("96b0d348d39357ae");
var $1i38n$proptypes = require("cb1138627157d51b");
var $1i38n$lodash = require("2999f0927c8291af");
var $1i38n$gramenesearchclient = require("d3e3c1c006af899a");
var $1i38n$gramenetreesclient = require("655840fac3bf0776");
var $1i38n$reactbootstrap = require("c475fe4917fff41c");
var $1i38n$reacticonsbs = require("13b037afc9bde3e");
require("cd2bb1545c4c36ff");
var $1i38n$platform = require("e7fcd00d2d5a80a1");
var $1i38n$interactjs = require("f433f47a06ab0a4b");
var $1i38n$d3scale = require("51079fc2f5df0d53");
var $1i38n$numeral = require("70e01aefa94f24e9");
var $1i38n$q = require("fc62f927d356b9b7");
var $1i38n$immutabilityhelper = require("f061b16d8f9acad8");
var $1i38n$reactdnd = require("81c0fa9203e105e0");
var $1i38n$reactdndhtml5backend = require("bc99aa7eb443d898");
var $1i38n$lodashflow = require("b0b41c1a3386c268");
var $parcel$global = globalThis;
function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", ()=>$d92d39518efdc8e9$export$2e2bcd8739ae039);
var $62e50bff44daad79$exports = {};
$parcel$defineInteropFlag($62e50bff44daad79$exports);
$parcel$export($62e50bff44daad79$exports, "default", ()=>$62e50bff44daad79$export$2e2bcd8739ae039);
var $62e50bff44daad79$export$2e2bcd8739ae039 = $parcel$interopDefault($1i38n$platform).name === "IE" || $parcel$interopDefault($1i38n$platform).name === "Microsoft Edge";
const $1acbe0e0655373a5$var$NodePopover = (props)=>{
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("div", {
                style: {
                    marginBottom: "0.5rem"
                },
                children: $1acbe0e0655373a5$var$buttons(props)
            }),
            $1acbe0e0655373a5$var$table(props)
        ]
    });
};
function $1acbe0e0655373a5$var$buttons(props) {
    return props.node.displayInfo.leafNode ? $1acbe0e0655373a5$var$geneNodeButtons(props) : $1acbe0e0655373a5$var$internalNodeButtons(props);
}
function $1acbe0e0655373a5$var$internalNodeButtons({ node: node, collapseClade: collapseClade, expandClade: expandClade }) {
    const collapseCladeButton = node.displayInfo.expanded ? $1acbe0e0655373a5$var$btn("Collapse", ()=>collapseClade(node, true), "warning") : undefined;
    // const collapseNodeButton = btn('Collapse node', () => collapseClade(node,false), "warning");
    const expandCladeButton = $1acbe0e0655373a5$var$btn("Expand", ()=>expandClade(node, true), "success");
    // const expandNodeButton = node.displayInfo.expanded ? undefined : btn('Expand node', () => expandClade(node,false), "success");
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("div", {
        children: [
            expandCladeButton,
            " ",
            collapseCladeButton
        ]
    });
}
function $1acbe0e0655373a5$var$geneNodeButtons({ node: node, changeParalogVisibility: changeParalogVisibility, changeGeneOfInterest: changeGeneOfInterest }) {
    var button;
    if (node.displayInfo.isGeneOfInterest && node.displayInfo.paralogs) {
        var root = node.parent;
        while(root.parent)root = root.parent;
        button = $1acbe0e0655373a5$var$btn("Show paralogs", ()=>changeParalogVisibility(root), "success");
    } else button = $1acbe0e0655373a5$var$btn("Focus on this gene", ()=>changeGeneOfInterest(node), "success");
    return button;
}
function $1acbe0e0655373a5$var$btn(name, handler, style = "default") {
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($1i38n$reactbootstrap.Button, {
        variant: style,
        onClick: handler,
        size: "sm",
        children: name
    });
}
function $1acbe0e0655373a5$var$table({ node: node, geneDocs: geneDocs }) {
    const model = node.model;
    const contents = node.displayInfo.leafNode ? $1acbe0e0655373a5$var$geneProps(model, geneDocs) : $1acbe0e0655373a5$var$internalProps(model);
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($1i38n$reactbootstrap.Table, {
        hover: true,
        style: {
            fontSize: 12
        },
        children: contents
    });
}
function $1acbe0e0655373a5$var$geneProps(model, geneDocs) {
    const gene = geneDocs[model.gene_stable_id];
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("tbody", {
        children: [
            $1acbe0e0655373a5$var$prop("ID", model.gene_stable_id),
            $1acbe0e0655373a5$var$prop("Description", model.gene_description),
            $1acbe0e0655373a5$var$prop("nTranscripts", model.nTranscripts),
            $1acbe0e0655373a5$var$prop("Distance to parent", model.distance_to_parent.toPrecision(3)),
            gene && $1acbe0e0655373a5$var$prop("Location", `${gene.region}:${gene.start}-${gene.end}:${gene.strand === 1 ? "+" : "-"}`)
        ]
    });
}
function $1acbe0e0655373a5$var$internalProps(model) {
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("tbody", {
        children: [
            $1acbe0e0655373a5$var$prop("Bootstrap", model.bootstrap),
            model.duplication_confidence_score && $1acbe0e0655373a5$var$prop("Duplication confidence", 100 * model.duplication_confidence_score.toPrecision(3) + "%"),
            $1acbe0e0655373a5$var$prop("Distance to parent", model.distance_to_parent.toPrecision(3))
        ]
    });
}
function $1acbe0e0655373a5$var$prop(name, value) {
    if (!$parcel$interopDefault($1i38n$lodash).isUndefined(value)) return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("td", {
                children: name
            }),
            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("td", {
                children: value
            })
        ]
    });
}
$1acbe0e0655373a5$var$NodePopover.propTypes = {
    node: $parcel$interopDefault($1i38n$proptypes).object.isRequired,
    geneDocs: $parcel$interopDefault($1i38n$proptypes).object.isRequired,
    collapseClade: $parcel$interopDefault($1i38n$proptypes).func.isRequired,
    expandClade: $parcel$interopDefault($1i38n$proptypes).func.isRequired,
    changeParalogVisibility: $parcel$interopDefault($1i38n$proptypes).func.isRequired
};
var $1acbe0e0655373a5$export$2e2bcd8739ae039 = $1acbe0e0655373a5$var$NodePopover;
function $9250a846d2fdf47e$var$taxonomyColor(node) {
    let stats, colorScale, score;
    stats = $parcel$interopDefault($1i38n$lodash).get(node, "relationToGeneOfInterest.taxonomy");
    if (stats) {
        score = stats.lcaDistance + stats.pathDistance;
        colorScale = stats.maxima.colorScale;
        return colorScale(score);
    }
}
var $9250a846d2fdf47e$export$2e2bcd8739ae039 = $9250a846d2fdf47e$var$taxonomyColor;
const $107ec56bdeb4af7c$var$INTERNAL_NODE_SIZE = 4;
const $107ec56bdeb4af7c$var$ONE_CHILD_SIZE_RATIO = 0.8;
const $107ec56bdeb4af7c$var$Internal = (props)=>{
    const hasOneChild = props.node.children.length === 1;
    const xy = hasOneChild ? $107ec56bdeb4af7c$var$Internal.xy * $107ec56bdeb4af7c$var$ONE_CHILD_SIZE_RATIO : $107ec56bdeb4af7c$var$Internal.xy;
    const wh = hasOneChild ? $107ec56bdeb4af7c$var$Internal.wh * $107ec56bdeb4af7c$var$ONE_CHILD_SIZE_RATIO : $107ec56bdeb4af7c$var$Internal.wh;
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
        className: $107ec56bdeb4af7c$var$className(props.node),
        children: [
            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("rect", {
                x: xy,
                y: xy,
                width: wh,
                height: wh
            }),
            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("text", {
                x: "10",
                dy: ".35em",
                textAnchor: "start",
                children: $107ec56bdeb4af7c$var$text(props.node)
            })
        ]
    });
};
function $107ec56bdeb4af7c$var$className(node) {
    let className = "internal";
    let nodeType = $parcel$interopDefault($1i38n$lodash).get(node, "model.node_type");
    if (nodeType) className += " " + nodeType;
    return className;
}
function $107ec56bdeb4af7c$var$text(node) {
    return $parcel$interopDefault($1i38n$lodash).get(node, "model.gene_display_label") || $parcel$interopDefault($1i38n$lodash).get(node, "model.gene_stable_id") || "";
}
$107ec56bdeb4af7c$var$Internal.propTypes = {
    node: $parcel$interopDefault($1i38n$proptypes).object.isRequired,
    onHover: $parcel$interopDefault($1i38n$proptypes).func.isRequired
};
$107ec56bdeb4af7c$var$Internal.xy = $107ec56bdeb4af7c$var$INTERNAL_NODE_SIZE / -2;
$107ec56bdeb4af7c$var$Internal.wh = $107ec56bdeb4af7c$var$INTERNAL_NODE_SIZE;
var $107ec56bdeb4af7c$export$2e2bcd8739ae039 = $107ec56bdeb4af7c$var$Internal;
let $144e30bd197fcd40$var$defaultXAdjust = $107ec56bdeb4af7c$export$2e2bcd8739ae039.xy;
// see CSS selector ".node:hover .internal"
const $144e30bd197fcd40$var$HOVER_SCALE_FACTOR = 2;
const $144e30bd197fcd40$var$Edge = (props)=>{
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
        className: "edge",
        children: [
            $144e30bd197fcd40$var$interactionHelper(props),
            $144e30bd197fcd40$var$edge(props)
        ]
    });
};
function $144e30bd197fcd40$var$pathCoords(props) {
    let adjustedTarget, path;
    let source = props.source;
    let target = props.target;
    let shouldAdjust = props.cladeHovered && !props.thisCladeHovered;
    let yDoesntChange = $parcel$interopDefault($1i38n$lodash).get(target, "model.children.length") === 1;
    // stop drawing the edge before it overlaps the parent node
    // (the child edge is always drawn after the parent node)
    let adjust = shouldAdjust ? $144e30bd197fcd40$var$defaultXAdjust * $144e30bd197fcd40$var$HOVER_SCALE_FACTOR : $144e30bd197fcd40$var$defaultXAdjust;
    if (yDoesntChange) {
        adjustedTarget = target.y - adjust;
        path = [
            [
                0,
                0
            ],
            [
                adjustedTarget - source.y,
                0
            ]
        ];
    } else {
        adjustedTarget = source.x > target.x ? target.x - adjust : target.x + adjust;
        path = [
            [
                0,
                0
            ],
            [
                target.y - source.y,
                0
            ],
            [
                target.y - source.y,
                adjustedTarget - source.x
            ]
        ];
    }
    return path;
}
function $144e30bd197fcd40$var$transform(c1, c2, size, isStyle) {
    let px, offset, transform, x1, x2, y1, y2, shouldScaleX;
    px = isStyle ? "px" : "";
    size = size || 1;
    offset = size / 2;
    x1 = c1[0];
    y1 = c1[1];
    x2 = c2[0];
    y2 = c2[1];
    shouldScaleX = x1 !== x2;
    // either the x coords (index 0) or y coords (index 1)
    // will differ.
    // if x coords differ, scaleX
    if (shouldScaleX) transform = "translate(" + (x2 - offset) + px + ", " + (y2 - offset) + px + ") " + "scale(" + (x1 - x2 + offset) + ", " + size + ") ";
    else transform = "translate(" + (x2 - offset) + px + ", " + y2 + px + ") " + "scale(" + size + ", " + (y1 - y2) + ")";
    return transform;
}
function $144e30bd197fcd40$var$rect(c1, c2, className, size, color) {
    // if either coordinate is missing, don't draw the rectangle.
    if (!c1 || !c2) return;
    let props = {
        className: className,
        style: {
            fill: color
        },
        x: 0,
        y: 0,
        width: 1,
        height: 1
    };
    if ($62e50bff44daad79$export$2e2bcd8739ae039) props.transform = $144e30bd197fcd40$var$transform(c1, c2, size, false);
    else props.style.transform = $144e30bd197fcd40$var$transform(c1, c2, size, true);
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("rect", {
        ...props
    });
}
function $144e30bd197fcd40$var$edge(props) {
    const coords = $144e30bd197fcd40$var$pathCoords(props);
    const className = "edge-rect";
    const size = props.cladeHovered ? $144e30bd197fcd40$var$Edge.width.hovered : $144e30bd197fcd40$var$Edge.width.edge;
    const color = $9250a846d2fdf47e$export$2e2bcd8739ae039(props.source);
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
        children: [
            $144e30bd197fcd40$var$rect(coords[0], coords[1], className, size, color),
            $144e30bd197fcd40$var$rect(coords[1], coords[2], className, size, color)
        ]
    });
}
function $144e30bd197fcd40$var$interactionHelper(props) {
    const coords = $144e30bd197fcd40$var$pathCoords(props);
    const className = "interaction-rect";
    const size = $144e30bd197fcd40$var$Edge.width.helper;
    const color = $9250a846d2fdf47e$export$2e2bcd8739ae039(props.source);
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
        className: "interaction-helper",
        children: [
            $144e30bd197fcd40$var$rect(coords[0], coords[1], className, size, color),
            $144e30bd197fcd40$var$rect(coords[1], coords[2], className, size, color)
        ]
    });
}
$144e30bd197fcd40$var$Edge.propTypes = {
    source: $parcel$interopDefault($1i38n$proptypes).object.isRequired,
    target: $parcel$interopDefault($1i38n$proptypes).object.isRequired,
    cladeHovered: $parcel$interopDefault($1i38n$proptypes).bool.isRequired,
    thisCladeHovered: $parcel$interopDefault($1i38n$proptypes).bool.isRequired
};
$144e30bd197fcd40$var$Edge.width = {
    edge: 1,
    hovered: 2,
    helper: 4
};
var $144e30bd197fcd40$export$2e2bcd8739ae039 = $144e30bd197fcd40$var$Edge;
const $68b624418d7ff7df$var$Collapsed = (props)=>{
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
        className: "collapsed",
        children: [
            $68b624418d7ff7df$var$triangle(props.node),
            $68b624418d7ff7df$var$text(props.node)
        ]
    });
};
function $68b624418d7ff7df$var$text(node) {
    let texts, homologs, /*orthologs,*/ paralogs;
    homologs = node.leafNodes().length;
    //orthologs = _.get(node, 'displayInfo.orthologs.length') || 0;
    paralogs = $parcel$interopDefault($1i38n$lodash).get(node, "displayInfo.paralogs.length") || 0;
    texts = [
        node.model.taxon_name + ": " + homologs + " genes"
    ];
    addToTexts(paralogs, "paralog");
    //addToTexts(orthologs, 'ortholog');
    function addToTexts(count, type) {
        let text, countText;
        if (count) {
            countText = count === homologs ? "all" : count;
            text = countText + " " + type;
            if (count > 1) text += "s";
            texts.push(text);
        }
    }
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("text", {
        x: "36",
        dy: ".35em",
        children: texts.join(", ")
    });
}
function $68b624418d7ff7df$var$style(node) {
    let color = $9250a846d2fdf47e$export$2e2bcd8739ae039(node);
    return {
        fill: color,
        stroke: color
    };
}
function $68b624418d7ff7df$var$triangle(node) {
    let d = "M0,0 30,8 30,-8 0,0";
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("path", {
        d: d,
        style: $68b624418d7ff7df$var$style(node)
    });
}
$68b624418d7ff7df$var$Collapsed.propTypes = {
    node: $parcel$interopDefault($1i38n$proptypes).object.isRequired,
    onHover: $parcel$interopDefault($1i38n$proptypes).func.isRequired
};
var $68b624418d7ff7df$export$2e2bcd8739ae039 = $68b624418d7ff7df$var$Collapsed;
const $7b72a1e0c4f8653d$var$Gene = (props)=>{
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
        className: $7b72a1e0c4f8653d$var$className(props.node),
        children: [
            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("circle", {
                r: "3"
            }),
            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("text", {
                x: "10",
                dy: ".35em",
                children: $7b72a1e0c4f8653d$var$text(props).join("; ")
            })
        ]
    });
};
function $7b72a1e0c4f8653d$var$className(node) {
    let className, homology, repType;
    className = "gene";
    homology = $parcel$interopDefault($1i38n$lodash).get(node, "relationToGeneOfInterest.homology");
    repType = $parcel$interopDefault($1i38n$lodash).get(node, "relationToGeneOfInterest.repType");
    if (homology) className += " homolog " + homology;
    if (repType) className += " representative";
    return className;
}
function $7b72a1e0c4f8653d$var$text(props) {
    return props.labelFields.map((field)=>{
        return $parcel$interopDefault($1i38n$lodash).get(props.node, field);
    }); //'model.gene_stable_id');
}
$7b72a1e0c4f8653d$var$Gene.propTypes = {
    node: $parcel$interopDefault($1i38n$proptypes).object.isRequired,
    labelFields: $parcel$interopDefault($1i38n$proptypes).array.isRequired,
    onHover: $parcel$interopDefault($1i38n$proptypes).func.isRequired,
    taxonomy: $parcel$interopDefault($1i38n$proptypes).object.isRequired
};
var $7b72a1e0c4f8653d$export$2e2bcd8739ae039 = $7b72a1e0c4f8653d$var$Gene;
const $e66d18a0c723ce01$var$Node = (props)=>{
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
        className: "node",
        children: [
            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("rect", {
                className: "interaction-helper",
                x: "-5",
                y: "-5",
                width: "10",
                height: "10"
            }),
            $parcel$interopDefault($1i38n$react).createElement($e66d18a0c723ce01$var$getNodeComponent(props.node), props)
        ]
    });
};
function $e66d18a0c723ce01$var$getNodeType(node) {
    if (node.model.gene_stable_id) return $7b72a1e0c4f8653d$export$2e2bcd8739ae039;
    else if (!node.displayInfo.expanded) return $68b624418d7ff7df$export$2e2bcd8739ae039;
    else return $107ec56bdeb4af7c$export$2e2bcd8739ae039;
}
function $e66d18a0c723ce01$var$getNodeComponent(node) {
    return $e66d18a0c723ce01$var$getNodeType(node);
}
$e66d18a0c723ce01$var$Node.propTypes = {
    node: $parcel$interopDefault($1i38n$proptypes).object.isRequired,
    labelFields: $parcel$interopDefault($1i38n$proptypes).array.isRequired,
    taxonomy: $parcel$interopDefault($1i38n$proptypes).object.isRequired
};
var $e66d18a0c723ce01$export$2e2bcd8739ae039 = $e66d18a0c723ce01$var$Node;
class $27a8bd4ebb68f267$export$2e2bcd8739ae039 extends $parcel$interopDefault($1i38n$react).Component {
    constructor(props){
        super(props);
        this.cladeRef = $parcel$interopDefault($1i38n$react).createRef();
        this.state = {
            popoverVisible: false
        };
    }
    componentDidMount() {
        this.setState({
            mounted: true
        });
    }
    hover(e) {
        e.stopPropagation();
        this.props.onNodeHover(this.props.node);
        this.setState({
            hovered: true
        });
    }
    unhover(e) {
        e.stopPropagation();
        this.props.onNodeUnhover(this.props.node);
        this.setState({
            hovered: false
        });
    }
    togglePopoverVisibility() {
        this.setState({
            popoverVisible: !this.state.popoverVisible
        });
    }
    collapseClade(node, recurse) {
        this.setState({
            popoverVisible: false
        });
        this.props.collapseClade(node, recurse);
    }
    expandClade(node, recurse) {
        this.setState({
            popoverVisible: false
        });
        this.props.expandClade(node, recurse);
    }
    changeParalogVisibility(node) {
        this.setState({
            popoverVisible: false
        });
        this.props.changeParalogVisibility(node);
    }
    changeGeneOfInterest(node) {
        this.setState({
            popoverVisible: false
        });
        this.props.onGeneSelect(node);
    }
    transform(isStyle) {
        let px = isStyle ? "px" : "";
        let x, y;
        if (this.state.mounted) {
            x = this.props.node.x - this.props.xOffset;
            y = this.props.node.y - this.props.yOffset;
        } else {
            x = this.props.xOffset;
            y = this.props.yOffset;
        }
        return "translate(" + y + px + ", " + x + px + ")";
    }
    renderSubClades() {
        let node = this.props.node;
        let treeProps = $parcel$interopDefault($1i38n$lodash).clone(this.props);
        let children = node.children;
        let cladeHovered = !!(this.props.cladeHovered || this.state.hovered);
        if ($parcel$interopDefault($1i38n$lodash).isArray(children) && node.displayInfo.expanded) return children.map(function(childNode, idx) {
            treeProps.node = childNode;
            return /*#__PURE__*/ (0, $1i38n$react.createElement)($27a8bd4ebb68f267$export$2e2bcd8739ae039, {
                ...treeProps,
                key: idx,
                cladeHovered: cladeHovered,
                xOffset: node.x,
                yOffset: node.y
            });
        });
    }
    renderNode() {
        let node = this.props.node;
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($e66d18a0c723ce01$export$2e2bcd8739ae039, {
            node: node,
            labelFields: this.props.labelFields,
            onHover: ()=>this.hover(),
            taxonomy: this.props.taxonomy
        });
    }
    renderEdge() {
        let node = this.props.node;
        let parent = node.parent;
        let cladeHovered = !!(this.props.cladeHovered || this.state.hovered);
        if (parent) return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($144e30bd197fcd40$export$2e2bcd8739ae039, {
            source: node,
            target: parent,
            cladeHovered: cladeHovered,
            thisCladeHovered: !!this.state.hovered
        });
    }
    overlay(node, geneDocs) {
        const model = node.model;
        const titleText = model.node_type ? `${model.taxon_name} \u{2013} ${model.node_type}` : model.gene_display_label ? `${model.taxon_name} \u{2013} ${model.gene_display_label}` : `${model.taxon_name} - ${model.gene_stable_id}`;
        const id = `nodepopover${model.node_id}`;
        const title = /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($1i38n$reactbootstrap.Button, {
                    className: "tooltip-title-button",
                    size: "sm",
                    variant: "light",
                    onClick: this.togglePopoverVisibility.bind(this),
                    children: "\xd7"
                }),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("span", {
                    children: titleText
                })
            ]
        });
        return(//          target={this.cladeRef.current}>
        /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)($1i38n$reactbootstrap.Popover, {
            id: id,
            children: [
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($1i38n$reactbootstrap.Popover.Header, {
                    children: title
                }),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($1i38n$reactbootstrap.Popover.Body, {
                    children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($1acbe0e0655373a5$export$2e2bcd8739ae039, {
                        node: node,
                        collapseClade: this.collapseClade.bind(this),
                        expandClade: this.expandClade.bind(this),
                        changeParalogVisibility: this.changeParalogVisibility.bind(this),
                        changeGeneOfInterest: this.changeGeneOfInterest.bind(this),
                        geneDocs: geneDocs
                    })
                })
            ]
        }));
    }
    cladeProps() {
        const props = {
            className: "clade"
        };
        if ($62e50bff44daad79$export$2e2bcd8739ae039) props.transform = this.transform(false);
        else props.style = {
            transform: this.transform(true)
        };
        return props;
    }
    render() {
        const popover = this.overlay(this.props.node, this.props.geneDocs);
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
            ...this.cladeProps(),
            children: [
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($1i38n$reactbootstrap.OverlayTrigger, {
                    trigger: "click",
                    placement: "right",
                    overlay: popover,
                    transition: false,
                    show: this.state.popoverVisible,
                    onToggle: this.togglePopoverVisibility.bind(this),
                    children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
                        children: [
                            this.renderEdge(),
                            this.renderNode()
                        ]
                    })
                }),
                this.renderSubClades()
            ]
        });
    }
}
$27a8bd4ebb68f267$export$2e2bcd8739ae039.propTypes = {
    node: $parcel$interopDefault($1i38n$proptypes).object.isRequired,
    labelFields: $parcel$interopDefault($1i38n$proptypes).array.isRequired,
    cladeHovered: $parcel$interopDefault($1i38n$proptypes).bool,
    xOffset: $parcel$interopDefault($1i38n$proptypes).number.isRequired,
    yOffset: $parcel$interopDefault($1i38n$proptypes).number.isRequired,
    geneDocs: $parcel$interopDefault($1i38n$proptypes).object.isRequired
};
const $42eda629c119b935$var$GeneTree = (props)=>{
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("g", {
        className: "genetree",
        children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($27a8bd4ebb68f267$export$2e2bcd8739ae039, {
            ...props,
            node: props.nodes[0],
            xOffset: 0,
            yOffset: 0
        })
    });
};
$42eda629c119b935$var$GeneTree.propTypes = {
    nodes: $parcel$interopDefault($1i38n$proptypes).array.isRequired,
    labelFields: $parcel$interopDefault($1i38n$proptypes).array.isRequired,
    onGeneSelect: $parcel$interopDefault($1i38n$proptypes).func.isRequired,
    onNodeHover: $parcel$interopDefault($1i38n$proptypes).func.isRequired,
    taxonomy: $parcel$interopDefault($1i38n$proptypes).object
};
var $42eda629c119b935$export$2e2bcd8739ae039 = $42eda629c119b935$var$GeneTree;
var $2a90f6e2b76b788a$exports = {};
var $2a90f6e2b76b788a$var$alignments = {};
function $2a90f6e2b76b788a$var$calculateAlignmentFromConsensus(node) {
    var nodeId = node.model.node_id;
    if ($2a90f6e2b76b788a$var$alignments[nodeId]) return $2a90f6e2b76b788a$var$alignments[nodeId];
    // these blocks are likely to be smaller and more numerous
    let consensus = node.model.consensus;
    let deltaDepth = {};
    // find first non-zero frequency
    let i = 0;
    while(consensus.frequency[i] === 0)i++;
    deltaDepth[i] = consensus.frequency[i];
    let blocks = [];
    let block = {
        start: i,
        end: consensus.consensusLength
    };
    for(let j = i + 1; j < consensus.consensusLength; j++)if (consensus.frequency[j] !== consensus.frequency[i]) {
        deltaDepth[j] = consensus.frequency[j] - consensus.frequency[i];
        if (consensus.frequency[i] === 0) block.start = j;
        if (consensus.frequency[j] === 0) {
            block.end = j;
            blocks.push($1i38n$lodash.cloneDeep(block));
        }
        i = j;
    }
    if (consensus.frequency[i]) {
        deltaDepth[consensus.consensusLength] = 0 - consensus.frequency[i];
        block.end = consensus.consensusLength;
        blocks.push($1i38n$lodash.cloneDeep(block));
    }
    $2a90f6e2b76b788a$var$alignments[nodeId] = {
        hist: deltaDepth,
        blocks: blocks,
        size: consensus.consensusLength,
        nSeqs: consensus.nSeqs
    };
    return $2a90f6e2b76b788a$var$alignments[nodeId];
}
function $2a90f6e2b76b788a$var$getOffsets(positions) {
    return Object.keys(positions).map(function(i) {
        return +i;
    }).sort(function(a, b) {
        return a - b;
    });
}
function $2a90f6e2b76b788a$var$findGaps(alignment) {
    var positions = alignment.hist;
    var offsets = $2a90f6e2b76b788a$var$getOffsets(positions);
    var depth = 0;
    var gaps = [];
    var prevEnd = 0;
    for(var i = 0; i < offsets.length; i++){
        if (depth === 0 && prevEnd < offsets[i]) gaps.push({
            start: prevEnd,
            end: offsets[i]
        });
        depth += positions[offsets[i]];
        prevEnd = offsets[i];
    }
    if (prevEnd < alignment.size) gaps.push({
        start: prevEnd,
        end: alignment.size
    });
    return gaps;
}
function $2a90f6e2b76b788a$var$removeGapsFromAlignment(gaps, positions) {
    var collapsedSoFar = 0;
    var offsets = $2a90f6e2b76b788a$var$getOffsets(positions);
    var newPositions = {};
    var g = 0;
    offsets.forEach(function(offset) {
        while(g < gaps.length && offset > gaps[g].start){
            collapsedSoFar += gaps[g].end - gaps[g].start;
            g++;
        }
        var newOffset = offset - collapsedSoFar;
        if (newPositions[newOffset]) {
            newPositions[newOffset] += positions[offset];
            if (newPositions[newOffset] === 0) delete newPositions[newOffset];
        } else newPositions[newOffset] = positions[offset];
    });
    return newPositions;
}
function $2a90f6e2b76b788a$var$rebuildBlocksFromAlignment(positions) {
    var offsets = $2a90f6e2b76b788a$var$getOffsets(positions);
    var blocks = [];
    var depth = 0;
    for(var i = 0; i < offsets.length - 1; i++){
        depth += positions[offsets[i]];
        if (depth > 0) blocks.push({
            start: offsets[i],
            end: offsets[i + 1]
        });
    }
    return blocks;
}
function $2a90f6e2b76b788a$var$removeGaps(gaps, tree) {
    var size = $2a90f6e2b76b788a$var$alignments[tree.model.node_id].size;
    gaps.forEach(function(g) {
        size -= g.end - g.start;
    });
    tree.walk(function(node) {
        var nodeId = node.model.node_id;
        $2a90f6e2b76b788a$var$alignments[nodeId].size = size;
        $2a90f6e2b76b788a$var$alignments[nodeId].hist = $2a90f6e2b76b788a$var$removeGapsFromAlignment(gaps, $2a90f6e2b76b788a$var$alignments[nodeId].hist);
        if (!node.hasChildren()) $2a90f6e2b76b788a$var$alignments[nodeId].blocks = $2a90f6e2b76b788a$var$rebuildBlocksFromAlignment($2a90f6e2b76b788a$var$alignments[nodeId].hist);
    });
}
function $2a90f6e2b76b788a$var$mergeAdjacent(domainList) {
    let merged = [];
    let last = domainList.shift();
    domainList.forEach(function(d) {
        if (last.id === d.id && last.end === d.start) last.end = d.end;
        else {
            merged.push(last);
            last = d;
        }
    });
    merged.push(last);
    return merged;
}
function $2a90f6e2b76b788a$var$resolveOverlaps(dl) {
    if (dl.length < 2) return dl;
    let domainList = $1i38n$lodash.cloneDeep(dl);
    domainList.sort(function(a, b) {
        return a.start - b.start;
    });
    let trimmed = [];
    let last = $1i38n$lodash.clone(domainList[0]);
    let i = 1;
    while(i < domainList.length){
        var d = domainList[i];
        if (d.start >= last.end) {
            trimmed.push(last);
            last = d;
            i++;
        } else {
            // trim last up to d.start
            if (last.start < d.start) {
                let l = $1i38n$lodash.clone(last);
                l.end = d.start;
                trimmed.push(l);
                last.start = d.start;
            }
            if (d.nSeqs > last.nSeqs) {
                if (d.end >= last.end) {
                    last = d;
                    i++;
                } else {
                    // d ends inside of last but d is better
                    // need to trim last and insert it into domainList
                    // where it goes to preserve sorted order
                    let l = $1i38n$lodash.clone(last);
                    l.start = d.end;
                    last = $1i38n$lodash.clone(d);
                    let j = i + 1;
                    while(j < domainList.length && domainList[j].start < l.start){
                        domainList[j - 1] = domainList[j];
                        j++;
                    }
                    domainList[j - 1] = l;
                }
            } else if (last.end >= d.end) i++;
            else {
                let l = $1i38n$lodash.clone(d);
                l.start = last.end;
                let j = i + 1;
                while(j < domainList.length && domainList[j].start < l.start){
                    domainList[j - 1] = domainList[j];
                    j++;
                }
                domainList[j - 1] = l;
            }
        }
    }
    trimmed.push(last);
    return $2a90f6e2b76b788a$var$mergeAdjacent(trimmed);
}
$2a90f6e2b76b788a$exports = {
    calculateAlignment: $2a90f6e2b76b788a$var$calculateAlignmentFromConsensus,
    findGaps: $2a90f6e2b76b788a$var$findGaps,
    removeGaps: $2a90f6e2b76b788a$var$removeGaps,
    getOffsets: $2a90f6e2b76b788a$var$getOffsets,
    resolveOverlaps: $2a90f6e2b76b788a$var$resolveOverlaps,
    clean: function() {
        $2a90f6e2b76b788a$var$alignments = {};
    }
};
class $94496b6b5723afdf$var$Alignment extends $1i38n$react.Component {
    // props: {
    //   id: React.PropTypes.number.isRequired,
    //   node: React.PropTypes.object.isRequired,
    //   width: React.PropTypes.number.isRequired,
    //   stats: React.PropTypes.object.isRequired,
    //   domains: React.PropTypes.object.idRequired,
    //   highlight: React.PropTypes.string.isRequired,
    //   alignment: React.PropTypes.object.isRequred
    // }
    getColorMap(alignment, stats) {
        var regionColor = [];
        var grayScale = $1i38n$d3scale.scaleLinear().domain([
            0,
            alignment.nSeqs
        ]).range([
            "#DDDDDD",
            "#444444"
        ]);
        var prevEnd = 0;
        if (this.props.domains.length > 0) $2a90f6e2b76b788a$exports.resolveOverlaps(this.props.domains).forEach(function(d) {
            if (d.start > prevEnd) regionColor.push({
                start: prevEnd,
                end: d.start,
                color: grayScale
            });
            d.start;
            if (d.end > prevEnd) {
                prevEnd = d.end;
                var maxColor = stats[d.id].color;
                var colorScale = $1i38n$d3scale.scaleLinear().domain([
                    0,
                    1
                ]).range([
                    "#FFFFFF",
                    maxColor
                ]);
                regionColor.push({
                    start: d.start,
                    end: d.end,
                    color: $1i38n$d3scale.scaleLinear().domain([
                        0,
                        alignment.nSeqs
                    ]).range([
                        colorScale(0.5),
                        maxColor
                    ])
                });
            }
        });
        if (prevEnd < alignment.size) regionColor.push({
            start: prevEnd,
            end: alignment.size,
            color: grayScale
        });
        return regionColor;
    }
    renderHighlight() {
        if (this.props.highlight) {
            var hlStyle = {
                fill: this.props.highlight,
                stroke: false
            };
            var u = this.props.alignment.size / this.props.width;
            var w = 4 * u;
            var s = -w - u;
            return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("rect", {
                x: s,
                width: w,
                height: "18",
                style: hlStyle
            }, "highlight");
        }
    }
    render() {
        var alignment = $1i38n$lodash.cloneDeep(this.props.alignment);
        var regionColor = this.getColorMap(alignment, this.props.stats);
        var k = 0;
        var bins = [];
        var offsets = $2a90f6e2b76b788a$exports.getOffsets(alignment.hist);
        var depth = 0;
        var regionIdx = 0;
        var renderBlock = function(block) {
            var style = {
                fill: block.color,
                stroke: false
            };
            var s = block.start;
            var w = block.end - block.start;
            k++;
            var rect = /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("rect", {
                width: w,
                height: "14",
                x: s,
                style: style
            }, k);
            return rect;
        };
        for(var i = 0; i < offsets.length - 1; i++){
            depth += alignment.hist[offsets[i]];
            if (depth > 0) {
                // find the region containing the start of this alignment block
                while(offsets[i] >= regionColor[regionIdx].end)regionIdx++;
                var color = regionColor[regionIdx].color(depth);
                // does the alignment block extend beyond the end of the region?
                if (offsets[i + 1] > regionColor[regionIdx].end) {
                    bins.push(renderBlock({
                        start: offsets[i],
                        end: regionColor[regionIdx].end,
                        color: color
                    }));
                    offsets[i] = regionColor[regionIdx].end;
                    if (!alignment.hist.hasOwnProperty(offsets[i])) alignment.hist[offsets[i]] = 0;
                    i--;
                } else bins.push(renderBlock({
                    start: offsets[i],
                    end: offsets[i + 1],
                    color: color
                }));
            }
        }
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
            className: "alignment",
            children: [
                this.renderHighlight(),
                bins
            ]
        });
    }
}
var $94496b6b5723afdf$export$2e2bcd8739ae039 = $94496b6b5723afdf$var$Alignment;
class $7e36c170ebf80241$export$2e2bcd8739ae039 extends $1i38n$react.Component {
    // props: {
    //   id: React.PropTypes.number.isRequired,
    //   node: React.PropTypes.object.isRequired,
    //   width: React.PropTypes.number.isRequired,
    //   stats: React.PropTypes.object.isRequired,
    //   highlight: React.PropTypes.string.isRequired,
    //   domains: React.PropTypes.object.isRequired,
    //   alignment: React.PropTypes.object.isRequired
    // }
    constructor(props){
        super(props);
        this.state = {};
    }
    transform(isStyle) {
        var x, y, px;
        px = isStyle ? "px" : "";
        x = 0;
        y = this.props.node.x; // - 7;
        return "translate(" + x + px + ", " + y + px + ")";
    }
    render() {
        var props = {};
        if ($62e50bff44daad79$exports) props.transform = this.transform(false);
        else props.style = {
            transform: this.transform(true)
        };
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("g", {
            ...props,
            children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($94496b6b5723afdf$export$2e2bcd8739ae039, {
                width: this.props.width,
                node: this.props.node,
                highlight: this.props.highlight,
                stats: this.props.stats,
                domains: this.props.domains,
                alignment: this.props.alignment
            })
        });
    }
}
let $aed637ffd5f869a8$var$colors = $1i38n$d3scale.scaleOrdinal($1i38n$d3scale.schemeCategory10).range();
function $aed637ffd5f869a8$export$2e2bcd8739ae039(genetree) {
    const speciesNodes = genetree.leafNodes();
    const numGenes = speciesNodes.length;
    let colorIdx = 0;
    return speciesNodes.reduce((map, node)=>{
        const domains = $parcel$interopDefault($1i38n$lodash).get(node, "model.domains");
        const geneId = $parcel$interopDefault($1i38n$lodash).get(node, "model.gene_stable_id");
        if ($parcel$interopDefault($1i38n$lodash).isArray(domains)) $parcel$interopDefault($1i38n$lodash).forEach(domains, (domain)=>{
            const id = domain.id;
            let mapValue = map[id];
            if (!mapValue) map[id] = mapValue = {
                totalGenes: numGenes,
                genesWithDomain: 0,
                nodes: {},
                color: $aed637ffd5f869a8$var$colors[colorIdx++ % $aed637ffd5f869a8$var$colors.length]
            };
            if (!mapValue.nodes[geneId]) {
                mapValue.nodes[geneId] = node;
                mapValue.genesWithDomain++;
            }
        });
        return map;
    }, {});
}
class $eaf596603b94813f$var$Domains extends $1i38n$react.Component {
    constructor(props){
        super(props);
        this.cladeStats = $aed637ffd5f869a8$export$2e2bcd8739ae039(this.props.node);
    }
    // props: {
    //   id: React.PropTypes.number.isRequired,
    //   node: React.PropTypes.object.isRequired,
    //   width: React.PropTypes.number.isRequired,
    //   stats: React.PropTypes.object.isRequired,
    //   domains: React.PropTypes.object.isRequired,
    //   alignment: React.PropTypes.object.isRequired
    // }
    // componentDidUpdate() {
    //   if (this.props.node.hasChildren()) {
    //     this.cladeStats = domainStats(this.props.node);
    //   }
    // }
    render() {
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("g", {
            className: "domains",
            children: this.renderDomains()
        });
    }
    renderDomains() {
        let nonOverlappingDomains = (0, $2a90f6e2b76b788a$exports.resolveOverlaps)(this.props.domains);
        return nonOverlappingDomains.map((function(domain, idx) {
            var w = domain.end - domain.start + 1;
            var stats = this.props.stats[domain.id];
            var color = stats.color;
            var opacity = 0.1;
            var style = {
                fill: color,
                stroke: color,
                fillOpacity: opacity
            };
            return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($1i38n$reactbootstrap.OverlayTrigger, {
                trigger: [
                    "click",
                    "focus"
                ],
                rootClose: true,
                placement: "bottom",
                overlay: this.renderPopover(domain),
                children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("rect", {
                    width: w,
                    height: "18",
                    x: domain.start,
                    style: style
                })
            }, idx);
        }).bind(this));
    }
    renderPopover(domain) {
        var title = `${domain.id} - ${domain.name}`;
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)($1i38n$reactbootstrap.Popover, {
            id: domain.name,
            children: [
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($1i38n$reactbootstrap.Popover.Header, {
                    children: title
                }),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($1i38n$reactbootstrap.Popover.Body, {
                    children: this.renderPopoverContent(domain)
                })
            ]
        });
    }
    renderPopoverContent(domain) {
        if (this.props.node.isRoot()) return this.renderRootNodePopoverContent(domain);
        if (this.props.node.hasChildren()) return this.renderInternalNodePopoverContent(domain);
        else return this.renderGeneNodePopoverContent(domain);
    }
    renderRootNodePopoverContent(domain) {
        var stats = this.props.stats[domain.id];
        var treeStatement = $eaf596603b94813f$var$createStatement(stats, "genetree");
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("p", {
                    className: "description",
                    children: domain.description
                }),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("p", {
                    className: "stats",
                    children: treeStatement
                })
            ]
        });
    }
    renderInternalNodePopoverContent(domain) {
        var stats = this.props.stats[domain.id];
        var cladeStats = this.cladeStats[domain.id];
        var treeStatement = $eaf596603b94813f$var$createStatement(stats, "genetree");
        var cladeStatement = $eaf596603b94813f$var$createStatement(cladeStats, "clade");
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("p", {
                    className: "description",
                    children: domain.description
                }),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("p", {
                    className: "stats",
                    children: treeStatement
                }),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("p", {
                    className: "stats",
                    children: cladeStatement
                })
            ]
        });
    }
    renderGeneNodePopoverContent(domain) {
        var stats = this.props.stats[domain.id];
        var statement = $eaf596603b94813f$var$createStatement(stats, "genetree");
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("p", {
                    className: "description",
                    children: domain.description
                }),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("p", {
                    className: "stats",
                    children: statement
                })
            ]
        });
    }
}
function $eaf596603b94813f$var$createStatement(stats, whatIsThis) {
    var geneCount = stats.genesWithDomain;
    var totalGenes = stats.totalGenes;
    var proportion = $parcel$interopDefault($1i38n$numeral)(geneCount / totalGenes).format("0.0%");
    var statement;
    if (geneCount === totalGenes) statement = `Shared by all ${totalGenes} genes in this ${whatIsThis}.`;
    else if (geneCount === 1) statement = `There is only one gene in the ${whatIsThis} with this domain.`;
    else statement = `Shared by ${geneCount} of ${totalGenes} (${proportion}) genes in this ${whatIsThis}.`;
    return statement;
}
var $eaf596603b94813f$export$2e2bcd8739ae039 = $eaf596603b94813f$var$Domains;
class $5e8e312d635014fa$var$PositionedDomains extends $1i38n$react.Component {
    // props: {
    //   id: React.PropTypes.number.isRequired,
    //   node: React.PropTypes.object.isRequired,
    //   width: React.PropTypes.number.isRequired,
    //   stats: React.PropTypes.object.isRequired,
    //   domains: React.PropTypes.object.isRequired,
    //   alignment: React.PropTypes.object.isRequired
    // }
    constructor(props){
        super(props);
        this.state = {};
    }
    transform(isStyle) {
        var x, y, px;
        px = isStyle ? "px" : "";
        x = 0;
        y = this.props.node.x - 2;
        return "translate(" + x + px + ", " + y + px + ")";
    }
    render() {
        var props = {};
        if ($62e50bff44daad79$exports) props.transform = this.transform(false);
        else props.style = {
            transform: this.transform(true)
        };
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("g", {
            ...props,
            children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($eaf596603b94813f$export$2e2bcd8739ae039, {
                stats: this.props.stats,
                width: this.props.width,
                node: this.props.node,
                domains: this.props.domains
            })
        });
    }
}
var $5e8e312d635014fa$export$2e2bcd8739ae039 = $5e8e312d635014fa$var$PositionedDomains;
function $e4b494008561eb2b$var$remap(seqPos, blocks) {
    var posInSeq = 0;
    for(var b = 0; b < blocks.length; b++){
        var block = blocks[b];
        var blockLength = block.end - block.start + 1;
        if (seqPos <= posInSeq + blockLength) return block.start + (seqPos - posInSeq);
        posInSeq += blockLength;
    }
    return 0;
}
class $e4b494008561eb2b$export$2e2bcd8739ae039 extends $1i38n$react.Component {
    // props: {
    //   id: React.PropTypes.number.isRequired,
    //   node: React.PropTypes.object.isRequired,
    //   width: React.PropTypes.number.isRequired,
    //   alignment: React.PropTypes.object.isRequired
    // }
    render() {
        var node = this.props.node;
        var alignment = this.props.alignment;
        var k = 0;
        var bins = node.model.exon_junctions.map(function(ej) {
            var ejPos = $e4b494008561eb2b$var$remap(ej, alignment.blocks);
            var top = ejPos - 1;
            var style = {
                fill: "red",
                stroke: false
            };
            k++;
            return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("rect", {
                width: "1",
                height: "18",
                x: top,
                style: style
            }, k);
        });
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("g", {
            className: "exonJunctions",
            children: bins
        });
    }
}
class $ce710bd567690513$export$2e2bcd8739ae039 extends $1i38n$react.Component {
    // props: {
    //   id: React.PropTypes.number.isRequired,
    //   node: React.PropTypes.object.isRequired,
    //   width: React.PropTypes.number.isRequired,
    //   alignment: React.PropTypes.object.isRequired
    // }
    //
    constructor(props){
        super(props);
        this.state = {};
    }
    transform(isStyle) {
        var x, y, px;
        px = isStyle ? "px" : "";
        x = 0;
        y = this.props.node.x - 2;
        return "translate(" + x + px + ", " + y + px + ")";
    }
    render() {
        var props = {};
        if ($62e50bff44daad79$exports) props.transform = this.transform(false);
        else props.style = {
            transform: this.transform(true)
        };
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("g", {
            ...props,
            children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($e4b494008561eb2b$export$2e2bcd8739ae039, {
                width: this.props.width,
                node: this.props.node,
                alignment: this.props.alignment
            })
        });
    }
}
var $5ac4cd4b588bde41$var$domains = {};
function $5ac4cd4b588bde41$var$remap(seqPos, blocks) {
    var posInSeq = 0;
    for(var b = 0; b < blocks.length; b++){
        var block = blocks[b];
        var blockLength = block.end - block.start;
        if (seqPos <= posInSeq + blockLength) return block.start + (seqPos - posInSeq);
        posInSeq += blockLength;
    }
    return 0;
}
function $5ac4cd4b588bde41$var$mergeDomains(domainList) {
    // merge domains with the same id first
    // then merge with other domains
    var domainHist = {}; // key is domain id
    domainList.forEach(function(d) {
        if (!domainHist.hasOwnProperty(d.id)) {
            domainHist[d.id] = $1i38n$lodash.clone(d); // representative
            domainHist[d.id].hist = {};
        }
        var hist = domainHist[d.id].hist;
        if (hist[d.start]) hist[d.start] += d.nSeqs;
        else hist[d.start] = d.nSeqs;
        if (hist[d.end]) hist[d.end] -= d.nSeqs;
        else hist[d.end] = -d.nSeqs;
    });
    var merged = [];
    $1i38n$lodash.each(domainHist, function(domain) {
        var offsets = (0, $2a90f6e2b76b788a$exports.getOffsets)(domain.hist);
        var depth = 0;
        for(var i = 0; i < offsets.length - 1; i++){
            depth += domain.hist[offsets[i]];
            if (depth > 0) {
                var d = $1i38n$lodash.clone(domain);
                d.start = offsets[i];
                d.end = offsets[i + 1];
                d.nSeqs = depth;
                delete d.hist;
                merged.push(d);
            }
        }
    });
    return merged;
}
function $5ac4cd4b588bde41$export$2e2bcd8739ae039(node, reset) {
    if (reset) $5ac4cd4b588bde41$var$domains = {};
    var nodeId = node.model.node_id;
    if ($5ac4cd4b588bde41$var$domains[nodeId]) return $5ac4cd4b588bde41$var$domains[nodeId];
    if (node.model.cigar) {
        var alignment = (0, $2a90f6e2b76b788a$exports.calculateAlignment)(node);
        if (node.model.domains) {
            // map start and end positions in domains to positions in cigar space
            var domainsList = node.model.domains.map(function(d) {
                return {
                    start: $5ac4cd4b588bde41$var$remap(d.start - 1, alignment.blocks),
                    end: $5ac4cd4b588bde41$var$remap(d.end, alignment.blocks),
                    root: d.root,
                    id: d.id,
                    name: d.name,
                    description: d.description,
                    nSeqs: 1
                };
            });
            $5ac4cd4b588bde41$var$domains[nodeId] = domainsList;
        } else $5ac4cd4b588bde41$var$domains[nodeId] = [];
    } else if (node.children.length === 1) $5ac4cd4b588bde41$var$domains[nodeId] = $5ac4cd4b588bde41$export$2e2bcd8739ae039(node.children[0]);
    else {
        var domainList = [];
        node.children.forEach(function(childNode) {
            var childDomains = $5ac4cd4b588bde41$export$2e2bcd8739ae039(childNode);
            childDomains.forEach(function(cd) {
                domainList.push(cd);
            });
        });
        // if we have domains, merge them
        if (domainList.length > 1) domainList = $5ac4cd4b588bde41$var$mergeDomains(domainList);
        $5ac4cd4b588bde41$var$domains[nodeId] = domainList;
    }
    return $5ac4cd4b588bde41$var$domains[nodeId];
}
class $2dbe1a8664116125$export$2e2bcd8739ae039 extends $parcel$interopDefault($1i38n$react).Component {
    constructor(props){
        super(props);
        this.state = {};
        this.zoomerRef = $parcel$interopDefault($1i38n$react).createRef();
        this.svgRef = $parcel$interopDefault($1i38n$react).createRef();
        this.consensusLength = props.rootNode.model.consensus.sequence.length;
        this.charWidth = 7.2065;
        this.minWidth = props.width * props.width / (this.charWidth * this.consensusLength);
        this.MSARange = props.MSARange;
    }
    componentDidMount() {
        let zoomer = this.zoomerRef.current;
        if (zoomer) {
            let x = this.props.width * this.MSARange.MSAStart / this.consensusLength;
            let y = parseFloat(zoomer.getAttribute("data-y")) || 0;
            zoomer.style.webkitTransform = zoomer.style.transform = `translate(${x}px,${y}px)`;
            zoomer.style.width = this.props.width * (this.MSARange.MSAStop - this.MSARange.MSAStart) / this.consensusLength + "px";
            $parcel$interopDefault($1i38n$interactjs)(zoomer).draggable({
                onmove: this.dragMoveListener.bind(this)
            }).resizable({
                preserveAspectRatio: false,
                edges: {
                    left: true,
                    right: true,
                    bottom: false,
                    top: false
                }
            }).on("resizemove", (function(event) {
                if (event.rect.width > this.minWidth) {
                    let target = event.target;
                    let x = this.props.width * this.MSARange.MSAStart / this.consensusLength;
                    let y = parseFloat(target.getAttribute("data-y")) || 0;
                    if (event.deltaRect.left !== 0) {
                        // move left edge
                        x += event.deltaRect.left;
                        if (x < 0) x = 0;
                        this.MSARange.MSAStart = x * this.consensusLength / this.props.width;
                    }
                    if (event.deltaRect.right !== 0) {
                        // move right edge
                        let right = x + event.rect.width;
                        if (right > this.props.width) right = this.props.width;
                        this.MSARange.MSAStop = right * this.consensusLength / this.props.width;
                    }
                    let viewWidth = this.MSARange.MSAStop - this.MSARange.MSAStart;
                    target.style.width = this.props.width * viewWidth / this.consensusLength + "px";
                    target.style.webkitTransform = target.style.transform = `translate(${x}px,${y}px)`;
                    target.setAttribute("data-x", x);
                    // let vb = `${this.MSARange.MSAStart} -3 ${viewWidth} ${this.props.height}`;
                    this.svgRef.current.setAttribute("viewBox", this.getViewBox(false));
                    this.props.handleRangeChange(this.MSARange);
                }
            }).bind(this));
        }
    }
    componentDidUpdate() {
        let zoomer = this.zoomerRef.current;
        let x = this.props.width * this.MSARange.MSAStart / this.consensusLength;
        let y = parseFloat(zoomer.getAttribute("data-y")) || 0;
        zoomer.style.webkitTransform = zoomer.style.transform = `translate(${x}px,${y}px)`;
        zoomer.style.width = this.props.width * (this.MSARange.MSAStop - this.MSARange.MSAStart) / this.consensusLength + "px";
    }
    dragMoveListener(event) {
        if (this.MSARange.MSAStop - this.MSARange.MSAStart < 0.98 * this.consensusLength) {
            let target = event.target, x = this.props.width * this.MSARange.MSAStart / this.consensusLength + event.dx, y = parseFloat(target.getAttribute("data-y")) || 0;
            // respect boundaries
            if (x < 0) x = 0;
            let zoomerWidth = parseFloat(target.style.width);
            if (x + zoomerWidth > this.props.width) x = this.props.width - zoomerWidth;
            let xPosInSeq = this.consensusLength * x / this.props.width;
            let viewWidth = this.MSARange.MSAStop - this.MSARange.MSAStart;
            // if (xPosInSeq + viewWidth > this.consensusLength) {
            //   viewWidth = this.consensusLength - xPosInSeq;
            // }
            // translate the element
            target.style.webkitTransform = target.style.transform = "translate(" + x + "px, " + y + "px)";
            // update the position attribute
            target.setAttribute("data-x", x);
            // update the MSA position
            this.MSARange.MSAStart = xPosInSeq;
            this.MSARange.MSAStop = xPosInSeq + viewWidth;
            // let vb = `${xPosInSeq} -3 ${viewWidth} ${this.props.height}`;
            this.svgRef.current.setAttribute("viewBox", this.getViewBox(false));
            this.props.handleRangeChange(this.MSARange);
        }
    }
    getViewBox(forConsensus) {
        let viewBoxMinX = forConsensus ? 0 : this.MSARange.MSAStart;
        let viewBoxMinY = -3;
        let viewBoxWidth = forConsensus ? this.consensusLength : this.MSARange.MSAStop - this.MSARange.MSAStart;
        let viewBoxHeight = forConsensus ? this.props.controlsHeight : this.props.height + 2 * this.props.margin + 3;
        return `${viewBoxMinX} ${viewBoxMinY} ${viewBoxWidth} ${viewBoxHeight}`;
    }
    renderNode(node) {
        if (node.model.gene_stable_id || !node.displayInfo.expanded) {
            let alignment = /*@__PURE__*/ $parcel$interopDefault($2a90f6e2b76b788a$exports).calculateAlignment(node);
            let pej;
            if (node.model.exon_junctions) pej = /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($ce710bd567690513$export$2e2bcd8739ae039, {
                node: node,
                width: this.props.width,
                alignment: alignment
            });
            let domains = $5ac4cd4b588bde41$export$2e2bcd8739ae039(node);
            return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
                children: [
                    pej,
                    /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($7e36c170ebf80241$export$2e2bcd8739ae039, {
                        node: node,
                        width: this.props.width,
                        stats: this.props.stats,
                        domains: domains,
                        highlight: false,
                        alignment: alignment
                    }),
                    /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($5e8e312d635014fa$export$2e2bcd8739ae039, {
                        node: node,
                        width: this.props.width,
                        stats: this.props.stats,
                        alignment: alignment,
                        domains: domains
                    })
                ]
            }, node.model.node_id);
        }
    }
    renderControls() {
        const tooltip = /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($1i38n$reactbootstrap.Tooltip, {
            id: "tooltip",
            children: "resize and drag"
        });
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("g", {
                    className: "consensus-wrapper",
                    transform: `translate(${this.props.xOffset},3)`,
                    children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("svg", {
                        width: this.props.width,
                        height: this.props.controlsHeight,
                        viewBox: this.getViewBox(true),
                        preserveAspectRatio: "none",
                        children: this.renderNode(this.props.rootNode)
                    })
                }),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("foreignObject", {
                    x: this.props.xOffset,
                    y: this.props.yOffset,
                    width: this.props.width,
                    height: this.props.controlsHeight + 6,
                    children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($1i38n$reactbootstrap.OverlayTrigger, {
                        placement: "left",
                        overlay: tooltip,
                        children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("div", {
                            className: "resize-container",
                            children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("div", {
                                ref: this.zoomerRef,
                                className: "resize-drag",
                                style: {
                                    height: this.props.controlsHeight + 6
                                }
                            })
                        })
                    })
                })
            ]
        });
    }
    renderOverview() {
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("g", {
            className: "alignments-wrapper",
            transform: `translate(${this.props.xOffset},${this.props.yOffset + this.props.controlsHeight + this.props.margin - 10})`,
            children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("svg", {
                ref: this.svgRef,
                width: this.props.width,
                height: this.props.height + 2 * this.props.margin,
                viewBox: this.getViewBox(false),
                preserveAspectRatio: "none",
                children: this.props.nodes.map(this.renderNode.bind(this))
            })
        });
    }
    render() {
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
            children: [
                this.renderOverview(),
                this.renderControls()
            ]
        });
    }
}
class $3a89ac38d37e6c49$export$2e2bcd8739ae039 extends $parcel$interopDefault($1i38n$react).Component {
    constructor(props){
        super(props);
        this.state = {};
        this.zoomerRef = $parcel$interopDefault($1i38n$react).createRef();
        this.consensusLength = this.props.rootNode.model.consensus.sequence.length;
        this.charWidth = 7.2065;
        this.charsAtOnce = props.width / this.charWidth;
        this.windowWidth = props.width * props.width / (this.charWidth * this.consensusLength);
        this.MSARange = props.MSARange;
    }
    // componentWillMount() {
    // }
    dragMoveListener(event) {
        let target = event.target, x = this.props.width * this.MSARange.MSAStart / this.consensusLength + event.dx, y = parseFloat(target.getAttribute("data-y")) || 0;
        // respect boundaries
        if (x < 0) x = 0;
        if (x > this.props.width - this.windowWidth) x = this.props.width - this.windowWidth;
        // translate the element
        target.style.webkitTransform = target.style.transform = "translate(" + x + "px, " + y + "px)";
        // update the position attribute
        target.setAttribute("data-x", x);
        // update the MSA position
        let Xmin = x * this.consensusLength / this.props.width;
        let rows = document.getElementsByClassName("MSAlignments-wrapper");
        rows[0].scrollLeft = Xmin * this.charWidth;
        this.MSARange.MSAStart = Xmin;
        this.MSARange.MSAStop = Xmin + this.charsAtOnce;
        this.props.handleRangeChange(this.MSARange);
    }
    componentDidMount() {
        let zoomer = this.zoomerRef.current;
        if (zoomer) {
            let x = this.props.width * this.MSARange.MSAStart / this.consensusLength;
            let y = parseFloat(zoomer.getAttribute("data-y")) || 0;
            zoomer.style.webkitTransform = zoomer.style.transform = `translate(${x}px,${y}px)`;
            zoomer.style.width = this.windowWidth + "px";
            let rows = document.getElementsByClassName("MSAlignments-wrapper");
            rows[0].scrollLeft = this.MSARange.MSAStart * this.charWidth;
            $parcel$interopDefault($1i38n$interactjs)(zoomer).draggable({
                onmove: this.dragMoveListener.bind(this)
            });
        }
    }
    componentDidUpdate() {
        let zoomer = this.zoomerRef.current;
        this.windowWidth = this.props.width * this.props.width / (this.charWidth * this.consensusLength);
        this.charsAtOnce = this.props.width / this.charWidth;
        let x = this.props.width * this.MSARange.MSAStart / this.consensusLength;
        let y = parseFloat(zoomer.getAttribute("data-y")) || 0;
        zoomer.style.webkitTransform = zoomer.style.transform = `translate(${x}px,${y}px)`;
        let rows = document.getElementsByClassName("MSAlignments-wrapper");
        rows[0].scrollLeft = this.MSARange.MSAStart * this.charWidth;
    }
    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.colorScheme !== this.props.colorScheme) {
            // change the className - don't render again CSS will do the work
            let rows = document.getElementsByClassName(this.props.colorScheme);
            while(rows.length > 0)rows[0].className = nextProps.colorScheme;
            return false;
        }
        return true;
    }
    getViewBox() {
        let viewBoxMinX = 0;
        let viewBoxMinY = -3;
        let viewBoxWidth = this.consensusLength;
        let viewBoxHeight = this.props.controlsHeight;
        return `${viewBoxMinX} ${viewBoxMinY} ${viewBoxWidth} ${viewBoxHeight}`;
    }
    renderNode(node) {
        let alignment = /*@__PURE__*/ $parcel$interopDefault($2a90f6e2b76b788a$exports).calculateAlignment(node);
        let domains = $5ac4cd4b588bde41$export$2e2bcd8739ae039(node);
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($7e36c170ebf80241$export$2e2bcd8739ae039, {
                    node: node,
                    width: this.props.width,
                    stats: this.props.stats,
                    domains: domains,
                    highlight: false,
                    alignment: alignment
                }),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($5e8e312d635014fa$export$2e2bcd8739ae039, {
                    node: node,
                    width: this.props.width,
                    stats: this.props.stats,
                    domains: domains,
                    alignment: alignment
                })
            ]
        }, node.model.node_id);
    }
    renderSequence(node) {
        if (node.model.gene_stable_id || !node.displayInfo.expanded) {
            let MSAProps = {
                key: node.model.node_id,
                className: this.props.colorScheme
            };
            let seq = node.model.consensus.sequence;
            let spans = []; // hold the lengths of each run
            let spanStart = 0;
            for(let i = 1; i < seq.length; i++)if (seq[i] !== seq[spanStart]) {
                spans.push(i - spanStart);
                spanStart = i;
            }
            spans.push(seq.length - spanStart);
            let offset = 0;
            let gapCode = "-".charCodeAt(0);
            let msaRow = [];
            for(let i = 0; i < spans.length; i++){
                let bases = String.fromCharCode.apply(this, seq.slice(offset, offset + spans[i]));
                let className = seq[offset] === gapCode ? "gap" : bases.charAt(0);
                msaRow.push(/*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("span", {
                    className: className,
                    children: bases
                }, i));
                offset += spans[i];
            }
            return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("div", {
                ...MSAProps,
                children: msaRow
            });
        }
    }
    renderControls() {
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("g", {
                    className: "viz-wrapper",
                    transform: `translate(${this.props.xOffset},3)`,
                    children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("svg", {
                        width: this.props.width,
                        height: this.props.controlsHeight,
                        viewBox: this.getViewBox(true),
                        preserveAspectRatio: "none",
                        children: this.renderNode(this.props.rootNode)
                    })
                }),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("foreignObject", {
                    x: this.props.xOffset,
                    y: this.props.yOffset,
                    width: this.props.width,
                    height: this.props.controlsHeight + 6,
                    children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("div", {
                        className: "resize-container",
                        children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("div", {
                            ref: this.zoomerRef,
                            className: "resize-drag",
                            style: {
                                height: this.props.controlsHeight + 6
                            }
                        })
                    })
                })
            ]
        });
    }
    renderMSA() {
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("foreignObject", {
            x: this.props.xOffset,
            y: this.props.yOffset + this.props.controlsHeight + this.props.margin - 10,
            width: this.props.width,
            height: this.props.height + 2 * this.props.margin + 3,
            children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("div", {
                className: "MSAlignments-wrapper",
                children: this.props.nodes.map(this.renderSequence.bind(this))
            })
        });
    }
    render() {
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
            children: [
                this.renderMSA(),
                this.renderControls()
            ]
        });
    }
}
class $64172895ffc11849$export$2e2bcd8739ae039 extends $1i38n$react.Component {
    static availableShapes() {
        return {
            triangle: {
                shape: function(opts) {
                    var halfWidth = Math.tan(Math.PI / 6) * opts.height;
                    return `M${opts.x + opts.width / 2},${opts.y} \
            l${halfWidth},${opts.height} \
            l${-halfWidth * 2},0 \
            Z`;
                }
            },
            bigSolidPointyRectangle: {
                shape: function(opts) {
                    let boxRatio = 0.75; //2 / 3;
                    let arrowRatio = 1 - boxRatio;
                    opts.cornerRadius = this.cornerRadius(opts.width, opts.height);
                    return `M${opts.x},${opts.y + opts.cornerRadius} \
            a${opts.cornerRadius},${opts.cornerRadius} 0 0 1 ${opts.cornerRadius},${-opts.cornerRadius}
            l${opts.width * boxRatio - opts.cornerRadius},0 \
            l${opts.width * arrowRatio},${opts.height / 2} \
            l${-opts.width * arrowRatio},${opts.height / 2} \
            l${-opts.width * boxRatio + opts.cornerRadius},0 \
            a${opts.cornerRadius},${opts.cornerRadius} 0 0 1 ${-opts.cornerRadius},${-opts.cornerRadius} \
            Z`;
                }
            },
            default: {
                shape: function(opts) {
                    opts.cornerRadius = this.cornerRadius(opts.width, opts.height);
                    return `M${opts.x},${opts.y + opts.height / 2} \
            a${opts.width / 2},${opts.cornerRadius} 0 0 1 ${opts.width / 2},${-opts.cornerRadius} \
            a${opts.width / 2},${opts.cornerRadius} 0 0 1 ${opts.width / 2},${opts.cornerRadius} \
            a${opts.width / 2},${opts.cornerRadius} 0 0 1 ${-opts.width / 2},${opts.cornerRadius} \
            a${opts.width / 2},${opts.cornerRadius} 0 0 1 ${-opts.width / 2},${-opts.cornerRadius} \
            Z`;
                }
            },
            thinSolidPointyRectangle: {
                shape: function(opts) {
                    var squeezeFactor = 2 / 3;
                    opts.y += opts.height * (1 - squeezeFactor) / 2;
                    opts.height = opts.height * squeezeFactor;
                    opts.cornerRadius = this.cornerRadius(opts.width, opts.height);
                    opts.cornerRadius = opts.cornerRadius * squeezeFactor;
                    return $64172895ffc11849$export$2e2bcd8739ae039.availableShapes().bigSolidPointyRectangle.shape.call(this, opts);
                }
            },
            bigStripedPointyRectangle: {
                shape: function(opts) {
                    return $64172895ffc11849$export$2e2bcd8739ae039.availableShapes().bigSolidPointyRectangle.shape.call(this, opts);
                },
                mask: function() {
                    return "url('#mask-stripe')";
                }
            },
            thinStripedPointyRectangle: {
                shape: function(opts) {
                    return $64172895ffc11849$export$2e2bcd8739ae039.availableShapes().thinSolidPointyRectangle.shape.call(this, opts);
                },
                mask: function() {
                    return "url('#mask-stripe')";
                }
            }
        };
    }
    static shapeMaster() {
        var availableShapes = $64172895ffc11849$export$2e2bcd8739ae039.availableShapes();
        return {
            "protein_coding": availableShapes.bigSolidPointyRectangle,
            "ncRNA": availableShapes.thinSolidPointyRectangle,
            "miRNA": availableShapes.thinStripedPointyRectangle,
            "snoRNA": availableShapes.thinSolidPointyRectangle,
            "tRNA": availableShapes.thinSolidPointyRectangle,
            "misc_RNA": availableShapes.thinSolidPointyRectangle,
            "transposable_element": availableShapes.bigStripedPointyRectangle,
            "lincRNA": availableShapes.thinSolidPointyRectangle,
            "nontranslating_CDS": availableShapes.bigStripedPointyRectangle,
            "tRNA_pseudogene": availableShapes.thinSolidPointyRectangle,
            "snRNA": availableShapes.thinSolidPointyRectangle,
            "rRNA": availableShapes.thinSolidPointyRectangle,
            "pseudogene": availableShapes.thinSolidPointyRectangle,
            "SRP_RNA": availableShapes.thinSolidPointyRectangle,
            "antisense": availableShapes.thinSolidPointyRectangle,
            "tmRNA": availableShapes.thinSolidPointyRectangle,
            "ribozyme": availableShapes.thinSolidPointyRectangle,
            "RNase_MRP_RNA": availableShapes.thinSolidPointyRectangle,
            "telomerase_RNA": availableShapes.thinSolidPointyRectangle,
            "P_RNA": availableShapes.thinSolidPointyRectangle,
            "RNase_P_RNA": availableShapes.thinSolidPointyRectangle,
            "vault_RNA": availableShapes.thinSolidPointyRectangle
        };
    }
    constructor(){
        super();
        this.handleClick = this.handleClick.bind(this);
        this.state = {
            highlighted: false
        };
    }
    static biotypes() {
        return Object.keys($64172895ffc11849$export$2e2bcd8739ae039.shapeMaster()).sort();
    }
    stroke(highlighted, highlightColor, defaultColor) {
        return highlighted ? highlightColor : defaultColor;
    }
    strokeWidth(highlighted, highlightWidth) {
        return highlighted ? highlightWidth : 0;
    }
    height() {
        return this.props.height || this.props.width * 2 / 3;
    }
    cornerRadius(width, height) {
        return Math.floor(Math.min(this.props.width / 7.5, this.props.height / 2));
    }
    render() {
        var shapeStuff = $64172895ffc11849$export$2e2bcd8739ae039.shapeMaster()[this.props.gene.biotype] || $64172895ffc11849$export$2e2bcd8739ae039.availableShapes().default;
        let d = shapeStuff.shape.call(this, {
            x: this.props.x,
            y: this.props.y,
            width: this.props.width,
            height: this.height()
        });
        const tooltip = this.props.tooltip ? /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($1i38n$reactbootstrap.Tooltip, {
            id: "tooltip",
            children: this.props.tooltip
        }) : null;
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($1i38n$reactbootstrap.OverlayTrigger, {
            placement: this.props.tooltipPlacement,
            overlay: tooltip,
            trigger: "click",
            rootClose: true,
            children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("g", {
                transform: "translate(" + (this.props.gene.orientation === "+" ? 0 : this.props.x * 2 + this.props.width) + ",0) scale(" + (this.props.gene.orientation === "+" ? 1 : -1) + ",1)",
                children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("path", {
                    d: d,
                    fill: this.props.fillColor,
                    strokeWidth: this.strokeWidth(this.props.highlighted, this.props.highlightWidth),
                    stroke: this.stroke(this.props.highlighted, this.props.highlightColor, this.props.strokeColor),
                    //onClick= { this.handleClick }
                    //onDoubleClick={ this.handleClick }
                    opacity: this.props.opacity,
                    //onMouseOver = { this.tooltipOver.bind(this) }
                    //onMouseOut  = { this.tooltipOut.bind(this) }
                    mask: shapeStuff.mask ? shapeStuff.mask() : "",
                    cursor: "pointer"
                })
            })
        });
    }
    handleClick() {
        if (this.props.clickHandler) this.props.clickHandler(this.props.gene.id, this.props.gene.tree_id);
    }
    tooltipOver(e) {
        if (this.props.tooltipHandler) this.props.tooltipHandler(this.props.gene, e.pageX, e.pageY, true);
    }
    tooltipOut(e) {
        if (this.props.tooltipHandler) this.props.tooltipHandler(this.props.gene, e.pageX, e.pageY, false);
    }
}
$64172895ffc11849$export$2e2bcd8739ae039.defaultProps = {
    y: 0,
    orientation: "-",
    highlightWidth: 1,
    highlightColor: "cyan",
    tooltipPlacement: "bottom",
    opacity: "0.9"
};
const $842f43965c1e0716$var$neighborhoodHeight = 24;
const $842f43965c1e0716$var$scaleFactor = 20;
const $842f43965c1e0716$var$NeighborhoodArrow = (props)=>{
    const arrowLength = $842f43965c1e0716$var$scaleFactor * 10 * props.totalLength / props.width;
    const arrowHeight = 4;
    let lineLength = $842f43965c1e0716$var$scaleFactor * props.totalLength;
    let lineStart = 0;
    let lineEnd = lineLength;
    let arrowHead;
    let color = "black";
    let tooltip = "<pre>internal node</pre>";
    if (props.neighborhood && props.neighborhood.strand) {
        const flipped = props.neighborhood.strand === "reverse";
        lineStart = flipped ? arrowLength : 0;
        lineEnd = flipped ? lineLength : lineLength - arrowLength;
        const tipX = flipped ? 0 : lineLength;
        const tailX = flipped ? arrowLength : tipX - arrowLength;
        const tipY = $842f43965c1e0716$var$neighborhoodHeight / 2;
        const points = `${tipX},${tipY} ${tailX},${tipY + arrowHeight} ${tailX},${tipY - arrowHeight}`;
        color = props.neighborhood.region.color;
        arrowHead = /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("polygon", {
            points: points,
            stroke: color,
            fill: color
        });
        const region = props.neighborhood.region;
        const system_name = props.neighborhood.genes[0].system_name;
        let syntenyURL = `${props.ensemblUrl}/${system_name}/Location/Synteny?r=${region.name}:${region.start}-${region.end}`;
        let tooltipFields = [
            [
                "region",
                region.name
            ],
            [
                "start",
                region.start
            ],
            [
                "end",
                region.end
            ],
            [
                "",
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("a", {
                    href: syntenyURL,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: `Synteny browser`
                })
            ]
        ];
        tooltip = /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($1i38n$reactbootstrap.Tooltip, {
            id: region.name + ":" + region.start,
            children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("table", {
                children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("tbody", {
                    children: tooltipFields.map((tip, i)=>{
                        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("tr", {
                            style: {
                                verticalAlign: "top"
                            },
                            children: [
                                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("th", {
                                    children: tip[0]
                                }),
                                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("td", {
                                    style: {
                                        color: "lightgray",
                                        textAlign: "left",
                                        paddingLeft: "15px"
                                    },
                                    children: tip[1]
                                })
                            ]
                        }, i);
                    })
                })
            })
        });
    }
    let tickMarks = [];
    for(let i = 1 * $842f43965c1e0716$var$scaleFactor; i < lineLength; i += $842f43965c1e0716$var$scaleFactor){
        let tick = /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("line", {
            x1: i,
            y1: 4,
            x2: i,
            y2: 20,
            stroke: color,
            strokeWidth: "0.25"
        }, i);
        tickMarks.push(tick);
    }
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
        children: [
            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($1i38n$reactbootstrap.OverlayTrigger, {
                placement: "left",
                overlay: tooltip,
                trigger: "click",
                rootClose: true,
                children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("line", {
                    x1: lineStart,
                    y1: $842f43965c1e0716$var$neighborhoodHeight / 2,
                    x2: lineEnd,
                    y2: $842f43965c1e0716$var$neighborhoodHeight / 2,
                    stroke: color,
                    strokeWidth: "3",
                    cursor: "pointer"
                })
            }),
            tickMarks,
            arrowHead
        ]
    });
};
const $842f43965c1e0716$var$ComparaGene = (props)=>{
    const gene = props.gene;
    const geneWidth = 0.6 * $842f43965c1e0716$var$scaleFactor;
    const geneHeight = 16;
    const identityScale = $1i38n$d3scale.scaleLinear().domain([
        1,
        0
    ]).range([
        props.color,
        "white"
    ]);
    const identity = gene.relationToGeneOfInterest ? gene.relationToGeneOfInterest.identity : 1;
    const highlighted = props.highlighted[gene.tree_id];
    let syntenyURL = `${props.ensemblUrl}/${gene.system_name}/Location/Synteny?r=${gene.region}:${gene.start}-${gene.end}:${gene.orientation}`;
    let tooltipFields = [
        [
            "Gene ID",
            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("a", {
                href: `?idList=${gene.id}`,
                target: "_blank",
                rel: "noopener noreferrer",
                children: gene.id
            })
        ],
        [
            "Gene Name",
            gene.name
        ],
        // ['Taxonomy',    props.taxonomy.taxonIdToSpeciesName[gene.taxon_id]],
        [
            "Region",
            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("a", {
                href: syntenyURL,
                target: "_blank",
                rel: "noopener noreferrer",
                children: `${gene.region}:${gene.start}-${gene.end}:${gene.orientation}`
            })
        ],
        [
            "Tree ID",
            gene.tree_id
        ],
        //['Tree Root',   this.props.taxonomy.taxonIdToSpeciesName[gene.gene_tree_root_taxon_id]],
        // ['Biotype',     gene.biotype],
        [
            "Description",
            gene.description
        ]
    ];
    if (gene.closest_rep_id) tooltipFields.push([
        "Homolog",
        gene.closest_rep_description
    ]);
    else if (gene.model_rep_id) tooltipFields.push([
        "Homolog",
        gene.model_rep_description
    ]);
    let button = /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)($1i38n$reactbootstrap.Button, {
        size: "sm",
        onClick: ()=>{
            if (props.clickHandler) props.clickHandler(gene.id, gene.tree_id);
        },
        children: [
            highlighted ? "Unhighlight" : "Highlight",
            " this gene tree"
        ]
    });
    if (gene.relationToGeneOfInterest) tooltipFields.push([
        "Identity",
        Math.floor(1000 * identity) / 10 + "%"
    ]);
    const tooltip = /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("table", {
        children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("tbody", {
            children: [
                tooltipFields.map((tip, i)=>{
                    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("tr", {
                        style: {
                            verticalAlign: "top"
                        },
                        children: [
                            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("th", {
                                children: tip[0]
                            }),
                            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("td", {
                                style: {
                                    color: "lightgray",
                                    textAlign: "left",
                                    paddingLeft: "15px"
                                },
                                children: tip[1]
                            })
                        ]
                    }, i);
                }),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("tr", {
                    style: {
                        verticalAlign: "top"
                    },
                    children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("td", {
                        colSpan: "2",
                        children: button
                    })
                })
            ]
        })
    });
    const centerStrokeLine = props.center ? /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("line", {
        x1: gene.x * $842f43965c1e0716$var$scaleFactor,
        y1: geneHeight / 4 - 2,
        x2: gene.x * $842f43965c1e0716$var$scaleFactor,
        y2: geneHeight / 4 + geneHeight + 2,
        stroke: "red",
        strokeWidth: "1"
    }) : null;
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
        children: [
            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($64172895ffc11849$export$2e2bcd8739ae039, {
                width: geneWidth,
                height: geneHeight,
                gene: gene,
                x: gene.x * $842f43965c1e0716$var$scaleFactor - geneWidth / 2,
                y: geneHeight / 4,
                fillColor: gene.relationToGeneOfInterest ? identityScale(identity) : props.color,
                highlightColor: highlighted ? "cyan" : props.color,
                tooltip: tooltip,
                highlighted: highlighted || props.center,
                opacity: undefined,
                clickHandler: ()=>{
                    if (props.clickHandler) props.clickHandler(gene.id, gene.tree_id);
                }
            }, "H-" + gene.id),
            centerStrokeLine
        ]
    });
};
const $842f43965c1e0716$var$NonCodingGroup = (props)=>{
    let x = +props.x * $842f43965c1e0716$var$scaleFactor;
    let n = props.genes.length;
    const ncgWidth = 0.3 * $842f43965c1e0716$var$scaleFactor;
    const ncgHeight = 16;
    const tooltip = /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)($1i38n$reactbootstrap.Tooltip, {
        id: "tooltip",
        children: [
            "Non-coding group with ",
            n,
            " gene",
            n > 1 ? "s" : ""
        ]
    });
    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($1i38n$reactbootstrap.OverlayTrigger, {
        placement: "top",
        overlay: tooltip,
        children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("rect", {
            x: x - ncgWidth / 2,
            y: 6,
            width: ncgWidth,
            height: 12,
            rx: ncgWidth / 6,
            ry: ncgHeight / 6,
            fill: props.scale(n)
        })
    });
};
function $842f43965c1e0716$var$treeIDToColor(tree_id, treeMap, scale) {
    if (tree_id === undefined) return "dimgray";
    else if (treeMap[tree_id] === undefined) return "lightgray";
    return scale(treeMap[tree_id]);
}
class $842f43965c1e0716$export$2e2bcd8739ae039 extends $parcel$interopDefault($1i38n$react).Component {
    constructor(props){
        super(props);
        this.state = {};
    }
    render() {
        let comparaGenes = [];
        let nonCodingGenes = [];
        let neighborhood = this.props.neighborhood;
        if (neighborhood) {
            let nonCodingGeneGroup = {};
            let center_x = this.props.totalLength / 2;
            let centralGene = neighborhood.genes[neighborhood.center_idx];
            let treeInfo = this.props.treeInfo;
            if (neighborhood.strand === "reverse") neighborhood.genes.forEach((gene, gene_idx)=>{
                gene.x = center_x + (centralGene.compara_idx - gene.compara_idx);
                if (gene.gene_tree) {
                    const treeColor = $842f43965c1e0716$var$treeIDToColor(gene.tree_id, treeInfo.treeMap, treeInfo.scale);
                    comparaGenes.push(/*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($842f43965c1e0716$var$ComparaGene, {
                        gene: gene,
                        color: treeColor,
                        center: gene_idx === neighborhood.center_idx,
                        clickHandler: this.props.clickHandler,
                        highlighted: this.props.highlighted
                    }, gene.x));
                } else {
                    gene.x = center_x + (centralGene.compara_idx - gene.compara_idx + 0.5);
                    if (!nonCodingGeneGroup.hasOwnProperty(gene.x)) nonCodingGeneGroup[gene.x] = [];
                    nonCodingGeneGroup[gene.x].push(gene);
                }
            });
            else neighborhood.genes.forEach((gene, gene_idx)=>{
                gene.x = center_x - (centralGene.compara_idx - gene.compara_idx);
                if (gene.gene_tree) {
                    const treeColor = $842f43965c1e0716$var$treeIDToColor(gene.tree_id, treeInfo.treeMap, treeInfo.scale);
                    comparaGenes.push(/*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($842f43965c1e0716$var$ComparaGene, {
                        gene: gene,
                        color: treeColor,
                        center: gene_idx === neighborhood.center_idx,
                        clickHandler: this.props.clickHandler,
                        highlighted: this.props.highlighted,
                        ensemblUrl: this.props.ensemblUrl
                    }, gene.x));
                } else {
                    gene.x = center_x - (centralGene.compara_idx - gene.compara_idx + 0.5);
                    if (!nonCodingGeneGroup.hasOwnProperty(gene.x)) nonCodingGeneGroup[gene.x] = [];
                    nonCodingGeneGroup[gene.x].push(gene);
                }
            });
            const ncgScale = $1i38n$d3scale.scaleLinear().domain([
                this.props.maxNCGGenes,
                1
            ]).range([
                "#333333",
                "lightgray"
            ]);
            for(let x in nonCodingGeneGroup)nonCodingGenes.push(/*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($842f43965c1e0716$var$NonCodingGroup, {
                x: x,
                genes: nonCodingGeneGroup[x],
                scale: ncgScale
            }, x));
        }
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("g", {
            className: "Neighborhood",
            children: [
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($842f43965c1e0716$var$NeighborhoodArrow, {
                    ensemblUrl: this.props.ensemblUrl,
                    neighborhood: neighborhood,
                    width: this.props.width,
                    totalLength: this.props.totalLength
                }),
                comparaGenes,
                nonCodingGenes
            ]
        });
    }
}
class $ced8d699a1299cf4$export$2e2bcd8739ae039 extends $parcel$interopDefault($1i38n$react).Component {
    constructor(props){
        super(props);
        this.state = {};
    }
    transform(isStyle) {
        let px = isStyle ? "px" : "";
        let x = 0;
        let y = this.props.node.x - 2;
        return "translate(" + x + px + ", " + y + px + ")";
    }
    render() {
        let props = {};
        if ($62e50bff44daad79$export$2e2bcd8739ae039) props.transform = this.transform(false);
        else props.style = {
            transform: this.transform(true)
        };
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("g", {
            ...props,
            children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($842f43965c1e0716$export$2e2bcd8739ae039, {
                ...this.props
            })
        });
    }
}
function $86f31c7466377268$var$initTreeColors(primary_neighborhood) {
    var range = [
        "red",
        "orange",
        "yellow",
        "green",
        "blue",
        "indigo",
        "darkviolet"
    ];
    if (primary_neighborhood.strand === "reverse") range = range.reverse();
    let treeMap = {}; // key is tree_id value is a number based on relative position in neighborhood
    var center_idx = Number(primary_neighborhood.center_idx); // always green
    var center_gene = primary_neighborhood.genes[center_idx];
    let d = 0;
    treeMap[center_gene.tree_id] = d;
    var i, nLeft = 0, nRight = 0;
    // trees left of center
    for(i = center_idx - 1; i >= 0; i--){
        var gene = primary_neighborhood.genes[i];
        if (gene.tree_id && !treeMap[gene.tree_id]) {
            treeMap[gene.tree_id] = --d;
            nLeft--;
        }
    }
    // trees right of center
    d = 0;
    for(i = center_idx + 1; i < primary_neighborhood.genes.length; i++){
        gene = primary_neighborhood.genes[i];
        if (gene.tree_id && !treeMap[gene.tree_id]) {
            treeMap[gene.tree_id] = ++d;
            nRight++;
        }
    }
    var domain = [
        nLeft,
        2 * nLeft / 3,
        nLeft / 3,
        0,
        nRight / 3,
        2 * nRight / 3,
        nRight
    ];
    if (nLeft === 0) {
        domain = domain.slice(3);
        range = range.slice(3);
    }
    if (nRight === 0) {
        domain = domain.reverse().slice(3).reverse();
        range = range.reverse().slice(3).reverse();
    }
    var scale = $1i38n$d3scale.scaleLinear().domain(domain).range(range);
    if (domain.length === 1) scale = function(value) {
        return "green";
    };
    return {
        scale: scale,
        treeMap: treeMap
    };
}
class $86f31c7466377268$export$2e2bcd8739ae039 extends $parcel$interopDefault($1i38n$react).Component {
    constructor(props){
        super(props);
        this.state = {
            highlighted: {}
        };
        // this.svgRef = React.createRef();
        this.totalLength = 2 + 2 * props.numberOfNeighbors;
        this.viewRange = {
            min: props.numberOfNeighbors / 2,
            max: .75 * this.totalLength
        };
        this.minWidth = props.width * 4 / this.totalLength;
        if (this.viewRange.max - this.viewRange.min <= this.minWidth) {
            this.viewRange.min = 0;
            this.viewRange.max = this.totalLength;
        }
    }
    // componentDidMount() {
    // }
    // componentDidMount() {
    //   if (this.zoomer) {
    //     let x = this.props.width * this.viewRange.min / this.totalLength;
    //     let y = parseFloat(this.zoomer.getAttribute('data-y')) || 0;
    //     this.zoomer.style.webkitTransform =
    //       this.zoomer.style.transform =
    //         `translate(${x}px,${y}px)`;
    //     this.zoomer.style.width = this.props.width * (this.viewRange.max - this.viewRange.min)/this.totalLength + 'px';
    //     interact(this.zoomer)
    //       .draggable({
    //         onmove: this.dragMoveListener.bind(this)
    //       })
    //       .resizable({
    //         preserveAspectRatio: false,
    //         edges: {left: true, right: true, bottom: false, top: false }
    //       })
    //       .on('resizemove', function (event) {
    //         if (event.rect.width > this.minWidth) {
    //           let target = event.target;
    //           let x = this.props.width * this.viewRange.min / this.totalLength;
    //           let y = (parseFloat(target.getAttribute('data-y')) || 0);
    //           if (event.deltaRect.left !== 0) {
    //             // move left edge
    //             x += event.deltaRect.left;
    //             if (x < 0) x = 0;
    //             this.viewRange.min = x * this.totalLength / this.props.width;
    //           }
    //           if (event.deltaRect.right !== 0) {
    //             // move right edge
    //             let right = x + event.rect.width;
    //             if (right > this.props.width) right = this.props.width;
    //             this.viewRange.max = right * this.totalLength / this.props.width;
    //           }
    //
    //           let viewWidth = this.viewRange.max - this.viewRange.min;
    //           target.style.width = this.props.width * viewWidth / this.totalLength + 'px';
    //           target.style.webkitTransform =
    //             target.style.transform =
    //               `translate(${x}px,${y}px)`;
    //           target.setAttribute('data-x', x);
    //           target.setAttribute('data-width', parseInt(target.style.width, 10));
    //
    //           this.svgRef.current.setAttribute('viewBox', this.getViewBox(false));
    //         }
    //       }.bind(this))
    //   }
    // }
    //
    // dragMoveListener(event) {
    //   if ((this.viewRange.max - this.viewRange.min + 1) < 0.98*this.totalLength) {
    //     let target = event.target,
    //       x = this.props.width * this.viewRange.min / this.totalLength + event.dx,
    //       y = parseFloat(target.getAttribute('data-y')) || 0;
    //     // respect boundaries
    //     if (x < 0) x = 0;
    //     let zoomerWidth = parseFloat(target.style.width);
    //     if (x + zoomerWidth > this.props.width) x = this.props.width - zoomerWidth;
    //     let xPosInSeq = this.totalLength * x / this.props.width;
    //     let viewWidth = this.viewRange.max - this.viewRange.min;
    //     // translate the element
    //     target.style.webkitTransform =
    //       target.style.transform =
    //         'translate(' + x + 'px, ' + y + 'px)';
    //     // update the position attribute
    //     target.setAttribute('data-x', x);
    //     // update the view position
    //     this.viewRange.min = xPosInSeq;
    //     this.viewRange.max = xPosInSeq + viewWidth;
    //
    //     this.svgRef.current.setAttribute('viewBox', this.getViewBox(false));
    //   }
    // }
    getViewBox(forConsensus) {
        let viewBoxMinX = forConsensus ? 0 : this.viewRange.min;
        let viewBoxMinY = 0;
        let viewBoxWidth = forConsensus ? this.totalLength : this.viewRange.max - this.viewRange.min;
        let viewBoxHeight = forConsensus ? this.props.controlsHeight : this.props.height + 2 * this.props.margin;
        return `${viewBoxMinX * 20} ${viewBoxMinY} ${viewBoxWidth * 20} ${viewBoxHeight}`;
    }
    getNeighborhood(node) {
        return node.model.gene_stable_id ? this.props.neighborhoods[node.model.gene_stable_id] : {
            genes: []
        };
    }
    renderNode(node, treeInfo) {
        if (node.model.gene_stable_id || !node.displayInfo.expanded) {
            let neighborhood = this.getNeighborhood(node);
            return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("g", {
                children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($ced8d699a1299cf4$export$2e2bcd8739ae039, {
                    node: node,
                    width: this.props.width,
                    totalLength: this.totalLength,
                    neighborhood: neighborhood,
                    maxNCGGenes: this.props.maxNCGGenes,
                    treeInfo: treeInfo,
                    highlighted: this.state.highlighted,
                    ensemblUrl: this.props.ensemblUrl,
                    clickHandler: (gene_id, tree_id)=>{
                        let highlighted = {
                            ...this.state.highlighted
                        };
                        highlighted[tree_id] = !highlighted[tree_id];
                        this.setState({
                            highlighted: highlighted
                        });
                    }
                })
            }, node.model.node_id);
        }
    }
    render() {
        let treeInfo = $86f31c7466377268$var$initTreeColors(this.getNeighborhood(this.props.queryNode));
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("g", {
            className: "phyloview-wrapper",
            transform: `translate(${this.props.xOffset},${this.props.yOffset + this.props.controlsHeight + this.props.margin - 10})`,
            children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("svg", {
                width: this.props.width,
                height: this.props.height + 2 * this.props.margin,
                viewBox: this.getViewBox(false),
                preserveAspectRatio: "none",
                children: this.props.nodes.map((node)=>{
                    return this.renderNode(node, treeInfo);
                })
            })
        });
    }
}
const $d4db98f04dcc88a8$var$shifty = {
    curate: "okay",
    okay: "flag",
    // unclear: 'curate',
    flag: "curate"
};
let $d4db98f04dcc88a8$var$reasons = [
    {
        name: "none",
        label: "choose a reason"
    }
];
let $d4db98f04dcc88a8$var$groups = [
    {
        name: "none",
        label: "choose a group"
    },
    {
        name: "A",
        label: "A"
    },
    {
        name: "B",
        label: "B"
    }
];
const $d4db98f04dcc88a8$var$combos = [
    "G__",
    "L__",
    "_G_",
    "_L_",
    "__G",
    "__L",
    "GG_",
    "GL_",
    "G_G",
    "G_L",
    "GGG",
    "GGL",
    "GLG",
    "GLL",
    "LG_",
    "LL_",
    "L_G",
    "L_L",
    "LGG",
    "LGL",
    "LLG",
    "LLL",
    "_GG",
    "_GL",
    "_LG",
    "_LL"
];
$d4db98f04dcc88a8$var$combos.forEach((c)=>{
    $d4db98f04dcc88a8$var$reasons.push({
        name: c,
        label: c.split("").join(",")
    });
});
$d4db98f04dcc88a8$var$reasons.push({
    name: "split",
    label: "split gene"
});
$d4db98f04dcc88a8$var$reasons.push({
    name: "fusion",
    label: "fused gene"
});
$d4db98f04dcc88a8$var$reasons.push({
    name: "other",
    label: "other"
});
class $d4db98f04dcc88a8$export$2e2bcd8739ae039 extends $parcel$interopDefault($1i38n$react).Component {
    constructor(props){
        super(props);
        let opinion = [];
        let reason = [];
        let group = [];
        props.nodes.forEach((node)=>{
            if (node.model.gene_stable_id && (props.curatable.all || props.curatable[node.model.taxon_id])) {
                opinion[node.model.gene_stable_id] = "curate";
                reason[node.model.gene_stable_id] = "none";
                group[node.model.gene_stable_id] = "none";
            }
        });
        this.state = {
            opinion: opinion,
            reason: reason,
            group: group
        };
    }
    componentWillReceiveProps(nextProps) {
        if (!$parcel$interopDefault($1i38n$lodash).isEqual(nextProps, this.state.props)) {
            let opinion = this.state.opinion;
            let doUpdate = false;
            nextProps.nodes.forEach((node)=>{
                const id = node.model.gene_stable_id;
                if (id && !this.state.opinion[id] && (nextProps.curatable.all || nextProps.curatable[node.model.taxon_id])) opinion[id] = "curate";
            });
            if (doUpdate) this.setState({
                opinion: opinion
            });
        }
    }
    flipFlop(node) {
        const id = node.model.gene_stable_id;
        let opinion = this.state.opinion;
        let reason = this.state.reason;
        let group = this.state.group;
        opinion[id] = $d4db98f04dcc88a8$var$shifty[opinion[id]];
        this.setState({
            opinion: opinion
        });
        this.props.getCuration(opinion, reason, group);
    }
    changeReason(e, node) {
        const id = node.model.gene_stable_id;
        let opinion = this.state.opinion;
        let reason = this.state.reason;
        let group = this.state.group;
        reason[id] = e.target.value;
        this.setState({
            reason: reason
        });
        this.props.getCuration(opinion, reason, group);
    }
    changeGroup(e, node) {
        const id = node.model.gene_stable_id;
        let opinion = this.state.opinion;
        let reason = this.state.reason;
        let group = this.state.group;
        group[id] = e.target.value;
        this.setState({
            group: group
        });
        this.props.getCuration(opinion, reason, group);
    }
    render() {
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("g", {
            className: "curation-wrapper",
            transform: `translate(${this.props.xOffset},${this.props.yOffset})`,
            children: this.props.nodes.map((node, idx)=>{
                if (node.model.gene_stable_id && (this.props.curatable.all || this.props.curatable[node.model.taxon_id])) {
                    const opinion = this.state.opinion[node.model.gene_stable_id];
                    const reason = this.state.reason[node.model.gene_stable_id] || "none";
                    const group = this.state.group[node.model.gene_stable_id] || "none";
                    let reasonSelect;
                    if (opinion === "flag") reasonSelect = /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("span", {
                        className: "curation-reason",
                        children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("select", {
                            value: reason,
                            name: node.model.gene_stable_id,
                            onChange: (e)=>this.changeReason(e, node),
                            children: $d4db98f04dcc88a8$var$reasons.map((r, idx)=>/*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("option", {
                                    value: r.name,
                                    children: r.label
                                }, idx))
                        })
                    });
                    let groupSelect;
                    // if (opinion === 'unclear') {
                    //   groupSelect = (<span className='curation-group'>
                    //     <select value={group} name={node.model.gene_stable_id} onChange={(e) => this.changeGroup(e,node)}>
                    //       {groups.map((g,idx) => (
                    //         <option key={idx} value={g.name}>{g.label}</option>
                    //       ))}
                    //     </select>
                    //   </span>)
                    // }
                    return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("foreignObject", {
                        x: 10,
                        y: node.x - 4,
                        height: this.props.height,
                        width: this.props.width,
                        children: [
                            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("span", {
                                className: `curation ${opinion}`,
                                onClick: ()=>this.flipFlop(node),
                                children: opinion
                            }),
                            reasonSelect,
                            groupSelect
                        ]
                    }, idx);
                }
                return "";
            })
        });
    }
}
const $1f9b52c72af6ed55$var$Spinner = (props)=>/*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("foreignObject", {
        x: props.xOffset,
        y: props.yOffset,
        children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("div", {
            className: "spinner",
            children: [
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("div", {
                    className: "bounce1"
                }),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("div", {
                    className: "bounce2"
                }),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("div", {
                    className: "bounce3"
                })
            ]
        })
    });
var $1f9b52c72af6ed55$export$2e2bcd8739ae039 = $1f9b52c72af6ed55$var$Spinner;
let $8c542044289fc59b$var$calculateIdentity = $1i38n$gramenetreesclient.extensions.identity;
function $8c542044289fc59b$var$relateNodesToGeneOfInterest(genetree, geneOfInterest, taxonomy, pivotTree) {
    $8c542044289fc59b$var$addHomologyInformationToNodes(genetree, geneOfInterest);
    $8c542044289fc59b$var$addTaxonDistanceInformationToNodes(genetree, geneOfInterest, taxonomy);
    if (pivotTree) {
        let node = genetree.indices.gene_stable_id[geneOfInterest._id];
        const indexCallback = (n)=>n === node;
        while(!node.isRoot()){
            const parent = node.parent;
            const children = parent.children;
            const nodeIdx = $parcel$interopDefault($1i38n$lodash).findIndex(children, indexCallback);
            // move this node to the front of the children array.
            if (nodeIdx) children.splice(0, 0, children.splice(nodeIdx, 1)[0]);
            node = parent;
        }
    }
}
function $8c542044289fc59b$var$addHomologyInformationToNodes(genetree, theGene) {
    if (theGene) {
        let theGeneNode = genetree.indices.gene_stable_id[theGene._id];
        let homologs = $8c542044289fc59b$var$indexHomologs(theGene);
        let representatives = $8c542044289fc59b$var$indexReps(theGene);
        // recursive function that sorts children by identity
        function sortByIdentity(node) {
            let homology;
            let nodeId = node.model.gene_stable_id;
            if (!node.hasOwnProperty("relationToGeneOfInterest")) node.relationToGeneOfInterest = {};
            if (nodeId) {
                if (nodeId === theGene._id) homology = "self";
                else homology = homologs[nodeId];
                node.relationToGeneOfInterest.identity = $8c542044289fc59b$var$calculateIdentity(theGeneNode, node);
                node.relationToGeneOfInterest.homology = homology;
                node.relationToGeneOfInterest.repType = representatives[nodeId];
                if (!node.model.gene_display_label) node.model.gene_display_label = `[${nodeId}]`;
            } else {
                node.children.forEach(function(child) {
                    sortByIdentity(child);
                });
                node.children = $parcel$interopDefault($1i38n$lodash).sortBy(node.children, function(n) {
                    return 1.0 - n.relationToGeneOfInterest.identity;
                });
                node.relationToGeneOfInterest.identity = node.children[0].relationToGeneOfInterest.identity;
            }
        }
        sortByIdentity(genetree);
    }
}
// IN -> key: homologyType, value: [geneId]
// OUT-> key: geneId, value: homologyType
function $8c542044289fc59b$var$indexHomologs(theGene) {
    let homologs = $parcel$interopDefault($1i38n$lodash).get(theGene, "homology.homologous_genes");
    return $parcel$interopDefault($1i38n$lodash).transform(homologs, function(result, value, key) {
        $parcel$interopDefault($1i38n$lodash).forEach(value, function(id) {
            result[id] = key;
        });
        return result;
    }, {});
}
// IN -> key: representativeType, value: gene doc
// OUT-> key: geneId, value: representativeType
function $8c542044289fc59b$var$indexReps(theGene) {
    let representative = $parcel$interopDefault($1i38n$lodash).get(theGene, "homology.gene_tree.representative");
    return $parcel$interopDefault($1i38n$lodash).transform(representative, function(result, rep, repType) {
        result[rep.id] = repType;
        return result;
    }, {});
}
function $8c542044289fc59b$var$addTaxonDistanceInformationToNodes(genetree, geneOfInterest, taxonomy) {
    /*const*/ var OUTGROUP_FLAG = -1;
    let theGeneTaxonId = geneOfInterest.taxon_id;
    if (theGeneTaxonId && taxonomy) {
        let theTaxonNode = taxonomy.indices.id[theGeneTaxonId];
        let theTaxonPath = theTaxonNode.getPath();
        let theTaxonPathIds = $parcel$interopDefault($1i38n$lodash).keyBy(theTaxonPath, "model.id");
        let relationLUT = {};
        let maxima = {
            lcaDistance: 0,
            pathDistance: 0
        };
        genetree.walk(function(node) {
            let nodeTaxonId = node.model.taxon_id || node.model.node_taxon_id;
            // have we already seen this?
            if (relationLUT[nodeTaxonId]) node.relationToGeneOfInterest.taxonomy = relationLUT[nodeTaxonId];
            else {
                let lcaDistance = 0;
                let pathDistance = 0;
                let lca;
                if (nodeTaxonId !== theGeneTaxonId) {
                    lca = theTaxonPathIds[nodeTaxonId];
                    if (lca) pathDistance = 0;
                    else {
                        let nodeTaxon = taxonomy.indices.id[nodeTaxonId];
                        if (nodeTaxon) {
                            lca = theTaxonNode.lcaWith([
                                nodeTaxon
                            ]);
                            pathDistance = lca.pathTo(nodeTaxon).length - 1;
                        } else pathDistance = OUTGROUP_FLAG;
                    }
                    if (pathDistance === OUTGROUP_FLAG) lcaDistance = OUTGROUP_FLAG;
                    else lcaDistance = theTaxonPath.length - $parcel$interopDefault($1i38n$lodash).indexOf(theTaxonPath, lca) - 1;
                }
                let distances = {
                    lcaDistance: lcaDistance,
                    pathDistance: pathDistance,
                    maxima: maxima
                };
                maxima.lcaDistance = Math.max(maxima.lcaDistance, distances.lcaDistance);
                maxima.pathDistance = Math.max(maxima.pathDistance, distances.pathDistance);
                relationLUT[nodeTaxonId] = node.relationToGeneOfInterest.taxonomy = distances;
            }
        });
        $parcel$interopDefault($1i38n$lodash).forIn(relationLUT, function updateOutgroupTaxa(distances) {
            if (distances.lcaDistance === OUTGROUP_FLAG) {
                distances.lcaDistance = maxima.lcaDistance;
                distances.pathDistance = maxima.pathDistance;
            }
        });
        maxima.colorScale = $1i38n$d3scale.scaleLinear().domain([
            0,
            maxima.lcaDistance + maxima.pathDistance
        ]).range([
            "green",
            "red"
        ]);
    }
}
var $8c542044289fc59b$export$2e2bcd8739ae039 = $8c542044289fc59b$var$relateNodesToGeneOfInterest;
const $f7e47e6ef7e802bb$var$PIXELS_PER_X_INDEX = 18;
const $f7e47e6ef7e802bb$var$DEFAULT_SVG_HEIGHT = 250;
function $f7e47e6ef7e802bb$var$calculateSvgHeight(genetree) {
    if (genetree && $parcel$interopDefault($1i38n$lodash).isNumber(genetree.minXindex) && $parcel$interopDefault($1i38n$lodash).isNumber(genetree.maxXindex)) return (genetree.maxXindex - genetree.minXindex) * $f7e47e6ef7e802bb$var$PIXELS_PER_X_INDEX;
    else return $f7e47e6ef7e802bb$var$DEFAULT_SVG_HEIGHT;
}
var $f7e47e6ef7e802bb$export$2e2bcd8739ae039 = $f7e47e6ef7e802bb$var$calculateSvgHeight;
function $1ec57391cf50db74$export$2e2bcd8739ae039(genetree, w, h) {
    const MIN_DIST = 0.05;
    const MAX_DIST = 2;
    let xscale = $1i38n$d3scale.scaleLinear().domain([
        genetree.minXindex,
        genetree.maxXindex
    ]).range([
        0,
        h
    ]);
    let maxExpandedDist = 0;
    let expandedNodes = [];
    genetree.walk(function(node) {
        let parentDist = Math.max(node.model.distance_to_parent, MIN_DIST) || 0;
        while(parentDist > MAX_DIST)parentDist /= 10;
        node.root_dist = (node.parent ? node.parent.root_dist : 0) + parentDist;
        if (!node.parent || node.parent.displayInfo.expanded) {
            node.x = xscale(node.xindex);
            expandedNodes.push(node);
            if (node.root_dist > maxExpandedDist) maxExpandedDist = node.root_dist;
        }
    });
    let yscale = $1i38n$d3scale.scaleLinear().domain([
        0,
        maxExpandedDist
    ]).range([
        0,
        w
    ]);
    return expandedNodes.map(function(node) {
        node.y = yscale(node.root_dist);
        return node;
    });
}
function $f295311ee73679ba$export$8b60bd6775d46208(node) {
    node.displayInfo.expanded = true;
}
function $f295311ee73679ba$export$3e625f118b045824(node) {
    node.displayInfo.expanded = false;
}
function $f295311ee73679ba$export$d865796a5b4a7f49(node) {
    node.walk($f295311ee73679ba$export$8b60bd6775d46208);
}
function $f295311ee73679ba$export$5be4099be9306efa(node) {
    node.walk($f295311ee73679ba$export$3e625f118b045824);
}
function $f295311ee73679ba$var$compressLongTaxonName(node) {
    const fullName = node.model.taxon_name;
    const removedExtraineousWords = fullName.replace(/( Group$| subsp\.| ssp\.| var\.| strain)/, "");
    let finalVersion;
    if (removedExtraineousWords.length > 20) {
        let words = removedExtraineousWords.split(" ");
        if (words.length === 2) finalVersion = removedExtraineousWords.replace(/^([A-Z])[a-z]+/, "$1.");
        if (words.length > 2) finalVersion = removedExtraineousWords.replace(/^([A-Z])[a-z]+\s([a-z])[a-z]+/, "$1$2.");
    } else finalVersion = removedExtraineousWords;
    node.model.taxon_name = finalVersion;
}
function $f295311ee73679ba$export$e2f5f157c8e85aef(node) {
    node.walk($f295311ee73679ba$var$compressLongTaxonName);
}
function $f295311ee73679ba$export$cbecd1a31826c595(genetree) {
    let visibleUnexpanded = []; // array of unexpanded nodes that are visible
    function calcXIndexFor(node) {
        if (node.displayInfo.expanded && node.children.length > 0) {
            if (node.children.length === 2) {
                let leftExtrema = calcXIndexFor(node.children[0]); // left child
                let rightExtrema = calcXIndexFor(node.children[1]); // right child
                node.xindex = (rightExtrema.min + leftExtrema.max) / 2; // midpoint
                return {
                    min: leftExtrema.min,
                    max: rightExtrema.max
                };
            } else {
                let childExtrema = calcXIndexFor(node.children[0]);
                node.xindex = node.children[0].xindex;
                return {
                    min: childExtrema.min,
                    max: childExtrema.max
                };
            }
        } else {
            visibleUnexpanded.push(node);
            node.xindex = visibleUnexpanded.length;
            return {
                min: node.xindex,
                max: node.xindex
            };
        }
    }
    let treeExtrema = calcXIndexFor(genetree);
    genetree.maxXindex = treeExtrema.max;
    genetree.minXindex = treeExtrema.min;
}
function $f295311ee73679ba$export$6ec9a7cb49676029(genetree, geneOfInterest, expandRepresentatives) {
    let pathIds = getPathIds(expandRepresentatives);
    let paralogPathIds = getParalogPathIds();
    let orthologPathIds = null; //getOrthologPathIds();
    genetree.walk(function(node) {
        let nodeId = node.model.node_id;
        let isLeafNode = !!node.model.gene_stable_id;
        let onlyChild = node.children && node.children.length === 1;
        let displayInfo = {
            expanded: false,
            leafNode: isLeafNode,
            isGeneOfInterest: node.model.gene_stable_id === geneOfInterest._id
        };
        if (!!pathIds[nodeId]) {
            displayInfo.expanded = true;
            displayInfo.expandedBecause = pathIds[nodeId];
        } else if (node.parent) {
            let parentNodeId = node.parent.model.node_id;
            if ((isLeafNode || onlyChild) && pathIds[parentNodeId]) {
                displayInfo.expanded = true;
                displayInfo.expandedBecause = pathIds[parentNodeId];
                pathIds[node.model.node_id] = [
                    node
                ];
            }
        }
        displayInfo.paralogs = paralogPathIds ? paralogPathIds[nodeId] : [];
        displayInfo.orthologs = orthologPathIds ? orthologPathIds[nodeId] : [];
        node.displayInfo = displayInfo;
    });
    function getPathIds(expandRepresentatives) {
        let representatives = expandRepresentatives && $parcel$interopDefault($1i38n$lodash).get(geneOfInterest.homology.gene_tree, "representative");
        // get nodes of representatives and gene of interest.
        let nodesToExpand = representatives ? $parcel$interopDefault($1i38n$lodash).map(representatives, (rep)=>idToNode(rep.id)) : [];
        nodesToExpand.push(idToNode(geneOfInterest._id));
        // get and index all node_ids in the paths for those nodes.
        // these are the ones that should be expanded by default.
        return $parcel$interopDefault($1i38n$lodash).reduce(nodesToExpand, nodesToPathIds, {});
    }
    function pathIdsImpl(path) {
        let ids = $parcel$interopDefault($1i38n$lodash).get(geneOfInterest, path);
        if (!ids) return null;
        ids.push(geneOfInterest._id);
        let nodes = $parcel$interopDefault($1i38n$lodash).map(ids, idToNode);
        return $parcel$interopDefault($1i38n$lodash).reduce(nodes, nodesToPathIds, {});
    }
    function getParalogPathIds() {
        return pathIdsImpl("homology.homologous_genes.within_species_paralog");
    }
    function getOrthologPathIds() {
        let keys = $parcel$interopDefault($1i38n$lodash).keys($parcel$interopDefault($1i38n$lodash).get(geneOfInterest, "homology.homologous_genes")).map(function(key) {
            return "homology.homologous_genes." + key;
        });
        let filteredKeys = $parcel$interopDefault($1i38n$lodash).filter(keys, function(key) {
            return key.indexOf("ortholog") > -1;
        });
        let pathIdsArray = $parcel$interopDefault($1i38n$lodash).map(filteredKeys, pathIdsImpl);
        return $parcel$interopDefault($1i38n$lodash).reduce(pathIdsArray, function(acc, obj) {
            return $parcel$interopDefault($1i38n$lodash).mergeWith(acc, obj, function mergeIndexedPathIds(accVal, objVal) {
                return $parcel$interopDefault($1i38n$lodash).isArray(accVal) ? accVal.concat(objVal) : objVal;
            });
        });
    }
    function idToNode(id) {
        return genetree.indices.gene_stable_id[id];
    }
    function nodesToPathIds(acc, node) {
        // take an array of nodes, return an object with
        // key: pathNodeId
        // value: array of actual nodes (not the ones in the path).
        if (!node) return acc;
        let paralogPairs = $parcel$interopDefault($1i38n$lodash).map(node.getPath(), function(n) {
            return [
                n.model.node_id,
                node
            ];
        });
        let paralogLUT = $parcel$interopDefault($1i38n$lodash).fromPairs(paralogPairs);
        return $parcel$interopDefault($1i38n$lodash).assignWith(acc, paralogLUT, function(accVal, srcVal) {
            return $parcel$interopDefault($1i38n$lodash).isUndefined(accVal) ? [
                srcVal
            ] : $parcel$interopDefault($1i38n$lodash).concat(accVal, srcVal);
        });
    }
}
const $bc2bf29db86f3503$var$regionColors = $1i38n$d3scale.scaleOrdinal($1i38n$d3scale.schemeCategory10).range();
const $bc2bf29db86f3503$var$unanchoredColor = "#d3d3d3";
var $bc2bf29db86f3503$var$facets = {
    roots: {
        type: "terms",
        field: "gene_tree_root_taxon_id",
        mincount: 1,
        limit: 100,
        collection: "taxonomy"
    },
    domains: {
        type: "terms",
        field: "domains__ancestors",
        mincount: 1,
        limit: 100
    },
    GO: {
        type: "terms",
        field: "GO__ancestors",
        mincount: 1,
        limit: 100
    },
    pathways: {
        type: "terms",
        field: "pathways__ancestors",
        mincount: 1,
        limit: 100
    }
};
function $bc2bf29db86f3503$var$search(query) {
    return (0, $1i38n$gramenesearchclient.client).grameneClient.then((client)=>client["Search"].genes(query).then((response)=>response.obj));
}
function $bc2bf29db86f3503$var$details(collection, idList) {
    return (0, $1i38n$gramenesearchclient.client).grameneClient.then((client)=>client["Data access"][collection]({
            idList: idList,
            rows: -1
        }).then((response)=>response.obj));
}
function $bc2bf29db86f3503$var$getRegionColors() {
    return (0, $1i38n$gramenesearchclient.client).grameneClient.then((client)=>client["Data access"]["maps"]({
            rows: -1
        }).then((response)=>{
            let colors = {};
            response.obj.forEach((map)=>{
                colors[map.taxon_id] = {};
                for(let i = 0; i < map.regions.names.length; i++)colors[map.taxon_id][map.regions.names[i]] = map.regions.names[i] === "UNANCHORED" ? $bc2bf29db86f3503$var$unanchoredColor : $bc2bf29db86f3503$var$regionColors[i % $bc2bf29db86f3503$var$regionColors.length];
            });
            return colors;
        }));
}
function $bc2bf29db86f3503$var$centralGenePromise(queryString) {
    return $bc2bf29db86f3503$var$search({
        q: queryString,
        rows: 10000,
        start: 0,
        fl: [
            "compara_idx",
            "gene_idx",
            "id",
            "taxon_id",
            "region",
            "start",
            "end",
            "strand"
        ]
    });
}
function $bc2bf29db86f3503$var$allGenesPromise(queryString, numberOfNeighbors) {
    var fieldToQuery = 20;
    if (numberOfNeighbors <= 10) fieldToQuery = 10;
    if (numberOfNeighbors <= 5) fieldToQuery = 5;
    return $bc2bf29db86f3503$var$search({
        fq: `{!graph from=compara_neighbors_${fieldToQuery} to=compara_idx_multi maxDepth=1}${queryString}`,
        rows: 100000,
        start: 0,
        fl: [
            "id",
            "name",
            "compara_idx",
            "gene_idx",
            "gene_tree",
            "taxon_id",
            "system_name",
            "closest_rep*",
            "model_rep*",
            "region",
            "strand",
            "biotype",
            "gene_tree_root_taxon_id",
            "description",
            "start",
            "end",
            "domains__ancestors",
            "GO__ancestors",
            "pathways__ancestors"
        ],
        "json.facet": JSON.stringify($bc2bf29db86f3503$var$facets)
    });
}
function $bc2bf29db86f3503$var$indexGenes(neighborhoodResponse) {
    const genes = {};
    neighborhoodResponse.response.docs.forEach(function(doc) {
        genes[doc.gene_idx] = doc;
    });
    return {
        genes: genes,
        facets: neighborhoodResponse.facets
    };
}
function $bc2bf29db86f3503$var$lookupFacetInfo(neighborhoodResponse) {
    var facetCounts = $parcel$interopDefault($1i38n$lodash).cloneDeep($bc2bf29db86f3503$var$facets);
    var detailsPromises = [];
    $parcel$interopDefault($1i38n$lodash).forEach(facetCounts, (facetCount, f)=>{
        if (neighborhoodResponse.facets.hasOwnProperty(f)) {
            var idList = [];
            facetCount.counts = neighborhoodResponse.facets[f].buckets.map(function(bucket) {
                idList.push(bucket.val);
                return {
                    id: bucket.val,
                    count: bucket.count
                };
            });
            if (idList.length > 0) {
                var collection = facetCount.hasOwnProperty("collection") ? facetCount.collection : f;
                detailsPromises.push($bc2bf29db86f3503$var$details(collection, idList).then(function(docs) {
                    const details = {};
                    docs.forEach(function(doc) {
                        details[doc._id] = doc;
                    });
                    facetCount.counts.forEach(function(bucket) {
                        bucket.info = details[bucket.id];
                    });
                    return 0;
                }));
            }
        }
    });
    // run all the promises
    return $parcel$interopDefault($1i38n$q).all(detailsPromises).then(function() {
        neighborhoodResponse.facets = facetCounts;
        return neighborhoodResponse;
    });
}
function $bc2bf29db86f3503$var$groupGenesIntoNeighborhoods(centralGenes, allGenesAndFacets, color, numberOfNeighbors, sortedIdsAndIdentities) {
    let allGenes = allGenesAndFacets.genes;
    const neighborhoods = [];
    const geneDocs = $parcel$interopDefault($1i38n$lodash).keyBy(centralGenes.response.docs, "id");
    let spanDistribution = [];
    sortedIdsAndIdentities.forEach(function(geneIdAndIdentity) {
        const geneId = geneIdAndIdentity.id;
        const doc = geneDocs[geneId];
        if (doc) {
            const geneNeighborhood = {
                region: {
                    name: doc.region,
                    color: color[doc.taxon_id][doc.region] || $bc2bf29db86f3503$var$unanchoredColor
                },
                center_gene_id: doc.id,
                center_relationToGeneOfInterest: geneIdAndIdentity.relationToGeneOfInterest,
                center_idx: 0,
                genes: [] // tbd
            };
            const idx = doc.gene_idx;
            const compara_idx = doc.compara_idx;
            let first = idx - 1;
            while(allGenes[first] && allGenes[first].compara_idx + numberOfNeighbors >= compara_idx)first--;
            let last = idx + 1;
            while(allGenes[last] && allGenes[last].compara_idx - numberOfNeighbors <= compara_idx)last++;
            for(let i = first; i <= last; i++)if (!!allGenes[i] && allGenes[i].taxon_id === allGenes[idx].taxon_id && allGenes[i].region === allGenes[idx].region) {
                if (i === idx) geneNeighborhood.center_idx = geneNeighborhood.genes.length;
                allGenes[i].tree_id = allGenes[i].gene_tree;
                allGenes[i].orientation = allGenes[i].strand === 1 ? "+" : "-";
                geneNeighborhood.genes.push(allGenes[i]);
            }
            geneNeighborhood.region.start = geneNeighborhood.genes[0].start;
            geneNeighborhood.region.end = geneNeighborhood.genes[geneNeighborhood.genes.length - 1].end;
            // non-coding group length histogram
            let spanStart = 0;
            let spanIsNonCoding = false;
            geneNeighborhood.genes.forEach(function(g, i) {
                if (!g.gene_tree) {
                    if (!spanIsNonCoding) {
                        spanStart = i;
                        spanIsNonCoding = true;
                    }
                } else if (spanIsNonCoding) {
                    let offset = i - spanStart;
                    if (spanDistribution[offset]) spanDistribution[offset]++;
                    else spanDistribution[offset] = 1;
                    spanIsNonCoding = false;
                }
            });
            // catch the edge case where the neighborhood ends with non-coding genes
            if (spanIsNonCoding) {
                let offset = geneNeighborhood.genes.length - spanStart;
                if (spanDistribution[offset]) spanDistribution[offset]++;
                else spanDistribution[offset] = 1;
            }
            neighborhoods.push(geneNeighborhood);
        }
    });
    return {
        neighborhoods: neighborhoods,
        facets: allGenesAndFacets.facets,
        nonCodingGroupLengthDistribution: spanDistribution,
        geneDocs: geneDocs
    };
}
function $bc2bf29db86f3503$var$reverseNeigborhoodsIfGeneOfInterestOnNegativeStrand(neighborhoodsAndFacets) {
    let oriented = {};
    let neighborhoods = neighborhoodsAndFacets.neighborhoods.map((neighborhood)=>{
        const { genes: genes, center_idx: center_idx } = neighborhood;
        const centerGenes = genes[center_idx];
        centerGenes.relationToGeneOfInterest = neighborhood.center_relationToGeneOfInterest;
        if (!oriented[centerGenes.id]) {
            if (centerGenes.orientation === "-") {
                // genes.reverse();
                genes.forEach((gene)=>{
                    gene.orientation = gene.orientation === "-" ? "+" : "-";
                });
                // neighborhood.center_idx = (genes.length - 1) - neighborhood.center_idx;
                neighborhood.strand = "reverse";
            } else neighborhood.strand = "forward";
            genes.forEach((gene)=>oriented[gene.id] = neighborhood.strand);
        } else neighborhood.strand = oriented[centerGenes.id];
        return neighborhood;
    });
    neighborhoodsAndFacets.neighborhoods = $parcel$interopDefault($1i38n$lodash).keyBy(neighborhoods, "center_gene_id");
    return neighborhoodsAndFacets;
}
function $bc2bf29db86f3503$var$getAndIndexGenes(queryString, numberOfNeighbors) {
    return $bc2bf29db86f3503$var$allGenesPromise(queryString, numberOfNeighbors).then($bc2bf29db86f3503$var$lookupFacetInfo).then($bc2bf29db86f3503$var$indexGenes);
}
function $bc2bf29db86f3503$export$2e2bcd8739ae039(genetree, numberOfNeighbors, genomesOfInterest) {
    let queryString = `gene_tree:${genetree.model._id}`;
    // if (!_.isEmpty(genomesOfInterest)) {
    //   let taxa = Object.keys(genomesOfInterest).join(' ');
    //   queryString = `${queryString} AND taxonomy__ancestors:(${taxa})`;
    // }
    return $parcel$interopDefault($1i38n$q).all([
        $bc2bf29db86f3503$var$centralGenePromise(queryString),
        $bc2bf29db86f3503$var$getAndIndexGenes(queryString, numberOfNeighbors),
        $bc2bf29db86f3503$var$getRegionColors(),
        numberOfNeighbors,
        genetree.leafNodes().map((n)=>{
            return {
                id: n.model.gene_stable_id,
                relationToGeneOfInterest: n.relationToGeneOfInterest
            };
        }).sort((a, b)=>b.relationToGeneOfInterest.identity - a.relationToGeneOfInterest.identity)
    ]).spread($bc2bf29db86f3503$var$groupGenesIntoNeighborhoods).then($bc2bf29db86f3503$var$reverseNeigborhoodsIfGeneOfInterestOnNegativeStrand);
}
var $4963a3e9a834b965$export$2e2bcd8739ae039 = {
    LABEL: "label"
};
const $48bcb93d056f01ef$var$style = {
    // border: '1px dashed gray',
    padding: "0.25rem 0.5rem",
    backgroundColor: "white",
    cursor: "move",
    display: "inline-block",
    zoom: 1,
    verticalAlign: "top",
    width: "20%"
};
const $48bcb93d056f01ef$var$labelSource = {
    beginDrag (props) {
        return {
            id: props.id,
            index: props.index
        };
    }
};
const $48bcb93d056f01ef$var$labelTarget = {
    hover (props, monitor, component) {
        const dragIndex = monitor.getItem().index;
        const hoverIndex = props.index;
        // Don't replace items with themselves
        if (dragIndex === hoverIndex) return;
        // Determine rectangle on screen
        const hoverBoundingRect = (0, $1i38n$reactdom.findDOMNode)(component).getBoundingClientRect();
        // Get vertical middle
        const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
        // Determine mouse position
        const clientOffset = monitor.getClientOffset();
        // Get pixels to the top
        const hoverClientY = clientOffset.y - hoverBoundingRect.top;
        // Only perform the move when the mouse has crossed half of the items height
        // When dragging downwards, only move when the cursor is below 50%
        // When dragging upwards, only move when the cursor is above 50%
        // Dragging downwards
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) return;
        // Dragging upwards
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) return;
        // Time to actually perform the action
        props.moveLabel(dragIndex, hoverIndex);
        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        // to avoid expensive index searches.
        monitor.getItem().index = hoverIndex;
    }
};
class $48bcb93d056f01ef$var$Label extends $1i38n$react.Component {
    render() {
        const { text: text, isDragging: isDragging, connectDragSource: connectDragSource, connectDropTarget: connectDropTarget, checked: checked } = this.props;
        const opacity = isDragging ? 0 : 1;
        return connectDragSource(connectDropTarget(/*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("div", {
            style: {
                ...$48bcb93d056f01ef$var$style,
                opacity: opacity
            },
            children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("div", {
                style: {
                    border: "1px dashed gray",
                    padding: "1rem"
                },
                children: [
                    /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("input", {
                        name: text,
                        onChange: ()=>this.props.toggleLabel(this.props.index),
                        checked: checked,
                        type: "checkbox"
                    }),
                    /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("label", {
                        style: {
                            marginBottom: 0,
                            paddingLeft: "0.2rem"
                        },
                        htmlFor: text,
                        children: text
                    })
                ]
            })
        })));
    }
}
$48bcb93d056f01ef$var$Label.propTypes = {
    connectDragSource: $parcel$interopDefault($1i38n$proptypes).func.isRequired,
    connectDropTarget: $parcel$interopDefault($1i38n$proptypes).func.isRequired,
    index: $parcel$interopDefault($1i38n$proptypes).number.isRequired,
    isDragging: $parcel$interopDefault($1i38n$proptypes).bool.isRequired,
    id: $parcel$interopDefault($1i38n$proptypes).any.isRequired,
    text: $parcel$interopDefault($1i38n$proptypes).string.isRequired,
    moveLabel: $parcel$interopDefault($1i38n$proptypes).func.isRequired,
    checked: $parcel$interopDefault($1i38n$proptypes).bool.isRequired,
    toggleLabel: $parcel$interopDefault($1i38n$proptypes).func.isRequired
};
var $48bcb93d056f01ef$export$2e2bcd8739ae039 = $parcel$interopDefault($1i38n$lodashflow)((0, $1i38n$reactdnd.DropTarget)($4963a3e9a834b965$export$2e2bcd8739ae039.LABEL, $48bcb93d056f01ef$var$labelTarget, (connect)=>({
        connectDropTarget: connect.dropTarget()
    })), (0, $1i38n$reactdnd.DragSource)($4963a3e9a834b965$export$2e2bcd8739ae039.LABEL, $48bcb93d056f01ef$var$labelSource, (connect, monitor)=>({
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging()
    })))($48bcb93d056f01ef$var$Label);
const $4c161799644cf022$var$style = {};
class $4c161799644cf022$var$LabelConfig extends $1i38n$react.Component {
    constructor(props){
        super(props);
        this.moveLabel = this.moveLabel.bind(this);
        this.state = {
            labels: [
                {
                    id: 1,
                    text: "Species",
                    field: "model.taxon_name",
                    checked: $parcel$interopDefault($1i38n$lodash).includes(props.labelFields, "model.taxon_name")
                },
                {
                    id: 2,
                    text: "Gene name",
                    field: "model.gene_display_label",
                    checked: $parcel$interopDefault($1i38n$lodash).includes(props.labelFields, "model.gene_display_label")
                },
                {
                    id: 3,
                    text: "Gene ID",
                    field: "model.gene_stable_id",
                    checked: $parcel$interopDefault($1i38n$lodash).includes(props.labelFields, "model.gene_stable_id")
                },
                {
                    id: 4,
                    text: "Protein ID",
                    field: "model.protein_stable_id",
                    checked: $parcel$interopDefault($1i38n$lodash).includes(props.labelFields, "model.protein_stable_id")
                }
            ]
        };
    }
    componentDidUpdate(prevProps, prevState) {
        const x = this.state.labels.filter((l)=>l.checked).map((l)=>l.field);
        const y = prevState.labels.filter((l)=>l.checked).map((l)=>l.field);
        if (!$parcel$interopDefault($1i38n$lodash).isEqual(x, y)) this.props.updateLabelFields(x);
    }
    moveLabel(dragIndex, hoverIndex) {
        const { labels: labels } = this.state;
        const dragLabel = labels[dragIndex];
        this.setState($parcel$interopDefault($1i38n$immutabilityhelper)(this.state, {
            labels: {
                $splice: [
                    [
                        dragIndex,
                        1
                    ],
                    [
                        hoverIndex,
                        0,
                        dragLabel
                    ]
                ]
            }
        }));
    }
    toggleLabel(index) {
        let labels = $parcel$interopDefault($1i38n$lodash).cloneDeep(this.state.labels);
        let label = labels[index];
        label.checked = !label.checked;
        this.setState({
            labels: labels
        });
    }
    render() {
        const { labels: labels } = this.state;
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("div", {
            style: $4c161799644cf022$var$style,
            children: [
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("p", {
                    children: "drag to reorder"
                }),
                labels.map((label, i)=>/*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($48bcb93d056f01ef$export$2e2bcd8739ae039, {
                        index: i,
                        id: label.id,
                        checked: label.checked,
                        text: label.text,
                        moveLabel: this.moveLabel,
                        toggleLabel: this.toggleLabel.bind(this)
                    }, label.id))
            ]
        });
    }
}
$4c161799644cf022$var$LabelConfig.propTypes = {
    labelFields: $parcel$interopDefault($1i38n$proptypes).array.isRequired,
    updateLabelFields: $parcel$interopDefault($1i38n$proptypes).func.isRequired
};
var $4c161799644cf022$export$2e2bcd8739ae039 = $parcel$interopDefault($1i38n$lodashflow)((0, $1i38n$reactdnd.DragDropContext)($parcel$interopDefault($1i38n$reactdndhtml5backend)))($4c161799644cf022$var$LabelConfig);
let $d92d39518efdc8e9$var$pruneTree = $parcel$interopDefault($1i38n$gramenetreesclient).extensions.pruneTree;
let $d92d39518efdc8e9$var$addConsensus = $parcel$interopDefault($1i38n$gramenetreesclient).extensions.addConsensus;
const $d92d39518efdc8e9$var$DEFAULT_MARGIN = 20;
const $d92d39518efdc8e9$var$DEFAULT_ZOOM_HEIGHT = 20;
const $d92d39518efdc8e9$var$DEFAULT_LABEL_WIDTH = 200;
const $d92d39518efdc8e9$var$CURATION_WIDTH = 200;
const $d92d39518efdc8e9$var$MIN_TREE_WIDTH = 50;
const $d92d39518efdc8e9$var$MAX_TREE_WIDTH = 200;
const $d92d39518efdc8e9$var$MIN_VIZ_WIDTH = 150;
const $d92d39518efdc8e9$var$windowResizeDebounceMs = 250;
const $d92d39518efdc8e9$var$rangeChangeDebounceMs = 150;
const $d92d39518efdc8e9$var$localStore = $parcel$global.localStorage || {};
function $d92d39518efdc8e9$var$getLabelFields() {
    let labelFields = $d92d39518efdc8e9$var$localStore.getItem("genetreeLeafLabels");
    if (labelFields) return JSON.parse(labelFields);
    else return [
        "model.gene_stable_id"
    ];
}
class $d92d39518efdc8e9$var$TreeVis extends $parcel$interopDefault($1i38n$react).Component {
    constructor(props){
        super(props);
        this.state = {
            geneOfInterest: this.props.initialGeneOfInterest,
            displayMode: "domains",
            visibleNodes: undefined,
            colorScheme: "clustal",
            configModal: false,
            labelFields: $d92d39518efdc8e9$var$getLabelFields(),
            MSARange: {
                MSAStart: 0,
                MSAStop: 0
            }
        };
        this.displayModes = [
            {
                id: "domains",
                label: "Alignment overview",
                description: "Proteins color-coded by InterPro domain. Resize slider to navigate.",
                getComponent: function(app) {
                    if (app.geneTreeRoot && app.state.visibleNodes && app.vizWidth && app.domainStats) return $parcel$interopDefault($1i38n$react).createElement($2dbe1a8664116125$export$2e2bcd8739ae039, {
                        nodes: app.state.visibleNodes,
                        rootNode: app.geneTreeRoot,
                        width: app.vizWidth,
                        height: app.treeHeight,
                        margin: app.margin,
                        xOffset: app.margin + app.treeWidth + app.labelWidth,
                        yOffset: 0,
                        controlsHeight: $d92d39518efdc8e9$var$DEFAULT_ZOOM_HEIGHT,
                        stats: app.domainStats,
                        MSARange: app.state.MSARange,
                        handleRangeChange: $parcel$interopDefault($1i38n$lodash).debounce(app.updateMSARange.bind(app), $d92d39518efdc8e9$var$rangeChangeDebounceMs),
                        transform: app.transformViz
                    });
                }
            },
            {
                id: "msa",
                label: "Multiple Sequence Alignment",
                description: "Amino acid MSA. Drag slider to reposition.",
                getComponent: function(app) {
                    if (app.geneTreeRoot && app.state.visibleNodes && app.vizWidth && app.domainStats) return $parcel$interopDefault($1i38n$react).createElement($3a89ac38d37e6c49$export$2e2bcd8739ae039, {
                        nodes: app.state.visibleNodes,
                        rootNode: app.geneTreeRoot,
                        width: app.vizWidth,
                        height: app.treeHeight,
                        margin: app.margin,
                        xOffset: app.margin + app.treeWidth + app.labelWidth,
                        yOffset: 0,
                        controlsHeight: $d92d39518efdc8e9$var$DEFAULT_ZOOM_HEIGHT,
                        stats: app.domainStats,
                        colorScheme: app.state.colorScheme,
                        MSARange: app.state.MSARange,
                        handleRangeChange: $parcel$interopDefault($1i38n$lodash).debounce(app.updateMSARange.bind(app), $d92d39518efdc8e9$var$rangeChangeDebounceMs),
                        transform: app.transformViz
                    });
                }
            }
        ];
        if (this.props.enablePhyloview) this.displayModes.push({
            id: "phyloview",
            label: "Neighborhood conservation",
            description: "+/- 10 genes flanking the gene of interest (top row) are color-coded by gene family. Gray genes are from other families. Central genes (green) are shaded based on similarity with gene of interest.",
            getComponent: function(app) {
                if (app.state.visibleNodes && app.state.neighborhoods && app.vizWidth) return $parcel$interopDefault($1i38n$react).createElement($86f31c7466377268$export$2e2bcd8739ae039, {
                    nodes: app.state.visibleNodes,
                    queryNode: app.genetree.indices.gene_stable_id[app.state.geneOfInterest._id],
                    width: app.vizWidth,
                    height: app.treeHeight,
                    margin: app.margin,
                    xOffset: app.margin + app.treeWidth + app.labelWidth,
                    yOffset: 0,
                    controlsHeight: $d92d39518efdc8e9$var$DEFAULT_ZOOM_HEIGHT,
                    neighborhoods: app.state.neighborhoods,
                    maxNCGGenes: app.state.nonCodingGroupLengthDistribution.length - 1,
                    numberOfNeighbors: app.props.numberOfNeighbors,
                    transform: app.transformViz,
                    ensemblUrl: app.props.ensemblUrl
                });
            }
        });
        this.displayModeIdx = $parcel$interopDefault($1i38n$lodash).keyBy(this.displayModes, "id");
    }
    updateMSARange(MSARange) {
        this.setState(MSARange);
    }
    componentDidMount() {
        this.resizeListener = $parcel$interopDefault($1i38n$lodash).debounce(this.updateAvailableWidth.bind(this), $d92d39518efdc8e9$var$windowResizeDebounceMs);
        if (!$parcel$interopDefault($1i38n$lodash).isUndefined($parcel$global.addEventListener)) $parcel$global.addEventListener("resize", this.resizeListener);
        this.domainStats = $aed637ffd5f869a8$export$2e2bcd8739ae039(this.props.genetree); // TODO: use a promise and a web worker
        if (!$parcel$interopDefault($1i38n$lodash).isEmpty(this.props.genomesOfInterest)) {
            this.genetree = $d92d39518efdc8e9$var$pruneTree(this.props.genetree, (function(node) {
                return this.props.genomesOfInterest.hasOwnProperty(node.model.taxon_id);
            }).bind(this));
            this.genetree.geneCount = this.props.genetree.geneCount;
        } else this.genetree = $parcel$interopDefault($1i38n$lodash).cloneDeep(this.props.genetree);
        $f295311ee73679ba$export$e2f5f157c8e85aef(this.genetree);
        $d92d39518efdc8e9$var$addConsensus(this.genetree); // TODO: use a promise
        $8c542044289fc59b$export$2e2bcd8739ae039(this.genetree, this.props.initialGeneOfInterest, this.props.taxonomy, this.props.pivotTree);
        if (this.props.enableCuration) {
            $f295311ee73679ba$export$6ec9a7cb49676029(this.genetree, this.props.initialGeneOfInterest, false);
            let curatable = this.props.curatable;
            const goi_tax = this.props.initialGeneOfInterest.taxon_id;
            this.genetree.walk(function(node) {
                if (curatable.hasOwnProperty("all") && node.model.cigar || curatable.hasOwnProperty(node.model.taxon_id)) {
                    let parentNode = node.parent;
                    while(!parentNode.displayInfo.expanded){
                        parentNode.displayInfo.expanded = true;
                        parentNode.displayInfo.expandedCuratable = true;
                        parentNode = parentNode.parent;
                    }
                }
            });
        } else $f295311ee73679ba$export$6ec9a7cb49676029(this.genetree, this.props.initialGeneOfInterest, true);
        $f295311ee73679ba$export$cbecd1a31826c595(this.genetree);
        this.treeHeight = $f7e47e6ef7e802bb$export$2e2bcd8739ae039(this.genetree);
        this.geneTreeRoot = $parcel$interopDefault($1i38n$lodash).clone(this.genetree);
        delete this.geneTreeRoot.displayInfo;
        this.geneTreeRoot.displayInfo = {
            expanded: false
        };
        let MSARange = this.state.MSARange;
        MSARange.MSAStop = this.geneTreeRoot.model.consensus.sequence.length;
        this.setState(MSARange);
        $f295311ee73679ba$export$cbecd1a31826c595(this.geneTreeRoot);
        $1ec57391cf50db74$export$2e2bcd8739ae039(this.geneTreeRoot, 0, this.treeHeight);
        //let ma = alignmentTools.calculateAlignment(this.genetree);
        //if (!_.isEmpty(this.props.genomesOfInterest)) {
        //  let gaps = alignmentTools.findGaps(ma);
        //  alignmentTools.removeGaps(gaps, this.genetree);
        //}
        this.domainHist = $5ac4cd4b588bde41$export$2e2bcd8739ae039(this.genetree, true);
        if (this.props.enablePhyloview) {
            let that = this;
            $bc2bf29db86f3503$export$2e2bcd8739ae039(this.genetree, this.props.numberOfNeighbors, this.props.genomesOfInterest).then(function(neighborhoodsAndFacets) {
                that.setState(neighborhoodsAndFacets);
            });
        }
        this.updateAvailableWidth();
    }
    componentWillUnmount() {
        if (this.resizeListener) $parcel$global.removeEventListener("resize", this.resizeListener);
    }
    updateAvailableWidth() {
        const DOMNode = $parcel$interopDefault($1i38n$reactdom).findDOMNode(this);
        const parentWidth = DOMNode.parentNode ? DOMNode.parentNode.clientWidth : DOMNode.clientWidth;
        if (this.width !== parentWidth) {
            this.width = parentWidth;
            this.initHeightAndMargin();
            this.setState({
                visibleNodes: $1ec57391cf50db74$export$2e2bcd8739ae039(this.genetree, this.treeWidth, this.treeHeight)
            });
        }
    }
    initHeightAndMargin() {
        this.margin = this.props.margin || $d92d39518efdc8e9$var$DEFAULT_MARGIN;
        this.labelWidth = this.props.labelWidth || $d92d39518efdc8e9$var$DEFAULT_LABEL_WIDTH;
        const w = this.width - this.labelWidth - 2 * this.margin;
        this.treeWidth = .25 * w < $d92d39518efdc8e9$var$MIN_TREE_WIDTH ? $d92d39518efdc8e9$var$MIN_TREE_WIDTH : Math.floor(.25 * w);
        if (this.treeWidth > $d92d39518efdc8e9$var$MAX_TREE_WIDTH) this.treeWidth = $d92d39518efdc8e9$var$MAX_TREE_WIDTH;
        this.vizWidth = w - this.treeWidth < $d92d39518efdc8e9$var$MIN_VIZ_WIDTH ? $d92d39518efdc8e9$var$MIN_VIZ_WIDTH : w - this.treeWidth;
        if (this.treeWidth + this.vizWidth + this.labelWidth + 2 * this.margin > this.width) {
            console.log("Is this too small to see everything?");
            this.width = this.treeWidth + this.vizWidth + this.labelWidth + 2 * this.margin;
        }
        if (this.props.enableCuration) this.vizWidth -= $d92d39518efdc8e9$var$CURATION_WIDTH;
        this.transformTree = `translate(${this.margin},${this.margin + $d92d39518efdc8e9$var$DEFAULT_ZOOM_HEIGHT})`;
        this.transformViz = `translate(${this.margin + this.treeWidth + this.labelWidth},0)`;
    }
    handleGeneSelect(geneNode) {
        (0, $1i38n$gramenesearchclient.client).genes(geneNode.model.gene_stable_id).then((function(response) {
            let geneOfInterest = response.docs[0];
            $8c542044289fc59b$export$2e2bcd8739ae039(this.genetree, geneOfInterest, this.props.taxonomy, this.props.pivotTree);
            $f295311ee73679ba$export$6ec9a7cb49676029(this.genetree, geneOfInterest, true);
            $f295311ee73679ba$export$cbecd1a31826c595(this.genetree);
            this.treeHeight = $f7e47e6ef7e802bb$export$2e2bcd8739ae039(this.genetree);
            let visibleNodes = $1ec57391cf50db74$export$2e2bcd8739ae039(this.genetree, this.treeWidth, this.treeHeight);
            this.setState({
                geneOfInterest: geneOfInterest,
                visibleNodes: visibleNodes
            });
        }).bind(this));
    }
    expandClade(node, recursive) {
        if (recursive) $f295311ee73679ba$export$d865796a5b4a7f49(node);
        else $f295311ee73679ba$export$8b60bd6775d46208(node);
        this.updateVisibleNodes();
    }
    collapseClade(node, recursive) {
        if (recursive) $f295311ee73679ba$export$5be4099be9306efa(node);
        else $f295311ee73679ba$export$3e625f118b045824(node);
        this.updateVisibleNodes();
    }
    updateVisibleNodes() {
        $f295311ee73679ba$export$cbecd1a31826c595(this.genetree);
        this.treeHeight = $f7e47e6ef7e802bb$export$2e2bcd8739ae039(this.genetree);
        const newVisibleNodes = $1ec57391cf50db74$export$2e2bcd8739ae039(this.genetree, this.treeWidth, this.treeHeight);
        this.setState({
            visibleNodes: newVisibleNodes
        });
    }
    handleNodeUnhover(node) {
        if (this.state.hoveredNode === node) this.setState({
            hoveredNode: undefined
        });
    }
    handleNodeHover(node) {
        this.setState({
            hoveredNode: node
        });
    }
    changeParalogVisibility(node) {
        if (node.displayInfo.paralogs) {
            if (node.displayInfo.expandedParalogs) node.displayInfo.paralogs.forEach(function(paralog) {
                let parentNode = paralog.parent;
                const childCallback = (child)=>{
                    if (child.displayInfo.expanded) parentNode.displayInfo.expanded = true;
                };
                while(parentNode !== node){
                    parentNode.displayInfo.expandedParalogs = false;
                    // check if any child is expanded
                    parentNode.displayInfo.expanded = false;
                    parentNode.children.forEach(childCallback);
                    parentNode = parentNode.parent;
                }
            });
            else node.displayInfo.paralogs.forEach(function(paralog) {
                let parentNode = paralog.parent;
                while(!parentNode.displayInfo.expanded){
                    parentNode.displayInfo.expanded = true;
                    parentNode.displayInfo.expandedParalogs = true;
                    parentNode = parentNode.parent;
                }
            });
            this.updateVisibleNodes();
        }
    }
    toggleConfigModal() {
        this.setState({
            configModal: !this.state.configModal
        });
    }
    handleModeSelection(e) {
        this.setState({
            displayMode: e
        });
    }
    colorSchemeDropdown() {
        // if (this.state.displayMode === 'msa') {
        function toTitleCase(str) {
            return str.replace(/\w\S*/g, function(txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        }
        const colorSchemes = [
            "clustal",
            "zappo",
            "taylor",
            "hydrophobicity",
            "helix_propensity",
            "strand_propensity",
            "turn_propensity",
            "buried_index"
        ];
        let items = colorSchemes.map((function(scheme, i) {
            return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($1i38n$reactbootstrap.Dropdown.Item, {
                eventKey: i,
                active: scheme === this.state.colorScheme,
                onClick: ()=>this.setState({
                        colorScheme: scheme
                    }),
                children: toTitleCase(scheme.replace("_", " "))
            }, i);
        }).bind(this));
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($1i38n$reactbootstrap.DropdownButton, {
            id: "colorscheme-dropdown",
            title: "Color Scheme",
            disabled: this.state.displayMode !== "msa",
            variant: "outline-dark",
            size: "sm",
            children: items
        });
    // }
    }
    renderToolbar(activeMode) {
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("div", {
            className: "display-mode",
            children: [
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)($1i38n$reactbootstrap.ButtonToolbar, {
                    children: [
                        /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($1i38n$reactbootstrap.Button, {
                            onClick: ()=>this.toggleConfigModal(),
                            variant: "light",
                            size: "sm",
                            children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($1i38n$reacticonsbs.BsGearFill, {})
                        }),
                        /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($1i38n$reactbootstrap.DropdownButton, {
                            id: "displaymode-dropdown",
                            title: "Display Mode",
                            variant: "outline-dark",
                            size: "sm",
                            children: this.displayModes.map((mode, idx)=>{
                                return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($1i38n$reactbootstrap.Dropdown.Item, {
                                    eventKey: mode.id,
                                    active: activeMode === mode.id,
                                    onClick: ()=>this.setState({
                                            displayMode: mode.id
                                        }),
                                    children: mode.label
                                }, idx);
                            })
                        }),
                        this.colorSchemeDropdown()
                    ]
                }),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("span", {
                    style: {
                        "marginLeft": `${this.margin + this.treeWidth + this.labelWidth}px`,
                        float: "left"
                    },
                    children: [
                        /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("b", {
                            children: [
                                this.displayModeIdx[activeMode].label,
                                ": "
                            ]
                        }),
                        this.displayModeIdx[activeMode].description
                    ]
                }),
                this.props.enableCuration && /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("div", {
                    style: {
                        position: "absolute",
                        left: `${this.margin + this.treeWidth + this.labelWidth + this.vizWidth}px`
                    },
                    children: [
                        /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("b", {
                            children: "Curate"
                        }),
                        ": click to flag genes",
                        /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("div", {
                            children: [
                                "\xa0",
                                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("span", {
                                    className: "curation okay",
                                    children: "okay"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("span", {
                                    className: "curation unclear",
                                    children: "flag"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    updateLabelConfig(labelFields) {
        if (!$parcel$interopDefault($1i38n$lodash).isEqual(labelFields, this.state.labelFields)) {
            $d92d39518efdc8e9$var$localStore.setItem("genetreeLeafLabels", JSON.stringify(labelFields));
            this.setState({
                labelFields: labelFields
            });
        }
    }
    render() {
        if (!(this.state.visibleNodes && this.state.geneDocs)) return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("div", {});
        let genetree = /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($42eda629c119b935$export$2e2bcd8739ae039, {
            nodes: this.state.visibleNodes,
            labelFields: this.state.labelFields,
            onGeneSelect: this.handleGeneSelect.bind(this),
            collapseClade: this.collapseClade.bind(this),
            expandClade: this.expandClade.bind(this),
            changeParalogVisibility: this.changeParalogVisibility.bind(this),
            onNodeHover: this.handleNodeHover,
            onNodeUnhover: this.handleNodeUnhover,
            taxonomy: this.props.taxonomy,
            geneDocs: this.state.geneDocs
        });
        let theViz = this.displayModeIdx[this.state.displayMode].getComponent(this);
        if (!theViz) theViz = $parcel$interopDefault($1i38n$react).createElement($1f9b52c72af6ed55$export$2e2bcd8739ae039, {
            xOffset: this.margin + this.treeWidth + this.labelWidth + this.vizWidth / 2 - 200,
            yOffset: this.treeHeight / 2
        });
        let curation;
        if (this.props.enableCuration) curation = /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($d4db98f04dcc88a8$export$2e2bcd8739ae039, {
            nodes: this.state.visibleNodes,
            width: $d92d39518efdc8e9$var$CURATION_WIDTH,
            height: $d92d39518efdc8e9$var$DEFAULT_ZOOM_HEIGHT,
            curatable: this.props.curatable,
            xOffset: this.margin + this.treeWidth + this.labelWidth + this.vizWidth,
            yOffset: $d92d39518efdc8e9$var$DEFAULT_ZOOM_HEIGHT + this.margin - 10,
            getCuration: this.props.getCuration
        });
        return /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("div", {
            children: [
                this.renderToolbar(this.state.displayMode),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)($1i38n$reactbootstrap.Modal, {
                    show: this.state.configModal,
                    onHide: this.toggleConfigModal.bind(this),
                    size: "lg",
                    children: [
                        /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($1i38n$reactbootstrap.Modal.Header, {
                            closeButton: true,
                            children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($1i38n$reactbootstrap.Modal.Title, {
                                children: "Configure labels"
                            })
                        }),
                        /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($1i38n$reactbootstrap.Modal.Body, {
                            children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)($4c161799644cf022$export$2e2bcd8739ae039, {
                                labelFields: this.state.labelFields,
                                updateLabelFields: (l)=>this.updateLabelConfig(l)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("div", {
                    className: "genetree-vis",
                    children: /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsxs)("svg", {
                        width: this.width,
                        height: this.treeHeight + 2 * this.margin + $d92d39518efdc8e9$var$DEFAULT_ZOOM_HEIGHT,
                        children: [
                            /*#__PURE__*/ (0, $1i38n$reactjsxruntime.jsx)("g", {
                                className: "tree-wrapper",
                                transform: this.transformTree,
                                children: genetree
                            }),
                            theViz,
                            curation
                        ]
                    })
                })
            ]
        });
    }
}
$d92d39518efdc8e9$var$TreeVis.propTypes = {
    margin: $parcel$interopDefault($1i38n$proptypes).number,
    genetree: $parcel$interopDefault($1i38n$proptypes).object.isRequired,
    initialGeneOfInterest: $parcel$interopDefault($1i38n$proptypes).object,
    genomesOfInterest: $parcel$interopDefault($1i38n$proptypes).object,
    taxonomy: $parcel$interopDefault($1i38n$proptypes).object,
    pivotTree: $parcel$interopDefault($1i38n$proptypes).bool,
    numberOfNeighbors: $parcel$interopDefault($1i38n$proptypes).number,
    enablePhyloview: $parcel$interopDefault($1i38n$proptypes).bool,
    ensemblUrl: $parcel$interopDefault($1i38n$proptypes).string.isRequired
};
var $d92d39518efdc8e9$export$2e2bcd8739ae039 = $d92d39518efdc8e9$var$TreeVis;

},{"9881da4c2fe51e9a":"lM41P","341aa39c7cadebd3":"gonF6","29d511aaa59e31be":"bmhQu","96b0d348d39357ae":"82aNB","cb1138627157d51b":"gLXGb","2999f0927c8291af":"L2GyB","d3e3c1c006af899a":"aIXvU","655840fac3bf0776":"hlIfA","c475fe4917fff41c":"jBmZO","13b037afc9bde3e":"fL51W","cd2bb1545c4c36ff":"9WwLb","e7fcd00d2d5a80a1":"8RVhR","f433f47a06ab0a4b":"3K3zG","51079fc2f5df0d53":"9Yt0x","70e01aefa94f24e9":"8zfX3","fc62f927d356b9b7":"iWYSC","f061b16d8f9acad8":"kZZiZ","81c0fa9203e105e0":"1w5VY","bc99aa7eb443d898":"jhVSh","b0b41c1a3386c268":"3DWzf"}],"lM41P":[function() {},{}],"9WwLb":[function() {},{}],"8RVhR":[function(require,module,exports,__globalThis) {
/*!
 * Platform.js v1.3.6
 * Copyright 2014-2020 Benjamin Tan
 * Copyright 2011-2013 John-David Dalton
 * Available under MIT license
 */ var global = arguments[3];
(function() {
    'use strict';
    /** Used to determine if values are of the language type `Object`. */ var objectTypes = {
        'function': true,
        'object': true
    };
    /** Used as a reference to the global object. */ var root = objectTypes[typeof window] && window || this;
    /** Backup possible global object. */ var oldRoot = root;
    /** Detect free variable `exports`. */ var freeExports = objectTypes["object"] && exports;
    /** Detect free variable `module`. */ var freeModule = objectTypes["object"] && module && !module.nodeType && module;
    /** Detect free variable `global` from Node.js or Browserified code and use it as `root`. */ var freeGlobal = freeExports && freeModule && typeof global == 'object' && global;
    if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) root = freeGlobal;
    /**
   * Used as the maximum length of an array-like object.
   * See the [ES6 spec](http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength)
   * for more details.
   */ var maxSafeInteger = Math.pow(2, 53) - 1;
    /** Regular expression to detect Opera. */ var reOpera = /\bOpera/;
    /** Possible global object. */ var thisBinding = this;
    /** Used for native method references. */ var objectProto = Object.prototype;
    /** Used to check for own properties of an object. */ var hasOwnProperty = objectProto.hasOwnProperty;
    /** Used to resolve the internal `[[Class]]` of values. */ var toString = objectProto.toString;
    /*--------------------------------------------------------------------------*/ /**
   * Capitalizes a string value.
   *
   * @private
   * @param {string} string The string to capitalize.
   * @returns {string} The capitalized string.
   */ function capitalize(string) {
        string = String(string);
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    /**
   * A utility function to clean up the OS name.
   *
   * @private
   * @param {string} os The OS name to clean up.
   * @param {string} [pattern] A `RegExp` pattern matching the OS name.
   * @param {string} [label] A label for the OS.
   */ function cleanupOS(os, pattern, label) {
        // Platform tokens are defined at:
        // http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
        // http://web.archive.org/web/20081122053950/http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
        var data = {
            '10.0': '10',
            '6.4': '10 Technical Preview',
            '6.3': '8.1',
            '6.2': '8',
            '6.1': 'Server 2008 R2 / 7',
            '6.0': 'Server 2008 / Vista',
            '5.2': 'Server 2003 / XP 64-bit',
            '5.1': 'XP',
            '5.01': '2000 SP1',
            '5.0': '2000',
            '4.0': 'NT',
            '4.90': 'ME'
        };
        // Detect Windows version from platform tokens.
        if (pattern && label && /^Win/i.test(os) && !/^Windows Phone /i.test(os) && (data = data[/[\d.]+$/.exec(os)])) os = 'Windows ' + data;
        // Correct character case and cleanup string.
        os = String(os);
        if (pattern && label) os = os.replace(RegExp(pattern, 'i'), label);
        os = format(os.replace(/ ce$/i, ' CE').replace(/\bhpw/i, 'web').replace(/\bMacintosh\b/, 'Mac OS').replace(/_PowerPC\b/i, ' OS').replace(/\b(OS X) [^ \d]+/i, '$1').replace(/\bMac (OS X)\b/, '$1').replace(/\/(\d)/, ' $1').replace(/_/g, '.').replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, '').replace(/\bx86\.64\b/gi, 'x86_64').replace(/\b(Windows Phone) OS\b/, '$1').replace(/\b(Chrome OS \w+) [\d.]+\b/, '$1').split(' on ')[0]);
        return os;
    }
    /**
   * An iteration utility for arrays and objects.
   *
   * @private
   * @param {Array|Object} object The object to iterate over.
   * @param {Function} callback The function called per iteration.
   */ function each(object, callback) {
        var index = -1, length = object ? object.length : 0;
        if (typeof length == 'number' && length > -1 && length <= maxSafeInteger) while(++index < length)callback(object[index], index, object);
        else forOwn(object, callback);
    }
    /**
   * Trim and conditionally capitalize string values.
   *
   * @private
   * @param {string} string The string to format.
   * @returns {string} The formatted string.
   */ function format(string) {
        string = trim(string);
        return /^(?:webOS|i(?:OS|P))/.test(string) ? string : capitalize(string);
    }
    /**
   * Iterates over an object's own properties, executing the `callback` for each.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} callback The function executed per own property.
   */ function forOwn(object, callback) {
        for(var key in object)if (hasOwnProperty.call(object, key)) callback(object[key], key, object);
    }
    /**
   * Gets the internal `[[Class]]` of a value.
   *
   * @private
   * @param {*} value The value.
   * @returns {string} The `[[Class]]`.
   */ function getClassOf(value) {
        return value == null ? capitalize(value) : toString.call(value).slice(8, -1);
    }
    /**
   * Host objects can return type values that are different from their actual
   * data type. The objects we are concerned with usually return non-primitive
   * types of "object", "function", or "unknown".
   *
   * @private
   * @param {*} object The owner of the property.
   * @param {string} property The property to check.
   * @returns {boolean} Returns `true` if the property value is a non-primitive, else `false`.
   */ function isHostType(object, property) {
        var type = object != null ? typeof object[property] : 'number';
        return !/^(?:boolean|number|string|undefined)$/.test(type) && (type == 'object' ? !!object[property] : true);
    }
    /**
   * Prepares a string for use in a `RegExp` by making hyphens and spaces optional.
   *
   * @private
   * @param {string} string The string to qualify.
   * @returns {string} The qualified string.
   */ function qualify(string) {
        return String(string).replace(/([ -])(?!$)/g, '$1?');
    }
    /**
   * A bare-bones `Array#reduce` like utility function.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} callback The function called per iteration.
   * @returns {*} The accumulated result.
   */ function reduce(array, callback) {
        var accumulator = null;
        each(array, function(value, index) {
            accumulator = callback(accumulator, value, index, array);
        });
        return accumulator;
    }
    /**
   * Removes leading and trailing whitespace from a string.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} The trimmed string.
   */ function trim(string) {
        return String(string).replace(/^ +| +$/g, '');
    }
    /*--------------------------------------------------------------------------*/ /**
   * Creates a new platform object.
   *
   * @memberOf platform
   * @param {Object|string} [ua=navigator.userAgent] The user agent string or
   *  context object.
   * @returns {Object} A platform object.
   */ function parse(ua) {
        /** The environment context object. */ var context = root;
        /** Used to flag when a custom context is provided. */ var isCustomContext = ua && typeof ua == 'object' && getClassOf(ua) != 'String';
        // Juggle arguments.
        if (isCustomContext) {
            context = ua;
            ua = null;
        }
        /** Browser navigator object. */ var nav = context.navigator || {};
        /** Browser user agent string. */ var userAgent = nav.userAgent || '';
        ua || (ua = userAgent);
        /** Used to flag when `thisBinding` is the [ModuleScope]. */ var isModuleScope = isCustomContext || thisBinding == oldRoot;
        /** Used to detect if browser is like Chrome. */ var likeChrome = isCustomContext ? !!nav.likeChrome : /\bChrome\b/.test(ua) && !/internal|\n/i.test(toString.toString());
        /** Internal `[[Class]]` value shortcuts. */ var objectClass = 'Object', airRuntimeClass = isCustomContext ? objectClass : 'ScriptBridgingProxyObject', enviroClass = isCustomContext ? objectClass : 'Environment', javaClass = isCustomContext && context.java ? 'JavaPackage' : getClassOf(context.java), phantomClass = isCustomContext ? objectClass : 'RuntimeObject';
        /** Detect Java environments. */ var java = /\bJava/.test(javaClass) && context.java;
        /** Detect Rhino. */ var rhino = java && getClassOf(context.environment) == enviroClass;
        /** A character to represent alpha. */ var alpha = java ? 'a' : '\u03b1';
        /** A character to represent beta. */ var beta = java ? 'b' : '\u03b2';
        /** Browser document object. */ var doc = context.document || {};
        /**
     * Detect Opera browser (Presto-based).
     * http://www.howtocreate.co.uk/operaStuff/operaObject.html
     * http://dev.opera.com/articles/view/opera-mini-web-content-authoring-guidelines/#operamini
     */ var opera = context.operamini || context.opera;
        /** Opera `[[Class]]`. */ var operaClass = reOpera.test(operaClass = isCustomContext && opera ? opera['[[Class]]'] : getClassOf(opera)) ? operaClass : opera = null;
        /*------------------------------------------------------------------------*/ /** Temporary variable used over the script's lifetime. */ var data;
        /** The CPU architecture. */ var arch = ua;
        /** Platform description array. */ var description = [];
        /** Platform alpha/beta indicator. */ var prerelease = null;
        /** A flag to indicate that environment features should be used to resolve the platform. */ var useFeatures = ua == userAgent;
        /** The browser/environment version. */ var version = useFeatures && opera && typeof opera.version == 'function' && opera.version();
        /** A flag to indicate if the OS ends with "/ Version" */ var isSpecialCasedOS;
        /* Detectable layout engines (order is important). */ var layout = getLayout([
            {
                'label': 'EdgeHTML',
                'pattern': 'Edge'
            },
            'Trident',
            {
                'label': 'WebKit',
                'pattern': 'AppleWebKit'
            },
            'iCab',
            'Presto',
            'NetFront',
            'Tasman',
            'KHTML',
            'Gecko'
        ]);
        /* Detectable browser names (order is important). */ var name = getName([
            'Adobe AIR',
            'Arora',
            'Avant Browser',
            'Breach',
            'Camino',
            'Electron',
            'Epiphany',
            'Fennec',
            'Flock',
            'Galeon',
            'GreenBrowser',
            'iCab',
            'Iceweasel',
            'K-Meleon',
            'Konqueror',
            'Lunascape',
            'Maxthon',
            {
                'label': 'Microsoft Edge',
                'pattern': '(?:Edge|Edg|EdgA|EdgiOS)'
            },
            'Midori',
            'Nook Browser',
            'PaleMoon',
            'PhantomJS',
            'Raven',
            'Rekonq',
            'RockMelt',
            {
                'label': 'Samsung Internet',
                'pattern': 'SamsungBrowser'
            },
            'SeaMonkey',
            {
                'label': 'Silk',
                'pattern': '(?:Cloud9|Silk-Accelerated)'
            },
            'Sleipnir',
            'SlimBrowser',
            {
                'label': 'SRWare Iron',
                'pattern': 'Iron'
            },
            'Sunrise',
            'Swiftfox',
            'Vivaldi',
            'Waterfox',
            'WebPositive',
            {
                'label': 'Yandex Browser',
                'pattern': 'YaBrowser'
            },
            {
                'label': 'UC Browser',
                'pattern': 'UCBrowser'
            },
            'Opera Mini',
            {
                'label': 'Opera Mini',
                'pattern': 'OPiOS'
            },
            'Opera',
            {
                'label': 'Opera',
                'pattern': 'OPR'
            },
            'Chromium',
            'Chrome',
            {
                'label': 'Chrome',
                'pattern': '(?:HeadlessChrome)'
            },
            {
                'label': 'Chrome Mobile',
                'pattern': '(?:CriOS|CrMo)'
            },
            {
                'label': 'Firefox',
                'pattern': '(?:Firefox|Minefield)'
            },
            {
                'label': 'Firefox for iOS',
                'pattern': 'FxiOS'
            },
            {
                'label': 'IE',
                'pattern': 'IEMobile'
            },
            {
                'label': 'IE',
                'pattern': 'MSIE'
            },
            'Safari'
        ]);
        /* Detectable products (order is important). */ var product = getProduct([
            {
                'label': 'BlackBerry',
                'pattern': 'BB10'
            },
            'BlackBerry',
            {
                'label': 'Galaxy S',
                'pattern': 'GT-I9000'
            },
            {
                'label': 'Galaxy S2',
                'pattern': 'GT-I9100'
            },
            {
                'label': 'Galaxy S3',
                'pattern': 'GT-I9300'
            },
            {
                'label': 'Galaxy S4',
                'pattern': 'GT-I9500'
            },
            {
                'label': 'Galaxy S5',
                'pattern': 'SM-G900'
            },
            {
                'label': 'Galaxy S6',
                'pattern': 'SM-G920'
            },
            {
                'label': 'Galaxy S6 Edge',
                'pattern': 'SM-G925'
            },
            {
                'label': 'Galaxy S7',
                'pattern': 'SM-G930'
            },
            {
                'label': 'Galaxy S7 Edge',
                'pattern': 'SM-G935'
            },
            'Google TV',
            'Lumia',
            'iPad',
            'iPod',
            'iPhone',
            'Kindle',
            {
                'label': 'Kindle Fire',
                'pattern': '(?:Cloud9|Silk-Accelerated)'
            },
            'Nexus',
            'Nook',
            'PlayBook',
            'PlayStation Vita',
            'PlayStation',
            'TouchPad',
            'Transformer',
            {
                'label': 'Wii U',
                'pattern': 'WiiU'
            },
            'Wii',
            'Xbox One',
            {
                'label': 'Xbox 360',
                'pattern': 'Xbox'
            },
            'Xoom'
        ]);
        /* Detectable manufacturers. */ var manufacturer = getManufacturer({
            'Apple': {
                'iPad': 1,
                'iPhone': 1,
                'iPod': 1
            },
            'Alcatel': {},
            'Archos': {},
            'Amazon': {
                'Kindle': 1,
                'Kindle Fire': 1
            },
            'Asus': {
                'Transformer': 1
            },
            'Barnes & Noble': {
                'Nook': 1
            },
            'BlackBerry': {
                'PlayBook': 1
            },
            'Google': {
                'Google TV': 1,
                'Nexus': 1
            },
            'HP': {
                'TouchPad': 1
            },
            'HTC': {},
            'Huawei': {},
            'Lenovo': {},
            'LG': {},
            'Microsoft': {
                'Xbox': 1,
                'Xbox One': 1
            },
            'Motorola': {
                'Xoom': 1
            },
            'Nintendo': {
                'Wii U': 1,
                'Wii': 1
            },
            'Nokia': {
                'Lumia': 1
            },
            'Oppo': {},
            'Samsung': {
                'Galaxy S': 1,
                'Galaxy S2': 1,
                'Galaxy S3': 1,
                'Galaxy S4': 1
            },
            'Sony': {
                'PlayStation': 1,
                'PlayStation Vita': 1
            },
            'Xiaomi': {
                'Mi': 1,
                'Redmi': 1
            }
        });
        /* Detectable operating systems (order is important). */ var os = getOS([
            'Windows Phone',
            'KaiOS',
            'Android',
            'CentOS',
            {
                'label': 'Chrome OS',
                'pattern': 'CrOS'
            },
            'Debian',
            {
                'label': 'DragonFly BSD',
                'pattern': 'DragonFly'
            },
            'Fedora',
            'FreeBSD',
            'Gentoo',
            'Haiku',
            'Kubuntu',
            'Linux Mint',
            'OpenBSD',
            'Red Hat',
            'SuSE',
            'Ubuntu',
            'Xubuntu',
            'Cygwin',
            'Symbian OS',
            'hpwOS',
            'webOS ',
            'webOS',
            'Tablet OS',
            'Tizen',
            'Linux',
            'Mac OS X',
            'Macintosh',
            'Mac',
            'Windows 98;',
            'Windows '
        ]);
        /*------------------------------------------------------------------------*/ /**
     * Picks the layout engine from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected layout engine.
     */ function getLayout(guesses) {
            return reduce(guesses, function(result, guess) {
                return result || RegExp('\\b' + (guess.pattern || qualify(guess)) + '\\b', 'i').exec(ua) && (guess.label || guess);
            });
        }
        /**
     * Picks the manufacturer from an array of guesses.
     *
     * @private
     * @param {Array} guesses An object of guesses.
     * @returns {null|string} The detected manufacturer.
     */ function getManufacturer(guesses) {
            return reduce(guesses, function(result, value, key) {
                // Lookup the manufacturer by product or scan the UA for the manufacturer.
                return result || (value[product] || value[/^[a-z]+(?: +[a-z]+\b)*/i.exec(product)] || RegExp('\\b' + qualify(key) + '(?:\\b|\\w*\\d)', 'i').exec(ua)) && key;
            });
        }
        /**
     * Picks the browser name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected browser name.
     */ function getName(guesses) {
            return reduce(guesses, function(result, guess) {
                return result || RegExp('\\b' + (guess.pattern || qualify(guess)) + '\\b', 'i').exec(ua) && (guess.label || guess);
            });
        }
        /**
     * Picks the OS name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected OS name.
     */ function getOS(guesses) {
            return reduce(guesses, function(result, guess) {
                var pattern = guess.pattern || qualify(guess);
                if (!result && (result = RegExp('\\b' + pattern + '(?:/[\\d.]+|[ \\w.]*)', 'i').exec(ua))) result = cleanupOS(result, pattern, guess.label || guess);
                return result;
            });
        }
        /**
     * Picks the product name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected product name.
     */ function getProduct(guesses) {
            return reduce(guesses, function(result, guess) {
                var pattern = guess.pattern || qualify(guess);
                if (!result && (result = RegExp('\\b' + pattern + ' *\\d+[.\\w_]*', 'i').exec(ua) || RegExp('\\b' + pattern + ' *\\w+-[\\w]*', 'i').exec(ua) || RegExp('\\b' + pattern + '(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)', 'i').exec(ua))) {
                    // Split by forward slash and append product version if needed.
                    if ((result = String(guess.label && !RegExp(pattern, 'i').test(guess.label) ? guess.label : result).split('/'))[1] && !/[\d.]+/.test(result[0])) result[0] += ' ' + result[1];
                    // Correct character case and cleanup string.
                    guess = guess.label || guess;
                    result = format(result[0].replace(RegExp(pattern, 'i'), guess).replace(RegExp('; *(?:' + guess + '[_-])?', 'i'), ' ').replace(RegExp('(' + guess + ')[-_.]?(\\w)', 'i'), '$1 $2'));
                }
                return result;
            });
        }
        /**
     * Resolves the version using an array of UA patterns.
     *
     * @private
     * @param {Array} patterns An array of UA patterns.
     * @returns {null|string} The detected version.
     */ function getVersion(patterns) {
            return reduce(patterns, function(result, pattern) {
                return result || (RegExp(pattern + '(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)', 'i').exec(ua) || 0)[1] || null;
            });
        }
        /**
     * Returns `platform.description` when the platform object is coerced to a string.
     *
     * @name toString
     * @memberOf platform
     * @returns {string} Returns `platform.description` if available, else an empty string.
     */ function toStringPlatform() {
            return this.description || '';
        }
        /*------------------------------------------------------------------------*/ // Convert layout to an array so we can add extra details.
        layout && (layout = [
            layout
        ]);
        // Detect Android products.
        // Browsers on Android devices typically provide their product IDS after "Android;"
        // up to "Build" or ") AppleWebKit".
        // Example:
        // "Mozilla/5.0 (Linux; Android 8.1.0; Moto G (5) Plus) AppleWebKit/537.36
        // (KHTML, like Gecko) Chrome/70.0.3538.80 Mobile Safari/537.36"
        if (/\bAndroid\b/.test(os) && !product && (data = /\bAndroid[^;]*;(.*?)(?:Build|\) AppleWebKit)\b/i.exec(ua))) product = trim(data[1])// Replace any language codes (eg. "en-US").
        .replace(/^[a-z]{2}-[a-z]{2};\s*/i, '') || null;
        // Detect product names that contain their manufacturer's name.
        if (manufacturer && !product) product = getProduct([
            manufacturer
        ]);
        else if (manufacturer && product) product = product.replace(RegExp('^(' + qualify(manufacturer) + ')[-_.\\s]', 'i'), manufacturer + ' ').replace(RegExp('^(' + qualify(manufacturer) + ')[-_.]?(\\w)', 'i'), manufacturer + ' $2');
        // Clean up Google TV.
        if (data = /\bGoogle TV\b/.exec(product)) product = data[0];
        // Detect simulators.
        if (/\bSimulator\b/i.test(ua)) product = (product ? product + ' ' : '') + 'Simulator';
        // Detect Opera Mini 8+ running in Turbo/Uncompressed mode on iOS.
        if (name == 'Opera Mini' && /\bOPiOS\b/.test(ua)) description.push('running in Turbo/Uncompressed mode');
        // Detect IE Mobile 11.
        if (name == 'IE' && /\blike iPhone OS\b/.test(ua)) {
            data = parse(ua.replace(/like iPhone OS/, ''));
            manufacturer = data.manufacturer;
            product = data.product;
        } else if (/^iP/.test(product)) {
            name || (name = 'Safari');
            os = 'iOS' + ((data = / OS ([\d_]+)/i.exec(ua)) ? ' ' + data[1].replace(/_/g, '.') : '');
        } else if (name == 'Konqueror' && /^Linux\b/i.test(os)) os = 'Kubuntu';
        else if (manufacturer && manufacturer != 'Google' && (/Chrome/.test(name) && !/\bMobile Safari\b/i.test(ua) || /\bVita\b/.test(product)) || /\bAndroid\b/.test(os) && /^Chrome/.test(name) && /\bVersion\//i.test(ua)) {
            name = 'Android Browser';
            os = /\bAndroid\b/.test(os) ? os : 'Android';
        } else if (name == 'Silk') {
            if (!/\bMobi/i.test(ua)) {
                os = 'Android';
                description.unshift('desktop mode');
            }
            if (/Accelerated *= *true/i.test(ua)) description.unshift('accelerated');
        } else if (name == 'UC Browser' && /\bUCWEB\b/.test(ua)) description.push('speed mode');
        else if (name == 'PaleMoon' && (data = /\bFirefox\/([\d.]+)\b/.exec(ua))) description.push('identifying as Firefox ' + data[1]);
        else if (name == 'Firefox' && (data = /\b(Mobile|Tablet|TV)\b/i.exec(ua))) {
            os || (os = 'Firefox OS');
            product || (product = data[1]);
        } else if (!name || (data = !/\bMinefield\b/i.test(ua) && /\b(?:Firefox|Safari)\b/.exec(name))) {
            // Escape the `/` for Firefox 1.
            if (name && !product && /[\/,]|^[^(]+?\)/.test(ua.slice(ua.indexOf(data + '/') + 8))) // Clear name of false positives.
            name = null;
            // Reassign a generic name.
            if ((data = product || manufacturer || os) && (product || manufacturer || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(os))) name = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(os) ? os : data) + ' Browser';
        } else if (name == 'Electron' && (data = (/\bChrome\/([\d.]+)\b/.exec(ua) || 0)[1])) description.push('Chromium ' + data);
        // Detect non-Opera (Presto-based) versions (order is important).
        if (!version) version = getVersion([
            '(?:Cloud9|CriOS|CrMo|Edge|Edg|EdgA|EdgiOS|FxiOS|HeadlessChrome|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|SamsungBrowser|Silk(?!/[\\d.]+$)|UCBrowser|YaBrowser)',
            'Version',
            qualify(name),
            '(?:Firefox|Minefield|NetFront)'
        ]);
        // Detect stubborn layout engines.
        if (data = layout == 'iCab' && parseFloat(version) > 3 && 'WebKit' || /\bOpera\b/.test(name) && (/\bOPR\b/.test(ua) ? 'Blink' : 'Presto') || /\b(?:Midori|Nook|Safari)\b/i.test(ua) && !/^(?:Trident|EdgeHTML)$/.test(layout) && 'WebKit' || !layout && /\bMSIE\b/i.test(ua) && (os == 'Mac OS' ? 'Tasman' : 'Trident') || layout == 'WebKit' && /\bPlayStation\b(?! Vita\b)/i.test(name) && 'NetFront') layout = [
            data
        ];
        // Detect Windows Phone 7 desktop mode.
        if (name == 'IE' && (data = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(ua) || 0)[1])) {
            name += ' Mobile';
            os = 'Windows Phone ' + (/\+$/.test(data) ? data : data + '.x');
            description.unshift('desktop mode');
        } else if (/\bWPDesktop\b/i.test(ua)) {
            name = 'IE Mobile';
            os = 'Windows Phone 8.x';
            description.unshift('desktop mode');
            version || (version = (/\brv:([\d.]+)/.exec(ua) || 0)[1]);
        } else if (name != 'IE' && layout == 'Trident' && (data = /\brv:([\d.]+)/.exec(ua))) {
            if (name) description.push('identifying as ' + name + (version ? ' ' + version : ''));
            name = 'IE';
            version = data[1];
        }
        // Leverage environment features.
        if (useFeatures) {
            // Detect server-side environments.
            // Rhino has a global function while others have a global object.
            if (isHostType(context, 'global')) {
                if (java) {
                    data = java.lang.System;
                    arch = data.getProperty('os.arch');
                    os = os || data.getProperty('os.name') + ' ' + data.getProperty('os.version');
                }
                if (rhino) {
                    try {
                        version = context.require('ringo/engine').version.join('.');
                        name = 'RingoJS';
                    } catch (e) {
                        if ((data = context.system) && data.global.system == context.system) {
                            name = 'Narwhal';
                            os || (os = data[0].os || null);
                        }
                    }
                    if (!name) name = 'Rhino';
                } else if (typeof context.process == 'object' && !context.process.browser && (data = context.process)) {
                    if (typeof data.versions == 'object') {
                        if (typeof data.versions.electron == 'string') {
                            description.push('Node ' + data.versions.node);
                            name = 'Electron';
                            version = data.versions.electron;
                        } else if (typeof data.versions.nw == 'string') {
                            description.push('Chromium ' + version, 'Node ' + data.versions.node);
                            name = 'NW.js';
                            version = data.versions.nw;
                        }
                    }
                    if (!name) {
                        name = 'Node.js';
                        arch = data.arch;
                        os = data.platform;
                        version = /[\d.]+/.exec(data.version);
                        version = version ? version[0] : null;
                    }
                }
            } else if (getClassOf(data = context.runtime) == airRuntimeClass) {
                name = 'Adobe AIR';
                os = data.flash.system.Capabilities.os;
            } else if (getClassOf(data = context.phantom) == phantomClass) {
                name = 'PhantomJS';
                version = (data = data.version || null) && data.major + '.' + data.minor + '.' + data.patch;
            } else if (typeof doc.documentMode == 'number' && (data = /\bTrident\/(\d+)/i.exec(ua))) {
                // We're in compatibility mode when the Trident version + 4 doesn't
                // equal the document mode.
                version = [
                    version,
                    doc.documentMode
                ];
                if ((data = +data[1] + 4) != version[1]) {
                    description.push('IE ' + version[1] + ' mode');
                    layout && (layout[1] = '');
                    version[1] = data;
                }
                version = name == 'IE' ? String(version[1].toFixed(1)) : version[0];
            } else if (typeof doc.documentMode == 'number' && /^(?:Chrome|Firefox)\b/.test(name)) {
                description.push('masking as ' + name + ' ' + version);
                name = 'IE';
                version = '11.0';
                layout = [
                    'Trident'
                ];
                os = 'Windows';
            }
            os = os && format(os);
        }
        // Detect prerelease phases.
        if (version && (data = /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(version) || /(?:alpha|beta)(?: ?\d)?/i.exec(ua + ';' + (useFeatures && nav.appMinorVersion)) || /\bMinefield\b/i.test(ua) && 'a')) {
            prerelease = /b/i.test(data) ? 'beta' : 'alpha';
            version = version.replace(RegExp(data + '\\+?$'), '') + (prerelease == 'beta' ? beta : alpha) + (/\d+\+?/.exec(data) || '');
        }
        // Detect Firefox Mobile.
        if (name == 'Fennec' || name == 'Firefox' && /\b(?:Android|Firefox OS|KaiOS)\b/.test(os)) name = 'Firefox Mobile';
        else if (name == 'Maxthon' && version) version = version.replace(/\.[\d.]+/, '.x');
        else if (/\bXbox\b/i.test(product)) {
            if (product == 'Xbox 360') os = null;
            if (product == 'Xbox 360' && /\bIEMobile\b/.test(ua)) description.unshift('mobile mode');
        } else if ((/^(?:Chrome|IE|Opera)$/.test(name) || name && !product && !/Browser|Mobi/.test(name)) && (os == 'Windows CE' || /Mobi/i.test(ua))) name += ' Mobile';
        else if (name == 'IE' && useFeatures) try {
            if (context.external === null) description.unshift('platform preview');
        } catch (e) {
            description.unshift('embedded');
        }
        else if ((/\bBlackBerry\b/.test(product) || /\bBB10\b/.test(ua)) && (data = (RegExp(product.replace(/ +/g, ' *') + '/([.\\d]+)', 'i').exec(ua) || 0)[1] || version)) {
            data = [
                data,
                /BB10/.test(ua)
            ];
            os = (data[1] ? (product = null, manufacturer = 'BlackBerry') : 'Device Software') + ' ' + data[0];
            version = null;
        } else if (this != forOwn && product != 'Wii' && (useFeatures && opera || /Opera/.test(name) && /\b(?:MSIE|Firefox)\b/i.test(ua) || name == 'Firefox' && /\bOS X (?:\d+\.){2,}/.test(os) || name == 'IE' && (os && !/^Win/.test(os) && version > 5.5 || /\bWindows XP\b/.test(os) && version > 8 || version == 8 && !/\bTrident\b/.test(ua))) && !reOpera.test(data = parse.call(forOwn, ua.replace(reOpera, '') + ';')) && data.name) {
            // When "identifying", the UA contains both Opera and the other browser's name.
            data = 'ing as ' + data.name + ((data = data.version) ? ' ' + data : '');
            if (reOpera.test(name)) {
                if (/\bIE\b/.test(data) && os == 'Mac OS') os = null;
                data = 'identify' + data;
            } else {
                data = 'mask' + data;
                if (operaClass) name = format(operaClass.replace(/([a-z])([A-Z])/g, '$1 $2'));
                else name = 'Opera';
                if (/\bIE\b/.test(data)) os = null;
                if (!useFeatures) version = null;
            }
            layout = [
                'Presto'
            ];
            description.push(data);
        }
        // Detect WebKit Nightly and approximate Chrome/Safari versions.
        if (data = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(ua) || 0)[1]) {
            // Correct build number for numeric comparison.
            // (e.g. "532.5" becomes "532.05")
            data = [
                parseFloat(data.replace(/\.(\d)$/, '.0$1')),
                data
            ];
            // Nightly builds are postfixed with a "+".
            if (name == 'Safari' && data[1].slice(-1) == '+') {
                name = 'WebKit Nightly';
                prerelease = 'alpha';
                version = data[1].slice(0, -1);
            } else if (version == data[1] || version == (data[2] = (/\bSafari\/([\d.]+\+?)/i.exec(ua) || 0)[1])) version = null;
            // Use the full Chrome version when available.
            data[1] = (/\b(?:Headless)?Chrome\/([\d.]+)/i.exec(ua) || 0)[1];
            // Detect Blink layout engine.
            if (data[0] == 537.36 && data[2] == 537.36 && parseFloat(data[1]) >= 28 && layout == 'WebKit') layout = [
                'Blink'
            ];
            // Detect JavaScriptCore.
            // http://stackoverflow.com/questions/6768474/how-can-i-detect-which-javascript-engine-v8-or-jsc-is-used-at-runtime-in-androi
            if (!useFeatures || !likeChrome && !data[1]) {
                layout && (layout[1] = 'like Safari');
                data = (data = data[0], data < 400 ? 1 : data < 500 ? 2 : data < 526 ? 3 : data < 533 ? 4 : data < 534 ? '4+' : data < 535 ? 5 : data < 537 ? 6 : data < 538 ? 7 : data < 601 ? 8 : data < 602 ? 9 : data < 604 ? 10 : data < 606 ? 11 : data < 608 ? 12 : '12');
            } else {
                layout && (layout[1] = 'like Chrome');
                data = data[1] || (data = data[0], data < 530 ? 1 : data < 532 ? 2 : data < 532.05 ? 3 : data < 533 ? 4 : data < 534.03 ? 5 : data < 534.07 ? 6 : data < 534.10 ? 7 : data < 534.13 ? 8 : data < 534.16 ? 9 : data < 534.24 ? 10 : data < 534.30 ? 11 : data < 535.01 ? 12 : data < 535.02 ? '13+' : data < 535.07 ? 15 : data < 535.11 ? 16 : data < 535.19 ? 17 : data < 536.05 ? 18 : data < 536.10 ? 19 : data < 537.01 ? 20 : data < 537.11 ? '21+' : data < 537.13 ? 23 : data < 537.18 ? 24 : data < 537.24 ? 25 : data < 537.36 ? 26 : layout != 'Blink' ? '27' : '28');
            }
            // Add the postfix of ".x" or "+" for approximate versions.
            layout && (layout[1] += ' ' + (data += typeof data == 'number' ? '.x' : /[.+]/.test(data) ? '' : '+'));
            // Obscure version for some Safari 1-2 releases.
            if (name == 'Safari' && (!version || parseInt(version) > 45)) version = data;
            else if (name == 'Chrome' && /\bHeadlessChrome/i.test(ua)) description.unshift('headless');
        }
        // Detect Opera desktop modes.
        if (name == 'Opera' && (data = /\bzbov|zvav$/.exec(os))) {
            name += ' ';
            description.unshift('desktop mode');
            if (data == 'zvav') {
                name += 'Mini';
                version = null;
            } else name += 'Mobile';
            os = os.replace(RegExp(' *' + data + '$'), '');
        } else if (name == 'Safari' && /\bChrome\b/.exec(layout && layout[1])) {
            description.unshift('desktop mode');
            name = 'Chrome Mobile';
            version = null;
            if (/\bOS X\b/.test(os)) {
                manufacturer = 'Apple';
                os = 'iOS 4.3+';
            } else os = null;
        } else if (/\bSRWare Iron\b/.test(name) && !version) version = getVersion('Chrome');
        // Strip incorrect OS versions.
        if (version && version.indexOf(data = /[\d.]+$/.exec(os)) == 0 && ua.indexOf('/' + data + '-') > -1) os = trim(os.replace(data, ''));
        // Ensure OS does not include the browser name.
        if (os && os.indexOf(name) != -1 && !RegExp(name + ' OS').test(os)) os = os.replace(RegExp(' *' + qualify(name) + ' *'), '');
        // Add layout engine.
        if (layout && !/\b(?:Avant|Nook)\b/.test(name) && (/Browser|Lunascape|Maxthon/.test(name) || name != 'Safari' && /^iOS/.test(os) && /\bSafari\b/.test(layout[1]) || /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Samsung Internet|Sleipnir|SRWare Iron|Vivaldi|Web)/.test(name) && layout[1])) // Don't add layout details to description if they are falsey.
        (data = layout[layout.length - 1]) && description.push(data);
        // Combine contextual information.
        if (description.length) description = [
            '(' + description.join('; ') + ')'
        ];
        // Append manufacturer to description.
        if (manufacturer && product && product.indexOf(manufacturer) < 0) description.push('on ' + manufacturer);
        // Append product to description.
        if (product) description.push((/^on /.test(description[description.length - 1]) ? '' : 'on ') + product);
        // Parse the OS into an object.
        if (os) {
            data = / ([\d.+]+)$/.exec(os);
            isSpecialCasedOS = data && os.charAt(os.length - data[0].length - 1) == '/';
            os = {
                'architecture': 32,
                'family': data && !isSpecialCasedOS ? os.replace(data[0], '') : os,
                'version': data ? data[1] : null,
                'toString': function() {
                    var version = this.version;
                    return this.family + (version && !isSpecialCasedOS ? ' ' + version : '') + (this.architecture == 64 ? ' 64-bit' : '');
                }
            };
        }
        // Add browser/OS architecture.
        if ((data = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(arch)) && !/\bi686\b/i.test(arch)) {
            if (os) {
                os.architecture = 64;
                os.family = os.family.replace(RegExp(' *' + data), '');
            }
            if (name && (/\bWOW64\b/i.test(ua) || useFeatures && /\w(?:86|32)$/.test(nav.cpuClass || nav.platform) && !/\bWin64; x64\b/i.test(ua))) description.unshift('32-bit');
        } else if (os && /^OS X/.test(os.family) && name == 'Chrome' && parseFloat(version) >= 39) os.architecture = 64;
        ua || (ua = null);
        /*------------------------------------------------------------------------*/ /**
     * The platform object.
     *
     * @name platform
     * @type Object
     */ var platform = {};
        /**
     * The platform description.
     *
     * @memberOf platform
     * @type string|null
     */ platform.description = ua;
        /**
     * The name of the browser's layout engine.
     *
     * The list of common layout engines include:
     * "Blink", "EdgeHTML", "Gecko", "Trident" and "WebKit"
     *
     * @memberOf platform
     * @type string|null
     */ platform.layout = layout && layout[0];
        /**
     * The name of the product's manufacturer.
     *
     * The list of manufacturers include:
     * "Apple", "Archos", "Amazon", "Asus", "Barnes & Noble", "BlackBerry",
     * "Google", "HP", "HTC", "LG", "Microsoft", "Motorola", "Nintendo",
     * "Nokia", "Samsung" and "Sony"
     *
     * @memberOf platform
     * @type string|null
     */ platform.manufacturer = manufacturer;
        /**
     * The name of the browser/environment.
     *
     * The list of common browser names include:
     * "Chrome", "Electron", "Firefox", "Firefox for iOS", "IE",
     * "Microsoft Edge", "PhantomJS", "Safari", "SeaMonkey", "Silk",
     * "Opera Mini" and "Opera"
     *
     * Mobile versions of some browsers have "Mobile" appended to their name:
     * eg. "Chrome Mobile", "Firefox Mobile", "IE Mobile" and "Opera Mobile"
     *
     * @memberOf platform
     * @type string|null
     */ platform.name = name;
        /**
     * The alpha/beta release indicator.
     *
     * @memberOf platform
     * @type string|null
     */ platform.prerelease = prerelease;
        /**
     * The name of the product hosting the browser.
     *
     * The list of common products include:
     *
     * "BlackBerry", "Galaxy S4", "Lumia", "iPad", "iPod", "iPhone", "Kindle",
     * "Kindle Fire", "Nexus", "Nook", "PlayBook", "TouchPad" and "Transformer"
     *
     * @memberOf platform
     * @type string|null
     */ platform.product = product;
        /**
     * The browser's user agent string.
     *
     * @memberOf platform
     * @type string|null
     */ platform.ua = ua;
        /**
     * The browser/environment version.
     *
     * @memberOf platform
     * @type string|null
     */ platform.version = name && version;
        /**
     * The name of the operating system.
     *
     * @memberOf platform
     * @type Object
     */ platform.os = os || {
            /**
       * The CPU architecture the OS is built for.
       *
       * @memberOf platform.os
       * @type number|null
       */ 'architecture': null,
            /**
       * The family of the OS.
       *
       * Common values include:
       * "Windows", "Windows Server 2008 R2 / 7", "Windows Server 2008 / Vista",
       * "Windows XP", "OS X", "Linux", "Ubuntu", "Debian", "Fedora", "Red Hat",
       * "SuSE", "Android", "iOS" and "Windows Phone"
       *
       * @memberOf platform.os
       * @type string|null
       */ 'family': null,
            /**
       * The version of the OS.
       *
       * @memberOf platform.os
       * @type string|null
       */ 'version': null,
            /**
       * Returns the OS string.
       *
       * @memberOf platform.os
       * @returns {string} The OS string.
       */ 'toString': function() {
                return 'null';
            }
        };
        platform.parse = parse;
        platform.toString = toStringPlatform;
        if (platform.version) description.unshift(version);
        if (platform.name) description.unshift(name);
        if (os && name && !(os == String(os).split(' ')[0] && (os == name.split(' ')[0] || product))) description.push(product ? '(' + os + ')' : 'on ' + os);
        if (description.length) platform.description = description.join(' ');
        return platform;
    }
    /*--------------------------------------------------------------------------*/ // Export platform.
    var platform = parse();
    // Some AMD build optimizers, like r.js, check for condition patterns like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose platform on the global object to prevent errors when platform is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        root.platform = platform;
        // Define as an anonymous module so platform can be aliased through path mapping.
        define(function() {
            return platform;
        });
    } else if (freeExports && freeModule) // Export for CommonJS support.
    forOwn(platform, function(value, key) {
        freeExports[key] = value;
    });
    else // Export to the global object.
    root.platform = platform;
}).call(this);

},{}],"3K3zG":[function(require,module,exports,__globalThis) {
/**
 * interact.js v1.2.8
 *
 * Copyright (c) 2012-2015 Taye Adeyemi <dev@taye.me>
 * Open source under the MIT License.
 * https://raw.github.com/taye/interact.js/master/LICENSE
 */ (function(realWindow) {
    'use strict';
    // return early if there's no window to work with (eg. Node.js)
    if (!realWindow) return;
    var window1 = function() {
        // create a TextNode
        var el = realWindow.document.createTextNode('');
        // check if it's wrapped by a polyfill
        if (el.ownerDocument !== realWindow.document && typeof realWindow.wrap === 'function' && realWindow.wrap(el) === el) // return wrapped window
        return realWindow.wrap(realWindow);
        // no Shadow DOM polyfil or native implementation
        return realWindow;
    }(), document = window1.document, DocumentFragment = window1.DocumentFragment || blank, SVGElement = window1.SVGElement || blank, SVGSVGElement = window1.SVGSVGElement || blank, SVGElementInstance = window1.SVGElementInstance || blank, HTMLElement = window1.HTMLElement || window1.Element, PointerEvent = window1.PointerEvent || window1.MSPointerEvent, pEventTypes, hypot = Math.hypot || function(x, y) {
        return Math.sqrt(x * x + y * y);
    }, tmpXY = {}, documents = [], interactables = [], interactions = [], dynamicDrop = false, // {
    //      type: {
    //          selectors: ['selector', ...],
    //          contexts : [document, ...],
    //          listeners: [[listener, useCapture], ...]
    //      }
    //  }
    delegatedEvents = {}, defaultOptions = {
        base: {
            accept: null,
            actionChecker: null,
            styleCursor: true,
            preventDefault: 'auto',
            origin: {
                x: 0,
                y: 0
            },
            deltaSource: 'page',
            allowFrom: null,
            ignoreFrom: null,
            _context: document,
            dropChecker: null
        },
        drag: {
            enabled: false,
            manualStart: true,
            max: Infinity,
            maxPerElement: 1,
            snap: null,
            restrict: null,
            inertia: null,
            autoScroll: null,
            axis: 'xy'
        },
        drop: {
            enabled: false,
            accept: null,
            overlap: 'pointer'
        },
        resize: {
            enabled: false,
            manualStart: false,
            max: Infinity,
            maxPerElement: 1,
            snap: null,
            restrict: null,
            inertia: null,
            autoScroll: null,
            square: false,
            preserveAspectRatio: false,
            axis: 'xy',
            // use default margin
            margin: NaN,
            // object with props left, right, top, bottom which are
            // true/false values to resize when the pointer is over that edge,
            // CSS selectors to match the handles for each direction
            // or the Elements for each handle
            edges: null,
            // a value of 'none' will limit the resize rect to a minimum of 0x0
            // 'negate' will alow the rect to have negative width/height
            // 'reposition' will keep the width/height positive by swapping
            // the top and bottom edges and/or swapping the left and right edges
            invert: 'none'
        },
        gesture: {
            manualStart: false,
            enabled: false,
            max: Infinity,
            maxPerElement: 1,
            restrict: null
        },
        perAction: {
            manualStart: false,
            max: Infinity,
            maxPerElement: 1,
            snap: {
                enabled: false,
                endOnly: false,
                range: Infinity,
                targets: null,
                offsets: null,
                relativePoints: null
            },
            restrict: {
                enabled: false,
                endOnly: false
            },
            autoScroll: {
                enabled: false,
                container: null,
                margin: 60,
                speed: 300 // the scroll speed in pixels per second
            },
            inertia: {
                enabled: false,
                resistance: 10,
                minSpeed: 100,
                endSpeed: 10,
                allowResume: true,
                zeroResumeDelta: true,
                smoothEndDuration: 300 // animate to snap/restrict endOnly if there's no inertia
            }
        },
        _holdDuration: 600
    }, // Things related to autoScroll
    autoScroll = {
        interaction: null,
        i: null,
        x: 0,
        y: 0,
        // scroll the window by the values in scroll.x/y
        scroll: function() {
            var options = autoScroll.interaction.target.options[autoScroll.interaction.prepared.name].autoScroll, container = options.container || getWindow(autoScroll.interaction.element), now = new Date().getTime(), // change in time in seconds
            dtx = (now - autoScroll.prevTimeX) / 1000, dty = (now - autoScroll.prevTimeY) / 1000, vx, vy, sx, sy;
            // displacement
            if (options.velocity) {
                vx = options.velocity.x;
                vy = options.velocity.y;
            } else vx = vy = options.speed;
            sx = vx * dtx;
            sy = vy * dty;
            if (sx >= 1 || sy >= 1) {
                if (isWindow(container)) container.scrollBy(autoScroll.x * sx, autoScroll.y * sy);
                else if (container) {
                    container.scrollLeft += autoScroll.x * sx;
                    container.scrollTop += autoScroll.y * sy;
                }
                if (sx >= 1) autoScroll.prevTimeX = now;
                if (sy >= 1) autoScroll.prevTimeY = now;
            }
            if (autoScroll.isScrolling) {
                cancelFrame(autoScroll.i);
                autoScroll.i = reqFrame(autoScroll.scroll);
            }
        },
        isScrolling: false,
        prevTimeX: 0,
        prevTimeY: 0,
        start: function(interaction) {
            autoScroll.isScrolling = true;
            cancelFrame(autoScroll.i);
            autoScroll.interaction = interaction;
            autoScroll.prevTimeX = new Date().getTime();
            autoScroll.prevTimeY = new Date().getTime();
            autoScroll.i = reqFrame(autoScroll.scroll);
        },
        stop: function() {
            autoScroll.isScrolling = false;
            cancelFrame(autoScroll.i);
        }
    }, // Does the browser support touch input?
    supportsTouch = 'ontouchstart' in window1 || window1.DocumentTouch && document instanceof window1.DocumentTouch, // Does the browser support PointerEvents
    // Avoid PointerEvent bugs introduced in Chrome 55
    supportsPointerEvent = PointerEvent && !/Chrome/.test(navigator.userAgent), // Less Precision with touch input
    margin = supportsTouch || supportsPointerEvent ? 20 : 10, pointerMoveTolerance = 1, // for ignoring browser's simulated mouse events
    prevTouchTime = 0, // Allow this many interactions to happen simultaneously
    maxInteractions = Infinity, // Check if is IE9 or older
    actionCursors = document.all && !window1.atob ? {
        drag: 'move',
        resizex: 'e-resize',
        resizey: 's-resize',
        resizexy: 'se-resize',
        resizetop: 'n-resize',
        resizeleft: 'w-resize',
        resizebottom: 's-resize',
        resizeright: 'e-resize',
        resizetopleft: 'se-resize',
        resizebottomright: 'se-resize',
        resizetopright: 'ne-resize',
        resizebottomleft: 'ne-resize',
        gesture: ''
    } : {
        drag: 'move',
        resizex: 'ew-resize',
        resizey: 'ns-resize',
        resizexy: 'nwse-resize',
        resizetop: 'ns-resize',
        resizeleft: 'ew-resize',
        resizebottom: 'ns-resize',
        resizeright: 'ew-resize',
        resizetopleft: 'nwse-resize',
        resizebottomright: 'nwse-resize',
        resizetopright: 'nesw-resize',
        resizebottomleft: 'nesw-resize',
        gesture: ''
    }, actionIsEnabled = {
        drag: true,
        resize: true,
        gesture: true
    }, // because Webkit and Opera still use 'mousewheel' event type
    wheelEvent = 'onmousewheel' in document ? 'mousewheel' : 'wheel', eventTypes = [
        'dragstart',
        'dragmove',
        'draginertiastart',
        'dragend',
        'dragenter',
        'dragleave',
        'dropactivate',
        'dropdeactivate',
        'dropmove',
        'drop',
        'resizestart',
        'resizemove',
        'resizeinertiastart',
        'resizeend',
        'gesturestart',
        'gesturemove',
        'gestureinertiastart',
        'gestureend',
        'down',
        'move',
        'up',
        'cancel',
        'tap',
        'doubletap',
        'hold'
    ], globalEvents = {}, // Opera Mobile must be handled differently
    isOperaMobile = navigator.appName == 'Opera' && supportsTouch && navigator.userAgent.match('Presto'), // scrolling doesn't change the result of getClientRects on iOS 7
    isIOS7 = /iP(hone|od|ad)/.test(navigator.platform) && /OS 7[^\d]/.test(navigator.appVersion), // prefix matchesSelector
    prefixedMatchesSelector = 'matches' in Element.prototype ? 'matches' : 'webkitMatchesSelector' in Element.prototype ? 'webkitMatchesSelector' : 'mozMatchesSelector' in Element.prototype ? 'mozMatchesSelector' : 'oMatchesSelector' in Element.prototype ? 'oMatchesSelector' : 'msMatchesSelector', // will be polyfill function if browser is IE8
    ie8MatchesSelector, // native requestAnimationFrame or polyfill
    reqFrame = realWindow.requestAnimationFrame, cancelFrame = realWindow.cancelAnimationFrame, // Events wrapper
    events = function() {
        var useAttachEvent = 'attachEvent' in window1 && !('addEventListener' in window1), addEvent = useAttachEvent ? 'attachEvent' : 'addEventListener', removeEvent = useAttachEvent ? 'detachEvent' : 'removeEventListener', on = useAttachEvent ? 'on' : '', elements = [], targets = [], attachedListeners = [];
        function add(element, type, listener, useCapture) {
            var elementIndex = indexOf(elements, element), target = targets[elementIndex];
            if (!target) {
                target = {
                    events: {},
                    typeCount: 0
                };
                elementIndex = elements.push(element) - 1;
                targets.push(target);
                attachedListeners.push(useAttachEvent ? {
                    supplied: [],
                    wrapped: [],
                    useCount: []
                } : null);
            }
            if (!target.events[type]) {
                target.events[type] = [];
                target.typeCount++;
            }
            if (!contains(target.events[type], listener)) {
                var ret;
                if (useAttachEvent) {
                    var listeners = attachedListeners[elementIndex], listenerIndex = indexOf(listeners.supplied, listener);
                    var wrapped = listeners.wrapped[listenerIndex] || function(event) {
                        if (!event.immediatePropagationStopped) {
                            event.target = event.srcElement;
                            event.currentTarget = element;
                            event.preventDefault = event.preventDefault || preventDef;
                            event.stopPropagation = event.stopPropagation || stopProp;
                            event.stopImmediatePropagation = event.stopImmediatePropagation || stopImmProp;
                            if (/mouse|click/.test(event.type)) {
                                event.pageX = event.clientX + getWindow(element).document.documentElement.scrollLeft;
                                event.pageY = event.clientY + getWindow(element).document.documentElement.scrollTop;
                            }
                            listener(event);
                        }
                    };
                    ret = element[addEvent](on + type, wrapped, Boolean(useCapture));
                    if (listenerIndex === -1) {
                        listeners.supplied.push(listener);
                        listeners.wrapped.push(wrapped);
                        listeners.useCount.push(1);
                    } else listeners.useCount[listenerIndex]++;
                } else ret = element[addEvent](type, listener, useCapture || false);
                target.events[type].push(listener);
                return ret;
            }
        }
        function remove(element, type, listener, useCapture) {
            var i, elementIndex = indexOf(elements, element), target = targets[elementIndex], listeners, listenerIndex, wrapped = listener;
            if (!target || !target.events) return;
            if (useAttachEvent) {
                listeners = attachedListeners[elementIndex];
                listenerIndex = indexOf(listeners.supplied, listener);
                wrapped = listeners.wrapped[listenerIndex];
            }
            if (type === 'all') {
                for(type in target.events)if (target.events.hasOwnProperty(type)) remove(element, type, 'all');
                return;
            }
            if (target.events[type]) {
                var len = target.events[type].length;
                if (listener === 'all') {
                    for(i = 0; i < len; i++)remove(element, type, target.events[type][i], Boolean(useCapture));
                    return;
                } else {
                    for(i = 0; i < len; i++)if (target.events[type][i] === listener) {
                        element[removeEvent](on + type, wrapped, useCapture || false);
                        target.events[type].splice(i, 1);
                        if (useAttachEvent && listeners) {
                            listeners.useCount[listenerIndex]--;
                            if (listeners.useCount[listenerIndex] === 0) {
                                listeners.supplied.splice(listenerIndex, 1);
                                listeners.wrapped.splice(listenerIndex, 1);
                                listeners.useCount.splice(listenerIndex, 1);
                            }
                        }
                        break;
                    }
                }
                if (target.events[type] && target.events[type].length === 0) {
                    target.events[type] = null;
                    target.typeCount--;
                }
            }
            if (!target.typeCount) {
                targets.splice(elementIndex, 1);
                elements.splice(elementIndex, 1);
                attachedListeners.splice(elementIndex, 1);
            }
        }
        function preventDef() {
            this.returnValue = false;
        }
        function stopProp() {
            this.cancelBubble = true;
        }
        function stopImmProp() {
            this.cancelBubble = true;
            this.immediatePropagationStopped = true;
        }
        return {
            add: add,
            remove: remove,
            useAttachEvent: useAttachEvent,
            _elements: elements,
            _targets: targets,
            _attachedListeners: attachedListeners
        };
    }();
    function blank() {}
    function isElement(o) {
        if (!o || typeof o !== 'object') return false;
        var _window = getWindow(o) || window1;
        return /object|function/.test(typeof _window.Element) ? o instanceof _window.Element //DOM2
         : o.nodeType === 1 && typeof o.nodeName === "string";
    }
    function isWindow(thing) {
        return thing === window1 || !!(thing && thing.Window) && thing instanceof thing.Window;
    }
    function isDocFrag(thing) {
        return !!thing && thing instanceof DocumentFragment;
    }
    function isArray(thing) {
        return isObject(thing) && (thing.length, true) && isFunction(thing.splice);
    }
    function isObject(thing) {
        return !!thing && typeof thing === 'object';
    }
    function isFunction(thing) {
        return typeof thing === 'function';
    }
    function isNumber(thing) {
        return typeof thing === 'number';
    }
    function isBool(thing) {
        return typeof thing === 'boolean';
    }
    function isString(thing) {
        return typeof thing === 'string';
    }
    function trySelector(value) {
        if (!isString(value)) return false;
        // an exception will be raised if it is invalid
        document.querySelector(value);
        return true;
    }
    function extend(dest, source) {
        for(var prop in source)dest[prop] = source[prop];
        return dest;
    }
    var prefixedPropREs = {
        webkit: /(Movement[XY]|Radius[XY]|RotationAngle|Force)$/
    };
    function pointerExtend(dest, source) {
        for(var prop in source){
            var deprecated = false;
            // skip deprecated prefixed properties
            for(var vendor in prefixedPropREs)if (prop.indexOf(vendor) === 0 && prefixedPropREs[vendor].test(prop)) {
                deprecated = true;
                break;
            }
            if (!deprecated) dest[prop] = source[prop];
        }
        return dest;
    }
    function copyCoords(dest, src) {
        dest.page = dest.page || {};
        dest.page.x = src.page.x;
        dest.page.y = src.page.y;
        dest.client = dest.client || {};
        dest.client.x = src.client.x;
        dest.client.y = src.client.y;
        dest.timeStamp = src.timeStamp;
    }
    function setEventXY(targetObj, pointers, interaction) {
        var pointer = pointers.length > 1 ? pointerAverage(pointers) : pointers[0];
        getPageXY(pointer, tmpXY, interaction);
        targetObj.page.x = tmpXY.x;
        targetObj.page.y = tmpXY.y;
        getClientXY(pointer, tmpXY, interaction);
        targetObj.client.x = tmpXY.x;
        targetObj.client.y = tmpXY.y;
        targetObj.timeStamp = new Date().getTime();
    }
    function setEventDeltas(targetObj, prev, cur) {
        targetObj.page.x = cur.page.x - prev.page.x;
        targetObj.page.y = cur.page.y - prev.page.y;
        targetObj.client.x = cur.client.x - prev.client.x;
        targetObj.client.y = cur.client.y - prev.client.y;
        targetObj.timeStamp = new Date().getTime() - prev.timeStamp;
        // set pointer velocity
        var dt = Math.max(targetObj.timeStamp / 1000, 0.001);
        targetObj.page.speed = hypot(targetObj.page.x, targetObj.page.y) / dt;
        targetObj.page.vx = targetObj.page.x / dt;
        targetObj.page.vy = targetObj.page.y / dt;
        targetObj.client.speed = hypot(targetObj.client.x, targetObj.page.y) / dt;
        targetObj.client.vx = targetObj.client.x / dt;
        targetObj.client.vy = targetObj.client.y / dt;
    }
    function isNativePointer(pointer) {
        return pointer instanceof window1.Event || supportsTouch && window1.Touch && pointer instanceof window1.Touch;
    }
    // Get specified X/Y coords for mouse or event.touches[0]
    function getXY(type, pointer, xy) {
        xy = xy || {};
        type = type || 'page';
        xy.x = pointer[type + 'X'];
        xy.y = pointer[type + 'Y'];
        return xy;
    }
    function getPageXY(pointer, page) {
        page = page || {};
        // Opera Mobile handles the viewport and scrolling oddly
        if (isOperaMobile && isNativePointer(pointer)) {
            getXY('screen', pointer, page);
            page.x += window1.scrollX;
            page.y += window1.scrollY;
        } else getXY('page', pointer, page);
        return page;
    }
    function getClientXY(pointer, client) {
        client = client || {};
        if (isOperaMobile && isNativePointer(pointer)) // Opera Mobile handles the viewport and scrolling oddly
        getXY('screen', pointer, client);
        else getXY('client', pointer, client);
        return client;
    }
    function getScrollXY(win) {
        win = win || window1;
        return {
            x: win.scrollX || win.document.documentElement.scrollLeft,
            y: win.scrollY || win.document.documentElement.scrollTop
        };
    }
    function getPointerId(pointer) {
        return isNumber(pointer.pointerId) ? pointer.pointerId : pointer.identifier;
    }
    function getActualElement(element) {
        return element instanceof SVGElementInstance ? element.correspondingUseElement : element;
    }
    function getWindow(node) {
        if (isWindow(node)) return node;
        var rootNode = node.ownerDocument || node;
        return rootNode.defaultView || rootNode.parentWindow || window1;
    }
    function getElementClientRect(element) {
        var clientRect = element instanceof SVGElement ? element.getBoundingClientRect() : element.getClientRects()[0];
        return clientRect && {
            left: clientRect.left,
            right: clientRect.right,
            top: clientRect.top,
            bottom: clientRect.bottom,
            width: clientRect.width || clientRect.right - clientRect.left,
            height: clientRect.height || clientRect.bottom - clientRect.top
        };
    }
    function getElementRect(element) {
        var clientRect = getElementClientRect(element);
        if (!isIOS7 && clientRect) {
            var scroll = getScrollXY(getWindow(element));
            clientRect.left += scroll.x;
            clientRect.right += scroll.x;
            clientRect.top += scroll.y;
            clientRect.bottom += scroll.y;
        }
        return clientRect;
    }
    function getTouchPair(event) {
        var touches = [];
        // array of touches is supplied
        if (isArray(event)) {
            touches[0] = event[0];
            touches[1] = event[1];
        } else if (event.type === 'touchend') {
            if (event.touches.length === 1) {
                touches[0] = event.touches[0];
                touches[1] = event.changedTouches[0];
            } else if (event.touches.length === 0) {
                touches[0] = event.changedTouches[0];
                touches[1] = event.changedTouches[1];
            }
        } else {
            touches[0] = event.touches[0];
            touches[1] = event.touches[1];
        }
        return touches;
    }
    function pointerAverage(pointers) {
        var average = {
            pageX: 0,
            pageY: 0,
            clientX: 0,
            clientY: 0,
            screenX: 0,
            screenY: 0
        };
        var prop;
        for(var i = 0; i < pointers.length; i++)for(prop in average)average[prop] += pointers[i][prop];
        for(prop in average)average[prop] /= pointers.length;
        return average;
    }
    function touchBBox(event) {
        if (!event.length && !(event.touches && event.touches.length > 1)) return;
        var touches = getTouchPair(event), minX = Math.min(touches[0].pageX, touches[1].pageX), minY = Math.min(touches[0].pageY, touches[1].pageY), maxX = Math.max(touches[0].pageX, touches[1].pageX), maxY = Math.max(touches[0].pageY, touches[1].pageY);
        return {
            x: minX,
            y: minY,
            left: minX,
            top: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    function touchDistance(event, deltaSource) {
        deltaSource = deltaSource || defaultOptions.deltaSource;
        var sourceX = deltaSource + 'X', sourceY = deltaSource + 'Y', touches = getTouchPair(event);
        var dx = touches[0][sourceX] - touches[1][sourceX], dy = touches[0][sourceY] - touches[1][sourceY];
        return hypot(dx, dy);
    }
    function touchAngle(event, prevAngle, deltaSource) {
        deltaSource = deltaSource || defaultOptions.deltaSource;
        var sourceX = deltaSource + 'X', sourceY = deltaSource + 'Y', touches = getTouchPair(event), dx = touches[0][sourceX] - touches[1][sourceX], dy = touches[0][sourceY] - touches[1][sourceY], angle = 180 * Math.atan(dy / dx) / Math.PI;
        if (isNumber(prevAngle)) {
            var dr = angle - prevAngle, drClamped = dr % 360;
            if (drClamped > 315) angle -= 360 + angle / 360 | 0;
            else if (drClamped > 135) angle -= 180 + angle / 360 | 0;
            else if (drClamped < -315) angle += 360 + angle / 360 | 0;
            else if (drClamped < -135) angle += 180 + angle / 360 | 0;
        }
        return angle;
    }
    function getOriginXY(interactable, element) {
        var origin = interactable ? interactable.options.origin : defaultOptions.origin;
        if (origin === 'parent') origin = parentElement(element);
        else if (origin === 'self') origin = interactable.getRect(element);
        else if (trySelector(origin)) origin = closest(element, origin) || {
            x: 0,
            y: 0
        };
        if (isFunction(origin)) origin = origin(interactable && element);
        if (isElement(origin)) origin = getElementRect(origin);
        origin.x = 'x' in origin ? origin.x : origin.left;
        origin.y = 'y' in origin ? origin.y : origin.top;
        return origin;
    }
    // http://stackoverflow.com/a/5634528/2280888
    function _getQBezierValue(t, p1, p2, p3) {
        var iT = 1 - t;
        return iT * iT * p1 + 2 * iT * t * p2 + t * t * p3;
    }
    function getQuadraticCurvePoint(startX, startY, cpX, cpY, endX, endY, position) {
        return {
            x: _getQBezierValue(position, startX, cpX, endX),
            y: _getQBezierValue(position, startY, cpY, endY)
        };
    }
    // http://gizma.com/easing/
    function easeOutQuad(t, b, c, d) {
        t /= d;
        return -c * t * (t - 2) + b;
    }
    function nodeContains(parent, child) {
        while(child){
            if (child === parent) return true;
            child = child.parentNode;
        }
        return false;
    }
    function closest(child, selector) {
        var parent = parentElement(child);
        while(isElement(parent)){
            if (matchesSelector(parent, selector)) return parent;
            parent = parentElement(parent);
        }
        return null;
    }
    function parentElement(node) {
        var parent = node.parentNode;
        if (isDocFrag(parent)) {
            // skip past #shado-root fragments
            while((parent = parent.host) && isDocFrag(parent));
            return parent;
        }
        return parent;
    }
    function inContext(interactable, element) {
        return interactable._context === element.ownerDocument || nodeContains(interactable._context, element);
    }
    function testIgnore(interactable, interactableElement, element) {
        var ignoreFrom = interactable.options.ignoreFrom;
        if (!ignoreFrom || !isElement(element)) return false;
        if (isString(ignoreFrom)) return matchesUpTo(element, ignoreFrom, interactableElement);
        else if (isElement(ignoreFrom)) return nodeContains(ignoreFrom, element);
        return false;
    }
    function testAllow(interactable, interactableElement, element) {
        var allowFrom = interactable.options.allowFrom;
        if (!allowFrom) return true;
        if (!isElement(element)) return false;
        if (isString(allowFrom)) return matchesUpTo(element, allowFrom, interactableElement);
        else if (isElement(allowFrom)) return nodeContains(allowFrom, element);
        return false;
    }
    function checkAxis(axis, interactable) {
        if (!interactable) return false;
        var thisAxis = interactable.options.drag.axis;
        return axis === 'xy' || thisAxis === 'xy' || thisAxis === axis;
    }
    function checkSnap(interactable, action) {
        var options = interactable.options;
        if (/^resize/.test(action)) action = 'resize';
        return options[action].snap && options[action].snap.enabled;
    }
    function checkRestrict(interactable, action) {
        var options = interactable.options;
        if (/^resize/.test(action)) action = 'resize';
        return options[action].restrict && options[action].restrict.enabled;
    }
    function checkAutoScroll(interactable, action) {
        var options = interactable.options;
        if (/^resize/.test(action)) action = 'resize';
        return options[action].autoScroll && options[action].autoScroll.enabled;
    }
    function withinInteractionLimit(interactable, element, action) {
        var options = interactable.options, maxActions = options[action.name].max, maxPerElement = options[action.name].maxPerElement, activeInteractions = 0, targetCount = 0, targetElementCount = 0;
        for(var i = 0, len = interactions.length; i < len; i++){
            var interaction = interactions[i], otherAction = interaction.prepared.name, active = interaction.interacting();
            if (!active) continue;
            activeInteractions++;
            if (activeInteractions >= maxInteractions) return false;
            if (interaction.target !== interactable) continue;
            targetCount += otherAction === action.name | 0;
            if (targetCount >= maxActions) return false;
            if (interaction.element === element) {
                targetElementCount++;
                if (otherAction !== action.name || targetElementCount >= maxPerElement) return false;
            }
        }
        return maxInteractions > 0;
    }
    // Test for the element that's "above" all other qualifiers
    function indexOfDeepestElement(elements) {
        var dropzone, deepestZone = elements[0], index = deepestZone ? 0 : -1, parent, deepestZoneParents = [], dropzoneParents = [], child, i, n;
        for(i = 1; i < elements.length; i++){
            dropzone = elements[i];
            // an element might belong to multiple selector dropzones
            if (!dropzone || dropzone === deepestZone) continue;
            if (!deepestZone) {
                deepestZone = dropzone;
                index = i;
                continue;
            }
            // check if the deepest or current are document.documentElement or document.rootElement
            // - if the current dropzone is, do nothing and continue
            if (dropzone.parentNode === dropzone.ownerDocument) continue;
            else if (deepestZone.parentNode === dropzone.ownerDocument) {
                deepestZone = dropzone;
                index = i;
                continue;
            }
            if (!deepestZoneParents.length) {
                parent = deepestZone;
                while(parent.parentNode && parent.parentNode !== parent.ownerDocument){
                    deepestZoneParents.unshift(parent);
                    parent = parent.parentNode;
                }
            }
            // if this element is an svg element and the current deepest is
            // an HTMLElement
            if (deepestZone instanceof HTMLElement && dropzone instanceof SVGElement && !(dropzone instanceof SVGSVGElement)) {
                if (dropzone === deepestZone.parentNode) continue;
                parent = dropzone.ownerSVGElement;
            } else parent = dropzone;
            dropzoneParents = [];
            while(parent.parentNode !== parent.ownerDocument){
                dropzoneParents.unshift(parent);
                parent = parent.parentNode;
            }
            n = 0;
            // get (position of last common ancestor) + 1
            while(dropzoneParents[n] && dropzoneParents[n] === deepestZoneParents[n])n++;
            var parents = [
                dropzoneParents[n - 1],
                dropzoneParents[n],
                deepestZoneParents[n]
            ];
            child = parents[0].lastChild;
            while(child){
                if (child === parents[1]) {
                    deepestZone = dropzone;
                    index = i;
                    deepestZoneParents = [];
                    break;
                } else if (child === parents[2]) break;
                child = child.previousSibling;
            }
        }
        return index;
    }
    function Interaction() {
        this.target = null; // current interactable being interacted with
        this.element = null; // the target element of the interactable
        this.dropTarget = null; // the dropzone a drag target might be dropped into
        this.dropElement = null; // the element at the time of checking
        this.prevDropTarget = null; // the dropzone that was recently dragged away from
        this.prevDropElement = null; // the element at the time of checking
        this.prepared = {
            name: null,
            axis: null,
            edges: null
        };
        this.matches = []; // all selectors that are matched by target element
        this.matchElements = []; // corresponding elements
        this.inertiaStatus = {
            active: false,
            smoothEnd: false,
            ending: false,
            startEvent: null,
            upCoords: {},
            xe: 0,
            ye: 0,
            sx: 0,
            sy: 0,
            t0: 0,
            vx0: 0,
            vys: 0,
            duration: 0,
            resumeDx: 0,
            resumeDy: 0,
            lambda_v0: 0,
            one_ve_v0: 0,
            i: null
        };
        if (isFunction(Function.prototype.bind)) {
            this.boundInertiaFrame = this.inertiaFrame.bind(this);
            this.boundSmoothEndFrame = this.smoothEndFrame.bind(this);
        } else {
            var that = this;
            this.boundInertiaFrame = function() {
                return that.inertiaFrame();
            };
            this.boundSmoothEndFrame = function() {
                return that.smoothEndFrame();
            };
        }
        this.activeDrops = {
            dropzones: [],
            elements: [],
            rects: [] // the rects of the elements mentioned above
        };
        // keep track of added pointers
        this.pointers = [];
        this.pointerIds = [];
        this.downTargets = [];
        this.downTimes = [];
        this.holdTimers = [];
        // Previous native pointer move event coordinates
        this.prevCoords = {
            page: {
                x: 0,
                y: 0
            },
            client: {
                x: 0,
                y: 0
            },
            timeStamp: 0
        };
        // current native pointer move event coordinates
        this.curCoords = {
            page: {
                x: 0,
                y: 0
            },
            client: {
                x: 0,
                y: 0
            },
            timeStamp: 0
        };
        // Starting InteractEvent pointer coordinates
        this.startCoords = {
            page: {
                x: 0,
                y: 0
            },
            client: {
                x: 0,
                y: 0
            },
            timeStamp: 0
        };
        // Change in coordinates and time of the pointer
        this.pointerDelta = {
            page: {
                x: 0,
                y: 0,
                vx: 0,
                vy: 0,
                speed: 0
            },
            client: {
                x: 0,
                y: 0,
                vx: 0,
                vy: 0,
                speed: 0
            },
            timeStamp: 0
        };
        this.downEvent = null; // pointerdown/mousedown/touchstart event
        this.downPointer = {};
        this._eventTarget = null;
        this._curEventTarget = null;
        this.prevEvent = null; // previous action event
        this.tapTime = 0; // time of the most recent tap event
        this.prevTap = null;
        this.startOffset = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.restrictOffset = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.snapOffsets = [];
        this.gesture = {
            start: {
                x: 0,
                y: 0
            },
            startDistance: 0,
            prevDistance: 0,
            distance: 0,
            scale: 1,
            startAngle: 0,
            prevAngle: 0 // angle of the previous gesture event
        };
        this.snapStatus = {
            x: 0,
            y: 0,
            dx: 0,
            dy: 0,
            realX: 0,
            realY: 0,
            snappedX: 0,
            snappedY: 0,
            targets: [],
            locked: false,
            changed: false
        };
        this.restrictStatus = {
            dx: 0,
            dy: 0,
            restrictedX: 0,
            restrictedY: 0,
            snap: null,
            restricted: false,
            changed: false
        };
        this.restrictStatus.snap = this.snapStatus;
        this.pointerIsDown = false;
        this.pointerWasMoved = false;
        this.gesturing = false;
        this.dragging = false;
        this.resizing = false;
        this.resizeAxes = 'xy';
        this.mouse = false;
        interactions.push(this);
    }
    Interaction.prototype = {
        getPageXY: function(pointer, xy) {
            return getPageXY(pointer, xy, this);
        },
        getClientXY: function(pointer, xy) {
            return getClientXY(pointer, xy, this);
        },
        setEventXY: function(target, ptr) {
            return setEventXY(target, ptr, this);
        },
        pointerOver: function(pointer, event, eventTarget) {
            if (this.prepared.name || !this.mouse) return;
            var curMatches = [], curMatchElements = [], prevTargetElement = this.element;
            this.addPointer(pointer);
            if (this.target && (testIgnore(this.target, this.element, eventTarget) || !testAllow(this.target, this.element, eventTarget))) {
                // if the eventTarget should be ignored or shouldn't be allowed
                // clear the previous target
                this.target = null;
                this.element = null;
                this.matches = [];
                this.matchElements = [];
            }
            var elementInteractable = interactables.get(eventTarget), elementAction = elementInteractable && !testIgnore(elementInteractable, eventTarget, eventTarget) && testAllow(elementInteractable, eventTarget, eventTarget) && validateAction(elementInteractable.getAction(pointer, event, this, eventTarget), elementInteractable);
            if (elementAction && !withinInteractionLimit(elementInteractable, eventTarget, elementAction)) elementAction = null;
            function pushCurMatches(interactable, selector) {
                if (interactable && inContext(interactable, eventTarget) && !testIgnore(interactable, eventTarget, eventTarget) && testAllow(interactable, eventTarget, eventTarget) && matchesSelector(eventTarget, selector)) {
                    curMatches.push(interactable);
                    curMatchElements.push(eventTarget);
                }
            }
            if (elementAction) {
                this.target = elementInteractable;
                this.element = eventTarget;
                this.matches = [];
                this.matchElements = [];
            } else {
                interactables.forEachSelector(pushCurMatches);
                if (this.validateSelector(pointer, event, curMatches, curMatchElements)) {
                    this.matches = curMatches;
                    this.matchElements = curMatchElements;
                    this.pointerHover(pointer, event, this.matches, this.matchElements);
                    events.add(eventTarget, supportsPointerEvent ? pEventTypes.move : 'mousemove', listeners.pointerHover);
                } else if (this.target) {
                    if (nodeContains(prevTargetElement, eventTarget)) {
                        this.pointerHover(pointer, event, this.matches, this.matchElements);
                        events.add(this.element, supportsPointerEvent ? pEventTypes.move : 'mousemove', listeners.pointerHover);
                    } else {
                        this.target = null;
                        this.element = null;
                        this.matches = [];
                        this.matchElements = [];
                    }
                }
            }
        },
        // Check what action would be performed on pointerMove target if a mouse
        // button were pressed and change the cursor accordingly
        pointerHover: function(pointer, event, eventTarget, curEventTarget, matches, matchElements) {
            var target = this.target;
            if (!this.prepared.name && this.mouse) {
                var action;
                // update pointer coords for defaultActionChecker to use
                this.setEventXY(this.curCoords, [
                    pointer
                ]);
                if (matches) action = this.validateSelector(pointer, event, matches, matchElements);
                else if (target) action = validateAction(target.getAction(this.pointers[0], event, this, this.element), this.target);
                if (target && target.options.styleCursor) {
                    if (action) target._doc.documentElement.style.cursor = getActionCursor(action);
                    else target._doc.documentElement.style.cursor = '';
                }
            } else if (this.prepared.name) this.checkAndPreventDefault(event, target, this.element);
        },
        pointerOut: function(pointer, event, eventTarget) {
            if (this.prepared.name) return;
            // Remove temporary event listeners for selector Interactables
            if (!interactables.get(eventTarget)) events.remove(eventTarget, supportsPointerEvent ? pEventTypes.move : 'mousemove', listeners.pointerHover);
            if (this.target && this.target.options.styleCursor && !this.interacting()) this.target._doc.documentElement.style.cursor = '';
        },
        selectorDown: function(pointer, event, eventTarget, curEventTarget) {
            var that = this, // copy event to be used in timeout for IE8
            eventCopy = events.useAttachEvent ? extend({}, event) : event, element = eventTarget, pointerIndex = this.addPointer(pointer), action;
            this.holdTimers[pointerIndex] = setTimeout(function() {
                that.pointerHold(events.useAttachEvent ? eventCopy : pointer, eventCopy, eventTarget, curEventTarget);
            }, defaultOptions._holdDuration);
            this.pointerIsDown = true;
            // Check if the down event hits the current inertia target
            if (this.inertiaStatus.active && this.target.selector) // climb up the DOM tree from the event target
            while(isElement(element)){
                // if this element is the current inertia target element
                if (element === this.element && validateAction(this.target.getAction(pointer, event, this, this.element), this.target).name === this.prepared.name) {
                    // stop inertia so that the next move will be a normal one
                    cancelFrame(this.inertiaStatus.i);
                    this.inertiaStatus.active = false;
                    this.collectEventTargets(pointer, event, eventTarget, 'down');
                    return;
                }
                element = parentElement(element);
            }
            // do nothing if interacting
            if (this.interacting()) {
                this.collectEventTargets(pointer, event, eventTarget, 'down');
                return;
            }
            function pushMatches(interactable, selector, context) {
                var elements = ie8MatchesSelector ? context.querySelectorAll(selector) : undefined;
                if (inContext(interactable, element) && !testIgnore(interactable, element, eventTarget) && testAllow(interactable, element, eventTarget) && matchesSelector(element, selector, elements)) {
                    that.matches.push(interactable);
                    that.matchElements.push(element);
                }
            }
            // update pointer coords for defaultActionChecker to use
            this.setEventXY(this.curCoords, [
                pointer
            ]);
            this.downEvent = event;
            while(isElement(element) && !action){
                this.matches = [];
                this.matchElements = [];
                interactables.forEachSelector(pushMatches);
                action = this.validateSelector(pointer, event, this.matches, this.matchElements);
                element = parentElement(element);
            }
            if (action) {
                this.prepared.name = action.name;
                this.prepared.axis = action.axis;
                this.prepared.edges = action.edges;
                this.collectEventTargets(pointer, event, eventTarget, 'down');
                return this.pointerDown(pointer, event, eventTarget, curEventTarget, action);
            } else {
                // do these now since pointerDown isn't being called from here
                this.downTimes[pointerIndex] = new Date().getTime();
                this.downTargets[pointerIndex] = eventTarget;
                pointerExtend(this.downPointer, pointer);
                copyCoords(this.prevCoords, this.curCoords);
                this.pointerWasMoved = false;
            }
            this.collectEventTargets(pointer, event, eventTarget, 'down');
        },
        // Determine action to be performed on next pointerMove and add appropriate
        // style and event Listeners
        pointerDown: function(pointer, event, eventTarget, curEventTarget, forceAction) {
            if (!forceAction && !this.inertiaStatus.active && this.pointerWasMoved && this.prepared.name) {
                this.checkAndPreventDefault(event, this.target, this.element);
                return;
            }
            this.pointerIsDown = true;
            this.downEvent = event;
            var pointerIndex = this.addPointer(pointer), action;
            // If it is the second touch of a multi-touch gesture, keep the
            // target the same and get a new action if a target was set by the
            // first touch
            if (this.pointerIds.length > 1 && this.target._element === this.element) {
                var newAction = validateAction(forceAction || this.target.getAction(pointer, event, this, this.element), this.target);
                if (withinInteractionLimit(this.target, this.element, newAction)) action = newAction;
                this.prepared.name = null;
            } else if (!this.prepared.name) {
                var interactable = interactables.get(curEventTarget);
                if (interactable && !testIgnore(interactable, curEventTarget, eventTarget) && testAllow(interactable, curEventTarget, eventTarget) && (action = validateAction(forceAction || interactable.getAction(pointer, event, this, curEventTarget), interactable, eventTarget)) && withinInteractionLimit(interactable, curEventTarget, action)) {
                    this.target = interactable;
                    this.element = curEventTarget;
                }
            }
            var target = this.target, options = target && target.options;
            if (target && (forceAction || !this.prepared.name)) {
                action = action || validateAction(forceAction || target.getAction(pointer, event, this, curEventTarget), target, this.element);
                this.setEventXY(this.startCoords, this.pointers);
                if (!action) return;
                if (options.styleCursor) target._doc.documentElement.style.cursor = getActionCursor(action);
                this.resizeAxes = action.name === 'resize' ? action.axis : null;
                if (action === 'gesture' && this.pointerIds.length < 2) action = null;
                this.prepared.name = action.name;
                this.prepared.axis = action.axis;
                this.prepared.edges = action.edges;
                this.snapStatus.snappedX = this.snapStatus.snappedY = this.restrictStatus.restrictedX = this.restrictStatus.restrictedY = NaN;
                this.downTimes[pointerIndex] = new Date().getTime();
                this.downTargets[pointerIndex] = eventTarget;
                pointerExtend(this.downPointer, pointer);
                copyCoords(this.prevCoords, this.startCoords);
                this.pointerWasMoved = false;
                this.checkAndPreventDefault(event, target, this.element);
            } else if (this.inertiaStatus.active && curEventTarget === this.element && validateAction(target.getAction(pointer, event, this, this.element), target).name === this.prepared.name) {
                cancelFrame(this.inertiaStatus.i);
                this.inertiaStatus.active = false;
                this.checkAndPreventDefault(event, target, this.element);
            }
        },
        setModifications: function(coords, preEnd) {
            var target = this.target, shouldMove = true, shouldSnap = checkSnap(target, this.prepared.name) && (!target.options[this.prepared.name].snap.endOnly || preEnd), shouldRestrict = checkRestrict(target, this.prepared.name) && (!target.options[this.prepared.name].restrict.endOnly || preEnd);
            if (shouldSnap) this.setSnapping(coords);
            else this.snapStatus.locked = false;
            if (shouldRestrict) this.setRestriction(coords);
            else this.restrictStatus.restricted = false;
            if (shouldSnap && this.snapStatus.locked && !this.snapStatus.changed) shouldMove = shouldRestrict && this.restrictStatus.restricted && this.restrictStatus.changed;
            else if (shouldRestrict && this.restrictStatus.restricted && !this.restrictStatus.changed) shouldMove = false;
            return shouldMove;
        },
        setStartOffsets: function(action, interactable, element) {
            var rect = interactable.getRect(element), origin = getOriginXY(interactable, element), snap = interactable.options[this.prepared.name].snap, restrict = interactable.options[this.prepared.name].restrict, width, height;
            if (rect) {
                this.startOffset.left = this.startCoords.page.x - rect.left;
                this.startOffset.top = this.startCoords.page.y - rect.top;
                this.startOffset.right = rect.right - this.startCoords.page.x;
                this.startOffset.bottom = rect.bottom - this.startCoords.page.y;
                if ('width' in rect) width = rect.width;
                else width = rect.right - rect.left;
                if ('height' in rect) height = rect.height;
                else height = rect.bottom - rect.top;
            } else this.startOffset.left = this.startOffset.top = this.startOffset.right = this.startOffset.bottom = 0;
            this.snapOffsets.splice(0);
            var snapOffset = snap && snap.offset === 'startCoords' ? {
                x: this.startCoords.page.x - origin.x,
                y: this.startCoords.page.y - origin.y
            } : snap && snap.offset || {
                x: 0,
                y: 0
            };
            if (rect && snap && snap.relativePoints && snap.relativePoints.length) for(var i = 0; i < snap.relativePoints.length; i++)this.snapOffsets.push({
                x: this.startOffset.left - width * snap.relativePoints[i].x + snapOffset.x,
                y: this.startOffset.top - height * snap.relativePoints[i].y + snapOffset.y
            });
            else this.snapOffsets.push(snapOffset);
            if (rect && restrict.elementRect) {
                this.restrictOffset.left = this.startOffset.left - width * restrict.elementRect.left;
                this.restrictOffset.top = this.startOffset.top - height * restrict.elementRect.top;
                this.restrictOffset.right = this.startOffset.right - width * (1 - restrict.elementRect.right);
                this.restrictOffset.bottom = this.startOffset.bottom - height * (1 - restrict.elementRect.bottom);
            } else this.restrictOffset.left = this.restrictOffset.top = this.restrictOffset.right = this.restrictOffset.bottom = 0;
        },
        /*\
         * Interaction.start
         [ method ]
         *
         * Start an action with the given Interactable and Element as tartgets. The
         * action must be enabled for the target Interactable and an appropriate number
         * of pointers must be held down – 1 for drag/resize, 2 for gesture.
         *
         * Use it with `interactable.<action>able({ manualStart: false })` to always
         * [start actions manually](https://github.com/taye/interact.js/issues/114)
         *
         - action       (object)  The action to be performed - drag, resize, etc.
         - interactable (Interactable) The Interactable to target
         - element      (Element) The DOM Element to target
         = (object) interact
         **
         | interact(target)
         |   .draggable({
         |     // disable the default drag start by down->move
         |     manualStart: true
         |   })
         |   // start dragging after the user holds the pointer down
         |   .on('hold', function (event) {
         |     var interaction = event.interaction;
         |
         |     if (!interaction.interacting()) {
         |       interaction.start({ name: 'drag' },
         |                         event.interactable,
         |                         event.currentTarget);
         |     }
         | });
        \*/ start: function(action, interactable, element) {
            if (this.interacting() || !this.pointerIsDown || this.pointerIds.length < (action.name === 'gesture' ? 2 : 1)) return;
            // if this interaction had been removed after stopping
            // add it back
            if (indexOf(interactions, this) === -1) interactions.push(this);
            // set the startCoords if there was no prepared action
            if (!this.prepared.name) this.setEventXY(this.startCoords, this.pointers);
            this.prepared.name = action.name;
            this.prepared.axis = action.axis;
            this.prepared.edges = action.edges;
            this.target = interactable;
            this.element = element;
            this.setStartOffsets(action.name, interactable, element);
            this.setModifications(this.startCoords.page);
            this.prevEvent = this[this.prepared.name + 'Start'](this.downEvent);
        },
        pointerMove: function(pointer, event, eventTarget, curEventTarget, preEnd) {
            if (this.inertiaStatus.active) {
                var pageUp = this.inertiaStatus.upCoords.page;
                var clientUp = this.inertiaStatus.upCoords.client;
                var inertiaPosition = {
                    pageX: pageUp.x + this.inertiaStatus.sx,
                    pageY: pageUp.y + this.inertiaStatus.sy,
                    clientX: clientUp.x + this.inertiaStatus.sx,
                    clientY: clientUp.y + this.inertiaStatus.sy
                };
                this.setEventXY(this.curCoords, [
                    inertiaPosition
                ]);
            } else {
                this.recordPointer(pointer);
                this.setEventXY(this.curCoords, this.pointers);
            }
            var duplicateMove = this.curCoords.page.x === this.prevCoords.page.x && this.curCoords.page.y === this.prevCoords.page.y && this.curCoords.client.x === this.prevCoords.client.x && this.curCoords.client.y === this.prevCoords.client.y;
            var dx, dy, pointerIndex = this.mouse ? 0 : indexOf(this.pointerIds, getPointerId(pointer));
            // register movement greater than pointerMoveTolerance
            if (this.pointerIsDown && !this.pointerWasMoved) {
                dx = this.curCoords.client.x - this.startCoords.client.x;
                dy = this.curCoords.client.y - this.startCoords.client.y;
                this.pointerWasMoved = hypot(dx, dy) > pointerMoveTolerance;
            }
            if (!duplicateMove && (!this.pointerIsDown || this.pointerWasMoved)) {
                if (this.pointerIsDown) clearTimeout(this.holdTimers[pointerIndex]);
                this.collectEventTargets(pointer, event, eventTarget, 'move');
            }
            if (!this.pointerIsDown) return;
            if (duplicateMove && this.pointerWasMoved && !preEnd) {
                this.checkAndPreventDefault(event, this.target, this.element);
                return;
            }
            // set pointer coordinate, time changes and speeds
            setEventDeltas(this.pointerDelta, this.prevCoords, this.curCoords);
            if (!this.prepared.name) return;
            if (this.pointerWasMoved && (!this.inertiaStatus.active || pointer instanceof InteractEvent && /inertiastart/.test(pointer.type))) {
                // if just starting an action, calculate the pointer speed now
                if (!this.interacting()) {
                    setEventDeltas(this.pointerDelta, this.prevCoords, this.curCoords);
                    // check if a drag is in the correct axis
                    if (this.prepared.name === 'drag') {
                        var absX = Math.abs(dx), absY = Math.abs(dy), targetAxis = this.target.options.drag.axis, axis = absX > absY ? 'x' : absX < absY ? 'y' : 'xy';
                        // if the movement isn't in the axis of the interactable
                        if (axis !== 'xy' && targetAxis !== 'xy' && targetAxis !== axis) {
                            // cancel the prepared action
                            this.prepared.name = null;
                            // then try to get a drag from another ineractable
                            var element = eventTarget;
                            // check element interactables
                            while(isElement(element)){
                                var elementInteractable = interactables.get(element);
                                if (elementInteractable && elementInteractable !== this.target && !elementInteractable.options.drag.manualStart && elementInteractable.getAction(this.downPointer, this.downEvent, this, element).name === 'drag' && checkAxis(axis, elementInteractable)) {
                                    this.prepared.name = 'drag';
                                    this.target = elementInteractable;
                                    this.element = element;
                                    break;
                                }
                                element = parentElement(element);
                            }
                            // if there's no drag from element interactables,
                            // check the selector interactables
                            if (!this.prepared.name) {
                                var thisInteraction = this;
                                var getDraggable = function(interactable, selector, context) {
                                    var elements = ie8MatchesSelector ? context.querySelectorAll(selector) : undefined;
                                    if (interactable === thisInteraction.target) return;
                                    if (inContext(interactable, eventTarget) && !interactable.options.drag.manualStart && !testIgnore(interactable, element, eventTarget) && testAllow(interactable, element, eventTarget) && matchesSelector(element, selector, elements) && interactable.getAction(thisInteraction.downPointer, thisInteraction.downEvent, thisInteraction, element).name === 'drag' && checkAxis(axis, interactable) && withinInteractionLimit(interactable, element, 'drag')) return interactable;
                                };
                                element = eventTarget;
                                while(isElement(element)){
                                    var selectorInteractable = interactables.forEachSelector(getDraggable);
                                    if (selectorInteractable) {
                                        this.prepared.name = 'drag';
                                        this.target = selectorInteractable;
                                        this.element = element;
                                        break;
                                    }
                                    element = parentElement(element);
                                }
                            }
                        }
                    }
                }
                var starting = !!this.prepared.name && !this.interacting();
                if (starting && (this.target.options[this.prepared.name].manualStart || !withinInteractionLimit(this.target, this.element, this.prepared))) {
                    this.stop(event);
                    return;
                }
                if (this.prepared.name && this.target) {
                    if (starting) this.start(this.prepared, this.target, this.element);
                    var shouldMove = this.setModifications(this.curCoords.page, preEnd);
                    // move if snapping or restriction doesn't prevent it
                    if (shouldMove || starting) this.prevEvent = this[this.prepared.name + 'Move'](event);
                    this.checkAndPreventDefault(event, this.target, this.element);
                }
            }
            copyCoords(this.prevCoords, this.curCoords);
            if (this.dragging || this.resizing) this.autoScrollMove(pointer);
        },
        dragStart: function(event) {
            var dragEvent = new InteractEvent(this, event, 'drag', 'start', this.element);
            this.dragging = true;
            this.target.fire(dragEvent);
            // reset active dropzones
            this.activeDrops.dropzones = [];
            this.activeDrops.elements = [];
            this.activeDrops.rects = [];
            if (!this.dynamicDrop) this.setActiveDrops(this.element);
            var dropEvents = this.getDropEvents(event, dragEvent);
            if (dropEvents.activate) this.fireActiveDrops(dropEvents.activate);
            return dragEvent;
        },
        dragMove: function(event) {
            var target = this.target, dragEvent = new InteractEvent(this, event, 'drag', 'move', this.element), draggableElement = this.element, drop = this.getDrop(dragEvent, event, draggableElement);
            this.dropTarget = drop.dropzone;
            this.dropElement = drop.element;
            var dropEvents = this.getDropEvents(event, dragEvent);
            target.fire(dragEvent);
            if (dropEvents.leave) this.prevDropTarget.fire(dropEvents.leave);
            if (dropEvents.enter) this.dropTarget.fire(dropEvents.enter);
            if (dropEvents.move) this.dropTarget.fire(dropEvents.move);
            this.prevDropTarget = this.dropTarget;
            this.prevDropElement = this.dropElement;
            return dragEvent;
        },
        resizeStart: function(event) {
            var resizeEvent = new InteractEvent(this, event, 'resize', 'start', this.element);
            if (this.prepared.edges) {
                var startRect = this.target.getRect(this.element);
                /*
                 * When using the `resizable.square` or `resizable.preserveAspectRatio` options, resizing from one edge
                 * will affect another. E.g. with `resizable.square`, resizing to make the right edge larger will make
                 * the bottom edge larger by the same amount. We call these 'linked' edges. Any linked edges will depend
                 * on the active edges and the edge being interacted with.
                 */ if (this.target.options.resize.square || this.target.options.resize.preserveAspectRatio) {
                    var linkedEdges = extend({}, this.prepared.edges);
                    linkedEdges.top = linkedEdges.top || linkedEdges.left && !linkedEdges.bottom;
                    linkedEdges.left = linkedEdges.left || linkedEdges.top && !linkedEdges.right;
                    linkedEdges.bottom = linkedEdges.bottom || linkedEdges.right && !linkedEdges.top;
                    linkedEdges.right = linkedEdges.right || linkedEdges.bottom && !linkedEdges.left;
                    this.prepared._linkedEdges = linkedEdges;
                } else this.prepared._linkedEdges = null;
                // if using `resizable.preserveAspectRatio` option, record aspect ratio at the start of the resize
                if (this.target.options.resize.preserveAspectRatio) this.resizeStartAspectRatio = startRect.width / startRect.height;
                this.resizeRects = {
                    start: startRect,
                    current: extend({}, startRect),
                    restricted: extend({}, startRect),
                    previous: extend({}, startRect),
                    delta: {
                        left: 0,
                        right: 0,
                        width: 0,
                        top: 0,
                        bottom: 0,
                        height: 0
                    }
                };
                resizeEvent.rect = this.resizeRects.restricted;
                resizeEvent.deltaRect = this.resizeRects.delta;
            }
            this.target.fire(resizeEvent);
            this.resizing = true;
            return resizeEvent;
        },
        resizeMove: function(event) {
            var resizeEvent = new InteractEvent(this, event, 'resize', 'move', this.element);
            var edges = this.prepared.edges, invert = this.target.options.resize.invert, invertible = invert === 'reposition' || invert === 'negate';
            if (edges) {
                var dx = resizeEvent.dx, dy = resizeEvent.dy, start = this.resizeRects.start, current = this.resizeRects.current, restricted = this.resizeRects.restricted, delta = this.resizeRects.delta, previous = extend(this.resizeRects.previous, restricted), originalEdges = edges;
                // `resize.preserveAspectRatio` takes precedence over `resize.square`
                if (this.target.options.resize.preserveAspectRatio) {
                    var resizeStartAspectRatio = this.resizeStartAspectRatio;
                    edges = this.prepared._linkedEdges;
                    if (originalEdges.left && originalEdges.bottom || originalEdges.right && originalEdges.top) dy = -dx / resizeStartAspectRatio;
                    else if (originalEdges.left || originalEdges.right) dy = dx / resizeStartAspectRatio;
                    else if (originalEdges.top || originalEdges.bottom) dx = dy * resizeStartAspectRatio;
                } else if (this.target.options.resize.square) {
                    edges = this.prepared._linkedEdges;
                    if (originalEdges.left && originalEdges.bottom || originalEdges.right && originalEdges.top) dy = -dx;
                    else if (originalEdges.left || originalEdges.right) dy = dx;
                    else if (originalEdges.top || originalEdges.bottom) dx = dy;
                }
                // update the 'current' rect without modifications
                if (edges.top) current.top += dy;
                if (edges.bottom) current.bottom += dy;
                if (edges.left) current.left += dx;
                if (edges.right) current.right += dx;
                if (invertible) {
                    // if invertible, copy the current rect
                    extend(restricted, current);
                    if (invert === 'reposition') {
                        // swap edge values if necessary to keep width/height positive
                        var swap;
                        if (restricted.top > restricted.bottom) {
                            swap = restricted.top;
                            restricted.top = restricted.bottom;
                            restricted.bottom = swap;
                        }
                        if (restricted.left > restricted.right) {
                            swap = restricted.left;
                            restricted.left = restricted.right;
                            restricted.right = swap;
                        }
                    }
                } else {
                    // if not invertible, restrict to minimum of 0x0 rect
                    restricted.top = Math.min(current.top, start.bottom);
                    restricted.bottom = Math.max(current.bottom, start.top);
                    restricted.left = Math.min(current.left, start.right);
                    restricted.right = Math.max(current.right, start.left);
                }
                restricted.width = restricted.right - restricted.left;
                restricted.height = restricted.bottom - restricted.top;
                for(var edge in restricted)delta[edge] = restricted[edge] - previous[edge];
                resizeEvent.edges = this.prepared.edges;
                resizeEvent.rect = restricted;
                resizeEvent.deltaRect = delta;
            }
            this.target.fire(resizeEvent);
            return resizeEvent;
        },
        gestureStart: function(event) {
            var gestureEvent = new InteractEvent(this, event, 'gesture', 'start', this.element);
            gestureEvent.ds = 0;
            this.gesture.startDistance = this.gesture.prevDistance = gestureEvent.distance;
            this.gesture.startAngle = this.gesture.prevAngle = gestureEvent.angle;
            this.gesture.scale = 1;
            this.gesturing = true;
            this.target.fire(gestureEvent);
            return gestureEvent;
        },
        gestureMove: function(event) {
            if (!this.pointerIds.length) return this.prevEvent;
            var gestureEvent;
            gestureEvent = new InteractEvent(this, event, 'gesture', 'move', this.element);
            gestureEvent.ds = gestureEvent.scale - this.gesture.scale;
            this.target.fire(gestureEvent);
            this.gesture.prevAngle = gestureEvent.angle;
            this.gesture.prevDistance = gestureEvent.distance;
            if (gestureEvent.scale !== Infinity && gestureEvent.scale !== null && gestureEvent.scale !== undefined && !isNaN(gestureEvent.scale)) this.gesture.scale = gestureEvent.scale;
            return gestureEvent;
        },
        pointerHold: function(pointer, event, eventTarget) {
            this.collectEventTargets(pointer, event, eventTarget, 'hold');
        },
        pointerUp: function(pointer, event, eventTarget, curEventTarget) {
            var pointerIndex = this.mouse ? 0 : indexOf(this.pointerIds, getPointerId(pointer));
            clearTimeout(this.holdTimers[pointerIndex]);
            this.collectEventTargets(pointer, event, eventTarget, 'up');
            this.collectEventTargets(pointer, event, eventTarget, 'tap');
            this.pointerEnd(pointer, event, eventTarget, curEventTarget);
            this.removePointer(pointer);
        },
        pointerCancel: function(pointer, event, eventTarget, curEventTarget) {
            var pointerIndex = this.mouse ? 0 : indexOf(this.pointerIds, getPointerId(pointer));
            clearTimeout(this.holdTimers[pointerIndex]);
            this.collectEventTargets(pointer, event, eventTarget, 'cancel');
            this.pointerEnd(pointer, event, eventTarget, curEventTarget);
            this.removePointer(pointer);
        },
        // http://www.quirksmode.org/dom/events/click.html
        // >Events leading to dblclick
        //
        // IE8 doesn't fire down event before dblclick.
        // This workaround tries to fire a tap and doubletap after dblclick
        ie8Dblclick: function(pointer, event, eventTarget) {
            if (this.prevTap && event.clientX === this.prevTap.clientX && event.clientY === this.prevTap.clientY && eventTarget === this.prevTap.target) {
                this.downTargets[0] = eventTarget;
                this.downTimes[0] = new Date().getTime();
                this.collectEventTargets(pointer, event, eventTarget, 'tap');
            }
        },
        // End interact move events and stop auto-scroll unless inertia is enabled
        pointerEnd: function(pointer, event, eventTarget, curEventTarget) {
            var endEvent, target = this.target, options = target && target.options, inertiaOptions = options && this.prepared.name && options[this.prepared.name].inertia, inertiaStatus = this.inertiaStatus;
            if (this.interacting()) {
                if (inertiaStatus.active && !inertiaStatus.ending) return;
                var pointerSpeed, now = new Date().getTime(), inertiaPossible = false, inertia = false, smoothEnd = false, endSnap = checkSnap(target, this.prepared.name) && options[this.prepared.name].snap.endOnly, endRestrict = checkRestrict(target, this.prepared.name) && options[this.prepared.name].restrict.endOnly, dx = 0, dy = 0, startEvent;
                if (this.dragging) {
                    if (options.drag.axis === 'x') pointerSpeed = Math.abs(this.pointerDelta.client.vx);
                    else if (options.drag.axis === 'y') pointerSpeed = Math.abs(this.pointerDelta.client.vy);
                    else pointerSpeed = this.pointerDelta.client.speed;
                } else pointerSpeed = this.pointerDelta.client.speed;
                // check if inertia should be started
                inertiaPossible = inertiaOptions && inertiaOptions.enabled && this.prepared.name !== 'gesture' && event !== inertiaStatus.startEvent;
                inertia = inertiaPossible && now - this.curCoords.timeStamp < 50 && pointerSpeed > inertiaOptions.minSpeed && pointerSpeed > inertiaOptions.endSpeed;
                if (inertiaPossible && !inertia && (endSnap || endRestrict)) {
                    var snapRestrict = {};
                    snapRestrict.snap = snapRestrict.restrict = snapRestrict;
                    if (endSnap) {
                        this.setSnapping(this.curCoords.page, snapRestrict);
                        if (snapRestrict.locked) {
                            dx += snapRestrict.dx;
                            dy += snapRestrict.dy;
                        }
                    }
                    if (endRestrict) {
                        this.setRestriction(this.curCoords.page, snapRestrict);
                        if (snapRestrict.restricted) {
                            dx += snapRestrict.dx;
                            dy += snapRestrict.dy;
                        }
                    }
                    if (dx || dy) smoothEnd = true;
                }
                if (inertia || smoothEnd) {
                    copyCoords(inertiaStatus.upCoords, this.curCoords);
                    this.pointers[0] = inertiaStatus.startEvent = startEvent = new InteractEvent(this, event, this.prepared.name, 'inertiastart', this.element);
                    inertiaStatus.t0 = now;
                    target.fire(inertiaStatus.startEvent);
                    if (inertia) {
                        inertiaStatus.vx0 = this.pointerDelta.client.vx;
                        inertiaStatus.vy0 = this.pointerDelta.client.vy;
                        inertiaStatus.v0 = pointerSpeed;
                        this.calcInertia(inertiaStatus);
                        var page = extend({}, this.curCoords.page), origin = getOriginXY(target, this.element), statusObject;
                        page.x = page.x + inertiaStatus.xe - origin.x;
                        page.y = page.y + inertiaStatus.ye - origin.y;
                        statusObject = {
                            useStatusXY: true,
                            x: page.x,
                            y: page.y,
                            dx: 0,
                            dy: 0,
                            snap: null
                        };
                        statusObject.snap = statusObject;
                        dx = dy = 0;
                        if (endSnap) {
                            var snap = this.setSnapping(this.curCoords.page, statusObject);
                            if (snap.locked) {
                                dx += snap.dx;
                                dy += snap.dy;
                            }
                        }
                        if (endRestrict) {
                            var restrict = this.setRestriction(this.curCoords.page, statusObject);
                            if (restrict.restricted) {
                                dx += restrict.dx;
                                dy += restrict.dy;
                            }
                        }
                        inertiaStatus.modifiedXe += dx;
                        inertiaStatus.modifiedYe += dy;
                        inertiaStatus.i = reqFrame(this.boundInertiaFrame);
                    } else {
                        inertiaStatus.smoothEnd = true;
                        inertiaStatus.xe = dx;
                        inertiaStatus.ye = dy;
                        inertiaStatus.sx = inertiaStatus.sy = 0;
                        inertiaStatus.i = reqFrame(this.boundSmoothEndFrame);
                    }
                    inertiaStatus.active = true;
                    return;
                }
                if (endSnap || endRestrict) // fire a move event at the snapped coordinates
                this.pointerMove(pointer, event, eventTarget, curEventTarget, true);
            }
            if (this.dragging) {
                endEvent = new InteractEvent(this, event, 'drag', 'end', this.element);
                var draggableElement = this.element, drop = this.getDrop(endEvent, event, draggableElement);
                this.dropTarget = drop.dropzone;
                this.dropElement = drop.element;
                var dropEvents = this.getDropEvents(event, endEvent);
                if (dropEvents.leave) this.prevDropTarget.fire(dropEvents.leave);
                if (dropEvents.enter) this.dropTarget.fire(dropEvents.enter);
                if (dropEvents.drop) this.dropTarget.fire(dropEvents.drop);
                if (dropEvents.deactivate) this.fireActiveDrops(dropEvents.deactivate);
                target.fire(endEvent);
            } else if (this.resizing) {
                endEvent = new InteractEvent(this, event, 'resize', 'end', this.element);
                target.fire(endEvent);
            } else if (this.gesturing) {
                endEvent = new InteractEvent(this, event, 'gesture', 'end', this.element);
                target.fire(endEvent);
            }
            this.stop(event);
        },
        collectDrops: function(element) {
            var drops = [], elements = [], i;
            element = element || this.element;
            // collect all dropzones and their elements which qualify for a drop
            for(i = 0; i < interactables.length; i++){
                if (!interactables[i].options.drop.enabled) continue;
                var current = interactables[i], accept = current.options.drop.accept;
                // test the draggable element against the dropzone's accept setting
                if (isElement(accept) && accept !== element || isString(accept) && !matchesSelector(element, accept)) continue;
                // query for new elements if necessary
                var dropElements = current.selector ? current._context.querySelectorAll(current.selector) : [
                    current._element
                ];
                for(var j = 0, len = dropElements.length; j < len; j++){
                    var currentElement = dropElements[j];
                    if (currentElement === element) continue;
                    drops.push(current);
                    elements.push(currentElement);
                }
            }
            return {
                dropzones: drops,
                elements: elements
            };
        },
        fireActiveDrops: function(event) {
            var i, current, currentElement, prevElement;
            // loop through all active dropzones and trigger event
            for(i = 0; i < this.activeDrops.dropzones.length; i++){
                current = this.activeDrops.dropzones[i];
                currentElement = this.activeDrops.elements[i];
                // prevent trigger of duplicate events on same element
                if (currentElement !== prevElement) {
                    // set current element as event target
                    event.target = currentElement;
                    current.fire(event);
                }
                prevElement = currentElement;
            }
        },
        // Collect a new set of possible drops and save them in activeDrops.
        // setActiveDrops should always be called when a drag has just started or a
        // drag event happens while dynamicDrop is true
        setActiveDrops: function(dragElement) {
            // get dropzones and their elements that could receive the draggable
            var possibleDrops = this.collectDrops(dragElement, true);
            this.activeDrops.dropzones = possibleDrops.dropzones;
            this.activeDrops.elements = possibleDrops.elements;
            this.activeDrops.rects = [];
            for(var i = 0; i < this.activeDrops.dropzones.length; i++)this.activeDrops.rects[i] = this.activeDrops.dropzones[i].getRect(this.activeDrops.elements[i]);
        },
        getDrop: function(dragEvent, event, dragElement) {
            var validDrops = [];
            if (dynamicDrop) this.setActiveDrops(dragElement);
            // collect all dropzones and their elements which qualify for a drop
            for(var j = 0; j < this.activeDrops.dropzones.length; j++){
                var current = this.activeDrops.dropzones[j], currentElement = this.activeDrops.elements[j], rect = this.activeDrops.rects[j];
                validDrops.push(current.dropCheck(dragEvent, event, this.target, dragElement, currentElement, rect) ? currentElement : null);
            }
            // get the most appropriate dropzone based on DOM depth and order
            var dropIndex = indexOfDeepestElement(validDrops), dropzone = this.activeDrops.dropzones[dropIndex] || null, element = this.activeDrops.elements[dropIndex] || null;
            return {
                dropzone: dropzone,
                element: element
            };
        },
        getDropEvents: function(pointerEvent, dragEvent) {
            var dropEvents = {
                enter: null,
                leave: null,
                activate: null,
                deactivate: null,
                move: null,
                drop: null
            };
            if (this.dropElement !== this.prevDropElement) {
                // if there was a prevDropTarget, create a dragleave event
                if (this.prevDropTarget) {
                    dropEvents.leave = {
                        target: this.prevDropElement,
                        dropzone: this.prevDropTarget,
                        relatedTarget: dragEvent.target,
                        draggable: dragEvent.interactable,
                        dragEvent: dragEvent,
                        interaction: this,
                        timeStamp: dragEvent.timeStamp,
                        type: 'dragleave'
                    };
                    dragEvent.dragLeave = this.prevDropElement;
                    dragEvent.prevDropzone = this.prevDropTarget;
                }
                // if the dropTarget is not null, create a dragenter event
                if (this.dropTarget) {
                    dropEvents.enter = {
                        target: this.dropElement,
                        dropzone: this.dropTarget,
                        relatedTarget: dragEvent.target,
                        draggable: dragEvent.interactable,
                        dragEvent: dragEvent,
                        interaction: this,
                        timeStamp: dragEvent.timeStamp,
                        type: 'dragenter'
                    };
                    dragEvent.dragEnter = this.dropElement;
                    dragEvent.dropzone = this.dropTarget;
                }
            }
            if (dragEvent.type === 'dragend' && this.dropTarget) {
                dropEvents.drop = {
                    target: this.dropElement,
                    dropzone: this.dropTarget,
                    relatedTarget: dragEvent.target,
                    draggable: dragEvent.interactable,
                    dragEvent: dragEvent,
                    interaction: this,
                    timeStamp: dragEvent.timeStamp,
                    type: 'drop'
                };
                dragEvent.dropzone = this.dropTarget;
            }
            if (dragEvent.type === 'dragstart') dropEvents.activate = {
                target: null,
                dropzone: null,
                relatedTarget: dragEvent.target,
                draggable: dragEvent.interactable,
                dragEvent: dragEvent,
                interaction: this,
                timeStamp: dragEvent.timeStamp,
                type: 'dropactivate'
            };
            if (dragEvent.type === 'dragend') dropEvents.deactivate = {
                target: null,
                dropzone: null,
                relatedTarget: dragEvent.target,
                draggable: dragEvent.interactable,
                dragEvent: dragEvent,
                interaction: this,
                timeStamp: dragEvent.timeStamp,
                type: 'dropdeactivate'
            };
            if (dragEvent.type === 'dragmove' && this.dropTarget) {
                dropEvents.move = {
                    target: this.dropElement,
                    dropzone: this.dropTarget,
                    relatedTarget: dragEvent.target,
                    draggable: dragEvent.interactable,
                    dragEvent: dragEvent,
                    interaction: this,
                    dragmove: dragEvent,
                    timeStamp: dragEvent.timeStamp,
                    type: 'dropmove'
                };
                dragEvent.dropzone = this.dropTarget;
            }
            return dropEvents;
        },
        currentAction: function() {
            return this.dragging && 'drag' || this.resizing && 'resize' || this.gesturing && 'gesture' || null;
        },
        interacting: function() {
            return this.dragging || this.resizing || this.gesturing;
        },
        clearTargets: function() {
            this.target = this.element = null;
            this.dropTarget = this.dropElement = this.prevDropTarget = this.prevDropElement = null;
        },
        stop: function(event) {
            if (this.interacting()) {
                autoScroll.stop();
                this.matches = [];
                this.matchElements = [];
                var target = this.target;
                if (target.options.styleCursor) target._doc.documentElement.style.cursor = '';
                // prevent Default only if were previously interacting
                if (event && isFunction(event.preventDefault)) this.checkAndPreventDefault(event, target, this.element);
                if (this.dragging) this.activeDrops.dropzones = this.activeDrops.elements = this.activeDrops.rects = null;
            }
            this.clearTargets();
            this.pointerIsDown = this.snapStatus.locked = this.dragging = this.resizing = this.gesturing = false;
            this.prepared.name = this.prevEvent = null;
            this.inertiaStatus.resumeDx = this.inertiaStatus.resumeDy = 0;
            // remove pointers if their ID isn't in this.pointerIds
            for(var i = 0; i < this.pointers.length; i++)if (indexOf(this.pointerIds, getPointerId(this.pointers[i])) === -1) this.pointers.splice(i, 1);
        },
        inertiaFrame: function() {
            var inertiaStatus = this.inertiaStatus, options = this.target.options[this.prepared.name].inertia, lambda = options.resistance, t = new Date().getTime() / 1000 - inertiaStatus.t0;
            if (t < inertiaStatus.te) {
                var progress = 1 - (Math.exp(-lambda * t) - inertiaStatus.lambda_v0) / inertiaStatus.one_ve_v0;
                if (inertiaStatus.modifiedXe === inertiaStatus.xe && inertiaStatus.modifiedYe === inertiaStatus.ye) {
                    inertiaStatus.sx = inertiaStatus.xe * progress;
                    inertiaStatus.sy = inertiaStatus.ye * progress;
                } else {
                    var quadPoint = getQuadraticCurvePoint(0, 0, inertiaStatus.xe, inertiaStatus.ye, inertiaStatus.modifiedXe, inertiaStatus.modifiedYe, progress);
                    inertiaStatus.sx = quadPoint.x;
                    inertiaStatus.sy = quadPoint.y;
                }
                this.pointerMove(inertiaStatus.startEvent, inertiaStatus.startEvent);
                inertiaStatus.i = reqFrame(this.boundInertiaFrame);
            } else {
                inertiaStatus.ending = true;
                inertiaStatus.sx = inertiaStatus.modifiedXe;
                inertiaStatus.sy = inertiaStatus.modifiedYe;
                this.pointerMove(inertiaStatus.startEvent, inertiaStatus.startEvent);
                this.pointerEnd(inertiaStatus.startEvent, inertiaStatus.startEvent);
                inertiaStatus.active = inertiaStatus.ending = false;
            }
        },
        smoothEndFrame: function() {
            var inertiaStatus = this.inertiaStatus, t = new Date().getTime() - inertiaStatus.t0, duration = this.target.options[this.prepared.name].inertia.smoothEndDuration;
            if (t < duration) {
                inertiaStatus.sx = easeOutQuad(t, 0, inertiaStatus.xe, duration);
                inertiaStatus.sy = easeOutQuad(t, 0, inertiaStatus.ye, duration);
                this.pointerMove(inertiaStatus.startEvent, inertiaStatus.startEvent);
                inertiaStatus.i = reqFrame(this.boundSmoothEndFrame);
            } else {
                inertiaStatus.ending = true;
                inertiaStatus.sx = inertiaStatus.xe;
                inertiaStatus.sy = inertiaStatus.ye;
                this.pointerMove(inertiaStatus.startEvent, inertiaStatus.startEvent);
                this.pointerEnd(inertiaStatus.startEvent, inertiaStatus.startEvent);
                inertiaStatus.smoothEnd = inertiaStatus.active = inertiaStatus.ending = false;
            }
        },
        addPointer: function(pointer) {
            var id = getPointerId(pointer), index = this.mouse ? 0 : indexOf(this.pointerIds, id);
            if (index === -1) index = this.pointerIds.length;
            this.pointerIds[index] = id;
            this.pointers[index] = pointer;
            return index;
        },
        removePointer: function(pointer) {
            var id = getPointerId(pointer), index = this.mouse ? 0 : indexOf(this.pointerIds, id);
            if (index === -1) return;
            this.pointers.splice(index, 1);
            this.pointerIds.splice(index, 1);
            this.downTargets.splice(index, 1);
            this.downTimes.splice(index, 1);
            this.holdTimers.splice(index, 1);
        },
        recordPointer: function(pointer) {
            var index = this.mouse ? 0 : indexOf(this.pointerIds, getPointerId(pointer));
            if (index === -1) return;
            this.pointers[index] = pointer;
        },
        collectEventTargets: function(pointer, event, eventTarget, eventType) {
            var pointerIndex = this.mouse ? 0 : indexOf(this.pointerIds, getPointerId(pointer));
            // do not fire a tap event if the pointer was moved before being lifted
            if (eventType === 'tap' && (this.pointerWasMoved || !(this.downTargets[pointerIndex] && this.downTargets[pointerIndex] === eventTarget))) return;
            var targets = [], elements = [], element = eventTarget;
            function collectSelectors(interactable, selector, context) {
                var els = ie8MatchesSelector ? context.querySelectorAll(selector) : undefined;
                if (interactable._iEvents[eventType] && isElement(element) && inContext(interactable, element) && !testIgnore(interactable, element, eventTarget) && testAllow(interactable, element, eventTarget) && matchesSelector(element, selector, els)) {
                    targets.push(interactable);
                    elements.push(element);
                }
            }
            while(element){
                if (interact.isSet(element) && interact(element)._iEvents[eventType]) {
                    targets.push(interact(element));
                    elements.push(element);
                }
                interactables.forEachSelector(collectSelectors);
                element = parentElement(element);
            }
            // create the tap event even if there are no listeners so that
            // doubletap can still be created and fired
            if (targets.length || eventType === 'tap') this.firePointers(pointer, event, eventTarget, targets, elements, eventType);
        },
        firePointers: function(pointer, event, eventTarget, targets, elements, eventType) {
            var pointerIndex = this.mouse ? 0 : indexOf(this.pointerIds, getPointerId(pointer)), pointerEvent = {}, i, // for tap events
            interval, createNewDoubleTap;
            // if it's a doubletap then the event properties would have been
            // copied from the tap event and provided as the pointer argument
            if (eventType === 'doubletap') pointerEvent = pointer;
            else {
                pointerExtend(pointerEvent, event);
                if (event !== pointer) pointerExtend(pointerEvent, pointer);
                pointerEvent.preventDefault = preventOriginalDefault;
                pointerEvent.stopPropagation = InteractEvent.prototype.stopPropagation;
                pointerEvent.stopImmediatePropagation = InteractEvent.prototype.stopImmediatePropagation;
                pointerEvent.interaction = this;
                pointerEvent.timeStamp = new Date().getTime();
                pointerEvent.originalEvent = event;
                pointerEvent.originalPointer = pointer;
                pointerEvent.type = eventType;
                pointerEvent.pointerId = getPointerId(pointer);
                pointerEvent.pointerType = this.mouse ? 'mouse' : !supportsPointerEvent ? 'touch' : isString(pointer.pointerType) ? pointer.pointerType : [
                    ,
                    ,
                    'touch',
                    'pen',
                    'mouse'
                ][pointer.pointerType];
            }
            if (eventType === 'tap') {
                pointerEvent.dt = pointerEvent.timeStamp - this.downTimes[pointerIndex];
                interval = pointerEvent.timeStamp - this.tapTime;
                createNewDoubleTap = !!(this.prevTap && this.prevTap.type !== 'doubletap' && this.prevTap.target === pointerEvent.target && interval < 500);
                pointerEvent.double = createNewDoubleTap;
                this.tapTime = pointerEvent.timeStamp;
            }
            for(i = 0; i < targets.length; i++){
                pointerEvent.currentTarget = elements[i];
                pointerEvent.interactable = targets[i];
                targets[i].fire(pointerEvent);
                if (pointerEvent.immediatePropagationStopped || pointerEvent.propagationStopped && elements[i + 1] !== pointerEvent.currentTarget) break;
            }
            if (createNewDoubleTap) {
                var doubleTap = {};
                extend(doubleTap, pointerEvent);
                doubleTap.dt = interval;
                doubleTap.type = 'doubletap';
                this.collectEventTargets(doubleTap, event, eventTarget, 'doubletap');
                this.prevTap = doubleTap;
            } else if (eventType === 'tap') this.prevTap = pointerEvent;
        },
        validateSelector: function(pointer, event, matches, matchElements) {
            for(var i = 0, len = matches.length; i < len; i++){
                var match = matches[i], matchElement = matchElements[i], action = validateAction(match.getAction(pointer, event, this, matchElement), match);
                if (action && withinInteractionLimit(match, matchElement, action)) {
                    this.target = match;
                    this.element = matchElement;
                    return action;
                }
            }
        },
        setSnapping: function(pageCoords, status) {
            var snap = this.target.options[this.prepared.name].snap, targets = [], target, page, i;
            status = status || this.snapStatus;
            if (status.useStatusXY) page = {
                x: status.x,
                y: status.y
            };
            else {
                var origin = getOriginXY(this.target, this.element);
                page = extend({}, pageCoords);
                page.x -= origin.x;
                page.y -= origin.y;
            }
            status.realX = page.x;
            status.realY = page.y;
            page.x = page.x - this.inertiaStatus.resumeDx;
            page.y = page.y - this.inertiaStatus.resumeDy;
            var len = snap.targets ? snap.targets.length : 0;
            for(var relIndex = 0; relIndex < this.snapOffsets.length; relIndex++){
                var relative = {
                    x: page.x - this.snapOffsets[relIndex].x,
                    y: page.y - this.snapOffsets[relIndex].y
                };
                for(i = 0; i < len; i++){
                    if (isFunction(snap.targets[i])) target = snap.targets[i](relative.x, relative.y, this);
                    else target = snap.targets[i];
                    if (!target) continue;
                    targets.push({
                        x: isNumber(target.x) ? target.x + this.snapOffsets[relIndex].x : relative.x,
                        y: isNumber(target.y) ? target.y + this.snapOffsets[relIndex].y : relative.y,
                        range: isNumber(target.range) ? target.range : snap.range
                    });
                }
            }
            var closest = {
                target: null,
                inRange: false,
                distance: 0,
                range: 0,
                dx: 0,
                dy: 0
            };
            for(i = 0, len = targets.length; i < len; i++){
                target = targets[i];
                var range = target.range, dx = target.x - page.x, dy = target.y - page.y, distance = hypot(dx, dy), inRange = distance <= range;
                // Infinite targets count as being out of range
                // compared to non infinite ones that are in range
                if (range === Infinity && closest.inRange && closest.range !== Infinity) inRange = false;
                if (!closest.target || (inRange ? closest.inRange && range !== Infinity ? distance / range < closest.distance / closest.range : range === Infinity && closest.range !== Infinity || distance < closest.distance : !closest.inRange && distance < closest.distance)) {
                    if (range === Infinity) inRange = true;
                    closest.target = target;
                    closest.distance = distance;
                    closest.range = range;
                    closest.inRange = inRange;
                    closest.dx = dx;
                    closest.dy = dy;
                    status.range = range;
                }
            }
            var snapChanged;
            if (closest.target) {
                snapChanged = status.snappedX !== closest.target.x || status.snappedY !== closest.target.y;
                status.snappedX = closest.target.x;
                status.snappedY = closest.target.y;
            } else {
                snapChanged = true;
                status.snappedX = NaN;
                status.snappedY = NaN;
            }
            status.dx = closest.dx;
            status.dy = closest.dy;
            status.changed = snapChanged || closest.inRange && !status.locked;
            status.locked = closest.inRange;
            return status;
        },
        setRestriction: function(pageCoords, status) {
            var target = this.target, restrict = target && target.options[this.prepared.name].restrict, restriction = restrict && restrict.restriction, page;
            if (!restriction) return status;
            status = status || this.restrictStatus;
            page = status.useStatusXY ? page = {
                x: status.x,
                y: status.y
            } : page = extend({}, pageCoords);
            if (status.snap && status.snap.locked) {
                page.x += status.snap.dx || 0;
                page.y += status.snap.dy || 0;
            }
            page.x -= this.inertiaStatus.resumeDx;
            page.y -= this.inertiaStatus.resumeDy;
            status.dx = 0;
            status.dy = 0;
            status.restricted = false;
            var rect, restrictedX, restrictedY;
            if (isString(restriction)) {
                if (restriction === 'parent') restriction = parentElement(this.element);
                else if (restriction === 'self') restriction = target.getRect(this.element);
                else restriction = closest(this.element, restriction);
                if (!restriction) return status;
            }
            if (isFunction(restriction)) restriction = restriction(page.x, page.y, this.element);
            if (isElement(restriction)) restriction = getElementRect(restriction);
            rect = restriction;
            if (!restriction) {
                restrictedX = page.x;
                restrictedY = page.y;
            } else if ('x' in restriction && 'y' in restriction) {
                restrictedX = Math.max(Math.min(rect.x + rect.width - this.restrictOffset.right, page.x), rect.x + this.restrictOffset.left);
                restrictedY = Math.max(Math.min(rect.y + rect.height - this.restrictOffset.bottom, page.y), rect.y + this.restrictOffset.top);
            } else {
                restrictedX = Math.max(Math.min(rect.right - this.restrictOffset.right, page.x), rect.left + this.restrictOffset.left);
                restrictedY = Math.max(Math.min(rect.bottom - this.restrictOffset.bottom, page.y), rect.top + this.restrictOffset.top);
            }
            status.dx = restrictedX - page.x;
            status.dy = restrictedY - page.y;
            status.changed = status.restrictedX !== restrictedX || status.restrictedY !== restrictedY;
            status.restricted = !!(status.dx || status.dy);
            status.restrictedX = restrictedX;
            status.restrictedY = restrictedY;
            return status;
        },
        checkAndPreventDefault: function(event, interactable, element) {
            if (!(interactable = interactable || this.target)) return;
            var options = interactable.options, prevent = options.preventDefault;
            if (prevent === 'auto' && element && !/^(input|select|textarea)$/i.test(event.target.nodeName)) {
                // do not preventDefault on pointerdown if the prepared action is a drag
                // and dragging can only start from a certain direction - this allows
                // a touch to pan the viewport if a drag isn't in the right direction
                if (/down|start/i.test(event.type) && this.prepared.name === 'drag' && options.drag.axis !== 'xy') return;
                // with manualStart, only preventDefault while interacting
                if (options[this.prepared.name] && options[this.prepared.name].manualStart && !this.interacting()) return;
                event.preventDefault();
                return;
            }
            if (prevent === 'always') {
                event.preventDefault();
                return;
            }
        },
        calcInertia: function(status) {
            var inertiaOptions = this.target.options[this.prepared.name].inertia, lambda = inertiaOptions.resistance, inertiaDur = -Math.log(inertiaOptions.endSpeed / status.v0) / lambda;
            status.x0 = this.prevEvent.pageX;
            status.y0 = this.prevEvent.pageY;
            status.t0 = status.startEvent.timeStamp / 1000;
            status.sx = status.sy = 0;
            status.modifiedXe = status.xe = (status.vx0 - inertiaDur) / lambda;
            status.modifiedYe = status.ye = (status.vy0 - inertiaDur) / lambda;
            status.te = inertiaDur;
            status.lambda_v0 = lambda / status.v0;
            status.one_ve_v0 = 1 - inertiaOptions.endSpeed / status.v0;
        },
        autoScrollMove: function(pointer) {
            if (!(this.interacting() && checkAutoScroll(this.target, this.prepared.name))) return;
            if (this.inertiaStatus.active) {
                autoScroll.x = autoScroll.y = 0;
                return;
            }
            var top, right, bottom, left, options = this.target.options[this.prepared.name].autoScroll, container = options.container || getWindow(this.element);
            if (isWindow(container)) {
                left = pointer.clientX < autoScroll.margin;
                top = pointer.clientY < autoScroll.margin;
                right = pointer.clientX > container.innerWidth - autoScroll.margin;
                bottom = pointer.clientY > container.innerHeight - autoScroll.margin;
            } else {
                var rect = getElementClientRect(container);
                left = pointer.clientX < rect.left + autoScroll.margin;
                top = pointer.clientY < rect.top + autoScroll.margin;
                right = pointer.clientX > rect.right - autoScroll.margin;
                bottom = pointer.clientY > rect.bottom - autoScroll.margin;
            }
            autoScroll.x = right ? 1 : left ? -1 : 0;
            autoScroll.y = bottom ? 1 : top ? -1 : 0;
            if (!autoScroll.isScrolling) {
                // set the autoScroll properties to those of the target
                autoScroll.margin = options.margin;
                autoScroll.speed = options.speed;
                autoScroll.start(this);
            }
        },
        _updateEventTargets: function(target, currentTarget) {
            this._eventTarget = target;
            this._curEventTarget = currentTarget;
        }
    };
    function getInteractionFromPointer(pointer, eventType, eventTarget) {
        var i = 0, len = interactions.length, mouseEvent = /mouse/i.test(pointer.pointerType || eventType) || pointer.pointerType === 4, interaction;
        var id = getPointerId(pointer);
        // try to resume inertia with a new pointer
        if (/down|start/i.test(eventType)) for(i = 0; i < len; i++){
            interaction = interactions[i];
            var element = eventTarget;
            if (interaction.inertiaStatus.active && interaction.target.options[interaction.prepared.name].inertia.allowResume && interaction.mouse === mouseEvent) while(element){
                // if the element is the interaction element
                if (element === interaction.element) return interaction;
                element = parentElement(element);
            }
        }
        // if it's a mouse interaction
        if (mouseEvent || !(supportsTouch || supportsPointerEvent)) {
            // find a mouse interaction that's not in inertia phase
            for(i = 0; i < len; i++){
                if (interactions[i].mouse && !interactions[i].inertiaStatus.active) return interactions[i];
            }
            // find any interaction specifically for mouse.
            // if the eventType is a mousedown, and inertia is active
            // ignore the interaction
            for(i = 0; i < len; i++){
                if (interactions[i].mouse && !(/down/.test(eventType) && interactions[i].inertiaStatus.active)) return interaction;
            }
            // create a new interaction for mouse
            interaction = new Interaction();
            interaction.mouse = true;
            return interaction;
        }
        // get interaction that has this pointer
        for(i = 0; i < len; i++){
            if (contains(interactions[i].pointerIds, id)) return interactions[i];
        }
        // at this stage, a pointerUp should not return an interaction
        if (/up|end|out/i.test(eventType)) return null;
        // get first idle interaction
        for(i = 0; i < len; i++){
            interaction = interactions[i];
            if ((!interaction.prepared.name || interaction.target.options.gesture.enabled) && !interaction.interacting() && !(!mouseEvent && interaction.mouse)) return interaction;
        }
        return new Interaction();
    }
    function doOnInteractions(method) {
        return function(event) {
            var interaction, eventTarget = getActualElement(event.path ? event.path[0] : event.target), curEventTarget = getActualElement(event.currentTarget), i;
            if (supportsTouch && /touch/.test(event.type)) {
                prevTouchTime = new Date().getTime();
                for(i = 0; i < event.changedTouches.length; i++){
                    var pointer = event.changedTouches[i];
                    interaction = getInteractionFromPointer(pointer, event.type, eventTarget);
                    if (!interaction) continue;
                    interaction._updateEventTargets(eventTarget, curEventTarget);
                    interaction[method](pointer, event, eventTarget, curEventTarget);
                }
            } else {
                if (!supportsPointerEvent && /mouse/.test(event.type)) {
                    // ignore mouse events while touch interactions are active
                    for(i = 0; i < interactions.length; i++){
                        if (!interactions[i].mouse && interactions[i].pointerIsDown) return;
                    }
                    // try to ignore mouse events that are simulated by the browser
                    // after a touch event
                    if (new Date().getTime() - prevTouchTime < 500) return;
                }
                interaction = getInteractionFromPointer(event, event.type, eventTarget);
                if (!interaction) return;
                interaction._updateEventTargets(eventTarget, curEventTarget);
                interaction[method](event, event, eventTarget, curEventTarget);
            }
        };
    }
    function InteractEvent(interaction, event, action, phase, element, related) {
        var client, page, target = interaction.target, snapStatus = interaction.snapStatus, restrictStatus = interaction.restrictStatus, pointers = interaction.pointers, deltaSource = (target && target.options || defaultOptions).deltaSource, sourceX = deltaSource + 'X', sourceY = deltaSource + 'Y', options = target ? target.options : defaultOptions, origin = getOriginXY(target, element), starting = phase === 'start', ending = phase === 'end', coords = starting ? interaction.startCoords : interaction.curCoords;
        element = element || interaction.element;
        page = extend({}, coords.page);
        client = extend({}, coords.client);
        page.x -= origin.x;
        page.y -= origin.y;
        client.x -= origin.x;
        client.y -= origin.y;
        var relativePoints = options[action].snap && options[action].snap.relativePoints;
        if (checkSnap(target, action) && !(starting && relativePoints && relativePoints.length)) {
            this.snap = {
                range: snapStatus.range,
                locked: snapStatus.locked,
                x: snapStatus.snappedX,
                y: snapStatus.snappedY,
                realX: snapStatus.realX,
                realY: snapStatus.realY,
                dx: snapStatus.dx,
                dy: snapStatus.dy
            };
            if (snapStatus.locked) {
                page.x += snapStatus.dx;
                page.y += snapStatus.dy;
                client.x += snapStatus.dx;
                client.y += snapStatus.dy;
            }
        }
        if (checkRestrict(target, action) && !(starting && options[action].restrict.elementRect) && restrictStatus.restricted) {
            page.x += restrictStatus.dx;
            page.y += restrictStatus.dy;
            client.x += restrictStatus.dx;
            client.y += restrictStatus.dy;
            this.restrict = {
                dx: restrictStatus.dx,
                dy: restrictStatus.dy
            };
        }
        this.pageX = page.x;
        this.pageY = page.y;
        this.clientX = client.x;
        this.clientY = client.y;
        this.x0 = interaction.startCoords.page.x - origin.x;
        this.y0 = interaction.startCoords.page.y - origin.y;
        this.clientX0 = interaction.startCoords.client.x - origin.x;
        this.clientY0 = interaction.startCoords.client.y - origin.y;
        this.ctrlKey = event.ctrlKey;
        this.altKey = event.altKey;
        this.shiftKey = event.shiftKey;
        this.metaKey = event.metaKey;
        this.button = event.button;
        this.buttons = event.buttons;
        this.target = element;
        this.t0 = interaction.downTimes[0];
        this.type = action + (phase || '');
        this.interaction = interaction;
        this.interactable = target;
        var inertiaStatus = interaction.inertiaStatus;
        if (inertiaStatus.active) this.detail = 'inertia';
        if (related) this.relatedTarget = related;
        // end event dx, dy is difference between start and end points
        if (ending) {
            if (deltaSource === 'client') {
                this.dx = client.x - interaction.startCoords.client.x;
                this.dy = client.y - interaction.startCoords.client.y;
            } else {
                this.dx = page.x - interaction.startCoords.page.x;
                this.dy = page.y - interaction.startCoords.page.y;
            }
        } else if (starting) {
            this.dx = 0;
            this.dy = 0;
        } else if (phase === 'inertiastart') {
            this.dx = interaction.prevEvent.dx;
            this.dy = interaction.prevEvent.dy;
        } else if (deltaSource === 'client') {
            this.dx = client.x - interaction.prevEvent.clientX;
            this.dy = client.y - interaction.prevEvent.clientY;
        } else {
            this.dx = page.x - interaction.prevEvent.pageX;
            this.dy = page.y - interaction.prevEvent.pageY;
        }
        if (interaction.prevEvent && interaction.prevEvent.detail === 'inertia' && !inertiaStatus.active && options[action].inertia && options[action].inertia.zeroResumeDelta) {
            inertiaStatus.resumeDx += this.dx;
            inertiaStatus.resumeDy += this.dy;
            this.dx = this.dy = 0;
        }
        if (action === 'resize' && interaction.resizeAxes) {
            if (options.resize.square) {
                if (interaction.resizeAxes === 'y') this.dx = this.dy;
                else this.dy = this.dx;
                this.axes = 'xy';
            } else {
                this.axes = interaction.resizeAxes;
                if (interaction.resizeAxes === 'x') this.dy = 0;
                else if (interaction.resizeAxes === 'y') this.dx = 0;
            }
        } else if (action === 'gesture') {
            this.touches = [
                pointers[0],
                pointers[1]
            ];
            if (starting) {
                this.distance = touchDistance(pointers, deltaSource);
                this.box = touchBBox(pointers);
                this.scale = 1;
                this.ds = 0;
                this.angle = touchAngle(pointers, undefined, deltaSource);
                this.da = 0;
            } else if (ending || event instanceof InteractEvent) {
                this.distance = interaction.prevEvent.distance;
                this.box = interaction.prevEvent.box;
                this.scale = interaction.prevEvent.scale;
                this.ds = this.scale - 1;
                this.angle = interaction.prevEvent.angle;
                this.da = this.angle - interaction.gesture.startAngle;
            } else {
                this.distance = touchDistance(pointers, deltaSource);
                this.box = touchBBox(pointers);
                this.scale = this.distance / interaction.gesture.startDistance;
                this.angle = touchAngle(pointers, interaction.gesture.prevAngle, deltaSource);
                this.ds = this.scale - interaction.gesture.prevScale;
                this.da = this.angle - interaction.gesture.prevAngle;
            }
        }
        if (starting) {
            this.timeStamp = interaction.downTimes[0];
            this.dt = 0;
            this.duration = 0;
            this.speed = 0;
            this.velocityX = 0;
            this.velocityY = 0;
        } else if (phase === 'inertiastart') {
            this.timeStamp = interaction.prevEvent.timeStamp;
            this.dt = interaction.prevEvent.dt;
            this.duration = interaction.prevEvent.duration;
            this.speed = interaction.prevEvent.speed;
            this.velocityX = interaction.prevEvent.velocityX;
            this.velocityY = interaction.prevEvent.velocityY;
        } else {
            this.timeStamp = new Date().getTime();
            this.dt = this.timeStamp - interaction.prevEvent.timeStamp;
            this.duration = this.timeStamp - interaction.downTimes[0];
            if (event instanceof InteractEvent) {
                var dx = this[sourceX] - interaction.prevEvent[sourceX], dy = this[sourceY] - interaction.prevEvent[sourceY], dt = this.dt / 1000;
                this.speed = hypot(dx, dy) / dt;
                this.velocityX = dx / dt;
                this.velocityY = dy / dt;
            } else {
                // speed and velocity in pixels per second
                this.speed = interaction.pointerDelta[deltaSource].speed;
                this.velocityX = interaction.pointerDelta[deltaSource].vx;
                this.velocityY = interaction.pointerDelta[deltaSource].vy;
            }
        }
        if ((ending || phase === 'inertiastart') && interaction.prevEvent.speed > 600 && this.timeStamp - interaction.prevEvent.timeStamp < 150) {
            var angle = 180 * Math.atan2(interaction.prevEvent.velocityY, interaction.prevEvent.velocityX) / Math.PI, overlap = 22.5;
            if (angle < 0) angle += 360;
            var left = 135 - overlap <= angle && angle < 225 + overlap, up = 225 - overlap <= angle && angle < 315 + overlap, right = !left && (315 - overlap <= angle || angle < 45 + overlap), down = !up && 45 - overlap <= angle && angle < 135 + overlap;
            this.swipe = {
                up: up,
                down: down,
                left: left,
                right: right,
                angle: angle,
                speed: interaction.prevEvent.speed,
                velocity: {
                    x: interaction.prevEvent.velocityX,
                    y: interaction.prevEvent.velocityY
                }
            };
        }
    }
    InteractEvent.prototype = {
        preventDefault: blank,
        stopImmediatePropagation: function() {
            this.immediatePropagationStopped = this.propagationStopped = true;
        },
        stopPropagation: function() {
            this.propagationStopped = true;
        }
    };
    function preventOriginalDefault() {
        this.originalEvent.preventDefault();
    }
    function getActionCursor(action) {
        var cursor = '';
        if (action.name === 'drag') cursor = actionCursors.drag;
        if (action.name === 'resize') {
            if (action.axis) cursor = actionCursors[action.name + action.axis];
            else if (action.edges) {
                var cursorKey = 'resize', edgeNames = [
                    'top',
                    'bottom',
                    'left',
                    'right'
                ];
                for(var i = 0; i < 4; i++)if (action.edges[edgeNames[i]]) cursorKey += edgeNames[i];
                cursor = actionCursors[cursorKey];
            }
        }
        return cursor;
    }
    function checkResizeEdge(name, value, page, element, interactableElement, rect, margin) {
        // false, '', undefined, null
        if (!value) return false;
        // true value, use pointer coords and element rect
        if (value === true) {
            // if dimensions are negative, "switch" edges
            var width = isNumber(rect.width) ? rect.width : rect.right - rect.left, height = isNumber(rect.height) ? rect.height : rect.bottom - rect.top;
            if (width < 0) {
                if (name === 'left') name = 'right';
                else if (name === 'right') name = 'left';
            }
            if (height < 0) {
                if (name === 'top') name = 'bottom';
                else if (name === 'bottom') name = 'top';
            }
            if (name === 'left') return page.x < (width >= 0 ? rect.left : rect.right) + margin;
            if (name === 'top') return page.y < (height >= 0 ? rect.top : rect.bottom) + margin;
            if (name === 'right') return page.x > (width >= 0 ? rect.right : rect.left) - margin;
            if (name === 'bottom') return page.y > (height >= 0 ? rect.bottom : rect.top) - margin;
        }
        // the remaining checks require an element
        if (!isElement(element)) return false;
        return isElement(value) ? value === element : matchesUpTo(element, value, interactableElement);
    }
    function defaultActionChecker(pointer, interaction, element) {
        var rect = this.getRect(element), shouldResize = false, action = null, resizeAxes = null, resizeEdges, page = extend({}, interaction.curCoords.page), options = this.options;
        if (!rect) return null;
        if (actionIsEnabled.resize && options.resize.enabled) {
            var resizeOptions = options.resize;
            resizeEdges = {
                left: false,
                right: false,
                top: false,
                bottom: false
            };
            // if using resize.edges
            if (isObject(resizeOptions.edges)) {
                for(var edge in resizeEdges)resizeEdges[edge] = checkResizeEdge(edge, resizeOptions.edges[edge], page, interaction._eventTarget, element, rect, resizeOptions.margin || margin);
                resizeEdges.left = resizeEdges.left && !resizeEdges.right;
                resizeEdges.top = resizeEdges.top && !resizeEdges.bottom;
                shouldResize = resizeEdges.left || resizeEdges.right || resizeEdges.top || resizeEdges.bottom;
            } else {
                var right = options.resize.axis !== 'y' && page.x > rect.right - margin, bottom = options.resize.axis !== 'x' && page.y > rect.bottom - margin;
                shouldResize = right || bottom;
                resizeAxes = (right ? 'x' : '') + (bottom ? 'y' : '');
            }
        }
        action = shouldResize ? 'resize' : actionIsEnabled.drag && options.drag.enabled ? 'drag' : null;
        if (actionIsEnabled.gesture && interaction.pointerIds.length >= 2 && !(interaction.dragging || interaction.resizing)) action = 'gesture';
        if (action) return {
            name: action,
            axis: resizeAxes,
            edges: resizeEdges
        };
        return null;
    }
    // Check if action is enabled globally and the current target supports it
    // If so, return the validated action. Otherwise, return null
    function validateAction(action, interactable) {
        if (!isObject(action)) return null;
        var actionName = action.name, options = interactable.options;
        if ((actionName === 'resize' && options.resize.enabled || actionName === 'drag' && options.drag.enabled || actionName === 'gesture' && options.gesture.enabled) && actionIsEnabled[actionName]) {
            if (actionName === 'resize' || actionName === 'resizeyx') actionName = 'resizexy';
            return action;
        }
        return null;
    }
    var listeners = {}, interactionListeners = [
        'dragStart',
        'dragMove',
        'resizeStart',
        'resizeMove',
        'gestureStart',
        'gestureMove',
        'pointerOver',
        'pointerOut',
        'pointerHover',
        'selectorDown',
        'pointerDown',
        'pointerMove',
        'pointerUp',
        'pointerCancel',
        'pointerEnd',
        'addPointer',
        'removePointer',
        'recordPointer',
        'autoScrollMove'
    ];
    for(var i = 0, len = interactionListeners.length; i < len; i++){
        var name = interactionListeners[i];
        listeners[name] = doOnInteractions(name);
    }
    // bound to the interactable context when a DOM event
    // listener is added to a selector interactable
    function delegateListener(event, useCapture) {
        var fakeEvent = {}, delegated = delegatedEvents[event.type], eventTarget = getActualElement(event.path ? event.path[0] : event.target), element = eventTarget;
        useCapture = useCapture ? true : false;
        // duplicate the event so that currentTarget can be changed
        for(var prop in event)fakeEvent[prop] = event[prop];
        fakeEvent.originalEvent = event;
        fakeEvent.preventDefault = preventOriginalDefault;
        // climb up document tree looking for selector matches
        while(isElement(element)){
            for(var i = 0; i < delegated.selectors.length; i++){
                var selector = delegated.selectors[i], context = delegated.contexts[i];
                if (matchesSelector(element, selector) && nodeContains(context, eventTarget) && nodeContains(context, element)) {
                    var listeners = delegated.listeners[i];
                    fakeEvent.currentTarget = element;
                    for(var j = 0; j < listeners.length; j++)if (listeners[j][1] === useCapture) listeners[j][0](fakeEvent);
                }
            }
            element = parentElement(element);
        }
    }
    function delegateUseCapture(event) {
        return delegateListener.call(this, event, true);
    }
    interactables.indexOfElement = function indexOfElement(element, context) {
        context = context || document;
        for(var i = 0; i < this.length; i++){
            var interactable = this[i];
            if (interactable.selector === element && interactable._context === context || !interactable.selector && interactable._element === element) return i;
        }
        return -1;
    };
    interactables.get = function interactableGet(element, options) {
        return this[this.indexOfElement(element, options && options.context)];
    };
    interactables.forEachSelector = function(callback) {
        for(var i = 0; i < this.length; i++){
            var interactable = this[i];
            if (!interactable.selector) continue;
            var ret = callback(interactable, interactable.selector, interactable._context, i, this);
            if (ret !== undefined) return ret;
        }
    };
    /*\
     * interact
     [ method ]
     *
     * The methods of this variable can be used to set elements as
     * interactables and also to change various default settings.
     *
     * Calling it as a function and passing an element or a valid CSS selector
     * string returns an Interactable object which has various methods to
     * configure it.
     *
     - element (Element | string) The HTML or SVG Element to interact with or CSS selector
     = (object) An @Interactable
     *
     > Usage
     | interact(document.getElementById('draggable')).draggable(true);
     |
     | var rectables = interact('rect');
     | rectables
     |     .gesturable(true)
     |     .on('gesturemove', function (event) {
     |         // something cool...
     |     })
     |     .autoScroll(true);
    \*/ function interact(element, options) {
        return interactables.get(element, options) || new Interactable(element, options);
    }
    /*\
     * Interactable
     [ property ]
     **
     * Object type returned by @interact
    \*/ function Interactable(element, options) {
        this._element = element;
        this._iEvents = this._iEvents || {};
        var _window;
        if (trySelector(element)) {
            this.selector = element;
            var context = options && options.context;
            _window = context ? getWindow(context) : window1;
            if (context && (_window.Node ? context instanceof _window.Node : isElement(context) || context === _window.document)) this._context = context;
        } else {
            _window = getWindow(element);
            if (isElement(element, _window)) {
                if (supportsPointerEvent) {
                    events.add(this._element, pEventTypes.down, listeners.pointerDown);
                    events.add(this._element, pEventTypes.move, listeners.pointerHover);
                } else {
                    events.add(this._element, 'mousedown', listeners.pointerDown);
                    events.add(this._element, 'mousemove', listeners.pointerHover);
                    events.add(this._element, 'touchstart', listeners.pointerDown);
                    events.add(this._element, 'touchmove', listeners.pointerHover);
                }
            }
        }
        this._doc = _window.document;
        if (!contains(documents, this._doc)) listenToDocument(this._doc);
        interactables.push(this);
        this.set(options);
    }
    Interactable.prototype = {
        setOnEvents: function(action, phases) {
            if (action === 'drop') {
                if (isFunction(phases.ondrop)) this.ondrop = phases.ondrop;
                if (isFunction(phases.ondropactivate)) this.ondropactivate = phases.ondropactivate;
                if (isFunction(phases.ondropdeactivate)) this.ondropdeactivate = phases.ondropdeactivate;
                if (isFunction(phases.ondragenter)) this.ondragenter = phases.ondragenter;
                if (isFunction(phases.ondragleave)) this.ondragleave = phases.ondragleave;
                if (isFunction(phases.ondropmove)) this.ondropmove = phases.ondropmove;
            } else {
                action = 'on' + action;
                if (isFunction(phases.onstart)) this[action + 'start'] = phases.onstart;
                if (isFunction(phases.onmove)) this[action + 'move'] = phases.onmove;
                if (isFunction(phases.onend)) this[action + 'end'] = phases.onend;
                if (isFunction(phases.oninertiastart)) this[action + 'inertiastart'] = phases.oninertiastart;
            }
            return this;
        },
        /*\
         * Interactable.draggable
         [ method ]
         *
         * Gets or sets whether drag actions can be performed on the
         * Interactable
         *
         = (boolean) Indicates if this can be the target of drag events
         | var isDraggable = interact('ul li').draggable();
         * or
         - options (boolean | object) #optional true/false or An object with event listeners to be fired on drag events (object makes the Interactable draggable)
         = (object) This Interactable
         | interact(element).draggable({
         |     onstart: function (event) {},
         |     onmove : function (event) {},
         |     onend  : function (event) {},
         |
         |     // the axis in which the first movement must be
         |     // for the drag sequence to start
         |     // 'xy' by default - any direction
         |     axis: 'x' || 'y' || 'xy',
         |
         |     // max number of drags that can happen concurrently
         |     // with elements of this Interactable. Infinity by default
         |     max: Infinity,
         |
         |     // max number of drags that can target the same element+Interactable
         |     // 1 by default
         |     maxPerElement: 2
         | });
        \*/ draggable: function(options) {
            if (isObject(options)) {
                this.options.drag.enabled = options.enabled === false ? false : true;
                this.setPerAction('drag', options);
                this.setOnEvents('drag', options);
                if (/^x$|^y$|^xy$/.test(options.axis)) this.options.drag.axis = options.axis;
                else if (options.axis === null) delete this.options.drag.axis;
                return this;
            }
            if (isBool(options)) {
                this.options.drag.enabled = options;
                return this;
            }
            return this.options.drag;
        },
        setPerAction: function(action, options) {
            // for all the default per-action options
            for(var option in options)// if this option exists for this action
            if (option in defaultOptions[action]) {
                // if the option in the options arg is an object value
                if (isObject(options[option])) {
                    // duplicate the object
                    this.options[action][option] = extend(this.options[action][option] || {}, options[option]);
                    if (isObject(defaultOptions.perAction[option]) && 'enabled' in defaultOptions.perAction[option]) this.options[action][option].enabled = options[option].enabled === false ? false : true;
                } else if (isBool(options[option]) && isObject(defaultOptions.perAction[option])) this.options[action][option].enabled = options[option];
                else if (options[option] !== undefined) // or if it's not undefined, do a plain assignment
                this.options[action][option] = options[option];
            }
        },
        /*\
         * Interactable.dropzone
         [ method ]
         *
         * Returns or sets whether elements can be dropped onto this
         * Interactable to trigger drop events
         *
         * Dropzones can receive the following events:
         *  - `dropactivate` and `dropdeactivate` when an acceptable drag starts and ends
         *  - `dragenter` and `dragleave` when a draggable enters and leaves the dropzone
         *  - `dragmove` when a draggable that has entered the dropzone is moved
         *  - `drop` when a draggable is dropped into this dropzone
         *
         *  Use the `accept` option to allow only elements that match the given CSS selector or element.
         *
         *  Use the `overlap` option to set how drops are checked for. The allowed values are:
         *   - `'pointer'`, the pointer must be over the dropzone (default)
         *   - `'center'`, the draggable element's center must be over the dropzone
         *   - a number from 0-1 which is the `(intersection area) / (draggable area)`.
         *       e.g. `0.5` for drop to happen when half of the area of the
         *       draggable is over the dropzone
         *
         - options (boolean | object | null) #optional The new value to be set.
         | interact('.drop').dropzone({
         |   accept: '.can-drop' || document.getElementById('single-drop'),
         |   overlap: 'pointer' || 'center' || zeroToOne
         | }
         = (boolean | object) The current setting or this Interactable
        \*/ dropzone: function(options) {
            if (isObject(options)) {
                this.options.drop.enabled = options.enabled === false ? false : true;
                this.setOnEvents('drop', options);
                if (/^(pointer|center)$/.test(options.overlap)) this.options.drop.overlap = options.overlap;
                else if (isNumber(options.overlap)) this.options.drop.overlap = Math.max(Math.min(1, options.overlap), 0);
                if ('accept' in options) this.options.drop.accept = options.accept;
                if ('checker' in options) this.options.drop.checker = options.checker;
                return this;
            }
            if (isBool(options)) {
                this.options.drop.enabled = options;
                return this;
            }
            return this.options.drop;
        },
        dropCheck: function(dragEvent, event, draggable, draggableElement, dropElement, rect) {
            var dropped = false;
            // if the dropzone has no rect (eg. display: none)
            // call the custom dropChecker or just return false
            if (!(rect = rect || this.getRect(dropElement))) return this.options.drop.checker ? this.options.drop.checker(dragEvent, event, dropped, this, dropElement, draggable, draggableElement) : false;
            var dropOverlap = this.options.drop.overlap;
            if (dropOverlap === 'pointer') {
                var page = getPageXY(dragEvent), origin = getOriginXY(draggable, draggableElement), horizontal, vertical;
                page.x += origin.x;
                page.y += origin.y;
                horizontal = page.x > rect.left && page.x < rect.right;
                vertical = page.y > rect.top && page.y < rect.bottom;
                dropped = horizontal && vertical;
            }
            var dragRect = draggable.getRect(draggableElement);
            if (dropOverlap === 'center') {
                var cx = dragRect.left + dragRect.width / 2, cy = dragRect.top + dragRect.height / 2;
                dropped = cx >= rect.left && cx <= rect.right && cy >= rect.top && cy <= rect.bottom;
            }
            if (isNumber(dropOverlap)) {
                var overlapArea = Math.max(0, Math.min(rect.right, dragRect.right) - Math.max(rect.left, dragRect.left)) * Math.max(0, Math.min(rect.bottom, dragRect.bottom) - Math.max(rect.top, dragRect.top)), overlapRatio = overlapArea / (dragRect.width * dragRect.height);
                dropped = overlapRatio >= dropOverlap;
            }
            if (this.options.drop.checker) dropped = this.options.drop.checker(dragEvent, event, dropped, this, dropElement, draggable, draggableElement);
            return dropped;
        },
        /*\
         * Interactable.dropChecker
         [ method ]
         *
         * DEPRECATED. Use interactable.dropzone({ checker: function... }) instead.
         *
         * Gets or sets the function used to check if a dragged element is
         * over this Interactable.
         *
         - checker (function) #optional The function that will be called when checking for a drop
         = (Function | Interactable) The checker function or this Interactable
         *
         * The checker function takes the following arguments:
         *
         - dragEvent (InteractEvent) The related dragmove or dragend event
         - event (TouchEvent | PointerEvent | MouseEvent) The user move/up/end Event related to the dragEvent
         - dropped (boolean) The value from the default drop checker
         - dropzone (Interactable) The dropzone interactable
         - dropElement (Element) The dropzone element
         - draggable (Interactable) The Interactable being dragged
         - draggableElement (Element) The actual element that's being dragged
         *
         > Usage:
         | interact(target)
         | .dropChecker(function(dragEvent,         // related dragmove or dragend event
         |                       event,             // TouchEvent/PointerEvent/MouseEvent
         |                       dropped,           // bool result of the default checker
         |                       dropzone,          // dropzone Interactable
         |                       dropElement,       // dropzone elemnt
         |                       draggable,         // draggable Interactable
         |                       draggableElement) {// draggable element
         |
         |   return dropped && event.target.hasAttribute('allow-drop');
         | }
        \*/ dropChecker: function(checker) {
            if (isFunction(checker)) {
                this.options.drop.checker = checker;
                return this;
            }
            if (checker === null) {
                delete this.options.getRect;
                return this;
            }
            return this.options.drop.checker;
        },
        /*\
         * Interactable.accept
         [ method ]
         *
         * Deprecated. add an `accept` property to the options object passed to
         * @Interactable.dropzone instead.
         *
         * Gets or sets the Element or CSS selector match that this
         * Interactable accepts if it is a dropzone.
         *
         - newValue (Element | string | null) #optional
         * If it is an Element, then only that element can be dropped into this dropzone.
         * If it is a string, the element being dragged must match it as a selector.
         * If it is null, the accept options is cleared - it accepts any element.
         *
         = (string | Element | null | Interactable) The current accept option if given `undefined` or this Interactable
        \*/ accept: function(newValue) {
            if (isElement(newValue)) {
                this.options.drop.accept = newValue;
                return this;
            }
            // test if it is a valid CSS selector
            if (trySelector(newValue)) {
                this.options.drop.accept = newValue;
                return this;
            }
            if (newValue === null) {
                delete this.options.drop.accept;
                return this;
            }
            return this.options.drop.accept;
        },
        /*\
         * Interactable.resizable
         [ method ]
         *
         * Gets or sets whether resize actions can be performed on the
         * Interactable
         *
         = (boolean) Indicates if this can be the target of resize elements
         | var isResizeable = interact('input[type=text]').resizable();
         * or
         - options (boolean | object) #optional true/false or An object with event listeners to be fired on resize events (object makes the Interactable resizable)
         = (object) This Interactable
         | interact(element).resizable({
         |     onstart: function (event) {},
         |     onmove : function (event) {},
         |     onend  : function (event) {},
         |
         |     edges: {
         |       top   : true,       // Use pointer coords to check for resize.
         |       left  : false,      // Disable resizing from left edge.
         |       bottom: '.resize-s',// Resize if pointer target matches selector
         |       right : handleEl    // Resize if pointer target is the given Element
         |     },
         |
         |     // Width and height can be adjusted independently. When `true`, width and
         |     // height are adjusted at a 1:1 ratio.
         |     square: false,
         |
         |     // Width and height can be adjusted independently. When `true`, width and
         |     // height maintain the aspect ratio they had when resizing started.
         |     preserveAspectRatio: false,
         |
         |     // a value of 'none' will limit the resize rect to a minimum of 0x0
         |     // 'negate' will allow the rect to have negative width/height
         |     // 'reposition' will keep the width/height positive by swapping
         |     // the top and bottom edges and/or swapping the left and right edges
         |     invert: 'none' || 'negate' || 'reposition'
         |
         |     // limit multiple resizes.
         |     // See the explanation in the @Interactable.draggable example
         |     max: Infinity,
         |     maxPerElement: 1,
         | });
        \*/ resizable: function(options) {
            if (isObject(options)) {
                this.options.resize.enabled = options.enabled === false ? false : true;
                this.setPerAction('resize', options);
                this.setOnEvents('resize', options);
                if (/^x$|^y$|^xy$/.test(options.axis)) this.options.resize.axis = options.axis;
                else if (options.axis === null) this.options.resize.axis = defaultOptions.resize.axis;
                if (isBool(options.preserveAspectRatio)) this.options.resize.preserveAspectRatio = options.preserveAspectRatio;
                else if (isBool(options.square)) this.options.resize.square = options.square;
                return this;
            }
            if (isBool(options)) {
                this.options.resize.enabled = options;
                return this;
            }
            return this.options.resize;
        },
        /*\
         * Interactable.squareResize
         [ method ]
         *
         * Deprecated. Add a `square: true || false` property to @Interactable.resizable instead
         *
         * Gets or sets whether resizing is forced 1:1 aspect
         *
         = (boolean) Current setting
         *
         * or
         *
         - newValue (boolean) #optional
         = (object) this Interactable
        \*/ squareResize: function(newValue) {
            if (isBool(newValue)) {
                this.options.resize.square = newValue;
                return this;
            }
            if (newValue === null) {
                delete this.options.resize.square;
                return this;
            }
            return this.options.resize.square;
        },
        /*\
         * Interactable.gesturable
         [ method ]
         *
         * Gets or sets whether multitouch gestures can be performed on the
         * Interactable's element
         *
         = (boolean) Indicates if this can be the target of gesture events
         | var isGestureable = interact(element).gesturable();
         * or
         - options (boolean | object) #optional true/false or An object with event listeners to be fired on gesture events (makes the Interactable gesturable)
         = (object) this Interactable
         | interact(element).gesturable({
         |     onstart: function (event) {},
         |     onmove : function (event) {},
         |     onend  : function (event) {},
         |
         |     // limit multiple gestures.
         |     // See the explanation in @Interactable.draggable example
         |     max: Infinity,
         |     maxPerElement: 1,
         | });
        \*/ gesturable: function(options) {
            if (isObject(options)) {
                this.options.gesture.enabled = options.enabled === false ? false : true;
                this.setPerAction('gesture', options);
                this.setOnEvents('gesture', options);
                return this;
            }
            if (isBool(options)) {
                this.options.gesture.enabled = options;
                return this;
            }
            return this.options.gesture;
        },
        /*\
         * Interactable.autoScroll
         [ method ]
         **
         * Deprecated. Add an `autoscroll` property to the options object
         * passed to @Interactable.draggable or @Interactable.resizable instead.
         *
         * Returns or sets whether dragging and resizing near the edges of the
         * window/container trigger autoScroll for this Interactable
         *
         = (object) Object with autoScroll properties
         *
         * or
         *
         - options (object | boolean) #optional
         * options can be:
         * - an object with margin, distance and interval properties,
         * - true or false to enable or disable autoScroll or
         = (Interactable) this Interactable
        \*/ autoScroll: function(options) {
            if (isObject(options)) options = extend({
                actions: [
                    'drag',
                    'resize'
                ]
            }, options);
            else if (isBool(options)) options = {
                actions: [
                    'drag',
                    'resize'
                ],
                enabled: options
            };
            return this.setOptions('autoScroll', options);
        },
        /*\
         * Interactable.snap
         [ method ]
         **
         * Deprecated. Add a `snap` property to the options object passed
         * to @Interactable.draggable or @Interactable.resizable instead.
         *
         * Returns or sets if and how action coordinates are snapped. By
         * default, snapping is relative to the pointer coordinates. You can
         * change this by setting the
         * [`elementOrigin`](https://github.com/taye/interact.js/pull/72).
         **
         = (boolean | object) `false` if snap is disabled; object with snap properties if snap is enabled
         **
         * or
         **
         - options (object | boolean | null) #optional
         = (Interactable) this Interactable
         > Usage
         | interact(document.querySelector('#thing')).snap({
         |     targets: [
         |         // snap to this specific point
         |         {
         |             x: 100,
         |             y: 100,
         |             range: 25
         |         },
         |         // give this function the x and y page coords and snap to the object returned
         |         function (x, y) {
         |             return {
         |                 x: x,
         |                 y: (75 + 50 * Math.sin(x * 0.04)),
         |                 range: 40
         |             };
         |         },
         |         // create a function that snaps to a grid
         |         interact.createSnapGrid({
         |             x: 50,
         |             y: 50,
         |             range: 10,              // optional
         |             offset: { x: 5, y: 10 } // optional
         |         })
         |     ],
         |     // do not snap during normal movement.
         |     // Instead, trigger only one snapped move event
         |     // immediately before the end event.
         |     endOnly: true,
         |
         |     relativePoints: [
         |         { x: 0, y: 0 },  // snap relative to the top left of the element
         |         { x: 1, y: 1 },  // and also to the bottom right
         |     ],  
         |
         |     // offset the snap target coordinates
         |     // can be an object with x/y or 'startCoords'
         |     offset: { x: 50, y: 50 }
         |   }
         | });
        \*/ snap: function(options) {
            var ret = this.setOptions('snap', options);
            if (ret === this) return this;
            return ret.drag;
        },
        setOptions: function(option, options) {
            var actions = options && isArray(options.actions) ? options.actions : [
                'drag'
            ];
            var i;
            if (isObject(options) || isBool(options)) {
                for(i = 0; i < actions.length; i++){
                    var action = /resize/.test(actions[i]) ? 'resize' : actions[i];
                    if (!isObject(this.options[action])) continue;
                    var thisOption = this.options[action][option];
                    if (isObject(options)) {
                        extend(thisOption, options);
                        thisOption.enabled = options.enabled === false ? false : true;
                        if (option === 'snap') {
                            if (thisOption.mode === 'grid') thisOption.targets = [
                                interact.createSnapGrid(extend({
                                    offset: thisOption.gridOffset || {
                                        x: 0,
                                        y: 0
                                    }
                                }, thisOption.grid || {}))
                            ];
                            else if (thisOption.mode === 'anchor') thisOption.targets = thisOption.anchors;
                            else if (thisOption.mode === 'path') thisOption.targets = thisOption.paths;
                            if ('elementOrigin' in options) thisOption.relativePoints = [
                                options.elementOrigin
                            ];
                        }
                    } else if (isBool(options)) thisOption.enabled = options;
                }
                return this;
            }
            var ret = {}, allActions = [
                'drag',
                'resize',
                'gesture'
            ];
            for(i = 0; i < allActions.length; i++)if (option in defaultOptions[allActions[i]]) ret[allActions[i]] = this.options[allActions[i]][option];
            return ret;
        },
        /*\
         * Interactable.inertia
         [ method ]
         **
         * Deprecated. Add an `inertia` property to the options object passed
         * to @Interactable.draggable or @Interactable.resizable instead.
         *
         * Returns or sets if and how events continue to run after the pointer is released
         **
         = (boolean | object) `false` if inertia is disabled; `object` with inertia properties if inertia is enabled
         **
         * or
         **
         - options (object | boolean | null) #optional
         = (Interactable) this Interactable
         > Usage
         | // enable and use default settings
         | interact(element).inertia(true);
         |
         | // enable and use custom settings
         | interact(element).inertia({
         |     // value greater than 0
         |     // high values slow the object down more quickly
         |     resistance     : 16,
         |
         |     // the minimum launch speed (pixels per second) that results in inertia start
         |     minSpeed       : 200,
         |
         |     // inertia will stop when the object slows down to this speed
         |     endSpeed       : 20,
         |
         |     // boolean; should actions be resumed when the pointer goes down during inertia
         |     allowResume    : true,
         |
         |     // boolean; should the jump when resuming from inertia be ignored in event.dx/dy
         |     zeroResumeDelta: false,
         |
         |     // if snap/restrict are set to be endOnly and inertia is enabled, releasing
         |     // the pointer without triggering inertia will animate from the release
         |     // point to the snaped/restricted point in the given amount of time (ms)
         |     smoothEndDuration: 300,
         |
         |     // an array of action types that can have inertia (no gesture)
         |     actions        : ['drag', 'resize']
         | });
         |
         | // reset custom settings and use all defaults
         | interact(element).inertia(null);
        \*/ inertia: function(options) {
            var ret = this.setOptions('inertia', options);
            if (ret === this) return this;
            return ret.drag;
        },
        getAction: function(pointer, event, interaction, element) {
            var action = this.defaultActionChecker(pointer, interaction, element);
            if (this.options.actionChecker) return this.options.actionChecker(pointer, event, action, this, element, interaction);
            return action;
        },
        defaultActionChecker: defaultActionChecker,
        /*\
         * Interactable.actionChecker
         [ method ]
         *
         * Gets or sets the function used to check action to be performed on
         * pointerDown
         *
         - checker (function | null) #optional A function which takes a pointer event, defaultAction string, interactable, element and interaction as parameters and returns an object with name property 'drag' 'resize' or 'gesture' and optionally an `edges` object with boolean 'top', 'left', 'bottom' and right props.
         = (Function | Interactable) The checker function or this Interactable
         *
         | interact('.resize-drag')
         |   .resizable(true)
         |   .draggable(true)
         |   .actionChecker(function (pointer, event, action, interactable, element, interaction) {
         |
         |   if (interact.matchesSelector(event.target, '.drag-handle') {
         |     // force drag with handle target
         |     action.name = drag;
         |   }
         |   else {
         |     // resize from the top and right edges
         |     action.name  = 'resize';
         |     action.edges = { top: true, right: true };
         |   }
         |
         |   return action;
         | });
        \*/ actionChecker: function(checker) {
            if (isFunction(checker)) {
                this.options.actionChecker = checker;
                return this;
            }
            if (checker === null) {
                delete this.options.actionChecker;
                return this;
            }
            return this.options.actionChecker;
        },
        /*\
         * Interactable.getRect
         [ method ]
         *
         * The default function to get an Interactables bounding rect. Can be
         * overridden using @Interactable.rectChecker.
         *
         - element (Element) #optional The element to measure.
         = (object) The object's bounding rectangle.
         o {
         o     top   : 0,
         o     left  : 0,
         o     bottom: 0,
         o     right : 0,
         o     width : 0,
         o     height: 0
         o }
        \*/ getRect: function rectCheck(element) {
            element = element || this._element;
            if (this.selector && !isElement(element)) element = this._context.querySelector(this.selector);
            return getElementRect(element);
        },
        /*\
         * Interactable.rectChecker
         [ method ]
         *
         * Returns or sets the function used to calculate the interactable's
         * element's rectangle
         *
         - checker (function) #optional A function which returns this Interactable's bounding rectangle. See @Interactable.getRect
         = (function | object) The checker function or this Interactable
        \*/ rectChecker: function(checker) {
            if (isFunction(checker)) {
                this.getRect = checker;
                return this;
            }
            if (checker === null) {
                delete this.options.getRect;
                return this;
            }
            return this.getRect;
        },
        /*\
         * Interactable.styleCursor
         [ method ]
         *
         * Returns or sets whether the action that would be performed when the
         * mouse on the element are checked on `mousemove` so that the cursor
         * may be styled appropriately
         *
         - newValue (boolean) #optional
         = (boolean | Interactable) The current setting or this Interactable
        \*/ styleCursor: function(newValue) {
            if (isBool(newValue)) {
                this.options.styleCursor = newValue;
                return this;
            }
            if (newValue === null) {
                delete this.options.styleCursor;
                return this;
            }
            return this.options.styleCursor;
        },
        /*\
         * Interactable.preventDefault
         [ method ]
         *
         * Returns or sets whether to prevent the browser's default behaviour
         * in response to pointer events. Can be set to:
         *  - `'always'` to always prevent
         *  - `'never'` to never prevent
         *  - `'auto'` to let interact.js try to determine what would be best
         *
         - newValue (string) #optional `true`, `false` or `'auto'`
         = (string | Interactable) The current setting or this Interactable
        \*/ preventDefault: function(newValue) {
            if (/^(always|never|auto)$/.test(newValue)) {
                this.options.preventDefault = newValue;
                return this;
            }
            if (isBool(newValue)) {
                this.options.preventDefault = newValue ? 'always' : 'never';
                return this;
            }
            return this.options.preventDefault;
        },
        /*\
         * Interactable.origin
         [ method ]
         *
         * Gets or sets the origin of the Interactable's element.  The x and y
         * of the origin will be subtracted from action event coordinates.
         *
         - origin (object | string) #optional An object eg. { x: 0, y: 0 } or string 'parent', 'self' or any CSS selector
         * OR
         - origin (Element) #optional An HTML or SVG Element whose rect will be used
         **
         = (object) The current origin or this Interactable
        \*/ origin: function(newValue) {
            if (trySelector(newValue)) {
                this.options.origin = newValue;
                return this;
            } else if (isObject(newValue)) {
                this.options.origin = newValue;
                return this;
            }
            return this.options.origin;
        },
        /*\
         * Interactable.deltaSource
         [ method ]
         *
         * Returns or sets the mouse coordinate types used to calculate the
         * movement of the pointer.
         *
         - newValue (string) #optional Use 'client' if you will be scrolling while interacting; Use 'page' if you want autoScroll to work
         = (string | object) The current deltaSource or this Interactable
        \*/ deltaSource: function(newValue) {
            if (newValue === 'page' || newValue === 'client') {
                this.options.deltaSource = newValue;
                return this;
            }
            return this.options.deltaSource;
        },
        /*\
         * Interactable.restrict
         [ method ]
         **
         * Deprecated. Add a `restrict` property to the options object passed to
         * @Interactable.draggable, @Interactable.resizable or @Interactable.gesturable instead.
         *
         * Returns or sets the rectangles within which actions on this
         * interactable (after snap calculations) are restricted. By default,
         * restricting is relative to the pointer coordinates. You can change
         * this by setting the
         * [`elementRect`](https://github.com/taye/interact.js/pull/72).
         **
         - options (object) #optional an object with keys drag, resize, and/or gesture whose values are rects, Elements, CSS selectors, or 'parent' or 'self'
         = (object) The current restrictions object or this Interactable
         **
         | interact(element).restrict({
         |     // the rect will be `interact.getElementRect(element.parentNode)`
         |     drag: element.parentNode,
         |
         |     // x and y are relative to the the interactable's origin
         |     resize: { x: 100, y: 100, width: 200, height: 200 }
         | })
         |
         | interact('.draggable').restrict({
         |     // the rect will be the selected element's parent
         |     drag: 'parent',
         |
         |     // do not restrict during normal movement.
         |     // Instead, trigger only one restricted move event
         |     // immediately before the end event.
         |     endOnly: true,
         |
         |     // https://github.com/taye/interact.js/pull/72#issue-41813493
         |     elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
         | });
        \*/ restrict: function(options) {
            if (!isObject(options)) return this.setOptions('restrict', options);
            var actions = [
                'drag',
                'resize',
                'gesture'
            ], ret;
            for(var i = 0; i < actions.length; i++){
                var action = actions[i];
                if (action in options) {
                    var perAction = extend({
                        actions: [
                            action
                        ],
                        restriction: options[action]
                    }, options);
                    ret = this.setOptions('restrict', perAction);
                }
            }
            return ret;
        },
        /*\
         * Interactable.context
         [ method ]
         *
         * Gets the selector context Node of the Interactable. The default is `window.document`.
         *
         = (Node) The context Node of this Interactable
         **
        \*/ context: function() {
            return this._context;
        },
        _context: document,
        /*\
         * Interactable.ignoreFrom
         [ method ]
         *
         * If the target of the `mousedown`, `pointerdown` or `touchstart`
         * event or any of it's parents match the given CSS selector or
         * Element, no drag/resize/gesture is started.
         *
         - newValue (string | Element | null) #optional a CSS selector string, an Element or `null` to not ignore any elements
         = (string | Element | object) The current ignoreFrom value or this Interactable
         **
         | interact(element, { ignoreFrom: document.getElementById('no-action') });
         | // or
         | interact(element).ignoreFrom('input, textarea, a');
        \*/ ignoreFrom: function(newValue) {
            if (trySelector(newValue)) {
                this.options.ignoreFrom = newValue;
                return this;
            }
            if (isElement(newValue)) {
                this.options.ignoreFrom = newValue;
                return this;
            }
            return this.options.ignoreFrom;
        },
        /*\
         * Interactable.allowFrom
         [ method ]
         *
         * A drag/resize/gesture is started only If the target of the
         * `mousedown`, `pointerdown` or `touchstart` event or any of it's
         * parents match the given CSS selector or Element.
         *
         - newValue (string | Element | null) #optional a CSS selector string, an Element or `null` to allow from any element
         = (string | Element | object) The current allowFrom value or this Interactable
         **
         | interact(element, { allowFrom: document.getElementById('drag-handle') });
         | // or
         | interact(element).allowFrom('.handle');
        \*/ allowFrom: function(newValue) {
            if (trySelector(newValue)) {
                this.options.allowFrom = newValue;
                return this;
            }
            if (isElement(newValue)) {
                this.options.allowFrom = newValue;
                return this;
            }
            return this.options.allowFrom;
        },
        /*\
         * Interactable.element
         [ method ]
         *
         * If this is not a selector Interactable, it returns the element this
         * interactable represents
         *
         = (Element) HTML / SVG Element
        \*/ element: function() {
            return this._element;
        },
        /*\
         * Interactable.fire
         [ method ]
         *
         * Calls listeners for the given InteractEvent type bound globally
         * and directly to this Interactable
         *
         - iEvent (InteractEvent) The InteractEvent object to be fired on this Interactable
         = (Interactable) this Interactable
        \*/ fire: function(iEvent) {
            if (!(iEvent && iEvent.type) || !contains(eventTypes, iEvent.type)) return this;
            var listeners, i, len, onEvent = 'on' + iEvent.type, funcName = '';
            // Interactable#on() listeners
            if (iEvent.type in this._iEvents) {
                listeners = this._iEvents[iEvent.type];
                for(i = 0, len = listeners.length; i < len && !iEvent.immediatePropagationStopped; i++){
                    funcName = listeners[i].name;
                    listeners[i](iEvent);
                }
            }
            // interactable.onevent listener
            if (isFunction(this[onEvent])) {
                funcName = this[onEvent].name;
                this[onEvent](iEvent);
            }
            // interact.on() listeners
            if (iEvent.type in globalEvents && (listeners = globalEvents[iEvent.type])) for(i = 0, len = listeners.length; i < len && !iEvent.immediatePropagationStopped; i++){
                funcName = listeners[i].name;
                listeners[i](iEvent);
            }
            return this;
        },
        /*\
         * Interactable.on
         [ method ]
         *
         * Binds a listener for an InteractEvent or DOM event.
         *
         - eventType  (string | array | object) The types of events to listen for
         - listener   (function) The function to be called on the given event(s)
         - useCapture (boolean) #optional useCapture flag for addEventListener
         = (object) This Interactable
        \*/ on: function(eventType, listener, useCapture) {
            var i;
            if (isString(eventType) && eventType.search(' ') !== -1) eventType = eventType.trim().split(/ +/);
            if (isArray(eventType)) {
                for(i = 0; i < eventType.length; i++)this.on(eventType[i], listener, useCapture);
                return this;
            }
            if (isObject(eventType)) {
                for(var prop in eventType)this.on(prop, eventType[prop], listener);
                return this;
            }
            if (eventType === 'wheel') eventType = wheelEvent;
            // convert to boolean
            useCapture = useCapture ? true : false;
            if (contains(eventTypes, eventType)) {
                // if this type of event was never bound to this Interactable
                if (!(eventType in this._iEvents)) this._iEvents[eventType] = [
                    listener
                ];
                else this._iEvents[eventType].push(listener);
            } else if (this.selector) {
                if (!delegatedEvents[eventType]) {
                    delegatedEvents[eventType] = {
                        selectors: [],
                        contexts: [],
                        listeners: []
                    };
                    // add delegate listener functions
                    for(i = 0; i < documents.length; i++){
                        events.add(documents[i], eventType, delegateListener);
                        events.add(documents[i], eventType, delegateUseCapture, true);
                    }
                }
                var delegated = delegatedEvents[eventType], index;
                for(index = delegated.selectors.length - 1; index >= 0; index--){
                    if (delegated.selectors[index] === this.selector && delegated.contexts[index] === this._context) break;
                }
                if (index === -1) {
                    index = delegated.selectors.length;
                    delegated.selectors.push(this.selector);
                    delegated.contexts.push(this._context);
                    delegated.listeners.push([]);
                }
                // keep listener and useCapture flag
                delegated.listeners[index].push([
                    listener,
                    useCapture
                ]);
            } else events.add(this._element, eventType, listener, useCapture);
            return this;
        },
        /*\
         * Interactable.off
         [ method ]
         *
         * Removes an InteractEvent or DOM event listener
         *
         - eventType  (string | array | object) The types of events that were listened for
         - listener   (function) The listener function to be removed
         - useCapture (boolean) #optional useCapture flag for removeEventListener
         = (object) This Interactable
        \*/ off: function(eventType, listener, useCapture) {
            var i;
            if (isString(eventType) && eventType.search(' ') !== -1) eventType = eventType.trim().split(/ +/);
            if (isArray(eventType)) {
                for(i = 0; i < eventType.length; i++)this.off(eventType[i], listener, useCapture);
                return this;
            }
            if (isObject(eventType)) {
                for(var prop in eventType)this.off(prop, eventType[prop], listener);
                return this;
            }
            var eventList, index = -1;
            // convert to boolean
            useCapture = useCapture ? true : false;
            if (eventType === 'wheel') eventType = wheelEvent;
            // if it is an action event type
            if (contains(eventTypes, eventType)) {
                eventList = this._iEvents[eventType];
                if (eventList && (index = indexOf(eventList, listener)) !== -1) this._iEvents[eventType].splice(index, 1);
            } else if (this.selector) {
                var delegated = delegatedEvents[eventType], matchFound = false;
                if (!delegated) return this;
                // count from last index of delegated to 0
                for(index = delegated.selectors.length - 1; index >= 0; index--)// look for matching selector and context Node
                if (delegated.selectors[index] === this.selector && delegated.contexts[index] === this._context) {
                    var listeners = delegated.listeners[index];
                    // each item of the listeners array is an array: [function, useCaptureFlag]
                    for(i = listeners.length - 1; i >= 0; i--){
                        var fn = listeners[i][0], useCap = listeners[i][1];
                        // check if the listener functions and useCapture flags match
                        if (fn === listener && useCap === useCapture) {
                            // remove the listener from the array of listeners
                            listeners.splice(i, 1);
                            // if all listeners for this interactable have been removed
                            // remove the interactable from the delegated arrays
                            if (!listeners.length) {
                                delegated.selectors.splice(index, 1);
                                delegated.contexts.splice(index, 1);
                                delegated.listeners.splice(index, 1);
                                // remove delegate function from context
                                events.remove(this._context, eventType, delegateListener);
                                events.remove(this._context, eventType, delegateUseCapture, true);
                                // remove the arrays if they are empty
                                if (!delegated.selectors.length) delegatedEvents[eventType] = null;
                            }
                            // only remove one listener
                            matchFound = true;
                            break;
                        }
                    }
                    if (matchFound) break;
                }
            } else events.remove(this._element, eventType, listener, useCapture);
            return this;
        },
        /*\
         * Interactable.set
         [ method ]
         *
         * Reset the options of this Interactable
         - options (object) The new settings to apply
         = (object) This Interactable
        \*/ set: function(options) {
            if (!isObject(options)) options = {};
            this.options = extend({}, defaultOptions.base);
            var i, actions = [
                'drag',
                'drop',
                'resize',
                'gesture'
            ], methods = [
                'draggable',
                'dropzone',
                'resizable',
                'gesturable'
            ], perActions = extend(extend({}, defaultOptions.perAction), options[action] || {});
            for(i = 0; i < actions.length; i++){
                var action = actions[i];
                this.options[action] = extend({}, defaultOptions[action]);
                this.setPerAction(action, perActions);
                this[methods[i]](options[action]);
            }
            var settings = [
                'accept',
                'actionChecker',
                'allowFrom',
                'deltaSource',
                'dropChecker',
                'ignoreFrom',
                'origin',
                'preventDefault',
                'rectChecker',
                'styleCursor'
            ];
            for(i = 0, len = settings.length; i < len; i++){
                var setting = settings[i];
                this.options[setting] = defaultOptions.base[setting];
                if (setting in options) this[setting](options[setting]);
            }
            return this;
        },
        /*\
         * Interactable.unset
         [ method ]
         *
         * Remove this interactable from the list of interactables and remove
         * it's drag, drop, resize and gesture capabilities
         *
         = (object) @interact
        \*/ unset: function() {
            events.remove(this._element, 'all');
            if (!isString(this.selector)) {
                events.remove(this, 'all');
                if (this.options.styleCursor) this._element.style.cursor = '';
            } else // remove delegated events
            for(var type in delegatedEvents){
                var delegated = delegatedEvents[type];
                for(var i = 0; i < delegated.selectors.length; i++){
                    if (delegated.selectors[i] === this.selector && delegated.contexts[i] === this._context) {
                        delegated.selectors.splice(i, 1);
                        delegated.contexts.splice(i, 1);
                        delegated.listeners.splice(i, 1);
                        // remove the arrays if they are empty
                        if (!delegated.selectors.length) delegatedEvents[type] = null;
                    }
                    events.remove(this._context, type, delegateListener);
                    events.remove(this._context, type, delegateUseCapture, true);
                    break;
                }
            }
            this.dropzone(false);
            interactables.splice(indexOf(interactables, this), 1);
            return interact;
        }
    };
    function warnOnce(method, message) {
        var warned = false;
        return function() {
            if (!warned) {
                window1.console.warn(message);
                warned = true;
            }
            return method.apply(this, arguments);
        };
    }
    Interactable.prototype.snap = warnOnce(Interactable.prototype.snap, 'Interactable#snap is deprecated. See the new documentation for snapping at http://interactjs.io/docs/snapping');
    Interactable.prototype.restrict = warnOnce(Interactable.prototype.restrict, 'Interactable#restrict is deprecated. See the new documentation for resticting at http://interactjs.io/docs/restriction');
    Interactable.prototype.inertia = warnOnce(Interactable.prototype.inertia, 'Interactable#inertia is deprecated. See the new documentation for inertia at http://interactjs.io/docs/inertia');
    Interactable.prototype.autoScroll = warnOnce(Interactable.prototype.autoScroll, 'Interactable#autoScroll is deprecated. See the new documentation for autoScroll at http://interactjs.io/docs/#autoscroll');
    Interactable.prototype.squareResize = warnOnce(Interactable.prototype.squareResize, 'Interactable#squareResize is deprecated. See http://interactjs.io/docs/#resize-square');
    Interactable.prototype.accept = warnOnce(Interactable.prototype.accept, 'Interactable#accept is deprecated. use Interactable#dropzone({ accept: target }) instead');
    Interactable.prototype.dropChecker = warnOnce(Interactable.prototype.dropChecker, 'Interactable#dropChecker is deprecated. use Interactable#dropzone({ dropChecker: checkerFunction }) instead');
    Interactable.prototype.context = warnOnce(Interactable.prototype.context, 'Interactable#context as a method is deprecated. It will soon be a DOM Node instead');
    /*\
     * interact.isSet
     [ method ]
     *
     * Check if an element has been set
     - element (Element) The Element being searched for
     = (boolean) Indicates if the element or CSS selector was previously passed to interact
    \*/ interact.isSet = function(element, options) {
        return interactables.indexOfElement(element, options && options.context) !== -1;
    };
    /*\
     * interact.on
     [ method ]
     *
     * Adds a global listener for an InteractEvent or adds a DOM event to
     * `document`
     *
     - type       (string | array | object) The types of events to listen for
     - listener   (function) The function to be called on the given event(s)
     - useCapture (boolean) #optional useCapture flag for addEventListener
     = (object) interact
    \*/ interact.on = function(type, listener, useCapture) {
        if (isString(type) && type.search(' ') !== -1) type = type.trim().split(/ +/);
        if (isArray(type)) {
            for(var i = 0; i < type.length; i++)interact.on(type[i], listener, useCapture);
            return interact;
        }
        if (isObject(type)) {
            for(var prop in type)interact.on(prop, type[prop], listener);
            return interact;
        }
        // if it is an InteractEvent type, add listener to globalEvents
        if (contains(eventTypes, type)) {
            // if this type of event was never bound
            if (!globalEvents[type]) globalEvents[type] = [
                listener
            ];
            else globalEvents[type].push(listener);
        } else events.add(document, type, listener, useCapture);
        return interact;
    };
    /*\
     * interact.off
     [ method ]
     *
     * Removes a global InteractEvent listener or DOM event from `document`
     *
     - type       (string | array | object) The types of events that were listened for
     - listener   (function) The listener function to be removed
     - useCapture (boolean) #optional useCapture flag for removeEventListener
     = (object) interact
     \*/ interact.off = function(type, listener, useCapture) {
        if (isString(type) && type.search(' ') !== -1) type = type.trim().split(/ +/);
        if (isArray(type)) {
            for(var i = 0; i < type.length; i++)interact.off(type[i], listener, useCapture);
            return interact;
        }
        if (isObject(type)) {
            for(var prop in type)interact.off(prop, type[prop], listener);
            return interact;
        }
        if (!contains(eventTypes, type)) events.remove(document, type, listener, useCapture);
        else {
            var index;
            if (type in globalEvents && (index = indexOf(globalEvents[type], listener)) !== -1) globalEvents[type].splice(index, 1);
        }
        return interact;
    };
    /*\
     * interact.enableDragging
     [ method ]
     *
     * Deprecated.
     *
     * Returns or sets whether dragging is enabled for any Interactables
     *
     - newValue (boolean) #optional `true` to allow the action; `false` to disable action for all Interactables
     = (boolean | object) The current setting or interact
    \*/ interact.enableDragging = warnOnce(function(newValue) {
        if (newValue !== null && newValue !== undefined) {
            actionIsEnabled.drag = newValue;
            return interact;
        }
        return actionIsEnabled.drag;
    }, 'interact.enableDragging is deprecated and will soon be removed.');
    /*\
     * interact.enableResizing
     [ method ]
     *
     * Deprecated.
     *
     * Returns or sets whether resizing is enabled for any Interactables
     *
     - newValue (boolean) #optional `true` to allow the action; `false` to disable action for all Interactables
     = (boolean | object) The current setting or interact
    \*/ interact.enableResizing = warnOnce(function(newValue) {
        if (newValue !== null && newValue !== undefined) {
            actionIsEnabled.resize = newValue;
            return interact;
        }
        return actionIsEnabled.resize;
    }, 'interact.enableResizing is deprecated and will soon be removed.');
    /*\
     * interact.enableGesturing
     [ method ]
     *
     * Deprecated.
     *
     * Returns or sets whether gesturing is enabled for any Interactables
     *
     - newValue (boolean) #optional `true` to allow the action; `false` to disable action for all Interactables
     = (boolean | object) The current setting or interact
    \*/ interact.enableGesturing = warnOnce(function(newValue) {
        if (newValue !== null && newValue !== undefined) {
            actionIsEnabled.gesture = newValue;
            return interact;
        }
        return actionIsEnabled.gesture;
    }, 'interact.enableGesturing is deprecated and will soon be removed.');
    interact.eventTypes = eventTypes;
    /*\
     * interact.debug
     [ method ]
     *
     * Returns debugging data
     = (object) An object with properties that outline the current state and expose internal functions and variables
    \*/ interact.debug = function() {
        var interaction = interactions[0] || new Interaction();
        return {
            interactions: interactions,
            target: interaction.target,
            dragging: interaction.dragging,
            resizing: interaction.resizing,
            gesturing: interaction.gesturing,
            prepared: interaction.prepared,
            matches: interaction.matches,
            matchElements: interaction.matchElements,
            prevCoords: interaction.prevCoords,
            startCoords: interaction.startCoords,
            pointerIds: interaction.pointerIds,
            pointers: interaction.pointers,
            addPointer: listeners.addPointer,
            removePointer: listeners.removePointer,
            recordPointer: listeners.recordPointer,
            snap: interaction.snapStatus,
            restrict: interaction.restrictStatus,
            inertia: interaction.inertiaStatus,
            downTime: interaction.downTimes[0],
            downEvent: interaction.downEvent,
            downPointer: interaction.downPointer,
            prevEvent: interaction.prevEvent,
            Interactable: Interactable,
            interactables: interactables,
            pointerIsDown: interaction.pointerIsDown,
            defaultOptions: defaultOptions,
            defaultActionChecker: defaultActionChecker,
            actionCursors: actionCursors,
            dragMove: listeners.dragMove,
            resizeMove: listeners.resizeMove,
            gestureMove: listeners.gestureMove,
            pointerUp: listeners.pointerUp,
            pointerDown: listeners.pointerDown,
            pointerMove: listeners.pointerMove,
            pointerHover: listeners.pointerHover,
            eventTypes: eventTypes,
            events: events,
            globalEvents: globalEvents,
            delegatedEvents: delegatedEvents,
            prefixedPropREs: prefixedPropREs
        };
    };
    // expose the functions used to calculate multi-touch properties
    interact.getPointerAverage = pointerAverage;
    interact.getTouchBBox = touchBBox;
    interact.getTouchDistance = touchDistance;
    interact.getTouchAngle = touchAngle;
    interact.getElementRect = getElementRect;
    interact.getElementClientRect = getElementClientRect;
    interact.matchesSelector = matchesSelector;
    interact.closest = closest;
    /*\
     * interact.margin
     [ method ]
     *
     * Deprecated. Use `interact(target).resizable({ margin: number });` instead.
     * Returns or sets the margin for autocheck resizing used in
     * @Interactable.getAction. That is the distance from the bottom and right
     * edges of an element clicking in which will start resizing
     *
     - newValue (number) #optional
     = (number | interact) The current margin value or interact
    \*/ interact.margin = warnOnce(function(newvalue) {
        if (isNumber(newvalue)) {
            margin = newvalue;
            return interact;
        }
        return margin;
    }, 'interact.margin is deprecated. Use interact(target).resizable({ margin: number }); instead.');
    /*\
     * interact.supportsTouch
     [ method ]
     *
     = (boolean) Whether or not the browser supports touch input
    \*/ interact.supportsTouch = function() {
        return supportsTouch;
    };
    /*\
     * interact.supportsPointerEvent
     [ method ]
     *
     = (boolean) Whether or not the browser supports PointerEvents
    \*/ interact.supportsPointerEvent = function() {
        return supportsPointerEvent;
    };
    /*\
     * interact.stop
     [ method ]
     *
     * Cancels all interactions (end events are not fired)
     *
     - event (Event) An event on which to call preventDefault()
     = (object) interact
    \*/ interact.stop = function(event) {
        for(var i = interactions.length - 1; i >= 0; i--)interactions[i].stop(event);
        return interact;
    };
    /*\
     * interact.dynamicDrop
     [ method ]
     *
     * Returns or sets whether the dimensions of dropzone elements are
     * calculated on every dragmove or only on dragstart for the default
     * dropChecker
     *
     - newValue (boolean) #optional True to check on each move. False to check only before start
     = (boolean | interact) The current setting or interact
    \*/ interact.dynamicDrop = function(newValue) {
        if (isBool(newValue)) {
            //if (dragging && dynamicDrop !== newValue && !newValue) {
            //calcRects(dropzones);
            //}
            dynamicDrop = newValue;
            return interact;
        }
        return dynamicDrop;
    };
    /*\
     * interact.pointerMoveTolerance
     [ method ]
     * Returns or sets the distance the pointer must be moved before an action
     * sequence occurs. This also affects tolerance for tap events.
     *
     - newValue (number) #optional The movement from the start position must be greater than this value
     = (number | Interactable) The current setting or interact
    \*/ interact.pointerMoveTolerance = function(newValue) {
        if (isNumber(newValue)) {
            pointerMoveTolerance = newValue;
            return this;
        }
        return pointerMoveTolerance;
    };
    /*\
     * interact.maxInteractions
     [ method ]
     **
     * Returns or sets the maximum number of concurrent interactions allowed.
     * By default only 1 interaction is allowed at a time (for backwards
     * compatibility). To allow multiple interactions on the same Interactables
     * and elements, you need to enable it in the draggable, resizable and
     * gesturable `'max'` and `'maxPerElement'` options.
     **
     - newValue (number) #optional Any number. newValue <= 0 means no interactions.
    \*/ interact.maxInteractions = function(newValue) {
        if (isNumber(newValue)) {
            maxInteractions = newValue;
            return this;
        }
        return maxInteractions;
    };
    interact.createSnapGrid = function(grid) {
        return function(x, y) {
            var offsetX = 0, offsetY = 0;
            if (isObject(grid.offset)) {
                offsetX = grid.offset.x;
                offsetY = grid.offset.y;
            }
            var gridx = Math.round((x - offsetX) / grid.x), gridy = Math.round((y - offsetY) / grid.y), newX = gridx * grid.x + offsetX, newY = gridy * grid.y + offsetY;
            return {
                x: newX,
                y: newY,
                range: grid.range
            };
        };
    };
    function endAllInteractions(event) {
        for(var i = 0; i < interactions.length; i++)interactions[i].pointerEnd(event, event);
    }
    function listenToDocument(doc) {
        if (contains(documents, doc)) return;
        var win = doc.defaultView || doc.parentWindow;
        // add delegate event listener
        for(var eventType in delegatedEvents){
            events.add(doc, eventType, delegateListener);
            events.add(doc, eventType, delegateUseCapture, true);
        }
        if (supportsPointerEvent) {
            if (PointerEvent === win.MSPointerEvent) pEventTypes = {
                up: 'MSPointerUp',
                down: 'MSPointerDown',
                over: 'mouseover',
                out: 'mouseout',
                move: 'MSPointerMove',
                cancel: 'MSPointerCancel'
            };
            else pEventTypes = {
                up: 'pointerup',
                down: 'pointerdown',
                over: 'pointerover',
                out: 'pointerout',
                move: 'pointermove',
                cancel: 'pointercancel'
            };
            events.add(doc, pEventTypes.down, listeners.selectorDown);
            events.add(doc, pEventTypes.move, listeners.pointerMove);
            events.add(doc, pEventTypes.over, listeners.pointerOver);
            events.add(doc, pEventTypes.out, listeners.pointerOut);
            events.add(doc, pEventTypes.up, listeners.pointerUp);
            events.add(doc, pEventTypes.cancel, listeners.pointerCancel);
            // autoscroll
            events.add(doc, pEventTypes.move, listeners.autoScrollMove);
        } else {
            events.add(doc, 'mousedown', listeners.selectorDown);
            events.add(doc, 'mousemove', listeners.pointerMove);
            events.add(doc, 'mouseup', listeners.pointerUp);
            events.add(doc, 'mouseover', listeners.pointerOver);
            events.add(doc, 'mouseout', listeners.pointerOut);
            events.add(doc, 'touchstart', listeners.selectorDown);
            events.add(doc, 'touchmove', listeners.pointerMove);
            events.add(doc, 'touchend', listeners.pointerUp);
            events.add(doc, 'touchcancel', listeners.pointerCancel);
            // autoscroll
            events.add(doc, 'mousemove', listeners.autoScrollMove);
            events.add(doc, 'touchmove', listeners.autoScrollMove);
        }
        events.add(win, 'blur', endAllInteractions);
        try {
            if (win.frameElement) {
                var parentDoc = win.frameElement.ownerDocument, parentWindow = parentDoc.defaultView;
                events.add(parentDoc, 'mouseup', listeners.pointerEnd);
                events.add(parentDoc, 'touchend', listeners.pointerEnd);
                events.add(parentDoc, 'touchcancel', listeners.pointerEnd);
                events.add(parentDoc, 'pointerup', listeners.pointerEnd);
                events.add(parentDoc, 'MSPointerUp', listeners.pointerEnd);
                events.add(parentWindow, 'blur', endAllInteractions);
            }
        } catch (error) {
            interact.windowParentError = error;
        }
        // prevent native HTML5 drag on interact.js target elements
        events.add(doc, 'dragstart', function(event) {
            for(var i = 0; i < interactions.length; i++){
                var interaction = interactions[i];
                if (interaction.element && (interaction.element === event.target || nodeContains(interaction.element, event.target))) {
                    interaction.checkAndPreventDefault(event, interaction.target, interaction.element);
                    return;
                }
            }
        });
        if (events.useAttachEvent) {
            // For IE's lack of Event#preventDefault
            events.add(doc, 'selectstart', function(event) {
                var interaction = interactions[0];
                if (interaction.currentAction()) interaction.checkAndPreventDefault(event);
            });
            // For IE's bad dblclick event sequence
            events.add(doc, 'dblclick', doOnInteractions('ie8Dblclick'));
        }
        documents.push(doc);
    }
    listenToDocument(document);
    function indexOf(array, target) {
        for(var i = 0, len = array.length; i < len; i++){
            if (array[i] === target) return i;
        }
        return -1;
    }
    function contains(array, target) {
        return indexOf(array, target) !== -1;
    }
    function matchesSelector(element, selector, nodeList) {
        if (ie8MatchesSelector) return ie8MatchesSelector(element, selector, nodeList);
        // remove /deep/ from selectors if shadowDOM polyfill is used
        if (window1 !== realWindow) selector = selector.replace(/\/deep\//g, ' ');
        return element[prefixedMatchesSelector](selector);
    }
    function matchesUpTo(element, selector, limit) {
        while(isElement(element)){
            if (matchesSelector(element, selector)) return true;
            element = parentElement(element);
            if (element === limit) return matchesSelector(element, selector);
        }
        return false;
    }
    // For IE8's lack of an Element#matchesSelector
    // taken from http://tanalin.com/en/blog/2012/12/matches-selector-ie8/ and modified
    if (!(prefixedMatchesSelector in Element.prototype) || !isFunction(Element.prototype[prefixedMatchesSelector])) ie8MatchesSelector = function(element, selector, elems) {
        elems = elems || element.parentNode.querySelectorAll(selector);
        for(var i = 0, len = elems.length; i < len; i++){
            if (elems[i] === element) return true;
        }
        return false;
    };
    // requestAnimationFrame polyfill
    (function() {
        var lastTime = 0, vendors = [
            'ms',
            'moz',
            'webkit',
            'o'
        ];
        for(var x = 0; x < vendors.length && !realWindow.requestAnimationFrame; ++x){
            reqFrame = realWindow[vendors[x] + 'RequestAnimationFrame'];
            cancelFrame = realWindow[vendors[x] + 'CancelAnimationFrame'] || realWindow[vendors[x] + 'CancelRequestAnimationFrame'];
        }
        if (!reqFrame) reqFrame = function(callback) {
            var currTime = new Date().getTime(), timeToCall = Math.max(0, 16 - (currTime - lastTime)), id = setTimeout(function() {
                callback(currTime + timeToCall);
            }, timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };
        if (!cancelFrame) cancelFrame = function(id) {
            clearTimeout(id);
        };
    })();
    if (module.exports) exports = module.exports = interact;
    exports.interact = interact;
})(typeof window === 'undefined' ? undefined : window);

},{}],"9Yt0x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scaleBand", ()=>(0, _bandDefault.default));
parcelHelpers.export(exports, "scalePoint", ()=>(0, _band.point));
parcelHelpers.export(exports, "scaleIdentity", ()=>(0, _identityDefault.default));
parcelHelpers.export(exports, "scaleLinear", ()=>(0, _linearDefault.default));
parcelHelpers.export(exports, "scaleLog", ()=>(0, _logDefault.default));
parcelHelpers.export(exports, "scaleOrdinal", ()=>(0, _ordinalDefault.default));
parcelHelpers.export(exports, "scaleImplicit", ()=>(0, _ordinal.implicit));
parcelHelpers.export(exports, "scalePow", ()=>(0, _powDefault.default));
parcelHelpers.export(exports, "scaleSqrt", ()=>(0, _pow.sqrt));
parcelHelpers.export(exports, "scaleQuantile", ()=>(0, _quantileDefault.default));
parcelHelpers.export(exports, "scaleQuantize", ()=>(0, _quantizeDefault.default));
parcelHelpers.export(exports, "scaleThreshold", ()=>(0, _thresholdDefault.default));
parcelHelpers.export(exports, "scaleTime", ()=>(0, _timeDefault.default));
parcelHelpers.export(exports, "scaleUtc", ()=>(0, _utcTimeDefault.default));
parcelHelpers.export(exports, "schemeCategory10", ()=>(0, _category10Default.default));
parcelHelpers.export(exports, "schemeCategory20b", ()=>(0, _category20BDefault.default));
parcelHelpers.export(exports, "schemeCategory20c", ()=>(0, _category20CDefault.default));
parcelHelpers.export(exports, "schemeCategory20", ()=>(0, _category20Default.default));
parcelHelpers.export(exports, "interpolateCubehelixDefault", ()=>(0, _cubehelixDefault.default));
parcelHelpers.export(exports, "interpolateRainbow", ()=>(0, _rainbowDefault.default));
parcelHelpers.export(exports, "interpolateWarm", ()=>(0, _rainbow.warm));
parcelHelpers.export(exports, "interpolateCool", ()=>(0, _rainbow.cool));
parcelHelpers.export(exports, "interpolateViridis", ()=>(0, _viridisDefault.default));
parcelHelpers.export(exports, "interpolateMagma", ()=>(0, _viridis.magma));
parcelHelpers.export(exports, "interpolateInferno", ()=>(0, _viridis.inferno));
parcelHelpers.export(exports, "interpolatePlasma", ()=>(0, _viridis.plasma));
parcelHelpers.export(exports, "scaleSequential", ()=>(0, _sequentialDefault.default));
var _band = require("./src/band");
var _bandDefault = parcelHelpers.interopDefault(_band);
var _identity = require("./src/identity");
var _identityDefault = parcelHelpers.interopDefault(_identity);
var _linear = require("./src/linear");
var _linearDefault = parcelHelpers.interopDefault(_linear);
var _log = require("./src/log");
var _logDefault = parcelHelpers.interopDefault(_log);
var _ordinal = require("./src/ordinal");
var _ordinalDefault = parcelHelpers.interopDefault(_ordinal);
var _pow = require("./src/pow");
var _powDefault = parcelHelpers.interopDefault(_pow);
var _quantile = require("./src/quantile");
var _quantileDefault = parcelHelpers.interopDefault(_quantile);
var _quantize = require("./src/quantize");
var _quantizeDefault = parcelHelpers.interopDefault(_quantize);
var _threshold = require("./src/threshold");
var _thresholdDefault = parcelHelpers.interopDefault(_threshold);
var _time = require("./src/time");
var _timeDefault = parcelHelpers.interopDefault(_time);
var _utcTime = require("./src/utcTime");
var _utcTimeDefault = parcelHelpers.interopDefault(_utcTime);
var _category10 = require("./src/category10");
var _category10Default = parcelHelpers.interopDefault(_category10);
var _category20B = require("./src/category20b");
var _category20BDefault = parcelHelpers.interopDefault(_category20B);
var _category20C = require("./src/category20c");
var _category20CDefault = parcelHelpers.interopDefault(_category20C);
var _category20 = require("./src/category20");
var _category20Default = parcelHelpers.interopDefault(_category20);
var _cubehelix = require("./src/cubehelix");
var _cubehelixDefault = parcelHelpers.interopDefault(_cubehelix);
var _rainbow = require("./src/rainbow");
var _rainbowDefault = parcelHelpers.interopDefault(_rainbow);
var _viridis = require("./src/viridis");
var _viridisDefault = parcelHelpers.interopDefault(_viridis);
var _sequential = require("./src/sequential");
var _sequentialDefault = parcelHelpers.interopDefault(_sequential);

},{"./src/band":"eTg7o","./src/identity":"4y6ob","./src/linear":"drdK3","./src/log":"4QyyI","./src/ordinal":"5SJUY","./src/pow":"bNEJh","./src/quantile":"7xViq","./src/quantize":"cbUWW","./src/threshold":"RpTbZ","./src/time":"2J8Xy","./src/utcTime":"lHXiS","./src/category10":"03mxo","./src/category20b":"cYn56","./src/category20c":"hkMJV","./src/category20":"cdOhs","./src/cubehelix":"62Lgs","./src/rainbow":"20XqR","./src/viridis":"hoSSi","./src/sequential":"aYUCC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eTg7o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>band);
parcelHelpers.export(exports, "point", ()=>point);
var _d3Array = require("d3-array");
var _ordinal = require("./ordinal");
var _ordinalDefault = parcelHelpers.interopDefault(_ordinal);
function band() {
    var scale = (0, _ordinalDefault.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, range = [
        0,
        1
    ], step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = range[1] < range[0], start = range[reverse - 0], stop = range[1 - reverse];
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, _d3Array.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? (range = [
            +_[0],
            +_[1]
        ], rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = [
            +_[0],
            +_[1]
        ], round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return band().domain(domain()).range(range).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return rescale();
}
function pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return pointish(copy());
    };
    return scale;
}
function point() {
    return pointish(band().paddingInner(1));
}

},{"d3-array":"5DW5h","./ordinal":"5SJUY","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5DW5h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bisect", ()=>(0, _bisectDefault.default));
parcelHelpers.export(exports, "bisectRight", ()=>(0, _bisect.bisectRight));
parcelHelpers.export(exports, "bisectLeft", ()=>(0, _bisect.bisectLeft));
parcelHelpers.export(exports, "ascending", ()=>(0, _ascendingDefault.default));
parcelHelpers.export(exports, "bisector", ()=>(0, _bisectorDefault.default));
parcelHelpers.export(exports, "cross", ()=>(0, _crossDefault.default));
parcelHelpers.export(exports, "descending", ()=>(0, _descendingDefault.default));
parcelHelpers.export(exports, "deviation", ()=>(0, _deviationDefault.default));
parcelHelpers.export(exports, "extent", ()=>(0, _extentDefault.default));
parcelHelpers.export(exports, "histogram", ()=>(0, _histogramDefault.default));
parcelHelpers.export(exports, "thresholdFreedmanDiaconis", ()=>(0, _freedmanDiaconisDefault.default));
parcelHelpers.export(exports, "thresholdScott", ()=>(0, _scottDefault.default));
parcelHelpers.export(exports, "thresholdSturges", ()=>(0, _sturgesDefault.default));
parcelHelpers.export(exports, "max", ()=>(0, _maxDefault.default));
parcelHelpers.export(exports, "mean", ()=>(0, _meanDefault.default));
parcelHelpers.export(exports, "median", ()=>(0, _medianDefault.default));
parcelHelpers.export(exports, "merge", ()=>(0, _mergeDefault.default));
parcelHelpers.export(exports, "min", ()=>(0, _minDefault.default));
parcelHelpers.export(exports, "pairs", ()=>(0, _pairsDefault.default));
parcelHelpers.export(exports, "permute", ()=>(0, _permuteDefault.default));
parcelHelpers.export(exports, "quantile", ()=>(0, _quantileDefault.default));
parcelHelpers.export(exports, "range", ()=>(0, _rangeDefault.default));
parcelHelpers.export(exports, "scan", ()=>(0, _scanDefault.default));
parcelHelpers.export(exports, "shuffle", ()=>(0, _shuffleDefault.default));
parcelHelpers.export(exports, "sum", ()=>(0, _sumDefault.default));
parcelHelpers.export(exports, "ticks", ()=>(0, _ticksDefault.default));
parcelHelpers.export(exports, "tickIncrement", ()=>(0, _ticks.tickIncrement));
parcelHelpers.export(exports, "tickStep", ()=>(0, _ticks.tickStep));
parcelHelpers.export(exports, "transpose", ()=>(0, _transposeDefault.default));
parcelHelpers.export(exports, "variance", ()=>(0, _varianceDefault.default));
parcelHelpers.export(exports, "zip", ()=>(0, _zipDefault.default));
var _bisect = require("./bisect");
var _bisectDefault = parcelHelpers.interopDefault(_bisect);
var _ascending = require("./ascending");
var _ascendingDefault = parcelHelpers.interopDefault(_ascending);
var _bisector = require("./bisector");
var _bisectorDefault = parcelHelpers.interopDefault(_bisector);
var _cross = require("./cross");
var _crossDefault = parcelHelpers.interopDefault(_cross);
var _descending = require("./descending");
var _descendingDefault = parcelHelpers.interopDefault(_descending);
var _deviation = require("./deviation");
var _deviationDefault = parcelHelpers.interopDefault(_deviation);
var _extent = require("./extent");
var _extentDefault = parcelHelpers.interopDefault(_extent);
var _histogram = require("./histogram");
var _histogramDefault = parcelHelpers.interopDefault(_histogram);
var _freedmanDiaconis = require("./threshold/freedmanDiaconis");
var _freedmanDiaconisDefault = parcelHelpers.interopDefault(_freedmanDiaconis);
var _scott = require("./threshold/scott");
var _scottDefault = parcelHelpers.interopDefault(_scott);
var _sturges = require("./threshold/sturges");
var _sturgesDefault = parcelHelpers.interopDefault(_sturges);
var _max = require("./max");
var _maxDefault = parcelHelpers.interopDefault(_max);
var _mean = require("./mean");
var _meanDefault = parcelHelpers.interopDefault(_mean);
var _median = require("./median");
var _medianDefault = parcelHelpers.interopDefault(_median);
var _merge = require("./merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _min = require("./min");
var _minDefault = parcelHelpers.interopDefault(_min);
var _pairs = require("./pairs");
var _pairsDefault = parcelHelpers.interopDefault(_pairs);
var _permute = require("./permute");
var _permuteDefault = parcelHelpers.interopDefault(_permute);
var _quantile = require("./quantile");
var _quantileDefault = parcelHelpers.interopDefault(_quantile);
var _range = require("./range");
var _rangeDefault = parcelHelpers.interopDefault(_range);
var _scan = require("./scan");
var _scanDefault = parcelHelpers.interopDefault(_scan);
var _shuffle = require("./shuffle");
var _shuffleDefault = parcelHelpers.interopDefault(_shuffle);
var _sum = require("./sum");
var _sumDefault = parcelHelpers.interopDefault(_sum);
var _ticks = require("./ticks");
var _ticksDefault = parcelHelpers.interopDefault(_ticks);
var _transpose = require("./transpose");
var _transposeDefault = parcelHelpers.interopDefault(_transpose);
var _variance = require("./variance");
var _varianceDefault = parcelHelpers.interopDefault(_variance);
var _zip = require("./zip");
var _zipDefault = parcelHelpers.interopDefault(_zip);

},{"./bisect":"lDeAY","./ascending":"iP4KQ","./bisector":"ad3uc","./cross":"lIeWP","./descending":"jH6HB","./deviation":"bNbWo","./extent":"d08xM","./histogram":"4ajnQ","./threshold/freedmanDiaconis":"dw43i","./threshold/scott":"9S0rK","./threshold/sturges":"lGOLN","./max":"1bAQJ","./mean":"iQade","./median":"dvvjV","./merge":"lGYAT","./min":"ae85G","./pairs":"ldT3i","./permute":"bsNRU","./quantile":"3VgWE","./range":"9KezC","./scan":"cLF1p","./shuffle":"kzPaq","./sum":"8jQRH","./ticks":"h8PmC","./transpose":"libcT","./variance":"99UkP","./zip":"jgLP9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lDeAY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bisectRight", ()=>bisectRight);
parcelHelpers.export(exports, "bisectLeft", ()=>bisectLeft);
var _ascending = require("./ascending");
var _ascendingDefault = parcelHelpers.interopDefault(_ascending);
var _bisector = require("./bisector");
var _bisectorDefault = parcelHelpers.interopDefault(_bisector);
var ascendingBisect = (0, _bisectorDefault.default)((0, _ascendingDefault.default));
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
exports.default = bisectRight;

},{"./ascending":"iP4KQ","./bisector":"ad3uc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iP4KQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ad3uc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(compare) {
        if (compare.length === 1) compare = ascendingComparator(compare);
        return {
            left: function(a, x, lo, hi) {
                if (lo == null) lo = 0;
                if (hi == null) hi = a.length;
                while(lo < hi){
                    var mid = lo + hi >>> 1;
                    if (compare(a[mid], x) < 0) lo = mid + 1;
                    else hi = mid;
                }
                return lo;
            },
            right: function(a, x, lo, hi) {
                if (lo == null) lo = 0;
                if (hi == null) hi = a.length;
                while(lo < hi){
                    var mid = lo + hi >>> 1;
                    if (compare(a[mid], x) > 0) hi = mid;
                    else lo = mid + 1;
                }
                return lo;
            }
        };
    });
var _ascending = require("./ascending");
var _ascendingDefault = parcelHelpers.interopDefault(_ascending);
function ascendingComparator(f) {
    return function(d, x) {
        return (0, _ascendingDefault.default)(f(d), x);
    };
}

},{"./ascending":"iP4KQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lIeWP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values0, values1, reduce) {
        var n0 = values0.length, n1 = values1.length, values = new Array(n0 * n1), i0, i1, i, value0;
        if (reduce == null) reduce = (0, _pairs.pair);
        for(i0 = i = 0; i0 < n0; ++i0)for(value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i)values[i] = reduce(value0, values1[i1]);
        return values;
    });
var _pairs = require("./pairs");

},{"./pairs":"ldT3i","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ldT3i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(array, f) {
        if (f == null) f = pair;
        var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
        while(i < n)pairs[i] = f(p, p = array[++i]);
        return pairs;
    });
parcelHelpers.export(exports, "pair", ()=>pair);
function pair(a, b) {
    return [
        a,
        b
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jH6HB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bNbWo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(array, f) {
        var v = (0, _varianceDefault.default)(array, f);
        return v ? Math.sqrt(v) : v;
    });
var _variance = require("./variance");
var _varianceDefault = parcelHelpers.interopDefault(_variance);

},{"./variance":"99UkP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"99UkP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values, valueof) {
        var n = values.length, m = 0, i = -1, mean = 0, value, delta, sum = 0;
        if (valueof == null) {
            while(++i < n)if (!isNaN(value = (0, _numberDefault.default)(values[i]))) {
                delta = value - mean;
                mean += delta / ++m;
                sum += delta * (value - mean);
            }
        } else {
            while(++i < n)if (!isNaN(value = (0, _numberDefault.default)(valueof(values[i], i, values)))) {
                delta = value - mean;
                mean += delta / ++m;
                sum += delta * (value - mean);
            }
        }
        if (m > 1) return sum / (m - 1);
    });
var _number = require("./number");
var _numberDefault = parcelHelpers.interopDefault(_number);

},{"./number":"gAMqv","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gAMqv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x === null ? NaN : +x;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d08xM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values, valueof) {
        var n = values.length, i = -1, value, min, max;
        if (valueof == null) {
            while(++i < n)if ((value = values[i]) != null && value >= value) {
                min = max = value;
                while(++i < n)if ((value = values[i]) != null) {
                    if (min > value) min = value;
                    if (max < value) max = value;
                }
            }
        } else {
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
                min = max = value;
                while(++i < n)if ((value = valueof(values[i], i, values)) != null) {
                    if (min > value) min = value;
                    if (max < value) max = value;
                }
            }
        }
        return [
            min,
            max
        ];
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4ajnQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var value = (0, _identityDefault.default), domain = (0, _extentDefault.default), threshold = (0, _sturgesDefault.default);
        function histogram(data) {
            var i, n = data.length, x, values = new Array(n);
            for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
            var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
            // Convert number of thresholds into uniform thresholds.
            if (!Array.isArray(tz)) {
                tz = (0, _ticks.tickStep)(x0, x1, tz);
                tz = (0, _rangeDefault.default)(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
            }
            // Remove any thresholds outside the domain.
            var m = tz.length;
            while(tz[0] <= x0)tz.shift(), --m;
            while(tz[m - 1] > x1)tz.pop(), --m;
            var bins = new Array(m + 1), bin;
            // Initialize bins.
            for(i = 0; i <= m; ++i){
                bin = bins[i] = [];
                bin.x0 = i > 0 ? tz[i - 1] : x0;
                bin.x1 = i < m ? tz[i] : x1;
            }
            // Assign data to bins by value, ignoring any outside the domain.
            for(i = 0; i < n; ++i){
                x = values[i];
                if (x0 <= x && x <= x1) bins[(0, _bisectDefault.default)(tz, x, 0, m)].push(data[i]);
            }
            return bins;
        }
        histogram.value = function(_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constantDefault.default)(_), histogram) : value;
        };
        histogram.domain = function(_) {
            return arguments.length ? (domain = typeof _ === "function" ? _ : (0, _constantDefault.default)([
                _[0],
                _[1]
            ]), histogram) : domain;
        };
        histogram.thresholds = function(_) {
            return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, _constantDefault.default)((0, _array.slice).call(_)) : (0, _constantDefault.default)(_), histogram) : threshold;
        };
        return histogram;
    });
var _array = require("./array");
var _bisect = require("./bisect");
var _bisectDefault = parcelHelpers.interopDefault(_bisect);
var _constant = require("./constant");
var _constantDefault = parcelHelpers.interopDefault(_constant);
var _extent = require("./extent");
var _extentDefault = parcelHelpers.interopDefault(_extent);
var _identity = require("./identity");
var _identityDefault = parcelHelpers.interopDefault(_identity);
var _range = require("./range");
var _rangeDefault = parcelHelpers.interopDefault(_range);
var _ticks = require("./ticks");
var _sturges = require("./threshold/sturges");
var _sturgesDefault = parcelHelpers.interopDefault(_sturges);

},{"./array":"kor7H","./bisect":"lDeAY","./constant":"aGmsU","./extent":"d08xM","./identity":"jDjDK","./range":"9KezC","./ticks":"h8PmC","./threshold/sturges":"lGOLN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kor7H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", ()=>slice);
parcelHelpers.export(exports, "map", ()=>map);
var array = Array.prototype;
var slice = array.slice;
var map = array.map;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aGmsU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jDjDK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9KezC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(start, stop, step) {
        start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
        var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
        while(++i < n)range[i] = start + i * step;
        return range;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h8PmC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(start, stop, count) {
        var reverse, i = -1, n, ticks, step;
        stop = +stop, start = +start, count = +count;
        if (start === stop && count > 0) return [
            start
        ];
        if (reverse = stop < start) n = start, start = stop, stop = n;
        if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
        if (step > 0) {
            start = Math.ceil(start / step);
            stop = Math.floor(stop / step);
            ticks = new Array(n = Math.ceil(stop - start + 1));
            while(++i < n)ticks[i] = (start + i) * step;
        } else {
            start = Math.floor(start * step);
            stop = Math.ceil(stop * step);
            ticks = new Array(n = Math.ceil(start - stop + 1));
            while(++i < n)ticks[i] = (start - i) / step;
        }
        if (reverse) ticks.reverse();
        return ticks;
    });
parcelHelpers.export(exports, "tickIncrement", ()=>tickIncrement);
parcelHelpers.export(exports, "tickStep", ()=>tickStep);
var e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
function tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}
function tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= e10) step1 *= 10;
    else if (error >= e5) step1 *= 5;
    else if (error >= e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lGOLN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values) {
        return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dw43i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values, min, max) {
        values = (0, _array.map).call(values, (0, _numberDefault.default)).sort((0, _ascendingDefault.default));
        return Math.ceil((max - min) / (2 * ((0, _quantileDefault.default)(values, 0.75) - (0, _quantileDefault.default)(values, 0.25)) * Math.pow(values.length, -1 / 3)));
    });
var _array = require("../array");
var _ascending = require("../ascending");
var _ascendingDefault = parcelHelpers.interopDefault(_ascending);
var _number = require("../number");
var _numberDefault = parcelHelpers.interopDefault(_number);
var _quantile = require("../quantile");
var _quantileDefault = parcelHelpers.interopDefault(_quantile);

},{"../array":"kor7H","../ascending":"iP4KQ","../number":"gAMqv","../quantile":"3VgWE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3VgWE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values, p, valueof) {
        if (valueof == null) valueof = (0, _numberDefault.default);
        if (!(n = values.length)) return;
        if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
        if (p >= 1) return +valueof(values[n - 1], n - 1, values);
        var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
        return value0 + (value1 - value0) * (i - i0);
    });
var _number = require("./number");
var _numberDefault = parcelHelpers.interopDefault(_number);

},{"./number":"gAMqv","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9S0rK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values, min, max) {
        return Math.ceil((max - min) / (3.5 * (0, _deviationDefault.default)(values) * Math.pow(values.length, -1 / 3)));
    });
var _deviation = require("../deviation");
var _deviationDefault = parcelHelpers.interopDefault(_deviation);

},{"../deviation":"bNbWo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1bAQJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values, valueof) {
        var n = values.length, i = -1, value, max;
        if (valueof == null) {
            while(++i < n)if ((value = values[i]) != null && value >= value) {
                max = value;
                while(++i < n)if ((value = values[i]) != null && value > max) max = value;
            }
        } else {
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
                max = value;
                while(++i < n)if ((value = valueof(values[i], i, values)) != null && value > max) max = value;
            }
        }
        return max;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iQade":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values, valueof) {
        var n = values.length, m = n, i = -1, value, sum = 0;
        if (valueof == null) {
            while(++i < n)if (!isNaN(value = (0, _numberDefault.default)(values[i]))) sum += value;
            else --m;
        } else {
            while(++i < n)if (!isNaN(value = (0, _numberDefault.default)(valueof(values[i], i, values)))) sum += value;
            else --m;
        }
        if (m) return sum / m;
    });
var _number = require("./number");
var _numberDefault = parcelHelpers.interopDefault(_number);

},{"./number":"gAMqv","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dvvjV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values, valueof) {
        var n = values.length, i = -1, value, numbers = [];
        if (valueof == null) {
            while(++i < n)if (!isNaN(value = (0, _numberDefault.default)(values[i]))) numbers.push(value);
        } else {
            while(++i < n)if (!isNaN(value = (0, _numberDefault.default)(valueof(values[i], i, values)))) numbers.push(value);
        }
        return (0, _quantileDefault.default)(numbers.sort((0, _ascendingDefault.default)), 0.5);
    });
var _ascending = require("./ascending");
var _ascendingDefault = parcelHelpers.interopDefault(_ascending);
var _number = require("./number");
var _numberDefault = parcelHelpers.interopDefault(_number);
var _quantile = require("./quantile");
var _quantileDefault = parcelHelpers.interopDefault(_quantile);

},{"./ascending":"iP4KQ","./number":"gAMqv","./quantile":"3VgWE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lGYAT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(arrays) {
        var n = arrays.length, m, i = -1, j = 0, merged, array;
        while(++i < n)j += arrays[i].length;
        merged = new Array(j);
        while(--n >= 0){
            array = arrays[n];
            m = array.length;
            while(--m >= 0)merged[--j] = array[m];
        }
        return merged;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ae85G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values, valueof) {
        var n = values.length, i = -1, value, min;
        if (valueof == null) {
            while(++i < n)if ((value = values[i]) != null && value >= value) {
                min = value;
                while(++i < n)if ((value = values[i]) != null && min > value) min = value;
            }
        } else {
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
                min = value;
                while(++i < n)if ((value = valueof(values[i], i, values)) != null && min > value) min = value;
            }
        }
        return min;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bsNRU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(array, indexes) {
        var i = indexes.length, permutes = new Array(i);
        while(i--)permutes[i] = array[indexes[i]];
        return permutes;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cLF1p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values, compare) {
        if (!(n = values.length)) return;
        var n, i = 0, j = 0, xi, xj = values[j];
        if (compare == null) compare = (0, _ascendingDefault.default);
        while(++i < n)if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) xj = xi, j = i;
        if (compare(xj, xj) === 0) return j;
    });
var _ascending = require("./ascending");
var _ascendingDefault = parcelHelpers.interopDefault(_ascending);

},{"./ascending":"iP4KQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kzPaq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(array, i0, i1) {
        var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0), t, i;
        while(m){
            i = Math.random() * m-- | 0;
            t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8jQRH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values, valueof) {
        var n = values.length, i = -1, value, sum = 0;
        if (valueof == null) {
            while(++i < n)if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
        } else {
            while(++i < n)if (value = +valueof(values[i], i, values)) sum += value;
        }
        return sum;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"libcT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(matrix) {
        if (!(n = matrix.length)) return [];
        for(var i = -1, m = (0, _minDefault.default)(matrix, length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
        return transpose;
    });
var _min = require("./min");
var _minDefault = parcelHelpers.interopDefault(_min);
function length(d) {
    return d.length;
}

},{"./min":"ae85G","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jgLP9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _transposeDefault.default)(arguments);
    });
var _transpose = require("./transpose");
var _transposeDefault = parcelHelpers.interopDefault(_transpose);

},{"./transpose":"libcT","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5SJUY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "implicit", ()=>implicit);
parcelHelpers.export(exports, "default", ()=>ordinal);
var _d3Collection = require("d3-collection");
var _array = require("./array");
var implicit = {
    name: "implicit"
};
function ordinal(range) {
    var index = (0, _d3Collection.map)(), domain = [], unknown = implicit;
    range = range == null ? [] : (0, _array.slice).call(range);
    function scale(d) {
        var key = d + "", i = index.get(key);
        if (!i) {
            if (unknown !== implicit) return unknown;
            index.set(key, i = domain.push(d));
        }
        return range[(i - 1) % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = (0, _d3Collection.map)();
        var i = -1, n = _.length, d, key;
        while(++i < n)if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, _array.slice).call(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return ordinal().domain(domain).range(range).unknown(unknown);
    };
    return scale;
}

},{"d3-collection":"625YO","./array":"aKlJq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"625YO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nest", ()=>(0, _nestDefault.default));
parcelHelpers.export(exports, "set", ()=>(0, _setDefault.default));
parcelHelpers.export(exports, "map", ()=>(0, _mapDefault.default));
parcelHelpers.export(exports, "keys", ()=>(0, _keysDefault.default));
parcelHelpers.export(exports, "values", ()=>(0, _valuesDefault.default));
parcelHelpers.export(exports, "entries", ()=>(0, _entriesDefault.default));
var _nest = require("./nest");
var _nestDefault = parcelHelpers.interopDefault(_nest);
var _set = require("./set");
var _setDefault = parcelHelpers.interopDefault(_set);
var _map = require("./map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _keys = require("./keys");
var _keysDefault = parcelHelpers.interopDefault(_keys);
var _values = require("./values");
var _valuesDefault = parcelHelpers.interopDefault(_values);
var _entries = require("./entries");
var _entriesDefault = parcelHelpers.interopDefault(_entries);

},{"./nest":"7wsYy","./set":"6SS4y","./map":"klZXp","./keys":"k3JWe","./values":"j21ib","./entries":"2UEgc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7wsYy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var keys = [], sortKeys = [], sortValues, rollup, nest;
        function apply(array, depth, createResult, setResult) {
            if (depth >= keys.length) {
                if (sortValues != null) array.sort(sortValues);
                return rollup != null ? rollup(array) : array;
            }
            var i = -1, n = array.length, key = keys[depth++], keyValue, value, valuesByKey = (0, _mapDefault.default)(), values, result = createResult();
            while(++i < n)if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) values.push(value);
            else valuesByKey.set(keyValue, [
                value
            ]);
            valuesByKey.each(function(values, key) {
                setResult(result, key, apply(values, depth, createResult, setResult));
            });
            return result;
        }
        function entries(map, depth) {
            if (++depth > keys.length) return map;
            var array, sortKey = sortKeys[depth - 1];
            if (rollup != null && depth >= keys.length) array = map.entries();
            else array = [], map.each(function(v, k) {
                array.push({
                    key: k,
                    values: entries(v, depth)
                });
            });
            return sortKey != null ? array.sort(function(a, b) {
                return sortKey(a.key, b.key);
            }) : array;
        }
        return nest = {
            object: function(array) {
                return apply(array, 0, createObject, setObject);
            },
            map: function(array) {
                return apply(array, 0, createMap, setMap);
            },
            entries: function(array) {
                return entries(apply(array, 0, createMap, setMap), 0);
            },
            key: function(d) {
                keys.push(d);
                return nest;
            },
            sortKeys: function(order) {
                sortKeys[keys.length - 1] = order;
                return nest;
            },
            sortValues: function(order) {
                sortValues = order;
                return nest;
            },
            rollup: function(f) {
                rollup = f;
                return nest;
            }
        };
    });
var _map = require("./map");
var _mapDefault = parcelHelpers.interopDefault(_map);
function createObject() {
    return {};
}
function setObject(object, key, value) {
    object[key] = value;
}
function createMap() {
    return (0, _mapDefault.default)();
}
function setMap(map, key, value) {
    map.set(key, value);
}

},{"./map":"klZXp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"klZXp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prefix", ()=>prefix);
var prefix = "$";
function Map() {}
Map.prototype = map.prototype = {
    constructor: Map,
    has: function(key) {
        return prefix + key in this;
    },
    get: function(key) {
        return this[prefix + key];
    },
    set: function(key, value) {
        this[prefix + key] = value;
        return this;
    },
    remove: function(key) {
        var property = prefix + key;
        return property in this && delete this[property];
    },
    clear: function() {
        for(var property in this)if (property[0] === prefix) delete this[property];
    },
    keys: function() {
        var keys = [];
        for(var property in this)if (property[0] === prefix) keys.push(property.slice(1));
        return keys;
    },
    values: function() {
        var values = [];
        for(var property in this)if (property[0] === prefix) values.push(this[property]);
        return values;
    },
    entries: function() {
        var entries = [];
        for(var property in this)if (property[0] === prefix) entries.push({
            key: property.slice(1),
            value: this[property]
        });
        return entries;
    },
    size: function() {
        var size = 0;
        for(var property in this)if (property[0] === prefix) ++size;
        return size;
    },
    empty: function() {
        for(var property in this)if (property[0] === prefix) return false;
        return true;
    },
    each: function(f) {
        for(var property in this)if (property[0] === prefix) f(this[property], property.slice(1), this);
    }
};
function map(object, f) {
    var map = new Map;
    // Copy constructor.
    if (object instanceof Map) object.each(function(value, key) {
        map.set(key, value);
    });
    else if (Array.isArray(object)) {
        var i = -1, n = object.length, o;
        if (f == null) while(++i < n)map.set(i, object[i]);
        else while(++i < n)map.set(f(o = object[i], i, object), o);
    } else if (object) for(var key in object)map.set(key, object[key]);
    return map;
}
exports.default = map;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6SS4y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _map = require("./map");
var _mapDefault = parcelHelpers.interopDefault(_map);
function Set() {}
var proto = (0, _mapDefault.default).prototype;
Set.prototype = set.prototype = {
    constructor: Set,
    has: proto.has,
    add: function(value) {
        value += "";
        this[(0, _map.prefix) + value] = value;
        return this;
    },
    remove: proto.remove,
    clear: proto.clear,
    values: proto.keys,
    size: proto.size,
    empty: proto.empty,
    each: proto.each
};
function set(object, f) {
    var set = new Set;
    // Copy constructor.
    if (object instanceof Set) object.each(function(value) {
        set.add(value);
    });
    else if (object) {
        var i = -1, n = object.length;
        if (f == null) while(++i < n)set.add(object[i]);
        else while(++i < n)set.add(f(object[i], i, object));
    }
    return set;
}
exports.default = set;

},{"./map":"klZXp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k3JWe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(map) {
        var keys = [];
        for(var key in map)keys.push(key);
        return keys;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j21ib":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(map) {
        var values = [];
        for(var key in map)values.push(map[key]);
        return values;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2UEgc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(map) {
        var entries = [];
        for(var key in map)entries.push({
            key: key,
            value: map[key]
        });
        return entries;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aKlJq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "map", ()=>map);
parcelHelpers.export(exports, "slice", ()=>slice);
var array = Array.prototype;
var map = array.map;
var slice = array.slice;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4y6ob":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>identity);
var _array = require("./array");
var _linear = require("./linear");
var _number = require("./number");
var _numberDefault = parcelHelpers.interopDefault(_number);
function identity() {
    var domain = [
        0,
        1
    ];
    function scale(x) {
        return +x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = (0, _array.map).call(_, (0, _numberDefault.default)), scale) : domain.slice();
    };
    scale.copy = function() {
        return identity().domain(domain);
    };
    return (0, _linear.linearish)(scale);
}

},{"./array":"aKlJq","./linear":"drdK3","./number":"h7A9x","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"drdK3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "linearish", ()=>linearish);
parcelHelpers.export(exports, "default", ()=>linear);
var _d3Array = require("d3-array");
var _d3Interpolate = require("d3-interpolate");
var _continuous = require("./continuous");
var _continuousDefault = parcelHelpers.interopDefault(_continuous);
var _tickFormat = require("./tickFormat");
var _tickFormatDefault = parcelHelpers.interopDefault(_tickFormat);
function linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, _d3Array.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        return (0, _tickFormatDefault.default)(domain(), count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain(), i0 = 0, i1 = d.length - 1, start = d[i0], stop = d[i1], step;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        step = (0, _d3Array.tickIncrement)(start, stop, count);
        if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
            step = (0, _d3Array.tickIncrement)(start, stop, count);
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
            step = (0, _d3Array.tickIncrement)(start, stop, count);
        }
        if (step > 0) {
            d[i0] = Math.floor(start / step) * step;
            d[i1] = Math.ceil(stop / step) * step;
            domain(d);
        } else if (step < 0) {
            d[i0] = Math.ceil(start * step) / step;
            d[i1] = Math.floor(stop * step) / step;
            domain(d);
        }
        return scale;
    };
    return scale;
}
function linear() {
    var scale = (0, _continuousDefault.default)((0, _continuous.deinterpolateLinear), (0, _d3Interpolate.interpolateNumber));
    scale.copy = function() {
        return (0, _continuous.copy)(scale, linear());
    };
    return linearish(scale);
}

},{"d3-array":"5DW5h","d3-interpolate":[["interpolateNumber","5p4je","default"]],"./continuous":"6tLkG","./tickFormat":"3sw4B","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5p4je":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a = +a, b = +b, function(t) {
            return a * (1 - t) + b * t;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6tLkG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deinterpolateLinear", ()=>deinterpolateLinear);
parcelHelpers.export(exports, "copy", ()=>copy);
parcelHelpers.export(exports, "default", ()=>continuous);
var _d3Array = require("d3-array");
var _d3Interpolate = require("d3-interpolate");
var _array = require("./array");
var _constant = require("./constant");
var _constantDefault = parcelHelpers.interopDefault(_constant);
var _number = require("./number");
var _numberDefault = parcelHelpers.interopDefault(_number);
var unit = [
    0,
    1
];
function deinterpolateLinear(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, _constantDefault.default)(b);
}
function deinterpolateClamp(deinterpolate) {
    return function(a, b) {
        var d = deinterpolate(a = +a, b = +b);
        return function(x) {
            return x <= a ? 0 : x >= b ? 1 : d(x);
        };
    };
}
function reinterpolateClamp(reinterpolate) {
    return function(a, b) {
        var r = reinterpolate(a = +a, b = +b);
        return function(t) {
            return t <= 0 ? a : t >= 1 ? b : r(t);
        };
    };
}
function bimap(domain, range, deinterpolate, reinterpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
    else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function polymap(domain, range, deinterpolate, reinterpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = deinterpolate(domain[i], domain[i + 1]);
        r[i] = reinterpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, _d3Array.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp());
}
function continuous(deinterpolate, reinterpolate) {
    var domain = unit, range = unit, interpolate = (0, _d3Interpolate.interpolate), clamp = false, piecewise, output, input;
    function rescale() {
        piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
    }
    scale.invert = function(y) {
        return (input || (input = piecewise(range, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = (0, _array.map).call(_, (0, _numberDefault.default)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, _array.slice).call(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = (0, _array.slice).call(_), interpolate = (0, _d3Interpolate.interpolateRound), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, rescale()) : clamp;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    return rescale();
}

},{"d3-array":"5DW5h","d3-interpolate":[["interpolate","cgT5h","default"],["interpolateRound","8LFms","default"]],"./array":"aKlJq","./constant":"8AYoV","./number":"h7A9x","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cgT5h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var t = typeof b, c;
        return b == null || t === "boolean" ? (0, _constantJsDefault.default)(b) : (t === "number" ? (0, _numberJsDefault.default) : t === "string" ? (c = (0, _d3Color.color)(b)) ? (b = c, _rgbJsDefault.default) : (0, _stringJsDefault.default) : b instanceof (0, _d3Color.color) ? (0, _rgbJsDefault.default) : b instanceof Date ? (0, _dateJsDefault.default) : (0, _numberArrayJs.isNumberArray)(b) ? (0, _numberArrayJsDefault.default) : Array.isArray(b) ? (0, _arrayJs.genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, _objectJsDefault.default) : (0, _numberJsDefault.default))(a, b);
    });
var _d3Color = require("d3-color");
var _rgbJs = require("./rgb.js");
var _rgbJsDefault = parcelHelpers.interopDefault(_rgbJs);
var _arrayJs = require("./array.js");
var _dateJs = require("./date.js");
var _dateJsDefault = parcelHelpers.interopDefault(_dateJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _objectJs = require("./object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);

},{"d3-color":[["color","6xHcs","default"]],"./rgb.js":"123Ym","./array.js":"jrO0o","./date.js":"3xTRS","./number.js":"5p4je","./object.js":"bXKxl","./string.js":"jLafa","./constant.js":"1nKc7","./numberArray.js":"hlETc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6xHcs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Color", ()=>Color);
parcelHelpers.export(exports, "darker", ()=>darker);
parcelHelpers.export(exports, "brighter", ()=>brighter);
parcelHelpers.export(exports, "default", ()=>color);
parcelHelpers.export(exports, "rgbConvert", ()=>rgbConvert);
parcelHelpers.export(exports, "rgb", ()=>rgb);
parcelHelpers.export(exports, "Rgb", ()=>Rgb);
parcelHelpers.export(exports, "hslConvert", ()=>hslConvert);
parcelHelpers.export(exports, "hsl", ()=>hsl);
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _defineJsDefault.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Rgb, rgb, (0, _defineJs.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Hsl, hsl, (0, _defineJs.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

},{"./define.js":"bmE5F","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bmE5F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(constructor, factory, prototype) {
        constructor.prototype = factory.prototype = prototype;
        prototype.constructor = constructor;
    });
parcelHelpers.export(exports, "extend", ()=>extend);
function extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"123Ym":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rgbBasis", ()=>rgbBasis);
parcelHelpers.export(exports, "rgbBasisClosed", ()=>rgbBasisClosed);
var _d3Color = require("d3-color");
var _basisJs = require("./basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _basisClosedJs = require("./basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
exports.default = function rgbGamma(y) {
    var color = (0, _colorJs.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, _d3Color.rgb)(start)).r, (end = (0, _d3Color.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, _d3Color.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var rgbBasis = rgbSpline((0, _basisJsDefault.default));
var rgbBasisClosed = rgbSpline((0, _basisClosedJsDefault.default));

},{"d3-color":"6xHcs","./basis.js":"kQwDn","./basisClosed.js":"If5Oj","./color.js":"6SyOh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kQwDn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "basis", ()=>basis);
parcelHelpers.export(exports, "default", ()=>function(values) {
        var n = values.length - 1;
        return function(t) {
            var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
            return basis((t - i / n) * n, v0, v1, v2, v3);
        };
    });
function basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"If5Oj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values) {
        var n = values.length;
        return function(t) {
            var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
            return (0, _basisJs.basis)((t - i / n) * n, v0, v1, v2, v3);
        };
    });
var _basisJs = require("./basis.js");

},{"./basis.js":"kQwDn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6SyOh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hue", ()=>hue);
parcelHelpers.export(exports, "gamma", ()=>gamma);
parcelHelpers.export(exports, "default", ()=>nogamma);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
function linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function hue(a, b) {
    var d = b - a;
    return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}
function gamma(y) {
    return (y = +y) === 1 ? nogamma : function(a, b) {
        return b - a ? exponential(a, b, y) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
    };
}
function nogamma(a, b) {
    var d = b - a;
    return d ? linear(a, d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}

},{"./constant.js":"1nKc7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1nKc7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jrO0o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return ((0, _numberArrayJs.isNumberArray)(b) ? (0, _numberArrayJsDefault.default) : genericArray)(a, b);
    });
parcelHelpers.export(exports, "genericArray", ()=>genericArray);
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);
function genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, _valueJsDefault.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

},{"./value.js":"cgT5h","./numberArray.js":"hlETc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hlETc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        if (!b) b = [];
        var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
        return function(t) {
            for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
            return c;
        };
    });
parcelHelpers.export(exports, "isNumberArray", ()=>isNumberArray);
function isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3xTRS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var d = new Date;
        return a = +a, b = +b, function(t) {
            return d.setTime(a * (1 - t) + b * t), d;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bXKxl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var i = {}, c = {}, k;
        if (a === null || typeof a !== "object") a = {};
        if (b === null || typeof b !== "object") b = {};
        for(k in b)if (k in a) i[k] = (0, _valueJsDefault.default)(a[k], b[k]);
        else c[k] = b[k];
        return function(t) {
            for(k in i)c[k] = i[k](t);
            return c;
        };
    });
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);

},{"./value.js":"cgT5h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jLafa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
        // Coerce inputs to strings.
        a = a + "", b = b + "";
        // Interpolate pairs of numbers in a & b.
        while((am = reA.exec(a)) && (bm = reB.exec(b))){
            if ((bs = bm.index) > bi) {
                bs = b.slice(bi, bs);
                if (s[i]) s[i] += bs; // coalesce with previous string
                else s[++i] = bs;
            }
            if ((am = am[0]) === (bm = bm[0])) {
                if (s[i]) s[i] += bm; // coalesce with previous string
                else s[++i] = bm;
            } else {
                s[++i] = null;
                q.push({
                    i: i,
                    x: (0, _numberJsDefault.default)(am, bm)
                });
            }
            bi = reB.lastIndex;
        }
        // Add remains of b.
        if (bi < b.length) {
            bs = b.slice(bi);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        // Special optimization for only a single match.
        // Otherwise, interpolate each of the numbers and rejoin the string.
        return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function(t) {
            for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        });
    });
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(b) {
    return function() {
        return b;
    };
}
function one(b) {
    return function(t) {
        return b(t) + "";
    };
}

},{"./number.js":"5p4je","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8LFms":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a = +a, b = +b, function(t) {
            return Math.round(a * (1 - t) + b * t);
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8AYoV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h7A9x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return +x;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3sw4B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(domain, count, specifier) {
        var start = domain[0], stop = domain[domain.length - 1], step = (0, _d3Array.tickStep)(start, stop, count == null ? 10 : count), precision;
        specifier = (0, _d3Format.formatSpecifier)(specifier == null ? ",f" : specifier);
        switch(specifier.type){
            case "s":
                var value = Math.max(Math.abs(start), Math.abs(stop));
                if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionPrefix)(step, value))) specifier.precision = precision;
                return (0, _d3Format.formatPrefix)(specifier, value);
            case "":
            case "e":
            case "g":
            case "p":
            case "r":
                if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
                break;
            case "f":
            case "%":
                if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
                break;
        }
        return (0, _d3Format.format)(specifier);
    });
var _d3Array = require("d3-array");
var _d3Format = require("d3-format");

},{"d3-array":"5DW5h","d3-format":[["format","fVakl"],["formatPrefix","fVakl"],["formatSpecifier","jaJGY","default"],["precisionFixed","62WHz","default"],["precisionPrefix","kblYP","default"],["precisionRound","1DIZw","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fVakl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "format", ()=>format);
parcelHelpers.export(exports, "formatPrefix", ()=>formatPrefix);
parcelHelpers.export(exports, "default", ()=>defaultLocale);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var locale;
var format;
var formatPrefix;
defaultLocale({
    decimal: ".",
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ],
    minus: "-"
});
function defaultLocale(definition) {
    locale = (0, _localeJsDefault.default)(definition);
    format = locale.format;
    formatPrefix = locale.formatPrefix;
    return locale;
}

},{"./locale.js":"64gSc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"64gSc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(locale) {
        var group = locale.grouping === undefined || locale.thousands === undefined ? (0, _identityJsDefault.default) : (0, _formatGroupJsDefault.default)(map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, _identityJsDefault.default) : (0, _formatNumeralsJsDefault.default)(map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "-" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
        function newFormat(specifier) {
            specifier = (0, _formatSpecifierJsDefault.default)(specifier);
            var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
            // The "n" type is an alias for ",g".
            if (type === "n") comma = true, type = "g";
            else if (!(0, _formatTypesJsDefault.default)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
            // If zero fill is specified, padding goes after sign and before digits.
            if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
            // Compute the prefix and suffix.
            // For SI-prefix, the suffix is lazily computed.
            var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
            // What format function should we use?
            // Is this an integer type?
            // Can this type generate exponential notation?
            var formatType = (0, _formatTypesJsDefault.default)[type], maybeSuffix = /[defgprs%]/.test(type);
            // Set the default precision if not specified,
            // or clamp the specified precision to the supported range.
            // For significant precision, it must be in [1, 21].
            // For fixed precision, it must be in [0, 20].
            precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
            function format(value) {
                var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
                if (type === "c") {
                    valueSuffix = formatType(value) + valueSuffix;
                    value = "";
                } else {
                    value = +value;
                    // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                    var valueNegative = value < 0 || 1 / value < 0;
                    // Perform the initial formatting.
                    value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                    // Trim insignificant zeros.
                    if (trim) value = (0, _formatTrimJsDefault.default)(value);
                    // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                    if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                    // Compute the prefix and suffix.
                    valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                    valueSuffix = (type === "s" ? prefixes[8 + (0, _formatPrefixAutoJs.prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                    // Break the formatted value into the integer “value” part that can be
                    // grouped, and fractional or exponential “suffix” part that is not.
                    if (maybeSuffix) {
                        i = -1, n = value.length;
                        while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                            valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                            value = value.slice(0, i);
                            break;
                        }
                    }
                }
                // If the fill character is not "0", grouping is applied before padding.
                if (comma && !zero) value = group(value, Infinity);
                // Compute the padding.
                var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
                // If the fill character is "0", grouping is applied after padding.
                if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
                // Reconstruct the final output based on the desired alignment.
                switch(align){
                    case "<":
                        value = valuePrefix + value + valueSuffix + padding;
                        break;
                    case "=":
                        value = valuePrefix + padding + value + valueSuffix;
                        break;
                    case "^":
                        value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                        break;
                    default:
                        value = padding + valuePrefix + value + valueSuffix;
                        break;
                }
                return numerals(value);
            }
            format.toString = function() {
                return specifier + "";
            };
            return format;
        }
        function formatPrefix(specifier, value) {
            var f = newFormat((specifier = (0, _formatSpecifierJsDefault.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, _exponentJsDefault.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = prefixes[8 + e / 3];
            return function(value) {
                return f(k * value) + prefix;
            };
        }
        return {
            format: newFormat,
            formatPrefix: formatPrefix
        };
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);
var _formatGroupJs = require("./formatGroup.js");
var _formatGroupJsDefault = parcelHelpers.interopDefault(_formatGroupJs);
var _formatNumeralsJs = require("./formatNumerals.js");
var _formatNumeralsJsDefault = parcelHelpers.interopDefault(_formatNumeralsJs);
var _formatSpecifierJs = require("./formatSpecifier.js");
var _formatSpecifierJsDefault = parcelHelpers.interopDefault(_formatSpecifierJs);
var _formatTrimJs = require("./formatTrim.js");
var _formatTrimJsDefault = parcelHelpers.interopDefault(_formatTrimJs);
var _formatTypesJs = require("./formatTypes.js");
var _formatTypesJsDefault = parcelHelpers.interopDefault(_formatTypesJs);
var _formatPrefixAutoJs = require("./formatPrefixAuto.js");
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var map = Array.prototype.map, prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];

},{"./exponent.js":"lHCgt","./formatGroup.js":"91f9E","./formatNumerals.js":"051BP","./formatSpecifier.js":"jaJGY","./formatTrim.js":"aBbiR","./formatTypes.js":"huiAC","./formatPrefixAuto.js":"58BPK","./identity.js":"3OXZP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lHCgt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x = (0, _formatDecimalJs.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
    });
var _formatDecimalJs = require("./formatDecimal.js");

},{"./formatDecimal.js":"9ezZc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9ezZc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
    });
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
parcelHelpers.export(exports, "formatDecimalParts", ()=>formatDecimalParts);
function formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"91f9E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(grouping, thousands) {
        return function(value, width) {
            var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
            while(i > 0 && g > 0){
                if (length + g + 1 > width) g = Math.max(1, width - length);
                t.push(value.substring(i -= g, i + g));
                if ((length += g + 1) > width) break;
                g = grouping[j = (j + 1) % grouping.length];
            }
            return t.reverse().join(thousands);
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"051BP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(numerals) {
        return function(value) {
            return value.replace(/[0-9]/g, function(i) {
                return numerals[+i];
            });
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jaJGY":[function(require,module,exports,__globalThis) {
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatSpecifier);
parcelHelpers.export(exports, "FormatSpecifier", ()=>FormatSpecifier);
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
    if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
function FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aBbiR":[function(require,module,exports,__globalThis) {
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(s) {
        out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
            case ".":
                i0 = i1 = i;
                break;
            case "0":
                if (i0 === 0) i0 = i;
                i1 = i;
                break;
            default:
                if (!+s[i]) break out;
                if (i0 > 0) i0 = 0;
                break;
        }
        return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"huiAC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formatDecimalJs = require("./formatDecimal.js");
var _formatDecimalJsDefault = parcelHelpers.interopDefault(_formatDecimalJs);
var _formatPrefixAutoJs = require("./formatPrefixAuto.js");
var _formatPrefixAutoJsDefault = parcelHelpers.interopDefault(_formatPrefixAutoJs);
var _formatRoundedJs = require("./formatRounded.js");
var _formatRoundedJsDefault = parcelHelpers.interopDefault(_formatRoundedJs);
exports.default = {
    "%": function(x, p) {
        return (x * 100).toFixed(p);
    },
    "b": function(x) {
        return Math.round(x).toString(2);
    },
    "c": function(x) {
        return x + "";
    },
    "d": (0, _formatDecimalJsDefault.default),
    "e": function(x, p) {
        return x.toExponential(p);
    },
    "f": function(x, p) {
        return x.toFixed(p);
    },
    "g": function(x, p) {
        return x.toPrecision(p);
    },
    "o": function(x) {
        return Math.round(x).toString(8);
    },
    "p": function(x, p) {
        return (0, _formatRoundedJsDefault.default)(x * 100, p);
    },
    "r": (0, _formatRoundedJsDefault.default),
    "s": (0, _formatPrefixAutoJsDefault.default),
    "X": function(x) {
        return Math.round(x).toString(16).toUpperCase();
    },
    "x": function(x) {
        return Math.round(x).toString(16);
    }
};

},{"./formatDecimal.js":"9ezZc","./formatPrefixAuto.js":"58BPK","./formatRounded.js":"61XQO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"58BPK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prefixExponent", ()=>prefixExponent);
parcelHelpers.export(exports, "default", ()=>function(x, p) {
        var d = (0, _formatDecimalJs.formatDecimalParts)(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1], i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
        return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, _formatDecimalJs.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
    });
var _formatDecimalJs = require("./formatDecimal.js");
var prefixExponent;

},{"./formatDecimal.js":"9ezZc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"61XQO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, p) {
        var d = (0, _formatDecimalJs.formatDecimalParts)(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1];
        return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
    });
var _formatDecimalJs = require("./formatDecimal.js");

},{"./formatDecimal.js":"9ezZc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3OXZP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"62WHz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(step) {
        return Math.max(0, -(0, _exponentJsDefault.default)(Math.abs(step)));
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"lHCgt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kblYP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(step, value) {
        return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, _exponentJsDefault.default)(value) / 3))) * 3 - (0, _exponentJsDefault.default)(Math.abs(step)));
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"lHCgt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1DIZw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(step, max) {
        step = Math.abs(step), max = Math.abs(max) - step;
        return Math.max(0, (0, _exponentJsDefault.default)(max) - (0, _exponentJsDefault.default)(step)) + 1;
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"lHCgt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4QyyI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>log);
var _d3Array = require("d3-array");
var _d3Format = require("d3-format");
var _constant = require("./constant");
var _constantDefault = parcelHelpers.interopDefault(_constant);
var _nice = require("./nice");
var _niceDefault = parcelHelpers.interopDefault(_nice);
var _continuous = require("./continuous");
var _continuousDefault = parcelHelpers.interopDefault(_continuous);
function deinterpolate(a, b) {
    return (b = Math.log(b / a)) ? function(x) {
        return Math.log(x / a) / b;
    } : (0, _constantDefault.default)(b);
}
function reinterpolate(a, b) {
    return a < 0 ? function(t) {
        return -Math.pow(-b, t) * Math.pow(-a, 1 - t);
    } : function(t) {
        return Math.pow(b, t) * Math.pow(a, 1 - t);
    };
}
function pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function powp(base) {
    return base === 10 ? pow10 : base === Math.E ? Math.exp : function(x) {
        return Math.pow(base, x);
    };
}
function logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), function(x) {
        return Math.log(x) / base;
    });
}
function reflect(f) {
    return function(x) {
        return -f(-x);
    };
}
function log() {
    var scale = (0, _continuousDefault.default)(deinterpolate, reinterpolate).domain([
        1,
        10
    ]), domain = scale.domain, base = 10, logs = logp(10), pows = powp(10);
    function rescale() {
        logs = logp(base), pows = powp(base);
        if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = function(count) {
        var d = domain(), u = d[0], v = d[d.length - 1], r;
        if (r = v < u) i = u, u = v, v = i;
        var i = logs(u), j = logs(v), p, k, t, n = count == null ? 10 : +count, z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.round(i) - 1, j = Math.round(j) + 1;
            if (u > 0) for(; i < j; ++i)for(k = 1, p = pows(i); k < base; ++k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i < j; ++i)for(k = base - 1, p = pows(i); k >= 1; --k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
        } else z = (0, _d3Array.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = function(count, specifier) {
        if (specifier == null) specifier = base === 10 ? ".0e" : ",";
        if (typeof specifier !== "function") specifier = (0, _d3Format.format)(specifier);
        if (count === Infinity) return specifier;
        if (count == null) count = 10;
        var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return function(d) {
            var i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = function() {
        return domain((0, _niceDefault.default)(domain(), {
            floor: function(x) {
                return pows(Math.floor(logs(x)));
            },
            ceil: function(x) {
                return pows(Math.ceil(logs(x)));
            }
        }));
    };
    scale.copy = function() {
        return (0, _continuous.copy)(scale, log().base(base));
    };
    return scale;
}

},{"d3-array":"5DW5h","d3-format":"fVakl","./constant":"8AYoV","./nice":"7g934","./continuous":"6tLkG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7g934":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(domain, interval) {
        domain = domain.slice();
        var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
        if (x1 < x0) {
            t = i0, i0 = i1, i1 = t;
            t = x0, x0 = x1, x1 = t;
        }
        domain[i0] = interval.floor(x0);
        domain[i1] = interval.ceil(x1);
        return domain;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bNEJh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>pow);
parcelHelpers.export(exports, "sqrt", ()=>sqrt);
var _constant = require("./constant");
var _constantDefault = parcelHelpers.interopDefault(_constant);
var _linear = require("./linear");
var _continuous = require("./continuous");
var _continuousDefault = parcelHelpers.interopDefault(_continuous);
function raise(x, exponent) {
    return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}
function pow() {
    var exponent = 1, scale = (0, _continuousDefault.default)(deinterpolate, reinterpolate), domain = scale.domain;
    function deinterpolate(a, b) {
        return (b = raise(b, exponent) - (a = raise(a, exponent))) ? function(x) {
            return (raise(x, exponent) - a) / b;
        } : (0, _constantDefault.default)(b);
    }
    function reinterpolate(a, b) {
        b = raise(b, exponent) - (a = raise(a, exponent));
        return function(t) {
            return raise(a + b * t, 1 / exponent);
        };
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, domain(domain())) : exponent;
    };
    scale.copy = function() {
        return (0, _continuous.copy)(scale, pow().exponent(exponent));
    };
    return (0, _linear.linearish)(scale);
}
function sqrt() {
    return pow().exponent(0.5);
}

},{"./constant":"8AYoV","./linear":"drdK3","./continuous":"6tLkG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7xViq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quantile);
var _d3Array = require("d3-array");
var _array = require("./array");
function quantile() {
    var domain = [], range = [], thresholds = [];
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, _d3Array.quantile)(domain, i / n);
        return scale;
    }
    function scale(x) {
        if (!isNaN(x = +x)) return range[(0, _d3Array.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for(var i = 0, n = _.length, d; i < n; ++i)if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, _d3Array.ascending));
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, _array.slice).call(_), rescale()) : range.slice();
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return quantile().domain(domain).range(range);
    };
    return scale;
}

},{"d3-array":"5DW5h","./array":"aKlJq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cbUWW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quantize);
var _d3Array = require("d3-array");
var _array = require("./array");
var _linear = require("./linear");
function quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ];
    function scale(x) {
        if (x <= x) return range[(0, _d3Array.bisect)(domain, x, 0, n)];
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = (0, _array.slice).call(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.copy = function() {
        return quantize().domain([
            x0,
            x1
        ]).range(range);
    };
    return (0, _linear.linearish)(scale);
}

},{"d3-array":"5DW5h","./array":"aKlJq","./linear":"drdK3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"RpTbZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>threshold);
var _d3Array = require("d3-array");
var _array = require("./array");
function threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], n = 1;
    function scale(x) {
        if (x <= x) return range[(0, _d3Array.bisect)(domain, x, 0, n)];
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = (0, _array.slice).call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, _array.slice).call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.copy = function() {
        return threshold().domain(domain).range(range);
    };
    return scale;
}

},{"d3-array":"5DW5h","./array":"aKlJq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2J8Xy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calendar", ()=>calendar);
parcelHelpers.export(exports, "default", ()=>function() {
        return calendar((0, _d3Time.timeYear), (0, _d3Time.timeMonth), (0, _d3Time.timeWeek), (0, _d3Time.timeDay), (0, _d3Time.timeHour), (0, _d3Time.timeMinute), (0, _d3Time.timeSecond), (0, _d3Time.timeMillisecond), (0, _d3TimeFormat.timeFormat)).domain([
            new Date(2000, 0, 1),
            new Date(2000, 0, 2)
        ]);
    });
var _d3Array = require("d3-array");
var _d3Interpolate = require("d3-interpolate");
var _d3Time = require("d3-time");
var _d3TimeFormat = require("d3-time-format");
var _array = require("./array");
var _continuous = require("./continuous");
var _continuousDefault = parcelHelpers.interopDefault(_continuous);
var _nice = require("./nice");
var _niceDefault = parcelHelpers.interopDefault(_nice);
var durationSecond = 1000, durationMinute = durationSecond * 60, durationHour = durationMinute * 60, durationDay = durationHour * 24, durationWeek = durationDay * 7, durationMonth = durationDay * 30, durationYear = durationDay * 365;
function date(t) {
    return new Date(t);
}
function number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
    var scale = (0, _continuousDefault.default)((0, _continuous.deinterpolateLinear), (0, _d3Interpolate.interpolateNumber)), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    var tickIntervals = [
        [
            second,
            1,
            durationSecond
        ],
        [
            second,
            5,
            5 * durationSecond
        ],
        [
            second,
            15,
            15 * durationSecond
        ],
        [
            second,
            30,
            30 * durationSecond
        ],
        [
            minute,
            1,
            durationMinute
        ],
        [
            minute,
            5,
            5 * durationMinute
        ],
        [
            minute,
            15,
            15 * durationMinute
        ],
        [
            minute,
            30,
            30 * durationMinute
        ],
        [
            hour,
            1,
            durationHour
        ],
        [
            hour,
            3,
            3 * durationHour
        ],
        [
            hour,
            6,
            6 * durationHour
        ],
        [
            hour,
            12,
            12 * durationHour
        ],
        [
            day,
            1,
            durationDay
        ],
        [
            day,
            2,
            2 * durationDay
        ],
        [
            week,
            1,
            durationWeek
        ],
        [
            month,
            1,
            durationMonth
        ],
        [
            month,
            3,
            3 * durationMonth
        ],
        [
            year,
            1,
            durationYear
        ]
    ];
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    function tickInterval(interval, start, stop, step) {
        if (interval == null) interval = 10;
        // If a desired tick count is specified, pick a reasonable tick interval
        // based on the extent of the domain and a rough estimate of tick size.
        // Otherwise, assume interval is already a time interval and use it.
        if (typeof interval === "number") {
            var target = Math.abs(stop - start) / interval, i = (0, _d3Array.bisector)(function(i) {
                return i[2];
            }).right(tickIntervals, target);
            if (i === tickIntervals.length) {
                step = (0, _d3Array.tickStep)(start / durationYear, stop / durationYear, interval);
                interval = year;
            } else if (i) {
                i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
                step = i[1];
                interval = i[0];
            } else {
                step = Math.max((0, _d3Array.tickStep)(start, stop, interval), 1);
                interval = millisecond;
            }
        }
        return step == null ? interval : interval.every(step);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain((0, _array.map).call(_, number)) : domain().map(date);
    };
    scale.ticks = function(interval, step) {
        var d = domain(), t0 = d[0], t1 = d[d.length - 1], r = t1 < t0, t;
        if (r) t = t0, t0 = t1, t1 = t;
        t = tickInterval(interval, t0, t1, step);
        t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
        return r ? t.reverse() : t;
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval, step) {
        var d = domain();
        return (interval = tickInterval(interval, d[0], d[d.length - 1], step)) ? domain((0, _niceDefault.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, _continuous.copy)(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
    };
    return scale;
}

},{"d3-array":"5DW5h","d3-interpolate":[["interpolateNumber","5p4je","default"]],"d3-time":[["timeDay","3Y5KR","default"],["timeHour","hMtA7","default"],["timeMillisecond","bAFZH","default"],["timeMinute","i2CqY","default"],["timeMonth","flBd4","default"],["timeSecond","kkZd9","default"],["timeWeek","9mL6O","sunday"],["timeYear","3XVTt","default"]],"d3-time-format":"grg0n","./array":"aKlJq","./continuous":"6tLkG","./nice":"7g934","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3Y5KR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "days", ()=>days);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var day = (0, _intervalJsDefault.default)(function(date) {
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setDate(date.getDate() + step);
}, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, _durationJs.durationMinute)) / (0, _durationJs.durationDay);
}, function(date) {
    return date.getDate() - 1;
});
exports.default = day;
var days = day.range;

},{"./interval.js":"cYueX","./duration.js":"gOuo5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cYueX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>newInterval);
var t0 = new Date, t1 = new Date;
function newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            t0.setTime(+start), t1.setTime(+end);
            floori(t0), floori(t1);
            return Math.floor(count(t0, t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gOuo5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "durationSecond", ()=>durationSecond);
parcelHelpers.export(exports, "durationMinute", ()=>durationMinute);
parcelHelpers.export(exports, "durationHour", ()=>durationHour);
parcelHelpers.export(exports, "durationDay", ()=>durationDay);
parcelHelpers.export(exports, "durationWeek", ()=>durationWeek);
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hMtA7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hours", ()=>hours);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var hour = (0, _intervalJsDefault.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, _durationJs.durationSecond) - date.getMinutes() * (0, _durationJs.durationMinute));
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationHour));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationHour);
}, function(date) {
    return date.getHours();
});
exports.default = hour;
var hours = hour.range;

},{"./interval.js":"cYueX","./duration.js":"gOuo5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bAFZH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "milliseconds", ()=>milliseconds);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var millisecond = (0, _intervalJsDefault.default)(function() {
// noop
}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
});
// An optimized implementation for this simple case.
millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return millisecond;
    return (0, _intervalJsDefault.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
exports.default = millisecond;
var milliseconds = millisecond.range;

},{"./interval.js":"cYueX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i2CqY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "minutes", ()=>minutes);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var minute = (0, _intervalJsDefault.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, _durationJs.durationSecond));
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationMinute));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationMinute);
}, function(date) {
    return date.getMinutes();
});
exports.default = minute;
var minutes = minute.range;

},{"./interval.js":"cYueX","./duration.js":"gOuo5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"flBd4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "months", ()=>months);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var month = (0, _intervalJsDefault.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
exports.default = month;
var months = month.range;

},{"./interval.js":"cYueX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kkZd9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "seconds", ()=>seconds);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var second = (0, _intervalJsDefault.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationSecond));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationSecond);
}, function(date) {
    return date.getUTCSeconds();
});
exports.default = second;
var seconds = second.range;

},{"./interval.js":"cYueX","./duration.js":"gOuo5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9mL6O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sunday", ()=>sunday);
parcelHelpers.export(exports, "monday", ()=>monday);
parcelHelpers.export(exports, "tuesday", ()=>tuesday);
parcelHelpers.export(exports, "wednesday", ()=>wednesday);
parcelHelpers.export(exports, "thursday", ()=>thursday);
parcelHelpers.export(exports, "friday", ()=>friday);
parcelHelpers.export(exports, "saturday", ()=>saturday);
parcelHelpers.export(exports, "sundays", ()=>sundays);
parcelHelpers.export(exports, "mondays", ()=>mondays);
parcelHelpers.export(exports, "tuesdays", ()=>tuesdays);
parcelHelpers.export(exports, "wednesdays", ()=>wednesdays);
parcelHelpers.export(exports, "thursdays", ()=>thursdays);
parcelHelpers.export(exports, "fridays", ()=>fridays);
parcelHelpers.export(exports, "saturdays", ()=>saturdays);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
function weekday(i) {
    return (0, _intervalJsDefault.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, _durationJs.durationMinute)) / (0, _durationJs.durationWeek);
    });
}
var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);
var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;

},{"./interval.js":"cYueX","./duration.js":"gOuo5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3XVTt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "years", ()=>years);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var year = (0, _intervalJsDefault.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _intervalJsDefault.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
exports.default = year;
var years = year.range;

},{"./interval.js":"cYueX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"grg0n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeFormat", ()=>timeFormat);
parcelHelpers.export(exports, "timeParse", ()=>timeParse);
parcelHelpers.export(exports, "utcFormat", ()=>utcFormat);
parcelHelpers.export(exports, "utcParse", ()=>utcParse);
parcelHelpers.export(exports, "default", ()=>defaultLocale);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;
defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function defaultLocale(definition) {
    locale = (0, _localeJsDefault.default)(definition);
    timeFormat = locale.format;
    timeParse = locale.parse;
    utcFormat = locale.utcFormat;
    utcParse = locale.utcParse;
    return locale;
}

},{"./locale.js":"ejJ05","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ejJ05":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatLocale);
var _d3Time = require("d3-time");
function localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": formatDayOfMonth,
        "e": formatDayOfMonth,
        "f": formatMicroseconds,
        "g": formatYearISO,
        "G": formatFullYearISO,
        "H": formatHour24,
        "I": formatHour12,
        "j": formatDayOfYear,
        "L": formatMilliseconds,
        "m": formatMonthNumber,
        "M": formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatSeconds,
        "u": formatWeekdayNumberMonday,
        "U": formatWeekNumberSunday,
        "V": formatWeekNumberISO,
        "w": formatWeekdayNumberSunday,
        "W": formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatYear,
        "Y": formatFullYear,
        "Z": formatZone,
        "%": formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": formatUTCDayOfMonth,
        "e": formatUTCDayOfMonth,
        "f": formatUTCMicroseconds,
        "g": formatUTCYearISO,
        "G": formatUTCFullYearISO,
        "H": formatUTCHour24,
        "I": formatUTCHour12,
        "j": formatUTCDayOfYear,
        "L": formatUTCMilliseconds,
        "m": formatUTCMonthNumber,
        "M": formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatUTCSeconds,
        "u": formatUTCWeekdayNumberMonday,
        "U": formatUTCWeekNumberSunday,
        "V": formatUTCWeekNumberISO,
        "w": formatUTCWeekdayNumberSunday,
        "W": formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatUTCYear,
        "Y": formatUTCFullYear,
        "Z": formatUTCZone,
        "%": formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": parseDayOfMonth,
        "e": parseDayOfMonth,
        "f": parseMicroseconds,
        "g": parseYear,
        "G": parseFullYear,
        "H": parseHour24,
        "I": parseHour24,
        "j": parseDayOfYear,
        "L": parseMilliseconds,
        "m": parseMonthNumber,
        "M": parseMinutes,
        "p": parsePeriod,
        "q": parseQuarter,
        "Q": parseUnixTimestamp,
        "s": parseUnixTimestampSeconds,
        "S": parseSeconds,
        "u": parseWeekdayNumberMonday,
        "U": parseWeekNumberSunday,
        "V": parseWeekNumberISO,
        "w": parseWeekdayNumberSunday,
        "W": parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": parseYear,
        "Y": parseFullYear,
        "Z": parseZone,
        "%": parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, _d3Time.utcMonday).ceil(week) : (0, _d3Time.utcMonday)(week);
                    week = (0, _d3Time.utcDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, _d3Time.timeMonday).ceil(week) : (0, _d3Time.timeMonday)(week);
                    week = (0, _d3Time.timeDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, numberRe = /^\s*\d+/, percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
function pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function requote(s) {
    return s.replace(requoteRe, "\\$&");
}
function formatRe(names) {
    return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}
function formatLookup(names) {
    var map = {}, i = -1, n = names.length;
    while(++i < n)map[names[i].toLowerCase()] = i;
    return map;
}
function parseWeekdayNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function parseWeekdayNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberISO(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function parseFullYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function parseYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function parseQuarter(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function parseMonthNumber(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function parseDayOfMonth(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function parseDayOfYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function parseHour24(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function parseMinutes(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function parseSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function parseMilliseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function parseMicroseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function parseLiteralPercent(d, string, i) {
    var n = percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function parseUnixTimestamp(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function parseUnixTimestampSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function formatDayOfMonth(d, p) {
    return pad(d.getDate(), p, 2);
}
function formatHour24(d, p) {
    return pad(d.getHours(), p, 2);
}
function formatHour12(d, p) {
    return pad(d.getHours() % 12 || 12, p, 2);
}
function formatDayOfYear(d, p) {
    return pad(1 + (0, _d3Time.timeDay).count((0, _d3Time.timeYear)(d), d), p, 3);
}
function formatMilliseconds(d, p) {
    return pad(d.getMilliseconds(), p, 3);
}
function formatMicroseconds(d, p) {
    return formatMilliseconds(d, p) + "000";
}
function formatMonthNumber(d, p) {
    return pad(d.getMonth() + 1, p, 2);
}
function formatMinutes(d, p) {
    return pad(d.getMinutes(), p, 2);
}
function formatSeconds(d, p) {
    return pad(d.getSeconds(), p, 2);
}
function formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function formatWeekNumberSunday(d, p) {
    return pad((0, _d3Time.timeSunday).count((0, _d3Time.timeYear)(d) - 1, d), p, 2);
}
function dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, _d3Time.timeThursday)(d) : (0, _d3Time.timeThursday).ceil(d);
}
function formatWeekNumberISO(d, p) {
    d = dISO(d);
    return pad((0, _d3Time.timeThursday).count((0, _d3Time.timeYear)(d), d) + ((0, _d3Time.timeYear)(d).getDay() === 4), p, 2);
}
function formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function formatWeekNumberMonday(d, p) {
    return pad((0, _d3Time.timeMonday).count((0, _d3Time.timeYear)(d) - 1, d), p, 2);
}
function formatYear(d, p) {
    return pad(d.getFullYear() % 100, p, 2);
}
function formatYearISO(d, p) {
    d = dISO(d);
    return pad(d.getFullYear() % 100, p, 2);
}
function formatFullYear(d, p) {
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, _d3Time.timeThursday)(d) : (0, _d3Time.timeThursday).ceil(d);
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
}
function formatUTCDayOfMonth(d, p) {
    return pad(d.getUTCDate(), p, 2);
}
function formatUTCHour24(d, p) {
    return pad(d.getUTCHours(), p, 2);
}
function formatUTCHour12(d, p) {
    return pad(d.getUTCHours() % 12 || 12, p, 2);
}
function formatUTCDayOfYear(d, p) {
    return pad(1 + (0, _d3Time.utcDay).count((0, _d3Time.utcYear)(d), d), p, 3);
}
function formatUTCMilliseconds(d, p) {
    return pad(d.getUTCMilliseconds(), p, 3);
}
function formatUTCMicroseconds(d, p) {
    return formatUTCMilliseconds(d, p) + "000";
}
function formatUTCMonthNumber(d, p) {
    return pad(d.getUTCMonth() + 1, p, 2);
}
function formatUTCMinutes(d, p) {
    return pad(d.getUTCMinutes(), p, 2);
}
function formatUTCSeconds(d, p) {
    return pad(d.getUTCSeconds(), p, 2);
}
function formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function formatUTCWeekNumberSunday(d, p) {
    return pad((0, _d3Time.utcSunday).count((0, _d3Time.utcYear)(d) - 1, d), p, 2);
}
function UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, _d3Time.utcThursday)(d) : (0, _d3Time.utcThursday).ceil(d);
}
function formatUTCWeekNumberISO(d, p) {
    d = UTCdISO(d);
    return pad((0, _d3Time.utcThursday).count((0, _d3Time.utcYear)(d), d) + ((0, _d3Time.utcYear)(d).getUTCDay() === 4), p, 2);
}
function formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function formatUTCWeekNumberMonday(d, p) {
    return pad((0, _d3Time.utcMonday).count((0, _d3Time.utcYear)(d) - 1, d), p, 2);
}
function formatUTCYear(d, p) {
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCYearISO(d, p) {
    d = UTCdISO(d);
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCFullYear(d, p) {
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, _d3Time.utcThursday)(d) : (0, _d3Time.utcThursday).ceil(d);
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCZone() {
    return "+0000";
}
function formatLiteralPercent() {
    return "%";
}
function formatUnixTimestamp(d) {
    return +d;
}
function formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

},{"d3-time":[["timeDay","3Y5KR","default"],["timeMonday","9mL6O","monday"],["timeSunday","9mL6O","sunday"],["timeThursday","9mL6O","thursday"],["timeYear","3XVTt","default"],["utcDay","gZm7w","default"],["utcMonday","9E6yg"],["utcSunday","9E6yg"],["utcThursday","9E6yg"],["utcYear","akN6N","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gZm7w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcDays", ()=>utcDays);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var utcDay = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationDay);
}, function(date) {
    return date.getUTCDate() - 1;
});
exports.default = utcDay;
var utcDays = utcDay.range;

},{"./interval.js":"cYueX","./duration.js":"gOuo5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9E6yg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcSunday", ()=>utcSunday);
parcelHelpers.export(exports, "utcMonday", ()=>utcMonday);
parcelHelpers.export(exports, "utcTuesday", ()=>utcTuesday);
parcelHelpers.export(exports, "utcWednesday", ()=>utcWednesday);
parcelHelpers.export(exports, "utcThursday", ()=>utcThursday);
parcelHelpers.export(exports, "utcFriday", ()=>utcFriday);
parcelHelpers.export(exports, "utcSaturday", ()=>utcSaturday);
parcelHelpers.export(exports, "utcSundays", ()=>utcSundays);
parcelHelpers.export(exports, "utcMondays", ()=>utcMondays);
parcelHelpers.export(exports, "utcTuesdays", ()=>utcTuesdays);
parcelHelpers.export(exports, "utcWednesdays", ()=>utcWednesdays);
parcelHelpers.export(exports, "utcThursdays", ()=>utcThursdays);
parcelHelpers.export(exports, "utcFridays", ()=>utcFridays);
parcelHelpers.export(exports, "utcSaturdays", ()=>utcSaturdays);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
function utcWeekday(i) {
    return (0, _intervalJsDefault.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, _durationJs.durationWeek);
    });
}
var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);
var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;

},{"./interval.js":"cYueX","./duration.js":"gOuo5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"akN6N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcYears", ()=>utcYears);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var utcYear = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _intervalJsDefault.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
exports.default = utcYear;
var utcYears = utcYear.range;

},{"./interval.js":"cYueX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lHXiS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _time.calendar)((0, _d3Time.utcYear), (0, _d3Time.utcMonth), (0, _d3Time.utcWeek), (0, _d3Time.utcDay), (0, _d3Time.utcHour), (0, _d3Time.utcMinute), (0, _d3Time.utcSecond), (0, _d3Time.utcMillisecond), (0, _d3TimeFormat.utcFormat)).domain([
            Date.UTC(2000, 0, 1),
            Date.UTC(2000, 0, 2)
        ]);
    });
var _time = require("./time");
var _d3TimeFormat = require("d3-time-format");
var _d3Time = require("d3-time");

},{"./time":"2J8Xy","d3-time-format":"grg0n","d3-time":[["utcDay","gZm7w","default"],["utcHour","iJiyk","default"],["utcMillisecond","bAFZH","default"],["utcMinute","ktc1v","default"],["utcMonth","a4Kgy","default"],["utcSecond","kkZd9","default"],["utcWeek","9E6yg","utcSunday"],["utcYear","akN6N","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iJiyk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcHours", ()=>utcHours);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var utcHour = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationHour));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationHour);
}, function(date) {
    return date.getUTCHours();
});
exports.default = utcHour;
var utcHours = utcHour.range;

},{"./interval.js":"cYueX","./duration.js":"gOuo5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ktc1v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcMinutes", ()=>utcMinutes);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var utcMinute = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationMinute));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationMinute);
}, function(date) {
    return date.getUTCMinutes();
});
exports.default = utcMinute;
var utcMinutes = utcMinute.range;

},{"./interval.js":"cYueX","./duration.js":"gOuo5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a4Kgy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcMonths", ()=>utcMonths);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var utcMonth = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
exports.default = utcMonth;
var utcMonths = utcMonth.range;

},{"./interval.js":"cYueX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"03mxo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colors = require("./colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
exports.default = (0, _colorsDefault.default)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");

},{"./colors":"hGS8W","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hGS8W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(s) {
        return s.match(/.{6}/g).map(function(x) {
            return "#" + x;
        });
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cYn56":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colors = require("./colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
exports.default = (0, _colorsDefault.default)("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");

},{"./colors":"hGS8W","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hkMJV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colors = require("./colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
exports.default = (0, _colorsDefault.default)("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");

},{"./colors":"hGS8W","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cdOhs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colors = require("./colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
exports.default = (0, _colorsDefault.default)("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");

},{"./colors":"hGS8W","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"62Lgs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _d3Color = require("d3-color");
var _d3Interpolate = require("d3-interpolate");
exports.default = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(300, 0.5, 0.0), (0, _d3Color.cubehelix)(-240, 0.5, 1.0));

},{"d3-color":[["cubehelix","5MccR","default"]],"d3-interpolate":[["interpolateCubehelixLong","jnt3O","cubehelixLong"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5MccR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cubehelix);
parcelHelpers.export(exports, "Cubehelix", ()=>Cubehelix);
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
var _colorJs = require("./color.js");
var _mathJs = require("./math.js");
var A = -0.14861, B = 1.78277, C = -0.29227, D = -0.90649, E = 1.97294, ED = E * D, EB = E * B, BC_DA = B * C - D * A;
function cubehelixConvert(o) {
    if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, _colorJs.Rgb))) o = (0, _colorJs.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB), bl = b - l, k = (E * (g - l) - C * bl) / D, s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, _mathJs.rad2deg) - 120 : NaN;
    return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Cubehelix, cubehelix, (0, _defineJs.extend)((0, _colorJs.Color), {
    brighter: function(k) {
        k = k == null ? (0, _colorJs.brighter) : Math.pow((0, _colorJs.brighter), k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? (0, _colorJs.darker) : Math.pow((0, _colorJs.darker), k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, _mathJs.deg2rad), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, _colorJs.Rgb)(255 * (l + a * (A * cosh + B * sinh)), 255 * (l + a * (C * cosh + D * sinh)), 255 * (l + a * (E * cosh)), this.opacity);
    }
}));

},{"./define.js":"bmE5F","./color.js":"6xHcs","./math.js":"aG2R6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aG2R6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deg2rad", ()=>deg2rad);
parcelHelpers.export(exports, "rad2deg", ()=>rad2deg);
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jnt3O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cubehelixLong", ()=>cubehelixLong);
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, _d3Color.cubehelix)(start)).h, (end = (0, _d3Color.cubehelix)(end)).h), s = (0, _colorJsDefault.default)(start.s, end.s), l = (0, _colorJsDefault.default)(start.l, end.l), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
exports.default = cubehelix((0, _colorJs.hue));
var cubehelixLong = cubehelix((0, _colorJsDefault.default));

},{"d3-color":[["cubehelix","5MccR","default"]],"./color.js":"6SyOh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"20XqR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "warm", ()=>warm);
parcelHelpers.export(exports, "cool", ()=>cool);
parcelHelpers.export(exports, "default", ()=>function(t) {
        if (t < 0 || t > 1) t -= Math.floor(t);
        var ts = Math.abs(t - 0.5);
        rainbow.h = 360 * t - 100;
        rainbow.s = 1.5 - 1.5 * ts;
        rainbow.l = 0.8 - 0.9 * ts;
        return rainbow + "";
    });
var _d3Color = require("d3-color");
var _d3Interpolate = require("d3-interpolate");
var warm = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(-100, 0.75, 0.35), (0, _d3Color.cubehelix)(80, 1.50, 0.8));
var cool = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(260, 0.75, 0.35), (0, _d3Color.cubehelix)(80, 1.50, 0.8));
var rainbow = (0, _d3Color.cubehelix)();

},{"d3-color":[["cubehelix","5MccR","default"]],"d3-interpolate":[["interpolateCubehelixLong","jnt3O","cubehelixLong"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hoSSi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "magma", ()=>magma);
parcelHelpers.export(exports, "inferno", ()=>inferno);
parcelHelpers.export(exports, "plasma", ()=>plasma);
var _colors = require("./colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
function ramp(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}
exports.default = ramp((0, _colorsDefault.default)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var magma = ramp((0, _colorsDefault.default)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
var inferno = ramp((0, _colorsDefault.default)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
var plasma = ramp((0, _colorsDefault.default)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

},{"./colors":"hGS8W","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aYUCC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>sequential);
var _linear = require("./linear");
function sequential(interpolator) {
    var x0 = 0, x1 = 1, clamp = false;
    function scale(x) {
        var t = (x - x0) / (x1 - x0);
        return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
    }
    scale.domain = function(_) {
        return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.copy = function() {
        return sequential(interpolator).domain([
            x0,
            x1
        ]).clamp(clamp);
    };
    return (0, _linear.linearish)(scale);
}

},{"./linear":"drdK3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8zfX3":[function(require,module,exports,__globalThis) {
/*! @preserve
 * numeral.js
 * version : 1.5.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */ (function() {
    /************************************
        Variables
    ************************************/ var numeral, VERSION = '1.5.6', // internal storage for language config files
    languages = {}, defaults = {
        currentLanguage: 'en',
        zeroFormat: null,
        nullFormat: null,
        defaultFormat: '0,0'
    }, options = {
        currentLanguage: defaults.currentLanguage,
        zeroFormat: defaults.zeroFormat,
        nullFormat: defaults.nullFormat,
        defaultFormat: defaults.defaultFormat
    }, byteSuffixes = {
        bytes: [
            'B',
            'KB',
            'MB',
            'GB',
            'TB',
            'PB',
            'EB',
            'ZB',
            'YB'
        ],
        iec: [
            'B',
            'KiB',
            'MiB',
            'GiB',
            'TiB',
            'PiB',
            'EiB',
            'ZiB',
            'YiB'
        ]
    };
    /************************************
        Constructors
    ************************************/ // Numeral prototype object
    function Numeral(number) {
        this._value = number;
    }
    /**
     * Implementation of toFixed() that treats floats more like decimals
     *
     * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
     * problems for accounting- and finance-related software.
     */ function toFixed(value, maxDecimals, roundingFunction, optionals) {
        var splitValue = value.toString().split('.'), minDecimals = maxDecimals - (optionals || 0), boundedPrecision, optionalsRegExp, power, output;
        // Use the smallest precision value possible to avoid errors from floating point representation
        if (splitValue.length === 2) boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
        else boundedPrecision = minDecimals;
        power = Math.pow(10, boundedPrecision);
        //roundingFunction = (roundingFunction !== undefined ? roundingFunction : Math.round);
        // Multiply up by precision, round accurately, then divide and use native toFixed():
        output = (roundingFunction(value * power) / power).toFixed(boundedPrecision);
        if (optionals > maxDecimals - boundedPrecision) {
            optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
            output = output.replace(optionalsRegExp, '');
        }
        return output;
    }
    /************************************
        Formatting
    ************************************/ // determine what type of formatting we need to do
    function formatNumeral(n, format, roundingFunction) {
        var output;
        if (n._value === 0 && options.zeroFormat !== null) output = options.zeroFormat;
        else if (n._value === null && options.nullFormat !== null) output = options.nullFormat;
        else {
            // figure out what kind of format we are dealing with
            if (format.indexOf('$') > -1) output = formatCurrency(n, format, roundingFunction);
            else if (format.indexOf('%') > -1) output = formatPercentage(n, format, roundingFunction);
            else if (format.indexOf(':') > -1) output = formatTime(n, format);
            else if (format.indexOf('b') > -1 || format.indexOf('ib') > -1) output = formatBytes(n, format, roundingFunction);
            else if (format.indexOf('o') > -1) output = formatOrdinal(n, format, roundingFunction);
            else output = formatNumber(n._value, format, roundingFunction);
        }
        return output;
    }
    function formatCurrency(n, format, roundingFunction) {
        var symbolIndex = format.indexOf('$'), openParenIndex = format.indexOf('('), minusSignIndex = format.indexOf('-'), space = '', spliceIndex, output;
        // check for space before or after currency
        if (format.indexOf(' $') > -1) {
            space = ' ';
            format = format.replace(' $', '');
        } else if (format.indexOf('$ ') > -1) {
            space = ' ';
            format = format.replace('$ ', '');
        } else format = format.replace('$', '');
        // format the number
        output = formatNumber(n._value, format, roundingFunction, false);
        // position the symbol
        if (symbolIndex <= 1) {
            if (output.indexOf('(') > -1 || output.indexOf('-') > -1) {
                output = output.split('');
                spliceIndex = 1;
                if (symbolIndex < openParenIndex || symbolIndex < minusSignIndex) // the symbol appears before the "(" or "-"
                spliceIndex = 0;
                output.splice(spliceIndex, 0, languages[options.currentLanguage].currency.symbol + space);
                output = output.join('');
            } else output = languages[options.currentLanguage].currency.symbol + space + output;
        } else if (output.indexOf(')') > -1) {
            output = output.split('');
            output.splice(-1, 0, space + languages[options.currentLanguage].currency.symbol);
            output = output.join('');
        } else output = output + space + languages[options.currentLanguage].currency.symbol;
        return output;
    }
    function formatPercentage(n, format, roundingFunction) {
        var space = '', output, value = n._value * 100;
        // check for space before %
        if (format.indexOf(' %') > -1) {
            space = ' ';
            format = format.replace(' %', '');
        } else format = format.replace('%', '');
        output = formatNumber(value, format, roundingFunction);
        if (output.indexOf(')') > -1) {
            output = output.split('');
            output.splice(-1, 0, space + '%');
            output = output.join('');
        } else output = output + space + '%';
        return output;
    }
    function formatBytes(n, format, roundingFunction) {
        var output, suffixes = format.indexOf('ib') > -1 ? byteSuffixes.iec : byteSuffixes.bytes, value = n._value, suffix = '', power, min, max;
        // check for space before
        if (format.indexOf(' b') > -1 || format.indexOf(' ib') > -1) {
            suffix = ' ';
            format = format.replace(' ib', '').replace(' b', '');
        } else format = format.replace('ib', '').replace('b', '');
        for(power = 0; power <= suffixes.length; power++){
            min = Math.pow(1024, power);
            max = Math.pow(1024, power + 1);
            if (value === null || value === 0 || value >= min && value < max) {
                suffix += suffixes[power];
                if (min > 0) value = value / min;
                break;
            }
        }
        output = formatNumber(value, format, roundingFunction);
        return output + suffix;
    }
    function formatOrdinal(n, format, roundingFunction) {
        var output, ordinal = '';
        // check for space before
        if (format.indexOf(' o') > -1) {
            ordinal = ' ';
            format = format.replace(' o', '');
        } else format = format.replace('o', '');
        ordinal += languages[options.currentLanguage].ordinal(n._value);
        output = formatNumber(n._value, format, roundingFunction);
        return output + ordinal;
    }
    function formatTime(n) {
        var hours = Math.floor(n._value / 60 / 60), minutes = Math.floor((n._value - hours * 3600) / 60), seconds = Math.round(n._value - hours * 3600 - minutes * 60);
        return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
    }
    function formatNumber(value, format, roundingFunction) {
        var negP = false, signed = false, optDec = false, abbr = '', abbrK = false, abbrM = false, abbrB = false, abbrT = false, abbrForce = false, abs, min, max, power, w, precision, thousands, d = '', neg = false;
        if (value === null) value = 0;
        abs = Math.abs(value);
        // see if we should use parentheses for negative number or if we should prefix with a sign
        // if both are present we default to parentheses
        if (format.indexOf('(') > -1) {
            negP = true;
            format = format.slice(1, -1);
        } else if (format.indexOf('+') > -1) {
            signed = true;
            format = format.replace(/\+/g, '');
        }
        // see if abbreviation is wanted
        if (format.indexOf('a') > -1) {
            // check if abbreviation is specified
            abbrK = format.indexOf('aK') >= 0;
            abbrM = format.indexOf('aM') >= 0;
            abbrB = format.indexOf('aB') >= 0;
            abbrT = format.indexOf('aT') >= 0;
            abbrForce = abbrK || abbrM || abbrB || abbrT;
            // check for space before abbreviation
            if (format.indexOf(' a') > -1) abbr = ' ';
            format = format.replace(new RegExp(abbr + 'a[KMBT]?'), '');
            if (abs >= Math.pow(10, 12) && !abbrForce || abbrT) {
                // trillion
                abbr = abbr + languages[options.currentLanguage].abbreviations.trillion;
                value = value / Math.pow(10, 12);
            } else if (abs < Math.pow(10, 12) && abs >= Math.pow(10, 9) && !abbrForce || abbrB) {
                // billion
                abbr = abbr + languages[options.currentLanguage].abbreviations.billion;
                value = value / Math.pow(10, 9);
            } else if (abs < Math.pow(10, 9) && abs >= Math.pow(10, 6) && !abbrForce || abbrM) {
                // million
                abbr = abbr + languages[options.currentLanguage].abbreviations.million;
                value = value / Math.pow(10, 6);
            } else if (abs < Math.pow(10, 6) && abs >= Math.pow(10, 3) && !abbrForce || abbrK) {
                // thousand
                abbr = abbr + languages[options.currentLanguage].abbreviations.thousand;
                value = value / Math.pow(10, 3);
            }
        }
        if (format.indexOf('[.]') > -1) {
            optDec = true;
            format = format.replace('[.]', '.');
        }
        w = value.toString().split('.')[0];
        precision = format.split('.')[1];
        thousands = format.indexOf(',');
        if (precision) {
            if (precision.indexOf('[') > -1) {
                precision = precision.replace(']', '');
                precision = precision.split('[');
                d = toFixed(value, precision[0].length + precision[1].length, roundingFunction, precision[1].length);
            } else d = toFixed(value, precision.length, roundingFunction);
            w = d.split('.')[0];
            if (d.indexOf('.') > -1) d = languages[options.currentLanguage].delimiters.decimal + d.split('.')[1];
            else d = '';
            if (optDec && Number(d.slice(1)) === 0) d = '';
        } else w = toFixed(value, null, roundingFunction);
        // format number
        if (w.indexOf('-') > -1) {
            w = w.slice(1);
            neg = true;
        }
        if (thousands > -1) w = w.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + languages[options.currentLanguage].delimiters.thousands);
        if (format.indexOf('.') === 0) w = '';
        return (negP && neg ? '(' : '') + (!negP && neg ? '-' : '') + (!neg && signed ? '+' : '') + w + d + (abbr ? abbr : '') + (negP && neg ? ')' : '');
    }
    /************************************
        Unformatting
    ************************************/ // revert to number
    function unformatNumeral(n, string) {
        var stringOriginal = string, thousandRegExp, millionRegExp, billionRegExp, trillionRegExp, bytesMultiplier = false, power, value;
        if (string.indexOf(':') > -1) value = unformatTime(string);
        else if (string === options.zeroFormat || string === options.nullFormat) value = 0;
        else {
            if (languages[options.currentLanguage].delimiters.decimal !== '.') string = string.replace(/\./g, '').replace(languages[options.currentLanguage].delimiters.decimal, '.');
            // see if abbreviations are there so that we can multiply to the correct number
            thousandRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.thousand + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
            millionRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.million + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
            billionRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.billion + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
            trillionRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.trillion + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
            // see if bytes are there so that we can multiply to the correct number
            for(power = 1; power <= byteSuffixes.bytes.length; power++){
                bytesMultiplier = string.indexOf(byteSuffixes.bytes[power]) > -1 || string.indexOf(byteSuffixes.iec[power]) > -1 ? Math.pow(1024, power) : false;
                if (bytesMultiplier) break;
            }
            // do some math to create our number
            value = bytesMultiplier ? bytesMultiplier : 1;
            value *= stringOriginal.match(thousandRegExp) ? Math.pow(10, 3) : 1;
            value *= stringOriginal.match(millionRegExp) ? Math.pow(10, 6) : 1;
            value *= stringOriginal.match(billionRegExp) ? Math.pow(10, 9) : 1;
            value *= stringOriginal.match(trillionRegExp) ? Math.pow(10, 12) : 1;
            // check for percentage
            value *= string.indexOf('%') > -1 ? 0.01 : 1;
            // check for negative number
            value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;
            // remove non numbers
            value *= Number(string.replace(/[^0-9\.]+/g, ''));
            // round if we are talking about bytes
            value = bytesMultiplier ? Math.ceil(value) : value;
        }
        n._value = value;
        return n._value;
    }
    function unformatTime(string) {
        var timeArray = string.split(':'), seconds = 0;
        // turn hours and minutes into seconds and add them all up
        if (timeArray.length === 3) {
            // hours
            seconds = seconds + Number(timeArray[0]) * 3600;
            // minutes
            seconds = seconds + Number(timeArray[1]) * 60;
            // seconds
            seconds = seconds + Number(timeArray[2]);
        } else if (timeArray.length === 2) {
            // minutes
            seconds = seconds + Number(timeArray[0]) * 60;
            // seconds
            seconds = seconds + Number(timeArray[1]);
        }
        return Number(seconds);
    }
    /************************************
        Top Level Functions
    ************************************/ numeral = function(input) {
        if (numeral.isNumeral(input)) input = input.value();
        else if (input === 0 || typeof input === 'undefined') input = 0;
        else if (input === null) input = null;
        else if (!Number(input)) input = numeral.fn.unformat(input);
        else input = Number(input);
        return new Numeral(input);
    };
    // version number
    numeral.version = VERSION;
    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };
    // This function will load languages and then set the global language.  If
    // no arguments are passed in, it will simply return the current global
    // language key.
    numeral.language = function(key, values) {
        if (!key) return options.currentLanguage;
        key = key.toLowerCase();
        if (key && !values) {
            if (!languages[key]) throw new Error('Unknown language : ' + key);
            options.currentLanguage = key;
        }
        if (values || !languages[key]) loadLanguage(key, values);
        return numeral;
    };
    numeral.reset = function() {
        for(var property in defaults)options[property] = defaults[property];
    };
    // This function provides access to the loaded language data.  If
    // no arguments are passed in, it will simply return the current
    // global language object.
    numeral.languageData = function(key) {
        if (!key) return languages[options.currentLanguage];
        if (!languages[key]) throw new Error('Unknown language : ' + key);
        return languages[key];
    };
    numeral.language('en', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function(number) {
            var b = number % 10;
            return ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });
    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof format === 'string' ? format : null;
    };
    numeral.nullFormat = function(format) {
        options.nullFormat = typeof format === 'string' ? format : null;
    };
    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof format === 'string' ? format : '0.0';
    };
    numeral.validate = function(val, culture) {
        var _decimalSep, _thousandSep, _currSymbol, _valArray, _abbrObj, _thousandRegEx, languageData, temp;
        //coerce val to string
        if (typeof val !== 'string') {
            val += '';
            if (console.warn) console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
        }
        //trim whitespaces from either sides
        val = val.trim();
        //if val is just digits return true
        if (!!val.match(/^\d+$/)) return true;
        //if val is empty return false
        if (val === '') return false;
        //get the decimal and thousands separator from numeral.languageData
        try {
            //check if the culture is understood by numeral. if not, default it to current language
            languageData = numeral.languageData(culture);
        } catch (e) {
            languageData = numeral.languageData(numeral.language());
        }
        //setup the delimiters and currency symbol based on culture/language
        _currSymbol = languageData.currency.symbol;
        _abbrObj = languageData.abbreviations;
        _decimalSep = languageData.delimiters.decimal;
        if (languageData.delimiters.thousands === '.') _thousandSep = '\\.';
        else _thousandSep = languageData.delimiters.thousands;
        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) return false;
        }
        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) return false;
        }
        _thousandRegEx = new RegExp(_thousandSep + '{2}');
        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) return false;
            else {
                if (_valArray.length < 2) return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx);
                else {
                    if (_valArray[0].length === 1) return !!_valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
                    else return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
                }
            }
        }
        return false;
    };
    /************************************
        Helpers
    ************************************/ function loadLanguage(key, values) {
        languages[key] = values;
    }
    /************************************
        Floating-point helpers
    ************************************/ // The floating-point helper functions and implementation
    // borrows heavily from sinful.js: http://guipn.github.io/sinful.js/
    // Production steps of ECMA-262, Edition 5, 15.4.4.21
    // Reference: http://es5.github.io/#x15.4.4.21
    if (!Array.prototype.reduce) Array.prototype.reduce = function(callback /*, initialValue*/ ) {
        'use strict';
        if (this === null) throw new TypeError('Array.prototype.reduce called on null or undefined');
        if (typeof callback !== 'function') throw new TypeError(callback + ' is not a function');
        var t = Object(this), len = t.length >>> 0, k = 0, value;
        if (arguments.length === 2) value = arguments[1];
        else {
            while(k < len && !(k in t))k++;
            if (k >= len) throw new TypeError('Reduce of empty array with no initial value');
            value = t[k++];
        }
        for(; k < len; k++)if (k in t) value = callback(value, t[k], k, t);
        return value;
    };
    /**
     * Computes the multiplier necessary to make x >= 1,
     * effectively eliminating miscalculations caused by
     * finite precision.
     */ function multiplier(x) {
        var parts = x.toString().split('.');
        if (parts.length < 2) return 1;
        return Math.pow(10, parts[1].length);
    }
    /**
     * Given a variable number of arguments, returns the maximum
     * multiplier that must be used to normalize an operation involving
     * all of them.
     */ function correctionFactor() {
        var args = Array.prototype.slice.call(arguments);
        return args.reduce(function(prev, next) {
            var mp = multiplier(prev), mn = multiplier(next);
            return mp > mn ? mp : mn;
        }, -Infinity);
    }
    /************************************
        Numeral Prototype
    ************************************/ numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            return formatNumeral(this, inputString ? inputString : options.defaultFormat, roundingFunction !== undefined ? roundingFunction : Math.round);
        },
        unformat: function(inputString) {
            if (Object.prototype.toString.call(inputString) === '[object Number]') return inputString;
            return unformatNumeral(this, inputString ? inputString : options.defaultFormat);
        },
        value: function() {
            return this._value;
        },
        valueOf: function() {
            return this._value;
        },
        set: function(value) {
            this._value = Number(value);
            return this;
        },
        add: function(value) {
            var corrFactor = correctionFactor.call(null, this._value, value);
            function cback(accum, curr, currI, O) {
                return accum + corrFactor * curr;
            }
            this._value = [
                this._value,
                value
            ].reduce(cback, 0) / corrFactor;
            return this;
        },
        subtract: function(value) {
            var corrFactor = correctionFactor.call(null, this._value, value);
            function cback(accum, curr, currI, O) {
                return accum - corrFactor * curr;
            }
            this._value = [
                value
            ].reduce(cback, this._value * corrFactor) / corrFactor;
            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = correctionFactor(accum, curr);
                return accum * corrFactor * (curr * corrFactor) / (corrFactor * corrFactor);
            }
            this._value = [
                this._value,
                value
            ].reduce(cback, 1);
            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = correctionFactor(accum, curr);
                return accum * corrFactor / (curr * corrFactor);
            }
            this._value = [
                this._value,
                value
            ].reduce(cback);
            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };
    /************************************
        Exposing Numeral
    ************************************/ // CommonJS module is defined
    if (module.exports) module.exports = numeral;
    /*global ender:false */ if (typeof ender === 'undefined') // here, `this` means `window` in the browser, or `global` on the server
    // add `numeral` as a global object via a string identifier,
    // for Closure Compiler 'advanced' mode
    this['numeral'] = numeral;
    /*global define:false */ if (typeof define === 'function' && define.amd) define([], function() {
        return numeral;
    });
}).call(this);

},{}],"kZZiZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function stringifiable(obj) {
    // Safely stringify Object.create(null)
    /* istanbul ignore next */ return typeof obj === 'object' && !('toString' in obj) ? Object.prototype.toString.call(obj).slice(8, -1) : obj;
}
var isProduction = false;
function invariant(condition, message) {
    if (!condition) {
        /* istanbul ignore next */ if (isProduction) throw new Error('Invariant failed');
        throw new Error(message());
    }
}
exports.invariant = invariant;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var splice = Array.prototype.splice;
var toString = Object.prototype.toString;
function type(obj) {
    return toString.call(obj).slice(8, -1);
}
var assign = Object.assign || /* istanbul ignore next */ function(target, source) {
    getAllKeys(source).forEach(function(key) {
        if (hasOwnProperty.call(source, key)) target[key] = source[key];
    });
    return target;
};
var getAllKeys = typeof Object.getOwnPropertySymbols === 'function' ? function(obj) {
    return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj));
} : function(obj) {
    return Object.keys(obj);
};
function copy(object) {
    return Array.isArray(object) ? assign(object.constructor(object.length), object) : type(object) === 'Map' ? new Map(object) : type(object) === 'Set' ? new Set(object) : object && typeof object === 'object' ? assign(Object.create(Object.getPrototypeOf(object)), object) : object;
}
var Context = /** @class */ function() {
    function Context() {
        this.commands = assign({}, defaultCommands);
        this.update = this.update.bind(this);
        // Deprecated: update.extend, update.isEquals and update.newContext
        this.update.extend = this.extend = this.extend.bind(this);
        this.update.isEquals = function(x, y) {
            return x === y;
        };
        this.update.newContext = function() {
            return new Context().update;
        };
    }
    Object.defineProperty(Context.prototype, "isEquals", {
        get: function() {
            return this.update.isEquals;
        },
        set: function(value) {
            this.update.isEquals = value;
        },
        enumerable: true,
        configurable: true
    });
    Context.prototype.extend = function(directive, fn) {
        this.commands[directive] = fn;
    };
    Context.prototype.update = function(object, $spec) {
        var _this = this;
        var spec = typeof $spec === 'function' ? {
            $apply: $spec
        } : $spec;
        if (!(Array.isArray(object) && Array.isArray(spec))) invariant(!Array.isArray(spec), function() {
            return "update(): You provided an invalid spec to update(). The spec may not contain an array except as the value of $set, $push, $unshift, $splice or any custom command allowing an array value.";
        });
        invariant(typeof spec === 'object' && spec !== null, function() {
            return "update(): You provided an invalid spec to update(). The spec and every included key path must be plain objects containing one of the " + ("following commands: " + Object.keys(_this.commands).join(', ') + ".");
        });
        var nextObject = object;
        getAllKeys(spec).forEach(function(key) {
            if (hasOwnProperty.call(_this.commands, key)) {
                var objectWasNextObject = object === nextObject;
                nextObject = _this.commands[key](spec[key], nextObject, spec, object);
                if (objectWasNextObject && _this.isEquals(nextObject, object)) nextObject = object;
            } else {
                var nextValueForKey = type(object) === 'Map' ? _this.update(object.get(key), spec[key]) : _this.update(object[key], spec[key]);
                var nextObjectValue = type(nextObject) === 'Map' ? nextObject.get(key) : nextObject[key];
                if (!_this.isEquals(nextValueForKey, nextObjectValue) || typeof nextValueForKey === 'undefined' && !hasOwnProperty.call(object, key)) {
                    if (nextObject === object) nextObject = copy(object);
                    if (type(nextObject) === 'Map') nextObject.set(key, nextValueForKey);
                    else nextObject[key] = nextValueForKey;
                }
            }
        });
        return nextObject;
    };
    return Context;
}();
exports.Context = Context;
var defaultCommands = {
    $push: function(value, nextObject, spec) {
        invariantPushAndUnshift(nextObject, spec, '$push');
        return value.length ? nextObject.concat(value) : nextObject;
    },
    $unshift: function(value, nextObject, spec) {
        invariantPushAndUnshift(nextObject, spec, '$unshift');
        return value.length ? value.concat(nextObject) : nextObject;
    },
    $splice: function(value, nextObject, spec, originalObject) {
        invariantSplices(nextObject, spec);
        value.forEach(function(args) {
            invariantSplice(args);
            if (nextObject === originalObject && args.length) nextObject = copy(originalObject);
            splice.apply(nextObject, args);
        });
        return nextObject;
    },
    $set: function(value, _nextObject, spec) {
        invariantSet(spec);
        return value;
    },
    $toggle: function(targets, nextObject) {
        invariantSpecArray(targets, '$toggle');
        var nextObjectCopy = targets.length ? copy(nextObject) : nextObject;
        targets.forEach(function(target) {
            nextObjectCopy[target] = !nextObject[target];
        });
        return nextObjectCopy;
    },
    $unset: function(value, nextObject, _spec, originalObject) {
        invariantSpecArray(value, '$unset');
        value.forEach(function(key) {
            if (Object.hasOwnProperty.call(nextObject, key)) {
                if (nextObject === originalObject) nextObject = copy(originalObject);
                delete nextObject[key];
            }
        });
        return nextObject;
    },
    $add: function(values, nextObject, _spec, originalObject) {
        invariantMapOrSet(nextObject, '$add');
        invariantSpecArray(values, '$add');
        if (type(nextObject) === 'Map') values.forEach(function(_a) {
            var key = _a[0], value = _a[1];
            if (nextObject === originalObject && nextObject.get(key) !== value) nextObject = copy(originalObject);
            nextObject.set(key, value);
        });
        else values.forEach(function(value) {
            if (nextObject === originalObject && !nextObject.has(value)) nextObject = copy(originalObject);
            nextObject.add(value);
        });
        return nextObject;
    },
    $remove: function(value, nextObject, _spec, originalObject) {
        invariantMapOrSet(nextObject, '$remove');
        invariantSpecArray(value, '$remove');
        value.forEach(function(key) {
            if (nextObject === originalObject && nextObject.has(key)) nextObject = copy(originalObject);
            nextObject.delete(key);
        });
        return nextObject;
    },
    $merge: function(value, nextObject, _spec, originalObject) {
        invariantMerge(nextObject, value);
        getAllKeys(value).forEach(function(key) {
            if (value[key] !== nextObject[key]) {
                if (nextObject === originalObject) nextObject = copy(originalObject);
                nextObject[key] = value[key];
            }
        });
        return nextObject;
    },
    $apply: function(value, original) {
        invariantApply(value);
        return value(original);
    }
};
var defaultContext = new Context();
exports.isEquals = defaultContext.update.isEquals;
exports.extend = defaultContext.extend;
exports.default = defaultContext.update;
// @ts-ignore
exports.default.default = module.exports = assign(exports.default, exports);
// invariants
function invariantPushAndUnshift(value, spec, command) {
    invariant(Array.isArray(value), function() {
        return "update(): expected target of " + stringifiable(command) + " to be an array; got " + stringifiable(value) + ".";
    });
    invariantSpecArray(spec[command], command);
}
function invariantSpecArray(spec, command) {
    invariant(Array.isArray(spec), function() {
        return "update(): expected spec of " + stringifiable(command) + " to be an array; got " + stringifiable(spec) + ". " + "Did you forget to wrap your parameter in an array?";
    });
}
function invariantSplices(value, spec) {
    invariant(Array.isArray(value), function() {
        return "Expected $splice target to be an array; got " + stringifiable(value);
    });
    invariantSplice(spec.$splice);
}
function invariantSplice(value) {
    invariant(Array.isArray(value), function() {
        return "update(): expected spec of $splice to be an array of arrays; got " + stringifiable(value) + ". " + "Did you forget to wrap your parameters in an array?";
    });
}
function invariantApply(fn) {
    invariant(typeof fn === 'function', function() {
        return "update(): expected spec of $apply to be a function; got " + stringifiable(fn) + ".";
    });
}
function invariantSet(spec) {
    invariant(Object.keys(spec).length === 1, function() {
        return "Cannot have more than one key in an object with $set";
    });
}
function invariantMerge(target, specValue) {
    invariant(specValue && typeof specValue === 'object', function() {
        return "update(): $merge expects a spec of type 'object'; got " + stringifiable(specValue);
    });
    invariant(target && typeof target === 'object', function() {
        return "update(): $merge expects a target of type 'object'; got " + stringifiable(target);
    });
}
function invariantMapOrSet(target, command) {
    var typeOfTarget = type(target);
    invariant(typeOfTarget === 'Map' || typeOfTarget === 'Set', function() {
        return "update(): " + stringifiable(command) + " expects a target of type Set or Map; got " + stringifiable(typeOfTarget);
    });
}

},{}],"1w5VY":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _DragDropContext = require("81862199f56dda99");
Object.defineProperty(exports, 'DragDropContext', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_DragDropContext).default;
    }
});
var _DragDropContextProvider = require("606cb06ce713b4f8");
Object.defineProperty(exports, 'DragDropContextProvider', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_DragDropContextProvider).default;
    }
});
var _DragLayer = require("269643f60090cac4");
Object.defineProperty(exports, 'DragLayer', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_DragLayer).default;
    }
});
var _DragSource = require("db4a3b542150bc3");
Object.defineProperty(exports, 'DragSource', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_DragSource).default;
    }
});
var _DropTarget = require("d50d1c3dea3277c1");
Object.defineProperty(exports, 'DropTarget', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_DropTarget).default;
    }
});
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

},{"81862199f56dda99":"3he9r","606cb06ce713b4f8":"aGl4n","269643f60090cac4":"b8Q5g","db4a3b542150bc3":"hLSIQ","d50d1c3dea3277c1":"eVo6m"}],"3he9r":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.unpackBackendForEs5Users = exports.createChildContext = exports.CHILD_CONTEXT_TYPES = undefined;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
exports.default = DragDropContext;
var _react = require("14fe3e01bbf0974f");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("9fdd982a434d6e65");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _dndCore = require("8f03ac49819e8f35");
var _invariant = require("fb17ef489d1e85bb");
var _invariant2 = _interopRequireDefault(_invariant);
var _hoistNonReactStatics = require("8e77db817bebcb81");
var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
var _checkDecoratorArguments = require("22655af7af5df331");
var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var CHILD_CONTEXT_TYPES = exports.CHILD_CONTEXT_TYPES = {
    dragDropManager: _propTypes2.default.object.isRequired
};
var createChildContext = exports.createChildContext = function createChildContext(backend, context) {
    return {
        dragDropManager: new _dndCore.DragDropManager(backend, context)
    };
};
var unpackBackendForEs5Users = exports.unpackBackendForEs5Users = function unpackBackendForEs5Users(backendOrModule) {
    // Auto-detect ES6 default export for people still using ES5
    var backend = backendOrModule;
    if ((typeof backend === 'undefined' ? 'undefined' : _typeof(backend)) === 'object' && typeof backend.default === 'function') backend = backend.default;
    (0, _invariant2.default)(typeof backend === 'function', "Expected the backend to be a function or an ES6 module exporting a default function. Read more: http://react-dnd.github.io/react-dnd/docs-drag-drop-context.html");
    return backend;
};
function DragDropContext(backendOrModule) {
    _checkDecoratorArguments2.default.apply(undefined, [
        'DragDropContext',
        'backend'
    ].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
    var backend = unpackBackendForEs5Users(backendOrModule);
    var childContext = createChildContext(backend);
    return function decorateContext(DecoratedComponent) {
        var _class, _temp;
        var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
        var DragDropContextContainer = (_temp = _class = function(_Component) {
            _inherits(DragDropContextContainer, _Component);
            function DragDropContextContainer() {
                _classCallCheck(this, DragDropContextContainer);
                return _possibleConstructorReturn(this, (DragDropContextContainer.__proto__ || Object.getPrototypeOf(DragDropContextContainer)).apply(this, arguments));
            }
            _createClass(DragDropContextContainer, [
                {
                    key: 'getDecoratedComponentInstance',
                    value: function getDecoratedComponentInstance() {
                        (0, _invariant2.default)(this.child, 'In order to access an instance of the decorated component it can not be a stateless component.');
                        return this.child;
                    }
                },
                {
                    key: 'getManager',
                    value: function getManager() {
                        return childContext.dragDropManager;
                    }
                },
                {
                    key: 'getChildContext',
                    value: function getChildContext() {
                        return childContext;
                    }
                },
                {
                    key: 'render',
                    value: function render() {
                        var _this2 = this;
                        return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, {
                            ref: function ref(child) {
                                _this2.child = child;
                            }
                        }));
                    }
                }
            ]);
            return DragDropContextContainer;
        }(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = 'DragDropContext(' + displayName + ')', _class.childContextTypes = CHILD_CONTEXT_TYPES, _temp);
        return (0, _hoistNonReactStatics2.default)(DragDropContextContainer, DecoratedComponent);
    };
}

},{"14fe3e01bbf0974f":"bmhQu","9fdd982a434d6e65":"gLXGb","8f03ac49819e8f35":"fzpmg","fb17ef489d1e85bb":"3cETI","8e77db817bebcb81":"7MfVA","22655af7af5df331":"1yKlN"}],"fzpmg":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _DragDropManager = require("d5e52d2e76dcc604");
Object.defineProperty(exports, 'DragDropManager', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_DragDropManager).default;
    }
});
var _DragSource = require("4a2cd96b77b18ad1");
Object.defineProperty(exports, 'DragSource', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_DragSource).default;
    }
});
var _DropTarget = require("6d3a8a93566e597e");
Object.defineProperty(exports, 'DropTarget', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_DropTarget).default;
    }
});
var _createTestBackend = require("595608bb4e235d0b");
Object.defineProperty(exports, 'createTestBackend', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_createTestBackend).default;
    }
});
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

},{"d5e52d2e76dcc604":"dM09Q","4a2cd96b77b18ad1":"KMRCV","6d3a8a93566e597e":"coZAw","595608bb4e235d0b":"cOjZH"}],"dM09Q":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _createStore = require("8092405c658c34ed");
var _createStore2 = _interopRequireDefault(_createStore);
var _reducers = require("98e8fb4bf902bf9");
var _reducers2 = _interopRequireDefault(_reducers);
var _dragDrop = require("dca2bf4cee5e8041");
var dragDropActions = _interopRequireWildcard(_dragDrop);
var _DragDropMonitor = require("71289c98f2321139");
var _DragDropMonitor2 = _interopRequireDefault(_DragDropMonitor);
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var DragDropManager = function() {
    function DragDropManager(createBackend) {
        var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        _classCallCheck(this, DragDropManager);
        var store = (0, _createStore2.default)(_reducers2.default);
        this.context = context;
        this.store = store;
        this.monitor = new _DragDropMonitor2.default(store);
        this.registry = this.monitor.registry;
        this.backend = createBackend(this);
        store.subscribe(this.handleRefCountChange.bind(this));
    }
    _createClass(DragDropManager, [
        {
            key: 'handleRefCountChange',
            value: function handleRefCountChange() {
                var shouldSetUp = this.store.getState().refCount > 0;
                if (shouldSetUp && !this.isSetUp) {
                    this.backend.setup();
                    this.isSetUp = true;
                } else if (!shouldSetUp && this.isSetUp) {
                    this.backend.teardown();
                    this.isSetUp = false;
                }
            }
        },
        {
            key: 'getContext',
            value: function getContext() {
                return this.context;
            }
        },
        {
            key: 'getMonitor',
            value: function getMonitor() {
                return this.monitor;
            }
        },
        {
            key: 'getBackend',
            value: function getBackend() {
                return this.backend;
            }
        },
        {
            key: 'getRegistry',
            value: function getRegistry() {
                return this.registry;
            }
        },
        {
            key: 'getActions',
            value: function getActions() {
                var manager = this;
                var dispatch = this.store.dispatch;
                function bindActionCreator(actionCreator) {
                    return function() {
                        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        var action = actionCreator.apply(manager, args);
                        if (typeof action !== 'undefined') dispatch(action);
                    };
                }
                return Object.keys(dragDropActions).filter(function(key) {
                    return typeof dragDropActions[key] === 'function';
                }).reduce(function(boundActions, key) {
                    var action = dragDropActions[key];
                    boundActions[key] = bindActionCreator(action); // eslint-disable-line no-param-reassign
                    return boundActions;
                }, {});
            }
        }
    ]);
    return DragDropManager;
}();
exports.default = DragDropManager;

},{"8092405c658c34ed":"9eFal","98e8fb4bf902bf9":"45A7O","dca2bf4cee5e8041":"a7XL4","71289c98f2321139":"gblyO"}],"9eFal":[function(require,module,exports,__globalThis) {
'use strict';
exports.__esModule = true;
exports.ActionTypes = undefined;
exports['default'] = createStore;
var _isPlainObject = require("fa322ced0162cef");
var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
var _symbolObservable = require("1deb0c103205c407");
var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var ActionTypes = exports.ActionTypes = {
    INIT: '@@redux/INIT'
};
function createStore(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error('Expected the enhancer to be a function.');
        return enhancer(createStore)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error('Expected the reducer to be a function.');
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error('Expected listener to be a function.');
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!(0, _isPlainObject2['default'])(action)) throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
        if (typeof action.type === 'undefined') throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
        if (isDispatching) throw new Error('Reducers may not dispatch actions.');
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error('Expected the nextReducer to be a function.');
        currentReducer = nextReducer;
        dispatch({
            type: ActionTypes.INIT
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object') throw new TypeError('Expected the observer to be an object.');
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[_symbolObservable2['default']] = function() {
            return this;
        }, _ref;
    }
    // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: ActionTypes.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[_symbolObservable2['default']] = observable, _ref2;
}

},{"fa322ced0162cef":"55i2R","1deb0c103205c407":"kokpv"}],"55i2R":[function(require,module,exports,__globalThis) {
var baseGetTag = require("c03dd41ed9922dd2"), getPrototype = require("2ca5b85a120835de"), isObjectLike = require("963b65e043435612");
/** `Object#toString` result references. */ var objectTag = '[object Object]';
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
module.exports = isPlainObject;

},{"c03dd41ed9922dd2":"7W5wu","2ca5b85a120835de":"jqLMp","963b65e043435612":"anjMx"}],"jqLMp":[function(require,module,exports,__globalThis) {
var overArg = require("11c2fcc01fbb2119");
/** Built-in value references. */ var getPrototype = overArg(Object.getPrototypeOf, Object);
module.exports = getPrototype;

},{"11c2fcc01fbb2119":"acc6S"}],"kokpv":[function(require,module,exports,__globalThis) {
/* global window */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ponyfillJs = require("./ponyfill.js");
var _ponyfillJsDefault = parcelHelpers.interopDefault(_ponyfillJs);
var global = arguments[3];
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof global !== 'undefined') root = global;
else root = module;
var result = (0, _ponyfillJsDefault.default)(root);
exports.default = result;

},{"./ponyfill.js":"4f4y3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4f4y3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>symbolObservablePonyfill);
function symbolObservablePonyfill(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol('observable');
            Symbol.observable = result;
        }
    } else result = '@@observable';
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"45A7O":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = reduce;
var _dragOffset = require("da371b224ac1444b");
var _dragOffset2 = _interopRequireDefault(_dragOffset);
var _dragOperation = require("54e76f5d2787cf4e");
var _dragOperation2 = _interopRequireDefault(_dragOperation);
var _refCount = require("45a3de1fb3c518c9");
var _refCount2 = _interopRequireDefault(_refCount);
var _dirtyHandlerIds = require("bb292ac39aa4a82b");
var _dirtyHandlerIds2 = _interopRequireDefault(_dirtyHandlerIds);
var _stateId = require("886769117053b22c");
var _stateId2 = _interopRequireDefault(_stateId);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function reduce() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];
    return {
        dirtyHandlerIds: (0, _dirtyHandlerIds2.default)(state.dirtyHandlerIds, action, state.dragOperation),
        dragOffset: (0, _dragOffset2.default)(state.dragOffset, action),
        refCount: (0, _refCount2.default)(state.refCount, action),
        dragOperation: (0, _dragOperation2.default)(state.dragOperation, action),
        stateId: (0, _stateId2.default)(state.stateId)
    };
}

},{"da371b224ac1444b":"jA3Lc","54e76f5d2787cf4e":"hrF1R","45a3de1fb3c518c9":"lYlfk","bb292ac39aa4a82b":"hWDQs","886769117053b22c":"4XXvq"}],"jA3Lc":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
exports.default = dragOffset;
exports.getSourceClientOffset = getSourceClientOffset;
exports.getDifferenceFromInitialOffset = getDifferenceFromInitialOffset;
var _dragDrop = require("5fff33bbb7e9baaa");
var initialState = {
    initialSourceClientOffset: null,
    initialClientOffset: null,
    clientOffset: null
};
function areOffsetsEqual(offsetA, offsetB) {
    if (offsetA === offsetB) return true;
    return offsetA && offsetB && offsetA.x === offsetB.x && offsetA.y === offsetB.y;
}
function dragOffset() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];
    switch(action.type){
        case _dragDrop.BEGIN_DRAG:
            return {
                initialSourceClientOffset: action.sourceClientOffset,
                initialClientOffset: action.clientOffset,
                clientOffset: action.clientOffset
            };
        case _dragDrop.HOVER:
            if (areOffsetsEqual(state.clientOffset, action.clientOffset)) return state;
            return _extends({}, state, {
                clientOffset: action.clientOffset
            });
        case _dragDrop.END_DRAG:
        case _dragDrop.DROP:
            return initialState;
        default:
            return state;
    }
}
function getSourceClientOffset(state) {
    var clientOffset = state.clientOffset, initialClientOffset = state.initialClientOffset, initialSourceClientOffset = state.initialSourceClientOffset;
    if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) return null;
    return {
        x: clientOffset.x + initialSourceClientOffset.x - initialClientOffset.x,
        y: clientOffset.y + initialSourceClientOffset.y - initialClientOffset.y
    };
}
function getDifferenceFromInitialOffset(state) {
    var clientOffset = state.clientOffset, initialClientOffset = state.initialClientOffset;
    if (!clientOffset || !initialClientOffset) return null;
    return {
        x: clientOffset.x - initialClientOffset.x,
        y: clientOffset.y - initialClientOffset.y
    };
}

},{"5fff33bbb7e9baaa":"a7XL4"}],"a7XL4":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.END_DRAG = exports.DROP = exports.HOVER = exports.PUBLISH_DRAG_SOURCE = exports.BEGIN_DRAG = undefined;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
exports.beginDrag = beginDrag;
exports.publishDragSource = publishDragSource;
exports.hover = hover;
exports.drop = drop;
exports.endDrag = endDrag;
var _invariant = require("9fcb34614cc2e2c3");
var _invariant2 = _interopRequireDefault(_invariant);
var _isArray = require("bb9afd67eba73a59");
var _isArray2 = _interopRequireDefault(_isArray);
var _isObject = require("7f1d289ad2937f4");
var _isObject2 = _interopRequireDefault(_isObject);
var _matchesType = require("91436d2c2e48885b");
var _matchesType2 = _interopRequireDefault(_matchesType);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var BEGIN_DRAG = exports.BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
var PUBLISH_DRAG_SOURCE = exports.PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
var HOVER = exports.HOVER = 'dnd-core/HOVER';
var DROP = exports.DROP = 'dnd-core/DROP';
var END_DRAG = exports.END_DRAG = 'dnd-core/END_DRAG';
function beginDrag(sourceIds) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        publishSource: true,
        clientOffset: null
    };
    var publishSource = options.publishSource, clientOffset = options.clientOffset, getSourceClientOffset = options.getSourceClientOffset;
    (0, _invariant2.default)((0, _isArray2.default)(sourceIds), 'Expected sourceIds to be an array.');
    var monitor = this.getMonitor();
    var registry = this.getRegistry();
    (0, _invariant2.default)(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');
    for(var i = 0; i < sourceIds.length; i++)(0, _invariant2.default)(registry.getSource(sourceIds[i]), 'Expected sourceIds to be registered.');
    var sourceId = null;
    for(var _i = sourceIds.length - 1; _i >= 0; _i--)if (monitor.canDragSource(sourceIds[_i])) {
        sourceId = sourceIds[_i];
        break;
    }
    if (sourceId === null) return;
    var sourceClientOffset = null;
    if (clientOffset) {
        (0, _invariant2.default)(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
        sourceClientOffset = getSourceClientOffset(sourceId);
    }
    var source = registry.getSource(sourceId);
    var item = source.beginDrag(monitor, sourceId);
    (0, _invariant2.default)((0, _isObject2.default)(item), 'Item must be an object.');
    registry.pinSource(sourceId);
    var itemType = registry.getSourceType(sourceId);
    return {
        type: BEGIN_DRAG,
        itemType: itemType,
        item: item,
        sourceId: sourceId,
        clientOffset: clientOffset,
        sourceClientOffset: sourceClientOffset,
        isSourcePublic: publishSource
    };
}
function publishDragSource() {
    var monitor = this.getMonitor();
    if (!monitor.isDragging()) return;
    return {
        type: PUBLISH_DRAG_SOURCE
    };
}
function hover(targetIdsArg) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$clientOffset = _ref.clientOffset, clientOffset = _ref$clientOffset === undefined ? null : _ref$clientOffset;
    (0, _invariant2.default)((0, _isArray2.default)(targetIdsArg), 'Expected targetIds to be an array.');
    var targetIds = targetIdsArg.slice(0);
    var monitor = this.getMonitor();
    var registry = this.getRegistry();
    (0, _invariant2.default)(monitor.isDragging(), 'Cannot call hover while not dragging.');
    (0, _invariant2.default)(!monitor.didDrop(), 'Cannot call hover after drop.');
    // First check invariants.
    for(var i = 0; i < targetIds.length; i++){
        var targetId = targetIds[i];
        (0, _invariant2.default)(targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');
        var target = registry.getTarget(targetId);
        (0, _invariant2.default)(target, 'Expected targetIds to be registered.');
    }
    var draggedItemType = monitor.getItemType();
    // Remove those targetIds that don't match the targetType.  This
    // fixes shallow isOver which would only be non-shallow because of
    // non-matching targets.
    for(var _i2 = targetIds.length - 1; _i2 >= 0; _i2--){
        var _targetId = targetIds[_i2];
        var targetType = registry.getTargetType(_targetId);
        if (!(0, _matchesType2.default)(targetType, draggedItemType)) targetIds.splice(_i2, 1);
    }
    // Finally call hover on all matching targets.
    for(var _i3 = 0; _i3 < targetIds.length; _i3++){
        var _targetId2 = targetIds[_i3];
        var _target = registry.getTarget(_targetId2);
        _target.hover(monitor, _targetId2);
    }
    return {
        type: HOVER,
        targetIds: targetIds,
        clientOffset: clientOffset
    };
}
function drop() {
    var _this = this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var monitor = this.getMonitor();
    var registry = this.getRegistry();
    (0, _invariant2.default)(monitor.isDragging(), 'Cannot call drop while not dragging.');
    (0, _invariant2.default)(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');
    var targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
    targetIds.reverse();
    targetIds.forEach(function(targetId, index) {
        var target = registry.getTarget(targetId);
        var dropResult = target.drop(monitor, targetId);
        (0, _invariant2.default)(typeof dropResult === 'undefined' || (0, _isObject2.default)(dropResult), 'Drop result must either be an object or undefined.');
        if (typeof dropResult === 'undefined') dropResult = index === 0 ? {} : monitor.getDropResult();
        _this.store.dispatch({
            type: DROP,
            dropResult: _extends({}, options, dropResult)
        });
    });
}
function endDrag() {
    var monitor = this.getMonitor();
    var registry = this.getRegistry();
    (0, _invariant2.default)(monitor.isDragging(), 'Cannot call endDrag while not dragging.');
    var sourceId = monitor.getSourceId();
    var source = registry.getSource(sourceId, true);
    source.endDrag(monitor, sourceId);
    registry.unpinSource();
    return {
        type: END_DRAG
    };
}

},{"9fcb34614cc2e2c3":"3cETI","bb9afd67eba73a59":"bCmB4","7f1d289ad2937f4":"b5XR2","91436d2c2e48885b":"1VTYe"}],"1VTYe":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = matchesType;
var _isArray = require("8bbc5fdba3182a2f");
var _isArray2 = _interopRequireDefault(_isArray);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function matchesType(targetType, draggedItemType) {
    if ((0, _isArray2.default)(targetType)) return targetType.some(function(t) {
        return t === draggedItemType;
    });
    else return targetType === draggedItemType;
}

},{"8bbc5fdba3182a2f":"bCmB4"}],"hrF1R":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
exports.default = dragOperation;
var _without = require("c1018505fe422249");
var _without2 = _interopRequireDefault(_without);
var _dragDrop = require("e249dc52c376374");
var _registry = require("9a43aa7dd32fa66");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var initialState = {
    itemType: null,
    item: null,
    sourceId: null,
    targetIds: [],
    dropResult: null,
    didDrop: false,
    isSourcePublic: null
};
function dragOperation() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];
    switch(action.type){
        case _dragDrop.BEGIN_DRAG:
            return _extends({}, state, {
                itemType: action.itemType,
                item: action.item,
                sourceId: action.sourceId,
                isSourcePublic: action.isSourcePublic,
                dropResult: null,
                didDrop: false
            });
        case _dragDrop.PUBLISH_DRAG_SOURCE:
            return _extends({}, state, {
                isSourcePublic: true
            });
        case _dragDrop.HOVER:
            return _extends({}, state, {
                targetIds: action.targetIds
            });
        case _registry.REMOVE_TARGET:
            if (state.targetIds.indexOf(action.targetId) === -1) return state;
            return _extends({}, state, {
                targetIds: (0, _without2.default)(state.targetIds, action.targetId)
            });
        case _dragDrop.DROP:
            return _extends({}, state, {
                dropResult: action.dropResult,
                didDrop: true,
                targetIds: []
            });
        case _dragDrop.END_DRAG:
            return _extends({}, state, {
                itemType: null,
                item: null,
                sourceId: null,
                dropResult: null,
                didDrop: false,
                isSourcePublic: null,
                targetIds: []
            });
        default:
            return state;
    }
}

},{"c1018505fe422249":"krQcN","e249dc52c376374":"a7XL4","9a43aa7dd32fa66":"84dMc"}],"krQcN":[function(require,module,exports,__globalThis) {
var baseDifference = require("4db0cb250ff88e72"), baseRest = require("b2f01aa6851573dc"), isArrayLikeObject = require("15809c5e06486880");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var without = baseRest(function(array, values) {
    return isArrayLikeObject(array) ? baseDifference(array, values) : [];
});
module.exports = without;

},{"4db0cb250ff88e72":"gaC8y","b2f01aa6851573dc":"1fVZL","15809c5e06486880":"6vQ3T"}],"84dMc":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addSource = addSource;
exports.addTarget = addTarget;
exports.removeSource = removeSource;
exports.removeTarget = removeTarget;
var ADD_SOURCE = exports.ADD_SOURCE = 'dnd-core/ADD_SOURCE';
var ADD_TARGET = exports.ADD_TARGET = 'dnd-core/ADD_TARGET';
var REMOVE_SOURCE = exports.REMOVE_SOURCE = 'dnd-core/REMOVE_SOURCE';
var REMOVE_TARGET = exports.REMOVE_TARGET = 'dnd-core/REMOVE_TARGET';
function addSource(sourceId) {
    return {
        type: ADD_SOURCE,
        sourceId: sourceId
    };
}
function addTarget(targetId) {
    return {
        type: ADD_TARGET,
        targetId: targetId
    };
}
function removeSource(sourceId) {
    return {
        type: REMOVE_SOURCE,
        sourceId: sourceId
    };
}
function removeTarget(targetId) {
    return {
        type: REMOVE_TARGET,
        targetId: targetId
    };
}

},{}],"lYlfk":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = refCount;
var _registry = require("51c3642d6ffbd0fa");
function refCount() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var action = arguments[1];
    switch(action.type){
        case _registry.ADD_SOURCE:
        case _registry.ADD_TARGET:
            return state + 1;
        case _registry.REMOVE_SOURCE:
        case _registry.REMOVE_TARGET:
            return state - 1;
        default:
            return state;
    }
}

},{"51c3642d6ffbd0fa":"84dMc"}],"hWDQs":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = dirtyHandlerIds;
exports.areDirty = areDirty;
var _xor = require("c116f0c0a2f63637");
var _xor2 = _interopRequireDefault(_xor);
var _intersection = require("4a6112cc205355ee");
var _intersection2 = _interopRequireDefault(_intersection);
var _dragDrop = require("283dacf65a272f14");
var _registry = require("53925589d5072646");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var NONE = [];
var ALL = [];
function dirtyHandlerIds() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NONE;
    var action = arguments[1];
    var dragOperation = arguments[2];
    switch(action.type){
        case _dragDrop.HOVER:
            break;
        case _registry.ADD_SOURCE:
        case _registry.ADD_TARGET:
        case _registry.REMOVE_TARGET:
        case _registry.REMOVE_SOURCE:
            return NONE;
        case _dragDrop.BEGIN_DRAG:
        case _dragDrop.PUBLISH_DRAG_SOURCE:
        case _dragDrop.END_DRAG:
        case _dragDrop.DROP:
        default:
            return ALL;
    }
    var targetIds = action.targetIds;
    var prevTargetIds = dragOperation.targetIds;
    var result = (0, _xor2.default)(targetIds, prevTargetIds);
    var didChange = false;
    if (result.length === 0) {
        for(var i = 0; i < targetIds.length; i++)if (targetIds[i] !== prevTargetIds[i]) {
            didChange = true;
            break;
        }
    } else didChange = true;
    if (!didChange) return NONE;
    var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
    var innermostTargetId = targetIds[targetIds.length - 1];
    if (prevInnermostTargetId !== innermostTargetId) {
        if (prevInnermostTargetId) result.push(prevInnermostTargetId);
        if (innermostTargetId) result.push(innermostTargetId);
    }
    return result;
}
function areDirty(state, handlerIds) {
    if (state === NONE) return false;
    if (state === ALL || typeof handlerIds === 'undefined') return true;
    return (0, _intersection2.default)(handlerIds, state).length > 0;
}

},{"c116f0c0a2f63637":"3l4am","4a6112cc205355ee":"5GWRZ","283dacf65a272f14":"a7XL4","53925589d5072646":"84dMc"}],"5GWRZ":[function(require,module,exports,__globalThis) {
var arrayMap = require("6a250a20b4b08a64"), baseIntersection = require("a82701bebbafe8d6"), baseRest = require("a4c4fe36b8bc714c"), castArrayLikeObject = require("a81a4617d84f59b5");
/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */ var intersection = baseRest(function(arrays) {
    var mapped = arrayMap(arrays, castArrayLikeObject);
    return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
});
module.exports = intersection;

},{"6a250a20b4b08a64":"eDg3z","a82701bebbafe8d6":"602CR","a4c4fe36b8bc714c":"1fVZL","a81a4617d84f59b5":"hYaIa"}],"602CR":[function(require,module,exports,__globalThis) {
var SetCache = require("7070c945ceea62ce"), arrayIncludes = require("ea93e7f7041da225"), arrayIncludesWith = require("95ac92fc6b845c29"), arrayMap = require("96e97fb8c1f62c2a"), baseUnary = require("cfcf6ce49738e1b2"), cacheHas = require("27c425d77edc5a7b");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */ function baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
    while(othIndex--){
        var array = arrays[othIndex];
        if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer: while(++index < length && result.length < maxLength){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while(--othIndex){
                var cache = caches[othIndex];
                if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
            }
            if (seen) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = baseIntersection;

},{"7070c945ceea62ce":"eYiqn","ea93e7f7041da225":"DgrAw","95ac92fc6b845c29":"3VKLq","96e97fb8c1f62c2a":"eDg3z","cfcf6ce49738e1b2":"infZD","27c425d77edc5a7b":"9fAC8"}],"hYaIa":[function(require,module,exports,__globalThis) {
var isArrayLikeObject = require("36f79b126a48f510");
/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */ function castArrayLikeObject(value) {
    return isArrayLikeObject(value) ? value : [];
}
module.exports = castArrayLikeObject;

},{"36f79b126a48f510":"6vQ3T"}],"4XXvq":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = stateId;
function stateId() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return state + 1;
}

},{}],"gblyO":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _invariant = require("71d1d33f57295683");
var _invariant2 = _interopRequireDefault(_invariant);
var _isArray = require("fbd52c81d636ba2d");
var _isArray2 = _interopRequireDefault(_isArray);
var _matchesType = require("8a57972afb532eb3");
var _matchesType2 = _interopRequireDefault(_matchesType);
var _HandlerRegistry = require("a30f56567c7a6138");
var _HandlerRegistry2 = _interopRequireDefault(_HandlerRegistry);
var _dragOffset = require("c4eeb5bb161bd5fb");
var _dirtyHandlerIds = require("5bc760d3b3d4a0f9");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var DragDropMonitor = function() {
    function DragDropMonitor(store) {
        _classCallCheck(this, DragDropMonitor);
        this.store = store;
        this.registry = new _HandlerRegistry2.default(store);
    }
    _createClass(DragDropMonitor, [
        {
            key: 'subscribeToStateChange',
            value: function subscribeToStateChange(listener) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var handlerIds = options.handlerIds;
                (0, _invariant2.default)(typeof listener === 'function', 'listener must be a function.');
                (0, _invariant2.default)(typeof handlerIds === 'undefined' || (0, _isArray2.default)(handlerIds), 'handlerIds, when specified, must be an array of strings.');
                var prevStateId = this.store.getState().stateId;
                var handleChange = function handleChange() {
                    var state = _this.store.getState();
                    var currentStateId = state.stateId;
                    try {
                        var canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !(0, _dirtyHandlerIds.areDirty)(state.dirtyHandlerIds, handlerIds);
                        if (!canSkipListener) listener();
                    } finally{
                        prevStateId = currentStateId;
                    }
                };
                return this.store.subscribe(handleChange);
            }
        },
        {
            key: 'subscribeToOffsetChange',
            value: function subscribeToOffsetChange(listener) {
                var _this2 = this;
                (0, _invariant2.default)(typeof listener === 'function', 'listener must be a function.');
                var previousState = this.store.getState().dragOffset;
                var handleChange = function handleChange() {
                    var nextState = _this2.store.getState().dragOffset;
                    if (nextState === previousState) return;
                    previousState = nextState;
                    listener();
                };
                return this.store.subscribe(handleChange);
            }
        },
        {
            key: 'canDragSource',
            value: function canDragSource(sourceId) {
                var source = this.registry.getSource(sourceId);
                (0, _invariant2.default)(source, 'Expected to find a valid source.');
                if (this.isDragging()) return false;
                return source.canDrag(this, sourceId);
            }
        },
        {
            key: 'canDropOnTarget',
            value: function canDropOnTarget(targetId) {
                var target = this.registry.getTarget(targetId);
                (0, _invariant2.default)(target, 'Expected to find a valid target.');
                if (!this.isDragging() || this.didDrop()) return false;
                var targetType = this.registry.getTargetType(targetId);
                var draggedItemType = this.getItemType();
                return (0, _matchesType2.default)(targetType, draggedItemType) && target.canDrop(this, targetId);
            }
        },
        {
            key: 'isDragging',
            value: function isDragging() {
                return Boolean(this.getItemType());
            }
        },
        {
            key: 'isDraggingSource',
            value: function isDraggingSource(sourceId) {
                var source = this.registry.getSource(sourceId, true);
                (0, _invariant2.default)(source, 'Expected to find a valid source.');
                if (!this.isDragging() || !this.isSourcePublic()) return false;
                var sourceType = this.registry.getSourceType(sourceId);
                var draggedItemType = this.getItemType();
                if (sourceType !== draggedItemType) return false;
                return source.isDragging(this, sourceId);
            }
        },
        {
            key: 'isOverTarget',
            value: function isOverTarget(targetId) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    shallow: false
                };
                var shallow = options.shallow;
                if (!this.isDragging()) return false;
                var targetType = this.registry.getTargetType(targetId);
                var draggedItemType = this.getItemType();
                if (!(0, _matchesType2.default)(targetType, draggedItemType)) return false;
                var targetIds = this.getTargetIds();
                if (!targetIds.length) return false;
                var index = targetIds.indexOf(targetId);
                if (shallow) return index === targetIds.length - 1;
                else return index > -1;
            }
        },
        {
            key: 'getItemType',
            value: function getItemType() {
                return this.store.getState().dragOperation.itemType;
            }
        },
        {
            key: 'getItem',
            value: function getItem() {
                return this.store.getState().dragOperation.item;
            }
        },
        {
            key: 'getSourceId',
            value: function getSourceId() {
                return this.store.getState().dragOperation.sourceId;
            }
        },
        {
            key: 'getTargetIds',
            value: function getTargetIds() {
                return this.store.getState().dragOperation.targetIds;
            }
        },
        {
            key: 'getDropResult',
            value: function getDropResult() {
                return this.store.getState().dragOperation.dropResult;
            }
        },
        {
            key: 'didDrop',
            value: function didDrop() {
                return this.store.getState().dragOperation.didDrop;
            }
        },
        {
            key: 'isSourcePublic',
            value: function isSourcePublic() {
                return this.store.getState().dragOperation.isSourcePublic;
            }
        },
        {
            key: 'getInitialClientOffset',
            value: function getInitialClientOffset() {
                return this.store.getState().dragOffset.initialClientOffset;
            }
        },
        {
            key: 'getInitialSourceClientOffset',
            value: function getInitialSourceClientOffset() {
                return this.store.getState().dragOffset.initialSourceClientOffset;
            }
        },
        {
            key: 'getClientOffset',
            value: function getClientOffset() {
                return this.store.getState().dragOffset.clientOffset;
            }
        },
        {
            key: 'getSourceClientOffset',
            value: function getSourceClientOffset() {
                return (0, _dragOffset.getSourceClientOffset)(this.store.getState().dragOffset);
            }
        },
        {
            key: 'getDifferenceFromInitialOffset',
            value: function getDifferenceFromInitialOffset() {
                return (0, _dragOffset.getDifferenceFromInitialOffset)(this.store.getState().dragOffset);
            }
        }
    ]);
    return DragDropMonitor;
}();
exports.default = DragDropMonitor;

},{"71d1d33f57295683":"3cETI","fbd52c81d636ba2d":"bCmB4","8a57972afb532eb3":"1VTYe","a30f56567c7a6138":"d6pbE","c4eeb5bb161bd5fb":"jA3Lc","5bc760d3b3d4a0f9":"hWDQs"}],"d6pbE":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var _invariant = require("af0e05b127cf6d4");
var _invariant2 = _interopRequireDefault(_invariant);
var _isArray = require("ed2891615c7fe339");
var _isArray2 = _interopRequireDefault(_isArray);
var _asap = require("ffe8b19b965958a6");
var _asap2 = _interopRequireDefault(_asap);
var _registry = require("9d3d3b1bd5821c4a");
var _getNextUniqueId = require("26bfa390f0ffd75a");
var _getNextUniqueId2 = _interopRequireDefault(_getNextUniqueId);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var HandlerRoles = {
    SOURCE: 'SOURCE',
    TARGET: 'TARGET'
};
function validateSourceContract(source) {
    (0, _invariant2.default)(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
    (0, _invariant2.default)(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
    (0, _invariant2.default)(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
}
function validateTargetContract(target) {
    (0, _invariant2.default)(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
    (0, _invariant2.default)(typeof target.hover === 'function', 'Expected hover to be a function.');
    (0, _invariant2.default)(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
}
function validateType(type, allowArray) {
    if (allowArray && (0, _isArray2.default)(type)) {
        type.forEach(function(t) {
            return validateType(t, false);
        });
        return;
    }
    (0, _invariant2.default)(typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
}
function getNextHandlerId(role) {
    var id = (0, _getNextUniqueId2.default)().toString();
    switch(role){
        case HandlerRoles.SOURCE:
            return 'S' + id;
        case HandlerRoles.TARGET:
            return 'T' + id;
        default:
            (0, _invariant2.default)(false, 'Unknown role: ' + role);
    }
}
function parseRoleFromHandlerId(handlerId) {
    switch(handlerId[0]){
        case 'S':
            return HandlerRoles.SOURCE;
        case 'T':
            return HandlerRoles.TARGET;
        default:
            (0, _invariant2.default)(false, 'Cannot parse handler ID: ' + handlerId);
    }
}
var HandlerRegistry = function() {
    function HandlerRegistry(store) {
        _classCallCheck(this, HandlerRegistry);
        this.store = store;
        this.types = {};
        this.handlers = {};
        this.pinnedSourceId = null;
        this.pinnedSource = null;
    }
    _createClass(HandlerRegistry, [
        {
            key: 'addSource',
            value: function addSource(type, source) {
                validateType(type);
                validateSourceContract(source);
                var sourceId = this.addHandler(HandlerRoles.SOURCE, type, source);
                this.store.dispatch((0, _registry.addSource)(sourceId));
                return sourceId;
            }
        },
        {
            key: 'addTarget',
            value: function addTarget(type, target) {
                validateType(type, true);
                validateTargetContract(target);
                var targetId = this.addHandler(HandlerRoles.TARGET, type, target);
                this.store.dispatch((0, _registry.addTarget)(targetId));
                return targetId;
            }
        },
        {
            key: 'addHandler',
            value: function addHandler(role, type, handler) {
                var id = getNextHandlerId(role);
                this.types[id] = type;
                this.handlers[id] = handler;
                return id;
            }
        },
        {
            key: 'containsHandler',
            value: function containsHandler(handler) {
                var _this = this;
                return Object.keys(this.handlers).some(function(key) {
                    return _this.handlers[key] === handler;
                });
            }
        },
        {
            key: 'getSource',
            value: function getSource(sourceId, includePinned) {
                (0, _invariant2.default)(this.isSourceId(sourceId), 'Expected a valid source ID.');
                var isPinned = includePinned && sourceId === this.pinnedSourceId;
                var source = isPinned ? this.pinnedSource : this.handlers[sourceId];
                return source;
            }
        },
        {
            key: 'getTarget',
            value: function getTarget(targetId) {
                (0, _invariant2.default)(this.isTargetId(targetId), 'Expected a valid target ID.');
                return this.handlers[targetId];
            }
        },
        {
            key: 'getSourceType',
            value: function getSourceType(sourceId) {
                (0, _invariant2.default)(this.isSourceId(sourceId), 'Expected a valid source ID.');
                return this.types[sourceId];
            }
        },
        {
            key: 'getTargetType',
            value: function getTargetType(targetId) {
                (0, _invariant2.default)(this.isTargetId(targetId), 'Expected a valid target ID.');
                return this.types[targetId];
            }
        },
        {
            key: 'isSourceId',
            value: function isSourceId(handlerId) {
                var role = parseRoleFromHandlerId(handlerId);
                return role === HandlerRoles.SOURCE;
            }
        },
        {
            key: 'isTargetId',
            value: function isTargetId(handlerId) {
                var role = parseRoleFromHandlerId(handlerId);
                return role === HandlerRoles.TARGET;
            }
        },
        {
            key: 'removeSource',
            value: function removeSource(sourceId) {
                var _this2 = this;
                (0, _invariant2.default)(this.getSource(sourceId), 'Expected an existing source.');
                this.store.dispatch((0, _registry.removeSource)(sourceId));
                (0, _asap2.default)(function() {
                    delete _this2.handlers[sourceId];
                    delete _this2.types[sourceId];
                });
            }
        },
        {
            key: 'removeTarget',
            value: function removeTarget(targetId) {
                var _this3 = this;
                (0, _invariant2.default)(this.getTarget(targetId), 'Expected an existing target.');
                this.store.dispatch((0, _registry.removeTarget)(targetId));
                (0, _asap2.default)(function() {
                    delete _this3.handlers[targetId];
                    delete _this3.types[targetId];
                });
            }
        },
        {
            key: 'pinSource',
            value: function pinSource(sourceId) {
                var source = this.getSource(sourceId);
                (0, _invariant2.default)(source, 'Expected an existing source.');
                this.pinnedSourceId = sourceId;
                this.pinnedSource = source;
            }
        },
        {
            key: 'unpinSource',
            value: function unpinSource() {
                (0, _invariant2.default)(this.pinnedSource, 'No source is pinned at the time.');
                this.pinnedSourceId = null;
                this.pinnedSource = null;
            }
        }
    ]);
    return HandlerRegistry;
}();
exports.default = HandlerRegistry;

},{"af0e05b127cf6d4":"3cETI","ed2891615c7fe339":"bCmB4","ffe8b19b965958a6":"cRoFH","9d3d3b1bd5821c4a":"84dMc","26bfa390f0ffd75a":"ii2vL"}],"cRoFH":[function(require,module,exports,__globalThis) {
"use strict";
// rawAsap provides everything we need except exception management.
var rawAsap = require("f2d0a4216b139c85");
// RawTasks are recycled to reduce GC churn.
var freeTasks = [];
// We queue errors to ensure they are thrown in right order (FIFO).
// Array-as-queue is good enough here, since we are just dealing with exceptions.
var pendingErrors = [];
var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);
function throwFirstError() {
    if (pendingErrors.length) throw pendingErrors.shift();
}
/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */ module.exports = asap;
function asap(task) {
    var rawTask;
    if (freeTasks.length) rawTask = freeTasks.pop();
    else rawTask = new RawTask();
    rawTask.task = task;
    rawAsap(rawTask);
}
// We wrap tasks with recyclable task objects.  A task object implements
// `call`, just like a function.
function RawTask() {
    this.task = null;
}
// The sole purpose of wrapping the task is to catch the exception and recycle
// the task object after its single use.
RawTask.prototype.call = function() {
    try {
        this.task.call();
    } catch (error) {
        if (asap.onerror) // This hook exists purely for testing purposes.
        // Its name will be periodically randomized to break any code that
        // depends on its existence.
        asap.onerror(error);
        else {
            // In a web browser, exceptions are not fatal. However, to avoid
            // slowing down the queue of pending tasks, we rethrow the error in a
            // lower priority turn.
            pendingErrors.push(error);
            requestErrorThrow();
        }
    } finally{
        this.task = null;
        freeTasks[freeTasks.length] = this;
    }
};

},{"f2d0a4216b139c85":"9f7vI"}],"9f7vI":[function(require,module,exports,__globalThis) {
var global = arguments[3];
"use strict";
// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}
var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;
// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while(index < queue.length){
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for(var scan = 0, newLength = queue.length - index; scan < newLength; scan++)queue[scan] = queue[scan + index];
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}
// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
/* globals self */ var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") requestFlush = makeRequestCallFromMutationObserver(flush);
else requestFlush = makeRequestCallFromTimer(flush);
// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;
// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {
        characterData: true
    });
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}
// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html
// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.
// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }
// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.
// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }
// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.
// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.
function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);
        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}
// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer; // ASAP was originally a nextTick shim included in Q. This was factored out
 // into this ASAP package. It was later adapted to RSVP which made further
 // amendments. These decisions, particularly to marginalize MessageChannel and
 // to capture the MutationObserver implementation in a closure, were integrated
 // back into ASAP proper.
 // https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

},{}],"ii2vL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getNextUniqueId;
var nextUniqueId = 0;
function getNextUniqueId() {
    return nextUniqueId++;
}

},{}],"KMRCV":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var DragSource = function() {
    function DragSource() {
        _classCallCheck(this, DragSource);
    }
    _createClass(DragSource, [
        {
            key: "canDrag",
            value: function canDrag() {
                return true;
            }
        },
        {
            key: "isDragging",
            value: function isDragging(monitor, handle) {
                return handle === monitor.getSourceId();
            }
        },
        {
            key: "endDrag",
            value: function endDrag() {}
        }
    ]);
    return DragSource;
}();
exports.default = DragSource;

},{}],"coZAw":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var DropTarget = function() {
    function DropTarget() {
        _classCallCheck(this, DropTarget);
    }
    _createClass(DropTarget, [
        {
            key: "canDrop",
            value: function canDrop() {
                return true;
            }
        },
        {
            key: "hover",
            value: function hover() {}
        },
        {
            key: "drop",
            value: function drop() {}
        }
    ]);
    return DropTarget;
}();
exports.default = DropTarget;

},{}],"cOjZH":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
exports.default = createBackend;
var _noop = require("da0dd919fa184557");
var _noop2 = _interopRequireDefault(_noop);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var TestBackend = function() {
    function TestBackend(manager) {
        _classCallCheck(this, TestBackend);
        this.actions = manager.getActions();
    }
    _createClass(TestBackend, [
        {
            key: 'setup',
            value: function setup() {
                this.didCallSetup = true;
            }
        },
        {
            key: 'teardown',
            value: function teardown() {
                this.didCallTeardown = true;
            }
        },
        {
            key: 'connectDragSource',
            value: function connectDragSource() {
                return _noop2.default;
            }
        },
        {
            key: 'connectDragPreview',
            value: function connectDragPreview() {
                return _noop2.default;
            }
        },
        {
            key: 'connectDropTarget',
            value: function connectDropTarget() {
                return _noop2.default;
            }
        },
        {
            key: 'simulateBeginDrag',
            value: function simulateBeginDrag(sourceIds, options) {
                this.actions.beginDrag(sourceIds, options);
            }
        },
        {
            key: 'simulatePublishDragSource',
            value: function simulatePublishDragSource() {
                this.actions.publishDragSource();
            }
        },
        {
            key: 'simulateHover',
            value: function simulateHover(targetIds, options) {
                this.actions.hover(targetIds, options);
            }
        },
        {
            key: 'simulateDrop',
            value: function simulateDrop() {
                this.actions.drop();
            }
        },
        {
            key: 'simulateEndDrag',
            value: function simulateEndDrag() {
                this.actions.endDrag();
            }
        }
    ]);
    return TestBackend;
}();
function createBackend(manager) {
    return new TestBackend(manager);
}

},{"da0dd919fa184557":"gtREm"}],"7MfVA":[function(require,module,exports,__globalThis) {
'use strict';
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
        return targetComponent;
    }
    return targetComponent;
}
module.exports = hoistNonReactStatics;

},{}],"1yKlN":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = checkDecoratorArguments;
function checkDecoratorArguments(functionName, signature) {
    var i, arg;
}

},{}],"aGl4n":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _class, _temp;
var _react = require("d10b3d2c42e1d67e");
var _propTypes = require("5628e46b0f1ba163");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _DragDropContext = require("ac793bf363f5ace2");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * This class is a React-Component based version of the DragDropContext.
 * This is an alternative to decorating an application component with an ES7 decorator.
 */ var DragDropContextProvider = (_temp = _class = function(_Component) {
    _inherits(DragDropContextProvider, _Component);
    function DragDropContextProvider(props, context) {
        _classCallCheck(this, DragDropContextProvider);
        /**
   * This property determines which window global to use for creating the DragDropManager.
   * If a window has been injected explicitly via props, that is used first. If it is available
   * as a context value, then use that, otherwise use the browser global.
   */ var _this = _possibleConstructorReturn(this, (DragDropContextProvider.__proto__ || Object.getPrototypeOf(DragDropContextProvider)).call(this, props, context));
        var getWindow = function getWindow() {
            if (props && props.window) return props.window;
            else if (context && context.window) return context.window;
            else if (typeof window !== 'undefined') return window;
            return undefined;
        };
        _this.backend = (0, _DragDropContext.unpackBackendForEs5Users)(props.backend);
        _this.childContext = (0, _DragDropContext.createChildContext)(_this.backend, {
            window: getWindow()
        });
        return _this;
    }
    _createClass(DragDropContextProvider, [
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if (nextProps.backend !== this.props.backend || nextProps.window !== this.props.window) throw new Error('DragDropContextProvider backend and window props must not change.');
            }
        },
        {
            key: 'getChildContext',
            value: function getChildContext() {
                return this.childContext;
            }
        },
        {
            key: 'render',
            value: function render() {
                return _react.Children.only(this.props.children);
            }
        }
    ]);
    return DragDropContextProvider;
}(_react.Component), _class.propTypes = {
    backend: _propTypes2.default.oneOfType([
        _propTypes2.default.func,
        _propTypes2.default.object
    ]).isRequired,
    children: _propTypes2.default.element.isRequired,
    window: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
}, _class.defaultProps = {
    window: undefined
}, _class.childContextTypes = _DragDropContext.CHILD_CONTEXT_TYPES, _class.displayName = 'DragDropContextProvider', _class.contextTypes = {
    window: _propTypes2.default.object
}, _temp);
exports.default = DragDropContextProvider;

},{"d10b3d2c42e1d67e":"bmhQu","5628e46b0f1ba163":"gLXGb","ac793bf363f5ace2":"3he9r"}],"b8Q5g":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
exports.default = DragLayer;
var _react = require("98900b32052f96c6");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("9673d1cd986480ef");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _hoistNonReactStatics = require("1679ffbe632323f6");
var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
var _isPlainObject = require("35a98ceb841b56a7");
var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
var _invariant = require("ad1456c6dc5bd3b");
var _invariant2 = _interopRequireDefault(_invariant);
var _shallowEqual = require("134c3e1face0b8be");
var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
var _shallowEqualScalar = require("38a60509d51582a5");
var _shallowEqualScalar2 = _interopRequireDefault(_shallowEqualScalar);
var _checkDecoratorArguments = require("151e64a7d6e555f3");
var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function DragLayer(collect) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _checkDecoratorArguments2.default.apply(undefined, [
        'DragLayer',
        'collect[, options]'
    ].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
    (0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the first argument to DragLayer to be a function that collects props to inject into the component. ', 'Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', collect);
    (0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the second argument to DragLayer to be a plain object when specified. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', options);
    return function decorateLayer(DecoratedComponent) {
        var _class, _temp;
        var _options$arePropsEqua = options.arePropsEqual, arePropsEqual = _options$arePropsEqua === undefined ? _shallowEqualScalar2.default : _options$arePropsEqua;
        var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
        var DragLayerContainer = (_temp = _class = function(_Component) {
            _inherits(DragLayerContainer, _Component);
            _createClass(DragLayerContainer, [
                {
                    key: 'getDecoratedComponentInstance',
                    value: function getDecoratedComponentInstance() {
                        (0, _invariant2.default)(this.child, 'In order to access an instance of the decorated component it can not be a stateless component.');
                        return this.child;
                    }
                },
                {
                    key: 'shouldComponentUpdate',
                    value: function shouldComponentUpdate(nextProps, nextState) {
                        return !arePropsEqual(nextProps, this.props) || !(0, _shallowEqual2.default)(nextState, this.state);
                    }
                }
            ]);
            function DragLayerContainer(props, context) {
                _classCallCheck(this, DragLayerContainer);
                var _this = _possibleConstructorReturn(this, (DragLayerContainer.__proto__ || Object.getPrototypeOf(DragLayerContainer)).call(this, props));
                _this.handleChange = _this.handleChange.bind(_this);
                _this.manager = context.dragDropManager;
                (0, _invariant2.default)(_typeof(_this.manager) === 'object', "Could not find the drag and drop manager in the context of %s. Make sure to wrap the top-level component of your app with DragDropContext. Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context", displayName, displayName);
                _this.state = _this.getCurrentState();
                return _this;
            }
            _createClass(DragLayerContainer, [
                {
                    key: 'componentDidMount',
                    value: function componentDidMount() {
                        this.isCurrentlyMounted = true;
                        var monitor = this.manager.getMonitor();
                        this.unsubscribeFromOffsetChange = monitor.subscribeToOffsetChange(this.handleChange);
                        this.unsubscribeFromStateChange = monitor.subscribeToStateChange(this.handleChange);
                        this.handleChange();
                    }
                },
                {
                    key: 'componentWillUnmount',
                    value: function componentWillUnmount() {
                        this.isCurrentlyMounted = false;
                        this.unsubscribeFromOffsetChange();
                        this.unsubscribeFromStateChange();
                    }
                },
                {
                    key: 'handleChange',
                    value: function handleChange() {
                        if (!this.isCurrentlyMounted) return;
                        var nextState = this.getCurrentState();
                        if (!(0, _shallowEqual2.default)(nextState, this.state)) this.setState(nextState);
                    }
                },
                {
                    key: 'getCurrentState',
                    value: function getCurrentState() {
                        var monitor = this.manager.getMonitor();
                        return collect(monitor, this.props);
                    }
                },
                {
                    key: 'render',
                    value: function render() {
                        var _this2 = this;
                        return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, this.state, {
                            ref: function ref(child) {
                                _this2.child = child;
                            }
                        }));
                    }
                }
            ]);
            return DragLayerContainer;
        }(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = 'DragLayer(' + displayName + ')', _class.contextTypes = {
            dragDropManager: _propTypes2.default.object.isRequired
        }, _temp);
        return (0, _hoistNonReactStatics2.default)(DragLayerContainer, DecoratedComponent);
    };
}

},{"98900b32052f96c6":"bmhQu","9673d1cd986480ef":"gLXGb","1679ffbe632323f6":"7MfVA","35a98ceb841b56a7":"55i2R","ad1456c6dc5bd3b":"3cETI","134c3e1face0b8be":"aI2wA","38a60509d51582a5":"7pm23","151e64a7d6e555f3":"1yKlN"}],"aI2wA":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = shallowEqual;
function shallowEqual(objA, objB) {
    if (objA === objB) return true;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    var hasOwn = Object.prototype.hasOwnProperty;
    for(var i = 0; i < keysA.length; i += 1){
        if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
        var valA = objA[keysA[i]];
        var valB = objB[keysA[i]];
        if (valA !== valB) return false;
    }
    return true;
}

},{}],"7pm23":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
exports.default = shallowEqualScalar;
function shallowEqualScalar(objA, objB) {
    if (objA === objB) return true;
    if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    var hasOwn = Object.prototype.hasOwnProperty;
    for(var i = 0; i < keysA.length; i += 1){
        if (!hasOwn.call(objB, keysA[i])) return false;
        var valA = objA[keysA[i]];
        var valB = objB[keysA[i]];
        if (valA !== valB || (typeof valA === 'undefined' ? 'undefined' : _typeof(valA)) === 'object' || (typeof valB === 'undefined' ? 'undefined' : _typeof(valB)) === 'object') return false;
    }
    return true;
}

},{}],"hLSIQ":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = DragSource;
var _invariant = require("25a3eb1ed0fa812a");
var _invariant2 = _interopRequireDefault(_invariant);
var _isPlainObject = require("313acc5047bd283");
var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
var _checkDecoratorArguments = require("b91b0e29d1bcd50e");
var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
var _decorateHandler = require("dcfc16301269cab4");
var _decorateHandler2 = _interopRequireDefault(_decorateHandler);
var _registerSource = require("1df638a868cc5c20");
var _registerSource2 = _interopRequireDefault(_registerSource);
var _createSourceFactory = require("346e8954f4047272");
var _createSourceFactory2 = _interopRequireDefault(_createSourceFactory);
var _createSourceMonitor = require("4d71c659d1dd4659");
var _createSourceMonitor2 = _interopRequireDefault(_createSourceMonitor);
var _createSourceConnector = require("ff6e5f4be33744f8");
var _createSourceConnector2 = _interopRequireDefault(_createSourceConnector);
var _isValidType = require("2168c696fc7654e2");
var _isValidType2 = _interopRequireDefault(_isValidType);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function DragSource(type, spec, collect) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    _checkDecoratorArguments2.default.apply(undefined, [
        'DragSource',
        'type, spec, collect[, options]'
    ].concat(Array.prototype.slice.call(arguments)));
    var getType = type;
    if (typeof type !== 'function') {
        (0, _invariant2.default)((0, _isValidType2.default)(type), 'Expected "type" provided as the first argument to DragSource to be a string, or a function that returns a string given the current props. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', type);
        getType = function getType() {
            return type;
        };
    }
    (0, _invariant2.default)((0, _isPlainObject2.default)(spec), 'Expected "spec" provided as the second argument to DragSource to be a plain object. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', spec);
    var createSource = (0, _createSourceFactory2.default)(spec);
    (0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DragSource to be a function that returns a plain object of props to inject. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);
    (0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the fourth argument to DragSource to be a plain object when specified. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);
    return function decorateSource(DecoratedComponent) {
        return (0, _decorateHandler2.default)({
            connectBackend: function connectBackend(backend, sourceId) {
                return backend.connectDragSource(sourceId);
            },
            containerDisplayName: 'DragSource',
            createHandler: createSource,
            registerHandler: _registerSource2.default,
            createMonitor: _createSourceMonitor2.default,
            createConnector: _createSourceConnector2.default,
            DecoratedComponent: DecoratedComponent,
            getType: getType,
            collect: collect,
            options: options
        });
    };
}

},{"25a3eb1ed0fa812a":"3cETI","313acc5047bd283":"55i2R","b91b0e29d1bcd50e":"1yKlN","dcfc16301269cab4":"bvhqv","1df638a868cc5c20":"lcZbJ","346e8954f4047272":"dT0WS","4d71c659d1dd4659":"nvMr6","ff6e5f4be33744f8":"kbT4K","2168c696fc7654e2":"al675"}],"bvhqv":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
exports.default = decorateHandler;
var _react = require("4a82db99d0370708");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("ac4682d19149e448");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _disposables = require("140c6e7fd247c731");
var _isPlainObject = require("4cb98de1182145ca");
var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
var _invariant = require("a68582010e7c259b");
var _invariant2 = _interopRequireDefault(_invariant);
var _hoistNonReactStatics = require("8f94459684b309da");
var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
var _shallowEqual = require("75bb0ffacb47b3bb");
var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
var _shallowEqualScalar = require("ec111773725cc871");
var _shallowEqualScalar2 = _interopRequireDefault(_shallowEqualScalar);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var isClassComponent = function isClassComponent(Comp) {
    return Boolean(Comp && Comp.prototype && typeof Comp.prototype.render === 'function');
};
function decorateHandler(_ref) {
    var _class, _temp;
    var DecoratedComponent = _ref.DecoratedComponent, createHandler = _ref.createHandler, createMonitor = _ref.createMonitor, createConnector = _ref.createConnector, registerHandler = _ref.registerHandler, containerDisplayName = _ref.containerDisplayName, getType = _ref.getType, collect = _ref.collect, options = _ref.options;
    var _options$arePropsEqua = options.arePropsEqual, arePropsEqual = _options$arePropsEqua === undefined ? _shallowEqualScalar2.default : _options$arePropsEqua;
    var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
    var DragDropContainer = (_temp = _class = function(_Component) {
        _inherits(DragDropContainer, _Component);
        _createClass(DragDropContainer, [
            {
                key: 'getHandlerId',
                value: function getHandlerId() {
                    return this.handlerId;
                }
            },
            {
                key: 'getDecoratedComponentInstance',
                value: function getDecoratedComponentInstance() {
                    return this.decoratedComponentInstance;
                }
            },
            {
                key: 'shouldComponentUpdate',
                value: function shouldComponentUpdate(nextProps, nextState) {
                    return !arePropsEqual(nextProps, this.props) || !(0, _shallowEqual2.default)(nextState, this.state);
                }
            }
        ]);
        function DragDropContainer(props, context) {
            _classCallCheck(this, DragDropContainer);
            var _this = _possibleConstructorReturn(this, (DragDropContainer.__proto__ || Object.getPrototypeOf(DragDropContainer)).call(this, props, context));
            _this.handleChange = _this.handleChange.bind(_this);
            _this.handleChildRef = _this.handleChildRef.bind(_this);
            (0, _invariant2.default)(_typeof(_this.context.dragDropManager) === 'object', "Could not find the drag and drop manager in the context of %s. Make sure to wrap the top-level component of your app with DragDropContext. Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context", displayName, displayName);
            _this.manager = _this.context.dragDropManager;
            _this.handlerMonitor = createMonitor(_this.manager);
            _this.handlerConnector = createConnector(_this.manager.getBackend());
            _this.handler = createHandler(_this.handlerMonitor);
            _this.disposable = new _disposables.SerialDisposable();
            _this.receiveProps(props);
            _this.state = _this.getCurrentState();
            _this.dispose();
            return _this;
        }
        _createClass(DragDropContainer, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.isCurrentlyMounted = true;
                    this.disposable = new _disposables.SerialDisposable();
                    this.currentType = null;
                    this.receiveProps(this.props);
                    this.handleChange();
                }
            },
            {
                key: 'componentWillReceiveProps',
                value: function componentWillReceiveProps(nextProps) {
                    if (!arePropsEqual(nextProps, this.props)) {
                        this.receiveProps(nextProps);
                        this.handleChange();
                    }
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.dispose();
                    this.isCurrentlyMounted = false;
                }
            },
            {
                key: 'receiveProps',
                value: function receiveProps(props) {
                    this.handler.receiveProps(props);
                    this.receiveType(getType(props));
                }
            },
            {
                key: 'receiveType',
                value: function receiveType(type) {
                    if (type === this.currentType) return;
                    this.currentType = type;
                    var _registerHandler = registerHandler(type, this.handler, this.manager), handlerId = _registerHandler.handlerId, unregister = _registerHandler.unregister;
                    this.handlerId = handlerId;
                    this.handlerMonitor.receiveHandlerId(handlerId);
                    this.handlerConnector.receiveHandlerId(handlerId);
                    var globalMonitor = this.manager.getMonitor();
                    var unsubscribe = globalMonitor.subscribeToStateChange(this.handleChange, {
                        handlerIds: [
                            handlerId
                        ]
                    });
                    this.disposable.setDisposable(new _disposables.CompositeDisposable(new _disposables.Disposable(unsubscribe), new _disposables.Disposable(unregister)));
                }
            },
            {
                key: 'handleChange',
                value: function handleChange() {
                    if (!this.isCurrentlyMounted) return;
                    var nextState = this.getCurrentState();
                    if (!(0, _shallowEqual2.default)(nextState, this.state)) this.setState(nextState);
                }
            },
            {
                key: 'dispose',
                value: function dispose() {
                    this.disposable.dispose();
                    this.handlerConnector.receiveHandlerId(null);
                }
            },
            {
                key: 'handleChildRef',
                value: function handleChildRef(component) {
                    this.decoratedComponentInstance = component;
                    this.handler.receiveComponent(component);
                }
            },
            {
                key: 'getCurrentState',
                value: function getCurrentState() {
                    var nextState = collect(this.handlerConnector.hooks, this.handlerMonitor);
                    return nextState;
                }
            },
            {
                key: 'render',
                value: function render() {
                    return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, this.state, {
                        ref: isClassComponent(DecoratedComponent) ? this.handleChildRef : null
                    }));
                }
            }
        ]);
        return DragDropContainer;
    }(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = containerDisplayName + '(' + displayName + ')', _class.contextTypes = {
        dragDropManager: _propTypes2.default.object.isRequired
    }, _temp);
    return (0, _hoistNonReactStatics2.default)(DragDropContainer, DecoratedComponent);
}

},{"4a82db99d0370708":"bmhQu","ac4682d19149e448":"gLXGb","140c6e7fd247c731":"5KxHX","4cb98de1182145ca":"55i2R","a68582010e7c259b":"3cETI","8f94459684b309da":"7MfVA","75bb0ffacb47b3bb":"aI2wA","ec111773725cc871":"7pm23"}],"5KxHX":[function(require,module,exports,__globalThis) {
'use strict';
exports.__esModule = true;
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var _isDisposable2 = require("688ac77d500334bf");
var _isDisposable3 = _interopRequireDefault(_isDisposable2);
exports.isDisposable = _isDisposable3['default'];
var _Disposable2 = require("958cb9be7499b41a");
var _Disposable3 = _interopRequireDefault(_Disposable2);
exports.Disposable = _Disposable3['default'];
var _CompositeDisposable2 = require("d744769dc7fa1daf");
var _CompositeDisposable3 = _interopRequireDefault(_CompositeDisposable2);
exports.CompositeDisposable = _CompositeDisposable3['default'];
var _SerialDisposable2 = require("70c8d0a2f7267216");
var _SerialDisposable3 = _interopRequireDefault(_SerialDisposable2);
exports.SerialDisposable = _SerialDisposable3['default'];

},{"688ac77d500334bf":"eYIBl","958cb9be7499b41a":"3Tf0V","d744769dc7fa1daf":"lPJTe","70c8d0a2f7267216":"dFnmT"}],"eYIBl":[function(require,module,exports,__globalThis) {
'use strict';
exports.__esModule = true;
exports['default'] = isDisposable;
function isDisposable(obj) {
    return Boolean(obj && typeof obj.dispose === 'function');
}
module.exports = exports['default'];

},{}],"3Tf0V":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var noop = function noop() {};
/**
 * The basic disposable.
 */ var Disposable = function() {
    _createClass(Disposable, null, [
        {
            key: "empty",
            value: {
                dispose: noop
            },
            enumerable: true
        }
    ]);
    function Disposable(action) {
        _classCallCheck(this, Disposable);
        this.isDisposed = false;
        this.action = action || noop;
    }
    Disposable.prototype.dispose = function dispose() {
        if (!this.isDisposed) {
            this.action.call(null);
            this.isDisposed = true;
        }
    };
    return Disposable;
}();
exports["default"] = Disposable;
module.exports = exports["default"];

},{}],"lPJTe":[function(require,module,exports,__globalThis) {
'use strict';
exports.__esModule = true;
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}
var _isDisposable = require("7afcc39e7774a090");
var _isDisposable2 = _interopRequireDefault(_isDisposable);
/**
 * Represents a group of disposable resources that are disposed together.
 */ var CompositeDisposable = function() {
    function CompositeDisposable() {
        for(var _len = arguments.length, disposables = Array(_len), _key = 0; _key < _len; _key++)disposables[_key] = arguments[_key];
        _classCallCheck(this, CompositeDisposable);
        if (Array.isArray(disposables[0]) && disposables.length === 1) disposables = disposables[0];
        for(var i = 0; i < disposables.length; i++){
            if (!_isDisposable2['default'](disposables[i])) throw new Error('Expected a disposable');
        }
        this.disposables = disposables;
        this.isDisposed = false;
    }
    /**
   * Adds a disposable to the CompositeDisposable or disposes the disposable if the CompositeDisposable is disposed.
   * @param {Disposable} item Disposable to add.
   */ CompositeDisposable.prototype.add = function add(item) {
        if (this.isDisposed) item.dispose();
        else this.disposables.push(item);
    };
    /**
   * Removes and disposes the first occurrence of a disposable from the CompositeDisposable.
   * @param {Disposable} item Disposable to remove.
   * @returns {Boolean} true if found; false otherwise.
   */ CompositeDisposable.prototype.remove = function remove(item) {
        if (this.isDisposed) return false;
        var index = this.disposables.indexOf(item);
        if (index === -1) return false;
        this.disposables.splice(index, 1);
        item.dispose();
        return true;
    };
    /**
   * Disposes all disposables in the group and removes them from the group.
   */ CompositeDisposable.prototype.dispose = function dispose() {
        if (this.isDisposed) return;
        var len = this.disposables.length;
        var currentDisposables = new Array(len);
        for(var i = 0; i < len; i++)currentDisposables[i] = this.disposables[i];
        this.isDisposed = true;
        this.disposables = [];
        this.length = 0;
        for(var i = 0; i < len; i++)currentDisposables[i].dispose();
    };
    return CompositeDisposable;
}();
exports['default'] = CompositeDisposable;
module.exports = exports['default'];

},{"7afcc39e7774a090":"eYIBl"}],"dFnmT":[function(require,module,exports,__globalThis) {
'use strict';
exports.__esModule = true;
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}
var _isDisposable = require("f13c94689df03cfb");
var _isDisposable2 = _interopRequireDefault(_isDisposable);
var SerialDisposable = function() {
    function SerialDisposable() {
        _classCallCheck(this, SerialDisposable);
        this.isDisposed = false;
        this.current = null;
    }
    /**
   * Gets the underlying disposable.
   * @return The underlying disposable.
   */ SerialDisposable.prototype.getDisposable = function getDisposable() {
        return this.current;
    };
    /**
   * Sets the underlying disposable.
   * @param {Disposable} value The new underlying disposable.
   */ SerialDisposable.prototype.setDisposable = function setDisposable() {
        var value = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
        if (value != null && !_isDisposable2['default'](value)) throw new Error('Expected either an empty value or a valid disposable');
        var isDisposed = this.isDisposed;
        var previous = undefined;
        if (!isDisposed) {
            previous = this.current;
            this.current = value;
        }
        if (previous) previous.dispose();
        if (isDisposed && value) value.dispose();
    };
    /**
   * Disposes the underlying disposable as well as all future replacements.
   */ SerialDisposable.prototype.dispose = function dispose() {
        if (this.isDisposed) return;
        this.isDisposed = true;
        var previous = this.current;
        this.current = null;
        if (previous) previous.dispose();
    };
    return SerialDisposable;
}();
exports['default'] = SerialDisposable;
module.exports = exports['default'];

},{"f13c94689df03cfb":"eYIBl"}],"lcZbJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = registerSource;
function registerSource(type, source, manager) {
    var registry = manager.getRegistry();
    var sourceId = registry.addSource(type, source);
    function unregisterSource() {
        registry.removeSource(sourceId);
    }
    return {
        handlerId: sourceId,
        unregister: unregisterSource
    };
}

},{}],"dT0WS":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
exports.default = createSourceFactory;
var _invariant = require("236e8ff8f8759844");
var _invariant2 = _interopRequireDefault(_invariant);
var _isPlainObject = require("e2b353ccfb05241b");
var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var ALLOWED_SPEC_METHODS = [
    'canDrag',
    'beginDrag',
    'isDragging',
    'endDrag'
];
var REQUIRED_SPEC_METHODS = [
    'beginDrag'
];
function createSourceFactory(spec) {
    Object.keys(spec).forEach(function(key) {
        (0, _invariant2.default)(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drag source specification to only have some of the following keys: %s. Instead received a specification with an unexpected "%s" key. Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', ALLOWED_SPEC_METHODS.join(', '), key);
        (0, _invariant2.default)(typeof spec[key] === 'function', "Expected %s in the drag source specification to be a function. Instead received a specification with %s: %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html", key, key, spec[key]);
    });
    REQUIRED_SPEC_METHODS.forEach(function(key) {
        (0, _invariant2.default)(typeof spec[key] === 'function', "Expected %s in the drag source specification to be a function. Instead received a specification with %s: %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html", key, key, spec[key]);
    });
    var Source = function() {
        function Source(monitor) {
            _classCallCheck(this, Source);
            this.monitor = monitor;
            this.props = null;
            this.component = null;
        }
        _createClass(Source, [
            {
                key: 'receiveProps',
                value: function receiveProps(props) {
                    this.props = props;
                }
            },
            {
                key: 'receiveComponent',
                value: function receiveComponent(component) {
                    this.component = component;
                }
            },
            {
                key: 'canDrag',
                value: function canDrag() {
                    if (!spec.canDrag) return true;
                    return spec.canDrag(this.props, this.monitor);
                }
            },
            {
                key: 'isDragging',
                value: function isDragging(globalMonitor, sourceId) {
                    if (!spec.isDragging) return sourceId === globalMonitor.getSourceId();
                    return spec.isDragging(this.props, this.monitor);
                }
            },
            {
                key: 'beginDrag',
                value: function beginDrag() {
                    var item = spec.beginDrag(this.props, this.monitor, this.component);
                    return item;
                }
            },
            {
                key: 'endDrag',
                value: function endDrag() {
                    if (!spec.endDrag) return;
                    spec.endDrag(this.props, this.monitor, this.component);
                }
            }
        ]);
        return Source;
    }();
    return function createSource(monitor) {
        return new Source(monitor);
    };
}

},{"236e8ff8f8759844":"3cETI","e2b353ccfb05241b":"55i2R"}],"nvMr6":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
exports.default = createSourceMonitor;
var _invariant = require("a6efeec2b7a947c");
var _invariant2 = _interopRequireDefault(_invariant);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var isCallingCanDrag = false;
var isCallingIsDragging = false;
var SourceMonitor = function() {
    function SourceMonitor(manager) {
        _classCallCheck(this, SourceMonitor);
        this.internalMonitor = manager.getMonitor();
    }
    _createClass(SourceMonitor, [
        {
            key: 'receiveHandlerId',
            value: function receiveHandlerId(sourceId) {
                this.sourceId = sourceId;
            }
        },
        {
            key: 'canDrag',
            value: function canDrag() {
                (0, _invariant2.default)(!isCallingCanDrag, "You may not call monitor.canDrag() inside your canDrag() implementation. Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html");
                try {
                    isCallingCanDrag = true;
                    return this.internalMonitor.canDragSource(this.sourceId);
                } finally{
                    isCallingCanDrag = false;
                }
            }
        },
        {
            key: 'isDragging',
            value: function isDragging() {
                (0, _invariant2.default)(!isCallingIsDragging, "You may not call monitor.isDragging() inside your isDragging() implementation. Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html");
                try {
                    isCallingIsDragging = true;
                    return this.internalMonitor.isDraggingSource(this.sourceId);
                } finally{
                    isCallingIsDragging = false;
                }
            }
        },
        {
            key: 'getItemType',
            value: function getItemType() {
                return this.internalMonitor.getItemType();
            }
        },
        {
            key: 'getItem',
            value: function getItem() {
                return this.internalMonitor.getItem();
            }
        },
        {
            key: 'getDropResult',
            value: function getDropResult() {
                return this.internalMonitor.getDropResult();
            }
        },
        {
            key: 'didDrop',
            value: function didDrop() {
                return this.internalMonitor.didDrop();
            }
        },
        {
            key: 'getInitialClientOffset',
            value: function getInitialClientOffset() {
                return this.internalMonitor.getInitialClientOffset();
            }
        },
        {
            key: 'getInitialSourceClientOffset',
            value: function getInitialSourceClientOffset() {
                return this.internalMonitor.getInitialSourceClientOffset();
            }
        },
        {
            key: 'getSourceClientOffset',
            value: function getSourceClientOffset() {
                return this.internalMonitor.getSourceClientOffset();
            }
        },
        {
            key: 'getClientOffset',
            value: function getClientOffset() {
                return this.internalMonitor.getClientOffset();
            }
        },
        {
            key: 'getDifferenceFromInitialOffset',
            value: function getDifferenceFromInitialOffset() {
                return this.internalMonitor.getDifferenceFromInitialOffset();
            }
        }
    ]);
    return SourceMonitor;
}();
function createSourceMonitor(manager) {
    return new SourceMonitor(manager);
}

},{"a6efeec2b7a947c":"3cETI"}],"kbT4K":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createSourceConnector;
var _wrapConnectorHooks = require("b6a144cd5839d3b5");
var _wrapConnectorHooks2 = _interopRequireDefault(_wrapConnectorHooks);
var _areOptionsEqual = require("730dceaa3abdfff7");
var _areOptionsEqual2 = _interopRequireDefault(_areOptionsEqual);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function createSourceConnector(backend) {
    var currentHandlerId = void 0;
    var currentDragSourceNode = void 0;
    var currentDragSourceOptions = void 0;
    var disconnectCurrentDragSource = void 0;
    var currentDragPreviewNode = void 0;
    var currentDragPreviewOptions = void 0;
    var disconnectCurrentDragPreview = void 0;
    function reconnectDragSource() {
        if (disconnectCurrentDragSource) {
            disconnectCurrentDragSource();
            disconnectCurrentDragSource = null;
        }
        if (currentHandlerId && currentDragSourceNode) disconnectCurrentDragSource = backend.connectDragSource(currentHandlerId, currentDragSourceNode, currentDragSourceOptions);
    }
    function reconnectDragPreview() {
        if (disconnectCurrentDragPreview) {
            disconnectCurrentDragPreview();
            disconnectCurrentDragPreview = null;
        }
        if (currentHandlerId && currentDragPreviewNode) disconnectCurrentDragPreview = backend.connectDragPreview(currentHandlerId, currentDragPreviewNode, currentDragPreviewOptions);
    }
    function receiveHandlerId(handlerId) {
        if (handlerId === currentHandlerId) return;
        currentHandlerId = handlerId;
        reconnectDragSource();
        reconnectDragPreview();
    }
    var hooks = (0, _wrapConnectorHooks2.default)({
        dragSource: function connectDragSource(node, options) {
            if (node === currentDragSourceNode && (0, _areOptionsEqual2.default)(options, currentDragSourceOptions)) return;
            currentDragSourceNode = node;
            currentDragSourceOptions = options;
            reconnectDragSource();
        },
        dragPreview: function connectDragPreview(node, options) {
            if (node === currentDragPreviewNode && (0, _areOptionsEqual2.default)(options, currentDragPreviewOptions)) return;
            currentDragPreviewNode = node;
            currentDragPreviewOptions = options;
            reconnectDragPreview();
        }
    });
    return {
        receiveHandlerId: receiveHandlerId,
        hooks: hooks
    };
}

},{"b6a144cd5839d3b5":"4Za7g","730dceaa3abdfff7":"2O28M"}],"4Za7g":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = wrapConnectorHooks;
var _react = require("963d603d4a82df76");
var _cloneWithRef = require("1d5ae0ce2ba51013");
var _cloneWithRef2 = _interopRequireDefault(_cloneWithRef);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function throwIfCompositeComponentElement(element) {
    // Custom components can no longer be wrapped directly in React DnD 2.0
    // so that we don't need to depend on findDOMNode() from react-dom.
    if (typeof element.type === 'string') return;
    var displayName = element.type.displayName || element.type.name || 'the component';
    throw new Error('Only native element nodes can now be passed to React DnD connectors.' + ('You can either wrap ' + displayName + ' into a <div>, or turn it into a ') + 'drag source or a drop target itself.');
}
function wrapHookToRecognizeElement(hook) {
    return function() {
        var elementOrNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        // When passed a node, call the hook straight away.
        if (!(0, _react.isValidElement)(elementOrNode)) {
            var node = elementOrNode;
            hook(node, options);
            return undefined;
        }
        // If passed a ReactElement, clone it and attach this function as a ref.
        // This helps us achieve a neat API where user doesn't even know that refs
        // are being used under the hood.
        var element = elementOrNode;
        throwIfCompositeComponentElement(element);
        // When no options are passed, use the hook directly
        var ref = options ? function(node) {
            return hook(node, options);
        } : hook;
        return (0, _cloneWithRef2.default)(element, ref);
    };
}
function wrapConnectorHooks(hooks) {
    var wrappedHooks = {};
    Object.keys(hooks).forEach(function(key) {
        var hook = hooks[key];
        var wrappedHook = wrapHookToRecognizeElement(hook);
        wrappedHooks[key] = function() {
            return wrappedHook;
        };
    });
    return wrappedHooks;
}

},{"963d603d4a82df76":"bmhQu","1d5ae0ce2ba51013":"1ZPGX"}],"1ZPGX":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = cloneWithRef;
var _invariant = require("a2b08331ec17e8de");
var _invariant2 = _interopRequireDefault(_invariant);
var _react = require("df238d91a21029d1");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function cloneWithRef(element, newRef) {
    var previousRef = element.ref;
    (0, _invariant2.default)(typeof previousRef !== 'string', "Cannot connect React DnD to an element with an existing string ref. Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. Read more: https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute");
    if (!previousRef) // When there is no ref on the element, use the new ref directly
    return (0, _react.cloneElement)(element, {
        ref: newRef
    });
    return (0, _react.cloneElement)(element, {
        ref: function ref(node) {
            newRef(node);
            if (previousRef) previousRef(node);
        }
    });
}

},{"a2b08331ec17e8de":"3cETI","df238d91a21029d1":"bmhQu"}],"2O28M":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = areOptionsEqual;
var _shallowEqual = require("ee9f45fcbf284e76");
var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function areOptionsEqual(nextOptions, currentOptions) {
    if (currentOptions === nextOptions) return true;
    return currentOptions !== null && nextOptions !== null && (0, _shallowEqual2.default)(currentOptions, nextOptions);
}

},{"ee9f45fcbf284e76":"aI2wA"}],"al675":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
exports.default = isValidType;
var _isArray = require("4d760438efe8fc96");
var _isArray2 = _interopRequireDefault(_isArray);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function isValidType(type, allowArray) {
    return typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol' || allowArray && (0, _isArray2.default)(type) && type.every(function(t) {
        return isValidType(t, false);
    });
}

},{"4d760438efe8fc96":"bCmB4"}],"eVo6m":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = DropTarget;
var _invariant = require("1a5f40e294ebfd06");
var _invariant2 = _interopRequireDefault(_invariant);
var _isPlainObject = require("66bc1be84a91e718");
var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
var _checkDecoratorArguments = require("6a1e63b99a5069af");
var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);
var _decorateHandler = require("dd7e71e822a648fd");
var _decorateHandler2 = _interopRequireDefault(_decorateHandler);
var _registerTarget = require("602bb20e35497edf");
var _registerTarget2 = _interopRequireDefault(_registerTarget);
var _createTargetFactory = require("4dcc5f5dd0f19a2a");
var _createTargetFactory2 = _interopRequireDefault(_createTargetFactory);
var _createTargetMonitor = require("e0f0c643e2537e7c");
var _createTargetMonitor2 = _interopRequireDefault(_createTargetMonitor);
var _createTargetConnector = require("b96f7336f024281b");
var _createTargetConnector2 = _interopRequireDefault(_createTargetConnector);
var _isValidType = require("5d53c7b11e627679");
var _isValidType2 = _interopRequireDefault(_isValidType);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function DropTarget(type, spec, collect) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    _checkDecoratorArguments2.default.apply(undefined, [
        'DropTarget',
        'type, spec, collect[, options]'
    ].concat(Array.prototype.slice.call(arguments)));
    var getType = type;
    if (typeof type !== 'function') {
        (0, _invariant2.default)((0, _isValidType2.default)(type, true), 'Expected "type" provided as the first argument to DropTarget to be a string, an array of strings, or a function that returns either given the current props. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', type);
        getType = function getType() {
            return type;
        };
    }
    (0, _invariant2.default)((0, _isPlainObject2.default)(spec), 'Expected "spec" provided as the second argument to DropTarget to be a plain object. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', spec);
    var createTarget = (0, _createTargetFactory2.default)(spec);
    (0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DropTarget to be a function that returns a plain object of props to inject. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);
    (0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the fourth argument to DropTarget to be a plain object when specified. Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);
    return function decorateTarget(DecoratedComponent) {
        return (0, _decorateHandler2.default)({
            connectBackend: function connectBackend(backend, targetId) {
                return backend.connectDropTarget(targetId);
            },
            containerDisplayName: 'DropTarget',
            createHandler: createTarget,
            registerHandler: _registerTarget2.default,
            createMonitor: _createTargetMonitor2.default,
            createConnector: _createTargetConnector2.default,
            DecoratedComponent: DecoratedComponent,
            getType: getType,
            collect: collect,
            options: options
        });
    };
}

},{"1a5f40e294ebfd06":"3cETI","66bc1be84a91e718":"55i2R","6a1e63b99a5069af":"1yKlN","dd7e71e822a648fd":"bvhqv","602bb20e35497edf":"dxl5G","4dcc5f5dd0f19a2a":"8AdJP","e0f0c643e2537e7c":"eeQzH","b96f7336f024281b":"9JzBX","5d53c7b11e627679":"al675"}],"dxl5G":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = registerTarget;
function registerTarget(type, target, manager) {
    var registry = manager.getRegistry();
    var targetId = registry.addTarget(type, target);
    function unregisterTarget() {
        registry.removeTarget(targetId);
    }
    return {
        handlerId: targetId,
        unregister: unregisterTarget
    };
}

},{}],"8AdJP":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
exports.default = createTargetFactory;
var _invariant = require("7f71d9282b13cc92");
var _invariant2 = _interopRequireDefault(_invariant);
var _isPlainObject = require("7c2fa0f6b926c6e3");
var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var ALLOWED_SPEC_METHODS = [
    'canDrop',
    'hover',
    'drop'
];
function createTargetFactory(spec) {
    Object.keys(spec).forEach(function(key) {
        (0, _invariant2.default)(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drop target specification to only have some of the following keys: %s. Instead received a specification with an unexpected "%s" key. Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', ALLOWED_SPEC_METHODS.join(', '), key);
        (0, _invariant2.default)(typeof spec[key] === 'function', "Expected %s in the drop target specification to be a function. Instead received a specification with %s: %s. Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html", key, key, spec[key]);
    });
    var Target = function() {
        function Target(monitor) {
            _classCallCheck(this, Target);
            this.monitor = monitor;
            this.props = null;
            this.component = null;
        }
        _createClass(Target, [
            {
                key: 'receiveProps',
                value: function receiveProps(props) {
                    this.props = props;
                }
            },
            {
                key: 'receiveMonitor',
                value: function receiveMonitor(monitor) {
                    this.monitor = monitor;
                }
            },
            {
                key: 'receiveComponent',
                value: function receiveComponent(component) {
                    this.component = component;
                }
            },
            {
                key: 'canDrop',
                value: function canDrop() {
                    if (!spec.canDrop) return true;
                    return spec.canDrop(this.props, this.monitor);
                }
            },
            {
                key: 'hover',
                value: function hover() {
                    if (!spec.hover) return;
                    spec.hover(this.props, this.monitor, this.component);
                }
            },
            {
                key: 'drop',
                value: function drop() {
                    if (!spec.drop) return undefined;
                    var dropResult = spec.drop(this.props, this.monitor, this.component);
                    return dropResult;
                }
            }
        ]);
        return Target;
    }();
    return function createTarget(monitor) {
        return new Target(monitor);
    };
}

},{"7f71d9282b13cc92":"3cETI","7c2fa0f6b926c6e3":"55i2R"}],"eeQzH":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
exports.default = createTargetMonitor;
var _invariant = require("6809d1163d216ecc");
var _invariant2 = _interopRequireDefault(_invariant);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var isCallingCanDrop = false;
var TargetMonitor = function() {
    function TargetMonitor(manager) {
        _classCallCheck(this, TargetMonitor);
        this.internalMonitor = manager.getMonitor();
    }
    _createClass(TargetMonitor, [
        {
            key: 'receiveHandlerId',
            value: function receiveHandlerId(targetId) {
                this.targetId = targetId;
            }
        },
        {
            key: 'canDrop',
            value: function canDrop() {
                (0, _invariant2.default)(!isCallingCanDrop, "You may not call monitor.canDrop() inside your canDrop() implementation. Read more: http://react-dnd.github.io/react-dnd/docs-drop-target-monitor.html");
                try {
                    isCallingCanDrop = true;
                    return this.internalMonitor.canDropOnTarget(this.targetId);
                } finally{
                    isCallingCanDrop = false;
                }
            }
        },
        {
            key: 'isOver',
            value: function isOver(options) {
                return this.internalMonitor.isOverTarget(this.targetId, options);
            }
        },
        {
            key: 'getItemType',
            value: function getItemType() {
                return this.internalMonitor.getItemType();
            }
        },
        {
            key: 'getItem',
            value: function getItem() {
                return this.internalMonitor.getItem();
            }
        },
        {
            key: 'getDropResult',
            value: function getDropResult() {
                return this.internalMonitor.getDropResult();
            }
        },
        {
            key: 'didDrop',
            value: function didDrop() {
                return this.internalMonitor.didDrop();
            }
        },
        {
            key: 'getInitialClientOffset',
            value: function getInitialClientOffset() {
                return this.internalMonitor.getInitialClientOffset();
            }
        },
        {
            key: 'getInitialSourceClientOffset',
            value: function getInitialSourceClientOffset() {
                return this.internalMonitor.getInitialSourceClientOffset();
            }
        },
        {
            key: 'getSourceClientOffset',
            value: function getSourceClientOffset() {
                return this.internalMonitor.getSourceClientOffset();
            }
        },
        {
            key: 'getClientOffset',
            value: function getClientOffset() {
                return this.internalMonitor.getClientOffset();
            }
        },
        {
            key: 'getDifferenceFromInitialOffset',
            value: function getDifferenceFromInitialOffset() {
                return this.internalMonitor.getDifferenceFromInitialOffset();
            }
        }
    ]);
    return TargetMonitor;
}();
function createTargetMonitor(manager) {
    return new TargetMonitor(manager);
}

},{"6809d1163d216ecc":"3cETI"}],"9JzBX":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createTargetConnector;
var _wrapConnectorHooks = require("1bc99ce5334715ee");
var _wrapConnectorHooks2 = _interopRequireDefault(_wrapConnectorHooks);
var _areOptionsEqual = require("5adac6c21cf64dfe");
var _areOptionsEqual2 = _interopRequireDefault(_areOptionsEqual);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function createTargetConnector(backend) {
    var currentHandlerId = void 0;
    var currentDropTargetNode = void 0;
    var currentDropTargetOptions = void 0;
    var disconnectCurrentDropTarget = void 0;
    function reconnectDropTarget() {
        if (disconnectCurrentDropTarget) {
            disconnectCurrentDropTarget();
            disconnectCurrentDropTarget = null;
        }
        if (currentHandlerId && currentDropTargetNode) disconnectCurrentDropTarget = backend.connectDropTarget(currentHandlerId, currentDropTargetNode, currentDropTargetOptions);
    }
    function receiveHandlerId(handlerId) {
        if (handlerId === currentHandlerId) return;
        currentHandlerId = handlerId;
        reconnectDropTarget();
    }
    var hooks = (0, _wrapConnectorHooks2.default)({
        dropTarget: function connectDropTarget(node, options) {
            if (node === currentDropTargetNode && (0, _areOptionsEqual2.default)(options, currentDropTargetOptions)) return;
            currentDropTargetNode = node;
            currentDropTargetOptions = options;
            reconnectDropTarget();
        }
    });
    return {
        receiveHandlerId: receiveHandlerId,
        hooks: hooks
    };
}

},{"1bc99ce5334715ee":"4Za7g","5adac6c21cf64dfe":"2O28M"}],"jhVSh":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getEmptyImage = exports.NativeTypes = undefined;
exports.default = createHTML5Backend;
var _HTML5Backend = require("8a0c9e77ce801924");
var _HTML5Backend2 = _interopRequireDefault(_HTML5Backend);
var _getEmptyImage = require("a0b9277d9a110d42");
var _getEmptyImage2 = _interopRequireDefault(_getEmptyImage);
var _NativeTypes = require("66abe47a635e517f");
var NativeTypes = _interopRequireWildcard(_NativeTypes);
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.NativeTypes = NativeTypes;
exports.getEmptyImage = _getEmptyImage2.default;
function createHTML5Backend(manager) {
    return new _HTML5Backend2.default(manager);
}

},{"8a0c9e77ce801924":"jtqYg","a0b9277d9a110d42":"jp3i4","66abe47a635e517f":"2W3mv"}],"jtqYg":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}(); /* eslint-disable no-underscore-dangle */ 
var _defaults = require("e10daec28cb67b28");
var _defaults2 = _interopRequireDefault(_defaults);
var _shallowEqual = require("ac8691ac8b3e7a7");
var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
var _EnterLeaveCounter = require("4672c25938fefe3b");
var _EnterLeaveCounter2 = _interopRequireDefault(_EnterLeaveCounter);
var _BrowserDetector = require("7e34fe493fa52fb");
var _OffsetUtils = require("bc1ffb8cf3ada8a2");
var _NativeDragSources = require("7fa8f84da98fc564");
var _NativeTypes = require("1428d404ee416c01");
var NativeTypes = _interopRequireWildcard(_NativeTypes);
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var HTML5Backend = function() {
    function HTML5Backend(manager) {
        _classCallCheck(this, HTML5Backend);
        this.actions = manager.getActions();
        this.monitor = manager.getMonitor();
        this.registry = manager.getRegistry();
        this.context = manager.getContext();
        this.sourcePreviewNodes = {};
        this.sourcePreviewNodeOptions = {};
        this.sourceNodes = {};
        this.sourceNodeOptions = {};
        this.enterLeaveCounter = new _EnterLeaveCounter2.default();
        this.dragStartSourceIds = [];
        this.dropTargetIds = [];
        this.dragEnterTargetIds = [];
        this.currentNativeSource = null;
        this.currentNativeHandle = null;
        this.currentDragSourceNode = null;
        this.currentDragSourceNodeOffset = null;
        this.currentDragSourceNodeOffsetChanged = false;
        this.altKeyPressed = false;
        this.mouseMoveTimeoutTimer = null;
        this.getSourceClientOffset = this.getSourceClientOffset.bind(this);
        this.handleTopDragStart = this.handleTopDragStart.bind(this);
        this.handleTopDragStartCapture = this.handleTopDragStartCapture.bind(this);
        this.handleTopDragEndCapture = this.handleTopDragEndCapture.bind(this);
        this.handleTopDragEnter = this.handleTopDragEnter.bind(this);
        this.handleTopDragEnterCapture = this.handleTopDragEnterCapture.bind(this);
        this.handleTopDragLeaveCapture = this.handleTopDragLeaveCapture.bind(this);
        this.handleTopDragOver = this.handleTopDragOver.bind(this);
        this.handleTopDragOverCapture = this.handleTopDragOverCapture.bind(this);
        this.handleTopDrop = this.handleTopDrop.bind(this);
        this.handleTopDropCapture = this.handleTopDropCapture.bind(this);
        this.handleSelectStart = this.handleSelectStart.bind(this);
        this.endDragIfSourceWasRemovedFromDOM = this.endDragIfSourceWasRemovedFromDOM.bind(this);
        this.endDragNativeItem = this.endDragNativeItem.bind(this);
        this.asyncEndDragNativeItem = this.asyncEndDragNativeItem.bind(this);
        this.isNodeInDocument = this.isNodeInDocument.bind(this);
    }
    _createClass(HTML5Backend, [
        {
            key: 'setup',
            value: function setup() {
                if (this.window === undefined) return;
                if (this.window.__isReactDndBackendSetUp) throw new Error('Cannot have two HTML5 backends at the same time.');
                this.window.__isReactDndBackendSetUp = true;
                this.addEventListeners(this.window);
            }
        },
        {
            key: 'teardown',
            value: function teardown() {
                if (this.window === undefined) return;
                this.window.__isReactDndBackendSetUp = false;
                this.removeEventListeners(this.window);
                this.clearCurrentDragSourceNode();
                if (this.asyncEndDragFrameId) this.window.cancelAnimationFrame(this.asyncEndDragFrameId);
            }
        },
        {
            key: 'addEventListeners',
            value: function addEventListeners(target) {
                // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
                if (!target.addEventListener) return;
                target.addEventListener('dragstart', this.handleTopDragStart);
                target.addEventListener('dragstart', this.handleTopDragStartCapture, true);
                target.addEventListener('dragend', this.handleTopDragEndCapture, true);
                target.addEventListener('dragenter', this.handleTopDragEnter);
                target.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
                target.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
                target.addEventListener('dragover', this.handleTopDragOver);
                target.addEventListener('dragover', this.handleTopDragOverCapture, true);
                target.addEventListener('drop', this.handleTopDrop);
                target.addEventListener('drop', this.handleTopDropCapture, true);
            }
        },
        {
            key: 'removeEventListeners',
            value: function removeEventListeners(target) {
                // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
                if (!target.removeEventListener) return;
                target.removeEventListener('dragstart', this.handleTopDragStart);
                target.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
                target.removeEventListener('dragend', this.handleTopDragEndCapture, true);
                target.removeEventListener('dragenter', this.handleTopDragEnter);
                target.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
                target.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
                target.removeEventListener('dragover', this.handleTopDragOver);
                target.removeEventListener('dragover', this.handleTopDragOverCapture, true);
                target.removeEventListener('drop', this.handleTopDrop);
                target.removeEventListener('drop', this.handleTopDropCapture, true);
            }
        },
        {
            key: 'connectDragPreview',
            value: function connectDragPreview(sourceId, node, options) {
                var _this = this;
                this.sourcePreviewNodeOptions[sourceId] = options;
                this.sourcePreviewNodes[sourceId] = node;
                return function() {
                    delete _this.sourcePreviewNodes[sourceId];
                    delete _this.sourcePreviewNodeOptions[sourceId];
                };
            }
        },
        {
            key: 'connectDragSource',
            value: function connectDragSource(sourceId, node, options) {
                var _this2 = this;
                this.sourceNodes[sourceId] = node;
                this.sourceNodeOptions[sourceId] = options;
                var handleDragStart = function handleDragStart(e) {
                    return _this2.handleDragStart(e, sourceId);
                };
                var handleSelectStart = function handleSelectStart(e) {
                    return _this2.handleSelectStart(e, sourceId);
                };
                node.setAttribute('draggable', true);
                node.addEventListener('dragstart', handleDragStart);
                node.addEventListener('selectstart', handleSelectStart);
                return function() {
                    delete _this2.sourceNodes[sourceId];
                    delete _this2.sourceNodeOptions[sourceId];
                    node.removeEventListener('dragstart', handleDragStart);
                    node.removeEventListener('selectstart', handleSelectStart);
                    node.setAttribute('draggable', false);
                };
            }
        },
        {
            key: 'connectDropTarget',
            value: function connectDropTarget(targetId, node) {
                var _this3 = this;
                var handleDragEnter = function handleDragEnter(e) {
                    return _this3.handleDragEnter(e, targetId);
                };
                var handleDragOver = function handleDragOver(e) {
                    return _this3.handleDragOver(e, targetId);
                };
                var handleDrop = function handleDrop(e) {
                    return _this3.handleDrop(e, targetId);
                };
                node.addEventListener('dragenter', handleDragEnter);
                node.addEventListener('dragover', handleDragOver);
                node.addEventListener('drop', handleDrop);
                return function() {
                    node.removeEventListener('dragenter', handleDragEnter);
                    node.removeEventListener('dragover', handleDragOver);
                    node.removeEventListener('drop', handleDrop);
                };
            }
        },
        {
            key: 'getCurrentSourceNodeOptions',
            value: function getCurrentSourceNodeOptions() {
                var sourceId = this.monitor.getSourceId();
                var sourceNodeOptions = this.sourceNodeOptions[sourceId];
                return (0, _defaults2.default)(sourceNodeOptions || {}, {
                    dropEffect: this.altKeyPressed ? 'copy' : 'move'
                });
            }
        },
        {
            key: 'getCurrentDropEffect',
            value: function getCurrentDropEffect() {
                if (this.isDraggingNativeItem()) // It makes more sense to default to 'copy' for native resources
                return 'copy';
                return this.getCurrentSourceNodeOptions().dropEffect;
            }
        },
        {
            key: 'getCurrentSourcePreviewNodeOptions',
            value: function getCurrentSourcePreviewNodeOptions() {
                var sourceId = this.monitor.getSourceId();
                var sourcePreviewNodeOptions = this.sourcePreviewNodeOptions[sourceId];
                return (0, _defaults2.default)(sourcePreviewNodeOptions || {}, {
                    anchorX: 0.5,
                    anchorY: 0.5,
                    captureDraggingState: false
                });
            }
        },
        {
            key: 'getSourceClientOffset',
            value: function getSourceClientOffset(sourceId) {
                return (0, _OffsetUtils.getNodeClientOffset)(this.sourceNodes[sourceId]);
            }
        },
        {
            key: 'isDraggingNativeItem',
            value: function isDraggingNativeItem() {
                var itemType = this.monitor.getItemType();
                return Object.keys(NativeTypes).some(function(key) {
                    return NativeTypes[key] === itemType;
                });
            }
        },
        {
            key: 'beginDragNativeItem',
            value: function beginDragNativeItem(type) {
                this.clearCurrentDragSourceNode();
                var SourceType = (0, _NativeDragSources.createNativeDragSource)(type);
                this.currentNativeSource = new SourceType();
                this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
                this.actions.beginDrag([
                    this.currentNativeHandle
                ]);
            }
        },
        {
            key: 'asyncEndDragNativeItem',
            value: function asyncEndDragNativeItem() {
                this.asyncEndDragFrameId = this.window.requestAnimationFrame(this.endDragNativeItem);
            }
        },
        {
            key: 'endDragNativeItem',
            value: function endDragNativeItem() {
                if (!this.isDraggingNativeItem()) return;
                this.actions.endDrag();
                this.registry.removeSource(this.currentNativeHandle);
                this.currentNativeHandle = null;
                this.currentNativeSource = null;
            }
        },
        {
            key: 'isNodeInDocument',
            value: function isNodeInDocument(node) {
                // Check the node either in the main document or in the current context
                return document.body.contains(node) || this.window ? this.window.document.body.contains(node) : false;
            }
        },
        {
            key: 'endDragIfSourceWasRemovedFromDOM',
            value: function endDragIfSourceWasRemovedFromDOM() {
                var node = this.currentDragSourceNode;
                if (this.isNodeInDocument(node)) return;
                if (this.clearCurrentDragSourceNode()) this.actions.endDrag();
            }
        },
        {
            key: 'setCurrentDragSourceNode',
            value: function setCurrentDragSourceNode(node) {
                var _this4 = this;
                this.clearCurrentDragSourceNode();
                this.currentDragSourceNode = node;
                this.currentDragSourceNodeOffset = (0, _OffsetUtils.getNodeClientOffset)(node);
                this.currentDragSourceNodeOffsetChanged = false;
                // A timeout of > 0 is necessary to resolve Firefox issue referenced
                // See:
                //   * https://github.com/react-dnd/react-dnd/pull/928
                //   * https://github.com/react-dnd/react-dnd/issues/869
                var MOUSE_MOVE_TIMEOUT = 1000;
                // Receiving a mouse event in the middle of a dragging operation
                // means it has ended and the drag source node disappeared from DOM,
                // so the browser didn't dispatch the dragend event.
                //
                // We need to wait before we start listening for mousemove events.
                // This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
                // immediately in some browsers.
                //
                // See:
                //   * https://github.com/react-dnd/react-dnd/pull/928
                //   * https://github.com/react-dnd/react-dnd/issues/869
                //
                this.mouseMoveTimeoutTimer = setTimeout(function() {
                    _this4.mouseMoveTimeoutId = null;
                    return _this4.window.addEventListener('mousemove', _this4.endDragIfSourceWasRemovedFromDOM, true);
                }, MOUSE_MOVE_TIMEOUT);
            }
        },
        {
            key: 'clearCurrentDragSourceNode',
            value: function clearCurrentDragSourceNode() {
                if (this.currentDragSourceNode) {
                    this.currentDragSourceNode = null;
                    this.currentDragSourceNodeOffset = null;
                    this.currentDragSourceNodeOffsetChanged = false;
                    this.window.clearTimeout(this.mouseMoveTimeoutTimer);
                    this.window.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
                    this.mouseMoveTimeoutTimer = null;
                    return true;
                }
                return false;
            }
        },
        {
            key: 'checkIfCurrentDragSourceRectChanged',
            value: function checkIfCurrentDragSourceRectChanged() {
                var node = this.currentDragSourceNode;
                if (!node) return false;
                if (this.currentDragSourceNodeOffsetChanged) return true;
                this.currentDragSourceNodeOffsetChanged = !(0, _shallowEqual2.default)((0, _OffsetUtils.getNodeClientOffset)(node), this.currentDragSourceNodeOffset);
                return this.currentDragSourceNodeOffsetChanged;
            }
        },
        {
            key: 'handleTopDragStartCapture',
            value: function handleTopDragStartCapture() {
                this.clearCurrentDragSourceNode();
                this.dragStartSourceIds = [];
            }
        },
        {
            key: 'handleDragStart',
            value: function handleDragStart(e, sourceId) {
                this.dragStartSourceIds.unshift(sourceId);
            }
        },
        {
            key: 'handleTopDragStart',
            value: function handleTopDragStart(e) {
                var _this5 = this;
                var dragStartSourceIds = this.dragStartSourceIds;
                this.dragStartSourceIds = null;
                var clientOffset = (0, _OffsetUtils.getEventClientOffset)(e);
                // Avoid crashing if we missed a drop event or our previous drag died
                if (this.monitor.isDragging()) this.actions.endDrag();
                // Don't publish the source just yet (see why below)
                this.actions.beginDrag(dragStartSourceIds, {
                    publishSource: false,
                    getSourceClientOffset: this.getSourceClientOffset,
                    clientOffset: clientOffset
                });
                var dataTransfer = e.dataTransfer;
                var nativeType = (0, _NativeDragSources.matchNativeItemType)(dataTransfer);
                if (this.monitor.isDragging()) {
                    if (typeof dataTransfer.setDragImage === 'function') {
                        // Use custom drag image if user specifies it.
                        // If child drag source refuses drag but parent agrees,
                        // use parent's node as drag image. Neither works in IE though.
                        var sourceId = this.monitor.getSourceId();
                        var sourceNode = this.sourceNodes[sourceId];
                        var dragPreview = this.sourcePreviewNodes[sourceId] || sourceNode;
                        var _getCurrentSourcePrev = this.getCurrentSourcePreviewNodeOptions(), anchorX = _getCurrentSourcePrev.anchorX, anchorY = _getCurrentSourcePrev.anchorY, offsetX = _getCurrentSourcePrev.offsetX, offsetY = _getCurrentSourcePrev.offsetY;
                        var anchorPoint = {
                            anchorX: anchorX,
                            anchorY: anchorY
                        };
                        var offsetPoint = {
                            offsetX: offsetX,
                            offsetY: offsetY
                        };
                        var dragPreviewOffset = (0, _OffsetUtils.getDragPreviewOffset)(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
                        dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
                    }
                    try {
                        // Firefox won't drag without setting data
                        dataTransfer.setData('application/json', {});
                    } catch (err) {}
                    // IE doesn't support MIME types in setData
                    // Store drag source node so we can check whether
                    // it is removed from DOM and trigger endDrag manually.
                    this.setCurrentDragSourceNode(e.target);
                    // Now we are ready to publish the drag source.. or are we not?
                    var _getCurrentSourcePrev2 = this.getCurrentSourcePreviewNodeOptions(), captureDraggingState = _getCurrentSourcePrev2.captureDraggingState;
                    if (!captureDraggingState) // Usually we want to publish it in the next tick so that browser
                    // is able to screenshot the current (not yet dragging) state.
                    //
                    // It also neatly avoids a situation where render() returns null
                    // in the same tick for the source element, and browser freaks out.
                    setTimeout(function() {
                        return _this5.actions.publishDragSource();
                    });
                    else // In some cases the user may want to override this behavior, e.g.
                    // to work around IE not supporting custom drag previews.
                    //
                    // When using a custom drag layer, the only way to prevent
                    // the default drag preview from drawing in IE is to screenshot
                    // the dragging state in which the node itself has zero opacity
                    // and height. In this case, though, returning null from render()
                    // will abruptly end the dragging, which is not obvious.
                    //
                    // This is the reason such behavior is strictly opt-in.
                    this.actions.publishDragSource();
                } else if (nativeType) // A native item (such as URL) dragged from inside the document
                this.beginDragNativeItem(nativeType);
                else if (!dataTransfer.types && (!e.target.hasAttribute || !e.target.hasAttribute('draggable'))) // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
                // Just let it drag. It's a native type (URL or text) and will be picked up in
                // dragenter handler.
                return; // eslint-disable-line no-useless-return
                else // If by this time no drag source reacted, tell browser not to drag.
                e.preventDefault();
            }
        },
        {
            key: 'handleTopDragEndCapture',
            value: function handleTopDragEndCapture() {
                if (this.clearCurrentDragSourceNode()) // Firefox can dispatch this event in an infinite loop
                // if dragend handler does something like showing an alert.
                // Only proceed if we have not handled it already.
                this.actions.endDrag();
            }
        },
        {
            key: 'handleTopDragEnterCapture',
            value: function handleTopDragEnterCapture(e) {
                this.dragEnterTargetIds = [];
                var isFirstEnter = this.enterLeaveCounter.enter(e.target);
                if (!isFirstEnter || this.monitor.isDragging()) return;
                var dataTransfer = e.dataTransfer;
                var nativeType = (0, _NativeDragSources.matchNativeItemType)(dataTransfer);
                if (nativeType) // A native item (such as file or URL) dragged from outside the document
                this.beginDragNativeItem(nativeType);
            }
        },
        {
            key: 'handleDragEnter',
            value: function handleDragEnter(e, targetId) {
                this.dragEnterTargetIds.unshift(targetId);
            }
        },
        {
            key: 'handleTopDragEnter',
            value: function handleTopDragEnter(e) {
                var _this6 = this;
                var dragEnterTargetIds = this.dragEnterTargetIds;
                this.dragEnterTargetIds = [];
                if (!this.monitor.isDragging()) // This is probably a native item type we don't understand.
                return;
                this.altKeyPressed = e.altKey;
                if (!(0, _BrowserDetector.isFirefox)()) // Don't emit hover in `dragenter` on Firefox due to an edge case.
                // If the target changes position as the result of `dragenter`, Firefox
                // will still happily dispatch `dragover` despite target being no longer
                // there. The easy solution is to only fire `hover` in `dragover` on FF.
                this.actions.hover(dragEnterTargetIds, {
                    clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
                });
                var canDrop = dragEnterTargetIds.some(function(targetId) {
                    return _this6.monitor.canDropOnTarget(targetId);
                });
                if (canDrop) {
                    // IE requires this to fire dragover events
                    e.preventDefault();
                    e.dataTransfer.dropEffect = this.getCurrentDropEffect();
                }
            }
        },
        {
            key: 'handleTopDragOverCapture',
            value: function handleTopDragOverCapture() {
                this.dragOverTargetIds = [];
            }
        },
        {
            key: 'handleDragOver',
            value: function handleDragOver(e, targetId) {
                this.dragOverTargetIds.unshift(targetId);
            }
        },
        {
            key: 'handleTopDragOver',
            value: function handleTopDragOver(e) {
                var _this7 = this;
                var dragOverTargetIds = this.dragOverTargetIds;
                this.dragOverTargetIds = [];
                if (!this.monitor.isDragging()) {
                    // This is probably a native item type we don't understand.
                    // Prevent default "drop and blow away the whole document" action.
                    e.preventDefault();
                    e.dataTransfer.dropEffect = 'none';
                    return;
                }
                this.altKeyPressed = e.altKey;
                this.actions.hover(dragOverTargetIds, {
                    clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
                });
                var canDrop = dragOverTargetIds.some(function(targetId) {
                    return _this7.monitor.canDropOnTarget(targetId);
                });
                if (canDrop) {
                    // Show user-specified drop effect.
                    e.preventDefault();
                    e.dataTransfer.dropEffect = this.getCurrentDropEffect();
                } else if (this.isDraggingNativeItem()) {
                    // Don't show a nice cursor but still prevent default
                    // "drop and blow away the whole document" action.
                    e.preventDefault();
                    e.dataTransfer.dropEffect = 'none';
                } else if (this.checkIfCurrentDragSourceRectChanged()) {
                    // Prevent animating to incorrect position.
                    // Drop effect must be other than 'none' to prevent animation.
                    e.preventDefault();
                    e.dataTransfer.dropEffect = 'move';
                }
            }
        },
        {
            key: 'handleTopDragLeaveCapture',
            value: function handleTopDragLeaveCapture(e) {
                if (this.isDraggingNativeItem()) e.preventDefault();
                var isLastLeave = this.enterLeaveCounter.leave(e.target);
                if (!isLastLeave) return;
                if (this.isDraggingNativeItem()) this.endDragNativeItem();
            }
        },
        {
            key: 'handleTopDropCapture',
            value: function handleTopDropCapture(e) {
                this.dropTargetIds = [];
                e.preventDefault();
                if (this.isDraggingNativeItem()) this.currentNativeSource.mutateItemByReadingDataTransfer(e.dataTransfer);
                this.enterLeaveCounter.reset();
            }
        },
        {
            key: 'handleDrop',
            value: function handleDrop(e, targetId) {
                this.dropTargetIds.unshift(targetId);
            }
        },
        {
            key: 'handleTopDrop',
            value: function handleTopDrop(e) {
                var dropTargetIds = this.dropTargetIds;
                this.dropTargetIds = [];
                this.actions.hover(dropTargetIds, {
                    clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
                });
                this.actions.drop({
                    dropEffect: this.getCurrentDropEffect()
                });
                if (this.isDraggingNativeItem()) this.endDragNativeItem();
                else this.endDragIfSourceWasRemovedFromDOM();
            }
        },
        {
            key: 'handleSelectStart',
            value: function handleSelectStart(e) {
                var target = e.target;
                // Only IE requires us to explicitly say
                // we want drag drop operation to start
                if (typeof target.dragDrop !== 'function') return;
                // Inputs and textareas should be selectable
                if (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return;
                // For other targets, ask IE
                // to enable drag and drop
                e.preventDefault();
                target.dragDrop();
            }
        },
        {
            key: 'window',
            get: function get() {
                if (this.context && this.context.window) return this.context.window;
                else if (typeof window !== 'undefined') return window;
                return undefined;
            }
        }
    ]);
    return HTML5Backend;
}();
exports.default = HTML5Backend;

},{"e10daec28cb67b28":"lViPr","ac8691ac8b3e7a7":"hQjwa","4672c25938fefe3b":"4Wjzm","7e34fe493fa52fb":"jpLhe","bc1ffb8cf3ada8a2":"2Dgi7","7fa8f84da98fc564":"lHOWm","1428d404ee416c01":"2W3mv"}],"lViPr":[function(require,module,exports,__globalThis) {
var baseRest = require("7185e90d741afd2a"), eq = require("c7442b0697635fa9"), isIterateeCall = require("4bcb10da45efc3b8"), keysIn = require("4217ca21be56753d");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */ var defaults = baseRest(function(object, sources) {
    object = Object(object);
    var index = -1;
    var length = sources.length;
    var guard = length > 2 ? sources[2] : undefined;
    if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
    while(++index < length){
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;
        while(++propsIndex < propsLength){
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
        }
    }
    return object;
});
module.exports = defaults;

},{"7185e90d741afd2a":"1fVZL","c7442b0697635fa9":"jOpKa","4bcb10da45efc3b8":"aZ0Hj","4217ca21be56753d":"5yt6M"}],"5yt6M":[function(require,module,exports,__globalThis) {
var arrayLikeKeys = require("635aebb56f3a408f"), baseKeysIn = require("194eb1a802636842"), isArrayLike = require("ac15afdc3ddd76cd");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
module.exports = keysIn;

},{"635aebb56f3a408f":"fcdyL","194eb1a802636842":"2ddY4","ac15afdc3ddd76cd":"f6382"}],"2ddY4":[function(require,module,exports,__globalThis) {
var isObject = require("bd1636f5883f1002"), isPrototype = require("f7d53cd92b2b977b"), nativeKeysIn = require("c039208a16eb68bd");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = baseKeysIn;

},{"bd1636f5883f1002":"b5XR2","f7d53cd92b2b977b":"9hPlj","c039208a16eb68bd":"SBfnS"}],"SBfnS":[function(require,module,exports,__globalThis) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = nativeKeysIn;

},{}],"hQjwa":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = shallowEqual;
function shallowEqual(objA, objB) {
    if (objA === objB) return true;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    var hasOwn = Object.prototype.hasOwnProperty;
    for(var i = 0; i < keysA.length; i += 1){
        if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
        var valA = objA[keysA[i]];
        var valB = objB[keysA[i]];
        if (valA !== valB) return false;
    }
    return true;
}

},{}],"4Wjzm":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _union = require("28cc2870430aca3");
var _union2 = _interopRequireDefault(_union);
var _without = require("9357ac50b4dae2bc");
var _without2 = _interopRequireDefault(_without);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var EnterLeaveCounter = function() {
    function EnterLeaveCounter() {
        _classCallCheck(this, EnterLeaveCounter);
        this.entered = [];
    }
    _createClass(EnterLeaveCounter, [
        {
            key: 'enter',
            value: function enter(enteringNode) {
                var previousLength = this.entered.length;
                var isNodeEntered = function isNodeEntered(node) {
                    return document.documentElement.contains(node) && (!node.contains || node.contains(enteringNode));
                };
                this.entered = (0, _union2.default)(this.entered.filter(isNodeEntered), [
                    enteringNode
                ]);
                return previousLength === 0 && this.entered.length > 0;
            }
        },
        {
            key: 'leave',
            value: function leave(leavingNode) {
                var previousLength = this.entered.length;
                this.entered = (0, _without2.default)(this.entered.filter(function(node) {
                    return document.documentElement.contains(node);
                }), leavingNode);
                return previousLength > 0 && this.entered.length === 0;
            }
        },
        {
            key: 'reset',
            value: function reset() {
                this.entered = [];
            }
        }
    ]);
    return EnterLeaveCounter;
}();
exports.default = EnterLeaveCounter;

},{"28cc2870430aca3":"5MHWZ","9357ac50b4dae2bc":"krQcN"}],"5MHWZ":[function(require,module,exports,__globalThis) {
var baseFlatten = require("4c6a8d1d22b46f1e"), baseRest = require("3c5b68a5bd4cb3c4"), baseUniq = require("d4a39eace292bbe3"), isArrayLikeObject = require("b9956cfd928a69da");
/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */ var union = baseRest(function(arrays) {
    return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});
module.exports = union;

},{"4c6a8d1d22b46f1e":"LCj6J","3c5b68a5bd4cb3c4":"1fVZL","d4a39eace292bbe3":"81vJ8","b9956cfd928a69da":"6vQ3T"}],"jpLhe":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isSafari = exports.isFirefox = undefined;
var _memoize = require("536f51124ecf2ba9");
var _memoize2 = _interopRequireDefault(_memoize);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var isFirefox = exports.isFirefox = (0, _memoize2.default)(function() {
    return /firefox/i.test(navigator.userAgent);
});
var isSafari = exports.isSafari = (0, _memoize2.default)(function() {
    return Boolean(window.safari);
});

},{"536f51124ecf2ba9":"6LVZz"}],"2Dgi7":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getNodeClientOffset = getNodeClientOffset;
exports.getEventClientOffset = getEventClientOffset;
exports.getDragPreviewOffset = getDragPreviewOffset;
var _BrowserDetector = require("94cf110e34f529cd");
var _MonotonicInterpolant = require("b90871ebeea78b2d");
var _MonotonicInterpolant2 = _interopRequireDefault(_MonotonicInterpolant);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint
   no-mixed-operators: off
*/ var ELEMENT_NODE = 1;
function getNodeClientOffset(node) {
    var el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;
    if (!el) return null;
    var _el$getBoundingClient = el.getBoundingClientRect(), top = _el$getBoundingClient.top, left = _el$getBoundingClient.left;
    return {
        x: left,
        y: top
    };
}
function getEventClientOffset(e) {
    return {
        x: e.clientX,
        y: e.clientY
    };
}
function isImageNode(node) {
    return node.nodeName === 'IMG' && ((0, _BrowserDetector.isFirefox)() || !document.documentElement.contains(node));
}
function getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
    var dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
    var dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;
    // Work around @2x coordinate discrepancies in browsers
    if ((0, _BrowserDetector.isSafari)() && isImage) {
        dragPreviewHeight /= window.devicePixelRatio;
        dragPreviewWidth /= window.devicePixelRatio;
    }
    return {
        dragPreviewWidth: dragPreviewWidth,
        dragPreviewHeight: dragPreviewHeight
    };
}
function getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
    // The browsers will use the image intrinsic size under different conditions.
    // Firefox only cares if it's an image, but WebKit also wants it to be detached.
    var isImage = isImageNode(dragPreview);
    var dragPreviewNode = isImage ? sourceNode : dragPreview;
    var dragPreviewNodeOffsetFromClient = getNodeClientOffset(dragPreviewNode);
    var offsetFromDragPreview = {
        x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
        y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
    };
    var sourceWidth = sourceNode.offsetWidth, sourceHeight = sourceNode.offsetHeight;
    var anchorX = anchorPoint.anchorX, anchorY = anchorPoint.anchorY;
    var _getDragPreviewSize = getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight), dragPreviewWidth = _getDragPreviewSize.dragPreviewWidth, dragPreviewHeight = _getDragPreviewSize.dragPreviewHeight;
    var calculateYOffset = function calculateYOffset() {
        var interpolantY = new _MonotonicInterpolant2.default([
            0,
            0.5,
            1
        ], [
            // Dock to the top
            offsetFromDragPreview.y,
            // Align at the center
            offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
            // Dock to the bottom
            offsetFromDragPreview.y + dragPreviewHeight - sourceHeight
        ]);
        var y = interpolantY.interpolate(anchorY);
        // Work around Safari 8 positioning bug
        if ((0, _BrowserDetector.isSafari)() && isImage) // We'll have to wait for @3x to see if this is entirely correct
        y += (window.devicePixelRatio - 1) * dragPreviewHeight;
        return y;
    };
    var calculateXOffset = function calculateXOffset() {
        // Interpolate coordinates depending on anchor point
        // If you know a simpler way to do this, let me know
        var interpolantX = new _MonotonicInterpolant2.default([
            0,
            0.5,
            1
        ], [
            // Dock to the left
            offsetFromDragPreview.x,
            // Align at the center
            offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
            // Dock to the right
            offsetFromDragPreview.x + dragPreviewWidth - sourceWidth
        ]);
        return interpolantX.interpolate(anchorX);
    };
    // Force offsets if specified in the options.
    var offsetX = offsetPoint.offsetX, offsetY = offsetPoint.offsetY;
    var isManualOffsetX = offsetX === 0 || offsetX;
    var isManualOffsetY = offsetY === 0 || offsetY;
    return {
        x: isManualOffsetX ? offsetX : calculateXOffset(),
        y: isManualOffsetY ? offsetY : calculateYOffset()
    };
}

},{"94cf110e34f529cd":"jpLhe","b90871ebeea78b2d":"1hEkW"}],"1hEkW":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
/* eslint
   no-plusplus: off,
   no-mixed-operators: off
*/ var MonotonicInterpolant = function() {
    function MonotonicInterpolant(xs, ys) {
        _classCallCheck(this, MonotonicInterpolant);
        var length = xs.length;
        // Rearrange xs and ys so that xs is sorted
        var indexes = [];
        for(var i = 0; i < length; i++)indexes.push(i);
        indexes.sort(function(a, b) {
            return xs[a] < xs[b] ? -1 : 1;
        });
        // Get consecutive differences and slopes
        var dys = [];
        var dxs = [];
        var ms = [];
        var dx = void 0;
        var dy = void 0;
        for(var _i = 0; _i < length - 1; _i++){
            dx = xs[_i + 1] - xs[_i];
            dy = ys[_i + 1] - ys[_i];
            dxs.push(dx);
            dys.push(dy);
            ms.push(dy / dx);
        }
        // Get degree-1 coefficients
        var c1s = [
            ms[0]
        ];
        for(var _i2 = 0; _i2 < dxs.length - 1; _i2++){
            var _m = ms[_i2];
            var mNext = ms[_i2 + 1];
            if (_m * mNext <= 0) c1s.push(0);
            else {
                dx = dxs[_i2];
                var dxNext = dxs[_i2 + 1];
                var common = dx + dxNext;
                c1s.push(3 * common / ((common + dxNext) / _m + (common + dx) / mNext));
            }
        }
        c1s.push(ms[ms.length - 1]);
        // Get degree-2 and degree-3 coefficients
        var c2s = [];
        var c3s = [];
        var m = void 0;
        for(var _i3 = 0; _i3 < c1s.length - 1; _i3++){
            m = ms[_i3];
            var c1 = c1s[_i3];
            var invDx = 1 / dxs[_i3];
            var _common = c1 + c1s[_i3 + 1] - m - m;
            c2s.push((m - c1 - _common) * invDx);
            c3s.push(_common * invDx * invDx);
        }
        this.xs = xs;
        this.ys = ys;
        this.c1s = c1s;
        this.c2s = c2s;
        this.c3s = c3s;
    }
    _createClass(MonotonicInterpolant, [
        {
            key: "interpolate",
            value: function interpolate(x) {
                var xs = this.xs, ys = this.ys, c1s = this.c1s, c2s = this.c2s, c3s = this.c3s;
                // The rightmost point in the dataset should give an exact result
                var i = xs.length - 1;
                if (x === xs[i]) return ys[i];
                // Search for the interval x is in, returning the corresponding y if x is one of the original xs
                var low = 0;
                var high = c3s.length - 1;
                var mid = void 0;
                while(low <= high){
                    mid = Math.floor(0.5 * (low + high));
                    var xHere = xs[mid];
                    if (xHere < x) low = mid + 1;
                    else if (xHere > x) high = mid - 1;
                    else return ys[mid];
                }
                i = Math.max(0, high);
                // Interpolate
                var diff = x - xs[i];
                var diffSq = diff * diff;
                return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
            }
        }
    ]);
    return MonotonicInterpolant;
}();
exports.default = MonotonicInterpolant;

},{}],"lHOWm":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _nativeTypesConfig;
exports.createNativeDragSource = createNativeDragSource;
exports.matchNativeItemType = matchNativeItemType;
var _NativeTypes = require("2fa36072c764cb30");
var NativeTypes = _interopRequireWildcard(_NativeTypes);
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function _defineEnumerableProperties(obj, descs) {
    for(var key in descs){
        var desc = descs[key];
        desc.configurable = desc.enumerable = true;
        if ("value" in desc) desc.writable = true;
        Object.defineProperty(obj, key, desc);
    }
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
    var result = typesToTry.reduce(function(resultSoFar, typeToTry) {
        return resultSoFar || dataTransfer.getData(typeToTry);
    }, null);
    return result != null // eslint-disable-line eqeqeq
     ? result : defaultValue;
}
var nativeTypesConfig = (_nativeTypesConfig = {}, _defineProperty(_nativeTypesConfig, NativeTypes.FILE, {
    exposeProperty: 'files',
    matchesTypes: [
        'Files'
    ],
    getData: function getData(dataTransfer) {
        return Array.prototype.slice.call(dataTransfer.files);
    }
}), _defineProperty(_nativeTypesConfig, NativeTypes.URL, {
    exposeProperty: 'urls',
    matchesTypes: [
        'Url',
        'text/uri-list'
    ],
    getData: function getData(dataTransfer, matchesTypes) {
        return getDataFromDataTransfer(dataTransfer, matchesTypes, '').split('\n');
    }
}), _defineProperty(_nativeTypesConfig, NativeTypes.TEXT, {
    exposeProperty: 'text',
    matchesTypes: [
        'Text',
        'text/plain'
    ],
    getData: function getData(dataTransfer, matchesTypes) {
        return getDataFromDataTransfer(dataTransfer, matchesTypes, '');
    }
}), _nativeTypesConfig);
function createNativeDragSource(type) {
    var _nativeTypesConfig$ty = nativeTypesConfig[type], exposeProperty = _nativeTypesConfig$ty.exposeProperty, matchesTypes = _nativeTypesConfig$ty.matchesTypes, getData = _nativeTypesConfig$ty.getData;
    return function() {
        function NativeDragSource() {
            var _item, _mutatorMap;
            _classCallCheck(this, NativeDragSource);
            this.item = (_item = {}, _mutatorMap = {}, _mutatorMap[exposeProperty] = _mutatorMap[exposeProperty] || {}, _mutatorMap[exposeProperty].get = function() {
                // eslint-disable-next-line no-console
                console.warn('Browser doesn\'t allow reading "' + exposeProperty + '" until the drop event.');
                return null;
            }, _defineEnumerableProperties(_item, _mutatorMap), _item);
        }
        _createClass(NativeDragSource, [
            {
                key: 'mutateItemByReadingDataTransfer',
                value: function mutateItemByReadingDataTransfer(dataTransfer) {
                    delete this.item[exposeProperty];
                    this.item[exposeProperty] = getData(dataTransfer, matchesTypes);
                }
            },
            {
                key: 'canDrag',
                value: function canDrag() {
                    return true;
                }
            },
            {
                key: 'beginDrag',
                value: function beginDrag() {
                    return this.item;
                }
            },
            {
                key: 'isDragging',
                value: function isDragging(monitor, handle) {
                    return handle === monitor.getSourceId();
                }
            },
            {
                key: 'endDrag',
                value: function endDrag() {}
            }
        ]);
        return NativeDragSource;
    }();
}
function matchNativeItemType(dataTransfer) {
    var dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
    return Object.keys(nativeTypesConfig).filter(function(nativeItemType) {
        var matchesTypes = nativeTypesConfig[nativeItemType].matchesTypes;
        return matchesTypes.some(function(t) {
            return dataTransferTypes.indexOf(t) > -1;
        });
    })[0] || null;
}

},{"2fa36072c764cb30":"2W3mv"}],"2W3mv":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var FILE = exports.FILE = '__NATIVE_FILE__';
var URL = exports.URL = '__NATIVE_URL__';
var TEXT = exports.TEXT = '__NATIVE_TEXT__';

},{}],"jp3i4":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getEmptyImage;
var emptyImage = void 0;
function getEmptyImage() {
    if (!emptyImage) {
        emptyImage = new Image();
        emptyImage.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
    }
    return emptyImage;
}

},{}],"3DWzf":[function(require,module,exports,__globalThis) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var global = arguments[3];
var FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]';
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Built-in value references. */ var Symbol = root.Symbol, propertyIsEnumerable = objectProto.propertyIsEnumerable, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = isFlattenable);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
            else arrayPush(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = array;
        return apply(func, this, otherArgs);
    };
}
/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */ function createFlow(fromRight) {
    return baseRest(function(funcs) {
        funcs = baseFlatten(funcs, 1);
        var length = funcs.length, index = length;
        if (fromRight) funcs.reverse();
        while(index--){
            if (typeof funcs[index] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
        }
        return function() {
            var index = 0, result = length ? funcs[index].apply(this, arguments) : arguments[0];
            while(++index < length)result = funcs[index].call(this, result);
            return result;
        };
    });
}
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function isFlattenable(value) {
    return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */ var flow = createFlow();
module.exports = flow;

},{}],"304K0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AGGREGATE_METHODS", ()=>(0, _tbrowseCore.AGGREGATE_METHODS));
parcelHelpers.export(exports, "BUILTIN_SEARCH_FIELDS", ()=>Qo);
parcelHelpers.export(exports, "COLOR_SCHEMES", ()=>nn);
parcelHelpers.export(exports, "DEFAULT_DIVERGING_PALETTE", ()=>Os);
parcelHelpers.export(exports, "DEFAULT_METHOD_ID", ()=>(0, _tbrowseCore.DEFAULT_METHOD_ID));
parcelHelpers.export(exports, "DEFAULT_SEQUENTIAL_PALETTE", ()=>mo);
parcelHelpers.export(exports, "EditableZoneName", ()=>nt);
parcelHelpers.export(exports, "LEAF_ROW_HEIGHT", ()=>yl);
parcelHelpers.export(exports, "PALETTES", ()=>mt);
parcelHelpers.export(exports, "SEARCH_MATCH_LIMIT", ()=>(0, _tbrowseCore.SEARCH_MATCH_LIMIT));
parcelHelpers.export(exports, "SUMMARY_ROW_HEIGHT", ()=>Il);
parcelHelpers.export(exports, "TBrowse", ()=>el);
parcelHelpers.export(exports, "TBrowseLogo", ()=>dr);
parcelHelpers.export(exports, "allFields", ()=>no);
parcelHelpers.export(exports, "applicableSchemes", ()=>wi);
parcelHelpers.export(exports, "builtInFields", ()=>ii);
parcelHelpers.export(exports, "compileStringMatcher", ()=>wt);
parcelHelpers.export(exports, "computePivotState", ()=>vl);
parcelHelpers.export(exports, "computeRowRange", ()=>Sl);
parcelHelpers.export(exports, "computeVisibleRows", ()=>wl);
parcelHelpers.export(exports, "createGenomeZone", ()=>cl);
parcelHelpers.export(exports, "createGenotypeMatrixZone", ()=>al);
parcelHelpers.export(exports, "createStubZone", ()=>ol);
parcelHelpers.export(exports, "createTableZone", ()=>dl);
parcelHelpers.export(exports, "defaultAggregators", ()=>(0, _tbrowseCore.defaultAggregators));
parcelHelpers.export(exports, "defaultSchemeFor", ()=>io);
parcelHelpers.export(exports, "ensureThemeStylesInjected", ()=>Ir);
parcelHelpers.export(exports, "fromEnsemblGeneStructure", ()=>fl);
parcelHelpers.export(exports, "fromEnsemblGeneTree", ()=>ul);
parcelHelpers.export(exports, "fromEnsemblGenomeFeatures", ()=>hl);
parcelHelpers.export(exports, "fromEnsemblProteinFeatures", ()=>pl);
parcelHelpers.export(exports, "fromGrameneGene", ()=>gl);
parcelHelpers.export(exports, "fromGrameneGeneStructures", ()=>bl);
parcelHelpers.export(exports, "fromGrameneGenetree", ()=>ml);
parcelHelpers.export(exports, "fromGrameneNeighborhood", ()=>xl);
parcelHelpers.export(exports, "labelsZone", ()=>il);
parcelHelpers.export(exports, "methodForKind", ()=>(0, _tbrowseCore.methodForKind));
parcelHelpers.export(exports, "msaZone", ()=>sl);
parcelHelpers.export(exports, "neighborhoodZone", ()=>ll);
parcelHelpers.export(exports, "providerFields", ()=>si);
parcelHelpers.export(exports, "resolveMatches", ()=>er);
parcelHelpers.export(exports, "rowHighlightBackground", ()=>Mr);
parcelHelpers.export(exports, "rowsWithFlags", ()=>Cr);
parcelHelpers.export(exports, "treeZone", ()=>rl);
parcelHelpers.export(exports, "useInitialViewState", ()=>nl);
parcelHelpers.export(exports, "useLoader", ()=>tl);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _zustand = require("zustand");
var _tbrowseCore = require("tbrowse-core");
var _reactDom = require("react-dom");
const Ot = 12;
function Go(e) {
    return {
        tree: e.tree,
        ...e.taxonomy !== void 0 ? {
            taxonomy: e.taxonomy
        } : {},
        ...e.msa !== void 0 ? {
            msa: e.msa
        } : {},
        ...e.geneMetadata !== void 0 ? {
            geneMetadata: e.geneMetadata
        } : {},
        ...e.nodeAnnotations !== void 0 ? {
            nodeAnnotations: e.nodeAnnotations
        } : {},
        ...e.labelProviders !== void 0 ? {
            labelProviders: e.labelProviders
        } : {},
        ...e.proteinDomains !== void 0 ? {
            proteinDomains: e.proteinDomains
        } : {},
        ...e.exonJunctions !== void 0 ? {
            exonJunctions: e.exonJunctions
        } : {},
        ...e.neighborhood !== void 0 ? {
            neighborhood: e.neighborhood
        } : {},
        ...e.geneStructures !== void 0 ? {
            geneStructures: e.geneStructures
        } : {},
        ...e.genomeFeatures !== void 0 ? {
            genomeFeatures: e.genomeFeatures
        } : {},
        ...e.germplasm !== void 0 ? {
            germplasm: e.germplasm
        } : {},
        ...e.hostData !== void 0 ? {
            hostData: e.hostData
        } : {}
    };
}
function Bo(e) {
    return (0, _tbrowseCore.buildInitialViewState)(e.zones, {
        data: Go(e),
        ...e.nodeOfInterest !== void 0 ? {
            nodeOfInterest: e.nodeOfInterest
        } : {},
        ...e.initialViewState !== void 0 ? {
            overrides: e.initialViewState
        } : {}
    });
}
function Xo(e) {
    const t = e.viewState ?? Bo(e);
    return (0, _zustand.createStore)((n)=>({
            viewState: t,
            hoveredNodeId: null,
            hoveredResidue: null,
            theme: e.theme ?? "light",
            fontSize: e.fontSize ?? Ot,
            nodeActions: e.nodeActions,
            setHoveredNodeId: (o)=>n({
                    hoveredNodeId: o
                }),
            setHoveredResidue: (o)=>n({
                    hoveredResidue: o
                }),
            setViewState: (o)=>n((i)=>({
                        viewState: typeof o == "function" ? o(i.viewState) : o
                    })),
            setTheme: (o)=>n({
                    theme: o
                }),
            setFontSize: (o)=>n({
                    fontSize: o
                })
        }));
}
const Qn = (0, _react.createContext)(null);
function Vo({ store: e, children: t }) {
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Qn.Provider, {
        value: e,
        children: t
    });
}
function Le(e) {
    const t = (0, _react.useContext)(Qn);
    if (!t) throw new Error("useTBrowseStore must be used within <TBrowse>");
    return (0, _zustand.useStore)(t, e);
}
function wt(e, { caseSensitive: t, regex: n }) {
    if (n) {
        let i;
        try {
            i = new RegExp(e, t ? "" : "i");
        } catch (a) {
            return {
                ok: !1,
                error: a.message
            };
        }
        return {
            ok: !0,
            test: (a)=>i.test(a),
            spanOf: (a)=>{
                i.lastIndex = 0;
                const c = i.exec(a);
                return c ? [
                    c.index,
                    c.index + c[0].length
                ] : null;
            }
        };
    }
    if (e.length === 0) return {
        ok: !1,
        error: "empty query"
    };
    if (t) return {
        ok: !0,
        test: (i)=>i.includes(e),
        spanOf: (i)=>{
            const a = i.indexOf(e);
            return a >= 0 ? [
                a,
                a + e.length
            ] : null;
        }
    };
    const o = e.toLowerCase();
    return {
        ok: !0,
        test: (i)=>i.toLowerCase().includes(o),
        spanOf: (i)=>{
            const a = i.toLowerCase().indexOf(o);
            return a >= 0 ? [
                a,
                a + e.length
            ] : null;
        }
    };
}
function at(e, t, n) {
    return {
        id: e,
        label: t,
        buildPredicate (o, i) {
            const a = wt(o, i);
            return a.ok ? {
                ok: !0,
                test: (c)=>{
                    const s = n(c, i.data);
                    return s != null && a.test(s);
                }
            } : a;
        },
        describeMatch (o, i, a, c) {
            const s = n(o, c);
            if (s == null) return null;
            const l = wt(i, a);
            if (!l.ok) return null;
            const f = l.spanOf(s);
            return f ? {
                value: s,
                start: f[0],
                end: f[1]
            } : null;
        }
    };
}
const Uo = at("gene-id", "Gene id", (e)=>e.geneId ?? null), Yo = at("gene-name", "Gene name", (e, t)=>{
    var o, i;
    if (!e.geneId) return null;
    const n = (i = (o = t.geneMetadata) == null ? void 0 : o[e.geneId]) == null ? void 0 : i.displayName;
    return typeof n == "string" ? n : null;
}), Ko = at("gene-description", "Gene description", (e, t)=>{
    var o, i;
    if (!e.geneId) return null;
    const n = (i = (o = t.geneMetadata) == null ? void 0 : o[e.geneId]) == null ? void 0 : i.description;
    return typeof n == "string" ? n : null;
}), jo = at("node-id", "Node id", (e)=>e.id), Zo = at("taxonomy-scientific", "Taxonomy (scientific name)", (e, t)=>{
    var n, o;
    return e.taxonomyId === void 0 ? null : ((o = (n = t.taxonomy) == null ? void 0 : n[e.taxonomyId]) == null ? void 0 : o.scientificName) ?? null;
}), Jo = at("taxonomy-common", "Taxonomy (common name)", (e, t)=>{
    var n, o;
    return e.taxonomyId === void 0 ? null : ((o = (n = t.taxonomy) == null ? void 0 : n[e.taxonomyId]) == null ? void 0 : o.commonName) ?? null;
}), Qo = [
    Uo,
    Yo,
    Ko,
    Zo,
    Jo,
    jo
], kt = {
    matchedLeafIds: /* @__PURE__ */ new Set(),
    matchedAncestorIds: /* @__PURE__ */ new Set(),
    truncated: !1,
    regexError: null
};
function er(e, t, n, o) {
    if (!t || !t.query) return kt;
    const i = new Set(t.excludedFields ?? []), a = n.filter((u)=>!i.has(u.id));
    if (a.length === 0) return kt;
    const c = {
        data: e,
        caseSensitive: t.caseSensitive ?? !1,
        regex: t.regex ?? !1
    }, s = [];
    let l = null;
    for (const u of a){
        const g = u.buildPredicate(t.query, c);
        g.ok ? s.push(g.test) : l === null && (l = g.error);
    }
    if (s.length === 0) return {
        ...kt,
        regexError: l
    };
    const f = /* @__PURE__ */ new Set();
    let h = !1;
    for (const u of Object.keys(e.tree.nodes)){
        const g = e.tree.nodes[u];
        if (!g.isLeaf || nr(g.id, e.tree, o)) continue;
        let y = !1;
        for(let p = 0; p < s.length; p++)if (s[p](g)) {
            y = !0;
            break;
        }
        if (y && (f.add(g.id), f.size >= (0, _tbrowseCore.SEARCH_MATCH_LIMIT))) {
            h = !0;
            break;
        }
    }
    return f.size === 0 ? {
        ...kt,
        truncated: h
    } : {
        matchedLeafIds: f,
        matchedAncestorIds: tr(f, e.tree),
        truncated: h,
        regexError: null
    };
}
function tr(e, t) {
    var o, i;
    const n = /* @__PURE__ */ new Set();
    for (const a of e){
        let c = ((o = t.nodes[a]) == null ? void 0 : o.parentId) ?? null;
        for(; c !== null && !n.has(c);)n.add(c), c = ((i = t.nodes[c]) == null ? void 0 : i.parentId) ?? null;
    }
    return n;
}
function nr(e, t, n) {
    var i;
    if (n.size === 0) return !1;
    let o = e;
    for(; o !== null;){
        if (n.has(o)) return !0;
        o = ((i = t.nodes[o]) == null ? void 0 : i.parentId) ?? null;
    }
    return !1;
}
function or({ zoneId: e, visibleZones: t, gridRef: n, setDragState: o }) {
    const i = Le((c)=>c.setViewState);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        className: "tbrowse-reorder-handle",
        onPointerDown: (c)=>{
            c.preventDefault(), c.stopPropagation();
            const s = t.findIndex((g)=>g.id === e);
            if (s < 0) return;
            let l = s;
            o({
                zoneId: e,
                fromIndex: s,
                targetIndex: s,
                cursorX: c.clientX
            });
            const f = (g)=>{
                const y = n.current;
                if (!y) return s;
                const p = y.getBoundingClientRect(), k = g - p.left + y.scrollLeft;
                let x = 0;
                for(let m = 0; m < t.length; m++){
                    const b = t[m].width;
                    if (k < x + b / 2) return m;
                    x += b;
                }
                return t.length;
            }, h = (g)=>{
                const y = f(g.clientX);
                l = y, o({
                    zoneId: e,
                    fromIndex: s,
                    targetIndex: y,
                    cursorX: g.clientX
                });
            }, u = ()=>{
                window.removeEventListener("pointermove", h), window.removeEventListener("pointerup", u), o(null), l !== s && l !== s + 1 && i((g)=>{
                    const y = t.map((b)=>b.id), p = y[s], k = [
                        ...y
                    ];
                    k.splice(s, 1), k.splice(l > s ? l - 1 : l, 0, p);
                    const x = [];
                    let m = 0;
                    for (const b of g.zones){
                        if (!b.visible) {
                            x.push(b);
                            continue;
                        }
                        const E = k[m++], T = g.zones.find((I)=>I.id === E);
                        x.push(T);
                    }
                    return {
                        ...g,
                        zones: x
                    };
                });
            };
            window.addEventListener("pointermove", h), window.addEventListener("pointerup", u);
        },
        title: "Drag to reorder",
        style: {
            width: 14,
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "grab",
            userSelect: "none",
            touchAction: "none",
            color: "var(--tbrowse-text-subtle)",
            flexShrink: 0
        },
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
            style: {
                fontSize: 12,
                lineHeight: 1
            },
            children: "\u22EE\u22EE"
        })
    });
}
function rr({ zoneId: e, nextZoneId: t, currentFr: n, nextFr: o, sumFr: i, containerWidth: a, minWidth: c, nextMinWidth: s, setResizing: l }) {
    const f = Le((u)=>u.setViewState);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        className: "tbrowse-resize-handle",
        onPointerDown: (u)=>{
            if (u.preventDefault(), u.stopPropagation(), i <= 0 || a <= 0) return;
            const g = u.clientX, y = n, p = o;
            l(!0);
            const k = i / a, x = c * k, m = s * k, b = x - y, E = p - m, T = (_)=>{
                let M = (_.clientX - g) * k;
                M < b && (M = b), M > E && (M = E), f(($)=>({
                        ...$,
                        zones: $.zones.map((W)=>W.id === e ? {
                                ...W,
                                width: y + M
                            } : W.id === t ? {
                                ...W,
                                width: p - M
                            } : W)
                    }));
            }, I = ()=>{
                window.removeEventListener("pointermove", T), window.removeEventListener("pointerup", I), l(!1);
            };
            window.addEventListener("pointermove", T), window.addEventListener("pointerup", I);
        },
        style: {
            position: "absolute",
            top: 0,
            right: 0,
            width: 6,
            height: "100%",
            cursor: "col-resize",
            userSelect: "none",
            touchAction: "none"
        }
    });
}
function yt({ size: e = 14 }) {
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("svg", {
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 1.75,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("circle", {
                cx: 12,
                cy: 12,
                r: 3
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("path", {
                d: "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"
            })
        ]
    });
}
function ir({ search: e, setSearch: t, results: n, fields: o, onCollapseToMatches: i, inputRef: a, portalTarget: c }) {
    const s = (0, _react.useRef)(null), l = a ?? s, [f, h] = (0, _react.useState)(!1), u = (e == null ? void 0 : e.query) ?? "", g = (e == null ? void 0 : e.caseSensitive) ?? !1, y = (e == null ? void 0 : e.regex) ?? !1, p = new Set((e == null ? void 0 : e.excludedFields) ?? []), k = o.length - p.size, x = g || y || p.size > 0, m = (M)=>{
        const $ = M.query ?? u, W = M.caseSensitive ?? g, H = M.regex ?? y, w = M.excludedFields ?? (e == null ? void 0 : e.excludedFields) ?? [], N = W || H || w.length > 0;
        if (!$ && !N) {
            t(null);
            return;
        }
        const v = {
            query: $,
            ...w.length > 0 ? {
                excludedFields: w
            } : {},
            ...W ? {
                caseSensitive: !0
            } : {},
            ...H ? {
                regex: !0
            } : {}
        };
        t(v);
    }, b = (M)=>{
        const $ = new Set(p);
        $.has(M) ? $.delete(M) : $.add(M), m({
            excludedFields: [
                ...$
            ]
        });
    }, E = n.matchedLeafIds.size, T = !!n.regexError, I = !!u, _ = n.truncated;
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: "tbrowse-search-controls",
        style: {
            display: "flex",
            alignItems: "center",
            gap: 6,
            fontSize: 12,
            color: "var(--tbrowse-text)"
        },
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                style: {
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    flex: "0 1 280px"
                },
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                    ref: l,
                    type: "search",
                    value: u,
                    placeholder: "Search\u2026",
                    onChange: (M)=>m({
                            query: M.target.value
                        }),
                    onKeyDown: (M)=>{
                        M.key === "Escape" && (t(null), M.target.blur());
                    },
                    "aria-invalid": T || void 0,
                    "aria-describedby": T ? "tbrowse-search-error" : void 0,
                    style: {
                        width: "100%",
                        height: 22,
                        padding: "0 6px",
                        background: "var(--tbrowse-bg-elevated)",
                        color: "var(--tbrowse-text)",
                        border: `1px solid ${T ? "var(--tbrowse-danger)" : "var(--tbrowse-border)"}`,
                        borderRadius: 3,
                        fontSize: 12,
                        outline: "none"
                    }
                })
            }),
            I && /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                style: {
                    color: T ? "var(--tbrowse-danger)" : E === 0 ? "var(--tbrowse-text-muted)" : "var(--tbrowse-text)",
                    fontVariantNumeric: "tabular-nums",
                    whiteSpace: "nowrap"
                },
                children: T ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                    id: "tbrowse-search-error",
                    title: n.regexError ?? "",
                    children: "regex error"
                }) : /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        E.toLocaleString(),
                        " ",
                        E === 1 ? "match" : "matches",
                        _ && /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                            title: `Capped at ${(0, _tbrowseCore.SEARCH_MATCH_LIMIT).toLocaleString()} \u{2014} refine the query to find specific matches.`,
                            style: {
                                marginLeft: 4,
                                color: "var(--tbrowse-text-muted)"
                            },
                            children: "(more)"
                        })
                    ]
                })
            }),
            I && E > 0 && /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                type: "button",
                "aria-label": "Show matches only",
                onClick: i,
                title: "Collapse every subtree that doesn't contain a match \u2014 only the matched lineages stay expanded.",
                style: {
                    height: 22,
                    padding: "0 8px",
                    background: "var(--tbrowse-search-soft)",
                    color: "var(--tbrowse-search)",
                    border: "1px solid var(--tbrowse-search)",
                    borderRadius: 3,
                    fontSize: 11,
                    fontWeight: 600,
                    cursor: "pointer",
                    whiteSpace: "nowrap"
                },
                children: "Show matches only"
            }),
            I && /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                type: "button",
                "aria-label": "Clear search",
                onClick: ()=>t(null),
                title: "Clear search (Esc)",
                style: {
                    height: 22,
                    padding: "0 6px",
                    background: "transparent",
                    color: "var(--tbrowse-text-muted)",
                    border: "1px solid var(--tbrowse-border)",
                    borderRadius: 3,
                    fontSize: 12,
                    cursor: "pointer"
                },
                children: "\xd7"
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(sr, {
                fields: o,
                excluded: p,
                activeFieldCount: k,
                totalFieldCount: o.length,
                caseSensitive: g,
                regex: y,
                nonDefault: x,
                open: f,
                setOpen: h,
                onToggleField: b,
                onSelectAllFields: ()=>m({
                        excludedFields: []
                    }),
                onSelectNoFields: ()=>m({
                        excludedFields: o.map((M)=>M.id)
                    }),
                onToggleCaseSensitive: ()=>m({
                        caseSensitive: !g
                    }),
                onToggleRegex: ()=>m({
                        regex: !y
                    }),
                portalTarget: c
            })
        ]
    });
}
function sr({ fields: e, excluded: t, activeFieldCount: n, totalFieldCount: o, caseSensitive: i, regex: a, nonDefault: c, open: s, setOpen: l, onToggleField: f, onSelectAllFields: h, onSelectNoFields: u, onToggleCaseSensitive: g, onToggleRegex: y, portalTarget: p }) {
    const k = (0, _react.useRef)(null), x = (0, _react.useRef)(null), m = (0, _react.useRef)(null), b = n === 0, E = Le((M)=>M.theme), [T, I] = (0, _react.useState)(null);
    (0, _react.useEffect)(()=>{
        var $;
        if (!s) {
            I(null);
            return;
        }
        const M = ($ = x.current) == null ? void 0 : $.getBoundingClientRect();
        M && I({
            top: M.bottom + 4,
            right: Math.max(8, window.innerWidth - M.right)
        });
    }, [
        s
    ]), (0, _react.useEffect)(()=>{
        if (!s) return;
        const M = (w)=>{
            var v, L;
            const N = w.target;
            (v = k.current) != null && v.contains(N) || (L = m.current) != null && L.contains(N) || l(!1);
        }, $ = (w)=>{
            w.key === "Escape" && l(!1);
        }, W = ()=>{
            var N;
            const w = (N = x.current) == null ? void 0 : N.getBoundingClientRect();
            w && I({
                top: w.bottom + 4,
                right: Math.max(8, window.innerWidth - w.right)
            });
        }, H = setTimeout(()=>{
            document.addEventListener("mousedown", M), document.addEventListener("keydown", $), window.addEventListener("resize", W);
        }, 0);
        return ()=>{
            clearTimeout(H), document.removeEventListener("mousedown", M), document.removeEventListener("keydown", $), window.removeEventListener("resize", W);
        };
    }, [
        s,
        l
    ]);
    const _ = s && T && /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        ref: m,
        role: "dialog",
        "aria-label": "Search settings",
        style: {
            position: "fixed",
            top: T.top,
            right: T.right,
            zIndex: 2e3,
            minWidth: 240,
            padding: 6,
            background: "var(--tbrowse-bg-elevated)",
            border: "1px solid var(--tbrowse-border)",
            borderRadius: 4,
            boxShadow: "0 4px 12px var(--tbrowse-tooltip-shadow)",
            color: "var(--tbrowse-text)",
            fontSize: 12
        },
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(fn, {
                label: "Fields",
                badge: n === o ? `${o}` : `${n}/${o}`,
                actions: /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            onClick: h,
                            style: hn,
                            children: "All"
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            onClick: u,
                            style: hn,
                            children: "None"
                        })
                    ]
                })
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("ul", {
                style: {
                    listStyle: "none",
                    margin: 0,
                    padding: 0,
                    maxHeight: 220,
                    overflowY: "auto"
                },
                children: e.map((M)=>{
                    const $ = !t.has(M.id);
                    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("li", {
                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ht, {
                            checked: $,
                            onToggle: ()=>f(M.id),
                            label: M.label
                        })
                    }, M.id);
                })
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                style: {
                    borderTop: "1px solid var(--tbrowse-border-soft)",
                    marginTop: 4,
                    paddingTop: 4
                }
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(fn, {
                label: "Modifiers"
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ht, {
                checked: i,
                onToggle: g,
                label: "Case-sensitive",
                hint: "Aa"
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ht, {
                checked: a,
                onToggle: y,
                label: "Regular expression",
                hint: ".*"
            })
        ]
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        ref: k,
        style: {
            display: "inline-flex"
        },
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                ref: x,
                type: "button",
                "aria-haspopup": "true",
                "aria-expanded": s,
                "aria-label": "Search settings",
                title: b ? "No fields selected \u2014 search disabled. Click to configure." : c ? "Search settings (modified)" : "Search settings",
                onClick: ()=>l(!s),
                style: {
                    height: 22,
                    width: 26,
                    padding: 0,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: b ? "transparent" : c ? "var(--tbrowse-accent-soft)" : "var(--tbrowse-bg-elevated)",
                    color: b ? "var(--tbrowse-danger)" : c ? "var(--tbrowse-accent)" : "var(--tbrowse-text-muted)",
                    border: `1px solid ${b ? "var(--tbrowse-danger)" : c ? "var(--tbrowse-accent)" : "var(--tbrowse-border)"}`,
                    borderRadius: 3,
                    fontSize: 14,
                    lineHeight: 1,
                    cursor: "pointer"
                },
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(yt, {})
            }),
            _ && (0, _reactDom.createPortal)(// Themed wrapper re-applies the `tbrowse-theme-*` class
            // on this side of the portal so the popover's CSS
            // custom properties resolve and it gets a real
            // background instead of rendering transparent on top of
            // whatever sits beneath it.
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                className: `tbrowse-root tbrowse-theme-${E}`,
                children: _
            }), // Prefer the chassis-root element — it's inside whatever
            // fullscreen / modal subtree the host has wrapped TBrowse
            // in, so the popover stays visible. Fall back to body
            // when no chassis ref is available. `document.body` is
            // hidden when the host enables the browser Fullscreen
            // API on a smaller subtree, which is why portaling into
            // the chassis is the safer default.
            (p == null ? void 0 : p.current) ?? document.body)
        ]
    });
}
function fn({ label: e, badge: t, actions: n }) {
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        style: {
            display: "flex",
            alignItems: "baseline",
            justifyContent: "space-between",
            gap: 6,
            padding: "4px 4px 2px 4px",
            fontSize: 11,
            fontWeight: 600,
            textTransform: "uppercase",
            letterSpacing: 0.4,
            color: "var(--tbrowse-text-muted)"
        },
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                children: [
                    e,
                    t && /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                        style: {
                            marginLeft: 6,
                            fontWeight: 400,
                            color: "var(--tbrowse-text-subtle)",
                            textTransform: "none",
                            letterSpacing: 0
                        },
                        children: t
                    })
                ]
            }),
            n && /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                style: {
                    display: "flex",
                    gap: 4
                },
                children: n
            })
        ]
    });
}
function Ht({ checked: e, onToggle: t, label: n, hint: o }) {
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("label", {
        style: {
            display: "flex",
            alignItems: "center",
            gap: 6,
            padding: "3px 4px",
            borderRadius: 3,
            cursor: "pointer"
        },
        onMouseDown: (i)=>i.preventDefault(),
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                type: "checkbox",
                checked: e,
                onChange: t
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                style: {
                    flex: 1
                },
                children: n
            }),
            o && /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                "aria-hidden": "true",
                style: {
                    fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
                    fontSize: 10,
                    color: "var(--tbrowse-text-subtle)",
                    background: "var(--tbrowse-bg-input)",
                    border: "1px solid var(--tbrowse-border-soft)",
                    borderRadius: 2,
                    padding: "0 4px"
                },
                children: o
            })
        ]
    });
}
const hn = {
    background: "transparent",
    border: "none",
    color: "var(--tbrowse-accent)",
    fontSize: 11,
    cursor: "pointer",
    padding: "2px 4px"
}, lr = {
    display: "inline-flex",
    border: "1px solid var(--tbrowse-border)",
    borderRadius: 3,
    overflow: "hidden"
};
function cr({ zones: e, data: t, zoneStatus: n }) {
    const o = Le((x)=>x.viewState.zones), i = Le((x)=>x.viewState.zoneStates), a = Le((x)=>x.viewState.unlinkedZoneGroups), c = Le((x)=>x.setViewState), s = {};
    for (const x of o)s[x.id] = x.visible;
    const l = new Set(a ?? []), f = (x, m)=>{
        let b = x.zones.map((E)=>Object.prototype.hasOwnProperty.call(m, E.id) ? {
                ...E,
                visible: m[E.id],
                userToggled: !0
            } : E);
        for (const [E, T] of Object.entries(m)){
            if (b.some((_)=>_.id === E)) continue;
            const I = e.find((_)=>_.id === E);
            I && (b = [
                ...b,
                {
                    id: E,
                    width: I.defaultWidth,
                    visible: T,
                    userToggled: !0
                }
            ]);
        }
        return {
            ...x,
            zones: b
        };
    }, h = (x, m)=>{
        c((b)=>{
            var _;
            const E = ((_ = b.zones.find((M)=>M.id === x)) == null ? void 0 : _.visible) ?? !1;
            if (!(!!m && !(b.unlinkedZoneGroups ?? []).includes(m.id))) return f(b, {
                [x]: !E
            });
            if (E) return f(b, {
                [x]: !1
            });
            const I = {};
            for (const M of m.members)I[M.id] = M.id === x;
            return f(b, I);
        });
    }, u = (x)=>{
        c((m)=>{
            const b = m.unlinkedZoneGroups ?? [];
            if (!b.includes(x.id)) return {
                ...m,
                unlinkedZoneGroups: [
                    ...b,
                    x.id
                ]
            };
            const E = {
                ...m,
                unlinkedZoneGroups: b.filter((_)=>_ !== x.id)
            }, T = x.members.filter((_)=>{
                var M;
                return (M = m.zones.find(($)=>$.id === _.id)) == null ? void 0 : M.visible;
            });
            if (T.length <= 1) return E;
            const I = {};
            for (const _ of T)I[_.id] = _.id === T[0].id;
            return f(E, I);
        });
    }, g = (x)=>{
        const m = x.isAvailable(t), b = n == null ? void 0 : n[x.id], E = b === "loading", T = b === "error", I = [];
        return E ? I.push("Loading\u2026") : T ? I.push("Load failed \u2014 click to retry from the host") : m || I.push("Unavailable: required data missing"), {
            available: m,
            isLoading: E,
            isError: T,
            // While loading the button doesn't toggle (no data to show anyway).
            // On error it stays clickable so a previously-shown zone can be
            // collapsed/expanded, but it visibly flags the failed attempt.
            enabled: m && !E,
            title: I.join(" ") || void 0,
            className: [
                "tbrowse-zone-toggle",
                E ? "tbrowse-zone-loading" : "",
                T ? "tbrowse-zone-error" : ""
            ].filter(Boolean).join(" ")
        };
    }, y = (x)=>{
        const m = i == null ? void 0 : i[x.id];
        return m != null && m.name && m.name !== "" ? m.name : x.displayName;
    }, p = [], k = /* @__PURE__ */ new Set();
    for (const x of e){
        const m = x.exclusiveGroup;
        if (!m) {
            p.push({
                kind: "single",
                def: x
            });
            continue;
        }
        if (k.has(m)) continue;
        k.add(m);
        const b = e.filter((E)=>E.exclusiveGroup === m);
        b.length < 2 ? p.push({
            kind: "single",
            def: x
        }) : p.push({
            kind: "group",
            id: m,
            members: b
        });
    }
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        className: "tbrowse-zone-toggles",
        style: {
            display: "flex",
            alignItems: "center",
            gap: 6,
            fontSize: 11,
            color: "var(--tbrowse-text)",
            flexWrap: "wrap"
        },
        children: p.map((x)=>{
            if (x.kind === "single") {
                const b = x.def, E = s[b.id] ?? !1, T = g(b);
                return /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                    type: "button",
                    className: T.className,
                    onClick: ()=>h(b.id),
                    disabled: !T.enabled,
                    title: T.title,
                    "aria-pressed": E,
                    style: {
                        fontSize: 11,
                        padding: "2px 8px",
                        lineHeight: 1.4,
                        borderRadius: 3,
                        // Error state overrides the standard accent border via the
                        // `tbrowse-zone-error` class (defined in theme.ts) so it
                        // wins visually without inline-style fighting.
                        border: `1px solid ${E ? "var(--tbrowse-accent)" : "var(--tbrowse-border)"}`,
                        background: E ? "var(--tbrowse-accent-soft)" : "var(--tbrowse-bg-input)",
                        color: T.available ? E ? "var(--tbrowse-accent-strong)" : "var(--tbrowse-text)" : "var(--tbrowse-text-subtle)",
                        cursor: T.enabled ? "pointer" : T.isLoading ? "progress" : "not-allowed"
                    },
                    children: y(b)
                }, b.id);
            }
            const m = l.has(x.id);
            return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                style: {
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 4
                },
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                        style: lr,
                        role: "group",
                        "aria-label": `${x.id} zones`,
                        children: x.members.map((b, E)=>{
                            const T = s[b.id] ?? !1, I = g(b), _ = E === x.members.length - 1;
                            return /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: I.className,
                                onClick: ()=>h(b.id, x),
                                disabled: !I.enabled,
                                title: I.title,
                                "aria-pressed": T,
                                style: {
                                    fontSize: 11,
                                    padding: "2px 8px",
                                    lineHeight: 1.4,
                                    border: "none",
                                    borderRight: _ ? "none" : "1px solid var(--tbrowse-border)",
                                    background: T ? "var(--tbrowse-accent-soft)" : "var(--tbrowse-bg-input)",
                                    color: I.available ? T ? "var(--tbrowse-accent-strong)" : "var(--tbrowse-text)" : "var(--tbrowse-text-subtle)",
                                    cursor: I.enabled ? "pointer" : I.isLoading ? "progress" : "not-allowed",
                                    fontFamily: "inherit"
                                },
                                children: y(b)
                            }, b.id);
                        })
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        onClick: ()=>u(x),
                        "aria-pressed": m,
                        title: m ? "Multiple of these zones allowed \u2014 click to show only one at a time" : "Only one of these zones at a time \u2014 click to allow multiple",
                        style: {
                            fontSize: 11,
                            padding: "2px 6px",
                            lineHeight: 1.4,
                            borderRadius: 3,
                            border: `1px solid ${m ? "var(--tbrowse-accent)" : "var(--tbrowse-border)"}`,
                            background: m ? "var(--tbrowse-accent-soft)" : "var(--tbrowse-bg-input)",
                            color: m ? "var(--tbrowse-accent-strong)" : "var(--tbrowse-text-muted)",
                            cursor: "pointer",
                            fontFamily: "inherit"
                        },
                        children: "multi"
                    })
                ]
            }, `group-${x.id}`);
        })
    });
}
const ar = {
    light: [
        "#595959",
        "#b40098",
        "#595959",
        "#cc3301",
        "#2f874c",
        "#0e0ee5"
    ],
    dark: [
        "#cccccc",
        "#ed5fcb",
        "#cccccc",
        "#ff7849",
        "#5dd28a",
        "#6680ff"
    ]
};
function dr({ height: e = 28, title: t = "TBrowse", variant: n = "light" }) {
    const o = 3.3891050583657587, i = ar[n], a = i[4];
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("svg", {
        role: "img",
        "aria-label": t,
        height: e,
        width: e * o,
        viewBox: "30 34 871 257",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("title", {
                children: t
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("path", {
                fill: i[0],
                d: "m294.1762 207.8402q0 7.15625 -1.828125 13.1875q-1.8125 6.03125 -5.09375 10.84375q-3.28125 4.796875 -7.90625 8.4375q-4.625 3.625 -10.4375 6.09375q-5.796875 2.453125 -12.421875 3.6875q-6.609375 1.234375 -15.171875 1.234375l-39.609375 0q-2.6875 0 -5.09375 -1.8125q-2.40625 -1.828125 -2.40625 -6.390625l0 -135.23438q0 -4.578125 2.40625 -6.390625q2.40625 -1.8125 5.09375 -1.8125l34.453125 0q13.59375 0 22.265625 2.578125q8.671875 2.578125 14.46875 7.5q5.8125 4.921875 8.734375 12.078125q2.9375 7.140617 2.9375 16.156242q0 5.390625 -1.296875 10.3125q-1.28125 4.921875 -3.8125 9.09375q-2.515625 4.15625 -6.328125 7.4375q-3.796875 3.28125 -8.71875 5.390625q6.203125 1.171875 11.59375 4.28125q5.390625 3.09375 9.4375 7.90625q4.046875 4.796875 6.390625 11.25q2.34375 6.4375 2.34375 14.171875zm-30.359375 -67.84375q0 -5.515625 -1.53125 -9.96875q-1.515625 -4.453117 -4.796875 -7.5468674q-3.28125 -3.109375 -8.5625 -4.75q-5.265625 -1.640625 -13.9375 -1.640625l-20.859375 0l0 49.093742l22.96875 0q7.859375 0 12.65625 -2.046875q4.8125 -2.046875 7.96875 -5.5q3.171875 -3.46875 4.625 -8.09375q1.46875 -4.625 1.46875 -9.546875zm9.140625 69.015625q0 -6.796875 -2.171875 -11.953125q-2.15625 -5.15625 -6.328125 -8.671875q-4.15625 -3.515625 -10.421875 -5.328125q-6.265625 -1.8125 -15.765625 -1.8125l-24.140625 0l0 53.4375l29.296875 0q6.921875 0 12.078125 -1.640625q5.15625 -1.640625 9.078125 -4.859375q3.921875 -3.234375 6.140625 -8.03125q2.234375 -4.8125 2.234375 -11.140625z"
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("path", {
                fill: i[1],
                d: "m384.1762 149.8402q0 2.578125 -0.125 4.34375q-0.109375 1.75 -0.46875 2.75q-0.34375 0.984375 -0.875 1.515625q-0.53125 0.53125 -1.46875 0.53125q-0.9375 0 -2.28125 -0.53125q-1.34375 -0.53125 -3.046875 -1.046875q-1.703125 -0.53125 -3.8125 -1.0q-2.109375 -0.46875 -4.5625 -0.46875q-2.9375 0 -5.75 1.171875q-2.8125 1.171875 -5.921875 3.875q-3.09375 2.6875 -6.5 7.140625q-3.390625 4.453125 -7.5 10.890625l0 69.375q0 0.9375 -0.46875 1.59375q-0.46875 0.640625 -1.53125 1.109375q-1.046875 0.46875 -2.921875 0.703125q-1.875 0.234375 -4.796875 0.234375q-2.8125 0 -4.6875 -0.234375q-1.875 -0.234375 -3.0 -0.703125q-1.109375 -0.46875 -1.515625 -1.109375q-0.40625 -0.65625 -0.40625 -1.59375l0 -105.46875q0 -0.9375 0.34375 -1.578125q0.359375 -0.640625 1.40625 -1.171875q1.0625 -0.53125 2.703125 -0.703125q1.640625 -0.171875 4.328125 -0.171875q2.578125 0 4.28125 0.171875q1.703125 0.171875 2.640625 0.703125q0.9375 0.53125 1.34375 1.171875q0.40625 0.640625 0.40625 1.578125l0 15.359375q4.34375 -6.328125 8.140625 -10.3125q3.8125 -3.984375 7.203125 -6.265625q3.40625 -2.296875 6.75 -3.171875q3.34375 -0.875 6.734375 -0.875q1.53125 0 3.453125 0.171875q1.9375 0.171875 4.046875 0.640625q2.109375 0.46875 3.8125 1.0625q1.703125 0.578125 2.40625 1.171875q0.703125 0.578125 0.9375 1.109375q0.234375 0.53125 0.40625 1.359375q0.171875 0.8125 0.234375 2.390625q0.0625 1.578125 0.0625 4.28125z"
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("path", {
                fill: i[2],
                d: "m504.28558 194.48082q0 12.890625 -3.40625 23.734375q-3.390625 10.84375 -10.125 18.703125q-6.734375 7.84375 -16.875 12.25q-10.140625 4.390625 -23.5 4.390625q-13.0 0 -22.671875 -3.875q-9.671875 -3.875 -16.125 -11.25q-6.4375 -7.390625 -9.609375 -17.9375q-3.15625 -10.546875 -3.15625 -23.90625q0 -12.890625 3.34375 -23.71875q3.34375 -10.84375 10.078125 -18.6875q6.734375 -7.859375 16.8125 -12.1875q10.078125 -4.34375 23.5625 -4.34375q13.0 0 22.671875 3.875q9.671875 3.859375 16.109375 11.25q6.453125 7.375 9.671875 17.921875q3.21875 10.546875 3.21875 23.78125zm-20.390625 1.296875q0 -8.5625 -1.578125 -16.171875q-1.578125 -7.625 -5.21875 -13.359375q-3.625 -5.75 -9.84375 -9.078125q-6.203125 -3.34375 -15.46875 -3.34375q-8.546875 0 -14.703125 3.046875q-6.15625 3.046875 -10.140625 8.609375q-3.984375 5.5625 -5.921875 13.1875q-1.921875 7.609375 -1.921875 16.640625q0 8.671875 1.578125 16.296875q1.578125 7.609375 5.265625 13.296875q3.703125 5.671875 9.90625 9.015625q6.21875 3.34375 15.46875 3.34375q8.4375 0 14.640625 -3.046875q6.21875 -3.046875 10.203125 -8.546875q3.984375 -5.515625 5.859375 -13.125q1.875 -7.625 1.875 -16.765625z"
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("path", {
                fill: i[3],
                d: "m680.3012 142.68394q0 0.828125 -0.234375 2.0q-0.234375 1.171875 -0.8125 2.921875l-31.0625 100.203125q-0.34375 1.28125 -1.109375 2.109375q-0.765625 0.8125 -2.109375 1.296875q-1.34375 0.46875 -3.6875 0.640625q-2.34375 0.171875 -5.859375 0.171875q-3.640625 0 -6.109375 -0.234375q-2.453125 -0.234375 -3.921875 -0.703125q-1.453125 -0.46875 -2.15625 -1.28125q-0.703125 -0.828125 -1.0625 -2.0l-22.140625 -76.53125l-0.234375 -1.046875l-0.234375 1.046875l-20.515625 76.53125q-0.34375 1.28125 -1.109375 2.109375q-0.765625 0.8125 -2.296875 1.296875q-1.515625 0.46875 -3.921875 0.640625q-2.390625 0.171875 -5.90625 0.171875q-3.640625 0 -5.921875 -0.234375q-2.28125 -0.234375 -3.75 -0.703125q-1.46875 -0.46875 -2.171875 -1.28125q-0.703125 -0.828125 -1.046875 -2.0l-30.828125 -100.203125q-0.578125 -1.75 -0.8125 -2.921875q-0.234375 -1.171875 -0.234375 -2.0q0 -1.046875 0.46875 -1.6875q0.46875 -0.65625 1.578125 -1.0625q1.109375 -0.40625 2.984375 -0.515625q1.875 -0.125 4.578125 -0.125q3.28125 0 5.265625 0.171875q2.0 0.171875 3.046875 0.59375q1.0625 0.40625 1.53125 1.171875q0.46875 0.75 0.8125 1.8125l25.4375 86.953125l0.234375 1.046875l0.234375 -1.046875l23.3125 -86.953125q0.234375 -1.0625 0.765625 -1.8125q0.53125 -0.765625 1.578125 -1.171875q1.0625 -0.421875 2.875 -0.59375q1.8125 -0.171875 4.75 -0.171875q2.8125 0 4.625 0.171875q1.8125 0.171875 2.859375 0.59375q1.0625 0.40625 1.53125 1.109375q0.46875 0.703125 0.703125 1.640625l25.203125 87.1875l0.234375 1.046875l0.109375 -1.046875l25.078125 -86.953125q0.234375 -1.0625 0.765625 -1.8125q0.53125 -0.765625 1.640625 -1.171875q1.109375 -0.421875 3.046875 -0.59375q1.9375 -0.171875 4.984375 -0.171875q2.8125 0 4.5 0.125q1.703125 0.109375 2.703125 0.578125q1.0 0.46875 1.40625 1.0625q0.40625 0.578125 0.40625 1.625z"
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("path", {
                fill: i[4],
                d: "m770.5356 219.68394q0 8.078125 -2.984375 14.40625q-2.984375 6.328125 -8.5 10.671875q-5.5 4.328125 -13.125 6.5625q-7.609375 2.234375 -16.75 2.234375q-5.625 0 -10.734375 -0.890625q-5.09375 -0.875 -9.140625 -2.21875q-4.03125 -1.359375 -6.84375 -2.8125q-2.8125 -1.46875 -4.109375 -2.640625q-1.28125 -1.171875 -1.875 -3.28125q-0.578125 -2.109375 -0.578125 -5.75q0 -2.21875 0.234375 -3.734375q0.234375 -1.53125 0.578125 -2.46875q0.359375 -0.9375 1.0 -1.34375q0.640625 -0.421875 1.46875 -0.421875q1.28125 0 3.796875 1.59375q2.53125 1.578125 6.21875 3.453125q3.6875 1.875 8.71875 3.453125q5.046875 1.578125 11.609375 1.578125q4.921875 0 8.90625 -1.046875q3.984375 -1.0625 6.90625 -3.109375q2.9375 -2.046875 4.515625 -5.203125q1.59375 -3.171875 1.59375 -7.515625q0 -4.453125 -2.296875 -7.5q-2.28125 -3.046875 -6.03125 -5.390625q-3.75 -2.34375 -8.4375 -4.15625q-4.6875 -1.8125 -9.671875 -3.796875q-4.96875 -2.0 -9.71875 -4.515625q-4.75 -2.53125 -8.5 -6.15625q-3.75 -3.640625 -6.03125 -8.671875q-2.28125 -5.046875 -2.28125 -12.078125q0 -6.203125 2.390625 -11.890625q2.40625 -5.6875 7.203125 -9.953125q4.8125 -4.28125 12.015625 -6.859375q7.21875 -2.578125 16.828125 -2.578125q4.21875 0 8.4375 0.703125q4.21875 0.703125 7.609375 1.765625q3.40625 1.046875 5.796875 2.28125q2.40625 1.21875 3.640625 2.15625q1.234375 0.9375 1.640625 1.640625q0.40625 0.703125 0.578125 1.59375q0.1875 0.875 0.359375 2.171875q0.171875 1.28125 0.171875 3.15625q0 1.984375 -0.171875 3.453125q-0.171875 1.46875 -0.59375 2.40625q-0.40625 0.9375 -1.0 1.34375q-0.578125 0.40625 -1.28125 0.40625q-1.046875 0 -3.046875 -1.28125q-1.984375 -1.296875 -5.15625 -2.75q-3.15625 -1.46875 -7.4375 -2.75q-4.28125 -1.296875 -9.78125 -1.296875q-4.921875 0 -8.671875 1.109375q-3.75 1.109375 -6.15625 3.171875q-2.40625 2.046875 -3.640625 4.859375q-1.21875 2.8125 -1.21875 6.09375q0 4.5625 2.34375 7.671875q2.34375 3.109375 6.09375 5.453125q3.75 2.34375 8.546875 4.21875q4.8125 1.875 9.78125 3.875q4.984375 1.984375 9.84375 4.453125q4.875 2.453125 8.625 5.96875q3.75 3.515625 6.03125 8.4375q2.28125 4.921875 2.28125 11.71875z"
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("path", {
                fill: i[5],
                d: "m888.19965 191.0902q0 4.5625 -2.296875 6.5q-2.28125 1.9375 -5.203125 1.9375l-69.140625 0q0 8.78125 1.75 15.8125q1.765625 7.03125 5.859375 12.078125q4.109375 5.03125 10.671875 7.734375q6.5625 2.6875 16.046875 2.6875q7.5 0 13.359375 -1.21875q5.859375 -1.234375 10.140625 -2.75q4.28125 -1.53125 7.03125 -2.765625q2.75 -1.234375 4.15625 -1.234375q0.828125 0 1.46875 0.421875q0.640625 0.40625 0.984375 1.234375q0.359375 0.8125 0.53125 2.28125q0.1875 1.453125 0.1875 3.5625q0 1.53125 -0.125 2.640625q-0.109375 1.109375 -0.296875 2.0q-0.171875 0.875 -0.578125 1.578125q-0.40625 0.703125 -1.0625 1.34375q-0.640625 0.640625 -3.8125 2.109375q-3.15625 1.46875 -8.203125 2.875q-5.03125 1.40625 -11.65625 2.515625q-6.609375 1.125 -14.109375 1.125q-13.015625 0 -22.796875 -3.640625q-9.78125 -3.640625 -16.46875 -10.78125q-6.671875 -7.15625 -10.078125 -17.9375q-3.390625 -10.78125 -3.390625 -25.078125q0 -13.59375 3.515625 -24.421875q3.515625 -10.84375 10.125 -18.40625q6.625 -7.5625 16.0 -11.59375q9.375 -4.046875 20.984375 -4.046875q12.421875 0 21.140625 3.984375q8.734375 3.984375 14.359375 10.71875q5.625 6.734375 8.265625 15.828125q2.640625 9.078125 2.640625 19.390625l0 3.515625zm-19.453125 -5.75q0.34375 -15.234375 -6.75 -23.90625q-7.078125 -8.671875 -21.03125 -8.671875q-7.140625 0 -12.53125 2.703125q-5.390625 2.6875 -9.03125 7.140625q-3.625 4.453125 -5.625 10.375q-1.984375 5.921875 -2.21875 12.359375l57.1875 0z"
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                x: "119.79",
                y: "266.92",
                width: "184.80",
                height: "21.6",
                fill: i[0]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                x: "304.60",
                y: "266.92",
                width: "83.67",
                height: "21.6",
                fill: i[1]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                x: "388.27",
                y: "266.92",
                width: "126.56",
                height: "21.6",
                fill: i[2]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                x: "514.83",
                y: "266.92",
                width: "171.56",
                height: "21.6",
                fill: i[3]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                x: "686.39",
                y: "266.92",
                width: "93.87",
                height: "21.6",
                fill: i[4]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                x: "780.26",
                y: "266.92",
                width: "119.41",
                height: "21.6",
                fill: i[5]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("path", {
                fill: a,
                d: "m220.73857 49.834484q0 3.703125 -0.390625 6.4375q-0.390625 2.734375 -1.28125 4.40625q-0.875 1.65625 -2.140625 2.4375q-1.265625 0.78125 -2.828125 0.78125l-71.09375 0l0 219.14061q0 1.5625 -0.78125 2.734375q-0.78125 1.171875 -2.734375 1.859375q-1.953125 0.6875 -5.1875 1.171875q-3.21875 0.484375 -8.09375 0.484375q-4.6875 0 -8.015625 -0.484375q-3.3125 -0.484375 -5.265625 -1.171875q-1.953125 -0.6875 -2.734375 -1.859375q-0.78125 -1.171875 -0.78125 -2.734375l0 -219.14061l-71.09375 0q-1.5625 0 -2.84375 -0.78125q-1.265625 -0.78125 -2.046875 -2.4375q-0.78125 -1.671875 -1.265625 -4.40625q-0.484375 -2.734375 -0.484375 -6.4375q0 -3.71875 0.484375 -6.546875q0.484375 -2.828125 1.265625 -4.578125q0.78125 -1.765625 2.046875 -2.546875q1.28125 -0.78125 2.84375 -0.78125l175.78125 0q1.5625 0 2.828125 0.78125q1.265625 0.78125 2.140625 2.546875q0.890625 1.75 1.28125 4.578125q0.390625 2.828125 0.390625 6.546875z"
            })
        ]
    });
}
function ur({ zones: e, data: t, search: n, setSearch: o, searchResults: i, searchFields: a, onCollapseToMatches: c, hotkeys: s, defaultOpenSections: l, zoneStatus: f, headerActions: h, densityControls: u, rowHeight: g, fontSize: y, containerRef: p }) {
    const k = !!(n != null && n.query), [x, m] = (0, _react.useState)((l == null ? void 0 : l.search) ?? k), [b, E] = (0, _react.useState)((l == null ? void 0 : l.zones) ?? !1), [T, I] = (0, _react.useState)((l == null ? void 0 : l.display) ?? !1), _ = (0, _react.useRef)(null), M = (s == null ? void 0 : s.search) ?? !0;
    return (0, _react.useEffect)(()=>{
        k && !x && m(!0);
    }, [
        k
    ]), (0, _react.useEffect)(()=>{
        if (!M) return;
        const $ = p.current;
        if (!$) return;
        let W = !1;
        const H = ()=>{
            W = !0;
        }, w = ()=>{
            W = !1;
        };
        $.addEventListener("mouseenter", H), $.addEventListener("mouseleave", w);
        const N = (v)=>{
            const L = v.target;
            if (L && (L.tagName === "INPUT" || L.tagName === "TEXTAREA" || L.isContentEditable)) return;
            const J = document.activeElement, ie = J instanceof Node && $.contains(J);
            !W && !ie || (v.key === "/" || (v.metaKey || v.ctrlKey) && v.key === "f") && (v.preventDefault(), m(!0), requestAnimationFrame(()=>{
                var ae, ue;
                (ae = _.current) == null || ae.focus(), (ue = _.current) == null || ue.select();
            }));
        };
        return document.addEventListener("keydown", N), ()=>{
            $.removeEventListener("mouseenter", H), $.removeEventListener("mouseleave", w), document.removeEventListener("keydown", N);
        };
    }, [
        p,
        M
    ]), /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: "tbrowse-toolbar",
        style: {
            display: "flex",
            alignItems: "stretch",
            height: 32,
            flexShrink: 0,
            borderBottom: "1px solid var(--tbrowse-divider)",
            background: "var(--tbrowse-bg-strip)",
            color: "var(--tbrowse-text)",
            fontSize: 12
        },
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(hr, {}),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ft, {
                id: "tbrowse-toolbar-search",
                label: "Search",
                open: x,
                onToggle: ()=>m(($)=>!$),
                showDot: !x && k,
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(ir, {
                    search: n,
                    setSearch: o,
                    results: i,
                    fields: a,
                    onCollapseToMatches: c,
                    inputRef: _,
                    portalTarget: p
                })
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ft, {
                id: "tbrowse-toolbar-zones",
                label: "Zones",
                open: b,
                onToggle: ()=>E(($)=>!$),
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(cr, {
                    zones: e,
                    data: t,
                    zoneStatus: f
                })
            }),
            u && /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ft, {
                id: "tbrowse-toolbar-display",
                label: "Display",
                open: T,
                onToggle: ()=>I(($)=>!$),
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(fr, {
                    rowHeightProp: g,
                    fontSizeProp: y
                })
            }),
            h && /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                className: "tbrowse-toolbar-actions",
                style: {
                    marginLeft: "auto",
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    padding: "0 10px"
                },
                children: h
            })
        ]
    });
}
function fr({ rowHeightProp: e, fontSizeProp: t }) {
    const n = Le((f)=>f.viewState.rowHeight), o = Le((f)=>f.viewState.fontSize), i = Le((f)=>f.setViewState), a = n ?? e ?? (0, _tbrowseCore.LEAF_ROW_HEIGHT), c = o ?? t ?? Ot, s = {
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        color: "var(--tbrowse-text-muted)",
        fontSize: 11,
        whiteSpace: "nowrap"
    }, l = {
        fontVariantNumeric: "tabular-nums",
        color: "var(--tbrowse-text)",
        minWidth: 30,
        textAlign: "right"
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        style: {
            display: "flex",
            alignItems: "center",
            gap: 12
        },
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("label", {
                style: s,
                title: `Row height: ${a}px`,
                children: [
                    "Row",
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                        type: "range",
                        min: 8,
                        max: 64,
                        step: 1,
                        value: a,
                        onChange: (f)=>{
                            const h = +f.target.value;
                            i((u)=>({
                                    ...u,
                                    rowHeight: h
                                }));
                        },
                        style: {
                            verticalAlign: "middle",
                            width: 84
                        }
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                        style: l,
                        children: [
                            a,
                            "px"
                        ]
                    })
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("label", {
                style: s,
                title: `Font size: ${c}px`,
                children: [
                    "Font",
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                        type: "range",
                        min: 8,
                        max: 36,
                        step: 1,
                        value: c,
                        onChange: (f)=>{
                            const h = +f.target.value;
                            i((u)=>({
                                    ...u,
                                    fontSize: h
                                }));
                        },
                        style: {
                            verticalAlign: "middle",
                            width: 84
                        }
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                        style: l,
                        children: [
                            c,
                            "px"
                        ]
                    })
                ]
            })
        ]
    });
}
function hr() {
    const e = Le((t)=>t.theme);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("a", {
        className: "tbrowse-toolbar-logo",
        href: "https://tbrowse.org",
        target: "_blank",
        rel: "noopener noreferrer",
        title: "TBrowse \u2014 open tbrowse.org",
        style: {
            display: "inline-flex",
            alignItems: "center",
            padding: "0 12px",
            borderRight: "1px solid var(--tbrowse-divider)",
            userSelect: "none",
            textDecoration: "none"
        },
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(dr, {
            height: 24,
            variant: e
        })
    });
}
function Ft({ id: e, label: t, open: n, onToggle: o, showDot: i, children: a }) {
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: "tbrowse-toolbar-section",
        "data-open": n,
        style: {
            display: "inline-flex",
            alignItems: "center",
            height: "100%",
            // Vertical separator at the right edge of every section.
            borderRight: "1px solid var(--tbrowse-divider)"
        },
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("button", {
                type: "button",
                className: "tbrowse-toolbar-section-label",
                onClick: o,
                "aria-expanded": n,
                "aria-controls": e,
                style: {
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                    height: "100%",
                    padding: "0 12px",
                    background: "transparent",
                    border: "none",
                    color: n ? "var(--tbrowse-accent-strong)" : "var(--tbrowse-text-muted)",
                    fontSize: 12,
                    fontWeight: 600,
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                    transition: "color 180ms ease"
                },
                children: [
                    t,
                    i && /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                        "aria-hidden": "true",
                        style: {
                            display: "inline-block",
                            width: 6,
                            height: 6,
                            borderRadius: 3,
                            background: "var(--tbrowse-search)"
                        }
                    })
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(pr, {
                id: e,
                open: n,
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        height: "100%",
                        paddingRight: 12
                    },
                    children: a
                })
            })
        ]
    });
}
function pr({ open: e, id: t, children: n }) {
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        id: t,
        role: "region",
        "aria-hidden": !e,
        style: {
            display: "grid",
            gridTemplateColumns: e ? "1fr" : "0fr",
            opacity: e ? 1 : 0,
            transition: "grid-template-columns 220ms ease, opacity 180ms ease",
            pointerEvents: e ? "auto" : "none"
        },
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
            style: {
                overflow: "hidden",
                minWidth: 0
            },
            children: n
        })
    });
}
function gr(e, t, n, o) {
    if (n.length === 0) return e;
    const i = new Set(e.unlinkedZoneGroups ?? []), a = /* @__PURE__ */ new Map();
    for (const g of t)a.set(g.id, g);
    const c = (g)=>{
        var p;
        const y = (p = a.get(g)) == null ? void 0 : p.exclusiveGroup;
        return y && !i.has(y) ? y : void 0;
    }, s = /* @__PURE__ */ new Set();
    for (const g of e.zones){
        if (!g.visible) continue;
        const y = c(g.id);
        if (!y) continue;
        const p = a.get(g.id);
        p && p.isAvailable(o) && s.add(y);
    }
    const l = (g)=>{
        const y = c(g);
        return y ? s.has(y) ? !1 : (s.add(y), !0) : !0;
    }, f = e.zones.map((g)=>n.includes(g.id) && !g.visible && !g.userToggled && l(g.id) ? {
            ...g,
            visible: !0
        } : g), h = new Set(f.map((g)=>g.id));
    for (const g of n){
        if (h.has(g)) continue;
        const y = a.get(g);
        y && f.push({
            id: g,
            width: y.defaultWidth,
            visible: l(g)
        });
    }
    return f.length !== e.zones.length || f.some((g, y)=>g !== e.zones[y]) ? {
        ...e,
        zones: f
    } : e;
}
const zt = 56, mr = 28, br = 14, pn = 260, xr = (e)=>1 - Math.pow(1 - e, 2);
function vr({ data: e, zones: t, searchFields: n, hotkeys: o, defaultOpenSections: i, zoneStatus: a, showHeader: c = !0, rowHeight: s, fontSize: l, densityControls: f, headerActions: h, autoHeight: u = !1, containerRef: g }) {
    const y = Le((D)=>D.viewState), p = Le((D)=>D.setViewState), k = Le((D)=>D.hoveredNodeId), x = Le((D)=>D.setHoveredNodeId), m = (0, _react.useMemo)(()=>{
        const D = /* @__PURE__ */ new Map();
        for (const d of t)D.set(d.id, d);
        return D;
    }, [
        t
    ]), b = (0, _react.useMemo)(()=>y.zones.filter((D)=>{
            if (!D.visible) return !1;
            const d = m.get(D.id);
            return d !== void 0 && d.isAvailable(e);
        }), [
        y.zones,
        m,
        e
    ]), E = (0, _react.useRef)(/* @__PURE__ */ new Set());
    (0, _react.useEffect)(()=>{
        const D = [];
        for (const d of t)E.current.has(d.id) || d.isAvailable(e) && (E.current.add(d.id), D.push(d.id));
        D.length !== 0 && p((d)=>gr(d, t, D, e));
    }, [
        e,
        t,
        p
    ]);
    const T = (0, _react.useMemo)(()=>new Set(y.collapsedNodeIds), [
        y.collapsedNodeIds
    ]), I = (0, _react.useMemo)(()=>new Set(y.prunedNodeIds), [
        y.prunedNodeIds
    ]), _ = (0, _react.useMemo)(()=>new Set(y.swappedNodeIds ?? []), [
        y.swappedNodeIds
    ]), M = (0, _react.useMemo)(()=>new Set(y.compressedNodeIds ?? []), [
        y.compressedNodeIds
    ]), $ = y.zoneStates, W = (0, _react.useMemo)(()=>{
        const D = [];
        for (const q of t){
            if (!q.getSearchFields) continue;
            const X = ($ == null ? void 0 : $[q.id]) ?? q.defaultZoneState, ee = q.getSearchFields(X, e);
            ee && ee.length > 0 && D.push(...ee);
        }
        const d = /* @__PURE__ */ new Set(), S = [];
        for (const q of n ?? [])d.has(q.id) || (d.add(q.id), S.push(q));
        for (const q of D)d.has(q.id) || (d.add(q.id), S.push(q));
        for (const q of Qo)d.has(q.id) || (d.add(q.id), S.push(q));
        return S;
    }, [
        n,
        t,
        $,
        e
    ]), H = (0, _react.useMemo)(()=>er(e, y.search, W, I), [
        e,
        y.search,
        W,
        I
    ]), w = (0, _react.useCallback)((D)=>p((d)=>D === null || !D.query && !D.caseSensitive && !D.regex && (!D.excludedFields || D.excludedFields.length === 0) ? d.search === null ? d : {
                ...d,
                search: null
            } : {
                ...d,
                search: D
            }), [
        p
    ]), N = (0, _react.useCallback)(()=>{
        H.matchedLeafIds.size !== 0 && p((D)=>{
            const d = new Set(H.matchedAncestorIds);
            for (const q of H.matchedLeafIds)d.add(q);
            const S = [];
            for (const q of Object.keys(e.tree.nodes)){
                if (d.has(q)) continue;
                const X = e.tree.nodes[q];
                !X || X.isLeaf || S.push(q);
            }
            return S.length === D.collapsedNodeIds.length && S.every((q, X)=>D.collapsedNodeIds[X] === q) ? D : {
                ...D,
                collapsedNodeIds: S
            };
        });
    }, [
        p,
        e.tree,
        H
    ]), v = y.rowHeight ?? s, L = (0, _react.useMemo)(()=>(0, _tbrowseCore.computeVisibleRows)({
            tree: e.tree,
            collapsedNodeIds: T,
            prunedNodeIds: I,
            swappedNodeIds: _,
            rowHeight: v
        }), [
        e.tree,
        T,
        I,
        _,
        v
    ]), A = (0, _react.useRef)(null), [J, ie] = (0, _react.useState)(0), ae = (0, _react.useRef)(L);
    (0, _react.useEffect)(()=>{
        if (ae.current === L) return;
        const D = ae.current;
        if (ae.current = L, D.length === 0 && L.length === 0) return;
        A.current = {
            previous: D,
            target: L,
            startTime: performance.now()
        }, ie((S)=>S + 1);
        const d = ()=>{
            const S = A.current;
            if (!S) return;
            if (Math.min(1, (performance.now() - S.startTime) / pn) >= 1) {
                A.current = null, ie((X)=>X + 1);
                return;
            }
            ie((X)=>X + 1), requestAnimationFrame(d);
        };
        requestAnimationFrame(d);
    }, [
        L
    ]);
    const ue = (0, _react.useMemo)(()=>{
        const D = A.current;
        if (!D) return L;
        const d = Math.min(1, (performance.now() - D.startTime) / pn);
        if (d >= 1) return L;
        const S = xr(d), q = new Map(D.target.map((Z)=>[
                Z.nodeId,
                Z
            ])), X = new Map(D.previous.map((Z)=>[
                Z.nodeId,
                Z
            ])), ee = [];
        for (const Z of D.target){
            const ce = X.get(Z.nodeId);
            ce ? ee.push({
                ...Z,
                y: ce.y + (Z.y - ce.y) * S,
                opacity: 1
            }) : ee.push({
                ...Z,
                opacity: S
            });
        }
        for (const Z of D.previous)q.has(Z.nodeId) || ee.push({
            ...Z,
            opacity: 1 - S
        });
        return ee.sort((Z, ce)=>Z.y - ce.y), ee;
    }, [
        L,
        J
    ]), pe = (0, _react.useMemo)(()=>(0, _tbrowseCore.buildChildrenIndex)(e.tree), [
        e.tree
    ]), oe = (0, _react.useMemo)(()=>k === null ? (0, _tbrowseCore.EMPTY_NODE_ID_SET) : (0, _tbrowseCore.subtreeIdsOf)(k, pe), [
        k,
        pe
    ]), B = (0, _react.useMemo)(()=>{
        let D = 0;
        for (const d of ue){
            const S = d.y + d.height;
            S > D && (D = S);
        }
        return D;
    }, [
        ue
    ]), re = (0, _react.useRef)(null), ge = (0, _react.useRef)(null), [fe, C] = (0, _react.useState)(0), [O, F] = (0, _react.useState)(0), [z, U] = (0, _react.useState)(0), [G, Y] = (0, _react.useState)({}), [R, K] = (0, _react.useState)(null), [Q, se] = (0, _react.useState)(!1);
    (0, _react.useEffect)(()=>{
        const D = re.current;
        if (!D) return;
        let d = !0, S = null;
        const q = new ResizeObserver((X)=>{
            const ee = X[0].contentRect;
            if (F(ee.height), U(ee.width), d) {
                d = !1;
                return;
            }
            se(!0), S && clearTimeout(S), S = setTimeout(()=>se(!1), 250);
        });
        return q.observe(D), ()=>{
            q.disconnect(), S && clearTimeout(S);
        };
    }, []);
    const le = (0, _react.useMemo)(// In autoHeight mode there's no scroll viewport to virtualize against, so
    // render every row — otherwise the windowing would clip rows that are
    // "below the fold" of the (zero-derived) viewport height.
    ()=>u ? {
            startIndex: 0,
            endIndex: ue.length
        } : (0, _tbrowseCore.computeRowRange)(ue, fe, O), [
        u,
        ue,
        fe,
        O
    ]), te = (0, _react.useCallback)((D)=>p((d)=>({
                ...d,
                selectedNodeId: D
            })), [
        p
    ]), V = (0, _react.useCallback)(()=>p((D)=>D.selectedNodeId === null ? D : {
                ...D,
                selectedNodeId: null
            }), [
        p
    ]), ne = (0, _react.useCallback)((D)=>x(D), [
        x
    ]), de = (0, _react.useCallback)((D)=>p((d)=>d.collapsedNodeIds.indexOf(D) >= 0 ? {
                ...d,
                collapsedNodeIds: d.collapsedNodeIds.filter((q)=>q !== D)
            } : {
                ...d,
                collapsedNodeIds: [
                    ...d.collapsedNodeIds,
                    D
                ]
            }), [
        p
    ]), me = (0, _react.useCallback)((D)=>{
        D !== e.tree.rootId && p((d)=>d.prunedNodeIds.indexOf(D) >= 0 ? {
                ...d,
                prunedNodeIds: d.prunedNodeIds.filter((q)=>q !== D)
            } : {
                ...d,
                prunedNodeIds: [
                    ...d.prunedNodeIds,
                    D
                ],
                selectedNodeId: d.selectedNodeId === D ? null : d.selectedNodeId
            });
    }, [
        p,
        e.tree.rootId
    ]), we = (0, _react.useCallback)((D)=>p((d)=>{
            const S = d.swappedNodeIds ?? [];
            return S.indexOf(D) >= 0 ? {
                ...d,
                swappedNodeIds: S.filter((X)=>X !== D)
            } : {
                ...d,
                swappedNodeIds: [
                    ...S,
                    D
                ]
            };
        }), [
        p
    ]), ke = (0, _react.useCallback)((D)=>p((d)=>{
            const S = d.compressedNodeIds ?? [];
            return S.indexOf(D) >= 0 ? {
                ...d,
                compressedNodeIds: S.filter((X)=>X !== D)
            } : {
                ...d,
                compressedNodeIds: [
                    ...S,
                    D
                ]
            };
        }), [
        p
    ]), Re = (0, _react.useCallback)((D)=>p((d)=>{
            if (d.collapsedNodeIds.length === 0) return d;
            const S = (0, _tbrowseCore.subtreeIdsOf)(D, pe), q = d.collapsedNodeIds.filter((X)=>!S.has(X));
            return q.length === d.collapsedNodeIds.length ? d : {
                ...d,
                collapsedNodeIds: q
            };
        }), [
        p,
        pe
    ]), Ae = (0, _react.useCallback)((D)=>p((d)=>{
            const S = (0, _tbrowseCore.computePivotState)(e.tree, D);
            return S ? {
                ...d,
                swappedNodeIds: S.swappedNodeIds,
                nodeOfInterestId: S.targetId
            } : d;
        }), [
        p,
        e.tree
    ]), _e = (0, _react.useCallback)((D)=>p((d)=>{
            var Z;
            const S = /* @__PURE__ */ new Set();
            let q = D;
            for(; q !== null;)S.add(q), q = ((Z = e.tree.nodes[q]) == null ? void 0 : Z.parentId) ?? null;
            if (S.size <= 1) return d;
            const X = new Set(d.prunedNodeIds);
            for (const ce of S){
                if (ce === D) continue;
                const be = pe.get(ce);
                if (be) for (const he of be)S.has(he) || X.add(he);
            }
            const ee = d.collapsedNodeIds.filter((ce)=>!S.has(ce));
            return {
                ...d,
                prunedNodeIds: [
                    ...X
                ],
                collapsedNodeIds: ee
            };
        }), [
        p,
        e.tree,
        pe
    ]), Fe = (0, _react.useCallback)((D)=>p((d)=>{
            var Z;
            const S = /* @__PURE__ */ new Set();
            let q = D;
            for(; q !== null;)S.add(q), q = ((Z = e.tree.nodes[q]) == null ? void 0 : Z.parentId) ?? null;
            if (S.size <= 1) return d;
            const X = /* @__PURE__ */ new Set();
            for (const ce of S){
                if (ce === D) continue;
                const be = pe.get(ce);
                if (be) for (const he of be)S.has(he) || X.add(he);
            }
            const ee = d.prunedNodeIds.filter((ce)=>!X.has(ce));
            return ee.length === d.prunedNodeIds.length ? d : {
                ...d,
                prunedNodeIds: ee
            };
        }), [
        p,
        e.tree,
        pe
    ]), Xe = (0, _react.useCallback)((D)=>p((d)=>{
            var Z;
            const S = e.tree.nodes[D];
            if (!S || S.taxonomyId === void 0) return d;
            const q = /* @__PURE__ */ new Set();
            for (const ce of Object.values(e.tree.nodes)){
                if (!ce.isLeaf || ce.taxonomyId !== S.taxonomyId) continue;
                let be = ce.id;
                for(; be !== null && !q.has(be);)q.add(be), be = ((Z = e.tree.nodes[be]) == null ? void 0 : Z.parentId) ?? null;
            }
            if (q.size === 0) return d;
            const X = new Set(d.collapsedNodeIds);
            let ee = !1;
            for (const ce of q){
                const be = e.tree.nodes[ce];
                if (!be || be.isLeaf || !X.has(ce)) continue;
                X.delete(ce), ee = !0;
                const he = pe.get(ce);
                if (he) for (const xe of he){
                    if (q.has(xe)) continue;
                    const Ce = e.tree.nodes[xe];
                    !Ce || Ce.isLeaf || X.has(xe) || (X.add(xe), ee = !0);
                }
            }
            return ee ? {
                ...d,
                collapsedNodeIds: [
                    ...X
                ]
            } : d;
        }), [
        p,
        e.tree,
        pe
    ]), Be = (0, _react.useCallback)((D, d, S)=>{
        p((q)=>{
            const X = q.zoneStates[D] !== void 0 ? q.zoneStates[D] : d, ee = typeof S == "function" ? S(X) : S;
            return {
                ...q,
                zoneStates: {
                    ...q.zoneStates,
                    [D]: ee
                }
            };
        });
    }, [
        p
    ]), Ne = (0, _react.useCallback)((D, d)=>{
        Y((S)=>{
            const q = S[D] ?? 0, X = typeof d == "function" ? d(q) : d;
            return X === q ? S : {
                ...S,
                [D]: X
            };
        });
    }, []), Te = b.reduce((D, d)=>D + d.width, 0), Ee = b.map((D)=>{
        const d = m.get(D.id);
        return `minmax(${(d == null ? void 0 : d.minWidth) ?? 50}px, ${D.width}fr)`;
    }).join(" "), $e = (D, d, S)=>{
        const q = y.zoneStates[D];
        return {
            visibleRows: ue,
            rowRange: le,
            hoveredNodeId: k,
            hoveredSubtreeIds: oe,
            selectedNodeId: y.selectedNodeId,
            collapsedNodeIds: T,
            prunedNodeIds: I,
            swappedNodeIds: _,
            compressedNodeIds: M,
            searchState: y.search,
            searchResults: H,
            onHoverNode: ne,
            onSelectNode: te,
            onClearSelection: V,
            onToggleCollapsed: de,
            onTogglePruned: me,
            onToggleSwapped: we,
            onToggleCompressed: ke,
            onExpandSubtree: Re,
            onMakeNodeOfInterest: Ae,
            onShowParalogs: Xe,
            onReroot: _e,
            onRegrowOthers: Fe,
            nodeOfInterestId: y.nodeOfInterestId ?? null,
            zoneState: q === void 0 ? S.defaultZoneState : q,
            setZoneState: (X)=>Be(D, S.defaultZoneState, X),
            width: d,
            bodyHeight: u ? B : O,
            bodyScrollLeft: G[D] ?? 0,
            setBodyScrollLeft: (X)=>Ne(D, X),
            data: e
        };
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: "tbrowse-shell",
        style: {
            display: "flex",
            flexDirection: "column",
            width: "100%",
            height: u ? "auto" : "100%",
            background: "var(--tbrowse-bg)",
            color: "var(--tbrowse-text)"
        },
        children: [
            c && /* @__PURE__ */ (0, _jsxRuntime.jsx)(ur, {
                zones: t,
                data: e,
                search: y.search,
                setSearch: w,
                searchResults: H,
                searchFields: W,
                onCollapseToMatches: N,
                hotkeys: o,
                defaultOpenSections: i,
                zoneStatus: a,
                headerActions: h,
                densityControls: f,
                rowHeight: s,
                fontSize: l,
                containerRef: g
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                ref: re,
                className: "tbrowse-outer",
                onScroll: (D)=>C(D.currentTarget.scrollTop),
                style: {
                    position: "relative",
                    // autoHeight: take the content's natural height and don't scroll
                    // internally, so the chassis grows to fit every row with no empty
                    // space below the last one. Otherwise fill the container and scroll.
                    flex: u ? "none" : 1,
                    minHeight: 0,
                    overflow: u ? "visible" : "auto"
                },
                children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                    ref: ge,
                    className: "tbrowse-grid",
                    style: {
                        display: "grid",
                        gridTemplateRows: `${zt}px auto`,
                        gridTemplateColumns: Ee || "1fr",
                        height: zt + B,
                        position: "relative",
                        cursor: R ? "grabbing" : void 0
                    },
                    children: [
                        b.map((D, d)=>{
                            var be;
                            const S = m.get(D.id), q = Te > 0 && z > 0 ? D.width / Te * z : D.width, X = $e(D.id, q, S), ee = (R == null ? void 0 : R.zoneId) === D.id, Z = b[d + 1], ce = Z ? ((be = m.get(Z.id)) == null ? void 0 : be.minWidth) ?? 50 : 0;
                            return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                                className: "tbrowse-zone-header",
                                style: {
                                    position: "sticky",
                                    top: 0,
                                    height: zt,
                                    background: "var(--tbrowse-bg-alt)",
                                    borderBottom: "1px solid var(--tbrowse-divider)",
                                    borderRight: "1px solid var(--tbrowse-border-soft)",
                                    zIndex: 1,
                                    overflow: "hidden",
                                    display: "flex",
                                    alignItems: "stretch",
                                    opacity: ee ? 0.5 : 1
                                },
                                children: [
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                                        style: {
                                            flex: 1,
                                            minWidth: 0,
                                            position: "relative"
                                        },
                                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(S.Header, {
                                            ...X
                                        })
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                                        style: {
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: br,
                                            height: mr,
                                            zIndex: 2
                                        },
                                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(or, {
                                            zoneId: D.id,
                                            visibleZones: b,
                                            gridRef: ge,
                                            setDragState: K
                                        })
                                    }),
                                    Z && /* @__PURE__ */ (0, _jsxRuntime.jsx)(rr, {
                                        zoneId: D.id,
                                        nextZoneId: Z.id,
                                        currentFr: D.width,
                                        nextFr: Z.width,
                                        sumFr: Te,
                                        containerWidth: z,
                                        minWidth: S.minWidth,
                                        nextMinWidth: ce,
                                        setResizing: se
                                    }),
                                    Q && /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                                        style: {
                                            position: "absolute",
                                            top: 4,
                                            right: 8,
                                            fontSize: 11,
                                            fontWeight: 400,
                                            color: "var(--tbrowse-text-muted)",
                                            background: "var(--tbrowse-bg-alt)",
                                            padding: "1px 4px",
                                            borderRadius: 3,
                                            pointerEvents: "none",
                                            zIndex: 3
                                        },
                                        children: [
                                            Math.ceil(q),
                                            "px"
                                        ]
                                    })
                                ]
                            }, `h-${D.id}`);
                        }),
                        b.map((D)=>{
                            const d = m.get(D.id), S = Te > 0 && z > 0 ? D.width / Te * z : D.width, q = $e(D.id, S, d);
                            return /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                                className: "tbrowse-zone-body",
                                style: {
                                    position: "relative",
                                    borderRight: "1px solid var(--tbrowse-border-soft)",
                                    overflow: "hidden"
                                },
                                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(d.Body, {
                                    ...q
                                })
                            }, `b-${D.id}`);
                        }),
                        R !== null && /* @__PURE__ */ (0, _jsxRuntime.jsx)(wr, {
                            visibleZones: b,
                            targetIndex: R.targetIndex
                        })
                    ]
                })
            })
        ]
    });
}
function wr({ visibleZones: e, targetIndex: t }) {
    let n = 0;
    for(let o = 0; o < t && o < e.length; o++)n += e[o].width;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        className: "tbrowse-reorder-indicator",
        style: {
            position: "absolute",
            top: 0,
            left: n - 1,
            width: 2,
            height: "100%",
            background: "var(--tbrowse-accent)",
            pointerEvents: "none",
            zIndex: 2
        }
    });
}
const yr = `
.tbrowse-root {
  /* Defaults match the light theme so that even un-themed (stylesheet
     not yet injected, or no class applied for some reason) the look is
     reasonable. */
  --tbrowse-bg: #ffffff;
  --tbrowse-bg-alt: #f7f7f7;
  --tbrowse-bg-strip: #fafafa;
  --tbrowse-bg-elevated: #ffffff;
  --tbrowse-bg-input: #ffffff;
  --tbrowse-text: #222222;
  --tbrowse-text-muted: #666666;
  --tbrowse-text-subtle: #999999;
  --tbrowse-border: #cccccc;
  --tbrowse-border-soft: #eeeeee;
  --tbrowse-border-row: #f0f0f0;
  --tbrowse-divider: #dddddd;
  --tbrowse-accent: #2878dc;
  --tbrowse-accent-strong: #1d5fb1;
  --tbrowse-accent-soft: #e6f0fb;
  --tbrowse-accent-fg: #ffffff;
  --tbrowse-danger: #c0392b;
  --tbrowse-danger-soft: rgba(192, 57, 43, 0.08);
  --tbrowse-search: #d97706;
  --tbrowse-search-soft: rgba(217, 119, 6, 0.18);
  --tbrowse-tooltip-shadow: rgba(0, 0, 0, 0.12);
  --tbrowse-row-hover-bg: rgba(40, 120, 220, 0.08);
  --tbrowse-row-select-bg: rgba(40, 120, 220, 0.15);
  --tbrowse-row-subtree-bg: rgba(40, 120, 220, 0.04);
  --tbrowse-branch: #444444;
  --tbrowse-leaf-extension: #bbbbbb;
}

/* Zone toggle status states \u{2014} see ChromeStrip.tsx and
   TBrowseProps.zoneStatus. The 'loading' class gently pulses the
   button opacity to signal in-flight host fetches; 'error' paints a
   red border + tinted background and overrides the visible-state
   accent so failures are unmistakable on either theme. */
@keyframes tbrowse-zone-pulse {
  0%, 100% { opacity: 0.55; }
  50% { opacity: 0.95; }
}
.tbrowse-zone-loading {
  animation: tbrowse-zone-pulse 1.4s ease-in-out infinite;
}
.tbrowse-zone-error {
  border-color: var(--tbrowse-danger) !important;
  background: var(--tbrowse-danger-soft) !important;
  color: var(--tbrowse-danger) !important;
}

.tbrowse-theme-dark {
  --tbrowse-bg: #1c1f24;
  --tbrowse-bg-alt: #24272d;
  --tbrowse-bg-strip: #20232a;
  --tbrowse-bg-elevated: #2e3138;
  --tbrowse-bg-input: #2a2d34;
  --tbrowse-text: #e7e9ed;
  --tbrowse-text-muted: #a8aeb6;
  --tbrowse-text-subtle: #7a8089;
  --tbrowse-border: #444851;
  --tbrowse-border-soft: #2f3239;
  --tbrowse-border-row: #2a2d34;
  --tbrowse-divider: #3a3e46;
  --tbrowse-accent: #5fa0f0;
  --tbrowse-accent-strong: #80b3f4;
  --tbrowse-accent-soft: #1f3a5f;
  --tbrowse-accent-fg: #0e1116;
  --tbrowse-danger: #e57373;
  --tbrowse-danger-soft: rgba(229, 115, 115, 0.16);
  --tbrowse-search: #fbbf24;
  --tbrowse-search-soft: rgba(251, 191, 36, 0.22);
  --tbrowse-tooltip-shadow: rgba(0, 0, 0, 0.6);
  --tbrowse-row-hover-bg: rgba(120, 170, 240, 0.16);
  --tbrowse-row-select-bg: rgba(120, 170, 240, 0.26);
  --tbrowse-row-subtree-bg: rgba(120, 170, 240, 0.07);
  --tbrowse-branch: #cdd1d8;
  --tbrowse-leaf-extension: #5d6068;
}
`;
let Gt = !1;
function Ir() {
    if (Gt || typeof document > "u") return;
    const e = "tbrowse-theme-style";
    if (document.getElementById(e)) {
        Gt = !0;
        return;
    }
    const t = document.createElement("style");
    t.id = e, t.textContent = yr, document.head.appendChild(t), Gt = !0;
}
Ir();
function el(e) {
    const t = (0, _react.useMemo)(()=>Xo(e), []), n = e.viewState, o = e.onViewStateChange, i = n !== void 0, a = (0, _react.useRef)(t.getState().viewState), c = e.theme ?? "light";
    (0, _react.useLayoutEffect)(()=>{
        i && n !== void 0 && t.getState().viewState !== n && (a.current = n, t.setState({
            viewState: n
        }));
    }, [
        i,
        n,
        t
    ]), (0, _react.useLayoutEffect)(()=>{
        t.getState().theme !== c && t.setState({
            theme: c
        });
    }, [
        c,
        t
    ]);
    const s = e.nodeActions;
    (0, _react.useLayoutEffect)(()=>{
        t.getState().nodeActions !== s && t.setState({
            nodeActions: s
        });
    }, [
        s,
        t
    ]);
    const l = e.fontSize;
    return (0, _react.useLayoutEffect)(()=>{
        const f = (u)=>u ?? l ?? Ot, h = ()=>{
            const u = f(t.getState().viewState.fontSize);
            t.getState().fontSize !== u && t.setState({
                fontSize: u
            });
        };
        return h(), t.subscribe(h);
    }, [
        l,
        t
    ]), (0, _react.useEffect)(()=>{
        if (o) return t.subscribe((f)=>{
            f.viewState !== a.current && (a.current = f.viewState, o(f.viewState));
        });
    }, [
        o,
        t
    ]), /* @__PURE__ */ (0, _jsxRuntime.jsx)(Vo, {
        store: t,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Sr, {
            ...e
        })
    });
}
function Sr(e) {
    const t = (0, _react.useRef)(null), n = {
        tree: e.tree,
        taxonomy: e.taxonomy,
        msa: e.msa,
        geneMetadata: e.geneMetadata,
        nodeAnnotations: e.nodeAnnotations,
        labelProviders: e.labelProviders,
        proteinDomains: e.proteinDomains,
        exonJunctions: e.exonJunctions,
        neighborhood: e.neighborhood,
        geneStructures: e.geneStructures,
        genomeFeatures: e.genomeFeatures,
        geneStructureErrors: e.geneStructureErrors,
        germplasm: e.germplasm,
        hostData: e.hostData
    }, o = Le((a)=>a.fontSize), i = {
        width: "100%",
        height: e.autoHeight ? "auto" : "100%",
        "--tbrowse-font-size": `${o}px`
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        ref: t,
        className: `tbrowse-root tbrowse-theme-${e.theme ?? "light"} ${e.className ?? ""}`,
        style: i,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(vr, {
            data: n,
            zones: e.zones,
            searchFields: e.searchFields,
            hotkeys: e.hotkeys,
            defaultOpenSections: e.defaultOpenSections,
            zoneStatus: e.zoneStatus,
            showHeader: e.showHeader ?? !0,
            rowHeight: e.rowHeight,
            fontSize: e.fontSize,
            densityControls: e.densityControls,
            headerActions: e.headerActions,
            autoHeight: e.autoHeight,
            containerRef: t
        })
    });
}
const kr = (e)=>Array.isArray(e) ? e.map((t)=>String(t)).join("\0") : String(e);
function tl(e, t, n = {}) {
    const { key: o, ...i } = n, a = (0, _react.useRef)(i);
    a.current = i;
    const c = (0, _react.useMemo)(()=>(0, _tbrowseCore.createLoader)(e, a.current), [
        e
    ]);
    (0, _react.useEffect)(()=>()=>c.dispose(), [
        c
    ]);
    const s = (0, _react.useSyncExternalStore)(c.subscribe, c.getSnapshot, c.getSnapshot), l = t === null ? null : o === void 0 ? t : kr(o);
    (0, _react.useEffect)(()=>{
        if (t === null) {
            c.abort();
            return;
        }
        c.start(t);
    }, [
        c,
        l
    ]);
    const f = (0, _react.useMemo)(()=>(0, _tbrowseCore.hostPropsFrom)(s), [
        s
    ]);
    return {
        snapshot: s,
        loader: c,
        hostProps: f
    };
}
function nl(e, t, n = {}) {
    const [o, i] = (0, _react.useState)(n.initial ?? null), a = (0, _react.useRef)(n);
    a.current = n;
    const c = (0, _react.useRef)(null), s = (0, _react.useCallback)((l)=>{
        const f = a.current, h = f.data ?? (l.tree ? {
            tree: l.tree,
            ...l.data
        } : void 0);
        return (0, _tbrowseCore.buildInitialViewState)(e, {
            ...h !== void 0 ? {
                data: h
            } : {},
            ...f.nodeOfInterest !== void 0 ? {
                nodeOfInterest: f.nodeOfInterest
            } : {},
            ...f.widths !== void 0 ? {
                widths: f.widths
            } : {},
            ...f.visible !== void 0 ? {
                visible: f.visible
            } : {},
            ...f.zoneStates !== void 0 ? {
                zoneStates: f.zoneStates
            } : {},
            ...f.overrides !== void 0 ? {
                overrides: f.overrides
            } : {}
        });
    }, [
        e
    ]);
    return (0, _react.useEffect)(()=>{
        !t || t.status !== "ready" || !t.tree || c.current !== t.tree && (c.current = t.tree, i((l)=>{
            var u, g;
            const f = ((g = (u = a.current).onRootReady) == null ? void 0 : g.call(u, t, l)) ?? (l === null ? "reset" : "soft");
            if (f === "keep") return l ?? (0, _tbrowseCore.ensureZones)(s(t), e);
            const h = f === "soft" && l ? (0, _tbrowseCore.softResetForNewTree)(l) : s(t);
            return (0, _tbrowseCore.applyPivot)((0, _tbrowseCore.ensureZones)(h, e), t.pivot);
        }));
    }, [
        t,
        e,
        s
    ]), (0, _react.useEffect)(()=>{
        i((l)=>l && (0, _tbrowseCore.ensureZones)(l, e));
    }, [
        e
    ]), [
        o,
        i
    ];
}
function ol(e) {
    const t = e.contentWidth, n = ({ width: i, bodyScrollLeft: a })=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
            style: {
                padding: "0 10px 0 18px",
                height: "100%",
                display: "flex",
                alignItems: "center",
                gap: 10,
                fontSize: 13,
                color: "var(--tbrowse-text)",
                position: "relative"
            },
            children: [
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                    style: {
                        fontWeight: 600
                    },
                    children: e.displayName
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                    style: {
                        fontWeight: 400,
                        color: "var(--tbrowse-text-muted)"
                    },
                    children: [
                        i,
                        "px"
                    ]
                }),
                t !== void 0 && /* @__PURE__ */ (0, _jsxRuntime.jsx)(Er, {
                    contentWidth: t,
                    width: i,
                    bodyScrollLeft: a
                })
            ]
        }), o = ({ visibleRows: i, rowRange: a, hoveredNodeId: c, hoveredSubtreeIds: s, selectedNodeId: l, onHoverNode: f, onSelectNode: h, width: u, bodyScrollLeft: g, setBodyScrollLeft: y })=>{
        const p = i.slice(a.startIndex, a.endIndex), k = t !== void 0 ? Math.max(0, t - u) : 0, x = (b)=>{
            t !== void 0 && b.deltaX !== 0 && (b.preventDefault(), y((E)=>Math.max(0, Math.min(k, E + b.deltaX))));
        }, m = {
            position: "relative",
            height: "100%",
            width: t ?? "100%",
            transform: t !== void 0 ? `translateX(${-g}px)` : void 0
        };
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
            onWheel: x,
            style: {
                height: "100%",
                position: "relative"
            },
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                style: m,
                children: p.map((b)=>{
                    const E = c === b.nodeId, T = s.has(b.nodeId), I = l === b.nodeId;
                    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                        onMouseEnter: ()=>f(b.nodeId),
                        onMouseLeave: ()=>f(null),
                        onClick: ()=>h(b.nodeId),
                        style: {
                            position: "absolute",
                            top: b.y,
                            left: 0,
                            width: t ?? "100%",
                            height: b.height,
                            fontSize: 12,
                            padding: "0 10px",
                            display: "flex",
                            alignItems: "center",
                            gap: 16,
                            background: I ? "var(--tbrowse-row-select-bg)" : E ? "var(--tbrowse-row-hover-bg)" : T ? "var(--tbrowse-row-subtree-bg)" : "transparent",
                            fontWeight: T ? 600 : 400,
                            borderBottom: "1px solid var(--tbrowse-border-row)",
                            cursor: "pointer",
                            whiteSpace: "nowrap",
                            opacity: b.opacity ?? 1,
                            transform: `translateX(${-32 * (1 - (b.opacity ?? 1))}px)`
                        },
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                children: b.kind === "leaf" ? b.nodeId : `${b.nodeId} (collapsed, ${b.leafCount})`
                            }),
                            t !== void 0 && /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                style: {
                                    color: "var(--tbrowse-text-subtle)",
                                    fontFamily: "monospace",
                                    fontSize: 11
                                },
                                children: Array.from({
                                    length: 24
                                }, (_, M)=>`col${M}`).join(" \xb7 ")
                            })
                        ]
                    }, b.nodeId);
                })
            })
        });
    };
    return {
        id: e.id,
        displayName: e.displayName,
        Header: n,
        Body: o,
        defaultWidth: e.defaultWidth ?? 200,
        minWidth: e.minWidth ?? 80,
        defaultZoneState: {},
        isAvailable: ()=>!0
    };
}
function Er({ contentWidth: e, width: t, bodyScrollLeft: n }) {
    const i = Math.min(1, t / e), a = Math.max(8, 80 * i), c = Math.max(1, e - t), s = Math.min(1, Math.max(0, n / c)), l = (80 - a) * s;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        style: {
            marginLeft: "auto",
            width: 80,
            height: 8,
            background: "var(--tbrowse-border-soft)",
            borderRadius: 4,
            position: "relative"
        },
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
            style: {
                position: "absolute",
                left: l,
                top: 0,
                width: a,
                height: "100%",
                background: "var(--tbrowse-accent)",
                borderRadius: 4
            }
        })
    });
}
function nt({ defaultName: e, customName: t, onChange: n, maxWidth: o = 160 }) {
    const i = t ?? e, [a, c] = (0, _react.useState)(!1), [s, l] = (0, _react.useState)(i), f = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        a || l(i);
    }, [
        a,
        i
    ]), (0, _react.useEffect)(()=>{
        a && f.current && (f.current.focus(), f.current.select());
    }, [
        a
    ]);
    const h = ()=>{
        const g = s.trim();
        n(g === "" || g === e ? void 0 : g), c(!1);
    }, u = ()=>{
        l(i), c(!1);
    };
    return a ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
        ref: f,
        value: s,
        onChange: (g)=>l(g.target.value),
        onBlur: h,
        onKeyDown: (g)=>{
            g.key === "Enter" ? h() : g.key === "Escape" && u();
        },
        style: {
            fontWeight: 600,
            fontSize: 13,
            background: "var(--tbrowse-bg-input)",
            color: "var(--tbrowse-text)",
            border: "1px solid var(--tbrowse-border)",
            borderRadius: 3,
            padding: "1px 4px",
            minWidth: 60,
            maxWidth: o
        }
    }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
        onClick: ()=>c(!0),
        title: "Click to rename",
        style: {
            fontWeight: 600,
            cursor: "text",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: o
        },
        children: i
    });
}
function Mr(e) {
    return e.isSelected ? "var(--tbrowse-row-select-bg)" : e.isExactHover ? "var(--tbrowse-row-hover-bg)" : e.isInHoveredSubtree ? "var(--tbrowse-row-subtree-bg)" : "transparent";
}
function Cr(e, t, n) {
    return (0, _tbrowseCore.rowsInRange)(e, t).map((o)=>{
        const i = (0, _tbrowseCore.rowFlags)(o, n);
        return {
            row: o,
            flags: i,
            background: Mr(i)
        };
    });
}
function eo(e, t, n) {
    var s, l;
    if (!e) return null;
    const o = t.tree.nodes[e];
    if (!o) return e;
    const i = o.taxonomyId !== void 0 ? (s = t.taxonomy) == null ? void 0 : s[o.taxonomyId] : void 0, a = (i == null ? void 0 : i.scientificName) ?? (i == null ? void 0 : i.commonName), c = [];
    if (o.isLeaf) {
        a && c.push(a), o.geneId && c.push(o.geneId);
        const f = o.geneId ? (l = t.geneMetadata) == null ? void 0 : l[o.geneId] : void 0, h = f == null ? void 0 : f.displayName;
        typeof h == "string" && h !== "" && h !== o.geneId && c.push(h);
    } else {
        a && c.push(a), i != null && i.rank && c.push(i.rank), o.eventType && c.push(o.eventType);
        const f = (0, _tbrowseCore.countLeavesInSubtree)(e, t.tree, n);
        c.push(`${f} ${f === 1 ? "leaf" : "leaves"}`);
    }
    return c.length > 0 ? c.join(" \xb7 ") : null;
}
const Lr = 0.01;
function Tr(e) {
    var g, y;
    const { tree: t, visibleRows: n, drawingLeftX: o, drawingWidth: i } = e;
    if (n.length === 0) return {
        nodes: [],
        rootId: null
    };
    const a = /* @__PURE__ */ new Map();
    for (const p of n)a.set(p.nodeId, p);
    const c = /* @__PURE__ */ new Set();
    for (const p of n){
        let k = p.nodeId;
        for(; k && !c.has(k);)c.add(k), k = ((g = t.nodes[k]) == null ? void 0 : g.parentId) ?? null;
    }
    if (!c.has(t.rootId)) return {
        nodes: [],
        rootId: null
    };
    const s = /* @__PURE__ */ new Map();
    for (const p of c){
        const k = t.nodes[p];
        if (!k || k.parentId === null || !c.has(k.parentId)) continue;
        let x = s.get(k.parentId);
        x || (x = [], s.set(k.parentId, x)), x.push(p);
    }
    const l = /* @__PURE__ */ new Map();
    if (e.layoutMode === "cladogram") {
        const p = /* @__PURE__ */ new Map(), k = (b)=>{
            const E = p.get(b);
            if (E !== void 0) return E;
            if (a.has(b)) return p.set(b, 0), 0;
            let T = 0;
            for (const I of s.get(b) ?? []){
                const _ = 1 + k(I);
                _ > T && (T = _);
            }
            return p.set(b, T), T;
        }, x = k(t.rootId), m = x > 0 ? i / x : 0;
        for (const b of c){
            const E = p.get(b) ?? 0;
            l.set(b, o + (x - E) * m);
        }
    } else {
        const p = /* @__PURE__ */ new Map();
        p.set(t.rootId, 0);
        const k = [
            t.rootId
        ];
        for(; k.length > 0;){
            const b = k.shift(), E = p.get(b) ?? 0;
            for (const T of s.get(b) ?? []){
                const I = ((y = t.nodes[T]) == null ? void 0 : y.distance) ?? 0, _ = Math.max(Lr, I);
                p.set(T, E + _), k.push(T);
            }
        }
        let x = 0;
        for (const b of a.keys()){
            const E = p.get(b) ?? 0;
            E > x && (x = E);
        }
        const m = x > 0 ? i / x : 0;
        for (const [b, E] of p)l.set(b, o + E * m);
    }
    const f = /* @__PURE__ */ new Map();
    for (const p of n)f.set(p.nodeId, p.y + p.height / 2);
    const h = (p)=>{
        const k = f.get(p);
        if (k !== void 0) return k;
        const x = s.get(p);
        if (!x || x.length === 0) return f.set(p, 0), 0;
        let m = 1 / 0, b = -1 / 0;
        for (const T of x){
            const I = h(T);
            I < m && (m = I), I > b && (b = I);
        }
        const E = (m + b) / 2;
        return f.set(p, E), E;
    };
    h(t.rootId);
    const u = [];
    for (const p of c){
        const k = t.nodes[p];
        if (!k) continue;
        const x = a.get(p);
        u.push({
            nodeId: p,
            parentId: k.parentId,
            x: l.get(p) ?? o,
            y: f.get(p) ?? 0,
            isVisibleEnd: x !== void 0,
            isLeaf: k.isLeaf,
            isCollapsedSummary: (x == null ? void 0 : x.kind) === "collapsedSummary"
        });
    }
    return {
        nodes: u,
        rootId: t.rootId
    };
}
function qr(e, t, n) {
    var E, T;
    if (t === null || e.length === 0) return null;
    const o = n.compressedWidth, i = n.exclude ?? /* @__PURE__ */ new Set(), a = n.minChainLength, c = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map();
    for (const I of e){
        if (c.set(I.nodeId, I), I.parentId === null) continue;
        let _ = s.get(I.parentId);
        _ || (_ = [], s.set(I.parentId, _)), _.push(I.nodeId);
    }
    const l = (I)=>{
        const _ = c.get(I);
        if (!_ || _.isVisibleEnd || i.has(I)) return !1;
        const M = s.get(I);
        return !!M && M.length === 1;
    }, f = [], h = /* @__PURE__ */ new Set(), u = /* @__PURE__ */ new Set(), g = /* @__PURE__ */ new Map(), y = /* @__PURE__ */ new Map(), p = /* @__PURE__ */ new Map();
    for (const I of e){
        if (!l(I.nodeId)) continue;
        const _ = I.parentId;
        if (_ !== null && l(_)) continue;
        const M = [
            I.nodeId
        ];
        let $ = I.nodeId;
        for(;;){
            const L = s.get($), A = L && L.length === 1 ? L[0] : null;
            if (A !== null && l(A)) M.push(A), $ = A;
            else break;
        }
        if (M.length < a) continue;
        const W = M[0], H = s.get(M[M.length - 1]), w = H && H.length === 1 ? H[0] : null;
        if (w === null) continue;
        const N = ((E = c.get(W)) == null ? void 0 : E.parentId) ?? null, v = f.length;
        f.push({
            entryId: N,
            startId: W,
            exitId: w,
            passThroughIds: [
                ...M
            ]
        }), y.set(w, N);
        for (const L of M)u.add(L), g.set(L, v), p.set(L, N);
        for(let L = 1; L < M.length; L++)h.add(M[L]);
        h.add(w);
    }
    if (f.length === 0) return null;
    const k = /* @__PURE__ */ new Map(), x = [
        t
    ], m = c.get(t);
    for(k.set(t, m ? m.x : 0); x.length > 0;){
        const I = x.shift(), _ = k.get(I) ?? 0, M = ((T = c.get(I)) == null ? void 0 : T.x) ?? 0;
        for (const $ of s.get(I) ?? []){
            const W = c.get($);
            if (!W) continue;
            let H;
            if (p.has($)) {
                const w = p.get($) ?? null;
                H = w !== null ? k.get(w) ?? _ : _;
            } else if (y.has($)) {
                const w = y.get($) ?? null;
                H = (w !== null ? k.get(w) ?? _ : _) + o;
            } else H = _ + (W.x - M);
            k.set($, H), x.push($);
        }
    }
    return {
        nodes: e.map((I)=>k.has(I.nodeId) ? {
                ...I,
                x: k.get(I.nodeId)
            } : I),
        branchSkip: h,
        glyphSkip: u,
        segments: f,
        anchorToSegment: g
    };
}
const Bt = "var(--tbrowse-accent)", gn = "var(--tbrowse-danger)", Wt = "var(--tbrowse-text-muted)";
function Rr({ svgRef: e, layoutNode: t, treeNode: n, data: o, isCollapsed: i, isPruned: a, isCompressed: c, isNodeOfInterest: s, subtreeLeafCount: l, hasCollapsedDescendants: f, pruneWouldEmptyTree: h, onClose: u, onToggleCollapsed: g, onTogglePruned: y, onToggleSwapped: p, onToggleCompressed: k, onExpandSubtree: x, onMakeNodeOfInterest: m, onShowParalogs: b, onReroot: E, onRegrowOthers: T, othersArePruned: I }) {
    var Y;
    const _ = $r(e, t.x, t.y), [M, $] = (0, _react.useState)({
        dx: 0,
        dy: 0
    }), W = (0, _react.useRef)(null), [H, w] = (0, _react.useState)({
        w: 0,
        h: 0
    });
    (0, _react.useEffect)(()=>{
        const R = (K)=>{
            K.key === "Escape" && u();
        };
        return window.addEventListener("keydown", R), ()=>window.removeEventListener("keydown", R);
    }, [
        u
    ]), (0, _react.useEffect)(()=>{
        const R = (K)=>{
            W.current && (W.current.contains(K.target) || u());
        };
        return document.addEventListener("mousedown", R), ()=>document.removeEventListener("mousedown", R);
    }, [
        u
    ]);
    const N = Le((R)=>R.theme), v = Le((R)=>R.nodeActions);
    (0, _react.useLayoutEffect)(()=>{
        const R = W.current;
        if (!R) return;
        const K = R.getBoundingClientRect();
        (Math.abs(K.width - H.w) > 0.5 || Math.abs(K.height - H.h) > 0.5) && w({
            w: K.width,
            h: K.height
        });
    });
    const L = (R)=>{
        if (R.target.closest("button, input, label")) return;
        R.preventDefault();
        const K = R.clientX, Q = R.clientY, se = M.dx, le = M.dy, te = (ne)=>{
            $({
                dx: se + (ne.clientX - K),
                dy: le + (ne.clientY - Q)
            });
        }, V = ()=>{
            window.removeEventListener("pointermove", te), window.removeEventListener("pointerup", V);
        };
        window.addEventListener("pointermove", te), window.addEventListener("pointerup", V);
    };
    if (!_) return null;
    const A = 8, J = H.w || 220, ie = H.h || 100, ae = typeof window < "u" ? window.innerWidth : 1024, ue = typeof window < "u" ? window.innerHeight : 768, pe = _.x + 10 + M.dx, oe = _.y - 8 + M.dy, B = Math.max(A, Math.min(ae - J - A, pe)), re = Math.max(A, Math.min(ue - ie - A, oe)), ge = n.taxonomyId !== void 0 ? (Y = o.taxonomy) == null ? void 0 : Y[n.taxonomyId] : void 0, fe = !n.isLeaf, C = n.isLeaf, O = (()=>{
        var K;
        if (!C || !n.geneId) return null;
        const R = (K = o.geneMetadata) == null ? void 0 : K[n.geneId];
        return !R || typeof R.displayName != "string" || R.displayName === "" ? null : R.displayName;
    })(), F = fe && !a, z = C && s && n.taxonomyId !== void 0 && !a, U = C && !s && !a, G = (v == null ? void 0 : v(n, o)) ?? [];
    return (0, _reactDom.createPortal)(/* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        className: `tbrowse-root tbrowse-theme-${N}`,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
            ref: W,
            className: "tbrowse-tooltip",
            style: {
                position: "fixed",
                left: B,
                top: re,
                minWidth: 200,
                maxWidth: 320,
                background: "var(--tbrowse-bg-elevated)",
                border: "1px solid var(--tbrowse-border)",
                borderRadius: 6,
                boxShadow: "0 4px 16px var(--tbrowse-tooltip-shadow)",
                padding: "8px 10px",
                fontSize: 12,
                lineHeight: 1.45,
                color: "var(--tbrowse-text)",
                zIndex: 2e3
            },
            onClick: (R)=>R.stopPropagation(),
            children: [
                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                    onPointerDown: L,
                    title: "Drag to reposition",
                    style: {
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 8,
                        marginBottom: 6,
                        cursor: "move",
                        userSelect: "none",
                        touchAction: "none"
                    },
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                            style: {
                                flex: 1,
                                minWidth: 0
                            },
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                                    style: {
                                        fontWeight: 600,
                                        fontSize: 13
                                    },
                                    children: (ge == null ? void 0 : ge.scientificName) ?? n.geneId ?? t.nodeId
                                }),
                                (ge == null ? void 0 : ge.commonName) && /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                                    style: {
                                        color: Wt,
                                        fontStyle: "italic"
                                    },
                                    children: ge.commonName
                                })
                            ]
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            onClick: u,
                            "aria-label": "Close",
                            style: {
                                background: "transparent",
                                border: "none",
                                cursor: "pointer",
                                color: Wt,
                                fontSize: 16,
                                lineHeight: 1,
                                padding: 0,
                                marginTop: -2
                            },
                            children: "\xd7"
                        })
                    ]
                }),
                C ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        n.geneId && /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ye, {
                            label: "Gene id",
                            value: n.geneId,
                            mono: !0
                        }),
                        O && /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ye, {
                            label: "Gene name",
                            value: O
                        }),
                        n.parentId !== null && /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ye, {
                            label: "Distance",
                            value: n.distance.toFixed(4)
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ye, {
                            label: "Node id",
                            value: t.nodeId,
                            mono: !0
                        })
                    ]
                }) : /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        n.eventType && /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ye, {
                            label: "Event",
                            value: n.eventType
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ye, {
                            label: "Leaves",
                            value: String(l)
                        }),
                        n.parentId !== null && /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ye, {
                            label: "Distance",
                            value: n.distance.toFixed(4)
                        }),
                        n.bootstrap !== void 0 && /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ye, {
                            label: "Bootstrap",
                            value: String(n.bootstrap)
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ye, {
                            label: "Node id",
                            value: t.nodeId,
                            mono: !0
                        })
                    ]
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                    style: {
                        marginTop: 8,
                        paddingTop: 8,
                        borderTop: "1px solid var(--tbrowse-border-soft)",
                        display: "flex",
                        flexDirection: "column",
                        gap: 6
                    },
                    children: [
                        !a && /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                            style: {
                                display: "flex",
                                gap: 6,
                                flexWrap: "wrap"
                            },
                            children: [
                                F && /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ke, {
                                    label: i ? "Expand" : "Collapse",
                                    onClick: ()=>{
                                        g(t.nodeId), u();
                                    }
                                }),
                                fe && !i && f && /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ke, {
                                    label: "Expand all",
                                    onClick: ()=>{
                                        x(t.nodeId), u();
                                    }
                                }),
                                fe && !i && /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ke, {
                                    label: "Swap children",
                                    onClick: ()=>{
                                        p(t.nodeId), u();
                                    }
                                }),
                                U && /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ke, {
                                    label: "Make node of interest",
                                    onClick: ()=>{
                                        m(t.nodeId), u();
                                    }
                                }),
                                z && /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ke, {
                                    label: "Show paralogs",
                                    onClick: ()=>{
                                        b(t.nodeId), u();
                                    }
                                }),
                                t.nodeId !== o.tree.rootId && /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ke, {
                                    label: c ? "Uncompress branch" : "Compress branch",
                                    title: c ? "Restore this branch to its full length" : "Render this branch at the auto-compression length",
                                    onClick: ()=>{
                                        k(t.nodeId), u();
                                    }
                                })
                            ]
                        }),
                        G.length > 0 && /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                display: "flex",
                                gap: 6,
                                flexWrap: "wrap"
                            },
                            children: G.map((R, K)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)(Ke, {
                                    label: R.label,
                                    title: R.title,
                                    color: R.color ?? Bt,
                                    disabled: R.disabled,
                                    onClick: ()=>{
                                        R.onClick(), u();
                                    }
                                }, `${K}:${R.label}`))
                        }),
                        t.nodeId !== o.tree.rootId && /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                            style: {
                                display: "flex",
                                gap: 6,
                                flexWrap: "wrap"
                            },
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ke, {
                                    label: a ? "Regrow branch" : "Prune branch",
                                    color: a ? Bt : gn,
                                    disabled: !a && h,
                                    title: !a && h ? "Pruning this node would leave nothing visible" : void 0,
                                    onClick: ()=>{
                                        y(t.nodeId), u();
                                    }
                                }),
                                !a && /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ke, {
                                    label: I ? "Regrow others" : "Prune others",
                                    color: I ? Bt : gn,
                                    title: I ? "Restore the sibling branches between this node and the root" : "Prune every sibling branch between this node and the root",
                                    onClick: ()=>{
                                        I ? T(t.nodeId) : E(t.nodeId), u();
                                    }
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }), document.body);
}
function Ye({ label: e, value: t, mono: n }) {
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        style: {
            display: "flex",
            gap: 8,
            alignItems: "baseline"
        },
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                style: {
                    color: Wt,
                    minWidth: 70
                },
                children: e
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                style: {
                    fontFamily: n ? "ui-monospace, SF Mono, Menlo, monospace" : void 0,
                    wordBreak: "break-all"
                },
                children: t
            })
        ]
    });
}
function Ke({ label: e, onClick: t, color: n = "var(--tbrowse-text)", disabled: o = !1, title: i }) {
    const a = o ? Wt : n;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
        type: "button",
        onClick: t,
        disabled: o,
        title: i,
        style: {
            background: "var(--tbrowse-bg-input)",
            border: `1px solid ${a}`,
            color: a,
            borderRadius: 4,
            padding: "3px 10px",
            fontSize: 12,
            cursor: o ? "not-allowed" : "pointer",
            opacity: o ? 0.6 : 1
        },
        children: e
    });
}
function $r(e, t, n) {
    const [o, i] = (0, _react.useState)(null), a = (0, _react.useRef)(null);
    return (0, _react.useEffect)(()=>{
        if (!e.current) return;
        const c = e.current;
        let s = 0;
        const l = ()=>{
            const f = c.getBoundingClientRect(), h = {
                x: f.left + t,
                y: f.top + n
            }, u = a.current;
            (!u || u.x !== h.x || u.y !== h.y) && (a.current = h, i(h)), s = requestAnimationFrame(l);
        };
        return l(), ()=>cancelAnimationFrame(s);
    }, [
        e,
        t,
        n
    ]), o;
}
const et = 16, Ar = 44, Pr = 6, rt = "var(--tbrowse-branch)", lt = "var(--tbrowse-accent)", Wr = 1, Dr = 3, mn = 1.25, Or = 4, _r = 8, bn = 6, xn = 1, vn = 3, Nr = "var(--tbrowse-leaf-extension)", Hr = "var(--tbrowse-accent)", Fr = "#f59e0b", zr = 5, wn = 12, Gr = "var(--tbrowse-text-muted)", Br = "var(--tbrowse-danger)", Xr = 3.8, Vr = 2.5, Et = 7, Ur = 14, yn = 38, Xt = "var(--tbrowse-search, #fbbf24)", Yr = 5, Kr = 1.75, In = 10, Sn = 3, jr = 22, Zr = 2, Jr = "rgba(128, 128, 140, 0.22)", Qr = "var(--tbrowse-text-muted)", Vt = 26, Mt = 8, kn = 3.5, ei = [];
function En(e, t) {
    if (!e && !t) return 0, _tbrowseCore.EMPTY_NODE_ID_SET;
    if (e && !t) return e;
    if (t && !e) return t;
    const n = new Set(e);
    for (const o of t)n.add(o);
    return n;
}
function ti(e, t, n) {
    const o = Math.min(jr, Math.max(Sn, n - Zr)), i = (s)=>Math.log2(Math.max(1, s) + 1), a = i(e) / i(Math.max(e, t)), c = Math.min(o, Sn);
    return Math.max(c, Math.min(o, o * a));
}
const to = "triangle", ni = ({ hoveredNodeId: e, data: t, zoneState: n, setZoneState: o })=>{
    const i = (0, _react.useMemo)(()=>(0, _tbrowseCore.buildChildrenIndex)(t.tree), [
        t.tree
    ]), a = (0, _react.useMemo)(()=>eo(e, t, i), [
        e,
        t,
        i
    ]), c = (n == null ? void 0 : n.autoCompressLongBranches) ?? !0, s = ()=>o((h)=>({
                ...h ?? {},
                autoCompressLongBranches: !((h == null ? void 0 : h.autoCompressLongBranches) ?? !0)
            })), l = ((n == null ? void 0 : n.layoutMode) ?? "phylogram") === "cladogram", f = ()=>o((h)=>({
                ...h ?? {},
                layoutMode: ((h == null ? void 0 : h.layoutMode) ?? "phylogram") === "cladogram" ? "phylogram" : "cladogram"
            }));
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        style: {
            height: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 4,
            fontSize: 13,
            color: "var(--tbrowse-text)"
        },
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    padding: "0 10px 0 18px"
                },
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(nt, {
                        defaultName: "Tree",
                        customName: n == null ? void 0 : n.name,
                        onChange: (h)=>o((u)=>({
                                    ...u ?? {},
                                    name: h
                                }))
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        onClick: s,
                        title: c ? "Long branches compressed \u2014 click to show full lengths" : "Long branches at full length \u2014 click to compress outliers",
                        style: {
                            fontSize: 11,
                            padding: "1px 6px",
                            border: `1px solid ${c ? "var(--tbrowse-accent)" : "var(--tbrowse-border)"}`,
                            background: c ? "var(--tbrowse-accent-soft)" : "var(--tbrowse-bg-input)",
                            color: c ? "var(--tbrowse-accent-strong)" : "var(--tbrowse-text)",
                            borderRadius: 3,
                            cursor: "pointer"
                        },
                        children: "//"
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        onClick: f,
                        title: l ? "Cladogram \u2014 tips aligned, branch lengths ignored. Click for phylogram." : "Phylogram \u2014 positioned by branch length. Click for cladogram (aligned tips).",
                        style: {
                            fontSize: 11,
                            padding: "1px 6px",
                            border: `1px solid ${l ? "var(--tbrowse-accent)" : "var(--tbrowse-border)"}`,
                            background: l ? "var(--tbrowse-accent-soft)" : "var(--tbrowse-bg-input)",
                            color: l ? "var(--tbrowse-accent-strong)" : "var(--tbrowse-text)",
                            borderRadius: 3,
                            cursor: "pointer"
                        },
                        children: l ? "clad" : "phylo"
                    })
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                style: {
                    flex: `0 0 ${(0, _tbrowseCore.LEAF_ROW_HEIGHT)}px`,
                    minHeight: 0,
                    padding: "0 10px 0 18px",
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    fontSize: 11,
                    color: "var(--tbrowse-text-muted)",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                },
                title: a ?? "",
                children: a ?? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                    style: {
                        color: "var(--tbrowse-text-subtle)"
                    },
                    children: "hover a node\u2026"
                })
            })
        ]
    });
}, oi = ({ data: e, visibleRows: t, rowRange: n, width: o, hoveredNodeId: i, hoveredSubtreeIds: a, selectedNodeId: c, collapsedNodeIds: s, prunedNodeIds: l, swappedNodeIds: f, compressedNodeIds: h, searchResults: u, nodeOfInterestId: g, onHoverNode: y, onSelectNode: p, onClearSelection: k, onToggleCollapsed: x, onTogglePruned: m, onToggleSwapped: b, onToggleCompressed: E, onExpandSubtree: T, onMakeNodeOfInterest: I, onShowParalogs: _, onReroot: M, onRegrowOthers: $, zoneState: W })=>{
    const H = W.prunedNodeStyle ?? to, w = W.showLeafExtensions ?? !0, N = t.some((d)=>d.kind === "collapsedSummary"), v = w ? Ar : N ? yn : Pr, L = Math.max(0, o - et - v), A = (0, _react.useRef)(null), J = W.autoCompressLongBranches ?? !0, ie = (0, _react.useMemo)(()=>{
        if (!J) return /* @__PURE__ */ new Set();
        const d = [];
        for (const Z of Object.values(e.tree.nodes))Z.parentId !== null && Z.distance > 0 && d.push(Z.distance);
        if (d.length < 5) return /* @__PURE__ */ new Set();
        const S = [
            ...d
        ].sort((Z, ce)=>Z - ce), q = S[Math.floor(S.length / 2)];
        if (q <= 0) return /* @__PURE__ */ new Set();
        const X = q * 5, ee = /* @__PURE__ */ new Set();
        for (const Z of Object.values(e.tree.nodes))Z.parentId !== null && Z.distance > X && ee.add(Z.id);
        return ee;
    }, [
        e.tree,
        J
    ]), ae = (0, _react.useMemo)(()=>{
        const d = new Set(ie);
        for (const S of h)d.has(S) ? d.delete(S) : d.add(S);
        return d;
    }, [
        ie,
        h
    ]), ue = (d)=>ae.has(d), pe = (0, _react.useMemo)(()=>{
        var S;
        const d = /* @__PURE__ */ new Map();
        for (const q of Object.values(e.tree.nodes)){
            if (!q.isLeaf) continue;
            let X = q.id;
            for(; X !== null;)d.set(X, (d.get(X) ?? 0) + 1), X = ((S = e.tree.nodes[X]) == null ? void 0 : S.parentId) ?? null;
        }
        return d;
    }, [
        e.tree
    ]), oe = (0, _react.useMemo)(()=>{
        const d = Math.log(Or);
        return (S, q, X)=>{
            if (S <= 1) return q;
            const ee = Math.log(S) / d, Z = Math.min(vn, ee), ce = (X - q) / vn;
            return q + Z * ce;
        };
    }, []), B = (0, _react.useMemo)(()=>(d)=>oe(pe.get(d) ?? 1, Wr, Dr), [
        pe,
        oe
    ]), re = (0, _react.useMemo)(()=>(d)=>oe(pe.get(d) ?? 1, Ur, yn), [
        pe,
        oe
    ]), ge = (0, _react.useMemo)(()=>{
        let d = 1;
        for (const S of t)S.kind === "collapsedSummary" && S.leafCount > d && (d = S.leafCount);
        return d;
    }, [
        t
    ]), fe = (0, _react.useMemo)(()=>{
        var S, q;
        const d = /* @__PURE__ */ new Map();
        if (u.matchedLeafIds.size === 0) return d;
        for (const X of u.matchedLeafIds){
            let ee = ((S = e.tree.nodes[X]) == null ? void 0 : S.parentId) ?? null;
            for(; ee !== null;)d.set(ee, (d.get(ee) ?? 0) + 1), ee = ((q = e.tree.nodes[ee]) == null ? void 0 : q.parentId) ?? null;
        }
        return d;
    }, [
        u.matchedLeafIds,
        e.tree
    ]), C = (0, _react.useMemo)(()=>Tr({
            tree: e.tree,
            visibleRows: t,
            drawingLeftX: et,
            drawingWidth: L,
            layoutMode: W.layoutMode
        }), [
        e.tree,
        t,
        L,
        W.layoutMode
    ]), O = (0, _react.useMemo)(()=>{
        if (ae.size === 0 || L <= 0) return C;
        const d = L * 0.1, S = new Map(C.nodes.map((he)=>[
                he.nodeId,
                he
            ])), q = /* @__PURE__ */ new Map();
        for (const he of C.nodes){
            if (he.parentId === null) continue;
            const xe = q.get(he.parentId);
            xe ? xe.push(he.nodeId) : q.set(he.parentId, [
                he.nodeId
            ]);
        }
        const X = /* @__PURE__ */ new Map(), ee = [];
        for(C.rootId && (X.set(C.rootId, S.get(C.rootId).x), ee.push(C.rootId)); ee.length > 0;){
            const he = ee.shift(), xe = S.get(he).x, Ce = X.get(he);
            for (const Pe of q.get(he) ?? []){
                const ze = S.get(Pe).x - xe, Ue = ae.has(Pe) ? Math.min(ze, d) : ze;
                X.set(Pe, Ce + Ue), ee.push(Pe);
            }
        }
        let Z = et;
        for (const he of C.nodes){
            if (!he.isVisibleEnd) continue;
            const xe = X.get(he.nodeId) ?? he.x;
            xe > Z && (Z = xe);
        }
        const ce = Z - et, be = ce > 0 ? L / ce : 1;
        return {
            rootId: C.rootId,
            nodes: C.nodes.map((he)=>{
                const xe = X.get(he.nodeId) ?? he.x;
                return {
                    ...he,
                    x: et + (xe - et) * be
                };
            })
        };
    }, [
        C,
        ae,
        L
    ]), F = (0, _react.useMemo)(()=>i === null ? /* @__PURE__ */ new Set() : (0, _tbrowseCore.ancestorIdsOf)(e.tree, i), [
        i,
        e.tree
    ]), z = (0, _react.useMemo)(()=>(0, _tbrowseCore.buildChildrenIndex)(e.tree), [
        e.tree
    ]), U = W.rerootCompression ?? !0, G = (0, _react.useMemo)(()=>{
        if (!U || !O.rootId) return null;
        const d = /* @__PURE__ */ new Map(), S = /* @__PURE__ */ new Map();
        for (const Se of O.nodes){
            if (d.set(Se.nodeId, Se), Se.parentId === null) continue;
            let qe = S.get(Se.parentId);
            qe || (qe = [], S.set(Se.parentId, qe)), qe.push(Se.nodeId);
        }
        const q = [];
        let X = O.rootId;
        for(; X !== null;){
            const Se = d.get(X);
            if (!Se || (q.push(X), Se.isVisibleEnd)) break;
            const qe = S.get(X);
            if (!qe || qe.length !== 1) break;
            X = qe[0];
        }
        if (q.length <= 1) return null;
        const ee = d.get(q[0]), Z = d.get(q[q.length - 1]);
        if (!ee || !Z) return null;
        const ce = Z.x - ee.x;
        if (ce <= Vt) return null;
        const be = ce - Vt, he = /* @__PURE__ */ new Set([
            Z.nodeId
        ]), xe = [
            Z.nodeId
        ];
        for(; xe.length > 0;){
            const Se = xe.shift();
            for (const qe of S.get(Se) ?? [])he.has(qe) || (he.add(qe), xe.push(qe));
        }
        let Ce = -1 / 0;
        for (const Se of O.nodes){
            if (!he.has(Se.nodeId) || !Se.isVisibleEnd) continue;
            const qe = Se.x - be;
            qe > Ce && (Ce = qe);
        }
        const Pe = Z.x - be, Ve = et + L, ze = Ce - Pe, Ue = Ve - Pe, ot = ze > 0 && Ue > 0 ? Ue / ze : 1, je = new Set(q.slice(1, -1)), We = O.nodes.map((Se)=>{
            if (he.has(Se.nodeId)) {
                const qe = Se.x - be, Qe = Pe + (qe - Pe) * ot;
                return {
                    ...Se,
                    x: Qe
                };
            }
            return je.has(Se.nodeId) ? {
                ...Se,
                x: Pe
            } : Se;
        });
        return {
            chain: q,
            branchSkip: new Set(q.slice(1)),
            glyphSkip: je,
            nodes: We
        };
    }, [
        O,
        U,
        L
    ]), Y = (0, _react.useMemo)(()=>U ? qr((G == null ? void 0 : G.nodes) ?? O.nodes, O.rootId, {
            compressedWidth: Vt,
            exclude: G ? new Set(G.chain) : void 0,
            minChainLength: 2
        }) : null, [
        G,
        O,
        U
    ]), R = (Y == null ? void 0 : Y.nodes) ?? (G == null ? void 0 : G.nodes) ?? O.nodes, K = (0, _react.useMemo)(()=>En(G == null ? void 0 : G.branchSkip, Y == null ? void 0 : Y.branchSkip), [
        G,
        Y
    ]), Q = (0, _react.useMemo)(()=>En(G == null ? void 0 : G.glyphSkip, Y == null ? void 0 : Y.glyphSkip), [
        G,
        Y
    ]), se = (G == null ? void 0 : G.chain) ?? null, le = (Y == null ? void 0 : Y.segments) ?? ei, te = (0, _react.useMemo)(()=>{
        const d = /* @__PURE__ */ new Map();
        for (const S of R)d.set(S.nodeId, S);
        return d;
    }, [
        R
    ]), V = (0, _react.useMemo)(()=>{
        var S, q;
        const d = /* @__PURE__ */ new Map();
        for (const X of O.nodes)d.set(X.nodeId, 0);
        for (const X of t)d.set(X.nodeId, X.opacity ?? 1);
        for (const X of t){
            const ee = X.opacity ?? 1;
            let Z = ((S = e.tree.nodes[X.nodeId]) == null ? void 0 : S.parentId) ?? null;
            for(; Z !== null && d.has(Z);){
                const ce = d.get(Z) ?? 0;
                ee > ce && d.set(Z, ee), Z = ((q = e.tree.nodes[Z]) == null ? void 0 : q.parentId) ?? null;
            }
        }
        return d;
    }, [
        O,
        t,
        e.tree
    ]), ne = (0, _react.useMemo)(()=>{
        var ee, Z;
        const d = (Y == null ? void 0 : Y.anchorToSegment) ?? null, S = /* @__PURE__ */ new Map(), q = /* @__PURE__ */ new Map();
        for (const ce of l){
            let be = ((ee = e.tree.nodes[ce]) == null ? void 0 : ee.parentId) ?? null;
            for(; be !== null && !te.has(be);)be = ((Z = e.tree.nodes[be]) == null ? void 0 : Z.parentId) ?? null;
            if (be === null) continue;
            const he = d == null ? void 0 : d.get(be);
            if (he !== void 0) {
                let Ce = q.get(he);
                Ce || (Ce = [], q.set(he, Ce)), Ce.push(ce);
                continue;
            }
            let xe = S.get(be);
            xe || (xe = [], S.set(be, xe)), xe.push(ce);
        }
        const X = [];
        for (const [ce, be] of S){
            const he = te.get(ce);
            if (!he) continue;
            const xe = z.get(ce) ?? [], Ce = f.has(ce) ? [
                ...xe
            ].reverse() : xe, Pe = [];
            Ce.forEach((We, Se)=>{
                te.has(We) && Pe.push(Se);
            });
            const Ve = Pe.length > 0 ? Pe.reduce((We, Se)=>We + Se, 0) / Pe.length : 0, ze = be.map((We)=>{
                var St, un;
                let Se = We, qe = ((St = e.tree.nodes[We]) == null ? void 0 : St.parentId) ?? null;
                for(; qe !== null && qe !== ce;)Se = qe, qe = ((un = e.tree.nodes[qe]) == null ? void 0 : un.parentId) ?? null;
                const Qe = Ce.indexOf(Se), It = Qe >= 0 && Qe < Ve;
                return {
                    prunedId: We,
                    baIdx: Qe,
                    above: It
                };
            }), Ue = ze.filter((We)=>We.above).sort((We, Se)=>Se.baIdx - We.baIdx), ot = ze.filter((We)=>!We.above).sort((We, Se)=>We.baIdx - Se.baIdx), je = (We, Se)=>{
                for (const qe of We){
                    const Qe = (0, _tbrowseCore.countLeavesInSubtree)(qe.prunedId, e.tree, z), It = he.y + Se * bn, St = he.x + _r;
                    X.push({
                        prunedId: qe.prunedId,
                        anchorX: he.x,
                        anchorY: he.y,
                        stubY: It,
                        markX: St,
                        markY: It,
                        leafCount: Qe,
                        strokeWidth: xn
                    });
                }
            };
            je(Ue, -1), je(ot, 1);
        }
        if (d) for (const [ce, be] of q){
            const he = le[ce];
            if (!he) continue;
            const xe = te.get(he.startId), Ce = te.get(he.exitId);
            if (!xe || !Ce) continue;
            const Pe = (xe.x + Ce.x) / 2;
            let Ve = 0, ze = be[0], Ue = -1;
            for (const je of be){
                const We = (0, _tbrowseCore.countLeavesInSubtree)(je, e.tree, z);
                Ve += We, We > Ue && (Ue = We, ze = je);
            }
            const ot = xe.y + bn;
            X.push({
                prunedId: ze,
                anchorX: Pe,
                anchorY: xe.y,
                stubY: ot,
                markX: Pe,
                markY: ot,
                leafCount: Ve,
                strokeWidth: xn
            });
        }
        return X;
    }, [
        l,
        e.tree,
        te,
        z,
        f,
        Y,
        le
    ]), de = (d)=>a.has(d) || F.has(d), me = (0, _react.useMemo)(()=>{
        var X;
        if (c === null || l.has(c) || !e.tree.nodes[c]) return !1;
        const S = /* @__PURE__ */ new Set(), q = [
            c
        ];
        for(; q.length > 0;){
            const ee = q.pop();
            if (S.has(ee)) continue;
            S.add(ee);
            const Z = z.get(ee);
            if (Z) for (const ce of Z)q.push(ce);
        }
        for (const ee of Object.values(e.tree.nodes)){
            if (!ee.isLeaf || S.has(ee.id)) continue;
            let Z = ee.id, ce = !1;
            for(; Z !== null;){
                if (l.has(Z)) {
                    ce = !0;
                    break;
                }
                Z = ((X = e.tree.nodes[Z]) == null ? void 0 : X.parentId) ?? null;
            }
            if (!ce) return !1;
        }
        return !0;
    }, [
        c,
        l,
        z,
        e.tree
    ]), we = (0, _react.useMemo)(()=>{
        if (c === null) return !1;
        const d = e.tree.nodes[c];
        if (!d || d.isLeaf || s.has(c) || s.size === 0) return !1;
        const S = [
            ...z.get(c) ?? []
        ];
        for(; S.length > 0;){
            const q = S.pop();
            if (s.has(q)) return !0;
            const X = z.get(q);
            if (X) for (const ee of X)S.push(ee);
        }
        return !1;
    }, [
        c,
        e.tree,
        s,
        z
    ]), ke = (0, _react.useMemo)(()=>{
        var q;
        if (c === null || l.size === 0) return !1;
        const d = /* @__PURE__ */ new Set();
        let S = c;
        for(; S !== null;)d.add(S), S = ((q = e.tree.nodes[S]) == null ? void 0 : q.parentId) ?? null;
        if (d.size <= 1) return !1;
        for (const X of d){
            if (X === c) continue;
            const ee = z.get(X);
            if (ee) {
                for (const Z of ee)if (!d.has(Z) && l.has(Z)) return !0;
            }
        }
        return !1;
    }, [
        c,
        e.tree,
        z,
        l
    ]);
    if (O.nodes.length === 0) return null;
    const Re = t.length > 0 ? t[t.length - 1].y + t[t.length - 1].height : 0, Ae = o - 1, _e = t[Math.max(0, n.startIndex)], Fe = t[Math.max(0, Math.min(t.length - 1, n.endIndex - 1))], Xe = _e ? _e.y : 0, Be = Fe ? Fe.y + Fe.height : Re, Ne = (d)=>d >= Xe && d <= Be, Te = (d, S)=>{
        const q = d < S ? d : S;
        return (d < S ? S : d) >= Xe && q <= Be;
    }, Ee = c !== null ? e.tree.nodes[c] : null;
    let $e = c !== null ? te.get(c) ?? null : null;
    if (!$e && c !== null && l.has(c)) {
        const d = ne.find((S)=>S.prunedId === c);
        d && Ee && ($e = {
            nodeId: c,
            parentId: Ee.parentId,
            x: d.markX,
            y: d.markY,
            isVisibleEnd: !1,
            isLeaf: Ee.isLeaf,
            isCollapsedSummary: !1
        });
    }
    const D = c !== null && Ee && !Ee.isLeaf ? (0, _tbrowseCore.countLeavesInSubtree)(c, e.tree, z) : 0;
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("svg", {
                ref: A,
                width: o,
                height: Re,
                style: {
                    display: "block",
                    shapeRendering: "crispEdges"
                },
                onMouseLeave: ()=>y(null),
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                        x: 0,
                        y: 0,
                        width: o,
                        height: Re,
                        fill: "transparent",
                        onClick: k
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("g", {
                        children: R.map((d)=>{
                            if (!d.isVisibleEnd) return null;
                            const S = t.find((q)=>q.nodeId === d.nodeId);
                            return !S || !Ne(S.y) ? null : /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                                x: 0,
                                y: S.y,
                                width: o,
                                height: S.height,
                                fill: "transparent",
                                onMouseEnter: ()=>y(d.nodeId),
                                onClick: ()=>p(d.nodeId),
                                style: {
                                    cursor: "pointer"
                                }
                            }, `row-${d.nodeId}`);
                        })
                    }),
                    (()=>{
                        if (!O.rootId) return null;
                        const d = te.get(O.rootId);
                        if (!d || !Ne(d.y)) return null;
                        const S = de(d.nodeId), q = B(d.nodeId);
                        return /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                            x1: d.x - In,
                            y1: d.y,
                            x2: d.x,
                            y2: d.y,
                            stroke: S ? lt : rt,
                            strokeWidth: S ? q + mn : q,
                            strokeLinecap: "round",
                            pointerEvents: "none"
                        }, "b-root");
                    })(),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("g", {
                        pointerEvents: "none",
                        children: R.map((d)=>{
                            if (d.parentId === null || K.has(d.nodeId)) return null;
                            const S = te.get(d.parentId);
                            if (!S || !Te(S.y, d.y)) return null;
                            const q = V.get(d.nodeId) ?? 1, X = S.x + (d.x - S.x) * q, ee = `M ${S.x} ${S.y} L ${S.x} ${d.y} L ${X} ${d.y}`, Z = de(d.nodeId), ce = B(d.nodeId);
                            return /* @__PURE__ */ (0, _jsxRuntime.jsx)("path", {
                                d: ee,
                                stroke: Z ? lt : rt,
                                strokeWidth: Z ? ce + mn : ce,
                                strokeLinejoin: "round",
                                strokeLinecap: "round",
                                fill: "none",
                                opacity: q
                            }, `b-${d.nodeId}`);
                        })
                    }),
                    se && (()=>{
                        const d = te.get(se[0]), S = te.get(se[se.length - 1]);
                        if (!d || !S || !Ne(d.y)) return null;
                        const q = d.x, ee = S.x - q;
                        if (ee <= 0) return null;
                        const Z = 2, be = Math.max(0, ee - 2 * Z) / (Mt - 1), he = kn / 2;
                        return /* @__PURE__ */ (0, _jsxRuntime.jsx)("g", {
                            pointerEvents: "none",
                            children: Array.from({
                                length: Mt
                            }).map((xe, Ce)=>{
                                const Pe = q + Z + Ce * be;
                                return /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                                    x1: Pe,
                                    y1: d.y - he,
                                    x2: Pe,
                                    y2: d.y + he,
                                    stroke: rt,
                                    strokeWidth: 1.25,
                                    strokeLinecap: "round"
                                }, `crp-${Ce}`);
                            })
                        });
                    })(),
                    le.length > 0 && /* @__PURE__ */ (0, _jsxRuntime.jsx)("g", {
                        pointerEvents: "none",
                        children: le.map((d, S)=>{
                            const q = te.get(d.startId), X = te.get(d.exitId);
                            if (!q || !X || !Ne(q.y)) return null;
                            const ee = q.x, ce = X.x - ee;
                            if (ce <= 0) return null;
                            const be = 2, xe = Math.max(0, ce - 2 * be) / (Mt - 1), Ce = kn / 2;
                            return Array.from({
                                length: Mt
                            }).map((Pe, Ve)=>{
                                const ze = ee + be + Ve * xe;
                                return /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                                    x1: ze,
                                    y1: q.y - Ce,
                                    x2: ze,
                                    y2: q.y + Ce,
                                    stroke: rt,
                                    strokeWidth: 1.25,
                                    strokeLinecap: "round"
                                }, `csp-${S}-${Ve}`);
                            });
                        })
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("g", {
                        pointerEvents: "none",
                        children: R.map((d)=>{
                            if (d.parentId === null || K.has(d.nodeId) || !ae.has(d.nodeId)) return null;
                            const S = te.get(d.parentId);
                            if (!S || !Ne(d.y)) return null;
                            const q = V.get(d.nodeId) ?? 1, X = S.x + (d.x - S.x) * q, ee = (S.x + X) / 2, ce = de(d.nodeId) ? lt : rt;
                            return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("g", {
                                opacity: q,
                                children: [
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                                        x1: ee - 3,
                                        y1: d.y + 3,
                                        x2: ee,
                                        y2: d.y - 3,
                                        stroke: ce,
                                        strokeWidth: 1.2
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                                        x1: ee,
                                        y1: d.y + 3,
                                        x2: ee + 3,
                                        y2: d.y - 3,
                                        stroke: ce,
                                        strokeWidth: 1.2
                                    })
                                ]
                            }, `bc-${d.nodeId}`);
                        })
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("g", {
                        pointerEvents: "none",
                        children: w && R.map((d)=>{
                            if (!d.isVisibleEnd || !Ne(d.y)) return null;
                            const S = de(d.nodeId), q = V.get(d.nodeId) ?? 1, X = d.parentId !== null ? te.get(d.parentId) : null, ee = X ? X.x + (d.x - X.x) * q : d.x, Z = d.isCollapsedSummary ? ee + re(d.nodeId) : ee;
                            return Z >= Ae ? null : /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                                x1: Z,
                                y1: d.y,
                                x2: Ae,
                                y2: d.y,
                                stroke: S ? Hr : Nr,
                                strokeWidth: S ? 1.5 : 1,
                                strokeDasharray: "2 3",
                                opacity: q
                            }, `e-${d.nodeId}`);
                        })
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("g", {
                        pointerEvents: "none",
                        children: R.map((d)=>{
                            if (!d.isCollapsedSummary || !Ne(d.y)) return null;
                            const S = t.find((Pe)=>Pe.nodeId === d.nodeId);
                            if (!S) return null;
                            const q = V.get(d.nodeId) ?? 1, X = d.parentId !== null ? te.get(d.parentId) : null, ee = X ? X.x + (d.x - X.x) * q : d.x, Z = ee + re(d.nodeId), ce = ti(S.leafCount, ge, S.height), be = d.y - ce / 2, he = d.y + ce / 2, xe = fe.get(d.nodeId) ?? 0, Ce = B(d.nodeId);
                            return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("g", {
                                opacity: q,
                                children: [
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("polygon", {
                                        points: `${ee},${d.y} ${Z},${be} ${Z},${he}`,
                                        fill: Jr,
                                        stroke: xe > 0 ? Xt : Qr,
                                        strokeWidth: xe > 0 ? Ce + 0.75 : Ce,
                                        strokeLinejoin: "round",
                                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("title", {
                                            children: xe > 0 ? `Collapsed (${S.leafCount} leaves, ${xe} matching)` : `Collapsed (${S.leafCount} leaves)`
                                        })
                                    }),
                                    xe > 0 && /* @__PURE__ */ (0, _jsxRuntime.jsx)("text", {
                                        x: Z + 3,
                                        y: d.y + 3,
                                        fontSize: 10,
                                        fontWeight: 600,
                                        fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
                                        fill: Xt,
                                        children: xe
                                    })
                                ]
                            }, `c-${d.nodeId}`);
                        })
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("g", {
                        pointerEvents: "none",
                        children: R.map((d)=>{
                            if (d.isLeaf || d.isVisibleEnd || Q.has(d.nodeId) || !Ne(d.y)) return null;
                            const S = e.tree.nodes[d.nodeId];
                            if (!S) return null;
                            const q = V.get(d.nodeId) ?? 1, X = d.parentId !== null ? te.get(d.parentId) : null, ee = X ? X.x + (d.x - X.x) * q : d.x, Z = q;
                            return S.eventType === "duplication" ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                                x: ee - Et / 2,
                                y: d.y - Et / 2,
                                width: Et,
                                height: Et,
                                fill: Br,
                                opacity: Z,
                                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("title", {
                                    children: `duplication${S.bootstrap !== void 0 ? ` \xb7 bootstrap ${S.bootstrap}` : ""}`
                                })
                            }, `g-${d.nodeId}`) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("circle", {
                                cx: ee,
                                cy: d.y,
                                r: Xr,
                                fill: Gr,
                                opacity: Z,
                                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("title", {
                                    children: `${S.eventType ?? "speciation"}${S.bootstrap !== void 0 ? ` \xb7 bootstrap ${S.bootstrap}` : ""}`
                                })
                            }, `g-${d.nodeId}`);
                        })
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("g", {
                        pointerEvents: "none",
                        children: R.map((d)=>{
                            if (!d.isLeaf || d.isCollapsedSummary || !Ne(d.y)) return null;
                            const S = e.tree.nodes[d.nodeId];
                            if (!S) return null;
                            const q = V.get(d.nodeId) ?? 1, X = d.parentId !== null ? te.get(d.parentId) : null, ee = X ? X.x + (d.x - X.x) * q : d.x, Z = q, ce = u.matchedLeafIds.has(d.nodeId);
                            return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("g", {
                                opacity: Z,
                                children: [
                                    ce && /* @__PURE__ */ (0, _jsxRuntime.jsx)("circle", {
                                        cx: ee,
                                        cy: d.y,
                                        r: Yr,
                                        fill: "none",
                                        stroke: Xt,
                                        strokeWidth: Kr
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("circle", {
                                        cx: ee,
                                        cy: d.y,
                                        r: Vr,
                                        fill: rt,
                                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("title", {
                                            children: S.geneId ?? d.nodeId
                                        })
                                    })
                                ]
                            }, `l-${d.nodeId}`);
                        })
                    }),
                    $e && c !== null && !l.has(c) && /* @__PURE__ */ (0, _jsxRuntime.jsx)("circle", {
                        cx: $e.x,
                        cy: $e.y,
                        r: zr,
                        fill: Fr,
                        stroke: "white",
                        strokeWidth: 1.5,
                        pointerEvents: "none"
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            O.rootId && (()=>{
                                const d = te.get(O.rootId);
                                return !d || !Ne(d.y) ? null : /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                                    x1: d.x - In,
                                    y1: d.y,
                                    x2: d.x,
                                    y2: d.y,
                                    stroke: "transparent",
                                    strokeWidth: wn,
                                    onMouseEnter: ()=>y(d.nodeId),
                                    onClick: ()=>p(d.nodeId),
                                    style: {
                                        cursor: "pointer"
                                    }
                                }, "h-root");
                            })(),
                            R.map((d)=>{
                                if (d.parentId === null || K.has(d.nodeId)) return null;
                                const S = te.get(d.parentId);
                                if (!S || !Te(S.y, d.y)) return null;
                                const q = `M ${S.x} ${S.y} L ${S.x} ${d.y} L ${d.x} ${d.y}`;
                                return /* @__PURE__ */ (0, _jsxRuntime.jsx)("path", {
                                    d: q,
                                    stroke: "transparent",
                                    strokeWidth: wn,
                                    fill: "none",
                                    onMouseEnter: ()=>y(d.nodeId),
                                    onClick: ()=>p(d.nodeId),
                                    style: {
                                        cursor: "pointer"
                                    }
                                }, `h-${d.nodeId}`);
                            })
                        ]
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("g", {
                        children: ne.map((d)=>{
                            if (!Ne(d.markY) && !Ne(d.anchorY)) return null;
                            const S = c === d.prunedId;
                            return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("g", {
                                style: {
                                    cursor: "pointer"
                                },
                                onClick: (q)=>{
                                    q.stopPropagation(), p(d.prunedId);
                                },
                                children: [
                                    ri(H, d, S),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("circle", {
                                        cx: d.markX,
                                        cy: d.markY,
                                        r: 9,
                                        fill: "transparent"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("title", {
                                        children: `Click to inspect pruned subtree (${d.prunedId})`
                                    })
                                ]
                            }, `pstub-${d.prunedId}`);
                        })
                    })
                ]
            }),
            $e && Ee && c !== null && /* @__PURE__ */ (0, _jsxRuntime.jsx)(Rr, {
                svgRef: A,
                layoutNode: $e,
                treeNode: Ee,
                data: e,
                isCollapsed: s.has(c),
                isPruned: l.has(c),
                isCompressed: ue(c),
                isNodeOfInterest: g === c,
                subtreeLeafCount: D,
                hasCollapsedDescendants: we,
                pruneWouldEmptyTree: me,
                onClose: k,
                onToggleCollapsed: x,
                onTogglePruned: m,
                onToggleSwapped: b,
                onToggleCompressed: E,
                onExpandSubtree: T,
                onMakeNodeOfInterest: I,
                onShowParalogs: _,
                onReroot: M,
                onRegrowOthers: $,
                othersArePruned: ke
            })
        ]
    });
};
function ri(e, t, n) {
    const o = n ? lt : "#888", i = n ? lt : "white", a = n ? lt : "#666", c = /* @__PURE__ */ (0, _jsxRuntime.jsx)("path", {
        d: `M ${t.anchorX} ${t.anchorY} L ${t.anchorX} ${t.stubY} L ${t.markX} ${t.stubY}`,
        fill: "none",
        stroke: o,
        strokeWidth: t.strokeWidth,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        pointerEvents: "none"
    }), s = t.markX, l = t.markY;
    switch(e){
        case "square":
            return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    c,
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                        x: s - 3,
                        y: l - 3,
                        width: 6,
                        height: 6,
                        fill: i,
                        stroke: o,
                        strokeWidth: 1,
                        pointerEvents: "none"
                    })
                ]
            });
        case "triangle":
            return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    c,
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("polygon", {
                        points: `${s - 3},${l} ${s + 3},${l - 3} ${s + 3},${l + 3}`,
                        fill: i,
                        stroke: o,
                        strokeWidth: 0.6,
                        pointerEvents: "none"
                    })
                ]
            });
        case "cap":
            return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    c,
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                        x1: s,
                        y1: l - 4,
                        x2: s,
                        y2: l + 4,
                        stroke: o,
                        strokeWidth: 1.5,
                        pointerEvents: "none"
                    })
                ]
            });
        case "slash":
            return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    c,
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                        x: s - 3,
                        y: l - 3,
                        width: 6,
                        height: 6,
                        fill: i,
                        stroke: o,
                        strokeWidth: 1,
                        pointerEvents: "none"
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                        x1: s - 3,
                        y1: l + 3,
                        x2: s + 3,
                        y2: l - 3,
                        stroke: o,
                        strokeWidth: 1.2,
                        pointerEvents: "none"
                    })
                ]
            });
        case "scissors":
            return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    c,
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                        x1: s - 3,
                        y1: l - 3,
                        x2: s + 3,
                        y2: l + 3,
                        stroke: o,
                        strokeWidth: 1.4,
                        pointerEvents: "none"
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                        x1: s - 3,
                        y1: l + 3,
                        x2: s + 3,
                        y2: l - 3,
                        stroke: o,
                        strokeWidth: 1.4,
                        pointerEvents: "none"
                    })
                ]
            });
        case "ellipsis":
            return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    c,
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                        x: s - 6,
                        y: l - 4,
                        width: 12,
                        height: 8,
                        rx: 2,
                        ry: 2,
                        fill: i,
                        stroke: o,
                        strokeWidth: 1,
                        pointerEvents: "none"
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("text", {
                        x: s,
                        y: l + 0.5,
                        textAnchor: "middle",
                        dominantBaseline: "middle",
                        fontSize: 8,
                        fontFamily: "ui-monospace, monospace",
                        fill: a,
                        pointerEvents: "none",
                        children: "\u2026"
                    })
                ]
            });
        case "ghost":
            return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("g", {
                opacity: 0.45,
                children: [
                    c,
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                        x: s - 4,
                        y: l - 4,
                        width: 8,
                        height: 8,
                        rx: 2,
                        ry: 2,
                        fill: "none",
                        stroke: o,
                        strokeWidth: 1,
                        pointerEvents: "none"
                    })
                ]
            });
        case "minitree":
            return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    c,
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("g", {
                        pointerEvents: "none",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                                x1: s - 3,
                                y1: l,
                                x2: s + 1,
                                y2: l,
                                stroke: o,
                                strokeWidth: 1
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                                x1: s + 1,
                                y1: l - 4,
                                x2: s + 1,
                                y2: l + 4,
                                stroke: o,
                                strokeWidth: 1
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                                x1: s + 1,
                                y1: l - 4,
                                x2: s + 4,
                                y2: l - 4,
                                stroke: o,
                                strokeWidth: 1
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                                x1: s + 1,
                                y1: l,
                                x2: s + 4,
                                y2: l,
                                stroke: o,
                                strokeWidth: 1
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                                x1: s + 1,
                                y1: l + 4,
                                x2: s + 4,
                                y2: l + 4,
                                stroke: o,
                                strokeWidth: 1
                            })
                        ]
                    })
                ]
            });
        case "count":
            {
                const f = String(t.leafCount), u = Math.max(12, f.length * 5 + 6);
                return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        c,
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                            x: s - u / 2,
                            y: l - 5,
                            width: u,
                            height: 10,
                            rx: 5,
                            ry: 5,
                            fill: i,
                            stroke: o,
                            strokeWidth: 1,
                            pointerEvents: "none"
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("text", {
                            x: s,
                            y: l + 0.5,
                            textAnchor: "middle",
                            dominantBaseline: "middle",
                            fontSize: 8,
                            fontFamily: "ui-monospace, monospace",
                            fontWeight: 600,
                            fill: a,
                            pointerEvents: "none",
                            children: f
                        })
                    ]
                });
            }
        case "broken":
            {
                const f = t.markX - 6, h = t.markX;
                return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("path", {
                            d: `M ${t.anchorX} ${t.anchorY} L ${t.anchorX} ${t.stubY} L ${f} ${t.stubY}`,
                            fill: "none",
                            stroke: o,
                            strokeWidth: 1,
                            pointerEvents: "none"
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("polyline", {
                            points: `${f},${t.stubY} ${f + 1.5},${t.stubY - 3} ${f + 3},${t.stubY + 3} ${f + 4.5},${t.stubY - 3} ${h},${t.stubY + 1}`,
                            fill: "none",
                            stroke: o,
                            strokeWidth: 1,
                            pointerEvents: "none"
                        })
                    ]
                });
            }
        case "bracket":
            return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    c,
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("polyline", {
                        points: `${s - 1},${l - 4} ${s + 3},${l - 4} ${s + 3},${l + 4} ${s - 1},${l + 4}`,
                        fill: "none",
                        stroke: o,
                        strokeWidth: 1.2,
                        pointerEvents: "none"
                    })
                ]
            });
    }
}
const rl = {
    id: "tree",
    displayName: "Tree",
    Header: ni,
    Body: oi,
    defaultWidth: 30,
    minWidth: 120,
    defaultZoneState: {
        prunedNodeStyle: to
    },
    isAvailable: (e)=>!!e.tree
}, ii = [
    {
        kind: "builtin",
        id: "gene.id",
        label: "Gene ID",
        get: (e)=>e.geneId ?? null
    },
    {
        kind: "builtin",
        id: "gene.name",
        label: "Gene name",
        get: (e, t)=>{
            var o, i;
            if (!e.geneId) return null;
            const n = (i = (o = t.geneMetadata) == null ? void 0 : o[e.geneId]) == null ? void 0 : i.displayName;
            return typeof n == "string" ? n : null;
        }
    },
    {
        kind: "builtin",
        id: "gene.description",
        label: "Gene description",
        get: (e, t)=>{
            var o, i;
            if (!e.geneId) return null;
            const n = (i = (o = t.geneMetadata) == null ? void 0 : o[e.geneId]) == null ? void 0 : i.description;
            return typeof n == "string" ? n : null;
        }
    },
    {
        kind: "builtin",
        id: "taxonomy.scientificName",
        label: "Scientific name",
        get: (e, t)=>{
            var n, o;
            return e.taxonomyId === void 0 ? null : ((o = (n = t.taxonomy) == null ? void 0 : n[e.taxonomyId]) == null ? void 0 : o.scientificName) ?? null;
        }
    },
    {
        kind: "builtin",
        id: "taxonomy.commonName",
        label: "Common name",
        get: (e, t)=>{
            var n, o;
            return e.taxonomyId === void 0 ? null : ((o = (n = t.taxonomy) == null ? void 0 : n[e.taxonomyId]) == null ? void 0 : o.commonName) ?? null;
        }
    },
    // Germplasm fields. Keyed by the leaf's `geneId` field, which for
    // germplasm trees carries the germplasmDbId / germplasmName. They
    // return null when no germplasm record exists, so they're invisible
    // on gene trees and other non-germplasm sources.
    {
        kind: "builtin",
        id: "germplasm.id",
        label: "Germplasm ID",
        get: (e)=>e.geneId ?? null
    },
    {
        kind: "builtin",
        id: "germplasm.name",
        label: "Germplasm name",
        get: (e, t)=>{
            var o;
            if (!e.geneId) return null;
            const n = (o = t.germplasm) == null ? void 0 : o[e.geneId];
            return (n == null ? void 0 : n.defaultDisplayName) ?? (n == null ? void 0 : n.germplasmName) ?? null;
        }
    },
    {
        kind: "builtin",
        id: "germplasm.species",
        label: "Species",
        get: (e, t)=>{
            var o;
            if (!e.geneId) return null;
            const n = (o = t.germplasm) == null ? void 0 : o[e.geneId];
            return n ? n.genus && n.species ? `${n.genus} ${n.species}` : n.species ?? null : null;
        }
    },
    {
        kind: "builtin",
        id: "germplasm.crop",
        label: "Crop",
        get: (e, t)=>{
            var n, o;
            return e.geneId ? ((o = (n = t.germplasm) == null ? void 0 : n[e.geneId]) == null ? void 0 : o.commonCropName) ?? null : null;
        }
    },
    {
        kind: "builtin",
        id: "germplasm.accession",
        label: "Accession",
        get: (e, t)=>{
            var n, o;
            return e.geneId ? ((o = (n = t.germplasm) == null ? void 0 : n[e.geneId]) == null ? void 0 : o.accessionNumber) ?? null : null;
        }
    },
    {
        kind: "builtin",
        id: "germplasm.pedigree",
        label: "Pedigree",
        get: (e, t)=>{
            var n, o;
            return e.geneId ? ((o = (n = t.germplasm) == null ? void 0 : n[e.geneId]) == null ? void 0 : o.pedigree) ?? null : null;
        }
    },
    {
        kind: "builtin",
        id: "germplasm.country",
        label: "Country of origin",
        get: (e, t)=>{
            var n, o;
            return e.geneId ? ((o = (n = t.germplasm) == null ? void 0 : n[e.geneId]) == null ? void 0 : o.countryOfOriginCode) ?? null : null;
        }
    }
];
function si(e) {
    return !e || e.length === 0 ? [] : e.map((t)=>({
            kind: "provider",
            id: t.id,
            label: t.label,
            providerId: t.id
        }));
}
function no(e) {
    return [
        ...ii,
        ...si(e.labelProviders)
    ];
}
function li({ fields: e, visibleFields: t, onChange: n }) {
    const [o, i] = (0, _react.useState)(!1), [a, c] = (0, _react.useState)(null), s = (0, _react.useRef)(null), l = Le((p)=>p.theme), f = new Set(t), h = ()=>{
        if (!o && s.current) {
            const p = s.current.getBoundingClientRect(), k = s.current.closest("[data-labels-zone-header]"), x = k == null ? void 0 : k.getBoundingClientRect(), m = x ? Math.max(0, window.innerWidth - x.right) : Math.max(0, window.innerWidth - p.right), b = x ? x.right - x.left : 240, E = Math.max(220, b);
            c({
                right: m,
                top: p.bottom + 4,
                maxWidth: E
            });
        }
        i((p)=>!p);
    };
    (0, _react.useEffect)(()=>{
        if (!o) return;
        const p = (x)=>{
            var E;
            const m = x.target;
            if ((E = s.current) != null && E.contains(m)) return;
            const b = document.querySelector(".tbrowse-labels-config");
            b != null && b.contains(m) || i(!1);
        }, k = (x)=>{
            x.key === "Escape" && i(!1);
        };
        return document.addEventListener("mousedown", p), document.addEventListener("keydown", k), ()=>{
            document.removeEventListener("mousedown", p), document.removeEventListener("keydown", k);
        };
    }, [
        o
    ]);
    const u = (p)=>{
        if (f.has(p)) n(t.filter((k)=>k !== p));
        else {
            const k = /* @__PURE__ */ new Set([
                ...t,
                p
            ]);
            n(e.filter((x)=>k.has(x.id)).map((x)=>x.id));
        }
    }, g = e.filter((p)=>p.kind === "builtin"), y = e.filter((p)=>p.kind === "provider");
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                ref: s,
                type: "button",
                onClick: h,
                title: "Configure visible label fields",
                style: {
                    display: "inline-flex",
                    alignItems: "center",
                    padding: "3px 6px",
                    borderRadius: 3,
                    border: "1px solid var(--tbrowse-border)",
                    background: o ? "var(--tbrowse-accent-soft)" : "var(--tbrowse-bg-input)",
                    color: "var(--tbrowse-text)",
                    cursor: "pointer"
                },
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(yt, {})
            }),
            o && a && (0, _reactDom.createPortal)(/* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                className: `tbrowse-root tbrowse-theme-${l}`,
                children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                    className: "tbrowse-labels-config",
                    style: {
                        position: "fixed",
                        right: a.right,
                        top: a.top,
                        boxSizing: "border-box",
                        background: "var(--tbrowse-bg-elevated)",
                        border: "1px solid var(--tbrowse-border)",
                        color: "var(--tbrowse-text)",
                        borderRadius: 6,
                        boxShadow: "0 4px 16px var(--tbrowse-tooltip-shadow)",
                        padding: "8px 0",
                        zIndex: 2e3,
                        fontSize: 12
                    },
                    children: [
                        Mn("Built-in", g, f, u),
                        y.length > 0 && /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                                    style: {
                                        height: 1,
                                        background: "var(--tbrowse-border-soft)",
                                        margin: "4px 0"
                                    }
                                }),
                                Mn("External", y, f, u)
                            ]
                        })
                    ]
                })
            }), document.body)
        ]
    });
}
function Mn(e, t, n, o) {
    return t.length === 0 ? null : /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                style: {
                    padding: "2px 12px",
                    fontSize: 10,
                    textTransform: "uppercase",
                    letterSpacing: 0.5,
                    color: "var(--tbrowse-text-subtle)",
                    fontWeight: 600
                },
                children: e
            }),
            t.map((i)=>{
                const a = n.has(i.id);
                return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("label", {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        padding: "4px 12px",
                        fontSize: 12,
                        cursor: "pointer"
                    },
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                            type: "checkbox",
                            checked: a,
                            onChange: ()=>o(i.id),
                            style: {
                                margin: 0
                            }
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                            children: i.label
                        })
                    ]
                }, i.id);
            })
        ]
    });
}
function ci(e, t) {
    const n = (0, _react.useRef)(/* @__PURE__ */ new Map()), [, o] = (0, _react.useState)(0), i = e.map((c)=>c.id).sort().join("|"), a = [
        ...new Set(t)
    ].sort().join("|");
    return (0, _react.useEffect)(()=>{
        if (e.length === 0 || t.length === 0) return;
        const c = [], s = n.current;
        for (const l of e){
            let f = s.get(l.id);
            f || (f = /* @__PURE__ */ new Map(), s.set(l.id, f));
            const h = f;
            for (const u of t){
                if (h.has(u)) continue;
                h.set(u, {
                    state: "pending"
                });
                const g = new AbortController();
                c.push(g), l.fetch(u, g.signal).then((y)=>{
                    g.signal.aborted || (h.set(u, {
                        state: "resolved",
                        value: y
                    }), o((p)=>p + 1));
                }).catch((y)=>{
                    g.signal.aborted || (y == null ? void 0 : y.name) === "AbortError" || (h.set(u, {
                        state: "rejected"
                    }), o((k)=>k + 1));
                });
            }
        }
        return ()=>{
            var l;
            for (const f of c)f.abort();
            for (const f of e){
                const h = n.current.get(f.id);
                if (h) for (const u of t)((l = h.get(u)) == null ? void 0 : l.state) === "pending" && h.delete(u);
            }
        };
    }, [
        i,
        a
    ]), {
        get (c, s) {
            var f;
            const l = (f = n.current.get(c)) == null ? void 0 : f.get(s);
            return !l || l.state === "pending" ? "pending" : l.state === "rejected" ? null : l.value;
        }
    };
}
const tn = {
    visibleFields: [
        "taxonomy.commonName",
        "gene.id"
    ]
}, oo = " \xb7 ", ro = "\u2026", ai = ({ zoneState: e, setZoneState: t, data: n, hoveredNodeId: o })=>{
    const i = (0, _react.useMemo)(()=>no(n), [
        n
    ]), a = (0, _react.useMemo)(()=>(0, _tbrowseCore.buildChildrenIndex)(n.tree), [
        n.tree
    ]), c = (0, _react.useMemo)(()=>eo(o, n, a), [
        o,
        n,
        a
    ]), s = e.visibleFields.length;
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        "data-labels-zone-header": !0,
        style: {
            height: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 4,
            fontSize: 13,
            color: "var(--tbrowse-text)"
        },
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    padding: "0 10px 0 18px"
                },
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(nt, {
                        defaultName: "Labels",
                        customName: e == null ? void 0 : e.name,
                        onChange: (l)=>t((f)=>({
                                    ...f ?? tn,
                                    name: l
                                }))
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                        style: {
                            fontWeight: 400,
                            color: "var(--tbrowse-text-muted)",
                            fontSize: 11
                        },
                        children: [
                            s,
                            "/",
                            i.length,
                            " field",
                            i.length === 1 ? "" : "s"
                        ]
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                        style: {
                            marginLeft: "auto"
                        },
                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(li, {
                            fields: i,
                            visibleFields: e.visibleFields,
                            onChange: (l)=>t((f)=>({
                                        ...f ?? tn,
                                        visibleFields: l
                                    }))
                        })
                    })
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                style: {
                    flex: `0 0 ${(0, _tbrowseCore.LEAF_ROW_HEIGHT)}px`,
                    minHeight: 0,
                    padding: "0 10px 0 18px",
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    fontSize: 11,
                    color: "var(--tbrowse-text-muted)",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                },
                title: c ?? "",
                children: c ?? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                    style: {
                        color: "var(--tbrowse-text-subtle)"
                    },
                    children: "hover a node\u2026"
                })
            })
        ]
    });
}, di = ({ visibleRows: e, rowRange: t, zoneState: n, data: o, hoveredNodeId: i, hoveredSubtreeIds: a, selectedNodeId: c, searchState: s, searchResults: l, onHoverNode: f, onSelectNode: h })=>{
    const u = (0, _react.useMemo)(()=>no(o), [
        o
    ]), g = (0, _react.useMemo)(()=>{
        const E = new Map(u.map((T)=>[
                T.id,
                T
            ]));
        return n.visibleFields.map((T)=>E.get(T)).filter((T)=>T !== void 0);
    }, [
        n.visibleFields,
        u
    ]), y = (0, _react.useMemo)(()=>{
        if (!o.labelProviders) return [];
        const E = new Set(g.filter((T)=>T.kind === "provider").map((T)=>T.providerId));
        return o.labelProviders.filter((T)=>E.has(T.id));
    }, [
        o.labelProviders,
        g
    ]), p = (0, _react.useMemo)(()=>{
        const E = [];
        for (const T of e){
            if (T.kind !== "leaf") continue;
            const I = o.tree.nodes[T.nodeId];
            I != null && I.geneId && E.push(I.geneId);
        }
        return E;
    }, [
        e,
        o.tree
    ]), k = ci(y, p), x = (0, _react.useMemo)(()=>{
        if (!s || !s.query) return null;
        const E = wt(s.query, {
            caseSensitive: s.caseSensitive ?? !1,
            regex: s.regex ?? !1
        });
        return E.ok ? E : null;
    }, [
        s
    ]), m = l.matchedLeafIds, b = e.slice(t.startIndex, t.endIndex);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: b.map((E)=>{
            const T = i === E.nodeId, I = a.has(E.nodeId), _ = c === E.nodeId, M = E.kind === "collapsedSummary", $ = !M && x && m.has(E.nodeId) ? x : null, W = M ? pi(E.nodeId, E.leafCount, o) : hi(E.nodeId, g, o, k), H = M ? W : ui(E.nodeId, g, o, k, $);
            return /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                onMouseEnter: ()=>f(E.nodeId),
                onMouseLeave: ()=>f(null),
                onClick: ()=>{
                    const w = window.getSelection();
                    w && w.toString().length > 0 || h(E.nodeId);
                },
                style: {
                    position: "absolute",
                    top: E.y,
                    left: 0,
                    right: 0,
                    height: E.height,
                    fontSize: "var(--tbrowse-font-size, 12px)",
                    padding: "0 10px",
                    display: "flex",
                    alignItems: "center",
                    background: _ ? "var(--tbrowse-row-select-bg)" : T ? "var(--tbrowse-row-hover-bg)" : I ? "var(--tbrowse-row-subtree-bg)" : "transparent",
                    fontWeight: I ? 600 : 400,
                    fontStyle: M ? "italic" : "normal",
                    color: M ? "var(--tbrowse-text-muted)" : "var(--tbrowse-text)",
                    borderBottom: "1px solid var(--tbrowse-border-row)",
                    cursor: "pointer",
                    // Allow drag-selection of text for copy/paste even though
                    // the row is clickable (the click handler ignores clicks
                    // that produced a non-empty selection).
                    userSelect: "text",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    opacity: E.opacity ?? 1,
                    transform: `translateX(${-32 * (1 - (E.opacity ?? 1))}px)`
                },
                title: W,
                children: H
            }, E.nodeId);
        })
    });
};
function ui(e, t, n, o, i) {
    const a = n.tree.nodes[e];
    if (!a) return "?";
    const c = [];
    for (const s of t){
        let l = null;
        if (s.kind === "builtin") l = s.get(a, n);
        else if (a.geneId) {
            const f = o.get(s.providerId, a.geneId);
            l = f === "pending" ? ro : f;
        }
        l === null || l === "" || (c.length > 0 && c.push(/* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
            "aria-hidden": "true",
            children: oo
        }, `s-${s.id}`)), c.push(/* @__PURE__ */ (0, _jsxRuntime.jsx)(fi, {
            value: l,
            matcher: i
        }, s.id)));
    }
    return c.length > 0 ? /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: c
    }) : "\u2014";
}
function fi({ value: e, matcher: t }) {
    if (!t) return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: e
    });
    const n = t.spanOf(e);
    return !n || n[0] === n[1] ? /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: e
    }) : /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            e.slice(0, n[0]),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("mark", {
                style: {
                    background: "var(--tbrowse-search-soft)",
                    color: "inherit",
                    padding: 0,
                    borderRadius: 2
                },
                children: e.slice(n[0], n[1])
            }),
            e.slice(n[1])
        ]
    });
}
function hi(e, t, n, o) {
    const i = n.tree.nodes[e];
    if (!i) return "?";
    const a = [];
    for (const c of t)if (c.kind === "builtin") {
        const s = c.get(i, n);
        s !== null && s !== "" && a.push(s);
    } else {
        if (!i.geneId) continue;
        const s = o.get(c.providerId, i.geneId);
        s === "pending" ? a.push(ro) : s !== null && s !== "" && a.push(s);
    }
    return a.length > 0 ? a.join(oo) : "\u2014";
}
function pi(e, t, n) {
    var i;
    const o = n.tree.nodes[e];
    if (o && o.taxonomyId !== void 0 && (i = n.taxonomy) != null && i[o.taxonomyId]) {
        const a = n.taxonomy[o.taxonomyId], c = a.scientificName ?? a.commonName;
        if (c) return `(${t}) ${c}`;
    }
    return `(${t} leaves)`;
}
const il = {
    id: "labels",
    displayName: "Labels",
    Header: ai,
    Body: di,
    defaultWidth: 20,
    minWidth: 100,
    defaultZoneState: tn,
    isAvailable: (e)=>!!e.tree
}, gi = {
    // hydrophobic
    A: "#80a0f0",
    I: "#80a0f0",
    L: "#80a0f0",
    M: "#80a0f0",
    F: "#80a0f0",
    W: "#80a0f0",
    V: "#80a0f0",
    // positive
    K: "#f01505",
    R: "#f01505",
    // negative
    D: "#c048c0",
    E: "#c048c0",
    // polar
    N: "#15c015",
    Q: "#15c015",
    S: "#15c015",
    T: "#15c015",
    // cysteine
    C: "#f08080",
    // glycine
    G: "#f09048",
    // proline
    P: "#c0c000",
    // histidine + tyrosine
    H: "#15a4a4",
    Y: "#15a4a4"
}, mi = {
    I: 4.5,
    V: 4.2,
    L: 3.8,
    F: 2.8,
    C: 2.5,
    M: 1.9,
    A: 1.8,
    G: -0.4,
    T: -0.7,
    S: -0.8,
    W: -0.9,
    Y: -1.3,
    P: -1.6,
    H: -3.2,
    E: -3.5,
    Q: -3.5,
    D: -3.5,
    N: -3.5,
    K: -3.9,
    R: -4.5
}, Cn = -4.5, bi = 4.5;
function xi(e) {
    const t = mi[e];
    if (t === void 0) return null;
    const n = (t - Cn) / (bi - Cn);
    if (n < 0.5) {
        const o = n / 0.5, i = Math.round(80 + 175 * o), a = Math.round(120 + 135 * o), c = Math.round(220 + 35 * o);
        return `rgb(${i},${a},${c})`;
    } else {
        const o = (n - 0.5) / 0.5, i = Math.round(255 + -35 * o), a = Math.round(255 + -165 * o), c = Math.round(255 + -195 * o);
        return `rgb(${i},${a},${c})`;
    }
}
const vi = {
    A: "#5ab33c",
    C: "#3782e3",
    G: "#1a1a1a",
    T: "#e85a4a",
    U: "#e85a4a",
    N: "#999"
}, nn = [
    {
        id: "plain",
        label: "Plain",
        alphabets: [
            "protein",
            "dna"
        ],
        color: ()=>null
    },
    {
        id: "clustal",
        label: "Clustal",
        alphabets: [
            "protein"
        ],
        color: (e)=>gi[e.toUpperCase()] ?? null
    },
    {
        id: "hydrophobicity",
        label: "Hydrophobicity",
        alphabets: [
            "protein"
        ],
        color: (e)=>xi(e.toUpperCase())
    },
    {
        id: "nucleotide",
        label: "Nucleotide",
        alphabets: [
            "dna"
        ],
        color: (e)=>vi[e.toUpperCase()] ?? null
    }
];
function io(e) {
    return e === "dna" ? "nucleotide" : "clustal";
}
function wi(e) {
    return nn.filter((t)=>t.alphabets.includes(e));
}
function yi(e) {
    return nn.find((t)=>t.id === e) ?? nn[0];
}
const Ii = {
    visibleCols: [],
    runs: []
};
function so(e, t, n, o, i = /* @__PURE__ */ new Set()) {
    var u;
    if (e.length === 0) return Ii;
    if (n <= 0) return dn(e);
    const a = new Array(e.length).fill(!1), c = [
        ...t
    ];
    for(let g = 0; g < e.length; g++){
        let y = 0;
        for (const p of c){
            const k = (u = e.sequences[p]) == null ? void 0 : u[g];
            k && k !== "-" && y++;
        }
        y >= n && (a[g] = !0);
    }
    const s = new Array(e.length).fill(!1);
    if (o === 0) for(let g = 0; g < e.length; g++)s[g] = a[g];
    else {
        let g = -1 / 0;
        for(let p = 0; p < e.length; p++)a[p] && (g = p), p - g <= o && (s[p] = !0);
        let y = 1 / 0;
        for(let p = e.length - 1; p >= 0; p--)a[p] && (y = p), y - p <= o && (s[p] = !0);
    }
    const l = [], f = [];
    let h = -1;
    for(let g = 0; g < e.length; g++)if (s[g]) {
        if (h >= 0) {
            const y = i.has(h), p = l.length;
            if (y) for(let k = h; k < g; k++)l.push(k);
            f.push({
                start: h,
                end: g - 1,
                visibleAt: p,
                expanded: y
            }), h = -1;
        }
        l.push(g);
    } else h < 0 && (h = g);
    if (h >= 0) {
        const g = i.has(h), y = l.length;
        if (g) for(let p = h; p < e.length; p++)l.push(p);
        f.push({
            start: h,
            end: e.length - 1,
            visibleAt: y,
            expanded: g
        });
    }
    return {
        visibleCols: l,
        runs: f
    };
}
function dn(e) {
    const t = new Array(e.length);
    for(let n = 0; n < e.length; n++)t[n] = n;
    return {
        visibleCols: t,
        runs: []
    };
}
function Si({ msa: e, zoneState: t, setZoneState: n, hasDomains: o, mask: i }) {
    const [a, c] = (0, _react.useState)(!1), [s, l] = (0, _react.useState)(null), f = (0, _react.useRef)(null), h = (0, _react.useRef)(null), u = Le((m)=>m.theme), g = ()=>{
        if (!a && f.current) {
            const m = f.current.getBoundingClientRect(), b = f.current.closest("[data-msa-zone-header]"), E = b == null ? void 0 : b.getBoundingClientRect(), T = E ? Math.max(0, window.innerWidth - E.right) : Math.max(0, window.innerWidth - m.right), I = E ? E.right - E.left : 320, _ = Math.max(240, I);
            h.current = f.current.closest(".tbrowse-root") ?? document.body, l({
                right: T,
                top: m.bottom + 4,
                maxWidth: _
            });
        }
        c((m)=>!m);
    };
    (0, _react.useEffect)(()=>{
        if (!a) return;
        const m = (E)=>{
            var _;
            const T = E.target;
            if ((_ = f.current) != null && _.contains(T)) return;
            const I = document.querySelector(".tbrowse-msa-config");
            I != null && I.contains(T) || c(!1);
        }, b = (E)=>{
            E.key === "Escape" && c(!1);
        };
        return document.addEventListener("mousedown", m), document.addEventListener("keydown", b), ()=>{
            document.removeEventListener("mousedown", m), document.removeEventListener("keydown", b);
        };
    }, [
        a
    ]);
    const y = wi(e.alphabet), p = t.colorSchemeId ?? io(e.alphabet), k = (m, b)=>m === "plain" && o ? "Domains" : b, x = i.params;
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                ref: f,
                type: "button",
                onClick: g,
                title: "Configure colors and column mask",
                style: {
                    display: "inline-flex",
                    alignItems: "center",
                    padding: "3px 6px",
                    borderRadius: 3,
                    border: "1px solid var(--tbrowse-border)",
                    background: a ? "var(--tbrowse-accent-soft)" : "var(--tbrowse-bg-input)",
                    color: "var(--tbrowse-text)",
                    cursor: "pointer"
                },
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(yt, {})
            }),
            a && s && (0, _reactDom.createPortal)(/* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                className: `tbrowse-root tbrowse-theme-${u}`,
                children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                    className: "tbrowse-msa-config",
                    style: {
                        position: "fixed",
                        right: s.right,
                        top: s.top,
                        boxSizing: "border-box",
                        background: "var(--tbrowse-bg-elevated)",
                        border: "1px solid var(--tbrowse-border)",
                        color: "var(--tbrowse-text)",
                        borderRadius: 6,
                        boxShadow: "0 4px 16px var(--tbrowse-tooltip-shadow)",
                        padding: "10px 12px",
                        zIndex: 2e3,
                        fontSize: 12
                    },
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                fontSize: 10,
                                textTransform: "uppercase",
                                letterSpacing: 0.5,
                                color: "var(--tbrowse-text-subtle)",
                                fontWeight: 600,
                                marginBottom: 6
                            },
                            children: "Color scheme"
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("select", {
                            value: p,
                            onChange: (m)=>n((b)=>({
                                        ...b,
                                        colorSchemeId: m.target.value
                                    })),
                            style: {
                                fontSize: 12,
                                padding: "2px 6px",
                                border: "1px solid var(--tbrowse-border)",
                                borderRadius: 3,
                                background: "var(--tbrowse-bg-input)",
                                color: "var(--tbrowse-text)",
                                cursor: "pointer",
                                width: "100%",
                                marginBottom: 12
                            },
                            children: y.map((m)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("option", {
                                    value: m.id,
                                    children: k(m.id, m.label)
                                }, m.id))
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                fontSize: 10,
                                textTransform: "uppercase",
                                letterSpacing: 0.5,
                                color: "var(--tbrowse-text-subtle)",
                                fontWeight: 600,
                                marginBottom: 6
                            },
                            children: "Column mask"
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("label", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                                cursor: "pointer",
                                marginBottom: 8
                            },
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                                    type: "checkbox",
                                    checked: x.enabled,
                                    onChange: (m)=>i.onChange({
                                            ...x,
                                            enabled: m.target.checked
                                        })
                                }),
                                "Enabled"
                            ]
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                            style: {
                                marginBottom: 8
                            },
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "baseline",
                                        gap: 6
                                    },
                                    children: [
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                            style: {
                                                color: "var(--tbrowse-text-muted)"
                                            },
                                            children: "Min coverage"
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                                            type: "number",
                                            min: 0,
                                            max: Math.max(0, i.maxCoverage),
                                            step: 1,
                                            value: x.minCoverage,
                                            disabled: !x.enabled,
                                            onChange: (m)=>{
                                                const b = Math.max(0, Math.floor(Number(m.target.value) || 0));
                                                i.onChange({
                                                    ...x,
                                                    minCoverage: b
                                                });
                                            },
                                            style: {
                                                width: 60,
                                                fontSize: 12,
                                                padding: "1px 4px"
                                            }
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                            style: {
                                                color: "var(--tbrowse-text-subtle)"
                                            },
                                            children: [
                                                "/ ",
                                                i.maxCoverage,
                                                " leaves"
                                            ]
                                        })
                                    ]
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                                    style: {
                                        color: "var(--tbrowse-text-muted)",
                                        fontSize: 11,
                                        marginTop: 2
                                    },
                                    children: "Drop a column unless at least this many active leaves have a non-gap residue there."
                                })
                            ]
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                            style: {
                                marginBottom: 8
                            },
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "baseline",
                                        gap: 6
                                    },
                                    children: [
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                            style: {
                                                color: "var(--tbrowse-text-muted)"
                                            },
                                            children: "Padding"
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                                            type: "number",
                                            min: 0,
                                            step: 1,
                                            value: x.padding,
                                            disabled: !x.enabled,
                                            onChange: (m)=>{
                                                const b = Math.max(0, Math.floor(Number(m.target.value) || 0));
                                                i.onChange({
                                                    ...x,
                                                    padding: b
                                                });
                                            },
                                            style: {
                                                width: 60,
                                                fontSize: 12,
                                                padding: "1px 4px"
                                            }
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                            style: {
                                                color: "var(--tbrowse-text-subtle)"
                                            },
                                            children: "cols"
                                        })
                                    ]
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                                    style: {
                                        color: "var(--tbrowse-text-muted)",
                                        fontSize: 11,
                                        marginTop: 2
                                    },
                                    children: "Keep this many columns flanking each covered region so brief low-coverage runs don't break a contiguous block."
                                })
                            ]
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                marginTop: 8,
                                paddingTop: 8,
                                borderTop: "1px solid var(--tbrowse-border-soft)",
                                color: "var(--tbrowse-text-muted)",
                                fontSize: 11
                            },
                            children: i.hiddenCols > 0 ? `Hiding ${i.hiddenCols} of ${i.totalCols} columns.` : `All ${i.totalCols} columns visible.`
                        })
                    ]
                })
            }), h.current ?? document.body)
        ]
    });
}
const ki = "rgba(40, 120, 220, 0.18)", Ei = "rgb(54 0 255)", Ct = 10;
function Mi({ colors: e, totalCols: t, vp: n, onSetViewport: o, height: i, width: a, minLength: c = 1 }) {
    const s = (0, _react.useRef)(null), l = (0, _react.useRef)(null), [f, h] = (0, _react.useState)(0), [u, g] = (0, _react.useState)(0), y = a ?? f;
    (0, _react.useEffect)(()=>{
        const T = s.current;
        if (!T) return;
        const I = a === void 0, _ = i === void 0;
        if (!I && !_) return;
        const M = new ResizeObserver(($)=>{
            const W = $[0].contentRect;
            I && h(W.width), _ && g(W.height);
        });
        return M.observe(T), ()=>M.disconnect();
    }, [
        i,
        a
    ]);
    const p = i ?? Math.max(8, u);
    (0, _react.useEffect)(()=>{
        const T = l.current;
        if (!T || y <= 0 || t <= 0 || p <= 0) return;
        const I = window.devicePixelRatio || 1;
        T.width = Math.floor(y * I), T.height = Math.floor(p * I), T.style.width = `${y}px`, T.style.height = `${p}px`;
        const _ = T.getContext("2d");
        if (!_) return;
        _.setTransform(I, 0, 0, I, 0, 0), _.clearRect(0, 0, y, p);
        const M = y / t, $ = (W)=>Math.round(W * M);
        for(let W = 0; W < t; W++){
            const H = e[W];
            if (!H) continue;
            _.fillStyle = H;
            const w = $(W), N = Math.max(1, $(W + 1) - w);
            _.fillRect(w, 0, N, p);
        }
    }, [
        y,
        p,
        t,
        e
    ]);
    const k = t > 0 ? n.start / t * y : 0, x = t > 0 ? Math.max(2, (n.end - n.start) / t * y) : 0, m = (T)=>{
        T.preventDefault(), T.stopPropagation();
        const I = T.clientX, _ = n.start, M = n.end - n.start, $ = y, W = (w)=>{
            const v = (w.clientX - I) / $ * t;
            let L = Math.round(_ + v);
            L = Math.max(0, Math.min(t - M, L)), o(L, L + M);
        }, H = ()=>{
            window.removeEventListener("pointermove", W), window.removeEventListener("pointerup", H);
        };
        window.addEventListener("pointermove", W), window.addEventListener("pointerup", H);
    }, b = (T)=>{
        if (!s.current || y <= 0 || t <= 0) return;
        const I = s.current.getBoundingClientRect(), _ = T.clientX - I.left, M = Math.round(_ / y * t), $ = n.end - n.start;
        let W = M - Math.floor($ / 2);
        W = Math.max(0, Math.min(t - $, W)), o(W, W + $);
    }, E = (T)=>(I)=>{
            I.preventDefault(), I.stopPropagation();
            const _ = I.clientX, M = n.start, $ = n.end, W = y, H = Math.max(1, Math.min(t, c)), w = (v)=>{
                const A = (v.clientX - _) / W * t;
                if (T === "start") {
                    let J = Math.round(M + A);
                    J = Math.max(0, Math.min($ - H, J)), o(J, $);
                } else {
                    let J = Math.round($ + A);
                    J = Math.max(M + H, Math.min(t, J)), o(M, J);
                }
            }, N = ()=>{
                window.removeEventListener("pointermove", w), window.removeEventListener("pointerup", N);
            };
            window.addEventListener("pointermove", w), window.addEventListener("pointerup", N);
        };
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        ref: s,
        onPointerDown: b,
        style: {
            position: "relative",
            width: a !== void 0 ? a : "100%",
            height: i ?? "100%",
            minHeight: 12,
            cursor: "pointer",
            // overflow:visible so the viewport rect's outline (drawn outside its
            // box) is not clipped at full-zoom, where the rect spans the entire
            // consensus track.
            overflow: "visible",
            background: "var(--tbrowse-bg-alt)"
        },
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("canvas", {
                ref: l,
                style: {
                    display: "block",
                    pointerEvents: "none"
                }
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                onPointerDown: m,
                style: {
                    position: "absolute",
                    left: k,
                    top: 0,
                    width: x,
                    height: "100%",
                    background: ki,
                    // Use outline (drawn outside the box) instead of border so the
                    // visible consensus track inside the rect is the full vpWidthPx and
                    // aligns pixel-for-pixel with the MSA body grid. The container's
                    // overflow: hidden clips the outline at full-zoom, where the rect
                    // spans the entire minimap.
                    outline: `3px solid ${Ei}`,
                    // Positive offset draws the outline outside the rect, so it sits
                    // around the consensus track rather than eating into it.
                    outlineOffset: 0,
                    cursor: "grab",
                    boxSizing: "border-box"
                }
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                onPointerDown: E("start"),
                style: {
                    position: "absolute",
                    left: k - Ct / 2,
                    top: 0,
                    width: Ct,
                    height: "100%",
                    cursor: "ew-resize"
                }
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                onPointerDown: E("end"),
                style: {
                    position: "absolute",
                    left: k + x - Ct / 2,
                    top: 0,
                    width: Ct,
                    height: "100%",
                    cursor: "ew-resize"
                }
            })
        ]
    });
}
function lo(e) {
    const t = [
        0
    ];
    for(let n = 0; n < e.length; n++){
        const o = e[n];
        o !== "-" && o !== "." && o !== void 0 && t.push(n);
    }
    return t;
}
function ft(e, t) {
    const n = t.length - 1;
    if (n <= 0) return null;
    const o = Math.max(1, Math.min(n, e.start)), i = Math.max(o, Math.min(n, e.end));
    return {
        startCol: t[o],
        endCol: t[i]
    };
}
function co(e, t, n) {
    const o = e.length, i = new Array(o).fill(null);
    if (!t) return i;
    const a = new Array(o).fill(null);
    for (const c of n){
        const s = t[c];
        if (!s || s.length === 0) continue;
        const l = e.sequences[c];
        if (!l) continue;
        const f = lo(l);
        for (const h of s){
            const u = ft(h, f);
            if (u) for(let g = u.startCol; g <= u.endCol; g++){
                let y = a[g];
                y || (y = /* @__PURE__ */ new Map(), a[g] = y), y.set(h.id, (y.get(h.id) ?? 0) + 1);
            }
        }
    }
    for(let c = 0; c < o; c++){
        const s = a[c];
        if (!s) continue;
        let l = null, f = 0;
        for (const [h, u] of s)(u > f || u === f && l !== null && h < l) && (f = u, l = h);
        i[c] = l;
    }
    return i;
}
function xt(e, t = 1) {
    let n = 2166136261;
    for(let i = 0; i < e.length; i++)n ^= e.charCodeAt(i), n = Math.imul(n, 16777619) >>> 0;
    const o = n % 360;
    return t < 1 ? `hsl(${o} 65% 45% / ${t})` : `hsl(${o} 65% 45%)`;
}
const Ci = {
    viewportStart: 0,
    viewportEnd: 0
}, on = {
    enabled: !0,
    minCoverage: 1,
    padding: 0,
    expandedRuns: []
}, De = 4, rn = 7;
function Li(e, t, n) {
    return n ? Math.max(6, Math.min(e - 2, t * 0.55)) : Math.max(6, Math.min(e - 1, t * 1.6));
}
const Ti = 5, qi = 22, Ri = 28, sn = 'ui-monospace, "SF Mono", Menlo, monospace', $i = "#444", Ai = "#cfd6df", Pi = 0.7, Wi = {
    A: "Ala",
    R: "Arg",
    N: "Asn",
    D: "Asp",
    C: "Cys",
    E: "Glu",
    Q: "Gln",
    G: "Gly",
    H: "His",
    I: "Ile",
    L: "Leu",
    K: "Lys",
    M: "Met",
    F: "Phe",
    P: "Pro",
    S: "Ser",
    T: "Thr",
    W: "Trp",
    Y: "Tyr",
    V: "Val",
    B: "Asx",
    Z: "Glx",
    X: "Xaa",
    U: "Sec",
    O: "Pyl"
};
function ln(e, t) {
    return e === "protein" && t > 0 ? Math.max(2, Math.ceil(t / Ri)) : 2;
}
function Di(e, t) {
    let n = 0;
    for(let o = 0; o <= t; o++){
        const i = e[o];
        i !== "-" && i !== "." && i !== void 0 && n++;
    }
    return n;
}
function ao(e, t, n) {
    const o = new Array(n).fill(null);
    if (e.length === 0) return o;
    const i = [];
    for (const a of e){
        const c = t[a];
        c && i.push(c);
    }
    for(let a = 0; a < n; a++){
        const c = {};
        let s = null, l = 0;
        for (const f of i){
            const h = f[a];
            if (!h || h === "-") continue;
            const u = (c[h] ?? 0) + 1;
            c[h] = u, u > l && (l = u, s = h);
        }
        o[a] = s;
    }
    return o;
}
function uo(e, t, n) {
    const o = new Array(n).fill(0);
    if (e.length === 0) return o;
    let i = 0;
    for (const a of e){
        const c = t[a];
        if (c) {
            i++;
            for(let s = 0; s < n; s++){
                const l = c[s];
                l && l !== "-" && l !== "." && (o[s] += 1);
            }
        }
    }
    if (i > 0) for(let a = 0; a < n; a++)o[a] = o[a] / i;
    return o;
}
function fo(e, t, n) {
    var i;
    const o = /* @__PURE__ */ new Set();
    for (const a of Object.values(e.nodes)){
        if (!a.isLeaf || !a.geneId || !t.sequences[a.geneId]) continue;
        let c = a.id, s = !1;
        for(; c !== null;){
            if (n.has(c)) {
                s = !0;
                break;
            }
            c = ((i = e.nodes[c]) == null ? void 0 : i.parentId) ?? null;
        }
        s || o.add(a.geneId);
    }
    return o;
}
function ht(e, t) {
    if (e.viewportEnd > e.viewportStart) {
        const n = Math.max(0, e.viewportStart), o = Math.min(t, e.viewportEnd);
        return {
            start: n,
            end: o,
            width: Math.max(1, o - n)
        };
    }
    return {
        start: 0,
        end: t,
        width: Math.max(1, t)
    };
}
const Oi = ({ data: e, zoneState: t, setZoneState: n, prunedNodeIds: o, width: i })=>{
    const a = e.msa, c = Le((M)=>M.hoveredResidue), s = t.mask ?? on, l = (0, _react.useMemo)(()=>a ? fo(e.tree, a, o) : /* @__PURE__ */ new Set(), [
        a,
        e.tree,
        o
    ]), f = (0, _react.useMemo)(()=>new Set(s.expandedRuns ?? []), [
        s.expandedRuns
    ]), h = (0, _react.useMemo)(()=>a ? s.enabled ? so(a, l, s.minCoverage, s.padding, f) : dn(a) : null, [
        a,
        l,
        s.enabled,
        s.minCoverage,
        s.padding,
        f
    ]), u = (h == null ? void 0 : h.visibleCols.length) ?? 0, g = a ? ht(t, u) : null, y = (0, _react.useMemo)(()=>a ? ao([
            ...l
        ], a.sequences, a.length) : null, [
        a,
        l
    ]), p = (0, _react.useMemo)(()=>a ? uo([
            ...l
        ], a.sequences, a.length) : null, [
        a,
        l
    ]), k = (0, _react.useMemo)(()=>a ? co(a, e.proteinDomains, l) : null, [
        a,
        e.proteinDomains,
        l
    ]), x = (0, _react.useMemo)(()=>{
        if (!y || !h) return {
            residues: [],
            colors: []
        };
        const M = new Array(h.visibleCols.length), $ = new Array(h.visibleCols.length);
        for(let W = 0; W < h.visibleCols.length; W++){
            const H = h.visibleCols[W], w = y[H] ?? null;
            if (M[W] = w, !w) {
                $[W] = null;
                continue;
            }
            const N = Math.max(0, Math.min(1, (p == null ? void 0 : p[H]) ?? 1)), v = (k == null ? void 0 : k[H]) ?? null;
            $[W] = v ? xt(v, N) : `hsl(220 10% 45% / ${N})`;
        }
        return {
            residues: M,
            colors: $
        };
    }, [
        y,
        p,
        h,
        k
    ]), m = (0, _react.useCallback)((M, $)=>n((W)=>({
                ...W,
                viewportStart: M,
                viewportEnd: $
            })), [
        n
    ]), b = (0, _react.useMemo)(()=>{
        if (!a) return null;
        const M = Math.max(1, i - 2 * De), $ = Math.max(2, Math.floor(M / rn)), W = Math.max(2, ln(a.alphabet, M));
        return Math.max(W, Math.min(u, $));
    }, [
        a,
        i,
        u
    ]), E = (0, _react.useCallback)(()=>{
        if (b === null || !g) return;
        const M = (g.start + g.end) / 2;
        let $ = Math.round(M - b / 2);
        $ = Math.max(0, Math.min(u - b, $)), m($, $ + b);
    }, [
        b,
        g,
        u,
        m
    ]), T = (0, _react.useMemo)(()=>{
        var $;
        if (!c) return null;
        const M = ($ = e.geneMetadata) == null ? void 0 : $[c.geneId];
        return {
            proteinId: (M == null ? void 0 : M.proteinId) ?? c.geneId,
            // Residue + position read together as the usual "K24" shorthand,
            // single-letter even when the body is drawing 3-letter codes.
            residue: c.residue.toUpperCase(),
            position: c.position
        };
    }, [
        c,
        e.geneMetadata
    ]), I = Math.max(0, i - 2 * De), _ = a ? Math.min(u || 1 / 0, ln(a.alphabet, I)) : 2;
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        "data-msa-zone-header": !0,
        style: {
            position: "relative",
            height: "100%",
            fontSize: 13,
            color: "var(--tbrowse-text)"
        },
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    position: "absolute",
                    top: 0,
                    left: 10,
                    right: 10,
                    bottom: (0, _tbrowseCore.LEAF_ROW_HEIGHT) + 4,
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    paddingLeft: 8
                },
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(nt, {
                        defaultName: "MSA",
                        customName: t.name,
                        onChange: (M)=>n(($)=>({
                                    ...$,
                                    name: M
                                }))
                    }),
                    a && g && /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                onClick: E,
                                disabled: b === null || g.end - g.start === b,
                                title: "Zoom to the level where residue letters become visible",
                                style: {
                                    fontSize: 11,
                                    padding: "2px 6px",
                                    border: "1px solid var(--tbrowse-border)",
                                    background: "var(--tbrowse-bg-input)",
                                    color: "var(--tbrowse-text)",
                                    borderRadius: 3,
                                    cursor: "pointer",
                                    fontFamily: 'ui-monospace, "SF Mono", Menlo, monospace'
                                },
                                children: "Aa"
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                onClick: ()=>m(0, u),
                                disabled: g.start === 0 && g.end === u,
                                title: "Zoom out to the full alignment",
                                style: {
                                    fontSize: 11,
                                    padding: "2px 6px",
                                    border: "1px solid var(--tbrowse-border)",
                                    background: "var(--tbrowse-bg-input)",
                                    color: "var(--tbrowse-text)",
                                    borderRadius: 3,
                                    cursor: "pointer",
                                    fontFamily: 'ui-monospace, "SF Mono", Menlo, monospace'
                                },
                                children: "<->"
                            }),
                            T && /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                title: "Residue under the pointer",
                                style: {
                                    minWidth: 0,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    fontSize: 11,
                                    fontFamily: sn,
                                    color: "var(--tbrowse-text-muted)"
                                },
                                children: [
                                    T.proteinId,
                                    " ",
                                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("strong", {
                                        style: {
                                            color: "var(--tbrowse-text)"
                                        },
                                        children: [
                                            T.residue,
                                            T.position
                                        ]
                                    })
                                ]
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                style: {
                                    marginLeft: "auto"
                                },
                                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Si, {
                                    msa: a,
                                    zoneState: t,
                                    setZoneState: n,
                                    hasDomains: !!e.proteinDomains && Object.keys(e.proteinDomains).length > 0,
                                    mask: {
                                        params: s,
                                        maxCoverage: l.size,
                                        hiddenCols: a.length - u,
                                        totalCols: a.length,
                                        onChange: (M)=>n(($)=>({
                                                    ...$,
                                                    mask: M
                                                }))
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            a && g && /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                style: {
                    position: "absolute",
                    left: De,
                    bottom: 3,
                    width: I,
                    height: (0, _tbrowseCore.LEAF_ROW_HEIGHT)
                },
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Mi, {
                    colors: x.colors,
                    totalCols: u,
                    vp: g,
                    onSetViewport: m,
                    height: (0, _tbrowseCore.LEAF_ROW_HEIGHT),
                    width: I,
                    minLength: _
                })
            })
        ]
    });
}, _i = ({ data: e, visibleRows: t, rowRange: n, width: o, zoneState: i, setZoneState: a, hoveredNodeId: c, hoveredSubtreeIds: s, selectedNodeId: l, prunedNodeIds: f, onHoverNode: h })=>{
    const u = e.msa, g = (0, _react.useRef)(null), y = (0, _react.useRef)(null), p = Le((C)=>C.fontSize), k = Le((C)=>C.hoveredResidue), x = Le((C)=>C.setHoveredResidue), m = (0, _react.useMemo)(()=>t.length > 0 ? t[t.length - 1].y + t[t.length - 1].height : 0, [
        t
    ]), b = (0, _react.useMemo)(()=>u ? fo(e.tree, u, f) : /* @__PURE__ */ new Set(), [
        u,
        e.tree,
        f
    ]), E = i.mask ?? on, T = (0, _react.useMemo)(()=>new Set(E.expandedRuns ?? []), [
        E.expandedRuns
    ]), I = (0, _react.useMemo)(()=>u ? E.enabled ? so(u, b, E.minCoverage, E.padding, T) : dn(u) : null, [
        u,
        b,
        E.enabled,
        E.minCoverage,
        E.padding,
        T
    ]), _ = (I == null ? void 0 : I.visibleCols.length) ?? 0, M = (0, _react.useMemo)(()=>(0, _tbrowseCore.buildChildrenIndex)(e.tree), [
        e.tree
    ]), $ = (0, _react.useMemo)(()=>{
        const C = /* @__PURE__ */ new Map();
        return (O)=>{
            const F = C.get(O);
            if (F) return F;
            const z = (0, _tbrowseCore.subtreeIdsOf)(O, M), U = [];
            for (const G of z){
                const Y = e.tree.nodes[G];
                Y != null && Y.isLeaf && Y.geneId && u != null && u.sequences[Y.geneId] && b.has(Y.geneId) && U.push(Y.geneId);
            }
            return C.set(O, U), U;
        };
    }, [
        e.tree,
        M,
        u,
        b
    ]), W = (0, _react.useMemo)(()=>{
        const C = /* @__PURE__ */ new Map();
        return (O)=>{
            if (!u) return null;
            const F = C.get(O);
            if (F) return F;
            const z = $(O);
            if (z.length === 0) return null;
            const U = ao(z, u.sequences, u.length);
            return C.set(O, U), U;
        };
    }, [
        u,
        $
    ]), H = (0, _react.useMemo)(()=>{
        const C = /* @__PURE__ */ new Map();
        return (O)=>{
            const F = C.get(O);
            if (F) return F;
            const z = (u == null ? void 0 : u.sequences[O]) ?? "", U = lo(z);
            return C.set(O, U), U;
        };
    }, [
        u
    ]), w = (0, _react.useMemo)(()=>{
        const C = /* @__PURE__ */ new Map();
        return (O)=>{
            if (!u || !e.proteinDomains) return null;
            const F = C.get(O);
            if (F) return F;
            const z = e.proteinDomains[O];
            if (!z || z.length === 0) return null;
            const U = H(O), G = new Array(u.length).fill(null);
            for (const Y of z){
                const R = ft(Y, U);
                if (R) for(let K = R.startCol; K <= R.endCol; K++)G[K] === null && (G[K] = Y.id);
            }
            return C.set(O, G), G;
        };
    }, [
        u,
        e.proteinDomains,
        H
    ]), N = (0, _react.useMemo)(()=>{
        const C = /* @__PURE__ */ new Map();
        return (O)=>{
            if (!u) return null;
            const F = C.get(O);
            if (F) return F;
            const z = $(O);
            if (z.length === 0) return null;
            const U = co(u, e.proteinDomains, new Set(z)), G = uo(z, u.sequences, u.length), Y = {
                dominant: U,
                coverage: G
            };
            return C.set(O, Y), Y;
        };
    }, [
        u,
        e.proteinDomains,
        $
    ]), v = (0, _react.useMemo)(()=>{
        var U;
        if (!u || !I) return [];
        const C = /* @__PURE__ */ new Map();
        for(let G = 0; G < I.visibleCols.length; G++)C.set(I.visibleCols[G], G);
        const O = n.startIndex, F = Math.min(n.endIndex, t.length), z = [];
        for(let G = O; G < F; G++){
            const Y = t[G];
            if (Y.kind === "leaf") {
                const R = e.tree.nodes[Y.nodeId];
                if (!(R != null && R.geneId)) continue;
                const K = (U = e.proteinDomains) == null ? void 0 : U[R.geneId];
                if (!(K != null && K.length)) continue;
                const Q = H(R.geneId);
                for (const se of K){
                    const le = ft(se, Q);
                    if (!le) continue;
                    let te = -1, V = -1;
                    for(let ne = le.startCol; ne <= le.endCol; ne++){
                        const de = C.get(ne);
                        if (de === void 0) {
                            te >= 0 && (z.push({
                                key: `${Y.nodeId}:${se.id}:${te}`,
                                rowY: Y.y,
                                rowH: Y.height,
                                startVCol: te,
                                endVCol: V,
                                id: se.id,
                                nodeId: Y.nodeId,
                                alpha: 1
                            }), te = -1);
                            continue;
                        }
                        te < 0 && (te = de), V = de;
                    }
                    te >= 0 && z.push({
                        key: `${Y.nodeId}:${se.id}:${te}`,
                        rowY: Y.y,
                        rowH: Y.height,
                        startVCol: te,
                        endVCol: V,
                        id: se.id,
                        nodeId: Y.nodeId,
                        alpha: 1
                    });
                }
            } else if (Y.kind === "collapsedSummary") {
                const R = N(Y.nodeId);
                if (!R) continue;
                let K = -1, Q = null, se = 0;
                const le = (te)=>{
                    K < 0 || !Q || (z.push({
                        key: `${Y.nodeId}:${Q}:${K}`,
                        rowY: Y.y,
                        rowH: Y.height,
                        startVCol: K,
                        endVCol: te,
                        id: Q,
                        nodeId: Y.nodeId,
                        alpha: se
                    }), K = -1, Q = null, se = 0);
                };
                for(let te = 0; te < I.visibleCols.length; te++){
                    const V = I.visibleCols[te], ne = R.dominant[V] ?? null;
                    if (ne !== Q) le(te - 1), ne && (K = te, Q = ne, se = R.coverage[V] ?? 0);
                    else if (ne) {
                        const de = R.coverage[V] ?? 0;
                        de > se && (se = de);
                    }
                }
                le(I.visibleCols.length - 1);
            }
        }
        return z;
    }, [
        u,
        I,
        e.proteinDomains,
        e.tree,
        t,
        n.startIndex,
        n.endIndex,
        H,
        N
    ]), L = (0, _react.useMemo)(()=>{
        if (!u || !I || !e.exonJunctions) return [];
        const C = /* @__PURE__ */ new Map();
        for(let U = 0; U < I.visibleCols.length; U++)C.set(I.visibleCols[U], U);
        const O = [], F = n.startIndex, z = Math.min(n.endIndex, t.length);
        for(let U = F; U < z; U++){
            const G = t[U];
            if (G.kind !== "leaf") continue;
            const Y = e.tree.nodes[G.nodeId];
            if (!(Y != null && Y.geneId)) continue;
            const R = e.exonJunctions[Y.geneId];
            if (!R || R.length === 0) continue;
            const K = H(Y.geneId), Q = K.length - 1;
            if (!(Q <= 0)) for (const se of R){
                if (!Number.isFinite(se) || se <= 0) continue;
                const le = Math.floor(se), te = se - le;
                let V, ne;
                if (te === 0) {
                    if (le < 1 || le > Q) continue;
                    V = le, ne = 1;
                } else {
                    const we = le + 1;
                    if (we < 1 || we > Q) continue;
                    V = we, ne = te;
                }
                const de = K[V], me = C.get(de);
                me !== void 0 && O.push({
                    key: `${G.nodeId}:${se}`,
                    rowY: G.y,
                    rowH: G.height,
                    vCol: me,
                    withinFrac: ne
                });
            }
        }
        return O;
    }, [
        u,
        I,
        e.exonJunctions,
        e.tree,
        t,
        n.startIndex,
        n.endIndex,
        H
    ]), A = (0, _react.useMemo)(()=>{
        var F;
        const C = /* @__PURE__ */ new Map();
        let O = 0;
        for (const z of Object.values(e.tree.nodes)){
            if (!z.isLeaf) continue;
            O++;
            const U = z.geneId ? (F = e.proteinDomains) == null ? void 0 : F[z.geneId] : void 0;
            if (!U || U.length === 0) continue;
            const G = /* @__PURE__ */ new Set();
            for (const Y of U)G.add(Y.id);
            for (const Y of G)C.set(Y, (C.get(Y) ?? 0) + 1);
        }
        return {
            freq: C,
            totalLeaves: O
        };
    }, [
        e.proteinDomains,
        e.tree
    ]), [J, ie] = (0, _react.useState)(null);
    if ((0, _react.useEffect)(()=>{
        if (!J) return;
        const C = (O)=>{
            O.key === "Escape" && ie(null);
        };
        return window.addEventListener("keydown", C), ()=>window.removeEventListener("keydown", C);
    }, [
        J
    ]), (0, _react.useEffect)(()=>{
        const C = g.current;
        if (!C || !u || o <= 0 || m <= 0) return;
        const O = window.devicePixelRatio || 1;
        C.width = Math.floor(o * O), C.height = Math.floor(m * O), C.style.width = `${o}px`, C.style.height = `${m}px`;
        const F = C.getContext("2d");
        if (!F) return;
        F.setTransform(O, 0, 0, O, 0, 0), F.clearRect(0, 0, o, m);
        const z = ht(i, _), G = Math.max(1, o - 2 * De) / z.width, Y = yi(i.colorSchemeId ?? io(u.alphabet)), R = I ? I.visibleCols : null, K = !!e.proteinDomains && Object.keys(e.proteinDomains).length > 0, Q = Y.id === "plain" || G < Ti && K, se = G >= rn;
        let le = "", te = "";
        const V = se && u.alphabet === "protein" && G >= qi;
        if (se) {
            const we = Li(p || Ot, G, V);
            le = `${we}px ${sn}`, te = `bold ${we}px ${sn}`, F.font = le, F.textBaseline = "middle", F.textAlign = "center";
        }
        const ne = n.startIndex, de = Math.min(n.endIndex, t.length);
        for(let me = ne; me < de; me++){
            const we = t[me];
            let ke = null, Re = !1, Ae = null;
            if (we.kind === "leaf") {
                const Te = e.tree.nodes[we.nodeId], Ee = Te == null ? void 0 : Te.geneId, $e = Ee ? u.sequences[Ee] : void 0;
                if ($e && (ke = (D)=>$e[D]), Q && Ee) {
                    const D = w(Ee);
                    D && (Ae = (d)=>{
                        const S = D[d];
                        return S ? xt(S) : null;
                    });
                }
            } else if (we.kind === "collapsedSummary") {
                const Te = W(we.nodeId);
                if (Te && (ke = (Ee)=>Te[Ee] ?? void 0, Re = !0), Q) {
                    const Ee = N(we.nodeId);
                    Ee && (Ae = ($e)=>{
                        const D = Ee.dominant[$e];
                        if (!D) return null;
                        const d = Math.max(0, Math.min(1, Ee.coverage[$e] ?? 1));
                        return xt(D, d);
                    });
                }
            }
            if (!ke) continue;
            const _e = (Te, Ee)=>Q ? Ae ? Ae(Te) : null : Y.color(Ee), Fe = we.y + we.height / 2, Xe = we.opacity ?? 1, Be = Re ? Xe * Pi : Xe, Ne = -32 * (1 - Xe);
            if (F.globalAlpha = Be, F.save(), F.translate(Ne, 0), se) {
                const Te = k && k.nodeId === we.nodeId ? k.column : -1;
                for(let Ee = z.start; Ee < z.end; Ee++){
                    const $e = R ? R[Ee] : Ee;
                    if ($e === void 0) continue;
                    const D = ke($e);
                    if (!D || D === "-") continue;
                    F.fillStyle = _e($e, D) ?? $i;
                    const d = De + (Ee - z.start + 0.5) * G, S = V ? Wi[D.toUpperCase()] ?? D : D;
                    $e === Te ? (F.font = te, F.fillText(S, d, Fe), F.font = le) : F.fillText(S, d, Fe);
                }
            } else for(let Te = z.start; Te < z.end; Te++){
                const Ee = R ? R[Te] : Te;
                if (Ee === void 0) continue;
                const $e = ke(Ee);
                if (!$e || $e === "-") continue;
                F.fillStyle = _e(Ee, $e) ?? Ai;
                const D = De + Math.round((Te - z.start) * G), d = De + Math.round((Te - z.start + 1) * G);
                F.fillRect(D, we.y + 2, Math.max(1, d - D), we.height - 4);
            }
            F.restore();
        }
        F.globalAlpha = 1;
    }, [
        u,
        t,
        n.startIndex,
        n.endIndex,
        o,
        m,
        i.viewportStart,
        i.viewportEnd,
        i.colorSchemeId,
        e.tree,
        W,
        w,
        N,
        I,
        _,
        p,
        k
    ]), (0, _react.useEffect)(()=>{
        x(null);
    }, [
        x,
        I,
        _,
        o,
        i.viewportStart,
        i.viewportEnd
    ]), (0, _react.useEffect)(()=>()=>x(null), [
        x
    ]), (0, _react.useEffect)(()=>{
        const C = y.current;
        if (!C || !u) return;
        const O = (F)=>{
            const z = ht(i, _), U = Math.max(1, o - 2 * De), G = z.end - z.start;
            if (F.ctrlKey || F.shiftKey) {
                F.preventDefault();
                const Y = C.getBoundingClientRect(), R = F.clientX - Y.left - De, K = Math.max(0, Math.min(U, R)), Q = z.start + K / U * G, se = Math.exp(F.deltaY * 2e-3), le = Math.min(_, ln(u.alphabet, U));
                let te = Math.round(G * se);
                te = Math.max(le, Math.min(_, te));
                let V = Math.round(Q - K / U * te);
                V = Math.max(0, Math.min(_ - te, V)), a((ne)=>({
                        ...ne,
                        viewportStart: V,
                        viewportEnd: V + te
                    }));
                return;
            }
            if (F.deltaX !== 0) {
                F.preventDefault();
                const Y = G / U;
                let R = Math.round(z.start + F.deltaX * Y);
                if (R = Math.max(0, Math.min(_ - G, R)), R === z.start) return;
                a((K)=>({
                        ...K,
                        viewportStart: R,
                        viewportEnd: R + G
                    }));
            }
        };
        return C.addEventListener("wheel", O, {
            passive: !1
        }), ()=>C.removeEventListener("wheel", O);
    }, [
        u,
        o,
        i.viewportStart,
        i.viewportEnd,
        _,
        a
    ]), !u) return /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        style: {
            padding: "8px 10px",
            fontSize: 12,
            color: "var(--tbrowse-text-muted)"
        },
        children: "No alignment provided"
    });
    const ae = t.slice(n.startIndex, n.endIndex), ue = u ? ht(i, _) : null, pe = Math.max(1, o - 2 * De), oe = ue && ue.width > 0 ? pe / ue.width : 0, B = (C)=>{
        a((O)=>{
            const F = O.mask ?? on, z = new Set(F.expandedRuns ?? []);
            return z.has(C) ? z.delete(C) : z.add(C), {
                ...O,
                mask: {
                    ...F,
                    expandedRuns: [
                        ...z
                    ].sort((U, G)=>U - G)
                }
            };
        });
    }, re = (C, O)=>{
        if (!u || !I || !y.current) return null;
        const F = y.current.getBoundingClientRect(), z = C - F.left, U = O - F.top, G = ht(i, _), Y = Math.max(1, o - 2 * De), R = Y / G.width, K = z - De;
        if (K < 0 || K > Y) return null;
        const Q = G.start + Math.floor(K / R);
        if (Q < G.start || Q >= G.end) return null;
        const se = I.visibleCols[Q];
        if (se === void 0) return null;
        const le = n.startIndex, te = Math.min(n.endIndex, t.length);
        for(let V = le; V < te; V++){
            const ne = t[V];
            if (U >= ne.y && U < ne.y + ne.height) return {
                row: ne,
                oCol: se,
                residueWidth: R
            };
        }
        return null;
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        ref: y,
        onClick: (C)=>{
            var G, Y, R, K, Q;
            const O = re(C.clientX, C.clientY);
            if (!O) return;
            const { row: F, oCol: z } = O, U = e.tree.nodes[F.nodeId];
            if (U) {
                if (F.kind === "leaf") {
                    if (!U.geneId) return;
                    const se = (G = e.proteinDomains) == null ? void 0 : G[U.geneId];
                    if (!se || se.length === 0) return;
                    const le = H(U.geneId), te = se.filter((ne)=>{
                        const de = ft(ne, le);
                        return de !== null && z >= de.startCol && z <= de.endCol;
                    });
                    if (te.length === 0) return;
                    const V = ((R = (Y = e.geneMetadata) == null ? void 0 : Y[U.geneId]) == null ? void 0 : R.displayName) ?? U.geneId;
                    ie({
                        screenX: C.clientX,
                        screenY: C.clientY,
                        title: V,
                        entries: te.map((ne)=>({
                                domain: ne
                            }))
                    });
                    return;
                }
                if (F.kind === "collapsedSummary") {
                    const se = $(F.nodeId);
                    if (se.length === 0) return;
                    const le = /* @__PURE__ */ new Map();
                    for (const ne of se){
                        const de = (K = e.proteinDomains) == null ? void 0 : K[ne];
                        if (!de || de.length === 0) continue;
                        const me = H(ne), we = /* @__PURE__ */ new Set();
                        for (const ke of de){
                            if (we.has(ke.id)) continue;
                            const Re = ft(ke, me);
                            if (!Re || z < Re.startCol || z > Re.endCol) continue;
                            we.add(ke.id);
                            const Ae = le.get(ke.id);
                            Ae ? Ae.count++ : le.set(ke.id, {
                                domain: ke,
                                count: 1
                            });
                        }
                    }
                    if (le.size === 0) return;
                    const te = [
                        ...le.values()
                    ].sort((ne, de)=>de.count - ne.count).map(({ domain: ne, count: de })=>({
                            domain: ne,
                            subtreeCount: de
                        }));
                    let V = `(${F.leafCount} leaves)`;
                    if (U.taxonomyId !== void 0 && (Q = e.taxonomy) != null && Q[U.taxonomyId]) {
                        const ne = e.taxonomy[U.taxonomyId], de = ne.scientificName ?? ne.commonName;
                        de && (V = `(${F.leafCount}) ${de}`);
                    }
                    ie({
                        screenX: C.clientX,
                        screenY: C.clientY,
                        title: V,
                        entries: te,
                        subtreeTotal: se.length
                    });
                }
            }
        },
        onMouseMove: (C)=>{
            var G;
            const O = re(C.clientX, C.clientY);
            if (!u || !O || O.residueWidth < rn || O.row.kind !== "leaf") {
                k && x(null);
                return;
            }
            const F = (G = e.tree.nodes[O.row.nodeId]) == null ? void 0 : G.geneId, z = F ? u.sequences[F] : void 0, U = z == null ? void 0 : z[O.oCol];
            if (!F || !z || !U || U === "-" || U === ".") {
                k && x(null);
                return;
            }
            k && k.nodeId === O.row.nodeId && k.column === O.oCol || x({
                nodeId: O.row.nodeId,
                geneId: F,
                column: O.oCol,
                position: Di(z, O.oCol),
                residue: U
            });
        },
        onMouseLeave: ()=>{
            k && x(null);
        },
        style: {
            position: "relative",
            width: "100%",
            height: "100%"
        },
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("canvas", {
                ref: g,
                style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: o,
                    height: m,
                    pointerEvents: "none"
                }
            }),
            ae.map((C)=>{
                const O = c === C.nodeId, F = s.has(C.nodeId), z = l === C.nodeId;
                return /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                    onMouseEnter: ()=>h(C.nodeId),
                    onMouseLeave: ()=>h(null),
                    style: {
                        position: "absolute",
                        top: C.y,
                        left: 0,
                        right: 0,
                        height: C.height,
                        // No click-to-select in MSA — clicks are handled at the body
                        // level and either open the domain tooltip or do nothing.
                        cursor: "default",
                        background: z ? "var(--tbrowse-row-select-bg)" : O ? "var(--tbrowse-row-hover-bg)" : F ? "var(--tbrowse-row-subtree-bg)" : "transparent",
                        borderBottom: "1px solid var(--tbrowse-border-row)",
                        opacity: C.opacity ?? 1,
                        transform: `translateX(${-32 * (1 - (C.opacity ?? 1))}px)`
                    }
                }, C.nodeId);
            }),
            v.length > 0 && ue && /* @__PURE__ */ (0, _jsxRuntime.jsx)("svg", {
                width: o,
                height: m,
                style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    pointerEvents: "none"
                },
                children: v.map((C)=>{
                    const O = De + (C.startVCol - ue.start) * oe, F = De + (C.endVCol - ue.start + 1) * oe;
                    if (F <= De || O >= De + pe) return null;
                    const z = Math.max(De, O), U = Math.min(De + pe, F), G = Math.max(1, U - z);
                    return(// Bars are passive visual markers; click handling is at the
                    // body level so any click in the row + column intersection
                    // (whether on the bar or just on its row pixels) opens the
                    // domain tooltip.
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                        x: z,
                        y: C.rowY + C.rowH - 3,
                        width: G,
                        height: 2,
                        fill: xt(C.id, C.alpha),
                        pointerEvents: "none"
                    }, C.key));
                })
            }),
            L.length > 0 && ue && /* @__PURE__ */ (0, _jsxRuntime.jsx)("svg", {
                width: o,
                height: m,
                style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    pointerEvents: "none"
                },
                children: L.map((C)=>{
                    const O = De + (C.vCol - ue.start + C.withinFrac) * oe;
                    return O <= De || O >= De + pe ? null : /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                        x1: O,
                        y1: C.rowY,
                        x2: O,
                        y2: C.rowY + C.rowH,
                        stroke: "red",
                        strokeWidth: 1,
                        strokeOpacity: 0.55
                    }, C.key);
                })
            }),
            I && I.runs.length > 0 && ue && /* @__PURE__ */ (0, _jsxRuntime.jsx)("svg", {
                width: o,
                height: 8,
                style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    overflow: "visible",
                    pointerEvents: "none"
                },
                children: I.runs.map((C)=>{
                    const O = C.end - C.start + 1, F = C.visibleAt;
                    if ((C.expanded ? C.visibleAt + O : C.visibleAt) < ue.start || F > ue.end) return null;
                    const U = (le)=>De + (le - ue.start) * oe, G = C.expanded ? "rgba(40, 120, 220, 0.85)" : "#888", Y = C.expanded ? "#1d5fb1" : "#666", R = {
                        style: {
                            pointerEvents: "auto",
                            cursor: "pointer"
                        },
                        onClick: (le)=>{
                            le.stopPropagation(), B(C.start);
                        }
                    }, K = /* @__PURE__ */ (0, _jsxRuntime.jsx)("title", {
                        children: C.expanded ? `Showing ${O} masked column${O === 1 ? "" : "s"} (${C.start + 1}\u{2013}${C.end + 1}). Click to hide.` : `${O} column${O === 1 ? "" : "s"} hidden (${C.start + 1}\u{2013}${C.end + 1}). Click to show.`
                    });
                    if (!C.expanded) {
                        const le = U(C.visibleAt);
                        return /* @__PURE__ */ (0, _jsxRuntime.jsx)("polygon", {
                            points: `${le - 3.5},0 ${le + 3.5},0 ${le},6`,
                            fill: G,
                            stroke: Y,
                            strokeWidth: 0.5,
                            ...R,
                            children: K
                        }, `runmarker-${C.start}`);
                    }
                    const Q = U(C.visibleAt), se = U(C.visibleAt + O);
                    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("g", {
                        ...R,
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("polygon", {
                                points: `${Q - 3.5},0 ${Q},0 ${Q},6`,
                                fill: G,
                                stroke: Y,
                                strokeWidth: 0.5
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                                x: Q,
                                y: 0,
                                width: Math.max(0, se - Q),
                                height: 6,
                                fill: G,
                                stroke: Y,
                                strokeWidth: 0.5
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("polygon", {
                                points: `${se},0 ${se + 3.5},0 ${se},6`,
                                fill: G,
                                stroke: Y,
                                strokeWidth: 0.5
                            }),
                            K
                        ]
                    }, `runmarker-${C.start}`);
                })
            }),
            J && /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ni, {
                tip: J,
                stats: A,
                onClose: ()=>ie(null)
            })
        ]
    });
};
function Ni({ tip: e, stats: t, onClose: n }) {
    const o = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        const f = (u)=>{
            o.current && (o.current.contains(u.target) || n());
        }, h = setTimeout(()=>document.addEventListener("click", f), 0);
        return ()=>{
            clearTimeout(h), document.removeEventListener("click", f);
        };
    }, [
        n
    ]);
    const i = 8, a = 280, c = 24 + e.entries.length * 36, s = Math.min(e.screenX + 12, window.innerWidth - a - i), l = Math.min(e.screenY + 12, window.innerHeight - c - i);
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        ref: o,
        style: {
            position: "fixed",
            left: s,
            top: l,
            zIndex: 2e3,
            background: "var(--tbrowse-bg-elevated)",
            border: "1px solid var(--tbrowse-border)",
            borderRadius: 6,
            boxShadow: "0 4px 12px var(--tbrowse-tooltip-shadow)",
            padding: "8px 10px",
            fontSize: 12,
            color: "var(--tbrowse-text)",
            maxWidth: 320,
            minWidth: 180
        },
        onClick: (f)=>f.stopPropagation(),
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    display: "flex",
                    alignItems: "baseline",
                    justifyContent: "space-between",
                    marginBottom: 6,
                    gap: 8
                },
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            fontWeight: 600
                        },
                        children: e.title
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        onClick: n,
                        "aria-label": "Close",
                        style: {
                            background: "none",
                            border: "none",
                            color: "var(--tbrowse-text-muted)",
                            fontSize: 14,
                            cursor: "pointer",
                            padding: 0,
                            lineHeight: 1
                        },
                        children: "\xd7"
                    })
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: 6
                },
                children: e.entries.map(({ domain: f, subtreeCount: h })=>{
                    const u = t.freq.get(f.id) ?? 0, g = t.totalLeaves, y = g > 0 ? Math.round(u / g * 100) : 0, p = h !== void 0 && e.subtreeTotal !== void 0, k = p && e.subtreeTotal > 0 ? Math.round(h / e.subtreeTotal * 100) : 0;
                    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                        style: {
                            display: "flex",
                            alignItems: "center",
                            gap: 8
                        },
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                style: {
                                    display: "inline-block",
                                    width: 10,
                                    height: 10,
                                    borderRadius: 2,
                                    background: xt(f.id),
                                    flex: "0 0 auto"
                                }
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                                style: {
                                    flex: 1,
                                    minWidth: 0
                                },
                                children: [
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                                        style: {
                                            fontWeight: 500
                                        },
                                        children: f.name
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                                        style: {
                                            color: "var(--tbrowse-text-muted)",
                                            fontSize: 11
                                        },
                                        children: [
                                            f.id,
                                            f.source ? ` \xb7 ${f.source}` : "",
                                            !p && ` \xb7 residues ${f.start}\u{2013}${f.end}`
                                        ]
                                    }),
                                    p && /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                                        style: {
                                            color: "var(--tbrowse-text-muted)",
                                            fontSize: 11
                                        },
                                        children: [
                                            "in ",
                                            h,
                                            " / ",
                                            e.subtreeTotal,
                                            " subtree leaves (",
                                            k,
                                            "%)"
                                        ]
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                                        style: {
                                            color: "var(--tbrowse-text-muted)",
                                            fontSize: 11
                                        },
                                        children: [
                                            "tree-wide: ",
                                            u,
                                            " / ",
                                            g,
                                            " leaves (",
                                            y,
                                            "%)"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, f.id);
                })
            })
        ]
    });
}
const sl = {
    id: "msa",
    displayName: "MSA",
    Header: Oi,
    Body: _i,
    defaultWidth: 50,
    minWidth: 120,
    defaultZoneState: Ci,
    isAvailable: (e)=>!!e.msa,
    // One of the wide per-leaf detail tracks — mutually exclusive with
    // neighborhood / genome (and any host zone joining 'detail') unless the
    // user unlinks the group.
    exclusiveGroup: "detail"
}, Lt = 4, Tt = 16, Ln = 4, Hi = 0.35, Fi = 7, zi = 1.5, Gi = 3, Bi = 200, Xi = "rgba(150, 150, 160, 0.55)", ho = {
    flippedNodeIds: [],
    gapOverrideKeys: [],
    compressIntergenic: !0
}, Vi = 4, Ui = 1, po = "__edge_left__", go = "__edge_right__";
function Yi(e) {
    return e === po || e === go;
}
const qt = 130, Tn = 290, Ki = -10;
function qn(e) {
    return (e % 360 + 360) % 360;
}
function ji(e) {
    let t = 2166136261;
    for(let n = 0; n < e.length; n++)t ^= e.charCodeAt(n), t = Math.imul(t, 16777619) >>> 0;
    return t % 360;
}
function Zi(e, t) {
    const n = /* @__PURE__ */ new Map();
    if (!e) return n;
    const o = t ? e[t] : void 0, i = o == null ? void 0 : o.center.geneTree;
    if (i && n.set(i, qt), o) {
        const f = /* @__PURE__ */ new Set();
        i && f.add(i);
        const h = [];
        for (const p of o.upstream){
            const k = p.geneTree;
            k && !f.has(k) && (h.push(k), f.add(k));
        }
        const u = [];
        for (const p of o.downstream){
            const k = p.geneTree;
            k && !f.has(k) && (u.push(k), f.add(k));
        }
        const g = h.length;
        for(let p = 0; p < g; p++){
            const k = (p + 1) / (g + 1), x = Tn - k * (Tn - qt);
            n.set(h[p], qn(x));
        }
        const y = u.length;
        for(let p = 0; p < y; p++){
            const k = (p + 1) / (y + 1), x = qt - k * (qt - Ki);
            n.set(u[p], qn(x));
        }
    }
    const a = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map();
    for(const f in e){
        const h = e[f], u = new Array(h.upstream.length + 1 + h.downstream.length);
        let g = 0;
        for (const y of h.upstream)u[g++] = y;
        u[g++] = h.center;
        for (const y of h.downstream)u[g++] = y;
        for(let y = 0; y < u.length; y++){
            const p = u[y].geneTree;
            !p || n.has(p) || (a.set(p, (a.get(p) ?? 0) + 1), c.has(p) ? s.has(p) || s.set(p, {
                list: u,
                idx: y
            }) : c.set(p, {
                list: u,
                idx: y
            }));
        }
    }
    const l = [
        ...a.keys()
    ].sort((f, h)=>{
        const u = a.get(h) - a.get(f);
        return u !== 0 ? u : f < h ? -1 : 1;
    });
    for (const f of l){
        let h;
        const u = c.get(f);
        if (u && (h = Rn(f, u, n)), h === void 0) {
            const g = s.get(f);
            g && (h = Rn(f, g, n));
        }
        n.set(f, h ?? ji(f));
    }
    return n;
}
function Rn(e, t, n) {
    const { list: o, idx: i } = t;
    let a, c;
    for(let s = i - 1; s >= 0; s--){
        const l = o[s].geneTree;
        if (!l || l === e) continue;
        const f = n.get(l);
        if (f !== void 0) {
            a = f;
            break;
        }
    }
    for(let s = i + 1; s < o.length; s++){
        const l = o[s].geneTree;
        if (!l || l === e) continue;
        const f = n.get(l);
        if (f !== void 0) {
            c = f;
            break;
        }
    }
    if (a !== void 0 && c !== void 0) return Ji(a, c);
    if (a !== void 0) return (a + 30) % 360;
    if (c !== void 0) return (c + 330) % 360;
}
function Ji(e, t) {
    let n = t - e;
    return n > 180 ? n -= 360 : n < -180 && (n += 360), (e + n / 2 + 360) % 360;
}
function Qi(e, t, n = 1) {
    let o = t.get(e);
    if (o === void 0) {
        let i = 2166136261;
        for(let a = 0; a < e.length; a++)i ^= e.charCodeAt(a), i = Math.imul(i, 16777619) >>> 0;
        o = i % 360;
    }
    return n < 1 ? `hsl(${o} 65% 50% / ${n})` : `hsl(${o} 65% 50%)`;
}
const $n = 45, An = 46;
function es(e, t) {
    if (!e || !t) return 0;
    const n = Math.min(e.length, t.length);
    let o = 0, i = 0;
    for(let a = 0; a < n; a++){
        const c = e.charCodeAt(a), s = t.charCodeAt(a);
        c === $n || c === An || s === $n || s === An || (o++, c === s && i++);
    }
    return o > 0 ? i / o : 0;
}
function ts(e) {
    return `hsl(130 50% ${80 - 55 * Math.max(0, Math.min(1, e))}%)`;
}
const ns = ({ hoveredNodeId: e, data: t, zoneState: n, setZoneState: o })=>{
    const i = n.compressIntergenic ?? !0, a = ()=>o((s)=>({
                ...s,
                compressIntergenic: !(s.compressIntergenic ?? !0)
            })), c = (()=>{
        var g, y;
        if (!e) return null;
        const s = t.tree.nodes[e];
        if (!(s != null && s.geneId)) return null;
        const l = (g = t.neighborhood) == null ? void 0 : g[s.geneId];
        if (!l) return null;
        const f = l.center, h = f.strand === -1 ? "\u2212" : "+", u = [];
        if (s.taxonomyId !== void 0 && (y = t.taxonomy) != null && y[s.taxonomyId]) {
            const p = t.taxonomy[s.taxonomyId], k = p.scientificName ?? p.commonName;
            k && u.push(k);
        }
        return u.push(`${f.region ?? "?"}:${f.start.toLocaleString()}\u{2013}${f.end.toLocaleString()} (${h})`), u.join(" \xb7 ");
    })();
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        style: {
            height: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 4,
            fontSize: 13,
            color: "var(--tbrowse-text)"
        },
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    padding: "0 10px 0 18px"
                },
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(nt, {
                        defaultName: "Neighborhood",
                        customName: n == null ? void 0 : n.name,
                        onChange: (s)=>o((l)=>({
                                    ...l ?? ho,
                                    name: s
                                }))
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                        style: {
                            fontWeight: 400,
                            color: "var(--tbrowse-text-muted)",
                            fontSize: 11
                        },
                        children: "\xb110 flanking genes"
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        onClick: a,
                        title: i ? "Long intergenic regions compressed \u2014 click to expand all" : "Long intergenic regions expanded \u2014 click to compress all",
                        style: {
                            fontSize: 11,
                            padding: "1px 6px",
                            border: `1px solid ${i ? "var(--tbrowse-accent)" : "var(--tbrowse-border)"}`,
                            background: i ? "var(--tbrowse-accent-soft)" : "var(--tbrowse-bg-input)",
                            color: i ? "var(--tbrowse-accent-strong)" : "var(--tbrowse-text)",
                            borderRadius: 3,
                            cursor: "pointer"
                        },
                        children: "//"
                    })
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                style: {
                    flex: `0 0 ${(0, _tbrowseCore.LEAF_ROW_HEIGHT)}px`,
                    minHeight: 0,
                    padding: "0 10px 0 18px",
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    fontSize: 11,
                    color: "var(--tbrowse-text-muted)",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                },
                title: c ?? "",
                children: c ?? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                    style: {
                        color: "var(--tbrowse-text-subtle)"
                    },
                    children: "hover a neighborhood\u2026"
                })
            })
        ]
    });
};
function os(e, t, n, o) {
    const i = [
        ...e.upstream,
        e.center,
        ...e.downstream
    ].sort((M, $)=>M.start - $.start), c = [
        ...i.map((M)=>Math.max(0, M.end - M.start))
    ].sort((M, $)=>M - $), s = c[Math.floor(c.length / 2)] ?? 1, l = Math.max(1, s) * Vi, f = Math.max(1, s) * Ui, h = (e.center.start + e.center.end) / 2, u = h - i[0].start, g = i[i.length - 1].end - h, y = Math.max(u, g), p = Math.abs(u - g), k = u < g, x = Math.min(Bi, Math.max(0, p - l - 1)), m = [
        ...i
    ];
    if (x > 0) {
        if (k) {
            const M = h - y;
            m.unshift({
                id: po,
                strand: 1,
                start: M,
                end: M + x
            });
        } else {
            const M = h + y;
            m.push({
                id: go,
                strand: 1,
                start: M - x,
                end: M
            });
        }
    }
    const b = new Array(m.length), E = new Array(m.length), T = [];
    let I = 0;
    for(let M = 0; M < m.length; M++){
        if (M > 0) {
            const W = m[M - 1], H = m[M], w = H.start - W.end;
            if (w > l) {
                const N = `${n}:gap:${W.id}-${H.id}`, v = t.has(N), L = o !== v;
                T.push({
                    key: N,
                    leftIdx: M - 1,
                    rightIdx: M,
                    realLength: w,
                    isCompressed: L
                }), L && (I += w - f);
            }
        }
        const $ = m[M];
        b[M] = $.start - I, E[M] = $.end - I;
    }
    const _ = m.findIndex((M)=>M.id === e.center.id);
    return {
        sorted: m,
        effStart: b,
        effEnd: E,
        longGaps: T,
        centerIdx: _
    };
}
function rs(e, t, n, o, i, a, c) {
    const s = n / 2, l = t + s, f = os(e, i, a, c), { sorted: h, effStart: u, effEnd: g, longGaps: y, centerIdx: p } = f;
    if (p < 0) return {
        arrows: [],
        gaps: []
    };
    let k = 1 / 0, x = -1 / 0;
    for(let W = 0; W < h.length; W++)u[W] < k && (k = u[W]), g[W] > x && (x = g[W]);
    const m = (u[p] + g[p]) / 2, b = Math.max(0, m - k), E = Math.max(0, x - m), T = s / Math.max(1, b), I = s / Math.max(1, E), _ = (W)=>W <= m ? l + (W - m) * T : l + (W - m) * I, M = [];
    for(let W = 0; W < h.length; W++){
        const H = h[W], w = Yi(H.id), N = _(u[W]), v = _(g[W]);
        let L = N;
        const A = Math.max(Gi, v - N);
        let J = H.strand;
        o && (L = 2 * l - N - A, J = -J), M.push({
            gene: H,
            x: L,
            width: A,
            strand: J,
            isCenter: W === p,
            isEdgeMarker: w
        });
    }
    const $ = [];
    for (const W of y){
        const H = g[W.leftIdx], w = u[W.rightIdx];
        let N = _(H), v = _(w);
        if (o) {
            const L = 2 * l - v, A = 2 * l - N;
            N = L, v = A;
        }
        $.push({
            key: W.key,
            x: N,
            width: Math.max(0, v - N),
            realLength: W.realLength,
            isCompressed: W.isCompressed
        });
    }
    return {
        arrows: M,
        gaps: $
    };
}
function is(e, t, n, o, i) {
    const a = Math.max(zi, Math.min(Fi, n * Hi));
    if (n <= a * 2) return i === 1 ? `${e},${t} ${e + n},${t + o / 2} ${e},${t + o}` : `${e + n},${t} ${e},${t + o / 2} ${e + n},${t + o}`;
    const c = e, s = e + n, l = t, f = t + o, h = t + o / 2;
    return i === 1 ? [
        [
            c,
            l
        ],
        [
            s - a,
            l
        ],
        [
            s,
            h
        ],
        [
            s - a,
            f
        ],
        [
            c,
            f
        ]
    ].map(([u, g])=>`${u},${g}`).join(" ") : [
        [
            s,
            l
        ],
        [
            c + a,
            l
        ],
        [
            c,
            h
        ],
        [
            c + a,
            f
        ],
        [
            s,
            f
        ]
    ].map(([u, g])=>`${u},${g}`).join(" ");
}
const ss = ({ visibleRows: e, rowRange: t, width: n, data: o, hoveredNodeId: i, hoveredSubtreeIds: a, selectedNodeId: c, nodeOfInterestId: s, onHoverNode: l, zoneState: f, setZoneState: h })=>{
    const u = (0, _react.useMemo)(()=>{
        if (!o.msa || !s) return null;
        const A = o.tree.nodes[s];
        return A != null && A.geneId ? o.msa.sequences[A.geneId] ?? null : null;
    }, [
        o.msa,
        o.tree.nodes,
        s
    ]), g = (0, _react.useMemo)(()=>/* @__PURE__ */ new Map(), [
        o.msa,
        u
    ]), y = (A)=>{
        if (!A || !u || !o.msa) return 0;
        const J = g.get(A);
        if (J !== void 0) return J;
        const ie = o.msa.sequences[A], ae = ie ? es(u, ie) : 0;
        return g.set(A, ae), ae;
    }, p = (0, _react.useMemo)(()=>{
        var A;
        if (s) return (A = o.tree.nodes[s]) == null ? void 0 : A.geneId;
    }, [
        o.tree.nodes,
        s
    ]), k = (0, _react.useMemo)(()=>Zi(o.neighborhood, p), [
        o.neighborhood,
        p
    ]), x = (0, _react.useMemo)(()=>new Set(f.flippedNodeIds ?? []), [
        f.flippedNodeIds
    ]), m = (0, _react.useMemo)(()=>new Set(f.gapOverrideKeys ?? []), [
        f.gapOverrideKeys
    ]), b = f.compressIntergenic ?? !0, E = (A)=>{
        h((J)=>{
            const ie = J.gapOverrideKeys ?? [], ue = ie.indexOf(A) >= 0 ? ie.filter((pe)=>pe !== A) : [
                ...ie,
                A
            ];
            return {
                ...J,
                gapOverrideKeys: ue
            };
        });
    }, [T, I] = (0, _react.useState)(null), [_, M] = (0, _react.useState)(null);
    (0, _react.useEffect)(()=>{
        if (!T) return;
        const A = (J)=>{
            J.key === "Escape" && I(null);
        };
        return window.addEventListener("keydown", A), ()=>window.removeEventListener("keydown", A);
    }, [
        T
    ]);
    const $ = (A)=>{
        h((J)=>{
            const ie = J.flippedNodeIds ?? [], ue = ie.indexOf(A) >= 0 ? ie.filter((pe)=>pe !== A) : [
                ...ie,
                A
            ];
            return {
                ...J,
                flippedNodeIds: ue
            };
        });
    }, W = (0, _react.useMemo)(()=>e.length > 0 ? e[e.length - 1].y + e[e.length - 1].height : 0, [
        e
    ]), H = Lt + Tt, w = Math.max(1, n - 2 * Lt - Tt), N = H + w / 2, v = Lt + Tt / 2, L = e.slice(t.startIndex, t.endIndex);
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("svg", {
                width: n,
                height: W,
                style: {
                    display: "block",
                    shapeRendering: "crispEdges"
                },
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                        x1: N,
                        y1: 0,
                        x2: N,
                        y2: W,
                        stroke: "red",
                        strokeOpacity: 0.18,
                        strokeWidth: 1,
                        pointerEvents: "none"
                    }),
                    L.map((A)=>{
                        var te;
                        if (A.kind !== "leaf") return null;
                        const J = o.tree.nodes[A.nodeId];
                        if (!(J != null && J.geneId)) return null;
                        const ie = (te = o.neighborhood) == null ? void 0 : te[J.geneId];
                        if (!ie) return null;
                        const ae = i === A.nodeId, ue = a.has(A.nodeId), oe = c === A.nodeId ? "var(--tbrowse-row-select-bg)" : ae ? "var(--tbrowse-row-hover-bg)" : ue ? "var(--tbrowse-row-subtree-bg)" : null, B = ie.center.strand === -1, re = x.has(A.nodeId), ge = B !== re, { arrows: fe, gaps: C } = rs(ie, H, w, ge, m, A.nodeId, b), O = A.height - Ln * 2, F = A.y + Ln, z = A.opacity ?? 1, U = 1, G = Math.max(2, (O - U) / 2), Y = F, R = F + G + U, K = fe.map((V, ne)=>{
                            if (V.isEdgeMarker) return !1;
                            for(let de = 0; de < fe.length; de++){
                                if (ne === de) continue;
                                const me = fe[de];
                                if (!me.isEdgeMarker && V.gene.strand !== me.gene.strand && V.x < me.x + me.width && me.x < V.x + V.width) return !0;
                            }
                            return !1;
                        }), se = (re ? ie.center.strand === 1 ? -1 : 1 : ie.center.strand) === 1 ? "+" : "\u2212", le = re ? `Neighborhood is flipped (showing as ${se} strand) \u{2014} click to unflip` : `Centre gene is on the ${se} strand \u{2014} click to flip neighborhood`;
                        return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("g", {
                            opacity: z,
                            transform: `translate(${-32 * (1 - z)}, 0)`,
                            onMouseEnter: ()=>l(A.nodeId),
                            onMouseLeave: ()=>l(null),
                            children: [
                                oe && /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                                    x: 0,
                                    y: A.y,
                                    width: n,
                                    height: A.height,
                                    fill: oe
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("g", {
                                    onClick: (V)=>{
                                        V.stopPropagation(), $(A.nodeId);
                                    },
                                    style: {
                                        cursor: "pointer"
                                    },
                                    children: [
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                                            x: Lt,
                                            y: A.y,
                                            width: Tt,
                                            height: A.height,
                                            fill: "transparent"
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("text", {
                                            x: v,
                                            y: A.y + A.height / 2 + 0.5,
                                            textAnchor: "middle",
                                            dominantBaseline: "middle",
                                            fontSize: 13,
                                            fontWeight: 700,
                                            fontFamily: "ui-monospace, 'SF Mono', Menlo, monospace",
                                            fill: "var(--tbrowse-text-muted)",
                                            pointerEvents: "none",
                                            children: se
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("title", {
                                            children: le
                                        })
                                    ]
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                                    x1: H,
                                    y1: F + O / 2,
                                    x2: H + w,
                                    y2: F + O / 2,
                                    stroke: "var(--tbrowse-text-subtle)",
                                    strokeOpacity: 0.25,
                                    strokeWidth: 0.75
                                }),
                                fe.map((V, ne)=>{
                                    if (V.isEdgeMarker) return /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                                        x: V.x,
                                        y: F,
                                        width: V.width,
                                        height: O,
                                        fill: "var(--tbrowse-text)",
                                        pointerEvents: "none",
                                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("title", {
                                            children: "End of neighborhood window"
                                        })
                                    }, `${A.nodeId}-${ne}-edge`);
                                    const de = V.isCenter ? ts(y(V.gene.id)) : V.gene.geneTree ? Qi(V.gene.geneTree, k) : Xi, me = K[ne], we = V.gene.strand === ie.center.strand, ke = me ? we ? Y : R : F, Re = me ? G : O, Ae = _ !== null && V.gene.geneTree === _;
                                    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("polygon", {
                                        points: is(V.x, ke, V.width, Re, V.strand),
                                        fill: de,
                                        stroke: Ae ? "var(--tbrowse-accent)" : "var(--tbrowse-bg)",
                                        strokeWidth: Ae ? 1.75 : 0.5,
                                        style: {
                                            cursor: "pointer"
                                        },
                                        onMouseEnter: ()=>{
                                            V.gene.geneTree && M(V.gene.geneTree);
                                        },
                                        onMouseLeave: ()=>{
                                            V.gene.geneTree && M(null);
                                        },
                                        onClick: (_e)=>{
                                            _e.stopPropagation(), I({
                                                screenX: _e.clientX,
                                                screenY: _e.clientY,
                                                gene: V.gene,
                                                isCenter: V.isCenter,
                                                identity: V.isCenter ? y(V.gene.id) : void 0
                                            });
                                        }
                                    }, `${A.nodeId}-${ne}-${V.gene.id}`);
                                }),
                                C.map((V)=>{
                                    const ne = V.x + V.width / 2, de = F + O / 2, me = Math.max(V.width, 14), we = ne - me / 2, ke = (V.realLength / 1e3).toLocaleString(void 0, {
                                        maximumFractionDigits: 1
                                    }), Re = V.isCompressed ? `Long intergenic gap (${ke} kb) \u{2014} click to expand` : `Intergenic gap (${ke} kb) \u{2014} click to compress`;
                                    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("g", {
                                        onClick: (Ae)=>{
                                            Ae.stopPropagation(), E(V.key);
                                        },
                                        style: {
                                            cursor: "pointer"
                                        },
                                        children: [
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                                                x: we,
                                                y: F,
                                                width: me,
                                                height: O,
                                                fill: "transparent"
                                            }),
                                            V.isCompressed ? // Two diagonal slashes drawn 2px apart for a tight
                                            // "cut-mark" look. Same pattern as the tree zone's
                                            // branch-compression glyph, just smaller.
                                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("g", {
                                                stroke: "var(--tbrowse-accent)",
                                                strokeWidth: 1.2,
                                                pointerEvents: "none",
                                                children: [
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                                                        x1: ne - 2,
                                                        y1: de + 4,
                                                        x2: ne,
                                                        y2: de - 4
                                                    }),
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                                                        x1: ne,
                                                        y1: de + 4,
                                                        x2: ne + 2,
                                                        y2: de - 4
                                                    })
                                                ]
                                            }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("text", {
                                                x: ne,
                                                y: de + 0.5,
                                                textAnchor: "middle",
                                                dominantBaseline: "middle",
                                                fontSize: 11,
                                                fontWeight: 700,
                                                fontFamily: "ui-monospace, 'SF Mono', Menlo, monospace",
                                                fill: "var(--tbrowse-accent)",
                                                pointerEvents: "none",
                                                children: "\u2194"
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("title", {
                                                children: Re
                                            })
                                        ]
                                    }, V.key);
                                })
                            ]
                        }, `row-${A.nodeId}`);
                    })
                ]
            }),
            T && /* @__PURE__ */ (0, _jsxRuntime.jsx)(ls, {
                tip: T,
                onClose: ()=>I(null)
            })
        ]
    });
};
function ls({ tip: e, onClose: t }) {
    const n = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        const h = (g)=>{
            n.current && (n.current.contains(g.target) || t());
        }, u = setTimeout(()=>document.addEventListener("mousedown", h), 0);
        return ()=>{
            clearTimeout(u), document.removeEventListener("mousedown", h);
        };
    }, [
        t
    ]);
    const o = 8, i = 280, a = 160, c = Math.min(e.screenX + 12, window.innerWidth - i - o), s = Math.min(e.screenY + 12, window.innerHeight - a - o), l = e.gene, f = l.strand === -1 ? "\u2212" : "+";
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        ref: n,
        style: {
            position: "fixed",
            left: c,
            top: s,
            zIndex: 2e3,
            background: "var(--tbrowse-bg-elevated)",
            border: "1px solid var(--tbrowse-border)",
            borderRadius: 6,
            boxShadow: "0 4px 12px var(--tbrowse-tooltip-shadow)",
            padding: "8px 10px",
            fontSize: 12,
            color: "var(--tbrowse-text)",
            maxWidth: 320,
            minWidth: 200
        },
        onClick: (h)=>h.stopPropagation(),
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    display: "flex",
                    alignItems: "baseline",
                    justifyContent: "space-between",
                    marginBottom: 6,
                    gap: 8
                },
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            fontWeight: 600
                        },
                        children: l.name ?? l.id
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        onClick: t,
                        "aria-label": "Close",
                        style: {
                            background: "none",
                            border: "none",
                            color: "var(--tbrowse-text-muted)",
                            fontSize: 14,
                            cursor: "pointer",
                            padding: 0,
                            lineHeight: 1
                        },
                        children: "\xd7"
                    })
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                style: {
                    color: "var(--tbrowse-text-muted)",
                    fontSize: 11,
                    fontFamily: 'ui-monospace, "SF Mono", Menlo, monospace'
                },
                children: l.id
            }),
            e.isCenter && /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                style: {
                    color: "var(--tbrowse-text-muted)",
                    fontSize: 11,
                    fontStyle: "italic"
                },
                children: "\u25CF centre gene"
            }),
            e.isCenter && e.identity !== void 0 && /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    color: "var(--tbrowse-text-muted)",
                    fontSize: 11
                },
                children: [
                    (e.identity * 100).toFixed(1),
                    "% identity to node of interest"
                ]
            }),
            l.biotype && /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                style: {
                    color: "var(--tbrowse-text-muted)",
                    fontSize: 11
                },
                children: l.biotype
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    color: "var(--tbrowse-text-muted)",
                    fontSize: 11
                },
                children: [
                    l.region ?? "?",
                    ":",
                    l.start.toLocaleString(),
                    "\u2013",
                    l.end.toLocaleString(),
                    " (",
                    f,
                    ")"
                ]
            }),
            l.geneTree && /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    color: "var(--tbrowse-text-muted)",
                    fontSize: 11
                },
                children: [
                    "family ",
                    l.geneTree
                ]
            }),
            l.description && /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                style: {
                    color: "var(--tbrowse-text)",
                    fontSize: 11,
                    marginTop: 4
                },
                children: l.description
            })
        ]
    });
}
const ll = {
    id: "neighborhood",
    displayName: "Neighborhood",
    Header: ns,
    Body: ss,
    defaultWidth: 30,
    minWidth: 200,
    defaultZoneState: ho,
    isAvailable: (e)=>!!(e.neighborhood && Object.keys(e.neighborhood).length > 0),
    // Off by default — the neighborhood track is opt-in. The chassis
    // auto-flips this on the first time `data.neighborhood` is
    // populated, so hosts that always have neighborhood data still
    // see the zone appear without intervention; hosts that never
    // have neighborhood data leave it hidden, and the toggle stays
    // disabled.
    defaultVisible: !1,
    exclusiveGroup: "detail"
}, vt = 100, cs = vt;
function as(e, t) {
    const n = e.exons.filter((s)=>s.cdsStart !== void 0 && s.cdsEnd !== void 0).map((s)=>({
            gStart: Math.max(s.start, s.cdsStart),
            gEnd: Math.min(s.end, s.cdsEnd)
        })).filter((s)=>s.gEnd >= s.gStart);
    if (n.length === 0) return null;
    n.sort((s, l)=>t === 1 ? s.gStart - l.gStart : l.gStart - s.gStart);
    let o = 0;
    for (const s of n)o += s.gEnd - s.gStart + 1;
    const i = Math.floor(o / 3), a = n[0], c = n[n.length - 1];
    return {
        peptideLength: i,
        cdsLength: o,
        startCodonGenomic: t === 1 ? a.gStart : a.gEnd,
        stopCodonGenomic: t === 1 ? c.gEnd : c.gStart
    };
}
function ds(e) {
    const { geneStructure: t, transcript: n, paddingMode: o, paddingKb: i = 2, overrideKeys: a, compressDefault: c, rowKey: s, features: l } = e, f = t.strand, h = as(n, f);
    let u, g;
    o === "cds" && h ? (u = Math.min(h.startCodonGenomic, h.stopCodonGenomic), g = Math.max(h.startCodonGenomic, h.stopCodonGenomic)) : o === "kb" ? (u = t.start - Math.round(i * 1e3), g = t.end + Math.round(i * 1e3)) : (u = t.start, g = t.end);
    const p = [
        ...n.exons
    ].map((v, L)=>({
            ...v,
            originalIndex: L
        })).sort((v, L)=>v.start - L.start).filter((v)=>v.end >= u && v.start <= g), k = [];
    for (const v of p)k.push({
        gStart: Math.max(v.start, u),
        gEnd: Math.min(v.end, g)
    });
    if (l) for (const v of l)v.end < u || v.start > g || k.push({
        gStart: Math.max(v.start, u),
        gEnd: Math.min(v.end, g)
    });
    k.sort((v, L)=>v.gStart - L.gStart);
    const x = [];
    for (const v of k){
        const L = x[x.length - 1];
        !L || v.gStart > L.gEnd + 1 ? x.push({
            gStart: v.gStart,
            gEnd: v.gEnd
        }) : v.gEnd > L.gEnd && (L.gEnd = v.gEnd);
    }
    const m = [];
    let b = 0;
    for(let v = 1; v < x.length; v++){
        const L = x[v - 1], A = x[v], J = L.gEnd + 1, ie = A.gStart - 1, ae = ie - J + 1;
        if (ae <= 0) continue;
        const ue = `${s}:gap:${J}-${ie}`, pe = ae > cs, oe = a.has(ue), B = pe && c !== oe, re = J - b;
        B && (b += ae - vt);
        const ge = ie - b;
        m.push({
            key: ue,
            gStart: J,
            gEnd: ie,
            effStart: re,
            effEnd: ge,
            realLength: ae,
            isCompressed: B
        });
    }
    const E = [];
    let T = 0, I = 0;
    for (const v of x){
        for(; I < m.length && m[I].gEnd < v.gStart;){
            const L = m[I];
            L.isCompressed && (T += L.realLength - vt), I++;
        }
        E.push({
            gStart: v.gStart,
            gEnd: v.gEnd,
            effStart: v.gStart - T,
            effEnd: v.gEnd - T
        });
    }
    const _ = [];
    let M = 0, $ = 0;
    for (const v of p){
        const L = Math.max(v.start, u), A = Math.min(v.end, g);
        for(; $ < m.length && m[$].gEnd < L;){
            const B = m[$];
            B.isCompressed && (M += B.realLength - vt), $++;
        }
        const J = L - M, ie = A - M;
        let ae, ue, pe, oe;
        if (v.cdsStart !== void 0 && v.cdsEnd !== void 0) {
            const B = Math.max(v.cdsStart, L), re = Math.min(v.cdsEnd, A);
            re >= B && (ae = B, ue = re, pe = B - M, oe = re - M);
        }
        _.push({
            exonIndex: v.originalIndex,
            gStart: L,
            gEnd: A,
            effStart: J,
            effEnd: ie,
            cdsGStart: ae,
            cdsGEnd: ue,
            cdsEffStart: pe,
            cdsEffEnd: oe
        });
    }
    const W = u, H = g - b;
    let w, N;
    if (h) for (const v of _)h.startCodonGenomic >= v.gStart && h.startCodonGenomic <= v.gEnd && (w = v.effStart + (h.startCodonGenomic - v.gStart)), h.stopCodonGenomic >= v.gStart && h.stopCodonGenomic <= v.gEnd && (N = v.effStart + (h.stopCodonGenomic - v.gStart));
    return {
        exons: _,
        introns: m,
        blockers: E,
        effMin: W,
        effMax: H,
        gMin: u,
        gMax: g,
        startCodonEff: w,
        stopCodonEff: N,
        startCodonGenomic: h == null ? void 0 : h.startCodonGenomic,
        stopCodonGenomic: h == null ? void 0 : h.stopCodonGenomic,
        peptideLength: h == null ? void 0 : h.peptideLength,
        cdsLength: h == null ? void 0 : h.cdsLength
    };
}
function Pn(e, t) {
    for (const i of e.blockers)if (t >= i.gStart && t <= i.gEnd) return i.effStart + (t - i.gStart);
    for (const i of e.introns)if (t >= i.gStart && t <= i.gEnd) {
        const a = Math.max(1, i.gEnd - i.gStart), c = i.effEnd - i.effStart;
        return i.effStart + (t - i.gStart) * c / a;
    }
    if (e.blockers.length > 0) {
        const i = e.blockers[0];
        if (t < i.gStart) return i.effStart - (i.gStart - t);
        const a = e.blockers[e.blockers.length - 1];
        if (t > a.gEnd) return a.effEnd + (t - a.gEnd);
    }
    const n = Math.max(1, e.gMax - e.gMin), o = e.effMax - e.effMin;
    return e.effMin + (t - e.gMin) * o / n;
}
function us(e) {
    return e.transcripts.length === 0 ? null : e.transcripts.find((n)=>n.id === e.canonicalTranscriptId) ?? e.transcripts[0];
}
function fs({ zoneState: e, setZoneState: t, genomeFeatures: n }) {
    const [o, i] = (0, _react.useState)(!1), [a, c] = (0, _react.useState)(null), s = (0, _react.useRef)(null), l = Le((x)=>x.theme), f = (0, _react.useMemo)(()=>{
        const x = /* @__PURE__ */ new Map();
        for (const m of Object.values(n ?? {}))for (const b of m)x.set(b.kind, (x.get(b.kind) ?? 0) + 1);
        return [
            ...x.entries()
        ].sort(([m], [b])=>m < b ? -1 : 1);
    }, [
        n
    ]), h = f.map(([x])=>x), u = new Set(e.visibleFeatureKinds ?? h), g = ()=>{
        if (!o && s.current) {
            const x = s.current.getBoundingClientRect(), m = s.current.closest("[data-genome-zone-header]"), b = m == null ? void 0 : m.getBoundingClientRect(), E = b ? Math.max(0, window.innerWidth - b.right) : Math.max(0, window.innerWidth - x.right), T = b ? b.right - b.left : 240, I = Math.max(220, T);
            c({
                right: E,
                top: x.bottom + 4,
                maxWidth: I
            });
        }
        i((x)=>!x);
    };
    (0, _react.useEffect)(()=>{
        if (!o) return;
        const x = (b)=>{
            var I;
            const E = b.target;
            if ((I = s.current) != null && I.contains(E)) return;
            const T = document.querySelector(".tbrowse-genome-config");
            T != null && T.contains(E) || i(!1);
        }, m = (b)=>{
            b.key === "Escape" && i(!1);
        };
        return document.addEventListener("mousedown", x), document.addEventListener("keydown", m), ()=>{
            document.removeEventListener("mousedown", x), document.removeEventListener("keydown", m);
        };
    }, [
        o
    ]);
    const y = (x)=>t((m)=>({
                ...m,
                visibleFeatureKinds: x
            })), p = (x)=>{
        const m = new Set(u);
        m.has(x) ? m.delete(x) : m.add(x), m.size === h.length ? y(null) : y(h.filter((b)=>m.has(b)));
    }, k = (x)=>t((m)=>({
                ...m,
                paddingKb: Math.max(0, x)
            }));
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                ref: s,
                type: "button",
                onClick: g,
                title: "Configure genome zone",
                style: {
                    display: "inline-flex",
                    alignItems: "center",
                    padding: "3px 6px",
                    borderRadius: 3,
                    border: "1px solid var(--tbrowse-border)",
                    background: o ? "var(--tbrowse-accent-soft)" : "var(--tbrowse-bg-input)",
                    color: "var(--tbrowse-text)",
                    cursor: "pointer"
                },
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(yt, {})
            }),
            o && a && (0, _reactDom.createPortal)(/* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                className: `tbrowse-root tbrowse-theme-${l}`,
                children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                    className: "tbrowse-genome-config",
                    style: {
                        position: "fixed",
                        right: a.right,
                        top: a.top,
                        boxSizing: "border-box",
                        background: "var(--tbrowse-bg-elevated)",
                        border: "1px solid var(--tbrowse-border)",
                        color: "var(--tbrowse-text)",
                        borderRadius: 6,
                        boxShadow: "0 4px 16px var(--tbrowse-tooltip-shadow)",
                        padding: "10px 12px",
                        zIndex: 2e3,
                        fontSize: 12
                    },
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                            style: {
                                fontSize: 10,
                                textTransform: "uppercase",
                                letterSpacing: 0.5,
                                color: "var(--tbrowse-text-subtle)",
                                fontWeight: 600,
                                marginBottom: 6,
                                display: "flex",
                                alignItems: "baseline",
                                justifyContent: "space-between"
                            },
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                    children: "Proximal features"
                                }),
                                f.length > 0 && /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>y(null),
                                    disabled: e.visibleFeatureKinds === null,
                                    style: {
                                        fontSize: 10,
                                        padding: "0 4px",
                                        border: "1px solid var(--tbrowse-border)",
                                        borderRadius: 3,
                                        background: "var(--tbrowse-bg-input)",
                                        color: "var(--tbrowse-text)",
                                        cursor: "pointer",
                                        letterSpacing: 0,
                                        textTransform: "none",
                                        fontWeight: 400,
                                        opacity: e.visibleFeatureKinds === null ? 0.5 : 1
                                    },
                                    title: "Show every feature kind",
                                    children: "all"
                                })
                            ]
                        }),
                        f.length === 0 ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                color: "var(--tbrowse-text-muted)",
                                fontSize: 11,
                                fontStyle: "italic",
                                marginBottom: 12
                            },
                            children: "No feature data on this tree."
                        }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                marginBottom: 12
                            },
                            children: f.map(([x, m])=>{
                                const b = u.has(x);
                                return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("label", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 8,
                                        padding: "3px 0",
                                        cursor: "pointer"
                                    },
                                    children: [
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                                            type: "checkbox",
                                            checked: b,
                                            onChange: ()=>p(x)
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                            style: {
                                                flex: 1
                                            },
                                            children: x
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                            style: {
                                                color: "var(--tbrowse-text-subtle)",
                                                fontSize: 11,
                                                fontVariantNumeric: "tabular-nums"
                                            },
                                            children: m.toLocaleString()
                                        })
                                    ]
                                }, x);
                            })
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                fontSize: 10,
                                textTransform: "uppercase",
                                letterSpacing: 0.5,
                                color: "var(--tbrowse-text-subtle)",
                                fontWeight: 600,
                                marginBottom: 6
                            },
                            children: "Window padding"
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("label", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                gap: 6,
                                fontSize: 12
                            },
                            title: "Used by the \xb1kb padding mode.",
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                    style: {
                                        color: "var(--tbrowse-text-muted)"
                                    },
                                    children: "\xb1"
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                                    type: "number",
                                    min: 0,
                                    step: 0.5,
                                    value: e.paddingKb,
                                    onChange: (x)=>k(Number(x.target.value) || 0),
                                    style: {
                                        width: 70,
                                        fontSize: 12,
                                        padding: "1px 4px"
                                    }
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                    style: {
                                        color: "var(--tbrowse-text-subtle)"
                                    },
                                    children: "kb"
                                })
                            ]
                        })
                    ]
                })
            }), document.body)
        ]
    });
}
const pt = 4, gt = 16, Wn = 4, hs = 0.5, ps = {
    TFBS: "hsl(280 60% 55%)",
    enhancer: "hsl(35 75% 55%)",
    CpG: "hsl(195 60% 50%)",
    repeat: "hsl(0 0% 60%)"
};
function gs(e) {
    const t = e.category ?? e.kind;
    return ps[t] ?? `hsl(${ms(t) % 360} 55% 55%)`;
}
function ms(e) {
    let t = 2166136261;
    for(let n = 0; n < e.length; n++)t ^= e.charCodeAt(n), t = Math.imul(t, 16777619) >>> 0;
    return t;
}
const bs = {
    paddingMode: "gene",
    paddingKb: 2,
    compressIntrons: !0,
    intronOverrideKeys: [],
    flippedNodeIds: [],
    visibleFeatureKinds: null,
    panPx: 0,
    zoom: 1
}, Ut = 0.25, Yt = 64, Dn = 1.5, xs = "-", vs = ".";
function At(e) {
    return e === xs || e === vs;
}
function On(e, t) {
    let n = 0;
    const o = Math.min(t, e.length - 1);
    for(let i = 0; i <= o; i++)At(e[i]) || n++;
    return n;
}
function ws(e, t) {
    const n = Math.min(e.length, t.length);
    let o = -1;
    for(let i = 0; i < n; i++)if (!At(e[i])) {
        o = i;
        break;
    }
    if (o < 0) return -1;
    for(let i = o; i < n; i++)if (!At(e[i]) && !At(t[i])) return i;
    return -1;
}
function ys(e, t) {
    if (e.length === 0) return null;
    let n = 0, o = 0;
    for (const s of e){
        const { layout: l, flipped: f, shiftEff: h } = s, u = l.startCodonEff ?? l.effMin, g = u - l.effMin, y = l.effMax - u, p = f ? y : g, k = f ? g : y, x = p - h, m = k + h;
        x > n && (n = x), m > o && (o = m);
    }
    const i = Math.max(1, n + o), a = t / i, c = n * a;
    return {
        pxPerEff: a,
        startCodonPx: c
    };
}
function cl(e) {
    const t = e.displayName ?? "Genome", n = e.defaultWidth ?? 32, o = {
        ...bs,
        ...e.initial
    }, i = (c)=>{
        const { zoneState: s, setZoneState: l, hoveredNodeId: f, data: h } = c, u = s ?? o, g = (b)=>l((E)=>({
                    ...E ?? o,
                    paddingMode: b
                })), y = ()=>l((b)=>({
                    ...b ?? o,
                    compressIntrons: !(b ?? o).compressIntrons
                })), p = (()=>{
            var H, w;
            if (!f) return null;
            const b = h.tree.nodes[f];
            if (!(b != null && b.geneId)) return null;
            const E = (H = h.geneStructures) == null ? void 0 : H[b.geneId];
            if (!E) return null;
            const T = b.taxonomyId ? (w = h.taxonomy) == null ? void 0 : w[b.taxonomyId] : void 0, I = (T == null ? void 0 : T.scientificName) ?? (T == null ? void 0 : T.commonName), _ = E.transcripts.length, M = E.transcripts.find((N)=>N.id === E.canonicalTranscriptId) ?? E.transcripts[0], $ = (M == null ? void 0 : M.exons.length) ?? 0, W = [];
            return I && W.push(I), E.name && W.push(E.name), W.push(`${$} exon${$ === 1 ? "" : "s"}`), W.push(`${_} transcript${_ === 1 ? "" : "s"}`), W.join(" \xb7 ");
        })(), k = (b)=>({
                fontSize: 11,
                padding: "1px 6px",
                border: `1px solid ${b ? "var(--tbrowse-accent)" : "var(--tbrowse-border)"}`,
                background: b ? "var(--tbrowse-accent-soft)" : "var(--tbrowse-bg-input)",
                color: b ? "var(--tbrowse-accent-strong)" : "var(--tbrowse-text)",
                borderRadius: 3,
                cursor: "pointer"
            }), x = {
            display: "inline-flex",
            border: "1px solid var(--tbrowse-border)",
            borderRadius: 3,
            overflow: "hidden"
        }, m = (b, E)=>({
                fontSize: 11,
                padding: "1px 6px",
                border: "none",
                borderRight: E !== "last" ? "1px solid var(--tbrowse-border)" : "none",
                background: b ? "var(--tbrowse-accent-soft)" : "var(--tbrowse-bg-input)",
                color: b ? "var(--tbrowse-accent-strong)" : "var(--tbrowse-text)",
                cursor: "pointer",
                fontFamily: "inherit"
            });
        return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
            "data-genome-zone-header": !0,
            style: {
                height: "100%",
                display: "flex",
                flexDirection: "column",
                gap: 4,
                fontSize: 13,
                color: "var(--tbrowse-text)"
            },
            children: [
                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                    style: {
                        flex: 1,
                        minHeight: 0,
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        padding: "0 10px 0 14px",
                        flexWrap: "wrap"
                    },
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)(nt, {
                            defaultName: t,
                            customName: u.name,
                            onChange: (b)=>l((E)=>({
                                        ...E ?? o,
                                        name: b
                                    }))
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                            style: x,
                            role: "group",
                            "aria-label": "Window mode",
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>g("cds"),
                                    style: m(u.paddingMode === "cds", "first"),
                                    title: "Window covers the CDS only",
                                    children: "CDS"
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>g("gene"),
                                    style: m(u.paddingMode === "gene", "middle"),
                                    title: "Window covers the full gene span (UTRs included)",
                                    children: "Gene"
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("button", {
                                    type: "button",
                                    onClick: ()=>g("kb"),
                                    style: m(u.paddingMode === "kb", "last"),
                                    title: `Window covers gene span \xb1 ${u.paddingKb} kb`,
                                    children: [
                                        "\xb1",
                                        u.paddingKb,
                                        "kb"
                                    ]
                                })
                            ]
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            onClick: y,
                            style: k(u.compressIntrons),
                            title: u.compressIntrons ? "Long introns compressed \u2014 click to expand all" : "Long introns expanded \u2014 click to compress all",
                            children: "//"
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                            style: x,
                            role: "group",
                            "aria-label": "Zoom",
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>l((b)=>{
                                            const E = b ?? o, T = E.zoom ?? 1, I = Math.max(Ut, T / Dn);
                                            if (I === T) return E;
                                            const M = (E.panPx ?? 0) * (I / T);
                                            return {
                                                ...E,
                                                zoom: I,
                                                panPx: M
                                            };
                                        }),
                                    disabled: (u.zoom ?? 1) <= Ut + 1e-6,
                                    style: m(!1, "first"),
                                    title: "Zoom out",
                                    children: "\u2212"
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>l((b)=>{
                                            const E = b ?? o, T = E.zoom ?? 1, I = Math.min(Yt, T * Dn);
                                            if (I === T) return E;
                                            const M = (E.panPx ?? 0) * (I / T);
                                            return {
                                                ...E,
                                                zoom: I,
                                                panPx: M
                                            };
                                        }),
                                    disabled: (u.zoom ?? 1) >= Yt - 1e-6,
                                    style: m(!1, "last"),
                                    title: "Zoom in",
                                    children: "+"
                                })
                            ]
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            onClick: ()=>l((b)=>({
                                        ...b ?? o,
                                        panPx: 0,
                                        zoom: 1
                                    })),
                            disabled: (u.panPx ?? 0) === 0 && (u.zoom ?? 1) === 1,
                            style: {
                                ...k((u.panPx ?? 0) !== 0 || (u.zoom ?? 1) !== 1),
                                opacity: (u.panPx ?? 0) === 0 && (u.zoom ?? 1) === 1 ? 0.5 : 1
                            },
                            title: "Reset pan and zoom",
                            children: (u.zoom ?? 1) !== 1 ? `${(u.zoom ?? 1).toFixed(2).replace(/\.?0+$/, "")}\xd7` : "fit"
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                            style: {
                                marginLeft: "auto"
                            },
                            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(fs, {
                                zoneState: u,
                                setZoneState: l,
                                genomeFeatures: h.genomeFeatures
                            })
                        })
                    ]
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        flex: "0 0 18px",
                        minHeight: 0,
                        padding: "0 10px 0 14px",
                        display: "flex",
                        alignItems: "center",
                        fontSize: 11,
                        color: "var(--tbrowse-text-muted)",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis"
                    },
                    title: p ?? "",
                    children: p ?? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                        style: {
                            color: "var(--tbrowse-text-subtle)"
                        },
                        children: "hover a row\u2026"
                    })
                })
            ]
        });
    }, a = (c)=>{
        const { visibleRows: s, rowRange: l, width: f, data: h, hoveredNodeId: u, hoveredSubtreeIds: g, selectedNodeId: y, onHoverNode: p, zoneState: k, setZoneState: x } = c, m = k ?? o, b = (0, _react.useRef)(null), E = (0, _react.useMemo)(()=>new Set(m.intronOverrideKeys), [
            m.intronOverrideKeys
        ]), T = (0, _react.useMemo)(()=>new Set(m.flippedNodeIds), [
            m.flippedNodeIds
        ]), I = pt + gt, _ = Math.max(1, f - 2 * pt - gt), M = (0, _react.useMemo)(()=>s.length > 0 ? s[s.length - 1].y + s[s.length - 1].height : 0, [
            s
        ]), $ = s.slice(l.startIndex, l.endIndex), W = (0, _react.useMemo)(()=>{
            var B;
            const oe = c.nodeOfInterestId;
            return oe ? ((B = h.tree.nodes[oe]) == null ? void 0 : B.geneId) ?? null : null;
        }, [
            c.nodeOfInterestId,
            h.tree.nodes
        ]), H = (0, _react.useMemo)(()=>!h.msa || !W ? null : h.msa.sequences[W] ?? null, [
            h.msa,
            W
        ]), w = (0, _react.useMemo)(()=>{
            var B, re, ge;
            const oe = /* @__PURE__ */ new Map();
            for (const fe of s){
                if (fe.kind !== "leaf") continue;
                const C = h.tree.nodes[fe.nodeId];
                if (!(C != null && C.geneId)) continue;
                const O = (B = h.geneStructures) == null ? void 0 : B[C.geneId];
                if (!O) continue;
                const F = us(O);
                if (!F) continue;
                const z = (re = h.genomeFeatures) == null ? void 0 : re[C.geneId], U = z ? m.visibleFeatureKinds ? z.filter((V)=>m.visibleFeatureKinds.includes(V.kind)) : z : void 0, G = ds({
                    geneStructure: O,
                    transcript: F,
                    paddingMode: m.paddingMode,
                    paddingKb: m.paddingKb,
                    overrideKeys: E,
                    compressDefault: m.compressIntrons,
                    rowKey: fe.nodeId,
                    features: U
                }), Y = O.strand === -1, R = T.has(fe.nodeId), K = Y !== R, Q = G.startCodonEff ?? G.effMin;
                let se = 0, le = Q;
                const te = (ge = h.msa) == null ? void 0 : ge.sequences[C.geneId];
                if (H && te && W !== null && C.geneId !== W) {
                    const V = ws(te, H);
                    if (V >= 0) {
                        const ne = On(te, V);
                        se = 3 * (On(H, V) - ne);
                        const me = 3 * (ne - 1);
                        le = O.strand === 1 ? Q + me : Q - me;
                    }
                }
                oe.set(fe.nodeId, {
                    geneStructure: O,
                    transcript: F,
                    layout: G,
                    flipped: K,
                    userFlipped: R,
                    shiftEff: se,
                    anchorEff: le
                });
            }
            return oe;
        }, [
            s,
            h.tree.nodes,
            h.geneStructures,
            h.genomeFeatures,
            h.msa,
            W,
            H,
            m.paddingMode,
            m.paddingKb,
            m.compressIntrons,
            m.visibleFeatureKinds,
            E,
            T
        ]), N = (0, _react.useMemo)(()=>ys([
                ...w.values()
            ], _), [
            w,
            _
        ]);
        (0, _react.useEffect)(()=>{
            const oe = b.current;
            if (!oe || !N) return;
            const B = (re)=>{
                if (!re.ctrlKey && !re.metaKey) return;
                re.preventDefault();
                const ge = oe.getBoundingClientRect(), fe = re.clientX - ge.left, C = Math.exp(-re.deltaY * 0.01);
                x((O)=>{
                    const F = O ?? o, z = F.zoom ?? 1, U = F.panPx ?? 0, G = Math.max(Ut, Math.min(Yt, z * C));
                    if (G === z) return F;
                    const Y = I + N.startCodonPx, R = fe - Y, Q = (R - U) * (G / z), se = R - Q;
                    return {
                        ...F,
                        zoom: G,
                        panPx: se
                    };
                });
            };
            return oe.addEventListener("wheel", B, {
                passive: !1
            }), ()=>oe.removeEventListener("wheel", B);
        }, [
            N,
            I,
            x
        ]);
        const v = 4, L = (0, _react.useRef)(null), A = (oe)=>{
            if (oe.button !== 0) return;
            L.current = {
                startX: oe.clientX,
                startPan: m.panPx ?? 0,
                engaged: !1
            };
            const B = (ge)=>{
                if (!L.current) return;
                const fe = ge.clientX - L.current.startX;
                if (!L.current.engaged) {
                    if (Math.abs(fe) < v) return;
                    L.current.engaged = !0;
                }
                x((C)=>({
                        ...C ?? o,
                        panPx: L.current.startPan + fe
                    }));
            }, re = ()=>{
                L.current = null, document.removeEventListener("mousemove", B), document.removeEventListener("mouseup", re);
            };
            document.addEventListener("mousemove", B), document.addEventListener("mouseup", re);
        }, J = (oe)=>{
            x((B)=>{
                const re = (B ?? o).intronOverrideKeys, fe = re.indexOf(oe) >= 0 ? re.filter((C)=>C !== oe) : [
                    ...re,
                    oe
                ];
                return {
                    ...B ?? o,
                    intronOverrideKeys: fe
                };
            });
        }, ie = (oe)=>{
            x((B)=>{
                const re = (B ?? o).flippedNodeIds, fe = re.indexOf(oe) >= 0 ? re.filter((C)=>C !== oe) : [
                    ...re,
                    oe
                ];
                return {
                    ...B ?? o,
                    flippedNodeIds: fe
                };
            });
        }, [ae, ue] = (0, _react.useState)(null);
        (0, _react.useEffect)(()=>{
            if (!ae) return;
            const oe = (B)=>{
                B.key === "Escape" && ue(null);
            };
            return window.addEventListener("keydown", oe), ()=>window.removeEventListener("keydown", oe);
        }, [
            ae
        ]);
        const pe = pt + gt / 2;
        return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                    ref: b,
                    onMouseDown: A,
                    style: {
                        position: "relative",
                        width: f,
                        height: M,
                        overflow: "hidden",
                        cursor: L.current ? "grabbing" : "grab"
                    },
                    children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("svg", {
                        width: f,
                        height: M,
                        style: {
                            display: "block",
                            shapeRendering: "crispEdges"
                        },
                        children: $.map((oe)=>{
                            if (oe.kind !== "leaf") return null;
                            const B = h.tree.nodes[oe.nodeId];
                            if (!(B != null && B.geneId)) return null;
                            const re = w.get(oe.nodeId), ge = u === oe.nodeId, fe = g.has(oe.nodeId), O = y === oe.nodeId ? "var(--tbrowse-row-select-bg)" : ge ? "var(--tbrowse-row-hover-bg)" : fe ? "var(--tbrowse-row-subtree-bg)" : null, F = oe.opacity ?? 1, z = oe.height - Wn * 2, U = oe.y + Wn, G = U + z / 2;
                            return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("g", {
                                opacity: F,
                                onMouseEnter: ()=>p(oe.nodeId),
                                onMouseLeave: ()=>p(null),
                                children: [
                                    O && /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                                        x: 0,
                                        y: oe.y,
                                        width: f,
                                        height: oe.height,
                                        fill: O
                                    }),
                                    re && Is({
                                        candidate: re,
                                        nodeId: oe.nodeId,
                                        geneId: B.geneId,
                                        drawingX: I,
                                        drawingWidth: _,
                                        rowY: U,
                                        rowH: z,
                                        midY: G,
                                        indicatorCx: pe,
                                        indicatorY: oe.y,
                                        indicatorH: oe.height,
                                        scale: N,
                                        panPx: m.panPx ?? 0,
                                        zoom: m.zoom ?? 1,
                                        shiftEff: re.shiftEff,
                                        anchorEff: re.anchorEff,
                                        state: m,
                                        data: h,
                                        onToggleIntron: J,
                                        onToggleFlip: ie,
                                        onTip: ue
                                    }),
                                    !re && (()=>{
                                        var R;
                                        return (B.geneId ? (R = h.geneStructureErrors) == null ? void 0 : R[B.geneId] : void 0) ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("g", {
                                            children: [
                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("text", {
                                                    x: pe,
                                                    y: G + 0.5,
                                                    textAnchor: "middle",
                                                    dominantBaseline: "middle",
                                                    fontSize: 13,
                                                    fontWeight: 700,
                                                    fill: "var(--tbrowse-danger)",
                                                    pointerEvents: "none",
                                                    children: "\u26A0"
                                                }),
                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                                                    x: pt,
                                                    y: oe.y,
                                                    width: gt,
                                                    height: oe.height,
                                                    fill: "transparent",
                                                    children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("title", {
                                                        children: "error fetching features"
                                                    })
                                                })
                                            ]
                                        }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("text", {
                                            x: I + _ / 2,
                                            y: G,
                                            textAnchor: "middle",
                                            dominantBaseline: "middle",
                                            fontSize: 11,
                                            fill: "var(--tbrowse-text-subtle)",
                                            pointerEvents: "none",
                                            children: "no gene structure"
                                        });
                                    })()
                                ]
                            }, `row-${oe.nodeId}`);
                        })
                    })
                }),
                ae && /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ss, {
                    tip: ae,
                    onClose: ()=>ue(null)
                })
            ]
        });
    };
    return {
        id: e.id,
        displayName: t,
        Header: i,
        Body: a,
        defaultWidth: n,
        minWidth: 200,
        defaultZoneState: o,
        isAvailable: (c)=>!!(c.geneStructures && Object.keys(c.geneStructures).length > 0),
        defaultVisible: !1,
        exclusiveGroup: "detail"
    };
}
function Is(e) {
    var oe;
    const { candidate: t, nodeId: n, geneId: o, drawingX: i, drawingWidth: a, rowY: c, rowH: s, midY: l, indicatorCx: f, indicatorY: h, indicatorH: u, scale: g, state: y, data: p, onToggleIntron: k, onToggleFlip: x, onTip: m } = e, { layout: b, flipped: E, userFlipped: T, geneStructure: I, transcript: _ } = t, M = b.startCodonEff ?? b.effMin;
    let $, W;
    if (g) $ = g.pxPerEff * e.zoom, W = i + g.startCodonPx + e.panPx + e.shiftEff * $;
    else {
        const B = Math.max(1, b.effMax - b.effMin);
        $ = a / B * e.zoom, W = i + (M - b.effMin) * $ + e.panPx + e.shiftEff * $;
    }
    const H = (B)=>E ? W - (B - M) * $ : W + (B - M) * $, w = s, N = Math.max(2, s * hs), v = c, L = c + (s - N) / 2, A = [];
    if (A.push(/* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
        x1: i,
        y1: l,
        x2: i + a,
        y2: l,
        stroke: "var(--tbrowse-text-subtle)",
        strokeOpacity: 0.25,
        strokeWidth: 0.75,
        pointerEvents: "none"
    }, "baseline")), b.startCodonEff !== void 0) {
        const B = H(e.anchorEff);
        A.push(/* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
            x1: B,
            y1: c - 1,
            x2: B,
            y2: c + s + 1,
            stroke: "var(--tbrowse-accent)",
            strokeOpacity: 0.55,
            strokeWidth: 1,
            pointerEvents: "none"
        }, "anchor"));
    }
    const J = (oe = p.genomeFeatures) == null ? void 0 : oe[o];
    if (J && J.length > 0) {
        const B = y.visibleFeatureKinds, re = c + s + 1, ge = Math.max(2, s * 0.25);
        for(let fe = 0; fe < J.length; fe++){
            const C = J[fe];
            if (B && !B.includes(C.kind) || C.end < b.gMin || C.start > b.gMax) continue;
            const O = Math.max(C.start, b.gMin), F = Math.min(C.end, b.gMax), z = Pn(b, O), U = Pn(b, F);
            let G = H(z), Y = H(U);
            Y < G && ([G, Y] = [
                Y,
                G
            ]);
            const R = Math.max(1.5, Y - G);
            A.push(/* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                x: G,
                y: re,
                width: R,
                height: ge,
                fill: gs(C),
                stroke: "var(--tbrowse-bg)",
                strokeWidth: 0.5,
                style: {
                    cursor: "pointer"
                },
                onClick: (K)=>{
                    K.stopPropagation(), m({
                        screenX: K.clientX,
                        screenY: K.clientY,
                        title: C.label ?? C.id,
                        lines: [
                            `${C.kind}${C.category ? ` \xb7 ${C.category}` : ""}`,
                            `${I.region}:${C.start.toLocaleString()}\u{2013}${C.end.toLocaleString()}`
                        ]
                    });
                }
            }, `feat-${fe}`));
        }
    }
    for(let B = 1; B < b.exons.length; B++){
        const re = b.exons[B - 1], ge = b.exons[B], fe = H(re.effEnd), C = H(ge.effStart), O = Math.min(fe, C), F = Math.max(fe, C);
        F <= O || A.push(/* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
            x1: O,
            y1: l,
            x2: F,
            y2: l,
            stroke: "var(--tbrowse-text-muted)",
            strokeWidth: 1,
            pointerEvents: "none"
        }, `intron-line-${re.exonIndex}-${ge.exonIndex}`));
    }
    for (const B of b.introns){
        const re = H(B.effStart), ge = H(B.effEnd), fe = Math.min(re, ge), C = Math.max(re, ge), O = Math.max(0, C - fe), F = (fe + C) / 2, z = Math.min(4, Math.max(2, O / 4));
        if (O > 6 && A.push(/* @__PURE__ */ (0, _jsxRuntime.jsx)("polyline", {
            points: `${F - z / 2},${l - 3} ${F + z / 2},${l} ${F - z / 2},${l + 3}`,
            fill: "none",
            stroke: "var(--tbrowse-text-muted)",
            strokeWidth: 1,
            pointerEvents: "none"
        }, `intron-${B.key}-c`)), B.realLength > vt) {
            const U = (B.realLength / 1e3).toLocaleString(void 0, {
                maximumFractionDigits: 1
            }), G = B.isCompressed ? `Intron (${U} kb) compressed \u{2014} click to expand` : `Intron (${U} kb) \u{2014} click to compress`, Y = Math.max(O, 14), R = F - Y / 2;
            A.push(/* @__PURE__ */ (0, _jsxRuntime.jsxs)("g", {
                onClick: (K)=>{
                    K.stopPropagation(), k(B.key);
                },
                style: {
                    cursor: "pointer"
                },
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                        x: R,
                        y: c,
                        width: Y,
                        height: s,
                        fill: "transparent"
                    }),
                    B.isCompressed ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("g", {
                        stroke: "var(--tbrowse-accent)",
                        strokeWidth: 1.2,
                        pointerEvents: "none",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                                x1: F - 2,
                                y1: l + 4,
                                x2: F,
                                y2: l - 4
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                                x1: F,
                                y1: l + 4,
                                x2: F + 2,
                                y2: l - 4
                            })
                        ]
                    }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("text", {
                        x: F,
                        y: l + 0.5,
                        textAnchor: "middle",
                        dominantBaseline: "middle",
                        fontSize: 11,
                        fontWeight: 700,
                        fontFamily: "ui-monospace, 'SF Mono', Menlo, monospace",
                        fill: "var(--tbrowse-accent)",
                        pointerEvents: "none",
                        children: "\u2194"
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("title", {
                        children: G
                    })
                ]
            }, `intron-${B.key}-hit`));
        }
    }
    const ie = I.transcripts.length > 1 ? I.transcripts.length : 0;
    for(let B = 0; B < b.exons.length; B++){
        const re = b.exons[B], ge = H(re.effStart), fe = H(re.effEnd), C = Math.min(ge, fe), O = Math.max(ge, fe), F = "hsl(210 50% 70%)", z = "hsl(210 60% 45%)";
        if (re.cdsEffStart === void 0 || re.cdsEffEnd === void 0) {
            const K = Math.max(1, O - C);
            A.push(/* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                x: C,
                y: L,
                width: K,
                height: N,
                fill: F,
                stroke: "var(--tbrowse-bg)",
                strokeWidth: 0.5,
                style: {
                    cursor: "pointer"
                },
                onClick: (Q)=>_n(Q, e, re, B, _, I, ie)
            }, `exon-${B}-utr`));
            continue;
        }
        const U = H(re.cdsEffStart), G = H(re.cdsEffEnd), Y = Math.min(U, G), R = Math.max(U, G);
        if (re.gStart < (re.cdsGStart ?? re.gStart) && A.push(/* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
            x: C,
            y: L,
            width: Math.max(1, Math.min(Y, R) - C),
            height: N,
            fill: F,
            stroke: "var(--tbrowse-bg)",
            strokeWidth: 0.5,
            pointerEvents: "none"
        }, `exon-${B}-utr-low`)), re.gEnd > (re.cdsGEnd ?? re.gEnd)) {
            const K = Math.max(Y, R);
            A.push(/* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                x: K,
                y: L,
                width: Math.max(1, O - K),
                height: N,
                fill: F,
                stroke: "var(--tbrowse-bg)",
                strokeWidth: 0.5,
                pointerEvents: "none"
            }, `exon-${B}-utr-high`));
        }
        A.push(/* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
            x: Y,
            y: v,
            width: Math.max(1, R - Y),
            height: w,
            fill: z,
            stroke: "var(--tbrowse-bg)",
            strokeWidth: 0.5,
            style: {
                cursor: "pointer"
            },
            onClick: (K)=>_n(K, e, re, B, _, I, ie)
        }, `exon-${B}-cds`));
    }
    const ue = (T ? I.strand === 1 ? -1 : 1 : I.strand) === 1 ? "+" : "\u2212", pe = I.strand === -1 ? E ? "Reverse-strand gene shown 5'\u21923' \u2014 click to view as transcribed" : "Reverse-strand gene shown as transcribed \u2014 click to flip 5'\u21923'" : E ? "Forward-strand gene mirrored \u2014 click to unflip" : "Forward-strand gene \u2014 click to mirror";
    return A.push(/* @__PURE__ */ (0, _jsxRuntime.jsxs)("g", {
        onClick: (B)=>{
            B.stopPropagation(), x(n);
        },
        style: {
            cursor: "pointer"
        },
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                x: pt,
                y: h,
                width: gt,
                height: u,
                fill: "transparent"
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("text", {
                x: f,
                y: h + u / 2 + 0.5,
                textAnchor: "middle",
                dominantBaseline: "middle",
                fontSize: 13,
                fontWeight: 700,
                fontFamily: "ui-monospace, 'SF Mono', Menlo, monospace",
                fill: "var(--tbrowse-text-muted)",
                pointerEvents: "none",
                children: ue
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("title", {
                children: pe
            })
        ]
    }, "indicator")), /* @__PURE__ */ (0, _jsxRuntime.jsx)("g", {
        children: A
    });
}
function _n(e, t, n, o, i, a, c) {
    e.stopPropagation();
    const s = [];
    if (s.push(`exon ${o + 1} of ${i.exons.length}`), s.push(`${a.region}:${n.gStart.toLocaleString()}\u{2013}${n.gEnd.toLocaleString()}`), n.cdsGStart !== void 0 && n.cdsGEnd !== void 0 ? s.push(`CDS ${n.cdsGStart.toLocaleString()}\u{2013}${n.cdsGEnd.toLocaleString()}`) : s.push("UTR only"), c > 1) {
        const l = a.transcripts.filter((f)=>f.id !== i.id).slice(0, 6).map((f)=>`${f.id}${f.biotype ? ` (${f.biotype})` : ""}`);
        l.length > 0 && s.push(`alt transcripts: ${l.join(", ")}`);
    }
    t.onTip({
        screenX: e.clientX,
        screenY: e.clientY,
        title: `${a.name ?? t.geneId} \xb7 ${i.id}`,
        lines: s
    });
}
function Ss({ tip: e, onClose: t }) {
    const n = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        const l = (h)=>{
            n.current && (n.current.contains(h.target) || t());
        }, f = setTimeout(()=>document.addEventListener("mousedown", l), 0);
        return ()=>{
            clearTimeout(f), document.removeEventListener("mousedown", l);
        };
    }, [
        t
    ]);
    const o = 8, i = 280, a = 140, c = Math.min(e.screenX + 12, window.innerWidth - i - o), s = Math.min(e.screenY + 12, window.innerHeight - a - o);
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        ref: n,
        style: {
            position: "fixed",
            left: c,
            top: s,
            zIndex: 2e3,
            background: "var(--tbrowse-bg-elevated)",
            border: "1px solid var(--tbrowse-border)",
            borderRadius: 6,
            boxShadow: "0 4px 12px var(--tbrowse-tooltip-shadow)",
            padding: "8px 10px",
            fontSize: 12,
            color: "var(--tbrowse-text)",
            maxWidth: 320,
            minWidth: 200
        },
        onClick: (l)=>l.stopPropagation(),
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    display: "flex",
                    alignItems: "baseline",
                    justifyContent: "space-between",
                    marginBottom: 6,
                    gap: 8
                },
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            fontWeight: 600
                        },
                        children: e.title
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        onClick: t,
                        "aria-label": "Close",
                        style: {
                            background: "none",
                            border: "none",
                            color: "var(--tbrowse-text-muted)",
                            fontSize: 14,
                            cursor: "pointer",
                            padding: 0,
                            lineHeight: 1
                        },
                        children: "\xd7"
                    })
                ]
            }),
            e.lines.map((l, f)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        color: "var(--tbrowse-text-muted)",
                        fontSize: 11,
                        fontFamily: 'ui-monospace, "SF Mono", Menlo, monospace'
                    },
                    children: l
                }, f))
        ]
    });
}
const Rt = 4, Nn = 2, Kt = 1, jt = 32, Hn = 1.5, ks = 1.45, Es = 2.2, Ms = 24;
function Cs(e, t) {
    if (e < 0) return ".";
    if (e === 0) {
        const i = t == null ? void 0 : t.ref;
        return i && i.length > 0 ? i[0] : "?";
    }
    const n = t == null ? void 0 : t.alt;
    if (!n || e - 1 >= n.length) return "?";
    const o = n[e - 1];
    return o && o.length > 0 ? o[0] : "?";
}
function Ls(e, t) {
    if (e < 0) return ".";
    if (e === 0) return (t == null ? void 0 : t.ref) ?? "?";
    const n = t == null ? void 0 : t.alt;
    return !n || e - 1 >= n.length ? "?" : n[e - 1] ?? "?";
}
function Ts(e) {
    return e ? !!(e.ref && e.ref.length > 1 || e.alt && e.alt.some((t)=>t.length > 1)) : !1;
}
function qs(e, t, n) {
    if (!(t != null && t.ref) && (!(t != null && t.alt) || t.alt.length === 0) || e.alleles.length === 0) return n;
    const o = e.phased ? "|" : "/";
    return e.alleles.map((i)=>Ls(i, t)).join(o);
}
function Rs(e, t, n, o, i = Ms) {
    if (!(t != null && t.ref) && !(t != null && t.alt) || e.alleles.length === 0) return null;
    if (e.missing && e.alleles.every((c)=>c < 0)) return ".";
    const a = e.alleles.map((c)=>Cs(c, t));
    return n && e.phased && o >= i ? a.join("|") : a.join("");
}
function Fn(e) {
    return e.position === void 0 ? e.id : `${e.reference ?? ""}${e.reference ? ":" : ""}${e.position.toLocaleString()}`;
}
function $s(e) {
    return e.altDosage >= 2 ? "#ffffff" : "#1a2733";
}
const As = {
    zoom: 1,
    panPx: 0,
    showPhasing: !1
}, Zt = "tbrowse:gtmatrix-hover-variant";
function al(e) {
    const t = e.displayName ?? "Genotypes", n = e.defaultWidth ?? 30, o = e.minWidth ?? 200, i = {
        ...As,
        ...e.initial
    }, a = e.matrix, c = a.sepPhased ?? (0, _tbrowseCore.DEFAULT_SEP_PHASED), s = a.sepUnphased ?? (0, _tbrowseCore.DEFAULT_SEP_UNPHASED), l = a.unknownString ?? (0, _tbrowseCore.DEFAULT_UNKNOWN), f = a.variants.length, h = (g)=>{
        const { zoneState: y, setZoneState: p, hoveredNodeId: k, data: x } = g, m = y ?? i, [b, E] = (0, _react.useState)(null);
        (0, _react.useEffect)(()=>{
            const H = (w)=>{
                const N = w;
                N.detail.id === e.id && E(N.detail.idx);
            };
            return window.addEventListener(Zt, H), ()=>window.removeEventListener(Zt, H);
        }, []);
        const T = `${f} variants${a.regionLabel ? ` \xb7 ${a.regionLabel}` : ""}`, I = (()=>{
            if (!k) return null;
            const H = x.tree.nodes[k], w = H == null ? void 0 : H.geneId;
            if (!w) return null;
            const N = a.callsByGeneId[w];
            if (!N) return null;
            if (b === null || b < 0 || b >= f) return `${w} \xb7 ${N.length} variants`;
            const v = a.variants[b], L = N[b] ?? l, A = (0, _tbrowseCore.decodeCall)(L, c, s, l), J = qs(A, v, L), ie = [
                w,
                Fn(v),
                J
            ];
            if (Ts(v)) {
                const ae = v.alt && v.alt.length > 0 ? v.alt.join(",") : "?";
                ie.push(`REF=${v.ref ?? "?"} ALT=${ae}`);
            }
            return ie.join(" \xb7 ");
        })(), _ = (H)=>({
                fontSize: 11,
                padding: "1px 6px",
                border: `1px solid ${H ? "var(--tbrowse-accent)" : "var(--tbrowse-border)"}`,
                background: H ? "var(--tbrowse-accent-soft)" : "var(--tbrowse-bg-input)",
                color: H ? "var(--tbrowse-accent-strong)" : "var(--tbrowse-text)",
                borderRadius: 3,
                cursor: "pointer"
            }), M = {
            display: "inline-flex",
            border: "1px solid var(--tbrowse-border)",
            borderRadius: 3,
            overflow: "hidden"
        }, $ = (H)=>({
                fontSize: 11,
                padding: "1px 6px",
                border: "none",
                borderRight: H === "first" ? "1px solid var(--tbrowse-border)" : "none",
                background: "var(--tbrowse-bg-input)",
                color: "var(--tbrowse-text)",
                cursor: "pointer",
                fontFamily: "inherit"
            }), W = (m.panPx ?? 0) === 0 && (m.zoom ?? 1) === 1;
        return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
            "data-genotype-matrix-zone-header": e.id,
            style: {
                height: "100%",
                display: "flex",
                flexDirection: "column",
                gap: 4,
                fontSize: 13,
                color: "var(--tbrowse-text)"
            },
            children: [
                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                    style: {
                        flex: 1,
                        minHeight: 0,
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        padding: "0 10px 0 14px",
                        flexWrap: "nowrap",
                        overflow: "hidden"
                    },
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)(nt, {
                            defaultName: t,
                            customName: m.name,
                            onChange: (H)=>p((w)=>({
                                        ...w ?? i,
                                        name: H
                                    }))
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            onClick: ()=>p((H)=>({
                                        ...H ?? i,
                                        showPhasing: !(H ?? i).showPhasing
                                    })),
                            style: _(m.showPhasing),
                            title: m.showPhasing ? "Phasing notches shown \u2014 click to hide" : "Phasing notches hidden \u2014 click to show",
                            children: c
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                            style: M,
                            role: "group",
                            "aria-label": "Zoom",
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>p((H)=>{
                                            const w = H ?? i, N = w.zoom ?? 1, v = Math.max(Kt, N / Hn);
                                            if (v === N) return w;
                                            const L = w.panPx ?? 0;
                                            return {
                                                ...w,
                                                zoom: v,
                                                panPx: L * (v / N)
                                            };
                                        }),
                                    disabled: (m.zoom ?? 1) <= Kt + 1e-6,
                                    style: $("first"),
                                    title: "Zoom out",
                                    children: "\u2212"
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>p((H)=>{
                                            const w = H ?? i, N = w.zoom ?? 1, v = Math.min(jt, N * Hn);
                                            if (v === N) return w;
                                            const L = w.panPx ?? 0;
                                            return {
                                                ...w,
                                                zoom: v,
                                                panPx: L * (v / N)
                                            };
                                        }),
                                    disabled: (m.zoom ?? 1) >= jt - 1e-6,
                                    style: $("last"),
                                    title: "Zoom in",
                                    children: "+"
                                })
                            ]
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            onClick: ()=>p((H)=>({
                                        ...H ?? i,
                                        panPx: 0,
                                        zoom: 1
                                    })),
                            disabled: W,
                            style: {
                                ..._(!W),
                                opacity: W ? 0.5 : 1
                            },
                            title: "Reset pan and zoom",
                            children: (m.zoom ?? 1) !== 1 ? `${(m.zoom ?? 1).toFixed(2).replace(/\.?0+$/, "")}\xd7` : "fit"
                        })
                    ]
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        flex: "0 0 18px",
                        minHeight: 0,
                        padding: "0 10px 0 14px",
                        display: "flex",
                        alignItems: "center",
                        fontSize: 11,
                        color: "var(--tbrowse-text-muted)",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis"
                    },
                    title: I ?? "",
                    children: I ?? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                        style: {
                            color: "var(--tbrowse-text-subtle)"
                        },
                        children: T
                    })
                })
            ]
        });
    }, u = (g)=>{
        var Y;
        const { visibleRows: y, rowRange: p, width: k, data: x, hoveredNodeId: m, hoveredSubtreeIds: b, selectedNodeId: E, onHoverNode: T, zoneState: I, setZoneState: _, prunedNodeIds: M } = g, $ = I ?? i, W = Le((R)=>R.fontSize), H = Math.max(8, Math.round(W * 0.92)), w = H * ks, N = H * Es, v = (0, _react.useRef)(null), L = (0, _react.useRef)(null), A = (0, _react.useMemo)(()=>(0, _tbrowseCore.rowsTotalHeight)(y), [
            y
        ]), J = Math.max(1, k - 2 * Rt), ae = (f > 0 ? J / f : 0) * $.zoom, ue = (0, _react.useMemo)(()=>(0, _tbrowseCore.buildChildrenIndex)(x.tree), [
            x.tree
        ]), pe = (0, _react.useMemo)(()=>{
            const R = /* @__PURE__ */ new Map();
            return (K)=>{
                const Q = R.get(K);
                if (Q) return Q;
                const se = (0, _tbrowseCore.subtreeIdsOf)(K, ue), le = [];
                for (const te of se){
                    if (M.has(te)) continue;
                    const V = x.tree.nodes[te];
                    V != null && V.isLeaf && V.geneId && a.callsByGeneId[V.geneId] && le.push(V.geneId);
                }
                return R.set(K, le), le;
            };
        }, [
            x.tree,
            ue,
            M
        ]);
        (0, _react.useEffect)(()=>{
            const R = L.current;
            if (!R || f === 0 || k <= 0 || A <= 0) return;
            const K = window.devicePixelRatio || 1;
            R.width = Math.floor(k * K), R.height = Math.floor(A * K), R.style.width = `${k}px`, R.style.height = `${A}px`;
            const Q = R.getContext("2d");
            if (!Q) return;
            Q.setTransform(K, 0, 0, K, 0, 0), Q.clearRect(0, 0, k, A);
            const se = (0, _tbrowseCore.rowsInRange)(y, p), le = Rt - $.panPx, te = ae >= w;
            te && (Q.font = `${H}px ui-monospace, "SF Mono", Menlo, monospace`, Q.textAlign = "center", Q.textBaseline = "middle");
            const V = ae > 0 ? Math.max(0, Math.floor(-le / ae)) : 0, ne = ae > 0 ? Math.min(f - 1, Math.ceil((k - le) / ae)) : f - 1;
            for (const de of se){
                const me = de.height - Nn * 2, we = de.y + Nn;
                if (de.kind === "leaf") {
                    const ke = x.tree.nodes[de.nodeId], Re = ke == null ? void 0 : ke.geneId, Ae = Re ? a.callsByGeneId[Re] : void 0;
                    if (!Ae) {
                        Q.fillStyle = "rgba(0,0,0,0.025)", Q.fillRect(0, de.y, k, de.height);
                        continue;
                    }
                    Q.globalAlpha = de.opacity ?? 1;
                    for(let _e = V; _e <= ne; _e++){
                        const Fe = le + _e * ae, Xe = Math.max(1, ae + 1), Be = (0, _tbrowseCore.decodeCall)(Ae[_e], c, s, l);
                        if (Q.fillStyle = (0, _tbrowseCore.colorForCall)(Be), Q.fillRect(Math.floor(Fe), we, Math.ceil(Xe), me), te) {
                            const Ne = Rs(Be, a.variants[_e], $.showPhasing, ae, N);
                            Ne && (Q.fillStyle = $s(Be), Q.fillText(Ne, Math.floor(Fe) + ae / 2, we + me / 2));
                        }
                        $.showPhasing && Be.phased && ae > 4 && !Be.missing && (Q.fillStyle = "rgba(0,0,0,0.4)", Q.fillRect(Math.floor(Fe + ae / 2 - 0.5), we, 1, me));
                    }
                    Q.globalAlpha = 1;
                } else {
                    const ke = pe(de.nodeId);
                    if (ke.length === 0) {
                        Q.fillStyle = "rgba(0,0,0,0.025)", Q.fillRect(0, de.y, k, de.height);
                        continue;
                    }
                    Q.globalAlpha = (de.opacity ?? 1) * 0.85;
                    for(let Re = V; Re <= ne; Re++){
                        const Ae = le + Re * ae, _e = Math.max(1, ae + 1), Fe = (0, _tbrowseCore.averageDosage)(a, ke, Re, c, s, l);
                        Q.fillStyle = Fe === null ? "#ececec" : (0, _tbrowseCore.colorForAverageDosage)(Fe), Q.fillRect(Math.floor(Ae), we, Math.ceil(_e), me);
                    }
                    Q.globalAlpha = 1;
                }
            }
        }, [
            y,
            p,
            k,
            A,
            ae,
            H,
            w,
            N,
            $.panPx,
            $.showPhasing,
            x.tree,
            pe
        ]);
        const oe = (R)=>{
            const K = v.current;
            if (!K) return {
                row: null,
                variantIdx: null
            };
            const Q = K.getBoundingClientRect(), se = R.clientX - Q.left, le = R.clientY - Q.top;
            let te = null;
            for (const ne of (0, _tbrowseCore.rowsInRange)(y, p))if (le >= ne.y && le < ne.y + ne.height) {
                te = ne;
                break;
            }
            let V = null;
            if (ae > 0) {
                const ne = Math.floor((se + $.panPx - Rt) / ae);
                ne >= 0 && ne < f && (V = ne);
            }
            return {
                row: te,
                variantIdx: V
            };
        }, B = (R)=>{
            window.dispatchEvent(new CustomEvent(Zt, {
                detail: {
                    id: e.id,
                    idx: R
                }
            }));
        }, re = (R)=>{
            const { row: K, variantIdx: Q } = oe(R);
            T((K == null ? void 0 : K.nodeId) ?? null), B(Q);
        }, ge = ()=>{
            T(null), B(null);
        }, [fe, C] = (0, _react.useState)(null);
        (0, _react.useEffect)(()=>{
            if (!fe) return;
            const R = (K)=>{
                K.key === "Escape" && C(null);
            };
            return window.addEventListener("keydown", R), ()=>window.removeEventListener("keydown", R);
        }, [
            fe
        ]);
        const O = (R)=>{
            var we;
            if ((we = z.current) != null && we.engaged) return;
            const { row: K, variantIdx: Q } = oe(R);
            if (!K || K.kind !== "leaf" || Q === null) return;
            const se = x.tree.nodes[K.nodeId], le = se == null ? void 0 : se.geneId;
            if (!le) return;
            const te = a.callsByGeneId[le];
            if (!te) return;
            const V = a.variants[Q], ne = te[Q] ?? l, de = (0, _tbrowseCore.decodeCall)(ne, c, s, l), me = [];
            if (me.push(`sample: ${le}`), me.push(`variant: ${Fn(V)}`), me.push(`call: ${ne}${de.phased ? " (phased)" : ""}`), V.ref || V.alt && V.alt.length > 0) {
                const ke = V.alt && V.alt.length > 0 ? V.alt.join(",") : "?";
                me.push(`alleles: ${V.ref ?? "?"} \u{2192} ${ke}`);
            }
            V.alleleFrequency !== void 0 && me.push(`AF: ${V.alleleFrequency.toFixed(3)}`), me.push(`alt dosage: ${de.altDosage}`), C({
                screenX: R.clientX,
                screenY: R.clientY,
                title: V.id,
                lines: me
            });
        }, F = 4, z = (0, _react.useRef)(null), U = (R)=>{
            if (R.button !== 0) return;
            z.current = {
                startX: R.clientX,
                startPan: $.panPx ?? 0,
                engaged: !1
            };
            const K = (se)=>{
                if (!z.current) return;
                const le = se.clientX - z.current.startX;
                if (!z.current.engaged) {
                    if (Math.abs(le) < F) return;
                    z.current.engaged = !0;
                }
                _((te)=>({
                        ...te ?? i,
                        panPx: z.current.startPan - le
                    }));
            }, Q = ()=>{
                document.removeEventListener("mousemove", K), document.removeEventListener("mouseup", Q), queueMicrotask(()=>{
                    z.current = null;
                });
            };
            document.addEventListener("mousemove", K), document.addEventListener("mouseup", Q);
        };
        (0, _react.useEffect)(()=>{
            const R = v.current;
            if (!R) return;
            const K = (Q)=>{
                if (!Q.ctrlKey && !Q.metaKey) return;
                Q.preventDefault();
                const se = R.getBoundingClientRect(), le = Q.clientX - se.left, te = Math.exp(-Q.deltaY * 0.01);
                _((V)=>{
                    const ne = V ?? i, de = ne.zoom ?? 1, me = Math.max(Kt, Math.min(jt, de * te));
                    if (me === de) return ne;
                    const we = ne.panPx ?? 0, ke = le - Rt, Ae = (ke + we) * me / de - ke;
                    return {
                        ...ne,
                        zoom: me,
                        panPx: Ae
                    };
                });
            };
            return R.addEventListener("wheel", K, {
                passive: !1
            }), ()=>R.removeEventListener("wheel", K);
        }, [
            _
        ]);
        const G = Cr(y, p, {
            hoveredNodeId: m,
            hoveredSubtreeIds: b,
            selectedNodeId: E
        });
        return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                    ref: v,
                    onMouseDown: U,
                    onMouseMove: re,
                    onMouseLeave: ge,
                    onClick: O,
                    style: {
                        position: "relative",
                        width: k,
                        height: A,
                        overflow: "hidden",
                        cursor: (Y = z.current) != null && Y.engaged ? "grabbing" : "crosshair"
                    },
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("canvas", {
                            ref: L,
                            style: {
                                display: "block",
                                position: "absolute",
                                inset: 0
                            }
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("svg", {
                            width: k,
                            height: A,
                            style: {
                                position: "absolute",
                                inset: 0,
                                pointerEvents: "none"
                            },
                            children: G.map(({ row: R, background: K })=>K === "transparent" ? null : /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                                    x: 0,
                                    y: R.y,
                                    width: k,
                                    height: R.height,
                                    fill: K,
                                    opacity: 0.4
                                }, `tint-${R.nodeId}`))
                        })
                    ]
                }),
                fe && /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ps, {
                    tip: fe,
                    onClose: ()=>C(null)
                })
            ]
        });
    };
    return {
        id: e.id,
        displayName: t,
        Header: h,
        Body: u,
        defaultWidth: n,
        minWidth: o,
        defaultZoneState: i,
        // The matrix is bound at construction (it's not a HostData field), so
        // availability is a property of the matrix rather than of `data`.
        isAvailable: ()=>f > 0 && Object.keys(a.callsByGeneId).length > 0,
        defaultVisible: e.defaultVisible,
        // One of the per-leaf detail tracks (msa / neighborhood / genome /
        // genotypes) — only one shows at a time unless the user unlinks them.
        exclusiveGroup: "detail"
    };
}
function Ps({ tip: e, onClose: t }) {
    const n = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        const l = (h)=>{
            n.current && (n.current.contains(h.target) || t());
        }, f = setTimeout(()=>document.addEventListener("mousedown", l), 0);
        return ()=>{
            clearTimeout(f), document.removeEventListener("mousedown", l);
        };
    }, [
        t
    ]);
    const o = 8, i = 280, a = 140, c = Math.min(e.screenX + 12, window.innerWidth - i - o), s = Math.min(e.screenY + 12, window.innerHeight - a - o);
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        ref: n,
        style: {
            position: "fixed",
            left: c,
            top: s,
            zIndex: 2e3,
            background: "var(--tbrowse-bg-elevated)",
            border: "1px solid var(--tbrowse-border)",
            borderRadius: 6,
            boxShadow: "0 4px 12px var(--tbrowse-tooltip-shadow)",
            padding: "8px 10px",
            fontSize: 12,
            color: "var(--tbrowse-text)",
            maxWidth: 320,
            minWidth: 200
        },
        onClick: (l)=>l.stopPropagation(),
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    display: "flex",
                    alignItems: "baseline",
                    justifyContent: "space-between",
                    marginBottom: 6,
                    gap: 8
                },
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            fontWeight: 600
                        },
                        children: e.title
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        onClick: t,
                        "aria-label": "Close",
                        style: {
                            background: "none",
                            border: "none",
                            color: "var(--tbrowse-text-muted)",
                            fontSize: 14,
                            cursor: "pointer",
                            padding: 0,
                            lineHeight: 1
                        },
                        children: "\xd7"
                    })
                ]
            }),
            e.lines.map((l, f)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        color: "var(--tbrowse-text-muted)",
                        fontSize: 11,
                        fontFamily: 'ui-monospace, "SF Mono", Menlo, monospace'
                    },
                    children: l
                }, f))
        ]
    });
}
const Ws = [
    {
        id: "blue",
        label: "Blue",
        kind: "sequential",
        light: [
            [
                240,
                244,
                250
            ],
            [
                40,
                120,
                220
            ]
        ],
        dark: [
            [
                40,
                50,
                65
            ],
            [
                120,
                180,
                250
            ]
        ]
    },
    {
        id: "orange",
        label: "Orange",
        kind: "sequential",
        light: [
            [
                255,
                245,
                235
            ],
            [
                217,
                95,
                14
            ]
        ],
        dark: [
            [
                55,
                40,
                25
            ],
            [
                255,
                160,
                80
            ]
        ]
    },
    {
        id: "purple",
        label: "Purple",
        kind: "sequential",
        light: [
            [
                247,
                242,
                252
            ],
            [
                106,
                81,
                163
            ]
        ],
        dark: [
            [
                40,
                30,
                55
            ],
            [
                180,
                140,
                230
            ]
        ]
    },
    {
        id: "green",
        label: "Green",
        kind: "sequential",
        light: [
            [
                240,
                250,
                240
            ],
            [
                35,
                139,
                69
            ]
        ],
        dark: [
            [
                30,
                55,
                40
            ],
            [
                120,
                200,
                140
            ]
        ]
    },
    {
        id: "gray",
        label: "Grayscale",
        kind: "sequential",
        light: [
            [
                245,
                245,
                245
            ],
            [
                80,
                80,
                80
            ]
        ],
        dark: [
            [
                40,
                42,
                48
            ],
            [
                200,
                200,
                200
            ]
        ]
    }
], Ds = [
    {
        id: "rdbu",
        label: "Red \u2194 Blue",
        kind: "diverging",
        light: [
            [
                178,
                24,
                43
            ],
            [
                247,
                247,
                247
            ],
            [
                33,
                102,
                172
            ]
        ],
        dark: [
            [
                230,
                90,
                90
            ],
            [
                40,
                42,
                48
            ],
            [
                110,
                170,
                230
            ]
        ]
    },
    {
        id: "rdylbu",
        label: "Red \u2194 Yellow \u2194 Blue",
        kind: "diverging",
        light: [
            [
                215,
                48,
                39
            ],
            [
                255,
                255,
                191
            ],
            [
                69,
                117,
                180
            ]
        ],
        dark: [
            [
                230,
                90,
                80
            ],
            [
                220,
                220,
                170
            ],
            [
                110,
                150,
                210
            ]
        ]
    },
    {
        id: "brbg",
        label: "Brown \u2194 Teal",
        kind: "diverging",
        light: [
            [
                140,
                81,
                10
            ],
            [
                245,
                245,
                245
            ],
            [
                1,
                102,
                94
            ]
        ],
        dark: [
            [
                200,
                150,
                90
            ],
            [
                40,
                42,
                48
            ],
            [
                80,
                180,
                170
            ]
        ]
    },
    {
        id: "puor",
        label: "Purple \u2194 Orange",
        kind: "diverging",
        light: [
            [
                94,
                60,
                153
            ],
            [
                247,
                247,
                247
            ],
            [
                230,
                97,
                1
            ]
        ],
        dark: [
            [
                160,
                130,
                200
            ],
            [
                40,
                42,
                48
            ],
            [
                240,
                160,
                90
            ]
        ]
    }
], mt = [
    ...Ws,
    ...Ds
], mo = "blue", Os = "rdbu", Dt = new Map(mt.map((e)=>[
        e.id,
        e
    ]));
function cn(e) {
    if (e) {
        const t = Dt.get(e);
        if (t) return t;
    }
    return Dt.get(mo);
}
function bo(e) {
    return e.min < 0 && e.max > 0 ? Dt.get(Os) : Dt.get(mo);
}
function _s(e, t) {
    const n = {};
    for (const o of t){
        let i = 1 / 0, a = -1 / 0, c = !1;
        for (const s of Object.values(e)){
            const l = s == null ? void 0 : s[o];
            typeof l == "number" && Number.isFinite(l) && (c = !0, l < i && (i = l), l > a && (a = l));
        }
        c && (n[o] = {
            min: i,
            max: a
        });
    }
    return n;
}
function Ns(e, t, n, o, i = 0) {
    if (!Number.isFinite(e)) return null;
    const a = o === "dark" ? n.dark : n.light;
    if (n.kind === "sequential") {
        const l = Jt(e, t.min, t.max);
        return Qt(a[0], a[a.length - 1], l);
    }
    const c = Math.min(t.min, i), s = Math.max(t.max, i);
    if (e <= i) {
        if (c === i) return a[1];
        const l = Jt(e, c, i);
        return Qt(a[0], a[1], l);
    } else {
        if (s === i) return a[1];
        const l = Jt(e, i, s);
        return Qt(a[1], a[2], l);
    }
}
function Jt(e, t, n) {
    return t === n ? 0.5 : e <= t ? 0 : e >= n ? 1 : (e - t) / (n - t);
}
function Qt(e, t, n) {
    return [
        Math.round(e[0] + (t[0] - e[0]) * n),
        Math.round(e[1] + (t[1] - e[1]) * n),
        Math.round(e[2] + (t[2] - e[2]) * n)
    ];
}
function Hs(e) {
    return `rgb(${e[0]}, ${e[1]}, ${e[2]})`;
}
function Fs(e, t) {
    const n = (0.2126 * e[0] + 0.7152 * e[1] + 0.0722 * e[2]) / 255;
    return t === "dark" ? n < 0.5 ? "#e7e9ed" : "#0e1116" : n > 0.55 ? "#222222" : "#ffffff";
}
const dt = [
    {
        id: "text",
        label: "Text",
        supports: [
            "number",
            "boolean",
            "string"
        ]
    },
    {
        id: "heatmap",
        label: "Heatmap",
        supports: [
            "number"
        ]
    }
], zn = [
    "string",
    "number",
    "boolean"
];
function zs({ factoryColumns: e, state: t, setState: n, orderedIds: o, heatmapDomains: i }) {
    const [a, c] = (0, _react.useState)(!1), [s, l] = (0, _react.useState)(null), f = (0, _react.useRef)(null), h = Le((w)=>w.theme), u = new Map(e.map((w)=>[
            w.id,
            w
        ])), g = o.map((w)=>{
        var ge, fe;
        const N = u.get(w);
        if (!N) return null;
        const v = ((ge = t.columnOverrides) == null ? void 0 : ge[w]) ?? {}, L = v.kind ?? N.kind ?? "string", A = N.display ?? "text", J = v.display ?? A, ie = (fe = dt.find((C)=>C.id === J)) != null && fe.supports.includes(L) ? J : "text", ae = !!N.aggregate, ue = ae ? "__factory__" : (0, _tbrowseCore.methodForKind)(L, v.aggregateMethod).id, pe = i[w] ?? null, oe = v.palette ?? N.palette, B = oe ? cn(oe) : pe ? bo(pe) : null, re = v.paletteMidpoint ?? N.paletteMidpoint ?? 0;
        return {
            base: N,
            hidden: v.hidden ?? !1,
            label: v.label ?? N.label,
            kind: L,
            display: ie,
            aggregateMethodId: ue,
            aggregateLocked: ae,
            searchable: v.searchable ?? N.searchable ?? !1,
            palette: B,
            paletteMidpoint: re,
            domain: pe
        };
    }).filter((w)=>w !== null), y = ()=>{
        if (!a && f.current) {
            const w = f.current.getBoundingClientRect(), N = f.current.closest("[data-table-zone-header]"), v = N == null ? void 0 : N.getBoundingClientRect(), L = v ? Math.max(0, window.innerWidth - v.right) : Math.max(0, window.innerWidth - w.right), A = v ? v.right - v.left : 540, J = Math.max(120, A);
            l({
                right: L,
                top: w.bottom + 4,
                maxWidth: J
            });
        }
        c((w)=>!w);
    };
    (0, _react.useEffect)(()=>{
        if (!a) return;
        const w = (v)=>{
            var J;
            const L = v.target;
            if ((J = f.current) != null && J.contains(L)) return;
            const A = document.querySelector(".tbrowse-table-config");
            A != null && A.contains(L) || c(!1);
        }, N = (v)=>{
            v.key === "Escape" && c(!1);
        };
        return document.addEventListener("mousedown", w), document.addEventListener("keydown", N), ()=>{
            document.removeEventListener("mousedown", w), document.removeEventListener("keydown", N);
        };
    }, [
        a
    ]);
    const p = (w, N)=>{
        n((v)=>{
            const L = v.columnOverrides ?? {}, A = L[w] ?? {}, ie = {
                ...typeof N == "function" ? N(A) : {
                    ...A,
                    ...N
                }
            };
            Object.keys(ie).forEach((pe)=>{
                ie[pe] === void 0 && delete ie[pe];
            });
            const ae = Object.keys(ie).length === 0, ue = {
                ...L
            };
            return ae ? delete ue[w] : ue[w] = ie, {
                ...v,
                columnOverrides: ue
            };
        });
    }, k = (w, N)=>{
        const v = o.indexOf(w);
        if (v < 0) return;
        const L = v + N;
        if (L < 0 || L >= o.length) return;
        const A = o.slice();
        [A[v], A[L]] = [
            A[L],
            A[v]
        ], n((J)=>({
                ...J,
                columnOrder: A
            }));
    }, x = (w)=>{
        n((N)=>{
            const v = {
                ...N.columnOverrides ?? {}
            };
            for (const L of g){
                const J = {
                    ...v[L.base.id] ?? {},
                    hidden: !w
                };
                w && delete J.hidden, Object.keys(J).length === 0 ? delete v[L.base.id] : v[L.base.id] = J;
            }
            return {
                ...N,
                columnOverrides: v
            };
        });
    }, m = (w)=>{
        n((N)=>{
            var L;
            const v = {
                ...N.columnOverrides ?? {}
            };
            for (const A of g){
                if (!((L = dt.find((pe)=>pe.id === w)) == null ? void 0 : L.supports.includes(A.kind))) continue;
                const ie = v[A.base.id] ?? {}, ae = A.base.display ?? "text", ue = {
                    ...ie
                };
                w === ae ? delete ue.display : ue.display = w, Object.keys(ue).length === 0 ? delete v[A.base.id] : v[A.base.id] = ue;
            }
            return {
                ...N,
                columnOverrides: v
            };
        });
    }, b = (w)=>{
        n((N)=>{
            const v = {
                ...N.columnOverrides ?? {}
            };
            for (const L of g){
                const A = v[L.base.id] ?? {}, J = L.base.kind ?? "string", ie = {
                    ...A
                };
                w === J ? delete ie.kind : ie.kind = w, ie.kind !== L.kind && delete ie.aggregateMethod, Object.keys(ie).length === 0 ? delete v[L.base.id] : v[L.base.id] = ie;
            }
            return {
                ...N,
                columnOverrides: v
            };
        });
    }, E = (w)=>{
        n((N)=>{
            const v = {
                ...N.columnOverrides ?? {}
            };
            for (const L of g){
                if (L.kind !== "number") continue;
                const J = {
                    ...v[L.base.id] ?? {},
                    palette: w
                };
                w === L.base.palette && delete J.palette, Object.keys(J).length === 0 ? delete v[L.base.id] : v[L.base.id] = J;
            }
            return {
                ...N,
                columnOverrides: v
            };
        });
    }, T = (w)=>{
        n((N)=>{
            const v = {
                ...N.columnOverrides ?? {}
            };
            for (const L of g){
                if (L.kind !== "string") continue;
                const A = v[L.base.id] ?? {}, J = L.base.searchable ?? !1, ie = {
                    ...A
                };
                w === J ? delete ie.searchable : ie.searchable = w, Object.keys(ie).length === 0 ? delete v[L.base.id] : v[L.base.id] = ie;
            }
            return {
                ...N,
                columnOverrides: v
            };
        });
    }, I = ()=>{
        n((w)=>({
                ...w,
                columnOverrides: void 0,
                columnOrder: void 0
            }));
    }, _ = g.filter((w)=>!w.hidden).length, M = g.filter((w)=>{
        var N;
        return (N = dt.find((v)=>v.id === "heatmap")) == null ? void 0 : N.supports.includes(w.kind);
    }), $ = M.length > 0 && M.every((w)=>w.display === "heatmap"), W = g.filter((w)=>w.kind === "string"), H = W.length > 0 && W.every((w)=>w.searchable);
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                ref: f,
                type: "button",
                onClick: y,
                title: "Configure columns",
                style: {
                    display: "inline-flex",
                    alignItems: "center",
                    padding: "3px 6px",
                    borderRadius: 3,
                    border: "1px solid var(--tbrowse-border)",
                    background: a ? "var(--tbrowse-accent-soft)" : "var(--tbrowse-bg-input)",
                    color: "var(--tbrowse-text)",
                    cursor: "pointer"
                },
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(yt, {})
            }),
            a && s && (0, _reactDom.createPortal)(/* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                className: `tbrowse-root tbrowse-theme-${h}`,
                children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                    className: "tbrowse-table-config",
                    style: {
                        position: "fixed",
                        right: s.right,
                        top: s.top,
                        boxSizing: "border-box",
                        background: "var(--tbrowse-bg-elevated)",
                        border: "1px solid var(--tbrowse-border)",
                        color: "var(--tbrowse-text)",
                        borderRadius: 6,
                        boxShadow: "0 4px 16px var(--tbrowse-tooltip-shadow)",
                        padding: 8,
                        zIndex: 2e3,
                        fontSize: 11,
                        display: "flex",
                        flexDirection: "column",
                        maxHeight: "70vh"
                    },
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                marginBottom: 8
                            },
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("strong", {
                                    children: "Column configuration"
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    onClick: I,
                                    style: bt(),
                                    title: "Restore factory defaults for every column",
                                    children: "Reset"
                                })
                            ]
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                overflow: "auto",
                                flex: "1 1 auto",
                                minHeight: 0
                            },
                            children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("table", {
                                style: {
                                    borderCollapse: "collapse",
                                    tableLayout: "auto",
                                    fontSize: 11
                                },
                                children: [
                                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("thead", {
                                        children: [
                                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                                children: [
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ze, {
                                                        children: "Order"
                                                    }),
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ze, {
                                                        children: "Visible"
                                                    }),
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ze, {
                                                        children: "Label"
                                                    }),
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ze, {
                                                        children: "Kind"
                                                    }),
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ze, {
                                                        children: "Display"
                                                    }),
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ze, {
                                                        children: "Palette"
                                                    }),
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ze, {
                                                        children: "Aggregation"
                                                    }),
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ze, {
                                                        children: "Searchable"
                                                    })
                                                ]
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                                style: {
                                                    background: "var(--tbrowse-bg-alt)"
                                                },
                                                children: [
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(He, {
                                                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                            style: {
                                                                color: "var(--tbrowse-text-subtle)",
                                                                fontSize: 10
                                                            },
                                                            children: "all"
                                                        })
                                                    }),
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(He, {
                                                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                                            type: "button",
                                                            style: bt(),
                                                            onClick: ()=>x(_ !== g.length),
                                                            title: _ === g.length ? "Hide all columns" : "Show all columns",
                                                            children: _ === g.length ? "hide all" : "show all"
                                                        })
                                                    }),
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(He, {}),
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(He, {
                                                        children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("select", {
                                                            value: "",
                                                            onChange: (w)=>w.target.value && b(w.target.value),
                                                            style: it(),
                                                            children: [
                                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("option", {
                                                                    value: "",
                                                                    children: "\u2014 set all \u2014"
                                                                }),
                                                                zn.map((w)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("option", {
                                                                        value: w,
                                                                        children: w
                                                                    }, w))
                                                            ]
                                                        })
                                                    }),
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(He, {
                                                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                                            type: "button",
                                                            style: bt(),
                                                            onClick: ()=>m($ ? "text" : "heatmap"),
                                                            disabled: M.length === 0,
                                                            title: M.length === 0 ? "No numeric columns" : $ ? "Switch every numeric column back to text" : "Switch every numeric column to heatmap",
                                                            children: $ ? "all \u2192 text" : "numeric \u2192 heatmap"
                                                        })
                                                    }),
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(He, {
                                                        children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("select", {
                                                            value: "",
                                                            onChange: (w)=>{
                                                                w.target.value && E(w.target.value);
                                                            },
                                                            style: it(),
                                                            title: "Apply this palette to every numeric column",
                                                            children: [
                                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("option", {
                                                                    value: "",
                                                                    children: "\u2014 set all \u2014"
                                                                }),
                                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("optgroup", {
                                                                    label: "Sequential",
                                                                    children: mt.filter((w)=>w.kind === "sequential").map((w)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("option", {
                                                                            value: w.id,
                                                                            children: w.label
                                                                        }, w.id))
                                                                }),
                                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("optgroup", {
                                                                    label: "Diverging",
                                                                    children: mt.filter((w)=>w.kind === "diverging").map((w)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("option", {
                                                                            value: w.id,
                                                                            children: w.label
                                                                        }, w.id))
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(He, {}),
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(He, {
                                                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                                            type: "button",
                                                            style: bt(),
                                                            onClick: ()=>T(!H),
                                                            disabled: W.length === 0,
                                                            title: W.length === 0 ? "No text columns" : H ? "Stop searching every text column" : "Make every text column searchable",
                                                            children: H ? "text \u2192 off" : "text \u2192 on"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("tbody", {
                                        children: g.map((w, N)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                                children: [
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(He, {
                                                        children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                            style: {
                                                                display: "inline-flex",
                                                                gap: 2
                                                            },
                                                            children: [
                                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                                                    type: "button",
                                                                    style: Gn(),
                                                                    disabled: N === 0,
                                                                    onClick: ()=>k(w.base.id, -1),
                                                                    title: "Move up",
                                                                    children: "\u2191"
                                                                }),
                                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                                                    type: "button",
                                                                    style: Gn(),
                                                                    disabled: N === g.length - 1,
                                                                    onClick: ()=>k(w.base.id, 1),
                                                                    title: "Move down",
                                                                    children: "\u2193"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(He, {
                                                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                                                            type: "checkbox",
                                                            checked: !w.hidden,
                                                            onChange: (v)=>p(w.base.id, {
                                                                    hidden: v.target.checked ? void 0 : !0
                                                                })
                                                        })
                                                    }),
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(He, {
                                                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                                                            type: "text",
                                                            value: w.label,
                                                            onChange: (v)=>p(w.base.id, {
                                                                    label: v.target.value === w.base.label ? void 0 : v.target.value
                                                                }),
                                                            style: Bn()
                                                        })
                                                    }),
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(He, {
                                                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("select", {
                                                            value: w.kind,
                                                            onChange: (v)=>{
                                                                const L = v.target.value;
                                                                p(w.base.id, (A)=>{
                                                                    var J;
                                                                    return {
                                                                        ...A,
                                                                        kind: L === (w.base.kind ?? "string") ? void 0 : L,
                                                                        // Method ids are kind-scoped; clear when kind changes.
                                                                        aggregateMethod: void 0,
                                                                        // If display is no longer supported by the new kind, clear it.
                                                                        display: A.display && !((J = dt.find((ie)=>ie.id === A.display)) != null && J.supports.includes(L)) ? void 0 : A.display
                                                                    };
                                                                });
                                                            },
                                                            style: it(),
                                                            children: zn.map((v)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("option", {
                                                                    value: v,
                                                                    children: v
                                                                }, v))
                                                        })
                                                    }),
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(He, {
                                                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("select", {
                                                            value: w.display,
                                                            onChange: (v)=>{
                                                                const L = v.target.value;
                                                                p(w.base.id, {
                                                                    display: L === (w.base.display ?? "text") ? void 0 : L
                                                                });
                                                            },
                                                            style: it(),
                                                            children: dt.map((v)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("option", {
                                                                    value: v.id,
                                                                    disabled: !v.supports.includes(w.kind),
                                                                    children: [
                                                                        v.label,
                                                                        v.supports.includes(w.kind) ? "" : " (n/a)"
                                                                    ]
                                                                }, v.id))
                                                        })
                                                    }),
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(He, {
                                                        children: w.kind !== "number" || !w.palette ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                            style: {
                                                                fontSize: 11,
                                                                color: "var(--tbrowse-text-subtle)"
                                                            },
                                                            title: "Palette applies to numeric heatmap columns only",
                                                            children: "\u2014"
                                                        }) : /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                            style: {
                                                                display: "inline-flex",
                                                                gap: 4,
                                                                alignItems: "center"
                                                            },
                                                            children: [
                                                                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("select", {
                                                                    value: w.palette.id,
                                                                    onChange: (v)=>{
                                                                        const L = v.target.value;
                                                                        p(w.base.id, {
                                                                            palette: L === w.base.palette ? void 0 : L
                                                                        });
                                                                    },
                                                                    style: it(),
                                                                    disabled: w.display !== "heatmap",
                                                                    title: w.display === "heatmap" ? "Pick a heatmap palette" : "Switch this column to Heatmap to choose a palette",
                                                                    children: [
                                                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("optgroup", {
                                                                            label: "Sequential",
                                                                            children: mt.filter((v)=>v.kind === "sequential").map((v)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("option", {
                                                                                    value: v.id,
                                                                                    children: v.label
                                                                                }, v.id))
                                                                        }),
                                                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("optgroup", {
                                                                            label: "Diverging",
                                                                            children: mt.filter((v)=>v.kind === "diverging").map((v)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("option", {
                                                                                    value: v.id,
                                                                                    children: v.label
                                                                                }, v.id))
                                                                        })
                                                                    ]
                                                                }),
                                                                w.palette.kind === "diverging" && /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                                                                    type: "number",
                                                                    value: w.paletteMidpoint,
                                                                    step: "any",
                                                                    onChange: (v)=>{
                                                                        const L = v.target.value === "" ? void 0 : Number(v.target.value), A = w.base.paletteMidpoint ?? 0;
                                                                        p(w.base.id, {
                                                                            paletteMidpoint: L === void 0 || L === A ? void 0 : L
                                                                        });
                                                                    },
                                                                    style: {
                                                                        ...Bn(),
                                                                        width: 56,
                                                                        minWidth: 0
                                                                    },
                                                                    disabled: w.display !== "heatmap",
                                                                    title: w.domain ? `Diverging midpoint (data range ${w.domain.min} \u{2013} ${w.domain.max})` : "Diverging midpoint (anchors the central palette stop)"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(He, {
                                                        children: w.aggregateLocked ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                            style: {
                                                                fontSize: 11,
                                                                color: "var(--tbrowse-text-subtle)"
                                                            },
                                                            title: "Locked by zone factory",
                                                            children: "(custom)"
                                                        }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("select", {
                                                            value: w.aggregateMethodId,
                                                            onChange: (v)=>p(w.base.id, {
                                                                    aggregateMethod: v.target.value || void 0
                                                                }),
                                                            style: it(),
                                                            children: (0, _tbrowseCore.AGGREGATE_METHODS)[w.kind].map((v)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("option", {
                                                                    value: v.id,
                                                                    children: v.label
                                                                }, v.id))
                                                        })
                                                    }),
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(He, {
                                                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                                                            type: "checkbox",
                                                            checked: w.searchable,
                                                            disabled: w.kind !== "string",
                                                            title: w.kind === "string" ? "Add this column to the search-bar dropdown" : "Searchable supports text columns only",
                                                            onChange: (v)=>p(w.base.id, {
                                                                    searchable: v.target.checked === (w.base.searchable ?? !1) ? void 0 : v.target.checked
                                                                })
                                                        })
                                                    })
                                                ]
                                            }, w.base.id))
                                    })
                                ]
                            })
                        })
                    ]
                })
            }), document.body)
        ]
    });
}
function Ze({ children: e }) {
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
        style: {
            textAlign: "left",
            fontSize: 9,
            textTransform: "uppercase",
            letterSpacing: 0.4,
            color: "var(--tbrowse-text-subtle)",
            fontWeight: 600,
            padding: "3px 4px",
            whiteSpace: "nowrap",
            borderBottom: "1px solid var(--tbrowse-border-soft)"
        },
        children: e
    });
}
function He({ children: e }) {
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
        style: {
            padding: "2px 4px",
            borderBottom: "1px solid var(--tbrowse-border-soft)",
            verticalAlign: "middle"
        },
        children: e
    });
}
function bt() {
    return {
        fontSize: 10,
        padding: "1px 6px",
        borderRadius: 3,
        border: "1px solid var(--tbrowse-border)",
        background: "var(--tbrowse-bg-input)",
        color: "var(--tbrowse-text)",
        cursor: "pointer",
        whiteSpace: "nowrap"
    };
}
function Gn() {
    return {
        ...bt(),
        padding: "0 4px",
        minWidth: 18
    };
}
function it() {
    return {
        fontSize: 11,
        padding: "1px 2px",
        background: "var(--tbrowse-bg-input)",
        color: "var(--tbrowse-text)",
        border: "1px solid var(--tbrowse-border)",
        borderRadius: 3,
        maxWidth: 130
    };
}
function Bn() {
    return {
        fontSize: 11,
        padding: "1px 4px",
        background: "var(--tbrowse-bg-input)",
        color: "var(--tbrowse-text)",
        border: "1px solid var(--tbrowse-border)",
        borderRadius: 3,
        width: 90,
        minWidth: 60
    };
}
const an = 90, xo = 30, Gs = (0, _tbrowseCore.LEAF_ROW_HEIGHT), st = {};
function Bs(e, t) {
    return e == null ? (0, _tbrowseCore.NULL_GLYPH) : t === "boolean" ? e ? "\u2713" : "" : t === "number" && typeof e == "number" && Number.isFinite(e) ? e.toLocaleString() : String(e);
}
function Xs(e) {
    return e === "number" ? "right" : e === "boolean" ? "center" : "left";
}
function Xn(e) {
    return e === "right" ? "flex-end" : e === "center" ? "center" : "flex-start";
}
function Vn(e, t) {
    return {
        start: t,
        end: t + e
    };
}
function Un(e, t, n) {
    const o = (t == null ? void 0 : t.columnOverrides) ?? {}, i = e.map((h)=>h.id), a = t == null ? void 0 : t.columnOrder, c = /* @__PURE__ */ new Set(), s = [];
    if (a) for (const h of a)i.includes(h) && !c.has(h) && (c.add(h), s.push(h));
    for (const h of i)c.has(h) || (c.add(h), s.push(h));
    const l = new Map(e.map((h)=>[
            h.id,
            h
        ])), f = [];
    for (const h of s){
        const u = l.get(h);
        if (!u) continue;
        const g = o[h] ?? {};
        if (g.hidden) continue;
        const y = g.kind ?? u.kind ?? "string", p = u.display ?? "text";
        let k = g.display ?? p;
        k === "heatmap" && y !== "number" && (k = "text");
        let x;
        u.aggregate ? x = u.aggregate : x = (0, _tbrowseCore.methodForKind)(y, g.aggregateMethod).fn;
        const m = g.palette ?? u.palette, b = n[h], E = m ? cn(m) : b ? bo(b) : cn(void 0), T = g.paletteMidpoint ?? u.paletteMidpoint ?? 0;
        f.push({
            id: h,
            base: u,
            label: g.label ?? u.label,
            kind: y,
            width: Math.max(xo, g.width ?? u.width ?? an),
            align: u.align ?? Xs(y),
            display: k,
            aggregator: x,
            format: u.format,
            palette: E,
            paletteMidpoint: T
        });
    }
    return {
        effective: f,
        orderedIds: s
    };
}
function Yn(e) {
    const t = [];
    let n = 0;
    for (const o of e)t.push(n), n += o.width;
    return {
        offsets: t,
        contentWidth: n
    };
}
function Vs(e, t, n, o, i, a) {
    const c = [];
    let s = 0, l = 0;
    const f = [
        e
    ];
    for(; f.length > 0;){
        const h = f.pop();
        if (a.has(h)) continue;
        const u = o.nodes[h];
        if (!u) continue;
        if (u.isLeaf) {
            if (s++, u.geneId) {
                const y = n[u.geneId];
                if (y && t in y) {
                    const p = y[t];
                    p != null && (c.push(p), l++);
                }
            }
            continue;
        }
        const g = i.get(h);
        if (g) for (const y of g)f.push(y);
    }
    return {
        values: c,
        totalLeaves: s,
        leavesWithValue: l
    };
}
function dl(e) {
    const t = e.columns, n = _s(e.table, t.filter((c)=>(c.kind ?? "string") === "number").map((c)=>c.id)), o = t.reduce((c, s)=>c + (s.width ?? an), 0), i = (c)=>{
        const { zoneState: s, setZoneState: l, width: f, bodyScrollLeft: h } = c, u = s ?? st, { effective: g, orderedIds: y } = (0, _react.useMemo)(()=>Un(t, u, n), [
            u
        ]), { offsets: p, contentWidth: k } = (0, _react.useMemo)(()=>Yn(g), [
            g
        ]), x = Vn(f, h);
        return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
            "data-table-zone-header": e.id,
            style: {
                height: "100%",
                display: "flex",
                flexDirection: "column",
                fontSize: 13,
                color: "var(--tbrowse-text)"
            },
            children: [
                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                    style: {
                        flex: 1,
                        minHeight: 0,
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        padding: "0 10px 0 14px"
                    },
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)(nt, {
                            defaultName: e.defaultName,
                            customName: u.name,
                            onChange: (m)=>l((b)=>({
                                        ...b ?? st,
                                        name: m
                                    }))
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                            style: {
                                color: "var(--tbrowse-text-subtle)",
                                fontSize: 11,
                                fontWeight: 400
                            },
                            children: [
                                g.length,
                                "/",
                                t.length,
                                " col",
                                t.length === 1 ? "" : "s"
                            ]
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                            style: {
                                marginLeft: "auto"
                            },
                            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(zs, {
                                factoryColumns: t,
                                state: u,
                                setState: (m)=>l((b)=>typeof m == "function" ? m(b ?? st) : m),
                                orderedIds: y,
                                heatmapDomains: n
                            })
                        })
                    ]
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        flex: `0 0 ${Gs}px`,
                        minHeight: 0,
                        position: "relative",
                        overflow: "hidden",
                        borderTop: "1px solid var(--tbrowse-border-soft)",
                        background: "var(--tbrowse-bg-alt)"
                    },
                    children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            position: "absolute",
                            top: 0,
                            left: 0,
                            height: "100%",
                            width: k,
                            transform: `translateX(${-h}px)`,
                            display: "flex"
                        },
                        children: g.map((m, b)=>p[b] + m.width < x.start || p[b] > x.end ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                                style: {
                                    width: m.width,
                                    flex: `0 0 ${m.width}px`
                                }
                            }, m.id) : /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                                title: m.label,
                                style: {
                                    width: m.width,
                                    flex: `0 0 ${m.width}px`,
                                    padding: "0 6px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: Xn(m.align),
                                    fontSize: 11,
                                    fontWeight: 600,
                                    color: "var(--tbrowse-text-muted)",
                                    borderRight: "1px solid var(--tbrowse-border-soft)",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    position: "relative"
                                },
                                children: [
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                        style: {
                                            flex: "1 1 auto",
                                            minWidth: 0,
                                            overflow: "hidden",
                                            textOverflow: "ellipsis"
                                        },
                                        children: m.label
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ys, {
                                        columnId: m.id,
                                        currentWidth: m.width,
                                        factoryWidth: m.base.width ?? an,
                                        setZoneState: (E)=>l((T)=>E(T ?? st))
                                    })
                                ]
                            }, m.id))
                    })
                })
            ]
        });
    }, a = (c)=>{
        const { visibleRows: s, rowRange: l, hoveredNodeId: f, hoveredSubtreeIds: h, selectedNodeId: u, prunedNodeIds: g, onHoverNode: y, onSelectNode: p, width: k, bodyScrollLeft: x, setBodyScrollLeft: m, data: b, zoneState: E } = c, T = E ?? st, I = Le((L)=>L.theme), { effective: _ } = (0, _react.useMemo)(()=>Un(t, T, n), [
            T
        ]), { offsets: M, contentWidth: $ } = (0, _react.useMemo)(()=>Yn(_), [
            _
        ]), W = Math.max(0, $ - k);
        (0, _react.useEffect)(()=>{
            x > W && m(W);
        }, [
            x,
            W,
            m
        ]);
        const H = (0, _react.useCallback)((L)=>{
            W <= 0 || L.deltaX !== 0 && (L.preventDefault(), m((A)=>Math.max(0, Math.min(W, A + L.deltaX))));
        }, [
            W,
            m
        ]), w = s.slice(l.startIndex, l.endIndex), N = Vn(k, x), v = (0, _react.useMemo)(()=>(0, _tbrowseCore.buildChildrenIndex)(b.tree), [
            b.tree
        ]);
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
            onWheel: H,
            style: {
                position: "relative",
                height: "100%",
                overflow: "hidden"
            },
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                style: {
                    position: "relative",
                    width: $,
                    height: "100%",
                    transform: `translateX(${-x}px)`
                },
                children: w.map((L)=>{
                    const A = f === L.nodeId, J = h.has(L.nodeId), ie = u === L.nodeId, ae = L.kind === "collapsedSummary", ue = b.tree.nodes[L.nodeId], pe = ue == null ? void 0 : ue.geneId, oe = !ae && pe ? e.table[pe] : void 0;
                    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                        onMouseEnter: ()=>y(L.nodeId),
                        onMouseLeave: ()=>y(null),
                        onClick: ()=>{
                            const B = window.getSelection();
                            B && B.toString().length > 0 || p(L.nodeId);
                        },
                        style: {
                            position: "absolute",
                            top: L.y,
                            left: 0,
                            width: $,
                            height: L.height,
                            display: "flex",
                            background: ie ? "var(--tbrowse-row-select-bg)" : A ? "var(--tbrowse-row-hover-bg)" : J ? "var(--tbrowse-row-subtree-bg)" : "transparent",
                            borderBottom: "1px solid var(--tbrowse-border-row)",
                            cursor: "pointer",
                            fontSize: 12,
                            color: ae ? "var(--tbrowse-text-muted)" : "var(--tbrowse-text)",
                            fontStyle: ae ? "italic" : "normal",
                            fontWeight: J ? 600 : 400,
                            opacity: L.opacity ?? 1,
                            transform: `translateX(${-32 * (1 - (L.opacity ?? 1))}px)`,
                            userSelect: "text"
                        },
                        children: _.map((B, re)=>{
                            if (M[re] + B.width < N.start || M[re] > N.end) return /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                                style: {
                                    width: B.width,
                                    flex: `0 0 ${B.width}px`
                                }
                            }, B.id);
                            let ge, fe, C, O = null;
                            if (ae) {
                                const U = Vs(L.nodeId, B.id, e.table, b.tree, v, g), G = (0, _tbrowseCore.normalizeAggregateResult)(B.aggregator(U));
                                ge = G.text, fe = G.title ?? G.text, C = U.leavesWithValue === 0, B.display === "heatmap" && typeof G.numeric == "number" && (O = G.numeric);
                            } else {
                                const U = oe == null ? void 0 : oe[B.id];
                                C = U == null, ge = B.format ? B.format(U) : Bs(U, B.kind), fe = C ? "" : ge, B.display === "heatmap" && typeof U == "number" && Number.isFinite(U) && (O = U);
                            }
                            let F, z;
                            if (B.display === "heatmap" && O !== null && n[B.id]) {
                                const U = Ns(O, n[B.id], B.palette, I, B.paletteMidpoint);
                                U && (F = Hs(U), z = Fs(U, I));
                            }
                            return /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                                title: fe,
                                style: {
                                    width: B.width,
                                    flex: `0 0 ${B.width}px`,
                                    padding: "0 6px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: Xn(B.align),
                                    borderRight: "1px solid var(--tbrowse-border-row)",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    color: z ?? (C ? "var(--tbrowse-text-subtle)" : "inherit"),
                                    background: F,
                                    fontVariantNumeric: B.kind === "number" ? "tabular-nums" : void 0
                                },
                                children: ge
                            }, B.id);
                        })
                    }, L.nodeId);
                })
            })
        });
    };
    return {
        id: e.id,
        displayName: e.defaultName,
        Header: i,
        Body: a,
        defaultWidth: e.defaultWidth ?? Math.min(40, Math.max(10, o / 20)),
        minWidth: e.minWidth ?? 80,
        defaultZoneState: st,
        isAvailable: (c)=>{
            for (const s of Object.values(c.tree.nodes))if (s.isLeaf && s.geneId && e.table[s.geneId]) return !0;
            return !1;
        },
        defaultVisible: e.defaultVisible,
        getSearchFields: (c, s)=>{
            const l = (c == null ? void 0 : c.columnOverrides) ?? {}, f = (c == null ? void 0 : c.name) ?? e.defaultName, h = [];
            for (const u of t){
                const g = l[u.id] ?? {};
                if ((g.kind ?? u.kind ?? "string") !== "string" || !(g.searchable ?? u.searchable ?? !1)) continue;
                const k = `${f} | ${g.label ?? u.label}`;
                h.push(Us(e.id, u.id, k, e.table));
            }
            return h;
        }
    };
}
function Us(e, t, n, o) {
    const i = `table:${e}:${t}`, a = (c)=>{
        var l;
        if (!c) return null;
        const s = (l = o[c]) == null ? void 0 : l[t];
        return s == null ? null : typeof s == "string" ? s : String(s);
    };
    return {
        id: i,
        label: n,
        buildPredicate (c, s) {
            const l = wt(c, s);
            return l.ok ? {
                ok: !0,
                test: (f)=>{
                    const h = a(f.geneId);
                    return h != null && l.test(h);
                }
            } : l;
        },
        describeMatch (c, s, l) {
            const f = a(c.geneId);
            if (f == null) return null;
            const h = wt(s, l);
            if (!h.ok) return null;
            const u = h.spanOf(f);
            return u ? {
                value: f,
                start: u[0],
                end: u[1]
            } : null;
        }
    };
}
function Ys({ columnId: e, currentWidth: t, factoryWidth: n, setZoneState: o }) {
    const [i, a] = (0, _react.useState)(!1), c = (0, _react.useRef)(null), s = (h)=>{
        o((u)=>{
            const g = {
                ...u.columnOverrides ?? {}
            }, p = {
                ...g[e] ?? {},
                width: h
            };
            return h === void 0 && delete p.width, Object.keys(p).filter((k)=>p[k] !== void 0).length === 0 ? delete g[e] : g[e] = p, {
                ...u,
                columnOverrides: g
            };
        });
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        role: "separator",
        "aria-orientation": "vertical",
        "aria-label": "Resize column",
        onPointerDown: (h)=>{
            h.preventDefault(), h.stopPropagation(), c.current = {
                startX: h.clientX,
                startWidth: t
            };
            const u = (y)=>{
                if (!c.current) return;
                const p = y.clientX - c.current.startX, k = Math.max(xo, c.current.startWidth + p);
                s(k);
            }, g = ()=>{
                c.current = null, window.removeEventListener("pointermove", u), window.removeEventListener("pointerup", g), window.removeEventListener("pointercancel", g);
            };
            window.addEventListener("pointermove", u), window.addEventListener("pointerup", g), window.addEventListener("pointercancel", g);
        },
        onDoubleClick: (h)=>{
            h.stopPropagation(), s(void 0);
        },
        onMouseEnter: ()=>a(!0),
        onMouseLeave: ()=>a(!1),
        title: "Drag to resize \xb7 double-click to reset",
        style: {
            position: "absolute",
            top: 0,
            right: -3,
            width: 6,
            height: "100%",
            cursor: "col-resize",
            zIndex: 1,
            background: i ? "var(--tbrowse-accent)" : "transparent",
            opacity: i ? 0.6 : 1,
            userSelect: "none",
            touchAction: "none"
        }
    });
}
const ul = _tbrowseCore.fromEnsemblGeneTree, fl = _tbrowseCore.fromEnsemblGeneStructure, hl = _tbrowseCore.fromEnsemblGenomeFeatures, pl = _tbrowseCore.fromEnsemblProteinFeatures, gl = _tbrowseCore.fromGrameneGene, ml = _tbrowseCore.fromGrameneGenetree, bl = _tbrowseCore.fromGrameneGeneStructures, xl = _tbrowseCore.fromGrameneNeighborhood, vl = _tbrowseCore.computePivotState, wl = _tbrowseCore.computeVisibleRows, yl = _tbrowseCore.LEAF_ROW_HEIGHT, Il = _tbrowseCore.SUMMARY_ROW_HEIGHT, Sl = _tbrowseCore.computeRowRange;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","zustand":"dodpK","tbrowse-core":"cl12L","react-dom":"82aNB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dodpK":[function(require,module,exports,__globalThis) {
'use strict';
var vanilla = require("a19f4edd89926025");
var react = require("a0cacd268d6bf882");
Object.keys(vanilla).forEach(function(k) {
    if (k !== 'default' && !Object.prototype.hasOwnProperty.call(exports, k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function() {
            return vanilla[k];
        }
    });
});
Object.keys(react).forEach(function(k) {
    if (k !== 'default' && !Object.prototype.hasOwnProperty.call(exports, k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function() {
            return react[k];
        }
    });
});

},{"a19f4edd89926025":"bsCIB","a0cacd268d6bf882":"3viQv"}],"bsCIB":[function(require,module,exports,__globalThis) {
'use strict';
const createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const api = {
        setState,
        getState,
        getInitialState,
        subscribe
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const createStore = (createState)=>createState ? createStoreImpl(createState) : createStoreImpl;
exports.createStore = createStore;

},{}],"3viQv":[function(require,module,exports,__globalThis) {
'use strict';
var React = require("6a69048f974f8971");
var vanilla = require("985957b117977eb9");
const identity = (arg)=>arg;
function useStore(api, selector = identity) {
    const slice = React.useSyncExternalStore(api.subscribe, React.useCallback(()=>selector(api.getState()), [
        api,
        selector
    ]), ()=>selector(api.getInitialState()));
    React.useDebugValue(slice);
    return slice;
}
const createImpl = (createState)=>{
    const api = vanilla.createStore(createState);
    const useBoundStore = (selector)=>useStore(api, selector);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const create = (createState)=>createState ? createImpl(createState) : createImpl;
exports.create = create;
exports.useStore = useStore;

},{"6a69048f974f8971":"bmhQu","985957b117977eb9":"bsCIB"}],"dnkT0":[function(require,module,exports,__globalThis) {
var baseAssignValue = require("c46c3767ff672674"), createAggregator = require("6b8d7408337ccc56");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var keyBy = createAggregator(function(result, value, key) {
    baseAssignValue(result, key, value);
});
module.exports = keyBy;

},{"c46c3767ff672674":"kIeTG","6b8d7408337ccc56":"g9n00"}],"ahx5Y":[function(require,module,exports,__globalThis) {
// THIS FILE IS AUTO GENERATED
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BiAbacus", ()=>BiAbacus);
parcelHelpers.export(exports, "BiAccessibility", ()=>BiAccessibility);
parcelHelpers.export(exports, "BiAddToQueue", ()=>BiAddToQueue);
parcelHelpers.export(exports, "BiAdjust", ()=>BiAdjust);
parcelHelpers.export(exports, "BiAlarmAdd", ()=>BiAlarmAdd);
parcelHelpers.export(exports, "BiAlarmExclamation", ()=>BiAlarmExclamation);
parcelHelpers.export(exports, "BiAlarmOff", ()=>BiAlarmOff);
parcelHelpers.export(exports, "BiAlarmSnooze", ()=>BiAlarmSnooze);
parcelHelpers.export(exports, "BiAlarm", ()=>BiAlarm);
parcelHelpers.export(exports, "BiAlbum", ()=>BiAlbum);
parcelHelpers.export(exports, "BiAlignJustify", ()=>BiAlignJustify);
parcelHelpers.export(exports, "BiAlignLeft", ()=>BiAlignLeft);
parcelHelpers.export(exports, "BiAlignMiddle", ()=>BiAlignMiddle);
parcelHelpers.export(exports, "BiAlignRight", ()=>BiAlignRight);
parcelHelpers.export(exports, "BiAnalyse", ()=>BiAnalyse);
parcelHelpers.export(exports, "BiAnchor", ()=>BiAnchor);
parcelHelpers.export(exports, "BiAngry", ()=>BiAngry);
parcelHelpers.export(exports, "BiAperture", ()=>BiAperture);
parcelHelpers.export(exports, "BiArch", ()=>BiArch);
parcelHelpers.export(exports, "BiArchiveIn", ()=>BiArchiveIn);
parcelHelpers.export(exports, "BiArchiveOut", ()=>BiArchiveOut);
parcelHelpers.export(exports, "BiArchive", ()=>BiArchive);
parcelHelpers.export(exports, "BiArea", ()=>BiArea);
parcelHelpers.export(exports, "BiArrowBack", ()=>BiArrowBack);
parcelHelpers.export(exports, "BiArrowFromBottom", ()=>BiArrowFromBottom);
parcelHelpers.export(exports, "BiArrowFromLeft", ()=>BiArrowFromLeft);
parcelHelpers.export(exports, "BiArrowFromRight", ()=>BiArrowFromRight);
parcelHelpers.export(exports, "BiArrowFromTop", ()=>BiArrowFromTop);
parcelHelpers.export(exports, "BiArrowToBottom", ()=>BiArrowToBottom);
parcelHelpers.export(exports, "BiArrowToLeft", ()=>BiArrowToLeft);
parcelHelpers.export(exports, "BiArrowToRight", ()=>BiArrowToRight);
parcelHelpers.export(exports, "BiArrowToTop", ()=>BiArrowToTop);
parcelHelpers.export(exports, "BiAt", ()=>BiAt);
parcelHelpers.export(exports, "BiAtom", ()=>BiAtom);
parcelHelpers.export(exports, "BiAward", ()=>BiAward);
parcelHelpers.export(exports, "BiBadgeCheck", ()=>BiBadgeCheck);
parcelHelpers.export(exports, "BiBadge", ()=>BiBadge);
parcelHelpers.export(exports, "BiBaguette", ()=>BiBaguette);
parcelHelpers.export(exports, "BiBall", ()=>BiBall);
parcelHelpers.export(exports, "BiBandAid", ()=>BiBandAid);
parcelHelpers.export(exports, "BiBarChartAlt2", ()=>BiBarChartAlt2);
parcelHelpers.export(exports, "BiBarChartAlt", ()=>BiBarChartAlt);
parcelHelpers.export(exports, "BiBarChartSquare", ()=>BiBarChartSquare);
parcelHelpers.export(exports, "BiBarChart", ()=>BiBarChart);
parcelHelpers.export(exports, "BiBarcodeReader", ()=>BiBarcodeReader);
parcelHelpers.export(exports, "BiBarcode", ()=>BiBarcode);
parcelHelpers.export(exports, "BiBaseball", ()=>BiBaseball);
parcelHelpers.export(exports, "BiBasket", ()=>BiBasket);
parcelHelpers.export(exports, "BiBasketball", ()=>BiBasketball);
parcelHelpers.export(exports, "BiBath", ()=>BiBath);
parcelHelpers.export(exports, "BiBattery", ()=>BiBattery);
parcelHelpers.export(exports, "BiBed", ()=>BiBed);
parcelHelpers.export(exports, "BiBeenHere", ()=>BiBeenHere);
parcelHelpers.export(exports, "BiBeer", ()=>BiBeer);
parcelHelpers.export(exports, "BiBellMinus", ()=>BiBellMinus);
parcelHelpers.export(exports, "BiBellOff", ()=>BiBellOff);
parcelHelpers.export(exports, "BiBellPlus", ()=>BiBellPlus);
parcelHelpers.export(exports, "BiBell", ()=>BiBell);
parcelHelpers.export(exports, "BiBible", ()=>BiBible);
parcelHelpers.export(exports, "BiBitcoin", ()=>BiBitcoin);
parcelHelpers.export(exports, "BiBlanket", ()=>BiBlanket);
parcelHelpers.export(exports, "BiBlock", ()=>BiBlock);
parcelHelpers.export(exports, "BiBluetooth", ()=>BiBluetooth);
parcelHelpers.export(exports, "BiBody", ()=>BiBody);
parcelHelpers.export(exports, "BiBold", ()=>BiBold);
parcelHelpers.export(exports, "BiBoltCircle", ()=>BiBoltCircle);
parcelHelpers.export(exports, "BiBomb", ()=>BiBomb);
parcelHelpers.export(exports, "BiBone", ()=>BiBone);
parcelHelpers.export(exports, "BiBong", ()=>BiBong);
parcelHelpers.export(exports, "BiBookAdd", ()=>BiBookAdd);
parcelHelpers.export(exports, "BiBookAlt", ()=>BiBookAlt);
parcelHelpers.export(exports, "BiBookBookmark", ()=>BiBookBookmark);
parcelHelpers.export(exports, "BiBookContent", ()=>BiBookContent);
parcelHelpers.export(exports, "BiBookHeart", ()=>BiBookHeart);
parcelHelpers.export(exports, "BiBookOpen", ()=>BiBookOpen);
parcelHelpers.export(exports, "BiBookReader", ()=>BiBookReader);
parcelHelpers.export(exports, "BiBook", ()=>BiBook);
parcelHelpers.export(exports, "BiBookmarkAltMinus", ()=>BiBookmarkAltMinus);
parcelHelpers.export(exports, "BiBookmarkAltPlus", ()=>BiBookmarkAltPlus);
parcelHelpers.export(exports, "BiBookmarkAlt", ()=>BiBookmarkAlt);
parcelHelpers.export(exports, "BiBookmarkHeart", ()=>BiBookmarkHeart);
parcelHelpers.export(exports, "BiBookmarkMinus", ()=>BiBookmarkMinus);
parcelHelpers.export(exports, "BiBookmarkPlus", ()=>BiBookmarkPlus);
parcelHelpers.export(exports, "BiBookmark", ()=>BiBookmark);
parcelHelpers.export(exports, "BiBookmarks", ()=>BiBookmarks);
parcelHelpers.export(exports, "BiBorderAll", ()=>BiBorderAll);
parcelHelpers.export(exports, "BiBorderBottom", ()=>BiBorderBottom);
parcelHelpers.export(exports, "BiBorderInner", ()=>BiBorderInner);
parcelHelpers.export(exports, "BiBorderLeft", ()=>BiBorderLeft);
parcelHelpers.export(exports, "BiBorderNone", ()=>BiBorderNone);
parcelHelpers.export(exports, "BiBorderOuter", ()=>BiBorderOuter);
parcelHelpers.export(exports, "BiBorderRadius", ()=>BiBorderRadius);
parcelHelpers.export(exports, "BiBorderRight", ()=>BiBorderRight);
parcelHelpers.export(exports, "BiBorderTop", ()=>BiBorderTop);
parcelHelpers.export(exports, "BiBot", ()=>BiBot);
parcelHelpers.export(exports, "BiBowlHot", ()=>BiBowlHot);
parcelHelpers.export(exports, "BiBowlRice", ()=>BiBowlRice);
parcelHelpers.export(exports, "BiBowlingBall", ()=>BiBowlingBall);
parcelHelpers.export(exports, "BiBox", ()=>BiBox);
parcelHelpers.export(exports, "BiBracket", ()=>BiBracket);
parcelHelpers.export(exports, "BiBraille", ()=>BiBraille);
parcelHelpers.export(exports, "BiBrain", ()=>BiBrain);
parcelHelpers.export(exports, "BiBriefcaseAlt2", ()=>BiBriefcaseAlt2);
parcelHelpers.export(exports, "BiBriefcaseAlt", ()=>BiBriefcaseAlt);
parcelHelpers.export(exports, "BiBriefcase", ()=>BiBriefcase);
parcelHelpers.export(exports, "BiBrightnessHalf", ()=>BiBrightnessHalf);
parcelHelpers.export(exports, "BiBrightness", ()=>BiBrightness);
parcelHelpers.export(exports, "BiBroadcast", ()=>BiBroadcast);
parcelHelpers.export(exports, "BiBrushAlt", ()=>BiBrushAlt);
parcelHelpers.export(exports, "BiBrush", ()=>BiBrush);
parcelHelpers.export(exports, "BiBugAlt", ()=>BiBugAlt);
parcelHelpers.export(exports, "BiBug", ()=>BiBug);
parcelHelpers.export(exports, "BiBuildingHouse", ()=>BiBuildingHouse);
parcelHelpers.export(exports, "BiBuilding", ()=>BiBuilding);
parcelHelpers.export(exports, "BiBuildings", ()=>BiBuildings);
parcelHelpers.export(exports, "BiBulb", ()=>BiBulb);
parcelHelpers.export(exports, "BiBullseye", ()=>BiBullseye);
parcelHelpers.export(exports, "BiBuoy", ()=>BiBuoy);
parcelHelpers.export(exports, "BiBusSchool", ()=>BiBusSchool);
parcelHelpers.export(exports, "BiBus", ()=>BiBus);
parcelHelpers.export(exports, "BiCabinet", ()=>BiCabinet);
parcelHelpers.export(exports, "BiCableCar", ()=>BiCableCar);
parcelHelpers.export(exports, "BiCake", ()=>BiCake);
parcelHelpers.export(exports, "BiCalculator", ()=>BiCalculator);
parcelHelpers.export(exports, "BiCalendarAlt", ()=>BiCalendarAlt);
parcelHelpers.export(exports, "BiCalendarCheck", ()=>BiCalendarCheck);
parcelHelpers.export(exports, "BiCalendarEdit", ()=>BiCalendarEdit);
parcelHelpers.export(exports, "BiCalendarEvent", ()=>BiCalendarEvent);
parcelHelpers.export(exports, "BiCalendarExclamation", ()=>BiCalendarExclamation);
parcelHelpers.export(exports, "BiCalendarHeart", ()=>BiCalendarHeart);
parcelHelpers.export(exports, "BiCalendarMinus", ()=>BiCalendarMinus);
parcelHelpers.export(exports, "BiCalendarPlus", ()=>BiCalendarPlus);
parcelHelpers.export(exports, "BiCalendarStar", ()=>BiCalendarStar);
parcelHelpers.export(exports, "BiCalendarWeek", ()=>BiCalendarWeek);
parcelHelpers.export(exports, "BiCalendarX", ()=>BiCalendarX);
parcelHelpers.export(exports, "BiCalendar", ()=>BiCalendar);
parcelHelpers.export(exports, "BiCameraHome", ()=>BiCameraHome);
parcelHelpers.export(exports, "BiCameraMovie", ()=>BiCameraMovie);
parcelHelpers.export(exports, "BiCameraOff", ()=>BiCameraOff);
parcelHelpers.export(exports, "BiCamera", ()=>BiCamera);
parcelHelpers.export(exports, "BiCandles", ()=>BiCandles);
parcelHelpers.export(exports, "BiCapsule", ()=>BiCapsule);
parcelHelpers.export(exports, "BiCaptions", ()=>BiCaptions);
parcelHelpers.export(exports, "BiCar", ()=>BiCar);
parcelHelpers.export(exports, "BiCard", ()=>BiCard);
parcelHelpers.export(exports, "BiCaretDownCircle", ()=>BiCaretDownCircle);
parcelHelpers.export(exports, "BiCaretDownSquare", ()=>BiCaretDownSquare);
parcelHelpers.export(exports, "BiCaretDown", ()=>BiCaretDown);
parcelHelpers.export(exports, "BiCaretLeftCircle", ()=>BiCaretLeftCircle);
parcelHelpers.export(exports, "BiCaretLeftSquare", ()=>BiCaretLeftSquare);
parcelHelpers.export(exports, "BiCaretLeft", ()=>BiCaretLeft);
parcelHelpers.export(exports, "BiCaretRightCircle", ()=>BiCaretRightCircle);
parcelHelpers.export(exports, "BiCaretRightSquare", ()=>BiCaretRightSquare);
parcelHelpers.export(exports, "BiCaretRight", ()=>BiCaretRight);
parcelHelpers.export(exports, "BiCaretUpCircle", ()=>BiCaretUpCircle);
parcelHelpers.export(exports, "BiCaretUpSquare", ()=>BiCaretUpSquare);
parcelHelpers.export(exports, "BiCaretUp", ()=>BiCaretUp);
parcelHelpers.export(exports, "BiCarousel", ()=>BiCarousel);
parcelHelpers.export(exports, "BiCartAdd", ()=>BiCartAdd);
parcelHelpers.export(exports, "BiCartAlt", ()=>BiCartAlt);
parcelHelpers.export(exports, "BiCartDownload", ()=>BiCartDownload);
parcelHelpers.export(exports, "BiCart", ()=>BiCart);
parcelHelpers.export(exports, "BiCast", ()=>BiCast);
parcelHelpers.export(exports, "BiCategoryAlt", ()=>BiCategoryAlt);
parcelHelpers.export(exports, "BiCategory", ()=>BiCategory);
parcelHelpers.export(exports, "BiCctv", ()=>BiCctv);
parcelHelpers.export(exports, "BiCertification", ()=>BiCertification);
parcelHelpers.export(exports, "BiChair", ()=>BiChair);
parcelHelpers.export(exports, "BiChalkboard", ()=>BiChalkboard);
parcelHelpers.export(exports, "BiChart", ()=>BiChart);
parcelHelpers.export(exports, "BiChat", ()=>BiChat);
parcelHelpers.export(exports, "BiCheckCircle", ()=>BiCheckCircle);
parcelHelpers.export(exports, "BiCheckDouble", ()=>BiCheckDouble);
parcelHelpers.export(exports, "BiCheckShield", ()=>BiCheckShield);
parcelHelpers.export(exports, "BiCheckSquare", ()=>BiCheckSquare);
parcelHelpers.export(exports, "BiCheck", ()=>BiCheck);
parcelHelpers.export(exports, "BiCheckboxChecked", ()=>BiCheckboxChecked);
parcelHelpers.export(exports, "BiCheckboxMinus", ()=>BiCheckboxMinus);
parcelHelpers.export(exports, "BiCheckboxSquare", ()=>BiCheckboxSquare);
parcelHelpers.export(exports, "BiCheckbox", ()=>BiCheckbox);
parcelHelpers.export(exports, "BiCheese", ()=>BiCheese);
parcelHelpers.export(exports, "BiChevronDownCircle", ()=>BiChevronDownCircle);
parcelHelpers.export(exports, "BiChevronDownSquare", ()=>BiChevronDownSquare);
parcelHelpers.export(exports, "BiChevronDown", ()=>BiChevronDown);
parcelHelpers.export(exports, "BiChevronLeftCircle", ()=>BiChevronLeftCircle);
parcelHelpers.export(exports, "BiChevronLeftSquare", ()=>BiChevronLeftSquare);
parcelHelpers.export(exports, "BiChevronLeft", ()=>BiChevronLeft);
parcelHelpers.export(exports, "BiChevronRightCircle", ()=>BiChevronRightCircle);
parcelHelpers.export(exports, "BiChevronRightSquare", ()=>BiChevronRightSquare);
parcelHelpers.export(exports, "BiChevronRight", ()=>BiChevronRight);
parcelHelpers.export(exports, "BiChevronUpCircle", ()=>BiChevronUpCircle);
parcelHelpers.export(exports, "BiChevronUpSquare", ()=>BiChevronUpSquare);
parcelHelpers.export(exports, "BiChevronUp", ()=>BiChevronUp);
parcelHelpers.export(exports, "BiChevronsDown", ()=>BiChevronsDown);
parcelHelpers.export(exports, "BiChevronsLeft", ()=>BiChevronsLeft);
parcelHelpers.export(exports, "BiChevronsRight", ()=>BiChevronsRight);
parcelHelpers.export(exports, "BiChevronsUp", ()=>BiChevronsUp);
parcelHelpers.export(exports, "BiChild", ()=>BiChild);
parcelHelpers.export(exports, "BiChip", ()=>BiChip);
parcelHelpers.export(exports, "BiChurch", ()=>BiChurch);
parcelHelpers.export(exports, "BiCircleHalf", ()=>BiCircleHalf);
parcelHelpers.export(exports, "BiCircleQuarter", ()=>BiCircleQuarter);
parcelHelpers.export(exports, "BiCircleThreeQuarter", ()=>BiCircleThreeQuarter);
parcelHelpers.export(exports, "BiCircle", ()=>BiCircle);
parcelHelpers.export(exports, "BiClinic", ()=>BiClinic);
parcelHelpers.export(exports, "BiClipboard", ()=>BiClipboard);
parcelHelpers.export(exports, "BiCloset", ()=>BiCloset);
parcelHelpers.export(exports, "BiCloudDownload", ()=>BiCloudDownload);
parcelHelpers.export(exports, "BiCloudDrizzle", ()=>BiCloudDrizzle);
parcelHelpers.export(exports, "BiCloudLightRain", ()=>BiCloudLightRain);
parcelHelpers.export(exports, "BiCloudLightning", ()=>BiCloudLightning);
parcelHelpers.export(exports, "BiCloudRain", ()=>BiCloudRain);
parcelHelpers.export(exports, "BiCloudSnow", ()=>BiCloudSnow);
parcelHelpers.export(exports, "BiCloudUpload", ()=>BiCloudUpload);
parcelHelpers.export(exports, "BiCloud", ()=>BiCloud);
parcelHelpers.export(exports, "BiCodeAlt", ()=>BiCodeAlt);
parcelHelpers.export(exports, "BiCodeBlock", ()=>BiCodeBlock);
parcelHelpers.export(exports, "BiCodeCurly", ()=>BiCodeCurly);
parcelHelpers.export(exports, "BiCode", ()=>BiCode);
parcelHelpers.export(exports, "BiCoffeeTogo", ()=>BiCoffeeTogo);
parcelHelpers.export(exports, "BiCoffee", ()=>BiCoffee);
parcelHelpers.export(exports, "BiCog", ()=>BiCog);
parcelHelpers.export(exports, "BiCoinStack", ()=>BiCoinStack);
parcelHelpers.export(exports, "BiCoin", ()=>BiCoin);
parcelHelpers.export(exports, "BiCollapseAlt", ()=>BiCollapseAlt);
parcelHelpers.export(exports, "BiCollapseHorizontal", ()=>BiCollapseHorizontal);
parcelHelpers.export(exports, "BiCollapseVertical", ()=>BiCollapseVertical);
parcelHelpers.export(exports, "BiCollapse", ()=>BiCollapse);
parcelHelpers.export(exports, "BiCollection", ()=>BiCollection);
parcelHelpers.export(exports, "BiColorFill", ()=>BiColorFill);
parcelHelpers.export(exports, "BiColor", ()=>BiColor);
parcelHelpers.export(exports, "BiColumns", ()=>BiColumns);
parcelHelpers.export(exports, "BiCommand", ()=>BiCommand);
parcelHelpers.export(exports, "BiCommentAdd", ()=>BiCommentAdd);
parcelHelpers.export(exports, "BiCommentCheck", ()=>BiCommentCheck);
parcelHelpers.export(exports, "BiCommentDetail", ()=>BiCommentDetail);
parcelHelpers.export(exports, "BiCommentDots", ()=>BiCommentDots);
parcelHelpers.export(exports, "BiCommentEdit", ()=>BiCommentEdit);
parcelHelpers.export(exports, "BiCommentError", ()=>BiCommentError);
parcelHelpers.export(exports, "BiCommentMinus", ()=>BiCommentMinus);
parcelHelpers.export(exports, "BiCommentX", ()=>BiCommentX);
parcelHelpers.export(exports, "BiComment", ()=>BiComment);
parcelHelpers.export(exports, "BiCompass", ()=>BiCompass);
parcelHelpers.export(exports, "BiConfused", ()=>BiConfused);
parcelHelpers.export(exports, "BiConversation", ()=>BiConversation);
parcelHelpers.export(exports, "BiCookie", ()=>BiCookie);
parcelHelpers.export(exports, "BiCool", ()=>BiCool);
parcelHelpers.export(exports, "BiCopyAlt", ()=>BiCopyAlt);
parcelHelpers.export(exports, "BiCopy", ()=>BiCopy);
parcelHelpers.export(exports, "BiCopyright", ()=>BiCopyright);
parcelHelpers.export(exports, "BiCreditCardAlt", ()=>BiCreditCardAlt);
parcelHelpers.export(exports, "BiCreditCardFront", ()=>BiCreditCardFront);
parcelHelpers.export(exports, "BiCreditCard", ()=>BiCreditCard);
parcelHelpers.export(exports, "BiCricketBall", ()=>BiCricketBall);
parcelHelpers.export(exports, "BiCrop", ()=>BiCrop);
parcelHelpers.export(exports, "BiCross", ()=>BiCross);
parcelHelpers.export(exports, "BiCrosshair", ()=>BiCrosshair);
parcelHelpers.export(exports, "BiCrown", ()=>BiCrown);
parcelHelpers.export(exports, "BiCubeAlt", ()=>BiCubeAlt);
parcelHelpers.export(exports, "BiCube", ()=>BiCube);
parcelHelpers.export(exports, "BiCuboid", ()=>BiCuboid);
parcelHelpers.export(exports, "BiCurrentLocation", ()=>BiCurrentLocation);
parcelHelpers.export(exports, "BiCustomize", ()=>BiCustomize);
parcelHelpers.export(exports, "BiCut", ()=>BiCut);
parcelHelpers.export(exports, "BiCycling", ()=>BiCycling);
parcelHelpers.export(exports, "BiCylinder", ()=>BiCylinder);
parcelHelpers.export(exports, "BiData", ()=>BiData);
parcelHelpers.export(exports, "BiDesktop", ()=>BiDesktop);
parcelHelpers.export(exports, "BiDetail", ()=>BiDetail);
parcelHelpers.export(exports, "BiDevices", ()=>BiDevices);
parcelHelpers.export(exports, "BiDialpadAlt", ()=>BiDialpadAlt);
parcelHelpers.export(exports, "BiDialpad", ()=>BiDialpad);
parcelHelpers.export(exports, "BiDiamond", ()=>BiDiamond);
parcelHelpers.export(exports, "BiDice1", ()=>BiDice1);
parcelHelpers.export(exports, "BiDice2", ()=>BiDice2);
parcelHelpers.export(exports, "BiDice3", ()=>BiDice3);
parcelHelpers.export(exports, "BiDice4", ()=>BiDice4);
parcelHelpers.export(exports, "BiDice5", ()=>BiDice5);
parcelHelpers.export(exports, "BiDice6", ()=>BiDice6);
parcelHelpers.export(exports, "BiDirections", ()=>BiDirections);
parcelHelpers.export(exports, "BiDisc", ()=>BiDisc);
parcelHelpers.export(exports, "BiDish", ()=>BiDish);
parcelHelpers.export(exports, "BiDislike", ()=>BiDislike);
parcelHelpers.export(exports, "BiDizzy", ()=>BiDizzy);
parcelHelpers.export(exports, "BiDna", ()=>BiDna);
parcelHelpers.export(exports, "BiDockBottom", ()=>BiDockBottom);
parcelHelpers.export(exports, "BiDockLeft", ()=>BiDockLeft);
parcelHelpers.export(exports, "BiDockRight", ()=>BiDockRight);
parcelHelpers.export(exports, "BiDockTop", ()=>BiDockTop);
parcelHelpers.export(exports, "BiDollarCircle", ()=>BiDollarCircle);
parcelHelpers.export(exports, "BiDollar", ()=>BiDollar);
parcelHelpers.export(exports, "BiDonateBlood", ()=>BiDonateBlood);
parcelHelpers.export(exports, "BiDonateHeart", ()=>BiDonateHeart);
parcelHelpers.export(exports, "BiDoorOpen", ()=>BiDoorOpen);
parcelHelpers.export(exports, "BiDotsHorizontalRounded", ()=>BiDotsHorizontalRounded);
parcelHelpers.export(exports, "BiDotsHorizontal", ()=>BiDotsHorizontal);
parcelHelpers.export(exports, "BiDotsVerticalRounded", ()=>BiDotsVerticalRounded);
parcelHelpers.export(exports, "BiDotsVertical", ()=>BiDotsVertical);
parcelHelpers.export(exports, "BiDoughnutChart", ()=>BiDoughnutChart);
parcelHelpers.export(exports, "BiDownArrowAlt", ()=>BiDownArrowAlt);
parcelHelpers.export(exports, "BiDownArrowCircle", ()=>BiDownArrowCircle);
parcelHelpers.export(exports, "BiDownArrow", ()=>BiDownArrow);
parcelHelpers.export(exports, "BiDownload", ()=>BiDownload);
parcelHelpers.export(exports, "BiDownvote", ()=>BiDownvote);
parcelHelpers.export(exports, "BiDrink", ()=>BiDrink);
parcelHelpers.export(exports, "BiDroplet", ()=>BiDroplet);
parcelHelpers.export(exports, "BiDumbbell", ()=>BiDumbbell);
parcelHelpers.export(exports, "BiDuplicate", ()=>BiDuplicate);
parcelHelpers.export(exports, "BiEditAlt", ()=>BiEditAlt);
parcelHelpers.export(exports, "BiEdit", ()=>BiEdit);
parcelHelpers.export(exports, "BiEnvelopeOpen", ()=>BiEnvelopeOpen);
parcelHelpers.export(exports, "BiEnvelope", ()=>BiEnvelope);
parcelHelpers.export(exports, "BiEqualizer", ()=>BiEqualizer);
parcelHelpers.export(exports, "BiEraser", ()=>BiEraser);
parcelHelpers.export(exports, "BiErrorAlt", ()=>BiErrorAlt);
parcelHelpers.export(exports, "BiErrorCircle", ()=>BiErrorCircle);
parcelHelpers.export(exports, "BiError", ()=>BiError);
parcelHelpers.export(exports, "BiEuro", ()=>BiEuro);
parcelHelpers.export(exports, "BiExclude", ()=>BiExclude);
parcelHelpers.export(exports, "BiExitFullscreen", ()=>BiExitFullscreen);
parcelHelpers.export(exports, "BiExit", ()=>BiExit);
parcelHelpers.export(exports, "BiExpandAlt", ()=>BiExpandAlt);
parcelHelpers.export(exports, "BiExpandHorizontal", ()=>BiExpandHorizontal);
parcelHelpers.export(exports, "BiExpandVertical", ()=>BiExpandVertical);
parcelHelpers.export(exports, "BiExpand", ()=>BiExpand);
parcelHelpers.export(exports, "BiExport", ()=>BiExport);
parcelHelpers.export(exports, "BiExtension", ()=>BiExtension);
parcelHelpers.export(exports, "BiFace", ()=>BiFace);
parcelHelpers.export(exports, "BiFastForwardCircle", ()=>BiFastForwardCircle);
parcelHelpers.export(exports, "BiFastForward", ()=>BiFastForward);
parcelHelpers.export(exports, "BiFemaleSign", ()=>BiFemaleSign);
parcelHelpers.export(exports, "BiFemale", ()=>BiFemale);
parcelHelpers.export(exports, "BiFileBlank", ()=>BiFileBlank);
parcelHelpers.export(exports, "BiFileFind", ()=>BiFileFind);
parcelHelpers.export(exports, "BiFile", ()=>BiFile);
parcelHelpers.export(exports, "BiFilm", ()=>BiFilm);
parcelHelpers.export(exports, "BiFilterAlt", ()=>BiFilterAlt);
parcelHelpers.export(exports, "BiFilter", ()=>BiFilter);
parcelHelpers.export(exports, "BiFingerprint", ()=>BiFingerprint);
parcelHelpers.export(exports, "BiFirstAid", ()=>BiFirstAid);
parcelHelpers.export(exports, "BiFirstPage", ()=>BiFirstPage);
parcelHelpers.export(exports, "BiFlag", ()=>BiFlag);
parcelHelpers.export(exports, "BiFolderMinus", ()=>BiFolderMinus);
parcelHelpers.export(exports, "BiFolderOpen", ()=>BiFolderOpen);
parcelHelpers.export(exports, "BiFolderPlus", ()=>BiFolderPlus);
parcelHelpers.export(exports, "BiFolder", ()=>BiFolder);
parcelHelpers.export(exports, "BiFontColor", ()=>BiFontColor);
parcelHelpers.export(exports, "BiFontFamily", ()=>BiFontFamily);
parcelHelpers.export(exports, "BiFontSize", ()=>BiFontSize);
parcelHelpers.export(exports, "BiFont", ()=>BiFont);
parcelHelpers.export(exports, "BiFoodMenu", ()=>BiFoodMenu);
parcelHelpers.export(exports, "BiFoodTag", ()=>BiFoodTag);
parcelHelpers.export(exports, "BiFootball", ()=>BiFootball);
parcelHelpers.export(exports, "BiFork", ()=>BiFork);
parcelHelpers.export(exports, "BiFridge", ()=>BiFridge);
parcelHelpers.export(exports, "BiFullscreen", ()=>BiFullscreen);
parcelHelpers.export(exports, "BiGame", ()=>BiGame);
parcelHelpers.export(exports, "BiGasPump", ()=>BiGasPump);
parcelHelpers.export(exports, "BiGhost", ()=>BiGhost);
parcelHelpers.export(exports, "BiGift", ()=>BiGift);
parcelHelpers.export(exports, "BiGitBranch", ()=>BiGitBranch);
parcelHelpers.export(exports, "BiGitCommit", ()=>BiGitCommit);
parcelHelpers.export(exports, "BiGitCompare", ()=>BiGitCompare);
parcelHelpers.export(exports, "BiGitMerge", ()=>BiGitMerge);
parcelHelpers.export(exports, "BiGitPullRequest", ()=>BiGitPullRequest);
parcelHelpers.export(exports, "BiGitRepoForked", ()=>BiGitRepoForked);
parcelHelpers.export(exports, "BiGlassesAlt", ()=>BiGlassesAlt);
parcelHelpers.export(exports, "BiGlasses", ()=>BiGlasses);
parcelHelpers.export(exports, "BiGlobeAlt", ()=>BiGlobeAlt);
parcelHelpers.export(exports, "BiGlobe", ()=>BiGlobe);
parcelHelpers.export(exports, "BiGridAlt", ()=>BiGridAlt);
parcelHelpers.export(exports, "BiGridHorizontal", ()=>BiGridHorizontal);
parcelHelpers.export(exports, "BiGridSmall", ()=>BiGridSmall);
parcelHelpers.export(exports, "BiGridVertical", ()=>BiGridVertical);
parcelHelpers.export(exports, "BiGrid", ()=>BiGrid);
parcelHelpers.export(exports, "BiGroup", ()=>BiGroup);
parcelHelpers.export(exports, "BiHandicap", ()=>BiHandicap);
parcelHelpers.export(exports, "BiHappyAlt", ()=>BiHappyAlt);
parcelHelpers.export(exports, "BiHappyBeaming", ()=>BiHappyBeaming);
parcelHelpers.export(exports, "BiHappyHeartEyes", ()=>BiHappyHeartEyes);
parcelHelpers.export(exports, "BiHappy", ()=>BiHappy);
parcelHelpers.export(exports, "BiHardHat", ()=>BiHardHat);
parcelHelpers.export(exports, "BiHash", ()=>BiHash);
parcelHelpers.export(exports, "BiHdd", ()=>BiHdd);
parcelHelpers.export(exports, "BiHeading", ()=>BiHeading);
parcelHelpers.export(exports, "BiHeadphone", ()=>BiHeadphone);
parcelHelpers.export(exports, "BiHealth", ()=>BiHealth);
parcelHelpers.export(exports, "BiHeartCircle", ()=>BiHeartCircle);
parcelHelpers.export(exports, "BiHeartSquare", ()=>BiHeartSquare);
parcelHelpers.export(exports, "BiHeart", ()=>BiHeart);
parcelHelpers.export(exports, "BiHelpCircle", ()=>BiHelpCircle);
parcelHelpers.export(exports, "BiHide", ()=>BiHide);
parcelHelpers.export(exports, "BiHighlight", ()=>BiHighlight);
parcelHelpers.export(exports, "BiHistory", ()=>BiHistory);
parcelHelpers.export(exports, "BiHive", ()=>BiHive);
parcelHelpers.export(exports, "BiHomeAlt2", ()=>BiHomeAlt2);
parcelHelpers.export(exports, "BiHomeAlt", ()=>BiHomeAlt);
parcelHelpers.export(exports, "BiHomeCircle", ()=>BiHomeCircle);
parcelHelpers.export(exports, "BiHomeHeart", ()=>BiHomeHeart);
parcelHelpers.export(exports, "BiHomeSmile", ()=>BiHomeSmile);
parcelHelpers.export(exports, "BiHome", ()=>BiHome);
parcelHelpers.export(exports, "BiHorizontalCenter", ()=>BiHorizontalCenter);
parcelHelpers.export(exports, "BiHorizontalLeft", ()=>BiHorizontalLeft);
parcelHelpers.export(exports, "BiHorizontalRight", ()=>BiHorizontalRight);
parcelHelpers.export(exports, "BiHotel", ()=>BiHotel);
parcelHelpers.export(exports, "BiHourglass", ()=>BiHourglass);
parcelHelpers.export(exports, "BiIdCard", ()=>BiIdCard);
parcelHelpers.export(exports, "BiImageAdd", ()=>BiImageAdd);
parcelHelpers.export(exports, "BiImageAlt", ()=>BiImageAlt);
parcelHelpers.export(exports, "BiImage", ()=>BiImage);
parcelHelpers.export(exports, "BiImages", ()=>BiImages);
parcelHelpers.export(exports, "BiImport", ()=>BiImport);
parcelHelpers.export(exports, "BiInfinite", ()=>BiInfinite);
parcelHelpers.export(exports, "BiInfoCircle", ()=>BiInfoCircle);
parcelHelpers.export(exports, "BiInfoSquare", ()=>BiInfoSquare);
parcelHelpers.export(exports, "BiInjection", ()=>BiInjection);
parcelHelpers.export(exports, "BiIntersect", ()=>BiIntersect);
parcelHelpers.export(exports, "BiItalic", ()=>BiItalic);
parcelHelpers.export(exports, "BiJoystickAlt", ()=>BiJoystickAlt);
parcelHelpers.export(exports, "BiJoystickButton", ()=>BiJoystickButton);
parcelHelpers.export(exports, "BiJoystick", ()=>BiJoystick);
parcelHelpers.export(exports, "BiKey", ()=>BiKey);
parcelHelpers.export(exports, "BiKnife", ()=>BiKnife);
parcelHelpers.export(exports, "BiLabel", ()=>BiLabel);
parcelHelpers.export(exports, "BiLandscape", ()=>BiLandscape);
parcelHelpers.export(exports, "BiLaptop", ()=>BiLaptop);
parcelHelpers.export(exports, "BiLastPage", ()=>BiLastPage);
parcelHelpers.export(exports, "BiLaugh", ()=>BiLaugh);
parcelHelpers.export(exports, "BiLayerMinus", ()=>BiLayerMinus);
parcelHelpers.export(exports, "BiLayerPlus", ()=>BiLayerPlus);
parcelHelpers.export(exports, "BiLayer", ()=>BiLayer);
parcelHelpers.export(exports, "BiLayout", ()=>BiLayout);
parcelHelpers.export(exports, "BiLeaf", ()=>BiLeaf);
parcelHelpers.export(exports, "BiLeftArrowAlt", ()=>BiLeftArrowAlt);
parcelHelpers.export(exports, "BiLeftArrowCircle", ()=>BiLeftArrowCircle);
parcelHelpers.export(exports, "BiLeftArrow", ()=>BiLeftArrow);
parcelHelpers.export(exports, "BiLeftDownArrowCircle", ()=>BiLeftDownArrowCircle);
parcelHelpers.export(exports, "BiLeftIndent", ()=>BiLeftIndent);
parcelHelpers.export(exports, "BiLeftTopArrowCircle", ()=>BiLeftTopArrowCircle);
parcelHelpers.export(exports, "BiLemon", ()=>BiLemon);
parcelHelpers.export(exports, "BiLibrary", ()=>BiLibrary);
parcelHelpers.export(exports, "BiLike", ()=>BiLike);
parcelHelpers.export(exports, "BiLineChartDown", ()=>BiLineChartDown);
parcelHelpers.export(exports, "BiLineChart", ()=>BiLineChart);
parcelHelpers.export(exports, "BiLinkAlt", ()=>BiLinkAlt);
parcelHelpers.export(exports, "BiLinkExternal", ()=>BiLinkExternal);
parcelHelpers.export(exports, "BiLink", ()=>BiLink);
parcelHelpers.export(exports, "BiLira", ()=>BiLira);
parcelHelpers.export(exports, "BiListCheck", ()=>BiListCheck);
parcelHelpers.export(exports, "BiListMinus", ()=>BiListMinus);
parcelHelpers.export(exports, "BiListOl", ()=>BiListOl);
parcelHelpers.export(exports, "BiListPlus", ()=>BiListPlus);
parcelHelpers.export(exports, "BiListUl", ()=>BiListUl);
parcelHelpers.export(exports, "BiLoaderAlt", ()=>BiLoaderAlt);
parcelHelpers.export(exports, "BiLoaderCircle", ()=>BiLoaderCircle);
parcelHelpers.export(exports, "BiLoader", ()=>BiLoader);
parcelHelpers.export(exports, "BiLocationPlus", ()=>BiLocationPlus);
parcelHelpers.export(exports, "BiLockAlt", ()=>BiLockAlt);
parcelHelpers.export(exports, "BiLockOpenAlt", ()=>BiLockOpenAlt);
parcelHelpers.export(exports, "BiLockOpen", ()=>BiLockOpen);
parcelHelpers.export(exports, "BiLock", ()=>BiLock);
parcelHelpers.export(exports, "BiLogInCircle", ()=>BiLogInCircle);
parcelHelpers.export(exports, "BiLogIn", ()=>BiLogIn);
parcelHelpers.export(exports, "BiLogOutCircle", ()=>BiLogOutCircle);
parcelHelpers.export(exports, "BiLogOut", ()=>BiLogOut);
parcelHelpers.export(exports, "BiLowVision", ()=>BiLowVision);
parcelHelpers.export(exports, "BiMagnet", ()=>BiMagnet);
parcelHelpers.export(exports, "BiMailSend", ()=>BiMailSend);
parcelHelpers.export(exports, "BiMaleFemale", ()=>BiMaleFemale);
parcelHelpers.export(exports, "BiMaleSign", ()=>BiMaleSign);
parcelHelpers.export(exports, "BiMale", ()=>BiMale);
parcelHelpers.export(exports, "BiMapAlt", ()=>BiMapAlt);
parcelHelpers.export(exports, "BiMapPin", ()=>BiMapPin);
parcelHelpers.export(exports, "BiMap", ()=>BiMap);
parcelHelpers.export(exports, "BiMask", ()=>BiMask);
parcelHelpers.export(exports, "BiMath", ()=>BiMath);
parcelHelpers.export(exports, "BiMedal", ()=>BiMedal);
parcelHelpers.export(exports, "BiMehAlt", ()=>BiMehAlt);
parcelHelpers.export(exports, "BiMehBlank", ()=>BiMehBlank);
parcelHelpers.export(exports, "BiMeh", ()=>BiMeh);
parcelHelpers.export(exports, "BiMemoryCard", ()=>BiMemoryCard);
parcelHelpers.export(exports, "BiMenuAltLeft", ()=>BiMenuAltLeft);
parcelHelpers.export(exports, "BiMenuAltRight", ()=>BiMenuAltRight);
parcelHelpers.export(exports, "BiMenu", ()=>BiMenu);
parcelHelpers.export(exports, "BiMerge", ()=>BiMerge);
parcelHelpers.export(exports, "BiMessageAdd", ()=>BiMessageAdd);
parcelHelpers.export(exports, "BiMessageAltAdd", ()=>BiMessageAltAdd);
parcelHelpers.export(exports, "BiMessageAltCheck", ()=>BiMessageAltCheck);
parcelHelpers.export(exports, "BiMessageAltDetail", ()=>BiMessageAltDetail);
parcelHelpers.export(exports, "BiMessageAltDots", ()=>BiMessageAltDots);
parcelHelpers.export(exports, "BiMessageAltEdit", ()=>BiMessageAltEdit);
parcelHelpers.export(exports, "BiMessageAltError", ()=>BiMessageAltError);
parcelHelpers.export(exports, "BiMessageAltMinus", ()=>BiMessageAltMinus);
parcelHelpers.export(exports, "BiMessageAltX", ()=>BiMessageAltX);
parcelHelpers.export(exports, "BiMessageAlt", ()=>BiMessageAlt);
parcelHelpers.export(exports, "BiMessageCheck", ()=>BiMessageCheck);
parcelHelpers.export(exports, "BiMessageDetail", ()=>BiMessageDetail);
parcelHelpers.export(exports, "BiMessageDots", ()=>BiMessageDots);
parcelHelpers.export(exports, "BiMessageEdit", ()=>BiMessageEdit);
parcelHelpers.export(exports, "BiMessageError", ()=>BiMessageError);
parcelHelpers.export(exports, "BiMessageMinus", ()=>BiMessageMinus);
parcelHelpers.export(exports, "BiMessageRoundedAdd", ()=>BiMessageRoundedAdd);
parcelHelpers.export(exports, "BiMessageRoundedCheck", ()=>BiMessageRoundedCheck);
parcelHelpers.export(exports, "BiMessageRoundedDetail", ()=>BiMessageRoundedDetail);
parcelHelpers.export(exports, "BiMessageRoundedDots", ()=>BiMessageRoundedDots);
parcelHelpers.export(exports, "BiMessageRoundedEdit", ()=>BiMessageRoundedEdit);
parcelHelpers.export(exports, "BiMessageRoundedError", ()=>BiMessageRoundedError);
parcelHelpers.export(exports, "BiMessageRoundedMinus", ()=>BiMessageRoundedMinus);
parcelHelpers.export(exports, "BiMessageRoundedX", ()=>BiMessageRoundedX);
parcelHelpers.export(exports, "BiMessageRounded", ()=>BiMessageRounded);
parcelHelpers.export(exports, "BiMessageSquareAdd", ()=>BiMessageSquareAdd);
parcelHelpers.export(exports, "BiMessageSquareCheck", ()=>BiMessageSquareCheck);
parcelHelpers.export(exports, "BiMessageSquareDetail", ()=>BiMessageSquareDetail);
parcelHelpers.export(exports, "BiMessageSquareDots", ()=>BiMessageSquareDots);
parcelHelpers.export(exports, "BiMessageSquareEdit", ()=>BiMessageSquareEdit);
parcelHelpers.export(exports, "BiMessageSquareError", ()=>BiMessageSquareError);
parcelHelpers.export(exports, "BiMessageSquareMinus", ()=>BiMessageSquareMinus);
parcelHelpers.export(exports, "BiMessageSquareX", ()=>BiMessageSquareX);
parcelHelpers.export(exports, "BiMessageSquare", ()=>BiMessageSquare);
parcelHelpers.export(exports, "BiMessageX", ()=>BiMessageX);
parcelHelpers.export(exports, "BiMessage", ()=>BiMessage);
parcelHelpers.export(exports, "BiMeteor", ()=>BiMeteor);
parcelHelpers.export(exports, "BiMicrochip", ()=>BiMicrochip);
parcelHelpers.export(exports, "BiMicrophoneOff", ()=>BiMicrophoneOff);
parcelHelpers.export(exports, "BiMicrophone", ()=>BiMicrophone);
parcelHelpers.export(exports, "BiMinusBack", ()=>BiMinusBack);
parcelHelpers.export(exports, "BiMinusCircle", ()=>BiMinusCircle);
parcelHelpers.export(exports, "BiMinusFront", ()=>BiMinusFront);
parcelHelpers.export(exports, "BiMinus", ()=>BiMinus);
parcelHelpers.export(exports, "BiMobileAlt", ()=>BiMobileAlt);
parcelHelpers.export(exports, "BiMobileLandscape", ()=>BiMobileLandscape);
parcelHelpers.export(exports, "BiMobileVibration", ()=>BiMobileVibration);
parcelHelpers.export(exports, "BiMobile", ()=>BiMobile);
parcelHelpers.export(exports, "BiMoneyWithdraw", ()=>BiMoneyWithdraw);
parcelHelpers.export(exports, "BiMoney", ()=>BiMoney);
parcelHelpers.export(exports, "BiMoon", ()=>BiMoon);
parcelHelpers.export(exports, "BiMouseAlt", ()=>BiMouseAlt);
parcelHelpers.export(exports, "BiMouse", ()=>BiMouse);
parcelHelpers.export(exports, "BiMoveHorizontal", ()=>BiMoveHorizontal);
parcelHelpers.export(exports, "BiMoveVertical", ()=>BiMoveVertical);
parcelHelpers.export(exports, "BiMove", ()=>BiMove);
parcelHelpers.export(exports, "BiMoviePlay", ()=>BiMoviePlay);
parcelHelpers.export(exports, "BiMovie", ()=>BiMovie);
parcelHelpers.export(exports, "BiMusic", ()=>BiMusic);
parcelHelpers.export(exports, "BiNavigation", ()=>BiNavigation);
parcelHelpers.export(exports, "BiNetworkChart", ()=>BiNetworkChart);
parcelHelpers.export(exports, "BiNews", ()=>BiNews);
parcelHelpers.export(exports, "BiNoEntry", ()=>BiNoEntry);
parcelHelpers.export(exports, "BiNoSignal", ()=>BiNoSignal);
parcelHelpers.export(exports, "BiNote", ()=>BiNote);
parcelHelpers.export(exports, "BiNotepad", ()=>BiNotepad);
parcelHelpers.export(exports, "BiNotificationOff", ()=>BiNotificationOff);
parcelHelpers.export(exports, "BiNotification", ()=>BiNotification);
parcelHelpers.export(exports, "BiObjectsHorizontalCenter", ()=>BiObjectsHorizontalCenter);
parcelHelpers.export(exports, "BiObjectsHorizontalLeft", ()=>BiObjectsHorizontalLeft);
parcelHelpers.export(exports, "BiObjectsHorizontalRight", ()=>BiObjectsHorizontalRight);
parcelHelpers.export(exports, "BiObjectsVerticalBottom", ()=>BiObjectsVerticalBottom);
parcelHelpers.export(exports, "BiObjectsVerticalCenter", ()=>BiObjectsVerticalCenter);
parcelHelpers.export(exports, "BiObjectsVerticalTop", ()=>BiObjectsVerticalTop);
parcelHelpers.export(exports, "BiOutline", ()=>BiOutline);
parcelHelpers.export(exports, "BiPackage", ()=>BiPackage);
parcelHelpers.export(exports, "BiPaintRoll", ()=>BiPaintRoll);
parcelHelpers.export(exports, "BiPaint", ()=>BiPaint);
parcelHelpers.export(exports, "BiPalette", ()=>BiPalette);
parcelHelpers.export(exports, "BiPaperPlane", ()=>BiPaperPlane);
parcelHelpers.export(exports, "BiPaperclip", ()=>BiPaperclip);
parcelHelpers.export(exports, "BiParagraph", ()=>BiParagraph);
parcelHelpers.export(exports, "BiParty", ()=>BiParty);
parcelHelpers.export(exports, "BiPaste", ()=>BiPaste);
parcelHelpers.export(exports, "BiPauseCircle", ()=>BiPauseCircle);
parcelHelpers.export(exports, "BiPause", ()=>BiPause);
parcelHelpers.export(exports, "BiPen", ()=>BiPen);
parcelHelpers.export(exports, "BiPencil", ()=>BiPencil);
parcelHelpers.export(exports, "BiPhoneCall", ()=>BiPhoneCall);
parcelHelpers.export(exports, "BiPhoneIncoming", ()=>BiPhoneIncoming);
parcelHelpers.export(exports, "BiPhoneOff", ()=>BiPhoneOff);
parcelHelpers.export(exports, "BiPhoneOutgoing", ()=>BiPhoneOutgoing);
parcelHelpers.export(exports, "BiPhone", ()=>BiPhone);
parcelHelpers.export(exports, "BiPhotoAlbum", ()=>BiPhotoAlbum);
parcelHelpers.export(exports, "BiPieChartAlt2", ()=>BiPieChartAlt2);
parcelHelpers.export(exports, "BiPieChartAlt", ()=>BiPieChartAlt);
parcelHelpers.export(exports, "BiPieChart", ()=>BiPieChart);
parcelHelpers.export(exports, "BiPin", ()=>BiPin);
parcelHelpers.export(exports, "BiPlanet", ()=>BiPlanet);
parcelHelpers.export(exports, "BiPlayCircle", ()=>BiPlayCircle);
parcelHelpers.export(exports, "BiPlay", ()=>BiPlay);
parcelHelpers.export(exports, "BiPlug", ()=>BiPlug);
parcelHelpers.export(exports, "BiPlusCircle", ()=>BiPlusCircle);
parcelHelpers.export(exports, "BiPlusMedical", ()=>BiPlusMedical);
parcelHelpers.export(exports, "BiPlus", ()=>BiPlus);
parcelHelpers.export(exports, "BiPodcast", ()=>BiPodcast);
parcelHelpers.export(exports, "BiPointer", ()=>BiPointer);
parcelHelpers.export(exports, "BiPoll", ()=>BiPoll);
parcelHelpers.export(exports, "BiPolygon", ()=>BiPolygon);
parcelHelpers.export(exports, "BiPopsicle", ()=>BiPopsicle);
parcelHelpers.export(exports, "BiPound", ()=>BiPound);
parcelHelpers.export(exports, "BiPowerOff", ()=>BiPowerOff);
parcelHelpers.export(exports, "BiPrinter", ()=>BiPrinter);
parcelHelpers.export(exports, "BiPulse", ()=>BiPulse);
parcelHelpers.export(exports, "BiPurchaseTagAlt", ()=>BiPurchaseTagAlt);
parcelHelpers.export(exports, "BiPurchaseTag", ()=>BiPurchaseTag);
parcelHelpers.export(exports, "BiPyramid", ()=>BiPyramid);
parcelHelpers.export(exports, "BiQrScan", ()=>BiQrScan);
parcelHelpers.export(exports, "BiQr", ()=>BiQr);
parcelHelpers.export(exports, "BiQuestionMark", ()=>BiQuestionMark);
parcelHelpers.export(exports, "BiRadar", ()=>BiRadar);
parcelHelpers.export(exports, "BiRadioCircleMarked", ()=>BiRadioCircleMarked);
parcelHelpers.export(exports, "BiRadioCircle", ()=>BiRadioCircle);
parcelHelpers.export(exports, "BiRadio", ()=>BiRadio);
parcelHelpers.export(exports, "BiReceipt", ()=>BiReceipt);
parcelHelpers.export(exports, "BiRectangle", ()=>BiRectangle);
parcelHelpers.export(exports, "BiRecycle", ()=>BiRecycle);
parcelHelpers.export(exports, "BiRedo", ()=>BiRedo);
parcelHelpers.export(exports, "BiReflectHorizontal", ()=>BiReflectHorizontal);
parcelHelpers.export(exports, "BiReflectVertical", ()=>BiReflectVertical);
parcelHelpers.export(exports, "BiRefresh", ()=>BiRefresh);
parcelHelpers.export(exports, "BiRegistered", ()=>BiRegistered);
parcelHelpers.export(exports, "BiRename", ()=>BiRename);
parcelHelpers.export(exports, "BiRepeat", ()=>BiRepeat);
parcelHelpers.export(exports, "BiReplyAll", ()=>BiReplyAll);
parcelHelpers.export(exports, "BiReply", ()=>BiReply);
parcelHelpers.export(exports, "BiRepost", ()=>BiRepost);
parcelHelpers.export(exports, "BiReset", ()=>BiReset);
parcelHelpers.export(exports, "BiRestaurant", ()=>BiRestaurant);
parcelHelpers.export(exports, "BiRevision", ()=>BiRevision);
parcelHelpers.export(exports, "BiRewindCircle", ()=>BiRewindCircle);
parcelHelpers.export(exports, "BiRewind", ()=>BiRewind);
parcelHelpers.export(exports, "BiRfid", ()=>BiRfid);
parcelHelpers.export(exports, "BiRightArrowAlt", ()=>BiRightArrowAlt);
parcelHelpers.export(exports, "BiRightArrowCircle", ()=>BiRightArrowCircle);
parcelHelpers.export(exports, "BiRightArrow", ()=>BiRightArrow);
parcelHelpers.export(exports, "BiRightDownArrowCircle", ()=>BiRightDownArrowCircle);
parcelHelpers.export(exports, "BiRightIndent", ()=>BiRightIndent);
parcelHelpers.export(exports, "BiRightTopArrowCircle", ()=>BiRightTopArrowCircle);
parcelHelpers.export(exports, "BiRocket", ()=>BiRocket);
parcelHelpers.export(exports, "BiRotateLeft", ()=>BiRotateLeft);
parcelHelpers.export(exports, "BiRotateRight", ()=>BiRotateRight);
parcelHelpers.export(exports, "BiRss", ()=>BiRss);
parcelHelpers.export(exports, "BiRuble", ()=>BiRuble);
parcelHelpers.export(exports, "BiRuler", ()=>BiRuler);
parcelHelpers.export(exports, "BiRun", ()=>BiRun);
parcelHelpers.export(exports, "BiRupee", ()=>BiRupee);
parcelHelpers.export(exports, "BiSad", ()=>BiSad);
parcelHelpers.export(exports, "BiSave", ()=>BiSave);
parcelHelpers.export(exports, "BiScan", ()=>BiScan);
parcelHelpers.export(exports, "BiScatterChart", ()=>BiScatterChart);
parcelHelpers.export(exports, "BiScreenshot", ()=>BiScreenshot);
parcelHelpers.export(exports, "BiSearchAlt2", ()=>BiSearchAlt2);
parcelHelpers.export(exports, "BiSearchAlt", ()=>BiSearchAlt);
parcelHelpers.export(exports, "BiSearch", ()=>BiSearch);
parcelHelpers.export(exports, "BiSelectMultiple", ()=>BiSelectMultiple);
parcelHelpers.export(exports, "BiSelection", ()=>BiSelection);
parcelHelpers.export(exports, "BiSend", ()=>BiSend);
parcelHelpers.export(exports, "BiServer", ()=>BiServer);
parcelHelpers.export(exports, "BiShapeCircle", ()=>BiShapeCircle);
parcelHelpers.export(exports, "BiShapePolygon", ()=>BiShapePolygon);
parcelHelpers.export(exports, "BiShapeSquare", ()=>BiShapeSquare);
parcelHelpers.export(exports, "BiShapeTriangle", ()=>BiShapeTriangle);
parcelHelpers.export(exports, "BiShareAlt", ()=>BiShareAlt);
parcelHelpers.export(exports, "BiShare", ()=>BiShare);
parcelHelpers.export(exports, "BiShekel", ()=>BiShekel);
parcelHelpers.export(exports, "BiShieldAlt2", ()=>BiShieldAlt2);
parcelHelpers.export(exports, "BiShieldAlt", ()=>BiShieldAlt);
parcelHelpers.export(exports, "BiShieldMinus", ()=>BiShieldMinus);
parcelHelpers.export(exports, "BiShieldPlus", ()=>BiShieldPlus);
parcelHelpers.export(exports, "BiShieldQuarter", ()=>BiShieldQuarter);
parcelHelpers.export(exports, "BiShieldX", ()=>BiShieldX);
parcelHelpers.export(exports, "BiShield", ()=>BiShield);
parcelHelpers.export(exports, "BiShocked", ()=>BiShocked);
parcelHelpers.export(exports, "BiShoppingBag", ()=>BiShoppingBag);
parcelHelpers.export(exports, "BiShowAlt", ()=>BiShowAlt);
parcelHelpers.export(exports, "BiShow", ()=>BiShow);
parcelHelpers.export(exports, "BiShower", ()=>BiShower);
parcelHelpers.export(exports, "BiShuffle", ()=>BiShuffle);
parcelHelpers.export(exports, "BiSidebar", ()=>BiSidebar);
parcelHelpers.export(exports, "BiSignal1", ()=>BiSignal1);
parcelHelpers.export(exports, "BiSignal2", ()=>BiSignal2);
parcelHelpers.export(exports, "BiSignal3", ()=>BiSignal3);
parcelHelpers.export(exports, "BiSignal4", ()=>BiSignal4);
parcelHelpers.export(exports, "BiSignal5", ()=>BiSignal5);
parcelHelpers.export(exports, "BiSitemap", ()=>BiSitemap);
parcelHelpers.export(exports, "BiSkipNextCircle", ()=>BiSkipNextCircle);
parcelHelpers.export(exports, "BiSkipNext", ()=>BiSkipNext);
parcelHelpers.export(exports, "BiSkipPreviousCircle", ()=>BiSkipPreviousCircle);
parcelHelpers.export(exports, "BiSkipPrevious", ()=>BiSkipPrevious);
parcelHelpers.export(exports, "BiSleepy", ()=>BiSleepy);
parcelHelpers.export(exports, "BiSliderAlt", ()=>BiSliderAlt);
parcelHelpers.export(exports, "BiSlider", ()=>BiSlider);
parcelHelpers.export(exports, "BiSlideshow", ()=>BiSlideshow);
parcelHelpers.export(exports, "BiSmile", ()=>BiSmile);
parcelHelpers.export(exports, "BiSortAZ", ()=>BiSortAZ);
parcelHelpers.export(exports, "BiSortAlt2", ()=>BiSortAlt2);
parcelHelpers.export(exports, "BiSortDown", ()=>BiSortDown);
parcelHelpers.export(exports, "BiSortUp", ()=>BiSortUp);
parcelHelpers.export(exports, "BiSortZA", ()=>BiSortZA);
parcelHelpers.export(exports, "BiSort", ()=>BiSort);
parcelHelpers.export(exports, "BiSpa", ()=>BiSpa);
parcelHelpers.export(exports, "BiSpaceBar", ()=>BiSpaceBar);
parcelHelpers.export(exports, "BiSpeaker", ()=>BiSpeaker);
parcelHelpers.export(exports, "BiSprayCan", ()=>BiSprayCan);
parcelHelpers.export(exports, "BiSpreadsheet", ()=>BiSpreadsheet);
parcelHelpers.export(exports, "BiSquareRounded", ()=>BiSquareRounded);
parcelHelpers.export(exports, "BiSquare", ()=>BiSquare);
parcelHelpers.export(exports, "BiStar", ()=>BiStar);
parcelHelpers.export(exports, "BiStation", ()=>BiStation);
parcelHelpers.export(exports, "BiStats", ()=>BiStats);
parcelHelpers.export(exports, "BiSticker", ()=>BiSticker);
parcelHelpers.export(exports, "BiStopCircle", ()=>BiStopCircle);
parcelHelpers.export(exports, "BiStop", ()=>BiStop);
parcelHelpers.export(exports, "BiStopwatch", ()=>BiStopwatch);
parcelHelpers.export(exports, "BiStoreAlt", ()=>BiStoreAlt);
parcelHelpers.export(exports, "BiStore", ()=>BiStore);
parcelHelpers.export(exports, "BiStreetView", ()=>BiStreetView);
parcelHelpers.export(exports, "BiStrikethrough", ()=>BiStrikethrough);
parcelHelpers.export(exports, "BiSubdirectoryLeft", ()=>BiSubdirectoryLeft);
parcelHelpers.export(exports, "BiSubdirectoryRight", ()=>BiSubdirectoryRight);
parcelHelpers.export(exports, "BiSun", ()=>BiSun);
parcelHelpers.export(exports, "BiSupport", ()=>BiSupport);
parcelHelpers.export(exports, "BiSushi", ()=>BiSushi);
parcelHelpers.export(exports, "BiSwim", ()=>BiSwim);
parcelHelpers.export(exports, "BiSync", ()=>BiSync);
parcelHelpers.export(exports, "BiTab", ()=>BiTab);
parcelHelpers.export(exports, "BiTable", ()=>BiTable);
parcelHelpers.export(exports, "BiTachometer", ()=>BiTachometer);
parcelHelpers.export(exports, "BiTagAlt", ()=>BiTagAlt);
parcelHelpers.export(exports, "BiTag", ()=>BiTag);
parcelHelpers.export(exports, "BiTargetLock", ()=>BiTargetLock);
parcelHelpers.export(exports, "BiTaskX", ()=>BiTaskX);
parcelHelpers.export(exports, "BiTask", ()=>BiTask);
parcelHelpers.export(exports, "BiTaxi", ()=>BiTaxi);
parcelHelpers.export(exports, "BiTennisBall", ()=>BiTennisBall);
parcelHelpers.export(exports, "BiTerminal", ()=>BiTerminal);
parcelHelpers.export(exports, "BiTestTube", ()=>BiTestTube);
parcelHelpers.export(exports, "BiText", ()=>BiText);
parcelHelpers.export(exports, "BiTimeFive", ()=>BiTimeFive);
parcelHelpers.export(exports, "BiTime", ()=>BiTime);
parcelHelpers.export(exports, "BiTimer", ()=>BiTimer);
parcelHelpers.export(exports, "BiTired", ()=>BiTired);
parcelHelpers.export(exports, "BiToggleLeft", ()=>BiToggleLeft);
parcelHelpers.export(exports, "BiToggleRight", ()=>BiToggleRight);
parcelHelpers.export(exports, "BiTone", ()=>BiTone);
parcelHelpers.export(exports, "BiTrafficCone", ()=>BiTrafficCone);
parcelHelpers.export(exports, "BiTrain", ()=>BiTrain);
parcelHelpers.export(exports, "BiTransferAlt", ()=>BiTransferAlt);
parcelHelpers.export(exports, "BiTransfer", ()=>BiTransfer);
parcelHelpers.export(exports, "BiTrashAlt", ()=>BiTrashAlt);
parcelHelpers.export(exports, "BiTrash", ()=>BiTrash);
parcelHelpers.export(exports, "BiTrendingDown", ()=>BiTrendingDown);
parcelHelpers.export(exports, "BiTrendingUp", ()=>BiTrendingUp);
parcelHelpers.export(exports, "BiTrim", ()=>BiTrim);
parcelHelpers.export(exports, "BiTrip", ()=>BiTrip);
parcelHelpers.export(exports, "BiTrophy", ()=>BiTrophy);
parcelHelpers.export(exports, "BiTv", ()=>BiTv);
parcelHelpers.export(exports, "BiUnderline", ()=>BiUnderline);
parcelHelpers.export(exports, "BiUndo", ()=>BiUndo);
parcelHelpers.export(exports, "BiUnite", ()=>BiUnite);
parcelHelpers.export(exports, "BiUniversalAccess", ()=>BiUniversalAccess);
parcelHelpers.export(exports, "BiUnlink", ()=>BiUnlink);
parcelHelpers.export(exports, "BiUpArrowAlt", ()=>BiUpArrowAlt);
parcelHelpers.export(exports, "BiUpArrowCircle", ()=>BiUpArrowCircle);
parcelHelpers.export(exports, "BiUpArrow", ()=>BiUpArrow);
parcelHelpers.export(exports, "BiUpload", ()=>BiUpload);
parcelHelpers.export(exports, "BiUpsideDown", ()=>BiUpsideDown);
parcelHelpers.export(exports, "BiUpvote", ()=>BiUpvote);
parcelHelpers.export(exports, "BiUsb", ()=>BiUsb);
parcelHelpers.export(exports, "BiUserCheck", ()=>BiUserCheck);
parcelHelpers.export(exports, "BiUserCircle", ()=>BiUserCircle);
parcelHelpers.export(exports, "BiUserMinus", ()=>BiUserMinus);
parcelHelpers.export(exports, "BiUserPin", ()=>BiUserPin);
parcelHelpers.export(exports, "BiUserPlus", ()=>BiUserPlus);
parcelHelpers.export(exports, "BiUserVoice", ()=>BiUserVoice);
parcelHelpers.export(exports, "BiUserX", ()=>BiUserX);
parcelHelpers.export(exports, "BiUser", ()=>BiUser);
parcelHelpers.export(exports, "BiVector", ()=>BiVector);
parcelHelpers.export(exports, "BiVerticalBottom", ()=>BiVerticalBottom);
parcelHelpers.export(exports, "BiVerticalCenter", ()=>BiVerticalCenter);
parcelHelpers.export(exports, "BiVerticalTop", ()=>BiVerticalTop);
parcelHelpers.export(exports, "BiVial", ()=>BiVial);
parcelHelpers.export(exports, "BiVideoOff", ()=>BiVideoOff);
parcelHelpers.export(exports, "BiVideoPlus", ()=>BiVideoPlus);
parcelHelpers.export(exports, "BiVideoRecording", ()=>BiVideoRecording);
parcelHelpers.export(exports, "BiVideo", ()=>BiVideo);
parcelHelpers.export(exports, "BiVoicemail", ()=>BiVoicemail);
parcelHelpers.export(exports, "BiVolumeFull", ()=>BiVolumeFull);
parcelHelpers.export(exports, "BiVolumeLow", ()=>BiVolumeLow);
parcelHelpers.export(exports, "BiVolumeMute", ()=>BiVolumeMute);
parcelHelpers.export(exports, "BiVolume", ()=>BiVolume);
parcelHelpers.export(exports, "BiWalk", ()=>BiWalk);
parcelHelpers.export(exports, "BiWalletAlt", ()=>BiWalletAlt);
parcelHelpers.export(exports, "BiWallet", ()=>BiWallet);
parcelHelpers.export(exports, "BiWater", ()=>BiWater);
parcelHelpers.export(exports, "BiWebcam", ()=>BiWebcam);
parcelHelpers.export(exports, "BiWifi0", ()=>BiWifi0);
parcelHelpers.export(exports, "BiWifi1", ()=>BiWifi1);
parcelHelpers.export(exports, "BiWifi2", ()=>BiWifi2);
parcelHelpers.export(exports, "BiWifiOff", ()=>BiWifiOff);
parcelHelpers.export(exports, "BiWifi", ()=>BiWifi);
parcelHelpers.export(exports, "BiWind", ()=>BiWind);
parcelHelpers.export(exports, "BiWindowAlt", ()=>BiWindowAlt);
parcelHelpers.export(exports, "BiWindowClose", ()=>BiWindowClose);
parcelHelpers.export(exports, "BiWindowOpen", ()=>BiWindowOpen);
parcelHelpers.export(exports, "BiWindow", ()=>BiWindow);
parcelHelpers.export(exports, "BiWindows", ()=>BiWindows);
parcelHelpers.export(exports, "BiWine", ()=>BiWine);
parcelHelpers.export(exports, "BiWinkSmile", ()=>BiWinkSmile);
parcelHelpers.export(exports, "BiWinkTongue", ()=>BiWinkTongue);
parcelHelpers.export(exports, "BiWon", ()=>BiWon);
parcelHelpers.export(exports, "BiWorld", ()=>BiWorld);
parcelHelpers.export(exports, "BiWrench", ()=>BiWrench);
parcelHelpers.export(exports, "BiXCircle", ()=>BiXCircle);
parcelHelpers.export(exports, "BiX", ()=>BiX);
parcelHelpers.export(exports, "BiYen", ()=>BiYen);
parcelHelpers.export(exports, "BiZoomIn", ()=>BiZoomIn);
parcelHelpers.export(exports, "BiZoomOut", ()=>BiZoomOut);
parcelHelpers.export(exports, "BiSolidAddToQueue", ()=>BiSolidAddToQueue);
parcelHelpers.export(exports, "BiSolidAdjustAlt", ()=>BiSolidAdjustAlt);
parcelHelpers.export(exports, "BiSolidAdjust", ()=>BiSolidAdjust);
parcelHelpers.export(exports, "BiSolidAlarmAdd", ()=>BiSolidAlarmAdd);
parcelHelpers.export(exports, "BiSolidAlarmExclamation", ()=>BiSolidAlarmExclamation);
parcelHelpers.export(exports, "BiSolidAlarmOff", ()=>BiSolidAlarmOff);
parcelHelpers.export(exports, "BiSolidAlarmSnooze", ()=>BiSolidAlarmSnooze);
parcelHelpers.export(exports, "BiSolidAlarm", ()=>BiSolidAlarm);
parcelHelpers.export(exports, "BiSolidAlbum", ()=>BiSolidAlbum);
parcelHelpers.export(exports, "BiSolidAmbulance", ()=>BiSolidAmbulance);
parcelHelpers.export(exports, "BiSolidAnalyse", ()=>BiSolidAnalyse);
parcelHelpers.export(exports, "BiSolidAngry", ()=>BiSolidAngry);
parcelHelpers.export(exports, "BiSolidArch", ()=>BiSolidArch);
parcelHelpers.export(exports, "BiSolidArchiveIn", ()=>BiSolidArchiveIn);
parcelHelpers.export(exports, "BiSolidArchiveOut", ()=>BiSolidArchiveOut);
parcelHelpers.export(exports, "BiSolidArchive", ()=>BiSolidArchive);
parcelHelpers.export(exports, "BiSolidArea", ()=>BiSolidArea);
parcelHelpers.export(exports, "BiSolidArrowFromBottom", ()=>BiSolidArrowFromBottom);
parcelHelpers.export(exports, "BiSolidArrowFromLeft", ()=>BiSolidArrowFromLeft);
parcelHelpers.export(exports, "BiSolidArrowFromRight", ()=>BiSolidArrowFromRight);
parcelHelpers.export(exports, "BiSolidArrowFromTop", ()=>BiSolidArrowFromTop);
parcelHelpers.export(exports, "BiSolidArrowToBottom", ()=>BiSolidArrowToBottom);
parcelHelpers.export(exports, "BiSolidArrowToLeft", ()=>BiSolidArrowToLeft);
parcelHelpers.export(exports, "BiSolidArrowToRight", ()=>BiSolidArrowToRight);
parcelHelpers.export(exports, "BiSolidArrowToTop", ()=>BiSolidArrowToTop);
parcelHelpers.export(exports, "BiSolidAward", ()=>BiSolidAward);
parcelHelpers.export(exports, "BiSolidBabyCarriage", ()=>BiSolidBabyCarriage);
parcelHelpers.export(exports, "BiSolidBackpack", ()=>BiSolidBackpack);
parcelHelpers.export(exports, "BiSolidBadgeCheck", ()=>BiSolidBadgeCheck);
parcelHelpers.export(exports, "BiSolidBadgeDollar", ()=>BiSolidBadgeDollar);
parcelHelpers.export(exports, "BiSolidBadge", ()=>BiSolidBadge);
parcelHelpers.export(exports, "BiSolidBaguette", ()=>BiSolidBaguette);
parcelHelpers.export(exports, "BiSolidBall", ()=>BiSolidBall);
parcelHelpers.export(exports, "BiSolidBalloon", ()=>BiSolidBalloon);
parcelHelpers.export(exports, "BiSolidBandAid", ()=>BiSolidBandAid);
parcelHelpers.export(exports, "BiSolidBank", ()=>BiSolidBank);
parcelHelpers.export(exports, "BiSolidBarChartAlt2", ()=>BiSolidBarChartAlt2);
parcelHelpers.export(exports, "BiSolidBarChartSquare", ()=>BiSolidBarChartSquare);
parcelHelpers.export(exports, "BiSolidBarcode", ()=>BiSolidBarcode);
parcelHelpers.export(exports, "BiSolidBaseball", ()=>BiSolidBaseball);
parcelHelpers.export(exports, "BiSolidBasket", ()=>BiSolidBasket);
parcelHelpers.export(exports, "BiSolidBasketball", ()=>BiSolidBasketball);
parcelHelpers.export(exports, "BiSolidBath", ()=>BiSolidBath);
parcelHelpers.export(exports, "BiSolidBatteryCharging", ()=>BiSolidBatteryCharging);
parcelHelpers.export(exports, "BiSolidBatteryFull", ()=>BiSolidBatteryFull);
parcelHelpers.export(exports, "BiSolidBatteryLow", ()=>BiSolidBatteryLow);
parcelHelpers.export(exports, "BiSolidBattery", ()=>BiSolidBattery);
parcelHelpers.export(exports, "BiSolidBed", ()=>BiSolidBed);
parcelHelpers.export(exports, "BiSolidBeenHere", ()=>BiSolidBeenHere);
parcelHelpers.export(exports, "BiSolidBeer", ()=>BiSolidBeer);
parcelHelpers.export(exports, "BiSolidBellMinus", ()=>BiSolidBellMinus);
parcelHelpers.export(exports, "BiSolidBellOff", ()=>BiSolidBellOff);
parcelHelpers.export(exports, "BiSolidBellPlus", ()=>BiSolidBellPlus);
parcelHelpers.export(exports, "BiSolidBellRing", ()=>BiSolidBellRing);
parcelHelpers.export(exports, "BiSolidBell", ()=>BiSolidBell);
parcelHelpers.export(exports, "BiSolidBible", ()=>BiSolidBible);
parcelHelpers.export(exports, "BiSolidBinoculars", ()=>BiSolidBinoculars);
parcelHelpers.export(exports, "BiSolidBlanket", ()=>BiSolidBlanket);
parcelHelpers.export(exports, "BiSolidBoltCircle", ()=>BiSolidBoltCircle);
parcelHelpers.export(exports, "BiSolidBolt", ()=>BiSolidBolt);
parcelHelpers.export(exports, "BiSolidBomb", ()=>BiSolidBomb);
parcelHelpers.export(exports, "BiSolidBone", ()=>BiSolidBone);
parcelHelpers.export(exports, "BiSolidBong", ()=>BiSolidBong);
parcelHelpers.export(exports, "BiSolidBookAdd", ()=>BiSolidBookAdd);
parcelHelpers.export(exports, "BiSolidBookAlt", ()=>BiSolidBookAlt);
parcelHelpers.export(exports, "BiSolidBookBookmark", ()=>BiSolidBookBookmark);
parcelHelpers.export(exports, "BiSolidBookContent", ()=>BiSolidBookContent);
parcelHelpers.export(exports, "BiSolidBookHeart", ()=>BiSolidBookHeart);
parcelHelpers.export(exports, "BiSolidBookOpen", ()=>BiSolidBookOpen);
parcelHelpers.export(exports, "BiSolidBookReader", ()=>BiSolidBookReader);
parcelHelpers.export(exports, "BiSolidBook", ()=>BiSolidBook);
parcelHelpers.export(exports, "BiSolidBookmarkAltMinus", ()=>BiSolidBookmarkAltMinus);
parcelHelpers.export(exports, "BiSolidBookmarkAltPlus", ()=>BiSolidBookmarkAltPlus);
parcelHelpers.export(exports, "BiSolidBookmarkAlt", ()=>BiSolidBookmarkAlt);
parcelHelpers.export(exports, "BiSolidBookmarkHeart", ()=>BiSolidBookmarkHeart);
parcelHelpers.export(exports, "BiSolidBookmarkMinus", ()=>BiSolidBookmarkMinus);
parcelHelpers.export(exports, "BiSolidBookmarkPlus", ()=>BiSolidBookmarkPlus);
parcelHelpers.export(exports, "BiSolidBookmarkStar", ()=>BiSolidBookmarkStar);
parcelHelpers.export(exports, "BiSolidBookmark", ()=>BiSolidBookmark);
parcelHelpers.export(exports, "BiSolidBookmarks", ()=>BiSolidBookmarks);
parcelHelpers.export(exports, "BiSolidBot", ()=>BiSolidBot);
parcelHelpers.export(exports, "BiSolidBowlHot", ()=>BiSolidBowlHot);
parcelHelpers.export(exports, "BiSolidBowlRice", ()=>BiSolidBowlRice);
parcelHelpers.export(exports, "BiSolidBowlingBall", ()=>BiSolidBowlingBall);
parcelHelpers.export(exports, "BiSolidBox", ()=>BiSolidBox);
parcelHelpers.export(exports, "BiSolidBrain", ()=>BiSolidBrain);
parcelHelpers.export(exports, "BiSolidBriefcaseAlt2", ()=>BiSolidBriefcaseAlt2);
parcelHelpers.export(exports, "BiSolidBriefcaseAlt", ()=>BiSolidBriefcaseAlt);
parcelHelpers.export(exports, "BiSolidBriefcase", ()=>BiSolidBriefcase);
parcelHelpers.export(exports, "BiSolidBrightnessHalf", ()=>BiSolidBrightnessHalf);
parcelHelpers.export(exports, "BiSolidBrightness", ()=>BiSolidBrightness);
parcelHelpers.export(exports, "BiSolidBrushAlt", ()=>BiSolidBrushAlt);
parcelHelpers.export(exports, "BiSolidBrush", ()=>BiSolidBrush);
parcelHelpers.export(exports, "BiSolidBugAlt", ()=>BiSolidBugAlt);
parcelHelpers.export(exports, "BiSolidBug", ()=>BiSolidBug);
parcelHelpers.export(exports, "BiSolidBuildingHouse", ()=>BiSolidBuildingHouse);
parcelHelpers.export(exports, "BiSolidBuilding", ()=>BiSolidBuilding);
parcelHelpers.export(exports, "BiSolidBuildings", ()=>BiSolidBuildings);
parcelHelpers.export(exports, "BiSolidBulb", ()=>BiSolidBulb);
parcelHelpers.export(exports, "BiSolidBullseye", ()=>BiSolidBullseye);
parcelHelpers.export(exports, "BiSolidBuoy", ()=>BiSolidBuoy);
parcelHelpers.export(exports, "BiSolidBusSchool", ()=>BiSolidBusSchool);
parcelHelpers.export(exports, "BiSolidBus", ()=>BiSolidBus);
parcelHelpers.export(exports, "BiSolidBusiness", ()=>BiSolidBusiness);
parcelHelpers.export(exports, "BiSolidCabinet", ()=>BiSolidCabinet);
parcelHelpers.export(exports, "BiSolidCableCar", ()=>BiSolidCableCar);
parcelHelpers.export(exports, "BiSolidCake", ()=>BiSolidCake);
parcelHelpers.export(exports, "BiSolidCalculator", ()=>BiSolidCalculator);
parcelHelpers.export(exports, "BiSolidCalendarAlt", ()=>BiSolidCalendarAlt);
parcelHelpers.export(exports, "BiSolidCalendarCheck", ()=>BiSolidCalendarCheck);
parcelHelpers.export(exports, "BiSolidCalendarEdit", ()=>BiSolidCalendarEdit);
parcelHelpers.export(exports, "BiSolidCalendarEvent", ()=>BiSolidCalendarEvent);
parcelHelpers.export(exports, "BiSolidCalendarExclamation", ()=>BiSolidCalendarExclamation);
parcelHelpers.export(exports, "BiSolidCalendarHeart", ()=>BiSolidCalendarHeart);
parcelHelpers.export(exports, "BiSolidCalendarMinus", ()=>BiSolidCalendarMinus);
parcelHelpers.export(exports, "BiSolidCalendarPlus", ()=>BiSolidCalendarPlus);
parcelHelpers.export(exports, "BiSolidCalendarStar", ()=>BiSolidCalendarStar);
parcelHelpers.export(exports, "BiSolidCalendarWeek", ()=>BiSolidCalendarWeek);
parcelHelpers.export(exports, "BiSolidCalendarX", ()=>BiSolidCalendarX);
parcelHelpers.export(exports, "BiSolidCalendar", ()=>BiSolidCalendar);
parcelHelpers.export(exports, "BiSolidCameraHome", ()=>BiSolidCameraHome);
parcelHelpers.export(exports, "BiSolidCameraMovie", ()=>BiSolidCameraMovie);
parcelHelpers.export(exports, "BiSolidCameraOff", ()=>BiSolidCameraOff);
parcelHelpers.export(exports, "BiSolidCameraPlus", ()=>BiSolidCameraPlus);
parcelHelpers.export(exports, "BiSolidCamera", ()=>BiSolidCamera);
parcelHelpers.export(exports, "BiSolidCapsule", ()=>BiSolidCapsule);
parcelHelpers.export(exports, "BiSolidCaptions", ()=>BiSolidCaptions);
parcelHelpers.export(exports, "BiSolidCarBattery", ()=>BiSolidCarBattery);
parcelHelpers.export(exports, "BiSolidCarCrash", ()=>BiSolidCarCrash);
parcelHelpers.export(exports, "BiSolidCarGarage", ()=>BiSolidCarGarage);
parcelHelpers.export(exports, "BiSolidCarMechanic", ()=>BiSolidCarMechanic);
parcelHelpers.export(exports, "BiSolidCarWash", ()=>BiSolidCarWash);
parcelHelpers.export(exports, "BiSolidCar", ()=>BiSolidCar);
parcelHelpers.export(exports, "BiSolidCard", ()=>BiSolidCard);
parcelHelpers.export(exports, "BiSolidCaretDownCircle", ()=>BiSolidCaretDownCircle);
parcelHelpers.export(exports, "BiSolidCaretDownSquare", ()=>BiSolidCaretDownSquare);
parcelHelpers.export(exports, "BiSolidCaretLeftCircle", ()=>BiSolidCaretLeftCircle);
parcelHelpers.export(exports, "BiSolidCaretLeftSquare", ()=>BiSolidCaretLeftSquare);
parcelHelpers.export(exports, "BiSolidCaretRightCircle", ()=>BiSolidCaretRightCircle);
parcelHelpers.export(exports, "BiSolidCaretRightSquare", ()=>BiSolidCaretRightSquare);
parcelHelpers.export(exports, "BiSolidCaretUpCircle", ()=>BiSolidCaretUpCircle);
parcelHelpers.export(exports, "BiSolidCaretUpSquare", ()=>BiSolidCaretUpSquare);
parcelHelpers.export(exports, "BiSolidCarousel", ()=>BiSolidCarousel);
parcelHelpers.export(exports, "BiSolidCartAdd", ()=>BiSolidCartAdd);
parcelHelpers.export(exports, "BiSolidCartAlt", ()=>BiSolidCartAlt);
parcelHelpers.export(exports, "BiSolidCartDownload", ()=>BiSolidCartDownload);
parcelHelpers.export(exports, "BiSolidCart", ()=>BiSolidCart);
parcelHelpers.export(exports, "BiSolidCastle", ()=>BiSolidCastle);
parcelHelpers.export(exports, "BiSolidCat", ()=>BiSolidCat);
parcelHelpers.export(exports, "BiSolidCategoryAlt", ()=>BiSolidCategoryAlt);
parcelHelpers.export(exports, "BiSolidCategory", ()=>BiSolidCategory);
parcelHelpers.export(exports, "BiSolidCctv", ()=>BiSolidCctv);
parcelHelpers.export(exports, "BiSolidCertification", ()=>BiSolidCertification);
parcelHelpers.export(exports, "BiSolidChalkboard", ()=>BiSolidChalkboard);
parcelHelpers.export(exports, "BiSolidChart", ()=>BiSolidChart);
parcelHelpers.export(exports, "BiSolidChat", ()=>BiSolidChat);
parcelHelpers.export(exports, "BiSolidCheckCircle", ()=>BiSolidCheckCircle);
parcelHelpers.export(exports, "BiSolidCheckShield", ()=>BiSolidCheckShield);
parcelHelpers.export(exports, "BiSolidCheckSquare", ()=>BiSolidCheckSquare);
parcelHelpers.export(exports, "BiSolidCheckboxChecked", ()=>BiSolidCheckboxChecked);
parcelHelpers.export(exports, "BiSolidCheckboxMinus", ()=>BiSolidCheckboxMinus);
parcelHelpers.export(exports, "BiSolidCheckbox", ()=>BiSolidCheckbox);
parcelHelpers.export(exports, "BiSolidCheese", ()=>BiSolidCheese);
parcelHelpers.export(exports, "BiSolidChess", ()=>BiSolidChess);
parcelHelpers.export(exports, "BiSolidChevronDownCircle", ()=>BiSolidChevronDownCircle);
parcelHelpers.export(exports, "BiSolidChevronDownSquare", ()=>BiSolidChevronDownSquare);
parcelHelpers.export(exports, "BiSolidChevronDown", ()=>BiSolidChevronDown);
parcelHelpers.export(exports, "BiSolidChevronLeftCircle", ()=>BiSolidChevronLeftCircle);
parcelHelpers.export(exports, "BiSolidChevronLeftSquare", ()=>BiSolidChevronLeftSquare);
parcelHelpers.export(exports, "BiSolidChevronLeft", ()=>BiSolidChevronLeft);
parcelHelpers.export(exports, "BiSolidChevronRightCircle", ()=>BiSolidChevronRightCircle);
parcelHelpers.export(exports, "BiSolidChevronRightSquare", ()=>BiSolidChevronRightSquare);
parcelHelpers.export(exports, "BiSolidChevronRight", ()=>BiSolidChevronRight);
parcelHelpers.export(exports, "BiSolidChevronUpCircle", ()=>BiSolidChevronUpCircle);
parcelHelpers.export(exports, "BiSolidChevronUpSquare", ()=>BiSolidChevronUpSquare);
parcelHelpers.export(exports, "BiSolidChevronUp", ()=>BiSolidChevronUp);
parcelHelpers.export(exports, "BiSolidChevronsDown", ()=>BiSolidChevronsDown);
parcelHelpers.export(exports, "BiSolidChevronsLeft", ()=>BiSolidChevronsLeft);
parcelHelpers.export(exports, "BiSolidChevronsRight", ()=>BiSolidChevronsRight);
parcelHelpers.export(exports, "BiSolidChevronsUp", ()=>BiSolidChevronsUp);
parcelHelpers.export(exports, "BiSolidChip", ()=>BiSolidChip);
parcelHelpers.export(exports, "BiSolidChurch", ()=>BiSolidChurch);
parcelHelpers.export(exports, "BiSolidCircleHalf", ()=>BiSolidCircleHalf);
parcelHelpers.export(exports, "BiSolidCircleQuarter", ()=>BiSolidCircleQuarter);
parcelHelpers.export(exports, "BiSolidCircleThreeQuarter", ()=>BiSolidCircleThreeQuarter);
parcelHelpers.export(exports, "BiSolidCircle", ()=>BiSolidCircle);
parcelHelpers.export(exports, "BiSolidCity", ()=>BiSolidCity);
parcelHelpers.export(exports, "BiSolidClinic", ()=>BiSolidClinic);
parcelHelpers.export(exports, "BiSolidCloudDownload", ()=>BiSolidCloudDownload);
parcelHelpers.export(exports, "BiSolidCloudLightning", ()=>BiSolidCloudLightning);
parcelHelpers.export(exports, "BiSolidCloudRain", ()=>BiSolidCloudRain);
parcelHelpers.export(exports, "BiSolidCloudUpload", ()=>BiSolidCloudUpload);
parcelHelpers.export(exports, "BiSolidCloud", ()=>BiSolidCloud);
parcelHelpers.export(exports, "BiSolidCoffeeAlt", ()=>BiSolidCoffeeAlt);
parcelHelpers.export(exports, "BiSolidCoffeeBean", ()=>BiSolidCoffeeBean);
parcelHelpers.export(exports, "BiSolidCoffeeTogo", ()=>BiSolidCoffeeTogo);
parcelHelpers.export(exports, "BiSolidCoffee", ()=>BiSolidCoffee);
parcelHelpers.export(exports, "BiSolidCog", ()=>BiSolidCog);
parcelHelpers.export(exports, "BiSolidCoinStack", ()=>BiSolidCoinStack);
parcelHelpers.export(exports, "BiSolidCoin", ()=>BiSolidCoin);
parcelHelpers.export(exports, "BiSolidCollection", ()=>BiSolidCollection);
parcelHelpers.export(exports, "BiSolidColorFill", ()=>BiSolidColorFill);
parcelHelpers.export(exports, "BiSolidColor", ()=>BiSolidColor);
parcelHelpers.export(exports, "BiSolidCommentAdd", ()=>BiSolidCommentAdd);
parcelHelpers.export(exports, "BiSolidCommentCheck", ()=>BiSolidCommentCheck);
parcelHelpers.export(exports, "BiSolidCommentDetail", ()=>BiSolidCommentDetail);
parcelHelpers.export(exports, "BiSolidCommentDots", ()=>BiSolidCommentDots);
parcelHelpers.export(exports, "BiSolidCommentEdit", ()=>BiSolidCommentEdit);
parcelHelpers.export(exports, "BiSolidCommentError", ()=>BiSolidCommentError);
parcelHelpers.export(exports, "BiSolidCommentMinus", ()=>BiSolidCommentMinus);
parcelHelpers.export(exports, "BiSolidCommentX", ()=>BiSolidCommentX);
parcelHelpers.export(exports, "BiSolidComment", ()=>BiSolidComment);
parcelHelpers.export(exports, "BiSolidCompass", ()=>BiSolidCompass);
parcelHelpers.export(exports, "BiSolidComponent", ()=>BiSolidComponent);
parcelHelpers.export(exports, "BiSolidConfused", ()=>BiSolidConfused);
parcelHelpers.export(exports, "BiSolidContact", ()=>BiSolidContact);
parcelHelpers.export(exports, "BiSolidConversation", ()=>BiSolidConversation);
parcelHelpers.export(exports, "BiSolidCookie", ()=>BiSolidCookie);
parcelHelpers.export(exports, "BiSolidCool", ()=>BiSolidCool);
parcelHelpers.export(exports, "BiSolidCopyAlt", ()=>BiSolidCopyAlt);
parcelHelpers.export(exports, "BiSolidCopy", ()=>BiSolidCopy);
parcelHelpers.export(exports, "BiSolidCopyright", ()=>BiSolidCopyright);
parcelHelpers.export(exports, "BiSolidCoupon", ()=>BiSolidCoupon);
parcelHelpers.export(exports, "BiSolidCreditCardAlt", ()=>BiSolidCreditCardAlt);
parcelHelpers.export(exports, "BiSolidCreditCardFront", ()=>BiSolidCreditCardFront);
parcelHelpers.export(exports, "BiSolidCreditCard", ()=>BiSolidCreditCard);
parcelHelpers.export(exports, "BiSolidCricketBall", ()=>BiSolidCricketBall);
parcelHelpers.export(exports, "BiSolidCrop", ()=>BiSolidCrop);
parcelHelpers.export(exports, "BiSolidCrown", ()=>BiSolidCrown);
parcelHelpers.export(exports, "BiSolidCubeAlt", ()=>BiSolidCubeAlt);
parcelHelpers.export(exports, "BiSolidCube", ()=>BiSolidCube);
parcelHelpers.export(exports, "BiSolidCuboid", ()=>BiSolidCuboid);
parcelHelpers.export(exports, "BiSolidCustomize", ()=>BiSolidCustomize);
parcelHelpers.export(exports, "BiSolidCylinder", ()=>BiSolidCylinder);
parcelHelpers.export(exports, "BiSolidDashboard", ()=>BiSolidDashboard);
parcelHelpers.export(exports, "BiSolidData", ()=>BiSolidData);
parcelHelpers.export(exports, "BiSolidDetail", ()=>BiSolidDetail);
parcelHelpers.export(exports, "BiSolidDevices", ()=>BiSolidDevices);
parcelHelpers.export(exports, "BiSolidDiamond", ()=>BiSolidDiamond);
parcelHelpers.export(exports, "BiSolidDice1", ()=>BiSolidDice1);
parcelHelpers.export(exports, "BiSolidDice2", ()=>BiSolidDice2);
parcelHelpers.export(exports, "BiSolidDice3", ()=>BiSolidDice3);
parcelHelpers.export(exports, "BiSolidDice4", ()=>BiSolidDice4);
parcelHelpers.export(exports, "BiSolidDice5", ()=>BiSolidDice5);
parcelHelpers.export(exports, "BiSolidDice6", ()=>BiSolidDice6);
parcelHelpers.export(exports, "BiSolidDirectionLeft", ()=>BiSolidDirectionLeft);
parcelHelpers.export(exports, "BiSolidDirectionRight", ()=>BiSolidDirectionRight);
parcelHelpers.export(exports, "BiSolidDirections", ()=>BiSolidDirections);
parcelHelpers.export(exports, "BiSolidDisc", ()=>BiSolidDisc);
parcelHelpers.export(exports, "BiSolidDiscount", ()=>BiSolidDiscount);
parcelHelpers.export(exports, "BiSolidDish", ()=>BiSolidDish);
parcelHelpers.export(exports, "BiSolidDislike", ()=>BiSolidDislike);
parcelHelpers.export(exports, "BiSolidDizzy", ()=>BiSolidDizzy);
parcelHelpers.export(exports, "BiSolidDockBottom", ()=>BiSolidDockBottom);
parcelHelpers.export(exports, "BiSolidDockLeft", ()=>BiSolidDockLeft);
parcelHelpers.export(exports, "BiSolidDockRight", ()=>BiSolidDockRight);
parcelHelpers.export(exports, "BiSolidDockTop", ()=>BiSolidDockTop);
parcelHelpers.export(exports, "BiSolidDog", ()=>BiSolidDog);
parcelHelpers.export(exports, "BiSolidDollarCircle", ()=>BiSolidDollarCircle);
parcelHelpers.export(exports, "BiSolidDonateBlood", ()=>BiSolidDonateBlood);
parcelHelpers.export(exports, "BiSolidDonateHeart", ()=>BiSolidDonateHeart);
parcelHelpers.export(exports, "BiSolidDoorOpen", ()=>BiSolidDoorOpen);
parcelHelpers.export(exports, "BiSolidDoughnutChart", ()=>BiSolidDoughnutChart);
parcelHelpers.export(exports, "BiSolidDownArrowAlt", ()=>BiSolidDownArrowAlt);
parcelHelpers.export(exports, "BiSolidDownArrowCircle", ()=>BiSolidDownArrowCircle);
parcelHelpers.export(exports, "BiSolidDownArrowSquare", ()=>BiSolidDownArrowSquare);
parcelHelpers.export(exports, "BiSolidDownArrow", ()=>BiSolidDownArrow);
parcelHelpers.export(exports, "BiSolidDownload", ()=>BiSolidDownload);
parcelHelpers.export(exports, "BiSolidDownvote", ()=>BiSolidDownvote);
parcelHelpers.export(exports, "BiSolidDrink", ()=>BiSolidDrink);
parcelHelpers.export(exports, "BiSolidDropletHalf", ()=>BiSolidDropletHalf);
parcelHelpers.export(exports, "BiSolidDroplet", ()=>BiSolidDroplet);
parcelHelpers.export(exports, "BiSolidDryer", ()=>BiSolidDryer);
parcelHelpers.export(exports, "BiSolidDuplicate", ()=>BiSolidDuplicate);
parcelHelpers.export(exports, "BiSolidEditAlt", ()=>BiSolidEditAlt);
parcelHelpers.export(exports, "BiSolidEditLocation", ()=>BiSolidEditLocation);
parcelHelpers.export(exports, "BiSolidEdit", ()=>BiSolidEdit);
parcelHelpers.export(exports, "BiSolidEject", ()=>BiSolidEject);
parcelHelpers.export(exports, "BiSolidEnvelopeOpen", ()=>BiSolidEnvelopeOpen);
parcelHelpers.export(exports, "BiSolidEnvelope", ()=>BiSolidEnvelope);
parcelHelpers.export(exports, "BiSolidEraser", ()=>BiSolidEraser);
parcelHelpers.export(exports, "BiSolidErrorAlt", ()=>BiSolidErrorAlt);
parcelHelpers.export(exports, "BiSolidErrorCircle", ()=>BiSolidErrorCircle);
parcelHelpers.export(exports, "BiSolidError", ()=>BiSolidError);
parcelHelpers.export(exports, "BiSolidEvStation", ()=>BiSolidEvStation);
parcelHelpers.export(exports, "BiSolidExit", ()=>BiSolidExit);
parcelHelpers.export(exports, "BiSolidExtension", ()=>BiSolidExtension);
parcelHelpers.export(exports, "BiSolidEyedropper", ()=>BiSolidEyedropper);
parcelHelpers.export(exports, "BiSolidFaceMask", ()=>BiSolidFaceMask);
parcelHelpers.export(exports, "BiSolidFace", ()=>BiSolidFace);
parcelHelpers.export(exports, "BiSolidFactory", ()=>BiSolidFactory);
parcelHelpers.export(exports, "BiSolidFastForwardCircle", ()=>BiSolidFastForwardCircle);
parcelHelpers.export(exports, "BiSolidFileArchive", ()=>BiSolidFileArchive);
parcelHelpers.export(exports, "BiSolidFileBlank", ()=>BiSolidFileBlank);
parcelHelpers.export(exports, "BiSolidFileCss", ()=>BiSolidFileCss);
parcelHelpers.export(exports, "BiSolidFileDoc", ()=>BiSolidFileDoc);
parcelHelpers.export(exports, "BiSolidFileExport", ()=>BiSolidFileExport);
parcelHelpers.export(exports, "BiSolidFileFind", ()=>BiSolidFileFind);
parcelHelpers.export(exports, "BiSolidFileGif", ()=>BiSolidFileGif);
parcelHelpers.export(exports, "BiSolidFileHtml", ()=>BiSolidFileHtml);
parcelHelpers.export(exports, "BiSolidFileImage", ()=>BiSolidFileImage);
parcelHelpers.export(exports, "BiSolidFileImport", ()=>BiSolidFileImport);
parcelHelpers.export(exports, "BiSolidFileJpg", ()=>BiSolidFileJpg);
parcelHelpers.export(exports, "BiSolidFileJs", ()=>BiSolidFileJs);
parcelHelpers.export(exports, "BiSolidFileJson", ()=>BiSolidFileJson);
parcelHelpers.export(exports, "BiSolidFileMd", ()=>BiSolidFileMd);
parcelHelpers.export(exports, "BiSolidFilePdf", ()=>BiSolidFilePdf);
parcelHelpers.export(exports, "BiSolidFilePlus", ()=>BiSolidFilePlus);
parcelHelpers.export(exports, "BiSolidFilePng", ()=>BiSolidFilePng);
parcelHelpers.export(exports, "BiSolidFileTxt", ()=>BiSolidFileTxt);
parcelHelpers.export(exports, "BiSolidFile", ()=>BiSolidFile);
parcelHelpers.export(exports, "BiSolidFilm", ()=>BiSolidFilm);
parcelHelpers.export(exports, "BiSolidFilterAlt", ()=>BiSolidFilterAlt);
parcelHelpers.export(exports, "BiSolidFirstAid", ()=>BiSolidFirstAid);
parcelHelpers.export(exports, "BiSolidFlagAlt", ()=>BiSolidFlagAlt);
parcelHelpers.export(exports, "BiSolidFlagCheckered", ()=>BiSolidFlagCheckered);
parcelHelpers.export(exports, "BiSolidFlag", ()=>BiSolidFlag);
parcelHelpers.export(exports, "BiSolidFlame", ()=>BiSolidFlame);
parcelHelpers.export(exports, "BiSolidFlask", ()=>BiSolidFlask);
parcelHelpers.export(exports, "BiSolidFlorist", ()=>BiSolidFlorist);
parcelHelpers.export(exports, "BiSolidFolderMinus", ()=>BiSolidFolderMinus);
parcelHelpers.export(exports, "BiSolidFolderOpen", ()=>BiSolidFolderOpen);
parcelHelpers.export(exports, "BiSolidFolderPlus", ()=>BiSolidFolderPlus);
parcelHelpers.export(exports, "BiSolidFolder", ()=>BiSolidFolder);
parcelHelpers.export(exports, "BiSolidFoodMenu", ()=>BiSolidFoodMenu);
parcelHelpers.export(exports, "BiSolidFridge", ()=>BiSolidFridge);
parcelHelpers.export(exports, "BiSolidGame", ()=>BiSolidGame);
parcelHelpers.export(exports, "BiSolidGasPump", ()=>BiSolidGasPump);
parcelHelpers.export(exports, "BiSolidGhost", ()=>BiSolidGhost);
parcelHelpers.export(exports, "BiSolidGift", ()=>BiSolidGift);
parcelHelpers.export(exports, "BiSolidGraduation", ()=>BiSolidGraduation);
parcelHelpers.export(exports, "BiSolidGridAlt", ()=>BiSolidGridAlt);
parcelHelpers.export(exports, "BiSolidGrid", ()=>BiSolidGrid);
parcelHelpers.export(exports, "BiSolidGroup", ()=>BiSolidGroup);
parcelHelpers.export(exports, "BiSolidGuitarAmp", ()=>BiSolidGuitarAmp);
parcelHelpers.export(exports, "BiSolidHandDown", ()=>BiSolidHandDown);
parcelHelpers.export(exports, "BiSolidHandLeft", ()=>BiSolidHandLeft);
parcelHelpers.export(exports, "BiSolidHandRight", ()=>BiSolidHandRight);
parcelHelpers.export(exports, "BiSolidHandUp", ()=>BiSolidHandUp);
parcelHelpers.export(exports, "BiSolidHand", ()=>BiSolidHand);
parcelHelpers.export(exports, "BiSolidHappyAlt", ()=>BiSolidHappyAlt);
parcelHelpers.export(exports, "BiSolidHappyBeaming", ()=>BiSolidHappyBeaming);
parcelHelpers.export(exports, "BiSolidHappyHeartEyes", ()=>BiSolidHappyHeartEyes);
parcelHelpers.export(exports, "BiSolidHappy", ()=>BiSolidHappy);
parcelHelpers.export(exports, "BiSolidHardHat", ()=>BiSolidHardHat);
parcelHelpers.export(exports, "BiSolidHdd", ()=>BiSolidHdd);
parcelHelpers.export(exports, "BiSolidHeartCircle", ()=>BiSolidHeartCircle);
parcelHelpers.export(exports, "BiSolidHeartSquare", ()=>BiSolidHeartSquare);
parcelHelpers.export(exports, "BiSolidHeart", ()=>BiSolidHeart);
parcelHelpers.export(exports, "BiSolidHelpCircle", ()=>BiSolidHelpCircle);
parcelHelpers.export(exports, "BiSolidHide", ()=>BiSolidHide);
parcelHelpers.export(exports, "BiSolidHomeAlt2", ()=>BiSolidHomeAlt2);
parcelHelpers.export(exports, "BiSolidHomeCircle", ()=>BiSolidHomeCircle);
parcelHelpers.export(exports, "BiSolidHomeHeart", ()=>BiSolidHomeHeart);
parcelHelpers.export(exports, "BiSolidHomeSmile", ()=>BiSolidHomeSmile);
parcelHelpers.export(exports, "BiSolidHome", ()=>BiSolidHome);
parcelHelpers.export(exports, "BiSolidHot", ()=>BiSolidHot);
parcelHelpers.export(exports, "BiSolidHotel", ()=>BiSolidHotel);
parcelHelpers.export(exports, "BiSolidHourglassBottom", ()=>BiSolidHourglassBottom);
parcelHelpers.export(exports, "BiSolidHourglassTop", ()=>BiSolidHourglassTop);
parcelHelpers.export(exports, "BiSolidHourglass", ()=>BiSolidHourglass);
parcelHelpers.export(exports, "BiSolidIdCard", ()=>BiSolidIdCard);
parcelHelpers.export(exports, "BiSolidImageAdd", ()=>BiSolidImageAdd);
parcelHelpers.export(exports, "BiSolidImageAlt", ()=>BiSolidImageAlt);
parcelHelpers.export(exports, "BiSolidImage", ()=>BiSolidImage);
parcelHelpers.export(exports, "BiSolidInbox", ()=>BiSolidInbox);
parcelHelpers.export(exports, "BiSolidInfoCircle", ()=>BiSolidInfoCircle);
parcelHelpers.export(exports, "BiSolidInfoSquare", ()=>BiSolidInfoSquare);
parcelHelpers.export(exports, "BiSolidInjection", ()=>BiSolidInjection);
parcelHelpers.export(exports, "BiSolidInstitution", ()=>BiSolidInstitution);
parcelHelpers.export(exports, "BiSolidInvader", ()=>BiSolidInvader);
parcelHelpers.export(exports, "BiSolidJoystickAlt", ()=>BiSolidJoystickAlt);
parcelHelpers.export(exports, "BiSolidJoystickButton", ()=>BiSolidJoystickButton);
parcelHelpers.export(exports, "BiSolidJoystick", ()=>BiSolidJoystick);
parcelHelpers.export(exports, "BiSolidKey", ()=>BiSolidKey);
parcelHelpers.export(exports, "BiSolidKeyboard", ()=>BiSolidKeyboard);
parcelHelpers.export(exports, "BiSolidLabel", ()=>BiSolidLabel);
parcelHelpers.export(exports, "BiSolidLandmark", ()=>BiSolidLandmark);
parcelHelpers.export(exports, "BiSolidLandscape", ()=>BiSolidLandscape);
parcelHelpers.export(exports, "BiSolidLaugh", ()=>BiSolidLaugh);
parcelHelpers.export(exports, "BiSolidLayerMinus", ()=>BiSolidLayerMinus);
parcelHelpers.export(exports, "BiSolidLayerPlus", ()=>BiSolidLayerPlus);
parcelHelpers.export(exports, "BiSolidLayer", ()=>BiSolidLayer);
parcelHelpers.export(exports, "BiSolidLayout", ()=>BiSolidLayout);
parcelHelpers.export(exports, "BiSolidLeaf", ()=>BiSolidLeaf);
parcelHelpers.export(exports, "BiSolidLeftArrowAlt", ()=>BiSolidLeftArrowAlt);
parcelHelpers.export(exports, "BiSolidLeftArrowCircle", ()=>BiSolidLeftArrowCircle);
parcelHelpers.export(exports, "BiSolidLeftArrowSquare", ()=>BiSolidLeftArrowSquare);
parcelHelpers.export(exports, "BiSolidLeftArrow", ()=>BiSolidLeftArrow);
parcelHelpers.export(exports, "BiSolidLeftDownArrowCircle", ()=>BiSolidLeftDownArrowCircle);
parcelHelpers.export(exports, "BiSolidLeftTopArrowCircle", ()=>BiSolidLeftTopArrowCircle);
parcelHelpers.export(exports, "BiSolidLemon", ()=>BiSolidLemon);
parcelHelpers.export(exports, "BiSolidLike", ()=>BiSolidLike);
parcelHelpers.export(exports, "BiSolidLocationPlus", ()=>BiSolidLocationPlus);
parcelHelpers.export(exports, "BiSolidLockAlt", ()=>BiSolidLockAlt);
parcelHelpers.export(exports, "BiSolidLockOpenAlt", ()=>BiSolidLockOpenAlt);
parcelHelpers.export(exports, "BiSolidLockOpen", ()=>BiSolidLockOpen);
parcelHelpers.export(exports, "BiSolidLock", ()=>BiSolidLock);
parcelHelpers.export(exports, "BiSolidLogInCircle", ()=>BiSolidLogInCircle);
parcelHelpers.export(exports, "BiSolidLogIn", ()=>BiSolidLogIn);
parcelHelpers.export(exports, "BiSolidLogOutCircle", ()=>BiSolidLogOutCircle);
parcelHelpers.export(exports, "BiSolidLogOut", ()=>BiSolidLogOut);
parcelHelpers.export(exports, "BiSolidLowVision", ()=>BiSolidLowVision);
parcelHelpers.export(exports, "BiSolidMagicWand", ()=>BiSolidMagicWand);
parcelHelpers.export(exports, "BiSolidMagnet", ()=>BiSolidMagnet);
parcelHelpers.export(exports, "BiSolidMapAlt", ()=>BiSolidMapAlt);
parcelHelpers.export(exports, "BiSolidMapPin", ()=>BiSolidMapPin);
parcelHelpers.export(exports, "BiSolidMap", ()=>BiSolidMap);
parcelHelpers.export(exports, "BiSolidMask", ()=>BiSolidMask);
parcelHelpers.export(exports, "BiSolidMedal", ()=>BiSolidMedal);
parcelHelpers.export(exports, "BiSolidMegaphone", ()=>BiSolidMegaphone);
parcelHelpers.export(exports, "BiSolidMehAlt", ()=>BiSolidMehAlt);
parcelHelpers.export(exports, "BiSolidMehBlank", ()=>BiSolidMehBlank);
parcelHelpers.export(exports, "BiSolidMeh", ()=>BiSolidMeh);
parcelHelpers.export(exports, "BiSolidMemoryCard", ()=>BiSolidMemoryCard);
parcelHelpers.export(exports, "BiSolidMessageAdd", ()=>BiSolidMessageAdd);
parcelHelpers.export(exports, "BiSolidMessageAltAdd", ()=>BiSolidMessageAltAdd);
parcelHelpers.export(exports, "BiSolidMessageAltCheck", ()=>BiSolidMessageAltCheck);
parcelHelpers.export(exports, "BiSolidMessageAltDetail", ()=>BiSolidMessageAltDetail);
parcelHelpers.export(exports, "BiSolidMessageAltDots", ()=>BiSolidMessageAltDots);
parcelHelpers.export(exports, "BiSolidMessageAltEdit", ()=>BiSolidMessageAltEdit);
parcelHelpers.export(exports, "BiSolidMessageAltError", ()=>BiSolidMessageAltError);
parcelHelpers.export(exports, "BiSolidMessageAltMinus", ()=>BiSolidMessageAltMinus);
parcelHelpers.export(exports, "BiSolidMessageAltX", ()=>BiSolidMessageAltX);
parcelHelpers.export(exports, "BiSolidMessageAlt", ()=>BiSolidMessageAlt);
parcelHelpers.export(exports, "BiSolidMessageCheck", ()=>BiSolidMessageCheck);
parcelHelpers.export(exports, "BiSolidMessageDetail", ()=>BiSolidMessageDetail);
parcelHelpers.export(exports, "BiSolidMessageDots", ()=>BiSolidMessageDots);
parcelHelpers.export(exports, "BiSolidMessageEdit", ()=>BiSolidMessageEdit);
parcelHelpers.export(exports, "BiSolidMessageError", ()=>BiSolidMessageError);
parcelHelpers.export(exports, "BiSolidMessageMinus", ()=>BiSolidMessageMinus);
parcelHelpers.export(exports, "BiSolidMessageRoundedAdd", ()=>BiSolidMessageRoundedAdd);
parcelHelpers.export(exports, "BiSolidMessageRoundedCheck", ()=>BiSolidMessageRoundedCheck);
parcelHelpers.export(exports, "BiSolidMessageRoundedDetail", ()=>BiSolidMessageRoundedDetail);
parcelHelpers.export(exports, "BiSolidMessageRoundedDots", ()=>BiSolidMessageRoundedDots);
parcelHelpers.export(exports, "BiSolidMessageRoundedEdit", ()=>BiSolidMessageRoundedEdit);
parcelHelpers.export(exports, "BiSolidMessageRoundedError", ()=>BiSolidMessageRoundedError);
parcelHelpers.export(exports, "BiSolidMessageRoundedMinus", ()=>BiSolidMessageRoundedMinus);
parcelHelpers.export(exports, "BiSolidMessageRoundedX", ()=>BiSolidMessageRoundedX);
parcelHelpers.export(exports, "BiSolidMessageRounded", ()=>BiSolidMessageRounded);
parcelHelpers.export(exports, "BiSolidMessageSquareAdd", ()=>BiSolidMessageSquareAdd);
parcelHelpers.export(exports, "BiSolidMessageSquareCheck", ()=>BiSolidMessageSquareCheck);
parcelHelpers.export(exports, "BiSolidMessageSquareDetail", ()=>BiSolidMessageSquareDetail);
parcelHelpers.export(exports, "BiSolidMessageSquareDots", ()=>BiSolidMessageSquareDots);
parcelHelpers.export(exports, "BiSolidMessageSquareEdit", ()=>BiSolidMessageSquareEdit);
parcelHelpers.export(exports, "BiSolidMessageSquareError", ()=>BiSolidMessageSquareError);
parcelHelpers.export(exports, "BiSolidMessageSquareMinus", ()=>BiSolidMessageSquareMinus);
parcelHelpers.export(exports, "BiSolidMessageSquareX", ()=>BiSolidMessageSquareX);
parcelHelpers.export(exports, "BiSolidMessageSquare", ()=>BiSolidMessageSquare);
parcelHelpers.export(exports, "BiSolidMessageX", ()=>BiSolidMessageX);
parcelHelpers.export(exports, "BiSolidMessage", ()=>BiSolidMessage);
parcelHelpers.export(exports, "BiSolidMeteor", ()=>BiSolidMeteor);
parcelHelpers.export(exports, "BiSolidMicrochip", ()=>BiSolidMicrochip);
parcelHelpers.export(exports, "BiSolidMicrophoneAlt", ()=>BiSolidMicrophoneAlt);
parcelHelpers.export(exports, "BiSolidMicrophoneOff", ()=>BiSolidMicrophoneOff);
parcelHelpers.export(exports, "BiSolidMicrophone", ()=>BiSolidMicrophone);
parcelHelpers.export(exports, "BiSolidMinusCircle", ()=>BiSolidMinusCircle);
parcelHelpers.export(exports, "BiSolidMinusSquare", ()=>BiSolidMinusSquare);
parcelHelpers.export(exports, "BiSolidMobileVibration", ()=>BiSolidMobileVibration);
parcelHelpers.export(exports, "BiSolidMobile", ()=>BiSolidMobile);
parcelHelpers.export(exports, "BiSolidMoon", ()=>BiSolidMoon);
parcelHelpers.export(exports, "BiSolidMouseAlt", ()=>BiSolidMouseAlt);
parcelHelpers.export(exports, "BiSolidMouse", ()=>BiSolidMouse);
parcelHelpers.export(exports, "BiSolidMoviePlay", ()=>BiSolidMoviePlay);
parcelHelpers.export(exports, "BiSolidMovie", ()=>BiSolidMovie);
parcelHelpers.export(exports, "BiSolidMusic", ()=>BiSolidMusic);
parcelHelpers.export(exports, "BiSolidNavigation", ()=>BiSolidNavigation);
parcelHelpers.export(exports, "BiSolidNetworkChart", ()=>BiSolidNetworkChart);
parcelHelpers.export(exports, "BiSolidNews", ()=>BiSolidNews);
parcelHelpers.export(exports, "BiSolidNoEntry", ()=>BiSolidNoEntry);
parcelHelpers.export(exports, "BiSolidNote", ()=>BiSolidNote);
parcelHelpers.export(exports, "BiSolidNotepad", ()=>BiSolidNotepad);
parcelHelpers.export(exports, "BiSolidNotificationOff", ()=>BiSolidNotificationOff);
parcelHelpers.export(exports, "BiSolidNotification", ()=>BiSolidNotification);
parcelHelpers.export(exports, "BiSolidObjectsHorizontalCenter", ()=>BiSolidObjectsHorizontalCenter);
parcelHelpers.export(exports, "BiSolidObjectsHorizontalLeft", ()=>BiSolidObjectsHorizontalLeft);
parcelHelpers.export(exports, "BiSolidObjectsHorizontalRight", ()=>BiSolidObjectsHorizontalRight);
parcelHelpers.export(exports, "BiSolidObjectsVerticalBottom", ()=>BiSolidObjectsVerticalBottom);
parcelHelpers.export(exports, "BiSolidObjectsVerticalCenter", ()=>BiSolidObjectsVerticalCenter);
parcelHelpers.export(exports, "BiSolidObjectsVerticalTop", ()=>BiSolidObjectsVerticalTop);
parcelHelpers.export(exports, "BiSolidOffer", ()=>BiSolidOffer);
parcelHelpers.export(exports, "BiSolidPackage", ()=>BiSolidPackage);
parcelHelpers.export(exports, "BiSolidPaintRoll", ()=>BiSolidPaintRoll);
parcelHelpers.export(exports, "BiSolidPaint", ()=>BiSolidPaint);
parcelHelpers.export(exports, "BiSolidPalette", ()=>BiSolidPalette);
parcelHelpers.export(exports, "BiSolidPaperPlane", ()=>BiSolidPaperPlane);
parcelHelpers.export(exports, "BiSolidParking", ()=>BiSolidParking);
parcelHelpers.export(exports, "BiSolidParty", ()=>BiSolidParty);
parcelHelpers.export(exports, "BiSolidPaste", ()=>BiSolidPaste);
parcelHelpers.export(exports, "BiSolidPear", ()=>BiSolidPear);
parcelHelpers.export(exports, "BiSolidPen", ()=>BiSolidPen);
parcelHelpers.export(exports, "BiSolidPencil", ()=>BiSolidPencil);
parcelHelpers.export(exports, "BiSolidPhoneCall", ()=>BiSolidPhoneCall);
parcelHelpers.export(exports, "BiSolidPhoneIncoming", ()=>BiSolidPhoneIncoming);
parcelHelpers.export(exports, "BiSolidPhoneOff", ()=>BiSolidPhoneOff);
parcelHelpers.export(exports, "BiSolidPhoneOutgoing", ()=>BiSolidPhoneOutgoing);
parcelHelpers.export(exports, "BiSolidPhone", ()=>BiSolidPhone);
parcelHelpers.export(exports, "BiSolidPhotoAlbum", ()=>BiSolidPhotoAlbum);
parcelHelpers.export(exports, "BiSolidPiano", ()=>BiSolidPiano);
parcelHelpers.export(exports, "BiSolidPieChartAlt2", ()=>BiSolidPieChartAlt2);
parcelHelpers.export(exports, "BiSolidPieChartAlt", ()=>BiSolidPieChartAlt);
parcelHelpers.export(exports, "BiSolidPieChart", ()=>BiSolidPieChart);
parcelHelpers.export(exports, "BiSolidPin", ()=>BiSolidPin);
parcelHelpers.export(exports, "BiSolidPizza", ()=>BiSolidPizza);
parcelHelpers.export(exports, "BiSolidPlaneAlt", ()=>BiSolidPlaneAlt);
parcelHelpers.export(exports, "BiSolidPlaneLand", ()=>BiSolidPlaneLand);
parcelHelpers.export(exports, "BiSolidPlaneTakeOff", ()=>BiSolidPlaneTakeOff);
parcelHelpers.export(exports, "BiSolidPlane", ()=>BiSolidPlane);
parcelHelpers.export(exports, "BiSolidPlanet", ()=>BiSolidPlanet);
parcelHelpers.export(exports, "BiSolidPlaylist", ()=>BiSolidPlaylist);
parcelHelpers.export(exports, "BiSolidPlug", ()=>BiSolidPlug);
parcelHelpers.export(exports, "BiSolidPlusCircle", ()=>BiSolidPlusCircle);
parcelHelpers.export(exports, "BiSolidPlusSquare", ()=>BiSolidPlusSquare);
parcelHelpers.export(exports, "BiSolidPointer", ()=>BiSolidPointer);
parcelHelpers.export(exports, "BiSolidPolygon", ()=>BiSolidPolygon);
parcelHelpers.export(exports, "BiSolidPopsicle", ()=>BiSolidPopsicle);
parcelHelpers.export(exports, "BiSolidPrinter", ()=>BiSolidPrinter);
parcelHelpers.export(exports, "BiSolidPurchaseTagAlt", ()=>BiSolidPurchaseTagAlt);
parcelHelpers.export(exports, "BiSolidPurchaseTag", ()=>BiSolidPurchaseTag);
parcelHelpers.export(exports, "BiSolidPyramid", ()=>BiSolidPyramid);
parcelHelpers.export(exports, "BiSolidQuoteAltLeft", ()=>BiSolidQuoteAltLeft);
parcelHelpers.export(exports, "BiSolidQuoteAltRight", ()=>BiSolidQuoteAltRight);
parcelHelpers.export(exports, "BiSolidQuoteLeft", ()=>BiSolidQuoteLeft);
parcelHelpers.export(exports, "BiSolidQuoteRight", ()=>BiSolidQuoteRight);
parcelHelpers.export(exports, "BiSolidQuoteSingleLeft", ()=>BiSolidQuoteSingleLeft);
parcelHelpers.export(exports, "BiSolidQuoteSingleRight", ()=>BiSolidQuoteSingleRight);
parcelHelpers.export(exports, "BiSolidRadiation", ()=>BiSolidRadiation);
parcelHelpers.export(exports, "BiSolidRadio", ()=>BiSolidRadio);
parcelHelpers.export(exports, "BiSolidReceipt", ()=>BiSolidReceipt);
parcelHelpers.export(exports, "BiSolidRectangle", ()=>BiSolidRectangle);
parcelHelpers.export(exports, "BiSolidRegistered", ()=>BiSolidRegistered);
parcelHelpers.export(exports, "BiSolidRename", ()=>BiSolidRename);
parcelHelpers.export(exports, "BiSolidReport", ()=>BiSolidReport);
parcelHelpers.export(exports, "BiSolidRewindCircle", ()=>BiSolidRewindCircle);
parcelHelpers.export(exports, "BiSolidRightArrowAlt", ()=>BiSolidRightArrowAlt);
parcelHelpers.export(exports, "BiSolidRightArrowCircle", ()=>BiSolidRightArrowCircle);
parcelHelpers.export(exports, "BiSolidRightArrowSquare", ()=>BiSolidRightArrowSquare);
parcelHelpers.export(exports, "BiSolidRightArrow", ()=>BiSolidRightArrow);
parcelHelpers.export(exports, "BiSolidRightDownArrowCircle", ()=>BiSolidRightDownArrowCircle);
parcelHelpers.export(exports, "BiSolidRightTopArrowCircle", ()=>BiSolidRightTopArrowCircle);
parcelHelpers.export(exports, "BiSolidRocket", ()=>BiSolidRocket);
parcelHelpers.export(exports, "BiSolidRuler", ()=>BiSolidRuler);
parcelHelpers.export(exports, "BiSolidSad", ()=>BiSolidSad);
parcelHelpers.export(exports, "BiSolidSave", ()=>BiSolidSave);
parcelHelpers.export(exports, "BiSolidSchool", ()=>BiSolidSchool);
parcelHelpers.export(exports, "BiSolidSearchAlt2", ()=>BiSolidSearchAlt2);
parcelHelpers.export(exports, "BiSolidSearch", ()=>BiSolidSearch);
parcelHelpers.export(exports, "BiSolidSelectMultiple", ()=>BiSolidSelectMultiple);
parcelHelpers.export(exports, "BiSolidSend", ()=>BiSolidSend);
parcelHelpers.export(exports, "BiSolidServer", ()=>BiSolidServer);
parcelHelpers.export(exports, "BiSolidShapes", ()=>BiSolidShapes);
parcelHelpers.export(exports, "BiSolidShareAlt", ()=>BiSolidShareAlt);
parcelHelpers.export(exports, "BiSolidShare", ()=>BiSolidShare);
parcelHelpers.export(exports, "BiSolidShieldAlt2", ()=>BiSolidShieldAlt2);
parcelHelpers.export(exports, "BiSolidShieldMinus", ()=>BiSolidShieldMinus);
parcelHelpers.export(exports, "BiSolidShieldPlus", ()=>BiSolidShieldPlus);
parcelHelpers.export(exports, "BiSolidShieldX", ()=>BiSolidShieldX);
parcelHelpers.export(exports, "BiSolidShield", ()=>BiSolidShield);
parcelHelpers.export(exports, "BiSolidShip", ()=>BiSolidShip);
parcelHelpers.export(exports, "BiSolidShocked", ()=>BiSolidShocked);
parcelHelpers.export(exports, "BiSolidShoppingBagAlt", ()=>BiSolidShoppingBagAlt);
parcelHelpers.export(exports, "BiSolidShoppingBag", ()=>BiSolidShoppingBag);
parcelHelpers.export(exports, "BiSolidShoppingBags", ()=>BiSolidShoppingBags);
parcelHelpers.export(exports, "BiSolidShow", ()=>BiSolidShow);
parcelHelpers.export(exports, "BiSolidShower", ()=>BiSolidShower);
parcelHelpers.export(exports, "BiSolidSkipNextCircle", ()=>BiSolidSkipNextCircle);
parcelHelpers.export(exports, "BiSolidSkipPreviousCircle", ()=>BiSolidSkipPreviousCircle);
parcelHelpers.export(exports, "BiSolidSkull", ()=>BiSolidSkull);
parcelHelpers.export(exports, "BiSolidSleepy", ()=>BiSolidSleepy);
parcelHelpers.export(exports, "BiSolidSlideshow", ()=>BiSolidSlideshow);
parcelHelpers.export(exports, "BiSolidSmile", ()=>BiSolidSmile);
parcelHelpers.export(exports, "BiSolidSortAlt", ()=>BiSolidSortAlt);
parcelHelpers.export(exports, "BiSolidSpa", ()=>BiSolidSpa);
parcelHelpers.export(exports, "BiSolidSpeaker", ()=>BiSolidSpeaker);
parcelHelpers.export(exports, "BiSolidSprayCan", ()=>BiSolidSprayCan);
parcelHelpers.export(exports, "BiSolidSpreadsheet", ()=>BiSolidSpreadsheet);
parcelHelpers.export(exports, "BiSolidSquareRounded", ()=>BiSolidSquareRounded);
parcelHelpers.export(exports, "BiSolidSquare", ()=>BiSolidSquare);
parcelHelpers.export(exports, "BiSolidStarHalf", ()=>BiSolidStarHalf);
parcelHelpers.export(exports, "BiSolidStar", ()=>BiSolidStar);
parcelHelpers.export(exports, "BiSolidSticker", ()=>BiSolidSticker);
parcelHelpers.export(exports, "BiSolidStopwatch", ()=>BiSolidStopwatch);
parcelHelpers.export(exports, "BiSolidStoreAlt", ()=>BiSolidStoreAlt);
parcelHelpers.export(exports, "BiSolidStore", ()=>BiSolidStore);
parcelHelpers.export(exports, "BiSolidSun", ()=>BiSolidSun);
parcelHelpers.export(exports, "BiSolidSushi", ()=>BiSolidSushi);
parcelHelpers.export(exports, "BiSolidTShirt", ()=>BiSolidTShirt);
parcelHelpers.export(exports, "BiSolidTachometer", ()=>BiSolidTachometer);
parcelHelpers.export(exports, "BiSolidTagAlt", ()=>BiSolidTagAlt);
parcelHelpers.export(exports, "BiSolidTagX", ()=>BiSolidTagX);
parcelHelpers.export(exports, "BiSolidTag", ()=>BiSolidTag);
parcelHelpers.export(exports, "BiSolidTaxi", ()=>BiSolidTaxi);
parcelHelpers.export(exports, "BiSolidTennisBall", ()=>BiSolidTennisBall);
parcelHelpers.export(exports, "BiSolidTerminal", ()=>BiSolidTerminal);
parcelHelpers.export(exports, "BiSolidThermometer", ()=>BiSolidThermometer);
parcelHelpers.export(exports, "BiSolidTimeFive", ()=>BiSolidTimeFive);
parcelHelpers.export(exports, "BiSolidTime", ()=>BiSolidTime);
parcelHelpers.export(exports, "BiSolidTimer", ()=>BiSolidTimer);
parcelHelpers.export(exports, "BiSolidTired", ()=>BiSolidTired);
parcelHelpers.export(exports, "BiSolidToTop", ()=>BiSolidToTop);
parcelHelpers.export(exports, "BiSolidToggleLeft", ()=>BiSolidToggleLeft);
parcelHelpers.export(exports, "BiSolidToggleRight", ()=>BiSolidToggleRight);
parcelHelpers.export(exports, "BiSolidTone", ()=>BiSolidTone);
parcelHelpers.export(exports, "BiSolidTorch", ()=>BiSolidTorch);
parcelHelpers.export(exports, "BiSolidTrafficBarrier", ()=>BiSolidTrafficBarrier);
parcelHelpers.export(exports, "BiSolidTrafficCone", ()=>BiSolidTrafficCone);
parcelHelpers.export(exports, "BiSolidTraffic", ()=>BiSolidTraffic);
parcelHelpers.export(exports, "BiSolidTrain", ()=>BiSolidTrain);
parcelHelpers.export(exports, "BiSolidTrashAlt", ()=>BiSolidTrashAlt);
parcelHelpers.export(exports, "BiSolidTrash", ()=>BiSolidTrash);
parcelHelpers.export(exports, "BiSolidTreeAlt", ()=>BiSolidTreeAlt);
parcelHelpers.export(exports, "BiSolidTree", ()=>BiSolidTree);
parcelHelpers.export(exports, "BiSolidTrophy", ()=>BiSolidTrophy);
parcelHelpers.export(exports, "BiSolidTruck", ()=>BiSolidTruck);
parcelHelpers.export(exports, "BiSolidTv", ()=>BiSolidTv);
parcelHelpers.export(exports, "BiSolidUniversalAccess", ()=>BiSolidUniversalAccess);
parcelHelpers.export(exports, "BiSolidUpArrowAlt", ()=>BiSolidUpArrowAlt);
parcelHelpers.export(exports, "BiSolidUpArrowCircle", ()=>BiSolidUpArrowCircle);
parcelHelpers.export(exports, "BiSolidUpArrowSquare", ()=>BiSolidUpArrowSquare);
parcelHelpers.export(exports, "BiSolidUpArrow", ()=>BiSolidUpArrow);
parcelHelpers.export(exports, "BiSolidUpsideDown", ()=>BiSolidUpsideDown);
parcelHelpers.export(exports, "BiSolidUpvote", ()=>BiSolidUpvote);
parcelHelpers.export(exports, "BiSolidUserAccount", ()=>BiSolidUserAccount);
parcelHelpers.export(exports, "BiSolidUserBadge", ()=>BiSolidUserBadge);
parcelHelpers.export(exports, "BiSolidUserCheck", ()=>BiSolidUserCheck);
parcelHelpers.export(exports, "BiSolidUserCircle", ()=>BiSolidUserCircle);
parcelHelpers.export(exports, "BiSolidUserDetail", ()=>BiSolidUserDetail);
parcelHelpers.export(exports, "BiSolidUserMinus", ()=>BiSolidUserMinus);
parcelHelpers.export(exports, "BiSolidUserPin", ()=>BiSolidUserPin);
parcelHelpers.export(exports, "BiSolidUserPlus", ()=>BiSolidUserPlus);
parcelHelpers.export(exports, "BiSolidUserRectangle", ()=>BiSolidUserRectangle);
parcelHelpers.export(exports, "BiSolidUserVoice", ()=>BiSolidUserVoice);
parcelHelpers.export(exports, "BiSolidUserX", ()=>BiSolidUserX);
parcelHelpers.export(exports, "BiSolidUser", ()=>BiSolidUser);
parcelHelpers.export(exports, "BiSolidVector", ()=>BiSolidVector);
parcelHelpers.export(exports, "BiSolidVial", ()=>BiSolidVial);
parcelHelpers.export(exports, "BiSolidVideoOff", ()=>BiSolidVideoOff);
parcelHelpers.export(exports, "BiSolidVideoPlus", ()=>BiSolidVideoPlus);
parcelHelpers.export(exports, "BiSolidVideoRecording", ()=>BiSolidVideoRecording);
parcelHelpers.export(exports, "BiSolidVideo", ()=>BiSolidVideo);
parcelHelpers.export(exports, "BiSolidVideos", ()=>BiSolidVideos);
parcelHelpers.export(exports, "BiSolidVirusBlock", ()=>BiSolidVirusBlock);
parcelHelpers.export(exports, "BiSolidVirus", ()=>BiSolidVirus);
parcelHelpers.export(exports, "BiSolidVolumeFull", ()=>BiSolidVolumeFull);
parcelHelpers.export(exports, "BiSolidVolumeLow", ()=>BiSolidVolumeLow);
parcelHelpers.export(exports, "BiSolidVolumeMute", ()=>BiSolidVolumeMute);
parcelHelpers.export(exports, "BiSolidVolume", ()=>BiSolidVolume);
parcelHelpers.export(exports, "BiSolidWalletAlt", ()=>BiSolidWalletAlt);
parcelHelpers.export(exports, "BiSolidWallet", ()=>BiSolidWallet);
parcelHelpers.export(exports, "BiSolidWasher", ()=>BiSolidWasher);
parcelHelpers.export(exports, "BiSolidWatchAlt", ()=>BiSolidWatchAlt);
parcelHelpers.export(exports, "BiSolidWatch", ()=>BiSolidWatch);
parcelHelpers.export(exports, "BiSolidWebcam", ()=>BiSolidWebcam);
parcelHelpers.export(exports, "BiSolidWidget", ()=>BiSolidWidget);
parcelHelpers.export(exports, "BiSolidWindowAlt", ()=>BiSolidWindowAlt);
parcelHelpers.export(exports, "BiSolidWine", ()=>BiSolidWine);
parcelHelpers.export(exports, "BiSolidWinkSmile", ()=>BiSolidWinkSmile);
parcelHelpers.export(exports, "BiSolidWinkTongue", ()=>BiSolidWinkTongue);
parcelHelpers.export(exports, "BiSolidWrench", ()=>BiSolidWrench);
parcelHelpers.export(exports, "BiSolidXCircle", ()=>BiSolidXCircle);
parcelHelpers.export(exports, "BiSolidXSquare", ()=>BiSolidXSquare);
parcelHelpers.export(exports, "BiSolidYinYang", ()=>BiSolidYinYang);
parcelHelpers.export(exports, "BiSolidZap", ()=>BiSolidZap);
parcelHelpers.export(exports, "BiSolidZoomIn", ()=>BiSolidZoomIn);
parcelHelpers.export(exports, "BiSolidZoomOut", ()=>BiSolidZoomOut);
parcelHelpers.export(exports, "BiLogo500Px", ()=>BiLogo500Px);
parcelHelpers.export(exports, "BiLogo99Designs", ()=>BiLogo99Designs);
parcelHelpers.export(exports, "BiLogoAdobe", ()=>BiLogoAdobe);
parcelHelpers.export(exports, "BiLogoAirbnb", ()=>BiLogoAirbnb);
parcelHelpers.export(exports, "BiLogoAlgolia", ()=>BiLogoAlgolia);
parcelHelpers.export(exports, "BiLogoAmazon", ()=>BiLogoAmazon);
parcelHelpers.export(exports, "BiLogoAndroid", ()=>BiLogoAndroid);
parcelHelpers.export(exports, "BiLogoAngular", ()=>BiLogoAngular);
parcelHelpers.export(exports, "BiLogoApple", ()=>BiLogoApple);
parcelHelpers.export(exports, "BiLogoAudible", ()=>BiLogoAudible);
parcelHelpers.export(exports, "BiLogoAws", ()=>BiLogoAws);
parcelHelpers.export(exports, "BiLogoBaidu", ()=>BiLogoBaidu);
parcelHelpers.export(exports, "BiLogoBehance", ()=>BiLogoBehance);
parcelHelpers.export(exports, "BiLogoBing", ()=>BiLogoBing);
parcelHelpers.export(exports, "BiLogoBitcoin", ()=>BiLogoBitcoin);
parcelHelpers.export(exports, "BiLogoBlender", ()=>BiLogoBlender);
parcelHelpers.export(exports, "BiLogoBlogger", ()=>BiLogoBlogger);
parcelHelpers.export(exports, "BiLogoBootstrap", ()=>BiLogoBootstrap);
parcelHelpers.export(exports, "BiLogoCPlusPlus", ()=>BiLogoCPlusPlus);
parcelHelpers.export(exports, "BiLogoChrome", ()=>BiLogoChrome);
parcelHelpers.export(exports, "BiLogoCodepen", ()=>BiLogoCodepen);
parcelHelpers.export(exports, "BiLogoCreativeCommons", ()=>BiLogoCreativeCommons);
parcelHelpers.export(exports, "BiLogoCss3", ()=>BiLogoCss3);
parcelHelpers.export(exports, "BiLogoDailymotion", ()=>BiLogoDailymotion);
parcelHelpers.export(exports, "BiLogoDeezer", ()=>BiLogoDeezer);
parcelHelpers.export(exports, "BiLogoDevTo", ()=>BiLogoDevTo);
parcelHelpers.export(exports, "BiLogoDeviantart", ()=>BiLogoDeviantart);
parcelHelpers.export(exports, "BiLogoDigg", ()=>BiLogoDigg);
parcelHelpers.export(exports, "BiLogoDigitalocean", ()=>BiLogoDigitalocean);
parcelHelpers.export(exports, "BiLogoDiscordAlt", ()=>BiLogoDiscordAlt);
parcelHelpers.export(exports, "BiLogoDiscord", ()=>BiLogoDiscord);
parcelHelpers.export(exports, "BiLogoDiscourse", ()=>BiLogoDiscourse);
parcelHelpers.export(exports, "BiLogoDjango", ()=>BiLogoDjango);
parcelHelpers.export(exports, "BiLogoDocker", ()=>BiLogoDocker);
parcelHelpers.export(exports, "BiLogoDribbble", ()=>BiLogoDribbble);
parcelHelpers.export(exports, "BiLogoDropbox", ()=>BiLogoDropbox);
parcelHelpers.export(exports, "BiLogoDrupal", ()=>BiLogoDrupal);
parcelHelpers.export(exports, "BiLogoEbay", ()=>BiLogoEbay);
parcelHelpers.export(exports, "BiLogoEdge", ()=>BiLogoEdge);
parcelHelpers.export(exports, "BiLogoEtsy", ()=>BiLogoEtsy);
parcelHelpers.export(exports, "BiLogoFacebookCircle", ()=>BiLogoFacebookCircle);
parcelHelpers.export(exports, "BiLogoFacebookSquare", ()=>BiLogoFacebookSquare);
parcelHelpers.export(exports, "BiLogoFacebook", ()=>BiLogoFacebook);
parcelHelpers.export(exports, "BiLogoFigma", ()=>BiLogoFigma);
parcelHelpers.export(exports, "BiLogoFirebase", ()=>BiLogoFirebase);
parcelHelpers.export(exports, "BiLogoFirefox", ()=>BiLogoFirefox);
parcelHelpers.export(exports, "BiLogoFlask", ()=>BiLogoFlask);
parcelHelpers.export(exports, "BiLogoFlickrSquare", ()=>BiLogoFlickrSquare);
parcelHelpers.export(exports, "BiLogoFlickr", ()=>BiLogoFlickr);
parcelHelpers.export(exports, "BiLogoFlutter", ()=>BiLogoFlutter);
parcelHelpers.export(exports, "BiLogoFoursquare", ()=>BiLogoFoursquare);
parcelHelpers.export(exports, "BiLogoGit", ()=>BiLogoGit);
parcelHelpers.export(exports, "BiLogoGithub", ()=>BiLogoGithub);
parcelHelpers.export(exports, "BiLogoGitlab", ()=>BiLogoGitlab);
parcelHelpers.export(exports, "BiLogoGmail", ()=>BiLogoGmail);
parcelHelpers.export(exports, "BiLogoGoLang", ()=>BiLogoGoLang);
parcelHelpers.export(exports, "BiLogoGoogleCloud", ()=>BiLogoGoogleCloud);
parcelHelpers.export(exports, "BiLogoGooglePlusCircle", ()=>BiLogoGooglePlusCircle);
parcelHelpers.export(exports, "BiLogoGooglePlus", ()=>BiLogoGooglePlus);
parcelHelpers.export(exports, "BiLogoGoogle", ()=>BiLogoGoogle);
parcelHelpers.export(exports, "BiLogoGraphql", ()=>BiLogoGraphql);
parcelHelpers.export(exports, "BiLogoHeroku", ()=>BiLogoHeroku);
parcelHelpers.export(exports, "BiLogoHtml5", ()=>BiLogoHtml5);
parcelHelpers.export(exports, "BiLogoImdb", ()=>BiLogoImdb);
parcelHelpers.export(exports, "BiLogoInstagramAlt", ()=>BiLogoInstagramAlt);
parcelHelpers.export(exports, "BiLogoInstagram", ()=>BiLogoInstagram);
parcelHelpers.export(exports, "BiLogoInternetExplorer", ()=>BiLogoInternetExplorer);
parcelHelpers.export(exports, "BiLogoInvision", ()=>BiLogoInvision);
parcelHelpers.export(exports, "BiLogoJava", ()=>BiLogoJava);
parcelHelpers.export(exports, "BiLogoJavascript", ()=>BiLogoJavascript);
parcelHelpers.export(exports, "BiLogoJoomla", ()=>BiLogoJoomla);
parcelHelpers.export(exports, "BiLogoJquery", ()=>BiLogoJquery);
parcelHelpers.export(exports, "BiLogoJsfiddle", ()=>BiLogoJsfiddle);
parcelHelpers.export(exports, "BiLogoKickstarter", ()=>BiLogoKickstarter);
parcelHelpers.export(exports, "BiLogoKubernetes", ()=>BiLogoKubernetes);
parcelHelpers.export(exports, "BiLogoLess", ()=>BiLogoLess);
parcelHelpers.export(exports, "BiLogoLinkedinSquare", ()=>BiLogoLinkedinSquare);
parcelHelpers.export(exports, "BiLogoLinkedin", ()=>BiLogoLinkedin);
parcelHelpers.export(exports, "BiLogoMagento", ()=>BiLogoMagento);
parcelHelpers.export(exports, "BiLogoMailchimp", ()=>BiLogoMailchimp);
parcelHelpers.export(exports, "BiLogoMarkdown", ()=>BiLogoMarkdown);
parcelHelpers.export(exports, "BiLogoMastercard", ()=>BiLogoMastercard);
parcelHelpers.export(exports, "BiLogoMastodon", ()=>BiLogoMastodon);
parcelHelpers.export(exports, "BiLogoMediumOld", ()=>BiLogoMediumOld);
parcelHelpers.export(exports, "BiLogoMediumSquare", ()=>BiLogoMediumSquare);
parcelHelpers.export(exports, "BiLogoMedium", ()=>BiLogoMedium);
parcelHelpers.export(exports, "BiLogoMessenger", ()=>BiLogoMessenger);
parcelHelpers.export(exports, "BiLogoMeta", ()=>BiLogoMeta);
parcelHelpers.export(exports, "BiLogoMicrosoftTeams", ()=>BiLogoMicrosoftTeams);
parcelHelpers.export(exports, "BiLogoMicrosoft", ()=>BiLogoMicrosoft);
parcelHelpers.export(exports, "BiLogoMongodb", ()=>BiLogoMongodb);
parcelHelpers.export(exports, "BiLogoNetlify", ()=>BiLogoNetlify);
parcelHelpers.export(exports, "BiLogoNodejs", ()=>BiLogoNodejs);
parcelHelpers.export(exports, "BiLogoOkRu", ()=>BiLogoOkRu);
parcelHelpers.export(exports, "BiLogoOpera", ()=>BiLogoOpera);
parcelHelpers.export(exports, "BiLogoPatreon", ()=>BiLogoPatreon);
parcelHelpers.export(exports, "BiLogoPaypal", ()=>BiLogoPaypal);
parcelHelpers.export(exports, "BiLogoPeriscope", ()=>BiLogoPeriscope);
parcelHelpers.export(exports, "BiLogoPhp", ()=>BiLogoPhp);
parcelHelpers.export(exports, "BiLogoPinterestAlt", ()=>BiLogoPinterestAlt);
parcelHelpers.export(exports, "BiLogoPinterest", ()=>BiLogoPinterest);
parcelHelpers.export(exports, "BiLogoPlayStore", ()=>BiLogoPlayStore);
parcelHelpers.export(exports, "BiLogoPocket", ()=>BiLogoPocket);
parcelHelpers.export(exports, "BiLogoPostgresql", ()=>BiLogoPostgresql);
parcelHelpers.export(exports, "BiLogoProductHunt", ()=>BiLogoProductHunt);
parcelHelpers.export(exports, "BiLogoPython", ()=>BiLogoPython);
parcelHelpers.export(exports, "BiLogoQuora", ()=>BiLogoQuora);
parcelHelpers.export(exports, "BiLogoReact", ()=>BiLogoReact);
parcelHelpers.export(exports, "BiLogoRedbubble", ()=>BiLogoRedbubble);
parcelHelpers.export(exports, "BiLogoReddit", ()=>BiLogoReddit);
parcelHelpers.export(exports, "BiLogoRedux", ()=>BiLogoRedux);
parcelHelpers.export(exports, "BiLogoSass", ()=>BiLogoSass);
parcelHelpers.export(exports, "BiLogoShopify", ()=>BiLogoShopify);
parcelHelpers.export(exports, "BiLogoSketch", ()=>BiLogoSketch);
parcelHelpers.export(exports, "BiLogoSkype", ()=>BiLogoSkype);
parcelHelpers.export(exports, "BiLogoSlackOld", ()=>BiLogoSlackOld);
parcelHelpers.export(exports, "BiLogoSlack", ()=>BiLogoSlack);
parcelHelpers.export(exports, "BiLogoSnapchat", ()=>BiLogoSnapchat);
parcelHelpers.export(exports, "BiLogoSoundcloud", ()=>BiLogoSoundcloud);
parcelHelpers.export(exports, "BiLogoSpotify", ()=>BiLogoSpotify);
parcelHelpers.export(exports, "BiLogoSpringBoot", ()=>BiLogoSpringBoot);
parcelHelpers.export(exports, "BiLogoSquarespace", ()=>BiLogoSquarespace);
parcelHelpers.export(exports, "BiLogoStackOverflow", ()=>BiLogoStackOverflow);
parcelHelpers.export(exports, "BiLogoSteam", ()=>BiLogoSteam);
parcelHelpers.export(exports, "BiLogoStripe", ()=>BiLogoStripe);
parcelHelpers.export(exports, "BiLogoTailwindCss", ()=>BiLogoTailwindCss);
parcelHelpers.export(exports, "BiLogoTelegram", ()=>BiLogoTelegram);
parcelHelpers.export(exports, "BiLogoTiktok", ()=>BiLogoTiktok);
parcelHelpers.export(exports, "BiLogoTrello", ()=>BiLogoTrello);
parcelHelpers.export(exports, "BiLogoTripAdvisor", ()=>BiLogoTripAdvisor);
parcelHelpers.export(exports, "BiLogoTumblr", ()=>BiLogoTumblr);
parcelHelpers.export(exports, "BiLogoTux", ()=>BiLogoTux);
parcelHelpers.export(exports, "BiLogoTwitch", ()=>BiLogoTwitch);
parcelHelpers.export(exports, "BiLogoTwitter", ()=>BiLogoTwitter);
parcelHelpers.export(exports, "BiLogoTypescript", ()=>BiLogoTypescript);
parcelHelpers.export(exports, "BiLogoUnity", ()=>BiLogoUnity);
parcelHelpers.export(exports, "BiLogoUnsplash", ()=>BiLogoUnsplash);
parcelHelpers.export(exports, "BiLogoUpwork", ()=>BiLogoUpwork);
parcelHelpers.export(exports, "BiLogoVenmo", ()=>BiLogoVenmo);
parcelHelpers.export(exports, "BiLogoVimeo", ()=>BiLogoVimeo);
parcelHelpers.export(exports, "BiLogoVisa", ()=>BiLogoVisa);
parcelHelpers.export(exports, "BiLogoVisualStudio", ()=>BiLogoVisualStudio);
parcelHelpers.export(exports, "BiLogoVk", ()=>BiLogoVk);
parcelHelpers.export(exports, "BiLogoVuejs", ()=>BiLogoVuejs);
parcelHelpers.export(exports, "BiLogoWhatsappSquare", ()=>BiLogoWhatsappSquare);
parcelHelpers.export(exports, "BiLogoWhatsapp", ()=>BiLogoWhatsapp);
parcelHelpers.export(exports, "BiLogoWikipedia", ()=>BiLogoWikipedia);
parcelHelpers.export(exports, "BiLogoWindows", ()=>BiLogoWindows);
parcelHelpers.export(exports, "BiLogoWix", ()=>BiLogoWix);
parcelHelpers.export(exports, "BiLogoWordpress", ()=>BiLogoWordpress);
parcelHelpers.export(exports, "BiLogoXing", ()=>BiLogoXing);
parcelHelpers.export(exports, "BiLogoYahoo", ()=>BiLogoYahoo);
parcelHelpers.export(exports, "BiLogoYelp", ()=>BiLogoYelp);
parcelHelpers.export(exports, "BiLogoYoutube", ()=>BiLogoYoutube);
parcelHelpers.export(exports, "BiLogoZoom", ()=>BiLogoZoom);
var _lib = require("../lib");
function BiAbacus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3h2v18H2zm18 0h2v18h-2zM5 13h2v1h2v-1h2v1h2v-1h4v1h2v-4h-2v1h-4v-1h-2v1H9v-1H7v1H5zm0-9v4h2V7h8v1h2V7h2V5h-2V4h-2v1H7V4zm0 13v3h2v-1h2v1h2v-1h8v-2h-8v-1H9v1H7v-1H5z"
                }
            }
        ]
    })(props);
}
function BiAccessibility(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "4",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17.836 12.014-4.345.725 3.29-4.113a1 1 0 0 0-.227-1.457l-6-4a.999.999 0 0 0-1.262.125l-4 4 1.414 1.414 3.42-3.42 2.584 1.723-2.681 3.352a5.913 5.913 0 0 0-5.5.752l1.451 1.451A3.972 3.972 0 0 1 8 12c2.206 0 4 1.794 4 4 0 .739-.216 1.425-.566 2.02l1.451 1.451A5.961 5.961 0 0 0 14 16c0-.445-.053-.878-.145-1.295L17 14.181V20h2v-7a.998.998 0 0 0-1.164-.986zM8 20c-2.206 0-4-1.794-4-4 0-.739.216-1.425.566-2.02l-1.451-1.451A5.961 5.961 0 0 0 2 16c0 3.309 2.691 6 6 6 1.294 0 2.49-.416 3.471-1.115l-1.451-1.451A3.972 3.972 0 0 1 8 20z"
                }
            }
        ]
    })(props);
}
function BiAddToQueue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM8 16V4h12l.002 12H8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8H2v12c0 1.103.897 2 2 2h12v-2H4V8zm11-2h-2v3h-3v2h3v3h2v-3h3V9h-3z"
                }
            }
        ]
    })(props);
}
function BiAdjust(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.514 0 10-4.486 10-10S17.514 2 12 2 2 6.486 2 12s4.486 10 10 10zm0-18c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12a7 7 0 0 0-7-7v14a7 7 0 0 0 7-7z"
                }
            }
        ]
    })(props);
}
function BiAlarmAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c-4.879 0-9 4.121-9 9s4.121 9 9 9 9-4.121 9-9-4.121-9-9-9zm0 16c-3.794 0-7-3.206-7-7s3.206-7 7-7 7 3.206 7 7-3.206 7-7 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8h-2v4H7v2h4v4h2v-4h4v-2h-4zm7.292-1.292-3.01-3 1.412-1.417 3.01 3zM5.282 2.294 6.7 3.706l-2.99 3-1.417-1.413z"
                }
            }
        ]
    })(props);
}
function BiAlarmExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c4.879 0 9-4.121 9-9s-4.121-9-9-9-9 4.121-9 9 4.121 9 9 9zm0-16c3.794 0 7 3.206 7 7s-3.206 7-7 7-7-3.206-7-7 3.206-7 7-7zm5.284-2.293 1.412-1.416 3.01 3-1.413 1.417zM5.282 2.294 6.7 3.706l-2.99 3-1.417-1.413z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9h2v5h-2zm0 6h2v2h-2z"
                }
            }
        ]
    })(props);
}
function BiAlarmOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.292 6.708-3.01-3 1.412-1.417 3.01 3zm1.415 13.585-2.287-2.287C20.409 16.563 21 14.838 21 13c0-4.879-4.121-9-9-9-1.838 0-3.563.591-5.006 1.58L5.91 4.496l.788-.79-1.416-1.412-.786.788-.789-.789-1.414 1.414 18 18 1.414-1.414zM12 6c3.794 0 7 3.206 7 7 0 1.292-.387 2.507-1.027 3.559L15.414 14H17v-2h-3.586L13 11.586V8h-2v1.586L8.441 7.027C9.493 6.387 10.708 6 12 6zM4.305 8.426A8.792 8.792 0 0 0 3 13c0 4.879 4.121 9 9 9a8.792 8.792 0 0 0 4.574-1.305l-1.461-1.461A6.801 6.801 0 0 1 12 20c-3.794 0-7-3.206-7-7 0-1.111.281-2.169.766-3.113L4.305 8.426z"
                }
            }
        ]
    })(props);
}
function BiAlarmSnooze(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c-4.879 0-9 4.121-9 9s4.121 9 9 9 9-4.121 9-9-4.121-9-9-9zm0 16c-3.794 0-7-3.206-7-7s3.206-7 7-7 7 3.206 7 7-3.206 7-7 7zm8.292-13.292-3.01-3 1.412-1.417 3.01 3zM6.698 3.707l-2.99 2.999L2.29 5.294l2.99-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.832 10.555A1 1 0 0 0 14 9H9v2h3.132l-2.964 4.445A1 1 0 0 0 10 17h5v-2h-3.132l2.964-4.445z"
                }
            }
        ]
    })(props);
}
function BiAlarm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c-4.879 0-9 4.121-9 9s4.121 9 9 9 9-4.121 9-9-4.121-9-9-9zm0 16c-3.794 0-7-3.206-7-7s3.206-7 7-7 7 3.206 7 7-3.206 7-7 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 12V8h-2v6h6v-2zm4.284-8.293 1.412-1.416 3.01 3-1.413 1.417zm-10.586 0-2.99 2.999L2.29 5.294l2.99-3z"
                }
            }
        ]
    })(props);
}
function BiAlbum(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.99",
                    "cy": "11.99",
                    "r": "2.01"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6a6 6 0 0 0-6 6h2a4 4 0 0 1 4-4z"
                }
            }
        ]
    })(props);
}
function BiAlignJustify(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7h16v2H4zm0-4h16v2H4zm0 8h16v2H4zm0 4h16v2H4zm2 4h12v2H6z"
                }
            }
        ]
    })(props);
}
function BiAlignLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19h16v2H4zm0-4h11v2H4zm0-4h16v2H4zm0-8h16v2H4zm0 4h11v2H4z"
                }
            }
        ]
    })(props);
}
function BiAlignMiddle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19h16v2H4zm3-4h10v2H7zm-3-4h16v2H4zm0-8h16v2H4zm3 4h10v2H7z"
                }
            }
        ]
    })(props);
}
function BiAlignRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19h16v2H4zm5-4h11v2H9zm-5-4h16v2H4zm0-8h16v2H4zm5 4h11v2H9z"
                }
            }
        ]
    })(props);
}
function BiAnalyse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12h2a7.986 7.986 0 0 1 2.337-5.663 7.91 7.91 0 0 1 2.542-1.71 8.12 8.12 0 0 1 6.13-.041A2.488 2.488 0 0 0 17.5 7C18.886 7 20 5.886 20 4.5S18.886 2 17.5 2c-.689 0-1.312.276-1.763.725-2.431-.973-5.223-.958-7.635.059a9.928 9.928 0 0 0-3.18 2.139 9.92 9.92 0 0 0-2.14 3.179A10.005 10.005 0 0 0 2 12zm17.373 3.122c-.401.952-.977 1.808-1.71 2.541s-1.589 1.309-2.542 1.71a8.12 8.12 0 0 1-6.13.041A2.488 2.488 0 0 0 6.5 17C5.114 17 4 18.114 4 19.5S5.114 22 6.5 22c.689 0 1.312-.276 1.763-.725A9.965 9.965 0 0 0 12 22a9.983 9.983 0 0 0 9.217-6.102A9.992 9.992 0 0 0 22 12h-2a7.993 7.993 0 0 1-.627 3.122z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.462c-2.502 0-4.538 2.036-4.538 4.538S9.498 16.538 12 16.538s4.538-2.036 4.538-4.538S14.502 7.462 12 7.462zm0 7.076c-1.399 0-2.538-1.139-2.538-2.538S10.601 9.462 12 9.462s2.538 1.139 2.538 2.538-1.139 2.538-2.538 2.538z"
                }
            }
        ]
    })(props);
}
function BiAnchor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m22 15-3-4-3 4h1.906c-.436 2.469-2.438 4.471-4.906 4.906V13h2v-2h-2V9.336c1.543-.459 2.714-1.923 2.714-3.621C15.714 3.666 14.048 2 12 2S8.286 3.666 8.286 5.715c0 1.698 1.171 3.162 2.714 3.621V11H9v2h2v6.906C8.531 19.471 6.529 17.469 6.094 15H8l-3-4-3 4h2.073c.511 3.885 3.929 7 7.927 7s7.416-3.115 7.927-7H22zM10.286 5.715C10.286 4.77 11.055 4 12 4s1.714.77 1.714 1.715c0 .951-.801 1.785-1.714 1.785s-1.714-.834-1.714-1.785z"
                }
            }
        ]
    })(props);
}
function BiAngry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14c-3 0-4 3-4 3h8s-1-3-4-3zm-2.439-2.439c.014-.014.023-.03.037-.044l1.031.413.742-1.857-5-2-.742 1.856 1.373.549L7 10.5a1.499 1.499 0 0 0 2.561 1.061zm3.068-1.49.742 1.857 1.037-.415c.011.011.019.024.029.035a1.488 1.488 0 0 0 2.112 0c.271-.271.438-.644.438-1.056l-.001-.01 1.386-.554-.742-1.857-5.001 2z"
                }
            }
        ]
    })(props);
}
function BiAperture(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.579 2 2 6.579 2 12s4.579 10 10 10 10-4.579 10-10S17.421 2 12 2zm2.113 13H9.986l-1.723-3.094L10.202 9h3.736l1.871 3.062L14.113 15zM4 12c0-.953.186-1.87.508-2.727L7.696 15H4.61A7.757 7.757 0 0 1 4 12zm12.283-3h3.106A7.74 7.74 0 0 1 20 12c0 .844-.143 1.66-.397 2.432L16.283 9zm1.905-2h-6.653l1.905-2.857c1.886.359 3.562 1.403 4.748 2.857zm-7.095-2.941L9.132 7H9v.197L7.17 9.942 5.65 7.214c1.3-1.703 3.249-2.895 5.443-3.155zM5.812 17h7.147l-1.709 2.961C9.084 19.748 7.141 18.63 5.812 17zm7.828 2.82 3.357-5.815 1.544 2.526c-1.154 1.642-2.901 2.854-4.901 3.289z"
                }
            }
        ]
    })(props);
}
function BiArch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 22h1v-6.995c.006-.502.177-3.005 3-3.005s2.994 2.503 3 3v7h7v-2h-1V4h1V2H2v2h1v16H2v2h6zM19 4v2H5V4h14zM5 8h14v12h-2v-5c0-1.729-1.045-5-5-5s-5 3.271-5 5v5H5V8z"
                }
            }
        ]
    })(props);
}
function BiArchiveIn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.706 5.292-2.999-2.999A.996.996 0 0 0 18 2H6a.996.996 0 0 0-.707.293L2.294 5.292A.994.994 0 0 0 2 6v13c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6a.994.994 0 0 0-.294-.708zM6.414 4h11.172l1 1H5.414l1-1zM4 19V7h16l.002 12H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9h-4v3H7l5 5 5-5h-3z"
                }
            }
        ]
    })(props);
}
function BiArchiveOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.706 5.292-2.999-2.999A.996.996 0 0 0 18 2H6a.996.996 0 0 0-.707.293L2.294 5.292A.994.994 0 0 0 2 6v13c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6a.994.994 0 0 0-.294-.708zM6.414 4h11.172l1 1H5.414l1-1zM4 19V7h16l.002 12H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14h3v3h4v-3h3l-5-5z"
                }
            }
        ]
    })(props);
}
function BiArchive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.706 5.291-2.999-2.998A.996.996 0 0 0 18 2H6a.996.996 0 0 0-.707.293L2.294 5.291A.994.994 0 0 0 2 5.999V19c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5.999a.994.994 0 0 0-.294-.708zM6.414 4h11.172l.999.999H5.415L6.414 4zM4 19V6.999h16L20.002 19H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 12H9v-2H7v4h10v-4h-2z"
                }
            }
        ]
    })(props);
}
function BiArea(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2zm16.002 14H5V5h14l.002 14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 12h2V7h-5v2h3zm-3 3H9v-3H7v5h5z"
                }
            }
        ]
    })(props);
}
function BiArrowBack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11H6.414l5.293-5.293-1.414-1.414L2.586 12l7.707 7.707 1.414-1.414L6.414 13H21z"
                }
            }
        ]
    })(props);
}
function BiArrowFromBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18h12v2H6zm6-14.414-6.707 6.707 1.414 1.414L11 7.414V16h2V7.414l4.293 4.293 1.414-1.414z"
                }
            }
        ]
    })(props);
}
function BiArrowFromLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h2v12H4zm4 7h8.586l-4.293 4.293 1.414 1.414L20.414 12l-6.707-6.707-1.414 1.414L16.586 11H8z"
                }
            }
        ]
    })(props);
}
function BiArrowFromRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6h2v12h-2zm-2 5H7.414l4.293-4.293-1.414-1.414L3.586 12l6.707 6.707 1.414-1.414L7.414 13H16z"
                }
            }
        ]
    })(props);
}
function BiArrowFromTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4h12v2H6zm6 16.414 6.707-6.707-1.414-1.414L13 16.586V8h-2v8.586l-4.293-4.293-1.414 1.414z"
                }
            }
        ]
    })(props);
}
function BiArrowToBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18h12v2H6zm5-14v8.586L6.707 8.293 5.293 9.707 12 16.414l6.707-6.707-1.414-1.414L13 12.586V4z"
                }
            }
        ]
    })(props);
}
function BiArrowToLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h2v12H4zm10.293-.707L7.586 12l6.707 6.707 1.414-1.414L11.414 13H20v-2h-8.586l4.293-4.293z"
                }
            }
        ]
    })(props);
}
function BiArrowToRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6h2v12h-2zM4 13h8.586l-4.293 4.293 1.414 1.414L16.414 12 9.707 5.293 8.293 6.707 12.586 11H4z"
                }
            }
        ]
    })(props);
}
function BiArrowToTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4h12v2H6zm.707 11.707L11 11.414V20h2v-8.586l4.293 4.293 1.414-1.414L12 7.586l-6.707 6.707z"
                }
            }
        ]
    })(props);
}
function BiAt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10c1.466 0 2.961-.371 4.442-1.104l-.885-1.793C14.353 19.698 13.156 20 12 20c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8v1c0 .692-.313 2-1.5 2-1.396 0-1.494-1.819-1.5-2V8h-2v.025A4.954 4.954 0 0 0 12 7c-2.757 0-5 2.243-5 5s2.243 5 5 5c1.45 0 2.748-.631 3.662-1.621.524.89 1.408 1.621 2.838 1.621 2.273 0 3.5-2.061 3.5-4v-1c0-5.514-4.486-10-10-10zm0 13c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3z"
                }
            }
        ]
    })(props);
}
function BiAtom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.102 20.898c.698.699 1.696 1.068 2.887 1.068 1.742 0 3.855-.778 6.012-2.127 2.156 1.35 4.27 2.127 6.012 2.127 1.19 0 2.188-.369 2.887-1.068 1.269-1.269 1.411-3.413.401-6.039-.358-.932-.854-1.895-1.457-2.859a16.792 16.792 0 0 0 1.457-2.859c1.01-2.626.867-4.771-.401-6.039-.698-.699-1.696-1.068-2.887-1.068-1.742 0-3.855.778-6.012 2.127-2.156-1.35-4.27-2.127-6.012-2.127-1.19 0-2.188.369-2.887 1.068C1.833 4.371 1.69 6.515 2.7 9.141c.359.932.854 1.895 1.457 2.859A16.792 16.792 0 0 0 2.7 14.859c-1.01 2.626-.867 4.77.402 6.039zm16.331-5.321c.689 1.79.708 3.251.052 3.907-.32.32-.815.482-1.473.482-1.167 0-2.646-.503-4.208-1.38a26.611 26.611 0 0 0 4.783-4.784c.336.601.623 1.196.846 1.775zM12 17.417a23.568 23.568 0 0 1-2.934-2.483A23.998 23.998 0 0 1 6.566 12 23.74 23.74 0 0 1 12 6.583a23.568 23.568 0 0 1 2.934 2.483 23.998 23.998 0 0 1 2.5 2.934A23.74 23.74 0 0 1 12 17.417zm6.012-13.383c.657 0 1.152.162 1.473.482.656.656.638 2.117-.052 3.907-.223.579-.51 1.174-.846 1.775a26.448 26.448 0 0 0-4.783-4.784c1.562-.876 3.041-1.38 4.208-1.38zM4.567 8.423c-.689-1.79-.708-3.251-.052-3.907.32-.32.815-.482 1.473-.482 1.167 0 2.646.503 4.208 1.38a26.448 26.448 0 0 0-4.783 4.784 13.934 13.934 0 0 1-.846-1.775zm0 7.154c.223-.579.51-1.174.846-1.775a26.448 26.448 0 0 0 4.783 4.784c-1.563.877-3.041 1.38-4.208 1.38-.657 0-1.152-.162-1.473-.482-.656-.656-.637-2.117.052-3.907z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2.574"
                }
            }
        ]
    })(props);
}
function BiAward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8.999c0 1.902.765 3.627 2 4.89V21a.998.998 0 0 0 1.447.895L12 20.118l3.553 1.776a.992.992 0 0 0 .972-.043c.295-.183.475-.504.475-.851v-7.11a6.976 6.976 0 0 0 2-4.891C19 5.14 15.86 2 12 2S5 5.14 5 8.999zm7.447 9.106a1 1 0 0 0-.895 0L9 19.382v-4.067c.911.434 1.926.685 3 .685s2.089-.25 3-.685v4.066l-2.553-1.276zM12 4c2.756 0 5 2.242 5 4.999A5.006 5.006 0 0 1 12 14c-2.757 0-5-2.243-5-5.001A5.005 5.005 0 0 1 12 4z"
                }
            }
        ]
    })(props);
}
function BiBadgeCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.035 15.479A3.976 3.976 0 0 0 4 16c0 2.378 2.138 4.284 4.521 3.964C9.214 21.198 10.534 22 12 22s2.786-.802 3.479-2.036C17.857 20.284 20 18.378 20 16c0-.173-.012-.347-.035-.521C21.198 14.786 22 13.465 22 12s-.802-2.786-2.035-3.479C19.988 8.347 20 8.173 20 8c0-2.378-2.143-4.288-4.521-3.964C14.786 2.802 13.466 2 12 2s-2.786.802-3.479 2.036C6.138 3.712 4 5.622 4 8c0 .173.012.347.035.521C2.802 9.214 2 10.535 2 12s.802 2.786 2.035 3.479zm1.442-5.403 1.102-.293-.434-1.053A1.932 1.932 0 0 1 6 8c0-1.103.897-2 2-2 .247 0 .499.05.73.145l1.054.434.293-1.102a1.99 1.99 0 0 1 3.846 0l.293 1.102 1.054-.434C15.501 6.05 15.753 6 16 6c1.103 0 2 .897 2 2 0 .247-.05.5-.145.73l-.434 1.053 1.102.293a1.993 1.993 0 0 1 0 3.848l-1.102.293.434 1.053c.095.23.145.483.145.73 0 1.103-.897 2-2 2-.247 0-.499-.05-.73-.145l-1.054-.434-.293 1.102a1.99 1.99 0 0 1-3.846 0l-.293-1.102-1.054.434A1.935 1.935 0 0 1 8 18c-1.103 0-2-.897-2-2 0-.247.05-.5.145-.73l.434-1.053-1.102-.293a1.993 1.993 0 0 1 0-3.848z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15.742 10.71-1.408-1.42-3.331 3.299-1.296-1.296-1.414 1.414 2.704 2.704z"
                }
            }
        ]
    })(props);
}
function BiBadge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.965 8.521C19.988 8.347 20 8.173 20 8c0-2.378-2.143-4.288-4.521-3.964C14.786 2.802 13.466 2 12 2s-2.786.802-3.479 2.036C6.138 3.712 4 5.622 4 8c0 .173.012.347.035.521C2.802 9.214 2 10.535 2 12s.802 2.786 2.035 3.479A3.976 3.976 0 0 0 4 16c0 2.378 2.138 4.284 4.521 3.964C9.214 21.198 10.534 22 12 22s2.786-.802 3.479-2.036C17.857 20.284 20 18.378 20 16c0-.173-.012-.347-.035-.521C21.198 14.786 22 13.465 22 12s-.802-2.786-2.035-3.479zm-1.442 5.403-1.102.293.434 1.053c.095.23.145.483.145.73 0 1.103-.897 2-2 2-.247 0-.499-.05-.73-.145l-1.054-.434-.293 1.102a1.99 1.99 0 0 1-3.846 0l-.293-1.102-1.054.434A1.935 1.935 0 0 1 8 18c-1.103 0-2-.897-2-2 0-.247.05-.5.145-.73l.434-1.053-1.102-.293a1.993 1.993 0 0 1 0-3.848l1.102-.293-.434-1.053A1.932 1.932 0 0 1 6 8c0-1.103.897-2 2-2 .247 0 .499.05.73.145l1.054.434.293-1.102a1.99 1.99 0 0 1 3.846 0l.293 1.102 1.054-.434C15.501 6.05 15.753 6 16 6c1.103 0 2 .897 2 2 0 .247-.05.5-.145.73l-.434 1.053 1.102.293a1.993 1.993 0 0 1 0 3.848z"
                }
            }
        ]
    })(props);
}
function BiBaguette(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.64 21.71a8 8 0 0 0 5.6-2.47l6-6c2.87-2.87 3.31-7.11 1-9.45s-6.58-1.91-9.45 1l-6 6c-2.87 2.87-3.31 7.11-1 9.45a5.38 5.38 0 0 0 3.85 1.47zm-2-9 2.78 2.79 1.42-1.42-2.79-2.79 1.41-1.41 2.83 2.83 1.42-1.42-2.83-2.83 1.41-1.41 2.83 2.83 1.42-1.42-2.79-2.78c2-1.61 4.65-1.87 6-.47s1.09 4.56-1 6.62l-6 6c-2.06 2.05-5.09 2.5-6.62 1s-1.06-4.07.55-6.08z"
                }
            }
        ]
    })(props);
}
function BiBall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.76 21a17.68 17.68 0 0 0 4 .43 13.89 13.89 0 0 0 9.93-3.69C23 12.37 21.06 4.11 21 3.76a1 1 0 0 0-.76-.76 17.91 17.91 0 0 0-4-.43 13.82 13.82 0 0 0-9.96 3.71C.94 11.63 2.94 19.89 3 20.24a1 1 0 0 0 .76.76zM7.7 7.7a11.86 11.86 0 0 1 8.49-3.1 17.57 17.57 0 0 1 3 .25c.31 1.87.91 7.67-2.86 11.44a11.91 11.91 0 0 1-8.55 3.11 17.16 17.16 0 0 1-2.93-.25c-.32-1.88-.92-7.67 2.85-11.45z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7.29 15.29 1.42 1.42 1.79-1.79 1.79 1.79 1.42-1.42-1.8-1.79 1.59-1.59 1.79 1.8 1.42-1.42-1.8-1.79 1.8-1.79-1.42-1.42-1.79 1.8-1.79-1.8-1.42 1.42 1.8 1.79-1.59 1.59-1.79-1.8-1.42 1.42 1.8 1.79z"
                }
            }
        ]
    })(props);
}
function BiBandAid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.111 21.889a5.962 5.962 0 0 0 4.242-1.757l7.778-7.778a6.007 6.007 0 0 0 0-8.485 5.965 5.965 0 0 0-4.243-1.757 5.962 5.962 0 0 0-4.242 1.757l-7.778 7.778a6.007 6.007 0 0 0 0 8.485 5.965 5.965 0 0 0 4.243 1.757zm-2.829-8.828 7.778-7.778a3.976 3.976 0 0 1 2.828-1.171c1.069 0 2.073.416 2.829 1.171a4.006 4.006 0 0 1 0 5.657l-7.778 7.778a3.976 3.976 0 0 1-2.828 1.171 3.977 3.977 0 0 1-2.829-1.171 4.008 4.008 0 0 1 0-5.657z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "12",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "12",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "15",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "9",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function BiBarChartAlt2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7h-4V4c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v5H4c-1.103 0-2 .897-2 2v9a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V9c0-1.103-.897-2-2-2zM4 11h4v8H4v-8zm6-1V4h4v15h-4v-9zm10 9h-4V9h4v10z"
                }
            }
        ]
    })(props);
}
function BiBarChartAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6h2v11h-2zm4-3h2v14h-2zM9 9h2v8H9zM4 19h16v2H4zm1-7h2v5H5z"
                }
            }
        ]
    })(props);
}
function BiBarChartSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2zm16.001 14H5V5h14l.001 14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h2v10h-2zm4 3h2v7h-2zm-8 2h2v5H7z"
                }
            }
        ]
    })(props);
}
function BiBarChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6h2v14H9zm4 2h2v12h-2zm4-4h2v16h-2zM5 12h2v8H5z"
                }
            }
        ]
    })(props);
}
function BiBarcodeReader(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 7h2v10H5zm9 0h1v10h-1zm-4 0h3v10h-3zM8 7h1v10H8zm8 0h3v10h-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 5h4V3H4c-1.103 0-2 .897-2 2v4h2V5zm0 16h4v-2H4v-4H2v4c0 1.103.897 2 2 2zM20 3h-4v2h4v4h2V5c0-1.103-.897-2-2-2zm0 16h-4v2h4c1.103 0 2-.897 2-2v-4h-2v4z"
                }
            }
        ]
    })(props);
}
function BiBarcode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM4 18V6h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8h2v8H6zm3 0h1v8H9zm8 0h1v8h-1zm-4 0h3v8h-3zm-2 0h1v8h-1z"
                }
            }
        ]
    })(props);
}
function BiBaseball(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2a9.937 9.937 0 0 0-7.071 2.938c-3.898 3.898-3.898 10.243 0 14.143 1.895 1.895 4.405 2.938 7.071 2.938s5.177-1.043 7.071-2.938c3.899-3.899 3.899-10.244 0-14.143A9.937 9.937 0 0 0 11.99 2zm5.657 15.667a7.957 7.957 0 0 1-3.816 2.129l-.001-.037a6.199 6.199 0 0 1 .421-2.259l-1.863-.729a8.188 8.188 0 0 0-.552 3.239 7.953 7.953 0 0 1-5.503-2.344 7.965 7.965 0 0 1-2.332-5.503c.08.002.16.005.24.005a8.16 8.16 0 0 0 2.988-.558l-.73-1.862a6.156 6.156 0 0 1-2.281.412 7.936 7.936 0 0 1 2.115-3.809 7.963 7.963 0 0 1 3.972-2.168 5.974 5.974 0 0 1-.357 1.95l1.881.681a7.92 7.92 0 0 0 .482-2.701c0-.033-.004-.065-.005-.098 2.013.079 3.9.896 5.342 2.336a7.959 7.959 0 0 1 2.324 5.348 7.908 7.908 0 0 0-2.787.473l.684 1.88a5.91 5.91 0 0 1 1.935-.361 7.953 7.953 0 0 1-2.157 3.976z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.112 14.13a7.599 7.599 0 0 0-.926 1.121l1.656 1.12c.2-.296.43-.574.683-.826a6.428 6.428 0 0 1 1.178-.929l-1.049-1.703a8.408 8.408 0 0 0-1.542 1.217zM8.456 8.474a5.713 5.713 0 0 1-.827.681l1.119 1.658a7.72 7.72 0 0 0 1.122-.926 8.501 8.501 0 0 0 1.217-1.542L9.384 7.297a6.519 6.519 0 0 1-.928 1.177z"
                }
            }
        ]
    })(props);
}
function BiBasket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9h-1.42l-3.712-6.496-1.736.992L17.277 9H6.723l3.146-5.504-1.737-.992L4.42 9H3a1.001 1.001 0 0 0-.965 1.263l2.799 10.264A2.005 2.005 0 0 0 6.764 22h10.473c.898 0 1.692-.605 1.93-1.475l2.799-10.263A.998.998 0 0 0 21 9zm-3.764 11v1-1H6.764L4.31 11h15.38l-2.454 9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13h2v5H9zm4 0h2v5h-2z"
                }
            }
        ]
    })(props);
}
function BiBasketball(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.929 19.071c1.895 1.895 4.405 2.938 7.071 2.938s5.177-1.043 7.071-2.938c3.899-3.899 3.899-10.243 0-14.143C17.177 3.034 14.665 1.99 12 1.99S6.823 3.034 4.929 4.929c-3.899 3.898-3.899 10.243 0 14.142zm7.38-15.065a7.912 7.912 0 0 1 4.594 1.678L12 10.586l-1.46-1.46c1.161-1.479 1.792-3.308 1.769-5.12zM9.11 7.696 7.098 5.684a7.929 7.929 0 0 1 3.218-1.51c-.015 1.236-.445 2.477-1.206 3.522zM7.686 9.1a6.065 6.065 0 0 1-3.459 1.057 7.923 7.923 0 0 1 1.458-3.058L7.686 9.1zm-3.675 3.046c.077.002.154.014.231.014a8.05 8.05 0 0 0 4.877-1.626L10.586 12l-4.901 4.901a7.972 7.972 0 0 1-1.674-4.755zm12.294 2.745c1.042-.758 2.28-1.188 3.508-1.206a7.947 7.947 0 0 1-1.497 3.217l-2.011-2.011zm.597 3.425a7.935 7.935 0 0 1-3.059 1.47 6.05 6.05 0 0 1 1.057-3.472l2.002 2.002zm-5.044 1.686a7.922 7.922 0 0 1-4.761-1.686L12 13.414l1.463 1.463c-1.103 1.444-1.659 3.266-1.605 5.125zm8.124-8.31c-1.807-.018-3.633.61-5.108 1.768L13.414 12l4.901-4.901a7.968 7.968 0 0 1 1.667 4.593z"
                }
            }
        ]
    })(props);
}
function BiBath(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10H7V7c0-1.103.897-2 2-2s2 .897 2 2h2c0-2.206-1.794-4-4-4S5 4.794 5 7v3H3a1 1 0 0 0-1 1v2c0 2.606 1.674 4.823 4 5.65V22h2v-3h8v3h2v-3.35c2.326-.827 4-3.044 4-5.65v-2a1 1 0 0 0-1-1zm-1 3c0 2.206-1.794 4-4 4H8c-2.206 0-4-1.794-4-4v-1h16v1z"
                }
            }
        ]
    })(props);
}
function BiBattery(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18h14c1.103 0 2-.897 2-2v-2h2v-4h-2V8c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2zM4 8h14l.002 8H4V8z"
                }
            }
        ]
    })(props);
}
function BiBed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9.557V3h-2v2H6V3H4v6.557C2.81 10.25 2 11.525 2 13v4a1 1 0 0 0 1 1h1v4h2v-4h12v4h2v-4h1a1 1 0 0 0 1-1v-4c0-1.475-.811-2.75-2-3.443zM18 7v2h-5V7h5zM6 7h5v2H6V7zm14 9H4v-3c0-1.103.897-2 2-2h12c1.103 0 2 .897 2 2v3z"
                }
            }
        ]
    })(props);
}
function BiBeenHere(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C7.589 2 4 5.589 4 9.995c-.029 6.445 7.116 11.604 7.42 11.819a.998.998 0 0 0 1.16 0C12.884 21.599 20.029 16.44 20 10c0-4.411-3.589-8-8-8zm0 17.735C10.389 18.427 5.979 14.441 6 10c0-3.309 2.691-6 6-6s6 2.691 6 6.005c.021 4.437-4.388 8.423-6 9.73z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11.586 8.707 9.293l-1.414 1.414L11 14.414l5.707-5.707-1.414-1.414z"
                }
            }
        ]
    })(props);
}
function BiBeer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-2V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v15c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3v-1h2c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zm-4 13c0 .551-.448 1-1 1H5c-.552 0-1-.449-1-1V5h12v14zm4-3h-2V8h2v8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7h2v10H6zm6 0h2v10h-2z"
                }
            }
        ]
    })(props);
}
function BiBellMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.707 15.293 19 13.586V10c0-3.217-2.185-5.927-5.145-6.742C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258C7.185 4.074 5 6.783 5 10v3.586l-1.707 1.707A.996.996 0 0 0 3 16v2a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-2a.996.996 0 0 0-.293-.707zM19 17H5v-.586l1.707-1.707A.996.996 0 0 0 7 14v-4c0-2.757 2.243-5 5-5s5 2.243 5 5v4c0 .266.105.52.293.707L19 16.414V17zm-7 5a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.037 10h7.926v2H8.037z"
                }
            }
        ]
    })(props);
}
function BiBellOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22zm9-4v-2a.996.996 0 0 0-.293-.707L19 13.586V10c0-3.217-2.185-5.927-5.145-6.742C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258c-1.323.364-2.463 1.128-3.346 2.127L3.707 2.293 2.293 3.707l18 18 1.414-1.414-1.362-1.362A.993.993 0 0 0 21 18zM12 5c2.757 0 5 2.243 5 5v4c0 .266.105.52.293.707L19 16.414V17h-.586L8.207 6.793C9.12 5.705 10.471 5 12 5zm-5.293 9.707A.996.996 0 0 0 7 14v-2.879L5.068 9.189C5.037 9.457 5 9.724 5 10v3.586l-1.707 1.707A.996.996 0 0 0 3 16v2a1 1 0 0 0 1 1h10.879l-2-2H5v-.586l1.707-1.707z"
                }
            }
        ]
    })(props);
}
function BiBellPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7.037h-2V10H8.037v2H11v2.963h2V12h2.963v-2H13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13.586V10c0-3.217-2.185-5.927-5.145-6.742C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258C7.185 4.074 5 6.783 5 10v3.586l-1.707 1.707A.996.996 0 0 0 3 16v2a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-2a.996.996 0 0 0-.293-.707L19 13.586zM19 17H5v-.586l1.707-1.707A.996.996 0 0 0 7 14v-4c0-2.757 2.243-5 5-5s5 2.243 5 5v4c0 .266.105.52.293.707L19 16.414V17zm-7 5a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22z"
                }
            }
        ]
    })(props);
}
function BiBell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13.586V10c0-3.217-2.185-5.927-5.145-6.742C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258C7.185 4.074 5 6.783 5 10v3.586l-1.707 1.707A.996.996 0 0 0 3 16v2a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-2a.996.996 0 0 0-.293-.707L19 13.586zM19 17H5v-.586l1.707-1.707A.996.996 0 0 0 7 14v-4c0-2.757 2.243-5 5-5s5 2.243 5 5v4c0 .266.105.52.293.707L19 16.414V17zm-7 5a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22z"
                }
            }
        ]
    })(props);
}
function BiBible(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22h15v-2H6.012C5.55 19.988 5 19.805 5 19s.55-.988 1.012-1H21V4c0-1.103-.897-2-2-2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3zM5 8V5c0-.805.55-.988 1-1h13v12H5V8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14h2v-4h2V8h-2V6h-2v2H9v2h2z"
                }
            }
        ]
    })(props);
}
function BiBitcoin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13v4H6v2h3v2h2v-2h2v2h2v-2.051c1.968-.249 3.5-1.915 3.5-3.949 0-1.32-.65-2.484-1.64-3.213A3.982 3.982 0 0 0 18 9c0-1.858-1.279-3.411-3-3.858V3h-2v2h-2V3H9v2H6v2h2v6zm6.5 4H10v-4h4.5c1.103 0 2 .897 2 2s-.897 2-2 2zM10 7h4c1.103 0 2 .897 2 2s-.897 2-2 2h-4V7z"
                }
            }
        ]
    })(props);
}
function BiBlanket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H7C4.243 2 2 4.243 2 7v10c0 2.757 2.243 5 5 5h12c1.654 0 3-1.346 3-3s-1.346-3-3-3H6v2h13a1 1 0 0 1 0 2H7c-1.654 0-3-1.346-3-3s1.346-3 3-3h13c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 10H7a4.973 4.973 0 0 0-3 1.002V7c0-1.654 1.346-3 3-3h13v8z"
                }
            }
        ]
    })(props);
}
function BiBlock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM4 12c0-1.846.634-3.542 1.688-4.897l11.209 11.209A7.946 7.946 0 0 1 12 20c-4.411 0-8-3.589-8-8zm14.312 4.897L7.103 5.688A7.948 7.948 0 0 1 12 4c4.411 0 8 3.589 8 8a7.954 7.954 0 0 1-1.688 4.897z"
                }
            }
        ]
    })(props);
}
function BiBluetooth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m4.41 16.192 1.18 1.615L10 14.584V21a1 1 0 0 0 1.541.841l7-4.5a.999.999 0 0 0 .049-1.649L13.537 12l5.053-3.692a1.002 1.002 0 0 0-.049-1.65l-7-4.5a1.002 1.002 0 0 0-1.021-.037c-.32.176-.52.513-.52.879v6.416L5.59 6.192 4.41 7.808 10 11.893v.215l-5.59 4.084zM12 4.832l4.232 2.721L12 10.646V4.832zm0 8.522 4.232 3.093L12 19.168v-5.814z"
                }
            }
        ]
    })(props);
}
function BiBody(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 22V9h5V7H4v2h5v13h2v-7h2v7z"
                }
            }
        ]
    })(props);
}
function BiBold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.061 11.22A4.46 4.46 0 0 0 18 8.5C18 6.019 15.981 4 13.5 4H6v15h8c2.481 0 4.5-2.019 4.5-4.5a4.48 4.48 0 0 0-1.439-3.28zM13.5 7c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5H9V7h4.5zm.5 9H9v-3h5c.827 0 1.5.673 1.5 1.5S14.827 16 14 16z"
                }
            }
        ]
    })(props);
}
function BiBoltCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13 6-6 7h4v5l6-7h-4z"
                }
            }
        ]
    })(props);
}
function BiBomb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3.001c-1.4 0-2.584 1.167-2.707 1.293L17.207 5.38l-1.091-1.088a.999.999 0 0 0-1.413.001L13.46 5.537A8.353 8.353 0 0 0 10.5 5C5.813 5 2 8.813 2 13.5S5.813 22 10.5 22s8.5-3.813 8.5-8.5c0-.909-.144-1.8-.428-2.658l1.345-1.345a1.002 1.002 0 0 0-.001-1.415l-1.293-1.29 1.088-1.088c.229-.229.845-.703 1.289-.703h1v-2h-1zm-4.511 7.978c.339.804.511 1.652.511 2.521 0 3.584-2.916 6.5-6.5 6.5S4 17.084 4 13.5 6.916 7 10.5 7c.96 0 1.89.21 2.762.624.381.181.837.103 1.136-.196l1.014-1.014 2.384 2.377-1.092 1.092a.998.998 0 0 0-.215 1.096z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 13.5a4.47 4.47 0 0 0 1.318 3.182l1.414-1.414C8.26 14.795 8 14.168 8 13.5s.26-1.295.732-1.768A2.484 2.484 0 0 1 10.5 11V9a4.469 4.469 0 0 0-3.182 1.318A4.47 4.47 0 0 0 6 13.5z"
                }
            }
        ]
    })(props);
}
function BiBone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.049 4.951a3.953 3.953 0 0 0-1.028-1.801c-1.51-1.51-4.146-1.51-5.656 0a4.009 4.009 0 0 0-.618 4.86l-3.714 3.714c-1.505-.89-3.591-.649-4.86.618a4.004 4.004 0 0 0 0 5.657 3.946 3.946 0 0 0 1.8 1.028c.178.681.53 1.302 1.028 1.8A3.966 3.966 0 0 0 8.829 22a3.973 3.973 0 0 0 2.828-1.172 4.007 4.007 0 0 0 .617-4.859l3.714-3.714c1.507.891 3.593.65 4.861-.619a4.003 4.003 0 0 0 0-5.656 3.942 3.942 0 0 0-1.8-1.029zm.387 5.271c-.756.755-2.073.756-2.829 0l-.707-.707-6.363 6.364.707.707a2.003 2.003 0 0 1 0 2.828c-.757.757-2.074.755-2.829 0a1.963 1.963 0 0 1-.571-1.31l-.047-.9-.9-.047a1.972 1.972 0 0 1-1.31-.571 2.003 2.003 0 0 1 0-2.829c.377-.377.879-.585 1.413-.585s1.036.208 1.414.585l.707.707 6.364-6.363-.707-.707a2.003 2.003 0 0 1 0-2.829c.756-.754 2.072-.754 2.828 0 .343.343.546.809.572 1.312l.048.897.897.048c.503.026.969.229 1.312.572.377.378.585.88.585 1.414s-.207 1.036-.584 1.414z"
                }
            }
        ]
    })(props);
}
function BiBong(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19.293 8.293-2.069 2.069A7.017 7.017 0 0 0 15 8.681V4h1V2H8v2h1v4.681A7.01 7.01 0 0 0 5 15c0 3.859 3.141 7 7 7s7-3.141 7-7a6.958 6.958 0 0 0-.652-2.934l2.359-2.359-1.414-1.414zm-8.959 1.998.666-.235V4h2v6.056l.666.235A5.006 5.006 0 0 1 16.886 14H7.114a5.006 5.006 0 0 1 3.22-3.709zM12 20a5.007 5.007 0 0 1-4.898-4h9.797A5.009 5.009 0 0 1 12 20z"
                }
            }
        ]
    })(props);
}
function BiBookAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 8v11c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.806 5 19c0-.101.009-.191.024-.273.112-.576.584-.717.988-.727H21V4c0-1.103-.897-2-2-2H6c-1.206 0-3 .799-3 3v3zm3-4h13v12H5V5c0-.806.55-.988 1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14h2v-3h3V9h-3V6h-2v3H8v2h3z"
                }
            }
        ]
    })(props);
}
function BiBookAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.806 5 19s.55-.988 1.012-1H21V4c0-1.103-.897-2-2-2zm0 14H5V5c0-.806.55-.988 1-1h13v12z"
                }
            }
        ]
    })(props);
}
function BiBookBookmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2.01H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.998 5 19.815 5 19.01c0-.101.009-.191.024-.273.112-.575.583-.717.987-.727H20c.018 0 .031-.009.049-.01H21V4.01c0-1.103-.897-2-2-2zm0 14H5v-11c0-.806.55-.988 1-1h7v7l2-1 2 1v-7h2v12z"
                }
            }
        ]
    })(props);
}
function BiBookContent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 19V5h7v14H4zm9 0V5h7l.001 14H13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7h3v2h-3zm0 4h3v2h-3z"
                }
            }
        ]
    })(props);
}
function BiBookHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 8v11c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.806 5 19s.55-.988 1.012-1H21V4c0-1.103-.897-2-2-2H6c-1.206 0-3 .799-3 3v3zm3-4h13v12H5V5c0-.806.55-.988 1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11.997 14 3.35-3.289a2.129 2.129 0 0 0 0-3.069 2.225 2.225 0 0 0-3.126 0l-.224.218-.224-.219a2.224 2.224 0 0 0-3.125 0 2.129 2.129 0 0 0 0 3.069L11.997 14z"
                }
            }
        ]
    })(props);
}
function BiBookOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3h-7a2.98 2.98 0 0 0-2 .78A2.98 2.98 0 0 0 10 3H3a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h5.758c.526 0 1.042.214 1.414.586l1.121 1.121c.009.009.021.012.03.021.086.079.182.149.294.196h.002a.996.996 0 0 0 .762 0h.002c.112-.047.208-.117.294-.196.009-.009.021-.012.03-.021l1.121-1.121A2.015 2.015 0 0 1 15.242 20H21a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM8.758 18H4V5h6c.552 0 1 .449 1 1v12.689A4.032 4.032 0 0 0 8.758 18zM20 18h-4.758c-.799 0-1.584.246-2.242.689V6c0-.551.448-1 1-1h6v13z"
                }
            }
        ]
    })(props);
}
function BiBookReader(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 8c-.202 0-4.85.029-9 2.008C7.85 8.029 3.202 8 3 8a1 1 0 0 0-1 1v9.883a1 1 0 0 0 .305.719c.195.188.48.305.729.28l.127-.001c.683 0 4.296.098 8.416 2.025.016.008.034.005.05.011.119.049.244.083.373.083s.254-.034.374-.083c.016-.006.034-.003.05-.011 4.12-1.928 7.733-2.025 8.416-2.025l.127.001c.238.025.533-.092.729-.28.194-.189.304-.449.304-.719V9a1 1 0 0 0-1-1zM4 10.049c1.485.111 4.381.48 7 1.692v7.742c-3-1.175-5.59-1.494-7-1.576v-7.858zm16 7.858c-1.41.082-4 .401-7 1.576v-7.742c2.619-1.212 5.515-1.581 7-1.692v7.858z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "5",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function BiBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22h15v-2H6.012C5.55 19.988 5 19.805 5 19s.55-.988 1.012-1H21V4c0-1.103-.897-2-2-2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3zM5 8V5c0-.805.55-.988 1-1h13v12H5V8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6h9v2H8z"
                }
            }
        ]
    })(props);
}
function BiBookmarkAltMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 2h-12C4.57 2 3 3.57 3 5.5V22l7-3.5 7 3.5v-9h5V5.5C22 3.57 20.43 2 18.5 2zM15 18.764l-5-2.5-5 2.5V5.5C5 4.673 5.673 4 6.5 4h8.852A3.451 3.451 0 0 0 15 5.5v13.264zM20 11h-3V5.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5V11z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9h6v2H7z"
                }
            }
        ]
    })(props);
}
function BiBookmarkAltPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 2h-12C4.57 2 3 3.57 3 5.5V22l7-3.5 7 3.5v-9h5V5.5C22 3.57 20.43 2 18.5 2zM15 18.764l-5-2.5-5 2.5V5.5C5 4.673 5.673 4 6.5 4h8.852A3.451 3.451 0 0 0 15 5.5v13.264zM20 11h-3V5.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5V11z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7H9v2H7v2h2v2h2v-2h2V9h-2z"
                }
            }
        ]
    })(props);
}
function BiBookmarkAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 2h-12C4.57 2 3 3.57 3 5.5V22l7-3.5 7 3.5v-9h5V5.5C22 3.57 20.43 2 18.5 2zM15 18.764l-5-2.5-5 2.5V5.5C5 4.673 5.673 4 6.5 4h8.852A3.451 3.451 0 0 0 15 5.5v13.264zM20 11h-3V5.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5V11z"
                }
            }
        ]
    })(props);
}
function BiBookmarkHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22V4c0-1.103-.897-2-2-2H6c-1.103 0-2 .897-2 2v18l8-4.572L20 22zM6 10V4h12v14.553l-6-3.428-6 3.428V10z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.409 9.512c.361-.372.585-.888.585-1.456s-.223-1.083-.585-1.456a1.962 1.962 0 0 0-1.412-.603S13.001 5.994 12 7.026c-1.001-1.032-1.997-1.029-1.997-1.029-.552 0-1.051.23-1.412.603-.362.373-.585.887-.585 1.456s.223 1.084.585 1.456L12 13.203l3.409-3.691z"
                }
            }
        ]
    })(props);
}
function BiBookmarkMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9h8v2H8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22V4c0-1.103-.897-2-2-2H6c-1.103 0-2 .897-2 2v18l8-4.572L20 22zM6 10V4h12v14.553l-6-3.428-6 3.428V10z"
                }
            }
        ]
    })(props);
}
function BiBookmarkPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 14v-3h3V9h-3V6h-2v3H8v2h3v3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 22V4c0-1.103-.897-2-2-2H6c-1.103 0-2 .897-2 2v18l8-4.572L20 22zM6 10V4h12v14.553l-6-3.428-6 3.428V10z"
                }
            }
        ]
    })(props);
}
function BiBookmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6c-1.103 0-2 .897-2 2v18l8-4.572L20 22V4c0-1.103-.897-2-2-2zm0 16.553-6-3.428-6 3.428V4h12v14.553z"
                }
            }
        ]
    })(props);
}
function BiBookmarks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 5H6c-1.103 0-2 .897-2 2v16l6-3.601L16 23V7c0-1.103-.897-2-2-2zm0 14.467-4-2.399-4 2.399V7h8v12.467z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 1h-8c-1.103 0-2 .897-2 2h8c1.103 0 2 .897 2 2v10.443l2 2.489V3c0-1.103-.897-2-2-2z"
                }
            }
        ]
    })(props);
}
function BiBorderAll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21h12V3H3v18h6zm10-4v2h-6v-6h6v4zM15 5h4v6h-6V5h2zM5 7V5h6v6H5V7zm0 12v-6h6v6H5z"
                }
            }
        ]
    })(props);
}
function BiBorderBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7h2v2H3zm0 4h2v2H3zm0 4h2v2H3zM3 3h2v2H3zm8 0h2v2h-2zM7 3h2v2H7zm8 0h2v2h-2zm4 0h2v2h-2zm0 12h2v2h-2zm0-4h2v2h-2zm0-4h2v2h-2zm-4 4h2v2h-2zm-8 0h2v2H7zm4-4h2v2h-2zm0 8h2v2h-2zm0-4h2v2h-2zm6 8H3v2h18v-2h-2z"
                }
            }
        ]
    })(props);
}
function BiBorderInner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19h2v2h-2zM7 19h2v2H7zm8 0h2v2h-2zM3 19h2v2H3zm0-4h2v2H3zm0-8h2v2H3zm0-4h2v2H3zm12 0h2v2h-2zM7 3h2v2H7zm12 0h2v2h-2zm0 12h2v2h-2zm0-8h2v2h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 13h6v8h2v-8h8v-2h-8V3h-2v8H3v2h1.93z"
                }
            }
        ]
    })(props);
}
function BiBorderLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 3h2v2h-2zm4 0h2v2h-2zM7 3h2v2H7zm12 0h2v2h-2zm0 8h2v2h-2zm0 4h2v2h-2zm0-8h2v2h-2zm0 12h2v2h-2zm-4 0h2v2h-2zm-8 0h2v2H7zm4 0h2v2h-2zm0-4h2v2h-2zm0-8h2v2h-2zm4 4h2v2h-2zm-8 0h2v2H7zm4 0h2v2h-2zM3 5v16h2V3H3z"
                }
            }
        ]
    })(props);
}
function BiBorderNone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19h2v2h-2zm-8 0h2v2h-2zm4 0h2v2h-2zm-8 0h2v2H7zm-4 0h2v2H3zM3 7h2v2H3zm0 8h2v2H3zm0-4h2v2H3zm0-8h2v2H3zm4 0h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2zm4 0h2v2h-2zm0 4h2v2h-2zm0 4h2v2h-2zm0 4h2v2h-2zm-8-8h2v2h-2zm0 8h2v2h-2zm-4-4h2v2H7zm8 0h2v2h-2zm-4 0h2v2h-2z"
                }
            }
        ]
    })(props);
}
function BiBorderOuter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h2v2h-2zm0 8h2v2h-2zm-4-4h2v2H7zm8 0h2v2h-2zm-4 0h2v2h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H3v18h18V3h-2zm0 4v12H5V5h14v2z"
                }
            }
        ]
    })(props);
}
function BiBorderRadius(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19h2v2h-2zM7 19h2v2H7zm8 0h2v2h-2zm-4 0h2v2h-2zm-8 0h2v2H3zm0-4h2v2H3zm0-8h2v2H3zm0 4h2v2H3zm0-8h2v2H3zm4 0h2v2H7zm12 12h2v2h-2zM16 3h-5v2h5c1.654 0 3 1.346 3 3v5h2V8c0-2.757-2.243-5-5-5z"
                }
            }
        ]
    })(props);
}
function BiBorderRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 19h2v2h-2zm-4 0h2v2h-2zm-4 0h2v2H7zm-4 0h2v2H3zM3 7h2v2H3zm0 8h2v2H3zm0-4h2v2H3zm0-8h2v2H3zm12 0h2v2h-2zm-4 0h2v2h-2zM7 3h2v2H7zm4 4h2v2h-2zm0 8h2v2h-2zm-4-4h2v2H7zm8 0h2v2h-2zm-4 0h2v2h-2zm8-6v16h2V3h-2z"
                }
            }
        ]
    })(props);
}
function BiBorderTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 11h2v2h-2zm0 4h2v2h-2zm0-8h2v2h-2zm0 12h2v2h-2zm-8 0h2v2h-2zm4 0h2v2h-2zm-8 0h2v2H7zm-4 0h2v2H3zm0-8h2v2H3zm0 4h2v2H3zm0-8h2v2H3zm4 4h2v2H7zm8 0h2v2h-2zm-4-4h2v2h-2zm0 8h2v2h-2zm0-4h2v2h-2zm10-8H3v2h18z"
                }
            }
        ]
    })(props);
}
function BiBot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.928 11.607c-.202-.488-.635-.605-.928-.633V8c0-1.103-.897-2-2-2h-6V4.61c.305-.274.5-.668.5-1.11a1.5 1.5 0 0 0-3 0c0 .442.195.836.5 1.11V6H5c-1.103 0-2 .897-2 2v2.997l-.082.006A1 1 0 0 0 1.99 12v2a1 1 0 0 0 1 1H3v5c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-5a1 1 0 0 0 1-1v-1.938a1.006 1.006 0 0 0-.072-.455zM5 20V8h14l.001 3.996L19 12v2l.001.005.001 5.995H5z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "8.5",
                    "cy": "12",
                    "rx": "1.5",
                    "ry": "2"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "15.5",
                    "cy": "12",
                    "rx": "1.5",
                    "ry": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16h8v2H8z"
                }
            }
        ]
    })(props);
}
function BiBowlHot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10H3a1 1 0 0 0-1 1 10 10 0 0 0 5 8.66V21a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1.34A10 10 0 0 0 22 11a1 1 0 0 0-1-1zm-5.45 8.16a1 1 0 0 0-.55.9V20H9v-.94a1 1 0 0 0-.55-.9A8 8 0 0 1 4.06 12h15.88a8 8 0 0 1-4.39 6.16zM9 9V7.93a4.53 4.53 0 0 0-1.28-3.15A2.49 2.49 0 0 1 7 3V2H5v1a4.53 4.53 0 0 0 1.28 3.17A2.49 2.49 0 0 1 7 7.93V9zm4 0V7.93a4.53 4.53 0 0 0-1.28-3.15A2.49 2.49 0 0 1 11 3V2H9v1a4.53 4.53 0 0 0 1.28 3.15A2.49 2.49 0 0 1 11 7.93V9zm4 0V7.93a4.53 4.53 0 0 0-1.28-3.15A2.49 2.49 0 0 1 15 3V2h-2v1a4.53 4.53 0 0 0 1.28 3.15A2.49 2.49 0 0 1 15 7.93V9z"
                }
            }
        ]
    })(props);
}
function BiBowlRice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 19.66V21a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1.34A10 10 0 0 0 22 11a1 1 0 0 0-1-1 3.58 3.58 0 0 0-1.8-3 3.66 3.66 0 0 0-3.63-3.13 3.86 3.86 0 0 0-1 .13 3.7 3.7 0 0 0-5.11 0 3.86 3.86 0 0 0-1-.13A3.66 3.66 0 0 0 4.81 7 3.58 3.58 0 0 0 3 10a1 1 0 0 0-1 1 10 10 0 0 0 5 8.66zm-.89-11 .83-.26-.16-.9a1.64 1.64 0 0 1 1.66-1.62 1.78 1.78 0 0 1 .83.2l.81.45.5-.77a1.71 1.71 0 0 1 2.84 0l.5.77.81-.45a1.78 1.78 0 0 1 .83-.2 1.65 1.65 0 0 1 1.67 1.6l-.16.85.82.28A1.59 1.59 0 0 1 19 10H5a1.59 1.59 0 0 1 1.11-1.39zM19.94 12a8 8 0 0 1-4.39 6.16 1 1 0 0 0-.55.9V20H9v-.94a1 1 0 0 0-.55-.9A8 8 0 0 1 4.06 12z"
                }
            }
        ]
    })(props);
}
function BiBowlingBall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "10.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "7.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.5",
                    "cy": "11.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function BiBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a2 2 0 0 0-2 2v2a2 2 0 0 0 1 1.72V19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.72A2 2 0 0 0 22 7V5a2 2 0 0 0-2-2zM4 5h16v2H4zm1 14V9h14v10z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11h8v2H8z"
                }
            }
        ]
    })(props);
}
function BiBracket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4V2H4v20h6v-2H6V4zm4 16v2h6V2h-6v2h4v16z"
                }
            }
        ]
    })(props);
}
function BiBraille(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "4",
                    "cy": "7",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "12",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "7",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "12",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "17",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "20",
                    "cy": "7",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4",
                    "cy": "17",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function BiBrain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.864 8.465a3.505 3.505 0 0 0-3.03-4.449A3.005 3.005 0 0 0 14 2a2.98 2.98 0 0 0-2 .78A2.98 2.98 0 0 0 10 2c-1.301 0-2.41.831-2.825 2.015a3.505 3.505 0 0 0-3.039 4.45A4.028 4.028 0 0 0 2 12c0 1.075.428 2.086 1.172 2.832A4.067 4.067 0 0 0 3 16c0 1.957 1.412 3.59 3.306 3.934A3.515 3.515 0 0 0 9.5 22c.979 0 1.864-.407 2.5-1.059A3.484 3.484 0 0 0 14.5 22a3.51 3.51 0 0 0 3.19-2.06 4.006 4.006 0 0 0 3.138-5.108A4.003 4.003 0 0 0 22 12a4.028 4.028 0 0 0-2.136-3.535zM9.5 20c-.711 0-1.33-.504-1.47-1.198L7.818 18H7c-1.103 0-2-.897-2-2 0-.352.085-.682.253-.981l.456-.816-.784-.51A2.019 2.019 0 0 1 4 12c0-.977.723-1.824 1.682-1.972l1.693-.26-1.059-1.346a1.502 1.502 0 0 1 1.498-2.39L9 6.207V5a1 1 0 0 1 2 0v13.5c0 .827-.673 1.5-1.5 1.5zm9.575-6.308-.784.51.456.816c.168.3.253.63.253.982 0 1.103-.897 2-2.05 2h-.818l-.162.802A1.502 1.502 0 0 1 14.5 20c-.827 0-1.5-.673-1.5-1.5V5c0-.552.448-1 1-1s1 .448 1 1.05v1.207l1.186-.225a1.502 1.502 0 0 1 1.498 2.39l-1.059 1.347 1.693.26A2.002 2.002 0 0 1 20 12c0 .683-.346 1.315-.925 1.692z"
                }
            }
        ]
    })(props);
}
function BiBriefcaseAlt2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-3V4c0-1.103-.897-2-2-2H9c-1.103 0-2 .897-2 2v2H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zm-5-2v2H9V4h6zM4 8h16v4h-3v-2h-2v2H9v-2H7v2H4V8zm0 11v-5h3v2h2v-2h6v2h2v-2h3.001v5H4z"
                }
            }
        ]
    })(props);
}
function BiBriefcaseAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-3V4c0-1.103-.897-2-2-2H9c-1.103 0-2 .897-2 2v2H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zm-4 2v11H8V8h8zm-1-4v2H9V4h6zM4 8h2v11H4V8zm14 11V8h2l.001 11H18z"
                }
            }
        ]
    })(props);
}
function BiBriefcase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-3V4c0-1.103-.897-2-2-2H9c-1.103 0-2 .897-2 2v2H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zm-5-2v2H9V4h6zM8 8h12v3H4V8h4zM4 19v-6h6v2h4v-2h6l.001 6H4z"
                }
            }
        ]
    })(props);
}
function BiBrightnessHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.707 11.293-2-2L19 8.586V6a1 1 0 0 0-1-1h-2.586l-.707-.707-2-2a.999.999 0 0 0-1.414 0l-2 2L8.586 5H6a1 1 0 0 0-1 1v2.586l-.707.707-2 2a.999.999 0 0 0 0 1.414l2 2 .707.707V18a1 1 0 0 0 1 1h2.586l.707.707 2 2a.997.997 0 0 0 1.414 0l2-2 .707-.707H18a1 1 0 0 0 1-1v-2.586l.707-.707 2-2a.999.999 0 0 0 0-1.414zm-4.414 3-.293.293V17h-2.414l-.293.293-1 1L12 19.586l-1.293-1.293-1-1L9.414 17H7v-2.414l-.293-.293-1-1L4.414 12l1.293-1.293 1-1L7 9.414V7h2.414l.293-.293 1-1L12 4.414l1.293 1.293 1 1 .293.293H17v2.414l.293.293 1 1L19.586 12l-1.293 1.293-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8v8c2.206 0 4-1.794 4-4s-1.794-4-4-4z"
                }
            }
        ]
    })(props);
}
function BiBrightness(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.707 9.293 19 8.586V6a1 1 0 0 0-1-1h-2.586l-.707-.707-2-2a.999.999 0 0 0-1.414 0l-2 2L8.586 5H6a1 1 0 0 0-1 1v2.586l-.707.707-2 2a.999.999 0 0 0 0 1.414l2 2 .707.707V18a1 1 0 0 0 1 1h2.586l.707.707 2 2a.997.997 0 0 0 1.414 0l2-2 .707-.707H18a1 1 0 0 0 1-1v-2.586l.707-.707 2-2a.999.999 0 0 0 0-1.414l-2-2zm-2.414 5-.293.293V17h-2.414l-.293.293-1 1L12 19.586l-1.293-1.293-1-1L9.414 17H7v-2.414l-.293-.293-1-1L4.414 12l1.293-1.293 1-1L7 9.414V7h2.414l.293-.293 1-1L12 4.414l1.293 1.293 1 1 .293.293H17v2.414l.293.293 1 1L19.586 12l-1.293 1.293-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4z"
                }
            }
        ]
    })(props);
}
function BiBroadcast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19.707 4.293-1.414 1.414c2.733 2.733 2.733 7.353 0 10.086l1.414 1.414c3.5-3.5 3.5-9.414 0-12.914zm-4.414 4.414c.566.566.879 1.292.879 2.043s-.313 1.477-.879 2.043l1.414 1.414c.944-.943 1.465-2.172 1.465-3.457s-.521-2.514-1.465-3.457l-1.414 1.414zm-9.086-3L4.793 4.293c-3.5 3.5-3.5 9.414 0 12.914l1.414-1.414c-2.733-2.733-2.733-7.353 0-10.086z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.293 7.293c-.944.943-1.465 2.172-1.465 3.457s.521 2.514 1.465 3.457l1.414-1.414c-.566-.566-.879-1.292-.879-2.043s.313-1.477.879-2.043L7.293 7.293zM14 10.5a2 2 0 0 0-4 0 1.993 1.993 0 0 0 .895 1.666L10.002 22h3.996l-.893-9.835c.54-.358.895-.97.895-1.665z"
                }
            }
        ]
    })(props);
}
function BiBrushAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8.001h-4V4.999a2.92 2.92 0 0 0-.874-2.108 2.943 2.943 0 0 0-2.39-.879C10.202 2.144 9 3.508 9 5.117V8H5c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-9.999c0-1.103-.897-2-2-2zM5 10h6V5.117c0-.57.407-1.07 1.002-1.117.266 0 .512.103.712.307a.956.956 0 0 1 .286.692V10h.995l.005.001h5V12H5v-2zm0 10v-6h14l.002 6H5z"
                }
            }
        ]
    })(props);
}
function BiBrush(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.707 2.293a.999.999 0 0 0-1.414 0l-5.84 5.84c-.015-.001-.029-.009-.044-.009a.997.997 0 0 0-.707.293L4.288 9.831a2.985 2.985 0 0 0-.878 2.122c0 .802.313 1.556.879 2.121l.707.707-2.122 2.122A2.92 2.92 0 0 0 2 19.012a2.968 2.968 0 0 0 1.063 2.308c.519.439 1.188.68 1.885.68.834 0 1.654-.341 2.25-.937l2.04-2.039.707.706c1.134 1.133 3.109 1.134 4.242.001l1.415-1.414a.997.997 0 0 0 .293-.707c0-.026-.013-.05-.015-.076l5.827-5.827a.999.999 0 0 0 0-1.414l-8-8zm-.935 16.024a1.023 1.023 0 0 1-1.414-.001l-1.414-1.413a.999.999 0 0 0-1.414 0l-2.746 2.745a1.19 1.19 0 0 1-.836.352.91.91 0 0 1-.594-.208A.978.978 0 0 1 4 19.01a.959.959 0 0 1 .287-.692l2.829-2.829a.999.999 0 0 0 0-1.414L5.701 12.66a.99.99 0 0 1-.292-.706c0-.268.104-.519.293-.708l.707-.707 7.071 7.072-.708.706zm1.889-2.392L8.075 9.339 13 4.414 19.586 11l-4.925 4.925z"
                }
            }
        ]
    })(props);
}
function BiBugAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9h6v2H9zm0 4h6v2H9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m18 5.414 1.707-1.707-1.414-1.414-1.563 1.562C15.483 2.708 13.824 2 12 2s-3.483.708-4.73 1.855L5.707 2.293 4.293 3.707 6 5.414A6.937 6.937 0 0 0 5 9H3v2h2v2H3v2h2c0 3.86 3.141 7 7 7s7-3.14 7-7h2v-2h-2v-2h2V9h-2a6.937 6.937 0 0 0-1-3.586zM17 13v2c0 2.757-2.243 5-5 5s-5-2.243-5-5V9c0-2.757 2.243-5 5-5s5 2.243 5 5v4z"
                }
            }
        ]
    })(props);
}
function BiBug(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m16.895 6.519 2.813-2.812-1.414-1.414-2.846 2.846a6.575 6.575 0 0 0-.723-.454 5.778 5.778 0 0 0-5.45 0c-.25.132-.488.287-.722.453L5.707 2.293 4.293 3.707l2.813 2.812A8.473 8.473 0 0 0 5.756 9H2v2h2.307c-.065.495-.107.997-.107 1.5 0 .507.042 1.013.107 1.511H2v2h2.753c.013.039.021.08.034.118.188.555.421 1.093.695 1.6.044.081.095.155.141.234l-2.33 2.33 1.414 1.414 2.11-2.111a7.477 7.477 0 0 0 2.068 1.619c.479.253.982.449 1.496.58a6.515 6.515 0 0 0 3.237.001 6.812 6.812 0 0 0 1.496-.58c.465-.246.914-.55 1.333-.904.258-.218.5-.462.734-.716l2.111 2.111 1.414-1.414-2.33-2.33c.047-.08.098-.155.142-.236.273-.505.507-1.043.694-1.599.013-.039.021-.079.034-.118H22v-2h-2.308c.065-.499.107-1.004.107-1.511 0-.503-.042-1.005-.106-1.5H22V9h-3.756a8.494 8.494 0 0 0-1.349-2.481zM8.681 7.748c.445-.558.96-.993 1.528-1.294a3.773 3.773 0 0 1 3.581 0 4.894 4.894 0 0 1 1.53 1.295c.299.373.54.8.753 1.251H7.927c.214-.451.454-.879.754-1.252zM17.8 12.5c0 .522-.042 1.044-.126 1.553-.079.49-.199.973-.355 1.436a8.28 8.28 0 0 1-.559 1.288 7.59 7.59 0 0 1-.733 1.11c-.267.333-.56.636-.869.898-.31.261-.639.484-.979.664s-.695.317-1.057.41c-.04.01-.082.014-.122.023V14h-2v5.881c-.04-.009-.082-.013-.122-.023-.361-.093-.717-.23-1.057-.41s-.669-.403-.978-.664a6.462 6.462 0 0 1-.871-.899 7.402 7.402 0 0 1-.731-1.108 8.337 8.337 0 0 1-.56-1.289 9.075 9.075 0 0 1-.356-1.438A9.61 9.61 0 0 1 6.319 11H17.68c.079.491.12.995.12 1.5z"
                }
            }
        ]
    })(props);
}
function BiBuildingHouse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H9c-1.103 0-2 .897-2 2v5.586l-4.707 4.707A1 1 0 0 0 3 16v5a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4c0-1.103-.897-2-2-2zm-8 18H5v-5.586l3-3 3 3V20zm8 0h-6v-4a.999.999 0 0 0 .707-1.707L9 9.586V4h10v16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6h2v2h-2zm4 0h2v2h-2zm0 4.031h2V12h-2zM15 14h2v2h-2zm-8 1h2v2H7z"
                }
            }
        ]
    })(props);
}
function BiBuilding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6c-1.103 0-2 .897-2 2v17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4c0-1.103-.897-2-2-2zm0 18H6V4h12v16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6h3v2H8zm5 0h3v2h-3zm-5 4h3v2H8zm5 .031h3V12h-3zM8 14h3v2H8zm5 0h3v2h-3z"
                }
            }
        ]
    })(props);
}
function BiBuildings(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H9c-1.103 0-2 .897-2 2v6H5c-1.103 0-2 .897-2 2v9a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4c0-1.103-.897-2-2-2zM5 12h6v8H5v-8zm14 8h-6v-8c0-1.103-.897-2-2-2H9V4h10v16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6h2v2h-2zm4 0h2v2h-2zm0 4.031h2V12h-2zM15 14h2v2h-2zm-8 .001h2v2H7z"
                }
            }
        ]
    })(props);
}
function BiBulb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 20h6v2H9zm7.906-6.288C17.936 12.506 19 11.259 19 9c0-3.859-3.141-7-7-7S5 5.141 5 9c0 2.285 1.067 3.528 2.101 4.73.358.418.729.851 1.084 1.349.144.206.38.996.591 1.921H8v2h8v-2h-.774c.213-.927.45-1.719.593-1.925.352-.503.726-.94 1.087-1.363zm-2.724.213c-.434.617-.796 2.075-1.006 3.075h-2.351c-.209-1.002-.572-2.463-1.011-3.08a20.502 20.502 0 0 0-1.196-1.492C7.644 11.294 7 10.544 7 9c0-2.757 2.243-5 5-5s5 2.243 5 5c0 1.521-.643 2.274-1.615 3.413-.373.438-.796.933-1.203 1.512z"
                }
            }
        ]
    })(props);
}
function BiBullseye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zm0 10c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.579 2 2 6.579 2 12s4.579 10 10 10 10-4.579 10-10S17.421 2 12 2zm0 18c-4.337 0-8-3.663-8-8s3.663-8 8-8 8 3.663 8 8-3.663 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c-1.081 0-2 .919-2 2s.919 2 2 2 2-.919 2-2-.919-2-2-2z"
                }
            }
        ]
    })(props);
}
function BiBuoy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm7.411 7H16v.031A5.037 5.037 0 0 0 14.969 8H15V4.589A8.039 8.039 0 0 1 19.411 9zM12 15c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm1-10.931v3.032a4.988 4.988 0 0 0-2 0V4.069c.328-.041.66-.069 1-.069s.672.028 1 .069zm-4 .52V8h.031A5.037 5.037 0 0 0 8 9.031V9H4.589C5.402 7 6.999 5.402 9 4.589zM4.069 11h3.032a4.995 4.995 0 0 0 .001 2H4.069C4.028 12.672 4 12.339 4 12s.028-.672.069-1zm.52 4H8v-.031c.284.381.621.718 1 1.005v3.437A8.039 8.039 0 0 1 4.589 15zM11 19.931v-3.032a4.988 4.988 0 0 0 2 0v3.032c-.328.041-.66.069-1 .069s-.672-.028-1-.069zm4-.52v-3.437a5.038 5.038 0 0 0 1-1.005V15h3.411A8.039 8.039 0 0 1 15 19.411zM19.931 13h-3.032a4.995 4.995 0 0 0-.001-2h3.032c.042.328.07.661.07 1s-.028.672-.069 1z"
                }
            }
        ]
    })(props);
}
function BiBusSchool(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.259 11.948A.986.986 0 0 0 22 11V8a.999.999 0 0 0-.996-.999V6H21c0-2.206-1.794-4-4-4H7C4.794 2 3 3.794 3 6v1a1 1 0 0 0-1 1v3c0 .461.317.832.742.948a3.953 3.953 0 0 0-.741 2.298l.004 3.757c.001.733.404 1.369.995 1.716V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h12v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.274a2.02 2.02 0 0 0 .421-.313c.377-.378.585-.881.584-1.415l-.004-3.759a3.966 3.966 0 0 0-.742-2.291zM5 18h-.995l-.004-3.757c-.001-.459.161-.89.443-1.243h15.111c.283.353.445.783.446 1.242L20.006 18H5zm6.004-10v3H5V8h6.004zM19 11h-5.996V8H19v3zM7 4h10c1.103 0 2 .897 2 2h-4V5H9v1H5c0-1.103.897-2 2-2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "15.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "15.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function BiBus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.004 7.975V6c0-2.206-1.794-4-4-4h-10c-2.206 0-4 1.794-4 4v1.998l-.076.004A1 1 0 0 0 2 9v2a1 1 0 0 0 1 1h.004v6c0 .735.403 1.372.996 1.72V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h10v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.276A1.994 1.994 0 0 0 21.004 18v-6a1 1 0 0 0 1-1V9.062a1.006 1.006 0 0 0-.072-.455c-.203-.487-.635-.604-.928-.632zM19.006 18H5.004v-5h14.001l.001 5zM11.004 7v4h-6V7h6zm8 0v4h-6V7h6zm-12-3h10c.736 0 1.375.405 1.722 1H5.282c.347-.595.986-1 1.722-1z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "15.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "15.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function BiCabinet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V4zM5 4h14v7H5V4zm0 16v-7h14.001v7H5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7h-4V6H8v3h8V6h-2zm0 8v1h-4v-1H8v3h8v-3z"
                }
            }
        ]
    })(props);
}
function BiCableCar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2 9.76 9-2.45V10H7a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-4V6.76l9-2.45V2.24L2 7.69zM11 12v3H7v-3zm6 0v8H7v-3h10v-2h-4v-3z"
                }
            }
        ]
    })(props);
}
function BiCake(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5h-6V2h-2v3H5C3.346 5 2 6.346 2 8v10c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.654-1.346-3-3-3zM5 7h14a1 1 0 0 1 1 1l.001 3.12c-.896.228-1.469.734-1.916 1.132-.507.45-.842.748-1.588.748-.745 0-1.08-.298-1.587-.747-.595-.529-1.409-1.253-2.915-1.253-1.505 0-2.319.724-2.914 1.253-.507.45-.841.747-1.586.747-.743 0-1.077-.297-1.582-.747-.447-.398-1.018-.905-1.913-1.133V8a1 1 0 0 1 1-1zM4 18v-4.714c.191.123.374.274.583.461C5.178 14.276 5.991 15 7.495 15c1.505 0 2.319-.724 2.914-1.253.507-.45.841-.747 1.586-.747s1.08.298 1.587.747c.595.529 1.409 1.253 2.915 1.253s2.321-.724 2.916-1.253c.211-.188.395-.34.588-.464L20.002 18H4z"
                }
            }
        ]
    })(props);
}
function BiCalculator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM5 20V4h14l.001 16H5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12h2v2H7zm0 4h2v2H7zm4-4h2v2h-2zM7 6h10v4H7zm4 10h2v2h-2zm4-4h2v6h-2z"
                }
            }
        ]
    })(props);
}
function BiCalendarAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2V2h-2v2H9V2H7v2H5a2 2 0 0 0-2 2zm16 14H5V8h14z"
                }
            }
        ]
    })(props);
}
function BiCalendarCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11 17.414 5.707-5.707-1.414-1.414L11 14.586l-2.293-2.293-1.414 1.414z"
                }
            }
        ]
    })(props);
}
function BiCalendarEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-3V2h-2v2h-4V2H8v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM5 20V7h14V6l.002 14H5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15.628 12.183-1.8-1.799 1.37-1.371 1.8 1.799zm-7.623 4.018V18h1.799l4.976-4.97-1.799-1.799z"
                }
            }
        ]
    })(props);
}
function BiCalendarEvent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12h6v6h-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.001 16H5V8h14l.001 12z"
                }
            }
        ]
    })(props);
}
function BiCalendarExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 10h2v5h-2zm0 6h2v2h-2z"
                }
            }
        ]
    })(props);
}
function BiCalendarHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.648 14.711 11.997 18l3.35-3.289a2.129 2.129 0 0 0 0-3.069 2.225 2.225 0 0 0-3.126 0l-.224.219-.224-.219a2.224 2.224 0 0 0-3.125 0 2.129 2.129 0 0 0 0 3.069z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"
                }
            }
        ]
    })(props);
}
function BiCalendarMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13h8v2H8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"
                }
            }
        ]
    })(props);
}
function BiCalendarPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15h3v3h2v-3h3v-2h-3v-3h-2v3H8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"
                }
            }
        ]
    })(props);
}
function BiCalendarStar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m9.981 14.811-.467 2.726 2.449-1.287 2.449 1.287-.468-2.726 1.982-1.932-2.738-.398L11.963 10l-1.225 2.481L8 12.879z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"
                }
            }
        ]
    })(props);
}
function BiCalendarWeek(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-3V2h-2v2h-4V2H8v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM5 20V7h14V6l.002 14H5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10v2h10V9H7z"
                }
            }
        ]
    })(props);
}
function BiCalendarX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m8.293 16.293 1.414 1.414L12 15.414l2.293 2.293 1.414-1.414L13.414 14l2.293-2.293-1.414-1.414L12 12.586l-2.293-2.293-1.414 1.414L10.586 14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"
                }
            }
        ]
    })(props);
}
function BiCalendar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11h2v2H7zm0 4h2v2H7zm4-4h2v2h-2zm0 4h2v2h-2zm4-4h2v2h-2zm0 4h2v2h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM19 8l.001 12H5V8h14z"
                }
            }
        ]
    })(props);
}
function BiCameraHome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.125 2H5.875A1.877 1.877 0 0 0 4 3.875v12.25C4 17.159 4.841 18 5.875 18H11v2H7v2h10v-2h-4v-2h5.125A1.877 1.877 0 0 0 20 16.125V3.875A1.877 1.877 0 0 0 18.125 2zM18 16H6V4h12v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z"
                }
            }
        ]
    })(props);
}
function BiCameraMovie(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11c0-.959-.68-1.761-1.581-1.954C16.779 8.445 17 7.75 17 7c0-2.206-1.794-4-4-4-1.517 0-2.821.857-3.5 2.104C8.821 3.857 7.517 3 6 3 3.794 3 2 4.794 2 7c0 .902.312 1.727.817 2.396A1.994 1.994 0 0 0 2 11v8c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-2.638l4 2v-7l-4 2V11zm-5-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zM6 5c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zM4 19v-8h12l.002 8H4z"
                }
            }
        ]
    })(props);
}
function BiCameraOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.014 12.135c.074 2.062 1.789 3.777 3.851 3.851l-3.851-3.851z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 20h11.879l-2-2H4V8.121L2.144 6.265A1.976 1.976 0 0 0 2 7v11c0 1.103.897 2 2 2zM20 5h-2.586l-2.707-2.707A.996.996 0 0 0 14 2h-4a.997.997 0 0 0-.707.293L6.586 5h-.172L3.707 2.293 2.293 3.707l18 18 1.414-1.414-.626-.626A1.98 1.98 0 0 0 22 18V7c0-1.103-.897-2-2-2zm-6.081 7.505-2.424-2.425c.163-.046.331-.08.505-.08 1.065 0 2 .935 2 2 0 .174-.033.342-.081.505zm1.502 1.501A3.881 3.881 0 0 0 16 12c0-2.168-1.832-4-4-4-.729 0-1.412.22-2.007.579L7.914 6.5l2.5-2.5h3.172l2.707 2.707A.996.996 0 0 0 17 7l3-.001V18h-.586l-3.993-3.994z"
                }
            }
        ]
    })(props);
}
function BiCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c-2.168 0-4 1.832-4 4s1.832 4 4 4 4-1.832 4-4-1.832-4-4-4zm0 6c-1.065 0-2-.935-2-2s.935-2 2-2 2 .935 2 2-.935 2-2 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-2.586l-2.707-2.707A.996.996 0 0 0 14 2h-4a.996.996 0 0 0-.707.293L6.586 5H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zM4 18V7h3c.266 0 .52-.105.707-.293L10.414 4h3.172l2.707 2.707A.996.996 0 0 0 17 7h3l.002 11H4z"
                }
            }
        ]
    })(props);
}
function BiCandles(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 19h1v3h2v-3h1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H9V2H7v3H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1zM7 7h2v10H7zm7 10h1v3h2v-3h1a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-1V4h-2v3h-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1zm1-8h2v6h-2z"
                }
            }
        ]
    })(props);
}
function BiCapsule(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.999 20.133a4.969 4.969 0 0 0 3.536-1.465l7.134-7.133a5.007 5.007 0 0 0-.001-7.072C18.723 3.52 17.467 3 16.132 3s-2.591.52-3.534 1.464l-7.134 7.134a5.009 5.009 0 0 0 0 7.072 4.97 4.97 0 0 0 3.535 1.463zm5.013-14.255A2.979 2.979 0 0 1 16.132 5c.802 0 1.556.313 2.122.878a3.004 3.004 0 0 1 .001 4.243l-2.893 2.892L11.12 8.77l2.892-2.892zm-7.134 7.134 2.828-2.828 4.242 4.243-2.827 2.827c-1.133 1.133-3.11 1.132-4.243.001a3.005 3.005 0 0 1 0-4.243z"
                }
            }
        ]
    })(props);
}
function BiCaptions(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10v4c0 1.103.897 2 2 2h3v-2H8v-4h3V8H8c-1.103 0-2 .897-2 2zm7 0v4c0 1.103.897 2 2 2h3v-2h-3v-4h3V8h-3c-1.103 0-2 .897-2 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM4 18V6h16l.002 12H4z"
                }
            }
        ]
    })(props);
}
function BiCar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.772 10.156-1.368-4.105A2.995 2.995 0 0 0 16.559 4H7.441a2.995 2.995 0 0 0-2.845 2.051l-1.368 4.105A2.003 2.003 0 0 0 2 12v5c0 .753.423 1.402 1.039 1.743-.013.066-.039.126-.039.195V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2h12v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2.062c0-.069-.026-.13-.039-.195A1.993 1.993 0 0 0 22 17v-5c0-.829-.508-1.541-1.228-1.844zM4 17v-5h16l.002 5H4zM7.441 6h9.117c.431 0 .813.274.949.684L18.613 10H5.387l1.105-3.316A1 1 0 0 1 7.441 6z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function BiCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.999 17c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2h-12c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h12zm-12-12h12l.002 10H5.999V5zm-2 14h16v2h-16z"
                }
            }
        ]
    })(props);
}
function BiCaretDownCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 16 5-6H7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            }
        ]
    })(props);
}
function BiCaretDownSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 16 5-6H7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                }
            }
        ]
    })(props);
}
function BiCaretDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.998 17 7-8h-14z"
                }
            }
        ]
    })(props);
}
function BiCaretLeftCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 17V7l-6 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            }
        ]
    })(props);
}
function BiCaretLeftSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 17V7l-6 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                }
            }
        ]
    })(props);
}
function BiCaretLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 19V5l-8 7z"
                }
            }
        ]
    })(props);
}
function BiCaretRightCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10 17 6-5-6-5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            }
        ]
    })(props);
}
function BiCaretRightSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10 17 6-5-6-5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                }
            }
        ]
    })(props);
}
function BiCaretRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m9 19 8-7-8-7z"
                }
            }
        ]
    })(props);
}
function BiCaretUpCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14h10l-5-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            }
        ]
    })(props);
}
function BiCaretUpSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14h10l-5-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                }
            }
        ]
    })(props);
}
function BiCaretUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15h14l-7-8z"
                }
            }
        ]
    })(props);
}
function BiCarousel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19h2c0 1.103.897 2 2 2h8c1.103 0 2-.897 2-2h2c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2h-2c0-1.103-.897-2-2-2H8c-1.103 0-2 .897-2 2H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2zM20 7v10h-2V7h2zM8 5h8l.001 14H8V5zM4 7h2v10H4V7z"
                }
            }
        ]
    })(props);
}
function BiCartAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 13h2v-2.99h2.99v-2H15V5.03h-2v2.98h-2.99v2H13V13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 17h8a1 1 0 0 0 .93-.64L21.76 9h-2.14l-2.31 6h-6.64L6.18 4.23A2 2 0 0 0 4.33 3H2v2h2.33l4.75 11.38A1 1 0 0 0 10 17z"
                }
            }
        ]
    })(props);
}
function BiCartAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H2v2h2.3l3.28 9a3 3 0 0 0 2.82 2H19v-2h-8.6a1 1 0 0 1-.94-.66L9 13h9.28a2 2 0 0 0 1.92-1.45L22 5.27A1 1 0 0 0 21.27 4 .84.84 0 0 0 21 4zm-2.75 7h-10L6.43 6h13.24z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function BiCartDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 13.99 4-5h-3v-4h-2v4h-3l4 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.31 15h-6.64L6.18 4.23A2 2 0 0 0 4.33 3H2v2h2.33l4.75 11.38A1 1 0 0 0 10 17h8a1 1 0 0 0 .93-.64L21.76 9h-2.14z"
                }
            }
        ]
    })(props);
}
function BiCart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.822 7.431A1 1 0 0 0 21 7H7.333L6.179 4.23A1.994 1.994 0 0 0 4.333 3H2v2h2.333l4.744 11.385A1 1 0 0 0 10 17h8c.417 0 .79-.259.937-.648l3-8a1 1 0 0 0-.115-.921zM17.307 15h-6.64l-2.5-6h11.39l-2.25 6z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function BiCast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 21.001h2C13 14.935 8.065 10 2 10v2c4.962 0 9 4.038 9 9.001z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21.001h2C9 17.141 5.86 14 2 14v2c2.757 0 5 2.243 5 5.001z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "3.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v2.052c.68.025 1.349.094 2 .217V6h16v13h-5.269c.123.651.191 1.32.217 2H20c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2z"
                }
            }
        ]
    })(props);
}
function BiCategoryAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM9 9H5V5h4v4zm11 4h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm-1 6h-4v-4h4v4zM17 3c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zM7 13c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z"
                }
            }
        ]
    })(props);
}
function BiCategory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM9 9H5V5h4v4zm11-6h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-1 6h-4V5h4v4zm-9 4H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm-1 6H5v-4h4v4zm8-6c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z"
                }
            }
        ]
    })(props);
}
function BiCctv(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.916 9.564a.998.998 0 0 0-.513-1.316L7.328 2.492c-.995-.438-2.22.051-2.645 1.042l-2.21 5.154a2.001 2.001 0 0 0 1.052 2.624L9.563 13.9 8.323 17H4v-3H2v8h2v-3h4.323c.823 0 1.552-.494 1.856-1.258l1.222-3.054 5.205 2.23a1 1 0 0 0 1.31-.517l.312-.71 1.701.68 2-5-1.536-.613.523-1.194zm-4.434 5.126L4.313 9.475l2.208-5.152 12.162 5.354-2.201 5.013z"
                }
            }
        ]
    })(props);
}
function BiCertification(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.06 14.68a1 1 0 0 0 .46.6l1.91 1.11v2.2a1 1 0 0 0 1 1h2.2l1.11 1.91a1 1 0 0 0 .86.5 1 1 0 0 0 .51-.14l1.9-1.1 1.91 1.1a1 1 0 0 0 1.37-.36l1.1-1.91h2.2a1 1 0 0 0 1-1v-2.2l1.91-1.11a1 1 0 0 0 .37-1.36L20.76 12l1.11-1.91a1 1 0 0 0-.37-1.36l-1.91-1.1v-2.2a1 1 0 0 0-1-1h-2.2l-1.1-1.91a1 1 0 0 0-.61-.46 1 1 0 0 0-.76.1L12 3.26l-1.9-1.1a1 1 0 0 0-1.36.36L7.63 4.43h-2.2a1 1 0 0 0-1 1v2.2l-1.9 1.1a1 1 0 0 0-.37 1.37l1.1 1.9-1.1 1.91a1 1 0 0 0-.1.77zm3.22-3.17L4.39 10l1.55-.9a1 1 0 0 0 .49-.86V6.43h1.78a1 1 0 0 0 .87-.5L10 4.39l1.54.89a1 1 0 0 0 1 0l1.55-.89.91 1.54a1 1 0 0 0 .87.5h1.77v1.78a1 1 0 0 0 .5.86l1.54.9-.89 1.54a1 1 0 0 0 0 1l.89 1.54-1.54.9a1 1 0 0 0-.5.86v1.78h-1.83a1 1 0 0 0-.86.5l-.89 1.54-1.55-.89a1 1 0 0 0-1 0l-1.51.89-.89-1.54a1 1 0 0 0-.87-.5H6.43v-1.78a1 1 0 0 0-.49-.81l-1.55-.9.89-1.54a1 1 0 0 0 0-1.05z"
                }
            }
        ]
    })(props);
}
function BiChair(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13V4c0-1.103-.897-2-2-2H7c-1.103 0-2 .897-2 2v9a1 1 0 0 0-1 1v8h2v-5h12v5h2v-8a1 1 0 0 0-1-1zm-2-9v9h-2V4h2zm-4 0v9h-2V4h2zM7 4h2v9H7V4z"
                }
            }
        ]
    })(props);
}
function BiChalkboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h4l-1.8 2.4 1.6 1.2 2.7-3.6h3l2.7 3.6 1.6-1.2L16 18h4c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 16V5h16l.001 11H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12h4v2H6z"
                }
            }
        ]
    })(props);
}
function BiChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM5 5h14l.001 14H5V5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13.553 11.658-4-2-2.448 4.895 1.79.894 1.552-3.105 4 2 2.448-4.895-1.79-.894z"
                }
            }
        ]
    })(props);
}
function BiChat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18v3.766l1.515-.909L11.277 18H16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h1zM4 8h12v8h-5.277L7 18.234V16H4V8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.103 0-2 .897-2 2h12c1.103 0 2 .897 2 2v8c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2z"
                }
            }
        ]
    })(props);
}
function BiCheckCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.999 13.587 7.7 11.292l-1.412 1.416 3.713 3.705 6.706-6.706-1.414-1.414z"
                }
            }
        ]
    })(props);
}
function BiCheckDouble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.394 13.742 4.743 3.62 7.616-8.704-1.506-1.316-6.384 7.296-3.257-2.486zm19.359-5.084-1.506-1.316-6.369 7.279-.753-.602-1.25 1.562 2.247 1.798z"
                }
            }
        ]
    })(props);
}
function BiCheckShield(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.995 6.9a.998.998 0 0 0-.548-.795l-8-4a1 1 0 0 0-.895 0l-8 4a1.002 1.002 0 0 0-.547.795c-.011.107-.961 10.767 8.589 15.014a.987.987 0 0 0 .812 0c9.55-4.247 8.6-14.906 8.589-15.014zM12 19.897C5.231 16.625 4.911 9.642 4.966 7.635L12 4.118l7.029 3.515c.037 1.989-.328 9.018-7.029 12.264z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11 12.586-2.293-2.293-1.414 1.414L11 15.414l5.707-5.707-1.414-1.414z"
                }
            }
        ]
    })(props);
}
function BiCheckSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10.933 13.519-2.226-2.226-1.414 1.414 3.774 3.774 5.702-6.84-1.538-1.282z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                }
            }
        ]
    })(props);
}
function BiCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"
                }
            }
        ]
    })(props);
}
function BiCheckboxChecked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2H7zm0 12V7h10l.002 10H7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.996 12.556 9.7 11.285l-1.4 1.43 2.704 2.647 4.699-4.651-1.406-1.422z"
                }
            }
        ]
    })(props);
}
function BiCheckboxMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.01 11h6v2h-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zM7 17V7h10v10z"
                }
            }
        ]
    })(props);
}
function BiCheckboxSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9h6v6H9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 17V7c0-1.103-.897-2-2-2H7c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2zM7 7h10l.002 10H7V7z"
                }
            }
        ]
    })(props);
}
function BiCheckbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2H7zm0 12V7h10l.002 10H7z"
                }
            }
        ]
    })(props);
}
function BiCheese(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.16 2a1 1 0 0 0-.66.13l-12 7a.64.64 0 0 0-.13.1l-.1.08a1.17 1.17 0 0 0-.17.26.84.84 0 0 0-.1.43v10a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V10a8.08 8.08 0 0 0-6.84-8zm0 2.05A6.07 6.07 0 0 1 19.93 9H6.7zM20 19H4v-8h16z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "16.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.5",
                    "cy": "13.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "16",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function BiChevronDownCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13.586 7.707 9.293l-1.414 1.414L12 16.414l5.707-5.707-1.414-1.414z"
                }
            }
        ]
    })(props);
}
function BiChevronDownSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM5 5h14l.001 14H5V5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13.586 7.707 9.293l-1.414 1.414L12 16.414l5.707-5.707-1.414-1.414z"
                }
            }
        ]
    })(props);
}
function BiChevronDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.293 9.293 12 13.586 7.707 9.293l-1.414 1.414L12 16.414l5.707-5.707z"
                }
            }
        ]
    })(props);
}
function BiChevronLeftCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"
                }
            }
        ]
    })(props);
}
function BiChevronLeftSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM5 5h14l.001 14H5V5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"
                }
            }
        ]
    })(props);
}
function BiChevronLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"
                }
            }
        ]
    })(props);
}
function BiChevronRightCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 7.707 13.586 12l-4.293 4.293 1.414 1.414L16.414 12l-5.707-5.707z"
                }
            }
        ]
    })(props);
}
function BiChevronRightSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM5 5h14l.001 14H5V5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 7.707 13.586 12l-4.293 4.293 1.414 1.414L16.414 12l-5.707-5.707z"
                }
            }
        ]
    })(props);
}
function BiChevronRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"
                }
            }
        ]
    })(props);
}
function BiChevronUpCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6.293 13.293 1.414 1.414L12 10.414l4.293 4.293 1.414-1.414L12 7.586z"
                }
            }
        ]
    })(props);
}
function BiChevronUpSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM5 5h14l.001 14H5V5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6.293 13.293 1.414 1.414L12 10.414l4.293 4.293 1.414-1.414L12 7.586z"
                }
            }
        ]
    })(props);
}
function BiChevronUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m6.293 13.293 1.414 1.414L12 10.414l4.293 4.293 1.414-1.414L12 7.586z"
                }
            }
        ]
    })(props);
}
function BiChevronsDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 15.586-4.293-4.293-1.414 1.414L12 18.414l5.707-5.707-1.414-1.414z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17.707 7.707-1.414-1.414L12 10.586 7.707 6.293 6.293 7.707 12 13.414z"
                }
            }
        ]
    })(props);
}
function BiChevronsLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12.707 7.707-1.414-1.414L5.586 12l5.707 5.707 1.414-1.414L8.414 12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.293 6.293 10.586 12l5.707 5.707 1.414-1.414L13.414 12l4.293-4.293z"
                }
            }
        ]
    })(props);
}
function BiChevronsRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.296 7.71 14.621 12l-4.325 4.29 1.408 1.42L17.461 12l-5.757-5.71z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.704 6.29 5.296 7.71 9.621 12l-4.325 4.29 1.408 1.42L12.461 12z"
                }
            }
        ]
    })(props);
}
function BiChevronsUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m6.293 11.293 1.414 1.414L12 8.414l4.293 4.293 1.414-1.414L12 5.586z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6.293 16.293 1.414 1.414L12 13.414l4.293 4.293 1.414-1.414L12 10.586z"
                }
            }
        ]
    })(props);
}
function BiChild(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "6",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9h-4a1 1 0 0 0-.8.4l-3 4 1.6 1.2L9 13v7h2v-4h2v4h2v-7l1.2 1.6 1.6-1.2-3-4A1 1 0 0 0 14 9z"
                }
            }
        ]
    })(props);
}
function BiChip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9h6v6H9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6c0-1.103-.897-2-2-2h-2V2h-2v2h-4V2H8v2H6c-1.103 0-2 .897-2 2v2H2v2h2v4H2v2h2v2c0 1.103.897 2 2 2h2v2h2v-2h4v2h2v-2h2c1.103 0 2-.897 2-2v-2h2v-2h-2v-4h2V8h-2V6zM6 18V6h12l.002 12H6z"
                }
            }
        ]
    })(props);
}
function BiChurch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.447 14.105 18 12.382V12a1 1 0 0 0-.485-.857L13 8.434V6h2V4h-2V2h-2v2H9v2h2v2.434l-4.515 2.709A1 1 0 0 0 6 12v.382l-3.447 1.724A.998.998 0 0 0 2 15v6a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-6c0-.379-.214-.725-.553-.895zM4 15.618l2-1V20H4v-4.382zM12 15a2 2 0 0 0-2 2v3H8v-7.434l4-2.4 4 2.4V20h-2v-3a2 2 0 0 0-2-2zm8 5h-2v-5.382l2 1V20z"
                }
            }
        ]
    })(props);
}
function BiCircleHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2h-1v20h1a10 10 0 0 0 0-20zm1 17.94V4.06a8 8 0 0 1 0 15.88z"
                }
            }
        ]
    })(props);
}
function BiCircleQuarter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2h-1v11h11v-1A10 10 0 0 0 12 2zm1 9V4.06A8 8 0 0 1 19.94 11z"
                }
            }
        ]
    })(props);
}
function BiCircleThreeQuarter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2h-1v9H2v1a10 10 0 0 0 17.07 7.07A10 10 0 0 0 12 2zm5.66 15.66A8 8 0 0 1 4.06 13H13V4.06a8 8 0 0 1 4.66 13.6z"
                }
            }
        ]
    })(props);
}
function BiCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12c.001 5.515 4.487 10.001 10 10.001 5.514 0 10-4.486 10.001-10.001 0-5.514-4.486-10-10.001-10zm0 18.001c-4.41 0-7.999-3.589-8-8.001 0-4.411 3.589-8 8-8 4.412 0 8.001 3.589 8.001 8-.001 4.412-3.59 8.001-8.001 8.001z"
                }
            }
        ]
    })(props);
}
function BiClinic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.707 2.293a.999.999 0 0 0-1.414 0l-9 9A1 1 0 0 0 3 13h1v7c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-7h1a.999.999 0 0 0 .707-1.707l-9-9zM18.001 20H6v-9.586l6-6 6 6V15l.001 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10h-2v3H8v2h3v3h2v-3h3v-2h-3z"
                }
            }
        ]
    })(props);
}
function BiClipboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-2.25a1 1 0 0 0-1-1h-7.5a1 1 0 0 0-1 1H5c-1.103 0-2 .897-2 2v15c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm0 17H5V5h2v2h10V5h2v15z"
                }
            }
        ]
    })(props);
}
function BiCloset(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10.551v-.678A4.005 4.005 0 0 0 16 6c0-2.206-1.794-4-4-4S8 3.794 8 6h2c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2a1 1 0 0 0-1 1v1.551l-8.665 7.702A1.001 1.001 0 0 0 3 20h18a1.001 1.001 0 0 0 .664-1.748L13 10.551zM5.63 18 12 12.338 18.37 18H5.63z"
                }
            }
        ]
    })(props);
}
function BiCloudDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.948 11.112C18.511 7.67 15.563 5 12.004 5c-2.756 0-5.15 1.611-6.243 4.15-2.148.642-3.757 2.67-3.757 4.85 0 2.757 2.243 5 5 5h1v-2h-1c-1.654 0-3-1.346-3-3 0-1.404 1.199-2.757 2.673-3.016l.581-.102.192-.558C8.153 8.273 9.898 7 12.004 7c2.757 0 5 2.243 5 5v1h1c1.103 0 2 .897 2 2s-.897 2-2 2h-2v2h2c2.206 0 4-1.794 4-4a4.008 4.008 0 0 0-3.056-3.888z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.004 14v-4h-2v4h-3l4 5 4-5z"
                }
            }
        ]
    })(props);
}
function BiCloudDrizzle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13h2v3H8zm0 4h2v3H8zm3-2h2v3h-2zm0 4h2v3h-2zm3-6h2v3h-2zm0 4h2v3h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 10.112C18.507 6.67 15.56 4 12 4 9.245 4 6.85 5.611 5.757 8.15 3.609 8.792 2 10.819 2 13c0 2.757 2.243 5 5 5v-2c-1.654 0-3-1.346-3-3 0-1.403 1.199-2.756 2.673-3.015l.582-.103.191-.559C8.149 7.273 9.895 6 12 6c2.757 0 5 2.243 5 5v1h1c1.103 0 2 .897 2 2s-.897 2-2 2h-1v2h1c2.206 0 4-1.794 4-4a4.008 4.008 0 0 0-3.056-3.888z"
                }
            }
        ]
    })(props);
}
function BiCloudLightRain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13h2v4H8zm0 5h2v2H8zm3-3h2v4h-2zm0 5h2v2h-2zm3-7h2v4h-2zm0 5h2v2h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 10.112C18.507 6.67 15.56 4 12 4 9.244 4 6.85 5.611 5.757 8.15 3.609 8.792 2 10.819 2 13c0 2.757 2.243 5 5 5v-2c-1.654 0-3-1.346-3-3 0-1.403 1.199-2.756 2.673-3.015l.581-.103.192-.559C8.149 7.273 9.895 6 12 6c2.757 0 5 2.243 5 5v1h1c1.103 0 2 .897 2 2s-.897 2-2 2h-1v2h1c2.206 0 4-1.794 4-4a4.008 4.008 0 0 0-3.056-3.888z"
                }
            }
        ]
    })(props);
}
function BiCloudLightning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10 13-1 5h2v4l3.975-6H13l1-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 10.112C18.507 6.67 15.56 4 12 4 9.244 4 6.85 5.611 5.757 8.15 3.609 8.792 2 10.819 2 13c0 2.757 2.243 5 5 5v-2c-1.654 0-3-1.346-3-3 0-1.403 1.199-2.756 2.673-3.015l.581-.103.192-.559C8.149 7.273 9.895 6 12 6c2.757 0 5 2.243 5 5v1h1c1.103 0 2 .897 2 2s-.897 2-2 2h-1v2h1c2.206 0 4-1.794 4-4a4.008 4.008 0 0 0-3.056-3.888z"
                }
            }
        ]
    })(props);
}
function BiCloudRain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13h2v7H8zm3 2h2v7h-2zm3-2h2v7h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 10.113C18.507 6.671 15.56 4.001 12 4.001c-2.756 0-5.15 1.611-6.243 4.15C3.609 8.793 2 10.82 2 13.001c0 2.757 2.243 5 5 5v-2c-1.654 0-3-1.346-3-3 0-1.403 1.199-2.756 2.673-3.015l.581-.103.192-.559C8.149 7.274 9.895 6.001 12 6.001c2.757 0 5 2.243 5 5v1h1c1.103 0 2 .897 2 2s-.897 2-2 2h-1v2h1c2.206 0 4-1.794 4-4a4.008 4.008 0 0 0-3.056-3.888z"
                }
            }
        ]
    })(props);
}
function BiCloudSnow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 10.112C18.507 6.67 15.56 4 12 4 9.244 4 6.85 5.611 5.757 8.15 3.609 8.792 2 10.819 2 13c0 2.757 2.243 5 5 5v-2c-1.654 0-3-1.346-3-3 0-1.403 1.199-2.756 2.673-3.015l.581-.103.192-.559C8.149 7.273 9.895 6 12 6c2.757 0 5 2.243 5 5v1h1c1.103 0 2 .897 2 2s-.897 2-2 2h-1v2h1c2.206 0 4-1.794 4-4a4.008 4.008 0 0 0-3.056-3.888z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "16",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "19",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "18",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "21",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "19",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "16",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function BiCloudUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 19v-4h3l-4-5-4 5h3v4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 19h2v-2H7c-1.654 0-3-1.346-3-3 0-1.404 1.199-2.756 2.673-3.015l.581-.102.192-.558C8.149 8.274 9.895 7 12 7c2.757 0 5 2.243 5 5v1h1c1.103 0 2 .897 2 2s-.897 2-2 2h-3v2h3c2.206 0 4-1.794 4-4a4.01 4.01 0 0 0-3.056-3.888C18.507 7.67 15.56 5 12 5 9.244 5 6.85 6.611 5.757 9.15 3.609 9.792 2 11.82 2 14c0 2.757 2.243 5 5 5z"
                }
            }
        ]
    })(props);
}
function BiCloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 11.112C18.507 7.67 15.56 5 12 5 9.244 5 6.85 6.611 5.757 9.15 3.609 9.792 2 11.82 2 14c0 2.757 2.243 5 5 5h11c2.206 0 4-1.794 4-4a4.01 4.01 0 0 0-3.056-3.888zM18 17H7c-1.654 0-3-1.346-3-3 0-1.404 1.199-2.756 2.673-3.015l.581-.102.192-.558C8.149 8.274 9.895 7 12 7c2.757 0 5 2.243 5 5v1h1c1.103 0 2 .897 2 2s-.897 2-2 2z"
                }
            }
        ]
    })(props);
}
function BiCodeAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7.375 16.781 1.25-1.562L4.601 12l4.024-3.219-1.25-1.562-5 4a1 1 0 0 0 0 1.562l5 4zm9.25-9.562-1.25 1.562L19.399 12l-4.024 3.219 1.25 1.562 5-4a1 1 0 0 0 0-1.562l-5-4zm-1.649-4.003-4 18-1.953-.434 4-18z"
                }
            }
        ]
    })(props);
}
function BiCodeBlock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 19V7h16l.002 12H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.293 9.293 5.586 13l3.707 3.707 1.414-1.414L8.414 13l2.293-2.293zm5.414 0-1.414 1.414L15.586 13l-2.293 2.293 1.414 1.414L18.414 13z"
                }
            }
        ]
    })(props);
}
function BiCodeCurly(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 22h1v-2h-.989C8.703 19.994 6 19.827 6 16c0-1.993-.665-3.246-1.502-4C5.335 11.246 6 9.993 6 8c0-3.827 2.703-3.994 3-4h1V2H8.998C7.269 2.004 4 3.264 4 8c0 2.8-1.678 2.99-2.014 3L2 13c.082 0 2 .034 2 3 0 4.736 3.269 5.996 5 6zm13-11c-.082 0-2-.034-2-3 0-4.736-3.269-5.996-5-6h-1v2h.989c.308.006 3.011.173 3.011 4 0 1.993.665 3.246 1.502 4-.837.754-1.502 2.007-1.502 4 0 3.827-2.703 3.994-3 4h-1v2h1.002C16.731 21.996 20 20.736 20 16c0-2.8 1.678-2.99 2.014-3L22 11z"
                }
            }
        ]
    })(props);
}
function BiCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.293 6.293 2.586 12l5.707 5.707 1.414-1.414L5.414 12l4.293-4.293zm7.414 11.414L21.414 12l-5.707-5.707-1.414 1.414L18.586 12l-4.293 4.293z"
                }
            }
        ]
    })(props);
}
function BiCoffeeTogo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 22h10a1 1 0 0 0 .99-.858L19.867 8H21V6h-1.382l-1.724-3.447A.998.998 0 0 0 17 2H7c-.379 0-.725.214-.895.553L4.382 6H3v2h1.133L6.01 21.142A1 1 0 0 0 7 22zm10.418-11H6.582l-.429-3h11.693l-.428 3zm-9.551 9-.429-3h9.123l-.429 3H7.867zM7.618 4h8.764l1 2H6.618l1-2z"
                }
            }
        ]
    })(props);
}
function BiCoffee(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2h2v3H5zm4 0h2v3H9zm4 0h2v3h-2zm6 7h-2V7H3v11c0 1.654 1.346 3 3 3h8c1.654 0 3-1.346 3-3h2c1.103 0 2-.897 2-2v-5c0-1.103-.897-2-2-2zm-4 9a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V9h10v9zm2-2v-5h2l.002 5H17z"
                }
            }
        ]
    })(props);
}
function BiCog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.084 0 2 .916 2 2s-.916 2-2 2-2-.916-2-2 .916-2 2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m2.845 16.136 1 1.73c.531.917 1.809 1.261 2.73.73l.529-.306A8.1 8.1 0 0 0 9 19.402V20c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2v-.598a8.132 8.132 0 0 0 1.896-1.111l.529.306c.923.53 2.198.188 2.731-.731l.999-1.729a2.001 2.001 0 0 0-.731-2.732l-.505-.292a7.718 7.718 0 0 0 0-2.224l.505-.292a2.002 2.002 0 0 0 .731-2.732l-.999-1.729c-.531-.92-1.808-1.265-2.731-.732l-.529.306A8.1 8.1 0 0 0 15 4.598V4c0-1.103-.897-2-2-2h-2c-1.103 0-2 .897-2 2v.598a8.132 8.132 0 0 0-1.896 1.111l-.529-.306c-.924-.531-2.2-.187-2.731.732l-.999 1.729a2.001 2.001 0 0 0 .731 2.732l.505.292a7.683 7.683 0 0 0 0 2.223l-.505.292a2.003 2.003 0 0 0-.731 2.733zm3.326-2.758A5.703 5.703 0 0 1 6 12c0-.462.058-.926.17-1.378a.999.999 0 0 0-.47-1.108l-1.123-.65.998-1.729 1.145.662a.997.997 0 0 0 1.188-.142 6.071 6.071 0 0 1 2.384-1.399A1 1 0 0 0 11 5.3V4h2v1.3a1 1 0 0 0 .708.956 6.083 6.083 0 0 1 2.384 1.399.999.999 0 0 0 1.188.142l1.144-.661 1 1.729-1.124.649a1 1 0 0 0-.47 1.108c.112.452.17.916.17 1.378 0 .461-.058.925-.171 1.378a1 1 0 0 0 .471 1.108l1.123.649-.998 1.729-1.145-.661a.996.996 0 0 0-1.188.142 6.071 6.071 0 0 1-2.384 1.399A1 1 0 0 0 13 18.7l.002 1.3H11v-1.3a1 1 0 0 0-.708-.956 6.083 6.083 0 0 1-2.384-1.399.992.992 0 0 0-1.188-.141l-1.144.662-1-1.729 1.124-.651a1 1 0 0 0 .471-1.108z"
                }
            }
        ]
    })(props);
}
function BiCoinStack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c3.976 0 8-1.374 8-4V6c0-2.626-4.024-4-8-4S4 3.374 4 6v12c0 2.626 4.024 4 8 4zm0-2c-3.722 0-6-1.295-6-2v-1.268C7.541 17.57 9.777 18 12 18s4.459-.43 6-1.268V18c0 .705-2.278 2-6 2zm0-16c3.722 0 6 1.295 6 2s-2.278 2-6 2-6-1.295-6-2 2.278-2 6-2zM6 8.732C7.541 9.57 9.777 10 12 10s4.459-.43 6-1.268V10c0 .705-2.278 2-6 2s-6-1.295-6-2V8.732zm0 4C7.541 13.57 9.777 14 12 14s4.459-.43 6-1.268V14c0 .705-2.278 2-6 2s-6-1.295-6-2v-1.268z"
                }
            }
        ]
    })(props);
}
function BiCoin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6C7.03 6 2 7.546 2 10.5v4C2 17.454 7.03 19 12 19s10-1.546 10-4.5v-4C22 7.546 16.97 6 12 6zm-8 8.5v-1.197a9.989 9.989 0 0 0 2 .86v1.881c-1.312-.514-2-1.126-2-1.544zm12 .148v1.971c-.867.179-1.867.31-3 .358v-2a21.75 21.75 0 0 0 3-.329zm-5 2.33a18.788 18.788 0 0 1-3-.358v-1.971c.959.174 1.972.287 3 .33v1.999zm7-.934v-1.881a9.931 9.931 0 0 0 2-.86V14.5c0 .418-.687 1.03-2 1.544zM12 13c-5.177 0-8-1.651-8-2.5S6.823 8 12 8s8 1.651 8 2.5-2.823 2.5-8 2.5z"
                }
            }
        ]
    })(props);
}
function BiCollapseAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 15h7v7h2v-9H2v2zM15 2h-2v9h9V9h-7V2z"
                }
            }
        ]
    })(props);
}
function BiCollapseHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.95 5.64 13.59 12l6.36 6.36 1.41-1.41L16.41 12l4.95-4.95-1.41-1.41zM2.64 7.05 7.59 12l-4.95 4.95 1.41 1.41L10.41 12 4.05 5.64 2.64 7.05z"
                }
            }
        ]
    })(props);
}
function BiCollapseVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.59 7.05 2.64 5.64 4.05 12 10.41l6.36-6.36-1.41-1.41L12 7.59zM5.64 19.95l1.41 1.41L12 16.41l4.95 4.95 1.41-1.41L12 13.59l-6.36 6.36z"
                }
            }
        ]
    })(props);
}
function BiCollapse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.121 6.465 14 4.344V10h5.656l-2.121-2.121 3.172-3.172-1.414-1.414zM4.707 3.293 3.293 4.707l3.172 3.172L4.344 10H10V4.344L7.879 6.465zM19.656 14H14v5.656l2.121-2.121 3.172 3.172 1.414-1.414-3.172-3.172zM6.465 16.121l-3.172 3.172 1.414 1.414 3.172-3.172L10 19.656V14H4.344z"
                }
            }
        ]
    })(props);
}
function BiCollection(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10H5c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-8c0-1.103-.897-2-2-2zM5 20v-8h14l.002 8H5zM5 6h14v2H5zm2-4h10v2H7z"
                }
            }
        ]
    })(props);
}
function BiColorFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13.998c-.092.065-2 2.083-2 3.5 0 1.494.949 2.448 2 2.5.906.044 2-.891 2-2.5 0-1.5-1.908-3.435-2-3.5zm-16.586-1c0 .534.208 1.036.586 1.414l5.586 5.586c.378.378.88.586 1.414.586s1.036-.208 1.414-.586l7-7-.707-.707L11 4.584 8.707 2.291 7.293 3.705l2.293 2.293L4 11.584c-.378.378-.586.88-.586 1.414zM11 7.412l5.586 5.586L11 18.584h.001l-.001 1v-1l-5.586-5.586L11 7.412z"
                }
            }
        ]
    })(props);
}
function BiColor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 13a3 3 0 1 1 3-3 3 3 0 0 1-3 3zm2.75-7.17A5 5 0 0 0 13 7.1v-3a7.94 7.94 0 0 1 3.9 1.62zM11 7.1a5 5 0 0 0-1.75.73L7.1 5.69A7.94 7.94 0 0 1 11 4.07zM7.83 9.25A5 5 0 0 0 7.1 11h-3a7.94 7.94 0 0 1 1.59-3.9zM7.1 13a5 5 0 0 0 .73 1.75L5.69 16.9A7.94 7.94 0 0 1 4.07 13zm2.15 3.17a5 5 0 0 0 1.75.73v3a7.94 7.94 0 0 1-3.9-1.62zm3.75.73a5 5 0 0 0 1.75-.73l2.15 2.14a7.94 7.94 0 0 1-3.9 1.62zm3.17-2.15A5 5 0 0 0 16.9 13h3a7.94 7.94 0 0 1-1.62 3.9zM16.9 11a5 5 0 0 0-.73-1.75l2.14-2.15a7.94 7.94 0 0 1 1.62 3.9z"
                }
            }
        ]
    })(props);
}
function BiColumns(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.893 3.001H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h15.893c1.103 0 2-.897 2-2V5a2.003 2.003 0 0 0-2-1.999zM8 19.001H4V8h4v11.001zm6 0h-4V8h4v11.001zm2 0V8h3.893l.001 11.001H16z"
                }
            }
        ]
    })(props);
}
function BiCommand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 14c-2.206 0-4 1.794-4 4s1.794 4 4 4a4.003 4.003 0 0 0 3.998-3.98H10V16h4v2.039h.004A4.002 4.002 0 0 0 18 22c2.206 0 4-1.794 4-4s-1.794-4-4-4h-2v-4h2c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4v2h-4V5.98h-.002A4.003 4.003 0 0 0 6 2C3.794 2 2 3.794 2 6s1.794 4 4 4h2v4H6zm2 4c0 1.122-.879 2-2 2s-2-.878-2-2 .879-2 2-2h2v2zm10-2c1.121 0 2 .878 2 2s-.879 2-2 2-2-.878-2-2v-2h2zM16 6c0-1.122.879-2 2-2s2 .878 2 2-.879 2-2 2h-2V6zM6 8c-1.121 0-2-.878-2-2s.879-2 2-2 2 .878 2 2v2H6zm4 2h4v4h-4v-4z"
                }
            }
        ]
    })(props);
}
function BiCommentAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14h2v-3h3V9h-3V6h-2v3H8v2h3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z"
                }
            }
        ]
    })(props);
}
function BiCommentCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m17.207 8.207-1.414-1.414L11 11.586 8.707 9.293l-1.414 1.414L11 14.414z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z"
                }
            }
        ]
    })(props);
}
function BiCommentDetail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h10v2H7zm0 4h7v2H7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z"
                }
            }
        ]
    })(props);
}
function BiCommentDots(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "10",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "10",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function BiCommentEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m13.771 9.123-1.399-1.398-3.869 3.864v1.398h1.398zM14.098 6l1.398 1.398-1.067 1.067-1.398-1.398z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z"
                }
            }
        ]
    })(props);
}
function BiCommentError(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6h2v5h-2zm0 6h2v2h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z"
                }
            }
        ]
    })(props);
}
function BiCommentMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9h8v2H8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z"
                }
            }
        ]
    })(props);
}
function BiCommentX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.707 13.707 12 11.414l2.293 2.293 1.414-1.414L13.414 10l2.293-2.293-1.414-1.414L12 8.586 9.707 6.293 8.293 7.707 10.586 10l-2.293 2.293z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z"
                }
            }
        ]
    })(props);
}
function BiComment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z"
                }
            }
        ]
    })(props);
}
function BiCompass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 16 5.991-2L16 8l-6 2z"
                }
            }
        ]
    })(props);
}
function BiConfused(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "10.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.493",
                    "cy": "10.493",
                    "r": "1.493"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8.124 16.992-.248-1.984 8-1 .248 1.984z"
                }
            }
        ]
    })(props);
}
function BiConversation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14h.5c.827 0 1.5-.673 1.5-1.5v-9c0-.827-.673-1.5-1.5-1.5h-13C2.673 2 2 2.673 2 3.5V18l5.333-4H16zm-9.333-2L4 14V4h12v8H6.667z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 8H20v6.001c0 1.1-.893 1.993-1.99 1.999H8v.5c0 .827.673 1.5 1.5 1.5h7.167L22 22V9.5c0-.827-.673-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function BiCookie(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.598 11.064a1.006 1.006 0 0 0-.854-.172A2.938 2.938 0 0 1 20 11c-1.654 0-3-1.346-3.003-2.937.005-.034.016-.136.017-.17a.998.998 0 0 0-1.254-1.006A2.963 2.963 0 0 1 15 7c-1.654 0-3-1.346-3-3 0-.217.031-.444.099-.716a1 1 0 0 0-1.067-1.236A9.956 9.956 0 0 0 2 12c0 5.514 4.486 10 10 10s10-4.486 10-10c0-.049-.003-.097-.007-.16a1.004 1.004 0 0 0-.395-.776zM12 20c-4.411 0-8-3.589-8-8a7.962 7.962 0 0 1 6.006-7.75A5.006 5.006 0 0 0 15 9l.101-.001a5.007 5.007 0 0 0 4.837 4C19.444 16.941 16.073 20 12 20z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12.5",
                    "cy": "11.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "8.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "12.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "15.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "16.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function BiCool(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.683 14.828a4.055 4.055 0 0 1-1.272.858 4.002 4.002 0 0 1-4.875-1.45l-1.658 1.119a6.063 6.063 0 0 0 1.621 1.62 5.963 5.963 0 0 0 2.148.903 6.035 6.035 0 0 0 3.542-.35 6.048 6.048 0 0 0 1.907-1.284c.272-.271.52-.571.734-.889l-1.658-1.119a4.147 4.147 0 0 1-.489.592z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 2c2.953 0 5.531 1.613 6.918 4H5.082C6.469 5.613 9.047 4 12 4zm0 16c-4.411 0-8-3.589-8-8 0-.691.098-1.359.264-2H5v1a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2h2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-1h.736c.166.641.264 1.309.264 2 0 4.411-3.589 8-8 8z"
                }
            }
        ]
    })(props);
}
function BiCopyAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H10c-1.103 0-2 .897-2 2v4H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2v-4h4c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM4 20V10h10l.002 10H4zm16-6h-4v-4c0-1.103-.897-2-2-2h-4V4h10v10z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12h6v2H6zm0 4h6v2H6z"
                }
            }
        ]
    })(props);
}
function BiCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H10c-1.103 0-2 .897-2 2v4H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2v-4h4c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM4 20V10h10l.002 10H4zm16-6h-4v-4c0-1.103-.897-2-2-2h-4V4h10v10z"
                }
            }
        ]
    })(props);
}
function BiCopyright(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.421 0 10-4.579 10-10S17.421 2 12 2 2 6.579 2 12s4.579 10 10 10zm0-18c4.337 0 8 3.663 8 8s-3.663 8-8 8-8-3.663-8-8 3.663-8 8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17c.901 0 2.581-.168 3.707-1.292l-1.414-1.416C13.85 14.735 12.992 15 12 15c-1.626 0-3-1.374-3-3s1.374-3 3-3c.993 0 1.851.265 2.293.707l1.414-1.414C14.582 7.168 12.901 7 12 7c-2.757 0-5 2.243-5 5s2.243 5 5 5z"
                }
            }
        ]
    })(props);
}
function BiCreditCardAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "13.5",
                    "r": "2.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13.5c0-.815.396-1.532 1-1.988A2.47 2.47 0 0 0 11.5 11a2.5 2.5 0 1 0 0 5 2.47 2.47 0 0 0 1.5-.512 2.486 2.486 0 0 1-1-1.988z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM4 18V6h16l.002 12H4z"
                }
            }
        ]
    })(props);
}
function BiCreditCardFront(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM4 18V6h16l.001 12H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 11h3a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5zM6 14h6v2.001H6zm7 0h5v2.001h-5z"
                }
            }
        ]
    })(props);
}
function BiCreditCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM4 6h16v2H4V6zm0 12v-6h16.001l.001 6H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 14h6v2H6z"
                }
            }
        ]
    })(props);
}
function BiCricketBall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.07 4.93A10 10 0 0 0 4.93 19.07 10 10 0 0 0 19.07 4.93zM6.34 6.34a8 8 0 0 1 8.78-1.71l-.29.3.71.71.52-.53a9.53 9.53 0 0 1 .84.57L5.68 16.9a9.53 9.53 0 0 1-.57-.84l.53-.52-.71-.71-.29.29a8 8 0 0 1 1.7-8.78zm11.32 11.32a8 8 0 0 1-8.78 1.71l.29-.3-.71-.71-.52.53a9.53 9.53 0 0 1-.84-.57L18.32 7.1a9.53 9.53 0 0 1 .57.84l-.53.52.71.71.29-.29a8 8 0 0 1-1.7 8.78zm-6.37-2.12.71.7-1.41 1.42-.71-.66zm2.83-2.83.71.7-1.42 1.42-.7-.71zM17 9.88l.71.71L16.24 12l-.7-.71zm-4.29-1.42-.71-.7 1.41-1.42.71.71zm-2.83 2.83-.71-.7 1.42-1.42.7.71zm-2.83 2.83-.71-.71L7.76 12l.7.71z"
                }
            }
        ]
    })(props);
}
function BiCrop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7c0-1.103-.897-2-2-2H7V2H5v3H2v2h15v15h2v-3h3v-2h-3V7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 9v8c0 1.103.897 2 2 2h8v-2H7V9H5z"
                }
            }
        ]
    })(props);
}
function BiCross(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2h2v7h-2zm0 13h2v7h-2zm4-4h7v2h-7zM2 11h7v2H2z"
                }
            }
        ]
    })(props);
}
function BiCrosshair(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm1 17.931V17h-2v2.931A8.008 8.008 0 0 1 4.069 13H7v-2H4.069A8.008 8.008 0 0 1 11 4.069V7h2V4.069A8.007 8.007 0 0 1 19.931 11H17v2h2.931A8.008 8.008 0 0 1 13 19.931z"
                }
            }
        ]
    })(props);
}
function BiCrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.219 3.375 8 7.399 4.781 3.375A1.002 1.002 0 0 0 3 4v15c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V4a1.002 1.002 0 0 0-1.781-.625L16 7.399l-3.219-4.024c-.381-.474-1.181-.474-1.562 0zM5 19v-2h14.001v2H5zm10.219-9.375c.381.475 1.182.475 1.563 0L19 6.851 19.001 15H5V6.851l2.219 2.774c.381.475 1.182.475 1.563 0L12 5.601l3.219 4.024z"
                }
            }
        ]
    })(props);
}
function BiCubeAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.895 3.553A1.001 1.001 0 0 0 17 3H7c-.379 0-.725.214-.895.553l-4 8a1 1 0 0 0 0 .895l4 8c.17.338.516.552.895.552h10c.379 0 .725-.214.895-.553l4-8a1 1 0 0 0 0-.895l-4-7.999zM19.382 11h-7.764l-3-6h7.764l3 6zM4.118 12 7 6.236 9.882 12 7 17.764 4.118 12zm12.264 7H8.618l3-6h7.764l-3 6z"
                }
            }
        ]
    })(props);
}
function BiCube(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.406 6.086-9-4a1.001 1.001 0 0 0-.813 0l-9 4c-.02.009-.034.024-.054.035-.028.014-.058.023-.084.04-.022.015-.039.034-.06.05a.87.87 0 0 0-.19.194c-.02.028-.041.053-.059.081a1.119 1.119 0 0 0-.076.165c-.009.027-.023.052-.031.079A1.013 1.013 0 0 0 2 7v10c0 .396.232.753.594.914l9 4c.13.058.268.086.406.086a.997.997 0 0 0 .402-.096l.004.01 9-4A.999.999 0 0 0 22 17V7a.999.999 0 0 0-.594-.914zM12 4.095 18.538 7 12 9.905l-1.308-.581L5.463 7 12 4.095zM4 16.351V8.539l7 3.111v7.811l-7-3.11zm9 3.11V11.65l7-3.111v7.812l-7 3.11z"
                }
            }
        ]
    })(props);
}
function BiCuboid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.707 2.293A.996.996 0 0 0 16 2H8c-.414 0-.785.255-.934.641l-5 13a.999.999 0 0 0 .227 1.066l5 5A.996.996 0 0 0 8 22h8c.414 0 .785-.255.934-.641l5-13a.999.999 0 0 0-.227-1.066l-5-5zM18.585 7h-5.171l-3-3h5.172l2.999 3zM8.381 4.795l3.438 3.438-4.462 10.71-3.19-3.191L8.381 4.795zM15.313 20h-6.23l4.583-11h5.878l-4.231 11z"
                }
            }
        ]
    })(props);
}
function BiCurrentLocation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 4.069V2h-2v2.069A8.01 8.01 0 0 0 4.069 11H2v2h2.069A8.008 8.008 0 0 0 11 19.931V22h2v-2.069A8.007 8.007 0 0 0 19.931 13H22v-2h-2.069A8.008 8.008 0 0 0 13 4.069zM12 18c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6z"
                }
            }
        ]
    })(props);
}
function BiCustomize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm1-6h4v4H5V5zm15-2h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-1 6h-4V5h4v4zm-9 12a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6zm-5-6h4v4H5v-4zm13-1h-2v2h-2v2h2v2h2v-2h2v-2h-2z"
                }
            }
        ]
    })(props);
}
function BiCut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 6.5C10 4.57 8.43 3 6.5 3S3 4.57 3 6.5 4.57 10 6.5 10a3.45 3.45 0 0 0 1.613-.413l2.357 2.528-2.318 2.318A3.46 3.46 0 0 0 6.5 14C4.57 14 3 15.57 3 17.5S4.57 21 6.5 21s3.5-1.57 3.5-3.5c0-.601-.166-1.158-.434-1.652l2.269-2.268L17 19.121a3 3 0 0 0 2.121.879H22L9.35 8.518c.406-.572.65-1.265.65-2.018zM6.5 8C5.673 8 5 7.327 5 6.5S5.673 5 6.5 5 8 5.673 8 6.5 7.327 8 6.5 8zm0 11c-.827 0-1.5-.673-1.5-1.5S5.673 16 6.5 16s1.5.673 1.5 1.5S7.327 19 6.5 19z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17 4.879-3.707 4.414 1.414 1.414L22 4h-2.879A3 3 0 0 0 17 4.879z"
                }
            }
        ]
    })(props);
}
function BiCycling(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15.414V20h2v-4.586c0-.526-.214-1.042-.586-1.414l-2-2L13 9.414l2 2c.372.372.888.586 1.414.586H20v-2h-3.586l-3.707-3.707a.999.999 0 0 0-1.414 0L8 9.586c-.378.378-.586.88-.586 1.414s.208 1.036.586 1.414l3 3z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "5",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 14c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zM6 22c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z"
                }
            }
        ]
    })(props);
}
function BiCylinder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.131 0 9-1.935 9-4.5V7h-.053c.033-.164.053-.33.053-.5C21 3.935 17.131 2 12 2 7.209 2 3.52 3.688 3.053 6H3v11.5c0 2.565 3.869 4.5 9 4.5zm0-2c-4.273 0-7-1.48-7-2.5V9.394C6.623 10.387 9.111 11 12 11s5.377-.613 7-1.606V17.5c0 1.02-2.727 2.5-7 2.5zm0-16c4.273 0 7 1.48 7 2.5S16.273 9 12 9 5 7.52 5 6.5 7.727 4 12 4z"
                }
            }
        ]
    })(props);
}
function BiData(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17V7c0-2.168-3.663-4-8-4S4 4.832 4 7v10c0 2.168 3.663 4 8 4s8-1.832 8-4zM12 5c3.691 0 5.931 1.507 6 1.994C17.931 7.493 15.691 9 12 9S6.069 7.493 6 7.006C6.069 6.507 8.309 5 12 5zM6 9.607C7.479 10.454 9.637 11 12 11s4.521-.546 6-1.393v2.387c-.069.499-2.309 2.006-6 2.006s-5.931-1.507-6-2V9.607zM6 17v-2.393C7.479 15.454 9.637 16 12 16s4.521-.546 6-1.393v2.387c-.069.499-2.309 2.006-6 2.006s-5.931-1.507-6-2z"
                }
            }
        ]
    })(props);
}
function BiDesktop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h7v2H8v2h8v-2h-3v-2h7c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 14V5h16l.002 9H4z"
                }
            }
        ]
    })(props);
}
function BiDetail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 19V5h16l.002 14H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7h12v2H6zm0 4h12v2H6zm0 4h6v2H6z"
                }
            }
        ]
    })(props);
}
function BiDevices(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H7c-1.103 0-2 .897-2 2v2H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h6c1.103 0 2-.897 2-2h8c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM9.997 19H4V9h6l-.003 10zm10-2H12V9c0-1.103-.897-2-2-2H7V5h13l-.003 12z"
                }
            }
        ]
    })(props);
}
function BiDialpadAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "6",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "6",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "6",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "12",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "12",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "18",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function BiDialpad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3h4v3h-4zm0 5h4v3h-4zm0 5h4v3h-4zm6-10h4v3h-4zm0 5h4v3h-4zm0 5h4v3h-4zM4 3h4v3H4zm0 5h4v3H4zm0 5h4v3H4zm6 5h4v3h-4z"
                }
            }
        ]
    })(props);
}
function BiDiamond(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.813 3.838A2 2 0 0 0 16.187 3H7.813c-.644 0-1.252.313-1.667.899l-4 6.581a.999.999 0 0 0 .111 1.188l9 10a.995.995 0 0 0 1.486.001l9-10a.997.997 0 0 0 .111-1.188l-4.041-6.643zM12 19.505 5.245 12h13.509L12 19.505zM4.777 10l3.036-5 8.332-.062L19.222 10H4.777z"
                }
            }
        ]
    })(props);
}
function BiDice1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function BiDice2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9.5",
                    "cy": "12",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.5",
                    "cy": "12",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function BiDice3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "8",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "16",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function BiDice4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "8",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "16",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "16",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "8",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function BiDice5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "8",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "16",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "16",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "8",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function BiDice6(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "8",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "12",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "12",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "16",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "16",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "8",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function BiDirections(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.781 13.875-2-2.5A1 1 0 0 0 19 11h-6V9h6c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5a1 1 0 0 0-.781.375l-2 2.5a1.001 1.001 0 0 0 0 1.25l2 2.5A1 1 0 0 0 5 9h6v2H5c-1.103 0-2 .897-2 2v3c0 1.103.897 2 2 2h6v4h2v-4h6a1 1 0 0 0 .781-.375l2-2.5a1.001 1.001 0 0 0 0-1.25zM4.281 5.5 5.48 4H19l.002 3H5.48L4.281 5.5zM18.52 16H5v-3h13.52l1.2 1.5-1.2 1.5z"
                }
            }
        ]
    })(props);
}
function BiDisc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm0 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"
                }
            }
        ]
    })(props);
}
function BiDish(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15c0-4.625-3.507-8.441-8-8.941V4h-2v2.059c-4.493.5-8 4.316-8 8.941v2h18v-2zM5 15c0-3.859 3.141-7 7-7s7 3.141 7 7H5zm-3 3h20v2H2z"
                }
            }
        ]
    })(props);
}
function BiDislike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H6.693A2.01 2.01 0 0 0 4.82 4.298l-2.757 7.351A1 1 0 0 0 2 12v2c0 1.103.897 2 2 2h5.612L8.49 19.367a2.004 2.004 0 0 0 .274 1.802c.376.52.982.831 1.624.831H12c.297 0 .578-.132.769-.36l4.7-5.64H20c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm-8.469 17h-1.145l1.562-4.684A1 1 0 0 0 11 14H4v-1.819L6.693 5H16v9.638L11.531 20zM18 14V5h2l.001 9H18z"
                }
            }
        ]
    })(props);
}
function BiDizzy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.707 12.293 9.414 11l1.293-1.293-1.414-1.414L8 9.586 6.707 8.293 5.293 9.707 6.586 11l-1.293 1.293 1.414 1.414L8 12.414l1.293 1.293zm6.586-4L16 9.586l-1.293-1.293-1.414 1.414L14.586 11l-1.293 1.293 1.414 1.414L16 12.414l1.293 1.293 1.414-1.414L17.414 11l1.293-1.293zM10 16h4v2h-4z"
                }
            }
        ]
    })(props);
}
function BiDna(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.794 11.09c.332-.263.648-.542.947-.84l.136-.142c.283-.293.552-.598.801-.919l.062-.075c.255-.335.486-.688.702-1.049l.128-.22c.205-.364.395-.737.559-1.123.02-.047.035-.095.055-.142.147-.361.274-.731.383-1.109.021-.07.044-.14.063-.211.107-.402.189-.813.251-1.229.013-.087.021-.175.032-.263.051-.432.087-.869.087-1.311V2h-2v.457c0 .184-.031.361-.042.543H6.022C6.012 2.819 6 2.64 6 2.457V2H4v.457c0 4.876 3.269 9.218 7.952 10.569l.028.009c2.881.823 5.056 3.146 5.769 5.965H6.251l.799-2h7.607a7.416 7.416 0 0 0-2.063-2h-4c.445-.424.956-.774 1.491-1.09a9.922 9.922 0 0 1-2.08-1.014C5.55 14.812 4 17.779 4 21.015V23h2v-1.985L6.001 21h11.998l.001.015V23h2v-1.985c0-3.83-2.159-7.303-5.443-9.07a11.1 11.1 0 0 0 1.072-.729c.055-.042.11-.082.165-.126zm-1.19-1.604a8.945 8.945 0 0 1-2.325 1.348c-.092.036-.185.068-.278.102A8.95 8.95 0 0 1 8.836 9h6.292c-.171.161-.332.333-.517.48l-.007.006zM17.619 5c-.005.016-.007.033-.012.049l-.044.151a9.089 9.089 0 0 1-.513 1.252c-.096.19-.213.365-.321.548h-9.48a9.066 9.066 0 0 1-.871-2h11.241z"
                }
            }
        ]
    })(props);
}
function BiDockBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm0 2v9H5V5zM5 19v-3h14v3z"
                }
            }
        ]
    })(props);
}
function BiDockLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM5 5h3v14H5zm5 14V5h9v14z"
                }
            }
        ]
    })(props);
}
function BiDockRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM5 5h9v14H5zm11 14V5h3v14z"
                }
            }
        ]
    })(props);
}
function BiDockTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm0 2v3H5V5zM5 19v-9h14v9z"
                }
            }
        ]
    })(props);
}
function BiDollarCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11c-2 0-2-.63-2-1s.7-1 2-1 1.39.64 1.4 1h2A3 3 0 0 0 13 7.12V6h-2v1.09C9 7.42 8 8.71 8 10c0 1.12.52 3 4 3 2 0 2 .68 2 1s-.62 1-2 1c-1.84 0-2-.86-2-1H8c0 .92.66 2.55 3 2.92V18h2v-1.08c2-.34 3-1.63 3-2.92 0-1.12-.52-3-4-3z"
                }
            }
        ]
    })(props);
}
function BiDollar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.999 8.5h2c0-2.837-2.755-4.131-5-4.429V2h-2v2.071c-2.245.298-5 1.592-5 4.429 0 2.706 2.666 4.113 5 4.43v4.97c-1.448-.251-3-1.024-3-2.4h-2c0 2.589 2.425 4.119 5 4.436V22h2v-2.07c2.245-.298 5-1.593 5-4.43s-2.755-4.131-5-4.429V6.1c1.33.239 3 .941 3 2.4zm-8 0c0-1.459 1.67-2.161 3-2.4v4.799c-1.371-.253-3-1.002-3-2.399zm8 7c0 1.459-1.67 2.161-3 2.4v-4.8c1.33.239 3 .941 3 2.4z"
                }
            }
        ]
    })(props);
}
function BiDonateBlood(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 21h9.62a3.995 3.995 0 0 0 3.037-1.397l5.102-5.952a1 1 0 0 0-.442-1.6l-1.968-.656a3.043 3.043 0 0 0-2.823.503l-3.185 2.547-.617-1.235A3.98 3.98 0 0 0 9.146 11H4c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2zm0-8h5.146c.763 0 1.448.423 1.789 1.105l.447.895H7v2h6.014a.996.996 0 0 0 .442-.11l.003-.001.004-.002h.003l.002-.001h.004l.001-.001c.011.003.003-.001.003-.001.012 0 .002-.001.002-.001h.001l.002-.001.003-.001.002-.001.002-.001.003-.001.002-.001.002-.001.003-.002.002-.001.002-.001.003-.001.002-.001h.001l.002-.001h.001l.002-.001.002-.001c.011-.001.003-.001.003-.001l.002-.001a.915.915 0 0 0 .11-.078l4.146-3.317c.261-.208.623-.273.94-.167l.557.186-4.133 4.823a2.029 2.029 0 0 1-1.52.688H4v-6zm9.761-10.674C13.3 2.832 11 5.457 11 7.5c0 1.93 1.57 3.5 3.5 3.5S18 9.43 18 7.5c0-2.043-2.3-4.668-2.761-5.174-.379-.416-1.099-.416-1.478 0zM16 7.5c0 .827-.673 1.5-1.5 1.5S13 8.327 13 7.5c0-.708.738-1.934 1.5-2.934.762 1 1.5 2.226 1.5 2.934z"
                }
            }
        ]
    })(props);
}
function BiDonateHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 21h9.62a3.995 3.995 0 0 0 3.037-1.397l5.102-5.952a1 1 0 0 0-.442-1.6l-1.968-.656a3.043 3.043 0 0 0-2.823.503l-3.185 2.547-.617-1.235A3.98 3.98 0 0 0 9.146 11H4c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2zm0-8h5.146c.763 0 1.448.423 1.789 1.105l.447.895H7v2h6.014a.996.996 0 0 0 .442-.11l.003-.001.004-.002h.003l.002-.001h.004l.001-.001c.009.003.003-.001.003-.001.01 0 .002-.001.002-.001h.001l.002-.001.003-.001.002-.001.002-.001.003-.001.002-.001c.003 0 .001-.001.002-.001l.003-.002.002-.001.002-.001.003-.001.002-.001h.001l.002-.001h.001l.002-.001.002-.001c.009-.001.003-.001.003-.001l.002-.001a.915.915 0 0 0 .11-.078l4.146-3.317c.262-.208.623-.273.94-.167l.557.186-4.133 4.823a2.029 2.029 0 0 1-1.52.688H4v-6zM16 2h-.017c-.163.002-1.006.039-1.983.705-.951-.648-1.774-.7-1.968-.704L12.002 2h-.004c-.801 0-1.555.313-2.119.878C9.313 3.445 9 4.198 9 5s.313 1.555.861 2.104l3.414 3.586a1.006 1.006 0 0 0 1.45-.001l3.396-3.568C18.688 6.555 19 5.802 19 5s-.313-1.555-.878-2.121A2.978 2.978 0 0 0 16.002 2H16zm1 3c0 .267-.104.518-.311.725L14 8.55l-2.707-2.843C11.104 5.518 11 5.267 11 5s.104-.518.294-.708A.977.977 0 0 1 11.979 4c.025.001.502.032 1.067.485.081.065.163.139.247.222l.707.707.707-.707c.084-.083.166-.157.247-.222.529-.425.976-.478 1.052-.484a.987.987 0 0 1 .701.292c.189.189.293.44.293.707z"
                }
            }
        ]
    })(props);
}
function BiDoorOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.385 21.788a.997.997 0 0 0 .857.182l8-2A.999.999 0 0 0 20 19V5a1 1 0 0 0-.758-.97l-8-2A1.003 1.003 0 0 0 10 3v1H6a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h4v1c0 .308.142.599.385.788zM12 4.281l6 1.5v12.438l-6 1.5V4.281zM7 18V6h3v12H7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.242 13.159c.446-.112.758-.512.758-.971v-.377a1 1 0 1 0-2 .001v.377a1 1 0 0 0 1.242.97z"
                }
            }
        ]
    })(props);
}
function BiDotsHorizontalRounded(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function BiDotsHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10h4v4h-4zm6 0h4v4h-4zM4 10h4v4H4z"
                }
            }
        ]
    })(props);
}
function BiDotsVerticalRounded(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function BiDotsVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10h4v4h-4zm0-6h4v4h-4zm0 12h4v4h-4z"
                }
            }
        ]
    })(props);
}
function BiDoughnutChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm7.931 9h-3.032A5.013 5.013 0 0 0 13 7.102V4.069A8.008 8.008 0 0 1 19.931 11zM12 9c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zm0 11c-4.411 0-8-3.589-8-8 0-4.072 3.061-7.436 7-7.931v3.032A5.009 5.009 0 0 0 7 12c0 2.757 2.243 5 5 5a5.007 5.007 0 0 0 4.898-4h3.032c-.494 3.939-3.858 7-7.93 7z"
                }
            }
        ]
    })(props);
}
function BiDownArrowAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m18.707 12.707-1.414-1.414L13 15.586V6h-2v9.586l-4.293-4.293-1.414 1.414L12 19.414z"
                }
            }
        ]
    })(props);
}
function BiDownArrowCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1.993C6.486 1.994 2 6.48 2 11.994c0 5.513 4.486 9.999 10 10 5.514 0 10-4.486 10-10s-4.485-10-10-10.001zm0 18.001c-4.411-.001-8-3.59-8-8 0-4.411 3.589-8 8-8.001 4.411.001 8 3.59 8 8.001s-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8h-2v4H7.991l4.005 4.005L16 12h-3z"
                }
            }
        ]
    })(props);
}
function BiDownArrow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.886 5.536A1.002 1.002 0 0 0 21 5H3a1.002 1.002 0 0 0-.822 1.569l9 13a.998.998 0 0 0 1.644 0l9-13a.998.998 0 0 0 .064-1.033zM12 17.243 4.908 7h14.184L12 17.243z"
                }
            }
        ]
    })(props);
}
function BiDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 16 4-5h-3V4h-2v7H8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18H4v-7H2v7c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-7h-2v7z"
                }
            }
        ]
    })(props);
}
function BiDownvote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.901 10.566A1.001 1.001 0 0 0 20 10h-4V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v7H4a1.001 1.001 0 0 0-.781 1.625l8 10a1 1 0 0 0 1.562 0l8-10c.24-.301.286-.712.12-1.059zM12 19.399 6.081 12H10V4h4v8h3.919L12 19.399z"
                }
            }
        ]
    })(props);
}
function BiDrink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.832 4.555A1 1 0 0 0 20 3H4a1 1 0 0 0-.832 1.554L11 16.303V20H8v2h8v-2h-3v-3.697l7.832-11.748zM12 14.197 8.535 9h6.93L12 14.197zM18.132 5l-1.333 2H7.201L5.868 5h12.264z"
                }
            }
        ]
    })(props);
}
function BiDroplet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c4.636 0 8-3.468 8-8.246C20 7.522 12.882 2.4 12.579 2.185a1 1 0 0 0-1.156-.001C11.12 2.397 4 7.503 4 13.75 4 18.53 7.364 22 12 22zm-.001-17.74C13.604 5.55 18 9.474 18 13.754 18 17.432 15.532 20 12 20s-6-2.57-6-6.25c0-4.29 4.394-8.203 5.999-9.49z"
                }
            }
        ]
    })(props);
}
function BiDumbbell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 5v14h3v-6h6v6h3V5h-3v6H9V5zM3 15a1 1 0 0 0 1 1h1V8H4a1 1 0 0 0-1 1v2H2v2h1v2zm18-6a1 1 0 0 0-1-1h-1v8h1a1 1 0 0 0 1-1v-2h1v-2h-1V9z"
                }
            }
        ]
    })(props);
}
function BiDuplicate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 10H9v3H6v2h3v3h2v-3h3v-2h-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h12c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2zM4 8h12l.002 12H4V8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8v2h12v12h2V4c0-1.103-.897-2-2-2z"
                }
            }
        ]
    })(props);
}
function BiEditAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.045 7.401c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.378-.378-.88-.586-1.414-.586s-1.036.208-1.413.585L4 13.585V18h4.413L19.045 7.401zm-3-3 1.587 1.585-1.59 1.584-1.586-1.585 1.589-1.584zM6 16v-1.585l7.04-7.018 1.586 1.586L7.587 16H6zm-2 4h16v2H4z"
                }
            }
        ]
    })(props);
}
function BiEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7 17.013 4.413-.015 9.632-9.54c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.756-.756-2.075-.752-2.825-.003L7 12.583v4.43zM18.045 4.458l1.589 1.583-1.597 1.582-1.586-1.585 1.594-1.58zM9 13.417l6.03-5.973 1.586 1.586-6.029 5.971L9 15.006v-1.589z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2v-8.668l-2 2V19H8.158c-.026 0-.053.01-.079.01-.033 0-.066-.009-.1-.01H5V5h6.847l2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2z"
                }
            }
        ]
    })(props);
}
function BiEnvelopeOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.555 8.168-9-6a1 1 0 0 0-1.109 0l-9 6A1 1 0 0 0 2 9v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V9c0-.334-.167-.646-.445-.832zM12 4.202 19.197 9 12 13.798 4.803 9 12 4.202zM4 20v-9.131l7.445 4.963a1 1 0 0 0 1.11 0L20 10.869 19.997 20H4z"
                }
            }
        ]
    })(props);
}
function BiEnvelope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm0 2v.511l-8 6.223-8-6.222V6h16zM4 18V9.044l7.386 5.745a.994.994 0 0 0 1.228 0L20 9.044 20.002 18H4z"
                }
            }
        ]
    })(props);
}
function BiEqualizer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9h2v6h-2zm4-3h2v12h-2zM7 4h2v16H7zm12 7h2v2h-2zM3 10h2v4H3z"
                }
            }
        ]
    })(props);
}
function BiEraser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.586 15.408 4.299 4.299a.996.996 0 0 0 .707.293h12.001v-2h-6.958l7.222-7.222c.78-.779.78-2.049 0-2.828L14.906 3a2.003 2.003 0 0 0-2.828 0l-4.75 4.749-4.754 4.843a2.007 2.007 0 0 0 .012 2.816zM13.492 4.414l4.95 4.95-2.586 2.586L10.906 7l2.586-2.586zM8.749 9.156l.743-.742 4.95 4.95-4.557 4.557a1.026 1.026 0 0 0-.069.079h-1.81l-4.005-4.007 4.748-4.837z"
                }
            }
        ]
    })(props);
}
function BiErrorAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h2v7h-2zm0 8h2v2h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21.707 7.293-5-5A.996.996 0 0 0 16 2H8a.996.996 0 0 0-.707.293l-5 5A.996.996 0 0 0 2 8v8c0 .266.105.52.293.707l5 5A.996.996 0 0 0 8 22h8c.266 0 .52-.105.707-.293l5-5A.996.996 0 0 0 22 16V8a.996.996 0 0 0-.293-.707zM20 15.586 15.586 20H8.414L4 15.586V8.414L8.414 4h7.172L20 8.414v7.172z"
                }
            }
        ]
    })(props);
}
function BiErrorCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.953 2C6.465 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.493 2 11.953 2zM12 20c-4.411 0-8-3.589-8-8s3.567-8 7.953-8C16.391 4 20 7.589 20 12s-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h2v7h-2zm0 8h2v2h-2z"
                }
            }
        ]
    })(props);
}
function BiError(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.001 10h2v5h-2zM11 16h2v2h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.768 4.2C13.42 3.545 12.742 3.138 12 3.138s-1.42.407-1.768 1.063L2.894 18.064a1.986 1.986 0 0 0 .054 1.968A1.984 1.984 0 0 0 4.661 21h14.678c.708 0 1.349-.362 1.714-.968a1.989 1.989 0 0 0 .054-1.968L13.768 4.2zM4.661 19 12 5.137 19.344 19H4.661z"
                }
            }
        ]
    })(props);
}
function BiEuro(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.464 6c1.43 0 2.779.613 3.799 1.726l1.475-1.352C17.334 4.843 15.461 4 13.464 4c-1.998 0-3.87.843-5.272 2.375A8.034 8.034 0 0 0 6.589 9H4v2h2.114c-.038.33-.064.663-.064 1s.026.67.064 1H4v2h2.589c.362.97.901 1.861 1.603 2.626C9.594 19.157 11.466 20 13.464 20c1.997 0 3.87-.843 5.273-2.374l-1.475-1.352C16.243 17.387 14.894 18 13.464 18s-2.778-.612-3.798-1.726A5.937 5.937 0 0 1 8.801 15H13v-2H8.139c-.05-.328-.089-.66-.089-1s.039-.672.089-1H13V9H8.801c.24-.457.516-.893.865-1.274C10.686 6.613 12.034 6 13.464 6z"
                }
            }
        ]
    })(props);
}
function BiExclude(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8h-3V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h3v3c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2zm-4 7H9V9h6v6z"
                }
            }
        ]
    })(props);
}
function BiExitFullscreen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4H8v4H4v2h6zM8 20h2v-6H4v2h4zm12-6h-6v6h2v-4h4zm0-6h-4V4h-2v6h6z"
                }
            }
        ]
    })(props);
}
function BiExit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.002 3h-14c-1.103 0-2 .897-2 2v4h2V5h14v14h-14v-4h-2v4c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.898-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11 16 5-4-5-4v3.001H3v2h8z"
                }
            }
        ]
    })(props);
}
function BiExpandAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12H3v9h9v-2H5zm7-7h7v7h2V3h-9z"
                }
            }
        ]
    })(props);
}
function BiExpandHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.29 5.64 1.93 12l6.36 6.36 1.42-1.41L4.76 12l4.95-4.95-1.42-1.41zm6 1.41L19.24 12l-4.95 4.95 1.42 1.41L22.07 12l-6.36-6.36-1.42 1.41z"
                }
            }
        ]
    })(props);
}
function BiExpandVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 19.24-4.95-4.95-1.41 1.42L12 22.07l6.36-6.36-1.41-1.42L12 19.24zM5.64 8.29l1.41 1.42L12 4.76l4.95 4.95 1.41-1.42L12 1.93 5.64 8.29z"
                }
            }
        ]
    })(props);
}
function BiExpand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21 15.344-2.121 2.121-3.172-3.172-1.414 1.414 3.172 3.172L15.344 21H21zM3 8.656l2.121-2.121 3.172 3.172 1.414-1.414-3.172-3.172L8.656 3H3zM21 3h-5.656l2.121 2.121-3.172 3.172 1.414 1.414 3.172-3.172L21 8.656zM3 21h5.656l-2.121-2.121 3.172-3.172-1.414-1.414-3.172 3.172L3 15.344z"
                }
            }
        ]
    })(props);
}
function BiExport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 16h2V7h3l-4-5-4 5h3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2h-4v2h4v9H5v-9h4V9H5c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2z"
                }
            }
        ]
    })(props);
}
function BiExtension(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10V7c0-1.103-.897-2-2-2h-3c0-1.654-1.346-3-3-3S8 3.346 8 5H5c-1.103 0-2 .897-2 2v3.881l.659.239C4.461 11.41 5 12.166 5 13s-.539 1.59-1.341 1.88L3 15.119V19c0 1.103.897 2 2 2h3.881l.239-.659C9.41 19.539 10.166 19 11 19s1.59.539 1.88 1.341l.239.659H17c1.103 0 2-.897 2-2v-3c1.654 0 3-1.346 3-3s-1.346-3-3-3zm0 4h-2l-.003 5h-2.545c-.711-1.22-2.022-2-3.452-2s-2.741.78-3.452 2H5v-2.548C6.22 15.741 7 14.43 7 13s-.78-2.741-2-3.452V7h5V5a1 1 0 0 1 2 0v2h5v5h2a1 1 0 0 1 0 2z"
                }
            }
        ]
    })(props);
}
function BiFace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 2c3.213 0 5.982 1.908 7.254 4.648a7.8 7.8 0 0 1-.895-.498c-.409-.258-.873-.551-1.46-.772-.669-.255-1.4-.378-2.234-.378s-1.565.123-2.234.377c-.587.223-1.051.516-1.472.781-.378.237-.703.443-1.103.594C9.41 8.921 8.926 9 8.33 9c-.595 0-1.079-.079-1.524-.248-.4-.151-.728-.358-1.106-.598-.161-.101-.34-.208-.52-.313C6.587 5.542 9.113 4 12 4zm0 16c-4.411 0-8-3.589-8-8 0-.81.123-1.59.348-2.327.094.058.185.11.283.173.411.26.876.554 1.466.776.669.255 1.399.378 2.233.378.833 0 1.564-.123 2.235-.377.587-.223 1.051-.516 1.472-.781.378-.237.703-.443 1.103-.595.445-.168.929-.247 1.525-.247s1.08.079 1.525.248c.399.15.725.356 1.114.602.409.258.873.551 1.46.773.363.138.748.229 1.153.291.049.357.083.717.083 1.086 0 4.411-3.589 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "13.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "13.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function BiFastForwardCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13 16 5-4-5-4zm-6 0 5-4-5-4z"
                }
            }
        ]
    })(props);
}
function BiFastForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19 12-7-5v10zM5 7v10l7-5z"
                }
            }
        ]
    })(props);
}
function BiFemaleSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.691 2 6 4.691 6 8c0 2.967 2.167 5.432 5 5.91V17H8v2h3v2.988h2V19h3v-2h-3v-3.09c2.833-.479 5-2.943 5-5.91 0-3.309-2.691-6-6-6zm0 10c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z"
                }
            }
        ]
    })(props);
}
function BiFemale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.948 7.684A.997.997 0 0 0 14 7h-4a.998.998 0 0 0-.948.684l-2 6 1.775.593L8 18h2v4h4v-4h2l-.827-3.724 1.775-.593-2-5.999z"
                }
            }
        ]
    })(props);
}
function BiFileBlank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.937 8.68c-.011-.032-.02-.063-.033-.094a.997.997 0 0 0-.196-.293l-6-6a.997.997 0 0 0-.293-.196c-.03-.014-.062-.022-.094-.033a.991.991 0 0 0-.259-.051C13.04 2.011 13.021 2 13 2H6c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V9c0-.021-.011-.04-.013-.062a.99.99 0 0 0-.05-.258zM16.586 8H14V5.414L16.586 8zM6 20V4h6v5a1 1 0 0 0 1 1h5l.002 10H6z"
                }
            }
        ]
    })(props);
}
function BiFileFind(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.707 2.293A.996.996 0 0 0 13 2H6c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V9a.996.996 0 0 0-.293-.707l-6-6zM6 4h6.586L18 9.414l.002 9.174-2.568-2.568c.35-.595.566-1.281.566-2.02 0-2.206-1.794-4-4-4s-4 1.794-4 4 1.794 4 4 4c.739 0 1.425-.216 2.02-.566L16.586 20H6V4zm6 12c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z"
                }
            }
        ]
    })(props);
}
function BiFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.903 8.586a.997.997 0 0 0-.196-.293l-6-6a.997.997 0 0 0-.293-.196c-.03-.014-.062-.022-.094-.033a.991.991 0 0 0-.259-.051C13.04 2.011 13.021 2 13 2H6c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V9c0-.021-.011-.04-.013-.062a.952.952 0 0 0-.051-.259c-.01-.032-.019-.063-.033-.093zM16.586 8H14V5.414L16.586 8zM6 20V4h6v5a1 1 0 0 0 1 1h5l.002 10H6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12h8v2H8zm0 4h8v2H8zm0-8h2v2H8z"
                }
            }
        ]
    })(props);
}
function BiFilm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM9 11V5h6v6H9zm6 2v6H9v-6h6zM5 5h2v2H5V5zm0 4h2v2H5V9zm0 4h2v2H5v-2zm0 4h2v2H5v-2zm14.002 2H17v-2h2.002v2zm-.001-4H17v-2h2.001v2zm0-4H17V9h2.001v2zM17 7V5h2v2h-2z"
                }
            }
        ]
    })(props);
}
function BiFilterAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H5a1 1 0 0 0-1 1v2.59c0 .523.213 1.037.583 1.407L10 13.414V21a1.001 1.001 0 0 0 1.447.895l4-2c.339-.17.553-.516.553-.895v-5.586l5.417-5.417c.37-.37.583-.884.583-1.407V4a1 1 0 0 0-1-1zm-6.707 9.293A.996.996 0 0 0 14 13v5.382l-2 1V13a.996.996 0 0 0-.293-.707L6 6.59V5h14.001l.002 1.583-5.71 5.71z"
                }
            }
        ]
    })(props);
}
function BiFilter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11h10v2H7zM4 7h16v2H4zm6 8h4v2h-4z"
                }
            }
        ]
    })(props);
}
function BiFingerprint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.962 17.674C7 19.331 7 20.567 7 22h2c0-1.521 0-3.244-1.343-5.389l-1.695 1.063zM16.504 3.387C13.977 1.91 7.55.926 4.281 4.305c-3.368 3.481-2.249 9.072.001 11.392.118.122.244.229.369.333.072.061.146.116.205.184l1.494-1.33a3.918 3.918 0 0 0-.419-.391c-.072-.06-.146-.119-.214-.188-1.66-1.711-2.506-6.017.001-8.608 2.525-2.611 8.068-1.579 9.777-.581 2.691 1.569 4.097 4.308 4.109 4.333l1.789-.895c-.065-.135-1.668-3.289-4.889-5.167z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.34 12.822c-1.03-1.26-1.787-2.317-1.392-3.506.263-.785.813-1.325 1.637-1.604 1.224-.41 2.92-.16 4.04.601l1.123-1.654c-1.648-1.12-3.982-1.457-5.804-.841-1.408.476-2.435 1.495-2.892 2.866-.776 2.328.799 4.254 1.74 5.405.149.183.29.354.409.512C11 18.323 11 20.109 11 22h2c0-2.036 0-4.345-3.201-8.601a19.71 19.71 0 0 0-.459-.577zm5.791-3.344c1.835 1.764 3.034 4.447 3.889 8.701l1.961-.395c-.939-4.678-2.316-7.685-4.463-9.748l-1.387 1.442z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11.556 9.169-1.115 1.66c.027.019 2.711 1.88 3.801 5.724l1.924-.545c-1.299-4.582-4.476-6.749-4.61-6.839zm3.132 9.29c.21 1.168.312 2.326.312 3.541h2c0-1.335-.112-2.608-.343-3.895l-1.969.354z"
                }
            }
        ]
    })(props);
}
function BiFirstAid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-3V4c0-1.103-.897-2-2-2H9c-1.103 0-2 .897-2 2v2H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zM9 4h6v2H9V4zM4 18V8h16l.001 10H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9h-2v3H8v2h3v3h2v-3h3v-2h-3z"
                }
            }
        ]
    })(props);
}
function BiFirstPage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m16.293 17.707 1.414-1.414L13.414 12l4.293-4.293-1.414-1.414L10.586 12zM7 6h2v12H7z"
                }
            }
        ]
    })(props);
}
function BiFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H6V2H4v18H3v2h4v-2H6v-5h13a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm-1 9H6V6h12v7z"
                }
            }
        ]
    })(props);
}
function BiFolderMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-8.586L9.707 3.293A.996.996 0 0 0 9 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zM4 19V7h16l.002 12H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.874 12h8v2h-8z"
                }
            }
        ]
    })(props);
}
function BiFolderOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.165 19.551c.186.28.499.449.835.449h15c.4 0 .762-.238.919-.606l3-7A.998.998 0 0 0 21 11h-1V7c0-1.103-.897-2-2-2h-6.1L9.616 3.213A.997.997 0 0 0 9 3H4c-1.103 0-2 .897-2 2v14h.007a1 1 0 0 0 .158.551zM17.341 18H4.517l2.143-5h12.824l-2.143 5zM18 7v4H6c-.4 0-.762.238-.919.606L4 14.129V7h14z"
                }
            }
        ]
    })(props);
}
function BiFolderPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9h-2v3H8v2h3v3h2v-3h3v-2h-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-8.586L9.707 3.293A.996.996 0 0 0 9 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zM4 19V7h16l.002 12H4z"
                }
            }
        ]
    })(props);
}
function BiFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-8.586L9.707 3.293A.997.997 0 0 0 9 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zM4 19V7h16l.002 12H4z"
                }
            }
        ]
    })(props);
}
function BiFontColor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18h14v3H5zm7.5-14h-1c-.401 0-.764.24-.921.609L5.745 16h2.173l1.273-3h5.604l1.268 3h2.171L13.421 4.61A1 1 0 0 0 12.5 4zm-2.46 7 1.959-4.616L13.95 11h-3.91z"
                }
            }
        ]
    })(props);
}
function BiFontFamily(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4h7v2h-7zm1 4h6v2h-6zm2 4h4v2h-4zM9.307 4l-6 16h2.137l1.875-5h6.363l1.875 5h2.137l-6-16H9.307zm-1.239 9L10.5 6.515 12.932 13H8.068z"
                }
            }
        ]
    })(props);
}
function BiFontSize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m22 6-3-4-3 4h2v4h-2l3 4 3-4h-2V6zM9.307 4l-6 16h2.137l1.875-5h6.363l1.875 5h2.137l-6-16H9.307zm-1.239 9L10.5 6.515 12.932 13H8.068z"
                }
            }
        ]
    })(props);
}
function BiFont(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.307 4-6 16h2.137l1.875-5h6.363l1.875 5h2.137l-6-16h-2.387zm-1.239 9L12.5 6.515 14.932 13h-4.864z"
                }
            }
        ]
    })(props);
}
function BiFoodMenu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2h2v20H3zm7 4h7v2h-7zm0 4h7v2h-7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H6v20h13c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 18H8V4h11v16z"
                }
            }
        ]
    })(props);
}
function BiFoodTag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-1 16H5V5h14v14z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "5"
                }
            }
        ]
    })(props);
}
function BiFootball(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.071 4.929a9.936 9.936 0 0 0-7.07-2.938 9.943 9.943 0 0 0-7.072 2.938c-3.899 3.898-3.899 10.243 0 14.142a9.94 9.94 0 0 0 7.073 2.938 9.936 9.936 0 0 0 7.07-2.937c3.899-3.898 3.899-10.243-.001-14.143zM12.181 4h-.359c.061-.001.119-.009.18-.009s.118.008.179.009zm6.062 13H16l-1.258 2.516a7.956 7.956 0 0 1-2.741.493 7.96 7.96 0 0 1-2.746-.494L8 17.01H5.765a7.96 7.96 0 0 1-1.623-3.532L6 11 4.784 8.567a7.936 7.936 0 0 1 1.559-2.224 7.994 7.994 0 0 1 3.22-1.969L12 6l2.438-1.625a8.01 8.01 0 0 1 3.22 1.968 7.94 7.94 0 0 1 1.558 2.221L18 11l1.858 2.478A7.952 7.952 0 0 1 18.243 17z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8.5 11 1.5 4h4l1.5-4L12 8.5z"
                }
            }
        ]
    })(props);
}
function BiFork(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m14.47 13.77-1.41-1.42 5.66-5.65-1.42-1.42-5.65 5.66-1.42-1.41 5.66-5.66-1.42-1.42-6.36 6.37a3 3 0 0 0 0 4.24l.71.71-6.37 6.36 1.42 1.42 6.36-6.37.71.71a3 3 0 0 0 4.24 0l6.37-6.36-1.42-1.42z"
                }
            }
        ]
    })(props);
}
function BiFridge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 2 .001 5H10V7H8v2H6V4h12zM6 20v-9h2v3h2v-3h8.001l.001 9H6z"
                }
            }
        ]
    })(props);
}
function BiFullscreen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5h5V3H3v7h2zm5 14H5v-5H3v7h7zm11-5h-2v5h-5v2h7zm-2-4h2V3h-7v2h5z"
                }
            }
        ]
    })(props);
}
function BiGame(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.937 7.53C19.227 4.119 15.803 2 12 2 6.486 2 2 6.486 2 12s4.486 10 10 10c3.803 0 7.227-2.119 8.937-5.53a1 1 0 0 0-.397-1.316L15.017 12l5.522-3.153c.461-.264.636-.842.398-1.317zm-8.433 3.602a.999.999 0 0 0 0 1.736l6.173 3.525A7.949 7.949 0 0 1 12 20c-4.411 0-8-3.589-8-8s3.589-8 8-8a7.95 7.95 0 0 1 6.677 3.606l-6.173 3.526z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.5",
                    "cy": "7.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function BiGasPump(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19.616 6.48.014-.017-4-3.24-1.26 1.554 2.067 1.674a2.99 2.99 0 0 0-1.395 3.058c.149.899.766 1.676 1.565 2.112.897.49 1.685.446 2.384.197L18.976 18a.996.996 0 0 1-1.39.922.995.995 0 0 1-.318-.217.996.996 0 0 1-.291-.705L17 16a2.98 2.98 0 0 0-.877-2.119A3 3 0 0 0 14 13h-1V5c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h7c1.103 0 2-.897 2-2v-4h1c.136 0 .267.027.391.078a1.028 1.028 0 0 1 .531.533A.994.994 0 0 1 15 16l-.024 2c0 .406.079.799.236 1.168.151.359.368.68.641.951a2.97 2.97 0 0 0 2.123.881c.406 0 .798-.078 1.168-.236.358-.15.68-.367.951-.641A2.983 2.983 0 0 0 20.976 18L21 9a2.997 2.997 0 0 0-1.384-2.52zM4 5h7l.001 4H4V5zm0 14v-8h7.001l.001 8H4zm14-9a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                }
            }
        ]
    })(props);
}
function BiGhost(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4.963 0-9 4.038-9 9v8h.051c.245 1.691 1.69 3 3.449 3 1.174 0 2.074-.417 2.672-1.174a3.99 3.99 0 0 0 5.668-.014c.601.762 1.504 1.188 2.66 1.188 1.93 0 3.5-1.57 3.5-3.5V11c0-4.962-4.037-9-9-9zm7 16.5c0 .827-.673 1.5-1.5 1.5-.449 0-1.5 0-1.5-2v-1h-2v1c0 1.103-.897 2-2 2s-2-.897-2-2v-1H8v1c0 1.845-.774 2-1.5 2-.827 0-1.5-.673-1.5-1.5V11c0-3.86 3.141-7 7-7s7 3.14 7 7v7.5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "10",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "10",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function BiGift(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7h-1.209A4.92 4.92 0 0 0 19 5.5C19 3.57 17.43 2 15.5 2c-1.622 0-2.705 1.482-3.404 3.085C11.407 3.57 10.269 2 8.5 2 6.57 2 5 3.57 5 5.5c0 .596.079 1.089.209 1.5H4c-1.103 0-2 .897-2 2v2c0 1.103.897 2 2 2v7c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-7c1.103 0 2-.897 2-2V9c0-1.103-.897-2-2-2zm-4.5-3c.827 0 1.5.673 1.5 1.5C17 7 16.374 7 16 7h-2.478c.511-1.576 1.253-3 1.978-3zM7 5.5C7 4.673 7.673 4 8.5 4c.888 0 1.714 1.525 2.198 3H8c-.374 0-1 0-1-1.5zM4 9h7v2H4V9zm2 11v-7h5v7H6zm12 0h-5v-7h5v7zm-5-9V9.085L13.017 9H20l.001 2H13z"
                }
            }
        ]
    })(props);
}
function BiGitBranch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 4C15.57 4 14 5.57 14 7.5c0 1.554 1.025 2.859 2.43 3.315-.146.932-.547 1.7-1.23 2.323-1.946 1.773-5.527 1.935-7.2 1.907V8.837c1.44-.434 2.5-1.757 2.5-3.337C10.5 3.57 8.93 2 7 2S3.5 3.57 3.5 5.5c0 1.58 1.06 2.903 2.5 3.337v6.326c-1.44.434-2.5 1.757-2.5 3.337C3.5 20.43 5.07 22 7 22s3.5-1.57 3.5-3.5c0-.551-.14-1.065-.367-1.529 2.06-.186 4.657-.757 6.409-2.35 1.097-.997 1.731-2.264 1.904-3.768C19.915 10.438 21 9.1 21 7.5 21 5.57 19.43 4 17.5 4zm-12 1.5C5.5 4.673 6.173 4 7 4s1.5.673 1.5 1.5S7.827 7 7 7s-1.5-.673-1.5-1.5zM7 20c-.827 0-1.5-.673-1.5-1.5a1.5 1.5 0 0 1 1.482-1.498l.13.01A1.495 1.495 0 0 1 7 20zM17.5 9c-.827 0-1.5-.673-1.5-1.5S16.673 6 17.5 6s1.5.673 1.5 1.5S18.327 9 17.5 9z"
                }
            }
        ]
    })(props);
}
function BiGitCommit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c-2.967 0-5.431 2.167-5.909 5H2v2h4.092c.479 2.832 2.942 4.998 5.909 4.998s5.43-2.166 5.909-4.998H22v-2h-4.09c-.478-2.833-2.942-5-5.91-5zm0 9.998c-2.205 0-3.999-1.794-3.999-3.999S9.795 8 12 8c2.206 0 4 1.794 4 3.999s-1.794 3.999-4 3.999z"
                }
            }
        ]
    })(props);
}
function BiGitCompare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.01 2c-1.93 0-3.5 1.57-3.5 3.5 0 1.58 1.06 2.903 2.5 3.337v7.16c-.001.179.027 1.781 1.174 2.931C6.892 19.64 7.84 20 9 20v2l4-3-4-3v2c-1.823 0-1.984-1.534-1.99-2V8.837c1.44-.434 2.5-1.757 2.5-3.337 0-1.93-1.571-3.5-3.5-3.5zm0 5c-.827 0-1.5-.673-1.5-1.5S5.183 4 6.01 4s1.5.673 1.5 1.5S6.837 7 6.01 7zm13 8.163V7.997C19.005 6.391 17.933 4 15 4V2l-4 3 4 3V6c1.829 0 2.001 1.539 2.01 2v7.163c-1.44.434-2.5 1.757-2.5 3.337 0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5c0-1.58-1.06-2.903-2.5-3.337zm-1 4.837c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function BiGitMerge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 18.5C2.5 20.43 4.07 22 6 22s3.5-1.57 3.5-3.5c0-1.58-1.06-2.903-2.5-3.337v-3.488c.244.273.509.527.813.744 1.18.844 2.617 1.098 3.918 1.098.966 0 1.853-.14 2.506-.281a3.5 3.5 0 0 0 3.264 2.265c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5a3.5 3.5 0 0 0-3.404 2.718c-1.297.321-3.664.616-5.119-.426-.666-.477-1.09-1.239-1.306-2.236C8.755 7.96 9.5 6.821 9.5 5.5 9.5 3.57 7.93 2 6 2S2.5 3.57 2.5 5.5c0 1.58 1.06 2.903 2.5 3.337v6.326c-1.44.434-2.5 1.757-2.5 3.337zm15-8c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5S16 12.827 16 12s.673-1.5 1.5-1.5zm-10 8c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5S5.173 17 6 17s1.5.673 1.5 1.5zm-3-13C4.5 4.673 5.173 4 6 4s1.5.673 1.5 1.5S6.827 7 6 7s-1.5-.673-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function BiGitPullRequest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.01 15.163V7.997C19.005 6.391 17.933 4 15 4V2l-4 3 4 3V6c1.829 0 2.001 1.539 2.01 2v7.163c-1.44.434-2.5 1.757-2.5 3.337 0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5c0-1.58-1.06-2.903-2.5-3.337zm-1 4.837c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5zM9.5 5.5C9.5 3.57 7.93 2 6 2S2.5 3.57 2.5 5.5c0 1.58 1.06 2.903 2.5 3.337v6.326c-1.44.434-2.5 1.757-2.5 3.337C2.5 20.43 4.07 22 6 22s3.5-1.57 3.5-3.5c0-1.58-1.06-2.903-2.5-3.337V8.837C8.44 8.403 9.5 7.08 9.5 5.5zm-5 0C4.5 4.673 5.173 4 6 4s1.5.673 1.5 1.5S6.827 7 6 7s-1.5-.673-1.5-1.5zm3 13c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5S5.173 17 6 17s1.5.673 1.5 1.5z"
                }
            }
        ]
    })(props);
}
function BiGitRepoForked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.559 8.855c.166 1.183.789 3.207 3.087 4.079C11 13.829 11 14.534 11 15v.163c-1.44.434-2.5 1.757-2.5 3.337 0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5c0-1.58-1.06-2.903-2.5-3.337V15c0-.466 0-1.171 2.354-2.065 2.298-.872 2.921-2.896 3.087-4.079C19.912 8.441 21 7.102 21 5.5 21 3.57 19.43 2 17.5 2S14 3.57 14 5.5c0 1.552 1.022 2.855 2.424 3.313-.146.735-.565 1.791-1.778 2.252-1.192.452-2.053.953-2.646 1.536-.593-.583-1.453-1.084-2.646-1.536-1.213-.461-1.633-1.517-1.778-2.252C8.978 8.355 10 7.052 10 5.5 10 3.57 8.43 2 6.5 2S3 3.57 3 5.5c0 1.602 1.088 2.941 2.559 3.355zM17.5 4c.827 0 1.5.673 1.5 1.5S18.327 7 17.5 7 16 6.327 16 5.5 16.673 4 17.5 4zm-4 14.5c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5.673-1.5 1.5-1.5 1.5.673 1.5 1.5zM6.5 4C7.327 4 8 4.673 8 5.5S7.327 7 6.5 7 5 6.327 5 5.5 5.673 4 6.5 4z"
                }
            }
        ]
    })(props);
}
function BiGlassesAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.948 11.684-2-6A.997.997 0 0 0 19 5h-3v2h2.279l1.334 4H15c-1.103 0-2 .897-2 2h-2c0-1.103-.897-2-2-2H4.387l1.334-4H8V5H5a.998.998 0 0 0-.948.684l-2 6 .012.004A.928.928 0 0 0 2 12v4c0 1.654 1.346 3 3 3h3c1.654 0 3-1.346 3-3v-1h2v1c0 1.654 1.346 3 3 3h3c1.654 0 3-1.346 3-3v-4a.964.964 0 0 0-.063-.313l.011-.003zM9 16c0 .551-.448 1-1 1H5c-.552 0-1-.449-1-1v-3h5v3zm11 0c0 .551-.448 1-1 1h-3c-.552 0-1-.449-1-1v-3h5v3z"
                }
            }
        ]
    })(props);
}
function BiGlasses(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.977 13.783-2-9A1.002 1.002 0 0 0 19 4h-3v2h2.198l.961 4.326A4.467 4.467 0 0 0 17.5 10c-1.953 0-3.603 1.258-4.224 3h-2.553c-.621-1.742-2.271-3-4.224-3-.587 0-1.145.121-1.659.326L5.802 6H8V4H5a1 1 0 0 0-.976.783l-2 9 .047.011A4.552 4.552 0 0 0 2 14.5C2 16.981 4.019 19 6.5 19c2.31 0 4.197-1.756 4.449-4h2.102c.252 2.244 2.139 4 4.449 4 2.481 0 4.5-2.019 4.5-4.5 0-.242-.034-.475-.071-.706l.048-.011zM6.5 17C5.122 17 4 15.878 4 14.5S5.122 12 6.5 12 9 13.122 9 14.5 7.878 17 6.5 17zm11 0c-1.379 0-2.5-1.122-2.5-2.5s1.121-2.5 2.5-2.5 2.5 1.122 2.5 2.5-1.121 2.5-2.5 2.5z"
                }
            }
        ]
    })(props);
}
function BiGlobeAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 18.791V20H9v2h6v-2h-2v-1.845a9.934 9.934 0 0 0 3.071-2.084c3.898-3.898 3.898-10.243 0-14.143l-1.414 1.414c3.119 3.12 3.119 8.195 0 11.314-3.119 3.118-8.195 3.12-11.314 0L1.929 16.07A9.971 9.971 0 0 0 9 18.994a9.98 9.98 0 0 0 2-.203z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9c0 3.309 2.691 6 6 6s6-2.691 6-6-2.691-6-6-6-6 2.691-6 6zm10 0c0 2.206-1.794 4-4 4s-4-1.794-4-4 1.794-4 4-4 4 1.794 4 4z"
                }
            }
        ]
    })(props);
}
function BiGlobe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm7.931 9h-2.764a14.67 14.67 0 0 0-1.792-6.243A8.013 8.013 0 0 1 19.931 11zM12.53 4.027c1.035 1.364 2.427 3.78 2.627 6.973H9.03c.139-2.596.994-5.028 2.451-6.974.172-.01.344-.026.519-.026.179 0 .354.016.53.027zm-3.842.7C7.704 6.618 7.136 8.762 7.03 11H4.069a8.013 8.013 0 0 1 4.619-6.273zM4.069 13h2.974c.136 2.379.665 4.478 1.556 6.23A8.01 8.01 0 0 1 4.069 13zm7.381 6.973C10.049 18.275 9.222 15.896 9.041 13h6.113c-.208 2.773-1.117 5.196-2.603 6.972-.182.012-.364.028-.551.028-.186 0-.367-.016-.55-.027zm4.011-.772c.955-1.794 1.538-3.901 1.691-6.201h2.778a8.005 8.005 0 0 1-4.469 6.201z"
                }
            }
        ]
    })(props);
}
function BiGridAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM9 9H5V5h4v4zm5 2h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm1-6h4v4h-4V5zM3 20a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6zm2-5h4v4H5v-4zm8 5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6zm2-5h4v4h-4v-4z"
                }
            }
        ]
    })(props);
}
function BiGridHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 7h4v4h-4zm6 0h4v4h-4zM4 7h4v4H4zm6 6h4v4h-4zm6 0h4v4h-4zM4 13h4v4H4z"
                }
            }
        ]
    })(props);
}
function BiGridSmall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h4v4H7zm0 6h4v4H7zm6-6h4v4h-4zm0 6h4v4h-4z"
                }
            }
        ]
    })(props);
}
function BiGridVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10h4v4H7zm0-6h4v4H7zm0 12h4v4H7zm6-6h4v4h-4zm0-6h4v4h-4zm0 12h4v4h-4z"
                }
            }
        ]
    })(props);
}
function BiGrid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3H4.984c-1.103 0-2 .897-2 2v14.016c0 1.103.897 2 2 2H19c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2h-4zm4 5h-3V5h3v3zM4.984 10h3v4.016h-3V10zm5 0H14v4.016H9.984V10zM16 10h3v4.016h-3V10zm-2-5v3H9.984V5H14zM7.984 5v3h-3V5h3zm-3 11.016h3v3h-3v-3zm5 3v-3H14v3H9.984zm6.016 0v-3h3.001v3H16z"
                }
            }
        ]
    })(props);
}
function BiGroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.604 11.048a5.67 5.67 0 0 0 .751-3.44c-.179-1.784-1.175-3.361-2.803-4.44l-1.105 1.666c1.119.742 1.8 1.799 1.918 2.974a3.693 3.693 0 0 1-1.072 2.986l-1.192 1.192 1.618.475C18.951 13.701 19 17.957 19 18h2c0-1.789-.956-5.285-4.396-6.952z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 12c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm1.5 7H8c-3.309 0-6 2.691-6 6v1h2v-1c0-2.206 1.794-4 4-4h3c2.206 0 4 1.794 4 4v1h2v-1c0-3.309-2.691-6-6-6z"
                }
            }
        ]
    })(props);
}
function BiHandicap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "4",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.98 14.804A1 1 0 0 0 16 14h-4.133l-.429-3H16V9h-4.847l-.163-1.142A1 1 0 0 0 10 7H9a1.003 1.003 0 0 0-.99 1.142l.877 6.142A2.009 2.009 0 0 0 10.867 16h4.313l.839 4.196c.094.467.504.804.981.804h3v-2h-2.181l-.839-4.196z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.51 17.5c-.739 1.476-2.25 2.5-4.01 2.5A4.505 4.505 0 0 1 4 15.5a4.503 4.503 0 0 1 2.817-4.167l-.289-2.025C3.905 10.145 2 12.604 2 15.5 2 19.084 4.916 22 8.5 22a6.497 6.497 0 0 0 5.545-3.126l-.274-1.374H12.51z"
                }
            }
        ]
    })(props);
}
function BiHappyAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.493",
                    "cy": "9.493",
                    "r": "1.493"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18c5 0 6-5 6-5H6s1 5 6 5z"
                }
            }
        ]
    })(props);
}
function BiHappyBeaming(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18c4 0 5-4 5-4H7s1 4 5 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13 12 2 .012c.012-.462.194-1.012 1-1.012s.988.55 1 1h2c0-1.206-.799-3-3-3s-3 1.794-3 3zm-5-1c.806 0 .988.55 1 1h2c0-1.206-.799-3-3-3s-3 1.794-3 3l2 .012C7.012 11.55 7.194 11 8 11z"
                }
            }
        ]
    })(props);
}
function BiHappyHeartEyes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18c4 0 5-4 5-4H7s1 4 5 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.514 0 10-4.486 10-10S17.514 2 12 2 2 6.486 2 12s4.486 10 10 10zm0-18c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8.535 12.634 2.05-2.083a1.485 1.485 0 0 0-.018-2.118 1.49 1.49 0 0 0-2.065-.034 1.488 1.488 0 0 0-2.067.068c-.586.6-.579 1.53.019 2.117l2.081 2.05zm7 0 2.05-2.083a1.485 1.485 0 0 0-.018-2.118 1.49 1.49 0 0 0-2.065-.034 1.488 1.488 0 0 0-2.068.067c-.586.6-.579 1.53.019 2.117l2.082 2.051z"
                }
            }
        ]
    })(props);
}
function BiHappy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "10.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.493",
                    "cy": "10.493",
                    "r": "1.493"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18c4 0 5-4 5-4H7s1 4 5 4z"
                }
            }
        ]
    })(props);
}
function BiHardHat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15a9.11 9.11 0 0 0-.18-1.81 8.53 8.53 0 0 0-.53-1.69 8.08 8.08 0 0 0-.83-1.5 8.73 8.73 0 0 0-1.1-1.33A8.27 8.27 0 0 0 17 7.54a8.08 8.08 0 0 0-1.53-.83L15 6.52V5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1.52l-.5.19a8.08 8.08 0 0 0-1.5.83 8.27 8.27 0 0 0-1.33 1.1A8.27 8.27 0 0 0 4.54 10a8.08 8.08 0 0 0-.83 1.53 9 9 0 0 0-.53 1.69A9.11 9.11 0 0 0 3 15v3H2v2h20v-2h-1zM5 15a7.33 7.33 0 0 1 .14-1.41 6.64 6.64 0 0 1 .41-1.31 7.15 7.15 0 0 1 .64-1.19 7.15 7.15 0 0 1 1.9-1.9A7.33 7.33 0 0 1 9 8.68V15h2V6h2v9h2V8.68a8.13 8.13 0 0 1 .91.51 7.09 7.09 0 0 1 1 .86 6.44 6.44 0 0 1 .85 1 6 6 0 0 1 .65 1.19 7.13 7.13 0 0 1 .41 1.31A7.33 7.33 0 0 1 19 15v3H5z"
                }
            }
        ]
    })(props);
}
function BiHash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.018 3.815 15.232 8h-4.966l.716-3.815-1.964-.37L8.232 8H4v2h3.857l-.751 4H3v2h3.731l-.714 3.805 1.965.369L8.766 16h4.966l-.714 3.805 1.965.369.783-4.174H20v-2h-3.859l.751-4H21V8h-3.733l.716-3.815-1.965-.37zM14.106 14H9.141l.751-4h4.966l-.752 4z"
                }
            }
        ]
    })(props);
}
function BiHdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.983 13.821-1.851-10.18A1.998 1.998 0 0 0 18.165 2H5.835a2 2 0 0 0-1.968 1.643l-1.85 10.178.019.003c-.012.06-.036.114-.036.176v5c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-5c0-.063-.024-.116-.035-.176l.018-.003zM5.835 4h12.331l1.637 9H4.198l1.637-9zM4 19v-4h16l.002 4H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 16h2v2h-2zm-3 0h2v2h-2z"
                }
            }
        ]
    })(props);
}
function BiHeading(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 20V4h-3v6H9V4H6v16h3v-7h6v7z"
                }
            }
        ]
    })(props);
}
function BiHeadphone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12v-1.707c0-4.442-3.479-8.161-7.755-8.29-2.204-.051-4.251.736-5.816 2.256A7.933 7.933 0 0 0 4 10v2c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h2V10a5.95 5.95 0 0 1 1.821-4.306 5.977 5.977 0 0 1 4.363-1.691C15.392 4.099 18 6.921 18 10.293V20h2c1.103 0 2-.897 2-2v-4c0-1.103-.897-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12h2v8H7zm8 0h2v8h-2z"
                }
            }
        ]
    })(props);
}
function BiHealth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.649 5.286 14 8.548V2.025h-4v6.523L4.351 5.286l-2 3.465 5.648 3.261-5.648 3.261 2 3.465L10 15.477V22h4v-6.523l5.649 3.261 2-3.465-5.648-3.261 5.648-3.261z"
                }
            }
        ]
    })(props);
}
function BiHeartCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.279 8.833 12 9.112l-.279-.279a2.745 2.745 0 0 0-3.906 0 2.745 2.745 0 0 0 0 3.907L12 16.926l4.186-4.186a2.745 2.745 0 0 0 0-3.907 2.746 2.746 0 0 0-3.907 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            }
        ]
    })(props);
}
function BiHeartSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.998 17 4.186-4.186a2.745 2.745 0 0 0 0-3.907 2.746 2.746 0 0 0-3.907 0l-.278.279-.279-.279a2.746 2.746 0 0 0-3.907 0 2.746 2.746 0 0 0 0 3.907L11.998 17z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4zm-2 15H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function BiHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4.595a5.904 5.904 0 0 0-3.996-1.558 5.942 5.942 0 0 0-4.213 1.758c-2.353 2.363-2.352 6.059.002 8.412l7.332 7.332c.17.299.498.492.875.492a.99.99 0 0 0 .792-.409l7.415-7.415c2.354-2.354 2.354-6.049-.002-8.416a5.938 5.938 0 0 0-4.209-1.754A5.906 5.906 0 0 0 12 4.595zm6.791 1.61c1.563 1.571 1.564 4.025.002 5.588L12 18.586l-6.793-6.793c-1.562-1.563-1.561-4.017-.002-5.584.76-.756 1.754-1.172 2.799-1.172s2.035.416 2.789 1.17l.5.5a.999.999 0 0 0 1.414 0l.5-.5c1.512-1.509 4.074-1.505 5.584-.002z"
                }
            }
        ]
    })(props);
}
function BiHelpCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6a3.939 3.939 0 0 0-3.934 3.934h2C10.066 8.867 10.934 8 12 8s1.934.867 1.934 1.934c0 .598-.481 1.032-1.216 1.626a9.208 9.208 0 0 0-.691.599c-.998.997-1.027 2.056-1.027 2.174V15h2l-.001-.633c.001-.016.033-.386.441-.793.15-.15.339-.3.535-.458.779-.631 1.958-1.584 1.958-3.182A3.937 3.937 0 0 0 12 6zm-1 10h2v2h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            }
        ]
    })(props);
}
function BiHide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19c.946 0 1.81-.103 2.598-.281l-1.757-1.757c-.273.021-.55.038-.841.038-5.351 0-7.424-3.846-7.926-5a8.642 8.642 0 0 1 1.508-2.297L4.184 8.305c-1.538 1.667-2.121 3.346-2.132 3.379a.994.994 0 0 0 0 .633C2.073 12.383 4.367 19 12 19zm0-14c-1.837 0-3.346.396-4.604.981L3.707 2.293 2.293 3.707l18 18 1.414-1.414-3.319-3.319c2.614-1.951 3.547-4.615 3.561-4.657a.994.994 0 0 0 0-.633C21.927 11.617 19.633 5 12 5zm4.972 10.558-2.28-2.28c.19-.39.308-.819.308-1.278 0-1.641-1.359-3-3-3-.459 0-.888.118-1.277.309L8.915 7.501A9.26 9.26 0 0 1 12 7c5.351 0 7.424 3.846 7.926 5-.302.692-1.166 2.342-2.954 3.558z"
                }
            }
        ]
    })(props);
}
function BiHighlight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.707 5.826-3.535-3.533a.999.999 0 0 0-1.408-.006L7.096 10.82a1.01 1.01 0 0 0-.273.488l-1.024 4.437L4 18h2.828l1.142-1.129 3.588-.828c.18-.042.345-.133.477-.262l8.667-8.535a1 1 0 0 0 .005-1.42zm-9.369 7.833-2.121-2.12 7.243-7.131 2.12 2.12-7.242 7.131zM4 20h16v2H4z"
                }
            }
        ]
    })(props);
}
function BiHistory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8v5h5v-2h-3V8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.292 8.497a8.957 8.957 0 0 0-1.928-2.862 9.004 9.004 0 0 0-4.55-2.452 9.09 9.09 0 0 0-3.626 0 8.965 8.965 0 0 0-4.552 2.453 9.048 9.048 0 0 0-1.928 2.86A8.963 8.963 0 0 0 4 12l.001.025H2L5 16l3-3.975H6.001L6 12a6.957 6.957 0 0 1 1.195-3.913 7.066 7.066 0 0 1 1.891-1.892 7.034 7.034 0 0 1 2.503-1.054 7.003 7.003 0 0 1 8.269 5.445 7.117 7.117 0 0 1 0 2.824 6.936 6.936 0 0 1-1.054 2.503c-.25.371-.537.72-.854 1.036a7.058 7.058 0 0 1-2.225 1.501 6.98 6.98 0 0 1-1.313.408 7.117 7.117 0 0 1-2.823 0 6.957 6.957 0 0 1-2.501-1.053 7.066 7.066 0 0 1-1.037-.855l-1.414 1.414A8.985 8.985 0 0 0 13 21a9.05 9.05 0 0 0 3.503-.707 9.009 9.009 0 0 0 3.959-3.26A8.968 8.968 0 0 0 22 12a8.928 8.928 0 0 0-.708-3.503z"
                }
            }
        ]
    })(props);
}
function BiHive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.895 7.553-2-4A1.001 1.001 0 0 0 18 3h-5c-.379 0-.725.214-.895.553L10.382 7H6c-.379 0-.725.214-.895.553l-2 4a1 1 0 0 0 0 .895l2 4c.17.338.516.552.895.552h4.382l1.724 3.447A.998.998 0 0 0 13 21h5c.379 0 .725-.214.895-.553l2-4a1 1 0 0 0 0-.895L19.118 12l1.776-3.553a1 1 0 0 0 .001-.894zM13.618 5h3.764l1.5 3-1.5 3h-3.764l-1.5-3 1.5-3zm-8.5 7 1.5-3h3.764l1.5 3-1.5 3H6.618l-1.5-3zm12.264 7h-3.764l-1.5-3 1.5-3h3.764l1.5 3-1.5 3z"
                }
            }
        ]
    })(props);
}
function BiHomeAlt2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.71 2.29a1 1 0 0 0-1.42 0l-9 9a1 1 0 0 0 0 1.42A1 1 0 0 0 3 13h1v7a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7h1a1 1 0 0 0 1-1 1 1 0 0 0-.29-.71zM6 20v-9.59l6-6 6 6V20z"
                }
            }
        ]
    })(props);
}
function BiHomeAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z"
                }
            }
        ]
    })(props);
}
function BiHomeCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13h1v7c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-7h1a1 1 0 0 0 .707-1.707l-9-9a.999.999 0 0 0-1.414 0l-9 9A1 1 0 0 0 3 13zm9-8.586 6 6V15l.001 5H6v-9.585l6-6.001z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z"
                }
            }
        ]
    })(props);
}
function BiHomeHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12.223 11.641-.223.22-.224-.22a2.224 2.224 0 0 0-3.125 0 2.13 2.13 0 0 0 0 3.07L12 18l3.349-3.289a2.13 2.13 0 0 0 0-3.07 2.225 2.225 0 0 0-3.126 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21.707 11.293-9-9a.999.999 0 0 0-1.414 0l-9 9A1 1 0 0 0 3 13h1v7c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-7h1a1 1 0 0 0 .707-1.707zM18.001 20H6v-9.585l6-6 6 6V15l.001 5z"
                }
            }
        ]
    })(props);
}
function BiHomeSmile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13h1v7c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-7h1a1 1 0 0 0 .707-1.707l-9-9a.999.999 0 0 0-1.414 0l-9 9A1 1 0 0 0 3 13zm9-8.586 6 6V15l.001 5H6v-9.586l6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18c3.703 0 4.901-3.539 4.95-3.689l-1.9-.621c-.008.023-.781 2.31-3.05 2.31-2.238 0-3.02-2.221-3.051-2.316l-1.899.627C7.099 14.461 8.297 18 12 18z"
                }
            }
        ]
    })(props);
}
function BiHome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13h1v7c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-7h1a1 1 0 0 0 .707-1.707l-9-9a.999.999 0 0 0-1.414 0l-9 9A1 1 0 0 0 3 13zm7 7v-5h4v5h-4zm2-15.586 6 6V15l.001 5H16v-5c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v5H6v-9.586l6-6z"
                }
            }
        ]
    })(props);
}
function BiHorizontalCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m5.005 15.995 4-4-4-4v3h-3v2h3zm14-5v-3l-4 4 4 4v-3h3v-2h-2.072zm-8 7h2v3h-2zm0-5h2v3h-2zm0-5h2v3h-2zm0-5h2v3h-2z"
                }
            }
        ]
    })(props);
}
function BiHorizontalLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11 8-4 4 4 4v-3h8v-2h-8V8zM3 18h2v3H3zM3 13h2v3H3zM3 8h2v3H3zM3 3h2v3H3z"
                }
            }
        ]
    })(props);
}
function BiHorizontalRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 11H5v2h8v3l4-4-4-4v3zM19 3h2v3h-2zM19 8h2v3h-2zM19 13h2v3h-2zM19 18h2v3h-2z"
                }
            }
        ]
    })(props);
}
function BiHotel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "11.5",
                    "r": "2.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.205 7H12a1 1 0 0 0-1 1v7H4V6H2v14h2v-3h16v3h2v-8.205A4.8 4.8 0 0 0 17.205 7zM13 15V9h4.205A2.798 2.798 0 0 1 20 11.795V15h-7z"
                }
            }
        ]
    })(props);
}
function BiHourglass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.566 11.021A7.016 7.016 0 0 0 19 5V4h1V2H4v2h1v1a7.016 7.016 0 0 0 3.434 6.021c.354.208.566.545.566.9v.158c0 .354-.212.69-.566.9A7.016 7.016 0 0 0 5 19v1H4v2h16v-2h-1v-1a7.014 7.014 0 0 0-3.433-6.02c-.355-.21-.567-.547-.567-.901v-.158c0-.355.212-.692.566-.9zm-1.015 3.681A5.008 5.008 0 0 1 17 19v1H7v-1a5.01 5.01 0 0 1 2.45-4.299c.971-.573 1.55-1.554 1.55-2.622v-.158c0-1.069-.58-2.051-1.551-2.623A5.008 5.008 0 0 1 7 5V4h10v1c0 1.76-.938 3.406-2.449 4.298C13.58 9.87 13 10.852 13 11.921v.158c0 1.068.579 2.049 1.551 2.623z"
                }
            }
        ]
    })(props);
}
function BiIdCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.715 12c1.151 0 2-.849 2-2s-.849-2-2-2-2 .849-2 2 .848 2 2 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .841-2 1.875v12.25C2 19.159 2.897 20 4 20h16c1.103 0 2-.841 2-1.875V5.875C22 4.841 21.103 4 20 4zm0 14-16-.011V6l16 .011V18z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9h4v2h-4zm1 4h3v2h-3zm-1.57 2.536c0-1.374-1.676-2.786-3.715-2.786S6 14.162 6 15.536V16h7.43v-.464z"
                }
            }
        ]
    })(props);
}
function BiImageAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 5h13v7h2V5c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h8v-2H4V5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 11-3 4h11l-4-6-3 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 14h-2v3h-3v2h3v3h2v-3h3v-2h-3z"
                }
            }
        ]
    })(props);
}
function BiImageAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10 14-1-1-3 4h12l-5-7z"
                }
            }
        ]
    })(props);
}
function BiImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.499",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10.499 14-1.5-2-3 4h12l-4.5-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.999 4h-16c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-16 14V6h16l.002 12H3.999z"
                }
            }
        ]
    })(props);
}
function BiImages(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM8 16V4h12l.002 12H8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8H2v12c0 1.103.897 2 2 2h12v-2H4V8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 12-1-1-2 3h10l-4-6z"
                }
            }
        ]
    })(props);
}
function BiImport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 18 4-5h-3V2h-2v11H8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9h-4v2h4v9H5v-9h4V9H5c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2z"
                }
            }
        ]
    })(props);
}
function BiInfinite(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7c-2.094 0-3.611 1.567-5.001 3.346C10.609 8.567 9.093 7 7 7c-2.757 0-5 2.243-5 5a4.98 4.98 0 0 0 1.459 3.534A4.956 4.956 0 0 0 6.99 17h.012c2.089-.005 3.605-1.572 4.996-3.351C13.389 15.431 14.906 17 17 17c2.757 0 5-2.243 5-5s-2.243-5-5-5zM6.998 15l-.008 1v-1c-.799 0-1.55-.312-2.114-.878A3.004 3.004 0 0 1 7 9c1.33 0 2.56 1.438 3.746 2.998C9.558 13.557 8.328 14.997 6.998 15zM17 15c-1.33 0-2.561-1.44-3.749-3.002C14.438 10.438 15.668 9 17 9c1.654 0 3 1.346 3 3s-1.346 3-3 3z"
                }
            }
        ]
    })(props);
}
function BiInfoCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11h2v6h-2zm0-4h2v2h-2z"
                }
            }
        ]
    })(props);
}
function BiInfoSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-1 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h2v2h-2zm0 4h2v6h-2z"
                }
            }
        ]
    })(props);
}
function BiInjection(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.84 7.4 22.25 6 18 1.75l-1.4 1.41L18 4.58 16.6 6l-2.13-2.13-1.41-1.42-1.41 1.42.7.71L3 13.92a2 2 0 0 0-.3 2.45L4 18.56l-2.25 2.28 1.41 1.41L5.44 20l2.19 1.31a2 2 0 0 0 1 .28 2 2 0 0 0 1.45-.59l9.34-9.34.71.7 1.42-1.41-1.42-1.42L18 7.4 19.42 6zM18 10.23l-9.34 9.35L6 18l-1.58-2.66.86-.87 2.83 2.83 1.42-1.41-2.83-2.83 1.41-1.41 2.83 2.82 1.41-1.41-2.83-2.83 1.42-1.41 2.83 2.83 1.41-1.42-2.83-2.83L13.77 6z"
                }
            }
        ]
    })(props);
}
function BiIntersect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16h3v3c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2h-3V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2zm9.001-2L14 10h.001v4zM19 10l.001 9H10v-3h4c1.103 0 2-.897 2-2v-4h3zM5 5h9v3h-4c-1.103 0-2 .897-2 2v4H5V5z"
                }
            }
        ]
    })(props);
}
function BiItalic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7V4H9v3h2.868L9.012 17H5v3h10v-3h-2.868l2.856-10z"
                }
            }
        ]
    })(props);
}
function BiJoystickAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "11",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9H8v2H6v2h2v2h2v-2h2v-2h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5H9a7 7 0 0 0-7 7 7 7 0 0 0 7 7h6a7 7 0 0 0 7-7 7 7 0 0 0-7-7zm0 12H9A5 5 0 1 1 9 7h6a5 5 0 1 1 0 10z"
                }
            }
        ]
    })(props);
}
function BiJoystickButton(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7h-3V4c0-1.103-.897-2-2-2H9c-1.103 0-2 .897-2 2v3H4c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2h3v3c0 1.103.897 2 2 2h6c1.103 0 2-.897 2-2v-3h3c1.103 0 2-.897 2-2V9c0-1.103-.897-2-2-2zm0 8h-5v4h.001v1H9v-5H4V9h5V4h6v5h5v6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14v-4l-3 2zm8 0 3-2-3-2zm-6-6h4l-2-3zm2 11 2-3h-4z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function BiJoystick(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 8.65A5 5 0 0 0 17 4H7a5 5 0 0 0-5 4.74A2 2 0 0 0 2 9v7.5A3.48 3.48 0 0 0 5.5 20c1.43 0 2.32-1.06 3.19-2.09.32-.37.65-.76 1-1.1a4.81 4.81 0 0 1 1.54-.75 6.61 6.61 0 0 1 1.54 0 4.81 4.81 0 0 1 1.54.75c.35.34.68.73 1 1.1.87 1 1.76 2.09 3.19 2.09a3.48 3.48 0 0 0 3.5-3.5V9a2.09 2.09 0 0 0 0-.26zm-2 7.85a1.5 1.5 0 0 1-1.5 1.5c-.5 0-1-.64-1.66-1.38-.34-.39-.72-.85-1.15-1.26a6.68 6.68 0 0 0-2.46-1.25 6.93 6.93 0 0 0-2.46 0 6.68 6.68 0 0 0-2.46 1.25c-.43.41-.81.87-1.15 1.26C6.54 17.36 6 18 5.5 18A1.5 1.5 0 0 1 4 16.5V9a.77.77 0 0 0 0-.15A3 3 0 0 1 7 6h10a3 3 0 0 1 3 2.72v.12A.86.86 0 0 0 20 9z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "12",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "10",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "8",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14",
                    "cy": "10",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "10",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function BiKey(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 17a5.007 5.007 0 0 0 4.898-4H14v2h2v-2h2v3h2v-3h1v-2h-9.102A5.007 5.007 0 0 0 7 7c-2.757 0-5 2.243-5 5s2.243 5 5 5zm0-8c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3z"
                }
            }
        ]
    })(props);
}
function BiKnife(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.66 3.6a3 3 0 0 0-4.24 0l-.71.71-7.07 7.07 2.12 2.12-6.36 6.36 1.41 1.42L19.66 6.43c1.1-1.1 1.1-1.73.71-2.12z"
                }
            }
        ]
    })(props);
}
function BiLabel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.813 4.419A.997.997 0 0 0 16 4H3a1 1 0 0 0-.813 1.581L6.771 12l-4.585 6.419A1 1 0 0 0 3 20h13a.997.997 0 0 0 .813-.419l5-7a.997.997 0 0 0 0-1.162l-5-7zM15.485 18H4.943l3.87-5.419a.997.997 0 0 0 0-1.162L4.943 6h10.542l4.286 6-4.286 6z"
                }
            }
        ]
    })(props);
}
function BiLandscape(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 20h18a1 1 0 0 0 .864-1.504l-7-12c-.359-.615-1.369-.613-1.729 0L9.866 12.1l-1.02-1.632A.998.998 0 0 0 8 10h-.001a1 1 0 0 0-.847.47l-5 8A1 1 0 0 0 3 20zM14 8.985 19.259 18h-5.704l-2.486-3.987L14 8.985zm-5.999 3.9L11.197 18H4.805l3.196-5.115zM6 8c1.654 0 3-1.346 3-3S7.654 2 6 2 3 3.346 3 5s1.346 3 3 3zm0-4a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                }
            }
        ]
    })(props);
}
function BiLaptop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17.722c.595-.347 1-.985 1-1.722V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v11c0 .736.405 1.375 1 1.722V18H2v2h20v-2h-2v-.278zM5 16V5h14l.002 11H5z"
                }
            }
        ]
    })(props);
}
function BiLastPage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.707 17.707 13.414 12 7.707 6.293 6.293 7.707 10.586 12l-4.293 4.293zM15 6h2v12h-2z"
                }
            }
        ]
    })(props);
}
function BiLaugh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18c4 0 5-4 5-4H7s1 4 5 4zm5.555-9.168-1.109-1.664-3 2a1.001 1.001 0 0 0 .108 1.727l4 2 .895-1.789-2.459-1.229 1.565-1.045zm-6.557 1.23a1 1 0 0 0-.443-.894l-3-2-1.11 1.664 1.566 1.044-2.459 1.229.895 1.789 4-2a.998.998 0 0 0 .551-.832z"
                }
            }
        ]
    })(props);
}
function BiLayerMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.513 12.833 9.022 5.04a.995.995 0 0 0 .973.001l8.978-5a1 1 0 0 0-.002-1.749l-9.022-5a1 1 0 0 0-.968-.001l-8.978 4.96a1 1 0 0 0-.003 1.749zm9.464-4.69 6.964 3.859-6.917 3.853-6.964-3.89 6.917-3.822z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3.485 15.126-.971 1.748 9 5a1 1 0 0 0 .971 0l9-5-.971-1.748L12 19.856l-8.515-4.73zM16 4h6v2h-6z"
                }
            }
        ]
    })(props);
}
function BiLayerPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.484 11.125-9.022-5a1 1 0 0 0-.968-.001l-8.978 4.96a1 1 0 0 0-.003 1.749l9.022 5.04a.995.995 0 0 0 .973.001l8.978-5a1 1 0 0 0-.002-1.749zm-9.461 4.73-6.964-3.89 6.917-3.822 6.964 3.859-6.917 3.853z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22a.994.994 0 0 0 .485-.126l9-5-.971-1.748L12 19.856l-8.515-4.73-.971 1.748 9 5A1 1 0 0 0 12 22zm8-20h-2v2h-2v2h2v2h2V6h2V4h-2z"
                }
            }
        ]
    })(props);
}
function BiLayer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7.999a1 1 0 0 0-.516-.874l-9.022-5a1.003 1.003 0 0 0-.968 0l-8.978 4.96a1 1 0 0 0-.003 1.748l9.022 5.04a.995.995 0 0 0 .973.001l8.978-5A1 1 0 0 0 22 7.999zm-9.977 3.855L5.06 7.965l6.917-3.822 6.964 3.859-6.918 3.852z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.515 11.126 12 15.856l-8.515-4.73-.971 1.748 9 5a1 1 0 0 0 .971 0l9-5-.97-1.748z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.515 15.126 12 19.856l-8.515-4.73-.971 1.748 9 5a1 1 0 0 0 .971 0l9-5-.97-1.748z"
                }
            }
        ]
    })(props);
}
function BiLayout(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm0 2 .001 4H5V5h14zM5 11h8v8H5v-8zm10 8v-8h4.001l.001 8H15z"
                }
            }
        ]
    })(props);
}
function BiLeaf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.88 2.15-1.2.4a13.84 13.84 0 0 1-6.41.64 11.87 11.87 0 0 0-6.68.9A7.23 7.23 0 0 0 3.3 9.5a8.65 8.65 0 0 0 1.47 6.6c-.06.21-.12.42-.17.63A22.6 22.6 0 0 0 4 22h2a30.69 30.69 0 0 1 .59-4.32 9.25 9.25 0 0 0 4.52 1.11 11 11 0 0 0 4.28-.87C23 14.67 22 3.86 22 3.41zm-7.27 13.93c-2.61 1.11-5.73.92-7.48-.45a13.79 13.79 0 0 1 1.21-2.84A10.17 10.17 0 0 1 9.73 11a9 9 0 0 1 1.81-1.42A12 12 0 0 1 16 8V7a11.43 11.43 0 0 0-5.26 1.08 10.28 10.28 0 0 0-4.12 3.65 15.07 15.07 0 0 0-1 1.87 7 7 0 0 1-.38-3.73 5.24 5.24 0 0 1 3.14-4 8.93 8.93 0 0 1 3.82-.84c.62 0 1.23.06 1.87.11a16.2 16.2 0 0 0 6-.35C20 7.55 19.5 14 14.61 16.08z"
                }
            }
        ]
    })(props);
}
function BiLeftArrowAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.707 17.293 8.414 13H18v-2H8.414l4.293-4.293-1.414-1.414L4.586 12l6.707 6.707z"
                }
            }
        ]
    })(props);
}
function BiLeftArrowCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.999 1.993C6.486 1.994 2 6.48 1.999 11.994c0 5.514 4.486 10 10.001 10 5.514-.001 10-4.487 10-10 0-5.514-4.486-10-10.001-10.001zM12 19.994c-4.412 0-8.001-3.589-8.001-8 .001-4.411 3.59-8 8-8.001C16.411 3.994 20 7.583 20 11.994c0 4.41-3.589 7.999-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12.012 7.989-4.005 4.005 4.005 4.004v-3.004h3.994v-2h-3.994z"
                }
            }
        ]
    })(props);
}
function BiLeftArrow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.464 2.114a.998.998 0 0 0-1.033.063l-13 9a1.003 1.003 0 0 0 0 1.645l13 9A1 1 0 0 0 19 21V3a1 1 0 0 0-.536-.886zM17 19.091 6.757 12 17 4.909v14.182z"
                }
            }
        ]
    })(props);
}
function BiLeftDownArrowCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.006 2.007A9.93 9.93 0 0 0 4.935 4.93c-3.898 3.898-3.898 10.242 0 14.142 1.885 1.885 4.396 2.923 7.071 2.923s5.187-1.038 7.071-2.923c3.898-3.899 3.898-10.243 0-14.142a9.931 9.931 0 0 0-7.071-2.923zm5.657 15.65c-1.507 1.507-3.516 2.337-5.657 2.337s-4.15-.83-5.657-2.337c-3.118-3.119-3.118-8.194 0-11.313 1.507-1.507 3.517-2.337 5.657-2.337s4.15.83 5.657 2.337c3.118 3.119 3.118 8.194 0 11.313z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14.346 8.247-3.215 3.215-2.125-2.125V15h5.663l-2.124-2.124 3.215-3.215z"
                }
            }
        ]
    })(props);
}
function BiLeftIndent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7h10v2H4zm0-4h16v2H4zm0 8h10v2H4zm0 4h10v2H4zm0 4h16v2H4zm16-3V8l-4 4z"
                }
            }
        ]
    })(props);
}
function BiLeftTopArrowCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.993 2.007a9.928 9.928 0 0 0-7.071 2.922c-3.899 3.899-3.899 10.243 0 14.143a9.931 9.931 0 0 0 7.071 2.923 9.928 9.928 0 0 0 7.071-2.923c3.899-3.899 3.899-10.243 0-14.143a9.927 9.927 0 0 0-7.071-2.922zm5.657 15.65a7.945 7.945 0 0 1-5.657 2.337c-2.141 0-4.15-.83-5.657-2.337-3.119-3.119-3.119-8.195 0-11.314a7.946 7.946 0 0 1 5.657-2.336c2.142 0 4.15.829 5.657 2.336 3.12 3.119 3.12 8.195 0 11.314z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.657 9H8.993v5.663l2.125-2.124 3.215 3.214 1.414-1.414-3.215-3.214z"
                }
            }
        ]
    })(props);
}
function BiLemon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22a9.83 9.83 0 0 1-3.26-.55 2.23 2.23 0 0 0-1.7.19 3.51 3.51 0 0 1-2.47.24 3.55 3.55 0 0 1-2.45-2.45A3.51 3.51 0 0 1 2.36 17a2.23 2.23 0 0 0 .19-1.7 10.07 10.07 0 0 1 0-6.53 9.87 9.87 0 0 1 6.18-6.23 10.07 10.07 0 0 1 6.53 0A2.23 2.23 0 0 0 17 2.36a3.51 3.51 0 0 1 2.47-.24 3.55 3.55 0 0 1 2.45 2.45A3.51 3.51 0 0 1 21.64 7a2.23 2.23 0 0 0-.19 1.7 10.07 10.07 0 0 1 0 6.53 9.87 9.87 0 0 1-6.19 6.19A10.33 10.33 0 0 1 12 22zm-3.84-2.64a3.91 3.91 0 0 1 1.23.2 8 8 0 0 0 5.24 0 7.84 7.84 0 0 0 4.94-4.93 8 8 0 0 0 0-5.24 4.19 4.19 0 0 1 .29-3.23 1.53 1.53 0 0 0 .09-1.08 1.49 1.49 0 0 0-1-1 1.53 1.53 0 0 0-1.08.09 4.19 4.19 0 0 1-3.23.29 8 8 0 0 0-5.24 0 7.84 7.84 0 0 0-4.97 4.91 8 8 0 0 0 0 5.24 4.19 4.19 0 0 1-.29 3.23 1.53 1.53 0 0 0-.09 1.08 1.49 1.49 0 0 0 1 1 1.53 1.53 0 0 0 1.08-.09 4.47 4.47 0 0 1 2.03-.47z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12H6a6 6 0 0 1 6-6v2a4 4 0 0 0-4 4z"
                }
            }
        ]
    })(props);
}
function BiLibrary(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 3h2v18H7zM4 3h2v18H4zm6 0h2v18h-2zm9.062 17.792-6.223-16.89 1.877-.692 6.223 16.89z"
                }
            }
        ]
    })(props);
}
function BiLike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8h-5.612l1.123-3.367c.202-.608.1-1.282-.275-1.802S14.253 2 13.612 2H12c-.297 0-.578.132-.769.36L6.531 8H4c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h13.307a2.01 2.01 0 0 0 1.873-1.298l2.757-7.351A1 1 0 0 0 22 12v-2c0-1.103-.897-2-2-2zM4 10h2v9H4v-9zm16 1.819L17.307 19H8V9.362L12.468 4h1.146l-1.562 4.683A.998.998 0 0 0 13 10h7v1.819z"
                }
            }
        ]
    })(props);
}
function BiLineChartDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3H3v18h18v-2H5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 12.586 8.707 8.293 7.293 9.707 13 15.414l3-3 4.293 4.293 1.414-1.414L16 9.586z"
                }
            }
        ]
    })(props);
}
function BiLineChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v17a1 1 0 0 0 1 1h17v-2H5V3H3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.293 14.707a.999.999 0 0 0 1.414 0l5-5-1.414-1.414L16 12.586l-2.293-2.293a.999.999 0 0 0-1.414 0l-5 5 1.414 1.414L13 12.414l2.293 2.293z"
                }
            }
        ]
    })(props);
}
function BiLinkAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.222 19.778a4.983 4.983 0 0 0 3.535 1.462 4.986 4.986 0 0 0 3.536-1.462l2.828-2.829-1.414-1.414-2.828 2.829a3.007 3.007 0 0 1-4.243 0 3.005 3.005 0 0 1 0-4.243l2.829-2.828-1.414-1.414-2.829 2.828a5.006 5.006 0 0 0 0 7.071zm15.556-8.485a5.008 5.008 0 0 0 0-7.071 5.006 5.006 0 0 0-7.071 0L9.879 7.051l1.414 1.414 2.828-2.829a3.007 3.007 0 0 1 4.243 0 3.005 3.005 0 0 1 0 4.243l-2.829 2.828 1.414 1.414 2.829-2.828z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8.464 16.95-1.415-1.414 8.487-8.486 1.414 1.415z"
                }
            }
        ]
    })(props);
}
function BiLinkExternal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m13 3 3.293 3.293-7 7 1.414 1.414 7-7L21 11V3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19H5V5h7l-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-5l-2-2v7z"
                }
            }
        ]
    })(props);
}
function BiLink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.465 11.293c1.133-1.133 3.109-1.133 4.242 0l.707.707 1.414-1.414-.707-.707c-.943-.944-2.199-1.465-3.535-1.465s-2.592.521-3.535 1.465L4.929 12a5.008 5.008 0 0 0 0 7.071 4.983 4.983 0 0 0 3.535 1.462A4.982 4.982 0 0 0 12 19.071l.707-.707-1.414-1.414-.707.707a3.007 3.007 0 0 1-4.243 0 3.005 3.005 0 0 1 0-4.243l2.122-2.121z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 4.929-.707.707 1.414 1.414.707-.707a3.007 3.007 0 0 1 4.243 0 3.005 3.005 0 0 1 0 4.243l-2.122 2.121c-1.133 1.133-3.109 1.133-4.242 0L10.586 12l-1.414 1.414.707.707c.943.944 2.199 1.465 3.535 1.465s2.592-.521 3.535-1.465L19.071 12a5.008 5.008 0 0 0 0-7.071 5.006 5.006 0 0 0-7.071 0z"
                }
            }
        ]
    })(props);
}
function BiLira(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21h2c4.411 0 8-4.038 8-9h-2c0 3.86-2.691 7-6 7v-7.358l6-1.385V8.204l-6 1.385V7.642l6-1.385V4.204l-6 1.385V3H9v3.05l-3 .693v2.053l3-.692v1.947l-3 .692v2.053l3-.692V21z"
                }
            }
        ]
    })(props);
}
function BiListCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7h11v2H4zm0 4h11v2H4zm0 4h7v2H4zm15.299-2.708-4.3 4.291-1.292-1.291-1.414 1.415 2.706 2.704 5.712-5.703z"
                }
            }
        ]
    })(props);
}
function BiListMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.063 15H13v2h9v-2zM4 7h11v2H4zm0 4h11v2H4zm0 4h7v2H4z"
                }
            }
        ]
    })(props);
}
function BiListOl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.282 12.064c-.428.328-.72.609-.875.851-.155.24-.249.498-.279.768h2.679v-.748H5.413c.081-.081.152-.151.212-.201.062-.05.182-.142.361-.27.303-.218.511-.42.626-.604.116-.186.173-.375.173-.578a.898.898 0 0 0-.151-.512.892.892 0 0 0-.412-.341c-.174-.076-.419-.111-.733-.111-.3 0-.537.038-.706.114a.889.889 0 0 0-.396.338c-.094.143-.159.346-.194.604l.894.076c.025-.188.074-.317.147-.394a.375.375 0 0 1 .279-.108c.11 0 .2.035.272.108a.344.344 0 0 1 .108.258.55.55 0 0 1-.108.297c-.074.102-.241.254-.503.453zm.055 6.386a.398.398 0 0 1-.282-.105c-.074-.07-.128-.195-.162-.378L4 18.085c.059.204.142.372.251.506.109.133.248.235.417.306.168.069.399.103.692.103.3 0 .541-.047.725-.14a1 1 0 0 0 .424-.403c.098-.175.146-.354.146-.544a.823.823 0 0 0-.088-.393.708.708 0 0 0-.249-.261 1.015 1.015 0 0 0-.286-.11.943.943 0 0 0 .345-.299.673.673 0 0 0 .113-.383.747.747 0 0 0-.281-.596c-.187-.159-.49-.238-.909-.238-.365 0-.648.072-.847.219-.2.143-.334.353-.404.626l.844.151c.023-.162.067-.274.133-.338s.151-.098.257-.098a.33.33 0 0 1 .241.089c.059.06.087.139.087.238 0 .104-.038.193-.117.27s-.177.112-.293.112a.907.907 0 0 1-.116-.011l-.045.649a1.13 1.13 0 0 1 .289-.056c.132 0 .237.041.313.126.077.082.115.199.115.352 0 .146-.04.266-.119.354a.394.394 0 0 1-.301.134zm.948-10.083V5h-.739a1.47 1.47 0 0 1-.394.523c-.168.142-.404.262-.708.365v.754a2.595 2.595 0 0 0 .937-.48v2.206h.904zM9 6h11v2H9zm0 5h11v2H9zm0 5h11v2H9z"
                }
            }
        ]
    })(props);
}
function BiListPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 15v-3h-2v3h-3v2h3v3h2v-3h3v-2h-.937zM4 7h11v2H4zm0 4h11v2H4zm0 4h8v2H4z"
                }
            }
        ]
    })(props);
}
function BiListUl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h2v2H4zm0 5h2v2H4zm0 5h2v2H4zm16-8V6H8.023v2H18.8zM8 11h12v2H8zm0 5h12v2H8z"
                }
            }
        ]
    })(props);
}
function BiLoaderAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V2C6.579 2 2 6.58 2 12c0 5.421 4.579 10 10 10z"
                }
            }
        ]
    })(props);
}
function BiLoaderCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "20",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.343",
                    "cy": "17.657",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.657",
                    "cy": "6.343",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4",
                    "cy": "12",
                    "r": "2.001"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "20",
                    "cy": "12",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.343",
                    "cy": "6.344",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.657",
                    "cy": "17.658",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function BiLoader(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 11h5v2H2zm15 0h5v2h-5zm-6 6h2v5h-2zm0-15h2v5h-2zM4.222 5.636l1.414-1.414 3.536 3.536-1.414 1.414zm15.556 12.728-1.414 1.414-3.536-3.536 1.414-1.414zm-12.02-3.536 1.414 1.414-3.536 3.536-1.414-1.414zm7.07-7.071 3.536-3.535 1.414 1.415-3.536 3.535z"
                }
            }
        ]
    })(props);
}
function BiLocationPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.42 21.815a1.004 1.004 0 0 0 1.16 0C12.884 21.598 20.029 16.44 20 10c0-4.411-3.589-8-8-8S4 5.589 4 9.996c-.029 6.444 7.116 11.602 7.42 11.819zM12 4c3.309 0 6 2.691 6 6.004.021 4.438-4.388 8.423-6 9.731-1.611-1.308-6.021-5.293-6-9.735 0-3.309 2.691-6 6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14h2v-3h3V9h-3V6h-2v3H8v2h3z"
                }
            }
        ]
    })(props);
}
function BiLockAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C9.243 2 7 4.243 7 7v3H6c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-8c0-1.103-.897-2-2-2h-1V7c0-2.757-2.243-5-5-5zm6 10 .002 8H6v-8h12zm-9-2V7c0-1.654 1.346-3 3-3s3 1.346 3 3v3H9z"
                }
            }
        ]
    })(props);
}
function BiLockOpenAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 8V7c0-2.757-2.243-5-5-5S7 4.243 7 7v3H6c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-8c0-1.103-.897-2-2-2H9V7c0-1.654 1.346-3 3-3s3 1.346 3 3v1h2zm1 4 .002 8H6v-8h12z"
                }
            }
        ]
    })(props);
}
function BiLockOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c1.654 0 3 1.346 3 3h2c0-2.757-2.243-5-5-5S7 4.243 7 7v2H6c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2H9V7c0-1.654 1.346-3 3-3zm6.002 16H13v-2.278c.595-.347 1-.985 1-1.722 0-1.103-.897-2-2-2s-2 .897-2 2c0 .736.405 1.375 1 1.722V20H6v-9h12l.002 9z"
                }
            }
        ]
    })(props);
}
function BiLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C9.243 2 7 4.243 7 7v2H6c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2h-1V7c0-2.757-2.243-5-5-5zM9 7c0-1.654 1.346-3 3-3s3 1.346 3 3v2H9V7zm9.002 13H13v-2.278c.595-.347 1-.985 1-1.722 0-1.103-.897-2-2-2s-2 .897-2 2c0 .736.405 1.375 1 1.722V20H6v-9h12l.002 9z"
                }
            }
        ]
    })(props);
}
function BiLogInCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10.998 16 5-4-5-4v3h-9v2h9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.999 2.999a8.938 8.938 0 0 0-6.364 2.637L8.049 7.05c1.322-1.322 3.08-2.051 4.95-2.051s3.628.729 4.95 2.051S20 10.13 20 12s-.729 3.628-2.051 4.95-3.08 2.051-4.95 2.051-3.628-.729-4.95-2.051l-1.414 1.414c1.699 1.7 3.959 2.637 6.364 2.637s4.665-.937 6.364-2.637C21.063 16.665 22 14.405 22 12s-.937-4.665-2.637-6.364a8.938 8.938 0 0 0-6.364-2.637z"
                }
            }
        ]
    })(props);
}
function BiLogIn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m13 16 5-4-5-4v3H4v2h9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3h-9c-1.103 0-2 .897-2 2v4h2V5h9v14h-9v-4H9v4c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2z"
                }
            }
        ]
    })(props);
}
function BiLogOutCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2 12 5 4v-3h9v-2H7V8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.001 2.999a8.938 8.938 0 0 0-6.364 2.637L8.051 7.05c1.322-1.322 3.08-2.051 4.95-2.051s3.628.729 4.95 2.051 2.051 3.08 2.051 4.95-.729 3.628-2.051 4.95-3.08 2.051-4.95 2.051-3.628-.729-4.95-2.051l-1.414 1.414c1.699 1.7 3.959 2.637 6.364 2.637s4.665-.937 6.364-2.637c1.7-1.699 2.637-3.959 2.637-6.364s-.937-4.665-2.637-6.364a8.938 8.938 0 0 0-6.364-2.637z"
                }
            }
        ]
    })(props);
}
function BiLogOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 13v-2H7V8l-5 4 5 4v-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3h-9c-1.103 0-2 .897-2 2v4h2V5h9v14h-9v-4H9v4c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2z"
                }
            }
        ]
    })(props);
}
function BiLowVision(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4.998c-1.836 0-3.356.389-4.617.971L3.707 2.293 2.293 3.707l3.315 3.316c-2.613 1.952-3.543 4.618-3.557 4.66l-.105.316.105.316C2.073 12.382 4.367 19 12 19c1.835 0 3.354-.389 4.615-.971l3.678 3.678 1.414-1.414-3.317-3.317c2.614-1.952 3.545-4.618 3.559-4.66l.105-.316-.105-.316c-.022-.068-2.316-6.686-9.949-6.686zM4.074 12c.103-.236.274-.586.521-.989l5.867 5.867C6.249 16.23 4.523 13.035 4.074 12zm9.247 4.907-7.48-7.481a8.138 8.138 0 0 1 1.188-.982l8.055 8.054a8.835 8.835 0 0 1-1.763.409zm3.648-1.352-1.541-1.541c.354-.596.572-1.28.572-2.015 0-.474-.099-.924-.255-1.349A.983.983 0 0 1 15 11a1 1 0 0 1-1-1c0-.439.288-.802.682-.936A3.97 3.97 0 0 0 12 7.999c-.735 0-1.419.218-2.015.572l-1.07-1.07A9.292 9.292 0 0 1 12 6.998c5.351 0 7.425 3.847 7.926 5a8.573 8.573 0 0 1-2.957 3.557z"
                }
            }
        ]
    })(props);
}
function BiMagnet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-3c-1.103 0-2 .897-2 2v8c0 1.103-.897 2-2 2s-2-.897-2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v8c0 4.963 4.037 9 9 9s9-4.037 9-9V5c0-1.103-.897-2-2-2zm-3 2h3v3h-3V5zM5 5h3v3H5V5zm7 15c-3.859 0-7-3.141-7-7v-3h3v3c0 2.206 1.794 4 4 4s4-1.794 4-4v-3h3v3c0 3.859-3.141 7-7 7z"
                }
            }
        ]
    })(props);
}
function BiMailSend(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H6c-1.103 0-2 .897-2 2v5h2V8l6.4 4.8a1.001 1.001 0 0 0 1.2 0L20 8v9h-8v2h8c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-7 6.75L6.666 6h12.668L13 10.75z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12h7v2H2zm2 3h6v2H4zm3 3h4v2H7z"
                }
            }
        ]
    })(props);
}
function BiMaleFemale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "4",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 7H3a1 1 0 0 0-1 1v7h2v7h4v-7h2V8a1 1 0 0 0-1-1z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "4",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.21 7.73a1 1 0 0 0-1-.73h-4.5a1 1 0 0 0-1 .73L12 14h2l-1 4h2v4h4v-4h2l-1-4h2z"
                }
            }
        ]
    })(props);
}
function BiMaleSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11V4h-7l2.793 2.793-4.322 4.322A5.961 5.961 0 0 0 8 10c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6c0-1.294-.416-2.49-1.115-3.471l4.322-4.322L20 11zM8 20c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z"
                }
            }
        ]
    })(props);
}
function BiMale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7H9a1 1 0 0 0-1 1v7h2v7h4v-7h2V8a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function BiMapAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.447 6.105-6-3a1 1 0 0 0-.895 0L9 5.882 3.447 3.105A1 1 0 0 0 2 4v13c0 .379.214.725.553.895l6 3a1 1 0 0 0 .895 0L15 18.118l5.553 2.776a.992.992 0 0 0 .972-.043c.295-.183.475-.504.475-.851V7c0-.379-.214-.725-.553-.895zM10 7.618l4-2v10.764l-4 2V7.618zm-6-2 4 2v10.764l-4-2V5.618zm16 12.764-4-2V5.618l4 2v10.764z"
                }
            }
        ]
    })(props);
}
function BiMapPin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 17 1-2V9.858c1.721-.447 3-2 3-3.858 0-2.206-1.794-4-4-4S8 3.794 8 6c0 1.858 1.279 3.411 3 3.858V15l1 2zM10 6c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2-2-.897-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16.267 10.563-.533 1.928C18.325 13.207 20 14.584 20 16c0 1.892-3.285 4-8 4s-8-2.108-8-4c0-1.416 1.675-2.793 4.267-3.51l-.533-1.928C4.197 11.54 2 13.623 2 16c0 3.364 4.393 6 10 6s10-2.636 10-6c0-2.377-2.197-4.46-5.733-5.437z"
                }
            }
        ]
    })(props);
}
function BiMap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.42 21.814a.998.998 0 0 0 1.16 0C12.884 21.599 20.029 16.44 20 10c0-4.411-3.589-8-8-8S4 5.589 4 9.995c-.029 6.445 7.116 11.604 7.42 11.819zM12 4c3.309 0 6 2.691 6 6.005.021 4.438-4.388 8.423-6 9.73-1.611-1.308-6.021-5.294-6-9.735 0-3.309 2.691-6 6-6z"
                }
            }
        ]
    })(props);
}
function BiMask(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6H5C3.346 6 2 7.346 2 9v5c0 2.206 1.794 4 4 4h1.637c1.166 0 2.28-.557 2.981-1.491.66-.879 2.104-.88 2.764.001A3.744 3.744 0 0 0 16.363 18H18c2.206 0 4-1.794 4-4V9c0-1.654-1.346-3-3-3zm1 8c0 1.103-.897 2-2 2h-1.637c-.54 0-1.057-.259-1.382-.69-.71-.948-1.797-1.492-2.981-1.492s-2.271.544-2.981 1.491A1.741 1.741 0 0 1 7.637 16H6c-1.103 0-2-.897-2-2V9c0-.551.448-1 1-1h14c.552 0 1 .449 1 1v5z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "7.5",
                    "cy": "11.5",
                    "rx": "2.5",
                    "ry": "1.5"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "16.5",
                    "cy": "11.5",
                    "rx": "2.5",
                    "ry": "1.5"
                }
            }
        ]
    })(props);
}
function BiMath(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2H5v3H2v2h3v3h2V7h3V5H7V2zm7 3h8v2h-8zm0 10h8v2h-8zm0 4h8v2h-8zm-5.71-4.71L6 16.59l-2.29-2.3-1.42 1.42L4.59 18l-2.3 2.29 1.42 1.42L6 19.41l2.29 2.3 1.42-1.42L7.41 18l2.3-2.29-1.42-1.42z"
                }
            }
        ]
    })(props);
}
function BiMedal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c3.859 0 7-3.141 7-7s-3.141-7-7-7c-3.86 0-7 3.141-7 7s3.14 7 7 7zm0-12c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5zm-1-8H7v5.518a8.957 8.957 0 0 1 4-1.459V2zm6 0h-4v4.059a8.957 8.957 0 0 1 4 1.459V2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10.019 15.811-.468 2.726L12 17.25l2.449 1.287-.468-2.726 1.982-1.932-2.738-.398L12 11l-1.225 2.481-2.738.398z"
                }
            }
        ]
    })(props);
}
function BiMehAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10h4v2h-4zm-6.026 5H16v2H7.974zM6 10h4v2H6z"
                }
            }
        ]
    })(props);
}
function BiMehBlank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "10.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.493",
                    "cy": "10.493",
                    "r": "1.493"
                }
            }
        ]
    })(props);
}
function BiMeh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "10.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.493",
                    "cy": "10.493",
                    "r": "1.493"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.974 15H16v2H7.974z"
                }
            }
        ]
    })(props);
}
function BiMemoryCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V8a.997.997 0 0 0-.293-.707l-5-5A.996.996 0 0 0 14 2H6c-1.103 0-2 .897-2 2zm14 4.414L18.001 20H6V4h7.586L18 8.414z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6h2v4H8zm4 0h2v4h-2z"
                }
            }
        ]
    })(props);
}
function BiMenuAltLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11h12v2H4zm0-5h16v2H4zm0 12h7.235v-2H4z"
                }
            }
        ]
    })(props);
}
function BiMenuAltRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h16v2H4zm4 5h12v2H8zm5 5h7v2h-7z"
                }
            }
        ]
    })(props);
}
function BiMenu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z"
                }
            }
        ]
    })(props);
}
function BiMerge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19v-9a2 2 0 0 0-2-2h-1v8a2 2 0 0 1-2 2H8v1a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2z"
                }
            }
        ]
    })(props);
}
function BiMessageAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3v3.767L13.277 18H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-7.277L9 18.233V16H4V4h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14h2v-3h3V9h-3V6h-2v3H8v2h3z"
                }
            }
        ]
    })(props);
}
function BiMessageAltAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16c0 1.103.897 2 2 2h3.586L12 21.414 15.414 18H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v12zM5 4h14v12h-4.414L12 18.586 9.414 16H5V4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14h2v-3h3V9h-3V6h-2v3H8v2h3z"
                }
            }
        ]
    })(props);
}
function BiMessageAltCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4v12c0 1.103.897 2 2 2h3.586L12 21.414 15.414 18H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2zm2 0h14v12h-4.414L12 18.586 9.414 16H5V4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17.207 7.207-1.414-1.414L11 10.586 8.707 8.293 7.293 9.707 11 13.414z"
                }
            }
        ]
    })(props);
}
function BiMessageAltDetail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.586L12 21.414 15.414 18H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5zm14 14h-4.414L12 18.586 9.414 16H5V4h14v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h10v2H7zm0 4h7v2H7z"
                }
            }
        ]
    })(props);
}
function BiMessageAltDots(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.586L12 21.414 15.414 18H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-4.414L12 18.586 9.414 16H5V4h14v12z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "10",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "10",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function BiMessageAltEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.586 18 12 21.414 15.414 18H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.586zM5 4h14v12h-4.414L12 18.586 9.414 16H5V4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12.479 7.219-4.977 4.969v1.799h1.8l4.975-4.969zm2.219-2.22 1.8 1.8-1.37 1.37-1.8-1.799z"
                }
            }
        ]
    })(props);
}
function BiMessageAltError(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.586L12 21.414 15.414 18H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5zm14 14h-4.414L12 18.586 9.414 16H5V4h14v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6h2v6h-2zm0 7h2v2h-2z"
                }
            }
        ]
    })(props);
}
function BiMessageAltMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.586 18 12 21.414 15.414 18H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.586zM5 4h14v12h-4.414L12 18.586 9.414 16H5V4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9h8v2H8z"
                }
            }
        ]
    })(props);
}
function BiMessageAltX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.586 18 12 21.414 15.414 18H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.586zM5 4h14v12h-4.414L12 18.586 9.414 16H5V4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.707 13.707 12 11.414l2.293 2.293 1.414-1.414L13.414 10l2.293-2.293-1.414-1.414L12 8.586 9.707 6.293 8.293 7.707 10.586 10l-2.293 2.293z"
                }
            }
        ]
    })(props);
}
function BiMessageAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.586L12 21.414 15.414 18H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-4.414L12 18.586 9.414 16H5V4h14v12z"
                }
            }
        ]
    })(props);
}
function BiMessageCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3v3.767L13.277 18H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-7.277L9 18.233V16H4V4h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17.207 7.207-1.414-1.414L11 10.586 8.707 8.293 7.293 9.707 11 13.414z"
                }
            }
        ]
    })(props);
}
function BiMessageDetail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3v3.767L13.277 18H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-7.277L9 18.233V16H4V4h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h10v2H7zm0 4h7v2H7z"
                }
            }
        ]
    })(props);
}
function BiMessageDots(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3v3.766L13.277 18H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-7.277L9 18.234V16H4V4h16v12z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "10",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "10",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function BiMessageEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3v3.767L13.277 18H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-7.277L9 18.233V16H4V4h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m13.803 9.189-1.399-1.398-3.869 3.864v1.399h1.399zm.327-3.123 1.398 1.399-1.066 1.066-1.399-1.398z"
                }
            }
        ]
    })(props);
}
function BiMessageError(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3v3.767L13.277 18H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-7.277L9 18.233V16H4V4h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6h2v5h-2zm0 6h2v2h-2z"
                }
            }
        ]
    })(props);
}
function BiMessageMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3v3.767L13.277 18H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-7.277L9 18.233V16H4V4h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9h8v2H8z"
                }
            }
        ]
    })(props);
}
function BiMessageRoundedAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.898 5.515 5 6.934V22l5.34-4.005C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm0 14h-.333L9 18v-2.417l-.641-.247C5.67 14.301 4 12.256 4 10c0-3.309 3.589-6 8-6s8 2.691 8 6-3.589 6-8 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6h-2v3H8v2h3v3h2v-3h3V9h-3z"
                }
            }
        ]
    })(props);
}
function BiMessageRoundedCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.898 5.515 5 6.934V22l5.339-4.005C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm0 14h-.333L9 18v-2.417l-.641-.247C5.67 14.301 4 12.256 4 10c0-3.309 3.589-6 8-6s8 2.691 8 6-3.589 6-8 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11.586 8.707 9.293l-1.414 1.414L11 14.414l6.207-6.207-1.414-1.414z"
                }
            }
        ]
    })(props);
}
function BiMessageRoundedDetail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.898 5.515 5 6.934V22l5.34-4.005C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm0 14h-.333L9 18v-2.417l-.641-.247C5.67 14.301 4 12.256 4 10c0-3.309 3.589-6 8-6s8 2.691 8 6-3.589 6-8 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h10v2H7zm0 4h7v2H7z"
                }
            }
        ]
    })(props);
}
function BiMessageRoundedDots(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "9.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.897 5.515 5 6.934V22l5.34-4.004C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm0 14h-.333L9 18v-2.417l-.641-.247C5.671 14.301 4 12.256 4 10c0-3.309 3.589-6 8-6s8 2.691 8 6-3.589 6-8 6z"
                }
            }
        ]
    })(props);
}
function BiMessageRoundedEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.898 5.515 5 6.934V22l5.34-4.005C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm0 14h-.333L9 18v-2.417l-.641-.247C5.67 14.301 4 12.256 4 10c0-3.309 3.589-6 8-6s8 2.691 8 6-3.589 6-8 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.503 11.589v1.398h1.398l3.87-3.864-1.399-1.398zm5.927-3.125-1.398-1.398 1.067-1.067 1.398 1.398z"
                }
            }
        ]
    })(props);
}
function BiMessageRoundedError(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.898 5.515 5 6.934V22l5.34-4.005C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm0 14h-.333L9 18v-2.417l-.641-.247C5.67 14.301 4 12.256 4 10c0-3.309 3.589-6 8-6s8 2.691 8 6-3.589 6-8 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6h2v5h-2zm0 6h2v2h-2z"
                }
            }
        ]
    })(props);
}
function BiMessageRoundedMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.898 5.515 5 6.934V22l5.34-4.005C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm0 14h-.333L9 18v-2.417l-.641-.247C5.67 14.301 4 12.256 4 10c0-3.309 3.589-6 8-6s8 2.691 8 6-3.589 6-8 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9h8v2H8z"
                }
            }
        ]
    })(props);
}
function BiMessageRoundedX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.898 5.515 5 6.934V22l5.34-4.005C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm0 14h-.333L9 18v-2.417l-.641-.247C5.67 14.301 4 12.256 4 10c0-3.309 3.589-6 8-6s8 2.691 8 6-3.589 6-8 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.293 6.293 12 8.586 9.707 6.293 8.293 7.707 10.586 10l-2.293 2.293 1.414 1.414L12 11.414l2.293 2.293 1.414-1.414L13.414 10l2.293-2.293z"
                }
            }
        ]
    })(props);
}
function BiMessageRounded(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.898 5.516 5 6.934V22l5.34-4.005C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm0 14h-.333L9 18v-2.417l-.641-.247C5.67 14.301 4 12.256 4 10c0-3.309 3.589-6 8-6s8 2.691 8 6-3.589 6-8 6z"
                }
            }
        ]
    })(props);
}
function BiMessageSquareAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm4 14c0 2.206-1.794 4-4 4H4V8c0-2.206 1.794-4 4-4h8c2.206 0 4 1.794 4 4v8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4z"
                }
            }
        ]
    })(props);
}
function BiMessageSquareCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm4 14c0 2.206-1.794 4-4 4H4V8c0-2.206 1.794-4 4-4h8c2.206 0 4 1.794 4 4v8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11 13.586-2.293-2.293-1.414 1.414L11 16.414l6.207-6.207-1.414-1.414z"
                }
            }
        ]
    })(props);
}
function BiMessageSquareDetail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm4 14c0 2.206-1.794 4-4 4H4V8c0-2.206 1.794-4 4-4h8c2.206 0 4 1.794 4 4v8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9h10v2H7zm0 4h7v2H7z"
                }
            }
        ]
    })(props);
}
function BiMessageSquareDots(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v12a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm4 13c0 2.206-1.794 4-4 4H4V8c0-2.206 1.794-4 4-4h8c2.206 0 4 1.794 4 4v7z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9.5",
                    "cy": "11.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.5",
                    "cy": "11.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function BiMessageSquareEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm4 14c0 2.206-1.794 4-4 4H4V8c0-2.206 1.794-4 4-4h8c2.206 0 4 1.794 4 4v8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14.987v1.999h1.999l5.529-5.522-1.998-1.998zm8.47-4.465-1.998-2L14.995 7l2 1.999z"
                }
            }
        ]
    })(props);
}
function BiMessageSquareError(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm4 14c0 2.206-1.794 4-4 4H4V8c0-2.206 1.794-4 4-4h8c2.206 0 4 1.794 4 4v8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6h2v8h-2zm0 10h2v2h-2z"
                }
            }
        ]
    })(props);
}
function BiMessageSquareMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm4 14c0 2.206-1.794 4-4 4H4V8c0-2.206 1.794-4 4-4h8c2.206 0 4 1.794 4 4v8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11h8v2H8z"
                }
            }
        ]
    })(props);
}
function BiMessageSquareX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm4 14c0 2.206-1.794 4-4 4H4V8c0-2.206 1.794-4 4-4h8c2.206 0 4 1.794 4 4v8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.292 7.295 12 10.587 8.708 7.295 7.294 8.709l3.292 3.292-3.292 3.292 1.414 1.414L12 13.415l3.292 3.292 1.414-1.414-3.292-3.292 3.292-3.292z"
                }
            }
        ]
    })(props);
}
function BiMessageSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v12a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm4 13c0 2.206-1.794 4-4 4H4V8c0-2.206 1.794-4 4-4h8c2.206 0 4 1.794 4 4v7z"
                }
            }
        ]
    })(props);
}
function BiMessageX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3v3.767L13.277 18H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-7.277L9 18.233V16H4V4h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.707 13.707 12 11.414l2.293 2.293 1.414-1.414L13.414 10l2.293-2.293-1.414-1.414L12 8.586 9.707 6.293 8.293 7.707 10.586 10l-2.293 2.293z"
                }
            }
        ]
    })(props);
}
function BiMessage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3v3.767L13.277 18H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14h-7.277L9 18.233V16H4V4h16v12z"
                }
            }
        ]
    })(props);
}
function BiMeteor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 22c2.003 0 3.887-.78 5.313-2.207l6.904-7.096A1 1 0 0 0 21 11h-3.301l4.175-7.514a1.001 1.001 0 0 0-1.359-1.36l-7.11 3.95.576-2.879a1 1 0 0 0-1.629-.957L4.196 9.197c-2.924 2.924-2.924 7.682 0 10.606A7.452 7.452 0 0 0 9.5 22zM5.552 10.665l5.902-5.031-.248 1.24-.186.93v.001l-.424 2.119 7.83-4.35-3.3 5.94-.001.001L14.301 13h4.331l-5.243 5.389C12.35 19.428 10.969 20 9.5 20s-2.851-.572-3.89-1.611c-2.143-2.144-2.143-5.634-.058-7.724z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 18a3.492 3.492 0 0 0 1.484-6.659c.005.053.016.105.016.159a1.5 1.5 0 1 1-3 0c0-.054.011-.106.016-.159A3.492 3.492 0 0 0 9.5 18z"
                }
            }
        ]
    })(props);
}
function BiMicrochip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h8c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM8 20V4h8l.001 16H8zM3 7h2V5H3v.5H2v1h1zm18-2h-2v2h2v-.5h1v-1h-1zM3 11h2V9H3v.5H2v1h1zm18-2h-2v2h2v-.5h1v-1h-1zM3 15h2v-2H3v.5H2v1h1zm18-2h-2v2h2v-.5h1v-1h-1zM3 19h2v-2H3v.5H2v1h1zm18-2h-2v2h2v-.5h1v-1h-1z"
                }
            }
        ]
    })(props);
}
function BiMicrophoneOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.707 20.293-3.388-3.388A7.942 7.942 0 0 0 20 12.021h-2a5.95 5.95 0 0 1-1.109 3.456l-1.452-1.452c.348-.591.561-1.27.561-2.004v-6C16 3.804 14.215 2 12.021 2c-.07 0-.14.009-.209.025A4.005 4.005 0 0 0 8 6.021v.565L3.707 2.293 2.293 3.707l18 18 1.414-1.414zM10 6.021c0-1.103.897-2 2-2a.918.918 0 0 0 .164-.015C13.188 4.08 14 4.956 14 6.021v6c0 .172-.029.335-.071.494L10 8.586V6.021zm-4 6H4c0 4.072 3.06 7.436 7 7.931v2.069h2v-2.07a7.993 7.993 0 0 0 2.218-.611l-1.558-1.558a5.979 5.979 0 0 1-1.66.239c-3.309 0-6-2.692-6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.011 12.132a3.993 3.993 0 0 0 3.877 3.877l-3.877-3.877z"
                }
            }
        ]
    })(props);
}
function BiMicrophone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12V6c0-2.217-1.785-4.021-3.979-4.021a.933.933 0 0 0-.209.025A4.006 4.006 0 0 0 8 6v6c0 2.206 1.794 4 4 4s4-1.794 4-4zm-6 0V6c0-1.103.897-2 2-2a.89.89 0 0 0 .163-.015C13.188 4.06 14 4.935 14 6v6c0 1.103-.897 2-2 2s-2-.897-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12H4c0 4.072 3.061 7.436 7 7.931V22h2v-2.069c3.939-.495 7-3.858 7-7.931h-2c0 3.309-2.691 6-6 6s-6-2.691-6-6z"
                }
            }
        ]
    })(props);
}
function BiMinusBack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3H5c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h3v3c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2h-3V5c0-1.103-.897-2-2-2zM5 5h9l-.003 9H5V5z"
                }
            }
        ]
    })(props);
}
function BiMinusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11h10v2H7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            }
        ]
    })(props);
}
function BiMinusFront(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16h3v3c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2h-3V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2zm13.997 3H10v-9h9l-.003 9z"
                }
            }
        ]
    })(props);
}
function BiMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11h14v2H5z"
                }
            }
        ]
    })(props);
}
function BiMobileAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.75 2h-10c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm-10 18V4h10l.002 16H6.75z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.75",
                    "cy": "18",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function BiMobileLandscape(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zM7.001 7H19v10H7.001V7z"
                }
            }
        ]
    })(props);
}
function BiMobileVibration(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.535 2.808c-.756-.756-2.072-.756-2.828 0l-9.899 9.899a2.001 2.001 0 0 0 0 2.828l5.657 5.657c.378.378.88.586 1.414.586s1.036-.208 1.414-.586l9.899-9.899c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-5.657-5.657zm-5.656 16.97v1-1l-5.657-5.657 9.899-9.899 5.657 5.657-9.899 9.899z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "15",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15.707 21.707-1.414-1.414 6-6 1.414 1.415zM8.293 2.293l1.414 1.414-6 6-1.414-1.415z"
                }
            }
        ]
    })(props);
}
function BiMobile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2H7c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM7 16.999V5h10l.002 11.999H7z"
                }
            }
        ]
    })(props);
}
function BiMoneyWithdraw(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15c-1.84 0-2-.86-2-1H8c0 .92.66 2.55 3 2.92V18h2v-1.08c2-.34 3-1.63 3-2.92 0-1.12-.52-3-4-3-2 0-2-.63-2-1s.7-1 2-1 1.39.64 1.4 1h2A3 3 0 0 0 13 7.12V6h-2v1.09C9 7.42 8 8.71 8 10c0 1.12.52 3 4 3 2 0 2 .68 2 1s-.62 1-2 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2H2v2h2v17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4h2V2H5zm13 18H6V4h12z"
                }
            }
        ]
    })(props);
}
function BiMoney(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm-1 11a3 3 0 0 0-3 3H7a3 3 0 0 0-3-3V9a3 3 0 0 0 3-3h10a3 3 0 0 0 3 3v6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z"
                }
            }
        ]
    })(props);
}
function BiMoon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.742 13.045a8.088 8.088 0 0 1-2.077.271c-2.135 0-4.14-.83-5.646-2.336a8.025 8.025 0 0 1-2.064-7.723A1 1 0 0 0 9.73 2.034a10.014 10.014 0 0 0-4.489 2.582c-3.898 3.898-3.898 10.243 0 14.143a9.937 9.937 0 0 0 7.072 2.93 9.93 9.93 0 0 0 7.07-2.929 10.007 10.007 0 0 0 2.583-4.491 1.001 1.001 0 0 0-1.224-1.224zm-2.772 4.301a7.947 7.947 0 0 1-5.656 2.343 7.953 7.953 0 0 1-5.658-2.344c-3.118-3.119-3.118-8.195 0-11.314a7.923 7.923 0 0 1 2.06-1.483 10.027 10.027 0 0 0 2.89 7.848 9.972 9.972 0 0 0 7.848 2.891 8.036 8.036 0 0 1-1.484 2.059z"
                }
            }
        ]
    })(props);
}
function BiMouseAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 2h-2C7.691 2 5 4.691 5 8v8c0 3.309 2.691 6 6 6h2c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm-2 2v6H7V8c0-2.206 1.794-4 4-4zm6 12c0 2.206-1.794 4-4 4h-2c-2.206 0-4-1.794-4-4v-4h10v4zm-4-6V4c2.206 0 4 1.794 4 4v2h-4z"
                }
            }
        ]
    })(props);
}
function BiMouse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.975 22H12c3.859 0 7-3.14 7-7V9c0-3.841-3.127-6.974-6.981-7h-.06C8.119 2.022 5 5.157 5 9v6c0 3.86 3.129 7 6.975 7zM7 9a5.007 5.007 0 0 1 4.985-5C14.75 4.006 17 6.249 17 9v6c0 2.757-2.243 5-5 5h-.025C9.186 20 7 17.804 7 15V9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6h2v6h-2z"
                }
            }
        ]
    })(props);
}
function BiMoveHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 11H7V7l-5 5 5 5v-4h10v4l5-5-5-5z"
                }
            }
        ]
    })(props);
}
function BiMoveVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7 17 5 5 5-5h-4V7h4l-5-5-5 5h4v10z"
                }
            }
        ]
    })(props);
}
function BiMove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11h-5V6h3l-4-4-4 4h3v5H6V8l-4 4 4 4v-3h5v5H8l4 4 4-4h-3v-5h5v3l4-4-4-4z"
                }
            }
        ]
    })(props);
}
function BiMoviePlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm.001 6c-.001 0-.001 0 0 0h-.465l-2.667-4H20l.001 4zM9.536 9 6.869 5h2.596l2.667 4H9.536zm5 0-2.667-4h2.596l2.667 4h-2.596zM4 5h.465l2.667 4H4V5zm0 14v-8h16l.002 8H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10 18 5.5-3-5.5-3z"
                }
            }
        ]
    })(props);
}
function BiMovie(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm.001 6c-.001 0-.001 0 0 0h-.466l-2.667-4H20l.001 4zM9.535 9 6.868 5h2.597l2.667 4H9.535zm5 0-2.667-4h2.597l2.667 4h-2.597zM4 5h.465l2.667 4H4V5zm0 14v-8h16l.002 8H4z"
                }
            }
        ]
    })(props);
}
function BiMusic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19.684 5.821-9-3.272A1.998 1.998 0 0 0 8 4.428v6.129A3.953 3.953 0 0 0 6 10c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4V4.428L19 7.7v6.856A3.962 3.962 0 0 0 17 14c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4V7.7c0-.838-.529-1.594-1.316-1.879zM6 16c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm11 4c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z"
                }
            }
        ]
    })(props);
}
function BiNavigation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.002 9.63c-.023.411.207.794.581.966l7.504 3.442 3.442 7.503c.164.356.52.583.909.583l.057-.002a1 1 0 0 0 .894-.686l5.595-17.032c.117-.358.023-.753-.243-1.02s-.66-.358-1.02-.243L2.688 8.736a1 1 0 0 0-.686.894zm16.464-3.971-4.182 12.73-2.534-5.522a.998.998 0 0 0-.492-.492L5.734 9.841l12.732-4.182z"
                }
            }
        ]
    })(props);
}
function BiNetworkChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3c-1.654 0-3 1.346-3 3 0 .502.136.968.354 1.385l-1.116 1.302A3.976 3.976 0 0 0 13 8c-.739 0-1.425.216-2.02.566L9.566 7.152A3.449 3.449 0 0 0 10 5.5C10 3.57 8.43 2 6.5 2S3 3.57 3 5.5 4.57 9 6.5 9c.601 0 1.158-.166 1.652-.434L9.566 9.98A3.972 3.972 0 0 0 9 12c0 .997.38 1.899.985 2.601l-1.692 1.692.025.025A2.962 2.962 0 0 0 7 16c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3c0-.476-.121-.919-.318-1.318l.025.025 1.954-1.954c.421.15.867.247 1.339.247 2.206 0 4-1.794 4-4a3.96 3.96 0 0 0-.439-1.785l1.253-1.462c.364.158.764.247 1.186.247 1.654 0 3-1.346 3-3s-1.346-3-3-3zM7 20a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM5 5.5C5 4.673 5.673 4 6.5 4S8 4.673 8 5.5 7.327 7 6.5 7 5 6.327 5 5.5zm8 8.5c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm6-7a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                }
            }
        ]
    })(props);
}
function BiNews(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.875 3H4.125C2.953 3 2 3.897 2 5v14c0 1.103.953 2 2.125 2h15.75C21.047 21 22 20.103 22 19V5c0-1.103-.953-2-2.125-2zm0 16H4.125c-.057 0-.096-.016-.113-.016-.007 0-.011.002-.012.008L3.988 5.046c.007-.01.052-.046.137-.046h15.75c.079.001.122.028.125.008l.012 13.946c-.007.01-.052.046-.137.046z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7h6v6H6zm7 8H6v2h12v-2h-4zm1-4h4v2h-4zm0-4h4v2h-4z"
                }
            }
        ]
    })(props);
}
function BiNoEntry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10h10v4H7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            }
        ]
    })(props);
}
function BiNoSignal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16h2v5H3zm4-3h2v8H7zM21 3h-2v14.59l-2-2V7h-2v6.59l-2-2V10h-1.59l-7.7-7.71-1.42 1.42 18 18 1.42-1.42-.71-.7V3zm-6 18h1.88L15 19.12V21zm-4 0h2v-3.88l-2-2V21z"
                }
            }
        ]
    })(props);
}
function BiNote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h8a.996.996 0 0 0 .707-.293l7-7a.997.997 0 0 0 .196-.293c.014-.03.022-.061.033-.093a.991.991 0 0 0 .051-.259c.002-.021.013-.041.013-.062V5c0-1.103-.897-2-2-2zM5 5h14v7h-6a1 1 0 0 0-1 1v6H5V5zm9 12.586V14h3.586L14 17.586z"
                }
            }
        ]
    })(props);
}
function BiNotepad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-3V2h-2v2h-4V2H8v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM5 20V7h14V6l.002 14H5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9h10v2H7zm0 4h5v2H7z"
                }
            }
        ]
    })(props);
}
function BiNotificationOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.71 20.296-1.786-1.786c.045-.163.076-.332.076-.51v-7h-2v5.586L7.414 6H13V4H6c-.178 0-.347.031-.51.076l-1.78-1.78L2.296 3.71l18 18 1.414-1.414zM4 8.121V18c0 1.103.897 2 2 2h9.879l-2-2H6v-7.879l-2-2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "6",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function BiNotification(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "6",
                    "r": "3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 19H5V6h8c0-.712.153-1.387.422-2H5c-1.103 0-2 .897-2 2v13c0 1.103.897 2 2 2h13c1.103 0 2-.897 2-2v-8.422A4.962 4.962 0 0 1 18 11v8z"
                }
            }
        ]
    })(props);
}
function BiObjectsHorizontalCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 20h6v2h2v-2h6a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1h-6v-2h4a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-4V2h-2v2H7a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h4v2H5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1zM8 6h8v3H8zm-2 9h12v3H6z"
                }
            }
        ]
    })(props);
}
function BiObjectsHorizontalLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2h2v20H2zM21 13H7a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1zm-1 5H8v-3h12zM7 11h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1zm1-5h8v3H8z"
                }
            }
        ]
    })(props);
}
function BiObjectsHorizontalRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2h2v20h-2zM18 14a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1zm-2 4H4v-3h12zM7 11h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1zm1-5h8v3H8z"
                }
            }
        ]
    })(props);
}
function BiObjectsVerticalBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 20h20v2H2zM4 3v14a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1zm2 1h3v12H6zM13 17a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1zm2-9h3v8h-3z"
                }
            }
        ]
    })(props);
}
function BiObjectsVerticalCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v4h-2V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v6H2v2h2v6a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-6h2v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4h2v-2h-2zM9 18H6V6h3zm9-2h-3V8h3z"
                }
            }
        ]
    })(props);
}
function BiObjectsVerticalTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2h20v2H2zM11 21V7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1zm-2-1H6V8h3zM19 6h-5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zm-1 10h-3V8h3z"
                }
            }
        ]
    })(props);
}
function BiOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19v-9c0-1.103-.897-2-2-2h-3V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h3v3c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2zM5 14V5h9v3h-4c-1.103 0-2 .897-2 2v4H5zm9.001 0H10v-4h4.001v4zM10 16h4c1.103 0 2-.897 2-2v-4h3l.001 9H10v-3z"
                }
            }
        ]
    })(props);
}
function BiPackage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 8a.76.76 0 0 0 0-.21v-.08a.77.77 0 0 0-.07-.16.35.35 0 0 0-.05-.08l-.1-.13-.08-.06-.12-.09-9-5a1 1 0 0 0-1 0l-9 5-.09.07-.11.08a.41.41 0 0 0-.07.11.39.39 0 0 0-.08.1.59.59 0 0 0-.06.14.3.3 0 0 0 0 .1A.76.76 0 0 0 2 8v8a1 1 0 0 0 .52.87l9 5a.75.75 0 0 0 .13.06h.1a1.06 1.06 0 0 0 .5 0h.1l.14-.06 9-5A1 1 0 0 0 22 16V8zm-10 3.87L5.06 8l2.76-1.52 6.83 3.9zm0-7.72L18.94 8 16.7 9.25 9.87 5.34zM4 9.7l7 3.92v5.68l-7-3.89zm9 9.6v-5.68l3-1.68V15l2-1v-3.18l2-1.11v5.7z"
                }
            }
        ]
    })(props);
}
function BiPaintRoll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H7c-1.103 0-2 .897-2 2v3c0 1.103.897 2 2 2h11c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM7 7V4h11l.002 3H7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 15v-2c0-1.103-.897-2-2-2H4V5c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h7v2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function BiPaint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.061 22c1.523 0 2.84-.543 3.91-1.613 1.123-1.123 1.707-2.854 1.551-4.494l8.564-8.564a3.123 3.123 0 0 0-.002-4.414c-1.178-1.18-3.234-1.18-4.412 0l-8.884 8.884c-1.913.169-3.807 1.521-3.807 3.919 0 .303.021.588.042.86.08 1.031.109 1.418-1.471 2.208a1.001 1.001 0 0 0-.122 1.717C2.52 20.563 4.623 22 7.061 22c-.001 0-.001 0 0 0zM18.086 4.328a1.144 1.144 0 0 1 1.586.002 1.12 1.12 0 0 1 0 1.584L12 13.586 10.414 12l7.672-7.672zM6.018 16.423c-.018-.224-.037-.458-.037-.706 0-1.545 1.445-1.953 2.21-1.953.356 0 .699.073.964.206.945.475 1.26 1.293 1.357 1.896.177 1.09-.217 2.368-.956 3.107C8.865 19.664 8.049 20 7.061 20H7.06c-.75 0-1.479-.196-2.074-.427 1.082-.973 1.121-1.989 1.032-3.15z"
                }
            }
        ]
    })(props);
}
function BiPalette(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.4 2.096a10.08 10.08 0 0 0-8.937 3.331A10.054 10.054 0 0 0 2.096 13.4c.53 3.894 3.458 7.207 7.285 8.246a9.982 9.982 0 0 0 2.618.354l.142-.001a3.001 3.001 0 0 0 2.516-1.426 2.989 2.989 0 0 0 .153-2.879l-.199-.416a1.919 1.919 0 0 1 .094-1.912 2.004 2.004 0 0 1 2.576-.755l.412.197c.412.198.85.299 1.301.299A3.022 3.022 0 0 0 22 12.14a9.935 9.935 0 0 0-.353-2.76c-1.04-3.826-4.353-6.754-8.247-7.284zm5.158 10.909-.412-.197c-1.828-.878-4.07-.198-5.135 1.494-.738 1.176-.813 2.576-.204 3.842l.199.416a.983.983 0 0 1-.051.961.992.992 0 0 1-.844.479h-.112a8.061 8.061 0 0 1-2.095-.283c-3.063-.831-5.403-3.479-5.826-6.586-.321-2.355.352-4.623 1.893-6.389a8.002 8.002 0 0 1 7.16-2.664c3.107.423 5.755 2.764 6.586 5.826.198.73.293 1.474.282 2.207-.012.807-.845 1.183-1.441.894z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "10.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "7.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.5",
                    "cy": "7.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function BiPaperPlane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.56,3.34a1,1,0,0,0-1-.08l-17,8a1,1,0,0,0-.57.92,1,1,0,0,0,.6.9L8,15.45v6.72L13.84,18l4.76,2.08a.93.93,0,0,0,.4.09,1,1,0,0,0,.52-.15,1,1,0,0,0,.48-.79l1-15A1,1,0,0,0,20.56,3.34ZM18.1,17.68l-5.27-2.31L16,9.17,8.35,13.42,5.42,12.13,18.89,5.79Z"
                }
            }
        ]
    })(props);
}
function BiPaperclip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.004 5H9c-1.838 0-3.586.737-4.924 2.076C2.737 8.415 2 10.163 2 12c0 1.838.737 3.586 2.076 4.924C5.414 18.263 7.162 19 9 19h8v-2H9c-1.303 0-2.55-.529-3.51-1.49C4.529 14.55 4 13.303 4 12c0-1.302.529-2.549 1.49-3.51C6.45 7.529 7.697 7 9 7h8V6l.001 1h.003c.79 0 1.539.314 2.109.886.571.571.886 1.322.887 2.116a2.966 2.966 0 0 1-.884 2.11A2.988 2.988 0 0 1 17 13H9a.99.99 0 0 1-.698-.3A.991.991 0 0 1 8 12c0-.252.11-.507.301-.698A.987.987 0 0 1 9 11h8V9H9c-.79 0-1.541.315-2.114.889C6.314 10.461 6 11.211 6 12s.314 1.54.888 2.114A2.974 2.974 0 0 0 9 15h8.001a4.97 4.97 0 0 0 3.528-1.473 4.967 4.967 0 0 0-.001-7.055A4.95 4.95 0 0 0 17.004 5z"
                }
            }
        ]
    })(props);
}
function BiParagraph(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16h2v4h2V6h2v14h2V6h3V4H9c-3.309 0-6 2.691-6 6s2.691 6 6 6zM9 6h2v8H9c-2.206 0-4-1.794-4-4s1.794-4 4-4z"
                }
            }
        ]
    })(props);
}
function BiParty(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8.31c-.36-.41-.73-.82-1.12-1.21l-.29-.27.14-.12a3.15 3.15 0 0 0 .9-3.49A3.91 3.91 0 0 0 14 1v2a2 2 0 0 1 1.76 1c.17.4 0 .84-.47 1.31-.07.08-.15.13-.22.2-3-2.41-6.29-3.77-7.9-2.16a2.16 2.16 0 0 0-.41.59v.1l-.18.53-4.41 13.1A3.28 3.28 0 0 0 5.28 22a3.21 3.21 0 0 0 1-.17L20 17.28a1 1 0 0 0 .43-.31l.21-.18c1.43-1.44.51-4.21-1.41-6.9A6.63 6.63 0 0 1 23 9V7a8.44 8.44 0 0 0-5 1.31zM5.7 19.93a1.29 1.29 0 0 1-1.63-1.63l1.36-4.1a10.7 10.7 0 0 0 4.29 4.39zm7-2.33a8.87 8.87 0 0 1-6.3-6.29l1-3 .06.09c.11.22.25.45.39.68s.16.29.26.44.33.48.51.73.19.28.3.42.43.55.66.82l.29.35c.34.39.7.77 1.08 1.16s.68.64 1 1l.33.28.78.63.37.28c.28.2.55.4.83.58l.31.2c.36.22.72.43 1.07.61h.05zm6.51-2.23h-.06c-.69.38-3.56-.57-6.79-3.81-.34-.34-.66-.67-.95-1l-.29-.35-.53-.64-.29-.4c-.13-.19-.27-.37-.39-.55l-.26-.42-.29-.47c-.08-.14-.14-.27-.21-.4s-.15-.26-.21-.4a3.31 3.31 0 0 1-.14-.36c-.05-.13-.11-.26-.15-.38S8.6 6 8.57 5.88s-.05-.22-.07-.32a2.26 2.26 0 0 1 0-.26 1 1 0 0 1 0-.24l.11-.31c.36-.36 2.23 0 4.73 1.9A4.13 4.13 0 0 1 12 7v2a6.45 6.45 0 0 0 3-.94l.48.46c.42.42.81.85 1.18 1.28a5.32 5.32 0 0 0-.6 3.4l2-.39a3.57 3.57 0 0 1 0-1.12 11.3 11.3 0 0 1 .81 1.45c.56 1.32.52 2.06.34 2.23z"
                }
            }
        ]
    })(props);
}
function BiPaste(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11V5c0-1.103-.897-2-2-2h-3a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1H4c-1.103 0-2 .897-2 2v13c0 1.103.897 2 2 2h7c0 1.103.897 2 2 2h7c1.103 0 2-.897 2-2v-7c0-1.103-.897-2-2-2zm-9 2v5H4V5h3v2h8V5h3v6h-5c-1.103 0-2 .897-2 2zm2 7v-7h7l.001 7H13z"
                }
            }
        ]
    })(props);
}
function BiPauseCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9h2v6h-2zM9 9h2v6H9z"
                }
            }
        ]
    })(props);
}
function BiPause(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7h3v10H8zm5 0h3v10h-3z"
                }
            }
        ]
    })(props);
}
function BiPen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.404 2.998c-.757-.754-2.077-.751-2.828.005l-1.784 1.791L11.586 7H7a.998.998 0 0 0-.939.658l-4 11c-.133.365-.042.774.232 1.049l2 2a.997.997 0 0 0 1.049.232l11-4A.998.998 0 0 0 17 17v-4.586l2.207-2.207v-.001h.001L21 8.409c.378-.378.586-.881.585-1.415 0-.535-.209-1.038-.588-1.415l-2.593-2.581zm-3.111 8.295A.996.996 0 0 0 15 12v4.3l-9.249 3.363 4.671-4.671c.026.001.052.008.078.008A1.5 1.5 0 1 0 9 13.5c0 .026.007.052.008.078l-4.671 4.671L7.7 9H12c.266 0 .52-.105.707-.293L14.5 6.914 17.086 9.5l-1.793 1.793zm3.206-3.208-2.586-2.586 1.079-1.084 2.593 2.581-1.086 1.089z"
                }
            }
        ]
    })(props);
}
function BiPencil(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 21a1 1 0 0 0 .24 0l4-1a1 1 0 0 0 .47-.26L21 7.41a2 2 0 0 0 0-2.82L19.42 3a2 2 0 0 0-2.83 0L4.3 15.29a1.06 1.06 0 0 0-.27.47l-1 4A1 1 0 0 0 3.76 21 1 1 0 0 0 4 21zM18 4.41 19.59 6 18 7.59 16.42 6zM5.91 16.51 15 7.41 16.59 9l-9.1 9.1-2.11.52z"
                }
            }
        ]
    })(props);
}
function BiPhoneCall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.57 22a2 2 0 0 0 1.43-.59l2.71-2.71a1 1 0 0 0 0-1.41l-4-4a1 1 0 0 0-1.41 0l-1.6 1.59a7.55 7.55 0 0 1-3-1.59 7.62 7.62 0 0 1-1.59-3l1.59-1.6a1 1 0 0 0 0-1.41l-4-4a1 1 0 0 0-1.41 0L2.59 6A2 2 0 0 0 2 7.43 15.28 15.28 0 0 0 6.3 17.7 15.28 15.28 0 0 0 16.57 22zM6 5.41 8.59 8 7.3 9.29a1 1 0 0 0-.3.91 10.12 10.12 0 0 0 2.3 4.5 10.08 10.08 0 0 0 4.5 2.3 1 1 0 0 0 .91-.27L16 15.41 18.59 18l-2 2a13.28 13.28 0 0 1-8.87-3.71A13.28 13.28 0 0 1 4 7.41zM20 11h2a8.81 8.81 0 0 0-9-9v2a6.77 6.77 0 0 1 7 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8c2.1 0 3 .9 3 3h2c0-3.22-1.78-5-5-5z"
                }
            }
        ]
    })(props);
}
function BiPhoneIncoming(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.712 13.288a.999.999 0 0 0-1.414 0l-1.597 1.596c-.824-.245-2.166-.771-2.99-1.596-.874-.874-1.374-2.253-1.594-2.992l1.594-1.594a.999.999 0 0 0 0-1.414l-4-4a1.03 1.03 0 0 0-1.414 0l-2.709 2.71c-.382.38-.597.904-.588 1.437.022 1.423.396 6.367 4.297 10.268C10.195 21.6 15.142 21.977 16.566 22h.028c.528 0 1.027-.208 1.405-.586l2.712-2.712a.999.999 0 0 0 0-1.414l-3.999-4zM16.585 20c-1.248-.021-5.518-.356-8.874-3.712C4.343 12.92 4.019 8.636 4 7.414l2.004-2.005L8.59 7.995 7.297 9.288c-.238.238-.34.582-.271.912.024.115.611 2.842 2.271 4.502s4.387 2.247 4.502 2.271a.994.994 0 0 0 .912-.271l1.293-1.293 2.586 2.586L16.585 20z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.795 6.791 13.005 4v6.995H20l-2.791-2.79 4.503-4.503-1.414-1.414z"
                }
            }
        ]
    })(props);
}
function BiPhoneOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.09 12.5a8.92 8.92 0 0 1-1-2.2l1.59-1.59a1 1 0 0 0 0-1.42l-4-4a1 1 0 0 0-1.41 0L2.59 6A2 2 0 0 0 2 7.44 15.44 15.44 0 0 0 5.62 17L2.3 20.29l1.41 1.42 18-18-1.41-1.42zM7 15.55a13.36 13.36 0 0 1-3-8.13l2-2L8.59 8 7.3 9.29a1 1 0 0 0-.27.92 11 11 0 0 0 1.62 3.73zm9.71-2.26a1 1 0 0 0-1.41 0l-1.6 1.6-.34-.12-1.56 1.55a12.06 12.06 0 0 0 2 .66 1 1 0 0 0 .91-.27l1.3-1.3L18.59 18l-2 2A13.61 13.61 0 0 1 10 18.1l-1.43 1.45a15.63 15.63 0 0 0 8 2.45 2 2 0 0 0 1.43-.58l2.71-2.71a1 1 0 0 0 0-1.42z"
                }
            }
        ]
    })(props);
}
function BiPhoneOutgoing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.712 13.288a.999.999 0 0 0-1.414 0l-1.594 1.594c-.739-.22-2.118-.72-2.992-1.594s-1.374-2.253-1.594-2.992l1.594-1.594a.999.999 0 0 0 0-1.414l-4-4a.999.999 0 0 0-1.414 0L2.586 6c-.38.38-.594.902-.586 1.435.023 1.424.4 6.37 4.298 10.268S15.142 21.977 16.566 22h.028c.528 0 1.027-.208 1.405-.586l2.712-2.712a.999.999 0 0 0 0-1.414l-3.999-4zM16.585 20c-1.248-.021-5.518-.356-8.873-3.712C4.346 12.922 4.02 8.637 4 7.414l2.005-2.005 2.586 2.586-1.293 1.293a1 1 0 0 0-.272.912c.024.115.611 2.842 2.271 4.502s4.387 2.247 4.502 2.271a.993.993 0 0 0 .912-.271l1.293-1.293 2.586 2.586L16.585 20z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16.795 5.791-4.497 4.497 1.414 1.414 4.497-4.497L21.005 10V2.995H14z"
                }
            }
        ]
    })(props);
}
function BiPhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.707 12.293a.999.999 0 0 0-1.414 0l-1.594 1.594c-.739-.22-2.118-.72-2.992-1.594s-1.374-2.253-1.594-2.992l1.594-1.594a.999.999 0 0 0 0-1.414l-4-4a.999.999 0 0 0-1.414 0L3.581 5.005c-.38.38-.594.902-.586 1.435.023 1.424.4 6.37 4.298 10.268s8.844 4.274 10.269 4.298h.028c.528 0 1.027-.208 1.405-.586l2.712-2.712a.999.999 0 0 0 0-1.414l-4-4.001zm-.127 6.712c-1.248-.021-5.518-.356-8.873-3.712-3.366-3.366-3.692-7.651-3.712-8.874L7 4.414 9.586 7 8.293 8.293a1 1 0 0 0-.272.912c.024.115.611 2.842 2.271 4.502s4.387 2.247 4.502 2.271a.991.991 0 0 0 .912-.271L17 14.414 19.586 17l-2.006 2.005z"
                }
            }
        ]
    })(props);
}
function BiPhotoAlbum(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.024 11.536 10 10l-2 3h9l-3.5-5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9.503",
                    "cy": "7.497",
                    "r": "1.503"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.806 5 19s.55-.988 1.012-1H21V4c0-1.103-.897-2-2-2zm0 14H5V5c0-.806.55-.988 1-1h13v12z"
                }
            }
        ]
    })(props);
}
function BiPieChartAlt2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm7.931 9H13V4.069A8.008 8.008 0 0 1 19.931 11zM4 12c0-4.072 3.061-7.436 7-7.931V12a.996.996 0 0 0 .111.438c.015.03.022.063.041.093l4.202 6.723A7.949 7.949 0 0 1 12 20c-4.411 0-8-3.589-8-8zm13.052 6.196L13.805 13h6.126a7.992 7.992 0 0 1-2.879 5.196z"
                }
            }
        ]
    })(props);
}
function BiPieChartAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a9.936 9.936 0 0 0-7.071 2.929C3.04 6.818 2 9.33 2 12s1.04 5.182 2.929 7.071C6.818 20.96 9.33 22 12 22s5.182-1.04 7.071-2.929C20.96 17.182 22 14.67 22 12s-1.04-5.182-2.929-7.071A9.936 9.936 0 0 0 12 2zm5.657 15.657C16.146 19.168 14.137 20 12 20s-4.146-.832-5.657-2.343C4.832 16.146 4 14.137 4 12s.832-4.146 2.343-5.657A7.927 7.927 0 0 1 11 4.069V12a1 1 0 0 0 1 1h7.931a7.927 7.927 0 0 1-2.274 4.657zM13 11V4.062a7.945 7.945 0 0 1 4.657 2.281A7.934 7.934 0 0 1 19.938 11H13z"
                }
            }
        ]
    })(props);
}
function BiPieChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.166V12h6.834A6.817 6.817 0 0 0 12 5.166z"
                }
            }
        ]
    })(props);
}
function BiPin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 22 1-2v-3h5a1 1 0 0 0 1-1v-1.586c0-.526-.214-1.042-.586-1.414L17 11.586V8a1 1 0 0 0 1-1V4c0-1.103-.897-2-2-2H8c-1.103 0-2 .897-2 2v3a1 1 0 0 0 1 1v3.586L5.586 13A2.01 2.01 0 0 0 5 14.414V16a1 1 0 0 0 1 1h5v3l1 2zM8 4h8v2H8V4zM7 14.414l1.707-1.707A.996.996 0 0 0 9 12V8h6v4c0 .266.105.52.293.707L17 14.414V15H7v-.586z"
                }
            }
        ]
    })(props);
}
function BiPlanet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.76 20.2a2.73 2.73 0 0 0 2.15.85 8.86 8.86 0 0 0 3.37-.86 9 9 0 0 0 12.27-10.9c1.31-2.23 1.75-4.26.67-5.48a2.94 2.94 0 0 0-2.57-1A5 5 0 0 0 16.1 4 9 9 0 0 0 3.58 15.14c-1.06 1.21-2.05 3.68-.82 5.06zm1.5-1.32c-.22-.25 0-1.07.37-1.76a9.26 9.26 0 0 0 1.57 1.74c-1.03.3-1.71.28-1.94.02zm14.51-5.17A7 7 0 0 1 15.58 18 7.12 7.12 0 0 1 12 19a6.44 6.44 0 0 1-1.24-.13 30.73 30.73 0 0 0 4.42-3.29 31.5 31.5 0 0 0 3.8-4 6.88 6.88 0 0 1-.21 2.13zm.09-8.89a.94.94 0 0 1 .87.32c.23.26.16.94-.26 1.93a9.2 9.2 0 0 0-1.61-1.86 2.48 2.48 0 0 1 1-.39zM5.22 10.31A6.94 6.94 0 0 1 8.41 6 7 7 0 0 1 12 5a6.9 6.9 0 0 1 6 3.41 5.19 5.19 0 0 1 .35.66 27.43 27.43 0 0 1-4.49 5A27.35 27.35 0 0 1 8.35 18a7 7 0 0 1-3.13-7.65z"
                }
            }
        ]
    })(props);
}
function BiPlayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m9 17 8-5-8-5z"
                }
            }
        ]
    })(props);
}
function BiPlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 6v12l10-6z"
                }
            }
        ]
    })(props);
}
function BiPlug(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 8h2v5c0 2.206 1.794 4 4 4h2v5h2v-5h2c2.206 0 4-1.794 4-4V8h2V6H3v2zm4 0h10v5c0 1.103-.897 2-2 2H9c-1.103 0-2-.897-2-2V8zm0-6h2v3H7zm8 0h2v3h-2z"
                }
            }
        ]
    })(props);
}
function BiPlusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            }
        ]
    })(props);
}
function BiPlusMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2.013H9V9H2v6h7v6.987h6V15h7V9h-7z"
                }
            }
        ]
    })(props);
}
function BiPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 11h-6V5h-2v6H5v2h6v6h2v-6h6z"
                }
            }
        ]
    })(props);
}
function BiPodcast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12.01",
                    "cy": "12",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.01 22h2l.5-7h-3l.5 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 0 0-2.45 19.68l-.15-2.12a8 8 0 1 1 5.21 0l-.15 2.12A10 10 0 0 0 12 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.32 9.61a3.44 3.44 0 0 1 .37.68 3.83 3.83 0 0 1 .23.75 3.57 3.57 0 0 1 .09.8 3.66 3.66 0 0 1-.09.81 3.83 3.83 0 0 1-.23.75 3.44 3.44 0 0 1-.37.68 4.7 4.7 0 0 1-.35.43l-.19 2.62a5.33 5.33 0 0 0 .58-.31A5.86 5.86 0 0 0 17 15.2a5.57 5.57 0 0 0 .55-1 5.89 5.89 0 0 0 .35-1.13 6.06 6.06 0 0 0 .1-1.23 6.22 6.22 0 0 0-.13-1.21A6.09 6.09 0 0 0 17 8.49a6.29 6.29 0 0 0-.73-.89 5.67 5.67 0 0 0-.89-.73 6.3 6.3 0 0 0-1-.56A6.17 6.17 0 0 0 13.21 6a6.11 6.11 0 0 0-2.41 0 5.51 5.51 0 0 0-1.13.36 5.57 5.57 0 0 0-1 .55 5.67 5.67 0 0 0-.89.73 6.29 6.29 0 0 0-.78.85 6.09 6.09 0 0 0-.9 2.14 6.21 6.21 0 0 0-.1 1.21 6.06 6.06 0 0 0 .12 1.21 5.89 5.89 0 0 0 .35 1.13 5.57 5.57 0 0 0 .55 1 6.24 6.24 0 0 0 1.62 1.62 5.33 5.33 0 0 0 .58.31L9 14.51a4.7 4.7 0 0 1-.35-.43 3.44 3.44 0 0 1-.37-.68 3.83 3.83 0 0 1-.23-.75 3.65 3.65 0 0 1-.05-.81 3.56 3.56 0 0 1 .08-.8 3.83 3.83 0 0 1 .23-.75 3.44 3.44 0 0 1 .37-.68 4 4 0 0 1 .5-.61 3.87 3.87 0 0 1 .59-.48 3.44 3.44 0 0 1 .68-.37 3.86 3.86 0 0 1 .75-.24 4.36 4.36 0 0 1 1.61 0 3.86 3.86 0 0 1 .75.24 3.58 3.58 0 0 1 1.27.85 3.49 3.49 0 0 1 .49.61z"
                }
            }
        ]
    })(props);
}
function BiPointer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.978 13.21a1 1 0 0 0-.396-1.024l-14-10a.999.999 0 0 0-1.575.931l2 17a1 1 0 0 0 1.767.516l3.612-4.416 3.377 5.46 1.701-1.052-3.357-5.428 6.089-1.218a.995.995 0 0 0 .782-.769zm-8.674.31a1 1 0 0 0-.578.347l-3.008 3.677L7.257 5.127l10.283 7.345-5.236 1.048z"
                }
            }
        ]
    })(props);
}
function BiPoll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11h7v2H7zm0-4h10.97v2H7zm0 8h13v2H7zM4 4h2v16H4z"
                }
            }
        ]
    })(props);
}
function BiPolygon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.707 2.293A.996.996 0 0 0 16 2H8a.996.996 0 0 0-.707.293l-5 5A.996.996 0 0 0 2 8v8c0 .266.105.52.293.707l5 5A.996.996 0 0 0 8 22h8c.266 0 .52-.105.707-.293l5-5A.996.996 0 0 0 22 16V8a.996.996 0 0 0-.293-.707l-5-5zM20 15.586 15.586 20H8.414L4 15.586V8.414L8.414 4h7.172L20 8.414v7.172z"
                }
            }
        ]
    })(props);
}
function BiPopsicle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2a7 7 0 0 0-4.94 2l-7.78 7.82a1 1 0 0 0 0 1.41l3.54 3.54-3.54 3.53 1.42 1.42 3.53-3.54 3.54 3.54a1 1 0 0 0 1.41 0L20 13.94A7 7 0 0 0 15 2zm3.54 10.54-7.07 7.06-2.82-2.83-1.42-1.42-2.83-2.83 7.07-7.07a5 5 0 0 1 7.08 7.08z"
                }
            }
        ]
    })(props);
}
function BiPound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m5.553 19.105.764 1.843C7.498 20.555 9.422 20 10 20c.838 0 1.462.208 2.184.448.775.259 1.654.552 2.816.552 1.177 0 3.078-.921 3.447-1.105l-.895-1.789c-.721.36-2.031.894-2.552.894-.838 0-1.462-.208-2.184-.448C12.041 18.293 11.162 18 10 18c-.229 0-.526.037-.857.099C9.702 16.95 10 15.561 10 14h3v-2H9.626c-.042-.107-.084-.216-.125-.317C9.243 11.052 9 10.455 9 9c0-1.369.521-3 3-3 2.224 0 3.021 2.227 3.052 2.316l1.896-.633C16.898 7.533 15.679 4 12 4 8.313 4 7 6.583 7 9c0 1.491.234 2.35.478 3H5v2h3c0 2.467-.892 4.328-2.447 5.105z"
                }
            }
        ]
    })(props);
}
function BiPowerOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21c4.411 0 8-3.589 8-8 0-3.35-2.072-6.221-5-7.411v2.223A6 6 0 0 1 18 13c0 3.309-2.691 6-6 6s-6-2.691-6-6a5.999 5.999 0 0 1 3-5.188V5.589C6.072 6.779 4 9.65 4 13c0 4.411 3.589 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2h2v10h-2z"
                }
            }
        ]
    })(props);
}
function BiPrinter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7h-1V2H6v5H5c-1.654 0-3 1.346-3 3v7c0 1.103.897 2 2 2h2v3h12v-3h2c1.103 0 2-.897 2-2v-7c0-1.654-1.346-3-3-3zM8 4h8v3H8V4zm8 16H8v-4h8v4zm4-3h-2v-3H6v3H4v-7c0-.551.449-1 1-1h14c.552 0 1 .449 1 1v7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10h4v2h-4z"
                }
            }
        ]
    })(props);
}
function BiPulse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.97 4.757a.999.999 0 0 0-1.918-.073l-3.186 9.554-2.952-6.644a1.002 1.002 0 0 0-1.843.034L5.323 12H2v2h3.323c.823 0 1.552-.494 1.856-1.257l.869-2.172 3.037 6.835c.162.363.521.594.915.594l.048-.001a.998.998 0 0 0 .9-.683l2.914-8.742.979 3.911A1.995 1.995 0 0 0 18.781 14H22v-2h-3.22l-1.81-7.243z"
                }
            }
        ]
    })(props);
}
function BiPurchaseTagAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.707 2.293A.997.997 0 0 0 11 2H6a.997.997 0 0 0-.707.293l-3 3A.996.996 0 0 0 2 6v5c0 .266.105.52.293.707l10 10a.997.997 0 0 0 1.414 0l8-8a.999.999 0 0 0 0-1.414l-10-10zM13 19.586l-9-9V6.414L6.414 4h4.172l9 9L13 19.586z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.353",
                    "cy": "8.353",
                    "r": "1.647"
                }
            }
        ]
    })(props);
}
function BiPurchaseTag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.707 3.293A.996.996 0 0 0 13 3H4a1 1 0 0 0-1 1v9c0 .266.105.52.293.707l8 8a.997.997 0 0 0 1.414 0l9-9a.999.999 0 0 0 0-1.414l-8-8zM12 19.586l-7-7V5h7.586l7 7L12 19.586z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.496",
                    "cy": "8.495",
                    "r": "1.505"
                }
            }
        ]
    })(props);
}
function BiPyramid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.445 21.832a1 1 0 0 0 1.11 0l9-6A.998.998 0 0 0 21.8 14.4l-9-12c-.377-.504-1.223-.504-1.6 0l-9 12a1 1 0 0 0 .245 1.432l9 6zM13 19.131V6l6.565 8.754L13 19.131zM11 6v13.131l-6.565-4.377L11 6z"
                }
            }
        ]
    })(props);
}
function BiQrScan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4h4.01V2H2v6h2V4zm0 12H2v6h6.01v-2H4v-4zm16 4h-4v2h6v-6h-2v4zM16 4h4v4h2V2h-6v2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11h6V5H5zm2-4h2v2H7zM5 19h6v-6H5zm2-4h2v2H7zM19 5h-6v6h6zm-2 4h-2V7h2zm-3.99 4h2v2h-2zm2 2h2v2h-2zm2 2h2v2h-2zm0-4h2v2h-2z"
                }
            }
        ]
    })(props);
}
function BiQr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11h8V3H3zm2-6h4v4H5zM3 21h8v-8H3zm2-6h4v4H5zm8-12v8h8V3zm6 6h-4V5h4zm-5.99 4h2v2h-2zm2 2h2v2h-2zm-2 2h2v2h-2zm4 0h2v2h-2zm2 2h2v2h-2zm-4 0h2v2h-2zm2-6h2v2h-2zm2 2h2v2h-2z"
                }
            }
        ]
    })(props);
}
function BiQuestionMark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C9.243 4 7 6.243 7 9h2c0-1.654 1.346-3 3-3s3 1.346 3 3c0 1.069-.454 1.465-1.481 2.255-.382.294-.813.626-1.226 1.038C10.981 13.604 10.995 14.897 11 15v2h2v-2.009c0-.024.023-.601.707-1.284.32-.32.682-.598 1.031-.867C15.798 12.024 17 11.1 17 9c0-2.757-2.243-5-5-5zm-1 14h2v2h-2z"
                }
            }
        ]
    })(props);
}
function BiRadar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.579 2 2 6.58 2 12s4.579 10 10 10 10-4.58 10-10S17.421 2 12 2zm0 18c-4.337 0-8-3.664-8-8 0-3.998 3.115-7.417 7-7.927V6.09C8.167 6.569 6 9.033 6 12c0 3.309 2.691 6 6 6 1.595 0 3.1-.626 4.237-1.763l-1.414-1.415A3.97 3.97 0 0 1 12 16c-2.206 0-4-1.794-4-4 0-1.858 1.279-3.411 3-3.858v2.146c-.59.353-1 .993-1 1.712 0 1.081.919 2 2 2s2-.919 2-2c0-.719-.41-1.359-1-1.712V4.073c3.885.51 7 3.929 7 7.927 0 4.336-3.663 8-8 8z"
                }
            }
        ]
    })(props);
}
function BiRadioCircleMarked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5c-3.859 0-7 3.141-7 7s3.141 7 7 7 7-3.141 7-7-3.141-7-7-7zm0 12c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9c-1.627 0-3 1.373-3 3s1.373 3 3 3 3-1.373 3-3-1.373-3-3-3z"
                }
            }
        ]
    })(props);
}
function BiRadioCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12c0 3.859 3.14 7 7 7 3.859 0 7-3.141 7-7s-3.141-7-7-7c-3.86 0-7 3.141-7 7zm12 0c0 2.757-2.243 5-5 5s-5-2.243-5-5 2.243-5 5-5 5 2.243 5 5z"
                }
            }
        ]
    })(props);
}
function BiRadio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.25 5.025-7.898-2.962-.703 1.873L14.484 5H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.018-.767-1.85-1.75-1.975zM4 19v-7h16v-2H4V7h16l.001 12H4z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "15.5",
                    "r": "2.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 15h4.999v2H6z"
                }
            }
        ]
    })(props);
}
function BiReceipt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11h-3V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v14c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-6a1 1 0 0 0-1-1zM5 19a1 1 0 0 1-1-1V5h12v13c0 .351.061.688.171 1H5zm15-1a1 1 0 0 1-2 0v-5h2v5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7h8v2H6zm0 4h8v2H6zm5 4h3v2h-3z"
                }
            }
        ]
    })(props);
}
function BiRectangle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 19V5h16l.001 14H4z"
                }
            }
        ]
    })(props);
}
function BiRecycle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.224 15.543-.813-1.464-1.748.972.812 1.461c.048.085.082.173.104.264a1.024 1.024 0 0 1-.014.5.988.988 0 0 1-.104.235 1 1 0 0 1-.347.352.978.978 0 0 1-.513.137H14v-2l-4 3 4 3v-2h4.601c.278 0 .552-.037.811-.109a2.948 2.948 0 0 0 1.319-.776c.178-.179.332-.38.456-.593a2.992 2.992 0 0 0 .336-2.215 3.163 3.163 0 0 0-.299-.764zM5.862 11.039l-2.31 4.62a3.06 3.06 0 0 0-.261.755 2.997 2.997 0 0 0 .851 2.735c.178.174.376.326.595.453A3.022 3.022 0 0 0 6.236 20H8v-2H6.236a1.016 1.016 0 0 1-.5-.13.974.974 0 0 1-.353-.349 1 1 0 0 1-.149-.468.933.933 0 0 1 .018-.245c.018-.087.048-.173.089-.256l2.256-4.512 1.599.923L8.598 8 4 9.964l1.862 1.075zm12.736 1.925L19.196 8l-1.638.945-2.843-5.117a2.95 2.95 0 0 0-1.913-1.459 3.227 3.227 0 0 0-.772-.083 3.003 3.003 0 0 0-1.498.433A2.967 2.967 0 0 0 9.41 3.944l-.732 1.464 1.789.895.732-1.465c.045-.09.101-.171.166-.242a.933.933 0 0 1 .443-.27 1.053 1.053 0 0 1 .53-.011.963.963 0 0 1 .63.485l2.858 5.146L14 11l4.598 1.964z"
                }
            }
        ]
    })(props);
}
function BiRedo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 18h3v-2H9c-1.654 0-3-1.346-3-3s1.346-3 3-3h6v3l5-4-5-4v3H9c-2.757 0-5 2.243-5 5s2.243 5 5 5z"
                }
            }
        ]
    })(props);
}
function BiReflectHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 21h12l-6-6-6 6zM18 3H6l6 6 6-6zM3 11h3v2H3zm5 0h3v2H8zm5 0h3v2h-3zm5 0h3v2h-3z"
                }
            }
        ]
    })(props);
}
function BiReflectVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3 18 6-6-6-6v12zm12-6 6 6V6l-6 6zm-4-9h2v3h-2zm0 5h2v3h-2zm0 5h2v3h-2zm0 5h2v3h-2z"
                }
            }
        ]
    })(props);
}
function BiRefresh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 11H7.101l.001-.009a4.956 4.956 0 0 1 .752-1.787 5.054 5.054 0 0 1 2.2-1.811c.302-.128.617-.226.938-.291a5.078 5.078 0 0 1 2.018 0 4.978 4.978 0 0 1 2.525 1.361l1.416-1.412a7.036 7.036 0 0 0-2.224-1.501 6.921 6.921 0 0 0-1.315-.408 7.079 7.079 0 0 0-2.819 0 6.94 6.94 0 0 0-1.316.409 7.04 7.04 0 0 0-3.08 2.534 6.978 6.978 0 0 0-1.054 2.505c-.028.135-.043.273-.063.41H2l4 4 4-4zm4 2h2.899l-.001.008a4.976 4.976 0 0 1-2.103 3.138 4.943 4.943 0 0 1-1.787.752 5.073 5.073 0 0 1-2.017 0 4.956 4.956 0 0 1-1.787-.752 5.072 5.072 0 0 1-.74-.61L7.05 16.95a7.032 7.032 0 0 0 2.225 1.5c.424.18.867.317 1.315.408a7.07 7.07 0 0 0 2.818 0 7.031 7.031 0 0 0 4.395-2.945 6.974 6.974 0 0 0 1.053-2.503c.027-.135.043-.273.063-.41H22l-4-4-4 4z"
                }
            }
        ]
    })(props);
}
function BiRegistered(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.14 2a10 10 0 1 0 10 10 10 10 0 0 0-10-10zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.14 10a3 3 0 0 0-3-3h-5v10h2v-4h1.46l2.67 4h2.4l-2.75-4.12A3 3 0 0 0 16.14 10zm-3 1h-3V9h3a1 1 0 0 1 0 2z"
                }
            }
        ]
    })(props);
}
function BiRename(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.005 5.995h-1v2h1v8h-1v2h1c1.103 0 2-.897 2-2v-8c0-1.102-.898-2-2-2zm-14 4H15v4H6.005z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.005 17.995V4H20V2h-8v2h3.005v1.995h-11c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h11V20H12v2h8v-2h-2.995v-2.005zm-13-2v-8h11v8h-11z"
                }
            }
        ]
    })(props);
}
function BiRepeat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6h-5v2h4v9H4V8h5v3l5-4-5-4v3H3a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function BiReplyAll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18v-8a1 1 0 0 0-1-1h-6V6l-5 4 5 4v-3h5v7h2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12.4 6 10l3-2.4V6l-5 4 5 4z"
                }
            }
        ]
    })(props);
}
function BiReply(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 11h6v7h2v-8a1 1 0 0 0-1-1h-7V6l-5 4 5 4v-3z"
                }
            }
        ]
    })(props);
}
function BiRepost(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7a1 1 0 0 0-1-1h-8v2h7v5h-3l3.969 5L22 13h-3V7zM5 17a1 1 0 0 0 1 1h8v-2H7v-5h3L6 6l-4 5h3v6z"
                }
            }
        ]
    })(props);
}
function BiReset(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16c1.671 0 3-1.331 3-3s-1.329-3-3-3-3 1.331-3 3 1.329 3 3 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.817 11.186a8.94 8.94 0 0 0-1.355-3.219 9.053 9.053 0 0 0-2.43-2.43 8.95 8.95 0 0 0-3.219-1.355 9.028 9.028 0 0 0-1.838-.18V2L8 5l3.975 3V6.002c.484-.002.968.044 1.435.14a6.961 6.961 0 0 1 2.502 1.053 7.005 7.005 0 0 1 1.892 1.892A6.967 6.967 0 0 1 19 13a7.032 7.032 0 0 1-.55 2.725 7.11 7.11 0 0 1-.644 1.188 7.2 7.2 0 0 1-.858 1.039 7.028 7.028 0 0 1-3.536 1.907 7.13 7.13 0 0 1-2.822 0 6.961 6.961 0 0 1-2.503-1.054 7.002 7.002 0 0 1-1.89-1.89A6.996 6.996 0 0 1 5 13H3a9.02 9.02 0 0 0 1.539 5.034 9.096 9.096 0 0 0 2.428 2.428A8.95 8.95 0 0 0 12 22a9.09 9.09 0 0 0 1.814-.183 9.014 9.014 0 0 0 3.218-1.355 8.886 8.886 0 0 0 1.331-1.099 9.228 9.228 0 0 0 1.1-1.332A8.952 8.952 0 0 0 21 13a9.09 9.09 0 0 0-.183-1.814z"
                }
            }
        ]
    })(props);
}
function BiRestaurant(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10h-2V3H8v7H6V3H4v8c0 1.654 1.346 3 3 3h1v7h2v-7h1c1.654 0 3-1.346 3-3V3h-2v7zm7-7h-1c-1.159 0-2 1.262-2 3v8h2v7h2V4a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function BiRevision(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.89 10.105a8.696 8.696 0 0 0-.789-1.456l-1.658 1.119a6.606 6.606 0 0 1 .987 2.345 6.659 6.659 0 0 1 0 2.648 6.495 6.495 0 0 1-.384 1.231 6.404 6.404 0 0 1-.603 1.112 6.654 6.654 0 0 1-1.776 1.775 6.606 6.606 0 0 1-2.343.987 6.734 6.734 0 0 1-2.646 0 6.55 6.55 0 0 1-3.317-1.788 6.605 6.605 0 0 1-1.408-2.088 6.613 6.613 0 0 1-.382-1.23 6.627 6.627 0 0 1 .382-3.877A6.551 6.551 0 0 1 7.36 8.797 6.628 6.628 0 0 1 9.446 7.39c.395-.167.81-.296 1.23-.382.107-.022.216-.032.324-.049V10l5-4-5-4v2.938a8.805 8.805 0 0 0-.725.111 8.512 8.512 0 0 0-3.063 1.29A8.566 8.566 0 0 0 4.11 16.77a8.535 8.535 0 0 0 1.835 2.724 8.614 8.614 0 0 0 2.721 1.833 8.55 8.55 0 0 0 5.061.499 8.576 8.576 0 0 0 6.162-5.056c.22-.52.389-1.061.5-1.608a8.643 8.643 0 0 0 0-3.45 8.684 8.684 0 0 0-.499-1.607z"
                }
            }
        ]
    })(props);
}
function BiRewindCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 16V8l-5 4zm6 0V8l-5 4z"
                }
            }
        ]
    })(props);
}
function BiRewind(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12V7l-7 5 7 5zm7-5-7 5 7 5z"
                }
            }
        ]
    })(props);
}
function BiRfid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h16a1 1 0 0 0 1-1v-8h-2v7H5V4h5V2H4a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "11",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11h2a5 5 0 0 0-5-5v2a3 3 0 0 1 3 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 11h2a9 9 0 0 0-9-9v2a7 7 0 0 1 7 7zM9.65 15.67a1 1 0 0 0-.14-.51.76.76 0 0 0-.38-.31 2.3 2.3 0 0 0-.75-.09H7V18h.65v-1.35h.14a1.31 1.31 0 0 1 .33 0 .58.58 0 0 1 .19.14 4.72 4.72 0 0 1 .35.48l.47.7h.78l-.39-.63a3.56 3.56 0 0 0-.38-.53 1.25 1.25 0 0 0-.35-.27 1 1 0 0 0 .64-.3.84.84 0 0 0 .22-.57zm-.74.33a.4.4 0 0 1-.18.14 2.36 2.36 0 0 1-.59 0h-.49v-.82h1a.4.4 0 0 1 .25.13.36.36 0 0 1 .09.26.43.43 0 0 1-.08.29zM10.92 16.62h1.36v-.54h-1.36v-.77h1.57v-.55h-2.22V18h.65v-1.38zM13.01 14.76h.65V18h-.65zM16.1 14.82a2.48 2.48 0 0 0-.62-.06h-1.2V18h1.24a1.76 1.76 0 0 0 .57-.07 1.07 1.07 0 0 0 .46-.26 1.35 1.35 0 0 0 .35-.57 2 2 0 0 0 .1-.69 2.35 2.35 0 0 0-.11-.76 1.33 1.33 0 0 0-.31-.53 1.09 1.09 0 0 0-.48-.3zm.16 2.18a.74.74 0 0 1-.17.31.57.57 0 0 1-.27.13 1.79 1.79 0 0 1-.39 0h-.49v-2.13h.29a3.06 3.06 0 0 1 .54 0 .71.71 0 0 1 .3.15.82.82 0 0 1 .19.32 2.05 2.05 0 0 1 .06.57 2.41 2.41 0 0 1-.06.65z"
                }
            }
        ]
    })(props);
}
function BiRightArrowAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.293 17.293 1.414 1.414L19.414 12l-6.707-6.707-1.414 1.414L15.586 11H6v2h9.586z"
                }
            }
        ]
    })(props);
}
function BiRightArrowCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.999 1.993c-5.514.001-10 4.487-10 10.001s4.486 10 10.001 10c5.513 0 9.999-4.486 10-10 0-5.514-4.486-10-10.001-10.001zM12 19.994c-4.412 0-8.001-3.589-8.001-8s3.589-8 8-8.001C16.411 3.994 20 7.583 20 11.994c-.001 4.411-3.59 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10.994H8v2h4V16l4.005-4.005L12 7.991z"
                }
            }
        ]
    })(props);
}
function BiRightArrow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.536 21.886a1.004 1.004 0 0 0 1.033-.064l13-9a1 1 0 0 0 0-1.644l-13-9A.998.998 0 0 0 5 3v18a1 1 0 0 0 .536.886zM7 4.909 17.243 12 7 19.091V4.909z"
                }
            }
        ]
    })(props);
}
function BiRightDownArrowCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2.007a9.928 9.928 0 0 0-7.071 2.922c-3.899 3.899-3.899 10.243 0 14.143A9.93 9.93 0 0 0 12 21.995a9.93 9.93 0 0 0 7.071-2.923c3.899-3.899 3.899-10.243 0-14.143A9.928 9.928 0 0 0 12 2.007zm5.657 15.65A7.946 7.946 0 0 1 12 19.994c-2.141 0-4.15-.83-5.657-2.337-3.119-3.119-3.119-8.195 0-11.314A7.944 7.944 0 0 1 12 4.007c2.141 0 4.15.829 5.657 2.336 3.119 3.119 3.119 8.195 0 11.314z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.661 8.247 8.247 9.661l3.214 3.214L9.336 15H15V9.337l-2.125 2.124z"
                }
            }
        ]
    })(props);
}
function BiRightIndent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 15h10v2H10zm-6 4h16v2H4zm6-8h10v2H10zm0-4h10v2H10zM4 3h16v2H4zm0 5v8l4-4z"
                }
            }
        ]
    })(props);
}
function BiRightTopArrowCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.006 2.007a9.927 9.927 0 0 0-7.071 2.922c-3.898 3.899-3.898 10.243 0 14.142 1.885 1.885 4.396 2.923 7.071 2.923s5.187-1.038 7.071-2.923c3.898-3.898 3.898-10.242 0-14.142a9.928 9.928 0 0 0-7.071-2.922zm5.657 15.649c-1.507 1.507-3.517 2.337-5.657 2.337s-4.15-.83-5.657-2.337c-3.118-3.119-3.118-8.194 0-11.313 1.507-1.507 3.516-2.336 5.657-2.336s4.15.829 5.657 2.336c3.118 3.119 3.118 8.194 0 11.313z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11.467 11.125-3.214 3.214 1.414 1.414 3.214-3.214 2.125 2.124V9H9.343z"
                }
            }
        ]
    })(props);
}
function BiRocket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.92 2.38A15.72 15.72 0 0 0 17.5 2a8.26 8.26 0 0 0-6 2.06Q9.89 5.67 8.31 7.27c-1.21-.13-4.08-.2-6 1.74a1 1 0 0 0 0 1.41l11.3 11.32a1 1 0 0 0 1.41 0c1.95-2 1.89-4.82 1.77-6l3.21-3.2c3.19-3.19 1.74-9.18 1.68-9.43a1 1 0 0 0-.76-.73zm-2.36 8.75L15 14.67a1 1 0 0 0-.27.9 6.81 6.81 0 0 1-.54 3.94L4.52 9.82a6.67 6.67 0 0 1 4-.5A1 1 0 0 0 9.39 9s1.4-1.45 3.51-3.56A6.61 6.61 0 0 1 17.5 4a14.51 14.51 0 0 1 2.33.2c.24 1.43.62 5.04-1.27 6.93z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.73",
                    "cy": "8.3",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16c-2 1-2 5-2 5a7.81 7.81 0 0 0 5-2z"
                }
            }
        ]
    })(props);
}
function BiRotateLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.758 8.758 5.344 7.344a8.048 8.048 0 0 0-1.841 2.859l1.873.701a6.048 6.048 0 0 1 1.382-2.146zM19 12.999a7.935 7.935 0 0 0-2.344-5.655A7.917 7.917 0 0 0 12 5.069V2L7 6l5 4V7.089a5.944 5.944 0 0 1 3.242 1.669A5.956 5.956 0 0 1 17 13v.002c0 .33-.033.655-.086.977-.007.043-.011.088-.019.131a6.053 6.053 0 0 1-1.138 2.536c-.16.209-.331.412-.516.597a5.954 5.954 0 0 1-.728.613 5.906 5.906 0 0 1-2.277 1.015c-.142.03-.285.05-.43.069-.062.009-.122.021-.184.027a6.104 6.104 0 0 1-1.898-.103L9.3 20.819a8.087 8.087 0 0 0 2.534.136c.069-.007.138-.021.207-.03.205-.026.409-.056.61-.098l.053-.009-.001-.005a7.877 7.877 0 0 0 2.136-.795l.001.001.028-.019a7.906 7.906 0 0 0 1.01-.67c.27-.209.532-.43.777-.675.248-.247.47-.513.681-.785.021-.028.049-.053.07-.081l-.006-.004a7.899 7.899 0 0 0 1.093-1.997l.008.003c.029-.078.05-.158.076-.237.037-.11.075-.221.107-.333.04-.14.073-.281.105-.423.022-.099.048-.195.066-.295.032-.171.056-.344.076-.516.01-.076.023-.15.03-.227.023-.249.037-.5.037-.753.002-.002.002-.004.002-.008zM6.197 16.597l-1.6 1.201a8.045 8.045 0 0 0 2.569 2.225l.961-1.754a6.018 6.018 0 0 1-1.93-1.672zM5 13c0-.145.005-.287.015-.429l-1.994-.143a7.977 7.977 0 0 0 .483 3.372l1.873-.701A5.975 5.975 0 0 1 5 13z"
                }
            }
        ]
    })(props);
}
function BiRotateRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.242 17.242a6.04 6.04 0 0 1-1.37 1.027l.961 1.754a8.068 8.068 0 0 0 2.569-2.225l-1.6-1.201a5.938 5.938 0 0 1-.56.645zm1.743-4.671a5.975 5.975 0 0 1-.362 2.528l1.873.701a7.977 7.977 0 0 0 .483-3.371l-1.994.142zm1.512-2.368a8.048 8.048 0 0 0-1.841-2.859l-1.414 1.414a6.071 6.071 0 0 1 1.382 2.146l1.873-.701zm-8.128 8.763c-.047-.005-.094-.015-.141-.021a6.701 6.701 0 0 1-.468-.075 5.923 5.923 0 0 1-2.421-1.122 5.954 5.954 0 0 1-.583-.506 6.138 6.138 0 0 1-.516-.597 5.91 5.91 0 0 1-.891-1.634 6.086 6.086 0 0 1-.247-.902c-.008-.043-.012-.088-.019-.131A6.332 6.332 0 0 1 6 13.002V13c0-1.603.624-3.109 1.758-4.242A5.944 5.944 0 0 1 11 7.089V10l5-4-5-4v3.069a7.917 7.917 0 0 0-4.656 2.275A7.936 7.936 0 0 0 4 12.999v.009c0 .253.014.504.037.753.007.076.021.15.03.227.021.172.044.345.076.516.019.1.044.196.066.295.032.142.065.283.105.423.032.112.07.223.107.333.026.079.047.159.076.237l.008-.003A7.948 7.948 0 0 0 5.6 17.785l-.007.005c.021.028.049.053.07.081.211.272.433.538.681.785a8.236 8.236 0 0 0 .966.816c.265.192.537.372.821.529l.028.019.001-.001a7.877 7.877 0 0 0 2.136.795l-.001.005.053.009c.201.042.405.071.61.098.069.009.138.023.207.03a8.038 8.038 0 0 0 2.532-.137l-.424-1.955a6.11 6.11 0 0 1-1.904.102z"
                }
            }
        ]
    })(props);
}
function BiRss(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 20.001C19 11.729 12.271 5 4 5v2c7.168 0 13 5.832 13 13.001h2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20.001h2C14 14.486 9.514 10 4 10v2c4.411 0 8 3.589 8 8.001z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "18",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function BiRuble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 21h2v-3h6v-2h-6v-2h4.5c2.757 0 5-2.243 5-5s-2.243-5-5-5H9a1 1 0 0 0-1 1v7H5v2h3v2H5v2h3v3zm2-15h4.5c1.654 0 3 1.346 3 3s-1.346 3-3 3H10V6z"
                }
            }
        ]
    })(props);
}
function BiRuler(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.875 7H3.125C1.953 7 1 7.897 1 9v6c0 1.103.953 2 2.125 2h17.75C22.047 17 23 16.103 23 15V9c0-1.103-.953-2-2.125-2zm0 8H3.125c-.057 0-.096-.016-.113-.016-.007 0-.011.002-.012.008l-.012-5.946c.007-.01.052-.046.137-.046H5v3h2V9h2v4h2V9h2v3h2V9h2v4h2V9h1.875c.079.001.122.028.125.008l.012 5.946c-.007.01-.052.046-.137.046z"
                }
            }
        ]
    })(props);
}
function BiRun(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "4",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.777 10.969a2.007 2.007 0 0 0 2.148.83l3.316-.829-.483-1.94-3.316.829-1.379-2.067a2.01 2.01 0 0 0-1.272-.854l-3.846-.77a1.998 1.998 0 0 0-2.181 1.067l-1.658 3.316 1.789.895 1.658-3.317 1.967.394L7.434 17H3v2h4.434c.698 0 1.355-.372 1.715-.971l1.918-3.196 5.169 1.034 1.816 5.449 1.896-.633-1.815-5.448a2.007 2.007 0 0 0-1.506-1.33l-3.039-.607 1.772-2.954.417.625z"
                }
            }
        ]
    })(props);
}
function BiRupee(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6V4H6v2h3.5c1.302 0 2.401.838 2.815 2H6v2h6.315A2.994 2.994 0 0 1 9.5 12H6v2.414L11.586 20h2.828l-6-6H9.5a5.007 5.007 0 0 0 4.898-4H17V8h-2.602a4.933 4.933 0 0 0-.924-2H17z"
                }
            }
        ]
    })(props);
}
function BiSad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "10.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.493",
                    "cy": "10.493",
                    "r": "1.493"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14c-3 0-4 3-4 3h8s-1-3-4-3z"
                }
            }
        ]
    })(props);
}
function BiSave(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14a2 2 0 0 0 2-2V8a1 1 0 0 0-.29-.71l-4-4A1 1 0 0 0 16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2zm10-2H9v-5h6zM13 7h-2V5h2zM5 5h2v4h8V5h.59L19 8.41V19h-2v-5a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v5H5z"
                }
            }
        ]
    })(props);
}
function BiScan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4v5h2V5h4V3H4a1 1 0 0 0-1 1zm18 5V4a1 1 0 0 0-1-1h-5v2h4v4h2zm-2 10h-4v2h5a1 1 0 0 0 1-1v-5h-2v4zM9 21v-2H5v-4H3v5a1 1 0 0 0 1 1h5zM2 11h20v2H2z"
                }
            }
        ]
    })(props);
}
function BiScatterChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 21h17v-2H5V3H3v17a1 1 0 0 0 1 1z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "8",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "12",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.5",
                    "cy": "13.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "6.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function BiScreenshot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 14h-2v3h-3v2h3v3h2v-3h3v-2h-3zM4 19h3v-2H5v-2H3v3a1 1 0 0 0 1 1zM19 4a1 1 0 0 0-1-1h-3v2h2v2h2V4zM5 5h2V3H4a1 1 0 0 0-1 1v3h2V5zM3 9h2v4H3zm14 0h2v3h-2zM9 3h4v2H9zm0 14h3v2H9z"
                }
            }
        ]
    })(props);
}
function BiSearchAlt2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.023 16.977a35.13 35.13 0 0 1-1.367-1.384c-.372-.378-.596-.653-.596-.653l-2.8-1.337A6.962 6.962 0 0 0 16 9c0-3.859-3.14-7-7-7S2 5.141 2 9s3.14 7 7 7c1.763 0 3.37-.66 4.603-1.739l1.337 2.8s.275.224.653.596c.387.363.896.854 1.384 1.367l1.358 1.392.604.646 2.121-2.121-.646-.604c-.379-.372-.885-.866-1.391-1.36zM9 14c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z"
                }
            }
        ]
    })(props);
}
function BiSearchAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8zm0-14c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.412 8.586c.379.38.588.882.588 1.414h2a3.977 3.977 0 0 0-1.174-2.828c-1.514-1.512-4.139-1.512-5.652 0l1.412 1.416c.76-.758 2.07-.756 2.826-.002z"
                }
            }
        ]
    })(props);
}
function BiSearch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8zm0-14c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z"
                }
            }
        ]
    })(props);
}
function BiSelectMultiple(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM8 16V4h12l.002 12H8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8H2v12c0 1.103.897 2 2 2h12v-2H4V8zm8.933 3.519-1.726-1.726-1.414 1.414 3.274 3.274 5.702-6.84-1.538-1.282z"
                }
            }
        ]
    })(props);
}
function BiSelection(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1H9V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1v6H4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1h6v1a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-1V9h1zm-3-4h2v2h-2V5zM5 5h2v2H5V5zm2 14H5v-2h2v2zm12 0h-2v-2h2v2zm-2-4h-1a1 1 0 0 0-1 1v1H9v-1a1 1 0 0 0-1-1H7V9h1a1 1 0 0 0 1-1V7h6v1a1 1 0 0 0 1 1h1v6z"
                }
            }
        ]
    })(props);
}
function BiSend(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.426 11.095-17-8A.999.999 0 0 0 3.03 4.242L4.969 12 3.03 19.758a.998.998 0 0 0 1.396 1.147l17-8a1 1 0 0 0 0-1.81zM5.481 18.197l.839-3.357L12 12 6.32 9.16l-.839-3.357L18.651 12l-13.17 6.197z"
                }
            }
        ]
    })(props);
}
function BiServer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM4 9V5h16v4zm16 4H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zM4 19v-4h16v4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6h2v2h-2zm-3 0h2v2h-2zm3 10h2v2h-2zm-3 0h2v2h-2z"
                }
            }
        ]
    })(props);
}
function BiShapeCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.494 9.05a8.14 8.14 0 0 0-4.544-4.544C14.713 3.088 13.485 2 12 2S9.287 3.088 9.05 4.506A8.136 8.136 0 0 0 4.506 9.05C3.088 9.287 2 10.515 2 12s1.088 2.713 2.506 2.95a8.14 8.14 0 0 0 4.544 4.544C9.287 20.912 10.515 22 12 22s2.713-1.088 2.95-2.506a8.14 8.14 0 0 0 4.544-4.544C20.912 14.713 22 13.485 22 12s-1.088-2.713-2.506-2.95zM12 4a1 1 0 0 1 1 1c0 .06-.023.11-.034.167a1.015 1.015 0 0 1-.083.279c-.014.027-.034.049-.051.075a1.062 1.062 0 0 1-.16.209c-.04.037-.09.062-.136.092-.054.036-.104.078-.165.103-.115.047-.239.075-.371.075s-.256-.028-.371-.075c-.061-.024-.111-.066-.165-.103-.046-.03-.096-.055-.136-.092a1.062 1.062 0 0 1-.16-.209c-.017-.026-.037-.048-.051-.075a1.026 1.026 0 0 1-.083-.279C11.023 5.11 11 5.06 11 5a1 1 0 0 1 1-1zm-7 7c.06 0 .11.023.167.034.099.017.194.041.279.083.027.014.049.034.075.051.075.047.149.097.209.16.037.04.062.09.092.136.036.054.078.104.103.165.047.115.075.239.075.371s-.028.256-.075.371c-.024.061-.066.111-.103.165-.03.046-.055.096-.092.136-.06.063-.134.113-.209.16-.026.017-.048.037-.075.051a1.026 1.026 0 0 1-.279.083C5.11 12.977 5.06 13 5 13a1 1 0 0 1 0-2zm7 9a1 1 0 0 1-1-1c0-.06.023-.11.034-.167.017-.099.041-.194.083-.279.014-.027.034-.049.051-.075.047-.075.097-.149.16-.209.04-.037.09-.062.136-.092.054-.036.104-.078.165-.103.115-.047.239-.075.371-.075s.256.028.371.075c.061.024.111.066.165.103.046.03.096.055.136.092.063.06.113.134.16.209.017.026.037.048.051.075.042.085.066.181.083.279.011.057.034.107.034.167a1 1 0 0 1-1 1zm2.583-2.512c-.006-.011-.017-.019-.022-.029a3.007 3.007 0 0 0-.996-1.007c-.054-.033-.109-.06-.166-.09a2.902 2.902 0 0 0-.486-.205c-.064-.021-.128-.044-.194-.061-.233-.057-.471-.096-.719-.096s-.486.039-.718.097c-.066.017-.13.039-.195.061a2.928 2.928 0 0 0-.485.205c-.056.029-.112.057-.166.09a3.007 3.007 0 0 0-.996 1.007c-.006.011-.017.019-.022.029a6.15 6.15 0 0 1-2.905-2.905c.011-.006.019-.017.029-.022a3.007 3.007 0 0 0 1.007-.996c.033-.054.061-.11.09-.166.083-.154.15-.316.205-.485.021-.065.044-.129.061-.195.056-.234.095-.472.095-.72s-.039-.486-.097-.718a2.568 2.568 0 0 0-.061-.194 2.902 2.902 0 0 0-.205-.486c-.03-.057-.057-.112-.09-.166A3.007 3.007 0 0 0 6.54 9.44c-.01-.006-.018-.017-.028-.023a6.15 6.15 0 0 1 2.905-2.905c.006.01.017.018.022.029.248.411.588.755.996 1.007.054.033.11.061.166.09.155.083.316.15.486.205.064.021.128.044.194.061.233.057.47.096.719.096a2.94 2.94 0 0 0 .912-.158c.17-.055.331-.122.486-.205.056-.029.112-.057.166-.09.408-.252.748-.596.996-1.007.006-.011.017-.019.022-.029a6.15 6.15 0 0 1 2.905 2.905c-.011.006-.019.017-.029.022a3.007 3.007 0 0 0-1.007.996c-.033.054-.061.11-.09.166-.083.155-.15.316-.205.486-.021.064-.044.128-.061.194A3.07 3.07 0 0 0 16 12a2.94 2.94 0 0 0 .158.912c.055.17.122.331.205.486.029.056.057.112.09.166.252.408.596.748 1.007.996.011.006.019.017.029.022a6.145 6.145 0 0 1-2.906 2.906zM19 13c-.06 0-.11-.023-.167-.034a1.015 1.015 0 0 1-.279-.083c-.027-.014-.049-.034-.075-.051a1.062 1.062 0 0 1-.209-.16c-.037-.04-.062-.09-.092-.136-.036-.054-.078-.104-.103-.165-.047-.115-.075-.239-.075-.371s.028-.256.075-.371c.024-.061.066-.111.103-.165.03-.046.055-.096.092-.136.06-.063.134-.113.209-.16.026-.017.048-.037.075-.051.085-.042.181-.066.279-.083.057-.011.107-.034.167-.034a1 1 0 0 1 0 2z"
                }
            }
        ]
    })(props);
}
function BiShapePolygon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 14.185v-2.369A2.997 2.997 0 0 0 22 9c0-1.654-1.346-3-3-3a2.99 2.99 0 0 0-2.116.876L12.969 5.31c.01-.103.031-.204.031-.31 0-1.654-1.346-3-3-3S7 3.346 7 5c0 .762.295 1.451.765 1.981L6.091 9.212A2.977 2.977 0 0 0 5 9c-1.654 0-3 1.346-3 3s1.346 3 3 3c.159 0 .313-.023.465-.047L7.4 17.532c-.248.436-.4.932-.4 1.468 0 1.654 1.346 3 3 3a2.994 2.994 0 0 0 2.863-2.153l3.962-.792A2.987 2.987 0 0 0 19 20c1.654 0 3-1.346 3-3a2.995 2.995 0 0 0-2-2.815zM19 8a1.001 1.001 0 1 1-1 1c0-.551.448-1 1-1zm-9-4a1.001 1.001 0 1 1-1 1c0-.551.448-1 1-1zm-6 8a1.001 1.001 0 1 1 1 1c-.552 0-1-.449-1-1zm6 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm2.761-2.172A3.005 3.005 0 0 0 10 16c-.386 0-.752.079-1.091.213l-1.674-2.231C7.705 13.451 8 12.762 8 12c0-.536-.152-1.032-.399-1.467l1.935-2.58c.152.024.305.047.464.047a2.99 2.99 0 0 0 2.116-.876l3.915 1.566c-.01.103-.031.204-.031.31 0 1.302.839 2.401 2 2.815v2.369a2.996 2.996 0 0 0-2 2.815c0 .061.015.117.018.177l-3.257.652zM19 18a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                }
            }
        ]
    })(props);
}
function BiShapeSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6c0-1.654-1.346-3-3-3a2.993 2.993 0 0 0-2.815 2h-6.37A2.993 2.993 0 0 0 6 3C4.346 3 3 4.346 3 6c0 1.302.839 2.401 2 2.815v6.369A2.997 2.997 0 0 0 3 18c0 1.654 1.346 3 3 3a2.993 2.993 0 0 0 2.815-2h6.369a2.994 2.994 0 0 0 2.815 2c1.654 0 3-1.346 3-3a2.997 2.997 0 0 0-2-2.816V8.816A2.996 2.996 0 0 0 21 6zm-3-1a1.001 1.001 0 1 1-1 1c0-.551.448-1 1-1zm-2.815 12h-6.37A2.99 2.99 0 0 0 7 15.184V8.816A2.99 2.99 0 0 0 8.815 7h6.369A2.99 2.99 0 0 0 17 8.815v6.369A2.99 2.99 0 0 0 15.185 17zM6 5a1.001 1.001 0 1 1-1 1c0-.551.448-1 1-1zm0 14a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2zm12 0a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2z"
                }
            }
        ]
    })(props);
}
function BiShapeTriangle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 15c-.183 0-.358.022-.532.054L8.946 6.532C8.978 6.359 9 6.182 9 6c0-1.654-1.346-3-3-3S3 4.346 3 6c0 1.302.839 2.401 2 2.815v6.369A2.997 2.997 0 0 0 3 18c0 1.654 1.346 3 3 3a2.993 2.993 0 0 0 2.815-2h6.369a2.994 2.994 0 0 0 2.815 2c1.654 0 3-1.346 3-3S19.654 15 18 15zm-11 .184V8.816c.329-.118.629-.291.894-.508l7.799 7.799a2.961 2.961 0 0 0-.508.894h-6.37A2.99 2.99 0 0 0 7 15.184zM6 5a1.001 1.001 0 1 1-1 1c0-.551.448-1 1-1zm0 14a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2zm12 0a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2z"
                }
            }
        ]
    })(props);
}
function BiShareAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 15a3.51 3.51 0 0 0 2.36-.93l6.26 3.58a3.06 3.06 0 0 0-.12.85 3.53 3.53 0 1 0 1.14-2.57l-6.26-3.58a2.74 2.74 0 0 0 .12-.76l6.15-3.52A3.49 3.49 0 1 0 14 5.5a3.35 3.35 0 0 0 .12.85L8.43 9.6A3.5 3.5 0 1 0 5.5 15zm12 2a1.5 1.5 0 1 1-1.5 1.5 1.5 1.5 0 0 1 1.5-1.5zm0-13A1.5 1.5 0 1 1 16 5.5 1.5 1.5 0 0 1 17.5 4zm-12 6A1.5 1.5 0 1 1 4 11.5 1.5 1.5 0 0 1 5.5 10z"
                }
            }
        ]
    })(props);
}
function BiShare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7.05V4a1 1 0 0 0-1-1 1 1 0 0 0-.7.29l-7 7a1 1 0 0 0 0 1.42l7 7A1 1 0 0 0 11 18v-3.1h.85a10.89 10.89 0 0 1 8.36 3.72 1 1 0 0 0 1.11.35A1 1 0 0 0 22 18c0-9.12-8.08-10.68-11-10.95zm.85 5.83a14.74 14.74 0 0 0-2 .13A1 1 0 0 0 9 14v1.59L4.42 11 9 6.41V8a1 1 0 0 0 1 1c.91 0 8.11.2 9.67 6.43a13.07 13.07 0 0 0-7.82-2.55z"
                }
            }
        ]
    })(props);
}
function BiShekel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8v8h2V8c0-2.206-1.794-4-4-4H5v16h2V6h4c1.103 0 2 .897 2 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 16c0 1.103-.897 2-2 2h-4V8H9v12h6c2.206 0 4-1.794 4-4V4h-2v12z"
                }
            }
        ]
    })(props);
}
function BiShieldAlt2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.438 5.089a1.002 1.002 0 0 0-.959.015c-.684.389-1.355.577-2.053.577-2.035 0-3.952-1.629-5.722-3.39-.375-.373-1.063-.373-1.438 0C9.592 3.959 7.598 5.663 5.51 5.663c-.69 0-1.351-.184-2.018-.561-.298-.166-.658-.171-.96-.012s-.501.461-.528.801c-.011.129-.944 12.872 9.683 16.041a.99.99 0 0 0 .286.042H12c.097 0 .192-.014.285-.041 10.657-3.17 9.695-15.916 9.684-16.044a1 1 0 0 0-.531-.8zm-9.452 14.842c-6.979-2.255-7.934-9.412-8.014-12.477.505.14 1.019.209 1.537.209 2.492 0 4.65-1.567 6.476-3.283 1.893 1.788 3.983 3.301 6.442 3.301.53 0 1.057-.074 1.575-.22-.074 3.065-1.021 10.217-8.016 12.47z"
                }
            }
        ]
    })(props);
}
function BiShieldAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.342 8.447 1.105-.553A.998.998 0 0 0 21.8 6.4l-3-4A1 1 0 0 0 18 2H6a1 1 0 0 0-.8.4l-3 4a1 1 0 0 0 .352 1.494l1.105.553-1.131 2.262A5.052 5.052 0 0 0 2 12.944v.591a6.028 6.028 0 0 0 3.894 5.618l3.431 1.286a5.488 5.488 0 0 1 1.969 1.268.997.997 0 0 0 1.413 0 5.486 5.486 0 0 1 1.969-1.267l3.432-1.287A6.03 6.03 0 0 0 22 13.535v-.591c0-.771-.183-1.545-.527-2.236l-1.131-2.261zM20 13.535a4.019 4.019 0 0 1-2.596 3.745l-3.431 1.287a7.5 7.5 0 0 0-1.974 1.101 7.515 7.515 0 0 0-1.974-1.102L6.596 17.28A4.019 4.019 0 0 1 4 13.535v-.591c0-.463.109-.928.316-1.342l1.131-2.261a2.003 2.003 0 0 0-.895-2.684l-.033-.015L6.5 4h11l1.981 2.642-.034.017a2.004 2.004 0 0 0-.895 2.684l1.131 2.26c.208.414.317.878.317 1.341v.591z"
                }
            }
        ]
    })(props);
}
function BiShieldMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.41 6.11-8-4a.94.94 0 0 0-.89 0l-8 4A1 1 0 0 0 3 6.9c0 .11-1 10.77 8.59 15a1 1 0 0 0 .41.1.93.93 0 0 0 .4-.09C21.92 17.67 21 7 21 6.9a1 1 0 0 0-.59-.79zM12 19.9C5.2 16.63 4.88 9.64 4.93 7.63l7-3.51 7 3.51c.13 2.01-.19 9-6.93 12.27z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11h8v2H8z"
                }
            }
        ]
    })(props);
}
function BiShieldPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.63 21.91A.9.9 0 0 0 12 22a1 1 0 0 0 .41-.09C22 17.67 21 7 21 6.9a1 1 0 0 0-.55-.79l-8-4a1 1 0 0 0-.9 0l-8 4A1 1 0 0 0 3 6.9c0 .1-.92 10.77 8.63 15.01zM5 7.63l7-3.51 7 3.51c.05 2-.27 9-7 12.27C5.26 16.63 4.94 9.64 5 7.63z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.06 16h2v-3h3.01v-2h-3.01V8h-2v3h-3v2h3v3z"
                }
            }
        ]
    })(props);
}
function BiShieldQuarter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.995 6.9a.998.998 0 0 0-.548-.795l-8-4a1 1 0 0 0-.895 0l-8 4a1.002 1.002 0 0 0-.547.795c-.011.107-.961 10.767 8.589 15.014a.987.987 0 0 0 .812 0c9.55-4.247 8.6-14.906 8.589-15.014zM12 19.897V12H5.51a15.473 15.473 0 0 1-.544-4.365L12 4.118V12h6.46c-.759 2.74-2.498 5.979-6.46 7.897z"
                }
            }
        ]
    })(props);
}
function BiShieldX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.48 6.105-8-4a1 1 0 0 0-.895 0l-8 4a1.002 1.002 0 0 0-.547.795c-.011.107-.961 10.767 8.589 15.014a.99.99 0 0 0 .812 0c9.55-4.247 8.6-14.906 8.589-15.014a1.001 1.001 0 0 0-.548-.795zm-8.447 13.792C5.265 16.625 4.944 9.642 4.999 7.635l7.034-3.517 7.029 3.515c.038 1.989-.328 9.018-7.029 12.264z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.293 8.293 12 10.586 9.707 8.293 8.293 9.707 10.586 12l-2.293 2.293 1.414 1.414L12 13.414l2.293 2.293 1.414-1.414L13.414 12l2.293-2.293z"
                }
            }
        ]
    })(props);
}
function BiShield(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.995 6.903a.997.997 0 0 0-.547-.797l-7.973-4a.997.997 0 0 0-.895-.002l-8.027 4c-.297.15-.502.437-.544.767-.013.097-1.145 9.741 8.541 15.008a.995.995 0 0 0 .969-.009c9.307-5.259 8.514-14.573 8.476-14.967zm-8.977 12.944c-6.86-4.01-7.14-10.352-7.063-12.205l7.071-3.523 6.998 3.511c.005 1.87-.481 8.243-7.006 12.217z"
                }
            }
        ]
    })(props);
}
function BiShocked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "10.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.493",
                    "cy": "10.493",
                    "r": "1.493"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "15.5",
                    "rx": "3",
                    "ry": "2.5"
                }
            }
        ]
    })(props);
}
function BiShoppingBag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14c1.103 0 2-.897 2-2V9a1 1 0 0 0-1-1h-3V7c0-2.757-2.243-5-5-5S7 4.243 7 7v1H4a1 1 0 0 0-1 1v11c0 1.103.897 2 2 2zM9 7c0-1.654 1.346-3 3-3s3 1.346 3 3v1H9V7zm-4 3h2v2h2v-2h6v2h2v-2h2l.002 10H5V10z"
                }
            }
        ]
    })(props);
}
function BiShowAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12c-1.095 0-2-.905-2-2 0-.354.103-.683.268-.973C12.178 9.02 12.092 9 12 9a3.02 3.02 0 0 0-3 3c0 1.642 1.358 3 3 3 1.641 0 3-1.358 3-3 0-.092-.02-.178-.027-.268-.29.165-.619.268-.973.268z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5c-7.633 0-9.927 6.617-9.948 6.684L1.946 12l.105.316C2.073 12.383 4.367 19 12 19s9.927-6.617 9.948-6.684l.106-.316-.105-.316C21.927 11.617 19.633 5 12 5zm0 12c-5.351 0-7.424-3.846-7.926-5C4.578 10.842 6.652 7 12 7c5.351 0 7.424 3.846 7.926 5-.504 1.158-2.578 5-7.926 5z"
                }
            }
        ]
    })(props);
}
function BiShow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9a3.02 3.02 0 0 0-3 3c0 1.642 1.358 3 3 3 1.641 0 3-1.358 3-3 0-1.641-1.359-3-3-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5c-7.633 0-9.927 6.617-9.948 6.684L1.946 12l.105.316C2.073 12.383 4.367 19 12 19s9.927-6.617 9.948-6.684l.106-.316-.105-.316C21.927 11.617 19.633 5 12 5zm0 12c-5.351 0-7.424-3.846-7.926-5C4.578 10.842 6.652 7 12 7c5.351 0 7.424 3.846 7.926 5-.504 1.158-2.578 5-7.926 5z"
                }
            }
        ]
    })(props);
}
function BiShower(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 18.33A6.78 6.78 0 0 0 19.5 15a6.73 6.73 0 0 0-1.5 3.33 1.51 1.51 0 1 0 3 0zM11 20.33A6.78 6.78 0 0 0 9.5 17 6.73 6.73 0 0 0 8 20.33 1.59 1.59 0 0 0 9.5 22a1.59 1.59 0 0 0 1.5-1.67zM14.5 22a1.59 1.59 0 0 0 1.5-1.67A6.78 6.78 0 0 0 14.5 17a6.73 6.73 0 0 0-1.5 3.33A1.59 1.59 0 0 0 14.5 22zM3 18.33A1.59 1.59 0 0 0 4.5 20 1.59 1.59 0 0 0 6 18.33 6.78 6.78 0 0 0 4.5 15 6.73 6.73 0 0 0 3 18.33zM13 4.07V2h-2v2.07A8 8 0 0 0 4 12H2v2h20v-2h-2a8 8 0 0 0-7-7.93zM6 12a6 6 0 0 1 12 0z"
                }
            }
        ]
    })(props);
}
function BiShuffle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 17h-1.559l-9.7-10.673A1 1 0 0 0 5.001 6H2v2h2.559l4.09 4.5-4.09 4.501H2v2h3.001a1 1 0 0 0 .74-.327L10 13.987l4.259 4.686a1 1 0 0 0 .74.327H17v3l5-4-5-4v3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.441 8H17v3l5-3.938L17 3v3h-2.001a1 1 0 0 0-.74.327l-3.368 3.707 1.48 1.346L15.441 8z"
                }
            }
        ]
    })(props);
}
function BiSidebar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 19V7h6v12H4zm8 0V7h8V5l.002 14H12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10h2v2H6zm0 4h2v2H6z"
                }
            }
        ]
    })(props);
}
function BiSignal1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16h2v5H3z"
                }
            }
        ]
    })(props);
}
function BiSignal2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16h2v5H3zm4-3h2v8H7z"
                }
            }
        ]
    })(props);
}
function BiSignal3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16h2v5H3zm4-3h2v8H7zm4-3h2v11h-2z"
                }
            }
        ]
    })(props);
}
function BiSignal4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16h2v5H3zm4-3h2v8H7zm4-3h2v11h-2zm4-3h2v14h-2z"
                }
            }
        ]
    })(props);
}
function BiSignal5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16h2v5H3zm4-3h2v8H7zm4-3h2v11h-2zm4-3h2v14h-2zm4-3h2v17h-2z"
                }
            }
        ]
    })(props);
}
function BiSitemap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13.01h-7V10h1c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h1v3.01H4V18H3v4h4v-4H6v-2.99h5V18h-1v4h4v-4h-1v-2.99h5V18h-1v4h4v-4h-1v-4.99zM10 8V4h4l.002 4H10z"
                }
            }
        ]
    })(props);
}
function BiSkipNextCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m8 16 5-4-5-4zm5-4v4h2V8h-2z"
                }
            }
        ]
    })(props);
}
function BiSkipNext(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7v10l7-5zm9 10V7h-2v10z"
                }
            }
        ]
    })(props);
}
function BiSkipPreviousCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16V8l-5 4zM9 8v8h2V8z"
                }
            }
        ]
    })(props);
}
function BiSkipPrevious(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m16 7-7 5 7 5zm-7 5V7H7v10h2z"
                }
            }
        ]
    })(props);
}
function BiSleepy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "15.5",
                    "rx": "3",
                    "ry": "2.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 7c-2.905 0-3.983 2.386-4 3.99l2 .021C8.002 10.804 8.076 9 10 9V7zm4 0v2c1.826 0 1.992 1.537 2 2.007L17 11h1c0-1.608-1.065-4-4-4z"
                }
            }
        ]
    })(props);
}
function BiSliderAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14.5c-1.58 0-2.903 1.06-3.337 2.5H2v2h2.163c.434 1.44 1.757 2.5 3.337 2.5s2.903-1.06 3.337-2.5H22v-2H10.837c-.434-1.44-1.757-2.5-3.337-2.5zm0 5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5S9 17.173 9 18s-.673 1.5-1.5 1.5zm9-11c-1.58 0-2.903 1.06-3.337 2.5H2v2h11.163c.434 1.44 1.757 2.5 3.337 2.5s2.903-1.06 3.337-2.5H22v-2h-2.163c-.434-1.44-1.757-2.5-3.337-2.5zm0 5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.837 5C12.403 3.56 11.08 2.5 9.5 2.5S6.597 3.56 6.163 5H2v2h4.163C6.597 8.44 7.92 9.5 9.5 9.5s2.903-1.06 3.337-2.5h9.288V5h-9.288zM9.5 7.5C8.673 7.5 8 6.827 8 6s.673-1.5 1.5-1.5S11 5.173 11 6s-.673 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function BiSlider(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5h9v2h-9zM2 7h7v2h2V3H9v2H2zm7 10h13v2H9zm10-6h3v2h-3zm-2 4V9.012h-2V11H2v2h13v2zM7 21v-6H5v2H2v2h3v2z"
                }
            }
        ]
    })(props);
}
function BiSlideshow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h7v3H8v2h8v-2h-3v-3h7c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 15V5h16l.001 10H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m10 13 5-3-5-3z"
                }
            }
        ]
    })(props);
}
function BiSmile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.829 14.828a4.055 4.055 0 0 1-1.272.858 4.002 4.002 0 0 1-4.875-1.45l-1.658 1.119a6.063 6.063 0 0 0 1.621 1.62 5.963 5.963 0 0 0 2.148.903 6.042 6.042 0 0 0 2.415 0 5.972 5.972 0 0 0 2.148-.903c.313-.212.612-.458.886-.731.272-.271.52-.571.734-.889l-1.658-1.119a4.017 4.017 0 0 1-.489.592z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "10.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.493",
                    "cy": "10.493",
                    "r": "1.493"
                }
            }
        ]
    })(props);
}
function BiSortAZ(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.707 14.707A1 1 0 0 0 19 13h-7v2h4.586l-4.293 4.293A1 1 0 0 0 13 21h7v-2h-4.586l4.293-4.293zM7 3.99H5v12H2l4 4 4-4H7zM17 3h-2c-.417 0-.79.259-.937.649l-2.75 7.333h2.137L14.193 9h3.613l.743 1.981h2.137l-2.75-7.333A1 1 0 0 0 17 3zm-2.057 4 .75-2h.613l.75 2h-2.113z"
                }
            }
        ]
    })(props);
}
function BiSortAlt2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 20h2V8h3L8 4 4 8h3zm13-4h-3V4h-2v12h-3l4 4z"
                }
            }
        ]
    })(props);
}
function BiSortDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m6 20 4-4H7V4H5v12H2zm5-12h9v2h-9zm0 4h7v2h-7zm0-8h11v2H11zm0 12h5v2h-5z"
                }
            }
        ]
    })(props);
}
function BiSortUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9h9v2h-9zm0 4h7v2h-7zm0-8h11v2H11zm0 12h5v2h-5zm-6 3h2V8h3L6 4 2 8h3z"
                }
            }
        ]
    })(props);
}
function BiSortZA(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.707 14.707A1 1 0 0 0 19 13h-7v2h4.586l-4.293 4.293A1 1 0 0 0 13 21h7v-2h-4.586l4.293-4.293zM6 3.99l-4 4h3v12h2v-12h3zM17 3h-2c-.417 0-.79.259-.937.649l-2.75 7.333h2.137L14.193 9h3.613l.743 1.981h2.137l-2.75-7.333A1 1 0 0 0 17 3zm-2.057 4 .75-2h.613l.75 2h-2.113z"
                }
            }
        ]
    })(props);
}
function BiSort(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16H4l6 6V2H8zm6-11v17h2V8h4l-6-6z"
                }
            }
        ]
    })(props);
}
function BiSpa(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.787 9.023c-.125.027-1.803.418-3.953 1.774-.323-1.567-1.279-4.501-4.108-7.485L12 2.546l-.726.767C8.435 6.308 7.483 9.25 7.163 10.827 5.005 9.448 3.34 9.052 3.218 9.024L2 8.752V10c0 7.29 3.925 12 10 12 5.981 0 10-4.822 10-12V8.758l-1.213.265zM8.999 12.038c.002-.033.152-3.1 3.001-6.532C14.814 8.906 14.999 12 15 12v.125a18.933 18.933 0 0 0-3.01 3.154 19.877 19.877 0 0 0-2.991-3.113v-.128zM12 20c-5.316 0-7.549-4.196-7.937-8.564 1.655.718 4.616 2.426 7.107 6.123l.841 1.249.825-1.26c2.426-3.708 5.425-5.411 7.096-6.122C19.534 15.654 17.304 20 12 20z"
                }
            }
        ]
    })(props);
}
function BiSpaceBar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 13H7V9H5v6h14V9h-2z"
                }
            }
        ]
    })(props);
}
function BiSpeaker(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0 18H6V4h12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0-6a2 2 0 1 1-2 2 2 2 0 0 1 2-2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12.01",
                    "cy": "7",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function BiSprayCan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.002 2h-4a1 1 0 0 0-1 1v3.812a5.998 5.998 0 0 0-3 5.188v.988L3 13l.002.072V21a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-9a5.999 5.999 0 0 0-3-5.188V3a1 1 0 0 0-1-1zm-3 4V4h2v2h-2zm5.001 14h-8v-6h8v6zm-8.001-8c0-2.206 1.794-4 4-4s4 1.794 4 4h-8zm8.001-9h2v2h-2zM16 3h2v2h-2zm0 3h2v2h-2zm3-3h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2z"
                }
            }
        ]
    })(props);
}
function BiSpreadsheet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5zM5 19V5h14l.002 14H5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h1.998v2H7zm4 0h6v2h-6zm-4 4h1.998v2H7zm4 0h6v2h-6zm-4 4h1.998v2H7zm4 0h6v2h-6z"
                }
            }
        ]
    })(props);
}
function BiSquareRounded(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2H7C4.243 2 2 4.243 2 7v10c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5V7c0-2.757-2.243-5-5-5zm3 15c0 1.654-1.346 3-3 3H7c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3h10c1.654 0 3 1.346 3 3v10z"
                }
            }
        ]
    })(props);
}
function BiSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-1 16H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function BiStar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m6.516 14.323-1.49 6.452a.998.998 0 0 0 1.529 1.057L12 18.202l5.445 3.63a1.001 1.001 0 0 0 1.517-1.106l-1.829-6.4 4.536-4.082a1 1 0 0 0-.59-1.74l-5.701-.454-2.467-5.461a.998.998 0 0 0-1.822 0L8.622 8.05l-5.701.453a1 1 0 0 0-.619 1.713l4.214 4.107zm2.853-4.326a.998.998 0 0 0 .832-.586L12 5.43l1.799 3.981a.998.998 0 0 0 .832.586l3.972.315-3.271 2.944c-.284.256-.397.65-.293 1.018l1.253 4.385-3.736-2.491a.995.995 0 0 0-1.109 0l-3.904 2.603 1.05-4.546a1 1 0 0 0-.276-.94l-3.038-2.962 4.09-.326z"
                }
            }
        ]
    })(props);
}
function BiStation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7.758 16.243 1.414-1.415a3.97 3.97 0 0 1-1.173-2.831c0-1.068.417-2.071 1.173-2.825L7.758 7.756a5.957 5.957 0 0 0-1.76 4.24c0 1.604.625 3.112 1.76 4.247zm8.484 0A5.96 5.96 0 0 0 18 12a5.96 5.96 0 0 0-1.758-4.243l-1.414 1.414C15.584 9.927 16 10.932 16 12s-.416 2.073-1.172 2.829l1.414 1.414z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.344 17.657a7.953 7.953 0 0 1-2.345-5.659c0-2.137.833-4.145 2.345-5.654L4.93 4.929c-1.89 1.886-2.931 4.397-2.931 7.069s1.041 5.183 2.931 7.073l1.414-1.414zM17.657 6.343A7.948 7.948 0 0 1 20 12a7.948 7.948 0 0 1-2.343 5.657l1.414 1.414A9.932 9.932 0 0 0 22 12a9.934 9.934 0 0 0-2.929-7.071l-1.414 1.414z"
                }
            }
        ]
    })(props);
}
function BiStats(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12a2 2 0 0 0-.703.133l-2.398-1.963c.059-.214.101-.436.101-.67C17 8.114 15.886 7 14.5 7S12 8.114 12 9.5c0 .396.1.765.262 1.097l-2.909 3.438A2.06 2.06 0 0 0 9 14c-.179 0-.348.03-.512.074l-2.563-2.563C5.97 11.348 6 11.179 6 11c0-1.108-.892-2-2-2s-2 .892-2 2 .892 2 2 2c.179 0 .348-.03.512-.074l2.563 2.563A1.906 1.906 0 0 0 7 16c0 1.108.892 2 2 2s2-.892 2-2c0-.237-.048-.46-.123-.671l2.913-3.442c.227.066.462.113.71.113a2.48 2.48 0 0 0 1.133-.281l2.399 1.963A2.077 2.077 0 0 0 18 14c0 1.108.892 2 2 2s2-.892 2-2-.892-2-2-2z"
                }
            }
        ]
    })(props);
}
function BiSticker(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.796 9.982C20.849 5.357 16.729 2 12 2 6.486 2 2 6.486 2 12c0 4.729 3.357 8.849 7.982 9.796a.988.988 0 0 0 .908-.272l10.633-10.633c.238-.238.34-.578.273-.909zM11 18a7.93 7.93 0 0 1 1.365-4.471 8.18 8.18 0 0 1 .978-1.186 8.211 8.211 0 0 1 1.184-.977 8.128 8.128 0 0 1 1.36-.738c.481-.203.986-.36 1.501-.466a8.112 8.112 0 0 1 2.17-.134l-8.529 8.529c-.013-.185-.029-.37-.029-.557zm-7-6c0-4.411 3.589-8 8-8 2.909 0 5.528 1.589 6.929 4.005a9.99 9.99 0 0 0-1.943.198c-.643.132-1.274.328-1.879.583a10.15 10.15 0 0 0-1.699.923c-.533.361-1.03.771-1.479 1.22s-.858.945-1.221 1.48c-.359.533-.67 1.104-.922 1.698A10.013 10.013 0 0 0 9 18c0 .491.048.979.119 1.461C6.089 18.288 4 15.336 4 12z"
                }
            }
        ]
    })(props);
}
function BiStopCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9h6v6H9z"
                }
            }
        ]
    })(props);
}
function BiStop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h10v10H7z"
                }
            }
        ]
    })(props);
}
function BiStopwatch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 14c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9h2v5h-2zM9 2h6v2H9zm10.293 5.707-2-2 1.414-1.414 2 2z"
                }
            }
        ]
    })(props);
}
function BiStoreAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5c0-1.654-1.346-3-3-3H5C3.346 2 2 3.346 2 5v2.831c0 1.053.382 2.01 1 2.746V19c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-8.424c.618-.735 1-1.692 1-2.746V5zm-2 0v2.831c0 1.14-.849 2.112-1.891 2.167L18 10c-1.103 0-2-.897-2-2V4h3c.552 0 1 .449 1 1zM10 4h4v4c0 1.103-.897 2-2 2s-2-.897-2-2V4zM4 5c0-.551.448-1 1-1h3v4c0 1.103-.897 2-2 2l-.109-.003C4.849 9.943 4 8.971 4 7.831V5zm6 14v-3h4v3h-4zm6 0v-3c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v3H5v-7.131c.254.067.517.111.787.125A3.988 3.988 0 0 0 9 10.643c.733.832 1.807 1.357 3 1.357s2.267-.525 3-1.357a3.988 3.988 0 0 0 3.213 1.351c.271-.014.533-.058.787-.125V19h-3z"
                }
            }
        ]
    })(props);
}
function BiStore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.148 2.971A2.008 2.008 0 0 0 17.434 2H6.566c-.698 0-1.355.372-1.714.971L2.143 7.485A.995.995 0 0 0 2 8a3.97 3.97 0 0 0 1 2.618V19c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-8.382A3.97 3.97 0 0 0 22 8a.995.995 0 0 0-.143-.515l-2.709-4.514zm.836 5.28A2.003 2.003 0 0 1 18 10c-1.103 0-2-.897-2-2 0-.068-.025-.128-.039-.192l.02-.004L15.22 4h2.214l2.55 4.251zM10.819 4h2.361l.813 4.065C13.958 9.137 13.08 10 12 10s-1.958-.863-1.993-1.935L10.819 4zM6.566 4H8.78l-.76 3.804.02.004C8.025 7.872 8 7.932 8 8c0 1.103-.897 2-2 2a2.003 2.003 0 0 1-1.984-1.749L6.566 4zM10 19v-3h4v3h-4zm6 0v-3c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v3H5v-7.142c.321.083.652.142 1 .142a3.99 3.99 0 0 0 3-1.357c.733.832 1.807 1.357 3 1.357s2.267-.525 3-1.357A3.99 3.99 0 0 0 18 12c.348 0 .679-.059 1-.142V19h-3z"
                }
            }
        ]
    })(props);
}
function BiStreetView(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18h2v-5h2V9c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v4h2v5h2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m18.446 11.386-.893 1.789C19.108 13.95 20 14.98 20 16c0 1.892-3.285 4-8 4s-8-2.108-8-4c0-1.02.892-2.05 2.446-2.825l-.893-1.789C3.295 12.512 2 14.193 2 16c0 3.364 4.393 6 10 6s10-2.636 10-6c0-1.807-1.295-3.488-3.554-4.614z"
                }
            }
        ]
    })(props);
}
function BiStrikethrough(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11h-8c-4 0-4-1.816-4-2.5C8 7.882 8 6 12 6c2.8 0 2.99 1.678 3 2.014L16 8h1c0-1.384-1.045-4-5-4-5.416 0-6 3.147-6 4.5 0 .728.148 1.667.736 2.5H4v2h16v-2zm-8 7c-3.793 0-3.99-1.815-4-2H6c0 .04.069 4 6 4 5.221 0 6-2.819 6-4.5 0-.146-.009-.317-.028-.5h-2.006c.032.2.034.376.034.5 0 .684 0 2.5-4 2.5z"
                }
            }
        ]
    })(props);
}
function BiSubdirectoryLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 13h-6v-3l-5 4 5 4v-3h7a1 1 0 0 0 1-1V5h-2v8z"
                }
            }
        ]
    })(props);
}
function BiSubdirectoryRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 13H8V5H6v9a1 1 0 0 0 1 1h7v3l5-4-5-4v3z"
                }
            }
        ]
    })(props);
}
function BiSun(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.993 12c0 2.761 2.246 5.007 5.007 5.007s5.007-2.246 5.007-5.007S14.761 6.993 12 6.993 6.993 9.239 6.993 12zM12 8.993c1.658 0 3.007 1.349 3.007 3.007S13.658 15.007 12 15.007 8.993 13.658 8.993 12 10.342 8.993 12 8.993zM10.998 19h2v3h-2zm0-17h2v3h-2zm-9 9h3v2h-3zm17 0h3v2h-3zM4.219 18.363l2.12-2.122 1.415 1.414-2.12 2.122zM16.24 6.344l2.122-2.122 1.414 1.414-2.122 2.122zM6.342 7.759 4.22 5.637l1.415-1.414 2.12 2.122zm13.434 10.605-1.414 1.414-2.122-2.122 1.414-1.414z"
                }
            }
        ]
    })(props);
}
function BiSupport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12v4.143C2 17.167 2.897 18 4 18h1a1 1 0 0 0 1-1v-5.143a1 1 0 0 0-1-1h-.908C4.648 6.987 7.978 4 12 4s7.352 2.987 7.908 6.857H19a1 1 0 0 0-1 1V18c0 1.103-.897 2-2 2h-2v-1h-4v3h6c2.206 0 4-1.794 4-4 1.103 0 2-.833 2-1.857V12c0-5.514-4.486-10-10-10z"
                }
            }
        ]
    })(props);
}
function BiSushi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C7.51 2 4 4.2 4 7v10c0 2.8 3.51 5 8 5s8-2.2 8-5V7c0-2.8-3.51-5-8-5zm0 18c-3.54 0-6-1.58-6-3v-6.67A10.52 10.52 0 0 0 12 12a10.52 10.52 0 0 0 6-1.67V17c0 1.42-2.46 3-6 3zm0-10c-3.54 0-6-1.58-6-3s2.46-3 6-3 6 1.58 6 3-2.46 3-6 3z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "7",
                    "rx": "3",
                    "ry": "1.71"
                }
            }
        ]
    })(props);
}
function BiSwim(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "19.003",
                    "cy": "6.002",
                    "r": "2.002"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.875 13.219c-.567.453-.978.781-1.878.781-.899 0-1.288-.311-1.876-.781-.68-.543-1.525-1.219-3.127-1.219-1.601 0-2.445.676-3.124 1.219-.588.47-.975.781-1.875.781-.898 0-1.286-.311-1.873-.78C4.443 12.676 3.6 12 2 12v2c.897 0 1.285.311 1.872.78.679.544 1.523 1.22 3.123 1.22s2.446-.676 3.125-1.22c.587-.47.976-.78 1.874-.78.9 0 1.311.328 1.878.781.679.543 1.524 1.219 3.125 1.219 1.602 0 2.447-.676 3.127-1.219.588-.47.977-.781 1.876-.781v-2c-1.601 0-2.446.676-3.125 1.219zM16.997 19c-.899 0-1.288-.311-1.876-.781-.68-.543-1.525-1.219-3.127-1.219-1.601 0-2.445.676-3.124 1.219-.588.47-.975.781-1.875.781-.898 0-1.286-.311-1.873-.78C4.443 17.676 3.6 17 2 17v2c.897 0 1.285.311 1.872.78.679.544 1.523 1.22 3.123 1.22s2.446-.676 3.125-1.22c.587-.47.976-.78 1.874-.78.9 0 1.311.328 1.878.781.679.543 1.524 1.219 3.125 1.219 1.602 0 2.447-.676 3.127-1.219.588-.47.977-.781 1.876-.781v-2c-1.601 0-2.446.676-3.125 1.219-.567.453-.978.781-1.878.781zM11 5.419l2.104 2.104-2.057 2.57c.286-.056.596-.093.947-.093 1.602 0 2.447.676 3.127 1.219.588.47.977.781 1.876.781.9 0 1.311-.328 1.878-.781.132-.105.274-.217.423-.326l-2.096-2.09.005-.005-5.5-5.5a.999.999 0 0 0-1.414 0l-4 4 1.414 1.414L11 5.419z"
                }
            }
        ]
    })(props);
}
function BiSync(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m13 7.101.01.001a4.978 4.978 0 0 1 2.526 1.362 5.005 5.005 0 0 1 1.363 2.528 5.061 5.061 0 0 1-.001 2.016 4.976 4.976 0 0 1-1.363 2.527l1.414 1.414a7.014 7.014 0 0 0 1.908-3.54 6.98 6.98 0 0 0 0-2.819 6.957 6.957 0 0 0-1.907-3.539 6.97 6.97 0 0 0-2.223-1.5 6.921 6.921 0 0 0-1.315-.408c-.137-.028-.275-.043-.412-.063V2L9 6l4 4V7.101zm-7.45 7.623c.174.412.392.812.646 1.19.249.37.537.718.854 1.034a7.036 7.036 0 0 0 2.224 1.501c.425.18.868.317 1.315.408.167.034.338.056.508.078v2.944l4-4-4-4v3.03c-.035-.006-.072-.003-.107-.011a4.978 4.978 0 0 1-2.526-1.362 4.994 4.994 0 0 1 .001-7.071L7.051 7.05a7.01 7.01 0 0 0-1.5 2.224A6.974 6.974 0 0 0 5 12a6.997 6.997 0 0 0 .55 2.724z"
                }
            }
        ]
    })(props);
}
function BiTab(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H6zm0 15V5h12l.002 12H6z"
                }
            }
        ]
    })(props);
}
function BiTable(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 21h15.893c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm0-2v-5h4v5H4zM14 7v5h-4V7h4zM8 7v5H4V7h4zm2 12v-5h4v5h-4zm6 0v-5h3.894v5H16zm3.893-7H16V7h3.893v5z"
                }
            }
        ]
    })(props);
}
function BiTachometer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C6.486 4 2 8.486 2 14a9.89 9.89 0 0 0 1.051 4.445c.17.34.516.555.895.555h16.107c.379 0 .726-.215.896-.555A9.89 9.89 0 0 0 22 14c0-5.514-4.486-10-10-10zm7.41 13H4.59A7.875 7.875 0 0 1 4 14c0-4.411 3.589-8 8-8s8 3.589 8 8a7.875 7.875 0 0 1-.59 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.939 12.939a1.53 1.53 0 0 0 0 2.561 1.53 1.53 0 0 0 2.121-.44l3.962-6.038a.034.034 0 0 0 0-.035.033.033 0 0 0-.045-.01l-6.038 3.962z"
                }
            }
        ]
    })(props);
}
function BiTagAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.868 4.504A1 1 0 0 0 17 4H3a1 1 0 0 0-.868 1.496L5.849 12l-3.717 6.504A1 1 0 0 0 3 20h14a1 1 0 0 0 .868-.504l4-7a.998.998 0 0 0 0-.992l-4-7zM16.42 18H4.724l3.145-5.504a.998.998 0 0 0 0-.992L4.724 6H16.42l3.429 6-3.429 6z"
                }
            }
        ]
    })(props);
}
function BiTag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H8.515a2 2 0 0 0-1.627.838l-4.701 6.581a.997.997 0 0 0 0 1.162l4.701 6.581A2 2 0 0 0 8.515 20H20c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm0 14H8.515l-4.286-6 4.286-6H20v12z"
                }
            }
        ]
    })(props);
}
function BiTargetLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 4.069V2h-2v2.069A8.008 8.008 0 0 0 4.069 11H2v2h2.069A8.007 8.007 0 0 0 11 19.931V22h2v-2.069A8.007 8.007 0 0 0 19.931 13H22v-2h-2.069A8.008 8.008 0 0 0 13 4.069zM12 18c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6z"
                }
            }
        ]
    })(props);
}
function BiTaskX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 20c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2h-2a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1H5c-1.103 0-2 .897-2 2v15zM5 5h2v2h10V5h2v15H5V5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.292 10.295 12 12.587l-2.292-2.292-1.414 1.414 2.292 2.292-2.292 2.292 1.414 1.414L12 15.415l2.292 2.292 1.414-1.414-2.292-2.292 2.292-2.292z"
                }
            }
        ]
    })(props);
}
function BiTask(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2h-2a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1H5c-1.103 0-2 .897-2 2v15c0 1.103.897 2 2 2zM5 5h2v2h10V5h2v15H5V5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m11 13.586-1.793-1.793-1.414 1.414L11 16.414l5.207-5.207-1.414-1.414z"
                }
            }
        ]
    })(props);
}
function BiTaxi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.772 10.156-1.368-4.105A2.995 2.995 0 0 0 16.559 4H14V2h-4v2H7.441a2.995 2.995 0 0 0-2.845 2.051l-1.368 4.105A2.003 2.003 0 0 0 2 12v5c0 .753.423 1.402 1.039 1.743-.013.066-.039.126-.039.195V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2h12v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2.062c0-.069-.026-.13-.039-.195A1.993 1.993 0 0 0 22 17v-5c0-.829-.508-1.541-1.228-1.844zM4 17v-5h16l.002 5H4zM7.441 6h9.117c.431 0 .813.274.949.684L18.613 10H5.387l1.105-3.316A1 1 0 0 1 7.441 6z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function BiTennisBall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.929 19.081c1.895 1.895 4.405 2.938 7.071 2.938s5.177-1.043 7.071-2.938c3.899-3.899 3.899-10.243 0-14.143C17.177 3.044 14.665 2 12 2S6.823 3.044 4.929 4.938c-3.899 3.899-3.899 10.244 0 14.143zm12.728-1.414a7.969 7.969 0 0 1-3.813 2.129c-.009-1.602.586-3.146 1.691-4.251 1.163-1.163 2.732-1.828 4.277-1.851a7.945 7.945 0 0 1-2.155 3.973zm2.325-5.965c-2.124-.021-4.284.853-5.861 2.429-1.532 1.532-2.327 3.68-2.263 5.881a7.946 7.946 0 0 1-5.516-2.345 7.97 7.97 0 0 1-2.332-5.512c.077.002.154.014.231.014 2.115 0 4.16-.804 5.637-2.28 1.58-1.58 2.457-3.739 2.43-5.873a7.948 7.948 0 0 1 5.349 2.337 7.96 7.96 0 0 1 2.325 5.349zM6.343 6.353a7.968 7.968 0 0 1 3.973-2.169c-.018 1.555-.685 3.124-1.851 4.291-1.104 1.103-2.642 1.696-4.238 1.691a7.929 7.929 0 0 1 2.116-3.813z"
                }
            }
        ]
    })(props);
}
function BiTerminal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14h6v2h-6zM6.293 9.707 8.586 12l-2.293 2.293 1.414 1.414L11.414 12 7.707 8.293z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM4 18V6h16l.002 12H4z"
                }
            }
        ]
    })(props);
}
function BiTestTube(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m13.293 2.707.818.818L3.318 14.318C2.468 15.168 2 16.298 2 17.5s.468 2.332 1.318 3.183C4.169 21.532 5.299 22 6.5 22s2.331-.468 3.182-1.318L20.475 9.889l.818.818 1.414-1.414-8-8-1.414 1.414zm3.182 8.354-2.403-2.404-1.414 1.414 2.403 2.404-1.414 1.415-.99-.99-1.414 1.414.99.99-1.415 1.415-2.403-2.404L7 15.728l2.403 2.404-1.136 1.136c-.945.944-2.59.944-3.535 0C4.26 18.795 4 18.168 4 17.5s.26-1.295.732-1.768L15.525 4.939l3.535 3.535-2.585 2.587z"
                }
            }
        ]
    })(props);
}
function BiText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8h2V6h3.252L7.68 18H5v2h8v-2h-2.252L13.32 6H17v2h2V4H5z"
                }
            }
        ]
    })(props);
}
function BiTimeFive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h-2v5.414l3.293 3.293 1.414-1.414L13 11.586z"
                }
            }
        ]
    })(props);
}
function BiTime(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h-2v6h6v-2h-4z"
                }
            }
        ]
    })(props);
}
function BiTimer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.145 8.27 1.563-1.563-1.414-1.414L18.586 7c-1.05-.63-2.274-1-3.586-1-3.859 0-7 3.14-7 7s3.141 7 7 7 7-3.14 7-7a6.966 6.966 0 0 0-1.855-4.73zM15 18c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10h2v4h-2zm-1-7h4v2h-4zM3 8h4v2H3zm0 8h4v2H3zm-1-4h3.99v2H2z"
                }
            }
        ]
    })(props);
}
function BiTired(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14c-3 0-4 3-4 3h8s-1-3-4-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17.555 8.832-1.109-1.664-3 2a1.001 1.001 0 0 0 .108 1.727l4 2 .895-1.789-2.459-1.229 1.565-1.045zm-6.557 1.23a1 1 0 0 0-.443-.894l-3-2-1.11 1.664 1.566 1.044-2.459 1.229.895 1.789 4-2a.998.998 0 0 0 .551-.832z"
                }
            }
        ]
    })(props);
}
function BiToggleLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9c-1.628 0-3 1.372-3 3s1.372 3 3 3 3-1.372 3-3-1.372-3-3-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6H8c-3.3 0-5.989 2.689-6 6v.016A6.01 6.01 0 0 0 8 18h8a6.01 6.01 0 0 0 6-5.994V12c-.009-3.309-2.699-6-6-6zm0 10H8a4.006 4.006 0 0 1-4-3.99C4.004 9.799 5.798 8 8 8h8c2.202 0 3.996 1.799 4 4.006A4.007 4.007 0 0 1 16 16zm4-3.984.443-.004.557.004h-1z"
                }
            }
        ]
    })(props);
}
function BiToggleRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9c-1.628 0-3 1.372-3 3s1.372 3 3 3 3-1.372 3-3-1.372-3-3-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6H8c-3.296 0-5.982 2.682-6 5.986v.042A6.01 6.01 0 0 0 8 18h8c3.309 0 6-2.691 6-6s-2.691-6-6-6zm0 10H8a4.006 4.006 0 0 1-4-3.99C4.004 9.799 5.798 8 8 8h8c2.206 0 4 1.794 4 4s-1.794 4-4 4z"
                }
            }
        ]
    })(props);
}
function BiTone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-1 9H4.069a7.965 7.965 0 0 1 .52-2H11v2zm0 4H4.589a7.965 7.965 0 0 1-.52-2H11v2zm0-10.931V7H5.765A7.996 7.996 0 0 1 11 4.069zM5.765 17H11v2.931A7.996 7.996 0 0 1 5.765 17zM13 19.931V4.069c3.939.495 7 3.858 7 7.931s-3.061 7.436-7 7.931z"
                }
            }
        ]
    })(props);
}
function BiTrafficCone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.943 2.667A1 1 0 0 0 13 2h-2a1 1 0 0 0-.943.667L4.292 19H2v2h20v-2h-2.292L13.943 2.667zM15.47 13H8.53l1.06-3h4.82l1.06 3zm-3.763-9h.586l1.412 4h-3.41l1.412-4zM7.825 15h8.35l1.412 4H6.413l1.412-4z"
                }
            }
        ]
    })(props);
}
function BiTrain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.87 3.34A3.55 3.55 0 0 0 16.38 2H7.62a3.47 3.47 0 0 0-2.5 1.35A4.32 4.32 0 0 0 4 6v12a1 1 0 0 0 1 1h2l-2 3h2.32L8 21h8l.68 1H19l-2-3h2a1 1 0 0 0 1-1V6a4.15 4.15 0 0 0-1.13-2.66zM7.62 4h8.72a1.77 1.77 0 0 1 1 .66 3.25 3.25 0 0 1 .25.34H6.39a2.3 2.3 0 0 1 .25-.35A1.65 1.65 0 0 1 7.62 4zM6 8V7h12v3H6zm12 9H6v-5h12z"
                }
            }
        ]
    })(props);
}
function BiTransferAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.924 10.383a1 1 0 0 0-.217-1.09l-5-5-1.414 1.414L16.586 9H4v2h15a1 1 0 0 0 .924-.617zM4.076 13.617a1 1 0 0 0 .217 1.09l5 5 1.414-1.414L7.414 15H20v-2H5a.999.999 0 0 0-.924.617z"
                }
            }
        ]
    })(props);
}
function BiTransfer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m15 12 5-4-5-4v2.999H2v2h13zm7 3H9v-3l-5 4 5 4v-3h13z"
                }
            }
        ]
    })(props);
}
function BiTrashAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H9c-1.103 0-2 .897-2 2v2H3v2h2v12c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V8h2V6h-4V4c0-1.103-.897-2-2-2zM9 4h6v2H9V4zm8 16H7V8h10v12z"
                }
            }
        ]
    })(props);
}
function BiTrash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 20a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8h2V6h-4V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H3v2h2zM9 4h6v2H9zM8 8h9v12H7V8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 10h2v8H9zm4 0h2v8h-2z"
                }
            }
        ]
    })(props);
}
function BiTrendingDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m14 9.586-4 4-6.293-6.293-1.414 1.414L10 16.414l4-4 4.293 4.293L16 19h6v-6l-2.293 2.293z"
                }
            }
        ]
    })(props);
}
function BiTrendingUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10 10.414 4 4 5.707-5.707L22 11V5h-6l2.293 2.293L14 11.586l-4-4-7.707 7.707 1.414 1.414z"
                }
            }
        ]
    })(props);
}
function BiTrim(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16h3v3c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2v-9c0-1.103-.897-2-2-2h-3V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2zm14-6-.003 9H10v-3h4c1.103 0 2-.897 2-2v-4h3zM5 10h5V5h4l-.003 9H5v-4z"
                }
            }
        ]
    })(props);
}
function BiTrip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.844 20H6.5C5.121 20 4 18.879 4 17.5S5.121 15 6.5 15h7c1.93 0 3.5-1.57 3.5-3.5S15.43 8 13.5 8H8.639a9.812 9.812 0 0 1-1.354 2H13.5c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5h-7C4.019 13 2 15.019 2 17.5S4.019 22 6.5 22h9.593a10.415 10.415 0 0 1-1.249-2zM5 2C3.346 2 2 3.346 2 5c0 3.188 3 5 3 5s3-1.813 3-5c0-1.654-1.346-3-3-3zm0 4.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 5 6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 14c-1.654 0-3 1.346-3 3 0 3.188 3 5 3 5s3-1.813 3-5c0-1.654-1.346-3-3-3zm0 4.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 19 18.5z"
                }
            }
        ]
    })(props);
}
function BiTrophy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4h-3V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v1H3a1 1 0 0 0-1 1v3c0 4.31 1.799 6.91 4.819 7.012A6.001 6.001 0 0 0 11 17.91V20H9v2h6v-2h-2v-2.09a6.01 6.01 0 0 0 4.181-2.898C20.201 14.91 22 12.31 22 8V5a1 1 0 0 0-1-1zM4 8V6h2v6.83C4.216 12.078 4 9.299 4 8zm8 8c-2.206 0-4-1.794-4-4V4h8v8c0 2.206-1.794 4-4 4zm6-3.17V6h2v2c0 1.299-.216 4.078-2 4.83z"
                }
            }
        ]
    })(props);
}
function BiTv(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-5.586l2.293-2.293-1.414-1.414L12 5.586 8.707 2.293 7.293 3.707 9.586 6H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zM4 19V8h16l.002 11H4z"
                }
            }
        ]
    })(props);
}
function BiUnderline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18h14v2H5zM6 4v6c0 3.309 2.691 6 6 6s6-2.691 6-6V4h-2v6c0 2.206-1.794 4-4 4s-4-1.794-4-4V4H6z"
                }
            }
        ]
    })(props);
}
function BiUndo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 10h6c1.654 0 3 1.346 3 3s-1.346 3-3 3h-3v2h3c2.757 0 5-2.243 5-5s-2.243-5-5-5H9V5L4 9l5 4v-3z"
                }
            }
        ]
    })(props);
}
function BiUnite(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 16a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16h1V8a2 2 0 0 1 2-2h8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2zm3 3a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2h-1v8a2 2 0 0 1-2 2H8v1z"
                }
            }
        ]
    })(props);
}
function BiUniversalAccess(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "7.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 10.5 16 9l-3 1h-2L8 9l-.5 1.5 3 1V13L9 17.25l1.5.75 1.25-3.5h.5L13.5 18l1.5-.75L13.5 13v-1.5l3-1z"
                }
            }
        ]
    })(props);
}
function BiUnlink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.949 14.121 19.071 12a5.008 5.008 0 0 0 0-7.071 5.006 5.006 0 0 0-7.071 0l-.707.707 1.414 1.414.707-.707a3.007 3.007 0 0 1 4.243 0 3.005 3.005 0 0 1 0 4.243l-2.122 2.121a2.723 2.723 0 0 1-.844.57L13.414 12l1.414-1.414-.707-.707a4.965 4.965 0 0 0-3.535-1.465c-.235 0-.464.032-.691.066L3.707 2.293 2.293 3.707l18 18 1.414-1.414-5.536-5.536c.277-.184.538-.396.778-.636zm-6.363 3.536a3.007 3.007 0 0 1-4.243 0 3.005 3.005 0 0 1 0-4.243l1.476-1.475-1.414-1.414L4.929 12a5.008 5.008 0 0 0 0 7.071 4.983 4.983 0 0 0 3.535 1.462A4.982 4.982 0 0 0 12 19.071l.707-.707-1.414-1.414-.707.707z"
                }
            }
        ]
    })(props);
}
function BiUpArrowAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8.414V18h2V8.414l4.293 4.293 1.414-1.414L12 4.586l-6.707 6.707 1.414 1.414z"
                }
            }
        ]
    })(props);
}
function BiUpArrowCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 1.993C6.486 1.994 2 6.48 2 11.994c.001 5.514 4.487 10 10 10 5.515 0 10.001-4.486 10.001-10s-4.486-10-10-10.001zM12 19.994c-4.41 0-7.999-3.589-8-8 0-4.411 3.589-8 8.001-8.001 4.411.001 8 3.59 8 8.001s-3.589 8-8.001 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12.001 8.001-4.005 4.005h3.005V16h2v-3.994h3.004z"
                }
            }
        ]
    })(props);
}
function BiUpArrow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 19h18a1.002 1.002 0 0 0 .823-1.569l-9-13c-.373-.539-1.271-.539-1.645 0l-9 13A.999.999 0 0 0 3 19zm9-12.243L19.092 17H4.908L12 6.757z"
                }
            }
        ]
    })(props);
}
function BiUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15h2V9h3l-4-5-4 5h3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18H4v-7H2v7c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-7h-2v7z"
                }
            }
        ]
    })(props);
}
function BiUpsideDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.829 9.172c.181.181.346.38.488.592l1.658-1.119a6.063 6.063 0 0 0-1.621-1.62 5.963 5.963 0 0 0-2.148-.903 5.985 5.985 0 0 0-5.448 1.634 5.993 5.993 0 0 0-.733.889l1.657 1.119a4.017 4.017 0 0 1 2.51-1.683 3.989 3.989 0 0 1 3.637 1.091z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "13.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.507",
                    "cy": "13.507",
                    "r": "1.493"
                }
            }
        ]
    })(props);
}
function BiUpvote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.781 2.375c-.381-.475-1.181-.475-1.562 0l-8 10A1.001 1.001 0 0 0 4 14h4v7a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-7h4a1.001 1.001 0 0 0 .781-1.625l-8-10zM15 12h-1v8h-4v-8H6.081L12 4.601 17.919 12H15z"
                }
            }
        ]
    })(props);
}
function BiUsb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10h1v2h-4V6h2l-3-4-3 4h2v8H7v-2.277c.596-.347 1-.985 1-1.723a2 2 0 0 0-4 0c0 .738.404 1.376 1 1.723V14c0 1.103.897 2 2 2h4v2.277A1.99 1.99 0 0 0 10 20a2 2 0 0 0 4 0c0-.738-.404-1.376-1-1.723V14h4c1.103 0 2-.897 2-2v-2h1V6h-4v4z"
                }
            }
        ]
    })(props);
}
function BiUserCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.29 8.29 16 12.58l-1.3-1.29-1.41 1.42 2.7 2.7 5.72-5.7zM4 8a3.91 3.91 0 0 0 4 4 3.91 3.91 0 0 0 4-4 3.91 3.91 0 0 0-4-4 3.91 3.91 0 0 0-4 4zm6 0a1.91 1.91 0 0 1-2 2 1.91 1.91 0 0 1-2-2 1.91 1.91 0 0 1 2-2 1.91 1.91 0 0 1 2 2zM4 18a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v1h2v-1a5 5 0 0 0-5-5H7a5 5 0 0 0-5 5v1h2z"
                }
            }
        ]
    })(props);
}
function BiUserCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2A10.13 10.13 0 0 0 2 12a10 10 0 0 0 4 7.92V20h.1a9.7 9.7 0 0 0 11.8 0h.1v-.08A10 10 0 0 0 22 12 10.13 10.13 0 0 0 12 2zM8.07 18.93A3 3 0 0 1 11 16.57h2a3 3 0 0 1 2.93 2.36 7.75 7.75 0 0 1-7.86 0zm9.54-1.29A5 5 0 0 0 13 14.57h-2a5 5 0 0 0-4.61 3.07A8 8 0 0 1 4 12a8.1 8.1 0 0 1 8-8 8.1 8.1 0 0 1 8 8 8 8 0 0 1-2.39 5.64z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6a3.91 3.91 0 0 0-4 4 3.91 3.91 0 0 0 4 4 3.91 3.91 0 0 0 4-4 3.91 3.91 0 0 0-4-4zm0 6a1.91 1.91 0 0 1-2-2 1.91 1.91 0 0 1 2-2 1.91 1.91 0 0 1 2 2 1.91 1.91 0 0 1-2 2z"
                }
            }
        ]
    })(props);
}
function BiUserMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 11h8v2h-8zM8 4a3.91 3.91 0 0 0-4 4 3.91 3.91 0 0 0 4 4 3.91 3.91 0 0 0 4-4 3.91 3.91 0 0 0-4-4zm0 6a1.91 1.91 0 0 1-2-2 1.91 1.91 0 0 1 2-2 1.91 1.91 0 0 1 2 2 1.91 1.91 0 0 1-2 2zm-4 8a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v1h2v-1a5 5 0 0 0-5-5H7a5 5 0 0 0-5 5v1h2z"
                }
            }
        ]
    })(props);
}
function BiUserPin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c1.151 0 2-.848 2-2s-.849-2-2-2c-1.15 0-2 .848-2 2s.85 2 2 2zm0 1c-2.209 0-4 1.612-4 3.6v.386h8V14.6c0-1.988-1.791-3.6-4-3.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5c-1.103 0-2 .897-2 2v13c0 1.103.897 2 2 2h4l3 3 3-3h4c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm-5 15-2 2-2-2H5V4h14l.002 13H14z"
                }
            }
        ]
    })(props);
}
function BiUserPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8h-2v3h-3v2h3v3h2v-3h3v-2h-3zM4 8a3.91 3.91 0 0 0 4 4 3.91 3.91 0 0 0 4-4 3.91 3.91 0 0 0-4-4 3.91 3.91 0 0 0-4 4zm6 0a1.91 1.91 0 0 1-2 2 1.91 1.91 0 0 1-2-2 1.91 1.91 0 0 1 2-2 1.91 1.91 0 0 1 2 2zM4 18a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v1h2v-1a5 5 0 0 0-5-5H7a5 5 0 0 0-5 5v1h2z"
                }
            }
        ]
    })(props);
}
function BiUserVoice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12c2.28 0 4-1.72 4-4s-1.72-4-4-4-4 1.72-4 4 1.72 4 4 4zm0-6c1.178 0 2 .822 2 2s-.822 2-2 2-2-.822-2-2 .822-2 2-2zm1 7H7c-2.757 0-5 2.243-5 5v1h2v-1c0-1.654 1.346-3 3-3h2c1.654 0 3 1.346 3 3v1h2v-1c0-2.757-2.243-5-5-5zm9.364-10.364L16.95 4.05C18.271 5.373 19 7.131 19 9s-.729 3.627-2.05 4.95l1.414 1.414C20.064 13.663 21 11.403 21 9s-.936-4.663-2.636-6.364z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.535 5.464 14.121 6.88C14.688 7.445 15 8.198 15 9s-.312 1.555-.879 2.12l1.414 1.416C16.479 11.592 17 10.337 17 9s-.521-2.592-1.465-3.536z"
                }
            }
        ]
    })(props);
}
function BiUserX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m15.71 15.71 2.29-2.3 2.29 2.3 1.42-1.42-2.3-2.29 2.3-2.29-1.42-1.42-2.29 2.3-2.29-2.3-1.42 1.42L16.58 12l-2.29 2.29zM12 8a3.91 3.91 0 0 0-4-4 3.91 3.91 0 0 0-4 4 3.91 3.91 0 0 0 4 4 3.91 3.91 0 0 0 4-4zM6 8a1.91 1.91 0 0 1 2-2 1.91 1.91 0 0 1 2 2 1.91 1.91 0 0 1-2 2 1.91 1.91 0 0 1-2-2zM4 18a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v1h2v-1a5 5 0 0 0-5-5H7a5 5 0 0 0-5 5v1h2z"
                }
            }
        ]
    })(props);
}
function BiUser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a5 5 0 1 0 5 5 5 5 0 0 0-5-5zm0 8a3 3 0 1 1 3-3 3 3 0 0 1-3 3zm9 11v-1a7 7 0 0 0-7-7h-4a7 7 0 0 0-7 7v1h2v-1a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5v1z"
                }
            }
        ]
    })(props);
}
function BiVector(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.277 8c.347.596.985 1 1.723 1a2 2 0 0 0 0-4c-.738 0-1.376.404-1.723 1H16V4a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v2H5.723C5.376 5.404 4.738 5 4 5a2 2 0 0 0 0 4c.738 0 1.376-.404 1.723-1H8v.369C5.133 9.84 4.318 12.534 4.091 14H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.877c.197-.959.718-2.406 2.085-3.418A.984.984 0 0 0 9 11h6a.98.98 0 0 0 .792-.419c1.373 1.013 1.895 2.458 2.089 3.419H17a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-1.092c-.227-1.466-1.042-4.161-3.908-5.632V8h2.277zM6 18H4v-2h2v2zm14 0h-2v-2h2v2zm-6-9h-4V5h4v4z"
                }
            }
        ]
    })(props);
}
function BiVerticalBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 19h3v2h-3zM13 19h3v2h-3zM8 19h3v2H8zM3 19h3v2H3zM13 5h-2v8H8l4 4 4-4h-3V5z"
                }
            }
        ]
    })(props);
}
function BiVerticalCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5V2h-2v3H8l4 4 4-4zm0 17v-3h3l-4-4-4 4h3v3zM3 11h3v2H3zm5 0h3v2H8zm5 0h3v2h-3zm5 0h3v2h-3z"
                }
            }
        ]
    })(props);
}
function BiVerticalTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 7-4 4h3v8h2v-8h3l-4-4zM3 3h3v2H3zM8 3h3v2H8zM13 3h3v2h-3zM18 3h3v2h-3z"
                }
            }
        ]
    })(props);
}
function BiVial(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.95 3.564.708.707-9.193 9.193C2.521 14.408 2 15.664 2 17s.521 2.592 1.465 3.535C4.408 21.479 5.664 22 7 22s2.592-.521 3.535-1.465l9.193-9.193.707.708 1.414-1.414-8.485-8.486-1.414 1.414zM9.121 19.121c-1.133 1.133-3.109 1.133-4.242 0C4.313 18.555 4 17.802 4 17s.313-1.555.879-2.121L5.758 14h8.484l-5.121 5.121zM16.242 12H7.758l6.314-6.314 4.242 4.242L16.242 12z"
                }
            }
        ]
    })(props);
}
function BiVideoOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7c0-1.103-.897-2-2-2H6.414L3.707 2.293 2.293 3.707l18 18 1.414-1.414L18 16.586v-2.919L22 17V7l-4 3.333V7zm-2 7.586L8.414 7H16v7.586zM4 19h10.879l-2-2H4V8.121L2.145 6.265A1.977 1.977 0 0 0 2 7v10c0 1.103.897 2 2 2z"
                }
            }
        ]
    })(props);
}
function BiVideoPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8H9v3H6v2h3v3h2v-3h3v-2h-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-3.333L22 17V7l-4 3.333V7zm-1.999 10H4V7h12v5l.001 5z"
                }
            }
        ]
    })(props);
}
function BiVideoRecording(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9c0-1.103-.897-2-2-2h-1.434l-2.418-4.029A2.008 2.008 0 0 0 10.434 2H5v2h5.434l1.8 3H4c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-3l4 2v-7l-4 2V9zm-1.998 9H4V9h12l.001 4H16v1l.001.001.001 3.999z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 14h6v2H6z"
                }
            }
        ]
    })(props);
}
function BiVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-3.333L22 17V7l-4 3.333V7zm-1.998 10H4V7h12l.001 4.999L16 12l.001.001.001 4.999z"
                }
            }
        ]
    })(props);
}
function BiVoicemail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 8a4.505 4.505 0 0 0-4.5 4.5c0 .925.281 1.784.762 2.5h-3.523c.48-.716.761-1.575.761-2.5C11 10.019 8.981 8 6.5 8S2 10.019 2 12.5 4.019 17 6.5 17c.171 0 .334-.032.5-.051V17h11v-.051c2.244-.252 4-2.139 4-4.449 0-2.481-2.019-4.5-4.5-4.5zM4 12.5C4 11.121 5.121 10 6.5 10S9 11.121 9 12.5 7.879 15 6.5 15 4 13.879 4 12.5zM17.5 15c-1.379 0-2.5-1.121-2.5-2.5s1.121-2.5 2.5-2.5 2.5 1.121 2.5 2.5-1.121 2.5-2.5 2.5z"
                }
            }
        ]
    })(props);
}
function BiVolumeFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21c3.527-1.547 5.999-4.909 5.999-9S19.527 4.547 16 3v2c2.387 1.386 3.999 4.047 3.999 7S18.387 17.614 16 19v2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7v10c1.225-1.1 2-3.229 2-5s-.775-3.9-2-5zM4 17h2.697l5.748 3.832a1.004 1.004 0 0 0 1.027.05A1 1 0 0 0 14 20V4a1 1 0 0 0-1.554-.832L6.697 7H4c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2zm0-8h3c.033 0 .061-.016.093-.019a1.027 1.027 0 0 0 .38-.116c.026-.015.057-.017.082-.033L12 5.868v12.264l-4.445-2.964c-.025-.017-.056-.02-.082-.033a.986.986 0 0 0-.382-.116C7.059 15.016 7.032 15 7 15H4V9z"
                }
            }
        ]
    })(props);
}
function BiVolumeLow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 17h2.697l5.748 3.832a1.004 1.004 0 0 0 1.027.05A1 1 0 0 0 14 20V4a1 1 0 0 0-1.554-.832L6.697 7H4c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2zm0-8h3c.033 0 .061-.016.093-.019a1.027 1.027 0 0 0 .379-.116c.026-.014.057-.017.082-.033L12 5.868v12.264l-4.445-2.964c-.025-.018-.056-.02-.082-.033a.977.977 0 0 0-.382-.116C7.059 15.016 7.032 15 7 15H4V9zm12-2v10c1.225-1.1 2-3.229 2-5s-.775-3.9-2-5z"
                }
            }
        ]
    })(props);
}
function BiVolumeMute(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.707 20.293-2.023-2.023A9.566 9.566 0 0 0 21.999 12c0-4.091-2.472-7.453-5.999-9v2c2.387 1.386 3.999 4.047 3.999 7a8.113 8.113 0 0 1-1.672 4.913l-1.285-1.285C17.644 14.536 18 13.19 18 12c0-1.771-.775-3.9-2-5v7.586l-2-2V4a1 1 0 0 0-1.554-.832L7.727 6.313l-4.02-4.02-1.414 1.414 18 18 1.414-1.414zM12 5.868v4.718L9.169 7.755 12 5.868zM4 17h2.697l5.748 3.832a1.004 1.004 0 0 0 1.027.05A1 1 0 0 0 14 20v-1.879l-2-2v2.011l-4.445-2.964c-.025-.017-.056-.02-.082-.033a.986.986 0 0 0-.382-.116C7.059 15.016 7.032 15 7 15H4V9h.879L3.102 7.223A1.995 1.995 0 0 0 2 9v6c0 1.103.897 2 2 2z"
                }
            }
        ]
    })(props);
}
function BiVolume(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 17h2.697l5.748 3.832a1.004 1.004 0 0 0 1.027.05A1 1 0 0 0 14 20V4a1 1 0 0 0-1.554-.832L6.697 7H4c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2zm0-8h3c.033 0 .061-.016.093-.019a1.027 1.027 0 0 0 .379-.116c.026-.014.057-.017.082-.033L12 5.868v12.264l-4.445-2.964c-.025-.018-.056-.02-.082-.033a.977.977 0 0 0-.382-.116C7.059 15.016 7.032 15 7 15H4V9z"
                }
            }
        ]
    })(props);
}
function BiWalk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "13",
                    "cy": "4",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.978 12.27c.245.368.611.647 1.031.787l2.675.892.633-1.896-2.675-.892-1.663-2.495a2.016 2.016 0 0 0-.769-.679l-1.434-.717a1.989 1.989 0 0 0-1.378-.149l-3.193.797a2.002 2.002 0 0 0-1.306 1.046l-1.794 3.589 1.789.895 1.794-3.589 2.223-.556-1.804 8.346-3.674 2.527 1.133 1.648 3.675-2.528c.421-.29.713-.725.82-1.225l.517-2.388 2.517 1.888.925 4.625 1.961-.393-.925-4.627a2 2 0 0 0-.762-1.206l-2.171-1.628.647-3.885 1.208 1.813z"
                }
            }
        ]
    })(props);
}
function BiWalletAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H5C3.346 3 2 4.346 2 6v12c0 1.654 1.346 3 3 3h15c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19c-.552 0-1-.449-1-1V6c0-.551.448-1 1-1h15v3h-6c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h6.001v3H5zm15-9v4h-6v-4h6z"
                }
            }
        ]
    })(props);
}
function BiWallet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12h2v4h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7V5c0-1.103-.897-2-2-2H5C3.346 3 2 4.346 2 6v12c0 2.201 1.794 3 3 3h15c1.103 0 2-.897 2-2V9c0-1.103-.897-2-2-2zM5 5h13v2H5a1.001 1.001 0 0 1 0-2zm15 14H5.012C4.55 18.988 4 18.805 4 18V8.815c.314.113.647.185 1 .185h15v10z"
                }
            }
        ]
    })(props);
}
function BiWater(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.996 9c1.413 0 2.16-.747 2.705-1.293.49-.49.731-.707 1.292-.707s.802.217 1.292.707C11.83 8.253 12.577 9 13.991 9c1.415 0 2.163-.747 2.71-1.293.491-.49.732-.707 1.295-.707s.804.217 1.295.707C19.837 8.253 20.585 9 22 9V7c-.563 0-.804-.217-1.295-.707C20.159 5.747 19.411 5 17.996 5s-2.162.747-2.709 1.292c-.491.491-.731.708-1.296.708-.562 0-.802-.217-1.292-.707C12.154 5.747 11.407 5 9.993 5s-2.161.747-2.706 1.293c-.49.49-.73.707-1.291.707s-.801-.217-1.291-.707C4.16 5.747 3.413 5 2 5v2c.561 0 .801.217 1.291.707C3.836 8.253 4.583 9 5.996 9zm0 5c1.413 0 2.16-.747 2.705-1.293.49-.49.731-.707 1.292-.707s.802.217 1.292.707c.545.546 1.292 1.293 2.706 1.293 1.415 0 2.163-.747 2.71-1.293.491-.49.732-.707 1.295-.707s.804.217 1.295.707C19.837 13.253 20.585 14 22 14v-2c-.563 0-.804-.217-1.295-.707-.546-.546-1.294-1.293-2.709-1.293s-2.162.747-2.709 1.292c-.491.491-.731.708-1.296.708-.562 0-.802-.217-1.292-.707C12.154 10.747 11.407 10 9.993 10s-2.161.747-2.706 1.293c-.49.49-.73.707-1.291.707s-.801-.217-1.291-.707C4.16 10.747 3.413 10 2 10v2c.561 0 .801.217 1.291.707C3.836 13.253 4.583 14 5.996 14zm0 5c1.413 0 2.16-.747 2.705-1.293.49-.49.731-.707 1.292-.707s.802.217 1.292.707c.545.546 1.292 1.293 2.706 1.293 1.415 0 2.163-.747 2.71-1.293.491-.49.732-.707 1.295-.707s.804.217 1.295.707C19.837 18.253 20.585 19 22 19v-2c-.563 0-.804-.217-1.295-.707-.546-.546-1.294-1.293-2.709-1.293s-2.162.747-2.709 1.292c-.491.491-.731.708-1.296.708-.562 0-.802-.217-1.292-.707C12.154 15.747 11.407 15 9.993 15s-2.161.747-2.706 1.293c-.49.49-.73.707-1.291.707s-.801-.217-1.291-.707C4.16 15.747 3.413 15 2 15v2c.561 0 .801.217 1.291.707C3.836 18.253 4.583 19 5.996 19z"
                }
            }
        ]
    })(props);
}
function BiWebcam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4.963 0-9 4.038-9 9 0 3.328 1.82 6.232 4.513 7.79l-2.067 1.378A1 1 0 0 0 6 22h12a1 1 0 0 0 .555-1.832l-2.067-1.378C19.18 17.232 21 14.328 21 11c0-4.962-4.037-9-9-9zm0 16c-3.859 0-7-3.141-7-7 0-3.86 3.141-7 7-7s7 3.14 7 7c0 3.859-3.141 7-7 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zm0 8c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3z"
                }
            }
        ]
    })(props);
}
function BiWifi0(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "18",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function BiWifi1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.671 14.307C16.184 12.819 14.17 12 12 12s-4.184.819-5.671 2.307l1.414 1.414c1.11-1.11 2.621-1.722 4.257-1.722 1.636.001 3.147.612 4.257 1.722l1.414-1.414z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "18",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function BiWifi2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.671 14.307C16.184 12.819 14.17 12 12 12s-4.184.819-5.671 2.307l1.414 1.414c1.11-1.11 2.621-1.722 4.257-1.722 1.636.001 3.147.612 4.257 1.722l1.414-1.414z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.437 11.292c-4.572-4.573-12.301-4.573-16.873 0l1.414 1.414c3.807-3.807 10.238-3.807 14.045 0l1.414-1.414z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "18",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function BiWifiOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m1.293 8.395 1.414 1.414c.504-.504 1.052-.95 1.622-1.359L2.9 7.021c-.56.422-1.104.87-1.607 1.374zM6.474 5.06 3.707 2.293 2.293 3.707l18 18 1.414-1.414-5.012-5.012.976-.975a7.86 7.86 0 0 0-4.099-2.148L11.294 9.88c2.789-.191 5.649.748 7.729 2.827l1.414-1.414c-2.898-2.899-7.061-3.936-10.888-3.158L8.024 6.61A13.366 13.366 0 0 1 12 6c3.537 0 6.837 1.353 9.293 3.809l1.414-1.414C19.874 5.561 16.071 4 12 4a15.198 15.198 0 0 0-5.526 1.06zm-2.911 6.233 1.414 1.414a9.563 9.563 0 0 1 2.058-1.551L5.576 9.697c-.717.451-1.395.979-2.013 1.596zm2.766 3.014 1.414 1.414c.692-.692 1.535-1.151 2.429-1.428l-1.557-1.557a7.76 7.76 0 0 0-2.286 1.571zm7.66 3.803-2.1-2.1a1.996 1.996 0 1 0 2.1 2.1z"
                }
            }
        ]
    })(props);
}
function BiWifi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c3.537 0 6.837 1.353 9.293 3.809l1.414-1.414C19.874 5.561 16.071 4 12 4c-4.071.001-7.874 1.561-10.707 4.395l1.414 1.414C5.163 7.353 8.463 6 12 6zm5.671 8.307c-3.074-3.074-8.268-3.074-11.342 0l1.414 1.414c2.307-2.307 6.207-2.307 8.514 0l1.414-1.414z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.437 11.293c-4.572-4.574-12.301-4.574-16.873 0l1.414 1.414c3.807-3.807 10.238-3.807 14.045 0l1.414-1.414z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "18",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function BiWind(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5.5C13 3.57 11.43 2 9.5 2 7.466 2 6.25 3.525 6.25 5h2c0-.415.388-1 1.25-1 .827 0 1.5.673 1.5 1.5S10.327 7 9.5 7H2v2h7.5C11.43 9 13 7.43 13 5.5zm2.5 9.5H8v2h7.5c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5c-.862 0-1.25-.585-1.25-1h-2c0 1.475 1.216 3 3.25 3 1.93 0 3.5-1.57 3.5-3.5S17.43 15 15.5 15z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 5c-2.206 0-4 1.794-4 4h2c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2H2v2h16c2.206 0 4-1.794 4-4s-1.794-4-4-4zM2 15h4v2H2z"
                }
            }
        ]
    })(props);
}
function BiWindowAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm0 2 .001 4H4V5h16zM4 19v-8h16.001l.001 8H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6h2v2h-2zm3 0h2v2h-2z"
                }
            }
        ]
    })(props);
}
function BiWindowClose(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 19V7h16l.001 12H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15.707 10.707-1.414-1.414L12 11.586 9.707 9.293l-1.414 1.414L10.586 13l-2.293 2.293 1.414 1.414L12 14.414l2.293 2.293 1.414-1.414L13.414 13z"
                }
            }
        ]
    })(props);
}
function BiWindowOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h5v-2H4V7h16v12h-5v2h5c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 21v-5h3l-4-5-4 5h3v5z"
                }
            }
        ]
    })(props);
}
function BiWindow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 21h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm0-2V7h16l.001 12H4z"
                }
            }
        ]
    })(props);
}
function BiWindows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V9c0-1.103-.897-2-2-2zM4 19v-8h12V9l.002 10H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5c0-1.103-.897-2-2-2H7c-1.103 0-2 .897-2 2h13.001c1.101 0 1.996.895 1.999 1.994L20.002 15H20v2c1.103 0 2-.897 2-2V8.007L22.001 8V6L22 5.99V5z"
                }
            }
        ]
    })(props);
}
function BiWine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.713 12.123c.264-.952.312-2.03.143-3.206l-.866-6.059A1 1 0 0 0 18 2H6a1 1 0 0 0-.99.858l-.865 6.058c-.169 1.177-.121 2.255.142 3.206.864 3.134 3.551 5.392 6.713 5.794V20H9v2h6v-2h-2v-2.084c3.162-.402 5.849-2.66 6.713-5.793zM17.133 4l.57 4H6.296l.571-4h10.266zM6.215 11.59c-.132-.474-.181-1.009-.159-1.59h11.889c.021.581-.028 1.116-.159 1.591A6.021 6.021 0 0 1 12 16a6.019 6.019 0 0 1-5.785-4.41z"
                }
            }
        ]
    })(props);
}
function BiWinkSmile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.828 14.828a3.988 3.988 0 0 1-2.02 1.09 4.108 4.108 0 0 1-1.616 0 4.103 4.103 0 0 1-.749-.232 4.161 4.161 0 0 1-.679-.368 4.115 4.115 0 0 1-1.082-1.082l-1.658 1.117c.215.319.462.619.733.889a5.991 5.991 0 0 0 8.485.002c.272-.271.52-.571.734-.891l-1.658-1.117c-.143.211-.307.41-.49.592z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "10.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 10c-2 0-2.5 2-2.5 2h5s-.501-2-2.5-2z"
                }
            }
        ]
    })(props);
}
function BiWinkTongue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 9c-2 0-2.5 2-2.5 2h5s-.501-2-2.5-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-2 16v-3h4v3c0 1.103-.897 2-2 2s-2-.897-2-2zm5.856 1.005c.085-.323.144-.656.144-1.005v-1.499C17.589 15.028 18 13 18 13H6s.412 2.028 2 3.501V18c0 .349.059.682.144 1.005A8.005 8.005 0 0 1 4 12c0-4.411 3.589-8 8-8s8 3.589 8 8a8.005 8.005 0 0 1-4.144 7.005z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function BiWon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.758 5H19.68l-.844 3h-4.893l-.899-3h-2.088l-.899 3H5.164L4.32 5H2.242l.844 3H2v2h1.648l.563 2H2v2h2.773l1.688 6h2.083l1.8-6h3.313l1.8 6h2.083l1.688-6H22v-2h-2.211l.563-2H22V8h-1.086l.844-3zM5.727 10h3.729l-.6 2H6.289l-.562-2zm1.804 6.417L6.852 14h1.404l-.725 2.417zM10.944 12l.6-2h.912l.6 2h-2.112zm5.525 4.417L15.744 14h1.404l-.679 2.417zM17.711 12h-2.567l-.6-2h3.729l-.562 2z"
                }
            }
        ]
    })(props);
}
function BiWorld(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM4 12c0-.899.156-1.762.431-2.569L6 11l2 2v2l2 2 1 1v1.931C7.061 19.436 4 16.072 4 12zm14.33 4.873C17.677 16.347 16.687 16 16 16v-1a2 2 0 0 0-2-2h-4v-3a2 2 0 0 0 2-2V7h1a2 2 0 0 0 2-2v-.411C17.928 5.778 20 8.65 20 12a7.947 7.947 0 0 1-1.67 4.873z"
                }
            }
        ]
    })(props);
}
function BiWrench(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.122 21c.378.378.88.586 1.414.586S7.572 21.378 7.95 21l4.336-4.336a7.495 7.495 0 0 0 2.217.333 7.446 7.446 0 0 0 5.302-2.195 7.484 7.484 0 0 0 1.632-8.158l-.57-1.388-4.244 4.243-2.121-2.122 4.243-4.243-1.389-.571A7.478 7.478 0 0 0 14.499 2c-2.003 0-3.886.78-5.301 2.196a7.479 7.479 0 0 0-1.862 7.518L3 16.05a2.001 2.001 0 0 0 0 2.828L5.122 21zm4.548-8.791-.254-.616a5.486 5.486 0 0 1 1.196-5.983 5.46 5.46 0 0 1 4.413-1.585l-3.353 3.353 4.949 4.95 3.355-3.355a5.49 5.49 0 0 1-1.587 4.416c-1.55 1.55-3.964 2.027-5.984 1.196l-.615-.255-5.254 5.256h.001l-.001 1v-1l-2.122-2.122 5.256-5.255z"
                }
            }
        ]
    })(props);
}
function BiXCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.172 16.242 12 13.414l2.828 2.828 1.414-1.414L13.414 12l2.828-2.828-1.414-1.414L12 10.586 9.172 7.758 7.758 9.172 10.586 12l-2.828 2.828z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.514 0 10-4.486 10-10S17.514 2 12 2 2 6.486 2 12s4.486 10 10 10zm0-18c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8z"
                }
            }
        ]
    })(props);
}
function BiX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
                }
            }
        ]
    })(props);
}
function BiYen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.2 3.4 12 10.333 6.8 3.4 5.2 4.6 10 11H7v2h4v2H7v2h4v4h2v-4h4v-2h-4v-2h4v-2h-3l4.8-6.4z"
                }
            }
        ]
    })(props);
}
function BiZoomIn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6H9v3H6v2h3v3h2v-3h3V9h-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2c-4.411 0-8 3.589-8 8s3.589 8 8 8a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8zm0 14c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6z"
                }
            }
        ]
    })(props);
}
function BiZoomOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 9h8v2H6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8zm0-14c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z"
                }
            }
        ]
    })(props);
}
function BiSolidAddToQueue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h12v-2H4V8H2v12c0 1.103.897 2 2 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm-2 9h-3v3h-2v-3h-3V9h3V6h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function BiSolidAdjustAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.071 19.071c3.833-3.833 3.833-10.31 0-14.143s-10.31-3.833-14.143 0-3.833 10.31 0 14.143 10.31 3.833 14.143 0zM7.051 7.051c2.706-2.707 7.191-2.708 9.898 0l-9.898 9.898c-2.708-2.707-2.71-7.19 0-9.898z"
                }
            }
        ]
    })(props);
}
function BiSolidAdjust(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.579 2 2 6.58 2 12s4.579 10 10 10 10-4.58 10-10S17.421 2 12 2zm0 17V5c3.829 0 7 3.169 7 7 0 3.828-3.171 7-7 7z"
                }
            }
        ]
    })(props);
}
function BiSolidAlarmAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c-4.879 0-9 4.121-9 9s4.121 9 9 9 9-4.121 9-9-4.121-9-9-9zm4 10h-3v3h-2v-3H8v-2h3V9h2v3h3v2zm1.284-10.293 1.412-1.416 3.01 3-1.413 1.417zM5.282 2.294 6.7 3.706l-2.99 3-1.417-1.413z"
                }
            }
        ]
    })(props);
}
function BiSolidAlarmExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m17.284 3.707 1.412-1.416 3.01 3-1.413 1.417zm-10.586 0-2.99 2.999L2.29 5.294l2.99-3zM12 4c-4.879 0-9 4.121-9 9s4.121 9 9 9 9-4.121 9-9-4.121-9-9-9zm1 14h-2v-2h2v2zm0-4h-2V8h2v6z"
                }
            }
        ]
    })(props);
}
function BiSolidAlarmOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.292 6.708-3.01-3 1.412-1.417 3.01 3zm1.415 13.585-2.287-2.288C20.409 16.563 21 14.837 21 13c0-4.878-4.121-9-9-9-1.838 0-3.563.59-5.006 1.581L5.91 4.496l.788-.79-1.416-1.412-.786.788-.789-.789-1.414 1.414 18 18 1.414-1.414zM17 14h-1.586l-2-2H17v2zm-6-6h2v3.586l-2-2V8zm1 14c1.658 0 3.224-.485 4.574-1.305L4.305 8.426A8.794 8.794 0 0 0 3 13c0 4.878 4.122 9 9 9z"
                }
            }
        ]
    })(props);
}
function BiSolidAlarmSnooze(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m17.284 3.707 1.412-1.416 3.01 3-1.413 1.417zm-10.586 0-2.99 2.999L2.29 5.294l2.99-3zM12 4c-4.878 0-9 4.121-9 9s4.122 9 9 9c4.879 0 9-4.121 9-9s-4.121-9-9-9zm4 13H8.131l4-6H8V9h7.868l-1.035 1.554-.001.001L11.869 15H16v2z"
                }
            }
        ]
    })(props);
}
function BiSolidAlarm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c-4.878 0-9 4.122-9 9s4.122 9 9 9c4.879 0 9-4.122 9-9s-4.121-9-9-9zm5 10h-6V8h2v4h4v2zm3.292-7.292-3.01-3 1.412-1.417 3.01 3zM5.282 2.294 6.7 3.706l-2.99 3-1.417-1.413z"
                }
            }
        ]
    })(props);
}
function BiSolidAlbum(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-4.607 8.055A4.956 4.956 0 0 0 7 12H5a6.978 6.978 0 0 1 2.051-4.95 6.978 6.978 0 0 1 2.225-1.5l.779 1.842c-.596.252-1.13.612-1.59 1.072s-.82.995-1.072 1.591zm4.6 3.945a2.007 2.007 0 1 1 0-4.014 2.007 2.007 0 0 1 0 4.014z"
                }
            }
        ]
    })(props);
}
function BiSolidAmbulance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.86 12.48 19.15 8a2 2 0 0 0-1.72-1H15V5a1 1 0 0 0-1-1H4a2 2 0 0 0-2 2v10a2 2 0 0 0 1 1.73 3.49 3.49 0 0 0 7 .27h3.1a3.48 3.48 0 0 0 6.9 0 2 2 0 0 0 2-2v-3a1.07 1.07 0 0 0-.14-.52zM6.5 19A1.5 1.5 0 1 1 8 17.5 1.5 1.5 0 0 1 6.5 19zm5.5-8h-2v2H8v-2H6V9h2V7h2v2h2zm4.5 8a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5zM15 12V9h2.43l1.8 3z"
                }
            }
        ]
    })(props);
}
function BiSolidAnalyse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.626 8.878a7.937 7.937 0 0 1 1.71-2.541 7.92 7.92 0 0 1 2.542-1.71 8.12 8.12 0 0 1 6.13-.041A2.49 2.49 0 0 0 17.5 7C18.886 7 20 5.886 20 4.5S18.886 2 17.5 2c-.689 0-1.312.276-1.763.725-2.431-.973-5.223-.958-7.635.059-1.19.5-2.26 1.22-3.18 2.139A9.98 9.98 0 0 0 2 12h2c0-1.086.211-2.136.626-3.122zm14.747 6.244c-.401.952-.977 1.808-1.71 2.541s-1.589 1.309-2.542 1.71a8.12 8.12 0 0 1-6.13.041A2.488 2.488 0 0 0 6.5 17C5.114 17 4 18.114 4 19.5S5.114 22 6.5 22c.689 0 1.312-.276 1.763-.725A9.973 9.973 0 0 0 12 22a9.983 9.983 0 0 0 9.217-6.102A9.992 9.992 0 0 0 22 12h-2a7.993 7.993 0 0 1-.627 3.122z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.462c-2.502 0-4.538 2.036-4.538 4.538S9.498 16.538 12 16.538c2.502 0 4.538-2.036 4.538-4.538S14.502 7.462 12 7.462z"
                }
            }
        ]
    })(props);
}
function BiSolidAngry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-5 8.5.002-.022-1.373-.549.742-1.857 5 2-.742 1.857-1.031-.413c-.014.014-.023.031-.037.044A1.499 1.499 0 0 1 7 10.5zM8 17s1-3 4-3 4 3 4 3H8zm8.986-6.507c0 .412-.167.785-.438 1.056a1.488 1.488 0 0 1-2.112 0c-.011-.011-.019-.024-.029-.035l-1.037.415-.742-1.857 5-2 .742 1.857-1.386.554a.036.036 0 0 1 .002.01z"
                }
            }
        ]
    })(props);
}
function BiSolidArch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 8V6H3v14H2v2h6v-7c0-.163.046-4 4-4 3.821 0 3.993 3.602 4 4v7h6v-2h-1V8zM2 2h20v2H2z"
                }
            }
        ]
    })(props);
}
function BiSolidArchiveIn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.706 5.292-2.999-2.999A.996.996 0 0 0 18 2H6a.997.997 0 0 0-.707.293L2.294 5.292A.996.996 0 0 0 2 6v13c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6a.994.994 0 0 0-.294-.708zM6.414 4h11.172l1 1H5.414l1-1zM12 18l-5-5h3v-3h4v3h3l-5 5z"
                }
            }
        ]
    })(props);
}
function BiSolidArchiveOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.706 5.292-2.999-2.999A.996.996 0 0 0 18 2H6a.996.996 0 0 0-.707.293L2.294 5.292A.994.994 0 0 0 2 6v13c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6a.994.994 0 0 0-.294-.708zM6.414 4h11.172l1 1H5.414l1-1zM14 14v3h-4v-3H7l5-5 5 5h-3z"
                }
            }
        ]
    })(props);
}
function BiSolidArchive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.704 5.29-2.997-2.997A.996.996 0 0 0 18 2H6a.996.996 0 0 0-.707.293L2.296 5.29A.994.994 0 0 0 2 5.999V19a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V5.999a.994.994 0 0 0-.296-.709zM6.414 4h11.172l1 1H5.414l1-1zM17 13v1H7v-4h2v2h6v-2h2v3z"
                }
            }
        ]
    })(props);
}
function BiSolidArea(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14zm9-13h6v6h-2V8h-4V6zm-6 6h2v4h4v2H6v-6z"
                }
            }
        ]
    })(props);
}
function BiSolidArrowFromBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18h12v2H6zm6-14-6 6h5v6h2v-6h5z"
                }
            }
        ]
    })(props);
}
function BiSolidArrowFromLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h2v12H4zm10 5H8v2h6v5l6-6-6-6z"
                }
            }
        ]
    })(props);
}
function BiSolidArrowFromRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6h2v12h-2zm-8 12v-5h6v-2h-6V6l-6 6z"
                }
            }
        ]
    })(props);
}
function BiSolidArrowFromTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4h12v2H6zm5 4v6H6l6 6 6-6h-5V8z"
                }
            }
        ]
    })(props);
}
function BiSolidArrowToBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18h12v2H6zm5-14v6H6l6 6 6-6h-5V4z"
                }
            }
        ]
    })(props);
}
function BiSolidArrowToLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h2v12H4zm10 7h6v-2h-6V6l-6 6 6 6z"
                }
            }
        ]
    })(props);
}
function BiSolidArrowToRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6h2v12h-2zm-8 5H4v2h6v5l6-6-6-6z"
                }
            }
        ]
    })(props);
}
function BiSolidArrowToTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4h12v2H6zm5 10v6h2v-6h5l-6-6-6 6z"
                }
            }
        ]
    })(props);
}
function BiSolidAward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8.999a6.99 6.99 0 0 0 2.879 5.646l.001.001a6.972 6.972 0 0 0 1.881.979l.051.019a6.906 6.906 0 0 0 1.163.271 6.79 6.79 0 0 0 1.024.085H12c.35 0 .69-.034 1.027-.084l.182-.028c.336-.059.664-.139.981-.243l.042-.016C17 14.693 19 12.078 19 8.999 19 5.14 15.86 2 12 2S5 5.14 5 8.999zM12 4c2.756 0 5 2.242 5 4.999h-2A3.003 3.003 0 0 0 12 6V4zM7.521 16.795V22L12 20.5l4.479 1.5.001-5.205a8.932 8.932 0 0 1-8.959 0z"
                }
            }
        ]
    })(props);
}
function BiSolidBabyCarriage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.666 12.277a7.72 7.72 0 0 0 .171-.665c.003-.017.004-.033.008-.05.02-.098.029-.199.045-.298.025-.157.055-.313.07-.471a7.979 7.979 0 0 0-2.303-6.45A7.979 7.979 0 0 0 14 2v8H6.517l-.858-2H2v2h2.341l1.828 4.266A3.504 3.504 0 0 0 4 17.5C4 19.43 5.57 21 7.5 21c1.759 0 3.204-1.309 3.449-3h2.102c.245 1.691 1.69 3 3.449 3 1.93 0 3.5-1.57 3.5-3.5 0-.63-.181-1.213-.473-1.725.042-.041.089-.077.131-.119.36-.361.688-.759.977-1.184.288-.43.536-.886.736-1.359.016-.037.026-.076.041-.113h.001l.015-.042c.088-.22.168-.441.235-.668l.003-.013zM7.5 19c-.827 0-1.5-.673-1.5-1.5S6.673 16 7.5 16s1.5.673 1.5 1.5S8.327 19 7.5 19zm9 0c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function BiSolidBackpack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 15a1 1 0 0 0-1-1H9c-.551 0-1 .448-1 1v2h8v-2zm-8 4h8v3H8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12c0-2.967-2.167-5.432-5-5.91V5c0-1.654-1.346-3-3-3h-2C9.346 2 8 3.346 8 5v1.09C5.167 6.568 3 9.033 3 12v8c0 1.103.897 2 2 2h1v-7c0-1.654 1.346-3 3-3h6c1.654 0 3 1.346 3 3v7h1c1.103 0 2-.897 2-2v-8zM10 5c0-.552.449-1 1-1h2a1 1 0 0 1 1 1v1h-4V5z"
                }
            }
        ]
    })(props);
}
function BiSolidBadgeCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.965 8.521C19.988 8.347 20 8.173 20 8c0-2.379-2.143-4.288-4.521-3.965C14.786 2.802 13.466 2 12 2s-2.786.802-3.479 2.035C6.138 3.712 4 5.621 4 8c0 .173.012.347.035.521C2.802 9.215 2 10.535 2 12s.802 2.785 2.035 3.479A3.976 3.976 0 0 0 4 16c0 2.379 2.138 4.283 4.521 3.965C9.214 21.198 10.534 22 12 22s2.786-.802 3.479-2.035C17.857 20.283 20 18.379 20 16c0-.173-.012-.347-.035-.521C21.198 14.785 22 13.465 22 12s-.802-2.785-2.035-3.479zm-9.01 7.895-3.667-3.714 1.424-1.404 2.257 2.286 4.327-4.294 1.408 1.42-5.749 5.706z"
                }
            }
        ]
    })(props);
}
function BiSolidBadgeDollar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.047 14.668a.994.994 0 0 0 .465.607l1.91 1.104v2.199a1 1 0 0 0 1 1h2.199l1.104 1.91a1.01 1.01 0 0 0 .866.5c.174 0 .347-.046.501-.135L12 20.75l1.91 1.104a1.001 1.001 0 0 0 1.366-.365l1.103-1.91h2.199a1 1 0 0 0 1-1V16.38l1.91-1.104a1 1 0 0 0 .365-1.367L20.75 12l1.104-1.908a1 1 0 0 0-.365-1.366l-1.91-1.104v-2.2a1 1 0 0 0-1-1H16.38l-1.103-1.909a1.008 1.008 0 0 0-.607-.466.993.993 0 0 0-.759.1L12 3.25l-1.909-1.104a1 1 0 0 0-1.366.365l-1.104 1.91H5.422a1 1 0 0 0-1 1V7.62l-1.91 1.104a1.003 1.003 0 0 0-.365 1.368L3.251 12l-1.104 1.908a1.009 1.009 0 0 0-.1.76zM12 13c-3.48 0-4-1.879-4-3 0-1.287 1.029-2.583 3-2.915V6.012h2v1.109c1.734.41 2.4 1.853 2.4 2.879h-1l-1 .018C13.386 9.638 13.185 9 12 9c-1.299 0-2 .515-2 1 0 .374 0 1 2 1 3.48 0 4 1.879 4 3 0 1.287-1.029 2.583-3 2.915V18h-2v-1.08c-2.339-.367-3-2.003-3-2.92h2c.011.143.159 1 2 1 1.38 0 2-.585 2-1 0-.325 0-1-2-1z"
                }
            }
        ]
    })(props);
}
function BiSolidBadge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.965 8.521C19.988 8.347 20 8.173 20 8c0-2.379-2.143-4.288-4.521-3.965C14.786 2.802 13.466 2 12 2s-2.786.802-3.479 2.035C6.138 3.712 4 5.621 4 8c0 .173.012.347.035.521C2.802 9.215 2 10.535 2 12s.802 2.785 2.035 3.479A3.976 3.976 0 0 0 4 16c0 2.379 2.138 4.283 4.521 3.965C9.214 21.198 10.534 22 12 22s2.786-.802 3.479-2.035C17.857 20.283 20 18.379 20 16c0-.173-.012-.347-.035-.521C21.198 14.785 22 13.465 22 12s-.802-2.785-2.035-3.479z"
                }
            }
        ]
    })(props);
}
function BiSolidBaguette(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.13 4.41 4.23 4.23L14.3 9.7l-4.24-4.24-1.77 1.77 4.24 4.24-1.06 1.06-4.24-4.24-1.77 1.77L9.7 14.3l-1.06 1.06-4.23-4.23C1.86 14 1.55 18 3.79 20.21a5.38 5.38 0 0 0 3.85 1.5 8 8 0 0 0 5.6-2.47l6-6c2.87-2.87 3.31-7.11 1-9.45s-6.24-1.93-9.11.62z"
                }
            }
        ]
    })(props);
}
function BiSolidBall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.247 3.034c-.069-.018-1.742-.433-4.052-.433-2.842 0-6.868.64-9.91 3.687-5.34 5.349-3.34 13.61-3.252 13.96a1 1 0 0 0 .728.726c.069.018 1.726.426 4.018.426 2.849 0 6.884-.641 9.932-3.688 5.335-5.335 3.351-13.6 3.264-13.949a1.005 1.005 0 0 0-.728-.729zm-3.537 9.262-1.414 1.414-1.793-1.792-1.586 1.586 1.792 1.793-1.414 1.414-1.792-1.793-1.793 1.793-1.414-1.414 1.793-1.793-1.793-1.794 1.414-1.414 1.793 1.794 1.586-1.586-1.794-1.793 1.414-1.414 1.794 1.793 1.793-1.793 1.414 1.414-1.793 1.793 1.793 1.792z"
                }
            }
        ]
    })(props);
}
function BiSolidBalloon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 19.91 10 22h4l-1-2.09c4-.65 7-5.28 7-9.91a8 8 0 0 0-16 0c0 4.63 3.08 9.26 7 9.91zm1-15.66v1.5A4.26 4.26 0 0 0 7.75 10h-1.5A5.76 5.76 0 0 1 12 4.25z"
                }
            }
        ]
    })(props);
}
function BiSolidBandAid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.646 3.868-7.778 7.778a6.007 6.007 0 0 0 0 8.485 5.984 5.984 0 0 0 4.242 1.754 5.984 5.984 0 0 0 4.243-1.754l7.778-7.778a6.007 6.007 0 0 0 0-8.485 6.008 6.008 0 0 0-8.485 0zM9 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm3 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-6a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm3 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                }
            }
        ]
    })(props);
}
function BiSolidBank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8v4.001h1V18H2v3h16l3 .001V21h1v-3h-1v-5.999h1V8L12 2 2 8zm4 10v-5.999h2V18H6zm5 0v-5.999h2V18h-2zm7 0h-2v-5.999h2V18zM14 8a2 2 0 1 1-4.001-.001A2 2 0 0 1 14 8z"
                }
            }
        ]
    })(props);
}
function BiSolidBarChartAlt2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 21H3a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1zm7 0h-3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v17a1 1 0 0 1-1 1zm7 0h-3a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1z"
                }
            }
        ]
    })(props);
}
function BiSolidBarChartSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2zM9 18H7v-6h2v6zm4 0h-2V7h2v11zm4 0h-2v-8h2v8z"
                }
            }
        ]
    })(props);
}
function BiSolidBarcode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM8 17H5V7h3zm2 0H9V7h1zm2 0h-1V7h1zm4 0h-3V7h3zm3 0h-2V7h2z"
                }
            }
        ]
    })(props);
}
function BiSolidBaseball(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.984 12.236a9.966 9.966 0 0 0-2.913-7.308 9.966 9.966 0 0 0-7.308-2.913 9.04 9.04 0 0 1-.673 4.313l-1.84-.78a7.044 7.044 0 0 0 .526-3.284 9.927 9.927 0 0 0-4.847 2.665 9.924 9.924 0 0 0-2.666 4.852 7.082 7.082 0 0 0 2.576-.276l.575 1.916c-1.1.33-2.257.443-3.398.344a9.964 9.964 0 0 0 2.913 7.307 9.965 9.965 0 0 0 7.307 2.913 9.079 9.079 0 0 1 .344-3.398l1.916.575a7.06 7.06 0 0 0-.276 2.576 9.927 9.927 0 0 0 4.853-2.666 9.926 9.926 0 0 0 2.665-4.848 7.056 7.056 0 0 0-3.284.526l-.78-1.841a9.025 9.025 0 0 1 4.31-.673zM9.17 9.173a9.017 9.017 0 0 1-2.192 1.612l-.927-1.772a7.01 7.01 0 0 0 2.576-2.314l1.663 1.113c-.328.49-.705.948-1.12 1.361zm7.074 7.068a6.991 6.991 0 0 0-1.257 1.708l-1.772-.927a9.025 9.025 0 0 1 2.972-3.312l1.113 1.663a6.987 6.987 0 0 0-1.056.868z"
                }
            }
        ]
    })(props);
}
function BiSolidBasket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.132 2.504 4.42 9H3a1.001 1.001 0 0 0-.965 1.263l2.799 10.263A2.004 2.004 0 0 0 6.764 22h10.473c.898 0 1.692-.605 1.93-1.475l2.799-10.263A.998.998 0 0 0 21 9h-1.42l-3.712-6.496-1.736.992L17.277 9H6.723l3.145-5.504-1.736-.992zM14 13h2v5h-2v-5zm-6 0h2v5H8v-5z"
                }
            }
        ]
    })(props);
}
function BiSolidBasketball(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.328 4.258a9.953 9.953 0 0 0-5.949-2.235 8.99 8.99 0 0 1-1.835 7.107L12 10.586l6.328-6.328zM7.701 9.115 4.258 5.672a9.938 9.938 0 0 0-2.112 4.704 7.007 7.007 0 0 0 5.555-1.261zm12.041-3.443L13.414 12l1.456 1.456a8.993 8.993 0 0 1 7.107-1.835 9.953 9.953 0 0 0-2.235-5.949zm2.112 7.952a7.007 7.007 0 0 0-5.555 1.261l3.443 3.443a9.924 9.924 0 0 0 2.112-4.704zM9.115 7.701a7.007 7.007 0 0 0 1.261-5.555 9.928 9.928 0 0 0-4.704 2.112l3.443 3.443zm4.509 14.153a9.936 9.936 0 0 0 4.704-2.111L14.885 16.3a7.003 7.003 0 0 0-1.261 5.554zM12 13.414l-6.328 6.328a9.953 9.953 0 0 0 5.949 2.235 8.99 8.99 0 0 1 1.835-7.107L12 13.414zm-7.742 4.914L10.586 12 9.13 10.544a8.993 8.993 0 0 1-7.107 1.835 9.953 9.953 0 0 0 2.235 5.949z"
                }
            }
        ]
    })(props);
}
function BiSolidBath(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10H7V7.113c0-.997.678-1.923 1.661-2.085A2.003 2.003 0 0 1 11 7h2a4.003 4.003 0 0 0-4.398-3.98C6.523 3.222 5 5.089 5 7.178V10H3a1 1 0 0 0-1 1v2c0 2.606 1.674 4.823 4 5.65V22h2v-3h8v3h2v-3.35c2.326-.827 4-3.044 4-5.65v-2a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function BiSolidBatteryCharging(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10V8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2h2v-4h-2zM9 17l2-3.89L7 12l6-5-1 3.89L16 12l-7 5z"
                }
            }
        ]
    })(props);
}
function BiSolidBatteryFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18h14a2 2 0 0 0 2-2v-2h2v-4h-2V8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2zm1-9h12v6H5V9z"
                }
            }
        ]
    })(props);
}
function BiSolidBatteryLow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2h2v-4h-2V8zM5 15V9h3l4 6H5z"
                }
            }
        ]
    })(props);
}
function BiSolidBattery(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2h2v-4h-2V8z"
                }
            }
        ]
    })(props);
}
function BiSolidBed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9.556V3h-2v2H6V3H4v6.557C2.81 10.25 2 11.526 2 13v4a1 1 0 0 0 1 1h1v4h2v-4h12v4h2v-4h1a1 1 0 0 0 1-1v-4c0-1.474-.811-2.75-2-3.444zM11 9H6V7h5v2zm7 0h-5V7h5v2z"
                }
            }
        ]
    })(props);
}
function BiSolidBeenHere(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C7.589 2 4 5.589 4 9.995 3.971 16.44 11.696 21.784 12 22c0 0 8.029-5.56 8-12 0-4.411-3.589-8-8-8zm-1 13.414-3.707-3.707 1.414-1.414L11 12.586l5.293-5.293 1.414 1.414L11 15.414z"
                }
            }
        ]
    })(props);
}
function BiSolidBeer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-2V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v15c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3v-1h2c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zM8 17H6V7h2v10zm6 0h-2V7h2v10zm6-1h-2V8h2v8z"
                }
            }
        ]
    })(props);
}
function BiSolidBellMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22zm8.707-5.707L19 14.586V10c0-3.217-2.185-5.926-5.145-6.743C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258C7.185 4.074 5 6.783 5 10v4.586l-1.707 1.707A.997.997 0 0 0 3 17v1a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-1a.997.997 0 0 0-.293-.707zM16 12H8v-2h8v2z"
                }
            }
        ]
    })(props);
}
function BiSolidBellOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.345 18.931A.993.993 0 0 0 21 18v-1a.996.996 0 0 0-.293-.707L19 14.586V10c0-3.217-2.185-5.927-5.145-6.742C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258c-1.323.364-2.463 1.128-3.346 2.127L3.707 2.293 2.293 3.707l18 18 1.414-1.414-1.362-1.362zM12 22a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22zM5 10v4.586l-1.707 1.707A.996.996 0 0 0 3 17v1a1 1 0 0 0 1 1h10.879L5.068 9.189C5.037 9.457 5 9.724 5 10z"
                }
            }
        ]
    })(props);
}
function BiSolidBellPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22zm8.707-5.707L19 14.586V10c0-3.217-2.185-5.926-5.145-6.743C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258C7.185 4.074 5 6.783 5 10v4.586l-1.707 1.707A.997.997 0 0 0 3 17v1a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-1a.997.997 0 0 0-.293-.707zM16 12h-3v3h-2v-3H8v-2h3V7h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function BiSolidBellRing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m5.705 3.71-1.41-1.42C1 5.563 1 7.935 1 11h1l1-.063C3 8.009 3 6.396 5.705 3.71zm13.999-1.42-1.408 1.42C21 6.396 21 8.009 21 11l2-.063c0-3.002 0-5.374-3.296-8.647zM12 22a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22zm7-7.414V10c0-3.217-2.185-5.927-5.145-6.742C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258C7.184 4.073 5 6.783 5 10v4.586l-1.707 1.707A.996.996 0 0 0 3 17v1a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-1a.996.996 0 0 0-.293-.707L19 14.586z"
                }
            }
        ]
    })(props);
}
function BiSolidBell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22zm7-7.414V10c0-3.217-2.185-5.927-5.145-6.742C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258C7.185 4.074 5 6.783 5 10v4.586l-1.707 1.707A.996.996 0 0 0 3 17v1a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-1a.996.996 0 0 0-.293-.707L19 14.586z"
                }
            }
        ]
    })(props);
}
function BiSolidBible(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22h15v-2H6.012C5.55 19.988 5 19.805 5 19s.55-.988 1.012-1H21V4a2 2 0 0 0-2-2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3zM8 7h3V5h2v2h3v2h-3v6h-2V9H8V7z"
                }
            }
        ]
    })(props);
}
function BiSolidBinoculars(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.447 5.345A3.27 3.27 0 0 0 16.29 3a3.293 3.293 0 0 0-3.277 3h-2.025a3.297 3.297 0 0 0-3.284-3 3.268 3.268 0 0 0-3.151 2.345l-2.511 8.368A1.027 1.027 0 0 0 2 14v1a5.006 5.006 0 0 0 5.001 5 5.003 5.003 0 0 0 4.576-3h.846a5.003 5.003 0 0 0 4.576 3A5.006 5.006 0 0 0 22 14.999V14c0-.098-.015-.194-.042-.287l-2.511-8.368zM7.001 18A3.005 3.005 0 0 1 4 15c0-.076.017-.147.022-.222A2.995 2.995 0 0 1 7 12a3 3 0 0 1 3 3v.009A3.004 3.004 0 0 1 7.001 18zm9.998 0A3.004 3.004 0 0 1 14 15.009V15a3 3 0 0 1 6-.001A3.005 3.005 0 0 1 16.999 18z"
                }
            }
        ]
    })(props);
}
function BiSolidBlanket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H7C4.243 2 2 4.243 2 7v10c0 2.757 2.243 5 5 5h12c1.654 0 3-1.346 3-3s-1.346-3-3-3H6v2h13a1 1 0 0 1 0 2H7c-1.654 0-3-1.346-3-3s1.346-3 3-3h13c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM4 13h.003L4 13.002V13z"
                }
            }
        ]
    })(props);
}
function BiSolidBoltCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-1 16v-5H7l6-7v5h4l-6 7z"
                }
            }
        ]
    })(props);
}
function BiSolidBolt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.168 8H13l.806-4.835A1 1 0 0 0 12.819 2H7.667a1 1 0 0 0-.986.835l-1.667 10A1 1 0 0 0 6 14h4v8l8.01-12.459A1 1 0 0 0 17.168 8z"
                }
            }
        ]
    })(props);
}
function BiSolidBomb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m18.293 4.293-1.086 1.086-1.086-1.086a.999.999 0 0 0-1.414 0l-1.249 1.249A8.427 8.427 0 0 0 10.499 5C5.813 5 2 8.813 2 13.5S5.813 22 10.499 22s8.5-3.813 8.5-8.5a8.42 8.42 0 0 0-.431-2.654L19.914 9.5a.999.999 0 0 0 0-1.414l-1.293-1.293 1.09-1.09C19.94 5.474 20.556 5 21 5h1V3h-1c-1.4 0-2.584 1.167-2.707 1.293zM10.499 10c-.935 0-1.813.364-2.475 1.025A3.48 3.48 0 0 0 7 13.5H5c0-1.468.571-2.849 1.609-3.888A5.464 5.464 0 0 1 10.499 8v2z"
                }
            }
        ]
    })(props);
}
function BiSolidBone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.852 5.148a3.317 3.317 0 0 0-.96-2.183 3.333 3.333 0 1 0-4.713 4.714l-5.499 5.5a3.333 3.333 0 1 0-4.714 4.713c.606.606 1.39.918 2.183.96.042.793.354 1.576.96 2.183a3.333 3.333 0 1 0 4.713-4.714l5.499-5.499a3.333 3.333 0 1 0 4.714-4.713 3.313 3.313 0 0 0-2.183-.961z"
                }
            }
        ]
    })(props);
}
function BiSolidBong(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19.293 8.293-2.069 2.069A7.017 7.017 0 0 0 15 8.681V4h1V2H8v2h1v4.681A7.01 7.01 0 0 0 5 15c0 3.859 3.141 7 7 7s7-3.141 7-7a6.958 6.958 0 0 0-.652-2.934l2.359-2.359-1.414-1.414zm-8.959 1.998.666-.235V4h2v6.056l.666.235A5.006 5.006 0 0 1 16.886 14H7.114a5.006 5.006 0 0 1 3.22-3.709z"
                }
            }
        ]
    })(props);
}
function BiSolidBookAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.012 18H21V4c0-1.103-.897-2-2-2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.806 5 19s.55-.988 1.012-1zM8 9h3V6h2v3h3v2h-3v3h-2v-3H8V9z"
                }
            }
        ]
    })(props);
}
function BiSolidBookAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.806 5 19s.55-.988 1.012-1H21V4c0-1.103-.897-2-2-2H6c-1.206 0-3 .799-3 3z"
                }
            }
        ]
    })(props);
}
function BiSolidBookBookmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.806 5 19c0-.101.009-.191.024-.273.112-.576.584-.717.988-.727H21V4a2 2 0 0 0-2-2zm0 9-2-1-2 1V4h4v7z"
                }
            }
        ]
    })(props);
}
function BiSolidBookContent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm-1 4v2h-5V7h5zm-5 4h5v2h-5v-2zM4 19V5h7v14H4z"
                }
            }
        ]
    })(props);
}
function BiSolidBookHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.012 18H21V4c0-1.103-.897-2-2-2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.806 5 19c0-.101.009-.191.024-.273.112-.576.584-.717.988-.727zM8.648 7.642a2.224 2.224 0 0 1 3.125 0l.224.219.223-.219a2.225 2.225 0 0 1 3.126 0 2.129 2.129 0 0 1 0 3.069L11.998 14l-3.349-3.289a2.128 2.128 0 0 1-.001-3.069z"
                }
            }
        ]
    })(props);
}
function BiSolidBookOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3h-7a2.98 2.98 0 0 0-2 .78A2.98 2.98 0 0 0 10 3H3a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h5.758a2.01 2.01 0 0 1 1.414.586l1.121 1.121c.009.009.021.012.03.021.086.08.182.15.294.196h.002a.996.996 0 0 0 .762 0h.002c.112-.046.208-.117.294-.196.009-.009.021-.012.03-.021l1.121-1.121A2.01 2.01 0 0 1 15.242 20H21a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-1 15h-4.758a4.03 4.03 0 0 0-2.242.689V6c0-.551.448-1 1-1h6v13z"
                }
            }
        ]
    })(props);
}
function BiSolidBookReader(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8v11.529S6.621 19.357 12 22c5.379-2.643 10-2.471 10-2.471V8s-5.454 0-10 2.471C7.454 8 2 8 2 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "5",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function BiSolidBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.012 18H21V4a2 2 0 0 0-2-2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.805 5 19s.55-.988 1.012-1zM8 6h9v2H8V6z"
                }
            }
        ]
    })(props);
}
function BiSolidBookmarkAltMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 2h-12C4.57 2 3 3.57 3 5.5V22l7-3.5 7 3.5v-9h5V5.5C22 3.57 20.43 2 18.5 2zM13 11H7V9h6v2zm7 0h-3V5.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5V11z"
                }
            }
        ]
    })(props);
}
function BiSolidBookmarkAltPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 2h-12C4.57 2 3 3.57 3 5.5V22l7-3.5 7 3.5v-9h5V5.5C22 3.57 20.43 2 18.5 2zM13 11h-2v2H9v-2H7V9h2V7h2v2h2v2zm7 0h-3V5.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5V11z"
                }
            }
        ]
    })(props);
}
function BiSolidBookmarkAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 2h-12C4.57 2 3 3.57 3 5.5V22l7-3.5 7 3.5v-9h5V5.5C22 3.57 20.43 2 18.5 2zm1.5 9h-3V5.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5V11z"
                }
            }
        ]
    })(props);
}
function BiSolidBookmarkHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 22V4c0-1.103-.897-2-2-2H7c-1.103 0-2 .897-2 2v18l7-4.666L19 22zM8.006 8.056c0-.568.224-1.083.585-1.456.361-.372.86-.603 1.412-.603 0 0 .996-.003 1.997 1.029 1.001-1.032 1.997-1.029 1.997-1.029.552 0 1.051.23 1.412.603s.585.888.585 1.456-.224 1.084-.585 1.456L12 13.203 8.591 9.512a2.083 2.083 0 0 1-.585-1.456z"
                }
            }
        ]
    })(props);
}
function BiSolidBookmarkMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2H7a2 2 0 0 0-2 2v18l7-4.848L19 22V4a2 2 0 0 0-2-2zm-1 9H8V9h8v2z"
                }
            }
        ]
    })(props);
}
function BiSolidBookmarkPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2H7a2 2 0 0 0-2 2v18l7-4.848L19 22V4a2 2 0 0 0-2-2zm-1 9h-3v3h-2v-3H8V9h3V6h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function BiSolidBookmarkStar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11.222 14.667 13l-.89-3.111L16 8l-2.667-.333L12 5l-1.333 2.667L8 8l2.223 1.889L9.333 13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21.723V4a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v17.723l7-4.571 7 4.571zM8 8l2.667-.333L12 5l1.333 2.667L16 8l-2.223 1.889.89 3.111L12 11.222 9.333 13l.89-3.111L8 8z"
                }
            }
        ]
    })(props);
}
function BiSolidBookmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10.132v-6c0-1.103-.897-2-2-2H7c-1.103 0-2 .897-2 2V22l7-4.666L19 22V10.132z"
                }
            }
        ]
    })(props);
}
function BiSolidBookmarks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.999 23V7c0-1.103-.897-2-2-2h-8c-1.103 0-2 .897-2 2v16l6-3.601 6 3.601z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.585 3h1.414c1.103 0 2 .897 2 2v10.443l2 2.489V3c0-1.103-.897-2-2-2h-8c-1.103 0-2 .897-2 2h6.586z"
                }
            }
        ]
    })(props);
}
function BiSolidBot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10.975V8a2 2 0 0 0-2-2h-6V4.688c.305-.274.5-.668.5-1.11a1.5 1.5 0 0 0-3 0c0 .442.195.836.5 1.11V6H5a2 2 0 0 0-2 2v2.998l-.072.005A.999.999 0 0 0 2 12v2a1 1 0 0 0 1 1v5a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5a1 1 0 0 0 1-1v-1.938a1.004 1.004 0 0 0-.072-.455c-.202-.488-.635-.605-.928-.632zM7 12c0-1.104.672-2 1.5-2s1.5.896 1.5 2-.672 2-1.5 2S7 13.104 7 12zm8.998 6c-1.001-.003-7.997 0-7.998 0v-2s7.001-.002 8.002 0l-.004 2zm-.498-4c-.828 0-1.5-.896-1.5-2s.672-2 1.5-2 1.5.896 1.5 2-.672 2-1.5 2z"
                }
            }
        ]
    })(props);
}
function BiSolidBowlHot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10H3a1 1 0 0 0-1 1 10 10 0 0 0 5 8.66V21a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1.34A10 10 0 0 0 22 11a1 1 0 0 0-1-1zM9 9V7.93a4.51 4.51 0 0 0-1.28-3.15A2.49 2.49 0 0 1 7 3V2H5v1a4.51 4.51 0 0 0 1.28 3.17A2.49 2.49 0 0 1 7 7.93V9zm4 0V7.93a4.51 4.51 0 0 0-1.28-3.15A2.49 2.49 0 0 1 11 3V2H9v1a4.51 4.51 0 0 0 1.28 3.15A2.49 2.49 0 0 1 11 7.93V9zm4 0V7.93a4.51 4.51 0 0 0-1.28-3.15A2.49 2.49 0 0 1 15 3V2h-2v1a4.51 4.51 0 0 0 1.28 3.15A2.49 2.49 0 0 1 15 7.93V9z"
                }
            }
        ]
    })(props);
}
function BiSolidBowlRice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10a3.58 3.58 0 0 0-1.8-3 3.66 3.66 0 0 0-3.63-3.13 3.86 3.86 0 0 0-1 .13 3.7 3.7 0 0 0-5.11 0 3.86 3.86 0 0 0-1-.13A3.66 3.66 0 0 0 4.81 7 3.58 3.58 0 0 0 3 10a1 1 0 0 0-1 1 10 10 0 0 0 5 8.66V21a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1.34A10 10 0 0 0 22 11a1 1 0 0 0-1-1zM5 10a1.59 1.59 0 0 1 1.11-1.39l.83-.26-.16-.85a1.64 1.64 0 0 1 1.66-1.62 1.78 1.78 0 0 1 .83.2l.81.45.5-.77a1.71 1.71 0 0 1 2.84 0l.5.77.81-.45a1.78 1.78 0 0 1 .83-.2 1.65 1.65 0 0 1 1.67 1.6l-.16.85.82.28A1.59 1.59 0 0 1 19 10z"
                }
            }
        ]
    })(props);
}
function BiSolidBowlingBall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM6.5 12a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 6.5 12zM9 6.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 9 6.5zm2.5 6.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 11.5 13z"
                }
            }
        ]
    })(props);
}
function BiSolidBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3h20v4H2zm17 5H3v11a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8h-2zm-3 6H8v-2h8v2z"
                }
            }
        ]
    })(props);
}
function BiSolidBrain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.299 17.596c.432 1.332 1.745 2.182 3.146 2.182H6.5A2.78 2.78 0 0 0 9.223 22c.457 0 .884-.115 1.262-.313a.992.992 0 0 0 .515-.882V3.027a.997.997 0 0 0-.785-.983 2.324 2.324 0 0 0-1.479.201c-.744.356-1.18 1.151-1.18 1.978v.055a2.778 2.778 0 0 0-2.744 4.433A3.327 3.327 0 0 0 2 12c0 1.178.611 2.211 1.533 2.812-.43.771-.571 1.746-.234 2.784zm15.889-8.885a2.778 2.778 0 0 0-2.744-4.433v-.055c0-.826-.437-1.622-1.181-1.978a2.32 2.32 0 0 0-1.478-.201.998.998 0 0 0-.785.983v17.777c0 .365.192.712.516.882.378.199.804.314 1.261.314a2.78 2.78 0 0 0 2.723-2.223h.056c1.4 0 2.714-.85 3.146-2.182.337-1.038.196-2.013-.234-2.784A3.35 3.35 0 0 0 22 12a3.327 3.327 0 0 0-2.812-3.289z"
                }
            }
        ]
    })(props);
}
function BiSolidBriefcaseAlt2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-3V4c0-1.103-.897-2-2-2H9c-1.103 0-2 .897-2 2v2H4c-1.103 0-2 .897-2 2v4h5v-2h2v2h6v-2h2v2h5V8c0-1.103-.897-2-2-2zM9 4h6v2H9V4zm8 11h-2v-2H9v2H7v-2H2v6c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-6h-5v2z"
                }
            }
        ]
    })(props);
}
function BiSolidBriefcaseAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-3V4c0-1.103-.897-2-2-2H9c-1.103 0-2 .897-2 2v2H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zM6 8h2v11H6V8zm12 11h-2V8h2v11zM15 4v2H9V4h6z"
                }
            }
        ]
    })(props);
}
function BiSolidBriefcase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-3V4c0-1.103-.897-2-2-2H9c-1.103 0-2 .897-2 2v2H4c-1.103 0-2 .897-2 2v3h20V8c0-1.103-.897-2-2-2zM9 4h6v2H9V4zm5 10h-4v-2H2v7c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-7h-8v2z"
                }
            }
        ]
    })(props);
}
function BiSolidBrightnessHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.546 11.646 19 9.101V5.5a.5.5 0 0 0-.5-.5h-3.601l-2.546-2.546a.5.5 0 0 0-.707 0L9.101 5H5.5a.5.5 0 0 0-.5.5v3.601l-2.546 2.546a.5.5 0 0 0 0 .707L5 14.899V18.5a.5.5 0 0 0 .5.5h3.601l2.546 2.546a.5.5 0 0 0 .707 0L14.899 19H18.5a.5.5 0 0 0 .5-.5v-3.601l2.546-2.546a.5.5 0 0 0 0-.707zM12 8a4 4 0 0 1 0 8"
                }
            }
        ]
    })(props);
}
function BiSolidBrightness(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.546 11.646 19 9.101V5.5a.5.5 0 0 0-.5-.5h-3.601l-2.546-2.546a.5.5 0 0 0-.707 0L9.101 5H5.5a.5.5 0 0 0-.5.5v3.601l-2.546 2.546a.5.5 0 0 0 0 .707L5 14.899V18.5a.5.5 0 0 0 .5.5h3.601l2.546 2.546a.5.5 0 0 0 .707 0L14.899 19H18.5a.5.5 0 0 0 .5-.5v-3.601l2.546-2.546a.5.5 0 0 0 0-.707zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8z"
                }
            }
        ]
    })(props);
}
function BiSolidBrushAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8.001h-2V8h-1V4.999a2.92 2.92 0 0 0-.874-2.108 2.943 2.943 0 0 0-2.39-.879C10.202 2.144 9 3.508 9 5.117V8H6c-1.103 0-2 .897-2 2v11a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V10.001c0-1.103-.897-2-2-2zM6 12v-2h5V5.117c0-.57.407-1.07 1.002-1.117.266 0 .512.103.712.307a.956.956 0 0 1 .286.692V10h.995l.005.001h4V12H6z"
                }
            }
        ]
    })(props);
}
function BiSolidBrush(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.207 11.278-2.035-2.035-1.415-1.415-5.035-5.035a.999.999 0 0 0-1.414 0L6.151 7.949 4.736 9.363a2.985 2.985 0 0 0-.878 2.122c0 .802.313 1.556.879 2.121l.707.707-2.122 2.122a2.925 2.925 0 0 0-.873 2.108 2.968 2.968 0 0 0 1.063 2.308 2.92 2.92 0 0 0 1.886.681c.834 0 1.654-.341 2.25-.937l2.039-2.039.707.706c1.133 1.133 3.107 1.134 4.242.001l.708-.707.569-.569.138-.138 5.156-5.157a.999.999 0 0 0 0-1.414zm-7.277 5.865-.708.706a1.021 1.021 0 0 1-1.414 0l-1.414-1.413a.999.999 0 0 0-1.414 0l-2.746 2.745a1.192 1.192 0 0 1-.836.352.914.914 0 0 1-.595-.208.981.981 0 0 1-.354-.782.955.955 0 0 1 .287-.692l2.829-2.829a.999.999 0 0 0 0-1.414l-1.414-1.415c-.189-.188-.293-.438-.293-.706s.104-.519.293-.708l.707-.707 3.536 3.536 3.536 3.535z"
                }
            }
        ]
    })(props);
}
function BiSolidBugAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m18 5.414 1.707-1.707-1.414-1.414-1.563 1.562C15.483 2.708 13.824 2 12 2s-3.483.708-4.73 1.855L5.707 2.293 4.293 3.707 6 5.414A6.937 6.937 0 0 0 5 9H3v2h2v2H3v2h2c0 3.86 3.141 7 7 7s7-3.14 7-7h2v-2h-2v-2h2V9h-2a6.937 6.937 0 0 0-1-3.586zM15 15H9v-2h6v2zm0-4H9V9h6v2z"
                }
            }
        ]
    })(props);
}
function BiSolidBug(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.787 7h10.426c-.108-.158-.201-.331-.318-.481l2.813-2.812-1.414-1.414-2.846 2.846a6.575 6.575 0 0 0-.723-.454 5.778 5.778 0 0 0-5.45 0c-.25.132-.488.287-.722.453L5.707 2.293 4.293 3.707l2.813 2.812c-.118.151-.21.323-.319.481zM5.756 9H2v2h2.307c-.065.495-.107.997-.107 1.5 0 .507.042 1.013.107 1.511H2v2h2.753c.013.039.021.08.034.118.188.555.421 1.093.695 1.6.044.081.095.155.141.234l-2.33 2.33 1.414 1.414 2.11-2.111a7.477 7.477 0 0 0 2.068 1.619c.479.253.982.449 1.496.58.204.052.411.085.618.118V16h2v5.914a6.23 6.23 0 0 0 .618-.118 6.812 6.812 0 0 0 1.496-.58c.465-.246.914-.55 1.333-.904.258-.218.5-.462.734-.716l2.111 2.111 1.414-1.414-2.33-2.33c.047-.08.098-.155.142-.236.273-.505.507-1.043.694-1.599.013-.039.021-.079.034-.118H22v-2h-2.308c.065-.499.107-1.004.107-1.511 0-.503-.042-1.005-.106-1.5H22V9H5.756z"
                }
            }
        ]
    })(props);
}
function BiSolidBuildingHouse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.991 2H9.01C7.899 2 7 2.899 7 4.01v5.637l-4.702 4.642A1 1 0 0 0 3 16v5a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4.009C21 2.899 20.102 2 18.991 2zm-8.069 13.111V20H5v-5.568l2.987-2.949 2.935 3.003v.625zM13 9h-2V7h2v2zm4 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15h2v2H7z"
                }
            }
        ]
    })(props);
}
function BiSolidBuilding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2H7a2 2 0 0 0-2 2v17a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a2 2 0 0 0-2-2zm-6 14H8v-2h3v2zm0-4H8v-2h3v2zm0-4H8V6h3v2zm5 8h-3v-2h3v2zm0-4h-3v-2h3v2zm0-4h-3V6h3v2z"
                }
            }
        ]
    })(props);
}
function BiSolidBuildings(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14.001h2v2H7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2h-8a2 2 0 0 0-2 2v6H5c-1.103 0-2 .897-2 2v9a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a2 2 0 0 0-2-2zM5 20v-8h6v8H5zm9-12h-2V6h2v2zm4 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V6h2v2z"
                }
            }
        ]
    })(props);
}
function BiSolidBulb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 20h6v2H9zm7.906-6.288C17.936 12.506 19 11.259 19 9c0-3.859-3.141-7-7-7S5 5.141 5 9c0 2.285 1.067 3.528 2.101 4.73.358.418.729.851 1.084 1.349.144.206.38.996.591 1.921h-.792v2h8.032v-2h-.79c.213-.927.45-1.719.593-1.925.352-.503.726-.94 1.087-1.363z"
                }
            }
        ]
    })(props);
}
function BiSolidBullseye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 17c-3.859 0-7-3.14-7-7s3.141-7 7-7 7 3.14 7 7-3.141 7-7 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zm0 7c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z"
                }
            }
        ]
    })(props);
}
function BiSolidBuoy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm7.736 8h-3.16A5.02 5.02 0 0 0 14 7.424V4.263A8.015 8.015 0 0 1 19.736 10zM12 15c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zM10 4.263v3.161A5.02 5.02 0 0 0 7.424 10h-3.16A8.015 8.015 0 0 1 10 4.263zM4.264 14h3.16A5.02 5.02 0 0 0 10 16.576v3.161A8.015 8.015 0 0 1 4.264 14zM14 19.737v-3.161A5.02 5.02 0 0 0 16.576 14h3.16A8.015 8.015 0 0 1 14 19.737z"
                }
            }
        ]
    })(props);
}
function BiSolidBusSchool(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11.597V11h1V8h-1V6c0-2.206-1.794-4-4-4H7C4.794 2 3 3.794 3 6v2H2v3h1v.597a3.97 3.97 0 0 0-.999 2.648l.004 3.758c.001.733.404 1.369.995 1.716V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h12v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.274a2.02 2.02 0 0 0 .421-.313c.377-.378.585-.881.584-1.415l-.004-3.759A3.965 3.965 0 0 0 21 11.597zM8 4h8v2H8V4zM6.5 17a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 6.5 17zm4.5-5H5V8h6v4zm6.5 5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 17.5 17zm1.5-5h-6V8h6v4z"
                }
            }
        ]
    })(props);
}
function BiSolidBus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6.021c.003-.146-.007-1.465-1.3-2.735C18.427 2.036 17.143 2 17 2H6.996c-.239 0-1.493.063-2.708 1.302C3.036 4.578 3 5.859 3 6v3H2v3h1v6c0 .734.406 1.373 1 1.721V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h10v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.277A1.99 1.99 0 0 0 21 18v-6h1V9h-1V6.021zM9 4h6v2H9V4zM6.5 18a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 6.5 18zm4.5-5H5V8h6v5zm6.5 5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 17.5 18zm1.5-5h-6V8h6v5z"
                }
            }
        ]
    })(props);
}
function BiSolidBusiness(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7h-6a1 1 0 0 0-1 1v3h-2V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zM8 6h2v2H8V6zM6 16H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V6h2v2zm4 8H8v-2h2v2zm0-4H8v-2h2v2zm9 4h-2v-2h2v2zm0-4h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function BiSolidCabinet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v7h18V4zm-5 4H8V5h2v1h4V5h2v3zM5 22h14c1.103 0 2-.897 2-2v-7H3v7c0 1.103.897 2 2 2zm3-6h2v1h4v-1h2v3H8v-3z"
                }
            }
        ]
    })(props);
}
function BiSolidCableCar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2 9.76 9-2.45V10H7a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-4V6.76l9-2.45V2.24L2 7.69zM11 12v3H7v-3zm6 0v3h-4v-3z"
                }
            }
        ]
    })(props);
}
function BiSolidCake(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.997 15c-1.601 0-2.446-.676-3.125-1.219-.567-.453-.977-.781-1.878-.781-.898 0-1.287.311-1.874.78-.679.544-1.524 1.22-3.125 1.22s-2.444-.676-3.123-1.22C3.285 13.311 2.897 13 2 13v5c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-5c-.899 0-1.288.311-1.876.781-.68.543-1.525 1.219-3.127 1.219zM19 5h-6V2h-2v3H5C3.346 5 2 6.346 2 8v3c1.6 0 2.443.676 3.122 1.22.587.469.975.78 1.873.78.899 0 1.287-.311 1.875-.781.679-.543 1.524-1.219 3.124-1.219 1.602 0 2.447.676 3.127 1.219.588.47.977.781 1.876.781.9 0 1.311-.328 1.878-.781C19.554 11.676 20.399 11 22 11V8c0-1.654-1.346-3-3-3z"
                }
            }
        ]
    })(props);
}
function BiSolidCalculator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2zm3-3H7v-2h2v2zm0-4H7v-2h2v2zm0-4H7V9h2v2zm4 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm4 8h-2v-6h2v6zm0-8h-2V9h2v2zM6 4h12v3H6V4z"
                }
            }
        ]
    })(props);
}
function BiSolidCalendarAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM5 7h14v2H5V7z"
                }
            }
        ]
    })(props);
}
function BiSolidCalendarCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm6-3.586-3.707-3.707 1.414-1.414L11 15.586l4.293-4.293 1.414 1.414L11 18.414zM5 7h14v2H5V7z"
                }
            }
        ]
    })(props);
}
function BiSolidCalendarEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm4.799-2.013H8v-1.799l4.977-4.97 1.799 1.799-4.977 4.97zm5.824-5.817-1.799-1.799L15.196 11l1.799 1.799-1.372 1.371zM5 7h14v2H5V7z"
                }
            }
        ]
    })(props);
}
function BiSolidCalendarEvent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-1 15h-6v-6h6v6zm1-10H5V7h14v2z"
                }
            }
        ]
    })(props);
}
function BiSolidCalendarExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-6 16h-2v-2h2v2zm0-4h-2v-5h2v5zm6-7H5V7h14v2z"
                }
            }
        ]
    })(props);
}
function BiSolidCalendarHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-3.648 11.711L12.002 19l-3.349-3.289a2.129 2.129 0 0 1 0-3.069 2.224 2.224 0 0 1 3.125 0l.224.219.224-.219a2.225 2.225 0 0 1 3.126 0 2.129 2.129 0 0 1 0 3.069zM19 9H5V7h14v2z"
                }
            }
        ]
    })(props);
}
function BiSolidCalendarMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm11-6H8v-2h8v2zM5 7h14v2H5V7z"
                }
            }
        ]
    })(props);
}
function BiSolidCalendarPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm11-6h-3v3h-2v-3H8v-2h3v-3h2v3h3v2zM5 7h14v2H5V7z"
                }
            }
        ]
    })(props);
}
function BiSolidCalendarStar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-4.588 15-2.449-1.288L9.514 19l.468-2.728L8 14.342l2.738-.398 1.225-2.48 1.225 2.48 2.738.398-1.981 1.931.467 2.727zM19 9H5V7h14v2z"
                }
            }
        ]
    })(props);
}
function BiSolidCalendarWeek(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-2 8v2H7v-3h10v1zm2-3H5V7h14v2z"
                }
            }
        ]
    })(props);
}
function BiSolidCalendarX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm10.707-4.707-1.414 1.414L12 16.414l-2.293 2.293-1.414-1.414L10.586 15l-2.293-2.293 1.414-1.414L12 13.586l2.293-2.293 1.414 1.414L13.414 15l2.293 2.293zM5 7h14v2H5V7z"
                }
            }
        ]
    })(props);
}
function BiSolidCalendar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 20V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2zM9 18H7v-2h2v2zm0-4H7v-2h2v2zm4 4h-2v-2h2v2zm0-4h-2v-2h2v2zm4 4h-2v-2h2v2zm0-4h-2v-2h2v2zm2-5H5V7h14v2z"
                }
            }
        ]
    })(props);
}
function BiSolidCameraHome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "10",
                    "r": "3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.125 2H5.875A1.877 1.877 0 0 0 4 3.875v12.25C4 17.159 4.841 18 5.875 18H11v2H7v2h10v-2h-4v-2h5.125A1.877 1.877 0 0 0 20 16.125V3.875A1.877 1.877 0 0 0 18.125 2zM12 15c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z"
                }
            }
        ]
    })(props);
}
function BiSolidCameraMovie(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11c0-.959-.68-1.761-1.581-1.954C16.779 8.445 17 7.75 17 7c0-2.206-1.794-4-4-4-1.516 0-2.822.857-3.5 2.104C8.822 3.857 7.516 3 6 3 3.794 3 2 4.794 2 7c0 .902.312 1.726.817 2.396A1.993 1.993 0 0 0 2 11v8c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-2.637l4 2v-7l-4 2V11zm-5-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zM6 5c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z"
                }
            }
        ]
    })(props);
}
function BiSolidCameraOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 20h11.879l-3.083-3.083A4.774 4.774 0 0 1 12 17c-2.71 0-5-2.29-5-5 0-.271.039-.535.083-.796L2.144 6.265C2.054 6.493 2 6.74 2 7v11c0 1.103.897 2 2 2zM20 5h-2.586l-2.707-2.707A.996.996 0 0 0 14 2h-4a.996.996 0 0 0-.707.293L6.586 5h-.172L3.707 2.293 2.293 3.707l18 18 1.414-1.414-.626-.626A1.98 1.98 0 0 0 22 18V7c0-1.103-.897-2-2-2zm-5.312 8.274A2.86 2.86 0 0 0 15 12c0-1.626-1.374-3-3-3-.456 0-.884.12-1.274.312l-1.46-1.46A4.88 4.88 0 0 1 12 7c2.71 0 5 2.29 5 5a4.88 4.88 0 0 1-.852 2.734l-1.46-1.46z"
                }
            }
        ]
    })(props);
}
function BiSolidCameraPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-2.586l-2.707-2.707A.996.996 0 0 0 14 2h-4a.996.996 0 0 0-.707.293L6.586 5H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zm-8 12c-2.71 0-5-2.29-5-5 0-2.711 2.29-5 5-5s5 2.289 5 5c0 2.71-2.29 5-5 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9h-2v2H9v2h2v2h2v-2h2v-2h-2z"
                }
            }
        ]
    })(props);
}
function BiSolidCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9c-1.626 0-3 1.374-3 3s1.374 3 3 3 3-1.374 3-3-1.374-3-3-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-2.586l-2.707-2.707A.996.996 0 0 0 14 2h-4a.996.996 0 0 0-.707.293L6.586 5H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zm-8 12c-2.71 0-5-2.29-5-5s2.29-5 5-5 5 2.29 5 5-2.29 5-5 5z"
                }
            }
        ]
    })(props);
}
function BiSolidCapsule(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.434 20.566c1.335 0 2.591-.52 3.535-1.464l7.134-7.133a5.008 5.008 0 0 0-.001-7.072 4.969 4.969 0 0 0-3.536-1.463c-1.335 0-2.59.52-3.534 1.464l-7.134 7.133a5.01 5.01 0 0 0-.001 7.072 4.971 4.971 0 0 0 3.537 1.463zm5.011-14.254a2.979 2.979 0 0 1 2.12-.878c.802 0 1.556.312 2.122.878a3.004 3.004 0 0 1 .001 4.243l-2.893 2.892-4.242-4.244 2.892-2.891z"
                }
            }
        ]
    })(props);
}
function BiSolidCaptions(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-9 6H8v4h3v2H8c-1.103 0-2-.897-2-2v-4c0-1.103.897-2 2-2h3v2zm7 0h-3v4h3v2h-3c-1.103 0-2-.897-2-2v-4c0-1.103.897-2 2-2h3v2z"
                }
            }
        ]
    })(props);
}
function BiSolidCarBattery(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zM9 14H4v-2h5v2zm11 0h-2v2h-2v-2h-2v-2h2v-2h2v2h2v2zM4 3h4v2H4zm12 0h4v2h-4z"
                }
            }
        ]
    })(props);
}
function BiSolidCarCrash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.634 17.918a1.765 1.765 0 0 0 1.201 1.291l.18.791H4v2h16v-2H6.683a.84.84 0 0 0-.007-.278l-.196-.863 10.357-2.356.196.863a.886.886 0 0 0 1.06.667l.863-.197a.885.885 0 0 0 .667-1.06l-.251-1.103c.446-.416.67-1.046.525-1.683l-.59-2.59a1.76 1.76 0 0 0-1.262-1.307l-2.049-3.378a2.774 2.774 0 0 0-2.982-1.263l-7.868 1.79a2.769 2.769 0 0 0-2.144 2.43l-.387 3.932a1.76 1.76 0 0 0-.57 1.724l.589 2.59zm3.02-.688a1.327 1.327 0 1 1-.59-2.589 1.327 1.327 0 0 1 .59 2.589zm11.222-2.552a1.328 1.328 0 1 1-.59-2.587 1.328 1.328 0 0 1 .59 2.587zM5.589 9.192l7.869-1.791a.773.773 0 0 1 .83.351l1.585 2.613-.566.129-10.046 2.287-.568.129.299-3.042a.772.772 0 0 1 .597-.676zM18.405 4 17 2l-.5 3L19 9l3 1-2-2.539 2-.933-2-.933L22 2z"
                }
            }
        ]
    })(props);
}
function BiSolidCarGarage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 19.723V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h12v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.277A1.99 1.99 0 0 0 22 18v-3c0-.831-.507-1.542-1.228-1.845l-1.368-4.104A2.995 2.995 0 0 0 16.559 7H7.441a2.995 2.995 0 0 0-2.845 2.051l-1.368 4.104A2.001 2.001 0 0 0 2 15v3c0 .738.404 1.376 1 1.723zM5.5 18a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 5.5 18zm13 0a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 18.5 18zM7.441 9h9.117a1 1 0 0 1 .949.684L18.613 13H5.387l1.105-3.316c.137-.409.519-.684.949-.684z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7.388V5.279l-9.684-3.228a.996.996 0 0 0-.658.009L2 5.572V7.7l10.015-3.642L22 7.388z"
                }
            }
        ]
    })(props);
}
function BiSolidCarMechanic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.772 13.155-1.368-4.104A2.995 2.995 0 0 0 16.559 7H7.441a2.995 2.995 0 0 0-2.845 2.051l-1.368 4.104A2.001 2.001 0 0 0 2 15v3c0 .738.404 1.376 1 1.723V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h12v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.277A1.99 1.99 0 0 0 22 18v-3c0-.831-.507-1.542-1.228-1.845zM7.441 9h9.117a1 1 0 0 1 .949.684L18.613 13H5.387l1.105-3.316c.137-.409.519-.684.949-.684zM5.5 18a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 5.5 18zm13 0a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 18.5 18zM5.277 5c.347.595.985 1 1.723 1s1.376-.405 1.723-1h6.555c.346.595.984 1 1.722 1s1.376-.405 1.723-1H17V3h1.723c-.347-.595-.985-1-1.723-1s-1.376.405-1.723 1H8.723C8.376 2.405 7.738 2 7 2s-1.376.405-1.723 1H7v2H5.277z"
                }
            }
        ]
    })(props);
}
function BiSolidCarWash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.772 13.155-1.368-4.104A2.995 2.995 0 0 0 16.559 7H7.441a2.995 2.995 0 0 0-2.845 2.051l-1.368 4.104A2.001 2.001 0 0 0 2 15v3c0 .738.404 1.376 1 1.723V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h12v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.277A1.99 1.99 0 0 0 22 18v-3c0-.831-.507-1.542-1.228-1.845zM7.441 9h9.117a1 1 0 0 1 .949.684L18.613 13H5.387l1.105-3.316c.137-.409.519-.684.949-.684zM5.5 18a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 5.5 18zm13 0a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 18.5 18zM9 4.378c.005-1.088-1.037-2.051-1.387-2.344a.176.176 0 0 0-.228 0C7.033 2.325 5.995 3.271 6 4.377 6 5.272 6.673 6 7.5 6S9 5.272 9 4.378zm4.5 0c.005-1.088-1.037-2.052-1.387-2.344a.176.176 0 0 0-.228 0c-.353.291-1.391 1.238-1.386 2.344C10.5 5.272 11.173 6 12 6s1.5-.728 1.5-1.622zm4.5 0c.005-1.088-1.037-2.052-1.387-2.344a.176.176 0 0 0-.228 0c-.352.291-1.39 1.237-1.385 2.343C15 5.272 15.673 6 16.5 6S18 5.272 18 4.378z"
                }
            }
        ]
    })(props);
}
function BiSolidCar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.772 10.155-1.368-4.104A2.995 2.995 0 0 0 16.559 4H7.441a2.995 2.995 0 0 0-2.845 2.051l-1.368 4.104A2 2 0 0 0 2 12v5c0 .738.404 1.376 1 1.723V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2h12v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2.277A1.99 1.99 0 0 0 22 17v-5a2 2 0 0 0-1.228-1.845zM7.441 6h9.117c.431 0 .813.274.949.684L18.613 10H5.387l1.105-3.316A1 1 0 0 1 7.441 6zM5.5 16a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 5.5 16zm13 0a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 18.5 16z"
                }
            }
        ]
    })(props);
}
function BiSolidCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 17c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H6c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h12zM4 19h16v2H4z"
                }
            }
        ]
    })(props);
}
function BiSolidCaretDownCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10c5.515 0 10-4.486 10-10S17.515 2 12 2zm0 14-5-6h10l-5 6z"
                }
            }
        ]
    })(props);
}
function BiSolidCaretDownSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm12-11-5 6-5-6h10z"
                }
            }
        ]
    })(props);
}
function BiSolidCaretLeftCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm2 15-6-5 6-5v10z"
                }
            }
        ]
    })(props);
}
function BiSolidCaretLeftSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm9-14v10l-6-5 6-5z"
                }
            }
        ]
    })(props);
}
function BiSolidCaretRightCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.514 0 10-4.486 10-10S17.514 2 12 2 2 6.486 2 12s4.486 10 10 10zM10 7l6 5-6 5V7z"
                }
            }
        ]
    })(props);
}
function BiSolidCaretRightSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm5-14 6 5-6 5V7z"
                }
            }
        ]
    })(props);
}
function BiSolidCaretUpCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.485 2 2 6.486 2 12s4.485 10 10 10c5.514 0 10-4.486 10-10S17.514 2 12 2zM7 14l5-6 5 6H7z"
                }
            }
        ]
    })(props);
}
function BiSolidCaretUpSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm7-13 5 6H7l5-6z"
                }
            }
        ]
    })(props);
}
function BiSolidCarousel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3H8c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h8c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM2 7v10c0 1.103.897 2 2 2V5c-1.103 0-2 .897-2 2zm18-2v14c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2z"
                }
            }
        ]
    })(props);
}
function BiSolidCartAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7H7.334L6.18 4.23A1.995 1.995 0 0 0 4.333 3H2v2h2.334l4.743 11.385c.155.372.52.615.923.615h8c.417 0 .79-.259.937-.648l3-8A1.003 1.003 0 0 0 21 7zm-4 6h-2v2h-2v-2h-2v-2h2V9h2v2h2v2z"
                }
            }
        ]
    })(props);
}
function BiSolidCartAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H2v2h2.3l3.521 9.683A2.004 2.004 0 0 0 9.7 17H18v-2H9.7l-.728-2H18c.4 0 .762-.238.919-.606l3-7A.998.998 0 0 0 21 4z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function BiSolidCartDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7H7.334L6.18 4.23A1.995 1.995 0 0 0 4.333 3H2v2h2.334l4.743 11.385c.155.372.52.615.923.615h8c.417 0 .79-.259.937-.648l3-8A1.003 1.003 0 0 0 21 7zm-7 8-3-3h2V9h2v3h2l-3 3z"
                }
            }
        ]
    })(props);
}
function BiSolidCart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.822 7.431A1 1 0 0 0 21 7H7.333L6.179 4.23A1.994 1.994 0 0 0 4.333 3H2v2h2.333l4.744 11.385A1 1 0 0 0 10 17h8c.417 0 .79-.259.937-.648l3-8a1 1 0 0 0-.115-.921z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function BiSolidCastle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11h-2V6h1V2h-2v2h-1V2h-2v2h-1V2h-2v2h-1V2H8v2H7V2H5v4h1v5H4V9H2v12h7v-5a3 3 0 0 1 6 0v5h7V9h-2zm-10-1H8V7h2zm6 0h-2V7h2z"
                }
            }
        ]
    })(props);
}
function BiSolidCat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 14a5 5 0 0 0 2.71-.81L20 13a3.16 3.16 0 0 0 .45-.37l.21-.2a4.48 4.48 0 0 0 .48-.58l.06-.08a4.28 4.28 0 0 0 .41-.76 1.57 1.57 0 0 0 .09-.23 4.21 4.21 0 0 0 .2-.63l.06-.25A5.5 5.5 0 0 0 22 9V2l-3 3h-4l-3-3v7a5 5 0 0 0 5 5zm2-7a1 1 0 1 1-1 1 1 1 0 0 1 1-1zm-4 0a1 1 0 1 1-1 1 1 1 0 0 1 1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 22v-5H8v5H5V11.9a3.49 3.49 0 0 1-2.48-1.64A3.59 3.59 0 0 1 2 8.5 3.65 3.65 0 0 1 6 5a1.89 1.89 0 0 0 2-2 1 1 0 0 1 1-1 1 1 0 0 1 1 1 3.89 3.89 0 0 1-4 4C4.19 7 4 8.16 4 8.51S4.18 10 6 10h5.09A6 6 0 0 0 19 14.65V22h-3v-5h-2v5z"
                }
            }
        ]
    })(props);
}
function BiSolidCategoryAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm10 10h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zM17 3c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zM7 13c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4z"
                }
            }
        ]
    })(props);
}
function BiSolidCategory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm10 0h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zM4 21h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm13 0c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4z"
                }
            }
        ]
    })(props);
}
function BiSolidCctv(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.618 7.462 6.403 2.085a1.007 1.007 0 0 0-.77-.016 1.002 1.002 0 0 0-.552.537l-3 7a1 1 0 0 0 .525 1.313L9.563 13.9 8.323 17H4v-3H2v8h2v-3h4.323c.823 0 1.552-.494 1.856-1.258l1.222-3.054 3.419 1.465a1 1 0 0 0 1.311-.518l3-6.857a1 1 0 0 0-.513-1.316zm1.312 8.91-1.858-.742 1.998-5 1.858.741z"
                }
            }
        ]
    })(props);
}
function BiSolidCertification(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.047 14.667a.992.992 0 0 0 .466.607l1.909 1.104v2.199a1 1 0 0 0 1 1h2.199l1.104 1.91a1.002 1.002 0 0 0 1.366.366L12 20.75l1.91 1.104a1.002 1.002 0 0 0 1.366-.366l1.103-1.909h2.199a1 1 0 0 0 1-1V16.38l1.909-1.104a.999.999 0 0 0 .366-1.366L20.75 12l1.104-1.909a1 1 0 0 0-.366-1.366l-1.909-1.104V5.422a1 1 0 0 0-1-1H16.38l-1.103-1.909a1.004 1.004 0 0 0-.607-.466.994.994 0 0 0-.759.1L12 3.25l-1.909-1.104a.998.998 0 0 0-1.366.365l-1.104 1.91H5.422a1 1 0 0 0-1 1V7.62L2.513 8.725a1.001 1.001 0 0 0-.365 1.366L3.251 12l-1.104 1.909a1.003 1.003 0 0 0-.1.758z"
                }
            }
        ]
    })(props);
}
function BiSolidChalkboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h4l-1.8 2.4 1.6 1.2 2.7-3.6h3l2.7 3.6 1.6-1.2L16 18h4c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM5 13h4v2H5v-2z"
                }
            }
        ]
    })(props);
}
function BiSolidChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14zM9.553 9.658l4 2 1.553-3.105 1.789.895-2.447 4.895-4-2-1.553 3.105-1.789-.895 2.447-4.895z"
                }
            }
        ]
    })(props);
}
function BiSolidChat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18h2v4.081L11.101 18H16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.103 0-2 .897-2 2h12c1.103 0 2 .897 2 2v8c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2z"
                }
            }
        ]
    })(props);
}
function BiSolidCheckCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-1.999 14.413-3.713-3.705L7.7 11.292l2.299 2.295 5.294-5.294 1.414 1.414-6.706 6.706z"
                }
            }
        ]
    })(props);
}
function BiSolidCheckShield(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.488 21.754c.294.157.663.156.957-.001 8.012-4.304 8.581-12.713 8.574-15.104a.988.988 0 0 0-.596-.903l-8.05-3.566a1.005 1.005 0 0 0-.813.001L3.566 5.747a.99.99 0 0 0-.592.892c-.034 2.379.445 10.806 8.514 15.115zM8.674 10.293l2.293 2.293 4.293-4.293 1.414 1.414-5.707 5.707-3.707-3.707 1.414-1.414z"
                }
            }
        ]
    })(props);
}
function BiSolidCheckSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm-7.933 13.481-3.774-3.774 1.414-1.414 2.226 2.226 4.299-5.159 1.537 1.28-5.702 6.841z"
                }
            }
        ]
    })(props);
}
function BiSolidCheckboxChecked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H7zm4 10.414-2.707-2.707 1.414-1.414L11 12.586l3.793-3.793 1.414 1.414L11 15.414z"
                }
            }
        ]
    })(props);
}
function BiSolidCheckboxMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm-1 8H8v-2h8z"
                }
            }
        ]
    })(props);
}
function BiSolidCheckbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 19h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2z"
                }
            }
        ]
    })(props);
}
function BiSolidCheese(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.16 2a1 1 0 0 0-.66.13l-12 7a.64.64 0 0 0-.13.1l-.1.08a1.17 1.17 0 0 0-.17.26.84.84 0 0 0-.1.43v10a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V10a8.08 8.08 0 0 0-6.84-8zm0 2.05A6.07 6.07 0 0 1 19.93 9H6.7zM6.5 18A1.5 1.5 0 1 1 8 16.5 1.5 1.5 0 0 1 6.5 18zm5-3a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5zm5.5 3a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"
                }
            }
        ]
    })(props);
}
function BiSolidChess(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-1 6h-4v4h4v4h-4v4h-4v-4H8v4H4v-4h4v-4H4V8h4V4h4v4h4V4h4v4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8h4v4H8zm4 4h4v4h-4z"
                }
            }
        ]
    })(props);
}
function BiSolidChevronDownCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 14.414-5.707-5.707 1.414-1.414L12 13.586l4.293-4.293 1.414 1.414L12 16.414z"
                }
            }
        ]
    })(props);
}
function BiSolidChevronDownSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM7.707 9.293 12 13.586l4.293-4.293 1.414 1.414L12 16.414l-5.707-5.707 1.414-1.414z"
                }
            }
        ]
    })(props);
}
function BiSolidChevronDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.939 7.939 12 12.879l-4.939-4.94-2.122 2.122L12 17.121l7.061-7.06z"
                }
            }
        ]
    })(props);
}
function BiSolidChevronLeftCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm2.707 14.293-1.414 1.414L7.586 12l5.707-5.707 1.414 1.414L10.414 12l4.293 4.293z"
                }
            }
        ]
    })(props);
}
function BiSolidChevronLeftSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5zm9.707 13.293-1.414 1.414L7.586 12l5.707-5.707 1.414 1.414L10.414 12l4.293 4.293z"
                }
            }
        ]
    })(props);
}
function BiSolidChevronLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.939 4.939 6.879 12l7.06 7.061 2.122-2.122L11.121 12l4.94-4.939z"
                }
            }
        ]
    })(props);
}
function BiSolidChevronRightCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-1.293 15.707-1.414-1.414L13.586 12 9.293 7.707l1.414-1.414L16.414 12l-5.707 5.707z"
                }
            }
        ]
    })(props);
}
function BiSolidChevronRightSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2zm6.293 2.707 1.414-1.414L16.414 12l-5.707 5.707-1.414-1.414L13.586 12 9.293 7.707z"
                }
            }
        ]
    })(props);
}
function BiSolidChevronRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.061 19.061 17.121 12l-7.06-7.061-2.122 2.122L12.879 12l-4.94 4.939z"
                }
            }
        ]
    })(props);
}
function BiSolidChevronUpCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm4.293 12.707L12 10.414l-4.293 4.293-1.414-1.414L12 7.586l5.707 5.707-1.414 1.414z"
                }
            }
        ]
    })(props);
}
function BiSolidChevronUpSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm7-13.414 5.707 5.707-1.414 1.414L12 10.414l-4.293 4.293-1.414-1.414L12 7.586z"
                }
            }
        ]
    })(props);
}
function BiSolidChevronUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 6.879-7.061 7.06 2.122 2.122L12 11.121l4.939 4.94 2.122-2.122z"
                }
            }
        ]
    })(props);
}
function BiSolidChevronsDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.939 10.939 12 15.879l-4.939-4.94-2.122 2.122L12 20.121l7.061-7.06z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.939 3.939 12 8.879l-4.939-4.94-2.122 2.122L12 13.121l7.061-7.06z"
                }
            }
        ]
    })(props);
}
function BiSolidChevronsLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m8.121 12 4.94-4.939-2.122-2.122L3.879 12l7.06 7.061 2.122-2.122z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.939 4.939 10.879 12l7.06 7.061 2.122-2.122L15.121 12l4.94-4.939z"
                }
            }
        ]
    })(props);
}
function BiSolidChevronsRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m13.061 4.939-2.122 2.122L15.879 12l-4.94 4.939 2.122 2.122L20.121 12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.061 19.061 13.121 12l-7.06-7.061-2.122 2.122L8.879 12l-4.94 4.939z"
                }
            }
        ]
    })(props);
}
function BiSolidChevronsUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 3.879-7.061 7.06 2.122 2.122L12 8.121l4.939 4.94 2.122-2.122z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m4.939 17.939 2.122 2.122L12 15.121l4.939 4.94 2.122-2.122L12 10.879z"
                }
            }
        ]
    })(props);
}
function BiSolidChip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7a2 2 0 0 0-2-2h-1V2h-2v3h-4V2H8v3H7a2 2 0 0 0-2 2v1H2v2h3v4H2v2h3v1a2 2 0 0 0 2 2h1v3h2v-3h4v3h2v-3h1a2 2 0 0 0 2-2v-1h3v-2h-3v-4h3V8h-3V7zm-4 8H9V9h6v6z"
                }
            }
        ]
    })(props);
}
function BiSolidChurch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 22v-4a2 2 0 0 1 4 0v4h4V12a1 1 0 0 0-.485-.857L13 8.434V6h2V4h-2V2h-2v2H9v2h2v2.434l-4.515 2.709A1 1 0 0 0 6 12v10h4zm-7 0h2v-8.118l-2.447 1.224A.998.998 0 0 0 2 16v5a1 1 0 0 0 1 1zm18.447-6.895L19 13.882V22h2a1 1 0 0 0 1-1v-5c0-.379-.214-.725-.553-.895z"
                }
            }
        ]
    })(props);
}
function BiSolidCircleHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2h-1v20h1a10 10 0 0 0 0-20z"
                }
            }
        ]
    })(props);
}
function BiSolidCircleQuarter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2h-1v11h11v-1A10 10 0 0 0 12 2z"
                }
            }
        ]
    })(props);
}
function BiSolidCircleThreeQuarter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2h-1v9H2v1a10 10 0 0 0 17.07 7.07A10 10 0 0 0 12 2z"
                }
            }
        ]
    })(props);
}
function BiSolidCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2z"
                }
            }
        ]
    })(props);
}
function BiSolidCity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6h-4V3a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zM6 18H4v-2h2v2zm0-4H4v-2h2v2zm5 4H9v-2h2v2zm0-4H9v-2h2v2zm0-4H9V8h2v2zm0-4H9V4h2v2zm4 12h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V8h2v2zm0-4h-2V4h2v2zm5 12h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V8h2v2z"
                }
            }
        ]
    })(props);
}
function BiSolidClinic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669zM16 15h-3v3h-2v-3H8v-2h3v-3h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function BiSolidCloudDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 11.112C18.507 7.67 15.56 5 12 5 9.244 5 6.85 6.61 5.757 9.149 3.609 9.792 2 11.82 2 14c0 2.657 2.089 4.815 4.708 4.971V19H17.99v-.003L18 19c2.206 0 4-1.794 4-4a4.008 4.008 0 0 0-3.056-3.888zM8 12h3V9h2v3h3l-4 5-4-5z"
                }
            }
        ]
    })(props);
}
function BiSolidCloudLightning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 10.112C18.507 6.67 15.56 4 12 4 9.244 4 6.85 5.611 5.757 8.15 3.609 8.792 2 10.82 2 13c0 2.757 2.243 5 5 5h1.333L10 13h4l-2 3h2.975l-1.325 2H18c2.206 0 4-1.794 4-4a4.01 4.01 0 0 0-3.056-3.888zM11 18H8.333L8 19h3v3l2.649-4H11.5z"
                }
            }
        ]
    })(props);
}
function BiSolidCloudRain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 10.112C18.507 6.67 15.56 4 12 4 9.244 4 6.85 5.611 5.757 8.15 3.609 8.792 2 10.82 2 13c0 2.757 2.243 5 5 5h1v3h2v-3h4v3h2v-3h2c2.206 0 4-1.794 4-4a4.01 4.01 0 0 0-3.056-3.888z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 19h2v3h-2z"
                }
            }
        ]
    })(props);
}
function BiSolidCloudUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 11.112C18.507 7.67 15.56 5 12 5 9.244 5 6.85 6.611 5.757 9.15 3.609 9.792 2 11.82 2 14c0 2.757 2.243 5 5 5h11c2.206 0 4-1.794 4-4a4.01 4.01 0 0 0-3.056-3.888zM13 14v3h-2v-3H8l4-5 4 5h-3z"
                }
            }
        ]
    })(props);
}
function BiSolidCloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.944 11.112C18.507 7.67 15.56 5 12 5 9.244 5 6.85 6.611 5.757 9.15 3.609 9.792 2 11.82 2 14c0 2.757 2.243 5 5 5h11c2.206 0 4-1.794 4-4a4.01 4.01 0 0 0-3.056-3.888z"
                }
            }
        ]
    })(props);
}
function BiSolidCoffeeAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5h-1V4a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v9a4 4 0 0 0 4 4h6c1.858 0 3.411-1.279 3.858-3H19a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3zm1 6a1 1 0 0 1-1 1h-1V7h1a1 1 0 0 1 1 1v3zm-2 8H3c0 1.654 1.346 3 3 3h11c1.654 0 3-1.346 3-3h-2z"
                }
            }
        ]
    })(props);
}
function BiSolidCoffeeBean(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18a6.06 6.06 0 0 0 5.17-6 7.62 7.62 0 0 1 6.52-7.51l2.59-.37c-.07-.08-.13-.16-.21-.24-3.26-3.26-9.52-2.28-14 2.18C2.28 9.9 1 15 2.76 18.46z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.73 12a7.63 7.63 0 0 1-6.51 7.52l-2.46.35.15.17c3.26 3.26 9.52 2.29 14-2.17C21.68 14.11 23 9 21.25 5.59l-3.34.48A6.05 6.05 0 0 0 12.73 12z"
                }
            }
        ]
    })(props);
}
function BiSolidCoffeeTogo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m18.5 5-1.224-2.447A1 1 0 0 0 16.382 2H7.618a1 1 0 0 0-.894.553L5.5 5H3v2h18V5h-2.5zM6.734 21.142c.071.492.493.858.991.858h8.551a1 1 0 0 0 .99-.858L19 9H5l1.734 12.142zM16 12l-.714 5H8.714L8 12h8z"
                }
            }
        ]
    })(props);
}
function BiSolidCoffee(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2h2v3H5zm4 0h2v3H9zm4 0h2v3h-2zm6 7h-2V8a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v10a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3h2c1.103 0 2-.897 2-2v-5c0-1.103-.897-2-2-2zm-2 7v-5h2l.002 5H17z"
                }
            }
        ]
    })(props);
}
function BiSolidCog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.344 15.271 2 3.46a1 1 0 0 0 1.366.365l1.396-.806c.58.457 1.221.832 1.895 1.112V21a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1.598a8.094 8.094 0 0 0 1.895-1.112l1.396.806c.477.275 1.091.11 1.366-.365l2-3.46a1.004 1.004 0 0 0-.365-1.366l-1.372-.793a7.683 7.683 0 0 0-.002-2.224l1.372-.793c.476-.275.641-.89.365-1.366l-2-3.46a1 1 0 0 0-1.366-.365l-1.396.806A8.034 8.034 0 0 0 15 4.598V3a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1.598A8.094 8.094 0 0 0 7.105 5.71L5.71 4.904a.999.999 0 0 0-1.366.365l-2 3.46a1.004 1.004 0 0 0 .365 1.366l1.372.793a7.683 7.683 0 0 0 0 2.224l-1.372.793c-.476.275-.641.89-.365 1.366zM12 8c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4z"
                }
            }
        ]
    })(props);
}
function BiSolidCoinStack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c3.976 0 8-1.374 8-4s-4.024-4-8-4-8 1.374-8 4 4.024 4 8 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10c0 2.626 4.024 4 8 4s8-1.374 8-4V8c0 2.626-4.024 4-8 4s-8-1.374-8-4v2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 14c0 2.626 4.024 4 8 4s8-1.374 8-4v-2c0 2.626-4.024 4-8 4s-8-1.374-8-4v2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18c0 2.626 4.024 4 8 4s8-1.374 8-4v-2c0 2.626-4.024 4-8 4s-8-1.374-8-4v2z"
                }
            }
        ]
    })(props);
}
function BiSolidCoin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5C7.031 5 2 6.546 2 9.5S7.031 14 12 14c4.97 0 10-1.546 10-4.5S16.97 5 12 5zm-5 9.938v3c1.237.299 2.605.482 4 .541v-3a21.166 21.166 0 0 1-4-.541zm6 .54v3a20.994 20.994 0 0 0 4-.541v-3a20.994 20.994 0 0 1-4 .541zm6-1.181v3c1.801-.755 3-1.857 3-3.297v-3c0 1.44-1.199 2.542-3 3.297zm-14 3v-3C3.2 13.542 2 12.439 2 11v3c0 1.439 1.2 2.542 3 3.297z"
                }
            }
        ]
    })(props);
}
function BiSolidCollection(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10H5c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-8c0-1.103-.897-2-2-2zM5 6h14v2H5zm2-4h10v2H7z"
                }
            }
        ]
    })(props);
}
function BiSolidColorFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 14c-.092.064-2 2.083-2 3.5 0 1.494.949 2.448 2 2.5.906.044 2-.891 2-2.5 0-1.5-1.908-3.436-2-3.5zM9.586 20c.378.378.88.586 1.414.586s1.036-.208 1.414-.586l7-7-.707-.707L11 4.586 8.707 2.293 7.293 3.707 9.586 6 4 11.586c-.378.378-.586.88-.586 1.414s.208 1.036.586 1.414L9.586 20zM11 7.414 16.586 13H5.414L11 7.414z"
                }
            }
        ]
    })(props);
}
function BiSolidColor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.08 11.25A4.84 4.84 0 0 1 8 9.05L4.43 5.49A9.88 9.88 0 0 0 2 11.25zM9.05 8a4.84 4.84 0 0 1 2.2-.91V2a9.88 9.88 0 0 0-5.76 2.43zm3.7-6v5A4.84 4.84 0 0 1 15 8l3.56-3.56A9.88 9.88 0 0 0 12.75 2zM8 15a4.84 4.84 0 0 1-.91-2.2H2a9.88 9.88 0 0 0 2.39 5.76zm3.25 1.92a4.84 4.84 0 0 1-2.2-.92l-3.56 3.57A9.88 9.88 0 0 0 11.25 22zM16 9.05a4.84 4.84 0 0 1 .91 2.2h5a9.88 9.88 0 0 0-2.39-5.76zM15 16a4.84 4.84 0 0 1-2.2.91v5a9.88 9.88 0 0 0 5.76-2.39zm1.92-3.25A4.84 4.84 0 0 1 16 15l3.56 3.56A9.88 9.88 0 0 0 22 12.75z"
                }
            }
        ]
    })(props);
}
function BiSolidCommentAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l4-4h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm-3 9h-4v4h-2v-4H7V9h4V5h2v4h4v2z"
                }
            }
        ]
    })(props);
}
function BiSolidCommentCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l4-4h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm-9 11.914-3.707-3.707 1.414-1.414L11 11.086l4.793-4.793 1.414 1.414L11 13.914z"
                }
            }
        ]
    })(props);
}
function BiSolidCommentDetail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 1.999H4c-1.103 0-2 .897-2 2v18l4-4h14c1.103 0 2-.897 2-2v-12c0-1.103-.897-2-2-2zm-6 11H7v-2h7v2zm3-4H7v-2h10v2z"
                }
            }
        ]
    })(props);
}
function BiSolidCommentDots(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l4-4h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM9 12a2 2 0 1 1 .001-4.001A2 2 0 0 1 9 12zm6 0a2 2 0 1 1 .001-4.001A2 2 0 0 1 15 12z"
                }
            }
        ]
    })(props);
}
function BiSolidCommentEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l4-4h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM8.999 14.987H7v-1.999l5.53-5.522 1.998 1.999-5.529 5.522zm6.472-6.464-1.999-1.999 1.524-1.523L16.995 7l-1.524 1.523z"
                }
            }
        ]
    })(props);
}
function BiSolidCommentError(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l4-4h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm-7 13h-2v-2h2v2zm0-4h-2V5h2v6z"
                }
            }
        ]
    })(props);
}
function BiSolidCommentMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l4-4h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm-4 9H8V9h8v2z"
                }
            }
        ]
    })(props);
}
function BiSolidCommentX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l4-4h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm-3.294 11.543-1.414 1.414-3.293-3.292-3.292 3.292-1.414-1.414 3.292-3.292-3.292-3.293 1.414-1.414 3.292 3.292 3.293-3.292 1.414 1.414-3.292 3.293 3.292 3.292z"
                }
            }
        ]
    })(props);
}
function BiSolidComment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .897-2 2v18l4-4h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2z"
                }
            }
        ]
    })(props);
}
function BiSolidCompass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm3 13-8 2 2-8 8-2-2 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function BiSolidComponent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3.553 18.895 4 2a1.001 1.001 0 0 0 .894 0L12 19.118l3.553 1.776a.99.99 0 0 0 .894.001l4-2c.339-.17.553-.516.553-.895v-5c0-.379-.214-.725-.553-.895L17 10.382V6c0-.379-.214-.725-.553-.895l-4-2a1 1 0 0 0-.895 0l-4 2C7.214 5.275 7 5.621 7 6v4.382l-3.447 1.724A.998.998 0 0 0 3 13v5c0 .379.214.725.553.895zM8 12.118l2.264 1.132-2.913 1.457-2.264-1.132L8 12.118zm4-2.5 3-1.5v2.264l-3 1.5V9.618zm6.264 3.632-2.882 1.441-2.264-1.132L16 12.118l2.264 1.132zM8 18.882l-.062-.031V16.65L11 15.118v2.264l-3 1.5zm8 0v-2.264l3-1.5v2.264l-3 1.5zM12 5.118l2.264 1.132-2.882 1.441-2.264-1.132L12 5.118z"
                }
            }
        ]
    })(props);
}
function BiSolidConfused(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-5 8.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 7 10.5zm1.124 6.492-.248-1.984 8-1 .248 1.984-8 1zm7.369-5.006a1.494 1.494 0 1 1 .001-2.987 1.494 1.494 0 0 1-.001 2.987z"
                }
            }
        ]
    })(props);
}
function BiSolidContact(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 2H6a2 2 0 0 0-2 2v3H2v2h2v2H2v2h2v2H2v2h2v3a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-8 2.999c1.648 0 3 1.351 3 3A3.012 3.012 0 0 1 13 11c-1.647 0-3-1.353-3-3.001 0-1.649 1.353-3 3-3zM19 18H7v-.75c0-2.219 2.705-4.5 6-4.5s6 2.281 6 4.5V18z"
                }
            }
        ]
    })(props);
}
function BiSolidConversation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 14h3.5c.827 0 1.5-.673 1.5-1.5v-9c0-.827-.673-1.5-1.5-1.5h-13C2.673 2 2 2.673 2 3.5V18l5.333-4H13zm-9-.1.154-.016L4 14v-.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 8H20v6.001c0 1.1-.893 1.993-1.99 1.999H8v.5c0 .827.673 1.5 1.5 1.5h7.167L22 22V9.5c0-.827-.673-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function BiSolidCookie(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.598 11.064a1.006 1.006 0 0 0-.854-.172A2.938 2.938 0 0 1 20 11c-1.654 0-3-1.346-3.003-2.938.005-.034.016-.134.017-.168a.998.998 0 0 0-1.254-1.006A3.002 3.002 0 0 1 15 7c-1.654 0-3-1.346-3-3 0-.217.031-.444.099-.716a1 1 0 0 0-1.067-1.236A9.956 9.956 0 0 0 2 12c0 5.514 4.486 10 10 10s10-4.486 10-10c0-.049-.003-.097-.007-.16a1.004 1.004 0 0 0-.395-.776zM8.5 6a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm-2 8a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm3 4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm2.5-6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0zm3.5 6.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                }
            }
        ]
    })(props);
}
function BiSolidCool(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm4.095 14.244a5.982 5.982 0 0 1-3.034 1.634 6.05 6.05 0 0 1-2.414 0 5.919 5.919 0 0 1-2.148-.903 6.078 6.078 0 0 1-1.621-1.622l1.658-1.117c.143.211.307.41.488.59a3.988 3.988 0 0 0 1.273.86c.243.102.495.181.749.232a4.108 4.108 0 0 0 1.616 0c.253-.052.505-.131.75-.233.234-.1.464-.224.679-.368.208-.142.407-.306.591-.489.183-.182.347-.381.489-.592l1.658 1.117c-.215.32-.462.62-.734.891zM19 10a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2h-2a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8h14v2z"
                }
            }
        ]
    })(props);
}
function BiSolidCopyAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H10a2 2 0 0 0-2 2v2h8a2 2 0 0 1 2 2v8h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h10c1.103 0 2-.897 2-2V10c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2zm2-10h6v2H6v-2zm0 4h6v2H6v-2z"
                }
            }
        ]
    })(props);
}
function BiSolidCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V10c0-1.103-.897-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H10a2 2 0 0 0-2 2v2h8a2 2 0 0 1 2 2v8h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z"
                }
            }
        ]
    })(props);
}
function BiSolidCopyright(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.579 2 2 6.58 2 12s4.579 10 10 10 10-4.58 10-10S17.421 2 12 2zm0 13c.992 0 1.85-.265 2.293-.708l1.414 1.415C14.581 16.832 12.901 17 12 17c-2.757 0-5-2.243-5-5s2.243-5 5-5c.901 0 2.582.168 3.707 1.293l-1.414 1.414C13.851 9.264 12.993 9 12 9c-1.626 0-3 1.374-3 3s1.374 3 3 3z"
                }
            }
        ]
    })(props);
}
function BiSolidCoupon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5H3a1 1 0 0 0-1 1v4h.893c.996 0 1.92.681 2.08 1.664A2.001 2.001 0 0 1 3 14H2v4a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-4h-1a2.001 2.001 0 0 1-1.973-2.336c.16-.983 1.084-1.664 2.08-1.664H22V6a1 1 0 0 0-1-1zM11 17H9v-2h2v2zm0-4H9v-2h2v2zm0-4H9V7h2v2z"
                }
            }
        ]
    })(props);
}
function BiSolidCreditCardAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-7.5 12a2.5 2.5 0 1 1 0-5 2.47 2.47 0 0 1 1.5.512c-.604.456-1 1.173-1 1.988s.396 1.532 1 1.988a2.47 2.47 0 0 1-1.5.512zm4 0a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"
                }
            }
        ]
    })(props);
}
function BiSolidCreditCardFront(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM5 8.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-2zm6 7.5H5v-2h6v2zm8 0h-6v-2h6v2z"
                }
            }
        ]
    })(props);
}
function BiSolidCreditCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v2h20V6c0-1.103-.897-2-2-2zM2 18c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-6H2v6zm3-3h6v2H5v-2z"
                }
            }
        ]
    })(props);
}
function BiSolidCricketBall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3.67 16.26.54.53-.62.61a9 9 0 0 0 .84 1.11L18.51 4.42a10.93 10.93 0 0 0-1.1-.83l-.62.61-.53-.53.48-.48A10 10 0 0 0 3.2 16.74zM14.86 5.07l.53.53L14 7l-.53-.53zm-2.79 2.8.52.53-1.39 1.4-.53-.53zm-2.8 2.8.53.53-1.4 1.39-.53-.53zm-2.8 2.79L7 14l-1.4 1.4-.53-.53zm.12 6.95.62-.61.53.53-.48.48A10 10 0 0 0 20.8 7.26l-.47.48-.54-.53.62-.61a9 9 0 0 0-.84-1.11L5.49 19.58a10.93 10.93 0 0 0 1.1.83zM18.4 8.61l.53.53-1.4 1.4L17 10zm-2.8 2.8.53.53-1.4 1.39-.53-.53zm-2.8 2.79.53.53-1.39 1.4-.54-.53zM10 17l.53.53-1.4 1.4-.53-.53z"
                }
            }
        ]
    })(props);
}
function BiSolidCrop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7.5C19 6.121 17.879 5 16.5 5H8V2H5v3H2v3h14v14h3v-3h3v-3h-3V7.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 10H5v6.5C5 17.879 6.121 19 7.5 19H14v-3H8v-6z"
                }
            }
        ]
    })(props);
}
function BiSolidCrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21 2-5 5-4-5-4 5-5-5v13h18zM5 21h14a2 2 0 0 0 2-2v-2H3v2a2 2 0 0 0 2 2z"
                }
            }
        ]
    })(props);
}
function BiSolidCubeAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.895 3.553A1.001 1.001 0 0 0 17 3H7c-.379 0-.725.214-.895.553l-4 8a1 1 0 0 0 0 .895l4 8c.17.338.516.552.895.552h10c.379 0 .725-.214.895-.553l4-8a1 1 0 0 0 0-.895l-4-7.999zM19.382 11h-7.764l-3-6h7.764l3 6zm-3 8H8.618l3-6h7.764l-3 6z"
                }
            }
        ]
    })(props);
}
function BiSolidCube(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.406 6.086-9-4a1.001 1.001 0 0 0-.813 0l-9 4c-.02.009-.034.024-.054.035-.028.014-.058.023-.084.04-.022.015-.039.034-.06.05a.87.87 0 0 0-.19.194c-.02.028-.041.053-.059.081a1.119 1.119 0 0 0-.076.165c-.009.027-.023.052-.031.079A1.013 1.013 0 0 0 2 7v10c0 .396.232.753.594.914l9 4c.13.058.268.086.406.086a.997.997 0 0 0 .402-.096l.004.01 9-4A.999.999 0 0 0 22 17V7a.999.999 0 0 0-.594-.914zM12 4.095 18.538 7 12 9.905l-1.308-.581L5.463 7 12 4.095zm1 15.366V11.65l7-3.111v7.812l-7 3.11z"
                }
            }
        ]
    })(props);
}
function BiSolidCuboid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.707 2.293A.996.996 0 0 0 16 2H8c-.414 0-.785.255-.934.641l-5 13a.999.999 0 0 0 .227 1.066l5 5A.996.996 0 0 0 8 22h8c.414 0 .785-.255.934-.641l5-13a.999.999 0 0 0-.227-1.066l-5-5zM18.585 7h-5.171l-3-3h5.172l2.999 3zm-3.272 13h-6.23l4.583-11h5.878l-4.231 11z"
                }
            }
        ]
    })(props);
}
function BiSolidCustomize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm10 0h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM10 13H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm8 1h-2v2h-2v2h2v2h2v-2h2v-2h-2z"
                }
            }
        ]
    })(props);
}
function BiSolidCylinder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.131 0 9-1.935 9-4.5V7c0-.051-.024-.097-.033-.146.016-.117.033-.234.033-.354C21 3.935 17.131 2 12 2S3 3.935 3 6.5v11c0 2.565 3.869 4.5 9 4.5zm0-18c4.273 0 7 1.48 7 2.5a.683.683 0 0 1-.025.158c-.004.01-.012.018-.015.027-.274.848-2.29 1.98-5.496 2.253l-.05.003C12.965 8.979 12.494 9 12 9 7.727 9 5 7.52 5 6.5S7.727 4 12 4z"
                }
            }
        ]
    })(props);
}
function BiSolidDashboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 13h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1zm-1 7a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v4zm10 0a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v7zm1-10h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1z"
                }
            }
        ]
    })(props);
}
function BiSolidData(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6c0-2.168-3.663-4-8-4S4 3.832 4 6v2c0 2.168 3.663 4 8 4s8-1.832 8-4V6zm-8 13c-4.337 0-8-1.832-8-4v3c0 2.168 3.663 4 8 4s8-1.832 8-4v-3c0 2.168-3.663 4-8 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10c0 2.168-3.663 4-8 4s-8-1.832-8-4v3c0 2.168 3.663 4 8 4s8-1.832 8-4v-3z"
                }
            }
        ]
    })(props);
}
function BiSolidDetail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-9 14H5v-2h6v2zm8-4H5v-2h14v2zm0-4H5V7h14v2z"
                }
            }
        ]
    })(props);
}
function BiSolidDevices(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H7c-1.103 0-2 .897-2 2v2H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h6c1.103 0 2-.897 2-2h8c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM6 9h4l-.003 9H4V9h2zm6 8V9c0-1.103-.897-2-2-2H7V5h11v12h-6z"
                }
            }
        ]
    })(props);
}
function BiSolidDiamond(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.445 3h-8.89c-.345 0-.666.178-.849.47L3.25 9h17.5l-3.456-5.53a1.003 1.003 0 0 0-.849-.47zM11.26 21.186a1 1 0 0 0 1.48 0L22 11H2l9.26 10.186z"
                }
            }
        ]
    })(props);
}
function BiSolidDice1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm-7 10.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                }
            }
        ]
    })(props);
}
function BiSolidDice2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM9.5 13.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 9.5 13.5zm5 0a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 14.5 13.5z"
                }
            }
        ]
    })(props);
}
function BiSolidDice3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM8 9.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8 9.5zm4 4a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 12 13.5zm4 4a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 16 17.5z"
                }
            }
        ]
    })(props);
}
function BiSolidDice4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM8 17.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8 17.5zm0-8a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8 9.5zm8 8a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 16 17.5zm0-8a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 16 9.5z"
                }
            }
        ]
    })(props);
}
function BiSolidDice5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM8 17.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8 17.5zm0-8a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8 9.5zm4 4a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 12 13.5zm4 4a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 16 17.5zm0-8a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 16 9.5z"
                }
            }
        ]
    })(props);
}
function BiSolidDice6(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM8 17.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8 17.5zm0-4a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8 13.5zm0-4a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8 9.5zm8 8a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 16 17.5zm0-4a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 16 13.5zm0-4a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 16 9.5z"
                }
            }
        ]
    })(props);
}
function BiSolidDirectionLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.707 11.294-8.978-9a1.001 1.001 0 0 0-1.415-.002l-9.021 9a1 1 0 0 0 0 1.416l9.021 9c.39.389 1.026.388 1.415-.002l8.978-9a.998.998 0 0 0 0-1.412zM15 16h-2v-4h-3v2l-3-3 3-3v2h5v6z"
                }
            }
        ]
    })(props);
}
function BiSolidDirectionRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.295 12.707 8.978 9c.389.39 1.025.391 1.414.002l9.021-9a1 1 0 0 0 0-1.416l-9.021-9a.999.999 0 0 0-1.414.002l-8.978 9a.998.998 0 0 0 0 1.412zm6.707-2.706h5v-2l3 3-3 3v-2h-3v4h-2v-6z"
                }
            }
        ]
    })(props);
}
function BiSolidDirections(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 11h-6V8h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H5L2 5l3 3h6v3H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h6v5h2v-5h6l3-3-3-3z"
                }
            }
        ]
    })(props);
}
function BiSolidDisc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 14c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.998",
                    "cy": "11.998",
                    "r": "2.002"
                }
            }
        ]
    })(props);
}
function BiSolidDiscount(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5H3a1 1 0 0 0-1 1v4h.893c.996 0 1.92.681 2.08 1.664A2.001 2.001 0 0 1 3 14H2v4a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-4h-1a2.001 2.001 0 0 1-1.973-2.336c.16-.983 1.084-1.664 2.08-1.664H22V6a1 1 0 0 0-1-1zM9 9a1 1 0 1 1 0 2 1 1 0 1 1 0-2zm-.8 6.4 6-8 1.6 1.2-6 8-1.6-1.2zM15 15a1 1 0 1 1 0-2 1 1 0 1 1 0 2z"
                }
            }
        ]
    })(props);
}
function BiSolidDish(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15c0-4.625-3.507-8.441-8-8.941V4h-2v2.059c-4.493.5-8 4.316-8 8.941v2h18v-2zM2 18h20v2H2z"
                }
            }
        ]
    })(props);
}
function BiSolidDislike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3h-1v13h1a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM4 16h7l-1.122 3.368A2 2 0 0 0 11.775 22H12l5-5.438V3H6l-3.937 8.649-.063.293V14a2 2 0 0 0 2 2z"
                }
            }
        ]
    })(props);
}
function BiSolidDizzy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM8 12.414l-1.293 1.293-1.414-1.414L6.586 11 5.293 9.707l1.414-1.414L8 9.586l1.293-1.293 1.414 1.414L9.414 11l1.293 1.293-1.414 1.414L8 12.414zM14 18h-4v-2h4v2zm4.707-5.707-1.414 1.414L16 12.414l-1.293 1.293-1.414-1.414L14.586 11l-1.293-1.293 1.414-1.414L16 9.586l1.293-1.293 1.414 1.414L17.414 11l1.293 1.293z"
                }
            }
        ]
    })(props);
}
function BiSolidDockBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM19 5l.001 9H5V5h14z"
                }
            }
        ]
    })(props);
}
function BiSolidDockLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2zm-11 0V5h9l.002 14H10z"
                }
            }
        ]
    })(props);
}
function BiSolidDockRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5zM5 5h9v14H5V5z"
                }
            }
        ]
    })(props);
}
function BiSolidDockTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2zm2 14v-9h14.001l.001 9H5z"
                }
            }
        ]
    })(props);
}
function BiSolidDog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6h-2l-1.27-1.27A2.49 2.49 0 0 0 16 4h-2.5A2.64 2.64 0 0 0 11 2v6.36a4.38 4.38 0 0 0 1.13 2.72 6.57 6.57 0 0 0 4.13 1.82l3.45-1.38a3 3 0 0 0 1.73-1.84L22 8.15a1.06 1.06 0 0 0 0-.31V7a1 1 0 0 0-1-1zm-5 2a1 1 0 1 1 1-1 1 1 0 0 1-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.38 11.74A5.24 5.24 0 0 1 10.07 9H6a1.88 1.88 0 0 1-2-2 1 1 0 0 0-2 0 4.69 4.69 0 0 0 .48 2A3.58 3.58 0 0 0 4 10.53V22h3v-5h6v5h3v-8.13a7.35 7.35 0 0 1-4.62-2.13z"
                }
            }
        ]
    })(props);
}
function BiSolidDollarCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm1 14.915V18h-2v-1.08c-2.339-.367-3-2.002-3-2.92h2c.011.143.159 1 2 1 1.38 0 2-.585 2-1 0-.324 0-1-2-1-3.48 0-4-1.88-4-3 0-1.288 1.029-2.584 3-2.915V6.012h2v1.109c1.734.41 2.4 1.853 2.4 2.879h-1l-1 .018C13.386 9.638 13.185 9 12 9c-1.299 0-2 .516-2 1 0 .374 0 1 2 1 3.48 0 4 1.88 4 3 0 1.288-1.029 2.584-3 2.915z"
                }
            }
        ]
    })(props);
}
function BiSolidDonateBlood(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.726 13.02 14 16H9v-1h4.065a.5.5 0 0 0 .416-.777l-.888-1.332A1.995 1.995 0 0 0 10.93 12H3a1 1 0 0 0-1 1v6a2 2 0 0 0 2 2h9.639a3 3 0 0 0 2.258-1.024L22 13l-1.452-.484a2.998 2.998 0 0 0-2.822.504zM15.403 12a3 3 0 0 0 3-3c0-2.708-3-6-3-6s-3 3.271-3 6a3 3 0 0 0 3 3z"
                }
            }
        ]
    })(props);
}
function BiSolidDonateHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.726 13.02 14 16H9v-1h4.065a.5.5 0 0 0 .416-.777l-.888-1.332A1.995 1.995 0 0 0 10.93 12H3a1 1 0 0 0-1 1v6a2 2 0 0 0 2 2h9.639a3 3 0 0 0 2.258-1.024L22 13l-1.452-.484a2.998 2.998 0 0 0-2.822.504zm1.532-5.63c.451-.465.73-1.108.73-1.818s-.279-1.353-.73-1.818A2.447 2.447 0 0 0 17.494 3S16.25 2.997 15 4.286C13.75 2.997 12.506 3 12.506 3a2.45 2.45 0 0 0-1.764.753c-.451.466-.73 1.108-.73 1.818s.279 1.354.73 1.818L15 12l4.258-4.61z"
                }
            }
        ]
    })(props);
}
function BiSolidDoorOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5v14a1 1 0 0 0 1 1h3v-2H7V6h2V4H6a1 1 0 0 0-1 1zm14.242-.97-8-2A1 1 0 0 0 10 3v18a.998.998 0 0 0 1.242.97l8-2A1 1 0 0 0 20 19V5a1 1 0 0 0-.758-.97zM15 12.188a1.001 1.001 0 0 1-2 0v-.377a1 1 0 1 1 2 .001v.376z"
                }
            }
        ]
    })(props);
}
function BiSolidDoughnutChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6c2.507.423 4.577 2.493 5 5h4c-.471-4.717-4.283-8.529-9-9v4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c-.478 2.833-2.982 4.949-5.949 4.949-3.309 0-6-2.691-6-6C6.051 8.982 8.167 6.478 11 6V2c-5.046.504-8.949 4.773-8.949 9.949 0 5.514 4.486 10 10 10 5.176 0 9.445-3.903 9.949-8.949h-4z"
                }
            }
        ]
    })(props);
}
function BiSolidDownArrowAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 12h-5V6h-2v6H6l6 7z"
                }
            }
        ]
    })(props);
}
function BiSolidDownArrowCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 15-5-5h4V7h2v5h4l-5 5z"
                }
            }
        ]
    })(props);
}
function BiSolidDownArrowSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14zm-8-9V7h2v5h4l-5 5-5-5h4z"
                }
            }
        ]
    })(props);
}
function BiSolidDownArrow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.178 19.569a.998.998 0 0 0 1.644 0l9-13A.999.999 0 0 0 21 5H3a1.002 1.002 0 0 0-.822 1.569l9 13z"
                }
            }
        ]
    })(props);
}
function BiSolidDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9h-4V3H9v6H5l7 8zM4 19h16v2H4z"
                }
            }
        ]
    })(props);
}
function BiSolidDownvote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.901 10.566A1.001 1.001 0 0 0 20 10h-4V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v7H4a1.001 1.001 0 0 0-.781 1.625l8 10a1 1 0 0 0 1.562 0l8-10c.24-.301.286-.712.12-1.059z"
                }
            }
        ]
    })(props);
}
function BiSolidDrink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.832 4.555A1 1 0 0 0 20 3H4a1 1 0 0 0-.832 1.554L11 16.303V20H8v2h8v-2h-3v-3.697l7.832-11.748zm-2.7.445-2 3H7.868l-2-3h12.264z"
                }
            }
        ]
    })(props);
}
function BiSolidDropletHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.578 2.184a1.004 1.004 0 0 0-1.156 0C11.119 2.398 4 7.513 4 13.75 4 18.53 7.364 22 12 22s8-3.468 8-8.246c0-6.241-7.119-11.356-7.422-11.57zM6 13.75c0-4.283 4.395-8.201 6-9.49V20c-3.533 0-6-2.57-6-6.25z"
                }
            }
        ]
    })(props);
}
function BiSolidDroplet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.6 2.4c-.4-.3-.9-.3-1.2 0C9.5 3.9 4 8.5 4 14c0 4.4 3.6 8 8 8s8-3.6 8-8c0-5.4-5.5-10.1-7.4-11.6"
                }
            }
        ]
    })(props);
}
function BiSolidDryer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h16a1 1 0 0 0 1-1V5c0-1.654-1.346-3-3-3H6C4.346 2 3 3.346 3 5v16a1 1 0 0 0 1 1zM18 3.924a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-3 3.117c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.32 12.265c-.415.384-1.041.964-1.041 2.067 0 1.104.626 1.684 1.041 2.068.352.325.4.398.4.6h2c0-1.104-.626-1.684-1.041-2.068-.352-.325-.4-.398-.4-.6s.048-.275.4-.6c.414-.384 1.041-.964 1.041-2.068 0-1.103-.626-1.683-1.041-2.066-.351-.325-.399-.397-.399-.598h-2c0 1.104.627 1.683 1.042 2.066.351.324.399.396.399.597-.001.203-.05.276-.401.602zm4 0c-.414.384-1.04.964-1.04 2.067s.626 1.684 1.04 2.067c.351.325.399.398.399.601h2c0-1.104-.626-1.684-1.04-2.067-.351-.325-.399-.398-.399-.601s.049-.275.399-.601c.414-.384 1.04-.964 1.04-2.068 0-1.103-.626-1.682-1.04-2.065-.35-.324-.399-.397-.399-.598h-2c0 1.103.626 1.683 1.041 2.066.35.324.398.397.398.598.001.202-.048.275-.399.601z"
                }
            }
        ]
    })(props);
}
function BiSolidDuplicate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2zm2-9h3v-3h2v3h3v2h-3v3H9v-3H6v-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8v2h12v12h2V4c0-1.103-.897-2-2-2z"
                }
            }
        ]
    })(props);
}
function BiSolidEditAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m16 2.012 3 3L16.713 7.3l-3-3zM4 14v3h3l8.299-8.287-3-3zm0 6h16v2H4z"
                }
            }
        ]
    })(props);
}
function BiSolidEditLocation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C7.589 2 4 5.589 4 9.995 3.971 16.44 11.696 21.784 12 22c0 0 8.029-5.56 8-12 0-4.411-3.589-8-8-8zM9.799 14.987H8v-1.799l4.977-4.97 1.799 1.799-4.977 4.97zm5.824-5.817-1.799-1.799L15.196 6l1.799 1.799-1.372 1.371z"
                }
            }
        ]
    })(props);
}
function BiSolidEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m18.988 2.012 3 3L19.701 7.3l-3-3zM8 16h3l7.287-7.287-3-3L8 13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19H8.158c-.026 0-.053.01-.079.01-.033 0-.066-.009-.1-.01H5V5h6.847l2-2H5c-1.103 0-2 .896-2 2v14c0 1.104.897 2 2 2h14a2 2 0 0 0 2-2v-8.668l-2 2V19z"
                }
            }
        ]
    })(props);
}
function BiSolidEject(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 6-6 8h12zM6 16h12v2H6z"
                }
            }
        ]
    })(props);
}
function BiSolidEnvelopeOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.555 8.168-9-6a1 1 0 0 0-1.109 0l-9 6A.995.995 0 0 0 2.004 9H2v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9h-.004a.997.997 0 0 0-.441-.832zM20 12.7 12 17l-8-4.3v-2.403l8 4.299 8-4.299V12.7z"
                }
            }
        ]
    })(props);
}
function BiSolidEnvelope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 4.7-8 5.334L4 8.7V6.297l8 5.333 8-5.333V8.7z"
                }
            }
        ]
    })(props);
}
function BiSolidEraser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.48 3 7.73 7.75 3 12.59a2 2 0 0 0 0 2.82l4.3 4.3A1 1 0 0 0 8 20h12v-2h-7l7.22-7.22a2 2 0 0 0 0-2.83L15.31 3a2 2 0 0 0-2.83 0zM8.41 18l-4-4 4.75-4.84.74-.75 4.95 4.95-4.56 4.56-.07.08z"
                }
            }
        ]
    })(props);
}
function BiSolidErrorAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.707 2.293A.996.996 0 0 0 16 2H8a.996.996 0 0 0-.707.293l-5 5A.996.996 0 0 0 2 8v8c0 .266.105.52.293.707l5 5A.996.996 0 0 0 8 22h8c.266 0 .52-.105.707-.293l5-5A.996.996 0 0 0 22 16V8a.996.996 0 0 0-.293-.707l-5-5zM13 17h-2v-2h2v2zm0-4h-2V7h2v6z"
                }
            }
        ]
    })(props);
}
function BiSolidErrorCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.953 2C6.465 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.493 2 11.953 2zM13 17h-2v-2h2v2zm0-4h-2V7h2v6z"
                }
            }
        ]
    })(props);
}
function BiSolidError(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.884 2.532c-.346-.654-1.422-.654-1.768 0l-9 17A.999.999 0 0 0 3 21h18a.998.998 0 0 0 .883-1.467L12.884 2.532zM13 18h-2v-2h2v2zm-2-4V9h2l.001 5H11z"
                }
            }
        ]
    })(props);
}
function BiSolidEvStation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19.616 6.48.014-.017-4-3.24-1.26 1.554 2.067 1.674a2.99 2.99 0 0 0-1.394 3.062c.15.899.769 1.676 1.57 2.111.895.487 1.68.442 2.378.194L18.976 18a.996.996 0 0 1-1.39.922.995.995 0 0 1-.318-.217.996.996 0 0 1-.291-.705L17 16a2.98 2.98 0 0 0-.877-2.119A3 3 0 0 0 14 13h-1V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2v-4h1c.136 0 .267.027.391.078a1.028 1.028 0 0 1 .531.533A.994.994 0 0 1 15 16l-.024 2c0 .406.079.799.236 1.168.151.359.368.68.641.951a2.97 2.97 0 0 0 2.123.881c.406 0 .798-.078 1.168-.236.358-.15.68-.367.951-.641A2.983 2.983 0 0 0 20.976 18L21 9a2.997 2.997 0 0 0-1.384-2.52zM6 18l1-5H4l5-7-1 5h3l-5 7zm12-8a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                }
            }
        ]
    })(props);
}
function BiSolidExit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.002 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2h-14c-1.103 0-2 .897-2 2v6.001H10V7l6 5-6 5v-3.999H3.002V19c0 1.103.897 2 2 2z"
                }
            }
        ]
    })(props);
}
function BiSolidExtension(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10V7c0-1.103-.897-2-2-2h-3c0-1.654-1.346-3-3-3S8 3.346 8 5H5c-1.103 0-2 .897-2 2v4h1a2 2 0 0 1 0 4H3v4c0 1.103.897 2 2 2h4v-1a2 2 0 0 1 4 0v1h4c1.103 0 2-.897 2-2v-3c1.654 0 3-1.346 3-3s-1.346-3-3-3z"
                }
            }
        ]
    })(props);
}
function BiSolidEyedropper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m4 15.76-1 4A1 1 0 0 0 3.75 21a1 1 0 0 0 .49 0l4-1a1 1 0 0 0 .47-.26L17 11.41l1.29 1.3 1.42-1.42-1.3-1.29L21 7.41a2 2 0 0 0 0-2.82L19.41 3a2 2 0 0 0-2.82 0L14 5.59l-1.3-1.3-1.42 1.42L12.58 7l-8.29 8.29a1 1 0 0 0-.29.47zm1.87.75L14 8.42 15.58 10l-8.09 8.1-2.12.53z"
                }
            }
        ]
    })(props);
}
function BiSolidFaceMask(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12c0 2.521.945 4.82 2.49 6.582 1.24 1.52 3.266 3.066 6.439 3.358a9.731 9.731 0 0 0 2.141 0c3.174-.292 5.199-1.839 6.439-3.358A9.948 9.948 0 0 0 22 12c0-5.514-4.486-10-10-10zM4.709 8.724c.154.09.308.182.456.276.396.25.791.5 1.286.688.494.187 1.088.312 1.879.312.792 0 1.386-.125 1.881-.313s.891-.437 1.287-.687.792-.5 1.287-.688c.494-.187 1.088-.312 1.88-.312s1.386.125 1.88.313c.495.187.891.437 1.287.687s.792.5 1.287.688c.178.067.374.122.581.171.191.682.3 1.398.3 2.141 0 .843-.133 1.654-.375 2.417-.261.195-.733.474-1.577.756-.769.256-1.672.458-2.685.602a25.337 25.337 0 0 1-6.727 0c-1.013-.144-1.916-.346-2.685-.602-.844-.282-1.316-.561-1.577-.756a7.953 7.953 0 0 1 .335-5.693z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "12.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "12.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function BiSolidFace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8 0-1.168.258-2.275.709-3.276.154.09.308.182.456.276.396.25.791.5 1.286.688.494.187 1.088.312 1.879.312.792 0 1.386-.125 1.881-.313s.891-.437 1.287-.687.792-.5 1.287-.688c.494-.187 1.088-.312 1.88-.312s1.386.125 1.88.313c.495.187.891.437 1.287.687s.792.5 1.287.688c.178.067.374.122.581.171.191.682.3 1.398.3 2.141 0 4.411-3.589 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "12.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "12.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function BiSolidFactory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10V6l-5 4V6l-5 4V4H2v16h20V6l-5 4zm-8 7H7v-3h2v3zm5 0h-2v-3h2v3zm5 0h-2v-3h2v3z"
                }
            }
        ]
    })(props);
}
function BiSolidFastForwardCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.485 2 2 6.485 2 12s4.485 10 10 10c5.514 0 10-4.485 10-10S17.514 2 12 2zm1 14v-4l-6 4V8l6 4V8l6 4-6 4z"
                }
            }
        ]
    })(props);
}
function BiSolidFileArchive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6h-3v2H9v2h2v2H9v2h2v8H7v-6h2v-2H7V8h2V6H7V4h2V2H6zm7 2 5 5h-5V4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 15h2v2H8z"
                }
            }
        ]
    })(props);
}
function BiSolidFileBlank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6H6zm8 7h-1V4l5 5h-4z"
                }
            }
        ]
    })(props);
}
function BiSolidFileCss(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM9.446 17.412c.275 0 .581-.061.762-.132l.138.713c-.168.084-.546.174-1.037.174-1.397 0-2.117-.869-2.117-2.021C7.191 14.768 8.175 14 9.398 14c.474 0 .833.096.995.18l-.186.726a1.98 1.98 0 0 0-.768-.149c-.726 0-1.29.438-1.29 1.337.001.808.482 1.318 1.297 1.318zm2.491.755c-.461 0-.917-.119-1.145-.245l.186-.756c.246.126.624.252 1.014.252.42 0 .642-.174.642-.438 0-.252-.192-.396-.678-.57-.672-.234-1.109-.605-1.109-1.193 0-.689.575-1.217 1.529-1.217.455 0 .791.096 1.031.203l-.204.738a1.919 1.919 0 0 0-.846-.192c-.396 0-.587.181-.587.39 0 .258.228.372.749.57.714.264 1.05.636 1.05 1.205-.001.678-.523 1.253-1.632 1.253zm3.24 0c-.461 0-.917-.119-1.145-.245l.186-.756c.246.126.624.252 1.014.252.42 0 .642-.174.642-.438 0-.252-.192-.396-.678-.57-.672-.234-1.109-.605-1.109-1.193 0-.689.575-1.217 1.529-1.217.455 0 .791.096 1.031.203l-.204.738a1.919 1.919 0 0 0-.846-.192c-.396 0-.587.181-.587.39 0 .258.228.372.749.57.714.264 1.05.636 1.05 1.205 0 .678-.523 1.253-1.632 1.253zM14 9h-1V4l5 5h-4z"
                }
            }
        ]
    })(props);
}
function BiSolidFileDoc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.186 14.552c-.617 0-.977.587-.977 1.373 0 .791.371 1.35.983 1.35.617 0 .971-.588.971-1.374 0-.726-.348-1.349-.977-1.349z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM9.155 17.454c-.426.354-1.073.521-1.864.521-.475 0-.81-.03-1.038-.06v-3.971a8.16 8.16 0 0 1 1.235-.083c.768 0 1.266.138 1.655.432.42.312.684.81.684 1.522 0 .775-.282 1.309-.672 1.639zm2.99.546c-1.2 0-1.901-.906-1.901-2.058 0-1.211.773-2.116 1.967-2.116 1.241 0 1.919.929 1.919 2.045-.001 1.325-.805 2.129-1.985 2.129zm4.655-.762c.275 0 .581-.061.762-.132l.138.713c-.168.084-.546.174-1.037.174-1.397 0-2.117-.869-2.117-2.021 0-1.379.983-2.146 2.207-2.146.474 0 .833.096.995.18l-.186.726a1.979 1.979 0 0 0-.768-.15c-.726 0-1.29.438-1.29 1.338 0 .809.48 1.318 1.296 1.318zM14 9h-1V4l5 5h-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.584 14.563c-.203 0-.335.018-.413.036v2.645c.078.018.204.018.317.018.828.006 1.367-.449 1.367-1.415.006-.84-.485-1.284-1.271-1.284z"
                }
            }
        ]
    })(props);
}
function BiSolidFileExport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 22a2 2 0 0 0 2-2v-5l-5 4v-3H8v-2h7v-3l5 4V8l-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12zM13 4l5 5h-5V4z"
                }
            }
        ]
    })(props);
}
function BiSolidFileFind(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22h12c.178 0 .348-.03.512-.074l-3.759-3.759A4.966 4.966 0 0 1 12 19c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5a4.964 4.964 0 0 1-.833 2.753l3.759 3.759c.044-.164.074-.334.074-.512V8l-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "14",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function BiSolidFileGif(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-2.667 15.772A4.512 4.512 0 0 1 9.984 18c-.737 0-1.271-.186-1.644-.546-.371-.348-.575-.875-.569-1.469.006-1.344.983-2.111 2.309-2.111.521 0 .924.103 1.121.198l-.191.731c-.222-.096-.498-.174-.941-.174-.762 0-1.338.432-1.338 1.308 0 .833.522 1.325 1.271 1.325.21 0 .378-.024.45-.061v-.846h-.624v-.713h1.505v2.13zm1.634.186h-.918v-4.042h.918v4.042zm3.262-3.292h-1.553v.923h1.451v.744h-1.451v1.625h-.918v-4.042h2.471v.75zM14 9h-1V4l5 5h-4z"
                }
            }
        ]
    })(props);
}
function BiSolidFileHtml(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 2 5 5h-5V4zM8.531 18h-.76v-1.411H6.515V18h-.767v-3.373h.767v1.296h1.257v-1.296h.76V18zm3-2.732h-.921V18h-.766v-2.732h-.905v-.641h2.592v.641zM14.818 18l-.05-1.291c-.017-.405-.03-.896-.03-1.387h-.016c-.104.431-.245.911-.375 1.307l-.41 1.316h-.597l-.359-1.307a15.154 15.154 0 0 1-.306-1.316h-.011c-.021.456-.034.976-.059 1.396L12.545 18h-.705l.216-3.373h1.015l.331 1.126c.104.391.21.811.284 1.206h.017c.095-.391.209-.836.32-1.211l.359-1.121h.996L15.563 18h-.745zm3.434 0h-2.108v-3.373h.767v2.732h1.342V18z"
                }
            }
        ]
    })(props);
}
function BiSolidFileImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22h12a2 2 0 0 0 2-2V8l-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2zm7-18 5 5h-5V4zm-4.5 7a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 8.5 11zm.5 5 1.597 1.363L13 13l4 6H7l2-3z"
                }
            }
        ]
    })(props);
}
function BiSolidFileImport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 14V8l-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4h-7v3l-5-4 5-4v3h7zM13 4l5 5h-5V4z"
                }
            }
        ]
    })(props);
}
function BiSolidFileJpg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM9.239 16.446c0 1.152-.551 1.554-1.438 1.554-.21 0-.486-.036-.665-.097l.101-.737c.127.042.289.072.469.072.384 0 .623-.174.623-.804v-2.543h.911v2.555zm3.294-.365c-.313.293-.773.426-1.313.426-.12 0-.228-.007-.312-.019v1.445h-.906v-3.988a7.528 7.528 0 0 1 1.236-.083c.563 0 .965.107 1.234.323.259.204.433.54.433.936s-.133.732-.372.96zm4.331 1.667c-.28.096-.815.228-1.349.228-.737 0-1.271-.186-1.643-.546-.371-.348-.575-.875-.57-1.469.007-1.344.983-2.111 2.309-2.111.521 0 .924.103 1.121.198l-.191.731c-.222-.096-.497-.174-.941-.174-.761 0-1.338.432-1.338 1.308 0 .833.523 1.325 1.271 1.325.211 0 .378-.024.451-.061v-.846h-.624v-.713h1.504v2.13zM14 9h-1V4l5 5h-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.285 14.552c-.186 0-.312.018-.377.036v1.193c.077.018.174.023.307.023.484 0 .784-.246.784-.659 0-.372-.257-.593-.714-.593z"
                }
            }
        ]
    })(props);
}
function BiSolidFileJs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-2.745 14.186c0 1.345-.644 1.814-1.681 1.814-.245 0-.567-.042-.777-.112l.119-.861c.147.049.336.084.546.084.448 0 .729-.203.729-.938v-2.97h1.064v2.983zm2.043 1.807c-.539 0-1.071-.141-1.337-.287l.217-.883c.287.147.729.294 1.184.294.491 0 .749-.203.749-.511 0-.295-.224-.463-.791-.666-.784-.272-1.295-.707-1.295-1.394 0-.806.672-1.422 1.786-1.422.533 0 .925.112 1.205.238l-.238.861c-.189-.091-.525-.224-.987-.224s-.687.21-.687.455c0 .301.267.435.875.665.834.309 1.226.742 1.226 1.408-.002.793-.61 1.466-1.907 1.466zM14 9h-1V4l5 5h-4z"
                }
            }
        ]
    })(props);
}
function BiSolidFileJson(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.823 15.122c-.517 0-.816.491-.816 1.146 0 .661.311 1.126.82 1.126.517 0 .812-.49.812-1.146 0-.604-.291-1.126-.816-1.126z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM8.022 16.704c0 .961-.461 1.296-1.2 1.296-.176 0-.406-.029-.557-.08l.086-.615c.104.035.239.06.391.06.319 0 .52-.145.52-.67v-2.122h.761v2.131zm1.459 1.291c-.385 0-.766-.1-.955-.205l.155-.631c.204.105.521.211.846.211.35 0 .534-.146.534-.365 0-.211-.159-.331-.564-.476-.562-.195-.927-.506-.927-.996 0-.576.481-1.017 1.277-1.017.38 0 .659.08.861.171l-.172.615c-.135-.065-.375-.16-.705-.16s-.491.15-.491.325c0 .215.19.311.627.476.596.22.876.53.876 1.006.001.566-.436 1.046-1.362 1.046zm3.306.005c-1.001 0-1.586-.755-1.586-1.716 0-1.012.646-1.768 1.642-1.768 1.035 0 1.601.776 1.601 1.707C14.443 17.33 13.773 18 12.787 18zm4.947-.055h-.802l-.721-1.302a12.64 12.64 0 0 1-.585-1.19l-.016.005c.021.445.031.921.031 1.472v1.016h-.701v-3.373h.891l.701 1.236c.2.354.4.775.552 1.155h.014c-.05-.445-.065-.9-.065-1.406v-.985h.702v3.372zM14 9h-1V4l5 5h-4z"
                }
            }
        ]
    })(props);
}
function BiSolidFileMd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.481 14.015c-.238 0-.393.021-.483.042v3.089c.091.021.237.021.371.021.966.007 1.597-.525 1.597-1.653.007-.981-.568-1.499-1.485-1.499z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-2.934 15.951-.07-1.807a53.142 53.142 0 0 1-.042-1.94h-.021a26.098 26.098 0 0 1-.525 1.828l-.574 1.842H9l-.504-1.828a21.996 21.996 0 0 1-.428-1.842h-.013c-.028.638-.049 1.366-.084 1.954l-.084 1.793h-.988L7.2 13.23h1.422l.462 1.576c.147.546.295 1.135.399 1.688h.021a39.87 39.87 0 0 1 .448-1.694l.504-1.569h1.394l.26 4.721h-1.044zm5.25-.56c-.498.413-1.253.609-2.178.609a9.27 9.27 0 0 1-1.212-.07v-4.636a9.535 9.535 0 0 1 1.443-.099c.896 0 1.478.161 1.933.505.49.364.799.945.799 1.778 0 .904-.33 1.528-.785 1.913zM14 9h-1V4l5 5h-4z"
                }
            }
        ]
    })(props);
}
function BiSolidFilePdf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.267 14.68c-.184 0-.308.018-.372.036v1.178c.076.018.171.023.302.023.479 0 .774-.242.774-.651 0-.366-.254-.586-.704-.586zm3.487.012c-.2 0-.33.018-.407.036v2.61c.077.018.201.018.313.018.817.006 1.349-.444 1.349-1.396.006-.83-.479-1.268-1.255-1.268z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM9.498 16.19c-.309.29-.765.42-1.296.42a2.23 2.23 0 0 1-.308-.018v1.426H7v-3.936A7.558 7.558 0 0 1 8.219 14c.557 0 .953.106 1.22.319.254.202.426.533.426.923-.001.392-.131.723-.367.948zm3.807 1.355c-.42.349-1.059.515-1.84.515-.468 0-.799-.03-1.024-.06v-3.917A7.947 7.947 0 0 1 11.66 14c.757 0 1.249.136 1.633.426.415.308.675.799.675 1.504 0 .763-.279 1.29-.663 1.615zM17 14.77h-1.532v.911H16.9v.734h-1.432v1.604h-.906V14.03H17v.74zM14 9h-1V4l5 5h-4z"
                }
            }
        ]
    })(props);
}
function BiSolidFilePlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22h12a2 2 0 0 0 2-2V8l-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2zm7-18 5 5h-5V4zM8 14h3v-3h2v3h3v2h-3v3h-2v-3H8v-2z"
                }
            }
        ]
    })(props);
}
function BiSolidFilePng(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.782 14.576c-.186 0-.312.018-.377.036v1.193c.077.018.174.023.306.023.485 0 .785-.246.785-.659 0-.371-.258-.593-.714-.593z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM9.03 16.105c-.313.293-.774.426-1.313.426-.12 0-.229-.007-.312-.019v1.445h-.906V13.97a7.504 7.504 0 0 1 1.235-.083c.563 0 .966.107 1.235.323.258.204.432.54.432.936s-.131.731-.371.959zm4.302 1.853h-.96l-.863-1.56c-.24-.432-.504-.953-.701-1.427l-.019.006c.024.534.036 1.104.036 1.763v1.218h-.84v-4.042h1.067l.84 1.481c.24.426.479.93.659 1.385h.019a14.746 14.746 0 0 1-.078-1.685v-1.182h.84v4.043zm4.169-.186a4.512 4.512 0 0 1-1.349.228c-.737 0-1.271-.186-1.644-.546-.371-.348-.575-.875-.569-1.469.006-1.344.983-2.111 2.309-2.111.521 0 .924.103 1.121.198l-.191.731c-.222-.096-.498-.174-.941-.174-.762 0-1.338.432-1.338 1.308 0 .833.522 1.325 1.271 1.325.21 0 .378-.024.45-.061v-.846h-.624v-.713h1.505v2.13zM14 9h-1V4l5 5h-4z"
                }
            }
        ]
    })(props);
}
function BiSolidFileTxt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM9.998 14.768H8.895v3.274h-.917v-3.274H6.893V14h3.105v.768zm2.725 3.274-.365-.731c-.15-.282-.246-.492-.359-.726h-.013c-.083.233-.185.443-.312.726l-.335.731h-1.045l1.171-2.045L10.336 14h1.05l.354.738c.121.245.21.443.306.671h.013c.096-.258.174-.438.276-.671l.341-.738h1.043l-1.139 1.973 1.198 2.069h-1.055zm4.384-3.274h-1.104v3.274h-.917v-3.274h-1.085V14h3.105v.768zM14 9h-1V4l5 5h-4z"
                }
            }
        ]
    })(props);
}
function BiSolidFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 22a2 2 0 0 0 2-2V8l-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12zM13 4l5 5h-5V4zM7 8h3v2H7V8zm0 4h10v2H7v-2zm0 4h10v2H7v-2z"
                }
            }
        ]
    })(props);
}
function BiSolidFilm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4v1h-2V3H7v2H5V3H3v18h2v-2h2v2h10v-2h2v2h2V3h-2v1zM5 7h2v2H5V7zm0 4h2v2H5v-2zm0 6v-2h2v2H5zm12 0v-2h2v2h-2zm2-4h-2v-2h2v2zm-2-4V7h2v2h-2z"
                }
            }
        ]
    })(props);
}
function BiSolidFilterAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 20v-4.586L20.414 8c.375-.375.586-.884.586-1.415V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v2.585c0 .531.211 1.04.586 1.415L11 15.414V22l2-2z"
                }
            }
        ]
    })(props);
}
function BiSolidFirstAid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-3V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zM9 4h6v2H9zm7 10h-3v3h-2v-3H8v-2h3V9h2v3h3z"
                }
            }
        ]
    })(props);
}
function BiSolidFlagAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m14.303 6-3-2H6V2H4v20h2v-8h4.697l3 2H20V6z"
                }
            }
        ]
    })(props);
}
function BiSolidFlagCheckered(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 2v18H3v2h4v-2H6v-5h13a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H6V2H4zm4 3v2h2V5h2v2h2V5h2v2h2v2h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H8v-2H6V9h2V7H6V5h2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9h2v2H8zm4 0h2v2h-2zm-2-2h2v2h-2zm4 0h2v2h-2z"
                }
            }
        ]
    })(props);
}
function BiSolidFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H6V2H4v18H3v2h4v-2H6v-5h13a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function BiSolidFlame(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.579 2.393a.982.982 0 0 0-1.153.006C9.592 3.728 4 8.252 4 14c0 3.247 1.948 6.043 4.734 7.296A3.971 3.971 0 0 1 8 19c-.017-3.221 3.558-6.893 3.71-7a.497.497 0 0 1 .579 0c.152.107 3.711 2.974 3.711 7.002 0 .854-.275 1.643-.733 2.294C18.052 20.043 20 17.248 20 14.005c0-5.861-5.582-10.307-7.421-11.612z"
                }
            }
        ]
    })(props);
}
function BiSolidFlask(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9.783V4h1V2H8v2h1v5.783l-4.268 9.389a1.992 1.992 0 0 0 .14 1.911A1.99 1.99 0 0 0 6.553 22h10.895a1.99 1.99 0 0 0 1.681-.917c.37-.574.423-1.289.14-1.911L15 9.783zm-4.09.631c.06-.13.09-.271.09-.414V4h2v6c0 .143.03.284.09.414L15.177 15H8.825l2.085-4.586z"
                }
            }
        ]
    })(props);
}
function BiSolidFlorist(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.84 21.871 12 22a10.221 10.221 0 0 0-9.013-8.891L2 13l.021.173a10.001 10.001 0 0 0 8.819 8.698zm11.139-8.698L22 13l-.987.109c-4.7.523-8.427 4.2-9.013 8.891l1.16-.129a10.001 10.001 0 0 0 8.819-8.698zM18.063 5.5a2.5 2.5 0 0 0-3.415-.915c-.062.035-.111.081-.168.121.005-.069.02-.136.02-.206a2.5 2.5 0 1 0-5 0c0 .07.015.137.021.206-.057-.04-.107-.086-.168-.121a2.5 2.5 0 0 0-2.5 4.33c.061.035.126.056.188.085-.062.029-.127.05-.188.085a2.5 2.5 0 0 0 2.5 4.33c.062-.035.111-.081.168-.121-.006.069-.021.136-.021.206a2.5 2.5 0 1 0 5 0c0-.07-.015-.137-.021-.206.057.04.106.086.168.121a2.5 2.5 0 0 0 2.5-4.33c-.061-.035-.126-.056-.188-.085.063-.029.127-.05.188-.085a2.5 2.5 0 0 0 .916-3.415zM12 12a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
                }
            }
        ]
    })(props);
}
function BiSolidFolderMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-9.586L8.707 3.293A.997.997 0 0 0 8 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zm-4 9H8v-2h8v2z"
                }
            }
        ]
    })(props);
}
function BiSolidFolderOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.165 19.551c.186.28.499.449.835.449h15c.4 0 .762-.238.919-.606l3-7A.998.998 0 0 0 21 11h-1V8c0-1.103-.897-2-2-2h-6.655L8.789 4H4c-1.103 0-2 .897-2 2v13h.007a1 1 0 0 0 .158.551zM18 8v3H6c-.4 0-.762.238-.919.606L4 14.129V8h14z"
                }
            }
        ]
    })(props);
}
function BiSolidFolderPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-9.586L8.707 3.293A.997.997 0 0 0 8 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zm-4 9h-3v3h-2v-3H8v-2h3V9h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function BiSolidFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-9.586L8.707 3.293A.997.997 0 0 0 8 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2z"
                }
            }
        ]
    })(props);
}
function BiSolidFoodMenu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2h2v20H3zm16 0H6v20h13c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm-1 10H9v-2h9v2zm0-4H9V6h9v2z"
                }
            }
        ]
    })(props);
}
function BiSolidFridge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6c-1.103 0-2 .897-2 2v5h4V6h2v3h10V4c0-1.103-.897-2-2-2zm-8 13H8v-5H4v10c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V10H10v5z"
                }
            }
        ]
    })(props);
}
function BiSolidGame(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c3.719 0 7.063-2.035 8.809-5.314L13 12l7.809-4.686C19.063 4.035 15.719 2 12 2 6.486 2 2 6.486 2 12s4.486 10 10 10zm-.5-16a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 11.5 6z"
                }
            }
        ]
    })(props);
}
function BiSolidGasPump(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19.616 6.48.014-.017-4-3.24-1.26 1.554 2.067 1.674a2.99 2.99 0 0 0-1.394 3.062c.15.899.769 1.676 1.57 2.111.895.487 1.68.442 2.378.194L18.976 18a.996.996 0 0 1-1.39.922.995.995 0 0 1-.318-.217.996.996 0 0 1-.291-.705L17 16a2.98 2.98 0 0 0-.877-2.119A3 3 0 0 0 14 13h-1V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2v-4h1c.136 0 .267.027.391.078a1.028 1.028 0 0 1 .531.533A.994.994 0 0 1 15 16l-.024 2c0 .406.079.799.236 1.168.151.359.368.68.641.951a2.97 2.97 0 0 0 2.123.881c.406 0 .798-.078 1.168-.236.358-.15.68-.367.951-.641A2.983 2.983 0 0 0 20.976 18L21 9a2.997 2.997 0 0 0-1.384-2.52zM11 8H4V5h7v3zm7 2a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                }
            }
        ]
    })(props);
}
function BiSolidGhost(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11v8h.051c.245 1.692 1.69 3 3.449 3 1.174 0 2.074-.417 2.672-1.174a3.99 3.99 0 0 0 5.668-.014c.601.762 1.504 1.188 2.66 1.188 1.93 0 3.5-1.57 3.5-3.5V11c0-4.962-4.037-9-9-9s-9 4.038-9 9zm6 1c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm6-4c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2z"
                }
            }
        ]
    })(props);
}
function BiSolidGift(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12H4v8a2 2 0 0 0 2 2h5V12H5zm13 0h-5v10h5a2 2 0 0 0 2-2v-8h-2zm.791-5A4.92 4.92 0 0 0 19 5.5C19 3.57 17.43 2 15.5 2c-1.622 0-2.705 1.482-3.404 3.085C11.407 3.57 10.269 2 8.5 2 6.57 2 5 3.57 5 5.5c0 .596.079 1.089.209 1.5H2v4h9V9h2v2h9V7h-3.209zM7 5.5C7 4.673 7.673 4 8.5 4c.888 0 1.714 1.525 2.198 3H8c-.374 0-1 0-1-1.5zM15.5 4c.827 0 1.5.673 1.5 1.5C17 7 16.374 7 16 7h-2.477c.51-1.576 1.251-3 1.977-3z"
                }
            }
        ]
    })(props);
}
function BiSolidGraduation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 7v1l11 4 9-4V7L11 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11v4.267c0 1.621 4.001 3.893 9 3.734 4-.126 6.586-1.972 7-3.467.024-.089.037-.178.037-.268V11L13 14l-5-1.667v3.213l-1-.364V12l-3-1z"
                }
            }
        ]
    })(props);
}
function BiSolidGridAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm10 0h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zM4 21h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm10 0h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1z"
                }
            }
        ]
    })(props);
}
function BiSolidGrid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4h4v4H4zm6 0h4v4h-4zm6 0h4v4h-4zM4 10h4v4H4zm6 0h4v4h-4zm6 0h4v4h-4zM4 16h4v4H4zm6 0h4v4h-4zm6 0h4v4h-4z"
                }
            }
        ]
    })(props);
}
function BiSolidGroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 12c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm1.5 1H8c-3.309 0-6 2.691-6 6v1h15v-1c0-3.309-2.691-6-6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.604 11.048a5.67 5.67 0 0 0 .751-3.44c-.179-1.784-1.175-3.361-2.803-4.44l-1.105 1.666c1.119.742 1.8 1.799 1.918 2.974a3.693 3.693 0 0 1-1.072 2.986l-1.192 1.192 1.618.475C18.951 13.701 19 17.957 19 18h2c0-1.789-.956-5.285-4.396-6.952z"
                }
            }
        ]
    })(props);
}
function BiSolidGuitarAmp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-2V4c0-1.103-.897-2-2-2H8c-1.103 0-2 .897-2 2v2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zM8 4h8v2H8V4zM6 19a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm3 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm3 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm3 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm3 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm2-4H4V8h16v4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9h2v2h-2zm3 0h2v2h-2z"
                }
            }
        ]
    })(props);
}
function BiSolidHandDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.278 2.231a1.001 1.001 0 0 0-.64-.231H5a2 2 0 0 0-2 2v7.21a2 2 0 0 0 1.779 1.987L12 14v6a2 2 0 0 0 4 0V8l3.03 1.212a2.001 2.001 0 0 0 2.641-1.225l.113-.34a.998.998 0 0 0-.309-1.084l-5.197-4.332z"
                }
            }
        ]
    })(props);
}
function BiSolidHandLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3h-7.21a2 2 0 0 0-1.987 1.779L10 12H4a2 2 0 0 0 0 4h12l-1.212 3.03a2.001 2.001 0 0 0 1.225 2.641l.34.113a.998.998 0 0 0 1.084-.309l4.332-5.197c.149-.179.231-.406.231-.64V5a2 2 0 0 0-2-2z"
                }
            }
        ]
    })(props);
}
function BiSolidHandRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8H8l1.212-3.03a2 2 0 0 0-1.225-2.641l-.34-.113a.998.998 0 0 0-1.084.309L2.231 7.722a1.001 1.001 0 0 0-.231.64V19a2 2 0 0 0 2 2h7.21a2 2 0 0 0 1.987-1.779L14 12h6a2 2 0 0 0 0-4z"
                }
            }
        ]
    })(props);
}
function BiSolidHandUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.221 10.803 12 10V4a2 2 0 0 0-4 0v12l-3.031-1.212a2 2 0 0 0-2.64 1.225l-.113.34a.998.998 0 0 0 .309 1.084l5.197 4.332c.179.149.406.231.64.231H19a2 2 0 0 0 2-2v-7.21a2 2 0 0 0-1.779-1.987z"
                }
            }
        ]
    })(props);
}
function BiSolidHand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 5A1.5 1.5 0 0 0 19 6.5V11h-1V4.5a1.5 1.5 0 0 0-3 0V11h-1V3.5a1.5 1.5 0 0 0-3 0V11h-1V5.5a1.5 1.5 0 0 0-3 0v10.81l-2.22-3.6a1.5 1.5 0 0 0-2.56 1.58l3.31 5.34A5 5 0 0 0 9.78 22H17a5 5 0 0 0 5-5V6.5A1.5 1.5 0 0 0 20.5 5z"
                }
            }
        ]
    })(props);
}
function BiSolidHappyAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm3.493 6a1.494 1.494 0 1 1-.001 2.987A1.494 1.494 0 0 1 15.493 8zM8.5 8a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 8.5 8zM12 18c-5 0-6-5-6-5h12s-1 5-6 5z"
                }
            }
        ]
    })(props);
}
function BiSolidHappyBeaming(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM8 9c2.201 0 3 1.794 3 3H9c-.012-.45-.194-1-1-1s-.988.55-1 1.012L5 12c0-1.206.799-3 3-3zm4 9c-4 0-5-4-5-4h10s-1 4-5 4zm5-6c-.012-.45-.194-1-1-1s-.988.55-1 1.012L13 12c0-1.206.799-3 3-3s3 1.794 3 3h-2z"
                }
            }
        ]
    })(props);
}
function BiSolidHappyHeartEyes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM6.435 8.467A1.49 1.49 0 0 1 8.502 8.4a1.49 1.49 0 0 1 2.065.033c.597.592.604 1.521.018 2.118l-2.05 2.083-2.082-2.05a1.484 1.484 0 0 1-.018-2.117zM12 18c-4 0-5-4-5-4h10s-1 4-5 4zm5.585-7.449-2.05 2.083-2.082-2.05a1.485 1.485 0 0 1-.019-2.117 1.49 1.49 0 0 1 2.068-.067 1.49 1.49 0 0 1 2.065.033c.597.591.605 1.521.018 2.118z"
                }
            }
        ]
    })(props);
}
function BiSolidHappy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm3.493 7a1.494 1.494 0 1 1-.001 2.987A1.494 1.494 0 0 1 15.493 9zM8.5 9a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 8.5 9zm3.5 9c-4 0-5-4-5-4h10s-1 4-5 4z"
                }
            }
        ]
    })(props);
}
function BiSolidHardHat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18v-3a8 8 0 0 0-5-7.4V13h-1V5h-4v8H9V7.6A8 8 0 0 0 4 15v3H2v2h20v-2z"
                }
            }
        ]
    })(props);
}
function BiSolidHdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm-4 5h-2v-2h2v2zm4 0h-2v-2h2v2zm.775-7H21l-1.652-7.434A2 2 0 0 0 17.396 2H6.604a2 2 0 0 0-1.952 1.566L3 11h17.775z"
                }
            }
        ]
    })(props);
}
function BiSolidHeartCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm4.186 10.74L12 16.926 7.814 12.74a2.745 2.745 0 0 1 0-3.907 2.745 2.745 0 0 1 3.906 0l.28.279.279-.279a2.745 2.745 0 0 1 3.906 0 2.745 2.745 0 0 1 .001 3.907z"
                }
            }
        ]
    })(props);
}
function BiSolidHeartSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 21h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1zM7.812 8.907a2.746 2.746 0 0 1 3.907 0l.279.279.278-.279a2.746 2.746 0 0 1 3.907 0 2.745 2.745 0 0 1 0 3.907L11.998 17l-4.187-4.186a2.747 2.747 0 0 1 .001-3.907z"
                }
            }
        ]
    })(props);
}
function BiSolidHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.205 4.791a5.938 5.938 0 0 0-4.209-1.754A5.906 5.906 0 0 0 12 4.595a5.904 5.904 0 0 0-3.996-1.558 5.942 5.942 0 0 0-4.213 1.758c-2.353 2.363-2.352 6.059.002 8.412L12 21.414l8.207-8.207c2.354-2.353 2.355-6.049-.002-8.416z"
                }
            }
        ]
    })(props);
}
function BiSolidHelpCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm1 16h-2v-2h2v2zm.976-4.885c-.196.158-.385.309-.535.459-.408.407-.44.777-.441.793v.133h-2v-.167c0-.118.029-1.177 1.026-2.174.195-.195.437-.393.691-.599.734-.595 1.216-1.029 1.216-1.627a1.934 1.934 0 0 0-3.867.001h-2C8.066 7.765 9.831 6 12 6s3.934 1.765 3.934 3.934c0 1.597-1.179 2.55-1.958 3.181z"
                }
            }
        ]
    })(props);
}
function BiSolidHide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.073 12.194 4.212 8.333c-1.52 1.657-2.096 3.317-2.106 3.351L2 12l.105.316C2.127 12.383 4.421 19 12.054 19c.929 0 1.775-.102 2.552-.273l-2.746-2.746a3.987 3.987 0 0 1-3.787-3.787zM12.054 5c-1.855 0-3.375.404-4.642.998L3.707 2.293 2.293 3.707l18 18 1.414-1.414-3.298-3.298c2.638-1.953 3.579-4.637 3.593-4.679l.105-.316-.105-.316C21.98 11.617 19.687 5 12.054 5zm1.906 7.546c.187-.677.028-1.439-.492-1.96s-1.283-.679-1.96-.492L10 8.586A3.955 3.955 0 0 1 12.054 8c2.206 0 4 1.794 4 4a3.94 3.94 0 0 1-.587 2.053l-1.507-1.507z"
                }
            }
        ]
    })(props);
}
function BiSolidHomeAlt2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.74 2.32a1 1 0 0 0-1.48 0l-9 10A1 1 0 0 0 3 14h2v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7h2a1 1 0 0 0 1-1 1 1 0 0 0-.26-.68z"
                }
            }
        ]
    })(props);
}
function BiSolidHomeCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10A1 1 0 0 0 3 14h2v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669zM12 16a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
                }
            }
        ]
    })(props);
}
function BiSolidHomeHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14h2v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .913-.593.998.998 0 0 0-.17-1.076l-9-10c-.379-.422-1.107-.422-1.486 0l-9 10A1 1 0 0 0 3 14zm5.653-2.359a2.224 2.224 0 0 1 3.125 0l.224.22.223-.22a2.225 2.225 0 0 1 3.126 0 2.13 2.13 0 0 1 0 3.07L12.002 18l-3.349-3.289a2.13 2.13 0 0 1 0-3.07z"
                }
            }
        ]
    })(props);
}
function BiSolidHomeSmile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14h2v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .913-.593.998.998 0 0 0-.17-1.076l-9-10c-.379-.422-1.107-.422-1.486 0l-9 10A1 1 0 0 0 3 14zm5.949-.316C8.98 13.779 9.762 16 12 16c2.269 0 3.042-2.287 3.05-2.311l1.9.621C16.901 14.461 15.703 18 12 18s-4.901-3.539-4.95-3.689l1.899-.627z"
                }
            }
        ]
    })(props);
}
function BiSolidHome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"
                }
            }
        ]
    })(props);
}
function BiSolidHot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 8c0 1.5-.5 3.5-2.9 4.3.7-1.7.8-3.4.3-5-.7-2.1-3-3.7-4.6-4.6-.4-.3-1.1.1-1 .7 0 1.1-.3 2.7-2 4.4C4.1 10 3 12.3 3 14.5 3 17.4 5 21 9 21c-4-4-1-7.5-1-7.5.8 5.9 5 7.5 7 7.5 1.7 0 5-1.2 5-6.4 0-3.1-1.3-5.5-2.4-6.9-.3-.5-1-.2-1.1.3"
                }
            }
        ]
    })(props);
}
function BiSolidHotel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "11",
                    "r": "3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.205 7H12v8H4V6H2v14h2v-3h16v3h2v-4c0-.009-.005-.016-.005-.024H22V11c0-2.096-1.698-4-3.795-4z"
                }
            }
        ]
    })(props);
}
function BiSolidHourglassBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2H4v2h1v1a7.014 7.014 0 0 0 3.433 6.02c.355.21.567.547.567.901v.158c0 .354-.212.691-.566.9A7.016 7.016 0 0 0 5 19v1H4v2h16v-2h-1v-1a7.016 7.016 0 0 0-3.434-6.021c-.354-.208-.566-.545-.566-.9v-.158c0-.354.212-.69.566-.9A7.016 7.016 0 0 0 19 5V4h1V2H5zm12 3a5.01 5.01 0 0 1-2.45 4.299A3.107 3.107 0 0 0 13.166 11h-2.332a3.114 3.114 0 0 0-1.385-1.702A5.008 5.008 0 0 1 7 5V4h10v1z"
                }
            }
        ]
    })(props);
}
function BiSolidHourglassTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.566 11.021A7.016 7.016 0 0 0 19 5V4h1V2H4v2h1v1a7.016 7.016 0 0 0 3.434 6.021c.354.208.566.545.566.9v.158c0 .354-.212.69-.566.9A7.016 7.016 0 0 0 5 19v1H4v2h16v-2h-1v-1a7.014 7.014 0 0 0-3.433-6.02c-.355-.21-.567-.547-.567-.901v-.158c0-.355.212-.692.566-.9zM17 19v1H7v-1a5.01 5.01 0 0 1 2.45-4.299A3.111 3.111 0 0 0 10.834 13h2.332c.23.691.704 1.3 1.385 1.702A5.008 5.008 0 0 1 17 19z"
                }
            }
        ]
    })(props);
}
function BiSolidHourglass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 22h1v-2h-1v-1a7.014 7.014 0 0 0-3.433-6.02c-.355-.21-.567-.547-.567-.901v-.158c0-.354.212-.691.566-.9A7.016 7.016 0 0 0 19 5V4h1V2H4v2h1v1a7.016 7.016 0 0 0 3.434 6.021c.354.209.566.545.566.9v.158c0 .354-.212.691-.566.9A7.016 7.016 0 0 0 5 19v1H4v2h15zM17 4v1a5.005 5.005 0 0 1-1.004 3H8.004A5.005 5.005 0 0 1 7 5V4h10zM9.45 14.702c.971-.574 1.55-1.554 1.55-2.623V12h2v.079c0 1.068.579 2.049 1.551 2.623A4.98 4.98 0 0 1 16.573 17H7.427a4.977 4.977 0 0 1 2.023-2.298z"
                }
            }
        ]
    })(props);
}
function BiSolidIdCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM8.715 8c1.151 0 2 .849 2 2s-.849 2-2 2-2-.849-2-2 .848-2 2-2zm3.715 8H5v-.465c0-1.373 1.676-2.785 3.715-2.785s3.715 1.412 3.715 2.785V16zM19 15h-4v-2h4v2zm0-4h-5V9h5v2z"
                }
            }
        ]
    })(props);
}
function BiSolidImageAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m9 13 3-4 3 4.5V12h4V5c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h8v-4H5l3-4 1 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 14h-2v3h-3v2h3v3h2v-3h3v-2h-3z"
                }
            }
        ]
    })(props);
}
function BiSolidImageAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2zm3-7 2.363 2.363L14 11l5 7H5l3-4z"
                }
            }
        ]
    })(props);
}
function BiSolidImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.999 4h-16c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-13.5 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm5.5 10h-7l4-5 1.5 2 3-4 5.5 7h-7z"
                }
            }
        ]
    })(props);
}
function BiSolidInbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V5c0-1.103-.897-2-2-2zm-1 9h-3.142c-.446 1.722-1.997 3-3.858 3s-3.412-1.278-3.858-3H4V5h16v7h-1z"
                }
            }
        ]
    })(props);
}
function BiSolidInfoCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
                }
            }
        ]
    })(props);
}
function BiSolidInfoSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1zm8 3h2v2h-2V7zm0 4h2v6h-2v-6z"
                }
            }
        ]
    })(props);
}
function BiSolidInjection(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.61 9.24 8.35l3.31 3.31-1.06 1.06-3.31-3.31-1.77 1.77 3.31 3.31-1.06 1.06-3.31-3.31-2 2A2 2 0 0 0 3 16.66l1 1.89-2.25 2.29 1.41 1.41L5.45 20l1.89 1a2 2 0 0 0 1 .26 2 2 0 0 0 1.42-.59L18.39 12zm7.8 3.59-1.79-1.8 1.42-1.41 1.41 1.41 1.41-1.41-4.24-4.24-1.41 1.41 1.41 1.42-1.41 1.41-1.8-1.79-1.74-1.75-1.41 1.42 1.03 1.03v.01l6.41 6.41h.01l1.03 1.03 1.42-1.41-1.74-1.74h-.01z"
                }
            }
        ]
    })(props);
}
function BiSolidInstitution(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.857 8.485-3-5A.997.997 0 0 0 18 3h-4.586l-.707-.707a.999.999 0 0 0-1.414 0L10.586 3H6a.997.997 0 0 0-.857.485l-3 5A1.001 1.001 0 0 0 2.002 9H2v10a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V9h-.002c0-.178-.046-.356-.141-.515zM20 18h-6v-4h-4v4H4v-8h2.414l.293-.293 2-2L12 4.414l4.293 4.293 1 1 .293.293H20v8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.895",
                    "cy": "9.895",
                    "r": "2.105"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12h2v3H6zm10 0h2v3h-2z"
                }
            }
        ]
    })(props);
}
function BiSolidInvader(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3h2v2H6zm2 16h3v2H8zm8-16h2v2h-2zm-3 16h3v2h-3zm7-8V9h-2V7h-2V5h-2v2h-4V5H8v2H6v2H4v2H2v8h2v-4h2v4h2v-3h8v3h2v-4h2v4h2v-8zm-10 1H8V9h2zm6 0h-2V9h2z"
                }
            }
        ]
    })(props);
}
function BiSolidJoystickAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6H8a6 6 0 0 0 0 12h8a6 6 0 0 0 0-12zm-5 7H9v2H7v-2H5v-2h2V9h2v2h2v2zm3.5 2a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm3-3a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                }
            }
        ]
    })(props);
}
function BiSolidJoystickButton(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8h-4V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v4H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zM7 14l-3-2 3-2v4zm5 6-2-3h4l-2 3zm0-6a2 2 0 1 1 .001-4.001A2 2 0 0 1 12 14zm-2-7 2-3 2 3h-4zm7 7v-4l3 2-3 2z"
                }
            }
        ]
    })(props);
}
function BiSolidJoystick(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.986 9.74a3.193 3.193 0 0 0-.008-.088A5.003 5.003 0 0 0 17 5H7a4.97 4.97 0 0 0-4.987 4.737c-.01.079-.013.161-.013.253v6.51c0 .925.373 1.828 1.022 2.476A3.524 3.524 0 0 0 5.5 20c1.8 0 2.504-1 3.5-3 .146-.292.992-2 3-2 1.996 0 2.853 1.707 3 2 1.004 2 1.7 3 3.5 3 .925 0 1.828-.373 2.476-1.022A3.524 3.524 0 0 0 22 16.5V10c0-.095-.004-.18-.014-.26zM7 12.031a2 2 0 1 1-.001-3.999A2 2 0 0 1 7 12.031zm10-5a1 1 0 1 1 0 2 1 1 0 1 1 0-2zm-2 4a1 1 0 1 1 0-2 1 1 0 1 1 0 2zm2 2a1 1 0 1 1 0-2 1 1 0 1 1 0 2zm2-2a1 1 0 1 1 0-2 1 1 0 1 1 0 2z"
                }
            }
        ]
    })(props);
}
function BiSolidKey(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.433 17.325 3.079 19.8a1 1 0 0 0 1.131 1.131l2.475-.354C7.06 20.524 8 18 8 18s.472.405.665.466c.412.13.813-.274.948-.684L10 16.01s.577.292.786.335c.266.055.524-.109.707-.293a.988.988 0 0 0 .241-.391L12 14.01s.675.187.906.214c.263.03.519-.104.707-.293l1.138-1.137a5.502 5.502 0 0 0 5.581-1.338 5.507 5.507 0 0 0 0-7.778 5.507 5.507 0 0 0-7.778 0 5.5 5.5 0 0 0-1.338 5.581l-7.501 7.5a.994.994 0 0 0-.282.566zM18.504 5.506a2.919 2.919 0 0 1 0 4.122l-4.122-4.122a2.919 2.919 0 0 1 4.122 0z"
                }
            }
        ]
    })(props);
}
function BiSolidKeyboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm-8 2h2v2h-2V7zm0 4h2v2h-2v-2zM9 7h2v2H9V7zm0 4h2v2H9v-2zM5 7h2v2H5V7zm0 4h2v2H5v-2zm12 6H7v-2h10v2zm2-4h-2v-2h2v2zm0-4h-2V7h2v2z"
                }
            }
        ]
    })(props);
}
function BiSolidLabel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.813 4.419A.997.997 0 0 0 16 4H3a1 1 0 0 0-.813 1.581L6.771 12l-4.585 6.419A1 1 0 0 0 3 20h13a.997.997 0 0 0 .813-.419l5-7a.997.997 0 0 0 0-1.162l-5-7z"
                }
            }
        ]
    })(props);
}
function BiSolidLandmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 17h-2V9h2V7a.998.998 0 0 0-.594-.914l-9.432-4.191-8.421 4.21A1 1 0 0 0 2 7v2h2v8H2v4h19v-4zm-5-8v8h-3V9h3zM7 9h3v8H7V9z"
                }
            }
        ]
    })(props);
}
function BiSolidLandscape(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "6.5",
                    "r": "2.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m14 7-5.223 8.487L7 13l-5 7h20z"
                }
            }
        ]
    })(props);
}
function BiSolidLaugh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-6.447 9.105 2.459-1.229-1.567-1.044 1.109-1.664 3 2a1 1 0 0 1-.108 1.727l-4 2-.893-1.79zM12 18c-4 0-5-4-5-4h10s-1 4-5 4zm5.553-5.105-4-2a1 1 0 0 1-.108-1.727l3-2 1.109 1.664-1.566 1.044 2.459 1.229-.894 1.79z"
                }
            }
        ]
    })(props);
}
function BiSolidLayerMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.484 11.125-9.022-5a1 1 0 0 0-.968-.001l-8.978 4.96a1 1 0 0 0-.003 1.749l9.022 5.04a.995.995 0 0 0 .973.001l8.978-5a1 1 0 0 0-.002-1.749z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.515 15.126 12 19.856l-8.515-4.73-.971 1.748 9 5a1 1 0 0 0 .971 0l9-5-.97-1.748zM16 4h6v2h-6z"
                }
            }
        ]
    })(props);
}
function BiSolidLayerPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.513 12.833 9.022 5.04a.995.995 0 0 0 .973.001l8.978-5a1 1 0 0 0-.002-1.749l-9.022-5a1 1 0 0 0-.968-.001l-8.978 4.96a1 1 0 0 0-.003 1.749z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m3.485 15.126-.971 1.748 9 5a1 1 0 0 0 .971 0l9-5-.971-1.748L12 19.856l-8.515-4.73zM20 8V6h2V4h-2V2h-2v2h-2v2h2v2z"
                }
            }
        ]
    })(props);
}
function BiSolidLayer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.484 7.125-9.022-5a1.003 1.003 0 0 0-.968 0l-8.978 4.96a1 1 0 0 0-.003 1.748l9.022 5.04a.995.995 0 0 0 .973.001l8.978-5a1 1 0 0 0-.002-1.749z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 15.856-8.515-4.73-.971 1.748 9 5a1 1 0 0 0 .971 0l9-5-.971-1.748L12 15.856z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m12 19.856-8.515-4.73-.971 1.748 9 5a1 1 0 0 0 .971 0l9-5-.971-1.748L12 19.856z"
                }
            }
        ]
    })(props);
}
function BiSolidLayout(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.103 0-2 .897-2 2v4h18V5c0-1.103-.897-2-2-2zM3 19c0 1.103.897 2 2 2h8V11H3v8zm12 2h4c1.103 0 2-.897 2-2v-8h-6v10z"
                }
            }
        ]
    })(props);
}
function BiSolidLeaf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m22 3.41-.12-1.26-1.2.4a13.84 13.84 0 0 1-6.41.64 11.87 11.87 0 0 0-6.68.9A7.23 7.23 0 0 0 3.3 9.5a9 9 0 0 0 .39 4.58 16.6 16.6 0 0 1 1.18-2.2 9.85 9.85 0 0 1 4.07-3.43 11.16 11.16 0 0 1 5.06-1A12.08 12.08 0 0 0 9.34 9.2a9.48 9.48 0 0 0-1.86 1.53 11.38 11.38 0 0 0-1.39 1.91 16.39 16.39 0 0 0-1.57 4.54A26.42 26.42 0 0 0 4 22h2a30.69 30.69 0 0 1 .59-4.32 9.25 9.25 0 0 0 4.52 1.11 11 11 0 0 0 4.28-.87C23 14.67 22 3.86 22 3.41z"
                }
            }
        ]
    })(props);
}
function BiSolidLeftArrowAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m5 12 7 6v-5h6v-2h-6V6z"
                }
            }
        ]
    })(props);
}
function BiSolidLeftArrowCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm5 11h-5v4l-5-5 5-5v4h5v2z"
                }
            }
        ]
    })(props);
}
function BiSolidLeftArrowSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14zM12 7v4h5v2h-5v4l-5-5 5-5z"
                }
            }
        ]
    })(props);
}
function BiSolidLeftArrow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m4.431 12.822 13 9A1 1 0 0 0 19 21V3a1 1 0 0 0-1.569-.823l-13 9a1.003 1.003 0 0 0 0 1.645z"
                }
            }
        ]
    })(props);
}
function BiSolidLeftDownArrowCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.071 19.071c3.898-3.899 3.898-10.244 0-14.143-3.899-3.899-10.244-3.898-14.143 0-3.898 3.899-3.899 10.243 0 14.143 3.9 3.899 10.244 3.899 14.143 0zM8.464 8.464l2.829 2.829 3.535-3.536 1.414 1.414-3.535 3.536 2.828 2.829H8.464V8.464z"
                }
            }
        ]
    })(props);
}
function BiSolidLeftTopArrowCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.071 19.071c3.898-3.899 3.898-10.244 0-14.143-3.899-3.898-10.243-3.898-14.143 0-3.898 3.899-3.898 10.244 0 14.143 3.9 3.899 10.244 3.899 14.143 0zM8.465 8.464h7.07l-2.828 2.829 3.535 3.536-1.414 1.414-3.535-3.536-2.828 2.829V8.464z"
                }
            }
        ]
    })(props);
}
function BiSolidLemon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.45 8.74A2.23 2.23 0 0 1 21.64 7a3.51 3.51 0 0 0 .24-2.47 3.55 3.55 0 0 0-2.45-2.45 3.51 3.51 0 0 0-2.43.28 2.23 2.23 0 0 1-1.7.19 10.07 10.07 0 0 0-6.53 0 9.87 9.87 0 0 0-6.23 6.18 10.07 10.07 0 0 0 0 6.53A2.23 2.23 0 0 1 2.36 17a3.51 3.51 0 0 0-.24 2.47 3.55 3.55 0 0 0 2.45 2.45A3.51 3.51 0 0 0 7 21.64a2.23 2.23 0 0 1 1.7-.19A9.83 9.83 0 0 0 12 22a10.33 10.33 0 0 0 3.27-.54 9.87 9.87 0 0 0 6.19-6.19 10.07 10.07 0 0 0-.01-6.53zM12 7a5 5 0 0 0-5 5H5a7 7 0 0 1 7-7z"
                }
            }
        ]
    })(props);
}
function BiSolidLike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 21h1V8H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2zM20 8h-7l1.122-3.368A2 2 0 0 0 12.225 2H12L7 7.438V21h11l3.912-8.596L22 12v-2a2 2 0 0 0-2-2z"
                }
            }
        ]
    })(props);
}
function BiSolidLocationPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22s8.029-5.56 8-12c0-4.411-3.589-8-8-8S4 5.589 4 9.995C3.971 16.44 11.696 21.784 12 22zM8 9h3V6h2v3h3v2h-3v3h-2v-3H8V9z"
                }
            }
        ]
    })(props);
}
function BiSolidLockAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12c0-1.103-.897-2-2-2h-1V7c0-2.757-2.243-5-5-5S7 4.243 7 7v3H6c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-8zM9 7c0-1.654 1.346-3 3-3s3 1.346 3 3v3H9V7z"
                }
            }
        ]
    })(props);
}
function BiSolidLockOpenAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 8V7c0-2.757-2.243-5-5-5S7 4.243 7 7v3H6c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-8c0-1.103-.897-2-2-2H9V7c0-1.654 1.346-3 3-3s3 1.346 3 3v1h2z"
                }
            }
        ]
    })(props);
}
function BiSolidLockOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 10H9V7c0-1.654 1.346-3 3-3s3 1.346 3 3h2c0-2.757-2.243-5-5-5S7 4.243 7 7v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zm-7.939 5.499A2.002 2.002 0 0 1 14 16a1.99 1.99 0 0 1-1 1.723V20h-2v-2.277a1.992 1.992 0 0 1-.939-2.224z"
                }
            }
        ]
    })(props);
}
function BiSolidLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C9.243 2 7 4.243 7 7v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1V7c0-2.757-2.243-5-5-5zM9 7c0-1.654 1.346-3 3-3s3 1.346 3 3v3H9V7zm4 10.723V20h-2v-2.277a1.993 1.993 0 0 1 .567-3.677A2.001 2.001 0 0 1 14 16a1.99 1.99 0 0 1-1 1.723z"
                }
            }
        ]
    })(props);
}
function BiSolidLogInCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3c-4.625 0-8.442 3.507-8.941 8.001H10v-3l5 4-5 4v-3H3.06C3.56 17.494 7.376 21 12 21c4.963 0 9-4.037 9-9s-4.037-9-9-9z"
                }
            }
        ]
    })(props);
}
function BiSolidLogIn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 2h-13a.5.5 0 0 0-.5.5V11h6V8l5 4-5 4v-3H5v8.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-19a.5.5 0 0 0-.5-.5z"
                }
            }
        ]
    })(props);
}
function BiSolidLogOutCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3c-4.963 0-9 4.037-9 9v.001l5-4v3h7v2H8v3l-5-4C3.001 16.964 7.037 21 12 21s9-4.037 9-9-4.037-9-9-9z"
                }
            }
        ]
    })(props);
}
function BiSolidLogOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6a1 1 0 0 0-1 1v9l5-4v3h6v2h-6v3l-5-4v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function BiSolidLowVision(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4.998c-1.836 0-3.356.389-4.617.971L3.707 2.293 2.293 3.707l3.315 3.315c-2.613 1.952-3.543 4.618-3.557 4.66l-.105.316.105.316C2.073 12.382 4.367 19 12 19c1.835 0 3.354-.389 4.615-.971l3.678 3.678 1.414-1.414-3.317-3.317c2.614-1.952 3.545-4.618 3.559-4.66l.105-.316-.105-.316c-.022-.068-2.316-6.686-9.949-6.686zM12.043 7H12a5 5 0 0 1 5 5 4.894 4.894 0 0 1-.852 2.734l-.721-.721A3.919 3.919 0 0 0 16 11.999c0-.474-.099-.925-.255-1.349A.985.985 0 0 1 15 11a1 1 0 0 1-1-1c0-.439.288-.802.682-.936A3.965 3.965 0 0 0 12 7.999c-.735 0-1.419.218-2.015.572l-.72-.72C10.053 7.326 10.982 7 12 7h-.043L12 6.998l.043.002zm-7.969 4.999c.103-.235.274-.586.521-.989l5.867 5.867c-4.213-.647-5.939-3.842-6.388-4.878zm9.247 4.908-7.48-7.48a8.146 8.146 0 0 1 1.188-.984l8.055 8.055a8.835 8.835 0 0 1-1.763.409z"
                }
            }
        ]
    })(props);
}
function BiSolidMagicWand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11 4-.5-1-.5 1-1 .125.834.708L9.5 6l1-.666 1 .666-.334-1.167.834-.708zm8.334 10.666L18.5 13l-.834 1.666-1.666.209 1.389 1.181L16.834 18l1.666-1.111L20.166 18l-.555-1.944L21 14.875zM6.667 6.333 6 5l-.667 1.333L4 6.5l1.111.944L4.667 9 6 8.111 7.333 9l-.444-1.556L8 6.5zM3.414 17c0 .534.208 1.036.586 1.414L5.586 20c.378.378.88.586 1.414.586s1.036-.208 1.414-.586L20 8.414c.378-.378.586-.88.586-1.414S20.378 5.964 20 5.586L18.414 4c-.756-.756-2.072-.756-2.828 0L4 15.586c-.378.378-.586.88-.586 1.414zM17 5.414 18.586 7 15 10.586 13.414 9 17 5.414z"
                }
            }
        ]
    })(props);
}
function BiSolidMagnet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3H5a1 1 0 0 0-1 1v3h5V4a1 1 0 0 0-1-1zm7 1v3h5V4a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1zm0 10a3 3 0 0 1-6 0V9H4v5a8 8 0 0 0 16 0V9h-5v5z"
                }
            }
        ]
    })(props);
}
function BiSolidMapAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m9 6.882-7-3.5v13.236l7 3.5 6-3 7 3.5V7.382l-7-3.5-6 3zM15 15l-6 3V9l6-3v9z"
                }
            }
        ]
    })(props);
}
function BiSolidMapPin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 17 1-2V9.858c1.721-.447 3-2 3-3.858 0-2.206-1.794-4-4-4S8 3.794 8 6c0 1.858 1.279 3.411 3 3.858V15l1 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m16.267 10.563-.533 1.928C18.325 13.207 20 14.584 20 16c0 1.892-3.285 4-8 4s-8-2.108-8-4c0-1.416 1.675-2.793 4.267-3.51l-.533-1.928C4.197 11.54 2 13.623 2 16c0 3.364 4.393 6 10 6s10-2.636 10-6c0-2.377-2.197-4.46-5.733-5.437z"
                }
            }
        ]
    })(props);
}
function BiSolidMap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C7.589 2 4 5.589 4 9.995 3.971 16.44 11.696 21.784 12 22c0 0 8.029-5.56 8-12 0-4.411-3.589-8-8-8zm0 12c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
                }
            }
        ]
    })(props);
}
function BiSolidMask(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6H5C3.346 6 2 7.346 2 9v5c0 2.206 1.794 4 4 4h1.637c1.166 0 2.28-.557 2.981-1.491.66-.879 2.104-.88 2.764.001A3.744 3.744 0 0 0 16.363 18H18c2.206 0 4-1.794 4-4V9c0-1.654-1.346-3-3-3zM7.5 13C6.119 13 5 12.328 5 11.5S6.119 10 7.5 10s2.5.672 2.5 1.5S8.881 13 7.5 13zm9 0c-1.381 0-2.5-.672-2.5-1.5s1.119-1.5 2.5-1.5 2.5.672 2.5 1.5-1.119 1.5-2.5 1.5z"
                }
            }
        ]
    })(props);
}
function BiSolidMedal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2h-4v4.059a8.946 8.946 0 0 1 4 1.459V2zm-6 0H7v5.518a8.946 8.946 0 0 1 4-1.459V2zm1 20a7 7 0 1 0 0-14 7 7 0 0 0 0 14zm-1.225-8.519L12 11l1.225 2.481 2.738.397-1.981 1.932.468 2.727L12 17.25l-2.449 1.287.468-2.727-1.981-1.932 2.737-.397z"
                }
            }
        ]
    })(props);
}
function BiSolidMegaphone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.664 3.478 8 8v7l.748.267-1.127 2.254a1.999 1.999 0 0 0 1.156 2.792l4.084 1.361a2.015 2.015 0 0 0 2.421-1.003l1.303-2.606 4.079 1.457A1 1 0 0 0 22 18.581V4.419a1 1 0 0 0-1.336-.941zm-7.171 16.299L9.41 18.416l1.235-2.471 4.042 1.444-1.194 2.388zM4 15h2V8H4c-1.103 0-2 .897-2 2v3c0 1.103.897 2 2 2z"
                }
            }
        ]
    })(props);
}
function BiSolidMehAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-6 8h4v2H6v-2zm10 7H7.974v-2H16v2zm2-5h-4v-2h4v2z"
                }
            }
        ]
    })(props);
}
function BiSolidMehBlank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM8.5 12a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8.5 12zm6.993-.014a1.494 1.494 0 1 1 .001-2.987 1.494 1.494 0 0 1-.001 2.987z"
                }
            }
        ]
    })(props);
}
function BiSolidMeh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-5 8.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 7 10.5zm9 6.5H7.974v-2H16v2zm-.507-5.014a1.494 1.494 0 1 1 .001-2.987 1.494 1.494 0 0 1-.001 2.987z"
                }
            }
        ]
    })(props);
}
function BiSolidMemoryCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V7l-5-5zm-6 8H7V6h2v4zm3 0h-2V6h2v4zm3 0h-2V6h2v4z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .894-2 1.992v12.016C2 17.106 2.897 18 4 18h3v4l6.351-4H20c1.103 0 2-.894 2-1.992V3.992A1.998 1.998 0 0 0 20 2zm-3 9h-4v4h-2v-4H7V9h4V5h2v4h4v2z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageAltAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m8.5 18 3.5 4 3.5-4H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.5zM7 9h4V5h2v4h4v2h-4v4h-2v-4H7V9z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageAltCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4v12c0 1.103.897 2 2 2h3.5l3.5 4 3.5-4H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2zm5.707 4.293L11 10.586l4.793-4.793 1.414 1.414L11 13.414 7.293 9.707l1.414-1.414z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageAltDetail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m8.5 18 3.5 4 3.5-4H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.5zM7 7h10v2H7V7zm0 4h7v2H7v-2z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageAltDots(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.5l3.5 4 3.5-4H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM9 12a2 2 0 1 1 .001-4.001A2 2 0 0 1 9 12zm6 0a2 2 0 1 1 .001-4.001A2 2 0 0 1 15 12z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageAltEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.5l3.5 4 3.5-4H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5zm4.302 11.987h-1.8v-1.799l4.978-4.97 1.798 1.799-4.976 4.97zm5.823-5.817-1.798-1.799L14.698 5l1.8 1.799-1.373 1.371z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageAltError(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4v12c0 1.103.897 2 2 2h3.5l3.5 4 3.5-4H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2zm8 1h2v6h-2V5zm0 8h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageAltMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.5l3.5 4 3.5-4H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5zm11 9H8V9h8v2z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageAltX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m8.5 18 3.5 4 3.5-4H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.5zM7.293 6.707l1.414-1.414L12 8.586l3.293-3.293 1.414 1.414L13.414 10l3.293 3.293-1.414 1.414L12 11.414l-3.293 3.293-1.414-1.414L10.586 10 7.293 6.707z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.999 2h-14c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h3.5l3.5 4 3.5-4h3.5c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .894-2 1.992v12.016C2 17.106 2.897 18 4 18h3v4l6.351-4H20c1.103 0 2-.894 2-1.992V3.992A1.998 1.998 0 0 0 20 2zm-9 11.914-3.707-3.707 1.414-1.414L11 11.086l4.793-4.793 1.414 1.414L11 13.914z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageDetail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .894-2 1.992v12.016C2 17.106 2.897 18 4 18h3v4l6.351-4H20c1.103 0 2-.894 2-1.992V3.992A1.998 1.998 0 0 0 20 2zm-6 11H7v-2h7v2zm3-4H7V7h10v2z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageDots(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .894-2 1.992v12.017C2 17.106 2.897 18 4 18h3v4l6.351-4H20c1.103 0 2-.894 2-1.992V3.992A1.998 1.998 0 0 0 20 2zm-9 8a2 2 0 1 1-2-2c.086 0 .167.015.25.025.082-.014.164-.025.25-.025A1.5 1.5 0 0 1 11 9.5c0 .086-.012.168-.025.25.01.083.025.165.025.25zm4 2a2 2 0 0 1-2-2c0-.086.015-.167.025-.25A1.592 1.592 0 0 1 13 9.5 1.5 1.5 0 0 1 14.5 8c.086 0 .168.011.25.025.083-.01.164-.025.25-.025a2 2 0 0 1 0 4z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .894-2 1.992v12.016C2 17.106 2.897 18 4 18h3v4l6.351-4H20c1.103 0 2-.894 2-1.992V3.992A1.998 1.998 0 0 0 20 2zM8.999 14.999H7V13l5.53-5.522 1.998 1.999-5.529 5.522zm6.472-6.464-1.999-1.999 1.524-1.523 1.999 1.999-1.524 1.523z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageError(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .894-2 1.992v12.016C2 17.106 2.897 18 4 18h3v4l6.351-4H20c1.103 0 2-.894 2-1.992V3.992A1.998 1.998 0 0 0 20 2zm-7 13h-2v-2h2v2zm0-4h-2V5h2v6z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .894-2 1.992v12.016C2 17.106 2.897 18 4 18h3v4l6.351-4H20c1.103 0 2-.894 2-1.992V3.992A1.998 1.998 0 0 0 20 2zm-4 9H8V9h8v2z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageRoundedAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.907 1.897 5.515 5 6.934V22l5.34-4.005C17.697 17.853 22 14.32 22 10c0-4.411-4.486-8-10-8zm4 9h-3v3h-2v-3H8V9h3V6h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageRoundedCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.907 1.897 5.515 5 6.934V22l5.34-4.005C17.697 17.853 22 14.32 22 10c0-4.411-4.486-8-10-8zm-1 12.414-3.707-3.707 1.414-1.414L11 11.586l4.793-4.793 1.414 1.414L11 14.414z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageRoundedDetail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.907 1.897 5.515 5 6.934V22l5.34-4.005C17.697 17.853 22 14.32 22 10c0-4.411-4.486-8-10-8zm2 11H7v-2h7v2zm3-4H7V7h10v2z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageRoundedDots(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.897 5.516 5 6.934V22l5.34-4.004C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8zm-2.5 9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageRoundedEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.907 1.897 5.516 5 6.934V22l5.34-4.005C17.697 17.854 22 14.32 22 10c0-4.411-4.486-8-10-8zM9.302 13.986H7.503v-1.798l4.976-4.97 1.798 1.799-4.975 4.969zm5.823-5.816-1.799-1.798 1.372-1.371 1.799 1.798-1.372 1.371z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageRoundedError(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.907 1.897 5.516 5 6.934V22l5.34-4.005C17.697 17.854 22 14.32 22 10c0-4.411-4.486-8-10-8zm1 12h-2v-2h2v2zm0-4h-2V5h2v5z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageRoundedMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.907 1.897 5.515 5 6.934V22l5.34-4.005C17.697 17.853 22 14.32 22 10c0-4.411-4.486-8-10-8zm4 9H8V9h8v2z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageRoundedX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.907 1.897 5.515 5 6.934V22l5.34-4.005C17.697 17.853 22 14.32 22 10c0-4.411-4.486-8-10-8zm3.707 10.293-1.414 1.414L12 11.414l-2.293 2.293-1.414-1.414L10.586 10 8.293 7.707l1.414-1.414L12 8.586l2.293-2.293 1.414 1.414L13.414 10l2.293 2.293z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageRounded(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 5.589 2 10c0 2.908 1.898 5.515 5 6.934V22l5.34-4.005C17.697 17.852 22 14.32 22 10c0-4.411-4.486-8-10-8z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageSquareAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm1 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageSquareCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm-5 14.414-3.707-3.707 1.414-1.414L11 13.586l4.793-4.793 1.414 1.414L11 16.414z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageSquareDetail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm-2 13H7v-2h7v2zm3-4H7V9h10v2z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageSquareDots(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm-5 10.5A1.5 1.5 0 0 1 9.5 14c-.086 0-.168-.011-.25-.025-.083.01-.164.025-.25.025a2 2 0 1 1 2-2c0 .085-.015.167-.025.25.013.082.025.164.025.25zm4 1.5c-.086 0-.167-.015-.25-.025a1.471 1.471 0 0 1-.25.025 1.5 1.5 0 0 1-1.5-1.5c0-.085.012-.168.025-.25-.01-.083-.025-.164-.025-.25a2 2 0 1 1 2 2z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageSquareEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zM8.999 17H7v-1.999l5.53-5.522 1.999 1.999L8.999 17zm6.473-6.465-1.999-1.999 1.524-1.523 1.999 1.999-1.524 1.523z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageSquareError(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm-3 16h-2v-2h2v2zm0-4h-2V6h2v8z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageSquareMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm0 11H8v-2h8v2z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageSquareX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm.706 13.293-1.414 1.414L12 13.415l-3.292 3.292-1.414-1.414 3.292-3.292-3.292-3.292 1.414-1.414L12 10.587l3.292-3.292 1.414 1.414-3.292 3.292 3.292 3.292z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 0 0 1 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6z"
                }
            }
        ]
    })(props);
}
function BiSolidMessageX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .894-2 1.992v12.016C2 17.106 2.897 18 4 18h3v4l6.351-4H20c1.103 0 2-.894 2-1.992V3.992A1.998 1.998 0 0 0 20 2zm-3.293 11.293-1.414 1.414L12 11.414l-3.293 3.293-1.414-1.414L10.586 10 7.293 6.707l1.414-1.414L12 8.586l3.293-3.293 1.414 1.414L13.414 10l3.293 3.293z"
                }
            }
        ]
    })(props);
}
function BiSolidMessage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.103 0-2 .894-2 1.992v12.016C2 17.106 2.897 18 4 18h3v4l6.351-4H20c1.103 0 2-.894 2-1.992V3.992A1.998 1.998 0 0 0 20 2z"
                }
            }
        ]
    })(props);
}
function BiSolidMeteor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.507 2.138a1 1 0 0 0-1.155.102L4.196 9.197c-2.924 2.924-2.924 7.682 0 10.606a7.472 7.472 0 0 0 5.3 2.192c1.924 0 3.85-.734 5.317-2.202l6.903-7.096A1 1 0 0 0 21 11h-3.301l4.175-7.514a1.001 1.001 0 0 0-1.359-1.36l-7.11 3.95.576-2.879a1.002 1.002 0 0 0-.474-1.059zM14 14.5a4.5 4.5 0 0 1-9 0c0-1.57.807-2.949 2.025-3.754-.01.084-.025.167-.025.254a2 2 0 1 0 3.845-.772C12.669 10.802 14 12.486 14 14.5z"
                }
            }
        ]
    })(props);
}
function BiSolidMicrochip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.999 22h8c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2h-8c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2zm-5-15h2V5h-2v.5h-1v1h1zm18-2h-2v2h2v-.5h1v-1h-1zm-18 6h2V9h-2v.5h-1v1h1zm18-2h-2v2h2v-.5h1v-1h-1zm-18 6h2v-2h-2v.5h-1v1h1zm18-2h-2v2h2v-.5h1v-1h-1zm-18 6h2v-2h-2v.5h-1v1h1zm18-2h-2v2h2v-.5h1v-1h-1z"
                }
            }
        ]
    })(props);
}
function BiSolidMicrophoneAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12H4c0 4.072 3.061 7.436 7 7.931V22h2v-2.069c3.939-.495 7-3.858 7-7.931h-2c0 3.309-2.691 6-6 6s-6-2.691-6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12c0 2.206 1.794 4 4 4s4-1.794 4-4h-2v-2h2V8h-2V6h2c0-2.217-1.785-4.021-3.979-4.021a.933.933 0 0 0-.209.025A4.006 4.006 0 0 0 8 6h4v2H8v2h4v2H8z"
                }
            }
        ]
    })(props);
}
function BiSolidMicrophoneOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.707 20.293-3.4-3.4A7.93 7.93 0 0 0 20 12h-2a5.945 5.945 0 0 1-1.119 3.467l-1.449-1.45A3.926 3.926 0 0 0 16 12V6c0-2.217-1.785-4.021-3.979-4.021-.07 0-.14.009-.209.025A4.006 4.006 0 0 0 8 6v.586L3.707 2.293 2.293 3.707l18 18 1.414-1.414zM6 12H4c0 4.072 3.06 7.436 7 7.931V22h2v-2.069a7.935 7.935 0 0 0 2.241-.63l-1.549-1.548A5.983 5.983 0 0 1 12 18c-3.309 0-6-2.691-6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.007 12.067a3.996 3.996 0 0 0 3.926 3.926l-3.926-3.926z"
                }
            }
        ]
    })(props);
}
function BiSolidMicrophone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16c2.206 0 4-1.794 4-4V6c0-2.217-1.785-4.021-3.979-4.021a.933.933 0 0 0-.209.025A4.006 4.006 0 0 0 8 6v6c0 2.206 1.794 4 4 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 19.931V22h2v-2.069c3.939-.495 7-3.858 7-7.931h-2c0 3.309-2.691 6-6 6s-6-2.691-6-6H4c0 4.072 3.061 7.436 7 7.931z"
                }
            }
        ]
    })(props);
}
function BiSolidMinusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm5 11H7v-2h10v2z"
                }
            }
        ]
    })(props);
}
function BiSolidMinusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5zm12 10H7v-2h10v2z"
                }
            }
        ]
    })(props);
}
function BiSolidMobileVibration(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.535 2.808a2.003 2.003 0 0 0-2.828 0l-9.899 9.899a2.001 2.001 0 0 0 0 2.828l5.657 5.657c.39.39.902.585 1.414.585s1.024-.195 1.414-.585l9.899-9.899c.78-.779.78-2.049 0-2.828l-5.657-5.657zM8.707 16.707a.999.999 0 1 1-1.414-1.414.999.999 0 1 1 1.414 1.414zm7 5-1.414-1.414 6-6 1.414 1.415zM8.293 2.293l1.414 1.414-6 6-1.414-1.415z"
                }
            }
        ]
    })(props);
}
function BiSolidMobile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 22c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H8c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h10zm-5-5a1 1 0 1 1 0 2 1 1 0 1 1 0-2z"
                }
            }
        ]
    })(props);
}
function BiSolidMoon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11.807A9.002 9.002 0 0 1 10.049 2a9.942 9.942 0 0 0-5.12 2.735c-3.905 3.905-3.905 10.237 0 14.142 3.906 3.906 10.237 3.905 14.143 0a9.946 9.946 0 0 0 2.735-5.119A9.003 9.003 0 0 1 12 11.807z"
                }
            }
        ]
    })(props);
}
function BiSolidMouseAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 2v8h6V8c0-3.309-2.691-6-6-6zM5 16c0 3.309 2.691 6 6 6h2c3.309 0 6-2.691 6-6v-4H5v4zm0-8v2h6V2C7.691 2 5 4.691 5 8z"
                }
            }
        ]
    })(props);
}
function BiSolidMouse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.975 22H12c3.859 0 7-3.14 7-7V9c0-3.841-3.127-6.974-6.981-7h-.06C8.119 2.022 5 5.157 5 9v6c0 3.86 3.129 7 6.975 7zM11 6h2v6h-2V6z"
                }
            }
        ]
    })(props);
}
function BiSolidMoviePlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm.001 6c-.001 0-.001 0 0 0h-.465l-2.667-4H20l.001 4zM15.5 15 10 18v-6l5.5 3zm-.964-6-2.667-4h2.596l2.667 4h-2.596zm-2.404 0H9.536L6.869 5h2.596l2.667 4zM4 5h.465l2.667 4H4V5z"
                }
            }
        ]
    })(props);
}
function BiSolidMovie(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm.001 6c-.001 0-.001 0 0 0h-.466l-2.667-4H20l.001 4zm-5.466 0-2.667-4h2.596l2.667 4h-2.596zm-2.404 0H9.535L6.869 5h2.596l2.666 4zM4 5h.465l2.667 4H4V5z"
                }
            }
        ]
    })(props);
}
function BiSolidMusic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18.573c2.206 0 4-1.794 4-4V4.428L19 7.7v7.43a3.953 3.953 0 0 0-2-.557c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4V7a.998.998 0 0 0-.658-.939l-11-4A.999.999 0 0 0 8 3v8.13a3.953 3.953 0 0 0-2-.557c-2.206 0-4 1.794-4 4s1.794 4 4 4z"
                }
            }
        ]
    })(props);
}
function BiSolidNavigation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.002 9.538c-.023.411.207.794.581.966l7.504 3.442 3.442 7.503c.164.356.52.583.909.583l.057-.002a1 1 0 0 0 .894-.686l5.595-17.032c.117-.358.023-.753-.243-1.02s-.66-.358-1.02-.243L2.688 8.645a.997.997 0 0 0-.686.893z"
                }
            }
        ]
    })(props);
}
function BiSolidNetworkChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 3A2.502 2.502 0 0 0 17 5.5c0 .357.078.696.214 1.005l-1.955 2.199A3.977 3.977 0 0 0 13 8c-.74 0-1.424.216-2.019.566L8.707 6.293l-.023.023C8.88 5.918 9 5.475 9 5a3 3 0 1 0-3 3c.475 0 .917-.12 1.316-.316l-.023.023L9.567 9.98A3.956 3.956 0 0 0 9 12c0 .997.38 1.899.985 2.601l-2.577 2.576A2.472 2.472 0 0 0 6.5 17C5.122 17 4 18.121 4 19.5S5.122 22 6.5 22 9 20.879 9 19.5c0-.321-.066-.626-.177-.909l2.838-2.838c.421.15.867.247 1.339.247 2.206 0 4-1.794 4-4 0-.636-.163-1.229-.428-1.764l2.117-2.383c.256.088.526.147.811.147C20.879 8 22 6.879 22 5.5S20.879 3 19.5 3zM13 14c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z"
                }
            }
        ]
    })(props);
}
function BiSolidNews(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17a1 1 0 0 1-2 0V5a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v13a2 2 0 0 0 2 2h15c1.654 0 3-1.346 3-3V7h-2v10zM12 7h3v2h-3V7zm0 4h3v2h-3v-2zM5 7h5v6H5V7zm0 10v-2h10v2H5z"
                }
            }
        ]
    })(props);
}
function BiSolidNoEntry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm5 12H7v-4h10v4z"
                }
            }
        ]
    })(props);
}
function BiSolidNote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8l8-8V5a2 2 0 0 0-2-2zm-7 16v-7h7l-7 7z"
                }
            }
        ]
    })(props);
}
function BiSolidNotepad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-3V2h-2v2h-4V2H8v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-7 10H7v-2h5v2zm5-4H7V8h10v2z"
                }
            }
        ]
    })(props);
}
function BiSolidNotificationOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "6",
                    "r": "3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18v-7.422A4.962 4.962 0 0 1 18 11a5 5 0 0 1-5-5c0-.712.153-1.387.422-2H6c-.178 0-.347.031-.51.076L3.707 2.293 2.293 3.707l18 18 1.414-1.414-1.783-1.783c.045-.163.076-.332.076-.51zM4 18c0 1.103.897 2 2 2h9.879L4 8.121V18z"
                }
            }
        ]
    })(props);
}
function BiSolidNotification(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "6",
                    "r": "3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6c0-.712.153-1.387.422-2H6c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-7.422A4.962 4.962 0 0 1 18 11a5 5 0 0 1-5-5z"
                }
            }
        ]
    })(props);
}
function BiSolidObjectsHorizontalCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13h-6v-2h4a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-4V2h-2v3H7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4v2H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h6v3h2v-3h6a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function BiSolidObjectsHorizontalLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2h2v20H2z"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "6",
                    "y": "13",
                    "width": "16",
                    "height": "6",
                    "rx": "1"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "6",
                    "y": "5",
                    "width": "12",
                    "height": "6",
                    "rx": "1"
                }
            }
        ]
    })(props);
}
function BiSolidObjectsHorizontalRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2h2v20h-2z"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "13",
                    "width": "16",
                    "height": "6",
                    "rx": "1"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "6",
                    "y": "5",
                    "width": "12",
                    "height": "6",
                    "rx": "1"
                }
            }
        ]
    })(props);
}
function BiSolidObjectsVerticalBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 20h20v2H2z"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "5",
                    "y": "2",
                    "width": "6",
                    "height": "16",
                    "rx": "1"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "13",
                    "y": "6",
                    "width": "6",
                    "height": "12",
                    "rx": "1"
                }
            }
        ]
    })(props);
}
function BiSolidObjectsVerticalCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v4h-2V5a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v6H2v2h3v6a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-6h2v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4h3v-2h-3z"
                }
            }
        ]
    })(props);
}
function BiSolidObjectsVerticalTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2h20v2H2z"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "5",
                    "y": "6",
                    "width": "6",
                    "height": "16",
                    "rx": "1"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "13",
                    "y": "6",
                    "width": "6",
                    "height": "12",
                    "rx": "1"
                }
            }
        ]
    })(props);
}
function BiSolidOffer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.749 12 1.104-1.908a1 1 0 0 0-.365-1.366l-1.91-1.104v-2.2a1 1 0 0 0-1-1h-2.199l-1.103-1.909a1.008 1.008 0 0 0-.607-.466.993.993 0 0 0-.759.1L12 3.251l-1.91-1.105a1 1 0 0 0-1.366.366L7.62 4.422H5.421a1 1 0 0 0-1 1v2.199l-1.91 1.104a.998.998 0 0 0-.365 1.367L3.25 12l-1.104 1.908a1.004 1.004 0 0 0 .364 1.367l1.91 1.104v2.199a1 1 0 0 0 1 1h2.2l1.104 1.91a1.01 1.01 0 0 0 .866.5c.174 0 .347-.046.501-.135l1.908-1.104 1.91 1.104a1.001 1.001 0 0 0 1.366-.365l1.103-1.91h2.199a1 1 0 0 0 1-1v-2.199l1.91-1.104a1 1 0 0 0 .365-1.367L20.749 12zM9.499 6.99a1.5 1.5 0 1 1-.001 3.001 1.5 1.5 0 0 1 .001-3.001zm.3 9.6-1.6-1.199 6-8 1.6 1.199-6 8zm4.7.4a1.5 1.5 0 1 1 .001-3.001 1.5 1.5 0 0 1-.001 3.001z"
                }
            }
        ]
    })(props);
}
function BiSolidPackage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.993 7.95a.96.96 0 0 0-.029-.214c-.007-.025-.021-.049-.03-.074-.021-.057-.04-.113-.07-.165-.016-.027-.038-.049-.057-.075-.032-.045-.063-.091-.102-.13-.023-.022-.053-.04-.078-.061-.039-.032-.075-.067-.12-.094-.004-.003-.009-.003-.014-.006l-.008-.006-8.979-4.99a1.002 1.002 0 0 0-.97-.001l-9.021 4.99c-.003.003-.006.007-.011.01l-.01.004c-.035.02-.061.049-.094.073-.036.027-.074.051-.106.082-.03.031-.053.067-.079.102-.027.035-.057.066-.079.104-.026.043-.04.092-.059.139-.014.033-.032.064-.041.1a.975.975 0 0 0-.029.21c-.001.017-.007.032-.007.05V16c0 .363.197.698.515.874l8.978 4.987.001.001.002.001.02.011c.043.024.09.037.135.054.032.013.063.03.097.039a1.013 1.013 0 0 0 .506 0c.033-.009.064-.026.097-.039.045-.017.092-.029.135-.054l.02-.011.002-.001.001-.001 8.978-4.987c.316-.176.513-.511.513-.874V7.998c0-.017-.006-.031-.007-.048zm-10.021 3.922L5.058 8.005 7.82 6.477l6.834 3.905-2.682 1.49zm.048-7.719L18.941 8l-2.244 1.247-6.83-3.903 2.153-1.191zM13 19.301l.002-5.679L16 11.944V15l2-1v-3.175l2-1.119v5.705l-7 3.89z"
                }
            }
        ]
    })(props);
}
function BiSolidPaintRoll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H7c-1.103 0-2 .897-2 2v3c0 1.103.897 2 2 2h11c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 15v-2c0-1.103-.897-2-2-2H4V5c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h7v2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function BiSolidPaint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.084 2.914c-1.178-1.179-3.234-1.179-4.412 0l-8.379 8.379a.999.999 0 0 0 0 1.414l3 3a.997.997 0 0 0 1.414 0l8.379-8.379a3.123 3.123 0 0 0-.002-4.414zm-1.412 3L12 13.586 10.414 12l7.672-7.672a1.146 1.146 0 0 1 1.586.002 1.123 1.123 0 0 1 0 1.584zM8 15c-1.265-.634-3.5 0-3.5 2 0 1.197.5 2-1.5 3 0 0 3.25 2.25 5.5 0 1.274-1.274 1.494-4-.5-5z"
                }
            }
        ]
    })(props);
}
function BiSolidPalette(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.38 21.646A9.985 9.985 0 0 0 12 22l.141-.001a2.998 2.998 0 0 0 2.515-1.425c.542-.876.6-1.953.153-2.88l-.198-.415c-.453-.942-.097-1.796.388-2.281.485-.485 1.341-.841 2.28-.388h.001l.413.199a2.99 2.99 0 0 0 2.881-.153A2.997 2.997 0 0 0 22 12.141a9.926 9.926 0 0 0-.353-2.76c-1.038-3.827-4.353-6.754-8.246-7.285-3.149-.427-6.241.602-8.471 2.833S1.666 10.247 2.096 13.4c.53 3.894 3.458 7.208 7.284 8.246zM15.5 6a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm-5-1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zM9 15.506a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm-2.5-6.5a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 6.5 9.006z"
                }
            }
        ]
    })(props);
}
function BiSolidPaperPlane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.6 13.083 3.452 1.511L16 9.167l-6 7 8.6 3.916a1 1 0 0 0 1.399-.85l1-15a1.002 1.002 0 0 0-1.424-.972l-17 8a1.002 1.002 0 0 0 .025 1.822zM8 22.167l4.776-2.316L8 17.623z"
                }
            }
        ]
    })(props);
}
function BiSolidParking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 3H5v18h4v-5h4.5c3.584 0 6.5-2.916 6.5-6.5S17.084 3 13.5 3zm0 9H9V7h4.5C14.879 7 16 8.121 16 9.5S14.879 12 13.5 12z"
                }
            }
        ]
    })(props);
}
function BiSolidParty(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M23 7a8.44 8.44 0 0 0-5 1.31c-.36-.41-.73-.82-1.12-1.21l-.29-.27.14-.12a3.15 3.15 0 0 0 .9-3.49A3.9 3.9 0 0 0 14 1v2a2 2 0 0 1 1.76 1c.17.4 0 .84-.47 1.31l-.23.21a16.71 16.71 0 0 0-3.41-2.2c-2.53-1.14-3.83-.61-4.47 0a2.18 2.18 0 0 0-.46.68l-.18.53L5.1 8.87C6.24 11.71 9 16.76 15 18.94l5-1.66a1 1 0 0 0 .43-.31l.21-.18c1.43-1.44.51-4.21-1.41-6.9A6.63 6.63 0 0 1 23 9zm-3.79 8.37h-.06c-.69.37-3.55-.57-6.79-3.81-.34-.34-.66-.67-.95-1-.1-.11-.19-.23-.29-.35l-.53-.64-.28-.39c-.14-.19-.28-.38-.4-.56s-.16-.26-.24-.39-.22-.34-.31-.51-.13-.24-.19-.37-.17-.28-.23-.42-.09-.23-.14-.34-.11-.27-.15-.4S8.6 6 8.58 5.9s-.06-.24-.08-.34a2 2 0 0 1 0-.24 1.15 1.15 0 0 1 0-.26l.11-.31c.17-.18.91-.23 2.23.37a13.83 13.83 0 0 1 2.49 1.54A4.17 4.17 0 0 1 12 7v2a6.43 6.43 0 0 0 3-.94l.49.46c.44.43.83.86 1.19 1.27A5.31 5.31 0 0 0 16 13.2l2-.39a3.23 3.23 0 0 1 0-1.14c1.29 1.97 1.53 3.39 1.21 3.7zM4.4 11l-2.23 6.7A3.28 3.28 0 0 0 5.28 22a3.21 3.21 0 0 0 1-.17l6.52-2.17A18.7 18.7 0 0 1 4.4 11z"
                }
            }
        ]
    })(props);
}
function BiSolidPaste(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4h6v2H9zm11 7h-7a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9V6a2 2 0 0 0-2-2h-2a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4v-9a2 2 0 0 1 2-2h10zM9 6V4h6v2H9z"
                }
            }
        ]
    })(props);
}
function BiSolidPear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.12 22a7.71 7.71 0 0 0 6.57-5 7.23 7.23 0 0 0 .46-3.21 3.26 3.26 0 0 1 1-2.57l.61-.61A3.89 3.89 0 0 0 19.43 6l2.28-2.28-1.42-1.43L18 4.55a3.82 3.82 0 0 0-4.66.57l-.75.75a3.22 3.22 0 0 1-2.52 1 7.05 7.05 0 0 0-3.32.57A7.75 7.75 0 0 0 2 14.11 7.59 7.59 0 0 0 10.12 22zM9.5 9.25v1.5a3.75 3.75 0 0 0-3.75 3.75h-1.5A5.26 5.26 0 0 1 9.5 9.25z"
                }
            }
        ]
    })(props);
}
function BiSolidPen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.587 6.999H7.702a2 2 0 0 0-1.88 1.316l-3.76 10.342c-.133.365-.042.774.232 1.049l.293.293 6.422-6.422c-.001-.026-.008-.052-.008-.078a1.5 1.5 0 1 1 1.5 1.5c-.026 0-.052-.007-.078-.008l-6.422 6.422.293.293a.997.997 0 0 0 1.049.232l10.342-3.761a2 2 0 0 0 1.316-1.88v-3.885L19 10.414 13.586 5l-1.999 1.999zm8.353 2.062-5-5 2.12-2.121 5 5z"
                }
            }
        ]
    })(props);
}
function BiSolidPencil(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.707 19.707 18 10.414 13.586 6l-9.293 9.293a1.003 1.003 0 0 0-.263.464L3 21l5.242-1.03c.176-.044.337-.135.465-.263zM21 7.414a2 2 0 0 0 0-2.828L19.414 3a2 2 0 0 0-2.828 0L15 4.586 19.414 9 21 7.414z"
                }
            }
        ]
    })(props);
}
function BiSolidPhoneCall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10.999h2C22 5.869 18.127 2 12.99 2v2C17.052 4 20 6.943 20 10.999z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8c2.103 0 3 .897 3 3h2c0-3.225-1.775-5-5-5v2zm3.422 5.443a1.001 1.001 0 0 0-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 0 0 .043-1.391L6.859 3.513a1 1 0 0 0-1.391-.087l-2.17 1.861a1 1 0 0 0-.29.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.323 21 17.705 21c.202 0 .326-.006.359-.008a.992.992 0 0 0 .648-.291l1.86-2.171a1 1 0 0 0-.086-1.391l-4.064-3.696z"
                }
            }
        ]
    })(props);
}
function BiSolidPhoneIncoming(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.793 6.793 13 4v7h7l-2.793-2.793 4.5-4.5-1.414-1.414z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.422 13.443a1.001 1.001 0 0 0-1.391.043l-2.392 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 0 0 .043-1.391L6.86 3.513a1 1 0 0 0-1.391-.087l-2.17 1.861a1.001 1.001 0 0 0-.291.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.324 21 17.705 21c.203 0 .326-.006.359-.008a.99.99 0 0 0 .648-.291l1.861-2.171a1.001 1.001 0 0 0-.086-1.391l-4.065-3.696z"
                }
            }
        ]
    })(props);
}
function BiSolidPhoneOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.17 13.42a5.24 5.24 0 0 1-.93-2.06L10.7 9a1 1 0 0 0 0-1.39l-3.65-4.1a1 1 0 0 0-1.4-.08L3.48 5.29a1 1 0 0 0-.29.65 15.25 15.25 0 0 0 3.54 9.92l-4.44 4.43 1.42 1.42 18-18-1.42-1.42zm7.44.02a1 1 0 0 0-1.39.05L12.82 16a4.07 4.07 0 0 1-.51-.14l-2.66 2.61A15.46 15.46 0 0 0 17.89 21h.36a1 1 0 0 0 .65-.29l1.86-2.17a1 1 0 0 0-.09-1.39z"
                }
            }
        ]
    })(props);
}
function BiSolidPhoneOutgoing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m16.793 5.793-4.5 4.5 1.414 1.414 4.5-4.5L21 10V3h-7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.422 13.446a1.001 1.001 0 0 0-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 0 0 .043-1.391L6.859 3.516a1 1 0 0 0-1.391-.087L3.299 5.29a.996.996 0 0 0-.291.648c-.015.25-.301 6.172 4.291 10.766 4.006 4.006 9.024 4.299 10.406 4.299.202 0 .326-.006.359-.008a.992.992 0 0 0 .648-.291l1.86-2.171a1 1 0 0 0-.086-1.391l-4.064-3.696z"
                }
            }
        ]
    })(props);
}
function BiSolidPhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.487 17.14-4.065-3.696a1.001 1.001 0 0 0-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 0 0 .043-1.391L6.859 3.513a1 1 0 0 0-1.391-.087l-2.17 1.861a1 1 0 0 0-.29.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.323 21 17.705 21c.202 0 .326-.006.359-.008a.992.992 0 0 0 .648-.291l1.86-2.171a.997.997 0 0 0-.085-1.39z"
                }
            }
        ]
    })(props);
}
function BiSolidPhotoAlbum(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3h15v-2H6.012C5.55 19.988 5 19.806 5 19s.55-.988 1.012-1H21V3a1 1 0 0 0-1-1zM9.503 5a1.503 1.503 0 1 1 0 3.006 1.503 1.503 0 0 1 0-3.006zM12 13H7l3-3 1.5 1.399L14.5 8l3.5 5h-6z"
                }
            }
        ]
    })(props);
}
function BiSolidPiano(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5C3.346 3 2 4.346 2 6v12c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3zm0 16H5a1 1 0 0 1-1-1v-6h2v4h2v-4h1v4h2v-4h1v4h2v-4h2v4h2v-4h2v6a1 1 0 0 1-1 1z"
                }
            }
        ]
    })(props);
}
function BiSolidPieChartAlt2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 2.051V11h8.949c-.47-4.717-4.232-8.479-8.949-8.949zm4.969 17.953c2.189-1.637 3.694-4.14 3.98-7.004h-8.183l4.203 7.004z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12V2.051C5.954 2.555 2 6.824 2 12c0 5.514 4.486 10 10 10a9.93 9.93 0 0 0 4.255-.964s-5.253-8.915-5.254-9.031A.02.02 0 0 0 11 12z"
                }
            }
        ]
    })(props);
}
function BiSolidPieChartAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.071 4.929A9.97 9.97 0 0 0 12 2a9.936 9.936 0 0 0-7.071 2.929C3.04 6.818 2 9.33 2 12s1.04 5.182 2.929 7.071C6.818 20.96 9.33 22 12 22s5.182-1.04 7.071-2.929A9.936 9.936 0 0 0 22 12a9.97 9.97 0 0 0-2.929-7.071zm-1.414 12.728C16.146 19.168 14.137 20 12 20s-4.146-.832-5.657-2.343C4.832 16.146 4 14.137 4 12s.832-4.146 2.343-5.657A7.948 7.948 0 0 1 12 4v8h8a7.948 7.948 0 0 1-2.343 5.657z"
                }
            }
        ]
    })(props);
}
function BiSolidPieChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 10V5c4 0 7 3 7 7h-7z"
                }
            }
        ]
    })(props);
}
function BiSolidPin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11.586V6h2V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2h2v5.586l-2.707 1.707A.996.996 0 0 0 6 14v2a1 1 0 0 0 1 1h4v3l1 2 1-2v-3h4a1 1 0 0 0 1-1v-2a.996.996 0 0 0-.293-.707L15 11.586z"
                }
            }
        ]
    })(props);
}
function BiSolidPizza(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.76 2.021a.995.995 0 0 0-.989.703L3.579 19.166a1 1 0 0 0 1.255 1.255l16.442-5.192a.991.991 0 0 0 .702-.988C21.6 7.666 16.334 2.4 9.76 2.021zM10 16a2 2 0 1 1 .001-4.001A2 2 0 0 1 10 16zm6-2a2 2 0 1 1 .001-4.001A2 2 0 0 1 16 14z"
                }
            }
        ]
    })(props);
}
function BiSolidPlaneAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.414 13.778 2 15.192l4.949 2.121 2.122 4.95 1.414-1.414-.707-3.536L13.091 14l3.61 7.704 1.339-1.339-1.19-10.123 2.828-2.829a2 2 0 1 0-2.828-2.828l-2.903 2.903L3.824 6.297 2.559 7.563l7.644 3.67-3.253 3.253-3.536-.708z"
                }
            }
        ]
    })(props);
}
function BiSolidPlaneLand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.842 15.296a1.61 1.61 0 0 0 1.892-1.189v-.001a1.609 1.609 0 0 0-1.177-1.949l-4.576-1.133L9.825 4.21l-2.224-.225 2.931 6.589-4.449-.449-2.312-3.829-1.38.31 1.24 5.52 15.211 3.17zM3 18h18v2H3z"
                }
            }
        ]
    })(props);
}
function BiSolidPlaneTakeOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18h18v2H3zm18.509-9.473a1.61 1.61 0 0 0-2.036-1.019L15 9 7 6 5 7l6 4-4 2-4-2-1 1 4 4 14.547-5.455a1.611 1.611 0 0 0 .962-2.018z"
                }
            }
        ]
    })(props);
}
function BiSolidPlane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16.21v-1.895L14 8V4a2 2 0 0 0-4 0v4.105L2 14.42v1.789l8-2.81V18l-3 2v2l5-2 5 2v-2l-3-2v-4.685l8 2.895z"
                }
            }
        ]
    })(props);
}
function BiSolidPlanet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.165 15.582c4.587-4.073 8.141-9.424 6.057-11.771-.661-.744-1.584-1.089-2.575-.983-.832.091-1.687.502-2.549 1.192a8.922 8.922 0 0 0-8.712.282 8.917 8.917 0 0 0-4.109 5.515 8.892 8.892 0 0 0 .306 5.325c-1.065 1.203-2.054 3.677-.823 5.063.517.581 1.257.841 2.147.841 2.707 0 6.808-2.399 10.258-5.464zm3.699-10.767c.358-.034.632.064.861.323.231.261.169.946-.252 1.929a9.059 9.059 0 0 0-1.617-1.853c.431-.262.776-.373 1.008-.399zM4.633 17.118a8.979 8.979 0 0 0 1.568 1.737c-1.025.303-1.714.283-1.945.021-.217-.243.002-1.069.377-1.758zm16.31-5.869c-1.215 1.797-2.906 3.671-4.778 5.333-1.934 1.719-4.066 3.208-6.05 4.202a9.082 9.082 0 0 0 1.874.212 8.986 8.986 0 0 0 4.616-1.282 8.915 8.915 0 0 0 4.338-8.465z"
                }
            }
        ]
    })(props);
}
function BiSolidPlaylist(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 16.493C13 18.427 14.573 20 16.507 20s3.507-1.573 3.507-3.507c0-.177-.027-.347-.053-.517H20V6h2V4h-3a1 1 0 0 0-1 1v8.333a3.465 3.465 0 0 0-1.493-.346A3.51 3.51 0 0 0 13 16.493zM2 5h14v2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9h14v2H2zm0 4h9v2H2zm0 4h9v2H2z"
                }
            }
        ]
    })(props);
}
function BiSolidPlug(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 8h2v5c0 2.206 1.794 4 4 4h2v5h2v-5h2c2.206 0 4-1.794 4-4V8h2V6H3v2zm4-6h2v3H7zm8 0h2v3h-2z"
                }
            }
        ]
    })(props);
}
function BiSolidPlusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
                }
            }
        ]
    })(props);
}
function BiSolidPlusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2zm2-10h4V7h2v4h4v2h-4v4h-2v-4H7v-2z"
                }
            }
        ]
    })(props);
}
function BiSolidPointer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.978 13.21a1 1 0 0 0-.396-1.024l-14-10a.999.999 0 0 0-1.575.931l2 17a1 1 0 0 0 1.767.516l3.612-4.416 3.377 5.46 1.701-1.052-3.357-5.428 6.089-1.218a.995.995 0 0 0 .782-.769z"
                }
            }
        ]
    })(props);
}
function BiSolidPolygon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.707 7.293-5-5A.996.996 0 0 0 16 2H8a.996.996 0 0 0-.707.293l-5 5A.996.996 0 0 0 2 8v8c0 .266.105.52.293.707l5 5A.996.996 0 0 0 8 22h8c.266 0 .52-.105.707-.293l5-5A.996.996 0 0 0 22 16V8a.996.996 0 0 0-.293-.707z"
                }
            }
        ]
    })(props);
}
function BiSolidPopsicle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4a7 7 0 0 0-9.9 0l-7.82 7.82a1 1 0 0 0 0 1.41l3.54 3.54-3.54 3.53 1.42 1.42 3.53-3.54 3.54 3.54a1 1 0 0 0 1.41 0L20 13.94A7 7 0 0 0 20 4zm-2.7 2.7a3.33 3.33 0 0 0-4.6 0l-1.06-1.06a4.76 4.76 0 0 1 6.72 0z"
                }
            }
        ]
    })(props);
}
function BiSolidPrinter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7h-1V2H6v5H5a3 3 0 0 0-3 3v7a2 2 0 0 0 2 2h2v3h12v-3h2a2 2 0 0 0 2-2v-7a3 3 0 0 0-3-3zM8 4h8v3H8V4zm0 16v-4h8v4H8zm11-8h-4v-2h4v2z"
                }
            }
        ]
    })(props);
}
function BiSolidPurchaseTagAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.707 2.293A.996.996 0 0 0 11 2H6a.996.996 0 0 0-.707.293l-3 3A.996.996 0 0 0 2 6v5c0 .266.105.52.293.707l10 10a.997.997 0 0 0 1.414 0l8-8a.999.999 0 0 0 0-1.414l-10-10zM8.353 10a1.647 1.647 0 1 1-.001-3.293A1.647 1.647 0 0 1 8.353 10z"
                }
            }
        ]
    })(props);
}
function BiSolidPurchaseTag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8 8a2 2 0 0 0 2.828 0l7.172-7.172a2 2 0 0 0 0-2.828l-8-8zM7 9a2 2 0 1 1 .001-4.001A2 2 0 0 1 7 9z"
                }
            }
        ]
    })(props);
}
function BiSolidPyramid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.445 21.832a1 1 0 0 0 1.11 0l9-6A.998.998 0 0 0 21.8 14.4l-9-12c-.377-.504-1.223-.504-1.6 0l-9 12a1 1 0 0 0 .245 1.432l9 6zm8.12-7.078L12 19.798V4.667l7.565 10.087z"
                }
            }
        ]
    })(props);
}
function BiSolidQuoteAltLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 10c-.223 0-.437.034-.65.065.069-.232.14-.468.254-.68.114-.308.292-.575.469-.844.148-.291.409-.488.601-.737.201-.242.475-.403.692-.604.213-.21.492-.315.714-.463.232-.133.434-.28.65-.35l.539-.222.474-.197-.485-1.938-.597.144c-.191.048-.424.104-.689.171-.271.05-.56.187-.882.312-.318.142-.686.238-1.028.466-.344.218-.741.4-1.091.692-.339.301-.748.562-1.05.945-.33.358-.656.734-.909 1.162-.293.408-.492.856-.702 1.299-.19.443-.343.896-.468 1.336-.237.882-.343 1.72-.384 2.437-.034.718-.014 1.315.028 1.747.015.204.043.402.063.539l.025.168.026-.006A4.5 4.5 0 1 0 6.5 10zm11 0c-.223 0-.437.034-.65.065.069-.232.14-.468.254-.68.114-.308.292-.575.469-.844.148-.291.409-.488.601-.737.201-.242.475-.403.692-.604.213-.21.492-.315.714-.463.232-.133.434-.28.65-.35l.539-.222.474-.197-.485-1.938-.597.144c-.191.048-.424.104-.689.171-.271.05-.56.187-.882.312-.317.143-.686.238-1.028.467-.344.218-.741.4-1.091.692-.339.301-.748.562-1.05.944-.33.358-.656.734-.909 1.162-.293.408-.492.856-.702 1.299-.19.443-.343.896-.468 1.336-.237.882-.343 1.72-.384 2.437-.034.718-.014 1.315.028 1.747.015.204.043.402.063.539l.025.168.026-.006A4.5 4.5 0 1 0 17.5 10z"
                }
            }
        ]
    })(props);
}
function BiSolidQuoteAltRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.95 8.721-.025-.168-.026.006A4.5 4.5 0 1 0 17.5 14c.223 0 .437-.034.65-.065-.069.232-.14.468-.254.68-.114.308-.292.575-.469.844-.148.291-.409.488-.601.737-.201.242-.475.403-.692.604-.213.21-.492.315-.714.463-.232.133-.434.28-.65.35l-.539.222-.474.197.484 1.939.597-.144c.191-.048.424-.104.689-.171.271-.05.56-.187.882-.312.317-.143.686-.238 1.028-.467.344-.218.741-.4 1.091-.692.339-.301.748-.562 1.05-.944.33-.358.656-.734.909-1.162.293-.408.492-.856.702-1.299.19-.443.343-.896.468-1.336.237-.882.343-1.72.384-2.437.034-.718.014-1.315-.028-1.747a7.028 7.028 0 0 0-.063-.539zm-11 0-.025-.168-.026.006A4.5 4.5 0 1 0 6.5 14c.223 0 .437-.034.65-.065-.069.232-.14.468-.254.68-.114.308-.292.575-.469.844-.148.291-.409.488-.601.737-.201.242-.475.403-.692.604-.213.21-.492.315-.714.463-.232.133-.434.28-.65.35l-.539.222c-.301.123-.473.195-.473.195l.484 1.939.597-.144c.191-.048.424-.104.689-.171.271-.05.56-.187.882-.312.317-.143.686-.238 1.028-.467.344-.218.741-.4 1.091-.692.339-.301.748-.562 1.05-.944.33-.358.656-.734.909-1.162.293-.408.492-.856.702-1.299.19-.443.343-.896.468-1.336.237-.882.343-1.72.384-2.437.034-.718.014-1.315-.028-1.747a7.571 7.571 0 0 0-.064-.537z"
                }
            }
        ]
    })(props);
}
function BiSolidQuoteLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.691 6.292C5.094 4.771 7.217 4 10 4h1v2.819l-.804.161c-1.37.274-2.323.813-2.833 1.604A2.902 2.902 0 0 0 6.925 10H10a1 1 0 0 1 1 1v7c0 1.103-.897 2-2 2H3a1 1 0 0 1-1-1v-5l.003-2.919c-.009-.111-.199-2.741 1.688-4.789zM20 20h-6a1 1 0 0 1-1-1v-5l.003-2.919c-.009-.111-.199-2.741 1.688-4.789C16.094 4.771 18.217 4 21 4h1v2.819l-.804.161c-1.37.274-2.323.813-2.833 1.604A2.902 2.902 0 0 0 17.925 10H21a1 1 0 0 1 1 1v7c0 1.103-.897 2-2 2z"
                }
            }
        ]
    })(props);
}
function BiSolidQuoteRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.309 17.708C22.196 15.66 22.006 13.03 22 13V5a1 1 0 0 0-1-1h-6c-1.103 0-2 .897-2 2v7a1 1 0 0 0 1 1h3.078a2.89 2.89 0 0 1-.429 1.396c-.508.801-1.465 1.348-2.846 1.624l-.803.16V20h1c2.783 0 4.906-.771 6.309-2.292zm-11.007 0C11.19 15.66 10.999 13.03 10.993 13V5a1 1 0 0 0-1-1h-6c-1.103 0-2 .897-2 2v7a1 1 0 0 0 1 1h3.078a2.89 2.89 0 0 1-.429 1.396c-.508.801-1.465 1.348-2.846 1.624l-.803.16V20h1c2.783 0 4.906-.771 6.309-2.292z"
                }
            }
        ]
    })(props);
}
function BiSolidQuoteSingleLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m15.203 6.98.804-.161V4h-1c-2.784 0-4.906.771-6.309 2.292C6.81 8.34 7 10.97 7.006 11v8a1 1 0 0 0 1 1h7c1.103 0 2-.897 2-2v-7a1 1 0 0 0-1-1h-4.079c.022-.402.123-.912.429-1.396.509-.801 1.466-1.347 2.847-1.624z"
                }
            }
        ]
    })(props);
}
function BiSolidQuoteSingleRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.804 17.02 8 17.18V20h1c2.783 0 4.906-.771 6.309-2.292C17.196 15.66 17.006 13.03 17 13V5a1 1 0 0 0-1-1H9c-1.103 0-2 .897-2 2v7a1 1 0 0 0 1 1h4.078a2.89 2.89 0 0 1-.429 1.396c-.507.801-1.464 1.347-2.845 1.624z"
                }
            }
        ]
    })(props);
}
function BiSolidRadiation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.912 8.531 7.121 3.877a.501.501 0 0 0-.704-.166 9.982 9.982 0 0 0-4.396 7.604.505.505 0 0 0 .497.528l5.421.09a4.042 4.042 0 0 1 1.973-3.402zm8.109-4.51a.504.504 0 0 0-.729.151L14.499 8.83a4.03 4.03 0 0 1 1.546 3.112l5.419-.09a.507.507 0 0 0 .499-.53 9.986 9.986 0 0 0-3.942-7.301zm-4.067 11.511a4.015 4.015 0 0 1-1.962.526 4.016 4.016 0 0 1-1.963-.526l-2.642 4.755a.5.5 0 0 0 .207.692A9.948 9.948 0 0 0 11.992 22a9.94 9.94 0 0 0 4.396-1.021.5.5 0 0 0 .207-.692l-2.641-4.755z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function BiSolidRadio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.249 5.025-7.897-2.962-.703 1.873L14.484 5H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7c0-1.02-.766-1.851-1.751-1.975zM10 17H6v-2h4v2zm6.5 1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm3.5-7H4V7h16v4z"
                }
            }
        ]
    })(props);
}
function BiSolidReceipt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12v6a1 1 0 0 1-2 0V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v14c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-6h-2zm-6-1v2H6v-2h8zM6 9V7h8v2H6zm8 6v2h-3v-2h3z"
                }
            }
        ]
    })(props);
}
function BiSolidRectangle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 20h18a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1z"
                }
            }
        ]
    })(props);
}
function BiSolidRegistered(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9h-3v2h3a1 1 0 0 0 0-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm2.13 15-2.67-4H10v4H8V7h5a3 3 0 0 1 .79 5.88L16.54 17z"
                }
            }
        ]
    })(props);
}
function BiSolidRename(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5.995h-1v12h1c1.103 0 2-.897 2-2v-8c0-1.102-.897-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 17.995V4h2.995V2h-8v2H15v1.995H4c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h11V20h-3.005v2h8v-2H17v-2.005zm-11-4v-4h9v4H6z"
                }
            }
        ]
    })(props);
}
function BiSolidReport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20 8-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM9 19H7v-9h2v9zm4 0h-2v-6h2v6zm4 0h-2v-3h2v3zM14 9h-1V4l5 5h-4z"
                }
            }
        ]
    })(props);
}
function BiSolidRewindCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.485 2 12s4.486 10 10 10c5.515 0 10-4.485 10-10S17.515 2 12 2zm5 14-6-4v4l-6-4 6-4v4l6-4v8z"
                }
            }
        ]
    })(props);
}
function BiSolidRightArrowAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m19 12-7-6v5H6v2h6v5z"
                }
            }
        ]
    })(props);
}
function BiSolidRightArrowCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 15v-4H7v-2h5V7l5 5-5 5z"
                }
            }
        ]
    })(props);
}
function BiSolidRightArrowSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2zm4 6h5V7l5 5-5 5v-4H7v-2z"
                }
            }
        ]
    })(props);
}
function BiSolidRightArrow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.536 21.886a1.004 1.004 0 0 0 1.033-.064l13-9a1 1 0 0 0 0-1.644l-13-9A1 1 0 0 0 5 3v18a1 1 0 0 0 .536.886z"
                }
            }
        ]
    })(props);
}
function BiSolidRightDownArrowCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.929 4.929c-3.898 3.899-3.898 10.244 0 14.143 3.899 3.898 10.243 3.898 14.143 0 3.898-3.899 3.898-10.244 0-14.143-3.9-3.899-10.244-3.899-14.143 0zm10.606 10.607h-7.07l2.828-2.829-3.535-3.536 1.414-1.414 3.535 3.536 2.828-2.829v7.072z"
                }
            }
        ]
    })(props);
}
function BiSolidRightTopArrowCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.071 4.929c-3.899-3.898-10.243-3.898-14.143 0-3.898 3.899-3.898 10.244 0 14.143 3.899 3.898 10.243 3.898 14.143 0 3.899-3.9 3.899-10.244 0-14.143zm-3.536 10.607-2.828-2.829-3.535 3.536-1.414-1.414 3.535-3.536-2.828-2.829h7.07v7.072z"
                }
            }
        ]
    })(props);
}
function BiSolidRocket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.78 15.84S18.64 13 19.61 12c3.07-3 1.54-9.18 1.54-9.18S15 1.29 12 4.36C9.66 6.64 8.14 8.22 8.14 8.22S4.3 7.42 2 9.72L14.25 22c2.3-2.33 1.53-6.16 1.53-6.16zm-1.5-9a2 2 0 0 1 2.83 0 2 2 0 1 1-2.83 0zM3 21a7.81 7.81 0 0 0 5-2l-3-3c-2 1-2 5-2 5z"
                }
            }
        ]
    })(props);
}
function BiSolidRuler(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.875 7H3.125C1.953 7 1 7.897 1 9v6c0 1.103.953 2 2.125 2h17.75C22.047 17 23 16.103 23 15V9c0-1.103-.953-2-2.125-2zM7 12H5V9h2v3zm4 1H9V9h2v4zm4-1h-2V9h2v3zm4 1h-2V9h2v4z"
                }
            }
        ]
    })(props);
}
function BiSolidSad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-5 8.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 7 10.5zM8 17s1-3 4-3 4 3 4 3H8zm7.493-5.014a1.494 1.494 0 1 1 .001-2.987 1.494 1.494 0 0 1-.001 2.987z"
                }
            }
        ]
    })(props);
}
function BiSolidSave(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14a2 2 0 0 0 2-2V8l-5-5H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2zM7 5h4v2h2V5h2v4H7V5zm0 8h10v6H7v-6z"
                }
            }
        ]
    })(props);
}
function BiSolidSchool(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10h-2V4h1V2H4v2h1v6H3a1 1 0 0 0-1 1v9h20v-9a1 1 0 0 0-1-1zm-7 8v-4h-4v4H7V4h10v14h-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6h2v2H9zm4 0h2v2h-2zm-4 4h2v2H9zm4 0h2v2h-2z"
                }
            }
        ]
    })(props);
}
function BiSolidSearchAlt2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16c1.763 0 3.37-.66 4.603-1.739l1.337 2.8s.275.224.653.596c.387.363.896.854 1.384 1.367l1.358 1.392.604.646 2.121-2.121-.646-.604-1.392-1.358a35.13 35.13 0 0 1-1.367-1.384c-.372-.378-.596-.653-.596-.653l-2.8-1.337A6.967 6.967 0 0 0 16 9c0-3.859-3.141-7-7-7S2 5.141 2 9s3.141 7 7 7z"
                }
            }
        ]
    })(props);
}
function BiSolidSearch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2c-4.411 0-8 3.589-8 8s3.589 8 8 8a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8z"
                }
            }
        ]
    })(props);
}
function BiSolidSelectMultiple(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-6.933 12.481-3.274-3.274 1.414-1.414 1.726 1.726 4.299-5.159 1.537 1.281-5.702 6.84z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h11v-2H4V8H2v12c0 1.103.897 2 2 2z"
                }
            }
        ]
    })(props);
}
function BiSolidSend(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.426 11.095-17-8A1 1 0 0 0 3.03 4.242l1.212 4.849L12 12l-7.758 2.909-1.212 4.849a.998.998 0 0 0 1.396 1.147l17-8a1 1 0 0 0 0-1.81z"
                }
            }
        ]
    })(props);
}
function BiSolidServer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-5 5h-2V6h2zm4 0h-2V6h2zm1 5H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm-5 5h-2v-2h2zm4 0h-2v-2h2z"
                }
            }
        ]
    })(props);
}
function BiSolidShapes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.867 2.504c-.355-.624-1.381-.623-1.736 0l-3.999 7A1 1 0 0 0 13 11h8a1.001 1.001 0 0 0 .868-1.496l-4.001-7zM3 22h7a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1zm14.5-9c-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5 4.5-2.019 4.5-4.5-2.019-4.5-4.5-4.5z"
                }
            }
        ]
    })(props);
}
function BiSolidShareAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12c0 1.654 1.346 3 3 3 .794 0 1.512-.315 2.049-.82l5.991 3.424c-.018.13-.04.26-.04.396 0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3c-.794 0-1.512.315-2.049.82L8.96 12.397c.018-.131.04-.261.04-.397s-.022-.266-.04-.397l5.991-3.423c.537.505 1.255.82 2.049.82 1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3c0 .136.022.266.04.397L8.049 9.82A2.982 2.982 0 0 0 6 9c-1.654 0-3 1.346-3 3z"
                }
            }
        ]
    })(props);
}
function BiSolidShare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6.914V2.586L6.293 7.293l-3.774 3.774 3.841 3.201L11 18.135V13.9c8.146-.614 11 4.1 11 4.1 0-2.937-.242-5.985-2.551-8.293C16.765 7.022 12.878 6.832 11 6.914z"
                }
            }
        ]
    })(props);
}
function BiSolidShieldAlt2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.881 5.223a.496.496 0 0 0-.747-.412c-.672.392-1.718.898-2.643.898-.421 0-.849-.064-1.289-.198a5.712 5.712 0 0 1-.808-.309c-1.338-.639-2.567-1.767-3.696-2.889a1.008 1.008 0 0 0-.698-.29 1.008 1.008 0 0 0-.698.29c-1.129 1.122-2.358 2.25-3.696 2.889h-.001a5.655 5.655 0 0 1-.807.309c-.44.134-.869.198-1.289.198-.925 0-1.971-.507-2.643-.898a.496.496 0 0 0-.747.412c-.061 1.538-.077 4.84.688 7.444 1.399 4.763 4.48 7.976 8.91 9.292l.14.041.14-.014V22v-.014H12l.143.014.14-.041c4.43-1.316 7.511-4.529 8.91-9.292.765-2.604.748-5.906.688-7.444z"
                }
            }
        ]
    })(props);
}
function BiSolidShieldMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.43 5.76-8-3.56a1 1 0 0 0-.82 0l-8 3.56a1 1 0 0 0-.59.9c0 2.37.44 10.8 8.51 15.11a1 1 0 0 0 1 0c8-4.3 8.58-12.71 8.57-15.1a1 1 0 0 0-.67-.91zm-4.43 7H8v-2h8z"
                }
            }
        ]
    })(props);
}
function BiSolidShieldPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.43 5.76-8-3.56a1 1 0 0 0-.82 0l-8 3.56a1 1 0 0 0-.59.9c0 2.37.44 10.8 8.51 15.11a1 1 0 0 0 1 0c8-4.3 8.58-12.71 8.57-15.1a1 1 0 0 0-.67-.91zm-4.43 7h-3v3h-2v-3H8v-2h3v-3h2v3h3z"
                }
            }
        ]
    })(props);
}
function BiSolidShieldX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.492 21.771c.294.157.663.157.957-.001 8.012-4.304 8.581-12.713 8.574-15.104a.988.988 0 0 0-.596-.903l-8.051-3.565a1.005 1.005 0 0 0-.813.001L3.57 5.765a.988.988 0 0 0-.592.891c-.034 2.379.445 10.806 8.514 15.115zM8.293 9.707l1.414-1.414L12 10.586l2.293-2.293 1.414 1.414L13.414 12l2.293 2.293-1.414 1.414L12 13.414l-2.293 2.293-1.414-1.414L10.586 12 8.293 9.707z"
                }
            }
        ]
    })(props);
}
function BiSolidShield(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.496 6.106-7.973-4a.997.997 0 0 0-.895-.002l-8.027 4c-.297.15-.502.437-.544.767-.013.097-1.145 9.741 8.541 15.008a.995.995 0 0 0 .969-.009c9.307-5.259 8.514-14.573 8.476-14.967a1 1 0 0 0-.547-.797z"
                }
            }
        ]
    })(props);
}
function BiSolidShip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.997 20c-.899 0-1.288-.311-1.876-.781-.68-.543-1.525-1.219-3.127-1.219-1.601 0-2.446.676-3.125 1.22-.587.469-.975.78-1.874.78-.897 0-1.285-.311-1.872-.78C4.444 18.676 3.601 18 2 18v2c.898 0 1.286.311 1.873.78.679.544 1.523 1.22 3.122 1.22 1.601 0 2.445-.676 3.124-1.219.588-.47.976-.781 1.875-.781.9 0 1.311.328 1.878.781.679.543 1.524 1.219 3.125 1.219s2.446-.676 3.125-1.219C20.689 20.328 21.1 20 22 20v-2c-1.602 0-2.447.676-3.127 1.219-.588.47-.977.781-1.876.781zM6 8.5 4 9l2 8h.995c1.601 0 2.445-.676 3.124-1.219.588-.47.976-.781 1.875-.781.9 0 1.311.328 1.878.781.679.543 1.524 1.219 3.125 1.219H18l.027-.107.313-1.252L20 9l-2-.5V5.001a1 1 0 0 0-.804-.981L13 3.181V2h-2v1.181l-4.196.839A1 1 0 0 0 6 5.001V8.5zm2-2.681 4-.8 4 .8V8l-4-1-4 1V5.819z"
                }
            }
        ]
    })(props);
}
function BiSolidShocked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-5 8.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 7 10.5zm5 7.5c-1.657 0-3-1.119-3-2.5s1.343-2.5 3-2.5 3 1.119 3 2.5-1.343 2.5-3 2.5zm3.493-6.014a1.494 1.494 0 1 1 .001-2.987 1.494 1.494 0 0 1-.001 2.987z"
                }
            }
        ]
    })(props);
}
function BiSolidShoppingBagAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H3a1 1 0 0 0-1 1v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V5a1 1 0 0 0-1-1zm-9 9c-3.309 0-6-2.691-6-6h2c0 2.206 1.794 4 4 4s4-1.794 4-4h2c0 3.309-2.691 6-6 6z"
                }
            }
        ]
    })(props);
}
function BiSolidShoppingBag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 22h14a2 2 0 0 0 2-2V9a1 1 0 0 0-1-1h-3v-.777c0-2.609-1.903-4.945-4.5-5.198A5.005 5.005 0 0 0 7 7v1H4a1 1 0 0 0-1 1v11a2 2 0 0 0 2 2zm12-12v2h-2v-2h2zM9 7c0-1.654 1.346-3 3-3s3 1.346 3 3v1H9V7zm-2 3h2v2H7v-2z"
                }
            }
        ]
    })(props);
}
function BiSolidShoppingBags(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 20h2V10a1 1 0 0 1 1-1h12V7a1 1 0 0 0-1-1h-3.051c-.252-2.244-2.139-4-4.449-4S6.303 3.756 6.051 6H3a1 1 0 0 0-1 1v11a2 2 0 0 0 2 2zm6.5-16c1.207 0 2.218.86 2.45 2h-4.9c.232-1.14 1.243-2 2.45-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11H9a1 1 0 0 0-1 1v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a1 1 0 0 0-1-1zm-6 7c-2.757 0-5-2.243-5-5h2c0 1.654 1.346 3 3 3s3-1.346 3-3h2c0 2.757-2.243 5-5 5z"
                }
            }
        ]
    })(props);
}
function BiSolidShow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5c-7.633 0-9.927 6.617-9.948 6.684L1.946 12l.105.316C2.073 12.383 4.367 19 12 19s9.927-6.617 9.948-6.684l.106-.316-.105-.316C21.927 11.617 19.633 5 12 5zm0 11c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c-1.084 0-2 .916-2 2s.916 2 2 2 2-.916 2-2-.916-2-2-2z"
                }
            }
        ]
    })(props);
}
function BiSolidShower(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 18.33A6.78 6.78 0 0 0 19.5 15a6.73 6.73 0 0 0-1.5 3.33 1.51 1.51 0 1 0 3 0zM11 20.33A6.78 6.78 0 0 0 9.5 17 6.73 6.73 0 0 0 8 20.33 1.59 1.59 0 0 0 9.5 22a1.59 1.59 0 0 0 1.5-1.67zM16 20.33A6.78 6.78 0 0 0 14.5 17a6.73 6.73 0 0 0-1.5 3.33A1.59 1.59 0 0 0 14.5 22a1.59 1.59 0 0 0 1.5-1.67zM6 18.33A6.78 6.78 0 0 0 4.5 15 6.73 6.73 0 0 0 3 18.33 1.59 1.59 0 0 0 4.5 20 1.59 1.59 0 0 0 6 18.33zM2 12h20v2H2zM13 4.07V2h-2v2.07A8 8 0 0 0 4.07 11h15.86A8 8 0 0 0 13 4.07z"
                }
            }
        ]
    })(props);
}
function BiSolidSkipNextCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm4 14h-2v-4l-6 4V8l6 4V8h2v8z"
                }
            }
        ]
    })(props);
}
function BiSolidSkipPreviousCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10c5.515 0 10-4.486 10-10S17.515 2 12 2zm4 14-6-4v4H8V8h2v4l6-4v8z"
                }
            }
        ]
    })(props);
}
function BiSolidSkull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C5.505 2 2 6.637 2 11c0 2.129 1.009 3.979 3 5.508V21h3v-3h2v3h4v-3h2v3h3v-4.493c1.991-1.528 3-3.379 3-5.507 0-4.363-3.505-9-10-9zM8 13c-1.121 0-2-1.098-2-2.5S6.879 8 8 8s2 1.098 2 2.5S9.121 13 8 13zm8 0c-1.121 0-2-1.098-2-2.5S14.879 8 16 8s2 1.098 2 2.5-.879 2.5-2 2.5z"
                }
            }
        ]
    })(props);
}
function BiSolidSleepy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-4 9.01-2-.02C6.017 9.386 7.095 7 10 7v2c-1.924 0-1.998 1.805-2 2.01zM12 18c-1.657 0-3-1.119-3-2.5s1.343-2.5 3-2.5 3 1.119 3 2.5-1.343 2.5-3 2.5zm5-7-1 .008C15.992 10.536 15.826 9 14 9V7c2.935 0 4 2.393 4 4h-1z"
                }
            }
        ]
    })(props);
}
function BiSolidSlideshow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h7v3H8v2h8v-2h-3v-3h7c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM10 13V7l5 3-5 3z"
                }
            }
        ]
    })(props);
}
function BiSolidSmile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.514 0 10-4.486 10-10S17.514 2 12 2 2 6.486 2 12s4.486 10 10 10zm3.493-13a1.494 1.494 0 1 1-.001 2.987A1.494 1.494 0 0 1 15.493 9zm-4.301 6.919a4.108 4.108 0 0 0 1.616 0c.253-.052.505-.131.75-.233.234-.1.464-.224.679-.368.208-.142.407-.306.591-.489.183-.182.347-.381.489-.592l1.658 1.117a6.027 6.027 0 0 1-1.619 1.621 6.003 6.003 0 0 1-2.149.904 6.116 6.116 0 0 1-2.414-.001 5.919 5.919 0 0 1-2.148-.903 6.078 6.078 0 0 1-1.621-1.622l1.658-1.117c.143.211.307.41.488.59a3.988 3.988 0 0 0 2.022 1.093zM8.5 9a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 8.5 9z"
                }
            }
        ]
    })(props);
}
function BiSolidSortAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.227 11h11.547c.862 0 1.32-1.02.747-1.665L12.748 2.84a.998.998 0 0 0-1.494 0L5.479 9.335C4.906 9.98 5.364 11 6.227 11zm5.026 10.159a.998.998 0 0 0 1.494 0l5.773-6.495c.574-.644.116-1.664-.747-1.664H6.227c-.862 0-1.32 1.02-.747 1.665l5.773 6.494z"
                }
            }
        ]
    })(props);
}
function BiSolidSpa(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16.114c-3.998-5.951-8.574-7.043-8.78-7.09L2 8.75V10c0 7.29 3.925 12 10 12 5.981 0 10-4.822 10-12V8.75l-1.22.274c-.206.047-4.782 1.139-8.78 7.09z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.274 3.767c-1.799 1.898-2.84 3.775-3.443 5.295 1.329.784 2.781 1.943 4.159 3.685 1.364-1.76 2.826-2.925 4.17-3.709-.605-1.515-1.646-3.383-3.435-5.271L12 3l-.726.767z"
                }
            }
        ]
    })(props);
}
function BiSolidSpeaker(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "15",
                    "r": "3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-6 2a2 2 0 1 1-2 2 2 2 0 0 1 2-2zm0 16a5 5 0 1 1 5-5 5 5 0 0 1-5 5z"
                }
            }
        ]
    })(props);
}
function BiSolidSprayCan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.003 3h2v2h-2zM16 3h2v2h-2zm0 3h2v2h-2zm3-3h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2zM4.012 12v9a1 1 0 0 0 1 1H13a1 1 0 0 0 1-1v-9a4 4 0 0 0-4-4H8.012a4 4 0 0 0-4 4zM7.003 2h4v4h-4z"
                }
            }
        ]
    })(props);
}
function BiSolidSpreadsheet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2zm7 2h8v2h-8V7zm0 4h8v2h-8v-2zm0 4h8v2h-8v-2zM6 7h2v2H6V7zm0 4h2v2H6v-2zm0 4h2v2H6v-2z"
                }
            }
        ]
    })(props);
}
function BiSolidSquareRounded(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2H7C4.243 2 2 4.243 2 7v10c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5V7c0-2.757-2.243-5-5-5z"
                }
            }
        ]
    })(props);
}
function BiSolidSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function BiSolidStarHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.025 20.775A.998.998 0 0 0 6 22a1 1 0 0 0 .555-.168L12 18.202l5.445 3.63a1.001 1.001 0 0 0 1.517-1.106l-1.829-6.4 4.536-4.082a1 1 0 0 0-.59-1.74l-5.701-.454-2.467-5.461a.998.998 0 0 0-1.822-.001L8.622 8.05l-5.701.453a1 1 0 0 0-.619 1.713l4.214 4.107-1.491 6.452zM12 5.429l2.042 4.521.588.047h.001l3.972.315-3.271 2.944-.001.002-.463.416.171.597v.003l1.253 4.385L12 15.798V5.429z"
                }
            }
        ]
    })(props);
}
function BiSolidStar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.947 9.179a1.001 1.001 0 0 0-.868-.676l-5.701-.453-2.467-5.461a.998.998 0 0 0-1.822-.001L8.622 8.05l-5.701.453a1 1 0 0 0-.619 1.713l4.213 4.107-1.49 6.452a1 1 0 0 0 1.53 1.057L12 18.202l5.445 3.63a1.001 1.001 0 0 0 1.517-1.106l-1.829-6.4 4.536-4.082c.297-.268.406-.686.278-1.065z"
                }
            }
        ]
    })(props);
}
function BiSolidSticker(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 11c-4.136 0-7.5 3.364-7.5 7.5 0 .871.157 1.704.432 2.482l9.551-9.551A7.462 7.462 0 0 0 18.5 11z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12c0 4.583 3.158 8.585 7.563 9.69A9.431 9.431 0 0 1 9 18.5C9 13.262 13.262 9 18.5 9c1.12 0 2.191.205 3.19.563C20.585 5.158 16.583 2 12 2z"
                }
            }
        ]
    })(props);
}
function BiSolidStopwatch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm1 8h-2V8h2v5zM9 2h6v2H9zm9.707 2.293 2 2-1.414 1.414-2-2z"
                }
            }
        ]
    })(props);
}
function BiSolidStoreAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5C3.346 2 2 3.346 2 5v2.831c0 1.053.382 2.01 1 2.746V20a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-5h4v5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-9.424c.618-.735 1-1.692 1-2.746V5c0-1.654-1.346-3-3-3zm1 3v2.831c0 1.14-.849 2.112-1.891 2.167L18 10c-1.103 0-2-.897-2-2V4h3c.552 0 1 .449 1 1zM10 8V4h4v4c0 1.103-.897 2-2 2s-2-.897-2-2zM4 5c0-.551.448-1 1-1h3v4c0 1.103-.897 2-2 2l-.109-.003C4.849 9.943 4 8.971 4 7.831V5zm6 11H6v-3h4v3z"
                }
            }
        ]
    })(props);
}
function BiSolidStore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.999 8a.997.997 0 0 0-.143-.515L19.147 2.97A2.01 2.01 0 0 0 17.433 2H6.565c-.698 0-1.355.372-1.714.971L2.142 7.485A.997.997 0 0 0 1.999 8c0 1.005.386 1.914 1 2.618V20a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-5h4v5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-9.382c.614-.704 1-1.613 1-2.618zm-2.016.251A2.002 2.002 0 0 1 17.999 10c-1.103 0-2-.897-2-2 0-.068-.025-.128-.039-.192l.02-.004L15.219 4h2.214l2.55 4.251zm-9.977-.186L10.818 4h2.361l.813 4.065C13.957 9.138 13.079 10 11.999 10s-1.958-.862-1.993-1.935zM6.565 4h2.214l-.76 3.804.02.004c-.015.064-.04.124-.04.192 0 1.103-.897 2-2 2a2.002 2.002 0 0 1-1.984-1.749L6.565 4zm3.434 12h-4v-3h4v3z"
                }
            }
        ]
    })(props);
}
function BiSolidSun(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.995 12c0 2.761 2.246 5.007 5.007 5.007s5.007-2.246 5.007-5.007-2.246-5.007-5.007-5.007S6.995 9.239 6.995 12zM11 19h2v3h-2zm0-17h2v3h-2zm-9 9h3v2H2zm17 0h3v2h-3zM5.637 19.778l-1.414-1.414 2.121-2.121 1.414 1.414zM16.242 6.344l2.122-2.122 1.414 1.414-2.122 2.122zM6.344 7.759 4.223 5.637l1.415-1.414 2.12 2.122zm13.434 10.605-1.414 1.414-2.122-2.122 1.414-1.414z"
                }
            }
        ]
    })(props);
}
function BiSolidSushi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12.07",
                    "cy": "7",
                    "rx": "3",
                    "ry": "1.71"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.07 22c4.48 0 8-2.2 8-5V7c0-2.8-3.52-5-8-5s-8 2.2-8 5v10c0 2.8 3.51 5 8 5zm0-18c3.53 0 6 1.58 6 3a2 2 0 0 1-.29.87c-.68 1-2.53 2-5 2.12h-1.39C8.88 9.83 7 8.89 6.35 7.84a2.16 2.16 0 0 1-.28-.76V7c0-1.42 2.46-3 6-3z"
                }
            }
        ]
    })(props);
}
function BiSolidTShirt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.316 4.055C19.556 3.478 15 1.985 15 2a3 3 0 1 1-6 0c0-.015-4.556 1.478-6.317 2.055A.992.992 0 0 0 2 5.003v3.716a1 1 0 0 0 1.242.97L6 9v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9l2.758.689A1 1 0 0 0 22 8.719V5.003a.992.992 0 0 0-.684-.948z"
                }
            }
        ]
    })(props);
}
function BiSolidTachometer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C6.486 4 2 8.486 2 14a9.89 9.89 0 0 0 1.051 4.445c.17.34.516.555.895.555h16.107c.379 0 .726-.215.896-.555A9.89 9.89 0 0 0 22 14c0-5.514-4.486-10-10-10zm5.022 5.022L13.06 15.06a1.53 1.53 0 0 1-2.121.44 1.53 1.53 0 0 1 0-2.561l6.038-3.962a.033.033 0 0 1 .045.01.034.034 0 0 1 0 .035z"
                }
            }
        ]
    })(props);
}
function BiSolidTagAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.868 11.504-4-7A1 1 0 0 0 17 4H3a1 1 0 0 0-.868 1.496L5.849 12l-3.717 6.504A1 1 0 0 0 3 20h14a1 1 0 0 0 .868-.504l4-7a.998.998 0 0 0 0-.992z"
                }
            }
        ]
    })(props);
}
function BiSolidTagX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.842 6.218a1.977 1.977 0 0 0-.424-.628A1.99 1.99 0 0 0 20 5H8c-.297 0-.578.132-.769.359l-5 6c-.309.371-.309.91 0 1.281l5 6c.191.228.472.36.769.36h12a1.977 1.977 0 0 0 1.41-.582A1.99 1.99 0 0 0 22 17V7c0-.266-.052-.525-.158-.782zm-4.135 8.075-1.414 1.414L14 13.414l-2.293 2.293-1.414-1.414L12.586 12l-2.293-2.293 1.414-1.414L14 10.586l2.293-2.293 1.414 1.414L15.414 12l2.293 2.293z"
                }
            }
        ]
    })(props);
}
function BiSolidTag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.842 6.218a1.977 1.977 0 0 0-.424-.628A1.99 1.99 0 0 0 20 5H8c-.297 0-.578.132-.769.359l-5 6c-.309.371-.309.91 0 1.281l5 6c.191.228.472.36.769.36h12a1.977 1.977 0 0 0 1.41-.582A1.99 1.99 0 0 0 22 17V7c0-.266-.052-.525-.158-.782z"
                }
            }
        ]
    })(props);
}
function BiSolidTaxi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.772 10.155-1.368-4.104A2.995 2.995 0 0 0 16.559 4H14V2h-4v2H7.441a2.995 2.995 0 0 0-2.845 2.051l-1.368 4.104A2 2 0 0 0 2 12v5c0 .738.404 1.376 1 1.723V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2h12v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2.277A1.99 1.99 0 0 0 22 17v-5a2 2 0 0 0-1.228-1.845zM7.441 6h9.117c.431 0 .813.274.949.684L18.613 10H5.387l1.105-3.316A1 1 0 0 1 7.441 6zM5.5 16a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 5.5 16zm13 0a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 18.5 16z"
                }
            }
        ]
    })(props);
}
function BiSolidTennisBall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.929 19.071a9.953 9.953 0 0 0 6.692 2.906c-.463-2.773.365-5.721 2.5-7.856 2.136-2.135 5.083-2.963 7.856-2.5-.092-2.433-1.053-4.839-2.906-6.692s-4.26-2.814-6.692-2.906c.463 2.773-.365 5.721-2.5 7.856-2.136 2.135-5.083 2.963-7.856 2.5a9.944 9.944 0 0 0 2.906 6.692z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.535 15.535a6.996 6.996 0 0 0-1.911 6.318 9.929 9.929 0 0 0 8.229-8.229 6.999 6.999 0 0 0-6.318 1.911zm-7.07-7.07a6.996 6.996 0 0 0 1.911-6.318 9.929 9.929 0 0 0-8.23 8.229 7 7 0 0 0 6.319-1.911z"
                }
            }
        ]
    })(props);
}
function BiSolidTerminal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM6.414 15.707 5 14.293 7.293 12 5 9.707l1.414-1.414L10.121 12l-3.707 3.707zM19 16h-7v-2h7v2z"
                }
            }
        ]
    })(props);
}
function BiSolidThermometer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16a3.001 3.001 0 0 0 6 0c0-.353-.072-.686-.184-1H9.184A2.962 2.962 0 0 0 9 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6V4h-3.185A2.995 2.995 0 0 0 12 2c-1.654 0-3 1.346-3 3v5.8A6.027 6.027 0 0 0 6 16c0 3.309 2.691 6 6 6s6-2.691 6-6a6.027 6.027 0 0 0-3-5.2V10h3V8h-3V6h3zm-4.405 6.324A4.033 4.033 0 0 1 16 16c0 2.206-1.794 4-4 4s-4-1.794-4-4c0-1.585.944-3.027 2.405-3.676l.595-.263V5a1 1 0 0 1 2 0v7.061l.595.263z"
                }
            }
        ]
    })(props);
}
function BiSolidTimeFive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm3.293 14.707L11 12.414V6h2v5.586l3.707 3.707-1.414 1.414z"
                }
            }
        ]
    })(props);
}
function BiSolidTime(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.25 2c-5.514 0-10 4.486-10 10s4.486 10 10 10 10-4.486 10-10-4.486-10-10-10zM18 13h-6.75V6h2v5H18v2z"
                }
            }
        ]
    })(props);
}
function BiSolidTimer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3h4v2h-4zM3 8h4v2H3zm0 8h4v2H3zm-1-4h3.99v2H2zm19.707-5.293-1.414-1.414L18.586 7A6.937 6.937 0 0 0 15 6c-3.859 0-7 3.141-7 7s3.141 7 7 7 7-3.141 7-7a6.968 6.968 0 0 0-1.855-4.73l1.562-1.563zM16 14h-2V8.958h2V14z"
                }
            }
        ]
    })(props);
}
function BiSolidTired(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-6.447 9.105 2.459-1.229-1.567-1.044 1.109-1.664 3 2a1 1 0 0 1-.108 1.727l-4 2-.893-1.79zM8 17s1-3 4-3 4 3 4 3H8zm9.553-4.105-4-2a1 1 0 0 1-.108-1.727l3-2 1.109 1.664-1.566 1.044 2.459 1.229-.894 1.79z"
                }
            }
        ]
    })(props);
}
function BiSolidToTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15h4v6h6v-6h4l-7-8zM4 3h16v2H4z"
                }
            }
        ]
    })(props);
}
function BiSolidToggleLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6H8c-3.296 0-5.982 2.682-6 5.986v.042A6.01 6.01 0 0 0 8 18h8a6.01 6.01 0 0 0 6-5.994v-.018C21.985 8.685 19.297 6 16 6zm-8 9c-1.627 0-3-1.373-3-3s1.373-3 3-3 3 1.373 3 3-1.373 3-3 3z"
                }
            }
        ]
    })(props);
}
function BiSolidToggleRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6H8c-3.296 0-5.982 2.682-6 5.986v.042A6.01 6.01 0 0 0 8 18h8c3.309 0 6-2.691 6-6s-2.691-6-6-6zm0 9c-1.627 0-3-1.373-3-3s1.373-3 3-3 3 1.373 3 3-1.373 3-3 3z"
                }
            }
        ]
    })(props);
}
function BiSolidTone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-1 9H4.069a7.965 7.965 0 0 1 .52-2H11v2zm0 4H4.589a7.965 7.965 0 0 1-.52-2H11v2zm0-10.931V7H5.765A7.996 7.996 0 0 1 11 4.069zM5.765 17H11v2.931A7.996 7.996 0 0 1 5.765 17z"
                }
            }
        ]
    })(props);
}
function BiSolidTorch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11.648V20a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-8.352c1.067-.552 3-1.928 3-4.648V5H5v2c0 2.72 1.933 4.096 3 4.648zM11 11h2v3h-2v-3zM5 2h14v2H5z"
                }
            }
        ]
    })(props);
}
function BiSolidTrafficBarrier(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6h-2V3h-2v3H7V3H5v3H3a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h2v6h2v-6h10v6h2v-6h2a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zM4.42 13l2.857-5H9.58l-2.857 5H4.42zm7.857-5h2.303l-2.857 5H9.42l2.857-5zm5 0h2.303l-2.857 5H14.42l2.857-5z"
                }
            }
        ]
    })(props);
}
function BiSolidTrafficCone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.649 16H5.352l-1.06 3H2v2h20v-2h-2.292zM6.057 14h11.886l-1.412-4H7.469zM13 2h-2a1 1 0 0 0-.943.667L8.175 8h7.65l-1.882-5.333A1 1 0 0 0 13 2z"
                }
            }
        ]
    })(props);
}
function BiSolidTraffic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m2.958 16 .043 1.042c.005.12.142 2.255 2.999 3.338v1.12a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-1.12c2.857-1.083 2.994-3.218 2.999-3.338L21.043 16H18v-1.62c2.857-1.083 2.994-3.218 2.999-3.338L21.043 10H18V8.38c2.857-1.083 2.994-3.218 2.999-3.338L21.043 4H18V2.5a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5V4H2.958l.043 1.042c.005.12.142 2.255 2.999 3.338V10H2.958l.043 1.042c.005.12.142 2.255 2.999 3.338V16H2.958zM12 4a2 2 0 1 1-.001 4.001A2 2 0 0 1 12 4zm0 6a2 2 0 1 1-.001 4.001A2 2 0 0 1 12 10zm0 6a2 2 0 1 1-.001 4.001A2 2 0 0 1 12 16z"
                }
            }
        ]
    })(props);
}
function BiSolidTrain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.375 2H7.621c-.224 0-1.399.065-2.503 1.351C4.031 4.616 4 5.862 4 6v11a2 2 0 0 0 2 2h1l-2 3h2.353l.667-1h8l.677 1H19l-2-3h1a2 2 0 0 0 2-2V6c.001-.188-.032-1.434-1.129-2.665C17.715 2.037 16.509 2 16.375 2zM10 4h4v2h-4V4zM7.5 17a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 7.5 17zm9 0a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 16.5 17zm1.5-5H6V8h12v4z"
                }
            }
        ]
    })(props);
}
function BiSolidTrashAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7H5v13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7H6zm10.618-3L15 2H9L7.382 4H3v2h18V4z"
                }
            }
        ]
    })(props);
}
function BiSolidTrash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7H5v13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7H6zm4 12H8v-9h2v9zm6 0h-2v-9h2v9zm.618-15L15 2H9L7.382 4H3v2h18V4z"
                }
            }
        ]
    })(props);
}
function BiSolidTreeAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m18 10-6-8-6 8h3l-5 8h7v4h2v-4h7l-5-8h3z"
                }
            }
        ]
    })(props);
}
function BiSolidTree(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20 18-4-5h3l-4-5h2l-5-6-5 6h2l-4 5h3l-4 5h7v4h2v-4z"
                }
            }
        ]
    })(props);
}
function BiSolidTrophy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4h-3V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v1H3a1 1 0 0 0-1 1v3c0 4.31 1.8 6.91 4.82 7A6 6 0 0 0 11 17.91V20H9v2h6v-2h-2v-2.09A6 6 0 0 0 17.18 15c3-.1 4.82-2.7 4.82-7V5a1 1 0 0 0-1-1zM4 8V6h2v6.83C4.22 12.08 4 9.3 4 8zm14 4.83V6h2v2c0 1.3-.22 4.08-2 4.83z"
                }
            }
        ]
    })(props);
}
function BiSolidTruck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.15 8a2 2 0 0 0-1.72-1H15V5a1 1 0 0 0-1-1H4a2 2 0 0 0-2 2v10a2 2 0 0 0 1 1.73 3.49 3.49 0 0 0 7 .27h3.1a3.48 3.48 0 0 0 6.9 0 2 2 0 0 0 2-2v-3a1.07 1.07 0 0 0-.14-.52zM15 9h2.43l1.8 3H15zM6.5 19A1.5 1.5 0 1 1 8 17.5 1.5 1.5 0 0 1 6.5 19zm10 0a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function BiSolidTv(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-5.586l2.293-2.293-1.414-1.414L12 5.586 8.707 2.293 7.293 3.707 9.586 6H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2z"
                }
            }
        ]
    })(props);
}
function BiSolidUniversalAccess(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 3.33A1.67 1.67 0 1 1 10.33 7 1.67 1.67 0 0 1 12 5.33zm3.33 12.5-1.66.84-1.39-3.89h-.56l-1.39 3.89-1.66-.84 1.66-4.72v-1.66L7 10.33l.56-1.66 3.33 1.11h2.22l3.33-1.11.56 1.66-3.33 1.12v1.66z"
                }
            }
        ]
    })(props);
}
function BiSolidUpArrowAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 18v-6h5l-6-7-6 7h5v6z"
                }
            }
        ]
    })(props);
}
function BiSolidUpArrowCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.514 0 10-4.486 10-10S17.514 2 12 2 2 6.486 2 12s4.486 10 10 10zm0-15 5 5h-4v5h-2v-5H7l5-5z"
                }
            }
        ]
    })(props);
}
function BiSolidUpArrowSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 21h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2zm7-14 5 5h-4v5h-2v-5H7l5-5z"
                }
            }
        ]
    })(props);
}
function BiSolidUpArrow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 19h18a1.002 1.002 0 0 0 .823-1.569l-9-13c-.373-.539-1.271-.539-1.645 0l-9 13A.999.999 0 0 0 3 19z"
                }
            }
        ]
    })(props);
}
function BiSolidUpsideDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM8.507 15a1.494 1.494 0 1 1 .001-2.987A1.494 1.494 0 0 1 8.507 15zm4.301-6.919a4.108 4.108 0 0 0-1.616 0 4.12 4.12 0 0 0-.751.233c-.234.1-.463.224-.678.368a4.077 4.077 0 0 0-1.08 1.082L7.024 8.646a6.026 6.026 0 0 1 2.639-2.175 6.097 6.097 0 0 1 1.128-.35 6.061 6.061 0 0 1 2.415 0 5.919 5.919 0 0 1 2.148.903 6.078 6.078 0 0 1 1.621 1.622l-1.658 1.117a3.994 3.994 0 0 0-.488-.59 3.988 3.988 0 0 0-2.021-1.092zM15.5 15a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 15.5 15z"
                }
            }
        ]
    })(props);
}
function BiSolidUpvote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 14h4v7a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-7h4a1.001 1.001 0 0 0 .781-1.625l-8-10c-.381-.475-1.181-.475-1.562 0l-8 10A1.001 1.001 0 0 0 4 14z"
                }
            }
        ]
    })(props);
}
function BiSolidUserAccount(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-6 2.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM19 15H9v-.25C9 12.901 11.254 11 14 11s5 1.901 5 3.75V15z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8H2v12c0 1.103.897 2 2 2h12v-2H4V8z"
                }
            }
        ]
    })(props);
}
function BiSolidUserBadge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.988 22a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h11.988zM9 5h6v2H9V5zm5.25 6.25A2.26 2.26 0 0 1 12 13.501c-1.235 0-2.25-1.015-2.25-2.251S10.765 9 12 9a2.259 2.259 0 0 1 2.25 2.25zM7.5 18.188c0-1.664 2.028-3.375 4.5-3.375s4.5 1.711 4.5 3.375v.563h-9v-.563z"
                }
            }
        ]
    })(props);
}
function BiSolidUserCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12.052c1.995 0 3.5-1.505 3.5-3.5s-1.505-3.5-3.5-3.5-3.5 1.505-3.5 3.5 1.505 3.5 3.5 3.5zM9 13H7c-2.757 0-5 2.243-5 5v1h12v-1c0-2.757-2.243-5-5-5zm11.294-4.708-4.3 4.292-1.292-1.292-1.414 1.414 2.706 2.704 5.712-5.702z"
                }
            }
        ]
    })(props);
}
function BiSolidUserCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.579 2 2 6.579 2 12s4.579 10 10 10 10-4.579 10-10S17.421 2 12 2zm0 5c1.727 0 3 1.272 3 3s-1.273 3-3 3c-1.726 0-3-1.272-3-3s1.274-3 3-3zm-5.106 9.772c.897-1.32 2.393-2.2 4.106-2.2h2c1.714 0 3.209.88 4.106 2.2C15.828 18.14 14.015 19 12 19s-3.828-.86-5.106-2.228z"
                }
            }
        ]
    })(props);
}
function BiSolidUserDetail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11h7v2h-7zm1 4h6v2h-6zm-2-8h8v2h-8zM4 19h10v-1c0-2.757-2.243-5-5-5H7c-2.757 0-5 2.243-5 5v1h2zm4-7c1.995 0 3.5-1.505 3.5-3.5S9.995 5 8 5 4.5 6.505 4.5 8.5 6.005 12 8 12z"
                }
            }
        ]
    })(props);
}
function BiSolidUserMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 11h8v2h-8zM4.5 8.552c0 1.995 1.505 3.5 3.5 3.5s3.5-1.505 3.5-3.5-1.505-3.5-3.5-3.5-3.5 1.505-3.5 3.5zM4 19h10v-1c0-2.757-2.243-5-5-5H7c-2.757 0-5 2.243-5 5v1h2z"
                }
            }
        ]
    })(props);
}
function BiSolidUserPin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h4l3 3 3-3h4a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-7 3c1.727 0 3 1.272 3 3s-1.273 3-3 3c-1.726 0-3-1.272-3-3s1.274-3 3-3zM7.177 16c.558-1.723 2.496-3 4.823-3s4.266 1.277 4.823 3H7.177z"
                }
            }
        ]
    })(props);
}
function BiSolidUserPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 8.552c0 1.995 1.505 3.5 3.5 3.5s3.5-1.505 3.5-3.5-1.505-3.5-3.5-3.5-3.5 1.505-3.5 3.5zM19 8h-2v3h-3v2h3v3h2v-3h3v-2h-3zM4 19h10v-1c0-2.757-2.243-5-5-5H7c-2.757 0-5 2.243-5 5v1h2z"
                }
            }
        ]
    })(props);
}
function BiSolidUserRectangle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22h13a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h1zm6-17.001c1.647 0 3 1.351 3 3C15 9.647 13.647 11 12 11S9 9.647 9 7.999c0-1.649 1.353-3 3-3zM6 17.25c0-2.219 2.705-4.5 6-4.5s6 2.281 6 4.5V18H6v-.75z"
                }
            }
        ]
    })(props);
}
function BiSolidUserVoice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12.052c1.995 0 3.5-1.505 3.5-3.5s-1.505-3.5-3.5-3.5-3.5 1.505-3.5 3.5 1.505 3.5 3.5 3.5zM9 13H7c-2.757 0-5 2.243-5 5v1h12v-1c0-2.757-2.243-5-5-5zm9.364-10.364L16.95 4.05C18.271 5.373 19 7.131 19 9s-.729 3.627-2.05 4.95l1.414 1.414C20.064 13.663 21 11.403 21 9s-.936-4.663-2.636-6.364z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.535 5.464 14.121 6.88C14.688 7.445 15 8.198 15 9s-.312 1.555-.879 2.12l1.414 1.416C16.479 11.592 17 10.337 17 9s-.521-2.592-1.465-3.536z"
                }
            }
        ]
    })(props);
}
function BiSolidUserX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12.052c1.995 0 3.5-1.505 3.5-3.5s-1.505-3.5-3.5-3.5-3.5 1.505-3.5 3.5 1.505 3.5 3.5 3.5zM9 13H7c-2.757 0-5 2.243-5 5v1h12v-1c0-2.757-2.243-5-5-5zm11.293-4.707L18 10.586l-2.293-2.293-1.414 1.414 2.292 2.292-2.293 2.293 1.414 1.414 2.293-2.293 2.294 2.294 1.414-1.414L19.414 12l2.293-2.293z"
                }
            }
        ]
    })(props);
}
function BiSolidUser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 6.5C7.5 8.981 9.519 11 12 11s4.5-2.019 4.5-4.5S14.481 2 12 2 7.5 4.019 7.5 6.5zM20 21h1v-1c0-3.859-3.141-7-7-7h-4c-3.86 0-7 3.141-7 7v1h17z"
                }
            }
        ]
    })(props);
}
function BiSolidVector(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.277 8c.347.596.985 1 1.723 1a2 2 0 0 0 0-4c-.738 0-1.376.404-1.723 1H16V4a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v2H5.723C5.376 5.404 4.738 5 4 5a2 2 0 0 0 0 4c.738 0 1.376-.404 1.723-1H8v.368C5.134 9.839 4.319 12.534 4.092 14H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.877c.197-.959.718-2.406 2.085-3.418A.984.984 0 0 0 9 11h6a.98.98 0 0 0 .792-.419c1.373 1.013 1.895 2.458 2.089 3.419H17a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-1.092c-.227-1.466-1.042-4.161-3.908-5.632V8h2.277zM14 9h-4V5h4v4z"
                }
            }
        ]
    })(props);
}
function BiSolidVial(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7 22a4.965 4.965 0 0 0 3.535-1.465l9.193-9.193.707.708 1.414-1.414-8.485-8.486-1.414 1.414.708.707-9.193 9.193C2.521 14.408 2 15.664 2 17s.521 2.592 1.465 3.535A4.965 4.965 0 0 0 7 22zM18.314 9.928 15.242 13H6.758l7.314-7.314 4.242 4.242z"
                }
            }
        ]
    })(props);
}
function BiSolidVideoOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19h10.879L2.145 6.265A1.977 1.977 0 0 0 2 7v10c0 1.103.897 2 2 2zM18 7c0-1.103-.897-2-2-2H6.414L3.707 2.293 2.293 3.707l18 18 1.414-1.414L18 16.586v-2.919L22 17V7l-4 3.333V7z"
                }
            }
        ]
    })(props);
}
function BiSolidVideoPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3.333L22 17V7l-4 3.333V7zm-4 6h-3v3H9v-3H6v-2h3V8h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function BiSolidVideoRecording(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9c0-1.103-.897-2-2-2h-1.434l-2.418-4.029A2.008 2.008 0 0 0 10.434 2H5v2h5.434l1.8 3H4c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-3l4 2v-7l-4 2V9zm-7 8H5v-2h6v2z"
                }
            }
        ]
    })(props);
}
function BiSolidVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-3.333L22 17V7l-4 3.333V7z"
                }
            }
        ]
    })(props);
}
function BiSolidVideos(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8H2v12a2 2 0 0 0 2 2h12v-2H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-9 12V6l7 4z"
                }
            }
        ]
    })(props);
}
function BiSolidVirusBlock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.952 17.538c-.749-.749-.908-1.869-.5-2.846l.021-.049c.399-.974 1.309-1.643 2.362-1.643h.08c.638 0 1.085-.447 1.085-1s-.447-1-1-1h-.17c-1.053 0-1.958-.669-2.357-1.644l-.021-.049c-.408-.977-.249-2.097.5-2.846l.119-.119a.999.999 0 1 0-1.414-1.414l-.119.119c-.749.749-1.869.908-2.846.5l-.049-.021C13.669 5.128 13 4.218 13 3.165v-.081C13 2.447 12.553 2 12 2s-1 .447-1 1v.036c0 1.096-.66 2.084-1.673 2.503l-.006.003a2.71 2.71 0 0 1-2.953-.588l-.025-.025-2.636-2.636-1.414 1.414 18 18 1.414-1.414-2.636-2.636-.119-.119zM12 10a2 2 0 1 1 2 2c-.257 0-.501-.053-.728-.142l-1.131-1.131A1.998 1.998 0 0 1 12 10zm-4 3a1 1 0 0 1-1-1 .99.99 0 0 1 .244-.635L5.431 9.552A2.634 2.634 0 0 1 3.085 11h-.001C2.447 11 2 11.447 2 12s.447 1 1 1h.068a2.66 2.66 0 0 1 2.459 1.644l.021.049a2.69 2.69 0 0 1-.583 2.929l-.036.036a.999.999 0 1 0 1.414 1.414l.036-.036a2.689 2.689 0 0 1 2.929-.583l.143.06A2.505 2.505 0 0 1 11 20.83v.085c0 .638.447 1.085 1 1.085s1-.448 1-1v-.17c0-.976.568-1.853 1.443-2.266l-5.809-5.809A.98.98 0 0 1 8 13z"
                }
            }
        ]
    })(props);
}
function BiSolidVirus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11h-.17c-1.053 0-1.958-.669-2.357-1.644l-.021-.049c-.408-.977-.249-2.097.5-2.846l.119-.119a.999.999 0 1 0-1.414-1.414l-.119.119c-.749.749-1.869.908-2.846.5l-.049-.021C13.669 5.128 13 4.218 13 3.165v-.081C13 2.447 12.553 2 12 2s-1 .447-1 1v.036c0 1.096-.66 2.084-1.673 2.503l-.006.003a2.71 2.71 0 0 1-2.953-.588l-.025-.025a.999.999 0 1 0-1.414 1.414l.036.036a2.69 2.69 0 0 1 .583 2.929l-.027.064A2.638 2.638 0 0 1 3.085 11h-.001C2.447 11 2 11.447 2 12s.447 1 1 1h.068a2.66 2.66 0 0 1 2.459 1.644l.021.049a2.69 2.69 0 0 1-.583 2.929l-.036.036a.999.999 0 1 0 1.414 1.414l.036-.036a2.689 2.689 0 0 1 2.929-.583l.143.06A2.505 2.505 0 0 1 11 20.83v.085c0 .638.447 1.085 1 1.085s1-.448 1-1v-.17c0-1.015.611-1.93 1.55-2.318l.252-.104a2.508 2.508 0 0 1 2.736.545l.119.119a.999.999 0 1 0 1.414-1.414l-.119-.119c-.749-.749-.908-1.869-.5-2.846l.021-.049c.399-.975 1.309-1.644 2.362-1.644h.08c.638 0 1.085-.447 1.085-1s-.447-1-1-1zM8 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm5 3.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm1-4.5a2 2 0 1 1 .001-4.001A2 2 0 0 1 14 12z"
                }
            }
        ]
    })(props);
}
function BiSolidVolumeFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21c3.527-1.547 5.999-4.909 5.999-9S19.527 4.547 16 3v2c2.387 1.386 3.999 4.047 3.999 7S18.387 17.614 16 19v2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7v10c1.225-1.1 2-3.229 2-5s-.775-3.9-2-5zM4 17h2.697L14 21.868V2.132L6.697 7H4c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2z"
                }
            }
        ]
    })(props);
}
function BiSolidVolumeLow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 17h2.697L14 21.868V2.132L6.697 7H4c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2zM16 7v10c1.225-1.1 2-3.229 2-5s-.775-3.9-2-5z"
                }
            }
        ]
    })(props);
}
function BiSolidVolumeMute(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m7.727 6.313-4.02-4.02-1.414 1.414 18 18 1.414-1.414-2.02-2.02A9.578 9.578 0 0 0 21.999 12c0-4.091-2.472-7.453-5.999-9v2c2.387 1.386 3.999 4.047 3.999 7a8.13 8.13 0 0 1-1.671 4.914l-1.286-1.286C17.644 14.536 18 13.19 18 12c0-1.771-.775-3.9-2-5v7.586l-2-2V2.132L7.727 6.313zM4 17h2.697L14 21.868v-3.747L3.102 7.223A1.995 1.995 0 0 0 2 9v6c0 1.103.897 2 2 2z"
                }
            }
        ]
    })(props);
}
function BiSolidVolume(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 17h2.697L14 21.868V2.132L6.697 7H4c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2z"
                }
            }
        ]
    })(props);
}
function BiSolidWalletAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9h8v6h-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H5C3.346 3 2 4.346 2 6v12c0 1.654 1.346 3 3 3h15c1.103 0 2-.897 2-2v-2h-8c-1.103 0-2-.897-2-2V9c0-1.103.897-2 2-2h8V5c0-1.103-.897-2-2-2z"
                }
            }
        ]
    })(props);
}
function BiSolidWallet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7V5c0-1.103-.897-2-2-2H5C3.346 3 2 4.346 2 6v12c0 2.201 1.794 3 3 3h15c1.103 0 2-.897 2-2V9c0-1.103-.897-2-2-2zm-2 9h-2v-4h2v4zM5 7a1.001 1.001 0 0 1 0-2h13v2H5z"
                }
            }
        ]
    })(props);
}
function BiSolidWasher(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22h16a1 1 0 0 0 1-1V5c0-1.654-1.346-3-3-3H6C4.346 2 3 3.346 3 5v16a1 1 0 0 0 1 1zM18 3.924a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM12 7c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.766 16.929c1.399-.261 2.571-1.315 3.023-2.665a3.853 3.853 0 0 0-.153-2.893.482.482 0 0 0-.544-.266c-.604.149-1.019.448-1.5.801-.786.577-1.765 1.294-3.592 1.294-.813 0-1.45-.146-1.984-.354l-.013.009a4.006 4.006 0 0 0 4.763 4.074z"
                }
            }
        ]
    })(props);
}
function BiSolidWatchAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8c0-.909-.613-1.67-1.445-1.912l-1.31-3.443A1 1 0 0 0 14.311 2H8.689a1 1 0 0 0-.934.645l-1.31 3.443A1.996 1.996 0 0 0 5 8v8c0 .909.613 1.67 1.445 1.912l1.31 3.443a1 1 0 0 0 .934.645h5.621c.415 0 .787-.257.935-.645l1.31-3.443A1.996 1.996 0 0 0 18 16v-2h1v-4h-1V8zm-1.998 8H7V8h9l.002 8z"
                }
            }
        ]
    })(props);
}
function BiSolidWatch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8h-2v5h5v-2h-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.999 12c0-2.953-1.612-5.53-3.999-6.916V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v2.083C5.613 6.469 4.001 9.047 4.001 12a8.003 8.003 0 0 0 4.136 7H8v2.041a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V19h-.139a8 8 0 0 0 4.138-7zm-8 5.999A6.005 6.005 0 0 1 6.001 12a6.005 6.005 0 0 1 5.998-5.999c3.31 0 6 2.691 6 5.999a6.005 6.005 0 0 1-6 5.999z"
                }
            }
        ]
    })(props);
}
function BiSolidWebcam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4.963 0-9 4.037-9 9 0 3.328 1.82 6.232 4.513 7.79l-2.067 1.378A1 1 0 0 0 6 22h12a1 1 0 0 0 .555-1.832l-2.067-1.378C19.18 17.232 21 14.328 21 11c0-4.963-4.037-9-9-9zm0 16c-3.859 0-7-3.141-7-7s3.141-7 7-7 7 3.141 7 7-3.141 7-7 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zm-1.5 5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 10.5 11z"
                }
            }
        ]
    })(props);
}
function BiSolidWidget(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm0 10h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm10 0h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zm7.293-14.707-3.586-3.586a.999.999 0 0 0-1.414 0l-3.586 3.586a.999.999 0 0 0 0 1.414l3.586 3.586a.999.999 0 0 0 1.414 0l3.586-3.586a.999.999 0 0 0 0-1.414z"
                }
            }
        ]
    })(props);
}
function BiSolidWindowAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm-3 3h2v2h-2V6zm-3 0h2v2h-2V6zM4 19v-9h16.001l.001 9H4z"
                }
            }
        ]
    })(props);
}
function BiSolidWine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 17.916V20H9v2h6v-2h-2v-2.084c3.162-.402 5.849-2.66 6.713-5.793.264-.952.312-2.03.143-3.206l-.866-6.059A1 1 0 0 0 18 2H6a1 1 0 0 0-.99.858l-.865 6.058c-.169 1.177-.121 2.255.143 3.206.863 3.134 3.55 5.392 6.712 5.794zM17.133 4l.57 4H6.296l.571-4h10.266z"
                }
            }
        ]
    })(props);
}
function BiSolidWinkSmile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM8.5 9a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 8.5 9zm7.741 7.244a5.982 5.982 0 0 1-3.034 1.634 6.042 6.042 0 0 1-3.541-.349 5.997 5.997 0 0 1-2.642-2.176l1.658-1.117c.143.211.307.41.488.59a3.988 3.988 0 0 0 1.273.86c.243.102.495.181.749.232a4.108 4.108 0 0 0 1.616 0c.253-.052.505-.131.75-.233.234-.1.464-.224.679-.368.208-.142.407-.306.591-.489.183-.182.347-.381.489-.592l1.658 1.117c-.214.32-.461.62-.734.891zM13 12s.5-2 2.5-2c1.999 0 2.5 2 2.5 2h-5z"
                }
            }
        ]
    })(props);
}
function BiSolidWinkTongue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 19v-4h-4v4c0 1.103.897 2 2 2s2-.897 2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12c0 4.434 2.903 8.198 6.906 9.505A3.969 3.969 0 0 1 8 19v-2.499C6.412 15.027 6 13 6 13h12s-.411 2.027-2 3.501V19c0 .953-.349 1.816-.906 2.504C19.097 20.197 22 16.434 22 12c0-5.514-4.486-10-10-10zm-3.5 9a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8.5 11zm4.5 0s.5-2 2.5-2c1.999 0 2.5 2 2.5 2h-5z"
                }
            }
        ]
    })(props);
}
function BiSolidWrench(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.512 6.112-3.89 3.889-3.535-3.536 3.889-3.889a6.501 6.501 0 0 0-8.484 8.486l-6.276 6.275a.999.999 0 0 0 0 1.414l2.122 2.122a.999.999 0 0 0 1.414 0l6.275-6.276a6.501 6.501 0 0 0 7.071-1.414 6.504 6.504 0 0 0 1.414-7.071z"
                }
            }
        ]
    })(props);
}
function BiSolidXCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm4.207 12.793-1.414 1.414L12 13.414l-2.793 2.793-1.414-1.414L10.586 12 7.793 9.207l1.414-1.414L12 10.586l2.793-2.793 1.414 1.414L13.414 12l2.793 2.793z"
                }
            }
        ]
    })(props);
}
function BiSolidXSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5zm-4.793 9.793-1.414 1.414L12 13.414l-2.793 2.793-1.414-1.414L10.586 12 7.793 9.207l1.414-1.414L12 10.586l2.793-2.793 1.414 1.414L13.414 12l2.793 2.793z"
                }
            }
        ]
    })(props);
}
function BiSolidYinYang(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.062 4.938A9.942 9.942 0 0 0 12.016 2h-.026a9.94 9.94 0 0 0-7.071 2.938c-3.898 3.898-3.898 10.243 0 14.143 1.895 1.895 4.405 2.938 7.071 2.938s5.177-1.043 7.071-2.938c3.9-3.899 3.9-10.243.001-14.143zM13.5 15a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 13.5 15zM6.333 6.353A7.953 7.953 0 0 1 11.99 4l.026.001c1.652.008 3.242 1.066 3.55 2.371.366 1.552-1.098 3.278-4.018 4.737-5.113 2.555-5.312 5.333-4.975 6.762l.008.021c-.082-.075-.169-.146-.249-.226-3.118-3.119-3.118-8.194.001-11.313z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "7.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function BiSolidZap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.98 11.802a.995.995 0 0 0-.738-.771l-6.86-1.716 2.537-5.921a.998.998 0 0 0-.317-1.192.996.996 0 0 0-1.234.024l-11 9a1 1 0 0 0 .39 1.744l6.719 1.681-3.345 5.854A1.001 1.001 0 0 0 8 22a.995.995 0 0 0 .6-.2l12-9a1 1 0 0 0 .38-.998z"
                }
            }
        ]
    })(props);
}
function BiSolidZoomIn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2c-4.411 0-8 3.589-8 8s3.589 8 8 8a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8zm4 9h-3v3H9v-3H6V9h3V6h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function BiSolidZoomOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8zM6 9h8v2H6V9z"
                }
            }
        ]
    })(props);
}
function BiLogo500Px(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.379 14.791c.004.01.098.269.151.396a5.859 5.859 0 0 0 1.258 1.865 5.86 5.86 0 0 0 6.437 1.259 5.876 5.876 0 0 0 3.124-3.125 5.802 5.802 0 0 0 .461-2.285c0-.793-.153-1.563-.461-2.287a5.862 5.862 0 0 0-1.257-1.864 5.86 5.86 0 0 0-4.152-1.72 6 6 0 0 0-2.318.461c-.57.241-1.536.862-2.102 1.446l-.002.002V4.107h8.117c.295-.003.295-.417.295-.55 0-.137 0-.549-.296-.553H7.857a.387.387 0 0 0-.388.384v6.801c0 .221.273.379.527.434.496.104.61-.053.732-.222l.015-.021c.187-.275.767-.858.771-.863a4.776 4.776 0 0 1 3.406-1.403 4.76 4.76 0 0 1 3.394 1.403 4.75 4.75 0 0 1 1.408 3.385c0 1.28-.498 2.483-1.4 3.385a4.858 4.858 0 0 1-3.416 1.403 4.656 4.656 0 0 1-2.42-.668l.004-4.137c0-.552.238-1.151.64-1.604a2.351 2.351 0 0 1 1.778-.803c.667 0 1.291.254 1.754.714.46.455.714 1.064.714 1.711a2.443 2.443 0 0 1-2.474 2.466c-.268 0-.753-.117-.773-.123-.281-.084-.4.305-.439.435-.151.492.077.59.122.604.448.138.741.164 1.124.164a3.555 3.555 0 0 0 3.551-3.553c0-1.943-1.592-3.526-3.548-3.526a3.59 3.59 0 0 0-2.536 1.033c-.644.632-1.013 1.478-1.013 2.317v.021c-.004.105-.004 2.583-.005 3.398l-.005-.006c-.368-.407-.731-1.029-.973-1.668-.097-.25-.309-.206-.601-.116-.127.04-.514.159-.429.438l.002.004zm4.172-.972c.002.118.111.223.175.286l.021.019c.111.11.217.164.315.164.081 0 .13-.037.148-.054.05-.046.604-.608.658-.662l.618.618c.058.064.12.097.192.098.1 0 .207-.058.32-.174.267-.272.134-.42.069-.49l-.628-.63.655-.658c.144-.155.017-.32-.111-.446-.183-.184-.359-.23-.474-.127l-.65.652-.657-.658a.183.183 0 0 0-.128-.051c-.087 0-.191.06-.308.177-.202.201-.246.341-.141.453l.657.656-.653.655a.247.247 0 0 0-.078.172m1.434-8.891c-1.053 0-2.171.211-2.992.566a.23.23 0 0 0-.151.205c-.011.093.013.216.076.377.051.131.187.478.449.376a7.566 7.566 0 0 1 2.618-.498c.96 0 1.892.188 2.768.558.696.296 1.354.721 2.068 1.341a.243.243 0 0 0 .165.068c.138 0 .271-.137.386-.266.191-.214.321-.392.135-.569a7.674 7.674 0 0 0-2.354-1.52 8.088 8.088 0 0 0-3.168-.638m5.668 12.986c-.127-.126-.235-.199-.33-.228a.24.24 0 0 0-.247.059l-.063.062a7.07 7.07 0 0 1-5.018 2.081 7.09 7.09 0 0 1-5.02-2.081 6.794 6.794 0 0 1-1.521-2.255 7.618 7.618 0 0 1-.462-1.596c-.004-.018-.005-.031-.009-.041-.044-.232-.257-.249-.564-.202-.127.019-.517.078-.479.358l.002.006a8.104 8.104 0 0 0 2.288 4.478 8.089 8.089 0 0 0 2.59 1.747 8.093 8.093 0 0 0 3.175.642 8.062 8.062 0 0 0 3.172-.643 8.129 8.129 0 0 0 2.658-1.813c.083-.09.154-.248-.172-.574"
                }
            }
        ]
    })(props);
}
function BiLogo99Designs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.93 10.61A2.7 2.7 0 0 0 19 10a2.74 2.74 0 0 0-1.1-.19 3.28 3.28 0 0 0-2.16.76v-.05a3.67 3.67 0 0 0-5.09-3.39 3.61 3.61 0 0 0-1.78 1.56 3.67 3.67 0 0 0-3.12-1.86 3.74 3.74 0 0 0-1.82.44 3.66 3.66 0 0 0-1.37 1.28A3.77 3.77 0 0 0 2 10.34a3.67 3.67 0 0 0 3.42 3.83l-1.6 2.76h2.39l2.65-4.59a3.63 3.63 0 0 0 2.93 1.84l-1.59 2.76h2.4l1.86-3.23a3.53 3.53 0 0 0 2.07 3.19 3.52 3.52 0 0 0 2.61.05 2.58 2.58 0 0 0 .9-.74v.73h2V7.06h-2.11zm-12.78.72a1.69 1.69 0 0 1-1.46.83 1.72 1.72 0 0 1-.86-.16 1.75 1.75 0 0 1-.62-.62 1.78 1.78 0 0 1-.21-.87 1.69 1.69 0 0 1 1.67-1.69 1.63 1.63 0 0 1 .84.23 1.58 1.58 0 0 1 .62.61 1.62 1.62 0 0 1 .23.83 1.72 1.72 0 0 1-.21.84zm6.38 0a1.58 1.58 0 0 1-.62.61 1.53 1.53 0 0 1-.84.22 1.78 1.78 0 0 1-.84-.22 1.65 1.65 0 0 1-.61-.62 1.67 1.67 0 0 1 0-1.69 1.73 1.73 0 0 1 .62-.61 1.63 1.63 0 0 1 .84-.23 1.69 1.69 0 0 1 .84.23 1.69 1.69 0 0 1 .63 2.28zm6.3 3a1.72 1.72 0 0 1-2 .85 1.72 1.72 0 0 1-1-.7 1.75 1.75 0 0 1-.29-1.15 1.77 1.77 0 0 1 .51-1.07 1.75 1.75 0 0 1 2.35-.11 1.73 1.73 0 0 1 .43 2.18z"
                }
            }
        ]
    })(props);
}
function BiLogoAdobe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19.966V4.034h-6.654zM3 4.034v15.932L9.658 4.034zM9.092 16.76h3.104l1.268 3.205h2.778L12.003 9.904z"
                }
            }
        ]
    })(props);
}
function BiLogoAirbnb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 16.709c-1.013-1.271-1.609-2.386-1.808-3.34-.197-.769-.12-1.385.218-1.848.357-.532.89-.791 1.589-.791s1.231.259 1.589.796c.335.458.419 1.075.215 1.848-.218.974-.813 2.087-1.808 3.341l.005-.006zm7.196.855c-.14.934-.775 1.708-1.65 2.085-1.687.734-3.359-.437-4.789-2.026 2.365-2.961 2.803-5.268 1.787-6.758-.596-.855-1.449-1.271-2.544-1.271-2.206 0-3.419 1.867-2.942 4.034.276 1.173 1.013 2.506 2.186 3.996-.735.813-1.432 1.391-2.047 1.748-.478.258-.934.418-1.37.456-2.008.299-3.582-1.647-2.867-3.656.1-.259.297-.734.634-1.471l.019-.039c1.097-2.382 2.43-5.088 3.961-8.09l.039-.1.435-.836c.338-.616.477-.892 1.014-1.231.258-.157.576-.235.934-.235.715 0 1.271.418 1.511.753.118.18.259.419.436.716l.419.815.06.119c1.53 3.001 2.863 5.702 3.955 8.089l.02.019.401.915.237.573c.183.459.221.915.16 1.393l.001.002zm.913-1.791c-.139-.438-.378-.953-.675-1.569v-.022a262.99 262.99 0 0 0-3.976-8.128l-.084-.121C14.486 4.109 13.849 3.014 12 3.014c-1.827 0-2.604 1.27-3.397 2.922l-.061.119c-1.251 2.426-2.564 5.128-3.975 8.13v.039l-.418.914c-.158.378-.237.575-.259.636C2.878 18.556 4.964 21 7.489 21c.021 0 .099 0 .198-.021h.278c1.313-.159 2.664-.993 4.035-2.485 1.371 1.49 2.725 2.326 4.033 2.485h.279c.1.021.18.021.2.021 2.525.002 4.61-2.444 3.598-5.227z"
                }
            }
        ]
    })(props);
}
function BiLogoAlgolia(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.177 9.059a3.582 3.582 0 0 0-3.576 3.584 3.584 3.584 0 0 0 3.576 3.585 3.578 3.578 0 0 0 3.575-3.585 3.582 3.582 0 0 0-3.575-3.584zm2.518 2.268-2.366 1.229c-.07.039-.153-.017-.153-.093V9.791h.001c0-.06.054-.104.109-.104a2.943 2.943 0 0 1 2.452 1.492c.028.055.011.121-.043.148z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.578 3H5.361A2.363 2.363 0 0 0 3 5.366v13.277a2.368 2.368 0 0 0 2.361 2.371h13.217a2.367 2.367 0 0 0 2.361-2.372V5.372A2.368 2.368 0 0 0 18.578 3zm-8.112 3.404a.78.78 0 0 1 .779-.781h1.815c.43 0 .778.35.778.781v.618a.106.106 0 0 1-.131.104 5.677 5.677 0 0 0-3.106.017c-.07.016-.136-.033-.136-.104v-.635zM7.08 8.993a.78.78 0 0 1 .001-1.103l.371-.371.002-.002a.776.776 0 0 1 1.099.002l.31.311c.043.05.038.127-.017.159a5.82 5.82 0 0 0-1.296 1.3c-.044.049-.114.06-.163.011l-.306-.306-.001-.001zm5.097 8.737a5.078 5.078 0 0 1-5.074-5.087c0-2.813 2.272-5.092 5.074-5.092a5.074 5.074 0 0 1 5.074 5.086c0 2.815-2.272 5.093-5.074 5.093z"
                }
            }
        ]
    })(props);
}
function BiLogoAmazon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.027 17.023c.061-.098.156-.105.289-.02 3.035 1.76 6.338 2.645 9.906 2.645 2.381 0 4.73-.447 7.051-1.332l.262-.117c.115-.051.195-.084.244-.109.189-.074.326-.037.438.109.102.143.076.279-.1.4-.213.158-.5.342-.84.545-1.037.619-2.203 1.098-3.492 1.441a14.815 14.815 0 0 1-3.77.508c-1.889 0-3.68-.33-5.369-.99a14.875 14.875 0 0 1-4.531-2.797c-.084-.061-.125-.123-.125-.184 0-.039.016-.074.041-.109l-.004.01zm5.479-5.189c0-.84.207-1.555.619-2.152.414-.592.977-1.041 1.703-1.346.666-.281 1.465-.48 2.43-.602.326-.037.861-.086 1.6-.145v-.31c0-.773-.084-1.299-.248-1.564-.252-.359-.65-.541-1.203-.541h-.15c-.4.039-.746.162-1.039.383a1.51 1.51 0 0 0-.564.916c-.049.25-.172.387-.361.426l-2.105-.264c-.209-.051-.311-.15-.311-.326 0-.037.006-.074.018-.123.209-1.078.715-1.881 1.52-2.404.814-.514 1.752-.814 2.828-.875h.451c1.379 0 2.469.361 3.244 1.076.115.123.227.25.34.398.1.139.188.264.234.377.063.111.127.275.164.475.051.213.088.352.113.426.023.086.051.25.064.514.006.262.016.41.016.461v4.406c0 .314.049.602.137.865.088.26.174.451.262.563l.428.561a.598.598 0 0 1 .111.303c0 .102-.049.188-.148.26-1.002.877-1.553 1.352-1.639 1.428-.137.113-.313.125-.525.039a5.397 5.397 0 0 1-.439-.414l-.258-.291c-.051-.063-.141-.174-.266-.352l-.25-.363c-.676.74-1.338 1.205-2.002 1.393-.414.125-.914.188-1.529.188-.926 0-1.701-.285-2.303-.863-.598-.576-.9-1.389-.9-2.453l-.043-.063.001-.007zm3.131-.367c0 .475.117.852.355 1.139.236.285.563.428.965.428.035 0 .088-.008.16-.018.078-.012.111-.02.141-.02.512-.133.902-.461 1.189-.982a2.62 2.62 0 0 0 .299-.758c.076-.268.1-.494.111-.666.016-.166.016-.453.016-.84v-.451c-.703 0-1.24.049-1.604.148-1.063.303-1.604.977-1.604 2.029l-.029-.016v.007zm7.646 5.865c.025-.051.063-.092.109-.143.301-.201.596-.342.877-.416a6.597 6.597 0 0 1 1.344-.201c.117-.01.234 0 .346.025.539.051.873.141.977.273.053.078.074.191.074.328v.125c0 .426-.117.926-.348 1.502s-.553 1.041-.963 1.402c-.061.049-.115.074-.164.074-.025 0-.051 0-.074-.01-.076-.037-.09-.1-.055-.201.451-1.051.672-1.787.672-2.201 0-.127-.025-.227-.074-.289-.119-.137-.457-.217-1.02-.217a9.42 9.42 0 0 0-.727.039c-.303.041-.582.078-.834.115-.074 0-.123-.014-.15-.037-.025-.025-.031-.039-.018-.064 0-.014.006-.025.018-.053v-.049l.01-.002z"
                }
            }
        ]
    })(props);
}
function BiLogoAndroid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.344 8.71c-.707 0-1.279.572-1.279 1.278v4.53a1.278 1.278 0 1 0 2.558 0v-4.53c0-.706-.572-1.278-1.279-1.278zm-12.688 0c-.707 0-1.279.572-1.279 1.278v4.53a1.278 1.278 0 1 0 2.558 0v-4.53A1.277 1.277 0 0 0 5.656 8.71zm8.889-3.809.768-1.388a.343.343 0 0 0-.133-.47.344.344 0 0 0-.471.135l-.789 1.42c-.588-.235-1.236-.368-1.92-.368s-1.332.132-1.92.367l-.789-1.418a.344.344 0 0 0-.471-.135.345.345 0 0 0-.133.47l.768 1.388C8.072 5.69 7.148 7.099 7.148 8.71c0 .011 0 .021.002.034-.002.006-.002.013-.002.019v.001h9.703V8.71c.001-1.611-.923-3.019-2.306-3.809zM9.76 6.869a.346.346 0 1 1 .005-.693.346.346 0 0 1-.005.693zm4.48 0a.347.347 0 0 1 0-.692.346.346 0 0 1 0 .692zM7.148 16.12c0 .646.525 1.171 1.174 1.171h.586v2.401a1.279 1.279 0 0 0 2.558 0v-2.401h1.066v2.401c0 .707.572 1.278 1.277 1.278.709 0 1.281-.571 1.281-1.278v-2.401h.586c.648 0 1.174-.524 1.174-1.171V9.028H7.148v7.092z"
                }
            }
        ]
    })(props);
}
function BiLogoAngular(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.483 12.482h3.034L12 8.831z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3.074 3.689 6.038l1.268 10.987 7.043 3.9 7.043-3.9 1.268-10.987L12 3.074zm5.187 13.621H15.25l-1.045-2.606h-4.41L8.75 16.695H6.813L12 5.047l5.187 11.648z"
                }
            }
        ]
    })(props);
}
function BiLogoApple(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.665 16.811a10.316 10.316 0 0 1-1.021 1.837c-.537.767-.978 1.297-1.316 1.592-.525.482-1.089.73-1.692.744-.432 0-.954-.123-1.562-.373-.61-.249-1.17-.371-1.683-.371-.537 0-1.113.122-1.73.371-.616.25-1.114.381-1.495.393-.577.025-1.154-.229-1.729-.764-.367-.32-.826-.87-1.377-1.648-.59-.829-1.075-1.794-1.455-2.891-.407-1.187-.611-2.335-.611-3.447 0-1.273.275-2.372.826-3.292a4.857 4.857 0 0 1 1.73-1.751 4.65 4.65 0 0 1 2.34-.662c.46 0 1.063.142 1.81.422s1.227.422 1.436.422c.158 0 .689-.167 1.593-.498.853-.307 1.573-.434 2.163-.384 1.6.129 2.801.759 3.6 1.895-1.43.867-2.137 2.08-2.123 3.637.012 1.213.453 2.222 1.317 3.023a4.33 4.33 0 0 0 1.315.863c-.106.307-.218.6-.336.882zM15.998 2.38c0 .95-.348 1.838-1.039 2.659-.836.976-1.846 1.541-2.941 1.452a2.955 2.955 0 0 1-.021-.36c0-.913.396-1.889 1.103-2.688.352-.404.8-.741 1.343-1.009.542-.264 1.054-.41 1.536-.435.013.128.019.255.019.381z"
                }
            }
        ]
    })(props);
}
function BiLogoAudible(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.005 10.238v1.69l10.002 6.254 9.988-6.254v-1.69l-9.988 6.229z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m15.938 12.469 1.465-.938c-1.161-1.701-3.153-2.876-5.396-2.876-2.257 0-4.236 1.135-5.371 2.89.093-.093.146-.146.238-.211 2.811-2.336 6.86-1.808 9.064 1.135z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.051 13.063a2.99 2.99 0 0 1 1.78-.58c1.083 0 2.047.554 2.692 1.49l1.399-.871c-.607-.963-1.688-1.557-2.916-1.557-1.226 0-2.309.62-2.955 1.518zM5.25 9.012c4.117-3.246 9.937-2.362 13.037 1.953l.026.026 1.517-.938a9.337 9.337 0 0 0-7.823-4.235 9.35 9.35 0 0 0-7.825 4.235c.304-.342.686-.751 1.068-1.041z"
                }
            }
        ]
    })(props);
}
function BiLogoAws(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.75 11.35a4.32 4.32 0 0 1-.79-.08 3.9 3.9 0 0 1-.73-.23l-.17-.04h-.12q-.15 0-.15.21v.33a.43.43 0 0 0 0 .19.5.5 0 0 0 .21.19 3 3 0 0 0 .76.26 4.38 4.38 0 0 0 1 .12 3 3 0 0 0 1-.14 1.94 1.94 0 0 0 .73-.37 1.81 1.81 0 0 0 .49-.58 1.79 1.79 0 0 0 .17-.78 1.54 1.54 0 0 0-.3-.93 2.15 2.15 0 0 0-1-.64l-.95-.3a2 2 0 0 1-.73-.36.65.65 0 0 1-.2-.47.66.66 0 0 1 .31-.6 1.82 1.82 0 0 1 .89-.18 2.89 2.89 0 0 1 1.27.26.79.79 0 0 0 .26.08c.1 0 .15-.08.15-.22v-.36a.38.38 0 0 0-.06-.22.56.56 0 0 0-.2-.16 1.55 1.55 0 0 0-.28-.12 3.44 3.44 0 0 0-.38-.11l-.44-.1A3.4 3.4 0 0 0 19 6a2.82 2.82 0 0 0-.83.11 2.19 2.19 0 0 0-.7.35A1.61 1.61 0 0 0 17 7a1.5 1.5 0 0 0-.18.74 1.6 1.6 0 0 0 .33 1 2.08 2.08 0 0 0 1.06.68l1 .3a1.58 1.58 0 0 1 .67.34.66.66 0 0 1 .18.47.72.72 0 0 1-.35.63 1.83 1.83 0 0 1-.96.19zM12.94 6.5a.48.48 0 0 0-.13-.26.37.37 0 0 0-.26-.07H12a.43.43 0 0 0-.26.07.42.42 0 0 0-.13.26l-1 4.4-1.14-4.4a.48.48 0 0 0-.14-.26s-.13-.07-.26-.07h-.65c-.11 0-.16.06-.16.17a1.22 1.22 0 0 0 .06.27l1.56 5.14A.61.61 0 0 0 10 12a.45.45 0 0 0 .26.06h.57a.49.49 0 0 0 .27-.06.57.57 0 0 0 .12-.27l1-4.28 1 4.29a.42.42 0 0 0 .12.26.4.4 0 0 0 .27.07h.57a.41.41 0 0 0 .25-.07.44.44 0 0 0 .14-.26l1.61-5.14a.73.73 0 0 0 0-.16.52.52 0 0 0 0-.11.15.15 0 0 0-.17-.17h-.62a.45.45 0 0 0-.26.07.68.68 0 0 0-.13.26L14 11zM5.77 8.63a5.92 5.92 0 0 0-.71-.05 2.42 2.42 0 0 0-1.63.52 1.72 1.72 0 0 0-.6 1.37 1.7 1.7 0 0 0 .49 1.28 1.82 1.82 0 0 0 1.33.48 2.48 2.48 0 0 0 2-.92 3.5 3.5 0 0 0 .2.39 2.34 2.34 0 0 0 .24.31.26.26 0 0 0 .37 0l.42-.28a.28.28 0 0 0 .13-.2.27.27 0 0 0 0-.16 3.63 3.63 0 0 1-.21-.47 2 2 0 0 1-.07-.6V8.19a2.2 2.2 0 0 0-.55-1.64A2.42 2.42 0 0 0 5.33 6a3.9 3.9 0 0 0-1 .13 3.9 3.9 0 0 0-.84.3.47.47 0 0 0-.18.14.37.37 0 0 0 0 .23v.33c0 .14 0 .2.14.2a.26.26 0 0 0 .11 0l.23-.08A4.32 4.32 0 0 1 4.42 7a3 3 0 0 1 .72-.09 1.5 1.5 0 0 1 1.08.31 1.46 1.46 0 0 1 .31 1.06v.49zm.78.9v.27a2.36 2.36 0 0 1-.07.58 1.06 1.06 0 0 1-.23.43 1.38 1.38 0 0 1-.63.42 2.12 2.12 0 0 1-.68.12.94.94 0 0 1-.7-.24.92.92 0 0 1-.24-.71.92.92 0 0 1 .33-.76 1.52 1.52 0 0 1 1-.27h.62a5.67 5.67 0 0 1 .6.16zM19.76 15a19.68 19.68 0 0 1-7.55 1.54 20 20 0 0 1-9.9-2.62c-.24-.15-.43.1-.22.29A14.68 14.68 0 0 0 12 18a14.4 14.4 0 0 0 8.1-2.47c.34-.31.03-.72-.34-.53z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.38 14.06c-.19.14-.16.33.05.3.71-.09 2.28-.27 2.56.09s-.31 1.83-.58 2.49c-.08.2.1.28.28.13a3.9 3.9 0 0 0 1.23-3.34 3.94 3.94 0 0 0-3.54.33z"
                }
            }
        ]
    })(props);
}
function BiLogoBaidu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.217 12.486c1.964-.422 1.693-2.772 1.637-3.287-.096-.788-1.028-2.172-2.291-2.061-1.588.141-1.821 2.44-1.821 2.44-.216 1.06.515 3.33 2.475 2.908m3.646-3.944c1.084 0 1.959-1.251 1.959-2.792 0-1.537-.871-2.785-1.955-2.785-1.086 0-1.966 1.242-1.966 2.785s.88 2.792 1.965 2.792m4.671.186c1.454.195 2.38-1.355 2.568-2.53.188-1.166-.754-2.528-1.776-2.763-1.031-.237-2.303 1.411-2.431 2.484-.136 1.318.188 2.627 1.634 2.813m5.751 1.973c0-.562-.46-2.253-2.19-2.253-1.729 0-1.965 1.596-1.965 2.726 0 1.077.089 2.573 2.247 2.528 2.148-.052 1.913-2.438 1.913-3.002M18.1 15.626s-2.247-1.739-3.557-3.613c-1.776-2.768-4.304-1.64-5.144-.239-.845 1.418-2.153 2.306-2.339 2.544-.188.232-2.709 1.596-2.147 4.079.563 2.483 2.528 2.439 2.528 2.439s1.446.142 3.133-.234c1.686-.375 3.13.091 3.13.091s3.92 1.317 5.005-1.212c1.072-2.537-.61-3.847-.61-3.847"
                }
            }
        ]
    })(props);
}
function BiLogoBehance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.803 5.731c.589 0 1.119.051 1.605.155.483.103.895.273 1.243.508.343.235.611.547.804.939.187.387.28.871.28 1.443 0 .62-.14 1.138-.421 1.551-.283.414-.7.753-1.256 1.015.757.219 1.318.602 1.69 1.146.374.549.557 1.206.557 1.976 0 .625-.119 1.162-.358 1.613a3.11 3.11 0 0 1-.974 1.114 4.315 4.315 0 0 1-1.399.64 6.287 6.287 0 0 1-1.609.206H2V5.731h5.803zm-.351 4.972c.48 0 .878-.114 1.192-.345.312-.228.463-.604.463-1.119 0-.286-.051-.522-.151-.707a1.114 1.114 0 0 0-.417-.428 1.683 1.683 0 0 0-.597-.215 3.609 3.609 0 0 0-.697-.061H4.71v2.875h2.742zm.151 5.239c.267 0 .521-.023.76-.077.241-.052.455-.136.637-.261.182-.12.332-.283.44-.491.109-.206.162-.475.162-.798 0-.634-.179-1.085-.533-1.358-.355-.27-.831-.404-1.414-.404H4.71v3.39h2.893zm8.565-.041c.367.358.896.538 1.584.538.493 0 .919-.125 1.278-.373.354-.249.57-.515.653-.79h2.155c-.346 1.072-.871 1.838-1.589 2.299-.709.463-1.572.693-2.58.693-.702 0-1.334-.113-1.9-.337a4.033 4.033 0 0 1-1.439-.958 4.37 4.37 0 0 1-.905-1.485 5.433 5.433 0 0 1-.32-1.899c0-.666.111-1.289.329-1.864a4.376 4.376 0 0 1 .934-1.493c.405-.42.885-.751 1.444-.994a4.634 4.634 0 0 1 1.858-.362c.754 0 1.413.146 1.979.44a3.967 3.967 0 0 1 1.39 1.182c.363.493.622 1.058.783 1.691.161.632.217 1.292.171 1.983h-6.431c.001.704.238 1.371.606 1.729zm2.812-4.681c-.291-.322-.783-.496-1.385-.496-.391 0-.714.065-.974.199a1.97 1.97 0 0 0-.62.491 1.772 1.772 0 0 0-.328.628 2.82 2.82 0 0 0-.111.587h3.982c-.058-.624-.272-1.085-.564-1.409zm-3.918-4.663h4.989v1.215h-4.989z"
                }
            }
        ]
    })(props);
}
function BiLogoBing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m5.71 3 3.593 1.264v12.645l5.061-2.919-2.48-1.165-1.566-3.897 7.974 2.802v4.073l-8.984 5.183-3.595-2L5.71 3z"
                }
            }
        ]
    })(props);
}
function BiLogoBitcoin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m11.953 8.819-.547 2.19c.619.154 2.529.784 2.838-.456.322-1.291-1.673-1.579-2.291-1.734zm-.822 3.296-.603 2.415c.743.185 3.037.921 3.376-.441.355-1.422-2.029-1.789-2.773-1.974z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.421 2.299C9.064.964 3.641 4.224 2.306 9.581.97 14.936 4.23 20.361 9.583 21.697c5.357 1.335 10.783-1.924 12.117-7.281 1.336-5.356-1.924-10.781-7.279-12.117zm1.991 8.275c-.145.974-.686 1.445-1.402 1.611.985.512 1.485 1.298 1.009 2.661-.592 1.691-1.998 1.834-3.87 1.48l-.454 1.82-1.096-.273.447-1.794a44.624 44.624 0 0 1-.875-.228l-.449 1.804-1.095-.275.454-1.823c-.257-.066-.517-.136-.782-.202L6.87 15l.546-1.256s.808.215.797.199c.311.077.448-.125.502-.261l.719-2.875.115.029a.864.864 0 0 0-.114-.037l.512-2.053c.013-.234-.066-.528-.511-.639.018-.011-.797-.198-.797-.198l.291-1.172 1.514.378-.001.005c.227.057.461.111.7.165l.449-1.802 1.097.273-.44 1.766c.294.067.591.135.879.207l.438-1.755 1.097.273-.449 1.802c1.384.479 2.396 1.195 2.198 2.525z"
                }
            }
        ]
    })(props);
}
function BiLogoBlender(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.427 13.011c.037-.667.363-1.254.856-1.671a2.855 2.855 0 0 1 1.844-.66c.71 0 1.36.25 1.845.66.492.417.819 1.005.856 1.671.038.686-.237 1.323-.721 1.795a2.829 2.829 0 0 1-1.979.782 2.83 2.83 0 0 1-1.981-.782c-.483-.472-.759-1.109-.72-1.795z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.124 14.361c.005.26.089.767.213 1.164a6.156 6.156 0 0 0 1.328 2.299 6.833 6.833 0 0 0 2.323 1.667 7.465 7.465 0 0 0 3.05.635 7.495 7.495 0 0 0 3.051-.645 6.913 6.913 0 0 0 2.321-1.675 6.196 6.196 0 0 0 1.326-2.303 5.76 5.76 0 0 0 .25-1.285 5.942 5.942 0 0 0-.888-3.594 6.496 6.496 0 0 0-1.545-1.703l.001-.001-6.249-4.799-.016-.014c-.411-.314-1.101-.313-1.551.002-.457.319-.508.846-.104 1.18l-.001.001 2.606 2.121-7.943.009h-.012c-.656 0-1.287.432-1.412.976-.128.555.318 1.015 1.001 1.017l-.001.003 4.027-.008-7.188 5.516-.027.021c-.677.519-.896 1.382-.47 1.929.434.556 1.354.556 2.04.002l3.922-3.209c.001 0-.056.433-.052.694zm10.078 1.45c-.808.824-1.938 1.291-3.163 1.293-1.226.002-2.356-.461-3.165-1.283a3.739 3.739 0 0 1-.864-1.352 3.503 3.503 0 0 1-.199-1.511c.044-.505.193-.987.434-1.422.236-.429.562-.815.962-1.144a4.477 4.477 0 0 1 2.832-.988 4.478 4.478 0 0 1 2.832.98c.399.326.725.711.961 1.139.24.436.39.916.434 1.421a3.52 3.52 0 0 1-.198 1.511 3.804 3.804 0 0 1-.866 1.356z"
                }
            }
        ]
    })(props);
}
function BiLogoBlogger(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.954 10.667c-.072-.322-.272-.621-.502-.745-.07-.039-.522-.088-1.004-.109-.809-.036-.898-.052-1.152-.201-.405-.237-.516-.493-.518-1.187-.002-1.327-.554-2.559-1.646-3.67-.776-.793-1.645-1.329-2.634-1.629-.236-.072-.768-.097-2.545-.118-2.787-.033-3.405.024-4.356.402-1.748.697-3.008 2.166-3.465 4.05-.087.353-.103.92-.124 4.177-.025 4.08.004 4.68.258 5.488.212.668.425 1.077.861 1.657.835 1.108 2.083 1.907 3.334 2.133.595.107 7.931.135 8.683.032 1.306-.178 2.331-.702 3.293-1.684.694-.71 1.129-1.479 1.414-2.499.117-.424.127-.63.149-3.117.017-1.878.002-2.758-.046-2.98zM8.007 8.108c.313-.316.399-.329 2.364-.329 1.764 0 1.822.004 2.081.134.375.189.538.456.538.88 0 .384-.153.653-.493.869-.184.115-.293.123-2.021.133-1.067.007-1.916-.013-2.043-.048-.669-.184-.918-1.143-.426-1.639zm7.706 8.037-.597.098-3.114.035c-2.736.033-3.511-.018-3.652-.08-.288-.124-.554-.472-.602-.78-.042-.292.104-.696.33-.9.285-.257.409-.266 3.911-.27 3.602-.002 3.583-.003 3.925.315.482.45.381 1.251-.201 1.582z"
                }
            }
        ]
    })(props);
}
function BiLogoBootstrap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.002 2.997H5.999A3.011 3.011 0 0 0 2.997 6v12.002a3.012 3.012 0 0 0 3.002 3.001h12.003a3.012 3.012 0 0 0 3.001-3.001V6a3.012 3.012 0 0 0-3.001-3.003zm-1.64 12.647c-.152.36-.389.68-.693.927a3.594 3.594 0 0 1-1.206.614c-.49.151-1.074.229-1.75.229H7.888V6.909h5.103c.943 0 1.7.213 2.267.646.569.436.854 1.082.854 1.958 0 .528-.13.983-.389 1.357-.259.373-.63.664-1.111.868v.034c.642.135 1.137.438 1.464.912.327.473.493 1.069.493 1.789 0 .405-.078.788-.225 1.147l.02.021v.003zm-2.084-2.589c-.309-.282-.739-.419-1.297-.419H9.737v3.276h3.253c.554 0 .991-.144 1.298-.435.308-.289.464-.701.464-1.229-.005-.518-.156-.919-.464-1.193h-.014.004zm-.451-2.119c.299-.251.444-.613.444-1.084 0-.526-.131-.902-.397-1.116-.264-.214-.646-.326-1.146-.326H9.727v2.898h3.001c.436.001.81-.127 1.099-.372z"
                }
            }
        ]
    })(props);
}
function BiLogoCPlusPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.66 7a1.51 1.51 0 0 0-.55-.57l-7.34-4.24a1.67 1.67 0 0 0-1.54 0L3.89 6.43a1.68 1.68 0 0 0-.77 1.33v8.48a1.57 1.57 0 0 0 .22.76 1.51 1.51 0 0 0 .55.57l7.34 4.24a1.67 1.67 0 0 0 1.54 0l7.34-4.24a1.51 1.51 0 0 0 .55-.57 1.57 1.57 0 0 0 .22-.76V7.76a1.57 1.57 0 0 0-.22-.76zM12 17.92A5.92 5.92 0 1 1 17.13 9L16 9.71l-.36.2-1 .61A3 3 0 0 0 9 12a2.88 2.88 0 0 0 .4 1.48 3 3 0 0 0 5.13 0l2.6 1.52A5.94 5.94 0 0 1 12 17.92zm5.92-5.59h-.66V13h-.65v-.66H16v-.66h.66V11h.65v.66h.66zm2.47 0h-.66V13h-.66v-.66h-.65v-.66h.65V11h.66v.66h.66z"
                }
            }
        ]
    })(props);
}
function BiLogoChrome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.742 2.04c-1.404.183-3.06.808-4.281 1.626-1.01.664-2.397 2.02-2.309 2.251.193.501 3.28 5.658 3.33 5.562.038-.067.095-.279.123-.49.25-1.385 1.425-2.704 2.897-3.253.568-.221.683-.221 5.495-.27l4.917-.047-.395-.646c-1.385-2.26-3.522-3.819-6.197-4.512-.731-.193-2.81-.318-3.58-.22z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.2 7.217c-.453.799-.983 2.415-1.107 3.358-.588 4.273 1.568 8.4 5.379 10.315.894.452 2.174.885 2.732.933l.356.029 1.674-2.838c.915-1.559 1.655-2.849 1.636-2.868-.02-.019-.231.039-.481.125-1.569.53-3.387.086-4.57-1.116-.424-.424-1.002-1.357-2.84-4.542C4.71 8.41 3.642 6.601 3.603 6.601c-.028 0-.211.279-.403.616z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.15 8.804c1.222 1.242 1.655 3.003 1.116 4.59-.086.26-1.212 2.271-2.501 4.485-1.29 2.203-2.349 4.031-2.349 4.06 0 .115 1.328.057 2.175-.087 4.32-.74 7.573-4.002 8.265-8.276.26-1.558.164-2.925-.307-4.503l-.25-.837h-6.707l.557.568z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.608 8.563C9.598 8.987 8.905 9.7 8.53 10.71c-.173.453-.202.713-.173 1.424.03.75.068.963.347 1.511.366.75.962 1.329 1.751 1.703.462.221.654.25 1.54.25.895 0 1.077-.029 1.559-.26.712-.326 1.462-1.077 1.79-1.79.23-.48.259-.663.259-1.558 0-.886-.029-1.078-.25-1.54-.375-.788-.952-1.386-1.703-1.75-.568-.28-.742-.318-1.56-.348-.788-.019-.99.01-1.48.212z"
                }
            }
        ]
    })(props);
}
function BiLogoCodepen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.838 8.445c0-.001-.001-.001 0 0l-.003-.004-.001-.001v-.001a.809.809 0 0 0-.235-.228l-9.164-6.08a.834.834 0 0 0-.898 0L2.371 8.214A.786.786 0 0 0 2 8.897v6.16a.789.789 0 0 0 .131.448v.001l.002.002.01.015v.002h.001l.001.001.001.001c.063.088.14.16.226.215l9.165 6.082a.787.787 0 0 0 .448.139.784.784 0 0 0 .45-.139l9.165-6.082a.794.794 0 0 0 .371-.685v-6.16a.793.793 0 0 0-.133-.452zm-9.057-4.172 6.953 4.613-3.183 2.112-3.771-2.536V4.273zm-1.592 0v4.189l-3.771 2.536-3.181-2.111 6.952-4.614zm-7.595 6.098 2.395 1.59-2.395 1.611v-3.201zm7.595 9.311-6.96-4.617 3.195-2.15 3.765 2.498v4.269zm.795-5.653-3.128-2.078 3.128-2.105 3.131 2.105-3.131 2.078zm.797 5.653v-4.27l3.766-2.498 3.193 2.15-6.959 4.618zm7.597-6.11-2.396-1.611 2.396-1.59v3.201z"
                }
            }
        ]
    })(props);
}
function BiLogoCreativeCommons(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.354 6.479a10.021 10.021 0 0 0-7.421-4.429c-3.108-.294-6.031.771-8.123 2.963C3.533 6.35 2.699 7.839 2.21 9.66c-.217.805-.247 1.104-.244 2.396.002 1.293.034 1.599.255 2.432a10.232 10.232 0 0 0 7.451 7.332c.315.078.702.16.859.182.696.097 2.381.056 3.131-.075 3.088-.538 5.832-2.531 7.24-5.258 1.644-3.181 1.426-7.222-.548-10.19zm-.41 7.688c-.808 2.99-3.263 5.272-6.361 5.912-4.831.997-9.538-2.658-9.839-7.641-.194-3.217 1.755-6.446 4.745-7.863 1.133-.536 2.045-.733 3.425-.738 1.327-.004 2.064.132 3.223.596 2.324.931 4.146 3.04 4.816 5.573.281 1.06.276 3.103-.009 4.161z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.042 14.955c-.915-.324-1.616-1.275-1.74-2.36-.183-1.607.422-2.856 1.654-3.415.669-.303 1.882-.296 2.603.016.438.19 1.261.933 1.261 1.139 0 .033-.284.201-.631.372l-.632.312-.337-.337c-.187-.188-.475-.363-.649-.396-.433-.082-.952.111-1.187.44-.389.546-.415 1.972-.048 2.533.191.291.512.494.813.518.635.05.796-.006 1.172-.401l.379-.398.488.269c.269.148.527.305.575.347.164.148-.592.92-1.199 1.224-.517.259-.679.293-1.358.286-.425-.006-.949-.074-1.164-.149zm5.816 0c-.901-.32-1.591-1.241-1.739-2.325-.215-1.569.419-2.888 1.654-3.45.717-.324 1.934-.3 2.661.056.45.221 1.201.911 1.201 1.104 0 .034-.295.203-.654.377l-.654.317-.341-.37c-.304-.332-.385-.369-.802-.369-.576 0-.945.225-1.145.698-.18.423-.201 1.461-.043 1.934.324.961 1.505 1.188 2.175.419l.304-.346.58.294c.32.161.582.319.582.352 0 .219-.75.918-1.256 1.17-.517.259-.679.293-1.358.287-.425-.005-.949-.073-1.165-.148z"
                }
            }
        ]
    })(props);
}
function BiLogoCss3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.192 3.143h15.615l-1.42 16.034-6.404 1.812-6.369-1.813L4.192 3.143zM16.9 6.424l-9.8-.002.158 1.949 7.529.002-.189 2.02H9.66l.179 1.913h4.597l-.272 2.62-2.164.598-2.197-.603-.141-1.569h-1.94l.216 2.867L12 17.484l3.995-1.137.905-9.923z"
                }
            }
        ]
    })(props);
}
function BiLogoDailymotion(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.551 11.485a2.327 2.327 0 0 0-2.328 2.332c0 1.314 1.013 2.313 2.441 2.313l-.012.002c1.192 0 2.193-.983 2.193-2.28.001-1.349-1.001-2.367-2.294-2.367z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v18h18V3H3zm15.52 15.605h-2.682v-1.058c-.825.81-1.667 1.103-2.786 1.103-1.142 0-2.124-.371-2.947-1.114-1.086-.956-1.648-2.227-1.648-3.701 0-1.351.524-2.561 1.507-3.506.878-.859 1.946-1.298 3.139-1.298 1.14 0 2.018.385 2.647 1.192V6.118l2.77-.574v-.002l.002.003h-.002v13.06z"
                }
            }
        ]
    })(props);
}
function BiLogoDeezer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.68 5.47H22V8h-4.32zm0 3.51H22v2.53h-4.32zm0 3.51H22v2.53h-4.32zM2 16h4.32v2.53H2zm5.22 0h4.32v2.53H7.22zm5.23 0h4.32v2.53h-4.32zm5.23 0H22v2.53h-4.32zm-5.23-3.51h4.32v2.53h-4.32zm-5.23 0h4.32v2.53H7.22zm0-3.51h4.32v2.53H7.22z"
                }
            }
        ]
    })(props);
}
function BiLogoDevTo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.826 10.083a.784.784 0 0 0-.468-.175h-.701v4.198h.701a.786.786 0 0 0 .469-.175c.155-.117.233-.292.233-.525v-2.798c.001-.233-.079-.408-.234-.525zM19.236 3H4.764C3.791 3 3.002 3.787 3 4.76v14.48c.002.973.791 1.76 1.764 1.76h14.473c.973 0 1.762-.787 1.764-1.76V4.76A1.765 1.765 0 0 0 19.236 3zM9.195 13.414c0 .755-.466 1.901-1.942 1.898H5.389V8.665h1.903c1.424 0 1.902 1.144 1.903 1.899v2.85zm4.045-3.562H11.1v1.544h1.309v1.188H11.1v1.543h2.142v1.188h-2.498a.813.813 0 0 1-.833-.792V9.497a.813.813 0 0 1 .792-.832h2.539l-.002 1.187zm4.165 4.632c-.531 1.235-1.481.99-1.906 0l-1.548-5.818h1.309l1.193 4.569 1.188-4.569h1.31l-1.546 5.818z"
                }
            }
        ]
    })(props);
}
function BiLogoDeviantart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.57 3h-3.271l-.326.33-1.544 2.942-.486.327H6.432v4.495h3.03l.27.327-3.3 6.305v3.273h3.272l.327-.33 1.543-2.943.486-.326h5.511v-4.495h-3.03l-.269-.329 3.299-6.303L17.57 3z"
                }
            }
        ]
    })(props);
}
function BiLogoDigg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.803 8.8v6.801h3.2v.799h-3.2v1.602h5.2V8.8h-5.2zm-6 0v6.801h3.199v.799h-3.199v1.602h5.199V8.8h-5.199zM5.2 5.999V8.8H2v6.801h5.201V5.999H5.2zM10.001 8.8h-2v6.801h2V8.8zM20.003 14h-1.2v-3.601h1.2V14zM5.2 14H4v-3.601h1.2V14zm8.802 0h-1.2v-3.601h1.2V14zm-4.001-8.001h-2v2h2v-2z"
                }
            }
        ]
    })(props);
}
function BiLogoDigitalocean(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.005 21.992v-3.877c4.104 0 7.288-4.068 5.714-8.388a5.81 5.81 0 0 0-3.457-3.446c-4.319-1.563-8.389 1.61-8.389 5.714H2.008c0-6.541 6.325-11.642 13.184-9.499 2.991.94 5.383 3.321 6.313 6.313 2.141 6.858-2.96 13.183-9.5 13.183z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.017 18.139H8.152v-3.866h3.865zm-3.865 2.959H5.193v-2.959h2.959zm-2.959-2.959H2.711v-2.483h2.482v2.483z"
                }
            }
        ]
    })(props);
}
function BiLogoDiscordAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.82 4.26a10.14 10.14 0 0 0-.53 1.1 14.66 14.66 0 0 0-4.58 0 10.14 10.14 0 0 0-.53-1.1 16 16 0 0 0-4.13 1.3 17.33 17.33 0 0 0-3 11.59 16.6 16.6 0 0 0 5.07 2.59A12.89 12.89 0 0 0 8.23 18a9.65 9.65 0 0 1-1.71-.83 3.39 3.39 0 0 0 .42-.33 11.66 11.66 0 0 0 10.12 0q.21.18.42.33a10.84 10.84 0 0 1-1.71.84 12.41 12.41 0 0 0 1.08 1.78 16.44 16.44 0 0 0 5.06-2.59 17.22 17.22 0 0 0-3-11.59 16.09 16.09 0 0 0-4.09-1.35zM8.68 14.81a1.94 1.94 0 0 1-1.8-2 1.93 1.93 0 0 1 1.8-2 1.93 1.93 0 0 1 1.8 2 1.93 1.93 0 0 1-1.8 2zm6.64 0a1.94 1.94 0 0 1-1.8-2 1.93 1.93 0 0 1 1.8-2 1.92 1.92 0 0 1 1.8 2 1.92 1.92 0 0 1-1.8 2z"
                }
            }
        ]
    })(props);
}
function BiLogoDiscord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.593 10.971c-.542 0-.969.475-.969 1.055 0 .578.437 1.055.969 1.055.541 0 .968-.477.968-1.055.011-.581-.427-1.055-.968-1.055zm3.468 0c-.542 0-.969.475-.969 1.055 0 .578.437 1.055.969 1.055.541 0 .968-.477.968-1.055-.001-.581-.427-1.055-.968-1.055z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.678 3H4.947A1.952 1.952 0 0 0 3 4.957v12.844c0 1.083.874 1.957 1.947 1.957H15.72l-.505-1.759 1.217 1.131 1.149 1.064L19.625 22V4.957A1.952 1.952 0 0 0 17.678 3zM14.01 15.407s-.342-.408-.626-.771c1.244-.352 1.719-1.13 1.719-1.13-.39.256-.76.438-1.093.562a6.679 6.679 0 0 1-3.838.398 7.944 7.944 0 0 1-1.396-.41 5.402 5.402 0 0 1-.693-.321c-.029-.021-.057-.029-.085-.048a.117.117 0 0 1-.039-.03c-.171-.094-.266-.16-.266-.16s.456.76 1.663 1.121c-.285.36-.637.789-.637.789-2.099-.067-2.896-1.444-2.896-1.444 0-3.059 1.368-5.538 1.368-5.538 1.368-1.027 2.669-.998 2.669-.998l.095.114c-1.71.495-2.499 1.245-2.499 1.245s.21-.114.561-.275c1.016-.446 1.823-.57 2.156-.599.057-.009.105-.019.162-.019a7.756 7.756 0 0 1 4.778.893s-.751-.712-2.366-1.206l.133-.152s1.302-.029 2.669.998c0 0 1.368 2.479 1.368 5.538 0-.001-.807 1.376-2.907 1.443z"
                }
            }
        ]
    })(props);
}
function BiLogoDiscourse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.077 3C7.149 3 3 6.96 3 11.843V21l9.075-.01c4.928 0 8.925-4.11 8.925-8.993C21 7.113 17 3 12.077 3zm3.92 12.859a5.568 5.568 0 0 1-6.102 1.043l-3.595.805 1.001-3.192a5.435 5.435 0 0 1 .11-5.415 5.55 5.55 0 0 1 4.753-2.678v.001h.006a5.533 5.533 0 0 1 5.131 3.438 5.442 5.442 0 0 1-1.304 5.998z"
                }
            }
        ]
    })(props);
}
function BiLogoDjango(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.533 12.249c-.011 1.985 1.445 3.168 3.768 2.63V9.618c-2.352-.716-3.758.733-3.768 2.631m3.839-10.238h3.199v15.143c-3.066.501-6.004.819-8.104-.355-2.705-1.513-2.923-6.319-.782-8.46 1.085-1.085 3.271-1.85 5.616-1.351V2.225c-.006-.101-.012-.202.071-.214m8.389 3.342h-3.199V2.011h3.199v3.342z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.761 7.044c-.003 2.356-.003 4.048-.003 6.911-.136 2.813-.104 5.052-1.135 6.398-.203.266-.634.652-.995.924-.303.228-.881.691-1.208.711-.331.021-1.18-.459-1.564-.64-.505-.237-.971-.553-1.493-.71 1.218-.754 2.372-1.32 2.844-2.844.41-1.326.355-3.247.355-5.119 0-1.849.009-3.998.009-5.63l3.19-.001z"
                }
            }
        ]
    })(props);
}
function BiLogoDocker(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.17 9.82a4.76 4.76 0 0 0-.84.07 3.12 3.12 0 0 0-1.43-2.14l-.28-.16-.19.27a3.7 3.7 0 0 0-.51 1.19 2.84 2.84 0 0 0 .33 2.22 4.11 4.11 0 0 1-1.45.35H2.63a.63.63 0 0 0-.63.62 9.6 9.6 0 0 0 .58 3.39 5 5 0 0 0 2 2.6 8.86 8.86 0 0 0 4.42.95 13.27 13.27 0 0 0 2.42-.18 10.09 10.09 0 0 0 3.19-1.15A8.9 8.9 0 0 0 16.78 16a11.94 11.94 0 0 0 2.13-3.67h.19a3.08 3.08 0 0 0 2.23-.84 2.36 2.36 0 0 0 .59-.87l.08-.22-.2-.16a2.69 2.69 0 0 0-1.63-.42z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.61 9.35H3.85a.16.16 0 0 0-.16.15v1.58a.16.16 0 0 0 .16.15h1.76a.16.16 0 0 0 .16-.15V9.5a.16.16 0 0 0-.16-.15zm2.44 0H6.28a.16.16 0 0 0-.16.15v1.58a.16.16 0 0 0 .16.15h1.77a.15.15 0 0 0 .15-.15V9.5a.15.15 0 0 0-.15-.15zm2.47 0H8.75a.15.15 0 0 0-.15.15v1.58a.15.15 0 0 0 .15.15h1.77a.15.15 0 0 0 .15-.15V9.5a.15.15 0 0 0-.15-.15zm.67 0a.15.15 0 0 0-.19.15v1.58a.15.15 0 0 0 .15.15H13a.15.15 0 0 0 .15-.15V9.5a.15.15 0 0 0-.15-.15zM6.28 7.09H8a.16.16 0 0 1 .16.16v1.56A.16.16 0 0 1 8 9H6.28a.15.15 0 0 1-.15-.15V7.24a.15.15 0 0 1 .15-.15zm2.47 0h1.77a.15.15 0 0 1 .15.15v1.57a.16.16 0 0 1-.16.16H8.75a.15.15 0 0 1-.15-.15V7.24a.15.15 0 0 1 .15-.15zm2.44 0H13a.15.15 0 0 1 .15.15v1.57A.15.15 0 0 1 13 9h-1.81a.16.16 0 0 1-.19-.19V7.24a.15.15 0 0 1 .19-.15z"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "11.04",
                    "y": "4.82",
                    "width": "2.07",
                    "height": "1.88",
                    "rx": ".15"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.65 9.35a.15.15 0 0 0-.15.15v1.58a.15.15 0 0 0 .15.15h1.77a.15.15 0 0 0 .15-.15V9.5a.15.15 0 0 0-.15-.15z"
                }
            }
        ]
    })(props);
}
function BiLogoDribbble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.66 6.98a9.932 9.932 0 0 0-3.641-3.64C15.486 2.447 13.813 2 12 2s-3.486.447-5.02 1.34c-1.533.893-2.747 2.107-3.64 3.64S2 10.187 2 12s.446 3.487 1.34 5.02a9.924 9.924 0 0 0 3.641 3.64C8.514 21.553 10.187 22 12 22s3.486-.447 5.02-1.34a9.932 9.932 0 0 0 3.641-3.64C21.554 15.487 22 13.813 22 12s-.446-3.487-1.34-5.02zM12 3.66c2 0 3.772.64 5.32 1.919-.92 1.174-2.286 2.14-4.1 2.9-1.002-1.813-2.088-3.327-3.261-4.54A7.715 7.715 0 0 1 12 3.66zM5.51 6.8a8.116 8.116 0 0 1 2.711-2.22c1.212 1.201 2.325 2.7 3.34 4.5-2 .6-4.114.9-6.341.9-.573 0-1.006-.013-1.3-.04A8.549 8.549 0 0 1 5.51 6.8zM3.66 12c0-.054.003-.12.01-.2.007-.08.01-.146.01-.2.254.014.641.02 1.161.02 2.666 0 5.146-.367 7.439-1.1.187.373.381.793.58 1.26-1.32.293-2.674 1.006-4.061 2.14S6.4 16.247 5.76 17.5c-1.4-1.587-2.1-3.42-2.1-5.5zM12 20.34c-1.894 0-3.594-.587-5.101-1.759.601-1.187 1.524-2.322 2.771-3.401 1.246-1.08 2.483-1.753 3.71-2.02a29.441 29.441 0 0 1 1.56 6.62 8.166 8.166 0 0 1-2.94.56zm7.08-3.96a8.351 8.351 0 0 1-2.58 2.621c-.24-2.08-.7-4.107-1.379-6.081.932-.066 1.765-.1 2.5-.1.799 0 1.686.034 2.659.1a8.098 8.098 0 0 1-1.2 3.46zm-1.24-5c-1.16 0-2.233.047-3.22.14a27.053 27.053 0 0 0-.68-1.62c2.066-.906 3.532-2.006 4.399-3.3 1.2 1.414 1.854 3.027 1.96 4.84-.812-.04-1.632-.06-2.459-.06z"
                }
            }
        ]
    })(props);
}
function BiLogoDropbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.004 3.5 2 6.689l5.004 3.186 5.002-3.186zm10.005 0-5.003 3.189 5.003 3.186 5.003-3.186zM2 13.062l5.004 3.187 5.002-3.187-5.002-3.187zm15.009-3.187-5.003 3.187 5.003 3.187 5.003-3.187zM7.004 17.311l5.002 3.189 5.003-3.189-5.003-3.186z"
                }
            }
        ]
    })(props);
}
function BiLogoDrupal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.474 14.42a3.162 3.162 0 1 0 0 6.324 3.162 3.162 0 0 0 0-6.324zm3.936-.606a5.433 5.433 0 0 1 1.513 3.769 5.441 5.441 0 0 1-2.335 4.47c2.609-.803 4.771-2.767 5.737-5.142 1.338-3.288.09-5.761-1.999-8.005.066.288.103.592.103.898a4.175 4.175 0 0 1-3.019 4.01zm-3.577-4.003c0 1.34 1.087 2.419 2.42 2.419s2.423-1.087 2.423-2.419a2.418 2.418 0 0 0-2.417-2.417 2.425 2.425 0 0 0-2.426 2.417z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.303 21.093a5.435 5.435 0 0 1-1.276-3.51 5.441 5.441 0 0 1 4.8-5.408 4.162 4.162 0 0 1 3.99-6.492c-1.361-1.176-2.724-2.369-3.799-3.672.547 5.714-5.2 3.638-7.332 8.904-1.422 3.527-.138 7.892 3.617 10.178z"
                }
            }
        ]
    })(props);
}
function BiLogoEbay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.021 12.111V8.004h1.001v2.525c.493-.586 1.17-.756 1.838-.756 1.118 0 2.361.754 2.361 2.383 0 .195-.014.381-.051.559.2-.797 1.063-1.09 2.418-1.123.426-.016.914-.016 1.302-.016v-.111c0-.738-.464-1.039-1.276-1.039-.602 0-1.04.25-1.09.676H12.46c.113-1.076 1.253-1.352 2.242-1.352.889 0 1.666.225 2.017.852l-.365-.702h1.177l1.716 3.443 1.716-3.445H22l-3.105 6.098h-1.124l.894-1.703-1.945-3.656c.108.213.167.465.167.777v2.055c0 .289.009.574.034.838h-.931a5.478 5.478 0 0 1-.038-.639c-.503.613-1.103.803-1.937.803-1.236 0-1.897-.652-1.897-1.416 0-.125.013-.236.031-.338-.251 1.041-1.135 1.74-2.31 1.74-.727 0-1.414-.262-1.837-.775 0 .201-.013.412-.033.611h-.986c.018-.324.034-.713.034-1.037v-.877H2.985c.054.914.683 1.451 1.547 1.451.599 0 1.131-.25 1.309-.775h1.035c-.2 1.078-1.344 1.439-2.329 1.439-1.789.018-2.582-.973-2.582-2.301 0-1.463.819-2.428 2.602-2.428 1.409 0 2.445.738 2.454 2.342v.004zm7.627.153c-.915.027-1.479.193-1.479.793 0 .389.301.809 1.09.809 1.052 0 1.615-.574 1.615-1.514v-.109c-.376 0-.826.006-1.239.02h.011l.002.001zm-5.059 1.564c.927 0 1.566-.672 1.566-1.686s-.642-1.686-1.58-1.686c-.928 0-1.578.672-1.578 1.686s.639 1.686 1.565 1.686h.027zM5.958 11.73c-.037-.939-.714-1.291-1.44-1.291-.788 0-1.414.395-1.516 1.291h2.956z"
                }
            }
        ]
    })(props);
}
function BiLogoEdge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.349 13.684H8.874c0 .433.063.825.195 1.178a3.334 3.334 0 0 0 1.381 1.634c.309.196.646.359 1.005.484.356.13.729.226 1.107.288.821.13 1.658.123 2.477-.021a9.79 9.79 0 0 0 2.421-.783c.393-.18.79-.376 1.201-.594v3.805a13.453 13.453 0 0 1-2.711.978c-.457.112-.92.196-1.396.246-.486.054-.975.079-1.464.079a8.185 8.185 0 0 1-1.95-.232 7.679 7.679 0 0 1-1.762-.668 7.29 7.29 0 0 1-1.51-1.062 6.67 6.67 0 0 1-1.941-3.103 6.978 6.978 0 0 1-.267-1.953c0-.737.101-1.439.303-2.11a6.718 6.718 0 0 1 2.264-3.342 7.38 7.38 0 0 1 1.847-1.066 3.891 3.891 0 0 0-.869 1.329 5.682 5.682 0 0 0-.401 1.538h6.391c0-.646-.063-1.207-.196-1.689-.131-.484-.342-.885-.637-1.201A2.64 2.64 0 0 0 13.23 6.7c-.462-.16-1.021-.241-1.675-.241-.771 0-1.543.111-2.314.344a9.804 9.804 0 0 0-2.2.955c-.695.412-1.335.897-1.919 1.452a9.167 9.167 0 0 0-1.474 1.819c.084-.742.247-1.474.485-2.18a9.304 9.304 0 0 1 .912-1.938 8.622 8.622 0 0 1 1.303-1.609 7.735 7.735 0 0 1 1.655-1.235 8.45 8.45 0 0 1 1.955-.792 10.042 10.042 0 0 1 2.233-.254c.46 0 .917.041 1.375.124.457.084.903.196 1.339.342a8.012 8.012 0 0 1 2.315 1.239 7.95 7.95 0 0 1 1.711 1.833c.463.692.813 1.459 1.055 2.292s.365 1.701.365 2.602v2.23h-.002z"
                }
            }
        ]
    })(props);
}
function BiLogoEtsy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.139 14.058c-.438 0-.693-.294-.693-1.058v-2.696l1.456.112.074-.694-1.496.074v-1.53h-.438c-.216 1.201-.759 1.638-1.488 1.712v.364h.869v3.062c0 .836.588 1.271 1.313 1.271.585 0 1.202-.255 1.418-.763l-.217-.255c-.108.18-.402.401-.798.401zm-3.494-.803c-.294.69-.767.729-1.24.729h-1.53c-.508 0-.729-.186-.729-.62v-2.258s1.092 0 1.457.039c.291.035.438.109.546.473l.108.511h.438l-.039-1.309.074-1.278h-.434l-.147.585c-.073.399-.147.438-.546.508-.508.038-1.457.038-1.457.038V7.979c0-.112 0-.147.185-.147h2.291c.402 0 .62.326.763.98l.147.512h.399c.039-1.457.074-2.074.074-2.074s-.981.105-1.562.105H3.53L2 7.324v.399l.508.107c.367.074.475.147.475.473 0 0 .039.984.039 2.619 0 1.639-.039 2.623-.039 2.623 0 .291-.108.399-.475.473L2 14.131v.396l1.565-.035h2.623c.581 0 1.965.035 1.965.035.034-.361.216-1.964.255-2.146H8.04l-.395.874zm6.04-2.622c0-.474.437-.655.875-.655.36 0 .653.147.729.325l.255.729.361-.035c0-.364.038-.838.111-1.201-.328-.147-.983-.221-1.421-.221-.984 0-1.747.441-1.747 1.387 0 1.674 2.44 1.31 2.44 2.549 0 .399-.256.729-.876.729-.581 0-.837-.294-.945-.585l-.29-.693h-.369c.04.476.074.948 0 1.382 0 0 .767.294 1.531.294 1.022 0 1.858-.507 1.858-1.457 0-1.674-2.512-1.421-2.512-2.548zm6.369-.945v.364l.259.074c.252.07.36.178.36.363 0 .108-.034.144-.073.291-.108.291-.802 2.003-1.162 2.767a75.566 75.566 0 0 1-1.093-2.949c-.035-.073-.035-.108-.035-.146 0-.148.105-.292.361-.326l.329-.074v-.364l-1.346.073-1.096-.039v.368l.187.069c.251.074.287.11.469.512.693 1.53 1.457 3.529 1.716 4.15-.584 1.019-1.204 1.309-1.677 1.309-.291 0-.399-.147-.435-.329l-.146-.763-.4.035c-.073.477-.147.984-.255 1.383.287.182.616.294 1.053.293.691 0 1.675-.182 2.623-2.332l1.601-3.747c.145-.293.182-.329.546-.476l.183-.144v-.362l-.945.034-1.024-.034z"
                }
            }
        ]
    })(props);
}
function BiLogoFacebookCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.001 2.002c-5.522 0-9.999 4.477-9.999 9.999 0 4.99 3.656 9.126 8.437 9.879v-6.988h-2.54v-2.891h2.54V9.798c0-2.508 1.493-3.891 3.776-3.891 1.094 0 2.24.195 2.24.195v2.459h-1.264c-1.24 0-1.628.772-1.628 1.563v1.875h2.771l-.443 2.891h-2.328v6.988C18.344 21.129 22 16.992 22 12.001c0-5.522-4.477-9.999-9.999-9.999z"
                }
            }
        ]
    })(props);
}
function BiLogoFacebookSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h8.615v-6.96h-2.338v-2.725h2.338v-2c0-2.325 1.42-3.592 3.5-3.592.699-.002 1.399.034 2.095.107v2.42h-1.435c-1.128 0-1.348.538-1.348 1.325v1.735h2.697l-.35 2.725h-2.348V21H20a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1z"
                }
            }
        ]
    })(props);
}
function BiLogoFacebook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.397 20.997v-8.196h2.765l.411-3.209h-3.176V7.548c0-.926.258-1.56 1.587-1.56h1.684V3.127A22.336 22.336 0 0 0 14.201 3c-2.444 0-4.122 1.492-4.122 4.231v2.355H7.332v3.209h2.753v8.202h3.312z"
                }
            }
        ]
    })(props);
}
function BiLogoFigma(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.332 8.668a3.333 3.333 0 0 0 0-6.663H8.668a3.333 3.333 0 0 0 0 6.663 3.333 3.333 0 0 0 0 6.665 3.333 3.333 0 0 0 0 6.664A3.334 3.334 0 0 0 12 18.664V8.668h3.332z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.332",
                    "cy": "12",
                    "r": "3.332"
                }
            }
        ]
    })(props);
}
function BiLogoFirebase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.239 15.063 7.21 2.381a.453.453 0 0 1 .847-.145l2.12 3.979-4.938 8.848zM19.24 18.14 17.363 6.469a.454.454 0 0 0-.766-.246L4.76 18.14l6.55 3.691c.411.23.912.23 1.323 0l6.607-3.691zM13.917 7.955 12.4 5.052a.452.452 0 0 0-.8 0L4.939 16.989l8.978-9.034z"
                }
            }
        ]
    })(props);
}
function BiLogoFirefox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.634 11.138a2.16 2.16 0 0 0-.06-.286l-.187.236a6.354 6.354 0 0 0-.228-1.274 8.66 8.66 0 0 0-.591-1.511 5.33 5.33 0 0 0-.54-.92c-.109-.17-.203-.296-.221-.322-.362-.589-.767-.947-1.249-1.621a4.942 4.942 0 0 1-.615-1.679 6.091 6.091 0 0 0-.303 1.097c-.483-.489-.913-.846-1.168-1.08-1.267-1.183-1.113-1.79-1.113-1.79s-2.364 2.635-1.342 5.377a5.278 5.278 0 0 0 1.764 2.347c.989.813 2.052 1.452 2.609 3.101a5.2 5.2 0 0 0-1.967-2.087c.253.602.38 1.232.371 1.884a4.468 4.468 0 0 1-4.476 4.465 4.28 4.28 0 0 1-.985-.109 4.117 4.117 0 0 1-1.107-.379 4.4 4.4 0 0 1-1.334-1.226v-.007a.372.372 0 0 0 .075.024c.187.067.372.118.567.153a3.558 3.558 0 0 0 2.245-.263c.708-.396 1.139-.685 1.484-.574.348.109.608-.22.373-.565a1.853 1.853 0 0 0-1.79-.692c-.711.101-1.36.599-2.28.117-.067-.032-.117-.066-.176-.101-.06-.042.202.051.134.009a4.138 4.138 0 0 1-.582-.347c-.009-.009.145.043.126.033a2.235 2.235 0 0 1-.608-.614 1.118 1.118 0 0 1-.04-.973.844.844 0 0 1 .38-.354l.192.1s-.059-.1-.085-.151c.01-.008.019 0 .035-.008.102.042.329.159.455.236a.6.6 0 0 1 .212.186s.043-.017.009-.108a.511.511 0 0 0-.221-.263h.018c.093.051.178.102.261.167.076-.186.119-.368.112-.563a.825.825 0 0 0-.043-.313c-.035-.067.017-.093.075-.025a.545.545 0 0 0-.051-.152s.034-.051.051-.062c.043-.04.084-.082.136-.107.293-.185.599-.347.92-.474a6.52 6.52 0 0 0 .515-.228c.067-.042.127-.084.186-.136.22-.185.364-.438.413-.718.01-.04.01-.074.01-.107v-.069c-.034-.144-.279-.245-1.553-.372a1.104 1.104 0 0 1-.911-.852v.007a2.035 2.035 0 0 0-.051.146c.016-.053.033-.094.051-.146v-.007a3.257 3.257 0 0 1 1.249-1.553c.031-.025-.126.007-.093-.017.102-.051.211-.103.329-.145.059-.018-.245-.134-.515-.11a1.545 1.545 0 0 0-.473.11c.067-.049.252-.118.21-.118a2.837 2.837 0 0 0-.97.363c0-.033.01-.06.018-.083a1.474 1.474 0 0 0-.6.464v-.112a2.706 2.706 0 0 0-.295.28h-.008a3.92 3.92 0 0 0-2.205-.184l-.008-.009h.008a1.684 1.684 0 0 1-.387-.439l-.01.007-.015-.016c-.053-.068-.093-.152-.147-.246-.04-.06-.074-.136-.116-.21 0 0 0-.008-.008-.008-.01 0-.026.077-.033.049a2.668 2.668 0 0 1-.179-1.053H5.28a1.12 1.12 0 0 0-.448.589c-.041.086-.067.128-.092.179v-.028l.024-.125c-.006.009-.006.017-.017.025a1.06 1.06 0 0 0-.15.23 1.117 1.117 0 0 0-.103.243v-.042c0-.034.009-.085 0-.067l-.009.023a5.968 5.968 0 0 0-.506 1.902c-.016.118-.016.228-.016.337v.018a4.422 4.422 0 0 0-.514.683 9.703 9.703 0 0 0-1.082 2.659c.161-.354.354-.701.583-1.021a9.332 9.332 0 0 0-.659 3.454c.076-.346.169-.684.278-1.022a8.737 8.737 0 0 0 .787 4.062 9.397 9.397 0 0 0 3.738 4.229 8.052 8.052 0 0 0 2.169 1.048c.102.033.213.074.313.109-.034-.018-.059-.035-.092-.042a9.912 9.912 0 0 0 2.818.413c3.387 0 4.501-1.292 4.61-1.418.16-.151.303-.331.396-.541.068-.024.127-.05.195-.084l.041-.016c.051-.026.075-.034.075-.034a7.11 7.11 0 0 0 1.437-.896 3.475 3.475 0 0 0 1.326-1.951c.125-.286.125-.6.024-.894.05-.084.094-.161.101-.178a7.954 7.954 0 0 0 1.199-3.876v-.116a4.918 4.918 0 0 0-.072-.872z"
                }
            }
        ]
    })(props);
}
function BiLogoFlask(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.78 18.29c0 .12.15 0 0 0zm-3.35-2.7c.39.17-.31-.6 0 0zm-5.03.28c.15.26 0-.12 0 0zm5.6.39c-.27-.42-.2.06 0 .32.48.47.18-.26 0-.32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.24 19.06c-.53.63-1-.07-1.63.13-1.1 0 .09-.5.06-1-.58-.45-1.24.61-1.62.9a10.75 10.75 0 0 1-2.67-.83 8 8 0 0 1-2.6-1.94 8.36 8.36 0 0 1-1.87-2.84 21.36 21.36 0 0 1-.84-5.74c.07-1.3 1.44.14 2-.33-.21-.67-1.29-.88-1.89-1.16-.58 0-.79-.55-1.4-.59 0-.73-1.13-.33-1.56-.84.42-1.08-1.37 0-1.23-.91.58-1.2-1.78-1-.8.06.95.54-.93.93-.38 1.29a.59.59 0 0 1-.53.86c-.74.07-.67 1.09.06.55.81-.25.14.11-.25.18a1.3 1.3 0 0 0-.95 1.9 35.32 35.32 0 0 1 1 3.42A16.25 16.25 0 0 0 5.84 17 9.78 9.78 0 0 0 8 19a9.89 9.89 0 0 0 2.43 1.22 18 18 0 0 0 4.73.73 16.53 16.53 0 0 0 2.9-.24c.87.09 1.49-.65 2.26-.26.48-.42 1.16-.23 1.63-.54.32-1.22-1.22-.27-1.71-.85zm-1.74-.74c-.22 0 .05-.34 0 0zm-7.63-11c-.1 0-.08-.12-.16-.15-.8-.37.39-.23.16.19zm6.76 11.39c-.35-.08.28-.25 0 0zm-2.81.11c-.23 0 .18-.14 0 0zm-1.88-1.18c-.13 0 0-.13 0 0zm-.22-.17c-.36 0-.09-.23 0 0zm-.42-.36c-.33.08 0-.34 0 0zm-6-11.66c-.53-.28.11.33-.34.32-.24 0-.69-.52-.54-.78.3.16.83.21.92.5zm-.92-.81h-.11c-.03-.27.87-.06.15.04zm-1.02-.79c-.42-.19 0-.93.44-.58.51.73-.95-.08-.44.58zm.49.69c-.27.11.16-.21 0 0zm.48.92c.6.46-.34 0-.72.29-.61.06.66-.34.72-.29zm.17.6c.35 0 1.88-.69 1.37-.07.47.55.1.37-.21 0 .28.19.06 1-.37.45s-.5-.18-.17.21C5.8 6 4.88 6.28 4.21 6.5c-.43-.04 1.13-.37 1.29-.44zM3.58 7.51c-.16.4.24.53.62.6.62-.17-.41-.28.06-.44.26 0-.82-.26.08-.38S6.09 6.77 7 6.58a8.71 8.71 0 0 1 2.35-.19c.3.35-.23.94-.77 1a8.61 8.61 0 0 1-2 .39c-.8-.1-1.37.61-2.19.7.22-.4-.18-.14-.59-.16.21.82-1.47-.21-.48-.41-.74-.26-.75.52-.67 1-.65-.91.07-1.29.93-1.4zm1.88 1.08c-.22-.05.17-.2 0 0zm-.72.88s-.34-.08-.2-.17c1 .13-.9-.33.13-.22.66-.02.44.36.07.39zm.33.17c-.12.12 0-.24 0 0zm-.71 0c-.44-.09.21-.22 0 0zm-.06 1.43c-.07.1-.1-.08 0 0zM4 10.9c-.55-.19 0-.21 0 0zm-.12 1.28c-.26-.09-.25-.5-.37-.72-.38-1.03.41.4.33.72zm.23-1.49c-.69-.08-.05-.49 0 0zm0-.34h-.09c-.76-.35.45-.17-.02 0zM4 9.56c-.61-.31.58-.36 0 0zm.21.26c-.34.06.05-.32 0 0zm-1.3.07c-.12.08 0-.23 0 0zM3 9.75c-.16 0 0-.27 0 0zm.08-1c-.4-.1.33-.25 0 0zm.26 2c-.44-.1-.12-.65 0 0zm.3 1.25c.42.51.26.79.69 1.41-.56-.35-.67-1.2-1-1.75-.41-.9.23-.01.31.34zm4.09 6.38c-.34-.07-.57-.43-.81-.66a4.88 4.88 0 0 1-1.57-1.94 12.26 12.26 0 0 1-1.46-2.38c-.41-.92.25.07.35.42.21.68.88 1.07.94 1.52.74.42.36 1.12 1 1.31.27-.14.3.84.89.64-.33.15.13.33.3.61.35-.05 1.17.82.36.52zM4.62 12c-.31-.07.33-.11 0 0zm.2.47c-.55-.14.52-.2 0 0zm1.39.47c.4-.17.16.78.55.9.76 1-.53 0-1-.07.06 0-.38-.12-.19-.16-.14-.15-.45-.66.26-.32.6.24.65.06.38-.39zm1.31 1.76c0 .15-.72.13-.06.42-.38 0-.5 0 0 .3-.22.17.43.31.21.57.66.52-.12.13-.4-.08s-.85-.35-.75-.5c.81.42.21 0-.15-.3.65.16-.51-.48.1-.31.19.05-.27-.38.33-.07-.54-.52.47-.12.72-.07zm.48-.17c-.61-.14 0-.34 0 0zm-.17 2c-.61-.26.39 0 0 0zm-.45-.17c-.71-.23.52 0 0 0zm-.09.11c-.22 0 0-.17 0 0zm-1.08-1.55c-.72-.3-.2-.33 0 0zm-.54-.35c-.58-.33-.08-.33 0 0zm0 .65c-.57-.44-.07-.25 0 0zm-.15-1.34c-.35 0 .13-.2 0 0zM8 17.38c-.51-.15 0-.14 0 0zM7.63 17h-.16c-.68-.54.31-.38.75-.14.97.14-.22.39-.59.14zm2.7 1.65c-.68-.16.16-.27 0 0zm-.17-.52c-.05 0-.1-.11 0 0zm-.86-1.34c-.59-.14.21-.19.36 0 1.02.21-.06.26-.36 0zM9.51 18H9.4l-.13-.06c-.56-.59 1.19.28.24.06zm-.28.69c-.15.06 0-.14 0 0zm.29-1.19-.16-.05c-.66-.45.84.09.16 0zm.16 1.72c-.4-.16.26-.25 0 0zm.1-.74c-.58-.14.36-.13 0 0zm.13-.61c-.44-.06.05-.21 0 0zm-.72-.88c.46.06.47.27 0 .14-.09 0-.24 0-.28-.17-.76-.5.03-.25.28-.02zm-.06 2c-.2.12 0-.22 0 0zm-.31-.51c-.53 0 .4-.26 0 0zm-.12.35c-.26-.1.17-.08 0 0zm.3-.89c-.52-.14.25-.18 0 0zm-.16-.57c-.28 0-.06-.16 0 0zm-.54-.95c-.57-.46 1.18.38 0 0zm-.06.19c0 .06-.11-.09 0 0zm3.65 3.78a9.4 9.4 0 0 1-2.56-.85l-.33-.2c-.57-.31-.5-.38.06-.07.19.16 1.59.73.93.35-.29-.07-1.9-.95-.84-.57a20.92 20.92 0 0 0 2.74 1.21 7.14 7.14 0 0 0 2.43.15c.65.33 1.33-.08 2 .21a13.05 13.05 0 0 1-4.45-.23zm-1.25-.7c-.51-.09.16-.23 0 0zm.73-1c-.58-.11.6-.23 0 0zm.84 1.31c1 .37-.6.12-.93-.09-.92-.38.72.09.93.09zm-1.06-1.1c-.81-.12.9 0 0 0zm1.52.85c-.29.23 0-.3 0 0zm.29.05c-.15.06 0-.17 0 0zm.27-.38c-.16.2 0-.23 0 0zm.31 0c-.45.17.47-.39 0 0zm.14 0c.49-.42.51-.22.5.13-.43.48-.17-.2-.44.06s-.19-.1-.06-.17zm.83.45c-.5 0 .51-.54 0 0zm0 .18c-.2.05 0-.13 0 0zm-.16-.35c-.39-.26.94-.61 0 0zm.57.09h-.08c-.03-.23.54-.27.08.02zm.15.19c-.3-.08.47-.4 0 0zm.36-.1c-.51.18.48-.4 0 0zm.22.11-.12.08c-.23-.14.71-.48.12-.07zm-.43-.53c-.54-.18-1.4-.76-2-.37-.8.51.41-.56-.24-.08-.66.79-.45-.5-1.09-.11 0-.12-.57-.16-.17-.37-.36 0-.13-.05 0-.34-.16 0-1 0-1.36-.29-.4-.52.07-.3.48-.23-.67.12.24.5.68.29-.2-.09-.43-.52-1-.9a18.83 18.83 0 0 0-2.13-1c-.84-.5.18-.18.47.08.84.37.51-.51 0-.74-.54 0-.67-.59-1.1-.56.67.11 1.14-.17.39-.85s.3.63-.11.44c-.19-.25-.05-.6-.65-.73 0 .23-.08.58-.21.1-.17 0-.36.21-.5-.28.13-.57-.56-.7-.67-1.06.6.38.87.08.45-.33s-.33-.11-.49 0c-.59.6-.06-1-.32-.56-.26 0-.11.29-.1.65-.86-.21.2.45.45.81-.39-.4-.32.31-.65 0-.11-.3-.12-.77-.67-.85.62-.22-.36-.65-.28-.67.35-.32.4-.76.82-.07-.53 0 0 .88.12.6 0-.47.22-1-.59-1.19-.24.32-.65-.63-.18-.43-.06-.63.74-.26.69-.53.42-.18-.5-.77 0-1 .38.24 1.36-.36.7-.44.42 0 .75.18.79-.24.33.07 1.24.36.42-.09a3.45 3.45 0 0 1 1.13-.25c.79-.61.63 1 .45 1.45.3-.21.24.94.14 1.37.16-.22.23.36 0 .77 0-.07.4-.13.12.35-.22-.47-.31 1-.17.32.37-.61.28 0 .39.24.08.55.32 1.06.4 1.56.35.35-.15.11-.15.59.11-.14.58.19.57.68 0-.78.09-.18.47 0a5.48 5.48 0 0 0 1 1.42c.37.43 0 .13.14.39a3.19 3.19 0 0 0 2.09 1.28 1.46 1.46 0 0 0 1.57.7c-.6.37 1.68.47.91.67-.23.16-.62-.2-1.01-.18zM8.7 15.89c-.24 0 0-.2 0 0zm.38.22c-.18 0-.12-.24 0 0zm-2.61-3.65c-.24-.07.1-.09 0 0zm-.59 0c-.26 0 0-.34 0 0zm-.3-.08c-.1.05 0-.11 0 0zm11 8.25c-.39-.07.32-.22 0 0zm.73-1.05h-.3c.06-.45 1.33-.1 1.85-.09-.16.34-1.13.04-1.55.13zm2 0c-.27 0 .12-.32 0 0zm1-.09c-.25.13 0-.3 0 0zm.48.11c-.52-.12.24-.12.4-.14.94.02 0 .16-.47.16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.51 7.11c1-.2-.38-.33-.69 0 .18.13.41-.21.69 0zm-.82.13c0 .19.18-.22 0 0zm2.62-.48c.67-.11.11-.41-.09.1.07.14.11-.05.09-.1zm-.62.1c.93.36-.05-1 0 0zm-2.92.93a.51.51 0 0 1 .33.1c.75.52-.1-.84-.33-.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.81 7.43c.16.13.29-.21 0 0zm.37.01.14.12c.68.06-.11-.46-.14-.12zM10.69 16c.09.3 0-.39 0 0zm-4.78-5c.1.18.18-.18 0 0zm.09.61c.19.34 0-.51 0 0zm.21-.49c.33.21-.28-.52 0 0zm-.41-.82c.07.15.24.16.37.2 1.32.61-.95-1-.37-.2zm.54 1.43c.31.53.18-.37 0 0zm.48-.16c.37.92-.23-.12-.3-.43a2.11 2.11 0 0 0 .28 1c.34.51.19-.28.55.23-.2-.45.1-.2.06-.4s-1-1.17-.59-.4zm.36 1.78c.09.31.18 0 0 0zM5.85 9c.06.14.11 0 0 0zm.67.42c.32.41.17-.36 0 0zm-.89 1.14.14.15c.99.29-1.05-.95-.14-.15zm.7-.37c1 .41-.09-.27-.44-.2.11.13.32.07.44.2zm-.18-.44c.18.18.82.51.31.06.32-.06 0-.16-.24-.32-.44-.67.07.06-.07.26z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.51 10.64c-.53-.44.16.21-.06.2-.55-.4-.32-.11 0 .2.33.5.6-.3.06-.4zm2.14.64c.12.11-.06-.68 0 0zm1.02-3.5c0 .12.07-.1 0 0zM9 12.47c0 .21 0-.18 0 0zm-.29-1.22c.08.46.1-.78 0 0zm.14.22v.1c.21-.51.04-.79 0-.1zm-.1-2.7c-.14.7-.27.41-.08-.11-.05-.67-.45.41-.27.72.29.47.6-1.16.35-.61zm1.01 5.98c.13.35.11-.42 0 0zm-1.35-4.28c0 .2 0-.14 0 0zm.64 1.7c0 .26.11-.38 0 0zM9.5 14l.07.11c.14-.49-.36-.79-.07-.11zm-1.56-.52c.27.22-.13-.23 0 0zm1.23-.85c.08.29 0-.42 0 0zM8.14 9.81c.15.33-.05-.27 0 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.3 10.23c.24.34-.26-.64 0 0zm-.06 1.15c-.13-1-.42.45 0 .69.13.34.25.2.3-.19-.32 0 .08-.62-.3-.5z"
                }
            }
        ]
    })(props);
}
function BiLogoFlickrSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM8.747 14.746A2.745 2.745 0 1 1 11.494 12a2.744 2.744 0 0 1-2.747 2.746zm6.506 0a2.746 2.746 0 1 1-.001-5.493 2.746 2.746 0 0 1 .001 5.493z"
                }
            }
        ]
    })(props);
}
function BiLogoFlickr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.157 12a4.573 4.573 0 1 1-9.147 0 4.573 4.573 0 0 1 9.147 0zm10.833 0a4.573 4.573 0 1 1-9.147 0 4.573 4.573 0 0 1 9.147 0z"
                }
            }
        ]
    })(props);
}
function BiLogoFlutter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.9 2.01 3.9 12l3.09 3.09 2.71-2.7L20.09 2l-6.19.01zm.82 14.6 5.39-5.38h-5.93c-.11 0-.26 0-.34.07l-2.23 2.23-3.09 3.07 3.09 3.1 2.15 2.15c.07.07.14.17.26.15h6.07z"
                }
            }
        ]
    })(props);
}
function BiLogoFoursquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m17.549 5.557-.403 2.113c-.049.229-.337.47-.605.47h-3.76c-.425 0-.729.296-.729.714v.463c0 .43.307.725.73.725h3.194c.298 0 .591.33.524.646l-.404 2.083c-.037.181-.237.475-.592.475h-2.609c-.477 0-.617.069-.936.454-.316.395-3.175 3.827-3.175 3.827-.026.033-.054.022-.054-.011V5.522c0-.271.234-.588.586-.588h7.756c.283 0 .549.269.477.618v.005zm.341 8.288c.111-.437 1.319-6.63 1.722-8.593m-1.489-2.311H8.457c-1.33 0-1.723 1.002-1.723 1.635v15.353c0 .71.381.975.596 1.062.214.087.807.161 1.163-.247 0 0 4.563-5.296 4.64-5.373.125-.118.125-.118.238-.118h2.954c1.245 0 1.438-.885 1.574-1.405.114-.429 1.325-6.622 1.721-8.595.307-1.496-.079-2.311-1.495-2.311h-.002z"
                }
            }
        ]
    })(props);
}
function BiLogoGit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.62 11.108-8.731-8.729a1.292 1.292 0 0 0-1.823 0L9.257 4.19l2.299 2.3a1.532 1.532 0 0 1 1.939 1.95l2.214 2.217a1.53 1.53 0 0 1 1.583 2.531c-.599.6-1.566.6-2.166 0a1.536 1.536 0 0 1-.337-1.662l-2.074-2.063V14.9c.146.071.286.169.407.29a1.537 1.537 0 0 1 0 2.166 1.536 1.536 0 0 1-2.174 0 1.528 1.528 0 0 1 0-2.164c.152-.15.322-.264.504-.339v-5.49a1.529 1.529 0 0 1-.83-2.008l-2.26-2.271-5.987 5.982c-.5.504-.5 1.32 0 1.824l8.731 8.729a1.286 1.286 0 0 0 1.821 0l8.69-8.689a1.284 1.284 0 0 0 .003-1.822"
                }
            }
        ]
    })(props);
}
function BiLogoGithub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.026 2c-5.509 0-9.974 4.465-9.974 9.974 0 4.406 2.857 8.145 6.821 9.465.499.09.679-.217.679-.481 0-.237-.008-.865-.011-1.696-2.775.602-3.361-1.338-3.361-1.338-.452-1.152-1.107-1.459-1.107-1.459-.905-.619.069-.605.069-.605 1.002.07 1.527 1.028 1.527 1.028.89 1.524 2.336 1.084 2.902.829.091-.645.351-1.085.635-1.334-2.214-.251-4.542-1.107-4.542-4.93 0-1.087.389-1.979 1.024-2.675-.101-.253-.446-1.268.099-2.64 0 0 .837-.269 2.742 1.021a9.582 9.582 0 0 1 2.496-.336 9.554 9.554 0 0 1 2.496.336c1.906-1.291 2.742-1.021 2.742-1.021.545 1.372.203 2.387.099 2.64.64.696 1.024 1.587 1.024 2.675 0 3.833-2.33 4.675-4.552 4.922.355.308.675.916.675 1.846 0 1.334-.012 2.41-.012 2.737 0 .267.178.577.687.479C19.146 20.115 22 16.379 22 11.974 22 6.465 17.535 2 12.026 2z"
                }
            }
        ]
    })(props);
}
function BiLogoGitlab(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.892 9.889a.664.664 0 0 0-.025-.087l-2.104-6.479a.84.84 0 0 0-.8-.57.822.822 0 0 0-.789.575l-2.006 6.175H8.834L6.826 3.327a.823.823 0 0 0-.786-.575h-.006a.837.837 0 0 0-.795.575L3.133 9.815c0 .005-.005.01-.007.016l-1.067 3.281a1.195 1.195 0 0 0 .435 1.34l9.227 6.706c.167.121.393.12.558-.003l9.229-6.703a1.2 1.2 0 0 0 .435-1.34l-1.051-3.223zM17.97 3.936l1.809 5.566H16.16l1.81-5.566zm-11.94 0 1.812 5.566H4.228L6.03 3.936zm-2.982 9.752a.253.253 0 0 1-.093-.284l.793-2.437 5.817 7.456-6.517-4.735zm1.499-3.239h3.601l2.573 7.916-6.174-7.916zm7.452 8.794-2.856-8.798h5.718l-1.792 5.515-1.07 3.283zm1.282-.877 2.467-7.588.106-.329h3.604l-5.586 7.156-.591.761zm7.671-4.678-6.519 4.733.022-.029 5.794-7.425.792 2.436a.25.25 0 0 1-.089.285z"
                }
            }
        ]
    })(props);
}
function BiLogoGmail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m18.73 5.41-1.28 1L12 10.46 6.55 6.37l-1.28-1A2 2 0 0 0 2 7.05v11.59A1.36 1.36 0 0 0 3.36 20h3.19v-7.72L12 16.37l5.45-4.09V20h3.19A1.36 1.36 0 0 0 22 18.64V7.05a2 2 0 0 0-3.27-1.64z"
                }
            }
        ]
    })(props);
}
function BiLogoGoLang(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.79 10.17a.18.18 0 0 0-.11 0l-.2.27H7a.15.15 0 0 0 .1-.06l.17-.26v-.05zm-1.47.89a.14.14 0 0 0-.11 0l-.2.26v.05h4.6a.09.09 0 0 0 .09-.06l.08-.23v-.06zM4.6 12a.13.13 0 0 0-.1.06l-.13.24v.06h2.15a.08.08 0 0 0 .07-.07v-.23s0-.07-.06-.07zm15.99-3.07a3.62 3.62 0 0 0-2.78-.5 4.09 4.09 0 0 0-2.72 1.63 4 4 0 0 0-.67 1.26h-3.14a.25.25 0 0 0-.24.16c-.14.25-.37.76-.5 1.06s0 .29.18.29h1.88a2.8 2.8 0 0 1-.26.36 1.81 1.81 0 0 1-1.65.65 1.53 1.53 0 0 1-1.32-1.53 2.07 2.07 0 0 1 1-1.85 1.71 1.71 0 0 1 1.77-.15 1.36 1.36 0 0 1 .45.37c.13.15.14.14.29.1l1.63-.43c.12 0 .16-.08.1-.16a3 3 0 0 0-1.13-1.38 3.35 3.35 0 0 0-2.58-.47A4.31 4.31 0 0 0 8.16 10a3.81 3.81 0 0 0-.82 2.85A3 3 0 0 0 8.57 15a3.46 3.46 0 0 0 2.62.65A4.06 4.06 0 0 0 14 14a4.33 4.33 0 0 0 .41-.69 3 3 0 0 0 1 1.55 3.68 3.68 0 0 0 2.38.86c.25 0 .51 0 .78-.09a4.51 4.51 0 0 0 2.33-1.25A3.72 3.72 0 0 0 22 11.1a3 3 0 0 0-1.41-2.17zm-1.78 4.73a1.81 1.81 0 0 1-1.59.06 1.61 1.61 0 0 1-.9-1.84A2.12 2.12 0 0 1 18 10.19a1.59 1.59 0 0 1 2 1.29 2.91 2.91 0 0 1 0 .32 2.11 2.11 0 0 1-1.19 1.86z"
                }
            }
        ]
    })(props);
}
function BiLogoGoogleCloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.511 9.722a7.833 7.833 0 0 0-2.359-3.804l-.035.035.005-.042A7.81 7.81 0 0 0 4.418 9.722c.031-.013.066-.013.099-.023a5.643 5.643 0 0 0-.306 9.166l.006-.006-.006.024a5.612 5.612 0 0 0 3.407 1.134h4.321l.024.024h4.341a5.644 5.644 0 0 0 3.207-10.319zm-3.206 6.845h-4.341l-.006.006v-.031h-4.34c-.308 0-.611-.066-.892-.193l.002-.001a2.17 2.17 0 1 1 2.87-2.871l2.518-2.518a5.634 5.634 0 0 0-3.396-2.1c.018-.009.035-.024.05-.021a4.334 4.334 0 0 1 5.931-.451h.046a4.334 4.334 0 0 1 1.558 3.407v.433a2.17 2.17 0 1 1 0 4.34z"
                }
            }
        ]
    })(props);
}
function BiLogoGooglePlusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.014 11.974C21.996 6.462 17.521 2 12.008 2 6.493 2 2.019 6.462 2.001 11.974L2 11.948v.112l.001-.023c.017 5.513 4.491 9.977 10.007 9.977 5.514 0 9.988-4.462 10.006-9.974l.001.026v-.118l-.001.026zM9.281 16.557c-2.509 0-4.548-2.039-4.548-4.549s2.039-4.549 4.548-4.549c1.23 0 2.258.451 3.046 1.188l-1.295 1.255c-.325-.309-.899-.673-1.751-.673-1.505 0-2.733 1.251-2.733 2.785 0 1.533 1.229 2.784 2.733 2.784 1.742 0 2.384-1.206 2.502-1.92H9.279V11.18h4.255c.066.286.115.554.115.932 0 2.597-1.742 4.445-4.368 4.445zm10.458-4.095H17.92v1.819h-1.364v-1.819h-1.82v-1.364h1.82v-1.82h1.364v1.82h1.819v1.364z"
                }
            }
        ]
    })(props);
}
function BiLogoGooglePlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.545 15.025v-2.421h2.422v-1.815h-2.422V8.368H17.73v2.421h-2.421v1.815h2.421v2.421zM8.052 8.302c1.133 0 1.896.484 2.33.896l1.722-1.67c-1.048-.98-2.415-1.58-4.052-1.58C4.714 5.947 2 8.659 2 12s2.714 6.053 6.052 6.053c3.493 0 5.812-2.457 5.812-5.913 0-.503-.064-.86-.153-1.24H8.049v2.256h3.332c-.158.951-1.011 2.556-3.329 2.556-2.003 0-3.637-1.665-3.637-3.704 0-2.042 1.634-3.706 3.637-3.706z"
                }
            }
        ]
    })(props);
}
function BiLogoGoogle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.283 10.356h-8.327v3.451h4.792c-.446 2.193-2.313 3.453-4.792 3.453a5.27 5.27 0 0 1-5.279-5.28 5.27 5.27 0 0 1 5.279-5.279c1.259 0 2.397.447 3.29 1.178l2.6-2.599c-1.584-1.381-3.615-2.233-5.89-2.233a8.908 8.908 0 0 0-8.934 8.934 8.907 8.907 0 0 0 8.934 8.934c4.467 0 8.529-3.249 8.529-8.934 0-.528-.081-1.097-.202-1.625z"
                }
            }
        ]
    })(props);
}
function BiLogoGraphql(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.1 14.56a2.07 2.07 0 0 0-.47-.18V9.62a1.64 1.64 0 0 0 .48-.18 1.78 1.78 0 0 0-1.78-3.09 1.62 1.62 0 0 0-.41.32l-4.11-2.38a1.7 1.7 0 0 0 .07-.51 1.78 1.78 0 0 0-3.56 0 1.7 1.7 0 0 0 .07.51L6.28 6.66a1.58 1.58 0 0 0-.41-.31 1.78 1.78 0 0 0-1.78 3.09 1.64 1.64 0 0 0 .48.18v4.76a2.07 2.07 0 0 0-.47.18 1.78 1.78 0 1 0 1.78 3.09 1.72 1.72 0 0 0 .4-.31l4.11 2.37a1.7 1.7 0 0 0-.07.51 1.78 1.78 0 0 0 3.56 0 1.69 1.69 0 0 0-.09-.56l4.09-2.36a1.7 1.7 0 0 0 .44.35 1.78 1.78 0 1 0 1.78-3.09zM6.72 15.69a1.72 1.72 0 0 0-.19-.47 1.53 1.53 0 0 0-.31-.4l5.38-9.33a1.82 1.82 0 0 0 1 0l5.4 9.33a1.53 1.53 0 0 0-.31.4 1.72 1.72 0 0 0-.19.47zM17.5 7.4a1.81 1.81 0 0 0 .17 1.38 1.75 1.75 0 0 0 1.12.84v4.76h-.07l-5.39-9.31.05-.07zM10.82 5a.12.12 0 0 0 0 .05L5.48 14.4h-.07V9.62a1.75 1.75 0 0 0 1.12-.84A1.81 1.81 0 0 0 6.7 7.4zm2.6 14a1.78 1.78 0 0 0-1.32-.58 1.75 1.75 0 0 0-1.28.54L6.7 16.6v-.06h10.78v.11z"
                }
            }
        ]
    })(props);
}
function BiLogoHeroku(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.17 2H4.83A1.79 1.79 0 0 0 3 3.8v16.4A1.79 1.79 0 0 0 4.83 22h14.34A1.8 1.8 0 0 0 21 20.2V3.8A1.8 1.8 0 0 0 19.17 2zM20 20.2a.8.8 0 0 1-.81.8H4.83a.79.79 0 0 1-.8-.8V3.8a.79.79 0 0 1 .8-.8h14.34a.8.8 0 0 1 .81.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7.53 19 2.25-2-2.25-2v4zm5.69-9a12 12 0 0 0-3.75.7V5h-2v8.65L8.88 13a12.3 12.3 0 0 1 4.29-1c1 0 1.25.55 1.25 1.05v6h2V13a2.68 2.68 0 0 0-.8-2.1 3.27 3.27 0 0 0-2.4-.9zM13 8.25h2A5.89 5.89 0 0 0 16.47 5h-2A7.17 7.17 0 0 1 13 8.25z"
                }
            }
        ]
    })(props);
}
function BiLogoHtml5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.136 3.012h15.729l-1.431 16.15-6.451 1.826-6.414-1.826-1.433-16.15zm5.266 7.302-.173-2.035 7.533.002.173-1.963-9.87-.002.522 5.998h6.835l-.243 2.566-2.179.602-2.214-.605-.141-1.58H7.691l.247 3.123L12 17.506l4.028-1.08.558-6.111H9.402v-.001z"
                }
            }
        ]
    })(props);
}
function BiLogoImdb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.646 10.237c-.057-.032-.16-.048-.313-.048v3.542c.201 0 .324-.041.371-.122s.07-.301.07-.66v-2.092c0-.244-.008-.4-.023-.469a.223.223 0 0 0-.105-.151zm3.499 1.182c-.082 0-.137.031-.162.091-.025.061-.037.214-.037.46v1.426c0 .237.014.389.041.456.029.066.086.1.168.1.086 0 .199-.035.225-.103.027-.069.039-.234.039-.495V11.97c0-.228-.014-.377-.043-.447-.032-.069-.147-.104-.231-.104z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM6.631 14.663H5.229V9.266h1.402v5.397zm4.822 0H10.23l-.006-3.643-.49 3.643h-.875L8.342 11.1l-.004 3.563H7.111V9.266H8.93c.051.327.107.71.166 1.15l.201 1.371.324-2.521h1.832v5.397zm3.664-1.601c0 .484-.027.808-.072.97a.728.728 0 0 1-.238.383.996.996 0 0 1-.422.193c-.166.037-.418.055-.754.055h-1.699V9.266h1.047c.678 0 1.07.031 1.309.093.24.062.422.164.545.306.125.142.203.3.234.475.031.174.051.516.051 1.026v1.896zm3.654.362c0 .324-.023.565-.066.723a.757.757 0 0 1-.309.413.947.947 0 0 1-.572.174c-.158 0-.365-.035-.502-.104a1.144 1.144 0 0 1-.377-.312l-.088.344h-1.262V9.266h1.35v1.755a1.09 1.09 0 0 1 .375-.289c.137-.064.344-.096.504-.096.186 0 .348.029.484.087a.716.716 0 0 1 .44.549c.016.1.023.313.023.638v1.514z"
                }
            }
        ]
    })(props);
}
function BiLogoInstagramAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.947 8.305a6.53 6.53 0 0 0-.419-2.216 4.61 4.61 0 0 0-2.633-2.633 6.606 6.606 0 0 0-2.186-.42c-.962-.043-1.267-.055-3.709-.055s-2.755 0-3.71.055a6.606 6.606 0 0 0-2.185.42 4.607 4.607 0 0 0-2.633 2.633 6.554 6.554 0 0 0-.419 2.185c-.043.963-.056 1.268-.056 3.71s0 2.754.056 3.71c.015.748.156 1.486.419 2.187a4.61 4.61 0 0 0 2.634 2.632 6.584 6.584 0 0 0 2.185.45c.963.043 1.268.056 3.71.056s2.755 0 3.71-.056a6.59 6.59 0 0 0 2.186-.419 4.615 4.615 0 0 0 2.633-2.633c.263-.7.404-1.438.419-2.187.043-.962.056-1.267.056-3.71-.002-2.442-.002-2.752-.058-3.709zm-8.953 8.297c-2.554 0-4.623-2.069-4.623-4.623s2.069-4.623 4.623-4.623a4.623 4.623 0 0 1 0 9.246zm4.807-8.339a1.077 1.077 0 0 1-1.078-1.078 1.077 1.077 0 1 1 2.155 0c0 .596-.482 1.078-1.077 1.078z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.994",
                    "cy": "11.979",
                    "r": "3.003"
                }
            }
        ]
    })(props);
}
function BiLogoInstagram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.999 7.377a4.623 4.623 0 1 0 0 9.248 4.623 4.623 0 0 0 0-9.248zm0 7.627a3.004 3.004 0 1 1 0-6.008 3.004 3.004 0 0 1 0 6.008z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.806",
                    "cy": "7.207",
                    "r": "1.078"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.533 6.111A4.605 4.605 0 0 0 17.9 3.479a6.606 6.606 0 0 0-2.186-.42c-.963-.042-1.268-.054-3.71-.054s-2.755 0-3.71.054a6.554 6.554 0 0 0-2.184.42 4.6 4.6 0 0 0-2.633 2.632 6.585 6.585 0 0 0-.419 2.186c-.043.962-.056 1.267-.056 3.71 0 2.442 0 2.753.056 3.71.015.748.156 1.486.419 2.187a4.61 4.61 0 0 0 2.634 2.632 6.584 6.584 0 0 0 2.185.45c.963.042 1.268.055 3.71.055s2.755 0 3.71-.055a6.615 6.615 0 0 0 2.186-.419 4.613 4.613 0 0 0 2.633-2.633c.263-.7.404-1.438.419-2.186.043-.962.056-1.267.056-3.71s0-2.753-.056-3.71a6.581 6.581 0 0 0-.421-2.217zm-1.218 9.532a5.043 5.043 0 0 1-.311 1.688 2.987 2.987 0 0 1-1.712 1.711 4.985 4.985 0 0 1-1.67.311c-.95.044-1.218.055-3.654.055-2.438 0-2.687 0-3.655-.055a4.96 4.96 0 0 1-1.669-.311 2.985 2.985 0 0 1-1.719-1.711 5.08 5.08 0 0 1-.311-1.669c-.043-.95-.053-1.218-.053-3.654 0-2.437 0-2.686.053-3.655a5.038 5.038 0 0 1 .311-1.687c.305-.789.93-1.41 1.719-1.712a5.01 5.01 0 0 1 1.669-.311c.951-.043 1.218-.055 3.655-.055s2.687 0 3.654.055a4.96 4.96 0 0 1 1.67.311 2.991 2.991 0 0 1 1.712 1.712 5.08 5.08 0 0 1 .311 1.669c.043.951.054 1.218.054 3.655 0 2.436 0 2.698-.043 3.654h-.011z"
                }
            }
        ]
    })(props);
}
function BiLogoInternetExplorer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.154 8.514c.85-2.039.906-3.738-.113-4.757-1.133-1.132-3.852-.792-6.737.565h-.341c-2.037 0-4.02.738-5.492 2.039-1.244 1.133-2.15 2.605-2.547 4.246.283-.337 1.869-2.207 3.68-3.226.058 0 .51-.283.51-.283-.057 0-.905.85-1.074 1.02-3.965 4.076-6.285 10.248-4.473 12.059 1.188 1.189 3.34.906 5.831-.452 1.075.51 2.265.735 3.565.735 1.699 0 3.285-.453 4.643-1.359 1.416-.906 2.436-2.319 3.059-3.962h-4.416c-.566 1.075-1.869 1.812-3.227 1.812-1.926 0-3.512-1.586-3.568-3.397v-.169h11.551v-.17c0-.283.057-.623.057-.848-.001-1.362-.341-2.664-.908-3.853zM4.811 19.838c-.906-.906-.621-2.662.453-4.756.51 1.416 1.359 2.662 2.435 3.567.341.282.735.565 1.133.792-1.814.963-3.285 1.133-4.021.397zm11.606-8.606H9.51v-.057c.113-1.756 1.754-3.285 3.681-3.285 1.812 0 3.284 1.416 3.397 3.285v.057h-.171zm3.454-3.171a6.948 6.948 0 0 0-1.303-1.585 8.445 8.445 0 0 0-2.718-1.699c1.813-.849 3.341-.961 4.134-.169.623.736.567 1.981-.113 3.453 0 .057 0 .057 0 0 0 .057 0 .057 0 0z"
                }
            }
        ]
    })(props);
}
function BiLogoInvision(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.361 3.008H4.638c-.901 0-1.63.729-1.63 1.63v14.724c0 .9.729 1.631 1.63 1.631h14.724c.9 0 1.631-.73 1.631-1.631V4.638a1.63 1.63 0 0 0-1.632-1.63zM9.018 6.505c.597 0 1.098.472 1.098 1.078 0 .616-.501 1.08-1.098 1.08v.022c-.604 0-1.09-.486-1.09-1.088 0-.605.486-1.092 1.09-1.092zm7.354 10.352c-1.112 0-1.651-.662-1.651-1.566 0-.26.033-.533.114-.812l.528-1.906c.068-.208.086-.405.086-.581 0-.615-.375-.984-.971-.984-.761 0-1.26.543-1.52 1.598l-1.033 4.146h-1.811l.327-1.303c-.534.873-1.271 1.412-2.183 1.412-1.102 0-1.617-.632-1.617-1.584a4.02 4.02 0 0 1 .096-.811l.826-3.366H6.285l.388-1.43h3.075l-1.216 4.804c-.08.309-.11.559-.11.738 0 .307.148.396.385.452.146.03 1.295.011 1.918-1.376l.798-3.188h-1.294l.391-1.404h2.787l-.359 1.617c.484-.899 1.452-1.762 2.406-1.762 1.012 0 1.855.728 1.855 2.111 0 .4-.063.796-.18 1.18l-.52 1.858a2.286 2.286 0 0 0-.075.492c0 .326.136.484.368.484.238 0 .553-.181.899-1.172l.708.272c-.414 1.473-1.182 2.081-2.137 2.081z"
                }
            }
        ]
    })(props);
}
function BiLogoJava(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.37 17.51c-3.09.86 1.87 2.64 5.8 1a7.18 7.18 0 0 1-1.1-.54 11.59 11.59 0 0 1-4.16.18c-1.31-.15-.54-.64-.54-.64zm5.33-1.68a16.27 16.27 0 0 1-5.36.26c-1.31-.14-.45-.77-.45-.77-3.4 1.12 1.89 2.4 6.64 1a2.25 2.25 0 0 1-.83-.49zm1.82-9.73s-6.87 1.71-3.59 5.49a1.47 1.47 0 0 1-.25 2.12s2.46-1.27 1.33-2.86-1.86-2.22 2.51-4.75z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.13 19.14s.56.46-.63.82c-2.27.69-9.43.9-11.42 0-.72-.31.62-.74 1-.83a2.54 2.54 0 0 1 .69-.08c-.8-.56-5.15 1.1-2.21 1.58 8.05 1.37 14.64-.56 12.57-1.49zm-2.76-4.88a7 7 0 0 1 .92-.49s-1.51.27-3 .4a28.11 28.11 0 0 1-4.82.05C6.09 13.91 9.74 13 9.74 13a6.81 6.81 0 0 0-3.16.75c-2.06 1.03 5.09 1.48 8.79.51zm.91 2.44a.39.39 0 0 1-.08.09c5-1.32 3.18-4.65.78-3.81a.71.71 0 0 0-.33.25s.14-.05.43-.12c1.22-.25 2.92 1.63-.8 3.59zM12 13c-.74-1.67-3.26-3.14 0-5.71C16.09 4.08 14 2 14 2c.84 3.31-3 4.31-4.34 6.37-.93 1.41.47 2.92 2.34 4.63z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.41 21.32a29.75 29.75 0 0 1-9.14.14s.46.38 2.84.53c3.61.23 9.15-.12 9.29-1.83 0 0-.26.64-2.99 1.16z"
                }
            }
        ]
    })(props);
}
function BiLogoJavascript(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3h18v18H3V3zm16.525 13.707c-.131-.821-.666-1.511-2.252-2.155-.552-.259-1.165-.438-1.349-.854-.068-.248-.078-.382-.034-.529.113-.484.687-.629 1.137-.495.293.09.563.315.732.676.775-.507.775-.507 1.316-.844-.203-.314-.304-.451-.439-.586-.473-.528-1.103-.798-2.126-.775l-.528.067c-.507.124-.991.395-1.283.754-.855.968-.608 2.655.427 3.354 1.023.765 2.521.933 2.712 1.653.18.878-.652 1.159-1.475 1.058-.607-.136-.945-.439-1.316-1.002l-1.372.788c.157.359.337.517.607.832 1.305 1.316 4.568 1.249 5.153-.754.021-.067.18-.528.056-1.237l.034.049zm-6.737-5.434h-1.686c0 1.453-.007 2.898-.007 4.354 0 .924.047 1.772-.104 2.033-.247.517-.886.451-1.175.359-.297-.146-.448-.349-.623-.641-.047-.078-.082-.146-.095-.146l-1.368.844c.229.473.563.879.994 1.137.641.383 1.502.507 2.404.305.588-.17 1.095-.519 1.358-1.059.384-.697.302-1.553.299-2.509.008-1.541 0-3.083 0-4.635l.003-.042z"
                }
            }
        ]
    })(props);
}
function BiLogoJoomla(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m15.539 14.059-1.874 1.875-1.777 1.777-.347.35a3.993 3.993 0 0 1-3.785 1.048A2.41 2.41 0 0 1 3 18.567c0-1.138.792-2.092 1.852-2.342a3.993 3.993 0 0 1 1.047-3.811l.135-.135 1.777 1.778-.138.135a1.48 1.48 0 0 0 0 2.092 1.462 1.462 0 0 0 2.09 0l.349-.349 1.775-1.778 1.877-1.879 1.775 1.781zm.693 4.988a3.986 3.986 0 0 1-3.996-.988l-.135-.139 1.773-1.777.135.139a1.48 1.48 0 0 0 2.09 0 1.474 1.474 0 0 0-.002-2.086l-.35-.349-1.773-1.777-1.877-1.878 1.777-1.776 1.875 1.879 1.774 1.777.349.349a3.962 3.962 0 0 1 1.058 3.766 2.407 2.407 0 0 1-.336 4.79 2.392 2.392 0 0 1-2.352-1.924l-.01-.006zm-8.001-8.962 1.881-1.879 1.777-1.777.347-.346a3.972 3.972 0 0 1 3.949-1.002 2.408 2.408 0 1 1 2.699 2.716 3.98 3.98 0 0 1-1.012 3.925l-.137.139-1.777-1.777.139-.138a1.474 1.474 0 1 0-2.086-2.085l-.347.346-1.777 1.776-1.879 1.876-1.777-1.774zm-1.99 1.984-.346-.347a3.984 3.984 0 0 1-.999-3.965 2.414 2.414 0 0 1-1.874-2.35A2.41 2.41 0 0 1 5.43 3c1.197 0 2.19.875 2.378 2.019a3.99 3.99 0 0 1 3.734 1.061l.138.14-1.778 1.776-.137-.136a1.481 1.481 0 0 0-2.088 0 1.481 1.481 0 0 0-.004 2.092l.349.35 1.777 1.777 1.879 1.879-1.775 1.777-1.883-1.879-1.778-1.777v-.01h-.001z"
                }
            }
        ]
    })(props);
}
function BiLogoJquery(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.345 6.935c-1.756 2.523-1.538 5.806-.196 8.487l.098.19c.021.04.041.082.063.121.012.024.026.047.039.069a7.842 7.842 0 0 0 .198.344l.073.12a9.14 9.14 0 0 0 .211.33 10.179 10.179 0 0 0 .221.319l.036.049c.063.088.129.175.196.261l.074.094.182.223.069.082c.082.097.167.194.252.289l.005.005c.004.004.007.006.01.011.083.091.17.181.256.271l.083.083.205.201.084.08c.092.087.186.172.281.256l.004.004.049.041c.083.073.169.145.255.215l.105.084a11.03 11.03 0 0 0 .565.424c.029.021.057.042.087.062l.024.017c.076.053.154.103.231.153.033.022.066.045.101.067a10.975 10.975 0 0 0 .886.509c.065.034.129.068.195.101l.045.022.08.039c.102.048.205.097.308.143l.066.029c.119.052.239.102.36.149l.088.035a13.895 13.895 0 0 0 .382.142c.125.044.252.085.38.124l.092.028c.128.039.256.085.39.11 8.492 1.548 10.958-5.102 10.958-5.102-2.072 2.698-5.748 3.41-9.232 2.618-.132-.03-.261-.071-.39-.109l-.097-.029a10.929 10.929 0 0 1-.755-.264l-.093-.036c-.12-.047-.239-.097-.356-.148l-.071-.031a11.932 11.932 0 0 1-.301-.14l-.087-.042c-.078-.038-.155-.079-.232-.118-.051-.027-.104-.053-.155-.082a8.294 8.294 0 0 1-.278-.156l-.094-.052a11.4 11.4 0 0 1-.363-.223l-.098-.065a10.557 10.557 0 0 1-.259-.172l-.083-.059c-.082-.058-.164-.116-.244-.176a11.921 11.921 0 0 1-.328-.255l-.099-.079c-.092-.076-.184-.152-.274-.231a12.01 12.01 0 0 1-.319-.288c-.028-.026-.055-.051-.081-.078a7.985 7.985 0 0 1-.208-.203l-.081-.081a10.76 10.76 0 0 1-.254-.269l-.012-.012a11.75 11.75 0 0 1-.258-.293l-.067-.081a10.313 10.313 0 0 1-.254-.313 11.855 11.855 0 0 1-.215-.286C3.864 11.825 3.17 8.186 4.715 5.198"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.794 4.809c-1.27 1.827-1.2 4.273-.21 6.205.166.324.353.639.561.938.191.273.401.597.654.816.092.101.187.199.284.295l.076.074c.094.092.19.182.291.271l.011.01.003.002c.111.097.224.19.34.281l.078.06a8.281 8.281 0 0 0 .366.268c.053.037.108.072.161.107.026.017.051.035.078.051a7.14 7.14 0 0 0 .301.184c.076.044.155.087.233.13.026.015.055.029.082.043.055.028.108.057.163.083a9.645 9.645 0 0 0 .365.171l.074.031c.093.039.186.077.281.113l.117.044c.086.032.171.06.256.089l.117.037c.121.038.243.085.37.107 6.556 1.086 8.068-3.961 8.068-3.961-1.364 1.964-4.006 2.902-6.825 2.17a7.866 7.866 0 0 1-.743-.232l-.118-.043a7.629 7.629 0 0 1-.353-.145 8.79 8.79 0 0 1-.344-.159c-.057-.028-.113-.058-.17-.087l-.099-.051a9.352 9.352 0 0 1-.533-.313l-.08-.053a7.65 7.65 0 0 1-.602-.435c-1.234-.974-2.213-2.306-2.678-3.815-.488-1.566-.382-3.323.462-4.75"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.379 3.221c-.749 1.102-.823 2.469-.304 3.686.548 1.292 1.671 2.304 2.981 2.785a3.85 3.85 0 0 0 .234.079c.077.024.152.053.233.067 3.62.699 4.601-1.857 4.862-2.234-.86 1.239-2.306 1.536-4.078 1.105a5.403 5.403 0 0 1-.939-.344 5.39 5.39 0 0 1-.895-.545c-1.585-1.204-2.573-3.501-1.536-5.372"
                }
            }
        ]
    })(props);
}
function BiLogoJsfiddle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.58 11.375c.008-.117.018-.231.018-.35 0-3.243-2.668-5.871-5.959-5.871A5.966 5.966 0 0 0 8.26 8.502a2.732 2.732 0 0 0-1.674-.568c-1.521 0-2.752 1.21-2.752 2.704 0 .283.043.554.125.808a3.957 3.957 0 0 0-1.98 3.418c0 2.173 1.773 3.938 3.975 3.972h11.898c.074 0 .15.012.227.012 2.178 0 3.943-1.739 3.943-3.893a3.885 3.885 0 0 0-2.432-3.579h-.01v-.001zM7.355 15.842a2.329 2.329 0 0 1-.748-1.318 2.865 2.865 0 0 1-.053-.544c0-.74.27-1.347.809-1.827.537-.48 1.221-.722 2.049-.722.854 0 1.654.32 2.363.957.176.158.352.338.514.536l.912 1.071c.158.217.324.399.5.56.471.422.977.632 1.408.632.365 0 .67-.112.912-.336.209-.19.336-.45.363-.73l.008-.123a1.054 1.054 0 0 0-.055-.347 1.275 1.275 0 0 0-1.238-.838c-.453 0-.902.153-1.396.631l-.807-.95-.088-.108c.713-.691 1.414-.95 2.367-.95.838 0 1.525.237 2.037.712l.014.014c.539.474.801 1.089.801 1.842a2.6 2.6 0 0 1-.049.528 2.38 2.38 0 0 1-.74 1.301 2.685 2.685 0 0 1-1.428.677 4.505 4.505 0 0 1-.588.038c-.863 0-1.676-.313-2.365-.938a4.866 4.866 0 0 1-.537-.576l-.914-1.065a3.58 3.58 0 0 0-.488-.563c-.463-.425-.977-.626-1.428-.626-.129 0-.26.018-.389.051a1.19 1.19 0 0 0-.523.289c-.232.216-.365.52-.365.839 0 .324.113.6.352.825l.014.013c.25.227.563.338.926.338.463 0 .914-.162 1.4-.639l.801.938.088.099c-.725.703-1.428.965-2.342.965-.838 0-1.525-.238-2.051-.713l-.046.057z"
                }
            }
        ]
    })(props);
}
function BiLogoKickstarter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10.198 9.127 3.309-4.799c.628-.902 1.434-1.354 2.427-1.354.806 0 1.506.287 2.097.861.59.574.885 1.26.885 2.059 0 .59-.155 1.113-.469 1.563l-2.983 4.34 3.649 4.627c.363.461.547 1 .547 1.617 0 .816-.286 1.518-.86 2.105a2.81 2.81 0 0 1-2.084.879c-.895 0-1.577-.291-2.047-.873L10.2 14.574v3.074c0 .879-.152 1.561-.457 2.049-.555.885-1.356 1.328-2.417 1.328-.963 0-1.711-.328-2.24-.977-.496-.602-.744-1.396-.744-2.387V6.258c0-.936.253-1.709.755-2.318.525-.643 1.255-.965 2.186-.965.887 0 1.624.322 2.216.965.329.357.537.717.625 1.082.053.227.079.646.079 1.266v2.84h-.005z"
                }
            }
        ]
    })(props);
}
function BiLogoKubernetes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10.013 13.738-2.254.387a4.475 4.475 0 0 0 1.753 2.231l.865-2.095a.27.27 0 0 0 .022-.228c-.022-.18-.204-.295-.386-.295zm.865-2.914c.205 0 .387-.159.387-.364l.114-2.277-.456.091a4.516 4.516 0 0 0-2.118 1.162l1.89 1.343c.069.022.115.045.183.045zm-1.002 1.48a.366.366 0 0 0-.045-.524l-1.685-1.503a4.797 4.797 0 0 0-.661 2.778l2.209-.637c.091-.023.137-.046.182-.114zm1.457.797.616.296.614-.296.16-.661-.433-.546h-.683l-.433.546zm1.344-2.436c.114.159.341.182.5.091l1.867-1.32a4.286 4.286 0 0 0-2.573-1.23l.137 2.3a.215.215 0 0 0 .069.159z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m21.944 14.103-1.73-7.446c-.113-.364-.387-.66-.729-.842L12.541 2.49c-.182-.091-.387-.114-.569-.114s-.387 0-.569.045L4.457 5.769a1.22 1.22 0 0 0-.683.842l-1.708 7.492c-.068.387.023.774.25 1.093l4.805 5.943c.273.273.66.456 1.047.479h7.651c.41.045.797-.137 1.048-.479l4.805-5.943c.227-.319.318-.706.272-1.093zm-2.845.501c-.046 0-.068 0-.114-.023-.022-.023-.022-.023-.045-.023-.046 0-.068-.022-.092-.022-.091-.023-.159-.068-.25-.114a.32.32 0 0 1-.137-.045h-.022a3.91 3.91 0 0 0-.729-.205h-.022a.26.26 0 0 0-.182.068s0 .023-.023.023l-.183-.024a5.628 5.628 0 0 1-2.46 3.097l.068.182s-.022 0-.022.022a.264.264 0 0 0-.022.228c.091.228.205.455.364.66v.045a.396.396 0 0 1 .091.114.81.81 0 0 1 .159.228c.023.022.046.045.046.068 0 0 .022 0 .022.022a.582.582 0 0 1 .023.342.38.38 0 0 1-.205.25c-.068.022-.114.045-.183.045a.511.511 0 0 1-.433-.273c-.022 0-.022-.022-.022-.022-.022-.023-.022-.045-.046-.068-.045-.068-.068-.159-.091-.25l-.046-.137v-.022a3.816 3.816 0 0 0-.296-.706.353.353 0 0 0-.182-.137c0-.023 0-.023-.023-.023l-.091-.159c-.228.068-.479.159-.729.205-.41.114-.82.159-1.229.159a5.368 5.368 0 0 1-1.981-.364l-.091.182c0 .023 0 .023-.023.023a.35.35 0 0 0-.182.137c-.114.228-.228.455-.296.706l-.045.137c-.023.091-.068.159-.091.25-.022.023-.045.045-.045.068-.023 0-.023.022-.023.022a.508.508 0 0 1-.433.273.434.434 0 0 1-.159-.045.469.469 0 0 1-.182-.615c.023 0 .023-.023.023-.023.022-.023.022-.045.045-.068.068-.091.114-.182.159-.228s.068-.068.091-.114v-.023a3.73 3.73 0 0 0 .364-.66.268.268 0 0 0-.023-.228s-.022 0-.022-.022l.114-.16a3.578 3.578 0 0 1-.615-.41 5.493 5.493 0 0 1-1.867-2.664l-.205.022s0-.022-.023-.022a.256.256 0 0 0-.182-.068h-.022a4.015 4.015 0 0 0-.751.205h-.024c-.045 0-.091.023-.137.046-.068.022-.159.068-.25.091-.022 0-.091-.022-.091 0 0 .023 0 .023-.023.023-.045.023-.068.023-.114.023a.424.424 0 0 1-.456-.319.445.445 0 0 1 .364-.524c.023-.023.023-.023.046-.023.045 0 .068-.022.091-.022.091 0 .182-.023.273-.023.045-.022.091-.022.137-.022a4.2 4.2 0 0 0 .774-.137c.068-.046.137-.091.16-.16 0 0 .022 0 .022-.022l.182-.046c-.205-1.298.091-2.618.797-3.734.022-.045.045-.068.068-.114l-.131-.132a.106.106 0 0 1-.004.019v-.023l.004.004c.01-.065-.031-.145-.072-.186-.182-.182-.41-.319-.638-.455l-.136-.069a2.587 2.587 0 0 1-.251-.136c-.022 0-.068-.045-.068-.045s0-.023-.022-.023a.49.49 0 0 1-.092-.639c.068-.114.182-.159.319-.159a.54.54 0 0 1 .319.114l.023.023c.022.022.045.022.068.045.068.069.114.137.182.205.023.022.068.045.091.091.159.182.364.364.569.524.045.022.091.045.137.045.045 0 .068-.023.091-.023h.023l.137.091a5.426 5.426 0 0 1 2.801-1.594c.273-.046.523-.091.774-.114l.023-.182v-.045c.068-.045.091-.114.114-.182 0-.273 0-.524-.045-.774v-.023c0-.045 0-.091-.023-.137a1.129 1.129 0 0 1-.045-.273v-.113c0-.114.045-.228.137-.319.114-.114.25-.182.387-.159a.45.45 0 0 1 .387.478v.137c-.023.091-.023.182-.045.273 0 .045-.023.091-.023.136v.023c-.048.273-.048.524-.048.774.023.068.045.136.114.182v-.023l.023.182a5.84 5.84 0 0 1 2.96 1.184c.183.182.387.364.569.546l.183-.114h.022c.022.023.068.023.091.023.046 0 .091-.023.137-.045.205-.137.41-.319.569-.501.022-.023.068-.046.091-.091.046-.068.114-.137.183-.205.022 0 .045-.022.068-.045l.022-.023a.546.546 0 0 1 .318-.114c.114 0 .251.068.319.16.159.205.113.478-.091.637 0 .023.022.023 0 .046-.023.022-.046.022-.068.045-.092.045-.16.091-.251.137l-.137.068a4.104 4.104 0 0 0-.638.455c-.045.046-.068.137-.068.205v.023l-.136.137c.364.569.638 1.207.797 1.867.137.66.182 1.343.091 2.003l.182.046a.278.278 0 0 0 .16.159c.25.068.523.114.773.137h.023a.297.297 0 0 0 .137.022c.091 0 .182 0 .272.023.046 0 .092 0 .092.023 0 .022.022.022.045.022a.537.537 0 0 1 .41.479.49.49 0 0 1-.453.32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.085 14.718a.352.352 0 0 0-.455.091l-1.116 2.027c.456.136.957.228 1.435.228.341 0 .66-.045.979-.114.159-.045.296-.068.433-.091l-1.093-1.981c-.069-.069-.115-.115-.183-.16zm3.644-4.441-1.708 1.548a.36.36 0 0 0-.091.16c-.046.205.068.41.273.455l2.163.615a4.375 4.375 0 0 0-.092-1.435 4.63 4.63 0 0 0-.545-1.343zm-2.073 3.484a.371.371 0 0 0-.205.433l.889 2.141a4.366 4.366 0 0 0 1.366-1.366c.182-.25.318-.547.433-.865l-2.277-.387a.634.634 0 0 0-.206.044z"
                }
            }
        ]
    })(props);
}
function BiLogoLess(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.142 10.843c0-.64.098-1.018.098-1.707 0-1.067-.393-1.411-1.263-1.411h-.641v.755h.196c.444 0 .542.147.542.689 0 .509-.049 1.018-.049 1.608 0 .755.246 1.05.739 1.165v.049c-.493.116-.739.411-.739 1.166 0 .591.049 1.067.049 1.608 0 .558-.114.705-.542.705v.017h-.196v.788h.641c.87 0 1.263-.344 1.263-1.411 0-.706-.098-1.067-.098-1.707 0-.345.213-.706.854-.739v-.853c-.642-.016-.854-.377-.854-.722zm-3.299 1.001c-.493-.196-.952-.312-.952-.64 0-.246.197-.395.558-.395.361 0 .689.148 1.05.411l.657-.87c-.409-.313-.968-.641-1.724-.641-1.115 0-1.871.641-1.871 1.544 0 .804.706 1.214 1.298 1.443.508.196 1.001.361 1.001.689 0 .246-.197.41-.641.41-.41 0-.821-.164-1.263-.509l-.657.952c.492.41 1.247.689 1.871.689 1.313 0 2.019-.689 2.019-1.592-.001-.9-.707-1.277-1.346-1.491zm-11.21 1.854c-.114 0-.262-.098-.262-.41V7.725H4.039c-.886 0-1.279.344-1.279 1.411 0 .706.099 1.101.099 1.707 0 .345-.213.706-.854.739v.853c.641.017.854.378.854.723 0 .606-.099.968-.099 1.674 0 1.067.394 1.411 1.264 1.411h.64v-.755h-.197c-.411 0-.542-.164-.542-.706 0-.541.049-1.001.049-1.607 0-.756-.245-1.05-.738-1.165v-.051c.493-.114.738-.409.738-1.165 0-.59-.049-1.066-.049-1.607 0-.542.114-.689.542-.689h.442v4.711c0 1.001.345 1.657 1.346 1.657.313 0 .559-.05.739-.115l-.165-1.066c-.098.013-.146.013-.196.013zm7.238-1.854c-.509-.196-.969-.312-.969-.64 0-.246.197-.395.558-.395.361 0 .689.148 1.051.411l.656-.87c-.41-.313-.968-.641-1.723-.641-1.116 0-1.872.641-1.872 1.544 0 .804.707 1.214 1.297 1.443.51.196 1.002.361 1.002.689 0 .246-.197.41-.641.41-.41 0-.82-.164-1.264-.509l-.64.952c.492.41 1.247.689 1.871.689 1.313 0 2.019-.689 2.019-1.592.001-.9-.705-1.277-1.345-1.491zm-4.842-2.15c-1.198 0-2.347 1.001-2.314 2.577 0 1.624 1.066 2.576 2.479 2.576.591 0 1.247-.214 1.756-.558l-.492-.87c-.36.213-.706.312-1.066.312-.657 0-1.165-.312-1.297-1.066h2.971c.017-.115.049-.345.049-.607.016-1.33-.707-2.364-2.086-2.364zm-.935 2.068c.099-.655.492-.969.951-.969.592 0 .821.411.821.969H8.094z"
                }
            }
        ]
    })(props);
}
function BiLogoLinkedinSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM8.339 18.337H5.667v-8.59h2.672v8.59zM7.003 8.574a1.548 1.548 0 1 1 0-3.096 1.548 1.548 0 0 1 0 3.096zm11.335 9.763h-2.669V14.16c0-.996-.018-2.277-1.388-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248h-2.667v-8.59h2.56v1.174h.037c.355-.675 1.227-1.387 2.524-1.387 2.704 0 3.203 1.778 3.203 4.092v4.71z"
                }
            }
        ]
    })(props);
}
function BiLogoLinkedin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "4.983",
                    "cy": "5.009",
                    "r": "2.188"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.237 8.855v12.139h3.769v-6.003c0-1.584.298-3.118 2.262-3.118 1.937 0 1.961 1.811 1.961 3.218v5.904H21v-6.657c0-3.27-.704-5.783-4.526-5.783-1.835 0-3.065 1.007-3.568 1.96h-.051v-1.66H9.237zm-6.142 0H6.87v12.139H3.095z"
                }
            }
        ]
    })(props);
}
function BiLogoMagento(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 22.019-3.717-2.146V9.863l2.479-1.43v10.01l1.238.753 1.238-.753V8.434l2.479 1.43v10.01L12 22.019zm8.666-15.014v10.009l-2.475 1.43V8.434L12 4.861 5.807 8.434v10.01l-2.473-1.43V7.005L12 2l8.666 5.005z"
                }
            }
        ]
    })(props);
}
function BiLogoMailchimp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.279 11.506c.132-.016.257-.018.373 0 .066-.154.078-.419.019-.708-.09-.429-.211-.688-.461-.646-.251.04-.261.35-.17.779.05.24.14.446.239.575zm-2.149.339c.18.078.29.129.331.086.029-.028.021-.084-.022-.154a1.05 1.05 0 0 0-.464-.371 1.26 1.26 0 0 0-1.228.146c-.119.088-.232.209-.218.283.007.023.023.042.065.05.099.011.444-.164.843-.188.282-.02.513.068.693.148zm-.361.205c-.232.037-.361.113-.443.187-.071.062-.113.128-.113.177l.018.042.037.014c.053 0 .171-.046.171-.046.324-.115.539-.102.752-.078.117.014.172.02.198-.02.007-.012.018-.035-.007-.074-.056-.091-.291-.24-.613-.202zm1.784.756c.159.078.333.046.39-.069.059-.115-.024-.272-.183-.349-.158-.079-.333-.049-.39.066-.057.115.026.274.183.352zm1.018-.891c-.128-.002-.234.138-.238.316-.003.177.1.321.229.322.129.002.235-.139.238-.315s-.099-.32-.229-.323zm-8.644 3.183c-.032-.04-.085-.029-.136-.015-.036.007-.076.017-.119.016a.265.265 0 0 1-.221-.111c-.059-.09-.056-.225.01-.378l.03-.069c.104-.231.275-.619.082-.988a.88.88 0 0 0-.671-.488.861.861 0 0 0-.739.267c-.284.313-.327.741-.273.893.021.056.053.071.075.074.048.007.119-.029.164-.15l.014-.038c.02-.064.057-.184.118-.278a.518.518 0 0 1 .717-.15c.2.131.275.375.19.608-.044.121-.115.351-.1.54.032.383.27.537.48.556.206.007.35-.108.387-.193.021-.053.003-.084-.008-.096z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.821 14.397c-.009-.029-.061-.216-.13-.44l-.144-.384c.281-.423.286-.799.249-1.013a1.284 1.284 0 0 0-.372-.724c-.222-.232-.677-.472-1.315-.651l-.335-.093c-.002-.015-.018-.79-.031-1.123-.011-.24-.031-.616-.148-.986-.14-.502-.381-.938-.684-1.221.835-.864 1.355-1.817 1.354-2.634-.003-1.571-1.933-2.049-4.312-1.063l-.503.214c-.002-.002-.911-.894-.924-.905-2.714-2.366-11.192 7.06-8.48 9.349l.593.501a2.916 2.916 0 0 0-.166 1.345c.065.631.389 1.234.915 1.701.5.442 1.159.724 1.796.723 1.055 2.432 3.465 3.922 6.291 4.007 3.032.09 5.576-1.333 6.644-3.889.069-.179.365-.987.365-1.7-.001-.718-.406-1.015-.663-1.014zM7.416 16.309a1.38 1.38 0 0 1-.28.021c-.916-.026-1.905-.85-2.003-1.827-.109-1.08.443-1.912 1.421-2.108.116-.025.258-.038.41-.031.548.032 1.354.452 1.539 1.645.164 1.055-.096 2.132-1.087 2.3zm-1.021-4.562a2.325 2.325 0 0 0-1.473.94c-.197-.164-.562-.48-.626-.604-.524-.994.571-2.928 1.337-4.02 1.889-2.698 4.851-4.739 6.223-4.371.222.064.96.921.96.921s-1.37.759-2.642 1.819c-1.711 1.32-3.006 3.236-3.779 5.315zm9.611 4.158a.05.05 0 0 0 .03-.054.05.05 0 0 0-.056-.045s-1.434.212-2.789-.283c.147-.479.541-.308 1.134-.259a8.287 8.287 0 0 0 2.735-.296c.613-.177 1.419-.524 2.045-1.018.212.465.286.975.286.975s.163-.029.3.055c.13.08.224.245.16.671-.133.798-.471 1.445-1.042 2.041a4.259 4.259 0 0 1-1.249.934 5.337 5.337 0 0 1-.814.346c-2.149.701-4.349-.07-5.058-1.727a2.761 2.761 0 0 1-.142-.392c-.302-1.092-.046-2.4.755-3.226v-.001c.051-.052.102-.113.102-.191 0-.064-.042-.133-.077-.183-.28-.406-1.253-1.099-1.057-2.44.139-.964.982-1.642 1.768-1.602l.2.012c.34.02.637.063.917.076.47.019.891-.049 1.391-.465.169-.142.304-.263.532-.301.024-.006.084-.025.203-.021a.681.681 0 0 1 .343.109c.4.266.457.912.479 1.385.012.269.045.922.055 1.108.026.428.139.489.365.563.129.044.248.074.423.125.529.147.845.3 1.043.493a.637.637 0 0 1 .188.372c.065.457-.353 1.021-1.455 1.533-1.206.559-2.669.701-3.679.588l-.354-.04c-.81-.108-1.269.936-.784 1.651.313.461 1.164.761 2.017.761 1.953.002 3.455-.832 4.015-1.554l.044-.063c.026-.042.005-.063-.03-.041-.455.312-2.483 1.552-4.651 1.18 0 0-.264-.044-.504-.138-.19-.072-.591-.258-.639-.668 1.747.543 2.85.031 2.85.03zm-2.773-.327zM9.886 8.053c.672-.776 1.499-1.452 2.241-1.83.025-.014.052.015.038.038a2.125 2.125 0 0 0-.208.508c-.006.027.023.049.046.032.462-.314 1.264-.651 1.968-.693a.03.03 0 0 1 .021.055 1.66 1.66 0 0 0-.31.311c-.014.02-.001.049.024.049.494.003 1.191.175 1.644.43.03.018.008.077-.025.069-.688-.157-1.811-.277-2.979.008-1.044.254-1.84.646-2.419 1.069-.03.02-.065-.019-.041-.046z"
                }
            }
        ]
    })(props);
}
function BiLogoMarkdown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.553 18.15H3.447a1.443 1.443 0 0 1-1.442-1.441V7.291c0-.795.647-1.441 1.442-1.441h17.105c.795 0 1.442.646 1.442 1.441v9.418a1.441 1.441 0 0 1-1.441 1.441zM6.811 15.268V11.52l1.922 2.402 1.922-2.402v3.748h1.922V8.732h-1.922l-1.922 2.403-1.922-2.403H4.889v6.535h1.922zM19.688 12h-1.922V8.732h-1.923V12h-1.922l2.884 3.364L19.688 12z"
                }
            }
        ]
    })(props);
}
function BiLogoMastercard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.454 17.021c.048.041.1.082.151.122a6.173 6.173 0 0 1-3.42 1.03A6.17 6.17 0 0 1 2.01 12a6.175 6.175 0 0 1 9.592-5.144c-.05.043-.1.082-.138.126A6.633 6.633 0 0 0 9.166 12c0 1.925.833 3.755 2.288 5.021zm4.361-11.195a6.14 6.14 0 0 0-3.416 1.03c.049.043.099.082.137.126 1.462 1.263 2.299 3.094 2.299 5.018s-.835 3.753-2.288 5.021c-.049.041-.101.082-.151.122a6.162 6.162 0 0 0 3.418 1.03 6.174 6.174 0 1 0 .001-12.347zM12 7.15A6.152 6.152 0 0 0 9.644 12 6.15 6.15 0 0 0 12 16.853 6.157 6.157 0 0 0 14.357 12 6.15 6.15 0 0 0 12 7.15z"
                }
            }
        ]
    })(props);
}
function BiLogoMastodon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 17.24c2.5-.3 4.69-1.84 5-3.25a33.59 33.59 0 0 0 .4-5.42C21.33 4.23 18.48 3 18.48 3A17.64 17.64 0 0 0 12 2a17.64 17.64 0 0 0-6.48 1S2.68 4.23 2.68 8.57v3.44c.1 4.24.78 8.42 4.7 9.46A14.73 14.73 0 0 0 12 22a9.21 9.21 0 0 0 3.54-.81l-.07-1.64A11.41 11.41 0 0 1 12 20c-1.8-.06-3.71-.19-4-2.4a4.26 4.26 0 0 1 0-.63 22.68 22.68 0 0 0 4 .54 23.6 23.6 0 0 0 4-.27zm-6.54-9.8q-1.35 0-1.35 1.62v5.1H6V8.9a3.78 3.78 0 0 1 .82-2.56 2.85 2.85 0 0 1 2.23-1 2.68 2.68 0 0 1 2.4 1.23l.52.87.52-.87a2.68 2.68 0 0 1 2.4-1.23 2.85 2.85 0 0 1 2.23 1A3.78 3.78 0 0 1 18 8.9v5.26h-2.11v-5.1q0-1.62-1.35-1.62c-1 0-1.51.64-1.51 1.92v2.79H11V9.36c0-1.28-.54-1.92-1.54-1.92z"
                }
            }
        ]
    })(props);
}
function BiLogoMediumOld(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.957 6.73a.073.073 0 0 0-.019-.097c-.004-.004-.008-.008-.012-.01l-.006-.002-6.033-3.018a.729.729 0 0 0-.292-.067.692.692 0 0 0-.586.317l-3.474 5.646 4.359 7.083 6.063-9.852zm-1.064 13.543c.611.306 1.107.092 1.107-.478V8.483l-5.809 9.439 4.702 2.351zM9.622 8.213v6.426l5.711 2.855zm-7.068 9.558 5.19 2.595a.845.845 0 0 0 .374.098c.323 0 .549-.25.549-.669V6.701a.067.067 0 0 0-.035-.059L2.739 3.697a.669.669 0 0 0-.3-.079c-.258 0-.439.199-.439.534v12.723c0 .341.25.744.554.896z"
                }
            }
        ]
    })(props);
}
function BiLogoMediumSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-2.046 4.265-.966.925a.28.28 0 0 0-.106.271v6.801a.28.28 0 0 0 .106.271l.942.926v.204h-4.741v-.204l.977-.948c.097-.096.097-.125.097-.271V9.742l-2.716 6.896h-.368L8.018 9.742v4.622a.644.644 0 0 0 .176.531l1.271 1.541v.203H5.861v-.203l1.271-1.541a.618.618 0 0 0 .164-.531V9.02a.468.468 0 0 0-.152-.395l-1.13-1.36v-.203H9.52l2.71 5.943 2.382-5.943h3.343v.203z"
                }
            }
        ]
    })(props);
}
function BiLogoMedium(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.285 7.269a.733.733 0 0 0-.24-.619l-1.77-2.133v-.32h5.498l4.25 9.32 3.736-9.32H21v.319l-1.515 1.451a.45.45 0 0 0-.168.425v10.666a.448.448 0 0 0 .168.425l1.479 1.451v.319h-7.436v-.319l1.529-1.487c.152-.15.152-.195.152-.424V8.401L10.95 19.218h-.575L5.417 8.401v7.249c-.041.305.06.612.275.833L7.684 18.9v.319H2.036V18.9l1.992-2.417a.971.971 0 0 0 .257-.833V7.269z"
                }
            }
        ]
    })(props);
}
function BiLogoMessenger(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3c-4.92 0-8.91 3.729-8.91 8.332 0 2.616 1.291 4.952 3.311 6.479V21l3.041-1.687c.811.228 1.668.35 2.559.35 4.92 0 8.91-3.73 8.91-8.331C20.91 6.729 16.92 3 12 3zm.938 11.172-2.305-2.394-4.438 2.454 4.865-5.163 2.305 2.395 4.439-2.455-4.866 5.163z"
                }
            }
        ]
    })(props);
}
function BiLogoMeta(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.26 7.8a4.82 4.82 0 0 0-3.93-2.44 3.91 3.91 0 0 0-2.54 1.09 10.58 10.58 0 0 0-1.52 1.71 11 11 0 0 0-1.63-1.72 4.39 4.39 0 0 0-2.88-1.08A5 5 0 0 0 3.7 8 11.49 11.49 0 0 0 2 14a7 7 0 0 0 .18 1.64A4.44 4.44 0 0 0 2.71 17a3.23 3.23 0 0 0 3 1.6c1.25 0 2.19-.56 3.3-2a26.4 26.4 0 0 0 2.21-3.6l.63-1.12c.06-.09.11-.18.16-.27l.15.25 1.79 3A14.77 14.77 0 0 0 16 17.63a3.38 3.38 0 0 0 2.55 1 3 3 0 0 0 2.54-1.23 2.2 2.2 0 0 0 .18-.28 4.1 4.1 0 0 0 .31-.63l.12-.35A6.53 6.53 0 0 0 22 15a9 9 0 0 0 0-1 11.15 11.15 0 0 0-1.74-6.2zm-10.12 3.56c-.64 1-1.57 2.51-2.37 3.61-1 1.37-1.51 1.51-2.07 1.51a1.29 1.29 0 0 1-1.15-.66 3.3 3.3 0 0 1-.39-1.7A9.74 9.74 0 0 1 5.54 9a2.8 2.8 0 0 1 2.19-1.47A3 3 0 0 1 10 8.74a14.07 14.07 0 0 1 1 1.31zm8.42 5.12c-.48 0-.85-.19-1.38-.83A34.87 34.87 0 0 1 14.82 12l-.52-.86c-.36-.61-.71-1.16-1-1.65a2.46 2.46 0 0 1 .17-.27c.94-1.39 1.77-2.17 2.8-2.17a3.12 3.12 0 0 1 2.49 1.66 10.17 10.17 0 0 1 1.37 5.34c-.04 1.31-.34 2.43-1.57 2.43z"
                }
            }
        ]
    })(props);
}
function BiLogoMicrosoftTeams(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "20.288",
                    "cy": "8.344",
                    "r": "1.707"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.581 11.513h3.413v3.656c0 .942-.765 1.706-1.707 1.706h-1.706v-5.362zM2.006 4.2v15.6l11.213 1.979V2.221L2.006 4.2zm8.288 5.411-1.95.049v5.752H6.881V9.757l-1.949.098V8.539l5.362-.292v1.364zm3.899.439v8.288h1.95c.808 0 1.463-.655 1.463-1.462V10.05h-3.413zm1.463-4.875c-.586 0-1.105.264-1.463.673v2.555c.357.409.877.673 1.463.673a1.95 1.95 0 0 0 0-3.901z"
                }
            }
        ]
    })(props);
}
function BiLogoMicrosoft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.55 21H3v-8.55h8.55V21zM21 21h-8.55v-8.55H21V21zm-9.45-9.45H3V3h8.55v8.55zm9.45 0h-8.55V3H21v8.55z"
                }
            }
        ]
    })(props);
}
function BiLogoMongodb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.74 4.23c-.84-1-1.57-2-1.71-2.22H12c-.14.21-.87 1.22-1.71 2.22-7.2 9.19 1.14 15.39 1.14 15.39l.07.05c.06.95.22 2.33.22 2.33h.62s.15-1.37.21-2.33l.07-.06s8.32-6.19 1.12-15.38zM12 19.48a3.48 3.48 0 0 1-.48-.48L12 9l.45 10a3.57 3.57 0 0 1-.45.48z"
                }
            }
        ]
    })(props);
}
function BiLogoNetlify(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.13 9.68 22 11.8v-.11c-.07-.24-.28-.45-.7-.87l-2-2-2.07.87zM12.2 7.24a1.31 1.31 0 0 1 .16.47l3 1.29a1.11 1.11 0 0 1 .29-.14l.48-3-2-2-1.95 3.3s0 .05.02.08zM10.61 7a1.1 1.1 0 0 1 1-.2h.05l2.16-3.34-.66-.66c-.42-.42-.63-.63-.87-.7a1 1 0 0 0-.63 0c-.24.07-.45.28-.87.7l-3 3c.31.14 2.5 1.06 2.78 1.19zm-3.12 5.29h.27a1.45 1.45 0 0 1 .29 0l2.38-3.68v-.06a1 1 0 0 1-.27-.95L9 7l-1.7-.73L5 8.61l2.51 3.66zm7.62-2.44v-.08a.59.59 0 0 1 0-.14l-2.86-1.27h-.05a1.05 1.05 0 0 1-.88.47h-.17s-.05 0-.06.05L8.73 12.5v.05l6.33-2.7s.05.02.05 0zm1.36-.91a.83.83 0 0 1 .26.19l2-.84-1.89-1.87-.4 2.47zm-2.29 5.54A.91.91 0 0 1 15 14v-.05l.54-3.37-.09-.08L9 13.15a2.76 2.76 0 0 1 .08.27zM2 11.95zm12.14 3.18L8.92 14v.06L13.47 21l.42-.43c.15-.92.71-4.33.78-4.72a.9.9 0 0 1-.53-.72zm1.65.32a.88.88 0 0 1-.36.27l-.64 3.94L18.43 16zm1.07-5.13a.07.07 0 0 0-.06 0 .92.92 0 0 1-.61.34v.06l-.55 3.4a.88.88 0 0 1 .34.62h.06l2.95.61 2.28-2.28a4.22 4.22 0 0 0 .65-.74zM8.3 14.59a1.27 1.27 0 0 1-.86 0l-1.22 1.9 4.69 4.68a2.68 2.68 0 0 0 .87.71 1 1 0 0 0 .63 0 1.86 1.86 0 0 0 .7-.54l-4.69-6.8zm4.71 6.82zm-6.62-7.82s.06 0 .06-.05 0 0-.06 0l-4.14-.86a7.07 7.07 0 0 0 .51.54l1.36 1.36 2.27-1zm.28-.66a1.05 1.05 0 0 1 .2-.27v-.06C6.1 11.4 5.3 10.24 4.5 9.07l-1.75 1.75c-.42.42-.63.63-.7.87A.75.75 0 0 0 2 12l4.67 1zm.17 1.33a.61.61 0 0 1-.07-.1L4.59 15l1.08 1.1 1.17-1.82s.01-.02 0-.02z"
                }
            }
        ]
    })(props);
}
function BiLogoNodejs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21.985c-.275 0-.532-.074-.772-.202l-2.439-1.448c-.365-.203-.182-.277-.072-.314.496-.165.588-.201 1.101-.493.056-.037.129-.02.185.017l1.87 1.12c.074.036.166.036.221 0l7.319-4.237c.074-.036.11-.11.11-.202V7.768c0-.091-.036-.165-.11-.201l-7.319-4.219c-.073-.037-.165-.037-.221 0L4.552 7.566c-.073.036-.11.129-.11.201v8.457c0 .073.037.166.11.202l2 1.157c1.082.548 1.762-.095 1.762-.735V8.502c0-.11.091-.221.22-.221h.936c.108 0 .22.092.22.221v8.347c0 1.449-.788 2.294-2.164 2.294-.422 0-.752 0-1.688-.46l-1.925-1.099a1.55 1.55 0 0 1-.771-1.34V7.786c0-.55.293-1.064.771-1.339l7.316-4.237a1.637 1.637 0 0 1 1.544 0l7.317 4.237c.479.274.771.789.771 1.339v8.458c0 .549-.293 1.063-.771 1.34l-7.317 4.236c-.241.11-.516.165-.773.165zm2.256-5.816c-3.21 0-3.87-1.468-3.87-2.714 0-.11.092-.221.22-.221h.954c.11 0 .201.073.201.184.147.971.568 1.449 2.514 1.449 1.54 0 2.202-.35 2.202-1.175 0-.477-.185-.825-2.587-1.063-1.999-.2-3.246-.643-3.246-2.238 0-1.485 1.247-2.366 3.339-2.366 2.347 0 3.503.809 3.649 2.568a.297.297 0 0 1-.056.165c-.037.036-.091.073-.146.073h-.953a.212.212 0 0 1-.202-.164c-.221-1.012-.789-1.34-2.292-1.34-1.689 0-1.891.587-1.891 1.027 0 .531.237.696 2.514.99 2.256.293 3.32.715 3.32 2.294-.02 1.615-1.339 2.531-3.67 2.531z"
                }
            }
        ]
    })(props);
}
function BiLogoOkRu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.986 12.341c-2.825 0-5.173-2.346-5.173-5.122C6.813 4.347 9.161 2 11.987 2c2.922 0 5.173 2.346 5.173 5.219a5.142 5.142 0 0 1-5.157 5.123l-.017-.001zm0-7.324c-1.196 0-2.106 1.005-2.106 2.203 0 1.196.91 2.106 2.107 2.106 1.245 0 2.107-.91 2.107-2.106.001-1.199-.862-2.203-2.108-2.203zm2.06 11.586 2.923 2.825c.575.621.575 1.531 0 2.106-.622.621-1.581.621-2.06 0l-2.922-2.873-2.826 2.873c-.287.287-.671.43-1.103.43-.335 0-.718-.144-1.054-.43-.575-.575-.575-1.485 0-2.107l2.97-2.825a13.49 13.49 0 0 1-3.063-1.339c-.719-.383-.862-1.34-.479-2.059.479-.718 1.341-.909 2.108-.43a6.62 6.62 0 0 0 6.897 0c.767-.479 1.676-.288 2.107.43.432.719.239 1.675-.432 2.059-.909.575-1.963 1.006-3.065 1.341l-.001-.001z"
                }
            }
        ]
    })(props);
}
function BiLogoOpera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.71 6.366C7.604 7.67 6.888 9.602 6.838 11.765v.471c.05 2.165.766 4.094 1.872 5.397 1.434 1.865 3.564 3.046 5.948 3.046a7.218 7.218 0 0 0 4.006-1.225 9.943 9.943 0 0 1-7.139 2.533A9.995 9.995 0 0 1 2 12C2 6.477 6.478 2 12 2h.038a9.971 9.971 0 0 1 6.627 2.545c-1.173-.773-2.543-1.225-4.009-1.225-2.382 0-4.514 1.184-5.95 3.046h.004zM22 12a9.971 9.971 0 0 1-3.335 7.455c-2.564 1.25-4.954.375-5.747-.172 2.52-.553 4.422-3.6 4.422-7.283 0-3.686-1.901-6.73-4.422-7.283.792-.545 3.183-1.42 5.747-.172A9.971 9.971 0 0 1 22 12z"
                }
            }
        ]
    })(props);
}
function BiLogoPatreon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.508",
                    "cy": "9.831",
                    "r": "6.496"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.996 3.335H6.17v17.33H2.996z"
                }
            }
        ]
    })(props);
}
function BiLogoPaypal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.554 9.488c.121.563.106 1.246-.04 2.051-.582 2.978-2.477 4.466-5.683 4.466h-.442a.666.666 0 0 0-.444.166.72.72 0 0 0-.239.427l-.041.189-.553 3.479-.021.151a.706.706 0 0 1-.247.426.666.666 0 0 1-.447.166H8.874a.395.395 0 0 1-.331-.15.457.457 0 0 1-.09-.363c.061-.373.148-.938.267-1.689.117-.75.206-1.314.267-1.689s.15-.938.272-1.685c.121-.748.212-1.31.271-1.685.033-.248.179-.371.433-.371h1.316c.893.013 1.682-.057 2.375-.211 1.172-.262 2.134-.744 2.886-1.449.685-.637 1.203-1.462 1.56-2.473.162-.47.277-.917.352-1.338.006-.041.014-.066.025-.074.008-.011.022-.014.035-.011a.378.378 0 0 1 .062.035c.524.398.854.941.98 1.632zm-1.728-2.836c0 .717-.154 1.508-.465 2.374-.537 1.562-1.547 2.618-3.037 3.168-.758.269-1.602.408-2.535.425 0 .006-.301.007-.904.007l-.903-.007c-.672 0-1.067.32-1.187.964-.013.053-.298 1.83-.855 5.329-.008.066-.048.102-.121.102H4.854a.473.473 0 0 1-.369-.165.469.469 0 0 1-.115-.39L6.702 3.664a.784.784 0 0 1 .276-.483.785.785 0 0 1 .519-.19h6.014c.228 0 .555.044.979.131.428.084.801.194 1.123.321.718.274 1.266.688 1.645 1.237.379.552.568 1.207.568 1.972z"
                }
            }
        ]
    })(props);
}
function BiLogoPeriscope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.102 21c1.406 0 6.985-6.329 6.985-10.571C19.087 6.368 15.915 3 12.102 3c-4.017 0-7.188 3.366-7.188 7.429C4.913 14.67 10.492 21 12.102 21zM10.979 5.885a4.696 4.696 0 0 1 1.143-.139c2.25 0 4.186 1.913 4.186 4.398 0 2.238-1.936 4.151-4.196 4.151-2.509 0-4.444-1.913-4.444-4.151 0-1.047.338-1.98.922-2.723v.022c0 .934.755 1.676 1.688 1.676.933.002 1.722-.764 1.722-1.697a1.68 1.68 0 0 0-1.02-1.54l-.001.003z"
                }
            }
        ]
    })(props);
}
function BiLogoPhp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.15 16.78h1.57a.14.14 0 0 0 .14-.12l.35-1.82h1.22a4.88 4.88 0 0 0 1.51-.2A2.79 2.79 0 0 0 8 14a3.18 3.18 0 0 0 .67-.85 3.43 3.43 0 0 0 .36-1 2.43 2.43 0 0 0-.41-2.16 2.64 2.64 0 0 0-2.09-.78h-3a.16.16 0 0 0-.15.13L2 16.6a.19.19 0 0 0 0 .13.17.17 0 0 0 .15.05zM5 10.62h1a1.45 1.45 0 0 1 1.08.29c.17.18.2.52.11 1a1.81 1.81 0 0 1-.57 1.12 2.17 2.17 0 0 1-1.33.33h-.8zm9.8-.95a2.7 2.7 0 0 0-1.88-.51h-1.19l.33-1.76a.15.15 0 0 0 0-.13.16.16 0 0 0-.11 0h-1.57a.14.14 0 0 0-.14.12l-1.38 7.27a.13.13 0 0 0 0 .12.13.13 0 0 0 .11.06h1.54a.14.14 0 0 0 .14-.13l.77-4.07h1.11c.45 0 .61.1.66.16a.81.81 0 0 1 0 .62l-.61 3.24a.13.13 0 0 0 0 .12.14.14 0 0 0 .11.06h1.56a.16.16 0 0 0 .15-.13l.64-3.4a1.7 1.7 0 0 0-.24-1.64zm4.52-.51h-3.13a.14.14 0 0 0-.15.13l-1.46 7.31a.16.16 0 0 0 0 .13.14.14 0 0 0 .11.05h1.63a.14.14 0 0 0 .15-.12l.37-1.82h1.27a5.28 5.28 0 0 0 1.56-.2 3 3 0 0 0 1.18-.64 3.31 3.31 0 0 0 .7-.85 3.45 3.45 0 0 0 .37-1 2.38 2.38 0 0 0-.42-2.16 2.81 2.81 0 0 0-2.18-.83zm.62 2.77a1.83 1.83 0 0 1-.6 1.12 2.28 2.28 0 0 1-1.37.33h-.8l.54-2.76h1a1.6 1.6 0 0 1 1.13.29c.16.18.16.52.1 1.02z"
                }
            }
        ]
    })(props);
}
function BiLogoPinterestAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.077 9.457c0-.778.136-1.513.404-2.199a5.63 5.63 0 0 1 1.121-1.802 7.614 7.614 0 0 1 1.644-1.329 7.513 7.513 0 0 1 2.002-.844 8.57 8.57 0 0 1 2.185-.281c1.139 0 2.199.241 3.182.721a6.021 6.021 0 0 1 2.391 2.094c.614.915.919 1.95.919 3.104 0 .692-.068 1.369-.207 2.031a8.28 8.28 0 0 1-.646 1.913 6.605 6.605 0 0 1-1.082 1.617 4.723 4.723 0 0 1-1.568 1.114 4.962 4.962 0 0 1-2.045.417c-.489 0-.977-.115-1.459-.346-.482-.23-.828-.546-1.036-.951-.073.281-.173.687-.306 1.218-.128.53-.214.872-.252 1.027-.04.154-.114.411-.222.767a5.183 5.183 0 0 1-.281.769l-.344.674a7.98 7.98 0 0 1-.498.838c-.181.262-.405.575-.672.935l-.149.053-.099-.108c-.107-1.133-.162-1.811-.162-2.035 0-.663.079-1.407.235-2.233.153-.825.395-1.862.72-3.109.325-1.246.511-1.979.561-2.196-.229-.467-.345-1.077-.345-1.827 0-.599.187-1.16.562-1.688.376-.526.851-.789 1.427-.789.441 0 .783.146 1.028.439.246.292.366.66.366 1.109 0 .476-.158 1.165-.476 2.066-.318.902-.476 1.575-.476 2.022 0 .453.162.832.486 1.129a1.68 1.68 0 0 0 1.179.449c.396 0 .763-.09 1.104-.271a2.46 2.46 0 0 0 .849-.733 6.123 6.123 0 0 0 1.017-2.225c.096-.422.17-.823.216-1.2.049-.379.07-.737.07-1.077 0-1.247-.396-2.219-1.183-2.915-.791-.696-1.821-1.042-3.088-1.042-1.441 0-2.646.466-3.611 1.401-.966.932-1.452 2.117-1.452 3.554 0 .317.048.623.139.919.089.295.186.53.291.704.104.171.202.338.291.492.09.154.137.264.137.33 0 .202-.053.465-.16.79-.111.325-.242.487-.4.487-.015 0-.077-.011-.185-.034a2.21 2.21 0 0 1-.979-.605 3.17 3.17 0 0 1-.659-1.022 6.986 6.986 0 0 1-.352-1.169 4.884 4.884 0 0 1-.132-1.153z"
                }
            }
        ]
    })(props);
}
function BiLogoPinterest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.472 2 2 6.473 2 11.99c0 4.232 2.633 7.85 6.35 9.306-.088-.79-.166-2.006.034-2.868.182-.78 1.172-4.966 1.172-4.966s-.299-.599-.299-1.484c0-1.388.805-2.425 1.808-2.425.853 0 1.264.64 1.264 1.407 0 .858-.546 2.139-.827 3.327-.235.994.499 1.805 1.479 1.805 1.775 0 3.141-1.872 3.141-4.575 0-2.392-1.719-4.064-4.173-4.064-2.843 0-4.512 2.132-4.512 4.335 0 .858.331 1.779.744 2.28a.3.3 0 0 1 .069.286c-.076.315-.245.994-.277 1.133-.044.183-.145.222-.335.134-1.247-.581-2.027-2.405-2.027-3.871 0-3.151 2.289-6.045 6.601-6.045 3.466 0 6.159 2.469 6.159 5.77 0 3.444-2.171 6.213-5.184 6.213-1.013 0-1.964-.525-2.29-1.146l-.623 2.374c-.225.868-.834 1.956-1.241 2.62a10 10 0 0 0 2.958.445c5.517 0 9.99-4.473 9.99-9.99S17.507 2 11.99 2"
                }
            }
        ]
    })(props);
}
function BiLogoPlayStore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12.954 11.616 2.957-2.957L6.36 3.291c-.633-.342-1.226-.39-1.746-.016l8.34 8.341zm3.461 3.462 3.074-1.729c.6-.336.929-.812.929-1.34 0-.527-.329-1.004-.928-1.34l-2.783-1.563-3.133 3.132 2.841 2.84zM4.1 4.002c-.064.197-.1.417-.1.658v14.705c0 .381.084.709.236.97l8.097-8.098L4.1 4.002zm8.854 8.855L4.902 20.91c.154.059.32.09.495.09.312 0 .637-.092.968-.276l9.255-5.197-2.666-2.67z"
                }
            }
        ]
    })(props);
}
function BiLogoPocket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.327 3.983H4.746c-.947 0-1.736.726-1.736 1.673v5.396c0 4.892 4.04 8.964 9.026 8.964 4.955 0 8.964-4.072 8.964-8.964V5.656c0-.947-.758-1.673-1.673-1.673zm-2.178 6.691-4.293 4.04c-.221.253-.567.348-.82.348-.315 0-.631-.095-.884-.348l-4.229-4.04c-.441-.473-.504-1.262 0-1.768.475-.441 1.263-.504 1.736 0l3.377 3.251 3.44-3.251c.441-.504 1.23-.441 1.673 0 .442.506.442 1.295 0 1.768z"
                }
            }
        ]
    })(props);
}
function BiLogoPostgresql(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.74 12.89v-.11c.06-.15.12-.29.19-.43a5.15 5.15 0 0 0 .26-3.74.86.86 0 0 0-.66-.74 3.12 3.12 0 0 0-2.08.61v.18a11.34 11.34 0 0 1-.06 2.41 2.37 2.37 0 0 0 .62 2 2 2 0 0 0 1.43.63 8.05 8.05 0 0 1 .3-.81zM10 8.58a.36.36 0 0 1-.09-.23.19.19 0 0 1 .09-.12.74.74 0 0 1 .48-.07c.25 0 .5.16.48.34a.51.51 0 0 1-.49.33h-.06a.63.63 0 0 1-.41-.25z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.88 11a12.58 12.58 0 0 0 .06-2.3v-.28a7 7 0 0 1 1.54-4.55c-1-.32-3.4-1-4.87.1-.9.64-1.32 1.84-1.23 3.55a24.85 24.85 0 0 0 1 4.4c.68 2.22 1.45 3.62 2.11 3.85.1 0 .41.13.86-.41.64-.76 1.23-1.41 1.5-1.7l-.19-.19A2.89 2.89 0 0 1 7.88 11zm3.5 3.4c-.16-.06-.24-.1-.42.11a2.52 2.52 0 0 0-.29.35c-.35.43-.5.58-1.51.79a2 2 0 0 0-.4.11 1 1 0 0 0 .37.16 2.21 2.21 0 0 0 2.5-.8.41.41 0 0 0 0-.35.59.59 0 0 0-.25-.37zm6.29-5.82a5.29 5.29 0 0 0 .08-.79c-.66-.08-1.42-.07-1.72.36-.58.83.56 2.88 1 3.75a4.34 4.34 0 0 1 .26.48 1.79 1.79 0 0 0 .15.31 3.72 3.72 0 0 0 .16-2.13 7.51 7.51 0 0 1-.07-1.05 6 6 0 0 1 .14-.93zm-.56-.16a.6.6 0 0 1-.32.17h-.06a.47.47 0 0 1-.44-.3c0-.14.2-.24.44-.28s.48 0 .5.15a.38.38 0 0 1-.12.26z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4.88a6.06 6.06 0 0 1 1.37 2.57.71.71 0 0 1 0 .15 5.67 5.67 0 0 1-.09 1.06 7.11 7.11 0 0 0-.09.86 6.61 6.61 0 0 0 .07 1 4 4 0 0 1-.36 2.71l.07.08c2.22-3.49 3-7.54 2.29-8.43a4.77 4.77 0 0 0-3.81-1.8 7.34 7.34 0 0 0-1.63.16A6.17 6.17 0 0 1 17 4.88z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.65 14c-.07-.2-.37-.85-1.47-.62a6.28 6.28 0 0 1-1 .13 19.74 19.74 0 0 0 2.06-4.88c.37-1.45.66-3.39-.11-4.38A5.91 5.91 0 0 0 16.37 2a8.44 8.44 0 0 0-2.46.35 9.38 9.38 0 0 0-1.45-.14 4.8 4.8 0 0 0-2.46.62 12.22 12.22 0 0 0-1.77-.44A5.44 5.44 0 0 0 4 3.05c-1.24.87-1.81 2.39-1.71 4.52a26.28 26.28 0 0 0 1 4.67A15.76 15.76 0 0 0 4.4 15a3.39 3.39 0 0 0 1.75 1.83 1.71 1.71 0 0 0 1.69-.37 2 2 0 0 0 1 .59 3.65 3.65 0 0 0 2.35-.14v.81a8.46 8.46 0 0 0 .31 2.36 1 1 0 0 1 0 .13 3 3 0 0 0 .71 1.24 2.08 2.08 0 0 0 1.49.56 3 3 0 0 0 .7-.08 3.27 3.27 0 0 0 2.21-1.27 7.34 7.34 0 0 0 .91-4v-.26h.17a5.24 5.24 0 0 0 2.4-.4c.45-.23 1.91-1 1.56-2zm-1.81 1.47a4.7 4.7 0 0 1-1.8.34 2.62 2.62 0 0 1-.79-.1c-.1.94-.32 2.69-.45 3.42a2.47 2.47 0 0 1-2.25 2.3 3.23 3.23 0 0 1-.66.07A2 2 0 0 1 12 20a16.77 16.77 0 0 1-.28-4.06 2.56 2.56 0 0 1-1.78.66 3.94 3.94 0 0 1-.94-.13c-.09 0-.87-.23-.86-.73s.66-.59.9-.64c.86-.18.92-.25 1.19-.59a2.79 2.79 0 0 1 .19-.24 2.56 2.56 0 0 1-1.11-.3c-.23.25-.86.93-1.54 1.74a1.43 1.43 0 0 1-1.11.63 1.23 1.23 0 0 1-.35 0C5.43 16 4.6 14.55 3.84 12a25.21 25.21 0 0 1-1-4.53c-.1-1.92.4-3.28 1.47-4 1.92-1.36 5-.31 5.7-.06a4 4 0 0 1 2.41-.66 5.58 5.58 0 0 1 1.4.18 7.51 7.51 0 0 1 2.5-.4 5.35 5.35 0 0 1 4.32 2c.69.88.23 3 0 3.89a18.84 18.84 0 0 1-2.41 5.41c.16.11.65.31 2 0 .46-.1.73 0 .82.25.22.55-.7 1.13-1.21 1.37z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.43 13.59a4 4 0 0 1-.62-1c0-.07-.12-.24-.23-.43-.58-1-1.79-3.22-1-4.34a2.16 2.16 0 0 1 2.12-.61 6.28 6.28 0 0 0-1.13-1.94 5.41 5.41 0 0 0-4.13-2 3.34 3.34 0 0 0-2.55.95A5.82 5.82 0 0 0 8.51 7.8l.15-.08A3.7 3.7 0 0 1 10 7.3a1.45 1.45 0 0 1 1.76 1.19 5.73 5.73 0 0 1-.29 4.09 3.29 3.29 0 0 0-.17.39v.11c-.1.27-.19.52-.25.73a.94.94 0 0 1 .57.07 1.16 1.16 0 0 1 .62.74v.16a.28.28 0 0 1 0 .09 22.22 22.22 0 0 0 .22 4.9 1.5 1.5 0 0 0 2 1.09A1.92 1.92 0 0 0 16.25 19c.15-.88.45-3.35.49-3.88 0-1.06.52-1.27.84-1.36z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m18 14.33-.08-.06h-.12c-.26.07-.5.14-.47.8a1.9 1.9 0 0 0 .93.12 4.29 4.29 0 0 0 1.38-.29 3 3 0 0 0 .79-.52 3.47 3.47 0 0 1-2.43-.05z"
                }
            }
        ]
    })(props);
}
function BiLogoProductHunt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.337 9h-2.838v3h2.838a1.501 1.501 0 1 0 0-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm1.337 12h-2.838v3H8.501V7h4.837a3.498 3.498 0 0 1 3.499 3.499 3.499 3.499 0 0 1-3.5 3.501z"
                }
            }
        ]
    })(props);
}
function BiLogoPython(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.585 11.692h4.328s2.432.039 2.432-2.35V5.391S16.714 3 11.936 3C7.362 3 7.647 4.983 7.647 4.983l.006 2.055h4.363v.617H5.92s-2.927-.332-2.927 4.282 2.555 4.45 2.555 4.45h1.524v-2.141s-.083-2.554 2.513-2.554zm-.056-5.74a.784.784 0 1 1 0-1.57.784.784 0 1 1 0 1.57z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.452 7.532h-1.524v2.141s.083 2.554-2.513 2.554h-4.328s-2.432-.04-2.432 2.35v3.951s-.369 2.391 4.409 2.391c4.573 0 4.288-1.983 4.288-1.983l-.006-2.054h-4.363v-.617h6.097s2.927.332 2.927-4.282-2.555-4.451-2.555-4.451zm-3.981 10.436a.784.784 0 1 1 0 1.57.784.784 0 1 1 0-1.57z"
                }
            }
        ]
    })(props);
}
function BiLogoQuora(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.555 17.025c-.624-1.227-1.354-2.465-2.781-2.465-.271 0-.546.046-.795.157l-.484-.967c.59-.509 1.544-.911 2.77-.911 1.908 0 2.889.922 3.667 2.094.459-1.001.678-2.354.678-4.03 0-4.188-1.308-6.336-4.366-6.336-3.014 0-4.318 2.148-4.318 6.336 0 4.164 1.305 6.291 4.318 6.291.478 0 .913-.051 1.311-.169zm.747 1.461a7.977 7.977 0 0 1-2.059.274c-4.014 0-7.941-3.202-7.941-7.858C3.303 6.203 7.229 3 11.243 3c4.081 0 7.972 3.179 7.972 7.903 0 2.628-1.226 4.763-3.007 6.143.572.861 1.157 1.436 1.988 1.436.899 0 1.261-.687 1.328-1.236h1.167c.07.73-.301 3.754-3.574 3.754-1.989 0-3.035-1.146-3.822-2.496l.007-.018z"
                }
            }
        ]
    })(props);
}
function BiLogoReact(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "11.245",
                    "r": "1.785"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m7.002 14.794-.395-.101c-2.934-.741-4.617-2.001-4.617-3.452 0-1.452 1.684-2.711 4.617-3.452l.395-.1.111.391a19.507 19.507 0 0 0 1.136 2.983l.085.178-.085.178c-.46.963-.841 1.961-1.136 2.985l-.111.39zm-.577-6.095c-2.229.628-3.598 1.586-3.598 2.542 0 .954 1.368 1.913 3.598 2.54.273-.868.603-1.717.985-2.54a20.356 20.356 0 0 1-.985-2.542zm10.572 6.095-.11-.392a19.628 19.628 0 0 0-1.137-2.984l-.085-.177.085-.179c.46-.961.839-1.96 1.137-2.984l.11-.39.395.1c2.935.741 4.617 2 4.617 3.453 0 1.452-1.683 2.711-4.617 3.452l-.395.101zm-.41-3.553c.4.866.733 1.718.987 2.54 2.23-.627 3.599-1.586 3.599-2.54 0-.956-1.368-1.913-3.599-2.542a20.683 20.683 0 0 1-.987 2.542z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m6.419 8.695-.11-.39c-.826-2.908-.576-4.991.687-5.717 1.235-.715 3.222.13 5.303 2.265l.284.292-.284.291a19.718 19.718 0 0 0-2.02 2.474l-.113.162-.196.016a19.646 19.646 0 0 0-3.157.509l-.394.098zm1.582-5.529c-.224 0-.422.049-.589.145-.828.477-.974 2.138-.404 4.38.891-.197 1.79-.338 2.696-.417a21.058 21.058 0 0 1 1.713-2.123c-1.303-1.267-2.533-1.985-3.416-1.985zm7.997 16.984c-1.188 0-2.714-.896-4.298-2.522l-.283-.291.283-.29a19.827 19.827 0 0 0 2.021-2.477l.112-.16.194-.019a19.473 19.473 0 0 0 3.158-.507l.395-.1.111.391c.822 2.906.573 4.992-.688 5.718a1.978 1.978 0 0 1-1.005.257zm-3.415-2.82c1.302 1.267 2.533 1.986 3.415 1.986.225 0 .423-.05.589-.145.829-.478.976-2.142.404-4.384-.89.198-1.79.34-2.698.419a20.526 20.526 0 0 1-1.71 2.124z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "m17.58 8.695-.395-.099a19.477 19.477 0 0 0-3.158-.509l-.194-.017-.112-.162A19.551 19.551 0 0 0 11.7 5.434l-.283-.291.283-.29c2.08-2.134 4.066-2.979 5.303-2.265 1.262.727 1.513 2.81.688 5.717l-.111.39zm-3.287-1.421c.954.085 1.858.228 2.698.417.571-2.242.425-3.903-.404-4.381-.824-.477-2.375.253-4.004 1.841.616.67 1.188 1.378 1.71 2.123zM8.001 20.15a1.983 1.983 0 0 1-1.005-.257c-1.263-.726-1.513-2.811-.688-5.718l.108-.391.395.1c.964.243 2.026.414 3.158.507l.194.019.113.16c.604.878 1.28 1.707 2.02 2.477l.284.29-.284.291c-1.583 1.627-3.109 2.522-4.295 2.522zm-.993-5.362c-.57 2.242-.424 3.906.404 4.384.825.47 2.371-.255 4.005-1.842a21.17 21.17 0 0 1-1.713-2.123 20.692 20.692 0 0 1-2.696-.419z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15.313c-.687 0-1.392-.029-2.1-.088l-.196-.017-.113-.162a25.697 25.697 0 0 1-1.126-1.769 26.028 26.028 0 0 1-.971-1.859l-.084-.177.084-.179c.299-.632.622-1.252.971-1.858.347-.596.726-1.192 1.126-1.77l.113-.16.196-.018a25.148 25.148 0 0 1 4.198 0l.194.019.113.16a25.136 25.136 0 0 1 2.1 3.628l.083.179-.083.177a24.742 24.742 0 0 1-2.1 3.628l-.113.162-.194.017c-.706.057-1.412.087-2.098.087zm-1.834-.904c1.235.093 2.433.093 3.667 0a24.469 24.469 0 0 0 1.832-3.168 23.916 23.916 0 0 0-1.832-3.168 23.877 23.877 0 0 0-3.667 0 23.743 23.743 0 0 0-1.832 3.168 24.82 24.82 0 0 0 1.832 3.168z"
                }
            }
        ]
    })(props);
}
function BiLogoRedbubble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.002 2.005 12 2.004c-5.52 0-9.996 4.475-9.996 9.995 0 5.521 4.477 9.998 9.996 9.998 5.521 0 9.996-4.475 9.996-9.997 0-5.52-4.475-9.995-9.994-9.995zm.162 13.53a.267.267 0 0 1-.174.066v.001H6.455a.268.268 0 0 1-.266-.268V8.646c0-.148.119-.268.266-.268h2.589c1.612 0 2.576.87 2.576 2.327 0 .969-.486 1.729-1.272 2.039l1.842 2.413a.269.269 0 0 1-.026.378zm3.695.068h-2.665a.268.268 0 0 1-.266-.269V8.646c0-.148.119-.267.266-.267h2.472c1.853 0 2.242 1.091 2.242 2.007 0 .529-.141.949-.421 1.258.681.28 1.047.913 1.047 1.827 0 1.335-1.001 2.132-2.675 2.132z"
                }
            }
        ]
    })(props);
}
function BiLogoReddit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "9.67",
                    "cy": "13",
                    "r": "1.001"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.09 15.391A3.28 3.28 0 0 1 12 16a3.271 3.271 0 0 1-2.081-.63.27.27 0 0 0-.379.38c.71.535 1.582.809 2.471.77a3.811 3.811 0 0 0 2.469-.77v.04a.284.284 0 0 0 .006-.396.28.28 0 0 0-.396-.003zm.209-3.351a1 1 0 0 0 0 2l-.008.039c.016.002.033 0 .051 0a1 1 0 0 0 .958-1.038 1 1 0 0 0-1.001-1.001z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.479 2 2 6.477 2 12c0 5.521 4.479 10 10 10s10-4.479 10-10c0-5.523-4.479-10-10-10zm5.859 11.33c.012.146.012.293 0 .439 0 2.24-2.609 4.062-5.83 4.062s-5.83-1.82-5.83-4.062a2.681 2.681 0 0 1 0-.439 1.46 1.46 0 0 1-.455-2.327 1.458 1.458 0 0 1 2.063-.063 7.145 7.145 0 0 1 3.899-1.23l.743-3.47v-.004A.313.313 0 0 1 12.82 6l2.449.49a1.001 1.001 0 1 1-.131.61L13 6.65l-.649 3.12a7.123 7.123 0 0 1 3.85 1.23 1.46 1.46 0 0 1 2.469 1c.01.563-.307 1.08-.811 1.33z"
                }
            }
        ]
    })(props);
}
function BiLogoRedux(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.661 15.549a1.315 1.315 0 0 0 1.185-1.386 1.363 1.363 0 0 0-1.35-1.302h-.048a1.352 1.352 0 0 0-1.303 1.397c.024.379.179.687.391.911-.827 1.609-2.07 2.794-3.954 3.788-1.266.663-2.604.912-3.905.734-1.089-.153-1.94-.64-2.463-1.421-.78-1.185-.852-2.462-.201-3.74a5.597 5.597 0 0 1 1.658-1.931 7.88 7.88 0 0 1-.331-1.218c-3.506 2.51-3.148 5.942-2.084 7.564.794 1.184 2.415 1.941 4.19 1.941.474 0 .972-.035 1.457-.154 3.077-.592 5.409-2.438 6.747-5.16l.011-.023z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.887 12.589c-1.834-2.154-4.533-3.337-7.611-3.337h-.403c-.2-.438-.661-.711-1.183-.711h-.036c-.744 0-1.325.64-1.301 1.385.023.71.627 1.302 1.35 1.302h.059a1.332 1.332 0 0 0 1.183-.828h.439c1.824 0 3.551.532 5.126 1.574 1.206.792 2.072 1.834 2.557 3.077.425 1.019.402 2.013-.035 2.843-.675 1.302-1.812 1.988-3.314 1.988-.947 0-1.871-.296-2.345-.509-.283.235-.758.626-1.102.863 1.042.473 2.096.746 3.113.746 2.309 0 4.023-1.302 4.676-2.557.709-1.422.651-3.813-1.161-5.859l-.012.023z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.647 15.975c.023.71.626 1.302 1.35 1.302h.048a1.334 1.334 0 0 0 1.302-1.397c0-.71-.616-1.301-1.338-1.301h-.048c-.048 0-.118 0-.178.022-.982-1.657-1.397-3.434-1.242-5.349.094-1.445.567-2.7 1.42-3.742.71-.888 2.048-1.326 2.96-1.35 2.556-.048 3.622 3.138 3.704 4.404l1.184.354C16.536 5.036 14.122 3 11.813 3 9.647 3 7.647 4.574 6.842 6.884c-1.102 3.077-.379 6.036.971 8.404-.118.154-.189.426-.166.687z"
                }
            }
        ]
    })(props);
}
function BiLogoSass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c5.522 0 10 4.478 10 10s-4.478 10-10 10S2 17.522 2 12 6.478 2 12 2zm-1.987 13.332c.146.537.13 1.039-.021 1.493l-.054.15a2.803 2.803 0 0 1-.527.821c-.582.633-1.394.872-1.742.671-.375-.219-.188-1.112.487-1.825.726-.765 1.766-1.258 1.766-1.258v-.002l.091-.05zm8.258-9.051c-.452-1.777-3.397-2.362-6.185-1.371-1.656.589-3.453 1.515-4.743 2.723-1.536 1.434-1.78 2.684-1.68 3.206.355 1.843 2.881 3.048 3.92 3.942v.005c-.307.149-2.548 1.274-3.072 2.438-.563 1.225.088 2.101.513 2.212 1.313.363 2.662-.3 3.388-1.374.699-1.051.638-2.4.337-3.063.413-.112.899-.162 1.524-.086 1.751.199 2.101 1.3 2.024 1.75-.074.449-.436.711-.561.786-.126.076-.163.101-.151.151.013.074.076.074.175.063.138-.025.914-.375.951-1.227.037-1.074-.988-2.273-2.813-2.25-.75.014-1.226.076-1.563.214a.295.295 0 0 0-.088-.088c-1.125-1.213-3.213-2.063-3.125-3.675.025-.588.237-2.137 4-4.012 3.088-1.538 5.551-1.112 5.977-.175.61 1.336-1.314 3.825-4.526 4.187-1.225.138-1.862-.337-2.026-.513-.174-.188-.198-.2-.261-.161-.101.05-.038.212 0 .313.1.249.487.688 1.163.912.587.188 2.024.299 3.75-.375 1.937-.749 3.449-2.838 3.012-4.588l.06.056z"
                }
            }
        ]
    })(props);
}
function BiLogoShopify(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m14.49 20.937 5.381-1.166S17.93 6.633 17.914 6.546c-.016-.086-.086-.144-.158-.144s-1.439-.101-1.439-.101-.949-.949-1.064-1.05c-.027-.029-.057-.043-.086-.058l-.677 15.744zm.446-15.772c-.016 0-.043.014-.057.014-.016 0-.217.059-.533.158-.318-.919-.879-1.768-1.871-1.768h-.086c-.289-.361-.633-.519-.936-.519-2.316 0-3.426 2.892-3.77 4.359-.892.275-1.538.476-1.613.505-.504.158-.517.172-.574.648-.057.344-1.367 10.489-1.367 10.489l10.117 1.899.69-15.785zm-2.635.704v.102c-.559.173-1.178.36-1.783.547.346-1.323.992-1.972 1.553-2.217.146.375.23.878.23 1.568zm-.92-2.2c.1 0 .201.028.303.102-.732.344-1.539 1.222-1.871 2.978a59.11 59.11 0 0 1-1.411.432c.389-1.339 1.325-3.512 2.979-3.512zm.402 7.812s-.604-.315-1.322-.315c-1.08 0-1.123.676-1.123.849 0 .921 2.418 1.28 2.418 3.453 0 1.712-1.08 2.806-2.547 2.806-1.756 0-2.648-1.094-2.648-1.094l.475-1.554s.922.792 1.697.792a.693.693 0 0 0 .721-.69c0-1.209-1.986-1.268-1.986-3.252 0-1.669 1.195-3.295 3.627-3.295.936 0 1.395.272 1.395.272l-.707 2.028zm.922-7.281c.518.06.85.648 1.064 1.311-.258.087-.547.173-.863.273v-.187c0-.561-.072-1.022-.201-1.397z"
                }
            }
        ]
    })(props);
}
function BiLogoSketch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.42 9.87 12 20.78l5.58-10.91H6.42zM5.9 4.01 2 9.24h3.62l.28-5.23zm6.1-.59L6.63 9.24h10.74L12 3.42zM2.04 9.87l9.09 10.58L5.72 9.87H2.04zM11.53 3h-.15l-4.84.51a.09.09 0 0 1 0 .05l-.27 5.15zm1.34 17.45 9.09-10.58h-3.68l-5.41 10.58zm4.58-16.87a.09.09 0 0 1 0-.05l-4-.42-1-.11 5.26 5.71zm.65.43.28 5.23H22l-2.22-2.98-1.68-2.25z"
                }
            }
        ]
    })(props);
}
function BiLogoSkype(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.857 17.417c-2.947 0-4.294-1.524-4.294-2.641 0-.266.108-.521.298-.705a.946.946 0 0 1 .71-.264c1.261 0 .931 1.92 3.286 1.92 1.203 0 1.91-.736 1.91-1.425 0-.415-.234-.889-1.028-1.079l-2.629-.673c-2.111-.545-2.479-1.737-2.479-2.842 0-2.293 2.068-3.124 4.036-3.124 1.814 0 3.97 1.016 3.97 2.391 0 .592-.488.91-1.055.91-1.078 0-.897-1.536-3.063-1.536-1.077 0-1.645.513-1.645 1.23s.839.96 1.574 1.123l1.941.445c2.126.486 2.691 1.751 2.691 2.963 0 1.865-1.423 3.305-4.226 3.305m8.139-3.942c.086-.49.128-.986.128-1.482a8.472 8.472 0 0 0-2.952-6.474 8.211 8.211 0 0 0-6.788-1.856A4.818 4.818 0 0 0 7.935 3a4.954 4.954 0 0 0-4.27 2.519 5.103 5.103 0 0 0-.015 5.011 8.51 8.51 0 0 0 2.282 7.453 8.23 8.23 0 0 0 7.333 2.355 4.823 4.823 0 0 0 2.443.662 4.954 4.954 0 0 0 4.269-2.518 5.095 5.095 0 0 0 .016-5.009"
                }
            }
        ]
    })(props);
}
function BiLogoSlackOld(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.935 12.646a1.617 1.617 0 0 0-2.022-1.034l-1.632.532c-.355-1.099-.735-2.268-1.092-3.365l.006-.002-.004-.008 1.613-.523a1.62 1.62 0 0 0 1.035-2.023 1.62 1.62 0 0 0-2.025-1.034l-1.621.527-.519-1.604a1.619 1.619 0 0 0-2.024-1.034 1.618 1.618 0 0 0-1.033 2.024l.522 1.609-3.368 1.092-.524-1.611a1.618 1.618 0 0 0-2.022-1.034 1.617 1.617 0 0 0-1.034 2.023l.524 1.616-1.662.541a1.602 1.602 0 0 0-.988 1.95c.25.856 1.152 1.373 1.979 1.092.006 0 .658-.209 1.665-.536l1.099 3.386h-.002v.002l-1.67.545a1.599 1.599 0 0 0-.987 1.949c.25.857 1.15 1.374 1.979 1.093.007 0 .659-.211 1.665-.538l.003.005a.024.024 0 0 0 .008-.002l.539 1.657a1.6 1.6 0 0 0 1.949.989c.857-.25 1.373-1.151 1.094-1.979 0-.006-.209-.654-.533-1.654l-.003-.009c1.104-.358 2.276-.739 3.376-1.098l.543 1.668a1.602 1.602 0 0 0 1.949.989c.856-.251 1.374-1.152 1.092-1.979 0-.007-.209-.659-.535-1.663l.019-.006-.003-.007 1.609-.522a1.62 1.62 0 0 0 1.035-2.024zM10.86 14.238l-1.097-3.377a.02.02 0 0 0 .005-.001v-.006c1.098-.356 2.268-.735 3.363-1.092l1.098 3.377-3.369 1.099z"
                }
            }
        ]
    })(props);
}
function BiLogoSlack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.194 14.644c0 1.16-.943 2.107-2.103 2.107a2.11 2.11 0 0 1-2.104-2.107 2.11 2.11 0 0 1 2.104-2.106h2.103v2.106zm1.061 0c0-1.16.944-2.106 2.104-2.106a2.11 2.11 0 0 1 2.103 2.106v5.274a2.11 2.11 0 0 1-2.103 2.106 2.108 2.108 0 0 1-2.104-2.106v-5.274zm2.104-8.455c-1.16 0-2.104-.948-2.104-2.107s.944-2.106 2.104-2.106a2.11 2.11 0 0 1 2.103 2.106v2.107H9.359zm0 1.06a2.11 2.11 0 0 1 2.103 2.107 2.11 2.11 0 0 1-2.103 2.106H4.092a2.11 2.11 0 0 1-2.104-2.106 2.11 2.11 0 0 1 2.104-2.107h5.267zm8.447 2.107c0-1.16.943-2.107 2.103-2.107a2.11 2.11 0 0 1 2.104 2.107 2.11 2.11 0 0 1-2.104 2.106h-2.103V9.356zm-1.061 0c0 1.16-.944 2.106-2.104 2.106a2.11 2.11 0 0 1-2.103-2.106V4.082a2.11 2.11 0 0 1 2.103-2.106c1.16 0 2.104.946 2.104 2.106v5.274zm-2.104 8.455c1.16 0 2.104.948 2.104 2.107s-.944 2.106-2.104 2.106a2.11 2.11 0 0 1-2.103-2.106v-2.107h2.103zm0-1.06a2.11 2.11 0 0 1-2.103-2.107 2.11 2.11 0 0 1 2.103-2.106h5.268a2.11 2.11 0 0 1 2.104 2.106 2.11 2.11 0 0 1-2.104 2.107h-5.268z"
                }
            }
        ]
    })(props);
}
function BiLogoSnapchat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.166 3c.796 0 3.495.223 4.769 3.073.426.959.324 2.589.24 3.898l-.002.047c-.011.146-.018.278-.024.41a.62.62 0 0 0 .322.072c.241-.013.53-.096.831-.241a.81.81 0 0 1 .373-.084c.146 0 .289.023.409.072.361.12.59.385.59.674.013.361-.313.675-.975.939-.071.023-.169.061-.276.096-.363.109-.917.289-1.073.651-.072.181-.049.421.098.697l.012.013c.048.109 1.228 2.795 3.854 3.229a.401.401 0 0 1 .337.409c0 .06-.013.119-.036.181-.193.457-1.023.795-2.53 1.021-.047.073-.096.302-.132.459-.022.144-.06.289-.107.444-.061.218-.217.325-.446.325h-.024a2.45 2.45 0 0 1-.433-.059 4.799 4.799 0 0 0-1.024-.108c-.24 0-.48.012-.732.06-.483.084-.904.373-1.386.71-.687.481-1.469 1.036-2.649 1.036-.048 0-.096-.012-.146-.012h-.119c-1.181 0-1.951-.543-2.637-1.036-.481-.338-.89-.626-1.373-.711a5.507 5.507 0 0 0-.745-.06c-.435 0-.771.072-1.023.12-.17.035-.314.059-.435.059a.45.45 0 0 1-.47-.337c-.048-.154-.071-.313-.107-.456-.038-.146-.085-.396-.133-.458-1.543-.179-2.373-.517-2.565-.986a.473.473 0 0 1-.044-.181.398.398 0 0 1 .337-.409c2.625-.434 3.805-3.119 3.854-3.232l.013-.023c.145-.277.18-.52.096-.699-.156-.349-.711-.529-1.07-.65a1.759 1.759 0 0 1-.279-.096c-.89-.35-1.011-.748-.962-1.024.072-.384.541-.637.939-.637.117 0 .217.023.308.06.337.155.635.241.888.241a.742.742 0 0 0 .373-.085l-.041-.458c-.08-1.307-.182-2.935.247-3.889 1.236-2.836 3.929-3.054 4.724-3.054L12.117 3h.049z"
                }
            }
        ]
    })(props);
}
function BiLogoSoundcloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.971 12.188c-.041 0-.078.038-.083.082l-.194 1.797.194 1.756c.005.049.042.082.083.082s.075-.033.084-.082l.211-1.756-.225-1.797c0-.046-.037-.082-.074-.082m-.75.691c-.051 0-.076.03-.088.079l-.138 1.109.138 1.092c0 .046.037.078.075.078.039 0 .073-.038.087-.087l.176-1.1-.176-1.112c0-.051-.037-.076-.075-.076m1.526-1.025c-.052 0-.1.039-.1.087l-.176 2.139.188 2.051c0 .049.037.1.099.1.052 0 .089-.051.102-.1l.211-2.064-.211-2.126c-.013-.049-.052-.1-.102-.1m.79-.075c-.063 0-.114.051-.126.113l-.161 2.201.177 2.123c.012.063.061.114.122.114.064 0 .113-.051.125-.124l.201-2.113-.201-2.187a.11.11 0 0 0-.111-.112l-.026-.015zm.962.301a.128.128 0 0 0-.133-.125.134.134 0 0 0-.137.125l-.182 2.026.169 2.138a.13.13 0 0 0 .132.131c.062 0 .123-.055.123-.132l.189-2.139-.189-2.036.028.012zm.674-1.426a.154.154 0 0 0-.148.15l-.176 3.3.156 2.139c0 .077.066.137.15.137.078 0 .145-.074.15-.15l.174-2.137-.173-3.313c-.007-.088-.074-.152-.15-.152m.8-.762a.178.178 0 0 0-.17.163l-.15 4.063.138 2.125c0 .1.075.174.163.174.086 0 .161-.074.174-.174l.162-2.125-.161-4.052c-.013-.1-.088-.175-.175-.175m.826-.372c-.102 0-.176.073-.188.173l-.139 4.4.139 2.102c.012.1.086.188.188.188a.193.193 0 0 0 .187-.188l.163-2.102-.164-4.4c0-.1-.087-.188-.188-.188m1.038.038a.196.196 0 0 0-.199-.199.205.205 0 0 0-.201.199l-.125 4.538.124 2.089c.015.111.101.199.214.199s.201-.088.201-.199l.136-2.089-.136-4.55-.014.012zm.625-.111c-.113 0-.213.1-.213.211l-.125 4.439.125 2.063c0 .125.1.213.213.213a.221.221 0 0 0 .214-.224l.125-2.064-.14-4.428c0-.122-.1-.225-.225-.225m.838.139a.236.236 0 0 0-.237.237l-.086 4.29.113 2.063c0 .124.1.231.236.231.125 0 .227-.1.237-.237l.101-2.038-.112-4.265c-.01-.137-.113-.238-.237-.238m.988-.786a.27.27 0 0 0-.139-.037c-.05 0-.1.013-.137.037a.25.25 0 0 0-.125.214v.05l-.086 5.044.096 2.043v.007c.006.05.024.112.06.15.05.051.12.086.196.086a.28.28 0 0 0 .175-.074.262.262 0 0 0 .076-.188l.013-.201.097-1.838-.113-5.075a.24.24 0 0 0-.111-.199l-.002-.019zm.837-.457a.155.155 0 0 0-.124-.052.283.283 0 0 0-.174.052.265.265 0 0 0-.1.201v.023l-.114 5.513.063 1.014.052.988a.274.274 0 0 0 .548-.012l.125-2.013-.125-5.536a.273.273 0 0 0-.138-.231m7.452 3.15c-.336 0-.663.072-.949.193a4.34 4.34 0 0 0-5.902-3.651c-.188.075-.227.151-.238.301v7.812a.31.31 0 0 0 .275.29h6.827a2.428 2.428 0 0 0 2.45-2.438 2.457 2.457 0 0 0-2.45-2.463"
                }
            }
        ]
    })(props);
}
function BiLogoSpotify(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.01 2.019c-5.495 0-9.991 4.496-9.991 9.991 0 5.494 4.496 9.99 9.991 9.99 5.494 0 9.99-4.496 9.99-9.99 0-5.495-4.446-9.991-9.99-9.991zm4.595 14.436c-.199.299-.549.4-.85.201-2.349-1.45-5.296-1.75-8.793-.951-.348.102-.648-.148-.748-.449-.101-.35.149-.648.45-.749 3.795-.85 7.093-.499 9.69 1.1.35.149.4.548.251.848zm1.2-2.747c-.251.349-.7.499-1.051.249-2.697-1.646-6.792-2.148-9.939-1.148-.398.101-.85-.1-.949-.498-.101-.402.1-.852.499-.952 3.646-1.098 8.143-.548 11.239 1.351.3.149.45.648.201.998zm.099-2.799c-3.197-1.897-8.542-2.097-11.59-1.146a.938.938 0 0 1-1.148-.6.937.937 0 0 1 .599-1.151c3.547-1.049 9.392-.85 13.089 1.351.449.249.599.849.349 1.298-.25.35-.849.498-1.299.248z"
                }
            }
        ]
    })(props);
}
function BiLogoSpringBoot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.205 16.392c-2.469 3.289-7.741 2.179-11.122 2.338 0 0-.599.034-1.201.133 0 0 .228-.097.519-.198 2.374-.821 3.496-.986 4.939-1.727 2.71-1.388 5.408-4.413 5.957-7.555-1.032 3.022-4.17 5.623-7.027 6.679-1.955.722-5.492 1.424-5.493 1.424a5.28 5.28 0 0 1-.143-.076c-2.405-1.17-2.475-6.38 1.894-8.059 1.916-.736 3.747-.332 5.818-.825 2.208-.525 4.766-2.18 5.805-4.344 1.165 3.458 2.565 8.866.054 12.21zm.042-13.28a9.212 9.212 0 0 1-1.065 1.89 9.982 9.982 0 0 0-7.167-3.031C6.492 1.971 2 6.463 2 11.985a9.983 9.983 0 0 0 3.205 7.334l.22.194a.856.856 0 1 1 .001.001l.149.132A9.96 9.96 0 0 0 12.015 22c5.278 0 9.613-4.108 9.984-9.292.274-2.539-.476-5.763-1.752-9.596"
                }
            }
        ]
    })(props);
}
function BiLogoSquarespace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.886 9.264c-1.502-1.5-3.941-1.5-5.475 0l-6.13 6.131a.981.981 0 0 0 0 1.377.982.982 0 0 0 1.376 0l6.13-6.131a1.925 1.925 0 0 1 2.722 2.723l-6.037 6.035c.751.75 1.971.75 2.723 0l4.66-4.66c1.531-1.534 1.531-3.973.031-5.475zm-2.064 2.033a.982.982 0 0 0-1.376 0l-6.134 6.162c-.751.75-1.97.75-2.72 0-.376-.375-1.002-.375-1.377 0s-.375 1.002 0 1.375c1.502 1.502 3.942 1.502 5.475 0l6.131-6.129c.375-.406.375-1.033.001-1.408zm-2.035-6.129c-1.501-1.502-3.941-1.502-5.475 0l-6.131 6.129a.98.98 0 0 0 0 1.375.98.98 0 0 0 1.377 0l6.168-6.129a1.934 1.934 0 0 1 2.727 0 .982.982 0 0 0 1.376 0c.352-.406.352-1-.024-1.375h-.018zm-2.063 2.031a.978.978 0 0 0-1.376 0l-6.131 6.164a1.933 1.933 0 0 1-2.723 0 1.927 1.927 0 0 1 0-2.723l6.037-6.039a1.928 1.928 0 0 0-2.722 0L3.118 9.264c-1.501 1.502-1.501 3.941 0 5.475 1.501 1.502 3.94 1.502 5.475 0l6.129-6.131c.377-.408.377-1.033 0-1.408h.002z"
                }
            }
        ]
    })(props);
}
function BiLogoStackOverflow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.24 19.399v-4.804h1.6V21H4.381v-6.405h1.598v4.804H17.24zM7.582 17.8h8.055v-1.604H7.582V17.8zm.195-3.64 7.859 1.641.34-1.552-7.861-1.642-.338 1.553zm1.018-3.794 7.281 3.398.678-1.463-7.281-3.399-.678 1.454v.01zm2.037-3.589 6.166 5.142 1.018-1.216-6.162-5.14-1.016 1.213-.006.001zm3.982-3.778-1.311.969 4.803 6.454 1.313-.971-4.807-6.452h.002z"
                }
            }
        ]
    })(props);
}
function BiLogoSteam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.21 17.32 7 16.8a2.13 2.13 0 1 0 1.17-2.93l1.28.53a1.58 1.58 0 0 1-1.22 2.92z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 0 0-10 9.34l5.38 2.21a2.31 2.31 0 0 1 .47-.24A2.62 2.62 0 0 1 9 13.1l2.44-3.56a3.8 3.8 0 1 1 3.8 3.8h-.08l-3.51 2.5a2.77 2.77 0 0 1-5.47.68l-3.77-1.6A10 10 0 1 0 12 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.79 9.5a2.53 2.53 0 1 0-2.53 2.5 2.54 2.54 0 0 0 2.53-2.5zm-4.42 0a1.9 1.9 0 1 1 1.9 1.91 1.9 1.9 0 0 1-1.9-1.92z"
                }
            }
        ]
    })(props);
}
function BiLogoStripe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.479 9.883c-1.626-.604-2.512-1.067-2.512-1.803 0-.622.511-.977 1.423-.977 1.667 0 3.379.642 4.558 1.22l.666-4.111c-.935-.446-2.847-1.177-5.49-1.177-1.87 0-3.425.489-4.536 1.401-1.155.954-1.757 2.334-1.757 4 0 3.023 1.847 4.312 4.847 5.403 1.936.688 2.579 1.178 2.579 1.934 0 .732-.629 1.155-1.762 1.155-1.403 0-3.716-.689-5.231-1.578l-.674 4.157c1.304.732 3.705 1.488 6.197 1.488 1.976 0 3.624-.467 4.735-1.356 1.245-.977 1.89-2.422 1.89-4.289 0-3.091-1.889-4.38-4.935-5.468h.002z"
                }
            }
        ]
    })(props);
}
function BiLogoTailwindCss(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 9.51a4.22 4.22 0 0 1-1.91-1.34A5.77 5.77 0 0 0 12 6a4.72 4.72 0 0 0-5 4 3.23 3.23 0 0 1 3.5-1.49 4.32 4.32 0 0 1 1.91 1.35A5.77 5.77 0 0 0 17 12a4.72 4.72 0 0 0 5-4 3.2 3.2 0 0 1-3.5 1.51zm-13 4.98a4.22 4.22 0 0 1 1.91 1.34A5.77 5.77 0 0 0 12 18a4.72 4.72 0 0 0 5-4 3.23 3.23 0 0 1-3.5 1.49 4.32 4.32 0 0 1-1.91-1.35A5.8 5.8 0 0 0 7 12a4.72 4.72 0 0 0-5 4 3.2 3.2 0 0 1 3.5-1.51z"
                }
            }
        ]
    })(props);
}
function BiLogoTelegram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m20.665 3.717-17.73 6.837c-1.21.486-1.203 1.161-.222 1.462l4.552 1.42 10.532-6.645c.498-.303.953-.14.579.192l-8.533 7.701h-.002l.002.001-.314 4.692c.46 0 .663-.211.921-.46l2.211-2.15 4.599 3.397c.848.467 1.457.227 1.668-.785l3.019-14.228c.309-1.239-.473-1.8-1.282-1.434z"
                }
            }
        ]
    })(props);
}
function BiLogoTiktok(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"
                }
            }
        ]
    })(props);
}
function BiLogoTrello(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.75 3H5.25A2.25 2.25 0 0 0 3 5.25v13.5A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V5.25A2.25 2.25 0 0 0 18.75 3zm-7.92 13.635a1.08 1.08 0 0 1-1.08 1.08H6.42a1.08 1.08 0 0 1-1.08-1.08V6.42c0-.597.483-1.08 1.08-1.08h3.33c.596 0 1.08.483 1.08 1.08v10.215zm7.83-4.5a1.08 1.08 0 0 1-1.08 1.08h-3.33a1.08 1.08 0 0 1-1.08-1.08V6.42c0-.597.484-1.08 1.08-1.08h3.33c.597 0 1.08.483 1.08 1.08v5.715z"
                }
            }
        ]
    })(props);
}
function BiLogoTripAdvisor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.31 10.28a2.5 2.5 0 1 0 2.5 2.49 2.5 2.5 0 0 0-2.5-2.49zm0 3.8a1.31 1.31 0 1 1 0-2.61 1.31 1.31 0 1 1 0 2.61zm7.38-3.8a2.5 2.5 0 1 0 2.5 2.49 2.5 2.5 0 0 0-2.5-2.49zM17 12.77a1.31 1.31 0 1 1-1.31-1.3 1.31 1.31 0 0 1 1.31 1.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm7.38 10.77a3.69 3.69 0 0 1-6.2 2.71L12 16.77l-1.18-1.29a3.69 3.69 0 1 1-5-5.44l-1.2-1.3H7.3a8.33 8.33 0 0 1 9.41 0h2.67l-1.2 1.31a3.71 3.71 0 0 1 1.2 2.72z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.77 9.05a7.19 7.19 0 0 0-5.54 0A4.06 4.06 0 0 1 12 12.7a4.08 4.08 0 0 1 2.77-3.65z"
                }
            }
        ]
    })(props);
}
function BiLogoTumblr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.078 20.953c-2.692 0-4.699-1.385-4.699-4.7v-5.308H6.931V8.07c2.694-.699 3.821-3.017 3.95-5.023h2.796v4.558h3.263v3.34h-3.263v4.622c0 1.386.699 1.864 1.813 1.864h1.58v3.522h-2.992z"
                }
            }
        ]
    })(props);
}
function BiLogoTux(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.642 8.084c-.364.189-.79.42-1.242.42s-.81-.209-1.066-.413c-.13-.101-.234-.202-.313-.276-.137-.108-.12-.259-.064-.254.094.012.108.136.168.191.08.075.18.172.302.269.243.192.567.38.973.38s.878-.238 1.167-.4c.163-.092.371-.256.541-.381.13-.095.125-.21.232-.198.107.013.028.127-.122.258a3.404 3.404 0 0 1-.576.404z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.649 17.77c-.142-.16-.209-.456-.281-.771s-.153-.654-.411-.874l-.002-.001a1.054 1.054 0 0 0-.317-.192c.359-1.065.219-2.126-.145-3.084-.444-1.177-1.222-2.202-1.815-2.903-.664-.838-1.313-1.633-1.301-2.808.021-1.793.197-5.118-2.958-5.122a4.66 4.66 0 0 0-.401.017c-3.526.283-2.59 4.008-2.643 5.255-.064.912-.249 1.631-.877 2.523-.736.876-1.774 2.295-2.266 3.771-.232.697-.342 1.407-.241 2.08a1.9 1.9 0 0 0-.091.089c-.216.231-.376.511-.555.699-.166.167-.403.229-.664.323s-.547.231-.721.565l-.001.002a1 1 0 0 0-.108.484c0 .154.023.311.046.461.048.313.097.609.032.81-.206.564-.232.954-.087 1.237.146.284.444.409.783.479.676.141 1.592.106 2.314.489l.062-.117-.061.118c.773.404 1.557.547 2.182.405.454-.104.821-.374 1.011-.789.489-.002 1.025-.209 1.885-.256.583-.047 1.312.207 2.149.16a1.119 1.119 0 0 0 .099.264c.324.649.928.946 1.571.896s1.329-.43 1.883-1.089l-.102-.085.102.084c.527-.64 1.403-.905 1.984-1.255.29-.175.525-.395.544-.713.018-.318-.169-.675-.599-1.152zm-7.79-11.708c-.003-.234.036-.435.126-.639s.201-.351.358-.47.312-.174.494-.176h.009c.179 0 .332.053.489.167.159.116.274.261.366.463a1.493 1.493 0 0 1 .141.636c.002.235-.038.435-.127.639a1.23 1.23 0 0 1-.18.299l-.074-.033c-.089-.038-.167-.069-.237-.096s-.124-.044-.181-.064c.041-.049.122-.108.151-.181a.943.943 0 0 0 .072-.347l.002-.016a.953.953 0 0 0-.05-.337c-.038-.113-.086-.195-.155-.263s-.139-.099-.223-.101h-.011a.324.324 0 0 0-.217.086.618.618 0 0 0-.174.25.944.944 0 0 0-.072.348l-.001.015a.992.992 0 0 0 .014.2 2.463 2.463 0 0 0-.507-.171 1.681 1.681 0 0 1-.014-.19v-.019zm-2.144.052c-.012-.202.009-.376.064-.556s.13-.311.238-.418a.516.516 0 0 1 .349-.168h.03c.118 0 .225.04.335.127a.968.968 0 0 1 .284.389c.076.171.116.343.127.545v.002a1.51 1.51 0 0 1-.002.243c-.023.006-.046.014-.068.021-.128.044-.23.093-.328.158a.845.845 0 0 0 .003-.214v-.012a.95.95 0 0 0-.068-.274.523.523 0 0 0-.138-.203c-.052-.044-.1-.065-.153-.064l-.017.001c-.061.005-.11.034-.157.092a.536.536 0 0 0-.101.223.912.912 0 0 0-.019.293l.001.012c.01.103.031.189.067.275a.528.528 0 0 0 .166.224c-.059.045-.098.078-.146.113l-.11.081a.995.995 0 0 1-.229-.342 1.528 1.528 0 0 1-.128-.546v-.002zm.155 1.228c.187-.14.315-.234.402-.298.086-.063.121-.086.148-.112h.001c.14-.132.362-.374.699-.49.115-.04.245-.065.39-.066.275-.001.608.089 1.01.348.247.16.439.174.882.363h.001c.213.087.338.202.399.321.061.12.063.25.012.387-.103.273-.429.562-.887.705h-.001c-.224.072-.418.233-.647.364a1.449 1.449 0 0 1-.842.217 1.105 1.105 0 0 1-.374-.083 1.202 1.202 0 0 1-.27-.167c-.161-.131-.303-.295-.51-.416h-.002c-.333-.19-.515-.408-.573-.598-.057-.189-.003-.351.162-.475zm.131 13.018v.001c-.047.623-.398.961-.938 1.085-.539.123-1.27 0-1.999-.381h-.001c-.808-.427-1.768-.385-2.384-.514-.308-.064-.509-.161-.602-.341-.092-.18-.094-.494.102-1.028l.001-.002.001-.002c.097-.299.025-.626-.021-.934-.047-.307-.07-.586.034-.781l.001-.002c.135-.259.332-.352.576-.439.245-.088.534-.157.764-.386l.001-.001.001-.001c.212-.223.371-.503.557-.702.157-.167.314-.279.551-.28h.009c.041 0 .085.003.132.011.314.047.588.268.853.625l.762 1.389h.001c.202.423.631.89.994 1.365.362.475.644.952.607 1.317l-.002.001zm-.063-1.01a6.721 6.721 0 0 0-.333-.469 13.467 13.467 0 0 0-.229-.293c.151 0 .28-.024.384-.072a.486.486 0 0 0 .266-.274c.09-.242 0-.583-.288-.973-.29-.39-.778-.83-1.494-1.269-.527-.328-.821-.729-.959-1.165s-.119-.907-.013-1.373c.204-.894.729-1.762 1.063-2.308.09-.066.032.123-.339.811-.332.629-.953 2.081-.103 3.214a6.722 6.722 0 0 1 .538-2.398c.472-1.067 1.456-2.919 1.534-4.395.041.029.18.123.241.158.182.106.316.262.492.403.177.142.396.264.729.283l.093.003c.343 0 .61-.112.833-.239.242-.138.436-.292.618-.351h.001c.387-.122.694-.335.869-.585.302 1.186 1.001 2.897 1.45 3.733.239.443.715 1.385.92 2.52.13-.004.273.015.427.054.537-1.393-.455-2.892-.909-3.31-.184-.178-.192-.258-.102-.254.492.436 1.139 1.311 1.374 2.3.107.451.13.925.016 1.393.056.023.113.048.171.076.862.42 1.181.785 1.027 1.283-.05-.002-.1-.001-.148 0h-.014c.125-.395-.151-.687-.889-1.02-.764-.336-1.373-.303-1.476.379a1.302 1.302 0 0 0-.017.109c-.057.02-.114.045-.172.076-.358.197-.555.553-.664.99-.108.437-.14.964-.17 1.558-.019.298-.141.702-.266 1.129-1.249.897-2.986 1.283-4.461.276zm9.628.057c-.524.317-1.456.593-2.05 1.313-.517.615-1.146.952-1.7.996-.555.044-1.033-.186-1.315-.752v-.001l-.001-.003c-.175-.333-.102-.858.045-1.412.147-.554.359-1.123.388-1.585v-.001c.03-.592.063-1.11.163-1.509.1-.399.256-.669.533-.821l.039-.02c.031.513.285 1.036.734 1.149.491.129 1.199-.292 1.498-.636.06-.002.118-.006.175-.007.262-.006.481.009.707.205v.001h.001c.173.146.255.423.326.733.071.31.128.647.342.888h.001c.41.456.542.764.531.96-.011.198-.153.344-.417.502z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.738 6.762c.015.048.093.04.138.063.04.02.071.065.116.066.042.001.107-.015.113-.057.008-.056-.073-.091-.126-.111-.067-.026-.153-.039-.216-.004-.014.008-.03.027-.025.043zm-.46 0c-.016.048-.094.04-.139.063-.039.02-.071.065-.115.066-.042.001-.108-.015-.114-.057-.007-.056.074-.091.126-.111.067-.026.153-.039.217-.004.015.008.03.027.025.043z"
                }
            }
        ]
    })(props);
}
function BiLogoTwitch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.265 3 3 6.236v13.223h4.502V21l2.531.85 2.392-2.391h3.658l4.923-4.924V3H4.265zm15.052 10.691-2.813 2.814h-4.502l-2.391 2.391v-2.391H5.813V4.688h13.504v9.003zm-2.812-5.767v4.923h-1.688V7.924h1.688zm-4.502 0v4.923h-1.688V7.924h1.688z"
                }
            }
        ]
    })(props);
}
function BiLogoTwitter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.633 7.997c.013.175.013.349.013.523 0 5.325-4.053 11.461-11.46 11.461-2.282 0-4.402-.661-6.186-1.809.324.037.636.05.973.05a8.07 8.07 0 0 0 5.001-1.721 4.036 4.036 0 0 1-3.767-2.793c.249.037.499.062.761.062.361 0 .724-.05 1.061-.137a4.027 4.027 0 0 1-3.23-3.953v-.05c.537.299 1.16.486 1.82.511a4.022 4.022 0 0 1-1.796-3.354c0-.748.199-1.434.548-2.032a11.457 11.457 0 0 0 8.306 4.215c-.062-.3-.1-.611-.1-.923a4.026 4.026 0 0 1 4.028-4.028c1.16 0 2.207.486 2.943 1.272a7.957 7.957 0 0 0 2.556-.973 4.02 4.02 0 0 1-1.771 2.22 8.073 8.073 0 0 0 2.319-.624 8.645 8.645 0 0 1-2.019 2.083z"
                }
            }
        ]
    })(props);
}
function BiLogoTypescript(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.24 3H4.76A1.76 1.76 0 0 0 3 4.76v14.48A1.76 1.76 0 0 0 4.76 21h14.48A1.76 1.76 0 0 0 21 19.24V4.76A1.76 1.76 0 0 0 19.24 3zm-5.8 10h-2.25v6.44H9.4V13H7.15v-1.46h6.29zm5.8 5.28a1.71 1.71 0 0 1-.67.74 3 3 0 0 1-1 .39 5.81 5.81 0 0 1-1.2.12 7 7 0 0 1-1.23-.11 4.52 4.52 0 0 1-1-.33v-1.71l-.06-.06h.06v.07a3.41 3.41 0 0 0 1 .54 3.06 3.06 0 0 0 1.13.2 2.58 2.58 0 0 0 .6-.06 1.47 1.47 0 0 0 .42-.17.75.75 0 0 0 .25-.25.69.69 0 0 0-.06-.74 1.24 1.24 0 0 0-.35-.33 3.12 3.12 0 0 0-.53-.3l-.67-.28a3.57 3.57 0 0 1-1.37-1 2 2 0 0 1-.46-1.33 2.16 2.16 0 0 1 .24-1.06 2.09 2.09 0 0 1 .66-.71 2.88 2.88 0 0 1 1-.42 5.11 5.11 0 0 1 1.19-.13 7 7 0 0 1 1.09.07 4.53 4.53 0 0 1 .88.23v1.65a2.42 2.42 0 0 0-.42-.24 3.58 3.58 0 0 0-.49-.17 3 3 0 0 0-.49-.1 2.45 2.45 0 0 0-.46 0 2.29 2.29 0 0 0-.56.06 1.54 1.54 0 0 0-.43.16.78.78 0 0 0-.26.25.63.63 0 0 0-.09.33.62.62 0 0 0 .1.35 1.19 1.19 0 0 0 .3.29 2.15 2.15 0 0 0 .46.28l.63.28a6.56 6.56 0 0 1 .84.42 2.65 2.65 0 0 1 .64.49 1.79 1.79 0 0 1 .42.63 2.48 2.48 0 0 1 .14.85 2.68 2.68 0 0 1-.25 1.08z"
                }
            }
        ]
    })(props);
}
function BiLogoUnity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m10.4 17.8 1.21 2.07L19.77 22 22 14.08 20.72 12 22 10l-2.23-8-8.16 2.13L10.4 6.2H8L2 12l6 5.81zm9.92-5.8-1.73 6L15 12l3.59-6zM10.6 6.54 16.84 5l-3.59 6H6.08zM13.27 13l3.59 6-6.26-1.55L6.1 13z"
                }
            }
        ]
    })(props);
}
function BiLogoUnsplash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.625 8.063V3h6.75v5.063h-6.75zm6.75 2.812H21V21H3V10.875h5.625v5.063h6.75v-5.063z"
                }
            }
        ]
    })(props);
}
function BiLogoUpwork(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.47 6.07a4.54 4.54 0 0 0-4.38 3.69 19.9 19.9 0 0 1-2.28-4.9H8.55v6a2.14 2.14 0 1 1-4.28 0v-6L2 4.91v6a4.4 4.4 0 1 0 8.8-.05v-1a20.55 20.55 0 0 0 1.65 2.7l-1.38 6.61h2.32l1-4.81a5.61 5.61 0 0 0 3.11.89 4.57 4.57 0 0 0 0-9.14zm0 6.83a4.09 4.09 0 0 1-2.55-1l.23-.91v-.05c.16-1 .66-2.6 2.35-2.6a2.25 2.25 0 0 1 2.27 2.24 2.41 2.41 0 0 1-2.27 2.32z"
                }
            }
        ]
    })(props);
}
function BiLogoVenmo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3.27a7.49 7.49 0 0 1 .66 3.35c0 2.72-1.93 6.72-3.49 9.27L9.53 2.44l-6.91.65L5.79 22h7.88c3.45-4.54 7.71-11 7.71-16a7.3 7.3 0 0 0-1.06-4z"
                }
            }
        ]
    })(props);
}
function BiLogoVimeo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.062 10.414c-2.036 4.349-6.949 10.267-10.054 10.267-3.06 0-3.501-6.527-5.173-10.869-.823-2.138-1.354-1.646-2.896-.567L2 8.031c2.248-1.976 4.499-4.272 5.88-4.399 1.559-.148 2.517.916 2.873 3.193.475 2.994 1.137 7.641 2.291 7.641.9 0 3.117-3.686 3.232-5.004.203-1.93-1.421-1.989-2.828-1.387 2.228-7.295 11.494-5.95 7.614 2.339z"
                }
            }
        ]
    })(props);
}
function BiLogoVisa(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.539 9.186a4.155 4.155 0 0 0-1.451-.251c-1.6 0-2.73.806-2.738 1.963-.01.85.803 1.329 1.418 1.613.631.292.842.476.84.737-.004.397-.504.577-.969.577-.639 0-.988-.089-1.525-.312l-.199-.093-.227 1.332c.389.162 1.09.301 1.814.313 1.701 0 2.813-.801 2.826-2.032.014-.679-.426-1.192-1.352-1.616-.563-.275-.912-.459-.912-.738 0-.247.299-.511.924-.511a2.95 2.95 0 0 1 1.213.229l.15.067.227-1.287-.039.009zm4.152-.143h-1.25c-.389 0-.682.107-.852.493l-2.404 5.446h1.701l.34-.893 2.076.002c.049.209.199.891.199.891h1.5l-1.31-5.939zm-10.642-.05h1.621l-1.014 5.942H9.037l1.012-5.944v.002zm-4.115 3.275.168.825 1.584-4.05h1.717l-2.551 5.931H5.139l-1.4-5.022a.339.339 0 0 0-.149-.199 6.948 6.948 0 0 0-1.592-.589l.022-.125h2.609c.354.014.639.125.734.503l.57 2.729v-.003zm12.757.606.646-1.662c-.008.018.133-.343.215-.566l.111.513.375 1.714H18.69v.001h.001z"
                }
            }
        ]
    })(props);
}
function BiLogoVisualStudio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m21.29 4.1-4.12-2a1.36 1.36 0 0 0-.48-.1h-.08a1.18 1.18 0 0 0-.72.24l-.14.12-7.88 7.19L4.44 7a.83.83 0 0 0-.54-.17.88.88 0 0 0-.53.17l-1.1 1a.8.8 0 0 0-.27.61.84.84 0 0 0 .27.62l3 2.71-3 2.72a.84.84 0 0 0 0 1.23l1.1 1a.89.89 0 0 0 .6.22.93.93 0 0 0 .47-.17l3.43-2.61 7.88 7.19a1.2 1.2 0 0 0 .76.36h.17a1 1 0 0 0 .49-.12l4.12-2a1.25 1.25 0 0 0 .71-1.1V5.23a1.26 1.26 0 0 0-.71-1.13zM17 16.47l-6-4.53 6-4.53z"
                }
            }
        ]
    })(props);
}
function BiLogoVk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.579 6.855c.14-.465 0-.806-.662-.806h-2.193c-.558 0-.813.295-.953.619 0 0-1.115 2.719-2.695 4.482-.51.513-.743.675-1.021.675-.139 0-.341-.162-.341-.627V6.855c0-.558-.161-.806-.626-.806H9.642c-.348 0-.558.258-.558.504 0 .528.79.65.871 2.138v3.228c0 .707-.127.836-.407.836-.743 0-2.551-2.729-3.624-5.853-.209-.607-.42-.852-.98-.852H2.752c-.627 0-.752.295-.752.619 0 .582.743 3.462 3.461 7.271 1.812 2.601 4.363 4.011 6.687 4.011 1.393 0 1.565-.313 1.565-.853v-1.966c0-.626.133-.752.574-.752.324 0 .882.164 2.183 1.417 1.486 1.486 1.732 2.153 2.567 2.153h2.192c.626 0 .939-.313.759-.931-.197-.615-.907-1.51-1.849-2.569-.512-.604-1.277-1.254-1.51-1.579-.325-.419-.231-.604 0-.976.001.001 2.672-3.761 2.95-5.04z"
                }
            }
        ]
    })(props);
}
function BiLogoVuejs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m12 12.765 5.592-9.437h-3.276L12 7.33v.002L9.688 3.328h-3.28z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.461 3.332 12 14.235 5.539 3.332H1.992L12 20.672l10.008-17.34z"
                }
            }
        ]
    })(props);
}
function BiLogoWhatsappSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.043 6.925a4.985 4.985 0 0 0-4.98 4.979c-.001.94.263 1.856.761 2.649l.118.188-.503 1.837 1.885-.494.181.108a4.97 4.97 0 0 0 2.535.693h.001a4.986 4.986 0 0 0 4.979-4.978 4.946 4.946 0 0 0-1.456-3.522 4.946 4.946 0 0 0-3.521-1.46zm2.928 7.118c-.125.35-.723.668-1.01.711a2.044 2.044 0 0 1-.943-.059 8.51 8.51 0 0 1-.853-.315c-1.502-.648-2.482-2.159-2.558-2.26-.074-.1-.61-.812-.61-1.548 0-.737.386-1.099.523-1.249a.552.552 0 0 1 .4-.186c.1 0 .199.001.287.005.092.004.215-.035.336.257.125.3.425 1.036.462 1.111.037.074.062.162.013.262-.05.101-.074.162-.15.25-.074.088-.157.195-.224.263-.075.074-.153.155-.066.305.088.149.388.64.832 1.037.572.51 1.055.667 1.204.743.15.074.237.063.325-.038.087-.101.374-.437.474-.586.1-.15.199-.125.337-.076.137.051.873.412 1.022.487.148.074.249.112.287.175.036.062.036.361-.088.711z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-7.96 14.896h-.002a5.98 5.98 0 0 1-2.862-.729L6 18l.85-3.104a5.991 5.991 0 0 1 5.19-8.983 5.95 5.95 0 0 1 4.238 1.757 5.95 5.95 0 0 1 1.751 4.237 5.998 5.998 0 0 1-5.989 5.989z"
                }
            }
        ]
    })(props);
}
function BiLogoWhatsapp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M18.403 5.633A8.919 8.919 0 0 0 12.053 3c-4.948 0-8.976 4.027-8.978 8.977 0 1.582.413 3.126 1.198 4.488L3 21.116l4.759-1.249a8.981 8.981 0 0 0 4.29 1.093h.004c4.947 0 8.975-4.027 8.977-8.977a8.926 8.926 0 0 0-2.627-6.35m-6.35 13.812h-.003a7.446 7.446 0 0 1-3.798-1.041l-.272-.162-2.824.741.753-2.753-.177-.282a7.448 7.448 0 0 1-1.141-3.971c.002-4.114 3.349-7.461 7.465-7.461a7.413 7.413 0 0 1 5.275 2.188 7.42 7.42 0 0 1 2.183 5.279c-.002 4.114-3.349 7.462-7.461 7.462m4.093-5.589c-.225-.113-1.327-.655-1.533-.73-.205-.075-.354-.112-.504.112s-.58.729-.711.879-.262.168-.486.056-.947-.349-1.804-1.113c-.667-.595-1.117-1.329-1.248-1.554s-.014-.346.099-.458c.101-.1.224-.262.336-.393.112-.131.149-.224.224-.374s.038-.281-.019-.393c-.056-.113-.505-1.217-.692-1.666-.181-.435-.366-.377-.504-.383a9.65 9.65 0 0 0-.429-.008.826.826 0 0 0-.599.28c-.206.225-.785.767-.785 1.871s.804 2.171.916 2.321c.112.15 1.582 2.415 3.832 3.387.536.231.954.369 1.279.473.537.171 1.026.146 1.413.089.431-.064 1.327-.542 1.514-1.066.187-.524.187-.973.131-1.067-.056-.094-.207-.151-.43-.263"
                }
            }
        ]
    })(props);
}
function BiLogoWikipedia(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.081 12.932c-.78 1.611-1.849 3.792-2.379 4.776-.513.896-.94.776-1.278.024-1.172-2.77-3.58-7.625-4.712-10.347-.209-.502-.367-.823-.516-.95-.151-.125-.462-.2-.936-.227-.174-.019-.26-.061-.26-.131v-.379l.043-.038c.771-.004 4.503 0 4.503 0l.042.038v.362c0 .1-.063.147-.188.147l-.47.024c-.403.026-.605.137-.605.365 0 .112.044.275.139.501.902 2.206 4.017 8.772 4.017 8.772l.114.039 2.01-4.012-.402-.89L9.82 8.285s-.265-.545-.357-.727c-.607-1.203-.593-1.265-1.206-1.347-.173-.02-.261-.042-.261-.125v-.39l.05-.037h3.578l.095.03v.376c0 .088-.063.125-.189.125l-.257.039c-.66.051-.551.318-.113 1.186l1.319 2.712 1.465-2.922c.244-.533.194-.668.093-.789-.058-.07-.255-.185-.677-.2l-.168-.018a.191.191 0 0 1-.121-.043.125.125 0 0 1-.056-.107v-.357l.051-.037c1.04-.007 3.371 0 3.371 0l.05.037v.364c0 .101-.05.148-.161.148-.539.024-.652.079-.854.366-.1.154-.313.49-.538.865l-1.919 3.563-.054.112 2.328 4.763.142.041 3.665-8.704c.129-.352.107-.602-.053-.746-.165-.144-.289-.228-.716-.246l-.35-.014a.211.211 0 0 1-.127-.037.128.128 0 0 1-.06-.1v-.361l.049-.038h4.137l.034.038v.364c0 .1-.062.15-.174.15-.541.024-.94.15-1.203.351-.263.213-.465.514-.614.89 0 0-3.371 7.72-4.524 10.289-.438.84-.878.765-1.253-.026-.477-.977-1.478-3.156-2.206-4.761l.045-.03z"
                }
            }
        ]
    })(props);
}
function BiLogoWindows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "m3 5.557 7.357-1.002.004 7.097-7.354.042L3 5.557zm7.354 6.913.006 7.103-7.354-1.011v-6.14l7.348.048zm.892-8.046L21.001 3v8.562l-9.755.077V4.424zm9.758 8.113-.003 8.523-9.755-1.378-.014-7.161 9.772.016z"
                }
            }
        ]
    })(props);
}
function BiLogoWix(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.444 8.256c-.4.212-.544.562-.544 1.53 0 0 .202-.194.499-.303a2.01 2.01 0 0 0 .512-.275c.338-.247.385-.562.385-1.096 0 0-.553-.016-.852.144zm-2.349.229c-.32.286-.418.739-.418.739l-1.078 4.141L8.71 9.97c-.087-.355-.246-.808-.495-1.107-.31-.378-.944-.401-1.015-.401-.068 0-.709.023-1.026.407-.246.303-.406.751-.493 1.108l-.889 3.395-1.066-4.147s-.092-.459-.418-.739c-.529-.465-1.314-.367-1.314-.367l2.048 7.764s.677.052 1.015-.126c.441-.224.659-.401.929-1.463.241-.94.912-3.704.974-3.905.029-.098.07-.332.241-.332.179 0 .214.229.241.332.064.195.729 2.965.976 3.905.268 1.055.481 1.227.929 1.463.338.178 1.015.126 1.015.126l2.048-7.759c-.002 0-.789-.099-1.315.361zm3.201.9s-.129.195-.42.367c-.188.104-.367.178-.562.271-.323.154-.414.332-.414.595v5.266s.522.063.854-.104c.436-.222.533-.435.541-1.404V9.385zm5.112 2.632 2.599-3.875s-1.096-.189-1.641.309c-.35.315-.738.885-.738.885l-.952 1.386c-.053.069-.104.15-.2.15-.099 0-.161-.075-.202-.15l-.962-1.382s-.385-.568-.74-.884c-.54-.499-1.641-.31-1.641-.31l2.603 3.865-2.603 3.858s1.146.149 1.688-.35c.35-.315.688-.837.688-.837l.95-1.383c.053-.068.104-.147.2-.147.1 0 .161.075.202.147l.952 1.383s.355.51.7.837c.538.499 1.667.35 1.667.35l-2.57-3.852z"
                }
            }
        ]
    })(props);
}
function BiLogoWordpress(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.891 7.788a8.966 8.966 0 0 1 1.099 4.313 8.986 8.986 0 0 1-4.47 7.771l2.746-7.939c.513-1.282.684-2.309.684-3.219a7.165 7.165 0 0 0-.059-.926m-6.651.087a14.14 14.14 0 0 0 1.026-.088c.485-.063.428-.775-.056-.749 0 0-1.463.112-2.4.112-.887 0-2.375-.125-2.375-.125-.487-.024-.55.713-.061.738 0 0 .449.052.938.075l1.399 3.838-1.975 5.899-3.274-9.724a17.006 17.006 0 0 0 1.028-.083c.487-.063.43-.775-.055-.747 0 0-1.455.115-2.395.115-.167 0-.365-.007-.575-.013C6.093 4.726 8.862 3.113 12 3.113c2.341 0 4.471.894 6.071 2.36-.038-.002-.076-.008-.117-.008-.883 0-1.51.77-1.51 1.596 0 .741.427 1.369.883 2.108.343.601.742 1.37.742 2.481 0 .763-.295 1.662-.685 2.899l-.896 2.987-3.25-9.675.002.014zM12 21.087a8.983 8.983 0 0 1-2.54-.364l2.697-7.838 2.763 7.572c.021.044.042.085.065.124a9.016 9.016 0 0 1-2.985.508m-8.99-8.988a8.94 8.94 0 0 1 .778-3.658l4.287 11.749a8.993 8.993 0 0 1-5.065-8.091m8.99-10c-5.513 0-10 4.487-10 10s4.487 10 10 10 10-4.487 10-10-4.487-10-10-10"
                }
            }
        ]
    })(props);
}
function BiLogoXing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 6a.4.4 0 0 0-.38.62l2 3.38-3.06 5.4a.45.45 0 0 0 0 .45.43.43 0 0 0 .38.19h2.87a.89.89 0 0 0 .79-.55s3-5.31 3.11-5.51l-2-3.46A.91.91 0 0 0 7.92 6zm12.16-4a.84.84 0 0 0-.77.55L10 13.93l4.09 7.52a.91.91 0 0 0 .81.55h2.88a.43.43 0 0 0 .38-.18.45.45 0 0 0 0-.45l-4.07-7.43 6.36-11.31a.45.45 0 0 0 0-.45.44.44 0 0 0-.38-.18z"
                }
            }
        ]
    })(props);
}
function BiLogoYahoo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.131 21s-.63-.114-1.138-.114c-.457 0-1.142.114-1.142.114l.143-7.646C9.933 11.52 6.814 5.933 4.868 3c.979.223 1.391.209 2.374 0l.015.025c1.239 2.194 3.135 5.254 4.736 7.905C13.575 8.325 16.064 4.258 16.74 3c.765.201 1.536.193 2.392 0-.9 1.213-4.175 6.88-6.153 10.354L13.125 21h.006z"
                }
            }
        ]
    })(props);
}
function BiLogoYelp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.824 16.675c-.105.726-1.587 2.609-2.269 2.882-.232.093-.457.07-.637-.068-.116-.09-.235-.272-1.833-2.866l-.475-.773c-.183-.277-.148-.642.078-.92.223-.27.549-.37.832-.262.016.008 1.195.397 1.195.397 2.688.883 2.775.917 2.891 1.002.17.139.249.356.214.608h.004zm-5.386-3.946c-.19-.289-.187-.63.01-.865l.746-1.019c1.642-2.235 1.732-2.353 1.843-2.431a.636.636 0 0 1 .652-.024c.651.316 1.966 2.269 2.045 3.019v.025a.623.623 0 0 1-.259.587c-.123.079-.235.125-3.291.866-.483.123-.752.19-.91.247l.021-.023c-.302.091-.64-.055-.831-.357l-.026-.025zm-1.875-1.159c-.146.046-.591.185-1.139-.702 0 0-3.694-5.813-3.78-5.992-.053-.201.011-.429.19-.613.55-.569 3.534-1.405 4.315-1.215.255.066.43.227.491.453.045.25.408 5.646.46 6.854.051 1.034-.392 1.171-.537 1.215zm.487 5.913c-.008 2.827-.015 2.922-.061 3.056-.079.211-.26.352-.51.398-.72.122-2.972-.71-3.441-1.267a.739.739 0 0 1-.157-.37c-.013-.09 0-.18.033-.259.057-.146.135-.259 2.158-2.63l.594-.706c.203-.26.563-.338.899-.204.325.124.528.405.506.708v1.259l-.021.015zm-6.13-1.808c-.222-.006-.42-.14-.535-.358-.083-.162-.142-.428-.18-.752-.102-.974.023-2.444.314-2.911.138-.214.338-.327.559-.319.146 0 .276.046 3.167 1.236l.848.337c.302.111.489.427.472.787-.022.348-.224.616-.521.696l-1.202.382c-2.689.864-2.778.888-2.919.877l-.003.025zm11.22 5.322h-.004l-.003.003.007-.003z"
                }
            }
        ]
    })(props);
}
function BiLogoYoutube(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.593 7.203a2.506 2.506 0 0 0-1.762-1.766C18.265 5.007 12 5 12 5s-6.264-.007-7.831.404a2.56 2.56 0 0 0-1.766 1.778c-.413 1.566-.417 4.814-.417 4.814s-.004 3.264.406 4.814c.23.857.905 1.534 1.763 1.765 1.582.43 7.83.437 7.83.437s6.265.007 7.831-.403a2.515 2.515 0 0 0 1.767-1.763c.414-1.565.417-4.812.417-4.812s.02-3.265-.407-4.831zM9.996 15.005l.005-6 5.207 3.005-5.212 2.995z"
                }
            }
        ]
    })(props);
}
function BiLogoZoom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1.984 7.506v6.74c.006 1.524 1.361 2.75 3.014 2.745h10.693c.303 0 .549-.225.549-.498v-6.74c-.008-1.523-1.363-2.75-3.014-2.744H2.531c-.302 0-.547.224-.547.497zm14.936 2.63 4.416-2.963c.383-.292.68-.219.68.309v9.036c0 .601-.363.528-.68.309L16.92 13.87v-3.734z"
                }
            }
        ]
    })(props);
}

},{"../lib":"hOIFC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4uLxM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _app = require("@firebase/app");
parcelHelpers.exportAll(_app, exports);
var name = "firebase";
var version = "11.10.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, _app.registerVersion)(name, version, 'app');

},{"@firebase/app":"1SyrH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1SyrH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FirebaseError", ()=>(0, _util.FirebaseError));
parcelHelpers.export(exports, "SDK_VERSION", ()=>SDK_VERSION);
parcelHelpers.export(exports, "_DEFAULT_ENTRY_NAME", ()=>DEFAULT_ENTRY_NAME);
parcelHelpers.export(exports, "_addComponent", ()=>_addComponent);
parcelHelpers.export(exports, "_addOrOverwriteComponent", ()=>_addOrOverwriteComponent);
parcelHelpers.export(exports, "_apps", ()=>_apps);
parcelHelpers.export(exports, "_clearComponents", ()=>_clearComponents);
parcelHelpers.export(exports, "_components", ()=>_components);
parcelHelpers.export(exports, "_getProvider", ()=>_getProvider);
parcelHelpers.export(exports, "_isFirebaseApp", ()=>_isFirebaseApp);
parcelHelpers.export(exports, "_isFirebaseServerApp", ()=>_isFirebaseServerApp);
parcelHelpers.export(exports, "_registerComponent", ()=>_registerComponent);
parcelHelpers.export(exports, "_removeServiceInstance", ()=>_removeServiceInstance);
parcelHelpers.export(exports, "_serverApps", ()=>_serverApps);
parcelHelpers.export(exports, "deleteApp", ()=>deleteApp);
parcelHelpers.export(exports, "getApp", ()=>getApp);
parcelHelpers.export(exports, "getApps", ()=>getApps);
parcelHelpers.export(exports, "initializeApp", ()=>initializeApp);
parcelHelpers.export(exports, "initializeServerApp", ()=>initializeServerApp);
parcelHelpers.export(exports, "onLog", ()=>onLog);
parcelHelpers.export(exports, "registerVersion", ()=>registerVersion);
parcelHelpers.export(exports, "setLogLevel", ()=>setLogLevel);
var _component = require("@firebase/component");
var _logger = require("@firebase/logger");
var _util = require("@firebase/util");
var _idb = require("idb");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if (isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
const name$q = "@firebase/app";
const version$1 = "0.13.2";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const logger = new (0, _logger.Logger)('@firebase/app');
const name$p = "@firebase/app-compat";
const name$o = "@firebase/analytics-compat";
const name$n = "@firebase/analytics";
const name$m = "@firebase/app-check-compat";
const name$l = "@firebase/app-check";
const name$k = "@firebase/auth";
const name$j = "@firebase/auth-compat";
const name$i = "@firebase/database";
const name$h = "@firebase/data-connect";
const name$g = "@firebase/database-compat";
const name$f = "@firebase/functions";
const name$e = "@firebase/functions-compat";
const name$d = "@firebase/installations";
const name$c = "@firebase/installations-compat";
const name$b = "@firebase/messaging";
const name$a = "@firebase/messaging-compat";
const name$9 = "@firebase/performance";
const name$8 = "@firebase/performance-compat";
const name$7 = "@firebase/remote-config";
const name$6 = "@firebase/remote-config-compat";
const name$5 = "@firebase/storage";
const name$4 = "@firebase/storage-compat";
const name$3 = "@firebase/firestore";
const name$2 = "@firebase/ai";
const name$1 = "@firebase/firestore-compat";
const name = "firebase";
const version = "11.10.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const DEFAULT_ENTRY_NAME = '[DEFAULT]';
const PLATFORM_LOG_STRING = {
    [name$q]: 'fire-core',
    [name$p]: 'fire-core-compat',
    [name$n]: 'fire-analytics',
    [name$o]: 'fire-analytics-compat',
    [name$l]: 'fire-app-check',
    [name$m]: 'fire-app-check-compat',
    [name$k]: 'fire-auth',
    [name$j]: 'fire-auth-compat',
    [name$i]: 'fire-rtdb',
    [name$h]: 'fire-data-connect',
    [name$g]: 'fire-rtdb-compat',
    [name$f]: 'fire-fn',
    [name$e]: 'fire-fn-compat',
    [name$d]: 'fire-iid',
    [name$c]: 'fire-iid-compat',
    [name$b]: 'fire-fcm',
    [name$a]: 'fire-fcm-compat',
    [name$9]: 'fire-perf',
    [name$8]: 'fire-perf-compat',
    [name$7]: 'fire-rc',
    [name$6]: 'fire-rc-compat',
    [name$5]: 'fire-gcs',
    [name$4]: 'fire-gcs-compat',
    [name$3]: 'fire-fst',
    [name$1]: 'fire-fst-compat',
    [name$2]: 'fire-vertex',
    'fire-js': 'fire-js',
    [name]: 'fire-js-all'
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const _apps = new Map();
/**
 * @internal
 */ const _serverApps = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const _components = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function _addComponent(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function _addOrOverwriteComponent(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function _registerComponent(component) {
    const componentName = component.name;
    if (_components.has(componentName)) {
        logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    _components.set(componentName, component);
    // add the component to existing app instances
    for (const app of _apps.values())_addComponent(app, component);
    for (const serverApp of _serverApps.values())_addComponent(serverApp, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function _getProvider(app, name) {
    const heartbeatController = app.container.getProvider('heartbeat').getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function _removeServiceInstance(app, name, instanceIdentifier = DEFAULT_ENTRY_NAME) {
    _getProvider(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp or FirebaseOptions.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function _isFirebaseApp(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function _isFirebaseServerApp(obj) {
    if (obj === null || obj === undefined) return false;
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function _clearComponents() {
    _components.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */ ]: 'Firebase Server App has been deleted',
    ["no-options" /* AppError.NO_OPTIONS */ ]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */ ]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */ ]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */ ]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */ ]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.',
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ ]: 'FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.',
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ ]: 'FirebaseServerApp is not for use in browser environments.'
};
const ERROR_FACTORY = new (0, _util.ErrorFactory)('app', 'Firebase', ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, _component.Component)('app', ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Parse the token and check to see if the `exp` claim is in the future.
// Reports an error to the console if the token or claim could not be parsed, or if `exp` is in
// the past.
function validateTokenTTL(base64Token, tokenName) {
    const secondPart = (0, _util.base64Decode)(base64Token.split('.')[1]);
    if (secondPart === null) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: second part could not be parsed.`);
        return;
    }
    const expClaim = JSON.parse(secondPart).exp;
    if (expClaim === undefined) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: expiration claim could not be parsed`);
        return;
    }
    const exp = JSON.parse(secondPart).exp * 1000;
    const now = new Date().getTime();
    const diff = exp - now;
    if (diff <= 0) console.error(`FirebaseServerApp ${tokenName} is invalid: the token has expired.`);
}
class FirebaseServerAppImpl extends FirebaseAppImpl {
    constructor(options, serverConfig, name, container){
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : true;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name,
            automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        super(options, config, container);
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = Object.assign({
            automaticDataCollectionEnabled
        }, serverConfig);
        // Ensure that the current time is within the `authIdtoken` window of validity.
        if (this._serverConfig.authIdToken) validateTokenTTL(this._serverConfig.authIdToken, 'authIdToken');
        // Ensure that the current time is within the `appCheckToken` window of validity.
        if (this._serverConfig.appCheckToken) validateTokenTTL(this._serverConfig.appCheckToken, 'appCheckToken');
        this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== 'undefined') this._finalizationRegistry = new FinalizationRegistry(()=>{
            this.automaticCleanup();
        });
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        registerVersion(name$q, version$1, 'serverapp');
    }
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) return;
        this._refCount++;
        if (obj !== undefined && this._finalizationRegistry !== null) this._finalizationRegistry.register(obj, this);
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) return 0;
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        deleteApp(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const SDK_VERSION = version;
function initializeApp(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = {
            name
        };
    }
    const config = Object.assign({
        name: DEFAULT_ENTRY_NAME,
        automaticDataCollectionEnabled: true
    }, rawConfig);
    const name = config.name;
    if (typeof name !== 'string' || !name) throw ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, _util.getDefaultAppConfig)());
    if (!options) throw ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = _apps.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, _util.deepEqual)(options, existingApp.options) && (0, _util.deepEqual)(config, existingApp.config)) return existingApp;
        else throw ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, _component.ComponentContainer)(name);
    for (const component of _components.values())container.addComponent(component);
    const newApp = new FirebaseAppImpl(options, config, container);
    _apps.set(name, newApp);
    return newApp;
}
function initializeServerApp(_options, _serverAppConfig) {
    if ((0, _util.isBrowser)() && !(0, _util.isWebWorker)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    if (_serverAppConfig.automaticDataCollectionEnabled === undefined) _serverAppConfig.automaticDataCollectionEnabled = true;
    let appOptions;
    if (_isFirebaseApp(_options)) appOptions = _options.options;
    else appOptions = _options;
    // Build an app name based on a hash of the configuration options.
    const nameObj = Object.assign(Object.assign({}, _serverAppConfig), appOptions);
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    const hashCode = (s)=>{
        return [
            ...s
        ].reduce((hash, c)=>Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
    };
    if (_serverAppConfig.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === 'undefined') throw ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    const nameString = '' + hashCode(JSON.stringify(nameObj));
    const existingApp = _serverApps.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(_serverAppConfig.releaseOnDeref);
        return existingApp;
    }
    const container = new (0, _component.ComponentContainer)(nameString);
    for (const component of _components.values())container.addComponent(component);
    const newApp = new FirebaseServerAppImpl(appOptions, _serverAppConfig, nameString, container);
    _serverApps.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function getApp(name = DEFAULT_ENTRY_NAME) {
    const app = _apps.get(name);
    if (!app && name === DEFAULT_ENTRY_NAME && (0, _util.getDefaultAppConfig)()) return initializeApp();
    if (!app) throw ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function getApps() {
    return Array.from(_apps.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function deleteApp(app) {
    let cleanupProviders = false;
    const name = app.name;
    if (_apps.has(name)) {
        cleanupProviders = true;
        _apps.delete(name);
    } else if (_serverApps.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            _serverApps.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function registerVersion(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push('and');
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        logger.warn(warning.join(' '));
        return;
    }
    _registerComponent(new (0, _component.Component)(`${library}-version`, ()=>({
            library,
            version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function onLog(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') throw ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, _logger.setUserLogHandler)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function setLogLevel(logLevel) {
    (0, _logger.setLogLevel)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const DB_NAME = 'firebase-heartbeat-database';
const DB_VERSION = 1;
const STORE_NAME = 'firebase-heartbeat-store';
let dbPromise = null;
function getDbPromise() {
    if (!dbPromise) dbPromise = (0, _idb.openDB)(DB_NAME, DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore(STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return dbPromise;
}
async function readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await getDbPromise();
        const tx = db.transaction(STORE_NAME);
        const result = await tx.objectStore(STORE_NAME).get(computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, _util.FirebaseError)) logger.warn(e.message);
        else {
            const idbGetError = ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            logger.warn(idbGetError.message);
        }
    }
}
async function writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await getDbPromise();
        const tx = db.transaction(STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore(STORE_NAME);
        await objectStore.put(heartbeatObject, computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, _util.FirebaseError)) logger.warn(e.message);
        else {
            const idbGetError = ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            logger.warn(idbGetError.message);
        }
    }
}
function computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const MAX_HEADER_BYTES = 1024;
const MAX_NUM_STORED_HEARTBEATS = 30;
class HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        var _a, _b;
        try {
            const platformLogger = this.container.getProvider('platform-logger').getImmediate();
            // This is the "Firebase user agent" string from the platform logger
            // service, not the browser user agent.
            const agent = platformLogger.getPlatformInfoString();
            const date = getUTCDateString();
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null) {
                this._heartbeatsCache = await this._heartbeatsCachePromise;
                // If we failed to construct a heartbeats cache, then return immediately.
                if (((_b = this._heartbeatsCache) === null || _b === void 0 ? void 0 : _b.heartbeats) == null) return;
            }
            // Do not store a heartbeat if one is already stored for this day
            // or if a header has already been sent today.
            if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
            else {
                // There is no entry for this date. Create one.
                this._heartbeatsCache.heartbeats.push({
                    date,
                    agent
                });
                // If the number of stored heartbeats exceeds the maximum number of stored heartbeats, remove the heartbeat with the earliest date.
                // Since this is executed each time a heartbeat is pushed, the limit can only be exceeded by one, so only one needs to be removed.
                if (this._heartbeatsCache.heartbeats.length > MAX_NUM_STORED_HEARTBEATS) {
                    const earliestHeartbeatIdx = getEarliestHeartbeatIdx(this._heartbeatsCache.heartbeats);
                    this._heartbeatsCache.heartbeats.splice(earliestHeartbeatIdx, 1);
                }
            }
            return this._storage.overwrite(this._heartbeatsCache);
        } catch (e) {
            logger.warn(e);
        }
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        var _a;
        try {
            if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
            // If it's still null or the array is empty, there is no data to send.
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0) return '';
            const date = getUTCDateString();
            // Extract as many heartbeats from the cache as will fit under the size limit.
            const { heartbeatsToSend, unsentEntries } = extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
            const headerString = (0, _util.base64urlEncodeWithoutPadding)(JSON.stringify({
                version: 2,
                heartbeats: heartbeatsToSend
            }));
            // Store last sent date to prevent another being logged/sent for the same day.
            this._heartbeatsCache.lastSentHeartbeatDate = date;
            if (unsentEntries.length > 0) {
                // Store any unsent entries if they exist.
                this._heartbeatsCache.heartbeats = unsentEntries;
                // This seems more likely than emptying the array (below) to lead to some odd state
                // since the cache isn't empty and this will be called again on the next request,
                // and is probably safest if we await it.
                await this._storage.overwrite(this._heartbeatsCache);
            } else {
                this._heartbeatsCache.heartbeats = [];
                // Do not wait for this, to reduce latency.
                this._storage.overwrite(this._heartbeatsCache);
            }
            return headerString;
        } catch (e) {
            logger.warn(e);
            return '';
        }
    }
}
function getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function extractHeartbeatsForHeader(heartbeatsCache, maxSize = MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if (countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if (countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend,
        unsentEntries
    };
}
class HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, _util.isIndexedDBAvailable)()) return false;
        else return (0, _util.validateIndexedDBOpenable)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, _util.base64urlEncodeWithoutPadding)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * Returns the index of the heartbeat with the earliest date.
 * If the heartbeats array is empty, -1 is returned.
 */ function getEarliestHeartbeatIdx(heartbeats) {
    if (heartbeats.length === 0) return -1;
    let earliestHeartbeatIdx = 0;
    let earliestHeartbeatDate = heartbeats[0].date;
    for(let i = 1; i < heartbeats.length; i++)if (heartbeats[i].date < earliestHeartbeatDate) {
        earliestHeartbeatDate = heartbeats[i].date;
        earliestHeartbeatIdx = i;
    }
    return earliestHeartbeatIdx;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function registerCoreComponents(variant) {
    _registerComponent(new (0, _component.Component)('platform-logger', (container)=>new PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    _registerComponent(new (0, _component.Component)('heartbeat', (container)=>new HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    registerVersion(name$q, version$1, variant);
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    registerVersion(name$q, version$1, 'esm2017');
    // Register platform SDK identifier (no version).
    registerVersion('fire-js', '');
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ registerCoreComponents('');

},{"@firebase/component":"2tpfU","@firebase/logger":"3ul0m","@firebase/util":"guJD8","idb":"d2rZl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2tpfU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Component", ()=>Component);
parcelHelpers.export(exports, "ComponentContainer", ()=>ComponentContainer);
parcelHelpers.export(exports, "Provider", ()=>Provider);
var _util = require("@firebase/util");
/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class Component {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const DEFAULT_ENTRY_NAME = '[DEFAULT]';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class Provider {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide multiple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, _util.Deferred)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/cannot be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if (isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>'INTERNAL' in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>'_delete' in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier, options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: normalizeIdentifierForFactory(instanceIdentifier),
                options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function normalizeIdentifierForFactory(identifier) {
    return identifier === DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class ComponentContainer {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new Provider(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}

},{"@firebase/util":"guJD8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"guJD8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONSTANTS", ()=>CONSTANTS);
parcelHelpers.export(exports, "DecodeBase64StringError", ()=>DecodeBase64StringError);
parcelHelpers.export(exports, "Deferred", ()=>Deferred);
parcelHelpers.export(exports, "ErrorFactory", ()=>ErrorFactory);
parcelHelpers.export(exports, "FirebaseError", ()=>FirebaseError);
parcelHelpers.export(exports, "MAX_VALUE_MILLIS", ()=>MAX_VALUE_MILLIS);
parcelHelpers.export(exports, "RANDOM_FACTOR", ()=>RANDOM_FACTOR);
parcelHelpers.export(exports, "Sha1", ()=>Sha1);
parcelHelpers.export(exports, "areCookiesEnabled", ()=>areCookiesEnabled);
parcelHelpers.export(exports, "assert", ()=>assert);
parcelHelpers.export(exports, "assertionError", ()=>assertionError);
parcelHelpers.export(exports, "async", ()=>async);
parcelHelpers.export(exports, "base64", ()=>base64);
parcelHelpers.export(exports, "base64Decode", ()=>base64Decode);
parcelHelpers.export(exports, "base64Encode", ()=>base64Encode);
parcelHelpers.export(exports, "base64urlEncodeWithoutPadding", ()=>base64urlEncodeWithoutPadding);
parcelHelpers.export(exports, "calculateBackoffMillis", ()=>calculateBackoffMillis);
parcelHelpers.export(exports, "contains", ()=>contains);
parcelHelpers.export(exports, "createMockUserToken", ()=>createMockUserToken);
parcelHelpers.export(exports, "createSubscribe", ()=>createSubscribe);
parcelHelpers.export(exports, "decode", ()=>decode);
parcelHelpers.export(exports, "deepCopy", ()=>deepCopy);
parcelHelpers.export(exports, "deepEqual", ()=>deepEqual);
parcelHelpers.export(exports, "deepExtend", ()=>deepExtend);
parcelHelpers.export(exports, "errorPrefix", ()=>errorPrefix);
parcelHelpers.export(exports, "extractQuerystring", ()=>extractQuerystring);
parcelHelpers.export(exports, "getDefaultAppConfig", ()=>getDefaultAppConfig);
parcelHelpers.export(exports, "getDefaultEmulatorHost", ()=>getDefaultEmulatorHost);
parcelHelpers.export(exports, "getDefaultEmulatorHostnameAndPort", ()=>getDefaultEmulatorHostnameAndPort);
parcelHelpers.export(exports, "getDefaults", ()=>getDefaults);
parcelHelpers.export(exports, "getExperimentalSetting", ()=>getExperimentalSetting);
parcelHelpers.export(exports, "getGlobal", ()=>getGlobal);
parcelHelpers.export(exports, "getModularInstance", ()=>getModularInstance);
parcelHelpers.export(exports, "getUA", ()=>getUA);
parcelHelpers.export(exports, "isAdmin", ()=>isAdmin);
parcelHelpers.export(exports, "isBrowser", ()=>isBrowser);
parcelHelpers.export(exports, "isBrowserExtension", ()=>isBrowserExtension);
parcelHelpers.export(exports, "isCloudWorkstation", ()=>isCloudWorkstation);
parcelHelpers.export(exports, "isCloudflareWorker", ()=>isCloudflareWorker);
parcelHelpers.export(exports, "isElectron", ()=>isElectron);
parcelHelpers.export(exports, "isEmpty", ()=>isEmpty);
parcelHelpers.export(exports, "isIE", ()=>isIE);
parcelHelpers.export(exports, "isIndexedDBAvailable", ()=>isIndexedDBAvailable);
parcelHelpers.export(exports, "isMobileCordova", ()=>isMobileCordova);
parcelHelpers.export(exports, "isNode", ()=>isNode);
parcelHelpers.export(exports, "isNodeSdk", ()=>isNodeSdk);
parcelHelpers.export(exports, "isReactNative", ()=>isReactNative);
parcelHelpers.export(exports, "isSafari", ()=>isSafari);
parcelHelpers.export(exports, "isSafariOrWebkit", ()=>isSafariOrWebkit);
parcelHelpers.export(exports, "isUWP", ()=>isUWP);
parcelHelpers.export(exports, "isValidFormat", ()=>isValidFormat);
parcelHelpers.export(exports, "isValidTimestamp", ()=>isValidTimestamp);
parcelHelpers.export(exports, "isWebWorker", ()=>isWebWorker);
parcelHelpers.export(exports, "issuedAtTime", ()=>issuedAtTime);
parcelHelpers.export(exports, "jsonEval", ()=>jsonEval);
parcelHelpers.export(exports, "map", ()=>map);
parcelHelpers.export(exports, "ordinal", ()=>ordinal);
parcelHelpers.export(exports, "pingServer", ()=>pingServer);
parcelHelpers.export(exports, "promiseWithTimeout", ()=>promiseWithTimeout);
parcelHelpers.export(exports, "querystring", ()=>querystring);
parcelHelpers.export(exports, "querystringDecode", ()=>querystringDecode);
parcelHelpers.export(exports, "safeGet", ()=>safeGet);
parcelHelpers.export(exports, "stringLength", ()=>stringLength);
parcelHelpers.export(exports, "stringToByteArray", ()=>stringToByteArray);
parcelHelpers.export(exports, "stringify", ()=>stringify);
parcelHelpers.export(exports, "updateEmulatorBanner", ()=>updateEmulatorBanner);
parcelHelpers.export(exports, "validateArgCount", ()=>validateArgCount);
parcelHelpers.export(exports, "validateCallback", ()=>validateCallback);
parcelHelpers.export(exports, "validateContextObject", ()=>validateContextObject);
parcelHelpers.export(exports, "validateIndexedDBOpenable", ()=>validateIndexedDBOpenable);
parcelHelpers.export(exports, "validateNamespace", ()=>validateNamespace);
var _postinstallMjs = require("./postinstall.mjs");
var global = arguments[3];
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ const CONSTANTS = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: '${JSCORE_VERSION}'
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const assert = function(assertion, message) {
    if (!assertion) throw assertionError(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const assertionError = function(message) {
    return new Error('Firebase Database (' + CONSTANTS.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
// TODO(dlarocque): Define this as a class, since we no longer target ES5.
const base64 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error('encodeByteArray takes an array as a parameter');
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray(stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new DecodeBase64StringError();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class DecodeBase64StringError extends Error {
    constructor(){
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */ const base64Encode = function(str) {
    const utf8Bytes = stringToByteArray$1(str);
    return base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const base64urlEncodeWithoutPadding = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return base64Encode(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const base64Decode = function(str) {
    try {
        return base64.decodeString(str, true);
    } catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function deepCopy(value) {
    return deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function deepExtend(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !isValidKey(prop)) continue;
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}
function isValidKey(key) {
    return key !== '__proto__';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function getGlobal() {
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof global !== 'undefined') return global;
    throw new Error('Unable to locate global object.');
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const getDefaultsFromGlobal = ()=>getGlobal().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const getDefaultsFromEnvVariable = ()=>{
    return;
};
const getDefaultsFromCookie = ()=>{
    if (typeof document === 'undefined') return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && base64Decode(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const getDefaults = ()=>{
    try {
        return (0, _postinstallMjs.getDefaultsFromPostinstall)() || getDefaultsFromGlobal() || getDefaultsFromEnvVariable() || getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const getDefaultEmulatorHost = (productName)=>{
    var _a, _b;
    return (_b = (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const getDefaultEmulatorHostnameAndPort = (productName)=>{
    const host = getDefaultEmulatorHost(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const getDefaultAppConfig = ()=>{
    var _a;
    return (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const getExperimentalSetting = (name)=>{
    var _a;
    return (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a[`_${name}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class Deferred {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks whether host is a cloud workstation or not.
 * @public
 */ function isCloudWorkstation(url) {
    // `isCloudWorkstation` is called without protocol in certain connect*Emulator functions
    // In HTTP request builders, it's called with the protocol.
    // If called with protocol prefix, it's a valid URL, so we extract the hostname
    // If called without, we assume the string is the hostname.
    try {
        const host = url.startsWith('http://') || url.startsWith('https://') ? new URL(url).hostname : url;
        return host.endsWith('.cloudworkstations.dev');
    } catch (_a) {
        return false;
    }
}
/**
 * Makes a fetch request to the given server.
 * Mostly used for forwarding cookies in Firebase Studio.
 * @public
 */ async function pingServer(endpoint) {
    const result = await fetch(endpoint, {
        credentials: 'include'
    });
    return result.ok;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function createMockUserToken(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat,
        exp: iat + 3600,
        auth_time: iat,
        sub,
        user_id: sub,
        firebase: {
            sign_in_provider: 'custom',
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        base64urlEncodeWithoutPadding(JSON.stringify(header)),
        base64urlEncodeWithoutPadding(JSON.stringify(payload)),
        signature
    ].join('.');
}
const emulatorStatus = {};
// Checks whether any products are running on an emulator
function getEmulatorSummary() {
    const summary = {
        prod: [],
        emulator: []
    };
    for (const key of Object.keys(emulatorStatus))if (emulatorStatus[key]) summary.emulator.push(key);
    else summary.prod.push(key);
    return summary;
}
function getOrCreateEl(id) {
    let parentDiv = document.getElementById(id);
    let created = false;
    if (!parentDiv) {
        parentDiv = document.createElement('div');
        parentDiv.setAttribute('id', id);
        created = true;
    }
    return {
        created,
        element: parentDiv
    };
}
let previouslyDismissed = false;
/**
 * Updates Emulator Banner. Primarily used for Firebase Studio
 * @param name
 * @param isRunningEmulator
 * @public
 */ function updateEmulatorBanner(name, isRunningEmulator) {
    if (typeof window === 'undefined' || typeof document === 'undefined' || !isCloudWorkstation(window.location.host) || emulatorStatus[name] === isRunningEmulator || emulatorStatus[name] || // If already set to use emulator, can't go back to prod.
    previouslyDismissed) return;
    emulatorStatus[name] = isRunningEmulator;
    function prefixedId(id) {
        return `__firebase__banner__${id}`;
    }
    const bannerId = '__firebase__banner';
    const summary = getEmulatorSummary();
    const showError = summary.prod.length > 0;
    function tearDown() {
        const element = document.getElementById(bannerId);
        if (element) element.remove();
    }
    function setupBannerStyles(bannerEl) {
        bannerEl.style.display = 'flex';
        bannerEl.style.background = '#7faaf0';
        bannerEl.style.position = 'fixed';
        bannerEl.style.bottom = '5px';
        bannerEl.style.left = '5px';
        bannerEl.style.padding = '.5em';
        bannerEl.style.borderRadius = '5px';
        bannerEl.style.alignItems = 'center';
    }
    function setupIconStyles(prependIcon, iconId) {
        prependIcon.setAttribute('width', '24');
        prependIcon.setAttribute('id', iconId);
        prependIcon.setAttribute('height', '24');
        prependIcon.setAttribute('viewBox', '0 0 24 24');
        prependIcon.setAttribute('fill', 'none');
        prependIcon.style.marginLeft = '-6px';
    }
    function setupCloseBtn() {
        const closeBtn = document.createElement('span');
        closeBtn.style.cursor = 'pointer';
        closeBtn.style.marginLeft = '16px';
        closeBtn.style.fontSize = '24px';
        closeBtn.innerHTML = ' &times;';
        closeBtn.onclick = ()=>{
            previouslyDismissed = true;
            tearDown();
        };
        return closeBtn;
    }
    function setupLinkStyles(learnMoreLink, learnMoreId) {
        learnMoreLink.setAttribute('id', learnMoreId);
        learnMoreLink.innerText = 'Learn more';
        learnMoreLink.href = 'https://firebase.google.com/docs/studio/preview-apps#preview-backend';
        learnMoreLink.setAttribute('target', '__blank');
        learnMoreLink.style.paddingLeft = '5px';
        learnMoreLink.style.textDecoration = 'underline';
    }
    function setupDom() {
        const banner = getOrCreateEl(bannerId);
        const firebaseTextId = prefixedId('text');
        const firebaseText = document.getElementById(firebaseTextId) || document.createElement('span');
        const learnMoreId = prefixedId('learnmore');
        const learnMoreLink = document.getElementById(learnMoreId) || document.createElement('a');
        const prependIconId = prefixedId('preprendIcon');
        const prependIcon = document.getElementById(prependIconId) || document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        if (banner.created) {
            // update styles
            const bannerEl = banner.element;
            setupBannerStyles(bannerEl);
            setupLinkStyles(learnMoreLink, learnMoreId);
            const closeBtn = setupCloseBtn();
            setupIconStyles(prependIcon, prependIconId);
            bannerEl.append(prependIcon, firebaseText, learnMoreLink, closeBtn);
            document.body.appendChild(bannerEl);
        }
        if (showError) {
            firebaseText.innerText = `Preview backend disconnected.`;
            prependIcon.innerHTML = `<g clip-path="url(#clip0_6013_33858)">
<path d="M4.8 17.6L12 5.6L19.2 17.6H4.8ZM6.91667 16.4H17.0833L12 7.93333L6.91667 16.4ZM12 15.6C12.1667 15.6 12.3056 15.5444 12.4167 15.4333C12.5389 15.3111 12.6 15.1667 12.6 15C12.6 14.8333 12.5389 14.6944 12.4167 14.5833C12.3056 14.4611 12.1667 14.4 12 14.4C11.8333 14.4 11.6889 14.4611 11.5667 14.5833C11.4556 14.6944 11.4 14.8333 11.4 15C11.4 15.1667 11.4556 15.3111 11.5667 15.4333C11.6889 15.5444 11.8333 15.6 12 15.6ZM11.4 13.6H12.6V10.4H11.4V13.6Z" fill="#212121"/>
</g>
<defs>
<clipPath id="clip0_6013_33858">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`;
        } else {
            prependIcon.innerHTML = `<g clip-path="url(#clip0_6083_34804)">
<path d="M11.4 15.2H12.6V11.2H11.4V15.2ZM12 10C12.1667 10 12.3056 9.94444 12.4167 9.83333C12.5389 9.71111 12.6 9.56667 12.6 9.4C12.6 9.23333 12.5389 9.09444 12.4167 8.98333C12.3056 8.86111 12.1667 8.8 12 8.8C11.8333 8.8 11.6889 8.86111 11.5667 8.98333C11.4556 9.09444 11.4 9.23333 11.4 9.4C11.4 9.56667 11.4556 9.71111 11.5667 9.83333C11.6889 9.94444 11.8333 10 12 10ZM12 18.4C11.1222 18.4 10.2944 18.2333 9.51667 17.9C8.73889 17.5667 8.05556 17.1111 7.46667 16.5333C6.88889 15.9444 6.43333 15.2611 6.1 14.4833C5.76667 13.7056 5.6 12.8778 5.6 12C5.6 11.1111 5.76667 10.2833 6.1 9.51667C6.43333 8.73889 6.88889 8.06111 7.46667 7.48333C8.05556 6.89444 8.73889 6.43333 9.51667 6.1C10.2944 5.76667 11.1222 5.6 12 5.6C12.8889 5.6 13.7167 5.76667 14.4833 6.1C15.2611 6.43333 15.9389 6.89444 16.5167 7.48333C17.1056 8.06111 17.5667 8.73889 17.9 9.51667C18.2333 10.2833 18.4 11.1111 18.4 12C18.4 12.8778 18.2333 13.7056 17.9 14.4833C17.5667 15.2611 17.1056 15.9444 16.5167 16.5333C15.9389 17.1111 15.2611 17.5667 14.4833 17.9C13.7167 18.2333 12.8889 18.4 12 18.4ZM12 17.2C13.4444 17.2 14.6722 16.6944 15.6833 15.6833C16.6944 14.6722 17.2 13.4444 17.2 12C17.2 10.5556 16.6944 9.32778 15.6833 8.31667C14.6722 7.30555 13.4444 6.8 12 6.8C10.5556 6.8 9.32778 7.30555 8.31667 8.31667C7.30556 9.32778 6.8 10.5556 6.8 12C6.8 13.4444 7.30556 14.6722 8.31667 15.6833C9.32778 16.6944 10.5556 17.2 12 17.2Z" fill="#212121"/>
</g>
<defs>
<clipPath id="clip0_6083_34804">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`;
            firebaseText.innerText = 'Preview backend running in this workspace.';
        }
        firebaseText.setAttribute('id', firebaseTextId);
    }
    if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', setupDom);
    else setupDom();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function getUA() {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') return navigator['userAgent'];
    else return '';
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function isMobileCordova() {
    return typeof window !== 'undefined' && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function isNode() {
    var _a;
    const forceEnvironment = (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === 'node') return true;
    else if (forceEnvironment === 'browser') return false;
    try {
        return Object.prototype.toString.call(global.process) === '[object process]';
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment.
 * Note: This will return true for certain test frameworks that are incompletely
 * mimicking a browser, and should not lead to assuming all browser APIs are
 * available.
 */ function isBrowser() {
    return typeof window !== 'undefined' || isWebWorker();
}
/**
 * Detect Web Worker context.
 */ function isWebWorker() {
    return typeof WorkerGlobalScope !== 'undefined' && typeof self !== 'undefined' && self instanceof WorkerGlobalScope;
}
/**
 * Detect Cloudflare Worker context.
 */ function isCloudflareWorker() {
    return typeof navigator !== 'undefined' && navigator.userAgent === 'Cloudflare-Workers';
}
function isBrowserExtension() {
    const runtime = typeof chrome === 'object' ? chrome.runtime : typeof browser === 'object' ? browser.runtime : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function isReactNative() {
    return typeof navigator === 'object' && navigator['product'] === 'ReactNative';
}
/** Detects Electron apps. */ function isElectron() {
    return getUA().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */ function isIE() {
    const ua = getUA();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */ function isUWP() {
    return getUA().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function isNodeSdk() {
    return CONSTANTS.NODE_CLIENT === true || CONSTANTS.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function isSafari() {
    return !isNode() && !!navigator.userAgent && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}
/** Returns true if we are running in Safari or WebKit */ function isSafariOrWebkit() {
    return !isNode() && !!navigator.userAgent && (navigator.userAgent.includes('Safari') || navigator.userAgent.includes('WebKit')) && !navigator.userAgent.includes('Chrome');
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function isIndexedDBAvailable() {
    try {
        return typeof indexedDB === 'object';
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function validateIndexedDBOpenable() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || '');
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function areCookiesEnabled() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // TypeScript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class FirebaseError extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        // TODO(dlarocque): Replace this with `new.target`: https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        //                   which we can now use since we no longer target ES5.
        Object.setPrototypeOf(this, FirebaseError.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, ErrorFactory.prototype.create);
    }
}
class ErrorFactory {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new FirebaseError(fullCode, fullMessage, customData);
        return error;
    }
}
function replaceTemplate(template, data) {
    return template.replace(PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function jsonEval(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data JavaScript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function stringify(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const decode = function(token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = jsonEval(base64Decode(parts[0]) || '');
        claims = jsonEval(base64Decode(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header,
        claims,
        data,
        signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const isValidTimestamp = function(token) {
    const claims = decode(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) validSince = claims['nbf'];
        else if (claims.hasOwnProperty('iat')) validSince = claims['iat'];
        if (claims.hasOwnProperty('exp')) validUntil = claims['exp'];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const issuedAtTime = function(token) {
    const claims = decode(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) return claims['iat'];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const isValidFormat = function(token) {
    const decoded = decode(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const isAdmin = function(token) {
    const claims = decode(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function safeGet(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function isEmpty(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function map(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function deepEqual(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if (isObject(aProp) && isObject(bProp)) {
            if (!deepEqual(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function isObject(thing) {
    return thing !== null && typeof thing === 'object';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function promiseWithTimeout(promise, timeInMS = 2000) {
    const deferredPromise = new Deferred();
    setTimeout(()=>deferredPromise.reject('timeout!'), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function querystring(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function querystringDecode(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function extractQuerystring(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) return '';
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class Sha1 {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === 'string') while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function createSubscribe(executor, onNoObservers) {
    const proxy = new ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber synchronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error('Missing Observer.');
        // Assemble an Observer object when passed as callback functions.
        if (implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error,
            complete
        };
        if (observer.next === undefined) observer.next = noop;
        if (observer.error === undefined) observer.error = noop;
        if (observer.complete === undefined) observer.complete = noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== 'undefined' && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function async(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === 'function') return true;
    }
    return false;
}
function noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const validateArgCount = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = 'at least ' + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    if (argError) {
        const error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function errorPrefix(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function validateNamespace(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== 'string') //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error(errorPrefix(fnName, 'namespace') + 'must be a valid firebase namespace.');
}
function validateCallback(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== 'function') throw new Error(errorPrefix(fnName, argumentName) + 'must be a valid function.');
}
function validateContextObject(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== 'object' || context === null) throw new Error(errorPrefix(fnName, argumentName) + 'must be a valid context object.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in JavaScript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const stringToByteArray = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            assert(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const stringLength = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const MAX_VALUE_MILLIS = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const RANDOM_FACTOR = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function calculateBackoffMillis(backoffCount, intervalMillis = DEFAULT_INTERVAL_MILLIS, backoffFactor = DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    RANDOM_FACTOR * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min(MAX_VALUE_MILLIS, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function ordinal(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + indicator(i);
}
function indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return 'th';
    const dec = i % 10;
    if (dec === 1) return 'st';
    if (dec === 2) return 'nd';
    if (dec === 3) return 'rd';
    return 'th';
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function getModularInstance(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}

},{"./postinstall.mjs":"hw48W","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hw48W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultsFromPostinstall", ()=>getDefaultsFromPostinstall);
const getDefaultsFromPostinstall = ()=>undefined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3ul0m":[function(require,module,exports,__globalThis) {
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LogLevel", ()=>LogLevel);
parcelHelpers.export(exports, "Logger", ()=>Logger);
parcelHelpers.export(exports, "setLogLevel", ()=>setLogLevel);
parcelHelpers.export(exports, "setUserLogHandler", ()=>setUserLogHandler);
const instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var LogLevel;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})(LogLevel || (LogLevel = {}));
const levelStringToEnum = {
    'debug': LogLevel.DEBUG,
    'verbose': LogLevel.VERBOSE,
    'info': LogLevel.INFO,
    'warn': LogLevel.WARN,
    'error': LogLevel.ERROR,
    'silent': LogLevel.SILENT
};
/**
 * The default log level
 */ const defaultLogLevel = LogLevel.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const ConsoleMethod = {
    [LogLevel.DEBUG]: 'log',
    [LogLevel.VERBOSE]: 'log',
    [LogLevel.INFO]: 'info',
    [LogLevel.WARN]: 'warn',
    [LogLevel.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class Logger {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in LogLevel)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') throw new TypeError('Value assigned to `logHandler` must be a function');
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.DEBUG, ...args);
        this._logHandler(this, LogLevel.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.VERBOSE, ...args);
        this._logHandler(this, LogLevel.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.INFO, ...args);
        this._logHandler(this, LogLevel.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.WARN, ...args);
        this._logHandler(this, LogLevel.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.ERROR, ...args);
        this._logHandler(this, LogLevel.ERROR, ...args);
    }
}
function setLogLevel(level) {
    instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function setUserLogHandler(logCallback, options) {
    for (const instance of instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === 'string') return arg;
                else if (typeof arg === 'number' || typeof arg === 'boolean') return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(' ');
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: LogLevel[level].toLowerCase(),
                message,
                args,
                type: instance.name
            });
        };
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d2rZl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unwrap", ()=>(0, _wrapIdbValueJs.u));
parcelHelpers.export(exports, "wrap", ()=>(0, _wrapIdbValueJs.w));
parcelHelpers.export(exports, "deleteDB", ()=>deleteDB);
parcelHelpers.export(exports, "openDB", ()=>openDB);
var _wrapIdbValueJs = require("./wrap-idb-value.js");
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function openDB(name, version, { blocked, upgrade, blocking, terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, _wrapIdbValueJs.w)(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade((0, _wrapIdbValueJs.w)(request.result), event.oldVersion, event.newVersion, (0, _wrapIdbValueJs.w)(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function deleteDB(name, { blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, _wrapIdbValueJs.w)(request).then(()=>undefined);
}
const readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const cachedMethods = new Map();
function getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if (cachedMethods.get(prop)) return cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    cachedMethods.set(prop, method);
    return method;
}
(0, _wrapIdbValueJs.r)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!getMethod(target, prop) || oldTraps.has(target, prop)
    }));

},{"./wrap-idb-value.js":"voj9K","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"voj9K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>reverseTransformCache);
parcelHelpers.export(exports, "i", ()=>instanceOfAny);
parcelHelpers.export(exports, "r", ()=>replaceTraps);
parcelHelpers.export(exports, "u", ()=>unwrap);
parcelHelpers.export(exports, "w", ()=>wrap);
const instanceOfAny = (object, constructors)=>constructors.some((c)=>object instanceof c);
let idbProxyableTypes;
let cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function getIdbProxyableTypes() {
    return idbProxyableTypes || (idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function getCursorAdvanceMethods() {
    return cursorAdvanceMethods || (cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const cursorRequestMap = new WeakMap();
const transactionDoneMap = new WeakMap();
const transactionStoreNamesMap = new WeakMap();
const transformCache = new WeakMap();
const reverseTransformCache = new WeakMap();
function promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve(wrap(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    reverseTransformCache.set(promise, request);
    return promise;
}
function cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if (transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    transactionDoneMap.set(tx, done);
}
let idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') return target.objectStoreNames || transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return wrap(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function replaceTraps(callback) {
    idbProxyTraps = callback(idbProxyTraps);
}
function wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !('objectStoreNames' in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call(unwrap(this), storeNames, ...args);
        transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return wrap(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if (getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply(unwrap(this), args);
        return wrap(cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return wrap(func.apply(unwrap(this), args));
    };
}
function transformCachableValue(value) {
    if (typeof value === 'function') return wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) cacheDonePromiseForTransaction(value);
    if (instanceOfAny(value, getIdbProxyableTypes())) return new Proxy(value, idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function wrap(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if (transformCache.has(value)) return transformCache.get(value);
    const newValue = transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        transformCache.set(value, newValue);
        reverseTransformCache.set(newValue, value);
    }
    return newValue;
}
const unwrap = (value)=>reverseTransformCache.get(value);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kv7CP":[function(require,module,exports,__globalThis) {
var baseIsEqual = require("7b71d3bc42bb6f3e");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
module.exports = isEqual;

},{"7b71d3bc42bb6f3e":"KbWXx"}],"RY1q0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ItemComponent", ()=>ItemComponent);
parcelHelpers.export(exports, "KeyDown", ()=>KeyDown);
parcelHelpers.export(exports, "defaultChildren", ()=>defaultChildren);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
var tinyDebounce = function debounce(fn, delay) {
    var timeoutID = null;
    return function() {
        clearTimeout(timeoutID);
        var args = arguments;
        var that = this;
        timeoutID = setTimeout(function() {
            fn.apply(that, args);
        }, delay);
    };
};
/**
 * Has own property.
 *
 * @type {Function}
 */ var has = Object.prototype.hasOwnProperty;
/**
 * To string.
 *
 * @type {Function}
 */ var toString = Object.prototype.toString;
/**
 * Test whether a value is "empty".
 *
 * @param {Mixed} val
 * @return {Boolean}
 */ function isEmpty(val) {
    // Null and Undefined...
    if (val == null) return true;
    // Booleans...
    if ('boolean' == typeof val) return false;
    // Numbers...
    if ('number' == typeof val) return val === 0;
    // Strings...
    if ('string' == typeof val) return val.length === 0;
    // Functions...
    if ('function' == typeof val) return val.length === 0;
    // Arrays...
    if (Array.isArray(val)) return val.length === 0;
    // Errors...
    if (val instanceof Error) return val.message === '';
    // Objects...
    if (val.toString == toString) switch(val.toString()){
        // Maps, Sets, Files and Errors...
        case '[object File]':
        case '[object Map]':
        case '[object Set]':
            return val.size === 0;
        // Plain objects...
        case '[object Object]':
            for(var key in val){
                if (has.call(val, key)) return false;
            }
            return true;
    }
    // Anything else...
    return false;
}
/**
 * Export `isEmpty`.
 *
 * @type {Function}
 */ var lib = isEmpty;
//
// Main
//
function memoize(fn, options) {
    var cache = options && options.cache ? options.cache : cacheDefault;
    var serializer = options && options.serializer ? options.serializer : serializerDefault;
    var strategy = options && options.strategy ? options.strategy : strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean' // || typeof value === "string" 'unsafe' primitive for our needs
    ;
}
function monadic(fn, cache, serializer, arg) {
    var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? monadic : variadic;
    return assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function strategyVariadic(fn, options) {
    var strategy = variadic;
    return assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function strategyMonadic(fn, options) {
    var strategy = monadic;
    return assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
//
// Serializer
//
function serializerDefault() {
    return JSON.stringify(arguments);
}
//
// Cache
//
function ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
ObjectWithoutPrototypeCache.prototype.has = function(key) {
    return key in this.cache;
};
ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var cacheDefault = {
    create: function create() {
        return new ObjectWithoutPrototypeCache();
    }
};
//
// API
//
var src = memoize;
var strategies = {
    variadic: strategyVariadic,
    monadic: strategyMonadic
};
src.strategies = strategies;
var validateData = function validateData(data) {
    return !!data && !lib(data);
};
var getValidatedData = function getValidatedData(data) {
    return validateData(data) ? data : [];
};
var walk = function walk(_a) {
    var data = _a.data, props = __rest(_a, [
        "data"
    ]);
    var validatedData = getValidatedData(data);
    var propsWithDefaultValues = __assign({
        parent: '',
        level: 0
    }, props);
    var handleArray = function handleArray(dataAsArray) {
        return dataAsArray.reduce(function(all, node, index) {
            var branchProps = __assign({
                node: node,
                index: index,
                nodeName: node.key
            }, propsWithDefaultValues);
            var branch = generateBranch(branchProps);
            return __spreadArrays(all, branch);
        }, []);
    };
    var handleObject = function handleObject(dataAsObject) {
        return Object.entries(dataAsObject).sort(function(a, b) {
            return a[1].index - b[1].index;
        }) // sorted by index
        .reduce(function(all, _a) {
            var nodeName = _a[0], node = _a[1];
            var branchProps = __assign({
                node: node,
                nodeName: nodeName
            }, propsWithDefaultValues);
            var branch = generateBranch(branchProps);
            return __spreadArrays(all, branch);
        }, []);
    };
    return Array.isArray(validatedData) ? handleArray(validatedData) : handleObject(validatedData);
};
var defaultMatchSearch = function defaultMatchSearch(_a) {
    var label = _a.label, searchTerm = _a.searchTerm;
    var processString = function processString(text) {
        return text.trim().toLowerCase();
    };
    return processString(label).includes(processString(searchTerm));
};
var defaultLocale = function defaultLocale(_a) {
    var label = _a.label;
    return label;
};
var generateBranch = function generateBranch(_a) {
    var node = _a.node, nodeName = _a.nodeName, _b = _a.matchSearch, matchSearch = _b === void 0 ? defaultMatchSearch : _b, _c = _a.locale, locale = _c === void 0 ? defaultLocale : _c, props = __rest(_a, [
        "node",
        "nodeName",
        "matchSearch",
        "locale"
    ]);
    var parent = props.parent, level = props.level, openNodes = props.openNodes, searchTerm = props.searchTerm;
    var nodes = node.nodes, _d = node.label, rawLabel = _d === void 0 ? 'unknown' : _d, nodeProps = __rest(node, [
        "nodes",
        "label"
    ]);
    var key = [
        parent,
        nodeName
    ].filter(function(x) {
        return x;
    }).join('/');
    var hasNodes = validateData(nodes);
    var isOpen = hasNodes && (openNodes.includes(key) || !!searchTerm);
    var label = locale(__assign({
        label: rawLabel
    }, nodeProps));
    var isVisible = !searchTerm || matchSearch(__assign({
        label: label,
        searchTerm: searchTerm
    }, nodeProps));
    var currentItem = __assign(__assign(__assign({}, props), nodeProps), {
        label: label,
        hasNodes: hasNodes,
        isOpen: isOpen,
        key: key
    });
    var data = getValidatedData(nodes);
    var nextLevelItems = isOpen ? walk(__assign(__assign({
        data: data,
        locale: locale,
        matchSearch: matchSearch
    }, props), {
        parent: key,
        level: level + 1
    })) : [];
    return isVisible ? __spreadArrays([
        currentItem
    ], nextLevelItems) : nextLevelItems;
};
var fastWalk = src(walk);
var slowWalk = walk;
function createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
var classnames = createCommonjsModule(function(module) {
    /*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
        var hasOwn = {}.hasOwnProperty;
        function classNames() {
            var classes = [];
            for(var i = 0; i < arguments.length; i++){
                var arg = arguments[i];
                if (!arg) continue;
                var argType = typeof arg;
                if (argType === 'string' || argType === 'number') classes.push(arg);
                else if (Array.isArray(arg) && arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                } else if (argType === 'object') {
                    for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
                }
            }
            return classes.join(' ');
        }
        if (module.exports) {
            classNames.default = classNames;
            module.exports = classNames;
        } else window.classNames = classNames;
    })();
});
var DEFAULT_PADDING = 0.75;
var ICON_SIZE = 2;
var LEVEL_SPACE = 1.75;
var ToggleIcon = function ToggleIcon(_a) {
    var on = _a.on, openedIcon = _a.openedIcon, closedIcon = _a.closedIcon;
    return (0, _reactDefault.default).createElement("div", {
        role: "img",
        "aria-label": "Toggle",
        className: "rstm-toggle-icon-symbol"
    }, on ? openedIcon : closedIcon);
};
var ItemComponent = function ItemComponent(_a) {
    var _b = _a.hasNodes, hasNodes = _b === void 0 ? false : _b, _c = _a.isOpen, isOpen = _c === void 0 ? false : _c, _d = _a.level, level = _d === void 0 ? 0 : _d, onClick = _a.onClick, toggleNode = _a.toggleNode, active = _a.active, focused = _a.focused, _e = _a.openedIcon, openedIcon = _e === void 0 ? '-' : _e, _f = _a.closedIcon, closedIcon = _f === void 0 ? '+' : _f, _g = _a.label, label = _g === void 0 ? 'unknown' : _g, _h = _a.style, style = _h === void 0 ? {} : _h;
    return (0, _reactDefault.default).createElement("li", {
        className: classnames('rstm-tree-item', "rstm-tree-item-level" + level, {
            'rstm-tree-item--active': active
        }, {
            'rstm-tree-item--focused': focused
        }),
        style: __assign({
            paddingLeft: DEFAULT_PADDING + ICON_SIZE * (hasNodes ? 0 : 1) + level * LEVEL_SPACE + "rem"
        }, style),
        role: "button",
        "aria-pressed": active,
        onClick: onClick
    }, hasNodes && (0, _reactDefault.default).createElement("div", {
        className: "rstm-toggle-icon",
        onClick: function onClick(e) {
            hasNodes && toggleNode && toggleNode();
            e.stopPropagation();
        }
    }, (0, _reactDefault.default).createElement(ToggleIcon, {
        on: isOpen,
        openedIcon: openedIcon,
        closedIcon: closedIcon
    })), label);
};
var defaultChildren = function defaultChildren(_a) {
    var search = _a.search, items = _a.items;
    var onSearch = function onSearch(e) {
        var value = e.target.value;
        search && search(value);
    };
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, search && (0, _reactDefault.default).createElement("input", {
        className: "rstm-search",
        "aria-label": "Type and search",
        type: "search",
        placeholder: "Type and search",
        onChange: onSearch
    }), (0, _reactDefault.default).createElement("ul", {
        className: "rstm-tree-item-group"
    }, items.map(function(_a) {
        var key = _a.key, props = __rest(_a, [
            "key"
        ]);
        return (0, _reactDefault.default).createElement(ItemComponent, __assign({
            key: key
        }, props));
    })));
};
var KeyDown = function KeyDown(_a) {
    var children = _a.children, up = _a.up, down = _a.down, left = _a.left, right = _a.right, enter = _a.enter;
    return (0, _reactDefault.default).createElement("div", {
        tabIndex: 0,
        onKeyDown: function onKeyDown(e) {
            switch(e.key){
                case 'ArrowUp':
                    up();
                    break;
                case 'ArrowDown':
                    down();
                    break;
                case 'ArrowLeft':
                    left();
                    break;
                case 'ArrowRight':
                    right();
                    break;
                case 'Enter':
                    enter();
                    break;
            }
        }
    }, children);
};
var defaultOnClick = function defaultOnClick(props) {
    return console.log(props);
}; // eslint-disable-line no-console
var TreeMenu = /** @class */ function(_super) {
    __extends(TreeMenu, _super);
    function TreeMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            openNodes: _this.props.initialOpenNodes || [],
            searchTerm: '',
            activeKey: _this.props.initialActiveKey || '',
            focusKey: _this.props.initialFocusKey || ''
        };
        _this.resetOpenNodes = function(newOpenNodes, activeKey, focusKey) {
            var initialOpenNodes = _this.props.initialOpenNodes;
            var openNodes = Array.isArray(newOpenNodes) && newOpenNodes || initialOpenNodes || [];
            _this.setState({
                openNodes: openNodes,
                searchTerm: '',
                activeKey: activeKey || '',
                focusKey: focusKey || activeKey || ''
            });
        };
        _this.search = function(value) {
            var debounceTime = _this.props.debounceTime;
            var search = tinyDebounce(function(searchTerm) {
                return _this.setState({
                    searchTerm: searchTerm
                });
            }, debounceTime);
            search(value);
        };
        _this.toggleNode = function(node) {
            if (!_this.props.openNodes) {
                var openNodes = _this.state.openNodes;
                var newOpenNodes = openNodes.includes(node) ? openNodes.filter(function(openNode) {
                    return openNode !== node;
                }) : __spreadArrays(openNodes, [
                    node
                ]);
                _this.setState({
                    openNodes: newOpenNodes
                });
            }
        };
        _this.generateItems = function() {
            var _a = _this.props, data = _a.data, onClickItem = _a.onClickItem, locale = _a.locale, matchSearch = _a.matchSearch;
            var searchTerm = _this.state.searchTerm;
            var openNodes = _this.props.openNodes || _this.state.openNodes;
            var activeKey = _this.props.activeKey || _this.state.activeKey;
            var focusKey = _this.props.focusKey || _this.state.focusKey;
            var defaultSearch = _this.props.cacheSearch ? fastWalk : slowWalk;
            var items = data ? defaultSearch({
                data: data,
                openNodes: openNodes,
                searchTerm: searchTerm,
                locale: locale,
                matchSearch: matchSearch
            }) : [];
            return items.map(function(item) {
                var focused = item.key === focusKey;
                var active = item.key === activeKey;
                var onClick = function onClick() {
                    var newActiveKey = _this.props.activeKey || item.key;
                    _this.setState({
                        activeKey: newActiveKey,
                        focusKey: newActiveKey
                    });
                    onClickItem && onClickItem(item);
                };
                var toggleNode = item.hasNodes ? function() {
                    return _this.toggleNode(item.key);
                } : undefined;
                return __assign(__assign({}, item), {
                    focused: focused,
                    active: active,
                    onClick: onClick,
                    toggleNode: toggleNode
                });
            });
        };
        _this.getKeyDownProps = function(items) {
            var onClickItem = _this.props.onClickItem;
            var _a = _this.state, focusKey = _a.focusKey, activeKey = _a.activeKey, searchTerm = _a.searchTerm;
            var focusIndex = items.findIndex(function(item) {
                return item.key === (focusKey || activeKey);
            });
            var getFocusKey = function getFocusKey(item) {
                var keyArray = item.key.split('/');
                return keyArray.length > 1 ? keyArray.slice(0, keyArray.length - 1).join('/') : item.key;
            };
            return {
                up: function up() {
                    _this.setState(function(_a) {
                        var focusKey = _a.focusKey;
                        return {
                            focusKey: focusIndex > 0 ? items[focusIndex - 1].key : focusKey
                        };
                    });
                },
                down: function down() {
                    _this.setState(function(_a) {
                        var focusKey = _a.focusKey;
                        return {
                            focusKey: focusIndex < items.length - 1 ? items[focusIndex + 1].key : focusKey
                        };
                    });
                },
                left: function left() {
                    var item = items[focusIndex];
                    if (item) _this.setState(function(_a) {
                        var openNodes = _a.openNodes, rest = __rest(_a, [
                            "openNodes"
                        ]);
                        var newOpenNodes = openNodes.filter(function(node) {
                            return node !== item.key;
                        });
                        return item.isOpen ? __assign(__assign({}, rest), {
                            openNodes: newOpenNodes,
                            focusKey: item.key
                        }) : __assign(__assign({}, rest), {
                            focusKey: getFocusKey(item)
                        });
                    });
                },
                right: function right() {
                    var _a = items[focusIndex], hasNodes = _a.hasNodes, key = _a.key;
                    if (hasNodes) _this.setState(function(_a) {
                        var openNodes = _a.openNodes;
                        return {
                            openNodes: __spreadArrays(openNodes, [
                                key
                            ])
                        };
                    });
                },
                enter: function enter() {
                    _this.setState(function(_a) {
                        var focusKey = _a.focusKey;
                        return {
                            activeKey: focusKey
                        };
                    });
                    onClickItem && onClickItem(items[focusIndex]);
                }
            };
        };
        return _this;
    }
    TreeMenu.prototype.componentDidUpdate = function(prevProps) {
        var _a = this.props, data = _a.data, initialOpenNodes = _a.initialOpenNodes, resetOpenNodesOnDataUpdate = _a.resetOpenNodesOnDataUpdate;
        if (prevProps.data !== data && resetOpenNodesOnDataUpdate && initialOpenNodes) this.setState({
            openNodes: initialOpenNodes
        });
    };
    TreeMenu.prototype.render = function() {
        var _a = this.props, children = _a.children, hasSearch = _a.hasSearch, disableKeyboard = _a.disableKeyboard;
        var searchTerm = this.state.searchTerm;
        var search = this.search;
        var items = this.generateItems();
        var resetOpenNodes = this.resetOpenNodes;
        var render = children || defaultChildren;
        var renderProps = hasSearch ? {
            search: search,
            resetOpenNodes: resetOpenNodes,
            items: items,
            searchTerm: searchTerm
        } : {
            items: items,
            resetOpenNodes: resetOpenNodes
        };
        return disableKeyboard ? render(renderProps) : (0, _reactDefault.default).createElement(KeyDown, __assign({}, this.getKeyDownProps(items)), render(renderProps));
    };
    TreeMenu.defaultProps = {
        data: {},
        onClickItem: defaultOnClick,
        debounceTime: 125,
        children: defaultChildren,
        hasSearch: true,
        cacheSearch: true,
        resetOpenNodesOnDataUpdate: false,
        disableKeyboard: false
    };
    return TreeMenu;
}((0, _reactDefault.default).Component);
exports.default = TreeMenu;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lbntV":[function() {},{}],"3pd0L":[function(require,module,exports,__globalThis) {
var dbxrefs = require("fc55e149eb114609");
module.exports = {
    isKnown: function(dbName) {
        return dbxrefs.hasOwnProperty(dbName);
    },
    fetch: function(dbName) {
        return dbxrefs[dbName];
    }
};

},{"fc55e149eb114609":"iAWUv"}],"iAWUv":[function(require,module,exports,__globalThis) {
var ENA = {
    label: 'ENA',
    url: function(id) {
        return 'http://www.ebi.ac.uk/ena/data/view/' + id;
    }
};
var thalemine = {
    label: 'thalemine',
    url: function(id) {
        return 'https://bar.utoronto.ca/thalemine/keywordSearchResults.do?searchTerm=' + id + '&searchSubmit=search';
    }
};
var TAIR = {
    label: 'TAIR',
    url: function(id) {
        return `https://www.arabidopsis.org/results?mainType=general&category=genes&searchText=${id}`;
    }
};
// A within-site facet filter, the same shape PanOryza / SB_PanGene / Pan-Zea already use below.
// This is the right target when an xref id names a SET of genes rather than one external record --
// a Grassius id is a transcription-factor FAMILY (LEUNIG, AP2/ERF-ERF, Sigma70-like), not a gene
// symbol -- and it keeps working when the external site does not. encodeURIComponent matters here:
// family names contain '/'.
function facetLink(field, category) {
    return {
        label: category,
        url: function(id) {
            var v = encodeURIComponent(id);
            return `?fq_field=${field}&fq_value=${v}&category=${encodeURIComponent(category)}&name=${v}`;
        }
    };
}
module.exports = {
    TAIR_LOCUS: TAIR,
    ARAPORT_GENE: thalemine,
    // ---- curated gene symbols and names -------------------------------------------------------
    // These five were all present in the data and absent from this registry, so Xrefs.js, which
    // filters on isKnown(xr.db), silently dropped every one of them: TAIR_SYMBOL 9,793 genes,
    // Oryzabase 8,051, RAP-DB 1,175, Grassius 8,796, external_wheat_gene_names 257. MaizeGDB and DOI
    // are new in release 70.
    TAIR_SYMBOL: {
        label: 'TAIR symbol',
        url: function(id) {
            // Same arabidopsis.org search this registry already uses for TAIR_LOCUS; the search box takes
            // a symbol as readily as a locus. Not verifiable from a server -- arabidopsis.org answers 403
            // to non-browser clients -- so this reuses an already-shipped template rather than a new guess.
            return `https://www.arabidopsis.org/results?mainType=general&category=genes&searchText=${encodeURIComponent(id)}`;
        }
    },
    Oryzabase: {
        label: 'Oryzabase',
        url: function(id) {
            // id is a rice gene symbol (RPS5, OsDjC1, OsHAP5H). Endpoint returns 200; Oryzabase renders
            // its results client-side, so a server-side fetch cannot confirm a given symbol resolves.
            return `https://shigen.nig.ac.jp/rice/oryzabase/gene/search?name=${encodeURIComponent(id)}`;
        }
    },
    'RAP-DB': {
        label: 'RAP-DB',
        url: function(id) {
            // id is a rice gene symbol (SPL33, OsTLP27), so this is the name SEARCH, not the /locus/
            // route that expects an Os##g####### id. Host is naro.go.jp: the affrc.go.jp host still
            // referenced elsewhere in this codebase does not answer at all.
            return `https://rapdb.dna.naro.go.jp/search/?name=${encodeURIComponent(id)}`;
        }
    },
    MaizeGDB: {
        label: 'MaizeGDB',
        url: function(id) {
            // id is a curated maize gene symbol (gbss2, thk1, mha11). gene_center/gene/ is the route this
            // codebase already uses for MaizeGDB (see gramene-search Location.js). NOT verified from
            // squam: www.maizegdb.org answers 403 to automated clients via Cloudflare, so this needs one
            // click in a browser to confirm.
            return `https://www.maizegdb.org/gene_center/gene/${encodeURIComponent(id)}`;
        }
    },
    DOI: {
        label: 'DOI',
        url: function(id) {
            // Curated references are not all PMIDs -- RAP-DB keys 246 of its references by DOI. Do NOT
            // encode: a DOI contains '/' as a structural separator (10.1016/j.cj.2016.06.014).
            return `https://doi.org/${id}`;
        }
    },
    Grassius: facetLink('Grassius__xrefs', 'Grassius TF family'),
    external_wheat_gene_names: facetLink('external_wheat_gene_names__xrefs', 'Wheat gene name'),
    LeGOO: {
        label: 'LeGOO (curated)',
        url: function() {
            // 4,399 medicago genes. This one is deliberately NOT an id link, for two reasons.
            //
            // The id is the gene's OWN MtrunA17 stable id, not a foreign accession -- the LeGOO acronym
            // went into gene.name -- so a link keyed on it would point back at the page it is rendered
            // on. What the xref actually records is PROVENANCE: this gene's name and description came
            // from LeGOO rather than from the Ensembl core, which for medicago supplied 452 names and
            // 113 descriptions across 50,739 genes.
            //
            // And LeGOO itself is gone: legoo.inrae.fr and legoo.inra.fr are both NXDOMAIN, not merely
            // blocking automated clients, so there is no gene page left to deep-link. The DOI is the
            // durable target -- it is also the citation the source REQUIRES, recorded in the external_db
            // row by gramene-mongodb/legoo/ so the obligation travels with the data. The genome the
            // spreadsheet came from is at medicago.toulouse.inra.fr/MtrunA17r5.0-ANR/ if a browsable
            // link is ever wanted, but that is the INRAE browser, not LeGOO, and mislabelling it here
            // would misattribute the curation.
            return 'https://doi.org/10.1093/pcp/pcz177';
        }
    },
    PanOryza: {
        label: 'PanOryza pan gene',
        url: function(id) {
            return `?fq_field=PanOryza__xrefs&fq_value=${id}&category=PanOryza pan gene&name=${id}`;
        }
    },
    SB_PanGene: {
        label: 'SorghumBase pan gene',
        url: function(id) {
            return `?fq_field=SB_PanGene__xrefs&fq_value=${id}&category=SorghumBase pan gene&name=${id}`;
        }
    },
    'Pan-Zea': {
        label: "Maize pan gene",
        url: function(id) {
            return `https://maize-pangenome.gramene.org?fq_field=Pan-Zea__xrefs&fq_value=${id}&category=Maize pan gene&name=${id}`;
        }
    },
    UniGene: {
        label: 'UniGene',
        url: function(id) {
            return 'http://www.ncbi.nlm.nih.gov/unigene/?term=' + id;
        }
    },
    UniParc: {
        label: 'UniParc',
        url: function(id) {
            return 'http://www.uniprot.org/uniparc/' + id;
        }
    },
    'Uniprot/SPTREMBL': {
        label: 'UniProt',
        url: function(id) {
            return 'http://www.uniprot.org/uniprot/' + id;
        }
    },
    'Uniprot/SWISSPROT': {
        label: 'UniProt',
        url: function(id) {
            return 'http://www.uniprot.org/uniprot/' + id;
        }
    },
    EMBL: ENA,
    protein_id: {
        label: 'ENA proteins',
        url: function(id) {
            return 'http://www.ebi.ac.uk/ena/data/view/' + id;
        }
    },
    KEGG_Enzyme: {
        label: 'KEGG Enzyme',
        url: function(id) {
            return 'http://www.genome.jp/dbget-bin/www_bget?' + id;
        }
    },
    UniPathway: {
        label: 'UniPathway',
        url: function(id) {
            return 'http://www.grenoble.prabi.fr/obiwarehouse/unipathway/upa?upid=' + id;
        }
    },
    MetaCyc: {
        label: 'MetaCyc',
        url: function(id) {
            return 'http://metacyc.org/META/NEW-IMAGE?type=NIL&object=' + id;
        }
    },
    MEROPS: {
        label: 'MEROPS',
        url: function(id) {
            return 'http://merops.sanger.ac.uk/cgi-bin/pepsum?id=' + id;
        }
    },
    PDB: {
        label: 'PDB',
        url: function(id) {
            return 'http://www.rcsb.org/pdb/explore.do?structureId=' + id;
        }
    },
    GOA: {
        label: 'QuickGO',
        url: function(id) {
            return 'http://www.ebi.ac.uk/QuickGO/GProtein?ac=' + id;
        }
    },
    IntEnz: {
        label: 'IntEnz',
        url: function(id) {
            return 'http://www.ebi.ac.uk/intenz/query?cmd=SearchEC&ec=' + id;
        }
    },
    reactions: {
        label: 'Plant Reactome',
        url: function(id) {
            return 'http://plantreactome.gramene.org/content/detail/' + id;
        }
    },
    NASC_GENE_ID: {
        label: 'NASC',
        url: function(id) {
            return 'http://arabidopsis.info/MultiResult?agi_code=' + id;
        }
    },
    KNETMINER_ARA: {
        label: 'KnetMiner',
        url: function(id) {
            return 'https://knetminer.rothamsted.ac.uk/araknet/genepage?list=' + id;
        }
    },
    KNETMINER_RICE: {
        label: 'KnetMiner',
        url: function(id) {
            return 'https://knetminer.rothamsted.ac.uk/riceknet/genepage?list=' + id;
        }
    },
    KNETMINER_WHEAT: {
        label: 'KnetMiner',
        url: function(id) {
            return 'https://knetminer.rothamsted.ac.uk/wheatknet/genepage?list=' + id;
        }
    },
    PUBMED: {
        label: 'PubMed',
        url: function(id) {
            return 'https://pubmed.ncbi.nlm.nih.gov/' + id;
        }
    }
};

},{}],"ac31b":[function(require,module,exports,__globalThis) {
// THIS FILE IS AUTO GENERATED
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AiFillAccountBook", ()=>AiFillAccountBook);
parcelHelpers.export(exports, "AiFillAlert", ()=>AiFillAlert);
parcelHelpers.export(exports, "AiFillAlipayCircle", ()=>AiFillAlipayCircle);
parcelHelpers.export(exports, "AiFillAlipaySquare", ()=>AiFillAlipaySquare);
parcelHelpers.export(exports, "AiFillAliwangwang", ()=>AiFillAliwangwang);
parcelHelpers.export(exports, "AiFillAmazonCircle", ()=>AiFillAmazonCircle);
parcelHelpers.export(exports, "AiFillAmazonSquare", ()=>AiFillAmazonSquare);
parcelHelpers.export(exports, "AiFillAndroid", ()=>AiFillAndroid);
parcelHelpers.export(exports, "AiFillApi", ()=>AiFillApi);
parcelHelpers.export(exports, "AiFillApple", ()=>AiFillApple);
parcelHelpers.export(exports, "AiFillAppstore", ()=>AiFillAppstore);
parcelHelpers.export(exports, "AiFillAudio", ()=>AiFillAudio);
parcelHelpers.export(exports, "AiFillBackward", ()=>AiFillBackward);
parcelHelpers.export(exports, "AiFillBank", ()=>AiFillBank);
parcelHelpers.export(exports, "AiFillBehanceCircle", ()=>AiFillBehanceCircle);
parcelHelpers.export(exports, "AiFillBehanceSquare", ()=>AiFillBehanceSquare);
parcelHelpers.export(exports, "AiFillBell", ()=>AiFillBell);
parcelHelpers.export(exports, "AiFillBook", ()=>AiFillBook);
parcelHelpers.export(exports, "AiFillBoxPlot", ()=>AiFillBoxPlot);
parcelHelpers.export(exports, "AiFillBug", ()=>AiFillBug);
parcelHelpers.export(exports, "AiFillBuild", ()=>AiFillBuild);
parcelHelpers.export(exports, "AiFillBulb", ()=>AiFillBulb);
parcelHelpers.export(exports, "AiFillCalculator", ()=>AiFillCalculator);
parcelHelpers.export(exports, "AiFillCalendar", ()=>AiFillCalendar);
parcelHelpers.export(exports, "AiFillCamera", ()=>AiFillCamera);
parcelHelpers.export(exports, "AiFillCar", ()=>AiFillCar);
parcelHelpers.export(exports, "AiFillCaretDown", ()=>AiFillCaretDown);
parcelHelpers.export(exports, "AiFillCaretLeft", ()=>AiFillCaretLeft);
parcelHelpers.export(exports, "AiFillCaretRight", ()=>AiFillCaretRight);
parcelHelpers.export(exports, "AiFillCaretUp", ()=>AiFillCaretUp);
parcelHelpers.export(exports, "AiFillCarryOut", ()=>AiFillCarryOut);
parcelHelpers.export(exports, "AiFillCheckCircle", ()=>AiFillCheckCircle);
parcelHelpers.export(exports, "AiFillCheckSquare", ()=>AiFillCheckSquare);
parcelHelpers.export(exports, "AiFillChrome", ()=>AiFillChrome);
parcelHelpers.export(exports, "AiFillCiCircle", ()=>AiFillCiCircle);
parcelHelpers.export(exports, "AiFillClockCircle", ()=>AiFillClockCircle);
parcelHelpers.export(exports, "AiFillCloseCircle", ()=>AiFillCloseCircle);
parcelHelpers.export(exports, "AiFillCloseSquare", ()=>AiFillCloseSquare);
parcelHelpers.export(exports, "AiFillCloud", ()=>AiFillCloud);
parcelHelpers.export(exports, "AiFillCodeSandboxCircle", ()=>AiFillCodeSandboxCircle);
parcelHelpers.export(exports, "AiFillCodeSandboxSquare", ()=>AiFillCodeSandboxSquare);
parcelHelpers.export(exports, "AiFillCode", ()=>AiFillCode);
parcelHelpers.export(exports, "AiFillCodepenCircle", ()=>AiFillCodepenCircle);
parcelHelpers.export(exports, "AiFillCodepenSquare", ()=>AiFillCodepenSquare);
parcelHelpers.export(exports, "AiFillCompass", ()=>AiFillCompass);
parcelHelpers.export(exports, "AiFillContacts", ()=>AiFillContacts);
parcelHelpers.export(exports, "AiFillContainer", ()=>AiFillContainer);
parcelHelpers.export(exports, "AiFillControl", ()=>AiFillControl);
parcelHelpers.export(exports, "AiFillCopy", ()=>AiFillCopy);
parcelHelpers.export(exports, "AiFillCopyrightCircle", ()=>AiFillCopyrightCircle);
parcelHelpers.export(exports, "AiFillCreditCard", ()=>AiFillCreditCard);
parcelHelpers.export(exports, "AiFillCrown", ()=>AiFillCrown);
parcelHelpers.export(exports, "AiFillCustomerService", ()=>AiFillCustomerService);
parcelHelpers.export(exports, "AiFillDashboard", ()=>AiFillDashboard);
parcelHelpers.export(exports, "AiFillDatabase", ()=>AiFillDatabase);
parcelHelpers.export(exports, "AiFillDelete", ()=>AiFillDelete);
parcelHelpers.export(exports, "AiFillDiff", ()=>AiFillDiff);
parcelHelpers.export(exports, "AiFillDingtalkCircle", ()=>AiFillDingtalkCircle);
parcelHelpers.export(exports, "AiFillDingtalkSquare", ()=>AiFillDingtalkSquare);
parcelHelpers.export(exports, "AiFillDislike", ()=>AiFillDislike);
parcelHelpers.export(exports, "AiFillDollarCircle", ()=>AiFillDollarCircle);
parcelHelpers.export(exports, "AiFillDownCircle", ()=>AiFillDownCircle);
parcelHelpers.export(exports, "AiFillDownSquare", ()=>AiFillDownSquare);
parcelHelpers.export(exports, "AiFillDribbbleCircle", ()=>AiFillDribbbleCircle);
parcelHelpers.export(exports, "AiFillDribbbleSquare", ()=>AiFillDribbbleSquare);
parcelHelpers.export(exports, "AiFillDropboxCircle", ()=>AiFillDropboxCircle);
parcelHelpers.export(exports, "AiFillDropboxSquare", ()=>AiFillDropboxSquare);
parcelHelpers.export(exports, "AiFillEdit", ()=>AiFillEdit);
parcelHelpers.export(exports, "AiFillEnvironment", ()=>AiFillEnvironment);
parcelHelpers.export(exports, "AiFillEuroCircle", ()=>AiFillEuroCircle);
parcelHelpers.export(exports, "AiFillExclamationCircle", ()=>AiFillExclamationCircle);
parcelHelpers.export(exports, "AiFillExperiment", ()=>AiFillExperiment);
parcelHelpers.export(exports, "AiFillEyeInvisible", ()=>AiFillEyeInvisible);
parcelHelpers.export(exports, "AiFillEye", ()=>AiFillEye);
parcelHelpers.export(exports, "AiFillFacebook", ()=>AiFillFacebook);
parcelHelpers.export(exports, "AiFillFastBackward", ()=>AiFillFastBackward);
parcelHelpers.export(exports, "AiFillFastForward", ()=>AiFillFastForward);
parcelHelpers.export(exports, "AiFillFileAdd", ()=>AiFillFileAdd);
parcelHelpers.export(exports, "AiFillFileExcel", ()=>AiFillFileExcel);
parcelHelpers.export(exports, "AiFillFileExclamation", ()=>AiFillFileExclamation);
parcelHelpers.export(exports, "AiFillFileImage", ()=>AiFillFileImage);
parcelHelpers.export(exports, "AiFillFileMarkdown", ()=>AiFillFileMarkdown);
parcelHelpers.export(exports, "AiFillFilePdf", ()=>AiFillFilePdf);
parcelHelpers.export(exports, "AiFillFilePpt", ()=>AiFillFilePpt);
parcelHelpers.export(exports, "AiFillFileText", ()=>AiFillFileText);
parcelHelpers.export(exports, "AiFillFileUnknown", ()=>AiFillFileUnknown);
parcelHelpers.export(exports, "AiFillFileWord", ()=>AiFillFileWord);
parcelHelpers.export(exports, "AiFillFileZip", ()=>AiFillFileZip);
parcelHelpers.export(exports, "AiFillFile", ()=>AiFillFile);
parcelHelpers.export(exports, "AiFillFilter", ()=>AiFillFilter);
parcelHelpers.export(exports, "AiFillFire", ()=>AiFillFire);
parcelHelpers.export(exports, "AiFillFlag", ()=>AiFillFlag);
parcelHelpers.export(exports, "AiFillFolderAdd", ()=>AiFillFolderAdd);
parcelHelpers.export(exports, "AiFillFolderOpen", ()=>AiFillFolderOpen);
parcelHelpers.export(exports, "AiFillFolder", ()=>AiFillFolder);
parcelHelpers.export(exports, "AiFillFormatPainter", ()=>AiFillFormatPainter);
parcelHelpers.export(exports, "AiFillForward", ()=>AiFillForward);
parcelHelpers.export(exports, "AiFillFrown", ()=>AiFillFrown);
parcelHelpers.export(exports, "AiFillFund", ()=>AiFillFund);
parcelHelpers.export(exports, "AiFillFunnelPlot", ()=>AiFillFunnelPlot);
parcelHelpers.export(exports, "AiFillGift", ()=>AiFillGift);
parcelHelpers.export(exports, "AiFillGithub", ()=>AiFillGithub);
parcelHelpers.export(exports, "AiFillGitlab", ()=>AiFillGitlab);
parcelHelpers.export(exports, "AiFillGold", ()=>AiFillGold);
parcelHelpers.export(exports, "AiFillGolden", ()=>AiFillGolden);
parcelHelpers.export(exports, "AiFillGoogleCircle", ()=>AiFillGoogleCircle);
parcelHelpers.export(exports, "AiFillGooglePlusCircle", ()=>AiFillGooglePlusCircle);
parcelHelpers.export(exports, "AiFillGooglePlusSquare", ()=>AiFillGooglePlusSquare);
parcelHelpers.export(exports, "AiFillGoogleSquare", ()=>AiFillGoogleSquare);
parcelHelpers.export(exports, "AiFillHdd", ()=>AiFillHdd);
parcelHelpers.export(exports, "AiFillHeart", ()=>AiFillHeart);
parcelHelpers.export(exports, "AiFillHighlight", ()=>AiFillHighlight);
parcelHelpers.export(exports, "AiFillHome", ()=>AiFillHome);
parcelHelpers.export(exports, "AiFillHourglass", ()=>AiFillHourglass);
parcelHelpers.export(exports, "AiFillHtml5", ()=>AiFillHtml5);
parcelHelpers.export(exports, "AiFillIdcard", ()=>AiFillIdcard);
parcelHelpers.export(exports, "AiFillIeCircle", ()=>AiFillIeCircle);
parcelHelpers.export(exports, "AiFillIeSquare", ()=>AiFillIeSquare);
parcelHelpers.export(exports, "AiFillInfoCircle", ()=>AiFillInfoCircle);
parcelHelpers.export(exports, "AiFillInstagram", ()=>AiFillInstagram);
parcelHelpers.export(exports, "AiFillInsurance", ()=>AiFillInsurance);
parcelHelpers.export(exports, "AiFillInteraction", ()=>AiFillInteraction);
parcelHelpers.export(exports, "AiFillLayout", ()=>AiFillLayout);
parcelHelpers.export(exports, "AiFillLeftCircle", ()=>AiFillLeftCircle);
parcelHelpers.export(exports, "AiFillLeftSquare", ()=>AiFillLeftSquare);
parcelHelpers.export(exports, "AiFillLike", ()=>AiFillLike);
parcelHelpers.export(exports, "AiFillLinkedin", ()=>AiFillLinkedin);
parcelHelpers.export(exports, "AiFillLock", ()=>AiFillLock);
parcelHelpers.export(exports, "AiFillMacCommand", ()=>AiFillMacCommand);
parcelHelpers.export(exports, "AiFillMail", ()=>AiFillMail);
parcelHelpers.export(exports, "AiFillMedicineBox", ()=>AiFillMedicineBox);
parcelHelpers.export(exports, "AiFillMediumCircle", ()=>AiFillMediumCircle);
parcelHelpers.export(exports, "AiFillMediumSquare", ()=>AiFillMediumSquare);
parcelHelpers.export(exports, "AiFillMeh", ()=>AiFillMeh);
parcelHelpers.export(exports, "AiFillMessage", ()=>AiFillMessage);
parcelHelpers.export(exports, "AiFillMinusCircle", ()=>AiFillMinusCircle);
parcelHelpers.export(exports, "AiFillMinusSquare", ()=>AiFillMinusSquare);
parcelHelpers.export(exports, "AiFillMobile", ()=>AiFillMobile);
parcelHelpers.export(exports, "AiFillMoneyCollect", ()=>AiFillMoneyCollect);
parcelHelpers.export(exports, "AiFillNotification", ()=>AiFillNotification);
parcelHelpers.export(exports, "AiFillPauseCircle", ()=>AiFillPauseCircle);
parcelHelpers.export(exports, "AiFillPayCircle", ()=>AiFillPayCircle);
parcelHelpers.export(exports, "AiFillPhone", ()=>AiFillPhone);
parcelHelpers.export(exports, "AiFillPicture", ()=>AiFillPicture);
parcelHelpers.export(exports, "AiFillPieChart", ()=>AiFillPieChart);
parcelHelpers.export(exports, "AiFillPlayCircle", ()=>AiFillPlayCircle);
parcelHelpers.export(exports, "AiFillPlaySquare", ()=>AiFillPlaySquare);
parcelHelpers.export(exports, "AiFillPlusCircle", ()=>AiFillPlusCircle);
parcelHelpers.export(exports, "AiFillPlusSquare", ()=>AiFillPlusSquare);
parcelHelpers.export(exports, "AiFillPoundCircle", ()=>AiFillPoundCircle);
parcelHelpers.export(exports, "AiFillPrinter", ()=>AiFillPrinter);
parcelHelpers.export(exports, "AiFillProfile", ()=>AiFillProfile);
parcelHelpers.export(exports, "AiFillProject", ()=>AiFillProject);
parcelHelpers.export(exports, "AiFillPropertySafety", ()=>AiFillPropertySafety);
parcelHelpers.export(exports, "AiFillPushpin", ()=>AiFillPushpin);
parcelHelpers.export(exports, "AiFillQqCircle", ()=>AiFillQqCircle);
parcelHelpers.export(exports, "AiFillQqSquare", ()=>AiFillQqSquare);
parcelHelpers.export(exports, "AiFillQuestionCircle", ()=>AiFillQuestionCircle);
parcelHelpers.export(exports, "AiFillRead", ()=>AiFillRead);
parcelHelpers.export(exports, "AiFillReconciliation", ()=>AiFillReconciliation);
parcelHelpers.export(exports, "AiFillRedEnvelope", ()=>AiFillRedEnvelope);
parcelHelpers.export(exports, "AiFillRedditCircle", ()=>AiFillRedditCircle);
parcelHelpers.export(exports, "AiFillRedditSquare", ()=>AiFillRedditSquare);
parcelHelpers.export(exports, "AiFillRest", ()=>AiFillRest);
parcelHelpers.export(exports, "AiFillRightCircle", ()=>AiFillRightCircle);
parcelHelpers.export(exports, "AiFillRightSquare", ()=>AiFillRightSquare);
parcelHelpers.export(exports, "AiFillRobot", ()=>AiFillRobot);
parcelHelpers.export(exports, "AiFillRocket", ()=>AiFillRocket);
parcelHelpers.export(exports, "AiFillSafetyCertificate", ()=>AiFillSafetyCertificate);
parcelHelpers.export(exports, "AiFillSave", ()=>AiFillSave);
parcelHelpers.export(exports, "AiFillSchedule", ()=>AiFillSchedule);
parcelHelpers.export(exports, "AiFillSecurityScan", ()=>AiFillSecurityScan);
parcelHelpers.export(exports, "AiFillSetting", ()=>AiFillSetting);
parcelHelpers.export(exports, "AiFillShop", ()=>AiFillShop);
parcelHelpers.export(exports, "AiFillShopping", ()=>AiFillShopping);
parcelHelpers.export(exports, "AiFillSignal", ()=>AiFillSignal);
parcelHelpers.export(exports, "AiFillSketchCircle", ()=>AiFillSketchCircle);
parcelHelpers.export(exports, "AiFillSketchSquare", ()=>AiFillSketchSquare);
parcelHelpers.export(exports, "AiFillSkin", ()=>AiFillSkin);
parcelHelpers.export(exports, "AiFillSkype", ()=>AiFillSkype);
parcelHelpers.export(exports, "AiFillSlackCircle", ()=>AiFillSlackCircle);
parcelHelpers.export(exports, "AiFillSlackSquare", ()=>AiFillSlackSquare);
parcelHelpers.export(exports, "AiFillSliders", ()=>AiFillSliders);
parcelHelpers.export(exports, "AiFillSmile", ()=>AiFillSmile);
parcelHelpers.export(exports, "AiFillSnippets", ()=>AiFillSnippets);
parcelHelpers.export(exports, "AiFillSound", ()=>AiFillSound);
parcelHelpers.export(exports, "AiFillStar", ()=>AiFillStar);
parcelHelpers.export(exports, "AiFillStepBackward", ()=>AiFillStepBackward);
parcelHelpers.export(exports, "AiFillStepForward", ()=>AiFillStepForward);
parcelHelpers.export(exports, "AiFillStop", ()=>AiFillStop);
parcelHelpers.export(exports, "AiFillSwitcher", ()=>AiFillSwitcher);
parcelHelpers.export(exports, "AiFillTablet", ()=>AiFillTablet);
parcelHelpers.export(exports, "AiFillTag", ()=>AiFillTag);
parcelHelpers.export(exports, "AiFillTags", ()=>AiFillTags);
parcelHelpers.export(exports, "AiFillTaobaoCircle", ()=>AiFillTaobaoCircle);
parcelHelpers.export(exports, "AiFillTaobaoSquare", ()=>AiFillTaobaoSquare);
parcelHelpers.export(exports, "AiFillThunderbolt", ()=>AiFillThunderbolt);
parcelHelpers.export(exports, "AiFillTool", ()=>AiFillTool);
parcelHelpers.export(exports, "AiFillTrademarkCircle", ()=>AiFillTrademarkCircle);
parcelHelpers.export(exports, "AiFillTrophy", ()=>AiFillTrophy);
parcelHelpers.export(exports, "AiFillTwitterCircle", ()=>AiFillTwitterCircle);
parcelHelpers.export(exports, "AiFillTwitterSquare", ()=>AiFillTwitterSquare);
parcelHelpers.export(exports, "AiFillUnlock", ()=>AiFillUnlock);
parcelHelpers.export(exports, "AiFillUpCircle", ()=>AiFillUpCircle);
parcelHelpers.export(exports, "AiFillUpSquare", ()=>AiFillUpSquare);
parcelHelpers.export(exports, "AiFillUsb", ()=>AiFillUsb);
parcelHelpers.export(exports, "AiFillVideoCamera", ()=>AiFillVideoCamera);
parcelHelpers.export(exports, "AiFillWallet", ()=>AiFillWallet);
parcelHelpers.export(exports, "AiFillWarning", ()=>AiFillWarning);
parcelHelpers.export(exports, "AiFillWechat", ()=>AiFillWechat);
parcelHelpers.export(exports, "AiFillWeiboCircle", ()=>AiFillWeiboCircle);
parcelHelpers.export(exports, "AiFillWeiboSquare", ()=>AiFillWeiboSquare);
parcelHelpers.export(exports, "AiFillWindows", ()=>AiFillWindows);
parcelHelpers.export(exports, "AiFillYahoo", ()=>AiFillYahoo);
parcelHelpers.export(exports, "AiFillYoutube", ()=>AiFillYoutube);
parcelHelpers.export(exports, "AiFillYuque", ()=>AiFillYuque);
parcelHelpers.export(exports, "AiFillZhihuCircle", ()=>AiFillZhihuCircle);
parcelHelpers.export(exports, "AiFillZhihuSquare", ()=>AiFillZhihuSquare);
parcelHelpers.export(exports, "AiOutlineAccountBook", ()=>AiOutlineAccountBook);
parcelHelpers.export(exports, "AiOutlineAim", ()=>AiOutlineAim);
parcelHelpers.export(exports, "AiOutlineAlert", ()=>AiOutlineAlert);
parcelHelpers.export(exports, "AiOutlineAlibaba", ()=>AiOutlineAlibaba);
parcelHelpers.export(exports, "AiOutlineAlignCenter", ()=>AiOutlineAlignCenter);
parcelHelpers.export(exports, "AiOutlineAlignLeft", ()=>AiOutlineAlignLeft);
parcelHelpers.export(exports, "AiOutlineAlignRight", ()=>AiOutlineAlignRight);
parcelHelpers.export(exports, "AiOutlineAlipayCircle", ()=>AiOutlineAlipayCircle);
parcelHelpers.export(exports, "AiOutlineAlipay", ()=>AiOutlineAlipay);
parcelHelpers.export(exports, "AiOutlineAliwangwang", ()=>AiOutlineAliwangwang);
parcelHelpers.export(exports, "AiOutlineAliyun", ()=>AiOutlineAliyun);
parcelHelpers.export(exports, "AiOutlineAmazon", ()=>AiOutlineAmazon);
parcelHelpers.export(exports, "AiOutlineAndroid", ()=>AiOutlineAndroid);
parcelHelpers.export(exports, "AiOutlineAntCloud", ()=>AiOutlineAntCloud);
parcelHelpers.export(exports, "AiOutlineAntDesign", ()=>AiOutlineAntDesign);
parcelHelpers.export(exports, "AiOutlineApartment", ()=>AiOutlineApartment);
parcelHelpers.export(exports, "AiOutlineApi", ()=>AiOutlineApi);
parcelHelpers.export(exports, "AiOutlineApple", ()=>AiOutlineApple);
parcelHelpers.export(exports, "AiOutlineAppstoreAdd", ()=>AiOutlineAppstoreAdd);
parcelHelpers.export(exports, "AiOutlineAppstore", ()=>AiOutlineAppstore);
parcelHelpers.export(exports, "AiOutlineAreaChart", ()=>AiOutlineAreaChart);
parcelHelpers.export(exports, "AiOutlineArrowDown", ()=>AiOutlineArrowDown);
parcelHelpers.export(exports, "AiOutlineArrowLeft", ()=>AiOutlineArrowLeft);
parcelHelpers.export(exports, "AiOutlineArrowRight", ()=>AiOutlineArrowRight);
parcelHelpers.export(exports, "AiOutlineArrowUp", ()=>AiOutlineArrowUp);
parcelHelpers.export(exports, "AiOutlineArrowsAlt", ()=>AiOutlineArrowsAlt);
parcelHelpers.export(exports, "AiOutlineAudioMuted", ()=>AiOutlineAudioMuted);
parcelHelpers.export(exports, "AiOutlineAudio", ()=>AiOutlineAudio);
parcelHelpers.export(exports, "AiOutlineAudit", ()=>AiOutlineAudit);
parcelHelpers.export(exports, "AiOutlineBackward", ()=>AiOutlineBackward);
parcelHelpers.export(exports, "AiOutlineBank", ()=>AiOutlineBank);
parcelHelpers.export(exports, "AiOutlineBarChart", ()=>AiOutlineBarChart);
parcelHelpers.export(exports, "AiOutlineBarcode", ()=>AiOutlineBarcode);
parcelHelpers.export(exports, "AiOutlineBars", ()=>AiOutlineBars);
parcelHelpers.export(exports, "AiOutlineBehanceSquare", ()=>AiOutlineBehanceSquare);
parcelHelpers.export(exports, "AiOutlineBehance", ()=>AiOutlineBehance);
parcelHelpers.export(exports, "AiOutlineBell", ()=>AiOutlineBell);
parcelHelpers.export(exports, "AiOutlineBgColors", ()=>AiOutlineBgColors);
parcelHelpers.export(exports, "AiOutlineBlock", ()=>AiOutlineBlock);
parcelHelpers.export(exports, "AiOutlineBold", ()=>AiOutlineBold);
parcelHelpers.export(exports, "AiOutlineBook", ()=>AiOutlineBook);
parcelHelpers.export(exports, "AiOutlineBorderBottom", ()=>AiOutlineBorderBottom);
parcelHelpers.export(exports, "AiOutlineBorderHorizontal", ()=>AiOutlineBorderHorizontal);
parcelHelpers.export(exports, "AiOutlineBorderInner", ()=>AiOutlineBorderInner);
parcelHelpers.export(exports, "AiOutlineBorderLeft", ()=>AiOutlineBorderLeft);
parcelHelpers.export(exports, "AiOutlineBorderOuter", ()=>AiOutlineBorderOuter);
parcelHelpers.export(exports, "AiOutlineBorderRight", ()=>AiOutlineBorderRight);
parcelHelpers.export(exports, "AiOutlineBorderTop", ()=>AiOutlineBorderTop);
parcelHelpers.export(exports, "AiOutlineBorderVerticle", ()=>AiOutlineBorderVerticle);
parcelHelpers.export(exports, "AiOutlineBorder", ()=>AiOutlineBorder);
parcelHelpers.export(exports, "AiOutlineBorderlessTable", ()=>AiOutlineBorderlessTable);
parcelHelpers.export(exports, "AiOutlineBoxPlot", ()=>AiOutlineBoxPlot);
parcelHelpers.export(exports, "AiOutlineBranches", ()=>AiOutlineBranches);
parcelHelpers.export(exports, "AiOutlineBug", ()=>AiOutlineBug);
parcelHelpers.export(exports, "AiOutlineBuild", ()=>AiOutlineBuild);
parcelHelpers.export(exports, "AiOutlineBulb", ()=>AiOutlineBulb);
parcelHelpers.export(exports, "AiOutlineCalculator", ()=>AiOutlineCalculator);
parcelHelpers.export(exports, "AiOutlineCalendar", ()=>AiOutlineCalendar);
parcelHelpers.export(exports, "AiOutlineCamera", ()=>AiOutlineCamera);
parcelHelpers.export(exports, "AiOutlineCar", ()=>AiOutlineCar);
parcelHelpers.export(exports, "AiOutlineCaretDown", ()=>AiOutlineCaretDown);
parcelHelpers.export(exports, "AiOutlineCaretLeft", ()=>AiOutlineCaretLeft);
parcelHelpers.export(exports, "AiOutlineCaretRight", ()=>AiOutlineCaretRight);
parcelHelpers.export(exports, "AiOutlineCaretUp", ()=>AiOutlineCaretUp);
parcelHelpers.export(exports, "AiOutlineCarryOut", ()=>AiOutlineCarryOut);
parcelHelpers.export(exports, "AiOutlineCheckCircle", ()=>AiOutlineCheckCircle);
parcelHelpers.export(exports, "AiOutlineCheckSquare", ()=>AiOutlineCheckSquare);
parcelHelpers.export(exports, "AiOutlineCheck", ()=>AiOutlineCheck);
parcelHelpers.export(exports, "AiOutlineChrome", ()=>AiOutlineChrome);
parcelHelpers.export(exports, "AiOutlineCiCircle", ()=>AiOutlineCiCircle);
parcelHelpers.export(exports, "AiOutlineCi", ()=>AiOutlineCi);
parcelHelpers.export(exports, "AiOutlineClear", ()=>AiOutlineClear);
parcelHelpers.export(exports, "AiOutlineClockCircle", ()=>AiOutlineClockCircle);
parcelHelpers.export(exports, "AiOutlineCloseCircle", ()=>AiOutlineCloseCircle);
parcelHelpers.export(exports, "AiOutlineCloseSquare", ()=>AiOutlineCloseSquare);
parcelHelpers.export(exports, "AiOutlineClose", ()=>AiOutlineClose);
parcelHelpers.export(exports, "AiOutlineCloudDownload", ()=>AiOutlineCloudDownload);
parcelHelpers.export(exports, "AiOutlineCloudServer", ()=>AiOutlineCloudServer);
parcelHelpers.export(exports, "AiOutlineCloudSync", ()=>AiOutlineCloudSync);
parcelHelpers.export(exports, "AiOutlineCloudUpload", ()=>AiOutlineCloudUpload);
parcelHelpers.export(exports, "AiOutlineCloud", ()=>AiOutlineCloud);
parcelHelpers.export(exports, "AiOutlineCluster", ()=>AiOutlineCluster);
parcelHelpers.export(exports, "AiOutlineCodeSandbox", ()=>AiOutlineCodeSandbox);
parcelHelpers.export(exports, "AiOutlineCode", ()=>AiOutlineCode);
parcelHelpers.export(exports, "AiOutlineCodepenCircle", ()=>AiOutlineCodepenCircle);
parcelHelpers.export(exports, "AiOutlineCodepen", ()=>AiOutlineCodepen);
parcelHelpers.export(exports, "AiOutlineCoffee", ()=>AiOutlineCoffee);
parcelHelpers.export(exports, "AiOutlineColumnHeight", ()=>AiOutlineColumnHeight);
parcelHelpers.export(exports, "AiOutlineColumnWidth", ()=>AiOutlineColumnWidth);
parcelHelpers.export(exports, "AiOutlineComment", ()=>AiOutlineComment);
parcelHelpers.export(exports, "AiOutlineCompass", ()=>AiOutlineCompass);
parcelHelpers.export(exports, "AiOutlineCompress", ()=>AiOutlineCompress);
parcelHelpers.export(exports, "AiOutlineConsoleSql", ()=>AiOutlineConsoleSql);
parcelHelpers.export(exports, "AiOutlineContacts", ()=>AiOutlineContacts);
parcelHelpers.export(exports, "AiOutlineContainer", ()=>AiOutlineContainer);
parcelHelpers.export(exports, "AiOutlineControl", ()=>AiOutlineControl);
parcelHelpers.export(exports, "AiOutlineCopy", ()=>AiOutlineCopy);
parcelHelpers.export(exports, "AiOutlineCopyrightCircle", ()=>AiOutlineCopyrightCircle);
parcelHelpers.export(exports, "AiOutlineCopyright", ()=>AiOutlineCopyright);
parcelHelpers.export(exports, "AiOutlineCreditCard", ()=>AiOutlineCreditCard);
parcelHelpers.export(exports, "AiOutlineCrown", ()=>AiOutlineCrown);
parcelHelpers.export(exports, "AiOutlineCustomerService", ()=>AiOutlineCustomerService);
parcelHelpers.export(exports, "AiOutlineDash", ()=>AiOutlineDash);
parcelHelpers.export(exports, "AiOutlineDashboard", ()=>AiOutlineDashboard);
parcelHelpers.export(exports, "AiOutlineDatabase", ()=>AiOutlineDatabase);
parcelHelpers.export(exports, "AiOutlineDeleteColumn", ()=>AiOutlineDeleteColumn);
parcelHelpers.export(exports, "AiOutlineDeleteRow", ()=>AiOutlineDeleteRow);
parcelHelpers.export(exports, "AiOutlineDelete", ()=>AiOutlineDelete);
parcelHelpers.export(exports, "AiOutlineDeliveredProcedure", ()=>AiOutlineDeliveredProcedure);
parcelHelpers.export(exports, "AiOutlineDeploymentUnit", ()=>AiOutlineDeploymentUnit);
parcelHelpers.export(exports, "AiOutlineDesktop", ()=>AiOutlineDesktop);
parcelHelpers.export(exports, "AiOutlineDiff", ()=>AiOutlineDiff);
parcelHelpers.export(exports, "AiOutlineDingding", ()=>AiOutlineDingding);
parcelHelpers.export(exports, "AiOutlineDingtalk", ()=>AiOutlineDingtalk);
parcelHelpers.export(exports, "AiOutlineDisconnect", ()=>AiOutlineDisconnect);
parcelHelpers.export(exports, "AiOutlineDislike", ()=>AiOutlineDislike);
parcelHelpers.export(exports, "AiOutlineDollarCircle", ()=>AiOutlineDollarCircle);
parcelHelpers.export(exports, "AiOutlineDollar", ()=>AiOutlineDollar);
parcelHelpers.export(exports, "AiOutlineDotChart", ()=>AiOutlineDotChart);
parcelHelpers.export(exports, "AiOutlineDoubleLeft", ()=>AiOutlineDoubleLeft);
parcelHelpers.export(exports, "AiOutlineDoubleRight", ()=>AiOutlineDoubleRight);
parcelHelpers.export(exports, "AiOutlineDownCircle", ()=>AiOutlineDownCircle);
parcelHelpers.export(exports, "AiOutlineDownSquare", ()=>AiOutlineDownSquare);
parcelHelpers.export(exports, "AiOutlineDown", ()=>AiOutlineDown);
parcelHelpers.export(exports, "AiOutlineDownload", ()=>AiOutlineDownload);
parcelHelpers.export(exports, "AiOutlineDrag", ()=>AiOutlineDrag);
parcelHelpers.export(exports, "AiOutlineDribbbleSquare", ()=>AiOutlineDribbbleSquare);
parcelHelpers.export(exports, "AiOutlineDribbble", ()=>AiOutlineDribbble);
parcelHelpers.export(exports, "AiOutlineDropbox", ()=>AiOutlineDropbox);
parcelHelpers.export(exports, "AiOutlineEdit", ()=>AiOutlineEdit);
parcelHelpers.export(exports, "AiOutlineEllipsis", ()=>AiOutlineEllipsis);
parcelHelpers.export(exports, "AiOutlineEnter", ()=>AiOutlineEnter);
parcelHelpers.export(exports, "AiOutlineEnvironment", ()=>AiOutlineEnvironment);
parcelHelpers.export(exports, "AiOutlineEuroCircle", ()=>AiOutlineEuroCircle);
parcelHelpers.export(exports, "AiOutlineEuro", ()=>AiOutlineEuro);
parcelHelpers.export(exports, "AiOutlineException", ()=>AiOutlineException);
parcelHelpers.export(exports, "AiOutlineExclamationCircle", ()=>AiOutlineExclamationCircle);
parcelHelpers.export(exports, "AiOutlineExclamation", ()=>AiOutlineExclamation);
parcelHelpers.export(exports, "AiOutlineExpandAlt", ()=>AiOutlineExpandAlt);
parcelHelpers.export(exports, "AiOutlineExpand", ()=>AiOutlineExpand);
parcelHelpers.export(exports, "AiOutlineExperiment", ()=>AiOutlineExperiment);
parcelHelpers.export(exports, "AiOutlineExport", ()=>AiOutlineExport);
parcelHelpers.export(exports, "AiOutlineEyeInvisible", ()=>AiOutlineEyeInvisible);
parcelHelpers.export(exports, "AiOutlineEye", ()=>AiOutlineEye);
parcelHelpers.export(exports, "AiOutlineFacebook", ()=>AiOutlineFacebook);
parcelHelpers.export(exports, "AiOutlineFall", ()=>AiOutlineFall);
parcelHelpers.export(exports, "AiOutlineFastBackward", ()=>AiOutlineFastBackward);
parcelHelpers.export(exports, "AiOutlineFastForward", ()=>AiOutlineFastForward);
parcelHelpers.export(exports, "AiOutlineFieldBinary", ()=>AiOutlineFieldBinary);
parcelHelpers.export(exports, "AiOutlineFieldNumber", ()=>AiOutlineFieldNumber);
parcelHelpers.export(exports, "AiOutlineFieldString", ()=>AiOutlineFieldString);
parcelHelpers.export(exports, "AiOutlineFieldTime", ()=>AiOutlineFieldTime);
parcelHelpers.export(exports, "AiOutlineFileAdd", ()=>AiOutlineFileAdd);
parcelHelpers.export(exports, "AiOutlineFileDone", ()=>AiOutlineFileDone);
parcelHelpers.export(exports, "AiOutlineFileExcel", ()=>AiOutlineFileExcel);
parcelHelpers.export(exports, "AiOutlineFileExclamation", ()=>AiOutlineFileExclamation);
parcelHelpers.export(exports, "AiOutlineFileGif", ()=>AiOutlineFileGif);
parcelHelpers.export(exports, "AiOutlineFileImage", ()=>AiOutlineFileImage);
parcelHelpers.export(exports, "AiOutlineFileJpg", ()=>AiOutlineFileJpg);
parcelHelpers.export(exports, "AiOutlineFileMarkdown", ()=>AiOutlineFileMarkdown);
parcelHelpers.export(exports, "AiOutlineFilePdf", ()=>AiOutlineFilePdf);
parcelHelpers.export(exports, "AiOutlineFilePpt", ()=>AiOutlineFilePpt);
parcelHelpers.export(exports, "AiOutlineFileProtect", ()=>AiOutlineFileProtect);
parcelHelpers.export(exports, "AiOutlineFileSearch", ()=>AiOutlineFileSearch);
parcelHelpers.export(exports, "AiOutlineFileSync", ()=>AiOutlineFileSync);
parcelHelpers.export(exports, "AiOutlineFileText", ()=>AiOutlineFileText);
parcelHelpers.export(exports, "AiOutlineFileUnknown", ()=>AiOutlineFileUnknown);
parcelHelpers.export(exports, "AiOutlineFileWord", ()=>AiOutlineFileWord);
parcelHelpers.export(exports, "AiOutlineFileZip", ()=>AiOutlineFileZip);
parcelHelpers.export(exports, "AiOutlineFile", ()=>AiOutlineFile);
parcelHelpers.export(exports, "AiOutlineFilter", ()=>AiOutlineFilter);
parcelHelpers.export(exports, "AiOutlineFire", ()=>AiOutlineFire);
parcelHelpers.export(exports, "AiOutlineFlag", ()=>AiOutlineFlag);
parcelHelpers.export(exports, "AiOutlineFolderAdd", ()=>AiOutlineFolderAdd);
parcelHelpers.export(exports, "AiOutlineFolderOpen", ()=>AiOutlineFolderOpen);
parcelHelpers.export(exports, "AiOutlineFolderView", ()=>AiOutlineFolderView);
parcelHelpers.export(exports, "AiOutlineFolder", ()=>AiOutlineFolder);
parcelHelpers.export(exports, "AiOutlineFontColors", ()=>AiOutlineFontColors);
parcelHelpers.export(exports, "AiOutlineFontSize", ()=>AiOutlineFontSize);
parcelHelpers.export(exports, "AiOutlineFork", ()=>AiOutlineFork);
parcelHelpers.export(exports, "AiOutlineForm", ()=>AiOutlineForm);
parcelHelpers.export(exports, "AiOutlineFormatPainter", ()=>AiOutlineFormatPainter);
parcelHelpers.export(exports, "AiOutlineForward", ()=>AiOutlineForward);
parcelHelpers.export(exports, "AiOutlineFrown", ()=>AiOutlineFrown);
parcelHelpers.export(exports, "AiOutlineFullscreenExit", ()=>AiOutlineFullscreenExit);
parcelHelpers.export(exports, "AiOutlineFullscreen", ()=>AiOutlineFullscreen);
parcelHelpers.export(exports, "AiOutlineFunction", ()=>AiOutlineFunction);
parcelHelpers.export(exports, "AiOutlineFundProjectionScreen", ()=>AiOutlineFundProjectionScreen);
parcelHelpers.export(exports, "AiOutlineFundView", ()=>AiOutlineFundView);
parcelHelpers.export(exports, "AiOutlineFund", ()=>AiOutlineFund);
parcelHelpers.export(exports, "AiOutlineFunnelPlot", ()=>AiOutlineFunnelPlot);
parcelHelpers.export(exports, "AiOutlineGateway", ()=>AiOutlineGateway);
parcelHelpers.export(exports, "AiOutlineGif", ()=>AiOutlineGif);
parcelHelpers.export(exports, "AiOutlineGift", ()=>AiOutlineGift);
parcelHelpers.export(exports, "AiOutlineGithub", ()=>AiOutlineGithub);
parcelHelpers.export(exports, "AiOutlineGitlab", ()=>AiOutlineGitlab);
parcelHelpers.export(exports, "AiOutlineGlobal", ()=>AiOutlineGlobal);
parcelHelpers.export(exports, "AiOutlineGold", ()=>AiOutlineGold);
parcelHelpers.export(exports, "AiOutlineGooglePlus", ()=>AiOutlineGooglePlus);
parcelHelpers.export(exports, "AiOutlineGoogle", ()=>AiOutlineGoogle);
parcelHelpers.export(exports, "AiOutlineGroup", ()=>AiOutlineGroup);
parcelHelpers.export(exports, "AiOutlineHdd", ()=>AiOutlineHdd);
parcelHelpers.export(exports, "AiOutlineHeart", ()=>AiOutlineHeart);
parcelHelpers.export(exports, "AiOutlineHeatMap", ()=>AiOutlineHeatMap);
parcelHelpers.export(exports, "AiOutlineHighlight", ()=>AiOutlineHighlight);
parcelHelpers.export(exports, "AiOutlineHistory", ()=>AiOutlineHistory);
parcelHelpers.export(exports, "AiOutlineHolder", ()=>AiOutlineHolder);
parcelHelpers.export(exports, "AiOutlineHome", ()=>AiOutlineHome);
parcelHelpers.export(exports, "AiOutlineHourglass", ()=>AiOutlineHourglass);
parcelHelpers.export(exports, "AiOutlineHtml5", ()=>AiOutlineHtml5);
parcelHelpers.export(exports, "AiOutlineIdcard", ()=>AiOutlineIdcard);
parcelHelpers.export(exports, "AiOutlineIe", ()=>AiOutlineIe);
parcelHelpers.export(exports, "AiOutlineImport", ()=>AiOutlineImport);
parcelHelpers.export(exports, "AiOutlineInbox", ()=>AiOutlineInbox);
parcelHelpers.export(exports, "AiOutlineInfoCircle", ()=>AiOutlineInfoCircle);
parcelHelpers.export(exports, "AiOutlineInfo", ()=>AiOutlineInfo);
parcelHelpers.export(exports, "AiOutlineInsertRowAbove", ()=>AiOutlineInsertRowAbove);
parcelHelpers.export(exports, "AiOutlineInsertRowBelow", ()=>AiOutlineInsertRowBelow);
parcelHelpers.export(exports, "AiOutlineInsertRowLeft", ()=>AiOutlineInsertRowLeft);
parcelHelpers.export(exports, "AiOutlineInsertRowRight", ()=>AiOutlineInsertRowRight);
parcelHelpers.export(exports, "AiOutlineInstagram", ()=>AiOutlineInstagram);
parcelHelpers.export(exports, "AiOutlineInsurance", ()=>AiOutlineInsurance);
parcelHelpers.export(exports, "AiOutlineInteraction", ()=>AiOutlineInteraction);
parcelHelpers.export(exports, "AiOutlineIssuesClose", ()=>AiOutlineIssuesClose);
parcelHelpers.export(exports, "AiOutlineItalic", ()=>AiOutlineItalic);
parcelHelpers.export(exports, "AiOutlineKey", ()=>AiOutlineKey);
parcelHelpers.export(exports, "AiOutlineLaptop", ()=>AiOutlineLaptop);
parcelHelpers.export(exports, "AiOutlineLayout", ()=>AiOutlineLayout);
parcelHelpers.export(exports, "AiOutlineLeftCircle", ()=>AiOutlineLeftCircle);
parcelHelpers.export(exports, "AiOutlineLeftSquare", ()=>AiOutlineLeftSquare);
parcelHelpers.export(exports, "AiOutlineLeft", ()=>AiOutlineLeft);
parcelHelpers.export(exports, "AiOutlineLike", ()=>AiOutlineLike);
parcelHelpers.export(exports, "AiOutlineLineChart", ()=>AiOutlineLineChart);
parcelHelpers.export(exports, "AiOutlineLineHeight", ()=>AiOutlineLineHeight);
parcelHelpers.export(exports, "AiOutlineLine", ()=>AiOutlineLine);
parcelHelpers.export(exports, "AiOutlineLink", ()=>AiOutlineLink);
parcelHelpers.export(exports, "AiOutlineLinkedin", ()=>AiOutlineLinkedin);
parcelHelpers.export(exports, "AiOutlineLoading3Quarters", ()=>AiOutlineLoading3Quarters);
parcelHelpers.export(exports, "AiOutlineLoading", ()=>AiOutlineLoading);
parcelHelpers.export(exports, "AiOutlineLock", ()=>AiOutlineLock);
parcelHelpers.export(exports, "AiOutlineLogin", ()=>AiOutlineLogin);
parcelHelpers.export(exports, "AiOutlineLogout", ()=>AiOutlineLogout);
parcelHelpers.export(exports, "AiOutlineMacCommand", ()=>AiOutlineMacCommand);
parcelHelpers.export(exports, "AiOutlineMail", ()=>AiOutlineMail);
parcelHelpers.export(exports, "AiOutlineMan", ()=>AiOutlineMan);
parcelHelpers.export(exports, "AiOutlineMedicineBox", ()=>AiOutlineMedicineBox);
parcelHelpers.export(exports, "AiOutlineMediumWorkmark", ()=>AiOutlineMediumWorkmark);
parcelHelpers.export(exports, "AiOutlineMedium", ()=>AiOutlineMedium);
parcelHelpers.export(exports, "AiOutlineMeh", ()=>AiOutlineMeh);
parcelHelpers.export(exports, "AiOutlineMenuFold", ()=>AiOutlineMenuFold);
parcelHelpers.export(exports, "AiOutlineMenuUnfold", ()=>AiOutlineMenuUnfold);
parcelHelpers.export(exports, "AiOutlineMenu", ()=>AiOutlineMenu);
parcelHelpers.export(exports, "AiOutlineMergeCells", ()=>AiOutlineMergeCells);
parcelHelpers.export(exports, "AiOutlineMessage", ()=>AiOutlineMessage);
parcelHelpers.export(exports, "AiOutlineMinusCircle", ()=>AiOutlineMinusCircle);
parcelHelpers.export(exports, "AiOutlineMinusSquare", ()=>AiOutlineMinusSquare);
parcelHelpers.export(exports, "AiOutlineMinus", ()=>AiOutlineMinus);
parcelHelpers.export(exports, "AiOutlineMobile", ()=>AiOutlineMobile);
parcelHelpers.export(exports, "AiOutlineMoneyCollect", ()=>AiOutlineMoneyCollect);
parcelHelpers.export(exports, "AiOutlineMonitor", ()=>AiOutlineMonitor);
parcelHelpers.export(exports, "AiOutlineMore", ()=>AiOutlineMore);
parcelHelpers.export(exports, "AiOutlineNodeCollapse", ()=>AiOutlineNodeCollapse);
parcelHelpers.export(exports, "AiOutlineNodeExpand", ()=>AiOutlineNodeExpand);
parcelHelpers.export(exports, "AiOutlineNodeIndex", ()=>AiOutlineNodeIndex);
parcelHelpers.export(exports, "AiOutlineNotification", ()=>AiOutlineNotification);
parcelHelpers.export(exports, "AiOutlineNumber", ()=>AiOutlineNumber);
parcelHelpers.export(exports, "AiOutlineOneToOne", ()=>AiOutlineOneToOne);
parcelHelpers.export(exports, "AiOutlineOrderedList", ()=>AiOutlineOrderedList);
parcelHelpers.export(exports, "AiOutlinePaperClip", ()=>AiOutlinePaperClip);
parcelHelpers.export(exports, "AiOutlinePartition", ()=>AiOutlinePartition);
parcelHelpers.export(exports, "AiOutlinePauseCircle", ()=>AiOutlinePauseCircle);
parcelHelpers.export(exports, "AiOutlinePause", ()=>AiOutlinePause);
parcelHelpers.export(exports, "AiOutlinePayCircle", ()=>AiOutlinePayCircle);
parcelHelpers.export(exports, "AiOutlinePercentage", ()=>AiOutlinePercentage);
parcelHelpers.export(exports, "AiOutlinePhone", ()=>AiOutlinePhone);
parcelHelpers.export(exports, "AiOutlinePicCenter", ()=>AiOutlinePicCenter);
parcelHelpers.export(exports, "AiOutlinePicLeft", ()=>AiOutlinePicLeft);
parcelHelpers.export(exports, "AiOutlinePicRight", ()=>AiOutlinePicRight);
parcelHelpers.export(exports, "AiOutlinePicture", ()=>AiOutlinePicture);
parcelHelpers.export(exports, "AiOutlinePieChart", ()=>AiOutlinePieChart);
parcelHelpers.export(exports, "AiOutlinePlayCircle", ()=>AiOutlinePlayCircle);
parcelHelpers.export(exports, "AiOutlinePlaySquare", ()=>AiOutlinePlaySquare);
parcelHelpers.export(exports, "AiOutlinePlusCircle", ()=>AiOutlinePlusCircle);
parcelHelpers.export(exports, "AiOutlinePlusSquare", ()=>AiOutlinePlusSquare);
parcelHelpers.export(exports, "AiOutlinePlus", ()=>AiOutlinePlus);
parcelHelpers.export(exports, "AiOutlinePoundCircle", ()=>AiOutlinePoundCircle);
parcelHelpers.export(exports, "AiOutlinePound", ()=>AiOutlinePound);
parcelHelpers.export(exports, "AiOutlinePoweroff", ()=>AiOutlinePoweroff);
parcelHelpers.export(exports, "AiOutlinePrinter", ()=>AiOutlinePrinter);
parcelHelpers.export(exports, "AiOutlineProfile", ()=>AiOutlineProfile);
parcelHelpers.export(exports, "AiOutlineProject", ()=>AiOutlineProject);
parcelHelpers.export(exports, "AiOutlinePropertySafety", ()=>AiOutlinePropertySafety);
parcelHelpers.export(exports, "AiOutlinePullRequest", ()=>AiOutlinePullRequest);
parcelHelpers.export(exports, "AiOutlinePushpin", ()=>AiOutlinePushpin);
parcelHelpers.export(exports, "AiOutlineQq", ()=>AiOutlineQq);
parcelHelpers.export(exports, "AiOutlineQrcode", ()=>AiOutlineQrcode);
parcelHelpers.export(exports, "AiOutlineQuestionCircle", ()=>AiOutlineQuestionCircle);
parcelHelpers.export(exports, "AiOutlineQuestion", ()=>AiOutlineQuestion);
parcelHelpers.export(exports, "AiOutlineRadarChart", ()=>AiOutlineRadarChart);
parcelHelpers.export(exports, "AiOutlineRadiusBottomleft", ()=>AiOutlineRadiusBottomleft);
parcelHelpers.export(exports, "AiOutlineRadiusBottomright", ()=>AiOutlineRadiusBottomright);
parcelHelpers.export(exports, "AiOutlineRadiusSetting", ()=>AiOutlineRadiusSetting);
parcelHelpers.export(exports, "AiOutlineRadiusUpleft", ()=>AiOutlineRadiusUpleft);
parcelHelpers.export(exports, "AiOutlineRadiusUpright", ()=>AiOutlineRadiusUpright);
parcelHelpers.export(exports, "AiOutlineRead", ()=>AiOutlineRead);
parcelHelpers.export(exports, "AiOutlineReconciliation", ()=>AiOutlineReconciliation);
parcelHelpers.export(exports, "AiOutlineRedEnvelope", ()=>AiOutlineRedEnvelope);
parcelHelpers.export(exports, "AiOutlineReddit", ()=>AiOutlineReddit);
parcelHelpers.export(exports, "AiOutlineRedo", ()=>AiOutlineRedo);
parcelHelpers.export(exports, "AiOutlineReload", ()=>AiOutlineReload);
parcelHelpers.export(exports, "AiOutlineRest", ()=>AiOutlineRest);
parcelHelpers.export(exports, "AiOutlineRetweet", ()=>AiOutlineRetweet);
parcelHelpers.export(exports, "AiOutlineRightCircle", ()=>AiOutlineRightCircle);
parcelHelpers.export(exports, "AiOutlineRightSquare", ()=>AiOutlineRightSquare);
parcelHelpers.export(exports, "AiOutlineRight", ()=>AiOutlineRight);
parcelHelpers.export(exports, "AiOutlineRise", ()=>AiOutlineRise);
parcelHelpers.export(exports, "AiOutlineRobot", ()=>AiOutlineRobot);
parcelHelpers.export(exports, "AiOutlineRocket", ()=>AiOutlineRocket);
parcelHelpers.export(exports, "AiOutlineRollback", ()=>AiOutlineRollback);
parcelHelpers.export(exports, "AiOutlineRotateLeft", ()=>AiOutlineRotateLeft);
parcelHelpers.export(exports, "AiOutlineRotateRight", ()=>AiOutlineRotateRight);
parcelHelpers.export(exports, "AiOutlineSafetyCertificate", ()=>AiOutlineSafetyCertificate);
parcelHelpers.export(exports, "AiOutlineSafety", ()=>AiOutlineSafety);
parcelHelpers.export(exports, "AiOutlineSave", ()=>AiOutlineSave);
parcelHelpers.export(exports, "AiOutlineScan", ()=>AiOutlineScan);
parcelHelpers.export(exports, "AiOutlineSchedule", ()=>AiOutlineSchedule);
parcelHelpers.export(exports, "AiOutlineScissor", ()=>AiOutlineScissor);
parcelHelpers.export(exports, "AiOutlineSearch", ()=>AiOutlineSearch);
parcelHelpers.export(exports, "AiOutlineSecurityScan", ()=>AiOutlineSecurityScan);
parcelHelpers.export(exports, "AiOutlineSelect", ()=>AiOutlineSelect);
parcelHelpers.export(exports, "AiOutlineSend", ()=>AiOutlineSend);
parcelHelpers.export(exports, "AiOutlineSetting", ()=>AiOutlineSetting);
parcelHelpers.export(exports, "AiOutlineShake", ()=>AiOutlineShake);
parcelHelpers.export(exports, "AiOutlineShareAlt", ()=>AiOutlineShareAlt);
parcelHelpers.export(exports, "AiOutlineShop", ()=>AiOutlineShop);
parcelHelpers.export(exports, "AiOutlineShoppingCart", ()=>AiOutlineShoppingCart);
parcelHelpers.export(exports, "AiOutlineShopping", ()=>AiOutlineShopping);
parcelHelpers.export(exports, "AiOutlineShrink", ()=>AiOutlineShrink);
parcelHelpers.export(exports, "AiOutlineSisternode", ()=>AiOutlineSisternode);
parcelHelpers.export(exports, "AiOutlineSketch", ()=>AiOutlineSketch);
parcelHelpers.export(exports, "AiOutlineSkin", ()=>AiOutlineSkin);
parcelHelpers.export(exports, "AiOutlineSkype", ()=>AiOutlineSkype);
parcelHelpers.export(exports, "AiOutlineSlackSquare", ()=>AiOutlineSlackSquare);
parcelHelpers.export(exports, "AiOutlineSlack", ()=>AiOutlineSlack);
parcelHelpers.export(exports, "AiOutlineSliders", ()=>AiOutlineSliders);
parcelHelpers.export(exports, "AiOutlineSmallDash", ()=>AiOutlineSmallDash);
parcelHelpers.export(exports, "AiOutlineSmile", ()=>AiOutlineSmile);
parcelHelpers.export(exports, "AiOutlineSnippets", ()=>AiOutlineSnippets);
parcelHelpers.export(exports, "AiOutlineSolution", ()=>AiOutlineSolution);
parcelHelpers.export(exports, "AiOutlineSortAscending", ()=>AiOutlineSortAscending);
parcelHelpers.export(exports, "AiOutlineSortDescending", ()=>AiOutlineSortDescending);
parcelHelpers.export(exports, "AiOutlineSound", ()=>AiOutlineSound);
parcelHelpers.export(exports, "AiOutlineSplitCells", ()=>AiOutlineSplitCells);
parcelHelpers.export(exports, "AiOutlineStar", ()=>AiOutlineStar);
parcelHelpers.export(exports, "AiOutlineStepBackward", ()=>AiOutlineStepBackward);
parcelHelpers.export(exports, "AiOutlineStepForward", ()=>AiOutlineStepForward);
parcelHelpers.export(exports, "AiOutlineStock", ()=>AiOutlineStock);
parcelHelpers.export(exports, "AiOutlineStop", ()=>AiOutlineStop);
parcelHelpers.export(exports, "AiOutlineStrikethrough", ()=>AiOutlineStrikethrough);
parcelHelpers.export(exports, "AiOutlineSubnode", ()=>AiOutlineSubnode);
parcelHelpers.export(exports, "AiOutlineSwapLeft", ()=>AiOutlineSwapLeft);
parcelHelpers.export(exports, "AiOutlineSwapRight", ()=>AiOutlineSwapRight);
parcelHelpers.export(exports, "AiOutlineSwap", ()=>AiOutlineSwap);
parcelHelpers.export(exports, "AiOutlineSwitcher", ()=>AiOutlineSwitcher);
parcelHelpers.export(exports, "AiOutlineSync", ()=>AiOutlineSync);
parcelHelpers.export(exports, "AiOutlineTable", ()=>AiOutlineTable);
parcelHelpers.export(exports, "AiOutlineTablet", ()=>AiOutlineTablet);
parcelHelpers.export(exports, "AiOutlineTag", ()=>AiOutlineTag);
parcelHelpers.export(exports, "AiOutlineTags", ()=>AiOutlineTags);
parcelHelpers.export(exports, "AiOutlineTaobaoCircle", ()=>AiOutlineTaobaoCircle);
parcelHelpers.export(exports, "AiOutlineTaobao", ()=>AiOutlineTaobao);
parcelHelpers.export(exports, "AiOutlineTeam", ()=>AiOutlineTeam);
parcelHelpers.export(exports, "AiOutlineThunderbolt", ()=>AiOutlineThunderbolt);
parcelHelpers.export(exports, "AiOutlineToTop", ()=>AiOutlineToTop);
parcelHelpers.export(exports, "AiOutlineTool", ()=>AiOutlineTool);
parcelHelpers.export(exports, "AiOutlineTrademarkCircle", ()=>AiOutlineTrademarkCircle);
parcelHelpers.export(exports, "AiOutlineTrademark", ()=>AiOutlineTrademark);
parcelHelpers.export(exports, "AiOutlineTransaction", ()=>AiOutlineTransaction);
parcelHelpers.export(exports, "AiOutlineTranslation", ()=>AiOutlineTranslation);
parcelHelpers.export(exports, "AiOutlineTrophy", ()=>AiOutlineTrophy);
parcelHelpers.export(exports, "AiOutlineTwitter", ()=>AiOutlineTwitter);
parcelHelpers.export(exports, "AiOutlineUnderline", ()=>AiOutlineUnderline);
parcelHelpers.export(exports, "AiOutlineUndo", ()=>AiOutlineUndo);
parcelHelpers.export(exports, "AiOutlineUngroup", ()=>AiOutlineUngroup);
parcelHelpers.export(exports, "AiOutlineUnlock", ()=>AiOutlineUnlock);
parcelHelpers.export(exports, "AiOutlineUnorderedList", ()=>AiOutlineUnorderedList);
parcelHelpers.export(exports, "AiOutlineUpCircle", ()=>AiOutlineUpCircle);
parcelHelpers.export(exports, "AiOutlineUpSquare", ()=>AiOutlineUpSquare);
parcelHelpers.export(exports, "AiOutlineUp", ()=>AiOutlineUp);
parcelHelpers.export(exports, "AiOutlineUpload", ()=>AiOutlineUpload);
parcelHelpers.export(exports, "AiOutlineUsb", ()=>AiOutlineUsb);
parcelHelpers.export(exports, "AiOutlineUserAdd", ()=>AiOutlineUserAdd);
parcelHelpers.export(exports, "AiOutlineUserDelete", ()=>AiOutlineUserDelete);
parcelHelpers.export(exports, "AiOutlineUserSwitch", ()=>AiOutlineUserSwitch);
parcelHelpers.export(exports, "AiOutlineUser", ()=>AiOutlineUser);
parcelHelpers.export(exports, "AiOutlineUsergroupAdd", ()=>AiOutlineUsergroupAdd);
parcelHelpers.export(exports, "AiOutlineUsergroupDelete", ()=>AiOutlineUsergroupDelete);
parcelHelpers.export(exports, "AiOutlineVerified", ()=>AiOutlineVerified);
parcelHelpers.export(exports, "AiOutlineVerticalAlignBottom", ()=>AiOutlineVerticalAlignBottom);
parcelHelpers.export(exports, "AiOutlineVerticalAlignMiddle", ()=>AiOutlineVerticalAlignMiddle);
parcelHelpers.export(exports, "AiOutlineVerticalAlignTop", ()=>AiOutlineVerticalAlignTop);
parcelHelpers.export(exports, "AiOutlineVerticalLeft", ()=>AiOutlineVerticalLeft);
parcelHelpers.export(exports, "AiOutlineVerticalRight", ()=>AiOutlineVerticalRight);
parcelHelpers.export(exports, "AiOutlineVideoCameraAdd", ()=>AiOutlineVideoCameraAdd);
parcelHelpers.export(exports, "AiOutlineVideoCamera", ()=>AiOutlineVideoCamera);
parcelHelpers.export(exports, "AiOutlineWallet", ()=>AiOutlineWallet);
parcelHelpers.export(exports, "AiOutlineWarning", ()=>AiOutlineWarning);
parcelHelpers.export(exports, "AiOutlineWechat", ()=>AiOutlineWechat);
parcelHelpers.export(exports, "AiOutlineWeiboCircle", ()=>AiOutlineWeiboCircle);
parcelHelpers.export(exports, "AiOutlineWeiboSquare", ()=>AiOutlineWeiboSquare);
parcelHelpers.export(exports, "AiOutlineWeibo", ()=>AiOutlineWeibo);
parcelHelpers.export(exports, "AiOutlineWhatsApp", ()=>AiOutlineWhatsApp);
parcelHelpers.export(exports, "AiOutlineWifi", ()=>AiOutlineWifi);
parcelHelpers.export(exports, "AiOutlineWindows", ()=>AiOutlineWindows);
parcelHelpers.export(exports, "AiOutlineWoman", ()=>AiOutlineWoman);
parcelHelpers.export(exports, "AiOutlineYahoo", ()=>AiOutlineYahoo);
parcelHelpers.export(exports, "AiOutlineYoutube", ()=>AiOutlineYoutube);
parcelHelpers.export(exports, "AiOutlineYuque", ()=>AiOutlineYuque);
parcelHelpers.export(exports, "AiOutlineZhihu", ()=>AiOutlineZhihu);
parcelHelpers.export(exports, "AiOutlineZoomIn", ()=>AiOutlineZoomIn);
parcelHelpers.export(exports, "AiOutlineZoomOut", ()=>AiOutlineZoomOut);
parcelHelpers.export(exports, "AiTwotoneAccountBook", ()=>AiTwotoneAccountBook);
parcelHelpers.export(exports, "AiTwotoneAlert", ()=>AiTwotoneAlert);
parcelHelpers.export(exports, "AiTwotoneApi", ()=>AiTwotoneApi);
parcelHelpers.export(exports, "AiTwotoneAppstore", ()=>AiTwotoneAppstore);
parcelHelpers.export(exports, "AiTwotoneAudio", ()=>AiTwotoneAudio);
parcelHelpers.export(exports, "AiTwotoneBank", ()=>AiTwotoneBank);
parcelHelpers.export(exports, "AiTwotoneBell", ()=>AiTwotoneBell);
parcelHelpers.export(exports, "AiTwotoneBook", ()=>AiTwotoneBook);
parcelHelpers.export(exports, "AiTwotoneBoxPlot", ()=>AiTwotoneBoxPlot);
parcelHelpers.export(exports, "AiTwotoneBug", ()=>AiTwotoneBug);
parcelHelpers.export(exports, "AiTwotoneBuild", ()=>AiTwotoneBuild);
parcelHelpers.export(exports, "AiTwotoneBulb", ()=>AiTwotoneBulb);
parcelHelpers.export(exports, "AiTwotoneCalculator", ()=>AiTwotoneCalculator);
parcelHelpers.export(exports, "AiTwotoneCalendar", ()=>AiTwotoneCalendar);
parcelHelpers.export(exports, "AiTwotoneCamera", ()=>AiTwotoneCamera);
parcelHelpers.export(exports, "AiTwotoneCar", ()=>AiTwotoneCar);
parcelHelpers.export(exports, "AiTwotoneCarryOut", ()=>AiTwotoneCarryOut);
parcelHelpers.export(exports, "AiTwotoneCheckCircle", ()=>AiTwotoneCheckCircle);
parcelHelpers.export(exports, "AiTwotoneCheckSquare", ()=>AiTwotoneCheckSquare);
parcelHelpers.export(exports, "AiTwotoneCiCircle", ()=>AiTwotoneCiCircle);
parcelHelpers.export(exports, "AiTwotoneCi", ()=>AiTwotoneCi);
parcelHelpers.export(exports, "AiTwotoneClockCircle", ()=>AiTwotoneClockCircle);
parcelHelpers.export(exports, "AiTwotoneCloseCircle", ()=>AiTwotoneCloseCircle);
parcelHelpers.export(exports, "AiTwotoneCloseSquare", ()=>AiTwotoneCloseSquare);
parcelHelpers.export(exports, "AiTwotoneCloud", ()=>AiTwotoneCloud);
parcelHelpers.export(exports, "AiTwotoneCode", ()=>AiTwotoneCode);
parcelHelpers.export(exports, "AiTwotoneCompass", ()=>AiTwotoneCompass);
parcelHelpers.export(exports, "AiTwotoneContacts", ()=>AiTwotoneContacts);
parcelHelpers.export(exports, "AiTwotoneContainer", ()=>AiTwotoneContainer);
parcelHelpers.export(exports, "AiTwotoneControl", ()=>AiTwotoneControl);
parcelHelpers.export(exports, "AiTwotoneCopy", ()=>AiTwotoneCopy);
parcelHelpers.export(exports, "AiTwotoneCopyrightCircle", ()=>AiTwotoneCopyrightCircle);
parcelHelpers.export(exports, "AiTwotoneCopyright", ()=>AiTwotoneCopyright);
parcelHelpers.export(exports, "AiTwotoneCreditCard", ()=>AiTwotoneCreditCard);
parcelHelpers.export(exports, "AiTwotoneCrown", ()=>AiTwotoneCrown);
parcelHelpers.export(exports, "AiTwotoneCustomerService", ()=>AiTwotoneCustomerService);
parcelHelpers.export(exports, "AiTwotoneDashboard", ()=>AiTwotoneDashboard);
parcelHelpers.export(exports, "AiTwotoneDatabase", ()=>AiTwotoneDatabase);
parcelHelpers.export(exports, "AiTwotoneDelete", ()=>AiTwotoneDelete);
parcelHelpers.export(exports, "AiTwotoneDiff", ()=>AiTwotoneDiff);
parcelHelpers.export(exports, "AiTwotoneDislike", ()=>AiTwotoneDislike);
parcelHelpers.export(exports, "AiTwotoneDollarCircle", ()=>AiTwotoneDollarCircle);
parcelHelpers.export(exports, "AiTwotoneDollar", ()=>AiTwotoneDollar);
parcelHelpers.export(exports, "AiTwotoneDownCircle", ()=>AiTwotoneDownCircle);
parcelHelpers.export(exports, "AiTwotoneDownSquare", ()=>AiTwotoneDownSquare);
parcelHelpers.export(exports, "AiTwotoneEdit", ()=>AiTwotoneEdit);
parcelHelpers.export(exports, "AiTwotoneEnvironment", ()=>AiTwotoneEnvironment);
parcelHelpers.export(exports, "AiTwotoneEuroCircle", ()=>AiTwotoneEuroCircle);
parcelHelpers.export(exports, "AiTwotoneEuro", ()=>AiTwotoneEuro);
parcelHelpers.export(exports, "AiTwotoneExclamationCircle", ()=>AiTwotoneExclamationCircle);
parcelHelpers.export(exports, "AiTwotoneExperiment", ()=>AiTwotoneExperiment);
parcelHelpers.export(exports, "AiTwotoneEyeInvisible", ()=>AiTwotoneEyeInvisible);
parcelHelpers.export(exports, "AiTwotoneEye", ()=>AiTwotoneEye);
parcelHelpers.export(exports, "AiTwotoneFileAdd", ()=>AiTwotoneFileAdd);
parcelHelpers.export(exports, "AiTwotoneFileExcel", ()=>AiTwotoneFileExcel);
parcelHelpers.export(exports, "AiTwotoneFileExclamation", ()=>AiTwotoneFileExclamation);
parcelHelpers.export(exports, "AiTwotoneFileImage", ()=>AiTwotoneFileImage);
parcelHelpers.export(exports, "AiTwotoneFileMarkdown", ()=>AiTwotoneFileMarkdown);
parcelHelpers.export(exports, "AiTwotoneFilePdf", ()=>AiTwotoneFilePdf);
parcelHelpers.export(exports, "AiTwotoneFilePpt", ()=>AiTwotoneFilePpt);
parcelHelpers.export(exports, "AiTwotoneFileText", ()=>AiTwotoneFileText);
parcelHelpers.export(exports, "AiTwotoneFileUnknown", ()=>AiTwotoneFileUnknown);
parcelHelpers.export(exports, "AiTwotoneFileWord", ()=>AiTwotoneFileWord);
parcelHelpers.export(exports, "AiTwotoneFileZip", ()=>AiTwotoneFileZip);
parcelHelpers.export(exports, "AiTwotoneFile", ()=>AiTwotoneFile);
parcelHelpers.export(exports, "AiTwotoneFilter", ()=>AiTwotoneFilter);
parcelHelpers.export(exports, "AiTwotoneFire", ()=>AiTwotoneFire);
parcelHelpers.export(exports, "AiTwotoneFlag", ()=>AiTwotoneFlag);
parcelHelpers.export(exports, "AiTwotoneFolderAdd", ()=>AiTwotoneFolderAdd);
parcelHelpers.export(exports, "AiTwotoneFolderOpen", ()=>AiTwotoneFolderOpen);
parcelHelpers.export(exports, "AiTwotoneFolder", ()=>AiTwotoneFolder);
parcelHelpers.export(exports, "AiTwotoneFrown", ()=>AiTwotoneFrown);
parcelHelpers.export(exports, "AiTwotoneFund", ()=>AiTwotoneFund);
parcelHelpers.export(exports, "AiTwotoneFunnelPlot", ()=>AiTwotoneFunnelPlot);
parcelHelpers.export(exports, "AiTwotoneGift", ()=>AiTwotoneGift);
parcelHelpers.export(exports, "AiTwotoneGold", ()=>AiTwotoneGold);
parcelHelpers.export(exports, "AiTwotoneHdd", ()=>AiTwotoneHdd);
parcelHelpers.export(exports, "AiTwotoneHeart", ()=>AiTwotoneHeart);
parcelHelpers.export(exports, "AiTwotoneHighlight", ()=>AiTwotoneHighlight);
parcelHelpers.export(exports, "AiTwotoneHome", ()=>AiTwotoneHome);
parcelHelpers.export(exports, "AiTwotoneHourglass", ()=>AiTwotoneHourglass);
parcelHelpers.export(exports, "AiTwotoneHtml5", ()=>AiTwotoneHtml5);
parcelHelpers.export(exports, "AiTwotoneIdcard", ()=>AiTwotoneIdcard);
parcelHelpers.export(exports, "AiTwotoneInfoCircle", ()=>AiTwotoneInfoCircle);
parcelHelpers.export(exports, "AiTwotoneInsurance", ()=>AiTwotoneInsurance);
parcelHelpers.export(exports, "AiTwotoneInteraction", ()=>AiTwotoneInteraction);
parcelHelpers.export(exports, "AiTwotoneLayout", ()=>AiTwotoneLayout);
parcelHelpers.export(exports, "AiTwotoneLeftCircle", ()=>AiTwotoneLeftCircle);
parcelHelpers.export(exports, "AiTwotoneLeftSquare", ()=>AiTwotoneLeftSquare);
parcelHelpers.export(exports, "AiTwotoneLike", ()=>AiTwotoneLike);
parcelHelpers.export(exports, "AiTwotoneLock", ()=>AiTwotoneLock);
parcelHelpers.export(exports, "AiTwotoneMail", ()=>AiTwotoneMail);
parcelHelpers.export(exports, "AiTwotoneMedicineBox", ()=>AiTwotoneMedicineBox);
parcelHelpers.export(exports, "AiTwotoneMeh", ()=>AiTwotoneMeh);
parcelHelpers.export(exports, "AiTwotoneMessage", ()=>AiTwotoneMessage);
parcelHelpers.export(exports, "AiTwotoneMinusCircle", ()=>AiTwotoneMinusCircle);
parcelHelpers.export(exports, "AiTwotoneMinusSquare", ()=>AiTwotoneMinusSquare);
parcelHelpers.export(exports, "AiTwotoneMobile", ()=>AiTwotoneMobile);
parcelHelpers.export(exports, "AiTwotoneMoneyCollect", ()=>AiTwotoneMoneyCollect);
parcelHelpers.export(exports, "AiTwotoneNotification", ()=>AiTwotoneNotification);
parcelHelpers.export(exports, "AiTwotonePauseCircle", ()=>AiTwotonePauseCircle);
parcelHelpers.export(exports, "AiTwotonePhone", ()=>AiTwotonePhone);
parcelHelpers.export(exports, "AiTwotonePicture", ()=>AiTwotonePicture);
parcelHelpers.export(exports, "AiTwotonePieChart", ()=>AiTwotonePieChart);
parcelHelpers.export(exports, "AiTwotonePlayCircle", ()=>AiTwotonePlayCircle);
parcelHelpers.export(exports, "AiTwotonePlaySquare", ()=>AiTwotonePlaySquare);
parcelHelpers.export(exports, "AiTwotonePlusCircle", ()=>AiTwotonePlusCircle);
parcelHelpers.export(exports, "AiTwotonePlusSquare", ()=>AiTwotonePlusSquare);
parcelHelpers.export(exports, "AiTwotonePoundCircle", ()=>AiTwotonePoundCircle);
parcelHelpers.export(exports, "AiTwotonePrinter", ()=>AiTwotonePrinter);
parcelHelpers.export(exports, "AiTwotoneProfile", ()=>AiTwotoneProfile);
parcelHelpers.export(exports, "AiTwotoneProject", ()=>AiTwotoneProject);
parcelHelpers.export(exports, "AiTwotonePropertySafety", ()=>AiTwotonePropertySafety);
parcelHelpers.export(exports, "AiTwotonePushpin", ()=>AiTwotonePushpin);
parcelHelpers.export(exports, "AiTwotoneQuestionCircle", ()=>AiTwotoneQuestionCircle);
parcelHelpers.export(exports, "AiTwotoneReconciliation", ()=>AiTwotoneReconciliation);
parcelHelpers.export(exports, "AiTwotoneRedEnvelope", ()=>AiTwotoneRedEnvelope);
parcelHelpers.export(exports, "AiTwotoneRest", ()=>AiTwotoneRest);
parcelHelpers.export(exports, "AiTwotoneRightCircle", ()=>AiTwotoneRightCircle);
parcelHelpers.export(exports, "AiTwotoneRightSquare", ()=>AiTwotoneRightSquare);
parcelHelpers.export(exports, "AiTwotoneRocket", ()=>AiTwotoneRocket);
parcelHelpers.export(exports, "AiTwotoneSafetyCertificate", ()=>AiTwotoneSafetyCertificate);
parcelHelpers.export(exports, "AiTwotoneSave", ()=>AiTwotoneSave);
parcelHelpers.export(exports, "AiTwotoneSchedule", ()=>AiTwotoneSchedule);
parcelHelpers.export(exports, "AiTwotoneSecurityScan", ()=>AiTwotoneSecurityScan);
parcelHelpers.export(exports, "AiTwotoneSetting", ()=>AiTwotoneSetting);
parcelHelpers.export(exports, "AiTwotoneShop", ()=>AiTwotoneShop);
parcelHelpers.export(exports, "AiTwotoneShopping", ()=>AiTwotoneShopping);
parcelHelpers.export(exports, "AiTwotoneSkin", ()=>AiTwotoneSkin);
parcelHelpers.export(exports, "AiTwotoneSliders", ()=>AiTwotoneSliders);
parcelHelpers.export(exports, "AiTwotoneSmile", ()=>AiTwotoneSmile);
parcelHelpers.export(exports, "AiTwotoneSnippets", ()=>AiTwotoneSnippets);
parcelHelpers.export(exports, "AiTwotoneSound", ()=>AiTwotoneSound);
parcelHelpers.export(exports, "AiTwotoneStar", ()=>AiTwotoneStar);
parcelHelpers.export(exports, "AiTwotoneStop", ()=>AiTwotoneStop);
parcelHelpers.export(exports, "AiTwotoneSwitcher", ()=>AiTwotoneSwitcher);
parcelHelpers.export(exports, "AiTwotoneTablet", ()=>AiTwotoneTablet);
parcelHelpers.export(exports, "AiTwotoneTag", ()=>AiTwotoneTag);
parcelHelpers.export(exports, "AiTwotoneTags", ()=>AiTwotoneTags);
parcelHelpers.export(exports, "AiTwotoneThunderbolt", ()=>AiTwotoneThunderbolt);
parcelHelpers.export(exports, "AiTwotoneTool", ()=>AiTwotoneTool);
parcelHelpers.export(exports, "AiTwotoneTrademarkCircle", ()=>AiTwotoneTrademarkCircle);
parcelHelpers.export(exports, "AiTwotoneTrophy", ()=>AiTwotoneTrophy);
parcelHelpers.export(exports, "AiTwotoneUnlock", ()=>AiTwotoneUnlock);
parcelHelpers.export(exports, "AiTwotoneUpCircle", ()=>AiTwotoneUpCircle);
parcelHelpers.export(exports, "AiTwotoneUpSquare", ()=>AiTwotoneUpSquare);
parcelHelpers.export(exports, "AiTwotoneUsb", ()=>AiTwotoneUsb);
parcelHelpers.export(exports, "AiTwotoneVideoCamera", ()=>AiTwotoneVideoCamera);
parcelHelpers.export(exports, "AiTwotoneWallet", ()=>AiTwotoneWallet);
parcelHelpers.export(exports, "AiTwotoneWarning", ()=>AiTwotoneWarning);
var _lib = require("../lib");
function AiFillAccountBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zM648.3 426.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V752c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3 73.2-144.3a10 10 0 0 1 8.9-5.5h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8z"
                }
            }
        ]
    })(props);
}
function AiFillAlert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 244c176.18 0 319 142.82 319 319v233a32 32 0 0 1-32 32H225a32 32 0 0 1-32-32V563c0-176.18 142.82-319 319-319zM484 68h56a8 8 0 0 1 8 8v96a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8V76a8 8 0 0 1 8-8zM177.25 191.66a8 8 0 0 1 11.32 0l67.88 67.88a8 8 0 0 1 0 11.31l-39.6 39.6a8 8 0 0 1-11.31 0l-67.88-67.88a8 8 0 0 1 0-11.31l39.6-39.6zm669.6 0l39.6 39.6a8 8 0 0 1 0 11.3l-67.88 67.9a8 8 0 0 1-11.32 0l-39.6-39.6a8 8 0 0 1 0-11.32l67.89-67.88a8 8 0 0 1 11.31 0zM192 892h640a32 32 0 0 1 32 32v24a8 8 0 0 1-8 8H168a8 8 0 0 1-8-8v-24a32 32 0 0 1 32-32zm148-317v253h64V575h-64z"
                }
            }
        ]
    })(props);
}
function AiFillAlipayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zm460.5 67c100.1 33.4 154.7 43 166.7 44.8A445.9 445.9 0 0 0 960 512c0-247.4-200.6-448-448-448S64 264.6 64 512s200.6 448 448 448c155.9 0 293.2-79.7 373.5-200.5-75.6-29.8-213.6-85-286.8-120.1-69.9 85.7-160.1 137.8-253.7 137.8-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9z"
                }
            }
        ]
    })(props);
}
function AiFillAlipaySquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm29.4 663.2S703 689.4 598.7 639.5C528.8 725.2 438.6 777.3 345 777.3c-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9 114.3 38.2 140.2 40.2 140.2 40.2v122.3z"
                }
            }
        ]
    })(props);
}
function AiFillAliwangwang(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M868.2 377.4c-18.9-45.1-46.3-85.6-81.2-120.6a377.26 377.26 0 0 0-120.5-81.2A375.65 375.65 0 0 0 519 145.8c-41.9 0-82.9 6.7-121.9 20C306 123.3 200.8 120 170.6 120c-2.2 0-7.4 0-9.4.2-11.9.4-22.8 6.5-29.2 16.4-6.5 9.9-7.7 22.4-3.4 33.5l64.3 161.6a378.59 378.59 0 0 0-52.8 193.2c0 51.4 10 101 29.8 147.6 18.9 45 46.2 85.6 81.2 120.5 34.7 34.8 75.4 62.1 120.5 81.2C418.3 894 467.9 904 519 904c51.3 0 100.9-10 147.7-29.8 44.9-18.9 85.5-46.3 120.4-81.2 34.7-34.8 62.1-75.4 81.2-120.6a376.5 376.5 0 0 0 29.8-147.6c-.2-51.2-10.1-100.8-29.9-147.4zm-325.2 79c0 20.4-16.6 37.1-37.1 37.1-20.4 0-37.1-16.7-37.1-37.1v-55.1c0-20.4 16.6-37.1 37.1-37.1 20.4 0 37.1 16.6 37.1 37.1v55.1zm175.2 0c0 20.4-16.6 37.1-37.1 37.1S644 476.8 644 456.4v-55.1c0-20.4 16.7-37.1 37.1-37.1 20.4 0 37.1 16.6 37.1 37.1v55.1z"
                }
            }
        ]
    })(props);
}
function AiFillAmazonCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M485 467.5c-11.6 4.9-20.9 12.2-27.8 22-6.9 9.8-10.4 21.6-10.4 35.5 0 17.8 7.5 31.5 22.4 41.2 14.1 9.1 28.9 11.4 44.4 6.8 17.9-5.2 30-17.9 36.4-38.1 3-9.3 4.5-19.7 4.5-31.3v-50.2c-12.6.4-24.4 1.6-35.5 3.7-11.1 2.1-22.4 5.6-34 10.4zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm35.8 262.7c-7.2-10.9-20.1-16.4-38.7-16.4-1.3 0-3 .1-5.3.3-2.2.2-6.6 1.5-12.9 3.7a79.4 79.4 0 0 0-17.9 9.1c-5.5 3.8-11.5 10-18 18.4-6.4 8.5-11.5 18.4-15.3 29.8l-94-8.4c0-12.4 2.4-24.7 7-36.9 4.7-12.2 11.8-23.9 21.4-35 9.6-11.2 21.1-21 34.5-29.4 13.4-8.5 29.6-15.2 48.4-20.3 18.9-5.1 39.1-7.6 60.9-7.6 21.3 0 40.6 2.6 57.8 7.7 17.2 5.2 31.1 11.5 41.4 19.1a117 117 0 0 1 25.9 25.7c6.9 9.6 11.7 18.5 14.4 26.7 2.7 8.2 4 15.7 4 22.8v182.5c0 6.4 1.4 13 4.3 19.8 2.9 6.8 6.3 12.8 10.2 18 3.9 5.2 7.9 9.9 12 14.3 4.1 4.3 7.6 7.7 10.6 9.9l4.1 3.4-72.5 69.4c-8.5-7.7-16.9-15.4-25.2-23.4-8.3-8-14.5-14-18.5-18.1l-6.1-6.2c-2.4-2.3-5-5.7-8-10.2-8.1 12.2-18.5 22.8-31.1 31.8-12.7 9-26.3 15.6-40.7 19.7-14.5 4.1-29.4 6.5-44.7 7.1-15.3.6-30-1.5-43.9-6.5-13.9-5-26.5-11.7-37.6-20.3-11.1-8.6-19.9-20.2-26.5-35-6.6-14.8-9.9-31.5-9.9-50.4 0-17.4 3-33.3 8.9-47.7 6-14.5 13.6-26.5 23-36.1 9.4-9.6 20.7-18.2 34-25.7s26.4-13.4 39.2-17.7c12.8-4.2 26.6-7.8 41.5-10.7 14.9-2.9 27.6-4.8 38.2-5.7 10.6-.9 21.2-1.6 31.8-2v-39.4c0-13.5-2.3-23.5-6.7-30.1zm180.5 379.6c-2.8 3.3-7.5 7.8-14.1 13.5s-16.8 12.7-30.5 21.1c-13.7 8.4-28.8 16-45 22.9-16.3 6.9-36.3 12.9-60.1 18-23.7 5.1-48.2 7.6-73.3 7.6-25.4 0-50.7-3.2-76.1-9.6-25.4-6.4-47.6-14.3-66.8-23.7-19.1-9.4-37.6-20.2-55.1-32.2-17.6-12.1-31.7-22.9-42.4-32.5-10.6-9.6-19.6-18.7-26.8-27.1-1.7-1.9-2.8-3.6-3.2-5.1-.4-1.5-.3-2.8.3-3.7.6-.9 1.5-1.6 2.6-2.2a7.42 7.42 0 0 1 7.4.8c40.9 24.2 72.9 41.3 95.9 51.4 82.9 36.4 168 45.7 255.3 27.9 40.5-8.3 82.1-22.2 124.9-41.8 3.2-1.2 6-1.5 8.3-.9 2.3.6 3.5 2.4 3.5 5.4 0 2.8-1.6 6.3-4.8 10.2zm59.9-29c-1.8 11.1-4.9 21.6-9.1 31.8-7.2 17.1-16.3 30-27.1 38.4-3.6 2.9-6.4 3.8-8.3 2.8-1.9-1-1.9-3.5 0-7.4 4.5-9.3 9.2-21.8 14.2-37.7 5-15.8 5.7-26 2.1-30.5-1.1-1.5-2.7-2.6-5-3.6-2.2-.9-5.1-1.5-8.6-1.9s-6.7-.6-9.4-.8c-2.8-.2-6.5-.2-11.2 0-4.7.2-8 .4-10.1.6a874.4 874.4 0 0 1-17.1 1.5c-1.3.2-2.7.4-4.1.5-1.5.1-2.7.2-3.5.3l-2.7.3c-1 .1-1.7.2-2.2.2h-3.2l-1-.2-.6-.5-.5-.9c-1.3-3.3 3.7-7.4 15-12.4s22.3-8.1 32.9-9.3c9.8-1.5 21.3-1.5 34.5-.3s21.3 3.7 24.3 7.4c2.3 3.5 2.5 10.7.7 21.7z"
                }
            }
        ]
    })(props);
}
function AiFillAmazonSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM547.8 326.7c-7.2-10.9-20.1-16.4-38.7-16.4-1.3 0-3 .1-5.3.3-2.2.2-6.6 1.5-12.9 3.7a79.4 79.4 0 0 0-17.9 9.1c-5.5 3.8-11.5 10-18 18.4-6.4 8.5-11.5 18.4-15.3 29.8l-94-8.4c0-12.4 2.4-24.7 7-36.9s11.8-23.9 21.4-35c9.6-11.2 21.1-21 34.5-29.4 13.4-8.5 29.6-15.2 48.4-20.3 18.9-5.1 39.1-7.6 60.9-7.6 21.3 0 40.6 2.6 57.8 7.7 17.2 5.2 31.1 11.5 41.4 19.1a117 117 0 0 1 25.9 25.7c6.9 9.6 11.7 18.5 14.4 26.7 2.7 8.2 4 15.7 4 22.8v182.5c0 6.4 1.4 13 4.3 19.8 2.9 6.8 6.3 12.8 10.2 18 3.9 5.2 7.9 9.9 12 14.3 4.1 4.3 7.6 7.7 10.6 9.9l4.1 3.4-72.5 69.4c-8.5-7.7-16.9-15.4-25.2-23.4-8.3-8-14.5-14-18.5-18.1l-6.1-6.2c-2.4-2.3-5-5.7-8-10.2-8.1 12.2-18.5 22.8-31.1 31.8-12.7 9-26.3 15.6-40.7 19.7-14.5 4.1-29.4 6.5-44.7 7.1-15.3.6-30-1.5-43.9-6.5-13.9-5-26.5-11.7-37.6-20.3-11.1-8.6-19.9-20.2-26.5-35-6.6-14.8-9.9-31.5-9.9-50.4 0-17.4 3-33.3 8.9-47.7 6-14.5 13.6-26.5 23-36.1 9.4-9.6 20.7-18.2 34-25.7s26.4-13.4 39.2-17.7c12.8-4.2 26.6-7.8 41.5-10.7 14.9-2.9 27.6-4.8 38.2-5.7 10.6-.9 21.2-1.6 31.8-2v-39.4c0-13.5-2.3-23.5-6.7-30.1zm180.5 379.6c-2.8 3.3-7.5 7.8-14.1 13.5s-16.8 12.7-30.5 21.1c-13.7 8.4-28.8 16-45 22.9-16.3 6.9-36.3 12.9-60.1 18-23.7 5.1-48.2 7.6-73.3 7.6-25.4 0-50.7-3.2-76.1-9.6-25.4-6.4-47.6-14.3-66.8-23.7-19.1-9.4-37.6-20.2-55.1-32.2-17.6-12.1-31.7-22.9-42.4-32.5-10.6-9.6-19.6-18.7-26.8-27.1-1.7-1.9-2.8-3.6-3.2-5.1-.4-1.5-.3-2.8.3-3.7.6-.9 1.5-1.6 2.6-2.2a7.42 7.42 0 0 1 7.4.8c40.9 24.2 72.9 41.3 95.9 51.4 82.9 36.4 168 45.7 255.3 27.9 40.5-8.3 82.1-22.2 124.9-41.8 3.2-1.2 6-1.5 8.3-.9 2.3.6 3.5 2.4 3.5 5.4 0 2.8-1.6 6.3-4.8 10.2zm59.9-29c-1.8 11.1-4.9 21.6-9.1 31.8-7.2 17.1-16.3 30-27.1 38.4-3.6 2.9-6.4 3.8-8.3 2.8-1.9-1-1.9-3.5 0-7.4 4.5-9.3 9.2-21.8 14.2-37.7 5-15.8 5.7-26 2.1-30.5-1.1-1.5-2.7-2.6-5-3.6-2.2-.9-5.1-1.5-8.6-1.9s-6.7-.6-9.4-.8c-2.8-.2-6.5-.2-11.2 0-4.7.2-8 .4-10.1.6a874.4 874.4 0 0 1-17.1 1.5c-1.3.2-2.7.4-4.1.5-1.5.1-2.7.2-3.5.3l-2.7.3c-1 .1-1.7.2-2.2.2h-3.2l-1-.2-.6-.5-.5-.9c-1.3-3.3 3.7-7.4 15-12.4s22.3-8.1 32.9-9.3c9.8-1.5 21.3-1.5 34.5-.3s21.3 3.7 24.3 7.4c2.3 3.5 2.5 10.7.7 21.7zM485 467.5c-11.6 4.9-20.9 12.2-27.8 22-6.9 9.8-10.4 21.6-10.4 35.5 0 17.8 7.5 31.5 22.4 41.2 14.1 9.1 28.9 11.4 44.4 6.8 17.9-5.2 30-17.9 36.4-38.1 3-9.3 4.5-19.7 4.5-31.3v-50.2c-12.6.4-24.4 1.6-35.5 3.7-11.1 2.1-22.4 5.6-34 10.4z"
                }
            }
        ]
    })(props);
}
function AiFillAndroid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M270.1 741.7c0 23.4 19.1 42.5 42.6 42.5h48.7v120.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V784.1h85v120.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V784.1h48.7c23.5 0 42.6-19.1 42.6-42.5V346.4h-486v395.3zm357.1-600.1l44.9-65c2.6-3.8 2-8.9-1.5-11.4-3.5-2.4-8.5-1.2-11.1 2.6l-46.6 67.6c-30.7-12.1-64.9-18.8-100.8-18.8-35.9 0-70.1 6.7-100.8 18.8l-46.6-67.5c-2.6-3.8-7.6-5.1-11.1-2.6-3.5 2.4-4.1 7.4-1.5 11.4l44.9 65c-71.4 33.2-121.4 96.1-127.8 169.6h486c-6.6-73.6-56.7-136.5-128-169.7zM409.5 244.1a26.9 26.9 0 1 1 26.9-26.9 26.97 26.97 0 0 1-26.9 26.9zm208.4 0a26.9 26.9 0 1 1 26.9-26.9 26.97 26.97 0 0 1-26.9 26.9zm223.4 100.7c-30.2 0-54.6 24.8-54.6 55.4v216.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V400.1c.1-30.6-24.3-55.3-54.6-55.3zm-658.6 0c-30.2 0-54.6 24.8-54.6 55.4v216.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V400.1c0-30.6-24.5-55.3-54.6-55.3z"
                }
            }
        ]
    })(props);
}
function AiFillApi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 0 0-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 0 0 0 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM578.9 546.7a8.03 8.03 0 0 0-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 0 0-11.3 0L363 475.3l-43-43a7.85 7.85 0 0 0-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 68.9-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 0 0 0 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2z"
                }
            }
        ]
    })(props);
}
function AiFillApple(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-105.1-305c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z"
                }
            }
        ]
    })(props);
}
function AiFillAppstore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M864 144H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm0 400H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zM464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm0 400H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function AiFillAudio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm330-170c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1z"
                }
            }
        ]
    })(props);
}
function AiFillBackward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M485.6 249.9L198.2 498c-8.3 7.1-8.3 20.8 0 27.9l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9zm320 0L518.2 498a18.6 18.6 0 0 0-6.2 14c0 5.2 2.1 10.4 6.2 14l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9z"
                }
            }
        ]
    })(props);
}
function AiFillBank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 0 0-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM381 836H264V462h117v374zm189 0H453V462h117v374zm190 0H642V462h118v374z"
                }
            }
        ]
    })(props);
}
function AiFillBehanceCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M420.3 470.3c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 0 0-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1a50.5 50.5 0 0 0 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm86.5 286.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 0 1-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 0 1-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 0 1-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0 1 38.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 0 0-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7z"
                }
            }
        ]
    })(props);
}
function AiFillBehanceSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM598.5 350.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 0 1-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 0 1-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 0 1-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0 1 38.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 0 0-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7zm-248.5-10.1c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 0 0-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1s12.7-3.8 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8z"
                }
            }
        ]
    })(props);
}
function AiFillBell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M816 768h-24V428c0-141.1-104.3-257.8-240-277.2V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.8C336.3 170.2 232 286.9 232 428v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48z"
                }
            }
        ]
    })(props);
}
function AiFillBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM668 345.9L621.5 312 572 347.4V124h96v221.9z"
                }
            }
        ]
    })(props);
}
function AiFillBoxPlot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H448v432h344c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-728 80v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h152V296H232c-4.4 0-8 3.6-8 8z"
                }
            }
        ]
    })(props);
}
function AiFillBug(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 280h416c4.4 0 8-3.6 8-8 0-40-8.8-76.7-25.9-108.1-17.2-31.5-42.5-56.8-74-74C596.7 72.8 560 64 520 64h-16c-40 0-76.7 8.8-108.1 25.9-31.5 17.2-56.8 42.5-74 74C304.8 195.3 296 232 296 272c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M940 512H792V412c76.8 0 139-62.2 139-139 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 34.8-28.2 63-63 63H232c-34.8 0-63-28.2-63-63 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 76.8 62.2 139 139 139v100H84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h148v96c0 6.5.2 13 .7 19.3C164.1 728.6 116 796.7 116 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-44.2 23.9-82.9 59.6-103.7 6 17.2 13.6 33.6 22.7 49 24.3 41.5 59 76.2 100.5 100.5 28.9 16.9 61 28.8 95.3 34.5 4.4 0 8-3.6 8-8V484c0-4.4 3.6-8 8-8h60c4.4 0 8 3.6 8 8v464.2c0 4.4 3.6 8 8 8 34.3-5.7 66.4-17.6 95.3-34.5 41.5-24.3 76.2-59 100.5-100.5 9.1-15.5 16.7-31.9 22.7-49C812.1 793.1 836 831.8 836 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-79.3-48.1-147.4-116.7-176.7.4-6.4.7-12.8.7-19.3v-96h148c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiFillBuild(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zM612 746H412V546h200v200zm268-268H680V278h200v200z"
                }
            }
        ]
    })(props);
}
function AiFillBulb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M348 676.1C250 619.4 184 513.4 184 392c0-181.1 146.9-328 328-328s328 146.9 328 328c0 121.4-66 227.4-164 284.1V792c0 17.7-14.3 32-32 32H380c-17.7 0-32-14.3-32-32V676.1zM392 888h240c4.4 0 8 3.6 8 8v32c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32v-32c0-4.4 3.6-8 8-8z"
                }
            }
        ]
    })(props);
}
function AiFillCalculator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM440.2 765h-50.8c-2.2 0-4.5-1.1-5.9-2.9L348 718.6l-35.5 43.5a7.38 7.38 0 0 1-5.9 2.9h-50.8c-6.6 0-10.2-7.9-5.8-13.1l62.7-76.8-61.2-74.9c-4.3-5.2-.7-13.1 5.9-13.1h50.9c2.2 0 4.5 1.1 5.9 2.9l34 41.6 34-41.6c1.5-1.9 3.6-2.9 5.9-2.9h50.8c6.6 0 10.2 7.9 5.9 13.1L383.5 675l62.7 76.8c4.2 5.3.6 13.2-6 13.2zm7.8-382c0 2.2-1.4 4-3.2 4H376v68.7c0 1.9-1.8 3.3-4 3.3h-48c-2.2 0-4-1.4-4-3.2V387h-68.8c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4H320v-68.8c0-1.8 1.8-3.2 4-3.2h48c2.2 0 4 1.4 4 3.2V331h68.7c1.9 0 3.3 1.8 3.3 4v48zm328 369c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48zm0-104c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48zm0-265c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48z"
                }
            }
        ]
    })(props);
}
function AiFillCalendar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 880c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V460H112v420zm768-696H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v176h800V216c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function AiFillCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M864 260H728l-32.4-90.8a32.07 32.07 0 0 0-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 260H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V340c0-44.2-35.8-80-80-80zM512 716c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160zm-96-160a96 96 0 1 0 192 0 96 96 0 1 0-192 0z"
                }
            }
        ]
    })(props);
}
function AiFillCar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M959 413.4L935.3 372a8 8 0 0 0-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 0 0-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 0 0-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 0 0 3-10.8zM264 621c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm388 75c0 4.4-3.6 8-8 8H380c-4.4 0-8-3.6-8-8v-84c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v36h168v-36c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v84zm108-75c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM220 418l72.7-199.9.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220z"
                }
            }
        ]
    })(props);
}
function AiFillCaretDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"
                }
            }
        ]
    })(props);
}
function AiFillCaretLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z"
                }
            }
        ]
    })(props);
}
function AiFillCaretRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z"
                }
            }
        ]
    })(props);
}
function AiFillCaretUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z"
                }
            }
        ]
    })(props);
}
function AiFillCarryOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zM694.5 432.7L481.9 725.4a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.1 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.8-6.6 13-6.6H688c6.5.1 10.3 7.5 6.5 12.8z"
                }
            }
        ]
    })(props);
}
function AiFillCheckCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"
                }
            }
        ]
    })(props);
}
function AiFillCheckSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM695.5 365.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L308.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H689c6.5 0 10.3 7.4 6.5 12.7z"
                }
            }
        ]
    })(props);
}
function AiFillChrome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M371.8 512c0 77.5 62.7 140.2 140.2 140.2S652.2 589.5 652.2 512 589.5 371.8 512 371.8 371.8 434.4 371.8 512zM900 362.4l-234.3 12.1c63.6 74.3 64.6 181.5 11.1 263.7l-188 289.2c78 4.2 158.4-12.9 231.2-55.2 180-104 253-322.1 180-509.8zM320.3 591.9L163.8 284.1A415.35 415.35 0 0 0 96 512c0 208 152.3 380.3 351.4 410.8l106.9-209.4c-96.6 18.2-189.9-34.8-234-121.5zm218.5-285.5l344.4 18.1C848 254.7 792.6 194 719.8 151.7 653.9 113.6 581.5 95.5 510.5 96c-122.5.5-242.2 55.2-322.1 154.5l128.2 196.9c32-91.9 124.8-146.7 222.2-141z"
                }
            }
        ]
    })(props);
}
function AiFillCiCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-63.6 656c-103 0-162.4-68.6-162.4-182.6v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-4-46.1-37.6-77.6-87-77.6-61.1 0-95.6 45.4-95.6 126.9v49.3c0 80.3 34.5 125.1 95.6 125.1 49.3 0 82.8-29.5 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z"
                }
            }
        ]
    })(props);
}
function AiFillClockCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm176.5 585.7l-28.6 39a7.99 7.99 0 0 1-11.2 1.7L483.3 569.8a7.92 7.92 0 0 1-3.3-6.5V288c0-4.4 3.6-8 8-8h48.1c4.4 0 8 3.6 8 8v247.5l142.6 103.1c3.6 2.5 4.4 7.5 1.8 11.1z"
                }
            }
        ]
    })(props);
}
function AiFillCloseCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024",
            "fill": "currentColor",
            "fillRule": "evenodd"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64Zm127.978 274.82-.034.006c-.023.007-.042.018-.083.059L512 466.745l-127.86-127.86c-.042-.041-.06-.052-.084-.059a.118.118 0 0 0-.07 0c-.022.007-.041.018-.082.059l-45.02 45.019c-.04.04-.05.06-.058.083a.118.118 0 0 0 0 .07l.01.022a.268.268 0 0 0 .049.06L466.745 512l-127.86 127.862c-.041.04-.052.06-.059.083a.118.118 0 0 0 0 .07c.007.022.018.041.059.082l45.019 45.02c.04.04.06.05.083.058a.118.118 0 0 0 .07 0c.022-.007.041-.018.082-.059L512 557.254l127.862 127.861c.04.041.06.052.083.059a.118.118 0 0 0 .07 0c.022-.007.041-.018.082-.059l45.02-45.019c.04-.04.05-.06.058-.083a.118.118 0 0 0 0-.07l-.01-.022a.268.268 0 0 0-.049-.06L557.254 512l127.861-127.86c.041-.042.052-.06.059-.084a.118.118 0 0 0 0-.07c-.007-.022-.018-.041-.059-.082l-45.019-45.02c-.04-.04-.06-.05-.083-.058a.118.118 0 0 0-.07 0Z"
                }
            }
        ]
    })(props);
}
function AiFillCloseSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024",
            "fill": "currentColor",
            "fillRule": "evenodd"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112c17.7 0 32 14.3 32 32v736c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32ZM639.978 338.82l-.034.006c-.023.007-.042.018-.083.059L512 466.745l-127.86-127.86c-.042-.041-.06-.052-.084-.059a.118.118 0 0 0-.07 0c-.022.007-.041.018-.082.059l-45.02 45.019c-.04.04-.05.06-.058.083a.118.118 0 0 0 0 .07l.01.022a.268.268 0 0 0 .049.06L466.745 512l-127.86 127.862c-.041.04-.052.06-.059.083a.118.118 0 0 0 0 .07c.007.022.018.041.059.082l45.019 45.02c.04.04.06.05.083.058a.118.118 0 0 0 .07 0c.022-.007.041-.018.082-.059L512 557.254l127.862 127.861c.04.041.06.052.083.059a.118.118 0 0 0 .07 0c.022-.007.041-.018.082-.059l45.02-45.019c.04-.04.05-.06.058-.083a.118.118 0 0 0 0-.07l-.01-.022a.268.268 0 0 0-.049-.06L557.254 512l127.861-127.86c.041-.042.052-.06.059-.084a.118.118 0 0 0 0-.07c-.007-.022-.018-.041-.059-.082l-45.019-45.02c-.04-.04-.06-.05-.083-.058a.118.118 0 0 0-.07 0Z"
                }
            }
        ]
    })(props);
}
function AiFillCloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3z"
                }
            }
        ]
    })(props);
}
function AiFillCodeSandboxCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm243.7 589.2L512 794 268.3 653.2V371.8l110-63.6-.4-.2h.2L512 231l134 77h-.2l-.3.2 110.1 63.6v281.4zM307.9 536.7l87.6 49.9V681l96.7 55.9V524.8L307.9 418.4zm203.9-151.8L418 331l-91.1 52.6 185.2 107 185.2-106.9-91.4-52.8zm20 352l97.3-56.2v-94.1l87-49.5V418.5L531.8 525z"
                }
            }
        ]
    })(props);
}
function AiFillCodeSandboxSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M307.9 536.7l87.6 49.9V681l96.7 55.9V524.8L307.9 418.4zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM755.7 653.2L512 794 268.3 653.2V371.8l110-63.6-.4-.2h.2L512 231l134 77h-.2l-.3.2 110.1 63.6v281.4zm-223.9 83.7l97.3-56.2v-94.1l87-49.5V418.5L531.8 525zm-20-352L418 331l-91.1 52.6 185.2 107 185.2-106.9-91.4-52.8z"
                }
            }
        ]
    })(props);
}
function AiFillCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM513.1 518.1l-192 161c-5.2 4.4-13.1.7-13.1-6.1v-62.7c0-2.3 1.1-4.6 2.9-6.1L420.7 512l-109.8-92.2a7.63 7.63 0 0 1-2.9-6.1V351c0-6.8 7.9-10.5 13.1-6.1l192 160.9c3.9 3.2 3.9 9.1 0 12.3zM716 673c0 4.4-3.4 8-7.5 8h-185c-4.1 0-7.5-3.6-7.5-8v-48c0-4.4 3.4-8 7.5-8h185c4.1 0 7.5 3.6 7.5 8v48z"
                }
            }
        ]
    })(props);
}
function AiFillCodepenCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.1 414.7V303.4L300.9 428l83.6 55.8zm254.1 137.7v-79.8l-59.8 39.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm278 533c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 0 1-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 0 1-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 0 1 .8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-254.1 13.3v111.3L723.1 597l-83.6-55.8zM281.8 472.6v79.8l59.8-39.9zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zM723.1 428L535.9 303.4v111.3l103.6 69.1zM384.5 541.2L300.9 597l187.2 124.6V610.3l-103.6-69.1z"
                }
            }
        ]
    })(props);
}
function AiFillCodepenSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M723.1 428L535.9 303.4v111.3l103.6 69.1zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zm23.9 154.2v111.3L723.1 597l-83.6-55.8zm-151.4-69.1L300.9 597l187.2 124.6V610.3l-103.6-69.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-90 485c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 0 1-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 0 1-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 0 1 .8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-47.8-44.6v-79.8l-59.8 39.9zm-460.4-79.8v79.8l59.8-39.9zm206.3-57.9V303.4L300.9 428l83.6 55.8z"
                }
            }
        ]
    })(props);
}
function AiFillCompass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM327.3 702.4c-2 .9-4.4 0-5.3-2.1-.4-1-.4-2.2 0-3.2l98.7-225.5 132.1 132.1-225.5 98.7zm375.1-375.1l-98.7 225.5-132.1-132.1L697.1 322c2-.9 4.4 0 5.3 2.1.4 1 .4 2.1 0 3.2z"
                }
            }
        ]
    })(props);
}
function AiFillContacts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zM661 736h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.6-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H363a8 8 0 0 1-8-8.4c2.8-53.3 32-99.7 74.6-126.1a111.8 111.8 0 0 1-29.1-75.5c0-61.9 49.9-112 111.4-112 61.5 0 111.4 50.1 111.4 112 0 29.1-11 55.5-29.1 75.5 42.7 26.5 71.8 72.8 74.6 126.1.4 4.6-3.2 8.4-7.8 8.4zM512 474c-28.5 0-51.7 23.3-51.7 52s23.2 52 51.7 52c28.5 0 51.7-23.3 51.7-52s-23.2-52-51.7-52z"
                }
            }
        ]
    })(props);
}
function AiFillContainer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v529c0-.6.4-1 1-1h219.3l5.2 24.7C397.6 708.5 450.8 752 512 752s114.4-43.5 126.4-103.3l5.2-24.7H863c.6 0 1 .4 1 1V96c0-17.7-14.3-32-32-32zM712 493c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8v48zm0-160c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8v48zm151 354H694.1c-11.6 32.8-32 62.3-59.1 84.7-34.5 28.6-78.2 44.3-123 44.3s-88.5-15.8-123-44.3a194.02 194.02 0 0 1-59.1-84.7H161c-.6 0-1-.4-1-1v242c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V686c0 .6-.4 1-1 1z"
                }
            }
        ]
    })(props);
}
function AiFillControl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM404 683v77c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-77c-41.7-13.6-72-52.8-72-99s30.3-85.5 72-99V264c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v221c41.7 13.6 72 52.8 72 99s-30.3 85.5-72 99zm279.6-143.9c.2 0 .3-.1.4-.1v221c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V539c.2 0 .3.1.4.1-42-13.4-72.4-52.7-72.4-99.1 0-46.4 30.4-85.7 72.4-99.1-.2 0-.3.1-.4.1v-77c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v77c-.2 0-.3-.1-.4-.1 42 13.4 72.4 52.7 72.4 99.1 0 46.4-30.4 85.7-72.4 99.1zM616 440a36 36 0 1 0 72 0 36 36 0 1 0-72 0zM403.4 566.5l-1.5-2.4c0-.1-.1-.1-.1-.2l-.9-1.2c-.1-.1-.2-.2-.2-.3-1-1.3-2-2.5-3.2-3.6l-.2-.2c-.4-.4-.8-.8-1.2-1.1-.8-.8-1.7-1.5-2.6-2.1h-.1l-1.2-.9c-.1-.1-.3-.2-.4-.3-1.2-.8-2.5-1.6-3.9-2.2-.2-.1-.5-.2-.7-.4-.4-.2-.7-.3-1.1-.5-.3-.1-.7-.3-1-.4-.5-.2-1-.4-1.5-.5-.4-.1-.9-.3-1.3-.4l-.9-.3-1.4-.3c-.2-.1-.5-.1-.7-.2-.7-.1-1.4-.3-2.1-.4-.2 0-.4 0-.6-.1-.6-.1-1.1-.1-1.7-.2-.2 0-.4 0-.7-.1-.8 0-1.5-.1-2.3-.1s-1.5 0-2.3.1c-.2 0-.4 0-.7.1-.6 0-1.2.1-1.7.2-.2 0-.4 0-.6.1-.7.1-1.4.2-2.1.4-.2.1-.5.1-.7.2l-1.4.3-.9.3c-.4.1-.9.3-1.3.4-.5.2-1 .4-1.5.5-.3.1-.7.3-1 .4-.4.2-.7.3-1.1.5-.2.1-.5.2-.7.4-1.3.7-2.6 1.4-3.9 2.2-.1.1-.3.2-.4.3l-1.2.9h-.1c-.9.7-1.8 1.4-2.6 2.1-.4.4-.8.7-1.2 1.1l-.2.2a54.8 54.8 0 0 0-3.2 3.6c-.1.1-.2.2-.2.3l-.9 1.2c0 .1-.1.1-.1.2l-1.5 2.4c-.1.2-.2.3-.3.5-2.7 5.1-4.3 10.9-4.3 17s1.6 12 4.3 17c.1.2.2.3.3.5l1.5 2.4c0 .1.1.1.1.2l.9 1.2c.1.1.2.2.2.3 1 1.3 2 2.5 3.2 3.6l.2.2c.4.4.8.8 1.2 1.1.8.8 1.7 1.5 2.6 2.1h.1l1.2.9c.1.1.3.2.4.3 1.2.8 2.5 1.6 3.9 2.2.2.1.5.2.7.4.4.2.7.3 1.1.5.3.1.7.3 1 .4.5.2 1 .4 1.5.5.4.1.9.3 1.3.4l.9.3 1.4.3c.2.1.5.1.7.2.7.1 1.4.3 2.1.4.2 0 .4 0 .6.1.6.1 1.1.1 1.7.2.2 0 .4 0 .7.1.8 0 1.5.1 2.3.1s1.5 0 2.3-.1c.2 0 .4 0 .7-.1.6 0 1.2-.1 1.7-.2.2 0 .4 0 .6-.1.7-.1 1.4-.2 2.1-.4.2-.1.5-.1.7-.2l1.4-.3.9-.3c.4-.1.9-.3 1.3-.4.5-.2 1-.4 1.5-.5.3-.1.7-.3 1-.4.4-.2.7-.3 1.1-.5.2-.1.5-.2.7-.4 1.3-.7 2.6-1.4 3.9-2.2.1-.1.3-.2.4-.3l1.2-.9h.1c.9-.7 1.8-1.4 2.6-2.1.4-.4.8-.7 1.2-1.1l.2-.2c1.1-1.1 2.2-2.4 3.2-3.6.1-.1.2-.2.2-.3l.9-1.2c0-.1.1-.1.1-.2l1.5-2.4c.1-.2.2-.3.3-.5 2.7-5.1 4.3-10.9 4.3-17s-1.6-12-4.3-17c-.1-.2-.2-.4-.3-.5z"
                }
            }
        ]
    })(props);
}
function AiFillCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM382 896h-.2L232 746.2v-.2h150v150z"
                }
            }
        ]
    })(props);
}
function AiFillCopyrightCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm5.4 670c-110 0-173.4-73.2-173.4-194.9v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.6-3.2-8-7.4-4-49.5-40-83.4-93-83.4-65.3 0-102.1 48.5-102.1 135.5v52.6c0 85.7 36.9 133.6 102.1 133.6 52.8 0 88.7-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4z"
                }
            }
        ]
    })(props);
}
function AiFillCreditCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v160h896V192c0-17.7-14.3-32-32-32zM64 832c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V440H64v392zm579-184c0-4.4 3.6-8 8-8h165c4.4 0 8 3.6 8 8v72c0 4.4-3.6 8-8 8H651c-4.4 0-8-3.6-8-8v-72z"
                }
            }
        ]
    })(props);
}
function AiFillCrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M899.6 276.5L705 396.4 518.4 147.5a8.06 8.06 0 0 0-12.9 0L319 396.4 124.3 276.5c-5.7-3.5-13.1 1.2-12.2 7.9L188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.8-6.7-6.5-11.4-12.3-7.9zM512 734.2c-62.1 0-112.6-50.5-112.6-112.6S449.9 509 512 509s112.6 50.5 112.6 112.6S574.1 734.2 512 734.2zm0-160.9c-26.6 0-48.2 21.6-48.2 48.3 0 26.6 21.6 48.3 48.2 48.3s48.2-21.6 48.2-48.3c0-26.6-21.6-48.3-48.2-48.3z"
                }
            }
        ]
    })(props);
}
function AiFillCustomerService(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384z"
                }
            }
        ]
    })(props);
}
function AiFillDashboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M924.8 385.6a446.7 446.7 0 0 0-96-142.4 446.7 446.7 0 0 0-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 0 0-142.4 96 446.7 446.7 0 0 0-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM482 232c0-4.4 3.6-8 8-8h44c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8h-44c-4.4 0-8-3.6-8-8v-80zM270 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44zm90.7-204.5l-31.1 31.1a8.03 8.03 0 0 1-11.3 0L261.7 352a8.03 8.03 0 0 1 0-11.3l31.1-31.1c3.1-3.1 8.2-3.1 11.3 0l56.6 56.6c3.1 3.1 3.1 8.2 0 11.3zm291.1 83.6l-84.5 84.5c5 18.7.2 39.4-14.5 54.1a55.95 55.95 0 0 1-79.2 0 55.95 55.95 0 0 1 0-79.2 55.87 55.87 0 0 1 54.1-14.5l84.5-84.5c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3c3.1 3.1 3.1 8.1 0 11.3zm43-52.4l-31.1-31.1a8.03 8.03 0 0 1 0-11.3l56.6-56.6c3.1-3.1 8.2-3.1 11.3 0l31.1 31.1c3.1 3.1 3.1 8.2 0 11.3l-56.6 56.6a8.03 8.03 0 0 1-11.3 0zM846 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44z"
                }
            }
        ]
    })(props);
}
function AiFillDatabase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v224h704V96c0-17.7-14.3-32-32-32zM288 232c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM160 928c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V704H160v224zm128-136c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM160 640h704V384H160v256zm128-168c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z"
                }
            }
        ]
    })(props);
}
function AiFillDelete(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M864 256H736v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zm-200 0H360v-72h304v72z"
                }
            }
        ]
    })(props);
}
function AiFillDiff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.2 306.6L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23zM553.4 201.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM568 753c0 3.8-3.4 7-7.5 7h-225c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7h225c4.1 0 7.5 3.2 7.5 7v42zm0-220c0 3.8-3.4 7-7.5 7H476v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V540h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H420v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1V484h84.5c4.1 0 7.5 3.1 7.5 7v42z"
                }
            }
        ]
    })(props);
}
function AiFillDingtalkCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm227 385.3c-1 4.2-3.5 10.4-7 17.8h.1l-.4.7c-20.3 43.1-73.1 127.7-73.1 127.7s-.1-.2-.3-.5l-15.5 26.8h74.5L575.1 810l32.3-128h-58.6l20.4-84.7c-16.5 3.9-35.9 9.4-59 16.8 0 0-31.2 18.2-89.9-35 0 0-39.6-34.7-16.6-43.4 9.8-3.7 47.4-8.4 77-12.3 40-5.4 64.6-8.2 64.6-8.2S422 517 392.7 512.5c-29.3-4.6-66.4-53.1-74.3-95.8 0 0-12.2-23.4 26.3-12.3 38.5 11.1 197.9 43.2 197.9 43.2s-207.4-63.3-221.2-78.7c-13.8-15.4-40.6-84.2-37.1-126.5 0 0 1.5-10.5 12.4-7.7 0 0 153.3 69.7 258.1 107.9 104.8 37.9 195.9 57.3 184.2 106.7z"
                }
            }
        ]
    })(props);
}
function AiFillDingtalkSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM739 449.3c-1 4.2-3.5 10.4-7 17.8h.1l-.4.7c-20.3 43.1-73.1 127.7-73.1 127.7s-.1-.2-.3-.5l-15.5 26.8h74.5L575.1 810l32.3-128h-58.6l20.4-84.7c-16.5 3.9-35.9 9.4-59 16.8 0 0-31.2 18.2-89.9-35 0 0-39.6-34.7-16.6-43.4 9.8-3.7 47.4-8.4 77-12.3 40-5.4 64.6-8.2 64.6-8.2S422 517 392.7 512.5c-29.3-4.6-66.4-53.1-74.3-95.8 0 0-12.2-23.4 26.3-12.3 38.5 11.1 197.9 43.2 197.9 43.2s-207.4-63.3-221.2-78.7c-13.8-15.4-40.6-84.2-37.1-126.5 0 0 1.5-10.5 12.4-7.7 0 0 153.3 69.7 258.1 107.9 104.8 37.9 195.9 57.3 184.2 106.7z"
                }
            }
        ]
    })(props);
}
function AiFillDislike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 0 0-26.5-5.4H273v428h.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32z"
                }
            }
        ]
    })(props);
}
function AiFillDollarCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm22.3 665.2l.2 31.7c0 4.4-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4C401.3 723 359.5 672.4 355 617.4c-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.7 29.8 55.4 74.1 61.3V533.9l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-72.9 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.9 46.9 125.9 109.2.5 4.7-3.2 8.8-8 8.8h-44.9c-4 0-7.4-3-7.9-6.9-4-29.2-27.4-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 108.9 116.4 0 75.3-56 117.3-134.3 124.1zM426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-36.9 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.8-.6-5.6-1.3-8.8-2.2V677c42.6-3.8 72-27.2 72-66.4 0-30.7-15.9-50.7-63.2-65.1z"
                }
            }
        ]
    })(props);
}
function AiFillDownCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm184.5 353.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7H381c10.2 0 19.9 4.9 25.9 13.2L512 563.6l105.2-145.4c6-8.3 15.6-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.5 12.7z"
                }
            }
        ]
    })(props);
}
function AiFillDownSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM696.5 412.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7H381c10.2 0 19.9 4.9 25.9 13.2L512 558.6l105.2-145.4c6-8.3 15.6-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.5 12.7z"
                }
            }
        ]
    })(props);
}
function AiFillDribbbleCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M675.1 328.3a245.2 245.2 0 0 0-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6zm47.7-11.9c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 736c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm53.1-346.2c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm30.6 82.5c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4z"
                }
            }
        ]
    })(props);
}
function AiFillDribbbleSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm66.5 21.8c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM512 800c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm89.7-259.1c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zm-72.5-26.4c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4zm145.9-186.2a245.2 245.2 0 0 0-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6z"
                }
            }
        ]
    })(props);
}
function AiFillDropboxCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M663.8 455.5zm-151.5-93.8l-151.8 93.8 151.8 93.9 151.5-93.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm151.2 595.5L512.6 750l-151-90.5v-33.1l45.4 29.4 105.6-87.7 105.6 87.7 45.1-29.4v33.1zm-45.6-22.4l-105.3-87.7L407 637.1l-151-99.2 104.5-82.4L256 371.2 407 274l105.3 87.7L617.6 274 768 372.1l-104.2 83.5L768 539l-150.4 98.1z"
                }
            }
        ]
    })(props);
}
function AiFillDropboxSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM663.2 659.5L512.6 750l-151-90.5v-33.1l45.4 29.4 105.6-87.7 105.6 87.7 45.1-29.4v33.1zm-45.6-22.4l-105.3-87.7L407 637.1l-151-99.2 104.5-82.4L256 371.2 407 274l105.3 87.7L617.6 274 768 372.1l-104.2 83.5L768 539l-150.4 98.1zM512.3 361.7l-151.8 93.8 151.8 93.9 151.5-93.9zm151.5 93.8z"
                }
            }
        ]
    })(props);
}
function AiFillEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9z"
                }
            }
        ]
    })(props);
}
function AiFillEnvironment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 327c-29.9 0-58 11.6-79.2 32.8A111.6 111.6 0 0 0 400 439c0 29.9 11.7 58 32.8 79.2A111.6 111.6 0 0 0 512 551c29.9 0 58-11.7 79.2-32.8C612.4 497 624 468.9 624 439c0-29.9-11.6-58-32.8-79.2S541.9 327 512 327zm342.6-37.9a362.49 362.49 0 0 0-79.9-115.7 370.83 370.83 0 0 0-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 0 0 169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0 0 22.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 615c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z"
                }
            }
        ]
    })(props);
}
function AiFillEuroCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm63.5 375.8c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8h-136c-.3 4.4-.3 9.1-.3 13.8v36h136.2c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H444.9c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.2 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.3 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H344c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.8.3-12.8H344c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.7c19.7-94.2 92-149.9 198.6-149.9 20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346h.1c0 5.1-4.6 8.8-9.6 7.8-14.7-2.9-31.8-4.4-51.7-4.4-65.4 0-110.4 33.5-127.6 90.4h128.4z"
                }
            }
        ]
    })(props);
}
function AiFillExclamationCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            }
        ]
    })(props);
}
function AiFillExperiment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M218.9 636.3l42.6 26.6c.1.1.3.2.4.3l12.7 8 .3.3a186.9 186.9 0 0 0 94.1 25.1c44.9 0 87.2-15.7 121-43.8a256.27 256.27 0 0 1 164.9-59.9c52.3 0 102.2 15.7 144.6 44.5l7.9 5-111.6-289V179.8h63.5c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8H264.7c-4.4 0-8 3.6-8 8v51.9c0 4.4 3.6 8 8 8h63.5v173.6L218.9 636.3zm333-203.1c22 0 39.9 17.9 39.9 39.9S573.9 513 551.9 513 512 495.1 512 473.1s17.9-39.9 39.9-39.9zM878 825.1l-29.9-77.4-85.7-53.5-.1.1c-.7-.5-1.5-1-2.2-1.5l-8.1-5-.3-.3c-29-17.5-62.3-26.8-97-26.8-44.9 0-87.2 15.7-121 43.8a256.27 256.27 0 0 1-164.9 59.9c-53 0-103.5-16.1-146.2-45.6l-28.9-18.1L146 825.1c-2.8 7.4-4.3 15.2-4.3 23 0 35.2 28.6 63.8 63.8 63.8h612.9c7.9 0 15.7-1.5 23-4.3a63.6 63.6 0 0 0 36.6-82.5z"
                }
            }
        ]
    })(props);
}
function AiFillEyeInvisible(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": [
                    {
                        "tag": "clipPath",
                        "attr": {},
                        "child": [
                            {
                                "tag": "path",
                                "attr": {
                                    "fill": "none",
                                    "d": "M124-288l388-672 388 672H124z",
                                    "clipRule": "evenodd"
                                }
                            }
                        ]
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M508 624a112 112 0 0 0 112-112c0-3.28-.15-6.53-.43-9.74L498.26 623.57c3.21.28 6.45.43 9.74.43zm370.72-458.44L836 122.88a8 8 0 0 0-11.31 0L715.37 232.23Q624.91 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q56.7 119.43 136.55 191.45L112.56 835a8 8 0 0 0 0 11.31L155.25 889a8 8 0 0 0 11.31 0l712.16-712.12a8 8 0 0 0 0-11.32zM332 512a176 176 0 0 1 258.88-155.28l-48.62 48.62a112.08 112.08 0 0 0-140.92 140.92l-48.62 48.62A175.09 175.09 0 0 1 332 512z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M942.2 486.2Q889.4 375 816.51 304.85L672.37 449A176.08 176.08 0 0 1 445 676.37L322.74 798.63Q407.82 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5z"
                }
            }
        ]
    })(props);
}
function AiFillEye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M396 512a112 112 0 1 0 224 0 112 112 0 1 0-224 0zm546.2-25.8C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM508 688c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z"
                }
            }
        ]
    })(props);
}
function AiFillFacebook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-92.4 233.5h-63.9c-50.1 0-59.8 23.8-59.8 58.8v77.1h119.6l-15.6 120.7h-104V912H539.2V602.2H434.9V481.4h104.3v-89c0-103.3 63.1-159.6 155.3-159.6 44.2 0 82.1 3.3 93.2 4.8v107.9z"
                }
            }
        ]
    })(props);
}
function AiFillFastBackward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M517.6 273.5L230.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm320 0L550.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm-620-25.5h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z"
                }
            }
        ]
    })(props);
}
function AiFillFastForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M793.8 499.3L506.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.6c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8a16.14 16.14 0 0 0 0-25.4zm-320 0L186.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.5c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8c4.1-3.2 6.2-8 6.2-12.7 0-4.6-2.1-9.4-6.2-12.6zM857.6 248h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z"
                }
            }
        ]
    })(props);
}
function AiFillFileAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 580H372a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h108v108a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8V644h108a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H544V472a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v108zm374.6-291.3c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2z"
                }
            }
        ]
    })(props);
}
function AiFillFileExcel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM575.34 477.84l-61.22 102.3L452.3 477.8a12 12 0 0 0-10.27-5.79h-38.44a12 12 0 0 0-6.4 1.85 12 12 0 0 0-3.75 16.56l82.34 130.42-83.45 132.78a12 12 0 0 0-1.84 6.39 12 12 0 0 0 12 12h34.46a12 12 0 0 0 10.21-5.7l62.7-101.47 62.3 101.45a12 12 0 0 0 10.23 5.72h37.48a12 12 0 0 0 6.48-1.9 12 12 0 0 0 3.62-16.58l-83.83-130.55 85.3-132.47a12 12 0 0 0 1.9-6.5 12 12 0 0 0-12-12h-35.7a12 12 0 0 0-10.29 5.84z"
                }
            }
        ]
    })(props);
}
function AiFillFileExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM512 784a40 40 0 1 0 0-80 40 40 0 0 0 0 80zm32-152V448a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v184a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8z"
                }
            }
        ]
    })(props);
}
function AiFillFileImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM400 402c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm296 294H328c-6.7 0-10.4-7.7-6.3-12.9l99.8-127.2a8 8 0 0 1 12.6 0l41.1 52.4 77.8-99.2a8 8 0 0 1 12.6 0l136.5 174c4.3 5.2.5 12.9-6.1 12.9zm-94-370V137.8L790.2 326H602z"
                }
            }
        ]
    })(props);
}
function AiFillFileMarkdown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM426.13 600.93l59.11 132.97a16 16 0 0 0 14.62 9.5h24.06a16 16 0 0 0 14.63-9.51l59.1-133.35V758a16 16 0 0 0 16.01 16H641a16 16 0 0 0 16-16V486a16 16 0 0 0-16-16h-34.75a16 16 0 0 0-14.67 9.62L512.1 662.2l-79.48-182.59a16 16 0 0 0-14.67-9.61H383a16 16 0 0 0-16 16v272a16 16 0 0 0 16 16h27.13a16 16 0 0 0 16-16V600.93z"
                }
            }
        ]
    })(props);
}
function AiFillFilePdf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM633.22 637.26c-15.18-.5-31.32.67-49.65 2.96-24.3-14.99-40.66-35.58-52.28-65.83l1.07-4.38 1.24-5.18c4.3-18.13 6.61-31.36 7.3-44.7.52-10.07-.04-19.36-1.83-27.97-3.3-18.59-16.45-29.46-33.02-30.13-15.45-.63-29.65 8-33.28 21.37-5.91 21.62-2.45 50.07 10.08 98.59-15.96 38.05-37.05 82.66-51.2 107.54-18.89 9.74-33.6 18.6-45.96 28.42-16.3 12.97-26.48 26.3-29.28 40.3-1.36 6.49.69 14.97 5.36 21.92 5.3 7.88 13.28 13 22.85 13.74 24.15 1.87 53.83-23.03 86.6-79.26 3.29-1.1 6.77-2.26 11.02-3.7l11.9-4.02c7.53-2.54 12.99-4.36 18.39-6.11 23.4-7.62 41.1-12.43 57.2-15.17 27.98 14.98 60.32 24.8 82.1 24.8 17.98 0 30.13-9.32 34.52-23.99 3.85-12.88.8-27.82-7.48-36.08-8.56-8.41-24.3-12.43-45.65-13.12zM385.23 765.68v-.36l.13-.34a54.86 54.86 0 0 1 5.6-10.76c4.28-6.58 10.17-13.5 17.47-20.87 3.92-3.95 8-7.8 12.79-12.12 1.07-.96 7.91-7.05 9.19-8.25l11.17-10.4-8.12 12.93c-12.32 19.64-23.46 33.78-33 43-3.51 3.4-6.6 5.9-9.1 7.51a16.43 16.43 0 0 1-2.61 1.42c-.41.17-.77.27-1.13.3a2.2 2.2 0 0 1-1.12-.15 2.07 2.07 0 0 1-1.27-1.91zM511.17 547.4l-2.26 4-1.4-4.38c-3.1-9.83-5.38-24.64-6.01-38-.72-15.2.49-24.32 5.29-24.32 6.74 0 9.83 10.8 10.07 27.05.22 14.28-2.03 29.14-5.7 35.65zm-5.81 58.46l1.53-4.05 2.09 3.8c11.69 21.24 26.86 38.96 43.54 51.31l3.6 2.66-4.39.9c-16.33 3.38-31.54 8.46-52.34 16.85 2.17-.88-21.62 8.86-27.64 11.17l-5.25 2.01 2.8-4.88c12.35-21.5 23.76-47.32 36.05-79.77zm157.62 76.26c-7.86 3.1-24.78.33-54.57-12.39l-7.56-3.22 8.2-.6c23.3-1.73 39.8-.45 49.42 3.07 4.1 1.5 6.83 3.39 8.04 5.55a4.64 4.64 0 0 1-1.36 6.31 6.7 6.7 0 0 1-2.17 1.28z"
                }
            }
        ]
    })(props);
}
function AiFillFilePpt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM468.53 760v-91.54h59.27c60.57 0 100.2-39.65 100.2-98.12 0-58.22-39.58-98.34-99.98-98.34H424a12 12 0 0 0-12 12v276a12 12 0 0 0 12 12h32.53a12 12 0 0 0 12-12zm0-139.33h34.9c47.82 0 67.19-12.93 67.19-50.33 0-32.05-18.12-50.12-49.87-50.12h-52.22v100.45z"
                }
            }
        ]
    })(props);
}
function AiFillFileText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM320 482a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h384a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H320zm0 136a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h184a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H320z"
                }
            }
        ]
    })(props);
}
function AiFillFileUnknown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM402 549c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103zm110 227a32 32 0 1 0 0-64 32 32 0 0 0 0 64z"
                }
            }
        ]
    })(props);
}
function AiFillFileWord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM512 566.1l52.81 197a12 12 0 0 0 11.6 8.9h31.77a12 12 0 0 0 11.6-8.88l74.37-276a12 12 0 0 0 .4-3.12 12 12 0 0 0-12-12h-35.57a12 12 0 0 0-11.7 9.31l-45.78 199.1-49.76-199.32A12 12 0 0 0 528.1 472h-32.2a12 12 0 0 0-11.64 9.1L434.6 680.01 388.5 481.3a12 12 0 0 0-11.68-9.29h-35.39a12 12 0 0 0-3.11.41 12 12 0 0 0-8.47 14.7l74.17 276A12 12 0 0 0 415.6 772h31.99a12 12 0 0 0 11.59-8.9l52.81-197z"
                }
            }
        ]
    })(props);
}
function AiFillFileZip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM296 136v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm0 64v160h128V584H296zm48 48h32v64h-32v-64z"
                }
            }
        ]
    })(props);
}
function AiFillFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2z"
                }
            }
        ]
    })(props);
}
function AiFillFilter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z"
                }
            }
        ]
    })(props);
}
function AiFillFire(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M834.1 469.2A347.49 347.49 0 0 0 751.2 354l-29.1-26.7a8.09 8.09 0 0 0-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 0 1-47.5 46.1 352.6 352.6 0 0 0-100.3 121.5A347.75 347.75 0 0 0 160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0 0 75.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 0 0 760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0 0 27.7-136c0-48.8-10-96.2-29.9-140.9z"
                }
            }
        ]
    })(props);
}
function AiFillFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function AiFillFolderAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM632 577c0 3.8-3.4 7-7.5 7H540v84.9c0 3.9-3.2 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V584h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7H484v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.8 0 7 3.2 7 7.1V528h84.5c4.1 0 7.5 3.2 7.5 7v42z"
                }
            }
        ]
    })(props);
}
function AiFillFolderOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zm-180 0H238c-13 0-24.8 7.9-29.7 20L136 643.2V256h188.5l119.6 114.4H748V444z"
                }
            }
        ]
    })(props);
}
function AiFillFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function AiFillFormatPainter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683558243",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M840 192h-56v-72c0-13.3-10.7-24-24-24H168c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h592c13.3 0 24-10.7 24-24V256h32v200H465c-22.1 0-40 17.9-40 40v136h-44c-4.4 0-8 3.6-8 8v228c0 1.1 0.2 2.2 0.6 3.1-0.4 1.6-0.6 3.2-0.6 4.9 0 46.4 37.6 84 84 84s84-37.6 84-84c0-1.7-0.2-3.3-0.6-4.9 0.4-1 0.6-2 0.6-3.1V640c0-4.4-3.6-8-8-8h-44V520h351c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40z"
                }
            }
        ]
    })(props);
}
function AiFillForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M825.8 498L538.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L825.8 526c8.3-7.2 8.3-20.8 0-28zm-320 0L218.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L505.8 526c4.1-3.6 6.2-8.8 6.2-14 0-5.2-2.1-10.4-6.2-14z"
                }
            }
        ]
    })(props);
}
function AiFillFrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm376 272h-48.1c-4.2 0-7.8-3.2-8.1-7.4C604 636.1 562.5 597 512 597s-92.1 39.1-95.8 88.6c-.3 4.2-3.9 7.4-8.1 7.4H360a8 8 0 0 1-8-8.4c4.4-84.3 74.5-151.6 160-151.6s155.6 67.3 160 151.6a8 8 0 0 1-8 8.4zm24-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            }
        ]
    })(props);
}
function AiFillFund(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M926 164H94c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V196c0-17.7-14.3-32-32-32zm-92.3 194.4l-297 297.2a8.03 8.03 0 0 1-11.3 0L410.9 541.1 238.4 713.7a8.03 8.03 0 0 1-11.3 0l-36.8-36.8a8.03 8.03 0 0 1 0-11.3l214.9-215c3.1-3.1 8.2-3.1 11.3 0L531 565l254.5-254.6c3.1-3.1 8.2-3.1 11.3 0l36.8 36.8c3.2 3 3.2 8.1.1 11.2z"
                }
            }
        ]
    })(props);
}
function AiFillFunnelPlot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336.7 586h350.6l84.9-148H251.8zm543.4-432H143.9c-24.5 0-39.8 26.7-27.5 48L215 374h594l98.7-172c12.2-21.3-3.1-48-27.6-48zM349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V650H349v188z"
                }
            }
        ]
    })(props);
}
function AiFillGift(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 894c0 17.7 14.3 32 32 32h286V550H160v344zm386 32h286c17.7 0 32-14.3 32-32V550H546v376zm334-616H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v140h366V310h68v172h366V342c0-17.7-14.3-32-32-32zm-402-4h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70 70 31.4 70 70v70zm138 0h-70v-70c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70z"
                }
            }
        ]
    })(props);
}
function AiFillGithub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0 1 38.1 91v112.5c.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z"
                }
            }
        ]
    })(props);
}
function AiFillGitlab(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M910.5 553.2l-109-370.8c-6.8-20.4-23.1-34.1-44.9-34.1s-39.5 12.3-46.3 32.7l-72.2 215.4H386.2L314 181.1c-6.8-20.4-24.5-32.7-46.3-32.7s-39.5 13.6-44.9 34.1L113.9 553.2c-4.1 13.6 1.4 28.6 12.3 36.8l385.4 289 386.7-289c10.8-8.1 16.3-23.1 12.2-36.8z"
                }
            }
        ]
    })(props);
}
function AiFillGold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M905.9 806.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zm-470.2-248c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiFillGolden(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M905.9 806.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zm-470.2-248c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiFillGoogleCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm167 633.6C638.4 735 583 757 516.9 757c-95.7 0-178.5-54.9-218.8-134.9C281.5 589 272 551.6 272 512s9.5-77 26.1-110.1c40.3-80.1 123.1-135 218.8-135 66 0 121.4 24.3 163.9 63.8L610.6 401c-25.4-24.3-57.7-36.6-93.6-36.6-63.8 0-117.8 43.1-137.1 101-4.9 14.7-7.7 30.4-7.7 46.6s2.8 31.9 7.7 46.6c19.3 57.9 73.3 101 137 101 33 0 61-8.7 82.9-23.4 26-17.4 43.2-43.3 48.9-74H516.9v-94.8h230.7c2.9 16.1 4.4 32.8 4.4 50.1 0 74.7-26.7 137.4-73 180.1z"
                }
            }
        ]
    })(props);
}
function AiFillGooglePlusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm36.5 558.8c-43.9 61.8-132.1 79.8-200.9 53.3-69-26.3-118-99.2-112.1-173.5 1.5-90.9 85.2-170.6 176.1-167.5 43.6-2 84.6 16.9 118 43.6-14.3 16.2-29 31.8-44.8 46.3-40.1-27.7-97.2-35.6-137.3-3.6-57.4 39.7-60 133.4-4.8 176.1 53.7 48.7 155.2 24.5 170.1-50.1-33.6-.5-67.4 0-101-1.1-.1-20.1-.2-40.1-.1-60.2 56.2-.2 112.5-.3 168.8.2 3.3 47.3-3 97.5-32 136.5zM791 536.5c-16.8.2-33.6.3-50.4.4-.2 16.8-.3 33.6-.3 50.4H690c-.2-16.8-.2-33.5-.3-50.3-16.8-.2-33.6-.3-50.4-.5v-50.1c16.8-.2 33.6-.3 50.4-.3.1-16.8.3-33.6.4-50.4h50.2l.3 50.4c16.8.2 33.6.2 50.4.3v50.1z"
                }
            }
        ]
    })(props);
}
function AiFillGooglePlusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM548.5 622.8c-43.9 61.8-132.1 79.8-200.9 53.3-69-26.3-118-99.2-112.1-173.5 1.5-90.9 85.2-170.6 176.1-167.5 43.6-2 84.6 16.9 118 43.6-14.3 16.2-29 31.8-44.8 46.3-40.1-27.7-97.2-35.6-137.3-3.6-57.4 39.7-60 133.4-4.8 176.1 53.7 48.7 155.2 24.5 170.1-50.1-33.6-.5-67.4 0-101-1.1-.1-20.1-.2-40.1-.1-60.2 56.2-.2 112.5-.3 168.8.2 3.3 47.3-3 97.5-32 136.5zM791 536.5c-16.8.2-33.6.3-50.4.4-.2 16.8-.3 33.6-.3 50.4H690c-.2-16.8-.2-33.5-.3-50.3-16.8-.2-33.6-.3-50.4-.5v-50.1c16.8-.2 33.6-.3 50.4-.3.1-16.8.3-33.6.4-50.4h50.2l.3 50.4c16.8.2 33.6.2 50.4.3v50.1z"
                }
            }
        ]
    })(props);
}
function AiFillGoogleSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM679 697.6C638.4 735 583 757 516.9 757c-95.7 0-178.5-54.9-218.8-134.9A245.02 245.02 0 0 1 272 512c0-39.6 9.5-77 26.1-110.1 40.3-80.1 123.1-135 218.8-135 66 0 121.4 24.3 163.9 63.8L610.6 401c-25.4-24.3-57.7-36.6-93.6-36.6-63.8 0-117.8 43.1-137.1 101-4.9 14.7-7.7 30.4-7.7 46.6s2.8 31.9 7.7 46.6c19.3 57.9 73.3 101 137 101 33 0 61-8.7 82.9-23.4 26-17.4 43.2-43.3 48.9-74H516.9v-94.8h230.7c2.9 16.1 4.4 32.8 4.4 50.1 0 74.7-26.7 137.4-73 180.1z"
                }
            }
        ]
    })(props);
}
function AiFillHdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v224h704V96c0-17.7-14.3-32-32-32zM456 216c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zM160 928c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V704H160v224zm576-136c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM160 640h704V384H160v256zm96-152c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8v-48z"
                }
            }
        ]
    })(props);
}
function AiFillHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9z"
                }
            }
        ]
    })(props);
}
function AiFillHighlight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M957.6 507.4L603.2 158.2a7.9 7.9 0 0 0-11.2 0L353.3 393.4a8.03 8.03 0 0 0-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 0 0-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8V860c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6 40.4 39.8a7.9 7.9 0 0 0 11.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0 0 11.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2z"
                }
            }
        ]
    })(props);
}
function AiFillHome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M946.5 505L534.6 93.4a31.93 31.93 0 0 0-45.2 0L77.5 505c-12 12-18.8 28.3-18.8 45.3 0 35.3 28.7 64 64 64h43.4V908c0 17.7 14.3 32 32 32H448V716h112v224h265.9c17.7 0 32-14.3 32-32V614.3h43.4c17 0 33.3-6.7 45.3-18.8 24.9-25 24.9-65.5-.1-90.5z"
                }
            }
        ]
    })(props);
}
function AiFillHourglass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194z"
                }
            }
        ]
    })(props);
}
function AiFillHtml5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M145.2 96l66 746.6L512 928l299.6-85.4L878.9 96H145.2zm595 177.1l-4.8 47.2-1.7 19.5H382.3l8.2 94.2h335.1l-3.3 24.3-21.2 242.2-1.7 16.2-187 51.6v.3h-1.2l-.3.1v-.1h-.1l-188.6-52L310.8 572h91.1l6.5 73.2 102.4 27.7h.4l102-27.6 11.4-118.6H510.9v-.1H306l-22.8-253.5-1.7-24.3h460.3l-1.6 24.3z"
                }
            }
        ]
    })(props);
}
function AiFillIdcard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M373 411c-28.5 0-51.7 23.3-51.7 52s23.2 52 51.7 52 51.7-23.3 51.7-52-23.2-52-51.7-52zm555-251H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zM608 420c0-4.4 1-8 2.3-8h123.4c1.3 0 2.3 3.6 2.3 8v48c0 4.4-1 8-2.3 8H610.3c-1.3 0-2.3-3.6-2.3-8v-48zm-86 253h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H224a8 8 0 0 1-8-8.4c2.8-53.3 32-99.7 74.6-126.1a111.8 111.8 0 0 1-29.1-75.5c0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.5-29.1 75.5 42.7 26.5 71.8 72.8 74.6 126.1.4 4.6-3.2 8.4-7.8 8.4zm278.9-53H615.1c-3.9 0-7.1-3.6-7.1-8v-48c0-4.4 3.2-8 7.1-8h185.7c3.9 0 7.1 3.6 7.1 8v48h.1c0 4.4-3.2 8-7.1 8z"
                }
            }
        ]
    })(props);
}
function AiFillIeCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M693.6 284.4c-24 0-51.1 11.7-72.6 22 46.3 18 86 57.3 112.3 99.6 7.1-18.9 14.6-47.9 14.6-67.9 0-32-22.8-53.7-54.3-53.7zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm253.9 492.9H437.1c0 100.4 144.3 136 196.8 47.4h120.8c-32.6 91.7-119.7 146-216.8 146-35.1 0-70.3-.1-101.7-15.6-87.4 44.5-180.3 56.6-180.3-42 0-45.8 23.2-107.1 44-145C335 484 381.3 422.8 435.6 374.5c-43.7 18.9-91.1 66.3-122 101.2 25.9-112.8 129.5-193.6 237.1-186.5 130-59.8 209.7-34.1 209.7 38.6 0 27.4-10.6 63.3-21.4 87.9 25.2 45.5 33.3 97.6 26.9 141.2zM540.5 399.1c-53.7 0-102 39.7-104 94.9h208c-2-55.1-50.6-94.9-104-94.9zM320.6 602.9c-73 152.4 11.5 172.2 100.3 123.3-46.6-27.5-82.6-72.2-100.3-123.3z"
                }
            }
        ]
    })(props);
}
function AiFillIeSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM765.9 556.9H437.1c0 100.4 144.3 136 196.8 47.4h120.8c-32.6 91.7-119.7 146-216.8 146-35.1 0-70.3-.1-101.7-15.6-87.4 44.5-180.3 56.6-180.3-42 0-45.8 23.2-107.1 44-145C335 484 381.3 422.8 435.6 374.5c-43.7 18.9-91.1 66.3-122 101.2 25.9-112.8 129.5-193.6 237.1-186.5 130-59.8 209.7-34.1 209.7 38.6 0 27.4-10.6 63.3-21.4 87.9 25.2 45.5 33.3 97.6 26.9 141.2zm-72.3-272.5c-24 0-51.1 11.7-72.6 22 46.3 18 86 57.3 112.3 99.6 7.1-18.9 14.6-47.9 14.6-67.9 0-32-22.8-53.7-54.3-53.7zM540.5 399.1c-53.7 0-102 39.7-104 94.9h208c-2-55.1-50.6-94.9-104-94.9zM320.6 602.9c-73 152.4 11.5 172.2 100.3 123.3-46.6-27.5-82.6-72.2-100.3-123.3z"
                }
            }
        ]
    })(props);
}
function AiFillInfoCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            }
        ]
    })(props);
}
function AiFillInstagram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 378.7c-73.4 0-133.3 59.9-133.3 133.3S438.6 645.3 512 645.3 645.3 585.4 645.3 512 585.4 378.7 512 378.7zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zM512 717.1c-113.5 0-205.1-91.6-205.1-205.1S398.5 306.9 512 306.9 717.1 398.5 717.1 512 625.5 717.1 512 717.1zm213.5-370.7c-26.5 0-47.9-21.4-47.9-47.9s21.4-47.9 47.9-47.9 47.9 21.4 47.9 47.9a47.84 47.84 0 0 1-47.9 47.9z"
                }
            }
        ]
    })(props);
}
function AiFillInsurance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M519.9 358.8h97.9v41.6h-97.9zm347-188.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM411.3 656h-.2c0 4.4-3.6 8-8 8h-37.3c-4.4 0-8-3.6-8-8V471.4c-7.7 9.2-15.4 17.9-23.1 26a6.04 6.04 0 0 1-10.2-2.4l-13.2-43.5c-.6-2-.2-4.1 1.2-5.6 37-43.4 64.7-95.1 82.2-153.6 1.1-3.5 5-5.3 8.4-3.7l38.6 18.3c2.7 1.3 4.1 4.4 3.2 7.2a429.2 429.2 0 0 1-33.6 79V656zm296.5-49.2l-26.3 35.3a5.92 5.92 0 0 1-8.9.7c-30.6-29.3-56.8-65.2-78.1-106.9V656c0 4.4-3.6 8-8 8h-36.2c-4.4 0-8-3.6-8-8V536c-22 44.7-49 80.8-80.6 107.6a5.9 5.9 0 0 1-8.9-1.4L430 605.7a6 6 0 0 1 1.6-8.1c28.6-20.3 51.9-45.2 71-76h-55.1c-4.4 0-8-3.6-8-8V478c0-4.4 3.6-8 8-8h94.9v-18.6h-65.9c-4.4 0-8-3.6-8-8V316c0-4.4 3.6-8 8-8h184.7c4.4 0 8 3.6 8 8v127.2c0 4.4-3.6 8-8 8h-66.7v18.6h98.8c4.4 0 8 3.6 8 8v35.6c0 4.4-3.6 8-8 8h-59c18.1 29.1 41.8 54.3 72.3 76.9 2.6 2.1 3.2 5.9 1.2 8.5z"
                }
            }
        ]
    })(props);
}
function AiFillInteraction(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM726 585.7c0 55.3-44.7 100.1-99.7 100.1H420.6v53.4c0 5.7-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.7l109.1-85.7c4.4-3.5 10.9-.3 10.9 5.3v53.4h205.7c19.6 0 35.5-16 35.5-35.6v-78.9c0-3.7 3-6.8 6.8-6.8h50.7c3.7 0 6.8 3 6.8 6.8v79.1zm-2.6-209.9l-109.1 85.7c-4.4 3.5-10.9.3-10.9-5.3v-53.4H397.7c-19.6 0-35.5 16-35.5 35.6v78.9c0 3.7-3 6.8-6.8 6.8h-50.7c-3.7 0-6.8-3-6.8-6.8v-78.9c0-55.3 44.7-100.1 99.7-100.1h205.7v-53.4c0-5.7 6.5-8.8 10.9-5.3l109.1 85.7c3.6 2.5 3.6 7.8.1 10.5z"
                }
            }
        ]
    })(props);
}
function AiFillLayout(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 912h496c17.7 0 32-14.3 32-32V340H384v572zm496-800H384v164h528V144c0-17.7-14.3-32-32-32zm-768 32v736c0 17.7 14.3 32 32 32h176V112H144c-17.7 0-32 14.3-32 32z"
                }
            }
        ]
    })(props);
}
function AiFillLeftCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm104 316.9c0 10.2-4.9 19.9-13.2 25.9L457.4 512l145.4 105.2c8.3 6 13.2 15.6 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 0 1 0-12.9l246-178a8 8 0 0 1 12.7 6.5v46.8z"
                }
            }
        ]
    })(props);
}
function AiFillLeftSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM624 380.9c0 10.2-4.9 19.9-13.2 25.9L465.4 512l145.4 105.2c8.3 6 13.2 15.6 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 0 1 0-12.9l246-178c5.3-3.8 12.7 0 12.7 6.5v46.8z"
                }
            }
        ]
    })(props);
}
function AiFillLike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 0 0-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 0 0 471 99.9c-52 0-98 35-111.8 85.1l-85.9 311h-.3v428h472.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32z"
                }
            }
        ]
    })(props);
}
function AiFillLinkedin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM349.3 793.7H230.6V411.9h118.7v381.8zm-59.3-434a68.8 68.8 0 1 1 68.8-68.8c-.1 38-30.9 68.8-68.8 68.8zm503.7 434H675.1V608c0-44.3-.8-101.2-61.7-101.2-61.7 0-71.2 48.2-71.2 98v188.9H423.7V411.9h113.8v52.2h1.6c15.8-30 54.5-61.7 112.3-61.7 120.2 0 142.3 79.1 142.3 181.9v209.4z"
                }
            }
        ]
    })(props);
}
function AiFillLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM540 701v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 1 1 56 0zm152-237H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224z"
                }
            }
        ]
    })(props);
}
function AiFillMacCommand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569747879816",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M624 672c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48h-48v48zM720 352c0-26.5-21.5-48-48-48s-48 21.5-48 48v48h48c26.5 0 48-21.5 48-48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M928 64H96c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM672 560c61.9 0 112 50.1 112 112s-50.1 112-112 112-112-50.1-112-112v-48h-96v48c0 61.9-50.1 112-112 112s-112-50.1-112-112 50.1-112 112-112h48v-96h-48c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112v48h96v-48c0-61.9 50.1-112 112-112s112 50.1 112 112-50.1 112-112 112h-48v96h48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M464 464h96v96h-96zM352 304c-26.5 0-48 21.5-48 48s21.5 48 48 48h48v-48c0-26.5-21.5-48-48-48zM304 672c0 26.5 21.5 48 48 48s48-21.5 48-48v-48h-48c-26.5 0-48 21.5-48 48z"
                }
            }
        ]
    })(props);
}
function AiFillMail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-80.8 108.9L531.7 514.4c-7.8 6.1-18.7 6.1-26.5 0L189.6 268.9A7.2 7.2 0 0 1 194 256h648.8a7.2 7.2 0 0 1 4.4 12.9z"
                }
            }
        ]
    })(props);
}
function AiFillMedicineBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M839.2 278.1a32 32 0 0 0-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 0 0-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM660 628c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V636H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V464c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8v48zm4-372H360v-72h304v72z"
                }
            }
        ]
    })(props);
}
function AiFillMediumCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm256 253.7l-40.8 39.1c-3.6 2.7-5.3 7.1-4.6 11.4v287.7c-.7 4.4 1 8.8 4.6 11.4l40 39.1v8.7H566.4v-8.3l41.3-40.1c4.1-4.1 4.1-5.3 4.1-11.4V422.5l-115 291.6h-15.5L347.5 422.5V618c-1.2 8.2 1.7 16.5 7.5 22.4l53.8 65.1v8.7H256v-8.7l53.8-65.1a26.1 26.1 0 0 0 7-22.4V392c.7-6.3-1.7-12.4-6.5-16.7l-47.8-57.6V309H411l114.6 251.5 100.9-251.3H768v8.5z"
                }
            }
        ]
    })(props);
}
function AiFillMediumSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM768 317.7l-40.8 39.1c-3.6 2.7-5.3 7.1-4.6 11.4v287.7c-.7 4.4 1 8.8 4.6 11.4l40 39.1v8.7H566.4v-8.3l41.3-40.1c4.1-4.1 4.1-5.3 4.1-11.4V422.5l-115 291.6h-15.5L347.5 422.5V618c-1.2 8.2 1.7 16.5 7.5 22.4l53.8 65.1v8.7H256v-8.7l53.8-65.1a26.1 26.1 0 0 0 7-22.4V392c.7-6.3-1.7-12.4-6.5-16.7l-47.8-57.6V309H411l114.6 251.5 100.9-251.3H768v8.5z"
                }
            }
        ]
    })(props);
}
function AiFillMeh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm384 200c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v48zm16-152a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            }
        ]
    })(props);
}
function AiFillMessage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M924.3 338.4a447.57 447.57 0 0 0-96.1-143.3 443.09 443.09 0 0 0-143-96.3A443.91 443.91 0 0 0 512 64h-2c-60.5.3-119 12.3-174.1 35.9a444.08 444.08 0 0 0-141.7 96.5 445 445 0 0 0-95 142.8A449.89 449.89 0 0 0 65 514.1c.3 69.4 16.9 138.3 47.9 199.9v152c0 25.4 20.6 46 45.9 46h151.8a447.72 447.72 0 0 0 199.5 48h2.1c59.8 0 117.7-11.6 172.3-34.3A443.2 443.2 0 0 0 827 830.5c41.2-40.9 73.6-88.7 96.3-142 23.5-55.2 35.5-113.9 35.8-174.5.2-60.9-11.6-120-34.8-175.6zM312.4 560c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.4 48-47.9 48zm199.6 0c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.5 48-47.9 48zm199.6 0c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.5 48-47.9 48z"
                }
            }
        ]
    })(props);
}
function AiFillMinusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z"
                }
            }
        ]
    })(props);
}
function AiFillMinusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM704 536c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z"
                }
            }
        ]
    })(props);
}
function AiFillMobile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zM512 824c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z"
                }
            }
        ]
    })(props);
}
function AiFillMoneyCollect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M911.5 699.7a8 8 0 0 0-10.3-4.8L840 717.2V179c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V762c0 3.3 2.1 6.3 5.3 7.5L501 909.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zm-243.8-377L564 514.3h57.6c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3v39h76.3c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3V703c0 4.4-3.6 8-8 8h-49.9c-4.4 0-8-3.6-8-8v-63.4h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h76v-39h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h57L356.5 322.8c-2.1-3.8-.7-8.7 3.2-10.8 1.2-.7 2.5-1 3.8-1h55.7a8 8 0 0 1 7.1 4.4L511 484.2h3.3L599 315.4c1.3-2.7 4.1-4.4 7.1-4.4h54.5c4.4 0 8 3.6 8.1 7.9 0 1.3-.4 2.6-1 3.8z"
                }
            }
        ]
    })(props);
}
function AiFillNotification(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.6c-3.7 11.6-5.6 23.9-5.6 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1z"
                }
            }
        ]
    })(props);
}
function AiFillPauseCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-80 600c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304zm224 0c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304z"
                }
            }
        ]
    })(props);
}
function AiFillPayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm166.6 246.8L567.5 515.6h62c4.4 0 8 3.6 8 8v29.9c0 4.4-3.6 8-8 8h-82V603h82c4.4 0 8 3.6 8 8v29.9c0 4.4-3.6 8-8 8h-82V717c0 4.4-3.6 8-8 8h-54.3c-4.4 0-8-3.6-8-8v-68.1h-81.7c-4.4 0-8-3.6-8-8V611c0-4.4 3.6-8 8-8h81.7v-41.5h-81.7c-4.4 0-8-3.6-8-8v-29.9c0-4.4 3.6-8 8-8h61.4L345.4 310.8a8.07 8.07 0 0 1 7-11.9h60.7c3 0 5.8 1.7 7.1 4.4l90.6 180h3.4l90.6-180a8 8 0 0 1 7.1-4.4h59.5c4.4 0 8 3.6 8 8 .2 1.4-.2 2.7-.8 3.9z"
                }
            }
        ]
    })(props);
}
function AiFillPhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M885.6 230.2L779.1 123.8a80.83 80.83 0 0 0-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L549.8 238.4a80.83 80.83 0 0 0-23.8 57.3c0 21.7 8.5 42.1 23.8 57.4l83.8 83.8A393.82 393.82 0 0 1 553.1 553 395.34 395.34 0 0 1 437 633.8L353.2 550a80.83 80.83 0 0 0-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L123.8 664.5a80.89 80.89 0 0 0-23.8 57.4c0 21.7 8.5 42.1 23.8 57.4l106.3 106.3c24.4 24.5 58.1 38.4 92.7 38.4 7.3 0 14.3-.6 21.2-1.8 134.8-22.2 268.5-93.9 376.4-201.7C828.2 612.8 899.8 479.2 922.3 344c6.8-41.3-6.9-83.8-36.7-113.8z"
                }
            }
        ]
    })(props);
}
function AiFillPicture(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zM338 304c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm513.9 437.1a8.11 8.11 0 0 1-5.2 1.9H177.2c-4.4 0-8-3.6-8-8 0-1.9.7-3.7 1.9-5.2l170.3-202c2.8-3.4 7.9-3.8 11.3-1 .3.3.7.6 1 1l99.4 118 158.1-187.5c2.8-3.4 7.9-3.8 11.3-1 .3.3.7.6 1 1l229.6 271.6c2.6 3.3 2.2 8.4-1.2 11.2z"
                }
            }
        ]
    })(props);
}
function AiFillPieChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M863.1 518.5H505.5V160.9c0-4.4-3.6-8-8-8h-26a398.57 398.57 0 0 0-282.5 117 397.47 397.47 0 0 0-85.6 127C82.6 446.2 72 498.5 72 552.5S82.6 658.7 103.4 708c20.1 47.5 48.9 90.3 85.6 127 36.7 36.7 79.4 65.5 127 85.6a396.64 396.64 0 0 0 155.6 31.5 398.57 398.57 0 0 0 282.5-117c36.7-36.7 65.5-79.4 85.6-127a396.64 396.64 0 0 0 31.5-155.6v-26c-.1-4.4-3.7-8-8.1-8zM951 463l-2.6-28.2c-8.5-92-49.3-178.8-115.1-244.3A398.5 398.5 0 0 0 588.4 75.6L560.1 73c-4.7-.4-8.7 3.2-8.7 7.9v383.7c0 4.4 3.6 8 8 8l383.6-1c4.7-.1 8.4-4 8-8.6z"
                }
            }
        ]
    })(props);
}
function AiFillPlayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm144.1 454.9L437.7 677.8a8.02 8.02 0 0 1-12.7-6.5V353.7a8 8 0 0 1 12.7-6.5L656.1 506a7.9 7.9 0 0 1 0 12.9z"
                }
            }
        ]
    })(props);
}
function AiFillPlaySquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM641.7 520.8L442.3 677.6c-7.4 5.8-18.3.6-18.3-8.8V355.3c0-9.4 10.9-14.7 18.3-8.8l199.4 156.7a11.2 11.2 0 0 1 0 17.6z"
                }
            }
        ]
    })(props);
}
function AiFillPlusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z"
                }
            }
        ]
    })(props);
}
function AiFillPlusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM704 536c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z"
                }
            }
        ]
    })(props);
}
function AiFillPoundCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm146 658c0 4.4-3.6 8-8 8H376.2c-4.4 0-8-3.6-8-8v-38.5c0-3.7 2.5-6.9 6.1-7.8 44-10.9 72.8-49 72.8-94.2 0-14.7-2.5-29.4-5.9-44.2H374c-4.4 0-8-3.6-8-8v-30c0-4.4 3.6-8 8-8h53.7c-7.8-25.1-14.6-50.7-14.6-77.1 0-75.8 58.6-120.3 151.5-120.3 26.5 0 51.4 5.5 70.3 12.7 3.1 1.2 5.2 4.2 5.2 7.5v39.5a8 8 0 0 1-10.6 7.6c-17.9-6.4-39-10.5-60.4-10.5-53.3 0-87.3 26.6-87.3 70.2 0 24.7 6.2 47.9 13.4 70.5h112c4.4 0 8 3.6 8 8v30c0 4.4-3.6 8-8 8h-98.6c3.1 13.2 5.3 26.9 5.3 41 0 40.7-16.5 73.9-43.9 91.1v4.7h180c4.4 0 8 3.6 8 8V722z"
                }
            }
        ]
    })(props);
}
function AiFillPrinter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M732 120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v148h440V120zm120 212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM664 844H360V568h304v276zm164-360c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v40z"
                }
            }
        ]
    })(props);
}
function AiFillProfile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM380 696c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm0-144c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm0-144c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm304 272c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-144c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-144c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48z"
                }
            }
        ]
    })(props);
}
function AiFillProject(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM368 744c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v464zm192-280c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v184zm192 72c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v256z"
                }
            }
        ]
    })(props);
}
function AiFillPropertySafety(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM648.3 332.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V658c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3 73.2-144.3a10 10 0 0 1 8.9-5.5h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8z"
                }
            }
        ]
    })(props);
}
function AiFillPushpin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3-15.4 12.3-16.6 35.4-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 0 0-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8z"
                }
            }
        ]
    })(props);
}
function AiFillQqCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm210.5 612.4c-11.5 1.4-44.9-52.7-44.9-52.7 0 31.3-16.2 72.2-51.1 101.8 16.9 5.2 54.9 19.2 45.9 34.4-7.3 12.3-125.6 7.9-159.8 4-34.2 3.8-152.5 8.3-159.8-4-9.1-15.2 28.9-29.2 45.8-34.4-35-29.5-51.1-70.4-51.1-101.8 0 0-33.4 54.1-44.9 52.7-5.4-.7-12.4-29.6 9.4-99.7 10.3-33 22-60.5 40.2-105.8-3.1-116.9 45.3-215 160.4-215 113.9 0 163.3 96.1 160.4 215 18.1 45.2 29.9 72.8 40.2 105.8 21.7 70.1 14.6 99.1 9.3 99.7z"
                }
            }
        ]
    })(props);
}
function AiFillQqSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM722.5 676.4c-11.5 1.4-44.9-52.7-44.9-52.7 0 31.3-16.2 72.2-51.1 101.8 16.9 5.2 54.9 19.2 45.9 34.4-7.3 12.3-125.6 7.9-159.8 4-34.2 3.8-152.5 8.3-159.8-4-9.1-15.2 28.9-29.2 45.8-34.4-35-29.5-51.1-70.4-51.1-101.8 0 0-33.4 54.1-44.9 52.7-5.4-.7-12.4-29.6 9.4-99.7 10.3-33 22-60.5 40.2-105.8-3.1-116.9 45.3-215 160.4-215 113.9 0 163.3 96.1 160.4 215 18.1 45.2 29.9 72.8 40.2 105.8 21.7 70.1 14.6 99.1 9.3 99.7z"
                }
            }
        ]
    })(props);
}
function AiFillQuestionCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 708c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm62.9-219.5a48.3 48.3 0 0 0-30.9 44.8V620c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-21.5c0-23.1 6.7-45.9 19.9-64.9 12.9-18.6 30.9-32.8 52.1-40.9 34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V420c0-39.3 17.2-76 48.4-103.3C430.4 290.4 470 276 512 276s81.6 14.5 111.6 40.7C654.8 344 672 380.7 672 420c0 57.8-38.1 109.8-97.1 132.5z"
                }
            }
        ]
    })(props);
}
function AiFillRead(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 161H699.2c-49.1 0-97.1 14.1-138.4 40.7L512 233l-48.8-31.3A255.2 255.2 0 0 0 324.8 161H96c-17.7 0-32 14.3-32 32v568c0 17.7 14.3 32 32 32h228.8c49.1 0 97.1 14.1 138.4 40.7l44.4 28.6c1.3.8 2.8 1.3 4.3 1.3s3-.4 4.3-1.3l44.4-28.6C602 807.1 650.1 793 699.2 793H928c17.7 0 32-14.3 32-32V193c0-17.7-14.3-32-32-32zM404 553.5c0 4.1-3.2 7.5-7.1 7.5H211.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm0-140c0 4.1-3.2 7.5-7.1 7.5H211.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm416 140c0 4.1-3.2 7.5-7.1 7.5H627.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm0-140c0 4.1-3.2 7.5-7.1 7.5H627.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45z"
                }
            }
        ]
    })(props);
}
function AiFillReconciliation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M676 623c-18.8 0-34 15.2-34 34s15.2 34 34 34 34-15.2 34-34-15.2-34-34-34zm204-455H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zM448 848H176V616h272v232zm0-296H176v-88h272v88zm20-272v-48h72v-56h64v56h72v48H468zm180 168v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8zm28 301c-50.8 0-92-41.2-92-92s41.2-92 92-92 92 41.2 92 92-41.2 92-92 92zm92-245c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v96zm-92 61c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34z"
                }
            }
        ]
    })(props);
}
function AiFillRedEnvelope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM647 470.4l-87.2 161h45.9c4.6 0 8.4 3.8 8.4 8.4v25.1c0 4.6-3.8 8.4-8.4 8.4h-63.3v28.6h63.3c4.6 0 8.4 3.8 8.4 8.4v25c.2 4.6-3.6 8.5-8.2 8.5h-63.3v49.9c0 4.6-3.8 8.4-8.4 8.4h-43.7c-4.6 0-8.4-3.8-8.4-8.4v-49.9h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h63v-28.6h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h45.4l-87.5-161c-2.2-4.1-.7-9.1 3.4-11.4 1.3-.6 2.6-1 3.9-1h48.8c3.2 0 6.1 1.8 7.5 4.6l71.9 141.8 71.9-141.9a8.5 8.5 0 0 1 7.5-4.6h47.8c4.6 0 8.4 3.8 8.4 8.4-.1 1.5-.5 2.9-1.1 4.1zM512.6 323L289 148h446L512.6 323z"
                }
            }
        ]
    })(props);
}
function AiFillRedditCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M584 548a36 36 0 1 0 72 0 36 36 0 1 0-72 0zm144-108a35.9 35.9 0 0 0-32.5 20.6c18.8 14.3 34.4 30.7 45.9 48.8A35.98 35.98 0 0 0 728 440zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm245 477.9c4.6 13.5 7 27.6 7 42.1 0 99.4-112.8 180-252 180s-252-80.6-252-180c0-14.5 2.4-28.6 7-42.1A72.01 72.01 0 0 1 296 404c27.1 0 50.6 14.9 62.9 37 36.2-19.8 80.2-32.8 128.1-36.1l58.4-131.1c4.3-9.8 15.2-14.8 25.5-11.8l91.6 26.5a54.03 54.03 0 0 1 101.6 25.6c0 29.8-24.2 54-54 54-23.5 0-43.5-15.1-50.9-36.1L577 308.3l-43 96.5c49.1 3 94.2 16.1 131.2 36.3 12.3-22.1 35.8-37 62.9-37 39.8 0 72 32.2 72 72-.1 29.3-17.8 54.6-43.1 65.8zm-171.3 83c-14.9 11.7-44.3 24.3-73.7 24.3s-58.9-12.6-73.7-24.3c-9.3-7.3-22.7-5.7-30 3.6-7.3 9.3-5.7 22.7 3.6 30 25.7 20.4 65 33.5 100.1 33.5 35.1 0 74.4-13.1 100.2-33.5 9.3-7.3 10.9-20.8 3.6-30a21.46 21.46 0 0 0-30.1-3.6zM296 440a35.98 35.98 0 0 0-13.4 69.4c11.5-18.1 27.1-34.5 45.9-48.8A35.9 35.9 0 0 0 296 440zm72 108a36 36 0 1 0 72 0 36 36 0 1 0-72 0z"
                }
            }
        ]
    })(props);
}
function AiFillRedditSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 440a35.98 35.98 0 0 0-13.4 69.4c11.5-18.1 27.1-34.5 45.9-48.8A35.9 35.9 0 0 0 296 440zm289.7 184.9c-14.9 11.7-44.3 24.3-73.7 24.3s-58.9-12.6-73.7-24.3c-9.3-7.3-22.7-5.7-30 3.6-7.3 9.3-5.7 22.7 3.6 30 25.7 20.4 65 33.5 100.1 33.5 35.1 0 74.4-13.1 100.2-33.5 9.3-7.3 10.9-20.8 3.6-30a21.46 21.46 0 0 0-30.1-3.6zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM757 541.9c4.6 13.5 7 27.6 7 42.1 0 99.4-112.8 180-252 180s-252-80.6-252-180c0-14.5 2.4-28.6 7-42.1A72.01 72.01 0 0 1 296 404c27.1 0 50.6 14.9 62.9 37 36.2-19.8 80.2-32.8 128.1-36.1l58.4-131.1c4.3-9.8 15.2-14.8 25.5-11.8l91.6 26.5a54.03 54.03 0 0 1 101.6 25.6c0 29.8-24.2 54-54 54-23.5 0-43.5-15.1-50.9-36.1L577 308.3l-43 96.5c49.1 3 94.2 16.1 131.2 36.3 12.3-22.1 35.8-37 62.9-37 39.8 0 72 32.2 72 72-.1 29.3-17.8 54.6-43.1 65.8zM584 548a36 36 0 1 0 72 0 36 36 0 1 0-72 0zm144-108a35.9 35.9 0 0 0-32.5 20.6c18.8 14.3 34.4 30.7 45.9 48.8A35.98 35.98 0 0 0 728 440zM368 548a36 36 0 1 0 72 0 36 36 0 1 0-72 0z"
                }
            }
        ]
    })(props);
}
function AiFillRest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0 0 31.9 29.3h429.2a32 32 0 0 0 31.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zM508 704c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144zM291 256l22.4-76h397.2l22.4 76H291zm137 304a80 80 0 1 0 160 0 80 80 0 1 0-160 0z"
                }
            }
        ]
    })(props);
}
function AiFillRightCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm154.7 454.5l-246 178c-5.3 3.8-12.7 0-12.7-6.5v-46.9c0-10.2 4.9-19.9 13.2-25.9L566.6 512 421.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.8 0 13z"
                }
            }
        ]
    })(props);
}
function AiFillRightSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM658.7 518.5l-246 178c-5.3 3.8-12.7 0-12.7-6.5v-46.9c0-10.2 4.9-19.9 13.2-25.9L558.6 512 413.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.8 0 13z"
                }
            }
        ]
    })(props);
}
function AiFillRobot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569682613478",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M852 64H172c-17.7 0-32 14.3-32 32v660c0 17.7 14.3 32 32 32h680c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM300 328c0-33.1 26.9-60 60-60s60 26.9 60 60-26.9 60-60 60-60-26.9-60-60z m372 248c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-60c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v60z m-8-188c-33.1 0-60-26.9-60-60s26.9-60 60-60 60 26.9 60 60-26.9 60-60 60zM799 864H225c-13.8 0-25 14.3-25 32v56c0 4.4 2.8 8 6.2 8h611.5c3.4 0 6.2-3.6 6.2-8v-56c0.1-17.7-11.1-32-24.9-32z"
                }
            }
        ]
    })(props);
}
function AiFillRocket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 0 0-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0 0 43.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0 0 43.1-30.5 97.52 97.52 0 0 0 21.4-60.8c0-8.4-1.1-16.4-3.1-23.8L864 736zM512 352a48.01 48.01 0 0 1 0 96 48.01 48.01 0 0 1 0-96zm116.1 432.2c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5s-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 0 1-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5z"
                }
            }
        ]
    })(props);
}
function AiFillSafetyCertificate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM694.5 340.7L481.9 633.4a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.1 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.8-6.6 13-6.6H688c6.5.1 10.3 7.5 6.5 12.8z"
                }
            }
        ]
    })(props);
}
function AiFillSave(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M893.3 293.3L730.7 130.7c-12-12-28.3-18.7-45.3-18.7H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 176h256v112H384V176zm128 554c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144zm0-224c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80z"
                }
            }
        ]
    })(props);
}
function AiFillSchedule(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zM424 688c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-136c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm374.5-91.3l-165 228.7a15.9 15.9 0 0 1-25.8 0L493.5 531.2c-3.8-5.3 0-12.7 6.5-12.7h54.9c5.1 0 9.9 2.5 12.9 6.6l52.8 73.1 103.7-143.7c3-4.2 7.8-6.6 12.9-6.6H792c6.5.1 10.3 7.5 6.5 12.8z"
                }
            }
        ]
    })(props);
}
function AiFillSecurityScan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM626.8 554c-48.5 48.5-123 55.2-178.6 20.1l-77.5 77.5a8.03 8.03 0 0 1-11.3 0l-34-34a8.03 8.03 0 0 1 0-11.3l77.5-77.5c-35.1-55.7-28.4-130.1 20.1-178.6 56.3-56.3 147.5-56.3 203.8 0 56.3 56.3 56.3 147.5 0 203.8zm-158.54-45.27a80.1 80.1 0 1 0 113.27-113.28 80.1 80.1 0 1 0-113.27 113.28z"
                }
            }
        ]
    })(props);
}
function AiFillSetting(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512.5 390.6c-29.9 0-57.9 11.6-79.1 32.8-21.1 21.2-32.8 49.2-32.8 79.1 0 29.9 11.7 57.9 32.8 79.1 21.2 21.1 49.2 32.8 79.1 32.8 29.9 0 57.9-11.7 79.1-32.8 21.1-21.2 32.8-49.2 32.8-79.1 0-29.9-11.7-57.9-32.8-79.1a110.96 110.96 0 0 0-79.1-32.8zm412.3 235.5l-65.4-55.9c3.1-19 4.7-38.4 4.7-57.7s-1.6-38.8-4.7-57.7l65.4-55.9a32.03 32.03 0 0 0 9.3-35.2l-.9-2.6a442.5 442.5 0 0 0-79.6-137.7l-1.8-2.1a32.12 32.12 0 0 0-35.1-9.5l-81.2 28.9c-30-24.6-63.4-44-99.6-57.5l-15.7-84.9a32.05 32.05 0 0 0-25.8-25.7l-2.7-.5c-52-9.4-106.8-9.4-158.8 0l-2.7.5a32.05 32.05 0 0 0-25.8 25.7l-15.8 85.3a353.44 353.44 0 0 0-98.9 57.3l-81.8-29.1a32 32 0 0 0-35.1 9.5l-1.8 2.1a445.93 445.93 0 0 0-79.6 137.7l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.2 56.5c-3.1 18.8-4.6 38-4.6 57 0 19.2 1.5 38.4 4.6 57l-66 56.5a32.03 32.03 0 0 0-9.3 35.2l.9 2.6c18.1 50.3 44.8 96.8 79.6 137.7l1.8 2.1a32.12 32.12 0 0 0 35.1 9.5l81.8-29.1c29.8 24.5 63 43.9 98.9 57.3l15.8 85.3a32.05 32.05 0 0 0 25.8 25.7l2.7.5a448.27 448.27 0 0 0 158.8 0l2.7-.5a32.05 32.05 0 0 0 25.8-25.7l15.7-84.9c36.2-13.6 69.6-32.9 99.6-57.5l81.2 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.5-87.4 79.6-137.7l.9-2.6c4.3-12.4.6-26.3-9.5-35zm-412.3 52.2c-97.1 0-175.8-78.7-175.8-175.8s78.7-175.8 175.8-175.8 175.8 78.7 175.8 175.8-78.7 175.8-175.8 175.8z"
                }
            }
        ]
    })(props);
}
function AiFillShop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0 0 14.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h274V736h128v176h274c17.7 0 32-14.3 32-32V535a175 175 0 0 0 15.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zm-72 568H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 3-1.3 6-2.6 9-4v242.2zm0-568.1H214v-88h596v88z"
                }
            }
        ]
    })(props);
}
function AiFillShopping(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-208 0H400v-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16z"
                }
            }
        ]
    })(props);
}
function AiFillSignal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569682885975",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M584 352H440c-17.7 0-32 14.3-32 32v544c0 17.7 14.3 32 32 32h144c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32zM892 64H748c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h144c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM276 640H132c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h144c17.7 0 32-14.3 32-32V672c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function AiFillSketchCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M582.3 625.6l147.9-166.3h-63.4zm90-202.3h62.5l-92.1-115.1zm-274.7 36L512 684.5l114.4-225.2zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm286.7 380.2L515.8 762.3c-1 1.1-2.4 1.7-3.8 1.7s-2.8-.6-3.8-1.7L225.3 444.2a5.14 5.14 0 0 1-.2-6.6L365.6 262c1-1.2 2.4-1.9 4-1.9h284.6c1.6 0 3 .7 4 1.9l140.5 175.6a4.9 4.9 0 0 1 0 6.6zm-190.5-20.9L512 326.1l-96.2 97.2zM420.3 301.1l-23.1 89.8 88.8-89.8zm183.4 0H538l88.8 89.8zm-222.4 7.1l-92.1 115.1h62.5zm-87.5 151.1l147.9 166.3-84.5-166.3z"
                }
            }
        ]
    })(props);
}
function AiFillSketchSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608.2 423.3L512 326.1l-96.2 97.2zm-25.9 202.3l147.9-166.3h-63.4zm90-202.3h62.5l-92.1-115.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-81.3 332.2L515.8 762.3c-1 1.1-2.4 1.7-3.8 1.7s-2.8-.6-3.8-1.7L225.3 444.2a5.14 5.14 0 0 1-.2-6.6L365.6 262c1-1.2 2.4-1.9 4-1.9h284.6c1.6 0 3 .7 4 1.9l140.5 175.6a4.9 4.9 0 0 1 0 6.6zm-401.1 15.1L512 684.5l114.4-225.2zm-16.3-151.1l-92.1 115.1h62.5zm-87.5 151.1l147.9 166.3-84.5-166.3zm126.5-158.2l-23.1 89.8 88.8-89.8zm183.4 0H538l88.8 89.8z"
                }
            }
        ]
    })(props);
}
function AiFillSkin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 0 0-37-29.3H154a44 44 0 0 0-44 44v252a44 44 0 0 0 44 44h75v388a44 44 0 0 0 44 44h478a44 44 0 0 0 44-44V466h75a44 44 0 0 0 44-44V170a44 44 0 0 0-44-44z"
                }
            }
        ]
    })(props);
}
function AiFillSkype(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M883.7 578.6c4.1-22.5 6.3-45.5 6.3-68.5 0-51-10-100.5-29.7-147-19-45-46.3-85.4-81-120.1a375.79 375.79 0 0 0-120.1-80.9c-46.6-19.7-96-29.7-147-29.7-24 0-48.1 2.3-71.5 6.8A225.1 225.1 0 0 0 335.6 113c-59.7 0-115.9 23.3-158.1 65.5A222.25 222.25 0 0 0 112 336.6c0 38 9.8 75.4 28.1 108.4-3.7 21.4-5.7 43.3-5.7 65.1 0 51 10 100.5 29.7 147 19 45 46.2 85.4 80.9 120.1 34.7 34.7 75.1 61.9 120.1 80.9 46.6 19.7 96 29.7 147 29.7 22.2 0 44.4-2 66.2-5.9 33.5 18.9 71.3 29 110 29 59.7 0 115.9-23.2 158.1-65.5 42.3-42.2 65.5-98.4 65.5-158.1.1-38-9.7-75.5-28.2-108.7zm-370 162.9c-134.2 0-194.2-66-194.2-115.4 0-25.4 18.7-43.1 44.5-43.1 57.4 0 42.6 82.5 149.7 82.5 54.9 0 85.2-29.8 85.2-60.3 0-18.3-9-38.7-45.2-47.6l-119.4-29.8c-96.1-24.1-113.6-76.1-113.6-124.9 0-101.4 95.5-139.5 185.2-139.5 82.6 0 180 45.7 180 106.5 0 26.1-22.6 41.2-48.4 41.2-49 0-40-67.8-138.7-67.8-49 0-76.1 22.2-76.1 53.9s38.7 41.8 72.3 49.5l88.4 19.6c96.8 21.6 121.3 78.1 121.3 131.3 0 82.3-63.3 143.9-191 143.9z"
                }
            }
        ]
    })(props);
}
function AiFillSlackCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4-13.3 0-26.1-5.3-35.6-14.8-9.4-9.5-14.7-22.3-14.7-35.6 0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4 13.3 0 26.1 5.3 35.6 14.8s14.7 22.3 14.7 35.6v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm83.7-50.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM579.3 765c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134c-13.3 0-26.1-5.3-35.6-14.8S529 593.6 529 580.2c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z"
                }
            }
        ]
    })(props);
}
function AiFillSlackSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM529 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4-13.3 0-26.1-5.3-35.6-14.8-9.4-9.5-14.7-22.3-14.7-35.6 0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4 13.3 0 26.1 5.3 35.6 14.8s14.7 22.3 14.7 35.6v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm134 403.2c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134c-13.3 0-26.1-5.3-35.6-14.8-9.4-9.5-14.7-22.3-14.7-35.6 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z"
                }
            }
        ]
    })(props);
}
function AiFillSliders(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M904 296h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-584-72h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm292 180h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiFillSmile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm224 272c-85.5 0-155.6-67.3-160-151.6a8 8 0 0 1 8-8.4h48.1c4.2 0 7.8 3.2 8.1 7.4C420 589.9 461.5 629 512 629s92.1-39.1 95.8-88.6c.3-4.2 3.9-7.4 8.1-7.4H664a8 8 0 0 1 8 8.4C667.6 625.7 597.5 693 512 693zm176-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            }
        ]
    })(props);
}
function AiFillSnippets(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 486H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z"
                }
            }
        ]
    })(props);
}
function AiFillSound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M892.1 737.8l-110.3-63.7a15.9 15.9 0 0 0-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0 0 21.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM760 344a15.9 15.9 0 0 0 21.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 0 0-21.7-5.9L746 287.8a15.99 15.99 0 0 0-5.8 21.8L760 344zm174 132H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zM625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1z"
                }
            }
        ]
    })(props);
}
function AiFillStar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z"
                }
            }
        ]
    })(props);
}
function AiFillStepBackward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M347.6 528.95l383.2 301.02c14.25 11.2 35.2 1.1 35.2-16.95V210.97c0-18.05-20.95-28.14-35.2-16.94L347.6 495.05a21.53 21.53 0 0 0 0 33.9M330 864h-64a8 8 0 0 1-8-8V168a8 8 0 0 1 8-8h64a8 8 0 0 1 8 8v688a8 8 0 0 1-8 8"
                }
            }
        ]
    })(props);
}
function AiFillStepForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M676.4 528.95L293.2 829.97c-14.25 11.2-35.2 1.1-35.2-16.95V210.97c0-18.05 20.95-28.14 35.2-16.94l383.2 301.02a21.53 21.53 0 0 1 0 33.9M694 864h64a8 8 0 0 0 8-8V168a8 8 0 0 0-8-8h-64a8 8 0 0 0-8 8v688a8 8 0 0 0 8 8"
                }
            }
        ]
    })(props);
}
function AiFillStop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm234.8 736.5L223.5 277.2c16-19.7 34-37.7 53.7-53.7l523.3 523.3c-16 19.6-34 37.7-53.7 53.7z"
                }
            }
        ]
    })(props);
}
function AiFillSwitcher(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zM596 606c0 4.4-3.6 8-8 8H308c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h280c4.4 0 8 3.6 8 8v48zm284-494H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function AiFillTablet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM512 824c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z"
                }
            }
        ]
    })(props);
}
function AiFillTag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 0 0 0 14.1l363.8 363.8c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM699 387c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"
                }
            }
        ]
    })(props);
}
function AiFillTags(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.2 790.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3c-2.3-.2-4.7.6-6.3 2.3L137.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c3.1 3.2 8.2 3.2 11.3 0zm122.7-533.4c18.7-18.7 49.1-18.7 67.9 0 18.7 18.7 18.7 49.1 0 67.9-18.7 18.7-49.1 18.7-67.9 0-18.7-18.7-18.7-49.1 0-67.9zm283.8 282.9l-39.6-39.5a8.03 8.03 0 0 0-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 0 0-11.3 0l-39.6 39.5a8.03 8.03 0 0 0 0 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3z"
                }
            }
        ]
    })(props);
}
function AiFillTaobaoCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 1 1 0-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z"
                }
            }
        ]
    })(props);
}
function AiFillTaobaoSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 1 1 0-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z"
                }
            }
        ]
    })(props);
}
function AiFillThunderbolt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M848 359.3H627.7L825.8 109c4.1-5.3.4-13-6.3-13H436c-2.8 0-5.5 1.5-6.9 4L170 547.5c-3.1 5.3.7 12 6.9 12h174.4l-89.4 357.6c-1.9 7.8 7.5 13.3 13.3 7.7L853.5 373c5.2-4.9 1.7-13.7-5.5-13.7z"
                }
            }
        ]
    })(props);
}
function AiFillTool(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M865.3 244.7c-.3-.3-61.1 59.8-182.1 180.6l-84.9-84.9 180.9-180.9c-95.2-57.3-217.5-42.6-296.8 36.7A244.42 244.42 0 0 0 419 432l1.8 6.7-283.5 283.4c-6.2 6.2-6.2 16.4 0 22.6l141.4 141.4c6.2 6.2 16.4 6.2 22.6 0l283.3-283.3 6.7 1.8c83.7 22.3 173.6-.9 236-63.3 79.4-79.3 94.1-201.6 38-296.6z"
                }
            }
        ]
    })(props);
}
function AiFillTrademarkCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm164.7 660.2c-1.1.5-2.3.8-3.5.8h-62c-3.1 0-5.9-1.8-7.2-4.6l-74.6-159.2h-88.7V717c0 4.4-3.6 8-8 8H378c-4.4 0-8-3.6-8-8V307c0-4.4 3.6-8 8-8h155.6c98.8 0 144.2 59.9 144.2 131.1 0 70.2-43.6 106.4-78.4 119.2l80.8 164.2c2.1 3.9.4 8.7-3.5 10.7zM523.9 357h-83.4v148H522c53 0 82.8-25.6 82.8-72.4 0-50.3-32.9-75.6-80.9-75.6z"
                }
            }
        ]
    })(props);
}
function AiFillTrophy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 0 0-44 44v148c0 81.7 60 149.6 138.2 162C265.6 630.2 359 721.8 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.8 758.4 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 0 0-44-44zM248 439.6c-37.1-11.9-64-46.7-64-87.6V232h64v207.6zM840 352c0 41-26.9 75.8-64 87.6V232h64v120z"
                }
            }
        ]
    })(props);
}
function AiFillTwitterCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm215.3 337.7c.3 4.7.3 9.6.3 14.4 0 146.8-111.8 315.9-316.1 315.9-63 0-121.4-18.3-170.6-49.8 9 1 17.6 1.4 26.8 1.4 52 0 99.8-17.6 137.9-47.4-48.8-1-89.8-33-103.8-77 17.1 2.5 32.5 2.5 50.1-2a111 111 0 0 1-88.9-109v-1.4c14.7 8.3 32 13.4 50.1 14.1a111.13 111.13 0 0 1-49.5-92.4c0-20.7 5.4-39.6 15.1-56a315.28 315.28 0 0 0 229 116.1C492 353.1 548.4 292 616.2 292c32 0 60.8 13.4 81.1 35 25.1-4.7 49.1-14.1 70.5-26.7-8.3 25.7-25.7 47.4-48.8 61.1 22.4-2.4 44-8.6 64-17.3-15.1 22.2-34 41.9-55.7 57.6z"
                }
            }
        ]
    })(props);
}
function AiFillTwitterSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM727.3 401.7c.3 4.7.3 9.6.3 14.4 0 146.8-111.8 315.9-316.1 315.9-63 0-121.4-18.3-170.6-49.8 9 1 17.6 1.4 26.8 1.4 52 0 99.8-17.6 137.9-47.4-48.8-1-89.8-33-103.8-77 17.1 2.5 32.5 2.5 50.1-2a111 111 0 0 1-88.9-109v-1.4c14.7 8.3 32 13.4 50.1 14.1a111.13 111.13 0 0 1-49.5-92.4c0-20.7 5.4-39.6 15.1-56a315.28 315.28 0 0 0 229 116.1C492 353.1 548.4 292 616.2 292c32 0 60.8 13.4 81.1 35 25.1-4.7 49.1-14.1 70.5-26.7-8.3 25.7-25.7 47.4-48.8 61.1 22.4-2.4 44-8.6 64-17.3-15.1 22.2-34 41.9-55.7 57.6z"
                }
            }
        ]
    })(props);
}
function AiFillUnlock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM540 701v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 1 1 56 0z"
                }
            }
        ]
    })(props);
}
function AiFillUpCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm178 555h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 460.4 406.8 605.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z"
                }
            }
        ]
    })(props);
}
function AiFillUpSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM690 624h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 465.4 406.8 610.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z"
                }
            }
        ]
    })(props);
}
function AiFillUsb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408 312h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm352 120V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zm-72 0H336V184h352v248zM568 312h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiFillVideoCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM328 352c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v48zm560 273l-104-59.8V458.9L888 399v226z"
                }
            }
        ]
    })(props);
}
function AiFillWallet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-32 464H528V448h320v128zm-268-64a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiFillWarning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416zm32 352a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            }
        ]
    })(props);
}
function AiFillWechat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M690.1 377.4c5.9 0 11.8.2 17.6.5-24.4-128.7-158.3-227.1-319.9-227.1C209 150.8 64 271.4 64 420.2c0 81.1 43.6 154.2 111.9 203.6a21.5 21.5 0 0 1 9.1 17.6c0 2.4-.5 4.6-1.1 6.9-5.5 20.3-14.2 52.8-14.6 54.3-.7 2.6-1.7 5.2-1.7 7.9 0 5.9 4.8 10.8 10.8 10.8 2.3 0 4.2-.9 6.2-2l70.9-40.9c5.3-3.1 11-5 17.2-5 3.2 0 6.4.5 9.5 1.4 33.1 9.5 68.8 14.8 105.7 14.8 6 0 11.9-.1 17.8-.4-7.1-21-10.9-43.1-10.9-66 0-135.8 132.2-245.8 295.3-245.8zm-194.3-86.5c23.8 0 43.2 19.3 43.2 43.1s-19.3 43.1-43.2 43.1c-23.8 0-43.2-19.3-43.2-43.1s19.4-43.1 43.2-43.1zm-215.9 86.2c-23.8 0-43.2-19.3-43.2-43.1s19.3-43.1 43.2-43.1 43.2 19.3 43.2 43.1-19.4 43.1-43.2 43.1zm586.8 415.6c56.9-41.2 93.2-102 93.2-169.7 0-124-120.8-224.5-269.9-224.5-149 0-269.9 100.5-269.9 224.5S540.9 847.5 690 847.5c30.8 0 60.6-4.4 88.1-12.3 2.6-.8 5.2-1.2 7.9-1.2 5.2 0 9.9 1.6 14.3 4.1l59.1 34c1.7 1 3.3 1.7 5.2 1.7a9 9 0 0 0 6.4-2.6 9 9 0 0 0 2.6-6.4c0-2.2-.9-4.4-1.4-6.6-.3-1.2-7.6-28.3-12.2-45.3-.5-1.9-.9-3.8-.9-5.7.1-5.9 3.1-11.2 7.6-14.5zM600.2 587.2c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9c0 19.8-16.2 35.9-36 35.9zm179.9 0c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9a36.08 36.08 0 0 1-36 35.9z"
                }
            }
        ]
    })(props);
}
function AiFillWeiboCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-44.4 672C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-93-32.2c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zm34.9-14.5c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z"
                }
            }
        ]
    })(props);
}
function AiFillWeiboSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.6 595.1c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM467.6 736C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-58.1-46.7c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z"
                }
            }
        ]
    })(props);
}
function AiFillWindows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M523.8 191.4v288.9h382V128.1zm0 642.2l382 62.2v-352h-382zM120.1 480.2H443V201.9l-322.9 53.5zm0 290.4L443 823.2V543.8H120.1z"
                }
            }
        ]
    })(props);
}
function AiFillYahoo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M937.3 231H824.7c-15.5 0-27.7 12.6-27.1 28.1l13.1 366h84.4l65.4-366.4c2.7-15.2-7.8-27.7-23.2-27.7zm-77.4 450.4h-14.1c-27.1 0-49.2 22.2-49.2 49.3v14.1c0 27.1 22.2 49.3 49.2 49.3h14.1c27.1 0 49.2-22.2 49.2-49.3v-14.1c0-27.1-22.2-49.3-49.2-49.3zM402.6 231C216.2 231 65 357 65 512.5S216.2 794 402.6 794s337.6-126 337.6-281.5S589.1 231 402.6 231zm225.2 225.2h-65.3L458.9 559.8v65.3h84.4v56.3H318.2v-56.3h84.4v-65.3L242.9 399.9h-37v-56.3h168.5v56.3h-37l93.4 93.5 28.1-28.1V400h168.8v56.2z"
                }
            }
        ]
    })(props);
}
function AiFillYoutube(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M941.3 296.1a112.3 112.3 0 0 0-79.2-79.3C792.2 198 512 198 512 198s-280.2 0-350.1 18.7A112.12 112.12 0 0 0 82.7 296C64 366 64 512 64 512s0 146 18.7 215.9c10.3 38.6 40.7 69 79.2 79.3C231.8 826 512 826 512 826s280.2 0 350.1-18.8c38.6-10.3 68.9-40.7 79.2-79.3C960 658 960 512 960 512s0-146-18.7-215.9zM423 646V378l232 133-232 135z"
                }
            }
        ]
    })(props);
}
function AiFillYuque(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 370.6c-9.9-39.4 9.9-102.2 73.4-124.4l-67.9-3.6s-25.7-90-143.6-98c-117.9-8.1-195-3-195-3s87.4 55.6 52.4 154.7c-25.6 52.5-65.8 95.6-108.8 144.7-1.3 1.3-2.5 2.6-3.5 3.7C319.4 605 96 860 96 860c245.9 64.4 410.7-6.3 508.2-91.1 20.5-.2 35.9-.3 46.3-.3 135.8 0 250.6-117.6 245.9-248.4-3.2-89.9-31.9-110.2-41.8-149.6z"
                }
            }
        ]
    })(props);
}
function AiFillZhihuCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-90.7 477.8l-.1 1.5c-1.5 20.4-6.3 43.9-12.9 67.6l24-18.1 71 80.7c9.2 33-3.3 63.1-3.3 63.1l-95.7-111.9v-.1c-8.9 29-20.1 57.3-33.3 84.7-22.6 45.7-55.2 54.7-89.5 57.7-34.4 3-23.3-5.3-23.3-5.3 68-55.5 78-87.8 96.8-123.1 11.9-22.3 20.4-64.3 25.3-96.8H264.1s4.8-31.2 19.2-41.7h101.6c.6-15.3-1.3-102.8-2-131.4h-49.4c-9.2 45-41 56.7-48.1 60.1-7 3.4-23.6 7.1-21.1 0 2.6-7.1 27-46.2 43.2-110.7 16.3-64.6 63.9-62 63.9-62-12.8 22.5-22.4 73.6-22.4 73.6h159.7c10.1 0 10.6 39 10.6 39h-90.8c-.7 22.7-2.8 83.8-5 131.4H519s12.2 15.4 12.2 41.7H421.3zm346.5 167h-87.6l-69.5 46.6-16.4-46.6h-40.1V321.5h213.6v387.3zM408.2 611s0-.1 0 0zm216 94.3l56.8-38.1h45.6-.1V364.7H596.7v302.5h14.1z"
                }
            }
        ]
    })(props);
}
function AiFillZhihuSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM432.3 592.8l71 80.7c9.2 33-3.3 63.1-3.3 63.1l-95.7-111.9v-.1c-8.9 29-20.1 57.3-33.3 84.7-22.6 45.7-55.2 54.7-89.5 57.7-34.4 3-23.3-5.3-23.3-5.3 68-55.5 78-87.8 96.8-123.1 11.9-22.3 20.4-64.3 25.3-96.8H264.1s4.8-31.2 19.2-41.7h101.6c.6-15.3-1.3-102.8-2-131.4h-49.4c-9.2 45-41 56.7-48.1 60.1-7 3.4-23.6 7.1-21.1 0 2.6-7.1 27-46.2 43.2-110.7 16.3-64.6 63.9-62 63.9-62-12.8 22.5-22.4 73.6-22.4 73.6h159.7c10.1 0 10.6 39 10.6 39h-90.8c-.7 22.7-2.8 83.8-5 131.4H519s12.2 15.4 12.2 41.7h-110l-.1 1.5c-1.5 20.4-6.3 43.9-12.9 67.6l24.1-18.1zm335.5 116h-87.6l-69.5 46.6-16.4-46.6h-40.1V321.5h213.6v387.3zM408.2 611s0-.1 0 0zm216 94.3l56.8-38.1h45.6-.1V364.7H596.7v302.5h14.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineAccountBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584zM639.5 414h-45c-3 0-5.8 1.7-7.1 4.4L514 563.8h-2.8l-73.4-145.4a8 8 0 0 0-7.1-4.4h-46c-1.3 0-2.7.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9l89.3 164h-48.6c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1v33.7h-65.1c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1V752c0 4.4 3.6 8 8 8h41.3c4.4 0 8-3.6 8-8v-53.8h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-65.4v-33.7h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-49.1l89.3-164.1c.6-1.2 1-2.5 1-3.8.1-4.4-3.4-8-7.9-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineAim(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683657482",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M952 474H829.8C812.5 327.6 696.4 211.5 550 194.2V72c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v122.2C327.6 211.5 211.5 327.6 194.2 474H72c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h122.2C211.5 696.4 327.6 812.5 474 829.8V952c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V829.8C696.4 812.5 812.5 696.4 829.8 550H952c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM512 756c-134.8 0-244-109.2-244-244s109.2-244 244-244 244 109.2 244 244-109.2 244-244 244z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 392c-32.1 0-62.1 12.4-84.8 35.2-22.7 22.7-35.2 52.7-35.2 84.8s12.5 62.1 35.2 84.8C449.9 619.4 480 632 512 632s62.1-12.5 84.8-35.2C619.4 574.1 632 544 632 512s-12.5-62.1-35.2-84.8C574.1 404.4 544.1 392 512 392z"
                }
            }
        ]
    })(props);
}
function AiOutlineAlert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M193 796c0 17.7 14.3 32 32 32h574c17.7 0 32-14.3 32-32V563c0-176.2-142.8-319-319-319S193 386.8 193 563v233zm72-233c0-136.4 110.6-247 247-247s247 110.6 247 247v193H404V585c0-5.5-4.5-10-10-10h-44c-5.5 0-10 4.5-10 10v171h-75V563zm-48.1-252.5l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3l-67.9-67.9a8.03 8.03 0 0 0-11.3 0l-39.6 39.6a8.03 8.03 0 0 0 0 11.3l67.9 67.9c3.1 3.1 8.1 3.1 11.3 0zm669.6-79.2l-39.6-39.6a8.03 8.03 0 0 0-11.3 0l-67.9 67.9a8.03 8.03 0 0 0 0 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l67.9-67.9c3.1-3.2 3.1-8.2 0-11.3zM832 892H192c-17.7 0-32 14.3-32 32v24c0 4.4 3.6 8 8 8h688c4.4 0 8-3.6 8-8v-24c0-17.7-14.3-32-32-32zM484 180h56c4.4 0 8-3.6 8-8V76c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineAlibaba(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M602.9 669.8c-37.2 2.6-33.6-17.3-11.5-46.2 50.4-67.2 143.7-158.5 147.9-225.2 5.8-86.6-81.3-113.4-171-113.4-62.4 1.6-127 18.9-171 34.6-151.6 53.5-246.6 137.5-306.9 232-62.4 93.4-43 183.2 91.8 185.8 101.8-4.2 170.5-32.5 239.7-68.2.5 0-192.5 55.1-263.9 14.7-7.9-4.2-15.7-10-17.8-26.2 0-33.1 54.6-67.7 86.6-78.7v-56.7c64.5 22.6 140.6 16.3 205.7-32 2.1 5.8 4.2 13.1 3.7 21h11c2.6-22.6-12.6-44.6-37.8-46.2 7.3 5.8 12.6 10.5 15.2 14.7l-1 1-.5.5c-83.9 58.8-165.3 31.5-173.1 29.9l46.7-45.7-13.1-33.1c92.9-32.5 169.5-56.2 296.9-78.7l-28.5-23 14.7-8.9c75.5 21 126.4 36.7 123.8 76.6-1 6.8-3.7 14.7-7.9 23.1C660.1 466.1 594 538 567.2 569c-17.3 20.5-34.6 39.4-46.7 58.3-13.6 19.4-20.5 37.3-21 53.5 2.6 131.8 391.4-61.9 468-112.9-111.7 47.8-232.9 93.5-364.6 101.9zm85-302.9c2.8 5.2 4.1 11.6 4.1 19.1-.1-6.8-1.4-13.3-4.1-19.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineAlignCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M264 230h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm496 424c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496zm144 140H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineAlignLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120 230h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 424h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm784 140H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineAlignRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M904 158H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 424H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 212H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineAlipayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zm460.5 67c100.1 33.4 154.7 43 166.7 44.8A445.9 445.9 0 0 0 960 512c0-247.4-200.6-448-448-448S64 264.6 64 512s200.6 448 448 448c155.9 0 293.2-79.7 373.5-200.5-75.6-29.8-213.6-85-286.8-120.1-69.9 85.7-160.1 137.8-253.7 137.8-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineAlipay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M789 610.3c-38.7-12.9-90.7-32.7-148.5-53.6 34.8-60.3 62.5-129 80.7-203.6H530.5v-68.6h233.6v-38.3H530.5V132h-95.4c-16.7 0-16.7 16.5-16.7 16.5v97.8H182.2v38.3h236.3v68.6H223.4v38.3h378.4a667.18 667.18 0 0 1-54.5 132.9c-122.8-40.4-253.8-73.2-336.1-53-52.6 13-86.5 36.1-106.5 60.3-91.4 111-25.9 279.6 167.2 279.6C386 811.2 496 747.6 581.2 643 708.3 704 960 808.7 960 808.7V659.4s-31.6-2.5-171-49.1zM253.9 746.6c-150.5 0-195-118.3-120.6-183.1 24.8-21.9 70.2-32.6 94.4-35 89.4-8.8 172.2 25.2 269.9 72.8-68.8 89.5-156.3 145.3-243.7 145.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineAliwangwang(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M868.2 377.4c-18.9-45.1-46.3-85.6-81.2-120.6a377.26 377.26 0 0 0-120.5-81.2A375.65 375.65 0 0 0 519 145.8c-41.9 0-82.9 6.7-121.9 20C306 123.3 200.8 120 170.6 120c-2.2 0-7.4 0-9.4.2-11.9.4-22.8 6.5-29.2 16.4-6.5 9.9-7.7 22.4-3.4 33.5l64.3 161.6a378.59 378.59 0 0 0-52.8 193.2c0 51.4 10 101 29.8 147.6 18.9 45 46.2 85.6 81.2 120.5 34.7 34.8 75.4 62.1 120.5 81.2C418.3 894 467.9 904 519 904c51.3 0 100.9-10.1 147.7-29.8 44.9-18.9 85.5-46.3 120.4-81.2 34.7-34.8 62.1-75.4 81.2-120.6a376.5 376.5 0 0 0 29.8-147.6c-.2-51.2-10.1-100.8-29.9-147.4zm-66.4 266.5a307.08 307.08 0 0 1-65.9 98c-28.4 28.5-61.3 50.7-97.7 65.9h-.1c-38 16-78.3 24.2-119.9 24.2a306.51 306.51 0 0 1-217.5-90.2c-28.4-28.5-50.6-61.4-65.8-97.8v-.1c-16-37.8-24.1-78.2-24.1-119.9 0-55.4 14.8-109.7 42.8-157l13.2-22.1-9.5-23.9L206 192c14.9.6 35.9 2.1 59.7 5.6 43.8 6.5 82.5 17.5 114.9 32.6l19 8.9 19.9-6.8c31.5-10.8 64.8-16.2 98.9-16.2a306.51 306.51 0 0 1 217.5 90.2c28.4 28.5 50.6 61.4 65.8 97.8l.1.1.1.1c16 37.6 24.1 78 24.2 119.8-.1 41.7-8.3 82-24.3 119.8zM681.1 364.2c-20.4 0-37.1 16.7-37.1 37.1v55.1c0 20.4 16.6 37.1 37.1 37.1s37.1-16.7 37.1-37.1v-55.1c0-20.5-16.7-37.1-37.1-37.1zm-175.2 0c-20.5 0-37.1 16.7-37.1 37.1v55.1c0 20.4 16.7 37.1 37.1 37.1 20.5 0 37.1-16.7 37.1-37.1v-55.1c0-20.5-16.7-37.1-37.1-37.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineAliyun(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M959.2 383.9c-.3-82.1-66.9-148.6-149.1-148.6H575.9l21.6 85.2 201 43.7a42.58 42.58 0 0 1 32.9 39.7c.1.5.1 216.1 0 216.6a42.58 42.58 0 0 1-32.9 39.7l-201 43.7-21.6 85.3h234.2c82.1 0 148.8-66.5 149.1-148.6V383.9zM225.5 660.4a42.58 42.58 0 0 1-32.9-39.7c-.1-.6-.1-216.1 0-216.6.8-19.4 14.6-35.5 32.9-39.7l201-43.7 21.6-85.2H213.8c-82.1 0-148.8 66.4-149.1 148.6V641c.3 82.1 67 148.6 149.1 148.6H448l-21.6-85.3-200.9-43.9zm200.9-158.8h171v21.3h-171z"
                }
            }
        ]
    })(props);
}
function AiOutlineAmazon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M825 768.9c-3.3-.9-7.3-.4-11.9 1.3-61.6 28.2-121.5 48.3-179.7 60.2C507.7 856 385.2 842.6 266 790.3c-33.1-14.6-79.1-39.2-138-74a9.36 9.36 0 0 0-5.3-2c-2-.1-3.7.1-5.3.9-1.6.8-2.8 1.8-3.7 3.1-.9 1.3-1.1 3.1-.4 5.4.6 2.2 2.1 4.7 4.6 7.4 10.4 12.2 23.3 25.2 38.6 39s35.6 29.4 60.9 46.8c25.3 17.4 51.8 32.9 79.3 46.4 27.6 13.5 59.6 24.9 96.1 34.1s73 13.8 109.4 13.8c36.2 0 71.4-3.7 105.5-10.9 34.2-7.3 63-15.9 86.5-25.9 23.4-9.9 45-21 64.8-33 19.8-12 34.4-22.2 43.9-30.3 9.5-8.2 16.3-14.6 20.2-19.4 4.6-5.7 6.9-10.6 6.9-14.9.1-4.5-1.7-7.1-5-7.9zM527.4 348.1c-15.2 1.3-33.5 4.1-55 8.3-21.5 4.1-41.4 9.3-59.8 15.4s-37.2 14.6-56.3 25.4c-19.2 10.8-35.5 23.2-49 37s-24.5 31.1-33.1 52c-8.6 20.8-12.9 43.7-12.9 68.7 0 27.1 4.7 51.2 14.3 72.5 9.5 21.3 22.2 38 38.2 50.4 15.9 12.4 34 22.1 54 29.2 20 7.1 41.2 10.3 63.2 9.4 22-.9 43.5-4.3 64.4-10.3 20.8-5.9 40.4-15.4 58.6-28.3 18.2-12.9 33.1-28.2 44.8-45.7 4.3 6.6 8.1 11.5 11.5 14.7l8.7 8.9c5.8 5.9 14.7 14.6 26.7 26.1 11.9 11.5 24.1 22.7 36.3 33.7l104.4-99.9-6-4.9c-4.3-3.3-9.4-8-15.2-14.3-5.8-6.2-11.6-13.1-17.2-20.5-5.7-7.4-10.6-16.1-14.7-25.9-4.1-9.8-6.2-19.3-6.2-28.5V258.7c0-10.1-1.9-21-5.7-32.8-3.9-11.7-10.7-24.5-20.7-38.3-10-13.8-22.4-26.2-37.2-37-14.9-10.8-34.7-20-59.6-27.4-24.8-7.4-52.6-11.1-83.2-11.1-31.3 0-60.4 3.7-87.6 10.9-27.1 7.3-50.3 17-69.7 29.2-19.3 12.2-35.9 26.3-49.7 42.4-13.8 16.1-24.1 32.9-30.8 50.4-6.7 17.5-10.1 35.2-10.1 53.1L408 310c5.5-16.4 12.9-30.6 22-42.8 9.2-12.2 17.9-21 25.8-26.5 8-5.5 16.6-9.9 25.7-13.2 9.2-3.3 15.4-5 18.6-5.4 3.2-.3 5.7-.4 7.6-.4 26.7 0 45.2 7.9 55.6 23.6 6.5 9.5 9.7 23.9 9.7 43.3v56.6c-15.2.6-30.4 1.6-45.6 2.9zM573.1 500c0 16.6-2.2 31.7-6.5 45-9.2 29.1-26.7 47.4-52.4 54.8-22.4 6.6-43.7 3.3-63.9-9.8-21.5-14-32.2-33.8-32.2-59.3 0-19.9 5-36.9 15-51.1 10-14.1 23.3-24.7 40-31.7s33-12 49-14.9c15.9-3 33-4.8 51-5.4V500zm335.2 218.9c-4.3-5.4-15.9-8.9-34.9-10.7-19-1.8-35.5-1.7-49.7.4-15.3 1.8-31.1 6.2-47.3 13.4-16.3 7.1-23.4 13.1-21.6 17.8l.7 1.3.9.7 1.4.2h4.6c.8 0 1.8-.1 3.2-.2 1.4-.1 2.7-.3 3.9-.4 1.2-.1 2.9-.3 5.1-.4 2.1-.1 4.1-.4 6-.7.3 0 3.7-.3 10.3-.9 6.6-.6 11.4-1 14.3-1.3 2.9-.3 7.8-.6 14.5-.9 6.7-.3 12.1-.3 16.1 0 4 .3 8.5.7 13.6 1.1 5.1.4 9.2 1.3 12.4 2.7 3.2 1.3 5.6 3 7.1 5.1 5.2 6.6 4.2 21.2-3 43.9s-14 40.8-20.4 54.2c-2.8 5.7-2.8 9.2 0 10.7s6.7.1 11.9-4c15.6-12.2 28.6-30.6 39.1-55.3 6.1-14.6 10.5-29.8 13.1-45.7 2.4-15.9 2-26.2-1.3-31z"
                }
            }
        ]
    })(props);
}
function AiOutlineAndroid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448.3 225.2c-18.6 0-32 13.4-32 31.9s13.5 31.9 32 31.9c18.6 0 32-13.4 32-31.9.1-18.4-13.4-31.9-32-31.9zm393.9 96.4c-13.8-13.8-32.7-21.5-53.2-21.5-3.9 0-7.4.4-10.7 1v-1h-3.6c-5.5-30.6-18.6-60.5-38.1-87.4-18.7-25.7-43-47.9-70.8-64.9l25.1-35.8v-3.3c0-.8.4-2.3.7-3.8.6-2.4 1.4-5.5 1.4-8.9 0-18.5-13.5-31.9-32-31.9-9.8 0-19.5 5.7-25.9 15.4l-29.3 42.1c-30-9.8-62.4-15-93.8-15-31.3 0-63.7 5.2-93.8 15L389 79.4c-6.6-9.6-16.1-15.4-26-15.4-18.6 0-32 13.4-32 31.9 0 6.2 2.5 12.8 6.7 17.4l22.6 32.3c-28.7 17-53.5 39.4-72.2 65.1-19.4 26.9-32 56.8-36.7 87.4h-5.5v1c-3.2-.6-6.7-1-10.7-1-20.3 0-39.2 7.5-53.1 21.3-13.8 13.8-21.5 32.6-21.5 53v235c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 3.9 0 7.4-.4 10.7-1v93.5c0 29.2 23.9 53.1 53.2 53.1H331v58.3c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 20.3 0 39.2-7.5 53.1-21.3 13.8-13.8 21.5-32.6 21.5-53v-58.2H544v58.1c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 20.4 0 39.2-7.5 53.1-21.6 13.8-13.8 21.5-32.6 21.5-53v-58.2h31.9c29.3 0 53.2-23.8 53.2-53.1v-91.4c3.2.6 6.7 1 10.7 1 20.3 0 39.2-7.5 53.1-21.3 13.8-13.8 21.5-32.6 21.5-53v-235c-.1-20.3-7.6-39-21.4-52.9zM246 609.6c0 6.8-3.9 10.6-10.7 10.6-6.8 0-10.7-3.8-10.7-10.6V374.5c0-6.8 3.9-10.6 10.7-10.6 6.8 0 10.7 3.8 10.7 10.6v235.1zm131.1-396.8c37.5-27.3 85.3-42.3 135-42.3s97.5 15.1 135 42.5c32.4 23.7 54.2 54.2 62.7 87.5H314.4c8.5-33.4 30.5-64 62.7-87.7zm39.3 674.7c-.6 5.6-4.4 8.7-10.5 8.7-6.8 0-10.7-3.8-10.7-10.6v-58.2h21.2v60.1zm202.3 8.7c-6.8 0-10.7-3.8-10.7-10.6v-58.2h21.2v60.1c-.6 5.6-4.3 8.7-10.5 8.7zm95.8-132.6H309.9V364h404.6v399.6zm85.2-154c0 6.8-3.9 10.6-10.7 10.6-6.8 0-10.7-3.8-10.7-10.6V374.5c0-6.8 3.9-10.6 10.7-10.6 6.8 0 10.7 3.8 10.7 10.6v235.1zM576.1 225.2c-18.6 0-32 13.4-32 31.9s13.5 31.9 32 31.9c18.6 0 32.1-13.4 32.1-32-.1-18.6-13.4-31.8-32.1-31.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineAntCloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M378.9 738c-3.1 0-6.1-.5-8.8-1.5l4.4 30.7h26.3l-15.5-29.9c-2.1.5-4.2.7-6.4.7zm421-291.2c-12.6 0-24.8 1.5-36.5 4.2-21.4-38.4-62.3-64.3-109.3-64.3-6.9 0-13.6.6-20.2 1.6-35.4-77.4-113.4-131.1-203.9-131.1-112.3 0-205.3 82.6-221.6 190.4C127.3 455.5 64 523.8 64 607c0 88.4 71.6 160.1 160 160.2h50l13.2-27.6c-26.2-8.3-43.3-29-39.1-48.8 4.6-21.6 32.8-33.9 63.1-27.5 22.9 4.9 40.4 19.1 45.5 35.1a26.1 26.1 0 0 1 22.1-12.4h.2c-.8-3.2-1.2-6.5-1.2-9.9 0-20.1 14.8-36.7 34.1-39.6v-25.4c0-4.4 3.6-8 8-8s8 3.6 8 8v26.3c4.6 1.2 8.8 3.2 12.6 5.8l19.5-21.4c3-3.3 8-3.5 11.3-.5 3.3 3 3.5 8 .5 11.3l-20 22-.2.2a40 40 0 0 1-46.9 59.2c-.4 5.6-2.6 10.7-6 14.8l20 38.4H804v-.1c86.5-2.2 156-73 156-160.1 0-88.5-71.7-160.2-160.1-160.2zM338.2 737.2l-4.3 30h24.4l-5.9-41.5c-3.5 4.6-8.3 8.5-14.2 11.5zM797.5 305a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-65.7 61.3a24 24 0 1 0 48 0 24 24 0 1 0-48 0zM303.4 742.9l-11.6 24.3h26l3.5-24.7c-5.7.8-11.7 1-17.9.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineAntDesign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M716.3 313.8c19-18.9 19-49.7 0-68.6l-69.9-69.9.1.1c-18.5-18.5-50.3-50.3-95.3-95.2-21.2-20.7-55.5-20.5-76.5.5L80.9 474.2a53.84 53.84 0 0 0 0 76.4L474.6 944a54.14 54.14 0 0 0 76.5 0l165.1-165c19-18.9 19-49.7 0-68.6a48.7 48.7 0 0 0-68.7 0l-125 125.2c-5.2 5.2-13.3 5.2-18.5 0L189.5 521.4c-5.2-5.2-5.2-13.3 0-18.5l314.4-314.2c.4-.4.9-.7 1.3-1.1 5.2-4.1 12.4-3.7 17.2 1.1l125.2 125.1c19 19 49.8 19 68.7 0zM408.6 514.4a106.3 106.2 0 1 0 212.6 0 106.3 106.2 0 1 0-212.6 0zm536.2-38.6L821.9 353.5c-19-18.9-49.8-18.9-68.7.1a48.4 48.4 0 0 0 0 68.6l83 82.9c5.2 5.2 5.2 13.3 0 18.5l-81.8 81.7a48.4 48.4 0 0 0 0 68.6 48.7 48.7 0 0 0 68.7 0l121.8-121.7a53.93 53.93 0 0 0-.1-76.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineApartment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M908 640H804V488c0-4.4-3.6-8-8-8H548v-96h108c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h108v96H228c-4.4 0-8 3.6-8 8v152H116c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16H292v-88h440v88H620c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16zm-564 76v168H176V716h168zm84-408V140h168v168H428zm420 576H680V716h168v168z"
                }
            }
        ]
    })(props);
}
function AiOutlineApi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 0 0-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 0 0 0 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM769.1 441.7l-59.4 59.4-186.8-186.8 59.4-59.4c24.9-24.9 58.1-38.7 93.4-38.7 35.3 0 68.4 13.7 93.4 38.7 24.9 24.9 38.7 58.1 38.7 93.4 0 35.3-13.8 68.4-38.7 93.4zm-190.2 105a8.03 8.03 0 0 0-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 0 0-11.3 0L363 475.3l-43-43a7.85 7.85 0 0 0-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 69-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 0 0 0 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2zM441.7 769.1a131.32 131.32 0 0 1-93.4 38.7c-35.3 0-68.4-13.7-93.4-38.7a131.32 131.32 0 0 1-38.7-93.4c0-35.3 13.7-68.4 38.7-93.4l59.4-59.4 186.8 186.8-59.4 59.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineApple(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-10.6 267c-14.3 19.9-28.7 35.6-41.9 45.7-10.5 8-18.6 11.4-24 11.6-9-.1-17.7-2.3-34.7-8.8-1.2-.5-2.5-1-4.2-1.6l-4.4-1.7c-17.4-6.7-27.8-10.3-41.1-13.8-18.6-4.8-37.1-7.4-56.9-7.4-20.2 0-39.2 2.5-58.1 7.2-13.9 3.5-25.6 7.4-42.7 13.8-.7.3-8.1 3.1-10.2 3.9-3.5 1.3-6.2 2.3-8.7 3.2-10.4 3.6-17 5.1-22.9 5.2-.7 0-1.3-.1-1.8-.2-1.1-.2-2.5-.6-4.1-1.3-4.5-1.8-9.9-5.1-16-9.8-14-10.9-29.4-28-45.1-49.9-27.5-38.6-53.5-89.8-66-125.7-15.4-44.8-23-87.7-23-128.6 0-60.2 17.8-106 48.4-137.1 26.3-26.6 61.7-41.5 97.8-42.3 5.9.1 14.5 1.5 25.4 4.5 8.6 2.3 18 5.4 30.7 9.9 3.8 1.4 16.9 6.1 18.5 6.7 7.7 2.8 13.5 4.8 19.2 6.6 18.2 5.8 32.3 9 47.6 9 15.5 0 28.8-3.3 47.7-9.8 7.1-2.4 32.9-12 37.5-13.6 25.6-9.1 44.5-14 60.8-15.2 4.8-.4 9.1-.4 13.2-.1 22.7 1.8 42.1 6.3 58.6 13.8-37.6 43.4-57 96.5-56.9 158.4-.3 14.7.9 31.7 5.1 51.8 6.4 30.5 18.6 60.7 37.9 89 14.7 21.5 32.9 40.9 54.7 57.8-11.5 23.7-25.6 48.2-40.4 68.8zm-94.5-572c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineAppstoreAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683928793",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16z m-52 268H212V212h200v200zM864 144H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16z m-52 268H612V212h200v200zM864 544H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16z m-52 268H612V612h200v200zM424 712H296V584c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v128H104c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h128v128c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V776h128c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineAppstore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zM464 544H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H212V612h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200z"
                }
            }
        ]
    })(props);
}
function AiOutlineAreaChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-616-64h536c4.4 0 8-3.6 8-8V284c0-7.2-8.7-10.7-13.7-5.7L592 488.6l-125.4-124a8.03 8.03 0 0 0-11.3 0l-189 189.6a7.87 7.87 0 0 0-2.3 5.6V720c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M862 465.3h-81c-4.6 0-9 2-12.1 5.5L550 723.1V160c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v563.1L255.1 470.8c-3-3.5-7.4-5.5-12.1-5.5h-81c-6.8 0-10.5 8.1-6 13.2L487.9 861a31.96 31.96 0 0 0 48.3 0L868 478.5c4.5-5.2.8-13.2-6-13.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineArrowLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 0 0 0 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineArrowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 0 0 0-48.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M868 545.5L536.1 163a31.96 31.96 0 0 0-48.3 0L156 545.5a7.97 7.97 0 0 0 6 13.2h81c4.6 0 9-2 12.1-5.5L474 300.9V864c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V300.9l218.9 252.3c3 3.5 7.4 5.5 12.1 5.5h81c6.8 0 10.5-8 6-13.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineArrowsAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M855 160.1l-189.2 23.5c-6.6.8-9.3 8.8-4.7 13.5l54.7 54.7-153.5 153.5a8.03 8.03 0 0 0 0 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l153.6-153.6 54.7 54.7a7.94 7.94 0 0 0 13.5-4.7L863.9 169a7.9 7.9 0 0 0-8.9-8.9zM416.6 562.3a8.03 8.03 0 0 0-11.3 0L251.8 715.9l-54.7-54.7a7.94 7.94 0 0 0-13.5 4.7L160.1 855c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 153.6-153.6c3.1-3.1 3.1-8.2 0-11.3l-45.2-45z"
                }
            }
        ]
    })(props);
}
function AiOutlineAudioMuted(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569682811064",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M682 455V311l-76 76v68c-0.1 50.7-42 92.1-94 92-19.1 0.1-36.8-5.4-52-15l-54 55c29.1 22.4 65.9 36 106 36 93.8 0 170-75.1 170-168z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M833 446h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254-63 0-120.7-23-165-61l-54 54c48.9 43.2 110.8 72.3 179 81v102H326c-13.9 0-24.9 14.3-25 32v36c0.1 4.4 2.9 8 6 8h408c3.2 0 6-3.6 6-8v-36c0-17.7-11-32-25-32H547V782c165.3-17.9 294-157.9 294-328 0-4.4-3.6-8-8-8zM846.1 68.3l-43.5-41.9c-3.1-3-8.1-3-11.2 0.1l-129 129C634.3 101.2 577 64 511 64c-93.9 0-170 75.3-170 168v224c0 6.7 0.4 13.3 1.2 19.8l-68 68c-10.5-27.9-16.3-58.2-16.2-89.8-0.2-4.4-3.8-8-8-8h-60c-4.4 0-8 3.6-8 8 0 53 12.5 103 34.6 147.4l-137 137c-3.1 3.1-3.1 8.2 0 11.3l42.7 42.7c3.1 3.1 8.2 3.1 11.3 0L846.2 79.8l0.1-0.1c3.1-3.2 3-8.3-0.2-11.4zM417 401V232c0-50.6 41.9-92 94-92 46 0 84.1 32.3 92.3 74.7L417 401z"
                }
            }
        ]
    })(props);
}
function AiOutlineAudio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M842 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1zM512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm-94-392c0-50.6 41.9-92 94-92s94 41.4 94 92v224c0 50.6-41.9 92-94 92s-94-41.4-94-92V232z"
                }
            }
        ]
    })(props);
}
function AiOutlineAudit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 250c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm184 144H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48 458H208V148h560v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm440-88H728v-36.6c46.3-13.8 80-56.6 80-107.4 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 50.7 33.7 93.6 80 107.4V764H520c-8.8 0-16 7.2-16 16v152c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16V780c0-8.8-7.2-16-16-16zM646 620c0-27.6 22.4-50 50-50s50 22.4 50 50-22.4 50-50 50-50-22.4-50-50zm180 266H566v-60h260v60z"
                }
            }
        ]
    })(props);
}
function AiOutlineBackward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M485.6 249.9L198.2 498c-8.3 7.1-8.3 20.8 0 27.9l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9zm320 0L518.2 498a18.6 18.6 0 0 0-6.2 14c0 5.2 2.1 10.4 6.2 14l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineBank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 0 0-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM512 196.7l271.1 197.2H240.9L512 196.7zM264 462h117v374H264V462zm189 0h117v374H453V462zm307 374H642V462h118v374z"
                }
            }
        ]
    })(props);
}
function AiOutlineBarChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-600-80h56c4.4 0 8-3.6 8-8V560c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V384c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v320c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V462c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v242c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v400c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBarcode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120 160H72c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zm833 0h-48c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zM200 736h112c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm321 0h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm126 0h178c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H647c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm-255 0h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm-79 64H201c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm257 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm256 0H648c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h178c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-385 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBars(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineBehanceSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM598.5 350.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 0 1-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 0 1-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 0 1-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0 1 38.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 0 0-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7zm-248.5-10.1c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 0 0-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1s12.7-3.8 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBehance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M634 294.3h199.5v48.4H634zM434.1 485.8c44.1-21.1 67.2-53.2 67.2-102.8 0-98.1-73-121.9-157.3-121.9H112v492.4h238.5c89.4 0 173.3-43 173.3-143 0-61.8-29.2-107.5-89.7-124.7zM220.2 345.1h101.5c39.1 0 74.2 10.9 74.2 56.3 0 41.8-27.3 58.6-66 58.6H220.2V345.1zm115.5 324.8H220.1V534.3H338c47.6 0 77.7 19.9 77.7 70.3 0 49.6-35.9 65.3-80 65.3zm575.8-89.5c0-105.5-61.7-193.4-173.3-193.4-108.5 0-182.3 81.7-182.3 188.8 0 111 69.9 187.2 182.3 187.2 85.1 0 140.2-38.3 166.7-120h-86.3c-9.4 30.5-47.6 46.5-77.3 46.5-57.4 0-87.4-33.6-87.4-90.7h256.9c.3-5.9.7-12.1.7-18.4zM653.9 537c3.1-46.9 34.4-76.2 81.2-76.2 49.2 0 73.8 28.9 78.1 76.2H653.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineBell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M816 768h-24V428c0-141.1-104.3-257.7-240-277.1V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.9c-135.7 19.4-240 136-240 277.1v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48zM304 768V428c0-55.6 21.6-107.8 60.9-147.1S456.4 220 512 220c55.6 0 107.8 21.6 147.1 60.9S720 372.4 720 428v340H304z"
                }
            }
        ]
    })(props);
}
function AiOutlineBgColors(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M766.4 744.3c43.7 0 79.4-36.2 79.4-80.5 0-53.5-79.4-140.8-79.4-140.8S687 610.3 687 663.8c0 44.3 35.7 80.5 79.4 80.5zm-377.1-44.1c7.1 7.1 18.6 7.1 25.6 0l256.1-256c7.1-7.1 7.1-18.6 0-25.6l-256-256c-.6-.6-1.3-1.2-2-1.7l-78.2-78.2a9.11 9.11 0 0 0-12.8 0l-48 48a9.11 9.11 0 0 0 0 12.8l67.2 67.2-207.8 207.9c-7.1 7.1-7.1 18.6 0 25.6l255.9 256zm12.9-448.6l178.9 178.9H223.4l178.8-178.9zM904 816H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBlock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M856 376H648V168c0-8.8-7.2-16-16-16H168c-8.8 0-16 7.2-16 16v464c0 8.8 7.2 16 16 16h208v208c0 8.8 7.2 16 16 16h464c8.8 0 16-7.2 16-16V392c0-8.8-7.2-16-16-16zm-480 16v188H220V220h360v156H392c-8.8 0-16 7.2-16 16zm204 52v136H444V444h136zm224 360H444V648h188c8.8 0 16-7.2 16-16V444h156v360z"
                }
            }
        ]
    })(props);
}
function AiOutlineBold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M697.8 481.4c33.6-35 54.2-82.3 54.2-134.3v-10.2C752 229.3 663.9 142 555.3 142H259.4c-15.1 0-27.4 12.3-27.4 27.4v679.1c0 16.3 13.2 29.5 29.5 29.5h318.7c117 0 211.8-94.2 211.8-210.5v-11c0-73-37.4-137.3-94.2-175.1zM328 238h224.7c57.1 0 103.3 44.4 103.3 99.3v9.5c0 54.8-46.3 99.3-103.3 99.3H328V238zm366.6 429.4c0 62.9-51.7 113.9-115.5 113.9H328V542.7h251.1c63.8 0 115.5 51 115.5 113.9v10.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zm220 752H232V136h280v296.9c0 3.3 1 6.6 3 9.3a15.9 15.9 0 0 0 22.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752z"
                }
            }
        ]
    })(props);
}
function AiOutlineBorderBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M872 808H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-720-94h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-498h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-166h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm166 166h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm222-72h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388-404h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388 426h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388-404h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBorderHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M540 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm664 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBorderInner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M872 476H548V144h-72v332H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h324v332h72V548h324c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-664h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM650 216h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-592h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-166 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-426h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 260h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBorderLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM540 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBorderOuter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM484 366h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM302 548h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm364 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-182 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 182h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBorderRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M872 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBorderTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M872 144H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332-498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBorderVerticle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M872 476H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-664h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM650 216h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-592h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-166 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM208 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM152 382h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM208 642h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBorder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlineBorderlessTable(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683537953",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M117 368h231v64H117zM676 368h241v64H676zM412 368h200v64H412zM412 592h200v64H412zM676 592h241v64H676zM117 592h231v64H117zM412 432V179h-64v666h64V592zM676 368V179h-64v666h64V432z"
                }
            }
        ]
    })(props);
}
function AiOutlineBoxPlot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H232c-4.4 0-8 3.6-8 8v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h560c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zM296 368h88v288h-88V368zm432 288H448V368h280v288z"
                }
            }
        ]
    })(props);
}
function AiOutlineBranches(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M740 161c-61.8 0-112 50.2-112 112 0 50.1 33.1 92.6 78.5 106.9v95.9L320 602.4V318.1c44.2-15 76-56.9 76-106.1 0-61.8-50.2-112-112-112s-112 50.2-112 112c0 49.2 31.8 91 76 106.1V706c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1v-27.8l423.5-138.7a50.52 50.52 0 0 0 34.9-48.2V378.2c42.9-15.8 73.6-57 73.6-105.2 0-61.8-50.2-112-112-112zm-504 51a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm96 600a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0zm408-491a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            }
        ]
    })(props);
}
function AiOutlineBug(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 280h56c4.4 0 8-3.6 8-8 0-28.3 5.9-53.2 17.1-73.5 10.6-19.4 26-34.8 45.4-45.4C450.9 142 475.7 136 504 136h16c28.3 0 53.2 5.9 73.5 17.1 19.4 10.6 34.8 26 45.4 45.4C650 218.9 656 243.7 656 272c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-40-8.8-76.7-25.9-108.1-17.2-31.5-42.5-56.8-74-74C596.7 72.8 560 64 520 64h-16c-40 0-76.7 8.8-108.1 25.9-31.5 17.2-56.8 42.5-74 74C304.8 195.3 296 232 296 272c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M940 512H792V412c76.8 0 139-62.2 139-139 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 34.8-28.2 63-63 63H232c-34.8 0-63-28.2-63-63 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 76.8 62.2 139 139 139v100H84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h148v96c0 6.5.2 13 .7 19.3C164.1 728.6 116 796.7 116 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-44.2 23.9-82.9 59.6-103.7 6 17.2 13.6 33.6 22.7 49 24.3 41.5 59 76.2 100.5 100.5S460.5 960 512 960s99.8-13.9 141.3-38.2c41.5-24.3 76.2-59 100.5-100.5 9.1-15.5 16.7-31.9 22.7-49C812.1 793.1 836 831.8 836 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-79.3-48.1-147.4-116.7-176.7.4-6.4.7-12.8.7-19.3v-96h148c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM716 680c0 36.8-9.7 72-27.8 102.9-17.7 30.3-43 55.6-73.3 73.3C584 874.3 548.8 884 512 884s-72-9.7-102.9-27.8c-30.3-17.7-55.6-43-73.3-73.3C317.7 752 308 716.8 308 680V412h408v268z"
                }
            }
        ]
    })(props);
}
function AiOutlineBuild(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zm-504 68h200v200H412V278zm-68 468H144V546h200v200zm268 0H412V546h200v200zm268-268H680V278h200v200z"
                }
            }
        ]
    })(props);
}
function AiOutlineBulb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M632 888H392c-4.4 0-8 3.6-8 8v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1V792c0 17.7 14.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328zm127.9 549.8L604 634.6V752H420V634.6l-35.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4 114.6-256 256-256s256 114.6 256 256c0 92.5-49.4 176.3-128.1 221.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineCalculator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M251.2 387H320v68.8c0 1.8 1.8 3.2 4 3.2h48c2.2 0 4-1.4 4-3.3V387h68.8c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H376v-68.8c0-1.8-1.8-3.2-4-3.2h-48c-2.2 0-4 1.4-4 3.2V331h-68.8c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm328 0h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0 265h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0 104h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm-195.7-81l61.2-74.9c4.3-5.2.7-13.1-5.9-13.1H388c-2.3 0-4.5 1-5.9 2.9l-34 41.6-34-41.6a7.85 7.85 0 0 0-5.9-2.9h-50.9c-6.6 0-10.2 7.9-5.9 13.1l61.2 74.9-62.7 76.8c-4.4 5.2-.8 13.1 5.8 13.1h50.8c2.3 0 4.5-1 5.9-2.9l35.5-43.5 35.5 43.5c1.5 1.8 3.7 2.9 5.9 2.9h50.8c6.6 0 10.2-7.9 5.9-13.1L383.5 675zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-36 732H180V180h664v664z"
                }
            }
        ]
    })(props);
}
function AiOutlineCalendar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z"
                }
            }
        ]
    })(props);
}
function AiOutlineCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M864 248H728l-32.4-90.8a32.07 32.07 0 0 0-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 248H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V328c0-44.2-35.8-80-80-80zm8 536c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V328c0-4.4 3.6-8 8-8h186.7l17.1-47.8 22.9-64.2h250.5l22.9 64.2 17.1 47.8H864c4.4 0 8 3.6 8 8v456zM512 384c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zm0 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"
                }
            }
        ]
    })(props);
}
function AiOutlineCar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M380 704h264c4.4 0 8-3.6 8-8v-84c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v36H428v-36c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v84c0 4.4 3.6 8 8 8zm340-123a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm239-167.6L935.3 372a8 8 0 0 0-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 0 0-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 0 0-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 0 0 3-10.8zM840 517v237H184V517l15.6-43h624.8l15.6 43zM292.7 218.1l.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220l72.7-199.9zM224 581a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineCaretDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"
                }
            }
        ]
    })(props);
}
function AiOutlineCaretLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineCaretRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z"
                }
            }
        ]
    })(props);
}
function AiOutlineCaretUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z"
                }
            }
        ]
    })(props);
}
function AiOutlineCarryOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584zM688 420h-55.2c-5.1 0-10 2.5-13 6.6L468.9 634.4l-64.7-89c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.4 0-12.8-6.5-12.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineCheckCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0 0 51.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    })(props);
}
function AiOutlineCheckSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.1 657.7a31.8 31.8 0 0 0 51.7 0l210.6-292c3.8-5.3 0-12.7-6.5-12.7H642c-10.2 0-19.9 4.9-25.9 13.3L459 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H315c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlineCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 0 0-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineChrome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 512.3v-.3c0-229.8-186.2-416-416-416S96 282.2 96 512v.4c0 229.8 186.2 416 416 416s416-186.2 416-416v-.3.2zm-6.7-74.6l.6 3.3-.6-3.3zM676.7 638.2c53.5-82.2 52.5-189.4-11.1-263.7l162.4-8.4c20.5 44.4 32 93.8 32 145.9 0 185.2-144.6 336.6-327.1 347.4l143.8-221.2zM512 652.3c-77.5 0-140.2-62.7-140.2-140.2 0-77.7 62.7-140.2 140.2-140.2S652.2 434.5 652.2 512 589.5 652.3 512 652.3zm369.2-331.7l-3-5.7 3 5.7zM512 164c121.3 0 228.2 62.1 290.4 156.2l-263.6-13.9c-97.5-5.7-190.2 49.2-222.3 141.1L227.8 311c63.1-88.9 166.9-147 284.2-147zM102.5 585.8c26 145 127.1 264 261.6 315.1C229.6 850 128.5 731 102.5 585.8zM164 512c0-55.9 13.2-108.7 36.6-155.5l119.7 235.4c44.1 86.7 137.4 139.7 234 121.6l-74 145.1C302.9 842.5 164 693.5 164 512zm324.7 415.4c4 .2 8 .4 12 .5-4-.2-8-.3-12-.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineCiCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm218-572.1h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineCi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm218-572.1h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineClear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683368540",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M899.1 869.6l-53-305.6H864c14.4 0 26-11.6 26-26V346c0-14.4-11.6-26-26-26H618V138c0-14.4-11.6-26-26-26H432c-14.4 0-26 11.6-26 26v182H160c-14.4 0-26 11.6-26 26v192c0 14.4 11.6 26 26 26h17.9l-53 305.6c-0.3 1.5-0.4 3-0.4 4.4 0 14.4 11.6 26 26 26h723c1.5 0 3-0.1 4.4-0.4 14.2-2.4 23.7-15.9 21.2-30zM204 390h272V182h72v208h272v104H204V390z m468 440V674c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v156H416V674c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v156H202.8l45.1-260H776l45.1 260H672z"
                }
            }
        ]
    })(props);
}
function AiOutlineClockCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineCloseCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024",
            "fill": "currentColor",
            "fillRule": "evenodd"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64Zm0 76c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372Zm128.013 198.826c.023.007.042.018.083.059l45.02 45.019c.04.04.05.06.058.083a.118.118 0 0 1 0 .07c-.007.022-.018.041-.059.082L557.254 512l127.861 127.862a.268.268 0 0 1 .05.06l.009.023a.118.118 0 0 1 0 .07c-.007.022-.018.041-.059.082l-45.019 45.02c-.04.04-.06.05-.083.058a.118.118 0 0 1-.07 0c-.022-.007-.041-.018-.082-.059L512 557.254 384.14 685.115c-.042.041-.06.052-.084.059a.118.118 0 0 1-.07 0c-.022-.007-.041-.018-.082-.059l-45.02-45.019c-.04-.04-.05-.06-.058-.083a.118.118 0 0 1 0-.07c.007-.022.018-.041.059-.082L466.745 512l-127.86-127.86a.268.268 0 0 1-.05-.061l-.009-.023a.118.118 0 0 1 0-.07c.007-.022.018-.041.059-.082l45.019-45.02c.04-.04.06-.05.083-.058a.118.118 0 0 1 .07 0c.022.007.041.018.082.059L512 466.745l127.862-127.86c.04-.041.06-.052.083-.059a.118.118 0 0 1 .07 0Z"
                }
            }
        ]
    })(props);
}
function AiOutlineCloseSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024",
            "fill": "currentColor",
            "fillRule": "evenodd"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112c17.7 0 32 14.3 32 32v736c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32Zm-40 72H184v656h656V184ZM640.013 338.826c.023.007.042.018.083.059l45.02 45.019c.04.04.05.06.058.083a.118.118 0 0 1 0 .07c-.007.022-.018.041-.059.082L557.254 512l127.861 127.862a.268.268 0 0 1 .05.06l.009.023a.118.118 0 0 1 0 .07c-.007.022-.018.041-.059.082l-45.019 45.02c-.04.04-.06.05-.083.058a.118.118 0 0 1-.07 0c-.022-.007-.041-.018-.082-.059L512 557.254 384.14 685.115c-.042.041-.06.052-.084.059a.118.118 0 0 1-.07 0c-.022-.007-.041-.018-.082-.059l-45.02-45.019c-.04-.04-.05-.06-.058-.083a.118.118 0 0 1 0-.07c.007-.022.018-.041.059-.082L466.745 512l-127.86-127.86a.268.268 0 0 1-.05-.061l-.009-.023a.118.118 0 0 1 0-.07c.007-.022.018-.041.059-.082l45.019-45.02c.04-.04.06-.05.083-.058a.118.118 0 0 1 .07 0c.022.007.041.018.082.059L512 466.745l127.862-127.86c.04-.041.06-.052.083-.059a.118.118 0 0 1 .07 0Z"
                }
            }
        ]
    })(props);
}
function AiOutlineClose(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024",
            "fill": "currentColor",
            "fillRule": "evenodd"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M799.855 166.312c.023.007.043.018.084.059l57.69 57.69c.041.041.052.06.059.084a.118.118 0 0 1 0 .069c-.007.023-.018.042-.059.083L569.926 512l287.703 287.703c.041.04.052.06.059.083a.118.118 0 0 1 0 .07c-.007.022-.018.042-.059.083l-57.69 57.69c-.041.041-.06.052-.084.059a.118.118 0 0 1-.069 0c-.023-.007-.042-.018-.083-.059L512 569.926 224.297 857.629c-.04.041-.06.052-.083.059a.118.118 0 0 1-.07 0c-.022-.007-.042-.018-.083-.059l-57.69-57.69c-.041-.041-.052-.06-.059-.084a.118.118 0 0 1 0-.069c.007-.023.018-.042.059-.083L454.073 512 166.371 224.297c-.041-.04-.052-.06-.059-.083a.118.118 0 0 1 0-.07c.007-.022.018-.042.059-.083l57.69-57.69c.041-.041.06-.052.084-.059a.118.118 0 0 1 .069 0c.023.007.042.018.083.059L512 454.073l287.703-287.702c.04-.041.06-.052.083-.059a.118.118 0 0 1 .07 0Z"
                }
            }
        ]
    })(props);
}
function AiOutlineCloudDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 0 1-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineCloudServer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M704 446H320c-4.4 0-8 3.6-8 8v402c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8V454c0-4.4-3.6-8-8-8zm-328 64h272v117H376V510zm272 290H376V683h272v117z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M424 748a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm0-178a32 32 0 1 0 64 0 32 32 0 1 0-64 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M811.4 368.9C765.6 248 648.9 162 512.2 162S258.8 247.9 213 368.8C126.9 391.5 63.5 470.2 64 563.6 64.6 668 145.6 752.9 247.6 762c4.7.4 8.7-3.3 8.7-8v-60.4c0-4-3-7.4-7-7.9-27-3.4-52.5-15.2-72.1-34.5-24-23.5-37.2-55.1-37.2-88.6 0-28 9.1-54.4 26.2-76.4 16.7-21.4 40.2-36.9 66.1-43.7l37.9-10 13.9-36.7c8.6-22.8 20.6-44.2 35.7-63.5 14.9-19.2 32.6-36 52.4-50 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.3c19.9 14 37.5 30.8 52.4 50 15.1 19.3 27.1 40.7 35.7 63.5l13.8 36.6 37.8 10c54.2 14.4 92.1 63.7 92.1 120 0 33.6-13.2 65.1-37.2 88.6-19.5 19.2-44.9 31.1-71.9 34.5-4 .5-6.9 3.9-6.9 7.9V754c0 4.7 4.1 8.4 8.8 8 101.7-9.2 182.5-94 183.2-198.2.6-93.4-62.7-172.1-148.6-194.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineCloudSync(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M811.4 368.9C765.6 248 648.9 162 512.2 162S258.8 247.9 213 368.8C126.9 391.5 63.5 470.2 64 563.6 64.6 668 145.6 752.9 247.6 762c4.7.4 8.7-3.3 8.7-8v-60.4c0-4-3-7.4-7-7.9-27-3.4-52.5-15.2-72.1-34.5-24-23.5-37.2-55.1-37.2-88.6 0-28 9.1-54.4 26.2-76.4 16.7-21.4 40.2-36.9 66.1-43.7l37.9-10 13.9-36.7c8.6-22.8 20.6-44.2 35.7-63.5 14.9-19.2 32.6-36 52.4-50 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.3c19.9 14 37.5 30.8 52.4 50 15.1 19.3 27.1 40.7 35.7 63.5l13.8 36.6 37.8 10c54.2 14.4 92.1 63.7 92.1 120 0 33.6-13.2 65.1-37.2 88.6-19.5 19.2-44.9 31.1-71.9 34.5-4 .5-6.9 3.9-6.9 7.9V754c0 4.7 4.1 8.4 8.8 8 101.7-9.2 182.5-94 183.2-198.2.6-93.4-62.7-172.1-148.6-194.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M376.9 656.4c1.8-33.5 15.7-64.7 39.5-88.6 25.4-25.5 60-39.8 96-39.8 36.2 0 70.3 14.1 96 39.8 1.4 1.4 2.7 2.8 4.1 4.3l-25 19.6a8 8 0 0 0 3 14.1l98.2 24c5 1.2 9.9-2.6 9.9-7.7l.5-101.3c0-6.7-7.6-10.5-12.9-6.3L663 532.7c-36.6-42-90.4-68.6-150.5-68.6-107.4 0-195 85.1-199.4 191.7-.2 4.5 3.4 8.3 8 8.3H369c4.2-.1 7.7-3.4 7.9-7.7zM703 664h-47.9c-4.2 0-7.7 3.3-8 7.6-1.8 33.5-15.7 64.7-39.5 88.6-25.4 25.5-60 39.8-96 39.8-36.2 0-70.3-14.1-96-39.8-1.4-1.4-2.7-2.8-4.1-4.3l25-19.6a8 8 0 0 0-3-14.1l-98.2-24c-5-1.2-9.9 2.6-9.9 7.7l-.4 101.4c0 6.7 7.6 10.5 12.9 6.3l23.2-18.2c36.6 42 90.4 68.6 150.5 68.6 107.4 0 195-85.1 199.4-191.7.2-4.5-3.4-8.3-8-8.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineCloudUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M518.3 459a8 8 0 0 0-12.6 0l-112 141.7a7.98 7.98 0 0 0 6.3 12.9h73.9V856c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V613.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 459z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 0 1-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineCloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3zm36.3 281a123.07 123.07 0 0 1-87.6 36.3H263.9c-33.1 0-64.2-12.9-87.6-36.3A123.3 123.3 0 0 1 140 612c0-28 9.1-54.3 26.2-76.3a125.7 125.7 0 0 1 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-12.9 64.3-36.3 87.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineCluster(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M888 680h-54V540H546v-92h238c8.8 0 16-7.2 16-16V168c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h238v92H190v140h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8h-54v-72h220v72h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8h-54v-72h220v72h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8zM256 805.3c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zm288 0c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zM288 384V216h448v168H288zm544 421.3c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zM360 300a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineCodeSandbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M709.6 210l.4-.2h.2L512 96 313.9 209.8h-.2l.7.3L151.5 304v416L512 928l360.5-208V304l-162.9-94zM482.7 843.6L339.6 761V621.4L210 547.8V372.9l272.7 157.3v313.4zM238.2 321.5l134.7-77.8 138.9 79.7 139.1-79.9 135.2 78-273.9 158-274-158zM814 548.3l-128.8 73.1v139.1l-143.9 83V530.4L814 373.1v175.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M516 673c0 4.4 3.4 8 7.5 8h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48zm-194.9 6.1l192-161c3.8-3.2 3.8-9.1 0-12.3l-192-160.9A7.95 7.95 0 0 0 308 351v62.7c0 2.4 1 4.6 2.9 6.1L420.7 512l-109.8 92.2a8.1 8.1 0 0 0-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlineCodepenCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.1 414.7V303.4L300.9 428l83.6 55.8zm254.1 137.7v-79.8l-59.8 39.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm278 533c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 0 1-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 0 1-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 0 1 .8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-254.1 13.3v111.3L723.1 597l-83.6-55.8zM281.8 472.6v79.8l59.8-39.9zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zM723.1 428L535.9 303.4v111.3l103.6 69.1zM384.5 541.2L300.9 597l187.2 124.6V610.3l-103.6-69.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineCodepen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M911.7 385.3l-.3-1.5c-.2-1-.3-1.9-.6-2.9-.2-.6-.4-1.1-.5-1.7-.3-.8-.5-1.7-.9-2.5-.2-.6-.5-1.1-.8-1.7-.4-.8-.8-1.5-1.2-2.3-.3-.5-.6-1.1-1-1.6-.8-1.2-1.7-2.4-2.6-3.6-.5-.6-1.1-1.3-1.7-1.9-.4-.5-.9-.9-1.4-1.3-.6-.6-1.3-1.1-1.9-1.6-.5-.4-1-.8-1.6-1.2-.2-.1-.4-.3-.6-.4L531.1 117.8a34.3 34.3 0 0 0-38.1 0L127.3 361.3c-.2.1-.4.3-.6.4-.5.4-1 .8-1.6 1.2-.7.5-1.3 1.1-1.9 1.6-.5.4-.9.9-1.4 1.3-.6.6-1.2 1.2-1.7 1.9-1 1.1-1.8 2.3-2.6 3.6-.3.5-.7 1-1 1.6-.4.7-.8 1.5-1.2 2.3-.3.5-.5 1.1-.8 1.7-.3.8-.6 1.7-.9 2.5-.2.6-.4 1.1-.5 1.7-.2.9-.4 1.9-.6 2.9l-.3 1.5c-.2 1.5-.3 3-.3 4.5v243.5c0 1.5.1 3 .3 4.5l.3 1.5.6 2.9c.2.6.3 1.1.5 1.7.3.9.6 1.7.9 2.5.2.6.5 1.1.8 1.7.4.8.7 1.5 1.2 2.3.3.5.6 1.1 1 1.6.5.7.9 1.4 1.5 2.1l1.2 1.5c.5.6 1.1 1.3 1.7 1.9.4.5.9.9 1.4 1.3.6.6 1.3 1.1 1.9 1.6.5.4 1 .8 1.6 1.2.2.1.4.3.6.4L493 905.7c5.6 3.8 12.3 5.8 19.1 5.8 6.6 0 13.3-1.9 19.1-5.8l365.6-243.5c.2-.1.4-.3.6-.4.5-.4 1-.8 1.6-1.2.7-.5 1.3-1.1 1.9-1.6.5-.4.9-.9 1.4-1.3.6-.6 1.2-1.2 1.7-1.9l1.2-1.5 1.5-2.1c.3-.5.7-1 1-1.6.4-.8.8-1.5 1.2-2.3.3-.5.5-1.1.8-1.7.3-.8.6-1.7.9-2.5.2-.5.4-1.1.5-1.7.3-.9.4-1.9.6-2.9l.3-1.5c.2-1.5.3-3 .3-4.5V389.8c-.3-1.5-.4-3-.6-4.5zM546.4 210.5l269.4 179.4-120.3 80.4-149-99.6V210.5zm-68.8 0v160.2l-149 99.6-120.3-80.4 269.3-179.4zM180.7 454.1l86 57.5-86 57.5v-115zm296.9 358.5L208.3 633.2l120.3-80.4 149 99.6v160.2zM512 592.8l-121.6-81.2L512 430.3l121.6 81.2L512 592.8zm34.4 219.8V652.4l149-99.6 120.3 80.4-269.3 179.4zM843.3 569l-86-57.5 86-57.5v115z"
                }
            }
        ]
    })(props);
}
function AiOutlineCoffee(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M275 281c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36zm613 144H768c0-39.8-32.2-72-72-72H200c-39.8 0-72 32.2-72 72v248c0 3.4.2 6.7.7 9.9-.5 7-.7 14-.7 21.1 0 176.7 143.3 320 320 320 160.1 0 292.7-117.5 316.3-271H888c39.8 0 72-32.2 72-72V497c0-39.8-32.2-72-72-72zM696 681h-1.1c.7 7.6 1.1 15.2 1.1 23 0 137-111 248-248 248S200 841 200 704c0-7.8.4-15.4 1.1-23H200V425h496v256zm192-8H776V497h112v176zM613 281c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36zm-170 0c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36z"
                }
            }
        ]
    })(props);
}
function AiOutlineColumnHeight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M840 836H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm0-724H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM610.8 378c6 0 9.4-7 5.7-11.7L515.7 238.7a7.14 7.14 0 0 0-11.3 0L403.6 366.3a7.23 7.23 0 0 0 5.7 11.7H476v268h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V378h62.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineColumnWidth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M180 176h-60c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8zm724 0h-60c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8zM785.3 504.3L657.7 403.6a7.23 7.23 0 0 0-11.7 5.7V476H378v-62.8c0-6-7-9.4-11.7-5.7L238.7 508.3a7.14 7.14 0 0 0 0 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V548h268v62.8c0 6 7 9.4 11.7 5.7l127.5-100.8c3.8-2.9 3.8-8.5.2-11.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineComment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569682881658",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M573 421c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40zM293 421c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M894 345c-48.1-66-115.3-110.1-189-130v0.1c-17.1-19-36.4-36.5-58-52.1-163.7-119-393.5-82.7-513 81-96.3 133-92.2 311.9 6 439l0.8 132.6c0 3.2 0.5 6.4 1.5 9.4 5.3 16.9 23.3 26.2 40.1 20.9L309 806c33.5 11.9 68.1 18.7 102.5 20.6l-0.5 0.4c89.1 64.9 205.9 84.4 313 49l127.1 41.4c3.2 1 6.5 1.6 9.9 1.6 17.7 0 32-14.3 32-32V753c88.1-119.6 90.4-284.9 1-408zM323 735l-12-5-99 31-1-104-8-9c-84.6-103.2-90.2-251.9-11-361 96.4-132.2 281.2-161.4 413-66 132.2 96.1 161.5 280.6 66 412-80.1 109.9-223.5 150.5-348 102z m505-17l-8 10 1 104-98-33-12 5c-56 20.8-115.7 22.5-171 7l-0.2-0.1C613.7 788.2 680.7 742.2 729 676c76.4-105.3 88.8-237.6 44.4-350.4l0.6 0.4c23 16.5 44.1 37.1 62 62 72.6 99.6 68.5 235.2-8 330z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M433 421c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40z"
                }
            }
        ]
    })(props);
}
function AiOutlineCompass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm198.4-588.1a32 32 0 0 0-24.5.5L414.9 415 296.4 686c-3.6 8.2-3.6 17.5 0 25.7 3.4 7.8 9.7 13.9 17.7 17 3.8 1.5 7.7 2.2 11.7 2.2 4.4 0 8.7-.9 12.8-2.7l271-118.6 118.5-271a32.06 32.06 0 0 0-17.7-42.7zM576.8 534.4l26.2 26.2-42.4 42.4-26.2-26.2L380 644.4 447.5 490 422 464.4l42.4-42.4 25.5 25.5L644.4 380l-67.6 154.4zM464.4 422L422 464.4l25.5 25.6 86.9 86.8 26.2 26.2 42.4-42.4-26.2-26.2-86.8-86.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineCompress(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683667781",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M326 664H104c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h174v176c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V696c0-17.7-14.3-32-32-32zM342 88h-48c-8.8 0-16 7.2-16 16v176H104c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h222c17.7 0 32-14.3 32-32V104c0-8.8-7.2-16-16-16zM920 664H698c-17.7 0-32 14.3-32 32v224c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V744h174c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16zM920 280H746V104c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16v224c0 17.7 14.3 32 32 32h222c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function AiOutlineConsoleSql(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683650778",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M301.3 496.7c-23.8 0-40.2-10.5-41.6-26.9H205c0.9 43.4 36.9 70.3 93.9 70.3 59.1 0 95-28.4 95-75.5 0-35.8-20-55.9-64.5-64.5l-29.1-5.6c-23.8-4.7-33.8-11.9-33.8-24.2 0-15 13.3-24.5 33.4-24.5 20.1 0 35.3 11.1 36.6 27h53c-0.9-41.7-37.5-70.3-90.3-70.3-54.4 0-89.7 28.9-89.7 73 0 35.5 21.2 58 62.5 65.8l29.7 5.9c25.8 5.2 35.6 11.9 35.6 24.4 0.1 14.7-14.5 25.1-36 25.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M928 140H96c-17.7 0-32 14.3-32 32v496c0 17.7 14.3 32 32 32h380v112H304c-8.8 0-16 7.2-16 16v48c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-48c0-8.8-7.2-16-16-16H548V700h380c17.7 0 32-14.3 32-32V172c0-17.7-14.3-32-32-32z m-40 488H136V212h752v416z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M828.5 486.7h-95.8V308.5h-57.4V534h153.2zM529.9 540.1c14.1 0 27.2-2 39.1-5.8l13.3 20.3h53.3L607.9 511c21.1-20 33-51.1 33-89.8 0-73.3-43.3-118.8-110.9-118.8s-111.2 45.3-111.2 118.8c-0.1 73.7 43 118.9 111.1 118.9z m0-190c31.6 0 52.7 27.7 52.7 71.1 0 16.7-3.6 30.6-10 40.5l-5.2-6.9h-48.8L542 491c-3.9 0.9-8 1.4-12.2 1.4-31.7 0-52.8-27.5-52.8-71.2 0.1-43.6 21.2-71.1 52.9-71.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineContacts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M594.3 601.5a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1 8 8 0 0 0 8 8.4H407c4.2 0 7.6-3.3 7.9-7.5 3.8-50.6 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H661a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.7-126.1zM512 578c-28.5 0-51.7-23.3-51.7-52s23.2-52 51.7-52 51.7 23.3 51.7 52-23.2 52-51.7 52zm416-354H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z"
                }
            }
        ]
    })(props);
}
function AiOutlineContainer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V687h97.9c11.6 32.8 32 62.3 59.1 84.7 34.5 28.5 78.2 44.3 123 44.3s88.5-15.7 123-44.3c27.1-22.4 47.5-51.9 59.1-84.7H792v-63H643.6l-5.2 24.7C626.4 708.5 573.2 752 512 752s-114.4-43.5-126.5-103.3l-5.2-24.7H232V136h560v752zM320 341h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 160h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineControl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM340 683v77c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-77c-10.1 3.3-20.8 5-32 5s-21.9-1.8-32-5zm64-198V264c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v221c10.1-3.3 20.8-5 32-5s21.9 1.8 32 5zm-64 198c10.1 3.3 20.8 5 32 5s21.9-1.8 32-5c41.8-13.5 72-52.7 72-99s-30.2-85.5-72-99c-10.1-3.3-20.8-5-32-5s-21.9 1.8-32 5c-41.8 13.5-72 52.7-72 99s30.2 85.5 72 99zm.1-115.7c.3-.6.7-1.2 1-1.8v-.1l1.2-1.8c.1-.2.2-.3.3-.5.3-.5.7-.9 1-1.4.1-.1.2-.3.3-.4.5-.6.9-1.1 1.4-1.6l.3-.3 1.2-1.2.4-.4c.5-.5 1-.9 1.6-1.4.6-.5 1.1-.9 1.7-1.3.2-.1.3-.2.5-.3.5-.3.9-.7 1.4-1 .1-.1.3-.2.4-.3.6-.4 1.2-.7 1.9-1.1.1-.1.3-.1.4-.2.5-.3 1-.5 1.6-.8l.6-.3c.7-.3 1.3-.6 2-.8.7-.3 1.4-.5 2.1-.7.2-.1.4-.1.6-.2.6-.2 1.1-.3 1.7-.4.2 0 .3-.1.5-.1.7-.2 1.5-.3 2.2-.4.2 0 .3 0 .5-.1.6-.1 1.2-.1 1.8-.2h.6c.8 0 1.5-.1 2.3-.1s1.5 0 2.3.1h.6c.6 0 1.2.1 1.8.2.2 0 .3 0 .5.1.7.1 1.5.2 2.2.4.2 0 .3.1.5.1.6.1 1.2.3 1.7.4.2.1.4.1.6.2.7.2 1.4.4 2.1.7.7.2 1.3.5 2 .8l.6.3c.5.2 1.1.5 1.6.8.1.1.3.1.4.2.6.3 1.3.7 1.9 1.1.1.1.3.2.4.3.5.3 1 .6 1.4 1 .2.1.3.2.5.3.6.4 1.2.9 1.7 1.3s1.1.9 1.6 1.4l.4.4 1.2 1.2.3.3c.5.5 1 1.1 1.4 1.6.1.1.2.3.3.4.4.4.7.9 1 1.4.1.2.2.3.3.5l1.2 1.8s0 .1.1.1a36.18 36.18 0 0 1 5.1 18.5c0 6-1.5 11.7-4.1 16.7-.3.6-.7 1.2-1 1.8 0 0 0 .1-.1.1l-1.2 1.8c-.1.2-.2.3-.3.5-.3.5-.7.9-1 1.4-.1.1-.2.3-.3.4-.5.6-.9 1.1-1.4 1.6l-.3.3-1.2 1.2-.4.4c-.5.5-1 .9-1.6 1.4-.6.5-1.1.9-1.7 1.3-.2.1-.3.2-.5.3-.5.3-.9.7-1.4 1-.1.1-.3.2-.4.3-.6.4-1.2.7-1.9 1.1-.1.1-.3.1-.4.2-.5.3-1 .5-1.6.8l-.6.3c-.7.3-1.3.6-2 .8-.7.3-1.4.5-2.1.7-.2.1-.4.1-.6.2-.6.2-1.1.3-1.7.4-.2 0-.3.1-.5.1-.7.2-1.5.3-2.2.4-.2 0-.3 0-.5.1-.6.1-1.2.1-1.8.2h-.6c-.8 0-1.5.1-2.3.1s-1.5 0-2.3-.1h-.6c-.6 0-1.2-.1-1.8-.2-.2 0-.3 0-.5-.1-.7-.1-1.5-.2-2.2-.4-.2 0-.3-.1-.5-.1-.6-.1-1.2-.3-1.7-.4-.2-.1-.4-.1-.6-.2-.7-.2-1.4-.4-2.1-.7-.7-.2-1.3-.5-2-.8l-.6-.3c-.5-.2-1.1-.5-1.6-.8-.1-.1-.3-.1-.4-.2-.6-.3-1.3-.7-1.9-1.1-.1-.1-.3-.2-.4-.3-.5-.3-1-.6-1.4-1-.2-.1-.3-.2-.5-.3-.6-.4-1.2-.9-1.7-1.3s-1.1-.9-1.6-1.4l-.4-.4-1.2-1.2-.3-.3c-.5-.5-1-1.1-1.4-1.6-.1-.1-.2-.3-.3-.4-.4-.4-.7-.9-1-1.4-.1-.2-.2-.3-.3-.5l-1.2-1.8v-.1c-.4-.6-.7-1.2-1-1.8-2.6-5-4.1-10.7-4.1-16.7s1.5-11.7 4.1-16.7zM620 539v221c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V539c-10.1 3.3-20.8 5-32 5s-21.9-1.8-32-5zm64-198v-77c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v77c10.1-3.3 20.8-5 32-5s21.9 1.8 32 5zm-64 198c10.1 3.3 20.8 5 32 5s21.9-1.8 32-5c41.8-13.5 72-52.7 72-99s-30.2-85.5-72-99c-10.1-3.3-20.8-5-32-5s-21.9 1.8-32 5c-41.8 13.5-72 52.7-72 99s30.2 85.5 72 99zm.1-115.7c.3-.6.7-1.2 1-1.8v-.1l1.2-1.8c.1-.2.2-.3.3-.5.3-.5.7-.9 1-1.4.1-.1.2-.3.3-.4.5-.6.9-1.1 1.4-1.6l.3-.3 1.2-1.2.4-.4c.5-.5 1-.9 1.6-1.4.6-.5 1.1-.9 1.7-1.3.2-.1.3-.2.5-.3.5-.3.9-.7 1.4-1 .1-.1.3-.2.4-.3.6-.4 1.2-.7 1.9-1.1.1-.1.3-.1.4-.2.5-.3 1-.5 1.6-.8l.6-.3c.7-.3 1.3-.6 2-.8.7-.3 1.4-.5 2.1-.7.2-.1.4-.1.6-.2.6-.2 1.1-.3 1.7-.4.2 0 .3-.1.5-.1.7-.2 1.5-.3 2.2-.4.2 0 .3 0 .5-.1.6-.1 1.2-.1 1.8-.2h.6c.8 0 1.5-.1 2.3-.1s1.5 0 2.3.1h.6c.6 0 1.2.1 1.8.2.2 0 .3 0 .5.1.7.1 1.5.2 2.2.4.2 0 .3.1.5.1.6.1 1.2.3 1.7.4.2.1.4.1.6.2.7.2 1.4.4 2.1.7.7.2 1.3.5 2 .8l.6.3c.5.2 1.1.5 1.6.8.1.1.3.1.4.2.6.3 1.3.7 1.9 1.1.1.1.3.2.4.3.5.3 1 .6 1.4 1 .2.1.3.2.5.3.6.4 1.2.9 1.7 1.3s1.1.9 1.6 1.4l.4.4 1.2 1.2.3.3c.5.5 1 1.1 1.4 1.6.1.1.2.3.3.4.4.4.7.9 1 1.4.1.2.2.3.3.5l1.2 1.8v.1a36.18 36.18 0 0 1 5.1 18.5c0 6-1.5 11.7-4.1 16.7-.3.6-.7 1.2-1 1.8v.1l-1.2 1.8c-.1.2-.2.3-.3.5-.3.5-.7.9-1 1.4-.1.1-.2.3-.3.4-.5.6-.9 1.1-1.4 1.6l-.3.3-1.2 1.2-.4.4c-.5.5-1 .9-1.6 1.4-.6.5-1.1.9-1.7 1.3-.2.1-.3.2-.5.3-.5.3-.9.7-1.4 1-.1.1-.3.2-.4.3-.6.4-1.2.7-1.9 1.1-.1.1-.3.1-.4.2-.5.3-1 .5-1.6.8l-.6.3c-.7.3-1.3.6-2 .8-.7.3-1.4.5-2.1.7-.2.1-.4.1-.6.2-.6.2-1.1.3-1.7.4-.2 0-.3.1-.5.1-.7.2-1.5.3-2.2.4-.2 0-.3 0-.5.1-.6.1-1.2.1-1.8.2h-.6c-.8 0-1.5.1-2.3.1s-1.5 0-2.3-.1h-.6c-.6 0-1.2-.1-1.8-.2-.2 0-.3 0-.5-.1-.7-.1-1.5-.2-2.2-.4-.2 0-.3-.1-.5-.1-.6-.1-1.2-.3-1.7-.4-.2-.1-.4-.1-.6-.2-.7-.2-1.4-.4-2.1-.7-.7-.2-1.3-.5-2-.8l-.6-.3c-.5-.2-1.1-.5-1.6-.8-.1-.1-.3-.1-.4-.2-.6-.3-1.3-.7-1.9-1.1-.1-.1-.3-.2-.4-.3-.5-.3-1-.6-1.4-1-.2-.1-.3-.2-.5-.3-.6-.4-1.2-.9-1.7-1.3s-1.1-.9-1.6-1.4l-.4-.4-1.2-1.2-.3-.3c-.5-.5-1-1.1-1.4-1.6-.1-.1-.2-.3-.3-.4-.4-.4-.7-.9-1-1.4-.1-.2-.2-.3-.3-.5l-1.2-1.8v-.1c-.4-.6-.7-1.2-1-1.8-2.6-5-4.1-10.7-4.1-16.7s1.5-11.7 4.1-16.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z"
                }
            }
        ]
    })(props);
}
function AiOutlineCopyrightCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm5.6-532.7c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineCopyright(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm5.6-532.7c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineCreditCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-792 72h752v120H136V232zm752 560H136V440h752v352zm-237-64h165c4.4 0 8-3.6 8-8v-72c0-4.4-3.6-8-8-8H651c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineCrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M899.6 276.5L705 396.4 518.4 147.5a8.06 8.06 0 0 0-12.9 0L319 396.4 124.3 276.5c-5.7-3.5-13.1 1.2-12.2 7.9L188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.8-6.7-6.5-11.4-12.3-7.9zm-126 534.1H250.3l-53.8-409.4 139.8 86.1L512 252.9l175.7 234.4 139.8-86.1-53.9 409.4zM512 509c-62.1 0-112.6 50.5-112.6 112.6S449.9 734.2 512 734.2s112.6-50.5 112.6-112.6S574.1 509 512 509zm0 160.9c-26.6 0-48.2-21.6-48.2-48.3 0-26.6 21.6-48.3 48.2-48.3s48.2 21.6 48.2 48.3c0 26.6-21.6 48.3-48.2 48.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineCustomerService(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384zM328 632v192H200V632h128zm496 192H696V632h128v192z"
                }
            }
        ]
    })(props);
}
function AiOutlineDash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 476h160v72H112zm320 0h160v72H432zm320 0h160v72H752z"
                }
            }
        ]
    })(props);
}
function AiOutlineDashboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M924.8 385.6a446.7 446.7 0 0 0-96-142.4 446.7 446.7 0 0 0-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 0 0-142.4 96 446.7 446.7 0 0 0-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM761.4 836H262.6A371.12 371.12 0 0 1 140 560c0-99.4 38.7-192.8 109-263 70.3-70.3 163.7-109 263-109 99.4 0 192.8 38.7 263 109 70.3 70.3 109 163.7 109 263 0 105.6-44.5 205.5-122.6 276zM623.5 421.5a8.03 8.03 0 0 0-11.3 0L527.7 506c-18.7-5-39.4-.2-54.1 14.5a55.95 55.95 0 0 0 0 79.2 55.95 55.95 0 0 0 79.2 0 55.87 55.87 0 0 0 14.5-54.1l84.5-84.5c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3zM490 320h44c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-44c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8zm260 218v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zm12.7-197.2l-31.1-31.1a8.03 8.03 0 0 0-11.3 0l-56.6 56.6a8.03 8.03 0 0 0 0 11.3l31.1 31.1c3.1 3.1 8.2 3.1 11.3 0l56.6-56.6c3.1-3.1 3.1-8.2 0-11.3zm-458.6-31.1a8.03 8.03 0 0 0-11.3 0l-31.1 31.1a8.03 8.03 0 0 0 0 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0l31.1-31.1c3.1-3.1 3.1-8.2 0-11.3l-56.6-56.6zM262 530h-80c-4.4 0-8 3.6-8 8v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineDatabase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-600 72h560v208H232V136zm560 480H232V408h560v208zm0 272H232V680h560v208zM304 240a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 272a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 272a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineDeleteColumn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683386799",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M651.1 641.9c-1.4-1.2-3.2-1.9-5.1-1.9h-54.7c-2.4 0-4.6 1.1-6.1 2.9L512 730.7l-73.1-87.8c-1.5-1.8-3.8-2.9-6.1-2.9H378c-1.9 0-3.7 0.7-5.1 1.9-3.4 2.8-3.9 7.9-1 11.3L474.2 776 371.8 898.9c-2.8 3.4-2.4 8.4 1 11.3 1.4 1.2 3.2 1.9 5.1 1.9h54.7c2.4 0 4.6-1.1 6.1-2.9l73.1-87.8 73.1 87.8c1.5 1.8 3.8 2.9 6.1 2.9h55c1.9 0 3.7-0.7 5.1-1.9 3.4-2.8 3.9-7.9 1-11.3L549.8 776l102.4-122.9c2.8-3.4 2.3-8.4-1.1-11.2zM472 544h80c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8zM350 386H184V136c0-3.3-2.7-6-6-6h-60c-3.3 0-6 2.7-6 6v292c0 16.6 13.4 30 30 30h208c3.3 0 6-2.7 6-6v-60c0-3.3-2.7-6-6-6zM906 130h-60c-3.3 0-6 2.7-6 6v250H674c-3.3 0-6 2.7-6 6v60c0 3.3 2.7 6 6 6h208c16.6 0 30-13.4 30-30V136c0-3.3-2.7-6-6-6z"
                }
            }
        ]
    })(props);
}
function AiOutlineDeleteRow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683582196",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M819.8 512l102.4-122.9c2.8-3.4 2.4-8.4-1-11.3-1.4-1.2-3.2-1.9-5.1-1.9h-54.7c-2.4 0-4.6 1.1-6.1 2.9L782 466.7l-73.1-87.8c-1.5-1.8-3.8-2.9-6.1-2.9H648c-1.9 0-3.7 0.7-5.1 1.9-3.4 2.8-3.9 7.9-1 11.3L744.2 512 641.8 634.9c-2.8 3.4-2.4 8.4 1 11.3 1.4 1.2 3.2 1.9 5.1 1.9h54.7c2.4 0 4.6-1.1 6.1-2.9l73.1-87.8 73.1 87.8c1.5 1.8 3.8 2.9 6.1 2.9h55c1.9 0 3.7-0.7 5.1-1.9 3.4-2.8 3.9-7.9 1-11.3L819.8 512zM536 464H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h416c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8zM452 668h-60c-3.3 0-6 2.7-6 6v166H136c-3.3 0-6 2.7-6 6v60c0 3.3 2.7 6 6 6h292c16.6 0 30-13.4 30-30V674c0-3.3-2.7-6-6-6zM136 184h250v166c0 3.3 2.7 6 6 6h60c3.3 0 6-2.7 6-6V142c0-16.6-13.4-30-30-30H136c-3.3 0-6 2.7-6 6v60c0 3.3 2.7 6 6 6z"
                }
            }
        ]
    })(props);
}
function AiOutlineDelete(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z"
                }
            }
        ]
    })(props);
}
function AiOutlineDeliveredProcedure(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683642448",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M632 698.3l141.9-112c4.1-3.2 4.1-9.4 0-12.6L632 461.7c-5.3-4.2-13-0.4-13 6.3v76H295c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h324v76c0 6.7 7.8 10.4 13 6.3zM893.3 293.3L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v278c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V422c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-83.5c0-17-6.7-33.2-18.7-45.2zM640 288H384V184h256v104zM904 724h-56c-4.4 0-8 3.6-8 8v108H184V732c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v148c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V732c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineDeploymentUnit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M888.3 693.2c-42.5-24.6-94.3-18-129.2 12.8l-53-30.7V523.6c0-15.7-8.4-30.3-22-38.1l-136-78.3v-67.1c44.2-15 76-56.8 76-106.1 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 49.3 31.8 91.1 76 106.1v67.1l-136 78.3c-13.6 7.8-22 22.4-22 38.1v151.6l-53 30.7c-34.9-30.8-86.8-37.4-129.2-12.8-53.5 31-71.7 99.4-41 152.9 30.8 53.5 98.9 71.9 152.2 41 42.5-24.6 62.7-73 53.6-118.8l48.7-28.3 140.6 81c6.8 3.9 14.4 5.9 22 5.9s15.2-2 22-5.9L674.5 740l48.7 28.3c-9.1 45.7 11.2 94.2 53.6 118.8 53.3 30.9 121.5 12.6 152.2-41 30.8-53.6 12.6-122-40.7-152.9zm-673 138.4a47.6 47.6 0 0 1-65.2-17.6c-13.2-22.9-5.4-52.3 17.5-65.5a47.6 47.6 0 0 1 65.2 17.6c13.2 22.9 5.4 52.3-17.5 65.5zM522 463.8zM464 234a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm170 446.2l-122 70.3-122-70.3V539.8l122-70.3 122 70.3v140.4zm239.9 133.9c-13.2 22.9-42.4 30.8-65.2 17.6-22.8-13.2-30.7-42.6-17.5-65.5s42.4-30.8 65.2-17.6c22.9 13.2 30.7 42.5 17.5 65.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineDesktop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 140H96c-17.7 0-32 14.3-32 32v496c0 17.7 14.3 32 32 32h380v112H304c-8.8 0-16 7.2-16 16v48c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-48c0-8.8-7.2-16-16-16H548V700h380c17.7 0 32-14.3 32-32V172c0-17.7-14.3-32-32-32zm-40 488H136V212h752v416z"
                }
            }
        ]
    })(props);
}
function AiOutlineDiff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476 399.1c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1V484h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H420v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V540h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H476v-84.9zM560.5 704h-225c-4.1 0-7.5 3.2-7.5 7v42c0 3.8 3.4 7 7.5 7h225c4.1 0 7.5-3.2 7.5-7v-42c0-3.8-3.4-7-7.5-7zm-7.1-502.6c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM664 888H232V264h282.2L664 413.8V888zm190.2-581.4L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23z"
                }
            }
        ]
    })(props);
}
function AiOutlineDingding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M573.7 252.5C422.5 197.4 201.3 96.7 201.3 96.7c-15.7-4.1-17.9 11.1-17.9 11.1-5 61.1 33.6 160.5 53.6 182.8 19.9 22.3 319.1 113.7 319.1 113.7S326 357.9 270.5 341.9c-55.6-16-37.9 17.8-37.9 17.8 11.4 61.7 64.9 131.8 107.2 138.4 42.2 6.6 220.1 4 220.1 4s-35.5 4.1-93.2 11.9c-42.7 5.8-97 12.5-111.1 17.8-33.1 12.5 24 62.6 24 62.6 84.7 76.8 129.7 50.5 129.7 50.5 33.3-10.7 61.4-18.5 85.2-24.2L565 743.1h84.6L603 928l205.3-271.9H700.8l22.3-38.7c.3.5.4.8.4.8S799.8 496.1 829 433.8l.6-1h-.1c5-10.8 8.6-19.7 10-25.8 17-71.3-114.5-99.4-265.8-154.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineDingtalk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M573.7 252.5C422.5 197.4 201.3 96.7 201.3 96.7c-15.7-4.1-17.9 11.1-17.9 11.1-5 61.1 33.6 160.5 53.6 182.8 19.9 22.3 319.1 113.7 319.1 113.7S326 357.9 270.5 341.9c-55.6-16-37.9 17.8-37.9 17.8 11.4 61.7 64.9 131.8 107.2 138.4 42.2 6.6 220.1 4 220.1 4s-35.5 4.1-93.2 11.9c-42.7 5.8-97 12.5-111.1 17.8-33.1 12.5 24 62.6 24 62.6 84.7 76.8 129.7 50.5 129.7 50.5 33.3-10.7 61.4-18.5 85.2-24.2L565 743.1h84.6L603 928l205.3-271.9H700.8l22.3-38.7c.3.5.4.8.4.8S799.8 496.1 829 433.8l.6-1h-.1c5-10.8 8.6-19.7 10-25.8 17-71.3-114.5-99.4-265.8-154.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineDisconnect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832.6 191.4c-84.6-84.6-221.5-84.6-306 0l-96.9 96.9 51 51 96.9-96.9c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204l-96.9 96.9 51.1 51.1 96.9-96.9c84.4-84.6 84.4-221.5-.1-306.1zM446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l96.9-96.9-51.1-51.1-96.9 96.9c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l96.9-96.9-51-51-96.8 97zM260.3 209.4a8.03 8.03 0 0 0-11.3 0L209.4 249a8.03 8.03 0 0 0 0 11.3l554.4 554.4c3.1 3.1 8.2 3.1 11.3 0l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3L260.3 209.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineDislike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 0 0-26.5-5.4H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h129.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM184 456V172h81v284h-81zm627.2 160.4H496.8l9.6 198.4c.6 11.9-4.7 23.1-14.6 30.5-6.1 4.5-13.6 6.8-21.1 6.7a44.28 44.28 0 0 1-42.2-32.3L329 459.2V172h415.4a56.85 56.85 0 0 1 33.6 51.8c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-14 25.5 21.9 19a56.76 56.76 0 0 1 19.6 43c0 19.1-11 37.5-28.8 48.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineDollarCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm47.7-395.2l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineDollar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm47.7-395.2l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineDotChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM288 604a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm118-224a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm158 228a96 96 0 1 0 192 0 96 96 0 1 0-192 0zm148-314a56 56 0 1 0 112 0 56 56 0 1 0-112 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineDoubleLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 0 0 0 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 0 0 0 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z"
                }
            }
        ]
    })(props);
}
function AiOutlineDoubleRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 0 0 188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 0 0 492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineDownCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M690 405h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 563.6 406.8 418.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    })(props);
}
function AiOutlineDownSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505.5 658.7c3.2 4.4 9.7 4.4 12.9 0l178-246c3.8-5.3 0-12.7-6.5-12.7H643c-10.2 0-19.9 4.9-25.9 13.2L512 558.6 406.8 413.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlineDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505.7 661a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineDrag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M909.3 506.3L781.7 405.6a7.23 7.23 0 0 0-11.7 5.7V476H548V254h64.8c6 0 9.4-7 5.7-11.7L517.7 114.7a7.14 7.14 0 0 0-11.3 0L405.6 242.3a7.23 7.23 0 0 0 5.7 11.7H476v222H254v-64.8c0-6-7-9.4-11.7-5.7L114.7 506.3a7.14 7.14 0 0 0 0 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V548h222v222h-64.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V548h222v64.8c0 6 7 9.4 11.7 5.7l127.5-100.8a7.3 7.3 0 0 0 .1-11.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineDribbbleSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm66.5 21.8c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM512 800c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm89.7-259.1c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zm-72.5-26.4c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4zm145.9-186.2a245.2 245.2 0 0 0-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6z"
                }
            }
        ]
    })(props);
}
function AiOutlineDribbble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 96C282.6 96 96 282.6 96 512s186.6 416 416 416 416-186.6 416-416S741.4 96 512 96zm275.1 191.8c49.5 60.5 79.5 137.5 80.2 221.4-11.7-2.5-129.2-26.3-247.4-11.4-2.5-6.1-5-12.2-7.6-18.3-7.4-17.3-15.3-34.6-23.6-51.5C720 374.3 779.6 298 787.1 287.8zM512 157.2c90.3 0 172.8 33.9 235.5 89.5-6.4 9.1-59.9 81-186.2 128.4-58.2-107-122.7-194.8-132.6-208 27.3-6.6 55.2-9.9 83.3-9.9zM360.9 191c9.4 12.8 72.9 100.9 131.7 205.5C326.4 440.6 180 440 164.1 439.8c23.1-110.3 97.4-201.9 196.8-248.8zM156.7 512.5c0-3.6.1-7.3.2-10.9 15.5.3 187.7 2.5 365.2-50.6 10.2 19.9 19.9 40.1 28.8 60.3-4.7 1.3-9.4 2.7-14 4.2C353.6 574.9 256.1 736.4 248 750.1c-56.7-63-91.3-146.3-91.3-237.6zM512 867.8c-82.2 0-157.9-28-218.1-75 6.4-13.1 78.3-152 278.7-221.9l2.3-.8c49.9 129.6 70.5 238.3 75.8 269.5A350.46 350.46 0 0 1 512 867.8zm198.5-60.7c-3.6-21.6-22.5-125.6-69-253.3C752.9 536 850.7 565.2 862.8 569c-15.8 98.8-72.5 184.2-152.3 238.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineDropbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 556.9l264.2 173.5L512.5 577 246.8 412.7zm896-290.3zm0 0L696.8 95 512.5 248.5l265.2 164.2L512.5 577l184.3 153.4L960 558.8 777.7 412.7zM513 609.8L328.2 763.3l-79.4-51.5v57.8L513 928l263.7-158.4v-57.8l-78.9 51.5zM328.2 95L64 265.1l182.8 147.6 265.7-164.2zM64 556.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function AiOutlineEllipsis(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 511a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm280 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm280 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineEnter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 0 0 0 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineEnvironment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 289.1a362.49 362.49 0 0 0-79.9-115.7 370.83 370.83 0 0 0-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 0 0 169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0 0 22.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1zm0-617.2c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 0 1 512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8C612.4 381 624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineEuroCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm117.7-588.6c-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H344c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H344c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H439.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H447.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 0 0 9.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineEuro(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm117.7-588.6c-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H344c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H344c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H439.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H447.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 0 0 9.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineException(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm376 116c-119.3 0-216 96.7-216 216s96.7 216 216 216 216-96.7 216-216-96.7-216-216-216zm107.5 323.5C750.8 868.2 712.6 884 672 884s-78.8-15.8-107.5-44.5C535.8 810.8 520 772.6 520 732s15.8-78.8 44.5-107.5C593.2 595.8 631.4 580 672 580s78.8 15.8 107.5 44.5C808.2 653.2 824 691.4 824 732s-15.8 78.8-44.5 107.5zM640 812a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm12-64h40c4.4 0 8-3.6 8-8V628c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8zM440 852H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineExclamationCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M464 688a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 804a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm32-168h64c4.4 0 8-3.6 8-8V164c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineExpandAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M855 160.1l-189.2 23.5c-6.6.8-9.3 8.8-4.7 13.5l54.7 54.7-153.5 153.5a8.03 8.03 0 0 0 0 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l153.6-153.6 54.7 54.7a7.94 7.94 0 0 0 13.5-4.7L863.9 169a7.9 7.9 0 0 0-8.9-8.9zM416.6 562.3a8.03 8.03 0 0 0-11.3 0L251.8 715.9l-54.7-54.7a7.94 7.94 0 0 0-13.5 4.7L160.1 855c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 153.6-153.6c3.1-3.1 3.1-8.2 0-11.3l-45.2-45z"
                }
            }
        ]
    })(props);
}
function AiOutlineExpand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683683230",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M342 88H120c-17.7 0-32 14.3-32 32v224c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V168h174c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16zM920 664h-48c-8.8 0-16 7.2-16 16v176H682c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h222c17.7 0 32-14.3 32-32V680c0-8.8-7.2-16-16-16zM342 856H168V680c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16v224c0 17.7 14.3 32 32 32h222c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16zM904 88H682c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h174v176c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V120c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function AiOutlineExperiment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 472a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm367 352.9L696.3 352V178H768v-68H256v68h71.7v174L145 824.9c-2.8 7.4-4.3 15.2-4.3 23.1 0 35.3 28.7 64 64 64h614.6c7.9 0 15.7-1.5 23.1-4.3 33-12.7 49.4-49.8 36.6-82.8zM395.7 364.7V180h232.6v184.7L719.2 600c-20.7-5.3-42.1-8-63.9-8-61.2 0-119.2 21.5-165.3 60a188.78 188.78 0 0 1-121.3 43.9c-32.7 0-64.1-8.3-91.8-23.7l118.8-307.5zM210.5 844l41.7-107.8c35.7 18.1 75.4 27.8 116.6 27.8 61.2 0 119.2-21.5 165.3-60 33.9-28.2 76.3-43.9 121.3-43.9 35 0 68.4 9.5 97.6 27.1L813.5 844h-603z"
                }
            }
        ]
    })(props);
}
function AiOutlineExport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024",
            "fill": "currentColor",
            "fillRule": "evenodd"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h360c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H184V184h656v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32ZM770.87 824.869l-52.2 52.2c-4.7 4.7-1.9 12.8 4.7 13.6l179.4 21c5.1.6 9.5-3.7 8.9-8.9l-21-179.4c-.8-6.6-8.9-9.4-13.6-4.7l-52.4 52.4-256.2-256.2c-3.1-3.1-8.2-3.1-11.3 0l-42.4 42.4c-3.1 3.1-3.1 8.2 0 11.3l256.1 256.3Z",
                    "transform": "matrix(1 0 0 -1 0 1024)"
                }
            }
        ]
    })(props);
}
function AiOutlineEyeInvisible(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5zm-63.57-320.64L836 122.88a8 8 0 0 0-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 0 0 0 11.31L155.17 889a8 8 0 0 0 11.31 0l712.15-712.12a8 8 0 0 0 0-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 0 0-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 0 1 146.2-106.69L401.31 546.2A112 112 0 0 1 396 512z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 0 0 227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 0 1-112 112z"
                }
            }
        ]
    })(props);
}
function AiOutlineEye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
                }
            }
        ]
    })(props);
}
function AiOutlineFacebook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-32 736H663.9V602.2h104l15.6-120.7H663.9v-77.1c0-35 9.7-58.8 59.8-58.8h63.9v-108c-11.1-1.5-49-4.8-93.2-4.8-92.2 0-155.3 56.3-155.3 159.6v89H434.9v120.7h104.3V848H176V176h672v672z"
                }
            }
        ]
    })(props);
}
function AiOutlineFall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M925.9 804l-24-199.2c-.8-6.6-8.9-9.4-13.6-4.7L829 659.5 557.7 388.3c-6.3-6.2-16.4-6.2-22.6 0L433.3 490 156.6 213.3a8.03 8.03 0 0 0-11.3 0l-45 45.2a8.03 8.03 0 0 0 0 11.3L422 591.7c6.2 6.3 16.4 6.3 22.6 0L546.4 490l226.1 226-59.3 59.3a8.01 8.01 0 0 0 4.7 13.6l199.2 24c5.1.7 9.5-3.7 8.8-8.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineFastBackward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M517.6 273.5L230.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm320 0L550.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm-620-25.5h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z"
                }
            }
        ]
    })(props);
}
function AiOutlineFastForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M793.8 499.3L506.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.6c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8a16.14 16.14 0 0 0 0-25.4zm-320 0L186.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.5c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8c4.1-3.2 6.2-8 6.2-12.7 0-4.6-2.1-9.4-6.2-12.6zM857.6 248h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z"
                }
            }
        ]
    })(props);
}
function AiOutlineFieldBinary(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683645783",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M600 395.4h91V649h79V267c0-4.4-3.6-8-8-8h-48.2c-3.7 0-7 2.6-7.7 6.3-2.6 12.1-6.9 22.3-12.9 30.9-7.2 10.1-15.9 18.2-26.3 24.4-10.3 6.2-22 10.5-35 12.9-10.4 1.9-21 3-32 3.1-4.4 0.1-7.9 3.6-7.9 8v42.8c0 4.4 3.6 8 8 8zM871 702H567c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM443.9 312.7c-16.1-19-34.4-32.4-55.2-40.4-21.3-8.2-44.1-12.3-68.4-12.3-23.9 0-46.4 4.1-67.7 12.3-20.8 8-39 21.4-54.8 40.3-15.9 19.1-28.7 44.7-38.3 77-9.6 32.5-14.5 73-14.5 121.5 0 49.9 4.9 91.4 14.5 124.4 9.6 32.8 22.4 58.7 38.3 77.7 15.8 18.9 34 32.3 54.8 40.3 21.3 8.2 43.8 12.3 67.7 12.3 24.4 0 47.2-4.1 68.4-12.3 20.8-8 39.2-21.4 55.2-40.4 16.1-19 29-44.9 38.6-77.7 9.6-33 14.5-74.5 14.5-124.4 0-48.4-4.9-88.9-14.5-121.5-9.5-32.1-22.4-57.7-38.6-76.8z m-29.5 251.7c-1 21.4-4.2 42-9.5 61.9-5.5 20.7-14.5 38.5-27 53.4-13.6 16.3-33.2 24.3-57.6 24.3-24 0-43.2-8.1-56.7-24.4-12.2-14.8-21.1-32.6-26.6-53.3-5.3-19.9-8.5-40.6-9.5-61.9-1-20.8-1.5-38.5-1.5-53.2 0-8.8 0.1-19.4 0.4-31.8 0.2-12.7 1.1-25.8 2.6-39.2 1.5-13.6 4-27.1 7.6-40.5 3.7-13.8 8.8-26.3 15.4-37.4 6.9-11.6 15.8-21.1 26.7-28.3 11.4-7.6 25.3-11.3 41.5-11.3 16.1 0 30.1 3.7 41.7 11.2 11.1 7.2 20.3 16.6 27.4 28.2 6.9 11.2 12.1 23.8 15.6 37.7 3.3 13.2 5.8 26.6 7.5 40.1 1.8 13.5 2.8 26.6 3 39.4 0.2 12.4 0.4 23 0.4 31.8 0.1 14.8-0.4 32.5-1.4 53.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineFieldNumber(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683604581",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M508 280h-63.3c-3.3 0-6 2.7-6 6v340.2H433L197.4 282.6c-1.1-1.6-3-2.6-4.9-2.6H126c-3.3 0-6 2.7-6 6v464c0 3.3 2.7 6 6 6h62.7c3.3 0 6-2.7 6-6V405.1h5.7l238.2 348.3c1.1 1.6 3 2.6 5 2.6H508c3.3 0 6-2.7 6-6V286c0-3.3-2.7-6-6-6zM886 693H582c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM733.8 630c52.9 0 95.2-17.2 126.2-51.7 29.4-32.9 44-75.8 44-128.8 0-53.1-14.6-96.5-44-129.3-30.9-34.8-73.2-52.2-126.2-52.2-53.7 0-95.9 17.5-126.3 52.8-29.2 33.1-43.4 75.9-43.4 128.7 0 52.4 14.3 95.2 43.5 128.3 30.6 34.7 73 52.2 126.2 52.2z m-71.5-263.7c16.9-20.6 40.3-30.9 71.4-30.9 31.5 0 54.8 9.6 71 29.1 16.4 20.3 24.9 48.6 24.9 84.9 0 36.3-8.4 64.1-24.8 83.9-16.5 19.4-40 29.2-71.1 29.2-31.2 0-55-10.3-71.4-30.4-16.3-20.1-24.5-47.3-24.5-82.6 0.1-35.8 8.2-63 24.5-83.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineFieldString(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683607277",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M875.6 515.9c2.1 0.8 4.4-0.3 5.2-2.4 0.2-0.4 0.2-0.9 0.2-1.4v-58.3c0-1.8-1.1-3.3-2.8-3.8-6-1.8-17.2-3-27.2-3-32.9 0-61.7 16.7-73.5 41.2v-28.6c0-4.4-3.6-8-8-8H717c-4.4 0-8 3.6-8 8V729c0 4.4 3.6 8 8 8h54.8c4.4 0 8-3.6 8-8V572.7c0-36.2 26.1-60.2 65.1-60.2 10.4 0.1 26.6 1.8 30.7 3.4zM338.6 475.4l-54.7-12.6c-61.2-14.2-87.7-34.8-87.7-70.7 0-44.6 39.1-73.5 96.9-73.5 52.8 0 91.4 26.5 99.9 68.9h70C455.9 311.6 387.6 259 293.4 259c-103.3 0-171 55.5-171 139 0 68.6 38.6 109.5 122.2 128.5l61.6 14.3c63.6 14.9 91.6 37.1 91.6 75.1 0 44.1-43.5 75.2-102.5 75.2-60.6 0-104.5-27.2-112.8-70.5H111c7.2 79.9 75.6 130.4 179.1 130.4C402.3 751 471 695.2 471 605.3c0-70.2-38.6-108.5-132.4-129.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M877 729m-36 0a36 36 0 1 0 72 0 36 36 0 1 0-72 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M653 457.8h-51.4V396c0-4.4-3.6-8-8-8h-54.7c-4.4 0-8 3.6-8 8v61.8H495c-4.4 0-8 3.6-8 8v42.3c0 4.4 3.6 8 8 8h35.9v147.5c0 56.2 27.4 79.4 93.1 79.4 11.7 0 23.6-1.2 33.8-3.1 1.9-0.3 3.2-2 3.2-3.9v-49.3c0-2.2-1.8-4-4-4h-0.4c-4.9 0.5-6.2 0.6-8.3 0.8-4.1 0.3-7.8 0.5-12.6 0.5-24.1 0-34.1-10.3-34.1-35.6V516.1H653c4.4 0 8-3.6 8-8v-42.3c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineFieldTime(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683618210",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M945 412H689c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h256c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM811 548H689c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h122c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM477.3 322.5H434c-6.2 0-11.2 5-11.2 11.2v248c0 3.6 1.7 6.9 4.6 9l148.9 108.6c5 3.6 12 2.6 15.6-2.4l25.7-35.1v-0.1c3.6-5 2.5-12-2.5-15.6l-126.7-91.6V333.7c0.1-6.2-5-11.2-11.1-11.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M804.8 673.9H747c-5.6 0-10.9 2.9-13.9 7.7-12.7 20.1-27.5 38.7-44.5 55.7-29.3 29.3-63.4 52.3-101.3 68.3-39.3 16.6-81 25-124 25-43.1 0-84.8-8.4-124-25-37.9-16-72-39-101.3-68.3s-52.3-63.4-68.3-101.3c-16.6-39.2-25-80.9-25-124 0-43.1 8.4-84.7 25-124 16-37.9 39-72 68.3-101.3 29.3-29.3 63.4-52.3 101.3-68.3 39.2-16.6 81-25 124-25 43.1 0 84.8 8.4 124 25 37.9 16 72 39 101.3 68.3 17 17 31.8 35.6 44.5 55.7 3 4.8 8.3 7.7 13.9 7.7h57.8c6.9 0 11.3-7.2 8.2-13.3-65.2-129.7-197.4-214-345-215.7-216.1-2.7-395.6 174.2-396 390.1C71.6 727.5 246.9 903 463.2 903c149.5 0 283.9-84.6 349.8-215.8 3.1-6.1-1.4-13.3-8.2-13.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM544 472c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V472z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileDone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm376 116c-119.3 0-216 96.7-216 216s96.7 216 216 216 216-96.7 216-216-96.7-216-216-216zm107.5 323.5C750.8 868.2 712.6 884 672 884s-78.8-15.8-107.5-44.5C535.8 810.8 520 772.6 520 732s15.8-78.8 44.5-107.5C593.2 595.8 631.4 580 672 580s78.8 15.8 107.5 44.5C808.2 653.2 824 691.4 824 732s-15.8 78.8-44.5 107.5zM761 656h-44.3c-2.6 0-5 1.2-6.5 3.3l-63.5 87.8-23.1-31.9a7.92 7.92 0 0 0-6.5-3.3H573c-6.5 0-10.3 7.4-6.5 12.7l73.8 102.1c3.2 4.4 9.7 4.4 12.9 0l114.2-158c3.9-5.3.1-12.7-6.4-12.7zM440 852H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileExcel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0 0 10.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 0 0-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM472 744a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm16-104h48c4.4 0 8-3.6 8-8V448c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileGif(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683725598",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M551.5 490.5H521c-4.6 0-8.4 3.7-8.4 8.4V720c0 4.6 3.7 8.4 8.4 8.4h30.5c4.6 0 8.4-3.7 8.4-8.4V498.9c-0.1-4.6-3.8-8.4-8.4-8.4zM477.3 600h-88.1c-4.6 0-8.4 3.7-8.4 8.4v23.8c0 4.6 3.7 8.4 8.4 8.4h47.6v0.7c-0.6 29.9-23 49.8-56.5 49.8-39.2 0-63.6-30.7-63.6-81.4 0-50.1 23.9-80.6 62.3-80.6 28.1 0 47.5 13.5 55.4 38.3l0.9 2.8h49.2l-0.7-4.6C475.9 515.9 434.7 484 379 484c-68.8 0-113 49.4-113 125.9 0 77.5 43.7 126.1 113.6 126.1 64.4 0 106-40.3 106-102.9v-24.8c0-4.6-3.7-8.3-8.3-8.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216c0 23.2 18.8 42 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M608.2 727.8h32.3c4.6 0 8.4-3.7 8.4-8.4v-84.8h87.8c4.6 0 8.4-3.7 8.4-8.4v-25.5c0-4.6-3.7-8.4-8.4-8.4h-87.8v-58.9h96.8c4.6 0 8.4-3.7 8.4-8.4v-26.8c0-4.6-3.7-8.4-8.4-8.4H608.2c-4.6 0-8.4 3.7-8.4 8.4v221.1c0 4.8 3.8 8.5 8.4 8.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M553.1 509.1l-77.8 99.2-41.1-52.4a8 8 0 0 0-12.6 0l-99.8 127.2a7.98 7.98 0 0 0 6.3 12.9H696c6.7 0 10.4-7.7 6.3-12.9l-136.5-174a8.1 8.1 0 0 0-12.7 0zM360 442a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm494.6-153.4L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileJpg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M874.6 301.8L596.8 21.3c-4.5-4.5-9.4-8.3-14.7-11.5-1.4-.8-2.8-1.6-4.3-2.3-.9-.5-1.9-.9-2.8-1.3-9-4-18.9-6.2-29-6.2H201c-39.8 0-73 32.2-73 72v880c0 39.8 33.2 72 73 72h623c39.8 0 71-32.2 71-72V352.5c0-19-7-37.2-20.4-50.7zM583 110.4L783.8 312H583V110.4zM823 952H200V72h311v240c0 39.8 33.2 72 73 72h239v568zM350 696.5c0 24.2-7.5 31.4-21.9 31.4-9 0-18.4-5.8-24.8-18.5L272.9 732c13.4 22.9 32.3 34.2 61.3 34.2 41.6 0 60.8-29.9 60.8-66.2V577h-45v119.5zM501.3 577H437v186h44v-62h21.6c39.1 0 73.1-19.6 73.1-63.6 0-45.8-33.5-60.4-74.4-60.4zm-.8 89H481v-53h18.2c21.5 0 33.4 6.2 33.4 24.9 0 18.1-10.5 28.1-32.1 28.1zm182.5-9v36h30v30.1c-4 2.9-11 4.7-17.7 4.7-34.3 0-50.7-21.4-50.7-58.2 0-36.1 19.7-57.4 47.1-57.4 15.3 0 25 6.2 34 14.4l23.7-28.3c-12.7-12.8-32.1-24.2-59.2-24.2-49.6 0-91.1 35.3-91.1 97 0 62.7 40 95.1 91.5 95.1 25.9 0 49.2-10.2 61.5-22.6V657H683z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileMarkdown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM429 481.2c-1.9-4.4-6.2-7.2-11-7.2h-35c-6.6 0-12 5.4-12 12v272c0 6.6 5.4 12 12 12h27.1c6.6 0 12-5.4 12-12V582.1l66.8 150.2a12 12 0 0 0 11 7.1H524c4.7 0 9-2.8 11-7.1l66.8-150.6V758c0 6.6 5.4 12 12 12H641c6.6 0 12-5.4 12-12V486c0-6.6-5.4-12-12-12h-34.7c-4.8 0-9.1 2.8-11 7.2l-83.1 191-83.2-191z"
                }
            }
        ]
    })(props);
}
function AiOutlineFilePdf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M531.3 574.4l.3-1.4c5.8-23.9 13.1-53.7 7.4-80.7-3.8-21.3-19.5-29.6-32.9-30.2-15.8-.7-29.9 8.3-33.4 21.4-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.5-51.2 107.5-29.6 15.3-69.3 38.9-75.2 68.7-1.2 5.5.2 12.5 3.5 18.8 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-13.2-13-45.3-16.4-95.3-10.2-24.6-15-40.7-35.4-52.4-65.8zM421.6 726.3c-13.9 20.2-24.4 30.3-30.1 34.7 6.7-12.3 19.8-25.3 30.1-34.7zm87.6-235.5c5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4.8.1 1.5.7 2.2 2zm-1.6 120.5c10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4zm155.6 65.5c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4zm191.4-388.2L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            }
        ]
    })(props);
}
function AiOutlineFilePpt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M424 476c-4.4 0-8 3.6-8 8v276c0 4.4 3.6 8 8 8h32.5c4.4 0 8-3.6 8-8v-95.5h63.3c59.4 0 96.2-38.9 96.2-94.1 0-54.5-36.3-94.3-96-94.3H424zm150.6 94.3c0 43.4-26.5 54.3-71.2 54.3h-38.9V516.2h56.2c33.8 0 53.9 19.7 53.9 54.1zm280-281.7L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileProtect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M644.7 669.2a7.92 7.92 0 0 0-6.5-3.3H594c-6.5 0-10.3 7.4-6.5 12.7l73.8 102.1c3.2 4.4 9.7 4.4 12.9 0l114.2-158c3.8-5.3 0-12.7-6.5-12.7h-44.3c-2.6 0-5 1.2-6.5 3.3l-63.5 87.8-22.9-31.9zM688 306v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm184 458H208V148h560v296c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h312c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm402.6-320.8l-192-66.7c-.9-.3-1.7-.4-2.6-.4s-1.8.1-2.6.4l-192 66.7a7.96 7.96 0 0 0-5.4 7.5v251.1c0 2.5 1.1 4.8 3.1 6.3l192 150.2c1.4 1.1 3.2 1.7 4.9 1.7s3.5-.6 4.9-1.7l192-150.2c1.9-1.5 3.1-3.8 3.1-6.3V538.7c0-3.4-2.2-6.4-5.4-7.5zM826 763.7L688 871.6 550 763.7V577l138-48 138 48v186.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileSearch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm144 452H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm445.7 51.5l-93.3-93.3C814.7 780.7 828 743.9 828 704c0-97.2-78.8-176-176-176s-176 78.8-176 176 78.8 176 176 176c35.8 0 69-10.7 96.8-29l94.7 94.7c1.6 1.6 3.6 2.3 5.6 2.3s4.1-.8 5.6-2.3l31-31a7.9 7.9 0 0 0 0-11.2zM652 816c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileSync(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 256c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm192 200v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8zm-48 396H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm104.1-115.6c1.8-34.5 16.2-66.8 40.8-91.4 26.2-26.2 62-41 99.1-41 37.4 0 72.6 14.6 99.1 41 3.2 3.2 6.3 6.6 9.2 10.1L769.2 673a8 8 0 0 0 3 14.1l93.3 22.5c5 1.2 9.8-2.6 9.9-7.7l.6-95.4a8 8 0 0 0-12.9-6.4l-20.3 15.8C805.4 569.6 748.1 540 684 540c-109.9 0-199.6 86.9-204 195.7-.2 4.5 3.5 8.3 8 8.3h48.1c4.3 0 7.8-3.3 8-7.6zM880 744h-48.1c-4.3 0-7.8 3.3-8 7.6-1.8 34.5-16.2 66.8-40.8 91.4-26.2 26.2-62 41-99.1 41-37.4 0-72.6-14.6-99.1-41-3.2-3.2-6.3-6.6-9.2-10.1l23.1-17.9a8 8 0 0 0-3-14.1l-93.3-22.5c-5-1.2-9.8 2.6-9.9 7.7l-.6 95.4a8 8 0 0 0 12.9 6.4l20.3-15.8C562.6 918.4 619.9 948 684 948c109.9 0 199.6-86.9 204-195.7.2-4.5-3.5-8.3-8-8.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM504 618H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileUnknown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM402 549c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103zm78 195a32 32 0 1 0 64 0 32 32 0 1 0-64 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileWord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM528.1 472h-32.2c-5.5 0-10.3 3.7-11.6 9.1L434.6 680l-46.1-198.7c-1.3-5.4-6.1-9.3-11.7-9.3h-35.4a12.02 12.02 0 0 0-11.6 15.1l74.2 276c1.4 5.2 6.2 8.9 11.6 8.9h32c5.4 0 10.2-3.6 11.6-8.9l52.8-197 52.8 197c1.4 5.2 6.2 8.9 11.6 8.9h31.8c5.4 0 10.2-3.6 11.6-8.9l74.4-276a12.04 12.04 0 0 0-11.6-15.1H647c-5.6 0-10.4 3.9-11.7 9.3l-45.8 199.1-49.8-199.3c-1.3-5.4-6.1-9.1-11.6-9.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileZip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 392h64v64h-64zm0 190v160h128V582h-64v-62h-64v62zm80 48v64h-32v-64h32zm-16-302h64v64h-64zm-64-64h64v64h-64zm64 192h64v64h-64zm0-256h64v64h-64zm494.6 88.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h64v64h64v-64h174v216a42 42 0 0 0 42 42h216v494z"
                }
            }
        ]
    })(props);
}
function AiOutlineFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            }
        ]
    })(props);
}
function AiOutlineFilter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V642h182.9v156zm9.6-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineFire(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M834.1 469.2A347.49 347.49 0 0 0 751.2 354l-29.1-26.7a8.09 8.09 0 0 0-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 0 1-47.5 46.1 352.6 352.6 0 0 0-100.3 121.5A347.75 347.75 0 0 0 160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0 0 75.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 0 0 760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0 0 27.7-136c0-48.8-10-96.2-29.9-140.9zM713 808.5c-53.7 53.2-125 82.4-201 82.4s-147.3-29.2-201-82.4c-53.5-53.1-83-123.5-83-198.4 0-43.5 9.8-85.2 29.1-124 18.8-37.9 46.8-71.8 80.8-97.9a349.6 349.6 0 0 0 58.6-56.8c25-30.5 44.6-64.5 58.2-101a240 240 0 0 0 12.1-46.5c24.1 22.2 44.3 49 61.2 80.4 33.4 62.6 48.8 118.3 45.8 165.7a74.01 74.01 0 0 0 24.4 59.8 73.36 73.36 0 0 0 53.4 18.8c19.7-1 37.8-9.7 51-24.4 13.3-14.9 24.8-30.1 34.4-45.6 14 17.9 25.7 37.4 35 58.4 15.9 35.8 24 73.9 24 113.1 0 74.9-29.5 145.4-83 198.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32zM184 568V232h368v336H184zm656 145H504v-73h112c4.4 0 8-3.6 8-8V377h216v336z"
                }
            }
        ]
    })(props);
}
function AiOutlineFolderAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M484 443.1V528h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H484v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V584h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H540v-84.9c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1zm396-144.7H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z"
                }
            }
        ]
    })(props);
}
function AiOutlineFolderOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z"
                }
            }
        ]
    })(props);
}
function AiOutlineFolderView(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683698855",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M309.1 554.3c-5.4 11.6-5.4 24.9 0 36.4C353.3 684 421.6 732 512.5 732s159.2-48.1 203.4-141.3c5.4-11.5 5.4-24.8 0.1-36.3l-0.1-0.1-0.1-0.1C671.7 461 603.4 413 512.5 413s-159.2 48.1-203.4 141.3zM512.5 477c62.1 0 107.4 30 141.1 95.5C620 638 574.6 668 512.5 668s-107.4-30-141.1-95.5c33.7-65.5 79-95.5 141.1-95.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M513 573m-56 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 298.4H521L403.7 186.2c-1.5-1.4-3.5-2.2-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z"
                }
            }
        ]
    })(props);
}
function AiOutlineFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z"
                }
            }
        ]
    })(props);
}
function AiOutlineFontColors(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M904 816H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8zm-650.3-80h85c4.2 0 8-2.7 9.3-6.8l53.7-166h219.2l53.2 166c1.3 4 5 6.8 9.3 6.8h89.1c1.1 0 2.2-.2 3.2-.5a9.7 9.7 0 0 0 6-12.4L573.6 118.6a9.9 9.9 0 0 0-9.2-6.6H462.1c-4.2 0-7.9 2.6-9.2 6.6L244.5 723.1c-.4 1-.5 2.1-.5 3.2-.1 5.3 4.3 9.7 9.7 9.7zm255.9-516.1h4.1l83.8 263.8H424.9l84.7-263.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineFontSize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M920 416H616c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h60v320h-46c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h164c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-46V480h60v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V424c0-4.4-3.6-8-8-8zM656 296V168c0-4.4-3.6-8-8-8H104c-4.4 0-8 3.6-8 8v128c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-64h168v560h-92c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-92V232h168v64c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineFork(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M752 100c-61.8 0-112 50.2-112 112 0 47.7 29.9 88.5 72 104.6v27.6L512 601.4 312 344.2v-27.6c42.1-16.1 72-56.9 72-104.6 0-61.8-50.2-112-112-112s-112 50.2-112 112c0 50.6 33.8 93.5 80 107.3v34.4c0 9.7 3.3 19.3 9.3 27L476 672.3v33.6c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1v-33.6l226.7-291.6c6-7.7 9.3-17.3 9.3-27v-34.4c46.2-13.8 80-56.7 80-107.3 0-61.8-50.2-112-112-112zM224 212a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm336 600a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0zm192-552a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            }
        ]
    })(props);
}
function AiOutlineForm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M904 512h-56c-4.4 0-8 3.6-8 8v320H184V184h320c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V520c0-4.4-3.6-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M355.9 534.9L354 653.8c-.1 8.9 7.1 16.2 16 16.2h.4l118-2.9c2-.1 4-.9 5.4-2.3l415.9-415c3.1-3.1 3.1-8.2 0-11.3L785.4 114.3c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-415.8 415a8.3 8.3 0 0 0-2.3 5.6zm63.5 23.6L779.7 199l45.2 45.1-360.5 359.7-45.7 1.1.7-46.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineFormatPainter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683552617",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M840 192h-56v-72c0-13.3-10.7-24-24-24H168c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h592c13.3 0 24-10.7 24-24V256h32v200H465c-22.1 0-40 17.9-40 40v136h-44c-4.4 0-8 3.6-8 8v228c0 0.6 0.1 1.3 0.2 1.9-0.1 2-0.2 4.1-0.2 6.1 0 46.4 37.6 84 84 84s84-37.6 84-84c0-2.1-0.1-4.1-0.2-6.1 0.1-0.6 0.2-1.2 0.2-1.9V640c0-4.4-3.6-8-8-8h-44V520h351c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40zM720 352H208V160h512v192zM477 876c0 11-9 20-20 20s-20-9-20-20V696h40v180z"
                }
            }
        ]
    })(props);
}
function AiOutlineForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M825.8 498L538.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L825.8 526c8.3-7.2 8.3-20.8 0-28zm-320 0L218.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L505.8 526c4.1-3.6 6.2-8.8 6.2-14 0-5.2-2.1-10.4-6.2-14z"
                }
            }
        ]
    })(props);
}
function AiOutlineFrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm352 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 0 1 248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 0 1 249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 0 1 775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 0 1 775 775zM512 533c-85.5 0-155.6 67.3-160 151.6a8 8 0 0 0 8 8.4h48.1c4.2 0 7.8-3.2 8.1-7.4C420 636.1 461.5 597 512 597s92.1 39.1 95.8 88.6c.3 4.2 3.9 7.4 8.1 7.4H664a8 8 0 0 0 8-8.4C667.6 600.3 597.5 533 512 533z"
                }
            }
        ]
    })(props);
}
function AiOutlineFullscreenExit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M391 240.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L200 146.3a8.03 8.03 0 0 0-11.3 0l-42.4 42.3a8.03 8.03 0 0 0 0 11.3L280 333.6l-43.9 43.9a8.01 8.01 0 0 0 4.7 13.6L401 410c5.1.6 9.5-3.7 8.9-8.9L391 240.9zm10.1 373.2L240.8 633c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L146.3 824a8.03 8.03 0 0 0 0 11.3l42.4 42.3c3.1 3.1 8.2 3.1 11.3 0L333.7 744l43.7 43.7A8.01 8.01 0 0 0 391 783l18.9-160.1c.6-5.1-3.7-9.4-8.8-8.8zm221.8-204.2L783.2 391c6.6-.8 9.4-8.9 4.7-13.6L744 333.6 877.7 200c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.3a8.03 8.03 0 0 0-11.3 0L690.3 279.9l-43.7-43.7a8.01 8.01 0 0 0-13.6 4.7L614.1 401c-.6 5.2 3.7 9.5 8.8 8.9zM744 690.4l43.9-43.9a8.01 8.01 0 0 0-4.7-13.6L623 614c-5.1-.6-9.5 3.7-8.9 8.9L633 783.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L824 877.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L744 690.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineFullscreen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290 236.4l43.9-43.9a8.01 8.01 0 0 0-4.7-13.6L169 160c-5.1-.6-9.5 3.7-8.9 8.9L179 329.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L370 423.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L290 236.4zm352.7 187.3c3.1 3.1 8.2 3.1 11.3 0l133.7-133.6 43.7 43.7a8.01 8.01 0 0 0 13.6-4.7L863.9 169c.6-5.1-3.7-9.5-8.9-8.9L694.8 179c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L600.3 370a8.03 8.03 0 0 0 0 11.3l42.4 42.4zM845 694.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L654 600.3a8.03 8.03 0 0 0-11.3 0l-42.4 42.3a8.03 8.03 0 0 0 0 11.3L734 787.6l-43.9 43.9a8.01 8.01 0 0 0 4.7 13.6L855 864c5.1.6 9.5-3.7 8.9-8.9L845 694.9zm-463.7-94.6a8.03 8.03 0 0 0-11.3 0L236.3 733.9l-43.7-43.7a8.01 8.01 0 0 0-13.6 4.7L160.1 855c-.6 5.1 3.7 9.5 8.9 8.9L329.2 845c6.6-.8 9.4-8.9 4.7-13.6L290 787.6 423.7 654c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineFunction(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683610100",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M841 370c3-3.3 2.7-8.3-0.6-11.3-1.5-1.3-3.4-2.1-5.3-2.1h-72.6c-2.4 0-4.6 1-6.1 2.8L633.5 504.6c-2.9 3.4-7.9 3.8-11.3 0.9-0.9-0.8-1.6-1.7-2.1-2.8l-63.5-141.3c-1.3-2.9-4.1-4.7-7.3-4.7H380.7l0.9-4.7 8-42.3c10.5-55.4 38-81.4 85.8-81.4 18.6 0 35.5 1.7 48.8 4.7l14.1-66.8c-22.6-4.7-35.2-6.1-54.9-6.1-103.3 0-156.4 44.3-175.9 147.3l-9.4 49.4h-97.6c-3.8 0-7.1 2.7-7.8 6.4L181.9 415c-0.9 4.3 1.9 8.6 6.2 9.5 0.5 0.1 1.1 0.2 1.6 0.2H284l-89 429.9c-0.9 4.3 1.9 8.6 6.2 9.5 0.5 0.1 1.1 0.2 1.6 0.2H269c3.8 0 7.1-2.7 7.8-6.4l89.7-433.1h135.8l68.2 139.1c1.4 2.9 1 6.4-1.2 8.8l-180.6 203c-2.9 3.3-2.6 8.4 0.7 11.3 1.5 1.3 3.4 2 5.3 2h72.7c2.4 0 4.6-1 6.1-2.8l123.7-146.7c2.8-3.4 7.9-3.8 11.3-1 0.9 0.8 1.6 1.7 2.1 2.8L676.4 784c1.3 2.8 4.1 4.7 7.3 4.7h64.6c4.4 0 8-3.6 8-8 0-1.2-0.3-2.4-0.8-3.5l-95.2-198.9c-1.4-2.9-0.9-6.4 1.3-8.8L841 370z"
                }
            }
        ]
    })(props);
}
function AiOutlineFundProjectionScreen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683753031",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M312.1 591.5c3.1 3.1 8.2 3.1 11.3 0l101.8-101.8 86.1 86.2c3.1 3.1 8.2 3.1 11.3 0l226.3-226.5c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8c-3.1-3.1-8.2-3.1-11.3 0L517 485.3l-86.1-86.2c-3.1-3.1-8.2-3.1-11.3 0L275.3 543.4c-3.1 3.1-3.1 8.2 0 11.3l36.8 36.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M904 160H548V96c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H120c-17.7 0-32 14.3-32 32v520c0 17.7 14.3 32 32 32h356.4v32L311.6 884.1c-3.7 2.4-4.7 7.3-2.3 11l30.3 47.2v0.1c2.4 3.7 7.4 4.7 11.1 2.3L512 838.9l161.3 105.8c3.7 2.4 8.7 1.4 11.1-2.3v-0.1l30.3-47.2c2.4-3.7 1.3-8.6-2.3-11L548 776.3V744h356c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32z m-40 512H160V232h704v440z"
                }
            }
        ]
    })(props);
}
function AiOutlineFundView(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683816874",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M956 686.5l-0.1-0.1-0.1-0.1C911.7 593 843.4 545 752.5 545s-159.2 48.1-203.4 141.3v0.1c-5.4 11.5-5.4 24.9 0 36.4C593.3 816 661.6 864 752.5 864s159.2-48.1 203.4-141.3c5.4-11.5 5.4-24.8 0.1-36.2zM752.5 800c-62.1 0-107.4-30-141.1-95.5C645 639 690.4 609 752.5 609c62.1 0 107.4 30 141.1 95.5C860 770 814.6 800 752.5 800z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M753 705m-56 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M136 232h704v253h72V192c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v520c0 17.7 14.3 32 32 32h352v-72H136V232z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M724.9 338.1l-36.8-36.8c-3.1-3.1-8.2-3.1-11.3 0L493 485.3l-86.1-86.2c-3.1-3.1-8.2-3.1-11.3 0L251.3 543.4c-3.1 3.1-3.1 8.2 0 11.3l36.8 36.8c3.1 3.1 8.2 3.1 11.3 0l101.8-101.8 86.1 86.2c3.1 3.1 8.2 3.1 11.3 0l226.3-226.5c3.2-3.1 3.2-8.2 0-11.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineFund(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M926 164H94c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V196c0-17.7-14.3-32-32-32zm-40 632H134V236h752v560zm-658.9-82.3c3.1 3.1 8.2 3.1 11.3 0l172.5-172.5 114.4 114.5c3.1 3.1 8.2 3.1 11.3 0l297-297.2c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 0 0-11.3 0L531 565 416.6 450.5a8.03 8.03 0 0 0-11.3 0l-214.9 215a8.03 8.03 0 0 0 0 11.3l36.7 36.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineFunnelPlot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 607.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V607.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V650h182.9v148zm9.6-226.6l-8.4 14.6H419.3l-8.4-14.6L334.4 438h355.2L613 571.4zM726.3 374H297.7l-85-148h598.6l-85 148z"
                }
            }
        ]
    })(props);
}
function AiOutlineGateway(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 392c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H744c-8.8 0-16 7.2-16 16v56H296v-56c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v184c0 8.8 7.2 16 16 16h56v240H96c-8.8 0-16 7.2-16 16v184c0 8.8 7.2 16 16 16h184c8.8 0 16-7.2 16-16v-56h432v56c0 8.8 7.2 16 16 16h184c8.8 0 16-7.2 16-16V648c0-8.8-7.2-16-16-16h-56V392h56zM792 240h88v88h-88v-88zm-648 88v-88h88v88h-88zm88 456h-88v-88h88v88zm648-88v88h-88v-88h88zm-80-64h-56c-8.8 0-16 7.2-16 16v56H296v-56c0-8.8-7.2-16-16-16h-56V392h56c8.8 0 16-7.2 16-16v-56h432v56c0 8.8 7.2 16 16 16h56v240z"
                }
            }
        ]
    })(props);
}
function AiOutlineGif(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683621237",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M944 299H692c-4.4 0-8 3.6-8 8v406c0 4.4 3.6 8 8 8h59.2c4.4 0 8-3.6 8-8V549.9h168.2c4.4 0 8-3.6 8-8V495c0-4.4-3.6-8-8-8H759.2V364.2H944c4.4 0 8-3.6 8-8V307c0-4.4-3.6-8-8-8zM588 300h-56c-4.4 0-8 3.6-8 8v406c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V308c0-4.4-3.6-8-8-8zM452 500.9H290.5c-4.4 0-8 3.6-8 8v43.7c0 4.4 3.6 8 8 8h94.9l-0.3 8.9c-1.2 58.8-45.6 98.5-110.9 98.5-76.2 0-123.9-59.7-123.9-156.7 0-95.8 46.8-155.2 121.5-155.2 54.8 0 93.1 26.9 108.5 75.4h76.2c-13.6-87.2-86-143.4-184.7-143.4C150 288 72 375.2 72 511.9 72 650.2 149.1 736 273 736c114.1 0 187-70.7 187-181.6v-45.5c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineGift(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 310H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v200c0 4.4 3.6 8 8 8h40v344c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V550h40c4.4 0 8-3.6 8-8V342c0-17.7-14.3-32-32-32zm-334-74c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70h-70v-70zm-138-70c38.6 0 70 31.4 70 70v70h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70zM180 482V378h298v104H180zm48 68h250v308H228V550zm568 308H546V550h250v308zm48-376H546V378h298v104z"
                }
            }
        ]
    })(props);
}
function AiOutlineGithub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0 1 38.1 91v112.5c.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineGitlab(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M913.9 552.2L805 181.4v-.1c-7.6-22.9-25.7-36.5-48.3-36.5-23.4 0-42.5 13.5-49.7 35.2l-71.4 213H388.8l-71.4-213c-7.2-21.7-26.3-35.2-49.7-35.2-23.1 0-42.5 14.8-48.4 36.6L110.5 552.2c-4.4 14.7 1.2 31.4 13.5 40.7l368.5 276.4c2.6 3.6 6.2 6.3 10.4 7.8l8.6 6.4 8.5-6.4c4.9-1.7 9-4.7 11.9-8.9l368.4-275.4c12.4-9.2 18-25.9 13.6-40.6zM751.7 193.4c1-1.8 2.9-1.9 3.5-1.9 1.1 0 2.5.3 3.4 3L818 394.3H684.5l67.2-200.9zm-487.4 1c.9-2.6 2.3-2.9 3.4-2.9 2.7 0 2.9.1 3.4 1.7l67.3 201.2H206.5l57.8-200zM158.8 558.7l28.2-97.3 202.4 270.2-230.6-172.9zm73.9-116.4h122.1l90.8 284.3-212.9-284.3zM512.9 776L405.7 442.3H620L512.9 776zm157.9-333.7h119.5L580 723.1l90.8-280.8zm-40.7 293.9l207.3-276.7 29.5 99.2-236.8 177.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineGlobal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.4 800.9c.2-.3.5-.6.7-.9C920.6 722.1 960 621.7 960 512s-39.4-210.1-104.8-288c-.2-.3-.5-.5-.7-.8-1.1-1.3-2.1-2.5-3.2-3.7-.4-.5-.8-.9-1.2-1.4l-4.1-4.7-.1-.1c-1.5-1.7-3.1-3.4-4.6-5.1l-.1-.1c-3.2-3.4-6.4-6.8-9.7-10.1l-.1-.1-4.8-4.8-.3-.3c-1.5-1.5-3-2.9-4.5-4.3-.5-.5-1-1-1.6-1.5-1-1-2-1.9-3-2.8-.3-.3-.7-.6-1-1C736.4 109.2 629.5 64 512 64s-224.4 45.2-304.3 119.2c-.3.3-.7.6-1 1-1 .9-2 1.9-3 2.9-.5.5-1 1-1.6 1.5-1.5 1.4-3 2.9-4.5 4.3l-.3.3-4.8 4.8-.1.1c-3.3 3.3-6.5 6.7-9.7 10.1l-.1.1c-1.6 1.7-3.1 3.4-4.6 5.1l-.1.1c-1.4 1.5-2.8 3.1-4.1 4.7-.4.5-.8.9-1.2 1.4-1.1 1.2-2.1 2.5-3.2 3.7-.2.3-.5.5-.7.8C103.4 301.9 64 402.3 64 512s39.4 210.1 104.8 288c.2.3.5.6.7.9l3.1 3.7c.4.5.8.9 1.2 1.4l4.1 4.7c0 .1.1.1.1.2 1.5 1.7 3 3.4 4.6 5l.1.1c3.2 3.4 6.4 6.8 9.6 10.1l.1.1c1.6 1.6 3.1 3.2 4.7 4.7l.3.3c3.3 3.3 6.7 6.5 10.1 9.6 80.1 74 187 119.2 304.5 119.2s224.4-45.2 304.3-119.2a300 300 0 0 0 10-9.6l.3-.3c1.6-1.6 3.2-3.1 4.7-4.7l.1-.1c3.3-3.3 6.5-6.7 9.6-10.1l.1-.1c1.5-1.7 3.1-3.3 4.6-5 0-.1.1-.1.1-.2 1.4-1.5 2.8-3.1 4.1-4.7.4-.5.8-.9 1.2-1.4a99 99 0 0 0 3.3-3.7zm4.1-142.6c-13.8 32.6-32 62.8-54.2 90.2a444.07 444.07 0 0 0-81.5-55.9c11.6-46.9 18.8-98.4 20.7-152.6H887c-3 40.9-12.6 80.6-28.5 118.3zM887 484H743.5c-1.9-54.2-9.1-105.7-20.7-152.6 29.3-15.6 56.6-34.4 81.5-55.9A373.86 373.86 0 0 1 887 484zM658.3 165.5c39.7 16.8 75.8 40 107.6 69.2a394.72 394.72 0 0 1-59.4 41.8c-15.7-45-35.8-84.1-59.2-115.4 3.7 1.4 7.4 2.9 11 4.4zm-90.6 700.6c-9.2 7.2-18.4 12.7-27.7 16.4V697a389.1 389.1 0 0 1 115.7 26.2c-8.3 24.6-17.9 47.3-29 67.8-17.4 32.4-37.8 58.3-59 75.1zm59-633.1c11 20.6 20.7 43.3 29 67.8A389.1 389.1 0 0 1 540 327V141.6c9.2 3.7 18.5 9.1 27.7 16.4 21.2 16.7 41.6 42.6 59 75zM540 640.9V540h147.5c-1.6 44.2-7.1 87.1-16.3 127.8l-.3 1.2A445.02 445.02 0 0 0 540 640.9zm0-156.9V383.1c45.8-2.8 89.8-12.5 130.9-28.1l.3 1.2c9.2 40.7 14.7 83.5 16.3 127.8H540zm-56 56v100.9c-45.8 2.8-89.8 12.5-130.9 28.1l-.3-1.2c-9.2-40.7-14.7-83.5-16.3-127.8H484zm-147.5-56c1.6-44.2 7.1-87.1 16.3-127.8l.3-1.2c41.1 15.6 85 25.3 130.9 28.1V484H336.5zM484 697v185.4c-9.2-3.7-18.5-9.1-27.7-16.4-21.2-16.7-41.7-42.7-59.1-75.1-11-20.6-20.7-43.3-29-67.8 37.2-14.6 75.9-23.3 115.8-26.1zm0-370a389.1 389.1 0 0 1-115.7-26.2c8.3-24.6 17.9-47.3 29-67.8 17.4-32.4 37.8-58.4 59.1-75.1 9.2-7.2 18.4-12.7 27.7-16.4V327zM365.7 165.5c3.7-1.5 7.3-3 11-4.4-23.4 31.3-43.5 70.4-59.2 115.4-21-12-40.9-26-59.4-41.8 31.8-29.2 67.9-52.4 107.6-69.2zM165.5 365.7c13.8-32.6 32-62.8 54.2-90.2 24.9 21.5 52.2 40.3 81.5 55.9-11.6 46.9-18.8 98.4-20.7 152.6H137c3-40.9 12.6-80.6 28.5-118.3zM137 540h143.5c1.9 54.2 9.1 105.7 20.7 152.6a444.07 444.07 0 0 0-81.5 55.9A373.86 373.86 0 0 1 137 540zm228.7 318.5c-39.7-16.8-75.8-40-107.6-69.2 18.5-15.8 38.4-29.7 59.4-41.8 15.7 45 35.8 84.1 59.2 115.4-3.7-1.4-7.4-2.9-11-4.4zm292.6 0c-3.7 1.5-7.3 3-11 4.4 23.4-31.3 43.5-70.4 59.2-115.4 21 12 40.9 26 59.4 41.8a373.81 373.81 0 0 1-107.6 69.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineGold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8zm91.2-196h159.5l20.7 128h-201l20.8-128zm2.5 282.7c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM196.5 748l20.7-128h159.5l20.7 128H196.5zm709.4 58.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zM626.5 748l20.7-128h159.5l20.7 128H626.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineGooglePlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M879.5 470.4c-.3-27-.4-54.2-.5-81.3h-80.8c-.3 27-.5 54.1-.7 81.3-27.2.1-54.2.3-81.2.6v80.9c27 .3 54.2.5 81.2.8.3 27 .3 54.1.5 81.1h80.9c.1-27 .3-54.1.5-81.3 27.2-.3 54.2-.4 81.2-.7v-80.9c-26.9-.2-54.1-.2-81.1-.5zm-530 .4c-.1 32.3 0 64.7.1 97 54.2 1.8 108.5 1 162.7 1.8-23.9 120.3-187.4 159.3-273.9 80.7-89-68.9-84.8-220 7.7-284 64.7-51.6 156.6-38.9 221.3 5.8 25.4-23.5 49.2-48.7 72.1-74.7-53.8-42.9-119.8-73.5-190-70.3-146.6-4.9-281.3 123.5-283.7 270.2-9.4 119.9 69.4 237.4 180.6 279.8 110.8 42.7 252.9 13.6 323.7-86 46.7-62.9 56.8-143.9 51.3-220-90.7-.7-181.3-.6-271.9-.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineGoogle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M881 442.4H519.7v148.5h206.4c-8.9 48-35.9 88.6-76.6 115.8-34.4 23-78.3 36.6-129.9 36.6-99.9 0-184.4-67.5-214.6-158.2-7.6-23-12-47.6-12-72.9s4.4-49.9 12-72.9c30.3-90.6 114.8-158.1 214.7-158.1 56.3 0 106.8 19.4 146.6 57.4l110-110.1c-66.5-62-153.2-100-256.6-100-149.9 0-279.6 86-342.7 211.4-26 51.8-40.8 110.4-40.8 172.4S151 632.8 177 684.6C240.1 810 369.8 896 519.7 896c103.6 0 190.4-34.4 253.8-93 72.5-66.8 114.4-165.2 114.4-282.1 0-27.2-2.4-53.3-6.9-78.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineGroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683739097",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M912 820.1V203.9c28-9.9 48-36.6 48-67.9 0-39.8-32.2-72-72-72-31.3 0-58 20-67.9 48H203.9C194 84 167.3 64 136 64c-39.8 0-72 32.2-72 72 0 31.3 20 58 48 67.9v616.2C84 830 64 856.7 64 888c0 39.8 32.2 72 72 72 31.3 0 58-20 67.9-48h616.2c9.9 28 36.6 48 67.9 48 39.8 0 72-32.2 72-72 0-31.3-20-58-48-67.9zM888 112c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zM136 912c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z m0-752c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z m704 680H184V184h656v656z m48 72c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M288 474h448c8.8 0 16-7.2 16-16V282c0-8.8-7.2-16-16-16H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16z m56-136h336v64H344v-64zM288 758h448c8.8 0 16-7.2 16-16V566c0-8.8-7.2-16-16-16H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16z m56-136h336v64H344v-64z"
                }
            }
        ]
    })(props);
}
function AiOutlineHdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-600 72h560v208H232V136zm560 480H232V408h560v208zm0 272H232V680h560v208zM496 208H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 544h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm328 244a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineHeatMap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-790.4-23.9L512 231.9 858.7 832H165.3zm319-474.1l-228 394c-12.3 21.3 3.1 48 27.7 48h455.8c24.7 0 40.1-26.7 27.7-48L539.7 358c-6.2-10.7-17-16-27.7-16-10.8 0-21.6 5.3-27.7 16zm214 386H325.7L512 422l186.3 322zm-214-194.1l-57 98.4C415 669.5 430.4 696 455 696h114c24.6 0 39.9-26.5 27.7-47.7l-57-98.4c-6.1-10.6-16.9-15.9-27.7-15.9s-21.5 5.3-27.7 15.9zm57.1 98.4h-58.7l29.4-50.7 29.3 50.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineHighlight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M957.6 507.4L603.2 158.2a7.9 7.9 0 0 0-11.2 0L353.3 393.4a8.03 8.03 0 0 0-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 0 0-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8V860c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6 40.4 39.8a7.9 7.9 0 0 0 11.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0 0 11.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2zM389.8 796.2H229.6l134.4-133 80.1 78.9-54.3 54.1zm154.8-62.1L373.2 565.2l68.6-67.6 171.4 168.9-68.6 67.6zM713.1 658L450.3 399.1 597.6 254l262.8 259-147.3 145z"
                }
            }
        ]
    })(props);
}
function AiOutlineHistory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M536.1 273H488c-4.4 0-8 3.6-8 8v275.3c0 2.6 1.2 5 3.3 6.5l165.3 120.7c3.6 2.6 8.6 1.9 11.2-1.7l28.6-39c2.7-3.7 1.9-8.7-1.7-11.2L544.1 528.5V281c0-4.4-3.6-8-8-8zm219.8 75.2l156.8 38.3c5 1.2 9.9-2.6 9.9-7.7l.8-161.5c0-6.7-7.7-10.5-12.9-6.3L752.9 334.1a8 8 0 0 0 3 14.1zm167.7 301.1l-56.7-19.5a8 8 0 0 0-10.1 4.8c-1.9 5.1-3.9 10.1-6 15.1-17.8 42.1-43.3 80-75.9 112.5a353 353 0 0 1-112.5 75.9 352.18 352.18 0 0 1-137.7 27.8c-47.8 0-94.1-9.3-137.7-27.8a353 353 0 0 1-112.5-75.9c-32.5-32.5-58-70.4-75.9-112.5A353.44 353.44 0 0 1 171 512c0-47.8 9.3-94.2 27.8-137.8 17.8-42.1 43.3-80 75.9-112.5a353 353 0 0 1 112.5-75.9C430.6 167.3 477 158 524.8 158s94.1 9.3 137.7 27.8A353 353 0 0 1 775 261.7c10.2 10.3 19.8 21 28.6 32.3l59.8-46.8C784.7 146.6 662.2 81.9 524.6 82 285 82.1 92.6 276.7 95 516.4 97.4 751.9 288.9 942 524.8 942c185.5 0 343.5-117.6 403.7-282.3 1.5-4.2-.7-8.9-4.9-10.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineHolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M300,276.497424 C317.32646,286.500861 338.67354,286.500861 356,276.497424 C373.326461,266.493987 384,248.006874 384,228 C384,207.993128 373.326461,189.506014 356,179.502578 C338.67354,169.499141 317.32646,169.499141 300,179.502578 C282.673539,189.506014 272,207.993128 272,228 C272,248.006874 282.673539,266.493987 300,276.497424 Z M300,560.497426 C317.32646,570.500863 338.67354,570.500863 356,560.497426 C373.326461,550.493989 384,532.006876 384,512.000002 C384,491.993129 373.326461,473.506016 356,463.502579 C338.67354,453.499142 317.32646,453.499142 300,463.502579 C282.673539,473.506016 272,491.993129 272,512.000002 C272,532.006876 282.673539,550.493989 300,560.497426 Z M640,228 C640,248.006874 650.673539,266.493987 668,276.497424 C685.32646,286.500861 706.67354,286.500861 724,276.497424 C741.326461,266.493987 752,248.006874 752,228 C752,207.993128 741.326461,189.506014 724,179.502578 C706.67354,169.499141 685.32646,169.499141 668,179.502578 C650.673539,189.506014 640,207.993128 640,228 L640,228 Z M640,512.000002 C640,532.006876 650.673539,550.493989 668,560.497426 C685.32646,570.500863 706.67354,570.500863 724,560.497426 C741.326461,550.493989 752,532.006876 752,512.000002 C752,491.993129 741.326461,473.506016 724,463.502579 C706.67354,453.499142 685.32646,453.499142 668,463.502579 C650.673539,473.506016 640,491.993129 640,512.000002 L640,512.000002 Z M300,844.497427 C317.32646,854.500864 338.67354,854.500864 356,844.497427 C373.326461,834.493991 384,816.006877 384,796.000003 C384,775.993131 373.326461,757.506018 356,747.502581 C338.67354,737.499144 317.32646,737.499144 300,747.502581 C282.673539,757.506018 272,775.993131 272,796.000003 C272,816.006877 282.673539,834.493991 300,844.497427 Z M640,796.000003 C640,816.006877 650.673539,834.493991 668,844.497427 C685.32646,854.500864 706.67354,854.500864 724,844.497427 C741.326461,834.493991 752,816.006877 752,796.000003 C752,775.993131 741.326461,757.506018 724,747.502581 C706.67354,737.499144 685.32646,737.499144 668,747.502581 C650.673539,757.506018 640,775.993131 640,796.000003 L640,796.000003 Z"
                }
            }
        ]
    })(props);
}
function AiOutlineHome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M946.5 505L560.1 118.8l-25.9-25.9a31.5 31.5 0 0 0-44.4 0L77.5 505a63.9 63.9 0 0 0-18.8 46c.4 35.2 29.7 63.3 64.9 63.3h42.5V940h691.8V614.3h43.4c17.1 0 33.2-6.7 45.3-18.8a63.6 63.6 0 0 0 18.7-45.3c0-17-6.7-33.1-18.8-45.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineHourglass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194zm-72 388v134H354V706c0-42.2 16.4-81.9 46.3-111.7C430.1 564.4 469.8 548 512 548s81.9 16.4 111.7 46.3C653.6 624.1 670 663.8 670 706zm0-388c0 42.2-16.4 81.9-46.3 111.7C593.9 459.6 554.2 476 512 476s-81.9-16.4-111.7-46.3A156.63 156.63 0 0 1 354 318V184h316v134z"
                }
            }
        ]
    })(props);
}
function AiOutlineHtml5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M145 96l66 746.6L511.8 928l299.6-85.4L878.7 96H145zm610.9 700.6l-244.1 69.6-245.2-69.6-56.7-641.2h603.8l-57.8 641.2zM281 249l1.7 24.3 22.7 253.5h206.5v-.1h112.9l-11.4 118.5L511 672.9v.2h-.8l-102.4-27.7-6.5-73.2h-91l11.3 144.7 188.6 52h1.7v-.4l187.7-51.7 1.7-16.3 21.2-242.2 3.2-24.3H511v.2H389.9l-8.2-94.2h352.1l1.7-19.5 4.8-47.2L742 249H511z"
                }
            }
        ]
    })(props);
}
function AiOutlineIdcard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560zM610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z"
                }
            }
        ]
    })(props);
}
function AiOutlineIe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M852.6 367.6c16.3-36.9 32.1-90.7 32.1-131.8 0-109.1-119.5-147.6-314.5-57.9-161.4-10.8-316.8 110.5-355.6 279.7 46.3-52.3 117.4-123.4 183-151.7C316.1 378.3 246.7 470 194 565.6c-31.1 56.9-66 148.8-66 217.5 0 147.9 139.3 129.8 270.4 63 47.1 23.1 99.8 23.4 152.5 23.4 145.7 0 276.4-81.4 325.2-219H694.9c-78.8 132.9-295.2 79.5-295.2-71.2h493.2c9.6-65.4-2.5-143.6-40.3-211.7zM224.8 648.3c26.6 76.7 80.6 143.8 150.4 185-133.1 73.4-259.9 43.6-150.4-185zm174-163.3c3-82.7 75.4-142.3 156-142.3 80.1 0 153 59.6 156 142.3h-312zm276.8-281.4c32.1-15.4 72.8-33 108.8-33 47.1 0 81.4 32.6 81.4 80.6 0 30-11.1 73.5-21.9 101.8-39.3-63.5-98.9-122.4-168.3-149.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineImport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024",
            "fill": "currentColor",
            "fillRule": "evenodd"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h360c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H184V184h656v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32ZM653.3 599.4l52.2-52.2c4.7-4.7 1.9-12.8-4.7-13.6l-179.4-21c-5.1-.6-9.5 3.7-8.9 8.9l21 179.4c.8 6.6 8.9 9.4 13.6 4.7l52.4-52.4 256.2 256.2c3.1 3.1 8.2 3.1 11.3 0l42.4-42.4c3.1-3.1 3.1-8.2 0-11.3L653.3 599.4Z",
                    "transform": "matrix(1 0 0 -1 0 1024)"
                }
            }
        ]
    })(props);
}
function AiOutlineInbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M885.2 446.3l-.2-.8-112.2-285.1c-5-16.1-19.9-27.2-36.8-27.2H281.2c-17 0-32.1 11.3-36.9 27.6L139.4 443l-.3.7-.2.8c-1.3 4.9-1.7 9.9-1 14.8-.1 1.6-.2 3.2-.2 4.8V830a60.9 60.9 0 0 0 60.8 60.8h627.2c33.5 0 60.8-27.3 60.9-60.8V464.1c0-1.3 0-2.6-.1-3.7.4-4.9 0-9.6-1.3-14.1zm-295.8-43l-.3 15.7c-.8 44.9-31.8 75.1-77.1 75.1-22.1 0-41.1-7.1-54.8-20.6S436 441.2 435.6 419l-.3-15.7H229.5L309 210h399.2l81.7 193.3H589.4zm-375 76.8h157.3c24.3 57.1 76 90.8 140.4 90.8 33.7 0 65-9.4 90.3-27.2 22.2-15.6 39.5-37.4 50.7-63.6h156.5V814H214.4V480.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineInfoCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M464 336a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineInfo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 224a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm96 168h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V400c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineInsertRowAbove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683507961",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M878.7 336H145.3c-18.4 0-33.3 14.3-33.3 32v464c0 17.7 14.9 32 33.3 32h733.3c18.4 0 33.3-14.3 33.3-32V368c0.1-17.7-14.8-32-33.2-32zM360 792H184V632h176v160z m0-224H184V408h176v160z m240 224H424V632h176v160z m0-224H424V408h176v160z m240 224H664V632h176v160z m0-224H664V408h176v160zM904 160H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineInsertRowBelow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683503597",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M904 768H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8zM878.7 160H145.3c-18.4 0-33.3 14.3-33.3 32v464c0 17.7 14.9 32 33.3 32h733.3c18.4 0 33.3-14.3 33.3-32V192c0.1-17.7-14.8-32-33.2-32zM360 616H184V456h176v160z m0-224H184V232h176v160z m240 224H424V456h176v160z m0-224H424V232h176v160z m240 224H664V456h176v160z m0-224H664V232h176v160z"
                }
            }
        ]
    })(props);
}
function AiOutlineInsertRowLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683561749",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M248 112h-80c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8zM832 112H368c-17.7 0-32 14.9-32 33.3v733.3c0 18.4 14.3 33.3 32 33.3h464c17.7 0 32-14.9 32-33.3V145.3c0-18.4-14.3-33.3-32-33.3zM568 840H408V664h160v176z m0-240H408V424h160v176z m0-240H408V184h160v176z m224 480H632V664h160v176z m0-240H632V424h160v176z m0-240H632V184h160v176z"
                }
            }
        ]
    })(props);
}
function AiOutlineInsertRowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683555439",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M856 112h-80c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8zM656 112H192c-17.7 0-32 14.9-32 33.3v733.3c0 18.4 14.3 33.3 32 33.3h464c17.7 0 32-14.9 32-33.3V145.3c0-18.4-14.3-33.3-32-33.3zM392 840H232V664h160v176z m0-240H232V424h160v176z m0-240H232V184h160v176z m224 480H456V664h160v176z m0-240H456V424h160v176z m0-240H456V184h160v176z"
                }
            }
        ]
    })(props);
}
function AiOutlineInstagram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 306.9c-113.5 0-205.1 91.6-205.1 205.1S398.5 717.1 512 717.1 717.1 625.5 717.1 512 625.5 306.9 512 306.9zm0 338.4c-73.4 0-133.3-59.9-133.3-133.3S438.6 378.7 512 378.7 645.3 438.6 645.3 512 585.4 645.3 512 645.3zm213.5-394.6c-26.5 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9 47.9-21.3 47.9-47.9a47.84 47.84 0 0 0-47.9-47.9zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zm-88 235.8c-7.3 18.2-16.1 31.8-30.2 45.8-14.1 14.1-27.6 22.9-45.8 30.2C695.2 844.7 570.3 840 512 840c-58.3 0-183.3 4.7-235.9-16.1-18.2-7.3-31.8-16.1-45.8-30.2-14.1-14.1-22.9-27.6-30.2-45.8C179.3 695.2 184 570.3 184 512c0-58.3-4.7-183.3 16.1-235.9 7.3-18.2 16.1-31.8 30.2-45.8s27.6-22.9 45.8-30.2C328.7 179.3 453.7 184 512 184s183.3-4.7 235.9 16.1c18.2 7.3 31.8 16.1 45.8 30.2 14.1 14.1 22.9 27.6 30.2 45.8C844.7 328.7 840 453.7 840 512c0 58.3 4.7 183.2-16.2 235.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineInsurance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M441.6 306.8L403 288.6a6.1 6.1 0 0 0-8.4 3.7c-17.5 58.5-45.2 110.1-82.2 153.6a6.05 6.05 0 0 0-1.2 5.6l13.2 43.5c1.3 4.4 7 5.7 10.2 2.4 7.7-8.1 15.4-16.9 23.1-26V656c0 4.4 3.6 8 8 8H403c4.4 0 8-3.6 8-8V393.1a429.2 429.2 0 0 0 33.6-79c1-2.9-.3-6-3-7.3zm26.8 9.2v127.2c0 4.4 3.6 8 8 8h65.9v18.6h-94.9c-4.4 0-8 3.6-8 8v35.6c0 4.4 3.6 8 8 8h55.1c-19.1 30.8-42.4 55.7-71 76a6 6 0 0 0-1.6 8.1l22.8 36.5c1.9 3.1 6.2 3.8 8.9 1.4 31.6-26.8 58.7-62.9 80.6-107.6v120c0 4.4 3.6 8 8 8h36.2c4.4 0 8-3.6 8-8V536c21.3 41.7 47.5 77.5 78.1 106.9 2.6 2.5 6.8 2.1 8.9-.7l26.3-35.3c2-2.7 1.4-6.5-1.2-8.4-30.5-22.6-54.2-47.8-72.3-76.9h59c4.4 0 8-3.6 8-8V478c0-4.4-3.6-8-8-8h-98.8v-18.6h66.7c4.4 0 8-3.6 8-8V316c0-4.4-3.6-8-8-8H476.4c-4.4 0-8 3.6-8 8zm51.5 42.8h97.9v41.6h-97.9v-41.6zm347-188.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z"
                }
            }
        ]
    })(props);
}
function AiOutlineInteraction(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineIssuesClose(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 688a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72-112c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48zm400-188h-59.3c-2.6 0-5 1.2-6.5 3.3L763.7 538.1l-49.9-68.8a7.92 7.92 0 0 0-6.5-3.3H648c-6.5 0-10.3 7.4-6.5 12.7l109.2 150.7a16.1 16.1 0 0 0 26 0l165.8-228.7c3.8-5.3 0-12.7-6.5-12.7zm-44 306h-64.2c-5.5 0-10.6 2.9-13.6 7.5a352.2 352.2 0 0 1-49.8 62.2A355.92 355.92 0 0 1 651.1 840a355 355 0 0 1-138.7 27.9c-48.1 0-94.8-9.4-138.7-27.9a355.92 355.92 0 0 1-113.3-76.3A353.06 353.06 0 0 1 184 650.5c-18.6-43.8-28-90.5-28-138.5s9.4-94.7 28-138.5c17.9-42.4 43.6-80.5 76.4-113.2 32.8-32.7 70.9-58.4 113.3-76.3a355 355 0 0 1 138.7-27.9c48.1 0 94.8 9.4 138.7 27.9 42.4 17.9 80.5 43.6 113.3 76.3 19 19 35.6 39.8 49.8 62.2 2.9 4.7 8.1 7.5 13.6 7.5H892c6 0 9.8-6.3 7.2-11.6C828.8 178.5 684.7 82 517.7 80 278.9 77.2 80.5 272.5 80 511.2 79.5 750.1 273.3 944 512.4 944c169.2 0 315.6-97 386.7-238.4A8 8 0 0 0 892 694z"
                }
            }
        ]
    })(props);
}
function AiOutlineItalic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M798 160H366c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h181.2l-156 544H229c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8H474.4l156-544H798c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineKey(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 112c-167.9 0-304 136.1-304 304 0 70.3 23.9 135 63.9 186.5l-41.1 41.1-62.3-62.3a8.15 8.15 0 0 0-11.4 0l-39.8 39.8a8.15 8.15 0 0 0 0 11.4l62.3 62.3-44.9 44.9-62.3-62.3a8.15 8.15 0 0 0-11.4 0l-39.8 39.8a8.15 8.15 0 0 0 0 11.4l62.3 62.3-65.3 65.3a8.03 8.03 0 0 0 0 11.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0l253.6-253.6A304.06 304.06 0 0 0 608 720c167.9 0 304-136.1 304-304S775.9 112 608 112zm161.2 465.2C726.2 620.3 668.9 644 608 644c-60.9 0-118.2-23.7-161.2-66.8-43.1-43-66.8-100.3-66.8-161.2 0-60.9 23.7-118.2 66.8-161.2 43-43.1 100.3-66.8 161.2-66.8 60.9 0 118.2 23.7 161.2 66.8 43.1 43 66.8 100.3 66.8 161.2 0 60.9-23.7 118.2-66.8 161.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineLaptop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M956.9 845.1L896.4 632V168c0-17.7-14.3-32-32-32h-704c-17.7 0-32 14.3-32 32v464L67.9 845.1C60.4 866 75.8 888 98 888h828.8c22.2 0 37.6-22 30.1-42.9zM200.4 208h624v395h-624V208zm228.3 608l8.1-37h150.3l8.1 37H428.7zm224 0l-19.1-86.7c-.8-3.7-4.1-6.3-7.8-6.3H398.2c-3.8 0-7 2.6-7.8 6.3L371.3 816H151l42.3-149h638.2l42.3 149H652.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineLayout(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-696 72h136v656H184V184zm656 656H384V384h456v456zM384 320V184h456v136H384z"
                }
            }
        ]
    })(props);
}
function AiOutlineLeftCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M603.3 327.5l-246 178a7.95 7.95 0 0 0 0 12.9l246 178c5.3 3.8 12.7 0 12.7-6.5V643c0-10.2-4.9-19.9-13.2-25.9L457.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    })(props);
}
function AiOutlineLeftSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M365.3 518.5l246 178c5.3 3.8 12.7 0 12.7-6.5v-46.9c0-10.2-4.9-19.9-13.2-25.9L465.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5l-246 178a8.05 8.05 0 0 0 0 13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlineLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 0 0 0 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"
                }
            }
        ]
    })(props);
}
function AiOutlineLike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 0 0-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 0 0 471 99.9c-52 0-98 35-111.8 85.1l-85.9 311H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h601.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM184 852V568h81v284h-81zm636.4-353l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 22.4-13.2 42.6-33.6 51.8H329V564.8l99.5-360.5a44.1 44.1 0 0 1 42.2-32.3c7.6 0 15.1 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.2 32.1-19.6 43z"
                }
            }
        ]
    })(props);
}
function AiOutlineLineChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM305.8 637.7c3.1 3.1 8.1 3.1 11.3 0l138.3-137.6L583 628.5c3.1 3.1 8.2 3.1 11.3 0l275.4-275.3c3.1-3.1 3.1-8.2 0-11.3l-39.6-39.6a8.03 8.03 0 0 0-11.3 0l-230 229.9L461.4 404a8.03 8.03 0 0 0-11.3 0L266.3 586.7a8.03 8.03 0 0 0 0 11.3l39.5 39.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineLineHeight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M648 160H104c-4.4 0-8 3.6-8 8v128c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-64h168v560h-92c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-92V232h168v64c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zm272.8 546H856V318h64.8c6 0 9.4-7 5.7-11.7L825.7 178.7a7.14 7.14 0 0 0-11.3 0L713.6 306.3a7.23 7.23 0 0 0 5.7 11.7H784v388h-64.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5a7.2 7.2 0 0 0-5.6-11.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineLine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M904 476H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineLink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M574 665.4a8.03 8.03 0 0 0-11.3 0L446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3l-39.8-39.8a8.03 8.03 0 0 0-11.3 0L191.4 526.5c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3L574 665.4zm258.6-474c-84.6-84.6-221.5-84.6-306 0L410.3 307.6a8.03 8.03 0 0 0 0 11.3l39.7 39.7c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204L665.3 562.6a8.03 8.03 0 0 0 0 11.3l39.8 39.8c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c84.5-84.6 84.5-221.5 0-306.1zM610.1 372.3a8.03 8.03 0 0 0-11.3 0L372.3 598.7a8.03 8.03 0 0 0 0 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l226.4-226.4c3.1-3.1 3.1-8.2 0-11.3l-39.5-39.6z"
                }
            }
        ]
    })(props);
}
function AiOutlineLinkedin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M847.7 112H176.3c-35.5 0-64.3 28.8-64.3 64.3v671.4c0 35.5 28.8 64.3 64.3 64.3h671.4c35.5 0 64.3-28.8 64.3-64.3V176.3c0-35.5-28.8-64.3-64.3-64.3zm0 736c-447.8-.1-671.7-.2-671.7-.3.1-447.8.2-671.7.3-671.7 447.8.1 671.7.2 671.7.3-.1 447.8-.2 671.7-.3 671.7zM230.6 411.9h118.7v381.8H230.6zm59.4-52.2c37.9 0 68.8-30.8 68.8-68.8a68.8 68.8 0 1 0-137.6 0c-.1 38 30.7 68.8 68.8 68.8zm252.3 245.1c0-49.8 9.5-98 71.2-98 60.8 0 61.7 56.9 61.7 101.2v185.7h118.6V584.3c0-102.8-22.2-181.9-142.3-181.9-57.7 0-96.4 31.7-112.3 61.7h-1.6v-52.2H423.7v381.8h118.6V604.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineLoading3Quarters(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 1024c-69.1 0-136.2-13.5-199.3-40.2C251.7 958 197 921 150 874c-47-47-84-101.7-109.8-162.7C13.5 648.2 0 581.1 0 512c0-19.9 16.1-36 36-36s36 16.1 36 36c0 59.4 11.6 117 34.6 171.3 22.2 52.4 53.9 99.5 94.3 139.9 40.4 40.4 87.5 72.2 139.9 94.3C395 940.4 452.6 952 512 952c59.4 0 117-11.6 171.3-34.6 52.4-22.2 99.5-53.9 139.9-94.3 40.4-40.4 72.2-87.5 94.3-139.9C940.4 629 952 571.4 952 512c0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.2C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3s-13.5 136.2-40.2 199.3C958 772.3 921 827 874 874c-47 47-101.8 83.9-162.7 109.7-63.1 26.8-130.2 40.3-199.3 40.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineLoading(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
                }
            }
        ]
    })(props);
}
function AiOutlineLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineLogin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M521.7 82c-152.5-.4-286.7 78.5-363.4 197.7-3.4 5.3.4 12.3 6.7 12.3h70.3c4.8 0 9.3-2.1 12.3-5.8 7-8.5 14.5-16.7 22.4-24.5 32.6-32.5 70.5-58.1 112.7-75.9 43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 32.6 32.5 58.1 70.4 76 112.5C865.7 417.8 875 464.1 875 512c0 47.9-9.4 94.2-27.8 137.8-17.8 42.1-43.4 80-76 112.5s-70.5 58.1-112.7 75.9A352.8 352.8 0 0 1 520.6 866c-47.9 0-94.3-9.4-137.9-27.8A353.84 353.84 0 0 1 270 762.3c-7.9-7.9-15.3-16.1-22.4-24.5-3-3.7-7.6-5.8-12.3-5.8H165c-6.3 0-10.2 7-6.7 12.3C234.9 863.2 368.5 942 520.6 942c236.2 0 428-190.1 430.4-425.6C953.4 277.1 761.3 82.6 521.7 82zM395.02 624v-76h-314c-4.4 0-8-3.6-8-8v-56c0-4.4 3.6-8 8-8h314v-76c0-6.7 7.8-10.5 13-6.3l141.9 112a8 8 0 0 1 0 12.6l-141.9 112c-5.2 4.1-13 .4-13-6.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineLogout(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M868 732h-70.3c-4.8 0-9.3 2.1-12.3 5.8-7 8.5-14.5 16.7-22.4 24.5a353.84 353.84 0 0 1-112.7 75.9A352.8 352.8 0 0 1 512.4 866c-47.9 0-94.3-9.4-137.9-27.8a353.84 353.84 0 0 1-112.7-75.9 353.28 353.28 0 0 1-76-112.5C167.3 606.2 158 559.9 158 512s9.4-94.2 27.8-137.8c17.8-42.1 43.4-80 76-112.5s70.5-58.1 112.7-75.9c43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 7.9 7.9 15.3 16.1 22.4 24.5 3 3.7 7.6 5.8 12.3 5.8H868c6.3 0 10.2-7 6.7-12.3C798 160.5 663.8 81.6 511.3 82 271.7 82.6 79.6 277.1 82 516.4 84.4 751.9 276.2 942 512.4 942c152.1 0 285.7-78.8 362.3-197.7 3.4-5.3-.4-12.3-6.7-12.3zm88.9-226.3L815 393.7c-5.3-4.2-13-.4-13 6.3v76H488c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 0 0 0-12.6z"
                }
            }
        ]
    })(props);
}
function AiOutlineMacCommand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683819749",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32z m-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M370.8 554.4c-54.6 0-98.8 44.2-98.8 98.8s44.2 98.8 98.8 98.8 98.8-44.2 98.8-98.8v-42.4h84.7v42.4c0 54.6 44.2 98.8 98.8 98.8s98.8-44.2 98.8-98.8-44.2-98.8-98.8-98.8h-42.4v-84.7h42.4c54.6 0 98.8-44.2 98.8-98.8 0-54.6-44.2-98.8-98.8-98.8s-98.8 44.2-98.8 98.8v42.4h-84.7v-42.4c0-54.6-44.2-98.8-98.8-98.8S272 316.2 272 370.8s44.2 98.8 98.8 98.8h42.4v84.7h-42.4z m42.4 98.8c0 23.4-19 42.4-42.4 42.4s-42.4-19-42.4-42.4 19-42.4 42.4-42.4h42.4v42.4z m197.6-282.4c0-23.4 19-42.4 42.4-42.4s42.4 19 42.4 42.4-19 42.4-42.4 42.4h-42.4v-42.4z m0 240h42.4c23.4 0 42.4 19 42.4 42.4s-19 42.4-42.4 42.4-42.4-19-42.4-42.4v-42.4zM469.6 469.6h84.7v84.7h-84.7v-84.7z m-98.8-56.4c-23.4 0-42.4-19-42.4-42.4s19-42.4 42.4-42.4 42.4 19 42.4 42.4v42.4h-42.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineMail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 110.8V792H136V270.8l-27.6-21.5 39.3-50.5 42.8 33.3h643.1l42.8-33.3 39.3 50.5-27.7 21.5zM833.6 232L512 482 190.4 232l-42.8-33.3-39.3 50.5 27.6 21.5 341.6 265.6a55.99 55.99 0 0 0 68.7 0L888 270.8l27.6-21.5-39.3-50.5-42.7 33.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineMan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M874 120H622c-3.3 0-6 2.7-6 6v56c0 3.3 2.7 6 6 6h160.4L583.1 387.3c-50-38.5-111-59.3-175.1-59.3-76.9 0-149.3 30-203.6 84.4S120 539.1 120 616s30 149.3 84.4 203.6C258.7 874 331.1 904 408 904s149.3-30 203.6-84.4C666 765.3 696 692.9 696 616c0-64.1-20.8-124.9-59.2-174.9L836 241.9V402c0 3.3 2.7 6 6 6h56c3.3 0 6-2.7 6-6V150c0-16.5-13.5-30-30-30zM408 828c-116.9 0-212-95.1-212-212s95.1-212 212-212 212 95.1 212 212-95.1 212-212 212z"
                }
            }
        ]
    })(props);
}
function AiOutlineMedicineBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M839.2 278.1a32 32 0 0 0-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 0 0-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM360 184h304v72H360v-72zm480 656H184V513.4L244.3 328h535.4L840 513.4V840zM652 572H544V464c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V636h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineMediumWorkmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M517.2 590.55c0 3.55 0 4.36 2.4 6.55l13.43 13.25v.57h-59.57v-25.47a41.44 41.44 0 0 1-39.5 27.65c-30.61 0-52.84-24.25-52.84-68.87 0-41.8 23.99-69.69 57.65-69.69a35.15 35.15 0 0 1 34.61 21.67v-56.19a6.99 6.99 0 0 0-2.71-6.79l-12.8-12.45v-.56l59.33-7.04v177.37zm-43.74-8.09v-83.83a22.2 22.2 0 0 0-17.74-8.4c-14.48 0-28.47 13.25-28.47 52.62 0 36.86 12.07 49.88 27.1 49.88a23.91 23.91 0 0 0 19.11-10.27zm83.23 28.46V497.74a7.65 7.65 0 0 0-2.4-6.79l-13.19-13.74v-.57h59.56v114.8c0 3.55 0 4.36 2.4 6.54l13.12 12.45v.57l-59.49-.08zm-2.16-175.67c0-13.4 10.74-24.25 23.99-24.25 13.25 0 23.98 10.86 23.98 24.25 0 13.4-10.73 24.25-23.98 24.25s-23.99-10.85-23.99-24.25zm206.83 155.06c0 3.55 0 4.6 2.4 6.79l13.43 13.25v.57h-59.88V581.9a43.4 43.4 0 0 1-41.01 31.2c-26.55 0-40.78-19.56-40.78-56.59 0-17.86 0-37.43.56-59.41a6.91 6.91 0 0 0-2.4-6.55L620.5 477.2v-.57h59.09v73.81c0 24.25 3.51 40.42 18.54 40.42a23.96 23.96 0 0 0 19.35-12.2v-80.85a7.65 7.65 0 0 0-2.4-6.79l-13.27-13.82v-.57h59.56V590.3zm202.76 20.6c0-4.36.8-59.97.8-72.75 0-24.25-3.76-40.98-20.63-40.98a26.7 26.7 0 0 0-21.19 11.64 99.68 99.68 0 0 1 2.4 23.04c0 16.81-.56 38.23-.8 59.66a6.91 6.91 0 0 0 2.4 6.55l13.43 12.45v.56h-60.12c0-4.04.8-59.98.8-72.76 0-24.65-3.76-40.98-20.39-40.98-8.2.3-15.68 4.8-19.83 11.96v82.46c0 3.56 0 4.37 2.4 6.55l13.11 12.45v.56h-59.48V498.15a7.65 7.65 0 0 0-2.4-6.8l-13.19-14.14v-.57H841v28.78c5.53-19 23.13-31.76 42.7-30.96 19.82 0 33.26 11.16 38.93 32.34a46.41 46.41 0 0 1 44.77-32.34c26.55 0 41.58 19.8 41.58 57.23 0 17.87-.56 38.24-.8 59.66a6.5 6.5 0 0 0 2.72 6.55l13.11 12.45v.57h-59.88zM215.87 593.3l17.66 17.05v.57h-89.62v-.57l17.99-17.05a6.91 6.91 0 0 0 2.4-6.55V477.69c0-4.6 0-10.83.8-16.16L104.66 613.1h-.72l-62.6-139.45c-1.37-3.47-1.77-3.72-2.65-6.06v91.43a32.08 32.08 0 0 0 2.96 17.87l25.19 33.46v.57H0v-.57l25.18-33.55a32.16 32.16 0 0 0 2.96-17.78V457.97A19.71 19.71 0 0 0 24 444.15L6.16 420.78v-.56h63.96l53.56 118.1 47.17-118.1h62.6v.56l-17.58 19.8a6.99 6.99 0 0 0-2.72 6.8v139.37a6.5 6.5 0 0 0 2.72 6.55zm70.11-54.65v.56c0 34.6 17.67 48.5 38.38 48.5a43.5 43.5 0 0 0 40.77-24.97h.56c-7.2 34.2-28.14 50.36-59.48 50.36-33.82 0-65.72-20.61-65.72-68.39 0-50.2 31.98-70.25 67.32-70.25 28.46 0 58.76 13.58 58.76 57.24v6.95h-80.59zm0-6.95h39.42v-7.04c0-35.57-7.28-45.03-18.23-45.03-13.27 0-21.35 14.15-21.35 52.07h.16z"
                }
            }
        ]
    })(props);
}
function AiOutlineMedium(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M834.7 279.8l61.3-58.9V208H683.7L532.4 586.4 360.3 208H137.7v12.9l71.6 86.6c7 6.4 10.6 15.8 9.7 25.2V673c2.2 12.3-1.7 24.8-10.3 33.7L128 805v12.7h228.6v-12.9l-80.6-98a39.99 39.99 0 0 1-11.1-33.7V378.7l200.7 439.2h23.3l172.6-439.2v349.9c0 9.2 0 11.1-6 17.2l-62.1 60.3V819h301.2v-12.9l-59.9-58.9c-5.2-4-7.9-10.7-6.8-17.2V297a18.1 18.1 0 0 1 6.8-17.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineMeh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm352 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 0 1 248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 0 1 249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 0 1 775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 0 1 775 775zM664 565H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineMenuFold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM115.4 518.9L271.7 642c5.8 4.6 14.4.5 14.4-6.9V388.9c0-7.4-8.5-11.5-14.4-6.9L115.4 505.1a8.74 8.74 0 0 0 0 13.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineMenuUnfold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z"
                }
            }
        ]
    })(props);
}
function AiOutlineMenu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineMergeCells(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683404098",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M482.2 508.4L331.3 389c-3-2.4-7.3-0.2-7.3 3.6V478H184V184h204v128c0 2.2 1.8 4 4 4h60c2.2 0 4-1.8 4-4V144c0-15.5-12.5-28-28-28H144c-15.5 0-28 12.5-28 28v736c0 15.5 12.5 28 28 28h284c15.5 0 28-12.5 28-28V712c0-2.2-1.8-4-4-4h-60c-2.2 0-4 1.8-4 4v128H184V546h140v85.4c0 3.8 4.4 6 7.3 3.6l150.9-119.4c2.4-1.8 2.4-5.4 0-7.2zM880 116H596c-15.5 0-28 12.5-28 28v168c0 2.2 1.8 4 4 4h60c2.2 0 4-1.8 4-4V184h204v294H700v-85.4c0-3.8-4.3-6-7.3-3.6l-151 119.4c-2.3 1.8-2.3 5.3 0 7.1l151 119.5c2.9 2.3 7.3 0.2 7.3-3.6V546h140v294H636V712c0-2.2-1.8-4-4-4h-60c-2.2 0-4 1.8-4 4v168c0 15.5 12.5 28 28 28h284c15.5 0 28-12.5 28-28V144c0-15.5-12.5-28-28-28z"
                }
            }
        ]
    })(props);
}
function AiOutlineMessage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm200 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-400 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm661.2-173.6c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 0 0-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 0 0-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 0 0 112 714v152a46 46 0 0 0 46 46h152.1A449.4 449.4 0 0 0 510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 0 0 142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineMinusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    })(props);
}
function AiOutlineMinusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlineMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M872 474H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineMobile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zm-8 824H288V134h448v752zM472 784a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineMoneyCollect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M911.5 700.7a8 8 0 0 0-10.3-4.8L840 718.2V180c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V763c0 3.3 2.1 6.3 5.3 7.5L501 910.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zM512 837.5l-256-93.1V184h512v560.4l-256 93.1zM660.6 312h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 0 0-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.6-1.2 1-2.5 1-3.8-.1-4.3-3.7-7.9-8.1-7.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineMonitor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M692.8 412.7l.2-.2-34.6-44.3a7.97 7.97 0 0 0-11.2-1.4l-50.4 39.3-70.5-90.1a7.97 7.97 0 0 0-11.2-1.4l-37.9 29.7a7.97 7.97 0 0 0-1.4 11.2l70.5 90.2-.2.1 34.6 44.3c2.7 3.5 7.7 4.1 11.2 1.4l50.4-39.3 64.1 82c2.7 3.5 7.7 4.1 11.2 1.4l37.9-29.6c3.5-2.7 4.1-7.7 1.4-11.2l-64.1-82.1zM608 112c-167.9 0-304 136.1-304 304 0 70.3 23.9 135 63.9 186.5L114.3 856.1a8.03 8.03 0 0 0 0 11.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0l253.6-253.6C473 696.1 537.7 720 608 720c167.9 0 304-136.1 304-304S775.9 112 608 112zm161.2 465.2C726.2 620.3 668.9 644 608 644s-118.2-23.7-161.2-66.8C403.7 534.2 380 476.9 380 416s23.7-118.2 66.8-161.2c43-43.1 100.3-66.8 161.2-66.8s118.2 23.7 161.2 66.8c43.1 43 66.8 100.3 66.8 161.2s-23.7 118.2-66.8 161.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineMore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M456 231a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 280a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 280a56 56 0 1 0 112 0 56 56 0 1 0-112 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineNodeCollapse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683371420",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M952 612c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H298c-14.2-35.2-48.7-60-89-60-53 0-96 43-96 96s43 96 96 96c40.3 0 74.8-24.8 89-60h150.3v152c0 55.2 44.8 100 100 100H952c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H548.3c-15.5 0-28-12.5-28-28V612H952zM451.7 313.7l172.5 136.2c6.3 5.1 15.8 0.5 15.8-7.7V344h264c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H640v-98.2c0-8.1-9.4-12.8-15.8-7.7L451.7 298.3c-4.9 3.9-4.9 11.5 0 15.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineNodeExpand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683374330",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M952 612c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H298c-14.2-35.2-48.7-60-89-60-53 0-96 43-96 96s43 96 96 96c40.3 0 74.8-24.8 89-60h150.3v152c0 55.2 44.8 100 100 100H952c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H548.3c-15.5 0-28-12.5-28-28V612H952zM456 344h264v98.2c0 8.1 9.5 12.8 15.8 7.7l172.5-136.2c5-3.9 5-11.4 0-15.3L735.8 162.1c-6.4-5.1-15.8-0.5-15.8 7.7V268H456c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineNodeIndex(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683635191",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M843.5 737.4c-12.4-75.2-79.2-129.1-155.3-125.4S550.9 676 546 752c-153.5-4.8-208-40.7-199.1-113.7 3.3-27.3 19.8-41.9 50.1-49 18.4-4.3 38.8-4.9 57.3-3.2 1.7 0.2 3.5 0.3 5.2 0.5 11.3 2.7 22.8 5 34.3 6.8 34.1 5.6 68.8 8.4 101.8 6.6 92.8-5 156-45.9 159.2-132.7 3.1-84.1-54.7-143.7-147.9-183.6-29.9-12.8-61.6-22.7-93.3-30.2-14.3-3.4-26.3-5.7-35.2-7.2-7.9-75.9-71.5-133.8-147.8-134.4-76.3-0.6-140.9 56.1-150.1 131.9s40 146.3 114.2 163.9c74.2 17.6 149.9-23.3 175.7-95.1 9.4 1.7 18.7 3.6 28 5.8 28.2 6.6 56.4 15.4 82.4 26.6 70.7 30.2 109.3 70.1 107.5 119.9-1.6 44.6-33.6 65.2-96.2 68.6-27.5 1.5-57.6-0.9-87.3-5.8-8.3-1.4-15.9-2.8-22.6-4.3-3.9-0.8-6.6-1.5-7.8-1.8l-3.1-0.6c-2.2-0.3-5.9-0.8-10.7-1.3-25-2.3-52.1-1.5-78.5 4.6-55.2 12.9-93.9 47.2-101.1 105.8-15.7 126.2 78.6 184.7 276 188.9 29.1 70.4 106.4 107.9 179.6 87 73.3-20.9 119.3-93.4 106.9-168.6zM329.1 345.2c-46 0-83.3-37.3-83.3-83.3s37.3-83.3 83.3-83.3 83.3 37.3 83.3 83.3-37.3 83.3-83.3 83.3zM695.6 845c-46 0-83.3-37.3-83.3-83.3s37.3-83.3 83.3-83.3 83.3 37.3 83.3 83.3-37.3 83.3-83.3 83.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineNotification(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.7c-3.7 11.6-5.7 23.9-5.7 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1zm496 58.4L318.8 611.3l-12.9-5.2H184V417.9h121.9l12.9-5.2L840 203.3v617.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineNumber(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M872 394c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H400V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v236H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h228v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h164c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V394h164zM628 630H400V394h228v236z"
                }
            }
        ]
    })(props);
}
function AiOutlineOneToOne(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683653709",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M316 672h60c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8zM512 622c22.1 0 40-17.9 40-39 0-23.1-17.9-41-40-41s-40 17.9-40 41c0 21.1 17.9 39 40 39zM512 482c22.1 0 40-17.9 40-39 0-23.1-17.9-41-40-41s-40 17.9-40 41c0 21.1 17.9 39 40 39z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32z m-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M648 672h60c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineOrderedList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M920 760H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-568H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM216 712H100c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h72.4v20.5h-35.7c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h35.7V838H100c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h116c2.2 0 4-1.8 4-4V716c0-2.2-1.8-4-4-4zM100 188h38v120c0 2.2 1.8 4 4 4h40c2.2 0 4-1.8 4-4V152c0-4.4-3.6-8-8-8h-78c-2.2 0-4 1.8-4 4v36c0 2.2 1.8 4 4 4zm116 240H100c-2.2 0-4 1.8-4 4v36c0 2.2 1.8 4 4 4h68.4l-70.3 77.7a8.3 8.3 0 0 0-2.1 5.4V592c0 2.2 1.8 4 4 4h116c2.2 0 4-1.8 4-4v-36c0-2.2-1.8-4-4-4h-68.4l70.3-77.7a8.3 8.3 0 0 0 2.1-5.4V432c0-2.2-1.8-4-4-4z"
                }
            }
        ]
    })(props);
}
function AiOutlinePaperClip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0 0 12.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0 0 12.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 0 0 174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z"
                }
            }
        ]
    })(props);
}
function AiOutlinePartition(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683632175",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M640.6 429.8h257.1c7.9 0 14.3-6.4 14.3-14.3V158.3c0-7.9-6.4-14.3-14.3-14.3H640.6c-7.9 0-14.3 6.4-14.3 14.3v92.9H490.6c-3.9 0-7.1 3.2-7.1 7.1v221.5h-85.7v-96.5c0-7.9-6.4-14.3-14.3-14.3H126.3c-7.9 0-14.3 6.4-14.3 14.3v257.2c0 7.9 6.4 14.3 14.3 14.3h257.1c7.9 0 14.3-6.4 14.3-14.3V544h85.7v221.5c0 3.9 3.2 7.1 7.1 7.1h135.7v92.9c0 7.9 6.4 14.3 14.3 14.3h257.1c7.9 0 14.3-6.4 14.3-14.3v-257c0-7.9-6.4-14.3-14.3-14.3h-257c-7.9 0-14.3 6.4-14.3 14.3v100h-78.6v-393h78.6v100c0 7.9 6.4 14.3 14.3 14.3z m53.5-217.9h150V362h-150V211.9zM329.9 587h-150V437h150v150z m364.2 75.1h150v150.1h-150V662.1z"
                }
            }
        ]
    })(props);
}
function AiOutlinePauseCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm-88-532h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zm224 0h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlinePause(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 176h80v672h-80zm408 0h-64c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlinePayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm159.6-585h-59.5c-3 0-5.8 1.7-7.1 4.4l-90.6 180H511l-90.6-180a8 8 0 0 0-7.1-4.4h-60.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9L457 515.7h-61.4c-4.4 0-8 3.6-8 8v29.9c0 4.4 3.6 8 8 8h81.7V603h-81.7c-4.4 0-8 3.6-8 8v29.9c0 4.4 3.6 8 8 8h81.7V717c0 4.4 3.6 8 8 8h54.3c4.4 0 8-3.6 8-8v-68.1h82c4.4 0 8-3.6 8-8V611c0-4.4-3.6-8-8-8h-82v-41.5h82c4.4 0 8-3.6 8-8v-29.9c0-4.4-3.6-8-8-8h-62l111.1-204.8c.6-1.2 1-2.5 1-3.8-.1-4.4-3.7-8-8.1-8z"
                }
            }
        ]
    })(props);
}
function AiOutlinePercentage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M855.7 210.8l-42.4-42.4a8.03 8.03 0 0 0-11.3 0L168.3 801.9a8.03 8.03 0 0 0 0 11.3l42.4 42.4c3.1 3.1 8.2 3.1 11.3 0L855.6 222c3.2-3 3.2-8.1.1-11.2zM304 448c79.4 0 144-64.6 144-144s-64.6-144-144-144-144 64.6-144 144 64.6 144 144 144zm0-216c39.7 0 72 32.3 72 72s-32.3 72-72 72-72-32.3-72-72 32.3-72 72-72zm416 344c-79.4 0-144 64.6-144 144s64.6 144 144 144 144-64.6 144-144-64.6-144-144-144zm0 216c-39.7 0-72-32.3-72-72s32.3-72 72-72 72 32.3 72 72-32.3 72-72 72z"
                }
            }
        ]
    })(props);
}
function AiOutlinePhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7a405.46 405.46 0 0 1-86.4 127.3c-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3a68.2 68.2 0 0 0-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4zm-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 .9.9 21.6-8a481.29 481.29 0 0 0 285.7-285.8l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z"
                }
            }
        ]
    })(props);
}
function AiOutlinePicCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM848 660c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h672zM232 436h560v152H232V436z"
                }
            }
        ]
    })(props);
}
function AiOutlinePicLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM608 660c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h512zM152 436h400v152H152V436zm552 210c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H712c-4.4 0-8 3.6-8 8v56zm8-204h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H712c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlinePicRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-24 500c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H416c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h512zM472 436h400v152H472V436zM80 646c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8v56zm8-204h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlinePicture(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2zM304 456a88 88 0 1 0 0-176 88 88 0 0 0 0 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z"
                }
            }
        ]
    })(props);
}
function AiOutlinePieChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M864 518H506V160c0-4.4-3.6-8-8-8h-26a398.46 398.46 0 0 0-282.8 117.1 398.19 398.19 0 0 0-85.7 127.1A397.61 397.61 0 0 0 72 552a398.46 398.46 0 0 0 117.1 282.8c36.7 36.7 79.5 65.6 127.1 85.7A397.61 397.61 0 0 0 472 952a398.46 398.46 0 0 0 282.8-117.1c36.7-36.7 65.6-79.5 85.7-127.1A397.61 397.61 0 0 0 872 552v-26c0-4.4-3.6-8-8-8zM705.7 787.8A331.59 331.59 0 0 1 470.4 884c-88.1-.4-170.9-34.9-233.2-97.2C174.5 724.1 140 640.7 140 552c0-88.7 34.5-172.1 97.2-234.8 54.6-54.6 124.9-87.9 200.8-95.5V586h364.3c-7.7 76.3-41.3 147-96.6 201.8zM952 462.4l-2.6-28.2c-8.5-92.1-49.4-179-115.2-244.6A399.4 399.4 0 0 0 589 74.6L560.7 72c-4.7-.4-8.7 3.2-8.7 7.9V464c0 4.4 3.6 8 8 8l384-1c4.7 0 8.4-4 8-8.6zm-332.2-58.2V147.6a332.24 332.24 0 0 1 166.4 89.8c45.7 45.6 77 103.6 90 166.1l-256.4.7z"
                }
            }
        ]
    })(props);
}
function AiOutlinePlayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M719.4 499.1l-296.1-215A15.9 15.9 0 0 0 398 297v430c0 13.1 14.8 20.5 25.3 12.9l296.1-215a15.9 15.9 0 0 0 0-25.8zm-257.6 134V390.9L628.5 512 461.8 633.1z"
                }
            }
        ]
    })(props);
}
function AiOutlinePlaySquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M442.3 677.6l199.4-156.7a11.3 11.3 0 0 0 0-17.7L442.3 346.4c-7.4-5.8-18.3-.6-18.3 8.8v313.5c0 9.4 10.9 14.7 18.3 8.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlinePlusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    })(props);
}
function AiOutlinePlusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlinePlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8Z"
                }
            }
        ]
    })(props);
}
function AiOutlinePoundCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm138-209.8H469.8v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.9-5.3-41H607c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8H495c-7.2-22.6-13.4-45.7-13.4-70.5 0-43.5 34-70.2 87.3-70.2 21.5 0 42.5 4.1 60.4 10.5 5.2 1.9 10.6-2 10.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.8-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.3 6.9 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.1c3.4 14.7 5.9 29.4 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8V722c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlinePound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm138-209.8H469.8v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.9-5.3-41H607c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8H495c-7.2-22.6-13.4-45.7-13.4-70.5 0-43.5 34-70.2 87.3-70.2 21.5 0 42.5 4.1 60.4 10.5 5.2 1.9 10.6-2 10.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.8-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.3 6.9 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.1c3.4 14.7 5.9 29.4 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8V722c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlinePoweroff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M705.6 124.9a8 8 0 0 0-11.6 7.2v64.2c0 5.5 2.9 10.6 7.5 13.6a352.2 352.2 0 0 1 62.2 49.8c32.7 32.8 58.4 70.9 76.3 113.3a355 355 0 0 1 27.9 138.7c0 48.1-9.4 94.8-27.9 138.7a355.92 355.92 0 0 1-76.3 113.3 353.06 353.06 0 0 1-113.2 76.4c-43.8 18.6-90.5 28-138.5 28s-94.7-9.4-138.5-28a353.06 353.06 0 0 1-113.2-76.4A355.92 355.92 0 0 1 184 650.4a355 355 0 0 1-27.9-138.7c0-48.1 9.4-94.8 27.9-138.7 17.9-42.4 43.6-80.5 76.3-113.3 19-19 39.8-35.6 62.2-49.8 4.7-2.9 7.5-8.1 7.5-13.6V132c0-6-6.3-9.8-11.6-7.2C178.5 195.2 82 339.3 80 506.3 77.2 745.1 272.5 943.5 511.2 944c239 .5 432.8-193.3 432.8-432.4 0-169.2-97-315.7-238.4-386.7zM480 560h64c4.4 0 8-3.6 8-8V88c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlinePrinter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M820 436h-40c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-40c0-4.4-3.6-8-8-8zm32-104H732V120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM360 180h304v152H360V180zm304 664H360V568h304v276zm200-140H732V500H292v204H160V412c0-6.6 5.4-12 12-12h680c6.6 0 12 5.4 12 12v292z"
                }
            }
        ]
    })(props);
}
function AiOutlineProfile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM492 400h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zM340 368a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 144a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 144a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineProject(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M280 752h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8zm192-280h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm192 72h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v256c0 4.4 3.6 8 8 8zm216-432H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlinePropertySafety(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zM430.5 318h-46c-1.7 0-3.3.4-4.8 1.2a10.1 10.1 0 0 0-4 13.6l88 161.1h-45.2c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1v29.7h-63.1c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1V658c0 5.5 4.5 10 10 10h41.3c5.5 0 10-4.5 10-10v-51.8h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-63.4v-29.7h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-45.7l87.7-161.1a10.05 10.05 0 0 0-8.8-14.8h-45c-3.8 0-7.2 2.1-8.9 5.5l-73.2 144.3-72.9-144.3c-1.7-3.4-5.2-5.5-9-5.5z"
                }
            }
        ]
    })(props);
}
function AiOutlinePullRequest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M788 705.9V192c0-8.8-7.2-16-16-16H602v-68.8c0-6-7-9.4-11.7-5.7L462.7 202.3a7.14 7.14 0 0 0 0 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V240h114v465.9c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c.1-49.2-31.7-91-75.9-106.1zM752 860a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96zM384 212c0-61.8-50.2-112-112-112s-112 50.2-112 112c0 49.2 31.8 91 76 106.1V706c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1V318.1c44.2-15.1 76-56.9 76-106.1zm-160 0a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm96 600a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0z"
                }
            }
        ]
    })(props);
}
function AiOutlinePushpin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3a33.23 33.23 0 0 0-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 0 0-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8zM666.2 549.3l-24.5 24.5 3.8 34.4a259.92 259.92 0 0 1-30.4 153.9L262 408.8c12.9-7.1 26.3-13.1 40.3-17.9 27.2-9.4 55.7-14.1 84.7-14.1 9.6 0 19.3.5 28.9 1.6l34.4 3.8 24.5-24.5L608.5 224 800 415.5 666.2 549.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineQq(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M824.8 613.2c-16-51.4-34.4-94.6-62.7-165.3C766.5 262.2 689.3 112 511.5 112 331.7 112 256.2 265.2 261 447.9c-28.4 70.8-46.7 113.7-62.7 165.3-34 109.5-23 154.8-14.6 155.8 18 2.2 70.1-82.4 70.1-82.4 0 49 25.2 112.9 79.8 159-26.4 8.1-85.7 29.9-71.6 53.8 11.4 19.3 196.2 12.3 249.5 6.3 53.3 6 238.1 13 249.5-6.3 14.1-23.8-45.3-45.7-71.6-53.8 54.6-46.2 79.8-110.1 79.8-159 0 0 52.1 84.6 70.1 82.4 8.5-1.1 19.5-46.4-14.5-155.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineQrcode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M468 128H160c-17.7 0-32 14.3-32 32v308c0 4.4 3.6 8 8 8h332c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8zm-56 284H192V192h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm194 210H136c-4.4 0-8 3.6-8 8v308c0 17.7 14.3 32 32 32h308c4.4 0 8-3.6 8-8V556c0-4.4-3.6-8-8-8zm-56 284H192V612h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm590-630H556c-4.4 0-8 3.6-8 8v332c0 4.4 3.6 8 8 8h332c4.4 0 8-3.6 8-8V160c0-17.7-14.3-32-32-32zm-32 284H612V192h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm194 210h-48c-4.4 0-8 3.6-8 8v134h-78V556c0-4.4-3.6-8-8-8H556c-4.4 0-8 3.6-8 8v332c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h78v102c0 4.4 3.6 8 8 8h190c4.4 0 8-3.6 8-8V556c0-4.4-3.6-8-8-8zM746 832h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm142 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineQuestionCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0 1 30.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineQuestion(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M764 280.9c-14-30.6-33.9-58.1-59.3-81.6C653.1 151.4 584.6 125 512 125s-141.1 26.4-192.7 74.2c-25.4 23.6-45.3 51-59.3 81.7-14.6 32-22 65.9-22 100.9v27c0 6.2 5 11.2 11.2 11.2h54c6.2 0 11.2-5 11.2-11.2v-27c0-99.5 88.6-180.4 197.6-180.4s197.6 80.9 197.6 180.4c0 40.8-14.5 79.2-42 111.2-27.2 31.7-65.6 54.4-108.1 64-24.3 5.5-46.2 19.2-61.7 38.8a110.85 110.85 0 0 0-23.9 68.6v31.4c0 6.2 5 11.2 11.2 11.2h54c6.2 0 11.2-5 11.2-11.2v-31.4c0-15.7 10.9-29.5 26-32.9 58.4-13.2 111.4-44.7 149.3-88.7 19.1-22.3 34-47.1 44.3-74 10.7-27.9 16.1-57.2 16.1-87 0-35-7.4-69-22-100.9zM512 787c-30.9 0-56 25.1-56 56s25.1 56 56 56 56-25.1 56-56-25.1-56-56-56z"
                }
            }
        ]
    })(props);
}
function AiOutlineRadarChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M926.8 397.1l-396-288a31.81 31.81 0 0 0-37.6 0l-396 288a31.99 31.99 0 0 0-11.6 35.8l151.3 466a32 32 0 0 0 30.4 22.1h489.5c13.9 0 26.1-8.9 30.4-22.1l151.3-466c4.2-13.2-.5-27.6-11.7-35.8zM838.6 417l-98.5 32-200-144.7V199.9L838.6 417zM466 567.2l-89.1 122.3-55.2-169.2L466 567.2zm-116.3-96.8L484 373.3v140.8l-134.3-43.7zM512 599.2l93.9 128.9H418.1L512 599.2zm28.1-225.9l134.2 97.1L540.1 514V373.3zM558 567.2l144.3-46.9-55.2 169.2L558 567.2zm-74-367.3v104.4L283.9 449l-98.5-32L484 199.9zM169.3 470.8l86.5 28.1 80.4 246.4-53.8 73.9-113.1-348.4zM327.1 853l50.3-69h269.3l50.3 69H327.1zm414.5-33.8l-53.8-73.9 80.4-246.4 86.5-28.1-113.1 348.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineRadiusBottomleft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M712 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm2-696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM136 374h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-174h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm752 624h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-230 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm230 624H358c-87.3 0-158-70.7-158-158V484c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v182c0 127 103 230 230 230h182c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineRadiusBottomright(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-58-624h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm578 102h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm292 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm174 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm230 276h-56c-4.4 0-8 3.6-8 8v182c0 87.3-70.7 158-158 158H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h182c127 0 230-103 230-230V484c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineRadiusSetting(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M396 140h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-44 684h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm524-204h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 344h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm320 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm160 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm140-284c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V370c0-127-103-230-230-230H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h170c87.3 0 158 70.7 158 158v170zM236 96H92c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8V104c0-4.4-3.6-8-8-8zm-48 101.6c0 1.3-1.1 2.4-2.4 2.4h-43.2c-1.3 0-2.4-1.1-2.4-2.4v-43.2c0-1.3 1.1-2.4 2.4-2.4h43.2c1.3 0 2.4 1.1 2.4 2.4v43.2zM920 780H776c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8V788c0-4.4-3.6-8-8-8zm-48 101.6c0 1.3-1.1 2.4-2.4 2.4h-43.2c-1.3 0-2.4-1.1-2.4-2.4v-43.2c0-1.3 1.1-2.4 2.4-2.4h43.2c1.3 0 2.4 1.1 2.4 2.4v43.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineRadiusUpleft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M656 200h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm58 624h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 650h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm696-696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-174 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm174-696H358c-127 0-230 103-230 230v182c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V358c0-87.3 70.7-158 158-158h182c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineRadiusUpright(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 128h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-2 696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm522-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 128h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm174 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-48-696H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h182c87.3 0 158 70.7 158 158v182c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V358c0-127-103-230-230-230z"
                }
            }
        ]
    })(props);
}
function AiOutlineRead(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 161H699.2c-49.1 0-97.1 14.1-138.4 40.7L512 233l-48.8-31.3A255.2 255.2 0 0 0 324.8 161H96c-17.7 0-32 14.3-32 32v568c0 17.7 14.3 32 32 32h228.8c49.1 0 97.1 14.1 138.4 40.7l44.4 28.6c1.3.8 2.8 1.3 4.3 1.3s3-.4 4.3-1.3l44.4-28.6C602 807.1 650.1 793 699.2 793H928c17.7 0 32-14.3 32-32V193c0-17.7-14.3-32-32-32zM324.8 721H136V233h188.8c35.4 0 69.8 10.1 99.5 29.2l48.8 31.3 6.9 4.5v462c-47.6-25.6-100.8-39-155.2-39zm563.2 0H699.2c-54.4 0-107.6 13.4-155.2 39V298l6.9-4.5 48.8-31.3c29.7-19.1 64.1-29.2 99.5-29.2H888v488zM396.9 361H211.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5zm223.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c0-4.1-3.2-7.5-7.1-7.5H627.1c-3.9 0-7.1 3.4-7.1 7.5zM396.9 501H211.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5zm416 0H627.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineReconciliation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M676 565c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34zm204-523H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zm-412 64h72v-56h64v56h72v48H468v-48zm-20 616H176V616h272v232zm0-296H176v-88h272v88zm392 240H512V432c0-17.7-14.3-32-32-32H304V240h100v104h336V240h100v552zM704 408v96c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-96c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zM592 512h48c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineRedEnvelope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.6 462.6a8.38 8.38 0 0 0-7.5-4.6h-48.8c-1.3 0-2.6.4-3.9 1a8.4 8.4 0 0 0-3.4 11.4l87.4 161.1H419c-4.6 0-8.4 3.8-8.4 8.4V665c0 4.6 3.8 8.4 8.4 8.4h63V702h-63c-4.6 0-8.4 3.8-8.4 8.4v25.1c0 4.6 3.8 8.4 8.4 8.4h63v49.9c0 4.6 3.8 8.4 8.4 8.4h43.7c4.6 0 8.4-3.8 8.4-8.4v-49.9h63.3c4.7 0 8.4-3.8 8.2-8.5v-25c0-4.6-3.8-8.4-8.4-8.4h-63.3v-28.6h63.3c4.6 0 8.4-3.8 8.4-8.4v-25.1c0-4.6-3.8-8.4-8.4-8.4h-45.9l87.2-161a8.45 8.45 0 0 0-7.4-12.4h-47.8c-3.1 0-6 1.8-7.5 4.6l-71.9 141.9-71.7-142zM832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V193.1l260.3 204.1c11.6 9.1 27.9 9.1 39.5 0L792 193.1V888zm0-751.3h-31.7L512 331.3 263.7 136.7H232v-.7h560v.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineReddit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 568a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm338.7 119.7c-23.1 18.2-68.9 37.8-114.7 37.8s-91.6-19.6-114.7-37.8c-14.4-11.3-35.3-8.9-46.7 5.5s-8.9 35.3 5.5 46.7C396.3 771.6 457.5 792 512 792s115.7-20.4 155.9-52.1a33.25 33.25 0 1 0-41.2-52.2zM960 456c0-61.9-50.1-112-112-112-42.1 0-78.7 23.2-97.9 57.6-57.6-31.5-127.7-51.8-204.1-56.5L612.9 195l127.9 36.9c11.5 32.6 42.6 56.1 79.2 56.1 46.4 0 84-37.6 84-84s-37.6-84-84-84c-32 0-59.8 17.9-74 44.2L603.5 123a33.2 33.2 0 0 0-39.6 18.4l-90.8 203.9c-74.5 5.2-142.9 25.4-199.2 56.2A111.94 111.94 0 0 0 176 344c-61.9 0-112 50.1-112 112 0 45.8 27.5 85.1 66.8 102.5-7.1 21-10.8 43-10.8 65.5 0 154.6 175.5 280 392 280s392-125.4 392-280c0-22.6-3.8-44.5-10.8-65.5C932.5 541.1 960 501.8 960 456zM820 172.5a31.5 31.5 0 1 1 0 63 31.5 31.5 0 0 1 0-63zM120 456c0-30.9 25.1-56 56-56a56 56 0 0 1 50.6 32.1c-29.3 22.2-53.5 47.8-71.5 75.9a56.23 56.23 0 0 1-35.1-52zm392 381.5c-179.8 0-325.5-95.6-325.5-213.5S332.2 410.5 512 410.5 837.5 506.1 837.5 624 691.8 837.5 512 837.5zM868.8 508c-17.9-28.1-42.2-53.7-71.5-75.9 9-18.9 28.3-32.1 50.6-32.1 30.9 0 56 25.1 56 56 .1 23.5-14.5 43.7-35.1 52zM624 568a56 56 0 1 0 112 0 56 56 0 1 0-112 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineRedo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M758.2 839.1C851.8 765.9 912 651.9 912 523.9 912 303 733.5 124.3 512.6 124 291.4 123.7 112 302.8 112 523.9c0 125.2 57.5 236.9 147.6 310.2 3.5 2.8 8.6 2.2 11.4-1.3l39.4-50.5c2.7-3.4 2.1-8.3-1.2-11.1-8.1-6.6-15.9-13.7-23.4-21.2a318.64 318.64 0 0 1-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 0 1-68.6 101.7c-9.3 9.3-19.1 18-29.3 26L668.2 724a8 8 0 0 0-14.1 3l-39.6 162.2c-1.2 5 2.6 9.9 7.7 9.9l167 .8c6.7 0 10.5-7.7 6.3-12.9l-37.3-47.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineReload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M909.1 209.3l-56.4 44.1C775.8 155.1 656.2 92 521.9 92 290 92 102.3 279.5 102 511.5 101.7 743.7 289.8 932 521.9 932c181.3 0 335.8-115 394.6-276.1 1.5-4.2-.7-8.9-4.9-10.3l-56.7-19.5a8 8 0 0 0-10.1 4.8c-1.8 5-3.8 10-5.9 14.9-17.3 41-42.1 77.8-73.7 109.4A344.77 344.77 0 0 1 655.9 829c-42.3 17.9-87.4 27-133.8 27-46.5 0-91.5-9.1-133.8-27A341.5 341.5 0 0 1 279 755.2a342.16 342.16 0 0 1-73.7-109.4c-17.9-42.4-27-87.4-27-133.9s9.1-91.5 27-133.9c17.3-41 42.1-77.8 73.7-109.4 31.6-31.6 68.4-56.4 109.3-73.8 42.3-17.9 87.4-27 133.8-27 46.5 0 91.5 9.1 133.8 27a341.5 341.5 0 0 1 109.3 73.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 0 0 3 14.1l175.6 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c-.1-6.6-7.8-10.3-13-6.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineRest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M508 704c79.5 0 144-64.5 144-144s-64.5-144-144-144-144 64.5-144 144 64.5 144 144 144zm0-224c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0 0 31.9 29.3h429.2a32 32 0 0 0 31.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zm-518.6-76h397.2l22.4 76H291l22.4-76zm376.2 664H326.4L282 324h451.9l-44.3 520z"
                }
            }
        ]
    })(props);
}
function AiOutlineRetweet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M136 552h63.6c4.4 0 8-3.6 8-8V288.7h528.6v72.6c0 1.9.6 3.7 1.8 5.2a8.3 8.3 0 0 0 11.7 1.4L893 255.4c4.3-5 3.6-10.3 0-13.2L749.7 129.8a8.22 8.22 0 0 0-5.2-1.8c-4.6 0-8.4 3.8-8.4 8.4V209H199.7c-39.5 0-71.7 32.2-71.7 71.8V544c0 4.4 3.6 8 8 8zm752-80h-63.6c-4.4 0-8 3.6-8 8v255.3H287.8v-72.6c0-1.9-.6-3.7-1.8-5.2a8.3 8.3 0 0 0-11.7-1.4L131 768.6c-4.3 5-3.6 10.3 0 13.2l143.3 112.4c1.5 1.2 3.3 1.8 5.2 1.8 4.6 0 8.4-3.8 8.4-8.4V815h536.6c39.5 0 71.7-32.2 71.7-71.8V480c-.2-4.4-3.8-8-8.2-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineRightCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M666.7 505.5l-246-178A8 8 0 0 0 408 334v46.9c0 10.2 4.9 19.9 13.2 25.9L566.6 512 421.2 617.2c-8.3 6-13.2 15.6-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.5l246-178c4.4-3.2 4.4-9.8 0-13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    })(props);
}
function AiOutlineRightSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M412.7 696.5l246-178c4.4-3.2 4.4-9.7 0-12.9l-246-178c-5.3-3.8-12.7 0-12.7 6.5V381c0 10.2 4.9 19.9 13.2 25.9L558.6 512 413.2 617.2c-8.3 6-13.2 15.6-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlineRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 0 0 302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 0 0 0-50.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineRise(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M917 211.1l-199.2 24c-6.6.8-9.4 8.9-4.7 13.6l59.3 59.3-226 226-101.8-101.7c-6.3-6.3-16.4-6.2-22.6 0L100.3 754.1a8.03 8.03 0 0 0 0 11.3l45 45.2c3.1 3.1 8.2 3.1 11.3 0L433.3 534 535 635.7c6.3 6.2 16.4 6.2 22.6 0L829 364.5l59.3 59.3a8.01 8.01 0 0 0 13.6-4.7l24-199.2c.7-5.1-3.7-9.5-8.9-8.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineRobot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M300 328a60 60 0 1 0 120 0 60 60 0 1 0-120 0zM852 64H172c-17.7 0-32 14.3-32 32v660c0 17.7 14.3 32 32 32h680c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-32 660H204V128h616v596zM604 328a60 60 0 1 0 120 0 60 60 0 1 0-120 0zm250.2 556H169.8c-16.5 0-29.8 14.3-29.8 32v36c0 4.4 3.3 8 7.4 8h729.1c4.1 0 7.4-3.6 7.4-8v-36c.1-17.7-13.2-32-29.7-32zM664 508H360c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineRocket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 0 0-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0 0 43.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0 0 43.1-30.5 97.52 97.52 0 0 0 21.4-60.8c0-8.4-1.1-16.4-3.1-23.8H864zM762.3 621.4c9.4 14.6 17 30.3 22.5 46.6H700V558.7a211.6 211.6 0 0 1 62.3 62.7zM388 483.1V318.8l124-147 124 147V668H388V483.1zM239.2 668c5.5-16.3 13.1-32 22.5-46.6 16.3-25.2 37.5-46.5 62.3-62.7V668h-84.8zm388.9 116.2c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5-38.3 0-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 0 1-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5zM464 400a48 48 0 1 0 96 0 48 48 0 1 0-96 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineRollback(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M793 242H366v-74c0-6.7-7.7-10.4-12.9-6.3l-142 112a8 8 0 0 0 0 12.6l142 112c5.2 4.1 12.9.4 12.9-6.3v-74h415v470H175c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h618c35.3 0 64-28.7 64-64V306c0-35.3-28.7-64-64-64z"
                }
            }
        ]
    })(props);
}
function AiOutlineRotateLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683455503",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M672 418H144c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32z m-44 402H188V494h440v326z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M819.3 328.5c-78.8-100.7-196-153.6-314.6-154.2l-0.2-64c0-6.5-7.6-10.1-12.6-6.1l-128 101c-4 3.1-3.9 9.1 0 12.3L492 318.6c5.1 4 12.7 0.4 12.6-6.1v-63.9c12.9 0.1 25.9 0.9 38.8 2.5 42.1 5.2 82.1 18.2 119 38.7 38.1 21.2 71.2 49.7 98.4 84.3 27.1 34.7 46.7 73.7 58.1 115.8 11 40.7 14 82.7 8.9 124.8-0.7 5.4-1.4 10.8-2.4 16.1h74.9c14.8-103.6-11.3-213-81-302.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineRotateRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683458761",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M480.5 251.2c13-1.6 25.9-2.4 38.8-2.5v63.9c0 6.5 7.5 10.1 12.6 6.1L660 217.6c4-3.2 4-9.2 0-12.3l-128-101c-5.1-4-12.6-0.4-12.6 6.1l-0.2 64c-118.6 0.5-235.8 53.4-314.6 154.2-69.6 89.2-95.7 198.6-81.1 302.4h74.9c-0.9-5.3-1.7-10.7-2.4-16.1-5.1-42.1-2.1-84.1 8.9-124.8 11.4-42.2 31-81.1 58.1-115.8 27.2-34.7 60.3-63.2 98.4-84.3 37-20.6 76.9-33.6 119.1-38.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 418H352c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32z m-44 402H396V494h440v326z"
                }
            }
        ]
    })(props);
}
function AiOutlineSafetyCertificate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zm-405.8-201c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.3 0-12.7-6.5-12.7h-55.2c-5.1 0-10 2.5-13 6.6L468.9 542.4l-64.7-89.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineSafety(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64L128 192v384c0 212.1 171.9 384 384 384s384-171.9 384-384V192L512 64zm312 512c0 172.3-139.7 312-312 312S200 748.3 200 576V246l312-110 312 110v330z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M378.4 475.1a35.91 35.91 0 0 0-50.9 0 35.91 35.91 0 0 0 0 50.9l129.4 129.4 2.1 2.1a33.98 33.98 0 0 0 48.1 0L730.6 434a33.98 33.98 0 0 0 0-48.1l-2.8-2.8a33.98 33.98 0 0 0-48.1 0L483 579.7 378.4 475.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineSave(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M893.3 293.3L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840zM512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z"
                }
            }
        ]
    })(props);
}
function AiOutlineScan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M136 384h56c4.4 0 8-3.6 8-8V200h176c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-37.6 0-68 30.4-68 68v180c0 4.4 3.6 8 8 8zm512-184h176v176c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V196c0-37.6-30.4-68-68-68H648c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM376 824H200V648c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v180c0 37.6 30.4 68 68 68h180c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm512-184h-56c-4.4 0-8 3.6-8 8v176H648c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h180c37.6 0 68-30.4 68-68V648c0-4.4-3.6-8-8-8zm16-164H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineSchedule(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496zM416 496H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 136H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm308.2-177.4L620.6 598.3l-52.8-73.1c-3-4.2-7.8-6.6-12.9-6.6H500c-6.5 0-10.3 7.4-6.5 12.7l114.1 158.2a15.9 15.9 0 0 0 25.8 0l165-228.7c3.8-5.3 0-12.7-6.5-12.7H737c-5-.1-9.8 2.4-12.8 6.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineScissor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M567.1 512l318.5-319.3c5-5 1.5-13.7-5.6-13.7h-90.5c-2.1 0-4.2.8-5.6 2.3l-273.3 274-90.2-90.5c12.5-22.1 19.7-47.6 19.7-74.8 0-83.9-68.1-152-152-152s-152 68.1-152 152 68.1 152 152 152c27.7 0 53.6-7.4 75.9-20.3l90 90.3-90.1 90.3A151.04 151.04 0 0 0 288 582c-83.9 0-152 68.1-152 152s68.1 152 152 152 152-68.1 152-152c0-27.2-7.2-52.7-19.7-74.8l90.2-90.5 273.3 274c1.5 1.5 3.5 2.3 5.6 2.3H880c7.1 0 10.7-8.6 5.6-13.7L567.1 512zM288 370c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm0 444c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                }
            }
        ]
    })(props);
}
function AiOutlineSearch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0 0 11.6 0l43.6-43.5a8.2 8.2 0 0 0 0-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineSecurityScan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zM402.9 528.8l-77.5 77.5a8.03 8.03 0 0 0 0 11.3l34 34c3.1 3.1 8.2 3.1 11.3 0l77.5-77.5c55.7 35.1 130.1 28.4 178.6-20.1 56.3-56.3 56.3-147.5 0-203.8-56.3-56.3-147.5-56.3-203.8 0-48.5 48.5-55.2 123-20.1 178.6zm65.4-133.3c31.3-31.3 82-31.3 113.2 0 31.3 31.3 31.3 82 0 113.2-31.3 31.3-82 31.3-113.2 0s-31.3-81.9 0-113.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineSelect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h360c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H184V184h656v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32zM653.3 599.4l52.2-52.2a8.01 8.01 0 0 0-4.7-13.6l-179.4-21c-5.1-.6-9.5 3.7-8.9 8.9l21 179.4c.8 6.6 8.9 9.4 13.6 4.7l52.4-52.4 256.2 256.2c3.1 3.1 8.2 3.1 11.3 0l42.4-42.4c3.1-3.1 3.1-8.2 0-11.3L653.3 599.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineSend(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683742680",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M931.4 498.9L94.9 79.5c-3.4-1.7-7.3-2.1-11-1.2-8.5 2.1-13.8 10.7-11.7 19.3l86.2 352.2c1.3 5.3 5.2 9.6 10.4 11.3l147.7 50.7-147.6 50.7c-5.2 1.8-9.1 6-10.3 11.3L72.2 926.5c-0.9 3.7-0.5 7.6 1.2 10.9 3.9 7.9 13.5 11.1 21.5 7.2l836.5-417c3.1-1.5 5.6-4.1 7.2-7.1 3.9-8 0.7-17.6-7.2-21.6zM170.8 826.3l50.3-205.6 295.2-101.3c2.3-0.8 4.2-2.6 5-5 1.4-4.2-0.8-8.7-5-10.2L221.1 403 171 198.2l628 314.9-628.2 313.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineSetting(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M924.8 625.7l-65.5-56c3.1-19 4.7-38.4 4.7-57.8s-1.6-38.8-4.7-57.8l65.5-56a32.03 32.03 0 0 0 9.3-35.2l-.9-2.6a443.74 443.74 0 0 0-79.7-137.9l-1.8-2.1a32.12 32.12 0 0 0-35.1-9.5l-81.3 28.9c-30-24.6-63.5-44-99.7-57.6l-15.7-85a32.05 32.05 0 0 0-25.8-25.7l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 0 0-25.8 25.7l-15.8 85.4a351.86 351.86 0 0 0-99 57.4l-81.9-29.1a32 32 0 0 0-35.1 9.5l-1.8 2.1a446.02 446.02 0 0 0-79.7 137.9l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.3 56.6c-3.1 18.8-4.6 38-4.6 57.1 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 0 0-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1a32.12 32.12 0 0 0 35.1 9.5l81.9-29.1c29.8 24.5 63.1 43.9 99 57.4l15.8 85.4a32.05 32.05 0 0 0 25.8 25.7l2.7.5a449.4 449.4 0 0 0 159 0l2.7-.5a32.05 32.05 0 0 0 25.8-25.7l15.7-85a350 350 0 0 0 99.7-57.6l81.3 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c4.5-12.3.8-26.3-9.3-35zM788.3 465.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 0 1-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97a377.5 377.5 0 0 1-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9zM512 326c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 0 1 512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 502c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 0 1 624 502c0 29.9-11.7 58-32.8 79.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineShake(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M324 666a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm616.7-309.6L667.6 83.2C655.2 70.9 638.7 64 621.1 64s-34.1 6.8-46.5 19.2L83.3 574.5a65.85 65.85 0 0 0 0 93.1l273.2 273.2c12.3 12.3 28.9 19.2 46.5 19.2s34.1-6.8 46.5-19.2l491.3-491.3c25.6-25.7 25.6-67.5-.1-93.1zM403 880.1L143.9 621l477.2-477.2 259 259.2L403 880.1zM152.8 373.7a7.9 7.9 0 0 0 11.2 0L373.7 164a7.9 7.9 0 0 0 0-11.2l-38.4-38.4a7.9 7.9 0 0 0-11.2 0L114.3 323.9a7.9 7.9 0 0 0 0 11.2l38.5 38.6zm718.6 276.6a7.9 7.9 0 0 0-11.2 0L650.3 860.1a7.9 7.9 0 0 0 0 11.2l38.4 38.4a7.9 7.9 0 0 0 11.2 0L909.7 700a7.9 7.9 0 0 0 0-11.2l-38.3-38.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineShareAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M752 664c-28.5 0-54.8 10-75.4 26.7L469.4 540.8a160.68 160.68 0 0 0 0-57.6l207.2-149.9C697.2 350 723.5 360 752 360c66.2 0 120-53.8 120-120s-53.8-120-120-120-120 53.8-120 120c0 11.6 1.6 22.7 4.7 33.3L439.9 415.8C410.7 377.1 364.3 352 312 352c-88.4 0-160 71.6-160 160s71.6 160 160 160c52.3 0 98.7-25.1 127.9-63.8l196.8 142.5c-3.1 10.6-4.7 21.8-4.7 33.3 0 66.2 53.8 120 120 120s120-53.8 120-120-53.8-120-120-120zm0-476c28.7 0 52 23.3 52 52s-23.3 52-52 52-52-23.3-52-52 23.3-52 52-52zM312 600c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88zm440 236c-28.7 0-52-23.3-52-52s23.3-52 52-52 52 23.3 52 52-23.3 52-52 52z"
                }
            }
        ]
    })(props);
}
function AiOutlineShop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0 0 14.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h676c17.7 0 32-14.3 32-32V535a175 175 0 0 0 15.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zM214 184h596v88H214v-88zm362 656.1H448V736h128v104.1zm234 0H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 3-1.3 6-2.6 9-4v242.2zm30-404.4c0 59.8-49 108.3-109.3 108.3-40.8 0-76.4-22.1-95.2-54.9-2.9-5-8.1-8.1-13.9-8.1h-.6c-5.7 0-11 3.1-13.9 8.1A109.24 109.24 0 0 1 512 544c-40.7 0-76.2-22-95-54.7-3-5.1-8.4-8.3-14.3-8.3s-11.4 3.2-14.3 8.3a109.63 109.63 0 0 1-95.1 54.7C233 544 184 495.5 184 435.7v-91.2c0-.3.2-.5.5-.5h655c.3 0 .5.2.5.5v91.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineShoppingCart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M922.9 701.9H327.4l29.9-60.9 496.8-.9c16.8 0 31.2-12 34.2-28.6l68.8-385.1c1.8-10.1-.9-20.5-7.5-28.4a34.99 34.99 0 0 0-26.6-12.5l-632-2.1-5.4-25.4c-3.4-16.2-18-28-34.6-28H96.5a35.3 35.3 0 1 0 0 70.6h125.9L246 312.8l58.1 281.3-74.8 122.1a34.96 34.96 0 0 0-3 36.8c6 11.9 18.1 19.4 31.5 19.4h62.8a102.43 102.43 0 0 0-20.6 61.7c0 56.6 46 102.6 102.6 102.6s102.6-46 102.6-102.6c0-22.3-7.4-44-20.6-61.7h161.1a102.43 102.43 0 0 0-20.6 61.7c0 56.6 46 102.6 102.6 102.6s102.6-46 102.6-102.6c0-22.3-7.4-44-20.6-61.7H923c19.4 0 35.3-15.8 35.3-35.3a35.42 35.42 0 0 0-35.4-35.2zM305.7 253l575.8 1.9-56.4 315.8-452.3.8L305.7 253zm96.9 612.7c-17.4 0-31.6-14.2-31.6-31.6 0-17.4 14.2-31.6 31.6-31.6s31.6 14.2 31.6 31.6a31.6 31.6 0 0 1-31.6 31.6zm325.1 0c-17.4 0-31.6-14.2-31.6-31.6 0-17.4 14.2-31.6 31.6-31.6s31.6 14.2 31.6 31.6a31.6 31.6 0 0 1-31.6 31.6z"
                }
            }
        ]
    })(props);
}
function AiOutlineShopping(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-432-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16H400v-16zm392 544H232V384h96v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h224v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h96v456z"
                }
            }
        ]
    })(props);
}
function AiOutlineShrink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M881.7 187.4l-45.1-45.1a8.03 8.03 0 0 0-11.3 0L667.8 299.9l-54.7-54.7a7.94 7.94 0 0 0-13.5 4.7L576.1 439c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 157.6-157.6c3-3 3-8.1-.1-11.2zM439 576.1l-189.2 23.5c-6.6.8-9.3 8.9-4.7 13.5l54.7 54.7-157.5 157.5a8.03 8.03 0 0 0 0 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l157.6-157.6 54.7 54.7a7.94 7.94 0 0 0 13.5-4.7L447.9 585a7.9 7.9 0 0 0-8.9-8.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineSisternode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683586275",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M672 432c-120.3 0-219.9 88.5-237.3 204H320c-15.5 0-28-12.5-28-28V244h291c14.2 35.2 48.7 60 89 60 53 0 96-43 96-96s-43-96-96-96c-40.3 0-74.8 24.8-89 60H112v72h108v364c0 55.2 44.8 100 100 100h114.7c17.4 115.5 117 204 237.3 204 132.5 0 240-107.5 240-240S804.5 432 672 432z m128 266c0 4.4-3.6 8-8 8h-86v86c0 4.4-3.6 8-8 8h-52c-4.4 0-8-3.6-8-8v-86h-86c-4.4 0-8-3.6-8-8v-52c0-4.4 3.6-8 8-8h86v-86c0-4.4 3.6-8 8-8h52c4.4 0 8 3.6 8 8v86h86c4.4 0 8 3.6 8 8v52z"
                }
            }
        ]
    })(props);
}
function AiOutlineSketch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M925.6 405.1l-203-253.7a6.5 6.5 0 0 0-5-2.4H306.4c-1.9 0-3.8.9-5 2.4l-203 253.7a6.5 6.5 0 0 0 .2 8.3l408.6 459.5c1.2 1.4 3 2.1 4.8 2.1 1.8 0 3.5-.8 4.8-2.1l408.6-459.5a6.5 6.5 0 0 0 .2-8.3zM645.2 206.4l34.4 133.9-132.5-133.9h98.1zm8.2 178.5H370.6L512 242l141.4 142.9zM378.8 206.4h98.1L344.3 340.3l34.5-133.9zm-53.4 7l-44.1 171.5h-93.1l137.2-171.5zM194.6 434.9H289l125.8 247.7-220.2-247.7zM512 763.4L345.1 434.9h333.7L512 763.4zm97.1-80.8L735 434.9h94.4L609.1 682.6zm133.6-297.7l-44.1-171.5 137.2 171.5h-93.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineSkin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 0 0-37-29.3H154a44 44 0 0 0-44 44v252a44 44 0 0 0 44 44h75v388a44 44 0 0 0 44 44h478a44 44 0 0 0 44-44V466h75a44 44 0 0 0 44-44V170a44 44 0 0 0-44-44zm-28 268H723v432H301V394H182V198h153.3c28.2 71.2 97.5 120 176.7 120s148.5-48.8 176.7-120H842v196z"
                }
            }
        ]
    })(props);
}
function AiOutlineSkype(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M883.7 578.6c4.1-22.5 6.3-45.5 6.3-68.5 0-51-10-100.5-29.7-147-19-45-46.3-85.4-81-120.1a375.79 375.79 0 0 0-120.1-80.9c-46.6-19.7-96-29.7-147-29.7-24 0-48.1 2.3-71.5 6.8A225.1 225.1 0 0 0 335.6 113c-59.7 0-115.9 23.3-158.1 65.5A222.25 222.25 0 0 0 112 336.6c0 38 9.8 75.4 28.1 108.4-3.7 21.4-5.7 43.3-5.7 65.1 0 51 10 100.5 29.7 147 19 45 46.2 85.4 80.9 120.1 34.7 34.7 75.1 61.9 120.1 80.9 46.6 19.7 96 29.7 147 29.7 22.2 0 44.4-2 66.2-5.9 33.5 18.9 71.3 29 110 29 59.7 0 115.9-23.2 158.1-65.5 42.3-42.2 65.5-98.4 65.5-158.1.1-38-9.7-75.5-28.2-108.7zm-88.1 216C766.9 823.4 729 839 688.4 839c-26.1 0-51.8-6.8-74.6-19.7l-22.5-12.7-25.5 4.5c-17.8 3.2-35.8 4.8-53.6 4.8-41.4 0-81.3-8.1-119.1-24.1-36.3-15.3-69-37.3-97.2-65.5a304.29 304.29 0 0 1-65.5-97.1c-16-37.7-24-77.6-24-119 0-17.4 1.6-35.2 4.6-52.8l4.4-25.1L203 410a151.02 151.02 0 0 1-19.1-73.4c0-40.6 15.7-78.5 44.4-107.2C257.1 200.7 295 185 335.6 185a153 153 0 0 1 71.4 17.9l22.4 11.8 24.8-4.8c18.9-3.6 38.4-5.5 58-5.5 41.4 0 81.3 8.1 119 24 36.5 15.4 69.1 37.4 97.2 65.5 28.2 28.1 50.2 60.8 65.6 97.2 16 37.7 24 77.6 24 119 0 18.4-1.7 37-5.1 55.5l-4.7 25.5 12.6 22.6c12.6 22.5 19.2 48 19.2 73.7 0 40.7-15.7 78.5-44.4 107.2zM583.4 466.2L495 446.6c-33.6-7.7-72.3-17.8-72.3-49.5s27.1-53.9 76.1-53.9c98.7 0 89.7 67.8 138.7 67.8 25.8 0 48.4-15.2 48.4-41.2 0-60.8-97.4-106.5-180-106.5-89.7 0-185.2 38.1-185.2 139.5 0 48.8 17.4 100.8 113.6 124.9l119.4 29.8c36.1 8.9 45.2 29.2 45.2 47.6 0 30.5-30.3 60.3-85.2 60.3-107.2 0-92.3-82.5-149.7-82.5-25.8 0-44.5 17.8-44.5 43.1 0 49.4 60 115.4 194.2 115.4 127.7 0 191-61.5 191-144 0-53.1-24.5-109.6-121.3-131.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineSlackSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM529 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4-13.3 0-26.1-5.3-35.6-14.8-9.4-9.5-14.7-22.3-14.7-35.6 0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4 13.3 0 26.1 5.3 35.6 14.8s14.7 22.3 14.7 35.6v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm134 403.2c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134c-13.3 0-26.1-5.3-35.6-14.8-9.4-9.5-14.7-22.3-14.7-35.6 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineSlack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M409.4 128c-42.4 0-76.7 34.4-76.7 76.8 0 20.3 8.1 39.9 22.4 54.3 14.4 14.4 33.9 22.5 54.3 22.5h76.7v-76.8c0-42.3-34.3-76.7-76.7-76.8zm0 204.8H204.7c-42.4 0-76.7 34.4-76.7 76.8s34.4 76.8 76.7 76.8h204.6c42.4 0 76.7-34.4 76.7-76.8.1-42.4-34.3-76.8-76.6-76.8zM614 486.4c42.4 0 76.8-34.4 76.7-76.8V204.8c0-42.4-34.3-76.8-76.7-76.8-42.4 0-76.7 34.4-76.7 76.8v204.8c0 42.5 34.3 76.8 76.7 76.8zm281.4-76.8c0-42.4-34.4-76.8-76.7-76.8S742 367.2 742 409.6v76.8h76.7c42.3 0 76.7-34.4 76.7-76.8zm-76.8 128H614c-42.4 0-76.7 34.4-76.7 76.8 0 20.3 8.1 39.9 22.4 54.3 14.4 14.4 33.9 22.5 54.3 22.5h204.6c42.4 0 76.7-34.4 76.7-76.8.1-42.4-34.3-76.7-76.7-76.8zM614 742.4h-76.7v76.8c0 42.4 34.4 76.8 76.7 76.8 42.4 0 76.8-34.4 76.7-76.8.1-42.4-34.3-76.7-76.7-76.8zM409.4 537.6c-42.4 0-76.7 34.4-76.7 76.8v204.8c0 42.4 34.4 76.8 76.7 76.8 42.4 0 76.8-34.4 76.7-76.8V614.4c0-20.3-8.1-39.9-22.4-54.3-14.4-14.4-34-22.5-54.3-22.5zM128 614.4c0 20.3 8.1 39.9 22.4 54.3 14.4 14.4 33.9 22.5 54.3 22.5 42.4 0 76.8-34.4 76.7-76.8v-76.8h-76.7c-42.3 0-76.7 34.4-76.7 76.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineSliders(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 224h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-60 508h-80V292h80v440zm644-436h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-60 364h-80V364h80v296zM612 404h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8zm-60 145a3 3 0 0 1-3 3h-74a3 3 0 0 1-3-3v-74a3 3 0 0 1 3-3h74a3 3 0 0 1 3 3v74z"
                }
            }
        ]
    })(props);
}
function AiOutlineSmallDash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 476h72v72h-72zm182 0h72v72h-72zm364 0h72v72h-72zm182 0h72v72h-72zm-364 0h72v72h-72z"
                }
            }
        ]
    })(props);
}
function AiOutlineSmile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm352 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 0 1 248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 0 1 249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 0 1 775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 0 1 775 775zM664 533h-48.1c-4.2 0-7.8 3.2-8.1 7.4C604 589.9 562.5 629 512 629s-92.1-39.1-95.8-88.6c-.3-4.2-3.9-7.4-8.1-7.4H360a8 8 0 0 0-8 8.4c4.4 84.3 74.5 151.6 160 151.6s155.6-67.3 160-151.6a8 8 0 0 0-8-8.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineSnippets(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 888H232V336h218v174c0 22.1 17.9 40 40 40h174v338zm0-402H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z"
                }
            }
        ]
    })(props);
}
function AiOutlineSolution(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M688 264c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48zm-8 136H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM480 544H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48 308H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm356.8-74.4c29-26.3 47.2-64.3 47.2-106.6 0-79.5-64.5-144-144-144s-144 64.5-144 144c0 42.3 18.2 80.3 47.2 106.6-57 32.5-96.2 92.7-99.2 162.1-.2 4.5 3.5 8.3 8 8.3h48.1c4.2 0 7.7-3.3 8-7.6C564 871.2 621.7 816 692 816s128 55.2 131.9 124.4c.2 4.2 3.7 7.6 8 7.6H880c4.6 0 8.2-3.8 8-8.3-2.9-69.5-42.2-129.6-99.2-162.1zM692 591c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z"
                }
            }
        ]
    })(props);
}
function AiOutlineSortAscending(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M839.6 433.8L749 150.5a9.24 9.24 0 0 0-8.9-6.5h-77.4c-4.1 0-7.6 2.6-8.9 6.5l-91.3 283.3c-.3.9-.5 1.9-.5 2.9 0 5.1 4.2 9.3 9.3 9.3h56.4c4.2 0 7.8-2.8 9-6.8l17.5-61.6h89l17.3 61.5c1.1 4 4.8 6.8 9 6.8h61.2c1 0 1.9-.1 2.8-.4 2.4-.8 4.3-2.4 5.5-4.6 1.1-2.2 1.3-4.7.6-7.1zM663.3 325.5l32.8-116.9h6.3l32.1 116.9h-71.2zm143.5 492.9H677.2v-.4l132.6-188.9c1.1-1.6 1.7-3.4 1.7-5.4v-36.4c0-5.1-4.2-9.3-9.3-9.3h-204c-5.1 0-9.3 4.2-9.3 9.3v43c0 5.1 4.2 9.3 9.3 9.3h122.6v.4L587.7 828.9a9.35 9.35 0 0 0-1.7 5.4v36.4c0 5.1 4.2 9.3 9.3 9.3h211.4c5.1 0 9.3-4.2 9.3-9.3v-43a9.2 9.2 0 0 0-9.2-9.3zM416 702h-76V172c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v530h-76c-6.7 0-10.5 7.8-6.3 13l112 141.9a8 8 0 0 0 12.6 0l112-141.9c4.1-5.2.4-13-6.3-13z"
                }
            }
        ]
    })(props);
}
function AiOutlineSortDescending(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M839.6 433.8L749 150.5a9.24 9.24 0 0 0-8.9-6.5h-77.4c-4.1 0-7.6 2.6-8.9 6.5l-91.3 283.3c-.3.9-.5 1.9-.5 2.9 0 5.1 4.2 9.3 9.3 9.3h56.4c4.2 0 7.8-2.8 9-6.8l17.5-61.6h89l17.3 61.5c1.1 4 4.8 6.8 9 6.8h61.2c1 0 1.9-.1 2.8-.4 2.4-.8 4.3-2.4 5.5-4.6 1.1-2.2 1.3-4.7.6-7.1zM663.3 325.5l32.8-116.9h6.3l32.1 116.9h-71.2zm143.5 492.9H677.2v-.4l132.6-188.9c1.1-1.6 1.7-3.4 1.7-5.4v-36.4c0-5.1-4.2-9.3-9.3-9.3h-204c-5.1 0-9.3 4.2-9.3 9.3v43c0 5.1 4.2 9.3 9.3 9.3h122.6v.4L587.7 828.9a9.35 9.35 0 0 0-1.7 5.4v36.4c0 5.1 4.2 9.3 9.3 9.3h211.4c5.1 0 9.3-4.2 9.3-9.3v-43a9.2 9.2 0 0 0-9.2-9.3zM310.3 167.1a8 8 0 0 0-12.6 0L185.7 309c-4.2 5.3-.4 13 6.3 13h76v530c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V322h76c6.7 0 10.5-7.8 6.3-13l-112-141.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineSound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1zM586 803L293.4 611.7l-18-11.7H146V424h129.4l17.9-11.7L586 221v582zm348-327H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zm-41.9 261.8l-110.3-63.7a15.9 15.9 0 0 0-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0 0 21.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM760 344a15.9 15.9 0 0 0 21.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 0 0-21.7-5.9L746 287.8a15.99 15.99 0 0 0-5.8 21.8L760 344z"
                }
            }
        ]
    })(props);
}
function AiOutlineSplitCells(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683545621",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M938.2 508.4L787.3 389c-3-2.4-7.3-0.2-7.3 3.6V478H636V184h204v128c0 2.2 1.8 4 4 4h60c2.2 0 4-1.8 4-4V144c0-15.5-12.5-28-28-28H596c-15.5 0-28 12.5-28 28v736c0 15.5 12.5 28 28 28h284c15.5 0 28-12.5 28-28V712c0-2.2-1.8-4-4-4h-60c-2.2 0-4 1.8-4 4v128H636V546h144v85.4c0 3.8 4.4 6 7.3 3.6l150.9-119.4c2.4-1.8 2.4-5.4 0-7.2zM428 116H144c-15.5 0-28 12.5-28 28v168c0 2.2 1.8 4 4 4h60c2.2 0 4-1.8 4-4V184h204v294H244v-85.4c0-3.8-4.3-6-7.3-3.6l-151 119.4c-2.3 1.8-2.3 5.3 0 7.1l151 119.5c2.9 2.3 7.3 0.2 7.3-3.6V546h144v294H184V712c0-2.2-1.8-4-4-4h-60c-2.2 0-4 1.8-4 4v168c0 15.5 12.5 28 28 28h284c15.5 0 28-12.5 28-28V144c0-15.5-12.5-28-28-28z"
                }
            }
        ]
    })(props);
}
function AiOutlineStar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM664.8 561.6l36.1 210.3L512 672.7 323.1 772l36.1-210.3-152.8-149L417.6 382 512 190.7 606.4 382l211.2 30.7-152.8 148.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineStepBackward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M347.6 528.95l383.2 301.02c14.25 11.2 35.2 1.1 35.2-16.95V210.97c0-18.05-20.95-28.14-35.2-16.94L347.6 495.05a21.53 21.53 0 0 0 0 33.9M330 864h-64a8 8 0 0 1-8-8V168a8 8 0 0 1 8-8h64a8 8 0 0 1 8 8v688a8 8 0 0 1-8 8"
                }
            }
        ]
    })(props);
}
function AiOutlineStepForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M676.4 528.95L293.2 829.97c-14.25 11.2-35.2 1.1-35.2-16.95V210.97c0-18.05 20.95-28.14 35.2-16.94l383.2 301.02a21.53 21.53 0 0 1 0 33.9M694 864h64a8 8 0 0 0 8-8V168a8 8 0 0 0-8-8h-64a8 8 0 0 0-8 8v688a8 8 0 0 0 8 8"
                }
            }
        ]
    })(props);
}
function AiOutlineStock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M904 747H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM165.7 621.8l39.7 39.5c3.1 3.1 8.2 3.1 11.3 0l234.7-233.9 97.6 97.3a32.11 32.11 0 0 0 45.2 0l264.2-263.2c3.1-3.1 3.1-8.2 0-11.3l-39.7-39.6a8.03 8.03 0 0 0-11.3 0l-235.7 235-97.7-97.3a32.11 32.11 0 0 0-45.2 0L165.7 610.5a7.94 7.94 0 0 0 0 11.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineStop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372 0-89 31.3-170.8 83.5-234.8l523.3 523.3C682.8 852.7 601 884 512 884zm288.5-137.2L277.2 223.5C341.2 171.3 423 140 512 140c205.4 0 372 166.6 372 372 0 89-31.3 170.8-83.5 234.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineStrikethrough(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M952 474H569.9c-10-2-20.5-4-31.6-6-15.9-2.9-22.2-4.1-30.8-5.8-51.3-10-82.2-20-106.8-34.2-35.1-20.5-52.2-48.3-52.2-85.1 0-37 15.2-67.7 44-89 28.4-21 68.8-32.1 116.8-32.1 54.8 0 97.1 14.4 125.8 42.8 14.6 14.4 25.3 32.1 31.8 52.6 1.3 4.1 2.8 10 4.3 17.8.9 4.8 5.2 8.2 9.9 8.2h72.8c5.6 0 10.1-4.6 10.1-10.1v-1c-.7-6.8-1.3-12.1-2-16-7.3-43.5-28-81.7-59.7-110.3-44.4-40.5-109.7-61.8-188.7-61.8-72.3 0-137.4 18.1-183.3 50.9-25.6 18.4-45.4 41.2-58.6 67.7-13.5 27.1-20.3 58.4-20.3 92.9 0 29.5 5.7 54.5 17.3 76.5 8.3 15.7 19.6 29.5 34.1 42H72c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h433.2c2.1.4 3.9.8 5.9 1.2 30.9 6.2 49.5 10.4 66.6 15.2 23 6.5 40.6 13.3 55.2 21.5 35.8 20.2 53.3 49.2 53.3 89 0 35.3-15.5 66.8-43.6 88.8-30.5 23.9-75.6 36.4-130.5 36.4-43.7 0-80.7-8.5-110.2-25-29.1-16.3-49.1-39.8-59.7-69.5-.8-2.2-1.7-5.2-2.7-9-1.2-4.4-5.3-7.5-9.7-7.5h-79.7c-5.6 0-10.1 4.6-10.1 10.1v1c.2 2.3.4 4.2.6 5.7 6.5 48.8 30.3 88.8 70.7 118.8 47.1 34.8 113.4 53.2 191.8 53.2 84.2 0 154.8-19.8 204.2-57.3 25-18.9 44.2-42.2 57.1-69 13-27.1 19.7-57.9 19.7-91.5 0-31.8-5.8-58.4-17.8-81.4-5.8-11.2-13.1-21.5-21.8-30.8H952c4.4 0 8-3.6 8-8v-60a8 8 0 0 0-8-7.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineSubnode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683432252",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M688 240c-138 0-252 102.8-269.6 236H249c-14.2-35.2-48.7-60-89-60-53 0-96 43-96 96s43 96 96 96c40.3 0 74.8-24.8 89-60h169.3C436 681.2 550 784 688 784c150.2 0 272-121.8 272-272S838.2 240 688 240z m128 298c0 4.4-3.6 8-8 8h-86v86c0 4.4-3.6 8-8 8h-52c-4.4 0-8-3.6-8-8v-86h-86c-4.4 0-8-3.6-8-8v-52c0-4.4 3.6-8 8-8h86v-86c0-4.4 3.6-8 8-8h52c4.4 0 8 3.6 8 8v86h86c4.4 0 8 3.6 8 8v52z"
                }
            }
        ]
    })(props);
}
function AiOutlineSwapLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M872 572H266.8l144.3-183c4.1-5.2.4-13-6.3-13H340c-9.8 0-19.1 4.5-25.1 12.2l-164 208c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineSwapRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M873.1 596.2l-164-208A32 32 0 0 0 684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineSwap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M847.9 592H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h605.2L612.9 851c-4.1 5.2-.4 13 6.3 13h72.5c4.9 0 9.5-2.2 12.6-6.1l168.8-214.1c16.5-21 1.6-51.8-25.2-51.8zM872 356H266.8l144.3-183c4.1-5.2.4-13-6.3-13h-72.5c-4.9 0-9.5 2.2-12.6 6.1L150.9 380.2c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineSwitcher(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zm-40 600H184V312h528v528zm168-728H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32zM300 550h296v64H300z"
                }
            }
        ]
    })(props);
}
function AiOutlineSync(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168 504.2c1-43.7 10-86.1 26.9-126 17.3-41 42.1-77.7 73.7-109.4S337 212.3 378 195c42.4-17.9 87.4-27 133.9-27s91.5 9.1 133.8 27A341.5 341.5 0 0 1 755 268.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 0 0 3 14.1l175.7 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c0-6.7-7.7-10.5-12.9-6.3l-56.4 44.1C765.8 155.1 646.2 92 511.8 92 282.7 92 96.3 275.6 92 503.8a8 8 0 0 0 8 8.2h60c4.4 0 7.9-3.5 8-7.8zm756 7.8h-60c-4.4 0-7.9 3.5-8 7.8-1 43.7-10 86.1-26.9 126-17.3 41-42.1 77.8-73.7 109.4A342.45 342.45 0 0 1 512.1 856a342.24 342.24 0 0 1-243.2-100.8c-9.9-9.9-19.2-20.4-27.8-31.4l60.2-47a8 8 0 0 0-3-14.1l-175.7-43c-5-1.2-9.9 2.6-9.9 7.7l-.7 181c0 6.7 7.7 10.5 12.9 6.3l56.4-44.1C258.2 868.9 377.8 932 512.2 932c229.2 0 415.5-183.7 419.8-411.8a8 8 0 0 0-8-8.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineTable(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 208H676V232h212v136zm0 224H676V432h212v160zM412 432h200v160H412V432zm200-64H412V232h200v136zm-476 64h212v160H136V432zm0-200h212v136H136V232zm0 424h212v136H136V656zm276 0h200v136H412V656zm476 136H676V656h212v136z"
                }
            }
        ]
    })(props);
}
function AiOutlineTablet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H232V136h560v752zM472 784a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineTag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 0 0 0 14.1l363.8 363.8c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM459.7 834.7L189.3 564.3 589 164.6 836 188l23.4 247-399.7 399.7zM680 256c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm0 120c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function AiOutlineTags(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.2 790.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3c-2.3-.2-4.7.6-6.3 2.3L137.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c3.1 3.2 8.2 3.2 11.3 0zm62.6-651.7l224.6 19 19 224.6L477.5 694 233.9 450.5l311.9-311.9zm60.16 186.23a48 48 0 1 0 67.88-67.89 48 48 0 1 0-67.88 67.89zM889.7 539.8l-39.6-39.5a8.03 8.03 0 0 0-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 0 0-11.3 0l-39.6 39.5a8.03 8.03 0 0 0 0 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineTaobaoCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 1 1 0-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineTaobao(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168.5 273.7a68.7 68.7 0 1 0 137.4 0 68.7 68.7 0 1 0-137.4 0zm730 79.2s-23.7-184.4-426.9-70.1c17.3-30 25.6-49.5 25.6-49.5L396.4 205s-40.6 132.6-113 194.4c0 0 70.1 40.6 69.4 39.4 20.1-20.1 38.2-40.6 53.7-60.4 16.1-7 31.5-13.6 46.7-19.8-18.6 33.5-48.7 83.8-78.8 115.6l42.4 37s28.8-27.7 60.4-61.2h36v61.8H372.9v49.5h140.3v118.5c-1.7 0-3.6 0-5.4-.2-15.4-.7-39.5-3.3-49-18.2-11.5-18.1-3-51.5-2.4-71.9h-97l-3.4 1.8s-35.5 159.1 102.3 155.5c129.1 3.6 203-36 238.6-63.1l14.2 52.6 79.6-33.2-53.9-131.9-64.6 20.1 12.1 45.2c-16.6 12.4-35.6 21.7-56.2 28.4V561.3h137.1v-49.5H628.1V450h137.6v-49.5H521.3c17.6-21.4 31.5-41.1 35-53.6l-42.5-11.6c182.8-65.5 284.5-54.2 283.6 53.2v282.8s10.8 97.1-100.4 90.1l-60.2-12.9-14.2 57.1S882.5 880 903.7 680.2c21.3-200-5.2-327.3-5.2-327.3zm-707.4 18.3l-45.4 69.7 83.6 52.1s56 28.5 29.4 81.9C233.8 625.5 112 736.3 112 736.3l109 68.1c75.4-163.7 70.5-142 89.5-200.7 19.5-60.1 23.7-105.9-9.4-139.1-42.4-42.6-47-46.6-110-93.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineTeam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M824.2 699.9a301.55 301.55 0 0 0-86.4-60.4C783.1 602.8 812 546.8 812 484c0-110.8-92.4-201.7-203.2-200-109.1 1.7-197 90.6-197 200 0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 0 0-86.4 60.4C345 754.6 314 826.8 312 903.8a8 8 0 0 0 8 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5A226.62 226.62 0 0 1 612 684c60.9 0 118.2 23.7 161.3 66.8C814.5 792 838 846.3 840 904.3c.1 4.3 3.7 7.7 8 7.7h56a8 8 0 0 0 8-8.2c-2-77-33-149.2-87.8-203.9zM612 612c-34.2 0-66.4-13.3-90.5-37.5a126.86 126.86 0 0 1-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4 0 34.2-13.3 66.3-37.5 90.5A127.3 127.3 0 0 1 612 612zM361.5 510.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 0 1-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 0 0 8 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineThunderbolt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M848 359.3H627.7L825.8 109c4.1-5.3.4-13-6.3-13H436c-2.8 0-5.5 1.5-6.9 4L170 547.5c-3.1 5.3.7 12 6.9 12h174.4l-89.4 357.6c-1.9 7.8 7.5 13.3 13.3 7.7L853.5 373c5.2-4.9 1.7-13.7-5.5-13.7zM378.2 732.5l60.3-241H281.1l189.6-327.4h224.6L487 427.4h211L378.2 732.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineToTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M885 780H165c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM400 325.7h73.9V664c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V325.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 171a8 8 0 0 0-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13z"
                }
            }
        ]
    })(props);
}
function AiOutlineTool(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M876.6 239.5c-.5-.9-1.2-1.8-2-2.5-5-5-13.1-5-18.1 0L684.2 409.3l-67.9-67.9L788.7 169c.8-.8 1.4-1.6 2-2.5 3.6-6.1 1.6-13.9-4.5-17.5-98.2-58-226.8-44.7-311.3 39.7-67 67-89.2 162-66.5 247.4l-293 293c-3 3-2.8 7.9.3 11l169.7 169.7c3.1 3.1 8.1 3.3 11 .3l292.9-292.9c85.5 22.8 180.5.7 247.6-66.4 84.4-84.5 97.7-213.1 39.7-311.3zM786 499.8c-58.1 58.1-145.3 69.3-214.6 33.6l-8.8 8.8-.1-.1-274 274.1-79.2-79.2 230.1-230.1s0 .1.1.1l52.8-52.8c-35.7-69.3-24.5-156.5 33.6-214.6a184.2 184.2 0 0 1 144-53.5L537 318.9a32.05 32.05 0 0 0 0 45.3l124.5 124.5a32.05 32.05 0 0 0 45.3 0l132.8-132.8c3.7 51.8-14.4 104.8-53.6 143.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineTrademarkCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm87.5-334.7c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.5-131.1-144.2-131.1H378c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.5c4.4 0 8-3.6 8-8V561.2h88.7l74.6 159.2c1.3 2.8 4.1 4.6 7.2 4.6h62a7.9 7.9 0 0 0 7.1-11.5l-80.6-164.2zM522 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.5 0 46.9-29.8 72.5-82.8 72.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineTrademark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm87.5-334.7c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.5-131.1-144.2-131.1H378c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.5c4.4 0 8-3.6 8-8V561.2h88.7l74.6 159.2c1.3 2.8 4.1 4.6 7.2 4.6h62a7.9 7.9 0 0 0 7.1-11.5l-80.6-164.2zM522 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.5 0 46.9-29.8 72.5-82.8 72.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineTransaction(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M668.6 320c0-4.4-3.6-8-8-8h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 0 0-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.5-1.1.9-2.4.9-3.7zM157.9 504.2a352.7 352.7 0 0 1 103.5-242.4c32.5-32.5 70.3-58.1 112.4-75.9 43.6-18.4 89.9-27.8 137.6-27.8 47.8 0 94.1 9.3 137.6 27.8 42.1 17.8 79.9 43.4 112.4 75.9 10 10 19.3 20.5 27.9 31.4l-50 39.1a8 8 0 0 0 3 14.1l156.8 38.3c5 1.2 9.9-2.6 9.9-7.7l.8-161.5c0-6.7-7.7-10.5-12.9-6.3l-47.8 37.4C770.7 146.3 648.6 82 511.5 82 277 82 86.3 270.1 82 503.8a8 8 0 0 0 8 8.2h60c4.3 0 7.8-3.5 7.9-7.8zM934 512h-60c-4.3 0-7.9 3.5-8 7.8a352.7 352.7 0 0 1-103.5 242.4 352.57 352.57 0 0 1-112.4 75.9c-43.6 18.4-89.9 27.8-137.6 27.8s-94.1-9.3-137.6-27.8a352.57 352.57 0 0 1-112.4-75.9c-10-10-19.3-20.5-27.9-31.4l49.9-39.1a8 8 0 0 0-3-14.1l-156.8-38.3c-5-1.2-9.9 2.6-9.9 7.7l-.8 161.7c0 6.7 7.7 10.5 12.9 6.3l47.8-37.4C253.3 877.7 375.4 942 512.5 942 747 942 937.7 753.9 942 520.2a8 8 0 0 0-8-8.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineTranslation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683569194",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M140 188h584v164h76V144c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h544v-76H140V188z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M414.3 256h-60.6c-3.4 0-6.4 2.2-7.6 5.4L219 629.4c-0.3 0.8-0.4 1.7-0.4 2.6 0 4.4 3.6 8 8 8h55.1c3.4 0 6.4-2.2 7.6-5.4L322 540h196.2L422 261.4c-1.3-3.2-4.3-5.4-7.7-5.4z m12.4 228h-85.5L384 360.2 426.7 484zM936 528H800v-93c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v93H592c-13.3 0-24 10.7-24 24v176c0 13.3 10.7 24 24 24h136v152c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V752h136c13.3 0 24-10.7 24-24V552c0-13.3-10.7-24-24-24zM728 680h-88v-80h88v80z m160 0h-88v-80h88v80z"
                }
            }
        ]
    })(props);
}
function AiOutlineTrophy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 0 0-44 44v148c0 81.7 60 149.6 138.2 162C265.7 630.2 359 721.7 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.7 758.3 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 0 0-44-44zM184 352V232h64v207.6a91.99 91.99 0 0 1-64-87.6zm520 128c0 49.1-19.1 95.4-53.9 130.1-34.8 34.8-81 53.9-130.1 53.9h-16c-49.1 0-95.4-19.1-130.1-53.9-34.8-34.8-53.9-81-53.9-130.1V184h384v296zm136-128c0 41-26.9 75.8-64 87.6V232h64v120z"
                }
            }
        ]
    })(props);
}
function AiOutlineTwitter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 254.3c-30.6 13.2-63.9 22.7-98.2 26.4a170.1 170.1 0 0 0 75-94 336.64 336.64 0 0 1-108.2 41.2A170.1 170.1 0 0 0 672 174c-94.5 0-170.5 76.6-170.5 170.6 0 13.2 1.6 26.4 4.2 39.1-141.5-7.4-267.7-75-351.6-178.5a169.32 169.32 0 0 0-23.2 86.1c0 59.2 30.1 111.4 76 142.1a172 172 0 0 1-77.1-21.7v2.1c0 82.9 58.6 151.6 136.7 167.4a180.6 180.6 0 0 1-44.9 5.8c-11.1 0-21.6-1.1-32.2-2.6C211 652 273.9 701.1 348.8 702.7c-58.6 45.9-132 72.9-211.7 72.9-14.3 0-27.5-.5-41.2-2.1C171.5 822 261.2 850 357.8 850 671.4 850 843 590.2 843 364.7c0-7.4 0-14.8-.5-22.2 33.2-24.3 62.3-54.4 85.5-88.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineUnderline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M824 804H200c-4.4 0-8 3.4-8 7.6v60.8c0 4.2 3.6 7.6 8 7.6h624c4.4 0 8-3.4 8-7.6v-60.8c0-4.2-3.6-7.6-8-7.6zm-312-76c69.4 0 134.6-27.1 183.8-76.2C745 602.7 772 537.4 772 468V156c0-6.6-5.4-12-12-12h-60c-6.6 0-12 5.4-12 12v312c0 97-79 176-176 176s-176-79-176-176V156c0-6.6-5.4-12-12-12h-60c-6.6 0-12 5.4-12 12v312c0 69.4 27.1 134.6 76.2 183.8C377.3 701 442.6 728 512 728z"
                }
            }
        ]
    })(props);
}
function AiOutlineUndo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.4 124C290.5 124.3 112 303 112 523.9c0 128 60.2 242 153.8 315.2l-37.5 48c-4.1 5.3-.3 13 6.3 12.9l167-.8c5.2 0 9-4.9 7.7-9.9L369.8 727a8 8 0 0 0-14.1-3L315 776.1c-10.2-8-20-16.7-29.3-26a318.64 318.64 0 0 1-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 0 1-68.6 101.7c-7.5 7.5-15.3 14.5-23.4 21.2a7.93 7.93 0 0 0-1.2 11.1l39.4 50.5c2.8 3.5 7.9 4.1 11.4 1.3C854.5 760.8 912 649.1 912 523.9c0-221.1-179.4-400.2-400.6-399.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineUngroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683823033",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M736 550H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V566c0-8.8-7.2-16-16-16z m-56 136H344v-64h336v64zM888 816c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z m0 96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zM736 266H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V282c0-8.8-7.2-16-16-16z m-56 136H344v-64h336v64zM888 208c39.8 0 72-32.2 72-72s-32.2-72-72-72-72 32.2-72 72 32.2 72 72 72z m0-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zM136 64c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z m0 96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zM136 816c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z m0 96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z"
                }
            }
        ]
    })(props);
}
function AiOutlineUnlock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zm-40 376H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineUnorderedList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineUpCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M518.5 360.3a7.95 7.95 0 0 0-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7H381c10.2 0 19.9-4.9 25.9-13.2L512 460.4l105.2 145.4c6 8.3 15.6 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.5-12.7l-178-246z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    })(props);
}
function AiOutlineUpSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M334 624h46.9c10.2 0 19.9-4.9 25.9-13.2L512 465.4l105.2 145.4c6 8.3 15.6 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.5-12.7l-178-246a7.95 7.95 0 0 0-12.9 0l-178 246A7.96 7.96 0 0 0 334 624z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlineUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 0 0 140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 0 0-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineUsb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M760 432V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V548c0-24.3 21.6-44 48.1-44h495.8c26.5 0 48.1 19.7 48.1 44v356c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zm-424 0V184h352v248H336zm120-184h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm160 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineUserAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M678.3 642.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 0 0-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 505 759.6 431.7 759.6 349c0-137-110.8-248-247.5-248S264.7 212 264.7 349c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 0 0-80.4 119.5A373.6 373.6 0 0 0 137 888.8a8 8 0 0 0 8 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 628.2 432.2 597 512.2 597c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 0 0 8.1.3zM512.2 521c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 0 1 340.5 349c0-45.9 17.9-89.1 50.3-121.6S466.3 177 512.2 177s88.9 17.9 121.4 50.4A171.2 171.2 0 0 1 683.9 349c0 45.9-17.9 89.1-50.3 121.6C601.1 503.1 558 521 512.2 521zM880 759h-84v-84c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v84h-84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h84v84c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-84h84c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineUserDelete(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M678.3 655.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 0 0-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 518 759.6 444.7 759.6 362c0-137-110.8-248-247.5-248S264.7 225 264.7 362c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 0 0-80.4 119.5A373.6 373.6 0 0 0 137 901.8a8 8 0 0 0 8 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 641.2 432.2 610 512.2 610c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 0 0 8.1.3zM512.2 534c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 0 1 340.5 362c0-45.9 17.9-89.1 50.3-121.6S466.3 190 512.2 190s88.9 17.9 121.4 50.4A171.2 171.2 0 0 1 683.9 362c0 45.9-17.9 89.1-50.3 121.6C601.1 516.1 558 534 512.2 534zM880 772H640c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineUserSwitch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683921137",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M759 335c0-137-111-248-248-248S263 198 263 335c0 82.8 40.6 156.2 103 201.2-0.4 0.2-0.7 0.3-0.9 0.4-44.7 18.9-84.8 46-119.3 80.6-34.5 34.5-61.5 74.7-80.4 119.5C146.9 780.5 137 827 136 874.8c-0.1 4.5 3.5 8.2 8 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C356 614.2 431 583 511 583c137 0 248-111 248-248zM511 507c-95 0-172-77-172-172s77-172 172-172 172 77 172 172-77 172-172 172zM616 728h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H703.5l47.2-60.1c1.1-1.4 1.7-3.2 1.7-4.9 0-4.4-3.6-8-8-8h-72.6c-4.9 0-9.5 2.3-12.6 6.1l-68.5 87.1c-4.4 5.6-6.8 12.6-6.8 19.8 0.1 17.7 14.4 32 32.1 32zM856 792H592c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h176.5l-47.2 60.1c-1.1 1.4-1.7 3.2-1.7 4.9 0 4.4 3.6 8 8 8h72.6c4.9 0 9.5-2.3 12.6-6.1l68.5-87.1c4.4-5.6 6.8-12.6 6.8-19.8-0.1-17.7-14.4-32-32.1-32z"
                }
            }
        ]
    })(props);
}
function AiOutlineUser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M858.5 763.6a374 374 0 0 0-80.6-119.5 375.63 375.63 0 0 0-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 0 0-80.6 119.5A371.7 371.7 0 0 0 136 901.8a8 8 0 0 0 8 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 0 0 8-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z"
                }
            }
        ]
    })(props);
}
function AiOutlineUsergroupAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M892 772h-80v-80c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v80h-80c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h80v80c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-80h80c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM373.5 498.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 0 1-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.8-1.7-203.2 89.2-203.2 200 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 0 0 8 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.8-1.1 6.4-4.8 5.9-8.8zM824 472c0-109.4-87.9-198.3-196.9-200C516.3 270.3 424 361.2 424 472c0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 0 0-86.4 60.4C357 742.6 326 814.8 324 891.8a8 8 0 0 0 8 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5C505.8 695.7 563 672 624 672c110.4 0 200-89.5 200-200zm-109.5 90.5C690.3 586.7 658.2 600 624 600s-66.3-13.3-90.5-37.5a127.26 127.26 0 0 1-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4-.1 34.2-13.4 66.3-37.6 90.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineUsergroupDelete(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M888 784H664c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM373.5 510.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 0 1-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 0 0 8 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7zM824 484c0-109.4-87.9-198.3-196.9-200C516.3 282.3 424 373.2 424 484c0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 0 0-86.4 60.4C357 754.6 326 826.8 324 903.8a8 8 0 0 0 8 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5C505.8 707.7 563 684 624 684c110.4 0 200-89.5 200-200zm-109.5 90.5C690.3 598.7 658.2 612 624 612s-66.3-13.3-90.5-37.5a127.26 127.26 0 0 1-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4-.1 34.2-13.4 66.3-37.6 90.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineVerified(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683899926",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M447.8 588.8l-7.3-32.5c-0.2-1-0.6-1.9-1.1-2.7-2.5-3.7-7.4-4.7-11.1-2.2L405 567V411c0-4.4-3.6-8-8-8h-81c-4.4 0-8 3.6-8 8v36c0 4.4 3.6 8 8 8h37v192.4c0 1.7 0.5 3.3 1.5 4.7 2.6 3.6 7.6 4.4 11.2 1.8l79-56.8c2.6-1.9 3.8-5.1 3.1-8.3zM391.1 372.2l0.2 0.2c3.2 3 8.3 2.8 11.3-0.5l24.1-26.2c2.9-3.2 2.8-8.1-0.3-11.2l-53.7-52.1c-3.1-3-8.1-3-11.2 0.1l-24.7 24.7c-3.1 3.1-3.1 8.2 0.1 11.3l54.2 53.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 0.7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c0.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M452 297v36c0 4.4 3.6 8 8 8h108v274h-38V405c0-4.4-3.6-8-8-8h-35c-4.4 0-8 3.6-8 8v210h-31c-4.4 0-8 3.6-8 8v37c0 4.4 3.6 8 8 8h244c4.4 0 8-3.6 8-8v-37c0-4.4-3.6-8-8-8h-72V493h58c4.4 0 8-3.6 8-8v-35c0-4.4-3.6-8-8-8h-58V341h63c4.4 0 8-3.6 8-8v-36c0-4.4-3.6-8-8-8H460c-4.4 0-8 3.6-8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineVerticalAlignBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M859.9 780H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM505.7 669a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V176c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineVerticalAlignMiddle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M859.9 474H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zm-353.6-74.7c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H550V104c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v156h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.6zm11.4 225.4a7.14 7.14 0 0 0-11.3 0L405.6 752.3a7.23 7.23 0 0 0 5.7 11.7H474v156c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V764h62.8c6 0 9.4-7 5.7-11.7L517.7 624.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineVerticalAlignTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M859.9 168H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM518.3 355a8 8 0 0 0-12.6 0l-112 141.7a7.98 7.98 0 0 0 6.3 12.9h73.9V848c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V509.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 355z"
                }
            }
        ]
    })(props);
}
function AiOutlineVerticalLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M762 164h-64c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V172c0-4.4-3.6-8-8-8zm-508 0v72.4c0 9.5 4.2 18.4 11.4 24.5L564.6 512 265.4 763.1c-7.2 6.1-11.4 15-11.4 24.5V860c0 6.8 7.9 10.5 13.1 6.1L689 512 267.1 157.9A7.95 7.95 0 0 0 254 164z"
                }
            }
        ]
    })(props);
}
function AiOutlineVerticalRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M326 164h-64c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V172c0-4.4-3.6-8-8-8zm444 72.4V164c0-6.8-7.9-10.5-13.1-6.1L335 512l421.9 354.1c5.2 4.4 13.1.7 13.1-6.1v-72.4c0-9.4-4.2-18.4-11.4-24.5L459.4 512l299.2-251.1c7.2-6.1 11.4-15.1 11.4-24.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineVideoCameraAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683915274",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M368 724H252V608c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v116H72c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h116v116c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V788h116c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v352h72V232h576v560H448v72h272c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM888 625l-104-59.8V458.9L888 399v226z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M320 360c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h112z"
                }
            }
        ]
    })(props);
}
function AiOutlineVideoCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM712 792H136V232h576v560zm176-167l-104-59.8V458.9L888 399v226zM208 360h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineWallet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 464H528V448h312v128zm0 264H184V184h656v200H496c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h344v200zM580 512a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineWarning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 720a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zm475.7 440l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineWechat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M690.1 377.4c5.9 0 11.8.2 17.6.5-24.4-128.7-158.3-227.1-319.9-227.1C209 150.8 64 271.4 64 420.2c0 81.1 43.6 154.2 111.9 203.6a21.5 21.5 0 0 1 9.1 17.6c0 2.4-.5 4.6-1.1 6.9-5.5 20.3-14.2 52.8-14.6 54.3-.7 2.6-1.7 5.2-1.7 7.9 0 5.9 4.8 10.8 10.8 10.8 2.3 0 4.2-.9 6.2-2l70.9-40.9c5.3-3.1 11-5 17.2-5 3.2 0 6.4.5 9.5 1.4 33.1 9.5 68.8 14.8 105.7 14.8 6 0 11.9-.1 17.8-.4-7.1-21-10.9-43.1-10.9-66 0-135.8 132.2-245.8 295.3-245.8zm-194.3-86.5c23.8 0 43.2 19.3 43.2 43.1s-19.3 43.1-43.2 43.1c-23.8 0-43.2-19.3-43.2-43.1s19.4-43.1 43.2-43.1zm-215.9 86.2c-23.8 0-43.2-19.3-43.2-43.1s19.3-43.1 43.2-43.1 43.2 19.3 43.2 43.1-19.4 43.1-43.2 43.1zm586.8 415.6c56.9-41.2 93.2-102 93.2-169.7 0-124-120.8-224.5-269.9-224.5-149 0-269.9 100.5-269.9 224.5S540.9 847.5 690 847.5c30.8 0 60.6-4.4 88.1-12.3 2.6-.8 5.2-1.2 7.9-1.2 5.2 0 9.9 1.6 14.3 4.1l59.1 34c1.7 1 3.3 1.7 5.2 1.7a9 9 0 0 0 6.4-2.6 9 9 0 0 0 2.6-6.4c0-2.2-.9-4.4-1.4-6.6-.3-1.2-7.6-28.3-12.2-45.3-.5-1.9-.9-3.8-.9-5.7.1-5.9 3.1-11.2 7.6-14.5zM600.2 587.2c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9c0 19.8-16.2 35.9-36 35.9zm179.9 0c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9a36.08 36.08 0 0 1-36 35.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineWeiboCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-44.4 672C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-93-32.2c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zm34.9-14.5c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineWeiboSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.6 595.1c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM467.6 736C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-58.1-46.7c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineWeibo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M457.3 543c-68.1-17.7-145 16.2-174.6 76.2-30.1 61.2-1 129.1 67.8 151.3 71.2 23 155.2-12.2 184.4-78.3 28.7-64.6-7.2-131-77.6-149.2zm-52 156.2c-13.8 22.1-43.5 31.7-65.8 21.6-22-10-28.5-35.7-14.6-57.2 13.7-21.4 42.3-31 64.4-21.7 22.4 9.5 29.6 35 16 57.3zm45.5-58.5c-5 8.6-16.1 12.7-24.7 9.1-8.5-3.5-11.2-13.1-6.4-21.5 5-8.4 15.6-12.4 24.1-9.1 8.7 3.2 11.8 12.9 7 21.5zm334.5-197.2c15 4.8 31-3.4 35.9-18.3 11.8-36.6 4.4-78.4-23.2-109a111.39 111.39 0 0 0-106-34.3 28.45 28.45 0 0 0-21.9 33.8 28.39 28.39 0 0 0 33.8 21.8c18.4-3.9 38.3 1.8 51.9 16.7a54.2 54.2 0 0 1 11.3 53.3 28.45 28.45 0 0 0 18.2 36zm99.8-206c-56.7-62.9-140.4-86.9-217.7-70.5a32.98 32.98 0 0 0-25.4 39.3 33.12 33.12 0 0 0 39.3 25.5c55-11.7 114.4 5.4 154.8 50.1 40.3 44.7 51.2 105.7 34 159.1-5.6 17.4 3.9 36 21.3 41.7 17.4 5.6 36-3.9 41.6-21.2v-.1c24.1-75.4 8.9-161.1-47.9-223.9zM729 499c-12.2-3.6-20.5-6.1-14.1-22.1 13.8-34.7 15.2-64.7.3-86-28-40.1-104.8-37.9-192.8-1.1 0 0-27.6 12.1-20.6-9.8 13.5-43.5 11.5-79.9-9.6-101-47.7-47.8-174.6 1.8-283.5 110.6C127.3 471.1 80 557.5 80 632.2 80 775.1 263.2 862 442.5 862c235 0 391.3-136.5 391.3-245 0-65.5-55.2-102.6-104.8-118zM443 810.8c-143 14.1-266.5-50.5-275.8-144.5-9.3-93.9 99.2-181.5 242.2-195.6 143-14.2 266.5 50.5 275.8 144.4C694.4 709 586 796.6 443 810.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineWhatsApp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683925316",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M713.5 599.9c-10.9-5.6-65.2-32.2-75.3-35.8-10.1-3.8-17.5-5.6-24.8 5.6-7.4 11.1-28.4 35.8-35 43.3-6.4 7.4-12.9 8.3-23.8 2.8-64.8-32.4-107.3-57.8-150-131.1-11.3-19.5 11.3-18.1 32.4-60.2 3.6-7.4 1.8-13.7-1-19.3-2.8-5.6-24.8-59.8-34-81.9-8.9-21.5-18.1-18.5-24.8-18.9-6.4-0.4-13.7-0.4-21.1-0.4-7.4 0-19.3 2.8-29.4 13.7-10.1 11.1-38.6 37.8-38.6 92s39.5 106.7 44.9 114.1c5.6 7.4 77.7 118.6 188.4 166.5 70 30.2 97.4 32.8 132.4 27.6 21.3-3.2 65.2-26.6 74.3-52.5 9.1-25.8 9.1-47.9 6.4-52.5-2.7-4.9-10.1-7.7-21-13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M925.2 338.4c-22.6-53.7-55-101.9-96.3-143.3-41.3-41.3-89.5-73.8-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6 0.3-119.3 12.3-174.5 35.9-53.3 22.8-101.1 55.2-142 96.5-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9 0.3 69.4 16.9 138.3 48 199.9v152c0 25.4 20.6 46 46 46h152.1c61.6 31.1 130.5 47.7 199.9 48h2.1c59.9 0 118-11.6 172.7-34.3 53.5-22.3 101.6-54.3 142.8-95.2 41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5 0.3-60.9-11.5-120-34.8-175.6z m-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-0.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-0.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-0.6 99.6-39.7 192.9-110.1 262.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineWifi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M723 620.5C666.8 571.6 593.4 542 513 542s-153.8 29.6-210.1 78.6a8.1 8.1 0 0 0-.8 11.2l36 42.9c2.9 3.4 8 3.8 11.4.9C393.1 637.2 450.3 614 513 614s119.9 23.2 163.5 61.5c3.4 2.9 8.5 2.5 11.4-.9l36-42.9c2.8-3.3 2.4-8.3-.9-11.2zm117.4-140.1C751.7 406.5 637.6 362 513 362s-238.7 44.5-327.5 118.4a8.05 8.05 0 0 0-1 11.3l36 42.9c2.8 3.4 7.9 3.8 11.2 1C308 472.2 406.1 434 513 434s205 38.2 281.2 101.6c3.4 2.8 8.4 2.4 11.2-1l36-42.9c2.8-3.4 2.4-8.5-1-11.3zm116.7-139C835.7 241.8 680.3 182 511 182c-168.2 0-322.6 59-443.7 157.4a8 8 0 0 0-1.1 11.4l36 42.9c2.8 3.3 7.8 3.8 11.1 1.1C222 306.7 360.3 254 511 254c151.8 0 291 53.5 400 142.7 3.4 2.8 8.4 2.3 11.2-1.1l36-42.9c2.9-3.4 2.4-8.5-1.1-11.3zM448 778a64 64 0 1 0 128 0 64 64 0 1 0-128 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineWindows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120.1 770.6L443 823.2V543.8H120.1v226.8zm63.4-163.5h196.2v141.6l-196.2-31.9V607.1zm340.3 226.5l382 62.2v-352h-382v289.8zm63.4-226.5h255.3v214.4l-255.3-41.6V607.1zm-63.4-415.7v288.8h382V128.1l-382 63.3zm318.7 225.5H587.3V245l255.3-42.3v214.2zm-722.4 63.3H443V201.9l-322.9 53.5v224.8zM183.5 309l196.2-32.5v140.4H183.5V309z"
                }
            }
        ]
    })(props);
}
function AiOutlineWoman(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M712.8 548.8c53.6-53.6 83.2-125 83.2-200.8 0-75.9-29.5-147.2-83.2-200.8C659.2 93.6 587.8 64 512 64s-147.2 29.5-200.8 83.2C257.6 200.9 228 272.1 228 348c0 63.8 20.9 124.4 59.4 173.9 7.3 9.4 15.2 18.3 23.7 26.9 8.5 8.5 17.5 16.4 26.8 23.7 39.6 30.8 86.3 50.4 136.1 57V736H360c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h114v140c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V812h114c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H550V629.5c61.5-8.2 118.2-36.1 162.8-80.7zM512 556c-55.6 0-107.7-21.6-147.1-60.9C325.6 455.8 304 403.6 304 348s21.6-107.7 60.9-147.1C404.2 161.5 456.4 140 512 140s107.7 21.6 147.1 60.9C698.4 240.2 720 292.4 720 348s-21.6 107.7-60.9 147.1C619.7 534.4 567.6 556 512 556z"
                }
            }
        ]
    })(props);
}
function AiOutlineYahoo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M859.9 681.4h-14.1c-27.1 0-49.2 22.2-49.2 49.3v14.1c0 27.1 22.2 49.3 49.2 49.3h14.1c27.1 0 49.2-22.2 49.2-49.3v-14.1c0-27.1-22.2-49.3-49.2-49.3zM402.6 231C216.2 231 65 357 65 512.5S216.2 794 402.6 794s337.6-126 337.6-281.5S589.1 231 402.6 231zm0 507C245.1 738 121 634.6 121 512.5c0-62.3 32.3-119.7 84.9-161v48.4h37l159.8 159.9v65.3h-84.4v56.3h225.1v-56.3H459v-65.3l103.5-103.6h65.3v-56.3H459v65.3l-28.1 28.1-93.4-93.5h37v-56.3H216.4c49.4-35 114.3-56.6 186.2-56.6 157.6 0 281.6 103.4 281.6 225.5S560.2 738 402.6 738zm534.7-507H824.7c-15.5 0-27.7 12.6-27.1 28.1l13.1 366h84.4l65.4-366.4c2.7-15.2-7.8-27.7-23.2-27.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineYoutube(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M960 509.2c0-2.2 0-4.7-.1-7.6-.1-8.1-.3-17.2-.5-26.9-.8-27.9-2.2-55.7-4.4-81.9-3-36.1-7.4-66.2-13.4-88.8a139.52 139.52 0 0 0-98.3-98.5c-28.3-7.6-83.7-12.3-161.7-15.2-37.1-1.4-76.8-2.3-116.5-2.8-13.9-.2-26.8-.3-38.4-.4h-29.4c-11.6.1-24.5.2-38.4.4-39.7.5-79.4 1.4-116.5 2.8-78 3-133.5 7.7-161.7 15.2A139.35 139.35 0 0 0 82.4 304C76.3 326.6 72 356.7 69 392.8c-2.2 26.2-3.6 54-4.4 81.9-.3 9.7-.4 18.8-.5 26.9 0 2.9-.1 5.4-.1 7.6v5.6c0 2.2 0 4.7.1 7.6.1 8.1.3 17.2.5 26.9.8 27.9 2.2 55.7 4.4 81.9 3 36.1 7.4 66.2 13.4 88.8 12.8 47.9 50.4 85.7 98.3 98.5 28.2 7.6 83.7 12.3 161.7 15.2 37.1 1.4 76.8 2.3 116.5 2.8 13.9.2 26.8.3 38.4.4h29.4c11.6-.1 24.5-.2 38.4-.4 39.7-.5 79.4-1.4 116.5-2.8 78-3 133.5-7.7 161.7-15.2 47.9-12.8 85.5-50.5 98.3-98.5 6.1-22.6 10.4-52.7 13.4-88.8 2.2-26.2 3.6-54 4.4-81.9.3-9.7.4-18.8.5-26.9 0-2.9.1-5.4.1-7.6v-5.6zm-72 5.2c0 2.1 0 4.4-.1 7.1-.1 7.8-.3 16.4-.5 25.7-.7 26.6-2.1 53.2-4.2 77.9-2.7 32.2-6.5 58.6-11.2 76.3-6.2 23.1-24.4 41.4-47.4 47.5-21 5.6-73.9 10.1-145.8 12.8-36.4 1.4-75.6 2.3-114.7 2.8-13.7.2-26.4.3-37.8.3h-28.6l-37.8-.3c-39.1-.5-78.2-1.4-114.7-2.8-71.9-2.8-124.9-7.2-145.8-12.8-23-6.2-41.2-24.4-47.4-47.5-4.7-17.7-8.5-44.1-11.2-76.3-2.1-24.7-3.4-51.3-4.2-77.9-.3-9.3-.4-18-.5-25.7 0-2.7-.1-5.1-.1-7.1v-4.8c0-2.1 0-4.4.1-7.1.1-7.8.3-16.4.5-25.7.7-26.6 2.1-53.2 4.2-77.9 2.7-32.2 6.5-58.6 11.2-76.3 6.2-23.1 24.4-41.4 47.4-47.5 21-5.6 73.9-10.1 145.8-12.8 36.4-1.4 75.6-2.3 114.7-2.8 13.7-.2 26.4-.3 37.8-.3h28.6l37.8.3c39.1.5 78.2 1.4 114.7 2.8 71.9 2.8 124.9 7.2 145.8 12.8 23 6.2 41.2 24.4 47.4 47.5 4.7 17.7 8.5 44.1 11.2 76.3 2.1 24.7 3.4 51.3 4.2 77.9.3 9.3.4 18 .5 25.7 0 2.7.1 5.1.1 7.1v4.8zM423 646l232-135-232-133z"
                }
            }
        ]
    })(props);
}
function AiOutlineYuque(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 370.6c-9.9-39.4 9.9-102.2 73.4-124.4l-67.9-3.6s-25.7-90-143.6-98c-117.8-8.1-194.9-3-195-3 .1 0 87.4 55.6 52.4 154.7-25.6 52.5-65.8 95.6-108.8 144.7-1.3 1.3-2.5 2.6-3.5 3.7C319.4 605 96 860 96 860c245.9 64.4 410.7-6.3 508.2-91.1 20.5-.2 35.9-.3 46.3-.3 135.8 0 250.6-117.6 245.9-248.4-3.2-89.9-31.9-110.2-41.8-149.6zm-204.1 334c-10.6 0-26.2.1-46.8.3l-23.6.2-17.8 15.5c-47.1 41-104.4 71.5-171.4 87.6-52.5 12.6-110 16.2-172.7 9.6 18-20.5 36.5-41.6 55.4-63.1 92-104.6 173.8-197.5 236.9-268.5l1.4-1.4 1.3-1.5c4.1-4.6 20.6-23.3 24.7-28.1 9.7-11.1 17.3-19.9 24.5-28.6 30.7-36.7 52.2-67.8 69-102.2l1.6-3.3 1.2-3.4c13.7-38.8 15.4-76.9 6.2-112.8 22.5.7 46.5 1.9 71.7 3.6 33.3 2.3 55.5 12.9 71.1 29.2 5.8 6 10.2 12.5 13.4 18.7 1 2 1.7 3.6 2.3 5l5 17.7c-15.7 34.5-19.9 73.3-11.4 107.2 3 11.8 6.9 22.4 12.3 34.4 2.1 4.7 9.5 20.1 11 23.3 10.3 22.7 15.4 43 16.7 78.7 3.3 94.6-82.7 181.9-182 181.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineZhihu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M564.7 230.1V803h60l25.2 71.4L756.3 803h131.5V230.1H564.7zm247.7 497h-59.9l-75.1 50.4-17.8-50.4h-18V308.3h170.7v418.8zM526.1 486.9H393.3c2.1-44.9 4.3-104.3 6.6-172.9h130.9l-.1-8.1c0-.6-.2-14.7-2.3-29.1-2.1-15-6.6-34.9-21-34.9H287.8c4.4-20.6 15.7-69.7 29.4-93.8l6.4-11.2-12.9-.7c-.8 0-19.6-.9-41.4 10.6-35.7 19-51.7 56.4-58.7 84.4-18.4 73.1-44.6 123.9-55.7 145.6-3.3 6.4-5.3 10.2-6.2 12.8-1.8 4.9-.8 9.8 2.8 13 10.5 9.5 38.2-2.9 38.5-3 .6-.3 1.3-.6 2.2-1 13.9-6.3 55.1-25 69.8-84.5h56.7c.7 32.2 3.1 138.4 2.9 172.9h-141l-2.1 1.5c-23.1 16.9-30.5 63.2-30.8 65.2l-1.4 9.2h167c-12.3 78.3-26.5 113.4-34 127.4-3.7 7-7.3 14-10.7 20.8-21.3 42.2-43.4 85.8-126.3 153.6-3.6 2.8-7 8-4.8 13.7 2.4 6.3 9.3 9.1 24.6 9.1 5.4 0 11.8-.3 19.4-1 49.9-4.4 100.8-18 135.1-87.6 17-35.1 31.7-71.7 43.9-108.9L497 850l5-12c.8-1.9 19-46.3 5.1-95.9l-.5-1.8-108.1-123-22 16.6c6.4-26.1 10.6-49.9 12.5-71.1h158.7v-8c0-40.1-18.5-63.9-19.2-64.9l-2.4-3z"
                }
            }
        ]
    })(props);
}
function AiOutlineZoomIn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z"
                }
            }
        ]
    })(props);
}
function AiOutlineZoomOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z"
                }
            }
        ]
    })(props);
}
function AiTwotoneAccountBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v584h656V256H712v48zm-65.6 121.8l-89.3 164.1h49.1c4.4 0 8 3.6 8 8v21.3c0 4.4-3.6 8-8 8h-65.4v33.7h65.4c4.4 0 8 3.6 8 8v21.3c0 4.4-3.6 8-8 8h-65.4V752c0 4.4-3.6 8-8 8h-41.3c-4.4 0-8-3.6-8-8v-53.8h-65.1c-4.4 0-8-3.6-8-8v-21.3c0-4.4 3.6-8 8-8h65.1v-33.7h-65.1c-4.4 0-8-3.6-8-8v-21.3c0-4.4 3.6-8 8-8H467l-89.3-164c-2.1-3.9-.7-8.8 3.2-10.9 1.1-.7 2.5-1 3.8-1h46a8 8 0 0 1 7.1 4.4l73.4 145.4h2.8l73.4-145.4c1.3-2.7 4.1-4.4 7.1-4.4h45c4.5 0 8 3.6 7.9 8 0 1.3-.4 2.6-1 3.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M639.5 414h-45c-3 0-5.8 1.7-7.1 4.4L514 563.8h-2.8l-73.4-145.4a8 8 0 0 0-7.1-4.4h-46c-1.3 0-2.7.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9l89.3 164h-48.6c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1v33.7h-65.1c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1V752c0 4.4 3.6 8 8 8h41.3c4.4 0 8-3.6 8-8v-53.8h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-65.4v-33.7h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-49.1l89.3-164.1c.6-1.2 1-2.5 1-3.8.1-4.4-3.4-8-7.9-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584z"
                }
            }
        ]
    })(props);
}
function AiTwotoneAlert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M340 585c0-5.5 4.5-10 10-10h44c5.5 0 10 4.5 10 10v171h355V563c0-136.4-110.6-247-247-247S265 426.6 265 563v193h75V585z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M216.9 310.5l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3l-67.9-67.9a8.03 8.03 0 0 0-11.3 0l-39.6 39.6a8.03 8.03 0 0 0 0 11.3l67.9 67.9c3.1 3.1 8.1 3.1 11.3 0zm669.6-79.2l-39.6-39.6a8.03 8.03 0 0 0-11.3 0l-67.9 67.9a8.03 8.03 0 0 0 0 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l67.9-67.9c3.1-3.2 3.1-8.2 0-11.3zM484 180h56c4.4 0 8-3.6 8-8V76c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8zm348 712H192c-17.7 0-32 14.3-32 32v24c0 4.4 3.6 8 8 8h688c4.4 0 8-3.6 8-8v-24c0-17.7-14.3-32-32-32zm-639-96c0 17.7 14.3 32 32 32h574c17.7 0 32-14.3 32-32V563c0-176.2-142.8-319-319-319S193 386.8 193 563v233zm72-233c0-136.4 110.6-247 247-247s247 110.6 247 247v193H404V585c0-5.5-4.5-10-10-10h-44c-5.5 0-10 4.5-10 10v171h-75V563z"
                }
            }
        ]
    })(props);
}
function AiTwotoneApi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M148.2 674.6zm106.7-92.3c-25 25-38.7 58.1-38.7 93.4s13.8 68.5 38.7 93.4c25 25 58.1 38.7 93.4 38.7 35.3 0 68.5-13.8 93.4-38.7l59.4-59.4-186.8-186.8-59.4 59.4zm420.8-366.1c-35.3 0-68.5 13.8-93.4 38.7l-59.4 59.4 186.8 186.8 59.4-59.4c24.9-25 38.7-58.1 38.7-93.4s-13.8-68.5-38.7-93.4c-25-25-58.1-38.7-93.4-38.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M578.9 546.7a8.03 8.03 0 0 0-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 0 0-11.3 0L363 475.3l-43-43a7.85 7.85 0 0 0-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2a199.45 199.45 0 0 0-58.6 140.4c-.2 39.5 11.2 79.1 34.3 113.1l-76.1 76.1a8.03 8.03 0 0 0 0 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2zM441.7 769.1a131.32 131.32 0 0 1-93.4 38.7c-35.3 0-68.4-13.7-93.4-38.7-24.9-24.9-38.7-58.1-38.7-93.4s13.7-68.4 38.7-93.4l59.4-59.4 186.8 186.8-59.4 59.4zm476-620.3l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 0 0-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 0 0 0 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM769.1 441.7l-59.4 59.4-186.8-186.8 59.4-59.4c24.9-24.9 58.1-38.7 93.4-38.7s68.4 13.7 93.4 38.7c24.9 24.9 38.7 58.1 38.7 93.4s-13.8 68.4-38.7 93.4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneAppstore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M864 144H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zM464 544H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H212V612h200v200zm52-668H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452 132H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M212 212h200v200H212zm400 0h200v200H612zM212 612h200v200H212zm400 0h200v200H612z"
                }
            }
        ]
    })(props);
}
function AiTwotoneAudio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M512 552c54.3 0 98-43.2 98-96V232c0-52.8-43.7-96-98-96s-98 43.2-98 96v224c0 52.8 43.7 96 98 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M842 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm-98-392c0-52.8 43.7-96 98-96s98 43.2 98 96v224c0 52.8-43.7 96-98 96s-98-43.2-98-96V232z"
                }
            }
        ]
    })(props);
}
function AiTwotoneBank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M240.9 393.9h542.2L512 196.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 0 0-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM381 836H264V462h117v374zm189 0H453V462h117v374zm190 0H642V462h118v374zM240.9 393.9L512 196.7l271.1 197.2H240.9z"
                }
            }
        ]
    })(props);
}
function AiTwotoneBell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M512 220c-55.6 0-107.8 21.6-147.1 60.9S304 372.4 304 428v340h416V428c0-55.6-21.6-107.8-60.9-147.1S567.6 220 512 220zm280 208c0-141.1-104.3-257.8-240-277.2v.1c135.7 19.4 240 136 240 277.1zM472 150.9v-.1C336.3 170.2 232 286.9 232 428c0-141.1 104.3-257.7 240-277.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M816 768h-24V428c0-141.1-104.3-257.7-240-277.1V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.9c-135.7 19.4-240 136-240 277.1v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48zm208-120H304V428c0-55.6 21.6-107.8 60.9-147.1S456.4 220 512 220c55.6 0 107.8 21.6 147.1 60.9S720 372.4 720 428v340z"
                }
            }
        ]
    })(props);
}
function AiTwotoneBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zM232 888V136h280v296.9c0 3.3 1 6.6 3 9.3a15.9 15.9 0 0 0 22.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752H232z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M668 345.9V136h-96v211.4l49.5-35.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M727.9 136v296.5c0 8.8-7.2 16-16 16-3.4 0-6.7-1.1-9.4-3.1L621.1 386l-83.8 59.9a15.9 15.9 0 0 1-22.3-3.7c-2-2.7-3-6-3-9.3V136H232v752h559.9V136h-64z"
                }
            }
        ]
    })(props);
}
function AiTwotoneBoxPlot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M296 368h88v288h-88zm152 0h280v288H448z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H232c-4.4 0-8 3.6-8 8v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h560c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zM384 656h-88V368h88v288zm344 0H448V368h280v288z"
                }
            }
        ]
    })(props);
}
function AiTwotoneBug(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M308 412v268c0 36.779 9.678 71.962 27.805 102.907a205.39 205.39 0 0 0 73.288 73.288C440.038 874.322 475.22 884 512 884c36.779 0 71.962-9.678 102.907-27.805a205.39 205.39 0 0 0 73.288-73.288C706.322 751.962 716 716.78 716 680V412H308zm484 172v96c0 6.503-.222 12.954-.658 19.346C859.931 728.636 908 796.705 908 876a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-44.24-23.94-82.888-59.57-103.697a278.635 278.635 0 0 1-22.658 49.018 281.39 281.39 0 0 1-100.45 100.45C611.84 946.072 563.546 960 512 960s-99.84-13.929-141.321-38.228a281.39 281.39 0 0 1-100.45-100.45 278.635 278.635 0 0 1-22.658-49.019C211.94 793.113 188 831.76 188 876a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-79.295 48.07-147.363 116.658-176.654A284.122 284.122 0 0 1 232 680v-96H84a8 8 0 0 1-8-8v-56a8 8 0 0 1 8-8h148V412c-76.768 0-139-62.232-139-139a8 8 0 0 1 8-8h60a8 8 0 0 1 8 8c0 34.794 28.206 63 63 63h560c34.794 0 63-28.206 63-63a8 8 0 0 1 8-8h60a8 8 0 0 1 8 8c0 76.768-62.232 139-139 139v100h148a8 8 0 0 1 8 8v56a8 8 0 0 1-8 8H792zM368 272a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-40.039 8.779-76.746 25.9-108.068 17.235-31.526 42.506-56.797 74.032-74.031C427.254 72.779 463.962 64 504 64h16c40.039 0 76.746 8.779 108.068 25.9 31.526 17.235 56.797 42.506 74.031 74.032C719.221 195.254 728 231.962 728 272a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-28.326-5.938-53.154-17.077-73.531-10.625-19.437-25.955-34.767-45.392-45.392C573.154 141.937 548.326 136 520 136h-16c-28.326 0-53.154 5.938-73.531 17.077-19.437 10.625-34.767 25.955-45.392 45.392C373.937 218.846 368 243.674 368 272z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M308 412v268c0 36.779 9.678 71.962 27.805 102.907a205.39 205.39 0 0 0 73.288 73.288C440.038 874.322 475.22 884 512 884c36.779 0 71.962-9.678 102.907-27.805a205.39 205.39 0 0 0 73.288-73.288C706.322 751.962 716 716.78 716 680V412H308z",
                    "fill": "#E6E6E6"
                }
            }
        ]
    })(props);
}
function AiTwotoneBuild(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M144 546h200v200H144zm268-268h200v200H412z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zM344 746H144V546h200v200zm268 0H412V546h200v200zm0-268H412V278h200v200zm268 0H680V278h200v200z"
                }
            }
        ]
    })(props);
}
function AiTwotoneBulb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M512 136c-141.4 0-256 114.6-256 256 0 92.5 49.4 176.3 128.1 221.8l35.9 20.8V752h184V634.6l35.9-20.8C718.6 568.3 768 484.5 768 392c0-141.4-114.6-256-256-256z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M632 888H392c-4.4 0-8 3.6-8 8v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1V792c0 17.7 14.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328zm127.9 549.8L604 634.6V752H420V634.6l-35.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4 114.6-256 256-256s256 114.6 256 256c0 92.5-49.4 176.3-128.1 221.8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCalculator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm256.2-75h-50.8c-2.2 0-4.5-1.1-5.9-2.9L348 718.6l-35.5 43.5a7.38 7.38 0 0 1-5.9 2.9h-50.8c-6.6 0-10.2-7.9-5.8-13.1l62.7-76.8-61.2-74.9c-4.3-5.2-.7-13.1 5.9-13.1h50.9c2.2 0 4.5 1.1 5.9 2.9l34 41.6 34-41.6c1.5-1.9 3.6-2.9 5.9-2.9h50.8c6.6 0 10.2 7.9 5.9 13.1L383.5 675l62.7 76.8c4.2 5.3.6 13.2-6 13.2zM576 335c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zm0 265c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zm0 104c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zM248 335c0-2.2 1.4-4 3.2-4H320v-68.8c0-1.8 1.8-3.2 4-3.2h48c2.2 0 4 1.4 4 3.2V331h68.7c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H376v68.7c0 1.9-1.8 3.3-4 3.3h-48c-2.2 0-4-1.4-4-3.2V387h-68.8c-1.8 0-3.2-1.8-3.2-4v-48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M383.5 675l61.3-74.8c4.3-5.2.7-13.1-5.9-13.1h-50.8c-2.3 0-4.4 1-5.9 2.9l-34 41.6-34-41.6a7.69 7.69 0 0 0-5.9-2.9h-50.9c-6.6 0-10.2 7.9-5.9 13.1l61.2 74.9-62.7 76.8c-4.4 5.2-.8 13.1 5.8 13.1h50.8c2.3 0 4.4-1 5.9-2.9l35.5-43.5 35.5 43.5c1.4 1.8 3.7 2.9 5.9 2.9h50.8c6.6 0 10.2-7.9 6-13.2L383.5 675zM251.2 387H320v68.8c0 1.8 1.8 3.2 4 3.2h48c2.2 0 4-1.4 4-3.3V387h68.8c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H376v-68.8c0-1.8-1.8-3.2-4-3.2h-48c-2.2 0-4 1.4-4 3.2V331h-68.8c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm328 369h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0-104h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0-265h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCalendar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v136h656V256H712v48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zm0-448H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M864 320H677.2l-17.1-47.8-22.9-64.2H386.7l-22.9 64.2-17.1 47.8H160c-4.4 0-8 3.6-8 8v456c0 4.4 3.6 8 8 8h704c4.4 0 8-3.6 8-8V328c0-4.4-3.6-8-8-8zM512 704c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 384c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zm0 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M864 248H728l-32.4-90.8a32.07 32.07 0 0 0-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 248H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V328c0-44.2-35.8-80-80-80zm8 536c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V328c0-4.4 3.6-8 8-8h186.7l17.1-47.8 22.9-64.2h250.5l22.9 64.2 17.1 47.8H864c4.4 0 8 3.6 8 8v456z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M199.6 474L184 517v237h656V517l-15.6-43H199.6zM264 621c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm388 75c0 4.4-3.6 8-8 8H380c-4.4 0-8-3.6-8-8v-84c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v36h168v-36c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v84zm108-75c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M720 581a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M959 413.4L935.3 372a8 8 0 0 0-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 0 0-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 0 0-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 0 0 3-10.8zM292.7 218.1l.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220l72.7-199.9zM840 754H184V517l15.6-43h624.8l15.6 43v237z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M224 581a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm420 23h-40c-4.4 0-8 3.6-8 8v36H428v-36c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v84c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-84c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCarryOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v584h656V256H712v48zm-17.5 128.8L481.9 725.5a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.2 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.9-6.6 13-6.6H688c6.5 0 10.3 7.4 6.5 12.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M688 420h-55.2c-5.1 0-10 2.5-13 6.6L468.9 634.4l-64.7-89c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.4 0-12.8-6.5-12.8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCheckCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm193.4 225.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.3 0 19.9 5 25.9 13.3l71.2 98.8 157.2-218c6-8.4 15.7-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.4 12.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0 0 51.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCheckSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm130-367.8h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H688c6.5 0 10.3 7.4 6.5 12.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L307.5 484.9c-3.8-5.3 0-12.7 6.5-12.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M432.2 657.7a31.8 31.8 0 0 0 51.7 0l210.6-292c3.8-5.3 0-12.7-6.5-12.7h-46.9c-10.3 0-19.9 5-25.9 13.3L458 584.3l-71.2-98.8c-6-8.4-15.7-13.3-25.9-13.3H314c-6.5 0-10.3 7.4-6.5 12.7l124.7 172.8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCiCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-63.5 522.8c49.3 0 82.8-29.4 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5C345.4 720 286 651.4 286 537.4v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-3.9-46.1-37.5-77.6-87-77.6-61.1 0-95.6 45.4-95.7 126.8v49.3c0 80.3 34.5 125.2 95.6 125.2zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M730 311.9h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-63.5 522.8c49.3 0 82.8-29.4 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5C345.4 720 286 651.4 286 537.4v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-3.9-46.1-37.5-77.6-87-77.6-61.1 0-95.6 45.4-95.7 126.8v49.3c0 80.3 34.5 125.2 95.6 125.2zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M730 311.9h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneClockCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm176.5 509.7l-28.6 39a7.99 7.99 0 0 1-11.2 1.7L483.3 569.8a7.92 7.92 0 0 1-3.3-6.5V288c0-4.4 3.6-8 8-8h48.1c4.4 0 8 3.6 8 8v247.5l142.6 103.1c3.6 2.5 4.4 7.5 1.8 11.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.3c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.9 11.2-1.7l28.6-39c2.6-3.6 1.8-8.6-1.8-11.1z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCloseCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm171.8 527.1c1.2 1.5 1.9 3.3 1.9 5.2 0 4.5-3.6 8-8 8l-66-.3-99.3-118.4-99.3 118.5-66.1.3c-4.4 0-8-3.6-8-8 0-1.9.7-3.7 1.9-5.2L471 512.3l-130.1-155a8.32 8.32 0 0 1-1.9-5.2c0-4.5 3.6-8 8-8l66.1.3 99.3 118.4 99.4-118.5 66-.3c4.4 0 8 3.6 8 8 0 1.9-.6 3.8-1.8 5.2l-130.1 155 129.9 154.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M685.8 352c0-4.4-3.6-8-8-8l-66 .3-99.4 118.5-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155-130.1 154.9a8.32 8.32 0 0 0-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3 99.3-118.5L611.7 680l66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.9 512.2l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCloseSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm163.9-473.9A7.95 7.95 0 0 1 354 353h58.9c4.7 0 9.2 2.1 12.3 5.7L512 462.2l86.8-103.5c3-3.6 7.5-5.7 12.3-5.7H670c6.8 0 10.5 7.9 6.1 13.1L553.8 512l122.3 145.9c4.4 5.2.7 13.1-6.1 13.1h-58.9c-4.7 0-9.2-2.1-12.3-5.7L512 561.8l-86.8 103.5c-3 3.6-7.5 5.7-12.3 5.7H354c-6.8 0-10.5-7.9-6.1-13.1L470.2 512 347.9 366.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M354 671h58.9c4.8 0 9.3-2.1 12.3-5.7L512 561.8l86.8 103.5c3.1 3.6 7.6 5.7 12.3 5.7H670c6.8 0 10.5-7.9 6.1-13.1L553.8 512l122.3-145.9c4.4-5.2.7-13.1-6.1-13.1h-58.9c-4.8 0-9.3 2.1-12.3 5.7L512 462.2l-86.8-103.5c-3.1-3.6-7.6-5.7-12.3-5.7H354c-6.8 0-10.5 7.9-6.1 13.1L470.2 512 347.9 657.9A7.95 7.95 0 0 0 354 671z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M791.9 492l-37.8-10-13.8-36.5c-8.6-22.7-20.6-44.1-35.7-63.4a245.73 245.73 0 0 0-52.4-49.9c-41.1-28.9-89.5-44.2-140-44.2s-98.9 15.3-140 44.2a245.6 245.6 0 0 0-52.4 49.9 240.47 240.47 0 0 0-35.7 63.4l-13.9 36.6-37.9 9.9a125.7 125.7 0 0 0-66.1 43.7A123.1 123.1 0 0 0 140 612c0 33.1 12.9 64.3 36.3 87.7 23.4 23.4 54.5 36.3 87.6 36.3h496.2c33.1 0 64.2-12.9 87.6-36.3A123.3 123.3 0 0 0 884 612c0-56.2-37.8-105.5-92.1-120z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3zm36.3 281a123.07 123.07 0 0 1-87.6 36.3H263.9c-33.1 0-64.2-12.9-87.6-36.3A123.3 123.3 0 0 1 140 612c0-28 9.1-54.3 26.2-76.3a125.7 125.7 0 0 1 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-12.9 64.3-36.3 87.7z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm339.5-223h185c4.1 0 7.5 3.6 7.5 8v48c0 4.4-3.4 8-7.5 8h-185c-4.1 0-7.5-3.6-7.5-8v-48c0-4.4 3.4-8 7.5-8zM308 610.3c0-2.3 1.1-4.6 2.9-6.1L420.7 512l-109.8-92.2a7.63 7.63 0 0 1-2.9-6.1V351c0-6.8 7.9-10.5 13.1-6.1l192 160.9c3.9 3.2 3.9 9.1 0 12.3l-192 161c-5.2 4.4-13.1.7-13.1-6.1v-62.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M321.1 679.1l192-161c3.9-3.2 3.9-9.1 0-12.3l-192-160.9A7.95 7.95 0 0 0 308 351v62.7c0 2.4 1 4.6 2.9 6.1L420.7 512l-109.8 92.2a8.1 8.1 0 0 0-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1zM516 673c0 4.4 3.4 8 7.5 8h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCompass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM327.6 701.7c-2 .9-4.4 0-5.3-2.1-.4-1-.4-2.2 0-3.2L421 470.9 553.1 603l-225.5 98.7zm375.1-375.1L604 552.1 471.9 420l225.5-98.7c2-.9 4.4 0 5.3 2.1.4 1 .4 2.1 0 3.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M322.3 696.4c-.4 1-.4 2.2 0 3.2.9 2.1 3.3 3 5.3 2.1L553.1 603 421 470.9l-98.7 225.5zm375.1-375.1L471.9 420 604 552.1l98.7-225.5c.4-1.1.4-2.2 0-3.2-.9-2.1-3.3-3-5.3-2.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    })(props);
}
function AiTwotoneContacts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M460.3 526a51.7 52 0 1 0 103.4 0 51.7 52 0 1 0-103.4 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M768 352c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H548v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H328v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H136v496h752V296H768v56zM661 736h-43.8c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 39.9-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5h-43.9a8 8 0 0 1-8-8.4c2.8-53.3 31.9-99.6 74.6-126.1-18.1-20-29.1-46.4-29.1-75.5 0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.6-29.1 75.5 42.7 26.4 71.9 72.8 74.7 126.1a8 8 0 0 1-8 8.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M594.3 601.5a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1 8 8 0 0 0 8 8.4H407c4.2 0 7.6-3.3 7.9-7.5 3.8-50.6 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H661a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.7-126.1zM512 578c-28.5 0-51.7-23.3-51.7-52s23.2-52 51.7-52 51.7 23.3 51.7 52-23.2 52-51.7 52z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z"
                }
            }
        ]
    })(props);
}
function AiTwotoneContainer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M635 771.7c-34.5 28.6-78.2 44.3-123 44.3s-88.5-15.8-123-44.3a194.02 194.02 0 0 1-59.1-84.7H232v201h560V687h-97.9c-11.6 32.8-32 62.3-59.1 84.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M320 501h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V687h97.9c11.6 32.8 32 62.3 59.1 84.7 34.5 28.5 78.2 44.3 123 44.3s88.5-15.7 123-44.3c27.1-22.4 47.5-51.9 59.1-84.7H792v201zm0-264H643.6l-5.2 24.7C626.4 708.5 573.2 752 512 752s-114.4-43.5-126.5-103.3l-5.2-24.7H232V136h560v488z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M320 341h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneControl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M616 440a36 36 0 1 0 72 0 36 36 0 1 0-72 0zM340.4 601.5l1.5 2.4c0 .1.1.1.1.2l.9 1.2c.1.1.2.2.2.3 1 1.3 2 2.5 3.2 3.6l.2.2c.4.4.8.8 1.2 1.1.8.8 1.7 1.5 2.6 2.1h.1l1.2.9c.1.1.3.2.4.3 1.2.8 2.5 1.6 3.9 2.2.2.1.5.2.7.4.4.2.7.3 1.1.5.3.1.7.3 1 .4.5.2 1 .4 1.5.5.4.1.9.3 1.3.4l.9.3 1.4.3c.2.1.5.1.7.2.7.1 1.4.3 2.1.4.2 0 .4 0 .6.1.6.1 1.1.1 1.7.2.2 0 .4 0 .7.1.8 0 1.5.1 2.3.1s1.5 0 2.3-.1c.2 0 .4 0 .7-.1.6 0 1.2-.1 1.7-.2.2 0 .4 0 .6-.1.7-.1 1.4-.2 2.1-.4.2-.1.5-.1.7-.2l1.4-.3.9-.3c.4-.1.9-.3 1.3-.4.5-.2 1-.4 1.5-.5.3-.1.7-.3 1-.4.4-.2.7-.3 1.1-.5.2-.1.5-.2.7-.4 1.3-.7 2.6-1.4 3.9-2.2.1-.1.3-.2.4-.3l1.2-.9h.1c.9-.7 1.8-1.4 2.6-2.1.4-.4.8-.7 1.2-1.1l.2-.2c1.1-1.1 2.2-2.4 3.2-3.6.1-.1.2-.2.2-.3l.9-1.2c0-.1.1-.1.1-.2l1.5-2.4c.1-.2.2-.3.3-.5 2.7-5.1 4.3-10.9 4.3-17s-1.6-12-4.3-17c-.1-.2-.2-.4-.3-.5l-1.5-2.4c0-.1-.1-.1-.1-.2l-.9-1.2c-.1-.1-.2-.2-.2-.3-1-1.3-2-2.5-3.2-3.6l-.2-.2c-.4-.4-.8-.8-1.2-1.1-.8-.8-1.7-1.5-2.6-2.1h-.1l-1.2-.9c-.1-.1-.3-.2-.4-.3-1.2-.8-2.5-1.6-3.9-2.2-.2-.1-.5-.2-.7-.4-.4-.2-.7-.3-1.1-.5-.3-.1-.7-.3-1-.4-.5-.2-1-.4-1.5-.5-.4-.1-.9-.3-1.3-.4l-.9-.3-1.4-.3c-.2-.1-.5-.1-.7-.2-.7-.1-1.4-.3-2.1-.4-.2 0-.4 0-.6-.1-.6-.1-1.1-.1-1.7-.2-.2 0-.4 0-.7-.1-.8 0-1.5-.1-2.3-.1s-1.5 0-2.3.1c-.2 0-.4 0-.7.1-.6 0-1.2.1-1.7.2-.2 0-.4 0-.6.1-.7.1-1.4.2-2.1.4-.2.1-.5.1-.7.2l-1.4.3-.9.3c-.4.1-.9.3-1.3.4-.5.2-1 .4-1.5.5-.3.1-.7.3-1 .4-.4.2-.7.3-1.1.5-.2.1-.5.2-.7.4-1.3.7-2.6 1.4-3.9 2.2-.1.1-.3.2-.4.3l-1.2.9h-.1c-.9.7-1.8 1.4-2.6 2.1-.4.4-.8.7-1.2 1.1l-.2.2a54.8 54.8 0 0 0-3.2 3.6c-.1.1-.2.2-.2.3l-.9 1.2c0 .1-.1.1-.1.2l-1.5 2.4c-.1.2-.2.3-.3.5-2.7 5.1-4.3 10.9-4.3 17s1.6 12 4.3 17c.1.2.2.3.3.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm436.4-499.1c-.2 0-.3.1-.4.1v-77c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v77c-.2 0-.3-.1-.4-.1 42 13.4 72.4 52.7 72.4 99.1 0 46.4-30.4 85.7-72.4 99.1.2 0 .3-.1.4-.1v221c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V539c.2 0 .3.1.4.1-42-13.4-72.4-52.7-72.4-99.1 0-46.4 30.4-85.7 72.4-99.1zM340 485V264c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v221c41.7 13.6 72 52.8 72 99s-30.3 85.5-72 99v77c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-77c-41.7-13.6-72-52.8-72-99s30.3-85.5 72-99z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M340 683v77c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-77c41.7-13.5 72-52.8 72-99s-30.3-85.4-72-99V264c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v221c-41.7 13.5-72 52.8-72 99s30.3 85.4 72 99zm.1-116c.1-.2.2-.3.3-.5l1.5-2.4c0-.1.1-.1.1-.2l.9-1.2c0-.1.1-.2.2-.3 1-1.2 2.1-2.5 3.2-3.6l.2-.2c.4-.4.8-.7 1.2-1.1.8-.7 1.7-1.4 2.6-2.1h.1l1.2-.9c.1-.1.3-.2.4-.3 1.3-.8 2.6-1.5 3.9-2.2.2-.2.5-.3.7-.4.4-.2.7-.3 1.1-.5.3-.1.7-.3 1-.4.5-.1 1-.3 1.5-.5.4-.1.9-.3 1.3-.4l.9-.3 1.4-.3c.2-.1.5-.1.7-.2.7-.2 1.4-.3 2.1-.4.2-.1.4-.1.6-.1.5-.1 1.1-.2 1.7-.2.3-.1.5-.1.7-.1.8-.1 1.5-.1 2.3-.1s1.5.1 2.3.1c.3.1.5.1.7.1.6.1 1.1.1 1.7.2.2.1.4.1.6.1.7.1 1.4.3 2.1.4.2.1.5.1.7.2l1.4.3.9.3c.4.1.9.3 1.3.4.5.1 1 .3 1.5.5.3.1.7.3 1 .4.4.2.7.3 1.1.5.2.2.5.3.7.4 1.4.6 2.7 1.4 3.9 2.2.1.1.3.2.4.3l1.2.9h.1c.9.6 1.8 1.3 2.6 2.1.4.3.8.7 1.2 1.1l.2.2c1.2 1.1 2.2 2.3 3.2 3.6 0 .1.1.2.2.3l.9 1.2c0 .1.1.1.1.2l1.5 2.4A36.03 36.03 0 0 1 408 584c0 6.1-1.6 11.9-4.3 17-.1.2-.2.3-.3.5l-1.5 2.4c0 .1-.1.1-.1.2l-.9 1.2c0 .1-.1.2-.2.3-1 1.2-2.1 2.5-3.2 3.6l-.2.2c-.4.4-.8.7-1.2 1.1-.8.7-1.7 1.4-2.6 2.1h-.1l-1.2.9c-.1.1-.3.2-.4.3-1.3.8-2.6 1.5-3.9 2.2-.2.2-.5.3-.7.4-.4.2-.7.3-1.1.5-.3.1-.7.3-1 .4-.5.1-1 .3-1.5.5-.4.1-.9.3-1.3.4l-.9.3-1.4.3c-.2.1-.5.1-.7.2-.7.2-1.4.3-2.1.4-.2.1-.4.1-.6.1-.5.1-1.1.2-1.7.2-.3.1-.5.1-.7.1-.8.1-1.5.1-2.3.1s-1.5-.1-2.3-.1c-.3-.1-.5-.1-.7-.1-.6-.1-1.1-.1-1.7-.2-.2-.1-.4-.1-.6-.1-.7-.1-1.4-.3-2.1-.4-.2-.1-.5-.1-.7-.2l-1.4-.3-.9-.3c-.4-.1-.9-.3-1.3-.4-.5-.1-1-.3-1.5-.5-.3-.1-.7-.3-1-.4-.4-.2-.7-.3-1.1-.5-.2-.2-.5-.3-.7-.4-1.4-.6-2.7-1.4-3.9-2.2-.1-.1-.3-.2-.4-.3l-1.2-.9h-.1c-.9-.6-1.8-1.3-2.6-2.1-.4-.3-.8-.7-1.2-1.1l-.2-.2c-1.2-1.1-2.2-2.3-3.2-3.6 0-.1-.1-.2-.2-.3l-.9-1.2c0-.1-.1-.1-.1-.2l-1.5-2.4c-.1-.2-.2-.3-.3-.5-2.7-5-4.3-10.9-4.3-17s1.6-11.9 4.3-17zm280.3-27.9c-.1 0-.2-.1-.4-.1v221c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V539c-.1 0-.2.1-.4.1 42-13.4 72.4-52.7 72.4-99.1 0-46.4-30.4-85.7-72.4-99.1.1 0 .2.1.4.1v-77c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v77c.1 0 .2-.1.4-.1-42 13.4-72.4 52.7-72.4 99.1 0 46.4 30.4 85.7 72.4 99.1zM652 404c19.9 0 36 16.1 36 36s-16.1 36-36 36-36-16.1-36-36 16.1-36 36-36z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M232 706h142c22.1 0 40 17.9 40 40v142h250V264H232v442z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCopyrightCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm5.5 533c52.9 0 88.8-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4C407.4 734 344 660.8 344 539.1v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.7-3.2-8-7.4-4-49.6-40-83.4-93-83.4-65.2 0-102.1 48.5-102.2 135.5v52.6c0 85.7 36.8 133.6 102.1 133.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M517.6 351.3c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCopyright(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm5.5 533c52.9 0 88.8-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4C407.4 734 344 660.8 344 539.1v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.7-3.2-8-7.4-4-49.6-40-83.4-93-83.4-65.2 0-102.1 48.5-102.2 135.5v52.6c0 85.7 36.8 133.6 102.1 133.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M517.6 351.3c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCreditCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M136 792h752V440H136v352zm507-144c0-4.4 3.6-8 8-8h165c4.4 0 8 3.6 8 8v72c0 4.4-3.6 8-8 8H651c-4.4 0-8-3.6-8-8v-72zM136 232h752v120H136z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M651 728h165c4.4 0 8-3.6 8-8v-72c0-4.4-3.6-8-8-8H651c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V440h752v352zm0-440H136V232h752v120z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M911.9 283.9v.5L835.5 865c-1 8-7.9 14-15.9 14H204.5c-8.1 0-14.9-6.1-16-14l-76.4-580.6v-.6 1.6L188.5 866c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.1-.5.1-1 0-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M773.6 810.6l53.9-409.4-139.8 86.1L512 252.9 336.3 487.3l-139.8-86.1 53.8 409.4h523.3zm-374.2-189c0-62.1 50.5-112.6 112.6-112.6s112.6 50.5 112.6 112.6v1c0 62.1-50.5 112.6-112.6 112.6s-112.6-50.5-112.6-112.6v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 734.2c61.9 0 112.3-50.2 112.6-112.1v-.5c0-62.1-50.5-112.6-112.6-112.6s-112.6 50.5-112.6 112.6v.5c.3 61.9 50.7 112.1 112.6 112.1zm0-160.9c26.6 0 48.2 21.6 48.2 48.3 0 26.6-21.6 48.3-48.2 48.3s-48.2-21.6-48.2-48.3c0-26.6 21.6-48.3 48.2-48.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6v-.5c.3-6.4-6.7-10.8-12.3-7.4L705 396.4 518.4 147.5a8.06 8.06 0 0 0-12.9 0L319 396.4 124.3 276.5c-5.5-3.4-12.6.9-12.2 7.3v.6L188.5 865zm147.8-377.7L512 252.9l175.7 234.4 139.8-86.1-53.9 409.4H250.3l-53.8-409.4 139.8 86.1z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCustomerService(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M696 632h128v192H696zm-496 0h128v192H200z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384zM328 632v192H200V632h128zm496 192H696V632h128v192z"
                }
            }
        ]
    })(props);
}
function AiTwotoneDashboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M512 188c-99.3 0-192.7 38.7-263 109-70.3 70.2-109 163.6-109 263 0 105.6 44.5 205.5 122.6 276h498.8A371.12 371.12 0 0 0 884 560c0-99.3-38.7-192.7-109-263-70.2-70.3-163.6-109-263-109zm-30 44c0-4.4 3.6-8 8-8h44c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8h-44c-4.4 0-8-3.6-8-8v-80zM270 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44zm90.7-204.4l-31.1 31.1a8.03 8.03 0 0 1-11.3 0l-56.6-56.6a8.03 8.03 0 0 1 0-11.3l31.1-31.1c3.1-3.1 8.2-3.1 11.3 0l56.6 56.6c3.1 3.1 3.1 8.2 0 11.3zm291.1 83.5l-84.5 84.5c5 18.7.2 39.4-14.5 54.1a55.95 55.95 0 0 1-79.2 0 55.95 55.95 0 0 1 0-79.2 55.87 55.87 0 0 1 54.1-14.5l84.5-84.5c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3c3.1 3.1 3.1 8.2 0 11.3zm43-52.4l-31.1-31.1a8.03 8.03 0 0 1 0-11.3l56.6-56.6c3.1-3.1 8.2-3.1 11.3 0l31.1 31.1c3.1 3.1 3.1 8.2 0 11.3l-56.6 56.6a8.03 8.03 0 0 1-11.3 0zM846 538v44c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M623.5 421.5a8.03 8.03 0 0 0-11.3 0L527.7 506c-18.7-5-39.4-.2-54.1 14.5a55.95 55.95 0 0 0 0 79.2 55.95 55.95 0 0 0 79.2 0 55.87 55.87 0 0 0 14.5-54.1l84.5-84.5c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3zM490 320h44c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-44c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M924.8 385.6a446.7 446.7 0 0 0-96-142.4 446.7 446.7 0 0 0-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 0 0-142.4 96 446.7 446.7 0 0 0-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM761.4 836H262.6A371.12 371.12 0 0 1 140 560c0-99.4 38.7-192.8 109-263 70.3-70.3 163.7-109 263-109 99.4 0 192.8 38.7 263 109 70.3 70.3 109 163.7 109 263 0 105.6-44.5 205.5-122.6 276z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M762.7 340.8l-31.1-31.1a8.03 8.03 0 0 0-11.3 0l-56.6 56.6a8.03 8.03 0 0 0 0 11.3l31.1 31.1c3.1 3.1 8.2 3.1 11.3 0l56.6-56.6c3.1-3.1 3.1-8.2 0-11.3zM750 538v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zM304.1 309.7a8.03 8.03 0 0 0-11.3 0l-31.1 31.1a8.03 8.03 0 0 0 0 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0l31.1-31.1c3.1-3.1 3.1-8.2 0-11.3l-56.6-56.6zM262 530h-80c-4.4 0-8 3.6-8 8v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneDatabase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D8D8D8",
                    "d": "M232 616h560V408H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 888h560V680H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 344h560V136H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M304 512a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 272a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0-544a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V680h560v208zm0-272H232V408h560v208zm0-272H232V136h560v208z"
                }
            }
        ]
    })(props);
}
function AiTwotoneDelete(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M292.7 840h438.6l24.2-512h-487z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M864 256H736v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zm-504-72h304v72H360v-72zm371.3 656H292.7l-24.2-512h487l-24.2 512z"
                }
            }
        ]
    })(props);
}
function AiTwotoneDiff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M232 264v624h432V413.8L514.2 264H232zm336 489c0 3.8-3.4 7-7.5 7h-225c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7h225c4.1 0 7.5 3.2 7.5 7v42zm0-262v42c0 3.8-3.4 7-7.5 7H476v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V540h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H420v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1V484h84.5c4.1 0 7.5 3.1 7.5 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.2 306.6L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M553.4 201.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM664 888H232V264h282.2L664 413.8V888z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M476 399.1c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1V484h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H420v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V540h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H476v-84.9zM560.5 704h-225c-4.1 0-7.5 3.2-7.5 7v42c0 3.8 3.4 7 7.5 7h225c4.1 0 7.5-3.2 7.5-7v-42c0-3.8-3.4-7-7.5-7z"
                }
            }
        ]
    })(props);
}
function AiTwotoneDislike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M273 100.1v428h.3l-.3-428zM820.4 525l-21.9-19 14-25.5a56.2 56.2 0 0 0 6.9-27.3c0-16.5-7.1-32.2-19.6-43l-21.9-19 13.9-25.4a56.2 56.2 0 0 0 6.9-27.3c0-16.5-7.1-32.2-19.6-43l-21.9-19 13.9-25.4a56.2 56.2 0 0 0 6.9-27.3c0-22.4-13.2-42.6-33.6-51.8H345v345.2c18.6 67.2 46.4 168 83.5 302.5a44.28 44.28 0 0 0 42.2 32.3c7.5.1 15-2.2 21.1-6.7 9.9-7.4 15.2-18.6 14.6-30.5l-9.6-198.4h314.4C829 605.5 840 587.1 840 568c0-16.5-7.1-32.2-19.6-43z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32zm773.9 358.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 0 0-26.5-5.4H273l.3 428 85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zm-74.7 126.1H496.8l9.6 198.4c.6 11.9-4.7 23.1-14.6 30.5-6.1 4.5-13.6 6.8-21.1 6.7a44.28 44.28 0 0 1-42.2-32.3c-37.1-134.4-64.9-235.2-83.5-302.5V172h399.4a56.85 56.85 0 0 1 33.6 51.8c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-14 25.5 21.9 19a56.76 56.76 0 0 1 19.6 43c0 19.1-11 37.5-28.8 48.4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneDollarCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-37 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.9-.6-5.7-1.3-8.8-2.2V677c42.6-3.8 72-27.3 72-66.4 0-30.7-15.9-50.7-63.2-65.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm22.4 589.2l.2 31.7c0 4.5-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4c-89-6.5-130.7-57.1-135.2-112.1-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.8 29.9 55.4 74.1 61.3V534l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-73 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.8 46.9 125.9 109.2a8.1 8.1 0 0 1-8 8.8h-44.9c-4 0-7.4-2.9-7.9-6.9-4-29.2-27.5-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 109 116.4 0 75.2-56 117.1-134.3 124z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M559.7 488.8l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneDollar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-37 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.9-.6-5.7-1.3-8.8-2.2V677c42.6-3.8 72-27.3 72-66.4 0-30.7-15.9-50.7-63.2-65.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm22.4 589.2l.2 31.7c0 4.5-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4c-89-6.5-130.7-57.1-135.2-112.1-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.8 29.9 55.4 74.1 61.3V534l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-73 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.8 46.9 125.9 109.2a8.1 8.1 0 0 1-8 8.8h-44.9c-4 0-7.4-2.9-7.9-6.9-4-29.2-27.5-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 109 116.4 0 75.2-56 117.1-134.3 124z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M559.7 488.8l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneDownCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm184.4 277.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.3 0 19.9 4.9 25.9 13.2L512 563.6l105.2-145.4c6-8.3 15.7-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.4 12.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M690 405h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 563.6 406.8 418.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7z"
                }
            }
        ]
    })(props);
}
function AiTwotoneDownSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm150-440h46.9c10.3 0 19.9 4.9 25.9 13.2L512 558.6l105.2-145.4c6-8.3 15.7-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.4 12.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M505.5 658.7c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 558.6 406.8 413.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246z"
                }
            }
        ]
    })(props);
}
function AiTwotoneEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M761.1 288.3L687.8 215 325.1 577.6l-15.6 89 88.9-15.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89z"
                }
            }
        ]
    })(props);
}
function AiTwotoneEnvironment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M724.4 224.9C667.7 169.5 592.3 139 512 139s-155.7 30.5-212.4 85.8C243.1 280 212 353.2 212 431.1c0 241.3 234.1 407.2 300 449.1 65.9-41.9 300-207.8 300-449.1 0-77.9-31.1-151.1-87.6-206.2zM512 615c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 263c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 0 1 512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8S624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 289.1a362.49 362.49 0 0 0-79.9-115.7 370.83 370.83 0 0 0-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 0 0 169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0 0 22.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1z"
                }
            }
        ]
    })(props);
}
function AiTwotoneEuroCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm117.1 581.1c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.4 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.7.3-12.8H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.8C388.5 345.7 460.7 290 567.4 290c20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346a8 8 0 0 1-9.6 7.8c-14.6-2.9-31.8-4.4-51.7-4.4-65.3 0-110.4 33.5-127.6 90.4h128.3c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8H432.5c-.3 4.4-.3 9.1-.3 13.8v36h136.4c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H438c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.3 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M619.6 670.5c-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H432.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H440.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 0 0 9.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H337c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H337c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneEuro(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm117.1 581.1c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.4 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.7.3-12.8H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.8C388.5 345.7 460.7 290 567.4 290c20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346a8 8 0 0 1-9.6 7.8c-14.6-2.9-31.8-4.4-51.7-4.4-65.3 0-110.4 33.5-127.6 90.4h128.3c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8H432.5c-.3 4.4-.3 9.1-.3 13.8v36h136.4c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H438c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.3 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M619.6 670.5c-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H432.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H440.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 0 0 9.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H337c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H337c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneExclamationCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-32 156c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M488 576h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8zm-24 112a48 48 0 1 0 96 0 48 48 0 1 0-96 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneExperiment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M551.9 513c19.6 0 35.9-14.2 39.3-32.8A40.02 40.02 0 0 1 552 512a40 40 0 0 1-40-39.4v.5c0 22 17.9 39.9 39.9 39.9zM752 687.8l-.3-.3c-29-17.5-62.3-26.8-97-26.8-44.9 0-87.2 15.7-121 43.8a256.27 256.27 0 0 1-164.9 59.9c-41.2 0-81-9.8-116.7-28L210.5 844h603l-59.9-155.2-1.6-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M879 824.9L696.3 352V178H768v-68H256v68h71.7v174L145 824.9c-2.8 7.4-4.3 15.2-4.3 23.1 0 35.3 28.7 64 64 64h614.6c7.9 0 15.7-1.5 23.1-4.3 33-12.7 49.4-49.8 36.6-82.8zM395.7 364.7V180h232.6v184.7L719.2 600c-20.7-5.3-42.1-8-63.9-8-61.2 0-119.2 21.5-165.3 60a188.78 188.78 0 0 1-121.3 43.9c-32.7 0-64.1-8.3-91.8-23.7l118.8-307.5zM210.5 844l41.6-107.6.1-.2c35.7 18.1 75.4 27.8 116.6 27.8 61.2 0 119.2-21.5 165.3-60 33.9-28.2 76.3-43.9 121.3-43.9 35 0 68.4 9.5 97.6 27.1l.6 1.6L813.5 844h-603z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M552 512c19.3 0 35.4-13.6 39.2-31.8.6-2.7.8-5.4.8-8.2 0-22.1-17.9-40-40-40s-40 17.9-40 40v.6a40 40 0 0 0 40 39.4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneEyeInvisible(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M254.89,758.85,380.46,633.28A176,176,0,0,1,629.28,384.46L757,256.72Q651.69,186.07,512,186,223.7,186,81.8,486.3a60.3,60.3,0,0,0,0,51.5Q151.07,683.71,254.89,758.85Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M942.2,486.2Q889.46,375.11,816.7,305L672.48,449.27A176.09,176.09,0,0,1,445.26,676.48L323,798.75Q408,838,512,838q288.3,0,430.2-300.3A60.29,60.29,0,0,0,942.2,486.2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M942.2,486.2Q889.47,375.11,816.7,305l-50.88,50.88C807.31,395.53,843.45,447.4,874.7,512,791.5,684.2,673.4,766,512,766q-72.67,0-133.87-22.38L323,798.75Q408,838,512,838q288.3,0,430.2-300.3A60.29,60.29,0,0,0,942.2,486.2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M878.63,165.56,836,122.88a8,8,0,0,0-11.32,0L715.31,232.2Q624.86,186,512,186,223.7,186,81.8,486.3a60.3,60.3,0,0,0,0,51.5q56.69,119.4,136.5,191.41L112.48,835a8,8,0,0,0,0,11.31L155.17,889a8,8,0,0,0,11.31,0L878.63,176.88A8,8,0,0,0,878.63,165.56ZM149.3,512C232.6,339.8,350.7,258,512,258c54.54,0,104.13,9.36,149.12,28.39l-70.3,70.3A176,176,0,0,0,352.69,594.82l-83.42,83.42C223.1,637.49,183.3,582.28,149.3,512ZM396,512A112.11,112.11,0,0,1,542.2,405.31L401.31,546.2A112,112,0,0,1,396,512Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M508,624c-3.46,0-6.87-.16-10.25-.47l-52.82,52.82A176.09,176.09,0,0,0,672.35,448.93l-52.82,52.82c.31,3.38.47,6.79.47,10.25A111.94,111.94,0,0,1,508,624Z"
                }
            }
        ]
    })(props);
}
function AiTwotoneEye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M81.8 537.8a60.3 60.3 0 0 1 0-51.5C176.6 286.5 319.8 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c-192.1 0-335.4-100.5-430.2-300.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M512 258c-161.3 0-279.4 81.8-362.7 254C232.6 684.2 350.7 766 512 766c161.4 0 279.5-81.8 362.7-254C791.4 339.8 673.3 258 512 258zm-4 430c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258s279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M508 336c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFileAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm126 236v48c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V644H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V472c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M544 472c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V472z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFileExcel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm51.6 120h35.7a12.04 12.04 0 0 1 10.1 18.5L546.1 623l84 130.4c3.6 5.6 2 13-3.6 16.6-2 1.2-4.2 1.9-6.5 1.9h-37.5c-4.1 0-8-2.1-10.2-5.7L510 664.8l-62.7 101.5c-2.2 3.5-6 5.7-10.2 5.7h-34.5a12.04 12.04 0 0 1-10.2-18.4l83.4-132.8-82.3-130.4c-3.6-5.7-1.9-13.1 3.7-16.6 1.9-1.3 4.1-1.9 6.4-1.9H442c4.2 0 8.1 2.2 10.3 5.8l61.8 102.4 61.2-102.3c2.2-3.6 6.1-5.8 10.3-5.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0 0 10.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 0 0-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFileExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-54 96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V448zm32 336c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M488 640h48c4.4 0 8-3.6 8-8V448c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm-16 104a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFileImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-134 50c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm296 294H328.1c-6.7 0-10.4-7.7-6.3-12.9l99.8-127.2a8 8 0 0 1 12.6 0l41.1 52.4 77.8-99.2a8.1 8.1 0 0 1 12.7 0l136.5 174c4.1 5.2.4 12.9-6.3 12.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M553.1 509.1l-77.8 99.2-41.1-52.4a8 8 0 0 0-12.6 0l-99.8 127.2a7.98 7.98 0 0 0 6.3 12.9H696c6.7 0 10.4-7.7 6.3-12.9l-136.5-174a8.1 8.1 0 0 0-12.7 0zM360 442a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFileMarkdown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm72.3 122H641c6.6 0 12 5.4 12 12v272c0 6.6-5.4 12-12 12h-27.2c-6.6 0-12-5.4-12-12V581.7L535 732.3c-2 4.3-6.3 7.1-11 7.1h-24.1a12 12 0 0 1-11-7.1l-66.8-150.2V758c0 6.6-5.4 12-12 12H383c-6.6 0-12-5.4-12-12V486c0-6.6 5.4-12 12-12h35c4.8 0 9.1 2.8 11 7.2l83.2 191 83.1-191c1.9-4.4 6.2-7.2 11-7.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M429 481.2c-1.9-4.4-6.2-7.2-11-7.2h-35c-6.6 0-12 5.4-12 12v272c0 6.6 5.4 12 12 12h27.1c6.6 0 12-5.4 12-12V582.1l66.8 150.2a12 12 0 0 0 11 7.1H524c4.7 0 9-2.8 11-7.1l66.8-150.6V758c0 6.6 5.4 12 12 12H641c6.6 0 12-5.4 12-12V486c0-6.6-5.4-12-12-12h-34.7c-4.8 0-9.1 2.8-11 7.2l-83.1 191-83.2-191z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFilePdf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M509.2 490.8c-.7-1.3-1.4-1.9-2.2-2-2.9 3.3-2.2 31.5 2.7 51.4 4-13.6 4.7-40.5-.5-49.4zm-1.6 120.5c-7.7 20-18.8 47.3-32.1 71.4 4-1.6 8.1-3.3 12.3-5 17.6-7.2 37.3-15.3 58.9-20.2-14.9-11.8-28.4-27.7-39.1-46.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm55 287.6c16.1-1.9 30.6-2.8 44.3-2.3 12.8.4 23.6 2 32 5.1.2.1.3.1.5.2.4.2.8.3 1.2.5.5.2 1.1.4 1.6.7.1.1.3.1.4.2 4.1 1.8 7.5 4 10.1 6.6 9.1 9.1 11.8 26.1 6.2 39.6-3.2 7.7-11.7 20.5-33.3 20.5-21.8 0-53.9-9.7-82.1-24.8-25.5 4.3-53.7 13.9-80.9 23.1-5.8 2-11.8 4-17.6 5.9-38 65.2-66.5 79.4-84.1 79.4-4.2 0-7.8-.9-10.8-2-6.9-2.6-12.8-8-16.5-15-.9-1.7-1.6-3.4-2.2-5.2-1.6-4.8-2.1-9.6-1.3-13.6l.6-2.7c.1-.2.1-.4.2-.6.2-.7.4-1.4.7-2.1 0-.1.1-.2.1-.3 4.1-11.9 13.6-23.4 27.7-34.6 12.3-9.8 27.1-18.7 45.9-28.4 15.9-28 37.6-75.1 51.2-107.4-10.8-41.8-16.7-74.6-10.1-98.6.9-3.3 2.5-6.4 4.6-9.1.2-.2.3-.4.5-.6.1-.1.1-.2.2-.2 6.3-7.5 16.9-11.9 28.1-11.5 16.6.7 29.7 11.5 33 30.1 1.7 8 2.2 16.5 1.9 25.7v.7c0 .5 0 1-.1 1.5-.7 13.3-3 26.6-7.3 44.7-.4 1.6-.8 3.2-1.2 5.2l-1 4.1-.1.3c.1.2.1.3.2.5l1.8 4.5c.1.3.3.7.4 1 .7 1.6 1.4 3.3 2.1 4.8v.1c8.7 18.8 19.7 33.4 33.9 45.1 4.3 3.5 8.9 6.7 13.9 9.8 1.8-.5 3.5-.7 5.3-.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M391.5 761c5.7-4.4 16.2-14.5 30.1-34.7-10.3 9.4-23.4 22.4-30.1 34.7zm270.9-83l.2-.3h.2c.6-.4.5-.7.4-.9-.1-.1-4.5-9.3-45.1-7.4 35.3 13.9 43.5 9.1 44.3 8.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M535.9 585.3c-.8-1.7-1.5-3.3-2.2-4.9-.1-.3-.3-.7-.4-1l-1.8-4.5c-.1-.2-.1-.3-.2-.5l.1-.3.2-1.1c4-16.3 8.6-35.3 9.4-54.4v-.7c.3-8.6-.2-17.2-2-25.6-3.8-21.3-19.5-29.6-32.9-30.2-11.3-.5-21.8 4-28.1 11.4-.1.1-.1.2-.2.2-.2.2-.4.4-.5.6-2.1 2.7-3.7 5.8-4.6 9.1-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.4-51.2 107.4v.1c-27.7 14.3-64.1 35.8-73.6 62.9 0 .1-.1.2-.1.3-.2.7-.5 1.4-.7 2.1-.1.2-.1.4-.2.6-.2.9-.5 1.8-.6 2.7-.9 4-.4 8.8 1.3 13.6.6 1.8 1.3 3.5 2.2 5.2 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-2.6-2.6-6-4.8-10.1-6.6-.1-.1-.3-.1-.4-.2-.5-.2-1.1-.4-1.6-.7-.4-.2-.8-.3-1.2-.5-.2-.1-.3-.1-.5-.2-16.2-5.8-41.7-6.7-76.3-2.8l-5.3.6c-5-3-9.6-6.3-13.9-9.8-14.2-11.3-25.1-25.8-33.8-44.7zM391.5 761c6.7-12.3 19.8-25.3 30.1-34.7-13.9 20.2-24.4 30.3-30.1 34.7zM507 488.8c.8.1 1.5.7 2.2 2 5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4zm-19.2 188.9c-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4 10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2zm175.4-.9c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFilePpt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M464.5 516.2v108.4h38.9c44.7 0 71.2-10.9 71.2-54.3 0-34.4-20.1-54.1-53.9-54.1h-56.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm90 218.4c0 55.2-36.8 94.1-96.2 94.1h-63.3V760c0 4.4-3.6 8-8 8H424c-4.4 0-8-3.6-8-8V484c0-4.4 3.6-8 8-8v.1h104c59.7 0 96 39.8 96 94.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M424 476.1c-4.4-.1-8 3.5-8 7.9v276c0 4.4 3.6 8 8 8h32.5c4.4 0 8-3.6 8-8v-95.5h63.3c59.4 0 96.2-38.9 96.2-94.1 0-54.5-36.3-94.3-96-94.3H424zm150.6 94.2c0 43.4-26.5 54.3-71.2 54.3h-38.9V516.2h56.2c33.8 0 53.9 19.7 53.9 54.1z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFileText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-22 322c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm200-184v48c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8zm192 128H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFileUnknown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-22 424c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm110-228.4c.7 44.9-29.7 84.5-74.3 98.9-5.7 1.8-9.7 7.3-9.7 13.3V672c0 5.5-4.5 10-10 10h-32c-5.5 0-10-4.5-10-10v-32c.2-19.8 15.4-37.3 34.7-40.1C549 596.2 570 574.3 570 549c0-28.1-25.8-51.5-58-51.5s-58 23.4-58 51.6c0 5.2-4.4 9.4-9.8 9.4h-32.4c-5.4 0-9.8-4.1-9.8-9.5 0-57.4 50.1-103.7 111.5-103 59.3.8 107.7 46.1 108.5 101.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M480 744a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm-78-195c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFileWord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm101.3 129.3c1.3-5.4 6.1-9.3 11.7-9.3h35.6a12.04 12.04 0 0 1 11.6 15.1l-74.4 276c-1.4 5.3-6.2 8.9-11.6 8.9h-31.8c-5.4 0-10.2-3.7-11.6-8.9l-52.8-197-52.8 197c-1.4 5.3-6.2 8.9-11.6 8.9h-32c-5.4 0-10.2-3.7-11.6-8.9l-74.2-276a12.02 12.02 0 0 1 11.6-15.1h35.4c5.6 0 10.4 3.9 11.7 9.3L434.6 680l49.7-198.9c1.3-5.4 6.1-9.1 11.6-9.1h32.2c5.5 0 10.3 3.7 11.6 9.1l49.8 199.3 45.8-199.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M528.1 472h-32.2c-5.5 0-10.3 3.7-11.6 9.1L434.6 680l-46.1-198.7c-1.3-5.4-6.1-9.3-11.7-9.3h-35.4a12.02 12.02 0 0 0-11.6 15.1l74.2 276c1.4 5.2 6.2 8.9 11.6 8.9h32c5.4 0 10.2-3.6 11.6-8.9l52.8-197 52.8 197c1.4 5.2 6.2 8.9 11.6 8.9h31.8c5.4 0 10.2-3.6 11.6-8.9l74.4-276a12.04 12.04 0 0 0-11.6-15.1H647c-5.6 0-10.4 3.9-11.7 9.3l-45.8 199.1-49.8-199.3c-1.3-5.4-6.1-9.1-11.6-9.1z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFileZip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M344 630h32v2h-32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H360v64h64v64h-64v64h64v64h-64v64h64v64h-64v62h64v160H296V520h64v-64h-64v-64h64v-64h-64v-64h64v-64h-64v-64h-64v752h560V394H576a42 42 0 0 1-42-42z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h64v64h64v-64h174v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M296 392h64v64h-64zm0-128h64v64h-64zm0 318v160h128V582h-64v-62h-64v62zm48 50v-2h32v64h-32v-62zm16-432h64v64h-64zm0 256h64v64h-64zm0-128h64v64h-64z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFilter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M420.6 798h182.9V642H420.6zM411 561.4l9.5 16.6h183l9.5-16.6L811.3 226H212.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.5 798H420.6V642h182.9v156zm9.5-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFire(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M737 438.6c-9.6 15.5-21.1 30.7-34.4 45.6a73.1 73.1 0 0 1-51 24.4 73.36 73.36 0 0 1-53.4-18.8 74.01 74.01 0 0 1-24.4-59.8c3-47.4-12.4-103.1-45.8-165.7-16.9-31.4-37.1-58.2-61.2-80.4a240 240 0 0 1-12.1 46.5 354.26 354.26 0 0 1-58.2 101 349.6 349.6 0 0 1-58.6 56.8c-34 26.1-62 60-80.8 97.9a275.96 275.96 0 0 0-29.1 124c0 74.9 29.5 145.3 83 198.4 53.7 53.2 125 82.4 201 82.4s147.3-29.2 201-82.4c53.5-53 83-123.5 83-198.4 0-39.2-8.1-77.3-24-113.1-9.3-21-21-40.5-35-58.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M834.1 469.2A347.49 347.49 0 0 0 751.2 354l-29.1-26.7a8.09 8.09 0 0 0-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 0 1-47.5 46.1 352.6 352.6 0 0 0-100.3 121.5A347.75 347.75 0 0 0 160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0 0 75.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 0 0 760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0 0 27.7-136c0-48.8-10-96.2-29.9-140.9zM713 808.5c-53.7 53.2-125 82.4-201 82.4s-147.3-29.2-201-82.4c-53.5-53.1-83-123.5-83-198.4 0-43.5 9.8-85.2 29.1-124 18.8-37.9 46.8-71.8 80.8-97.9a349.6 349.6 0 0 0 58.6-56.8c25-30.5 44.6-64.5 58.2-101a240 240 0 0 0 12.1-46.5c24.1 22.2 44.3 49 61.2 80.4 33.4 62.6 48.8 118.3 45.8 165.7a74.01 74.01 0 0 0 24.4 59.8 73.36 73.36 0 0 0 53.4 18.8c19.7-1 37.8-9.7 51-24.4 13.3-14.9 24.8-30.1 34.4-45.6 14 17.9 25.7 37.4 35 58.4 15.9 35.8 24 73.9 24 113.1 0 74.9-29.5 145.4-83 198.4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M184 232h368v336H184z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M624 632c0 4.4-3.6 8-8 8H504v73h336V377H624v255z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32zM184 568V232h368v336H184zm656 145H504v-73h112c4.4 0 8-3.6 8-8V377h216v336z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFolderAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M372.5 256H184v512h656V370.4H492.1L372.5 256zM540 443.1V528h84.5c4.1 0 7.5 3.1 7.5 7v42c0 3.8-3.4 7-7.5 7H540v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V584h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H484v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M484 443.1V528h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H484v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V584h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H540v-84.9c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFolderOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M159 768h612.3l103.4-256H262.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M372.5 256H184v512h656V370.4H492.1z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm376 272h-48.1c-4.2 0-7.8-3.2-8.1-7.4C604 636.1 562.5 597 512 597s-92.1 39.1-95.8 88.6c-.3 4.2-3.9 7.4-8.1 7.4H360a8 8 0 0 1-8-8.4c4.4-84.3 74.5-151.6 160-151.6s155.6 67.3 160 151.6a8 8 0 0 1-8 8.4zm24-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm224 112c-85.5 0-155.6 67.3-160 151.6a8 8 0 0 0 8 8.4h48.1c4.2 0 7.8-3.2 8.1-7.4 3.7-49.5 45.3-88.6 95.8-88.6s92 39.1 95.8 88.6c.3 4.2 3.9 7.4 8.1 7.4H664a8 8 0 0 0 8-8.4C667.6 600.3 597.5 533 512 533zm128-112a48 48 0 1 0 96 0 48 48 0 1 0-96 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFund(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M136 792h752V232H136v560zm56.4-130.5l214.9-215c3.1-3.1 8.2-3.1 11.3 0L533 561l254.5-254.6c3.1-3.1 8.2-3.1 11.3 0l36.8 36.8c3.1 3.1 3.1 8.2 0 11.3l-297 297.2a8.03 8.03 0 0 1-11.3 0L412.9 537.2 240.4 709.7a8.03 8.03 0 0 1-11.3 0l-36.7-36.9a8.03 8.03 0 0 1 0-11.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M229.1 709.7c3.1 3.1 8.2 3.1 11.3 0l172.5-172.5 114.4 114.5c3.1 3.1 8.2 3.1 11.3 0l297-297.2c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 0 0-11.3 0L533 561 418.6 446.5a8.03 8.03 0 0 0-11.3 0l-214.9 215a8.03 8.03 0 0 0 0 11.3l36.7 36.9z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFunnelPlot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M420.6 798h182.9V650H420.6zM297.7 374h428.6l85-148H212.7zm113.2 197.4l8.4 14.6h185.3l8.4-14.6L689.6 438H334.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 607.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V607.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.5 798H420.6V650h182.9v148zm9.5-226.6l-8.4 14.6H419.3l-8.4-14.6L334.4 438h355.2L613 571.4zM726.3 374H297.7l-85-148h598.6l-85 148z"
                }
            }
        ]
    })(props);
}
function AiTwotoneGift(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M546 378h298v104H546zM228 550h250v308H228zm-48-172h298v104H180zm366 172h250v308H546z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 310H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v200c0 4.4 3.6 8 8 8h40v344c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V550h40c4.4 0 8-3.6 8-8V342c0-17.7-14.3-32-32-32zM478 858H228V550h250v308zm0-376H180V378h298v104zm0-176h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70 70 31.4 70 70v70zm68-70c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70h-70v-70zm250 622H546V550h250v308zm48-376H546V378h298v104z"
                }
            }
        ]
    })(props);
}
function AiTwotoneGold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M435.7 558.7c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM196.5 748l20.7-128h159.5l20.7 128H196.5zm709.4 58.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zM626.5 748l20.7-128h159.5l20.7 128H626.5zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8zm91.2-196h159.5l20.7 128h-201l20.8-128z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M592.7 276H433.2l-20.8 128h201zM217.2 620l-20.7 128h200.9l-20.7-128zm430 0l-20.7 128h200.9l-20.7-128z"
                }
            }
        ]
    })(props);
}
function AiTwotoneHdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M232 888h560V680H232v208zm448-140c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 616h560V408H232v208zm72-128c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8v-48zm-72-144h560V136H232v208zm72-128c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8v-48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V680h560v208zm0-272H232V408h560v208zm0-272H232V136h560v208z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M312 544h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-272h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm328 516a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M679.7 201c-73.1 0-136.5 40.8-167.7 100.4C480.8 241.8 417.4 201 344.3 201c-104 0-188.3 82.6-188.3 184.5 0 201.2 356 429.3 356 429.3s356-228.1 356-429.3C868 283.6 783.7 201 679.7 201z"
                }
            }
        ]
    })(props);
}
function AiTwotoneHighlight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M229.6 796.3h160.2l54.3-54.1-80.1-78.9zm220.7-397.1l262.8 258.9 147.3-145-262.8-259zm-77.1 166.1l171.4 168.9 68.6-67.6-171.4-168.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M957.6 507.5L603.2 158.3a7.9 7.9 0 0 0-11.2 0L353.3 393.5a8.03 8.03 0 0 0-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 0 0-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8v55.2c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6L539 830a7.9 7.9 0 0 0 11.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0 0 11.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2zM389.8 796.3H229.6l134.4-133 80.1 78.9-54.3 54.1zm154.8-62.1L373.2 565.3l68.6-67.6 171.4 168.9-68.6 67.6zm168.5-76.1L450.3 399.2l147.3-145.1 262.8 259-147.3 145z"
                }
            }
        ]
    })(props);
}
function AiTwotoneHome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M512.1 172.6l-370 369.7h96V868H392V640c0-22.1 17.9-40 40-40h160c22.1 0 40 17.9 40 40v228h153.9V542.3H882L535.2 195.7l-23.1-23.1zm434.5 422.9c-6 6-13.1 10.8-20.8 13.9 7.7-3.2 14.8-7.9 20.8-13.9zm-887-34.7c5 30.3 31.4 53.5 63.1 53.5h.9c-31.9 0-58.9-23-64-53.5zm-.9-10.5v-1.9 1.9zm.1-2.6c.1-3.1.5-6.1 1-9.1-.6 2.9-.9 6-1 9.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M951 510c0-.1-.1-.1-.1-.2l-1.8-2.1c-.1-.1-.2-.3-.4-.4-.7-.8-1.5-1.6-2.2-2.4L560.1 118.8l-25.9-25.9a31.5 31.5 0 0 0-44.4 0L77.5 505a63.6 63.6 0 0 0-16 26.6l-.6 2.1-.3 1.1-.3 1.2c-.2.7-.3 1.4-.4 2.1 0 .1 0 .3-.1.4-.6 3-.9 6-1 9.1v3.3c0 .5 0 1 .1 1.5 0 .5 0 .9.1 1.4 0 .5.1 1 .1 1.5 0 .6.1 1.2.2 1.8 0 .3.1.6.1.9l.3 2.5v.1c5.1 30.5 32.2 53.5 64 53.5h42.5V940h691.7V614.3h43.4c8.6 0 16.9-1.7 24.5-4.9s14.7-7.9 20.8-13.9a63.6 63.6 0 0 0 18.7-45.3c0-14.7-5-28.8-14.3-40.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z"
                }
            }
        ]
    })(props);
}
function AiTwotoneHourglass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M512 548c-42.2 0-81.9 16.4-111.7 46.3A156.63 156.63 0 0 0 354 706v134h316V706c0-42.2-16.4-81.9-46.3-111.7A156.63 156.63 0 0 0 512 548zM354 318c0 42.2 16.4 81.9 46.3 111.7C430.1 459.6 469.8 476 512 476s81.9-16.4 111.7-46.3C653.6 399.9 670 360.2 670 318V184H354v134z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194zm-72 388v134H354V706c0-42.2 16.4-81.9 46.3-111.7C430.1 564.4 469.8 548 512 548s81.9 16.4 111.7 46.3C653.6 624.1 670 663.8 670 706zm0-388c0 42.2-16.4 81.9-46.3 111.7C593.9 459.6 554.2 476 512 476s-81.9-16.4-111.7-46.3A156.63 156.63 0 0 1 354 318V184h316v134z"
                }
            }
        ]
    })(props);
}
function AiTwotoneHtml5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M145 96l66 746.6L511.8 928l299.6-85.4L878.7 96H145zm610.9 700.6l-244.1 69.6-245.2-69.6-56.7-641.2h603.8l-57.8 641.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M209.9 155.4l56.7 641.2 245.2 69.6 244.1-69.6 57.8-641.2H209.9zm530.4 117.9l-4.8 47.2-1.7 19.5H381.7l8.2 94.2H511v-.2h214.7l-3.2 24.3-21.2 242.2-1.7 16.3-187.7 51.7v.4h-1.7l-188.6-52-11.3-144.7h91l6.5 73.2 102.4 27.7h.8v-.2l102.4-27.7 11.4-118.5H511.9v.1H305.4l-22.7-253.5L281 249h461l-1.7 24.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M281 249l1.7 24.3 22.7 253.5h206.5v-.1h112.9l-11.4 118.5L511 672.9v.2h-.8l-102.4-27.7-6.5-73.2h-91l11.3 144.7 188.6 52h1.7v-.4l187.7-51.7 1.7-16.3 21.2-242.2 3.2-24.3H511v.2H389.9l-8.2-94.2h352.1l1.7-19.5 4.8-47.2L742 249H511z"
                }
            }
        ]
    })(props);
}
function AiTwotoneIdcard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M136 792h752V232H136v560zm472-372c0-4.4 1-8 2.3-8h123.4c1.3 0 2.3 3.6 2.3 8v48c0 4.4-1 8-2.3 8H610.3c-1.3 0-2.3-3.6-2.3-8v-48zm0 144c0-4.4 3.2-8 7.1-8h185.7c3.9 0 7.1 3.6 7.1 8v48c0 4.4-3.2 8-7.1 8H615.1c-3.9 0-7.1-3.6-7.1-8v-48zM216.2 664.6c2.8-53.3 31.9-99.6 74.6-126.1-18.1-20-29.1-46.4-29.1-75.5 0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.6-29.1 75.5 42.6 26.4 71.8 72.8 74.6 126.1a8 8 0 0 1-8 8.4h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H224c-4.6 0-8.2-3.8-7.8-8.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M321.3 463a51.7 52 0 1 0 103.4 0 51.7 52 0 1 0-103.4 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z"
                }
            }
        ]
    })(props);
}
function AiTwotoneInfoCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm32 588c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M464 336a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneInsurance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M521.9 358.8h97.9v41.6h-97.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM413.3 656h-.2c0 4.4-3.6 8-8 8h-37.3c-4.4 0-8-3.6-8-8V471.4c-7.7 9.2-15.4 17.9-23.1 26a6.04 6.04 0 0 1-10.2-2.4l-13.2-43.5c-.6-2-.2-4.1 1.2-5.6 37-43.4 64.7-95.1 82.2-153.6 1.1-3.5 5-5.3 8.4-3.7l38.6 18.3c2.7 1.3 4.1 4.4 3.2 7.2a429.2 429.2 0 0 1-33.6 79V656zm257.9-340v127.2c0 4.4-3.6 8-8 8h-66.7v18.6h98.8c4.4 0 8 3.6 8 8v35.6c0 4.4-3.6 8-8 8h-59c18.1 29.1 41.8 54.3 72.3 76.9 2.6 2.1 3.2 5.9 1.2 8.5l-26.3 35.3a5.92 5.92 0 0 1-8.9.7c-30.6-29.3-56.8-65.2-78.1-106.9V656c0 4.4-3.6 8-8 8h-36.2c-4.4 0-8-3.6-8-8V536c-22 44.7-49 80.8-80.6 107.6a6.38 6.38 0 0 1-4.8 1.4c-1.7-.3-3.2-1.3-4.1-2.8L432 605.7a6 6 0 0 1 1.6-8.1c28.6-20.3 51.9-45.2 71-76h-55.1c-4.4 0-8-3.6-8-8V478c0-4.4 3.6-8 8-8h94.9v-18.6h-65.9c-4.4 0-8-3.6-8-8V316c0-4.4 3.6-8 8-8h184.7c4.4 0 8 3.6 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M443.7 306.9l-38.6-18.3c-3.4-1.6-7.3.2-8.4 3.7-17.5 58.5-45.2 110.2-82.2 153.6a5.7 5.7 0 0 0-1.2 5.6l13.2 43.5c1.4 4.5 7 5.8 10.2 2.4 7.7-8.1 15.4-16.8 23.1-26V656c0 4.4 3.6 8 8 8h37.3c4.4 0 8-3.6 8-8h.2V393.1a429.2 429.2 0 0 0 33.6-79c.9-2.8-.5-5.9-3.2-7.2zm26.8 9.1v127.4c0 4.4 3.6 8 8 8h65.9V470h-94.9c-4.4 0-8 3.6-8 8v35.6c0 4.4 3.6 8 8 8h55.1c-19.1 30.8-42.4 55.7-71 76a6 6 0 0 0-1.6 8.1l22.8 36.5c.9 1.5 2.4 2.5 4.1 2.8 1.7.3 3.5-.2 4.8-1.4 31.6-26.8 58.6-62.9 80.6-107.6v120c0 4.4 3.6 8 8 8h36.2c4.4 0 8-3.6 8-8V535.9c21.3 41.7 47.5 77.6 78.1 106.9 2.6 2.5 6.7 2.2 8.9-.7l26.3-35.3c2-2.6 1.4-6.4-1.2-8.5-30.5-22.6-54.2-47.8-72.3-76.9h59c4.4 0 8-3.6 8-8v-35.6c0-4.4-3.6-8-8-8h-98.8v-18.6h66.7c4.4 0 8-3.6 8-8V316c0-4.4-3.6-8-8-8H478.5c-4.4 0-8 3.6-8 8zm51.4 42.8h97.9v41.6h-97.9v-41.6z"
                }
            }
        ]
    })(props);
}
function AiTwotoneInteraction(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm114-401.9c0-55.3 44.6-100.1 99.7-100.1h205.8v-53.4c0-5.6 6.5-8.8 10.9-5.3L723.5 365c3.5 2.7 3.5 8 0 10.7l-109.1 85.7c-4.4 3.5-10.9.4-10.9-5.3v-53.4H397.8c-19.6 0-35.5 15.9-35.5 35.6v78.9c0 3.8-3.1 6.8-6.8 6.8h-50.7c-3.8 0-6.8-3-6.8-7v-78.9zm2.6 210.3l109.1-85.7c4.4-3.5 10.9-.4 10.9 5.3v53.4h205.6c19.6 0 35.5-15.9 35.5-35.6v-78.9c0-3.8 3.1-6.8 6.8-6.8h50.7c3.8 0 6.8 3.1 6.8 6.8v78.9c0 55.3-44.6 100.1-99.7 100.1H420.6v53.4c0 5.6-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z"
                }
            }
        ]
    })(props);
}
function AiTwotoneLayout(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M384 185h456v136H384zm-200 0h136v656H184zm696-73H144c-17.7 0-32 14.3-32 32v1c0-17.7 14.3-32 32-32h736c17.7 0 32 14.3 32 32v-1c0-17.7-14.3-32-32-32zM384 385h456v456H384z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 113H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V145c0-17.7-14.3-32-32-32zM320 841H184V185h136v656zm520 0H384V385h456v456zm0-520H384V185h456v136z"
                }
            }
        ]
    })(props);
}
function AiTwotoneLeftCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm104 240.9c0 10.3-4.9 19.9-13.2 25.9L457.4 512l145.4 105.1c8.3 6 13.2 15.7 13.2 25.9v46.9c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 0 1 0-12.9l246-178c5.3-3.8 12.7 0 12.7 6.5v46.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M603.3 327.5l-246 178a7.95 7.95 0 0 0 0 12.9l246 178c5.3 3.8 12.7 0 12.7-6.5V643c0-10.2-4.9-19.9-13.2-25.9L457.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5z"
                }
            }
        ]
    })(props);
}
function AiTwotoneLeftSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm181.3-334.5l246-178c5.3-3.8 12.7 0 12.7 6.5v46.9c0 10.3-4.9 19.9-13.2 25.9L465.4 512l145.4 105.2c8.3 6 13.2 15.7 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.4l-246-178a7.95 7.95 0 0 1 0-12.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M365.3 518.4l246 178c5.3 3.9 12.7.1 12.7-6.4v-46.9c0-10.2-4.9-19.9-13.2-25.9L465.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5l-246 178a7.95 7.95 0 0 0 0 12.9z"
                }
            }
        ]
    })(props);
}
function AiTwotoneLike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M273 495.9v428l.3-428zm538.2-88.3H496.8l9.6-198.4c.6-11.9-4.7-23.1-14.6-30.5-6.1-4.5-13.6-6.8-21.1-6.7-19.6.1-36.9 13.4-42.2 32.3-37.1 134.4-64.9 235.2-83.5 302.5V852h399.4a56.85 56.85 0 0 0 33.6-51.8c0-9.7-2.3-18.9-6.9-27.3l-13.9-25.4 21.9-19a56.76 56.76 0 0 0 19.6-43c0-9.7-2.3-18.9-6.9-27.3l-13.9-25.4 21.9-19a56.76 56.76 0 0 0 19.6-43c0-9.7-2.3-18.9-6.9-27.3l-14-25.5 21.9-19a56.76 56.76 0 0 0 19.6-43c0-19.1-11-37.5-28.8-48.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32zm773.9 5.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.5-65.5-111a67.67 67.67 0 0 0-34.3-9.3H572.3l6-122.9c1.5-29.7-9-57.9-29.5-79.4a106.4 106.4 0 0 0-77.9-33.4c-52 0-98 35-111.8 85.1l-85.8 310.8-.3 428h472.1c9.3 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37zM820.4 499l-21.9 19 14 25.5a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.1 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.1 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 22.4-13.2 42.6-33.6 51.8H345V506.8c18.6-67.2 46.4-168 83.5-302.5a44.28 44.28 0 0 1 42.2-32.3c7.5-.1 15 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.1 32.2-19.6 43z"
                }
            }
        ]
    })(props);
}
function AiTwotoneLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M232 840h560V536H232v304zm280-226a48.01 48.01 0 0 1 28 87v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 0 1 28-87z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneMail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M477.5 536.3L135.9 270.7l-27.5-21.4 27.6 21.5V792h752V270.8L546.2 536.3a55.99 55.99 0 0 1-68.7 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M876.3 198.8l39.3 50.5-27.6 21.5 27.7-21.5-39.3-50.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-94.5 72.1L512 482 190.5 232.1h643zm54.5 38.7V792H136V270.8l-27.6-21.5 27.5 21.4 341.6 265.6a55.99 55.99 0 0 0 68.7 0L888 270.8l27.6-21.5-39.3-50.5h.1l39.3 50.5-27.7 21.5z"
                }
            }
        ]
    })(props);
}
function AiTwotoneMedicineBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M244.3 328L184 513.4V840h656V513.4L779.7 328H244.3zM660 628c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V636H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V464c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8v48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M652 572H544V464c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V636h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M839.2 278.1a32 32 0 0 0-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 0 0-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM360 184h304v72H360v-72zm480 656H184V513.4L244.3 328h535.4L840 513.4V840z"
                }
            }
        ]
    })(props);
}
function AiTwotoneMeh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm384 200c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v48zm16-152a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm376 144H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-24-144a48 48 0 1 0 96 0 48 48 0 1 0-96 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneMessage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D8D8D8",
                    "d": "M775.3 248.9a369.62 369.62 0 0 0-119-80A370.2 370.2 0 0 0 512.1 140h-1.7c-99.7.4-193 39.4-262.8 109.9-69.9 70.5-108 164.1-107.6 263.8.3 60.3 15.3 120.2 43.5 173.1l4.5 8.4V836h140.8l8.4 4.5c52.9 28.2 112.8 43.2 173.1 43.5h1.7c99 0 192-38.2 262.1-107.6 70.4-69.8 109.5-163.1 110.1-262.7.2-50.6-9.5-99.6-28.9-145.8a370.15 370.15 0 0 0-80-119zM312 560a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96zm200 0a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96zm200 0a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M664 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-400 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M925.2 338.4c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 0 0-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 0 0-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 0 0 112 714v152a46 46 0 0 0 46 46h152.1A449.4 449.4 0 0 0 510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 0 0 142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M464 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneMinusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm192 396c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneMinusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm136-352c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneMobile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M744 64H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H288V136h448v752z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M288 888h448V136H288v752zm224-142c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M472 786a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneMoneyCollect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M256 744.4l256 93.1 256-93.1V184H256v560.4zM359.7 313c1.2-.7 2.5-1 3.8-1h55.7a8 8 0 0 1 7.1 4.4L511 485.2h3.3L599 316.4c1.3-2.7 4.1-4.4 7.1-4.4h54.5c4.4 0 8 3.6 8.1 7.9 0 1.3-.4 2.6-1 3.8L564 515.3h57.6c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3v39h76.3c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3V704c0 4.4-3.6 8-8 8h-49.9c-4.4 0-8-3.6-8-8v-63.4h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h76v-39h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h57L356.5 323.8c-2.1-3.8-.7-8.7 3.2-10.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M911.5 700.7a8 8 0 0 0-10.3-4.8L840 718.2V180c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V763c0 3.3 2.1 6.3 5.3 7.5L501 910.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zM768 744.4l-256 93.1-256-93.1V184h512v560.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M460.4 515.4h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.6-1.2 1-2.5 1-3.8-.1-4.3-3.7-7.9-8.1-7.9h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 0 0-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6z"
                }
            }
        ]
    })(props);
}
function AiTwotoneNotification(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M229.6 678.1c-3.7 11.6-5.6 23.9-5.6 36.4 0-12.5 2-24.8 5.7-36.4h-.1zm76.3-260.2H184v188.2h121.9l12.9 5.2L840 820.7V203.3L318.8 412.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.7c-3.7 11.6-5.7 23.9-5.7 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1zm496 58.4L318.8 611.3l-12.9-5.2H184V417.9h121.9l12.9-5.2L840 203.3v617.4z"
                }
            }
        ]
    })(props);
}
function AiTwotonePauseCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-80 524c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304zm224 0c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M424 352h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zm224 0h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiTwotonePhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M721.7 184.9L610.9 295.8l120.8 120.7-8 21.6A481.29 481.29 0 0 1 438 723.9l-21.6 8-.9-.9-119.8-120-110.8 110.9 104.5 104.5c10.8 10.7 26 15.7 40.8 13.2 117.9-19.5 235.4-82.9 330.9-178.4s158.9-213.1 178.4-331c2.5-14.8-2.5-30-13.3-40.8L721.7 184.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7a405.46 405.46 0 0 1-86.4 127.3c-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3a68.2 68.2 0 0 0-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4zm-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 .9.9 21.6-8a481.29 481.29 0 0 0 285.7-285.8l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z"
                }
            }
        ]
    })(props);
}
function AiTwotonePicture(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M424.6 765.8l-150.1-178L136 752.1V792h752v-30.4L658.1 489z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M136 652.7l132.4-157c3.2-3.8 9-3.8 12.2 0l144 170.7L652 396.8c3.2-3.8 9-3.8 12.2 0L888 662.2V232H136v420.7zM304 280a88 88 0 1 1 0 176 88 88 0 0 1 0-176z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M276 368a28 28 0 1 0 56 0 28 28 0 1 0-56 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M304 456a88 88 0 1 0 0-176 88 88 0 0 0 0 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z"
                }
            }
        ]
    })(props);
}
function AiTwotonePieChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M316.2 920.5c-47.6-20.1-90.4-49-127.1-85.7a398.19 398.19 0 0 1-85.7-127.1A397.12 397.12 0 0 1 72 552.2v.2a398.57 398.57 0 0 0 117 282.5c36.7 36.7 79.4 65.5 127 85.6A396.64 396.64 0 0 0 471.6 952c27 0 53.6-2.7 79.7-7.9-25.9 5.2-52.4 7.8-79.3 7.8-54 .1-106.4-10.5-155.8-31.4zM560 472c-4.4 0-8-3.6-8-8V79.9c0-1.3.3-2.5.9-3.6-.9 1.3-1.5 2.9-1.5 4.6v383.7c0 4.4 3.6 8 8 8l383.6-1c1.6 0 3.1-.5 4.4-1.3-1 .5-2.2.7-3.4.7l-384 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M619.8 147.6v256.6l256.4-.7c-13-62.5-44.3-120.5-90-166.1a332.24 332.24 0 0 0-166.4-89.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M438 221.7c-75.9 7.6-146.2 40.9-200.8 95.5C174.5 379.9 140 463.3 140 552s34.5 172.1 97.2 234.8c62.3 62.3 145.1 96.8 233.2 97.2 88.2.4 172.7-34.1 235.3-96.2C761 733 794.6 662.3 802.3 586H438V221.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M864 518H506V160c0-4.4-3.6-8-8-8h-26a398.46 398.46 0 0 0-282.8 117.1 398.19 398.19 0 0 0-85.7 127.1A397.61 397.61 0 0 0 72 552v.2c0 53.9 10.6 106.2 31.4 155.5 20.1 47.6 49 90.4 85.7 127.1 36.7 36.7 79.5 65.6 127.1 85.7A397.61 397.61 0 0 0 472 952c26.9 0 53.4-2.6 79.3-7.8 26.1-5.3 51.7-13.1 76.4-23.6 47.6-20.1 90.4-49 127.1-85.7 36.7-36.7 65.6-79.5 85.7-127.1A397.61 397.61 0 0 0 872 552v-26c0-4.4-3.6-8-8-8zM705.7 787.8A331.59 331.59 0 0 1 470.4 884c-88.1-.4-170.9-34.9-233.2-97.2C174.5 724.1 140 640.7 140 552s34.5-172.1 97.2-234.8c54.6-54.6 124.9-87.9 200.8-95.5V586h364.3c-7.7 76.3-41.3 147-96.6 201.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M952 462.4l-2.6-28.2c-8.5-92.1-49.4-179-115.2-244.6A399.4 399.4 0 0 0 589 74.6L560.7 72c-3.4-.3-6.4 1.5-7.8 4.3a8.7 8.7 0 0 0-.9 3.6V464c0 4.4 3.6 8 8 8l384-1c1.2 0 2.3-.3 3.4-.7a8.1 8.1 0 0 0 4.6-7.9zm-332.2-58.2V147.6a332.24 332.24 0 0 1 166.4 89.8c45.7 45.6 77 103.6 90 166.1l-256.4.7z"
                }
            }
        ]
    })(props);
}
function AiTwotonePlayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm164.1 378.2L457.7 677.1a8.02 8.02 0 0 1-12.7-6.5V353a8 8 0 0 1 12.7-6.5l218.4 158.8a7.9 7.9 0 0 1 0 12.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M676.1 505.3L457.7 346.5A8 8 0 0 0 445 353v317.6a8.02 8.02 0 0 0 12.7 6.5l218.4-158.9a7.9 7.9 0 0 0 0-12.9z"
                }
            }
        ]
    })(props);
}
function AiTwotonePlaySquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm240-484.7c0-9.4 10.9-14.7 18.3-8.8l199.4 156.7a11.2 11.2 0 0 1 0 17.6L442.3 677.6c-7.4 5.8-18.3.6-18.3-8.8V355.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M442.3 677.6l199.4-156.8a11.2 11.2 0 0 0 0-17.6L442.3 346.5c-7.4-5.9-18.3-.6-18.3 8.8v313.5c0 9.4 10.9 14.6 18.3 8.8z"
                }
            }
        ]
    })(props);
}
function AiTwotonePlusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm192 396c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiTwotonePlusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm136-352c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiTwotonePoundCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm146 582.1c0 4.4-3.6 8-8 8H376.2c-4.4 0-8-3.6-8-8v-38.5c0-3.7 2.5-6.9 6.1-7.8 44-10.9 72.8-49 72.8-94.2 0-14.7-2.5-29.4-5.9-44.2H374c-4.4 0-8-3.6-8-8v-30c0-4.4 3.6-8 8-8h53.7c-7.8-25.1-14.6-50.7-14.6-77.1 0-75.8 58.6-120.3 151.5-120.3 26.5 0 51.4 5.5 70.3 12.7 3.1 1.2 5.2 4.2 5.2 7.5v39.5a8 8 0 0 1-10.6 7.6c-17.9-6.4-39-10.5-60.4-10.5-53.3 0-87.3 26.6-87.3 70.2 0 24.7 6.2 47.9 13.4 70.5h112c4.4 0 8 3.6 8 8v30c0 4.4-3.6 8-8 8h-98.6c3.1 13.2 5.3 26.9 5.3 41 0 40.7-16.5 73.9-43.9 91.1v4.7h180c4.4 0 8 3.6 8 8v39.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M650 674.3H470v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.8-5.3-41h98.6c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8h-112c-7.2-22.6-13.4-45.8-13.4-70.5 0-43.6 34-70.2 87.3-70.2 21.4 0 42.5 4.1 60.4 10.5a8 8 0 0 0 10.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.9-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.4 6.8 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.2c3.4 14.8 5.9 29.5 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8v38.5c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiTwotonePrinter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M360 180h304v152H360zm492 220H172c-6.6 0-12 5.4-12 12v292h132V500h440v204h132V412c0-6.6-5.4-12-12-12zm-24 84c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M852 332H732V120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM360 180h304v152H360V180zm304 664H360V568h304v276zm200-140H732V500H292v204H160V412c0-6.6 5.4-12 12-12h680c6.6 0 12 5.4 12 12v292z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M820 436h-40c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-40c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneProfile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm300-496c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zm0 144c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zm0 144c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zM380 328c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0 144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0 144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M340 656a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0-144a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0-144a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm152 320h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneProject(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm472-560c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v256c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280zm-192 0c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280zm-192 0c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v464c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M280 752h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8zm192-280h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm192 72h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v256c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiTwotonePropertySafety(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM593.9 318h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V658c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8H418c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7H418c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3L585 323.5a10 10 0 0 1 8.9-5.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M438.9 323.5a9.88 9.88 0 0 0-8.9-5.5h-46c-1.7 0-3.3.4-4.8 1.2-4.9 2.7-6.6 8.8-4 13.6l88 161.1H418c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1v29.7H418c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1V658c0 5.5 4.5 10 10 10h41.3c5.5 0 10-4.5 10-10v-51.8h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-63.4v-29.7h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-45.7l87.7-161.1c.8-1.5 1.2-3.1 1.1-4.8 0-5.5-4.5-10-10-10h-45a10 10 0 0 0-8.9 5.5l-73.2 144.3-72.9-144.3z"
                }
            }
        ]
    })(props);
}
function AiTwotonePushpin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M474.8 357.7l-24.5 24.5-34.4-3.8c-9.6-1.1-19.3-1.6-28.9-1.6-29 0-57.5 4.7-84.7 14.1-14 4.8-27.4 10.8-40.3 17.9l353.1 353.3a259.92 259.92 0 0 0 30.4-153.9l-3.8-34.4 24.5-24.5L800 415.5 608.5 224 474.8 357.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3a33.23 33.23 0 0 0-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 0 0-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8zM666.2 549.3l-24.5 24.5 3.8 34.4a259.92 259.92 0 0 1-30.4 153.9L262 408.8c12.9-7.1 26.3-13.1 40.3-17.9 27.2-9.4 55.7-14.1 84.7-14.1 9.6 0 19.3.5 28.9 1.6l34.4 3.8 24.5-24.5L608.5 224 800 415.5 666.2 549.3z"
                }
            }
        ]
    })(props);
}
function AiTwotoneQuestionCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm0 632c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm62.9-219.5a48.3 48.3 0 0 0-30.9 44.8V620c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-21.5c0-23.1 6.7-45.9 19.9-64.9 12.9-18.6 30.9-32.8 52.1-40.9 34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V420c0-39.3 17.2-76 48.4-103.3C430.4 290.4 470 276 512 276s81.6 14.5 111.6 40.7C654.8 344 672 380.7 672 420c0 57.8-38.1 109.8-97.1 132.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M472 732a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm151.6-415.3C593.6 290.5 554 276 512 276s-81.6 14.4-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.2 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0 1 30.9-44.8c59-22.7 97.1-74.7 97.1-132.5 0-39.3-17.2-76-48.4-103.3z"
                }
            }
        ]
    })(props);
}
function AiTwotoneReconciliation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M740 344H404V240H304v160h176c17.7 0 32 14.3 32 32v360h328V240H740v104zM584 448c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56zm92 301c-50.8 0-92-41.2-92-92s41.2-92 92-92 92 41.2 92 92-41.2 92-92 92zm92-341v96c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M642 657a34 34 0 1 0 68 0 34 34 0 1 0-68 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M592 512h48c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm112-104v96c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-96c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 168H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zm-412 64h72v-56h64v56h72v48H468v-48zm-20 616H176V616h272v232zm0-296H176v-88h272v88zm392 240H512V432c0-17.7-14.3-32-32-32H304V240h100v104h336V240h100v552z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M676 565c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34z"
                }
            }
        ]
    })(props);
}
function AiTwotoneRedEnvelope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V193.1l260.3 204.1c11.6 9.1 27.9 9.1 39.5 0L792 193.1V888zm0-751.3h-31.7L512 331.3 263.7 136.7H232v-.7h560v.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M492.3 397.2L232 193.1V888h560V193.1L531.8 397.2a31.99 31.99 0 0 1-39.5 0zm99.4 60.9h47.8a8.45 8.45 0 0 1 7.4 12.4l-87.2 161h45.9c4.6 0 8.4 3.8 8.4 8.4V665c0 4.6-3.8 8.4-8.4 8.4h-63.3V702h63.3c4.6 0 8.4 3.8 8.4 8.4v25c.2 4.7-3.5 8.5-8.2 8.5h-63.3v49.9c0 4.6-3.8 8.4-8.4 8.4h-43.7c-4.6 0-8.4-3.8-8.4-8.4v-49.9h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h63v-28.6h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h45.4L377 470.4a8.4 8.4 0 0 1 3.4-11.4c1.3-.6 2.6-1 3.9-1h48.8c3.2 0 6.1 1.8 7.5 4.6l71.7 142 71.9-141.9a8.6 8.6 0 0 1 7.5-4.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M232 136.7h31.7L512 331.3l248.3-194.6H792v-.7H232z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M440.6 462.6a8.38 8.38 0 0 0-7.5-4.6h-48.8c-1.3 0-2.6.4-3.9 1a8.4 8.4 0 0 0-3.4 11.4l87.4 161.1H419c-4.6 0-8.4 3.8-8.4 8.4V665c0 4.6 3.8 8.4 8.4 8.4h63V702h-63c-4.6 0-8.4 3.8-8.4 8.4v25.1c0 4.6 3.8 8.4 8.4 8.4h63v49.9c0 4.6 3.8 8.4 8.4 8.4h43.7c4.6 0 8.4-3.8 8.4-8.4v-49.9h63.3c4.7 0 8.4-3.8 8.2-8.5v-25c0-4.6-3.8-8.4-8.4-8.4h-63.3v-28.6h63.3c4.6 0 8.4-3.8 8.4-8.4v-25.1c0-4.6-3.8-8.4-8.4-8.4h-45.9l87.2-161a8.45 8.45 0 0 0-7.4-12.4h-47.8c-3.1 0-6 1.8-7.5 4.6l-71.9 141.9-71.7-142z"
                }
            }
        ]
    })(props);
}
function AiTwotoneRest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M326.4 844h363.2l44.3-520H282l44.4 520zM508 416c79.5 0 144 64.5 144 144s-64.5 144-144 144-144-64.5-144-144 64.5-144 144-144z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M508 704c79.5 0 144-64.5 144-144s-64.5-144-144-144-144 64.5-144 144 64.5 144 144 144zm0-224c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0 0 31.9 29.3h429.2a32 32 0 0 0 31.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zm-518.6-76h397.2l22.4 76H291l22.4-76zm376.2 664H326.4L282 324h451.9l-44.3 520z"
                }
            }
        ]
    })(props);
}
function AiTwotoneRightCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm154.7 378.4l-246 178c-5.3 3.8-12.7 0-12.7-6.5V643c0-10.2 4.9-19.9 13.2-25.9L566.6 512 421.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.7 0 12.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M666.7 505.5l-246-178c-5.3-3.8-12.7 0-12.7 6.5v46.9c0 10.3 4.9 19.9 13.2 25.9L566.6 512 421.2 617.1c-8.3 6-13.2 15.7-13.2 25.9v46.9c0 6.5 7.4 10.3 12.7 6.5l246-178c4.4-3.2 4.4-9.7 0-12.9z"
                }
            }
        ]
    })(props);
}
function AiTwotoneRightSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm216-196.9c0-10.2 4.9-19.9 13.2-25.9L558.6 512 413.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.7 0 12.9l-246 178c-5.3 3.9-12.7.1-12.7-6.4v-46.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M412.7 696.4l246-178c4.4-3.2 4.4-9.7 0-12.9l-246-178c-5.3-3.8-12.7 0-12.7 6.5v46.9c0 10.3 4.9 19.9 13.2 25.9L558.6 512 413.2 617.2c-8.3 6-13.2 15.7-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneRocket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M261.7 621.4c-9.4 14.6-17 30.3-22.5 46.6H324V558.7c-24.8 16.2-46 37.5-62.3 62.7zM700 558.7V668h84.8c-5.5-16.3-13.1-32-22.5-46.6a211.6 211.6 0 0 0-62.3-62.7zm-64-239.9l-124-147-124 147V668h248V318.8zM512 448a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 0 0-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0 0 43.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0 0 43.1-30.5 97.52 97.52 0 0 0 21.4-60.8c0-8.4-1.1-16.4-3.1-23.8L864 736zm-540-68h-84.8c5.5-16.3 13.1-32 22.5-46.6 16.3-25.2 37.5-46.5 62.3-62.7V668zm64-184.9V318.8l124-147 124 147V668H388V483.1zm240.1 301.1c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5s-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 0 1-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5zM700 668V558.7a211.6 211.6 0 0 1 62.3 62.7c9.4 14.6 17 30.3 22.5 46.6H700z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M464 400a48 48 0 1 0 96 0 48 48 0 1 0-96 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSafetyCertificate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM632.8 328H688c6.5 0 10.3 7.4 6.5 12.7L481.9 633.4a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.2 0 10 2.5 13 6.6l64.7 89.1 150.9-207.8c3-4.1 7.9-6.6 13-6.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M404.2 453.3c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.3 0-12.7-6.5-12.7h-55.2c-5.1 0-10 2.5-13 6.6L468.9 542.4l-64.7-89.1z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSave(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M704 320c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V184H184v656h656V341.8l-136-136V320zM512 730c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M893.3 293.3L730.7 130.7c-.7-.7-1.4-1.3-2.1-2-.1-.1-.3-.2-.4-.3-.7-.7-1.5-1.3-2.2-1.9a64 64 0 0 0-22-11.7V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSchedule(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M768 352c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H548v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H328v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H136v496h752V296H768v56zM424 688c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-136c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm374.4-91.2l-165 228.7a15.9 15.9 0 0 1-25.8 0L493.5 531.3c-3.8-5.3 0-12.7 6.5-12.7h54.9c5.1 0 9.9 2.4 12.9 6.6l52.8 73.1 103.6-143.7c3-4.1 7.8-6.6 12.8-6.5h54.9c6.5 0 10.3 7.4 6.5 12.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M724.2 454.6L620.6 598.3l-52.8-73.1c-3-4.2-7.8-6.6-12.9-6.6H500c-6.5 0-10.3 7.4-6.5 12.7l114.1 158.2a15.9 15.9 0 0 0 25.8 0l165-228.7c3.8-5.3 0-12.7-6.5-12.7H737c-5-.1-9.8 2.4-12.8 6.5zM416 496H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M416 632H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSecurityScan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M460.7 451.1a80.1 80.1 0 1 0 160.2 0 80.1 80.1 0 1 0-160.2 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zm428.7 122.5c56.3 56.3 56.3 147.5 0 203.8-48.5 48.5-123 55.2-178.6 20.1l-77.5 77.5a8.03 8.03 0 0 1-11.3 0l-34-34a8.03 8.03 0 0 1 0-11.3l77.5-77.5c-35.1-55.7-28.4-130.1 20.1-178.6 56.3-56.3 147.5-56.3 203.8 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M418.8 527.8l-77.5 77.5a8.03 8.03 0 0 0 0 11.3l34 34c3.1 3.1 8.2 3.1 11.3 0l77.5-77.5c55.6 35.1 130.1 28.4 178.6-20.1 56.3-56.3 56.3-147.5 0-203.8-56.3-56.3-147.5-56.3-203.8 0-48.5 48.5-55.2 122.9-20.1 178.6zm65.4-133.3a80.1 80.1 0 0 1 113.3 0 80.1 80.1 0 0 1 0 113.3c-31.3 31.3-82 31.3-113.3 0s-31.3-82 0-113.3z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSetting(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M859.3 569.7l.2.1c3.1-18.9 4.6-38.2 4.6-57.3 0-17.1-1.3-34.3-3.7-51.1 2.4 16.7 3.6 33.6 3.6 50.5 0 19.4-1.6 38.8-4.7 57.8zM99 398.1c-.5-.4-.9-.8-1.4-1.3.7.7 1.4 1.4 2.2 2.1l65.5 55.9v-.1L99 398.1zm536.6-216h.1l-15.5-83.8c-.2-1-.4-1.9-.7-2.8.1.5.3 1.1.4 1.6l15.7 85zm54 546.5l31.4-25.8 92.8 32.9c17-22.9 31.3-47.5 42.6-73.6l-74.7-63.9 6.6-40.1c2.5-15.1 3.8-30.6 3.8-46.1s-1.3-31-3.8-46.1l-6.5-39.9 74.7-63.9c-11.4-26-25.6-50.7-42.6-73.6l-92.8 32.9-31.4-25.8c-23.9-19.6-50.6-35-79.3-45.8l-38.1-14.3-17.9-97a377.5 377.5 0 0 0-85 0l-17.9 97.2-37.9 14.3c-28.5 10.8-55 26.2-78.7 45.7l-31.4 25.9-93.4-33.2c-17 22.9-31.3 47.5-42.6 73.6l75.5 64.5-6.5 40c-2.5 14.9-3.7 30.2-3.7 45.5 0 15.2 1.3 30.6 3.7 45.5l6.5 40-75.5 64.5c11.4 26 25.6 50.7 42.6 73.6l93.4-33.2 31.4 25.9c23.7 19.5 50.2 34.9 78.7 45.7l37.8 14.5 17.9 97.2c28.2 3.2 56.9 3.2 85 0l17.9-97 38.1-14.3c28.8-10.8 55.4-26.2 79.3-45.8zm-177.1-50.3c-30.5 0-59.2-7.8-84.3-21.5C373.3 627 336 568.9 336 502c0-97.2 78.8-176 176-176 66.9 0 125 37.3 154.8 92.2 13.7 25 21.5 53.7 21.5 84.3 0 97.1-78.7 175.8-175.8 175.8zM207.2 812.8c-5.5 1.9-11.2 2.3-16.6 1.2 5.7 1.2 11.7 1 17.5-1l81.4-29c-.1-.1-.3-.2-.4-.3l-81.9 29.1zm717.6-414.7l-65.5 56c0 .2.1.5.1.7l65.4-55.9c7.1-6.1 11.1-14.9 11.2-24-.3 8.8-4.3 17.3-11.2 23.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M935.8 646.6c.5 4.7 0 9.5-1.7 14.1l-.9 2.6a446.02 446.02 0 0 1-79.7 137.9l-1.8 2.1a32 32 0 0 1-35.1 9.5l-81.3-28.9a350 350 0 0 1-99.7 57.6l-15.7 85a32.05 32.05 0 0 1-25.8 25.7l-2.7.5a445.2 445.2 0 0 1-79.2 7.1h.3c26.7 0 53.4-2.4 79.4-7.1l2.7-.5a32.05 32.05 0 0 0 25.8-25.7l15.7-84.9c36.2-13.6 69.6-32.9 99.6-57.5l81.2 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.5-87.4 79.6-137.7l.9-2.6c1.6-4.7 2.1-9.7 1.5-14.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M688 502c0-30.3-7.7-58.9-21.2-83.8C637 363.3 578.9 326 512 326c-97.2 0-176 78.8-176 176 0 66.9 37.3 125 92.2 154.8 24.9 13.5 53.4 21.2 83.8 21.2 97.2 0 176-78.8 176-176zm-288 0c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 0 1 624 502c0 29.9-11.7 58-32.8 79.2A111.6 111.6 0 0 1 512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 502z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M594.1 952.2a32.05 32.05 0 0 0 25.8-25.7l15.7-85a350 350 0 0 0 99.7-57.6l81.3 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c1.7-4.6 2.2-9.4 1.7-14.1-.9-7.9-4.7-15.4-11-20.9l-65.3-55.9-.2-.1c3.1-19 4.7-38.4 4.7-57.8 0-16.9-1.2-33.9-3.6-50.5-.3-2.2-.7-4.4-1-6.6 0-.2-.1-.5-.1-.7l65.5-56c6.9-5.9 10.9-14.4 11.2-23.2.1-4-.5-8.1-1.9-12l-.9-2.6a443.74 443.74 0 0 0-79.7-137.9l-1.8-2.1a32.12 32.12 0 0 0-35.1-9.5l-81.3 28.9c-30-24.6-63.4-44-99.6-57.6h-.1l-15.7-85c-.1-.5-.2-1.1-.4-1.6a32.08 32.08 0 0 0-25.4-24.1l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 0 0-25.8 25.7l-15.8 85.4a351.86 351.86 0 0 0-99 57.4l-81.9-29.1a32 32 0 0 0-35.1 9.5l-1.8 2.1a446.02 446.02 0 0 0-79.7 137.9l-.9 2.6a32.09 32.09 0 0 0 7.9 33.9c.5.4.9.9 1.4 1.3l66.3 56.6v.1c-3.1 18.8-4.6 37.9-4.6 57 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 0 0-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1c4.9 5.7 11.4 9.4 18.5 10.7 5.4 1 11.1.7 16.6-1.2l81.9-29.1c.1.1.3.2.4.3 29.7 24.3 62.8 43.6 98.6 57.1l15.8 85.4a32.05 32.05 0 0 0 25.8 25.7l2.7.5c26.1 4.7 52.8 7.1 79.5 7.1h.3c26.6 0 53.3-2.4 79.2-7.1l2.7-.5zm-39.8-66.5a377.5 377.5 0 0 1-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 0 1-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97z"
                }
            }
        ]
    })(props);
}
function AiTwotoneShop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M839.5 344h-655c-.3 0-.5.2-.5.5v91.2c0 59.8 49 108.3 109.3 108.3 40.7 0 76.2-22 95.1-54.7 2.9-5.1 8.4-8.3 14.3-8.3s11.3 3.2 14.3 8.3c18.8 32.7 54.3 54.7 95 54.7 40.8 0 76.4-22.1 95.1-54.9 2.9-5 8.2-8.1 13.9-8.1h.6c5.8 0 11 3.1 13.9 8.1 18.8 32.8 54.4 54.9 95.2 54.9C791 544 840 495.5 840 435.7v-91.2c0-.3-.2-.5-.5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0 0 14.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h676c17.7 0 32-14.3 32-32V535a175 175 0 0 0 15.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zM214 184h596v88H214v-88zm362 656.1H448V736h128v104.1zm234.4 0H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c3-1.3 6-2.6 9-4v242.2zM840 435.7c0 59.8-49 108.3-109.3 108.3-40.8 0-76.4-22.1-95.2-54.9-2.9-5-8.1-8.1-13.9-8.1h-.6c-5.7 0-11 3.1-13.9 8.1A109.24 109.24 0 0 1 512 544c-40.7 0-76.2-22-95-54.7-3-5.1-8.4-8.3-14.3-8.3s-11.4 3.2-14.3 8.3a109.63 109.63 0 0 1-95.1 54.7C233 544 184 495.5 184 435.7v-91.2c0-.3.2-.5.5-.5h655c.3 0 .5.2.5.5v91.2z"
                }
            }
        ]
    })(props);
}
function AiTwotoneShopping(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M696 472c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-88H400v88c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-88h-96v456h560V384h-96v88z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-432-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16H400v-16zm392 544H232V384h96v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h224v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h96v456z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSkin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M512 318c-79.2 0-148.5-48.8-176.7-120H182v196h119v432h422V394h119V198H688.7c-28.2 71.2-97.5 120-176.7 120z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 0 0-37-29.3H154a44 44 0 0 0-44 44v252a44 44 0 0 0 44 44h75v388a44 44 0 0 0 44 44h478a44 44 0 0 0 44-44V466h75a44 44 0 0 0 44-44V170a44 44 0 0 0-44-44zm-28 268H723v432H301V394H182V198h153.3c28.2 71.2 97.5 120 176.7 120s148.5-48.8 176.7-120H842v196z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSliders(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M180 292h80v440h-80zm369 180h-74a3 3 0 0 0-3 3v74a3 3 0 0 0 3 3h74a3 3 0 0 0 3-3v-74a3 3 0 0 0-3-3zm215-108h80v296h-80z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M904 296h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-60 364h-80V364h80v296zM612 404h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8zm-60 145a3 3 0 0 1-3 3h-74a3 3 0 0 1-3-3v-74a3 3 0 0 1 3-3h74a3 3 0 0 1 3 3v74zM320 224h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-60 508h-80V292h80v440z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSmile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm224 272c-85.5 0-155.6-67.3-160-151.6a8 8 0 0 1 8-8.4h48.1c4.2 0 7.8 3.2 8.1 7.4C420 589.9 461.5 629 512 629s92.1-39.1 95.8-88.6c.3-4.2 3.9-7.4 8.1-7.4H664a8 8 0 0 1 8 8.4C667.6 625.7 597.5 693 512 693zm176-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm376 112h-48.1c-4.2 0-7.8 3.2-8.1 7.4-3.7 49.5-45.3 88.6-95.8 88.6s-92-39.1-95.8-88.6c-.3-4.2-3.9-7.4-8.1-7.4H360a8 8 0 0 0-8 8.4c4.4 84.3 74.5 151.6 160 151.6s155.6-67.3 160-151.6a8 8 0 0 0-8-8.4zm-24-112a48 48 0 1 0 96 0 48 48 0 1 0-96 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSnippets(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M450 510V336H232v552h432V550H490c-22.1 0-40-17.9-40-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 888H232V336h218v174c0 22.1 17.9 40 40 40h174v338zm0-402H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M275.4 424H146v176h129.4l18 11.7L586 803V221L293.3 412.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M892.1 737.8l-110.3-63.7a15.9 15.9 0 0 0-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0 0 21.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM934 476H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zM760 344a15.9 15.9 0 0 0 21.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 0 0-21.7-5.9L746 287.8a15.99 15.99 0 0 0-5.8 21.8L760 344zM625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1zM586 803L293.4 611.7l-18-11.7H146V424h129.4l17.9-11.7L586 221v582z"
                }
            }
        ]
    })(props);
}
function AiTwotoneStar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M512.5 190.4l-94.4 191.3-211.2 30.7 152.8 149-36.1 210.3 188.9-99.3 188.9 99.2-36.1-210.3 152.8-148.9-211.2-30.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M908.6 352.8l-253.9-36.9L541.2 85.8c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L370.3 315.9l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1L239 839.4a31.95 31.95 0 0 0 46.4 33.7l227.1-119.4 227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM665.3 561.3l36.1 210.3-188.9-99.2-188.9 99.3 36.1-210.3-152.8-149 211.2-30.7 94.4-191.3 94.4 191.3 211.2 30.7-152.8 148.9z"
                }
            }
        ]
    })(props);
}
function AiTwotoneStop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm288.5 682.8L277.7 224C258 240 240 258 224 277.7l522.8 522.8C682.8 852.7 601 884 512 884c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372c0 89-31.3 170.8-83.5 234.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372c89 0 170.8-31.3 234.8-83.5L224 277.7c16-19.7 34-37.7 53.7-53.7l522.8 522.8C852.7 682.8 884 601 884 512c0-205.4-166.6-372-372-372z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSwitcher(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M184 840h528V312H184v528zm116-290h296v64H300v-64z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zm-40 600H184V312h528v528z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M300 550h296v64H300z"
                }
            }
        ]
    })(props);
}
function AiTwotoneTablet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H232V136h560v752z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M232 888h560V136H232v752zm280-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M472 784a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneTag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M589 164.6L189.3 564.3l270.4 270.4L859.4 435 836 188l-247-23.4zM680 432c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M680 256c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm0 120c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 0 0 0 14.1l363.8 363.8a9.9 9.9 0 0 0 7.1 2.9c2.7 0 5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM459.7 834.7L189.3 564.3 589 164.6 836 188l23.4 247-399.7 399.7z"
                }
            }
        ]
    })(props);
}
function AiTwotoneTags(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M477.5 694l311.9-311.8-19-224.6-224.6-19-311.9 311.9L477.5 694zm116-415.5a47.81 47.81 0 0 1 33.9-33.9c16.6-4.4 34.2.3 46.4 12.4a47.93 47.93 0 0 1 12.4 46.4 47.81 47.81 0 0 1-33.9 33.9c-16.6 4.4-34.2-.3-46.4-12.4a48.3 48.3 0 0 1-12.4-46.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M476.6 792.6c-1.7-.2-3.4-1-4.7-2.3L137.7 456.1a8.03 8.03 0 0 1 0-11.3L515.9 66.6c1.2-1.3 2.9-2.1 4.7-2.3h-.4c-2.3-.2-4.7.6-6.3 2.3L135.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c1.8 1.9 4.3 2.6 6.7 2.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M889.7 539.8l-39.6-39.5a8.03 8.03 0 0 0-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 0 0-11.3 0l-39.6 39.5a8.03 8.03 0 0 0 0 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3zM652.3 337.3a47.81 47.81 0 0 0 33.9-33.9c4.4-16.6-.3-34.2-12.4-46.4a47.93 47.93 0 0 0-46.4-12.4 47.81 47.81 0 0 0-33.9 33.9c-4.4 16.6.3 34.2 12.4 46.4a48.3 48.3 0 0 0 46.4 12.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M137.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c1.3 1.3 2.9 2.1 4.7 2.3 2.4.3 4.8-.5 6.6-2.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3h-1.6c-1.8.2-3.4 1-4.7 2.3L137.7 444.8zm408.1-306.2l224.6 19 19 224.6L477.5 694 233.9 450.5l311.9-311.9z"
                }
            }
        ]
    })(props);
}
function AiTwotoneThunderbolt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M695.4 164.1H470.8L281.2 491.5h157.4l-60.3 241 319.8-305.1h-211z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M848.1 359.3H627.8L825.9 109c4.1-5.3.4-13-6.3-13H436.1c-2.8 0-5.5 1.5-6.9 4L170.1 547.5c-3.1 5.3.7 12 6.9 12h174.4L262 917.1c-1.9 7.8 7.5 13.3 13.3 7.7L853.6 373c5.2-4.9 1.7-13.7-5.5-13.7zM378.3 732.5l60.3-241H281.2l189.6-327.4h224.6L487.1 427.4h211L378.3 732.5z"
                }
            }
        ]
    })(props);
}
function AiTwotoneTool(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M706.8 488.7a32.05 32.05 0 0 1-45.3 0L537 364.2a32.05 32.05 0 0 1 0-45.3l132.9-132.8a184.2 184.2 0 0 0-144 53.5c-58.1 58.1-69.3 145.3-33.6 214.6L439.5 507c-.1 0-.1-.1-.1-.1L209.3 737l79.2 79.2 274-274.1.1.1 8.8-8.8c69.3 35.7 156.5 24.5 214.6-33.6 39.2-39.1 57.3-92.1 53.6-143.9L706.8 488.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M876.6 239.5c-.5-.9-1.2-1.8-2-2.5-5-5-13.1-5-18.1 0L684.2 409.3l-67.9-67.9L788.7 169c.8-.8 1.4-1.6 2-2.5 3.6-6.1 1.6-13.9-4.5-17.5-98.2-58-226.8-44.7-311.3 39.7-67 67-89.2 162-66.5 247.4l-293 293c-3 3-2.8 7.9.3 11l169.7 169.7c3.1 3.1 8.1 3.3 11 .3l292.9-292.9c85.5 22.8 180.5.7 247.6-66.4 84.4-84.5 97.7-213.1 39.7-311.3zM786 499.8c-58.1 58.1-145.3 69.3-214.6 33.6l-8.8 8.8-.1-.1-274 274.1-79.2-79.2 230.1-230.1s0 .1.1.1l52.8-52.8c-35.7-69.3-24.5-156.5 33.6-214.6a184.2 184.2 0 0 1 144-53.5L537 318.9a32.05 32.05 0 0 0 0 45.3l124.5 124.5a32.05 32.05 0 0 0 45.3 0l132.8-132.8c3.7 51.8-14.4 104.8-53.6 143.9z"
                }
            }
        ]
    })(props);
}
function AiTwotoneTrademarkCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm170.7 584.2c-1.1.5-2.3.8-3.5.8h-62c-3.1 0-5.9-1.8-7.2-4.6l-74.6-159.2h-88.7V717c0 4.4-3.6 8-8 8H384c-4.4 0-8-3.6-8-8V307c0-4.4 3.6-8 8-8h155.6c98.8 0 144.2 59.9 144.2 131.1 0 70.2-43.6 106.4-78.4 119.2l80.8 164.2c2.1 3.9.4 8.7-3.5 10.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M529.9 357h-83.4v148H528c53 0 82.8-25.6 82.8-72.4 0-50.3-32.9-75.6-80.9-75.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M605.4 549.3c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.4-131.1-144.2-131.1H384c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.7c4.4 0 8-3.6 8-8V561.2h88.7L610 720.4c1.3 2.8 4.1 4.6 7.2 4.6h62c1.2 0 2.4-.3 3.5-.8 3.9-2 5.6-6.8 3.5-10.7l-80.8-164.2zM528 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.6 0 46.8-29.8 72.4-82.8 72.4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneTrophy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M320 480c0 49.1 19.1 95.3 53.9 130.1 34.7 34.8 81 53.9 130.1 53.9h16c49.1 0 95.3-19.1 130.1-53.9 34.8-34.7 53.9-81 53.9-130.1V184H320v296zM184 352c0 41 26.9 75.8 64 87.6-37.1-11.9-64-46.7-64-87.6zm364 382.5C665 721.8 758.4 630.2 773.8 514 758.3 630.2 665 721.7 548 734.5zM250.2 514C265.6 630.2 359 721.8 476 734.5 359 721.7 265.7 630.2 250.2 514z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 0 0-44 44v148c0 81.7 60 149.6 138.2 162C265.7 630.2 359 721.7 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.7 758.3 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 0 0-44-44zM248 439.6a91.99 91.99 0 0 1-64-87.6V232h64v207.6zM704 480c0 49.1-19.1 95.4-53.9 130.1-34.8 34.8-81 53.9-130.1 53.9h-16c-49.1 0-95.4-19.1-130.1-53.9-34.8-34.8-53.9-81-53.9-130.1V184h384v296zm136-128c0 41-26.9 75.8-64 87.6V232h64v120z"
                }
            }
        ]
    })(props);
}
function AiTwotoneUnlock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M232 840h560V536H232v304zm280-226a48.01 48.01 0 0 1 28 87v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 0 1 28-87z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zm-40 376H232V536h560v304z"
                }
            }
        ]
    })(props);
}
function AiTwotoneUpCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm178 479h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 460.4 406.8 605.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M518.4 360.3a7.95 7.95 0 0 0-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7h46.9c10.3 0 19.9-4.9 25.9-13.2L512 460.4l105.2 145.4c6 8.3 15.7 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.4-12.7l-178-246z"
                }
            }
        ]
    })(props);
}
function AiTwotoneUpSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm143.5-228.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 465.4 406.8 610.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M334 624h46.9c10.3 0 19.9-4.9 25.9-13.2L512 465.4l105.2 145.4c6 8.3 15.7 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.4-12.7l-178-246a7.95 7.95 0 0 0-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7z"
                }
            }
        ]
    })(props);
}
function AiTwotoneUsb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M759.9 504H264.1c-26.5 0-48.1 19.7-48.1 44v292h592V548c0-24.3-21.6-44-48.1-44z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M456 248h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm160 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M760 432V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zM336 184h352v248H336V184zm472 656H216V548c0-24.3 21.6-44 48.1-44h495.8c26.5 0 48.1 19.7 48.1 44v292z"
                }
            }
        ]
    })(props);
}
function AiTwotoneVideoCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M136 792h576V232H136v560zm64-488c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8v-48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM712 792H136V232h576v560zm176-167l-104-59.8V458.9L888 399v226z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M208 360h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneWallet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 464H528V448h312v128zm0-192H496c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h344v200H184V184h656v200z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M528 576h312V448H528v128zm92-104c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M580 512a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V640H496c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32h344V184H184v656z"
                }
            }
        ]
    })(props);
}
function AiTwotoneWarning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M172.2 828.1h679.6L512 239.9 172.2 828.1zM560 720a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0zm-16-304v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M464 720a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8z"
                }
            }
        ]
    })(props);
}

},{"../lib":"hOIFC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dXOCa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALLELE_META", ()=>vs);
parcelHelpers.export(exports, "ALL_MODES", ()=>vi);
parcelHelpers.export(exports, "AgreementMark", ()=>ni);
parcelHelpers.export(exports, "AlleleChip", ()=>ti);
parcelHelpers.export(exports, "AlleleLegend", ()=>Al);
parcelHelpers.export(exports, "AlleleMatrix", ()=>El);
parcelHelpers.export(exports, "AssayOptions", ()=>Ol);
parcelHelpers.export(exports, "CDNA_GB_ESTIMATE", ()=>Ii);
parcelHelpers.export(exports, "CHECK_DEFAULTS", ()=>Re);
parcelHelpers.export(exports, "CHECK_LIMITS", ()=>ae);
parcelHelpers.export(exports, "CHECK_PARAM_LIMITS", ()=>sr);
parcelHelpers.export(exports, "COMMON_ENZYMES", ()=>qt);
parcelHelpers.export(exports, "CONSEQUENCE_PALETTE", ()=>bn);
parcelHelpers.export(exports, "CPU_S_PER_PRIMER_GB", ()=>Wr);
parcelHelpers.export(exports, "CheckRequestError", ()=>be);
parcelHelpers.export(exports, "DEFAULT_POLL", ()=>pt);
parcelHelpers.export(exports, "DEFAULT_TIMEOUTS", ()=>os);
parcelHelpers.export(exports, "DESIGN_LIMITS", ()=>ee);
parcelHelpers.export(exports, "DESIGN_MODES", ()=>ur);
parcelHelpers.export(exports, "DESIGN_PARAM_LIMITS", ()=>he);
parcelHelpers.export(exports, "ENZYME_PALETTE", ()=>ir);
parcelHelpers.export(exports, "EXPLAIN_HINTS", ()=>ul);
parcelHelpers.export(exports, "FALLBACK_GENOME_GB", ()=>Oi);
parcelHelpers.export(exports, "GENOTYPE_CALLS_TSV_HEADER", ()=>Go);
parcelHelpers.export(exports, "GENOTYPE_CPU_S_PER_GENOME", ()=>zi);
parcelHelpers.export(exports, "GENOTYPING_CHECK_LIMITS", ()=>$e);
parcelHelpers.export(exports, "GENOTYPING_FLOORS", ()=>Vr);
parcelHelpers.export(exports, "GENOTYPING_LADDER", ()=>Si);
parcelHelpers.export(exports, "GENOTYPING_LEVEL0_PARAMS", ()=>Ci);
parcelHelpers.export(exports, "GENOTYPING_LIMITS", ()=>ye);
parcelHelpers.export(exports, "GENOTYPING_NUMERIC_PARAM_KEYS", ()=>aa);
parcelHelpers.export(exports, "GENOTYPING_PARAM_LIMITS", ()=>Tn);
parcelHelpers.export(exports, "GENOTYPING_PRESETS", ()=>nr);
parcelHelpers.export(exports, "GenomePicker", ()=>Ga);
parcelHelpers.export(exports, "GenotypeChip", ()=>jr);
parcelHelpers.export(exports, "GenotypingPanel", ()=>Vc);
parcelHelpers.export(exports, "MASK_SOURCE_LABELS", ()=>pr);
parcelHelpers.export(exports, "MAX_JOB_CPU_S", ()=>ca);
parcelHelpers.export(exports, "ManualVariantInputs", ()=>vc);
parcelHelpers.export(exports, "NUMERIC_DESIGN_PARAM_KEYS", ()=>hr);
parcelHelpers.export(exports, "OFF_TARGETS_TSV_HEADER", ()=>Po);
parcelHelpers.export(exports, "ORDER_TSV_HEADER", ()=>zo);
parcelHelpers.export(exports, "OrderSheet", ()=>ql);
parcelHelpers.export(exports, "OrientationExplain", ()=>Bl);
parcelHelpers.export(exports, "PAIRS_TSV_HEADER", ()=>$o);
parcelHelpers.export(exports, "PANGENOME_CPU_FACTOR", ()=>Pi);
parcelHelpers.export(exports, "PANGENOME_STATUSES", ()=>Rr);
parcelHelpers.export(exports, "PANGENOME_STATUS_META", ()=>ft);
parcelHelpers.export(exports, "PANGENOME_TRANSCRIPT_MODELS_ONLY", ()=>Ea);
parcelHelpers.export(exports, "PANGENOME_TSV_HEADER", ()=>jo);
parcelHelpers.export(exports, "PANGENOME_WORD_SIZE", ()=>Ri);
parcelHelpers.export(exports, "PREDICTION_META", ()=>xs);
parcelHelpers.export(exports, "PRESETS", ()=>en);
parcelHelpers.export(exports, "PRIMER3_DEFAULTS", ()=>Ai);
parcelHelpers.export(exports, "PRIMERS_CSS", ()=>Zo);
parcelHelpers.export(exports, "PRIMER_STATUS_META", ()=>Ns);
parcelHelpers.export(exports, "PairsTable", ()=>dd);
parcelHelpers.export(exports, "PangenomeLegend", ()=>Wl);
parcelHelpers.export(exports, "PangenomeMatrix", ()=>si);
parcelHelpers.export(exports, "PredictionChip", ()=>ks);
parcelHelpers.export(exports, "PrimerDesigner", ()=>ea);
parcelHelpers.export(exports, "PrimerStatusChip", ()=>wn);
parcelHelpers.export(exports, "PrimersApiError", ()=>He);
parcelHelpers.export(exports, "REALIGN_CPU_S_PER_PRIMER_TASK", ()=>Mi);
parcelHelpers.export(exports, "REFERENCE_WORD_SIZE", ()=>$i);
parcelHelpers.export(exports, "SIX_CUTTER_SPECIFICITY", ()=>to);
parcelHelpers.export(exports, "STYLE_ELEMENT_ID", ()=>fs);
parcelHelpers.export(exports, "SetDetail", ()=>Xl);
parcelHelpers.export(exports, "SetsTable", ()=>ec);
parcelHelpers.export(exports, "SpecificityResults", ()=>oi);
parcelHelpers.export(exports, "TemplateMap", ()=>Mc);
parcelHelpers.export(exports, "VARIANT_ALLELE_PATTERN", ()=>Kr);
parcelHelpers.export(exports, "VERDICT_META", ()=>Ql);
parcelHelpers.export(exports, "VERSION", ()=>Hd);
parcelHelpers.export(exports, "VariantBrowser", ()=>zc);
parcelHelpers.export(exports, "VariantPicker", ()=>Kc);
parcelHelpers.export(exports, "WARNING_TEXT", ()=>nl);
parcelHelpers.export(exports, "alleleMatrixRows", ()=>wl);
parcelHelpers.export(exports, "alleleMeta", ()=>Gr);
parcelHelpers.export(exports, "alleleShare", ()=>gc);
parcelHelpers.export(exports, "allocateEnzymeColours", ()=>ro);
parcelHelpers.export(exports, "ampliconSeq", ()=>Na);
parcelHelpers.export(exports, "ampliconsToFasta", ()=>Sa);
parcelHelpers.export(exports, "amplifiesFraction", ()=>Ia);
parcelHelpers.export(exports, "annotateVariants", ()=>mo);
parcelHelpers.export(exports, "availableGenomeNames", ()=>xr);
parcelHelpers.export(exports, "availableModes", ()=>Nr);
parcelHelpers.export(exports, "bestPopulation", ()=>Bd);
parcelHelpers.export(exports, "buildCheckRequest", ()=>ma);
parcelHelpers.export(exports, "buildDesignRequest", ()=>Di);
parcelHelpers.export(exports, "buildGenotypingCheckRequest", ()=>Vi);
parcelHelpers.export(exports, "buildGenotypingRequest", ()=>Hi);
parcelHelpers.export(exports, "buildMatrixRows", ()=>Kl);
parcelHelpers.export(exports, "canAddPairToCheck", ()=>Ui);
parcelHelpers.export(exports, "canonicalTranscriptId", ()=>gr);
parcelHelpers.export(exports, "capsCall", ()=>lo);
parcelHelpers.export(exports, "cdnaToGenomicBlocks", ()=>Id);
parcelHelpers.export(exports, "changedCheckParams", ()=>pa);
parcelHelpers.export(exports, "changedDesignParams", ()=>Gi);
parcelHelpers.export(exports, "changedGenotypingAssay", ()=>Ti);
parcelHelpers.export(exports, "changedGenotypingParams", ()=>la);
parcelHelpers.export(exports, "checkMaxProductSize", ()=>ga);
parcelHelpers.export(exports, "checkPairId", ()=>Xr);
parcelHelpers.export(exports, "checkSelectionSummary", ()=>ji);
parcelHelpers.export(exports, "cleanSequenceInput", ()=>ia);
parcelHelpers.export(exports, "consequenceColor", ()=>Hn);
parcelHelpers.export(exports, "consequenceLabel", ()=>Ms);
parcelHelpers.export(exports, "copyText", ()=>Ja);
parcelHelpers.export(exports, "createPrimersClient", ()=>ko);
parcelHelpers.export(exports, "dcapsOpportunities", ()=>oo);
parcelHelpers.export(exports, "dedupePopulations", ()=>Ur);
parcelHelpers.export(exports, "defaultGenotypingAssay", ()=>fr);
parcelHelpers.export(exports, "defaultPangenomeGenomes", ()=>an);
parcelHelpers.export(exports, "defaultPresetFor", ()=>St);
parcelHelpers.export(exports, "designModeOf", ()=>Ze);
parcelHelpers.export(exports, "designRequestFor", ()=>Qs);
parcelHelpers.export(exports, "designSetTriple", ()=>Ao);
parcelHelpers.export(exports, "designerIdentity", ()=>Zi);
parcelHelpers.export(exports, "designerReducer", ()=>Yc);
parcelHelpers.export(exports, "differentialSites", ()=>xa);
parcelHelpers.export(exports, "digestAmplicon", ()=>Sr);
parcelHelpers.export(exports, "digestFragments", ()=>po);
parcelHelpers.export(exports, "downloadText", ()=>yl);
parcelHelpers.export(exports, "effectiveDesignParams", ()=>br);
parcelHelpers.export(exports, "effectiveGenotypingAssay", ()=>oa);
parcelHelpers.export(exports, "effectiveMaxAmplifyingMismatches", ()=>Bi);
parcelHelpers.export(exports, "effectiveMinProductSize", ()=>wi);
parcelHelpers.export(exports, "emptyGenotypeSetSummary", ()=>jd);
parcelHelpers.export(exports, "emptyGenotypeSummary", ()=>xl);
parcelHelpers.export(exports, "emptyPangenomeSummary", ()=>Fo);
parcelHelpers.export(exports, "ensureStylesInjected", ()=>el);
parcelHelpers.export(exports, "enzymeColor", ()=>va);
parcelHelpers.export(exports, "enzymeCounts", ()=>uo);
parcelHelpers.export(exports, "enzymeSpecificity", ()=>Ar);
parcelHelpers.export(exports, "estimateCheckCpu", ()=>yr);
parcelHelpers.export(exports, "expectedMaskSource", ()=>$l);
parcelHelpers.export(exports, "explainRows", ()=>hl);
parcelHelpers.export(exports, "findEnzyme", ()=>no);
parcelHelpers.export(exports, "findSites", ()=>on);
parcelHelpers.export(exports, "flattenValidationErrors", ()=>ka);
parcelHelpers.export(exports, "formatGenomic", ()=>gt);
parcelHelpers.export(exports, "formatRegion", ()=>Zt);
parcelHelpers.export(exports, "geneLength", ()=>mr);
parcelHelpers.export(exports, "geneRelativeToGenomic", ()=>Td);
parcelHelpers.export(exports, "geneTemplateExtent", ()=>ra);
parcelHelpers.export(exports, "genomeAvailability", ()=>Dn);
parcelHelpers.export(exports, "genomicToTemplatePosition", ()=>rs);
parcelHelpers.export(exports, "genotypeCallsToTSV", ()=>Do);
parcelHelpers.export(exports, "genotypingSetTriple", ()=>or);
parcelHelpers.export(exports, "hashString", ()=>wr);
parcelHelpers.export(exports, "initialDesignerState", ()=>ba);
parcelHelpers.export(exports, "isAbortError", ()=>Ue);
parcelHelpers.export(exports, "isCheckablePair", ()=>da);
parcelHelpers.export(exports, "isCheckablePrimer", ()=>Jr);
parcelHelpers.export(exports, "isConsistentGenotypeSummary", ()=>Fd);
parcelHelpers.export(exports, "isConsistentSummary", ()=>qd);
parcelHelpers.export(exports, "isDesignMode", ()=>xi);
parcelHelpers.export(exports, "isDisagreement", ()=>ei);
parcelHelpers.export(exports, "isIssueAllele", ()=>Nl);
parcelHelpers.export(exports, "isIssuePrediction", ()=>kl);
parcelHelpers.export(exports, "isIssueStatus", ()=>Bo);
parcelHelpers.export(exports, "isPrimersApiError", ()=>Me);
parcelHelpers.export(exports, "isRepetitivePrimer", ()=>zd);
parcelHelpers.export(exports, "isResolvable", ()=>Md);
parcelHelpers.export(exports, "isRetryableError", ()=>bo);
parcelHelpers.export(exports, "isSixCutter", ()=>Rd);
parcelHelpers.export(exports, "isTerminalJob", ()=>Ye);
parcelHelpers.export(exports, "isTranscriptModelsOnly", ()=>Ho);
parcelHelpers.export(exports, "iupacMatcher", ()=>so);
parcelHelpers.export(exports, "leftFootprint", ()=>wd);
parcelHelpers.export(exports, "matchCheckResults", ()=>Aa);
parcelHelpers.export(exports, "matchGenotypingResults", ()=>Co);
parcelHelpers.export(exports, "minorAlleleFrequency", ()=>mc);
parcelHelpers.export(exports, "mismatchGlyphIndex", ()=>bi);
parcelHelpers.export(exports, "mismatchIndexes", ()=>yi);
parcelHelpers.export(exports, "mount", ()=>Kd);
parcelHelpers.export(exports, "needsJobDocument", ()=>yo);
parcelHelpers.export(exports, "nextPollDelay", ()=>ss);
parcelHelpers.export(exports, "niceTicks", ()=>di);
parcelHelpers.export(exports, "nonCutters", ()=>fo);
parcelHelpers.export(exports, "normalizeDesignerState", ()=>Zr);
parcelHelpers.export(exports, "offTargetsToTSV", ()=>Oo);
parcelHelpers.export(exports, "orderRowsToFasta", ()=>qo);
parcelHelpers.export(exports, "orderSheetToTSV", ()=>Lo);
parcelHelpers.export(exports, "packPairLanes", ()=>Ec);
parcelHelpers.export(exports, "pairCheckability", ()=>vr);
parcelHelpers.export(exports, "pairKey", ()=>ht);
parcelHelpers.export(exports, "pairsToTSV", ()=>Ro);
parcelHelpers.export(exports, "pangenomeCellText", ()=>Ko);
parcelHelpers.export(exports, "pangenomeRows", ()=>Gd);
parcelHelpers.export(exports, "pangenomeToTSV", ()=>Uo);
parcelHelpers.export(exports, "parseExplainString", ()=>Wa);
parcelHelpers.export(exports, "parseRetryAfter", ()=>vo);
parcelHelpers.export(exports, "pollCheckJob", ()=>is);
parcelHelpers.export(exports, "populationCounts", ()=>li);
parcelHelpers.export(exports, "populationsOf", ()=>dc);
parcelHelpers.export(exports, "predictionMeta", ()=>Dr);
parcelHelpers.export(exports, "presetParams", ()=>Ei);
parcelHelpers.export(exports, "primerStatusMeta", ()=>vl);
parcelHelpers.export(exports, "primersToFasta", ()=>Mo);
parcelHelpers.export(exports, "productSize", ()=>Cd);
parcelHelpers.export(exports, "regionFromGene", ()=>_r);
parcelHelpers.export(exports, "revcomp", ()=>An);
parcelHelpers.export(exports, "rightFootprint", ()=>Ad);
parcelHelpers.export(exports, "singleCutters", ()=>Pd);
parcelHelpers.export(exports, "siteWithCut", ()=>_a);
parcelHelpers.export(exports, "sortPangenomeRows", ()=>Dd);
parcelHelpers.export(exports, "spansJunction", ()=>Sd);
parcelHelpers.export(exports, "submittedGenotypingSets", ()=>So);
parcelHelpers.export(exports, "submittedPairs", ()=>wo);
parcelHelpers.export(exports, "summarizeExplain", ()=>fl);
parcelHelpers.export(exports, "summarizeGenotypeGenomes", ()=>Ud);
parcelHelpers.export(exports, "summarizePangenome", ()=>Ld);
parcelHelpers.export(exports, "templateToGenomic", ()=>_i);
parcelHelpers.export(exports, "toApiError", ()=>xo);
parcelHelpers.export(exports, "toPersistedState", ()=>ya);
parcelHelpers.export(exports, "toTSV", ()=>ln);
parcelHelpers.export(exports, "transcriptLayout", ()=>Ed);
parcelHelpers.export(exports, "truncatedGenomeCount", ()=>lr);
parcelHelpers.export(exports, "tsvCell", ()=>Sn);
parcelHelpers.export(exports, "uniquePrimers", ()=>En);
parcelHelpers.export(exports, "unlikelyReason", ()=>Tr);
parcelHelpers.export(exports, "unlikelyText", ()=>Er);
parcelHelpers.export(exports, "validateCheckParams", ()=>Ki);
parcelHelpers.export(exports, "validateDesignParams", ()=>Ni);
parcelHelpers.export(exports, "validateGenotypingParams", ()=>$d);
parcelHelpers.export(exports, "validateInterval", ()=>kn);
parcelHelpers.export(exports, "validateIntervals", ()=>ki);
parcelHelpers.export(exports, "validateVariantInput", ()=>Hr);
parcelHelpers.export(exports, "variantAllele", ()=>pc);
parcelHelpers.export(exports, "variantContext", ()=>ao);
parcelHelpers.export(exports, "variantOnTemplate", ()=>Od);
parcelHelpers.export(exports, "verifyWindow", ()=>go);
var _jsxRuntime = require("react/jsx-runtime");
var _client = require("react-dom/client");
var _react = require("react");
const fi = {
    A: "T",
    T: "A",
    U: "A",
    G: "C",
    C: "G",
    R: "Y",
    Y: "R",
    K: "M",
    M: "K",
    S: "S",
    W: "W",
    B: "V",
    V: "B",
    D: "H",
    H: "D",
    N: "N",
    a: "t",
    t: "a",
    u: "a",
    g: "c",
    c: "g",
    r: "y",
    y: "r",
    k: "m",
    m: "k",
    s: "s",
    w: "w",
    b: "v",
    v: "b",
    d: "h",
    h: "d",
    n: "n"
};
function An(e) {
    let t = "";
    for(let r = e.length - 1; r >= 0; r--){
        const n = e[r];
        t += fi[n] ?? n;
    }
    return t;
}
function bi(e, t) {
    return !Number.isInteger(e) || !Number.isInteger(t) || t < 1 || t > e ? null : e - t;
}
function yi(e, t) {
    const r = /* @__PURE__ */ new Set();
    for (const n of t ?? []){
        const a = bi(e, n);
        a !== null && r.add(a);
    }
    return [
        ...r
    ].sort((n, a)=>n - a);
}
function wd(e, t) {
    return {
        start: e,
        end: e + t - 1
    };
}
function Ad(e, t) {
    return {
        start: e - t + 1,
        end: e
    };
}
function Cd(e, t) {
    return t - e + 1;
}
function Sd(e, t, r, n, a) {
    const i = r - t.start + 1, l = t.end - r;
    return e === "left" ? i >= n && l >= a : i >= a && l >= n;
}
function _i(e, t) {
    return t.strand === 1 ? t.start + e - 1 : t.end - e + 1;
}
function Td(e, t) {
    return t.strand === 1 ? t.start + e - 1 : t.end - e + 1;
}
function gr(e) {
    const t = e?.gene_structure;
    return t ? t.canonical_transcript && t.transcripts?.some((r)=>r.id === t.canonical_transcript) ? t.canonical_transcript : t.transcripts?.[0]?.id ?? null : null;
}
function Ed(e, t) {
    const r = e.gene_structure, n = e.location;
    if (!r || !n) return null;
    const a = t ?? gr(e), i = r.transcripts?.find((p)=>p.id === a);
    if (!i) return null;
    const l = new Map(r.exons.map((p)=>[
            p.id,
            p
        ])), o = [];
    let d = 0;
    for (const p of i.exons){
        const g = l.get(p);
        if (!g) return null;
        const m = g.end - g.start + 1, f = n.strand === 1 ? n.start + g.start - 1 : n.end - g.end + 1, u = n.strand === 1 ? n.start + g.end - 1 : n.end - g.start + 1;
        o.push({
            exonId: p,
            tStart: d + 1,
            tEnd: d + m,
            gStart: f,
            gEnd: u
        }), d += m;
    }
    return {
        transcriptId: i.id,
        length: d,
        strand: n.strand,
        region: n.region,
        segments: o,
        junctions: o.slice(0, -1).map((p)=>p.tEnd),
        cds: i.cds ? {
            start: i.cds.start,
            end: i.cds.end
        } : null
    };
}
function Id(e, t, r) {
    const n = [];
    for (const a of e.segments){
        const i = Math.max(t, a.tStart), l = Math.min(r, a.tEnd);
        i > l || (e.strand === 1 ? n.push({
            start: a.gStart + i - a.tStart,
            end: a.gStart + l - a.tStart
        }) : n.push({
            start: a.gEnd - (l - a.tStart),
            end: a.gEnd - (i - a.tStart)
        }));
    }
    return n.sort((a, i)=>a.start - i.start);
}
function ra(e, t = 0, r = 0) {
    const { start: n, end: a, strand: i } = e.location, l = Math.max(0, t), o = Math.max(0, r), d = i === 1 ? Math.max(1, n - l) : Math.max(1, n - o), p = i === 1 ? a + o : a + l, g = i === 1 ? n - d : p - a;
    return {
        start: d,
        end: p,
        length: p - d + 1,
        effUp: g
    };
}
function mr(e) {
    return e.location.end - e.location.start + 1;
}
const sa = (e)=>e === -1 ? "-" : "+";
function gt(e) {
    if (!e) return "";
    const t = "blocks" in e && Array.isArray(e.blocks) && e.blocks.length ? e.blocks : [
        {
            start: e.start,
            end: e.end
        }
    ];
    return `${e.region}:${t.map((r)=>`${r.start}-${r.end}`).join(",")}(${sa(e.strand)})`;
}
function Zt(e, t, r, n) {
    return `${e}:${t}-${r}${n ? `(${sa(n)})` : ""}`;
}
const ur = Object.freeze([
    "gene",
    "transcript",
    "region",
    "sequence"
]), vi = Object.freeze([
    ...ur,
    "genotyping"
]);
function xi(e) {
    return !!e && ur.includes(e);
}
function Ze(e) {
    return xi(e) ? e : "region";
}
const ee = Object.freeze({
    maxTemplateLength: 5e4,
    minSequenceLength: 20,
    maxSequenceLength: 5e4,
    maxSequenceInput: 6e4,
    maxFlank: 1e4,
    maxExcluded: 50,
    maxProductRanges: 10,
    minProductSize: 20,
    maxProductSize: 5e4,
    maxIdLength: 255,
    systemNamePattern: /^[a-z0-9_]+$/
}), he = Object.freeze({
    opt_size: {
        min: 15,
        max: 36,
        integer: !0
    },
    min_size: {
        min: 15,
        max: 36,
        integer: !0
    },
    max_size: {
        min: 15,
        max: 36,
        integer: !0
    },
    opt_tm: {
        min: 30,
        max: 90,
        integer: !1
    },
    min_tm: {
        min: 30,
        max: 90,
        integer: !1
    },
    max_tm: {
        min: 30,
        max: 90,
        integer: !1
    },
    opt_gc: {
        min: 0,
        max: 100,
        integer: !1
    },
    min_gc: {
        min: 0,
        max: 100,
        integer: !1
    },
    max_gc: {
        min: 0,
        max: 100,
        integer: !1
    },
    max_tm_diff: {
        min: 0,
        max: 30,
        integer: !1
    },
    max_poly_x: {
        min: 0,
        max: 10,
        integer: !0
    },
    gc_clamp: {
        min: 0,
        max: 5,
        integer: !0
    },
    max_end_stability: {
        min: 0,
        max: 100,
        integer: !1
    },
    max_ns: {
        min: 0,
        max: 5,
        integer: !0
    },
    salt_monovalent: {
        min: 0,
        max: 1e3,
        integer: !1
    },
    salt_divalent: {
        min: 0,
        max: 100,
        integer: !1
    },
    dntp_conc: {
        min: 0,
        max: 100,
        integer: !1
    },
    dna_conc: {
        min: 0,
        max: 1e4,
        integer: !1
    },
    num_return: {
        min: 1,
        max: 20,
        integer: !0
    },
    min_3_prime_overlap_of_junction: {
        min: 1,
        max: 20,
        integer: !0
    },
    min_5_prime_overlap_of_junction: {
        min: 1,
        max: 20,
        integer: !0
    }
}), hr = Object.freeze(Object.keys(he));
function ge(e) {
    return typeof e == "number" && Number.isFinite(e);
}
function Ni(e, t = {}) {
    const r = [], n = e;
    for (const i of hr){
        const l = n[i];
        if (l == null) continue;
        const o = he[i];
        if (!ge(l)) {
            r.push({
                field: i,
                code: "NOT_A_NUMBER",
                message: `${i} must be a number`
            });
            continue;
        }
        o.integer && !Number.isInteger(l) && r.push({
            field: i,
            code: "NOT_AN_INTEGER",
            message: `${i} must be a whole number`
        }), (l < o.min || l > o.max) && r.push({
            field: i,
            code: "OUT_OF_RANGE",
            message: `${i} must be between ${o.min} and ${o.max}`
        });
    }
    for (const [i, l, o, d] of [
        [
            "size",
            "min_size",
            "opt_size",
            "max_size"
        ],
        [
            "Tm",
            "min_tm",
            "opt_tm",
            "max_tm"
        ],
        [
            "GC",
            "min_gc",
            "opt_gc",
            "max_gc"
        ]
    ]){
        const p = n[l], g = n[o], m = n[d];
        ge(p) && ge(m) && p > m && r.push({
            field: l,
            code: "MIN_GT_MAX",
            message: `Minimum ${i} must not exceed maximum ${i}`
        }), ge(g) && ge(p) && g < p && r.push({
            field: o,
            code: "OPT_LT_MIN",
            message: `Optimal ${i} must be at least the minimum`
        }), ge(g) && ge(m) && g > m && r.push({
            field: o,
            code: "OPT_GT_MAX",
            message: `Optimal ${i} must not exceed the maximum`
        });
    }
    const a = n.product_size_ranges;
    if (a !== void 0) {
        if (!Array.isArray(a) || a.length < 1) r.push({
            field: "product_size_ranges",
            code: "REQUIRED",
            message: "At least one product size range is required"
        });
        else {
            a.length > ee.maxProductRanges && r.push({
                field: "product_size_ranges",
                code: "TOO_MANY",
                message: `At most ${ee.maxProductRanges} product size ranges`
            }), a.forEach((o, d)=>{
                const p = `product_size_ranges[${d}]`;
                if (!Array.isArray(o) || o.length !== 2 || !o.every((f)=>ge(f) && Number.isInteger(f))) {
                    r.push({
                        field: p,
                        code: "INVALID_RANGE",
                        message: "Product size range must be two whole numbers"
                    });
                    return;
                }
                const [g, m] = o;
                (g < ee.minProductSize || m > ee.maxProductSize || m < ee.minProductSize || g > ee.maxProductSize) && r.push({
                    field: p,
                    code: "OUT_OF_RANGE",
                    message: `Product sizes must be between ${ee.minProductSize} and ${ee.maxProductSize}`
                }), g < m || r.push({
                    field: p,
                    code: "MIN_GE_MAX",
                    message: "Range start must be smaller than its end"
                });
            });
            const i = a.filter((o)=>Array.isArray(o) && ge(o[0])).map((o)=>o[0]);
            if (ge(n.max_size) && i.length && n.max_size > Math.min(...i)) {
                const o = Math.min(...i);
                r.push({
                    field: "max_size",
                    code: "MAX_SIZE_GT_PRODUCT",
                    message: `Maximum primer size (${n.max_size}) must not exceed the smallest product size (${o})`
                });
            }
            const l = t.templateLength;
            ge(l) && a.every((o)=>Array.isArray(o) && ge(o[0]) && o[0] > l) && r.push({
                field: "product_size_ranges",
                code: "LONGER_THAN_TEMPLATE",
                message: `No product size range starts at or below the template length (${l})`
            });
        }
    }
    if (t.mode === "transcript" && t.junctionSpanning !== !1 && ge(n.max_size)) {
        const i = Math.floor(n.max_size / 2);
        for (const l of [
            "min_5_prime_overlap_of_junction",
            "min_3_prime_overlap_of_junction"
        ]){
            const o = n[l];
            ge(o) && o > i && r.push({
                field: l,
                code: "JUNCTION_OVERLAP_TOO_LARGE",
                message: `${l} must be at most floor(max_size/2) = ${i}`
            });
        }
    }
    return r;
}
function kn(e, t, r) {
    if (!Array.isArray(t) || t.length !== 2 || !t.every((l)=>ge(l) && Number.isInteger(l))) return [
        {
            field: e,
            code: "INVALID_INTERVAL",
            message: "Interval must be [start, length] whole numbers"
        }
    ];
    const [n, a] = t, i = [];
    return n < 1 && i.push({
        field: e,
        code: "OUT_OF_RANGE",
        message: "Interval start must be \u2265 1"
    }), a < 1 && i.push({
        field: e,
        code: "OUT_OF_RANGE",
        message: "Interval length must be \u2265 1"
    }), ge(r) && n + a - 1 > r && i.push({
        field: e,
        code: "INTERVAL_OUT_OF_BOUNDS",
        message: `Interval ends past the template (length ${r})`
    }), i;
}
function ki(e, t) {
    const r = [];
    e.target && r.push(...kn("target", e.target, t)), e.included && r.push(...kn("included", e.included, t));
    const n = e.excluded ?? [];
    return n.length > ee.maxExcluded && r.push({
        field: "excluded",
        code: "TOO_MANY",
        message: `At most ${ee.maxExcluded} excluded intervals`
    }), n.forEach((a, i)=>r.push(...kn(`excluded[${i}]`, a, t))), r;
}
const Kr = /^([ACGTacgt]{1,50}|-)$/, ye = Object.freeze({
    /** `400 VARIANT_WINDOW_TOO_LONG` above this. */ maxWindow: 5e4,
    maxAlleleLength: 50,
    defaultVariantLimit: 2e3,
    maxVariantLimit: 5e3,
    minSets: 1,
    maxSets: 10,
    maxRelaxation: 2,
    minProductSize: 20,
    maxProductSize: 1e3,
    maxProductRanges: 4,
    /** An indel that slides further is `400 VARIANT_TOO_REPETITIVE`. */ maxShift: 1e3
}), Tn = Object.freeze({
    opt_size: he.opt_size,
    min_size: he.min_size,
    max_size: he.max_size,
    opt_tm: he.opt_tm,
    min_tm: he.min_tm,
    max_tm: he.max_tm,
    opt_gc: he.opt_gc,
    min_gc: he.min_gc,
    max_gc: he.max_gc,
    max_tm_diff: he.max_tm_diff,
    max_poly_x: he.max_poly_x,
    gc_clamp: he.gc_clamp,
    max_end_stability: he.max_end_stability,
    salt_monovalent: he.salt_monovalent,
    salt_divalent: he.salt_divalent,
    dntp_conc: he.dntp_conc,
    dna_conc: he.dna_conc
}), aa = Object.freeze(Object.keys(Tn));
function wi(e) {
    return ge(e) ? 2 * Math.round(e) + 1 : null;
}
function $d(e) {
    const t = [];
    if (!e) return t;
    const r = e;
    for (const a of aa){
        const i = r[a];
        if (i == null) continue;
        const l = Tn[a];
        if (!ge(i)) {
            t.push({
                field: a,
                code: "NOT_A_NUMBER",
                message: `${a} must be a number`
            });
            continue;
        }
        l.integer && !Number.isInteger(i) && t.push({
            field: a,
            code: "NOT_AN_INTEGER",
            message: `${a} must be a whole number`
        }), (i < l.min || i > l.max) && t.push({
            field: a,
            code: "OUT_OF_RANGE",
            message: `${a} must be between ${l.min} and ${l.max}`
        });
    }
    for (const [a, i, l, o] of [
        [
            "size",
            "min_size",
            "opt_size",
            "max_size"
        ],
        [
            "Tm",
            "min_tm",
            "opt_tm",
            "max_tm"
        ],
        [
            "GC",
            "min_gc",
            "opt_gc",
            "max_gc"
        ]
    ]){
        const d = r[i], p = r[l], g = r[o];
        ge(d) && ge(g) && d > g && t.push({
            field: i,
            code: "MIN_GT_MAX",
            message: `Minimum ${a} must not exceed maximum ${a}`
        }), ge(p) && ge(d) && p < d && t.push({
            field: l,
            code: "OPT_LT_MIN",
            message: `Optimal ${a} must be at least the minimum`
        }), ge(p) && ge(g) && p > g && t.push({
            field: l,
            code: "OPT_GT_MAX",
            message: `Optimal ${a} must not exceed the maximum`
        });
    }
    const n = r.product_size_ranges;
    if (n !== void 0) {
        if (!Array.isArray(n) || n.length < 1) t.push({
            field: "product_size_ranges",
            code: "REQUIRED",
            message: "At least one product size range is required"
        });
        else {
            n.length > ye.maxProductRanges && t.push({
                field: "product_size_ranges",
                code: "TOO_MANY",
                message: `At most ${ye.maxProductRanges} product size ranges`
            });
            const a = wi(ge(r.max_size) ? r.max_size : null);
            n.forEach((i, l)=>{
                const o = `product_size_ranges[${l}]`;
                if (!Array.isArray(i) || i.length !== 2 || !i.every((g)=>ge(g) && Number.isInteger(g))) {
                    t.push({
                        field: o,
                        code: "INVALID_RANGE",
                        message: "Product size range must be two whole numbers"
                    });
                    return;
                }
                const [d, p] = i;
                (d < ye.minProductSize || p > ye.maxProductSize) && t.push({
                    field: o,
                    code: "OUT_OF_RANGE",
                    message: `Product sizes must be between ${ye.minProductSize} and ${ye.maxProductSize}`
                }), d < p || t.push({
                    field: o,
                    code: "MIN_GE_MAX",
                    message: "Range start must be smaller than its end"
                }), a !== null && p < a && t.push({
                    field: o,
                    code: "BELOW_EFFECTIVE_MINIMUM",
                    message: `Both primers meet at the variant, so no product is shorter than 2 \xd7 max_size + 1 = ${a} bp`
                });
            });
        }
    }
    return t;
}
function Hr(e) {
    const t = [], r = typeof e?.id == "string" ? e.id.trim() : "", n = typeof e?.region == "string" ? e.region.trim() : "", a = e?.position !== void 0 && e?.position !== null && String(e.position).trim() !== "", i = typeof e?.ref == "string" ? e.ref.trim() : "", l = [
        n,
        a ? "p" : "",
        i
    ].filter(Boolean).length, o = typeof e?.alt == "string" ? e.alt.trim() : "";
    if (!r && l === 0) return t.push({
        field: "variant",
        code: "REQUIRED",
        message: "Choose a variant, or enter its region, position, REF and ALT"
    }), t;
    if (r && l > 0) return t.push({
        field: "variant",
        code: "ID_OR_MANUAL",
        message: "Give either a variant id or region, position, REF and ALT \u2014 not both"
    }), t;
    if (r) return r.length > ee.maxIdLength && t.push({
        field: "id",
        code: "TOO_LONG",
        message: `A variant id is at most ${ee.maxIdLength} characters`
    }), o && !Kr.test(o) && t.push({
        field: "alt",
        code: "INVALID_ALLELE",
        message: "ALT must be 1\u201350 bases of A, C, G or T, or `-`"
    }), t;
    n || t.push({
        field: "region",
        code: "REQUIRED",
        message: "Enter the sequence region"
    });
    const d = Number(String(e?.position ?? "").trim());
    (!a || !Number.isInteger(d) || d < 1) && t.push({
        field: "position",
        code: "INVALID_POSITION",
        message: "Position must be a whole number of at least 1"
    });
    for (const [p, g] of [
        [
            "ref",
            i
        ],
        [
            "alt",
            o
        ]
    ])g ? Kr.test(g) || t.push({
        field: p,
        code: "INVALID_ALLELE",
        message: `${p.toUpperCase()} must be 1\u{2013}50 bases of A, C, G or T, or \`-\``
    }) : t.push({
        field: p,
        code: "REQUIRED",
        message: `Enter ${p.toUpperCase()}`
    });
    return i && o && (i.toUpperCase() === o.toUpperCase() && t.push({
        field: "alt",
        code: "REF_EQUALS_ALT",
        message: "REF and ALT must differ"
    }), i === "-" && o === "-" && t.push({
        field: "ref",
        code: "INVALID_ALLELE",
        message: "REF and ALT cannot both be `-`"
    })), t;
}
function ia(e) {
    let t = 0, r = !1;
    const n = String(e ?? "").split(/\r\n|\r|\n/).filter((p)=>/^\s*>/.test(p) ? (r = !1, !1) : (!r && /[^\s\d]/.test(p) && (r = !0, t += 1), !0)).join("").replace(/[\s\d]+/g, ""), a = /* @__PURE__ */ new Set();
    for (const p of n)/[ACGTRYKMSWBDHVN]/i.test(p) || a.add(p);
    const i = n.length, l = /[RYKMSWBDHV]/i.test(n), o = i < ee.minSequenceLength, d = i > ee.maxSequenceLength;
    return {
        seq: n,
        length: i,
        invalidChars: [
            ...a
        ],
        iupacConverted: l,
        hasLowercase: /[a-z]/.test(n),
        tooShort: o,
        tooLong: d,
        records: t,
        ok: a.size === 0 && !o && !d
    };
}
function Lt(e) {
    if (e && typeof e == "object") {
        for (const t of Object.values(e))Lt(t);
        Object.freeze(e);
    }
    return e;
}
const en = Lt({
    pcr: {
        id: "pcr",
        label: "PCR",
        description: "Genomic PCR: 18\u201325 nt, Tm 57\u201363 \xb0C, 100\u20131000 bp products.",
        modes: [
            "gene",
            "region",
            "sequence"
        ],
        junction_spanning: !1,
        params: {
            opt_size: 20,
            min_size: 18,
            max_size: 25,
            opt_tm: 60,
            min_tm: 57,
            max_tm: 63,
            min_gc: 30,
            max_gc: 70,
            max_tm_diff: 3,
            max_poly_x: 4,
            product_size_ranges: [
                [
                    100,
                    1e3
                ]
            ],
            num_return: 5
        }
    },
    qpcr: {
        id: "qpcr",
        label: "qPCR",
        description: "qPCR on cDNA: 18\u201324 nt, Tm 58\u201362 \xb0C, 70\u2013150 bp, one primer spanning an exon\u2013exon junction.",
        modes: [
            "transcript"
        ],
        junction_spanning: !0,
        params: {
            opt_size: 20,
            min_size: 18,
            max_size: 24,
            opt_tm: 60,
            min_tm: 58,
            max_tm: 62,
            min_gc: 35,
            max_gc: 65,
            max_tm_diff: 2,
            max_poly_x: 4,
            product_size_ranges: [
                [
                    70,
                    150
                ]
            ],
            num_return: 5,
            min_3_prime_overlap_of_junction: 4,
            min_5_prime_overlap_of_junction: 7
        }
    }
}), Ai = Lt({
    opt_gc: null,
    gc_clamp: 0,
    max_end_stability: 100,
    max_ns: 0,
    salt_monovalent: 50,
    salt_divalent: 1.5,
    dntp_conc: 0.6,
    dna_conc: 50,
    min_3_prime_overlap_of_junction: 4,
    min_5_prime_overlap_of_junction: 7
}), Re = Object.freeze({
    max_product_size: 4e3,
    ignore_mismatches: 6,
    max_amplifying_mismatches: 3,
    min_total_mismatches: 2,
    min_3p_mismatches: 2,
    three_prime_window: 5,
    include_unlikely: !1,
    repeat_site_threshold: 5
});
function St(e) {
    return e === "transcript" ? "qpcr" : "pcr";
}
const nr = Lt({
    kasp: {
        id: "kasp",
        label: "KASP",
        description: "Tailed allele-specific primers read by FAM and HEX, plus one common primer.",
        assay: {
            orientation: "both",
            tails: "ref_fam_alt_hex",
            deliberate_mismatch: "none",
            mismatch_position: 2,
            num_sets: 6,
            max_relaxation: 2,
            neighbour_policy: "avoid_3p"
        }
    },
    as_pcr: {
        id: "as_pcr",
        label: "AS-PCR",
        description: "Untailed allele-specific PCR scored on a gel; a deliberate mismatch sharpens discrimination.",
        assay: {
            orientation: "both",
            tails: "none",
            deliberate_mismatch: "auto",
            mismatch_position: 2,
            num_sets: 6,
            max_relaxation: 2,
            neighbour_policy: "avoid_3p"
        }
    }
}), Ci = Lt({
    opt_size: 22,
    min_size: 18,
    max_size: 30,
    opt_tm: 60,
    min_tm: 57,
    max_tm: 63,
    min_gc: 30,
    max_gc: 70,
    max_tm_diff: 3,
    max_poly_x: 5,
    product_size_ranges: [
        [
            61,
            120
        ]
    ]
}), Si = Lt([
    {
        level: 1,
        changes: {
            max_size: 32,
            min_tm: 55,
            max_tm: 65,
            min_gc: 20,
            max_gc: 80,
            product_size_ranges: [
                [
                    65,
                    150
                ]
            ]
        }
    },
    {
        level: 2,
        changes: {
            min_tm: 52,
            max_tm_diff: 6
        }
    }
]), Vr = Object.freeze({
    as_min_tm: 52,
    as_min_gc: 15
});
function fr(e = "kasp") {
    return {
        type: e,
        ...nr[e].assay
    };
}
function oa(e) {
    const t = e?.type === "as_pcr" ? "as_pcr" : "kasp", r = fr(t);
    return e && (e.orientation && (r.orientation = e.orientation), e.tails && (r.tails = e.tails), e.deliberate_mismatch && (r.deliberate_mismatch = e.deliberate_mismatch), typeof e.mismatch_position == "number" && (r.mismatch_position = e.mismatch_position), typeof e.num_sets == "number" && (r.num_sets = e.num_sets), typeof e.max_relaxation == "number" && (r.max_relaxation = e.max_relaxation), e.neighbour_policy && (r.neighbour_policy = e.neighbour_policy)), r;
}
function Ti(e) {
    const t = oa(e), r = fr(t.type), n = {};
    t.type !== "kasp" && (n.type = t.type);
    for (const a of Object.keys(r))a !== "type" && t[a] !== r[a] && (n[a] = t[a]);
    return n;
}
function la(e) {
    const t = {};
    if (!e) return t;
    for (const n of aa){
        const a = e[n];
        if (typeof a != "number" || !Number.isFinite(a)) continue;
        const i = Tn[n];
        i.integer && !Number.isInteger(a) || a < i.min || a > i.max || (t[n] = a);
    }
    const r = e.product_size_ranges;
    return Array.isArray(r) && r.length && r.every((n)=>Array.isArray(n) && n.length === 2 && n.every((a)=>Number.isInteger(a))) && (t.product_size_ranges = r.map((n)=>[
            n[0],
            n[1]
        ])), t;
}
function Ei(e) {
    const t = en[e].params, r = {
        ...t
    };
    return t.product_size_ranges && (r.product_size_ranges = t.product_size_ranges.map((n)=>[
            n[0],
            n[1]
        ])), r;
}
function br(e, t) {
    const r = Ei(e);
    if (t) for (const [n, a] of Object.entries(t))a !== void 0 && (r[n] = n === "product_size_ranges" && Array.isArray(a) ? a.map((i)=>Array.isArray(i) ? [
            ...i
        ] : i) : a);
    return r;
}
const Wr = Object.freeze({
    5: 5.2,
    6: 2.2,
    7: 1.2
}), Ii = 0.15, ca = 6e3, $i = 5, Ri = 6, Mi = 0.6, Pi = 2, Oi = 1, zi = 0.2;
function Li(e) {
    if (typeof e == "number") return Math.max(0, Math.floor(e));
    const t = /* @__PURE__ */ new Set();
    for (const r of e)typeof r == "string" ? t.add(r.toUpperCase()) : (t.add((typeof r.left == "string" ? r.left : r.left.seq).toUpperCase()), t.add((typeof r.right == "string" ? r.right : r.right.seq).toUpperCase()));
    return t.size;
}
function qi(e) {
    return typeof e == "number" ? Number.isFinite(e) ? e : null : e && typeof e == "object" && typeof e.total_bases == "number" ? e.total_bases : null;
}
function Yr(e) {
    return e !== null && Number.isFinite(e) && e > 0 ? e / 1e9 : Oi;
}
function yr(e) {
    const t = Li(e.primers), r = e.wordSizeReference ?? $i, n = e.wordSizePangenome ?? Ri, a = Wr[r], i = Wr[n], l = e.cdnaGb ?? Ii, o = e.limit ?? ca, d = e.mode === "transcript", p = Yr(typeof e.referenceTotalBases == "number" ? e.referenceTotalBases : null), g = t * p * a, m = d ? t * l * a : 0;
    let f = 0;
    const u = e.pangenome ?? [];
    for (const C of u)d ? f += l : f += Yr(qi(C));
    const h = t * f * i * Pi, y = 1 + (d ? 0 : u.length), _ = t * y * Mi, k = e.genotyping ? (1 + u.length) * zi : 0, b = g + m + h + _ + k;
    return {
        // Server ceilCpu: Math.ceil(Math.round(x × 1e6) / 1e6).
        cpu_s: Math.max(0, Math.ceil(Math.round(b * 1e6) / 1e6)),
        reference_cpu_s: g,
        transcriptome_cpu_s: m,
        pangenome_cpu_s: h,
        realign_cpu_s: _,
        genotyping_cpu_s: k,
        genome_tasks: y,
        unique_primers: t,
        genomes: u.length,
        limit: o,
        over_limit: b > o
    };
}
const ae = Object.freeze({
    maxPairs: 10,
    maxUniquePrimers: 20,
    maxGenomes: 150,
    minPrimerLength: 15,
    maxPrimerLength: 36,
    primerPattern: /^[ACGTacgt]{15,36}$/,
    pairIdPattern: /^[A-Za-z0-9_.:-]+$/,
    pairIdMaxLength: 64,
    defaultMaxProductSize: Re.max_product_size,
    /** Products longer than this cannot be checked (server 400 `PRODUCT_TOO_LONG_TO_CHECK`). */ maxProductSize: 1e4,
    /** Automatic raise: `ceil(raiseFactor × largest expected size)`. */ raiseFactor: 1.2,
    maxJobCpuS: 6e3
});
class be extends Error {
    constructor(t, r, n = {}){
        super(r), this.name = "CheckRequestError", this.code = t, this.details = n, Object.setPrototypeOf(this, new.target.prototype);
    }
}
function rr(e, t) {
    return Array.isArray(e) || Array.isArray(t) ? !Array.isArray(e) || !Array.isArray(t) || e.length !== t.length ? !1 : e.every((r, n)=>rr(r, t[n])) : e === t;
}
function tn(e) {
    return typeof e == "number" && Number.isFinite(e);
}
function Gi(e, t, r) {
    const n = en[St(e)].params, a = br(t ?? St(e), r), i = {};
    for (const o of hr){
        const d = a[o];
        d != null && tn(d) && (he[o].integer && !Number.isInteger(d) || rr(d, n[o]) || (i[o] = d));
    }
    const l = a.product_size_ranges;
    return Array.isArray(l) && l.length > 0 && l.every((o)=>Array.isArray(o) && o.length === 2 && o.every((d)=>Number.isInteger(d))) && (rr(l, n.product_size_ranges) || (i.product_size_ranges = l.map((o)=>[
            o[0],
            o[1]
        ]))), i;
}
function zn(e) {
    if (!Array.isArray(e) || e.length !== 2) return;
    const [t, r] = e;
    if (!(!Number.isInteger(t) || !Number.isInteger(r))) return [
        t,
        r
    ];
}
function _r(e) {
    const t = e?.location;
    return !t || typeof t.region != "string" ? null : {
        region: t.region,
        start: t.start,
        end: t.end,
        strand: t.strand === -1 ? -1 : 1
    };
}
function Di(e, t = {}) {
    const r = Ze(e.mode), n = {
        mode: r
    }, a = t.gene?._id ?? t.geneId ?? void 0;
    switch(r){
        case "gene":
            a && (n.gene_id = a), t.gene?.system_name && (n.system_name = t.gene.system_name), e.transcriptId && (n.transcript_id = e.transcriptId), tn(e.flankUp) && e.flankUp > 0 && (n.flank_up = Math.round(e.flankUp)), tn(e.flankDown) && e.flankDown > 0 && (n.flank_down = Math.round(e.flankDown));
            break;
        case "transcript":
            a && (n.gene_id = a), e.transcriptId && (n.transcript_id = e.transcriptId), typeof e.junctionSpanning == "boolean" && (n.junction_spanning = e.junctionSpanning);
            break;
        case "region":
            {
                const p = e.systemName ?? t.systemName ?? t.gene?.system_name ?? void 0;
                p && (n.system_name = p);
                const g = e.region ?? (t.region ? {
                    ...t.region,
                    strand: t.region.strand ?? 1
                } : null) ?? _r(t.gene);
                g && (n.region = {
                    region: String(g.region),
                    start: g.start,
                    end: g.end,
                    strand: g.strand === -1 ? -1 : 1
                });
                break;
            }
        case "sequence":
            {
                const p = e.sequence ?? t.sequence ?? "";
                n.sequence = p;
                const g = e.systemName ?? t.systemName ?? void 0;
                g && (n.system_name = g);
                break;
            }
    }
    const i = zn(e.target);
    i && (n.target = i);
    const l = zn(e.included);
    l && (n.included = l);
    const o = (e.excluded ?? []).map(zn).filter((p)=>!!p);
    o.length && (n.excluded = o), e.avoidRepeats && (n.avoid_repeats = !0, e.repeatMaskMode && (n.repeat_mask_mode = e.repeatMaskMode)), t.templateOnly && (n.template_only = !0);
    const d = Gi(r, e.preset, e.params);
    return Object.keys(d).length && (n.params = d), n;
}
function Jr(e) {
    return typeof e == "string" && ae.primerPattern.test(e);
}
function vr(e) {
    return !Jr(e.left?.seq) || !Jr(e.right?.seq) ? {
        ok: !1,
        reason: "PRIMER_NOT_CHECKABLE",
        message: "Primers must be 15\u201336 nt of A/C/G/T to be checked"
    } : tn(e.product_size) && e.product_size > ae.maxProductSize ? {
        ok: !1,
        reason: "PRODUCT_TOO_LONG_TO_CHECK",
        message: `Products longer than ${ae.maxProductSize} bp cannot be checked`
    } : {
        ok: !0
    };
}
function da(e) {
    return vr(e).ok;
}
function En(e) {
    const t = /* @__PURE__ */ new Set();
    for (const r of e)t.add((typeof r.left == "string" ? r.left : r.left.seq).toUpperCase()), t.add((typeof r.right == "string" ? r.right : r.right.seq).toUpperCase());
    return [
        ...t
    ];
}
function ji(e) {
    const t = En(e).length;
    return {
        pairs: e.length,
        uniquePrimers: t,
        withinLimits: e.length <= ae.maxPairs && t <= ae.maxUniquePrimers
    };
}
function Ui(e, t) {
    return da(t) ? ji([
        ...e,
        t
    ]).withinLimits : !1;
}
function Xr(e) {
    return `P${e.rank + 1}`;
}
function an(e, t, r) {
    const n = Array.isArray(e) ? e : e.genomes, a = r ?? (Array.isArray(e) ? void 0 : e.system_name);
    return n.filter((i)=>!i.is_query && i.system_name !== a && (t === "transcript" ? i.has_cdna_blastdb : i.has_blastdb));
}
function xr(e, t, r) {
    if (!e) return null;
    let n;
    if (Array.isArray(e) && e.every((a)=>typeof a == "string")) n = [
        ...e
    ];
    else {
        const a = Array.isArray(e) ? e : e.genomes, i = r ?? (Array.isArray(e) ? void 0 : e.system_name);
        n = an(a, t, i).map((l)=>l.system_name);
    }
    return [
        ...new Set(n)
    ].filter((a)=>a !== r).sort();
}
function Fi(e) {
    return e ? Array.isArray(e) ? e.every((t)=>typeof t == "string") ? null : e : e.genomes ?? null : null;
}
const sr = Object.freeze({
    max_product_size: {
        min: 50,
        max: 1e4
    },
    ignore_mismatches: {
        min: 3,
        max: 6
    },
    max_amplifying_mismatches: {
        min: 0,
        max: 5
    },
    min_total_mismatches: {
        min: 0,
        max: 6
    },
    min_3p_mismatches: {
        min: 1,
        max: 5
    },
    three_prime_window: {
        min: 3,
        max: 10
    },
    repeat_site_threshold: {
        min: 1,
        max: 100
    }
});
function Bi(e) {
    const t = e?.max_amplifying_mismatches;
    if (t != null) return Number.isInteger(t) ? t : null;
    const r = e?.ignore_mismatches ?? Re.ignore_mismatches;
    return Number.isInteger(r) ? Math.min(Re.max_amplifying_mismatches, r - 1) : null;
}
function Ki(e) {
    const t = [];
    if (!e) return t;
    const r = /* @__PURE__ */ new Set();
    for (const [o, d] of Object.entries(sr)){
        const p = e[o];
        p != null && (typeof p != "number" || !Number.isInteger(p) ? t.push({
            field: o,
            code: "NOT_AN_INTEGER",
            message: `${o} must be a whole number`
        }) : p < d.min || p > d.max ? t.push({
            field: o,
            code: "OUT_OF_RANGE",
            message: `${o} must be between ${d.min} and ${d.max}`
        }) : r.add(o));
    }
    const n = e.include_unlikely;
    n != null && typeof n != "boolean" && t.push({
        field: "include_unlikely",
        code: "NOT_A_BOOLEAN",
        message: "include_unlikely must be true or false"
    });
    const a = e.max_amplifying_mismatches, l = e.ignore_mismatches !== void 0 && e.ignore_mismatches !== null ? r.has("ignore_mismatches") ? e.ignore_mismatches : null : Re.ignore_mismatches;
    return typeof a == "number" && r.has("max_amplifying_mismatches") && l !== null && a >= l && t.push({
        field: "max_amplifying_mismatches",
        code: "NOT_BELOW_IGNORE_MISMATCHES",
        message: `max_amplifying_mismatches (${a}) must be less than ignore_mismatches (${l})`
    }), t;
}
function pa(e) {
    const t = {};
    if (!e) return t;
    for (const r of Object.keys(Re)){
        const n = e[r];
        if (n != null) {
            if (r === "include_unlikely") {
                typeof n == "boolean" && n !== Re.include_unlikely && (t.include_unlikely = n);
                continue;
            }
            Number.isInteger(n) && n !== Re[r] && (t[r] = n);
        }
    }
    return t;
}
function ga(e) {
    const t = e.params?.max_product_size ?? ae.defaultMaxProductSize, r = e.mode ?? "region";
    let n = null;
    if (r === "gene" || r === "region") for (const l of e.pairs){
        if (!l.expected) continue;
        const o = l.expected.end - l.expected.start + 1;
        (n === null || o > n) && (n = o);
    }
    if (n !== null && n > ae.maxProductSize) return {
        requested: t,
        effective: t,
        raised: !1,
        tooLong: !0,
        largestExpected: n
    };
    const a = n === null ? t : Math.max(t, Math.ceil(ae.raiseFactor * n)), i = Math.min(ae.maxProductSize, a);
    return {
        requested: t,
        effective: i,
        raised: i > t,
        tooLong: !1,
        largestExpected: n
    };
}
function ma(e) {
    const { mode: t } = e, r = e.systemName ?? "";
    if (!r) throw new be("NO_SYSTEM_NAME", "Choose a genome to check against");
    if ((t === "gene" || t === "transcript") && !e.geneId) throw new be("GENE_ID_REQUIRED", `A gene id is required in ${t} mode`);
    const n = e.pairs ?? [];
    if (n.length === 0) throw new be("NO_PAIRS", "Select at least one primer pair");
    if (n.length > ae.maxPairs) throw new be("TOO_MANY_PAIRS", `At most ${ae.maxPairs} pairs can be checked at once`, {
        pairs: n.length
    });
    for (const g of n){
        const m = vr(g);
        if (!m.ok) throw new be(m.reason, m.message, {
            id: Xr(g)
        });
    }
    const a = En(n).length;
    if (a > ae.maxUniquePrimers) throw new be("TOO_MANY_PRIMERS", `At most ${ae.maxUniquePrimers} distinct primers can be checked at once`, {
        unique: a
    });
    const i = {
        system_name: r,
        mode: t
    };
    (t === "gene" || t === "transcript") && e.geneId && (i.gene_id = e.geneId), t === "transcript" && e.transcriptId && (i.transcript_id = e.transcriptId);
    const l = [
        "specificity"
    ];
    if (e.checks?.includes("pangenome") && l.push("pangenome"), i.checks = l, l.includes("pangenome") && e.genomes) {
        let g = [
            ...new Set(e.genomes)
        ].filter((u)=>u !== r).sort();
        const m = xr(e.allGenomes, t, r);
        if (m !== null) {
            const u = new Set(m), h = g.filter((y)=>u.has(y));
            if (g.length > 0 && h.length === 0) throw new be("NO_GENOMES", "None of the selected genomes can be searched; select genomes again", {
                genomes: g
            });
            g = h;
        }
        if (!(m !== null && m.length === g.length && m.every((u, h)=>u === g[h]))) {
            if (g.length > ae.maxGenomes) throw new be("TOO_MANY_GENOMES", `At most ${ae.maxGenomes} genomes`, {
                genomes: g.length
            });
            i.genomes = g;
        }
    }
    const o = pa(e.params);
    if (t === "sequence") {
        const g = Math.max(...n.map((u)=>tn(u.product_size) ? u.product_size : 0)), m = o.max_product_size ?? ae.defaultMaxProductSize, f = Math.min(ae.maxProductSize, Math.ceil(ae.raiseFactor * g));
        f > m && (o.max_product_size = f);
    }
    Object.keys(o).length && (i.params = o), i.pairs = n.map((g)=>{
        const m = {
            id: Xr(g),
            left: g.left.seq,
            right: g.right.seq
        }, f = g.product?.genomic;
        return (t === "gene" || t === "region") && f && (m.expected = {
            region: String(f.region),
            start: f.start,
            end: f.end
        }), m;
    });
    const d = i, p = ga(d);
    if (p.tooLong) throw new be("PRODUCT_TOO_LONG_TO_CHECK", `Products longer than ${ae.maxProductSize} bp cannot be checked`, {
        largest: p.largestExpected
    });
    return d;
}
const $e = Object.freeze({
    maxSets: 5,
    maxPairs: ae.maxPairs,
    maxUniquePrimers: ae.maxUniquePrimers
});
function Hi(e, t = {}) {
    const r = e.genotyping, n = t.systemName ?? e.systemName ?? "";
    if (!r || !n) return null;
    let a = null;
    if (r.manual && typeof r.manual.region == "string" && Number.isInteger(r.manual.position)) a = {
        region: String(r.manual.region),
        position: r.manual.position,
        ref: r.manual.ref,
        alt: r.manual.alt
    };
    else if (r.variantKey) {
        const d = r.variantKey.split(":");
        if (d.length >= 4) {
            const p = d[d.length - 1], g = d[d.length - 2], m = Number(d[d.length - 3]), f = d.slice(0, d.length - 3).join(":");
            f && Number.isInteger(m) && (a = {
                region: f,
                position: m,
                ref: g,
                alt: p
            });
        }
    }
    if (!a && r.variantId && (a = r.alt ? {
        id: r.variantId,
        alt: r.alt
    } : {
        id: r.variantId
    }), !a) return null;
    const i = {
        system_name: n,
        variant: a
    }, l = Ti(r.assay);
    Object.keys(l).length && (i.assay = l);
    const o = la(r.params);
    return Object.keys(o).length && (i.params = o), r.avoidRepeats && (i.avoid_repeats = !0, r.repeatMaskMode && (i.repeat_mask_mode = r.repeatMaskMode)), r.label && (i.label = r.label), t.templateOnly && (i.template_only = !0), i;
}
function Vi(e) {
    const t = e.systemName ?? "";
    if (!t) throw new be("NO_SYSTEM_NAME", "Choose a genome to check against");
    const r = e.sets ?? [];
    if (!r.length) throw new be("NO_PAIRS", "Select at least one set");
    if (r.length > $e.maxSets) throw new be("TOO_MANY_SETS", `At most ${$e.maxSets} sets can be checked at once`, {
        sets: r.length
    });
    const n = e.mode ?? (e.geneId ? "gene" : "region");
    if (n === "gene" && !e.geneId) throw new be("GENE_ID_REQUIRED", "A gene id is required in gene mode");
    const a = [], i = [];
    for (const m of r){
        const f = m.check;
        if (!(!f?.set || !Array.isArray(f.pairs))) {
            i.push({
                id: f.set.id,
                ref_pair: f.set.ref_pair,
                alt_pair: f.set.alt_pair
            });
            for (const u of f.pairs)a.push({
                ...u,
                ...u.expected ? {
                    expected: {
                        ...u.expected
                    }
                } : {}
            });
        }
    }
    if (!a.length) throw new be("NO_PAIRS", "These sets carry no check pairs");
    if (a.length > $e.maxPairs) throw new be("TOO_MANY_PAIRS", `At most ${$e.maxPairs} pairs can be checked at once`, {
        pairs: a.length
    });
    const l = En(a).length;
    if (l > $e.maxUniquePrimers) throw new be("TOO_MANY_PRIMERS", `At most ${$e.maxUniquePrimers} distinct primers can be checked at once`, {
        unique: l
    });
    const o = {
        system_name: t,
        mode: n,
        pairs: a
    };
    n === "gene" && e.geneId && (o.gene_id = e.geneId);
    const d = [
        "specificity"
    ];
    if (e.checks?.includes("pangenome") && d.push("pangenome"), o.checks = d, d.includes("pangenome") && e.genomes) {
        let m = [
            ...new Set(e.genomes)
        ].filter((h)=>h !== t).sort();
        const f = xr(e.allGenomes, n, t);
        if (f !== null) {
            const h = new Set(f), y = m.filter((_)=>h.has(_));
            if (m.length > 0 && y.length === 0) throw new be("NO_GENOMES", "None of the selected genomes can be searched; select genomes again", {
                genomes: m
            });
            m = y;
        }
        if (!(f !== null && f.length === m.length && f.every((h, y)=>h === m[y]))) {
            if (m.length > ae.maxGenomes) throw new be("TOO_MANY_GENOMES", `At most ${ae.maxGenomes} genomes`, {
                genomes: m.length
            });
            o.genomes = m;
        }
    }
    const p = pa(e.params);
    Object.keys(p).length && (o.params = p), o.genotyping = {
        variant: {
            region: String(e.variant.region),
            position: e.variant.vcf.position,
            ref: e.variant.vcf.ref,
            alt: e.variant.vcf.alt
        },
        sets: i
    };
    const g = Fi(e.allGenomes);
    if (g) {
        const m = d.includes("pangenome") ? an(g, n, t) : [], f = e.genomes ? m.filter((h)=>e.genomes?.includes(h.system_name)) : m, u = yr({
            primers: a.map((h)=>({
                    left: h.left,
                    right: h.right
                })),
            mode: n,
            referenceTotalBases: g.find((h)=>h.system_name === t)?.total_bases ?? null,
            pangenome: d.includes("pangenome") ? f : null,
            genotyping: !0
        });
        if (u.over_limit) throw new be("OVER_CPU_LIMIT", `This check needs about ${u.cpu_s.toLocaleString("en-US")} CPU-seconds, over the ${u.limit.toLocaleString("en-US")} limit; check fewer sets or fewer genomes`, {
            estimate_cpu_s: u.cpu_s,
            limit: u.limit
        });
    }
    return o;
}
const Wi = [
    "pairs",
    "specificity",
    "transcriptome",
    "pangenome"
], ua = /^[0-9a-f]{32}$/, ar = /^[a-z0-9_]+$/;
function Nr(e = {}) {
    const t = (e.modes && e.modes.length ? e.modes : ur).filter((i)=>vi.includes(i)), r = !!(e.gene?._id || e.geneId), n = !!(e.systemName || e.gene?.system_name), a = t.filter((i)=>i === "gene" || i === "transcript" ? r : i === "region" || i === "genotyping" ? n : !0);
    return a.length ? [
        ...new Set(a)
    ] : [
        "sequence"
    ];
}
function Ae(e) {
    return typeof e == "object" && e !== null && !Array.isArray(e);
}
const Ge = (e)=>typeof e == "number" && Number.isInteger(e);
function ha(e) {
    if (!Ae(e)) return;
    const t = {};
    for (const n of hr){
        const a = e[n];
        typeof a != "number" || !Number.isFinite(a) || he[n].integer && !Number.isInteger(a) || (t[n] = a);
    }
    const r = e.product_size_ranges;
    return Array.isArray(r) && r.length >= 1 && r.length <= ee.maxProductRanges && r.every((n)=>Array.isArray(n) && n.length === 2 && Ge(n[0]) && Ge(n[1])) && (t.product_size_ranges = r.map((n)=>[
            n[0],
            n[1]
        ])), Object.keys(t).length ? t : void 0;
}
function fa(e) {
    if (!Ae(e)) return;
    const t = {};
    for (const r of Object.keys(Re)){
        const n = e[r];
        r === "include_unlikely" ? typeof n == "boolean" && (t[r] = n) : Ge(n) && (t[r] = n);
    }
    return Object.keys(t).length ? t : void 0;
}
function Ln(e) {
    if (!(!Array.isArray(e) || e.length !== 2 || !Ge(e[0]) || !Ge(e[1])) && !(e[0] < 1 || e[1] < 1)) return [
        e[0],
        e[1]
    ];
}
function Yi(e) {
    if (!Ae(e)) return;
    const t = e.region;
    if (typeof t != "string" && typeof t != "number" || String(t).length === 0 || String(t).length > 255 || !Ge(e.start) || !Ge(e.end) || e.start < 1 || e.end < 1) return;
    const r = e.strand === -1 ? -1 : 1;
    return {
        region: String(t),
        start: e.start,
        end: e.end,
        strand: r
    };
}
function Qr(e) {
    if (!(typeof e != "number" || !Number.isFinite(e))) return Math.min(ee.maxFlank, Math.max(0, Math.round(e)));
}
function ba(e = {}) {
    const t = Nr(e), r = e.defaultMode && t.includes(e.defaultMode) ? e.defaultMode : t[0], n = {
        v: 1,
        mode: r,
        preset: St(Ze(r)),
        flankUp: 0,
        flankDown: 0,
        junctionSpanning: !0,
        avoidRepeats: !1,
        repeatMaskMode: "n_mask",
        designed: !1,
        checkedRanks: [],
        check: {
            checks: [
                "specificity"
            ]
        },
        view: {
            resultsTab: "pairs"
        }
    }, a = e.systemName ?? e.gene?.system_name;
    a && (n.systemName = a);
    const i = e.region ? {
        region: String(e.region.region),
        start: e.region.start,
        end: e.region.end,
        strand: e.region.strand === -1 ? -1 : 1
    } : _r(e.gene);
    i && (n.region = i), e.sequence && e.persistSequence !== !1 && (n.sequence = e.sequence);
    const l = ha(e.defaultParams);
    return l && (n.params = l), n;
}
function Zr(e, t = {}) {
    const r = ba(t);
    if (!Ae(e) || e.v !== 1) return r;
    const n = Nr(t), a = typeof e.mode == "string" && n.includes(e.mode) ? e.mode : r.mode, i = {
        ...r,
        mode: a,
        preset: St(Ze(a))
    };
    (e.preset === "pcr" || e.preset === "qpcr") && (i.preset = e.preset), typeof e.transcriptId == "string" && e.transcriptId.length > 0 && e.transcriptId.length <= 255 && (i.transcriptId = e.transcriptId);
    const l = Qr(e.flankUp);
    l !== void 0 && (i.flankUp = l);
    const o = Qr(e.flankDown);
    o !== void 0 && (i.flankDown = o);
    const d = Yi(e.region);
    d && (i.region = d), typeof e.sequence == "string" && e.sequence.length <= ee.maxSequenceInput && (i.sequence = e.sequence), typeof e.systemName == "string" && ar.test(e.systemName) && e.systemName.length <= 128 && (i.systemName = e.systemName);
    const p = Ln(e.target);
    p && (i.target = p);
    const g = Ln(e.included);
    if (g && (i.included = g), Array.isArray(e.excluded)) {
        const u = e.excluded.map(Ln).filter((h)=>!!h).slice(0, ee.maxExcluded);
        u.length && (i.excluded = u);
    }
    typeof e.junctionSpanning == "boolean" && (i.junctionSpanning = e.junctionSpanning), typeof e.avoidRepeats == "boolean" && (i.avoidRepeats = e.avoidRepeats), (e.repeatMaskMode === "n_mask" || e.repeatMaskMode === "three_prime") && (i.repeatMaskMode = e.repeatMaskMode);
    const m = ha(e.params);
    if (m ? i.params = m : delete i.params, typeof e.designed == "boolean" && (i.designed = e.designed), Ge(e.selectedRank) && e.selectedRank >= 0 && (i.selectedRank = e.selectedRank), Array.isArray(e.checkedRanks) && (i.checkedRanks = [
        ...new Set(e.checkedRanks.filter((u)=>Ge(u) && u >= 0))
    ].sort((u, h)=>u - h)), Ae(e.check)) {
        const u = e.check, h = [
            "specificity"
        ];
        Array.isArray(u.checks) && u.checks.includes("pangenome") && h.push("pangenome");
        const y = {
            checks: h
        };
        Array.isArray(u.genomes) && (y.genomes = [
            ...new Set(u.genomes.filter((k)=>typeof k == "string" && ar.test(k) && k.length <= 128))
        ].slice(0, 150));
        const _ = fa(u.params);
        if (_ && (y.params = _), typeof u.jobId == "string" && ua.test(u.jobId) && (y.jobId = u.jobId), Array.isArray(u.submitted)) {
            const k = u.submitted.filter((b)=>Ae(b) && typeof b.id == "string" && typeof b.left == "string" && typeof b.right == "string").slice(0, 10).map((b)=>({
                    id: b.id,
                    left: b.left.toUpperCase(),
                    right: b.right.toUpperCase()
                }));
            k.length && (y.submitted = k);
        }
        i.check = y;
    }
    const f = Qi(e.genotyping);
    if (f && (i.genotyping = f), Ae(e.view)) {
        const u = Wi.includes(e.view.resultsTab) ? e.view.resultsTab : "pairs";
        i.view = {
            resultsTab: u
        }, typeof e.view.explainOpen == "boolean" && (i.view.explainOpen = e.view.explainOpen), typeof e.view.formWidth == "number" && Number.isFinite(e.view.formWidth) && (i.view.formWidth = kr(e.view.formWidth));
    }
    return t.persistSequence === !1 ? ya(i, {
        persistSequence: !1
    }) : i;
}
const st = Object.freeze({
    formMin: 300,
    formDefault: 380,
    formMax: 2400,
    splitter: 18,
    resultsMin: 360
});
function kr(e) {
    return Math.min(st.formMax, Math.max(st.formMin, Math.round(e)));
}
const es = /^[0-9a-f]{12}$/, qn = /^([ACGTacgt]{1,50}|-)$/, Ji = [
    "snv",
    "mnv",
    "insertion",
    "deletion",
    "complex"
], Xi = [
    "sets",
    "alleles",
    "specificity",
    "pangenome",
    "order"
];
function Qi(e) {
    if (!Ae(e)) return;
    const t = {};
    if (typeof e.variantId == "string" && e.variantId.length > 0 && e.variantId.length <= ee.maxIdLength && (t.variantId = e.variantId), typeof e.variantKey == "string" && e.variantKey.length > 0 && e.variantKey.length <= 600 && (t.variantKey = e.variantKey), typeof e.alt == "string" && qn.test(e.alt) && (t.alt = e.alt), typeof e.label == "string" && e.label.length > 0 && e.label.length <= 128 && (t.label = e.label), Ae(e.manual)) {
        const n = e.manual;
        typeof n.region == "string" && n.region.length > 0 && n.region.length <= 255 && Ge(n.position) && n.position >= 1 && typeof n.ref == "string" && typeof n.alt == "string" && qn.test(n.ref) && qn.test(n.alt) && (t.manual = {
            region: n.region,
            position: n.position,
            ref: n.ref,
            alt: n.alt
        });
    }
    if (Ae(e.window)) {
        const n = e.window;
        typeof n.region == "string" && n.region.length > 0 && Ge(n.start) && Ge(n.end) && n.start >= 1 && n.end >= n.start && n.end - n.start + 1 <= ye.maxWindow && (t.window = {
            region: n.region,
            start: n.start,
            end: n.end
        });
    }
    if (Ae(e.filters)) {
        const n = e.filters, a = {};
        if (Array.isArray(n.types)) {
            const i = [
                ...new Set(n.types.filter((l)=>typeof l == "string" && Ji.includes(l)))
            ];
            i.length && (a.types = i);
        }
        typeof n.includeEms == "boolean" && (a.includeEms = n.includeEms), typeof n.query == "string" && n.query.length <= 255 && (a.query = n.query), Object.keys(a).length && (t.filters = a);
    }
    if (Ae(e.assay)) {
        const n = e.assay, a = {};
        (n.type === "kasp" || n.type === "as_pcr") && (a.type = n.type), (n.orientation === "both" || n.orientation === "forward" || n.orientation === "reverse") && (a.orientation = n.orientation), (n.tails === "none" || n.tails === "ref_fam_alt_hex" || n.tails === "ref_hex_alt_fam") && (a.tails = n.tails), (n.deliberate_mismatch === "none" || n.deliberate_mismatch === "auto") && (a.deliberate_mismatch = n.deliberate_mismatch), (n.mismatch_position === 2 || n.mismatch_position === 3) && (a.mismatch_position = n.mismatch_position), Ge(n.num_sets) && n.num_sets >= ye.minSets && n.num_sets <= ye.maxSets && (a.num_sets = n.num_sets), Ge(n.max_relaxation) && n.max_relaxation >= 0 && n.max_relaxation <= ye.maxRelaxation && (a.max_relaxation = n.max_relaxation), (n.neighbour_policy === "avoid_3p" || n.neighbour_policy === "ignore") && (a.neighbour_policy = n.neighbour_policy), Object.keys(a).length && (t.assay = a);
    }
    const r = la(Ae(e.params) ? e.params : void 0);
    if (Object.keys(r).length && (t.params = r), typeof e.avoidRepeats == "boolean" && (t.avoidRepeats = e.avoidRepeats), (e.repeatMaskMode === "n_mask" || e.repeatMaskMode === "three_prime") && (t.repeatMaskMode = e.repeatMaskMode), typeof e.designed == "boolean" && (t.designed = e.designed), typeof e.selectedSetKey == "string" && es.test(e.selectedSetKey) && (t.selectedSetKey = e.selectedSetKey), Array.isArray(e.checkedSetKeys)) {
        const n = [
            ...new Set(e.checkedSetKeys.filter((a)=>typeof a == "string" && es.test(a)))
        ].slice(0, $e.maxSets);
        n.length && (t.checkedSetKeys = n);
    }
    if (Ae(e.check)) {
        const n = e.check, a = [
            "specificity"
        ];
        Array.isArray(n.checks) && n.checks.includes("pangenome") && a.push("pangenome");
        const i = {
            checks: a
        };
        Array.isArray(n.genomes) && (i.genomes = [
            ...new Set(n.genomes.filter((o)=>typeof o == "string" && ar.test(o) && o.length <= 128))
        ].slice(0, 150));
        const l = fa(n.params);
        if (l && (i.params = l), typeof n.jobId == "string" && ua.test(n.jobId) && (i.jobId = n.jobId), Array.isArray(n.submitted)) {
            const o = n.submitted.filter((d)=>Ae(d) && typeof d.id == "string" && Ae(d.ref) && Ae(d.alt)).slice(0, $e.maxSets).map((d)=>{
                const p = (g)=>({
                        id: typeof g.id == "string" ? g.id : "",
                        left: typeof g.left == "string" ? g.left.toUpperCase() : "",
                        right: typeof g.right == "string" ? g.right.toUpperCase() : ""
                    });
                return {
                    id: d.id,
                    ref: p(d.ref),
                    alt: p(d.alt)
                };
            }).filter((d)=>d.ref.left && d.ref.right && d.alt.left && d.alt.right);
            o.length && (i.submitted = o);
        }
        t.check = i;
    }
    return Ae(e.view) && typeof e.view.tab == "string" && Xi.includes(e.view.tab) && (t.view = {
        tab: e.view.tab
    }), Object.keys(t).length ? t : void 0;
}
function ya(e, t = {}) {
    const r = JSON.parse(JSON.stringify(e));
    return t.persistSequence === !1 && delete r.sequence, r;
}
function wr(e) {
    let t = 2166136261;
    for(let r = 0; r < e.length; r++)t ^= e.charCodeAt(r), t = Math.imul(t, 16777619);
    return (t >>> 0).toString(16).padStart(8, "0");
}
function Zi(e) {
    const t = e.gene?._id ?? e.geneId;
    if (t) return `gene:${t}`;
    if (e.systemName && e.region) {
        const r = e.region;
        return `region:${e.systemName}:${r.region}:${r.start}-${r.end}:${r.strand === -1 ? -1 : 1}`;
    }
    return e.sequence ? `sequence:${wr(e.sequence)}` : e.systemName ? `genome:${e.systemName}` : "empty";
}
const qt = Object.freeze([
    // ---- six and eight base cutters ----
    {
        name: "AatII",
        site: "GACGTC",
        cut: 5
    },
    {
        name: "AccI",
        site: "GTMKAC",
        cut: 2
    },
    {
        name: "AflII",
        site: "CTTAAG",
        cut: 1
    },
    {
        name: "ApaI",
        site: "GGGCCC",
        cut: 5
    },
    {
        name: "AvrII",
        site: "CCTAGG",
        cut: 1
    },
    {
        name: "BamHI",
        site: "GGATCC",
        cut: 1
    },
    {
        name: "BglII",
        site: "AGATCT",
        cut: 1
    },
    {
        name: "BstYI",
        site: "RGATCY",
        cut: 1
    },
    {
        name: "ClaI",
        site: "ATCGAT",
        cut: 2
    },
    {
        name: "DraI",
        site: "TTTAAA",
        cut: 3
    },
    {
        name: "EagI",
        site: "CGGCCG",
        cut: 1
    },
    {
        name: "EcoRI",
        site: "GAATTC",
        cut: 1
    },
    {
        name: "EcoRV",
        site: "GATATC",
        cut: 3
    },
    {
        name: "HindIII",
        site: "AAGCTT",
        cut: 1
    },
    {
        name: "HpaI",
        site: "GTTAAC",
        cut: 3
    },
    {
        name: "KpnI",
        site: "GGTACC",
        cut: 5
    },
    {
        name: "MfeI",
        site: "CAATTG",
        cut: 1
    },
    {
        name: "NcoI",
        site: "CCATGG",
        cut: 1
    },
    {
        name: "NdeI",
        site: "CATATG",
        cut: 2
    },
    {
        name: "NheI",
        site: "GCTAGC",
        cut: 1
    },
    {
        name: "NotI",
        site: "GCGGCCGC",
        cut: 2
    },
    {
        name: "NsiI",
        site: "ATGCAT",
        cut: 5
    },
    {
        name: "PstI",
        site: "CTGCAG",
        cut: 5
    },
    {
        name: "PvuII",
        site: "CAGCTG",
        cut: 3
    },
    {
        name: "SacI",
        site: "GAGCTC",
        cut: 5
    },
    {
        name: "SalI",
        site: "GTCGAC",
        cut: 1
    },
    {
        name: "ScaI",
        site: "AGTACT",
        cut: 3
    },
    {
        name: "SmaI",
        site: "CCCGGG",
        cut: 3
    },
    {
        name: "SpeI",
        site: "ACTAGT",
        cut: 1
    },
    {
        name: "SphI",
        site: "GCATGC",
        cut: 5
    },
    {
        name: "SspI",
        site: "AATATT",
        cut: 3
    },
    {
        name: "StuI",
        site: "AGGCCT",
        cut: 3
    },
    {
        name: "XbaI",
        site: "TCTAGA",
        cut: 1
    },
    {
        name: "XhoI",
        site: "CTCGAG",
        cut: 1
    },
    // Interrupted sites: the Ns are spacers, not informative bases.
    {
        name: "XmnI",
        site: "GAANNNNTTC",
        cut: 5
    },
    {
        name: "BsaJI",
        site: "CCNNGG",
        cut: 1
    },
    // ---- four and five base cutters ----
    {
        name: "AluI",
        site: "AGCT",
        cut: 2
    },
    {
        name: "DdeI",
        site: "CTNAG",
        cut: 1
    },
    {
        name: "HaeIII",
        site: "GGCC",
        cut: 2
    },
    {
        name: "HhaI",
        site: "GCGC",
        cut: 3
    },
    {
        name: "HinfI",
        site: "GANTC",
        cut: 1
    },
    {
        name: "MseI",
        site: "TTAA",
        cut: 1
    },
    {
        name: "MspI",
        site: "CCGG",
        cut: 1
    },
    {
        name: "NlaIII",
        site: "CATG",
        cut: 4
    },
    {
        name: "RsaI",
        site: "GTAC",
        cut: 2
    },
    {
        name: "Sau3AI",
        site: "GATC",
        cut: 0
    },
    {
        name: "TaqI",
        site: "TCGA",
        cut: 1
    },
    {
        name: "Tsp509I",
        site: "AATT",
        cut: 0
    }
]), eo = Object.freeze({
    A: 1,
    C: 1,
    G: 1,
    T: 1,
    U: 1,
    R: 2,
    Y: 2,
    S: 2,
    W: 2,
    K: 2,
    M: 2,
    B: 3,
    D: 3,
    H: 3,
    V: 3,
    N: 4
});
function Ar(e) {
    let t = 1;
    for (const r of e.toUpperCase())t *= 4 / (eo[r] ?? 4);
    return t;
}
const to = 4096;
function Rd(e) {
    return Ar(e.site) >= to;
}
function no(e, t = qt) {
    const r = e.trim().toLowerCase();
    return t.find((n)=>n.name.toLowerCase() === r) ?? null;
}
function _a(e) {
    return e.cut === null ? e.site : `${e.site.slice(0, e.cut)}^${e.site.slice(e.cut)}`;
}
const ir = Object.freeze([
    "#0072B2",
    "#E69F00",
    "#009E73",
    "#CC79A7",
    "#56B4E9",
    "#D55E00",
    "#8C6D1F",
    "#555555"
]);
function va(e) {
    const t = parseInt(wr(e).slice(0, 8), 16);
    return ir[t % ir.length];
}
function ro(e, t = /* @__PURE__ */ new Map(), r = ir) {
    const n = /* @__PURE__ */ new Map(), a = new Map(r.map((l)=>[
            l,
            0
        ])), i = new Set(e);
    for (const [l, o] of t)!i.has(l) || !a.has(o) || (n.set(l, o), a.set(o, (a.get(o) ?? 0) + 1));
    for (const l of e){
        if (n.has(l)) continue;
        let o = r[0];
        for (const d of r)(a.get(d) ?? 0) < (a.get(o) ?? 0) && (o = d);
        n.set(l, o), a.set(o, (a.get(o) ?? 0) + 1);
    }
    return n;
}
const Cr = Object.freeze({
    A: "A",
    C: "C",
    G: "G",
    T: "T",
    U: "T",
    R: "AG",
    Y: "CT",
    S: "CG",
    W: "AT",
    K: "GT",
    M: "AC",
    B: "CGT",
    D: "AGT",
    H: "ACT",
    V: "ACG",
    N: "ACGT"
});
function so(e) {
    const t = [
        ...e.toUpperCase()
    ].map((r)=>{
        const n = Cr[r];
        if (!n) throw new Error(`Not an IUPAC base: ${r}`);
        return n.length === 1 ? n : `[${n}]`;
    }).join("");
    return new RegExp(t, "g");
}
function on(e, t) {
    const r = e.toUpperCase(), n = t.site.toUpperCase(), a = An(n).toUpperCase(), i = n === a ? [
        [
            n,
            1
        ]
    ] : [
        [
            n,
            1
        ],
        [
            a,
            -1
        ]
    ], l = [];
    for (const [o, d] of i){
        const p = so(o);
        let g;
        for(; (g = p.exec(r)) !== null;)l.push({
            start: g.index + 1,
            end: g.index + o.length,
            strand: d
        }), p.lastIndex = g.index + 1;
    }
    return l.sort((o, d)=>o.start - d.start || o.end - d.end);
}
function ts(e, t, r, n) {
    return on(e, t).filter((a)=>a.start <= n && a.end >= r);
}
function ao(e, t, r, n = 20) {
    const a = e.toUpperCase(), i = r.ref.toUpperCase(), l = r.alt.toUpperCase();
    if (!i || !l) return null;
    const o = r.position - t;
    if (o < 0 || o + i.length > a.length || a.slice(o, o + i.length) !== i) return null;
    const d = Math.max(0, o - n), p = a.slice(d, o), g = a.slice(o + i.length, o + i.length + n);
    return {
        ref: p + i + g,
        alt: p + l + g,
        at: o - d + 1,
        refLength: i.length,
        altLength: l.length
    };
}
function xa(e, t = qt) {
    const r = [];
    for (const n of t){
        const a = ts(e.ref, n, e.at, e.at + e.refLength - 1), i = ts(e.alt, n, e.at, e.at + e.altLength - 1);
        if (a.length === i.length) continue;
        const l = a.length > i.length ? a : i, o = a.length > i.length ? i : a, d = l.find((p)=>!o.some((g)=>g.start === p.start && g.strand === p.strand)) ?? l[0];
        r.push({
            enzyme: n,
            cuts: a.length > i.length ? "ref" : "alt",
            site: d,
            specificity: Ar(n.site)
        });
    }
    return r.sort((n, a)=>a.specificity - n.specificity || n.enzyme.name.localeCompare(a.enzyme.name));
}
function io(e, t) {
    return (Cr[e] ?? "").includes(t);
}
function ns(e, t, r, n, a) {
    const i = [], l = t.length, o = Math.max(0, r - l), d = Math.min(e.length - l, n - 1);
    for(let p = o; p <= d; p++){
        let g = -1, m = 0;
        for(let _ = 0; _ < l && m < 2; _++)io(t[_], e[p + _]) || (m++, g = p + _);
        if (m !== 1 || g >= r - 1 && g <= n - 1) continue;
        const f = g < r - 1 ? "upstream" : "downstream", u = f === "upstream" ? r - 1 - g : g - (n - 1);
        if (u > a) continue;
        const h = e[g], y = t[g - p];
        for (const _ of Cr[y])if (_ !== h) {
            i.push({
                side: f,
                offset: u,
                from: h,
                to: _
            });
            break;
        }
    }
    return i.sort((p, g)=>p.offset - g.offset);
}
function oo(e, t = qt, r = 12) {
    const n = [], a = e.at;
    for (const i of t){
        const l = i.site.toUpperCase(), o = An(l).toUpperCase(), d = l === o ? [
            l
        ] : [
            l,
            o
        ], p = [];
        for (const m of d)p.push(...ns(e.ref, m, a, a + e.refLength - 1, r), ...ns(e.alt, m, a, a + e.altLength - 1, r));
        p.sort((m, f)=>m.offset - f.offset);
        let g = null;
        for (const m of p){
            const f = m.side === "upstream" ? a - 1 - m.offset : a - 1 + e.refLength - 1 + m.offset, u = m.side === "upstream" ? a - 1 - m.offset : a - 1 + e.altLength - 1 + m.offset;
            if (f < 0 || u < 0 || f >= e.ref.length || u >= e.alt.length || e.ref[f] !== m.from || e.alt[u] !== m.from) continue;
            const h = {
                ...e,
                ref: e.ref.slice(0, f) + m.to + e.ref.slice(f + 1),
                alt: e.alt.slice(0, u) + m.to + e.alt.slice(u + 1)
            }, [y] = xa(h, [
                i
            ]);
            if (y) {
                g = {
                    enzyme: i,
                    cuts: y.cuts,
                    side: m.side,
                    offset: m.offset,
                    from: m.from,
                    to: m.to,
                    specificity: y.specificity
                };
                break;
            }
        }
        g && n.push(g);
    }
    return n.sort((i, l)=>l.specificity - i.specificity || i.offset - l.offset || i.enzyme.name.localeCompare(l.enzyme.name));
}
function lo(e, t = {}) {
    const r = t.enzymes ?? qt, n = xa(e, r);
    if (n.length) return {
        verdict: "caps",
        sites: n,
        dcaps: []
    };
    if (t.dcaps === !1) return {
        verdict: "none",
        sites: [],
        dcaps: []
    };
    const a = oo(e, r, t.reach ?? 12);
    return {
        verdict: a.length ? "dcaps" : "none",
        sites: [],
        dcaps: a
    };
}
function co(e, t) {
    if (t.cut === null) return [];
    const r = t.cut, n = on(e, t).map((a)=>a.strand === 1 ? a.start - 1 + r : a.end - r);
    return [
        ...new Set(n)
    ].filter((a)=>a > 0 && a < e.length).sort((a, i)=>a - i);
}
function po(e, t) {
    if (t.cut === null) return [
        e.length
    ];
    const r = [
        0,
        ...co(e, t),
        e.length
    ], n = [];
    for(let a = 1; a < r.length; a++)n.push(r[a] - r[a - 1]);
    return n.sort((a, i)=>i - a);
}
function Md(e, t, r = 25) {
    if (e.length < 2) return !1;
    const n = [
        ...e
    ].sort((a, i)=>i - a);
    if (t - n[0] < r) return !1;
    for(let a = 1; a < n.length; a++)if (n[a - 1] - n[a] < r) return !1;
    return !0;
}
function go(e, t, r) {
    const n = e.toUpperCase();
    let a = 0;
    for (const i of r){
        const l = i.vcf;
        if (!l || !l.ref) continue;
        const o = l.position - t;
        if (o < 0 || o + l.ref.length > n.length) continue;
        a++;
        const d = n.slice(o, o + l.ref.length), p = l.ref.toUpperCase();
        if (d !== p) return {
            ok: !1,
            checked: a,
            mismatch: {
                position: l.position,
                expected: p,
                found: d
            }
        };
    }
    return {
        ok: a > 0,
        checked: a,
        mismatch: null
    };
}
const hn = (e)=>({
        verdict: "none",
        sites: [],
        dcaps: [],
        unknown: e
    });
function mo(e, t, r, n = {}) {
    const a = /* @__PURE__ */ new Map();
    if (!t) {
        for (const i of e)a.set(i.key, hn("no-sequence"));
        return a;
    }
    if (!go(t, r, e).ok) {
        for (const i of e)a.set(i.key, hn("window-mismatch"));
        return a;
    }
    for (const i of e){
        if (!i.vcf) {
            a.set(i.key, hn("out-of-window"));
            continue;
        }
        const l = ao(t, r, i.vcf, n.flank ?? 20);
        if (!l) {
            const o = i.vcf.position - r, d = o >= 0 && o + i.vcf.ref.length <= t.length;
            a.set(i.key, hn(d ? "ref-mismatch" : "out-of-window"));
            continue;
        }
        a.set(i.key, {
            ...lo(l, n),
            unknown: null
        });
    }
    return a;
}
function uo(e) {
    const t = /* @__PURE__ */ new Map();
    for (const r of e){
        const n = /* @__PURE__ */ new Set([
            ...r.sites.map((a)=>a.enzyme.name),
            ...r.dcaps.map((a)=>a.enzyme.name)
        ]);
        for (const a of n)t.set(a, (t.get(a) ?? 0) + 1);
    }
    return t;
}
function Na(e, t) {
    return !e || t.start < 1 || t.end > e.length || t.end < t.start ? null : e.slice(t.start - 1, t.end).toUpperCase();
}
function Sr(e, t, r = {}) {
    const n = Na(e, t);
    if (!n) return [];
    const a = r.enzymes ?? qt, i = [];
    for (const l of a){
        if (l.cut === null) continue;
        const o = on(n, l);
        if (!o.length) continue;
        const d = po(n, l);
        d.length < 2 || i.push({
            enzyme: l,
            sites: o.map((p)=>({
                    ...p,
                    start: p.start + t.start - 1,
                    end: p.end + t.start - 1
                })),
            cuts: ho(n, l).map((p)=>p + t.start - 1),
            fragments: d,
            specificity: Ar(l.site)
        });
    }
    return i.sort((l, o)=>l.cuts.length - o.cuts.length || o.specificity - l.specificity || l.enzyme.name.localeCompare(o.enzyme.name));
}
function ho(e, t) {
    if (t.cut === null) return [];
    const r = t.cut, n = on(e, t).map((a)=>a.strand === 1 ? a.start - 1 + r : a.end - r);
    return [
        ...new Set(n)
    ].filter((a)=>a > 0 && a < e.length).sort((a, i)=>a - i).map((a)=>a + 1);
}
function Pd(e) {
    return e.filter((t)=>t.cuts.length === 1);
}
function fo(e, t, r = qt) {
    const n = Na(e, t);
    return n ? r.filter((a)=>on(n, a).length === 0) : [];
}
function Od(e, t) {
    const r = t.ref.toUpperCase(), n = t.alt.toUpperCase();
    if (!r || !n) return null;
    const a = rs(e, t.position), i = rs(e, t.position + r.length - 1);
    if (a === null || i === null || Math.abs(i - a) !== r.length - 1) return null;
    const l = e.strand === -1;
    return {
        position: Math.min(a, i),
        ref: l ? An(r) : r,
        alt: l ? An(n) : n
    };
}
function rs(e, t) {
    if (!e.region || e.mode === "sequence") return null;
    const r = e.strand === -1 ? -1 : 1;
    if (e.mode === "transcript") {
        for (const i of e.features?.exons ?? []){
            const l = i.genomic;
            if (!(!l || t < l.start || t > l.end)) return r === 1 ? i.start + (t - l.start) : i.start + (l.end - t);
        }
        return null;
    }
    const { start: n, end: a } = e;
    return typeof n != "number" || typeof a != "number" || t < n || t > a ? null : r === 1 ? t - n + 1 : a - t + 1;
}
class He extends Error {
    constructor(t){
        super(t.message), this.name = "PrimersApiError", this.status = t.status, this.code = t.code, this.details = t.details ?? null, this.errors = t.errors ?? null, this.retryAfterMs = t.retryAfterMs ?? null, Object.setPrototypeOf(this, new.target.prototype);
    }
}
function Me(e) {
    return e instanceof He;
}
function ka(e) {
    const t = [];
    for (const r of e ?? []){
        if (!r || typeof r != "object") continue;
        const n = Array.isArray(r.errors) ? r.errors : [];
        n.length ? t.push(...ka(n)) : t.push(r);
    }
    return t;
}
function Ue(e) {
    return typeof e == "object" && e !== null && e.name === "AbortError";
}
function bo(e) {
    return e instanceof He ? e.code === "NETWORK" || e.code === "TIMEOUT" ? !0 : e.status >= 500 && e.status <= 599 : !1;
}
function ut(e) {
    if (Ue(e)) return e;
    const t = typeof e == "string" && e ? e : "The operation was aborted.";
    if (typeof DOMException == "function") return new DOMException(t, "AbortError");
    const r = new Error(t);
    return r.name = "AbortError", r;
}
function wa(e) {
    if (e?.aborted) throw ut(e.reason);
}
const pt = Object.freeze({
    initialDelayMs: 1e3,
    maxDelayMs: 1e4,
    factor: 1.5,
    queuedMinDelayMs: 2e3,
    maxConsecutiveErrors: 5,
    pauseWhenHidden: !0
});
function Ye(e) {
    return !!e && (e.status === "done" || e.status === "error");
}
function yo(e) {
    return !!e && Ye(e) && !Object.prototype.hasOwnProperty.call(e, "results");
}
function ss(e, t = pt.factor, r = pt.maxDelayMs) {
    return Math.min(r, Math.round(e * t));
}
function Cn(e, t) {
    return new Promise((r, n)=>{
        if (t?.aborted) {
            n(ut(t.reason));
            return;
        }
        const a = ()=>{
            clearTimeout(i), n(ut(t?.reason));
        }, i = setTimeout(()=>{
            t?.removeEventListener("abort", a), r();
        }, Math.max(0, e));
        t?.addEventListener("abort", a, {
            once: !0
        });
    });
}
function as() {
    return typeof document < "u" && document.visibilityState === "hidden";
}
function _o(e) {
    return as() ? new Promise((t, r)=>{
        if (e?.aborted) {
            r(ut(e.reason));
            return;
        }
        const n = ()=>{
            document.removeEventListener("visibilitychange", a), e?.removeEventListener("abort", i);
        }, a = ()=>{
            as() || (n(), t());
        }, i = ()=>{
            n(), r(ut(e?.reason));
        };
        document.addEventListener("visibilitychange", a), e?.addEventListener("abort", i, {
            once: !0
        });
    }) : Promise.resolve();
}
async function is(e, t, r = {}) {
    const n = r.initialDelayMs ?? pt.initialDelayMs, a = r.maxDelayMs ?? pt.maxDelayMs, i = r.factor ?? pt.factor, l = r.queuedMinDelayMs ?? pt.queuedMinDelayMs, o = r.maxConsecutiveErrors ?? pt.maxConsecutiveErrors, d = r.pauseWhenHidden ?? pt.pauseWhenHidden, { signal: p, onUpdate: g, resubmit: m } = r;
    let f = t, u = n, h, y = 0, _ = !1, k = r.initialJob;
    const b = (C)=>{
        if (g?.(C), Ye(C)) return C;
        const N = C.progress?.done;
        return h !== void 0 && N !== h && (u = n), h = N, null;
    };
    if (k) {
        if (f = k.job_id || f, yo(k)) k = void 0;
        else {
            if (Ye(k)) return k;
            h = k.progress?.done;
        }
    }
    for(;;){
        if (wa(p), k) {
            const w = k.status === "queued" ? Math.max(u, l) : u;
            await Cn(w, p), u = ss(u, i, a), k = void 0;
        }
        d && await _o(p);
        let C;
        try {
            C = await e.getCheck(f, {
                signal: p
            }), y = 0;
        } catch (w) {
            if (Ue(w)) throw w;
            if (w instanceof He && w.status === 404) {
                if (m && !_) {
                    _ = !0;
                    const R = await e.submitCheck(m, {
                        signal: p
                    });
                    if (f = R.job_id, u = n, h = void 0, Ye(R)) continue;
                    b(R), k = R;
                    continue;
                }
                throw w.code === "UNKNOWN_JOB" ? w : new He({
                    status: 404,
                    code: "UNKNOWN_JOB",
                    message: w.message || "Unknown or expired job",
                    details: w.details
                });
            }
            if (bo(w)) {
                if (y += 1, y >= o) throw w;
                const R = w.retryAfterMs ?? u;
                await Cn(R, p), u = ss(u, i, a);
                continue;
            }
            throw w;
        }
        const N = b(C);
        if (N) return N;
        k = C;
    }
}
const os = Object.freeze({
    design: 6e4,
    other: 15e3
});
function At(e) {
    return typeof e == "object" && e !== null && !Array.isArray(e);
}
function vo(e, t = Date.now()) {
    if (e == null) return null;
    const r = e.trim();
    if (!r) return null;
    if (/^\d+(\.\d+)?$/.test(r)) return Math.round(Number(r) * 1e3);
    const n = Date.parse(r);
    return Number.isNaN(n) ? null : Math.max(0, n - t);
}
function xo(e, t, r, n = "") {
    let a, i = !1;
    try {
        a = JSON.parse(t), i = At(a);
    } catch  {
        i = !1;
    }
    const l = vo(r?.get("Retry-After") ?? null);
    if (!i) return new He({
        status: e,
        code: `HTTP_${e}`,
        message: `HTTP ${e}${n ? ` ${n}` : ""}`,
        retryAfterMs: l
    });
    const o = a, d = At(o.details) ? o.details : null, p = d && typeof d.retry_after_s == "number" && Number.isFinite(d.retry_after_s) ? d.retry_after_s : null, g = p != null ? Math.round(p * 1e3) : l, m = Array.isArray(o.errors) ? o.errors : null;
    let f;
    typeof o.code == "string" && o.code ? f = o.code : m ? f = "VALIDATION" : f = `HTTP_${e}`;
    const u = typeof o.message == "string" && o.message ? o.message : `HTTP ${e}${n ? ` ${n}` : ""}`;
    return new He({
        status: e,
        code: f,
        message: u,
        details: d,
        errors: m,
        retryAfterMs: g
    });
}
function Nt(e, t) {
    return new He({
        status: e,
        code: `HTTP_${e}`,
        message: t
    });
}
function No(e) {
    const t = e.types?.length ? [
        ...e.types
    ].join(",") : "", r = e.include_ems === !1 ? "0" : "", n = typeof e.limit == "number" && Number.isFinite(e.limit) ? String(e.limit) : "";
    return [
        e.system_name,
        e.region,
        e.start,
        e.end,
        t,
        r,
        n
    ].join("|");
}
function ko(e) {
    if (!e || typeof e.apiBase != "string") throw new TypeError("createPrimersClient: apiBase is required");
    const t = e.apiBase.replace(/\/+$/, ""), r = e.fetch ?? (typeof fetch == "function" ? fetch.bind(globalThis) : void 0), n = {
        design: e.timeouts?.design ?? os.design,
        other: e.timeouts?.other ?? os.other
    }, a = e.headers ?? {}, i = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Map();
    async function o(f, u, h, y, _) {
        if (!r) throw new He({
            status: 0,
            code: "NETWORK",
            message: "fetch is not available"
        });
        wa(_);
        const k = new AbortController();
        let b = !1;
        const C = ()=>k.abort(_?.reason);
        _?.addEventListener("abort", C, {
            once: !0
        });
        const N = setTimeout(()=>{
            b = !0, k.abort();
        }, y), w = {
            ...a,
            Accept: "application/json"
        };
        h !== void 0 && (w["Content-Type"] = "application/json");
        try {
            let I;
            try {
                I = await r(`${t}${u}`, {
                    method: f,
                    headers: w,
                    body: h === void 0 ? void 0 : JSON.stringify(h),
                    cache: "no-store",
                    credentials: "omit",
                    mode: "cors",
                    signal: k.signal
                });
            } catch (V) {
                throw R(V);
            }
            let M;
            try {
                M = await I.text();
            } catch (V) {
                throw R(V);
            }
            if (!I.ok) throw xo(I.status, M, I.headers, I.statusText);
            let P;
            try {
                P = JSON.parse(M);
            } catch  {
                throw Nt(I.status, `HTTP ${I.status}: response is not JSON`);
            }
            return {
                status: I.status,
                body: P
            };
        } finally{
            clearTimeout(N), _?.removeEventListener("abort", C);
        }
        function R(I) {
            if (I instanceof He) return I;
            if (b) return new He({
                status: 0,
                code: "TIMEOUT",
                message: `Request timed out after ${y} ms`
            });
            if (_?.aborted) return Ue(I) ? I : ut(_.reason);
            if (Ue(I)) return I;
            const M = I instanceof Error && I.message ? I.message : "Network request failed";
            return new He({
                status: 0,
                code: "NETWORK",
                message: M
            });
        }
    }
    function d(f, u, h) {
        if (!At(u)) throw Nt(f, `Unexpected ${h} response`);
        return u;
    }
    function p(f, u) {
        const h = d(f, u, "check job");
        if (typeof h.job_id != "string" || typeof h.status != "string") throw Nt(f, "Unexpected check job response");
        return Array.isArray(h.warnings) || (h.warnings = []), h;
    }
    function g(f, u, h) {
        const y = d(f, u, h);
        if (!Array.isArray(y.variants)) throw Nt(f, `Unexpected ${h} response`);
        return Array.isArray(y.warnings) || (y.warnings = []), y;
    }
    const m = {
        apiBase: t,
        async design (f, u) {
            const { status: h, body: y } = await o("POST", "/primers/design", f, n.design, u?.signal), _ = d(h, y, "design");
            if (!At(_.template)) throw Nt(h, "Unexpected design response");
            return Array.isArray(_.pairs) || (_.pairs = []), Array.isArray(_.warnings) || (_.warnings = []), _;
        },
        async submitCheck (f, u) {
            const { status: h, body: y } = await o("POST", "/primers/check", f, n.other, u?.signal), _ = p(h, y);
            return Object.assign(_, {
                created: h === 202
            });
        },
        async getCheck (f, u) {
            const { status: h, body: y } = await o("GET", `/primers/check/${encodeURIComponent(f)}`, void 0, n.other, u?.signal);
            return p(h, y);
        },
        pollCheck (f, u) {
            return is(m, f, u);
        },
        async runCheck (f, u) {
            let h = await m.submitCheck(f, {
                signal: u?.signal
            });
            return Ye(h) && (h = await m.getCheck(h.job_id, {
                signal: u?.signal
            })), u?.onUpdate?.(h), Ye(h) ? h : is(m, h.job_id, {
                ...u,
                resubmit: f,
                initialJob: h
            });
        },
        listGenomes (f, u) {
            let h = i.get(f);
            if (!h) {
                h = o("GET", `/primers/genomes?system_name=${encodeURIComponent(f)}`, void 0, n.other).then(({ status: _, body: k })=>{
                    const b = d(_, k, "genomes");
                    if (!Array.isArray(b.genomes)) throw Nt(_, "Unexpected genomes response");
                    return b;
                }), i.set(f, h);
                const y = h;
                y.catch(()=>{
                    i.get(f) === y && i.delete(f);
                });
            }
            return ls(h, u?.signal);
        },
        async getGene (f, u) {
            const { body: h } = await o("GET", `/genes?idList=${encodeURIComponent(f)}`, void 0, n.other, u?.signal);
            if (!Array.isArray(h) || h.length === 0) return null;
            const y = h.find((_)=>At(_) && _._id === f) ?? h[0];
            return At(y) ? y : null;
        },
        /** Memoized per window and filters, like `listGenomes`; one caller's abort never cancels it for the others. */ listVariants (f, u) {
            const h = No(f);
            let y = l.get(h);
            if (!y) {
                const _ = new URLSearchParams({
                    system_name: f.system_name,
                    region: String(f.region),
                    start: String(f.start),
                    end: String(f.end)
                });
                f.types?.length && _.set("types", [
                    ...f.types
                ].join(",")), f.include_ems === !1 && _.set("include_ems", "false"), typeof f.limit == "number" && Number.isFinite(f.limit) && _.set("limit", String(Math.round(f.limit))), y = o("GET", `/primers/variants?${_.toString()}`, void 0, n.other).then(({ status: b, body: C })=>g(b, C, "variants")), l.set(h, y);
                const k = y;
                k.catch(()=>{
                    l.get(h) === k && l.delete(h);
                });
            }
            return ls(y, u?.signal);
        },
        async getVariant (f, u, h) {
            const y = `/primers/variants/${encodeURIComponent(f)}?system_name=${encodeURIComponent(u.system_name)}`, { status: _, body: k } = await o("GET", y, void 0, n.other, h?.signal);
            return g(_, k, "variant lookup");
        },
        async designGenotyping (f, u) {
            const { status: h, body: y } = await o("POST", "/primers/genotyping/design", f, n.design, u?.signal), _ = d(h, y, "genotyping design");
            if (!At(_.template)) throw Nt(h, "Unexpected genotyping design response");
            return Array.isArray(_.sets) || (_.sets = []), Array.isArray(_.warnings) || (_.warnings = []), _;
        }
    };
    return m;
}
function ls(e, t) {
    return t ? t.aborted ? Promise.reject(ut(t.reason)) : new Promise((r, n)=>{
        const a = ()=>n(ut(t.reason));
        t.addEventListener("abort", a, {
            once: !0
        }), e.then((i)=>{
            t.removeEventListener("abort", a), r(i);
        }, (i)=>{
            t.removeEventListener("abort", a), n(i);
        });
    }) : e;
}
function ht(e, t) {
    return `${e.toUpperCase()}|${t.toUpperCase()}`;
}
function Aa(e, t, r) {
    const n = t?.results, a = t?.request?.pairs?.length ? t.request.pairs : r ?? [], i = /* @__PURE__ */ new Map();
    for (const h of a)typeof h.left == "string" && typeof h.right == "string" && i.set(ht(h.left, h.right), h.id);
    const l = new Map((n?.specificity?.pairs ?? []).map((h)=>[
            h.id,
            h
        ])), o = new Map((n?.transcriptome?.pairs ?? []).map((h)=>[
            h.id,
            h
        ])), d = new Map((n?.pangenome?.pairs ?? []).map((h)=>[
            h.id,
            h
        ])), p = n?.primers ?? {}, g = /* @__PURE__ */ new Map(), m = [], f = /* @__PURE__ */ new Set();
    for (const h of e){
        const y = i.get(ht(h.left.seq, h.right.seq));
        if (!y) {
            m.push(h.rank);
            continue;
        }
        f.add(y), g.set(h.rank, {
            id: y,
            specificity: l.get(y) ?? null,
            transcriptome: o.get(y) ?? null,
            pangenome: d.get(y) ?? null,
            leftPrimer: p[h.left.seq.toUpperCase()] ?? null,
            rightPrimer: p[h.right.seq.toUpperCase()] ?? null
        });
    }
    const u = a.map((h)=>h.id).filter((h)=>!f.has(h));
    return {
        byRank: g,
        notChecked: m,
        orphanIds: u
    };
}
function wo(e) {
    return e.pairs.map((t)=>({
            id: t.id,
            left: t.left.toUpperCase(),
            right: t.right.toUpperCase()
        }));
}
function Ca(e) {
    const t = e?.max_amplifying_mismatches;
    if (typeof t == "number" && Number.isFinite(t)) return t;
    const r = typeof e?.ignore_mismatches == "number" && Number.isFinite(e.ignore_mismatches) ? e.ignore_mismatches : Re.ignore_mismatches;
    return Math.min(Re.max_amplifying_mismatches, r - 1);
}
function Tr(e, t) {
    if (e.likelihood !== "unlikely") return null;
    const r = (o)=>typeof o == "number" && Number.isFinite(o) ? o : null, n = Ca(t), a = r(t?.min_total_mismatches) ?? Re.min_total_mismatches, i = r(t?.min_3p_mismatches) ?? Re.min_3p_mismatches, l = [
        [
            r(e.left_mm),
            r(e.left_3p_mm)
        ],
        [
            r(e.right_mm),
            r(e.right_3p_mm)
        ]
    ];
    return l.some(([o])=>o !== null && o > n) ? "mismatch_cap" : l.some(([o, d])=>o !== null && d !== null && o >= a && d >= i) ? "three_prime" : null;
}
function Er(e, t) {
    if (e === "mismatch_cap") {
        const r = Ca(t);
        return `unlikely: a primer has more than ${r} mismatch${r === 1 ? "" : "es"}`;
    }
    return e === "three_prime" ? "unlikely: mismatches near the 3\u2032 end" : "unlikely";
}
function zd(e, t) {
    return !!e?.primers?.[t.toUpperCase()]?.repetitive;
}
function or(e, t) {
    return `${ht(e.left, e.right)}#${ht(t.left, t.right)}`;
}
function Ao(e) {
    const t = e.check;
    if (!t?.set || !Array.isArray(t.pairs)) return null;
    const r = t.pairs.find((a)=>a.id === t.set.ref_pair), n = t.pairs.find((a)=>a.id === t.set.alt_pair);
    return !r || !n ? null : or(r, n);
}
function Co(e, t, r) {
    const n = /* @__PURE__ */ new Map(), a = t?.request, i = a?.genotyping?.sets ?? [];
    if (i.length && a?.pairs?.length) {
        const m = new Map(a.pairs.map((f)=>[
                f.id,
                f
            ]));
        for (const f of i){
            const u = m.get(f.ref_pair), h = m.get(f.alt_pair);
            u && h && n.set(or(u, h), f.id);
        }
    }
    for (const m of r ?? []){
        const f = or(m.ref, m.alt);
        n.has(f) || n.set(f, m.id);
    }
    const l = new Map((t?.results?.genotyping?.sets ?? []).map((m)=>[
            m.id,
            m
        ])), o = /* @__PURE__ */ new Map(), d = [], p = /* @__PURE__ */ new Set();
    for (const m of e){
        const f = Ao(m), u = f ? n.get(f) : void 0;
        if (!u) {
            d.push(m.key);
            continue;
        }
        p.add(u), o.set(m.key, {
            id: u,
            results: l.get(u) ?? null
        });
    }
    const g = [
        ...new Set(n.values())
    ].filter((m)=>!p.has(m));
    return {
        bySetKey: o,
        notChecked: d,
        orphanIds: g
    };
}
function So(e) {
    const t = new Map((e.pairs ?? []).map((n)=>[
            n.id,
            n
        ])), r = [];
    for (const n of e.genotyping?.sets ?? []){
        const a = t.get(n.ref_pair), i = t.get(n.alt_pair);
        !a || !i || r.push({
            id: n.id,
            ref: {
                id: a.id,
                left: a.left.toUpperCase(),
                right: a.right.toUpperCase()
            },
            alt: {
                id: i.id,
                left: i.left.toUpperCase(),
                right: i.right.toUpperCase()
            }
        });
    }
    return r;
}
const To = /^[-+]?(\d+(\.\d*)?|\.\d+)([eE][-+]?\d+)?$/, Eo = /^[=+\-@＝＋－＠]/;
function Sn(e) {
    if (e == null) return "";
    if (typeof e == "number") return Number.isFinite(e) ? String(e) : "";
    if (typeof e == "boolean") return e ? "true" : "false";
    const t = String(e).replace(/[\t\r\n]+/g, " ");
    return To.test(t.trim()) ? t : Eo.test(t.trimStart()) ? `'${t}` : t;
}
function ln(e, t) {
    const r = [
        e.map(Sn).join("	")
    ];
    for (const n of t)r.push(n.map(Sn).join("	"));
    return `${r.join(`
`)}
`;
}
function Ee(e, t) {
    if (typeof e != "number" || !Number.isFinite(e)) return null;
    const r = 10 ** t;
    return Math.round(e * r) / r;
}
function Ir(e) {
    return String(e ?? "").replace(/[^A-Za-z0-9_.:-]+/g, "_").replace(/^_+|_+$/g, "") || "primers";
}
function $r(e) {
    return e.replace(/[\r\n]+/g, " ").trim();
}
function Io(e, t = 60) {
    const r = [];
    for(let n = 0; n < e.length; n += t)r.push(e.slice(n, n + t));
    return r.join(`
`);
}
function cs(e) {
    return e.junction ? `${e.junction.position} (${e.junction.overlap_5p}/${e.junction.overlap_3p})` : "";
}
const $o = [
    "pair",
    "rank",
    "left_seq",
    "left_start",
    "left_len",
    "left_tm",
    "left_gc",
    "left_junction",
    "left_genomic",
    "right_seq",
    "right_start",
    "right_len",
    "right_tm",
    "right_gc",
    "right_junction",
    "right_genomic",
    "product_size",
    "product_tm",
    "product_genomic",
    "genomic_size",
    "penalty",
    "compl_any_th",
    "compl_end_th",
    "left_hairpin_th",
    "right_hairpin_th",
    "specificity",
    "off_targets",
    "transcriptome",
    "pangenome_amplifies"
];
function Ro(e, t = {}) {
    const r = t.check ? Aa(e, t.check) : null, n = e.map((a)=>{
        const i = r?.byRank.get(a.rank), l = i?.pangenome?.summary;
        return [
            `P${a.rank + 1}`,
            a.rank + 1,
            a.left.seq,
            a.left.start,
            a.left.len,
            Ee(a.left.tm, 2),
            Ee(a.left.gc, 2),
            cs(a.left),
            gt(a.left.genomic),
            a.right.seq,
            a.right.start,
            a.right.len,
            Ee(a.right.tm, 2),
            Ee(a.right.gc, 2),
            cs(a.right),
            gt(a.right.genomic),
            a.product_size,
            Ee(a.product_tm, 2),
            gt(a.product?.genomic),
            a.product?.genomic_size ?? null,
            Ee(a.penalty, 4),
            Ee(a.compl_any_th, 2),
            Ee(a.compl_end_th, 2),
            Ee(a.left.hairpin_th, 2),
            Ee(a.right.hairpin_th, 2),
            i ? i.specificity?.verdict ?? "" : r ? "not checked" : "",
            i?.specificity ? i.specificity.off_target_count : null,
            i?.transcriptome?.verdict ?? "",
            l ? `${l.amplifies}/${l.genomes_total}` : ""
        ];
    });
    return ln($o, n);
}
function Mo(e, t = {}) {
    const r = Ir(t.label), n = [];
    for (const a of e)for (const [i, l] of [
        [
            "F",
            a.left
        ],
        [
            "R",
            a.right
        ]
    ]){
        const o = [
            `>${r}_P${a.rank + 1}_${i}`,
            `tm=${Ee(l.tm, 1) ?? ""}`,
            `gc=${Ee(l.gc, 1) ?? ""}`
        ], d = gt(l.genomic);
        d && o.push(d), n.push($r(o.join(" ")), l.seq.toUpperCase());
    }
    return n.length ? `${n.join(`
`)}
` : "";
}
function Sa(e, t, r = {}) {
    const n = Ir(r.label), a = t?.seq ?? "", i = [];
    for (const l of e){
        const o = l.left.start, d = l.right.end;
        if (!a || o < 1 || d > a.length || d < o) continue;
        const p = a.slice(o - 1, d).toUpperCase(), g = [
            `>${n}_P${l.rank + 1}_amplicon`,
            `size=${p.length}`,
            `template=${o}-${d}`
        ], m = gt(l.product?.genomic);
        m && g.push(m), i.push($r(g.join(" ")), Io(p));
    }
    return i.length ? `${i.join(`
`)}
` : "";
}
const Po = [
    "target",
    "pair",
    "verdict",
    "kind",
    "region",
    "start",
    "end",
    "size",
    "gene_id",
    "isoforms",
    "orientation",
    "likelihood",
    "left_mm",
    "right_mm",
    "left_3p_mm",
    "right_3p_mm",
    "left_mm_pos",
    "right_mm_pos",
    "approx",
    "genes"
];
function fn(e, t, r, n, a) {
    return [
        e,
        t,
        r,
        n,
        a.region,
        a.start,
        a.end,
        a.size,
        "",
        "",
        a.orientation,
        a.likelihood,
        a.left_mm,
        a.right_mm,
        a.left_3p_mm,
        a.right_3p_mm,
        (a.left_mm_pos ?? []).join(","),
        (a.right_mm_pos ?? []).join(","),
        a.approx ?? !1,
        (a.genes ?? []).map((i)=>i.id).join(",")
    ];
}
function ds(e, t, r, n) {
    const a = n.size_min === n.size_max ? n.size_min : `${n.size_min}-${n.size_max}`;
    return [
        "cdna",
        e,
        t,
        r,
        "",
        "",
        "",
        a,
        n.gene_id,
        (n.isoforms ?? []).map((i)=>i.transcript_id).join(","),
        n.orientation ?? "",
        n.likelihood,
        n.left_mm ?? null,
        n.right_mm ?? null,
        n.left_3p_mm ?? null,
        n.right_3p_mm ?? null,
        (n.left_mm_pos ?? []).join(","),
        (n.right_mm_pos ?? []).join(","),
        n.approx ?? !1,
        n.gene_id
    ];
}
function Oo(e) {
    const t = [];
    for (const r of e?.specificity?.pairs ?? []){
        r.on_target && t.push(fn("genome", r.id, r.verdict, "on_target", r.on_target));
        for (const n of r.off_targets ?? [])t.push(fn("genome", r.id, r.verdict, "off_target", n));
        for (const n of r.unlikely ?? [])t.push(fn("genome", r.id, r.verdict, "unlikely", n));
        for (const n of r.gdna_products ?? [])t.push(fn("genome", r.id, r.verdict, "gdna_product", n));
    }
    for (const r of e?.transcriptome?.pairs ?? []){
        r.on_target && t.push(ds(r.id, r.verdict, "on_target", r.on_target));
        for (const n of r.off_targets ?? [])t.push(ds(r.id, r.verdict, "off_target", n));
    }
    return ln(Po, t);
}
const zo = [
    "name",
    "set_id",
    "set_key",
    "role",
    "allele",
    "dye",
    "order_seq",
    "target_seq",
    "tail_seq",
    "length",
    "tm",
    "gc",
    "orientation",
    "product_size_ref",
    "product_size_alt",
    "variant_key",
    "notes"
];
function Ta(e) {
    return e.flatMap((t)=>t.order ?? []);
}
function Lo(e, t = {}) {
    const r = Ta(e).map((i)=>[
            i.name,
            i.set_id,
            i.set_key,
            i.role,
            i.allele,
            i.dye,
            i.order_seq,
            i.target_seq,
            i.tail_seq,
            i.length,
            Ee(i.tm, 2),
            Ee(i.gc, 2),
            i.orientation,
            i.product_size_ref,
            i.product_size_alt,
            i.variant_key,
            i.notes
        ]), n = [], a = t.kaspMix;
    return a && n.push(Sn(`# KASP mix: ${a.as_ref_uL} \xb5L REF + ${a.as_alt_uL} \xb5L ALT + ${a.common_uL} \xb5L common at ${a.stock_uM} \xb5M + ${a.water_uL} \xb5L water = ${a.total_uL} \xb5L (${a.source})`)), t.submissionSequence && n.push(Sn(`# Submission sequence: ${t.submissionSequence}`)), (n.length ? `${n.join(`
`)}
` : "") + ln(zo, r);
}
function qo(e) {
    const t = [];
    for (const r of Ta(e)){
        const n = [
            `>${Ir(r.name)}`,
            `tm=${Ee(r.tm, 1) ?? ""}`,
            `gc=${Ee(r.gc, 1) ?? ""}`,
            r.role
        ];
        r.dye && n.push(r.dye), t.push($r(n.join(" ")), r.order_seq.toUpperCase());
    }
    return t.length ? `${t.join(`
`)}
` : "";
}
const Go = [
    "system_name",
    "display_name",
    "is_reference",
    "allele",
    "observed",
    "source",
    "orthologous_copies",
    "paralog_copies",
    "reason",
    "set_id",
    "orientation",
    "predicted",
    "strength",
    "agrees",
    "reasons",
    "off_locus_products",
    "ref_primer",
    "alt_primer",
    "common_primer"
];
function Do(e) {
    const t = [], r = e?.sets ?? [];
    for (const n of e?.genomes ?? []){
        const a = [
            n.system_name,
            n.display_name ?? "",
            n.is_reference,
            n.allele,
            n.observed,
            n.source,
            n.orthologous_copies ?? null,
            n.paralog_copies ?? null,
            n.reason
        ];
        if (!r.length) {
            t.push([
                ...a,
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                ""
            ]);
            continue;
        }
        for (const i of r){
            const l = n.is_reference ? i.reference : (i.genomes ?? []).find((o)=>o.system_name === n.system_name) ?? null;
            t.push([
                ...a,
                i.id,
                i.orientation,
                l?.predicted ?? "",
                l?.strength ?? "",
                l?.agrees ?? null,
                (l?.reasons ?? []).join(","),
                l?.off_locus_products ?? null,
                l?.ref_primer?.status ?? "",
                l?.alt_primer?.status ?? "",
                l?.common_primer?.status ?? ""
            ]);
        }
    }
    return ln(Go, t);
}
const jo = [
    "pair",
    "reference_size",
    "system_name",
    "display_name",
    "status",
    "ortholog_annotated",
    "region",
    "start",
    "end",
    "strand",
    "size",
    "size_delta",
    "orientation",
    "likelihood",
    "left_mm",
    "right_mm",
    "left_3p_mm",
    "right_3p_mm",
    "mismatch_in_3p_window",
    "terminal_mismatch",
    "ortholog",
    "genes",
    "other_amplicons",
    "nearest_size",
    "truncated"
];
function ps(e) {
    return e ? typeof e.size_min == "number" && typeof e.size_max == "number" && e.size_min !== e.size_max ? `${e.size_min}-${e.size_max}` : e.size : null;
}
function Uo(e) {
    const t = [];
    for (const r of e?.pangenome?.pairs ?? [])for (const n of r.genomes ?? []){
        const a = n.primary ?? null, i = a?.genes ? a.genes.map((l)=>l.id).join(",") : a?.gene_id ?? "";
        t.push([
            r.id,
            r.reference_size,
            n.system_name,
            n.display_name ?? "",
            n.status,
            n.ortholog_annotated ?? null,
            a?.region ?? "",
            a?.start ?? null,
            a?.end ?? null,
            a?.strand ?? null,
            ps(a),
            a?.size_delta ?? null,
            a?.orientation ?? "",
            a?.likelihood ?? "",
            a?.left_mm ?? null,
            a?.right_mm ?? null,
            a?.left_3p_mm ?? null,
            a?.right_3p_mm ?? null,
            a?.mismatch_in_3p_window ?? null,
            a?.terminal_mismatch ?? null,
            a?.ortholog ?? null,
            i,
            n.other_amplicons ?? null,
            ps(n.nearest),
            n.truncated ?? null
        ]);
    }
    return ln(jo, t);
}
const ft = Object.freeze({
    single_perfect: {
        status: "single_perfect",
        glyph: "\u2713",
        color: "#009E73",
        label: "One amplicon, no mismatches",
        severity: 0,
        amplifies: !0
    },
    single_mismatch: {
        status: "single_mismatch",
        glyph: "\u2248",
        color: "#56B4E9",
        label: "One amplicon with mismatches",
        severity: 3,
        amplifies: !0
    },
    multiple: {
        status: "multiple",
        glyph: "\xd7",
        color: "#E69F00",
        label: "Two or more amplicons",
        severity: 4,
        amplifies: !0
    },
    no_amplicon: {
        status: "no_amplicon",
        glyph: "\u2205",
        color: "#D55E00",
        label: "No amplicon",
        severity: 5,
        amplifies: !1
    },
    db_unavailable: {
        status: "db_unavailable",
        glyph: "?",
        color: null,
        label: "No usable database",
        severity: 1,
        amplifies: !1
    },
    error: {
        status: "error",
        glyph: "!",
        color: "#555555",
        label: "Check failed",
        severity: 2,
        amplifies: !1
    },
    pending: {
        status: "pending",
        glyph: "\u2026",
        color: null,
        label: "Pending",
        severity: -1,
        amplifies: !1
    }
}), Rr = Object.freeze([
    "single_perfect",
    "single_mismatch",
    "multiple",
    "no_amplicon",
    "db_unavailable",
    "error"
]), Ea = "PANGENOME_TRANSCRIPT_MODELS_ONLY";
function Fo() {
    return {
        genomes_total: 0,
        single_perfect: 0,
        single_mismatch: 0,
        multiple: 0,
        no_amplicon: 0,
        db_unavailable: 0,
        error: 0,
        amplifies: 0,
        truncated: 0
    };
}
function Ld(e) {
    const t = Fo();
    for (const r of e)Rr.includes(r.status) && (t[r.status] += 1), t.genomes_total += 1, r.truncated && (t.truncated = (t.truncated ?? 0) + 1);
    return t.amplifies = t.single_perfect + t.single_mismatch + t.multiple, t;
}
function lr(e) {
    return e ? typeof e.summary?.truncated == "number" ? e.summary.truncated : (e.genomes ?? []).filter((t)=>t.truncated).length : 0;
}
function qd(e) {
    return Rr.reduce((r, n)=>r + (e[n] ?? 0), 0) === e.genomes_total && e.amplifies === e.single_perfect + e.single_mismatch + e.multiple;
}
function Ia(e) {
    return e ? {
        amplifies: e.single_perfect + e.single_mismatch + e.multiple,
        total: e.genomes_total
    } : {
        amplifies: 0,
        total: 0
    };
}
function Bo(e) {
    return e !== "single_perfect" && e !== "pending";
}
function Ko(e) {
    switch(e.status){
        case "single_perfect":
            {
                const t = e.primary?.size_delta;
                return typeof t == "number" ? t > 0 ? `+${t}` : String(t) : "";
            }
        case "single_mismatch":
            return e.primary?.mismatch_in_3p_window || e.primary?.terminal_mismatch ? "3\u2032" : "";
        case "multiple":
            return `\xd7${1 + (e.other_amplicons ?? e.others?.length ?? 1)}`;
        case "no_amplicon":
            return e.ortholog_annotated === !1 ? "no ortholog annotated" : "";
        default:
            return "";
    }
}
function Gd(e, t) {
    const r = [], n = /* @__PURE__ */ new Set();
    for (const a of e?.genomes ?? [])n.add(a.system_name), r.push({
        system_name: a.system_name,
        display_name: a.display_name ?? a.system_name,
        status: a.status,
        result: a
    });
    for (const a of t ?? []){
        const i = typeof a == "string" ? a : a.system_name;
        n.has(i) || (n.add(i), r.push({
            system_name: i,
            display_name: typeof a == "string" ? a : a.display_name ?? i,
            status: "pending",
            result: null
        }));
    }
    return r;
}
function Dd(e, t) {
    const r = (a, i)=>a.display_name.localeCompare(i.display_name) || a.system_name.localeCompare(i.system_name), n = [
        ...e
    ];
    return t === "name" ? n.sort(r) : n.sort((a, i)=>ft[i.status].severity - ft[a.status].severity || r(a, i));
}
function Ho(e) {
    if (!e) return !1;
    const t = "job_id" in e ? e.results : e;
    return [
        ...e.warnings ?? [],
        ...t?.warnings ?? []
    ].some((n)=>(typeof n == "string" ? n : n?.code) === Ea) ? !0 : t?.pangenome?.target === "cdna";
}
const Gt = typeof window < "u" ? (0, _react.useLayoutEffect) : (0, _react.useEffect), nn = 3, $a = 5e3, gs = {
    status: "idle",
    response: null,
    responseRequest: null,
    responseMeta: null,
    request: null,
    error: null,
    busy: null
};
function Vo(e, t) {
    const [r, n] = (0, _react.useState)(gs), a = (0, _react.useRef)(null), i = (0, _react.useRef)(0), l = (0, _react.useRef)(null), o = (0, _react.useRef)(t);
    Gt(()=>{
        o.current = t;
    });
    const d = (0, _react.useCallback)(()=>{
        a.current?.abort(), a.current = null, i.current += 1;
    }, []), p = (0, _react.useCallback)(async (u, h)=>{
        a.current?.abort();
        const y = new AbortController();
        a.current = y;
        const _ = ++i.current;
        n((b)=>({
                ...b,
                status: "running",
                request: u,
                error: null,
                busy: null
            }));
        let k = 0;
        for(;;)try {
            const b = await e.design(u, {
                signal: y.signal
            });
            if (_ !== i.current) return;
            a.current = null;
            const C = l.current;
            h.templateOnly || (l.current = b), n({
                status: "done",
                response: b,
                responseRequest: u,
                responseMeta: h,
                request: u,
                error: null,
                busy: null
            }), o.current.onSuccess?.(b, u, h, C);
            return;
        } catch (b) {
            if (_ !== i.current || y.signal.aborted || Ue(b)) return;
            if (Me(b) && b.code === "BUSY" && k < nn) {
                k += 1;
                const C = b.retryAfterMs ?? $a;
                n((N)=>({
                        ...N,
                        busy: {
                            attempt: k,
                            max: nn,
                            retryAt: Date.now() + C,
                            error: b
                        }
                    }));
                try {
                    await Cn(C, y.signal);
                } catch  {
                    return;
                }
                if (_ !== i.current) return;
                continue;
            }
            a.current = null, n((C)=>({
                    ...C,
                    status: "error",
                    error: b,
                    busy: null
                })), Me(b) && o.current.onError?.(b);
            return;
        }
    }, [
        e
    ]), g = (0, _react.useCallback)(()=>{
        d(), n((u)=>({
                ...u,
                status: u.response ? "done" : "idle",
                request: u.responseRequest,
                error: null,
                busy: null
            }));
    }, [
        d
    ]), m = (0, _react.useCallback)(()=>{
        d(), l.current = null, n(gs);
    }, [
        d
    ]), f = (0, _react.useCallback)(()=>{
        n((u)=>u.status === "error" ? {
                ...u,
                status: u.response ? "done" : "idle",
                error: null
            } : u);
    }, []);
    return (0, _react.useEffect)(()=>()=>a.current?.abort(), []), {
        state: r,
        run: p,
        cancel: g,
        reset: m,
        abort: d,
        clearError: f
    };
}
function Gn(e) {
    return typeof e == "number" ? Math.max(0, Math.ceil((e - Date.now()) / 1e3)) : 0;
}
function Ra(e) {
    const [t, r] = (0, _react.useState)(()=>Gn(e));
    return (0, _react.useEffect)(()=>{
        if (r(Gn(e)), typeof e != "number") return;
        const n = setInterval(()=>{
            const a = Gn(e);
            r(a), a <= 0 && clearInterval(n);
        }, 250);
        return ()=>clearInterval(n);
    }, [
        e
    ]), t;
}
function Pe(...e) {
    return e.filter(Boolean).join(" ");
}
function v(e) {
    return typeof e == "number" && Number.isFinite(e) ? Math.round(e).toLocaleString("en-US") : "\u2013";
}
function F(e, t = 1) {
    return typeof e == "number" && Number.isFinite(e) ? e.toFixed(t) : "\u2013";
}
function Ma(e, t = 1) {
    return typeof e == "number" && Number.isFinite(e) ? `${(e * 100).toFixed(t)}%` : "\u2013";
}
function Wo(e) {
    return e === -1 ? "\u2212" : "+";
}
function Yo(e) {
    return `P${e + 1}`;
}
function De(e = "gpr") {
    const t = (0, _react.useId)();
    return `${e}-${t.replace(/[^A-Za-z0-9_-]/g, "")}`;
}
const ms = Object.freeze({
    gene: "Gene",
    transcript: "Transcript (qPCR)",
    region: "Region",
    sequence: "Sequence",
    genotyping: "Genotyping (KASP)"
});
function Pa(e) {
    return e?.gene_structure?.transcripts ?? [];
}
function Mr(e, t) {
    const r = Pa(e);
    if (!r.length) return null;
    const n = t ?? gr(e ?? null);
    return r.find((a)=>a.id === n) ?? null;
}
function Oa(e) {
    return !!e?.location && mr(e) > ee.maxTemplateLength;
}
function Jo(e, t, r) {
    switch(e.mode){
        case "gene":
            return t?.location ? ra(t, e.flankUp ?? 0, e.flankDown ?? 0).length : null;
        case "transcript":
            return Mr(t, e.transcriptId)?.length ?? null;
        case "region":
            return e.region ? e.region.end - e.region.start + 1 : null;
        case "sequence":
            return r;
        default:
            return null;
    }
}
function cr(e, t) {
    const r = e.region;
    if (!r || e.mode === "sequence") return null;
    const n = e.strand === -1 ? -1 : 1;
    if (e.mode === "transcript") {
        for (const a of e.features?.exons ?? [])if (t >= a.start && t <= a.end && a.genomic) {
            const i = t - a.start;
            return {
                region: r,
                pos: n === 1 ? a.genomic.start + i : a.genomic.end - i
            };
        }
        return null;
    }
    return typeof e.start != "number" || typeof e.end != "number" ? null : {
        region: r,
        pos: _i(t, {
            start: e.start,
            end: e.end,
            strand: n
        })
    };
}
function rt(e, t, r) {
    return Math.min(r, Math.max(t, e));
}
function Yt(e, t) {
    return JSON.stringify(e) === JSON.stringify(t);
}
function Xo(e) {
    return Me(e) && (e.code === "PRIMER3_UNAVAILABLE" || e.code === "FEATURE_DISABLED");
}
function us(e, t) {
    const r = e?.[t];
    return typeof r == "number" && Number.isFinite(r) ? r : null;
}
function rn({ error: e, context: t, busy: r, onRetry: n, onCancel: a, onDismiss: i }) {
    const l = Me(e) && e.code === "QUEUE_FULL", o = (0, _react.useMemo)(()=>r ? r.retryAt : l && Me(e) ? Date.now() + (e.retryAfterMs ?? 6e4) : null, [
        r,
        e,
        l
    ]), d = Ra(o);
    if (r) return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: "gpr-banner gpr-banner-warn",
        role: "status",
        "data-code": "BUSY",
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-banner-title",
                children: [
                    "The server is busy. Retrying in ",
                    d,
                    " s (attempt ",
                    r.attempt,
                    " of ",
                    r.max,
                    ")\u2026"
                ]
            }),
            a ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                className: "gpr-banner-actions",
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                    type: "button",
                    className: "gpr-btn",
                    onClick: a,
                    children: "Cancel"
                })
            }) : null
        ]
    });
    if (!e) return null;
    const p = Me(e) ? e : null, g = p?.code ?? (e instanceof Error && e.name ? e.name : "ERROR"), m = e instanceof Error ? e.message : String(e), f = t === "check" ? "check" : t === "genomes" ? "genome list" : "design";
    let u, h = null, y = !1, _ = !1, k = !0;
    switch(g){
        case "BUSY":
            u = "The server is still busy.", h = /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-banner-text",
                children: [
                    "Gave up after ",
                    nn,
                    " automatic retries. Try again in a moment."
                ]
            }), y = !0;
            break;
        case "QUEUE_FULL":
            u = "The check queue is full.", h = /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                className: "gpr-banner-text",
                children: d > 0 ? `You can retry in ${d} s.` : "You can retry now."
            }), y = !0, _ = d > 0;
            break;
        case "JOB_TOO_LARGE":
            {
                const b = us(p?.details, "estimate_cpu_s"), C = us(p?.details, "limit") ?? ca;
                u = "This check is too large.", h = /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                    className: "gpr-banner-text",
                    children: [
                        "Estimated ",
                        v(b),
                        " CPU-s; the limit is ",
                        v(C),
                        " CPU-s. Select fewer pairs or genomes."
                    ]
                });
                break;
            }
        case "PRIMER3_UNAVAILABLE":
            u = "Primer design is temporarily unavailable.", h = /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                className: "gpr-banner-text",
                children: "Primer3 is not available on this server, so the form is disabled."
            }), y = !0;
            break;
        case "FEATURE_DISABLED":
            u = t === "check" ? "Primer checks are disabled on this server." : "Primer design is disabled on this server.", h = /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                className: "gpr-banner-text",
                children: t === "check" ? "The check panel is disabled." : "The form is disabled."
            });
            break;
        case "VALIDATION":
            u = "The server rejected the request.", k = !1, h = /* @__PURE__ */ (0, _jsxRuntime.jsx)("ul", {
                className: "gpr-banner-list",
                children: ka(p?.errors).map((b, C)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("li", {
                        children: [
                            b.message || b.code,
                            Array.isArray(b.path) && b.path.length ? ` (${b.path.join(".")})` : "",
                            " ",
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("code", {
                                className: "gpr-code",
                                children: b.code
                            })
                        ]
                    }, C))
            });
            break;
        case "NETWORK":
            u = `The ${f} request could not reach the server.`, y = !0;
            break;
        case "TIMEOUT":
            u = `The ${f} request timed out.`, y = !0;
            break;
        default:
            p && p.status >= 500 ? (u = `The server could not complete the ${f}.`, y = !0) : (u = m || `The ${f} request failed.`, k = !1);
    }
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: "gpr-banner gpr-banner-error",
        role: "alert",
        "data-code": g,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                className: "gpr-banner-title",
                children: u
            }),
            k && m ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-banner-text",
                children: [
                    m,
                    " ",
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("code", {
                        className: "gpr-code",
                        children: g
                    })
                ]
            }) : !k && g !== "VALIDATION" ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                className: "gpr-banner-text",
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("code", {
                    className: "gpr-code",
                    children: g
                })
            }) : null,
            h,
            y && n || i ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                className: "gpr-banner-actions",
                children: [
                    y && n ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "gpr-btn",
                        disabled: _,
                        onClick: n,
                        children: "Retry"
                    }) : null,
                    i ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "gpr-btn gpr-btn-quiet",
                        onClick: i,
                        children: "Dismiss"
                    }) : null
                ]
            }) : null
        ]
    });
}
function hs(e) {
    const t = e.trim();
    if (t === "") return;
    const r = Number(t);
    return Number.isFinite(r) ? r : null;
}
function mt(e) {
    const [t, r] = (0, _react.useState)(e.value === void 0 ? "" : String(e.value));
    (0, _react.useEffect)(()=>{
        r((d)=>{
            const p = hs(d);
            return p === e.value || p === null && e.value === void 0 ? d : e.value === void 0 ? "" : String(e.value);
        });
    }, [
        e.value
    ]);
    const n = e.issues ?? [], a = `${e.id}-err`, i = `${e.id}-hint`, l = [
        e.hint ? i : null,
        e.describedBy ?? null,
        n.length ? a : null
    ].filter(Boolean).join(" ") || void 0, o = /* @__PURE__ */ (0, _jsxRuntime.jsx)("label", {
        className: "gpr-label",
        htmlFor: e.id,
        children: e.label
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: Pe("gpr-field", e.className),
        "data-state": n.length ? "invalid" : e.changed ? "changed" : void 0,
        children: [
            e.labelAddon ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                className: "gpr-label-row",
                children: [
                    o,
                    e.labelAddon
                ]
            }) : o,
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                id: e.id,
                className: "gpr-input gpr-input-number",
                type: "number",
                inputMode: "decimal",
                value: t,
                placeholder: e.placeholder,
                min: e.min,
                max: e.max,
                step: e.step ?? "any",
                disabled: e.disabled,
                "aria-invalid": n.length ? !0 : void 0,
                "aria-describedby": l,
                onChange: (d)=>{
                    const p = d.target.value;
                    r(p);
                    const g = hs(p);
                    g !== null && e.onChange(g);
                }
            }),
            e.hint ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                id: i,
                className: "gpr-hint",
                children: e.hint
            }) : null,
            n.length ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                id: a,
                className: "gpr-field-error",
                children: n.map((d)=>d.message).join(" ")
            }) : null
        ]
    });
}
function Ot(e) {
    const t = e.issues ?? [], r = `${e.id}-err`, n = `${e.id}-hint`, a = [
        e.hint ? n : null,
        t.length ? r : null
    ].filter(Boolean).join(" ") || void 0;
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: Pe("gpr-field", e.className),
        "data-state": t.length ? "invalid" : void 0,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("label", {
                className: "gpr-label",
                htmlFor: e.id,
                children: e.label
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                id: e.id,
                className: Pe("gpr-input", e.short && "gpr-input-short"),
                type: e.type ?? "text",
                value: e.value,
                placeholder: e.placeholder,
                disabled: e.disabled,
                "aria-invalid": t.length ? !0 : void 0,
                "aria-describedby": a,
                onChange: (i)=>e.onChange(i.target.value)
            }),
            e.hint ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                id: n,
                className: "gpr-hint",
                children: e.hint
            }) : null,
            t.length ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                id: r,
                className: "gpr-field-error",
                children: t.map((i)=>i.message).join(" ")
            }) : null
        ]
    });
}
function Ie(e) {
    const t = `${e.id}-hint`, r = `${e.id}-desc`, n = Pe(e.hint ? t : null, e.description ? r : null) || void 0;
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: Pe("gpr-check-row", e.className),
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                id: e.id,
                className: "gpr-checkbox",
                type: "checkbox",
                checked: e.checked,
                disabled: e.disabled,
                "aria-describedby": n,
                onChange: (a)=>e.onChange(a.target.checked)
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("label", {
                className: "gpr-label gpr-label-inline",
                htmlFor: e.id,
                title: e.description,
                children: e.label
            }),
            e.description ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                id: r,
                className: "gpr-visually-hidden",
                children: e.description
            }) : null,
            e.hint ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                id: t,
                className: "gpr-hint gpr-check-hint",
                children: e.hint
            }) : null
        ]
    });
}
function za(e) {
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("fieldset", {
        className: "gpr-subfieldset gpr-presets",
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("legend", {
                className: "gpr-legend gpr-legend-small",
                children: e.legend
            }),
            e.options.map((t)=>{
                const r = `${e.idPrefix}-preset-${t.id}`, n = `${r}-desc`;
                return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                    className: "gpr-radio-row",
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                            type: "radio",
                            className: "gpr-radio",
                            id: r,
                            name: `${e.idPrefix}-preset`,
                            checked: e.value === t.id,
                            "aria-describedby": t.description ? n : void 0,
                            onChange: ()=>e.onChange(t.id)
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("label", {
                            className: "gpr-label gpr-label-inline",
                            htmlFor: r,
                            children: t.label
                        }),
                        t.description ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                            id: n,
                            className: "gpr-hint gpr-preset-desc",
                            children: t.description
                        }) : null
                    ]
                }, t.id);
            })
        ]
    });
}
function Jt(e, t) {
    return `${e}-tab-${t}`;
}
function Pr(e) {
    const t = (0, _react.useRef)(/* @__PURE__ */ new Map()), r = e.items.filter((i)=>!i.disabledReason), n = e.items.some((i)=>i.id === e.value), a = (i)=>{
        if (!r.length) return;
        const l = r.findIndex((d)=>d.id === e.value);
        let o;
        switch(i.key){
            case "ArrowRight":
                o = r[(l + 1) % r.length];
                break;
            case "ArrowLeft":
                o = r[(l <= 0 ? r.length : l) - 1];
                break;
            case "Home":
                o = r[0];
                break;
            case "End":
                o = r[r.length - 1];
                break;
            default:
                return;
        }
        o && (i.preventDefault(), e.onChange(o.id), t.current.get(o.id)?.focus());
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        role: "tablist",
        "aria-label": e.label,
        className: Pe("gpr-tabs", e.className),
        onKeyDown: a,
        children: e.items.map((i, l)=>{
            const o = i.id === e.value;
            return /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                ref: (d)=>{
                    d ? t.current.set(i.id, d) : t.current.delete(i.id);
                },
                type: "button",
                role: "tab",
                id: Jt(e.idPrefix, i.id),
                className: "gpr-tab",
                "aria-selected": o,
                "aria-controls": e.panelId,
                "aria-disabled": i.disabledReason ? !0 : void 0,
                "aria-describedby": i.describedBy,
                tabIndex: o || !n && l === 0 ? 0 : -1,
                onClick: ()=>{
                    i.disabledReason || e.onChange(i.id);
                },
                children: i.label
            }, i.id);
        })
    });
}
const Qo = '.gpr-root{--gpr-font: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;--gpr-mono: ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace;--gpr-font-size: 14px;--gpr-radius: 6px;--gpr-gap: 12px;--gpr-bg: #ffffff;--gpr-surface: #f6f8fa;--gpr-surface-2: #eaeef2;--gpr-fg: #1f2328;--gpr-muted: #57606a;--gpr-border: #d0d7de;--gpr-accent: #0b5cad;--gpr-accent-fg: #ffffff;--gpr-accent-soft: #ddeaf8;--gpr-focus: #1a73e8;--gpr-danger: #b42318;--gpr-danger-soft: #fdecea;--gpr-warn: #7a4a00;--gpr-warn-soft: #fff3d1;--gpr-ok: #0a6b47;--gpr-ok-soft: #e0f4ea;--gpr-info: #1a5a86;--gpr-info-soft: #e3f1fb;--gpr-selected: #fff3b0;--gpr-utr5: #aaccaf;--gpr-cds: #a7b4d3;--gpr-utr3: #c5a3bf;--gpr-intron: #aaaaaa;--gpr-exon-alt: #8796bd;--gpr-mask: #7a6a53;--gpr-target: #d55e00;--gpr-included: #009e73;--gpr-excluded: #b42318;--gpr-primer-left: #0072b2;--gpr-primer-right: #cc79a7;--gpr-fp-left-bg: #d3e7f6;--gpr-fp-right-bg: #f5dfec;--gpr-masked-fg: #8a8f96;--gpr-st-perfect: #009e73;--gpr-st-mismatch: #56b4e9;--gpr-st-multiple: #e69f00;--gpr-st-none: #d55e00;--gpr-st-error: #555555;--gpr-st-db: #8c8c8c;box-sizing:border-box;container-type:inline-size;container-name:gpr;color:var(--gpr-fg);background-color:var(--gpr-bg);font-family:var(--gpr-font);font-size:var(--gpr-font-size);font-weight:400;line-height:1.45;text-align:left;-webkit-text-size-adjust:100%}.gpr-root.gpr-theme-light{color-scheme:light}.gpr-root.gpr-theme-dark{color-scheme:dark;--gpr-bg: #0f1419;--gpr-surface: #161b22;--gpr-surface-2: #212833;--gpr-fg: #e6edf3;--gpr-muted: #9da7b3;--gpr-border: #3b4450;--gpr-accent: #58a6ff;--gpr-accent-fg: #0b1220;--gpr-accent-soft: #14304d;--gpr-focus: #79b8ff;--gpr-danger: #ff8078;--gpr-danger-soft: #3a1714;--gpr-warn: #e3b341;--gpr-warn-soft: #3a2c0c;--gpr-ok: #56d364;--gpr-ok-soft: #0f2e1d;--gpr-info: #79c0ff;--gpr-info-soft: #10273d;--gpr-selected: #3d3614;--gpr-exon-alt: #6f7fa8;--gpr-fp-left-bg: #173b57;--gpr-fp-right-bg: #4a2240;--gpr-masked-fg: #7d8590;--gpr-st-error: #9a9a9a;--gpr-st-db: #6e7681}@media(prefers-color-scheme:dark){.gpr-root.gpr-theme-auto{color-scheme:dark;--gpr-bg: #0f1419;--gpr-surface: #161b22;--gpr-surface-2: #212833;--gpr-fg: #e6edf3;--gpr-muted: #9da7b3;--gpr-border: #3b4450;--gpr-accent: #58a6ff;--gpr-accent-fg: #0b1220;--gpr-accent-soft: #14304d;--gpr-focus: #79b8ff;--gpr-danger: #ff8078;--gpr-danger-soft: #3a1714;--gpr-warn: #e3b341;--gpr-warn-soft: #3a2c0c;--gpr-ok: #56d364;--gpr-ok-soft: #0f2e1d;--gpr-info: #79c0ff;--gpr-info-soft: #10273d;--gpr-selected: #3d3614;--gpr-exon-alt: #6f7fa8;--gpr-fp-left-bg: #173b57;--gpr-fp-right-bg: #4a2240;--gpr-masked-fg: #7d8590;--gpr-st-error: #9a9a9a;--gpr-st-db: #6e7681}}.gpr-root *,.gpr-root *:before,.gpr-root *:after{box-sizing:inherit}.gpr-root details>*{box-sizing:border-box}.gpr-root button,.gpr-root input,.gpr-root select,.gpr-root textarea{margin:0;font-family:inherit;font-size:inherit;font-weight:inherit;line-height:1.3;color:inherit;letter-spacing:normal;text-transform:none;overflow:visible;box-shadow:none;max-width:100%}.gpr-root button{border-radius:var(--gpr-radius)}.gpr-root button:focus,.gpr-root input:focus,.gpr-root select:focus,.gpr-root textarea:focus{outline:none}.gpr-root textarea{overflow:auto}.gpr-root table{border-collapse:collapse;border-spacing:0;margin:0;background-color:transparent;color:inherit;font-size:inherit}.gpr-root th,.gpr-root td{padding:0;border:0;text-align:left;vertical-align:top;font-weight:inherit}.gpr-root caption{caption-side:top;padding:0;color:inherit;text-align:left}.gpr-root label{display:inline;margin:0;font-weight:inherit;cursor:default}.gpr-root code,.gpr-root pre,.gpr-root kbd{font-family:var(--gpr-mono);font-size:.92em;color:inherit;background-color:transparent;padding:0;border-radius:0;word-wrap:normal;word-break:normal}.gpr-root pre{margin:0;overflow:auto;white-space:pre;border:0}.gpr-root h3,.gpr-root h4{margin:0;font-family:inherit;font-weight:600;line-height:1.3;color:inherit}.gpr-root h3{font-size:1.05em}.gpr-root h4{font-size:1em}.gpr-root p,.gpr-root ul,.gpr-root ol,.gpr-root dl,.gpr-root dt,.gpr-root dd{margin:0}.gpr-root ul,.gpr-root ol{padding:0;list-style:none}.gpr-root fieldset{min-width:0;margin:0;padding:0;border:0}.gpr-root legend{display:block;float:none;width:auto;max-width:100%;margin:0;padding:0;font-size:inherit;line-height:inherit;color:inherit;white-space:normal}.gpr-root a{color:var(--gpr-accent);text-decoration:underline;background-color:transparent}.gpr-root a:hover{color:var(--gpr-accent);text-decoration:underline}.gpr-root summary{display:list-item;cursor:pointer}.gpr-root svg{overflow:visible;vertical-align:middle}.gpr-root strong,.gpr-root b{font-weight:600}.gpr-root small{font-size:.85em}.gpr-root :focus-visible{outline:2px solid var(--gpr-focus);outline-offset:2px}.gpr-root .gpr-visually-hidden{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);white-space:nowrap;border:0}.gpr-root .gpr-sub{color:var(--gpr-muted);font-size:.85em;font-weight:400}.gpr-root .gpr-block{display:block}.gpr-root .gpr-hint{color:var(--gpr-muted);font-size:.88em}.gpr-root .gpr-label-row{display:inline-flex;flex-wrap:wrap;align-items:center;gap:2px 5px}.gpr-root .gpr-help-button{display:inline-flex;flex:none;align-items:center;justify-content:center;width:16px;height:16px;padding:0;border:1px solid var(--gpr-border);border-radius:50%;background-color:var(--gpr-bg);color:var(--gpr-muted);font-size:11px;font-weight:700;line-height:1;cursor:pointer}.gpr-root .gpr-help-button:hover,.gpr-root .gpr-help-button[aria-expanded=true]{border-color:var(--gpr-accent);color:var(--gpr-accent)}.gpr-root .gpr-help-text{margin:0 0 6px}.gpr-root .gpr-help-wide{grid-column:1 / -1}.gpr-root .gpr-p3-tag{font-family:var(--gpr-mono);font-size:.92em;overflow-wrap:anywhere}.gpr-root .gpr-column-help{margin-top:8px}.gpr-root .gpr-column-help-list dd{margin:0}.gpr-root .gpr-p3-credit{margin-top:10px}.gpr-root .gpr-field-error{color:var(--gpr-danger);font-size:.88em}.gpr-root .gpr-readout{font-size:.92em;font-variant-numeric:tabular-nums}.gpr-root .gpr-note{padding:6px 10px;border-left:3px solid var(--gpr-info);border-radius:0 var(--gpr-radius) var(--gpr-radius) 0;background-color:var(--gpr-info-soft);font-size:.92em}.gpr-root .gpr-code{font-family:var(--gpr-mono);font-size:.82em;color:var(--gpr-muted)}.gpr-root .gpr-seq{font-family:var(--gpr-mono);font-size:.92em;letter-spacing:.02em;word-break:break-all;color:var(--gpr-fg)}.gpr-root .gpr-num{text-align:right;white-space:nowrap;font-variant-numeric:tabular-nums}.gpr-root .gpr-loc{white-space:nowrap;font-variant-numeric:tabular-nums}.gpr-root .gpr-link{color:var(--gpr-accent)}.gpr-root .gpr-link-button{padding:0;border:0;border-radius:2px;background:none;color:var(--gpr-accent);text-decoration:underline;cursor:pointer}.gpr-root .gpr-gene-list{display:inline-flex;flex-wrap:wrap;gap:2px 8px}.gpr-root .gpr-plain-list,.gpr-root .gpr-banner-list,.gpr-root .gpr-issues{list-style:disc;padding-left:1.2em}.gpr-root .gpr-designer{display:flex;flex-direction:column;gap:var(--gpr-gap)}.gpr-root .gpr-header,.gpr-root .gpr-mode-tabs{display:flex;flex-direction:column;gap:4px}.gpr-root .gpr-layout{display:grid;grid-template-columns:minmax(0,1fr);gap:var(--gpr-gap) 18px;align-items:start}.gpr-root .gpr-splitter{display:none;position:relative;align-self:stretch;min-height:48px;cursor:col-resize;touch-action:none;user-select:none}.gpr-root .gpr-splitter:before{content:"";position:absolute;top:0;bottom:0;left:8px;width:2px;border-radius:1px;background-color:var(--gpr-border);transition:background-color .15s ease}.gpr-root .gpr-splitter:hover:before,.gpr-root .gpr-splitter:focus-visible:before,.gpr-root .gpr-splitter[data-state=dragging]:before{background-color:var(--gpr-accent)}.gpr-root .gpr-layout[data-dragging]{cursor:col-resize;user-select:none}@container gpr (min-width: 960px){.gpr-root .gpr-layout{grid-template-columns:minmax(300px,380px) 18px minmax(0,1fr);column-gap:0}.gpr-root .gpr-layout[data-resized]{grid-template-columns:clamp(300px,var(--gpr-form-width),calc(100% - 378px)) 18px minmax(0,1fr)}.gpr-root .gpr-splitter{display:block}}@supports not (container-type: inline-size){@media(min-width:1000px){.gpr-root .gpr-layout{grid-template-columns:minmax(300px,380px) 18px minmax(0,1fr);column-gap:0}.gpr-root .gpr-layout[data-resized]{grid-template-columns:clamp(300px,var(--gpr-form-width),calc(100% - 378px)) 18px minmax(0,1fr)}.gpr-root .gpr-splitter{display:block}}}.gpr-root .gpr-inputs,.gpr-root .gpr-results{display:flex;flex-direction:column;gap:var(--gpr-gap);min-width:0}.gpr-root .gpr-form-fieldset{display:flex;flex-direction:column;gap:10px}.gpr-root .gpr-tabs{display:flex;flex-wrap:wrap;gap:2px;border-bottom:1px solid var(--gpr-border)}.gpr-root .gpr-tab{margin-bottom:-1px;padding:6px 12px;border:1px solid transparent;border-bottom:0;border-radius:var(--gpr-radius) var(--gpr-radius) 0 0;background-color:transparent;color:var(--gpr-muted);font-weight:500;cursor:pointer}.gpr-root .gpr-tab:hover{color:var(--gpr-fg);background-color:var(--gpr-surface)}.gpr-root .gpr-tab[aria-selected=true]{color:var(--gpr-fg);background-color:var(--gpr-bg);border-color:var(--gpr-border);border-bottom:1px solid var(--gpr-bg)}.gpr-root .gpr-tab[aria-disabled=true]{opacity:.55;cursor:not-allowed;text-decoration:line-through}.gpr-root .gpr-tabpanel{padding-top:8px}.gpr-root .gpr-result-tabs{display:flex;flex-direction:column}.gpr-root .gpr-fieldset{display:flex;flex-direction:column;gap:8px;padding:8px 10px 10px;border:1px solid var(--gpr-border);border-radius:var(--gpr-radius);background-color:var(--gpr-surface)}.gpr-root .gpr-subfieldset{display:flex;flex-direction:column;gap:6px}.gpr-root .gpr-legend{padding:0 4px;margin-left:-4px;font-weight:600}.gpr-root .gpr-legend-small{padding:0;margin:0 0 2px;font-size:.9em;color:var(--gpr-muted)}.gpr-root .gpr-field{display:flex;flex-direction:column;gap:3px;min-width:0}.gpr-root .gpr-field-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(9.5em,1fr));gap:8px}.gpr-root .gpr-triple-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:6px}.gpr-root .gpr-label{font-size:.92em;font-weight:500}.gpr-root .gpr-label-inline{font-size:1em;font-weight:400}.gpr-root .gpr-input,.gpr-root .gpr-select,.gpr-root .gpr-textarea{display:block;width:100%;min-height:30px;height:auto;padding:4px 8px;border:1px solid var(--gpr-border);border-radius:var(--gpr-radius);background-color:var(--gpr-bg);color:var(--gpr-fg)}.gpr-root .gpr-input-short{display:inline-block;width:7em}.gpr-root .gpr-select-small{display:inline-block;width:auto;min-height:26px;padding:2px 6px}.gpr-root .gpr-textarea{min-height:8em;font-family:var(--gpr-mono);font-size:.9em;word-break:break-all;resize:vertical}.gpr-root .gpr-input:focus-visible,.gpr-root .gpr-select:focus-visible,.gpr-root .gpr-textarea:focus-visible{outline:2px solid var(--gpr-focus);outline-offset:0;border-color:var(--gpr-focus)}.gpr-root .gpr-input[aria-invalid=true],.gpr-root .gpr-select[aria-invalid=true],.gpr-root .gpr-textarea[aria-invalid=true]{border-color:var(--gpr-danger)}.gpr-root .gpr-input:disabled,.gpr-root .gpr-select:disabled,.gpr-root .gpr-textarea:disabled{opacity:.6;cursor:not-allowed}.gpr-root .gpr-field[data-state=changed] .gpr-input{border-color:var(--gpr-accent);background-color:var(--gpr-accent-soft)}.gpr-root .gpr-check-row,.gpr-root .gpr-radio-row{display:flex;flex-wrap:wrap;align-items:baseline;gap:2px 8px}.gpr-root .gpr-check-hint,.gpr-root .gpr-preset-desc{flex-basis:100%;padding-left:22px}.gpr-root .gpr-checkbox,.gpr-root .gpr-radio{position:relative;top:2px;flex:none;width:14px;height:14px;margin:0;accent-color:var(--gpr-accent)}.gpr-root .gpr-inline{display:flex;align-items:center;gap:6px}.gpr-root .gpr-inline .gpr-select{flex:1 1 auto;min-width:0}.gpr-root .gpr-flank-controls{display:flex;align-items:center;gap:8px}.gpr-root .gpr-range{flex:1 1 auto;min-width:0;accent-color:var(--gpr-accent)}.gpr-root .gpr-gene-summary{font-size:.95em}.gpr-root .gpr-gene-name{font-weight:600}.gpr-root .gpr-mask-source-name{color:var(--gpr-fg)}.gpr-root .gpr-interval-row{display:flex;flex-wrap:wrap;align-items:center;gap:4px 6px}.gpr-root .gpr-interval-label{min-width:7.5em;font-size:.92em;font-weight:500}.gpr-root .gpr-interval-end{min-width:5em}.gpr-root .gpr-interval-error{flex-basis:100%}.gpr-root .gpr-range-chips{display:flex;flex-wrap:wrap;gap:4px}.gpr-root .gpr-range-chip{display:inline-flex;align-items:center;gap:2px;padding:1px 2px 1px 8px;border:1px solid var(--gpr-accent);border-radius:999px;background-color:var(--gpr-accent-soft);font-size:.9em;font-variant-numeric:tabular-nums}.gpr-root .gpr-range-chip-remove{padding:0 6px;border:0;border-radius:999px;background:none;color:inherit;font-weight:700;line-height:1.2;cursor:pointer}.gpr-root .gpr-range-chip-remove:disabled{opacity:.35;cursor:not-allowed}.gpr-root .gpr-range-add{display:flex;flex-wrap:wrap;align-items:center;gap:4px}.gpr-root .gpr-ranges[data-state=changed] .gpr-legend-small{color:var(--gpr-accent)}.gpr-root .gpr-details{padding-top:6px;border-top:1px solid var(--gpr-border)}.gpr-root .gpr-summary{font-size:.92em;font-weight:600}.gpr-root .gpr-details[open]>.gpr-summary{margin-bottom:6px}.gpr-root .gpr-issues{color:var(--gpr-danger);font-size:.88em}.gpr-root .gpr-btn{display:inline-flex;align-items:center;justify-content:center;gap:4px;min-height:30px;padding:4px 12px;border:1px solid var(--gpr-border);border-radius:var(--gpr-radius);background-color:var(--gpr-surface-2);color:var(--gpr-fg);font-weight:500;white-space:nowrap;text-decoration:none;cursor:pointer;transition:background-color .15s ease,border-color .15s ease}.gpr-root .gpr-btn:hover:not(:disabled){border-color:var(--gpr-accent)}.gpr-root .gpr-btn:disabled{opacity:.55;cursor:not-allowed}.gpr-root .gpr-btn-primary{border-color:var(--gpr-accent);background-color:var(--gpr-accent);color:var(--gpr-accent-fg)}.gpr-root .gpr-btn-primary:hover:not(:disabled){filter:brightness(1.08)}.gpr-root .gpr-btn-small{min-height:24px;padding:1px 8px;font-size:.88em}.gpr-root .gpr-btn-quiet{border-color:transparent;background-color:transparent;color:var(--gpr-accent)}.gpr-root .gpr-btn-quiet:hover:not(:disabled){border-color:var(--gpr-border)}.gpr-root .gpr-copy[data-state=copied]{border-color:var(--gpr-ok);color:var(--gpr-ok)}.gpr-root .gpr-copy[data-state=failed]{border-color:var(--gpr-danger);color:var(--gpr-danger)}.gpr-root .gpr-button-row,.gpr-root .gpr-actions{display:flex;flex-wrap:wrap;align-items:center;gap:6px}.gpr-root .gpr-disclosure{display:inline-flex;align-items:center;gap:6px;padding:2px 0;border:0;background:none;color:inherit;font-weight:600;cursor:pointer}.gpr-root .gpr-disclosure:before{content:"\u25B8";display:inline-block;transition:transform .15s ease}.gpr-root .gpr-disclosure[aria-expanded=true]:before{transform:rotate(90deg)}.gpr-root .gpr-empty{padding:24px;border:1px dashed var(--gpr-border);border-radius:var(--gpr-radius);color:var(--gpr-muted);text-align:center}.gpr-root .gpr-status-line{color:var(--gpr-muted);font-size:.92em}.gpr-root .gpr-status-done{color:var(--gpr-ok)}.gpr-root .gpr-warnings{display:flex;flex-direction:column;gap:4px}.gpr-root .gpr-warnings-title{font-size:.92em;font-weight:600}.gpr-root .gpr-warning-list{display:flex;flex-direction:column;gap:4px}.gpr-root .gpr-warning{display:flex;flex-wrap:wrap;align-items:baseline;gap:4px 6px;padding:5px 10px;border-left:3px solid var(--gpr-warn);border-radius:0 var(--gpr-radius) var(--gpr-radius) 0;background-color:var(--gpr-warn-soft)}.gpr-root .gpr-warning-glyph{color:var(--gpr-warn)}.gpr-root .gpr-banner{display:flex;flex-direction:column;gap:4px;padding:8px 12px;border:1px solid var(--gpr-border);border-left-width:4px;border-radius:var(--gpr-radius)}.gpr-root .gpr-banner-error{border-color:var(--gpr-danger);background-color:var(--gpr-danger-soft)}.gpr-root .gpr-banner-warn{border-color:var(--gpr-warn);background-color:var(--gpr-warn-soft)}.gpr-root .gpr-banner-title{font-weight:600}.gpr-root .gpr-banner-actions{display:flex;flex-wrap:wrap;gap:6px;margin-top:4px}.gpr-root .gpr-chip{display:inline-flex;align-items:center;gap:4px;padding:0 8px;border:1px solid currentColor;border-radius:999px;font-size:.85em;font-weight:600;line-height:1.6;white-space:nowrap}.gpr-root .gpr-chip-glyph{font-weight:700}.gpr-root .gpr-chip-ok{color:var(--gpr-ok);background-color:var(--gpr-ok-soft)}.gpr-root .gpr-chip-warn{color:var(--gpr-warn);background-color:var(--gpr-warn-soft)}.gpr-root .gpr-chip-bad{color:var(--gpr-danger);background-color:var(--gpr-danger-soft)}.gpr-root .gpr-chip-info{color:var(--gpr-info);background-color:var(--gpr-info-soft)}.gpr-root .gpr-chip-muted{color:var(--gpr-muted);background-color:var(--gpr-surface);border-style:dashed}.gpr-root .gpr-badge{display:inline-block;padding:0 6px;border:1px solid var(--gpr-border);border-radius:4px;background-color:var(--gpr-surface-2);color:var(--gpr-muted);font-size:.78em;font-weight:600;white-space:nowrap}.gpr-root .gpr-badge-warn{border-color:var(--gpr-warn);background-color:var(--gpr-warn-soft);color:var(--gpr-warn)}.gpr-root .gpr-badge-junction{border-color:var(--gpr-accent);background-color:var(--gpr-accent-soft);color:var(--gpr-accent)}.gpr-root .gpr-verdicts{display:flex;flex-direction:column;align-items:flex-start;gap:3px}.gpr-root .gpr-table-wrap{max-width:100%;overflow-x:auto}.gpr-root .gpr-table{width:100%;font-size:.92em;font-variant-numeric:tabular-nums}.gpr-root .gpr-table th,.gpr-root .gpr-table td{padding:5px 8px;border-bottom:1px solid var(--gpr-border);vertical-align:top}.gpr-root .gpr-table thead th{position:sticky;top:0;z-index:1;background-color:var(--gpr-surface);color:var(--gpr-muted);font-size:.92em;font-weight:600;white-space:nowrap}.gpr-root .gpr-table tbody th{font-weight:500}.gpr-root .gpr-caption{padding:4px 0 6px;color:var(--gpr-fg);font-weight:600;text-align:left}.gpr-root .gpr-pair-row[data-state=selected]>th,.gpr-root .gpr-pair-row[data-state=selected]>td{background-color:var(--gpr-selected)}.gpr-root .gpr-detail-row>td{background-color:var(--gpr-surface)}.gpr-root .gpr-primer{display:flex;flex-direction:column;gap:2px;min-width:15em}.gpr-root .gpr-primer-line{display:flex;align-items:center;gap:6px}.gpr-root .gpr-rank{min-width:2em;padding:0 6px;border:1px solid var(--gpr-border);border-radius:999px;background-color:var(--gpr-bg);font-weight:600;cursor:pointer}.gpr-root .gpr-rank[aria-pressed=true]{border-color:var(--gpr-accent);background-color:var(--gpr-accent);color:var(--gpr-accent-fg)}.gpr-root .gpr-not-checkable{color:var(--gpr-warn)}.gpr-root .gpr-sort{padding:0;border:0;background:none;color:inherit;font-weight:600;cursor:pointer}.gpr-root .gpr-pair-detail{display:flex;flex-direction:column;gap:10px;padding:6px 0}.gpr-root .gpr-detail-table{width:auto}.gpr-root .gpr-dl{display:grid;grid-template-columns:max-content minmax(0,1fr);gap:3px 12px}.gpr-root .gpr-dl-row{display:contents}.gpr-root .gpr-dl dt{color:var(--gpr-muted);font-weight:500}.gpr-root .gpr-mm{font-family:var(--gpr-mono);font-size:.85em;letter-spacing:.03em;white-space:nowrap}.gpr-root .gpr-mm-base{color:var(--gpr-muted)}.gpr-root .gpr-mm-hit{color:var(--gpr-danger);font-weight:700;text-decoration:underline}.gpr-root .gpr-amplicon{display:flex;flex-direction:column;gap:6px}.gpr-root .gpr-amplicon-head{display:flex;flex-wrap:wrap;align-items:center;gap:8px;font-weight:600}.gpr-root .gpr-amplicon-seq{max-height:24em;padding:8px;overflow:auto;border:1px solid var(--gpr-border);border-radius:var(--gpr-radius);background-color:var(--gpr-bg);font-family:var(--gpr-mono);font-size:12px;line-height:1.6;white-space:pre}.gpr-root .gpr-amplicon-line{white-space:pre}.gpr-root .gpr-amplicon-pos{margin-right:1ch;color:var(--gpr-muted);user-select:none}.gpr-root .gpr-fp-left{background-color:var(--gpr-fp-left-bg);box-shadow:inset 0 -2px 0 var(--gpr-primer-left)}.gpr-root .gpr-fp-right{background-color:var(--gpr-fp-right-bg);box-shadow:inset 0 -2px 0 var(--gpr-primer-right)}.gpr-root .gpr-seq-masked{color:var(--gpr-masked-fg);text-decoration:underline dotted}.gpr-root .gpr-junction-bar,.gpr-root .gpr-junction-sample{display:inline-block;width:0;height:1.2em;margin:0 -1px;border-left:2px solid var(--gpr-target);vertical-align:text-bottom}.gpr-root .gpr-junction-sample{margin:0 4px}.gpr-root .gpr-amplicon-legend{display:flex;flex-wrap:wrap;align-items:center;gap:4px 10px;color:var(--gpr-muted);font-size:.85em}.gpr-root .gpr-map{position:relative;display:flex;flex-direction:column;gap:4px;min-width:0;padding:6px 8px;border:1px solid var(--gpr-border);border-radius:var(--gpr-radius);background-color:var(--gpr-bg)}.gpr-root .gpr-map-toolbar{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:6px}.gpr-root .gpr-map-actions{display:flex;flex-wrap:wrap;gap:4px}.gpr-root .gpr-map-view{color:var(--gpr-muted);font-size:.85em;font-variant-numeric:tabular-nums}.gpr-root .gpr-map-svg{display:block;width:100%;height:auto;overflow:hidden;font-family:var(--gpr-font);user-select:none}.gpr-root .gpr-map-axis,.gpr-root .gpr-map-tick{stroke:var(--gpr-muted);stroke-width:1}.gpr-root .gpr-map-tick-label{fill:var(--gpr-muted);font-size:10px}.gpr-root .gpr-map-intron{stroke:var(--gpr-intron);stroke-width:2}.gpr-root .gpr-map-cds{fill:var(--gpr-cds)}.gpr-root .gpr-map-utr5{fill:var(--gpr-utr5)}.gpr-root .gpr-map-utr3{fill:var(--gpr-utr3)}.gpr-root .gpr-map-nc{fill:var(--gpr-intron)}.gpr-root .gpr-map-exon{fill:var(--gpr-cds)}.gpr-root .gpr-map-exon-alt{fill:var(--gpr-exon-alt)}.gpr-root .gpr-map-cds-band{fill:var(--gpr-fg);opacity:.6}.gpr-root .gpr-map-junction{stroke:var(--gpr-target);stroke-width:1.5}.gpr-root .gpr-map-hatch-line{stroke:var(--gpr-mask);stroke-width:2}.gpr-root .gpr-map-exhatch-line{stroke:var(--gpr-excluded);stroke-width:2}.gpr-root .gpr-map-mask{stroke:var(--gpr-mask);stroke-width:.5}.gpr-root .gpr-map-included{fill:none;stroke:var(--gpr-included);stroke-width:1.5;stroke-dasharray:4 2}.gpr-root .gpr-map-target{fill:var(--gpr-target);opacity:.85}.gpr-root .gpr-map-excluded{stroke:var(--gpr-excluded);stroke-width:.5}.gpr-root .gpr-map-product{stroke:var(--gpr-muted);stroke-width:1}.gpr-root .gpr-map-primer{fill:var(--gpr-primer-left);stroke:var(--gpr-bg);stroke-width:.5}.gpr-root .gpr-map-primer-right{fill:var(--gpr-primer-right)}.gpr-root .gpr-map-notch{stroke:var(--gpr-fg);stroke-width:2}.gpr-root .gpr-map-pair-label{fill:var(--gpr-muted);font-size:10px;font-weight:600}.gpr-root .gpr-map-pair-hit{fill:transparent;stroke:none}.gpr-root .gpr-map-pair[role=button]{cursor:pointer}.gpr-root .gpr-map-pair:hover .gpr-map-pair-hit{fill:var(--gpr-surface-2)}.gpr-root .gpr-map-pair[data-state=selected] .gpr-map-pair-hit{fill:var(--gpr-selected);stroke:var(--gpr-warn);stroke-width:1}.gpr-root .gpr-map-pair[data-state=selected] .gpr-map-pair-label{fill:var(--gpr-fg)}.gpr-root .gpr-map-pair:focus{outline:none}.gpr-root .gpr-map-pair:focus-visible .gpr-map-pair-hit{stroke:var(--gpr-focus);stroke-width:2}.gpr-root .gpr-map-guide{stroke:var(--gpr-focus);stroke-width:1;stroke-dasharray:2 2;pointer-events:none}.gpr-root .gpr-map-legend{display:flex;flex-wrap:wrap;gap:4px 12px;color:var(--gpr-muted);font-size:.82em}.gpr-root .gpr-map-legend-item{display:inline-flex;align-items:center;gap:4px}.gpr-root .gpr-map-swatch{flex:none}.gpr-root .gpr-pangenome{display:flex;flex-direction:column;gap:8px}.gpr-root .gpr-matrix-toolbar{display:flex;flex-wrap:wrap;align-items:center;gap:6px 12px}.gpr-root .gpr-legend{display:flex;flex-wrap:wrap;gap:4px 14px;font-size:.85em}.gpr-root .gpr-legend-item{display:inline-flex;align-items:center;gap:4px}.gpr-root .gpr-status{display:inline-flex;align-items:center;justify-content:center;min-width:1.6em;height:1.4em;padding:0 3px;border:1px solid transparent;border-radius:4px;font-weight:700}.gpr-root .gpr-status-single_perfect{background-color:var(--gpr-st-perfect);color:#fff}.gpr-root .gpr-status-single_mismatch{background-color:var(--gpr-st-mismatch);color:#06243a}.gpr-root .gpr-status-multiple{background-color:var(--gpr-st-multiple);color:#2b1d00}.gpr-root .gpr-status-no_amplicon{background-color:var(--gpr-st-none);color:#fff}.gpr-root .gpr-status-db_unavailable{border-color:var(--gpr-st-db);background:repeating-linear-gradient(45deg,var(--gpr-surface-2) 0 4px,var(--gpr-st-db) 4px 6px);color:var(--gpr-fg)}.gpr-root .gpr-status-error{background-color:var(--gpr-st-error);color:#fff}.gpr-root .gpr-status-pending{border:1px dotted var(--gpr-muted);background-color:transparent;color:var(--gpr-muted)}.gpr-root .gpr-matrix-wrap{max-height:32em;overflow:auto}.gpr-root .gpr-matrix{width:auto;border-collapse:separate;border-spacing:2px}.gpr-root .gpr-matrix th,.gpr-root .gpr-matrix td{border-bottom:0}.gpr-root .gpr-matrix .gpr-cell{position:relative;min-width:3.4em;height:2em;padding:2px 6px;border-radius:4px;text-align:center;vertical-align:middle;white-space:nowrap;cursor:pointer}.gpr-root .gpr-matrix .gpr-cell[data-state=open]{box-shadow:0 0 0 2px var(--gpr-fg)}.gpr-root .gpr-matrix .gpr-cell:focus-visible{outline:3px solid var(--gpr-focus);outline-offset:1px}.gpr-root .gpr-cell-glyph{font-weight:700}.gpr-root .gpr-cell-text{margin-left:3px;font-size:.78em}.gpr-root .gpr-status-single_mismatch .gpr-cell-text{position:absolute;top:0;right:3px;margin:0;font-size:.72em}.gpr-root .gpr-cell-flag{margin-left:2px;font-weight:700;letter-spacing:-.05em}.gpr-root .gpr-matrix .gpr-cell[data-truncated=true]{outline:2px dashed var(--gpr-fg);outline-offset:-3px}.gpr-root .gpr-matrix-genome{position:sticky;left:0;z-index:1;background-color:var(--gpr-bg);white-space:nowrap}.gpr-root .gpr-matrix-corner{left:0;z-index:2}.gpr-root .gpr-matrix-pair{text-align:center}.gpr-root .gpr-cell-detail{display:flex;flex-direction:column;align-items:flex-start;gap:6px;padding:8px 12px;border:1px solid var(--gpr-border);border-radius:var(--gpr-radius);background-color:var(--gpr-surface)}.gpr-root .gpr-specificity{display:flex;flex-direction:column;gap:6px}.gpr-root .gpr-result-pair{display:flex;flex-direction:column;gap:6px;padding:8px 0;border-bottom:1px solid var(--gpr-border)}.gpr-root .gpr-result-pair .gpr-h4{display:flex;flex-wrap:wrap;align-items:center;gap:6px}.gpr-root .gpr-isoforms{display:flex;flex-direction:column;gap:1px}.gpr-root .gpr-check-panel,.gpr-root .gpr-explain,.gpr-root .gpr-export{display:flex;flex-direction:column;gap:8px;padding:8px 12px;border:1px solid var(--gpr-border);border-radius:var(--gpr-radius)}.gpr-root .gpr-explain[data-state=open]{background-color:var(--gpr-surface)}.gpr-root .gpr-estimate{font-size:.92em}.gpr-root .gpr-estimate[data-state=over]{color:var(--gpr-danger);font-weight:600}.gpr-root .gpr-progress-block,.gpr-root .gpr-status-block{display:flex;flex-direction:column;gap:4px}.gpr-root .gpr-progress{position:relative;height:10px;overflow:hidden;border:1px solid var(--gpr-border);border-radius:999px;background-color:var(--gpr-surface-2)}.gpr-root .gpr-progress[data-state=queued]{background:repeating-linear-gradient(90deg,var(--gpr-surface-2) 0 8px,var(--gpr-accent-soft) 8px 16px);background-size:32px 100%;animation:gpr-queued 1.2s linear infinite}@keyframes gpr-queued{0%{background-position:0 0}to{background-position:32px 0}}.gpr-root .gpr-progress-bar{height:100%;background-color:var(--gpr-accent);transition:width .3s ease}.gpr-root .gpr-genome-picker{background-color:var(--gpr-bg)}.gpr-root .gpr-picker-toolbar{display:flex;flex-wrap:wrap;align-items:center;gap:6px}.gpr-root .gpr-picker-filter{flex:1 1 10em;width:auto}.gpr-root .gpr-genome-list{max-height:14em;padding:4px 8px;overflow-y:auto;border:1px solid var(--gpr-border);border-radius:var(--gpr-radius);columns:16em auto;column-gap:16px}.gpr-root .gpr-genome-item{display:flex;flex-wrap:wrap;align-items:baseline;gap:2px 6px;padding:1px 0;break-inside:avoid}.gpr-root .gpr-genome-item[data-state=unavailable]{color:var(--gpr-muted)}.gpr-root .gpr-explain-body{display:flex;flex-direction:column;gap:8px}.gpr-root .gpr-explain-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(14em,1fr));gap:8px}.gpr-root .gpr-explain-side{padding:6px 8px;border:1px solid var(--gpr-border);border-radius:var(--gpr-radius);background-color:var(--gpr-bg)}.gpr-root .gpr-explain-side[data-state=blocked]{border-color:var(--gpr-danger)}.gpr-root .gpr-explain-reasons{display:flex;flex-direction:column;gap:3px;padding-left:1.1em;list-style:disc;font-size:.92em}.gpr-root .gpr-explain-label{font-weight:600}.gpr-root .gpr-explain-count{color:var(--gpr-muted);font-variant-numeric:tabular-nums}.gpr-root .gpr-explain-suggestion{display:block;color:var(--gpr-accent)}.gpr-root .gpr-export-list{display:flex;flex-direction:column;gap:4px}.gpr-root .gpr-export-item{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:8px;padding:3px 0;border-bottom:1px solid var(--gpr-border)}.gpr-root .gpr-export-actions{display:flex;gap:4px}@media(prefers-reduced-motion:reduce){.gpr-root .gpr-btn,.gpr-root .gpr-progress-bar,.gpr-root .gpr-disclosure:before,.gpr-root .gpr-splitter:before{transition:none}.gpr-root .gpr-progress[data-state=queued]{animation:none}}.gpr-root .gpr-genotype-chip{gap:4px;white-space:nowrap}.gpr-root .gpr-genotype-chip-compact{padding:0;border:0;background:none}.gpr-root .gpr-genotype-chip .gpr-chip-glyph{font-size:1.05em;line-height:1}.gpr-root .gpr-genotype-legend{display:flex;flex-wrap:wrap;gap:16px;margin:6px 0}.gpr-root .gpr-genotype-legend-group{min-width:180px}.gpr-root .gpr-genotype-legend-title{margin:0 0 2px;font-weight:600;font-size:.85em;color:var(--gpr-muted)}.gpr-root .gpr-genotype-legend-list{display:flex;flex-wrap:wrap;gap:2px 12px}.gpr-root .gpr-genotype-legend-item{display:inline-flex;align-items:center;gap:4px;font-size:.85em}.gpr-root .gpr-genotype-legend-glyph{font-size:1.05em;line-height:1}.gpr-root .gpr-genotype-legend-label{color:var(--gpr-muted)}.gpr-root .gpr-agreement{font-weight:600}.gpr-root .gpr-agreement-ok{color:#009e73}.gpr-root .gpr-agreement-bad{color:#d55e00}.gpr-root .gpr-agreement-muted{color:var(--gpr-muted)}.gpr-root .gpr-sets-table .gpr-col-set{white-space:nowrap;vertical-align:top}.gpr-root .gpr-set-primer{min-width:190px}.gpr-root .gpr-seq-3p{font-weight:700;text-decoration:underline;text-underline-offset:2px}.gpr-root .gpr-allele-badge,.gpr-root .gpr-dye-badge{font-weight:600}.gpr-root .gpr-col-quality{white-space:nowrap}.gpr-root .gpr-issue-badge{display:inline-block;margin-top:2px}.gpr-root .gpr-agreement-line{display:block;margin-bottom:2px}.gpr-root .gpr-control-warn{color:#d55e00}.gpr-root .gpr-set-detail{display:flex;flex-direction:column;gap:10px;padding:6px 0}.gpr-root .gpr-set-stats,.gpr-root .gpr-set-issues{margin:0}.gpr-root .gpr-set-issue{padding:2px 0}.gpr-root .gpr-set-issue-severity{font-weight:600}.gpr-root .gpr-set-issue[data-severity=high] .gpr-set-issue-severity{color:#d55e00}.gpr-root .gpr-set-issue[data-severity=warn] .gpr-set-issue-severity{color:#e69f00}.gpr-root .gpr-set-issue[data-severity=info] .gpr-set-issue-severity{color:var(--gpr-muted)}.gpr-root .gpr-neighbour-table{font-size:.9em}.gpr-root .gpr-assay-options{display:flex;flex-direction:column;gap:8px}.gpr-root .gpr-assay-fieldset{margin:0}.gpr-root .gpr-assay-advanced{margin-top:2px}.gpr-root .gpr-assay-limits{margin:8px 0 0;font-size:.9em;color:var(--gpr-muted)}.gpr-root .gpr-allele-matrix{display:flex;flex-direction:column;gap:6px}.gpr-root .gpr-allele-grid .gpr-allele-cell,.gpr-root .gpr-allele-grid .gpr-prediction-cell{white-space:nowrap;text-align:center}.gpr-root .gpr-prediction-cell[data-disagrees=true]{outline:2px solid #D55E00;outline-offset:-2px}.gpr-root .gpr-allele-grid tr[data-reference=true] .gpr-matrix-genome{font-weight:600}.gpr-root .gpr-copies{font-size:.75em;margin-left:1px}.gpr-root .gpr-allele-detail{border:1px solid var(--gpr-border);border-radius:4px;padding:8px}.gpr-root .gpr-manual-variant{display:flex;flex-direction:column;gap:6px}.gpr-root .gpr-manual-issues{margin:0}.gpr-root .gpr-variant-picker{display:flex;flex-direction:column;gap:8px}.gpr-root .gpr-variant-source{font-weight:600}.gpr-root .gpr-variant-window,.gpr-root .gpr-variant-filters{margin:0}.gpr-root .gpr-variant-kinds{display:flex;flex-wrap:wrap;gap:2px 12px}.gpr-root .gpr-variant-lookup{display:flex;flex-direction:column;gap:4px}.gpr-root .gpr-variant-table{font-size:.95em}.gpr-root .gpr-variant-row[data-designable=false]{color:var(--gpr-muted)}.gpr-root .gpr-variant-row[data-state=selected]>th,.gpr-root .gpr-variant-row[data-state=selected]>td{background-color:var(--gpr-selected)}.gpr-root .gpr-variant-ids{min-width:140px}.gpr-root .gpr-variant-record{margin-right:6px;white-space:nowrap}.gpr-root .gpr-variant-manual{display:flex;flex-direction:column;gap:4px}.gpr-root .gpr-orientation-explain{display:grid;gap:8px;grid-template-columns:1fr}@container gpr (min-width: 760px){.gpr-root .gpr-orientation-explain{grid-template-columns:1fr 1fr}}.gpr-root .gpr-orientation-card{border:1px solid var(--gpr-border);border-radius:var(--gpr-radius);padding:8px}.gpr-root .gpr-orientation-card[data-status=blocked]{border-color:var(--gpr-danger)}.gpr-root .gpr-orientation-head{display:flex;align-items:center;justify-content:space-between;gap:8px}.gpr-root .gpr-orientation-why{margin:2px 0}.gpr-root .gpr-orientation-blockers,.gpr-root .gpr-orientation-rejected{margin:4px 0;font-size:.9em}.gpr-root .gpr-orientation-attempt{border-top:1px solid var(--gpr-border);margin-top:6px;padding-top:6px}.gpr-root .gpr-orientation-attempt-head{margin:0 0 2px}.gpr-root .gpr-orientation-changes,.gpr-root .gpr-orientation-reason{color:var(--gpr-muted)}.gpr-root .gpr-order-sheet{display:flex;flex-direction:column;gap:8px}.gpr-root .gpr-order-note{margin:0}.gpr-root .gpr-submission .gpr-seq{word-break:break-all}.gpr-root .gpr-order-table{font-size:.95em}.gpr-root .gpr-order-seq{min-width:200px}.gpr-root .gpr-order-notes{color:var(--gpr-muted);max-width:260px}.gpr-root .gpr-order-row[data-role=common]{border-top:1px solid var(--gpr-border)}.gpr-root .gpr-genotyping{display:flex;flex-direction:column;gap:10px}.gpr-root .gpr-genotyping-actions{display:flex;align-items:center;gap:8px;flex-wrap:wrap}.gpr-root .gpr-genotyping-check{display:flex;flex-direction:column;gap:6px;border:1px solid var(--gpr-border);border-radius:var(--gpr-radius);padding:8px}.gpr-root .gpr-genotyping-cost{margin:0}.gpr-root .gpr-layout.gpr-layout-genotyping{grid-template-columns:minmax(0,1fr);column-gap:var(--gpr-gap)}.gpr-root .gpr-variant-toolbar{display:flex;flex-wrap:wrap;align-items:flex-end;gap:6px 12px}.gpr-root .gpr-variant-search{min-width:200px}.gpr-root .gpr-variant-scroll{max-height:26em;overflow:auto}.gpr-root .gpr-sort-glyph{font-size:.85em}.gpr-root .gpr-variant-facet{min-width:170px}.gpr-root .gpr-browser{display:flex;flex-direction:column;gap:4px;border:1px solid var(--gpr-border);border-radius:var(--gpr-radius);padding:8px}.gpr-root .gpr-browser-toolbar{display:flex;flex-wrap:wrap;align-items:center;gap:6px 12px}.gpr-root .gpr-browser-loc{font-weight:600}.gpr-root .gpr-browser-svg{display:block;touch-action:pan-y;cursor:grab;user-select:none}.gpr-root .gpr-browser-svg:active{cursor:grabbing}.gpr-root .gpr-browser-gene-label{font-size:10px;fill:var(--gpr-muted)}.gpr-root .gpr-browser-variant{cursor:pointer}.gpr-root .gpr-browser-variant[data-designable=false]{opacity:.45}.gpr-root .gpr-browser-variant[data-state=selected] circle{stroke:var(--gpr-fg);stroke-width:2}.gpr-root .gpr-browser-legend{display:flex;flex-wrap:wrap;gap:2px 12px;font-size:.85em;color:var(--gpr-muted)}.gpr-root .gpr-browser-key{display:inline-flex;align-items:center;gap:4px}.gpr-root .gpr-browser-swatch{display:inline-block;width:10px;height:10px;border-radius:2px}.gpr-root .gpr-browser-variant[data-designable=false]{cursor:default}.gpr-root .gpr-caps-more{font-weight:400;opacity:.75}.gpr-root .gpr-caps-note{margin:4px 0 0;max-width:68ch}.gpr-root .gpr-browser-caps{stroke:var(--gpr-fg);stroke-width:1.25;stroke-dasharray:2.5 2;opacity:.65}.gpr-root .gpr-browser-caps-key{width:14px;height:14px;vertical-align:-2px;fill:var(--gpr-muted)}.gpr-root .gpr-digest{margin-top:12px;display:grid;gap:8px}.gpr-root .gpr-digest-table td,.gpr-root .gpr-digest-table th{white-space:nowrap}.gpr-root .gpr-digest-table .gpr-digest-positions{white-space:normal;max-width:28ch;font-variant-numeric:tabular-nums}.gpr-root .gpr-seq-site{background-color:var(--gpr-accent-soft);box-shadow:inset 0 -2px 0 var(--gpr-accent)}.gpr-root .gpr-digest-name{display:inline-flex;align-items:center;gap:6px;cursor:pointer}.gpr-root .gpr-digest-swatch,.gpr-root .gpr-map-enzyme-swatch{display:inline-block;width:10px;height:10px;border:1px solid transparent;border-radius:2px;flex:none;box-sizing:border-box}.gpr-root .gpr-digest-swatch[data-off=true],.gpr-root .gpr-map-enzyme-swatch[data-off=true]{border-color:var(--gpr-border);background-color:transparent}.gpr-root .gpr-cut-bar,.gpr-root .gpr-cut-sample{display:inline-block;width:0;height:1.2em;margin:0 -1px;border-left:2px dashed var(--gpr-accent);vertical-align:text-bottom}.gpr-root .gpr-map-site{cursor:default;stroke:transparent;stroke-width:1}.gpr-root .gpr-map-site[data-state=hover]{stroke:var(--gpr-fg)}.gpr-root .gpr-map-site-hit{fill:transparent;pointer-events:all}.gpr-root .gpr-map-tip{position:absolute;z-index:5;width:250px;max-width:calc(100% - 8px);padding:6px 8px;border:1px solid var(--gpr-border);border-radius:6px;background-color:var(--gpr-surface);color:var(--gpr-fg);box-shadow:0 4px 14px #0000002e;font-size:.85em;pointer-events:none}.gpr-root .gpr-map-tip-head{display:flex;align-items:center;gap:6px;margin-bottom:4px}.gpr-root .gpr-map-tip-rows{display:grid;grid-template-columns:auto 1fr;gap:2px 10px;margin:0}.gpr-root .gpr-map-tip-rows dt{color:var(--gpr-muted)}.gpr-root .gpr-map-tip-rows dd{margin:0;overflow-wrap:anywhere}.gpr-root .gpr-map-enzyme-list li[data-empty=true] .gpr-label{color:var(--gpr-muted)}.gpr-root .gpr-map-enzyme-list li[data-empty=true] .gpr-map-enzyme-swatch{opacity:.35}.gpr-root .gpr-map-enzyme-count{font-variant-numeric:tabular-nums;color:var(--gpr-muted)}.gpr-root .gpr-map-enzymes{margin-top:6px;font-size:.9em}.gpr-root .gpr-map-enzymes>summary{cursor:pointer;padding:2px 0}.gpr-root .gpr-map-enzyme-actions{display:flex;flex-wrap:wrap;align-items:center;gap:6px;padding:6px 0 4px}.gpr-root .gpr-map-enzyme-list{list-style:none;margin:0;padding:0;display:grid;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:2px 12px;max-height:220px;overflow-y:auto}.gpr-root .gpr-map-enzyme-list .gpr-check-row{display:flex;align-items:center;gap:6px;margin:0}.gpr-root .gpr-map-enzyme-list .gpr-label{margin:0;white-space:nowrap}.gpr-root .gpr-freq{white-space:nowrap;font-variant-numeric:tabular-nums}.gpr-root .gpr-freq-value{font-weight:600}.gpr-root [hidden]{display:none}', fs = "gramene-primers-styles", Zo = Qo;
function bs(e) {
    return typeof e.host < "u" && !e.createElement;
}
function el(e) {
    const t = e ?? (typeof document < "u" ? document : null);
    if (!t || t.getElementById(fs)) return !1;
    const r = bs(t) ? t.ownerDocument : t;
    if (!r) return !1;
    const n = r.createElement("style");
    if (n.id = fs, n.setAttribute("data-gramene-primers", ""), n.textContent = Zo, bs(t)) t.insertBefore(n, t.firstChild);
    else {
        const a = t.head ?? t.documentElement;
        a.insertBefore(n, a.firstChild);
    }
    return !0;
}
const dr = (0, _react.createContext)(!1);
function La(e) {
    (0, _react.useInsertionEffect)(()=>{
        e && el();
    }, [
        e
    ]);
}
function qa(e) {
    return `gpr-theme-${e === "light" || e === "dark" ? e : "auto"}`;
}
function bt(e) {
    const t = (0, _react.useContext)(dr);
    return La(!t && e.injectStyles !== !1), t ? /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: e.children
    }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)(dr.Provider, {
        value: !0,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
            className: Pe("gpr-root", qa(e.theme), e.className),
            style: e.style,
            children: e.children
        })
    });
}
function tl({ children: e }) {
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(dr.Provider, {
        value: !0,
        children: e
    });
}
function Dn(e, t) {
    return t === "transcript" ? e.has_cdna_blastdb ? {
        ok: !0
    } : {
        ok: !1,
        reason: "no cDNA BLAST database"
    } : e.has_blastdb ? {
        ok: !0
    } : {
        ok: !1,
        reason: "no BLAST database"
    };
}
function Ga(e) {
    const t = De("gpr-genomes"), r = Array.isArray(e.genomes) ? e.genomes : e.genomes.genomes ?? [], n = e.systemName ?? (Array.isArray(e.genomes) ? null : e.genomes.system_name), a = r.filter((h)=>!h.is_query && h.system_name !== n), i = a.filter((h)=>Dn(h, e.mode).ok).map((h)=>h.system_name), l = new Set(e.selected ?? i), o = i.filter((h)=>l.has(h)).length, [d, p] = (0, _react.useState)(""), g = d.trim().toLowerCase(), m = g ? a.filter((h)=>h.system_name.toLowerCase().includes(g) || (h.display_name ?? "").toLowerCase().includes(g)) : a, f = m.filter((h)=>Dn(h, e.mode).ok).map((h)=>h.system_name), u = (h)=>{
        const y = i.filter((_)=>h.has(_)).sort();
        e.onChange(y.length === i.length ? void 0 : y);
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(bt, {
        theme: e.theme,
        injectStyles: e.injectStyles,
        className: e.className,
        style: e.style,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("fieldset", {
            className: "gpr-fieldset gpr-genome-picker",
            disabled: e.disabled,
            children: [
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("legend", {
                    className: "gpr-legend",
                    children: e.label ?? "Genomes to search"
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                    className: "gpr-picker-toolbar",
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("label", {
                            className: "gpr-visually-hidden",
                            htmlFor: `${t}-filter`,
                            children: "Filter genomes"
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                            id: `${t}-filter`,
                            className: "gpr-input gpr-picker-filter",
                            type: "search",
                            placeholder: "Filter genomes",
                            autoComplete: "off",
                            value: d,
                            onChange: (h)=>p(h.target.value)
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "gpr-btn gpr-btn-small",
                            "aria-label": g ? "Select all shown genomes" : "Select all genomes",
                            onClick: ()=>u(/* @__PURE__ */ new Set([
                                    ...l,
                                    ...f
                                ])),
                            children: "All"
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "gpr-btn gpr-btn-small",
                            "aria-label": g ? "Deselect all shown genomes" : "Deselect all genomes",
                            onClick: ()=>{
                                const h = new Set(l);
                                for (const y of f)h.delete(y);
                                u(h);
                            },
                            children: "None"
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                            className: "gpr-sub gpr-picker-count",
                            children: [
                                o,
                                " of ",
                                i.length,
                                " selected"
                            ]
                        })
                    ]
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("ul", {
                    className: "gpr-genome-list",
                    children: m.map((h)=>{
                        const y = Dn(h, e.mode), _ = `${t}-${h.system_name}`;
                        return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("li", {
                            className: "gpr-genome-item",
                            "data-state": y.ok ? void 0 : "unavailable",
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                                    id: _,
                                    type: "checkbox",
                                    className: "gpr-checkbox",
                                    checked: y.ok && l.has(h.system_name),
                                    disabled: !y.ok,
                                    "aria-describedby": y.ok ? void 0 : `${_}-why`,
                                    onChange: (k)=>{
                                        const b = new Set(l);
                                        k.target.checked ? b.add(h.system_name) : b.delete(h.system_name), u(b);
                                    }
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("label", {
                                    className: "gpr-label gpr-label-inline",
                                    htmlFor: _,
                                    children: h.display_name || h.system_name
                                }),
                                " ",
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                    className: "gpr-sub",
                                    children: h.system_name
                                }),
                                y.ok ? null : /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                    id: `${_}-why`,
                                    className: "gpr-sub gpr-unavailable",
                                    children: [
                                        " ",
                                        "(",
                                        y.reason,
                                        ")"
                                    ]
                                })
                            ]
                        }, h.system_name);
                    })
                }),
                m.length === 0 ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                    className: "gpr-hint",
                    children: "No genomes match the filter."
                }) : null
            ]
        })
    });
}
const ys = {
    status: "idle",
    job: null,
    request: null,
    error: null,
    startedHere: !1,
    created: null
};
function Or(e) {
    return e === "submitting" || e === "restoring" || e === "watching";
}
function Da(e, t) {
    const [r, n] = (0, _react.useState)(ys), a = (0, _react.useRef)(null), i = (0, _react.useRef)(t);
    Gt(()=>{
        i.current = t;
    });
    const l = (0, _react.useCallback)(()=>{
        a.current?.abort(), a.current = null;
    }, []), o = (0, _react.useCallback)((y, _)=>{
        if (!(y.signal.aborted || Ue(_))) {
            if (a.current === y && (a.current = null), Me(_) && (_.code === "UNKNOWN_JOB" || _.status === 404)) {
                n((k)=>({
                        ...k,
                        status: "expired",
                        error: _
                    }));
                return;
            }
            n((k)=>({
                    ...k,
                    status: "error",
                    error: _
                })), Me(_) && i.current.onError?.(_);
        }
    }, []), d = (0, _react.useCallback)((y, _)=>{
        y.signal.aborted || (a.current === y && (a.current = null), n((k)=>({
                ...k,
                job: _,
                status: _.status === "done" ? "done" : "failed"
            })));
    }, []), p = (0, _react.useCallback)(async (y, _, k)=>{
        let b = _.job_id;
        const C = await e.pollCheck(_.job_id, {
            ...i.current.poll ?? {},
            signal: y.signal,
            initialJob: _,
            resubmit: k ?? void 0,
            onUpdate: (N)=>{
                y.signal.aborted || (N.job_id && N.job_id !== b && (b = N.job_id, i.current.onJobId?.(N.job_id, k)), n((w)=>({
                        ...w,
                        job: N
                    })), i.current.onUpdate?.(N));
            }
        });
        d(y, C);
    }, [
        e,
        d
    ]), g = (0, _react.useCallback)((y)=>{
        l();
        const _ = new AbortController();
        return a.current = _, n(y), _;
    }, [
        l
    ]), m = (0, _react.useCallback)(async (y)=>{
        const _ = g({
            status: "submitting",
            job: null,
            request: y,
            error: null,
            startedHere: !0,
            created: null
        });
        try {
            const k = await e.submitCheck(y, {
                signal: _.signal
            });
            if (_.signal.aborted) return;
            if (i.current.onJobId?.(k.job_id, y), Ye(k)) {
                n((C)=>({
                        ...C,
                        created: k.created
                    }));
                const b = await e.getCheck(k.job_id, {
                    signal: _.signal
                });
                if (_.signal.aborted) return;
                i.current.onUpdate?.(b), n((C)=>({
                        ...C,
                        job: b,
                        status: Ye(b) ? C.status : "watching"
                    })), Ye(b) ? d(_, b) : await p(_, b, y);
                return;
            }
            i.current.onUpdate?.(k), n((b)=>({
                    ...b,
                    job: k,
                    created: k.created,
                    status: "watching"
                })), await p(_, k, y);
        } catch (k) {
            o(_, k);
        }
    }, [
        g,
        e,
        o,
        d,
        p
    ]), f = (0, _react.useCallback)(async (y, _ = null, k = !1)=>{
        const b = g({
            status: "restoring",
            job: null,
            request: _,
            error: null,
            startedHere: k,
            created: null
        });
        try {
            const C = await e.getCheck(y, {
                signal: b.signal
            });
            if (b.signal.aborted) return;
            if (i.current.onUpdate?.(C), n((N)=>({
                    ...N,
                    job: C,
                    status: Ye(C) ? N.status : "watching"
                })), Ye(C)) {
                d(b, C);
                return;
            }
            await p(b, C, k ? _ : null);
        } catch (C) {
            o(b, C);
        }
    }, [
        g,
        e,
        o,
        d,
        p
    ]), u = (0, _react.useCallback)(()=>{
        l(), n((y)=>Or(y.status) ? {
                ...y,
                status: "detached"
            } : y);
    }, [
        l
    ]), h = (0, _react.useCallback)(()=>{
        l(), n(ys);
    }, [
        l
    ]);
    return (0, _react.useEffect)(()=>()=>a.current?.abort(), []), {
        state: r,
        submit: m,
        restore: f,
        detach: u,
        reset: h,
        stop: l
    };
}
const nl = Object.freeze({
    NO_PAIRS: "Primer3 found no acceptable primer pairs.",
    IUPAC_CONVERTED: "IUPAC ambiguity codes in the sequence were converted to N.",
    MULTIPLE_RECORDS: "Several FASTA records were joined into one template; primer pairs may span the joins.",
    SINGLE_EXON_TRANSCRIPT: "The transcript has a single exon, so primers were designed without the junction constraint.",
    JUNCTIONS_TRUNCATED: "Only the first 200 junctions (or those inside the included region) were used.",
    BLAST_DEPTH_MASK: "Repeats were estimated with a BLAST copy-number heuristic; multi-copy gene families are masked too.",
    MOSTLY_REPEAT: "More than 80% of the template is masked as repeat.",
    REPEAT_MASK_FAILED: "Repeat masking failed; primers were designed without a mask.",
    NO_REPEAT_MASK: "No repeat mask is available for this genome.",
    ASSEMBLY_MISMATCH: "The assembly files do not fully match the genome annotation.",
    AMBIGUOUS_ASSEMBLY: "Several assemblies match this genome; the newest was used.",
    PRIMER3_WARNING: "Primer3 reported a warning.",
    MAX_PRODUCT_SIZE_RAISED: "The maximum product size was raised to cover the expected products.",
    EXPECTED_IGNORED: "Expected product locations are ignored in transcript mode.",
    PANGENOME_TRANSCRIPT_MODELS_ONLY: "Annotated transcripts only: the pan-genome check searched annotated transcript models.",
    ANNOTATION_UNAVAILABLE: "Gene annotation was unavailable; amplicons are not labelled with genes.",
    NO_FASTA_FOR_REALIGN: "Some hits could not be re-aligned; their mismatch counts are lower bounds.",
    TRANSCRIPT_GENE_UNMAPPED: "Some transcripts could not be mapped to genes.",
    // ---- genotyping: variant lookups ----------------------------------------
    DUPLICATE_VARIANT_IDS: "Several Ensembl ids describe this variant; they were merged into one entry.",
    VARIATION_RECORDS_SKIPPED: "Some variant records could not be read and were left out.",
    REF_MISMATCHES: "Some variant records disagree with our reference sequence and were left out.",
    VARIANTS_TRUNCATED: "Not all variants in this window are listed; narrow the window to see the rest.",
    NO_VARIATION_DATA: "Known variants were not screened: this genome has no variant data, or lookups are switched off on this server.",
    NEIGHBOURS_UNAVAILABLE: "Known variants could not be screened during this design, so neighbouring variants were not checked.",
    // ---- genotyping: design --------------------------------------------------
    EMS_TARGET: "This is an EMS mutation, private to one mutant line; natural variants nearby warn instead of blocking.",
    MULTIALLELIC_SITE: "Other alleles exist at this position; genomes carrying them mismatch both allele-specific primers.",
    SHIFTABLE_INDEL: "This indel can slide along the sequence, so the wrong-allele primer may still amplify.",
    ORIENTATION_BLOCKED: "A known variant sits in the last few bases of that orientation\u2019s allele-specific primer.",
    DENSE_NEIGHBOURS: "Several known variants lie close together here.",
    SUBMISSION_NEIGHBOURS_OMITTED: "Some neighbouring variants were left as reference bases in the submission sequence.",
    VARIANT_IN_REPEAT: "The repeat mask reached the allele-specific window.",
    ORIENTATION_SKIPPED: "That orientation was skipped: too close to the end of the sequence, or an N in the allele-specific window.",
    ORIENTATION_NO_SETS: "No primer set in that orientation cleared the minimum requirements.",
    RELAXED_CONSTRAINTS: "These sets needed relaxed Primer3 constraints.",
    NO_SETS: "No primer set was found in either orientation; the orientation cards explain why.",
    DESIGN_BUDGET_EXHAUSTED: "The design stopped scoring further candidates; the sets shown are still valid.",
    // ---- genotyping: set issues ---------------------------------------------
    ALT_PRIMER_SUBOPTIMAL: "A derived primer Primer3 would not have picked on its own, though it clears the hard limits.",
    AS_TM_IMBALANCE: "The two allele-specific primers differ in melting temperature.",
    COMMON_TM_OUT_OF_RANGE: "The common primer\u2019s melting temperature sits outside the preferred window.",
    TAILED_STRUCTURE: "The tailed oligo can fold or pair with itself near the annealing temperature.",
    MISMATCH_NOT_APPLICABLE: "No deliberate mismatch was added: the base is the same in both allele-specific primers.",
    MISMATCH_STRUCTURE: "The deliberate-mismatch primer can fold or pair with itself.",
    NEIGHBOUR_IN_PRIMER: "Known variants lie inside a primer, away from its 3\u2032 end.",
    NEIGHBOUR_AT_3P: "A known variant lies in the last few bases of a primer, where it affects discrimination.",
    WEAK_DISCRIMINATION: "This primer is predicted to amplify the other allele as well.",
    SHIFT_TRACT_DISCRIMINATION: "The discriminating base lies inside the indel\u2019s shift tract.",
    WEAK_TERMINAL_CLASS: "Both 3\u2032 mismatches are of a weakly discriminating type.",
    // ---- genotyping: check results ------------------------------------------
    REFERENCE_CONTROL_FAILED: "The reference control did not give the expected allele, so that set\u2019s other predictions are unreliable.",
    WEAK_OFF_TARGETS: "Some off-target products were found with several mismatches; they are listed but do not change the allele predictions.",
    GENOTYPE_FALLBACK_FAILED: "The fallback search failed for some genomes, which are reported as missing.",
    GENOTYPE_FALLBACK_BUDGET: "The fallback search ran out of budget for some genomes, which are reported as missing.",
    GENOTYPE_FAILED: "Allele calling failed for some genomes, which are reported as unavailable."
});
function cn({ warnings: e, title: t, className: r }) {
    const n = (e ?? []).map((a)=>typeof a == "string" ? {
            code: a
        } : a).filter((a)=>!!a && typeof a.code == "string" && a.code.length > 0);
    return n.length ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: Pe("gpr-warnings", r),
        children: [
            t ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                className: "gpr-warnings-title",
                children: t
            }) : null,
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("ul", {
                className: "gpr-warning-list",
                children: n.map((a, i)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("li", {
                        className: "gpr-warning",
                        "data-code": a.code,
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                className: "gpr-warning-glyph",
                                "aria-hidden": "true",
                                children: "\u26A0"
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                className: "gpr-warning-text",
                                children: a.message || nl[a.code] || a.code
                            }),
                            " ",
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("code", {
                                className: "gpr-code gpr-warning-code",
                                children: a.code
                            })
                        ]
                    }, `${a.code}-${i}`))
            })
        ]
    }) : null;
}
const rl = [
    {
        key: "max_product_size",
        label: "Max product size (bp)"
    },
    {
        key: "ignore_mismatches",
        label: "Ignore sites with at least this many mismatches"
    },
    {
        key: "max_amplifying_mismatches",
        label: "Max mismatches per primer for a product"
    },
    {
        key: "min_total_mismatches",
        label: "Unlikely product: at least this many mismatches"
    },
    {
        key: "min_3p_mismatches",
        label: "\u2026of which in the 3\u2032 window"
    },
    {
        key: "three_prime_window",
        label: "3\u2032 window (nt)"
    },
    {
        key: "repeat_site_threshold",
        label: "Repetitive primer: more near-perfect sites than"
    }
];
function sl(e) {
    if (!e) return "";
    if (e.status === "queued") {
        const i = e.queue_position;
        return typeof i == "number" ? `Queued \xb7 ${i} job${i === 1 ? "" : "s"} ahead` : "Queued";
    }
    const t = e.progress, r = t?.done ?? 0, n = Math.max(t?.total ?? 0, r), a = t?.running?.length ? ` \xb7 running: ${t.running.join(", ")}` : "";
    return `${v(r)} of ${v(n)} \xb7 ${t?.stage ?? e.status}${a}`;
}
function al({ run: e, onDetach: t, onResume: r, onRerun: n, onRetry: a }) {
    const i = e.job;
    switch(e.status){
        case "idle":
            return null;
        case "submitting":
            return /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                className: "gpr-status-line",
                children: "Submitting the check\u2026"
            });
        case "restoring":
            return /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                className: "gpr-status-line",
                children: "Loading the saved check\u2026"
            });
        case "watching":
            {
                const l = i?.progress, o = l?.done ?? 0, d = Math.max(l?.total ?? 0, o), p = i?.status === "queued", g = sl(i);
                return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                    className: "gpr-progress-block",
                    "data-status": i?.status,
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                            className: "gpr-progress",
                            role: "progressbar",
                            "aria-label": "Check progress",
                            "aria-valuemin": 0,
                            "aria-valuemax": d || 1,
                            "aria-valuenow": p ? 0 : o,
                            "aria-valuetext": g,
                            "data-state": p ? "queued" : "running",
                            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                                className: "gpr-progress-bar",
                                style: {
                                    width: `${d ? Math.round(o / d * 100) : 0}%`
                                }
                            })
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                            className: "gpr-status-line",
                            children: [
                                g,
                                i?.partial ? " \xb7 partial results shown" : ""
                            ]
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                            className: "gpr-button-row",
                            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: "gpr-btn gpr-btn-small",
                                onClick: t,
                                children: "Stop watching"
                            })
                        })
                    ]
                });
            }
        case "detached":
            return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                className: "gpr-status-block",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                        className: "gpr-status-line",
                        children: "Stopped watching. The check keeps running on the server."
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                        className: "gpr-button-row",
                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "gpr-btn gpr-btn-small",
                            onClick: r,
                            children: "Resume watching"
                        })
                    })
                ]
            });
        case "done":
            return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-status-line gpr-status-done",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                        "aria-hidden": "true",
                        children: "\u2713 "
                    }),
                    "Check finished",
                    i?.attempts && i.attempts > 1 ? ` (after ${i.attempts} attempts)` : "",
                    "."
                ]
            });
        case "failed":
            return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                className: "gpr-banner gpr-banner-error",
                role: "alert",
                "data-code": i?.error?.code ?? "JOB_ERROR",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                        className: "gpr-banner-title",
                        children: [
                            "The check failed",
                            i?.error?.message ? `: ${i.error.message}` : "."
                        ]
                    }),
                    i?.error?.code ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                        className: "gpr-banner-text",
                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("code", {
                            className: "gpr-code",
                            children: i.error.code
                        })
                    }) : null,
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                        className: "gpr-banner-actions",
                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "gpr-btn",
                            onClick: n,
                            children: "Re-run check"
                        })
                    })
                ]
            });
        case "expired":
            return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                className: "gpr-banner gpr-banner-warn",
                role: "status",
                "data-code": "UNKNOWN_JOB",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                        className: "gpr-banner-title",
                        children: "Results expired \u2014 Re-run check"
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                        className: "gpr-banner-text",
                        children: "Check results are kept on the server for a limited time."
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                        className: "gpr-banner-actions",
                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "gpr-btn gpr-btn-primary",
                            onClick: n,
                            children: "Re-run check"
                        })
                    })
                ]
            });
        case "error":
            return /* @__PURE__ */ (0, _jsxRuntime.jsx)(rn, {
                error: e.error,
                context: "check",
                onRetry: a
            });
        default:
            return null;
    }
}
function il(e) {
    const t = e.pairs.filter((b)=>e.checkedRanks.includes(b.rank)), r = e.pangenomeFeature && (e.genomes?.counts?.total ?? 0) > 1, n = r && e.checkState.checks.includes("pangenome"), a = Ki(e.checkState.params), i = Or(e.run.status);
    let l = null, o = null;
    if (t.length) try {
        l = ma({
            mode: e.mode,
            systemName: e.systemName,
            geneId: e.geneId,
            transcriptId: e.transcriptId,
            pairs: t,
            checks: n ? [
                "specificity",
                "pangenome"
            ] : [
                "specificity"
            ],
            genomes: n ? e.checkState.genomes ?? null : null,
            allGenomes: e.genomes,
            params: e.checkState.params
        });
    } catch (b) {
        if (b instanceof be) o = b;
        else throw b;
    }
    const d = n && Array.isArray(e.checkState.genomes) && e.checkState.genomes.length === 0, p = e.genomes?.genomes.find((b)=>b.system_name === e.systemName) ?? null, g = n && e.genomes ? an(e.genomes, e.mode, e.systemName ?? void 0) : null, m = g ? e.checkState.genomes ? g.filter((b)=>e.checkState.genomes.includes(b.system_name)) : g : null, f = t.length && e.genomes ? yr({
        primers: t.map((b)=>({
                left: b.left.seq,
                right: b.right.seq
            })),
        mode: e.mode,
        referenceTotalBases: p?.total_bases ?? null,
        pangenome: m
    }) : null, u = l ? ga(l) : null, h = En(t).length, y = !!l && !o && !a.length && !f?.over_limit && !i && !e.disabled && !d, _ = `${e.idPrefix}-check-h`, k = ()=>{
        l && y && e.onSubmit(l);
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("section", {
        className: "gpr-check-panel",
        "aria-labelledby": _,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("h3", {
                className: "gpr-h3",
                id: _,
                children: "Check primers"
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                className: "gpr-readout",
                children: t.length ? `${t.length} pair${t.length === 1 ? "" : "s"} selected \xb7 ${h} distinct primer${h === 1 ? "" : "s"} (limits: ${ae.maxPairs} pairs, ${ae.maxUniquePrimers} primers)` : `Tick pairs in the table to check them (up to ${ae.maxPairs}).`
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("fieldset", {
                className: "gpr-fieldset",
                disabled: e.disabled,
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("legend", {
                        className: "gpr-legend",
                        children: "Checks"
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ie, {
                        id: `${e.idPrefix}-check-specificity`,
                        label: e.mode === "transcript" ? "Genome and transcriptome specificity" : "Genome specificity",
                        checked: !0,
                        disabled: !0,
                        onChange: ()=>{},
                        hint: "Always run."
                    }),
                    r ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ie, {
                        id: `${e.idPrefix}-check-pangenome`,
                        label: e.mode === "transcript" ? "Pan-genome coverage (annotated transcripts)" : "Pan-genome coverage",
                        checked: n,
                        onChange: e.onPangenome,
                        hint: e.mode === "transcript" ? "Transcript mode searches the annotated transcript models of each genome (PANGENOME_TRANSCRIPT_MODELS_ONLY); unannotated copies are missed." : `Searches up to ${v((e.genomes?.counts?.total ?? 1) - 1)} other genomes of ${e.genomes?.species?.name ?? "this species"}.`
                    }) : null
                ]
            }),
            n && e.genomes ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ga, {
                genomes: e.genomes,
                mode: e.mode,
                systemName: e.systemName,
                selected: e.checkState.genomes ?? null,
                onChange: e.onGenomes,
                disabled: e.disabled
            }) : null,
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("details", {
                className: "gpr-details",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("summary", {
                        className: "gpr-summary",
                        children: "Advanced check settings"
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                        className: "gpr-field-grid",
                        children: rl.map((b)=>{
                            const C = e.checkState.params?.[b.key];
                            return /* @__PURE__ */ (0, _jsxRuntime.jsx)(mt, {
                                id: `${e.idPrefix}-check-${b.key}`,
                                label: b.label,
                                value: typeof C == "number" ? C : void 0,
                                placeholder: String(b.key === "max_amplifying_mismatches" ? Bi({
                                    ignore_mismatches: e.checkState.params?.ignore_mismatches
                                }) ?? Re[b.key] : Re[b.key]),
                                min: sr[b.key].min,
                                max: sr[b.key].max,
                                step: 1,
                                issues: a.filter((N)=>N.field === b.key),
                                changed: typeof C == "number",
                                disabled: e.disabled,
                                onChange: (N)=>e.onParam(b.key, N)
                            }, b.key);
                        })
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ie, {
                        id: `${e.idPrefix}-check-include-unlikely`,
                        label: "List unlikely products too",
                        checked: e.checkState.params?.include_unlikely ?? Re.include_unlikely,
                        disabled: e.disabled,
                        onChange: (b)=>e.onParam("include_unlikely", b === Re.include_unlikely ? void 0 : b)
                    })
                ]
            }),
            u?.raised ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-hint",
                children: [
                    "The maximum product size will be raised to ",
                    v(u.effective),
                    " bp to cover the expected products."
                ]
            }) : null,
            f ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-estimate",
                "data-state": f.over_limit ? "over" : void 0,
                children: [
                    "Estimated cost \u2248 ",
                    v(f.cpu_s),
                    " CPU-s",
                    f.over_limit ? ` \u{2014} over the ${v(f.limit)} CPU-s limit; select fewer pairs or genomes.` : "."
                ]
            }) : null,
            o ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                className: "gpr-field-error",
                children: o.message
            }) : null,
            d ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                className: "gpr-field-error",
                children: "Select at least one genome for the pan-genome check."
            }) : null,
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                className: "gpr-button-row",
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                    type: "button",
                    className: "gpr-btn gpr-btn-primary",
                    disabled: !y,
                    onClick: k,
                    children: n ? "Run checks" : "Check specificity"
                })
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                className: "gpr-check-status",
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(al, {
                    run: e.run,
                    onDetach: e.onDetach,
                    onResume: e.onResume,
                    onRerun: e.onRerun,
                    onRetry: e.onRerun
                })
            }),
            e.run.job?.warnings?.length ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(cn, {
                warnings: e.run.job.warnings,
                title: "Check warnings"
            }) : null
        ]
    });
}
const ja = "https://primer3.org/manual.html", jn = Object.freeze({
    text: "Untergasser A, Cutcutache I, Koressaar T, Ye J, Faircloth BC, Remm M, Rozen SG. Primer3\u2014new capabilities and interfaces. Nucleic Acids Res. 2012;40(15):e115.",
    short: "Untergasser et al. 2012",
    url: "https://doi.org/10.1093/nar/gks596"
});
function ol(e) {
    return `${ja}#${e}`;
}
const ie = (...e)=>e.map((t)=>({
            anchor: t
        })), ll = {
    size: {
        text: "Primer length. Primers shorter than min or longer than max are rejected, and Primer3 prefers lengths close to opt.",
        links: ie("PRIMER_MIN_SIZE", "PRIMER_OPT_SIZE", "PRIMER_MAX_SIZE")
    },
    tm: {
        text: "Primer melting temperature, calculated with SantaLucia (1998) nearest-neighbor parameters and the salt, dNTP and oligo concentrations under Advanced parameters. Primers outside min\u2013max are rejected, and Primer3 prefers a Tm close to opt.",
        links: ie("PRIMER_MIN_TM", "PRIMER_OPT_TM", "PRIMER_MAX_TM", "PRIMER_TM_FORMULA")
    },
    gc: {
        text: "Share of G and C bases. Primers outside min\u2013max are rejected. Primer3 uses opt only when a GC penalty weight is set, which this form does not send.",
        links: ie("PRIMER_MIN_GC", "PRIMER_OPT_GC_PERCENT", "PRIMER_MAX_GC")
    },
    max_tm_diff: {
        text: "Largest allowed difference between the melting temperatures of the left and right primers.",
        links: ie("PRIMER_PAIR_MAX_DIFF_TM")
    },
    num_return: {
        text: "Most primer pairs to return, sorted by penalty (best first).",
        links: ie("PRIMER_NUM_RETURN")
    },
    product_size_ranges: {
        text: "Allowed product lengths, primers included. Primer3 returns pairs from the first range and uses a later range only when the first has too few pairs.",
        links: ie("PRIMER_PRODUCT_SIZE_RANGE")
    },
    max_poly_x: {
        text: "Longest allowed run of a single base: 4 accepts AAAA but rejects AAAAA.",
        links: ie("PRIMER_MAX_POLY_X")
    },
    gc_clamp: {
        text: "Number of consecutive G or C bases required at the 3\u2032 end of both primers.",
        links: ie("PRIMER_GC_CLAMP")
    },
    max_end_stability: {
        text: "Largest allowed stability of a primer\u2019s last five 3\u2032 bases, as the \u0394G (kcal/mol) to disrupt their duplex. Bigger values mean more stable 3\u2032 ends.",
        links: ie("PRIMER_MAX_END_STABILITY")
    },
    max_ns: {
        text: "Most unknown bases (N) a primer may contain. Avoid repeats with \u201CReplace with N\u201D sets this to 0.",
        links: ie("PRIMER_MAX_NS_ACCEPTED")
    },
    salt_monovalent: {
        text: "Concentration of monovalent cations (usually KCl) in the PCR, used for melting temperatures.",
        links: ie("PRIMER_SALT_MONOVALENT")
    },
    salt_divalent: {
        text: "Concentration of divalent cations (usually Mg\xb2\u207A). Primer3 converts it to an equivalent monovalent concentration, allowing for the dNTPs that bind it.",
        links: ie("PRIMER_SALT_DIVALENT")
    },
    dntp_conc: {
        text: "Total concentration of all four dNTPs. It affects melting temperatures only when the divalent cation concentration is above 0.",
        links: ie("PRIMER_DNTP_CONC")
    },
    dna_conc: {
        text: "Concentration of each annealing oligo during the PCR, used for melting temperatures.",
        links: ie("PRIMER_DNA_CONC")
    },
    min_5_prime_overlap_of_junction: {
        text: "For a junction-spanning primer: the fewest primer bases on the 5\u2032 side of the exon\u2013exon junction.",
        links: ie("PRIMER_MIN_5_PRIME_OVERLAP_OF_JUNCTION", "SEQUENCE_OVERLAP_JUNCTION_LIST")
    },
    min_3_prime_overlap_of_junction: {
        text: "For a junction-spanning primer: the fewest primer bases on the 3\u2032 side of the exon\u2013exon junction.",
        links: ie("PRIMER_MIN_3_PRIME_OVERLAP_OF_JUNCTION", "SEQUENCE_OVERLAP_JUNCTION_LIST")
    },
    junction: {
        text: "The server gives Primer3 the transcript\u2019s exon\u2013exon junctions; the left or the right primer of every pair must then span one.",
        links: ie("SEQUENCE_OVERLAP_JUNCTION_LIST", "PRIMER_MIN_5_PRIME_OVERLAP_OF_JUNCTION", "PRIMER_MIN_3_PRIME_OVERLAP_OF_JUNCTION")
    },
    repeat_masking: {
        text: "Replace with N turns masked bases into N and allows no N in primers. Keep marks masked bases as lowercase, and Primer3 rejects only primers whose 3\u2032-end base is masked.",
        links: ie("PRIMER_MAX_NS_ACCEPTED", "PRIMER_LOWERCASE_MASKING")
    },
    intervals: {
        text: "Primer3 receives these as start,length pairs.",
        links: ie("SEQUENCE_TARGET", "SEQUENCE_INCLUDED_REGION", "SEQUENCE_EXCLUDED_REGION")
    },
    explain: {
        text: "Primer3 reports how many candidate primers and pairs it considered and why it rejected the others.",
        links: [
            ...ie("PRIMER_LEFT_EXPLAIN", "PRIMER_PAIR_EXPLAIN"),
            {
                anchor: "findNoPrimers",
                label: "What to do if Primer3 cannot find primers"
            }
        ]
    },
    tm_gc: {
        text: "Melting temperature and GC percentage of the left and right primer.",
        links: ie("PRIMER_LEFT_4_TM", "PRIMER_LEFT_4_GC_PERCENT")
    },
    product: {
        text: "Product length in bp, from the 5\u2032 end of the left primer to the 5\u2032 end of the right primer.",
        links: ie("PRIMER_PAIR_4_PRODUCT_SIZE")
    },
    penalty: {
        text: "Primer3\u2019s objective function for the pair; with its default weights, mostly how far each primer is from the optimal length and Tm. Lower is better, and pairs are listed best first.",
        links: [
            ...ie("PRIMER_PAIR_4_PENALTY"),
            {
                anchor: "calculatePenalties",
                label: "How Primer3 calculates the penalty"
            }
        ]
    },
    complementarity: {
        text: "Melting temperature (\xb0C) of the most stable duplex the two primers form with each other, anywhere and at their 3\u2032 ends; high 3\u2032 values risk primer-dimers. Lower is better.",
        links: ie("PRIMER_PAIR_4_COMPL_ANY_TH", "PRIMER_PAIR_4_COMPL_END_TH")
    },
    hairpin: {
        text: "Melting temperature (\xb0C) of the most stable hairpin each primer can form. Lower is better.",
        links: ie("PRIMER_LEFT_4_HAIRPIN_TH")
    },
    self_complementarity: {
        text: "Melting temperature (\xb0C) of the most stable duplex a primer forms with itself, anywhere and at its 3\u2032 end. Lower is better.",
        links: ie("PRIMER_LEFT_4_SELF_ANY_TH", "PRIMER_LEFT_4_SELF_END_TH")
    },
    end_stability: {
        text: "\u0394G (kcal/mol) to disrupt the duplex of a primer\u2019s last five 3\u2032 bases; bigger values mean a more stable 3\u2032 end.",
        links: ie("PRIMER_LEFT_4_END_STABILITY")
    },
    product_tm: {
        text: "Melting temperature of the product (Rychlik et al. 1990).",
        links: ie("PRIMER_PAIR_4_PRODUCT_TM")
    }
}, Ua = Object.freeze(ll), Fa = /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
    className: "gpr-visually-hidden",
    children: " (opens in a new tab)"
});
function zr({ anchor: e, className: t, children: r }) {
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("a", {
        className: t ? `gpr-link ${t}` : "gpr-link",
        href: e ? ol(e) : ja,
        target: "_blank",
        rel: "noopener noreferrer",
        children: [
            r,
            Fa
        ]
    });
}
function Lr({ topic: e }) {
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
        className: "gpr-p3-links",
        children: [
            "Primer3 manual:",
            " ",
            Ua[e].links.map((t, r)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                    children: [
                        r ? ", " : null,
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)(zr, {
                            anchor: t.anchor,
                            className: t.label ? void 0 : "gpr-p3-tag",
                            children: t.label ?? t.anchor
                        })
                    ]
                }, t.anchor))
        ]
    });
}
function zt({ topic: e }) {
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            Ua[e].text,
            " ",
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(Lr, {
                topic: e
            })
        ]
    });
}
function qr({ subject: e, expanded: t, controls: r, onToggle: n }) {
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
        type: "button",
        className: "gpr-help-button",
        "aria-label": `About ${e}`,
        "aria-expanded": t,
        "aria-controls": t ? r : void 0,
        onClick: n,
        children: "?"
    });
}
function cl({ version: e }) {
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
        className: "gpr-hint gpr-p3-credit",
        children: [
            "Designed with Primer3",
            e ? ` ${e}` : "",
            " (",
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("a", {
                className: "gpr-link",
                href: jn.url,
                target: "_blank",
                rel: "noopener noreferrer",
                title: jn.text,
                children: [
                    jn.short,
                    Fa
                ]
            }),
            "). ",
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(zr, {
                children: "Primer3 manual"
            })
        ]
    });
}
function dl(e, t) {
    const r = Array.isArray(e.exons) ? e.exons.length : 0, n = [
        `${r} exon${r === 1 ? "" : "s"}`,
        `${v(e.length)} nt`,
        e.cds ? `CDS ${v(e.cds.start)}\u{2013}${v(e.cds.end)}` : "non-coding"
    ];
    return `${e.id}${e.id === t ? " (canonical)" : ""} \xb7 ${n.join(", ")}`;
}
function Ba({ id: e, label: t, gene: r, value: n, onChange: a, disabled: i }) {
    const l = Pa(r);
    if (!l.length) return null;
    const o = gr(r), d = n && l.some((p)=>p.id === n) ? n : o ?? l[0].id;
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: "gpr-field",
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("label", {
                className: "gpr-label",
                htmlFor: e,
                children: t
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                className: "gpr-inline",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("select", {
                        id: e,
                        className: "gpr-select",
                        value: d,
                        disabled: i,
                        onChange: (p)=>a(p.target.value === o ? void 0 : p.target.value),
                        children: l.map((p)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("option", {
                                value: p.id,
                                children: dl(p, o)
                            }, p.id))
                    }),
                    d === o ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                        className: "gpr-badge",
                        children: "canonical"
                    }) : null
                ]
            })
        ]
    });
}
function Ka({ id: e, label: t, value: r, genomes: n, onChange: a, allowNone: i, noneLabel: l, disabled: o, hint: d }) {
    const p = `${e}-hint`;
    if (!n || n.length === 0) {
        const m = !!r && !ee.systemNamePattern.test(r);
        return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
            className: "gpr-field",
            children: [
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("label", {
                    className: "gpr-label",
                    htmlFor: e,
                    children: t
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                    id: e,
                    className: "gpr-input",
                    type: "text",
                    value: r ?? "",
                    spellCheck: !1,
                    autoComplete: "off",
                    placeholder: "e.g. sorghum_bicolor",
                    disabled: o,
                    "aria-invalid": m ? !0 : void 0,
                    "aria-describedby": p,
                    onChange: (f)=>a(f.target.value.trim() || void 0)
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                    id: p,
                    className: m ? "gpr-field-error" : "gpr-hint",
                    children: m ? "Use the genome system name: lowercase letters, digits and _." : d ?? "Genome system name."
                })
            ]
        });
    }
    const g = !!r && n.some((m)=>m.system_name === r);
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: "gpr-field",
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("label", {
                className: "gpr-label",
                htmlFor: e,
                children: t
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("select", {
                id: e,
                className: "gpr-select",
                value: r ?? "",
                disabled: o,
                "aria-describedby": d ? p : void 0,
                onChange: (m)=>a(m.target.value || void 0),
                children: [
                    i || !r ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("option", {
                        value: "",
                        children: l ?? "\u2014 choose a genome \u2014"
                    }) : null,
                    r && !g ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("option", {
                        value: r,
                        children: r
                    }) : null,
                    n.map((m)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("option", {
                            value: m.system_name,
                            children: [
                                m.display_name || m.system_name,
                                m.is_query ? " (this genome)" : ""
                            ]
                        }, m.system_name))
                ]
            }),
            d ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                id: p,
                className: "gpr-hint",
                children: d
            }) : null
        ]
    });
}
function Ha(e, t) {
    const r = Mr(e, t);
    return !!r && (r.exons?.length ?? 0) <= 1;
}
function pl(e) {
    const t = Mr(e.gene, e.transcriptId), r = t?.exons?.length ?? 0, n = !!t && r <= 1, a = Math.max(0, r - 1), i = t?.cds ?? null, l = i ? [
        i.start,
        i.end - i.start + 1
    ] : null, o = !!l && !!e.included && e.included[0] === l[0] && e.included[1] === l[1];
    let d;
    return n ? d = "Single-exon transcript: there is no junction to span." : t && (d = `${a} junction${a === 1 ? "" : "s"}; a spanning primer overlaps one by at least ${e.overlaps.min5} nt on its 5\u{2032} side and ${e.overlaps.min3} nt on its 3\u{2032} side.`), /* @__PURE__ */ (0, _jsxRuntime.jsxs)("fieldset", {
        className: "gpr-fieldset",
        disabled: e.disabled,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("legend", {
                className: "gpr-legend",
                children: "Transcript"
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ba, {
                id: `${e.idPrefix}-transcript`,
                label: "Transcript",
                gene: e.gene,
                value: e.transcriptId,
                onChange: e.onTranscript
            }),
            e.gene ? null : /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                className: "gpr-hint",
                children: "Transcript details are not loaded; the canonical transcript is used."
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ie, {
                id: `${e.idPrefix}-junction`,
                label: "One primer must span an exon\u2013exon junction",
                checked: !n && e.junctionSpanning,
                disabled: n,
                onChange: e.onJunctionSpanning,
                hint: d
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                className: "gpr-hint",
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Lr, {
                    topic: "junction"
                })
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                className: "gpr-button-row",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "gpr-btn gpr-btn-small",
                        disabled: !l || o,
                        onClick: ()=>l && e.onIncluded(l),
                        children: "Restrict to CDS"
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "gpr-btn gpr-btn-small",
                        disabled: !e.included,
                        onClick: ()=>e.onIncluded(void 0),
                        children: "Clear"
                    })
                ]
            }),
            i ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-hint",
                children: [
                    "CDS at cDNA ",
                    v(i.start),
                    "\u2013",
                    v(i.end),
                    o ? "; primers are restricted to the CDS." : "."
                ]
            }) : t ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                className: "gpr-hint",
                children: "Non-coding transcript."
            }) : null
        ]
    });
}
const gl = /* @__PURE__ */ new Set([
    "LONGER_THAN_TEMPLATE"
]);
function _s(e) {
    return ee.systemNamePattern.test(e) && e.length <= 128;
}
function Va(e, t, r) {
    const n = r ?? ia(e.sequence ?? t.sequence ?? ""), a = t.gene, i = Jo(e, a, e.mode === "sequence" ? n.length : null), l = Ha(a, e.transcriptId), o = e.mode === "transcript" && !l && e.junctionSpanning !== !1, d = Ze(e.mode), p = e.preset ?? St(d), g = br(p, e.params), m = Ni(g, {
        mode: d,
        junctionSpanning: o,
        templateLength: i
    }), f = Oa(a), u = [];
    switch(e.mode){
        case "gene":
            t.geneId ? f ? u.push("The gene is longer than 50,000 bp; use Transcript or Region mode.") : i !== null && i > ee.maxTemplateLength && u.push("The gene plus flanks is longer than 50,000 bp.") : u.push("No gene is selected.");
            break;
        case "transcript":
            t.geneId || u.push("No gene is selected.");
            break;
        case "region":
            {
                e.region || u.push("Enter a genomic region.");
                const h = e.systemName ?? t.systemName ?? a?.system_name ?? null;
                h ? _s(h) || u.push("The genome name is not valid.") : u.push("Choose a genome.");
                break;
            }
        case "sequence":
            n.ok || u.push(n.length ? "Fix the pasted sequence." : "Paste a sequence."), e.systemName && !_s(e.systemName) && u.push("The genome name is not valid.");
            break;
    }
    return {
        cleaned: n,
        templateLength: i,
        singleExon: l,
        junctionSpanning: o,
        preset: p,
        effective: g,
        paramIssues: m,
        modeIssues: u,
        tooLong: f
    };
}
function ml(e, t) {
    const r = Va(e, t), n = ki({
        target: e.target,
        included: e.included,
        excluded: e.excluded
    }, r.templateLength);
    return [
        .../* @__PURE__ */ new Set([
            ...r.modeIssues,
            ...r.paramIssues.map((a)=>a.message),
            ...n.map((a)=>a.message)
        ])
    ];
}
const ul = Object.freeze({
    considered: {
        hint: "Candidates examined.",
        informational: !0
    },
    ok: {
        hint: "Candidates that passed every filter.",
        informational: !0
    },
    "sequencing locations": {
        hint: "Sequencing-primer locations evaluated.",
        informational: !0
    },
    // oligo (left/right) labels
    "would not amplify any of the ORF": {
        hint: "The primer would not amplify any part of the ORF."
    },
    "too many Ns": {
        hint: "The primer overlaps N bases \u2014 ambiguity codes or masked repeats.",
        suggestion: "Turn off repeat avoidance, switch the mask mode to 3\u2032 end only, or allow Ns."
    },
    "overlap target": {
        hint: "The primer would overlap the target region.",
        suggestion: "Shrink the target or widen the template."
    },
    "overlap excluded region": {
        hint: "The primer overlaps an excluded region.",
        suggestion: "Remove or shrink excluded intervals."
    },
    "GC content failed": {
        hint: "GC% outside the allowed range.",
        suggestion: "Widen the GC range."
    },
    "GC clamp failed": {
        hint: "Not enough G/C at the 3\u2032 end.",
        suggestion: "Lower the GC clamp."
    },
    "low tm": {
        hint: "Melting temperature below the minimum.",
        suggestion: "Lower the minimum Tm or allow longer primers."
    },
    "high tm": {
        hint: "Melting temperature above the maximum.",
        suggestion: "Raise the maximum Tm or allow shorter primers."
    },
    "low faction bound": {
        hint: "Too small a fraction of primer bound at the annealing temperature."
    },
    "high fraction bound": {
        hint: "Too large a fraction of primer bound at the annealing temperature."
    },
    "high any compl": {
        hint: "Self-complementarity (any position) is too stable.",
        suggestion: "Try another region."
    },
    "high end compl": {
        hint: "3\u2032 self-complementarity is too stable (primer-dimer risk).",
        suggestion: "Try another region."
    },
    "high hairpin stability": {
        hint: "The primer forms a stable hairpin.",
        suggestion: "Try another region."
    },
    "high repeat similarity": {
        hint: "Too similar to a mispriming library sequence."
    },
    "long poly-x seq": {
        hint: "Mononucleotide run longer than allowed.",
        suggestion: "Raise max poly-X."
    },
    "low sequence quality": {
        hint: "Sequence quality below the minimum."
    },
    "high 3' stability": {
        hint: "3\u2032 end stability above the maximum.",
        suggestion: "Raise max end stability."
    },
    "high template mispriming score": {
        hint: "The primer may misprime elsewhere in the template."
    },
    "lowercase masking of 3' end": {
        hint: "The 3\u2032 end falls in a masked (lowercase) repeat.",
        suggestion: "Turn off repeat avoidance or pick a less repetitive region."
    },
    "failed must_match requirements": {
        hint: "Did not match the required 5\u2032/3\u2032 pattern."
    },
    "not in any ok left region": {
        hint: "Outside every allowed left-primer region."
    },
    "not in any ok right region": {
        hint: "Outside every allowed right-primer region."
    },
    "no overlap of required point": {
        hint: "Does not span an exon\u2013exon junction by the required overlap.",
        suggestion: "Lower the junction overlaps, pick another transcript, or turn off junction spanning."
    },
    // pair labels
    "no target": {
        hint: "The pair does not flank the target.",
        suggestion: "Move or shrink the target."
    },
    "unacceptable product size": {
        hint: "Product size outside every allowed range.",
        suggestion: "Widen the product size ranges."
    },
    "low product Tm": {
        hint: "Product Tm below the minimum."
    },
    "high product Tm": {
        hint: "Product Tm above the maximum."
    },
    "tm diff too large": {
        hint: "Left/right Tm difference is too large.",
        suggestion: "Raise the max Tm difference."
    },
    "no internal oligo": {
        hint: "No acceptable internal oligo."
    },
    "high mispriming library similarity": {
        hint: "The pair is too similar to a mispriming library."
    },
    "primer in pair overlaps a primer in a better pair": {
        hint: "A primer is shared with a better-ranked pair."
    },
    "not in any ok region": {
        hint: "The pair lies outside the allowed regions."
    },
    "left primer to right of right primer": {
        hint: "Left primer lies to the right of the right primer."
    }
});
function Wa(e) {
    const t = {
        raw: e ?? ""
    };
    for (const r of (e ?? "").split(",")){
        const n = /^\s*(.*?)\s+(\d+)\s*$/.exec(r);
        n && n[1] && (t[n[1]] = Number(n[2]));
    }
    return t;
}
function hl(e) {
    if (!e) return [];
    const t = typeof e == "string" ? Wa(e) : e, r = [];
    for (const [n, a] of Object.entries(t)){
        if (n === "raw" || typeof a != "number") continue;
        const i = ul[n];
        r.push({
            label: n,
            count: a,
            hint: i?.hint ?? null,
            suggestion: i?.suggestion ?? null,
            informational: !!i?.informational
        });
    }
    return r.sort((n, a)=>Number(n.informational) - Number(a.informational) || a.count - n.count);
}
function fl(e, t = 3) {
    if (!e) return [];
    const r = [];
    for (const n of [
        "left",
        "right",
        "pair"
    ]){
        const a = e[n];
        if (!a) continue;
        const i = typeof a.raw == "string" && Object.keys(a).length <= 1 ? Wa(a.raw) : a, l = typeof i.considered == "number" ? i.considered : null, o = typeof i.ok == "number" ? i.ok : null, d = hl(i).filter((p)=>!p.informational && p.count > 0).slice(0, t);
        r.push({
            side: n,
            considered: l,
            ok: o,
            reasons: d
        });
    }
    return r;
}
const bl = {
    left: "Left primers",
    right: "Right primers",
    pair: "Primer pairs"
};
function Ya({ explain: e, open: t, onToggle: r, noPairs: n, idPrefix: a, title: i }) {
    const l = fl(e, 50);
    if (!l.length && !n) return null;
    const o = `${a}-explain-h`, d = `${a}-explain-body`;
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("section", {
        className: "gpr-explain",
        "data-state": t ? "open" : "closed",
        "aria-labelledby": o,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("h3", {
                className: "gpr-h3",
                id: o,
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                    type: "button",
                    className: "gpr-disclosure",
                    "aria-expanded": t,
                    "aria-controls": d,
                    onClick: ()=>r(!t),
                    children: i ?? (n ? "Why no primer pairs?" : "Primer3 explain")
                })
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                id: d,
                className: "gpr-explain-body",
                hidden: !t,
                children: [
                    n ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                        className: "gpr-explain-lead",
                        children: "Primer3 found no acceptable primer pair. The filters that rejected the most candidates are listed first, with suggestions."
                    }) : null,
                    l.length === 0 ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                        className: "gpr-hint",
                        children: "No explain counts were returned."
                    }) : null,
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                        className: "gpr-explain-grid",
                        children: l.map((p)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                                className: "gpr-explain-side",
                                "data-state": p.ok === 0 ? "blocked" : void 0,
                                children: [
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("h4", {
                                        className: "gpr-h4",
                                        children: bl[p.side]
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                                        className: "gpr-explain-counts",
                                        children: [
                                            v(p.considered),
                                            " considered \xb7 ",
                                            v(p.ok),
                                            " ok"
                                        ]
                                    }),
                                    p.reasons.length ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("ul", {
                                        className: "gpr-explain-reasons",
                                        children: p.reasons.map((g)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("li", {
                                                className: "gpr-explain-reason",
                                                children: [
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                        className: "gpr-explain-label",
                                                        children: g.label
                                                    }),
                                                    " ",
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                        className: "gpr-explain-count",
                                                        children: v(g.count)
                                                    }),
                                                    g.hint ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "gpr-explain-hint",
                                                        children: [
                                                            " \u2014 ",
                                                            g.hint
                                                        ]
                                                    }) : null,
                                                    g.suggestion ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "gpr-explain-suggestion",
                                                        children: [
                                                            " Try: ",
                                                            g.suggestion
                                                        ]
                                                    }) : null
                                                ]
                                            }, g.label))
                                    }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                                        className: "gpr-hint",
                                        children: "No candidates were rejected."
                                    })
                                ]
                            }, p.side))
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                        className: "gpr-hint gpr-explain-docs",
                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(zt, {
                            topic: "explain"
                        })
                    })
                ]
            })
        ]
    });
}
async function Ja(e) {
    try {
        if (typeof navigator < "u" && navigator.clipboard && typeof navigator.clipboard.writeText == "function") return await navigator.clipboard.writeText(e), !0;
    } catch  {}
    if (typeof document > "u" || !document.body) return !1;
    const t = document.createElement("textarea");
    t.value = e, t.setAttribute("readonly", ""), t.style.position = "fixed", t.style.top = "-1000px", t.style.opacity = "0", document.body.appendChild(t);
    try {
        return t.select(), typeof document.execCommand == "function" ? document.execCommand("copy") : !1;
    } catch  {
        return !1;
    } finally{
        t.remove();
    }
}
function yl(e, t, r = "text/plain;charset=utf-8") {
    if (typeof document > "u" || typeof URL > "u" || typeof URL.createObjectURL != "function") return !1;
    const n = URL.createObjectURL(new Blob([
        t
    ], {
        type: r
    })), a = document.createElement("a");
    a.href = n, a.download = e.replace(/[\\/:*?"<>|\r\n]+/g, "_"), a.rel = "noopener", a.style.display = "none", document.body.appendChild(a);
    try {
        a.click();
    } finally{
        a.remove(), setTimeout(()=>URL.revokeObjectURL(n), 0);
    }
    return !0;
}
const Xa = (0, _react.createContext)(()=>{});
function Qa() {
    return (0, _react.useContext)(Xa);
}
function _l() {
    const [e, t] = (0, _react.useState)(""), [r, n] = (0, _react.useState)(""), a = (0, _react.useRef)(!1), i = (0, _react.useCallback)((o, d = "polite")=>{
        a.current = !a.current;
        const p = a.current ? o : `${o}\xa0`;
        d === "assertive" ? n(p) : t(p);
    }, []), l = (0, _react.useMemo)(()=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                    className: "gpr-visually-hidden",
                    role: "status",
                    "aria-live": "polite",
                    "aria-atomic": "true",
                    "data-gpr-live": "polite",
                    children: e
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                    className: "gpr-visually-hidden",
                    "aria-live": "assertive",
                    "aria-atomic": "true",
                    "data-gpr-live": "assertive",
                    children: r
                })
            ]
        }), [
        e,
        r
    ]);
    return {
        announce: i,
        regions: l,
        Provider: Xa.Provider
    };
}
function Za({ items: e, idPrefix: t }) {
    const [r, n] = (0, _react.useState)(!1), [a, i] = (0, _react.useState)(""), l = Qa();
    if (!e.length) return null;
    const o = (g)=>{
        i(g), l(g);
    }, d = `${t}-export-body`, p = `${t}-export-h`;
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("section", {
        className: "gpr-export",
        "aria-labelledby": p,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("h3", {
                className: "gpr-h3",
                id: p,
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                    type: "button",
                    className: "gpr-disclosure",
                    "aria-expanded": r,
                    "aria-controls": d,
                    onClick: ()=>n((g)=>!g),
                    children: "Export"
                })
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                id: d,
                className: "gpr-export-body",
                hidden: !r,
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("ul", {
                        className: "gpr-export-list",
                        children: e.map((g)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("li", {
                                className: "gpr-export-item",
                                "data-export": g.id,
                                children: [
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                        className: "gpr-export-label",
                                        children: g.label
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                        className: "gpr-export-actions",
                                        children: [
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                                type: "button",
                                                className: "gpr-btn gpr-btn-small",
                                                "aria-label": `Download ${g.label}`,
                                                onClick: ()=>{
                                                    const m = yl(g.filename, g.build(), g.mime);
                                                    o(m ? `Downloaded ${g.filename}` : "Downloads are not available here; use Copy");
                                                },
                                                children: "Download"
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                                type: "button",
                                                className: "gpr-btn gpr-btn-small",
                                                "aria-label": `Copy ${g.label}`,
                                                onClick: async ()=>{
                                                    const m = await Ja(g.build());
                                                    o(m ? `Copied ${g.label}` : "Copy failed");
                                                },
                                                children: "Copy"
                                            })
                                        ]
                                    })
                                ]
                            }, g.id))
                    }),
                    a ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                        className: "gpr-hint gpr-export-status",
                        "aria-hidden": "true",
                        children: a
                    }) : null
                ]
            })
        ]
    });
}
const vs = Object.freeze({
    ref: {
        status: "ref",
        glyph: "\u25CF",
        color: "#0072B2",
        label: "Reference allele",
        severity: 0
    },
    alt: {
        status: "alt",
        glyph: "\u25B2",
        color: "#E69F00",
        label: "Alternative allele",
        severity: 0
    },
    other: {
        status: "other",
        glyph: "\u25C6",
        color: "#CC79A7",
        label: "A third allele",
        severity: 3
    },
    ambiguous: {
        status: "ambiguous",
        glyph: "?",
        color: "#999999",
        label: "Copies disagree",
        severity: 4
    },
    missing: {
        status: "missing",
        glyph: "\u2013",
        color: null,
        label: "No comparable locus",
        severity: 2
    },
    unavailable: {
        status: "unavailable",
        glyph: "\xd7",
        color: "#555555",
        label: "Allele call failed",
        severity: 5
    }
}), xs = Object.freeze({
    ref: {
        status: "ref",
        glyph: "\u25CF",
        color: "#0072B2",
        label: "REF dye only",
        severity: 0
    },
    alt: {
        status: "alt",
        glyph: "\u25B2",
        color: "#E69F00",
        label: "ALT dye only",
        severity: 0
    },
    both: {
        status: "both",
        glyph: "\u25D0",
        color: "#CC79A7",
        label: "Both dyes",
        severity: 4
    },
    none: {
        status: "none",
        glyph: "\u25CB",
        color: null,
        label: "No product",
        severity: 3
    },
    no_call: {
        status: "no_call",
        glyph: "\u2298",
        color: "#D55E00",
        label: "No call",
        severity: 5
    },
    unknown: {
        status: "unknown",
        glyph: "\xb7",
        color: null,
        label: "Cannot be predicted",
        severity: 2
    }
}), Ns = Object.freeze({
    match: {
        status: "match",
        glyph: "=",
        color: "#009E73",
        label: "Perfect match",
        severity: 0
    },
    terminal_mismatch: {
        status: "terminal_mismatch",
        glyph: "\u2260",
        color: "#56B4E9",
        label: "3\u2032 terminal mismatch",
        severity: 1
    },
    weak: {
        status: "weak",
        glyph: "~",
        color: "#E69F00",
        label: "Weak binding",
        severity: 2
    },
    uncertain: {
        status: "uncertain",
        glyph: "?",
        color: "#999999",
        label: "Uncertain",
        severity: 3
    },
    blocked: {
        status: "blocked",
        glyph: "\u2297",
        color: "#D55E00",
        label: "Blocked",
        severity: 4
    },
    no_product: {
        status: "no_product",
        glyph: "\u2205",
        color: null,
        label: "No product",
        severity: 3
    },
    unknown: {
        status: "unknown",
        glyph: "\xb7",
        color: null,
        label: "Not determined",
        severity: 2
    }
});
function Gr(e) {
    return vs[e ?? "unavailable"] ?? vs.unavailable;
}
function Dr(e) {
    return xs[e ?? "unknown"] ?? xs.unknown;
}
function vl(e) {
    return Ns[String(e ?? "unknown")] ?? Ns.unknown;
}
function xl() {
    return {
        genomes_total: 0,
        ref: 0,
        alt: 0,
        other: 0,
        ambiguous: 0,
        missing: 0,
        unavailable: 0
    };
}
function jd() {
    return {
        genomes_total: 0,
        predicted_ref: 0,
        predicted_alt: 0,
        both: 0,
        none: 0,
        no_call: 0,
        unknown: 0,
        weak: 0,
        agree: 0,
        disagree: 0,
        not_comparable: 0
    };
}
function Ud(e) {
    const t = xl();
    for (const r of e)if (!r.is_reference) {
        switch(r.allele){
            case "ref":
            case "alt":
            case "other":
            case "ambiguous":
            case "missing":
            case "unavailable":
                t[r.allele] += 1;
                break;
        }
        t.genomes_total += 1;
    }
    return t;
}
function Fd(e) {
    return e.ref + e.alt + e.other + e.ambiguous + e.missing + e.unavailable === e.genomes_total;
}
function ei(e) {
    return e?.agrees === !1;
}
function Nl(e) {
    return e !== "ref" && e !== "alt";
}
function kl(e) {
    return e !== "ref" && e !== "alt";
}
function wl(e, t) {
    const n = (e?.sets ?? []).map((o)=>{
        const d = /* @__PURE__ */ new Map();
        for (const p of o.genomes ?? [])d.set(p.system_name, p);
        return {
            set: o,
            map: d
        };
    }), a = [], i = /* @__PURE__ */ new Set(), l = (o, d, p, g)=>{
        if (i.has(d)) return;
        i.add(d);
        const m = n.map(({ set: f, map: u })=>({
                set: f,
                prediction: g ? f.reference ?? null : u.get(d) ?? null
            }));
        a.push({
            system_name: d,
            display_name: p,
            is_reference: g,
            genome: o,
            allele: o?.allele ?? null,
            cells: m,
            hasDisagreement: m.some((f)=>ei(f.prediction))
        });
    };
    for (const o of e?.genomes ?? [])o.is_reference && l(o, o.system_name, o.display_name ?? o.system_name, !0);
    for (const o of e?.genomes ?? [])o.is_reference || l(o, o.system_name, o.display_name ?? o.system_name, !1);
    for (const o of t ?? []){
        const d = typeof o == "string" ? o : o.system_name;
        l(null, d, typeof o == "string" ? o : o.display_name ?? d, !1);
    }
    return a;
}
function jr({ meta: e, context: t, compact: r, detail: n, className: a }) {
    const i = n ? `${e.label} \xb7 ${n}` : e.label;
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
        className: Pe("gpr-chip", "gpr-genotype-chip", r && "gpr-genotype-chip-compact", a),
        "data-status": e.status,
        "data-severity": e.severity,
        style: e.color ? {
            color: e.color
        } : void 0,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                className: "gpr-chip-glyph",
                "aria-hidden": "true",
                children: e.glyph
            }),
            r ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                className: "gpr-visually-hidden",
                children: [
                    t ? `${t}: ` : "",
                    i
                ]
            }) : /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                className: "gpr-chip-text",
                children: [
                    t ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                        className: "gpr-visually-hidden",
                        children: [
                            t,
                            ": "
                        ]
                    }) : null,
                    i
                ]
            })
        ]
    });
}
function ti(e) {
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(jr, {
        meta: Gr(e.allele),
        context: e.context ?? "Allele",
        compact: e.compact,
        detail: e.detail
    });
}
function ks(e) {
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(jr, {
        meta: Dr(e.predicted),
        context: e.context ?? "Predicted",
        compact: e.compact,
        detail: e.detail
    });
}
function wn(e) {
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(jr, {
        meta: vl(e.status),
        context: e.context,
        compact: e.compact
    });
}
function ws({ meta: e }) {
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("li", {
        className: "gpr-legend-item gpr-genotype-legend-item",
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                className: "gpr-genotype-legend-glyph",
                "aria-hidden": "true",
                style: e.color ? {
                    color: e.color
                } : void 0,
                children: e.glyph
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                className: "gpr-genotype-legend-label",
                children: e.label
            })
        ]
    });
}
function Al() {
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: "gpr-genotype-legend",
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                className: "gpr-genotype-legend-group",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                        className: "gpr-genotype-legend-title",
                        id: "gpr-legend-allele",
                        children: "Allele observed"
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("ul", {
                        className: "gpr-plain-list gpr-genotype-legend-list",
                        "aria-labelledby": "gpr-legend-allele",
                        children: [
                            "ref",
                            "alt",
                            "other",
                            "ambiguous",
                            "missing",
                            "unavailable"
                        ].map((e)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)(ws, {
                                meta: Gr(e)
                            }, e))
                    })
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                className: "gpr-genotype-legend-group",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                        className: "gpr-genotype-legend-title",
                        id: "gpr-legend-predicted",
                        children: "Predicted by the set"
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("ul", {
                        className: "gpr-plain-list gpr-genotype-legend-list",
                        "aria-labelledby": "gpr-legend-predicted",
                        children: [
                            "ref",
                            "alt",
                            "both",
                            "none",
                            "no_call",
                            "unknown"
                        ].map((e)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)(ws, {
                                meta: Dr(e)
                            }, e))
                    })
                ]
            })
        ]
    });
}
function ni({ agrees: e }) {
    const t = e === !0 ? {
        glyph: "\u2713",
        label: "Agrees with the observed allele",
        tone: "ok"
    } : e === !1 ? {
        glyph: "\u2717",
        label: "Disagrees with the observed allele",
        tone: "bad"
    } : {
        glyph: "\u2013",
        label: "Cannot be compared",
        tone: "muted"
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
        className: Pe("gpr-agreement", `gpr-agreement-${t.tone}`),
        title: t.label,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                "aria-hidden": "true",
                children: t.glyph
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                className: "gpr-visually-hidden",
                children: t.label
            })
        ]
    });
}
function Cl(e, t, r) {
    if (!r) return `${e.display_name}, set ${t}: not called yet`;
    const n = [
        `${e.display_name}, set ${t}: ${Dr(r.predicted).label}`
    ];
    return r.strength && n.push(r.strength), n.push(r.agrees === !0 ? "agrees" : r.agrees === !1 ? "disagrees" : "cannot be compared"), r.off_locus_products > 0 && n.push(`${r.off_locus_products} off-locus product${r.off_locus_products === 1 ? "" : "s"}`), r.reasons.length && n.push(r.reasons.join(", ")), n.join(" \xb7 ");
}
function Sl(e) {
    if (!e.genome) return `${e.display_name}: not called yet`;
    const t = e.genome, r = [
        `${e.display_name}: ${Gr(t.allele).label}`
    ];
    return t.observed && r.push(`reads ${t.observed}`), t.orthologous_copies !== 1 && r.push(`${t.orthologous_copies} orthologous copies`), t.paralog_copies && r.push(`${t.paralog_copies} paralog${t.paralog_copies === 1 ? "" : "s"}`), t.reason && r.push(t.reason.replace(/_/g, " ")), r.join(" \xb7 ");
}
function Tl({ row: e, headingId: t, onClose: r }) {
    const n = e.genome;
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("section", {
        className: "gpr-cell-detail gpr-allele-detail",
        "aria-labelledby": t,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                className: "gpr-banner-actions",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("h4", {
                        className: "gpr-h4",
                        id: t,
                        children: e.display_name
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "gpr-btn gpr-btn-small gpr-btn-quiet",
                        onClick: r,
                        children: "Close"
                    })
                ]
            }),
            n ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("dl", {
                        className: "gpr-dl",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                                className: "gpr-dl-row",
                                children: [
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("dt", {
                                        children: "Allele"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("dd", {
                                        children: [
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)(ti, {
                                                allele: n.allele
                                            }),
                                            " ",
                                            n.observed ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("code", {
                                                className: "gpr-seq",
                                                children: n.observed
                                            }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                className: "gpr-sub",
                                                children: "no sequence reported"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                                className: "gpr-dl-row",
                                children: [
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("dt", {
                                        children: "Copies"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("dd", {
                                        children: [
                                            v(n.orthologous_copies),
                                            " orthologous",
                                            n.paralog_copies ? `, ${v(n.paralog_copies)} paralog${n.paralog_copies === 1 ? "" : "s"}` : "",
                                            n.source ? ` \xb7 found by ${n.source}` : ""
                                        ]
                                    })
                                ]
                            }),
                            n.reason ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                                className: "gpr-dl-row",
                                children: [
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("dt", {
                                        children: "Reason"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("dd", {
                                        children: n.reason.replace(/_/g, " ")
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    n.copies.length ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                        className: "gpr-table-wrap",
                        children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("table", {
                            className: "gpr-table gpr-detail-table",
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("caption", {
                                    className: "gpr-caption",
                                    children: "Orthologous copies \xb7 the ortholog test uses gap-compressed identity"
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("thead", {
                                    children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                        children: [
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                                scope: "col",
                                                children: "Location"
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                                scope: "col",
                                                children: "Identity"
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                                scope: "col",
                                                children: "Gap-compressed"
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                                scope: "col",
                                                children: "Aligned"
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                                scope: "col",
                                                children: "Reads"
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                                scope: "col",
                                                children: "Call"
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                                scope: "col",
                                                children: "Source"
                                            })
                                        ]
                                    })
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("tbody", {
                                    children: n.copies.map((a, i)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                            children: [
                                                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("th", {
                                                    scope: "row",
                                                    children: [
                                                        a.region,
                                                        ":",
                                                        v(a.start),
                                                        "\u2013",
                                                        v(a.end),
                                                        " ",
                                                        a.strand === -1 ? "\u2212" : "+"
                                                    ]
                                                }),
                                                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("td", {
                                                    className: "gpr-num",
                                                    children: [
                                                        F(a.identity, 2),
                                                        " %"
                                                    ]
                                                }),
                                                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("td", {
                                                    className: "gpr-num",
                                                    children: [
                                                        F(a.gap_compressed_identity, 2),
                                                        " %"
                                                    ]
                                                }),
                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                    className: "gpr-num",
                                                    children: v(a.aligned_length)
                                                }),
                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                    children: a.observed ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("code", {
                                                        className: "gpr-seq",
                                                        children: a.observed
                                                    }) : "\u2013"
                                                }),
                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                    children: a.call ?? "\u2013"
                                                }),
                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                    children: a.source
                                                })
                                            ]
                                        }, `${a.region}-${a.start}-${i}`))
                                })
                            ]
                        })
                    }) : null
                ]
            }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                className: "gpr-hint",
                children: "This genome has not been called yet."
            })
        ]
    });
}
function El(e) {
    const { results: t, requestedGenomes: r, running: n, caption: a } = e, i = De("gpr-alleles"), [l, o] = (0, _react.useState)(!1), [d, p] = (0, _react.useState)(!1), [g, m] = (0, _react.useState)(null), [f, u] = (0, _react.useState)({
        r: 0,
        c: 0
    }), h = (0, _react.useRef)(/* @__PURE__ */ new Map()), y = t?.sets ?? [], _ = (0, _react.useMemo)(()=>wl(t, r), [
        t,
        r
    ]), k = (0, _react.useMemo)(()=>_.filter(($)=>{
            if (l && !$.hasDisagreement) return !1;
            if (d) {
                const L = !!$.allele && Nl($.allele), z = $.cells.some((K)=>!!K.prediction && kl(K.prediction.predicted));
                if (!L && !z) return !1;
            }
            return !0;
        }), [
        _,
        l,
        d
    ]), b = t?.summary ?? null, C = Math.max(0, k.length - 1), N = y.length, { r: w, c: R } = f, I = ($, L)=>{
        u({
            r: $,
            c: L
        }), h.current.get(`${$}:${L}`)?.focus();
    }, M = ($, L, z)=>{
        let K = L, S = z;
        switch($.key){
            case "ArrowRight":
                S = Math.min(N, z + 1);
                break;
            case "ArrowLeft":
                S = Math.max(0, z - 1);
                break;
            case "ArrowDown":
                K = Math.min(C, L + 1);
                break;
            case "ArrowUp":
                K = Math.max(0, L - 1);
                break;
            case "Home":
                S = 0, $.ctrlKey && (K = 0);
                break;
            case "End":
                S = N, $.ctrlKey && (K = C);
                break;
            case "Enter":
            case " ":
                $.preventDefault(), u({
                    r: L,
                    c: z
                }), m(k[L]?.system_name ?? null);
                return;
            case "Escape":
                g && ($.preventDefault(), m(null));
                return;
            default:
                return;
        }
        $.preventDefault(), I(K, S);
    }, P = g ? _.find(($)=>$.system_name === g) ?? null : null, V = y.filter(($)=>$.control.status !== "pass");
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(bt, {
        theme: e.theme,
        injectStyles: e.injectStyles,
        className: e.className,
        style: e.style,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
            className: "gpr-allele-matrix",
            children: [
                V.map(($)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                        className: "gpr-note",
                        role: "note",
                        "data-code": "REFERENCE_CONTROL_FAILED",
                        "data-status": $.control.status,
                        children: [
                            "Set ",
                            $.id,
                            ": the reference genome did not read its own allele (",
                            $.control.status,
                            "). Its other predictions are unreliable.",
                            $.control.reasons.length ? ` ${$.control.reasons.join(", ").replace(/_/g, " ")}.` : ""
                        ]
                    }, $.id)),
                b ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                    className: "gpr-readout",
                    children: n && b.genomes_total === 0 ? /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: "Calling alleles \u2014 genomes appear as they finish."
                    }) : /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            v(b.genomes_total),
                            " genome",
                            b.genomes_total === 1 ? "" : "s",
                            ": ",
                            v(b.ref),
                            " reference \xb7 ",
                            v(b.alt),
                            " alternative",
                            b.other ? ` \xb7 ${v(b.other)} a third allele` : "",
                            b.ambiguous ? ` \xb7 ${v(b.ambiguous)} ambiguous` : "",
                            b.missing ? ` \xb7 ${v(b.missing)} no comparable locus` : "",
                            b.unavailable ? ` \xb7 ${v(b.unavailable)} unavailable` : "",
                            _.length < b.genomes_total ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                className: "gpr-sub",
                                children: [
                                    " \xb7 ",
                                    v(_.length),
                                    " shown"
                                ]
                            }) : null
                        ]
                    })
                }) : null,
                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                    className: "gpr-matrix-toolbar",
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ie, {
                            id: `${i}-disagree`,
                            label: "Disagreements only",
                            checked: l,
                            onChange: o
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ie, {
                            id: `${i}-issues`,
                            label: "Issues only",
                            checked: d,
                            onChange: p
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                            className: "gpr-sub",
                            children: [
                                k.length,
                                " of ",
                                _.length,
                                " row",
                                _.length === 1 ? "" : "s"
                            ]
                        })
                    ]
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)(Al, {}),
                k.length ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                    className: "gpr-table-wrap gpr-matrix-wrap",
                    children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("table", {
                        role: "grid",
                        className: "gpr-table gpr-matrix gpr-allele-grid",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("caption", {
                                className: "gpr-caption",
                                children: [
                                    a ?? "Allele calls by genome",
                                    " \xb7 arrow keys move, Enter shows the copies"
                                ]
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("thead", {
                                children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                    children: [
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                            scope: "col",
                                            className: "gpr-matrix-corner",
                                            children: "Genome"
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                            scope: "col",
                                            className: "gpr-matrix-pair",
                                            children: "Allele"
                                        }),
                                        y.map(($)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("th", {
                                                scope: "col",
                                                className: "gpr-matrix-pair",
                                                children: [
                                                    $.id,
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                        className: "gpr-sub gpr-block",
                                                        children: $.orientation
                                                    }),
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "gpr-sub gpr-block",
                                                        children: [
                                                            v($.summary.agree),
                                                            "/",
                                                            v($.summary.agree + $.summary.disagree),
                                                            " agree"
                                                        ]
                                                    })
                                                ]
                                            }, $.id))
                                    ]
                                })
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("tbody", {
                                children: k.map(($, L)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                        "data-reference": $.is_reference ? "true" : void 0,
                                        children: [
                                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("th", {
                                                scope: "row",
                                                className: "gpr-matrix-genome",
                                                children: [
                                                    $.display_name,
                                                    $.is_reference ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                        className: "gpr-sub gpr-block",
                                                        children: "reference"
                                                    }) : null
                                                ]
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("td", {
                                                role: "gridcell",
                                                ref: (z)=>{
                                                    const K = `${L}:0`;
                                                    z ? h.current.set(K, z) : h.current.delete(K);
                                                },
                                                className: "gpr-cell gpr-allele-cell",
                                                "data-status": $.allele ?? "pending",
                                                tabIndex: L === w && R === 0 ? 0 : -1,
                                                "aria-label": Sl($),
                                                onClick: ()=>{
                                                    u({
                                                        r: L,
                                                        c: 0
                                                    }), m($.system_name);
                                                },
                                                onFocus: ()=>{
                                                    (L !== w || R !== 0) && u({
                                                        r: L,
                                                        c: 0
                                                    });
                                                },
                                                onKeyDown: (z)=>M(z, L, 0),
                                                children: [
                                                    $.allele ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(ti, {
                                                        allele: $.allele,
                                                        compact: !0
                                                    }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                        "aria-hidden": "true",
                                                        children: "\u2026"
                                                    }),
                                                    $.genome && $.genome.orthologous_copies > 1 ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("sup", {
                                                        className: "gpr-copies",
                                                        "aria-hidden": "true",
                                                        children: $.genome.orthologous_copies
                                                    }) : null
                                                ]
                                            }),
                                            $.cells.map((z, K)=>{
                                                const S = K + 1, T = z.prediction;
                                                return /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                    role: "gridcell",
                                                    ref: (W)=>{
                                                        const H = `${L}:${S}`;
                                                        W ? h.current.set(H, W) : h.current.delete(H);
                                                    },
                                                    className: "gpr-cell gpr-prediction-cell",
                                                    "data-status": T?.predicted ?? "pending",
                                                    "data-disagrees": ei(T) ? "true" : void 0,
                                                    tabIndex: L === w && S === R ? 0 : -1,
                                                    "aria-label": Cl($, z.set.id, T),
                                                    onClick: ()=>{
                                                        u({
                                                            r: L,
                                                            c: S
                                                        }), m($.system_name);
                                                    },
                                                    onFocus: ()=>{
                                                        (L !== w || S !== R) && u({
                                                            r: L,
                                                            c: S
                                                        });
                                                    },
                                                    onKeyDown: (W)=>M(W, L, S),
                                                    children: T ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                        children: [
                                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)(ks, {
                                                                predicted: T.predicted,
                                                                compact: !0
                                                            }),
                                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)(ni, {
                                                                agrees: T.agrees
                                                            }),
                                                            T.strength === "weak" ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                                className: "gpr-cell-flag",
                                                                "aria-hidden": "true",
                                                                title: "weak signal",
                                                                children: "~"
                                                            }) : null,
                                                            T.off_locus_products > 0 ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                                className: "gpr-cell-flag",
                                                                "aria-hidden": "true",
                                                                title: "off-locus products",
                                                                children: "\u26A0"
                                                            }) : null
                                                        ]
                                                    }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                        "aria-hidden": "true",
                                                        children: "\u2026"
                                                    })
                                                }, z.set.id);
                                            })
                                        ]
                                    }, $.system_name))
                            })
                        ]
                    })
                }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                    className: "gpr-hint",
                    children: n ? "No genomes have been called yet." : "No genomes match these filters."
                }),
                P ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(Tl, {
                    row: P,
                    headingId: `${i}-detail-h`,
                    onClose: ()=>{
                        m(null), h.current.get(`${w}:${R}`)?.focus();
                    }
                }) : null,
                P && P.cells.some(($)=>$.prediction) ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                    className: "gpr-table-wrap",
                    children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("table", {
                        className: "gpr-table gpr-detail-table",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("caption", {
                                className: "gpr-caption",
                                children: [
                                    "How each set behaves in ",
                                    P.display_name
                                ]
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("thead", {
                                children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                    children: [
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                            scope: "col",
                                            children: "Set"
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                            scope: "col",
                                            children: "Predicted"
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                            scope: "col",
                                            children: "REF primer"
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                            scope: "col",
                                            children: "ALT primer"
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                            scope: "col",
                                            children: "Common primer"
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                            scope: "col",
                                            children: "Reasons"
                                        })
                                    ]
                                })
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("tbody", {
                                children: P.cells.map(($)=>{
                                    const L = $.prediction;
                                    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                        children: [
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                                scope: "row",
                                                children: $.set.id
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                children: L ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(ks, {
                                                    predicted: L.predicted,
                                                    detail: L.strength ?? void 0
                                                }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                    className: "gpr-sub",
                                                    children: "not called yet"
                                                })
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                children: L ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(wn, {
                                                    status: L.ref_primer.status,
                                                    context: "REF primer"
                                                }) : "\u2013"
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                children: L ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(wn, {
                                                    status: L.alt_primer.status,
                                                    context: "ALT primer"
                                                }) : "\u2013"
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                children: L ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(wn, {
                                                    status: L.common_primer.status,
                                                    context: "Common primer"
                                                }) : "\u2013"
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                children: L?.reasons.length ? L.reasons.join(", ").replace(/_/g, " ") : "\u2013"
                                            })
                                        ]
                                    }, $.set.id);
                                })
                            })
                        ]
                    })
                }) : null
            ]
        })
    });
}
const pr = Object.freeze({
    softmask: "RepeatMasker soft-mask",
    blast_depth: "BLAST copy-number heuristic",
    user_lowercase: "lowercase letters in the pasted sequence"
}), Il = Object.freeze({
    soft_masked: "soft-masked by RepeatMasker",
    unmasked_copy: "no real soft-mask (the soft-masked FASTA is an unmasked copy)",
    absent: "no soft-masked FASTA"
});
function $l(e, t, r) {
    return e === "sequence" ? r ? "user_lowercase" : null : t ? t.repeat_masking === "soft_masked" ? "softmask" : "blast_depth" : null;
}
function ri(e) {
    const [t, r] = (0, _react.useState)(!1), n = $l(e.mode, e.genome, e.hasLowercase), a = e.template && e.template.mode === e.mode ? e.template : null, i = a?.mask_source ?? null, l = i ?? n, o = `${e.idPrefix}-maskmode`, d = `${e.idPrefix}-maskmode-legend`, p = `${e.idPrefix}-help-repeat_masking`;
    let g;
    return l ? g = /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            "Mask source: ",
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("strong", {
                className: "gpr-mask-source-name",
                children: pr[l]
            }),
            l === "blast_depth" ? " \u2014 it also masks multi-copy gene families, not only repeats." : "."
        ]
    }) : e.mode === "sequence" ? g = "Pasted sequences are masked only where you type lowercase letters." : g = "Mask source: not known until the genome list has loaded.", /* @__PURE__ */ (0, _jsxRuntime.jsxs)("fieldset", {
        className: "gpr-fieldset",
        disabled: e.disabled,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("legend", {
                className: "gpr-legend",
                children: "Repeats"
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ie, {
                id: `${e.idPrefix}-avoid-repeats`,
                label: "Avoid repeats",
                checked: e.avoidRepeats,
                onChange: (m)=>e.onChange({
                        avoidRepeats: m
                    })
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("fieldset", {
                className: "gpr-subfieldset",
                disabled: e.disabled || !e.avoidRepeats,
                "aria-labelledby": d,
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("legend", {
                        className: "gpr-legend gpr-legend-small",
                        children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                            className: "gpr-label-row",
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                    id: d,
                                    children: "Masked bases"
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)(qr, {
                                    subject: "Masked bases",
                                    expanded: t,
                                    controls: p,
                                    onToggle: ()=>r((m)=>!m)
                                })
                            ]
                        })
                    }),
                    t ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                        id: p,
                        className: "gpr-hint gpr-help-text",
                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(zt, {
                            topic: "repeat_masking"
                        })
                    }) : null,
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                        className: "gpr-radio-row",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                                type: "radio",
                                className: "gpr-radio",
                                id: `${o}-n`,
                                name: o,
                                value: "n_mask",
                                checked: e.repeatMaskMode !== "three_prime",
                                onChange: ()=>e.onChange({
                                        repeatMaskMode: "n_mask"
                                    })
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("label", {
                                className: "gpr-label gpr-label-inline",
                                htmlFor: `${o}-n`,
                                children: "Replace with N: no primer may overlap a repeat"
                            })
                        ]
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                        className: "gpr-radio-row",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                                type: "radio",
                                className: "gpr-radio",
                                id: `${o}-3p`,
                                name: o,
                                value: "three_prime",
                                checked: e.repeatMaskMode === "three_prime",
                                onChange: ()=>e.onChange({
                                        repeatMaskMode: "three_prime"
                                    })
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("label", {
                                className: "gpr-label gpr-label-inline",
                                htmlFor: `${o}-3p`,
                                children: "Keep, but no primer 3\u2032 end in a repeat"
                            })
                        ]
                    })
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                className: "gpr-hint gpr-mask-source",
                "data-source": l ?? "none",
                children: g
            }),
            e.genome && e.mode !== "sequence" ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-hint",
                children: [
                    e.genome.display_name || e.genome.system_name,
                    ": ",
                    Il[e.genome.repeat_masking] ?? e.genome.repeat_masking,
                    "."
                ]
            }) : null,
            a && i ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-readout",
                children: [
                    "Last template: ",
                    Ma(a.masked_fraction ?? 0),
                    " masked (",
                    pr[i],
                    ")."
                ]
            }) : null
        ]
    });
}
const Rl = [
    "kasp",
    "as_pcr"
].map((e)=>({
        id: e,
        label: nr[e].label,
        description: nr[e].description
    })), Ml = [
    {
        label: "Primer size",
        unit: "nt",
        keys: [
            "min_size",
            "opt_size",
            "max_size"
        ]
    },
    {
        label: "Melting temperature",
        unit: "\xb0C",
        keys: [
            "min_tm",
            "opt_tm",
            "max_tm"
        ]
    },
    {
        label: "GC content",
        unit: "%",
        keys: [
            "min_gc",
            "opt_gc",
            "max_gc"
        ]
    }
], Pl = [
    {
        key: "max_tm_diff",
        label: "Max Tm difference (\xb0C)"
    },
    {
        key: "max_poly_x",
        label: "Max mononucleotide run (nt)"
    },
    {
        key: "gc_clamp",
        label: "GC clamp (3\u2032 G/C bases)"
    },
    {
        key: "max_end_stability",
        label: "Max 3\u2032 end stability (kcal/mol)"
    },
    {
        key: "salt_monovalent",
        label: "Monovalent cations (mM)"
    },
    {
        key: "salt_divalent",
        label: "Divalent cations (mM)"
    },
    {
        key: "dntp_conc",
        label: "dNTP (mM)"
    },
    {
        key: "dna_conc",
        label: "Oligo DNA (nM)"
    }
];
function Ol(e) {
    const [t, r] = (0, _react.useState)(!1), n = oa(e.assay), a = fr(n.type), i = e.params ?? {}, l = new Set(e.settings?.pinned ?? []), o = (m)=>e.issues.filter((f)=>f.field === m), d = (m)=>`${e.idPrefix}-gt-${m}`, p = (m, f, u, h, y = !1)=>{
        const _ = d(String(m)), k = `${_}-hint`;
        return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
            className: "gpr-field",
            children: [
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("label", {
                    className: "gpr-label",
                    htmlFor: _,
                    children: f
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("select", {
                    id: _,
                    className: "gpr-select",
                    value: String(n[m]),
                    disabled: e.disabled,
                    "aria-describedby": h ? k : void 0,
                    onChange: (b)=>e.onAssay({
                            [m]: y ? Number(b.target.value) : b.target.value
                        }),
                    children: u.map(([b, C])=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("option", {
                            value: b,
                            children: C
                        }, b))
                }),
                h ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                    id: k,
                    className: "gpr-hint",
                    children: h
                }) : null
            ]
        });
    }, g = (m, f)=>{
        const u = Tn[m], h = i[m], y = Ci[m];
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(mt, {
            id: d(`param-${m}`),
            label: f,
            value: typeof h == "number" ? h : void 0,
            placeholder: typeof y == "number" ? String(y) : "",
            min: u.min,
            max: u.max,
            step: u.integer ? 1 : "any",
            issues: o(m),
            changed: typeof h == "number",
            disabled: e.disabled,
            hint: l.has(m) ? "Pinned: this value was sent, so it was never relaxed." : void 0,
            onChange: (_)=>e.onParam(m, _)
        }, m);
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: "gpr-assay-options",
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(za, {
                idPrefix: `${e.idPrefix}-assay`,
                legend: "Assay",
                options: Rl,
                value: n.type,
                onChange: (m)=>e.onAssay({
                        type: m
                    })
            }),
            e.emsTarget ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                className: "gpr-note",
                role: "note",
                "data-code": "EMS_TARGET",
                children: "This is an EMS mutation, private to one mutant line. Natural variants nearby warn instead of blocking a primer."
            }) : null,
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("fieldset", {
                className: "gpr-fieldset gpr-assay-fieldset",
                disabled: e.disabled,
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("legend", {
                        className: "gpr-legend gpr-legend-small",
                        children: "Assay options"
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                        className: "gpr-field-grid",
                        children: [
                            p("orientation", "Orientation", [
                                [
                                    "both",
                                    "Both"
                                ],
                                [
                                    "forward",
                                    "Forward only"
                                ],
                                [
                                    "reverse",
                                    "Reverse only"
                                ]
                            ], "An orientation you do not ask for is reported as skipped."),
                            n.type === "kasp" || t ? p("tails", "Tails", [
                                [
                                    "ref_fam_alt_hex",
                                    "REF \u2192 FAM, ALT \u2192 HEX"
                                ],
                                [
                                    "ref_hex_alt_fam",
                                    "REF \u2192 HEX, ALT \u2192 FAM"
                                ],
                                [
                                    "none",
                                    "No tails"
                                ]
                            ], "The tail is never part of a check; it is only synthesized.") : null,
                            p("deliberate_mismatch", "Deliberate mismatch", [
                                [
                                    "none",
                                    "None"
                                ],
                                [
                                    "auto",
                                    "Add automatically"
                                ]
                            ], "A second mismatch near the 3\u2032 end sharpens discrimination."),
                            p("mismatch_position", "Mismatch position", [
                                [
                                    "2",
                                    "\u22122 (Little 1995)"
                                ],
                                [
                                    "3",
                                    "\u22123 (extrapolated)"
                                ]
                            ], "Little (1995) is defined for \u22122; \u22123 is extrapolated from it.", !0),
                            p("neighbour_policy", "Known variants at the 3\u2032 end", [
                                [
                                    "avoid_3p",
                                    "Avoid them"
                                ],
                                [
                                    "ignore",
                                    "Allow, and report as an issue"
                                ]
                            ]),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)(mt, {
                                id: d("num_sets"),
                                label: "Sets to design",
                                value: n.num_sets,
                                min: ye.minSets,
                                max: ye.maxSets,
                                step: 1,
                                disabled: e.disabled,
                                changed: n.num_sets !== a.num_sets,
                                hint: `${ye.minSets}\u{2013}${ye.maxSets}; at most 5 can be checked at once.`,
                                onChange: (m)=>e.onAssay({
                                        num_sets: m ?? a.num_sets
                                    })
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)(mt, {
                                id: d("max_relaxation"),
                                label: "Relaxation levels allowed",
                                value: n.max_relaxation,
                                min: 0,
                                max: ye.maxRelaxation,
                                step: 1,
                                disabled: e.disabled,
                                changed: n.max_relaxation !== a.max_relaxation,
                                hint: "How far the constraints may be loosened when no set is found.",
                                onChange: (m)=>e.onAssay({
                                        max_relaxation: m ?? a.max_relaxation
                                    })
                            })
                        ]
                    })
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(ri, {
                idPrefix: `${e.idPrefix}-gt`,
                mode: "region",
                avoidRepeats: !!e.avoidRepeats,
                repeatMaskMode: e.repeatMaskMode ?? "n_mask",
                onChange: e.onRepeats,
                genome: e.genome ?? null,
                template: null,
                hasLowercase: !1,
                disabled: e.disabled
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("details", {
                className: "gpr-details gpr-assay-advanced",
                onToggle: (m)=>r(m.currentTarget.open),
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("summary", {
                        className: "gpr-summary",
                        children: "Primer3 parameters"
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                        className: "gpr-hint",
                        children: "An empty field uses the value shown in grey and may be relaxed. A value you enter is pinned: the server keeps it exactly, at every relaxation level."
                    }),
                    Ml.map((m)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("fieldset", {
                            className: "gpr-subfieldset gpr-triple",
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("legend", {
                                    className: "gpr-legend gpr-legend-small",
                                    children: [
                                        m.label,
                                        " (",
                                        m.unit,
                                        ")"
                                    ]
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                                    className: "gpr-triple-grid",
                                    children: m.keys.map((f)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _react.Fragment), {
                                            children: g(f, f.startsWith("min") ? "Min" : f.startsWith("opt") ? "Optimum" : "Max")
                                        }, f))
                                })
                            ]
                        }, m.label)),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                        className: "gpr-field-grid",
                        children: Pl.map((m)=>g(m.key, m.label))
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                        className: "gpr-button-row",
                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "gpr-btn gpr-btn-small",
                            disabled: e.disabled || !e.params,
                            onClick: e.onResetParams,
                            children: "Reset parameters"
                        })
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("dl", {
                        className: "gpr-dl gpr-assay-limits",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                                className: "gpr-dl-row",
                                children: [
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("dt", {
                                        children: "Hard floors"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("dd", {
                                        children: [
                                            "allele-specific Tm at least ",
                                            F(Vr.as_min_tm, 0),
                                            " \xb0C, GC at least ",
                                            F(Vr.as_min_gc, 0),
                                            " %"
                                        ]
                                    })
                                ]
                            }),
                            (e.settings?.ladder ?? Si).map((m)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                                    className: "gpr-dl-row",
                                    children: [
                                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("dt", {
                                            children: [
                                                "Relaxation level ",
                                                m.level
                                            ]
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("dd", {
                                            children: Object.entries(m.changes).map(([f, u])=>`${f} ${Array.isArray(u) ? u.map((h)=>Array.isArray(h) ? h.join("\u2013") : h).join(", ") : u}`).join(" \xb7 ")
                                        })
                                    ]
                                }, m.level))
                        ]
                    })
                ]
            })
        ]
    });
}
const As = {
    status: "idle",
    response: null,
    responseRequest: null,
    responseMeta: null,
    request: null,
    error: null,
    busy: null
};
function zl(e, t) {
    const [r, n] = (0, _react.useState)(As), a = (0, _react.useRef)(null), i = (0, _react.useRef)(0), l = (0, _react.useRef)(null), o = (0, _react.useRef)(t);
    Gt(()=>{
        o.current = t;
    });
    const d = typeof e.designGenotyping == "function", p = (0, _react.useCallback)(()=>{
        a.current?.abort(), a.current = null, i.current += 1;
    }, []), g = (0, _react.useCallback)(async (h, y)=>{
        if (typeof e.designGenotyping != "function") {
            const C = new He({
                status: 501,
                code: "NOT_SUPPORTED",
                message: "This server cannot design genotyping assays."
            });
            n((N)=>({
                    ...N,
                    status: "error",
                    error: C,
                    busy: null
                })), o.current.onError?.(C);
            return;
        }
        a.current?.abort();
        const _ = new AbortController();
        a.current = _;
        const k = ++i.current;
        n((C)=>({
                ...C,
                status: "running",
                request: h,
                error: null,
                busy: null
            }));
        let b = 0;
        for(;;)try {
            const C = await e.designGenotyping(h, {
                signal: _.signal
            });
            if (k !== i.current) return;
            a.current = null;
            const N = l.current;
            y.templateOnly || (l.current = C), n({
                status: "done",
                response: C,
                responseRequest: h,
                responseMeta: y,
                request: h,
                error: null,
                busy: null
            }), o.current.onSuccess?.(C, h, y, N);
            return;
        } catch (C) {
            if (k !== i.current || _.signal.aborted || Ue(C)) return;
            if (Me(C) && C.code === "BUSY" && b < nn) {
                b += 1;
                const N = C.retryAfterMs ?? $a;
                n((w)=>({
                        ...w,
                        busy: {
                            attempt: b,
                            max: nn,
                            retryAt: Date.now() + N,
                            error: C
                        }
                    }));
                try {
                    await Cn(N, _.signal);
                } catch  {
                    return;
                }
                if (k !== i.current) return;
                continue;
            }
            a.current = null, n((N)=>({
                    ...N,
                    status: "error",
                    error: C,
                    busy: null
                })), Me(C) && o.current.onError?.(C);
            return;
        }
    }, [
        e
    ]), m = (0, _react.useCallback)(()=>{
        p(), n((h)=>({
                ...h,
                status: h.response ? "done" : "idle",
                request: h.responseRequest,
                error: null,
                busy: null
            }));
    }, [
        p
    ]), f = (0, _react.useCallback)(()=>{
        p(), l.current = null, n(As);
    }, [
        p
    ]), u = (0, _react.useCallback)(()=>{
        n((h)=>h.status === "error" ? {
                ...h,
                status: h.response ? "done" : "idle",
                error: null
            } : h);
    }, []);
    return (0, _react.useEffect)(()=>()=>a.current?.abort(), []), {
        state: r,
        run: g,
        cancel: m,
        reset: f,
        abort: p,
        clearError: u,
        supported: d
    };
}
function it({ text: e, label: t, children: r, className: n }) {
    const [a, i] = (0, _react.useState)("idle"), l = Qa(), o = (0, _react.useRef)(void 0);
    (0, _react.useEffect)(()=>()=>clearTimeout(o.current), []);
    const d = async ()=>{
        const p = typeof e == "function" ? e() : e, g = await Ja(p);
        i(g ? "copied" : "failed"), l(g ? "Copied to the clipboard" : "Copy failed"), clearTimeout(o.current), o.current = setTimeout(()=>i("idle"), 1500);
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
        type: "button",
        className: Pe("gpr-btn", "gpr-btn-small", "gpr-copy", n),
        "aria-label": t,
        title: t,
        "data-state": a === "idle" ? void 0 : a,
        onClick: d,
        children: a === "copied" ? "Copied" : a === "failed" ? "Failed" : r ?? "Copy"
    });
}
const Ll = {
    as_ref: "REF",
    as_alt: "ALT",
    common: "Common"
};
function ql(e) {
    const { sets: t, kaspMix: r, submissionSequence: n, results: a, label: i } = e, l = De("gpr-order"), o = t.flatMap((g)=>g.order ?? []), d = i || o[0]?.variant_key?.replace(/[^A-Za-z0-9_.-]+/g, "_") || "primers", p = [];
    return o.length && (p.push({
        id: "order-tsv",
        label: "Order sheet (TSV)",
        filename: `${d}-order.tsv`,
        mime: "text/tab-separated-values",
        build: ()=>Lo(t, {
                kaspMix: r,
                submissionSequence: n
            })
    }), p.push({
        id: "order-fasta",
        label: "Primers (FASTA)",
        filename: `${d}-primers.fa`,
        mime: "text/plain",
        build: ()=>qo(t)
    })), a && p.push({
        id: "genotype-calls",
        label: "Genotype calls (TSV)",
        filename: `${d}-genotypes.tsv`,
        mime: "text/tab-separated-values",
        build: ()=>Do(a)
    }), /* @__PURE__ */ (0, _jsxRuntime.jsx)(bt, {
        theme: e.theme,
        injectStyles: e.injectStyles,
        className: e.className,
        style: e.style,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
            className: "gpr-order-sheet",
            children: [
                r ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                    className: "gpr-order-note",
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("strong", {
                            children: "KASP mix:"
                        }),
                        " ",
                        F(r.as_ref_uL, 0),
                        " \xb5L REF + ",
                        F(r.as_alt_uL, 0),
                        " \xb5L ALT + ",
                        F(r.common_uL, 0),
                        " \xb5L common at",
                        " ",
                        F(r.stock_uM, 0),
                        " \xb5M + ",
                        F(r.water_uL, 0),
                        " \xb5L water = ",
                        F(r.total_uL, 0),
                        " \xb5L",
                        " ",
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                            className: "gpr-sub",
                            children: [
                                "(",
                                r.source,
                                ")"
                            ]
                        })
                    ]
                }) : null,
                n ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                    className: "gpr-order-note gpr-submission",
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("strong", {
                            children: "Submission sequence:"
                        }),
                        " ",
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("code", {
                            className: "gpr-seq",
                            children: n
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)(it, {
                            text: n,
                            label: "Copy the submission sequence"
                        })
                    ]
                }) : null,
                o.length ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                    className: "gpr-table-wrap",
                    children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("table", {
                        className: "gpr-table gpr-order-table",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("caption", {
                                className: "gpr-caption",
                                children: [
                                    v(o.length),
                                    " oligo",
                                    o.length === 1 ? "" : "s",
                                    " \xb7 order the ",
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("strong", {
                                        children: "order sequence"
                                    }),
                                    "; the target sequence is what anneals"
                                ]
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("thead", {
                                children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                    children: [
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                            scope: "col",
                                            children: "Name"
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                            scope: "col",
                                            children: "Set"
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                            scope: "col",
                                            children: "Role"
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                            scope: "col",
                                            children: "Dye"
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                            scope: "col",
                                            children: "Order sequence 5\u2032\u21923\u2032"
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                            scope: "col",
                                            children: "Target sequence 5\u2032\u21923\u2032"
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                            scope: "col",
                                            children: "nt"
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                            scope: "col",
                                            children: "Tm \xb0C"
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                            scope: "col",
                                            children: "GC %"
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                            scope: "col",
                                            children: "Notes"
                                        })
                                    ]
                                })
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("tbody", {
                                children: o.map((g)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                        className: "gpr-order-row",
                                        "data-role": g.role,
                                        children: [
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                                scope: "row",
                                                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("code", {
                                                    className: "gpr-code",
                                                    children: g.name
                                                })
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                children: g.set_id
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("td", {
                                                children: [
                                                    Ll[g.role],
                                                    g.allele ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                        className: "gpr-sub gpr-block",
                                                        children: g.allele
                                                    }) : null
                                                ]
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                children: g.dye ?? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                    className: "gpr-sub",
                                                    children: "\u2013"
                                                })
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("td", {
                                                className: "gpr-order-seq",
                                                children: [
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("code", {
                                                        className: "gpr-seq",
                                                        children: g.order_seq
                                                    }),
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(it, {
                                                        text: g.order_seq,
                                                        label: `Copy the order sequence of ${g.name}`
                                                    })
                                                ]
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                className: "gpr-order-seq",
                                                children: g.order_seq === g.target_seq ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                    className: "gpr-sub",
                                                    children: "same"
                                                }) : /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("code", {
                                                            className: "gpr-seq",
                                                            children: g.target_seq
                                                        }),
                                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)(it, {
                                                            text: g.target_seq,
                                                            label: `Copy the target sequence of ${g.name}`
                                                        })
                                                    ]
                                                })
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                className: "gpr-num",
                                                children: v(g.length)
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                className: "gpr-num",
                                                children: F(g.tm, 1)
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                className: "gpr-num",
                                                children: F(g.gc, 0)
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                className: "gpr-order-notes",
                                                children: g.notes || /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                    className: "gpr-sub",
                                                    children: "\u2013"
                                                })
                                            })
                                        ]
                                    }, g.name))
                            })
                        ]
                    })
                }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                    className: "gpr-hint",
                    children: "Design a set to see the oligos to order."
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)(Za, {
                    items: p,
                    idPrefix: l
                })
            ]
        })
    });
}
const Gl = Object.freeze({
    ok: {
        glyph: "\u2713",
        label: "Sets found",
        tone: "ok"
    },
    blocked: {
        glyph: "\u2717",
        label: "Blocked",
        tone: "bad"
    },
    skipped: {
        glyph: "\u2013",
        label: "Skipped",
        tone: "muted"
    },
    no_sets: {
        glyph: "!",
        label: "No sets",
        tone: "warn"
    }
}), Dl = Object.freeze({
    not_requested: "You asked for the other orientation only.",
    too_close_to_end: "The variant is too close to the end of the sequence for a product.",
    n_in_window: "The allele-specific window contains an N.",
    budget_exhausted: "The design ran out of budget before scoring this orientation.",
    neighbour_at_3p: "A known variant sits in the last few bases of the allele-specific primer.",
    no_candidates: "Primer3 returned no usable candidate in this orientation."
});
function jl(e) {
    return Gl[e] ?? {
        glyph: "?",
        label: e,
        tone: "muted"
    };
}
function Ul(e) {
    return Object.entries(e).map(([t, r])=>t === "product_size_ranges" && Array.isArray(r) ? `product ${r.map((n)=>Array.isArray(n) ? `${n[0]}\u{2013}${n[1]}` : String(n)).join(", ")}` : `${t} ${String(r)}`).join(" \xb7 ");
}
function Fl({ attempt: e, orientation: t, idPrefix: r }) {
    const [n, a] = (0, _react.useState)(!1), i = Object.entries(e.rejected).filter(([, o])=>o > 0), l = i.reduce((o, [, d])=>o + d, 0) + e.not_scored + e.sets;
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: "gpr-orientation-attempt",
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-orientation-attempt-head",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("strong", {
                        children: [
                            "Level ",
                            e.level
                        ]
                    }),
                    Object.keys(e.changes).length ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                        className: "gpr-orientation-changes",
                        children: [
                            " \u2014 ",
                            Ul(e.changes)
                        ]
                    }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                        className: "gpr-sub",
                        children: " \u2014 no relaxation"
                    })
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-sub",
                children: [
                    v(e.pairs_returned),
                    " candidate",
                    e.pairs_returned === 1 ? "" : "s",
                    " from Primer3 \xb7 ",
                    v(e.sets),
                    " usable set",
                    e.sets === 1 ? "" : "s",
                    e.not_scored ? ` \xb7 ${v(e.not_scored)} not scored` : "",
                    l !== e.pairs_returned ? ` \xb7 ${v(e.pairs_returned - l)} unaccounted` : ""
                ]
            }),
            i.length ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("ul", {
                className: "gpr-plain-list gpr-orientation-rejected",
                children: i.map(([o, d])=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("li", {
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                className: "gpr-orientation-reason",
                                children: o.replace(/_/g, " ")
                            }),
                            " ",
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                className: "gpr-explain-count",
                                children: v(d)
                            })
                        ]
                    }, o))
            }) : null,
            e.explain ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ya, {
                explain: e.explain,
                open: n,
                onToggle: a,
                noPairs: e.sets === 0,
                idPrefix: `${r}-l${e.level}`,
                title: `Primer3 explain \u{2014} ${t}, level ${e.level}`
            }) : null
        ]
    });
}
function Cs({ orientation: e, report: t, idPrefix: r }) {
    const n = jl(t.status), a = `${r}-${e}-h`;
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("section", {
        className: "gpr-orientation-card",
        "data-status": t.status,
        "aria-labelledby": a,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                className: "gpr-orientation-head",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("h4", {
                        className: "gpr-h4",
                        id: a,
                        children: e === "forward" ? "Forward" : "Reverse"
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                        className: Pe("gpr-chip", `gpr-chip-${n.tone}`),
                        "data-status": t.status,
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                className: "gpr-chip-glyph",
                                "aria-hidden": "true",
                                children: n.glyph
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                className: "gpr-chip-text",
                                children: n.label
                            })
                        ]
                    })
                ]
            }),
            t.reason ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                className: "gpr-orientation-why",
                children: Dl[t.reason] ?? t.reason.replace(/_/g, " ")
            }) : null,
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-sub",
                children: [
                    "Discriminating base at ",
                    v(t.discriminating_position),
                    t.relaxation_level != null ? ` \xb7 relaxation level ${t.relaxation_level}` : "",
                    " \xb7 ",
                    v(t.sets_found),
                    " set",
                    t.sets_found === 1 ? "" : "s",
                    " found"
                ]
            }),
            t.blockers.length ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("ul", {
                className: "gpr-plain-list gpr-orientation-blockers",
                children: t.blockers.map((i)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("li", {
                        children: [
                            "blocked by ",
                            i.ids[0] ?? i.label,
                            " (",
                            i.alleles,
                            "), ",
                            i.distance_from_3p,
                            " nt from the 3\u2032 end",
                            i.ems ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                className: "gpr-sub",
                                children: " \xb7 EMS"
                            }) : null
                        ]
                    }, i.key))
            }) : null,
            t.attempts.length ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                className: "gpr-orientation-attempts",
                children: t.attempts.map((i)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)(Fl, {
                        attempt: i,
                        orientation: e,
                        idPrefix: `${r}-${e}`
                    }, i.level))
            }) : null
        ]
    });
}
function Bl({ orientations: e }) {
    const t = De("gpr-orient");
    return e ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: "gpr-orientation-explain",
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(Cs, {
                orientation: "forward",
                report: e.forward,
                idPrefix: t
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(Cs, {
                orientation: "reverse",
                report: e.reverse,
                idPrefix: t
            })
        ]
    }) : null;
}
function sn({ geneId: e, systemName: t, geneHref: r, onGeneClick: n }) {
    const a = t ?? void 0;
    return r ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("a", {
        className: "gpr-link",
        href: r(e, a),
        onClick: n ? (i)=>{
            i.button !== 0 || i.metaKey || i.ctrlKey || i.shiftKey || i.altKey || (i.preventDefault(), n(e, a));
        } : void 0,
        children: e
    }) : n ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
        type: "button",
        className: "gpr-link-button",
        onClick: ()=>n(e, a),
        children: e
    }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
        className: "gpr-gene-id",
        children: e
    });
}
function Kl(e, t, r) {
    const n = [], a = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Map();
    for (const d of r ?? [])i.set(d.system_name, d.display_name || d.system_name);
    const l = (d, p)=>{
        a.has(d) || (a.add(d), n.push(d)), p && i.set(d, p);
    };
    for (const d of t ?? [])typeof d == "string" ? l(d) : l(d.system_name, d.display_name);
    for (const d of e)for (const p of d.genomes ?? [])l(p.system_name, p.display_name);
    const o = e.map((d)=>new Map((d.genomes ?? []).map((p)=>[
                p.system_name,
                p
            ])));
    return n.map((d)=>{
        const p = o.map((m)=>{
            const f = m.get(d) ?? null;
            return {
                status: f ? f.status : "pending",
                result: f
            };
        }), g = p.reduce((m, f)=>Math.max(m, ft[f.status]?.severity ?? 0), -1);
        return {
            system_name: d,
            display_name: i.get(d) ?? d,
            cells: p,
            worst: g
        };
    });
}
function Hl(e) {
    const t = ft[e.status];
    if (!e.result) return {
        glyph: t.glyph,
        text: ""
    };
    const r = Ko(e.result);
    return e.status === "multiple" ? {
        glyph: r || t.glyph,
        text: ""
    } : {
        glyph: t.glyph,
        text: r
    };
}
function Vl(e, t, r) {
    const n = [
        e.display_name,
        t,
        ft[r.status].label
    ], a = r.result;
    if (a) {
        const i = a.primary;
        a.status === "single_perfect" && typeof i?.size_delta == "number" && n.push(`size difference ${i.size_delta} bp`), a.status === "single_mismatch" && i?.terminal_mismatch ? n.push("mismatch at the 3\u2032 end") : a.status === "single_mismatch" && i?.mismatch_in_3p_window && n.push("mismatch in the 3\u2032 window"), a.status === "multiple" && n.push(`${1 + (a.other_amplicons ?? a.others?.length ?? 1)} amplicons`), a.status === "no_amplicon" && a.ortholog_annotated === !1 && n.push("no ortholog annotated"), a.status === "no_amplicon" && a.nearest && n.push("closest product not expected to amplify"), a.truncated && n.push("search incomplete");
    }
    return n.join(", ");
}
const Xt = "\u22EF";
function Un(e, t) {
    const r = e.region != null && typeof e.start == "number" && typeof e.end == "number" ? Zt(String(e.region), e.start, e.end, e.strand ?? null) : e.gene_id ?? t, n = typeof e.size_min == "number" && typeof e.size_max == "number" && e.size_min !== e.size_max ? `${v(e.size_min)}\u{2013}${v(e.size_max)}` : v(e.size);
    return `${r}, ${n} bp`;
}
function Ss(e, t) {
    return e.likelihood === "unlikely" ? Er(Tr(e, t), t) : e.likelihood?.replace("_", " ");
}
function Wl() {
    const e = [
        ...Rr,
        "pending"
    ];
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("ul", {
        className: "gpr-legend",
        "aria-label": "Pan-genome status legend",
        children: [
            e.map((t)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("li", {
                    className: "gpr-legend-item",
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                            className: `gpr-status gpr-status-${t}`,
                            "aria-hidden": "true",
                            children: ft[t].glyph
                        }),
                        " ",
                        ft[t].label
                    ]
                }, t)),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("li", {
                className: "gpr-legend-item",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                        className: "gpr-cell-flag",
                        "aria-hidden": "true",
                        children: Xt
                    }),
                    " ",
                    "Search incomplete (a result cap was hit)"
                ]
            })
        ]
    });
}
function Yl(e) {
    const { row: t, pairLabel: r, cell: n, headingId: a, onClose: i, geneHref: l, onGeneClick: o, params: d } = e, p = ft[n.status], g = n.result, m = g?.primary ?? null, f = g?.other_amplicons ?? g?.others?.length ?? 0, u = g?.error ? typeof g.error == "string" ? g.error : g.error.message : null;
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("section", {
        className: "gpr-cell-detail",
        "aria-labelledby": a,
        "aria-live": "polite",
        "data-status": n.status,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("h4", {
                className: "gpr-h4",
                id: a,
                children: [
                    t.display_name,
                    " \xb7 ",
                    r
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-cell-detail-status",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                        className: `gpr-status gpr-status-${n.status}`,
                        "aria-hidden": "true",
                        children: p.glyph
                    }),
                    " ",
                    p.label,
                    t.display_name !== t.system_name ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                        className: "gpr-sub",
                        children: [
                            " (",
                            t.system_name,
                            ")"
                        ]
                    }) : null
                ]
            }),
            m ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("dl", {
                className: "gpr-dl",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                        className: "gpr-dl-row",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("dt", {
                                children: "Product"
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("dd", {
                                children: [
                                    Un(m, t.system_name),
                                    typeof m.size_delta == "number" ? ` (${m.size_delta > 0 ? "+" : ""}${m.size_delta} bp vs the reference)` : ""
                                ]
                            })
                        ]
                    }),
                    m.gene_id ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                        className: "gpr-dl-row",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("dt", {
                                children: "Transcript model"
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("dd", {
                                children: [
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(sn, {
                                        geneId: m.gene_id,
                                        systemName: t.system_name,
                                        geneHref: l,
                                        onGeneClick: o
                                    }),
                                    m.isoforms?.length ? ` (${m.isoforms.map((h)=>h.transcript_id).join(", ")})` : ""
                                ]
                            })
                        ]
                    }) : null,
                    m.orientation || m.likelihood ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                        className: "gpr-dl-row",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("dt", {
                                children: "Orientation, likelihood"
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("dd", {
                                children: [
                                    m.orientation,
                                    Ss(m, d)
                                ].filter(Boolean).join(", ")
                            })
                        ]
                    }) : null,
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                        className: "gpr-dl-row",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("dt", {
                                children: "Mismatches"
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("dd", {
                                children: [
                                    "left ",
                                    m.left_mm ?? "\u2013",
                                    " (",
                                    m.left_3p_mm ?? "\u2013",
                                    " in the 3\u2032 window), right ",
                                    m.right_mm ?? "\u2013",
                                    " (",
                                    m.right_3p_mm ?? "\u2013",
                                    " in the 3\u2032 window)",
                                    m.terminal_mismatch ? "; terminal 3\u2032 mismatch" : m.mismatch_in_3p_window ? "; mismatch in the 3\u2032 window" : "",
                                    m.approx ? "; approximate (from the BLAST alignment)" : ""
                                ]
                            })
                        ]
                    }),
                    m.genes?.length ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                        className: "gpr-dl-row",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("dt", {
                                children: "Genes"
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("dd", {
                                className: "gpr-gene-list",
                                children: m.genes.map((h)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)(sn, {
                                        geneId: h.id,
                                        systemName: t.system_name,
                                        geneHref: l,
                                        onGeneClick: o
                                    }, h.id))
                            })
                        ]
                    }) : null,
                    m.ortholog != null ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                        className: "gpr-dl-row",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("dt", {
                                children: "Ortholog of the query gene"
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("dd", {
                                children: m.ortholog ? "yes" : "no"
                            })
                        ]
                    }) : null
                ]
            }) : null,
            g?.status === "no_amplicon" ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                children: g.ortholog_annotated === !1 ? "No ortholog of the query gene is annotated in this genome (possible presence/absence variation)." : g.ortholog_annotated ? "An ortholog is annotated, but these primers do not amplify it." : g.nearest ? "No product is expected to amplify." : "No product was found."
            }) : null,
            g?.nearest ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "Closest product (",
                    g.nearest.likelihood === "unlikely" || !g.nearest.likelihood ? Er(Tr({
                        ...g.nearest,
                        likelihood: "unlikely"
                    }, d), d) : Ss(g.nearest, d),
                    "):",
                    " ",
                    Un(g.nearest, t.system_name),
                    typeof g.nearest.left_mm == "number" || typeof g.nearest.right_mm == "number" ? `; mismatches left ${g.nearest.left_mm ?? "\u2013"}, right ${g.nearest.right_mm ?? "\u2013"}${g.nearest.approx ? " (approximate)" : ""}` : "",
                    "."
                ]
            }) : null,
            g?.truncated ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-note",
                role: "note",
                "data-code": "TRUNCATED",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                        "aria-hidden": "true",
                        children: [
                            Xt,
                            " "
                        ]
                    }),
                    "The search in this genome hit a result cap, so this result may be incomplete: products may have been missed."
                ]
            }) : null,
            f > 0 ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            f,
                            " other amplicon",
                            f === 1 ? "" : "s",
                            g?.others?.length ? ":" : "."
                        ]
                    }),
                    g?.others?.length ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("ul", {
                        className: "gpr-plain-list",
                        children: g.others.slice(0, 20).map((h, y)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("li", {
                                children: Un(h, t.system_name)
                            }, y))
                    }) : null
                ]
            }) : null,
            u ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                className: "gpr-field-error",
                children: u
            }) : null,
            n.status === "pending" ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                className: "gpr-hint",
                children: "This genome has not been searched yet."
            }) : null,
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                type: "button",
                className: "gpr-btn gpr-btn-small",
                onClick: i,
                children: "Close details"
            })
        ]
    });
}
function si(e) {
    const { results: t, requestedGenomes: r, genomes: n, pairLabels: a, transcriptModelsOnly: i, geneHref: l, onGeneClick: o, params: d } = e, p = De("gpr-pan"), g = t?.pairs ?? [], [m, f] = (0, _react.useState)("name"), [u, h] = (0, _react.useState)(!1), [y, _] = (0, _react.useState)({
        r: 0,
        c: 0
    }), [k, b] = (0, _react.useState)(null), C = (0, _react.useRef)(/* @__PURE__ */ new Map()), N = (0, _react.useMemo)(()=>Kl(g, r, n), [
        g,
        r,
        n
    ]), w = (0, _react.useMemo)(()=>{
        let O = N;
        u && (O = O.filter((B)=>B.cells.some((ne)=>Bo(ne.status))));
        const U = (B, ne)=>B.display_name.localeCompare(ne.display_name) || B.system_name.localeCompare(ne.system_name);
        return [
            ...O
        ].sort(m === "worst" ? (B, ne)=>ne.worst - B.worst || U(B, ne) : U);
    }, [
        N,
        u,
        m
    ]), R = (O)=>a?.[O] ?? O, I = w.length - 1, M = g.length - 1, P = Math.max(0, Math.min(y.r, I)), V = Math.max(0, Math.min(y.c, M)), $ = (O, U)=>{
        _({
            r: O,
            c: U
        }), C.current.get(`${O}:${U}`)?.focus();
        const B = w[O];
        k && B && b({
            system_name: B.system_name,
            c: U
        });
    }, L = (O, U)=>{
        const B = w[O];
        B && (_({
            r: O,
            c: U
        }), b({
            system_name: B.system_name,
            c: U
        }));
    }, z = (O, U, B)=>{
        let ne = U, de = B;
        switch(O.key){
            case "ArrowRight":
                de = Math.min(M, B + 1);
                break;
            case "ArrowLeft":
                de = Math.max(0, B - 1);
                break;
            case "ArrowDown":
                ne = Math.min(I, U + 1);
                break;
            case "ArrowUp":
                ne = Math.max(0, U - 1);
                break;
            case "Home":
                de = 0, O.ctrlKey && (ne = 0);
                break;
            case "End":
                de = M, O.ctrlKey && (ne = I);
                break;
            case "PageDown":
                ne = Math.min(I, U + 10);
                break;
            case "PageUp":
                ne = Math.max(0, U - 10);
                break;
            case "Enter":
            case " ":
                O.preventDefault(), L(U, B);
                return;
            case "Escape":
                k && (O.preventDefault(), b(null));
                return;
            default:
                return;
        }
        O.preventDefault(), $(ne, de);
    }, K = k ? N.find((O)=>O.system_name === k.system_name) ?? null : null, S = K && k ? K.cells[k.c] ?? null : null, T = k ? g[k.c] : void 0, W = g.reduce((O, U)=>O + lr(U), 0), H = g.reduce((O, U)=>O + (U.genomes?.length ?? 0), 0);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(bt, {
        theme: e.theme,
        injectStyles: e.injectStyles,
        className: e.className,
        style: e.style,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
            className: "gpr-pangenome",
            children: [
                i ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                    className: "gpr-note",
                    role: "note",
                    "data-code": Ea,
                    children: "Annotated transcripts only: in transcript mode the pan-genome check searches each genome's annotated transcript models, so copies that are not annotated are not found."
                }) : null,
                W ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                    className: "gpr-note",
                    role: "note",
                    "data-code": "TRUNCATED",
                    children: [
                        Xt,
                        " marks ",
                        W,
                        " of ",
                        H,
                        " result",
                        H === 1 ? "" : "s",
                        " where the search hit a result cap: products may have been missed, so those statuses and the amplifies counts are not definitive."
                    ]
                }) : null,
                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                    className: "gpr-matrix-toolbar",
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("label", {
                            className: "gpr-label gpr-label-inline",
                            htmlFor: `${p}-sort`,
                            children: "Sort"
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("select", {
                            id: `${p}-sort`,
                            className: "gpr-select gpr-select-small",
                            value: m,
                            onChange: (O)=>f(O.target.value === "worst" ? "worst" : "name"),
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("option", {
                                    value: "name",
                                    children: "by genome name"
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("option", {
                                    value: "worst",
                                    children: "worst status first"
                                })
                            ]
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ie, {
                            id: `${p}-issues`,
                            label: "Issues only",
                            checked: u,
                            onChange: h
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                            className: "gpr-sub",
                            children: [
                                w.length,
                                " of ",
                                N.length,
                                " genomes"
                            ]
                        })
                    ]
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)(Wl, {}),
                g.length === 0 ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                    className: "gpr-hint",
                    children: "No pan-genome results yet."
                }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                    className: "gpr-table-wrap gpr-matrix-wrap",
                    children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("table", {
                        role: "grid",
                        className: "gpr-table gpr-matrix",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("caption", {
                                className: "gpr-caption",
                                children: [
                                    e.caption ?? (i ? "Pan-genome coverage (annotated transcripts)" : "Pan-genome coverage"),
                                    " \xb7 arrow keys move, Enter shows details"
                                ]
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("thead", {
                                children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                    children: [
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                            scope: "col",
                                            className: "gpr-matrix-corner",
                                            children: "Genome"
                                        }),
                                        g.map((O)=>{
                                            const U = Ia(O.summary), B = lr(O);
                                            return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("th", {
                                                scope: "col",
                                                className: "gpr-matrix-pair",
                                                children: [
                                                    R(O.id),
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "gpr-sub gpr-block",
                                                        children: [
                                                            "amplifies ",
                                                            U.amplifies,
                                                            "/",
                                                            U.total
                                                        ]
                                                    }),
                                                    B ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "gpr-sub gpr-block",
                                                        children: [
                                                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                                "aria-hidden": "true",
                                                                children: [
                                                                    Xt,
                                                                    " "
                                                                ]
                                                            }),
                                                            B,
                                                            " incomplete"
                                                        ]
                                                    }) : null,
                                                    O.reference_size != null ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "gpr-sub gpr-block",
                                                        children: [
                                                            "ref. ",
                                                            v(O.reference_size),
                                                            " bp"
                                                        ]
                                                    }) : null
                                                ]
                                            }, O.id);
                                        })
                                    ]
                                })
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("tbody", {
                                children: w.map((O, U)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                        children: [
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                                scope: "row",
                                                className: "gpr-matrix-genome",
                                                children: O.display_name
                                            }),
                                            O.cells.map((B, ne)=>{
                                                const { glyph: de, text: Ve } = Hl(B), xe = g[ne]?.id ?? "", Se = !!k && k.system_name === O.system_name && k.c === ne;
                                                return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("td", {
                                                    role: "gridcell",
                                                    ref: (Te)=>{
                                                        const Fe = `${U}:${ne}`;
                                                        Te ? C.current.set(Fe, Te) : C.current.delete(Fe);
                                                    },
                                                    className: `gpr-cell gpr-status-${B.status}`,
                                                    "data-status": B.status,
                                                    "data-truncated": B.result?.truncated ? "true" : void 0,
                                                    "data-state": Se ? "open" : void 0,
                                                    tabIndex: U === P && ne === V ? 0 : -1,
                                                    "aria-label": Vl(O, R(xe), B),
                                                    "aria-selected": Se,
                                                    onClick: ()=>L(U, ne),
                                                    onFocus: ()=>{
                                                        (U !== y.r || ne !== y.c) && _({
                                                            r: U,
                                                            c: ne
                                                        });
                                                    },
                                                    onKeyDown: (Te)=>z(Te, U, ne),
                                                    children: [
                                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                            className: "gpr-cell-glyph",
                                                            "aria-hidden": "true",
                                                            children: de
                                                        }),
                                                        Ve ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                            className: "gpr-cell-text",
                                                            "aria-hidden": "true",
                                                            children: Ve
                                                        }) : null,
                                                        B.result?.truncated ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                            className: "gpr-cell-flag",
                                                            "aria-hidden": "true",
                                                            children: Xt
                                                        }) : null
                                                    ]
                                                }, xe);
                                            })
                                        ]
                                    }, O.system_name))
                            })
                        ]
                    })
                }),
                K && S && T ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(Yl, {
                    row: K,
                    pairLabel: R(T.id),
                    cell: S,
                    headingId: `${p}-detail-h`,
                    onClose: ()=>{
                        b(null), C.current.get(`${P}:${V}`)?.focus();
                    },
                    geneHref: l,
                    onGeneClick: o,
                    params: d
                }) : null
            ]
        })
    });
}
const Ht = {
    as_ref: "REF primer",
    as_alt: "ALT primer",
    common: "Common primer"
}, Jl = [
    [
        "Target sequence (5\u2032\u21923\u2032)",
        (e)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("code", {
                className: "gpr-seq",
                children: e.target_seq
            })
    ],
    [
        "Order sequence (5\u2032\u21923\u2032)",
        (e)=>e.tail_seq ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("code", {
                className: "gpr-seq",
                children: e.order_seq
            }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                className: "gpr-sub",
                children: "same as the target sequence"
            })
    ],
    [
        "Tail",
        (e)=>e.tail_seq ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("code", {
                className: "gpr-seq",
                children: e.tail_seq
            }) : "\u2013"
    ],
    [
        "Dye",
        (e)=>e.dye ?? "\u2013"
    ],
    [
        "Allele read",
        (e)=>e.allele ?? "\u2013"
    ],
    [
        "3\u2032 base",
        (e)=>e.three_prime_base
    ],
    [
        "Length",
        (e)=>`${e.len} nt${e.order_len !== e.len ? ` (${e.order_len} nt ordered)` : ""}`
    ],
    [
        "Tm",
        (e)=>`${F(e.tm, 2)} \xb0C${e.tm_method === "ntthal_duplex" ? " (template duplex)" : ""}`
    ],
    [
        "Perfect-match Tm",
        (e)=>e.matched_tm == null ? "\u2013" : `${F(e.matched_tm, 2)} \xb0C`
    ],
    [
        "GC",
        (e)=>`${F(e.gc, 1)} %`
    ],
    [
        "Hairpin (Tm \xb0C)",
        (e)=>F(e.hairpin_th)
    ],
    [
        "Self-complementarity, any / 3\u2032 (Tm \xb0C)",
        (e)=>`${F(e.self_any_th)} / ${F(e.self_end_th)}`
    ],
    [
        "Tailed hairpin / self 3\u2032 (Tm \xb0C)",
        (e)=>e.tailed ? `${F(e.tailed.hairpin_th)} / ${F(e.tailed.self_end_th)}` : "\u2013"
    ],
    [
        "3\u2032 end stability (kcal/mol)",
        (e)=>F(e.end_stability, 2)
    ],
    [
        "Template position",
        (e)=>`${v(e.template.start)}\u{2013}${v(e.template.end)} (${e.template.sequence.toUpperCase()})`
    ],
    [
        "Genomic",
        (e)=>e.genomic ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    gt(e.genomic),
                    e.genomic.blocks.length > 1 ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                        className: "gpr-sub gpr-block",
                        children: [
                            e.genomic.blocks.length,
                            " blocks \u2014 the primer spans the indel"
                        ]
                    }) : null
                ]
            }) : "\u2013"
    ],
    [
        "Bases with no reference coordinate",
        (e)=>e.inserted_bases > 0 ? `${e.inserted_bases} inserted` : "\u2013"
    ],
    [
        "Deliberate mismatch",
        (e)=>e.deliberate_mismatch ? `\u{2212}${e.deliberate_mismatch.position}${e.deliberate_mismatch.from && e.deliberate_mismatch.to ? ` ${e.deliberate_mismatch.from}\u{2192}${e.deliberate_mismatch.to}` : ""}` : "\u2013"
    ],
    [
        "Discrimination",
        (e)=>e.discrimination ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    "own ",
                    e.discrimination.own_allele.likelihood,
                    ", other ",
                    e.discrimination.other_allele.likelihood,
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                        className: "gpr-sub gpr-block",
                        children: [
                            "terminal class ",
                            e.discrimination.terminal_mismatch_class,
                            e.discrimination.in_shift_tract ? " \xb7 3\u2032 base inside the shift tract" : ""
                        ]
                    })
                ]
            }) : "\u2013"
    ],
    [
        "Primer3 notes",
        (e)=>e.primer3_problems ?? "\u2013"
    ]
];
function Xl({ set: e, results: t, id: r }) {
    const n = [
        e.primers.as_ref,
        e.primers.as_alt,
        e.primers.common
    ], a = n.flatMap((l)=>l.neighbours.map((o)=>({
                role: l.role,
                n: o
            }))), i = t?.reference ?? null;
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: "gpr-set-detail",
        id: r,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                className: "gpr-table-wrap",
                children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("table", {
                    className: "gpr-table gpr-detail-table",
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("caption", {
                            className: "gpr-caption",
                            children: [
                                "Primer statistics, set ",
                                e.id
                            ]
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("thead", {
                            children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                children: [
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Statistic"
                                    }),
                                    n.map((l)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("th", {
                                            scope: "col",
                                            children: [
                                                Ht[l.role],
                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)(it, {
                                                    text: l.target_seq,
                                                    label: `Copy the target sequence of the ${Ht[l.role].toLowerCase()} of set ${e.id}`
                                                }),
                                                l.tail_seq ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(it, {
                                                    text: l.order_seq,
                                                    label: `Copy the order sequence of the ${Ht[l.role].toLowerCase()} of set ${e.id}`,
                                                    children: "Copy order"
                                                }) : null
                                            ]
                                        }, l.role))
                                ]
                            })
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("tbody", {
                            children: [
                                Jl.map(([l, o])=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                        children: [
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                                scope: "row",
                                                children: l
                                            }),
                                            n.map((d)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                    children: o(d)
                                                }, d.role))
                                        ]
                                    }, l)),
                                i ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                    children: [
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                            scope: "row",
                                            children: "Reference genome reads"
                                        }),
                                        [
                                            "ref_primer",
                                            "alt_primer",
                                            "common_primer"
                                        ].map((l)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(wn, {
                                                    status: i[l].status,
                                                    context: Ht[n[[
                                                        "ref_primer",
                                                        "alt_primer",
                                                        "common_primer"
                                                    ].indexOf(l)].role]
                                                })
                                            }, l))
                                    ]
                                }) : null
                            ]
                        })
                    ]
                })
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("dl", {
                className: "gpr-dl gpr-set-stats",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                        className: "gpr-dl-row",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("dt", {
                                children: "Products"
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("dd", {
                                children: [
                                    "REF ",
                                    v(e.products.ref.size),
                                    " bp \xb7 ALT ",
                                    v(e.products.alt.size),
                                    " bp"
                                ]
                            })
                        ]
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                        className: "gpr-dl-row",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("dt", {
                                children: "Tm balance"
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("dd", {
                                children: [
                                    "allele-specific primers differ by ",
                                    F(e.tm_balance.as_tm_diff, 2),
                                    " \xb0C; common primer ",
                                    F(e.tm_balance.common_minus_as, 2),
                                    " \xb0C above them"
                                ]
                            })
                        ]
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                        className: "gpr-dl-row",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("dt", {
                                children: "Cross-complementarity, any / 3\u2032 (Tm \xb0C)"
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("dd", {
                                children: [
                                    "REF+common ",
                                    F(e.thermo.ref_common.compl_any_th),
                                    " / ",
                                    F(e.thermo.ref_common.compl_end_th),
                                    " \xb7 ALT+common ",
                                    F(e.thermo.alt_common.compl_any_th),
                                    " /",
                                    " ",
                                    F(e.thermo.alt_common.compl_end_th)
                                ]
                            })
                        ]
                    }),
                    e.thermo.tailed ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                        className: "gpr-dl-row",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("dt", {
                                children: "Tailed cross-complementarity, any / 3\u2032 (Tm \xb0C)"
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("dd", {
                                children: [
                                    "REF+ALT ",
                                    F(e.thermo.tailed.ref_alt_any_th),
                                    " / ",
                                    F(e.thermo.tailed.ref_alt_end_th),
                                    " \xb7 REF+common ",
                                    F(e.thermo.tailed.ref_common_any_th),
                                    " /",
                                    " ",
                                    F(e.thermo.tailed.ref_common_end_th),
                                    " \xb7 ALT+common ",
                                    F(e.thermo.tailed.alt_common_any_th),
                                    " / ",
                                    F(e.thermo.tailed.alt_common_end_th)
                                ]
                            })
                        ]
                    }) : null,
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                        className: "gpr-dl-row",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("dt", {
                                children: "Score"
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("dd", {
                                children: [
                                    F(e.score, 2),
                                    " ",
                                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                        className: "gpr-sub",
                                        children: [
                                            "(lower is better; Primer3 penalty ",
                                            F(e.primer3_penalty, 2),
                                            ")"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            e.issues.length ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                className: "gpr-set-issues",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                        className: "gpr-h4",
                        children: "Issues"
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("ul", {
                        className: "gpr-plain-list",
                        children: e.issues.map((l)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("li", {
                                className: "gpr-set-issue",
                                "data-severity": l.severity,
                                "data-code": l.code,
                                children: [
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                        className: "gpr-set-issue-severity",
                                        children: l.severity === "high" ? "Important" : l.severity === "warn" ? "Check" : "Note"
                                    }),
                                    " ",
                                    l.message,
                                    " ",
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("code", {
                                        className: "gpr-code",
                                        children: l.code
                                    })
                                ]
                            }, l.code))
                    })
                ]
            }) : null,
            a.length ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                className: "gpr-table-wrap",
                children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("table", {
                    className: "gpr-table gpr-neighbour-table",
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("caption", {
                            className: "gpr-caption",
                            children: [
                                "Known variants under the primers of set ",
                                e.id,
                                " \xb7 a filled marker is a natural variant, hollow is EMS"
                            ]
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("thead", {
                            children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                children: [
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Primer"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Variant"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Alleles"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "From the 3\u2032 end"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Source"
                                    })
                                ]
                            })
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("tbody", {
                            children: a.map(({ role: l, n: o })=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                    children: [
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                            scope: "row",
                                            children: Ht[l]
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                            children: o.label
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                            children: o.alleles
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("td", {
                                            className: "gpr-num",
                                            children: [
                                                o.distance_from_3p,
                                                " nt",
                                                o.distance_from_3p === 1 ? " (the 3\u2032 base)" : ""
                                            ]
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("td", {
                                            children: [
                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                    "aria-hidden": "true",
                                                    children: o.ems ? "\u25CB" : "\u25CF"
                                                }),
                                                " ",
                                                o.ems ? "EMS" : "natural"
                                            ]
                                        })
                                    ]
                                }, `${l}-${o.key}`))
                        })
                    ]
                })
            }) : null
        ]
    });
}
const Ql = Object.freeze({
    specific: {
        glyph: "\u2713",
        label: "Specific",
        tone: "ok"
    },
    off_targets: {
        glyph: "!",
        label: "Off-targets",
        tone: "warn"
    },
    on_target_missing: {
        glyph: "\u2717",
        label: "On-target missing",
        tone: "bad"
    },
    unverified_target: {
        glyph: "?",
        label: "Target unverified",
        tone: "info"
    },
    truncated: {
        glyph: "\u22EF",
        label: "Truncated",
        tone: "warn"
    },
    error: {
        glyph: "!",
        label: "Check error",
        tone: "bad"
    },
    pending: {
        glyph: "\u2026",
        label: "Checking",
        tone: "muted"
    },
    not_checked: {
        glyph: "\u2013",
        label: "Not checked",
        tone: "muted"
    }
});
function at({ verdict: e, count: t, inferred: r, context: n, className: a }) {
    const i = Ql[e] ?? {
        glyph: "?",
        label: String(e),
        tone: "muted"
    }, l = `${i.label}${e === "off_targets" && typeof t == "number" ? ` (${t})` : ""}${r ? " \xb7 inferred" : ""}`;
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
        className: Pe("gpr-chip", `gpr-chip-${i.tone}`, a),
        "data-verdict": e,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                className: "gpr-chip-glyph",
                "aria-hidden": "true",
                children: i.glyph
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                className: "gpr-chip-text",
                children: [
                    n ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                        className: "gpr-visually-hidden",
                        children: [
                            n,
                            ": "
                        ]
                    }) : null,
                    l
                ]
            })
        ]
    });
}
function Ts({ seq: e, positions: t, label: r }) {
    const n = [
        ...t ?? []
    ], a = new Set(yi(e.length, n)), i = n.length ? `${r}: ${n.length} mismatch${n.length === 1 ? "" : "es"} at ${[
        ...n
    ].sort((l, o)=>l - o).join(", ")} nt from the 3\u{2032} end` : `${r}: no mismatches`;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
        className: "gpr-mm",
        role: "img",
        "aria-label": i,
        title: i,
        children: Array.from(e).map((l, o)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                className: a.has(o) ? "gpr-mm-base gpr-mm-hit" : "gpr-mm-base",
                "aria-hidden": "true",
                children: a.has(o) ? l : "\xb7"
            }, o))
    });
}
const Es = Object.freeze({
    good: {
        glyph: "\u2713",
        label: "Good",
        tone: "ok"
    },
    usable: {
        glyph: "~",
        label: "Usable",
        tone: "warn"
    },
    poor: {
        glyph: "!",
        label: "Poor",
        tone: "bad"
    }
}), Zl = {
    forward: "\u2192",
    reverse: "\u2190"
};
function Fn({ oligo: e, set: t }) {
    const r = e.role === "common" ? "common primer" : `${e.role === "as_ref" ? "REF" : "ALT"} primer`, n = e.target_seq.slice(0, -1), a = e.target_seq.slice(-1);
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: "gpr-primer gpr-set-primer",
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                className: "gpr-primer-line",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("code", {
                        className: "gpr-seq",
                        children: [
                            n,
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                className: "gpr-seq-3p",
                                children: a
                            })
                        ]
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(it, {
                        text: e.target_seq,
                        label: `Copy the ${r} of set ${t.id}`
                    })
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                className: "gpr-sub gpr-block",
                children: [
                    e.allele ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                        className: "gpr-badge gpr-allele-badge",
                        title: `Reads the ${e.allele} allele`,
                        children: e.allele
                    }) : null,
                    " ",
                    e.dye ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                        className: "gpr-badge gpr-dye-badge",
                        children: e.dye
                    }) : null,
                    " ",
                    e.len,
                    " nt \xb7 ",
                    F(e.tm, 1),
                    " \xb0C \xb7 ",
                    F(e.gc, 0),
                    " % GC"
                ]
            }),
            e.tail_seq ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                className: "gpr-sub gpr-block",
                children: [
                    "tailed: ",
                    e.order_len,
                    " nt ",
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(it, {
                        text: e.order_seq,
                        label: `Copy the tailed order sequence of the ${r} of set ${t.id}`,
                        children: "Copy order"
                    })
                ]
            }) : null,
            e.inserted_bases > 0 ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                className: "gpr-sub gpr-block",
                children: [
                    e.inserted_bases,
                    " base",
                    e.inserted_bases === 1 ? "" : "s",
                    " with no reference coordinate"
                ]
            }) : null
        ]
    });
}
function ec(e) {
    const { sets: t, checkedKeys: r, onCheckedChange: n, selectedKey: a, onSelect: i, check: l, submitted: o, caption: d } = e, p = De("gpr-sets"), [g, m] = (0, _react.useState)(()=>/* @__PURE__ */ new Set()), f = (0, _react.useMemo)(()=>l ? Co(t, l, o) : null, [
        t,
        l,
        o
    ]), u = new Set(r ?? []), h = !!n, y = !!l, _ = l?.status === "queued" || l?.status === "running", k = u.size >= $e.maxSets, b = 9 + (h ? 1 : 0) + (y ? 1 : 0), C = (N, w)=>{
        const R = r ? [
            ...r
        ] : [], I = R.indexOf(N);
        w && I < 0 ? R.push(N) : !w && I >= 0 && R.splice(I, 1), n?.(R);
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)(bt, {
        theme: e.theme,
        injectStyles: e.injectStyles,
        className: e.className,
        style: e.style,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                className: "gpr-table-wrap",
                children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("table", {
                    className: "gpr-table gpr-sets-table",
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("caption", {
                            className: "gpr-caption",
                            children: [
                                d ?? `${t.length} primer set${t.length === 1 ? "" : "s"}`,
                                h ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                    className: "gpr-sub",
                                    children: [
                                        " \xb7 tick up to ",
                                        $e.maxSets,
                                        " sets to check them"
                                    ]
                                }) : null
                            ]
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("thead", {
                            children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                children: [
                                    h ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        className: "gpr-col-check",
                                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                            className: "gpr-visually-hidden",
                                            children: "Select for check"
                                        })
                                    }) : null,
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Set"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "REF primer 5\u2032\u21923\u2032"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "ALT primer 5\u2032\u21923\u2032"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Common primer 5\u2032\u21923\u2032"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Product bp"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Tm balance \xb0C"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Variants"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Quality"
                                    }),
                                    y ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Check"
                                    }) : null,
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                            className: "gpr-visually-hidden",
                                            children: "Details"
                                        })
                                    })
                                ]
                            })
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("tbody", {
                            children: t.map((N)=>{
                                const w = u.has(N.key), R = g.has(N.key), I = N.key === a, M = `${p}-detail-${N.key}`, P = `${p}-why-${N.key}`, V = !w && k ? `At most ${$e.maxSets} sets can be checked at once` : null, $ = Es[N.quality] ?? Es.poor, z = (f?.bySetKey.get(N.key) ?? null)?.results ?? null, K = N.issues.filter((S)=>S.severity === "high");
                                return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                                    children: [
                                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                            className: "gpr-set-row",
                                            "data-state": I ? "selected" : void 0,
                                            "data-key": N.key,
                                            children: [
                                                h ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("td", {
                                                    className: "gpr-col-check",
                                                    children: [
                                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                                                            type: "checkbox",
                                                            className: "gpr-checkbox",
                                                            "aria-label": `Check set ${N.id}`,
                                                            checked: w,
                                                            disabled: !!V,
                                                            "aria-describedby": V ? P : void 0,
                                                            onChange: (S)=>C(N.key, S.target.checked)
                                                        }),
                                                        V ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                            id: P,
                                                            className: "gpr-visually-hidden",
                                                            children: V
                                                        }) : null
                                                    ]
                                                }) : null,
                                                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("th", {
                                                    scope: "row",
                                                    className: "gpr-col-set",
                                                    children: [
                                                        i ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                                            type: "button",
                                                            className: "gpr-rank",
                                                            "aria-pressed": I,
                                                            "aria-label": `Select set ${N.id}`,
                                                            onClick: ()=>i(N.key),
                                                            children: N.id
                                                        }) : N.id,
                                                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                            className: "gpr-sub gpr-block",
                                                            children: [
                                                                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                                    "aria-hidden": "true",
                                                                    children: [
                                                                        Zl[N.orientation],
                                                                        " "
                                                                    ]
                                                                }),
                                                                N.orientation
                                                            ]
                                                        }),
                                                        N.relaxation_level > 0 ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                            className: "gpr-sub gpr-block",
                                                            title: "These constraints were relaxed to find a set",
                                                            children: [
                                                                "level ",
                                                                N.relaxation_level
                                                            ]
                                                        }) : null
                                                    ]
                                                }),
                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                    className: "gpr-col-primer",
                                                    children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Fn, {
                                                        oligo: N.primers.as_ref,
                                                        set: N
                                                    })
                                                }),
                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                    className: "gpr-col-primer",
                                                    children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Fn, {
                                                        oligo: N.primers.as_alt,
                                                        set: N
                                                    })
                                                }),
                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                    className: "gpr-col-primer",
                                                    children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Fn, {
                                                        oligo: N.primers.common,
                                                        set: N
                                                    })
                                                }),
                                                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("td", {
                                                    className: "gpr-num",
                                                    children: [
                                                        v(N.products.ref.size),
                                                        N.products.alt.size !== N.products.ref.size ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                            className: "gpr-sub gpr-block",
                                                            children: [
                                                                "ALT ",
                                                                v(N.products.alt.size)
                                                            ]
                                                        }) : null
                                                    ]
                                                }),
                                                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("td", {
                                                    className: "gpr-num",
                                                    children: [
                                                        F(N.tm_balance.as_tm_diff, 1),
                                                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                            className: "gpr-sub gpr-block",
                                                            children: [
                                                                "common ",
                                                                F(N.tm_balance.common_minus_as, 1)
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                    className: "gpr-num",
                                                    children: N.neighbour_sites === 0 ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                        className: "gpr-sub",
                                                        children: "none"
                                                    }) : v(N.neighbour_sites)
                                                }),
                                                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("td", {
                                                    className: "gpr-col-quality",
                                                    children: [
                                                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                            className: Pe("gpr-chip", `gpr-chip-${$.tone}`),
                                                            "data-quality": N.quality,
                                                            children: [
                                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "gpr-chip-glyph",
                                                                    "aria-hidden": "true",
                                                                    children: $.glyph
                                                                }),
                                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "gpr-chip-text",
                                                                    children: $.label
                                                                })
                                                            ]
                                                        }),
                                                        K.map((S)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                                className: "gpr-badge gpr-badge-warn gpr-issue-badge",
                                                                "data-code": S.code,
                                                                title: S.message,
                                                                children: S.code.replace(/_/g, " ").toLowerCase()
                                                            }, S.code))
                                                    ]
                                                }),
                                                y ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                    className: "gpr-col-verdict",
                                                    children: z ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "gpr-verdicts",
                                                        children: [
                                                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                                className: "gpr-agreement-line",
                                                                children: [
                                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(ni, {
                                                                        agrees: z.summary.disagree === 0
                                                                    }),
                                                                    " ",
                                                                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                                        className: "gpr-sub",
                                                                        children: [
                                                                            z.summary.agree,
                                                                            "/",
                                                                            z.summary.agree + z.summary.disagree,
                                                                            " agree"
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                                className: "gpr-verdict-line",
                                                                children: [
                                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "gpr-sub",
                                                                        "aria-hidden": "true",
                                                                        children: "REF"
                                                                    }),
                                                                    " ",
                                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(at, {
                                                                        verdict: z.specificity.ref_pair.verdict,
                                                                        count: z.specificity.off_target_count,
                                                                        context: "REF pair genome specificity"
                                                                    })
                                                                ]
                                                            }),
                                                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                                className: "gpr-verdict-line",
                                                                children: [
                                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "gpr-sub",
                                                                        "aria-hidden": "true",
                                                                        children: "ALT"
                                                                    }),
                                                                    " ",
                                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(at, {
                                                                        verdict: z.specificity.alt_pair.verdict,
                                                                        context: "ALT pair genome specificity"
                                                                    })
                                                                ]
                                                            }),
                                                            z.control.status !== "pass" ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                                className: "gpr-sub gpr-block gpr-control-warn",
                                                                children: [
                                                                    "reference control ",
                                                                    z.control.status
                                                                ]
                                                            }) : null
                                                        ]
                                                    }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)(at, {
                                                        verdict: _ ? "pending" : "not_checked",
                                                        context: "Allele check"
                                                    })
                                                }) : null,
                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                    className: "gpr-col-expand",
                                                    children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("button", {
                                                        type: "button",
                                                        className: "gpr-btn gpr-btn-small gpr-btn-quiet",
                                                        "aria-expanded": R,
                                                        "aria-controls": R ? M : void 0,
                                                        onClick: ()=>m((S)=>{
                                                                const T = new Set(S);
                                                                return T.has(N.key) ? T.delete(N.key) : T.add(N.key), T;
                                                            }),
                                                        children: [
                                                            R ? "Hide" : "Details",
                                                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                                className: "gpr-visually-hidden",
                                                                children: [
                                                                    " of set ",
                                                                    N.id
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        R ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("tr", {
                                            className: "gpr-detail-row",
                                            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                colSpan: b,
                                                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Xl, {
                                                    id: M,
                                                    set: N,
                                                    results: z
                                                })
                                            })
                                        }) : null
                                    ]
                                }, N.key);
                            })
                        })
                    ]
                })
            }),
            f?.notChecked.length ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-hint",
                children: [
                    f.notChecked.length,
                    " set",
                    f.notChecked.length === 1 ? " was" : "s were",
                    " not part of this check."
                ]
            }) : null,
            f?.orphanIds.length ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-hint",
                children: [
                    "The check also returned results for ",
                    f.orphanIds.length,
                    " set",
                    f.orphanIds.length === 1 ? "" : "s",
                    " that ",
                    f.orphanIds.length === 1 ? "is" : "are",
                    " not in this design."
                ]
            }) : null
        ]
    });
}
const ai = Object.freeze({
    likely: "likely",
    likely_weak: "likely, weak (3\u2032 mismatch)",
    unlikely: "unlikely"
}), Is = Object.freeze({
    likely: 0,
    likely_weak: 1,
    unlikely: 2
});
function ii(e, t) {
    return e.likelihood === "unlikely" ? Er(Tr(e, t), t) : ai[e.likelihood] ?? String(e.likelihood);
}
function tc(e, t, r) {
    const n = e?.request?.pairs?.length ? e.request.pairs : t ?? [], a = new Map((r ?? []).map((i)=>[
            ht(i.left.seq, i.right.seq),
            i.rank
        ]));
    return new Map(n.map((i)=>[
            i.id,
            {
                left: i.left.toUpperCase(),
                right: i.right.toUpperCase(),
                rank: a.get(ht(i.left, i.right))
            }
        ]));
}
function nc(e, t) {
    return e.localeCompare(t, "en", {
        numeric: !0
    });
}
const rc = [
    {
        key: "location",
        label: "Location"
    },
    {
        key: "size",
        label: "Size (bp)"
    },
    {
        key: "orientation",
        label: "Orientation"
    },
    {
        key: "likelihood",
        label: "Likelihood"
    },
    {
        key: "left",
        label: "Left primer mismatches"
    },
    {
        key: "right",
        label: "Right primer mismatches"
    },
    {
        key: "genes",
        label: "Genes"
    }
];
function sc(e) {
    const t = (r, n)=>nc(String(r.region), String(n.region)) || r.start - n.start;
    switch(e){
        case "size":
            return (r, n)=>r.size - n.size || t(r, n);
        case "orientation":
            return (r, n)=>r.orientation.localeCompare(n.orientation) || t(r, n);
        case "likelihood":
            return (r, n)=>(Is[r.likelihood] ?? 9) - (Is[n.likelihood] ?? 9) || t(r, n);
        case "left":
            return (r, n)=>r.left_mm - n.left_mm || r.left_3p_mm - n.left_3p_mm || t(r, n);
        case "right":
            return (r, n)=>r.right_mm - n.right_mm || r.right_3p_mm - n.right_3p_mm || t(r, n);
        case "genes":
            return (r, n)=>(r.genes?.[0]?.id ?? "~").localeCompare(n.genes?.[0]?.id ?? "~") || t(r, n);
        default:
            return t;
    }
}
function $s({ rows: e, caption: t, maxRows: r, info: n, systemName: a, geneHref: i, onGeneClick: l, params: o }) {
    const [d, p] = (0, _react.useState)({
        key: "location",
        dir: 1
    }), m = (0, _react.useMemo)(()=>{
        const f = sc(d.key);
        return [
            ...e
        ].sort((u, h)=>d.dir * f(u, h));
    }, [
        e,
        d
    ]).slice(0, r);
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                className: "gpr-table-wrap",
                children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("table", {
                    className: "gpr-table gpr-amplicon-table",
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("caption", {
                            className: "gpr-caption",
                            children: [
                                t,
                                " (",
                                v(e.length),
                                ")"
                            ]
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("thead", {
                            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("tr", {
                                children: rc.map((f)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        "aria-sort": d.key === f.key ? d.dir === 1 ? "ascending" : "descending" : void 0,
                                        children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("button", {
                                            type: "button",
                                            className: "gpr-sort",
                                            onClick: ()=>p((u)=>({
                                                        key: f.key,
                                                        dir: u.key === f.key && u.dir === 1 ? -1 : 1
                                                    })),
                                            children: [
                                                f.label,
                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                    className: "gpr-sort-glyph",
                                                    "aria-hidden": "true",
                                                    children: d.key === f.key ? d.dir === 1 ? " \u25B2" : " \u25BC" : ""
                                                })
                                            ]
                                        })
                                    }, f.key))
                            })
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("tbody", {
                            children: m.map((f, u)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                    children: [
                                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("td", {
                                            className: "gpr-loc",
                                            children: [
                                                Zt(String(f.region), f.start, f.end),
                                                f.approx ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                    className: "gpr-sub",
                                                    children: " (approx.)"
                                                }) : null
                                            ]
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                            className: "gpr-num",
                                            children: v(f.size)
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                            children: f.orientation
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                            children: ii(f, o)
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("td", {
                                            className: "gpr-col-mm",
                                            children: [
                                                n?.left ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ts, {
                                                    seq: n.left,
                                                    positions: f.left_mm_pos,
                                                    label: "Left primer"
                                                }) : null,
                                                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                    className: "gpr-sub gpr-block",
                                                    children: [
                                                        f.left_mm,
                                                        " total, ",
                                                        f.left_3p_mm,
                                                        " in 3\u2032 window",
                                                        f.approx ? " (approx.)" : ""
                                                    ]
                                                })
                                            ]
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("td", {
                                            className: "gpr-col-mm",
                                            children: [
                                                n?.right ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ts, {
                                                    seq: n.right,
                                                    positions: f.right_mm_pos,
                                                    label: "Right primer"
                                                }) : null,
                                                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                    className: "gpr-sub gpr-block",
                                                    children: [
                                                        f.right_mm,
                                                        " total, ",
                                                        f.right_3p_mm,
                                                        " in 3\u2032 window",
                                                        f.approx ? " (approx.)" : ""
                                                    ]
                                                })
                                            ]
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                            children: f.genes?.length ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                className: "gpr-gene-list",
                                                children: f.genes.map((h)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)(sn, {
                                                        geneId: h.id,
                                                        systemName: a,
                                                        geneHref: i,
                                                        onGeneClick: l
                                                    }, h.id))
                                            }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                className: "gpr-sub",
                                                children: "intergenic"
                                            })
                                        })
                                    ]
                                }, `${f.region}:${f.start}-${f.end}:${f.orientation}:${u}`))
                        })
                    ]
                })
            }),
            e.length > r ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-hint",
                children: [
                    "Showing ",
                    v(r),
                    " of ",
                    v(e.length),
                    "; export the off-target TSV for the full list."
                ]
            }) : null
        ]
    });
}
function ac({ r: e, mode: t, systemName: r, geneHref: n, onGeneClick: a }) {
    const i = e.on_target;
    if (i) return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
        className: "gpr-on-target",
        children: [
            "On target: ",
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                className: "gpr-loc",
                children: Zt(String(i.region), i.start, i.end)
            }),
            ", ",
            v(i.size),
            " bp, ",
            i.orientation,
            i.likelihood !== "likely" ? `, ${ai[i.likelihood] ?? i.likelihood}` : "",
            i.genes?.length ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    " ",
                    "in",
                    " ",
                    i.genes.map((g)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)(sn, {
                            geneId: g.id,
                            systemName: r,
                            geneHref: n,
                            onGeneClick: a
                        }, g.id))
                ]
            }) : null,
            e.on_target_inferred ? " (inferred: the only perfect product)" : ""
        ]
    });
    const l = e.gdna_products?.length ?? 0, o = t === "transcript" || l > 0, d = (e.off_target_count ?? 0) > 0 || (e.off_targets?.length ?? 0) > 0;
    let p = "No on-target product was reported.";
    return e.verdict === "on_target_missing" ? p = "The expected product was not found in the genome." : e.verdict === "unverified_target" ? p = "No expected location was given and the target could not be inferred." : o && d ? p = `Transcript check: the genome has no expected product, so products outside the gene are listed as off-targets${l ? " and products inside it as genomic DNA products" : ""}.` : e.verdict === "specific" && !d && (p = l ? "No off-target products in the genome outside the gene." : "No off-target products in the genome."), /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
        className: "gpr-on-target",
        children: p
    });
}
function ic({ r: e, info: t, results: r, maxRows: n, systemName: a, geneHref: i, onGeneClick: l, headingId: o, mode: d }) {
    const p = r.params ?? null, g = r.primers ?? {}, m = [
        [
            "Left",
            t?.left
        ],
        [
            "Right",
            t?.right
        ]
    ].map(([u, h])=>h && g[h]?.repetitive ? {
            side: u,
            sites: g[h].near_perfect_sites
        } : null).filter((u)=>!!u), f = e.gdna_products ?? [];
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("section", {
        className: "gpr-result-pair",
        "aria-labelledby": o,
        "data-pair": e.id,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("h4", {
                className: "gpr-h4",
                id: o,
                children: [
                    e.id,
                    t?.rank != null ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                        className: "gpr-sub",
                        children: [
                            " \xb7 designed pair ",
                            t.rank + 1
                        ]
                    }) : null,
                    " ",
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(at, {
                        verdict: e.verdict,
                        count: e.off_target_count,
                        inferred: e.on_target_inferred
                    })
                ]
            }),
            m.map((u)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                    className: "gpr-note gpr-repetitive",
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                            className: "gpr-badge gpr-badge-warn",
                            children: "repetitive"
                        }),
                        " ",
                        u.side,
                        " primer: ",
                        v(u.sites),
                        " near-perfect genome sites."
                    ]
                }, u.side)),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(ac, {
                r: e,
                mode: d,
                systemName: a,
                geneHref: i,
                onGeneClick: l
            }),
            e.truncated ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                className: "gpr-note",
                role: "note",
                children: "The search hit a candidate cap, so this list may be incomplete."
            }) : null,
            e.error ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                className: "gpr-field-error",
                children: e.error.message
            }) : null,
            e.off_targets?.length ? /* @__PURE__ */ (0, _jsxRuntime.jsx)($s, {
                rows: e.off_targets,
                caption: `Off-target products of ${e.id}`,
                maxRows: n,
                info: t,
                systemName: a,
                geneHref: i,
                onGeneClick: l,
                params: p
            }) : null,
            e.unlikely?.length ? /* @__PURE__ */ (0, _jsxRuntime.jsx)($s, {
                rows: e.unlikely,
                caption: `Unlikely products of ${e.id}`,
                maxRows: n,
                info: t,
                systemName: a,
                geneHref: i,
                onGeneClick: l,
                params: p
            }) : e.unlikely_count ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-hint",
                children: [
                    v(e.unlikely_count),
                    " unlikely product",
                    e.unlikely_count === 1 ? "" : "s",
                    " not listed (include them in the advanced check settings)."
                ]
            }) : null,
            f.length ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                className: "gpr-note gpr-gdna",
                role: "note",
                children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                    children: [
                        f.length,
                        " genomic DNA product",
                        f.length === 1 ? "" : "s",
                        " inside the gene (",
                        f.map((u)=>`${v(u.size)} bp`).join(", "),
                        "): DNase-treat RNA before reverse transcription."
                    ]
                })
            }) : null
        ]
    });
}
function oc(e) {
    return e.size_min === e.size_max ? v(e.size_min) : `${v(e.size_min)}\u{2013}${v(e.size_max)}`;
}
function lc({ r: e, info: t, systemName: r, geneHref: n, onGeneClick: a, headingId: i, params: l }) {
    const o = [
        ...e.on_target ? [
            {
                g: e.on_target,
                kind: "on target"
            }
        ] : [],
        ...(e.off_targets ?? []).map((d)=>({
                g: d,
                kind: "off target"
            }))
    ];
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("section", {
        className: "gpr-result-pair",
        "aria-labelledby": i,
        "data-pair": e.id,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("h4", {
                className: "gpr-h4",
                id: i,
                children: [
                    e.id,
                    t?.rank != null ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                        className: "gpr-sub",
                        children: [
                            " \xb7 designed pair ",
                            t.rank + 1
                        ]
                    }) : null,
                    " ",
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(at, {
                        verdict: e.verdict,
                        count: e.off_target_count,
                        context: "Transcriptome"
                    })
                ]
            }),
            e.truncated ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                className: "gpr-note",
                role: "note",
                children: "The search hit a candidate cap, so this list may be incomplete."
            }) : null,
            o.length ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                className: "gpr-table-wrap",
                children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("table", {
                    className: "gpr-table gpr-transcript-table",
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("caption", {
                            className: "gpr-caption",
                            children: [
                                "Transcript products of ",
                                e.id,
                                ", one row per gene"
                            ]
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("thead", {
                            children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                children: [
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Gene"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Kind"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Isoforms"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Size (bp)"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Likelihood"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Mismatches L/R"
                                    })
                                ]
                            })
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("tbody", {
                            children: o.map(({ g: d, kind: p }, g)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                    "data-kind": p,
                                    children: [
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(sn, {
                                                geneId: d.gene_id,
                                                systemName: r,
                                                geneHref: n,
                                                onGeneClick: a
                                            })
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                            children: p
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("ul", {
                                                className: "gpr-isoforms",
                                                children: (d.isoforms ?? []).map((m)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("li", {
                                                        children: [
                                                            m.transcript_id,
                                                            " ",
                                                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                                className: "gpr-sub",
                                                                children: [
                                                                    v(m.start),
                                                                    "\u2013",
                                                                    v(m.end),
                                                                    ", ",
                                                                    v(m.size),
                                                                    " bp"
                                                                ]
                                                            })
                                                        ]
                                                    }, m.transcript_id))
                                            })
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                            className: "gpr-num",
                                            children: oc(d)
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("td", {
                                            children: [
                                                ii(d, l),
                                                d.approx ? " (approx.)" : ""
                                            ]
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("td", {
                                            className: "gpr-num",
                                            children: [
                                                d.left_mm ?? "\u2013",
                                                " / ",
                                                d.right_mm ?? "\u2013"
                                            ]
                                        })
                                    ]
                                }, `${d.gene_id}-${g}`))
                        })
                    ]
                })
            }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                className: "gpr-hint",
                children: "No transcript products."
            })
        ]
    });
}
function cc({ results: e }) {
    const t = Object.entries(e.primers ?? {});
    return t.length ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        className: "gpr-table-wrap",
        children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("table", {
            className: "gpr-table gpr-sensitivity-table",
            children: [
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("caption", {
                    className: "gpr-caption",
                    children: "Per-primer search sensitivity"
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("thead", {
                    children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                scope: "col",
                                children: "Primer"
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                scope: "col",
                                children: "Near-perfect sites"
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                scope: "col",
                                children: "Reference: always found up to"
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                scope: "col",
                                children: "Pan-genome: always found up to"
                            })
                        ]
                    })
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("tbody", {
                    children: t.map(([r, n])=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("td", {
                                    children: [
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("code", {
                                            className: "gpr-seq",
                                            children: r
                                        }),
                                        n.repetitive ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                            className: "gpr-badge gpr-badge-warn",
                                            children: "repetitive"
                                        }) : null
                                    ]
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                    className: "gpr-num",
                                    children: v(n.near_perfect_sites)
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                    children: n.sensitivity?.reference ? `${n.sensitivity.reference.guaranteed_max_mismatches} mismatches (word size ${n.sensitivity.reference.word_size})` : "\u2013"
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                    children: n.sensitivity?.pangenome ? `${n.sensitivity.pangenome.guaranteed_max_mismatches} mismatches (word size ${n.sensitivity.pangenome.word_size})` : "\u2013"
                                })
                            ]
                        }, r))
                })
            ]
        })
    }) : null;
}
function oi(e) {
    const { results: t, block: r = "genome", job: n, maxRows: a = 100, systemName: i, geneHref: l, onGeneClick: o } = e, d = De("gpr-spec"), p = (0, _react.useMemo)(()=>tc(n, e.submitted, e.pairs), [
        n,
        e.submitted,
        e.pairs
    ]), g = n?.status === "queued" || n?.status === "running", m = t?.specificity?.pairs ?? [], f = t?.transcriptome?.pairs ?? [], u = r === "genome" ? m.length : f.length;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(bt, {
        theme: e.theme,
        injectStyles: e.injectStyles,
        className: e.className,
        style: e.style,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
            className: "gpr-specificity",
            "data-block": r,
            children: [
                u === 0 ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                    className: "gpr-hint",
                    children: g ? r === "genome" ? "Searching the reference genome\u2026" : "Searching the transcriptome\u2026" : "No results."
                }) : g ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                    className: "gpr-hint",
                    role: "note",
                    children: "Partial results: the check is still running."
                }) : null,
                t && r === "genome" ? m.map((h, y)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)(ic, {
                        r: h,
                        info: p.get(h.id),
                        results: t,
                        maxRows: a,
                        systemName: i,
                        geneHref: l,
                        onGeneClick: o,
                        headingId: `${d}-g-${y}`,
                        mode: n?.request?.mode ?? null
                    }, h.id)) : null,
                t && r === "transcriptome" ? f.map((h, y)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)(lc, {
                        r: h,
                        info: p.get(h.id),
                        systemName: i,
                        geneHref: l,
                        onGeneClick: o,
                        headingId: `${d}-t-${y}`,
                        params: t.params ?? null
                    }, h.id)) : null,
                t && r === "genome" && (t.sensitivity_note || Object.keys(t.primers ?? {}).length) ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("details", {
                    className: "gpr-details gpr-sensitivity",
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("summary", {
                            className: "gpr-summary",
                            children: "Search sensitivity"
                        }),
                        t.sensitivity_note ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                            className: "gpr-hint",
                            children: t.sensitivity_note
                        }) : null,
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)(cc, {
                            results: t
                        })
                    ]
                }) : null,
                r === "genome" ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(cn, {
                    warnings: t?.warnings,
                    title: "Check warnings"
                }) : null
            ]
        })
    });
}
function Ur(e) {
    const t = /* @__PURE__ */ new Map();
    for (const r of e ?? []){
        if (!r || typeof r.population != "string" || typeof r.allele != "string") continue;
        const n = Number(r.frequency);
        if (!Number.isFinite(n)) continue;
        const a = `${r.population}|${r.allele}`;
        if (t.has(a)) continue;
        const i = r.count, l = i == null ? Number.NaN : Number(i);
        t.set(a, {
            population: r.population,
            allele: r.allele,
            frequency: n,
            count: Number.isFinite(l) ? l : null
        });
    }
    return [
        ...t.values()
    ];
}
function dc(e) {
    return [
        ...new Set(Ur(e).map((t)=>t.population))
    ].sort((t, r)=>t.localeCompare(r));
}
function pc(e) {
    const t = e.minimal?.alt;
    if (typeof t == "string" && t) return t;
    const r = e.alleles?.[1];
    return typeof r == "string" && r ? r : null;
}
function gc(e, t, r) {
    if (!r) return null;
    const n = Ur(e).find((a)=>a.population === t && a.allele === r);
    return n ? {
        frequency: n.frequency,
        count: n.count
    } : null;
}
function mc(e, t) {
    const r = Ur(e).filter((n)=>n.population === t).sort((n, a)=>a.frequency - n.frequency);
    return r.length >= 2 ? r[1].frequency : null;
}
function li(e) {
    const t = /* @__PURE__ */ new Map();
    for (const r of e.values())for (const n of dc(r))t.set(n, (t.get(n) ?? 0) + 1);
    return [
        ...t
    ].sort((r, n)=>n[1] - r[1] || r[0].localeCompare(n[0]));
}
function Bd(e) {
    return li(e)[0]?.[0] ?? null;
}
const uc = 200, hc = 2, ci = 600;
function fc(e, t, r, n = {}) {
    const a = n.batchSize ?? uc, i = n.maxAnnotated ?? ci, l = n.debounceMs ?? 250, o = (0, _react.useRef)(/* @__PURE__ */ new Map()), [d, p] = (0, _react.useState)(0), [g, m] = (0, _react.useState)({
        loading: !1,
        done: !1,
        error: null
    }), f = r.length > i, u = JSON.stringify({
        systemName: t,
        ids: r.slice(0, i)
    });
    return (0, _react.useEffect)(()=>{
        if (!e || !t) {
            m({
                loading: !1,
                done: !1,
                error: null
            });
            return;
        }
        const { ids: y } = JSON.parse(u), _ = y.filter((C)=>!o.current.has(C));
        if (!_.length) {
            m({
                loading: !1,
                done: !0,
                error: null
            });
            return;
        }
        const k = new AbortController();
        m({
            loading: !0,
            done: !1,
            error: null
        });
        const b = setTimeout(()=>{
            const C = [];
            for(let I = 0; I < _.length; I += a)C.push(_.slice(I, I + a));
            let N = 0;
            const w = async ()=>{
                for(; N < C.length && !k.signal.aborted;){
                    const I = C[N++], M = await e({
                        system_name: t,
                        ids: I
                    }, {
                        signal: k.signal
                    });
                    if (k.signal.aborted) return;
                    for (const P of I)o.current.set(P, M?.[P] ?? []);
                    p((P)=>P + 1);
                }
            }, R = Array.from({
                length: Math.min(hc, C.length)
            }, w);
            Promise.all(R).then(()=>{
                k.signal.aborted || m({
                    loading: !1,
                    done: !0,
                    error: null
                });
            }, (I)=>{
                !k.signal.aborted && !Ue(I) && m({
                    loading: !1,
                    done: !1,
                    error: I
                });
            });
        }, l);
        return ()=>{
            clearTimeout(b), k.abort();
        };
    }, [
        e,
        t,
        u,
        a,
        l
    ]), {
        byId: (0, _react.useMemo)(()=>{
            const y = /* @__PURE__ */ new Map();
            for (const _ of JSON.parse(u).ids){
                const k = o.current.get(_);
                k && y.set(_, k);
            }
            return y;
        }, [
            u,
            d
        ]),
        ...g,
        capped: f,
        unsupported: !e
    };
}
const Bn = {
    seq: null,
    start: 0,
    error: null,
    loading: !1,
    unsupported: !1
}, bc = 2e5, Rs = 20;
function yc(e, t, r = 250) {
    const n = t ? {
        ...t,
        start: Math.max(1, t.start - Rs),
        end: t.end + Rs
    } : null, a = n ? n.end - n.start + 1 > bc : !1, i = n && !a ? JSON.stringify(n) : "", [l, o] = (0, _react.useState)(Bn);
    return (0, _react.useEffect)(()=>{
        if (!i) {
            o(Bn);
            return;
        }
        if (!e) {
            o({
                ...Bn,
                unsupported: !0
            });
            return;
        }
        const d = JSON.parse(i), p = new AbortController();
        o((m)=>({
                seq: m.seq,
                start: m.start,
                error: null,
                loading: !0,
                unsupported: !1
            }));
        const g = setTimeout(()=>{
            e(d, {
                signal: p.signal
            }).then((m)=>{
                if (p.signal.aborted) return;
                const f = d.end - d.start + 1, u = typeof m == "string" && m.length === f;
                o({
                    seq: u ? m.toUpperCase() : null,
                    start: u ? d.start : 0,
                    error: null,
                    loading: !1,
                    unsupported: !1
                });
            }, (m)=>{
                !p.signal.aborted && !Ue(m) && o({
                    seq: null,
                    start: 0,
                    error: m,
                    loading: !1,
                    unsupported: !1
                });
            });
        }, r);
        return ()=>{
            clearTimeout(g), p.abort();
        };
    }, [
        e,
        i,
        r
    ]), l;
}
const Kn = {
    data: null,
    error: null,
    loading: !1,
    unsupported: !1
};
function _c(e, t, r = 300) {
    const n = t ? JSON.stringify(t) : "", a = typeof e.listVariants == "function", [i, l] = (0, _react.useState)(Kn);
    return (0, _react.useEffect)(()=>{
        if (!n) {
            l(Kn);
            return;
        }
        if (!a) {
            l({
                ...Kn,
                unsupported: !0
            });
            return;
        }
        const o = JSON.parse(n), d = new AbortController();
        l((g)=>({
                data: g.data,
                error: null,
                loading: !0,
                unsupported: !1
            }));
        const p = setTimeout(()=>{
            e.listVariants?.(o, {
                signal: d.signal
            }).then((g)=>{
                d.signal.aborted || l({
                    data: g,
                    error: null,
                    loading: !1,
                    unsupported: !1
                });
            }, (g)=>{
                !d.signal.aborted && !Ue(g) && l({
                    data: null,
                    error: g,
                    loading: !1,
                    unsupported: !1
                });
            });
        }, r);
        return ()=>{
            clearTimeout(p), d.abort();
        };
    }, [
        e,
        n,
        a,
        r
    ]), i;
}
function vc(e) {
    const t = e.value ?? {}, r = (o)=>`${e.idPrefix}-manual-${o}`, n = /* @__PURE__ */ new Set([
        "region",
        "position",
        "ref",
        "alt"
    ]), a = (o)=>e.issues.filter((d)=>d.field === o), i = e.issues.filter((o)=>!n.has(o.field)), l = (o)=>e.onChange({
            ...t,
            ...o
        });
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: "gpr-manual-variant",
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                className: "gpr-field-grid",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ot, {
                        id: r("region"),
                        label: "Sequence",
                        value: t.region ?? "",
                        placeholder: "1",
                        issues: a("region"),
                        disabled: e.disabled,
                        short: !0,
                        onChange: (o)=>l({
                                region: o
                            })
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(mt, {
                        id: r("position"),
                        label: "Position",
                        value: typeof t.position == "number" ? t.position : void 0,
                        min: 1,
                        step: 1,
                        issues: a("position"),
                        disabled: e.disabled,
                        onChange: (o)=>l({
                                position: o
                            })
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ot, {
                        id: r("ref"),
                        label: "Reference allele",
                        value: t.ref ?? "",
                        placeholder: "C",
                        issues: a("ref"),
                        disabled: e.disabled,
                        short: !0,
                        onChange: (o)=>l({
                                ref: o
                            })
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ot, {
                        id: r("alt"),
                        label: "Alternative allele",
                        value: t.alt ?? "",
                        placeholder: "A",
                        issues: a("alt"),
                        disabled: e.disabled,
                        short: !0,
                        onChange: (o)=>l({
                                alt: o
                            })
                    })
                ]
            }),
            e.refMismatch ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-field-error",
                role: "alert",
                "data-code": "REF_MISMATCH",
                children: [
                    "The genome has ",
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("code", {
                        className: "gpr-code",
                        children: e.refMismatch.genome
                    }),
                    " at this position, not ",
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("code", {
                        className: "gpr-code",
                        children: e.refMismatch.given
                    }),
                    "."
                ]
            }) : null,
            i.length ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("ul", {
                className: "gpr-plain-list gpr-manual-issues",
                children: i.map((o)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("li", {
                        className: "gpr-field-error",
                        children: o.message
                    }, `${o.field}-${o.code}`))
            }) : null,
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-hint",
                children: [
                    "Either style works. VCF: neither allele is ",
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("code", {
                        className: "gpr-code",
                        children: "-"
                    }),
                    ", and both carry the base before an indel. Ensembl: exactly one allele is",
                    " ",
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("code", {
                        className: "gpr-code",
                        children: "-"
                    }),
                    ", and for an insertion the position is the base ",
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("em", {
                        children: "after"
                    }),
                    " the insertion point. Alleles are A, C, G or T, up to",
                    " ",
                    ye.maxAlleleLength,
                    " bases."
                ]
            }),
            e.onCheckReference ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                className: "gpr-button-row",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "gpr-btn gpr-btn-small",
                        disabled: e.disabled || e.checking,
                        onClick: e.onCheckReference,
                        children: e.checking ? "Checking\u2026" : "Check reference"
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                        className: "gpr-hint",
                        children: "Verifies the reference allele against the genome without designing primers."
                    })
                ]
            }) : null
        ]
    });
}
const bn = Object.freeze([
    "#0072B2",
    "#E69F00",
    "#009E73",
    "#CC79A7",
    "#56B4E9",
    "#D55E00",
    "#8C6D1F",
    "#555555"
]);
function Hn(e) {
    if (!e) return bn[bn.length - 1];
    const t = parseInt(wr(e).slice(0, 8), 16);
    return bn[t % bn.length];
}
function Ms(e) {
    return e ? e.replace(/_/g, " ") : "no consequence reported";
}
const Vn = {
    genes: [],
    error: null,
    loading: !1,
    unsupported: !1
};
function xc(e, t, r = 250) {
    const n = t ? JSON.stringify(t) : "", [a, i] = (0, _react.useState)(Vn);
    return (0, _react.useEffect)(()=>{
        if (!n) {
            i(Vn);
            return;
        }
        if (!e) {
            i({
                ...Vn,
                unsupported: !0
            });
            return;
        }
        const l = JSON.parse(n), o = new AbortController();
        i((p)=>({
                genes: p.genes,
                error: null,
                loading: !0,
                unsupported: !1
            }));
        const d = setTimeout(()=>{
            e(l, {
                signal: o.signal
            }).then((p)=>{
                o.signal.aborted || i({
                    genes: p ?? [],
                    error: null,
                    loading: !1,
                    unsupported: !1
                });
            }, (p)=>{
                !o.signal.aborted && !Ue(p) && i({
                    genes: [],
                    error: p,
                    loading: !1,
                    unsupported: !1
                });
            });
        }, r);
        return ()=>{
            clearTimeout(d), o.abort();
        };
    }, [
        e,
        n,
        r
    ]), a;
}
function In(e) {
    const t = (0, _react.useRef)(/* @__PURE__ */ new Map()), r = JSON.stringify(e);
    return (0, _react.useMemo)(()=>{
        const n = ro(e, t.current);
        return t.current = n, n;
    }, [
        r
    ]);
}
const ct = 30, Rt = 24, dt = 36, kt = 16, Nc = 60, kc = 8, Wn = 74, Yn = 10, wc = 94, Ac = 88, Jn = 8, yn = 11, Cc = 8, Sc = 2, Tc = 8, Xn = 20, Mt = 12, Ps = 30, Os = 20;
function Ec(e, t) {
    const r = [
        ...e
    ].sort((i, l)=>i.left.start - l.left.start || i.right.end - l.right.end || i.rank - l.rank), n = [], a = /* @__PURE__ */ new Map();
    for (const i of r){
        let l = n.findIndex((o)=>o + t < i.left.start);
        l === -1 ? (l = n.length, n.push(i.right.end)) : n[l] = i.right.end, a.set(i.rank, l);
    }
    return a;
}
function zs(e, t, r) {
    return e.filter((n)=>n.end >= t && n.start <= r);
}
function Ic(e, t, r) {
    const n = [];
    return e.map((a)=>{
        let i = n.findIndex((l)=>l + t <= a.x0);
        if (i === -1) {
            if (n.length < r) return i = n.length, n.push(a.x1), i;
            i = r - 1;
        }
        return n[i] = Math.max(n[i] ?? a.x1, a.x1), i;
    });
}
function di(e, t, r = 8) {
    const a = Math.max(1, t - e) / Math.max(1, r), i = 10 ** Math.floor(Math.log10(a)), l = Math.max(1, [
        1,
        2,
        5,
        10
    ].map((d)=>d * i).find((d)=>d >= a) ?? 10 * i), o = [];
    for(let d = Math.ceil(e / l) * l; d <= t; d += l)o.push(d);
    return o;
}
function $c(e, t) {
    if (!t) return [
        {
            s: e.start,
            e: e.end,
            kind: "nc"
        }
    ];
    const r = [];
    e.start < t.start && r.push({
        s: e.start,
        e: Math.min(e.end, t.start - 1),
        kind: "utr5"
    });
    const n = Math.max(e.start, t.start), a = Math.min(e.end, t.end);
    return n <= a && r.push({
        s: n,
        e: a,
        kind: "cds"
    }), e.end > t.end && r.push({
        s: Math.max(e.start, t.end + 1),
        e: e.end,
        kind: "utr3"
    }), r.filter((i)=>i.s <= i.e);
}
function Ls(e, t, r, n, a) {
    const i = Math.max(4, t - e), l = Math.min(5, i * 0.6);
    if (a === 1) {
        const d = e + i;
        return `M${e},${r}H${d - l}L${d},${r + n / 2}L${d - l},${r + n}H${e}Z`;
    }
    const o = t - i;
    return `M${t},${r}H${o + l}L${o},${r + n / 2}L${o + l},${r + n}H${t}Z`;
}
function Rc(e) {
    const { enzyme: t, site: r } = e.mark, n = cr(e.template, r.start), a = cr(e.template, r.end), i = n && a ? `${n.region}:${v(Math.min(n.pos, a.pos))}\u{2013}${v(Math.max(n.pos, a.pos))}` : null, l = e.template.seq?.slice(r.start - 1, r.end) ?? "";
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: "gpr-map-tip",
        role: "tooltip",
        style: {
            left: e.left,
            top: e.top
        },
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                className: "gpr-map-tip-head",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                        className: "gpr-map-enzyme-swatch",
                        "aria-hidden": "true",
                        style: {
                            backgroundColor: e.colour
                        }
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("strong", {
                        children: t.name
                    })
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("dl", {
                className: "gpr-map-tip-rows",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("dt", {
                        children: "Location"
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("dd", {
                        children: [
                            "template ",
                            v(r.start),
                            "\u2013",
                            v(r.end),
                            i ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                className: "gpr-block",
                                children: i
                            }) : null,
                            r.strand === -1 ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                className: "gpr-block",
                                children: "reverse strand"
                            }) : null
                        ]
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("dt", {
                        children: "Recognition"
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("dd", {
                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("code", {
                            className: "gpr-seq",
                            children: _a(t)
                        })
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("dt", {
                        children: "Sequence"
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("dd", {
                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("code", {
                            className: "gpr-seq",
                            children: l
                        })
                    })
                ]
            })
        ]
    });
}
function Mc(e) {
    const { template: t, pairs: r = [], selectedRank: n, onSelect: a, target: i, included: l, excluded: o, enzymeSites: d = [] } = e, p = (0, _react.useMemo)(()=>new Set(e.selectedEnzymes ?? []), [
        e.selectedEnzymes
    ]), g = In(e.selectedEnzymes ?? []), m = e.enzymeColours ?? g, f = (E)=>m.get(E) ?? va(E), u = Math.max(1, t.length || t.seq?.length || 1), h = De("gpr-map"), y = (0, _react.useRef)(null), _ = (0, _react.useRef)(null), [k, b] = (0, _react.useState)(760);
    Gt(()=>{
        const E = y.current;
        if (!E) return;
        const G = ()=>{
            const Y = E.clientWidth;
            Y > 0 && b(Math.max(320, Math.round(Y)));
        };
        if (G(), typeof ResizeObserver > "u") return;
        const q = new ResizeObserver(G);
        return q.observe(E), ()=>q.disconnect();
    }, []);
    const [C, N] = (0, _react.useState)([
        1,
        u
    ]);
    (0, _react.useEffect)(()=>{
        N([
            1,
            u
        ]);
    }, [
        t,
        u
    ]);
    const w = rt(C[0], 1, u), R = rt(C[1], w, u), I = R - w + 1, M = k - 2 * ct, P = (E)=>ct + (E - w) / I * M, V = (E, G)=>Math.max(1, P(G + 1) - P(E)), $ = (0, _react.useMemo)(()=>Ec(r, Math.ceil(28 * u / Math.max(1, M))), [
        r,
        u,
        M
    ]), L = Math.min(Ps, r.length ? Math.max(...$.values()) + 1 : 0), z = (0, _react.useMemo)(()=>{
        const E = /* @__PURE__ */ new Map();
        for (const { enzyme: G, sites: q } of d)E.set(G.name, zs(q, w, R).length);
        return E;
    }, [
        d,
        w,
        R
    ]), K = [
        ...p
    ].sort().join(","), S = (0, _react.useMemo)(()=>{
        const E = [];
        for (const { enzyme: q, sites: Y } of d)if (p.has(q.name)) for (const Q of zs(Y, w, R)){
            const Z = P(Q.start);
            E.push({
                enzyme: q,
                site: Q,
                x0: Z,
                x1: Z + Math.max(2, V(Q.start, Q.end)),
                lane: 0
            });
        }
        E.sort((q, Y)=>q.x0 - Y.x0 || q.x1 - Y.x1 || q.enzyme.name.localeCompare(Y.enzyme.name));
        const G = Ic(E, Sc, Cc);
        return E.forEach((q, Y)=>q.lane = G[Y] ?? 0), E;
    }, [
        d,
        K,
        w,
        R,
        M
    ]), T = S.length ? Math.max(...S.map((E)=>E.lane)) + 1 : 0, W = wc + (T ? (T - 1) * yn + Jn + 6 : 0), [H, O] = (0, _react.useState)(null);
    (0, _react.useEffect)(()=>O(null), [
        w,
        R,
        K
    ]);
    const U = (E, G)=>{
        const q = y.current?.getBoundingClientRect();
        if (!q) return;
        const Y = 250, Q = G.clientX - q.left, Z = Q + 14 + Y > q.width ? Math.max(0, Q - 14 - Y) : Q + 14;
        O({
            mark: E,
            left: Z,
            top: G.clientY - q.top + 14
        });
    }, B = W + Math.max(1, L) * Xn + 6, ne = di(w, R, Math.max(3, Math.floor(M / 90))), [de, Ve] = (0, _react.useState)(null), xe = (E)=>{
        const G = _.current?.getBoundingClientRect();
        if (!G || G.width === 0) return;
        const q = (E.clientX - G.left) / G.width * k;
        if (q < ct || q > k - ct) {
            Ve(null);
            return;
        }
        Ve(rt(Math.floor(w + (q - ct) / M * I), w, R));
    }, Se = de !== null ? cr(t, de) : null, Te = r.find((E)=>E.rank === n) ?? null, Fe = (E, G)=>{
        const q = rt(Math.round(G), Math.min(Os, u), u);
        let Y = Math.round(E - q / 2);
        Y = rt(Y, 1, u - q + 1), N([
            Y,
            Y + q - 1
        ]);
    }, oe = (w + R) / 2, Oe = w === 1 && R === u, Ce = t.features ?? {}, re = [
        ...Ce.exons ?? []
    ].sort((E, G)=>E.start - G.start), fe = Ce.cds ?? null, Je = Ce.junctions ?? [], Xe = t.mask ?? [], Be = t.mode, Ne = dt + kt / 2, ze = t.region, Le = ze && typeof t.start == "number" && typeof t.end == "number" ? `${ze}:${v(t.start)}\u{2013}${v(t.end)} (${Wo(t.strand)})` : null, je = [
        `${v(u)} bp ${Be} template${Le ? ` at ${Le}` : ""}`,
        re.length ? `${re.length} exon${re.length === 1 ? "" : "s"}` : null,
        Je.length ? `${Je.length} junction${Je.length === 1 ? "" : "s"}` : null,
        Xe.length ? `${Xe.length} masked run${Xe.length === 1 ? "" : "s"}` : null,
        `${r.length} primer pair${r.length === 1 ? "" : "s"}`
    ].filter(Boolean).join(", "), et = (E, G)=>E.junction ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
            className: "gpr-map-notch",
            x1: P(E.junction.position + 1),
            x2: P(E.junction.position + 1),
            y1: G - 2,
            y2: G + Mt + 2
        }) : null, qe = [];
    if (re.length) {
        const E = re[0], G = re[re.length - 1];
        Be !== "transcript" && qe.push(/* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
            className: "gpr-map-intron",
            x1: P(E.start),
            x2: P(G.end + 1),
            y1: Ne,
            y2: Ne
        }, "intron")), re.forEach((q, Y)=>{
            if (Be === "transcript") qe.push(/* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                className: Y % 2 ? "gpr-map-exon gpr-map-exon-alt" : "gpr-map-exon",
                x: P(q.start),
                y: dt + 2,
                width: V(q.start, q.end),
                height: kt - 6,
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("title", {
                    children: `${q.id}: cDNA ${v(q.start)}\u{2013}${v(q.end)}`
                })
            }, `ex-${Y}`));
            else for (const Q of $c(q, fe)){
                const Z = Q.kind === "cds" || Q.kind === "nc";
                qe.push(/* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                    className: `gpr-map-feature gpr-map-${Q.kind}`,
                    x: P(Q.s),
                    y: Z ? dt : dt + 3,
                    width: V(Q.s, Q.e),
                    height: Z ? kt : kt - 6,
                    children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("title", {
                        children: `${q.id} ${Q.kind === "nc" ? "exon" : Q.kind.toUpperCase()}: ${v(Q.s)}\u{2013}${v(Q.e)}`
                    })
                }, `ex-${Y}-${Q.kind}-${Q.s}`));
            }
        }), Be === "transcript" && fe && qe.push(/* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
            className: "gpr-map-cds-band",
            x: P(fe.start),
            y: dt + kt - 3,
            width: V(fe.start, fe.end),
            height: 3,
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("title", {
                children: `CDS: ${v(fe.start)}\u{2013}${v(fe.end)}`
            })
        }, "cds-band"));
    } else Ce.gene && qe.push(/* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
        className: "gpr-map-feature gpr-map-nc",
        x: P(Ce.gene.start),
        y: dt + 3,
        width: V(Ce.gene.start, Ce.gene.end),
        height: kt - 6,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("title", {
            children: `Gene: ${v(Ce.gene.start)}\u{2013}${v(Ce.gene.end)}`
        })
    }, "gene"));
    Je.forEach((E)=>qe.push(/* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
            className: "gpr-map-junction",
            x1: P(E + 1),
            x2: P(E + 1),
            y1: dt - 3,
            y2: dt + kt + 2
        }, `j-${E}`)));
    const we = [];
    return re.length && Be !== "transcript" && (fe ? we.push([
        "gpr-map-cds",
        "CDS"
    ], [
        "gpr-map-utr5",
        "5\u2032 UTR"
    ], [
        "gpr-map-utr3",
        "3\u2032 UTR"
    ]) : we.push([
        "gpr-map-nc",
        "exon"
    ]), we.push([
        "gpr-map-intron",
        "intron"
    ])), Be === "transcript" && re.length && we.push([
        "gpr-map-exon",
        "exon"
    ], [
        "gpr-map-cds-band",
        "CDS"
    ], [
        "gpr-map-junction",
        "junction"
    ]), Xe.length && we.push([
        "gpr-map-mask",
        "repeat mask"
    ]), i && we.push([
        "gpr-map-target",
        "target"
    ]), l && we.push([
        "gpr-map-included",
        "included"
    ]), o?.length && we.push([
        "gpr-map-excluded",
        "excluded"
    ]), r.length && we.push([
        "gpr-map-primer",
        "primers"
    ]), /* @__PURE__ */ (0, _jsxRuntime.jsx)(bt, {
        theme: e.theme,
        injectStyles: e.injectStyles,
        className: e.className,
        style: e.style,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
            className: "gpr-map",
            ref: y,
            children: [
                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                    className: "gpr-map-toolbar",
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                            className: "gpr-map-actions",
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    className: "gpr-btn gpr-btn-small",
                                    disabled: Oe,
                                    onClick: ()=>N([
                                            1,
                                            u
                                        ]),
                                    children: "Fit"
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    className: "gpr-btn gpr-btn-small",
                                    disabled: I <= Math.min(Os, u),
                                    onClick: ()=>Fe(oe, I / 2),
                                    children: "Zoom in"
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    className: "gpr-btn gpr-btn-small",
                                    disabled: Oe,
                                    onClick: ()=>Fe(oe, I * 2),
                                    children: "Zoom out"
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    className: "gpr-btn gpr-btn-small",
                                    disabled: w <= 1,
                                    "aria-label": "Pan left",
                                    onClick: ()=>Fe(oe - I / 2, I),
                                    children: "\u2190"
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    className: "gpr-btn gpr-btn-small",
                                    disabled: R >= u,
                                    "aria-label": "Pan right",
                                    onClick: ()=>Fe(oe + I / 2, I),
                                    children: "\u2192"
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    className: "gpr-btn gpr-btn-small",
                                    disabled: !Te,
                                    onClick: ()=>{
                                        if (!Te) return;
                                        const E = Te.left.start, G = Te.right.end, q = Math.max(10, Math.round((G - E + 1) * 0.15)), Y = rt(E - q, 1, u), Q = rt(G + q, Y, u);
                                        N([
                                            Y,
                                            Q
                                        ]);
                                    },
                                    children: "Zoom to pair"
                                })
                            ]
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                            className: "gpr-map-view",
                            children: [
                                v(w),
                                "\u2013",
                                v(R),
                                " of ",
                                v(u),
                                " bp",
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                    className: "gpr-map-hover",
                                    "aria-hidden": "true",
                                    children: de !== null ? ` \xb7 position ${v(de)}${Se ? ` = ${Se.region}:${v(Se.pos)}` : ""}` : ""
                                })
                            ]
                        })
                    ]
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("svg", {
                    ref: _,
                    className: "gpr-map-svg",
                    role: "group",
                    "aria-label": e.title ?? "Template map",
                    "aria-describedby": `${h}-desc`,
                    width: k,
                    height: B,
                    viewBox: `0 0 ${k} ${B}`,
                    onMouseMove: xe,
                    onMouseLeave: ()=>Ve(null),
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("desc", {
                            id: `${h}-desc`,
                            children: je
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("defs", {
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("clipPath", {
                                    id: `${h}-clip`,
                                    children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                                        x: ct,
                                        y: 0,
                                        width: M,
                                        height: B
                                    })
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("pattern", {
                                    id: `${h}-hatch`,
                                    width: 6,
                                    height: 6,
                                    patternUnits: "userSpaceOnUse",
                                    patternTransform: "rotate(45)",
                                    children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                                        className: "gpr-map-hatch-line",
                                        x1: 0,
                                        y1: 0,
                                        x2: 0,
                                        y2: 6
                                    })
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("pattern", {
                                    id: `${h}-exhatch`,
                                    width: 6,
                                    height: 6,
                                    patternUnits: "userSpaceOnUse",
                                    patternTransform: "rotate(-45)",
                                    children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                                        className: "gpr-map-exhatch-line",
                                        x1: 0,
                                        y1: 0,
                                        x2: 0,
                                        y2: 6
                                    })
                                })
                            ]
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("g", {
                            className: "gpr-map-ruler",
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("title", {
                                    children: `Template positions ${v(w)}\u{2013}${v(R)}${Le ? `; genomic ${Le}` : ""}`
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                                    className: "gpr-map-axis",
                                    x1: ct,
                                    x2: k - ct,
                                    y1: Rt,
                                    y2: Rt
                                }),
                                ne.map((E)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("g", {
                                        children: [
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                                                className: "gpr-map-tick",
                                                x1: P(E),
                                                x2: P(E),
                                                y1: Rt,
                                                y2: Rt + 4
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("text", {
                                                className: "gpr-map-tick-label",
                                                x: P(E),
                                                y: Rt - 6,
                                                textAnchor: "middle",
                                                children: v(E)
                                            })
                                        ]
                                    }, E))
                            ]
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("g", {
                            clipPath: `url(#${h}-clip)`,
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("g", {
                                    className: "gpr-map-features",
                                    children: qe
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("g", {
                                    className: "gpr-map-masks",
                                    children: Xe.map(([E, G], q)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                                            className: "gpr-map-mask",
                                            x: P(E),
                                            y: Nc,
                                            width: V(E, E + G - 1),
                                            height: kc,
                                            fill: `url(#${h}-hatch)`,
                                            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("title", {
                                                children: `Masked ${v(E)}\u{2013}${v(E + G - 1)}`
                                            })
                                        }, `m-${q}`))
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("g", {
                                    className: "gpr-map-intervals",
                                    children: [
                                        l ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                                            className: "gpr-map-included",
                                            x: P(l[0]),
                                            y: Wn,
                                            width: V(l[0], l[0] + l[1] - 1),
                                            height: Yn,
                                            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("title", {
                                                children: `Included ${v(l[0])}\u{2013}${v(l[0] + l[1] - 1)}`
                                            })
                                        }) : null,
                                        (o ?? []).map(([E, G], q)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                                                className: "gpr-map-excluded",
                                                x: P(E),
                                                y: Wn,
                                                width: V(E, E + G - 1),
                                                height: Yn,
                                                fill: `url(#${h}-exhatch)`,
                                                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("title", {
                                                    children: `Excluded ${v(E)}\u{2013}${v(E + G - 1)}`
                                                })
                                            }, `x-${q}`)),
                                        i ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                                            className: "gpr-map-target",
                                            x: P(i[0]),
                                            y: Wn + 2,
                                            width: V(i[0], i[0] + i[1] - 1),
                                            height: Yn - 4,
                                            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("title", {
                                                children: `Target ${v(i[0])}\u{2013}${v(i[0] + i[1] - 1)}`
                                            })
                                        }) : null
                                    ]
                                }),
                                S.length ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("g", {
                                    className: "gpr-map-sites",
                                    onMouseLeave: ()=>O(null),
                                    children: S.map((E)=>{
                                        const G = H?.mark === E, q = Ac + E.lane * yn, Y = E.x1 - E.x0, Q = Math.max(Y, Tc);
                                        return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("g", {
                                            onMouseEnter: (Z)=>U(E, Z),
                                            onMouseMove: (Z)=>U(E, Z),
                                            children: [
                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                                                    className: "gpr-map-site",
                                                    "data-enzyme": E.enzyme.name,
                                                    "data-lane": E.lane,
                                                    "data-state": G ? "hover" : void 0,
                                                    x: E.x0,
                                                    y: q,
                                                    width: Y,
                                                    height: Jn,
                                                    style: {
                                                        fill: f(E.enzyme.name)
                                                    }
                                                }),
                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                                                    className: "gpr-map-site-hit",
                                                    x: E.x0 + Y / 2 - Q / 2,
                                                    y: q - (yn - Jn) / 2,
                                                    width: Q,
                                                    height: yn
                                                })
                                            ]
                                        }, `${E.enzyme.name}-${E.site.start}-${E.site.strand ?? 1}`);
                                    })
                                }) : null,
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("g", {
                                    className: "gpr-map-pairs",
                                    children: r.map((E)=>{
                                        const G = Math.min(Ps - 1, $.get(E.rank) ?? 0), q = W + G * Xn, Y = E.rank === n, Q = `Pair ${E.rank + 1}: ${v(E.product_size)} bp product, left primer ${v(E.left.start)}\u{2013}${v(E.left.end)}, right primer ${v(E.right.start)}\u{2013}${v(E.right.end)}`, Z = !!a;
                                        return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("g", {
                                            className: "gpr-map-pair",
                                            "data-state": Y ? "selected" : void 0,
                                            "data-rank": E.rank,
                                            role: Z ? "button" : void 0,
                                            tabIndex: Z ? 0 : void 0,
                                            "aria-pressed": Z ? Y : void 0,
                                            "aria-label": Z ? Q : void 0,
                                            onClick: Z ? ()=>a(E.rank) : void 0,
                                            onKeyDown: Z ? (ke)=>{
                                                (ke.key === "Enter" || ke.key === " ") && (ke.preventDefault(), a(E.rank));
                                            } : void 0,
                                            children: [
                                                Z ? null : /* @__PURE__ */ (0, _jsxRuntime.jsx)("title", {
                                                    children: Q
                                                }),
                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                                                    className: "gpr-map-pair-hit",
                                                    x: P(E.left.start) - 24,
                                                    y: q - 3,
                                                    width: Math.max(8, P(E.right.end + 1) - P(E.left.start) + 26),
                                                    height: Xn - 2
                                                }),
                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                                                    className: "gpr-map-product",
                                                    x1: P(E.left.start),
                                                    x2: P(E.right.end + 1),
                                                    y1: q + Mt / 2,
                                                    y2: q + Mt / 2
                                                }),
                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("path", {
                                                    className: "gpr-map-primer gpr-map-primer-left",
                                                    d: Ls(P(E.left.start), P(E.left.end + 1), q, Mt, 1)
                                                }),
                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("path", {
                                                    className: "gpr-map-primer gpr-map-primer-right",
                                                    d: Ls(P(E.right.start), P(E.right.end + 1), q, Mt, -1)
                                                }),
                                                et(E.left, q),
                                                et(E.right, q),
                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("text", {
                                                    className: "gpr-map-pair-label",
                                                    x: P(E.left.start) - 3,
                                                    y: q + Mt - 2,
                                                    textAnchor: "end",
                                                    children: Yo(E.rank)
                                                })
                                            ]
                                        }, E.rank);
                                    })
                                })
                            ]
                        }),
                        de !== null ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                            className: "gpr-map-guide",
                            x1: P(de) + V(de, de) / 2,
                            x2: P(de) + V(de, de) / 2,
                            y1: Rt,
                            y2: B
                        }) : null
                    ]
                }),
                H ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(Rc, {
                    template: t,
                    colour: f(H.mark.enzyme.name),
                    ...H
                }) : null,
                d.length ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("details", {
                    className: "gpr-map-enzymes",
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("summary", {
                            children: [
                                "Restriction sites",
                                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                    className: "gpr-sub",
                                    children: [
                                        " ",
                                        p.size ? `${v(p.size)} shown` : "none shown"
                                    ]
                                })
                            ]
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                            className: "gpr-map-enzyme-actions",
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    className: "gpr-btn gpr-btn-small gpr-btn-quiet",
                                    disabled: p.size === d.length,
                                    onClick: ()=>e.onSelectEnzymes?.(d.map((E)=>E.enzyme.name)),
                                    children: "Select all"
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    className: "gpr-btn gpr-btn-small gpr-btn-quiet",
                                    disabled: p.size === 0,
                                    onClick: ()=>e.onSelectEnzymes?.([]),
                                    children: "Select none"
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                    className: "gpr-sub",
                                    children: Oe ? "Sites in the whole template" : `Sites in view, ${v(w)}\u{2013}${v(R)}`
                                })
                            ]
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("ul", {
                            className: "gpr-map-enzyme-list",
                            children: d.map(({ enzyme: E })=>{
                                const G = E.name, q = p.has(G), Y = z.get(G) ?? 0;
                                return(// Greyed rather than hidden or disabled: the list stays put as
                                // the view moves, and an enzyme with nothing here may well
                                // have sites a pan away.
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("li", {
                                    "data-empty": Y === 0 ? "true" : void 0,
                                    children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("label", {
                                        className: "gpr-check-row",
                                        children: [
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                                                type: "checkbox",
                                                className: "gpr-checkbox",
                                                checked: q,
                                                onChange: (Q)=>{
                                                    const Z = new Set(p);
                                                    Q.target.checked ? Z.add(G) : Z.delete(G), e.onSelectEnzymes?.([
                                                        ...Z
                                                    ]);
                                                }
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                className: "gpr-map-enzyme-swatch",
                                                "aria-hidden": "true",
                                                "data-off": q ? void 0 : "true",
                                                style: q ? {
                                                    backgroundColor: f(G)
                                                } : void 0
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                className: "gpr-label",
                                                children: [
                                                    G,
                                                    " ",
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "gpr-map-enzyme-count",
                                                        children: [
                                                            "(",
                                                            v(Y),
                                                            ")"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, G));
                            })
                        })
                    ]
                }) : null,
                we.length ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("ul", {
                    className: "gpr-map-legend",
                    "aria-label": "Map legend",
                    children: we.map(([E, G])=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("li", {
                            className: "gpr-map-legend-item",
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("svg", {
                                    className: "gpr-map-swatch",
                                    width: 14,
                                    height: 10,
                                    "aria-hidden": "true",
                                    focusable: "false",
                                    children: E === "gpr-map-intron" || E === "gpr-map-junction" ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                                        className: E,
                                        x1: 0,
                                        x2: 14,
                                        y1: 5,
                                        y2: 5
                                    }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                                        className: E,
                                        x: 0,
                                        y: 0,
                                        width: 14,
                                        height: 10,
                                        fill: E === "gpr-map-mask" ? `url(#${h}-hatch)` : E === "gpr-map-excluded" ? `url(#${h}-exhatch)` : void 0
                                    })
                                }),
                                G
                            ]
                        }, E))
                }) : null
            ]
        })
    });
}
const _n = 34, Vt = 18, qs = 34, Qn = 11, Gs = 16, Ds = 6, vn = 16, js = 40;
function Pc(e) {
    return !Number.isFinite(e.start) || !Number.isFinite(e.end) ? null : {
        id: e.id,
        label: e.label || e.id,
        start: e.start,
        end: e.end,
        strand: e.strand === -1 ? -1 : 1,
        exons: e.exons?.length ? [
            ...e.exons
        ].sort((t, r)=>t.start - r.start) : [
            {
                start: e.start,
                end: e.end
            }
        ],
        cds: e.cds ?? null
    };
}
function Oc(e, t) {
    const r = [
        ...e
    ].sort((i, l)=>i.start - l.start || i.end - l.end), n = [], a = /* @__PURE__ */ new Map();
    for (const i of r){
        let l = n.findIndex((o)=>o + t < i.start);
        l === -1 ? (l = n.length, n.push(i.end)) : n[l] = i.end, a.set(i.id, l);
    }
    return a;
}
function zc(e) {
    const t = De("gpr-browser"), r = (0, _react.useRef)(null), [n, a] = (0, _react.useState)(760);
    (0, _react.useEffect)(()=>{
        const S = r.current;
        if (!S) return;
        const T = ()=>a(Math.max(320, S.clientWidth));
        if (T(), typeof ResizeObserver > "u") return;
        const W = new ResizeObserver(T);
        return W.observe(S), ()=>W.disconnect();
    }, []);
    const [i, l] = (0, _react.useState)([
        e.window.start,
        e.window.end
    ]);
    (0, _react.useEffect)(()=>{
        l([
            e.window.start,
            e.window.end
        ]);
    }, [
        e.window.start,
        e.window.end
    ]);
    const o = Math.max(1, Math.round(i[0])), d = Math.max(o + js - 1, Math.round(i[1])), p = d - o + 1, g = n - 2 * _n, m = (S)=>_n + (S - o) / p * g, f = e.systemName && e.region ? {
        system_name: e.systemName,
        region: e.region,
        start: o,
        end: d
    } : null, u = xc(e.genesInRegion, f), y = (0, _react.useMemo)(()=>u.genes.map(Pc).filter((S)=>!!S), [
        u.genes
    ]).filter((S)=>S.end >= o && S.start <= d), _ = (0, _react.useMemo)(()=>Oc(y, Math.ceil(60 * p / Math.max(1, g))), [
        y,
        p,
        g
    ]), k = Math.min(Ds, y.length ? Math.max(..._.values()) + 1 : 0), b = qs + k * Gs + 12, C = b + vn + 22, N = e.variants.filter((S)=>S.vcf.position >= o && S.vcf.position <= d), w = (0, _react.useMemo)(()=>{
        const S = /* @__PURE__ */ new Map();
        for (const T of N)S.has(T.consequence ?? "") || S.set(T.consequence ?? "", Hn(T.consequence));
        return [
            ...S
        ].sort((T, W)=>T[0].localeCompare(W[0]));
    }, [
        N
    ]), R = (S, T)=>{
        const W = Math.max(js, Math.round(T)), H = Math.max(1, Math.round(S - W / 2));
        l([
            H,
            H + W - 1
        ]);
    }, I = (S)=>{
        const T = Math.round(p * S);
        l([
            Math.max(1, o + T),
            Math.max(1 + p - 1, d + T)
        ]);
    }, M = (0, _react.useRef)(null), P = (S)=>{
        if (!e.disabled) {
            M.current = {
                x: S.clientX,
                v0: o,
                v1: d
            };
            try {
                S.currentTarget.setPointerCapture(S.pointerId);
            } catch  {}
        }
    }, V = (S)=>{
        const T = M.current;
        if (!T || g <= 0) return;
        const W = S.currentTarget.getBoundingClientRect(), H = p / Math.max(1, W.width * g / n), O = Math.round((T.x - S.clientX) * H), U = Math.max(1, T.v0 + O);
        l([
            U,
            U + (T.v1 - T.v0)
        ]);
    }, $ = (S)=>{
        M.current = null;
        try {
            S.currentTarget.releasePointerCapture(S.pointerId);
        } catch  {}
    }, L = di(o, d, Math.max(3, Math.floor(g / 90))), z = p > e.maxWindow, K = `${e.region}:${v(o)}\u{2013}${v(d)}, ${v(p)} bp, ${v(N.length)} variant${N.length === 1 ? "" : "s"}${y.length ? `, ${v(y.length)} gene${y.length === 1 ? "" : "s"}` : ""}`;
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: "gpr-browser",
        ref: r,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                className: "gpr-browser-toolbar",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                        className: "gpr-browser-loc",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("code", {
                                className: "gpr-code",
                                children: [
                                    e.region,
                                    ":",
                                    v(o),
                                    "\u2013",
                                    v(d)
                                ]
                            }),
                            " ",
                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                className: "gpr-sub",
                                children: [
                                    v(p),
                                    " bp"
                                ]
                            })
                        ]
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                        className: "gpr-button-row",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: "gpr-btn gpr-btn-small",
                                disabled: e.disabled,
                                "aria-label": "Pan left",
                                onClick: ()=>I(-0.25),
                                children: "\u2190"
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: "gpr-btn gpr-btn-small",
                                disabled: e.disabled,
                                "aria-label": "Pan right",
                                onClick: ()=>I(0.25),
                                children: "\u2192"
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: "gpr-btn gpr-btn-small",
                                disabled: e.disabled,
                                "aria-label": "Zoom in",
                                onClick: ()=>R((o + d) / 2, p / 2),
                                children: "+"
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: "gpr-btn gpr-btn-small",
                                disabled: e.disabled,
                                "aria-label": "Zoom out",
                                onClick: ()=>R((o + d) / 2, p * 2),
                                children: "\u2212"
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: "gpr-btn gpr-btn-small gpr-btn-quiet",
                                disabled: e.disabled,
                                onClick: ()=>l([
                                        e.window.start,
                                        e.window.end
                                    ]),
                                children: "Fit to listing"
                            })
                        ]
                    }),
                    e.onUseRegion ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "gpr-btn gpr-btn-small",
                        disabled: e.disabled || z,
                        title: z ? `Zoom in: at most ${v(e.maxWindow)} bp can be listed` : void 0,
                        onClick: ()=>e.onUseRegion?.(o, d),
                        children: "List this region"
                    }) : null
                ]
            }),
            z ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-hint",
                children: [
                    "This view spans ",
                    v(p),
                    " bp; at most ",
                    v(e.maxWindow),
                    " bp can be listed at once."
                ]
            }) : null,
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("svg", {
                className: "gpr-browser-svg",
                role: "img",
                "aria-label": K,
                viewBox: `0 0 ${n} ${C}`,
                style: {
                    width: "100%",
                    height: C
                },
                onPointerDown: P,
                onPointerMove: V,
                onPointerUp: $,
                onPointerCancel: $,
                children: [
                    L.map((S)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("g", {
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                                    className: "gpr-map-tick",
                                    x1: m(S),
                                    x2: m(S),
                                    y1: Vt - 4,
                                    y2: Vt
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("text", {
                                    className: "gpr-map-tick-label",
                                    x: m(S),
                                    y: Vt - 6,
                                    textAnchor: "middle",
                                    children: v(S)
                                })
                            ]
                        }, S)),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                        className: "gpr-map-axis",
                        x1: _n,
                        x2: n - _n,
                        y1: Vt,
                        y2: Vt
                    }),
                    y.map((S)=>{
                        const T = _.get(S.id) ?? 0;
                        if (T >= Ds) return null;
                        const W = qs + T * Gs;
                        return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("g", {
                            className: "gpr-browser-gene",
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("title", {
                                    children: `${S.label} ${S.start}\u{2013}${S.end} (${S.strand === -1 ? "\u2212" : "+"})`
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                                    className: "gpr-map-intron",
                                    x1: m(S.start),
                                    x2: m(S.end),
                                    y1: W + Qn / 2,
                                    y2: W + Qn / 2
                                }),
                                S.exons.map((H, O)=>{
                                    const U = S.cds && H.end >= S.cds.start && H.start <= S.cds.end;
                                    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
                                        className: U ? "gpr-map-cds" : "gpr-map-exon",
                                        x: m(H.start),
                                        y: W,
                                        width: Math.max(1, m(H.end + 1) - m(H.start)),
                                        height: Qn
                                    }, O);
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("text", {
                                    className: "gpr-browser-gene-label",
                                    x: m(Math.max(S.start, o)) + 2,
                                    y: W - 1,
                                    children: [
                                        S.label,
                                        " ",
                                        S.strand === -1 ? "\u2190" : "\u2192"
                                    ]
                                })
                            ]
                        }, S.id);
                    }),
                    N.map((S)=>{
                        const T = m(S.vcf.position), W = e.selectedKey === S.key, H = e.caps?.get(S.key), O = !!H && !H.unknown && H.verdict === "caps";
                        return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("g", {
                            className: "gpr-browser-variant",
                            "data-state": W ? "selected" : void 0,
                            "data-designable": S.designable ? "true" : "false",
                            onClick: ()=>{
                                S.designable && e.onSelect?.(S);
                            },
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("title", {
                                    children: `${S.label} \xb7 ${S.kind} \xb7 ${Ms(S.consequence)}${O ? ` \xb7 ${H.sites[0].enzyme.name} cuts one allele` : ""}${S.designable ? "" : " \xb7 cannot be designed"}`
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("line", {
                                    x1: T,
                                    x2: T,
                                    y1: b,
                                    y2: b + vn,
                                    stroke: Hn(S.consequence)
                                }),
                                O ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("circle", {
                                    className: "gpr-browser-caps",
                                    cx: T,
                                    cy: b + vn,
                                    r: W ? 8 : 6.5,
                                    fill: "none"
                                }) : null,
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("circle", {
                                    cx: T,
                                    cy: b + vn,
                                    r: W ? 5 : 3.5,
                                    fill: Hn(S.consequence)
                                })
                            ]
                        }, S.key);
                    })
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                className: "gpr-browser-legend",
                children: [
                    u.unsupported ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                        className: "gpr-sub",
                        children: "Gene models are not available here."
                    }) : null,
                    u.loading ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                        className: "gpr-sub",
                        children: "Loading gene models\u2026"
                    }) : null,
                    u.error ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                        className: "gpr-sub",
                        children: "Gene models could not be loaded."
                    }) : null,
                    e.variants.some((S)=>{
                        const T = e.caps?.get(S.key);
                        return !!T && !T.unknown && T.verdict === "caps";
                    }) ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                        className: "gpr-browser-key",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("svg", {
                                className: "gpr-browser-caps-key",
                                viewBox: "0 0 14 14",
                                "aria-hidden": "true",
                                focusable: "false",
                                children: [
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("circle", {
                                        className: "gpr-browser-caps",
                                        cx: "7",
                                        cy: "7",
                                        r: "5.5",
                                        fill: "none"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("circle", {
                                        cx: "7",
                                        cy: "7",
                                        r: "2.5"
                                    })
                                ]
                            }),
                            "cut differently by an enzyme"
                        ]
                    }) : null,
                    w.map(([S, T])=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                            className: "gpr-browser-key",
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                    className: "gpr-browser-swatch",
                                    "aria-hidden": "true",
                                    style: {
                                        backgroundColor: T
                                    }
                                }),
                                Ms(S)
                            ]
                        }, S))
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                className: "gpr-hint",
                id: `${t}-help`,
                children: "Drag to pan, or use the buttons. The browser shows the rows the table is showing, so filtering here and there agree."
            })
        ]
    });
}
const xn = [
    "snv",
    "mnv",
    "insertion",
    "deletion",
    "complex"
], Zn = 0.05, Lc = Object.freeze({
    snv: "Single nucleotide variant: one base changed, such as C/T. The most straightforward kind to tell apart by allele-specific PCR.",
    mnv: "Multi-nucleotide variant: several adjacent bases changed together, the same number of them in each allele.",
    insertion: "Bases added between two positions, listed at the gap between them: 1:513^514 -/AA.",
    deletion: "Bases removed, listed over the bases that go: 1:259-262 CAAA/-.",
    complex: "A change that is not a plain substitution, insertion or deletion \u2014 usually bases altered and the length changed at once."
}), qc = [
    {
        key: "position",
        label: "Position"
    },
    {
        key: "label",
        label: "Change"
    },
    {
        key: "kind",
        label: "Kind"
    },
    {
        key: "ids",
        label: "Ids"
    },
    {
        key: "consequence",
        label: "Consequence"
    },
    {
        key: "frequency",
        label: "Frequency"
    },
    {
        key: "caps",
        label: "CAPS"
    },
    {
        key: "designable",
        label: "Designable"
    }
];
function Us(e) {
    return !e || e.unknown ? 0 : e.verdict === "caps" ? 3 : e.verdict === "dcaps" ? 2 : 1;
}
function Gc(e, t, r) {
    const n = (a, i)=>a.vcf.position - i.vcf.position || a.key.localeCompare(i.key);
    switch(e){
        case "label":
            return (a, i)=>a.label.localeCompare(i.label) || n(a, i);
        case "kind":
            return (a, i)=>a.kind.localeCompare(i.kind) || n(a, i);
        case "ids":
            return (a, i)=>(a.ids[0] ?? "").localeCompare(i.ids[0] ?? "") || n(a, i);
        case "consequence":
            return (a, i)=>(a.consequence ?? "~").localeCompare(i.consequence ?? "~") || n(a, i);
        case "frequency":
            return (a, i)=>(r(i) ?? -1) - (r(a) ?? -1) || n(a, i);
        case "caps":
            return (a, i)=>Us(t.get(i.key)) - Us(t.get(a.key)) || n(a, i);
        case "designable":
            return (a, i)=>Number(i.designable) - Number(a.designable) || n(a, i);
        default:
            return n;
    }
}
function Fs(e) {
    return Me(e) && (e.code === "FEATURE_DISABLED" || e.code === "VARIATION_SOURCE_UNAVAILABLE" || e.code === "NO_VARIATION_DATA") ? e.code : null;
}
function Dc(e) {
    return !!e.region && Number.isInteger(e.position) && !!e.ref && !!e.alt;
}
function Nn(e) {
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: "gpr-field gpr-variant-facet",
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("label", {
                className: "gpr-label",
                htmlFor: e.id,
                children: e.label
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("select", {
                id: e.id,
                className: "gpr-select gpr-select-small",
                value: e.value,
                disabled: e.disabled || e.options.length < 2,
                onChange: (t)=>e.onChange(t.target.value),
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("option", {
                        value: "",
                        children: e.anyLabel
                    }),
                    e.options.map(([t, r])=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("option", {
                            value: t,
                            children: [
                                t.replace(/_/g, " "),
                                " (",
                                r,
                                ")"
                            ]
                        }, t))
                ]
            })
        ]
    });
}
const jc = {
    "no-sequence": "No reference sequence is available here, so restriction sites cannot be checked.",
    "window-mismatch": "The reference sequence disagrees with the reported alleles, so no site can be trusted.",
    "out-of-window": "This variant lies outside the fetched sequence.",
    "ref-mismatch": "The reference allele does not match the sequence at this position."
};
function Uc({ annotation: e }) {
    if (!e || e.unknown) return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
        className: "gpr-chip gpr-chip-muted",
        title: jc[e?.unknown ?? "no-sequence"],
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                className: "gpr-chip-glyph",
                "aria-hidden": "true",
                children: "\xb7"
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                className: "gpr-chip-text",
                children: "Unknown"
            })
        ]
    });
    if (e.verdict === "caps") {
        const t = e.sites[0], r = e.sites.length - 1;
        return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
            className: "gpr-chip gpr-chip-ok",
            title: `${t.enzyme.name} (${t.enzyme.site}) cuts the ${t.cuts === "ref" ? "reference" : "alternate"} allele and not the other. Fragment sizes depend on the amplicon.`,
            children: [
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                    className: "gpr-chip-glyph",
                    "aria-hidden": "true",
                    children: "\u2702"
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                    className: "gpr-chip-text",
                    children: t.enzyme.name
                }),
                r > 0 ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                    className: "gpr-caps-more",
                    children: [
                        " +",
                        r
                    ]
                }) : null
            ]
        });
    }
    if (e.verdict === "dcaps") {
        const t = e.dcaps[0];
        return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
            className: "gpr-chip gpr-chip-warn",
            title: `No natural site. A primer carrying ${t.from}\u{2192}${t.to} ${t.offset} bp ${t.side} of the variant would create a ${t.enzyme.name} (${t.enzyme.site}) site in the ${t.cuts === "ref" ? "reference" : "alternate"} allele. The primer is not designed here.`,
            children: [
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                    className: "gpr-chip-glyph",
                    "aria-hidden": "true",
                    children: "~"
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                    className: "gpr-chip-text",
                    children: "dCAPS"
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                    className: "gpr-caps-more",
                    children: [
                        " ",
                        t.enzyme.name
                    ]
                })
            ]
        });
    }
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
        className: "gpr-chip gpr-chip-muted",
        title: "No enzyme in the panel tells the alleles apart, with or without a modified primer.",
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                className: "gpr-chip-glyph",
                "aria-hidden": "true",
                children: "\u2013"
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                className: "gpr-chip-text",
                children: "None"
            })
        ]
    });
}
function Fc(e) {
    if (!e.share) return e.pending ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
        className: "gpr-sub",
        title: "Still being looked up.",
        children: "\u2026"
    }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
        className: "gpr-sub",
        title: "This panel reports no frequency for this variant.",
        children: "\u2013"
    });
    const t = e.share.frequency * 100;
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
        className: "gpr-freq",
        title: `${(e.share.frequency * 100).toFixed(2)}% in ${e.share.population}${e.share.count !== null ? `, from ${v(e.share.count)} chromosomes` : ""}`,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                className: "gpr-freq-value",
                children: [
                    t < 1 ? t.toFixed(2) : t.toFixed(1),
                    "%"
                ]
            }),
            e.share.count !== null ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                className: "gpr-sub",
                children: [
                    " n=",
                    v(e.share.count)
                ]
            }) : null,
            e.named ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                className: "gpr-sub gpr-block",
                children: e.share.population
            }) : null
        ]
    });
}
function Bc(e) {
    return e?.name ? e.release ? `${e.name} ${e.release} variants` : `${e.name} variants` : "manual entry only";
}
function Kc(e) {
    const t = De("gpr-variant"), [r, n] = (0, _react.useState)(""), [a, i] = (0, _react.useState)(null), [l, o] = (0, _react.useState)(()=>e.state.manual ?? {}), [d, p] = (0, _react.useState)(null), [g, m] = (0, _react.useState)(!1), [f, u] = (0, _react.useState)(!1), [h, y] = (0, _react.useState)(!1), [_, k] = (0, _react.useState)({
        key: "position",
        dir: 1
    }), [b, C] = (0, _react.useState)(""), [N, w] = (0, _react.useState)(""), [R, I] = (0, _react.useState)(!1), [M, P] = (0, _react.useState)(!1), [V, $] = (0, _react.useState)(!1), [L, z] = (0, _react.useState)(""), [K, S] = (0, _react.useState)(""), [T, W] = (0, _react.useState)(!1), H = (0, _react.useRef)(null), O = e.state.window ?? e.defaultWindow ?? null, U = e.state.filters ?? {}, B = O ? O.end - O.start + 1 : 0, ne = B > ye.maxWindow, de = !!O && O.region.length > 0 && O.start >= 1 && O.end >= O.start && !ne, Ve = (0, _react.useMemo)(()=>{
        if (!e.variationAvailable || !de || !O) return null;
        const A = {
            system_name: e.systemName,
            region: O.region,
            start: O.start,
            end: O.end
        };
        return U.types?.length && U.types.length < xn.length && (A.types = [
            ...U.types
        ]), U.includeEms === !1 && (A.include_ems = !1), A;
    }, [
        e.variationAvailable,
        e.systemName,
        de,
        O?.region,
        O?.start,
        O?.end,
        U.types,
        U.includeEms
    ]), xe = _c(e.client, Ve), Se = Fs(xe.error) ?? Fs(d), Te = (0, _react.useMemo)(()=>{
        const A = Me(xe.error) ? xe.error : Me(d) ? d : null;
        return A?.retryAfterMs ? Date.now() + A.retryAfterMs : null;
    }, [
        xe.error,
        d
    ]), Fe = Ra(Te), oe = yc(e.sequenceForRegion, Ve), Oe = (U.query ?? "").trim().toLowerCase(), Ce = xe.data?.variants ?? [], re = a ? a.variants : Ce, fe = (0, _react.useMemo)(()=>mo(re, oe.seq, oe.start, {
            enzymes: e.enzymes
        }), [
        re,
        oe.seq,
        oe.start,
        e.enzymes
    ]), Je = oe.unsupported || !oe.seq, Xe = oe.unsupported ? "Restriction sites are not available here: this site supplies no reference sequence." : oe.loading ? "Checking restriction sites\u2026" : oe.error ? "Reference sequence could not be fetched, so restriction sites are unknown." : [
        ...fe.values()
    ].some((A)=>A.unknown === "window-mismatch") ? "The reference sequence disagrees with the reported alleles, so restriction sites are not shown. The sequence source and the variant source are probably different releases." : null, Be = (0, _react.useMemo)(()=>[
            ...uo(fe.values())
        ].sort((A, J)=>J[1] - A[1] || A[0].localeCompare(J[0])), [
        fe
    ]), Ne = (0, _react.useMemo)(()=>re.map((A)=>A.ids[0]).filter((A)=>!!A), [
        re
    ]), ze = fc(e.alleleFrequencies, e.systemName, Ne), Le = (0, _react.useMemo)(()=>li(ze.byId), [
        ze.byId
    ]), je = Le.some(([A])=>A === K) ? K : "", et = (A)=>A.ids[0] ? ze.byId.get(A.ids[0]) : void 0, qe = (A)=>{
        const J = et(A);
        if (!J) return null;
        const x = pc(A), j = je ? [
            je
        ] : Le.map(([se])=>se);
        for (const se of j){
            const ue = gc(J, se, x);
            if (ue) return {
                ...ue,
                population: se
            };
        }
        return null;
    }, we = (A)=>{
        const J = et(A);
        if (!J) return null;
        const x = je ? [
            je
        ] : Le.map(([j])=>j);
        for (const j of x){
            const se = mc(J, j);
            if (se !== null) return se;
        }
        return null;
    }, E = !ze.unsupported && Le.length > 0, G = Be.some(([A])=>A === L) ? L : "", q = (A)=>{
        const J = /* @__PURE__ */ new Map();
        for (const x of re)for (const j of A(x))J.set(j, (J.get(j) ?? 0) + 1);
        return [
            ...J
        ].sort((x, j)=>x[0].localeCompare(j[0]));
    }, Y = (0, _react.useMemo)(()=>q((A)=>A.consequence ? [
                A.consequence
            ] : []), [
        re
    ]), Q = (0, _react.useMemo)(()=>q((A)=>[
                ...new Set(A.records.map((J)=>J.source))
            ]), [
        re
    ]), Z = Y.some(([A])=>A === b) ? b : "", ke = Q.some(([A])=>A === N) ? N : "", Tt = !!(Oe || Z || ke || G || h || R || M || V || T), yt = !!xe.data?.truncated || !!a, _t = (A)=>{
        if (!re.length) return !1;
        let J = 0;
        for (const x of re)A(x) && J++;
        return J > 0 && J < re.length;
    }, Dt = (A)=>!U.types || U.types.includes(A), dn = (0, _react.useMemo)(()=>new Set(re.map((A)=>A.kind)), [
        re
    ]), tt = xn.filter((A)=>yt || dn.has(A) || !Dt(A)), jt = yt || U.includeEms === !1 || re.some((A)=>A.ems), nt = h || _t((A)=>A.designable), $n = R || _t((A)=>!!A.multiallelic), Rn = M || _t((A)=>typeof A.shift == "number" && A.shift > 0), pn = V || !Je && _t((A)=>fe.get(A.key)?.verdict === "caps"), Et = T || E && _t((A)=>(we(A) ?? -1) >= Zn), Ke = (0, _react.useMemo)(()=>{
        const A = re.filter((x)=>{
            if (h && !x.designable || R && !x.multiallelic || M && !(typeof x.shift == "number" && x.shift > 0) || Z && x.consequence !== Z || ke && !x.records.some((j)=>j.source === ke) || V && fe.get(x.key)?.verdict !== "caps") return !1;
            if (T) {
                const j = we(x);
                if (j === null || j < Zn) return !1;
            }
            if (G) {
                const j = fe.get(x.key), se = (ue)=>ue === G;
                if (!j || !j.sites.some((ue)=>se(ue.enzyme.name)) && !j.dcaps.some((ue)=>se(ue.enzyme.name))) return !1;
            }
            return Oe ? x.label.toLowerCase().includes(Oe) || x.ids.some((j)=>j.toLowerCase().includes(Oe)) : !0;
        }), J = Gc(_.key, fe, (x)=>qe(x)?.frequency ?? null);
        return [
            ...A
        ].sort((x, j)=>{
            if (_.key === "frequency") {
                const se = qe(x)?.frequency ?? null, ue = qe(j)?.frequency ?? null;
                if (se === null && ue !== null) return 1;
                if (ue === null && se !== null) return -1;
            }
            return _.dir * J(x, j);
        });
    }, [
        re,
        Oe,
        h,
        R,
        M,
        V,
        T,
        Z,
        ke,
        G,
        fe,
        ze.byId,
        je,
        _
    ]), Mn = ()=>{
        C(""), w(""), y(!1), I(!1), P(!1), $(!1), z(""), W(!1), S(""), e.onFilters({
            ...U,
            query: void 0
        });
    }, It = typeof e.client.getVariant == "function", Pn = async ()=>{
        const A = r.trim();
        if (!A || !It) return;
        H.current?.abort();
        const J = new AbortController();
        H.current = J, m(!0), p(null);
        try {
            const x = await e.client.getVariant(A, {
                system_name: e.systemName
            }, {
                signal: J.signal
            });
            J.signal.aborted || i({
                id: x.requested_id,
                variants: x.variants,
                warnings: x.warnings ?? []
            });
        } catch (x) {
            !J.signal.aborted && !Ue(x) && (i(null), p(x));
        } finally{
            J.signal.aborted || m(!1);
        }
    }, Ut = (A)=>{
        const J = O ?? {
            region: "",
            start: 1,
            end: 1
        };
        e.onWindow({
            ...J,
            ...A
        });
    }, On = (A, J)=>{
        const x = new Set(U.types ?? xn);
        J ? x.add(A) : x.delete(A), e.onFilters({
            ...U,
            types: xn.filter((j)=>x.has(j))
        });
    }, $t = Object.values(l).some((A)=>A !== void 0 && A !== ""), gn = (0, _react.useMemo)(()=>Hr(l), [
        l
    ]), vt = !!e.variationAvailable && !Se, Ft = f || !vt;
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: "gpr-variant-picker",
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                className: "gpr-readout",
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                    className: "gpr-badge gpr-variant-source",
                    children: e.variationAvailable ? Bc(e.source) : "manual entry only"
                })
            }),
            Se ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-note",
                role: "note",
                "data-code": Se,
                children: [
                    Se === "FEATURE_DISABLED" ? "Variant lookups are switched off on this server." : Se === "NO_VARIATION_DATA" ? "This genome has no known variants." : "Variant lookups are temporarily unavailable.",
                    " ",
                    Fe > 0 ? `Try again in ${Fe} s. ` : "",
                    "You can still enter a variant by hand; neighbouring variants will not be screened."
                ]
            }) : null,
            vt ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("fieldset", {
                        className: "gpr-fieldset gpr-variant-window",
                        disabled: e.disabled,
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("legend", {
                                className: "gpr-legend gpr-legend-small",
                                children: "Where to look"
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                                className: "gpr-field-grid",
                                children: [
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ot, {
                                        id: `${t}-region`,
                                        label: "Sequence",
                                        value: O?.region ?? "",
                                        short: !0,
                                        onChange: (A)=>Ut({
                                                region: A
                                            })
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(mt, {
                                        id: `${t}-start`,
                                        label: "From",
                                        value: O?.start,
                                        min: 1,
                                        step: 1,
                                        onChange: (A)=>Ut({
                                                start: A ?? 1
                                            })
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(mt, {
                                        id: `${t}-end`,
                                        label: "To",
                                        value: O?.end,
                                        min: 1,
                                        step: 1,
                                        onChange: (A)=>Ut({
                                                end: A ?? 1
                                            })
                                    })
                                ]
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                                className: ne ? "gpr-field-error" : "gpr-hint",
                                children: ne ? `That window is ${v(B)} bp; at most ${v(ye.maxWindow)} bp can be listed at once.` : `${v(B)} bp of at most ${v(ye.maxWindow)} bp.`
                            })
                        ]
                    }),
                    tt.length || jt ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("fieldset", {
                        className: "gpr-fieldset gpr-variant-filters",
                        disabled: e.disabled,
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("legend", {
                                className: "gpr-legend gpr-legend-small",
                                children: "Filters"
                            }),
                            tt.length ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                                className: "gpr-variant-kinds",
                                children: tt.map((A)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)(Ie, {
                                        id: `${t}-kind-${A}`,
                                        label: A,
                                        description: Lc[A],
                                        checked: Dt(A),
                                        onChange: (J)=>On(A, J)
                                    }, A))
                            }) : null,
                            jt ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ie, {
                                id: `${t}-ems`,
                                label: "Include EMS mutations",
                                checked: U.includeEms !== !1,
                                hint: "EMS mutations are private to one mutant line.",
                                onChange: (A)=>e.onFilters({
                                        ...U,
                                        includeEms: A ? void 0 : !1
                                    })
                            }) : null
                        ]
                    }) : null,
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                        className: "gpr-variant-lookup",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ot, {
                                id: `${t}-lookup`,
                                label: "Or look up a variant id",
                                value: r,
                                placeholder: "rs871475760",
                                disabled: e.disabled || !It,
                                hint: It ? "Returns one row per alternative allele at that position." : "This server cannot look variants up by id.",
                                onChange: n
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                                className: "gpr-button-row",
                                children: [
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        className: "gpr-btn gpr-btn-small",
                                        disabled: e.disabled || !It || !r.trim() || g,
                                        onClick: Pn,
                                        children: g ? "Looking up\u2026" : "Look up"
                                    }),
                                    a ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        className: "gpr-btn gpr-btn-small gpr-btn-quiet",
                                        onClick: ()=>i(null),
                                        children: "Back to the list"
                                    }) : null
                                ]
                            }),
                            d && !Se ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                                className: "gpr-field-error",
                                role: "alert",
                                "data-code": Me(d) ? d.code : "ERROR",
                                children: Me(d) && d.code === "UNKNOWN_VARIANT" ? "That id is not known here." : d instanceof Error ? d.message : String(d)
                            }) : null
                        ]
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(cn, {
                        warnings: a ? a.warnings : xe.data?.warnings,
                        title: a ? "About this id" : "About this list"
                    }),
                    de && O && !a ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(zc, {
                        region: O.region,
                        window: {
                            start: O.start,
                            end: O.end
                        },
                        systemName: e.systemName,
                        genesInRegion: e.genesInRegion,
                        caps: fe,
                        variants: Ke,
                        selectedKey: e.state.variantKey ?? null,
                        disabled: e.disabled,
                        maxWindow: ye.maxWindow,
                        onSelect: (A)=>e.onSelect({
                                variantKey: A.key,
                                variantId: A.ids[0],
                                alt: A.vcf.alt
                            }),
                        onUseRegion: (A, J)=>e.onWindow({
                                region: O.region,
                                start: A,
                                end: J
                            })
                    }) : null,
                    xe.loading ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                        className: "gpr-hint",
                        children: "Looking for variants\u2026"
                    }) : null,
                    !xe.loading && !re.length ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                        className: "gpr-hint",
                        children: de ? "No variants in this window." : "Choose a window to list variants."
                    }) : null,
                    re.length ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            xe.data?.truncated && !a ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                                className: "gpr-note",
                                role: "note",
                                "data-code": "VARIANTS_TRUNCATED",
                                children: [
                                    "Showing ",
                                    v(xe.data.returned),
                                    " of ",
                                    v(xe.data.total),
                                    " variants; narrow the window to see the rest."
                                ]
                            }) : null,
                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                                className: "gpr-variant-toolbar",
                                children: [
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ot, {
                                        id: `${t}-search`,
                                        label: "Search",
                                        type: "search",
                                        value: U.query ?? "",
                                        placeholder: "id or position",
                                        disabled: e.disabled,
                                        className: "gpr-variant-search",
                                        onChange: (A)=>e.onFilters({
                                                ...U,
                                                query: A || void 0
                                            })
                                    }),
                                    Y.length > 1 || Z ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(Nn, {
                                        id: `${t}-consequence`,
                                        label: "Consequence",
                                        anyLabel: "Any consequence",
                                        value: Z,
                                        options: Y,
                                        disabled: e.disabled,
                                        onChange: C
                                    }) : null,
                                    Q.length > 1 || ke ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(Nn, {
                                        id: `${t}-source`,
                                        label: "Source",
                                        anyLabel: "Any source",
                                        value: ke,
                                        options: Q,
                                        disabled: e.disabled,
                                        onChange: w
                                    }) : null,
                                    Le.length > 1 || je ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(Nn, {
                                        id: `${t}-population`,
                                        label: "Panel",
                                        anyLabel: "Any panel",
                                        value: je,
                                        options: Le,
                                        disabled: e.disabled,
                                        onChange: S
                                    }) : null,
                                    Be.length > 1 || G ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(Nn, {
                                        id: `${t}-enzyme`,
                                        label: "Enzyme",
                                        anyLabel: "Any enzyme",
                                        value: G,
                                        options: Be,
                                        disabled: e.disabled || Je,
                                        onChange: z
                                    }) : null
                                ]
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                                className: "gpr-variant-toolbar",
                                children: [
                                    nt ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ie, {
                                        id: `${t}-designable`,
                                        label: "Designable only",
                                        checked: h,
                                        onChange: y
                                    }) : null,
                                    $n ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ie, {
                                        id: `${t}-multiallelic`,
                                        label: "Multi-allelic only",
                                        checked: R,
                                        onChange: I
                                    }) : null,
                                    Rn ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ie, {
                                        id: `${t}-shiftable`,
                                        label: "Can slide",
                                        checked: M,
                                        onChange: P
                                    }) : null,
                                    Et ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ie, {
                                        id: `${t}-polymorphic`,
                                        label: "Polymorphic only",
                                        description: `Hides variants whose minor allele is carried by fewer than ${Math.round(Zn * 100)}% of the chosen panel, which are too rare to screen for.`,
                                        checked: T,
                                        onChange: W
                                    }) : null,
                                    pn ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ie, {
                                        id: `${t}-caps`,
                                        label: "CAPS-able only",
                                        checked: V,
                                        disabled: e.disabled || Je,
                                        onChange: $
                                    }) : null,
                                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                        className: "gpr-sub",
                                        children: [
                                            v(Ke.length),
                                            " of ",
                                            v(re.length),
                                            " variant",
                                            re.length === 1 ? "" : "s"
                                        ]
                                    }),
                                    Tt ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        className: "gpr-btn gpr-btn-small gpr-btn-quiet",
                                        onClick: Mn,
                                        children: "Clear filters"
                                    }) : null
                                ]
                            }),
                            Xe ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                                className: "gpr-sub gpr-caps-note",
                                children: Xe
                            }) : null,
                            E && ze.capped ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                                className: "gpr-sub gpr-caps-note",
                                children: [
                                    "Frequencies were looked up for the first ",
                                    v(ci),
                                    " variants; narrow the window to cover the rest."
                                ]
                            }) : null,
                            Ke.length ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                                className: "gpr-table-wrap gpr-variant-scroll",
                                children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("table", {
                                    className: "gpr-table gpr-variant-table",
                                    children: [
                                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("caption", {
                                            className: "gpr-caption",
                                            children: [
                                                a ? `Alternative alleles of ${a.id}` : `${v(Ke.length)} variant${Ke.length === 1 ? "" : "s"}`,
                                                " \xb7 rows that cannot be designed are listed with the reason"
                                            ]
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("thead", {
                                            children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                                children: [
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                                        scope: "col",
                                                        className: "gpr-col-check",
                                                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                            className: "gpr-visually-hidden",
                                                            children: "Select"
                                                        })
                                                    }),
                                                    qc.filter((A)=>A.key !== "frequency" || E).map((A)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                                            scope: "col",
                                                            "aria-sort": _.key === A.key ? _.dir === 1 ? "ascending" : "descending" : void 0,
                                                            children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("button", {
                                                                type: "button",
                                                                className: "gpr-sort",
                                                                onClick: ()=>k((J)=>({
                                                                            key: A.key,
                                                                            dir: J.key === A.key && J.dir === 1 ? -1 : 1
                                                                        })),
                                                                children: [
                                                                    A.label,
                                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "gpr-sort-glyph",
                                                                        "aria-hidden": "true",
                                                                        children: _.key === A.key ? _.dir === 1 ? " \u25B2" : " \u25BC" : ""
                                                                    })
                                                                ]
                                                            })
                                                        }, A.key))
                                                ]
                                            })
                                        }),
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("tbody", {
                                            children: Ke.map((A)=>{
                                                const J = e.state.variantKey === A.key, x = A.issues[0] ?? null;
                                                return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                                    className: "gpr-variant-row",
                                                    "data-state": J ? "selected" : void 0,
                                                    "data-designable": A.designable ? "true" : "false",
                                                    children: [
                                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                            className: "gpr-col-check",
                                                            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                                                                type: "radio",
                                                                className: "gpr-radio",
                                                                name: `${t}-variant`,
                                                                id: `${t}-v-${A.key}`,
                                                                checked: J,
                                                                disabled: e.disabled || !A.designable,
                                                                "aria-label": `Use ${A.label}`,
                                                                onChange: ()=>e.onSelect({
                                                                        variantKey: A.key,
                                                                        variantId: A.ids[0],
                                                                        alt: A.vcf.alt
                                                                    })
                                                            })
                                                        }),
                                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                                            scope: "row",
                                                            className: "gpr-num",
                                                            children: v(A.vcf.position)
                                                        }),
                                                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("td", {
                                                            children: [
                                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("code", {
                                                                    className: "gpr-seq",
                                                                    children: A.label
                                                                }),
                                                                A.shift ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                                    className: "gpr-sub gpr-block",
                                                                    children: [
                                                                        "can slide ",
                                                                        v(A.shift),
                                                                        " bp"
                                                                    ]
                                                                }) : null,
                                                                A.multiallelic ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                                    className: "gpr-sub gpr-block",
                                                                    children: [
                                                                        "other alleles here: ",
                                                                        A.multiallelic.other_alts.join(", ")
                                                                    ]
                                                                }) : null
                                                            ]
                                                        }),
                                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                            children: A.kind
                                                        }),
                                                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("td", {
                                                            className: "gpr-variant-ids",
                                                            children: [
                                                                A.ids[0] ?? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "gpr-sub",
                                                                    children: "none"
                                                                }),
                                                                A.ids.length > 1 ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                                    className: "gpr-sub",
                                                                    children: [
                                                                        " +",
                                                                        A.ids.length - 1
                                                                    ]
                                                                }) : null,
                                                                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                                    className: "gpr-sub gpr-block",
                                                                    children: [
                                                                        A.records.map((j)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                                                className: "gpr-variant-record",
                                                                                title: j.ems ? "EMS mutation" : j.source,
                                                                                children: [
                                                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                                                        "aria-hidden": "true",
                                                                                        children: j.ems ? "\u25CB" : "\u25CF"
                                                                                    }),
                                                                                    " ",
                                                                                    j.source
                                                                                ]
                                                                            }, `${j.id}-${j.source}`)),
                                                                        A.ems ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "gpr-badge",
                                                                            children: " EMS only"
                                                                        }) : null
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                            children: A.consequence ?? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                                className: "gpr-sub",
                                                                children: "\u2013"
                                                            })
                                                        }),
                                                        E ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                            className: "gpr-num",
                                                            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Fc, {
                                                                share: qe(A),
                                                                pending: ze.loading && !et(A),
                                                                named: !je
                                                            })
                                                        }) : null,
                                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Uc, {
                                                                annotation: fe.get(A.key)
                                                            })
                                                        }),
                                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                            children: A.designable ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                                className: "gpr-chip gpr-chip-ok",
                                                                children: [
                                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "gpr-chip-glyph",
                                                                        "aria-hidden": "true",
                                                                        children: "\u2713"
                                                                    }),
                                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "gpr-chip-text",
                                                                        children: "Yes"
                                                                    })
                                                                ]
                                                            }) : /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                                className: "gpr-chip gpr-chip-bad",
                                                                "data-code": x?.code,
                                                                title: x?.message,
                                                                children: [
                                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "gpr-chip-glyph",
                                                                        "aria-hidden": "true",
                                                                        children: "\u2717"
                                                                    }),
                                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "gpr-chip-text",
                                                                        children: x?.code ? x.code.replace(/_/g, " ").toLowerCase() : "no"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }, A.key);
                                            })
                                        })
                                    ]
                                })
                            }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                                className: "gpr-hint",
                                children: "No variants match these filters."
                            })
                        ]
                    }) : null
                ]
            }) : null,
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                className: "gpr-variant-manual",
                children: [
                    vt ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "gpr-btn gpr-btn-small gpr-btn-quiet",
                        "aria-expanded": Ft,
                        "aria-controls": `${t}-manual`,
                        onClick: ()=>u((A)=>!A),
                        children: Ft ? "Hide manual entry" : "Enter a variant by hand"
                    }) : null,
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                        id: `${t}-manual`,
                        hidden: !Ft,
                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(vc, {
                            idPrefix: t,
                            value: l,
                            issues: $t ? gn : [],
                            refMismatch: e.refMismatch,
                            disabled: e.disabled,
                            checking: e.checkingReference,
                            onCheckReference: e.onCheckReference,
                            onChange: (A)=>{
                                o(A), Dc(A) && Hr(A).length === 0 && e.onSelect({
                                    manual: A
                                });
                            }
                        })
                    })
                ]
            })
        ]
    });
}
const Hc = Object.freeze({
    sets: "Sets",
    alleles: "Alleles",
    specificity: "Specificity",
    pangenome: "Pan-genome",
    order: "Order sheet"
});
function Vc(e) {
    const t = De("gpr-gt"), r = e.idPrefix ?? t, n = e.state.genotyping ?? {}, [a, i] = (0, _react.useState)(null), l = zl(e.client, {
        onSuccess: (T, W, H)=>{
            if (H.templateOnly) return;
            const O = new Map(T.sets.map((B)=>[
                    B.id,
                    B.key
                ])), U = (T.check?.set_ids ?? T.sets.slice(0, $e.maxSets).map((B)=>B.id)).map((B)=>O.get(B)).filter((B)=>!!B).slice(0, $e.maxSets);
            e.dispatch({
                type: "genotypingDesignDone",
                templateOnly: !1,
                noSets: T.sets.length === 0,
                checkedSetKeys: U,
                selectedSetKey: T.sets[0]?.key
            });
        }
    }), o = Da(e.client, {
        onJobId: (T)=>e.dispatch({
                type: "genotypingCheckJob",
                jobId: T
            })
    }), d = l.state.response, p = d?.sets ?? [], g = n.checkedSetKeys ?? [], m = (0, _react.useMemo)(()=>p.filter((T)=>g.includes(T.key)), [
        p,
        g
    ]), f = o.state.job, u = f?.results?.genotyping ?? null, h = (0, _react.useRef)(null), y = o.restore;
    (0, _react.useEffect)(()=>{
        const T = n.check?.jobId;
        !T || h.current === T || (h.current = T, y(T, null, !1));
    }, [
        n.check?.jobId,
        y
    ]);
    const _ = (0, _react.useMemo)(()=>Hi(e.state, {
            systemName: e.systemName
        }), [
        e.state,
        e.systemName
    ]), k = n.check?.checks?.includes("pangenome") ? [
        "specificity",
        "pangenome"
    ] : [
        "specificity"
    ];
    let b = null, C = null;
    if (m.length && d) try {
        b = Vi({
            sets: m,
            variant: d.variant,
            systemName: e.systemName,
            mode: Ze(e.state.mode) === "gene" ? "gene" : "region",
            geneId: e.geneId ?? null,
            checks: k,
            genomes: n.check?.genomes,
            allGenomes: e.genomes,
            params: n.check?.params
        });
    } catch (T) {
        if (T instanceof be) C = T;
        else throw T;
    }
    const N = e.genomes?.genomes.find((T)=>T.system_name === e.systemName) ?? null, w = k.includes("pangenome") && e.genomes ? an(e.genomes.genomes, "region", e.systemName ?? void 0) : null, R = w ? n.check?.genomes ? w.filter((T)=>n.check.genomes.includes(T.system_name)) : w : null, I = m.length && e.genomes ? yr({
        primers: m.flatMap((T)=>(T.check?.pairs ?? []).map((W)=>({
                    left: W.left,
                    right: W.right
                }))),
        mode: "region",
        referenceTotalBases: N?.total_bases ?? null,
        pangenome: R,
        genotyping: !0
    }) : null, M = n.view?.tab ?? "sets", P = !!f?.results, V = (T)=>T === "sets" ? null : T === "order" ? p.length ? null : "Design a set first" : T === "alleles" ? u ? null : "Run a check to see allele calls" : T === "pangenome" ? f?.results?.pangenome ? null : "Run a pan-genome check first" : P ? null : "Run a check first", $ = V(M) ? "sets" : M, L = `${r}-gt-panel`, z = l.state.status === "running", K = Or(o.state.status), S = ()=>{
        b && (i(null), e.dispatch({
            type: "setGenotypingSubmitted",
            submitted: So(b)
        }), o.submit(b));
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: "gpr-genotyping",
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(Kc, {
                client: e.client,
                systemName: e.systemName ?? "",
                variationAvailable: !!e.genomes?.variation?.available && e.genomes.genomes.find((T)=>T.system_name === e.systemName)?.has_variation !== !1,
                source: e.genomes?.variation ? {
                    name: e.genomes.variation.source ?? "Ensembl",
                    release: e.genomes.variation.release
                } : null,
                state: n,
                genesInRegion: e.genesInRegion,
                sequenceForRegion: e.sequenceForRegion,
                alleleFrequencies: e.alleleFrequencies,
                enzymes: e.enzymes,
                defaultWindow: e.defaultWindow,
                disabled: e.disabled,
                onWindow: (T)=>e.dispatch({
                        type: "setGenotypingWindow",
                        window: T
                    }),
                onFilters: (T)=>e.dispatch({
                        type: "setGenotypingFilters",
                        filters: T
                    }),
                onSelect: (T)=>e.dispatch({
                        type: "setGenotypingVariant",
                        ...T
                    })
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ol, {
                idPrefix: r,
                assay: n.assay,
                params: n.params,
                settings: d?.settings ?? null,
                emsTarget: d?.assay.ems_target,
                genome: N,
                avoidRepeats: n.avoidRepeats,
                repeatMaskMode: n.repeatMaskMode,
                issues: [],
                disabled: e.disabled,
                onAssay: (T)=>e.dispatch({
                        type: "setGenotypingAssay",
                        assay: T
                    }),
                onParam: (T, W)=>e.dispatch({
                        type: "setGenotypingParam",
                        key: T,
                        value: W
                    }),
                onResetParams: ()=>e.dispatch({
                        type: "resetGenotypingParams"
                    }),
                onRepeats: (T)=>e.dispatch({
                        type: "setGenotypingRepeats",
                        ...T
                    })
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                className: "gpr-genotyping-actions",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "gpr-btn gpr-btn-primary",
                        disabled: e.disabled || !_ || z || !l.supported,
                        onClick: ()=>_ && l.run(_, {
                                templateOnly: !1,
                                userInitiated: !0
                            }),
                        children: z ? "Designing\u2026" : "Design assay"
                    }),
                    z ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "gpr-btn gpr-btn-small",
                        onClick: l.cancel,
                        children: "Cancel"
                    }) : null,
                    l.supported ? null : /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                        className: "gpr-hint",
                        children: "This server cannot design genotyping assays."
                    }),
                    !_ && !e.disabled ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                        className: "gpr-hint",
                        children: "Choose a variant to design against."
                    }) : null
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(rn, {
                error: l.state.error,
                context: "design",
                busy: l.state.busy,
                onRetry: ()=>_ && l.run(_, {
                        templateOnly: !1,
                        userInitiated: !0
                    }),
                onDismiss: l.clearError
            }),
            d ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(cn, {
                warnings: d.warnings,
                title: "About this design"
            }) : null,
            d ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(Pr, {
                        items: [
                            "sets",
                            "alleles",
                            "specificity",
                            "pangenome",
                            "order"
                        ].map((T)=>({
                                id: T,
                                label: Hc[T],
                                disabledReason: V(T)
                            })),
                        value: $,
                        onChange: (T)=>e.dispatch({
                                type: "setGenotypingTab",
                                tab: T
                            }),
                        label: "Genotyping results",
                        idPrefix: r,
                        panelId: L
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                        id: L,
                        role: "tabpanel",
                        className: "gpr-tabpanel",
                        "aria-labelledby": Jt(r, $),
                        tabIndex: -1,
                        children: [
                            $ === "sets" ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    p.length ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                                        className: "gpr-genotyping-check",
                                        children: [
                                            e.pangenomeFeature !== !1 ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ie, {
                                                id: `${r}-gt-pangenome`,
                                                label: "Pan-genome allele calls",
                                                checked: k.includes("pangenome"),
                                                disabled: e.disabled || K,
                                                hint: "Reads the allele every other assembly carries.",
                                                onChange: (T)=>e.dispatch({
                                                        type: "setGenotypingPangenome",
                                                        enabled: T
                                                    })
                                            }) : null,
                                            k.includes("pangenome") && e.genomes ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ga, {
                                                genomes: e.genomes,
                                                mode: "region",
                                                systemName: e.systemName,
                                                selected: n.check?.genomes,
                                                disabled: e.disabled || K,
                                                onChange: (T)=>e.dispatch({
                                                        type: "setGenotypingGenomes",
                                                        genomes: T
                                                    })
                                            }) : null,
                                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                                                className: "gpr-readout gpr-genotyping-cost",
                                                children: [
                                                    m.length,
                                                    " set",
                                                    m.length === 1 ? "" : "s",
                                                    " selected",
                                                    I ? ` \xb7 estimated ${v(I.cpu_s)} CPU-seconds` : "",
                                                    I?.over_limit ? ` \u{2014} over the ${v(I.limit)} limit` : ""
                                                ]
                                            }),
                                            C ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                                                className: "gpr-field-error",
                                                role: "alert",
                                                "data-code": C.code,
                                                children: C.message
                                            }) : null,
                                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                                                className: "gpr-button-row",
                                                children: [
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                                        type: "button",
                                                        className: "gpr-btn gpr-btn-primary",
                                                        disabled: e.disabled || !b || !!C || K || !!I?.over_limit,
                                                        onClick: S,
                                                        children: K ? "Checking\u2026" : "Check selected sets"
                                                    }),
                                                    K ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                                        type: "button",
                                                        className: "gpr-btn gpr-btn-small",
                                                        onClick: o.detach,
                                                        children: "Stop watching"
                                                    }) : null,
                                                    o.state.status === "expired" ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                                        type: "button",
                                                        className: "gpr-btn gpr-btn-small",
                                                        onClick: S,
                                                        children: "Results expired \u2014 Re-run check"
                                                    }) : null
                                                ]
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)(rn, {
                                                error: o.state.status === "error" ? o.state.error : a,
                                                context: "check",
                                                onDismiss: ()=>i(null)
                                            })
                                        ]
                                    }) : null,
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(ec, {
                                        sets: p,
                                        checkedKeys: g,
                                        selectedKey: n.selectedSetKey ?? null,
                                        check: f,
                                        submitted: n.check?.submitted,
                                        onCheckedChange: (T)=>e.dispatch({
                                                type: "setGenotypingCheckedKeys",
                                                keys: T
                                            }),
                                        onSelect: (T)=>e.dispatch({
                                                type: "selectGenotypingSet",
                                                key: T
                                            })
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(Bl, {
                                        orientations: d.orientations
                                    })
                                ]
                            }) : null,
                            $ === "alleles" ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(El, {
                                results: u,
                                requestedGenomes: n.check?.genomes,
                                running: K
                            }) : null,
                            $ === "specificity" && f?.results ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(oi, {
                                results: f.results,
                                job: f,
                                systemName: e.systemName ?? void 0
                            }) : null,
                            $ === "pangenome" && f?.results?.pangenome ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(si, {
                                results: f.results.pangenome,
                                requestedGenomes: n.check?.genomes,
                                params: n.check?.params
                            }) : null,
                            $ === "order" ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(ql, {
                                sets: p,
                                kaspMix: d.assay.kasp_mix,
                                submissionSequence: d.variant.submission_sequence,
                                results: u,
                                label: d.variant.ids[0] ?? d.variant.key
                            }) : null
                        ]
                    })
                ]
            }) : null
        ]
    });
}
function pe(e) {
    const t = {
        ...e
    };
    for (const r of Object.keys(t))t[r] === void 0 && delete t[r];
    return t;
}
const wt = (e)=>e.view ?? {
        resultsTab: "pairs"
    }, Wt = (e)=>e.check ?? {
        checks: [
            "specificity"
        ]
    }, ve = (e)=>e.genotyping ?? {}, Pt = (e)=>ve(e).check ?? {
        checks: [
            "specificity"
        ]
    };
function _e(e, t) {
    const r = pe(t);
    return pe({
        ...e,
        genotyping: Object.keys(r).length ? r : void 0
    });
}
function Wc(e) {
    return {
        ...e,
        designed: void 0,
        selectedSetKey: void 0,
        checkedSetKeys: void 0,
        check: void 0
    };
}
function Yc(e, t) {
    switch(t.type){
        case "replace":
            return t.state;
        case "setMode":
            {
                if (e.mode === t.mode) return e;
                const r = e.preset && e.preset !== St(Ze(e.mode)) ? e.preset : St(Ze(t.mode));
                return pe({
                    ...e,
                    mode: t.mode,
                    preset: r,
                    target: void 0,
                    included: void 0,
                    excluded: void 0
                });
            }
        case "setTranscript":
            return pe({
                ...e,
                transcriptId: t.transcriptId
            });
        case "setFlanks":
            return pe({
                ...e,
                flankUp: t.flankUp ?? e.flankUp,
                flankDown: t.flankDown ?? e.flankDown
            });
        case "setRegion":
            return pe({
                ...e,
                region: t.region
            });
        case "setSequence":
            return {
                ...e,
                sequence: t.sequence
            };
        case "setSystemName":
            return pe({
                ...e,
                systemName: t.systemName
            });
        case "setJunctionSpanning":
            return {
                ...e,
                junctionSpanning: t.value
            };
        case "setRepeats":
            return pe({
                ...e,
                avoidRepeats: t.avoidRepeats ?? e.avoidRepeats,
                repeatMaskMode: t.repeatMaskMode ?? e.repeatMaskMode
            });
        case "setIntervals":
            {
                const r = t.excluded && t.excluded.length ? t.excluded.map((n)=>[
                        n[0],
                        n[1]
                    ]) : void 0;
                return pe({
                    ...e,
                    target: t.target,
                    included: t.included,
                    excluded: r
                });
            }
        case "setIncluded":
            return pe({
                ...e,
                included: t.included
            });
        case "setPreset":
            return e.preset === t.preset && !e.params ? e : pe({
                ...e,
                preset: t.preset,
                params: void 0
            });
        case "setParam":
            {
                const r = {
                    ...e.params ?? {}
                };
                return t.value === void 0 ? delete r[t.key] : r[t.key] = t.value, pe({
                    ...e,
                    params: Object.keys(r).length ? r : void 0
                });
            }
        case "resetParams":
            return pe({
                ...e,
                params: void 0
            });
        case "setChecked":
            {
                const r = new Set(e.checkedRanks ?? []);
                return t.checked ? r.add(t.rank) : r.delete(t.rank), {
                    ...e,
                    checkedRanks: [
                        ...r
                    ].sort((n, a)=>n - a)
                };
            }
        case "setCheckedRanks":
            return {
                ...e,
                checkedRanks: [
                    ...new Set(t.ranks)
                ].sort((r, n)=>r - n)
            };
        case "select":
            return pe({
                ...e,
                selectedRank: t.rank
            });
        case "designDone":
            {
                if (t.templateOnly) return e;
                const r = {
                    ...e,
                    designed: !0
                };
                return t.checkedRanks && (r.checkedRanks = [
                    ...t.checkedRanks
                ].sort((n, a)=>n - a)), "selectedRank" in t && (r.selectedRank = t.selectedRank), t.noPairs && (r.view = {
                    ...wt(e),
                    explainOpen: !0
                }), pe(r);
            }
        case "setPangenome":
            {
                const n = {
                    ...Wt(e),
                    checks: t.enabled ? [
                        "specificity",
                        "pangenome"
                    ] : [
                        "specificity"
                    ]
                };
                return {
                    ...e,
                    check: n
                };
            }
        case "setGenomes":
            return {
                ...e,
                check: pe({
                    ...Wt(e),
                    genomes: t.genomes ? [
                        ...t.genomes
                    ] : void 0
                })
            };
        case "setCheckParam":
            {
                const r = Wt(e), n = {
                    ...r.params ?? {}
                };
                return t.value === void 0 ? delete n[t.key] : n[t.key] = t.value, {
                    ...e,
                    check: pe({
                        ...r,
                        params: Object.keys(n).length ? n : void 0
                    })
                };
            }
        case "checkJob":
            {
                const r = Wt(e);
                return {
                    ...e,
                    check: pe({
                        ...r,
                        jobId: t.jobId,
                        submitted: t.submitted ?? r.submitted
                    })
                };
            }
        case "clearCheckJob":
            {
                const r = Wt(e);
                return {
                    ...e,
                    check: pe({
                        ...r,
                        jobId: void 0,
                        submitted: void 0
                    })
                };
            }
        case "setTab":
            return wt(e).resultsTab === t.tab ? e : {
                ...e,
                view: {
                    ...wt(e),
                    resultsTab: t.tab
                }
            };
        case "setExplainOpen":
            return !!wt(e).explainOpen === t.open ? e : {
                ...e,
                view: {
                    ...wt(e),
                    explainOpen: t.open
                }
            };
        case "setFormWidth":
            return wt(e).formWidth === t.width ? e : {
                ...e,
                view: pe({
                    ...wt(e),
                    formWidth: t.width
                })
            };
        // ---- genotyping --------------------------------------------------------
        case "setGenotypingVariant":
            {
                const r = Wc(ve(e));
                return _e(e, {
                    ...r,
                    variantId: t.variantId,
                    alt: t.alt,
                    variantKey: t.variantKey,
                    manual: t.manual
                });
            }
        case "setGenotypingWindow":
            return _e(e, {
                ...ve(e),
                window: t.window
            });
        case "setGenotypingFilters":
            return _e(e, {
                ...ve(e),
                filters: t.filters
            });
        case "setGenotypingAssay":
            {
                const r = ve(e), n = pe({
                    ...r.assay ?? {},
                    ...t.assay
                }), a = r.assay ? r.assay.type ?? "kasp" : void 0, i = t.assay.type && a && t.assay.type !== a ? {
                    type: t.assay.type
                } : n;
                return _e(e, {
                    ...r,
                    assay: Object.keys(i).length ? i : void 0
                });
            }
        case "setGenotypingParam":
            {
                const r = ve(e), n = {
                    ...r.params ?? {}
                };
                return t.value === void 0 ? delete n[t.key] : n[t.key] = t.value, _e(e, {
                    ...r,
                    params: Object.keys(n).length ? n : void 0
                });
            }
        case "resetGenotypingParams":
            return _e(e, {
                ...ve(e),
                params: void 0
            });
        case "setGenotypingLabel":
            return _e(e, {
                ...ve(e),
                label: t.label
            });
        case "setGenotypingRepeats":
            {
                const r = ve(e);
                return _e(e, {
                    ...r,
                    avoidRepeats: t.avoidRepeats ?? r.avoidRepeats,
                    repeatMaskMode: t.repeatMaskMode ?? r.repeatMaskMode
                });
            }
        case "genotypingDesignDone":
            {
                if (t.templateOnly) return e;
                const r = {
                    ...ve(e),
                    designed: !0
                };
                return t.checkedSetKeys && (r.checkedSetKeys = t.checkedSetKeys.slice(0, $e.maxSets)), "selectedSetKey" in t && (r.selectedSetKey = t.selectedSetKey), t.noSets && (r.view = {
                    tab: "sets"
                }), _e(e, r);
            }
        case "selectGenotypingSet":
            return _e(e, {
                ...ve(e),
                selectedSetKey: t.key
            });
        case "setGenotypingChecked":
            {
                const r = ve(e), n = r.checkedSetKeys ?? [];
                if (t.checked) return n.includes(t.key) || n.length >= $e.maxSets ? e : _e(e, {
                    ...r,
                    checkedSetKeys: [
                        ...n,
                        t.key
                    ]
                });
                if (!n.includes(t.key)) return e;
                const a = n.filter((i)=>i !== t.key);
                return _e(e, {
                    ...r,
                    checkedSetKeys: a.length ? a : void 0
                });
            }
        case "setGenotypingCheckedKeys":
            {
                const r = [
                    ...new Set(t.keys)
                ].slice(0, $e.maxSets);
                return _e(e, {
                    ...ve(e),
                    checkedSetKeys: r.length ? r : void 0
                });
            }
        case "setGenotypingTab":
            {
                const r = ve(e);
                return r.view?.tab === t.tab ? e : _e(e, {
                    ...r,
                    view: {
                        tab: t.tab
                    }
                });
            }
        case "setGenotypingPangenome":
            {
                const r = Pt(e);
                return _e(e, {
                    ...ve(e),
                    check: {
                        ...r,
                        checks: t.enabled ? [
                            "specificity",
                            "pangenome"
                        ] : [
                            "specificity"
                        ]
                    }
                });
            }
        case "setGenotypingGenomes":
            return _e(e, {
                ...ve(e),
                check: pe({
                    ...Pt(e),
                    genomes: t.genomes ? [
                        ...t.genomes
                    ] : void 0
                })
            });
        case "setGenotypingCheckParam":
            {
                const r = Pt(e), n = {
                    ...r.params ?? {}
                };
                return t.value === void 0 ? delete n[t.key] : n[t.key] = t.value, _e(e, {
                    ...ve(e),
                    check: pe({
                        ...r,
                        params: Object.keys(n).length ? n : void 0
                    })
                });
            }
        case "genotypingCheckJob":
            {
                const r = Pt(e);
                return _e(e, {
                    ...ve(e),
                    check: pe({
                        ...r,
                        jobId: t.jobId,
                        submitted: t.submitted ?? r.submitted
                    })
                });
            }
        case "setGenotypingSubmitted":
            {
                const r = Pt(e);
                return _e(e, {
                    ...ve(e),
                    check: pe({
                        ...r,
                        submitted: t.submitted.length ? t.submitted : void 0
                    })
                });
            }
        case "clearGenotypingCheckJob":
            {
                const r = Pt(e);
                return _e(e, {
                    ...ve(e),
                    check: pe({
                        ...r,
                        jobId: void 0,
                        submitted: void 0
                    })
                });
            }
        default:
            return e;
    }
}
function Jc(e) {
    const { stateProp: t, persistSequence: r, ctx: n, identity: a } = e, i = t !== void 0, l = {
        ...n,
        persistSequence: !0
    }, o = (0, _react.useRef)(l);
    o.current = l;
    const [d, p] = (0, _react.useState)(()=>Zr(t ?? null, l)), [g, m] = (0, _react.useState)(void 0), f = (n.modes ?? []).join(","), u = (0, _react.useMemo)(()=>t !== void 0 ? Zr(t, o.current) : null, // ctx is summarized by identity + modes + defaultMode
    [
        t,
        a,
        f,
        n.defaultMode
    ]), h = (0, _react.useMemo)(()=>u ? !r && g !== void 0 && u.sequence !== g ? {
            ...u,
            sequence: g
        } : u : d, [
        u,
        d,
        r,
        g
    ]), y = (0, _react.useRef)(h), _ = (0, _react.useRef)(null), k = (0, _react.useRef)(e.onStateChange), b = (0, _react.useRef)(r);
    Gt(()=>{
        y.current = h, _.current = null, k.current = e.onStateChange, b.current = r;
    });
    const C = (0, _react.useCallback)((I)=>{
        k.current?.(ya(I, {
            persistSequence: b.current
        }));
    }, []), N = (0, _react.useCallback)((I)=>{
        const M = _.current ?? y.current, P = Yc(M, I);
        P !== M && (_.current = P, p(P), b.current || m(P.sequence), C(P));
    }, [
        C
    ]), w = (0, _react.useCallback)((I, M)=>{
        _.current = I, p(I), m(I.sequence), M && C(I);
    }, [
        C
    ]), R = (0, _react.useCallback)(()=>_.current ?? y.current, []);
    return {
        state: h,
        dispatch: N,
        replace: w,
        getState: R,
        controlled: i
    };
}
function Xc(e, t, r = !0) {
    const n = r && t ? t : null, [a, i] = (0, _react.useState)({
        systemName: null,
        data: null,
        error: null,
        loading: !1
    });
    return (0, _react.useEffect)(()=>{
        if (!n) {
            i({
                systemName: null,
                data: null,
                error: null,
                loading: !1
            });
            return;
        }
        const l = new AbortController();
        return i({
            systemName: n,
            data: null,
            error: null,
            loading: !0
        }), e.listGenomes(n, {
            signal: l.signal
        }).then((o)=>{
            l.signal.aborted || i({
                systemName: n,
                data: o,
                error: null,
                loading: !1
            });
        }, (o)=>{
            !l.signal.aborted && !Ue(o) && i({
                systemName: n,
                data: null,
                error: o,
                loading: !1
            });
        }), ()=>l.abort();
    }, [
        e,
        n
    ]), a.systemName === n ? a : {
        systemName: n,
        data: null,
        error: null,
        loading: !!n
    };
}
function Qc(e, t, r) {
    const [n, a] = (0, _react.useState)(null), i = !t && !!r;
    return (0, _react.useEffect)(()=>{
        if (!i || !r) return;
        const l = new AbortController();
        return e.getGene(r, {
            signal: l.signal
        }).then((o)=>{
            l.signal.aborted || a({
                id: r,
                doc: o
            });
        }, ()=>{}), ()=>l.abort();
    }, [
        e,
        r,
        i
    ]), t || (n && n.id === r ? n.doc : null);
}
const Bs = 50;
function Ks(e, t) {
    return e?.location ? rt(ee.maxTemplateLength - mr(e) - Math.max(0, t), 0, ee.maxFlank) : ee.maxFlank;
}
function Hs(e) {
    const { id: t, label: r, value: n, max: a, onChange: i, disabled: l } = e, o = `${t}-label`, d = `${t}-hint`, p = (g)=>i(rt(Math.round(g), 0, a));
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: "gpr-field gpr-flank",
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("label", {
                className: "gpr-label",
                id: o,
                htmlFor: t,
                children: r
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                className: "gpr-flank-controls",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                        type: "range",
                        className: "gpr-range",
                        min: 0,
                        max: a,
                        step: Bs,
                        value: Math.min(n, a),
                        "aria-labelledby": o,
                        "aria-describedby": d,
                        disabled: l || a === 0,
                        onChange: (g)=>p(Number(g.target.value))
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                        id: t,
                        type: "number",
                        className: "gpr-input gpr-input-number gpr-input-short",
                        min: 0,
                        max: a,
                        step: Bs,
                        value: n,
                        disabled: l,
                        "aria-describedby": d,
                        onChange: (g)=>{
                            const m = g.target.value.trim() === "" ? 0 : Number(g.target.value);
                            Number.isFinite(m) && p(m);
                        }
                    })
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                id: d,
                className: "gpr-hint",
                children: [
                    "0\u2013",
                    v(a),
                    " bp"
                ]
            })
        ]
    });
}
function Zc(e) {
    const t = e.gene, r = t?.location ?? null, n = Oa(t), a = t && r ? ra(t, e.flankUp, e.flankDown) : null;
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("fieldset", {
        className: "gpr-fieldset",
        disabled: e.disabled,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("legend", {
                className: "gpr-legend",
                children: "Gene"
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-gene-summary",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                        className: "gpr-gene-name",
                        children: e.geneLabel ?? t?.name ?? t?._id ?? e.geneId
                    }),
                    t && r ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                        className: "gpr-sub",
                        children: [
                            " ",
                            Zt(r.region, r.start, r.end, r.strand),
                            " \xb7 ",
                            v(mr(t)),
                            " bp"
                        ]
                    }) : null
                ]
            }),
            n ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-note",
                role: "note",
                children: [
                    "This gene is longer than the ",
                    v(ee.maxTemplateLength),
                    " bp template limit: use Transcript or Region mode."
                ]
            }) : null,
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ba, {
                id: `${e.idPrefix}-overlay`,
                label: "Transcript features shown",
                gene: t,
                value: e.transcriptId,
                onChange: e.onTranscript
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(Hs, {
                id: `${e.idPrefix}-flank-up`,
                label: "Upstream flank (bp)",
                value: e.flankUp,
                max: Ks(t, e.flankDown),
                disabled: n,
                onChange: (i)=>e.onFlanks({
                        flankUp: i
                    })
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(Hs, {
                id: `${e.idPrefix}-flank-down`,
                label: "Downstream flank (bp)",
                value: e.flankDown,
                max: Ks(t, e.flankUp),
                disabled: n,
                onChange: (i)=>e.onFlanks({
                        flankDown: i
                    })
            }),
            a && r ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-readout",
                "data-testid": "gpr-template-size",
                children: [
                    "Template: ",
                    v(a.length),
                    " bp (",
                    Zt(r.region, a.start, a.end, r.strand),
                    ")"
                ]
            }) : null
        ]
    });
}
function Vs(e) {
    return {
        region: e?.region ?? "",
        start: e ? String(e.start) : "",
        end: e ? String(e.end) : "",
        strand: e?.strand === -1 ? "-1" : "1"
    };
}
function Ws(e) {
    const t = [], r = e.region.trim();
    r ? r.length > ee.maxIdLength && t.push({
        field: "region.region",
        code: "TOO_LONG",
        message: "The region name is too long."
    }) : t.push({
        field: "region.region",
        code: "REQUIRED",
        message: "Enter a chromosome or scaffold name."
    });
    const n = /^\d+$/.test(e.start.trim()) ? Number(e.start) : null, a = /^\d+$/.test(e.end.trim()) ? Number(e.end) : null;
    return (n === null || n < 1) && t.push({
        field: "region.start",
        code: "INVALID",
        message: "Start must be a whole number of at least 1."
    }), (a === null || a < 1) && t.push({
        field: "region.end",
        code: "INVALID",
        message: "End must be a whole number of at least 1."
    }), n !== null && a !== null && n >= 1 && a >= 1 && (a < n ? t.push({
        field: "region.end",
        code: "END_BEFORE_START",
        message: "End must not be before start."
    }) : a - n + 1 > ee.maxTemplateLength && t.push({
        field: "region.end",
        code: "TEMPLATE_TOO_LONG",
        message: `Regions are limited to ${v(ee.maxTemplateLength)} bp (this one is ${v(a - n + 1)} bp).`
    })), {
        value: t.length ? void 0 : {
            region: r,
            start: n,
            end: a,
            strand: e.strand === "-1" ? -1 : 1
        },
        issues: t
    };
}
function ed(e) {
    const [t, r] = (0, _react.useState)(()=>Vs(e.region)), n = (0, _react.useRef)(e.region);
    (0, _react.useEffect)(()=>{
        Yt(e.region, n.current) || (n.current = e.region, r(Vs(e.region)));
    }, [
        e.region
    ]);
    const a = Ws(t), i = [
        ...a.issues
    ];
    e.systemName ? (!ee.systemNamePattern.test(e.systemName) || e.systemName.length > 128) && i.unshift({
        field: "system_name",
        code: "INVALID",
        message: "The genome name is not valid."
    }) : i.unshift({
        field: "system_name",
        code: "REQUIRED",
        message: "Choose a genome."
    });
    const l = (0, _react.useRef)(e.onIssues);
    l.current = e.onIssues;
    const o = JSON.stringify(i);
    (0, _react.useEffect)(()=>{
        l.current(JSON.parse(o));
    }, [
        o
    ]), (0, _react.useEffect)(()=>()=>l.current([]), []);
    const d = (u)=>{
        const h = {
            ...t,
            ...u
        };
        r(h);
        const y = Ws(h);
        y.value && !Yt(y.value, e.region) && (n.current = y.value, e.onRegion(y.value));
    }, p = (u)=>`${e.idPrefix}-region-${u}`, g = (u)=>i.filter((h)=>h.field === u), m = (u)=>g(u).map((h)=>h.message).join(" "), f = _r(e.gene);
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("fieldset", {
        className: "gpr-fieldset",
        disabled: e.disabled,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("legend", {
                className: "gpr-legend",
                children: "Genomic region"
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ka, {
                id: p("genome"),
                label: "Genome",
                value: e.systemName,
                genomes: e.genomes,
                onChange: e.onSystemName
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                className: "gpr-field-grid",
                children: [
                    [
                        [
                            "region",
                            "Region",
                            "text",
                            "e.g. 1"
                        ],
                        [
                            "start",
                            "Start",
                            "numeric",
                            ""
                        ],
                        [
                            "end",
                            "End",
                            "numeric",
                            ""
                        ]
                    ].map(([u, h, y, _])=>{
                        const k = m(`region.${u}`);
                        return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                            className: "gpr-field",
                            children: [
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("label", {
                                    className: "gpr-label",
                                    htmlFor: p(u),
                                    children: h
                                }),
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                                    id: p(u),
                                    className: "gpr-input",
                                    type: "text",
                                    inputMode: y,
                                    spellCheck: !1,
                                    autoComplete: "off",
                                    placeholder: _ || void 0,
                                    value: t[u],
                                    "aria-invalid": k ? !0 : void 0,
                                    "aria-describedby": k ? `${p(u)}-err` : void 0,
                                    onChange: (b)=>d({
                                            [u]: b.target.value
                                        })
                                }),
                                k ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                    id: `${p(u)}-err`,
                                    className: "gpr-field-error",
                                    children: k
                                }) : null
                            ]
                        }, u);
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                        className: "gpr-field",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("label", {
                                className: "gpr-label",
                                htmlFor: p("strand"),
                                children: "Strand"
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("select", {
                                id: p("strand"),
                                className: "gpr-select",
                                value: t.strand,
                                onChange: (u)=>d({
                                        strand: u.target.value === "-1" ? "-1" : "1"
                                    }),
                                children: [
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("option", {
                                        value: "1",
                                        children: "+ (forward)"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("option", {
                                        value: "-1",
                                        children: "\u2212 (reverse)"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            a.value ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-readout",
                children: [
                    "Template: ",
                    v(a.value.end - a.value.start + 1),
                    " bp"
                ]
            }) : null,
            f ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                className: "gpr-button-row",
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                    type: "button",
                    className: "gpr-btn gpr-btn-small",
                    disabled: Yt(f, e.region),
                    onClick: ()=>e.onRegion(f),
                    children: "Use gene location"
                })
            }) : null
        ]
    });
}
function td(e) {
    const t = e.cleaned, r = `${e.idPrefix}-sequence-status`, n = [];
    t.invalidChars.length && n.push(`invalid characters: ${t.invalidChars.slice(0, 10).map((i)=>`\u{201C}${i}\u{201D}`).join(" ")}`), t.length > 0 && t.tooShort && n.push(`at least ${ee.minSequenceLength} nt are needed`), t.tooLong && n.push(`at most ${v(ee.maxSequenceLength)} nt are allowed`);
    const a = t.length > 0 && !t.ok;
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("fieldset", {
        className: "gpr-fieldset",
        disabled: e.disabled,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("legend", {
                className: "gpr-legend",
                children: "Sequence"
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                className: "gpr-field",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("label", {
                        className: "gpr-label",
                        htmlFor: `${e.idPrefix}-sequence`,
                        children: [
                            "Sequence (FASTA or plain, ",
                            ee.minSequenceLength,
                            "\u2013",
                            v(ee.maxSequenceLength),
                            " nt)"
                        ]
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("textarea", {
                        id: `${e.idPrefix}-sequence`,
                        className: "gpr-textarea",
                        rows: 8,
                        spellCheck: !1,
                        autoCapitalize: "off",
                        autoComplete: "off",
                        value: e.sequence,
                        maxLength: ee.maxSequenceInput,
                        "aria-invalid": a ? !0 : void 0,
                        "aria-describedby": r,
                        onChange: (i)=>e.onSequence(i.target.value)
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                        id: r,
                        className: a ? "gpr-field-error" : "gpr-readout",
                        children: [
                            v(t.length),
                            " nt",
                            n.length ? ` \xb7 ${n.join(" \xb7 ")}` : "",
                            t.iupacConverted ? " \xb7 IUPAC codes will be converted to N" : ""
                        ]
                    }),
                    t.records > 1 ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                        className: "gpr-note",
                        role: "note",
                        "data-code": "MULTIPLE_RECORDS",
                        children: [
                            v(t.records),
                            " FASTA records will be joined into one template, so a primer pair may span a join. Paste one record to design on it alone."
                        ]
                    }) : null
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ka, {
                id: `${e.idPrefix}-sequence-genome`,
                label: "Genome (needed for checks)",
                value: e.systemName,
                genomes: e.genomes,
                onChange: e.onSystemName,
                allowNone: !0,
                noneLabel: "None (design only)"
            })
        ]
    });
}
function er(e) {
    return e ? {
        s: String(e[0]),
        l: String(e[1])
    } : {
        s: "",
        l: ""
    };
}
function Qt(e) {
    const t = e.s.trim(), r = e.l.trim();
    if (!(!t && !r)) return !/^\d+$/.test(t) || !/^\d+$/.test(r) ? null : [
        Number(t),
        Number(r)
    ];
}
function Ys(e) {
    return {
        target: Qt(e.target) ?? void 0,
        included: Qt(e.included) ?? void 0,
        excluded: e.excluded.map(Qt).filter((t)=>!!t)
    };
}
function tr(e) {
    return JSON.stringify({
        target: e.target ?? null,
        included: e.included ?? null,
        excluded: e.excluded ?? []
    });
}
function nd(e) {
    const t = (0, _react.useRef)(0), r = ()=>({
            target: er(e.target),
            included: er(e.included),
            excluded: (e.excluded ?? []).map((u)=>({
                    ...er(u),
                    key: ++t.current
                }))
        }), [n, a] = (0, _react.useState)(r), i = tr({
        target: e.target,
        included: e.included,
        excluded: e.excluded
    });
    (0, _react.useEffect)(()=>{
        a((u)=>tr(Ys(u)) === i ? u : r());
    }, [
        i
    ]);
    const l = (u)=>{
        a(u);
        const h = Ys(u);
        tr(h) !== i && e.onChange(h);
    }, o = [], d = (u, h, y)=>{
        const _ = Qt(y);
        if (_ === null) o.push({
            field: u,
            code: "INCOMPLETE",
            message: `${h}: enter a whole-number start and length.`
        });
        else if (_) for (const k of kn(u, _, e.templateLength))o.push({
            ...k,
            message: `${h}: ${k.message}`
        });
    };
    d("target", "Target", n.target), d("included", "Included region", n.included), n.excluded.forEach((u, h)=>d(`excluded[${h}]`, `Excluded ${h + 1}`, u));
    const p = (0, _react.useRef)(e.onIssues);
    p.current = e.onIssues;
    const g = JSON.stringify(o);
    (0, _react.useEffect)(()=>{
        p.current(JSON.parse(g));
    }, [
        g
    ]), (0, _react.useEffect)(()=>()=>p.current([]), []);
    const m = (u, h, y, _, k, b)=>{
        const C = o.filter((R)=>R.field === u), N = `${y}-err`, w = Qt(_);
        return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
            className: "gpr-interval-row",
            role: "group",
            "aria-labelledby": `${y}-label`,
            "data-state": C.length ? "invalid" : void 0,
            children: [
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                    className: "gpr-interval-label",
                    id: `${y}-label`,
                    children: h
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("label", {
                    className: "gpr-visually-hidden",
                    htmlFor: `${y}-start`,
                    children: [
                        h,
                        " start"
                    ]
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                    id: `${y}-start`,
                    className: "gpr-input gpr-input-short",
                    type: "text",
                    inputMode: "numeric",
                    placeholder: "start",
                    autoComplete: "off",
                    value: _.s,
                    "aria-invalid": C.length ? !0 : void 0,
                    "aria-describedby": C.length ? N : void 0,
                    onChange: (R)=>k({
                            ..._,
                            s: R.target.value
                        })
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("label", {
                    className: "gpr-visually-hidden",
                    htmlFor: `${y}-len`,
                    children: [
                        h,
                        " length"
                    ]
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                    id: `${y}-len`,
                    className: "gpr-input gpr-input-short",
                    type: "text",
                    inputMode: "numeric",
                    placeholder: "length",
                    autoComplete: "off",
                    value: _.l,
                    "aria-invalid": C.length ? !0 : void 0,
                    "aria-describedby": C.length ? N : void 0,
                    onChange: (R)=>k({
                            ..._,
                            l: R.target.value
                        })
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                    className: "gpr-sub gpr-interval-end",
                    children: w ? `to ${v(w[0] + w[1] - 1)}` : ""
                }),
                b,
                C.length ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                    id: N,
                    className: "gpr-field-error gpr-interval-error",
                    children: C.map((R)=>R.message).join(" ")
                }) : null
            ]
        }, y);
    }, f = (u, h, y)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
            type: "button",
            className: "gpr-btn gpr-btn-small gpr-btn-quiet",
            "aria-label": `Clear ${u.toLowerCase()}`,
            disabled: !h.s && !h.l,
            onClick: ()=>y({
                    s: "",
                    l: ""
                }),
            children: "Clear"
        });
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("fieldset", {
        className: "gpr-fieldset gpr-intervals",
        disabled: e.disabled,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("legend", {
                className: "gpr-legend",
                children: "Target and excluded regions"
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-hint",
                children: [
                    "1-based template positions as start and length",
                    e.templateLength ? ` (template ${v(e.templateLength)} bp)` : "",
                    ". The product must cover the target; primers stay inside the included region and outside excluded regions.",
                    " ",
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(Lr, {
                        topic: "intervals"
                    })
                ]
            }),
            m("target", "Target", `${e.idPrefix}-iv-target`, n.target, (u)=>l({
                    ...n,
                    target: u
                }), f("Target", n.target, (u)=>l({
                    ...n,
                    target: u
                }))),
            m("included", "Included region", `${e.idPrefix}-iv-included`, n.included, (u)=>l({
                    ...n,
                    included: u
                }), f("Included region", n.included, (u)=>l({
                    ...n,
                    included: u
                }))),
            n.excluded.map((u, h)=>m(`excluded[${h}]`, `Excluded ${h + 1}`, `${e.idPrefix}-iv-ex-${u.key}`, u, (y)=>l({
                        ...n,
                        excluded: n.excluded.map((_)=>_.key === u.key ? {
                                ...y,
                                key: u.key
                            } : _)
                    }), /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                    type: "button",
                    className: "gpr-btn gpr-btn-small gpr-btn-quiet",
                    "aria-label": `Remove excluded interval ${h + 1}`,
                    onClick: ()=>l({
                            ...n,
                            excluded: n.excluded.filter((y)=>y.key !== u.key)
                        }),
                    children: "Remove"
                }))),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                className: "gpr-button-row",
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                    type: "button",
                    className: "gpr-btn gpr-btn-small",
                    disabled: n.excluded.length >= ee.maxExcluded,
                    onClick: ()=>l({
                            ...n,
                            excluded: [
                                ...n.excluded,
                                {
                                    s: "",
                                    l: "",
                                    key: ++t.current
                                }
                            ]
                        }),
                    children: "Add excluded interval"
                })
            })
        ]
    });
}
function rd({ modes: e, value: t, onChange: r, disabled: n, idPrefix: a, panelId: i }) {
    const l = (d)=>`${a}-mode-hint-${d}`, o = e.map((d)=>({
            id: d,
            label: ms[d],
            disabledReason: n?.[d] ?? null,
            describedBy: n?.[d] ? l(d) : void 0
        }));
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: "gpr-mode-tabs",
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(Pr, {
                items: o,
                value: t,
                onChange: r,
                label: "Design mode",
                idPrefix: `${a}-mode`,
                panelId: i,
                className: "gpr-tabs-mode"
            }),
            e.filter((d)=>n?.[d]).map((d)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                    id: l(d),
                    className: "gpr-hint gpr-tab-hint",
                    children: [
                        ms[d],
                        " mode is unavailable: ",
                        n?.[d]
                    ]
                }, d))
        ]
    });
}
const Js = 60;
function sd({ pair: e, template: t, label: r, sites: n, cuts: a, colours: i }) {
    const l = (w)=>i?.get(w) ?? va(w), o = t?.seq ?? "", d = e.left.start, p = e.right.end, g = !!o && d >= 1 && p <= o.length && p >= d, m = t?.features?.junctions, f = t?.mask, u = (a ?? []).map((w)=>`${w.position}:${w.enzyme}`).join(","), h = (n ?? []).map((w)=>`${w.start}:${w.end}:${w.enzyme}`).join(","), { lines: y, hasMask: _, hasJunction: k, shown: b } = (0, _react.useMemo)(()=>{
        if (!g) return {
            lines: [],
            hasMask: !1,
            hasJunction: !1,
            shown: []
        };
        const w = new Set((m ?? []).filter(($)=>$ >= d && $ < p)), R = /* @__PURE__ */ new Map();
        for (const $ of a ?? []){
            const L = $.position - 1;
            if (L < d || L >= p) continue;
            const z = R.get(L) ?? [];
            z.includes($.enzyme) || z.push($.enzyme), R.set(L, z);
        }
        const I = /* @__PURE__ */ new Map();
        for (const $ of n ?? [])for(let L = Math.max($.start, d); L <= Math.min($.end, p); L++){
            const z = I.get(L) ?? [];
            z.includes($.enzyme) || z.push($.enzyme), I.set(L, z);
        }
        const M = new Uint8Array(p - d + 1);
        for (const [$, L] of f ?? [])for(let z = Math.max($, d); z <= Math.min(p, $ + L - 1); z++)M[z - d] = 1;
        const P = [];
        let V = !1;
        for(let $ = d; $ <= p; $ += Js){
            const L = Math.min(p, $ + Js - 1), z = [];
            let K = null;
            for(let S = $; S <= L; S++){
                const T = M[S - d] === 1;
                V = V || T;
                const W = I.get(S) ?? [], H = Pe(S >= e.left.start && S <= e.left.end && "gpr-fp-left", S >= e.right.start && S <= e.right.end && "gpr-fp-right", T && "gpr-seq-masked", W.length > 0 && "gpr-seq-site") || "gpr-seq-plain";
                (!K || K.cls !== H || K.siteOf.join("+") !== W.join("+")) && (K = {
                    text: "",
                    cls: H,
                    barAfter: !1,
                    cutAfter: [],
                    siteOf: W
                }, z.push(K)), K.text += o[S - 1] ?? "";
                const O = R.get(S);
                (w.has(S) || O) && (K.barAfter = w.has(S), K.cutAfter = O ?? [], K = null);
            }
            P.push({
                pos: $,
                segs: z
            });
        }
        return {
            lines: P,
            hasMask: V,
            hasJunction: w.size > 0,
            // Only enzymes actually visible in this amplicon belong in its legend.
            shown: [
                ...new Set((n ?? []).filter(($)=>$.end >= d && $.start <= p).map(($)=>$.enzyme))
            ]
        };
    }, [
        g,
        o,
        d,
        p,
        e.left.start,
        e.left.end,
        e.right.start,
        e.right.end,
        m,
        f,
        u,
        h
    ]);
    if (!g) return /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
        className: "gpr-hint",
        children: "The amplicon sequence is not available."
    });
    const C = e.rank + 1, N = String(p).length;
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: "gpr-amplicon",
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                className: "gpr-amplicon-head",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                        className: "gpr-amplicon-title",
                        children: [
                            "Amplicon: ",
                            v(p - d + 1),
                            " bp (template ",
                            v(d),
                            "\u2013",
                            v(p),
                            ")"
                        ]
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(it, {
                        text: ()=>Sa([
                                e
                            ], t ? {
                                seq: o,
                                length: t.length
                            } : null, {
                                label: r
                            }),
                        label: `Copy the amplicon of pair ${C} as FASTA`,
                        children: "Copy FASTA"
                    })
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                className: "gpr-amplicon-seq",
                role: "group",
                "aria-label": `Amplicon sequence of pair ${C}`,
                children: y.map((w)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                        className: "gpr-amplicon-line",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                className: "gpr-amplicon-pos",
                                "aria-hidden": "true",
                                children: String(w.pos).padStart(N, " ")
                            }),
                            w.segs.map((R, I)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                                    children: [
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                            className: R.cls,
                                            style: R.siteOf.length ? {
                                                boxShadow: `inset 0 -2px 0 ${l(R.siteOf[0])}`
                                            } : void 0,
                                            title: R.siteOf.length ? `${R.siteOf.join(", ")} site` : void 0,
                                            children: R.text
                                        }),
                                        R.barAfter ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                            className: "gpr-junction-bar",
                                            "aria-hidden": "true"
                                        }) : null,
                                        R.cutAfter.map((M)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                className: "gpr-cut-bar",
                                                style: {
                                                    borderLeftColor: l(M)
                                                },
                                                "aria-hidden": "true"
                                            }, M))
                                    ]
                                }, I))
                        ]
                    }, w.pos))
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-amplicon-legend",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                        className: "gpr-fp-left",
                        children: "left primer"
                    }),
                    " ",
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                        className: "gpr-fp-right",
                        children: "right primer site (reverse complement)"
                    }),
                    k ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            " ",
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                className: "gpr-junction-sample",
                                "aria-hidden": "true"
                            }),
                            " exon\u2013exon junction"
                        ]
                    }) : null,
                    b.map((w)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                            children: [
                                " ",
                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                    className: "gpr-seq-site",
                                    style: {
                                        boxShadow: `inset 0 -2px 0 ${l(w)}`
                                    },
                                    children: w
                                })
                            ]
                        }, w)),
                    b.length ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            " ",
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                className: "gpr-cut-sample",
                                "aria-hidden": "true"
                            }),
                            " cut"
                        ]
                    }) : null,
                    _ ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            " ",
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                className: "gpr-seq-masked",
                                children: "masked"
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
}
function ad(e) {
    const t = De("gpr-digest"), [r, n] = (0, _react.useState)(!1), a = e.template?.seq, i = `${e.span.start}-${e.span.end}`, l = e.maxCuts ?? 4, o = (0, _react.useMemo)(()=>Sr(a, e.span, {
            enzymes: e.enzymes
        }), [
        a,
        i,
        e.enzymes
    ]), d = (0, _react.useMemo)(()=>fo(a, e.span, e.enzymes), [
        a,
        i,
        e.enzymes
    ]), p = (0, _react.useMemo)(()=>new Set(e.selected ?? []), [
        e.selected
    ]), g = In(e.selected ?? []), m = e.colours ?? g;
    if (!a) return null;
    const f = o.filter((b)=>b.cuts.length <= l), u = r ? o : f, h = e.span.end - e.span.start + 1, y = u.map((b)=>b.enzyme.name), _ = y.length > 0 && y.every((b)=>p.has(b)), k = (b, C)=>{
        const N = new Set(p);
        C ? N.add(b) : N.delete(b), e.onSelect?.([
            ...N
        ]);
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: "gpr-digest",
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                className: "gpr-table-wrap",
                children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("table", {
                    className: "gpr-table gpr-digest-table",
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("caption", {
                            className: "gpr-caption",
                            children: [
                                "Restriction sites in the ",
                                v(h),
                                " bp product \xb7",
                                " ",
                                o.length ? `${v(o.length)} enzyme${o.length === 1 ? "" : "s"} cut it` : "no enzyme in the panel cuts it"
                            ]
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("thead", {
                            children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                children: [
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        className: "gpr-col-check",
                                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                            className: "gpr-visually-hidden",
                                            children: "Show sites"
                                        })
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Enzyme"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Site"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        className: "gpr-num",
                                        children: "Sites"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Positions (template)"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Fragments (bp)"
                                    })
                                ]
                            })
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("tbody", {
                            children: [
                                u.map((b)=>{
                                    const C = p.has(b.enzyme.name);
                                    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                        children: [
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                className: "gpr-col-check",
                                                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                                                    type: "checkbox",
                                                    className: "gpr-checkbox",
                                                    id: `${t}-e-${b.enzyme.name}`,
                                                    checked: C,
                                                    "aria-label": `Show ${b.enzyme.name} sites`,
                                                    onChange: (N)=>k(b.enzyme.name, N.target.checked)
                                                })
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                                scope: "row",
                                                children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("label", {
                                                    htmlFor: `${t}-e-${b.enzyme.name}`,
                                                    className: "gpr-digest-name",
                                                    children: [
                                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                            className: "gpr-digest-swatch",
                                                            "aria-hidden": "true",
                                                            "data-off": C ? void 0 : "true",
                                                            style: C ? {
                                                                backgroundColor: m.get(b.enzyme.name)
                                                            } : void 0
                                                        }),
                                                        b.enzyme.name
                                                    ]
                                                })
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("code", {
                                                    className: "gpr-seq",
                                                    children: _a(b.enzyme)
                                                })
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                className: "gpr-num",
                                                children: b.sites.length
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                className: "gpr-digest-positions",
                                                children: b.sites.map((N)=>`${v(N.start)}\u{2013}${v(N.end)}`).join(", ")
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                children: b.fragments.map((N)=>v(N)).join(" / ")
                                            })
                                        ]
                                    }, b.enzyme.name);
                                }),
                                u.length === 0 ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("tr", {
                                    children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                        colSpan: 6,
                                        className: "gpr-sub",
                                        children: o.length ? "No enzyme cuts this product few enough times to read." : "No enzyme in the panel has a site inside this product."
                                    })
                                }) : null
                            ]
                        })
                    ]
                })
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-hint",
                id: `${t}-hint`,
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "gpr-btn gpr-btn-small gpr-btn-quiet",
                        disabled: _ || !y.length,
                        onClick: ()=>e.onSelect?.([
                                .../* @__PURE__ */ new Set([
                                    ...p,
                                    ...y
                                ])
                            ]),
                        children: "Select all"
                    }),
                    " ",
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "gpr-btn gpr-btn-small gpr-btn-quiet",
                        disabled: !y.some((b)=>p.has(b)),
                        onClick: ()=>e.onSelect?.([
                                ...p
                            ].filter((b)=>!y.includes(b))),
                        children: "Select none"
                    }),
                    " ",
                    "Ticking an enzyme marks its sites and cuts in the sequence above. Sizes are from sequence alone: methylation, star activity and partial digests are not modelled.",
                    o.length > f.length ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            " ",
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: "gpr-btn gpr-btn-small gpr-btn-quiet",
                                onClick: ()=>n((b)=>!b),
                                children: r ? `Hide the ${v(o.length - f.length)} that cut more than ${l} times` : `Show ${v(o.length - f.length)} more that cut more than ${l} times`
                            })
                        ]
                    }) : null
                ]
            }),
            d.length ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-hint",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("strong", {
                        children: v(d.length)
                    }),
                    " of the panel have no site in this product, so they are safe to add to the primer ends: ",
                    d.slice(0, 12).map((b)=>b.name).join(", "),
                    d.length > 12 ? ` and ${v(d.length - 12)} more` : "",
                    "."
                ]
            }) : null
        ]
    });
}
const id = [
    [
        "Sequence (5\u2032\u21923\u2032)",
        (e)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("code", {
                className: "gpr-seq",
                children: e.seq
            })
    ],
    [
        "Template position",
        (e)=>`${v(e.start)}\u{2013}${v(e.end)}`
    ],
    [
        "Length",
        (e)=>`${e.len} nt`
    ],
    [
        "Tm",
        (e)=>`${F(e.tm, 2)} \xb0C`
    ],
    [
        "GC",
        (e)=>`${F(e.gc, 1)} %`
    ],
    [
        "Self-complementarity, any (Tm \xb0C)",
        (e)=>F(e.self_any_th)
    ],
    [
        "Self-complementarity, 3\u2032 end (Tm \xb0C)",
        (e)=>F(e.self_end_th)
    ],
    [
        "Hairpin (Tm \xb0C)",
        (e)=>F(e.hairpin_th)
    ],
    [
        "3\u2032 end stability (kcal/mol)",
        (e)=>F(e.end_stability, 2)
    ],
    [
        "Penalty",
        (e)=>F(e.penalty, 3)
    ],
    [
        "Exon\u2013exon junction",
        (e)=>e.junction ? `at ${v(e.junction.position)}: ${e.junction.overlap_5p} nt 5\u{2032}, ${e.junction.overlap_3p} nt 3\u{2032}` : "\u2013"
    ],
    [
        "Genomic",
        (e)=>e.genomic ? gt(e.genomic) : "\u2013"
    ]
];
function od({ pair: e, template: t, label: r, primers: n, id: a, enzymes: i, selectedEnzymes: l, onSelectEnzymes: o, enzymeColours: d }) {
    const p = e.rank + 1, [g, m] = (0, _react.useState)([]), f = o ? l ?? [] : g, u = o ?? m, h = In(f), y = d ?? h, _ = {
        start: e.left.start,
        end: e.right.end
    }, k = [
        ...f
    ].sort().join(","), b = (0, _react.useMemo)(()=>{
        const w = f.map((M)=>no(M, i)).filter((M)=>M !== null);
        if (!w.length || !t?.seq) return {
            sites: [],
            cuts: []
        };
        const R = [], I = [];
        for (const M of Sr(t.seq, _, {
            enzymes: w
        })){
            for (const P of M.sites)R.push({
                start: P.start,
                end: P.end,
                enzyme: M.enzyme.name
            });
            for (const P of M.cuts)I.push({
                position: P,
                enzyme: M.enzyme.name
            });
        }
        return {
            sites: R,
            cuts: I
        };
    }, [
        k,
        i,
        t?.seq,
        _.start,
        _.end
    ]), C = (w)=>n?.[w.seq.toUpperCase()] ?? null, N = !!(C(e.left) || C(e.right));
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: "gpr-pair-detail",
        id: a,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                className: "gpr-table-wrap",
                children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("table", {
                    className: "gpr-table gpr-detail-table",
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("caption", {
                            className: "gpr-caption",
                            children: [
                                "Primer statistics, pair ",
                                p
                            ]
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("thead", {
                            children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                children: [
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Statistic"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Left primer"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Right primer"
                                    })
                                ]
                            })
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("tbody", {
                            children: [
                                id.map(([w, R])=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                        children: [
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                                scope: "row",
                                                children: w
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                children: R(e.left)
                                            }),
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                children: R(e.right)
                                            })
                                        ]
                                    }, w)),
                                N ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                    children: [
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                            scope: "row",
                                            children: "Near-perfect genome sites"
                                        }),
                                        [
                                            e.left,
                                            e.right
                                        ].map((w, R)=>{
                                            const I = C(w);
                                            return /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                children: I ? `${v(I.near_perfect_sites)}${I.repetitive ? " (repetitive)" : ""}` : "\u2013"
                                            }, R);
                                        })
                                    ]
                                }) : null
                            ]
                        })
                    ]
                })
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("dl", {
                className: "gpr-dl gpr-product-stats",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                        className: "gpr-dl-row",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("dt", {
                                children: "Product"
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("dd", {
                                children: [
                                    v(e.product_size),
                                    " bp, template ",
                                    v(e.product.start),
                                    "\u2013",
                                    v(e.product.end)
                                ]
                            })
                        ]
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                        className: "gpr-dl-row",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("dt", {
                                children: "Product Tm"
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("dd", {
                                children: e.product_tm == null ? "not reported" : `${F(e.product_tm, 1)} \xb0C`
                            })
                        ]
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                        className: "gpr-dl-row",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("dt", {
                                children: "Pair complementarity, any / 3\u2032 (Tm \xb0C)"
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("dd", {
                                children: [
                                    F(e.compl_any_th),
                                    " / ",
                                    F(e.compl_end_th)
                                ]
                            })
                        ]
                    }),
                    e.product.genomic ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                        className: "gpr-dl-row",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("dt", {
                                children: "Genomic"
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("dd", {
                                children: [
                                    gt(e.product.genomic),
                                    e.product.genomic_size != null ? ` (${v(e.product.genomic_size)} bp in the genome)` : ""
                                ]
                            })
                        ]
                    }) : null
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(sd, {
                pair: e,
                template: t,
                label: r,
                sites: b.sites,
                cuts: b.cuts,
                colours: y
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(ad, {
                template: t,
                span: _,
                enzymes: i,
                selected: f,
                onSelect: u,
                colours: y
            })
        ]
    });
}
const ld = [
    [
        "Tm \xb0C, GC %",
        "tm_gc"
    ],
    [
        "Product bp",
        "product"
    ],
    [
        "Penalty",
        "penalty"
    ],
    [
        "Compl. any/3\u2032",
        "complementarity"
    ],
    [
        "Hairpin",
        "hairpin"
    ],
    [
        "Self-complementarity (Details)",
        "self_complementarity"
    ],
    [
        "3\u2032 end stability (Details)",
        "end_stability"
    ],
    [
        "Product Tm (Details)",
        "product_tm"
    ]
];
function Xs({ oligo: e, side: t, n: r, info: n }) {
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        className: "gpr-primer",
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                className: "gpr-primer-line",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("code", {
                        className: "gpr-seq",
                        children: e.seq
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(it, {
                        text: e.seq,
                        label: `Copy the ${t} primer of pair ${r}`
                    })
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                className: "gpr-sub gpr-block",
                children: [
                    v(e.start),
                    "\u2013",
                    v(e.end),
                    " \xb7 ",
                    e.len,
                    " nt"
                ]
            }),
            n?.repetitive ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                className: "gpr-badge gpr-badge-warn",
                title: `${v(n.near_perfect_sites)} near-perfect genome sites`,
                children: [
                    "repetitive",
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                        className: "gpr-visually-hidden",
                        children: [
                            ": ",
                            v(n.near_perfect_sites),
                            " near-perfect genome sites"
                        ]
                    })
                ]
            }) : null
        ]
    });
}
function cd({ pair: e }) {
    const t = [
        [
            "L",
            "left",
            e.left
        ],
        [
            "R",
            "right",
            e.right
        ]
    ].filter(([, , r])=>!!r.junction);
    return t.length ? /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: t.map(([r, n, a])=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                className: "gpr-badge gpr-badge-junction",
                title: `The ${n} primer spans the junction at ${a.junction.position}`,
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                        "aria-hidden": "true",
                        children: [
                            r,
                            " \u27C2 ",
                            v(a.junction.position)
                        ]
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                        className: "gpr-visually-hidden",
                        children: [
                            n,
                            " primer spans the junction at ",
                            v(a.junction.position),
                            " (",
                            a.junction.overlap_5p,
                            " nt 5\u2032, ",
                            a.junction.overlap_3p,
                            " nt 3\u2032)"
                        ]
                    })
                ]
            }, r))
    }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
        className: "gpr-sub",
        children: "\u2013"
    });
}
function dd(e) {
    const { pairs: t, template: r, checkedRanks: n, onCheckedChange: a, selectedRank: i, onSelect: l, check: o, submitted: d, label: p, caption: g } = e, m = De("gpr-pairs"), [f, u] = (0, _react.useState)(()=>/* @__PURE__ */ new Set()), h = (0, _react.useMemo)(()=>o ? Aa(t, o, d) : null, [
        t,
        o,
        d
    ]), y = new Set(n ?? []), _ = t.filter((M)=>y.has(M.rank)), k = !!a, b = !!o, C = o?.status === "queued" || o?.status === "running", N = o?.results?.primers ?? null, w = r?.mode === "transcript", R = 11 + (k ? 1 : 0) + (b ? 1 : 0), I = (M, P)=>{
        const V = new Set(y);
        P ? V.add(M) : V.delete(M), a?.([
            ...V
        ].sort(($, L)=>$ - L));
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)(bt, {
        theme: e.theme,
        injectStyles: e.injectStyles,
        className: e.className,
        style: e.style,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                className: "gpr-table-wrap",
                children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("table", {
                    className: "gpr-table gpr-pairs-table",
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("caption", {
                            className: "gpr-caption",
                            children: [
                                g ?? `${t.length} primer pair${t.length === 1 ? "" : "s"}`,
                                k ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                    className: "gpr-sub",
                                    children: [
                                        " ",
                                        "\xb7 tick up to ",
                                        ae.maxPairs,
                                        " pairs (",
                                        ae.maxUniquePrimers,
                                        " distinct primers) to check them"
                                    ]
                                }) : null
                            ]
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("thead", {
                            children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                children: [
                                    k ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        className: "gpr-col-check",
                                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                            className: "gpr-visually-hidden",
                                            children: "Select for check"
                                        })
                                    }) : null,
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "#"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Left primer 5\u2032\u21923\u2032"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Right primer 5\u2032\u21923\u2032"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Tm \xb0C L/R"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "GC % L/R"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Product bp"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Penalty"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Compl. any/3\u2032"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Hairpin L/R"
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Junction"
                                    }),
                                    b ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: "Check"
                                    }) : null,
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                        scope: "col",
                                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                            className: "gpr-visually-hidden",
                                            children: "Details"
                                        })
                                    })
                                ]
                            })
                        }),
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("tbody", {
                            children: t.map((M)=>{
                                const P = M.rank + 1, V = M.rank === i, $ = f.has(M.rank), L = `${m}-detail-${M.rank}`, z = vr(M), K = y.has(M.rank), S = K || Ui(_, M), T = z.ok ? S ? null : `At most ${ae.maxPairs} pairs and ${ae.maxUniquePrimers} distinct primers can be checked at once` : z.message, W = `${m}-why-${M.rank}`, H = h?.byRank.get(M.rank) ?? null, O = H?.pangenome ? Ia(H.pangenome.summary) : null, U = H?.pangenome ? lr(H.pangenome) : 0;
                                return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                                    children: [
                                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("tr", {
                                            className: "gpr-pair-row",
                                            "data-state": V ? "selected" : void 0,
                                            "data-rank": M.rank,
                                            children: [
                                                k ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("td", {
                                                    className: "gpr-col-check",
                                                    children: [
                                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                                                            type: "checkbox",
                                                            className: "gpr-checkbox",
                                                            "aria-label": `Check pair ${P}`,
                                                            checked: K,
                                                            disabled: !!T && !K,
                                                            "aria-describedby": T ? W : void 0,
                                                            onChange: (B)=>I(M.rank, B.target.checked)
                                                        }),
                                                        T ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                            id: W,
                                                            className: "gpr-visually-hidden",
                                                            children: T
                                                        }) : null,
                                                        z.ok ? null : /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                            className: "gpr-sub gpr-block gpr-not-checkable",
                                                            "aria-hidden": "true",
                                                            title: z.message,
                                                            children: "not checkable"
                                                        })
                                                    ]
                                                }) : null,
                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("th", {
                                                    scope: "row",
                                                    className: "gpr-col-rank",
                                                    children: l ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                                        type: "button",
                                                        className: "gpr-rank",
                                                        "aria-pressed": V,
                                                        "aria-label": `Select pair ${P}`,
                                                        onClick: ()=>l(M.rank),
                                                        children: P
                                                    }) : P
                                                }),
                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                    className: "gpr-col-primer",
                                                    children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Xs, {
                                                        oligo: M.left,
                                                        side: "left",
                                                        n: P,
                                                        info: N?.[M.left.seq.toUpperCase()] ?? null
                                                    })
                                                }),
                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                    className: "gpr-col-primer",
                                                    children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Xs, {
                                                        oligo: M.right,
                                                        side: "right",
                                                        n: P,
                                                        info: N?.[M.right.seq.toUpperCase()] ?? null
                                                    })
                                                }),
                                                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("td", {
                                                    className: "gpr-num",
                                                    children: [
                                                        F(M.left.tm),
                                                        " / ",
                                                        F(M.right.tm)
                                                    ]
                                                }),
                                                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("td", {
                                                    className: "gpr-num",
                                                    children: [
                                                        F(M.left.gc),
                                                        " / ",
                                                        F(M.right.gc)
                                                    ]
                                                }),
                                                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("td", {
                                                    className: "gpr-num",
                                                    children: [
                                                        v(M.product_size),
                                                        w && M.product?.genomic_size != null ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                            className: "gpr-sub gpr-block",
                                                            children: [
                                                                "gDNA ",
                                                                v(M.product.genomic_size)
                                                            ]
                                                        }) : null
                                                    ]
                                                }),
                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                    className: "gpr-num",
                                                    children: F(M.penalty, 2)
                                                }),
                                                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("td", {
                                                    className: "gpr-num",
                                                    children: [
                                                        F(M.compl_any_th),
                                                        " / ",
                                                        F(M.compl_end_th)
                                                    ]
                                                }),
                                                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("td", {
                                                    className: "gpr-num",
                                                    children: [
                                                        F(M.left.hairpin_th),
                                                        " / ",
                                                        F(M.right.hairpin_th)
                                                    ]
                                                }),
                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                    className: "gpr-col-junction",
                                                    children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(cd, {
                                                        pair: M
                                                    })
                                                }),
                                                b ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                    className: "gpr-col-verdict",
                                                    children: H ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "gpr-verdicts",
                                                        children: [
                                                            H.specificity ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(at, {
                                                                verdict: H.specificity.verdict,
                                                                count: H.specificity.off_target_count,
                                                                inferred: H.specificity.on_target_inferred,
                                                                context: "Genome"
                                                            }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)(at, {
                                                                verdict: C ? "pending" : "not_checked",
                                                                context: "Genome"
                                                            }),
                                                            H.transcriptome ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                                className: "gpr-verdict-line",
                                                                children: [
                                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "gpr-sub",
                                                                        "aria-hidden": "true",
                                                                        children: "cDNA"
                                                                    }),
                                                                    " ",
                                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(at, {
                                                                        verdict: H.transcriptome.verdict,
                                                                        count: H.transcriptome.off_target_count,
                                                                        context: "Transcriptome"
                                                                    })
                                                                ]
                                                            }) : null,
                                                            O ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                                className: "gpr-sub gpr-block gpr-amplifies",
                                                                children: [
                                                                    "amplifies ",
                                                                    O.amplifies,
                                                                    "/",
                                                                    O.total,
                                                                    U ? ` \xb7 ${U} incomplete` : ""
                                                                ]
                                                            }) : null
                                                        ]
                                                    }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)(at, {
                                                        verdict: "not_checked"
                                                    })
                                                }) : null,
                                                /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                    className: "gpr-col-expand",
                                                    children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("button", {
                                                        type: "button",
                                                        className: "gpr-btn gpr-btn-small gpr-btn-quiet",
                                                        "aria-expanded": $,
                                                        "aria-controls": $ ? L : void 0,
                                                        onClick: ()=>u((B)=>{
                                                                const ne = new Set(B);
                                                                return ne.has(M.rank) ? ne.delete(M.rank) : ne.add(M.rank), ne;
                                                            }),
                                                        children: [
                                                            $ ? "Hide" : "Details",
                                                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                                                className: "gpr-visually-hidden",
                                                                children: [
                                                                    " of pair ",
                                                                    P
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        $ ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("tr", {
                                            className: "gpr-detail-row",
                                            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("td", {
                                                colSpan: R,
                                                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(od, {
                                                    id: L,
                                                    pair: M,
                                                    template: r,
                                                    label: p,
                                                    primers: N,
                                                    enzymes: e.enzymes,
                                                    selectedEnzymes: e.selectedEnzymes,
                                                    onSelectEnzymes: e.onSelectEnzymes,
                                                    enzymeColours: e.enzymeColours
                                                })
                                            })
                                        }) : null
                                    ]
                                }, M.rank);
                            })
                        })
                    ]
                })
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("details", {
                className: "gpr-details gpr-column-help",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("summary", {
                        className: "gpr-summary",
                        children: "About these columns"
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("dl", {
                        className: "gpr-dl gpr-column-help-list",
                        children: ld.map(([M, P])=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                                className: "gpr-dl-row",
                                children: [
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("dt", {
                                        children: M
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("dd", {
                                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(zt, {
                                            topic: P
                                        })
                                    })
                                ]
                            }, P))
                    })
                ]
            })
        ]
    });
}
const pd = [
    "pcr",
    "qpcr"
].map((e)=>({
        id: e,
        label: en[e].label,
        description: en[e].description
    })), gd = [
    {
        label: "Primer size",
        unit: "nt",
        topic: "size",
        keys: [
            "min_size",
            "opt_size",
            "max_size"
        ]
    },
    {
        label: "Melting temperature",
        unit: "\xb0C",
        topic: "tm",
        keys: [
            "min_tm",
            "opt_tm",
            "max_tm"
        ]
    },
    {
        label: "GC content",
        unit: "%",
        topic: "gc",
        keys: [
            "min_gc",
            "opt_gc",
            "max_gc"
        ]
    }
], md = [
    {
        key: "max_poly_x",
        label: "Max mononucleotide run (nt)"
    },
    {
        key: "gc_clamp",
        label: "GC clamp (3\u2032 G/C bases)"
    },
    {
        key: "max_end_stability",
        label: "Max 3\u2032 end stability (kcal/mol)"
    },
    {
        key: "max_ns",
        label: "Max Ns accepted"
    },
    {
        key: "salt_monovalent",
        label: "Monovalent cations (mM)"
    },
    {
        key: "salt_divalent",
        label: "Divalent cations (mM)"
    },
    {
        key: "dntp_conc",
        label: "dNTP (mM)"
    },
    {
        key: "dna_conc",
        label: "Oligo DNA (nM)"
    },
    {
        key: "min_5_prime_overlap_of_junction",
        label: "Min junction overlap, 5\u2032 side (nt)",
        transcriptOnly: !0
    },
    {
        key: "min_3_prime_overlap_of_junction",
        label: "Min junction overlap, 3\u2032 side (nt)",
        transcriptOnly: !0
    }
];
function ud(e, t, r, n, a) {
    const i = en[t].params[e];
    if (typeof i == "number") return String(i);
    const l = !!a?.params && e in a.params;
    if (n?.params && a?.mode === r && !l) {
        const d = n.params[e];
        if (typeof d == "number") return String(d);
    }
    const o = Ai[e];
    return typeof o == "number" ? String(o) : "";
}
function pi(e) {
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("legend", {
        className: "gpr-legend gpr-legend-small",
        children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
            className: "gpr-label-row",
            children: [
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                    id: e.textId,
                    children: e.label
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)(qr, {
                    subject: e.label,
                    expanded: e.open,
                    controls: e.helpId,
                    onToggle: e.onToggle
                })
            ]
        })
    });
}
function hd(e) {
    const { idPrefix: t, ranges: r, changed: n, issues: a, onChange: i, helpOpen: l, onHelp: o } = e, [d, p] = (0, _react.useState)(""), [g, m] = (0, _react.useState)(""), f = Number(d), u = Number(g), y = /^\d+$/.test(d.trim()) && /^\d+$/.test(g.trim()) && f < u && f >= ee.minProductSize && u <= ee.maxProductSize && r.length < ee.maxProductRanges, _ = ()=>{
        y && (i([
            ...r,
            [
                f,
                u
            ]
        ].sort((w, R)=>w[0] - R[0] || w[1] - R[1])), p(""), m(""));
    }, k = (w)=>{
        w.key === "Enter" && (w.preventDefault(), _());
    }, b = `${t}-ranges-err`, C = `${t}-ranges-legend`, N = `${t}-help-product_size_ranges`;
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("fieldset", {
        className: "gpr-subfieldset gpr-ranges",
        "data-state": n ? "changed" : void 0,
        "aria-labelledby": C,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(pi, {
                textId: C,
                label: "Product size ranges (bp)",
                helpId: N,
                open: l,
                onToggle: o
            }),
            l ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                id: N,
                className: "gpr-hint gpr-help-text",
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(zt, {
                    topic: "product_size_ranges"
                })
            }) : null,
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("ul", {
                className: "gpr-range-chips",
                "aria-describedby": a.length ? b : void 0,
                children: r.map((w, R)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)("li", {
                        className: "gpr-range-chip",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                                children: [
                                    v(w[0]),
                                    "\u2013",
                                    v(w[1])
                                ]
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: "gpr-range-chip-remove",
                                "aria-label": `Remove range ${w[0]}\u{2013}${w[1]} bp`,
                                disabled: r.length <= 1 && !n,
                                onClick: ()=>{
                                    const I = r.filter((M, P)=>P !== R);
                                    i(I.length ? I : void 0);
                                },
                                children: "\xd7"
                            })
                        ]
                    }, `${w[0]}-${w[1]}-${R}`))
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                className: "gpr-range-add",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("label", {
                        className: "gpr-visually-hidden",
                        htmlFor: `${t}-range-from`,
                        children: "New range from (bp)"
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                        id: `${t}-range-from`,
                        className: "gpr-input gpr-input-short",
                        type: "text",
                        inputMode: "numeric",
                        placeholder: "from",
                        value: d,
                        onChange: (w)=>p(w.target.value),
                        onKeyDown: k
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                        "aria-hidden": "true",
                        children: "\u2013"
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("label", {
                        className: "gpr-visually-hidden",
                        htmlFor: `${t}-range-to`,
                        children: "New range to (bp)"
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
                        id: `${t}-range-to`,
                        className: "gpr-input gpr-input-short",
                        type: "text",
                        inputMode: "numeric",
                        placeholder: "to",
                        value: g,
                        onChange: (w)=>m(w.target.value),
                        onKeyDown: k
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "gpr-btn gpr-btn-small",
                        disabled: !y,
                        onClick: _,
                        children: "Add range"
                    })
                ]
            }),
            a.length ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                id: b,
                className: "gpr-field-error",
                children: a.map((w)=>w.message).join(" ")
            }) : null
        ]
    });
}
function fd(e) {
    const [t, r] = (0, _react.useState)(null), n = (p)=>r((g)=>g === p ? null : p), a = br(e.preset, e.params), i = (p)=>e.issues.filter((g)=>g.field === p), l = e.params ?? {}, o = (p, g, m)=>{
        const f = he[p], u = l[p], h = `${e.idPrefix}-param-${p}`, y = `${h}-help`, _ = !!m && t === m.topic;
        return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
            children: [
                /* @__PURE__ */ (0, _jsxRuntime.jsx)(mt, {
                    id: h,
                    label: g,
                    value: typeof u == "number" ? u : void 0,
                    placeholder: ud(p, e.preset, e.mode, e.settings, e.lastRequest),
                    min: f.min,
                    max: f.max,
                    step: f.integer ? 1 : "any",
                    issues: i(p),
                    changed: typeof u == "number",
                    labelAddon: m ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(qr, {
                        subject: m.subject,
                        expanded: _,
                        controls: y,
                        onToggle: ()=>n(m.topic)
                    }) : void 0,
                    describedBy: _ ? y : void 0,
                    onChange: (k)=>e.onParam(p, k)
                }),
                m && _ ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                    id: y,
                    className: "gpr-hint gpr-help-text gpr-help-wide",
                    children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(zt, {
                        topic: m.topic
                    })
                }) : null
            ]
        }, p);
    }, d = e.issues.filter((p)=>p.field === "product_size_ranges" || p.field.startsWith("product_size_ranges["));
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("fieldset", {
        className: "gpr-fieldset gpr-params",
        disabled: e.disabled,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("legend", {
                className: "gpr-legend",
                children: "Primer3 parameters"
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                className: "gpr-hint",
                children: [
                    "Settings for Primer3; an empty field uses the value shown in grey. ",
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(zr, {
                        anchor: "globalTags",
                        children: "Primer3 manual"
                    })
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(za, {
                idPrefix: e.idPrefix,
                legend: "Preset",
                options: e.presets ?? pd,
                value: e.preset,
                onChange: e.onPreset
            }),
            gd.map((p)=>{
                const g = `${e.idPrefix}-legend-${p.topic}`, m = `${e.idPrefix}-help-${p.topic}`;
                return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("fieldset", {
                    className: "gpr-subfieldset gpr-triple",
                    "aria-labelledby": g,
                    children: [
                        /* @__PURE__ */ (0, _jsxRuntime.jsx)(pi, {
                            textId: g,
                            label: `${p.label} (${p.unit})`,
                            helpId: m,
                            open: t === p.topic,
                            onToggle: ()=>n(p.topic)
                        }),
                        t === p.topic ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                            id: m,
                            className: "gpr-hint gpr-help-text",
                            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(zt, {
                                topic: p.topic
                            })
                        }) : null,
                        /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                            className: "gpr-triple-grid",
                            children: [
                                o(p.keys[0], /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                            className: "gpr-visually-hidden",
                                            children: p.label
                                        }),
                                        " min"
                                    ]
                                })),
                                o(p.keys[1], /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                            className: "gpr-visually-hidden",
                                            children: p.label
                                        }),
                                        " opt"
                                    ]
                                })),
                                o(p.keys[2], /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                                            className: "gpr-visually-hidden",
                                            children: p.label
                                        }),
                                        " max"
                                    ]
                                }))
                            ]
                        })
                    ]
                }, p.label);
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                className: "gpr-field-grid",
                children: [
                    o("max_tm_diff", "Max Tm difference (\xb0C)", {
                        topic: "max_tm_diff",
                        subject: "Max Tm difference (\xb0C)"
                    }),
                    o("num_return", "Pairs to return", {
                        topic: "num_return",
                        subject: "Pairs to return"
                    })
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(hd, {
                idPrefix: e.idPrefix,
                ranges: a.product_size_ranges ?? [],
                changed: Array.isArray(e.params?.product_size_ranges),
                issues: d,
                onChange: (p)=>e.onParam("product_size_ranges", p),
                helpOpen: t === "product_size_ranges",
                onHelp: ()=>n("product_size_ranges")
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("details", {
                className: "gpr-details",
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("summary", {
                        className: "gpr-summary",
                        children: "Advanced parameters"
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                        className: "gpr-field-grid",
                        children: md.filter((p)=>!p.transcriptOnly || e.mode === "transcript").map((p)=>o(p.key, p.label, {
                                topic: p.key,
                                subject: p.label
                            }))
                    })
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                className: "gpr-button-row",
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                    type: "button",
                    className: "gpr-btn gpr-btn-small gpr-btn-quiet",
                    disabled: !e.params,
                    onClick: e.onReset,
                    children: "Reset to preset"
                })
            })
        ]
    });
}
const bd = 16, yd = 64;
function _d(e) {
    return e > 0 ? kr(Math.floor(e - st.splitter - st.resultsMin)) : st.formMax;
}
function vd({ controls: e, width: t, onChange: r }) {
    const n = (0, _react.useRef)(null), a = (0, _react.useRef)(null), [i, l] = (0, _react.useState)(!1), o = ()=>n.current?.parentElement ?? null, d = (N)=>{
        const w = o();
        w && (N === void 0 ? (w.style.removeProperty("--gpr-form-width"), w.removeAttribute("data-resized")) : (w.style.setProperty("--gpr-form-width", `${N}px`), w.setAttribute("data-resized", "")));
    };
    Gt(()=>{
        a.current || d(t);
    }, [
        t
    ]);
    const p = ()=>_d(o()?.getBoundingClientRect().width ?? 0), g = (N)=>Math.min(p(), kr(N)), m = ()=>{
        if (t !== void 0) return Math.min(p(), t);
        const N = o()?.firstElementChild?.getBoundingClientRect().width ?? 0;
        return N > 0 ? Math.round(N) : st.formDefault;
    }, f = (N)=>{
        const w = a.current;
        w && (a.current = null, l(!1), o()?.removeAttribute("data-dragging"), N && w.last !== w.startWidth ? r(w.last) : d(t));
    }, u = (N)=>{
        if (N.button !== 0 || a.current) return;
        N.preventDefault();
        const w = m();
        a.current = {
            pointerId: N.pointerId,
            startX: N.clientX,
            startWidth: w,
            last: w
        };
        try {
            N.currentTarget.setPointerCapture(N.pointerId);
        } catch  {}
        l(!0), o()?.setAttribute("data-dragging", "");
    }, h = (N)=>{
        const w = a.current;
        if (!w || N.pointerId !== w.pointerId) return;
        const R = g(w.startWidth + N.clientX - w.startX);
        R !== w.last && (w.last = R, d(R));
    }, y = (N)=>{
        a.current?.pointerId === N.pointerId && f(!0);
    }, _ = (N)=>{
        a.current?.pointerId === N.pointerId && f(!1);
    }, k = (N)=>{
        if (N.key === "Escape" && a.current) {
            N.preventDefault(), f(!1);
            return;
        }
        const w = N.shiftKey ? yd : bd;
        let R;
        if (N.key === "ArrowLeft") R = g(m() - w);
        else if (N.key === "ArrowRight") R = g(m() + w);
        else if (N.key === "Home") R = st.formMin;
        else if (N.key === "End") R = p();
        else return;
        N.preventDefault(), R !== t && r(R);
    }, b = p(), C = Math.min(b, t ?? st.formDefault);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        ref: n,
        className: "gpr-splitter",
        role: "separator",
        "aria-orientation": "vertical",
        "aria-label": "Resize the form and results columns",
        "aria-controls": e,
        "aria-valuemin": st.formMin,
        "aria-valuemax": b,
        "aria-valuenow": C,
        "aria-valuetext": `Form column ${C} pixels wide`,
        tabIndex: 0,
        title: "Drag to resize the columns; double-click to reset",
        "data-state": i ? "dragging" : void 0,
        onPointerDown: u,
        onPointerMove: h,
        onPointerUp: y,
        onPointerCancel: _,
        onKeyDown: k,
        onDoubleClick: ()=>r(void 0)
    });
}
function Qs(e, t, r) {
    const n = e.mode === "transcript" && Ha(t.gene ?? null, e.transcriptId) ? {
        ...e,
        junctionSpanning: !1
    } : e;
    return Di(n, {
        gene: t.gene,
        geneId: t.geneId,
        systemName: t.systemName,
        region: t.region,
        sequence: t.sequence,
        templateOnly: r
    });
}
function Zs(e) {
    if (!e) return "";
    const { template_only: t, ...r } = e;
    return JSON.stringify(r);
}
function ea(e) {
    const t = e.persistSequence !== !1, r = {
        check: e.features?.check !== !1,
        pangenome: e.features?.pangenome !== !1,
        export: e.features?.export !== !1,
        map: e.features?.map !== !1,
        genotyping: e.features?.genotyping !== !1
    };
    La(e.injectStyles !== !1);
    const n = De("gpr"), a = (0, _react.useMemo)(()=>e.client ?? ko({
            apiBase: e.apiBase
        }), [
        e.client,
        e.apiBase
    ]), i = Qc(a, e.gene ?? null, e.geneId ?? null), l = e.gene?._id ?? e.geneId ?? null, o = {
        gene: i,
        geneId: l,
        systemName: e.systemName ?? null,
        region: e.region ?? null,
        sequence: e.sequence ?? null,
        modes: e.modes ?? null,
        defaultMode: e.defaultMode ?? null,
        defaultParams: e.defaultParams ?? null,
        persistSequence: t
    }, d = (0, _react.useRef)(o);
    d.current = o;
    const p = Zi({
        gene: e.gene ?? null,
        geneId: l,
        systemName: e.systemName,
        region: e.region,
        sequence: e.sequence
    }), { state: g, dispatch: m, replace: f, getState: u } = Jc({
        stateProp: e.state,
        onStateChange: e.onStateChange,
        persistSequence: t,
        ctx: o,
        identity: p
    }), { announce: h, regions: y, Provider: _ } = _l(), k = (0, _react.useRef)(e);
    k.current = e;
    const b = Vo(a, {
        onError: (x)=>k.current.onError?.(x),
        onSuccess: (x, j, se, ue)=>w(x, j, se, ue)
    }), C = (0, _react.useRef)({
        templateOnly: !1,
        userInitiated: !0
    }), N = (0, _react.useCallback)((x, j)=>{
        C.current = j, b.run(Qs(x, d.current, j.templateOnly), j);
    }, [
        b.run
    ]), w = (x, j, se, ue)=>{
        if (se.templateOnly) {
            h(`Template ready: ${v(x.template.length)} bp.`), k.current.onDesign?.(x, j);
            return;
        }
        const ot = u(), Qe = x.pairs ?? [], Bt = Qe.length === 0 || (x.warnings ?? []).some((lt)=>lt.code === "NO_PAIRS"), mn = new Map(Qe.map((lt)=>[
                lt.rank,
                lt
            ]));
        let Kt = ot.checkedRanks ?? [], xt = ot.selectedRank;
        if (se.userInitiated && ue) {
            const lt = new Map(ue.pairs.map((We)=>[
                    We.rank,
                    ht(We.left.seq, We.right.seq)
                ])), un = new Map(Qe.map((We)=>[
                    ht(We.left.seq, We.right.seq),
                    We.rank
                ])), Fr = (We)=>{
                const Br = lt.get(We);
                return Br ? un.get(Br) : void 0;
            };
            Kt = Kt.map(Fr).filter((We)=>We !== void 0), xt = xt !== void 0 ? Fr(xt) : void 0;
        }
        Kt = Kt.filter((lt)=>{
            const un = mn.get(lt);
            return !!un && da(un);
        }), xt !== void 0 && !mn.has(xt) && (xt = void 0), m({
            type: "designDone",
            templateOnly: !1,
            noPairs: Bt,
            checkedRanks: Kt,
            selectedRank: xt
        }), h(Bt ? "No primer pairs were found; see \u201CWhy no primer pairs?\u201D." : `Designed ${Qe.length} primer pair${Qe.length === 1 ? "" : "s"}.`), k.current.onDesign?.(x, j);
    }, R = (0, _react.useRef)(null), I = Da(a, {
        poll: e.poll,
        onError: (x)=>k.current.onError?.(x),
        onJobId: (x, j)=>m({
                type: "checkJob",
                jobId: x,
                submitted: j ? wo(j) : void 0
            }),
        onUpdate: (x)=>{
            k.current.onCheckUpdate?.(x), x.status !== R.current && (R.current = x.status, x.status === "queued" ? h("Check queued.") : x.status === "running" ? h("Check running.") : x.status === "done" ? h("Check finished.") : x.status === "error" && h(`Check failed${x.error?.message ? `: ${x.error.message}` : ""}.`, "assertive"));
        }
    });
    (0, _react.useEffect)(()=>{
        I.state.status === "expired" && h("The saved check results have expired.", "assertive");
    }, [
        I.state.status,
        h
    ]);
    const [M, P] = (0, _react.useState)({}), V = (0, _react.useRef)(null), $ = (0, _react.useRef)(e.state);
    (0, _react.useEffect)(()=>{
        const x = V.current;
        V.current = p;
        const j = x !== null && x !== p;
        let se = u();
        if (j && (b.reset(), I.reset(), R.current = null, e.state !== void 0 && e.state !== $.current || (f(ba({
            ...d.current,
            persistSequence: !0
        }), !0), se = null)), se?.designed) {
            const ue = d.current;
            ml(se, {
                gene: ue.gene ?? null,
                geneId: ue.geneId ?? null,
                systemName: ue.systemName,
                sequence: ue.sequence
            }).length === 0 && N(se, {
                templateOnly: !1,
                userInitiated: !1
            });
        }
        return se?.check?.jobId && I.restore(se.check.jobId), ()=>{
            b.abort(), I.stop();
        };
    }, [
        p
    ]), (0, _react.useEffect)(()=>{
        $.current = e.state;
    });
    const L = b.state.response, z = L?.template ?? null, K = e.systemName ?? i?.system_name ?? z?.system_name ?? null, S = Xc(a, K), T = S.data?.genomes ?? null, W = (0, _react.useMemo)(()=>ia(g.sequence ?? ""), [
        g.sequence
    ]), H = Va(g, {
        gene: i,
        geneId: l,
        systemName: e.systemName ?? null,
        sequence: e.sequence ?? null
    }, W), { templateLength: O, preset: U, effective: B, paramIssues: ne, tooLong: de } = H, Ve = (0, _react.useCallback)((x)=>P((j)=>Yt(j.region ?? [], x) ? j : {
                ...j,
                region: x
            }), []), xe = (0, _react.useCallback)((x)=>P((j)=>Yt(j.intervals ?? [], x) ? j : {
                ...j,
                intervals: x
            }), []), Se = [
        ...(g.mode === "region" ? M.region ?? [] : []).map((x)=>x.message),
        ...(M.intervals ?? []).map((x)=>x.message)
    ], Te = [
        .../* @__PURE__ */ new Set([
            ...H.modeIssues,
            ...Se,
            ...ne.map((x)=>x.message)
        ])
    ], Fe = [
        .../* @__PURE__ */ new Set([
            ...H.modeIssues,
            ...Se,
            ...ne.filter((x)=>!gl.has(x.code)).map((x)=>x.message)
        ])
    ], oe = b.state.status === "running", Oe = b.state.status === "error" ? b.state.error : null, Ce = Xo(Oe), re = !oe && !Ce && Te.length === 0, fe = !oe && !Ce && Fe.length === 0, Je = (0, _react.useMemo)(()=>{
        try {
            return Zs(Qs(g, o, !1));
        } catch  {
            return "";
        }
    }, [
        g,
        i,
        p
    ]), Xe = !!b.state.responseRequest && Zs(b.state.responseRequest) !== Je, Be = (x)=>{
        x.preventDefault(), re && N(u(), {
            templateOnly: !1,
            userInitiated: !0
        });
    }, Ne = L?.pairs ?? [], [ze, Le] = (0, _react.useState)([]), je = In(ze), et = (0, _react.useMemo)(()=>z?.seq ? Sr(z.seq, {
            start: 1,
            end: z.seq.length
        }, {
            enzymes: e.enzymes
        }) : [], [
        z?.seq,
        e.enzymes
    ]), qe = (0, _react.useMemo)(()=>et.map((x)=>({
                enzyme: x.enzyme,
                sites: x.sites
            })), [
        et
    ]), we = !!b.state.responseMeta?.templateOnly, E = !!L && !we && (Ne.length === 0 || (L.warnings ?? []).some((x)=>x.code === "NO_PAIRS")), G = I.state.job, q = G?.results ?? null, Y = G?.request ?? I.state.request ?? null, Q = g.check?.submitted ?? null, Z = z?.mode ?? Ze(g.mode), ke = Z === "sequence" ? g.systemName ?? z?.system_name ?? null : z?.system_name ?? i?.system_name ?? g.systemName ?? null, Tt = z?.gene_id ?? l, yt = z?.transcript_id ?? null, _t = r.pangenome && (S.data?.counts?.total ?? 0) > 1, Dt = G ? {
        request: G.request ?? (Q && ke ? {
            system_name: ke,
            pairs: Q
        } : void 0),
        results: G.results,
        status: G.status
    } : null, dn = !!G && (Ho(G) || Y?.mode === "transcript" && !!Y.checks?.includes("pangenome")), tt = [
        {
            id: "pairs",
            label: `Pairs (${Ne.length})`
        }
    ];
    G && (tt.push({
        id: "specificity",
        label: "Specificity"
    }), (q?.transcriptome || Y?.mode === "transcript") && tt.push({
        id: "transcriptome",
        label: "Transcriptome"
    }), (q?.pangenome || G.kind === "pangenome" || Y?.checks?.includes("pangenome")) && tt.push({
        id: "pangenome",
        label: dn ? "Pan-genome (annotated transcripts)" : "Pan-genome"
    }));
    const jt = g.view?.resultsTab ?? "pairs", nt = tt.some((x)=>x.id === jt) ? jt : "pairs", $n = Y?.genomes ?? (Y?.checks?.includes("pangenome") && S.data ? an(S.data, Y.mode ?? Z, Y.system_name) : null), Rn = ()=>{
        if (I.state.request) return I.state.request;
        const x = u(), j = Ne.filter((Qe)=>(x.checkedRanks ?? []).includes(Qe.rank)), se = _t && !!x.check?.checks?.includes("pangenome");
        if (j.length) try {
            return ma({
                mode: Z,
                systemName: ke,
                geneId: Tt,
                transcriptId: yt,
                pairs: j,
                checks: se ? [
                    "specificity",
                    "pangenome"
                ] : [
                    "specificity"
                ],
                genomes: se ? x.check?.genomes ?? null : null,
                allGenomes: S.data,
                params: x.check?.params
            });
        } catch  {}
        const ue = x.check?.submitted;
        if (!ue?.length || !ke) return null;
        const ot = {
            system_name: ke,
            mode: Z,
            checks: se ? [
                "specificity",
                "pangenome"
            ] : [
                "specificity"
            ],
            pairs: ue
        };
        if (Tt && (Z === "gene" || Z === "transcript") && (ot.gene_id = Tt), Z === "transcript" && yt && (ot.transcript_id = yt), se && x.check?.genomes) {
            const Qe = xr(S.data, Z, ke), Bt = Qe ? x.check.genomes.filter((mn)=>Qe.includes(mn)) : x.check.genomes;
            if (!Bt.length) return null;
            ot.genomes = Bt;
        }
        return ot;
    }, pn = (x)=>{
        R.current = null, I.submit(x);
    }, Et = e.geneLabel ?? i?.name ?? l ?? z?.gene_id ?? z?.system_name ?? "primers", Ke = String(Et).replace(/[^A-Za-z0-9_.-]+/g, "_") || "primers", Mn = Ne.length ? [
        {
            id: "pairs-tsv",
            label: "Primer pairs (TSV)",
            filename: `${Ke}_primer_pairs.tsv`,
            mime: "text/tab-separated-values;charset=utf-8",
            build: ()=>Ro(Ne, {
                    check: Dt
                })
        },
        {
            id: "primers-fasta",
            label: "Primers (FASTA)",
            filename: `${Ke}_primers.fasta`,
            build: ()=>Mo(Ne, {
                    label: Et
                })
        },
        {
            id: "amplicons-fasta",
            label: "Amplicons (FASTA)",
            filename: `${Ke}_amplicons.fasta`,
            build: ()=>Sa(Ne, z, {
                    label: Et
                })
        },
        ...q?.specificity || q?.transcriptome ? [
            {
                id: "offtargets-tsv",
                label: "Off-target products (TSV)",
                filename: `${Ke}_off_targets.tsv`,
                mime: "text/tab-separated-values;charset=utf-8",
                build: ()=>Oo(q)
            }
        ] : [],
        ...q?.pangenome ? [
            {
                id: "pangenome-tsv",
                label: "Pan-genome coverage (TSV)",
                filename: `${Ke}_pangenome.tsv`,
                mime: "text/tab-separated-values;charset=utf-8",
                build: ()=>Uo(q)
            }
        ] : []
    ] : [], It = g.mode === "region" ? g.systemName ?? null : g.mode === "sequence" ? null : i?.system_name ?? e.systemName ?? null, Pn = T?.find((x)=>x.system_name === It) ?? null, Ut = de ? {
        gene: "the gene is longer than 50,000 bp \u2014 use Transcript or Region."
    } : {}, On = Nr(o).filter((x)=>x !== "genotyping" || r.genotyping), $t = `${n}-inputs`, gn = `${n}-issues`, vt = z && z.mode === g.mode ? {
        target: g.target,
        included: g.included,
        excluded: g.excluded
    } : {}, Ft = i?.location ? (()=>{
        const j = Math.max(1, i.location.start - 2e3);
        return {
            region: i.location.region,
            start: j,
            end: Math.min(i.location.end + 2e3, j + ye.maxWindow - 1)
        };
    })() : void 0;
    let A = null;
    nt === "pairs" ? A = /* @__PURE__ */ (0, _jsxRuntime.jsx)(dd, {
        pairs: Ne,
        template: z,
        checkedRanks: g.checkedRanks ?? [],
        onCheckedChange: r.check ? (x)=>m({
                type: "setCheckedRanks",
                ranks: x
            }) : void 0,
        selectedRank: g.selectedRank ?? null,
        onSelect: (x)=>m({
                type: "select",
                rank: g.selectedRank === x ? void 0 : x
            }),
        check: Dt,
        submitted: Q,
        label: Et,
        enzymes: e.enzymes,
        selectedEnzymes: ze,
        onSelectEnzymes: Le,
        enzymeColours: je
    }) : nt === "specificity" || nt === "transcriptome" ? A = /* @__PURE__ */ (0, _jsxRuntime.jsx)(oi, {
        results: q,
        block: nt === "specificity" ? "genome" : "transcriptome",
        pairs: Ne,
        job: G ? {
            request: Y ?? void 0,
            status: G.status,
            partial: G.partial
        } : null,
        submitted: Q,
        systemName: ke,
        geneHref: e.geneHref,
        onGeneClick: e.onGeneClick
    }) : nt === "pangenome" && (A = /* @__PURE__ */ (0, _jsxRuntime.jsx)(si, {
        results: q?.pangenome,
        requestedGenomes: $n,
        genomes: T,
        transcriptModelsOnly: dn,
        params: q?.params ?? null,
        geneHref: e.geneHref,
        onGeneClick: e.onGeneClick
    }));
    let J = null;
    return b.state.busy ? J = /* @__PURE__ */ (0, _jsxRuntime.jsx)(rn, {
        error: null,
        busy: b.state.busy,
        context: "design",
        onCancel: b.cancel
    }) : Oe && (J = /* @__PURE__ */ (0, _jsxRuntime.jsx)(rn, {
        error: Oe,
        context: "design",
        onRetry: b.state.request ? ()=>{
            b.run(b.state.request, C.current);
        } : void 0,
        onDismiss: Ce ? void 0 : b.clearError
    })), /* @__PURE__ */ (0, _jsxRuntime.jsx)(_, {
        value: h,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(tl, {
            children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                className: Pe("gpr-root", qa(e.theme), e.className),
                style: e.style,
                "data-mode": g.mode,
                children: [
                    y,
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                        className: "gpr-designer",
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                                className: "gpr-header",
                                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(rd, {
                                    modes: On,
                                    value: g.mode,
                                    onChange: (x)=>m({
                                            type: "setMode",
                                            mode: x
                                        }),
                                    disabled: Ut,
                                    idPrefix: n,
                                    panelId: $t
                                })
                            }),
                            g.mode === "genotyping" ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                                className: "gpr-layout gpr-layout-genotyping",
                                role: "tabpanel",
                                id: $t,
                                "aria-labelledby": Jt(`${n}-mode`, g.mode),
                                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Vc, {
                                    client: a,
                                    state: g,
                                    dispatch: m,
                                    systemName: K,
                                    genomes: S.data,
                                    defaultWindow: Ft,
                                    geneId: l,
                                    genesInRegion: e.genesInRegion,
                                    sequenceForRegion: e.sequenceForRegion,
                                    alleleFrequencies: e.alleleFrequencies,
                                    enzymes: e.enzymes,
                                    pangenomeFeature: r.pangenome,
                                    exportFeature: r.export,
                                    disabled: Ce,
                                    idPrefix: n
                                })
                            }) : /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                                className: "gpr-layout",
                                children: [
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                                        className: "gpr-inputs",
                                        role: "tabpanel",
                                        id: $t,
                                        "aria-labelledby": Jt(`${n}-mode`, g.mode),
                                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("form", {
                                            className: "gpr-form",
                                            onSubmit: Be,
                                            noValidate: !0,
                                            children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)("fieldset", {
                                                className: "gpr-form-fieldset",
                                                disabled: Ce,
                                                children: [
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("legend", {
                                                        className: "gpr-visually-hidden",
                                                        children: "Design inputs"
                                                    }),
                                                    g.mode === "gene" ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(Zc, {
                                                        idPrefix: n,
                                                        gene: i,
                                                        geneId: l,
                                                        geneLabel: e.geneLabel,
                                                        transcriptId: g.transcriptId,
                                                        flankUp: g.flankUp ?? 0,
                                                        flankDown: g.flankDown ?? 0,
                                                        onTranscript: (x)=>m({
                                                                type: "setTranscript",
                                                                transcriptId: x
                                                            }),
                                                        onFlanks: (x)=>m({
                                                                type: "setFlanks",
                                                                ...x
                                                            })
                                                    }) : null,
                                                    g.mode === "transcript" ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(pl, {
                                                        idPrefix: n,
                                                        gene: i,
                                                        transcriptId: g.transcriptId,
                                                        junctionSpanning: g.junctionSpanning !== !1,
                                                        included: g.included,
                                                        overlaps: {
                                                            min5: B.min_5_prime_overlap_of_junction ?? 7,
                                                            min3: B.min_3_prime_overlap_of_junction ?? 4
                                                        },
                                                        onTranscript: (x)=>m({
                                                                type: "setTranscript",
                                                                transcriptId: x
                                                            }),
                                                        onJunctionSpanning: (x)=>m({
                                                                type: "setJunctionSpanning",
                                                                value: x
                                                            }),
                                                        onIncluded: (x)=>m({
                                                                type: "setIncluded",
                                                                included: x
                                                            })
                                                    }) : null,
                                                    g.mode === "region" ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(ed, {
                                                        idPrefix: n,
                                                        region: g.region,
                                                        systemName: g.systemName,
                                                        genomes: T,
                                                        gene: i,
                                                        onRegion: (x)=>m({
                                                                type: "setRegion",
                                                                region: x
                                                            }),
                                                        onSystemName: (x)=>m({
                                                                type: "setSystemName",
                                                                systemName: x
                                                            }),
                                                        onIssues: Ve
                                                    }) : null,
                                                    g.mode === "sequence" ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(td, {
                                                        idPrefix: n,
                                                        sequence: g.sequence ?? "",
                                                        cleaned: W,
                                                        systemName: g.systemName,
                                                        genomes: T,
                                                        onSequence: (x)=>m({
                                                                type: "setSequence",
                                                                sequence: x
                                                            }),
                                                        onSystemName: (x)=>m({
                                                                type: "setSystemName",
                                                                systemName: x
                                                            })
                                                    }) : null,
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(ri, {
                                                        idPrefix: n,
                                                        mode: Ze(g.mode),
                                                        avoidRepeats: !!g.avoidRepeats,
                                                        repeatMaskMode: g.repeatMaskMode ?? "n_mask",
                                                        onChange: (x)=>m({
                                                                type: "setRepeats",
                                                                ...x
                                                            }),
                                                        genome: Pn,
                                                        template: z,
                                                        hasLowercase: g.mode === "sequence" && W.hasLowercase
                                                    }),
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(nd, {
                                                        idPrefix: n,
                                                        target: g.target,
                                                        included: g.included,
                                                        excluded: g.excluded,
                                                        templateLength: O,
                                                        onIssues: xe,
                                                        onChange: (x)=>m({
                                                                type: "setIntervals",
                                                                target: x.target,
                                                                included: x.included,
                                                                excluded: x.excluded
                                                            })
                                                    }),
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(fd, {
                                                        idPrefix: n,
                                                        mode: Ze(g.mode),
                                                        preset: U,
                                                        params: g.params,
                                                        onPreset: (x)=>m({
                                                                type: "setPreset",
                                                                preset: x
                                                            }),
                                                        onParam: (x, j)=>m({
                                                                type: "setParam",
                                                                key: x,
                                                                value: j
                                                            }),
                                                        onReset: ()=>m({
                                                                type: "resetParams"
                                                            }),
                                                        settings: L?.settings ?? null,
                                                        lastRequest: b.state.responseRequest,
                                                        issues: ne
                                                    }),
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "gpr-actions",
                                                        children: [
                                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                                                type: oe ? "button" : "submit",
                                                                className: "gpr-btn gpr-btn-primary",
                                                                disabled: !oe && !re,
                                                                "aria-describedby": !oe && Te.length ? gn : void 0,
                                                                onClick: oe ? ()=>b.cancel() : void 0,
                                                                children: oe ? "Cancel" : "Design primers"
                                                            }),
                                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                                                                type: "button",
                                                                className: "gpr-btn",
                                                                disabled: oe || !fe,
                                                                onClick: ()=>N(u(), {
                                                                        templateOnly: !0,
                                                                        userInitiated: !0
                                                                    }),
                                                                children: "Preview template"
                                                            })
                                                        ]
                                                    }),
                                                    Te.length ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("ul", {
                                                        id: gn,
                                                        className: "gpr-issues",
                                                        children: Te.slice(0, 6).map((x)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("li", {
                                                                children: x
                                                            }, x))
                                                    }) : null
                                                ]
                                            })
                                        })
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(vd, {
                                        controls: $t,
                                        width: g.view?.formWidth,
                                        onChange: (x)=>m({
                                                type: "setFormWidth",
                                                width: x
                                            })
                                    }),
                                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)("section", {
                                        className: "gpr-results",
                                        "aria-labelledby": `${n}-results-h`,
                                        "aria-busy": oe ? !0 : void 0,
                                        children: [
                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("h3", {
                                                className: "gpr-visually-hidden",
                                                id: `${n}-results-h`,
                                                children: "Results"
                                            }),
                                            L ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(cn, {
                                                warnings: L.warnings
                                            }) : null,
                                            J,
                                            !L && !oe && !Oe ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                                                className: "gpr-empty",
                                                children: [
                                                    "Choose the inputs and press ",
                                                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("strong", {
                                                        children: "Design primers"
                                                    }),
                                                    "."
                                                ]
                                            }) : null,
                                            oe ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                                                className: "gpr-status-line",
                                                children: b.state.request?.template_only ? "Building the template\u2026" : "Designing primers\u2026"
                                            }) : null,
                                            L && z ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                children: [
                                                    Xe && !oe ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                                                        className: "gpr-note",
                                                        role: "note",
                                                        children: "The inputs have changed since these results were designed."
                                                    }) : null,
                                                    r.map ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(Mc, {
                                                        template: z,
                                                        pairs: Ne,
                                                        selectedRank: g.selectedRank ?? null,
                                                        onSelect: (x)=>m({
                                                                type: "select",
                                                                rank: g.selectedRank === x ? void 0 : x
                                                            }),
                                                        target: vt.target,
                                                        included: vt.included,
                                                        excluded: vt.excluded,
                                                        enzymeSites: qe,
                                                        selectedEnzymes: ze,
                                                        onSelectEnzymes: Le,
                                                        enzymeColours: je
                                                    }) : null,
                                                    we ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("p", {
                                                        className: "gpr-readout",
                                                        children: [
                                                            "Template preview: ",
                                                            v(z.length),
                                                            " bp",
                                                            z.mask_source ? `, ${Ma(z.masked_fraction ?? 0)} masked (${pr[z.mask_source]})` : "",
                                                            ". Press Design primers to pick primers."
                                                        ]
                                                    }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)(Ya, {
                                                        explain: L.explain,
                                                        open: !!g.view?.explainOpen,
                                                        onToggle: (x)=>m({
                                                                type: "setExplainOpen",
                                                                open: x
                                                            }),
                                                        noPairs: E,
                                                        idPrefix: n
                                                    }),
                                                    Ne.length ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "gpr-result-tabs",
                                                        children: [
                                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)(Pr, {
                                                                items: tt,
                                                                value: nt,
                                                                onChange: (x)=>m({
                                                                        type: "setTab",
                                                                        tab: x
                                                                    }),
                                                                label: "Results",
                                                                idPrefix: `${n}-results`,
                                                                panelId: `${n}-results-panel`
                                                            }),
                                                            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                                                                className: "gpr-tabpanel",
                                                                role: "tabpanel",
                                                                id: `${n}-results-panel`,
                                                                "aria-labelledby": Jt(`${n}-results`, nt),
                                                                children: A
                                                            })
                                                        ]
                                                    }) : null,
                                                    we ? null : /* @__PURE__ */ (0, _jsxRuntime.jsx)(cl, {
                                                        version: L.engine?.primer3
                                                    })
                                                ]
                                            }) : null,
                                            r.check && (Ne.length > 0 || I.state.status !== "idle") ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(il, {
                                                idPrefix: n,
                                                mode: Z,
                                                systemName: ke,
                                                geneId: Tt,
                                                transcriptId: yt,
                                                pairs: Ne,
                                                checkedRanks: g.checkedRanks ?? [],
                                                checkState: g.check ?? {
                                                    checks: [
                                                        "specificity"
                                                    ]
                                                },
                                                genomes: S.data,
                                                pangenomeFeature: r.pangenome,
                                                run: I.state,
                                                disabled: I.state.status === "error" && Me(I.state.error) && I.state.error.code === "FEATURE_DISABLED",
                                                onPangenome: (x)=>m({
                                                        type: "setPangenome",
                                                        enabled: x
                                                    }),
                                                onGenomes: (x)=>m({
                                                        type: "setGenomes",
                                                        genomes: x
                                                    }),
                                                onParam: (x, j)=>m({
                                                        type: "setCheckParam",
                                                        key: x,
                                                        value: j
                                                    }),
                                                onSubmit: pn,
                                                onDetach: I.detach,
                                                onResume: ()=>{
                                                    const x = G?.job_id ?? g.check?.jobId;
                                                    x && I.restore(x, I.state.request, I.state.startedHere);
                                                },
                                                onRerun: ()=>{
                                                    const x = Rn();
                                                    x && pn(x);
                                                }
                                            }) : null,
                                            r.export && Ne.length ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(Za, {
                                                items: Mn,
                                                idPrefix: n
                                            }) : null
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
function Kd(e, t) {
    const r = typeof e == "string" ? typeof document < "u" ? document.querySelector(e) : null : e;
    if (!r) throw new Error(`gramene-primers mount: no element matches ${typeof e == "string" ? e : "the given target"}`);
    let n = {
        ...t
    }, a = (0, _client.createRoot)(r);
    return a.render(/* @__PURE__ */ (0, _jsxRuntime.jsx)(ea, {
        ...n
    })), {
        update (i) {
            a && (n = {
                ...n,
                ...i
            }, a.render(/* @__PURE__ */ (0, _jsxRuntime.jsx)(ea, {
                ...n
            })));
        },
        unmount () {
            a?.unmount(), a = null;
        }
    };
}
const Hd = "0.11.0";

},{"react/jsx-runtime":"gonF6","react-dom/client":"5eZdG","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ffqsH":[function(require,module,exports,__globalThis) {
var $1Kll1$reactjsxruntime = require("2fc1562fa4d105dc");
var $1Kll1$react = require("e139595a0b7f3104");
var $1Kll1$reactdom = require("a00d6202c65e27eb");
var $1Kll1$lodash = require("32e8129e9bc02852");
var $1Kll1$d3hierarchy = require("afbce5c17db0ba5d");
var $1Kll1$d3scale = require("886b5c4db9a0d347");
var $1Kll1$numeral = require("db936f098744703e");
var $1Kll1$platform = require("294dd37eb3c39938");
var $1Kll1$d3 = require("9eb6b5ba97248c8c");
var $1Kll1$d3scalechromatic = require("7164af7e69208eb7");
var $parcel$global = globalThis;
function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", ()=>$08ed429e2991b5a8$export$2e2bcd8739ae039);
const $856009e104b5527d$var$UNSIZED_LAYOUT = $1Kll1$d3hierarchy.cluster().separation(()=>1);
function $856009e104b5527d$export$2e2bcd8739ae039(width, height, taxonomy, currentDisplayInfo, rootNodeId, selectedTaxa) {
    const rootNode = taxonomy.indices.id[rootNodeId];
    return updateNodeCoordinates();
    // update x and y coordinates for currently visible nodes
    function updateNodeCoordinates() {
        // clear out any existing position information in readiness of calculating
        // it again.
        const incompleteNodeDisplayInfo = $parcel$interopDefault($1Kll1$lodash).mapValues(currentDisplayInfo, (val)=>$parcel$interopDefault($1Kll1$lodash).omit(val, [
                "x",
                "y",
                "offsetX",
                "offsetY",
                "lineThickness"
            ]));
        const layout = $856009e104b5527d$var$UNSIZED_LAYOUT.size([
            height,
            width
        ]);
        const myNodes = d3data(incompleteNodeDisplayInfo);
        const myRoot = $1Kll1$d3hierarchy.hierarchy(myNodes);
        const nodes = layout(myRoot).descendants();
        const strokeScale = getStrokeScale();
        for(let i = 0; i < nodes.length; i++){
            const node = nodes[i];
            const displayInfo = incompleteNodeDisplayInfo[node.data.id];
            displayInfo.x = node.x;
            displayInfo.y = node.y;
            displayInfo.lineThickness = strokeScale(node.data.proportion);
        }
        return updateRelativeNodeCoordinates(incompleteNodeDisplayInfo);
    }
    function getStrokeScale() {
        const maxScore = taxonomy.globalResultSetStats().maxProportion;
        const maxRange = maxScore >= 1 ? 2 : 5;
        return $1Kll1$d3scale.scaleLinear().domain([
            0,
            maxScore
        ]).range([
            .5,
            maxRange
        ]);
    }
    // get data structure of currently visible nodes
    function d3data(nodeDisplayInfo) {
        const isNodeExpanded = (node)=>$parcel$interopDefault($1Kll1$lodash).get(nodeDisplayInfo[node.model.id], "expanded", false);
        const d3dataRecursive = (node)=>{
            const id = node.model.id;
            const proportion = node.model.results.proportion;
            const datum = {
                id: id,
                proportion: proportion
            };
            if (node.hasChildren()) datum.children = $parcel$interopDefault($1Kll1$lodash)(node.children).filter(isNodeExpanded).map(d3dataRecursive).value();
            return datum;
        };
        return d3dataRecursive(rootNode);
    }
    function updateRelativeNodeCoordinates(incompleteNodeDisplayInfo) {
        const updateRecursive = (node, parentX = 0, parentY = 0, result = {}, depth = 0)=>{
            const nodeId = $parcel$interopDefault($1Kll1$lodash).get(node, "model.id");
            if (!nodeId) throw new Error(`No nodeId for ${node}`);
            const displayInfo = result[nodeId] = $parcel$interopDefault($1Kll1$lodash).cloneDeep(incompleteNodeDisplayInfo[nodeId]);
            if (!displayInfo) throw new Error(`No displayInfo for ${node.model.id}`);
            if (!$parcel$interopDefault($1Kll1$lodash).isNumber(displayInfo.x)) ;
            else {
                displayInfo.offsetX = displayInfo.x - parentX;
                displayInfo.offsetY = displayInfo.y - parentY;
            }
            if (displayInfo.expanded && node.hasChildren()) node.children.map((child)=>updateRecursive(child, displayInfo.x, displayInfo.y, result, depth + 1));
            return result;
        };
        return $parcel$interopDefault($1Kll1$lodash).assign(incompleteNodeDisplayInfo, updateRecursive(taxonomy));
    }
}
function $3ba3fb37090da528$export$f27c46a4165fa319(taxonomy, displayInfo) {
    return $3ba3fb37090da528$export$5d5aa51867371914(taxonomy, displayInfo).length;
}
function $3ba3fb37090da528$export$5d5aa51867371914(taxonomy, displayInfo) {
    if (displayInfo) return $3ba3fb37090da528$var$walkTreeForVisibleLeaves(taxonomy, displayInfo);
    else return taxonomy.leafNodes();
}
function $3ba3fb37090da528$var$walkTreeForVisibleLeaves(taxonomy, displayInfo) {
    const leaves = [];
    taxonomy.filterWalk((n)=>{
        const di = displayInfo[n.model.id];
        if (!di) throw new Error(`No display info for node ${n.model.id}`);
        if (di.expanded) {
            // if a node has no children, it's a leaf node (with a reference genome)
            if (!n.hasChildren()) {
                if (!n.model.genome) throw new Error(`Node ${_.get(n, "model.id")} has no genome`);
                leaves.push(n);
            }
            return true;
        }
    });
    return leaves;
}
const $124e2536d5ac167e$var$SMALL_SCREEN_WIDTH_PX = 480;
const $124e2536d5ac167e$var$TEXT_WIDTH_PX = 275;
const $124e2536d5ac167e$var$GENOME_PADDING_DEFAULT_PX = 2;
const $124e2536d5ac167e$var$GENOME_PADDING_SMALL_PX = 1.5;
const $124e2536d5ac167e$var$CIRCLE_RADIUS_DEFAULT_PX = 2.5;
const $124e2536d5ac167e$var$CIRCLE_RADIUS_SMALL_PX = 1.5;
const $124e2536d5ac167e$var$STROKE_WIDTH_DEFAULT_PX = 1; // px, defined in taxonomy.less;
const $124e2536d5ac167e$var$STROKE_WIDTH_SMALL_PX = $124e2536d5ac167e$var$STROKE_WIDTH_DEFAULT_PX;
const $124e2536d5ac167e$var$SPECIES_TREE_PROPORTION = 0.18;
const $124e2536d5ac167e$var$LEAF_NODE_HEIGHT_DEFAULT_PX = 12;
const $124e2536d5ac167e$var$LEAF_NODE_HEIGHT_SMALL_PX = 6.5;
const $124e2536d5ac167e$var$MARGIN_PX = 6;
function $124e2536d5ac167e$export$2e2bcd8739ae039(width) {
    const visWidth = width - $124e2536d5ac167e$var$MARGIN_PX;
    const showSpeciesNames = visWidth > $124e2536d5ac167e$var$SMALL_SCREEN_WIDTH_PX;
    let genomePadding;
    let leafNodeHeight;
    let circleRadius;
    let strokeWidth;
    let textWidth;
    if (showSpeciesNames) {
        genomePadding = $124e2536d5ac167e$var$GENOME_PADDING_DEFAULT_PX;
        leafNodeHeight = $124e2536d5ac167e$var$LEAF_NODE_HEIGHT_DEFAULT_PX;
        circleRadius = $124e2536d5ac167e$var$CIRCLE_RADIUS_DEFAULT_PX;
        strokeWidth = $124e2536d5ac167e$var$STROKE_WIDTH_DEFAULT_PX;
        textWidth = $124e2536d5ac167e$var$TEXT_WIDTH_PX + genomePadding;
    } else {
        genomePadding = $124e2536d5ac167e$var$GENOME_PADDING_SMALL_PX;
        leafNodeHeight = $124e2536d5ac167e$var$LEAF_NODE_HEIGHT_SMALL_PX;
        circleRadius = $124e2536d5ac167e$var$CIRCLE_RADIUS_SMALL_PX;
        strokeWidth = $124e2536d5ac167e$var$STROKE_WIDTH_SMALL_PX;
        textWidth = genomePadding;
    }
    const textProportion = textWidth / visWidth;
    const genomesProportion = 1 - $124e2536d5ac167e$var$SPECIES_TREE_PROPORTION - textProportion;
    const speciesTreeWidth = visWidth * $124e2536d5ac167e$var$SPECIES_TREE_PROPORTION;
    const genomesWidth = visWidth * genomesProportion;
    const genomesStart = visWidth - genomesWidth;
    return {
        layout: {
            genomesXStart: genomesStart,
            genomePadding: genomePadding,
            showSpeciesNames: showSpeciesNames,
            circleRadius: circleRadius,
            strokeWidth: strokeWidth,
            margin: $124e2536d5ac167e$var$MARGIN_PX
        },
        proportion: {
            text: textProportion,
            speciesTree: $124e2536d5ac167e$var$SPECIES_TREE_PROPORTION,
            genomes: genomesProportion
        },
        width: {
            vis: visWidth,
            genomes: genomesWidth,
            speciesTree: speciesTreeWidth,
            text: textWidth
        },
        height: {
            leafNode: leafNodeHeight
        }
    };
}
var $5e67d87d35f6489c$exports = {};
$5e67d87d35f6489c$exports = $1Kll1$platform.name === "IE" || $1Kll1$platform.name === "Microsoft Edge";
class $57385b6d93b04052$export$2e2bcd8739ae039 extends $parcel$interopDefault($1Kll1$react).Component {
    render() {
        return /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsxs)("g", {
            className: this.className(),
            children: [
                /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)("rect", {
                    x: "0",
                    y: "0",
                    width: "1",
                    height: "1",
                    ...this.rect1Props()
                }),
                /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)("rect", {
                    x: "0",
                    y: "0",
                    width: "1",
                    height: "1",
                    ...this.rect2Props()
                })
            ]
        });
    }
    className() {
        let className = "edge";
        if (this.props.displayInfo.highlight) {
            console.log("HIGHLIGHT", this.props.node);
            className += " highlight";
        }
        return className;
    }
    rect1Props() {
        return this.rectProps((di, size, px)=>{
            const scaleX = -di.offsetY - size / 2;
            return `translate(0${px}, ${-size / 2}${px}) scale(${scaleX}, ${size})`;
        });
    }
    circleWidth() {
        return this.props.nodeRadius + this.props.strokeWidth / 2;
    }
    rect2Props() {
        const circleWidth = this.circleWidth();
        return this.rectProps((di, size, px)=>{
            // we need to take into account the size of the parent node.
            const scaleY = di.offsetX > 0 ? circleWidth - di.offsetX : -circleWidth - di.offsetX;
            return `translate(${-di.offsetY - size / 2}${px}, 0${px}) scale(${size}, ${scaleY})`;
        });
    }
    rectProps(getXform) {
        const di = this.props.displayInfo;
        const px = /*@__PURE__*/ $parcel$interopDefault($5e67d87d35f6489c$exports) ? "" : "px";
        const size = di.lineThickness;
        const transform = getXform(di, size, px);
        return /*@__PURE__*/ $parcel$interopDefault($5e67d87d35f6489c$exports) ? {
            transform: transform
        } : {
            style: {
                transform: transform
            }
        };
    }
}
"use strict";
const $b28e2542aa883c86$var$Node = ({ node: node, displayInfo: displayInfo, onSelect: onSelect, radius: radius })=>/*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)("g", {
        className: $b28e2542aa883c86$var$className(displayInfo),
        onClick: onSelect,
        children: /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)("circle", {
            className: "circle",
            r: radius
        })
    });
function $b28e2542aa883c86$var$className(displayInfo) {
    let className = "node";
    if (displayInfo.highlight) className += " highlight";
    return className;
}
var $b28e2542aa883c86$export$2e2bcd8739ae039 = $b28e2542aa883c86$var$Node;
function $923e1d9e74d6570a$export$2e2bcd8739ae039(x, y) {
    const props = {};
    const isStyle = !/*@__PURE__*/ $parcel$interopDefault($5e67d87d35f6489c$exports);
    const px = isStyle ? "px" : "";
    if (/*@__PURE__*/ $parcel$interopDefault($5e67d87d35f6489c$exports)) props.transform = `translate(${x}${px}, ${y}${px})`;
    else props.style = {
        transform: `translate(${x}${px}, ${y}${px})`
    };
    return props;
}
class $412f91be2b3621a9$export$2e2bcd8739ae039 extends $parcel$interopDefault($1Kll1$react).Component {
    constructor(props){
        super(props);
        this.state = {
            className: "clade"
        };
    }
    addHighlightClass() {
        this.setClassNameState("clade highlight");
    }
    removeHighlightClass() {
        this.setClassNameState("clade");
    }
    notifyOfHover(e) {
        e.stopPropagation();
        this.props.onHighlight({
            name: `${this.props.node.model.name} has ${this.props.node.model.results.count} results`,
            taxon: this.props.node.model
        });
    }
    handleCladeSelection(e) {
        e.stopPropagation();
        this.props.onSelection({
            name: this.props.node.model.name,
            taxon: this.props.node.model
        });
    }
    setClassNameState(className) {
        if (this.state.className !== className) this.setState({
            className: className
        });
    }
    render() {
        return /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsxs)("g", {
            className: this.state.className,
            ...this.gProps(),
            // use mouse enter/leave to set class for coloring path
            onMouseEnter: this.addHighlightClass.bind(this),
            onMouseLeave: this.removeHighlightClass.bind(this),
            // mouse over (with propagation stopped) for notifying others
            // of mouse over.
            onMouseOver: this.notifyOfHover.bind(this),
            onSelect: this.handleCladeSelection.bind(this),
            children: [
                this.renderEdge(),
                this.renderNode(),
                this.renderBackground(),
                this.renderText(),
                this.renderSubclades()
            ]
        });
    }
    renderEdge() {
        if (!this.props.isRoot) return /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)($57385b6d93b04052$export$2e2bcd8739ae039, {
            node: this.props.node,
            displayInfo: this.displayInfo(),
            nodeRadius: this.props.svgMetrics.layout.circleRadius,
            strokeWidth: this.props.svgMetrics.layout.strokeWidth
        });
    }
    renderNode() {
        return /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)($b28e2542aa883c86$export$2e2bcd8739ae039, {
            node: this.props.node,
            displayInfo: this.displayInfo(),
            radius: this.props.svgMetrics.layout.circleRadius
        });
    }
    renderText() {
        if (!this.props.node.hasChildren()) return /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsxs)("g", {
            className: "node-label",
            children: [
                this.renderSpeciesName(),
                this.renderResultsCount()
            ]
        });
    }
    renderSpeciesName() {
        if (this.props.svgMetrics.layout.showSpeciesNames) return /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)("text", {
            x: "10",
            y: "4.75",
            className: "species-name",
            children: this.speciesName()
        });
    }
    renderBackground() {
        if (this.props.node.model.genome) {
            const { width: width, height: height } = this.props.svgMetrics;
            const y = 1 - height.leafNode / 2;
            return /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)("rect", {
                className: "species-background",
                x: "10",
                y: y,
                width: width.text + width.genomes,
                height: height.leafNode
            });
        }
    }
    renderResultsCount() {
        if (this.props.svgMetrics.layout.showSpeciesNames) {
            const x = this.props.svgMetrics.width.text - 2 * this.props.svgMetrics.layout.genomePadding;
            return /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)("text", {
                x: x,
                y: "4.75",
                className: "results-count",
                textAnchor: "end",
                children: $parcel$interopDefault($1Kll1$numeral)(this.props.node.model.results.count).format("0,0")
            });
        }
    }
    speciesName() {
        const fullName = this.props.node.model.name;
        const removedExtraineousWords = fullName.replace(/( Group$| subsp\.| ssp\.| var\.| strain)/, "");
        let finalVersion;
        if (removedExtraineousWords.length > 20) {
            let words = removedExtraineousWords.split(" ");
            if (words.length === 2) finalVersion = removedExtraineousWords.replace(/^([A-Z])[a-z]+/, "$1.");
            if (words.length > 2) finalVersion = removedExtraineousWords.replace(/^([A-Z])[a-z]+\s([a-z])[a-z]+/, "$1$2.");
        } else finalVersion = removedExtraineousWords;
        return finalVersion;
    }
    renderSubclades() {
        // if (this.showChildren()) {
        const propsPassthrough = $parcel$interopDefault($1Kll1$lodash).pick(this.props, [
            "nodeDisplayInfo",
            "svgMetrics",
            "highlight",
            "selection",
            "inProgressSelection",
            "onSelection",
            "onSelectionStart",
            "onHighlight"
        ]);
        const nodeDisplayInfo = this.props.nodeDisplayInfo;
        return $parcel$interopDefault($1Kll1$lodash)(this.props.node.children).filter((child)=>{
            const childInfo = nodeDisplayInfo[child.model.id];
            return $parcel$interopDefault($1Kll1$lodash).get(childInfo, "expanded", false);
        }).map((child)=>{
            const key = $parcel$interopDefault($1Kll1$lodash).get(child, "model.id");
            if (!$parcel$interopDefault($1Kll1$lodash).isNumber(key)) throw new Error("No node id for child!");
            return /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)($412f91be2b3621a9$export$2e2bcd8739ae039, {
                node: child,
                ...propsPassthrough
            }, key);
        }).value();
    // }
    }
    gProps() {
        return $923e1d9e74d6570a$export$2e2bcd8739ae039(this.displayInfo().offsetY, this.displayInfo().offsetX);
    }
    componentWillMount() {
        const node = this.props.node;
        this.nodeId = $parcel$interopDefault($1Kll1$lodash).get(node, "model.id");
        if (!$parcel$interopDefault($1Kll1$lodash).isNumber(this.nodeId)) throw new Error(`No node id found!`);
    }
    displayInfo() {
        return this.props.nodeDisplayInfo[this.nodeId];
    }
}
const $c4cd86894eca6282$var$regionColors = $1Kll1$d3scalechromatic.schemeCategory10;
const $c4cd86894eca6282$var$unanchoredColor = "#d3d3d3";
const $c4cd86894eca6282$var$baseColors = $1Kll1$d3scalechromatic.schemeCategory10;
// const baseColors = d3.scaleOrdinal(d3.schemeCategory10);
// const baseColors = ['#547b74', '#9abe6c'];
const $c4cd86894eca6282$var$regionColorScales = $c4cd86894eca6282$var$baseColors.map((color)=>$1Kll1$d3.scaleLinear().domain([
        0,
        1
    ]).range([
        "#FFFFFF",
        color
    ]));
const $c4cd86894eca6282$var$binColorScales = $c4cd86894eca6282$var$regionColorScales.map((scale, idx)=>$1Kll1$d3.scalePow().exponent(0.4).domain([
        0,
        1
    ]).range([
        scale(0.15),
        $c4cd86894eca6282$var$baseColors[idx]
    ]));
function $c4cd86894eca6282$export$ecd521500f0c73a1(regionIdx, isUnanchored) {
    if (isUnanchored) return $c4cd86894eca6282$var$unanchoredColor;
    const idx = regionIdx % $c4cd86894eca6282$var$regionColors.length;
    return $c4cd86894eca6282$var$regionColors[idx];
}
function $c4cd86894eca6282$export$188f209dcef43618(regionIdx, binScore, isUnanchored) {
    if (isUnanchored) return $c4cd86894eca6282$var$unanchoredColor;
    const idx = regionIdx % $c4cd86894eca6282$var$regionColors.length;
    return $c4cd86894eca6282$var$binColorScales[idx](binScore);
}
function $181c61c8a6bd5396$export$42ffd38884aecdac(ctx) {
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
}
function $29fa6aea70318279$export$3380fc6bdc12eb9(highlight) {
    if (!highlight.genome) return "nothing here";
    let name = highlight.genome.system_name;
    if (!highlight.region) return name;
    name += ` ${highlight.region.name}`;
    if (!highlight.bins) return name;
    const startBase = $parcel$interopDefault($1Kll1$lodash).head(highlight.bins).start;
    const endBase = $parcel$interopDefault($1Kll1$lodash).last(highlight.bins).end;
    name += `:${startBase}-${endBase}`;
    return name;
}
function $29fa6aea70318279$export$e42238dd896ae5a8(ctx, genomes, metrics, globalStats) {
    $181c61c8a6bd5396$export$42ffd38884aecdac(ctx);
    return $parcel$interopDefault($1Kll1$lodash)(genomes).map((genome, idx)=>{
        const x = metrics.padding;
        const y = idx * metrics.height + metrics.margin;
        const xPixels = $29fa6aea70318279$var$drawGenome({
            genome: genome,
            genomeCtx: ctx,
            x: x,
            y: y,
            globalStats: globalStats,
            width: metrics.width,
            height: metrics.unpaddedHeight
        });
        return {
            genome: genome,
            xPixels: xPixels,
            y: y,
            height: metrics.height
        };
    }).keyBy("y").value();
}
function $29fa6aea70318279$var$drawGenome({ genome: genome, genomeCtx: genomeCtx, x: x, y: y, width: width, height: height, globalStats: globalStats }) {
    const basesPerPx = genome.fullGenomeSize / width;
    const regions = genome._regionsArray;
    const maxScore = globalStats.bins.max;
    const pixelInfo = {};
    let binIdx = 0;
    let binFirstPx = x;
    let basesInBinUsedAlready = 0;
    let basesNeededByThisPixel;
    let bin;
    let binSize;
    let binScore;
    let basesAvailableInBin;
    let regionIdx = 0;
    let region = regions[regionIdx];
    let regionDims = {
        x: x,
        width: Math.floor(region.size / basesPerPx)
    };
    let regionUnanchored = region.name === "UNANCHORED";
    for(let px = x; px < width + x; px++){
        const pxInfo = {
            bins: [],
            x: binFirstPx,
            region: region,
            regionDims: regionDims,
            genome: genome,
            score: undefined,
            baseCount: 0
        };
        while(pxInfo.baseCount < basesPerPx){
            basesNeededByThisPixel = basesPerPx - pxInfo.baseCount;
            bin = region.bin(binIdx);
            binSize = bin.end - bin.start + 1;
            binScore = maxScore ? bin.results.count / maxScore : 0;
            basesAvailableInBin = binSize - basesInBinUsedAlready;
            pxInfo.bins.push(bin);
            // did we use all the bases in the bin?
            let binBasesUsed;
            if (basesAvailableInBin <= basesNeededByThisPixel) {
                // if yes, we'll move on to the next one.
                binIdx++;
                binFirstPx = px;
                basesInBinUsedAlready = 0;
                binBasesUsed = basesAvailableInBin;
            } else {
                // otherwise, track how many bases we have used.
                basesInBinUsedAlready += basesNeededByThisPixel;
                binBasesUsed = basesNeededByThisPixel;
            }
            pxInfo.score = $29fa6aea70318279$var$updateScore(pxInfo.score, pxInfo.baseCount, binScore, binBasesUsed);
            pxInfo.baseCount += binBasesUsed;
            // if the new bin index is too big for the region,
            // go to the next region and set bin index to 0
            if (binIdx === region.binCount()) {
                binIdx = 0;
                ++regionIdx;
                if (regionIdx === regions.length) break;
                region = pxInfo.region = regions[regionIdx];
                regionDims = pxInfo.regionDims = {
                    x: px,
                    width: Math.ceil(region.size / basesPerPx)
                };
                regionUnanchored = region.name === "UNANCHORED";
            }
        }
        genomeCtx.fillStyle = $c4cd86894eca6282$export$188f209dcef43618(regionIdx, pxInfo.score, regionUnanchored);
        genomeCtx.fillRect(px, y, 1, height);
        pxInfo.width = px - pxInfo.x + Math.floor(basesAvailableInBin / basesPerPx);
        pixelInfo[px] = pxInfo;
    }
    return pixelInfo;
}
function $29fa6aea70318279$var$updateScore(currentScore, baseCount, binScore, binBasesUsed) {
    let newScore;
    if ($parcel$interopDefault($1Kll1$lodash).isNumber(currentScore)) {
        if (baseCount === 0) throw new Error("There should already be bases accounted for in this pixel");
        // weight scores.
        newScore = (currentScore * baseCount + binScore * binBasesUsed) / (binBasesUsed + baseCount);
    } else {
        if (baseCount !== 0) throw new Error("There should already be a color");
        newScore = binScore;
    }
    return newScore;
}
function $e0b1c9ed93c3930a$export$88d60b1cf1c6237e(highlight, selection, inProgressSelection, ctx) {
    $181c61c8a6bd5396$export$42ffd38884aecdac(ctx);
    if (!$parcel$interopDefault($1Kll1$lodash).isEmpty(selection)) $e0b1c9ed93c3930a$var$drawSelections(selection, ctx);
    if (!$parcel$interopDefault($1Kll1$lodash).isEmpty(inProgressSelection)) $e0b1c9ed93c3930a$var$drawInProgressSelection(highlight, inProgressSelection, ctx);
    else $e0b1c9ed93c3930a$var$drawHighlight(highlight, ctx);
}
function $e0b1c9ed93c3930a$var$drawSelections(selections, ctx) {
    $parcel$interopDefault($1Kll1$lodash)(selections).filter((selection)=>selection.select).forEach((selection)=>{
        if ($e0b1c9ed93c3930a$var$isSelectionBad(selection)) return;
        const { x: x, width: width, y: y, height: height } = selection;
        ctx.strokeStyle = "red";
        ctx.strokeRect(x - 1, y - 1, width + 1, height);
    });
}
function $e0b1c9ed93c3930a$var$drawHighlight(highlight, ctx) {
    if ($e0b1c9ed93c3930a$var$isHighlightBad(highlight)) return;
    const { x: x, width: width, y: y, height: height } = highlight;
    ctx.strokeStyle = "green";
    ctx.strokeRect(x - 1, y - 1, width + 1, height);
}
function $e0b1c9ed93c3930a$var$drawInProgressSelection(highlight, inProgressSelection, ctx) {
    if ($e0b1c9ed93c3930a$var$isHighlightBad(highlight)) return;
    if ($e0b1c9ed93c3930a$var$isSelectionBad(inProgressSelection)) return;
    let start, end;
    if ($parcel$interopDefault($1Kll1$lodash).head(highlight.bins).idx > inProgressSelection.binFrom.idx) {
        start = inProgressSelection;
        end = highlight;
    } else {
        start = highlight;
        end = inProgressSelection;
    }
    const { y: y, height: height } = highlight;
    const xRange = {
        x: Math.min(start.x, end.x),
        width: end.x - start.x + end.width
    };
    ctx.strokeStyle = "green";
    ctx.strokeRect(xRange.x - 1, y - 1, xRange.width + 1, height);
}
function $e0b1c9ed93c3930a$var$isHighlightBad(highlight) {
    return !highlight || !highlight.genome || !highlight.bins || !highlight.bins.length;
}
function $e0b1c9ed93c3930a$var$isSelectionBad(sel) {
    return !sel || !sel.genome || !sel.binTo || !sel.binFrom;
}
class $530496d5ae59225d$export$2e2bcd8739ae039 {
    constructor(...listOfPaths){
        const badPaths = $parcel$interopDefault($1Kll1$lodash).filter(listOfPaths, (path)=>!($parcel$interopDefault($1Kll1$lodash).isString(path) || $530496d5ae59225d$export$2e2bcd8739ae039.isPathObject(path)));
        if (badPaths.length) {
            console.log("badpaths", badPaths);
            throw new Error(`${badPaths.length} paths that can't be used`);
        }
        this.listOfPaths = listOfPaths;
    }
    differ(stateA, stateB) {
        return !!$parcel$interopDefault($1Kll1$lodash).find(this.listOfPaths, (thePath)=>{
            if ($parcel$interopDefault($1Kll1$lodash).isString(thePath)) return $530496d5ae59225d$export$2e2bcd8739ae039.stringDiffer(stateA, stateB, thePath);
            else if ($530496d5ae59225d$export$2e2bcd8739ae039.isPathObject(thePath)) return $530496d5ae59225d$export$2e2bcd8739ae039.objectDiffer(stateA, stateB, thePath);
        });
    }
    static isPathObject(path) {
        return $parcel$interopDefault($1Kll1$lodash).isObject(path) && !($parcel$interopDefault($1Kll1$lodash).isUndefined(path.path) || $parcel$interopDefault($1Kll1$lodash).isUndefined(path.referenceValue));
    }
    static stringDiffer(stateA, stateB, thePath) {
        const a = $parcel$interopDefault($1Kll1$lodash).get(stateA, thePath);
        const b = $parcel$interopDefault($1Kll1$lodash).get(stateB, thePath);
        return !$parcel$interopDefault($1Kll1$lodash).isEqual(a, b);
    }
    static objectDiffer(stateA, stateB, thePath) {
        const { referenceValue: referenceValue, path: path } = thePath;
        const a = $530496d5ae59225d$export$2e2bcd8739ae039.matchesReferenceValue(stateA, path, referenceValue);
        const b = $530496d5ae59225d$export$2e2bcd8739ae039.matchesReferenceValue(stateB, path, referenceValue);
        return a || b;
    }
    static matchesReferenceValue(state, path, referenceValue) {
        return !$parcel$interopDefault($1Kll1$lodash).isEqual($parcel$interopDefault($1Kll1$lodash).get(state, path), referenceValue);
    }
}
function $ca3c19a284cf9b05$export$2e2bcd8739ae039(start, end) {
    $ca3c19a284cf9b05$var$checkSelection(start);
    $ca3c19a284cf9b05$var$checkSelection(end);
    $ca3c19a284cf9b05$var$checkSelectionsOnSameGenome(start, end);
    if (start === end) return start;
    let first, last;
    if (start.binFrom.idx < end.binFrom.idx) {
        first = start;
        last = end;
    } else {
        first = end;
        last = start;
    }
    const selection = $parcel$interopDefault($1Kll1$lodash).omit(first, [
        "binFrom",
        "binTo",
        "x"
    ]);
    selection.binFrom = first.binFrom;
    selection.binTo = last.binTo;
    selection.x = first.x;
    selection.width = last.x - first.x + last.width;
    return selection;
}
function $ca3c19a284cf9b05$var$checkSelection(s) {
    if (!s || !$parcel$interopDefault($1Kll1$lodash).isObject(s) || !s.genome || !s.region || !s.binFrom || !s.binTo) throw Error("Selection object invalid", s);
}
function $ca3c19a284cf9b05$var$checkSelectionsOnSameGenome(start, end) {
    if (!$parcel$interopDefault($1Kll1$lodash).isNumber(start.genome.taxon_id) || !$parcel$interopDefault($1Kll1$lodash).isEqual(start.genome.taxon_id, end.genome.taxon_id)) throw new Error("Selection start and end are on different genomes");
}
class $26ed8e186f907c39$export$2e2bcd8739ae039 extends $parcel$interopDefault($1Kll1$react).Component {
    constructor(props){
        super(props);
        this.genomesCanvasRef = $parcel$interopDefault($1Kll1$react).createRef();
        this.highlightCanvasRef = $parcel$interopDefault($1Kll1$react).createRef();
        this.state = {
            events: []
        };
        this.doGenomeRedrawProps = new $530496d5ae59225d$export$2e2bcd8739ae039("globalStats.timesSetResultsHasBeenCalled", "svgMetrics", "nodeDisplayInfo");
        this.doHighlightRedrawProps = new $530496d5ae59225d$export$2e2bcd8739ae039("highlight", "selection", "inProgressSelection");
    }
    componentWillReceiveProps(props) {
        this.genomeCanvasDirty = this.doGenomeRedrawProps.differ(props, this.props);
        this.highlightCanvasDirty = this.doHighlightRedrawProps.differ(props, this.props);
    }
    componentDidMount() {
        this.drawImage();
        this.drawHighlightsAndSelections();
    }
    componentDidUpdate() {
        if (this.genomeCanvasDirty) {
            this.drawImage();
            this.genomeCanvasDirty = false;
        }
        if (this.highlightCanvasDirty) {
            this.drawHighlightsAndSelections();
            this.highlightCanvasDirty = false;
        }
    }
    metrics(props = this.props) {
        const padding = props.svgMetrics.layout.genomePadding;
        const margin = props.svgMetrics.layout.margin;
        const width = props.svgMetrics.width.genomes;
        const height = props.svgMetrics.height.leafNode;
        const unpaddedHeight = height - padding;
        return {
            padding: padding,
            margin: margin,
            width: width,
            height: height,
            unpaddedHeight: unpaddedHeight
        };
    }
    drawImage(props = this.props) {
        const metrics = this.metrics(props);
        const globalStats = props.globalStats;
        const ctx = this.genomesCanvasRef.current.getContext("2d");
        const objectLocations = $29fa6aea70318279$export$e42238dd896ae5a8(ctx, props.genomes, metrics, globalStats);
        this.setState({
            objectLocations: objectLocations
        });
    }
    drawHighlightsAndSelections(props = this.props) {
        const ctx = this.highlightCanvasRef.current.getContext("2d");
        $e0b1c9ed93c3930a$export$88d60b1cf1c6237e(props.highlight, props.selections, props.inProgressSelection, ctx);
    }
    getHighlightFromEventCoordinates(coords) {
        let highlight = this.getHighlightCoords(coords);
        if (this.state.objectLocations) {
            const objectLocations = this.state.objectLocations[highlight.y];
            if (objectLocations && objectLocations.xPixels) $parcel$interopDefault($1Kll1$lodash).assign(highlight, objectLocations.xPixels[highlight.x]);
        }
        highlight.name = $29fa6aea70318279$export$3380fc6bdc12eb9(highlight);
        return highlight;
    }
    getHighlightCoords(coords) {
        const { offsetX: offsetX, offsetY: offsetY } = coords;
        const { margin: margin, height: height } = this.metrics();
        // if we have an in-progress selection, then take Y coord from that
        // in order to maintain selection in same genome.
        const y = $parcel$interopDefault($1Kll1$lodash).get(this.props.inProgressSelection, "y", offsetY);
        return {
            x: offsetX,
            y: y - (y - margin) % height,
            height: height
        };
    }
    getSelectionFromEventCoordinates(coords) {
        const highlight = this.getHighlightFromEventCoordinates(coords);
        const selection = $parcel$interopDefault($1Kll1$lodash).omit(highlight, "bins");
        selection.binFrom = $parcel$interopDefault($1Kll1$lodash).head(highlight.bins);
        selection.binTo = $parcel$interopDefault($1Kll1$lodash).last(highlight.bins);
        // if the first bin is already selected, we will be deselecting.
        selection.select = !this.isBinAlreadySelected(selection.binFrom);
        return selection;
    }
    isBinAlreadySelected(bin) {
        return !!$parcel$interopDefault($1Kll1$lodash).find(this.props.selections, (selection)=>selection.binFrom && selection.binFrom.idx <= bin.idx && selection.binTo.idx >= bin.idx);
    }
    getOffsetCoordsForTouchEvent(e) {
        const firstTouch = $parcel$interopDefault($1Kll1$lodash).get(e.nativeEvent, "touches[0]");
        if (!firstTouch) throw new Error("No touch information in event", e);
        const offsetX = firstTouch.pageX - firstTouch.target.offsetLeft;
        const offsetY = firstTouch.pageY - firstTouch.target.offsetTop;
        return {
            offsetX: offsetX,
            offsetY: offsetY
        };
    }
    onMouseMove(e) {
        this.logEvent(e);
        e.preventDefault();
        this.handleMove(e.nativeEvent);
    }
    onTouchMove(e) {
        this.logEvent(e);
        e.preventDefault();
        e.stopPropagation();
        this.handleMove(this.getOffsetCoordsForTouchEvent(e));
    }
    handleMove(coords) {
        this.props.onHighlight(this.getHighlightFromEventCoordinates(coords));
    }
    onMouseDown(e) {
        this.logEvent(e);
        this.handleSelectionStart(e.nativeEvent);
    }
    onTouchStart(e) {
        e.preventDefault();
        e.stopPropagation();
        this.logEvent(e);
        this.handleSelectionStart(this.getOffsetCoordsForTouchEvent(e));
    }
    handleSelectionStart(coords) {
        this.props.onSelectionStart(this.getSelectionFromEventCoordinates(coords));
    }
    onTouchEnd(e) {
        e.preventDefault();
        e.stopPropagation();
        this.logEvent(e);
        this.handleSelection(this.getOffsetCoordsForTouchEvent(e));
    }
    handleSelection(coords) {
        const selectionStart = this.props.inProgressSelection;
        if (selectionStart) {
            // Lock Y coordinate like this in order to allow contiguous selection
            // *within a genome*
            const fakeCoords = {
                offsetX: coords.offsetX,
                offsetY: selectionStart.y
            };
            const selectionEnd = this.getSelectionFromEventCoordinates(fakeCoords);
            this.props.onSelection($ca3c19a284cf9b05$export$2e2bcd8739ae039(selectionStart, selectionEnd));
        }
    }
    onClick(e) {
        this.logEvent(e);
        e.preventDefault();
        e.stopPropagation();
        const numberOfClicks = e.nativeEvent.detail;
        const ne = e.nativeEvent;
        if (numberOfClicks === 1) {
            this.handleSelection(ne);
            return;
        }
        const selection = this.getSelectionFromEventCoordinates(ne);
        switch(numberOfClicks){
            case 2:
                this.selectRegion(selection);
                break;
            case 3:
                this.selectGenome(selection);
                break;
        }
    }
    selectRegion(selection) {
        const { region: region, regionDims: regionDims } = selection;
        selection.binFrom = region.firstBin();
        selection.binTo = region.bin(region.binCount() - 1);
        selection.x = regionDims.x;
        selection.width = regionDims.width;
        selection.select = !selection.select; // it's state was changed on the first click.
        this.props.onSelection(selection);
    }
    selectGenome(selection) {
        const rootNode = this.props.rootNode;
        const genome = selection.genome;
        const metrics = this.metrics();
        selection.binFrom = rootNode.getBin(genome.startBin);
        selection.binTo = rootNode.getBin(genome.startBin + genome.nbins - 1);
        selection.x = metrics.padding;
        selection.width = metrics.width;
        selection.select = !selection.select; // it's state was changed on the previous two clicks
        this.props.onSelection(selection);
    }
    cancelSelection(e) {
        this.logEvent(e);
        this.props.onSelectionStart();
    }
    logEvent(e) {
        const { type: type, nativeEvent: { offsetX: offsetX, offsetY: offsetY, detail: detail, touches: touches } } = e;
        const info = detail || touches && touches.length;
        const time = new Date();
        this.setState({
            events: $parcel$interopDefault($1Kll1$lodash).concat([], {
                type: type,
                offsetX: offsetX,
                offsetY: offsetY,
                info: info,
                time: time
            }, this.state.events)
        });
    }
    eventLog() {
        return this.state.events.map((e)=>/*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsxs)("li", {
                children: [
                    String(e.time.getTime()).substr(8),
                    " ",
                    e.type,
                    ": (",
                    e.offsetX,
                    ", ",
                    e.offsetY,
                    ") detail: ",
                    e.detail
                ]
            }, e.time.getTime()));
    }
    render() {
        const metrics = this.props.svgMetrics;
        const dimensions = {
            height: this.props.genomes.length * metrics.height.leafNode + metrics.layout.margin,
            width: metrics.width.genomes + metrics.layout.genomePadding * 2
        };
        return /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsxs)("div", {
            className: "genomes",
            children: [
                /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)("canvas", {
                    ref: this.genomesCanvasRef,
                    ...dimensions
                }),
                /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)("canvas", {
                    ref: this.highlightCanvasRef,
                    ...dimensions,
                    onClick: this.onClick.bind(this),
                    onMouseDown: this.onMouseDown.bind(this),
                    onMouseMove: this.onMouseMove.bind(this),
                    onMouseOut: this.cancelSelection.bind(this),
                    onTouchStart: this.onTouchStart.bind(this),
                    onTouchMove: this.onTouchMove.bind(this),
                    onTouchEnd: this.onTouchEnd.bind(this),
                    onTouchCancel: this.cancelSelection.bind(this)
                })
            ]
        });
    }
}
function $565d4ca0b99315ee$export$2e2bcd8739ae039(selections, newSelection) {
    // add or subtract one because we may need to modify selections immediately adjacent.
    const start = newSelection.binFrom.idx - 1;
    const end = newSelection.binTo.idx + 1;
    const taxonId = newSelection.genome.taxon_id;
    const partitioned = $parcel$interopDefault($1Kll1$lodash).partition(selections, (selection)=>{
        const from = $parcel$interopDefault($1Kll1$lodash).get(selection.binFrom, "idx");
        const to = $parcel$interopDefault($1Kll1$lodash).get(selection.binTo, "idx");
        return taxonId === $parcel$interopDefault($1Kll1$lodash).get(selection.genome, "taxon_id") && !(from > end || to < start);
    });
    return {
        toUpdate: partitioned[0],
        toLeave: partitioned[1]
    };
}
function $f544a09c7aaad705$export$2e2bcd8739ae039(newSelection, oldSelection) {
    if (oldSelection.select !== newSelection.select) throw new Error("Can only merge selections if they are both the same type");
    const { genome: { taxon_id: oldTaxonId }, binFrom: { idx: oldStartIdx }, binTo: { idx: oldEndIdx } } = oldSelection;
    const { genome: { taxon_id: newTaxonId }, binFrom: { idx: newStartIdx }, binTo: { idx: newEndIdx } } = newSelection;
    if (oldTaxonId !== newTaxonId) throw new Error("Adjacent bins on different genomes. Will not merge.");
    const updatedNewSelection = $parcel$interopDefault($1Kll1$lodash).clone(newSelection);
    if (oldStartIdx < newStartIdx) {
        if (oldEndIdx + 1 < newStartIdx) throw new Error("Selections don't overlap/are not adjacent");
        updatedNewSelection.binFrom = oldSelection.binFrom;
        updatedNewSelection.x = oldSelection.x;
        updatedNewSelection.width = updatedNewSelection.width + newSelection.x - oldSelection.x;
    }
    if (oldEndIdx > newEndIdx) {
        if (oldStartIdx - 1 > newEndIdx) throw new Error("Selections don't overlap/are not adjacent");
        updatedNewSelection.binTo = oldSelection.binTo;
        updatedNewSelection.width = oldSelection.width + oldSelection.x - updatedNewSelection.x;
    }
    return updatedNewSelection;
}
function $3adf4dbbc1fb6445$export$4df50c43964c29ef(newSelection, oldSelection, rootNode) {
    $3adf4dbbc1fb6445$var$commonChecks(oldSelection, newSelection);
    const updatedEndIdx = newSelection.binFrom.idx - 1;
    if (updatedEndIdx < oldSelection.binFrom.idx) throw new Error("Cannot end selection before it starts");
    const updatedEnd = rootNode.getBin(updatedEndIdx);
    const updatedSelectionBefore = $parcel$interopDefault($1Kll1$lodash).clone(oldSelection);
    updatedSelectionBefore.binTo = updatedEnd;
    updatedSelectionBefore.width = newSelection.x - oldSelection.x;
    return updatedSelectionBefore;
}
function $3adf4dbbc1fb6445$export$d9ca64303a4c5d71(newSelection, oldSelection, rootNode) {
    $3adf4dbbc1fb6445$var$commonChecks(oldSelection, newSelection);
    const updatedStartIdx = newSelection.binTo.idx + 1;
    if (updatedStartIdx > oldSelection.binTo.idx) throw new Error("Cannot start selection after it ends");
    const updatedStart = rootNode.getBin(updatedStartIdx);
    const updatedSelectionAfter = $parcel$interopDefault($1Kll1$lodash).clone(oldSelection);
    updatedSelectionAfter.binFrom = updatedStart;
    updatedSelectionAfter.x = newSelection.x + newSelection.width;
    updatedSelectionAfter.width = oldSelection.x + oldSelection.width - updatedSelectionAfter.x;
    return updatedSelectionAfter;
}
function $3adf4dbbc1fb6445$var$commonChecks(oldS, newS) {
    if (oldS.select === newS.select) throw new Error("These selections should be merged!");
    if (newS.binFrom.idx < oldS.binFrom.idx && newS.binTo.idx > oldS.binTo.idx) throw new Error("Old bin should be removed, not trimmed");
    if (newS.binFrom.idx > oldS.binTo.idx || newS.binTo.idx < oldS.binFrom.idx) throw new Error("No appropriate overlap for trim");
}
function $eb703776a00ee55e$export$2e2bcd8739ae039(acc, oldSelection, rootNode) {
    const newSelection = acc.modifiedNewSelection;
    const { genome: { taxon_id: oldTaxonId }, binFrom: { idx: oldStartIdx }, binTo: { idx: oldEndIdx } } = oldSelection;
    const { genome: { taxon_id: newTaxonId }, binFrom: { idx: newStartIdx }, binTo: { idx: newEndIdx } } = newSelection;
    if (oldTaxonId !== newTaxonId || oldEndIdx + 1 < newStartIdx && oldStartIdx < newStartIdx || oldStartIdx - 1 > newEndIdx && oldEndIdx > newEndIdx) throw new Error("Selections don't overlap/are not adjacent");
    /*
   If overlapping or adjacent selections are the same
   type (e.g. both have "select" === true) and are on
   the same genome, then we should merge them into the
   new selection.
   */ if (oldSelection.select === newSelection.select) acc.modifiedNewSelection = $f544a09c7aaad705$export$2e2bcd8739ae039(newSelection, oldSelection);
    else if (oldStartIdx >= newStartIdx && oldEndIdx <= newEndIdx) ;
    else {
        /* NB it's possible for both of the following conditions to be true */ /* case 2: newSelection overwrites end of old selection
     oldSelection:       |-------------|
     newSelection:               |---------...
     updatedSelections:  |------|
     */ if (oldStartIdx < newStartIdx && oldEndIdx >= newStartIdx) acc.updated.push($3adf4dbbc1fb6445$export$4df50c43964c29ef(newSelection, oldSelection, rootNode));
        /* case 3: newSelection overwrites start of oldSelection
     oldSelection:               |------------|
     newSelection:       ...-----------|
     updatedSelections:                 |-----|
     */ if (oldStartIdx <= newEndIdx && oldEndIdx > newEndIdx) acc.updated.push($3adf4dbbc1fb6445$export$d9ca64303a4c5d71(newSelection, oldSelection, rootNode));
    }
    return acc;
}
function $62cb6e6f9f8e464a$export$2e2bcd8739ae039(existingSelectionsToUpdate, rootNode, newSelection) {
    return existingSelectionsToUpdate.reduce((acc, oldSelection)=>$eb703776a00ee55e$export$2e2bcd8739ae039(acc, oldSelection, rootNode), {
        modifiedNewSelection: newSelection,
        updated: []
    });
}
function $eeb63405e607c2a2$export$6c7848d79ea81085(newSelection, currentSelectionState, rootNode) {
    // find any existing selections that will be affected by the new one.
    const { toUpdate: toUpdate, toLeave: toLeave } = $565d4ca0b99315ee$export$2e2bcd8739ae039(currentSelectionState, newSelection);
    // modify the new selection and any existing ones that overlap
    // in order to remove overlaps
    const { modifiedNewSelection: modifiedNewSelection, updated: updated } = $62cb6e6f9f8e464a$export$2e2bcd8739ae039(toUpdate, rootNode, newSelection);
    const newSelections = [
        ...toLeave,
        ...updated
    ];
    // add the new selection if it is a selection (i.e. not a deselection).
    if (modifiedNewSelection.select) newSelections.push(modifiedNewSelection);
    return newSelections;
}
class $51d08e07ac9e9607$export$2e2bcd8739ae039 extends $parcel$interopDefault($1Kll1$react).Component {
    constructor(props){
        super(props);
        this.state = {
            inProgressSelection: {},
            selections: [],
            highlight: {}
        };
    }
    expandedNodesWillChange(newNodeDisplayInfo) {
        return !$parcel$interopDefault($1Kll1$lodash).isEqualWith(newNodeDisplayInfo, this.props.nodeDisplayInfo, (a, b)=>a.expanded == b.expanded);
    }
    componentWillReceiveProps(newProps) {
        if (this.expandedNodesWillChange(newProps.nodeDisplayInfo)) {
            console.log("Clearing selection state because expanded nodes will change");
            this.setState({
                selections: []
            });
        }
    }
    handleSelectionStart(selection) {
        this.setState({
            inProgressSelection: selection
        });
    }
    handleSelection(selection) {
        const newSelections = this.updateSelection(selection);
        if (newSelections) {
            this.setState({
                selections: newSelections,
                inProgressSelection: undefined
            });
            if (this.props.onSelection) this.props.onSelection(newSelections);
        }
    }
    updateSelection(selectionObj) {
        return $eeb63405e607c2a2$export$6c7848d79ea81085(selectionObj, this.state.selections, this.props.rootNode);
    }
    handleHighlight(highlight) {
        this.setState({
            highlight: highlight
        });
        if (this.props.onHighlight) {
            // need to expose highlight with modified coordinates, taking into account the x offset
            // caused by the species tree
            const mtx = this.props.svgMetrics;
            const modifiedHighlight = $parcel$interopDefault($1Kll1$lodash).cloneDeep(highlight);
            const xOffset = mtx.width.speciesTree + mtx.width.text;
            if (modifiedHighlight.hasOwnProperty("x") && modifiedHighlight.hasOwnProperty("regionDims")) {
                modifiedHighlight.x += xOffset;
                modifiedHighlight.regionDims.x += xOffset;
                this.props.onHighlight(modifiedHighlight);
            }
        }
    }
    marginTransform() {
        const m = this.props.svgMetrics.layout.margin / 2;
        return `translate(${m},${m})`;
    }
    getGenomes(props = this.props) {
        return $3ba3fb37090da528$export$5d5aa51867371914(props.rootNode, props.nodeDisplayInfo).map((node)=>node.model.genome);
    }
    render() {
        const propsPassthrough = $parcel$interopDefault($1Kll1$lodash).pick(this.props, [
            "nodeDisplayInfo",
            "svgMetrics"
        ]);
        const mtx = this.props.svgMetrics;
        const svgWidth = mtx.width.speciesTree + mtx.width.text;
        const style = {
            minWidth: mtx.width.vis
        };
        return /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsxs)("div", {
            className: "gramene-search-vis",
            style: style,
            children: [
                /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)("svg", {
                    width: svgWidth,
                    height: this.props.height,
                    children: /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)("g", {
                        className: "taxonomy",
                        transform: this.marginTransform(),
                        children: /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)($412f91be2b3621a9$export$2e2bcd8739ae039, {
                            node: this.props.rootNode,
                            isRoot: true,
                            ...this.state,
                            onSelectionStart: this.handleSelectionStart.bind(this),
                            onSelection: this.handleSelection.bind(this),
                            onHighlight: this.handleHighlight.bind(this),
                            ...propsPassthrough
                        })
                    })
                }),
                /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)($26ed8e186f907c39$export$2e2bcd8739ae039, {
                    genomes: this.getGenomes(),
                    rootNode: this.props.rootNode,
                    globalStats: this.props.rootNode.globalResultSetStats(),
                    ...this.state,
                    onSelectionStart: this.handleSelectionStart.bind(this),
                    onSelection: this.handleSelection.bind(this),
                    onHighlight: this.handleHighlight.bind(this),
                    ...propsPassthrough
                })
            ]
        });
    }
}
const $08ed429e2991b5a8$var$windowResizeDebounceMs = 250;
class $08ed429e2991b5a8$var$Vis extends $parcel$interopDefault($1Kll1$react).Component {
    constructor(props){
        super(props);
        this.updateProps = new $530496d5ae59225d$export$2e2bcd8739ae039("selectedTaxa");
        var rootNode = props.taxonomy;
        while(rootNode.children.length === 1)rootNode = rootNode.children[0];
        this.state = {
            nodeDisplayInfo: this.initNodeState(props.taxonomy, props.selectedTaxa),
            rootNodeId: rootNode.model.id
        };
        if (!$parcel$interopDefault($1Kll1$lodash).isUndefined($parcel$global.addEventListener)) {
            this.resizeListener = $parcel$interopDefault($1Kll1$lodash).debounce(this.updateAvailableWidth.bind(this), $08ed429e2991b5a8$var$windowResizeDebounceMs);
            $parcel$global.addEventListener("resize", this.resizeListener);
        }
    }
    componentDidMount() {
        this.updateAvailableWidth();
    }
    componentWillUnmount() {
        if (this.resizeListener) $parcel$global.removeEventListener("resize", this.resizeListener);
    }
    updateAvailableWidth() {
        const parentWidth = $parcel$interopDefault($1Kll1$reactdom).findDOMNode(this).parentNode.clientWidth;
        const newMetrics = $124e2536d5ac167e$export$2e2bcd8739ae039(parentWidth);
        console.log("width is", parentWidth, "metrics are", newMetrics);
        if (this.didMetricsUpdate(newMetrics)) this.setState({
            metrics: newMetrics,
            nodeDisplayInfo: this.updateTaxonomyDisplayInfo(this.props, newMetrics)
        });
    }
    componentWillReceiveProps(newProps) {
        if (this.didResultsChange(newProps) || this.updateProps.differ(this.props, newProps)) {
            const newDisplayInfo = this.updateTaxonomyDisplayInfo(newProps);
            if (newDisplayInfo) this.setState({
                nodeDisplayInfo: newDisplayInfo
            });
        }
    }
    updateTaxonomyDisplayInfo(props = this.props, metrics = this.state.metrics) {
        if (metrics) {
            const intermediateDisplayInfo = this.updateNodeExpansionState(props.selectedTaxa);
            const newDisplayInfo = $856009e104b5527d$export$2e2bcd8739ae039($parcel$interopDefault($1Kll1$lodash).get(metrics, "width.speciesTree"), this.height(metrics, intermediateDisplayInfo), props.taxonomy, intermediateDisplayInfo, this.state.rootNodeId, props.selectedTaxa);
            return newDisplayInfo;
        } else console.log("Did not update taxonomy display info because no svg metrics available");
    }
    selectedTaxaWithParents(selectedTaxa) {
        const nodeIndex = this.props.taxonomy.indices.id;
        return $parcel$interopDefault($1Kll1$lodash).reduce(selectedTaxa, (acc, val, selectedTaxonId)=>{
            const selectedNode = nodeIndex[selectedTaxonId];
            const parents = $parcel$interopDefault($1Kll1$lodash).reduce(selectedNode.getPath(), (acc, parent)=>{
                acc[parent.model.id] = true;
                return acc;
            }, {});
            return $parcel$interopDefault($1Kll1$lodash).assign(acc, parents);
        }, {});
    }
    updateNodeExpansionState(selectedTaxa) {
        const allSelected = $parcel$interopDefault($1Kll1$lodash).size(selectedTaxa) == 0;
        const selectedTaxaWithParents = allSelected ? null : this.selectedTaxaWithParents(selectedTaxa);
        return $parcel$interopDefault($1Kll1$lodash).mapValues(this.state.nodeDisplayInfo, (val, key)=>{
            const newVal = $parcel$interopDefault($1Kll1$lodash).clone(val);
            newVal.expanded = allSelected || !!selectedTaxaWithParents[key];
            return newVal;
        });
    }
    initNodeState(taxonomy) {
        return $parcel$interopDefault($1Kll1$lodash)(taxonomy.all()).keyBy("model.id").mapValues(()=>({
                expanded: true,
                highlight: false
            })).value();
    }
    getSetResultsCallCount(props) {
        return props.taxonomy.globalResultSetStats().timesSetResultsHasBeenCalled;
    }
    didResultsChange(props) {
        const newResultsState = this.getSetResultsCallCount(props);
        return this.genomeResultsState !== newResultsState;
    }
    updateResultsCount(props) {
        this.genomeResultsState = this.getSetResultsCallCount(props);
    }
    shouldComponentUpdate(newProps, newState) {
        const decision = this.didResultsChange(newProps) || this.didMetricsUpdate(newState.metrics) || this.updateProps.differ(this.props, newProps);
        this.updateResultsCount(newProps);
        return decision;
    }
    didMetricsUpdate(newMetrics) {
        return !$parcel$interopDefault($1Kll1$lodash).isEqual(this.state.metrics, newMetrics);
    }
    rootNode() {
        return this.props.taxonomy.indices.id[this.state.rootNodeId];
    }
    height(metrics = this.state.metrics, nodeDisplayInfo = this.state.nodeDisplayInfo) {
        if (!metrics) throw new Error("No svg metrics available for call to height()");
        return $3ba3fb37090da528$export$f27c46a4165fa319(this.props.taxonomy, nodeDisplayInfo) * metrics.height.leafNode;
    }
    width() {
        if (!this.state.metrics) throw new Error("No svg metrics available for call to width()");
        return this.state.metrics.width.vis;
    }
    margin() {
        if (!this.state.metrics) throw new Error("No svg metrics available for call to width()");
        return this.state.metrics.layout.margin;
    }
    renderTaxonomy() {
        if (this.state.metrics) return /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)($51d08e07ac9e9607$export$2e2bcd8739ae039, {
            width: this.width() + this.margin(),
            height: this.height() + this.margin(),
            rootNode: this.rootNode(),
            selectedTaxa: this.props.selectedTaxa,
            nodeDisplayInfo: this.state.nodeDisplayInfo,
            onHighlight: this.props.onHighlight,
            onSelection: this.props.onSelection,
            svgMetrics: this.state.metrics
        });
    }
    render() {
        return /*#__PURE__*/ (0, $1Kll1$reactjsxruntime.jsx)("div", {
            className: "taxogenomic-vis",
            children: this.renderTaxonomy()
        });
    }
}
var $08ed429e2991b5a8$export$2e2bcd8739ae039 = $08ed429e2991b5a8$var$Vis;

},{"2fc1562fa4d105dc":"gonF6","e139595a0b7f3104":"bmhQu","a00d6202c65e27eb":"82aNB","32e8129e9bc02852":"L2GyB","afbce5c17db0ba5d":"ib0IG","886b5c4db9a0d347":"33tt3","db936f098744703e":"1X467","294dd37eb3c39938":"8RVhR","9eb6b5ba97248c8c":"84aZA","7164af7e69208eb7":"5y5Lb"}],"ib0IG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cluster", ()=>(0, _clusterJsDefault.default));
parcelHelpers.export(exports, "hierarchy", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "Node", ()=>(0, _indexJs.Node));
parcelHelpers.export(exports, "pack", ()=>(0, _indexJsDefault1.default));
parcelHelpers.export(exports, "packSiblings", ()=>(0, _siblingsJsDefault.default));
parcelHelpers.export(exports, "packEnclose", ()=>(0, _encloseJsDefault.default));
parcelHelpers.export(exports, "partition", ()=>(0, _partitionJsDefault.default));
parcelHelpers.export(exports, "stratify", ()=>(0, _stratifyJsDefault.default));
parcelHelpers.export(exports, "tree", ()=>(0, _treeJsDefault.default));
parcelHelpers.export(exports, "treemap", ()=>(0, _indexJsDefault2.default));
parcelHelpers.export(exports, "treemapBinary", ()=>(0, _binaryJsDefault.default));
parcelHelpers.export(exports, "treemapDice", ()=>(0, _diceJsDefault.default));
parcelHelpers.export(exports, "treemapSlice", ()=>(0, _sliceJsDefault.default));
parcelHelpers.export(exports, "treemapSliceDice", ()=>(0, _sliceDiceJsDefault.default));
parcelHelpers.export(exports, "treemapSquarify", ()=>(0, _squarifyJsDefault.default));
parcelHelpers.export(exports, "treemapResquarify", ()=>(0, _resquarifyJsDefault.default));
var _clusterJs = require("./cluster.js");
var _clusterJsDefault = parcelHelpers.interopDefault(_clusterJs);
var _indexJs = require("./hierarchy/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./pack/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _siblingsJs = require("./pack/siblings.js");
var _siblingsJsDefault = parcelHelpers.interopDefault(_siblingsJs);
var _encloseJs = require("./pack/enclose.js");
var _encloseJsDefault = parcelHelpers.interopDefault(_encloseJs);
var _partitionJs = require("./partition.js");
var _partitionJsDefault = parcelHelpers.interopDefault(_partitionJs);
var _stratifyJs = require("./stratify.js");
var _stratifyJsDefault = parcelHelpers.interopDefault(_stratifyJs);
var _treeJs = require("./tree.js");
var _treeJsDefault = parcelHelpers.interopDefault(_treeJs);
var _indexJs2 = require("./treemap/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _binaryJs = require("./treemap/binary.js");
var _binaryJsDefault = parcelHelpers.interopDefault(_binaryJs);
var _diceJs = require("./treemap/dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);
var _sliceJs = require("./treemap/slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
var _sliceDiceJs = require("./treemap/sliceDice.js");
var _sliceDiceJsDefault = parcelHelpers.interopDefault(_sliceDiceJs);
var _squarifyJs = require("./treemap/squarify.js");
var _squarifyJsDefault = parcelHelpers.interopDefault(_squarifyJs);
var _resquarifyJs = require("./treemap/resquarify.js");
var _resquarifyJsDefault = parcelHelpers.interopDefault(_resquarifyJs);

},{"./cluster.js":"80u41","./hierarchy/index.js":"dielx","./pack/index.js":"g70u9","./pack/siblings.js":"k2M8h","./pack/enclose.js":"dlMAD","./partition.js":"2cSVo","./stratify.js":"b3EYW","./tree.js":"6ix7A","./treemap/index.js":"dQUds","./treemap/binary.js":"cwOYb","./treemap/dice.js":"2vaII","./treemap/slice.js":"fnBvC","./treemap/sliceDice.js":"5nWez","./treemap/squarify.js":"dFeQs","./treemap/resquarify.js":"gjqpQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"80u41":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var separation = defaultSeparation, dx = 1, dy = 1, nodeSize = false;
        function cluster(root) {
            var previousNode, x = 0;
            // First walk, computing the initial x & y values.
            root.eachAfter(function(node) {
                var children = node.children;
                if (children) {
                    node.x = meanX(children);
                    node.y = maxY(children);
                } else {
                    node.x = previousNode ? x += separation(node, previousNode) : 0;
                    node.y = 0;
                    previousNode = node;
                }
            });
            var left = leafLeft(root), right = leafRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
            // Second walk, normalizing x & y to the desired size.
            return root.eachAfter(nodeSize ? function(node) {
                node.x = (node.x - root.x) * dx;
                node.y = (root.y - node.y) * dy;
            } : function(node) {
                node.x = (node.x - x0) / (x1 - x0) * dx;
                node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
            });
        }
        cluster.separation = function(x) {
            return arguments.length ? (separation = x, cluster) : separation;
        };
        cluster.size = function(x) {
            return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : nodeSize ? null : [
                dx,
                dy
            ];
        };
        cluster.nodeSize = function(x) {
            return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : nodeSize ? [
                dx,
                dy
            ] : null;
        };
        return cluster;
    });
function defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
}
function meanX(children) {
    return children.reduce(meanXReduce, 0) / children.length;
}
function meanXReduce(x, c) {
    return x + c.x;
}
function maxY(children) {
    return 1 + children.reduce(maxYReduce, 0);
}
function maxYReduce(y, c) {
    return Math.max(y, c.y);
}
function leafLeft(node) {
    var children;
    while(children = node.children)node = children[0];
    return node;
}
function leafRight(node) {
    var children;
    while(children = node.children)node = children[children.length - 1];
    return node;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dielx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hierarchy);
parcelHelpers.export(exports, "computeHeight", ()=>computeHeight);
parcelHelpers.export(exports, "Node", ()=>Node);
var _countJs = require("./count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
var _eachJs = require("./each.js");
var _eachJsDefault = parcelHelpers.interopDefault(_eachJs);
var _eachBeforeJs = require("./eachBefore.js");
var _eachBeforeJsDefault = parcelHelpers.interopDefault(_eachBeforeJs);
var _eachAfterJs = require("./eachAfter.js");
var _eachAfterJsDefault = parcelHelpers.interopDefault(_eachAfterJs);
var _findJs = require("./find.js");
var _findJsDefault = parcelHelpers.interopDefault(_findJs);
var _sumJs = require("./sum.js");
var _sumJsDefault = parcelHelpers.interopDefault(_sumJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
var _ancestorsJs = require("./ancestors.js");
var _ancestorsJsDefault = parcelHelpers.interopDefault(_ancestorsJs);
var _descendantsJs = require("./descendants.js");
var _descendantsJsDefault = parcelHelpers.interopDefault(_descendantsJs);
var _leavesJs = require("./leaves.js");
var _leavesJsDefault = parcelHelpers.interopDefault(_leavesJs);
var _linksJs = require("./links.js");
var _linksJsDefault = parcelHelpers.interopDefault(_linksJs);
var _iteratorJs = require("./iterator.js");
var _iteratorJsDefault = parcelHelpers.interopDefault(_iteratorJs);
function hierarchy(data, children) {
    if (data instanceof Map) {
        data = [
            undefined,
            data
        ];
        if (children === undefined) children = mapChildren;
    } else if (children === undefined) children = objectChildren;
    var root = new Node(data), node, nodes = [
        root
    ], child, childs, i, n;
    while(node = nodes.pop())if ((childs = children(node.data)) && (n = (childs = Array.from(childs)).length)) {
        node.children = childs;
        for(i = n - 1; i >= 0; --i){
            nodes.push(child = childs[i] = new Node(childs[i]));
            child.parent = node;
            child.depth = node.depth + 1;
        }
    }
    return root.eachBefore(computeHeight);
}
function node_copy() {
    return hierarchy(this).eachBefore(copyData);
}
function objectChildren(d) {
    return d.children;
}
function mapChildren(d) {
    return Array.isArray(d) ? d[1] : null;
}
function copyData(node) {
    if (node.data.value !== undefined) node.value = node.data.value;
    node.data = node.data.data;
}
function computeHeight(node) {
    var height = 0;
    do node.height = height;
    while ((node = node.parent) && node.height < ++height);
}
function Node(data) {
    this.data = data;
    this.depth = this.height = 0;
    this.parent = null;
}
Node.prototype = hierarchy.prototype = {
    constructor: Node,
    count: (0, _countJsDefault.default),
    each: (0, _eachJsDefault.default),
    eachAfter: (0, _eachAfterJsDefault.default),
    eachBefore: (0, _eachBeforeJsDefault.default),
    find: (0, _findJsDefault.default),
    sum: (0, _sumJsDefault.default),
    sort: (0, _sortJsDefault.default),
    path: (0, _pathJsDefault.default),
    ancestors: (0, _ancestorsJsDefault.default),
    descendants: (0, _descendantsJsDefault.default),
    leaves: (0, _leavesJsDefault.default),
    links: (0, _linksJsDefault.default),
    copy: node_copy,
    [Symbol.iterator]: (0, _iteratorJsDefault.default)
};

},{"./count.js":"eSSsq","./each.js":"5HqsA","./eachBefore.js":"cEibP","./eachAfter.js":"7y28Y","./find.js":"fxLUL","./sum.js":"cBkcq","./sort.js":"kdz8M","./path.js":"h8btk","./ancestors.js":"Ps2TY","./descendants.js":"46Kyd","./leaves.js":"ftjw3","./links.js":"rmksM","./iterator.js":"1OfuY","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eSSsq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.eachAfter(count);
    });
function count(node) {
    var sum = 0, children = node.children, i = children && children.length;
    if (!i) sum = 1;
    else while(--i >= 0)sum += children[i].value;
    node.value = sum;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5HqsA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, that) {
        let index = -1;
        for (const node of this)callback.call(that, node, ++index, this);
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cEibP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, that) {
        var node = this, nodes = [
            node
        ], children, i, index = -1;
        while(node = nodes.pop()){
            callback.call(that, node, ++index, this);
            if (children = node.children) for(i = children.length - 1; i >= 0; --i)nodes.push(children[i]);
        }
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7y28Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, that) {
        var node = this, nodes = [
            node
        ], next = [], children, i, n, index = -1;
        while(node = nodes.pop()){
            next.push(node);
            if (children = node.children) for(i = 0, n = children.length; i < n; ++i)nodes.push(children[i]);
        }
        while(node = next.pop())callback.call(that, node, ++index, this);
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fxLUL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, that) {
        let index = -1;
        for (const node of this){
            if (callback.call(that, node, ++index, this)) return node;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cBkcq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return this.eachAfter(function(node) {
            var sum = +value(node.data) || 0, children = node.children, i = children && children.length;
            while(--i >= 0)sum += children[i].value;
            node.value = sum;
        });
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kdz8M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(compare) {
        return this.eachBefore(function(node) {
            if (node.children) node.children.sort(compare);
        });
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h8btk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(end) {
        var start = this, ancestor = leastCommonAncestor(start, end), nodes = [
            start
        ];
        while(start !== ancestor){
            start = start.parent;
            nodes.push(start);
        }
        var k = nodes.length;
        while(end !== ancestor){
            nodes.splice(k, 0, end);
            end = end.parent;
        }
        return nodes;
    });
function leastCommonAncestor(a, b) {
    if (a === b) return a;
    var aNodes = a.ancestors(), bNodes = b.ancestors(), c = null;
    a = aNodes.pop();
    b = bNodes.pop();
    while(a === b){
        c = a;
        a = aNodes.pop();
        b = bNodes.pop();
    }
    return c;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"Ps2TY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var node = this, nodes = [
            node
        ];
        while(node = node.parent)nodes.push(node);
        return nodes;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"46Kyd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return Array.from(this);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ftjw3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var leaves = [];
        this.eachBefore(function(node) {
            if (!node.children) leaves.push(node);
        });
        return leaves;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"rmksM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var root = this, links = [];
        root.each(function(node) {
            if (node !== root) links.push({
                source: node.parent,
                target: node
            });
        });
        return links;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1OfuY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function*() {
        var node = this, current, next = [
            node
        ], children, i, n;
        do {
            current = next.reverse(), next = [];
            while(node = current.pop()){
                yield node;
                if (children = node.children) for(i = 0, n = children.length; i < n; ++i)next.push(children[i]);
            }
        }while (next.length);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g70u9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var radius = null, dx = 1, dy = 1, padding = (0, _constantJs.constantZero);
        function pack(root) {
            const random = (0, _lcgJsDefault.default)();
            root.x = dx / 2, root.y = dy / 2;
            if (radius) root.eachBefore(radiusLeaf(radius)).eachAfter(packChildrenRandom(padding, 0.5, random)).eachBefore(translateChild(1));
            else root.eachBefore(radiusLeaf(defaultRadius)).eachAfter(packChildrenRandom((0, _constantJs.constantZero), 1, random)).eachAfter(packChildrenRandom(padding, root.r / Math.min(dx, dy), random)).eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
            return root;
        }
        pack.radius = function(x) {
            return arguments.length ? (radius = (0, _accessorsJs.optional)(x), pack) : radius;
        };
        pack.size = function(x) {
            return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [
                dx,
                dy
            ];
        };
        pack.padding = function(x) {
            return arguments.length ? (padding = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), pack) : padding;
        };
        return pack;
    });
var _accessorsJs = require("../accessors.js");
var _constantJs = require("../constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _lcgJs = require("../lcg.js");
var _lcgJsDefault = parcelHelpers.interopDefault(_lcgJs);
var _siblingsJs = require("./siblings.js");
function defaultRadius(d) {
    return Math.sqrt(d.value);
}
function radiusLeaf(radius) {
    return function(node) {
        if (!node.children) node.r = Math.max(0, +radius(node) || 0);
    };
}
function packChildrenRandom(padding, k, random) {
    return function(node) {
        if (children = node.children) {
            var children, i, n = children.length, r = padding(node) * k || 0, e;
            if (r) for(i = 0; i < n; ++i)children[i].r += r;
            e = (0, _siblingsJs.packSiblingsRandom)(children, random);
            if (r) for(i = 0; i < n; ++i)children[i].r -= r;
            node.r = e + r;
        }
    };
}
function translateChild(k) {
    return function(node) {
        var parent = node.parent;
        node.r *= k;
        if (parent) {
            node.x = parent.x + k * node.x;
            node.y = parent.y + k * node.y;
        }
    };
}

},{"../accessors.js":"bZ9BQ","../constant.js":"cLuOx","../lcg.js":"lu3XO","./siblings.js":"k2M8h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bZ9BQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "optional", ()=>optional);
parcelHelpers.export(exports, "required", ()=>required);
function optional(f) {
    return f == null ? null : required(f);
}
function required(f) {
    if (typeof f !== "function") throw new Error;
    return f;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cLuOx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "constantZero", ()=>constantZero);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });
function constantZero() {
    return 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lu3XO":[function(require,module,exports,__globalThis) {
// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        let s = 1;
        return ()=>(s = (a * s + c) % m) / m;
    });
const a = 1664525;
const c = 1013904223;
const m = 4294967296; // 2^32

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k2M8h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "packSiblingsRandom", ()=>packSiblingsRandom);
parcelHelpers.export(exports, "default", ()=>function(circles) {
        packSiblingsRandom(circles, (0, _lcgJsDefault.default)());
        return circles;
    });
var _arrayJs = require("../array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _lcgJs = require("../lcg.js");
var _lcgJsDefault = parcelHelpers.interopDefault(_lcgJs);
var _encloseJs = require("./enclose.js");
function place(b, a, c) {
    var dx = b.x - a.x, x, a2, dy = b.y - a.y, y, b2, d2 = dx * dx + dy * dy;
    if (d2) {
        a2 = a.r + c.r, a2 *= a2;
        b2 = b.r + c.r, b2 *= b2;
        if (a2 > b2) {
            x = (d2 + b2 - a2) / (2 * d2);
            y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
            c.x = b.x - x * dx - y * dy;
            c.y = b.y - x * dy + y * dx;
        } else {
            x = (d2 + a2 - b2) / (2 * d2);
            y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
            c.x = a.x + x * dx - y * dy;
            c.y = a.y + x * dy + y * dx;
        }
    } else {
        c.x = a.x + c.r;
        c.y = a.y;
    }
}
function intersects(a, b) {
    var dr = a.r + b.r - 1e-6, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function score(node) {
    var a = node._, b = node.next._, ab = a.r + b.r, dx = (a.x * b.r + b.x * a.r) / ab, dy = (a.y * b.r + b.y * a.r) / ab;
    return dx * dx + dy * dy;
}
function Node(circle) {
    this._ = circle;
    this.next = null;
    this.previous = null;
}
function packSiblingsRandom(circles, random) {
    if (!(n = (circles = (0, _arrayJsDefault.default)(circles)).length)) return 0;
    var a, b, c, n, aa, ca, i, j, k, sj, sk;
    // Place the first circle.
    a = circles[0], a.x = 0, a.y = 0;
    if (!(n > 1)) return a.r;
    // Place the second circle.
    b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
    if (!(n > 2)) return a.r + b.r;
    // Place the third circle.
    place(b, a, c = circles[2]);
    // Initialize the front-chain using the first three circles a, b and c.
    a = new Node(a), b = new Node(b), c = new Node(c);
    a.next = c.previous = b;
    b.next = a.previous = c;
    c.next = b.previous = a;
    // Attempt to place each remaining circle…
    pack: for(i = 3; i < n; ++i){
        place(a._, b._, c = circles[i]), c = new Node(c);
        // Find the closest intersecting circle on the front-chain, if any.
        // “Closeness” is determined by linear distance along the front-chain.
        // “Ahead” or “behind” is likewise determined by linear distance.
        j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
        do if (sj <= sk) {
            if (intersects(j._, c._)) {
                b = j, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sj += j._.r, j = j.next;
        } else {
            if (intersects(k._, c._)) {
                a = k, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sk += k._.r, k = k.previous;
        }
        while (j !== k.next);
        // Success! Insert the new circle c between a and b.
        c.previous = a, c.next = b, a.next = b.previous = b = c;
        // Compute the new closest circle pair to the centroid.
        aa = score(a);
        while((c = c.next) !== b)if ((ca = score(c)) < aa) a = c, aa = ca;
        b = a.next;
    }
    // Compute the enclosing circle of the front chain.
    a = [
        b._
    ], c = b;
    while((c = c.next) !== b)a.push(c._);
    c = (0, _encloseJs.packEncloseRandom)(a, random);
    // Translate the circles to put the enclosing circle around the origin.
    for(i = 0; i < n; ++i)a = circles[i], a.x -= c.x, a.y -= c.y;
    return c.r;
}

},{"../array.js":"2xiEp","../lcg.js":"lu3XO","./enclose.js":"dlMAD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2xiEp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
         : Array.from(x); // Map, Set, iterable, string, or anything else
    });
parcelHelpers.export(exports, "shuffle", ()=>shuffle);
function shuffle(array, random) {
    let m = array.length, t, i;
    while(m){
        i = random() * m-- | 0;
        t = array[m];
        array[m] = array[i];
        array[i] = t;
    }
    return array;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dlMAD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(circles) {
        return packEncloseRandom(circles, (0, _lcgJsDefault.default)());
    });
parcelHelpers.export(exports, "packEncloseRandom", ()=>packEncloseRandom);
var _arrayJs = require("../array.js");
var _lcgJs = require("../lcg.js");
var _lcgJsDefault = parcelHelpers.interopDefault(_lcgJs);
function packEncloseRandom(circles, random) {
    var i = 0, n = (circles = (0, _arrayJs.shuffle)(Array.from(circles), random)).length, B = [], p, e;
    while(i < n){
        p = circles[i];
        if (e && enclosesWeak(e, p)) ++i;
        else e = encloseBasis(B = extendBasis(B, p)), i = 0;
    }
    return e;
}
function extendBasis(B, p) {
    var i, j;
    if (enclosesWeakAll(p, B)) return [
        p
    ];
    // If we get here then B must have at least one element.
    for(i = 0; i < B.length; ++i){
        if (enclosesNot(p, B[i]) && enclosesWeakAll(encloseBasis2(B[i], p), B)) return [
            B[i],
            p
        ];
    }
    // If we get here then B must have at least two elements.
    for(i = 0; i < B.length - 1; ++i)for(j = i + 1; j < B.length; ++j){
        if (enclosesNot(encloseBasis2(B[i], B[j]), p) && enclosesNot(encloseBasis2(B[i], p), B[j]) && enclosesNot(encloseBasis2(B[j], p), B[i]) && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) return [
            B[i],
            B[j],
            p
        ];
    }
    // If we get here then something is very wrong.
    throw new Error;
}
function enclosesNot(a, b) {
    var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
    return dr < 0 || dr * dr < dx * dx + dy * dy;
}
function enclosesWeak(a, b) {
    var dr = a.r - b.r + Math.max(a.r, b.r, 1) * 1e-9, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function enclosesWeakAll(a, B) {
    for(var i = 0; i < B.length; ++i){
        if (!enclosesWeak(a, B[i])) return false;
    }
    return true;
}
function encloseBasis(B) {
    switch(B.length){
        case 1:
            return encloseBasis1(B[0]);
        case 2:
            return encloseBasis2(B[0], B[1]);
        case 3:
            return encloseBasis3(B[0], B[1], B[2]);
    }
}
function encloseBasis1(a) {
    return {
        x: a.x,
        y: a.y,
        r: a.r
    };
}
function encloseBasis2(a, b) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1, l = Math.sqrt(x21 * x21 + y21 * y21);
    return {
        x: (x1 + x2 + x21 / l * r21) / 2,
        y: (y1 + y2 + y21 / l * r21) / 2,
        r: (l + r1 + r2) / 2
    };
}
function encloseBasis3(a, b, c) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x3 = c.x, y3 = c.y, r3 = c.r, a2 = x1 - x2, a3 = x1 - x3, b2 = y1 - y2, b3 = y1 - y3, c2 = r2 - r1, c3 = r3 - r1, d1 = x1 * x1 + y1 * y1 - r1 * r1, d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2, d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3, ab = a3 * b2 - a2 * b3, xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1, xb = (b3 * c2 - b2 * c3) / ab, ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1, yb = (a2 * c3 - a3 * c2) / ab, A = xb * xb + yb * yb - 1, B = 2 * (r1 + xa * xb + ya * yb), C = xa * xa + ya * ya - r1 * r1, r = -(Math.abs(A) > 1e-6 ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
    return {
        x: x1 + xa + xb * r,
        y: y1 + ya + yb * r,
        r: r
    };
}

},{"../array.js":"2xiEp","../lcg.js":"lu3XO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2cSVo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var dx = 1, dy = 1, padding = 0, round = false;
        function partition(root) {
            var n = root.height + 1;
            root.x0 = root.y0 = padding;
            root.x1 = dx;
            root.y1 = dy / n;
            root.eachBefore(positionNode(dy, n));
            if (round) root.eachBefore((0, _roundJsDefault.default));
            return root;
        }
        function positionNode(dy, n) {
            return function(node) {
                if (node.children) (0, _diceJsDefault.default)(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
                var x0 = node.x0, y0 = node.y0, x1 = node.x1 - padding, y1 = node.y1 - padding;
                if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
                if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
                node.x0 = x0;
                node.y0 = y0;
                node.x1 = x1;
                node.y1 = y1;
            };
        }
        partition.round = function(x) {
            return arguments.length ? (round = !!x, partition) : round;
        };
        partition.size = function(x) {
            return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [
                dx,
                dy
            ];
        };
        partition.padding = function(x) {
            return arguments.length ? (padding = +x, partition) : padding;
        };
        return partition;
    });
var _roundJs = require("./treemap/round.js");
var _roundJsDefault = parcelHelpers.interopDefault(_roundJs);
var _diceJs = require("./treemap/dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);

},{"./treemap/round.js":"lDVwz","./treemap/dice.js":"2vaII","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lDVwz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node) {
        node.x0 = Math.round(node.x0);
        node.y0 = Math.round(node.y0);
        node.x1 = Math.round(node.x1);
        node.y1 = Math.round(node.y1);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2vaII":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(parent, x0, y0, x1, y1) {
        var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (x1 - x0) / parent.value;
        while(++i < n){
            node = nodes[i], node.y0 = y0, node.y1 = y1;
            node.x0 = x0, node.x1 = x0 += node.value * k;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b3EYW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var id = defaultId, parentId = defaultParentId, path;
        function stratify(data) {
            var nodes = Array.from(data), currentId = id, currentParentId = parentId, n, d, i, root, parent, node, nodeId, nodeKey, nodeByKey = new Map;
            if (path != null) {
                const I = nodes.map((d, i)=>normalize(path(d, i, data)));
                const P = I.map(parentof);
                const S = new Set(I).add("");
                for (const i of P)if (!S.has(i)) {
                    S.add(i);
                    I.push(i);
                    P.push(parentof(i));
                    nodes.push(imputed);
                }
                currentId = (_, i)=>I[i];
                currentParentId = (_, i)=>P[i];
            }
            for(i = 0, n = nodes.length; i < n; ++i){
                d = nodes[i], node = nodes[i] = new (0, _indexJs.Node)(d);
                if ((nodeId = currentId(d, i, data)) != null && (nodeId += "")) {
                    nodeKey = node.id = nodeId;
                    nodeByKey.set(nodeKey, nodeByKey.has(nodeKey) ? ambiguous : node);
                }
                if ((nodeId = currentParentId(d, i, data)) != null && (nodeId += "")) node.parent = nodeId;
            }
            for(i = 0; i < n; ++i){
                node = nodes[i];
                if (nodeId = node.parent) {
                    parent = nodeByKey.get(nodeId);
                    if (!parent) throw new Error("missing: " + nodeId);
                    if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
                    if (parent.children) parent.children.push(node);
                    else parent.children = [
                        node
                    ];
                    node.parent = parent;
                } else {
                    if (root) throw new Error("multiple roots");
                    root = node;
                }
            }
            if (!root) throw new Error("no root");
            // When imputing internal nodes, only introduce roots if needed.
            // Then replace the imputed marker data with null.
            if (path != null) {
                while(root.data === imputed && root.children.length === 1)root = root.children[0], --n;
                for(let i = nodes.length - 1; i >= 0; --i){
                    node = nodes[i];
                    if (node.data !== imputed) break;
                    node.data = null;
                }
            }
            root.parent = preroot;
            root.eachBefore(function(node) {
                node.depth = node.parent.depth + 1;
                --n;
            }).eachBefore((0, _indexJs.computeHeight));
            root.parent = null;
            if (n > 0) throw new Error("cycle");
            return root;
        }
        stratify.id = function(x) {
            return arguments.length ? (id = (0, _accessorsJs.optional)(x), stratify) : id;
        };
        stratify.parentId = function(x) {
            return arguments.length ? (parentId = (0, _accessorsJs.optional)(x), stratify) : parentId;
        };
        stratify.path = function(x) {
            return arguments.length ? (path = (0, _accessorsJs.optional)(x), stratify) : path;
        };
        return stratify;
    });
var _accessorsJs = require("./accessors.js");
var _indexJs = require("./hierarchy/index.js");
var preroot = {
    depth: -1
}, ambiguous = {}, imputed = {};
function defaultId(d) {
    return d.id;
}
function defaultParentId(d) {
    return d.parentId;
}
// To normalize a path, we coerce to a string, strip the trailing slash if any
// (as long as the trailing slash is not immediately preceded by another slash),
// and add leading slash if missing.
function normalize(path) {
    path = `${path}`;
    let i = path.length;
    if (slash(path, i - 1) && !slash(path, i - 2)) path = path.slice(0, -1);
    return path[0] === "/" ? path : `/${path}`;
}
// Walk backwards to find the first slash that is not the leading slash, e.g.:
// "/foo/bar" ⇥ "/foo", "/foo" ⇥ "/", "/" ↦ "". (The root is special-cased
// because the id of the root must be a truthy value.)
function parentof(path) {
    let i = path.length;
    if (i < 2) return "";
    while(--i > 1)if (slash(path, i)) break;
    return path.slice(0, i);
}
// Slashes can be escaped; to determine whether a slash is a path delimiter, we
// count the number of preceding backslashes escaping the forward slash: an odd
// number indicates an escaped forward slash.
function slash(path, i) {
    if (path[i] === "/") {
        let k = 0;
        while(i > 0 && path[--i] === "\\")++k;
        if ((k & 1) === 0) return true;
    }
    return false;
}

},{"./accessors.js":"bZ9BQ","./hierarchy/index.js":"dielx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6ix7A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
parcelHelpers.export(exports, "default", ()=>function() {
        var separation = defaultSeparation, dx = 1, dy = 1, nodeSize = null;
        function tree(root) {
            var t = treeRoot(root);
            // Compute the layout using Buchheim et al.’s algorithm.
            t.eachAfter(firstWalk), t.parent.m = -t.z;
            t.eachBefore(secondWalk);
            // If a fixed node size is specified, scale x and y.
            if (nodeSize) root.eachBefore(sizeNode);
            else {
                var left = root, right = root, bottom = root;
                root.eachBefore(function(node) {
                    if (node.x < left.x) left = node;
                    if (node.x > right.x) right = node;
                    if (node.depth > bottom.depth) bottom = node;
                });
                var s = left === right ? 1 : separation(left, right) / 2, tx = s - left.x, kx = dx / (right.x + s + tx), ky = dy / (bottom.depth || 1);
                root.eachBefore(function(node) {
                    node.x = (node.x + tx) * kx;
                    node.y = node.depth * ky;
                });
            }
            return root;
        }
        // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
        // applied recursively to the children of v, as well as the function
        // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
        // node v is placed to the midpoint of its outermost children.
        function firstWalk(v) {
            var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
            if (children) {
                executeShifts(v);
                var midpoint = (children[0].z + children[children.length - 1].z) / 2;
                if (w) {
                    v.z = w.z + separation(v._, w._);
                    v.m = v.z - midpoint;
                } else v.z = midpoint;
            } else if (w) v.z = w.z + separation(v._, w._);
            v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
        }
        // Computes all real x-coordinates by summing up the modifiers recursively.
        function secondWalk(v) {
            v._.x = v.z + v.parent.m;
            v.m += v.parent.m;
        }
        // The core of the algorithm. Here, a new subtree is combined with the
        // previous subtrees. Threads are used to traverse the inside and outside
        // contours of the left and right subtree up to the highest common level. The
        // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
        // superscript o means outside and i means inside, the subscript - means left
        // subtree and + means right subtree. For summing up the modifiers along the
        // contour, we use respective variables si+, si-, so-, and so+. Whenever two
        // nodes of the inside contours conflict, we compute the left one of the
        // greatest uncommon ancestors using the function ANCESTOR and call MOVE
        // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
        // Finally, we add a new thread (if necessary).
        function apportion(v, w, ancestor) {
            if (w) {
                var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
                while(vim = nextRight(vim), vip = nextLeft(vip), vim && vip){
                    vom = nextLeft(vom);
                    vop = nextRight(vop);
                    vop.a = v;
                    shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
                    if (shift > 0) {
                        moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
                        sip += shift;
                        sop += shift;
                    }
                    sim += vim.m;
                    sip += vip.m;
                    som += vom.m;
                    sop += vop.m;
                }
                if (vim && !nextRight(vop)) {
                    vop.t = vim;
                    vop.m += sim - sop;
                }
                if (vip && !nextLeft(vom)) {
                    vom.t = vip;
                    vom.m += sip - som;
                    ancestor = v;
                }
            }
            return ancestor;
        }
        function sizeNode(node) {
            node.x *= dx;
            node.y = node.depth * dy;
        }
        tree.separation = function(x) {
            return arguments.length ? (separation = x, tree) : separation;
        };
        tree.size = function(x) {
            return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : nodeSize ? null : [
                dx,
                dy
            ];
        };
        tree.nodeSize = function(x) {
            return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : nodeSize ? [
                dx,
                dy
            ] : null;
        };
        return tree;
    });
var _indexJs = require("./hierarchy/index.js");
function defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
}
// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }
// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function nextLeft(v) {
    var children = v.children;
    return children ? children[0] : v.t;
}
// This function works analogously to nextLeft.
function nextRight(v) {
    var children = v.children;
    return children ? children[children.length - 1] : v.t;
}
// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function moveSubtree(wm, wp, shift) {
    var change = shift / (wp.i - wm.i);
    wp.c -= change;
    wp.s += shift;
    wm.c += change;
    wp.z += shift;
    wp.m += shift;
}
// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function executeShifts(v) {
    var shift = 0, change = 0, children = v.children, i = children.length, w;
    while(--i >= 0){
        w = children[i];
        w.z += shift;
        w.m += shift;
        shift += w.s + (change += w.c);
    }
}
// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function nextAncestor(vim, v, ancestor) {
    return vim.a.parent === v.parent ? vim.a : ancestor;
}
function TreeNode(node, i) {
    this._ = node;
    this.parent = null;
    this.children = null;
    this.A = null; // default ancestor
    this.a = this; // ancestor
    this.z = 0; // prelim
    this.m = 0; // mod
    this.c = 0; // change
    this.s = 0; // shift
    this.t = null; // thread
    this.i = i; // number
}
TreeNode.prototype = Object.create((0, _indexJs.Node).prototype);
function treeRoot(root) {
    var tree = new TreeNode(root, 0), node, nodes = [
        tree
    ], child, children, i, n;
    while(node = nodes.pop())if (children = node._.children) {
        node.children = new Array(n = children.length);
        for(i = n - 1; i >= 0; --i){
            nodes.push(child = node.children[i] = new TreeNode(children[i], i));
            child.parent = node;
        }
    }
    (tree.parent = new TreeNode(null, 0)).children = [
        tree
    ];
    return tree;
}

},{"./hierarchy/index.js":"dielx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dQUds":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var tile = (0, _squarifyJsDefault.default), round = false, dx = 1, dy = 1, paddingStack = [
            0
        ], paddingInner = (0, _constantJs.constantZero), paddingTop = (0, _constantJs.constantZero), paddingRight = (0, _constantJs.constantZero), paddingBottom = (0, _constantJs.constantZero), paddingLeft = (0, _constantJs.constantZero);
        function treemap(root) {
            root.x0 = root.y0 = 0;
            root.x1 = dx;
            root.y1 = dy;
            root.eachBefore(positionNode);
            paddingStack = [
                0
            ];
            if (round) root.eachBefore((0, _roundJsDefault.default));
            return root;
        }
        function positionNode(node) {
            var p = paddingStack[node.depth], x0 = node.x0 + p, y0 = node.y0 + p, x1 = node.x1 - p, y1 = node.y1 - p;
            if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
            if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
            node.x0 = x0;
            node.y0 = y0;
            node.x1 = x1;
            node.y1 = y1;
            if (node.children) {
                p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
                x0 += paddingLeft(node) - p;
                y0 += paddingTop(node) - p;
                x1 -= paddingRight(node) - p;
                y1 -= paddingBottom(node) - p;
                if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
                if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
                tile(node, x0, y0, x1, y1);
            }
        }
        treemap.round = function(x) {
            return arguments.length ? (round = !!x, treemap) : round;
        };
        treemap.size = function(x) {
            return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [
                dx,
                dy
            ];
        };
        treemap.tile = function(x) {
            return arguments.length ? (tile = (0, _accessorsJs.required)(x), treemap) : tile;
        };
        treemap.padding = function(x) {
            return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
        };
        treemap.paddingInner = function(x) {
            return arguments.length ? (paddingInner = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), treemap) : paddingInner;
        };
        treemap.paddingOuter = function(x) {
            return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
        };
        treemap.paddingTop = function(x) {
            return arguments.length ? (paddingTop = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), treemap) : paddingTop;
        };
        treemap.paddingRight = function(x) {
            return arguments.length ? (paddingRight = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), treemap) : paddingRight;
        };
        treemap.paddingBottom = function(x) {
            return arguments.length ? (paddingBottom = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), treemap) : paddingBottom;
        };
        treemap.paddingLeft = function(x) {
            return arguments.length ? (paddingLeft = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), treemap) : paddingLeft;
        };
        return treemap;
    });
var _roundJs = require("./round.js");
var _roundJsDefault = parcelHelpers.interopDefault(_roundJs);
var _squarifyJs = require("./squarify.js");
var _squarifyJsDefault = parcelHelpers.interopDefault(_squarifyJs);
var _accessorsJs = require("../accessors.js");
var _constantJs = require("../constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);

},{"./round.js":"lDVwz","./squarify.js":"dFeQs","../accessors.js":"bZ9BQ","../constant.js":"cLuOx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dFeQs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "phi", ()=>phi);
parcelHelpers.export(exports, "squarifyRatio", ()=>squarifyRatio);
var _diceJs = require("./dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
var phi = (1 + Math.sqrt(5)) / 2;
function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
    var rows = [], nodes = parent.children, row, nodeValue, i0 = 0, i1 = 0, n = nodes.length, dx, dy, value = parent.value, sumValue, minValue, maxValue, newRatio, minRatio, alpha, beta;
    while(i0 < n){
        dx = x1 - x0, dy = y1 - y0;
        // Find the next non-empty node.
        do sumValue = nodes[i1++].value;
        while (!sumValue && i1 < n);
        minValue = maxValue = sumValue;
        alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
        beta = sumValue * sumValue * alpha;
        minRatio = Math.max(maxValue / beta, beta / minValue);
        // Keep adding nodes while the aspect ratio maintains or improves.
        for(; i1 < n; ++i1){
            sumValue += nodeValue = nodes[i1].value;
            if (nodeValue < minValue) minValue = nodeValue;
            if (nodeValue > maxValue) maxValue = nodeValue;
            beta = sumValue * sumValue * alpha;
            newRatio = Math.max(maxValue / beta, beta / minValue);
            if (newRatio > minRatio) {
                sumValue -= nodeValue;
                break;
            }
            minRatio = newRatio;
        }
        // Position and record the row orientation.
        rows.push(row = {
            value: sumValue,
            dice: dx < dy,
            children: nodes.slice(i0, i1)
        });
        if (row.dice) (0, _diceJsDefault.default)(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
        else (0, _sliceJsDefault.default)(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
        value -= sumValue, i0 = i1;
    }
    return rows;
}
exports.default = function custom(ratio) {
    function squarify(parent, x0, y0, x1, y1) {
        squarifyRatio(ratio, parent, x0, y0, x1, y1);
    }
    squarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return squarify;
}(phi);

},{"./dice.js":"2vaII","./slice.js":"fnBvC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fnBvC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(parent, x0, y0, x1, y1) {
        var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (y1 - y0) / parent.value;
        while(++i < n){
            node = nodes[i], node.x0 = x0, node.x1 = x1;
            node.y0 = y0, node.y1 = y0 += node.value * k;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cwOYb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(parent, x0, y0, x1, y1) {
        var nodes = parent.children, i, n = nodes.length, sum, sums = new Array(n + 1);
        for(sums[0] = sum = i = 0; i < n; ++i)sums[i + 1] = sum += nodes[i].value;
        partition(0, n, parent.value, x0, y0, x1, y1);
        function partition(i, j, value, x0, y0, x1, y1) {
            if (i >= j - 1) {
                var node = nodes[i];
                node.x0 = x0, node.y0 = y0;
                node.x1 = x1, node.y1 = y1;
                return;
            }
            var valueOffset = sums[i], valueTarget = value / 2 + valueOffset, k = i + 1, hi = j - 1;
            while(k < hi){
                var mid = k + hi >>> 1;
                if (sums[mid] < valueTarget) k = mid + 1;
                else hi = mid;
            }
            if (valueTarget - sums[k - 1] < sums[k] - valueTarget && i + 1 < k) --k;
            var valueLeft = sums[k] - valueOffset, valueRight = value - valueLeft;
            if (x1 - x0 > y1 - y0) {
                var xk = value ? (x0 * valueRight + x1 * valueLeft) / value : x1;
                partition(i, k, valueLeft, x0, y0, xk, y1);
                partition(k, j, valueRight, xk, y0, x1, y1);
            } else {
                var yk = value ? (y0 * valueRight + y1 * valueLeft) / value : y1;
                partition(i, k, valueLeft, x0, y0, x1, yk);
                partition(k, j, valueRight, x0, yk, x1, y1);
            }
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5nWez":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(parent, x0, y0, x1, y1) {
        (parent.depth & 1 ? (0, _sliceJsDefault.default) : (0, _diceJsDefault.default))(parent, x0, y0, x1, y1);
    });
var _diceJs = require("./dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);

},{"./dice.js":"2vaII","./slice.js":"fnBvC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gjqpQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _diceJs = require("./dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
var _squarifyJs = require("./squarify.js");
exports.default = function custom(ratio) {
    function resquarify(parent, x0, y0, x1, y1) {
        if ((rows = parent._squarify) && rows.ratio === ratio) {
            var rows, row, nodes, i, j = -1, n, m = rows.length, value = parent.value;
            while(++j < m){
                row = rows[j], nodes = row.children;
                for(i = row.value = 0, n = nodes.length; i < n; ++i)row.value += nodes[i].value;
                if (row.dice) (0, _diceJsDefault.default)(row, x0, y0, x1, value ? y0 += (y1 - y0) * row.value / value : y1);
                else (0, _sliceJsDefault.default)(row, x0, y0, value ? x0 += (x1 - x0) * row.value / value : x1, y1);
                value -= row.value;
            }
        } else {
            parent._squarify = rows = (0, _squarifyJs.squarifyRatio)(ratio, parent, x0, y0, x1, y1);
            rows.ratio = ratio;
        }
    }
    resquarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return resquarify;
}((0, _squarifyJs.phi));

},{"./dice.js":"2vaII","./slice.js":"fnBvC","./squarify.js":"dFeQs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"33tt3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scaleBand", ()=>(0, _bandJsDefault.default));
parcelHelpers.export(exports, "scalePoint", ()=>(0, _bandJs.point));
parcelHelpers.export(exports, "scaleIdentity", ()=>(0, _identityJsDefault.default));
parcelHelpers.export(exports, "scaleLinear", ()=>(0, _linearJsDefault.default));
parcelHelpers.export(exports, "scaleLog", ()=>(0, _logJsDefault.default));
parcelHelpers.export(exports, "scaleSymlog", ()=>(0, _symlogJsDefault.default));
parcelHelpers.export(exports, "scaleOrdinal", ()=>(0, _ordinalJsDefault.default));
parcelHelpers.export(exports, "scaleImplicit", ()=>(0, _ordinalJs.implicit));
parcelHelpers.export(exports, "scalePow", ()=>(0, _powJsDefault.default));
parcelHelpers.export(exports, "scaleSqrt", ()=>(0, _powJs.sqrt));
parcelHelpers.export(exports, "scaleRadial", ()=>(0, _radialJsDefault.default));
parcelHelpers.export(exports, "scaleQuantile", ()=>(0, _quantileJsDefault.default));
parcelHelpers.export(exports, "scaleQuantize", ()=>(0, _quantizeJsDefault.default));
parcelHelpers.export(exports, "scaleThreshold", ()=>(0, _thresholdJsDefault.default));
parcelHelpers.export(exports, "scaleTime", ()=>(0, _timeJsDefault.default));
parcelHelpers.export(exports, "scaleUtc", ()=>(0, _utcTimeJsDefault.default));
parcelHelpers.export(exports, "scaleSequential", ()=>(0, _sequentialJsDefault.default));
parcelHelpers.export(exports, "scaleSequentialLog", ()=>(0, _sequentialJs.sequentialLog));
parcelHelpers.export(exports, "scaleSequentialPow", ()=>(0, _sequentialJs.sequentialPow));
parcelHelpers.export(exports, "scaleSequentialSqrt", ()=>(0, _sequentialJs.sequentialSqrt));
parcelHelpers.export(exports, "scaleSequentialSymlog", ()=>(0, _sequentialJs.sequentialSymlog));
parcelHelpers.export(exports, "scaleSequentialQuantile", ()=>(0, _sequentialQuantileJsDefault.default));
parcelHelpers.export(exports, "scaleDiverging", ()=>(0, _divergingJsDefault.default));
parcelHelpers.export(exports, "scaleDivergingLog", ()=>(0, _divergingJs.divergingLog));
parcelHelpers.export(exports, "scaleDivergingPow", ()=>(0, _divergingJs.divergingPow));
parcelHelpers.export(exports, "scaleDivergingSqrt", ()=>(0, _divergingJs.divergingSqrt));
parcelHelpers.export(exports, "scaleDivergingSymlog", ()=>(0, _divergingJs.divergingSymlog));
parcelHelpers.export(exports, "tickFormat", ()=>(0, _tickFormatJsDefault.default));
var _bandJs = require("./band.js");
var _bandJsDefault = parcelHelpers.interopDefault(_bandJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _linearJs = require("./linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _logJs = require("./log.js");
var _logJsDefault = parcelHelpers.interopDefault(_logJs);
var _symlogJs = require("./symlog.js");
var _symlogJsDefault = parcelHelpers.interopDefault(_symlogJs);
var _ordinalJs = require("./ordinal.js");
var _ordinalJsDefault = parcelHelpers.interopDefault(_ordinalJs);
var _powJs = require("./pow.js");
var _powJsDefault = parcelHelpers.interopDefault(_powJs);
var _radialJs = require("./radial.js");
var _radialJsDefault = parcelHelpers.interopDefault(_radialJs);
var _quantileJs = require("./quantile.js");
var _quantileJsDefault = parcelHelpers.interopDefault(_quantileJs);
var _quantizeJs = require("./quantize.js");
var _quantizeJsDefault = parcelHelpers.interopDefault(_quantizeJs);
var _thresholdJs = require("./threshold.js");
var _thresholdJsDefault = parcelHelpers.interopDefault(_thresholdJs);
var _timeJs = require("./time.js");
var _timeJsDefault = parcelHelpers.interopDefault(_timeJs);
var _utcTimeJs = require("./utcTime.js");
var _utcTimeJsDefault = parcelHelpers.interopDefault(_utcTimeJs);
var _sequentialJs = require("./sequential.js");
var _sequentialJsDefault = parcelHelpers.interopDefault(_sequentialJs);
var _sequentialQuantileJs = require("./sequentialQuantile.js");
var _sequentialQuantileJsDefault = parcelHelpers.interopDefault(_sequentialQuantileJs);
var _divergingJs = require("./diverging.js");
var _divergingJsDefault = parcelHelpers.interopDefault(_divergingJs);
var _tickFormatJs = require("./tickFormat.js");
var _tickFormatJsDefault = parcelHelpers.interopDefault(_tickFormatJs);

},{"./band.js":"hxl8x","./identity.js":"9LL7I","./linear.js":"7SztY","./log.js":"idfbA","./symlog.js":"g07CI","./ordinal.js":"hup2W","./pow.js":"ljC55","./radial.js":"42gCO","./quantile.js":"jb3oU","./quantize.js":"4DTyJ","./threshold.js":"2GhxC","./time.js":"5G37R","./utcTime.js":"9Mols","./sequential.js":"2SIjS","./sequentialQuantile.js":"4bzQH","./diverging.js":"ecRvG","./tickFormat.js":"k6jbH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hxl8x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>band);
parcelHelpers.export(exports, "point", ()=>point);
var _d3Array = require("d3-array");
var _initJs = require("./init.js");
var _ordinalJs = require("./ordinal.js");
var _ordinalJsDefault = parcelHelpers.interopDefault(_ordinalJs);
function band() {
    var scale = (0, _ordinalJsDefault.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, _d3Array.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, _initJs.initRange).apply(rescale(), arguments);
}
function pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return pointish(copy());
    };
    return scale;
}
function point() {
    return pointish(band.apply(null, arguments).paddingInner(1));
}

},{"d3-array":[["range","fkSdr","default"]],"./init.js":"h9ql6","./ordinal.js":"hup2W","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fkSdr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>range);
function range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h9ql6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initRange", ()=>initRange);
parcelHelpers.export(exports, "initInterpolator", ()=>initInterpolator);
function initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hup2W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "implicit", ()=>implicit);
parcelHelpers.export(exports, "default", ()=>ordinal);
var _d3Array = require("d3-array");
var _initJs = require("./init.js");
const implicit = Symbol("implicit");
function ordinal() {
    var index = new (0, _d3Array.InternMap)(), domain = [], range = [], unknown = implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new (0, _d3Array.InternMap)();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return ordinal(domain, range).unknown(unknown);
    };
    (0, _initJs.initRange).apply(scale, arguments);
    return scale;
}

},{"d3-array":"3QR3P","./init.js":"h9ql6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3QR3P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternMap", ()=>InternMap);
parcelHelpers.export(exports, "InternSet", ()=>InternSet);
class InternMap extends Map {
    constructor(entries, key = keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get(intern_get(this, key));
    }
    has(key) {
        return super.has(intern_get(this, key));
    }
    set(key, value) {
        return super.set(intern_set(this, key), value);
    }
    delete(key) {
        return super.delete(intern_delete(this, key));
    }
}
class InternSet extends Set {
    constructor(values, key = keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has(intern_get(this, value));
    }
    add(value) {
        return super.add(intern_set(this, value));
    }
    delete(value) {
        return super.delete(intern_delete(this, value));
    }
}
function intern_get({ _intern, _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function intern_set({ _intern, _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function intern_delete({ _intern, _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9LL7I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>identity);
var _linearJs = require("./linear.js");
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
function identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, _numberJsDefault.default)), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, (0, _numberJsDefault.default)) : [
        0,
        1
    ];
    return (0, _linearJs.linearish)(scale);
}

},{"./linear.js":"7SztY","./number.js":"lyk5i","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7SztY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "linearish", ()=>linearish);
parcelHelpers.export(exports, "default", ()=>linear);
var _d3Array = require("d3-array");
var _continuousJs = require("./continuous.js");
var _continuousJsDefault = parcelHelpers.interopDefault(_continuousJs);
var _initJs = require("./init.js");
var _tickFormatJs = require("./tickFormat.js");
var _tickFormatJsDefault = parcelHelpers.interopDefault(_tickFormatJs);
function linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, _d3Array.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, _tickFormatJsDefault.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, _d3Array.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function linear() {
    var scale = (0, _continuousJsDefault.default)();
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, linear());
    };
    (0, _initJs.initRange).apply(scale, arguments);
    return linearish(scale);
}

},{"d3-array":[["tickIncrement","9j7q7"],["ticks","9j7q7","default"]],"./continuous.js":"1zZMt","./init.js":"h9ql6","./tickFormat.js":"k6jbH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9j7q7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ticks);
parcelHelpers.export(exports, "tickIncrement", ()=>tickIncrement);
parcelHelpers.export(exports, "tickStep", ()=>tickStep);
const e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
function tickSpec(start, stop, count) {
    const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1;
    let i1, i2, inc;
    if (power < 0) {
        inc = Math.pow(10, -power) / factor;
        i1 = Math.round(start * inc);
        i2 = Math.round(stop * inc);
        if (i1 / inc < start) ++i1;
        if (i2 / inc > stop) --i2;
        inc = -inc;
    } else {
        inc = Math.pow(10, power) * factor;
        i1 = Math.round(start / inc);
        i2 = Math.round(stop / inc);
        if (i1 * inc < start) ++i1;
        if (i2 * inc > stop) --i2;
    }
    if (i2 < i1 && 0.5 <= count && count < 2) return tickSpec(start, stop, count * 2);
    return [
        i1,
        i2,
        inc
    ];
}
function ticks(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    if (!(count > 0)) return [];
    if (start === stop) return [
        start
    ];
    const reverse = stop < start, [i1, i2, inc] = reverse ? tickSpec(stop, start, count) : tickSpec(start, stop, count);
    if (!(i2 >= i1)) return [];
    const n = i2 - i1 + 1, ticks = new Array(n);
    if (reverse) {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) * inc;
    } else {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) * inc;
    }
    return ticks;
}
function tickIncrement(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    return tickSpec(start, stop, count)[2];
}
function tickStep(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    const reverse = stop < start, inc = reverse ? tickIncrement(stop, start, count) : tickIncrement(start, stop, count);
    return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1zZMt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "copy", ()=>copy);
parcelHelpers.export(exports, "transformer", ()=>transformer);
parcelHelpers.export(exports, "default", ()=>continuous);
var _d3Array = require("d3-array");
var _d3Interpolate = require("d3-interpolate");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var unit = [
    0,
    1
];
function identity(x) {
    return x;
}
function normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, _constantJsDefault.default)(isNaN(b) ? NaN : 0.5);
}
function clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, _d3Array.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function transformer() {
    var domain = unit, range = unit, interpolate = (0, _d3Interpolate.interpolate), transform, untransform, unknown, clamp = identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== identity) clamp = clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? polymap : bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, _d3Interpolate.interpolateNumber))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, _numberJsDefault.default)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, _d3Interpolate.interpolateRound), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : identity, rescale()) : clamp !== identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function continuous() {
    return transformer()(identity, identity);
}

},{"d3-array":[["bisect","80NTU","default"]],"d3-interpolate":[["interpolate","bQQ1J","default"],["interpolateNumber","lU4Z0","default"],["interpolateRound","aOsJ9","default"]],"./constant.js":"4keph","./number.js":"lyk5i","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"80NTU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bisectRight", ()=>bisectRight);
parcelHelpers.export(exports, "bisectLeft", ()=>bisectLeft);
parcelHelpers.export(exports, "bisectCenter", ()=>bisectCenter);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _bisectorJs = require("./bisector.js");
var _bisectorJsDefault = parcelHelpers.interopDefault(_bisectorJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
const ascendingBisect = (0, _bisectorJsDefault.default)((0, _ascendingJsDefault.default));
const bisectRight = ascendingBisect.right;
const bisectLeft = ascendingBisect.left;
const bisectCenter = (0, _bisectorJsDefault.default)((0, _numberJsDefault.default)).center;
exports.default = bisectRight;

},{"./ascending.js":"grXWP","./bisector.js":"2pLFs","./number.js":"6GQY1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"grXWP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ascending);
function ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2pLFs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bisector);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _descendingJs = require("./descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
function bisector(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = (0, _ascendingJsDefault.default);
        compare2 = (d, x)=>(0, _ascendingJsDefault.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === (0, _ascendingJsDefault.default) || f === (0, _descendingJsDefault.default) ? f : zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left,
        center,
        right
    };
}
function zero() {
    return 0;
}

},{"./ascending.js":"grXWP","./descending.js":"2Vb2b","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2Vb2b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>descending);
function descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6GQY1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>number);
parcelHelpers.export(exports, "numbers", ()=>numbers);
function number(x) {
    return x === null ? NaN : +x;
}
function* numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bQQ1J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var t = typeof b, c;
        return b == null || t === "boolean" ? (0, _constantJsDefault.default)(b) : (t === "number" ? (0, _numberJsDefault.default) : t === "string" ? (c = (0, _d3Color.color)(b)) ? (b = c, _rgbJsDefault.default) : (0, _stringJsDefault.default) : b instanceof (0, _d3Color.color) ? (0, _rgbJsDefault.default) : b instanceof Date ? (0, _dateJsDefault.default) : (0, _numberArrayJs.isNumberArray)(b) ? (0, _numberArrayJsDefault.default) : Array.isArray(b) ? (0, _arrayJs.genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, _objectJsDefault.default) : (0, _numberJsDefault.default))(a, b);
    });
var _d3Color = require("d3-color");
var _rgbJs = require("./rgb.js");
var _rgbJsDefault = parcelHelpers.interopDefault(_rgbJs);
var _arrayJs = require("./array.js");
var _dateJs = require("./date.js");
var _dateJsDefault = parcelHelpers.interopDefault(_dateJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _objectJs = require("./object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);

},{"d3-color":[["color","cZjkf","default"]],"./rgb.js":"bG7wU","./array.js":"9Rmt3","./date.js":"4wvkD","./number.js":"lU4Z0","./object.js":"csAzg","./string.js":"iNjOh","./constant.js":"lJpIo","./numberArray.js":"8eUFq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cZjkf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Color", ()=>Color);
parcelHelpers.export(exports, "darker", ()=>darker);
parcelHelpers.export(exports, "brighter", ()=>brighter);
parcelHelpers.export(exports, "default", ()=>color);
parcelHelpers.export(exports, "rgbConvert", ()=>rgbConvert);
parcelHelpers.export(exports, "rgb", ()=>rgb);
parcelHelpers.export(exports, "Rgb", ()=>Rgb);
parcelHelpers.export(exports, "hslConvert", ()=>hslConvert);
parcelHelpers.export(exports, "hsl", ()=>hsl);
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _defineJsDefault.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Rgb, rgb, (0, _defineJs.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Hsl, hsl, (0, _defineJs.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

},{"./define.js":"34Inj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"34Inj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(constructor, factory, prototype) {
        constructor.prototype = factory.prototype = prototype;
        prototype.constructor = constructor;
    });
parcelHelpers.export(exports, "extend", ()=>extend);
function extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bG7wU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rgbBasis", ()=>rgbBasis);
parcelHelpers.export(exports, "rgbBasisClosed", ()=>rgbBasisClosed);
var _d3Color = require("d3-color");
var _basisJs = require("./basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _basisClosedJs = require("./basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
exports.default = function rgbGamma(y) {
    var color = (0, _colorJs.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, _d3Color.rgb)(start)).r, (end = (0, _d3Color.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, _d3Color.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var rgbBasis = rgbSpline((0, _basisJsDefault.default));
var rgbBasisClosed = rgbSpline((0, _basisClosedJsDefault.default));

},{"d3-color":"cZjkf","./basis.js":"8v2RP","./basisClosed.js":"93ABE","./color.js":"igqbp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8v2RP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "basis", ()=>basis);
parcelHelpers.export(exports, "default", ()=>function(values) {
        var n = values.length - 1;
        return function(t) {
            var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
            return basis((t - i / n) * n, v0, v1, v2, v3);
        };
    });
function basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"93ABE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values) {
        var n = values.length;
        return function(t) {
            var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
            return (0, _basisJs.basis)((t - i / n) * n, v0, v1, v2, v3);
        };
    });
var _basisJs = require("./basis.js");

},{"./basis.js":"8v2RP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"igqbp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hue", ()=>hue);
parcelHelpers.export(exports, "gamma", ()=>gamma);
parcelHelpers.export(exports, "default", ()=>nogamma);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
function linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function hue(a, b) {
    var d = b - a;
    return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}
function gamma(y) {
    return (y = +y) === 1 ? nogamma : function(a, b) {
        return b - a ? exponential(a, b, y) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
    };
}
function nogamma(a, b) {
    var d = b - a;
    return d ? linear(a, d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}

},{"./constant.js":"lJpIo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lJpIo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>()=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9Rmt3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return ((0, _numberArrayJs.isNumberArray)(b) ? (0, _numberArrayJsDefault.default) : genericArray)(a, b);
    });
parcelHelpers.export(exports, "genericArray", ()=>genericArray);
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);
function genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, _valueJsDefault.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

},{"./value.js":"bQQ1J","./numberArray.js":"8eUFq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8eUFq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        if (!b) b = [];
        var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
        return function(t) {
            for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
            return c;
        };
    });
parcelHelpers.export(exports, "isNumberArray", ()=>isNumberArray);
function isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4wvkD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var d = new Date;
        return a = +a, b = +b, function(t) {
            return d.setTime(a * (1 - t) + b * t), d;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lU4Z0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a = +a, b = +b, function(t) {
            return a * (1 - t) + b * t;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"csAzg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var i = {}, c = {}, k;
        if (a === null || typeof a !== "object") a = {};
        if (b === null || typeof b !== "object") b = {};
        for(k in b)if (k in a) i[k] = (0, _valueJsDefault.default)(a[k], b[k]);
        else c[k] = b[k];
        return function(t) {
            for(k in i)c[k] = i[k](t);
            return c;
        };
    });
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);

},{"./value.js":"bQQ1J","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iNjOh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
        // Coerce inputs to strings.
        a = a + "", b = b + "";
        // Interpolate pairs of numbers in a & b.
        while((am = reA.exec(a)) && (bm = reB.exec(b))){
            if ((bs = bm.index) > bi) {
                bs = b.slice(bi, bs);
                if (s[i]) s[i] += bs; // coalesce with previous string
                else s[++i] = bs;
            }
            if ((am = am[0]) === (bm = bm[0])) {
                if (s[i]) s[i] += bm; // coalesce with previous string
                else s[++i] = bm;
            } else {
                s[++i] = null;
                q.push({
                    i: i,
                    x: (0, _numberJsDefault.default)(am, bm)
                });
            }
            bi = reB.lastIndex;
        }
        // Add remains of b.
        if (bi < b.length) {
            bs = b.slice(bi);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        // Special optimization for only a single match.
        // Otherwise, interpolate each of the numbers and rejoin the string.
        return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function(t) {
            for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        });
    });
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(b) {
    return function() {
        return b;
    };
}
function one(b) {
    return function(t) {
        return b(t) + "";
    };
}

},{"./number.js":"lU4Z0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aOsJ9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a = +a, b = +b, function(t) {
            return Math.round(a * (1 - t) + b * t);
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4keph":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>constants);
function constants(x) {
    return function() {
        return x;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lyk5i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>number);
function number(x) {
    return +x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k6jbH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>tickFormat);
var _d3Array = require("d3-array");
var _d3Format = require("d3-format");
function tickFormat(start, stop, count, specifier) {
    var step = (0, _d3Array.tickStep)(start, stop, count), precision;
    specifier = (0, _d3Format.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, _d3Format.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, _d3Format.format)(specifier);
}

},{"d3-array":"9j7q7","d3-format":[["format","fNAkW"],["formatPrefix","fNAkW"],["formatSpecifier","4Dwks","default"],["precisionFixed","amWFt","default"],["precisionPrefix","3cedQ","default"],["precisionRound","ay474","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fNAkW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "format", ()=>format);
parcelHelpers.export(exports, "formatPrefix", ()=>formatPrefix);
parcelHelpers.export(exports, "default", ()=>defaultLocale);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var locale;
var format;
var formatPrefix;
defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function defaultLocale(definition) {
    locale = (0, _localeJsDefault.default)(definition);
    format = locale.format;
    formatPrefix = locale.formatPrefix;
    return locale;
}

},{"./locale.js":"5rSKU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5rSKU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(locale) {
        var group = locale.grouping === undefined || locale.thousands === undefined ? (0, _identityJsDefault.default) : (0, _formatGroupJsDefault.default)(map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, _identityJsDefault.default) : (0, _formatNumeralsJsDefault.default)(map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
        function newFormat(specifier, options) {
            specifier = (0, _formatSpecifierJsDefault.default)(specifier);
            var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
            // The "n" type is an alias for ",g".
            if (type === "n") comma = true, type = "g";
            else if (!(0, _formatTypesJsDefault.default)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
            // If zero fill is specified, padding goes after sign and before digits.
            if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
            // Compute the prefix and suffix.
            // For SI-prefix, the suffix is lazily computed.
            var prefix = (options && options.prefix !== undefined ? options.prefix : "") + (symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : ""), suffix = (symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "") + (options && options.suffix !== undefined ? options.suffix : "");
            // What format function should we use?
            // Is this an integer type?
            // Can this type generate exponential notation?
            var formatType = (0, _formatTypesJsDefault.default)[type], maybeSuffix = /[defgprs%]/.test(type);
            // Set the default precision if not specified,
            // or clamp the specified precision to the supported range.
            // For significant precision, it must be in [1, 21].
            // For fixed precision, it must be in [0, 20].
            precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
            function format(value) {
                var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
                if (type === "c") {
                    valueSuffix = formatType(value) + valueSuffix;
                    value = "";
                } else {
                    value = +value;
                    // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                    var valueNegative = value < 0 || 1 / value < 0;
                    // Perform the initial formatting.
                    value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                    // Trim insignificant zeros.
                    if (trim) value = (0, _formatTrimJsDefault.default)(value);
                    // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                    if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                    // Compute the prefix and suffix.
                    valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                    valueSuffix = (type === "s" && !isNaN(value) && (0, _formatPrefixAutoJs.prefixExponent) !== undefined ? prefixes[8 + (0, _formatPrefixAutoJs.prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                    // Break the formatted value into the integer “value” part that can be
                    // grouped, and fractional or exponential “suffix” part that is not.
                    if (maybeSuffix) {
                        i = -1, n = value.length;
                        while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                            valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                            value = value.slice(0, i);
                            break;
                        }
                    }
                }
                // If the fill character is not "0", grouping is applied before padding.
                if (comma && !zero) value = group(value, Infinity);
                // Compute the padding.
                var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
                // If the fill character is "0", grouping is applied after padding.
                if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
                // Reconstruct the final output based on the desired alignment.
                switch(align){
                    case "<":
                        value = valuePrefix + value + valueSuffix + padding;
                        break;
                    case "=":
                        value = valuePrefix + padding + value + valueSuffix;
                        break;
                    case "^":
                        value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                        break;
                    default:
                        value = padding + valuePrefix + value + valueSuffix;
                        break;
                }
                return numerals(value);
            }
            format.toString = function() {
                return specifier + "";
            };
            return format;
        }
        function formatPrefix(specifier, value) {
            var e = Math.max(-8, Math.min(8, Math.floor((0, _exponentJsDefault.default)(value) / 3))) * 3, k = Math.pow(10, -e), f = newFormat((specifier = (0, _formatSpecifierJsDefault.default)(specifier), specifier.type = "f", specifier), {
                suffix: prefixes[8 + e / 3]
            });
            return function(value) {
                return f(k * value);
            };
        }
        return {
            format: newFormat,
            formatPrefix: formatPrefix
        };
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);
var _formatGroupJs = require("./formatGroup.js");
var _formatGroupJsDefault = parcelHelpers.interopDefault(_formatGroupJs);
var _formatNumeralsJs = require("./formatNumerals.js");
var _formatNumeralsJsDefault = parcelHelpers.interopDefault(_formatNumeralsJs);
var _formatSpecifierJs = require("./formatSpecifier.js");
var _formatSpecifierJsDefault = parcelHelpers.interopDefault(_formatSpecifierJs);
var _formatTrimJs = require("./formatTrim.js");
var _formatTrimJsDefault = parcelHelpers.interopDefault(_formatTrimJs);
var _formatTypesJs = require("./formatTypes.js");
var _formatTypesJsDefault = parcelHelpers.interopDefault(_formatTypesJs);
var _formatPrefixAutoJs = require("./formatPrefixAuto.js");
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var map = Array.prototype.map, prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];

},{"./exponent.js":"8V9SR","./formatGroup.js":"1TWks","./formatNumerals.js":"26t5o","./formatSpecifier.js":"4Dwks","./formatTrim.js":"k0jrv","./formatTypes.js":"eHFBL","./formatPrefixAuto.js":"6I2tL","./identity.js":"dgEFq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8V9SR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x = (0, _formatDecimalJs.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
    });
var _formatDecimalJs = require("./formatDecimal.js");

},{"./formatDecimal.js":"aVkiP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aVkiP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
    });
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
parcelHelpers.export(exports, "formatDecimalParts", ()=>formatDecimalParts);
function formatDecimalParts(x, p) {
    if (!isFinite(x) || x === 0) return null; // NaN, ±Infinity, ±0
    var i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e"), coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1TWks":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(grouping, thousands) {
        return function(value, width) {
            var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
            while(i > 0 && g > 0){
                if (length + g + 1 > width) g = Math.max(1, width - length);
                t.push(value.substring(i -= g, i + g));
                if ((length += g + 1) > width) break;
                g = grouping[j = (j + 1) % grouping.length];
            }
            return t.reverse().join(thousands);
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"26t5o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(numerals) {
        return function(value) {
            return value.replace(/[0-9]/g, function(i) {
                return numerals[+i];
            });
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4Dwks":[function(require,module,exports,__globalThis) {
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatSpecifier);
parcelHelpers.export(exports, "FormatSpecifier", ()=>FormatSpecifier);
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
    if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
function FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k0jrv":[function(require,module,exports,__globalThis) {
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(s) {
        out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
            case ".":
                i0 = i1 = i;
                break;
            case "0":
                if (i0 === 0) i0 = i;
                i1 = i;
                break;
            default:
                if (!+s[i]) break out;
                if (i0 > 0) i0 = 0;
                break;
        }
        return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eHFBL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formatDecimalJs = require("./formatDecimal.js");
var _formatDecimalJsDefault = parcelHelpers.interopDefault(_formatDecimalJs);
var _formatPrefixAutoJs = require("./formatPrefixAuto.js");
var _formatPrefixAutoJsDefault = parcelHelpers.interopDefault(_formatPrefixAutoJs);
var _formatRoundedJs = require("./formatRounded.js");
var _formatRoundedJsDefault = parcelHelpers.interopDefault(_formatRoundedJs);
exports.default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, _formatDecimalJsDefault.default),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, _formatRoundedJsDefault.default)(x * 100, p),
    "r": (0, _formatRoundedJsDefault.default),
    "s": (0, _formatPrefixAutoJsDefault.default),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};

},{"./formatDecimal.js":"aVkiP","./formatPrefixAuto.js":"6I2tL","./formatRounded.js":"g2k00","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6I2tL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prefixExponent", ()=>prefixExponent);
parcelHelpers.export(exports, "default", ()=>function(x, p) {
        var d = (0, _formatDecimalJs.formatDecimalParts)(x, p);
        if (!d) return prefixExponent = undefined, x.toPrecision(p);
        var coefficient = d[0], exponent = d[1], i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
        return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, _formatDecimalJs.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
    });
var _formatDecimalJs = require("./formatDecimal.js");
var prefixExponent;

},{"./formatDecimal.js":"aVkiP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g2k00":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, p) {
        var d = (0, _formatDecimalJs.formatDecimalParts)(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1];
        return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
    });
var _formatDecimalJs = require("./formatDecimal.js");

},{"./formatDecimal.js":"aVkiP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dgEFq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"amWFt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(step) {
        return Math.max(0, -(0, _exponentJsDefault.default)(Math.abs(step)));
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"8V9SR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3cedQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(step, value) {
        return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, _exponentJsDefault.default)(value) / 3))) * 3 - (0, _exponentJsDefault.default)(Math.abs(step)));
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"8V9SR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ay474":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(step, max) {
        step = Math.abs(step), max = Math.abs(max) - step;
        return Math.max(0, (0, _exponentJsDefault.default)(max) - (0, _exponentJsDefault.default)(step)) + 1;
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"8V9SR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"idfbA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loggish", ()=>loggish);
parcelHelpers.export(exports, "default", ()=>log);
var _d3Array = require("d3-array");
var _d3Format = require("d3-format");
var _niceJs = require("./nice.js");
var _niceJsDefault = parcelHelpers.interopDefault(_niceJs);
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
function transformLog(x) {
    return Math.log(x);
}
function transformExp(x) {
    return Math.exp(x);
}
function transformLogn(x) {
    return -Math.log(-x);
}
function transformExpn(x) {
    return -Math.exp(-x);
}
function pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function powp(base) {
    return base === 10 ? pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function reflect(f) {
    return (x, k)=>-f(-x, k);
}
function loggish(transform) {
    const scale = transform(transformLog, transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = logp(base), pows = powp(base);
        if (domain()[0] < 0) {
            logs = reflect(logs), pows = reflect(pows);
            transform(transformLogn, transformExpn);
        } else transform(transformLog, transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, _d3Array.ticks)(u, v, n);
        } else z = (0, _d3Array.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, _d3Format.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, _d3Format.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, _niceJsDefault.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function log() {
    const scale = loggish((0, _continuousJs.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, _continuousJs.copy)(scale, log()).base(scale.base());
    (0, _initJs.initRange).apply(scale, arguments);
    return scale;
}

},{"d3-array":[["ticks","9j7q7","default"]],"d3-format":[["format","fNAkW"],["formatSpecifier","4Dwks","default"]],"./nice.js":"dN8Tk","./continuous.js":"1zZMt","./init.js":"h9ql6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dN8Tk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>nice);
function nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g07CI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "symlogish", ()=>symlogish);
parcelHelpers.export(exports, "default", ()=>symlog);
var _linearJs = require("./linear.js");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
function transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function symlogish(transform) {
    var c = 1, scale = transform(transformSymlog(c), transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
    };
    return (0, _linearJs.linearish)(scale);
}
function symlog() {
    var scale = symlogish((0, _continuousJs.transformer)());
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, symlog()).constant(scale.constant());
    };
    return (0, _initJs.initRange).apply(scale, arguments);
}

},{"./linear.js":"7SztY","./continuous.js":"1zZMt","./init.js":"h9ql6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ljC55":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "powish", ()=>powish);
parcelHelpers.export(exports, "default", ()=>pow);
parcelHelpers.export(exports, "sqrt", ()=>sqrt);
var _linearJs = require("./linear.js");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
function transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function powish(transform) {
    var scale = transform((0, _continuousJs.identity), (0, _continuousJs.identity)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, _continuousJs.identity), (0, _continuousJs.identity)) : exponent === 0.5 ? transform(transformSqrt, transformSquare) : transform(transformPow(exponent), transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, _linearJs.linearish)(scale);
}
function pow() {
    var scale = powish((0, _continuousJs.transformer)());
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, pow()).exponent(scale.exponent());
    };
    (0, _initJs.initRange).apply(scale, arguments);
    return scale;
}
function sqrt() {
    return pow.apply(null, arguments).exponent(0.5);
}

},{"./linear.js":"7SztY","./continuous.js":"1zZMt","./init.js":"h9ql6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"42gCO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>radial);
var _continuousJs = require("./continuous.js");
var _continuousJsDefault = parcelHelpers.interopDefault(_continuousJs);
var _initJs = require("./init.js");
var _linearJs = require("./linear.js");
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
function square(x) {
    return Math.sign(x) * x * x;
}
function unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function radial() {
    var squared = (0, _continuousJsDefault.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert(square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, (0, _numberJsDefault.default))).map(square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    (0, _initJs.initRange).apply(scale, arguments);
    return (0, _linearJs.linearish)(scale);
}

},{"./continuous.js":"1zZMt","./init.js":"h9ql6","./linear.js":"7SztY","./number.js":"lyk5i","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jb3oU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quantile);
var _d3Array = require("d3-array");
var _initJs = require("./init.js");
function quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, _d3Array.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, _d3Array.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, _d3Array.ascending));
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return quantile().domain(domain).range(range).unknown(unknown);
    };
    return (0, _initJs.initRange).apply(scale, arguments);
}

},{"d3-array":[["ascending","grXWP","default"],["quantileSorted","tnk8R"]],"./init.js":"h9ql6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"tnk8R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quantile);
parcelHelpers.export(exports, "quantileSorted", ()=>quantileSorted);
parcelHelpers.export(exports, "quantileIndex", ()=>quantileIndex);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _maxIndexJs = require("./maxIndex.js");
var _maxIndexJsDefault = parcelHelpers.interopDefault(_maxIndexJs);
var _minJs = require("./min.js");
var _minJsDefault = parcelHelpers.interopDefault(_minJs);
var _minIndexJs = require("./minIndex.js");
var _minIndexJsDefault = parcelHelpers.interopDefault(_minIndexJs);
var _quickselectJs = require("./quickselect.js");
var _quickselectJsDefault = parcelHelpers.interopDefault(_quickselectJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _sortJs = require("./sort.js");
var _greatestJs = require("./greatest.js");
var _greatestJsDefault = parcelHelpers.interopDefault(_greatestJs);
function quantile(values, p, valueof) {
    values = Float64Array.from((0, _numberJs.numbers)(values, valueof));
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return (0, _minJsDefault.default)(values);
    if (p >= 1) return (0, _maxJsDefault.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, _maxJsDefault.default)((0, _quickselectJsDefault.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, _minJsDefault.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function quantileSorted(values, p, valueof = (0, _numberJsDefault.default)) {
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}
function quantileIndex(values, p, valueof = (0, _numberJsDefault.default)) {
    if (isNaN(p = +p)) return;
    numbers = Float64Array.from(values, (_, i)=>(0, _numberJsDefault.default)(valueof(values[i], i, values)));
    if (p <= 0) return (0, _minIndexJsDefault.default)(numbers);
    if (p >= 1) return (0, _maxIndexJsDefault.default)(numbers);
    var numbers, index = Uint32Array.from(values, (_, i)=>i), j = numbers.length - 1, i = Math.floor(j * p);
    (0, _quickselectJsDefault.default)(index, i, 0, j, (i, j)=>(0, _sortJs.ascendingDefined)(numbers[i], numbers[j]));
    i = (0, _greatestJsDefault.default)(index.subarray(0, i + 1), (i)=>numbers[i]);
    return i >= 0 ? i : -1;
}

},{"./max.js":"aVqVJ","./maxIndex.js":"4eSGa","./min.js":"76icn","./minIndex.js":"9PbIB","./quickselect.js":"dxirM","./number.js":"6GQY1","./sort.js":"3eB6g","./greatest.js":"9Y64F","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aVqVJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>max);
function max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4eSGa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>maxIndex);
function maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"76icn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>min);
function min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9PbIB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>minIndex);
function minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dxirM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quickselect);
var _sortJs = require("./sort.js");
function quickselect(array, k, left = 0, right = Infinity, compare) {
    k = Math.floor(k);
    left = Math.floor(Math.max(0, left));
    right = Math.floor(Math.min(array.length - 1, right));
    if (!(left <= k && k <= right)) return array;
    compare = compare === undefined ? (0, _sortJs.ascendingDefined) : (0, _sortJs.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        swap(array, left, k);
        if (compare(array[right], t) > 0) swap(array, left, right);
        while(i < j){
            swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) swap(array, left, j);
        else ++j, swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

},{"./sort.js":"3eB6g","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3eB6g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>sort);
parcelHelpers.export(exports, "compareDefined", ()=>compareDefined);
parcelHelpers.export(exports, "ascendingDefined", ()=>ascendingDefined);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _permuteJs = require("./permute.js");
var _permuteJsDefault = parcelHelpers.interopDefault(_permuteJs);
function sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>ascendingDefined(f[i], f[j]));
        }
        return (0, _permuteJsDefault.default)(values, index);
    }
    return values.sort(compareDefined(f));
}
function compareDefined(compare = (0, _ascendingJsDefault.default)) {
    if (compare === (0, _ascendingJsDefault.default)) return ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

},{"./ascending.js":"grXWP","./permute.js":"3Vyjb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3Vyjb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>permute);
function permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9Y64F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>greatest);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
function greatest(values, compare = (0, _ascendingJsDefault.default)) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, _ascendingJsDefault.default)(value, maxValue) > 0 : (0, _ascendingJsDefault.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

},{"./ascending.js":"grXWP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4DTyJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quantize);
var _d3Array = require("d3-array");
var _linearJs = require("./linear.js");
var _initJs = require("./init.js");
function quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, _d3Array.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return (0, _initJs.initRange).apply((0, _linearJs.linearish)(scale), arguments);
}

},{"d3-array":"4pSqo","./linear.js":"7SztY","./init.js":"h9ql6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4pSqo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bisect", ()=>(0, _bisectJsDefault.default));
parcelHelpers.export(exports, "bisectRight", ()=>(0, _bisectJs.bisectRight));
parcelHelpers.export(exports, "bisectLeft", ()=>(0, _bisectJs.bisectLeft));
parcelHelpers.export(exports, "bisectCenter", ()=>(0, _bisectJs.bisectCenter));
parcelHelpers.export(exports, "ascending", ()=>(0, _ascendingJsDefault.default));
parcelHelpers.export(exports, "bisector", ()=>(0, _bisectorJsDefault.default));
parcelHelpers.export(exports, "blur", ()=>(0, _blurJs.blur));
parcelHelpers.export(exports, "blur2", ()=>(0, _blurJs.blur2));
parcelHelpers.export(exports, "blurImage", ()=>(0, _blurJs.blurImage));
parcelHelpers.export(exports, "count", ()=>(0, _countJsDefault.default));
parcelHelpers.export(exports, "cross", ()=>(0, _crossJsDefault.default));
parcelHelpers.export(exports, "cumsum", ()=>(0, _cumsumJsDefault.default));
parcelHelpers.export(exports, "descending", ()=>(0, _descendingJsDefault.default));
parcelHelpers.export(exports, "deviation", ()=>(0, _deviationJsDefault.default));
parcelHelpers.export(exports, "extent", ()=>(0, _extentJsDefault.default));
parcelHelpers.export(exports, "Adder", ()=>(0, _fsumJs.Adder));
parcelHelpers.export(exports, "fsum", ()=>(0, _fsumJs.fsum));
parcelHelpers.export(exports, "fcumsum", ()=>(0, _fsumJs.fcumsum));
parcelHelpers.export(exports, "group", ()=>(0, _groupJsDefault.default));
parcelHelpers.export(exports, "flatGroup", ()=>(0, _groupJs.flatGroup));
parcelHelpers.export(exports, "flatRollup", ()=>(0, _groupJs.flatRollup));
parcelHelpers.export(exports, "groups", ()=>(0, _groupJs.groups));
parcelHelpers.export(exports, "index", ()=>(0, _groupJs.index));
parcelHelpers.export(exports, "indexes", ()=>(0, _groupJs.indexes));
parcelHelpers.export(exports, "rollup", ()=>(0, _groupJs.rollup));
parcelHelpers.export(exports, "rollups", ()=>(0, _groupJs.rollups));
parcelHelpers.export(exports, "groupSort", ()=>(0, _groupSortJsDefault.default));
parcelHelpers.export(exports, "bin", ()=>(0, _binJsDefault.default)) // Deprecated; use bin.
;
parcelHelpers.export(exports, "histogram", ()=>(0, _binJsDefault.default));
parcelHelpers.export(exports, "thresholdFreedmanDiaconis", ()=>(0, _freedmanDiaconisJsDefault.default));
parcelHelpers.export(exports, "thresholdScott", ()=>(0, _scottJsDefault.default));
parcelHelpers.export(exports, "thresholdSturges", ()=>(0, _sturgesJsDefault.default));
parcelHelpers.export(exports, "max", ()=>(0, _maxJsDefault.default));
parcelHelpers.export(exports, "maxIndex", ()=>(0, _maxIndexJsDefault.default));
parcelHelpers.export(exports, "mean", ()=>(0, _meanJsDefault.default));
parcelHelpers.export(exports, "median", ()=>(0, _medianJsDefault.default));
parcelHelpers.export(exports, "medianIndex", ()=>(0, _medianJs.medianIndex));
parcelHelpers.export(exports, "merge", ()=>(0, _mergeJsDefault.default));
parcelHelpers.export(exports, "min", ()=>(0, _minJsDefault.default));
parcelHelpers.export(exports, "minIndex", ()=>(0, _minIndexJsDefault.default));
parcelHelpers.export(exports, "mode", ()=>(0, _modeJsDefault.default));
parcelHelpers.export(exports, "nice", ()=>(0, _niceJsDefault.default));
parcelHelpers.export(exports, "pairs", ()=>(0, _pairsJsDefault.default));
parcelHelpers.export(exports, "permute", ()=>(0, _permuteJsDefault.default));
parcelHelpers.export(exports, "quantile", ()=>(0, _quantileJsDefault.default));
parcelHelpers.export(exports, "quantileIndex", ()=>(0, _quantileJs.quantileIndex));
parcelHelpers.export(exports, "quantileSorted", ()=>(0, _quantileJs.quantileSorted));
parcelHelpers.export(exports, "quickselect", ()=>(0, _quickselectJsDefault.default));
parcelHelpers.export(exports, "range", ()=>(0, _rangeJsDefault.default));
parcelHelpers.export(exports, "rank", ()=>(0, _rankJsDefault.default));
parcelHelpers.export(exports, "least", ()=>(0, _leastJsDefault.default));
parcelHelpers.export(exports, "leastIndex", ()=>(0, _leastIndexJsDefault.default));
parcelHelpers.export(exports, "greatest", ()=>(0, _greatestJsDefault.default));
parcelHelpers.export(exports, "greatestIndex", ()=>(0, _greatestIndexJsDefault.default));
parcelHelpers.export(exports, "scan", ()=>(0, _scanJsDefault.default)) // Deprecated; use leastIndex.
;
parcelHelpers.export(exports, "shuffle", ()=>(0, _shuffleJsDefault.default));
parcelHelpers.export(exports, "shuffler", ()=>(0, _shuffleJs.shuffler));
parcelHelpers.export(exports, "sum", ()=>(0, _sumJsDefault.default));
parcelHelpers.export(exports, "ticks", ()=>(0, _ticksJsDefault.default));
parcelHelpers.export(exports, "tickIncrement", ()=>(0, _ticksJs.tickIncrement));
parcelHelpers.export(exports, "tickStep", ()=>(0, _ticksJs.tickStep));
parcelHelpers.export(exports, "transpose", ()=>(0, _transposeJsDefault.default));
parcelHelpers.export(exports, "variance", ()=>(0, _varianceJsDefault.default));
parcelHelpers.export(exports, "zip", ()=>(0, _zipJsDefault.default));
parcelHelpers.export(exports, "every", ()=>(0, _everyJsDefault.default));
parcelHelpers.export(exports, "some", ()=>(0, _someJsDefault.default));
parcelHelpers.export(exports, "filter", ()=>(0, _filterJsDefault.default));
parcelHelpers.export(exports, "map", ()=>(0, _mapJsDefault.default));
parcelHelpers.export(exports, "reduce", ()=>(0, _reduceJsDefault.default));
parcelHelpers.export(exports, "reverse", ()=>(0, _reverseJsDefault.default));
parcelHelpers.export(exports, "sort", ()=>(0, _sortJsDefault.default));
parcelHelpers.export(exports, "difference", ()=>(0, _differenceJsDefault.default));
parcelHelpers.export(exports, "disjoint", ()=>(0, _disjointJsDefault.default));
parcelHelpers.export(exports, "intersection", ()=>(0, _intersectionJsDefault.default));
parcelHelpers.export(exports, "subset", ()=>(0, _subsetJsDefault.default));
parcelHelpers.export(exports, "superset", ()=>(0, _supersetJsDefault.default));
parcelHelpers.export(exports, "union", ()=>(0, _unionJsDefault.default));
parcelHelpers.export(exports, "InternMap", ()=>(0, _internmap.InternMap));
parcelHelpers.export(exports, "InternSet", ()=>(0, _internmap.InternSet));
var _bisectJs = require("./bisect.js");
var _bisectJsDefault = parcelHelpers.interopDefault(_bisectJs);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _bisectorJs = require("./bisector.js");
var _bisectorJsDefault = parcelHelpers.interopDefault(_bisectorJs);
var _blurJs = require("./blur.js");
var _countJs = require("./count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
var _crossJs = require("./cross.js");
var _crossJsDefault = parcelHelpers.interopDefault(_crossJs);
var _cumsumJs = require("./cumsum.js");
var _cumsumJsDefault = parcelHelpers.interopDefault(_cumsumJs);
var _descendingJs = require("./descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
var _deviationJs = require("./deviation.js");
var _deviationJsDefault = parcelHelpers.interopDefault(_deviationJs);
var _extentJs = require("./extent.js");
var _extentJsDefault = parcelHelpers.interopDefault(_extentJs);
var _fsumJs = require("./fsum.js");
var _groupJs = require("./group.js");
var _groupJsDefault = parcelHelpers.interopDefault(_groupJs);
var _groupSortJs = require("./groupSort.js");
var _groupSortJsDefault = parcelHelpers.interopDefault(_groupSortJs);
var _binJs = require("./bin.js");
var _binJsDefault = parcelHelpers.interopDefault(_binJs);
var _freedmanDiaconisJs = require("./threshold/freedmanDiaconis.js");
var _freedmanDiaconisJsDefault = parcelHelpers.interopDefault(_freedmanDiaconisJs);
var _scottJs = require("./threshold/scott.js");
var _scottJsDefault = parcelHelpers.interopDefault(_scottJs);
var _sturgesJs = require("./threshold/sturges.js");
var _sturgesJsDefault = parcelHelpers.interopDefault(_sturgesJs);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _maxIndexJs = require("./maxIndex.js");
var _maxIndexJsDefault = parcelHelpers.interopDefault(_maxIndexJs);
var _meanJs = require("./mean.js");
var _meanJsDefault = parcelHelpers.interopDefault(_meanJs);
var _medianJs = require("./median.js");
var _medianJsDefault = parcelHelpers.interopDefault(_medianJs);
var _mergeJs = require("./merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _minJs = require("./min.js");
var _minJsDefault = parcelHelpers.interopDefault(_minJs);
var _minIndexJs = require("./minIndex.js");
var _minIndexJsDefault = parcelHelpers.interopDefault(_minIndexJs);
var _modeJs = require("./mode.js");
var _modeJsDefault = parcelHelpers.interopDefault(_modeJs);
var _niceJs = require("./nice.js");
var _niceJsDefault = parcelHelpers.interopDefault(_niceJs);
var _pairsJs = require("./pairs.js");
var _pairsJsDefault = parcelHelpers.interopDefault(_pairsJs);
var _permuteJs = require("./permute.js");
var _permuteJsDefault = parcelHelpers.interopDefault(_permuteJs);
var _quantileJs = require("./quantile.js");
var _quantileJsDefault = parcelHelpers.interopDefault(_quantileJs);
var _quickselectJs = require("./quickselect.js");
var _quickselectJsDefault = parcelHelpers.interopDefault(_quickselectJs);
var _rangeJs = require("./range.js");
var _rangeJsDefault = parcelHelpers.interopDefault(_rangeJs);
var _rankJs = require("./rank.js");
var _rankJsDefault = parcelHelpers.interopDefault(_rankJs);
var _leastJs = require("./least.js");
var _leastJsDefault = parcelHelpers.interopDefault(_leastJs);
var _leastIndexJs = require("./leastIndex.js");
var _leastIndexJsDefault = parcelHelpers.interopDefault(_leastIndexJs);
var _greatestJs = require("./greatest.js");
var _greatestJsDefault = parcelHelpers.interopDefault(_greatestJs);
var _greatestIndexJs = require("./greatestIndex.js");
var _greatestIndexJsDefault = parcelHelpers.interopDefault(_greatestIndexJs);
var _scanJs = require("./scan.js");
var _scanJsDefault = parcelHelpers.interopDefault(_scanJs);
var _shuffleJs = require("./shuffle.js");
var _shuffleJsDefault = parcelHelpers.interopDefault(_shuffleJs);
var _sumJs = require("./sum.js");
var _sumJsDefault = parcelHelpers.interopDefault(_sumJs);
var _ticksJs = require("./ticks.js");
var _ticksJsDefault = parcelHelpers.interopDefault(_ticksJs);
var _transposeJs = require("./transpose.js");
var _transposeJsDefault = parcelHelpers.interopDefault(_transposeJs);
var _varianceJs = require("./variance.js");
var _varianceJsDefault = parcelHelpers.interopDefault(_varianceJs);
var _zipJs = require("./zip.js");
var _zipJsDefault = parcelHelpers.interopDefault(_zipJs);
var _everyJs = require("./every.js");
var _everyJsDefault = parcelHelpers.interopDefault(_everyJs);
var _someJs = require("./some.js");
var _someJsDefault = parcelHelpers.interopDefault(_someJs);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _reverseJs = require("./reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
var _differenceJs = require("./difference.js");
var _differenceJsDefault = parcelHelpers.interopDefault(_differenceJs);
var _disjointJs = require("./disjoint.js");
var _disjointJsDefault = parcelHelpers.interopDefault(_disjointJs);
var _intersectionJs = require("./intersection.js");
var _intersectionJsDefault = parcelHelpers.interopDefault(_intersectionJs);
var _subsetJs = require("./subset.js");
var _subsetJsDefault = parcelHelpers.interopDefault(_subsetJs);
var _supersetJs = require("./superset.js");
var _supersetJsDefault = parcelHelpers.interopDefault(_supersetJs);
var _unionJs = require("./union.js");
var _unionJsDefault = parcelHelpers.interopDefault(_unionJs);
var _internmap = require("internmap");

},{"./bisect.js":"80NTU","./ascending.js":"grXWP","./bisector.js":"2pLFs","./blur.js":"9jCwi","./count.js":"agXtf","./cross.js":"8IaWn","./cumsum.js":"lOdNE","./descending.js":"2Vb2b","./deviation.js":"bPVzr","./extent.js":"brRYD","./fsum.js":"2G8br","./group.js":"eL2qj","./groupSort.js":"4fyHL","./bin.js":"fSROM","./threshold/freedmanDiaconis.js":"5695x","./threshold/scott.js":"gaOXY","./threshold/sturges.js":"e0V2b","./max.js":"aVqVJ","./maxIndex.js":"4eSGa","./mean.js":"gXbZT","./median.js":"dqpfK","./merge.js":"fe3e6","./min.js":"76icn","./minIndex.js":"9PbIB","./mode.js":"bwUgW","./nice.js":"kOVv9","./pairs.js":"bugvm","./permute.js":"3Vyjb","./quantile.js":"tnk8R","./quickselect.js":"dxirM","./range.js":"fkSdr","./rank.js":"8xCIw","./least.js":"bnIXz","./leastIndex.js":"iCueW","./greatest.js":"9Y64F","./greatestIndex.js":"jmfa3","./scan.js":"7QZf1","./shuffle.js":"itv30","./sum.js":"ktqNc","./ticks.js":"9j7q7","./transpose.js":"am3vK","./variance.js":"dexTn","./zip.js":"g92aw","./every.js":"drHSk","./some.js":"eSYok","./filter.js":"iXS2l","./map.js":"4slZj","./reduce.js":"hNpZ3","./reverse.js":"jBJ8J","./sort.js":"3eB6g","./difference.js":"kmDRW","./disjoint.js":"cePzP","./intersection.js":"1O8YC","./subset.js":"7OjXO","./superset.js":"eVs3r","./union.js":"92REI","internmap":"3QR3P","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9jCwi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "blur", ()=>blur);
parcelHelpers.export(exports, "blur2", ()=>blur2);
parcelHelpers.export(exports, "blurImage", ()=>blurImage);
function blur(values, r) {
    if (!((r = +r) >= 0)) throw new RangeError("invalid r");
    let length = values.length;
    if (!((length = Math.floor(length)) >= 0)) throw new RangeError("invalid length");
    if (!length || !r) return values;
    const blur = blurf(r);
    const temp = values.slice();
    blur(values, temp, 0, length, 1);
    blur(temp, values, 0, length, 1);
    blur(values, temp, 0, length, 1);
    return values;
}
const blur2 = Blur2(blurf);
const blurImage = Blur2(blurfImage);
function Blur2(blur) {
    return function(data, rx, ry = rx) {
        if (!((rx = +rx) >= 0)) throw new RangeError("invalid rx");
        if (!((ry = +ry) >= 0)) throw new RangeError("invalid ry");
        let { data: values, width, height } = data;
        if (!((width = Math.floor(width)) >= 0)) throw new RangeError("invalid width");
        if (!((height = Math.floor(height !== undefined ? height : values.length / width)) >= 0)) throw new RangeError("invalid height");
        if (!width || !height || !rx && !ry) return data;
        const blurx = rx && blur(rx);
        const blury = ry && blur(ry);
        const temp = values.slice();
        if (blurx && blury) {
            blurh(blurx, temp, values, width, height);
            blurh(blurx, values, temp, width, height);
            blurh(blurx, temp, values, width, height);
            blurv(blury, values, temp, width, height);
            blurv(blury, temp, values, width, height);
            blurv(blury, values, temp, width, height);
        } else if (blurx) {
            blurh(blurx, values, temp, width, height);
            blurh(blurx, temp, values, width, height);
            blurh(blurx, values, temp, width, height);
        } else if (blury) {
            blurv(blury, values, temp, width, height);
            blurv(blury, temp, values, width, height);
            blurv(blury, values, temp, width, height);
        }
        return data;
    };
}
function blurh(blur, T, S, w, h) {
    for(let y = 0, n = w * h; y < n;)blur(T, S, y, y += w, 1);
}
function blurv(blur, T, S, w, h) {
    for(let x = 0, n = w * h; x < w; ++x)blur(T, S, x, x + n, w);
}
function blurfImage(radius) {
    const blur = blurf(radius);
    return (T, S, start, stop, step)=>{
        start <<= 2, stop <<= 2, step <<= 2;
        blur(T, S, start + 0, stop + 0, step);
        blur(T, S, start + 1, stop + 1, step);
        blur(T, S, start + 2, stop + 2, step);
        blur(T, S, start + 3, stop + 3, step);
    };
}
// Given a target array T, a source array S, sets each value T[i] to the average
// of {S[i - r], …, S[i], …, S[i + r]}, where r = ⌊radius⌋, start <= i < stop,
// for each i, i + step, i + 2 * step, etc., and where S[j] is clamped between
// S[start] (inclusive) and S[stop] (exclusive). If the given radius is not an
// integer, S[i - r - 1] and S[i + r + 1] are added to the sum, each weighted
// according to r - ⌊radius⌋.
function blurf(radius) {
    const radius0 = Math.floor(radius);
    if (radius0 === radius) return bluri(radius);
    const t = radius - radius0;
    const w = 2 * radius + 1;
    return (T, S, start, stop, step)=>{
        if (!((stop -= step) >= start)) return; // inclusive stop
        let sum = radius0 * S[start];
        const s0 = step * radius0;
        const s1 = s0 + step;
        for(let i = start, j = start + s0; i < j; i += step)sum += S[Math.min(stop, i)];
        for(let i = start, j = stop; i <= j; i += step){
            sum += S[Math.min(stop, i + s0)];
            T[i] = (sum + t * (S[Math.max(start, i - s1)] + S[Math.min(stop, i + s1)])) / w;
            sum -= S[Math.max(start, i - s0)];
        }
    };
}
// Like blurf, but optimized for integer radius.
function bluri(radius) {
    const w = 2 * radius + 1;
    return (T, S, start, stop, step)=>{
        if (!((stop -= step) >= start)) return; // inclusive stop
        let sum = radius * S[start];
        const s = step * radius;
        for(let i = start, j = start + s; i < j; i += step)sum += S[Math.min(stop, i)];
        for(let i = start, j = stop; i <= j; i += step){
            sum += S[Math.min(stop, i + s)];
            T[i] = sum / w;
            sum -= S[Math.max(start, i - s)];
        }
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"agXtf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>count);
function count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8IaWn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cross);
function length(array) {
    return array.length | 0;
}
function empty(length) {
    return !(length > 0);
}
function arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function reducer(reduce) {
    return (values)=>reduce(...values);
}
function cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && reducer(values.pop());
    values = values.map(arrayify);
    const lengths = values.map(length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some(empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lOdNE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cumsum);
function cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bPVzr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>deviation);
var _varianceJs = require("./variance.js");
var _varianceJsDefault = parcelHelpers.interopDefault(_varianceJs);
function deviation(values, valueof) {
    const v = (0, _varianceJsDefault.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

},{"./variance.js":"dexTn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dexTn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>variance);
function variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"brRYD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>extent);
function extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2G8br":[function(require,module,exports,__globalThis) {
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Adder", ()=>Adder);
parcelHelpers.export(exports, "fsum", ()=>fsum);
parcelHelpers.export(exports, "fcumsum", ()=>fcumsum);
class Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
function fsum(values, valueof) {
    const adder = new Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function fcumsum(values, valueof) {
    const adder = new Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eL2qj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>group);
parcelHelpers.export(exports, "groups", ()=>groups);
parcelHelpers.export(exports, "flatGroup", ()=>flatGroup);
parcelHelpers.export(exports, "flatRollup", ()=>flatRollup);
parcelHelpers.export(exports, "rollup", ()=>rollup);
parcelHelpers.export(exports, "rollups", ()=>rollups);
parcelHelpers.export(exports, "index", ()=>index);
parcelHelpers.export(exports, "indexes", ()=>indexes);
var _internmap = require("internmap");
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
function group(values, ...keys) {
    return nest(values, (0, _identityJsDefault.default), (0, _identityJsDefault.default), keys);
}
function groups(values, ...keys) {
    return nest(values, Array.from, (0, _identityJsDefault.default), keys);
}
function flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function flatGroup(values, ...keys) {
    return flatten(groups(values, ...keys), keys);
}
function flatRollup(values, reduce, ...keys) {
    return flatten(rollups(values, reduce, ...keys), keys);
}
function rollup(values, reduce, ...keys) {
    return nest(values, (0, _identityJsDefault.default), reduce, keys);
}
function rollups(values, reduce, ...keys) {
    return nest(values, Array.from, reduce, keys);
}
function index(values, ...keys) {
    return nest(values, (0, _identityJsDefault.default), unique, keys);
}
function indexes(values, ...keys) {
    return nest(values, Array.from, unique, keys);
}
function unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new (0, _internmap.InternMap)();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

},{"internmap":"3QR3P","./identity.js":"cehw1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cehw1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>identity);
function identity(x) {
    return x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4fyHL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>groupSort);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _groupJs = require("./group.js");
var _groupJsDefault = parcelHelpers.interopDefault(_groupJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
function groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, _sortJsDefault.default)((0, _groupJs.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, _ascendingJsDefault.default)(av, bv) || (0, _ascendingJsDefault.default)(ak, bk)) : (0, _sortJsDefault.default)((0, _groupJsDefault.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, _ascendingJsDefault.default)(ak, bk))).map(([key])=>key);
}

},{"./ascending.js":"grXWP","./group.js":"eL2qj","./sort.js":"3eB6g","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fSROM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bin);
var _arrayJs = require("./array.js");
var _bisectJs = require("./bisect.js");
var _bisectJsDefault = parcelHelpers.interopDefault(_bisectJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _extentJs = require("./extent.js");
var _extentJsDefault = parcelHelpers.interopDefault(_extentJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _niceJs = require("./nice.js");
var _niceJsDefault = parcelHelpers.interopDefault(_niceJs);
var _ticksJs = require("./ticks.js");
var _ticksJsDefault = parcelHelpers.interopDefault(_ticksJs);
var _sturgesJs = require("./threshold/sturges.js");
var _sturgesJsDefault = parcelHelpers.interopDefault(_sturgesJs);
function bin() {
    var value = (0, _identityJsDefault.default), domain = (0, _extentJsDefault.default), threshold = (0, _sturgesJsDefault.default);
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
        // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === (0, _extentJsDefault.default)) [x0, x1] = (0, _niceJsDefault.default)(x0, x1, tn);
            tz = (0, _ticksJsDefault.default)(x0, x1, tn);
            // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, _ticksJs.tickIncrement)(x0, x1, tn);
            // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === (0, _extentJsDefault.default)) {
                    const step = (0, _ticksJs.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        }
        // Remove any thresholds outside the domain.
        // Be careful not to mutate an array owned by the user!
        var m = tz.length, a = 0, b = m;
        while(tz[a] <= x0)++a;
        while(tz[b - 1] > x1)--b;
        if (a || b < m) tz = tz.slice(a, b), m = b - a;
        var bins = new Array(m + 1), bin;
        // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        }
        // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, _bisectJsDefault.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, _constantJsDefault.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(Array.isArray(_) ? (0, _arrayJs.slice).call(_) : _), histogram) : threshold;
    };
    return histogram;
}

},{"./array.js":"3TdMz","./bisect.js":"80NTU","./constant.js":"lBtZM","./extent.js":"brRYD","./identity.js":"cehw1","./nice.js":"kOVv9","./ticks.js":"9j7q7","./threshold/sturges.js":"e0V2b","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3TdMz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", ()=>slice);
parcelHelpers.export(exports, "map", ()=>map);
var array = Array.prototype;
var slice = array.slice;
var map = array.map;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lBtZM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>constant);
function constant(x) {
    return ()=>x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kOVv9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>nice);
var _ticksJs = require("./ticks.js");
function nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, _ticksJs.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

},{"./ticks.js":"9j7q7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e0V2b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>thresholdSturges);
var _countJs = require("../count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
function thresholdSturges(values) {
    return Math.max(1, Math.ceil(Math.log((0, _countJsDefault.default)(values)) / Math.LN2) + 1);
}

},{"../count.js":"agXtf","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5695x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>thresholdFreedmanDiaconis);
var _countJs = require("../count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
var _quantileJs = require("../quantile.js");
var _quantileJsDefault = parcelHelpers.interopDefault(_quantileJs);
function thresholdFreedmanDiaconis(values, min, max) {
    const c = (0, _countJsDefault.default)(values), d = (0, _quantileJsDefault.default)(values, 0.75) - (0, _quantileJsDefault.default)(values, 0.25);
    return c && d ? Math.ceil((max - min) / (2 * d * Math.pow(c, -1 / 3))) : 1;
}

},{"../count.js":"agXtf","../quantile.js":"tnk8R","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gaOXY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>thresholdScott);
var _countJs = require("../count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
var _deviationJs = require("../deviation.js");
var _deviationJsDefault = parcelHelpers.interopDefault(_deviationJs);
function thresholdScott(values, min, max) {
    const c = (0, _countJsDefault.default)(values), d = (0, _deviationJsDefault.default)(values);
    return c && d ? Math.ceil((max - min) * Math.cbrt(c) / (3.49 * d)) : 1;
}

},{"../count.js":"agXtf","../deviation.js":"bPVzr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gXbZT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mean);
function mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dqpfK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>median);
parcelHelpers.export(exports, "medianIndex", ()=>medianIndex);
var _quantileJs = require("./quantile.js");
var _quantileJsDefault = parcelHelpers.interopDefault(_quantileJs);
function median(values, valueof) {
    return (0, _quantileJsDefault.default)(values, 0.5, valueof);
}
function medianIndex(values, valueof) {
    return (0, _quantileJs.quantileIndex)(values, 0.5, valueof);
}

},{"./quantile.js":"tnk8R","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fe3e6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>merge);
function* flatten(arrays) {
    for (const array of arrays)yield* array;
}
function merge(arrays) {
    return Array.from(flatten(arrays));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bwUgW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mode);
var _internmap = require("internmap");
function mode(values, valueof) {
    const counts = new (0, _internmap.InternMap)();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

},{"internmap":"3QR3P","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bugvm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>pairs);
parcelHelpers.export(exports, "pair", ()=>pair);
function pairs(values, pairof = pair) {
    const pairs1 = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs1.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs1;
}
function pair(a, b) {
    return [
        a,
        b
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8xCIw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rank);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _sortJs = require("./sort.js");
function rank(values, valueof = (0, _ascendingJsDefault.default)) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = (0, _ascendingJsDefault.default);
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    values = Uint32Array.from(V, (_, i)=>i);
    // Risky chaining due to Safari 14 https://github.com/d3/d3-array/issues/123
    values.sort(valueof === (0, _ascendingJsDefault.default) ? (i, j)=>(0, _sortJs.ascendingDefined)(V[i], V[j]) : (0, _sortJs.compareDefined)(compareIndex));
    values.forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

},{"./ascending.js":"grXWP","./sort.js":"3eB6g","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bnIXz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>least);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
function least(values, compare = (0, _ascendingJsDefault.default)) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, _ascendingJsDefault.default)(value, minValue) < 0 : (0, _ascendingJsDefault.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

},{"./ascending.js":"grXWP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iCueW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>leastIndex);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _minIndexJs = require("./minIndex.js");
var _minIndexJsDefault = parcelHelpers.interopDefault(_minIndexJs);
function leastIndex(values, compare = (0, _ascendingJsDefault.default)) {
    if (compare.length === 1) return (0, _minIndexJsDefault.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

},{"./ascending.js":"grXWP","./minIndex.js":"9PbIB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jmfa3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>greatestIndex);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _maxIndexJs = require("./maxIndex.js");
var _maxIndexJsDefault = parcelHelpers.interopDefault(_maxIndexJs);
function greatestIndex(values, compare = (0, _ascendingJsDefault.default)) {
    if (compare.length === 1) return (0, _maxIndexJsDefault.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

},{"./ascending.js":"grXWP","./maxIndex.js":"4eSGa","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7QZf1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>scan);
var _leastIndexJs = require("./leastIndex.js");
var _leastIndexJsDefault = parcelHelpers.interopDefault(_leastIndexJs);
function scan(values, compare) {
    const index = (0, _leastIndexJsDefault.default)(values, compare);
    return index < 0 ? undefined : index;
}

},{"./leastIndex.js":"iCueW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"itv30":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shuffler", ()=>shuffler);
exports.default = shuffler(Math.random);
function shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ktqNc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>sum);
function sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"am3vK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>transpose);
var _minJs = require("./min.js");
var _minJsDefault = parcelHelpers.interopDefault(_minJs);
function transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, _minJsDefault.default)(matrix, length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function length(d) {
    return d.length;
}

},{"./min.js":"76icn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g92aw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>zip);
var _transposeJs = require("./transpose.js");
var _transposeJsDefault = parcelHelpers.interopDefault(_transposeJs);
function zip() {
    return (0, _transposeJsDefault.default)(arguments);
}

},{"./transpose.js":"am3vK","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"drHSk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>every);
function every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eSYok":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>some);
function some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iXS2l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>filter);
function filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4slZj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>map);
function map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hNpZ3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>reduce);
function reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done, value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jBJ8J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>reverse);
function reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kmDRW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>difference);
var _internmap = require("internmap");
function difference(values, ...others) {
    values = new (0, _internmap.InternSet)(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

},{"internmap":"3QR3P","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cePzP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>disjoint);
var _internmap = require("internmap");
function disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new (0, _internmap.InternSet)();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value, done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

},{"internmap":"3QR3P","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1O8YC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>intersection);
var _internmap = require("internmap");
function intersection(values, ...others) {
    values = new (0, _internmap.InternSet)(values);
    others = others.map(set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function set(values) {
    return values instanceof (0, _internmap.InternSet) ? values : new (0, _internmap.InternSet)(values);
}

},{"internmap":"3QR3P","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7OjXO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subset);
var _supersetJs = require("./superset.js");
var _supersetJsDefault = parcelHelpers.interopDefault(_supersetJs);
function subset(values, other) {
    return (0, _supersetJsDefault.default)(other, values);
}

},{"./superset.js":"eVs3r","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eVs3r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>superset);
function superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value, done } = iterator.next()){
            if (done) return false;
            const ivalue = intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"92REI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>union);
var _internmap = require("internmap");
function union(...others) {
    const set = new (0, _internmap.InternSet)();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

},{"internmap":"3QR3P","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2GhxC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>threshold);
var _d3Array = require("d3-array");
var _initJs = require("./init.js");
function threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, _d3Array.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return threshold().domain(domain).range(range).unknown(unknown);
    };
    return (0, _initJs.initRange).apply(scale, arguments);
}

},{"d3-array":"4pSqo","./init.js":"h9ql6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5G37R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calendar", ()=>calendar);
parcelHelpers.export(exports, "default", ()=>time);
var _d3Time = require("d3-time");
var _d3TimeFormat = require("d3-time-format");
var _continuousJs = require("./continuous.js");
var _continuousJsDefault = parcelHelpers.interopDefault(_continuousJs);
var _initJs = require("./init.js");
var _niceJs = require("./nice.js");
var _niceJsDefault = parcelHelpers.interopDefault(_niceJs);
function date(t) {
    return new Date(t);
}
function number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, _continuousJsDefault.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, number)) : domain().map(date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, _niceJsDefault.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function time() {
    return (0, _initJs.initRange).apply(calendar((0, _d3Time.timeTicks), (0, _d3Time.timeTickInterval), (0, _d3Time.timeYear), (0, _d3Time.timeMonth), (0, _d3Time.timeWeek), (0, _d3Time.timeDay), (0, _d3Time.timeHour), (0, _d3Time.timeMinute), (0, _d3Time.timeSecond), (0, _d3TimeFormat.timeFormat)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

},{"d3-time":[["timeDay","ckWH7"],["timeHour","iD1qs"],["timeMinute","dTJQZ"],["timeMonth","84iEq"],["timeSecond","fAm1a","second"],["timeTickInterval","6WIS9"],["timeTicks","6WIS9"],["timeWeek","k6n3C","timeSunday"],["timeYear","lOZjL"]],"d3-time-format":"3sFOd","./continuous.js":"1zZMt","./init.js":"h9ql6","./nice.js":"dN8Tk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ckWH7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeDay", ()=>timeDay);
parcelHelpers.export(exports, "timeDays", ()=>timeDays);
parcelHelpers.export(exports, "utcDay", ()=>utcDay);
parcelHelpers.export(exports, "utcDays", ()=>utcDays);
parcelHelpers.export(exports, "unixDay", ()=>unixDay);
parcelHelpers.export(exports, "unixDays", ()=>unixDays);
var _intervalJs = require("./interval.js");
var _durationJs = require("./duration.js");
const timeDay = (0, _intervalJs.timeInterval)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, _durationJs.durationMinute)) / (0, _durationJs.durationDay), (date)=>date.getDate() - 1);
const timeDays = timeDay.range;
const utcDay = (0, _intervalJs.timeInterval)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationDay);
}, (date)=>{
    return date.getUTCDate() - 1;
});
const utcDays = utcDay.range;
const unixDay = (0, _intervalJs.timeInterval)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationDay);
}, (date)=>{
    return Math.floor(date / (0, _durationJs.durationDay));
});
const unixDays = unixDay.range;

},{"./interval.js":"8b01o","./duration.js":"8Rr4E","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8b01o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeInterval", ()=>timeInterval);
const t0 = new Date, t1 = new Date;
function timeInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = (date)=>{
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = (date)=>{
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = (date)=>{
        const d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = (date, step)=>{
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = (start, stop, step)=>{
        const range = [];
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        let previous;
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = (test)=>{
        return timeInterval((date)=>{
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, (date, step)=>{
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = (start, end)=>{
            t0.setTime(+start), t1.setTime(+end);
            floori(t0), floori(t1);
            return Math.floor(count(t0, t1));
        };
        interval.every = (step)=>{
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? (d)=>field(d) % step === 0 : (d)=>interval.count(0, d) % step === 0);
        };
    }
    return interval;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8Rr4E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "durationSecond", ()=>durationSecond);
parcelHelpers.export(exports, "durationMinute", ()=>durationMinute);
parcelHelpers.export(exports, "durationHour", ()=>durationHour);
parcelHelpers.export(exports, "durationDay", ()=>durationDay);
parcelHelpers.export(exports, "durationWeek", ()=>durationWeek);
parcelHelpers.export(exports, "durationMonth", ()=>durationMonth);
parcelHelpers.export(exports, "durationYear", ()=>durationYear);
const durationSecond = 1000;
const durationMinute = durationSecond * 60;
const durationHour = durationMinute * 60;
const durationDay = durationHour * 24;
const durationWeek = durationDay * 7;
const durationMonth = durationDay * 30;
const durationYear = durationDay * 365;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iD1qs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeHour", ()=>timeHour);
parcelHelpers.export(exports, "timeHours", ()=>timeHours);
parcelHelpers.export(exports, "utcHour", ()=>utcHour);
parcelHelpers.export(exports, "utcHours", ()=>utcHours);
var _intervalJs = require("./interval.js");
var _durationJs = require("./duration.js");
const timeHour = (0, _intervalJs.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, _durationJs.durationSecond) - date.getMinutes() * (0, _durationJs.durationMinute));
}, (date, step)=>{
    date.setTime(+date + step * (0, _durationJs.durationHour));
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationHour);
}, (date)=>{
    return date.getHours();
});
const timeHours = timeHour.range;
const utcHour = (0, _intervalJs.timeInterval)((date)=>{
    date.setUTCMinutes(0, 0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, _durationJs.durationHour));
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationHour);
}, (date)=>{
    return date.getUTCHours();
});
const utcHours = utcHour.range;

},{"./interval.js":"8b01o","./duration.js":"8Rr4E","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dTJQZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeMinute", ()=>timeMinute);
parcelHelpers.export(exports, "timeMinutes", ()=>timeMinutes);
parcelHelpers.export(exports, "utcMinute", ()=>utcMinute);
parcelHelpers.export(exports, "utcMinutes", ()=>utcMinutes);
var _intervalJs = require("./interval.js");
var _durationJs = require("./duration.js");
const timeMinute = (0, _intervalJs.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, _durationJs.durationSecond));
}, (date, step)=>{
    date.setTime(+date + step * (0, _durationJs.durationMinute));
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationMinute);
}, (date)=>{
    return date.getMinutes();
});
const timeMinutes = timeMinute.range;
const utcMinute = (0, _intervalJs.timeInterval)((date)=>{
    date.setUTCSeconds(0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, _durationJs.durationMinute));
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationMinute);
}, (date)=>{
    return date.getUTCMinutes();
});
const utcMinutes = utcMinute.range;

},{"./interval.js":"8b01o","./duration.js":"8Rr4E","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"84iEq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeMonth", ()=>timeMonth);
parcelHelpers.export(exports, "timeMonths", ()=>timeMonths);
parcelHelpers.export(exports, "utcMonth", ()=>utcMonth);
parcelHelpers.export(exports, "utcMonths", ()=>utcMonths);
var _intervalJs = require("./interval.js");
const timeMonth = (0, _intervalJs.timeInterval)((date)=>{
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setMonth(date.getMonth() + step);
}, (start, end)=>{
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, (date)=>{
    return date.getMonth();
});
const timeMonths = timeMonth.range;
const utcMonth = (0, _intervalJs.timeInterval)((date)=>{
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCMonth(date.getUTCMonth() + step);
}, (start, end)=>{
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, (date)=>{
    return date.getUTCMonth();
});
const utcMonths = utcMonth.range;

},{"./interval.js":"8b01o","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fAm1a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "second", ()=>second);
parcelHelpers.export(exports, "seconds", ()=>seconds);
var _intervalJs = require("./interval.js");
var _durationJs = require("./duration.js");
const second = (0, _intervalJs.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds());
}, (date, step)=>{
    date.setTime(+date + step * (0, _durationJs.durationSecond));
}, (start, end)=>{
    return (end - start) / (0, _durationJs.durationSecond);
}, (date)=>{
    return date.getUTCSeconds();
});
const seconds = second.range;

},{"./interval.js":"8b01o","./duration.js":"8Rr4E","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6WIS9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcTicks", ()=>utcTicks);
parcelHelpers.export(exports, "utcTickInterval", ()=>utcTickInterval);
parcelHelpers.export(exports, "timeTicks", ()=>timeTicks);
parcelHelpers.export(exports, "timeTickInterval", ()=>timeTickInterval);
var _d3Array = require("d3-array");
var _durationJs = require("./duration.js");
var _millisecondJs = require("./millisecond.js");
var _secondJs = require("./second.js");
var _minuteJs = require("./minute.js");
var _hourJs = require("./hour.js");
var _dayJs = require("./day.js");
var _weekJs = require("./week.js");
var _monthJs = require("./month.js");
var _yearJs = require("./year.js");
function ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            (0, _secondJs.second),
            1,
            (0, _durationJs.durationSecond)
        ],
        [
            (0, _secondJs.second),
            5,
            5 * (0, _durationJs.durationSecond)
        ],
        [
            (0, _secondJs.second),
            15,
            15 * (0, _durationJs.durationSecond)
        ],
        [
            (0, _secondJs.second),
            30,
            30 * (0, _durationJs.durationSecond)
        ],
        [
            minute,
            1,
            (0, _durationJs.durationMinute)
        ],
        [
            minute,
            5,
            5 * (0, _durationJs.durationMinute)
        ],
        [
            minute,
            15,
            15 * (0, _durationJs.durationMinute)
        ],
        [
            minute,
            30,
            30 * (0, _durationJs.durationMinute)
        ],
        [
            hour,
            1,
            (0, _durationJs.durationHour)
        ],
        [
            hour,
            3,
            3 * (0, _durationJs.durationHour)
        ],
        [
            hour,
            6,
            6 * (0, _durationJs.durationHour)
        ],
        [
            hour,
            12,
            12 * (0, _durationJs.durationHour)
        ],
        [
            day,
            1,
            (0, _durationJs.durationDay)
        ],
        [
            day,
            2,
            2 * (0, _durationJs.durationDay)
        ],
        [
            week,
            1,
            (0, _durationJs.durationWeek)
        ],
        [
            month,
            1,
            (0, _durationJs.durationMonth)
        ],
        [
            month,
            3,
            3 * (0, _durationJs.durationMonth)
        ],
        [
            year,
            1,
            (0, _durationJs.durationYear)
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, _d3Array.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, _d3Array.tickStep)(start / (0, _durationJs.durationYear), stop / (0, _durationJs.durationYear), count));
        if (i === 0) return (0, _millisecondJs.millisecond).every(Math.max((0, _d3Array.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [utcTicks, utcTickInterval] = ticker((0, _yearJs.utcYear), (0, _monthJs.utcMonth), (0, _weekJs.utcSunday), (0, _dayJs.unixDay), (0, _hourJs.utcHour), (0, _minuteJs.utcMinute));
const [timeTicks, timeTickInterval] = ticker((0, _yearJs.timeYear), (0, _monthJs.timeMonth), (0, _weekJs.timeSunday), (0, _dayJs.timeDay), (0, _hourJs.timeHour), (0, _minuteJs.timeMinute));

},{"d3-array":[["bisector","2pLFs","default"],["tickStep","9j7q7"]],"./duration.js":"8Rr4E","./millisecond.js":"5ZpfR","./second.js":"fAm1a","./minute.js":"dTJQZ","./hour.js":"iD1qs","./day.js":"ckWH7","./week.js":"k6n3C","./month.js":"84iEq","./year.js":"lOZjL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5ZpfR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "millisecond", ()=>millisecond);
parcelHelpers.export(exports, "milliseconds", ()=>milliseconds);
var _intervalJs = require("./interval.js");
const millisecond = (0, _intervalJs.timeInterval)(()=>{
// noop
}, (date, step)=>{
    date.setTime(+date + step);
}, (start, end)=>{
    return end - start;
});
// An optimized implementation for this simple case.
millisecond.every = (k)=>{
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return millisecond;
    return (0, _intervalJs.timeInterval)((date)=>{
        date.setTime(Math.floor(date / k) * k);
    }, (date, step)=>{
        date.setTime(+date + step * k);
    }, (start, end)=>{
        return (end - start) / k;
    });
};
const milliseconds = millisecond.range;

},{"./interval.js":"8b01o","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k6n3C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeSunday", ()=>timeSunday);
parcelHelpers.export(exports, "timeMonday", ()=>timeMonday);
parcelHelpers.export(exports, "timeTuesday", ()=>timeTuesday);
parcelHelpers.export(exports, "timeWednesday", ()=>timeWednesday);
parcelHelpers.export(exports, "timeThursday", ()=>timeThursday);
parcelHelpers.export(exports, "timeFriday", ()=>timeFriday);
parcelHelpers.export(exports, "timeSaturday", ()=>timeSaturday);
parcelHelpers.export(exports, "timeSundays", ()=>timeSundays);
parcelHelpers.export(exports, "timeMondays", ()=>timeMondays);
parcelHelpers.export(exports, "timeTuesdays", ()=>timeTuesdays);
parcelHelpers.export(exports, "timeWednesdays", ()=>timeWednesdays);
parcelHelpers.export(exports, "timeThursdays", ()=>timeThursdays);
parcelHelpers.export(exports, "timeFridays", ()=>timeFridays);
parcelHelpers.export(exports, "timeSaturdays", ()=>timeSaturdays);
parcelHelpers.export(exports, "utcSunday", ()=>utcSunday);
parcelHelpers.export(exports, "utcMonday", ()=>utcMonday);
parcelHelpers.export(exports, "utcTuesday", ()=>utcTuesday);
parcelHelpers.export(exports, "utcWednesday", ()=>utcWednesday);
parcelHelpers.export(exports, "utcThursday", ()=>utcThursday);
parcelHelpers.export(exports, "utcFriday", ()=>utcFriday);
parcelHelpers.export(exports, "utcSaturday", ()=>utcSaturday);
parcelHelpers.export(exports, "utcSundays", ()=>utcSundays);
parcelHelpers.export(exports, "utcMondays", ()=>utcMondays);
parcelHelpers.export(exports, "utcTuesdays", ()=>utcTuesdays);
parcelHelpers.export(exports, "utcWednesdays", ()=>utcWednesdays);
parcelHelpers.export(exports, "utcThursdays", ()=>utcThursdays);
parcelHelpers.export(exports, "utcFridays", ()=>utcFridays);
parcelHelpers.export(exports, "utcSaturdays", ()=>utcSaturdays);
var _intervalJs = require("./interval.js");
var _durationJs = require("./duration.js");
function timeWeekday(i) {
    return (0, _intervalJs.timeInterval)((date)=>{
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setDate(date.getDate() + step * 7);
    }, (start, end)=>{
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, _durationJs.durationMinute)) / (0, _durationJs.durationWeek);
    });
}
const timeSunday = timeWeekday(0);
const timeMonday = timeWeekday(1);
const timeTuesday = timeWeekday(2);
const timeWednesday = timeWeekday(3);
const timeThursday = timeWeekday(4);
const timeFriday = timeWeekday(5);
const timeSaturday = timeWeekday(6);
const timeSundays = timeSunday.range;
const timeMondays = timeMonday.range;
const timeTuesdays = timeTuesday.range;
const timeWednesdays = timeWednesday.range;
const timeThursdays = timeThursday.range;
const timeFridays = timeFriday.range;
const timeSaturdays = timeSaturday.range;
function utcWeekday(i) {
    return (0, _intervalJs.timeInterval)((date)=>{
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, (start, end)=>{
        return (end - start) / (0, _durationJs.durationWeek);
    });
}
const utcSunday = utcWeekday(0);
const utcMonday = utcWeekday(1);
const utcTuesday = utcWeekday(2);
const utcWednesday = utcWeekday(3);
const utcThursday = utcWeekday(4);
const utcFriday = utcWeekday(5);
const utcSaturday = utcWeekday(6);
const utcSundays = utcSunday.range;
const utcMondays = utcMonday.range;
const utcTuesdays = utcTuesday.range;
const utcWednesdays = utcWednesday.range;
const utcThursdays = utcThursday.range;
const utcFridays = utcFriday.range;
const utcSaturdays = utcSaturday.range;

},{"./interval.js":"8b01o","./duration.js":"8Rr4E","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lOZjL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeYear", ()=>timeYear);
parcelHelpers.export(exports, "timeYears", ()=>timeYears);
parcelHelpers.export(exports, "utcYear", ()=>utcYear);
parcelHelpers.export(exports, "utcYears", ()=>utcYears);
var _intervalJs = require("./interval.js");
const timeYear = (0, _intervalJs.timeInterval)((date)=>{
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setFullYear(date.getFullYear() + step);
}, (start, end)=>{
    return end.getFullYear() - start.getFullYear();
}, (date)=>{
    return date.getFullYear();
});
// An optimized implementation for this simple case.
timeYear.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _intervalJs.timeInterval)((date)=>{
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setFullYear(date.getFullYear() + step * k);
    });
};
const timeYears = timeYear.range;
const utcYear = (0, _intervalJs.timeInterval)((date)=>{
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, (start, end)=>{
    return end.getUTCFullYear() - start.getUTCFullYear();
}, (date)=>{
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
utcYear.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _intervalJs.timeInterval)((date)=>{
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
const utcYears = utcYear.range;

},{"./interval.js":"8b01o","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3sFOd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeFormat", ()=>timeFormat);
parcelHelpers.export(exports, "timeParse", ()=>timeParse);
parcelHelpers.export(exports, "utcFormat", ()=>utcFormat);
parcelHelpers.export(exports, "utcParse", ()=>utcParse);
parcelHelpers.export(exports, "default", ()=>defaultLocale);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;
defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function defaultLocale(definition) {
    locale = (0, _localeJsDefault.default)(definition);
    timeFormat = locale.format;
    timeParse = locale.parse;
    utcFormat = locale.utcFormat;
    utcParse = locale.utcParse;
    return locale;
}

},{"./locale.js":"hYi04","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hYi04":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatLocale);
var _d3Time = require("d3-time");
function localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": formatDayOfMonth,
        "e": formatDayOfMonth,
        "f": formatMicroseconds,
        "g": formatYearISO,
        "G": formatFullYearISO,
        "H": formatHour24,
        "I": formatHour12,
        "j": formatDayOfYear,
        "L": formatMilliseconds,
        "m": formatMonthNumber,
        "M": formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatSeconds,
        "u": formatWeekdayNumberMonday,
        "U": formatWeekNumberSunday,
        "V": formatWeekNumberISO,
        "w": formatWeekdayNumberSunday,
        "W": formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatYear,
        "Y": formatFullYear,
        "Z": formatZone,
        "%": formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": formatUTCDayOfMonth,
        "e": formatUTCDayOfMonth,
        "f": formatUTCMicroseconds,
        "g": formatUTCYearISO,
        "G": formatUTCFullYearISO,
        "H": formatUTCHour24,
        "I": formatUTCHour12,
        "j": formatUTCDayOfYear,
        "L": formatUTCMilliseconds,
        "m": formatUTCMonthNumber,
        "M": formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatUTCSeconds,
        "u": formatUTCWeekdayNumberMonday,
        "U": formatUTCWeekNumberSunday,
        "V": formatUTCWeekNumberISO,
        "w": formatUTCWeekdayNumberSunday,
        "W": formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatUTCYear,
        "Y": formatUTCFullYear,
        "Z": formatUTCZone,
        "%": formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": parseDayOfMonth,
        "e": parseDayOfMonth,
        "f": parseMicroseconds,
        "g": parseYear,
        "G": parseFullYear,
        "H": parseHour24,
        "I": parseHour24,
        "j": parseDayOfYear,
        "L": parseMilliseconds,
        "m": parseMonthNumber,
        "M": parseMinutes,
        "p": parsePeriod,
        "q": parseQuarter,
        "Q": parseUnixTimestamp,
        "s": parseUnixTimestampSeconds,
        "S": parseSeconds,
        "u": parseWeekdayNumberMonday,
        "U": parseWeekNumberSunday,
        "V": parseWeekNumberISO,
        "w": parseWeekdayNumberSunday,
        "W": parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": parseYear,
        "Y": parseFullYear,
        "Z": parseZone,
        "%": parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, _d3Time.utcMonday).ceil(week) : (0, _d3Time.utcMonday)(week);
                    week = (0, _d3Time.utcDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, _d3Time.timeMonday).ceil(week) : (0, _d3Time.timeMonday)(week);
                    week = (0, _d3Time.timeDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, numberRe = /^\s*\d+/, percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
function pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function requote(s) {
    return s.replace(requoteRe, "\\$&");
}
function formatRe(names) {
    return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}
function formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function parseWeekdayNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function parseWeekdayNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberISO(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function parseFullYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function parseYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function parseQuarter(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function parseMonthNumber(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function parseDayOfMonth(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function parseDayOfYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function parseHour24(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function parseMinutes(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function parseSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function parseMilliseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function parseMicroseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function parseLiteralPercent(d, string, i) {
    var n = percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function parseUnixTimestamp(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function parseUnixTimestampSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function formatDayOfMonth(d, p) {
    return pad(d.getDate(), p, 2);
}
function formatHour24(d, p) {
    return pad(d.getHours(), p, 2);
}
function formatHour12(d, p) {
    return pad(d.getHours() % 12 || 12, p, 2);
}
function formatDayOfYear(d, p) {
    return pad(1 + (0, _d3Time.timeDay).count((0, _d3Time.timeYear)(d), d), p, 3);
}
function formatMilliseconds(d, p) {
    return pad(d.getMilliseconds(), p, 3);
}
function formatMicroseconds(d, p) {
    return formatMilliseconds(d, p) + "000";
}
function formatMonthNumber(d, p) {
    return pad(d.getMonth() + 1, p, 2);
}
function formatMinutes(d, p) {
    return pad(d.getMinutes(), p, 2);
}
function formatSeconds(d, p) {
    return pad(d.getSeconds(), p, 2);
}
function formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function formatWeekNumberSunday(d, p) {
    return pad((0, _d3Time.timeSunday).count((0, _d3Time.timeYear)(d) - 1, d), p, 2);
}
function dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, _d3Time.timeThursday)(d) : (0, _d3Time.timeThursday).ceil(d);
}
function formatWeekNumberISO(d, p) {
    d = dISO(d);
    return pad((0, _d3Time.timeThursday).count((0, _d3Time.timeYear)(d), d) + ((0, _d3Time.timeYear)(d).getDay() === 4), p, 2);
}
function formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function formatWeekNumberMonday(d, p) {
    return pad((0, _d3Time.timeMonday).count((0, _d3Time.timeYear)(d) - 1, d), p, 2);
}
function formatYear(d, p) {
    return pad(d.getFullYear() % 100, p, 2);
}
function formatYearISO(d, p) {
    d = dISO(d);
    return pad(d.getFullYear() % 100, p, 2);
}
function formatFullYear(d, p) {
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, _d3Time.timeThursday)(d) : (0, _d3Time.timeThursday).ceil(d);
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
}
function formatUTCDayOfMonth(d, p) {
    return pad(d.getUTCDate(), p, 2);
}
function formatUTCHour24(d, p) {
    return pad(d.getUTCHours(), p, 2);
}
function formatUTCHour12(d, p) {
    return pad(d.getUTCHours() % 12 || 12, p, 2);
}
function formatUTCDayOfYear(d, p) {
    return pad(1 + (0, _d3Time.utcDay).count((0, _d3Time.utcYear)(d), d), p, 3);
}
function formatUTCMilliseconds(d, p) {
    return pad(d.getUTCMilliseconds(), p, 3);
}
function formatUTCMicroseconds(d, p) {
    return formatUTCMilliseconds(d, p) + "000";
}
function formatUTCMonthNumber(d, p) {
    return pad(d.getUTCMonth() + 1, p, 2);
}
function formatUTCMinutes(d, p) {
    return pad(d.getUTCMinutes(), p, 2);
}
function formatUTCSeconds(d, p) {
    return pad(d.getUTCSeconds(), p, 2);
}
function formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function formatUTCWeekNumberSunday(d, p) {
    return pad((0, _d3Time.utcSunday).count((0, _d3Time.utcYear)(d) - 1, d), p, 2);
}
function UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, _d3Time.utcThursday)(d) : (0, _d3Time.utcThursday).ceil(d);
}
function formatUTCWeekNumberISO(d, p) {
    d = UTCdISO(d);
    return pad((0, _d3Time.utcThursday).count((0, _d3Time.utcYear)(d), d) + ((0, _d3Time.utcYear)(d).getUTCDay() === 4), p, 2);
}
function formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function formatUTCWeekNumberMonday(d, p) {
    return pad((0, _d3Time.utcMonday).count((0, _d3Time.utcYear)(d) - 1, d), p, 2);
}
function formatUTCYear(d, p) {
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCYearISO(d, p) {
    d = UTCdISO(d);
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCFullYear(d, p) {
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, _d3Time.utcThursday)(d) : (0, _d3Time.utcThursday).ceil(d);
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCZone() {
    return "+0000";
}
function formatLiteralPercent() {
    return "%";
}
function formatUnixTimestamp(d) {
    return +d;
}
function formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

},{"d3-time":[["timeDay","ckWH7"],["utcDay","ckWH7"],["timeMonday","k6n3C"],["timeSunday","k6n3C"],["timeThursday","k6n3C"],["utcMonday","k6n3C"],["utcSunday","k6n3C"],["utcThursday","k6n3C"],["timeYear","lOZjL"],["utcYear","lOZjL"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9Mols":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>utcTime);
var _d3Time = require("d3-time");
var _d3TimeFormat = require("d3-time-format");
var _timeJs = require("./time.js");
var _initJs = require("./init.js");
function utcTime() {
    return (0, _initJs.initRange).apply((0, _timeJs.calendar)((0, _d3Time.utcTicks), (0, _d3Time.utcTickInterval), (0, _d3Time.utcYear), (0, _d3Time.utcMonth), (0, _d3Time.utcWeek), (0, _d3Time.utcDay), (0, _d3Time.utcHour), (0, _d3Time.utcMinute), (0, _d3Time.utcSecond), (0, _d3TimeFormat.utcFormat)).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

},{"d3-time":[["utcDay","ckWH7"],["utcHour","iD1qs"],["utcMinute","dTJQZ"],["utcMonth","84iEq"],["utcSecond","fAm1a","second"],["utcTickInterval","6WIS9"],["utcTicks","6WIS9"],["utcWeek","k6n3C","utcSunday"],["utcYear","lOZjL"]],"d3-time-format":"3sFOd","./time.js":"5G37R","./init.js":"h9ql6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2SIjS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "copy", ()=>copy);
parcelHelpers.export(exports, "default", ()=>sequential);
parcelHelpers.export(exports, "sequentialLog", ()=>sequentialLog);
parcelHelpers.export(exports, "sequentialSymlog", ()=>sequentialSymlog);
parcelHelpers.export(exports, "sequentialPow", ()=>sequentialPow);
parcelHelpers.export(exports, "sequentialSqrt", ()=>sequentialSqrt);
var _d3Interpolate = require("d3-interpolate");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
var _linearJs = require("./linear.js");
var _logJs = require("./log.js");
var _symlogJs = require("./symlog.js");
var _powJs = require("./pow.js");
function transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, _continuousJs.identity), clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, _d3Interpolate.interpolate));
    scale.rangeRound = range((0, _d3Interpolate.interpolateRound));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function sequential() {
    var scale = (0, _linearJs.linearish)(transformer()((0, _continuousJs.identity)));
    scale.copy = function() {
        return copy(scale, sequential());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function sequentialLog() {
    var scale = (0, _logJs.loggish)(transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return copy(scale, sequentialLog()).base(scale.base());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function sequentialSymlog() {
    var scale = (0, _symlogJs.symlogish)(transformer());
    scale.copy = function() {
        return copy(scale, sequentialSymlog()).constant(scale.constant());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function sequentialPow() {
    var scale = (0, _powJs.powish)(transformer());
    scale.copy = function() {
        return copy(scale, sequentialPow()).exponent(scale.exponent());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function sequentialSqrt() {
    return sequentialPow.apply(null, arguments).exponent(0.5);
}

},{"d3-interpolate":[["interpolate","bQQ1J","default"],["interpolateRound","aOsJ9","default"]],"./continuous.js":"1zZMt","./init.js":"h9ql6","./linear.js":"7SztY","./log.js":"idfbA","./symlog.js":"g07CI","./pow.js":"ljC55","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4bzQH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>sequentialQuantile);
var _d3Array = require("d3-array");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
function sequentialQuantile() {
    var domain = [], interpolator = (0, _continuousJs.identity);
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, _d3Array.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, _d3Array.ascending));
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, _d3Array.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return sequentialQuantile(interpolator).domain(domain);
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}

},{"d3-array":[["ascending","grXWP","default"],["bisect","80NTU","default"],["quantile","tnk8R","default"]],"./continuous.js":"1zZMt","./init.js":"h9ql6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ecRvG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>diverging);
parcelHelpers.export(exports, "divergingLog", ()=>divergingLog);
parcelHelpers.export(exports, "divergingSymlog", ()=>divergingSymlog);
parcelHelpers.export(exports, "divergingPow", ()=>divergingPow);
parcelHelpers.export(exports, "divergingSqrt", ()=>divergingSqrt);
var _d3Interpolate = require("d3-interpolate");
var _continuousJs = require("./continuous.js");
var _initJs = require("./init.js");
var _linearJs = require("./linear.js");
var _logJs = require("./log.js");
var _sequentialJs = require("./sequential.js");
var _symlogJs = require("./symlog.js");
var _powJs = require("./pow.js");
function transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = (0, _continuousJs.identity), transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, _d3Interpolate.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, _d3Interpolate.interpolate));
    scale.rangeRound = range((0, _d3Interpolate.interpolateRound));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function diverging() {
    var scale = (0, _linearJs.linearish)(transformer()((0, _continuousJs.identity)));
    scale.copy = function() {
        return (0, _sequentialJs.copy)(scale, diverging());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function divergingLog() {
    var scale = (0, _logJs.loggish)(transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, _sequentialJs.copy)(scale, divergingLog()).base(scale.base());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function divergingSymlog() {
    var scale = (0, _symlogJs.symlogish)(transformer());
    scale.copy = function() {
        return (0, _sequentialJs.copy)(scale, divergingSymlog()).constant(scale.constant());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function divergingPow() {
    var scale = (0, _powJs.powish)(transformer());
    scale.copy = function() {
        return (0, _sequentialJs.copy)(scale, divergingPow()).exponent(scale.exponent());
    };
    return (0, _initJs.initInterpolator).apply(scale, arguments);
}
function divergingSqrt() {
    return divergingPow.apply(null, arguments).exponent(0.5);
}

},{"d3-interpolate":[["interpolate","bQQ1J","default"],["interpolateRound","aOsJ9","default"],["piecewise","gakap","default"]],"./continuous.js":"1zZMt","./init.js":"h9ql6","./linear.js":"7SztY","./log.js":"idfbA","./sequential.js":"2SIjS","./symlog.js":"g07CI","./pow.js":"ljC55","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gakap":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>piecewise);
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
function piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = (0, _valueJsDefault.default);
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

},{"./value.js":"bQQ1J","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1X467":[function(require,module,exports,__globalThis) {
/*! @preserve
 * numeral.js
 * version : 1.5.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */ (function() {
    /************************************
        Variables
    ************************************/ var numeral, VERSION = '1.5.6', // internal storage for language config files
    languages = {}, defaults = {
        currentLanguage: 'en',
        zeroFormat: null,
        nullFormat: null,
        defaultFormat: '0,0'
    }, options = {
        currentLanguage: defaults.currentLanguage,
        zeroFormat: defaults.zeroFormat,
        nullFormat: defaults.nullFormat,
        defaultFormat: defaults.defaultFormat
    }, byteSuffixes = {
        bytes: [
            'B',
            'KB',
            'MB',
            'GB',
            'TB',
            'PB',
            'EB',
            'ZB',
            'YB'
        ],
        iec: [
            'B',
            'KiB',
            'MiB',
            'GiB',
            'TiB',
            'PiB',
            'EiB',
            'ZiB',
            'YiB'
        ]
    };
    /************************************
        Constructors
    ************************************/ // Numeral prototype object
    function Numeral(number) {
        this._value = number;
    }
    /**
     * Implementation of toFixed() that treats floats more like decimals
     *
     * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
     * problems for accounting- and finance-related software.
     */ function toFixed(value, maxDecimals, roundingFunction, optionals) {
        var splitValue = value.toString().split('.'), minDecimals = maxDecimals - (optionals || 0), boundedPrecision, optionalsRegExp, power, output;
        // Use the smallest precision value possible to avoid errors from floating point representation
        if (splitValue.length === 2) boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
        else boundedPrecision = minDecimals;
        power = Math.pow(10, boundedPrecision);
        //roundingFunction = (roundingFunction !== undefined ? roundingFunction : Math.round);
        // Multiply up by precision, round accurately, then divide and use native toFixed():
        output = (roundingFunction(value * power) / power).toFixed(boundedPrecision);
        if (optionals > maxDecimals - boundedPrecision) {
            optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
            output = output.replace(optionalsRegExp, '');
        }
        return output;
    }
    /************************************
        Formatting
    ************************************/ // determine what type of formatting we need to do
    function formatNumeral(n, format, roundingFunction) {
        var output;
        if (n._value === 0 && options.zeroFormat !== null) output = options.zeroFormat;
        else if (n._value === null && options.nullFormat !== null) output = options.nullFormat;
        else {
            // figure out what kind of format we are dealing with
            if (format.indexOf('$') > -1) output = formatCurrency(n, format, roundingFunction);
            else if (format.indexOf('%') > -1) output = formatPercentage(n, format, roundingFunction);
            else if (format.indexOf(':') > -1) output = formatTime(n, format);
            else if (format.indexOf('b') > -1 || format.indexOf('ib') > -1) output = formatBytes(n, format, roundingFunction);
            else if (format.indexOf('o') > -1) output = formatOrdinal(n, format, roundingFunction);
            else output = formatNumber(n._value, format, roundingFunction);
        }
        return output;
    }
    function formatCurrency(n, format, roundingFunction) {
        var symbolIndex = format.indexOf('$'), openParenIndex = format.indexOf('('), minusSignIndex = format.indexOf('-'), space = '', spliceIndex, output;
        // check for space before or after currency
        if (format.indexOf(' $') > -1) {
            space = ' ';
            format = format.replace(' $', '');
        } else if (format.indexOf('$ ') > -1) {
            space = ' ';
            format = format.replace('$ ', '');
        } else format = format.replace('$', '');
        // format the number
        output = formatNumber(n._value, format, roundingFunction, false);
        // position the symbol
        if (symbolIndex <= 1) {
            if (output.indexOf('(') > -1 || output.indexOf('-') > -1) {
                output = output.split('');
                spliceIndex = 1;
                if (symbolIndex < openParenIndex || symbolIndex < minusSignIndex) // the symbol appears before the "(" or "-"
                spliceIndex = 0;
                output.splice(spliceIndex, 0, languages[options.currentLanguage].currency.symbol + space);
                output = output.join('');
            } else output = languages[options.currentLanguage].currency.symbol + space + output;
        } else if (output.indexOf(')') > -1) {
            output = output.split('');
            output.splice(-1, 0, space + languages[options.currentLanguage].currency.symbol);
            output = output.join('');
        } else output = output + space + languages[options.currentLanguage].currency.symbol;
        return output;
    }
    function formatPercentage(n, format, roundingFunction) {
        var space = '', output, value = n._value * 100;
        // check for space before %
        if (format.indexOf(' %') > -1) {
            space = ' ';
            format = format.replace(' %', '');
        } else format = format.replace('%', '');
        output = formatNumber(value, format, roundingFunction);
        if (output.indexOf(')') > -1) {
            output = output.split('');
            output.splice(-1, 0, space + '%');
            output = output.join('');
        } else output = output + space + '%';
        return output;
    }
    function formatBytes(n, format, roundingFunction) {
        var output, suffixes = format.indexOf('ib') > -1 ? byteSuffixes.iec : byteSuffixes.bytes, value = n._value, suffix = '', power, min, max;
        // check for space before
        if (format.indexOf(' b') > -1 || format.indexOf(' ib') > -1) {
            suffix = ' ';
            format = format.replace(' ib', '').replace(' b', '');
        } else format = format.replace('ib', '').replace('b', '');
        for(power = 0; power <= suffixes.length; power++){
            min = Math.pow(1024, power);
            max = Math.pow(1024, power + 1);
            if (value === null || value === 0 || value >= min && value < max) {
                suffix += suffixes[power];
                if (min > 0) value = value / min;
                break;
            }
        }
        output = formatNumber(value, format, roundingFunction);
        return output + suffix;
    }
    function formatOrdinal(n, format, roundingFunction) {
        var output, ordinal = '';
        // check for space before
        if (format.indexOf(' o') > -1) {
            ordinal = ' ';
            format = format.replace(' o', '');
        } else format = format.replace('o', '');
        ordinal += languages[options.currentLanguage].ordinal(n._value);
        output = formatNumber(n._value, format, roundingFunction);
        return output + ordinal;
    }
    function formatTime(n) {
        var hours = Math.floor(n._value / 60 / 60), minutes = Math.floor((n._value - hours * 3600) / 60), seconds = Math.round(n._value - hours * 3600 - minutes * 60);
        return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
    }
    function formatNumber(value, format, roundingFunction) {
        var negP = false, signed = false, optDec = false, abbr = '', abbrK = false, abbrM = false, abbrB = false, abbrT = false, abbrForce = false, abs, min, max, power, w, precision, thousands, d = '', neg = false;
        if (value === null) value = 0;
        abs = Math.abs(value);
        // see if we should use parentheses for negative number or if we should prefix with a sign
        // if both are present we default to parentheses
        if (format.indexOf('(') > -1) {
            negP = true;
            format = format.slice(1, -1);
        } else if (format.indexOf('+') > -1) {
            signed = true;
            format = format.replace(/\+/g, '');
        }
        // see if abbreviation is wanted
        if (format.indexOf('a') > -1) {
            // check if abbreviation is specified
            abbrK = format.indexOf('aK') >= 0;
            abbrM = format.indexOf('aM') >= 0;
            abbrB = format.indexOf('aB') >= 0;
            abbrT = format.indexOf('aT') >= 0;
            abbrForce = abbrK || abbrM || abbrB || abbrT;
            // check for space before abbreviation
            if (format.indexOf(' a') > -1) abbr = ' ';
            format = format.replace(new RegExp(abbr + 'a[KMBT]?'), '');
            if (abs >= Math.pow(10, 12) && !abbrForce || abbrT) {
                // trillion
                abbr = abbr + languages[options.currentLanguage].abbreviations.trillion;
                value = value / Math.pow(10, 12);
            } else if (abs < Math.pow(10, 12) && abs >= Math.pow(10, 9) && !abbrForce || abbrB) {
                // billion
                abbr = abbr + languages[options.currentLanguage].abbreviations.billion;
                value = value / Math.pow(10, 9);
            } else if (abs < Math.pow(10, 9) && abs >= Math.pow(10, 6) && !abbrForce || abbrM) {
                // million
                abbr = abbr + languages[options.currentLanguage].abbreviations.million;
                value = value / Math.pow(10, 6);
            } else if (abs < Math.pow(10, 6) && abs >= Math.pow(10, 3) && !abbrForce || abbrK) {
                // thousand
                abbr = abbr + languages[options.currentLanguage].abbreviations.thousand;
                value = value / Math.pow(10, 3);
            }
        }
        if (format.indexOf('[.]') > -1) {
            optDec = true;
            format = format.replace('[.]', '.');
        }
        w = value.toString().split('.')[0];
        precision = format.split('.')[1];
        thousands = format.indexOf(',');
        if (precision) {
            if (precision.indexOf('[') > -1) {
                precision = precision.replace(']', '');
                precision = precision.split('[');
                d = toFixed(value, precision[0].length + precision[1].length, roundingFunction, precision[1].length);
            } else d = toFixed(value, precision.length, roundingFunction);
            w = d.split('.')[0];
            if (d.indexOf('.') > -1) d = languages[options.currentLanguage].delimiters.decimal + d.split('.')[1];
            else d = '';
            if (optDec && Number(d.slice(1)) === 0) d = '';
        } else w = toFixed(value, null, roundingFunction);
        // format number
        if (w.indexOf('-') > -1) {
            w = w.slice(1);
            neg = true;
        }
        if (thousands > -1) w = w.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + languages[options.currentLanguage].delimiters.thousands);
        if (format.indexOf('.') === 0) w = '';
        return (negP && neg ? '(' : '') + (!negP && neg ? '-' : '') + (!neg && signed ? '+' : '') + w + d + (abbr ? abbr : '') + (negP && neg ? ')' : '');
    }
    /************************************
        Unformatting
    ************************************/ // revert to number
    function unformatNumeral(n, string) {
        var stringOriginal = string, thousandRegExp, millionRegExp, billionRegExp, trillionRegExp, bytesMultiplier = false, power, value;
        if (string.indexOf(':') > -1) value = unformatTime(string);
        else if (string === options.zeroFormat || string === options.nullFormat) value = 0;
        else {
            if (languages[options.currentLanguage].delimiters.decimal !== '.') string = string.replace(/\./g, '').replace(languages[options.currentLanguage].delimiters.decimal, '.');
            // see if abbreviations are there so that we can multiply to the correct number
            thousandRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.thousand + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
            millionRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.million + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
            billionRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.billion + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
            trillionRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.trillion + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
            // see if bytes are there so that we can multiply to the correct number
            for(power = 1; power <= byteSuffixes.bytes.length; power++){
                bytesMultiplier = string.indexOf(byteSuffixes.bytes[power]) > -1 || string.indexOf(byteSuffixes.iec[power]) > -1 ? Math.pow(1024, power) : false;
                if (bytesMultiplier) break;
            }
            // do some math to create our number
            value = bytesMultiplier ? bytesMultiplier : 1;
            value *= stringOriginal.match(thousandRegExp) ? Math.pow(10, 3) : 1;
            value *= stringOriginal.match(millionRegExp) ? Math.pow(10, 6) : 1;
            value *= stringOriginal.match(billionRegExp) ? Math.pow(10, 9) : 1;
            value *= stringOriginal.match(trillionRegExp) ? Math.pow(10, 12) : 1;
            // check for percentage
            value *= string.indexOf('%') > -1 ? 0.01 : 1;
            // check for negative number
            value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;
            // remove non numbers
            value *= Number(string.replace(/[^0-9\.]+/g, ''));
            // round if we are talking about bytes
            value = bytesMultiplier ? Math.ceil(value) : value;
        }
        n._value = value;
        return n._value;
    }
    function unformatTime(string) {
        var timeArray = string.split(':'), seconds = 0;
        // turn hours and minutes into seconds and add them all up
        if (timeArray.length === 3) {
            // hours
            seconds = seconds + Number(timeArray[0]) * 3600;
            // minutes
            seconds = seconds + Number(timeArray[1]) * 60;
            // seconds
            seconds = seconds + Number(timeArray[2]);
        } else if (timeArray.length === 2) {
            // minutes
            seconds = seconds + Number(timeArray[0]) * 60;
            // seconds
            seconds = seconds + Number(timeArray[1]);
        }
        return Number(seconds);
    }
    /************************************
        Top Level Functions
    ************************************/ numeral = function(input) {
        if (numeral.isNumeral(input)) input = input.value();
        else if (input === 0 || typeof input === 'undefined') input = 0;
        else if (input === null) input = null;
        else if (!Number(input)) input = numeral.fn.unformat(input);
        else input = Number(input);
        return new Numeral(input);
    };
    // version number
    numeral.version = VERSION;
    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };
    // This function will load languages and then set the global language.  If
    // no arguments are passed in, it will simply return the current global
    // language key.
    numeral.language = function(key, values) {
        if (!key) return options.currentLanguage;
        key = key.toLowerCase();
        if (key && !values) {
            if (!languages[key]) throw new Error('Unknown language : ' + key);
            options.currentLanguage = key;
        }
        if (values || !languages[key]) loadLanguage(key, values);
        return numeral;
    };
    numeral.reset = function() {
        for(var property in defaults)options[property] = defaults[property];
    };
    // This function provides access to the loaded language data.  If
    // no arguments are passed in, it will simply return the current
    // global language object.
    numeral.languageData = function(key) {
        if (!key) return languages[options.currentLanguage];
        if (!languages[key]) throw new Error('Unknown language : ' + key);
        return languages[key];
    };
    numeral.language('en', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function(number) {
            var b = number % 10;
            return ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });
    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof format === 'string' ? format : null;
    };
    numeral.nullFormat = function(format) {
        options.nullFormat = typeof format === 'string' ? format : null;
    };
    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof format === 'string' ? format : '0.0';
    };
    numeral.validate = function(val, culture) {
        var _decimalSep, _thousandSep, _currSymbol, _valArray, _abbrObj, _thousandRegEx, languageData, temp;
        //coerce val to string
        if (typeof val !== 'string') {
            val += '';
            if (console.warn) console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
        }
        //trim whitespaces from either sides
        val = val.trim();
        //if val is just digits return true
        if (!!val.match(/^\d+$/)) return true;
        //if val is empty return false
        if (val === '') return false;
        //get the decimal and thousands separator from numeral.languageData
        try {
            //check if the culture is understood by numeral. if not, default it to current language
            languageData = numeral.languageData(culture);
        } catch (e) {
            languageData = numeral.languageData(numeral.language());
        }
        //setup the delimiters and currency symbol based on culture/language
        _currSymbol = languageData.currency.symbol;
        _abbrObj = languageData.abbreviations;
        _decimalSep = languageData.delimiters.decimal;
        if (languageData.delimiters.thousands === '.') _thousandSep = '\\.';
        else _thousandSep = languageData.delimiters.thousands;
        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) return false;
        }
        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) return false;
        }
        _thousandRegEx = new RegExp(_thousandSep + '{2}');
        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) return false;
            else {
                if (_valArray.length < 2) return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx);
                else {
                    if (_valArray[0].length === 1) return !!_valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
                    else return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
                }
            }
        }
        return false;
    };
    /************************************
        Helpers
    ************************************/ function loadLanguage(key, values) {
        languages[key] = values;
    }
    /************************************
        Floating-point helpers
    ************************************/ // The floating-point helper functions and implementation
    // borrows heavily from sinful.js: http://guipn.github.io/sinful.js/
    // Production steps of ECMA-262, Edition 5, 15.4.4.21
    // Reference: http://es5.github.io/#x15.4.4.21
    if (!Array.prototype.reduce) Array.prototype.reduce = function(callback /*, initialValue*/ ) {
        'use strict';
        if (this === null) throw new TypeError('Array.prototype.reduce called on null or undefined');
        if (typeof callback !== 'function') throw new TypeError(callback + ' is not a function');
        var t = Object(this), len = t.length >>> 0, k = 0, value;
        if (arguments.length === 2) value = arguments[1];
        else {
            while(k < len && !(k in t))k++;
            if (k >= len) throw new TypeError('Reduce of empty array with no initial value');
            value = t[k++];
        }
        for(; k < len; k++)if (k in t) value = callback(value, t[k], k, t);
        return value;
    };
    /**
     * Computes the multiplier necessary to make x >= 1,
     * effectively eliminating miscalculations caused by
     * finite precision.
     */ function multiplier(x) {
        var parts = x.toString().split('.');
        if (parts.length < 2) return 1;
        return Math.pow(10, parts[1].length);
    }
    /**
     * Given a variable number of arguments, returns the maximum
     * multiplier that must be used to normalize an operation involving
     * all of them.
     */ function correctionFactor() {
        var args = Array.prototype.slice.call(arguments);
        return args.reduce(function(prev, next) {
            var mp = multiplier(prev), mn = multiplier(next);
            return mp > mn ? mp : mn;
        }, -Infinity);
    }
    /************************************
        Numeral Prototype
    ************************************/ numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            return formatNumeral(this, inputString ? inputString : options.defaultFormat, roundingFunction !== undefined ? roundingFunction : Math.round);
        },
        unformat: function(inputString) {
            if (Object.prototype.toString.call(inputString) === '[object Number]') return inputString;
            return unformatNumeral(this, inputString ? inputString : options.defaultFormat);
        },
        value: function() {
            return this._value;
        },
        valueOf: function() {
            return this._value;
        },
        set: function(value) {
            this._value = Number(value);
            return this;
        },
        add: function(value) {
            var corrFactor = correctionFactor.call(null, this._value, value);
            function cback(accum, curr, currI, O) {
                return accum + corrFactor * curr;
            }
            this._value = [
                this._value,
                value
            ].reduce(cback, 0) / corrFactor;
            return this;
        },
        subtract: function(value) {
            var corrFactor = correctionFactor.call(null, this._value, value);
            function cback(accum, curr, currI, O) {
                return accum - corrFactor * curr;
            }
            this._value = [
                value
            ].reduce(cback, this._value * corrFactor) / corrFactor;
            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = correctionFactor(accum, curr);
                return accum * corrFactor * (curr * corrFactor) / (corrFactor * corrFactor);
            }
            this._value = [
                this._value,
                value
            ].reduce(cback, 1);
            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = correctionFactor(accum, curr);
                return accum * corrFactor / (curr * corrFactor);
            }
            this._value = [
                this._value,
                value
            ].reduce(cback);
            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };
    /************************************
        Exposing Numeral
    ************************************/ // CommonJS module is defined
    if (module.exports) module.exports = numeral;
    /*global ender:false */ if (typeof ender === 'undefined') // here, `this` means `window` in the browser, or `global` on the server
    // add `numeral` as a global object via a string identifier,
    // for Closure Compiler 'advanced' mode
    this['numeral'] = numeral;
    /*global define:false */ if (typeof define === 'function' && define.amd) define([], function() {
        return numeral;
    });
}).call(this);

},{}],"84aZA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _d3Array = require("d3-array");
parcelHelpers.exportAll(_d3Array, exports);
var _d3Axis = require("d3-axis");
parcelHelpers.exportAll(_d3Axis, exports);
var _d3Brush = require("d3-brush");
parcelHelpers.exportAll(_d3Brush, exports);
var _d3Chord = require("d3-chord");
parcelHelpers.exportAll(_d3Chord, exports);
var _d3Color = require("d3-color");
parcelHelpers.exportAll(_d3Color, exports);
var _d3Contour = require("d3-contour");
parcelHelpers.exportAll(_d3Contour, exports);
var _d3Delaunay = require("d3-delaunay");
parcelHelpers.exportAll(_d3Delaunay, exports);
var _d3Dispatch = require("d3-dispatch");
parcelHelpers.exportAll(_d3Dispatch, exports);
var _d3Drag = require("d3-drag");
parcelHelpers.exportAll(_d3Drag, exports);
var _d3Dsv = require("d3-dsv");
parcelHelpers.exportAll(_d3Dsv, exports);
var _d3Ease = require("d3-ease");
parcelHelpers.exportAll(_d3Ease, exports);
var _d3Fetch = require("d3-fetch");
parcelHelpers.exportAll(_d3Fetch, exports);
var _d3Force = require("d3-force");
parcelHelpers.exportAll(_d3Force, exports);
var _d3Format = require("d3-format");
parcelHelpers.exportAll(_d3Format, exports);
var _d3Geo = require("d3-geo");
parcelHelpers.exportAll(_d3Geo, exports);
var _d3Hierarchy = require("d3-hierarchy");
parcelHelpers.exportAll(_d3Hierarchy, exports);
var _d3Interpolate = require("d3-interpolate");
parcelHelpers.exportAll(_d3Interpolate, exports);
var _d3Path = require("d3-path");
parcelHelpers.exportAll(_d3Path, exports);
var _d3Polygon = require("d3-polygon");
parcelHelpers.exportAll(_d3Polygon, exports);
var _d3Quadtree = require("d3-quadtree");
parcelHelpers.exportAll(_d3Quadtree, exports);
var _d3Random = require("d3-random");
parcelHelpers.exportAll(_d3Random, exports);
var _d3Scale = require("d3-scale");
parcelHelpers.exportAll(_d3Scale, exports);
var _d3ScaleChromatic = require("d3-scale-chromatic");
parcelHelpers.exportAll(_d3ScaleChromatic, exports);
var _d3Selection = require("d3-selection");
parcelHelpers.exportAll(_d3Selection, exports);
var _d3Shape = require("d3-shape");
parcelHelpers.exportAll(_d3Shape, exports);
var _d3Time = require("d3-time");
parcelHelpers.exportAll(_d3Time, exports);
var _d3TimeFormat = require("d3-time-format");
parcelHelpers.exportAll(_d3TimeFormat, exports);
var _d3Timer = require("d3-timer");
parcelHelpers.exportAll(_d3Timer, exports);
var _d3Transition = require("d3-transition");
parcelHelpers.exportAll(_d3Transition, exports);
var _d3Zoom = require("d3-zoom");
parcelHelpers.exportAll(_d3Zoom, exports);

},{"d3-array":"4pSqo","d3-axis":"dWhWG","d3-brush":"diJJQ","d3-chord":"fhDFW","d3-color":"c8Fkk","d3-contour":"k46dS","d3-delaunay":"hlXWZ","d3-dispatch":"fCaQb","d3-drag":"hntwN","d3-dsv":"3pPXN","d3-ease":"lnriX","d3-fetch":"gjgbc","d3-force":"39JL7","d3-format":"9IytR","d3-geo":"hvz1M","d3-hierarchy":"ib0IG","d3-interpolate":"gKQHn","d3-path":"41uJT","d3-polygon":"7KahZ","d3-quadtree":"d5sFf","d3-random":"9Pwtr","d3-scale":"33tt3","d3-scale-chromatic":"5y5Lb","d3-selection":"aa95Z","d3-shape":"1tv6N","d3-time":"5UzaV","d3-time-format":"l85y1","d3-timer":"cOPFt","d3-transition":"aUsOn","d3-zoom":"h8Ny4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dWhWG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "axisTop", ()=>(0, _axisJs.axisTop));
parcelHelpers.export(exports, "axisRight", ()=>(0, _axisJs.axisRight));
parcelHelpers.export(exports, "axisBottom", ()=>(0, _axisJs.axisBottom));
parcelHelpers.export(exports, "axisLeft", ()=>(0, _axisJs.axisLeft));
var _axisJs = require("./axis.js");

},{"./axis.js":"iOgsB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iOgsB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "axisTop", ()=>axisTop);
parcelHelpers.export(exports, "axisRight", ()=>axisRight);
parcelHelpers.export(exports, "axisBottom", ()=>axisBottom);
parcelHelpers.export(exports, "axisLeft", ()=>axisLeft);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var top = 1, right = 2, bottom = 3, left = 4, epsilon = 1e-6;
function translateX(x) {
    return "translate(" + x + ",0)";
}
function translateY(y) {
    return "translate(0," + y + ")";
}
function number(scale) {
    return (d)=>+scale(d);
}
function center(scale, offset) {
    offset = Math.max(0, scale.bandwidth() - offset * 2) / 2;
    if (scale.round()) offset = Math.round(offset);
    return (d)=>+scale(d) + offset;
}
function entering() {
    return !this.__axis;
}
function axis(orient, scale) {
    var tickArguments = [], tickValues = null, tickFormat = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, offset = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5, k = orient === top || orient === left ? -1 : 1, x = orient === left || orient === right ? "x" : "y", transform = orient === top || orient === bottom ? translateX : translateY;
    function axis(context) {
        var values = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format = tickFormat == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : (0, _identityJsDefault.default) : tickFormat, spacing = Math.max(tickSizeInner, 0) + tickPadding, range = scale.range(), range0 = +range[0] + offset, range1 = +range[range.length - 1] + offset, position = (scale.bandwidth ? center : number)(scale.copy(), offset), selection = context.selection ? context.selection() : context, path = selection.selectAll(".domain").data([
            null
        ]), tick = selection.selectAll(".tick").data(values, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line = tick.select("line"), text = tick.select("text");
        path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
        tick = tick.merge(tickEnter);
        line = line.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x + "2", k * tickSizeInner));
        text = text.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x, k * spacing).attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));
        if (context !== selection) {
            path = path.transition(context);
            tick = tick.transition(context);
            line = line.transition(context);
            text = text.transition(context);
            tickExit = tickExit.transition(context).attr("opacity", epsilon).attr("transform", function(d) {
                return isFinite(d = position(d)) ? transform(d + offset) : this.getAttribute("transform");
            });
            tickEnter.attr("opacity", epsilon).attr("transform", function(d) {
                var p = this.parentNode.__axis;
                return transform((p && isFinite(p = p(d)) ? p : position(d)) + offset);
            });
        }
        tickExit.remove();
        path.attr("d", orient === left || orient === right ? tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H" + offset + "V" + range1 + "H" + k * tickSizeOuter : "M" + offset + "," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V" + offset + "H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + "," + offset + "H" + range1);
        tick.attr("opacity", 1).attr("transform", function(d) {
            return transform(position(d) + offset);
        });
        line.attr(x + "2", k * tickSizeInner);
        text.attr(x, k * spacing).text(format);
        selection.filter(entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");
        selection.each(function() {
            this.__axis = position;
        });
    }
    axis.scale = function(_) {
        return arguments.length ? (scale = _, axis) : scale;
    };
    axis.ticks = function() {
        return tickArguments = Array.from(arguments), axis;
    };
    axis.tickArguments = function(_) {
        return arguments.length ? (tickArguments = _ == null ? [] : Array.from(_), axis) : tickArguments.slice();
    };
    axis.tickValues = function(_) {
        return arguments.length ? (tickValues = _ == null ? null : Array.from(_), axis) : tickValues && tickValues.slice();
    };
    axis.tickFormat = function(_) {
        return arguments.length ? (tickFormat = _, axis) : tickFormat;
    };
    axis.tickSize = function(_) {
        return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
    };
    axis.tickSizeInner = function(_) {
        return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
    };
    axis.tickSizeOuter = function(_) {
        return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
    };
    axis.tickPadding = function(_) {
        return arguments.length ? (tickPadding = +_, axis) : tickPadding;
    };
    axis.offset = function(_) {
        return arguments.length ? (offset = +_, axis) : offset;
    };
    return axis;
}
function axisTop(scale) {
    return axis(top, scale);
}
function axisRight(scale) {
    return axis(right, scale);
}
function axisBottom(scale) {
    return axis(bottom, scale);
}
function axisLeft(scale) {
    return axis(left, scale);
}

},{"./identity.js":"2TtQ6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2TtQ6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"diJJQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "brush", ()=>(0, _brushJsDefault.default));
parcelHelpers.export(exports, "brushX", ()=>(0, _brushJs.brushX));
parcelHelpers.export(exports, "brushY", ()=>(0, _brushJs.brushY));
parcelHelpers.export(exports, "brushSelection", ()=>(0, _brushJs.brushSelection));
var _brushJs = require("./brush.js");
var _brushJsDefault = parcelHelpers.interopDefault(_brushJs);

},{"./brush.js":"29usa","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"29usa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "brushSelection", ()=>brushSelection);
parcelHelpers.export(exports, "brushX", ()=>brushX);
parcelHelpers.export(exports, "brushY", ()=>brushY);
parcelHelpers.export(exports, "default", ()=>function() {
        return brush(XY);
    });
var _d3Dispatch = require("d3-dispatch");
var _d3Drag = require("d3-drag");
var _d3Interpolate = require("d3-interpolate");
var _d3Selection = require("d3-selection");
var _d3Transition = require("d3-transition");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _eventJs = require("./event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
var _noeventJs = require("./noevent.js");
var _noeventJsDefault = parcelHelpers.interopDefault(_noeventJs);
var MODE_DRAG = {
    name: "drag"
}, MODE_SPACE = {
    name: "space"
}, MODE_HANDLE = {
    name: "handle"
}, MODE_CENTER = {
    name: "center"
};
const { abs, max, min } = Math;
function number1(e) {
    return [
        +e[0],
        +e[1]
    ];
}
function number2(e) {
    return [
        number1(e[0]),
        number1(e[1])
    ];
}
var X = {
    name: "x",
    handles: [
        "w",
        "e"
    ].map(type),
    input: function(x, e) {
        return x == null ? null : [
            [
                +x[0],
                e[0][1]
            ],
            [
                +x[1],
                e[1][1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][0],
            xy[1][0]
        ];
    }
};
var Y = {
    name: "y",
    handles: [
        "n",
        "s"
    ].map(type),
    input: function(y, e) {
        return y == null ? null : [
            [
                e[0][0],
                +y[0]
            ],
            [
                e[1][0],
                +y[1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][1],
            xy[1][1]
        ];
    }
};
var XY = {
    name: "xy",
    handles: [
        "n",
        "w",
        "e",
        "s",
        "nw",
        "ne",
        "sw",
        "se"
    ].map(type),
    input: function(xy) {
        return xy == null ? null : number2(xy);
    },
    output: function(xy) {
        return xy;
    }
};
var cursors = {
    overlay: "crosshair",
    selection: "move",
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
};
var flipX = {
    e: "w",
    w: "e",
    nw: "ne",
    ne: "nw",
    se: "sw",
    sw: "se"
};
var flipY = {
    n: "s",
    s: "n",
    nw: "sw",
    ne: "se",
    se: "ne",
    sw: "nw"
};
var signsX = {
    overlay: 1,
    selection: 1,
    n: null,
    e: 1,
    s: null,
    w: -1,
    nw: -1,
    ne: 1,
    se: 1,
    sw: -1
};
var signsY = {
    overlay: 1,
    selection: 1,
    n: -1,
    e: null,
    s: 1,
    w: null,
    nw: -1,
    ne: -1,
    se: 1,
    sw: 1
};
function type(t) {
    return {
        type: t
    };
}
// Ignore right-click, since that should open the context menu.
function defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function defaultExtent() {
    var svg = this.ownerSVGElement || this;
    if (svg.hasAttribute("viewBox")) {
        svg = svg.viewBox.baseVal;
        return [
            [
                svg.x,
                svg.y
            ],
            [
                svg.x + svg.width,
                svg.y + svg.height
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            svg.width.baseVal.value,
            svg.height.baseVal.value
        ]
    ];
}
function defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
// Like d3.local, but with the name “__brush” rather than auto-generated.
function local(node) {
    while(!node.__brush)if (!(node = node.parentNode)) return;
    return node.__brush;
}
function empty(extent) {
    return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
}
function brushSelection(node) {
    var state = node.__brush;
    return state ? state.dim.output(state.selection) : null;
}
function brushX() {
    return brush(X);
}
function brushY() {
    return brush(Y);
}
function brush(dim) {
    var extent = defaultExtent, filter = defaultFilter, touchable = defaultTouchable, keys = true, listeners = (0, _d3Dispatch.dispatch)("start", "brush", "end"), handleSize = 6, touchending;
    function brush(group) {
        var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
            type("overlay")
        ]);
        overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", cursors.overlay).merge(overlay).each(function() {
            var extent = local(this).extent;
            (0, _d3Selection.select)(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
        });
        group.selectAll(".selection").data([
            type("selection")
        ]).enter().append("rect").attr("class", "selection").attr("cursor", cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
        var handle = group.selectAll(".handle").data(dim.handles, function(d) {
            return d.type;
        });
        handle.exit().remove();
        handle.enter().append("rect").attr("class", function(d) {
            return "handle handle--" + d.type;
        }).attr("cursor", function(d) {
            return cursors[d.type];
        });
        group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    brush.move = function(group, selection, event) {
        if (group.tween) group.on("start.brush", function(event) {
            emitter(this, arguments).beforestart().start(event);
        }).on("interrupt.brush end.brush", function(event) {
            emitter(this, arguments).end(event);
        }).tween("brush", function() {
            var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = (0, _d3Interpolate.interpolate)(selection0, selection1);
            function tween(t) {
                state.selection = t === 1 && selection1 === null ? null : i(t);
                redraw.call(that);
                emit.brush();
            }
            return selection0 !== null && selection1 !== null ? tween : tween(1);
        });
        else group.each(function() {
            var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
            (0, _d3Transition.interrupt)(that);
            state.selection = selection1 === null ? null : selection1;
            redraw.call(that);
            emit.start(event).brush(event).end(event);
        });
    };
    brush.clear = function(group, event) {
        brush.move(group, null, event);
    };
    function redraw() {
        var group = (0, _d3Selection.select)(this), selection = local(this).selection;
        if (selection) {
            group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
            group.selectAll(".handle").style("display", null).attr("x", function(d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
            }).attr("y", function(d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
            }).attr("width", function(d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
            }).attr("height", function(d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
            });
        } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
    function emitter(that, args, clean) {
        var emit = that.__brush.emitter;
        return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
    }
    function Emitter(that, args, clean) {
        this.that = that;
        this.args = args;
        this.state = that.__brush;
        this.active = 0;
        this.clean = clean;
    }
    Emitter.prototype = {
        beforestart: function() {
            if (++this.active === 1) this.state.emitter = this, this.starting = true;
            return this;
        },
        start: function(event, mode) {
            if (this.starting) this.starting = false, this.emit("start", event, mode);
            else this.emit("brush", event);
            return this;
        },
        brush: function(event, mode) {
            this.emit("brush", event, mode);
            return this;
        },
        end: function(event, mode) {
            if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode);
            return this;
        },
        emit: function(type, event, mode) {
            var d = (0, _d3Selection.select)(this.that).datum();
            listeners.call(type, this.that, new (0, _eventJsDefault.default)(type, {
                sourceEvent: event,
                target: brush,
                selection: dim.output(this.state.selection),
                mode,
                dispatch: listeners
            }), d);
        }
    };
    function started(event) {
        if (touchending && !event.touches) return;
        if (!filter.apply(this, arguments)) return;
        var that = this, type = event.target.__data__.type, mode = (keys && event.metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : keys && event.altKey ? MODE_CENTER : MODE_HANDLE, signX = dim === Y ? null : signsX[type], signY = dim === X ? null : signsY[type], state = local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && event.shiftKey, lockX, lockY, points = Array.from(event.touches || [
            event
        ], (t)=>{
            const i = t.identifier;
            t = (0, _d3Selection.pointer)(t, that);
            t.point0 = t.slice();
            t.identifier = i;
            return t;
        });
        (0, _d3Transition.interrupt)(that);
        var emit = emitter(that, arguments, true).beforestart();
        if (type === "overlay") {
            if (selection) moving = true;
            const pts = [
                points[0],
                points[1] || points[0]
            ];
            state.selection = selection = [
                [
                    w0 = dim === Y ? W : min(pts[0][0], pts[1][0]),
                    n0 = dim === X ? N : min(pts[0][1], pts[1][1])
                ],
                [
                    e0 = dim === Y ? E : max(pts[0][0], pts[1][0]),
                    s0 = dim === X ? S : max(pts[0][1], pts[1][1])
                ]
            ];
            if (points.length > 1) move(event);
        } else {
            w0 = selection[0][0];
            n0 = selection[0][1];
            e0 = selection[1][0];
            s0 = selection[1][1];
        }
        w1 = w0;
        n1 = n0;
        e1 = e0;
        s1 = s0;
        var group = (0, _d3Selection.select)(that).attr("pointer-events", "none");
        var overlay = group.selectAll(".overlay").attr("cursor", cursors[type]);
        if (event.touches) {
            emit.moved = moved;
            emit.ended = ended;
        } else {
            var view = (0, _d3Selection.select)(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
            if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
            (0, _d3Drag.dragDisable)(event.view);
        }
        redraw.call(that);
        emit.start(event, mode.name);
        function moved(event) {
            for (const p of event.changedTouches || [
                event
            ]){
                for (const d of points)if (d.identifier === p.identifier) d.cur = (0, _d3Selection.pointer)(p, that);
            }
            if (shifting && !lockX && !lockY && points.length === 1) {
                const point = points[0];
                if (abs(point.cur[0] - point[0]) > abs(point.cur[1] - point[1])) lockY = true;
                else lockX = true;
            }
            for (const point of points)if (point.cur) point[0] = point.cur[0], point[1] = point.cur[1];
            moving = true;
            (0, _noeventJsDefault.default)(event);
            move(event);
        }
        function move(event) {
            const point = points[0], point0 = point.point0;
            var t;
            dx = point[0] - point0[0];
            dy = point[1] - point0[1];
            switch(mode){
                case MODE_SPACE:
                case MODE_DRAG:
                    if (signX) dx = max(W - w0, min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                    if (signY) dy = max(N - n0, min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                    break;
                case MODE_HANDLE:
                    if (points[1]) {
                        if (signX) w1 = max(W, min(E, points[0][0])), e1 = max(W, min(E, points[1][0])), signX = 1;
                        if (signY) n1 = max(N, min(S, points[0][1])), s1 = max(N, min(S, points[1][1])), signY = 1;
                    } else {
                        if (signX < 0) dx = max(W - w0, min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                        else if (signX > 0) dx = max(W - e0, min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                        if (signY < 0) dy = max(N - n0, min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                        else if (signY > 0) dy = max(N - s0, min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                    }
                    break;
                case MODE_CENTER:
                    if (signX) w1 = max(W, min(E, w0 - dx * signX)), e1 = max(W, min(E, e0 + dx * signX));
                    if (signY) n1 = max(N, min(S, n0 - dy * signY)), s1 = max(N, min(S, s0 + dy * signY));
                    break;
            }
            if (e1 < w1) {
                signX *= -1;
                t = w0, w0 = e0, e0 = t;
                t = w1, w1 = e1, e1 = t;
                if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
            }
            if (s1 < n1) {
                signY *= -1;
                t = n0, n0 = s0, s0 = t;
                t = n1, n1 = s1, s1 = t;
                if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
            }
            if (state.selection) selection = state.selection; // May be set by brush.move!
            if (lockX) w1 = selection[0][0], e1 = selection[1][0];
            if (lockY) n1 = selection[0][1], s1 = selection[1][1];
            if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                state.selection = [
                    [
                        w1,
                        n1
                    ],
                    [
                        e1,
                        s1
                    ]
                ];
                redraw.call(that);
                emit.brush(event, mode.name);
            }
        }
        function ended(event) {
            (0, _noeventJs.nopropagation)(event);
            if (event.touches) {
                if (event.touches.length) return;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, 500); // Ghost clicks are delayed!
            } else {
                (0, _d3Drag.dragEnable)(event.view, moving);
                view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
            }
            group.attr("pointer-events", "all");
            overlay.attr("cursor", cursors.overlay);
            if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
            if (empty(selection)) state.selection = null, redraw.call(that);
            emit.end(event, mode.name);
        }
        function keydowned(event) {
            switch(event.keyCode){
                case 16:
                    shifting = signX && signY;
                    break;
                case 18:
                    if (mode === MODE_HANDLE) {
                        if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                        if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                        mode = MODE_CENTER;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === MODE_HANDLE || mode === MODE_CENTER) {
                        if (signX < 0) e0 = e1 - dx;
                        else if (signX > 0) w0 = w1 - dx;
                        if (signY < 0) s0 = s1 - dy;
                        else if (signY > 0) n0 = n1 - dy;
                        mode = MODE_SPACE;
                        overlay.attr("cursor", cursors.selection);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, _noeventJsDefault.default)(event);
        }
        function keyupped(event) {
            switch(event.keyCode){
                case 16:
                    if (shifting) {
                        lockX = lockY = shifting = false;
                        move(event);
                    }
                    break;
                case 18:
                    if (mode === MODE_CENTER) {
                        if (signX < 0) e0 = e1;
                        else if (signX > 0) w0 = w1;
                        if (signY < 0) s0 = s1;
                        else if (signY > 0) n0 = n1;
                        mode = MODE_HANDLE;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === MODE_SPACE) {
                        if (event.altKey) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = MODE_CENTER;
                        } else {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = MODE_HANDLE;
                        }
                        overlay.attr("cursor", cursors[type]);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, _noeventJsDefault.default)(event);
        }
    }
    function touchmoved(event) {
        emitter(this, arguments).moved(event);
    }
    function touchended(event) {
        emitter(this, arguments).ended(event);
    }
    function initialize() {
        var state = this.__brush || {
            selection: null
        };
        state.extent = number2(extent.apply(this, arguments));
        state.dim = dim;
        return state;
    }
    brush.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(number2(_)), brush) : extent;
    };
    brush.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), brush) : filter;
    };
    brush.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), brush) : touchable;
    };
    brush.handleSize = function(_) {
        return arguments.length ? (handleSize = +_, brush) : handleSize;
    };
    brush.keyModifiers = function(_) {
        return arguments.length ? (keys = !!_, brush) : keys;
    };
    brush.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? brush : value;
    };
    return brush;
}

},{"d3-dispatch":[["dispatch","avnlO","default"]],"d3-drag":[["dragDisable","2o3My","default"],["dragEnable","2o3My","yesdrag"]],"d3-interpolate":[["interpolate","bQQ1J","default"]],"d3-selection":[["pointer","04Hca","default"],["select","4CEQV","default"]],"d3-transition":"aUsOn","./constant.js":"9KcHm","./event.js":"14hSA","./noevent.js":"g2Qnx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"avnlO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var noop = {
    value: ()=>{}
};
function dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new Dispatch(_);
}
function Dispatch(_) {
    this._ = _;
}
function parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
Dispatch.prototype = dispatch.prototype = {
    constructor: Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
exports.default = dispatch;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2o3My":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(view) {
        var root = view.document.documentElement, selection = (0, _d3Selection.select)(view).on("dragstart.drag", (0, _noeventJsDefault.default), (0, _noeventJs.nonpassivecapture));
        if ("onselectstart" in root) selection.on("selectstart.drag", (0, _noeventJsDefault.default), (0, _noeventJs.nonpassivecapture));
        else {
            root.__noselect = root.style.MozUserSelect;
            root.style.MozUserSelect = "none";
        }
    });
parcelHelpers.export(exports, "yesdrag", ()=>yesdrag);
var _d3Selection = require("d3-selection");
var _noeventJs = require("./noevent.js");
var _noeventJsDefault = parcelHelpers.interopDefault(_noeventJs);
function yesdrag(view, noclick) {
    var root = view.document.documentElement, selection = (0, _d3Selection.select)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, _noeventJsDefault.default), (0, _noeventJs.nonpassivecapture));
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}

},{"d3-selection":[["select","4CEQV","default"]],"./noevent.js":"lC7cP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4CEQV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return typeof selector === "string" ? new (0, _indexJs.Selection)([
            [
                document.querySelector(selector)
            ]
        ], [
            document.documentElement
        ]) : new (0, _indexJs.Selection)([
            [
                selector
            ]
        ], (0, _indexJs.root));
    });
var _indexJs = require("./selection/index.js");

},{"./selection/index.js":"c44R6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c44R6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "root", ()=>root);
parcelHelpers.export(exports, "Selection", ()=>Selection);
var _selectJs = require("./select.js");
var _selectJsDefault = parcelHelpers.interopDefault(_selectJs);
var _selectAllJs = require("./selectAll.js");
var _selectAllJsDefault = parcelHelpers.interopDefault(_selectAllJs);
var _selectChildJs = require("./selectChild.js");
var _selectChildJsDefault = parcelHelpers.interopDefault(_selectChildJs);
var _selectChildrenJs = require("./selectChildren.js");
var _selectChildrenJsDefault = parcelHelpers.interopDefault(_selectChildrenJs);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _dataJs = require("./data.js");
var _dataJsDefault = parcelHelpers.interopDefault(_dataJs);
var _enterJs = require("./enter.js");
var _enterJsDefault = parcelHelpers.interopDefault(_enterJs);
var _exitJs = require("./exit.js");
var _exitJsDefault = parcelHelpers.interopDefault(_exitJs);
var _joinJs = require("./join.js");
var _joinJsDefault = parcelHelpers.interopDefault(_joinJs);
var _mergeJs = require("./merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _orderJs = require("./order.js");
var _orderJsDefault = parcelHelpers.interopDefault(_orderJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
var _callJs = require("./call.js");
var _callJsDefault = parcelHelpers.interopDefault(_callJs);
var _nodesJs = require("./nodes.js");
var _nodesJsDefault = parcelHelpers.interopDefault(_nodesJs);
var _nodeJs = require("./node.js");
var _nodeJsDefault = parcelHelpers.interopDefault(_nodeJs);
var _sizeJs = require("./size.js");
var _sizeJsDefault = parcelHelpers.interopDefault(_sizeJs);
var _emptyJs = require("./empty.js");
var _emptyJsDefault = parcelHelpers.interopDefault(_emptyJs);
var _eachJs = require("./each.js");
var _eachJsDefault = parcelHelpers.interopDefault(_eachJs);
var _attrJs = require("./attr.js");
var _attrJsDefault = parcelHelpers.interopDefault(_attrJs);
var _styleJs = require("./style.js");
var _styleJsDefault = parcelHelpers.interopDefault(_styleJs);
var _propertyJs = require("./property.js");
var _propertyJsDefault = parcelHelpers.interopDefault(_propertyJs);
var _classedJs = require("./classed.js");
var _classedJsDefault = parcelHelpers.interopDefault(_classedJs);
var _textJs = require("./text.js");
var _textJsDefault = parcelHelpers.interopDefault(_textJs);
var _htmlJs = require("./html.js");
var _htmlJsDefault = parcelHelpers.interopDefault(_htmlJs);
var _raiseJs = require("./raise.js");
var _raiseJsDefault = parcelHelpers.interopDefault(_raiseJs);
var _lowerJs = require("./lower.js");
var _lowerJsDefault = parcelHelpers.interopDefault(_lowerJs);
var _appendJs = require("./append.js");
var _appendJsDefault = parcelHelpers.interopDefault(_appendJs);
var _insertJs = require("./insert.js");
var _insertJsDefault = parcelHelpers.interopDefault(_insertJs);
var _removeJs = require("./remove.js");
var _removeJsDefault = parcelHelpers.interopDefault(_removeJs);
var _cloneJs = require("./clone.js");
var _cloneJsDefault = parcelHelpers.interopDefault(_cloneJs);
var _datumJs = require("./datum.js");
var _datumJsDefault = parcelHelpers.interopDefault(_datumJs);
var _onJs = require("./on.js");
var _onJsDefault = parcelHelpers.interopDefault(_onJs);
var _dispatchJs = require("./dispatch.js");
var _dispatchJsDefault = parcelHelpers.interopDefault(_dispatchJs);
var _iteratorJs = require("./iterator.js");
var _iteratorJsDefault = parcelHelpers.interopDefault(_iteratorJs);
var root = [
    null
];
function Selection(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function selection() {
    return new Selection([
        [
            document.documentElement
        ]
    ], root);
}
function selection_selection() {
    return this;
}
Selection.prototype = selection.prototype = {
    constructor: Selection,
    select: (0, _selectJsDefault.default),
    selectAll: (0, _selectAllJsDefault.default),
    selectChild: (0, _selectChildJsDefault.default),
    selectChildren: (0, _selectChildrenJsDefault.default),
    filter: (0, _filterJsDefault.default),
    data: (0, _dataJsDefault.default),
    enter: (0, _enterJsDefault.default),
    exit: (0, _exitJsDefault.default),
    join: (0, _joinJsDefault.default),
    merge: (0, _mergeJsDefault.default),
    selection: selection_selection,
    order: (0, _orderJsDefault.default),
    sort: (0, _sortJsDefault.default),
    call: (0, _callJsDefault.default),
    nodes: (0, _nodesJsDefault.default),
    node: (0, _nodeJsDefault.default),
    size: (0, _sizeJsDefault.default),
    empty: (0, _emptyJsDefault.default),
    each: (0, _eachJsDefault.default),
    attr: (0, _attrJsDefault.default),
    style: (0, _styleJsDefault.default),
    property: (0, _propertyJsDefault.default),
    classed: (0, _classedJsDefault.default),
    text: (0, _textJsDefault.default),
    html: (0, _htmlJsDefault.default),
    raise: (0, _raiseJsDefault.default),
    lower: (0, _lowerJsDefault.default),
    append: (0, _appendJsDefault.default),
    insert: (0, _insertJsDefault.default),
    remove: (0, _removeJsDefault.default),
    clone: (0, _cloneJsDefault.default),
    datum: (0, _datumJsDefault.default),
    on: (0, _onJsDefault.default),
    dispatch: (0, _dispatchJsDefault.default),
    [Symbol.iterator]: (0, _iteratorJsDefault.default)
};
exports.default = selection;

},{"./select.js":"jThnY","./selectAll.js":"BcdEF","./selectChild.js":"7cTWi","./selectChildren.js":"dlxsy","./filter.js":"kUYOE","./data.js":"fgP1j","./enter.js":"lmM9E","./exit.js":"2p8KH","./join.js":"daI42","./merge.js":"5vqne","./order.js":"c1xIF","./sort.js":"f4hiX","./call.js":"j3Hlh","./nodes.js":"9pWqB","./node.js":"7QU4v","./size.js":"9Ekbp","./empty.js":"iI41J","./each.js":"KNRWO","./attr.js":"i51aH","./style.js":"jEBVs","./property.js":"3F4kb","./classed.js":"8PX0y","./text.js":"i8K0e","./html.js":"i1OWe","./raise.js":"6PNKJ","./lower.js":"aZVnM","./append.js":"685tA","./insert.js":"gMCYh","./remove.js":"90pUx","./clone.js":"gtufo","./datum.js":"dvdJ8","./on.js":"lkgsT","./dispatch.js":"cwbD6","./iterator.js":"2FeiE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jThnY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(select) {
        if (typeof select !== "function") select = (0, _selectorJsDefault.default)(select);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
                if ("__data__" in node) subnode.__data__ = node.__data__;
                subgroup[i] = subnode;
            }
        }
        return new (0, _indexJs.Selection)(subgroups, this._parents);
    });
var _indexJs = require("./index.js");
var _selectorJs = require("../selector.js");
var _selectorJsDefault = parcelHelpers.interopDefault(_selectorJs);

},{"./index.js":"c44R6","../selector.js":"4I2PW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4I2PW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return selector == null ? none : function() {
            return this.querySelector(selector);
        };
    });
function none() {}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"BcdEF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(select) {
        if (typeof select === "function") select = arrayAll(select);
        else select = (0, _selectorAllJsDefault.default)(select);
        for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                subgroups.push(select.call(node, node.__data__, i, group));
                parents.push(node);
            }
        }
        return new (0, _indexJs.Selection)(subgroups, parents);
    });
var _indexJs = require("./index.js");
var _arrayJs = require("../array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _selectorAllJs = require("../selectorAll.js");
var _selectorAllJsDefault = parcelHelpers.interopDefault(_selectorAllJs);
function arrayAll(select) {
    return function() {
        return (0, _arrayJsDefault.default)(select.apply(this, arguments));
    };
}

},{"./index.js":"c44R6","../array.js":"2iarJ","../selectorAll.js":"9H6e7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2iarJ":[function(require,module,exports,__globalThis) {
// Given something array like (or null), returns something that is strictly an
// array. This is used to ensure that array-like objects passed to d3.selectAll
// or selection.selectAll are converted into proper arrays when creating a
// selection; we don’t ever want to create a selection backed by a live
// HTMLCollection or NodeList. However, note that selection.selectAll will use a
// static NodeList as a group, since it safely derived from querySelectorAll.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>array);
function array(x) {
    return x == null ? [] : Array.isArray(x) ? x : Array.from(x);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9H6e7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return selector == null ? empty : function() {
            return this.querySelectorAll(selector);
        };
    });
function empty() {
    return [];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7cTWi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(match) {
        return this.select(match == null ? childFirst : childFind(typeof match === "function" ? match : (0, _matcherJs.childMatcher)(match)));
    });
var _matcherJs = require("../matcher.js");
var find = Array.prototype.find;
function childFind(match) {
    return function() {
        return find.call(this.children, match);
    };
}
function childFirst() {
    return this.firstElementChild;
}

},{"../matcher.js":"iOc8r","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iOc8r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return function() {
            return this.matches(selector);
        };
    });
parcelHelpers.export(exports, "childMatcher", ()=>childMatcher);
function childMatcher(selector) {
    return function(node) {
        return node.matches(selector);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dlxsy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(match) {
        return this.selectAll(match == null ? children : childrenFilter(typeof match === "function" ? match : (0, _matcherJs.childMatcher)(match)));
    });
var _matcherJs = require("../matcher.js");
var filter = Array.prototype.filter;
function children() {
    return Array.from(this.children);
}
function childrenFilter(match) {
    return function() {
        return filter.call(this.children, match);
    };
}

},{"../matcher.js":"iOc8r","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kUYOE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(match) {
        if (typeof match !== "function") match = (0, _matcherJsDefault.default)(match);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
        }
        return new (0, _indexJs.Selection)(subgroups, this._parents);
    });
var _indexJs = require("./index.js");
var _matcherJs = require("../matcher.js");
var _matcherJsDefault = parcelHelpers.interopDefault(_matcherJs);

},{"./index.js":"c44R6","../matcher.js":"iOc8r","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fgP1j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value, key) {
        if (!arguments.length) return Array.from(this, datum);
        var bind = key ? bindKey : bindIndex, parents = this._parents, groups = this._groups;
        if (typeof value !== "function") value = (0, _constantJsDefault.default)(value);
        for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
            var parent = parents[j], group = groups[j], groupLength = group.length, data = arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
            bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
            // Now connect the enter nodes to their following update node, such that
            // appendChild can insert the materialized enter node before this node,
            // rather than at the end of the parent node.
            for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
                if (i0 >= i1) i1 = i0 + 1;
                while(!(next = updateGroup[i1]) && ++i1 < dataLength);
                previous._next = next || null;
            }
        }
        update = new (0, _indexJs.Selection)(update, parents);
        update._enter = enter;
        update._exit = exit;
        return update;
    });
var _indexJs = require("./index.js");
var _enterJs = require("./enter.js");
var _constantJs = require("../constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
function bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, _enterJs.EnterNode)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, _enterJs.EnterNode)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function datum(node) {
    return node.__data__;
}
// Given some data, this returns an array-like view of it: an object that
// exposes a length property and allows numeric indexing. Note that unlike
// selectAll, this isn’t worried about “live” collections because the resulting
// array will only be used briefly while data is being bound. (It is possible to
// cause the data to change while iterating by using a key function, but please
// don’t; we’d rather avoid a gratuitous copy.)
function arraylike(data) {
    return typeof data === "object" && "length" in data ? data // Array, TypedArray, NodeList, array-like
     : Array.from(data); // Map, Set, iterable, string, or anything else
}

},{"./index.js":"c44R6","./enter.js":"lmM9E","../constant.js":"7old4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lmM9E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return new (0, _indexJs.Selection)(this._enter || this._groups.map((0, _sparseJsDefault.default)), this._parents);
    });
parcelHelpers.export(exports, "EnterNode", ()=>EnterNode);
var _sparseJs = require("./sparse.js");
var _sparseJsDefault = parcelHelpers.interopDefault(_sparseJs);
var _indexJs = require("./index.js");
function EnterNode(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
EnterNode.prototype = {
    constructor: EnterNode,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};

},{"./sparse.js":"5bra5","./index.js":"c44R6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5bra5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(update) {
        return new Array(update.length);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7old4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2p8KH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return new (0, _indexJs.Selection)(this._exit || this._groups.map((0, _sparseJsDefault.default)), this._parents);
    });
var _sparseJs = require("./sparse.js");
var _sparseJsDefault = parcelHelpers.interopDefault(_sparseJs);
var _indexJs = require("./index.js");

},{"./sparse.js":"5bra5","./index.js":"c44R6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"daI42":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(onenter, onupdate, onexit) {
        var enter = this.enter(), update = this, exit = this.exit();
        if (typeof onenter === "function") {
            enter = onenter(enter);
            if (enter) enter = enter.selection();
        } else enter = enter.append(onenter + "");
        if (onupdate != null) {
            update = onupdate(update);
            if (update) update = update.selection();
        }
        if (onexit == null) exit.remove();
        else onexit(exit);
        return enter && update ? enter.merge(update).order() : update;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5vqne":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        var selection = context.selection ? context.selection() : context;
        for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
            for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
        }
        for(; j < m0; ++j)merges[j] = groups0[j];
        return new (0, _indexJs.Selection)(merges, this._parents);
    });
var _indexJs = require("./index.js");

},{"./index.js":"c44R6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c1xIF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
            for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
                if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
                next = node;
            }
        }
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f4hiX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(compare) {
        if (!compare) compare = ascending;
        function compareNode(a, b) {
            return a && b ? compare(a.__data__, b.__data__) : !a - !b;
        }
        for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
            sortgroup.sort(compareNode);
        }
        return new (0, _indexJs.Selection)(sortgroups, this._parents).order();
    });
var _indexJs = require("./index.js");
function ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

},{"./index.js":"c44R6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j3Hlh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var callback = arguments[0];
        arguments[0] = this;
        callback.apply(null, arguments);
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9pWqB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return Array.from(this);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7QU4v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
            var node = group[i];
            if (node) return node;
        }
        return null;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9Ekbp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        let size = 0;
        for (const node of this)++size; // eslint-disable-line no-unused-vars
        return size;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iI41J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return !this.node();
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"KNRWO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback) {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
            for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
        }
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i51aH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var fullname = (0, _namespaceJsDefault.default)(name);
        if (arguments.length < 2) {
            var node = this.node();
            return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
        }
        return this.each((value == null ? fullname.local ? attrRemoveNS : attrRemove : typeof value === "function" ? fullname.local ? attrFunctionNS : attrFunction : fullname.local ? attrConstantNS : attrConstant)(fullname, value));
    });
var _namespaceJs = require("../namespace.js");
var _namespaceJsDefault = parcelHelpers.interopDefault(_namespaceJs);
function attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}

},{"../namespace.js":"e2lf9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e2lf9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var prefix = name += "", i = prefix.indexOf(":");
        if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
        return (0, _namespacesJsDefault.default).hasOwnProperty(prefix) ? {
            space: (0, _namespacesJsDefault.default)[prefix],
            local: name
        } : name; // eslint-disable-line no-prototype-builtins
    });
var _namespacesJs = require("./namespaces.js");
var _namespacesJsDefault = parcelHelpers.interopDefault(_namespacesJs);

},{"./namespaces.js":"eaqJV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eaqJV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "xhtml", ()=>xhtml);
var xhtml = "http://www.w3.org/1999/xhtml";
exports.default = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: xhtml,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jEBVs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value, priority) {
        return arguments.length > 1 ? this.each((value == null ? styleRemove : typeof value === "function" ? styleFunction : styleConstant)(name, value, priority == null ? "" : priority)) : styleValue(this.node(), name);
    });
parcelHelpers.export(exports, "styleValue", ()=>styleValue);
var _windowJs = require("../window.js");
var _windowJsDefault = parcelHelpers.interopDefault(_windowJs);
function styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function styleValue(node, name) {
    return node.style.getPropertyValue(name) || (0, _windowJsDefault.default)(node).getComputedStyle(node, null).getPropertyValue(name);
}

},{"../window.js":"esh79","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"esh79":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node) {
        return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
         || node.document && node // node is a Window
         || node.defaultView; // node is a Document
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3F4kb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        return arguments.length > 1 ? this.each((value == null ? propertyRemove : typeof value === "function" ? propertyFunction : propertyConstant)(name, value)) : this.node()[name];
    });
function propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8PX0y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var names = classArray(name + "");
        if (arguments.length < 2) {
            var list = classList(this.node()), i = -1, n = names.length;
            while(++i < n)if (!list.contains(names[i])) return false;
            return true;
        }
        return this.each((typeof value === "function" ? classedFunction : value ? classedTrue : classedFalse)(names, value));
    });
function classArray(string) {
    return string.trim().split(/^|\s+/);
}
function classList(node) {
    return node.classList || new ClassList(node);
}
function ClassList(node) {
    this._node = node;
    this._names = classArray(node.getAttribute("class") || "");
}
ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function classedAdd(node, names) {
    var list = classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function classedRemove(node, names) {
    var list = classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function classedTrue(names) {
    return function() {
        classedAdd(this, names);
    };
}
function classedFalse(names) {
    return function() {
        classedRemove(this, names);
    };
}
function classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i8K0e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return arguments.length ? this.each(value == null ? textRemove : (typeof value === "function" ? textFunction : textConstant)(value)) : this.node().textContent;
    });
function textRemove() {
    this.textContent = "";
}
function textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i1OWe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return arguments.length ? this.each(value == null ? htmlRemove : (typeof value === "function" ? htmlFunction : htmlConstant)(value)) : this.node().innerHTML;
    });
function htmlRemove() {
    this.innerHTML = "";
}
function htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6PNKJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.each(raise);
    });
function raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aZVnM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.each(lower);
    });
function lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"685tA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var create = typeof name === "function" ? name : (0, _creatorJsDefault.default)(name);
        return this.select(function() {
            return this.appendChild(create.apply(this, arguments));
        });
    });
var _creatorJs = require("../creator.js");
var _creatorJsDefault = parcelHelpers.interopDefault(_creatorJs);

},{"../creator.js":"8Llrx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8Llrx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var fullname = (0, _namespaceJsDefault.default)(name);
        return (fullname.local ? creatorFixed : creatorInherit)(fullname);
    });
var _namespaceJs = require("./namespace.js");
var _namespaceJsDefault = parcelHelpers.interopDefault(_namespaceJs);
var _namespacesJs = require("./namespaces.js");
function creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, _namespacesJs.xhtml) && document.documentElement.namespaceURI === (0, _namespacesJs.xhtml) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}

},{"./namespace.js":"e2lf9","./namespaces.js":"eaqJV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gMCYh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, before) {
        var create = typeof name === "function" ? name : (0, _creatorJsDefault.default)(name), select = before == null ? constantNull : typeof before === "function" ? before : (0, _selectorJsDefault.default)(before);
        return this.select(function() {
            return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
        });
    });
var _creatorJs = require("../creator.js");
var _creatorJsDefault = parcelHelpers.interopDefault(_creatorJs);
var _selectorJs = require("../selector.js");
var _selectorJsDefault = parcelHelpers.interopDefault(_selectorJs);
function constantNull() {
    return null;
}

},{"../creator.js":"8Llrx","../selector.js":"4I2PW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"90pUx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.each(remove);
    });
function remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gtufo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(deep) {
        return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
    });
function selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dvdJ8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return arguments.length ? this.property("__data__", value) : this.node().__data__;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lkgsT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(typename, value, options) {
        var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;
        if (arguments.length < 2) {
            var on = this.node().__on;
            if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
                if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
            }
            return;
        }
        on = value ? onAdd : onRemove;
        for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
        return this;
    });
function contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cwbD6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(type, params) {
        return this.each((typeof params === "function" ? dispatchFunction : dispatchConstant)(type, params));
    });
var _windowJs = require("../window.js");
var _windowJsDefault = parcelHelpers.interopDefault(_windowJs);
function dispatchEvent(node, type, params) {
    var window = (0, _windowJsDefault.default)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function dispatchConstant(type, params) {
    return function() {
        return dispatchEvent(this, type, params);
    };
}
function dispatchFunction(type, params) {
    return function() {
        return dispatchEvent(this, type, params.apply(this, arguments));
    };
}

},{"../window.js":"esh79","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2FeiE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function*() {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
            for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lC7cP":[function(require,module,exports,__globalThis) {
// These are typically used in conjunction with noevent to ensure that we can
// preventDefault on the event.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nonpassive", ()=>nonpassive);
parcelHelpers.export(exports, "nonpassivecapture", ()=>nonpassivecapture);
parcelHelpers.export(exports, "nopropagation", ()=>nopropagation);
parcelHelpers.export(exports, "default", ()=>function(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    });
const nonpassive = {
    passive: false
};
const nonpassivecapture = {
    capture: true,
    passive: false
};
function nopropagation(event) {
    event.stopImmediatePropagation();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"04Hca":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(event, node) {
        event = (0, _sourceEventJsDefault.default)(event);
        if (node === undefined) node = event.currentTarget;
        if (node) {
            var svg = node.ownerSVGElement || node;
            if (svg.createSVGPoint) {
                var point = svg.createSVGPoint();
                point.x = event.clientX, point.y = event.clientY;
                point = point.matrixTransform(node.getScreenCTM().inverse());
                return [
                    point.x,
                    point.y
                ];
            }
            if (node.getBoundingClientRect) {
                var rect = node.getBoundingClientRect();
                return [
                    event.clientX - rect.left - node.clientLeft,
                    event.clientY - rect.top - node.clientTop
                ];
            }
        }
        return [
            event.pageX,
            event.pageY
        ];
    });
var _sourceEventJs = require("./sourceEvent.js");
var _sourceEventJsDefault = parcelHelpers.interopDefault(_sourceEventJs);

},{"./sourceEvent.js":"awReS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"awReS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(event) {
        let sourceEvent;
        while(sourceEvent = event.sourceEvent)event = sourceEvent;
        return event;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aUsOn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transition", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "active", ()=>(0, _activeJsDefault.default));
parcelHelpers.export(exports, "interrupt", ()=>(0, _interruptJsDefault.default));
var _indexJs = require("./selection/index.js");
var _indexJs1 = require("./transition/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _activeJs = require("./active.js");
var _activeJsDefault = parcelHelpers.interopDefault(_activeJs);
var _interruptJs = require("./interrupt.js");
var _interruptJsDefault = parcelHelpers.interopDefault(_interruptJs);

},{"./selection/index.js":"kbAB7","./transition/index.js":"aaeaM","./active.js":"l9Cbz","./interrupt.js":"1GwKS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kbAB7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _d3Selection = require("d3-selection");
var _interruptJs = require("./interrupt.js");
var _interruptJsDefault = parcelHelpers.interopDefault(_interruptJs);
var _transitionJs = require("./transition.js");
var _transitionJsDefault = parcelHelpers.interopDefault(_transitionJs);
(0, _d3Selection.selection).prototype.interrupt = (0, _interruptJsDefault.default);
(0, _d3Selection.selection).prototype.transition = (0, _transitionJsDefault.default);

},{"d3-selection":[["selection","c44R6","default"]],"./interrupt.js":"6Q4h6","./transition.js":"4zdbY","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6Q4h6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        return this.each(function() {
            (0, _interruptJsDefault.default)(this, name);
        });
    });
var _interruptJs = require("../interrupt.js");
var _interruptJsDefault = parcelHelpers.interopDefault(_interruptJs);

},{"../interrupt.js":"1GwKS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1GwKS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node, name) {
        var schedules = node.__transition, schedule, active, empty = true, i;
        if (!schedules) return;
        name = name == null ? null : name + "";
        for(i in schedules){
            if ((schedule = schedules[i]).name !== name) {
                empty = false;
                continue;
            }
            active = schedule.state > (0, _scheduleJs.STARTING) && schedule.state < (0, _scheduleJs.ENDING);
            schedule.state = (0, _scheduleJs.ENDED);
            schedule.timer.stop();
            schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
            delete schedules[i];
        }
        if (empty) delete node.__transition;
    });
var _scheduleJs = require("./transition/schedule.js");

},{"./transition/schedule.js":"1oCbn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1oCbn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CREATED", ()=>CREATED);
parcelHelpers.export(exports, "SCHEDULED", ()=>SCHEDULED);
parcelHelpers.export(exports, "STARTING", ()=>STARTING);
parcelHelpers.export(exports, "STARTED", ()=>STARTED);
parcelHelpers.export(exports, "RUNNING", ()=>RUNNING);
parcelHelpers.export(exports, "ENDING", ()=>ENDING);
parcelHelpers.export(exports, "ENDED", ()=>ENDED);
parcelHelpers.export(exports, "default", ()=>function(node, name, id, index, group, timing) {
        var schedules = node.__transition;
        if (!schedules) node.__transition = {};
        else if (id in schedules) return;
        create(node, id, {
            name: name,
            index: index,
            group: group,
            on: emptyOn,
            tween: emptyTween,
            time: timing.time,
            delay: timing.delay,
            duration: timing.duration,
            ease: timing.ease,
            timer: null,
            state: CREATED
        });
    });
parcelHelpers.export(exports, "init", ()=>init);
parcelHelpers.export(exports, "set", ()=>set);
parcelHelpers.export(exports, "get", ()=>get);
var _d3Dispatch = require("d3-dispatch");
var _d3Timer = require("d3-timer");
var emptyOn = (0, _d3Dispatch.dispatch)("start", "end", "cancel", "interrupt");
var emptyTween = [];
var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;
function init(node, id) {
    var schedule = get(node, id);
    if (schedule.state > CREATED) throw new Error("too late; already scheduled");
    return schedule;
}
function set(node, id) {
    var schedule = get(node, id);
    if (schedule.state > STARTED) throw new Error("too late; already running");
    return schedule;
}
function get(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, _d3Timer.timer)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = SCHEDULED;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== SCHEDULED) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === STARTED) return (0, _d3Timer.timeout)(start);
            // Interrupt the active transition, if any.
            if (o.state === RUNNING) {
                o.state = ENDED;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = ENDED;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, _d3Timer.timeout)(function() {
            if (self.state === STARTED) {
                self.state = RUNNING;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = STARTING;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== STARTING) return; // interrupted
        self.state = STARTED;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === ENDING) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = ENDED;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}

},{"d3-dispatch":[["dispatch","avnlO","default"]],"d3-timer":[["timeout","gA1Vs","default"],["timer","bgtMb"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gA1Vs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, delay, time) {
        var t = new (0, _timerJs.Timer);
        delay = delay == null ? 0 : +delay;
        t.restart((elapsed)=>{
            t.stop();
            callback(elapsed + delay);
        }, delay, time);
        return t;
    });
var _timerJs = require("./timer.js");

},{"./timer.js":"bgtMb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bgtMb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "now", ()=>now);
parcelHelpers.export(exports, "Timer", ()=>Timer);
parcelHelpers.export(exports, "timer", ()=>timer);
parcelHelpers.export(exports, "timerFlush", ()=>timerFlush);
var frame = 0, timeout = 0, interval = 0, pokeDelay = 1000, taskHead, taskTail, clockLast = 0, clockNow = 0, clockSkew = 0, clock = typeof performance === "object" && performance.now ? performance : Date, setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function now() {
    return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}
function clearNow() {
    clockNow = 0;
}
function Timer() {
    this._call = this._time = this._next = null;
}
Timer.prototype = timer.prototype = {
    constructor: Timer,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && taskTail !== this) {
            if (taskTail) taskTail._next = this;
            else taskHead = this;
            taskTail = this;
        }
        this._call = callback;
        this._time = time;
        sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            sleep();
        }
    }
};
function timer(callback, delay, time) {
    var t = new Timer;
    t.restart(callback, delay, time);
    return t;
}
function timerFlush() {
    now(); // Get the current time, if not already set.
    ++frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = taskHead, e;
    while(t){
        if ((e = clockNow - t._time) >= 0) t._call.call(undefined, e);
        t = t._next;
    }
    --frame;
}
function wake() {
    clockNow = (clockLast = clock.now()) + clockSkew;
    frame = timeout = 0;
    try {
        timerFlush();
    } finally{
        frame = 0;
        nap();
        clockNow = 0;
    }
}
function poke() {
    var now = clock.now(), delay = now - clockLast;
    if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}
function nap() {
    var t0, t1 = taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
    taskTail = t0;
    sleep(time);
}
function sleep(time) {
    if (frame) return; // Soonest alarm already set, or will be.
    if (timeout) timeout = clearTimeout(timeout);
    var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
        if (interval) interval = clearInterval(interval);
    } else {
        if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
        frame = 1, setFrame(wake);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4zdbY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var id, timing;
        if (name instanceof (0, _indexJs.Transition)) id = name._id, name = name._name;
        else id = (0, _indexJs.newId)(), (timing = defaultTiming).time = (0, _d3Timer.now)(), name = name == null ? null : name + "";
        for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, _scheduleJsDefault.default)(node, name, id, i, group, timing || inherit(node, id));
        }
        return new (0, _indexJs.Transition)(groups, this._parents, name, id);
    });
var _indexJs = require("../transition/index.js");
var _scheduleJs = require("../transition/schedule.js");
var _scheduleJsDefault = parcelHelpers.interopDefault(_scheduleJs);
var _d3Ease = require("d3-ease");
var _d3Timer = require("d3-timer");
var defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, _d3Ease.easeCubicInOut)
};
function inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
    }
    return timing;
}

},{"../transition/index.js":"aaeaM","../transition/schedule.js":"1oCbn","d3-ease":[["easeCubicInOut","eWkjr","cubicInOut"]],"d3-timer":"bgtMb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aaeaM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Transition", ()=>Transition);
parcelHelpers.export(exports, "default", ()=>transition);
parcelHelpers.export(exports, "newId", ()=>newId);
var _d3Selection = require("d3-selection");
var _attrJs = require("./attr.js");
var _attrJsDefault = parcelHelpers.interopDefault(_attrJs);
var _attrTweenJs = require("./attrTween.js");
var _attrTweenJsDefault = parcelHelpers.interopDefault(_attrTweenJs);
var _delayJs = require("./delay.js");
var _delayJsDefault = parcelHelpers.interopDefault(_delayJs);
var _durationJs = require("./duration.js");
var _durationJsDefault = parcelHelpers.interopDefault(_durationJs);
var _easeJs = require("./ease.js");
var _easeJsDefault = parcelHelpers.interopDefault(_easeJs);
var _easeVaryingJs = require("./easeVarying.js");
var _easeVaryingJsDefault = parcelHelpers.interopDefault(_easeVaryingJs);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _mergeJs = require("./merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _onJs = require("./on.js");
var _onJsDefault = parcelHelpers.interopDefault(_onJs);
var _removeJs = require("./remove.js");
var _removeJsDefault = parcelHelpers.interopDefault(_removeJs);
var _selectJs = require("./select.js");
var _selectJsDefault = parcelHelpers.interopDefault(_selectJs);
var _selectAllJs = require("./selectAll.js");
var _selectAllJsDefault = parcelHelpers.interopDefault(_selectAllJs);
var _selectionJs = require("./selection.js");
var _selectionJsDefault = parcelHelpers.interopDefault(_selectionJs);
var _styleJs = require("./style.js");
var _styleJsDefault = parcelHelpers.interopDefault(_styleJs);
var _styleTweenJs = require("./styleTween.js");
var _styleTweenJsDefault = parcelHelpers.interopDefault(_styleTweenJs);
var _textJs = require("./text.js");
var _textJsDefault = parcelHelpers.interopDefault(_textJs);
var _textTweenJs = require("./textTween.js");
var _textTweenJsDefault = parcelHelpers.interopDefault(_textTweenJs);
var _transitionJs = require("./transition.js");
var _transitionJsDefault = parcelHelpers.interopDefault(_transitionJs);
var _tweenJs = require("./tween.js");
var _tweenJsDefault = parcelHelpers.interopDefault(_tweenJs);
var _endJs = require("./end.js");
var _endJsDefault = parcelHelpers.interopDefault(_endJs);
var id = 0;
function Transition(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function transition(name) {
    return (0, _d3Selection.selection)().transition(name);
}
function newId() {
    return ++id;
}
var selection_prototype = (0, _d3Selection.selection).prototype;
Transition.prototype = transition.prototype = {
    constructor: Transition,
    select: (0, _selectJsDefault.default),
    selectAll: (0, _selectAllJsDefault.default),
    selectChild: selection_prototype.selectChild,
    selectChildren: selection_prototype.selectChildren,
    filter: (0, _filterJsDefault.default),
    merge: (0, _mergeJsDefault.default),
    selection: (0, _selectionJsDefault.default),
    transition: (0, _transitionJsDefault.default),
    call: selection_prototype.call,
    nodes: selection_prototype.nodes,
    node: selection_prototype.node,
    size: selection_prototype.size,
    empty: selection_prototype.empty,
    each: selection_prototype.each,
    on: (0, _onJsDefault.default),
    attr: (0, _attrJsDefault.default),
    attrTween: (0, _attrTweenJsDefault.default),
    style: (0, _styleJsDefault.default),
    styleTween: (0, _styleTweenJsDefault.default),
    text: (0, _textJsDefault.default),
    textTween: (0, _textTweenJsDefault.default),
    remove: (0, _removeJsDefault.default),
    tween: (0, _tweenJsDefault.default),
    delay: (0, _delayJsDefault.default),
    duration: (0, _durationJsDefault.default),
    ease: (0, _easeJsDefault.default),
    easeVarying: (0, _easeVaryingJsDefault.default),
    end: (0, _endJsDefault.default),
    [Symbol.iterator]: selection_prototype[Symbol.iterator]
};

},{"d3-selection":[["selection","c44R6","default"]],"./attr.js":"9pTF6","./attrTween.js":"4y7yx","./delay.js":"jpYbS","./duration.js":"bS8QM","./ease.js":"ch4gA","./easeVarying.js":"9tsi5","./filter.js":"1SOMQ","./merge.js":"3i9NJ","./on.js":"2aVC6","./remove.js":"2AsGY","./select.js":"ctive","./selectAll.js":"9V26T","./selection.js":"a3x7P","./style.js":"2gmad","./styleTween.js":"cyLVZ","./text.js":"dNCcW","./textTween.js":"fUt07","./transition.js":"hRfsB","./tween.js":"ecbar","./end.js":"9nUPj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9pTF6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var fullname = (0, _d3Selection.namespace)(name), i = fullname === "transform" ? (0, _d3Interpolate.interpolateTransformSvg) : (0, _interpolateJsDefault.default);
        return this.attrTween(name, typeof value === "function" ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, (0, _tweenJs.tweenValue)(this, "attr." + name, value)) : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname) : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value));
    });
var _d3Interpolate = require("d3-interpolate");
var _d3Selection = require("d3-selection");
var _tweenJs = require("./tween.js");
var _interpolateJs = require("./interpolate.js");
var _interpolateJsDefault = parcelHelpers.interopDefault(_interpolateJs);
function attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}

},{"d3-interpolate":"iN9Uy","d3-selection":[["namespace","e2lf9","default"]],"./tween.js":"ecbar","./interpolate.js":"ixUdt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iN9Uy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interpolateTransformCss", ()=>interpolateTransformCss);
parcelHelpers.export(exports, "interpolateTransformSvg", ()=>interpolateTransformSvg);
var _numberJs = require("../number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _parseJs = require("./parse.js");
function interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, _numberJsDefault.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, _numberJsDefault.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, _numberJsDefault.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, _numberJsDefault.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, _numberJsDefault.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, _numberJsDefault.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var interpolateTransformCss = interpolateTransform((0, _parseJs.parseCss), "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform((0, _parseJs.parseSvg), ", ", ")", ")");

},{"../number.js":"lU4Z0","./parse.js":"4Gvvu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4Gvvu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/* eslint-disable no-undef */ parcelHelpers.export(exports, "parseCss", ()=>parseCss);
parcelHelpers.export(exports, "parseSvg", ()=>parseSvg);
var _decomposeJs = require("./decompose.js");
var _decomposeJsDefault = parcelHelpers.interopDefault(_decomposeJs);
var svgNode;
function parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, _decomposeJs.identity) : (0, _decomposeJsDefault.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function parseSvg(value) {
    if (value == null) return 0, _decomposeJs.identity;
    if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    svgNode.setAttribute("transform", value);
    if (!(value = svgNode.transform.baseVal.consolidate())) return 0, _decomposeJs.identity;
    value = value.matrix;
    return (0, _decomposeJsDefault.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

},{"./decompose.js":"8mHaF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8mHaF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "default", ()=>function(a, b, c, d, e, f) {
        var scaleX, scaleY, skewX;
        if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
        if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
        if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
        if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
        return {
            translateX: e,
            translateY: f,
            rotate: Math.atan2(b, a) * degrees,
            skewX: Math.atan(skewX) * degrees,
            scaleX: scaleX,
            scaleY: scaleY
        };
    });
var degrees = 180 / Math.PI;
var identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ecbar":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var id = this._id;
        name += "";
        if (arguments.length < 2) {
            var tween = (0, _scheduleJs.get)(this.node(), id).tween;
            for(var i = 0, n = tween.length, t; i < n; ++i){
                if ((t = tween[i]).name === name) return t.value;
            }
            return null;
        }
        return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
    });
parcelHelpers.export(exports, "tweenValue", ()=>tweenValue);
var _scheduleJs = require("./schedule.js");
function tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, _scheduleJs.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, _scheduleJs.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function tweenValue(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, _scheduleJs.set)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, _scheduleJs.get)(node, id).value[name];
    };
}

},{"./schedule.js":"1oCbn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ixUdt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var c;
        return (typeof b === "number" ? (0, _d3Interpolate.interpolateNumber) : b instanceof (0, _d3Color.color) ? (0, _d3Interpolate.interpolateRgb) : (c = (0, _d3Color.color)(b)) ? (b = c, _d3Interpolate.interpolateRgb) : (0, _d3Interpolate.interpolateString))(a, b);
    });
var _d3Color = require("d3-color");
var _d3Interpolate = require("d3-interpolate");

},{"d3-color":[["color","cZjkf","default"]],"d3-interpolate":[["interpolateNumber","lU4Z0","default"],["interpolateRgb","bG7wU","default"],["interpolateString","iNjOh","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4y7yx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var key = "attr." + name;
        if (arguments.length < 2) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        var fullname = (0, _d3Selection.namespace)(name);
        return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
    });
var _d3Selection = require("d3-selection");
function attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}

},{"d3-selection":[["namespace","e2lf9","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jpYbS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        var id = this._id;
        return arguments.length ? this.each((typeof value === "function" ? delayFunction : delayConstant)(id, value)) : (0, _scheduleJs.get)(this.node(), id).delay;
    });
var _scheduleJs = require("./schedule.js");
function delayFunction(id, value) {
    return function() {
        (0, _scheduleJs.init)(this, id).delay = +value.apply(this, arguments);
    };
}
function delayConstant(id, value) {
    return value = +value, function() {
        (0, _scheduleJs.init)(this, id).delay = value;
    };
}

},{"./schedule.js":"1oCbn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bS8QM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        var id = this._id;
        return arguments.length ? this.each((typeof value === "function" ? durationFunction : durationConstant)(id, value)) : (0, _scheduleJs.get)(this.node(), id).duration;
    });
var _scheduleJs = require("./schedule.js");
function durationFunction(id, value) {
    return function() {
        (0, _scheduleJs.set)(this, id).duration = +value.apply(this, arguments);
    };
}
function durationConstant(id, value) {
    return value = +value, function() {
        (0, _scheduleJs.set)(this, id).duration = value;
    };
}

},{"./schedule.js":"1oCbn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ch4gA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        var id = this._id;
        return arguments.length ? this.each(easeConstant(id, value)) : (0, _scheduleJs.get)(this.node(), id).ease;
    });
var _scheduleJs = require("./schedule.js");
function easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, _scheduleJs.set)(this, id).ease = value;
    };
}

},{"./schedule.js":"1oCbn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9tsi5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        if (typeof value !== "function") throw new Error;
        return this.each(easeVarying(this._id, value));
    });
var _scheduleJs = require("./schedule.js");
function easeVarying(id, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (typeof v !== "function") throw new Error;
        (0, _scheduleJs.set)(this, id).ease = v;
    };
}

},{"./schedule.js":"1oCbn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1SOMQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(match) {
        if (typeof match !== "function") match = (0, _d3Selection.matcher)(match);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
        }
        return new (0, _indexJs.Transition)(subgroups, this._parents, this._name, this._id);
    });
var _d3Selection = require("d3-selection");
var _indexJs = require("./index.js");

},{"d3-selection":[["matcher","iOc8r","default"]],"./index.js":"aaeaM","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3i9NJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(transition) {
        if (transition._id !== this._id) throw new Error;
        for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
            for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
        }
        for(; j < m0; ++j)merges[j] = groups0[j];
        return new (0, _indexJs.Transition)(merges, this._parents, this._name, this._id);
    });
var _indexJs = require("./index.js");

},{"./index.js":"aaeaM","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2aVC6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, listener) {
        var id = this._id;
        return arguments.length < 2 ? (0, _scheduleJs.get)(this.node(), id).on.on(name) : this.each(onFunction(id, name, listener));
    });
var _scheduleJs = require("./schedule.js");
function start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function onFunction(id, name, listener) {
    var on0, on1, sit = start(name) ? (0, _scheduleJs.init) : (0, _scheduleJs.set);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}

},{"./schedule.js":"1oCbn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2AsGY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.on("end.remove", removeFunction(this._id));
    });
function removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ctive":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(select) {
        var name = this._name, id = this._id;
        if (typeof select !== "function") select = (0, _d3Selection.selector)(select);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
                if ("__data__" in node) subnode.__data__ = node.__data__;
                subgroup[i] = subnode;
                (0, _scheduleJsDefault.default)(subgroup[i], name, id, i, subgroup, (0, _scheduleJs.get)(node, id));
            }
        }
        return new (0, _indexJs.Transition)(subgroups, this._parents, name, id);
    });
var _d3Selection = require("d3-selection");
var _indexJs = require("./index.js");
var _scheduleJs = require("./schedule.js");
var _scheduleJsDefault = parcelHelpers.interopDefault(_scheduleJs);

},{"d3-selection":[["selector","4I2PW","default"]],"./index.js":"aaeaM","./schedule.js":"1oCbn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9V26T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(select) {
        var name = this._name, id = this._id;
        if (typeof select !== "function") select = (0, _d3Selection.selectorAll)(select);
        for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, _scheduleJs.get)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, _scheduleJsDefault.default)(child, name, id, k, children, inherit);
                subgroups.push(children);
                parents.push(node);
            }
        }
        return new (0, _indexJs.Transition)(subgroups, parents, name, id);
    });
var _d3Selection = require("d3-selection");
var _indexJs = require("./index.js");
var _scheduleJs = require("./schedule.js");
var _scheduleJsDefault = parcelHelpers.interopDefault(_scheduleJs);

},{"d3-selection":[["selectorAll","9H6e7","default"]],"./index.js":"aaeaM","./schedule.js":"1oCbn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a3x7P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return new Selection(this._groups, this._parents);
    });
var _d3Selection = require("d3-selection");
var Selection = (0, _d3Selection.selection).prototype.constructor;

},{"d3-selection":[["selection","c44R6","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2gmad":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value, priority) {
        var i = (name += "") === "transform" ? (0, _d3Interpolate.interpolateTransformCss) : (0, _interpolateJsDefault.default);
        return value == null ? this.styleTween(name, styleNull(name, i)).on("end.style." + name, styleRemove(name)) : typeof value === "function" ? this.styleTween(name, styleFunction(name, i, (0, _tweenJs.tweenValue)(this, "style." + name, value))).each(styleMaybeRemove(this._id, name)) : this.styleTween(name, styleConstant(name, i, value), priority).on("end.style." + name, null);
    });
var _d3Interpolate = require("d3-interpolate");
var _d3Selection = require("d3-selection");
var _scheduleJs = require("./schedule.js");
var _tweenJs = require("./tween.js");
var _interpolateJs = require("./interpolate.js");
var _interpolateJsDefault = parcelHelpers.interopDefault(_interpolateJs);
function styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, _d3Selection.style)(this, name), string1 = (this.style.removeProperty(name), (0, _d3Selection.style)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, _d3Selection.style)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, _d3Selection.style)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, _d3Selection.style)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, _scheduleJs.set)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}

},{"d3-interpolate":"iN9Uy","d3-selection":[["style","jEBVs","styleValue"]],"./schedule.js":"1oCbn","./tween.js":"ecbar","./interpolate.js":"ixUdt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cyLVZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value, priority) {
        var key = "style." + (name += "");
        if (arguments.length < 2) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
    });
function styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dNCcW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return this.tween("text", typeof value === "function" ? textFunction((0, _tweenJs.tweenValue)(this, "text", value)) : textConstant(value == null ? "" : value + ""));
    });
var _tweenJs = require("./tween.js");
function textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}

},{"./tween.js":"ecbar","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fUt07":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        var key = "text";
        if (arguments.length < 1) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        return this.tween(key, textTween(value));
    });
function textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hRfsB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var name = this._name, id0 = this._id, id1 = (0, _indexJs.newId)();
        for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                var inherit = (0, _scheduleJs.get)(node, id0);
                (0, _scheduleJsDefault.default)(node, name, id1, i, group, {
                    time: inherit.time + inherit.delay + inherit.duration,
                    delay: 0,
                    duration: inherit.duration,
                    ease: inherit.ease
                });
            }
        }
        return new (0, _indexJs.Transition)(groups, this._parents, name, id1);
    });
var _indexJs = require("./index.js");
var _scheduleJs = require("./schedule.js");
var _scheduleJsDefault = parcelHelpers.interopDefault(_scheduleJs);

},{"./index.js":"aaeaM","./schedule.js":"1oCbn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9nUPj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var on0, on1, that = this, id = that._id, size = that.size();
        return new Promise(function(resolve, reject) {
            var cancel = {
                value: reject
            }, end = {
                value: function() {
                    if (--size === 0) resolve();
                }
            };
            that.each(function() {
                var schedule = (0, _scheduleJs.set)(this, id), on = schedule.on;
                // If this node shared a dispatch with the previous node,
                // just assign the updated shared dispatch and we’re done!
                // Otherwise, copy-on-write.
                if (on !== on0) {
                    on1 = (on0 = on).copy();
                    on1._.cancel.push(cancel);
                    on1._.interrupt.push(cancel);
                    on1._.end.push(end);
                }
                schedule.on = on1;
            });
            // The selection was empty, resolve end immediately
            if (size === 0) resolve();
        });
    });
var _scheduleJs = require("./schedule.js");

},{"./schedule.js":"1oCbn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eWkjr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cubicIn", ()=>cubicIn);
parcelHelpers.export(exports, "cubicOut", ()=>cubicOut);
parcelHelpers.export(exports, "cubicInOut", ()=>cubicInOut);
function cubicIn(t) {
    return t * t * t;
}
function cubicOut(t) {
    return --t * t * t + 1;
}
function cubicInOut(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l9Cbz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node, name) {
        var schedules = node.__transition, schedule, i;
        if (schedules) {
            name = name == null ? null : name + "";
            for(i in schedules){
                if ((schedule = schedules[i]).state > (0, _scheduleJs.SCHEDULED) && schedule.name === name) return new (0, _indexJs.Transition)([
                    [
                        node
                    ]
                ], root, name, +i);
            }
        }
        return null;
    });
var _indexJs = require("./transition/index.js");
var _scheduleJs = require("./transition/schedule.js");
var root = [
    null
];

},{"./transition/index.js":"aaeaM","./transition/schedule.js":"1oCbn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9KcHm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>()=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"14hSA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BrushEvent);
function BrushEvent(type, { sourceEvent, target, selection, mode, dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        selection: {
            value: selection,
            enumerable: true,
            configurable: true
        },
        mode: {
            value: mode,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g2Qnx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nopropagation", ()=>nopropagation);
parcelHelpers.export(exports, "default", ()=>function(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    });
function nopropagation(event) {
    event.stopImmediatePropagation();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fhDFW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chord", ()=>(0, _chordJsDefault.default));
parcelHelpers.export(exports, "chordTranspose", ()=>(0, _chordJs.chordTranspose));
parcelHelpers.export(exports, "chordDirected", ()=>(0, _chordJs.chordDirected));
parcelHelpers.export(exports, "ribbon", ()=>(0, _ribbonJsDefault.default));
parcelHelpers.export(exports, "ribbonArrow", ()=>(0, _ribbonJs.ribbonArrow));
var _chordJs = require("./chord.js");
var _chordJsDefault = parcelHelpers.interopDefault(_chordJs);
var _ribbonJs = require("./ribbon.js");
var _ribbonJsDefault = parcelHelpers.interopDefault(_ribbonJs);

},{"./chord.js":"g22rh","./ribbon.js":"eR2Yx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g22rh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return chord(false, false);
    });
parcelHelpers.export(exports, "chordTranspose", ()=>chordTranspose);
parcelHelpers.export(exports, "chordDirected", ()=>chordDirected);
var _mathJs = require("./math.js");
function range(i, j) {
    return Array.from({
        length: j - i
    }, (_, k)=>i + k);
}
function compareValue(compare) {
    return function(a, b) {
        return compare(a.source.value + a.target.value, b.source.value + b.target.value);
    };
}
function chordTranspose() {
    return chord(false, true);
}
function chordDirected() {
    return chord(true, false);
}
function chord(directed, transpose) {
    var padAngle = 0, sortGroups = null, sortSubgroups = null, sortChords = null;
    function chord(matrix) {
        var n = matrix.length, groupSums = new Array(n), groupIndex = range(0, n), chords = new Array(n * n), groups = new Array(n), k = 0, dx;
        matrix = Float64Array.from({
            length: n * n
        }, transpose ? (_, i)=>matrix[i % n][i / n | 0] : (_, i)=>matrix[i / n | 0][i % n]);
        // Compute the scaling factor from value to angle in [0, 2pi].
        for(let i = 0; i < n; ++i){
            let x = 0;
            for(let j = 0; j < n; ++j)x += matrix[i * n + j] + directed * matrix[j * n + i];
            k += groupSums[i] = x;
        }
        k = (0, _mathJs.max)(0, (0, _mathJs.tau) - padAngle * n) / k;
        dx = k ? padAngle : (0, _mathJs.tau) / n;
        // Compute the angles for each group and constituent chord.
        {
            let x = 0;
            if (sortGroups) groupIndex.sort((a, b)=>sortGroups(groupSums[a], groupSums[b]));
            for (const i of groupIndex){
                const x0 = x;
                if (directed) {
                    const subgroupIndex = range(~n + 1, n).filter((j)=>j < 0 ? matrix[~j * n + i] : matrix[i * n + j]);
                    if (sortSubgroups) subgroupIndex.sort((a, b)=>sortSubgroups(a < 0 ? -matrix[~a * n + i] : matrix[i * n + a], b < 0 ? -matrix[~b * n + i] : matrix[i * n + b]));
                    for (const j of subgroupIndex)if (j < 0) {
                        const chord = chords[~j * n + i] || (chords[~j * n + i] = {
                            source: null,
                            target: null
                        });
                        chord.target = {
                            index: i,
                            startAngle: x,
                            endAngle: x += matrix[~j * n + i] * k,
                            value: matrix[~j * n + i]
                        };
                    } else {
                        const chord = chords[i * n + j] || (chords[i * n + j] = {
                            source: null,
                            target: null
                        });
                        chord.source = {
                            index: i,
                            startAngle: x,
                            endAngle: x += matrix[i * n + j] * k,
                            value: matrix[i * n + j]
                        };
                    }
                    groups[i] = {
                        index: i,
                        startAngle: x0,
                        endAngle: x,
                        value: groupSums[i]
                    };
                } else {
                    const subgroupIndex = range(0, n).filter((j)=>matrix[i * n + j] || matrix[j * n + i]);
                    if (sortSubgroups) subgroupIndex.sort((a, b)=>sortSubgroups(matrix[i * n + a], matrix[i * n + b]));
                    for (const j of subgroupIndex){
                        let chord;
                        if (i < j) {
                            chord = chords[i * n + j] || (chords[i * n + j] = {
                                source: null,
                                target: null
                            });
                            chord.source = {
                                index: i,
                                startAngle: x,
                                endAngle: x += matrix[i * n + j] * k,
                                value: matrix[i * n + j]
                            };
                        } else {
                            chord = chords[j * n + i] || (chords[j * n + i] = {
                                source: null,
                                target: null
                            });
                            chord.target = {
                                index: i,
                                startAngle: x,
                                endAngle: x += matrix[i * n + j] * k,
                                value: matrix[i * n + j]
                            };
                            if (i === j) chord.source = chord.target;
                        }
                        if (chord.source && chord.target && chord.source.value < chord.target.value) {
                            const source = chord.source;
                            chord.source = chord.target;
                            chord.target = source;
                        }
                    }
                    groups[i] = {
                        index: i,
                        startAngle: x0,
                        endAngle: x,
                        value: groupSums[i]
                    };
                }
                x += dx;
            }
        }
        // Remove empty chords.
        chords = Object.values(chords);
        chords.groups = groups;
        return sortChords ? chords.sort(sortChords) : chords;
    }
    chord.padAngle = function(_) {
        return arguments.length ? (padAngle = (0, _mathJs.max)(0, _), chord) : padAngle;
    };
    chord.sortGroups = function(_) {
        return arguments.length ? (sortGroups = _, chord) : sortGroups;
    };
    chord.sortSubgroups = function(_) {
        return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
    };
    chord.sortChords = function(_) {
        return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
    };
    return chord;
}

},{"./math.js":"Zi3zs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"Zi3zs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "abs", ()=>abs);
parcelHelpers.export(exports, "cos", ()=>cos);
parcelHelpers.export(exports, "sin", ()=>sin);
parcelHelpers.export(exports, "pi", ()=>pi);
parcelHelpers.export(exports, "halfPi", ()=>halfPi);
parcelHelpers.export(exports, "tau", ()=>tau);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "epsilon", ()=>epsilon);
var abs = Math.abs;
var cos = Math.cos;
var sin = Math.sin;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = pi * 2;
var max = Math.max;
var epsilon = 1e-12;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eR2Yx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return ribbon();
    });
parcelHelpers.export(exports, "ribbonArrow", ()=>ribbonArrow);
var _d3Path = require("d3-path");
var _arrayJs = require("./array.js");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _mathJs = require("./math.js");
function defaultSource(d) {
    return d.source;
}
function defaultTarget(d) {
    return d.target;
}
function defaultRadius(d) {
    return d.radius;
}
function defaultStartAngle(d) {
    return d.startAngle;
}
function defaultEndAngle(d) {
    return d.endAngle;
}
function defaultPadAngle() {
    return 0;
}
function defaultArrowheadRadius() {
    return 10;
}
function ribbon(headRadius) {
    var source = defaultSource, target = defaultTarget, sourceRadius = defaultRadius, targetRadius = defaultRadius, startAngle = defaultStartAngle, endAngle = defaultEndAngle, padAngle = defaultPadAngle, context = null;
    function ribbon() {
        var buffer, s = source.apply(this, arguments), t = target.apply(this, arguments), ap = padAngle.apply(this, arguments) / 2, argv = (0, _arrayJs.slice).call(arguments), sr = +sourceRadius.apply(this, (argv[0] = s, argv)), sa0 = startAngle.apply(this, argv) - (0, _mathJs.halfPi), sa1 = endAngle.apply(this, argv) - (0, _mathJs.halfPi), tr = +targetRadius.apply(this, (argv[0] = t, argv)), ta0 = startAngle.apply(this, argv) - (0, _mathJs.halfPi), ta1 = endAngle.apply(this, argv) - (0, _mathJs.halfPi);
        if (!context) context = buffer = (0, _d3Path.path)();
        if (ap > (0, _mathJs.epsilon)) {
            if ((0, _mathJs.abs)(sa1 - sa0) > ap * 2 + (0, _mathJs.epsilon)) sa1 > sa0 ? (sa0 += ap, sa1 -= ap) : (sa0 -= ap, sa1 += ap);
            else sa0 = sa1 = (sa0 + sa1) / 2;
            if ((0, _mathJs.abs)(ta1 - ta0) > ap * 2 + (0, _mathJs.epsilon)) ta1 > ta0 ? (ta0 += ap, ta1 -= ap) : (ta0 -= ap, ta1 += ap);
            else ta0 = ta1 = (ta0 + ta1) / 2;
        }
        context.moveTo(sr * (0, _mathJs.cos)(sa0), sr * (0, _mathJs.sin)(sa0));
        context.arc(0, 0, sr, sa0, sa1);
        if (sa0 !== ta0 || sa1 !== ta1) {
            if (headRadius) {
                var hr = +headRadius.apply(this, arguments), tr2 = tr - hr, ta2 = (ta0 + ta1) / 2;
                context.quadraticCurveTo(0, 0, tr2 * (0, _mathJs.cos)(ta0), tr2 * (0, _mathJs.sin)(ta0));
                context.lineTo(tr * (0, _mathJs.cos)(ta2), tr * (0, _mathJs.sin)(ta2));
                context.lineTo(tr2 * (0, _mathJs.cos)(ta1), tr2 * (0, _mathJs.sin)(ta1));
            } else {
                context.quadraticCurveTo(0, 0, tr * (0, _mathJs.cos)(ta0), tr * (0, _mathJs.sin)(ta0));
                context.arc(0, 0, tr, ta0, ta1);
            }
        }
        context.quadraticCurveTo(0, 0, sr * (0, _mathJs.cos)(sa0), sr * (0, _mathJs.sin)(sa0));
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    if (headRadius) ribbon.headRadius = function(_) {
        return arguments.length ? (headRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), ribbon) : headRadius;
    };
    ribbon.radius = function(_) {
        return arguments.length ? (sourceRadius = targetRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), ribbon) : sourceRadius;
    };
    ribbon.sourceRadius = function(_) {
        return arguments.length ? (sourceRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), ribbon) : sourceRadius;
    };
    ribbon.targetRadius = function(_) {
        return arguments.length ? (targetRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), ribbon) : targetRadius;
    };
    ribbon.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), ribbon) : startAngle;
    };
    ribbon.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), ribbon) : endAngle;
    };
    ribbon.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), ribbon) : padAngle;
    };
    ribbon.source = function(_) {
        return arguments.length ? (source = _, ribbon) : source;
    };
    ribbon.target = function(_) {
        return arguments.length ? (target = _, ribbon) : target;
    };
    ribbon.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, ribbon) : context;
    };
    return ribbon;
}
function ribbonArrow() {
    return ribbon(defaultArrowheadRadius);
}

},{"d3-path":"jFrOU","./array.js":"5zjqp","./constant.js":"5dZsq","./math.js":"Zi3zs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jFrOU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Path", ()=>Path);
parcelHelpers.export(exports, "path", ()=>path);
parcelHelpers.export(exports, "pathRound", ()=>pathRound);
const pi = Math.PI, tau = 2 * pi, epsilon = 1e-6, tauEpsilon = tau - epsilon;
function append(strings) {
    this._ += strings[0];
    for(let i = 1, n = strings.length; i < n; ++i)this._ += arguments[i] + strings[i];
}
function appendRound(digits) {
    let d = Math.floor(digits);
    if (!(d >= 0)) throw new Error(`invalid digits: ${digits}`);
    if (d > 15) return append;
    const k = 10 ** d;
    return function(strings) {
        this._ += strings[0];
        for(let i = 1, n = strings.length; i < n; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
    };
}
class Path {
    constructor(digits){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
        this._append = digits == null ? append : appendRound(digits);
    }
    moveTo(x, y) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._append`Z`;
        }
    }
    lineTo(x, y) {
        this._append`L${this._x1 = +x},${this._y1 = +y}`;
    }
    quadraticCurveTo(x1, y1, x, y) {
        this._append`Q${+x1},${+y1},${this._x1 = +x},${this._y1 = +y}`;
    }
    bezierCurveTo(x1, y1, x2, y2, x, y) {
        this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x},${this._y1 = +y}`;
    }
    arcTo(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._append`M${this._x1 = x1},${this._y1 = y1}`;
        else if (!(l01_2 > epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) this._append`L${this._x1 = x1},${this._y1 = y1}`;
        else {
            let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > epsilon) this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
            this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
        }
    }
    arc(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._append`M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) this._append`L${x0},${y0}`;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % tau + tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > tauEpsilon) this._append`A${r},${r},0,1,${cw},${x - dx},${y - dy}A${r},${r},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
        else if (da > epsilon) this._append`A${r},${r},0,${+(da >= pi)},${cw},${this._x1 = x + r * Math.cos(a1)},${this._y1 = y + r * Math.sin(a1)}`;
    }
    rect(x, y, w, h) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${w = +w}v${+h}h${-w}Z`;
    }
    toString() {
        return this._;
    }
}
function path() {
    return new Path;
}
// Allow instanceof d3.path
path.prototype = Path.prototype;
function pathRound(digits = 3) {
    return new Path(+digits);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5zjqp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", ()=>slice);
var slice = Array.prototype.slice;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5dZsq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c8Fkk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "color", ()=>(0, _colorJsDefault.default));
parcelHelpers.export(exports, "rgb", ()=>(0, _colorJs.rgb));
parcelHelpers.export(exports, "hsl", ()=>(0, _colorJs.hsl));
parcelHelpers.export(exports, "lab", ()=>(0, _labJsDefault.default));
parcelHelpers.export(exports, "hcl", ()=>(0, _labJs.hcl));
parcelHelpers.export(exports, "lch", ()=>(0, _labJs.lch));
parcelHelpers.export(exports, "gray", ()=>(0, _labJs.gray));
parcelHelpers.export(exports, "cubehelix", ()=>(0, _cubehelixJsDefault.default));
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
var _labJs = require("./lab.js");
var _labJsDefault = parcelHelpers.interopDefault(_labJs);
var _cubehelixJs = require("./cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);

},{"./color.js":"cZjkf","./lab.js":"bikfP","./cubehelix.js":"b6Cou","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bikfP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gray", ()=>gray);
parcelHelpers.export(exports, "default", ()=>lab);
parcelHelpers.export(exports, "Lab", ()=>Lab);
parcelHelpers.export(exports, "lch", ()=>lch);
parcelHelpers.export(exports, "hcl", ()=>hcl);
parcelHelpers.export(exports, "Hcl", ()=>Hcl);
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
var _colorJs = require("./color.js");
var _mathJs = require("./math.js");
// https://observablehq.com/@mbostock/lab-and-rgb
const K = 18, Xn = 0.96422, Yn = 1, Zn = 0.82521, t0 = 4 / 29, t1 = 6 / 29, t2 = 3 * t1 * t1, t3 = t1 * t1 * t1;
function labConvert(o) {
    if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof Hcl) return hcl2lab(o);
    if (!(o instanceof (0, _colorJs.Rgb))) o = (0, _colorJs.rgbConvert)(o);
    var r = rgb2lrgb(o.r), g = rgb2lrgb(o.g), b = rgb2lrgb(o.b), y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
        z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
    }
    return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function gray(l, opacity) {
    return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function lab(l, a, b, opacity) {
    return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}
function Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Lab, lab, (0, _defineJs.extend)((0, _colorJs.Color), {
    brighter (k) {
        return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = Xn * lab2xyz(x);
        y = Yn * lab2xyz(y);
        z = Zn * lab2xyz(z);
        return new (0, _colorJs.Rgb)(lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function xyz2lab(t) {
    return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}
function lab2xyz(t) {
    return t > t1 ? t * t * t : t2 * (t - t0);
}
function lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function hclConvert(o) {
    if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof Lab)) o = labConvert(o);
    if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * (0, _mathJs.degrees);
    return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function lch(l, c, h, opacity) {
    return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function hcl(h, c, l, opacity) {
    return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function hcl2lab(o) {
    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
    var h = o.h * (0, _mathJs.radians);
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, _defineJsDefault.default)(Hcl, hcl, (0, _defineJs.extend)((0, _colorJs.Color), {
    brighter (k) {
        return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return hcl2lab(this).rgb();
    }
}));

},{"./define.js":"34Inj","./color.js":"cZjkf","./math.js":"ddscs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ddscs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "radians", ()=>radians);
parcelHelpers.export(exports, "degrees", ()=>degrees);
const radians = Math.PI / 180;
const degrees = 180 / Math.PI;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b6Cou":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cubehelix);
parcelHelpers.export(exports, "Cubehelix", ()=>Cubehelix);
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
var _colorJs = require("./color.js");
var _mathJs = require("./math.js");
var A = -0.14861, B = 1.78277, C = -0.29227, D = -0.90649, E = 1.97294, ED = E * D, EB = E * B, BC_DA = B * C - D * A;
function cubehelixConvert(o) {
    if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, _colorJs.Rgb))) o = (0, _colorJs.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB), bl = b - l, k = (E * (g - l) - C * bl) / D, s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, _mathJs.degrees) - 120 : NaN;
    return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Cubehelix, cubehelix, (0, _defineJs.extend)((0, _colorJs.Color), {
    brighter (k) {
        k = k == null ? (0, _colorJs.brighter) : Math.pow((0, _colorJs.brighter), k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? (0, _colorJs.darker) : Math.pow((0, _colorJs.darker), k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, _mathJs.radians), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, _colorJs.Rgb)(255 * (l + a * (A * cosh + B * sinh)), 255 * (l + a * (C * cosh + D * sinh)), 255 * (l + a * (E * cosh)), this.opacity);
    }
}));

},{"./define.js":"34Inj","./color.js":"cZjkf","./math.js":"ddscs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k46dS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "contours", ()=>(0, _contoursJsDefault.default));
parcelHelpers.export(exports, "contourDensity", ()=>(0, _densityJsDefault.default));
var _contoursJs = require("./contours.js");
var _contoursJsDefault = parcelHelpers.interopDefault(_contoursJs);
var _densityJs = require("./density.js");
var _densityJsDefault = parcelHelpers.interopDefault(_densityJs);

},{"./contours.js":"ftAFW","./density.js":"jY6zK","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ftAFW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var dx = 1, dy = 1, threshold = (0, _d3Array.thresholdSturges), smooth = smoothLinear;
        function contours(values) {
            var tz = threshold(values);
            // Convert number of thresholds into uniform thresholds.
            if (!Array.isArray(tz)) {
                const e = (0, _d3Array.extent)(values, finite);
                tz = (0, _d3Array.ticks)(...(0, _d3Array.nice)(e[0], e[1], tz), tz);
                while(tz[tz.length - 1] >= e[1])tz.pop();
                while(tz[1] < e[0])tz.shift();
            } else tz = tz.slice().sort((0, _ascendingJsDefault.default));
            return tz.map((value)=>contour(values, value));
        }
        // Accumulate, smooth contour rings, assign holes to exterior rings.
        // Based on https://github.com/mbostock/shapefile/blob/v0.6.2/shp/polygon.js
        function contour(values, value) {
            const v = value == null ? NaN : +value;
            if (isNaN(v)) throw new Error(`invalid value: ${value}`);
            var polygons = [], holes = [];
            isorings(values, v, function(ring) {
                smooth(ring, values, v);
                if ((0, _areaJsDefault.default)(ring) > 0) polygons.push([
                    ring
                ]);
                else holes.push(ring);
            });
            holes.forEach(function(hole) {
                for(var i = 0, n = polygons.length, polygon; i < n; ++i)if ((0, _containsJsDefault.default)((polygon = polygons[i])[0], hole) !== -1) {
                    polygon.push(hole);
                    return;
                }
            });
            return {
                type: "MultiPolygon",
                value: value,
                coordinates: polygons
            };
        }
        // Marching squares with isolines stitched into rings.
        // Based on https://github.com/topojson/topojson-client/blob/v3.0.0/src/stitch.js
        function isorings(values, value, callback) {
            var fragmentByStart = new Array, fragmentByEnd = new Array, x, y, t0, t1, t2, t3;
            // Special case for the first row (y = -1, t2 = t3 = 0).
            x = y = -1;
            t1 = above(values[0], value);
            cases[t1 << 1].forEach(stitch);
            while(++x < dx - 1){
                t0 = t1, t1 = above(values[x + 1], value);
                cases[t0 | t1 << 1].forEach(stitch);
            }
            cases[t1 << 0].forEach(stitch);
            // General case for the intermediate rows.
            while(++y < dy - 1){
                x = -1;
                t1 = above(values[y * dx + dx], value);
                t2 = above(values[y * dx], value);
                cases[t1 << 1 | t2 << 2].forEach(stitch);
                while(++x < dx - 1){
                    t0 = t1, t1 = above(values[y * dx + dx + x + 1], value);
                    t3 = t2, t2 = above(values[y * dx + x + 1], value);
                    cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
                }
                cases[t1 | t2 << 3].forEach(stitch);
            }
            // Special case for the last row (y = dy - 1, t0 = t1 = 0).
            x = -1;
            t2 = values[y * dx] >= value;
            cases[t2 << 2].forEach(stitch);
            while(++x < dx - 1){
                t3 = t2, t2 = above(values[y * dx + x + 1], value);
                cases[t2 << 2 | t3 << 3].forEach(stitch);
            }
            cases[t2 << 3].forEach(stitch);
            function stitch(line) {
                var start = [
                    line[0][0] + x,
                    line[0][1] + y
                ], end = [
                    line[1][0] + x,
                    line[1][1] + y
                ], startIndex = index(start), endIndex = index(end), f, g;
                if (f = fragmentByEnd[startIndex]) {
                    if (g = fragmentByStart[endIndex]) {
                        delete fragmentByEnd[f.end];
                        delete fragmentByStart[g.start];
                        if (f === g) {
                            f.ring.push(end);
                            callback(f.ring);
                        } else fragmentByStart[f.start] = fragmentByEnd[g.end] = {
                            start: f.start,
                            end: g.end,
                            ring: f.ring.concat(g.ring)
                        };
                    } else {
                        delete fragmentByEnd[f.end];
                        f.ring.push(end);
                        fragmentByEnd[f.end = endIndex] = f;
                    }
                } else if (f = fragmentByStart[endIndex]) {
                    if (g = fragmentByEnd[startIndex]) {
                        delete fragmentByStart[f.start];
                        delete fragmentByEnd[g.end];
                        if (f === g) {
                            f.ring.push(end);
                            callback(f.ring);
                        } else fragmentByStart[g.start] = fragmentByEnd[f.end] = {
                            start: g.start,
                            end: f.end,
                            ring: g.ring.concat(f.ring)
                        };
                    } else {
                        delete fragmentByStart[f.start];
                        f.ring.unshift(start);
                        fragmentByStart[f.start = startIndex] = f;
                    }
                } else fragmentByStart[startIndex] = fragmentByEnd[endIndex] = {
                    start: startIndex,
                    end: endIndex,
                    ring: [
                        start,
                        end
                    ]
                };
            }
        }
        function index(point) {
            return point[0] * 2 + point[1] * (dx + 1) * 4;
        }
        function smoothLinear(ring, values, value) {
            ring.forEach(function(point) {
                var x = point[0], y = point[1], xt = x | 0, yt = y | 0, v1 = valid(values[yt * dx + xt]);
                if (x > 0 && x < dx && xt === x) point[0] = smooth1(x, valid(values[yt * dx + xt - 1]), v1, value);
                if (y > 0 && y < dy && yt === y) point[1] = smooth1(y, valid(values[(yt - 1) * dx + xt]), v1, value);
            });
        }
        contours.contour = contour;
        contours.size = function(_) {
            if (!arguments.length) return [
                dx,
                dy
            ];
            var _0 = Math.floor(_[0]), _1 = Math.floor(_[1]);
            if (!(_0 >= 0 && _1 >= 0)) throw new Error("invalid size");
            return dx = _0, dy = _1, contours;
        };
        contours.thresholds = function(_) {
            return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, _constantJsDefault.default)((0, _arrayJs.slice).call(_)) : (0, _constantJsDefault.default)(_), contours) : threshold;
        };
        contours.smooth = function(_) {
            return arguments.length ? (smooth = _ ? smoothLinear : (0, _noopJsDefault.default), contours) : smooth === smoothLinear;
        };
        return contours;
    });
var _d3Array = require("d3-array");
var _arrayJs = require("./array.js");
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _noopJs = require("./noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var cases = [
    [],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                0.5,
                1.0
            ]
        ],
        [
            [
                1.0,
                0.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ],
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    []
];
// When computing the extent, ignore infinite values (as well as invalid ones).
function finite(x) {
    return isFinite(x) ? x : NaN;
}
// Is the (possibly invalid) x greater than or equal to the (known valid) value?
// Treat any invalid value as below negative infinity.
function above(x, value) {
    return x == null ? false : +x >= value;
}
// During smoothing, treat any invalid value as negative infinity.
function valid(v) {
    return v == null || isNaN(v = +v) ? -Infinity : v;
}
function smooth1(x, v0, v1, value) {
    const a = value - v0;
    const b = v1 - v0;
    const d = isFinite(a) || isFinite(b) ? a / b : Math.sign(a) / Math.sign(b);
    return isNaN(d) ? x : x + d - 0.5;
}

},{"d3-array":[["extent","brRYD","default"],["nice","kOVv9","default"],["thresholdSturges","e0V2b","default"],["ticks","9j7q7","default"]],"./array.js":"57tSJ","./ascending.js":"8BYHM","./area.js":"4ieco","./constant.js":"aVEwO","./contains.js":"cflZ8","./noop.js":"bUKda","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"57tSJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", ()=>slice);
var array = Array.prototype;
var slice = array.slice;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8BYHM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a - b;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4ieco":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(ring) {
        var i = 0, n = ring.length, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
        while(++i < n)area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
        return area;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aVEwO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>()=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cflZ8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(ring, hole) {
        var i = -1, n = hole.length, c;
        while(++i < n)if (c = ringContains(ring, hole[i])) return c;
        return 0;
    });
function ringContains(ring, point) {
    var x = point[0], y = point[1], contains = -1;
    for(var i = 0, n = ring.length, j = n - 1; i < n; j = i++){
        var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
        if (segmentContains(pi, pj, point)) return 0;
        if (yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) contains = -contains;
    }
    return contains;
}
function segmentContains(a, b, c) {
    var i;
    return collinear(a, b, c) && within(a[i = +(a[0] === b[0])], c[i], b[i]);
}
function collinear(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
}
function within(p, q, r) {
    return p <= q && q <= r || r <= q && q <= p;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bUKda":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jY6zK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var x = defaultX, y = defaultY, weight = defaultWeight, dx = 960, dy = 500, r = 20, k = 2, o = r * 3, n = dx + o * 2 >> k, m = dy + o * 2 >> k, threshold = (0, _constantJsDefault.default)(20);
        function grid(data) {
            var values = new Float32Array(n * m), pow2k = Math.pow(2, -k), i = -1;
            for (const d of data){
                var xi = (x(d, ++i, data) + o) * pow2k, yi = (y(d, i, data) + o) * pow2k, wi = +weight(d, i, data);
                if (wi && xi >= 0 && xi < n && yi >= 0 && yi < m) {
                    var x0 = Math.floor(xi), y0 = Math.floor(yi), xt = xi - x0 - 0.5, yt = yi - y0 - 0.5;
                    values[x0 + y0 * n] += (1 - xt) * (1 - yt) * wi;
                    values[x0 + 1 + y0 * n] += xt * (1 - yt) * wi;
                    values[x0 + 1 + (y0 + 1) * n] += xt * yt * wi;
                    values[x0 + (y0 + 1) * n] += (1 - xt) * yt * wi;
                }
            }
            (0, _d3Array.blur2)({
                data: values,
                width: n,
                height: m
            }, r * pow2k);
            return values;
        }
        function density(data) {
            var values = grid(data), tz = threshold(values), pow4k = Math.pow(2, 2 * k);
            // Convert number of thresholds into uniform thresholds.
            if (!Array.isArray(tz)) tz = (0, _d3Array.ticks)(Number.MIN_VALUE, (0, _d3Array.max)(values) / pow4k, tz);
            return (0, _contoursJsDefault.default)().size([
                n,
                m
            ]).thresholds(tz.map((d)=>d * pow4k))(values).map((c, i)=>(c.value = +tz[i], transform(c)));
        }
        density.contours = function(data) {
            var values = grid(data), contours = (0, _contoursJsDefault.default)().size([
                n,
                m
            ]), pow4k = Math.pow(2, 2 * k), contour = (value)=>{
                value = +value;
                var c = transform(contours.contour(values, value * pow4k));
                c.value = value; // preserve exact threshold value
                return c;
            };
            Object.defineProperty(contour, "max", {
                get: ()=>(0, _d3Array.max)(values) / pow4k
            });
            return contour;
        };
        function transform(geometry) {
            geometry.coordinates.forEach(transformPolygon);
            return geometry;
        }
        function transformPolygon(coordinates) {
            coordinates.forEach(transformRing);
        }
        function transformRing(coordinates) {
            coordinates.forEach(transformPoint);
        }
        // TODO Optimize.
        function transformPoint(coordinates) {
            coordinates[0] = coordinates[0] * Math.pow(2, k) - o;
            coordinates[1] = coordinates[1] * Math.pow(2, k) - o;
        }
        function resize() {
            o = r * 3;
            n = dx + o * 2 >> k;
            m = dy + o * 2 >> k;
            return density;
        }
        density.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), density) : x;
        };
        density.y = function(_) {
            return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), density) : y;
        };
        density.weight = function(_) {
            return arguments.length ? (weight = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), density) : weight;
        };
        density.size = function(_) {
            if (!arguments.length) return [
                dx,
                dy
            ];
            var _0 = +_[0], _1 = +_[1];
            if (!(_0 >= 0 && _1 >= 0)) throw new Error("invalid size");
            return dx = _0, dy = _1, resize();
        };
        density.cellSize = function(_) {
            if (!arguments.length) return 1 << k;
            if (!((_ = +_) >= 1)) throw new Error("invalid cell size");
            return k = Math.floor(Math.log(_) / Math.LN2), resize();
        };
        density.thresholds = function(_) {
            return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, _constantJsDefault.default)((0, _arrayJs.slice).call(_)) : (0, _constantJsDefault.default)(_), density) : threshold;
        };
        density.bandwidth = function(_) {
            if (!arguments.length) return Math.sqrt(r * (r + 1));
            if (!((_ = +_) >= 0)) throw new Error("invalid bandwidth");
            return r = (Math.sqrt(4 * _ * _ + 1) - 1) / 2, resize();
        };
        return density;
    });
var _d3Array = require("d3-array");
var _arrayJs = require("./array.js");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _contoursJs = require("./contours.js");
var _contoursJsDefault = parcelHelpers.interopDefault(_contoursJs);
function defaultX(d) {
    return d[0];
}
function defaultY(d) {
    return d[1];
}
function defaultWeight() {
    return 1;
}

},{"d3-array":[["blur2","9jCwi"],["max","aVqVJ","default"],["ticks","9j7q7","default"]],"./array.js":"57tSJ","./constant.js":"aVEwO","./contours.js":"ftAFW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hlXWZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Delaunay", ()=>(0, _delaunayJsDefault.default));
parcelHelpers.export(exports, "Voronoi", ()=>(0, _voronoiJsDefault.default));
var _delaunayJs = require("./delaunay.js");
var _delaunayJsDefault = parcelHelpers.interopDefault(_delaunayJs);
var _voronoiJs = require("./voronoi.js");
var _voronoiJsDefault = parcelHelpers.interopDefault(_voronoiJs);

},{"./delaunay.js":"dJasL","./voronoi.js":"l0HTg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dJasL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _delaunator = require("delaunator");
var _delaunatorDefault = parcelHelpers.interopDefault(_delaunator);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
var _polygonJs = require("./polygon.js");
var _polygonJsDefault = parcelHelpers.interopDefault(_polygonJs);
var _voronoiJs = require("./voronoi.js");
var _voronoiJsDefault = parcelHelpers.interopDefault(_voronoiJs);
const tau = 2 * Math.PI, pow = Math.pow;
function pointX(p) {
    return p[0];
}
function pointY(p) {
    return p[1];
}
// A triangulation is collinear if all its triangles have a non-null area
function collinear(d) {
    const { triangles, coords } = d;
    for(let i = 0; i < triangles.length; i += 3){
        const a = 2 * triangles[i], b = 2 * triangles[i + 1], c = 2 * triangles[i + 2], cross = (coords[c] - coords[a]) * (coords[b + 1] - coords[a + 1]) - (coords[b] - coords[a]) * (coords[c + 1] - coords[a + 1]);
        if (cross > 1e-10) return false;
    }
    return true;
}
function jitter(x, y, r) {
    return [
        x + Math.sin(x + y) * r,
        y + Math.cos(x - y) * r
    ];
}
class Delaunay {
    static from(points, fx = pointX, fy = pointY, that) {
        return new Delaunay("length" in points ? flatArray(points, fx, fy, that) : Float64Array.from(flatIterable(points, fx, fy, that)));
    }
    constructor(points){
        this._delaunator = new (0, _delaunatorDefault.default)(points);
        this.inedges = new Int32Array(points.length / 2);
        this._hullIndex = new Int32Array(points.length / 2);
        this.points = this._delaunator.coords;
        this._init();
    }
    update() {
        this._delaunator.update();
        this._init();
        return this;
    }
    _init() {
        const d = this._delaunator, points = this.points;
        // check for collinear
        if (d.hull && d.hull.length > 2 && collinear(d)) {
            this.collinear = Int32Array.from({
                length: points.length / 2
            }, (_, i)=>i).sort((i, j)=>points[2 * i] - points[2 * j] || points[2 * i + 1] - points[2 * j + 1]); // for exact neighbors
            const e = this.collinear[0], f = this.collinear[this.collinear.length - 1], bounds = [
                points[2 * e],
                points[2 * e + 1],
                points[2 * f],
                points[2 * f + 1]
            ], r = 1e-8 * Math.hypot(bounds[3] - bounds[1], bounds[2] - bounds[0]);
            for(let i = 0, n = points.length / 2; i < n; ++i){
                const p = jitter(points[2 * i], points[2 * i + 1], r);
                points[2 * i] = p[0];
                points[2 * i + 1] = p[1];
            }
            this._delaunator = new (0, _delaunatorDefault.default)(points);
        } else delete this.collinear;
        const halfedges = this.halfedges = this._delaunator.halfedges;
        const hull = this.hull = this._delaunator.hull;
        const triangles = this.triangles = this._delaunator.triangles;
        const inedges = this.inedges.fill(-1);
        const hullIndex = this._hullIndex.fill(-1);
        // Compute an index from each point to an (arbitrary) incoming halfedge
        // Used to give the first neighbor of each point; for this reason,
        // on the hull we give priority to exterior halfedges
        for(let e = 0, n = halfedges.length; e < n; ++e){
            const p = triangles[e % 3 === 2 ? e - 2 : e + 1];
            if (halfedges[e] === -1 || inedges[p] === -1) inedges[p] = e;
        }
        for(let i = 0, n = hull.length; i < n; ++i)hullIndex[hull[i]] = i;
        // degenerate case: 1 or 2 (distinct) points
        if (hull.length <= 2 && hull.length > 0) {
            this.triangles = new Int32Array(3).fill(-1);
            this.halfedges = new Int32Array(3).fill(-1);
            this.triangles[0] = hull[0];
            inedges[hull[0]] = 1;
            if (hull.length === 2) {
                inedges[hull[1]] = 0;
                this.triangles[1] = hull[1];
                this.triangles[2] = hull[1];
            }
        }
    }
    voronoi(bounds) {
        return new (0, _voronoiJsDefault.default)(this, bounds);
    }
    *neighbors(i) {
        const { inedges, hull, _hullIndex, halfedges, triangles, collinear } = this;
        // degenerate case with several collinear points
        if (collinear) {
            const l = collinear.indexOf(i);
            if (l > 0) yield collinear[l - 1];
            if (l < collinear.length - 1) yield collinear[l + 1];
            return;
        }
        const e0 = inedges[i];
        if (e0 === -1) return; // coincident point
        let e = e0, p0 = -1;
        do {
            yield p0 = triangles[e];
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) return; // bad triangulation
            e = halfedges[e];
            if (e === -1) {
                const p = hull[(_hullIndex[i] + 1) % hull.length];
                if (p !== p0) yield p;
                return;
            }
        }while (e !== e0);
    }
    find(x, y, i = 0) {
        if ((x = +x, x !== x) || (y = +y, y !== y)) return -1;
        const i0 = i;
        let c;
        while((c = this._step(i, x, y)) >= 0 && c !== i && c !== i0)i = c;
        return c;
    }
    _step(i, x, y) {
        const { inedges, hull, _hullIndex, halfedges, triangles, points } = this;
        if (inedges[i] === -1 || !points.length) return (i + 1) % (points.length >> 1);
        let c = i;
        let dc = pow(x - points[i * 2], 2) + pow(y - points[i * 2 + 1], 2);
        const e0 = inedges[i];
        let e = e0;
        do {
            let t = triangles[e];
            const dt = pow(x - points[t * 2], 2) + pow(y - points[t * 2 + 1], 2);
            if (dt < dc) dc = dt, c = t;
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) break; // bad triangulation
            e = halfedges[e];
            if (e === -1) {
                e = hull[(_hullIndex[i] + 1) % hull.length];
                if (e !== t) {
                    if (pow(x - points[e * 2], 2) + pow(y - points[e * 2 + 1], 2) < dc) return e;
                }
                break;
            }
        }while (e !== e0);
        return c;
    }
    render(context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const { points, halfedges, triangles } = this;
        for(let i = 0, n = halfedges.length; i < n; ++i){
            const j = halfedges[i];
            if (j < i) continue;
            const ti = triangles[i] * 2;
            const tj = triangles[j] * 2;
            context.moveTo(points[ti], points[ti + 1]);
            context.lineTo(points[tj], points[tj + 1]);
        }
        this.renderHull(context);
        return buffer && buffer.value();
    }
    renderPoints(context, r) {
        if (r === undefined && (!context || typeof context.moveTo !== "function")) r = context, context = null;
        r = r == undefined ? 2 : +r;
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const { points } = this;
        for(let i = 0, n = points.length; i < n; i += 2){
            const x = points[i], y = points[i + 1];
            context.moveTo(x + r, y);
            context.arc(x, y, r, 0, tau);
        }
        return buffer && buffer.value();
    }
    renderHull(context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const { hull, points } = this;
        const h = hull[0] * 2, n = hull.length;
        context.moveTo(points[h], points[h + 1]);
        for(let i = 1; i < n; ++i){
            const h = 2 * hull[i];
            context.lineTo(points[h], points[h + 1]);
        }
        context.closePath();
        return buffer && buffer.value();
    }
    hullPolygon() {
        const polygon = new (0, _polygonJsDefault.default);
        this.renderHull(polygon);
        return polygon.value();
    }
    renderTriangle(i, context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const { points, triangles } = this;
        const t0 = triangles[i *= 3] * 2;
        const t1 = triangles[i + 1] * 2;
        const t2 = triangles[i + 2] * 2;
        context.moveTo(points[t0], points[t0 + 1]);
        context.lineTo(points[t1], points[t1 + 1]);
        context.lineTo(points[t2], points[t2 + 1]);
        context.closePath();
        return buffer && buffer.value();
    }
    *trianglePolygons() {
        const { triangles } = this;
        for(let i = 0, n = triangles.length / 3; i < n; ++i)yield this.trianglePolygon(i);
    }
    trianglePolygon(i) {
        const polygon = new (0, _polygonJsDefault.default);
        this.renderTriangle(i, polygon);
        return polygon.value();
    }
}
exports.default = Delaunay;
function flatArray(points, fx, fy, that) {
    const n = points.length;
    const array = new Float64Array(n * 2);
    for(let i = 0; i < n; ++i){
        const p = points[i];
        array[i * 2] = fx.call(that, p, i, points);
        array[i * 2 + 1] = fy.call(that, p, i, points);
    }
    return array;
}
function* flatIterable(points, fx, fy, that) {
    let i = 0;
    for (const p of points){
        yield fx.call(that, p, i, points);
        yield fy.call(that, p, i, points);
        ++i;
    }
}

},{"delaunator":"b2ccY","./path.js":"ebBL9","./polygon.js":"bSOj4","./voronoi.js":"l0HTg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b2ccY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _robustPredicates = require("robust-predicates");
const EPSILON = Math.pow(2, -52);
const EDGE_STACK = new Uint32Array(512);
class Delaunator {
    /**
     * Constructs a delaunay triangulation object given an array of points (`[x, y]` by default).
     * `getX` and `getY` are optional functions of the form `(point) => value` for custom point formats.
     *
     * @template P
     * @param {P[]} points
     * @param {(p: P) => number} [getX]
     * @param {(p: P) => number} [getY]
     */ // @ts-expect-error TS2322
    static from(points, getX = defaultGetX, getY = defaultGetY) {
        const n = points.length;
        const coords = new Float64Array(n * 2);
        for(let i = 0; i < n; i++){
            const p = points[i];
            coords[2 * i] = getX(p);
            coords[2 * i + 1] = getY(p);
        }
        return new Delaunator(coords);
    }
    /**
     * Constructs a delaunay triangulation object given an array of point coordinates of the form:
     * `[x0, y0, x1, y1, ...]` (use a typed array for best performance). Duplicate points are skipped.
     *
     * @param {T} coords
     */ constructor(coords){
        const n = coords.length >> 1;
        if (n > 0 && typeof coords[0] !== 'number') throw new Error('Expected coords to contain numbers.');
        this.coords = coords;
        // arrays that will store the triangulation graph
        const maxTriangles = Math.max(2 * n - 5, 0);
        /** @private */ this._triangles = new Uint32Array(maxTriangles * 3);
        /** @private */ this._halfedges = new Int32Array(maxTriangles * 3);
        // temporary arrays for tracking the edges of the advancing convex hull
        /** @private */ this._hashSize = Math.ceil(Math.sqrt(n));
        /** @private */ this._hullPrev = new Uint32Array(n); // edge to prev edge
        /** @private */ this._hullNext = new Uint32Array(n); // edge to next edge
        /** @private */ this._hullTri = new Uint32Array(n); // edge to adjacent triangle
        /** @private */ this._hullHash = new Int32Array(this._hashSize); // angular edge hash
        // temporary arrays for sorting points
        /** @private */ this._ids = new Uint32Array(n);
        /** @private */ this._dists = new Float64Array(n);
        /** @private */ this.trianglesLen = 0;
        /** @private */ this._cx = 0;
        /** @private */ this._cy = 0;
        /** @private */ this._hullStart = 0;
        /** A `Uint32Array` array of indices that reference points on the convex hull of the input data, counter-clockwise. */ this.hull = this._triangles;
        /** A `Uint32Array` array of triangle vertex indices (each group of three numbers forms a triangle). All triangles are directed counterclockwise. */ this.triangles = this._triangles;
        /**
         * A `Int32Array` array of triangle half-edge indices that allows you to traverse the triangulation.
         * `i`-th half-edge in the array corresponds to vertex `triangles[i]` the half-edge is coming from.
         * `halfedges[i]` is the index of a twin half-edge in an adjacent triangle (or `-1` for outer half-edges on the convex hull).
         */ this.halfedges = this._halfedges;
        this.update();
    }
    /**
     * Updates the triangulation if you modified `delaunay.coords` values in place, avoiding expensive memory allocations.
     * Useful for iterative relaxation algorithms such as Lloyd's.
     */ update() {
        const { coords, _hullPrev: hullPrev, _hullNext: hullNext, _hullTri: hullTri, _hullHash: hullHash } = this;
        const n = coords.length >> 1;
        // populate an array of point indices; calculate input data bbox
        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        for(let i = 0; i < n; i++){
            const x = coords[2 * i];
            const y = coords[2 * i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            this._ids[i] = i;
        }
        const cx = (minX + maxX) / 2;
        const cy = (minY + maxY) / 2;
        let i0 = 0, i1 = 0, i2 = 0;
        // pick a seed point close to the center
        for(let i = 0, minDist = Infinity; i < n; i++){
            const d = dist(cx, cy, coords[2 * i], coords[2 * i + 1]);
            if (d < minDist) {
                i0 = i;
                minDist = d;
            }
        }
        const i0x = coords[2 * i0];
        const i0y = coords[2 * i0 + 1];
        // find the point closest to the seed
        for(let i = 0, minDist = Infinity; i < n; i++){
            if (i === i0) continue;
            const d = dist(i0x, i0y, coords[2 * i], coords[2 * i + 1]);
            if (d < minDist && d > 0) {
                i1 = i;
                minDist = d;
            }
        }
        let i1x = coords[2 * i1];
        let i1y = coords[2 * i1 + 1];
        let minRadius = Infinity;
        // find the third point which forms the smallest circumcircle with the first two
        for(let i = 0; i < n; i++){
            if (i === i0 || i === i1) continue;
            const r = circumradius(i0x, i0y, i1x, i1y, coords[2 * i], coords[2 * i + 1]);
            if (r < minRadius) {
                i2 = i;
                minRadius = r;
            }
        }
        let i2x = coords[2 * i2];
        let i2y = coords[2 * i2 + 1];
        if (minRadius === Infinity) {
            // order collinear points by dx (or dy if all x are identical)
            // and return the list as a hull
            for(let i = 0; i < n; i++)this._dists[i] = coords[2 * i] - coords[0] || coords[2 * i + 1] - coords[1];
            quicksort(this._ids, this._dists, 0, n - 1);
            const hull = new Uint32Array(n);
            let j = 0;
            for(let i = 0, d0 = -Infinity; i < n; i++){
                const id = this._ids[i];
                const d = this._dists[id];
                if (d > d0) {
                    hull[j++] = id;
                    d0 = d;
                }
            }
            this.hull = hull.subarray(0, j);
            this.triangles = new Uint32Array(0);
            this.halfedges = new Int32Array(0);
            return;
        }
        // swap the order of the seed points for counter-clockwise orientation
        if ((0, _robustPredicates.orient2d)(i0x, i0y, i1x, i1y, i2x, i2y) < 0) {
            const i = i1;
            const x = i1x;
            const y = i1y;
            i1 = i2;
            i1x = i2x;
            i1y = i2y;
            i2 = i;
            i2x = x;
            i2y = y;
        }
        const center = circumcenter(i0x, i0y, i1x, i1y, i2x, i2y);
        this._cx = center.x;
        this._cy = center.y;
        for(let i = 0; i < n; i++)this._dists[i] = dist(coords[2 * i], coords[2 * i + 1], center.x, center.y);
        // sort the points by distance from the seed triangle circumcenter
        quicksort(this._ids, this._dists, 0, n - 1);
        // set up the seed triangle as the starting hull
        this._hullStart = i0;
        let hullSize = 3;
        hullNext[i0] = hullPrev[i2] = i1;
        hullNext[i1] = hullPrev[i0] = i2;
        hullNext[i2] = hullPrev[i1] = i0;
        hullTri[i0] = 0;
        hullTri[i1] = 1;
        hullTri[i2] = 2;
        hullHash.fill(-1);
        hullHash[this._hashKey(i0x, i0y)] = i0;
        hullHash[this._hashKey(i1x, i1y)] = i1;
        hullHash[this._hashKey(i2x, i2y)] = i2;
        this.trianglesLen = 0;
        this._addTriangle(i0, i1, i2, -1, -1, -1);
        for(let k = 0, xp = 0, yp = 0; k < this._ids.length; k++){
            const i = this._ids[k];
            const x = coords[2 * i];
            const y = coords[2 * i + 1];
            // skip near-duplicate points
            if (k > 0 && Math.abs(x - xp) <= EPSILON && Math.abs(y - yp) <= EPSILON) continue;
            xp = x;
            yp = y;
            // skip seed triangle points
            if (i === i0 || i === i1 || i === i2) continue;
            // find a visible edge on the convex hull using edge hash
            let start = 0;
            for(let j = 0, key = this._hashKey(x, y); j < this._hashSize; j++){
                start = hullHash[(key + j) % this._hashSize];
                if (start !== -1 && start !== hullNext[start]) break;
            }
            start = hullPrev[start];
            let e = start, q;
            while(q = hullNext[e], (0, _robustPredicates.orient2d)(x, y, coords[2 * e], coords[2 * e + 1], coords[2 * q], coords[2 * q + 1]) >= 0){
                e = q;
                if (e === start) {
                    e = -1;
                    break;
                }
            }
            if (e === -1) continue; // likely a near-duplicate point; skip it
            // add the first triangle from the point
            let t = this._addTriangle(e, i, hullNext[e], -1, -1, hullTri[e]);
            // recursively flip triangles from the point until they satisfy the Delaunay condition
            hullTri[i] = this._legalize(t + 2);
            hullTri[e] = t; // keep track of boundary triangles on the hull
            hullSize++;
            // walk forward through the hull, adding more triangles and flipping recursively
            let n = hullNext[e];
            while(q = hullNext[n], (0, _robustPredicates.orient2d)(x, y, coords[2 * n], coords[2 * n + 1], coords[2 * q], coords[2 * q + 1]) < 0){
                t = this._addTriangle(n, i, q, hullTri[i], -1, hullTri[n]);
                hullTri[i] = this._legalize(t + 2);
                hullNext[n] = n; // mark as removed
                hullSize--;
                n = q;
            }
            // walk backward from the other side, adding more triangles and flipping
            if (e === start) while(q = hullPrev[e], (0, _robustPredicates.orient2d)(x, y, coords[2 * q], coords[2 * q + 1], coords[2 * e], coords[2 * e + 1]) < 0){
                t = this._addTriangle(q, i, e, -1, hullTri[e], hullTri[q]);
                this._legalize(t + 2);
                hullTri[q] = t;
                hullNext[e] = e; // mark as removed
                hullSize--;
                e = q;
            }
            // update the hull indices
            this._hullStart = hullPrev[i] = e;
            hullNext[e] = hullPrev[n] = i;
            hullNext[i] = n;
            // save the two new edges in the hash table
            hullHash[this._hashKey(x, y)] = i;
            hullHash[this._hashKey(coords[2 * e], coords[2 * e + 1])] = e;
        }
        this.hull = new Uint32Array(hullSize);
        for(let i = 0, e = this._hullStart; i < hullSize; i++){
            this.hull[i] = e;
            e = hullNext[e];
        }
        // trim typed triangle mesh arrays
        this.triangles = this._triangles.subarray(0, this.trianglesLen);
        this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
    }
    /**
     * Calculate an angle-based key for the edge hash used for advancing convex hull.
     *
     * @param {number} x
     * @param {number} y
     * @private
     */ _hashKey(x, y) {
        return Math.floor(pseudoAngle(x - this._cx, y - this._cy) * this._hashSize) % this._hashSize;
    }
    /**
     * Flip an edge in a pair of triangles if it doesn't satisfy the Delaunay condition.
     *
     * @param {number} a
     * @private
     */ _legalize(a) {
        const { _triangles: triangles, _halfedges: halfedges, coords } = this;
        let i = 0;
        let ar = 0;
        // recursion eliminated with a fixed-size stack
        while(true){
            const b = halfedges[a];
            /* if the pair of triangles doesn't satisfy the Delaunay condition
             * (p1 is inside the circumcircle of [p0, pl, pr]), flip them,
             * then do the same check/flip recursively for the new pair of triangles
             *
             *           pl                    pl
             *          /||\                  /  \
             *       al/ || \bl            al/    \a
             *        /  ||  \              /      \
             *       /  a||b  \    flip    /___ar___\
             *     p0\   ||   /p1   =>   p0\---bl---/p1
             *        \  ||  /              \      /
             *       ar\ || /br             b\    /br
             *          \||/                  \  /
             *           pr                    pr
             */ const a0 = a - a % 3;
            ar = a0 + (a + 2) % 3;
            if (b === -1) {
                if (i === 0) break;
                a = EDGE_STACK[--i];
                continue;
            }
            const b0 = b - b % 3;
            const al = a0 + (a + 1) % 3;
            const bl = b0 + (b + 2) % 3;
            const p0 = triangles[ar];
            const pr = triangles[a];
            const pl = triangles[al];
            const p1 = triangles[bl];
            const illegal = inCircle(coords[2 * p0], coords[2 * p0 + 1], coords[2 * pr], coords[2 * pr + 1], coords[2 * pl], coords[2 * pl + 1], coords[2 * p1], coords[2 * p1 + 1]);
            if (illegal) {
                triangles[a] = p1;
                triangles[b] = p0;
                const hbl = halfedges[bl];
                // edge swapped on the other side of the hull (rare); fix the half-edge reference
                if (hbl === -1) {
                    let e = this._hullStart;
                    do {
                        if (this._hullTri[e] === bl) {
                            this._hullTri[e] = a;
                            break;
                        }
                        e = this._hullPrev[e];
                    }while (e !== this._hullStart);
                }
                this._link(a, hbl);
                this._link(b, halfedges[ar]);
                this._link(ar, bl);
                const br = b0 + (b + 1) % 3;
                // don't worry about hitting the cap: it can only happen on extremely degenerate input
                if (i < EDGE_STACK.length) EDGE_STACK[i++] = br;
            } else {
                if (i === 0) break;
                a = EDGE_STACK[--i];
            }
        }
        return ar;
    }
    /**
     * Link two half-edges to each other.
     * @param {number} a
     * @param {number} b
     * @private
     */ _link(a, b) {
        this._halfedges[a] = b;
        if (b !== -1) this._halfedges[b] = a;
    }
    /**
     * Add a new triangle given vertex indices and adjacent half-edge ids.
     *
     * @param {number} i0
     * @param {number} i1
     * @param {number} i2
     * @param {number} a
     * @param {number} b
     * @param {number} c
     * @private
     */ _addTriangle(i0, i1, i2, a, b, c) {
        const t = this.trianglesLen;
        this._triangles[t] = i0;
        this._triangles[t + 1] = i1;
        this._triangles[t + 2] = i2;
        this._link(t, a);
        this._link(t + 1, b);
        this._link(t + 2, c);
        this.trianglesLen += 3;
        return t;
    }
}
exports.default = Delaunator;
/**
 * Monotonically increases with real angle, but doesn't need expensive trigonometry.
 *
 * @param {number} dx
 * @param {number} dy
 */ function pseudoAngle(dx, dy) {
    const p = dx / (Math.abs(dx) + Math.abs(dy));
    return (dy > 0 ? 3 - p : 1 + p) / 4; // [0..1]
}
/**
 * Squared distance between two points.
 *
 * @param {number} ax
 * @param {number} ay
 * @param {number} bx
 * @param {number} by
 */ function dist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
}
/**
 * Check whether point P is inside a circle formed by points A, B, C.
 *
 * @param {number} ax
 * @param {number} ay
 * @param {number} bx
 * @param {number} by
 * @param {number} cx
 * @param {number} cy
 * @param {number} px
 * @param {number} py
 */ function inCircle(ax, ay, bx, by, cx, cy, px, py) {
    const dx = ax - px;
    const dy = ay - py;
    const ex = bx - px;
    const ey = by - py;
    const fx = cx - px;
    const fy = cy - py;
    const ap = dx * dx + dy * dy;
    const bp = ex * ex + ey * ey;
    const cp = fx * fx + fy * fy;
    return dx * (ey * cp - bp * fy) - dy * (ex * cp - bp * fx) + ap * (ex * fy - ey * fx) < 0;
}
/**
 * Squared radius of the circle formed by points A, B, C.
 *
 * @param {number} ax
 * @param {number} ay
 * @param {number} bx
 * @param {number} by
 * @param {number} cx
 * @param {number} cy
 */ function circumradius(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;
    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);
    const x = (ey * bl - dy * cl) * d;
    const y = (dx * cl - ex * bl) * d;
    return x * x + y * y;
}
/**
 * Get coordinates of a circumcenter for points A, B, C.
 *
 * @param {number} ax
 * @param {number} ay
 * @param {number} bx
 * @param {number} by
 * @param {number} cx
 * @param {number} cy
 */ function circumcenter(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;
    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);
    const x = ax + (ey * bl - dy * cl) * d;
    const y = ay + (dx * cl - ex * bl) * d;
    return {
        x,
        y
    };
}
/**
 * Sort points by distance via an array of point indices and an array of calculated distances.
 *
 * @param {Uint32Array} ids
 * @param {Float64Array} dists
 * @param {number} left
 * @param {number} right
 */ function quicksort(ids, dists, left, right) {
    if (right - left <= 20) for(let i = left + 1; i <= right; i++){
        const temp = ids[i];
        const tempDist = dists[temp];
        let j = i - 1;
        while(j >= left && dists[ids[j]] > tempDist)ids[j + 1] = ids[j--];
        ids[j + 1] = temp;
    }
    else {
        const median = left + right >> 1;
        let i = left + 1;
        let j = right;
        swap(ids, median, i);
        if (dists[ids[left]] > dists[ids[right]]) swap(ids, left, right);
        if (dists[ids[i]] > dists[ids[right]]) swap(ids, i, right);
        if (dists[ids[left]] > dists[ids[i]]) swap(ids, left, i);
        const temp = ids[i];
        const tempDist = dists[temp];
        while(true){
            do i++;
            while (dists[ids[i]] < tempDist);
            do j--;
            while (dists[ids[j]] > tempDist);
            if (j < i) break;
            swap(ids, i, j);
        }
        ids[left + 1] = ids[j];
        ids[j] = temp;
        if (right - i + 1 >= j - left) {
            quicksort(ids, dists, i, right);
            quicksort(ids, dists, left, j - 1);
        } else {
            quicksort(ids, dists, left, j - 1);
            quicksort(ids, dists, i, right);
        }
    }
}
/**
 * @param {Uint32Array} arr
 * @param {number} i
 * @param {number} j
 */ function swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
/** @param {[number, number]} p */ function defaultGetX(p) {
    return p[0];
}
/** @param {[number, number]} p */ function defaultGetY(p) {
    return p[1];
}

},{"robust-predicates":"8K7Zx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8K7Zx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "orient2d", ()=>(0, _orient2DJs.orient2d));
parcelHelpers.export(exports, "orient2dfast", ()=>(0, _orient2DJs.orient2dfast));
parcelHelpers.export(exports, "orient3d", ()=>(0, _orient3DJs.orient3d));
parcelHelpers.export(exports, "orient3dfast", ()=>(0, _orient3DJs.orient3dfast));
parcelHelpers.export(exports, "incircle", ()=>(0, _incircleJs.incircle));
parcelHelpers.export(exports, "incirclefast", ()=>(0, _incircleJs.incirclefast));
parcelHelpers.export(exports, "insphere", ()=>(0, _insphereJs.insphere));
parcelHelpers.export(exports, "inspherefast", ()=>(0, _insphereJs.inspherefast));
var _orient2DJs = require("./esm/orient2d.js");
var _orient3DJs = require("./esm/orient3d.js");
var _incircleJs = require("./esm/incircle.js");
var _insphereJs = require("./esm/insphere.js");

},{"./esm/orient2d.js":"aMxbU","./esm/orient3d.js":"aRdDo","./esm/incircle.js":"cGSqn","./esm/insphere.js":"a9t6m","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aMxbU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "orient2d", ()=>orient2d);
parcelHelpers.export(exports, "orient2dfast", ()=>orient2dfast);
var _utilJs = require("./util.js");
const ccwerrboundA = (3 + 16 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const ccwerrboundB = (2 + 12 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const ccwerrboundC = (9 + 64 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon) * (0, _utilJs.epsilon);
const B = (0, _utilJs.vec)(4);
const C1 = (0, _utilJs.vec)(8);
const C2 = (0, _utilJs.vec)(12);
const D = (0, _utilJs.vec)(16);
const u = (0, _utilJs.vec)(4);
function orient2dadapt(ax, ay, bx, by, cx, cy, detsum) {
    let acxtail, acytail, bcxtail, bcytail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    const acx = ax - cx;
    const bcx = bx - cx;
    const acy = ay - cy;
    const bcy = by - cy;
    s1 = acx * bcy;
    c = (0, _utilJs.splitter) * acx;
    ahi = c - (c - acx);
    alo = acx - ahi;
    c = (0, _utilJs.splitter) * bcy;
    bhi = c - (c - bcy);
    blo = bcy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acy * bcx;
    c = (0, _utilJs.splitter) * acy;
    ahi = c - (c - acy);
    alo = acy - ahi;
    c = (0, _utilJs.splitter) * bcx;
    bhi = c - (c - bcx);
    blo = bcx - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    B[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    B[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    B[2] = _j - (u3 - bvirt) + (_i - bvirt);
    B[3] = u3;
    let det = (0, _utilJs.estimate)(4, B);
    let errbound = ccwerrboundB * detsum;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - acx;
    acxtail = ax - (acx + bvirt) + (bvirt - cx);
    bvirt = bx - bcx;
    bcxtail = bx - (bcx + bvirt) + (bvirt - cx);
    bvirt = ay - acy;
    acytail = ay - (acy + bvirt) + (bvirt - cy);
    bvirt = by - bcy;
    bcytail = by - (bcy + bvirt) + (bvirt - cy);
    if (acxtail === 0 && acytail === 0 && bcxtail === 0 && bcytail === 0) return det;
    errbound = ccwerrboundC * detsum + (0, _utilJs.resulterrbound) * Math.abs(det);
    det += acx * bcytail + bcy * acxtail - (acy * bcxtail + bcx * acytail);
    if (det >= errbound || -det >= errbound) return det;
    s1 = acxtail * bcy;
    c = (0, _utilJs.splitter) * acxtail;
    ahi = c - (c - acxtail);
    alo = acxtail - ahi;
    c = (0, _utilJs.splitter) * bcy;
    bhi = c - (c - bcy);
    blo = bcy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acytail * bcx;
    c = (0, _utilJs.splitter) * acytail;
    ahi = c - (c - acytail);
    alo = acytail - ahi;
    c = (0, _utilJs.splitter) * bcx;
    bhi = c - (c - bcx);
    blo = bcx - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    u[3] = u3;
    const C1len = (0, _utilJs.sum)(4, B, 4, u, C1);
    s1 = acx * bcytail;
    c = (0, _utilJs.splitter) * acx;
    ahi = c - (c - acx);
    alo = acx - ahi;
    c = (0, _utilJs.splitter) * bcytail;
    bhi = c - (c - bcytail);
    blo = bcytail - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acy * bcxtail;
    c = (0, _utilJs.splitter) * acy;
    ahi = c - (c - acy);
    alo = acy - ahi;
    c = (0, _utilJs.splitter) * bcxtail;
    bhi = c - (c - bcxtail);
    blo = bcxtail - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    u[3] = u3;
    const C2len = (0, _utilJs.sum)(C1len, C1, 4, u, C2);
    s1 = acxtail * bcytail;
    c = (0, _utilJs.splitter) * acxtail;
    ahi = c - (c - acxtail);
    alo = acxtail - ahi;
    c = (0, _utilJs.splitter) * bcytail;
    bhi = c - (c - bcytail);
    blo = bcytail - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acytail * bcxtail;
    c = (0, _utilJs.splitter) * acytail;
    ahi = c - (c - acytail);
    alo = acytail - ahi;
    c = (0, _utilJs.splitter) * bcxtail;
    bhi = c - (c - bcxtail);
    blo = bcxtail - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    u[3] = u3;
    const Dlen = (0, _utilJs.sum)(C2len, C2, 4, u, D);
    return D[Dlen - 1];
}
function orient2d(ax, ay, bx, by, cx, cy) {
    const detleft = (ay - cy) * (bx - cx);
    const detright = (ax - cx) * (by - cy);
    const det = detleft - detright;
    const detsum = Math.abs(detleft + detright);
    if (Math.abs(det) >= ccwerrboundA * detsum) return det;
    return -orient2dadapt(ax, ay, bx, by, cx, cy, detsum);
}
function orient2dfast(ax, ay, bx, by, cx, cy) {
    return (ay - cy) * (bx - cx) - (ax - cx) * (by - cy);
}

},{"./util.js":"dWrL1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dWrL1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "epsilon", ()=>epsilon);
parcelHelpers.export(exports, "splitter", ()=>splitter);
parcelHelpers.export(exports, "resulterrbound", ()=>resulterrbound);
// fast_expansion_sum_zeroelim routine from original code
parcelHelpers.export(exports, "sum", ()=>sum);
parcelHelpers.export(exports, "sum_three", ()=>sum_three);
// scale_expansion_zeroelim routine from oritinal code
parcelHelpers.export(exports, "scale", ()=>scale);
parcelHelpers.export(exports, "negate", ()=>negate);
parcelHelpers.export(exports, "estimate", ()=>estimate);
parcelHelpers.export(exports, "vec", ()=>vec);
const epsilon = 1.1102230246251565e-16;
const splitter = 134217729;
const resulterrbound = (3 + 8 * epsilon) * epsilon;
function sum(elen, e, flen, f, h) {
    let Q, Qnew, hh, bvirt;
    let enow = e[0];
    let fnow = f[0];
    let eindex = 0;
    let findex = 0;
    if (fnow > enow === fnow > -enow) {
        Q = enow;
        enow = e[++eindex];
    } else {
        Q = fnow;
        fnow = f[++findex];
    }
    let hindex = 0;
    if (eindex < elen && findex < flen) {
        if (fnow > enow === fnow > -enow) {
            Qnew = enow + Q;
            hh = Q - (Qnew - enow);
            enow = e[++eindex];
        } else {
            Qnew = fnow + Q;
            hh = Q - (Qnew - fnow);
            fnow = f[++findex];
        }
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
        while(eindex < elen && findex < flen){
            if (fnow > enow === fnow > -enow) {
                Qnew = Q + enow;
                bvirt = Qnew - Q;
                hh = Q - (Qnew - bvirt) + (enow - bvirt);
                enow = e[++eindex];
            } else {
                Qnew = Q + fnow;
                bvirt = Qnew - Q;
                hh = Q - (Qnew - bvirt) + (fnow - bvirt);
                fnow = f[++findex];
            }
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
        }
    }
    while(eindex < elen){
        Qnew = Q + enow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (enow - bvirt);
        enow = e[++eindex];
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
    }
    while(findex < flen){
        Qnew = Q + fnow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (fnow - bvirt);
        fnow = f[++findex];
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
    }
    if (Q !== 0 || hindex === 0) h[hindex++] = Q;
    return hindex;
}
function sum_three(alen, a, blen, b, clen, c, tmp, out) {
    return sum(sum(alen, a, blen, b, tmp), tmp, clen, c, out);
}
function scale(elen, e, b, h) {
    let Q, sum, hh, product1, product0;
    let bvirt, c, ahi, alo, bhi, blo;
    c = splitter * b;
    bhi = c - (c - b);
    blo = b - bhi;
    let enow = e[0];
    Q = enow * b;
    c = splitter * enow;
    ahi = c - (c - enow);
    alo = enow - ahi;
    hh = alo * blo - (Q - ahi * bhi - alo * bhi - ahi * blo);
    let hindex = 0;
    if (hh !== 0) h[hindex++] = hh;
    for(let i = 1; i < elen; i++){
        enow = e[i];
        product1 = enow * b;
        c = splitter * enow;
        ahi = c - (c - enow);
        alo = enow - ahi;
        product0 = alo * blo - (product1 - ahi * bhi - alo * bhi - ahi * blo);
        sum = Q + product0;
        bvirt = sum - Q;
        hh = Q - (sum - bvirt) + (product0 - bvirt);
        if (hh !== 0) h[hindex++] = hh;
        Q = product1 + sum;
        hh = sum - (Q - product1);
        if (hh !== 0) h[hindex++] = hh;
    }
    if (Q !== 0 || hindex === 0) h[hindex++] = Q;
    return hindex;
}
function negate(elen, e) {
    for(let i = 0; i < elen; i++)e[i] = -e[i];
    return elen;
}
function estimate(elen, e) {
    let Q = e[0];
    for(let i = 1; i < elen; i++)Q += e[i];
    return Q;
}
function vec(n) {
    return new Float64Array(n);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aRdDo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "orient3d", ()=>orient3d);
parcelHelpers.export(exports, "orient3dfast", ()=>orient3dfast);
var _utilJs = require("./util.js");
const o3derrboundA = (7 + 56 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const o3derrboundB = (3 + 28 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const o3derrboundC = (26 + 288 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon) * (0, _utilJs.epsilon);
const bc = (0, _utilJs.vec)(4);
const ca = (0, _utilJs.vec)(4);
const ab = (0, _utilJs.vec)(4);
const at_b = (0, _utilJs.vec)(4);
const at_c = (0, _utilJs.vec)(4);
const bt_c = (0, _utilJs.vec)(4);
const bt_a = (0, _utilJs.vec)(4);
const ct_a = (0, _utilJs.vec)(4);
const ct_b = (0, _utilJs.vec)(4);
const bct = (0, _utilJs.vec)(8);
const cat = (0, _utilJs.vec)(8);
const abt = (0, _utilJs.vec)(8);
const u = (0, _utilJs.vec)(4);
const _8 = (0, _utilJs.vec)(8);
const _8b = (0, _utilJs.vec)(8);
const _16 = (0, _utilJs.vec)(16);
const _12 = (0, _utilJs.vec)(12);
let fin = (0, _utilJs.vec)(192);
let fin2 = (0, _utilJs.vec)(192);
function finadd(finlen, alen, a) {
    finlen = (0, _utilJs.sum)(finlen, fin, alen, a, fin2);
    const tmp = fin;
    fin = fin2;
    fin2 = tmp;
    return finlen;
}
function tailinit(xtail, ytail, ax, ay, bx, by, a, b) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, t1, t0, u3, negate;
    if (xtail === 0) {
        if (ytail === 0) {
            a[0] = 0;
            b[0] = 0;
            return 1;
        }
        negate = -ytail;
        s1 = negate * ax;
        c = (0, _utilJs.splitter) * negate;
        ahi = c - (c - negate);
        alo = negate - ahi;
        c = (0, _utilJs.splitter) * ax;
        bhi = c - (c - ax);
        blo = ax - bhi;
        a[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        a[1] = s1;
        s1 = ytail * bx;
        c = (0, _utilJs.splitter) * ytail;
        ahi = c - (c - ytail);
        alo = ytail - ahi;
        c = (0, _utilJs.splitter) * bx;
        bhi = c - (c - bx);
        blo = bx - bhi;
        b[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        b[1] = s1;
        return 2;
    }
    if (ytail === 0) {
        s1 = xtail * ay;
        c = (0, _utilJs.splitter) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, _utilJs.splitter) * ay;
        bhi = c - (c - ay);
        blo = ay - bhi;
        a[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        a[1] = s1;
        negate = -xtail;
        s1 = negate * by;
        c = (0, _utilJs.splitter) * negate;
        ahi = c - (c - negate);
        alo = negate - ahi;
        c = (0, _utilJs.splitter) * by;
        bhi = c - (c - by);
        blo = by - bhi;
        b[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        b[1] = s1;
        return 2;
    }
    s1 = xtail * ay;
    c = (0, _utilJs.splitter) * xtail;
    ahi = c - (c - xtail);
    alo = xtail - ahi;
    c = (0, _utilJs.splitter) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ytail * ax;
    c = (0, _utilJs.splitter) * ytail;
    ahi = c - (c - ytail);
    alo = ytail - ahi;
    c = (0, _utilJs.splitter) * ax;
    bhi = c - (c - ax);
    blo = ax - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    a[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    a[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    a[2] = _j - (u3 - bvirt) + (_i - bvirt);
    a[3] = u3;
    s1 = ytail * bx;
    c = (0, _utilJs.splitter) * ytail;
    ahi = c - (c - ytail);
    alo = ytail - ahi;
    c = (0, _utilJs.splitter) * bx;
    bhi = c - (c - bx);
    blo = bx - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = xtail * by;
    c = (0, _utilJs.splitter) * xtail;
    ahi = c - (c - xtail);
    alo = xtail - ahi;
    c = (0, _utilJs.splitter) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    b[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    b[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    b[2] = _j - (u3 - bvirt) + (_i - bvirt);
    b[3] = u3;
    return 4;
}
function tailadd(finlen, a, b, k, z) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, u3;
    s1 = a * b;
    c = (0, _utilJs.splitter) * a;
    ahi = c - (c - a);
    alo = a - ahi;
    c = (0, _utilJs.splitter) * b;
    bhi = c - (c - b);
    blo = b - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    c = (0, _utilJs.splitter) * k;
    bhi = c - (c - k);
    blo = k - bhi;
    _i = s0 * k;
    c = (0, _utilJs.splitter) * s0;
    ahi = c - (c - s0);
    alo = s0 - ahi;
    u[0] = alo * blo - (_i - ahi * bhi - alo * bhi - ahi * blo);
    _j = s1 * k;
    c = (0, _utilJs.splitter) * s1;
    ahi = c - (c - s1);
    alo = s1 - ahi;
    _0 = alo * blo - (_j - ahi * bhi - alo * bhi - ahi * blo);
    _k = _i + _0;
    bvirt = _k - _i;
    u[1] = _i - (_k - bvirt) + (_0 - bvirt);
    u3 = _j + _k;
    u[2] = _k - (u3 - _j);
    u[3] = u3;
    finlen = finadd(finlen, 4, u);
    if (z !== 0) {
        c = (0, _utilJs.splitter) * z;
        bhi = c - (c - z);
        blo = z - bhi;
        _i = s0 * z;
        c = (0, _utilJs.splitter) * s0;
        ahi = c - (c - s0);
        alo = s0 - ahi;
        u[0] = alo * blo - (_i - ahi * bhi - alo * bhi - ahi * blo);
        _j = s1 * z;
        c = (0, _utilJs.splitter) * s1;
        ahi = c - (c - s1);
        alo = s1 - ahi;
        _0 = alo * blo - (_j - ahi * bhi - alo * bhi - ahi * blo);
        _k = _i + _0;
        bvirt = _k - _i;
        u[1] = _i - (_k - bvirt) + (_0 - bvirt);
        u3 = _j + _k;
        u[2] = _k - (u3 - _j);
        u[3] = u3;
        finlen = finadd(finlen, 4, u);
    }
    return finlen;
}
function orient3dadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, permanent) {
    let finlen;
    let adxtail, bdxtail, cdxtail;
    let adytail, bdytail, cdytail;
    let adztail, bdztail, cdztail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, t1, t0, u3;
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    s1 = bdx * cdy;
    c = (0, _utilJs.splitter) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, _utilJs.splitter) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cdx * bdy;
    c = (0, _utilJs.splitter) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, _utilJs.splitter) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    bc[3] = u3;
    s1 = cdx * ady;
    c = (0, _utilJs.splitter) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, _utilJs.splitter) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = adx * cdy;
    c = (0, _utilJs.splitter) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, _utilJs.splitter) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ca[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ca[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ca[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ca[3] = u3;
    s1 = adx * bdy;
    c = (0, _utilJs.splitter) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, _utilJs.splitter) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bdx * ady;
    c = (0, _utilJs.splitter) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, _utilJs.splitter) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ab[3] = u3;
    finlen = (0, _utilJs.sum)((0, _utilJs.sum)((0, _utilJs.scale)(4, bc, adz, _8), _8, (0, _utilJs.scale)(4, ca, bdz, _8b), _8b, _16), _16, (0, _utilJs.scale)(4, ab, cdz, _8), _8, fin);
    let det = (0, _utilJs.estimate)(finlen, fin);
    let errbound = o3derrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - adx;
    adxtail = ax - (adx + bvirt) + (bvirt - dx);
    bvirt = bx - bdx;
    bdxtail = bx - (bdx + bvirt) + (bvirt - dx);
    bvirt = cx - cdx;
    cdxtail = cx - (cdx + bvirt) + (bvirt - dx);
    bvirt = ay - ady;
    adytail = ay - (ady + bvirt) + (bvirt - dy);
    bvirt = by - bdy;
    bdytail = by - (bdy + bvirt) + (bvirt - dy);
    bvirt = cy - cdy;
    cdytail = cy - (cdy + bvirt) + (bvirt - dy);
    bvirt = az - adz;
    adztail = az - (adz + bvirt) + (bvirt - dz);
    bvirt = bz - bdz;
    bdztail = bz - (bdz + bvirt) + (bvirt - dz);
    bvirt = cz - cdz;
    cdztail = cz - (cdz + bvirt) + (bvirt - dz);
    if (adxtail === 0 && bdxtail === 0 && cdxtail === 0 && adytail === 0 && bdytail === 0 && cdytail === 0 && adztail === 0 && bdztail === 0 && cdztail === 0) return det;
    errbound = o3derrboundC * permanent + (0, _utilJs.resulterrbound) * Math.abs(det);
    det += adz * (bdx * cdytail + cdy * bdxtail - (bdy * cdxtail + cdx * bdytail)) + adztail * (bdx * cdy - bdy * cdx) + bdz * (cdx * adytail + ady * cdxtail - (cdy * adxtail + adx * cdytail)) + bdztail * (cdx * ady - cdy * adx) + cdz * (adx * bdytail + bdy * adxtail - (ady * bdxtail + bdx * adytail)) + cdztail * (adx * bdy - ady * bdx);
    if (det >= errbound || -det >= errbound) return det;
    const at_len = tailinit(adxtail, adytail, bdx, bdy, cdx, cdy, at_b, at_c);
    const bt_len = tailinit(bdxtail, bdytail, cdx, cdy, adx, ady, bt_c, bt_a);
    const ct_len = tailinit(cdxtail, cdytail, adx, ady, bdx, bdy, ct_a, ct_b);
    const bctlen = (0, _utilJs.sum)(bt_len, bt_c, ct_len, ct_b, bct);
    finlen = finadd(finlen, (0, _utilJs.scale)(bctlen, bct, adz, _16), _16);
    const catlen = (0, _utilJs.sum)(ct_len, ct_a, at_len, at_c, cat);
    finlen = finadd(finlen, (0, _utilJs.scale)(catlen, cat, bdz, _16), _16);
    const abtlen = (0, _utilJs.sum)(at_len, at_b, bt_len, bt_a, abt);
    finlen = finadd(finlen, (0, _utilJs.scale)(abtlen, abt, cdz, _16), _16);
    if (adztail !== 0) {
        finlen = finadd(finlen, (0, _utilJs.scale)(4, bc, adztail, _12), _12);
        finlen = finadd(finlen, (0, _utilJs.scale)(bctlen, bct, adztail, _16), _16);
    }
    if (bdztail !== 0) {
        finlen = finadd(finlen, (0, _utilJs.scale)(4, ca, bdztail, _12), _12);
        finlen = finadd(finlen, (0, _utilJs.scale)(catlen, cat, bdztail, _16), _16);
    }
    if (cdztail !== 0) {
        finlen = finadd(finlen, (0, _utilJs.scale)(4, ab, cdztail, _12), _12);
        finlen = finadd(finlen, (0, _utilJs.scale)(abtlen, abt, cdztail, _16), _16);
    }
    if (adxtail !== 0) {
        if (bdytail !== 0) finlen = tailadd(finlen, adxtail, bdytail, cdz, cdztail);
        if (cdytail !== 0) finlen = tailadd(finlen, -adxtail, cdytail, bdz, bdztail);
    }
    if (bdxtail !== 0) {
        if (cdytail !== 0) finlen = tailadd(finlen, bdxtail, cdytail, adz, adztail);
        if (adytail !== 0) finlen = tailadd(finlen, -bdxtail, adytail, cdz, cdztail);
    }
    if (cdxtail !== 0) {
        if (adytail !== 0) finlen = tailadd(finlen, cdxtail, adytail, bdz, bdztail);
        if (bdytail !== 0) finlen = tailadd(finlen, -cdxtail, bdytail, adz, adztail);
    }
    return fin[finlen - 1];
}
function orient3d(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    const bdxcdy = bdx * cdy;
    const cdxbdy = cdx * bdy;
    const cdxady = cdx * ady;
    const adxcdy = adx * cdy;
    const adxbdy = adx * bdy;
    const bdxady = bdx * ady;
    const det = adz * (bdxcdy - cdxbdy) + bdz * (cdxady - adxcdy) + cdz * (adxbdy - bdxady);
    const permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * Math.abs(adz) + (Math.abs(cdxady) + Math.abs(adxcdy)) * Math.abs(bdz) + (Math.abs(adxbdy) + Math.abs(bdxady)) * Math.abs(cdz);
    const errbound = o3derrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return orient3dadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, permanent);
}
function orient3dfast(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    return adx * (bdy * cdz - bdz * cdy) + bdx * (cdy * adz - cdz * ady) + cdx * (ady * bdz - adz * bdy);
}

},{"./util.js":"dWrL1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cGSqn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "incircle", ()=>incircle);
parcelHelpers.export(exports, "incirclefast", ()=>incirclefast);
var _utilJs = require("./util.js");
const iccerrboundA = (10 + 96 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const iccerrboundB = (4 + 48 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const iccerrboundC = (44 + 576 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon) * (0, _utilJs.epsilon);
const bc = (0, _utilJs.vec)(4);
const ca = (0, _utilJs.vec)(4);
const ab = (0, _utilJs.vec)(4);
const aa = (0, _utilJs.vec)(4);
const bb = (0, _utilJs.vec)(4);
const cc = (0, _utilJs.vec)(4);
const u = (0, _utilJs.vec)(4);
const v = (0, _utilJs.vec)(4);
const axtbc = (0, _utilJs.vec)(8);
const aytbc = (0, _utilJs.vec)(8);
const bxtca = (0, _utilJs.vec)(8);
const bytca = (0, _utilJs.vec)(8);
const cxtab = (0, _utilJs.vec)(8);
const cytab = (0, _utilJs.vec)(8);
const abt = (0, _utilJs.vec)(8);
const bct = (0, _utilJs.vec)(8);
const cat = (0, _utilJs.vec)(8);
const abtt = (0, _utilJs.vec)(4);
const bctt = (0, _utilJs.vec)(4);
const catt = (0, _utilJs.vec)(4);
const _8 = (0, _utilJs.vec)(8);
const _16 = (0, _utilJs.vec)(16);
const _16b = (0, _utilJs.vec)(16);
const _16c = (0, _utilJs.vec)(16);
const _32 = (0, _utilJs.vec)(32);
const _32b = (0, _utilJs.vec)(32);
const _48 = (0, _utilJs.vec)(48);
const _64 = (0, _utilJs.vec)(64);
let fin = (0, _utilJs.vec)(1152);
let fin2 = (0, _utilJs.vec)(1152);
function finadd(finlen, a, alen) {
    finlen = (0, _utilJs.sum)(finlen, fin, a, alen, fin2);
    const tmp = fin;
    fin = fin2;
    fin2 = tmp;
    return finlen;
}
function incircleadapt(ax, ay, bx, by, cx, cy, dx, dy, permanent) {
    let finlen;
    let adxtail, bdxtail, cdxtail, adytail, bdytail, cdytail;
    let axtbclen, aytbclen, bxtcalen, bytcalen, cxtablen, cytablen;
    let abtlen, bctlen, catlen;
    let abttlen, bcttlen, cattlen;
    let n1, n0;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    s1 = bdx * cdy;
    c = (0, _utilJs.splitter) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, _utilJs.splitter) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cdx * bdy;
    c = (0, _utilJs.splitter) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, _utilJs.splitter) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    bc[3] = u3;
    s1 = cdx * ady;
    c = (0, _utilJs.splitter) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, _utilJs.splitter) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = adx * cdy;
    c = (0, _utilJs.splitter) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, _utilJs.splitter) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ca[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ca[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ca[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ca[3] = u3;
    s1 = adx * bdy;
    c = (0, _utilJs.splitter) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, _utilJs.splitter) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bdx * ady;
    c = (0, _utilJs.splitter) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, _utilJs.splitter) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ab[3] = u3;
    finlen = (0, _utilJs.sum)((0, _utilJs.sum)((0, _utilJs.sum)((0, _utilJs.scale)((0, _utilJs.scale)(4, bc, adx, _8), _8, adx, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, bc, ady, _8), _8, ady, _16b), _16b, _32), _32, (0, _utilJs.sum)((0, _utilJs.scale)((0, _utilJs.scale)(4, ca, bdx, _8), _8, bdx, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, ca, bdy, _8), _8, bdy, _16b), _16b, _32b), _32b, _64), _64, (0, _utilJs.sum)((0, _utilJs.scale)((0, _utilJs.scale)(4, ab, cdx, _8), _8, cdx, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, ab, cdy, _8), _8, cdy, _16b), _16b, _32), _32, fin);
    let det = (0, _utilJs.estimate)(finlen, fin);
    let errbound = iccerrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - adx;
    adxtail = ax - (adx + bvirt) + (bvirt - dx);
    bvirt = ay - ady;
    adytail = ay - (ady + bvirt) + (bvirt - dy);
    bvirt = bx - bdx;
    bdxtail = bx - (bdx + bvirt) + (bvirt - dx);
    bvirt = by - bdy;
    bdytail = by - (bdy + bvirt) + (bvirt - dy);
    bvirt = cx - cdx;
    cdxtail = cx - (cdx + bvirt) + (bvirt - dx);
    bvirt = cy - cdy;
    cdytail = cy - (cdy + bvirt) + (bvirt - dy);
    if (adxtail === 0 && bdxtail === 0 && cdxtail === 0 && adytail === 0 && bdytail === 0 && cdytail === 0) return det;
    errbound = iccerrboundC * permanent + (0, _utilJs.resulterrbound) * Math.abs(det);
    det += (adx * adx + ady * ady) * (bdx * cdytail + cdy * bdxtail - (bdy * cdxtail + cdx * bdytail)) + 2 * (adx * adxtail + ady * adytail) * (bdx * cdy - bdy * cdx) + ((bdx * bdx + bdy * bdy) * (cdx * adytail + ady * cdxtail - (cdy * adxtail + adx * cdytail)) + 2 * (bdx * bdxtail + bdy * bdytail) * (cdx * ady - cdy * adx)) + ((cdx * cdx + cdy * cdy) * (adx * bdytail + bdy * adxtail - (ady * bdxtail + bdx * adytail)) + 2 * (cdx * cdxtail + cdy * cdytail) * (adx * bdy - ady * bdx));
    if (det >= errbound || -det >= errbound) return det;
    if (bdxtail !== 0 || bdytail !== 0 || cdxtail !== 0 || cdytail !== 0) {
        s1 = adx * adx;
        c = (0, _utilJs.splitter) * adx;
        ahi = c - (c - adx);
        alo = adx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = ady * ady;
        c = (0, _utilJs.splitter) * ady;
        ahi = c - (c - ady);
        alo = ady - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        aa[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        aa[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        aa[2] = _j - (u3 - bvirt) + (_i - bvirt);
        aa[3] = u3;
    }
    if (cdxtail !== 0 || cdytail !== 0 || adxtail !== 0 || adytail !== 0) {
        s1 = bdx * bdx;
        c = (0, _utilJs.splitter) * bdx;
        ahi = c - (c - bdx);
        alo = bdx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = bdy * bdy;
        c = (0, _utilJs.splitter) * bdy;
        ahi = c - (c - bdy);
        alo = bdy - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        bb[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        bb[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        bb[2] = _j - (u3 - bvirt) + (_i - bvirt);
        bb[3] = u3;
    }
    if (adxtail !== 0 || adytail !== 0 || bdxtail !== 0 || bdytail !== 0) {
        s1 = cdx * cdx;
        c = (0, _utilJs.splitter) * cdx;
        ahi = c - (c - cdx);
        alo = cdx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = cdy * cdy;
        c = (0, _utilJs.splitter) * cdy;
        ahi = c - (c - cdy);
        alo = cdy - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        cc[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        cc[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        cc[2] = _j - (u3 - bvirt) + (_i - bvirt);
        cc[3] = u3;
    }
    if (adxtail !== 0) {
        axtbclen = (0, _utilJs.scale)(4, bc, adxtail, axtbc);
        finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(axtbclen, axtbc, 2 * adx, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, cc, adxtail, _8), _8, bdy, _16b), _16b, (0, _utilJs.scale)((0, _utilJs.scale)(4, bb, adxtail, _8), _8, -cdy, _16c), _16c, _32, _48), _48);
    }
    if (adytail !== 0) {
        aytbclen = (0, _utilJs.scale)(4, bc, adytail, aytbc);
        finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(aytbclen, aytbc, 2 * ady, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, bb, adytail, _8), _8, cdx, _16b), _16b, (0, _utilJs.scale)((0, _utilJs.scale)(4, cc, adytail, _8), _8, -bdx, _16c), _16c, _32, _48), _48);
    }
    if (bdxtail !== 0) {
        bxtcalen = (0, _utilJs.scale)(4, ca, bdxtail, bxtca);
        finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(bxtcalen, bxtca, 2 * bdx, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, aa, bdxtail, _8), _8, cdy, _16b), _16b, (0, _utilJs.scale)((0, _utilJs.scale)(4, cc, bdxtail, _8), _8, -ady, _16c), _16c, _32, _48), _48);
    }
    if (bdytail !== 0) {
        bytcalen = (0, _utilJs.scale)(4, ca, bdytail, bytca);
        finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(bytcalen, bytca, 2 * bdy, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, cc, bdytail, _8), _8, adx, _16b), _16b, (0, _utilJs.scale)((0, _utilJs.scale)(4, aa, bdytail, _8), _8, -cdx, _16c), _16c, _32, _48), _48);
    }
    if (cdxtail !== 0) {
        cxtablen = (0, _utilJs.scale)(4, ab, cdxtail, cxtab);
        finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(cxtablen, cxtab, 2 * cdx, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, bb, cdxtail, _8), _8, ady, _16b), _16b, (0, _utilJs.scale)((0, _utilJs.scale)(4, aa, cdxtail, _8), _8, -bdy, _16c), _16c, _32, _48), _48);
    }
    if (cdytail !== 0) {
        cytablen = (0, _utilJs.scale)(4, ab, cdytail, cytab);
        finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(cytablen, cytab, 2 * cdy, _16), _16, (0, _utilJs.scale)((0, _utilJs.scale)(4, aa, cdytail, _8), _8, bdx, _16b), _16b, (0, _utilJs.scale)((0, _utilJs.scale)(4, bb, cdytail, _8), _8, -adx, _16c), _16c, _32, _48), _48);
    }
    if (adxtail !== 0 || adytail !== 0) {
        if (bdxtail !== 0 || bdytail !== 0 || cdxtail !== 0 || cdytail !== 0) {
            s1 = bdxtail * cdy;
            c = (0, _utilJs.splitter) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, _utilJs.splitter) * cdy;
            bhi = c - (c - cdy);
            blo = cdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdx * cdytail;
            c = (0, _utilJs.splitter) * bdx;
            ahi = c - (c - bdx);
            alo = bdx - ahi;
            c = (0, _utilJs.splitter) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            u[3] = u3;
            s1 = cdxtail * -bdy;
            c = (0, _utilJs.splitter) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, _utilJs.splitter) * -bdy;
            bhi = c - (c - -bdy);
            blo = -bdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdx * -bdytail;
            c = (0, _utilJs.splitter) * cdx;
            ahi = c - (c - cdx);
            alo = cdx - ahi;
            c = (0, _utilJs.splitter) * -bdytail;
            bhi = c - (c - -bdytail);
            blo = -bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            v[3] = u3;
            bctlen = (0, _utilJs.sum)(4, u, 4, v, bct);
            s1 = bdxtail * cdytail;
            c = (0, _utilJs.splitter) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, _utilJs.splitter) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdxtail * bdytail;
            c = (0, _utilJs.splitter) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, _utilJs.splitter) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            bctt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            bctt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            bctt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            bctt[3] = u3;
            bcttlen = 4;
        } else {
            bct[0] = 0;
            bctlen = 1;
            bctt[0] = 0;
            bcttlen = 1;
        }
        if (adxtail !== 0) {
            const len = (0, _utilJs.scale)(bctlen, bct, adxtail, _16c);
            finlen = finadd(finlen, (0, _utilJs.sum)((0, _utilJs.scale)(axtbclen, axtbc, adxtail, _16), _16, (0, _utilJs.scale)(len, _16c, 2 * adx, _32), _32, _48), _48);
            const len2 = (0, _utilJs.scale)(bcttlen, bctt, adxtail, _8);
            finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(len2, _8, 2 * adx, _16), _16, (0, _utilJs.scale)(len2, _8, adxtail, _16b), _16b, (0, _utilJs.scale)(len, _16c, adxtail, _32), _32, _32b, _64), _64);
            if (bdytail !== 0) finlen = finadd(finlen, (0, _utilJs.scale)((0, _utilJs.scale)(4, cc, adxtail, _8), _8, bdytail, _16), _16);
            if (cdytail !== 0) finlen = finadd(finlen, (0, _utilJs.scale)((0, _utilJs.scale)(4, bb, -adxtail, _8), _8, cdytail, _16), _16);
        }
        if (adytail !== 0) {
            const len = (0, _utilJs.scale)(bctlen, bct, adytail, _16c);
            finlen = finadd(finlen, (0, _utilJs.sum)((0, _utilJs.scale)(aytbclen, aytbc, adytail, _16), _16, (0, _utilJs.scale)(len, _16c, 2 * ady, _32), _32, _48), _48);
            const len2 = (0, _utilJs.scale)(bcttlen, bctt, adytail, _8);
            finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(len2, _8, 2 * ady, _16), _16, (0, _utilJs.scale)(len2, _8, adytail, _16b), _16b, (0, _utilJs.scale)(len, _16c, adytail, _32), _32, _32b, _64), _64);
        }
    }
    if (bdxtail !== 0 || bdytail !== 0) {
        if (cdxtail !== 0 || cdytail !== 0 || adxtail !== 0 || adytail !== 0) {
            s1 = cdxtail * ady;
            c = (0, _utilJs.splitter) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, _utilJs.splitter) * ady;
            bhi = c - (c - ady);
            blo = ady - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdx * adytail;
            c = (0, _utilJs.splitter) * cdx;
            ahi = c - (c - cdx);
            alo = cdx - ahi;
            c = (0, _utilJs.splitter) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            u[3] = u3;
            n1 = -cdy;
            n0 = -cdytail;
            s1 = adxtail * n1;
            c = (0, _utilJs.splitter) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, _utilJs.splitter) * n1;
            bhi = c - (c - n1);
            blo = n1 - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adx * n0;
            c = (0, _utilJs.splitter) * adx;
            ahi = c - (c - adx);
            alo = adx - ahi;
            c = (0, _utilJs.splitter) * n0;
            bhi = c - (c - n0);
            blo = n0 - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            v[3] = u3;
            catlen = (0, _utilJs.sum)(4, u, 4, v, cat);
            s1 = cdxtail * adytail;
            c = (0, _utilJs.splitter) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, _utilJs.splitter) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adxtail * cdytail;
            c = (0, _utilJs.splitter) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, _utilJs.splitter) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            catt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            catt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            catt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            catt[3] = u3;
            cattlen = 4;
        } else {
            cat[0] = 0;
            catlen = 1;
            catt[0] = 0;
            cattlen = 1;
        }
        if (bdxtail !== 0) {
            const len = (0, _utilJs.scale)(catlen, cat, bdxtail, _16c);
            finlen = finadd(finlen, (0, _utilJs.sum)((0, _utilJs.scale)(bxtcalen, bxtca, bdxtail, _16), _16, (0, _utilJs.scale)(len, _16c, 2 * bdx, _32), _32, _48), _48);
            const len2 = (0, _utilJs.scale)(cattlen, catt, bdxtail, _8);
            finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(len2, _8, 2 * bdx, _16), _16, (0, _utilJs.scale)(len2, _8, bdxtail, _16b), _16b, (0, _utilJs.scale)(len, _16c, bdxtail, _32), _32, _32b, _64), _64);
            if (cdytail !== 0) finlen = finadd(finlen, (0, _utilJs.scale)((0, _utilJs.scale)(4, aa, bdxtail, _8), _8, cdytail, _16), _16);
            if (adytail !== 0) finlen = finadd(finlen, (0, _utilJs.scale)((0, _utilJs.scale)(4, cc, -bdxtail, _8), _8, adytail, _16), _16);
        }
        if (bdytail !== 0) {
            const len = (0, _utilJs.scale)(catlen, cat, bdytail, _16c);
            finlen = finadd(finlen, (0, _utilJs.sum)((0, _utilJs.scale)(bytcalen, bytca, bdytail, _16), _16, (0, _utilJs.scale)(len, _16c, 2 * bdy, _32), _32, _48), _48);
            const len2 = (0, _utilJs.scale)(cattlen, catt, bdytail, _8);
            finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(len2, _8, 2 * bdy, _16), _16, (0, _utilJs.scale)(len2, _8, bdytail, _16b), _16b, (0, _utilJs.scale)(len, _16c, bdytail, _32), _32, _32b, _64), _64);
        }
    }
    if (cdxtail !== 0 || cdytail !== 0) {
        if (adxtail !== 0 || adytail !== 0 || bdxtail !== 0 || bdytail !== 0) {
            s1 = adxtail * bdy;
            c = (0, _utilJs.splitter) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, _utilJs.splitter) * bdy;
            bhi = c - (c - bdy);
            blo = bdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adx * bdytail;
            c = (0, _utilJs.splitter) * adx;
            ahi = c - (c - adx);
            alo = adx - ahi;
            c = (0, _utilJs.splitter) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            u[3] = u3;
            n1 = -ady;
            n0 = -adytail;
            s1 = bdxtail * n1;
            c = (0, _utilJs.splitter) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, _utilJs.splitter) * n1;
            bhi = c - (c - n1);
            blo = n1 - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdx * n0;
            c = (0, _utilJs.splitter) * bdx;
            ahi = c - (c - bdx);
            alo = bdx - ahi;
            c = (0, _utilJs.splitter) * n0;
            bhi = c - (c - n0);
            blo = n0 - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            v[3] = u3;
            abtlen = (0, _utilJs.sum)(4, u, 4, v, abt);
            s1 = adxtail * bdytail;
            c = (0, _utilJs.splitter) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, _utilJs.splitter) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdxtail * adytail;
            c = (0, _utilJs.splitter) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, _utilJs.splitter) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            abtt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            abtt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            abtt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            abtt[3] = u3;
            abttlen = 4;
        } else {
            abt[0] = 0;
            abtlen = 1;
            abtt[0] = 0;
            abttlen = 1;
        }
        if (cdxtail !== 0) {
            const len = (0, _utilJs.scale)(abtlen, abt, cdxtail, _16c);
            finlen = finadd(finlen, (0, _utilJs.sum)((0, _utilJs.scale)(cxtablen, cxtab, cdxtail, _16), _16, (0, _utilJs.scale)(len, _16c, 2 * cdx, _32), _32, _48), _48);
            const len2 = (0, _utilJs.scale)(abttlen, abtt, cdxtail, _8);
            finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(len2, _8, 2 * cdx, _16), _16, (0, _utilJs.scale)(len2, _8, cdxtail, _16b), _16b, (0, _utilJs.scale)(len, _16c, cdxtail, _32), _32, _32b, _64), _64);
            if (adytail !== 0) finlen = finadd(finlen, (0, _utilJs.scale)((0, _utilJs.scale)(4, bb, cdxtail, _8), _8, adytail, _16), _16);
            if (bdytail !== 0) finlen = finadd(finlen, (0, _utilJs.scale)((0, _utilJs.scale)(4, aa, -cdxtail, _8), _8, bdytail, _16), _16);
        }
        if (cdytail !== 0) {
            const len = (0, _utilJs.scale)(abtlen, abt, cdytail, _16c);
            finlen = finadd(finlen, (0, _utilJs.sum)((0, _utilJs.scale)(cytablen, cytab, cdytail, _16), _16, (0, _utilJs.scale)(len, _16c, 2 * cdy, _32), _32, _48), _48);
            const len2 = (0, _utilJs.scale)(abttlen, abtt, cdytail, _8);
            finlen = finadd(finlen, (0, _utilJs.sum_three)((0, _utilJs.scale)(len2, _8, 2 * cdy, _16), _16, (0, _utilJs.scale)(len2, _8, cdytail, _16b), _16b, (0, _utilJs.scale)(len, _16c, cdytail, _32), _32, _32b, _64), _64);
        }
    }
    return fin[finlen - 1];
}
function incircle(ax, ay, bx, by, cx, cy, dx, dy) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const bdxcdy = bdx * cdy;
    const cdxbdy = cdx * bdy;
    const alift = adx * adx + ady * ady;
    const cdxady = cdx * ady;
    const adxcdy = adx * cdy;
    const blift = bdx * bdx + bdy * bdy;
    const adxbdy = adx * bdy;
    const bdxady = bdx * ady;
    const clift = cdx * cdx + cdy * cdy;
    const det = alift * (bdxcdy - cdxbdy) + blift * (cdxady - adxcdy) + clift * (adxbdy - bdxady);
    const permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * alift + (Math.abs(cdxady) + Math.abs(adxcdy)) * blift + (Math.abs(adxbdy) + Math.abs(bdxady)) * clift;
    const errbound = iccerrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return incircleadapt(ax, ay, bx, by, cx, cy, dx, dy, permanent);
}
function incirclefast(ax, ay, bx, by, cx, cy, dx, dy) {
    const adx = ax - dx;
    const ady = ay - dy;
    const bdx = bx - dx;
    const bdy = by - dy;
    const cdx = cx - dx;
    const cdy = cy - dy;
    const abdet = adx * bdy - bdx * ady;
    const bcdet = bdx * cdy - cdx * bdy;
    const cadet = cdx * ady - adx * cdy;
    const alift = adx * adx + ady * ady;
    const blift = bdx * bdx + bdy * bdy;
    const clift = cdx * cdx + cdy * cdy;
    return alift * bcdet + blift * cadet + clift * abdet;
}

},{"./util.js":"dWrL1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a9t6m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "insphere", ()=>insphere);
parcelHelpers.export(exports, "inspherefast", ()=>inspherefast);
var _utilJs = require("./util.js");
const isperrboundA = (16 + 224 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const isperrboundB = (5 + 72 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon);
const isperrboundC = (71 + 1408 * (0, _utilJs.epsilon)) * (0, _utilJs.epsilon) * (0, _utilJs.epsilon);
const ab = (0, _utilJs.vec)(4);
const bc = (0, _utilJs.vec)(4);
const cd = (0, _utilJs.vec)(4);
const de = (0, _utilJs.vec)(4);
const ea = (0, _utilJs.vec)(4);
const ac = (0, _utilJs.vec)(4);
const bd = (0, _utilJs.vec)(4);
const ce = (0, _utilJs.vec)(4);
const da = (0, _utilJs.vec)(4);
const eb = (0, _utilJs.vec)(4);
const abc = (0, _utilJs.vec)(24);
const bcd = (0, _utilJs.vec)(24);
const cde = (0, _utilJs.vec)(24);
const dea = (0, _utilJs.vec)(24);
const eab = (0, _utilJs.vec)(24);
const abd = (0, _utilJs.vec)(24);
const bce = (0, _utilJs.vec)(24);
const cda = (0, _utilJs.vec)(24);
const deb = (0, _utilJs.vec)(24);
const eac = (0, _utilJs.vec)(24);
const adet = (0, _utilJs.vec)(1152);
const bdet = (0, _utilJs.vec)(1152);
const cdet = (0, _utilJs.vec)(1152);
const ddet = (0, _utilJs.vec)(1152);
const edet = (0, _utilJs.vec)(1152);
const abdet = (0, _utilJs.vec)(2304);
const cddet = (0, _utilJs.vec)(2304);
const cdedet = (0, _utilJs.vec)(3456);
const deter = (0, _utilJs.vec)(5760);
const _8 = (0, _utilJs.vec)(8);
const _8b = (0, _utilJs.vec)(8);
const _8c = (0, _utilJs.vec)(8);
const _16 = (0, _utilJs.vec)(16);
const _24 = (0, _utilJs.vec)(24);
const _48 = (0, _utilJs.vec)(48);
const _48b = (0, _utilJs.vec)(48);
const _96 = (0, _utilJs.vec)(96);
const _192 = (0, _utilJs.vec)(192);
const _384x = (0, _utilJs.vec)(384);
const _384y = (0, _utilJs.vec)(384);
const _384z = (0, _utilJs.vec)(384);
const _768 = (0, _utilJs.vec)(768);
function sum_three_scale(a, b, c, az, bz, cz, out) {
    return (0, _utilJs.sum_three)((0, _utilJs.scale)(4, a, az, _8), _8, (0, _utilJs.scale)(4, b, bz, _8b), _8b, (0, _utilJs.scale)(4, c, cz, _8c), _8c, _16, out);
}
function liftexact(alen, a, blen, b, clen, c, dlen, d, x, y, z, out) {
    const len = (0, _utilJs.sum)((0, _utilJs.sum)(alen, a, blen, b, _48), _48, (0, _utilJs.negate)((0, _utilJs.sum)(clen, c, dlen, d, _48b), _48b), _48b, _96);
    return (0, _utilJs.sum_three)((0, _utilJs.scale)((0, _utilJs.scale)(len, _96, x, _192), _192, x, _384x), _384x, (0, _utilJs.scale)((0, _utilJs.scale)(len, _96, y, _192), _192, y, _384y), _384y, (0, _utilJs.scale)((0, _utilJs.scale)(len, _96, z, _192), _192, z, _384z), _384z, _768, out);
}
function insphereexact(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    s1 = ax * by;
    c = (0, _utilJs.splitter) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, _utilJs.splitter) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bx * ay;
    c = (0, _utilJs.splitter) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, _utilJs.splitter) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ab[3] = u3;
    s1 = bx * cy;
    c = (0, _utilJs.splitter) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, _utilJs.splitter) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cx * by;
    c = (0, _utilJs.splitter) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, _utilJs.splitter) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    bc[3] = u3;
    s1 = cx * dy;
    c = (0, _utilJs.splitter) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, _utilJs.splitter) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dx * cy;
    c = (0, _utilJs.splitter) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, _utilJs.splitter) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    cd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    cd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    cd[2] = _j - (u3 - bvirt) + (_i - bvirt);
    cd[3] = u3;
    s1 = dx * ey;
    c = (0, _utilJs.splitter) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, _utilJs.splitter) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ex * dy;
    c = (0, _utilJs.splitter) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, _utilJs.splitter) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    de[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    de[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    de[2] = _j - (u3 - bvirt) + (_i - bvirt);
    de[3] = u3;
    s1 = ex * ay;
    c = (0, _utilJs.splitter) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, _utilJs.splitter) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ax * ey;
    c = (0, _utilJs.splitter) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, _utilJs.splitter) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ea[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ea[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ea[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ea[3] = u3;
    s1 = ax * cy;
    c = (0, _utilJs.splitter) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, _utilJs.splitter) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cx * ay;
    c = (0, _utilJs.splitter) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, _utilJs.splitter) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ac[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ac[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ac[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ac[3] = u3;
    s1 = bx * dy;
    c = (0, _utilJs.splitter) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, _utilJs.splitter) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dx * by;
    c = (0, _utilJs.splitter) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, _utilJs.splitter) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    bd[2] = _j - (u3 - bvirt) + (_i - bvirt);
    bd[3] = u3;
    s1 = cx * ey;
    c = (0, _utilJs.splitter) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, _utilJs.splitter) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ex * cy;
    c = (0, _utilJs.splitter) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, _utilJs.splitter) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ce[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ce[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    ce[2] = _j - (u3 - bvirt) + (_i - bvirt);
    ce[3] = u3;
    s1 = dx * ay;
    c = (0, _utilJs.splitter) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, _utilJs.splitter) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ax * dy;
    c = (0, _utilJs.splitter) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, _utilJs.splitter) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    da[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    da[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    da[2] = _j - (u3 - bvirt) + (_i - bvirt);
    da[3] = u3;
    s1 = ex * by;
    c = (0, _utilJs.splitter) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, _utilJs.splitter) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bx * ey;
    c = (0, _utilJs.splitter) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, _utilJs.splitter) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    eb[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    eb[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    eb[2] = _j - (u3 - bvirt) + (_i - bvirt);
    eb[3] = u3;
    const abclen = sum_three_scale(ab, bc, ac, cz, az, -bz, abc);
    const bcdlen = sum_three_scale(bc, cd, bd, dz, bz, -cz, bcd);
    const cdelen = sum_three_scale(cd, de, ce, ez, cz, -dz, cde);
    const dealen = sum_three_scale(de, ea, da, az, dz, -ez, dea);
    const eablen = sum_three_scale(ea, ab, eb, bz, ez, -az, eab);
    const abdlen = sum_three_scale(ab, bd, da, dz, az, bz, abd);
    const bcelen = sum_three_scale(bc, ce, eb, ez, bz, cz, bce);
    const cdalen = sum_three_scale(cd, da, ac, az, cz, dz, cda);
    const deblen = sum_three_scale(de, eb, bd, bz, dz, ez, deb);
    const eaclen = sum_three_scale(ea, ac, ce, cz, ez, az, eac);
    const deterlen = (0, _utilJs.sum_three)(liftexact(cdelen, cde, bcelen, bce, deblen, deb, bcdlen, bcd, ax, ay, az, adet), adet, liftexact(dealen, dea, cdalen, cda, eaclen, eac, cdelen, cde, bx, by, bz, bdet), bdet, (0, _utilJs.sum_three)(liftexact(eablen, eab, deblen, deb, abdlen, abd, dealen, dea, cx, cy, cz, cdet), cdet, liftexact(abclen, abc, eaclen, eac, bcelen, bce, eablen, eab, dx, dy, dz, ddet), ddet, liftexact(bcdlen, bcd, abdlen, abd, cdalen, cda, abclen, abc, ex, ey, ez, edet), edet, cddet, cdedet), cdedet, abdet, deter);
    return deter[deterlen - 1];
}
const xdet = (0, _utilJs.vec)(96);
const ydet = (0, _utilJs.vec)(96);
const zdet = (0, _utilJs.vec)(96);
const fin = (0, _utilJs.vec)(1152);
function liftadapt(a, b, c, az, bz, cz, x, y, z, out) {
    const len = sum_three_scale(a, b, c, az, bz, cz, _24);
    return (0, _utilJs.sum_three)((0, _utilJs.scale)((0, _utilJs.scale)(len, _24, x, _48), _48, x, xdet), xdet, (0, _utilJs.scale)((0, _utilJs.scale)(len, _24, y, _48), _48, y, ydet), ydet, (0, _utilJs.scale)((0, _utilJs.scale)(len, _24, z, _48), _48, z, zdet), zdet, _192, out);
}
function insphereadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez, permanent) {
    let ab3, bc3, cd3, da3, ac3, bd3;
    let aextail, bextail, cextail, dextail;
    let aeytail, beytail, ceytail, deytail;
    let aeztail, beztail, ceztail, deztail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0;
    const aex = ax - ex;
    const bex = bx - ex;
    const cex = cx - ex;
    const dex = dx - ex;
    const aey = ay - ey;
    const bey = by - ey;
    const cey = cy - ey;
    const dey = dy - ey;
    const aez = az - ez;
    const bez = bz - ez;
    const cez = cz - ez;
    const dez = dz - ez;
    s1 = aex * bey;
    c = (0, _utilJs.splitter) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, _utilJs.splitter) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bex * aey;
    c = (0, _utilJs.splitter) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, _utilJs.splitter) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    ab3 = _j + _i;
    bvirt = ab3 - _j;
    ab[2] = _j - (ab3 - bvirt) + (_i - bvirt);
    ab[3] = ab3;
    s1 = bex * cey;
    c = (0, _utilJs.splitter) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, _utilJs.splitter) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cex * bey;
    c = (0, _utilJs.splitter) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, _utilJs.splitter) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    bc3 = _j + _i;
    bvirt = bc3 - _j;
    bc[2] = _j - (bc3 - bvirt) + (_i - bvirt);
    bc[3] = bc3;
    s1 = cex * dey;
    c = (0, _utilJs.splitter) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, _utilJs.splitter) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dex * cey;
    c = (0, _utilJs.splitter) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, _utilJs.splitter) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    cd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    cd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    cd3 = _j + _i;
    bvirt = cd3 - _j;
    cd[2] = _j - (cd3 - bvirt) + (_i - bvirt);
    cd[3] = cd3;
    s1 = dex * aey;
    c = (0, _utilJs.splitter) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, _utilJs.splitter) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = aex * dey;
    c = (0, _utilJs.splitter) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, _utilJs.splitter) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    da[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    da[1] = _0 - (_i + bvirt) + (bvirt - t1);
    da3 = _j + _i;
    bvirt = da3 - _j;
    da[2] = _j - (da3 - bvirt) + (_i - bvirt);
    da[3] = da3;
    s1 = aex * cey;
    c = (0, _utilJs.splitter) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, _utilJs.splitter) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cex * aey;
    c = (0, _utilJs.splitter) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, _utilJs.splitter) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    ac[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    ac[1] = _0 - (_i + bvirt) + (bvirt - t1);
    ac3 = _j + _i;
    bvirt = ac3 - _j;
    ac[2] = _j - (ac3 - bvirt) + (_i - bvirt);
    ac[3] = ac3;
    s1 = bex * dey;
    c = (0, _utilJs.splitter) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, _utilJs.splitter) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dex * bey;
    c = (0, _utilJs.splitter) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, _utilJs.splitter) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    bd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    bd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    bd3 = _j + _i;
    bvirt = bd3 - _j;
    bd[2] = _j - (bd3 - bvirt) + (_i - bvirt);
    bd[3] = bd3;
    const finlen = (0, _utilJs.sum)((0, _utilJs.sum)((0, _utilJs.negate)(liftadapt(bc, cd, bd, dez, bez, -cez, aex, aey, aez, adet), adet), adet, liftadapt(cd, da, ac, aez, cez, dez, bex, bey, bez, bdet), bdet, abdet), abdet, (0, _utilJs.sum)((0, _utilJs.negate)(liftadapt(da, ab, bd, bez, dez, aez, cex, cey, cez, cdet), cdet), cdet, liftadapt(ab, bc, ac, cez, aez, -bez, dex, dey, dez, ddet), ddet, cddet), cddet, fin);
    let det = (0, _utilJs.estimate)(finlen, fin);
    let errbound = isperrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - aex;
    aextail = ax - (aex + bvirt) + (bvirt - ex);
    bvirt = ay - aey;
    aeytail = ay - (aey + bvirt) + (bvirt - ey);
    bvirt = az - aez;
    aeztail = az - (aez + bvirt) + (bvirt - ez);
    bvirt = bx - bex;
    bextail = bx - (bex + bvirt) + (bvirt - ex);
    bvirt = by - bey;
    beytail = by - (bey + bvirt) + (bvirt - ey);
    bvirt = bz - bez;
    beztail = bz - (bez + bvirt) + (bvirt - ez);
    bvirt = cx - cex;
    cextail = cx - (cex + bvirt) + (bvirt - ex);
    bvirt = cy - cey;
    ceytail = cy - (cey + bvirt) + (bvirt - ey);
    bvirt = cz - cez;
    ceztail = cz - (cez + bvirt) + (bvirt - ez);
    bvirt = dx - dex;
    dextail = dx - (dex + bvirt) + (bvirt - ex);
    bvirt = dy - dey;
    deytail = dy - (dey + bvirt) + (bvirt - ey);
    bvirt = dz - dez;
    deztail = dz - (dez + bvirt) + (bvirt - ez);
    if (aextail === 0 && aeytail === 0 && aeztail === 0 && bextail === 0 && beytail === 0 && beztail === 0 && cextail === 0 && ceytail === 0 && ceztail === 0 && dextail === 0 && deytail === 0 && deztail === 0) return det;
    errbound = isperrboundC * permanent + (0, _utilJs.resulterrbound) * Math.abs(det);
    const abeps = aex * beytail + bey * aextail - (aey * bextail + bex * aeytail);
    const bceps = bex * ceytail + cey * bextail - (bey * cextail + cex * beytail);
    const cdeps = cex * deytail + dey * cextail - (cey * dextail + dex * ceytail);
    const daeps = dex * aeytail + aey * dextail - (dey * aextail + aex * deytail);
    const aceps = aex * ceytail + cey * aextail - (aey * cextail + cex * aeytail);
    const bdeps = bex * deytail + dey * bextail - (bey * dextail + dex * beytail);
    det += (bex * bex + bey * bey + bez * bez) * (cez * daeps + dez * aceps + aez * cdeps + (ceztail * da3 + deztail * ac3 + aeztail * cd3)) + (dex * dex + dey * dey + dez * dez) * (aez * bceps - bez * aceps + cez * abeps + (aeztail * bc3 - beztail * ac3 + ceztail * ab3)) - ((aex * aex + aey * aey + aez * aez) * (bez * cdeps - cez * bdeps + dez * bceps + (beztail * cd3 - ceztail * bd3 + deztail * bc3)) + (cex * cex + cey * cey + cez * cez) * (dez * abeps + aez * bdeps + bez * daeps + (deztail * ab3 + aeztail * bd3 + beztail * da3))) + 2 * ((bex * bextail + bey * beytail + bez * beztail) * (cez * da3 + dez * ac3 + aez * cd3) + (dex * dextail + dey * deytail + dez * deztail) * (aez * bc3 - bez * ac3 + cez * ab3) - ((aex * aextail + aey * aeytail + aez * aeztail) * (bez * cd3 - cez * bd3 + dez * bc3) + (cex * cextail + cey * ceytail + cez * ceztail) * (dez * ab3 + aez * bd3 + bez * da3)));
    if (det >= errbound || -det >= errbound) return det;
    return insphereexact(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez);
}
function insphere(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez) {
    const aex = ax - ex;
    const bex = bx - ex;
    const cex = cx - ex;
    const dex = dx - ex;
    const aey = ay - ey;
    const bey = by - ey;
    const cey = cy - ey;
    const dey = dy - ey;
    const aez = az - ez;
    const bez = bz - ez;
    const cez = cz - ez;
    const dez = dz - ez;
    const aexbey = aex * bey;
    const bexaey = bex * aey;
    const ab = aexbey - bexaey;
    const bexcey = bex * cey;
    const cexbey = cex * bey;
    const bc = bexcey - cexbey;
    const cexdey = cex * dey;
    const dexcey = dex * cey;
    const cd = cexdey - dexcey;
    const dexaey = dex * aey;
    const aexdey = aex * dey;
    const da = dexaey - aexdey;
    const aexcey = aex * cey;
    const cexaey = cex * aey;
    const ac = aexcey - cexaey;
    const bexdey = bex * dey;
    const dexbey = dex * bey;
    const bd = bexdey - dexbey;
    const alift = aex * aex + aey * aey + aez * aez;
    const blift = bex * bex + bey * bey + bez * bez;
    const clift = cex * cex + cey * cey + cez * cez;
    const dlift = dex * dex + dey * dey + dez * dez;
    const det = clift * (dez * ab + aez * bd + bez * da) - dlift * (aez * bc - bez * ac + cez * ab) + (alift * (bez * cd - cez * bd + dez * bc) - blift * (cez * da + dez * ac + aez * cd));
    const aezplus = Math.abs(aez);
    const bezplus = Math.abs(bez);
    const cezplus = Math.abs(cez);
    const dezplus = Math.abs(dez);
    const aexbeyplus = Math.abs(aexbey) + Math.abs(bexaey);
    const bexceyplus = Math.abs(bexcey) + Math.abs(cexbey);
    const cexdeyplus = Math.abs(cexdey) + Math.abs(dexcey);
    const dexaeyplus = Math.abs(dexaey) + Math.abs(aexdey);
    const aexceyplus = Math.abs(aexcey) + Math.abs(cexaey);
    const bexdeyplus = Math.abs(bexdey) + Math.abs(dexbey);
    const permanent = (cexdeyplus * bezplus + bexdeyplus * cezplus + bexceyplus * dezplus) * alift + (dexaeyplus * cezplus + aexceyplus * dezplus + cexdeyplus * aezplus) * blift + (aexbeyplus * dezplus + bexdeyplus * aezplus + dexaeyplus * bezplus) * clift + (bexceyplus * aezplus + aexceyplus * bezplus + aexbeyplus * cezplus) * dlift;
    const errbound = isperrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return -insphereadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez, permanent);
}
function inspherefast(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez) {
    const aex = ax - ex;
    const bex = bx - ex;
    const cex = cx - ex;
    const dex = dx - ex;
    const aey = ay - ey;
    const bey = by - ey;
    const cey = cy - ey;
    const dey = dy - ey;
    const aez = az - ez;
    const bez = bz - ez;
    const cez = cz - ez;
    const dez = dz - ez;
    const ab = aex * bey - bex * aey;
    const bc = bex * cey - cex * bey;
    const cd = cex * dey - dex * cey;
    const da = dex * aey - aex * dey;
    const ac = aex * cey - cex * aey;
    const bd = bex * dey - dex * bey;
    const abc = aez * bc - bez * ac + cez * ab;
    const bcd = bez * cd - cez * bd + dez * bc;
    const cda = cez * da + dez * ac + aez * cd;
    const dab = dez * ab + aez * bd + bez * da;
    const alift = aex * aex + aey * aey + aez * aez;
    const blift = bex * bex + bey * bey + bez * bez;
    const clift = cex * cex + cey * cey + cez * cez;
    const dlift = dex * dex + dey * dey + dez * dez;
    return clift * dab - dlift * abc + (alift * bcd - blift * cda);
}

},{"./util.js":"dWrL1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ebBL9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const epsilon = 1e-6;
class Path {
    constructor(){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
    }
    moveTo(x, y) {
        this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    }
    lineTo(x, y) {
        this._ += `L${this._x1 = +x},${this._y1 = +y}`;
    }
    arc(x, y, r) {
        x = +x, y = +y, r = +r;
        const x0 = x + r;
        const y0 = y;
        if (r < 0) throw new Error("negative radius");
        if (this._x1 === null) this._ += `M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) this._ += "L" + x0 + "," + y0;
        if (!r) return;
        this._ += `A${r},${r},0,1,1,${x - r},${y}A${r},${r},0,1,1,${this._x1 = x0},${this._y1 = y0}`;
    }
    rect(x, y, w, h) {
        this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${+w}v${+h}h${-w}Z`;
    }
    value() {
        return this._ || null;
    }
}
exports.default = Path;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bSOj4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class Polygon {
    constructor(){
        this._ = [];
    }
    moveTo(x, y) {
        this._.push([
            x,
            y
        ]);
    }
    closePath() {
        this._.push(this._[0].slice());
    }
    lineTo(x, y) {
        this._.push([
            x,
            y
        ]);
    }
    value() {
        return this._.length ? this._ : null;
    }
}
exports.default = Polygon;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l0HTg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
var _polygonJs = require("./polygon.js");
var _polygonJsDefault = parcelHelpers.interopDefault(_polygonJs);
class Voronoi {
    constructor(delaunay, [xmin, ymin, xmax, ymax] = [
        0,
        0,
        960,
        500
    ]){
        if (!((xmax = +xmax) >= (xmin = +xmin)) || !((ymax = +ymax) >= (ymin = +ymin))) throw new Error("invalid bounds");
        this.delaunay = delaunay;
        this._circumcenters = new Float64Array(delaunay.points.length * 2);
        this.vectors = new Float64Array(delaunay.points.length * 2);
        this.xmax = xmax, this.xmin = xmin;
        this.ymax = ymax, this.ymin = ymin;
        this._init();
    }
    update() {
        this.delaunay.update();
        this._init();
        return this;
    }
    _init() {
        const { delaunay: { points, hull, triangles }, vectors } = this;
        let bx, by; // lazily computed barycenter of the hull
        // Compute circumcenters.
        const circumcenters = this.circumcenters = this._circumcenters.subarray(0, triangles.length / 3 * 2);
        for(let i = 0, j = 0, n = triangles.length, x, y; i < n; i += 3, j += 2){
            const t1 = triangles[i] * 2;
            const t2 = triangles[i + 1] * 2;
            const t3 = triangles[i + 2] * 2;
            const x1 = points[t1];
            const y1 = points[t1 + 1];
            const x2 = points[t2];
            const y2 = points[t2 + 1];
            const x3 = points[t3];
            const y3 = points[t3 + 1];
            const dx = x2 - x1;
            const dy = y2 - y1;
            const ex = x3 - x1;
            const ey = y3 - y1;
            const ab = (dx * ey - dy * ex) * 2;
            if (Math.abs(ab) < 1e-9) {
                // For a degenerate triangle, the circumcenter is at the infinity, in a
                // direction orthogonal to the halfedge and away from the “center” of
                // the diagram <bx, by>, defined as the hull’s barycenter.
                if (bx === undefined) {
                    bx = by = 0;
                    for (const i of hull)bx += points[i * 2], by += points[i * 2 + 1];
                    bx /= hull.length, by /= hull.length;
                }
                const a = 1e9 * Math.sign((bx - x1) * ey - (by - y1) * ex);
                x = (x1 + x3) / 2 - a * ey;
                y = (y1 + y3) / 2 + a * ex;
            } else {
                const d = 1 / ab;
                const bl = dx * dx + dy * dy;
                const cl = ex * ex + ey * ey;
                x = x1 + (ey * bl - dy * cl) * d;
                y = y1 + (dx * cl - ex * bl) * d;
            }
            circumcenters[j] = x;
            circumcenters[j + 1] = y;
        }
        // Compute exterior cell rays.
        let h = hull[hull.length - 1];
        let p0, p1 = h * 4;
        let x0, x1 = points[2 * h];
        let y0, y1 = points[2 * h + 1];
        vectors.fill(0);
        for(let i = 0; i < hull.length; ++i){
            h = hull[i];
            p0 = p1, x0 = x1, y0 = y1;
            p1 = h * 4, x1 = points[2 * h], y1 = points[2 * h + 1];
            vectors[p0 + 2] = vectors[p1] = y0 - y1;
            vectors[p0 + 3] = vectors[p1 + 1] = x1 - x0;
        }
    }
    render(context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const { delaunay: { halfedges, inedges, hull }, circumcenters, vectors } = this;
        if (hull.length <= 1) return null;
        for(let i = 0, n = halfedges.length; i < n; ++i){
            const j = halfedges[i];
            if (j < i) continue;
            const ti = Math.floor(i / 3) * 2;
            const tj = Math.floor(j / 3) * 2;
            const xi = circumcenters[ti];
            const yi = circumcenters[ti + 1];
            const xj = circumcenters[tj];
            const yj = circumcenters[tj + 1];
            this._renderSegment(xi, yi, xj, yj, context);
        }
        let h0, h1 = hull[hull.length - 1];
        for(let i = 0; i < hull.length; ++i){
            h0 = h1, h1 = hull[i];
            const t = Math.floor(inedges[h1] / 3) * 2;
            const x = circumcenters[t];
            const y = circumcenters[t + 1];
            const v = h0 * 4;
            const p = this._project(x, y, vectors[v + 2], vectors[v + 3]);
            if (p) this._renderSegment(x, y, p[0], p[1], context);
        }
        return buffer && buffer.value();
    }
    renderBounds(context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        context.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin);
        return buffer && buffer.value();
    }
    renderCell(i, context) {
        const buffer = context == null ? context = new (0, _pathJsDefault.default) : undefined;
        const points = this._clip(i);
        if (points === null || !points.length) return;
        context.moveTo(points[0], points[1]);
        let n = points.length;
        while(points[0] === points[n - 2] && points[1] === points[n - 1] && n > 1)n -= 2;
        for(let i = 2; i < n; i += 2)if (points[i] !== points[i - 2] || points[i + 1] !== points[i - 1]) context.lineTo(points[i], points[i + 1]);
        context.closePath();
        return buffer && buffer.value();
    }
    *cellPolygons() {
        const { delaunay: { points } } = this;
        for(let i = 0, n = points.length / 2; i < n; ++i){
            const cell = this.cellPolygon(i);
            if (cell) cell.index = i, yield cell;
        }
    }
    cellPolygon(i) {
        const polygon = new (0, _polygonJsDefault.default);
        this.renderCell(i, polygon);
        return polygon.value();
    }
    _renderSegment(x0, y0, x1, y1, context) {
        let S;
        const c0 = this._regioncode(x0, y0);
        const c1 = this._regioncode(x1, y1);
        if (c0 === 0 && c1 === 0) {
            context.moveTo(x0, y0);
            context.lineTo(x1, y1);
        } else if (S = this._clipSegment(x0, y0, x1, y1, c0, c1)) {
            context.moveTo(S[0], S[1]);
            context.lineTo(S[2], S[3]);
        }
    }
    contains(i, x, y) {
        if ((x = +x, x !== x) || (y = +y, y !== y)) return false;
        return this.delaunay._step(i, x, y) === i;
    }
    *neighbors(i) {
        const ci = this._clip(i);
        if (ci) for (const j of this.delaunay.neighbors(i)){
            const cj = this._clip(j);
            // find the common edge
            if (cj) loop: for(let ai = 0, li = ci.length; ai < li; ai += 2){
                for(let aj = 0, lj = cj.length; aj < lj; aj += 2)if (ci[ai] === cj[aj] && ci[ai + 1] === cj[aj + 1] && ci[(ai + 2) % li] === cj[(aj + lj - 2) % lj] && ci[(ai + 3) % li] === cj[(aj + lj - 1) % lj]) {
                    yield j;
                    break loop;
                }
            }
        }
    }
    _cell(i) {
        const { circumcenters, delaunay: { inedges, halfedges, triangles } } = this;
        const e0 = inedges[i];
        if (e0 === -1) return null; // coincident point
        const points = [];
        let e = e0;
        do {
            const t = Math.floor(e / 3);
            points.push(circumcenters[t * 2], circumcenters[t * 2 + 1]);
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) break; // bad triangulation
            e = halfedges[e];
        }while (e !== e0 && e !== -1);
        return points;
    }
    _clip(i) {
        // degenerate case (1 valid point: return the box)
        if (i === 0 && this.delaunay.hull.length === 1) return [
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax,
            this.xmin,
            this.ymin
        ];
        const points = this._cell(i);
        if (points === null) return null;
        const { vectors: V } = this;
        const v = i * 4;
        return this._simplify(V[v] || V[v + 1] ? this._clipInfinite(i, points, V[v], V[v + 1], V[v + 2], V[v + 3]) : this._clipFinite(i, points));
    }
    _clipFinite(i, points) {
        const n = points.length;
        let P = null;
        let x0, y0, x1 = points[n - 2], y1 = points[n - 1];
        let c0, c1 = this._regioncode(x1, y1);
        let e0, e1 = 0;
        for(let j = 0; j < n; j += 2){
            x0 = x1, y0 = y1, x1 = points[j], y1 = points[j + 1];
            c0 = c1, c1 = this._regioncode(x1, y1);
            if (c0 === 0 && c1 === 0) {
                e0 = e1, e1 = 0;
                if (P) P.push(x1, y1);
                else P = [
                    x1,
                    y1
                ];
            } else {
                let S, sx0, sy0, sx1, sy1;
                if (c0 === 0) {
                    if ((S = this._clipSegment(x0, y0, x1, y1, c0, c1)) === null) continue;
                    [sx0, sy0, sx1, sy1] = S;
                } else {
                    if ((S = this._clipSegment(x1, y1, x0, y0, c1, c0)) === null) continue;
                    [sx1, sy1, sx0, sy0] = S;
                    e0 = e1, e1 = this._edgecode(sx0, sy0);
                    if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                    if (P) P.push(sx0, sy0);
                    else P = [
                        sx0,
                        sy0
                    ];
                }
                e0 = e1, e1 = this._edgecode(sx1, sy1);
                if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                if (P) P.push(sx1, sy1);
                else P = [
                    sx1,
                    sy1
                ];
            }
        }
        if (P) {
            e0 = e1, e1 = this._edgecode(P[0], P[1]);
            if (e0 && e1) this._edge(i, e0, e1, P, P.length);
        } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) return [
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax,
            this.xmin,
            this.ymin
        ];
        return P;
    }
    _clipSegment(x0, y0, x1, y1, c0, c1) {
        // for more robustness, always consider the segment in the same order
        const flip = c0 < c1;
        if (flip) [x0, y0, x1, y1, c0, c1] = [
            x1,
            y1,
            x0,
            y0,
            c1,
            c0
        ];
        while(true){
            if (c0 === 0 && c1 === 0) return flip ? [
                x1,
                y1,
                x0,
                y0
            ] : [
                x0,
                y0,
                x1,
                y1
            ];
            if (c0 & c1) return null;
            let x, y, c = c0 || c1;
            if (c & 8) x = x0 + (x1 - x0) * (this.ymax - y0) / (y1 - y0), y = this.ymax;
            else if (c & 4) x = x0 + (x1 - x0) * (this.ymin - y0) / (y1 - y0), y = this.ymin;
            else if (c & 2) y = y0 + (y1 - y0) * (this.xmax - x0) / (x1 - x0), x = this.xmax;
            else y = y0 + (y1 - y0) * (this.xmin - x0) / (x1 - x0), x = this.xmin;
            if (c0) x0 = x, y0 = y, c0 = this._regioncode(x0, y0);
            else x1 = x, y1 = y, c1 = this._regioncode(x1, y1);
        }
    }
    _clipInfinite(i, points, vx0, vy0, vxn, vyn) {
        let P = Array.from(points), p;
        if (p = this._project(P[0], P[1], vx0, vy0)) P.unshift(p[0], p[1]);
        if (p = this._project(P[P.length - 2], P[P.length - 1], vxn, vyn)) P.push(p[0], p[1]);
        if (P = this._clipFinite(i, P)) for(let j = 0, n = P.length, c0, c1 = this._edgecode(P[n - 2], P[n - 1]); j < n; j += 2){
            c0 = c1, c1 = this._edgecode(P[j], P[j + 1]);
            if (c0 && c1) j = this._edge(i, c0, c1, P, j), n = P.length;
        }
        else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) P = [
            this.xmin,
            this.ymin,
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax
        ];
        return P;
    }
    _edge(i, e0, e1, P, j) {
        while(e0 !== e1){
            let x, y;
            switch(e0){
                case 5:
                    e0 = 4;
                    continue; // top-left
                case 4:
                    e0 = 6, x = this.xmax, y = this.ymin;
                    break; // top
                case 6:
                    e0 = 2;
                    continue; // top-right
                case 2:
                    e0 = 10, x = this.xmax, y = this.ymax;
                    break; // right
                case 10:
                    e0 = 8;
                    continue; // bottom-right
                case 8:
                    e0 = 9, x = this.xmin, y = this.ymax;
                    break; // bottom
                case 9:
                    e0 = 1;
                    continue; // bottom-left
                case 1:
                    e0 = 5, x = this.xmin, y = this.ymin;
                    break; // left
            }
            // Note: this implicitly checks for out of bounds: if P[j] or P[j+1] are
            // undefined, the conditional statement will be executed.
            if ((P[j] !== x || P[j + 1] !== y) && this.contains(i, x, y)) P.splice(j, 0, x, y), j += 2;
        }
        return j;
    }
    _project(x0, y0, vx, vy) {
        let t = Infinity, c, x, y;
        if (vy < 0) {
            if (y0 <= this.ymin) return null;
            if ((c = (this.ymin - y0) / vy) < t) y = this.ymin, x = x0 + (t = c) * vx;
        } else if (vy > 0) {
            if (y0 >= this.ymax) return null;
            if ((c = (this.ymax - y0) / vy) < t) y = this.ymax, x = x0 + (t = c) * vx;
        }
        if (vx > 0) {
            if (x0 >= this.xmax) return null;
            if ((c = (this.xmax - x0) / vx) < t) x = this.xmax, y = y0 + (t = c) * vy;
        } else if (vx < 0) {
            if (x0 <= this.xmin) return null;
            if ((c = (this.xmin - x0) / vx) < t) x = this.xmin, y = y0 + (t = c) * vy;
        }
        return [
            x,
            y
        ];
    }
    _edgecode(x, y) {
        return (x === this.xmin ? 1 : x === this.xmax ? 2 : 0) | (y === this.ymin ? 4 : y === this.ymax ? 8 : 0);
    }
    _regioncode(x, y) {
        return (x < this.xmin ? 1 : x > this.xmax ? 2 : 0) | (y < this.ymin ? 4 : y > this.ymax ? 8 : 0);
    }
    _simplify(P) {
        if (P && P.length > 4) {
            for(let i = 0; i < P.length; i += 2){
                const j = (i + 2) % P.length, k = (i + 4) % P.length;
                if (P[i] === P[j] && P[j] === P[k] || P[i + 1] === P[j + 1] && P[j + 1] === P[k + 1]) P.splice(j, 2), i -= 2;
            }
            if (!P.length) P = null;
        }
        return P;
    }
}
exports.default = Voronoi;

},{"./path.js":"ebBL9","./polygon.js":"bSOj4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fCaQb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dispatch", ()=>(0, _dispatchJsDefault.default));
var _dispatchJs = require("./dispatch.js");
var _dispatchJsDefault = parcelHelpers.interopDefault(_dispatchJs);

},{"./dispatch.js":"avnlO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hntwN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "drag", ()=>(0, _dragJsDefault.default));
parcelHelpers.export(exports, "dragDisable", ()=>(0, _nodragJsDefault.default));
parcelHelpers.export(exports, "dragEnable", ()=>(0, _nodragJs.yesdrag));
var _dragJs = require("./drag.js");
var _dragJsDefault = parcelHelpers.interopDefault(_dragJs);
var _nodragJs = require("./nodrag.js");
var _nodragJsDefault = parcelHelpers.interopDefault(_nodragJs);

},{"./drag.js":"2iRCi","./nodrag.js":"2o3My","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2iRCi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var filter = defaultFilter, container = defaultContainer, subject = defaultSubject, touchable = defaultTouchable, gestures = {}, listeners = (0, _d3Dispatch.dispatch)("start", "drag", "end"), active = 0, mousedownx, mousedowny, mousemoving, touchending, clickDistance2 = 0;
        function drag(selection) {
            selection.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved, (0, _noeventJs.nonpassive)).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
        }
        function mousedowned(event, d) {
            if (touchending || !filter.call(this, event, d)) return;
            var gesture = beforestart(this, container.call(this, event, d), event, d, "mouse");
            if (!gesture) return;
            (0, _d3Selection.select)(event.view).on("mousemove.drag", mousemoved, (0, _noeventJs.nonpassivecapture)).on("mouseup.drag", mouseupped, (0, _noeventJs.nonpassivecapture));
            (0, _nodragJsDefault.default)(event.view);
            (0, _noeventJs.nopropagation)(event);
            mousemoving = false;
            mousedownx = event.clientX;
            mousedowny = event.clientY;
            gesture("start", event);
        }
        function mousemoved(event) {
            (0, _noeventJsDefault.default)(event);
            if (!mousemoving) {
                var dx = event.clientX - mousedownx, dy = event.clientY - mousedowny;
                mousemoving = dx * dx + dy * dy > clickDistance2;
            }
            gestures.mouse("drag", event);
        }
        function mouseupped(event) {
            (0, _d3Selection.select)(event.view).on("mousemove.drag mouseup.drag", null);
            (0, _nodragJs.yesdrag)(event.view, mousemoving);
            (0, _noeventJsDefault.default)(event);
            gestures.mouse("end", event);
        }
        function touchstarted(event, d) {
            if (!filter.call(this, event, d)) return;
            var touches = event.changedTouches, c = container.call(this, event, d), n = touches.length, i, gesture;
            for(i = 0; i < n; ++i)if (gesture = beforestart(this, c, event, d, touches[i].identifier, touches[i])) {
                (0, _noeventJs.nopropagation)(event);
                gesture("start", event, touches[i]);
            }
        }
        function touchmoved(event) {
            var touches = event.changedTouches, n = touches.length, i, gesture;
            for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
                (0, _noeventJsDefault.default)(event);
                gesture("drag", event, touches[i]);
            }
        }
        function touchended(event) {
            var touches = event.changedTouches, n = touches.length, i, gesture;
            if (touchending) clearTimeout(touchending);
            touchending = setTimeout(function() {
                touchending = null;
            }, 500); // Ghost clicks are delayed!
            for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
                (0, _noeventJs.nopropagation)(event);
                gesture("end", event, touches[i]);
            }
        }
        function beforestart(that, container, event, d, identifier, touch) {
            var dispatch = listeners.copy(), p = (0, _d3Selection.pointer)(touch || event, container), dx, dy, s;
            if ((s = subject.call(that, new (0, _eventJsDefault.default)("beforestart", {
                sourceEvent: event,
                target: drag,
                identifier,
                active,
                x: p[0],
                y: p[1],
                dx: 0,
                dy: 0,
                dispatch
            }), d)) == null) return;
            dx = s.x - p[0] || 0;
            dy = s.y - p[1] || 0;
            return function gesture(type, event, touch) {
                var p0 = p, n;
                switch(type){
                    case "start":
                        gestures[identifier] = gesture, n = active++;
                        break;
                    case "end":
                        delete gestures[identifier], --active; // falls through
                    case "drag":
                        p = (0, _d3Selection.pointer)(touch || event, container), n = active;
                        break;
                }
                dispatch.call(type, that, new (0, _eventJsDefault.default)(type, {
                    sourceEvent: event,
                    subject: s,
                    target: drag,
                    identifier,
                    active: n,
                    x: p[0] + dx,
                    y: p[1] + dy,
                    dx: p[0] - p0[0],
                    dy: p[1] - p0[1],
                    dispatch
                }), d);
            };
        }
        drag.filter = function(_) {
            return arguments.length ? (filter = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), drag) : filter;
        };
        drag.container = function(_) {
            return arguments.length ? (container = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(_), drag) : container;
        };
        drag.subject = function(_) {
            return arguments.length ? (subject = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(_), drag) : subject;
        };
        drag.touchable = function(_) {
            return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), drag) : touchable;
        };
        drag.on = function() {
            var value = listeners.on.apply(listeners, arguments);
            return value === listeners ? drag : value;
        };
        drag.clickDistance = function(_) {
            return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
        };
        return drag;
    });
var _d3Dispatch = require("d3-dispatch");
var _d3Selection = require("d3-selection");
var _nodragJs = require("./nodrag.js");
var _nodragJsDefault = parcelHelpers.interopDefault(_nodragJs);
var _noeventJs = require("./noevent.js");
var _noeventJsDefault = parcelHelpers.interopDefault(_noeventJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _eventJs = require("./event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
// Ignore right-click, since that should open the context menu.
function defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function defaultContainer() {
    return this.parentNode;
}
function defaultSubject(event, d) {
    return d == null ? {
        x: event.x,
        y: event.y
    } : d;
}
function defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}

},{"d3-dispatch":[["dispatch","avnlO","default"]],"d3-selection":[["pointer","04Hca","default"],["select","4CEQV","default"]],"./nodrag.js":"2o3My","./noevent.js":"lC7cP","./constant.js":"dYY1a","./event.js":"5PN43","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dYY1a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>()=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5PN43":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DragEvent);
function DragEvent(type, { sourceEvent, subject, target, identifier, active, x, y, dx, dy, dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        subject: {
            value: subject,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        identifier: {
            value: identifier,
            enumerable: true,
            configurable: true
        },
        active: {
            value: active,
            enumerable: true,
            configurable: true
        },
        x: {
            value: x,
            enumerable: true,
            configurable: true
        },
        y: {
            value: y,
            enumerable: true,
            configurable: true
        },
        dx: {
            value: dx,
            enumerable: true,
            configurable: true
        },
        dy: {
            value: dy,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}
DragEvent.prototype.on = function() {
    var value = this._.on.apply(this._, arguments);
    return value === this._ ? this : value;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3pPXN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dsvFormat", ()=>(0, _dsvJsDefault.default));
parcelHelpers.export(exports, "csvParse", ()=>(0, _csvJs.csvParse));
parcelHelpers.export(exports, "csvParseRows", ()=>(0, _csvJs.csvParseRows));
parcelHelpers.export(exports, "csvFormat", ()=>(0, _csvJs.csvFormat));
parcelHelpers.export(exports, "csvFormatBody", ()=>(0, _csvJs.csvFormatBody));
parcelHelpers.export(exports, "csvFormatRows", ()=>(0, _csvJs.csvFormatRows));
parcelHelpers.export(exports, "csvFormatRow", ()=>(0, _csvJs.csvFormatRow));
parcelHelpers.export(exports, "csvFormatValue", ()=>(0, _csvJs.csvFormatValue));
parcelHelpers.export(exports, "tsvParse", ()=>(0, _tsvJs.tsvParse));
parcelHelpers.export(exports, "tsvParseRows", ()=>(0, _tsvJs.tsvParseRows));
parcelHelpers.export(exports, "tsvFormat", ()=>(0, _tsvJs.tsvFormat));
parcelHelpers.export(exports, "tsvFormatBody", ()=>(0, _tsvJs.tsvFormatBody));
parcelHelpers.export(exports, "tsvFormatRows", ()=>(0, _tsvJs.tsvFormatRows));
parcelHelpers.export(exports, "tsvFormatRow", ()=>(0, _tsvJs.tsvFormatRow));
parcelHelpers.export(exports, "tsvFormatValue", ()=>(0, _tsvJs.tsvFormatValue));
parcelHelpers.export(exports, "autoType", ()=>(0, _autoTypeJsDefault.default));
var _dsvJs = require("./dsv.js");
var _dsvJsDefault = parcelHelpers.interopDefault(_dsvJs);
var _csvJs = require("./csv.js");
var _tsvJs = require("./tsv.js");
var _autoTypeJs = require("./autoType.js");
var _autoTypeJsDefault = parcelHelpers.interopDefault(_autoTypeJs);

},{"./dsv.js":"aCvUx","./csv.js":"2EMYN","./tsv.js":"duO2f","./autoType.js":"58NbF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aCvUx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(delimiter) {
        var reFormat = new RegExp("[\"" + delimiter + "\n\r]"), DELIMITER = delimiter.charCodeAt(0);
        function parse(text, f) {
            var convert, columns, rows = parseRows(text, function(row, i) {
                if (convert) return convert(row, i - 1);
                columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
            });
            rows.columns = columns || [];
            return rows;
        }
        function parseRows(text, f) {
            var rows = [], N = text.length, I = 0, n = 0, t, eof = N <= 0, eol = false; // current token followed by EOL?
            // Strip the trailing newline.
            if (text.charCodeAt(N - 1) === NEWLINE) --N;
            if (text.charCodeAt(N - 1) === RETURN) --N;
            function token() {
                if (eof) return EOF;
                if (eol) return eol = false, EOL;
                // Unescape quotes.
                var i, j = I, c;
                if (text.charCodeAt(j) === QUOTE) {
                    while(I++ < N && text.charCodeAt(I) !== QUOTE || text.charCodeAt(++I) === QUOTE);
                    if ((i = I) >= N) eof = true;
                    else if ((c = text.charCodeAt(I++)) === NEWLINE) eol = true;
                    else if (c === RETURN) {
                        eol = true;
                        if (text.charCodeAt(I) === NEWLINE) ++I;
                    }
                    return text.slice(j + 1, i - 1).replace(/""/g, "\"");
                }
                // Find next delimiter or newline.
                while(I < N){
                    if ((c = text.charCodeAt(i = I++)) === NEWLINE) eol = true;
                    else if (c === RETURN) {
                        eol = true;
                        if (text.charCodeAt(I) === NEWLINE) ++I;
                    } else if (c !== DELIMITER) continue;
                    return text.slice(j, i);
                }
                // Return last token before EOF.
                return eof = true, text.slice(j, N);
            }
            while((t = token()) !== EOF){
                var row = [];
                while(t !== EOL && t !== EOF)row.push(t), t = token();
                if (f && (row = f(row, n++)) == null) continue;
                rows.push(row);
            }
            return rows;
        }
        function preformatBody(rows, columns) {
            return rows.map(function(row) {
                return columns.map(function(column) {
                    return formatValue(row[column]);
                }).join(delimiter);
            });
        }
        function format(rows, columns) {
            if (columns == null) columns = inferColumns(rows);
            return [
                columns.map(formatValue).join(delimiter)
            ].concat(preformatBody(rows, columns)).join("\n");
        }
        function formatBody(rows, columns) {
            if (columns == null) columns = inferColumns(rows);
            return preformatBody(rows, columns).join("\n");
        }
        function formatRows(rows) {
            return rows.map(formatRow).join("\n");
        }
        function formatRow(row) {
            return row.map(formatValue).join(delimiter);
        }
        function formatValue(value) {
            return value == null ? "" : value instanceof Date ? formatDate(value) : reFormat.test(value += "") ? "\"" + value.replace(/"/g, "\"\"") + "\"" : value;
        }
        return {
            parse: parse,
            parseRows: parseRows,
            format: format,
            formatBody: formatBody,
            formatRows: formatRows,
            formatRow: formatRow,
            formatValue: formatValue
        };
    });
var EOL = {}, EOF = {}, QUOTE = 34, NEWLINE = 10, RETURN = 13;
function objectConverter(columns) {
    return new Function("d", "return {" + columns.map(function(name, i) {
        return JSON.stringify(name) + ": d[" + i + "] || \"\"";
    }).join(",") + "}");
}
function customConverter(columns, f) {
    var object = objectConverter(columns);
    return function(row, i) {
        return f(object(row), i, columns);
    };
}
// Compute unique columns in order of discovery.
function inferColumns(rows) {
    var columnSet = Object.create(null), columns = [];
    rows.forEach(function(row) {
        for(var column in row)if (!(column in columnSet)) columns.push(columnSet[column] = column);
    });
    return columns;
}
function pad(value, width) {
    var s = value + "", length = s.length;
    return length < width ? new Array(width - length + 1).join(0) + s : s;
}
function formatYear(year) {
    return year < 0 ? "-" + pad(-year, 6) : year > 9999 ? "+" + pad(year, 6) : pad(year, 4);
}
function formatDate(date) {
    var hours = date.getUTCHours(), minutes = date.getUTCMinutes(), seconds = date.getUTCSeconds(), milliseconds = date.getUTCMilliseconds();
    return isNaN(date) ? "Invalid Date" : formatYear(date.getUTCFullYear(), 4) + "-" + pad(date.getUTCMonth() + 1, 2) + "-" + pad(date.getUTCDate(), 2) + (milliseconds ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2) + "." + pad(milliseconds, 3) + "Z" : seconds ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2) + "Z" : minutes || hours ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + "Z" : "");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2EMYN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "csvParse", ()=>csvParse);
parcelHelpers.export(exports, "csvParseRows", ()=>csvParseRows);
parcelHelpers.export(exports, "csvFormat", ()=>csvFormat);
parcelHelpers.export(exports, "csvFormatBody", ()=>csvFormatBody);
parcelHelpers.export(exports, "csvFormatRows", ()=>csvFormatRows);
parcelHelpers.export(exports, "csvFormatRow", ()=>csvFormatRow);
parcelHelpers.export(exports, "csvFormatValue", ()=>csvFormatValue);
var _dsvJs = require("./dsv.js");
var _dsvJsDefault = parcelHelpers.interopDefault(_dsvJs);
var csv = (0, _dsvJsDefault.default)(",");
var csvParse = csv.parse;
var csvParseRows = csv.parseRows;
var csvFormat = csv.format;
var csvFormatBody = csv.formatBody;
var csvFormatRows = csv.formatRows;
var csvFormatRow = csv.formatRow;
var csvFormatValue = csv.formatValue;

},{"./dsv.js":"aCvUx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"duO2f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tsvParse", ()=>tsvParse);
parcelHelpers.export(exports, "tsvParseRows", ()=>tsvParseRows);
parcelHelpers.export(exports, "tsvFormat", ()=>tsvFormat);
parcelHelpers.export(exports, "tsvFormatBody", ()=>tsvFormatBody);
parcelHelpers.export(exports, "tsvFormatRows", ()=>tsvFormatRows);
parcelHelpers.export(exports, "tsvFormatRow", ()=>tsvFormatRow);
parcelHelpers.export(exports, "tsvFormatValue", ()=>tsvFormatValue);
var _dsvJs = require("./dsv.js");
var _dsvJsDefault = parcelHelpers.interopDefault(_dsvJs);
var tsv = (0, _dsvJsDefault.default)("\t");
var tsvParse = tsv.parse;
var tsvParseRows = tsv.parseRows;
var tsvFormat = tsv.format;
var tsvFormatBody = tsv.formatBody;
var tsvFormatRows = tsv.formatRows;
var tsvFormatRow = tsv.formatRow;
var tsvFormatValue = tsv.formatValue;

},{"./dsv.js":"aCvUx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"58NbF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>autoType);
function autoType(object) {
    for(var key in object){
        var value = object[key].trim(), number, m;
        if (!value) value = null;
        else if (value === "true") value = true;
        else if (value === "false") value = false;
        else if (value === "NaN") value = NaN;
        else if (!isNaN(number = +value)) value = number;
        else if (m = value.match(/^([-+]\d{2})?\d{4}(-\d{2}(-\d{2})?)?(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|[-+]\d{2}:\d{2})?)?$/)) {
            if (fixtz && !!m[4] && !m[7]) value = value.replace(/-/g, "/").replace(/T/, " ");
            value = new Date(value);
        } else continue;
        object[key] = value;
    }
    return object;
}
// https://github.com/d3/d3-dsv/issues/45
const fixtz = new Date("2019-01-01T00:00").getHours() || new Date("2019-07-01T00:00").getHours();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lnriX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "easeLinear", ()=>(0, _linearJs.linear));
parcelHelpers.export(exports, "easeQuad", ()=>(0, _quadJs.quadInOut));
parcelHelpers.export(exports, "easeQuadIn", ()=>(0, _quadJs.quadIn));
parcelHelpers.export(exports, "easeQuadOut", ()=>(0, _quadJs.quadOut));
parcelHelpers.export(exports, "easeQuadInOut", ()=>(0, _quadJs.quadInOut));
parcelHelpers.export(exports, "easeCubic", ()=>(0, _cubicJs.cubicInOut));
parcelHelpers.export(exports, "easeCubicIn", ()=>(0, _cubicJs.cubicIn));
parcelHelpers.export(exports, "easeCubicOut", ()=>(0, _cubicJs.cubicOut));
parcelHelpers.export(exports, "easeCubicInOut", ()=>(0, _cubicJs.cubicInOut));
parcelHelpers.export(exports, "easePoly", ()=>(0, _polyJs.polyInOut));
parcelHelpers.export(exports, "easePolyIn", ()=>(0, _polyJs.polyIn));
parcelHelpers.export(exports, "easePolyOut", ()=>(0, _polyJs.polyOut));
parcelHelpers.export(exports, "easePolyInOut", ()=>(0, _polyJs.polyInOut));
parcelHelpers.export(exports, "easeSin", ()=>(0, _sinJs.sinInOut));
parcelHelpers.export(exports, "easeSinIn", ()=>(0, _sinJs.sinIn));
parcelHelpers.export(exports, "easeSinOut", ()=>(0, _sinJs.sinOut));
parcelHelpers.export(exports, "easeSinInOut", ()=>(0, _sinJs.sinInOut));
parcelHelpers.export(exports, "easeExp", ()=>(0, _expJs.expInOut));
parcelHelpers.export(exports, "easeExpIn", ()=>(0, _expJs.expIn));
parcelHelpers.export(exports, "easeExpOut", ()=>(0, _expJs.expOut));
parcelHelpers.export(exports, "easeExpInOut", ()=>(0, _expJs.expInOut));
parcelHelpers.export(exports, "easeCircle", ()=>(0, _circleJs.circleInOut));
parcelHelpers.export(exports, "easeCircleIn", ()=>(0, _circleJs.circleIn));
parcelHelpers.export(exports, "easeCircleOut", ()=>(0, _circleJs.circleOut));
parcelHelpers.export(exports, "easeCircleInOut", ()=>(0, _circleJs.circleInOut));
parcelHelpers.export(exports, "easeBounce", ()=>(0, _bounceJs.bounceOut));
parcelHelpers.export(exports, "easeBounceIn", ()=>(0, _bounceJs.bounceIn));
parcelHelpers.export(exports, "easeBounceOut", ()=>(0, _bounceJs.bounceOut));
parcelHelpers.export(exports, "easeBounceInOut", ()=>(0, _bounceJs.bounceInOut));
parcelHelpers.export(exports, "easeBack", ()=>(0, _backJs.backInOut));
parcelHelpers.export(exports, "easeBackIn", ()=>(0, _backJs.backIn));
parcelHelpers.export(exports, "easeBackOut", ()=>(0, _backJs.backOut));
parcelHelpers.export(exports, "easeBackInOut", ()=>(0, _backJs.backInOut));
parcelHelpers.export(exports, "easeElastic", ()=>(0, _elasticJs.elasticOut));
parcelHelpers.export(exports, "easeElasticIn", ()=>(0, _elasticJs.elasticIn));
parcelHelpers.export(exports, "easeElasticOut", ()=>(0, _elasticJs.elasticOut));
parcelHelpers.export(exports, "easeElasticInOut", ()=>(0, _elasticJs.elasticInOut));
var _linearJs = require("./linear.js");
var _quadJs = require("./quad.js");
var _cubicJs = require("./cubic.js");
var _polyJs = require("./poly.js");
var _sinJs = require("./sin.js");
var _expJs = require("./exp.js");
var _circleJs = require("./circle.js");
var _bounceJs = require("./bounce.js");
var _backJs = require("./back.js");
var _elasticJs = require("./elastic.js");

},{"./linear.js":"gnhqa","./quad.js":"gDbcJ","./cubic.js":"eWkjr","./poly.js":"lySeM","./sin.js":"ipidq","./exp.js":"j2egS","./circle.js":"joZ19","./bounce.js":"3uH13","./back.js":"5STqh","./elastic.js":"1DiDZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gnhqa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "linear", ()=>linear);
const linear = (t)=>+t;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gDbcJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "quadIn", ()=>quadIn);
parcelHelpers.export(exports, "quadOut", ()=>quadOut);
parcelHelpers.export(exports, "quadInOut", ()=>quadInOut);
function quadIn(t) {
    return t * t;
}
function quadOut(t) {
    return t * (2 - t);
}
function quadInOut(t) {
    return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lySeM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "polyIn", ()=>polyIn);
parcelHelpers.export(exports, "polyOut", ()=>polyOut);
parcelHelpers.export(exports, "polyInOut", ()=>polyInOut);
var exponent = 3;
var polyIn = function custom(e) {
    e = +e;
    function polyIn(t) {
        return Math.pow(t, e);
    }
    polyIn.exponent = custom;
    return polyIn;
}(exponent);
var polyOut = function custom(e) {
    e = +e;
    function polyOut(t) {
        return 1 - Math.pow(1 - t, e);
    }
    polyOut.exponent = custom;
    return polyOut;
}(exponent);
var polyInOut = function custom(e) {
    e = +e;
    function polyInOut(t) {
        return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
    }
    polyInOut.exponent = custom;
    return polyInOut;
}(exponent);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ipidq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sinIn", ()=>sinIn);
parcelHelpers.export(exports, "sinOut", ()=>sinOut);
parcelHelpers.export(exports, "sinInOut", ()=>sinInOut);
var pi = Math.PI, halfPi = pi / 2;
function sinIn(t) {
    return +t === 1 ? 1 : 1 - Math.cos(t * halfPi);
}
function sinOut(t) {
    return Math.sin(t * halfPi);
}
function sinInOut(t) {
    return (1 - Math.cos(pi * t)) / 2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j2egS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "expIn", ()=>expIn);
parcelHelpers.export(exports, "expOut", ()=>expOut);
parcelHelpers.export(exports, "expInOut", ()=>expInOut);
var _mathJs = require("./math.js");
function expIn(t) {
    return (0, _mathJs.tpmt)(1 - +t);
}
function expOut(t) {
    return 1 - (0, _mathJs.tpmt)(t);
}
function expInOut(t) {
    return ((t *= 2) <= 1 ? (0, _mathJs.tpmt)(1 - t) : 2 - (0, _mathJs.tpmt)(t - 1)) / 2;
}

},{"./math.js":"9ZvVy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9ZvVy":[function(require,module,exports,__globalThis) {
// tpmt is two power minus ten times t scaled to [0,1]
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tpmt", ()=>tpmt);
function tpmt(x) {
    return (Math.pow(2, -10 * x) - 0.0009765625) * 1.0009775171065494;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"joZ19":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "circleIn", ()=>circleIn);
parcelHelpers.export(exports, "circleOut", ()=>circleOut);
parcelHelpers.export(exports, "circleInOut", ()=>circleInOut);
function circleIn(t) {
    return 1 - Math.sqrt(1 - t * t);
}
function circleOut(t) {
    return Math.sqrt(1 - --t * t);
}
function circleInOut(t) {
    return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3uH13":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bounceIn", ()=>bounceIn);
parcelHelpers.export(exports, "bounceOut", ()=>bounceOut);
parcelHelpers.export(exports, "bounceInOut", ()=>bounceInOut);
var b1 = 4 / 11, b2 = 6 / 11, b3 = 8 / 11, b4 = 3 / 4, b5 = 9 / 11, b6 = 10 / 11, b7 = 15 / 16, b8 = 21 / 22, b9 = 63 / 64, b0 = 1 / b1 / b1;
function bounceIn(t) {
    return 1 - bounceOut(1 - t);
}
function bounceOut(t) {
    return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
}
function bounceInOut(t) {
    return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5STqh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "backIn", ()=>backIn);
parcelHelpers.export(exports, "backOut", ()=>backOut);
parcelHelpers.export(exports, "backInOut", ()=>backInOut);
var overshoot = 1.70158;
var backIn = function custom(s) {
    s = +s;
    function backIn(t) {
        return (t = +t) * t * (s * (t - 1) + t);
    }
    backIn.overshoot = custom;
    return backIn;
}(overshoot);
var backOut = function custom(s) {
    s = +s;
    function backOut(t) {
        return --t * t * ((t + 1) * s + t) + 1;
    }
    backOut.overshoot = custom;
    return backOut;
}(overshoot);
var backInOut = function custom(s) {
    s = +s;
    function backInOut(t) {
        return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
    }
    backInOut.overshoot = custom;
    return backInOut;
}(overshoot);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1DiDZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "elasticIn", ()=>elasticIn);
parcelHelpers.export(exports, "elasticOut", ()=>elasticOut);
parcelHelpers.export(exports, "elasticInOut", ()=>elasticInOut);
var _mathJs = require("./math.js");
var tau = 2 * Math.PI, amplitude = 1, period = 0.3;
var elasticIn = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
    function elasticIn(t) {
        return a * (0, _mathJs.tpmt)(- --t) * Math.sin((s - t) / p);
    }
    elasticIn.amplitude = function(a) {
        return custom(a, p * tau);
    };
    elasticIn.period = function(p) {
        return custom(a, p);
    };
    return elasticIn;
}(amplitude, period);
var elasticOut = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
    function elasticOut(t) {
        return 1 - a * (0, _mathJs.tpmt)(t = +t) * Math.sin((t + s) / p);
    }
    elasticOut.amplitude = function(a) {
        return custom(a, p * tau);
    };
    elasticOut.period = function(p) {
        return custom(a, p);
    };
    return elasticOut;
}(amplitude, period);
var elasticInOut = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
    function elasticInOut(t) {
        return ((t = t * 2 - 1) < 0 ? a * (0, _mathJs.tpmt)(-t) * Math.sin((s - t) / p) : 2 - a * (0, _mathJs.tpmt)(t) * Math.sin((s + t) / p)) / 2;
    }
    elasticInOut.amplitude = function(a) {
        return custom(a, p * tau);
    };
    elasticInOut.period = function(p) {
        return custom(a, p);
    };
    return elasticInOut;
}(amplitude, period);

},{"./math.js":"9ZvVy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gjgbc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "blob", ()=>(0, _blobJsDefault.default));
parcelHelpers.export(exports, "buffer", ()=>(0, _bufferJsDefault.default));
parcelHelpers.export(exports, "dsv", ()=>(0, _dsvJsDefault.default));
parcelHelpers.export(exports, "csv", ()=>(0, _dsvJs.csv));
parcelHelpers.export(exports, "tsv", ()=>(0, _dsvJs.tsv));
parcelHelpers.export(exports, "image", ()=>(0, _imageJsDefault.default));
parcelHelpers.export(exports, "json", ()=>(0, _jsonJsDefault.default));
parcelHelpers.export(exports, "text", ()=>(0, _textJsDefault.default));
parcelHelpers.export(exports, "xml", ()=>(0, _xmlJsDefault.default));
parcelHelpers.export(exports, "html", ()=>(0, _xmlJs.html));
parcelHelpers.export(exports, "svg", ()=>(0, _xmlJs.svg));
var _blobJs = require("./blob.js");
var _blobJsDefault = parcelHelpers.interopDefault(_blobJs);
var _bufferJs = require("./buffer.js");
var _bufferJsDefault = parcelHelpers.interopDefault(_bufferJs);
var _dsvJs = require("./dsv.js");
var _dsvJsDefault = parcelHelpers.interopDefault(_dsvJs);
var _imageJs = require("./image.js");
var _imageJsDefault = parcelHelpers.interopDefault(_imageJs);
var _jsonJs = require("./json.js");
var _jsonJsDefault = parcelHelpers.interopDefault(_jsonJs);
var _textJs = require("./text.js");
var _textJsDefault = parcelHelpers.interopDefault(_textJs);
var _xmlJs = require("./xml.js");
var _xmlJsDefault = parcelHelpers.interopDefault(_xmlJs);

},{"./blob.js":"2F9E5","./buffer.js":"0ngGS","./dsv.js":"kVJqu","./image.js":"aMGNK","./json.js":"akwP6","./text.js":"eElbP","./xml.js":"aXupz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2F9E5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(input, init) {
        return fetch(input, init).then(responseBlob);
    });
function responseBlob(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.blob();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"0ngGS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(input, init) {
        return fetch(input, init).then(responseArrayBuffer);
    });
function responseArrayBuffer(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.arrayBuffer();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kVJqu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>dsv);
parcelHelpers.export(exports, "csv", ()=>csv);
parcelHelpers.export(exports, "tsv", ()=>tsv);
var _d3Dsv = require("d3-dsv");
var _textJs = require("./text.js");
var _textJsDefault = parcelHelpers.interopDefault(_textJs);
function dsvParse(parse) {
    return function(input, init, row) {
        if (arguments.length === 2 && typeof init === "function") row = init, init = undefined;
        return (0, _textJsDefault.default)(input, init).then(function(response) {
            return parse(response, row);
        });
    };
}
function dsv(delimiter, input, init, row) {
    if (arguments.length === 3 && typeof init === "function") row = init, init = undefined;
    var format = (0, _d3Dsv.dsvFormat)(delimiter);
    return (0, _textJsDefault.default)(input, init).then(function(response) {
        return format.parse(response, row);
    });
}
var csv = dsvParse((0, _d3Dsv.csvParse));
var tsv = dsvParse((0, _d3Dsv.tsvParse));

},{"d3-dsv":[["csvParse","2EMYN"],["dsvFormat","aCvUx","default"],["tsvParse","duO2f"]],"./text.js":"eElbP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eElbP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(input, init) {
        return fetch(input, init).then(responseText);
    });
function responseText(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.text();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aMGNK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(input, init) {
        return new Promise(function(resolve, reject) {
            var image = new Image;
            for(var key in init)image[key] = init[key];
            image.onerror = reject;
            image.onload = function() {
                resolve(image);
            };
            image.src = input;
        });
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"akwP6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(input, init) {
        return fetch(input, init).then(responseJson);
    });
function responseJson(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    if (response.status === 204 || response.status === 205) return;
    return response.json();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aXupz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "html", ()=>html);
parcelHelpers.export(exports, "svg", ()=>svg);
var _textJs = require("./text.js");
var _textJsDefault = parcelHelpers.interopDefault(_textJs);
function parser(type) {
    return (input, init)=>(0, _textJsDefault.default)(input, init).then((text)=>(new DOMParser).parseFromString(text, type));
}
exports.default = parser("application/xml");
var html = parser("text/html");
var svg = parser("image/svg+xml");

},{"./text.js":"eElbP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"39JL7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forceCenter", ()=>(0, _centerJsDefault.default));
parcelHelpers.export(exports, "forceCollide", ()=>(0, _collideJsDefault.default));
parcelHelpers.export(exports, "forceLink", ()=>(0, _linkJsDefault.default));
parcelHelpers.export(exports, "forceManyBody", ()=>(0, _manyBodyJsDefault.default));
parcelHelpers.export(exports, "forceRadial", ()=>(0, _radialJsDefault.default));
parcelHelpers.export(exports, "forceSimulation", ()=>(0, _simulationJsDefault.default));
parcelHelpers.export(exports, "forceX", ()=>(0, _xJsDefault.default));
parcelHelpers.export(exports, "forceY", ()=>(0, _yJsDefault.default));
var _centerJs = require("./center.js");
var _centerJsDefault = parcelHelpers.interopDefault(_centerJs);
var _collideJs = require("./collide.js");
var _collideJsDefault = parcelHelpers.interopDefault(_collideJs);
var _linkJs = require("./link.js");
var _linkJsDefault = parcelHelpers.interopDefault(_linkJs);
var _manyBodyJs = require("./manyBody.js");
var _manyBodyJsDefault = parcelHelpers.interopDefault(_manyBodyJs);
var _radialJs = require("./radial.js");
var _radialJsDefault = parcelHelpers.interopDefault(_radialJs);
var _simulationJs = require("./simulation.js");
var _simulationJsDefault = parcelHelpers.interopDefault(_simulationJs);
var _xJs = require("./x.js");
var _xJsDefault = parcelHelpers.interopDefault(_xJs);
var _yJs = require("./y.js");
var _yJsDefault = parcelHelpers.interopDefault(_yJs);

},{"./center.js":"k3HJq","./collide.js":"cwyEu","./link.js":"gvzg5","./manyBody.js":"WlvbG","./radial.js":"lmKrJ","./simulation.js":"jWL0m","./x.js":"kEXmp","./y.js":"cdBKy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k3HJq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y) {
        var nodes, strength = 1;
        if (x == null) x = 0;
        if (y == null) y = 0;
        function force() {
            var i, n = nodes.length, node, sx = 0, sy = 0;
            for(i = 0; i < n; ++i)node = nodes[i], sx += node.x, sy += node.y;
            for(sx = (sx / n - x) * strength, sy = (sy / n - y) * strength, i = 0; i < n; ++i)node = nodes[i], node.x -= sx, node.y -= sy;
        }
        force.initialize = function(_) {
            nodes = _;
        };
        force.x = function(_) {
            return arguments.length ? (x = +_, force) : x;
        };
        force.y = function(_) {
            return arguments.length ? (y = +_, force) : y;
        };
        force.strength = function(_) {
            return arguments.length ? (strength = +_, force) : strength;
        };
        return force;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cwyEu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(radius) {
        var nodes, radii, random, strength = 1, iterations = 1;
        if (typeof radius !== "function") radius = (0, _constantJsDefault.default)(radius == null ? 1 : +radius);
        function force() {
            var i, n = nodes.length, tree, node, xi, yi, ri, ri2;
            for(var k = 0; k < iterations; ++k){
                tree = (0, _d3Quadtree.quadtree)(nodes, x, y).visitAfter(prepare);
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    ri = radii[node.index], ri2 = ri * ri;
                    xi = node.x + node.vx;
                    yi = node.y + node.vy;
                    tree.visit(apply);
                }
            }
            function apply(quad, x0, y0, x1, y1) {
                var data = quad.data, rj = quad.r, r = ri + rj;
                if (data) {
                    if (data.index > node.index) {
                        var x = xi - data.x - data.vx, y = yi - data.y - data.vy, l = x * x + y * y;
                        if (l < r * r) {
                            if (x === 0) x = (0, _jiggleJsDefault.default)(random), l += x * x;
                            if (y === 0) y = (0, _jiggleJsDefault.default)(random), l += y * y;
                            l = (r - (l = Math.sqrt(l))) / l * strength;
                            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
                            node.vy += (y *= l) * r;
                            data.vx -= x * (r = 1 - r);
                            data.vy -= y * r;
                        }
                    }
                    return;
                }
                return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
            }
        }
        function prepare(quad) {
            if (quad.data) return quad.r = radii[quad.data.index];
            for(var i = quad.r = 0; i < 4; ++i)if (quad[i] && quad[i].r > quad.r) quad.r = quad[i].r;
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length, node;
            radii = new Array(n);
            for(i = 0; i < n; ++i)node = nodes[i], radii[node.index] = +radius(node, i, nodes);
        }
        force.initialize = function(_nodes, _random) {
            nodes = _nodes;
            random = _random;
            initialize();
        };
        force.iterations = function(_) {
            return arguments.length ? (iterations = +_, force) : iterations;
        };
        force.strength = function(_) {
            return arguments.length ? (strength = +_, force) : strength;
        };
        force.radius = function(_) {
            return arguments.length ? (radius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : radius;
        };
        return force;
    });
var _d3Quadtree = require("d3-quadtree");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _jiggleJs = require("./jiggle.js");
var _jiggleJsDefault = parcelHelpers.interopDefault(_jiggleJs);
function x(d) {
    return d.x + d.vx;
}
function y(d) {
    return d.y + d.vy;
}

},{"d3-quadtree":[["quadtree","60xyB","default"]],"./constant.js":"2K30W","./jiggle.js":"9fHEz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"60xyB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quadtree);
var _addJs = require("./add.js");
var _addJsDefault = parcelHelpers.interopDefault(_addJs);
var _coverJs = require("./cover.js");
var _coverJsDefault = parcelHelpers.interopDefault(_coverJs);
var _dataJs = require("./data.js");
var _dataJsDefault = parcelHelpers.interopDefault(_dataJs);
var _extentJs = require("./extent.js");
var _extentJsDefault = parcelHelpers.interopDefault(_extentJs);
var _findJs = require("./find.js");
var _findJsDefault = parcelHelpers.interopDefault(_findJs);
var _removeJs = require("./remove.js");
var _removeJsDefault = parcelHelpers.interopDefault(_removeJs);
var _rootJs = require("./root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
var _sizeJs = require("./size.js");
var _sizeJsDefault = parcelHelpers.interopDefault(_sizeJs);
var _visitJs = require("./visit.js");
var _visitJsDefault = parcelHelpers.interopDefault(_visitJs);
var _visitAfterJs = require("./visitAfter.js");
var _visitAfterJsDefault = parcelHelpers.interopDefault(_visitAfterJs);
var _xJs = require("./x.js");
var _xJsDefault = parcelHelpers.interopDefault(_xJs);
var _yJs = require("./y.js");
var _yJsDefault = parcelHelpers.interopDefault(_yJs);
function quadtree(nodes, x, y) {
    var tree = new Quadtree(x == null ? (0, _xJs.defaultX) : x, y == null ? (0, _yJs.defaultY) : y, NaN, NaN, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
}
function Quadtree(x, y, x0, y0, x1, y1) {
    this._x = x;
    this._y = y;
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    this._root = undefined;
}
function leaf_copy(leaf) {
    var copy = {
        data: leaf.data
    }, next = copy;
    while(leaf = leaf.next)next = next.next = {
        data: leaf.data
    };
    return copy;
}
var treeProto = quadtree.prototype = Quadtree.prototype;
treeProto.copy = function() {
    var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node = this._root, nodes, child;
    if (!node) return copy;
    if (!node.length) return copy._root = leaf_copy(node), copy;
    nodes = [
        {
            source: node,
            target: copy._root = new Array(4)
        }
    ];
    while(node = nodes.pop()){
        for(var i = 0; i < 4; ++i)if (child = node.source[i]) {
            if (child.length) nodes.push({
                source: child,
                target: node.target[i] = new Array(4)
            });
            else node.target[i] = leaf_copy(child);
        }
    }
    return copy;
};
treeProto.add = (0, _addJsDefault.default);
treeProto.addAll = (0, _addJs.addAll);
treeProto.cover = (0, _coverJsDefault.default);
treeProto.data = (0, _dataJsDefault.default);
treeProto.extent = (0, _extentJsDefault.default);
treeProto.find = (0, _findJsDefault.default);
treeProto.remove = (0, _removeJsDefault.default);
treeProto.removeAll = (0, _removeJs.removeAll);
treeProto.root = (0, _rootJsDefault.default);
treeProto.size = (0, _sizeJsDefault.default);
treeProto.visit = (0, _visitJsDefault.default);
treeProto.visitAfter = (0, _visitAfterJsDefault.default);
treeProto.x = (0, _xJsDefault.default);
treeProto.y = (0, _yJsDefault.default);

},{"./add.js":"2TVLM","./cover.js":"iUBZo","./data.js":"bIuX8","./extent.js":"i0Pjn","./find.js":"exOv9","./remove.js":"5vdMH","./root.js":"7bueU","./size.js":"jTW2e","./visit.js":"9NrfC","./visitAfter.js":"i8GPg","./x.js":"8GC2s","./y.js":"eNKHk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2TVLM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(d) {
        const x = +this._x.call(null, d), y = +this._y.call(null, d);
        return add(this.cover(x, y), x, y, d);
    });
parcelHelpers.export(exports, "addAll", ()=>addAll);
function add(tree, x, y, d) {
    if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
    var parent, node = tree._root, leaf = {
        data: d
    }, x0 = tree._x0, y0 = tree._y0, x1 = tree._x1, y1 = tree._y1, xm, ym, xp, yp, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return tree._root = leaf, tree;
    // Find the existing leaf for the new point, or add it.
    while(node.length){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
    }
    // Is the new point is exactly coincident with the existing point?
    xp = +tree._x.call(null, node.data);
    yp = +tree._y.call(null, node.data);
    if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
    // Otherwise, split the leaf node until the old and new point are separated.
    do {
        parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
    }while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
    return parent[j] = node, parent[i] = leaf, tree;
}
function addAll(data) {
    var d, i, n = data.length, x, y, xz = new Array(n), yz = new Array(n), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    // Compute the points and their extent.
    for(i = 0; i < n; ++i){
        if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
        xz[i] = x;
        yz[i] = y;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
    }
    // If there were no (valid) points, abort.
    if (x0 > x1 || y0 > y1) return this;
    // Expand the tree to cover the new points.
    this.cover(x0, y0).cover(x1, y1);
    // Add the new points.
    for(i = 0; i < n; ++i)add(this, xz[i], yz[i], data[i]);
    return this;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iUBZo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y) {
        if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
        var x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1;
        // If the quadtree has no extent, initialize them.
        // Integer extent are necessary so that if we later double the extent,
        // the existing quadrant boundaries don’t change due to floating point error!
        if (isNaN(x0)) {
            x1 = (x0 = Math.floor(x)) + 1;
            y1 = (y0 = Math.floor(y)) + 1;
        } else {
            var z = x1 - x0 || 1, node = this._root, parent, i;
            while(x0 > x || x >= x1 || y0 > y || y >= y1){
                i = (y < y0) << 1 | x < x0;
                parent = new Array(4), parent[i] = node, node = parent, z *= 2;
                switch(i){
                    case 0:
                        x1 = x0 + z, y1 = y0 + z;
                        break;
                    case 1:
                        x0 = x1 - z, y1 = y0 + z;
                        break;
                    case 2:
                        x1 = x0 + z, y0 = y1 - z;
                        break;
                    case 3:
                        x0 = x1 - z, y0 = y1 - z;
                        break;
                }
            }
            if (this._root && this._root.length) this._root = node;
        }
        this._x0 = x0;
        this._y0 = y0;
        this._x1 = x1;
        this._y1 = y1;
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bIuX8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var data = [];
        this.visit(function(node) {
            if (!node.length) do data.push(node.data);
            while (node = node.next);
        });
        return data;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i0Pjn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(_) {
        return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [
            [
                this._x0,
                this._y0
            ],
            [
                this._x1,
                this._y1
            ]
        ];
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"exOv9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y, radius) {
        var data, x0 = this._x0, y0 = this._y0, x1, y1, x2, y2, x3 = this._x1, y3 = this._y1, quads = [], node = this._root, q, i;
        if (node) quads.push(new (0, _quadJsDefault.default)(node, x0, y0, x3, y3));
        if (radius == null) radius = Infinity;
        else {
            x0 = x - radius, y0 = y - radius;
            x3 = x + radius, y3 = y + radius;
            radius *= radius;
        }
        while(q = quads.pop()){
            // Stop searching if this quadrant can’t contain a closer node.
            if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue;
            // Bisect the current quadrant.
            if (node.length) {
                var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2;
                quads.push(new (0, _quadJsDefault.default)(node[3], xm, ym, x2, y2), new (0, _quadJsDefault.default)(node[2], x1, ym, xm, y2), new (0, _quadJsDefault.default)(node[1], xm, y1, x2, ym), new (0, _quadJsDefault.default)(node[0], x1, y1, xm, ym));
                // Visit the closest quadrant first.
                if (i = (y >= ym) << 1 | x >= xm) {
                    q = quads[quads.length - 1];
                    quads[quads.length - 1] = quads[quads.length - 1 - i];
                    quads[quads.length - 1 - i] = q;
                }
            } else {
                var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), d2 = dx * dx + dy * dy;
                if (d2 < radius) {
                    var d = Math.sqrt(radius = d2);
                    x0 = x - d, y0 = y - d;
                    x3 = x + d, y3 = y + d;
                    data = node.data;
                }
            }
        }
        return data;
    });
var _quadJs = require("./quad.js");
var _quadJsDefault = parcelHelpers.interopDefault(_quadJs);

},{"./quad.js":"hhEMd","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hhEMd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node, x0, y0, x1, y1) {
        this.node = node;
        this.x0 = x0;
        this.y0 = y0;
        this.x1 = x1;
        this.y1 = y1;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5vdMH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(d) {
        if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
        var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1, x, y, xm, ym, right, bottom, i, j;
        // If the tree is empty, initialize the root as a leaf.
        if (!node) return this;
        // Find the leaf node for the point.
        // While descending, also retain the deepest parent with a non-removed sibling.
        if (node.length) while(true){
            if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
            else x1 = xm;
            if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
            else y1 = ym;
            if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
            if (!node.length) break;
            if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
        }
        // Find the point to remove.
        while(node.data !== d)if (!(previous = node, node = node.next)) return this;
        if (next = node.next) delete node.next;
        // If there are multiple coincident points, remove just the point.
        if (previous) return next ? previous.next = next : delete previous.next, this;
        // If this is the root point, remove it.
        if (!parent) return this._root = next, this;
        // Remove this leaf.
        next ? parent[i] = next : delete parent[i];
        // If the parent now contains exactly one leaf, collapse superfluous parents.
        if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
            if (retainer) retainer[j] = node;
            else this._root = node;
        }
        return this;
    });
parcelHelpers.export(exports, "removeAll", ()=>removeAll);
function removeAll(data) {
    for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
    return this;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7bueU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this._root;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jTW2e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var size = 0;
        this.visit(function(node) {
            if (!node.length) do ++size;
            while (node = node.next);
        });
        return size;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9NrfC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback) {
        var quads = [], q, node = this._root, child, x0, y0, x1, y1;
        if (node) quads.push(new (0, _quadJsDefault.default)(node, this._x0, this._y0, this._x1, this._y1));
        while(q = quads.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
            var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
            if (child = node[3]) quads.push(new (0, _quadJsDefault.default)(child, xm, ym, x1, y1));
            if (child = node[2]) quads.push(new (0, _quadJsDefault.default)(child, x0, ym, xm, y1));
            if (child = node[1]) quads.push(new (0, _quadJsDefault.default)(child, xm, y0, x1, ym));
            if (child = node[0]) quads.push(new (0, _quadJsDefault.default)(child, x0, y0, xm, ym));
        }
        return this;
    });
var _quadJs = require("./quad.js");
var _quadJsDefault = parcelHelpers.interopDefault(_quadJs);

},{"./quad.js":"hhEMd","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i8GPg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback) {
        var quads = [], next = [], q;
        if (this._root) quads.push(new (0, _quadJsDefault.default)(this._root, this._x0, this._y0, this._x1, this._y1));
        while(q = quads.pop()){
            var node = q.node;
            if (node.length) {
                var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
                if (child = node[0]) quads.push(new (0, _quadJsDefault.default)(child, x0, y0, xm, ym));
                if (child = node[1]) quads.push(new (0, _quadJsDefault.default)(child, xm, y0, x1, ym));
                if (child = node[2]) quads.push(new (0, _quadJsDefault.default)(child, x0, ym, xm, y1));
                if (child = node[3]) quads.push(new (0, _quadJsDefault.default)(child, xm, ym, x1, y1));
            }
            next.push(q);
        }
        while(q = next.pop())callback(q.node, q.x0, q.y0, q.x1, q.y1);
        return this;
    });
var _quadJs = require("./quad.js");
var _quadJsDefault = parcelHelpers.interopDefault(_quadJs);

},{"./quad.js":"hhEMd","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8GC2s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultX", ()=>defaultX);
parcelHelpers.export(exports, "default", ()=>function(_) {
        return arguments.length ? (this._x = _, this) : this._x;
    });
function defaultX(d) {
    return d[0];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eNKHk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultY", ()=>defaultY);
parcelHelpers.export(exports, "default", ()=>function(_) {
        return arguments.length ? (this._y = _, this) : this._y;
    });
function defaultY(d) {
    return d[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2K30W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9fHEz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(random) {
        return (random() - 0.5) * 1e-6;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gvzg5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(links) {
        var id = index, strength = defaultStrength, strengths, distance = (0, _constantJsDefault.default)(30), distances, nodes, count, bias, random, iterations = 1;
        if (links == null) links = [];
        function defaultStrength(link) {
            return 1 / Math.min(count[link.source.index], count[link.target.index]);
        }
        function force(alpha) {
            for(var k = 0, n = links.length; k < iterations; ++k)for(var i = 0, link, source, target, x, y, l, b; i < n; ++i){
                link = links[i], source = link.source, target = link.target;
                x = target.x + target.vx - source.x - source.vx || (0, _jiggleJsDefault.default)(random);
                y = target.y + target.vy - source.y - source.vy || (0, _jiggleJsDefault.default)(random);
                l = Math.sqrt(x * x + y * y);
                l = (l - distances[i]) / l * alpha * strengths[i];
                x *= l, y *= l;
                target.vx -= x * (b = bias[i]);
                target.vy -= y * b;
                source.vx += x * (b = 1 - b);
                source.vy += y * b;
            }
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length, m = links.length, nodeById = new Map(nodes.map((d, i)=>[
                    id(d, i, nodes),
                    d
                ])), link;
            for(i = 0, count = new Array(n); i < m; ++i){
                link = links[i], link.index = i;
                if (typeof link.source !== "object") link.source = find(nodeById, link.source);
                if (typeof link.target !== "object") link.target = find(nodeById, link.target);
                count[link.source.index] = (count[link.source.index] || 0) + 1;
                count[link.target.index] = (count[link.target.index] || 0) + 1;
            }
            for(i = 0, bias = new Array(m); i < m; ++i)link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
            strengths = new Array(m), initializeStrength();
            distances = new Array(m), initializeDistance();
        }
        function initializeStrength() {
            if (!nodes) return;
            for(var i = 0, n = links.length; i < n; ++i)strengths[i] = +strength(links[i], i, links);
        }
        function initializeDistance() {
            if (!nodes) return;
            for(var i = 0, n = links.length; i < n; ++i)distances[i] = +distance(links[i], i, links);
        }
        force.initialize = function(_nodes, _random) {
            nodes = _nodes;
            random = _random;
            initialize();
        };
        force.links = function(_) {
            return arguments.length ? (links = _, initialize(), force) : links;
        };
        force.id = function(_) {
            return arguments.length ? (id = _, force) : id;
        };
        force.iterations = function(_) {
            return arguments.length ? (iterations = +_, force) : iterations;
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initializeStrength(), force) : strength;
        };
        force.distance = function(_) {
            return arguments.length ? (distance = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initializeDistance(), force) : distance;
        };
        return force;
    });
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _jiggleJs = require("./jiggle.js");
var _jiggleJsDefault = parcelHelpers.interopDefault(_jiggleJs);
function index(d) {
    return d.index;
}
function find(nodeById, nodeId) {
    var node = nodeById.get(nodeId);
    if (!node) throw new Error("node not found: " + nodeId);
    return node;
}

},{"./constant.js":"2K30W","./jiggle.js":"9fHEz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"WlvbG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var nodes, node, random, alpha, strength = (0, _constantJsDefault.default)(-30), strengths, distanceMin2 = 1, distanceMax2 = Infinity, theta2 = 0.81;
        function force(_) {
            var i, n = nodes.length, tree = (0, _d3Quadtree.quadtree)(nodes, (0, _simulationJs.x), (0, _simulationJs.y)).visitAfter(accumulate);
            for(alpha = _, i = 0; i < n; ++i)node = nodes[i], tree.visit(apply);
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length, node;
            strengths = new Array(n);
            for(i = 0; i < n; ++i)node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
        }
        function accumulate(quad) {
            var strength = 0, q, c, weight = 0, x, y, i;
            // For internal nodes, accumulate forces from child quadrants.
            if (quad.length) {
                for(x = y = i = 0; i < 4; ++i)if ((q = quad[i]) && (c = Math.abs(q.value))) strength += q.value, weight += c, x += c * q.x, y += c * q.y;
                quad.x = x / weight;
                quad.y = y / weight;
            } else {
                q = quad;
                q.x = q.data.x;
                q.y = q.data.y;
                do strength += strengths[q.data.index];
                while (q = q.next);
            }
            quad.value = strength;
        }
        function apply(quad, x1, _, x2) {
            if (!quad.value) return true;
            var x = quad.x - node.x, y = quad.y - node.y, w = x2 - x1, l = x * x + y * y;
            // Apply the Barnes-Hut approximation if possible.
            // Limit forces for very close nodes; randomize direction if coincident.
            if (w * w / theta2 < l) {
                if (l < distanceMax2) {
                    if (x === 0) x = (0, _jiggleJsDefault.default)(random), l += x * x;
                    if (y === 0) y = (0, _jiggleJsDefault.default)(random), l += y * y;
                    if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
                    node.vx += x * quad.value * alpha / l;
                    node.vy += y * quad.value * alpha / l;
                }
                return true;
            } else if (quad.length || l >= distanceMax2) return;
            // Limit forces for very close nodes; randomize direction if coincident.
            if (quad.data !== node || quad.next) {
                if (x === 0) x = (0, _jiggleJsDefault.default)(random), l += x * x;
                if (y === 0) y = (0, _jiggleJsDefault.default)(random), l += y * y;
                if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
            }
            do if (quad.data !== node) {
                w = strengths[quad.data.index] * alpha / l;
                node.vx += x * w;
                node.vy += y * w;
            }
            while (quad = quad.next);
        }
        force.initialize = function(_nodes, _random) {
            nodes = _nodes;
            random = _random;
            initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : strength;
        };
        force.distanceMin = function(_) {
            return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
        };
        force.distanceMax = function(_) {
            return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
        };
        force.theta = function(_) {
            return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
        };
        return force;
    });
var _d3Quadtree = require("d3-quadtree");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _jiggleJs = require("./jiggle.js");
var _jiggleJsDefault = parcelHelpers.interopDefault(_jiggleJs);
var _simulationJs = require("./simulation.js");

},{"d3-quadtree":[["quadtree","60xyB","default"]],"./constant.js":"2K30W","./jiggle.js":"9fHEz","./simulation.js":"jWL0m","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jWL0m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "x", ()=>x);
parcelHelpers.export(exports, "y", ()=>y);
parcelHelpers.export(exports, "default", ()=>function(nodes) {
        var simulation, alpha = 1, alphaMin = 0.001, alphaDecay = 1 - Math.pow(alphaMin, 1 / 300), alphaTarget = 0, velocityDecay = 0.6, forces = new Map(), stepper = (0, _d3Timer.timer)(step), event = (0, _d3Dispatch.dispatch)("tick", "end"), random = (0, _lcgJsDefault.default)();
        if (nodes == null) nodes = [];
        function step() {
            tick();
            event.call("tick", simulation);
            if (alpha < alphaMin) {
                stepper.stop();
                event.call("end", simulation);
            }
        }
        function tick(iterations) {
            var i, n = nodes.length, node;
            if (iterations === undefined) iterations = 1;
            for(var k = 0; k < iterations; ++k){
                alpha += (alphaTarget - alpha) * alphaDecay;
                forces.forEach(function(force) {
                    force(alpha);
                });
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    if (node.fx == null) node.x += node.vx *= velocityDecay;
                    else node.x = node.fx, node.vx = 0;
                    if (node.fy == null) node.y += node.vy *= velocityDecay;
                    else node.y = node.fy, node.vy = 0;
                }
            }
            return simulation;
        }
        function initializeNodes() {
            for(var i = 0, n = nodes.length, node; i < n; ++i){
                node = nodes[i], node.index = i;
                if (node.fx != null) node.x = node.fx;
                if (node.fy != null) node.y = node.fy;
                if (isNaN(node.x) || isNaN(node.y)) {
                    var radius = initialRadius * Math.sqrt(0.5 + i), angle = i * initialAngle;
                    node.x = radius * Math.cos(angle);
                    node.y = radius * Math.sin(angle);
                }
                if (isNaN(node.vx) || isNaN(node.vy)) node.vx = node.vy = 0;
            }
        }
        function initializeForce(force) {
            if (force.initialize) force.initialize(nodes, random);
            return force;
        }
        initializeNodes();
        return simulation = {
            tick: tick,
            restart: function() {
                return stepper.restart(step), simulation;
            },
            stop: function() {
                return stepper.stop(), simulation;
            },
            nodes: function(_) {
                return arguments.length ? (nodes = _, initializeNodes(), forces.forEach(initializeForce), simulation) : nodes;
            },
            alpha: function(_) {
                return arguments.length ? (alpha = +_, simulation) : alpha;
            },
            alphaMin: function(_) {
                return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
            },
            alphaDecay: function(_) {
                return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
            },
            alphaTarget: function(_) {
                return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
            },
            velocityDecay: function(_) {
                return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
            },
            randomSource: function(_) {
                return arguments.length ? (random = _, forces.forEach(initializeForce), simulation) : random;
            },
            force: function(name, _) {
                return arguments.length > 1 ? (_ == null ? forces.delete(name) : forces.set(name, initializeForce(_)), simulation) : forces.get(name);
            },
            find: function(x, y, radius) {
                var i = 0, n = nodes.length, dx, dy, d2, node, closest;
                if (radius == null) radius = Infinity;
                else radius *= radius;
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    dx = x - node.x;
                    dy = y - node.y;
                    d2 = dx * dx + dy * dy;
                    if (d2 < radius) closest = node, radius = d2;
                }
                return closest;
            },
            on: function(name, _) {
                return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
            }
        };
    });
var _d3Dispatch = require("d3-dispatch");
var _d3Timer = require("d3-timer");
var _lcgJs = require("./lcg.js");
var _lcgJsDefault = parcelHelpers.interopDefault(_lcgJs);
function x(d) {
    return d.x;
}
function y(d) {
    return d.y;
}
var initialRadius = 10, initialAngle = Math.PI * (3 - Math.sqrt(5));

},{"d3-dispatch":[["dispatch","avnlO","default"]],"d3-timer":"bgtMb","./lcg.js":"cLvrs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cLvrs":[function(require,module,exports,__globalThis) {
// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        let s = 1;
        return ()=>(s = (a * s + c) % m) / m;
    });
const a = 1664525;
const c = 1013904223;
const m = 4294967296; // 2^32

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lmKrJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(radius, x, y) {
        var nodes, strength = (0, _constantJsDefault.default)(0.1), strengths, radiuses;
        if (typeof radius !== "function") radius = (0, _constantJsDefault.default)(+radius);
        if (x == null) x = 0;
        if (y == null) y = 0;
        function force(alpha) {
            for(var i = 0, n = nodes.length; i < n; ++i){
                var node = nodes[i], dx = node.x - x || 1e-6, dy = node.y - y || 1e-6, r = Math.sqrt(dx * dx + dy * dy), k = (radiuses[i] - r) * strengths[i] * alpha / r;
                node.vx += dx * k;
                node.vy += dy * k;
            }
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length;
            strengths = new Array(n);
            radiuses = new Array(n);
            for(i = 0; i < n; ++i){
                radiuses[i] = +radius(nodes[i], i, nodes);
                strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
            }
        }
        force.initialize = function(_) {
            nodes = _, initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : strength;
        };
        force.radius = function(_) {
            return arguments.length ? (radius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : radius;
        };
        force.x = function(_) {
            return arguments.length ? (x = +_, force) : x;
        };
        force.y = function(_) {
            return arguments.length ? (y = +_, force) : y;
        };
        return force;
    });
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);

},{"./constant.js":"2K30W","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kEXmp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        var strength = (0, _constantJsDefault.default)(0.1), nodes, strengths, xz;
        if (typeof x !== "function") x = (0, _constantJsDefault.default)(x == null ? 0 : +x);
        function force(alpha) {
            for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length;
            strengths = new Array(n);
            xz = new Array(n);
            for(i = 0; i < n; ++i)strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
        }
        force.initialize = function(_) {
            nodes = _;
            initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : strength;
        };
        force.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : x;
        };
        return force;
    });
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);

},{"./constant.js":"2K30W","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cdBKy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(y) {
        var strength = (0, _constantJsDefault.default)(0.1), nodes, strengths, yz;
        if (typeof y !== "function") y = (0, _constantJsDefault.default)(y == null ? 0 : +y);
        function force(alpha) {
            for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length;
            strengths = new Array(n);
            yz = new Array(n);
            for(i = 0; i < n; ++i)strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
        }
        force.initialize = function(_) {
            nodes = _;
            initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : strength;
        };
        force.y = function(_) {
            return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), initialize(), force) : y;
        };
        return force;
    });
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);

},{"./constant.js":"2K30W","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9IytR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatDefaultLocale", ()=>(0, _defaultLocaleJsDefault.default));
parcelHelpers.export(exports, "format", ()=>(0, _defaultLocaleJs.format));
parcelHelpers.export(exports, "formatPrefix", ()=>(0, _defaultLocaleJs.formatPrefix));
parcelHelpers.export(exports, "formatLocale", ()=>(0, _localeJsDefault.default));
parcelHelpers.export(exports, "formatSpecifier", ()=>(0, _formatSpecifierJsDefault.default));
parcelHelpers.export(exports, "FormatSpecifier", ()=>(0, _formatSpecifierJs.FormatSpecifier));
parcelHelpers.export(exports, "precisionFixed", ()=>(0, _precisionFixedJsDefault.default));
parcelHelpers.export(exports, "precisionPrefix", ()=>(0, _precisionPrefixJsDefault.default));
parcelHelpers.export(exports, "precisionRound", ()=>(0, _precisionRoundJsDefault.default));
var _defaultLocaleJs = require("./defaultLocale.js");
var _defaultLocaleJsDefault = parcelHelpers.interopDefault(_defaultLocaleJs);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var _formatSpecifierJs = require("./formatSpecifier.js");
var _formatSpecifierJsDefault = parcelHelpers.interopDefault(_formatSpecifierJs);
var _precisionFixedJs = require("./precisionFixed.js");
var _precisionFixedJsDefault = parcelHelpers.interopDefault(_precisionFixedJs);
var _precisionPrefixJs = require("./precisionPrefix.js");
var _precisionPrefixJsDefault = parcelHelpers.interopDefault(_precisionPrefixJs);
var _precisionRoundJs = require("./precisionRound.js");
var _precisionRoundJsDefault = parcelHelpers.interopDefault(_precisionRoundJs);

},{"./defaultLocale.js":"fNAkW","./locale.js":"5rSKU","./formatSpecifier.js":"4Dwks","./precisionFixed.js":"amWFt","./precisionPrefix.js":"3cedQ","./precisionRound.js":"ay474","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hvz1M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "geoArea", ()=>(0, _areaJsDefault.default));
parcelHelpers.export(exports, "geoBounds", ()=>(0, _boundsJsDefault.default));
parcelHelpers.export(exports, "geoCentroid", ()=>(0, _centroidJsDefault.default));
parcelHelpers.export(exports, "geoCircle", ()=>(0, _circleJsDefault.default));
parcelHelpers.export(exports, "geoClipAntimeridian", ()=>(0, _antimeridianJsDefault.default));
parcelHelpers.export(exports, "geoClipCircle", ()=>(0, _circleJsDefault1.default));
parcelHelpers.export(exports, "geoClipExtent", ()=>(0, _extentJsDefault.default)) // DEPRECATED! Use d3.geoIdentity().clipExtent(…).
;
parcelHelpers.export(exports, "geoClipRectangle", ()=>(0, _rectangleJsDefault.default));
parcelHelpers.export(exports, "geoContains", ()=>(0, _containsJsDefault.default));
parcelHelpers.export(exports, "geoDistance", ()=>(0, _distanceJsDefault.default));
parcelHelpers.export(exports, "geoGraticule", ()=>(0, _graticuleJsDefault.default));
parcelHelpers.export(exports, "geoGraticule10", ()=>(0, _graticuleJs.graticule10));
parcelHelpers.export(exports, "geoInterpolate", ()=>(0, _interpolateJsDefault.default));
parcelHelpers.export(exports, "geoLength", ()=>(0, _lengthJsDefault.default));
parcelHelpers.export(exports, "geoPath", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "geoAlbers", ()=>(0, _albersJsDefault.default));
parcelHelpers.export(exports, "geoAlbersUsa", ()=>(0, _albersUsaJsDefault.default));
parcelHelpers.export(exports, "geoAzimuthalEqualArea", ()=>(0, _azimuthalEqualAreaJsDefault.default));
parcelHelpers.export(exports, "geoAzimuthalEqualAreaRaw", ()=>(0, _azimuthalEqualAreaJs.azimuthalEqualAreaRaw));
parcelHelpers.export(exports, "geoAzimuthalEquidistant", ()=>(0, _azimuthalEquidistantJsDefault.default));
parcelHelpers.export(exports, "geoAzimuthalEquidistantRaw", ()=>(0, _azimuthalEquidistantJs.azimuthalEquidistantRaw));
parcelHelpers.export(exports, "geoConicConformal", ()=>(0, _conicConformalJsDefault.default));
parcelHelpers.export(exports, "geoConicConformalRaw", ()=>(0, _conicConformalJs.conicConformalRaw));
parcelHelpers.export(exports, "geoConicEqualArea", ()=>(0, _conicEqualAreaJsDefault.default));
parcelHelpers.export(exports, "geoConicEqualAreaRaw", ()=>(0, _conicEqualAreaJs.conicEqualAreaRaw));
parcelHelpers.export(exports, "geoConicEquidistant", ()=>(0, _conicEquidistantJsDefault.default));
parcelHelpers.export(exports, "geoConicEquidistantRaw", ()=>(0, _conicEquidistantJs.conicEquidistantRaw));
parcelHelpers.export(exports, "geoEqualEarth", ()=>(0, _equalEarthJsDefault.default));
parcelHelpers.export(exports, "geoEqualEarthRaw", ()=>(0, _equalEarthJs.equalEarthRaw));
parcelHelpers.export(exports, "geoEquirectangular", ()=>(0, _equirectangularJsDefault.default));
parcelHelpers.export(exports, "geoEquirectangularRaw", ()=>(0, _equirectangularJs.equirectangularRaw));
parcelHelpers.export(exports, "geoGnomonic", ()=>(0, _gnomonicJsDefault.default));
parcelHelpers.export(exports, "geoGnomonicRaw", ()=>(0, _gnomonicJs.gnomonicRaw));
parcelHelpers.export(exports, "geoIdentity", ()=>(0, _identityJsDefault.default));
parcelHelpers.export(exports, "geoProjection", ()=>(0, _indexJsDefault1.default));
parcelHelpers.export(exports, "geoProjectionMutator", ()=>(0, _indexJs1.projectionMutator));
parcelHelpers.export(exports, "geoMercator", ()=>(0, _mercatorJsDefault.default));
parcelHelpers.export(exports, "geoMercatorRaw", ()=>(0, _mercatorJs.mercatorRaw));
parcelHelpers.export(exports, "geoNaturalEarth1", ()=>(0, _naturalEarth1JsDefault.default));
parcelHelpers.export(exports, "geoNaturalEarth1Raw", ()=>(0, _naturalEarth1Js.naturalEarth1Raw));
parcelHelpers.export(exports, "geoOrthographic", ()=>(0, _orthographicJsDefault.default));
parcelHelpers.export(exports, "geoOrthographicRaw", ()=>(0, _orthographicJs.orthographicRaw));
parcelHelpers.export(exports, "geoStereographic", ()=>(0, _stereographicJsDefault.default));
parcelHelpers.export(exports, "geoStereographicRaw", ()=>(0, _stereographicJs.stereographicRaw));
parcelHelpers.export(exports, "geoTransverseMercator", ()=>(0, _transverseMercatorJsDefault.default));
parcelHelpers.export(exports, "geoTransverseMercatorRaw", ()=>(0, _transverseMercatorJs.transverseMercatorRaw));
parcelHelpers.export(exports, "geoRotation", ()=>(0, _rotationJsDefault.default));
parcelHelpers.export(exports, "geoStream", ()=>(0, _streamJsDefault.default));
parcelHelpers.export(exports, "geoTransform", ()=>(0, _transformJsDefault.default));
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _boundsJs = require("./bounds.js");
var _boundsJsDefault = parcelHelpers.interopDefault(_boundsJs);
var _centroidJs = require("./centroid.js");
var _centroidJsDefault = parcelHelpers.interopDefault(_centroidJs);
var _circleJs = require("./circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _antimeridianJs = require("./clip/antimeridian.js");
var _antimeridianJsDefault = parcelHelpers.interopDefault(_antimeridianJs);
var _circleJs1 = require("./clip/circle.js");
var _circleJsDefault1 = parcelHelpers.interopDefault(_circleJs1);
var _extentJs = require("./clip/extent.js");
var _extentJsDefault = parcelHelpers.interopDefault(_extentJs);
var _rectangleJs = require("./clip/rectangle.js");
var _rectangleJsDefault = parcelHelpers.interopDefault(_rectangleJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _distanceJs = require("./distance.js");
var _distanceJsDefault = parcelHelpers.interopDefault(_distanceJs);
var _graticuleJs = require("./graticule.js");
var _graticuleJsDefault = parcelHelpers.interopDefault(_graticuleJs);
var _interpolateJs = require("./interpolate.js");
var _interpolateJsDefault = parcelHelpers.interopDefault(_interpolateJs);
var _lengthJs = require("./length.js");
var _lengthJsDefault = parcelHelpers.interopDefault(_lengthJs);
var _indexJs = require("./path/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _albersJs = require("./projection/albers.js");
var _albersJsDefault = parcelHelpers.interopDefault(_albersJs);
var _albersUsaJs = require("./projection/albersUsa.js");
var _albersUsaJsDefault = parcelHelpers.interopDefault(_albersUsaJs);
var _azimuthalEqualAreaJs = require("./projection/azimuthalEqualArea.js");
var _azimuthalEqualAreaJsDefault = parcelHelpers.interopDefault(_azimuthalEqualAreaJs);
var _azimuthalEquidistantJs = require("./projection/azimuthalEquidistant.js");
var _azimuthalEquidistantJsDefault = parcelHelpers.interopDefault(_azimuthalEquidistantJs);
var _conicConformalJs = require("./projection/conicConformal.js");
var _conicConformalJsDefault = parcelHelpers.interopDefault(_conicConformalJs);
var _conicEqualAreaJs = require("./projection/conicEqualArea.js");
var _conicEqualAreaJsDefault = parcelHelpers.interopDefault(_conicEqualAreaJs);
var _conicEquidistantJs = require("./projection/conicEquidistant.js");
var _conicEquidistantJsDefault = parcelHelpers.interopDefault(_conicEquidistantJs);
var _equalEarthJs = require("./projection/equalEarth.js");
var _equalEarthJsDefault = parcelHelpers.interopDefault(_equalEarthJs);
var _equirectangularJs = require("./projection/equirectangular.js");
var _equirectangularJsDefault = parcelHelpers.interopDefault(_equirectangularJs);
var _gnomonicJs = require("./projection/gnomonic.js");
var _gnomonicJsDefault = parcelHelpers.interopDefault(_gnomonicJs);
var _identityJs = require("./projection/identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _indexJs1 = require("./projection/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _mercatorJs = require("./projection/mercator.js");
var _mercatorJsDefault = parcelHelpers.interopDefault(_mercatorJs);
var _naturalEarth1Js = require("./projection/naturalEarth1.js");
var _naturalEarth1JsDefault = parcelHelpers.interopDefault(_naturalEarth1Js);
var _orthographicJs = require("./projection/orthographic.js");
var _orthographicJsDefault = parcelHelpers.interopDefault(_orthographicJs);
var _stereographicJs = require("./projection/stereographic.js");
var _stereographicJsDefault = parcelHelpers.interopDefault(_stereographicJs);
var _transverseMercatorJs = require("./projection/transverseMercator.js");
var _transverseMercatorJsDefault = parcelHelpers.interopDefault(_transverseMercatorJs);
var _rotationJs = require("./rotation.js");
var _rotationJsDefault = parcelHelpers.interopDefault(_rotationJs);
var _streamJs = require("./stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var _transformJs = require("./transform.js");
var _transformJsDefault = parcelHelpers.interopDefault(_transformJs);

},{"./area.js":"fU0uC","./bounds.js":"90PvZ","./centroid.js":"fSoBX","./circle.js":"2UTty","./clip/antimeridian.js":"bpOyZ","./clip/circle.js":"8GPcP","./clip/extent.js":"eSopJ","./clip/rectangle.js":"hgkNK","./contains.js":"bcHJ0","./distance.js":"bqozI","./graticule.js":"bJKKE","./interpolate.js":"a1PWF","./length.js":"f4PvO","./path/index.js":"funLc","./projection/albers.js":"gVkNI","./projection/albersUsa.js":"kKmvt","./projection/azimuthalEqualArea.js":"agpPS","./projection/azimuthalEquidistant.js":"1EsCY","./projection/conicConformal.js":"d2zyE","./projection/conicEqualArea.js":"84dLC","./projection/conicEquidistant.js":"4pwTI","./projection/equalEarth.js":"3QHBT","./projection/equirectangular.js":"ivpfD","./projection/gnomonic.js":"8g2g8","./projection/identity.js":"3FhuX","./projection/index.js":"jabgC","./projection/mercator.js":"awlzv","./projection/naturalEarth1.js":"invjX","./projection/orthographic.js":"awIEX","./projection/stereographic.js":"fBs4c","./projection/transverseMercator.js":"i3KJ4","./rotation.js":"ka8Fr","./stream.js":"hAqHD","./transform.js":"2cPnh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fU0uC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "areaRingSum", ()=>areaRingSum);
parcelHelpers.export(exports, "areaStream", ()=>areaStream);
parcelHelpers.export(exports, "default", ()=>function(object) {
        areaSum = new (0, _d3Array.Adder)();
        (0, _streamJsDefault.default)(object, areaStream);
        return areaSum * 2;
    });
var _d3Array = require("d3-array");
var _mathJs = require("./math.js");
var _noopJs = require("./noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _streamJs = require("./stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var areaRingSum = new (0, _d3Array.Adder)();
// hello?
var areaSum = new (0, _d3Array.Adder)(), lambda00, phi00, lambda0, cosPhi0, sinPhi0;
var areaStream = {
    point: (0, _noopJsDefault.default),
    lineStart: (0, _noopJsDefault.default),
    lineEnd: (0, _noopJsDefault.default),
    polygonStart: function() {
        areaRingSum = new (0, _d3Array.Adder)();
        areaStream.lineStart = areaRingStart;
        areaStream.lineEnd = areaRingEnd;
    },
    polygonEnd: function() {
        var areaRing = +areaRingSum;
        areaSum.add(areaRing < 0 ? (0, _mathJs.tau) + areaRing : areaRing);
        this.lineStart = this.lineEnd = this.point = (0, _noopJsDefault.default);
    },
    sphere: function() {
        areaSum.add((0, _mathJs.tau));
    }
};
function areaRingStart() {
    areaStream.point = areaPointFirst;
}
function areaRingEnd() {
    areaPoint(lambda00, phi00);
}
function areaPointFirst(lambda, phi) {
    areaStream.point = areaPoint;
    lambda00 = lambda, phi00 = phi;
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    lambda0 = lambda, cosPhi0 = (0, _mathJs.cos)(phi = phi / 2 + (0, _mathJs.quarterPi)), sinPhi0 = (0, _mathJs.sin)(phi);
}
function areaPoint(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    phi = phi / 2 + (0, _mathJs.quarterPi); // half the angular distance from south pole
    // Spherical excess E for a spherical triangle with vertices: south pole,
    // previous point, current point.  Uses a formula derived from Cagnoli’s
    // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
    var dLambda = lambda - lambda0, sdLambda = dLambda >= 0 ? 1 : -1, adLambda = sdLambda * dLambda, cosPhi = (0, _mathJs.cos)(phi), sinPhi = (0, _mathJs.sin)(phi), k = sinPhi0 * sinPhi, u = cosPhi0 * cosPhi + k * (0, _mathJs.cos)(adLambda), v = k * sdLambda * (0, _mathJs.sin)(adLambda);
    areaRingSum.add((0, _mathJs.atan2)(v, u));
    // Advance the previous points.
    lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
}

},{"d3-array":"2G8br","./math.js":"hswBu","./noop.js":"bwHmr","./stream.js":"hAqHD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hswBu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "epsilon", ()=>epsilon);
parcelHelpers.export(exports, "epsilon2", ()=>epsilon2);
parcelHelpers.export(exports, "pi", ()=>pi);
parcelHelpers.export(exports, "halfPi", ()=>halfPi);
parcelHelpers.export(exports, "quarterPi", ()=>quarterPi);
parcelHelpers.export(exports, "tau", ()=>tau);
parcelHelpers.export(exports, "degrees", ()=>degrees);
parcelHelpers.export(exports, "radians", ()=>radians);
parcelHelpers.export(exports, "abs", ()=>abs);
parcelHelpers.export(exports, "atan", ()=>atan);
parcelHelpers.export(exports, "atan2", ()=>atan2);
parcelHelpers.export(exports, "cos", ()=>cos);
parcelHelpers.export(exports, "ceil", ()=>ceil);
parcelHelpers.export(exports, "exp", ()=>exp);
parcelHelpers.export(exports, "floor", ()=>floor);
parcelHelpers.export(exports, "hypot", ()=>hypot);
parcelHelpers.export(exports, "log", ()=>log);
parcelHelpers.export(exports, "pow", ()=>pow);
parcelHelpers.export(exports, "sin", ()=>sin);
parcelHelpers.export(exports, "sign", ()=>sign);
parcelHelpers.export(exports, "sqrt", ()=>sqrt);
parcelHelpers.export(exports, "tan", ()=>tan);
parcelHelpers.export(exports, "acos", ()=>acos);
parcelHelpers.export(exports, "asin", ()=>asin);
parcelHelpers.export(exports, "haversin", ()=>haversin);
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var quarterPi = pi / 4;
var tau = pi * 2;
var degrees = 180 / pi;
var radians = pi / 180;
var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var cos = Math.cos;
var ceil = Math.ceil;
var exp = Math.exp;
var floor = Math.floor;
var hypot = Math.hypot;
var log = Math.log;
var pow = Math.pow;
var sin = Math.sin;
var sign = Math.sign || function(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var sqrt = Math.sqrt;
var tan = Math.tan;
function acos(x) {
    return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}
function asin(x) {
    return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
}
function haversin(x) {
    return (x = sin(x / 2)) * x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bwHmr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>noop);
function noop() {}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hAqHD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(object, stream) {
        if (object && streamObjectType.hasOwnProperty(object.type)) streamObjectType[object.type](object, stream);
        else streamGeometry(object, stream);
    });
function streamGeometry(geometry, stream) {
    if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) streamGeometryType[geometry.type](geometry, stream);
}
var streamObjectType = {
    Feature: function(object, stream) {
        streamGeometry(object.geometry, stream);
    },
    FeatureCollection: function(object, stream) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)streamGeometry(features[i].geometry, stream);
    }
};
var streamGeometryType = {
    Sphere: function(object, stream) {
        stream.sphere();
    },
    Point: function(object, stream) {
        object = object.coordinates;
        stream.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)object = coordinates[i], stream.point(object[0], object[1], object[2]);
    },
    LineString: function(object, stream) {
        streamLine(object.coordinates, stream, 0);
    },
    MultiLineString: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)streamLine(coordinates[i], stream, 0);
    },
    Polygon: function(object, stream) {
        streamPolygon(object.coordinates, stream);
    },
    MultiPolygon: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)streamPolygon(coordinates[i], stream);
    },
    GeometryCollection: function(object, stream) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)streamGeometry(geometries[i], stream);
    }
};
function streamLine(coordinates, stream, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    stream.lineStart();
    while(++i < n)coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
    stream.lineEnd();
}
function streamPolygon(coordinates, stream) {
    var i = -1, n = coordinates.length;
    stream.polygonStart();
    while(++i < n)streamLine(coordinates[i], stream, 1);
    stream.polygonEnd();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"90PvZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(feature) {
        var i, n, a, b, merged, deltaMax, delta;
        phi1 = lambda1 = -(lambda0 = phi0 = Infinity);
        ranges = [];
        (0, _streamJsDefault.default)(feature, boundsStream);
        // First, sort ranges by their minimum longitudes.
        if (n = ranges.length) {
            ranges.sort(rangeCompare);
            // Then, merge any ranges that overlap.
            for(i = 1, a = ranges[0], merged = [
                a
            ]; i < n; ++i){
                b = ranges[i];
                if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
                    if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
                    if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
                } else merged.push(a = b);
            }
            // Finally, find the largest gap between the merged ranges.
            // The final bounding box will be the inverse of this gap.
            for(deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i){
                b = merged[i];
                if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0 = b[0], lambda1 = a[1];
            }
        }
        ranges = range = null;
        return lambda0 === Infinity || phi0 === Infinity ? [
            [
                NaN,
                NaN
            ],
            [
                NaN,
                NaN
            ]
        ] : [
            [
                lambda0,
                phi0
            ],
            [
                lambda1,
                phi1
            ]
        ];
    });
var _d3Array = require("d3-array");
var _areaJs = require("./area.js");
var _cartesianJs = require("./cartesian.js");
var _mathJs = require("./math.js");
var _streamJs = require("./stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var lambda0, phi0, lambda1, phi1, lambda2, lambda00, phi00, p0, deltaSum, ranges, range;
var boundsStream = {
    point: boundsPoint,
    lineStart: boundsLineStart,
    lineEnd: boundsLineEnd,
    polygonStart: function() {
        boundsStream.point = boundsRingPoint;
        boundsStream.lineStart = boundsRingStart;
        boundsStream.lineEnd = boundsRingEnd;
        deltaSum = new (0, _d3Array.Adder)();
        (0, _areaJs.areaStream).polygonStart();
    },
    polygonEnd: function() {
        (0, _areaJs.areaStream).polygonEnd();
        boundsStream.point = boundsPoint;
        boundsStream.lineStart = boundsLineStart;
        boundsStream.lineEnd = boundsLineEnd;
        if ((0, _areaJs.areaRingSum) < 0) lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
        else if (deltaSum > (0, _mathJs.epsilon)) phi1 = 90;
        else if (deltaSum < -(0, _mathJs.epsilon)) phi0 = -90;
        range[0] = lambda0, range[1] = lambda1;
    },
    sphere: function() {
        lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
    }
};
function boundsPoint(lambda, phi) {
    ranges.push(range = [
        lambda0 = lambda,
        lambda1 = lambda
    ]);
    if (phi < phi0) phi0 = phi;
    if (phi > phi1) phi1 = phi;
}
function linePoint(lambda, phi) {
    var p = (0, _cartesianJs.cartesian)([
        lambda * (0, _mathJs.radians),
        phi * (0, _mathJs.radians)
    ]);
    if (p0) {
        var normal = (0, _cartesianJs.cartesianCross)(p0, p), equatorial = [
            normal[1],
            -normal[0],
            0
        ], inflection = (0, _cartesianJs.cartesianCross)(equatorial, normal);
        (0, _cartesianJs.cartesianNormalizeInPlace)(inflection);
        inflection = (0, _cartesianJs.spherical)(inflection);
        var delta = lambda - lambda2, sign = delta > 0 ? 1 : -1, lambdai = inflection[0] * (0, _mathJs.degrees) * sign, phii, antimeridian = (0, _mathJs.abs)(delta) > 180;
        if (antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = inflection[1] * (0, _mathJs.degrees);
            if (phii > phi1) phi1 = phii;
        } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = -inflection[1] * (0, _mathJs.degrees);
            if (phii < phi0) phi0 = phii;
        } else {
            if (phi < phi0) phi0 = phi;
            if (phi > phi1) phi1 = phi;
        }
        if (antimeridian) {
            if (lambda < lambda2) {
                if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
            } else if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
        } else if (lambda1 >= lambda0) {
            if (lambda < lambda0) lambda0 = lambda;
            if (lambda > lambda1) lambda1 = lambda;
        } else {
            if (lambda > lambda2) {
                if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
            } else if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
        }
    } else ranges.push(range = [
        lambda0 = lambda,
        lambda1 = lambda
    ]);
    if (phi < phi0) phi0 = phi;
    if (phi > phi1) phi1 = phi;
    p0 = p, lambda2 = lambda;
}
function boundsLineStart() {
    boundsStream.point = linePoint;
}
function boundsLineEnd() {
    range[0] = lambda0, range[1] = lambda1;
    boundsStream.point = boundsPoint;
    p0 = null;
}
function boundsRingPoint(lambda, phi) {
    if (p0) {
        var delta = lambda - lambda2;
        deltaSum.add((0, _mathJs.abs)(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
    } else lambda00 = lambda, phi00 = phi;
    (0, _areaJs.areaStream).point(lambda, phi);
    linePoint(lambda, phi);
}
function boundsRingStart() {
    (0, _areaJs.areaStream).lineStart();
}
function boundsRingEnd() {
    boundsRingPoint(lambda00, phi00);
    (0, _areaJs.areaStream).lineEnd();
    if ((0, _mathJs.abs)(deltaSum) > (0, _mathJs.epsilon)) lambda0 = -(lambda1 = 180);
    range[0] = lambda0, range[1] = lambda1;
    p0 = null;
}
// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function angle(lambda0, lambda1) {
    return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}
function rangeCompare(a, b) {
    return a[0] - b[0];
}
function rangeContains(range, x) {
    return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}

},{"d3-array":"2G8br","./area.js":"fU0uC","./cartesian.js":"90jyE","./math.js":"hswBu","./stream.js":"hAqHD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"90jyE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "spherical", ()=>spherical);
parcelHelpers.export(exports, "cartesian", ()=>cartesian);
parcelHelpers.export(exports, "cartesianDot", ()=>cartesianDot);
parcelHelpers.export(exports, "cartesianCross", ()=>cartesianCross);
// TODO return a
parcelHelpers.export(exports, "cartesianAddInPlace", ()=>cartesianAddInPlace);
parcelHelpers.export(exports, "cartesianScale", ()=>cartesianScale);
// TODO return d
parcelHelpers.export(exports, "cartesianNormalizeInPlace", ()=>cartesianNormalizeInPlace);
var _mathJs = require("./math.js");
function spherical(cartesian) {
    return [
        (0, _mathJs.atan2)(cartesian[1], cartesian[0]),
        (0, _mathJs.asin)(cartesian[2])
    ];
}
function cartesian(spherical) {
    var lambda = spherical[0], phi = spherical[1], cosPhi = (0, _mathJs.cos)(phi);
    return [
        cosPhi * (0, _mathJs.cos)(lambda),
        cosPhi * (0, _mathJs.sin)(lambda),
        (0, _mathJs.sin)(phi)
    ];
}
function cartesianDot(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function cartesianCross(a, b) {
    return [
        a[1] * b[2] - a[2] * b[1],
        a[2] * b[0] - a[0] * b[2],
        a[0] * b[1] - a[1] * b[0]
    ];
}
function cartesianAddInPlace(a, b) {
    a[0] += b[0], a[1] += b[1], a[2] += b[2];
}
function cartesianScale(vector, k) {
    return [
        vector[0] * k,
        vector[1] * k,
        vector[2] * k
    ];
}
function cartesianNormalizeInPlace(d) {
    var l = (0, _mathJs.sqrt)(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l, d[1] /= l, d[2] /= l;
}

},{"./math.js":"hswBu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fSoBX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(object) {
        W0 = W1 = X0 = Y0 = Z0 = X1 = Y1 = Z1 = 0;
        X2 = new (0, _d3Array.Adder)();
        Y2 = new (0, _d3Array.Adder)();
        Z2 = new (0, _d3Array.Adder)();
        (0, _streamJsDefault.default)(object, centroidStream);
        var x = +X2, y = +Y2, z = +Z2, m = (0, _mathJs.hypot)(x, y, z);
        // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
        if (m < (0, _mathJs.epsilon2)) {
            x = X1, y = Y1, z = Z1;
            // If the feature has zero length, fall back to arithmetic mean of point vectors.
            if (W1 < (0, _mathJs.epsilon)) x = X0, y = Y0, z = Z0;
            m = (0, _mathJs.hypot)(x, y, z);
            // If the feature still has an undefined ccentroid, then return.
            if (m < (0, _mathJs.epsilon2)) return [
                NaN,
                NaN
            ];
        }
        return [
            (0, _mathJs.atan2)(y, x) * (0, _mathJs.degrees),
            (0, _mathJs.asin)(z / m) * (0, _mathJs.degrees)
        ];
    });
var _d3Array = require("d3-array");
var _mathJs = require("./math.js");
var _noopJs = require("./noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _streamJs = require("./stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var W0, W1, X0, Y0, Z0, X1, Y1, Z1, X2, Y2, Z2, lambda00, phi00, x0, y0, z0; // previous point
var centroidStream = {
    sphere: (0, _noopJsDefault.default),
    point: centroidPoint,
    lineStart: centroidLineStart,
    lineEnd: centroidLineEnd,
    polygonStart: function() {
        centroidStream.lineStart = centroidRingStart;
        centroidStream.lineEnd = centroidRingEnd;
    },
    polygonEnd: function() {
        centroidStream.lineStart = centroidLineStart;
        centroidStream.lineEnd = centroidLineEnd;
    }
};
// Arithmetic mean of Cartesian vectors.
function centroidPoint(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    var cosPhi = (0, _mathJs.cos)(phi);
    centroidPointCartesian(cosPhi * (0, _mathJs.cos)(lambda), cosPhi * (0, _mathJs.sin)(lambda), (0, _mathJs.sin)(phi));
}
function centroidPointCartesian(x, y, z) {
    ++W0;
    X0 += (x - X0) / W0;
    Y0 += (y - Y0) / W0;
    Z0 += (z - Z0) / W0;
}
function centroidLineStart() {
    centroidStream.point = centroidLinePointFirst;
}
function centroidLinePointFirst(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    var cosPhi = (0, _mathJs.cos)(phi);
    x0 = cosPhi * (0, _mathJs.cos)(lambda);
    y0 = cosPhi * (0, _mathJs.sin)(lambda);
    z0 = (0, _mathJs.sin)(phi);
    centroidStream.point = centroidLinePoint;
    centroidPointCartesian(x0, y0, z0);
}
function centroidLinePoint(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    var cosPhi = (0, _mathJs.cos)(phi), x = cosPhi * (0, _mathJs.cos)(lambda), y = cosPhi * (0, _mathJs.sin)(lambda), z = (0, _mathJs.sin)(phi), w = (0, _mathJs.atan2)((0, _mathJs.sqrt)((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
    W1 += w;
    X1 += w * (x0 + (x0 = x));
    Y1 += w * (y0 + (y0 = y));
    Z1 += w * (z0 + (z0 = z));
    centroidPointCartesian(x0, y0, z0);
}
function centroidLineEnd() {
    centroidStream.point = centroidPoint;
}
// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function centroidRingStart() {
    centroidStream.point = centroidRingPointFirst;
}
function centroidRingEnd() {
    centroidRingPoint(lambda00, phi00);
    centroidStream.point = centroidPoint;
}
function centroidRingPointFirst(lambda, phi) {
    lambda00 = lambda, phi00 = phi;
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    centroidStream.point = centroidRingPoint;
    var cosPhi = (0, _mathJs.cos)(phi);
    x0 = cosPhi * (0, _mathJs.cos)(lambda);
    y0 = cosPhi * (0, _mathJs.sin)(lambda);
    z0 = (0, _mathJs.sin)(phi);
    centroidPointCartesian(x0, y0, z0);
}
function centroidRingPoint(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    var cosPhi = (0, _mathJs.cos)(phi), x = cosPhi * (0, _mathJs.cos)(lambda), y = cosPhi * (0, _mathJs.sin)(lambda), z = (0, _mathJs.sin)(phi), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = (0, _mathJs.hypot)(cx, cy, cz), w = (0, _mathJs.asin)(m), v = m && -w / m; // area weight multiplier
    X2.add(v * cx);
    Y2.add(v * cy);
    Z2.add(v * cz);
    W1 += w;
    X1 += w * (x0 + (x0 = x));
    Y1 += w * (y0 + (y0 = y));
    Z1 += w * (z0 + (z0 = z));
    centroidPointCartesian(x0, y0, z0);
}

},{"d3-array":"2G8br","./math.js":"hswBu","./noop.js":"bwHmr","./stream.js":"hAqHD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2UTty":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Generates a circle centered at [0°, 0°], with a given radius and precision.
parcelHelpers.export(exports, "circleStream", ()=>circleStream);
parcelHelpers.export(exports, "default", ()=>function() {
        var center = (0, _constantJsDefault.default)([
            0,
            0
        ]), radius = (0, _constantJsDefault.default)(90), precision = (0, _constantJsDefault.default)(2), ring, rotate, stream = {
            point: point
        };
        function point(x, y) {
            ring.push(x = rotate(x, y));
            x[0] *= (0, _mathJs.degrees), x[1] *= (0, _mathJs.degrees);
        }
        function circle() {
            var c = center.apply(this, arguments), r = radius.apply(this, arguments) * (0, _mathJs.radians), p = precision.apply(this, arguments) * (0, _mathJs.radians);
            ring = [];
            rotate = (0, _rotationJs.rotateRadians)(-c[0] * (0, _mathJs.radians), -c[1] * (0, _mathJs.radians), 0).invert;
            circleStream(stream, r, p, 1);
            c = {
                type: "Polygon",
                coordinates: [
                    ring
                ]
            };
            ring = rotate = null;
            return c;
        }
        circle.center = function(_) {
            return arguments.length ? (center = typeof _ === "function" ? _ : (0, _constantJsDefault.default)([
                +_[0],
                +_[1]
            ]), circle) : center;
        };
        circle.radius = function(_) {
            return arguments.length ? (radius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), circle) : radius;
        };
        circle.precision = function(_) {
            return arguments.length ? (precision = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), circle) : precision;
        };
        return circle;
    });
var _cartesianJs = require("./cartesian.js");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _mathJs = require("./math.js");
var _rotationJs = require("./rotation.js");
function circleStream(stream, radius, delta, direction, t0, t1) {
    if (!delta) return;
    var cosRadius = (0, _mathJs.cos)(radius), sinRadius = (0, _mathJs.sin)(radius), step = direction * delta;
    if (t0 == null) {
        t0 = radius + direction * (0, _mathJs.tau);
        t1 = radius - step / 2;
    } else {
        t0 = circleRadius(cosRadius, t0);
        t1 = circleRadius(cosRadius, t1);
        if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * (0, _mathJs.tau);
    }
    for(var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step){
        point = (0, _cartesianJs.spherical)([
            cosRadius,
            -sinRadius * (0, _mathJs.cos)(t),
            -sinRadius * (0, _mathJs.sin)(t)
        ]);
        stream.point(point[0], point[1]);
    }
}
// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function circleRadius(cosRadius, point) {
    point = (0, _cartesianJs.cartesian)(point), point[0] -= cosRadius;
    (0, _cartesianJs.cartesianNormalizeInPlace)(point);
    var radius = (0, _mathJs.acos)(-point[1]);
    return ((-point[2] < 0 ? -radius : radius) + (0, _mathJs.tau) - (0, _mathJs.epsilon)) % (0, _mathJs.tau);
}

},{"./cartesian.js":"90jyE","./constant.js":"kMW7Y","./math.js":"hswBu","./rotation.js":"ka8Fr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kMW7Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ka8Fr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rotateRadians", ()=>rotateRadians);
parcelHelpers.export(exports, "default", ()=>function(rotate) {
        rotate = rotateRadians(rotate[0] * (0, _mathJs.radians), rotate[1] * (0, _mathJs.radians), rotate.length > 2 ? rotate[2] * (0, _mathJs.radians) : 0);
        function forward(coordinates) {
            coordinates = rotate(coordinates[0] * (0, _mathJs.radians), coordinates[1] * (0, _mathJs.radians));
            return coordinates[0] *= (0, _mathJs.degrees), coordinates[1] *= (0, _mathJs.degrees), coordinates;
        }
        forward.invert = function(coordinates) {
            coordinates = rotate.invert(coordinates[0] * (0, _mathJs.radians), coordinates[1] * (0, _mathJs.radians));
            return coordinates[0] *= (0, _mathJs.degrees), coordinates[1] *= (0, _mathJs.degrees), coordinates;
        };
        return forward;
    });
var _composeJs = require("./compose.js");
var _composeJsDefault = parcelHelpers.interopDefault(_composeJs);
var _mathJs = require("./math.js");
function rotationIdentity(lambda, phi) {
    if ((0, _mathJs.abs)(lambda) > (0, _mathJs.pi)) lambda -= Math.round(lambda / (0, _mathJs.tau)) * (0, _mathJs.tau);
    return [
        lambda,
        phi
    ];
}
rotationIdentity.invert = rotationIdentity;
function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
    return (deltaLambda %= (0, _mathJs.tau)) ? deltaPhi || deltaGamma ? (0, _composeJsDefault.default)(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma)) : rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma) : rotationIdentity;
}
function forwardRotationLambda(deltaLambda) {
    return function(lambda, phi) {
        lambda += deltaLambda;
        if ((0, _mathJs.abs)(lambda) > (0, _mathJs.pi)) lambda -= Math.round(lambda / (0, _mathJs.tau)) * (0, _mathJs.tau);
        return [
            lambda,
            phi
        ];
    };
}
function rotationLambda(deltaLambda) {
    var rotation = forwardRotationLambda(deltaLambda);
    rotation.invert = forwardRotationLambda(-deltaLambda);
    return rotation;
}
function rotationPhiGamma(deltaPhi, deltaGamma) {
    var cosDeltaPhi = (0, _mathJs.cos)(deltaPhi), sinDeltaPhi = (0, _mathJs.sin)(deltaPhi), cosDeltaGamma = (0, _mathJs.cos)(deltaGamma), sinDeltaGamma = (0, _mathJs.sin)(deltaGamma);
    function rotation(lambda, phi) {
        var cosPhi = (0, _mathJs.cos)(phi), x = (0, _mathJs.cos)(lambda) * cosPhi, y = (0, _mathJs.sin)(lambda) * cosPhi, z = (0, _mathJs.sin)(phi), k = z * cosDeltaPhi + x * sinDeltaPhi;
        return [
            (0, _mathJs.atan2)(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
            (0, _mathJs.asin)(k * cosDeltaGamma + y * sinDeltaGamma)
        ];
    }
    rotation.invert = function(lambda, phi) {
        var cosPhi = (0, _mathJs.cos)(phi), x = (0, _mathJs.cos)(lambda) * cosPhi, y = (0, _mathJs.sin)(lambda) * cosPhi, z = (0, _mathJs.sin)(phi), k = z * cosDeltaGamma - y * sinDeltaGamma;
        return [
            (0, _mathJs.atan2)(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
            (0, _mathJs.asin)(k * cosDeltaPhi - x * sinDeltaPhi)
        ];
    };
    return rotation;
}

},{"./compose.js":"2iAT7","./math.js":"hswBu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2iAT7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        function compose(x, y) {
            return x = a(x, y), b(x[0], x[1]);
        }
        if (a.invert && b.invert) compose.invert = function(x, y) {
            return x = b.invert(x, y), x && a.invert(x[0], x[1]);
        };
        return compose;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bpOyZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _mathJs = require("../math.js");
exports.default = (0, _indexJsDefault.default)(function() {
    return true;
}, clipAntimeridianLine, clipAntimeridianInterpolate, [
    -(0, _mathJs.pi),
    -(0, _mathJs.halfPi)
]);
// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function clipAntimeridianLine(stream) {
    var lambda0 = NaN, phi0 = NaN, sign0 = NaN, clean; // no intersections
    return {
        lineStart: function() {
            stream.lineStart();
            clean = 1;
        },
        point: function(lambda1, phi1) {
            var sign1 = lambda1 > 0 ? (0, _mathJs.pi) : -(0, _mathJs.pi), delta = (0, _mathJs.abs)(lambda1 - lambda0);
            if ((0, _mathJs.abs)(delta - (0, _mathJs.pi)) < (0, _mathJs.epsilon)) {
                stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? (0, _mathJs.halfPi) : -(0, _mathJs.halfPi));
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                stream.point(lambda1, phi0);
                clean = 0;
            } else if (sign0 !== sign1 && delta >= (0, _mathJs.pi)) {
                if ((0, _mathJs.abs)(lambda0 - sign0) < (0, _mathJs.epsilon)) lambda0 -= sign0 * (0, _mathJs.epsilon); // handle degeneracies
                if ((0, _mathJs.abs)(lambda1 - sign1) < (0, _mathJs.epsilon)) lambda1 -= sign1 * (0, _mathJs.epsilon);
                phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                clean = 0;
            }
            stream.point(lambda0 = lambda1, phi0 = phi1);
            sign0 = sign1;
        },
        lineEnd: function() {
            stream.lineEnd();
            lambda0 = phi0 = NaN;
        },
        clean: function() {
            return 2 - clean; // if intersections, rejoin first and last segments
        }
    };
}
function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
    var cosPhi0, cosPhi1, sinLambda0Lambda1 = (0, _mathJs.sin)(lambda0 - lambda1);
    return (0, _mathJs.abs)(sinLambda0Lambda1) > (0, _mathJs.epsilon) ? (0, _mathJs.atan)(((0, _mathJs.sin)(phi0) * (cosPhi1 = (0, _mathJs.cos)(phi1)) * (0, _mathJs.sin)(lambda1) - (0, _mathJs.sin)(phi1) * (cosPhi0 = (0, _mathJs.cos)(phi0)) * (0, _mathJs.sin)(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
}
function clipAntimeridianInterpolate(from, to, direction, stream) {
    var phi;
    if (from == null) {
        phi = direction * (0, _mathJs.halfPi);
        stream.point(-(0, _mathJs.pi), phi);
        stream.point(0, phi);
        stream.point((0, _mathJs.pi), phi);
        stream.point((0, _mathJs.pi), 0);
        stream.point((0, _mathJs.pi), -phi);
        stream.point(0, -phi);
        stream.point(-(0, _mathJs.pi), -phi);
        stream.point(-(0, _mathJs.pi), 0);
        stream.point(-(0, _mathJs.pi), phi);
    } else if ((0, _mathJs.abs)(from[0] - to[0]) > (0, _mathJs.epsilon)) {
        var lambda = from[0] < to[0] ? (0, _mathJs.pi) : -(0, _mathJs.pi);
        phi = direction * lambda / 2;
        stream.point(-lambda, phi);
        stream.point(0, phi);
        stream.point(lambda, phi);
    } else stream.point(to[0], to[1]);
}

},{"./index.js":"dJoEr","../math.js":"hswBu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dJoEr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(pointVisible, clipLine, interpolate, start) {
        return function(sink) {
            var line = clipLine(sink), ringBuffer = (0, _bufferJsDefault.default)(), ringSink = clipLine(ringBuffer), polygonStarted = false, polygon, segments, ring;
            var clip = {
                point: point,
                lineStart: lineStart,
                lineEnd: lineEnd,
                polygonStart: function() {
                    clip.point = pointRing;
                    clip.lineStart = ringStart;
                    clip.lineEnd = ringEnd;
                    segments = [];
                    polygon = [];
                },
                polygonEnd: function() {
                    clip.point = point;
                    clip.lineStart = lineStart;
                    clip.lineEnd = lineEnd;
                    segments = (0, _d3Array.merge)(segments);
                    var startInside = (0, _polygonContainsJsDefault.default)(polygon, start);
                    if (segments.length) {
                        if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                        (0, _rejoinJsDefault.default)(segments, compareIntersection, startInside, interpolate, sink);
                    } else if (startInside) {
                        if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                        sink.lineStart();
                        interpolate(null, null, 1, sink);
                        sink.lineEnd();
                    }
                    if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
                    segments = polygon = null;
                },
                sphere: function() {
                    sink.polygonStart();
                    sink.lineStart();
                    interpolate(null, null, 1, sink);
                    sink.lineEnd();
                    sink.polygonEnd();
                }
            };
            function point(lambda, phi) {
                if (pointVisible(lambda, phi)) sink.point(lambda, phi);
            }
            function pointLine(lambda, phi) {
                line.point(lambda, phi);
            }
            function lineStart() {
                clip.point = pointLine;
                line.lineStart();
            }
            function lineEnd() {
                clip.point = point;
                line.lineEnd();
            }
            function pointRing(lambda, phi) {
                ring.push([
                    lambda,
                    phi
                ]);
                ringSink.point(lambda, phi);
            }
            function ringStart() {
                ringSink.lineStart();
                ring = [];
            }
            function ringEnd() {
                pointRing(ring[0][0], ring[0][1]);
                ringSink.lineEnd();
                var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i, n = ringSegments.length, m, segment, point;
                ring.pop();
                polygon.push(ring);
                ring = null;
                if (!n) return;
                // No intersections.
                if (clean & 1) {
                    segment = ringSegments[0];
                    if ((m = segment.length - 1) > 0) {
                        if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                        sink.lineStart();
                        for(i = 0; i < m; ++i)sink.point((point = segment[i])[0], point[1]);
                        sink.lineEnd();
                    }
                    return;
                }
                // Rejoin connected segments.
                // TODO reuse ringBuffer.rejoin()?
                if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
                segments.push(ringSegments.filter(validSegment));
            }
            return clip;
        };
    });
var _bufferJs = require("./buffer.js");
var _bufferJsDefault = parcelHelpers.interopDefault(_bufferJs);
var _rejoinJs = require("./rejoin.js");
var _rejoinJsDefault = parcelHelpers.interopDefault(_rejoinJs);
var _mathJs = require("../math.js");
var _polygonContainsJs = require("../polygonContains.js");
var _polygonContainsJsDefault = parcelHelpers.interopDefault(_polygonContainsJs);
var _d3Array = require("d3-array");
function validSegment(segment) {
    return segment.length > 1;
}
// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function compareIntersection(a, b) {
    return ((a = a.x)[0] < 0 ? a[1] - (0, _mathJs.halfPi) - (0, _mathJs.epsilon) : (0, _mathJs.halfPi) - a[1]) - ((b = b.x)[0] < 0 ? b[1] - (0, _mathJs.halfPi) - (0, _mathJs.epsilon) : (0, _mathJs.halfPi) - b[1]);
}

},{"./buffer.js":"8HaBU","./rejoin.js":"gC1l2","../math.js":"hswBu","../polygonContains.js":"dRixn","d3-array":[["merge","fe3e6","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8HaBU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var lines = [], line;
        return {
            point: function(x, y, m) {
                line.push([
                    x,
                    y,
                    m
                ]);
            },
            lineStart: function() {
                lines.push(line = []);
            },
            lineEnd: (0, _noopJsDefault.default),
            rejoin: function() {
                if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
            },
            result: function() {
                var result = lines;
                lines = [];
                line = null;
                return result;
            }
        };
    });
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);

},{"../noop.js":"bwHmr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gC1l2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// A generalized polygon clipping algorithm: given a polygon that has been cut
// into its visible line segments, and rejoins the segments by interpolating
// along the clip edge.
parcelHelpers.export(exports, "default", ()=>function(segments, compareIntersection, startInside, interpolate, stream) {
        var subject = [], clip = [], i, n;
        segments.forEach(function(segment) {
            if ((n = segment.length - 1) <= 0) return;
            var n, p0 = segment[0], p1 = segment[n], x;
            if ((0, _pointEqualJsDefault.default)(p0, p1)) {
                if (!p0[2] && !p1[2]) {
                    stream.lineStart();
                    for(i = 0; i < n; ++i)stream.point((p0 = segment[i])[0], p0[1]);
                    stream.lineEnd();
                    return;
                }
                // handle degenerate cases by moving the point
                p1[0] += 2 * (0, _mathJs.epsilon);
            }
            subject.push(x = new Intersection(p0, segment, null, true));
            clip.push(x.o = new Intersection(p0, null, x, false));
            subject.push(x = new Intersection(p1, segment, null, false));
            clip.push(x.o = new Intersection(p1, null, x, true));
        });
        if (!subject.length) return;
        clip.sort(compareIntersection);
        link(subject);
        link(clip);
        for(i = 0, n = clip.length; i < n; ++i)clip[i].e = startInside = !startInside;
        var start = subject[0], points, point;
        while(true){
            // Find first unvisited intersection.
            var current = start, isSubject = true;
            while(current.v)if ((current = current.n) === start) return;
            points = current.z;
            stream.lineStart();
            do {
                current.v = current.o.v = true;
                if (current.e) {
                    if (isSubject) for(i = 0, n = points.length; i < n; ++i)stream.point((point = points[i])[0], point[1]);
                    else interpolate(current.x, current.n.x, 1, stream);
                    current = current.n;
                } else {
                    if (isSubject) {
                        points = current.p.z;
                        for(i = points.length - 1; i >= 0; --i)stream.point((point = points[i])[0], point[1]);
                    } else interpolate(current.x, current.p.x, -1, stream);
                    current = current.p;
                }
                current = current.o;
                points = current.z;
                isSubject = !isSubject;
            }while (!current.v);
            stream.lineEnd();
        }
    });
var _pointEqualJs = require("../pointEqual.js");
var _pointEqualJsDefault = parcelHelpers.interopDefault(_pointEqualJs);
var _mathJs = require("../math.js");
function Intersection(point, points, other, entry) {
    this.x = point;
    this.z = points;
    this.o = other; // another intersection
    this.e = entry; // is an entry?
    this.v = false; // visited
    this.n = this.p = null; // next & previous
}
function link(array) {
    if (!(n = array.length)) return;
    var n, i = 0, a = array[0], b;
    while(++i < n){
        a.n = b = array[i];
        b.p = a;
        a = b;
    }
    a.n = b = array[0];
    b.p = a;
}

},{"../pointEqual.js":"aecr8","../math.js":"hswBu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aecr8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return (0, _mathJs.abs)(a[0] - b[0]) < (0, _mathJs.epsilon) && (0, _mathJs.abs)(a[1] - b[1]) < (0, _mathJs.epsilon);
    });
var _mathJs = require("./math.js");

},{"./math.js":"hswBu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dRixn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(polygon, point) {
        var lambda = longitude(point), phi = point[1], sinPhi = (0, _mathJs.sin)(phi), normal = [
            (0, _mathJs.sin)(lambda),
            -(0, _mathJs.cos)(lambda),
            0
        ], angle = 0, winding = 0;
        var sum = new (0, _d3Array.Adder)();
        if (sinPhi === 1) phi = (0, _mathJs.halfPi) + (0, _mathJs.epsilon);
        else if (sinPhi === -1) phi = -(0, _mathJs.halfPi) - (0, _mathJs.epsilon);
        for(var i = 0, n = polygon.length; i < n; ++i){
            if (!(m = (ring = polygon[i]).length)) continue;
            var ring, m, point0 = ring[m - 1], lambda0 = longitude(point0), phi0 = point0[1] / 2 + (0, _mathJs.quarterPi), sinPhi0 = (0, _mathJs.sin)(phi0), cosPhi0 = (0, _mathJs.cos)(phi0);
            for(var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1){
                var point1 = ring[j], lambda1 = longitude(point1), phi1 = point1[1] / 2 + (0, _mathJs.quarterPi), sinPhi1 = (0, _mathJs.sin)(phi1), cosPhi1 = (0, _mathJs.cos)(phi1), delta = lambda1 - lambda0, sign = delta >= 0 ? 1 : -1, absDelta = sign * delta, antimeridian = absDelta > (0, _mathJs.pi), k = sinPhi0 * sinPhi1;
                sum.add((0, _mathJs.atan2)(k * sign * (0, _mathJs.sin)(absDelta), cosPhi0 * cosPhi1 + k * (0, _mathJs.cos)(absDelta)));
                angle += antimeridian ? delta + sign * (0, _mathJs.tau) : delta;
                // Are the longitudes either side of the point’s meridian (lambda),
                // and are the latitudes smaller than the parallel (phi)?
                if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
                    var arc = (0, _cartesianJs.cartesianCross)((0, _cartesianJs.cartesian)(point0), (0, _cartesianJs.cartesian)(point1));
                    (0, _cartesianJs.cartesianNormalizeInPlace)(arc);
                    var intersection = (0, _cartesianJs.cartesianCross)(normal, arc);
                    (0, _cartesianJs.cartesianNormalizeInPlace)(intersection);
                    var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * (0, _mathJs.asin)(intersection[2]);
                    if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) winding += antimeridian ^ delta >= 0 ? 1 : -1;
                }
            }
        }
        // First, determine whether the South pole is inside or outside:
        //
        // It is inside if:
        // * the polygon winds around it in a clockwise direction.
        // * the polygon does not (cumulatively) wind around it, but has a negative
        //   (counter-clockwise) area.
        //
        // Second, count the (signed) number of times a segment crosses a lambda
        // from the point to the South pole.  If it is zero, then the point is the
        // same side as the South pole.
        return (angle < -(0, _mathJs.epsilon) || angle < (0, _mathJs.epsilon) && sum < -(0, _mathJs.epsilon2)) ^ winding & 1;
    });
var _d3Array = require("d3-array");
var _cartesianJs = require("./cartesian.js");
var _mathJs = require("./math.js");
function longitude(point) {
    return (0, _mathJs.abs)(point[0]) <= (0, _mathJs.pi) ? point[0] : (0, _mathJs.sign)(point[0]) * (((0, _mathJs.abs)(point[0]) + (0, _mathJs.pi)) % (0, _mathJs.tau) - (0, _mathJs.pi));
}

},{"d3-array":"2G8br","./cartesian.js":"90jyE","./math.js":"hswBu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8GPcP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(radius) {
        var cr = (0, _mathJs.cos)(radius), delta = 2 * (0, _mathJs.radians), smallRadius = cr > 0, notHemisphere = (0, _mathJs.abs)(cr) > (0, _mathJs.epsilon); // TODO optimise for this common case
        function interpolate(from, to, direction, stream) {
            (0, _circleJs.circleStream)(stream, radius, delta, direction, from, to);
        }
        function visible(lambda, phi) {
            return (0, _mathJs.cos)(lambda) * (0, _mathJs.cos)(phi) > cr;
        }
        // Takes a line and cuts into visible segments. Return values used for polygon
        // clipping: 0 - there were intersections or the line was empty; 1 - no
        // intersections 2 - there were intersections, and the first and last segments
        // should be rejoined.
        function clipLine(stream) {
            var point0, c0, v0, v00, clean; // no intersections
            return {
                lineStart: function() {
                    v00 = v0 = false;
                    clean = 1;
                },
                point: function(lambda, phi) {
                    var point1 = [
                        lambda,
                        phi
                    ], point2, v = visible(lambda, phi), c = smallRadius ? v ? 0 : code(lambda, phi) : v ? code(lambda + (lambda < 0 ? (0, _mathJs.pi) : -(0, _mathJs.pi)), phi) : 0;
                    if (!point0 && (v00 = v0 = v)) stream.lineStart();
                    if (v !== v0) {
                        point2 = intersect(point0, point1);
                        if (!point2 || (0, _pointEqualJsDefault.default)(point0, point2) || (0, _pointEqualJsDefault.default)(point1, point2)) point1[2] = 1;
                    }
                    if (v !== v0) {
                        clean = 0;
                        if (v) {
                            // outside going in
                            stream.lineStart();
                            point2 = intersect(point1, point0);
                            stream.point(point2[0], point2[1]);
                        } else {
                            // inside going out
                            point2 = intersect(point0, point1);
                            stream.point(point2[0], point2[1], 2);
                            stream.lineEnd();
                        }
                        point0 = point2;
                    } else if (notHemisphere && point0 && smallRadius ^ v) {
                        var t;
                        // If the codes for two points are different, or are both zero,
                        // and there this segment intersects with the small circle.
                        if (!(c & c0) && (t = intersect(point1, point0, true))) {
                            clean = 0;
                            if (smallRadius) {
                                stream.lineStart();
                                stream.point(t[0][0], t[0][1]);
                                stream.point(t[1][0], t[1][1]);
                                stream.lineEnd();
                            } else {
                                stream.point(t[1][0], t[1][1]);
                                stream.lineEnd();
                                stream.lineStart();
                                stream.point(t[0][0], t[0][1], 3);
                            }
                        }
                    }
                    if (v && (!point0 || !(0, _pointEqualJsDefault.default)(point0, point1))) stream.point(point1[0], point1[1]);
                    point0 = point1, v0 = v, c0 = c;
                },
                lineEnd: function() {
                    if (v0) stream.lineEnd();
                    point0 = null;
                },
                // Rejoin first and last segments if there were intersections and the first
                // and last points were visible.
                clean: function() {
                    return clean | (v00 && v0) << 1;
                }
            };
        }
        // Intersects the great circle between a and b with the clip circle.
        function intersect(a, b, two) {
            var pa = (0, _cartesianJs.cartesian)(a), pb = (0, _cartesianJs.cartesian)(b);
            // We have two planes, n1.p = d1 and n2.p = d2.
            // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
            var n1 = [
                1,
                0,
                0
            ], n2 = (0, _cartesianJs.cartesianCross)(pa, pb), n2n2 = (0, _cartesianJs.cartesianDot)(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
            // Two polar points.
            if (!determinant) return !two && a;
            var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = (0, _cartesianJs.cartesianCross)(n1, n2), A = (0, _cartesianJs.cartesianScale)(n1, c1), B = (0, _cartesianJs.cartesianScale)(n2, c2);
            (0, _cartesianJs.cartesianAddInPlace)(A, B);
            // Solve |p(t)|^2 = 1.
            var u = n1xn2, w = (0, _cartesianJs.cartesianDot)(A, u), uu = (0, _cartesianJs.cartesianDot)(u, u), t2 = w * w - uu * ((0, _cartesianJs.cartesianDot)(A, A) - 1);
            if (t2 < 0) return;
            var t = (0, _mathJs.sqrt)(t2), q = (0, _cartesianJs.cartesianScale)(u, (-w - t) / uu);
            (0, _cartesianJs.cartesianAddInPlace)(q, A);
            q = (0, _cartesianJs.spherical)(q);
            if (!two) return q;
            // Two intersection points.
            var lambda0 = a[0], lambda1 = b[0], phi0 = a[1], phi1 = b[1], z;
            if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
            var delta = lambda1 - lambda0, polar = (0, _mathJs.abs)(delta - (0, _mathJs.pi)) < (0, _mathJs.epsilon), meridian = polar || delta < (0, _mathJs.epsilon);
            if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
            // Check that the first point is between a and b.
            if (meridian ? polar ? phi0 + phi1 > 0 ^ q[1] < ((0, _mathJs.abs)(q[0] - lambda0) < (0, _mathJs.epsilon) ? phi0 : phi1) : phi0 <= q[1] && q[1] <= phi1 : delta > (0, _mathJs.pi) ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
                var q1 = (0, _cartesianJs.cartesianScale)(u, (-w + t) / uu);
                (0, _cartesianJs.cartesianAddInPlace)(q1, A);
                return [
                    q,
                    (0, _cartesianJs.spherical)(q1)
                ];
            }
        }
        // Generates a 4-bit vector representing the location of a point relative to
        // the small circle's bounding box.
        function code(lambda, phi) {
            var r = smallRadius ? radius : (0, _mathJs.pi) - radius, code = 0;
            if (lambda < -r) code |= 1; // left
            else if (lambda > r) code |= 2; // right
            if (phi < -r) code |= 4; // below
            else if (phi > r) code |= 8; // above
            return code;
        }
        return (0, _indexJsDefault.default)(visible, clipLine, interpolate, smallRadius ? [
            0,
            -radius
        ] : [
            -(0, _mathJs.pi),
            radius - (0, _mathJs.pi)
        ]);
    });
var _cartesianJs = require("../cartesian.js");
var _circleJs = require("../circle.js");
var _mathJs = require("../math.js");
var _pointEqualJs = require("../pointEqual.js");
var _pointEqualJsDefault = parcelHelpers.interopDefault(_pointEqualJs);
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);

},{"../cartesian.js":"90jyE","../circle.js":"2UTty","../math.js":"hswBu","../pointEqual.js":"aecr8","./index.js":"dJoEr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eSopJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var x0 = 0, y0 = 0, x1 = 960, y1 = 500, cache, cacheStream, clip;
        return clip = {
            stream: function(stream) {
                return cache && cacheStream === stream ? cache : cache = (0, _rectangleJsDefault.default)(x0, y0, x1, y1)(cacheStream = stream);
            },
            extent: function(_) {
                return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [
                    [
                        x0,
                        y0
                    ],
                    [
                        x1,
                        y1
                    ]
                ];
            }
        };
    });
var _rectangleJs = require("./rectangle.js");
var _rectangleJsDefault = parcelHelpers.interopDefault(_rectangleJs);

},{"./rectangle.js":"hgkNK","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hgkNK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>clipRectangle);
var _mathJs = require("../math.js");
var _bufferJs = require("./buffer.js");
var _bufferJsDefault = parcelHelpers.interopDefault(_bufferJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
var _rejoinJs = require("./rejoin.js");
var _rejoinJsDefault = parcelHelpers.interopDefault(_rejoinJs);
var _d3Array = require("d3-array");
var clipMax = 1e9, clipMin = -clipMax;
function clipRectangle(x0, y0, x1, y1) {
    function visible(x, y) {
        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
    }
    function interpolate(from, to, direction, stream) {
        var a = 0, a1 = 0;
        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
        while ((a = (a + direction + 4) % 4) !== a1);
        else stream.point(to[0], to[1]);
    }
    function corner(p, direction) {
        return (0, _mathJs.abs)(p[0] - x0) < (0, _mathJs.epsilon) ? direction > 0 ? 0 : 3 : (0, _mathJs.abs)(p[0] - x1) < (0, _mathJs.epsilon) ? direction > 0 ? 2 : 1 : (0, _mathJs.abs)(p[1] - y0) < (0, _mathJs.epsilon) ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
    }
    function compareIntersection(a, b) {
        return comparePoint(a.x, b.x);
    }
    function comparePoint(a, b) {
        var ca = corner(a, 1), cb = corner(b, 1);
        return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
    }
    return function(stream) {
        var activeStream = stream, bufferStream = (0, _bufferJsDefault.default)(), segments, polygon, ring, x__, y__, v__, x_, y_, v_, first, clean;
        var clipStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: polygonStart,
            polygonEnd: polygonEnd
        };
        function point(x, y) {
            if (visible(x, y)) activeStream.point(x, y);
        }
        function polygonInside() {
            var winding = 0;
            for(var i = 0, n = polygon.length; i < n; ++i)for(var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j){
                a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
                if (a1 <= y1) {
                    if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding;
                } else if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding;
            }
            return winding;
        }
        // Buffer geometry within a polygon and then clip it en masse.
        function polygonStart() {
            activeStream = bufferStream, segments = [], polygon = [], clean = true;
        }
        function polygonEnd() {
            var startInside = polygonInside(), cleanInside = clean && startInside, visible = (segments = (0, _d3Array.merge)(segments)).length;
            if (cleanInside || visible) {
                stream.polygonStart();
                if (cleanInside) {
                    stream.lineStart();
                    interpolate(null, null, 1, stream);
                    stream.lineEnd();
                }
                if (visible) (0, _rejoinJsDefault.default)(segments, compareIntersection, startInside, interpolate, stream);
                stream.polygonEnd();
            }
            activeStream = stream, segments = polygon = ring = null;
        }
        function lineStart() {
            clipStream.point = linePoint;
            if (polygon) polygon.push(ring = []);
            first = true;
            v_ = false;
            x_ = y_ = NaN;
        }
        // TODO rather than special-case polygons, simply handle them separately.
        // Ideally, coincident intersection points should be jittered to avoid
        // clipping issues.
        function lineEnd() {
            if (segments) {
                linePoint(x__, y__);
                if (v__ && v_) bufferStream.rejoin();
                segments.push(bufferStream.result());
            }
            clipStream.point = point;
            if (v_) activeStream.lineEnd();
        }
        function linePoint(x, y) {
            var v = visible(x, y);
            if (polygon) ring.push([
                x,
                y
            ]);
            if (first) {
                x__ = x, y__ = y, v__ = v;
                first = false;
                if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                }
            } else if (v && v_) activeStream.point(x, y);
            else {
                var a = [
                    x_ = Math.max(clipMin, Math.min(clipMax, x_)),
                    y_ = Math.max(clipMin, Math.min(clipMax, y_))
                ], b = [
                    x = Math.max(clipMin, Math.min(clipMax, x)),
                    y = Math.max(clipMin, Math.min(clipMax, y))
                ];
                if ((0, _lineJsDefault.default)(a, b, x0, y0, x1, y1)) {
                    if (!v_) {
                        activeStream.lineStart();
                        activeStream.point(a[0], a[1]);
                    }
                    activeStream.point(b[0], b[1]);
                    if (!v) activeStream.lineEnd();
                    clean = false;
                } else if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                    clean = false;
                }
            }
            x_ = x, y_ = y, v_ = v;
        }
        return clipStream;
    };
}

},{"../math.js":"hswBu","./buffer.js":"8HaBU","./line.js":"ekx16","./rejoin.js":"gC1l2","d3-array":[["merge","fe3e6","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ekx16":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b, x0, y0, x1, y1) {
        var ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
        r = x0 - ax;
        if (!dx && r > 0) return;
        r /= dx;
        if (dx < 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        } else if (dx > 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        }
        r = x1 - ax;
        if (!dx && r < 0) return;
        r /= dx;
        if (dx < 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        } else if (dx > 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        }
        r = y0 - ay;
        if (!dy && r > 0) return;
        r /= dy;
        if (dy < 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        } else if (dy > 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        }
        r = y1 - ay;
        if (!dy && r < 0) return;
        r /= dy;
        if (dy < 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        } else if (dy > 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        }
        if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
        if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
        return true;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bcHJ0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(object, point) {
        return (object && containsObjectType.hasOwnProperty(object.type) ? containsObjectType[object.type] : containsGeometry)(object, point);
    });
var _polygonContainsJs = require("./polygonContains.js");
var _polygonContainsJsDefault = parcelHelpers.interopDefault(_polygonContainsJs);
var _distanceJs = require("./distance.js");
var _distanceJsDefault = parcelHelpers.interopDefault(_distanceJs);
var _mathJs = require("./math.js");
var containsObjectType = {
    Feature: function(object, point) {
        return containsGeometry(object.geometry, point);
    },
    FeatureCollection: function(object, point) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)if (containsGeometry(features[i].geometry, point)) return true;
        return false;
    }
};
var containsGeometryType = {
    Sphere: function() {
        return true;
    },
    Point: function(object, point) {
        return containsPoint(object.coordinates, point);
    },
    MultiPoint: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if (containsPoint(coordinates[i], point)) return true;
        return false;
    },
    LineString: function(object, point) {
        return containsLine(object.coordinates, point);
    },
    MultiLineString: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if (containsLine(coordinates[i], point)) return true;
        return false;
    },
    Polygon: function(object, point) {
        return containsPolygon(object.coordinates, point);
    },
    MultiPolygon: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if (containsPolygon(coordinates[i], point)) return true;
        return false;
    },
    GeometryCollection: function(object, point) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)if (containsGeometry(geometries[i], point)) return true;
        return false;
    }
};
function containsGeometry(geometry, point) {
    return geometry && containsGeometryType.hasOwnProperty(geometry.type) ? containsGeometryType[geometry.type](geometry, point) : false;
}
function containsPoint(coordinates, point) {
    return (0, _distanceJsDefault.default)(coordinates, point) === 0;
}
function containsLine(coordinates, point) {
    var ao, bo, ab;
    for(var i = 0, n = coordinates.length; i < n; i++){
        bo = (0, _distanceJsDefault.default)(coordinates[i], point);
        if (bo === 0) return true;
        if (i > 0) {
            ab = (0, _distanceJsDefault.default)(coordinates[i], coordinates[i - 1]);
            if (ab > 0 && ao <= ab && bo <= ab && (ao + bo - ab) * (1 - Math.pow((ao - bo) / ab, 2)) < (0, _mathJs.epsilon2) * ab) return true;
        }
        ao = bo;
    }
    return false;
}
function containsPolygon(coordinates, point) {
    return !!(0, _polygonContainsJsDefault.default)(coordinates.map(ringRadians), pointRadians(point));
}
function ringRadians(ring) {
    return ring = ring.map(pointRadians), ring.pop(), ring;
}
function pointRadians(point) {
    return [
        point[0] * (0, _mathJs.radians),
        point[1] * (0, _mathJs.radians)
    ];
}

},{"./polygonContains.js":"dRixn","./distance.js":"bqozI","./math.js":"hswBu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bqozI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        coordinates[0] = a;
        coordinates[1] = b;
        return (0, _lengthJsDefault.default)(object);
    });
var _lengthJs = require("./length.js");
var _lengthJsDefault = parcelHelpers.interopDefault(_lengthJs);
var coordinates = [
    null,
    null
], object = {
    type: "LineString",
    coordinates: coordinates
};

},{"./length.js":"f4PvO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f4PvO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(object) {
        lengthSum = new (0, _d3Array.Adder)();
        (0, _streamJsDefault.default)(object, lengthStream);
        return +lengthSum;
    });
var _d3Array = require("d3-array");
var _mathJs = require("./math.js");
var _noopJs = require("./noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _streamJs = require("./stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var lengthSum, lambda0, sinPhi0, cosPhi0;
var lengthStream = {
    sphere: (0, _noopJsDefault.default),
    point: (0, _noopJsDefault.default),
    lineStart: lengthLineStart,
    lineEnd: (0, _noopJsDefault.default),
    polygonStart: (0, _noopJsDefault.default),
    polygonEnd: (0, _noopJsDefault.default)
};
function lengthLineStart() {
    lengthStream.point = lengthPointFirst;
    lengthStream.lineEnd = lengthLineEnd;
}
function lengthLineEnd() {
    lengthStream.point = lengthStream.lineEnd = (0, _noopJsDefault.default);
}
function lengthPointFirst(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    lambda0 = lambda, sinPhi0 = (0, _mathJs.sin)(phi), cosPhi0 = (0, _mathJs.cos)(phi);
    lengthStream.point = lengthPoint;
}
function lengthPoint(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    var sinPhi = (0, _mathJs.sin)(phi), cosPhi = (0, _mathJs.cos)(phi), delta = (0, _mathJs.abs)(lambda - lambda0), cosDelta = (0, _mathJs.cos)(delta), sinDelta = (0, _mathJs.sin)(delta), x = cosPhi * sinDelta, y = cosPhi0 * sinPhi - sinPhi0 * cosPhi * cosDelta, z = sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosDelta;
    lengthSum.add((0, _mathJs.atan2)((0, _mathJs.sqrt)(x * x + y * y), z));
    lambda0 = lambda, sinPhi0 = sinPhi, cosPhi0 = cosPhi;
}

},{"d3-array":"2G8br","./math.js":"hswBu","./noop.js":"bwHmr","./stream.js":"hAqHD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bJKKE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>graticule);
parcelHelpers.export(exports, "graticule10", ()=>graticule10);
var _d3Array = require("d3-array");
var _mathJs = require("./math.js");
function graticuleX(y0, y1, dy) {
    var y = (0, _d3Array.range)(y0, y1 - (0, _mathJs.epsilon), dy).concat(y1);
    return function(x) {
        return y.map(function(y) {
            return [
                x,
                y
            ];
        });
    };
}
function graticuleY(x0, x1, dx) {
    var x = (0, _d3Array.range)(x0, x1 - (0, _mathJs.epsilon), dx).concat(x1);
    return function(y) {
        return x.map(function(x) {
            return [
                x,
                y
            ];
        });
    };
}
function graticule() {
    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
    function graticule() {
        return {
            type: "MultiLineString",
            coordinates: lines()
        };
    }
    function lines() {
        return (0, _d3Array.range)((0, _mathJs.ceil)(X0 / DX) * DX, X1, DX).map(X).concat((0, _d3Array.range)((0, _mathJs.ceil)(Y0 / DY) * DY, Y1, DY).map(Y)).concat((0, _d3Array.range)((0, _mathJs.ceil)(x0 / dx) * dx, x1, dx).filter(function(x) {
            return (0, _mathJs.abs)(x % DX) > (0, _mathJs.epsilon);
        }).map(x)).concat((0, _d3Array.range)((0, _mathJs.ceil)(y0 / dy) * dy, y1, dy).filter(function(y) {
            return (0, _mathJs.abs)(y % DY) > (0, _mathJs.epsilon);
        }).map(y));
    }
    graticule.lines = function() {
        return lines().map(function(coordinates) {
            return {
                type: "LineString",
                coordinates: coordinates
            };
        });
    };
    graticule.outline = function() {
        return {
            type: "Polygon",
            coordinates: [
                X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1))
            ]
        };
    };
    graticule.extent = function(_) {
        if (!arguments.length) return graticule.extentMinor();
        return graticule.extentMajor(_).extentMinor(_);
    };
    graticule.extentMajor = function(_) {
        if (!arguments.length) return [
            [
                X0,
                Y0
            ],
            [
                X1,
                Y1
            ]
        ];
        X0 = +_[0][0], X1 = +_[1][0];
        Y0 = +_[0][1], Y1 = +_[1][1];
        if (X0 > X1) _ = X0, X0 = X1, X1 = _;
        if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
        return graticule.precision(precision);
    };
    graticule.extentMinor = function(_) {
        if (!arguments.length) return [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
        x0 = +_[0][0], x1 = +_[1][0];
        y0 = +_[0][1], y1 = +_[1][1];
        if (x0 > x1) _ = x0, x0 = x1, x1 = _;
        if (y0 > y1) _ = y0, y0 = y1, y1 = _;
        return graticule.precision(precision);
    };
    graticule.step = function(_) {
        if (!arguments.length) return graticule.stepMinor();
        return graticule.stepMajor(_).stepMinor(_);
    };
    graticule.stepMajor = function(_) {
        if (!arguments.length) return [
            DX,
            DY
        ];
        DX = +_[0], DY = +_[1];
        return graticule;
    };
    graticule.stepMinor = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        dx = +_[0], dy = +_[1];
        return graticule;
    };
    graticule.precision = function(_) {
        if (!arguments.length) return precision;
        precision = +_;
        x = graticuleX(y0, y1, 90);
        y = graticuleY(x0, x1, precision);
        X = graticuleX(Y0, Y1, 90);
        Y = graticuleY(X0, X1, precision);
        return graticule;
    };
    return graticule.extentMajor([
        [
            -180,
            -90 + (0, _mathJs.epsilon)
        ],
        [
            180,
            90 - (0, _mathJs.epsilon)
        ]
    ]).extentMinor([
        [
            -180,
            -80 - (0, _mathJs.epsilon)
        ],
        [
            180,
            80 + (0, _mathJs.epsilon)
        ]
    ]);
}
function graticule10() {
    return graticule()();
}

},{"d3-array":[["range","fkSdr","default"]],"./math.js":"hswBu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a1PWF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var x0 = a[0] * (0, _mathJs.radians), y0 = a[1] * (0, _mathJs.radians), x1 = b[0] * (0, _mathJs.radians), y1 = b[1] * (0, _mathJs.radians), cy0 = (0, _mathJs.cos)(y0), sy0 = (0, _mathJs.sin)(y0), cy1 = (0, _mathJs.cos)(y1), sy1 = (0, _mathJs.sin)(y1), kx0 = cy0 * (0, _mathJs.cos)(x0), ky0 = cy0 * (0, _mathJs.sin)(x0), kx1 = cy1 * (0, _mathJs.cos)(x1), ky1 = cy1 * (0, _mathJs.sin)(x1), d = 2 * (0, _mathJs.asin)((0, _mathJs.sqrt)((0, _mathJs.haversin)(y1 - y0) + cy0 * cy1 * (0, _mathJs.haversin)(x1 - x0))), k = (0, _mathJs.sin)(d);
        var interpolate = d ? function(t) {
            var B = (0, _mathJs.sin)(t *= d) / k, A = (0, _mathJs.sin)(d - t) / k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
            return [
                (0, _mathJs.atan2)(y, x) * (0, _mathJs.degrees),
                (0, _mathJs.atan2)(z, (0, _mathJs.sqrt)(x * x + y * y)) * (0, _mathJs.degrees)
            ];
        } : function() {
            return [
                x0 * (0, _mathJs.degrees),
                y0 * (0, _mathJs.degrees)
            ];
        };
        interpolate.distance = d;
        return interpolate;
    });
var _mathJs = require("./math.js");

},{"./math.js":"hswBu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"funLc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(projection, context) {
        let digits = 3, pointRadius = 4.5, projectionStream, contextStream;
        function path(object) {
            if (object) {
                if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
                (0, _streamJsDefault.default)(object, projectionStream(contextStream));
            }
            return contextStream.result();
        }
        path.area = function(object) {
            (0, _streamJsDefault.default)(object, projectionStream((0, _areaJsDefault.default)));
            return (0, _areaJsDefault.default).result();
        };
        path.measure = function(object) {
            (0, _streamJsDefault.default)(object, projectionStream((0, _measureJsDefault.default)));
            return (0, _measureJsDefault.default).result();
        };
        path.bounds = function(object) {
            (0, _streamJsDefault.default)(object, projectionStream((0, _boundsJsDefault.default)));
            return (0, _boundsJsDefault.default).result();
        };
        path.centroid = function(object) {
            (0, _streamJsDefault.default)(object, projectionStream((0, _centroidJsDefault.default)));
            return (0, _centroidJsDefault.default).result();
        };
        path.projection = function(_) {
            if (!arguments.length) return projection;
            projectionStream = _ == null ? (projection = null, _identityJsDefault.default) : (projection = _).stream;
            return path;
        };
        path.context = function(_) {
            if (!arguments.length) return context;
            contextStream = _ == null ? (context = null, new (0, _stringJsDefault.default)(digits)) : new (0, _contextJsDefault.default)(context = _);
            if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
            return path;
        };
        path.pointRadius = function(_) {
            if (!arguments.length) return pointRadius;
            pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
            return path;
        };
        path.digits = function(_) {
            if (!arguments.length) return digits;
            if (_ == null) digits = null;
            else {
                const d = Math.floor(_);
                if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
                digits = d;
            }
            if (context === null) contextStream = new (0, _stringJsDefault.default)(digits);
            return path;
        };
        return path.projection(projection).digits(digits).context(context);
    });
var _identityJs = require("../identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _streamJs = require("../stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _boundsJs = require("./bounds.js");
var _boundsJsDefault = parcelHelpers.interopDefault(_boundsJs);
var _centroidJs = require("./centroid.js");
var _centroidJsDefault = parcelHelpers.interopDefault(_centroidJs);
var _contextJs = require("./context.js");
var _contextJsDefault = parcelHelpers.interopDefault(_contextJs);
var _measureJs = require("./measure.js");
var _measureJsDefault = parcelHelpers.interopDefault(_measureJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);

},{"../identity.js":"gpb1g","../stream.js":"hAqHD","./area.js":"4cqHY","./bounds.js":"2k57R","./centroid.js":"d8ydg","./context.js":"5yul9","./measure.js":"8wEvG","./string.js":"16pyK","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gpb1g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4cqHY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _d3Array = require("d3-array");
var _mathJs = require("../math.js");
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var areaSum = new (0, _d3Array.Adder)(), areaRingSum = new (0, _d3Array.Adder)(), x00, y00, x0, y0;
var areaStream = {
    point: (0, _noopJsDefault.default),
    lineStart: (0, _noopJsDefault.default),
    lineEnd: (0, _noopJsDefault.default),
    polygonStart: function() {
        areaStream.lineStart = areaRingStart;
        areaStream.lineEnd = areaRingEnd;
    },
    polygonEnd: function() {
        areaStream.lineStart = areaStream.lineEnd = areaStream.point = (0, _noopJsDefault.default);
        areaSum.add((0, _mathJs.abs)(areaRingSum));
        areaRingSum = new (0, _d3Array.Adder)();
    },
    result: function() {
        var area = areaSum / 2;
        areaSum = new (0, _d3Array.Adder)();
        return area;
    }
};
function areaRingStart() {
    areaStream.point = areaPointFirst;
}
function areaPointFirst(x, y) {
    areaStream.point = areaPoint;
    x00 = x0 = x, y00 = y0 = y;
}
function areaPoint(x, y) {
    areaRingSum.add(y0 * x - x0 * y);
    x0 = x, y0 = y;
}
function areaRingEnd() {
    areaPoint(x00, y00);
}
exports.default = areaStream;

},{"d3-array":"2G8br","../math.js":"hswBu","../noop.js":"bwHmr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2k57R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var x0 = Infinity, y0 = x0, x1 = -x0, y1 = x1;
var boundsStream = {
    point: boundsPoint,
    lineStart: (0, _noopJsDefault.default),
    lineEnd: (0, _noopJsDefault.default),
    polygonStart: (0, _noopJsDefault.default),
    polygonEnd: (0, _noopJsDefault.default),
    result: function() {
        var bounds = [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
        x1 = y1 = -(y0 = x0 = Infinity);
        return bounds;
    }
};
function boundsPoint(x, y) {
    if (x < x0) x0 = x;
    if (x > x1) x1 = x;
    if (y < y0) y0 = y;
    if (y > y1) y1 = y;
}
exports.default = boundsStream;

},{"../noop.js":"bwHmr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d8ydg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
// TODO Enforce positive area for exterior, negative area for interior?
var X0 = 0, Y0 = 0, Z0 = 0, X1 = 0, Y1 = 0, Z1 = 0, X2 = 0, Y2 = 0, Z2 = 0, x00, y00, x0, y0;
var centroidStream = {
    point: centroidPoint,
    lineStart: centroidLineStart,
    lineEnd: centroidLineEnd,
    polygonStart: function() {
        centroidStream.lineStart = centroidRingStart;
        centroidStream.lineEnd = centroidRingEnd;
    },
    polygonEnd: function() {
        centroidStream.point = centroidPoint;
        centroidStream.lineStart = centroidLineStart;
        centroidStream.lineEnd = centroidLineEnd;
    },
    result: function() {
        var centroid = Z2 ? [
            X2 / Z2,
            Y2 / Z2
        ] : Z1 ? [
            X1 / Z1,
            Y1 / Z1
        ] : Z0 ? [
            X0 / Z0,
            Y0 / Z0
        ] : [
            NaN,
            NaN
        ];
        X0 = Y0 = Z0 = X1 = Y1 = Z1 = X2 = Y2 = Z2 = 0;
        return centroid;
    }
};
function centroidPoint(x, y) {
    X0 += x;
    Y0 += y;
    ++Z0;
}
function centroidLineStart() {
    centroidStream.point = centroidPointFirstLine;
}
function centroidPointFirstLine(x, y) {
    centroidStream.point = centroidPointLine;
    centroidPoint(x0 = x, y0 = y);
}
function centroidPointLine(x, y) {
    var dx = x - x0, dy = y - y0, z = (0, _mathJs.sqrt)(dx * dx + dy * dy);
    X1 += z * (x0 + x) / 2;
    Y1 += z * (y0 + y) / 2;
    Z1 += z;
    centroidPoint(x0 = x, y0 = y);
}
function centroidLineEnd() {
    centroidStream.point = centroidPoint;
}
function centroidRingStart() {
    centroidStream.point = centroidPointFirstRing;
}
function centroidRingEnd() {
    centroidPointRing(x00, y00);
}
function centroidPointFirstRing(x, y) {
    centroidStream.point = centroidPointRing;
    centroidPoint(x00 = x0 = x, y00 = y0 = y);
}
function centroidPointRing(x, y) {
    var dx = x - x0, dy = y - y0, z = (0, _mathJs.sqrt)(dx * dx + dy * dy);
    X1 += z * (x0 + x) / 2;
    Y1 += z * (y0 + y) / 2;
    Z1 += z;
    z = y0 * x - x0 * y;
    X2 += z * (x0 + x);
    Y2 += z * (y0 + y);
    Z2 += z * 3;
    centroidPoint(x0 = x, y0 = y);
}
exports.default = centroidStream;

},{"../math.js":"hswBu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5yul9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PathContext);
var _mathJs = require("../math.js");
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
function PathContext(context) {
    this._context = context;
}
PathContext.prototype = {
    _radius: 4.5,
    pointRadius: function(_) {
        return this._radius = _, this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._context.closePath();
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._context.moveTo(x, y);
                this._point = 1;
                break;
            case 1:
                this._context.lineTo(x, y);
                break;
            default:
                this._context.moveTo(x + this._radius, y);
                this._context.arc(x, y, this._radius, 0, (0, _mathJs.tau));
                break;
        }
    },
    result: (0, _noopJsDefault.default)
};

},{"../math.js":"hswBu","../noop.js":"bwHmr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8wEvG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _d3Array = require("d3-array");
var _mathJs = require("../math.js");
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var lengthSum = new (0, _d3Array.Adder)(), lengthRing, x00, y00, x0, y0;
var lengthStream = {
    point: (0, _noopJsDefault.default),
    lineStart: function() {
        lengthStream.point = lengthPointFirst;
    },
    lineEnd: function() {
        if (lengthRing) lengthPoint(x00, y00);
        lengthStream.point = (0, _noopJsDefault.default);
    },
    polygonStart: function() {
        lengthRing = true;
    },
    polygonEnd: function() {
        lengthRing = null;
    },
    result: function() {
        var length = +lengthSum;
        lengthSum = new (0, _d3Array.Adder)();
        return length;
    }
};
function lengthPointFirst(x, y) {
    lengthStream.point = lengthPoint;
    x00 = x0 = x, y00 = y0 = y;
}
function lengthPoint(x, y) {
    x0 -= x, y0 -= y;
    lengthSum.add((0, _mathJs.sqrt)(x0 * x0 + y0 * y0));
    x0 = x, y0 = y;
}
exports.default = lengthStream;

},{"d3-array":"2G8br","../math.js":"hswBu","../noop.js":"bwHmr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"16pyK":[function(require,module,exports,__globalThis) {
// Simple caching for constant-radius points.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let cacheDigits, cacheAppend, cacheRadius, cacheCircle;
class PathString {
    constructor(digits){
        this._append = digits == null ? append : appendRound(digits);
        this._radius = 4.5;
        this._ = "";
    }
    pointRadius(_) {
        this._radius = +_;
        return this;
    }
    polygonStart() {
        this._line = 0;
    }
    polygonEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line === 0) this._ += "Z";
        this._point = NaN;
    }
    point(x, y) {
        switch(this._point){
            case 0:
                this._append`M${x},${y}`;
                this._point = 1;
                break;
            case 1:
                this._append`L${x},${y}`;
                break;
            default:
                this._append`M${x},${y}`;
                if (this._radius !== cacheRadius || this._append !== cacheAppend) {
                    const r = this._radius;
                    const s = this._;
                    this._ = ""; // stash the old string so we can cache the circle path fragment
                    this._append`m0,${r}a${r},${r} 0 1,1 0,${-2 * r}a${r},${r} 0 1,1 0,${2 * r}z`;
                    cacheRadius = r;
                    cacheAppend = this._append;
                    cacheCircle = this._;
                    this._ = s;
                }
                this._ += cacheCircle;
                break;
        }
    }
    result() {
        const result = this._;
        this._ = "";
        return result.length ? result : null;
    }
}
exports.default = PathString;
function append(strings) {
    let i = 1;
    this._ += strings[0];
    for(const j = strings.length; i < j; ++i)this._ += arguments[i] + strings[i];
}
function appendRound(digits) {
    const d = Math.floor(digits);
    if (!(d >= 0)) throw new RangeError(`invalid digits: ${digits}`);
    if (d > 15) return append;
    if (d !== cacheDigits) {
        const k = 10 ** d;
        cacheDigits = d;
        cacheAppend = function append(strings) {
            let i = 1;
            this._ += strings[0];
            for(const j = strings.length; i < j; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
        };
    }
    return cacheAppend;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gVkNI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _conicEqualAreaJsDefault.default)().parallels([
            29.5,
            45.5
        ]).scale(1070).translate([
            480,
            250
        ]).rotate([
            96,
            0
        ]).center([
            -0.6,
            38.7
        ]);
    });
var _conicEqualAreaJs = require("./conicEqualArea.js");
var _conicEqualAreaJsDefault = parcelHelpers.interopDefault(_conicEqualAreaJs);

},{"./conicEqualArea.js":"84dLC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"84dLC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "conicEqualAreaRaw", ()=>conicEqualAreaRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _conicJs.conicProjection)(conicEqualAreaRaw).scale(155.424).center([
            0,
            33.6442
        ]);
    });
var _mathJs = require("../math.js");
var _conicJs = require("./conic.js");
var _cylindricalEqualAreaJs = require("./cylindricalEqualArea.js");
function conicEqualAreaRaw(y0, y1) {
    var sy0 = (0, _mathJs.sin)(y0), n = (sy0 + (0, _mathJs.sin)(y1)) / 2;
    // Are the parallels symmetrical around the Equator?
    if ((0, _mathJs.abs)(n) < (0, _mathJs.epsilon)) return (0, _cylindricalEqualAreaJs.cylindricalEqualAreaRaw)(y0);
    var c = 1 + sy0 * (2 * n - sy0), r0 = (0, _mathJs.sqrt)(c) / n;
    function project(x, y) {
        var r = (0, _mathJs.sqrt)(c - 2 * n * (0, _mathJs.sin)(y)) / n;
        return [
            r * (0, _mathJs.sin)(x *= n),
            r0 - r * (0, _mathJs.cos)(x)
        ];
    }
    project.invert = function(x, y) {
        var r0y = r0 - y, l = (0, _mathJs.atan2)(x, (0, _mathJs.abs)(r0y)) * (0, _mathJs.sign)(r0y);
        if (r0y * n < 0) l -= (0, _mathJs.pi) * (0, _mathJs.sign)(x) * (0, _mathJs.sign)(r0y);
        return [
            l / n,
            (0, _mathJs.asin)((c - (x * x + r0y * r0y) * n * n) / (2 * n))
        ];
    };
    return project;
}

},{"../math.js":"hswBu","./conic.js":"dYBWc","./cylindricalEqualArea.js":"1c2m0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dYBWc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "conicProjection", ()=>conicProjection);
var _mathJs = require("../math.js");
var _indexJs = require("./index.js");
function conicProjection(projectAt) {
    var phi0 = 0, phi1 = (0, _mathJs.pi) / 3, m = (0, _indexJs.projectionMutator)(projectAt), p = m(phi0, phi1);
    p.parallels = function(_) {
        return arguments.length ? m(phi0 = _[0] * (0, _mathJs.radians), phi1 = _[1] * (0, _mathJs.radians)) : [
            phi0 * (0, _mathJs.degrees),
            phi1 * (0, _mathJs.degrees)
        ];
    };
    return p;
}

},{"../math.js":"hswBu","./index.js":"jabgC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jabgC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>projection);
parcelHelpers.export(exports, "projectionMutator", ()=>projectionMutator);
var _antimeridianJs = require("../clip/antimeridian.js");
var _antimeridianJsDefault = parcelHelpers.interopDefault(_antimeridianJs);
var _circleJs = require("../clip/circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _rectangleJs = require("../clip/rectangle.js");
var _rectangleJsDefault = parcelHelpers.interopDefault(_rectangleJs);
var _composeJs = require("../compose.js");
var _composeJsDefault = parcelHelpers.interopDefault(_composeJs);
var _identityJs = require("../identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _mathJs = require("../math.js");
var _rotationJs = require("../rotation.js");
var _transformJs = require("../transform.js");
var _fitJs = require("./fit.js");
var _resampleJs = require("./resample.js");
var _resampleJsDefault = parcelHelpers.interopDefault(_resampleJs);
var transformRadians = (0, _transformJs.transformer)({
    point: function(x, y) {
        this.stream.point(x * (0, _mathJs.radians), y * (0, _mathJs.radians));
    }
});
function transformRotate(rotate) {
    return (0, _transformJs.transformer)({
        point: function(x, y) {
            var r = rotate(x, y);
            return this.stream.point(r[0], r[1]);
        }
    });
}
function scaleTranslate(k, dx, dy, sx, sy) {
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            dx + k * x,
            dy - k * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            (x - dx) / k * sx,
            (dy - y) / k * sy
        ];
    };
    return transform;
}
function scaleTranslateRotate(k, dx, dy, sx, sy, alpha) {
    if (!alpha) return scaleTranslate(k, dx, dy, sx, sy);
    var cosAlpha = (0, _mathJs.cos)(alpha), sinAlpha = (0, _mathJs.sin)(alpha), a = cosAlpha * k, b = sinAlpha * k, ai = cosAlpha / k, bi = sinAlpha / k, ci = (sinAlpha * dy - cosAlpha * dx) / k, fi = (sinAlpha * dx + cosAlpha * dy) / k;
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            a * x - b * y + dx,
            dy - b * x - a * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            sx * (ai * x - bi * y + ci),
            sy * (fi - bi * x - ai * y)
        ];
    };
    return transform;
}
function projection(project) {
    return projectionMutator(function() {
        return project;
    })();
}
function projectionMutator(projectAt) {
    var project, k = 150, x = 480, y = 250, lambda = 0, phi = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, alpha = 0, sx = 1, sy = 1, theta = null, preclip = (0, _antimeridianJsDefault.default), x0 = null, y0, x1, y1, postclip = (0, _identityJsDefault.default), delta2 = 0.5, projectResample, projectTransform, projectRotateTransform, cache, cacheStream;
    function projection(point) {
        return projectRotateTransform(point[0] * (0, _mathJs.radians), point[1] * (0, _mathJs.radians));
    }
    function invert(point) {
        point = projectRotateTransform.invert(point[0], point[1]);
        return point && [
            point[0] * (0, _mathJs.degrees),
            point[1] * (0, _mathJs.degrees)
        ];
    }
    projection.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
    };
    projection.preclip = function(_) {
        return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
    };
    projection.postclip = function(_) {
        return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    };
    projection.clipAngle = function(_) {
        return arguments.length ? (preclip = +_ ? (0, _circleJsDefault.default)(theta = _ * (0, _mathJs.radians)) : (theta = null, _antimeridianJsDefault.default), reset()) : theta * (0, _mathJs.degrees);
    };
    projection.clipExtent = function(_) {
        return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, _identityJsDefault.default) : (0, _rectangleJsDefault.default)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    projection.scale = function(_) {
        return arguments.length ? (k = +_, recenter()) : k;
    };
    projection.translate = function(_) {
        return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [
            x,
            y
        ];
    };
    projection.center = function(_) {
        return arguments.length ? (lambda = _[0] % 360 * (0, _mathJs.radians), phi = _[1] % 360 * (0, _mathJs.radians), recenter()) : [
            lambda * (0, _mathJs.degrees),
            phi * (0, _mathJs.degrees)
        ];
    };
    projection.rotate = function(_) {
        return arguments.length ? (deltaLambda = _[0] % 360 * (0, _mathJs.radians), deltaPhi = _[1] % 360 * (0, _mathJs.radians), deltaGamma = _.length > 2 ? _[2] % 360 * (0, _mathJs.radians) : 0, recenter()) : [
            deltaLambda * (0, _mathJs.degrees),
            deltaPhi * (0, _mathJs.degrees),
            deltaGamma * (0, _mathJs.degrees)
        ];
    };
    projection.angle = function(_) {
        return arguments.length ? (alpha = _ % 360 * (0, _mathJs.radians), recenter()) : alpha * (0, _mathJs.degrees);
    };
    projection.reflectX = function(_) {
        return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
    };
    projection.reflectY = function(_) {
        return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
    };
    projection.precision = function(_) {
        return arguments.length ? (projectResample = (0, _resampleJsDefault.default)(projectTransform, delta2 = _ * _), reset()) : (0, _mathJs.sqrt)(delta2);
    };
    projection.fitExtent = function(extent, object) {
        return (0, _fitJs.fitExtent)(projection, extent, object);
    };
    projection.fitSize = function(size, object) {
        return (0, _fitJs.fitSize)(projection, size, object);
    };
    projection.fitWidth = function(width, object) {
        return (0, _fitJs.fitWidth)(projection, width, object);
    };
    projection.fitHeight = function(height, object) {
        return (0, _fitJs.fitHeight)(projection, height, object);
    };
    function recenter() {
        var center = scaleTranslateRotate(k, 0, 0, sx, sy, alpha).apply(null, project(lambda, phi)), transform = scaleTranslateRotate(k, x - center[0], y - center[1], sx, sy, alpha);
        rotate = (0, _rotationJs.rotateRadians)(deltaLambda, deltaPhi, deltaGamma);
        projectTransform = (0, _composeJsDefault.default)(project, transform);
        projectRotateTransform = (0, _composeJsDefault.default)(rotate, projectTransform);
        projectResample = (0, _resampleJsDefault.default)(projectTransform, delta2);
        return reset();
    }
    function reset() {
        cache = cacheStream = null;
        return projection;
    }
    return function() {
        project = projectAt.apply(this, arguments);
        projection.invert = project.invert && invert;
        return recenter();
    };
}

},{"../clip/antimeridian.js":"bpOyZ","../clip/circle.js":"8GPcP","../clip/rectangle.js":"hgkNK","../compose.js":"2iAT7","../identity.js":"gpb1g","../math.js":"hswBu","../rotation.js":"ka8Fr","../transform.js":"2cPnh","./fit.js":"8wphn","./resample.js":"l0Yg4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2cPnh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(methods) {
        return {
            stream: transformer(methods)
        };
    });
parcelHelpers.export(exports, "transformer", ()=>transformer);
function transformer(methods) {
    return function(stream) {
        var s = new TransformStream;
        for(var key in methods)s[key] = methods[key];
        s.stream = stream;
        return s;
    };
}
function TransformStream() {}
TransformStream.prototype = {
    constructor: TransformStream,
    point: function(x, y) {
        this.stream.point(x, y);
    },
    sphere: function() {
        this.stream.sphere();
    },
    lineStart: function() {
        this.stream.lineStart();
    },
    lineEnd: function() {
        this.stream.lineEnd();
    },
    polygonStart: function() {
        this.stream.polygonStart();
    },
    polygonEnd: function() {
        this.stream.polygonEnd();
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8wphn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fitExtent", ()=>fitExtent);
parcelHelpers.export(exports, "fitSize", ()=>fitSize);
parcelHelpers.export(exports, "fitWidth", ()=>fitWidth);
parcelHelpers.export(exports, "fitHeight", ()=>fitHeight);
var _streamJs = require("../stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var _boundsJs = require("../path/bounds.js");
var _boundsJsDefault = parcelHelpers.interopDefault(_boundsJs);
function fit(projection, fitBounds, object) {
    var clip = projection.clipExtent && projection.clipExtent();
    projection.scale(150).translate([
        0,
        0
    ]);
    if (clip != null) projection.clipExtent(null);
    (0, _streamJsDefault.default)(object, projection.stream((0, _boundsJsDefault.default)));
    fitBounds((0, _boundsJsDefault.default).result());
    if (clip != null) projection.clipExtent(clip);
    return projection;
}
function fitExtent(projection, extent, object) {
    return fit(projection, function(b) {
        var w = extent[1][0] - extent[0][0], h = extent[1][1] - extent[0][1], k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])), x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2, y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function fitSize(projection, size, object) {
    return fitExtent(projection, [
        [
            0,
            0
        ],
        size
    ], object);
}
function fitWidth(projection, width, object) {
    return fit(projection, function(b) {
        var w = +width, k = w / (b[1][0] - b[0][0]), x = (w - k * (b[1][0] + b[0][0])) / 2, y = -k * b[0][1];
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function fitHeight(projection, height, object) {
    return fit(projection, function(b) {
        var h = +height, k = h / (b[1][1] - b[0][1]), x = -k * b[0][0], y = (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}

},{"../stream.js":"hAqHD","../path/bounds.js":"2k57R","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l0Yg4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(project, delta2) {
        return +delta2 ? resample(project, delta2) : resampleNone(project);
    });
var _cartesianJs = require("../cartesian.js");
var _mathJs = require("../math.js");
var _transformJs = require("../transform.js");
var maxDepth = 16, cosMinDistance = (0, _mathJs.cos)(30 * (0, _mathJs.radians)); // cos(minimum angular distance)
function resampleNone(project) {
    return (0, _transformJs.transformer)({
        point: function(x, y) {
            x = project(x, y);
            this.stream.point(x[0], x[1]);
        }
    });
}
function resample(project, delta2) {
    function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
        var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
        if (d2 > 4 * delta2 && depth--) {
            var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = (0, _mathJs.sqrt)(a * a + b * b + c * c), phi2 = (0, _mathJs.asin)(c /= m), lambda2 = (0, _mathJs.abs)((0, _mathJs.abs)(c) - 1) < (0, _mathJs.epsilon) || (0, _mathJs.abs)(lambda0 - lambda1) < (0, _mathJs.epsilon) ? (lambda0 + lambda1) / 2 : (0, _mathJs.atan2)(b, a), p = project(lambda2, phi2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
            if (dz * dz / d2 > delta2 // perpendicular projected distance
             || (0, _mathJs.abs)((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
             || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
                resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
                stream.point(x2, y2);
                resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
            }
        }
    }
    return function(stream) {
        var lambda00, x00, y00, a00, b00, c00, lambda0, x0, y0, a0, b0, c0; // previous point
        var resampleStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                stream.polygonStart();
                resampleStream.lineStart = ringStart;
            },
            polygonEnd: function() {
                stream.polygonEnd();
                resampleStream.lineStart = lineStart;
            }
        };
        function point(x, y) {
            x = project(x, y);
            stream.point(x[0], x[1]);
        }
        function lineStart() {
            x0 = NaN;
            resampleStream.point = linePoint;
            stream.lineStart();
        }
        function linePoint(lambda, phi) {
            var c = (0, _cartesianJs.cartesian)([
                lambda,
                phi
            ]), p = project(lambda, phi);
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
            stream.point(x0, y0);
        }
        function lineEnd() {
            resampleStream.point = point;
            stream.lineEnd();
        }
        function ringStart() {
            lineStart();
            resampleStream.point = ringPoint;
            resampleStream.lineEnd = ringEnd;
        }
        function ringPoint(lambda, phi) {
            linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
            resampleStream.point = linePoint;
        }
        function ringEnd() {
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
            resampleStream.lineEnd = lineEnd;
            lineEnd();
        }
        return resampleStream;
    };
}

},{"../cartesian.js":"90jyE","../math.js":"hswBu","../transform.js":"2cPnh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1c2m0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cylindricalEqualAreaRaw", ()=>cylindricalEqualAreaRaw);
var _mathJs = require("../math.js");
function cylindricalEqualAreaRaw(phi0) {
    var cosPhi0 = (0, _mathJs.cos)(phi0);
    function forward(lambda, phi) {
        return [
            lambda * cosPhi0,
            (0, _mathJs.sin)(phi) / cosPhi0
        ];
    }
    forward.invert = function(x, y) {
        return [
            x / cosPhi0,
            (0, _mathJs.asin)(y * cosPhi0)
        ];
    };
    return forward;
}

},{"../math.js":"hswBu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kKmvt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// A composite projection for the United States, configured by default for
// 960×500. The projection also works quite well at 960×600 if you change the
// scale to 1285 and adjust the translate accordingly. The set of standard
// parallels for each region comes from USGS, which is published here:
// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
parcelHelpers.export(exports, "default", ()=>function() {
        var cache, cacheStream, lower48 = (0, _albersJsDefault.default)(), lower48Point, alaska = (0, _conicEqualAreaJsDefault.default)().rotate([
            154,
            0
        ]).center([
            -2,
            58.5
        ]).parallels([
            55,
            65
        ]), alaskaPoint, hawaii = (0, _conicEqualAreaJsDefault.default)().rotate([
            157,
            0
        ]).center([
            -3,
            19.9
        ]).parallels([
            8,
            18
        ]), hawaiiPoint, point, pointStream = {
            point: function(x, y) {
                point = [
                    x,
                    y
                ];
            }
        };
        function albersUsa(coordinates) {
            var x = coordinates[0], y = coordinates[1];
            return point = null, (lower48Point.point(x, y), point) || (alaskaPoint.point(x, y), point) || (hawaiiPoint.point(x, y), point);
        }
        albersUsa.invert = function(coordinates) {
            var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
            return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : lower48).invert(coordinates);
        };
        albersUsa.stream = function(stream) {
            return cache && cacheStream === stream ? cache : cache = multiplex([
                lower48.stream(cacheStream = stream),
                alaska.stream(stream),
                hawaii.stream(stream)
            ]);
        };
        albersUsa.precision = function(_) {
            if (!arguments.length) return lower48.precision();
            lower48.precision(_), alaska.precision(_), hawaii.precision(_);
            return reset();
        };
        albersUsa.scale = function(_) {
            if (!arguments.length) return lower48.scale();
            lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
            return albersUsa.translate(lower48.translate());
        };
        albersUsa.translate = function(_) {
            if (!arguments.length) return lower48.translate();
            var k = lower48.scale(), x = +_[0], y = +_[1];
            lower48Point = lower48.translate(_).clipExtent([
                [
                    x - 0.455 * k,
                    y - 0.238 * k
                ],
                [
                    x + 0.455 * k,
                    y + 0.238 * k
                ]
            ]).stream(pointStream);
            alaskaPoint = alaska.translate([
                x - 0.307 * k,
                y + 0.201 * k
            ]).clipExtent([
                [
                    x - 0.425 * k + (0, _mathJs.epsilon),
                    y + 0.120 * k + (0, _mathJs.epsilon)
                ],
                [
                    x - 0.214 * k - (0, _mathJs.epsilon),
                    y + 0.234 * k - (0, _mathJs.epsilon)
                ]
            ]).stream(pointStream);
            hawaiiPoint = hawaii.translate([
                x - 0.205 * k,
                y + 0.212 * k
            ]).clipExtent([
                [
                    x - 0.214 * k + (0, _mathJs.epsilon),
                    y + 0.166 * k + (0, _mathJs.epsilon)
                ],
                [
                    x - 0.115 * k - (0, _mathJs.epsilon),
                    y + 0.234 * k - (0, _mathJs.epsilon)
                ]
            ]).stream(pointStream);
            return reset();
        };
        albersUsa.fitExtent = function(extent, object) {
            return (0, _fitJs.fitExtent)(albersUsa, extent, object);
        };
        albersUsa.fitSize = function(size, object) {
            return (0, _fitJs.fitSize)(albersUsa, size, object);
        };
        albersUsa.fitWidth = function(width, object) {
            return (0, _fitJs.fitWidth)(albersUsa, width, object);
        };
        albersUsa.fitHeight = function(height, object) {
            return (0, _fitJs.fitHeight)(albersUsa, height, object);
        };
        function reset() {
            cache = cacheStream = null;
            return albersUsa;
        }
        return albersUsa.scale(1070);
    });
var _mathJs = require("../math.js");
var _albersJs = require("./albers.js");
var _albersJsDefault = parcelHelpers.interopDefault(_albersJs);
var _conicEqualAreaJs = require("./conicEqualArea.js");
var _conicEqualAreaJsDefault = parcelHelpers.interopDefault(_conicEqualAreaJs);
var _fitJs = require("./fit.js");
// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function multiplex(streams) {
    var n = streams.length;
    return {
        point: function(x, y) {
            var i = -1;
            while(++i < n)streams[i].point(x, y);
        },
        sphere: function() {
            var i = -1;
            while(++i < n)streams[i].sphere();
        },
        lineStart: function() {
            var i = -1;
            while(++i < n)streams[i].lineStart();
        },
        lineEnd: function() {
            var i = -1;
            while(++i < n)streams[i].lineEnd();
        },
        polygonStart: function() {
            var i = -1;
            while(++i < n)streams[i].polygonStart();
        },
        polygonEnd: function() {
            var i = -1;
            while(++i < n)streams[i].polygonEnd();
        }
    };
}

},{"../math.js":"hswBu","./albers.js":"gVkNI","./conicEqualArea.js":"84dLC","./fit.js":"8wphn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"agpPS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "azimuthalEqualAreaRaw", ()=>azimuthalEqualAreaRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(azimuthalEqualAreaRaw).scale(124.75).clipAngle(179.999);
    });
var _mathJs = require("../math.js");
var _azimuthalJs = require("./azimuthal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var azimuthalEqualAreaRaw = (0, _azimuthalJs.azimuthalRaw)(function(cxcy) {
    return (0, _mathJs.sqrt)(2 / (1 + cxcy));
});
azimuthalEqualAreaRaw.invert = (0, _azimuthalJs.azimuthalInvert)(function(z) {
    return 2 * (0, _mathJs.asin)(z / 2);
});

},{"../math.js":"hswBu","./azimuthal.js":"dlPcy","./index.js":"jabgC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dlPcy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "azimuthalRaw", ()=>azimuthalRaw);
parcelHelpers.export(exports, "azimuthalInvert", ()=>azimuthalInvert);
var _mathJs = require("../math.js");
function azimuthalRaw(scale) {
    return function(x, y) {
        var cx = (0, _mathJs.cos)(x), cy = (0, _mathJs.cos)(y), k = scale(cx * cy);
        if (k === Infinity) return [
            2,
            0
        ];
        return [
            k * cy * (0, _mathJs.sin)(x),
            k * (0, _mathJs.sin)(y)
        ];
    };
}
function azimuthalInvert(angle) {
    return function(x, y) {
        var z = (0, _mathJs.sqrt)(x * x + y * y), c = angle(z), sc = (0, _mathJs.sin)(c), cc = (0, _mathJs.cos)(c);
        return [
            (0, _mathJs.atan2)(x * sc, z * cc),
            (0, _mathJs.asin)(z && y * sc / z)
        ];
    };
}

},{"../math.js":"hswBu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1EsCY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "azimuthalEquidistantRaw", ()=>azimuthalEquidistantRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(azimuthalEquidistantRaw).scale(79.4188).clipAngle(179.999);
    });
var _mathJs = require("../math.js");
var _azimuthalJs = require("./azimuthal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var azimuthalEquidistantRaw = (0, _azimuthalJs.azimuthalRaw)(function(c) {
    return (c = (0, _mathJs.acos)(c)) && c / (0, _mathJs.sin)(c);
});
azimuthalEquidistantRaw.invert = (0, _azimuthalJs.azimuthalInvert)(function(z) {
    return z;
});

},{"../math.js":"hswBu","./azimuthal.js":"dlPcy","./index.js":"jabgC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d2zyE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "conicConformalRaw", ()=>conicConformalRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _conicJs.conicProjection)(conicConformalRaw).scale(109.5).parallels([
            30,
            30
        ]);
    });
var _mathJs = require("../math.js");
var _conicJs = require("./conic.js");
var _mercatorJs = require("./mercator.js");
function tany(y) {
    return (0, _mathJs.tan)(((0, _mathJs.halfPi) + y) / 2);
}
function conicConformalRaw(y0, y1) {
    var cy0 = (0, _mathJs.cos)(y0), n = y0 === y1 ? (0, _mathJs.sin)(y0) : (0, _mathJs.log)(cy0 / (0, _mathJs.cos)(y1)) / (0, _mathJs.log)(tany(y1) / tany(y0)), f = cy0 * (0, _mathJs.pow)(tany(y0), n) / n;
    if (!n) return 0, _mercatorJs.mercatorRaw;
    function project(x, y) {
        if (f > 0) {
            if (y < -(0, _mathJs.halfPi) + (0, _mathJs.epsilon)) y = -(0, _mathJs.halfPi) + (0, _mathJs.epsilon);
        } else if (y > (0, _mathJs.halfPi) - (0, _mathJs.epsilon)) y = (0, _mathJs.halfPi) - (0, _mathJs.epsilon);
        var r = f / (0, _mathJs.pow)(tany(y), n);
        return [
            r * (0, _mathJs.sin)(n * x),
            f - r * (0, _mathJs.cos)(n * x)
        ];
    }
    project.invert = function(x, y) {
        var fy = f - y, r = (0, _mathJs.sign)(n) * (0, _mathJs.sqrt)(x * x + fy * fy), l = (0, _mathJs.atan2)(x, (0, _mathJs.abs)(fy)) * (0, _mathJs.sign)(fy);
        if (fy * n < 0) l -= (0, _mathJs.pi) * (0, _mathJs.sign)(x) * (0, _mathJs.sign)(fy);
        return [
            l / n,
            2 * (0, _mathJs.atan)((0, _mathJs.pow)(f / r, 1 / n)) - (0, _mathJs.halfPi)
        ];
    };
    return project;
}

},{"../math.js":"hswBu","./conic.js":"dYBWc","./mercator.js":"awlzv","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"awlzv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mercatorRaw", ()=>mercatorRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return mercatorProjection(mercatorRaw).scale(961 / (0, _mathJs.tau));
    });
parcelHelpers.export(exports, "mercatorProjection", ()=>mercatorProjection);
var _mathJs = require("../math.js");
var _rotationJs = require("../rotation.js");
var _rotationJsDefault = parcelHelpers.interopDefault(_rotationJs);
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function mercatorRaw(lambda, phi) {
    return [
        lambda,
        (0, _mathJs.log)((0, _mathJs.tan)(((0, _mathJs.halfPi) + phi) / 2))
    ];
}
mercatorRaw.invert = function(x, y) {
    return [
        x,
        2 * (0, _mathJs.atan)((0, _mathJs.exp)(y)) - (0, _mathJs.halfPi)
    ];
};
function mercatorProjection(project) {
    var m = (0, _indexJsDefault.default)(project), center = m.center, scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, x0 = null, y0, x1, y1; // clip extent
    m.scale = function(_) {
        return arguments.length ? (scale(_), reclip()) : scale();
    };
    m.translate = function(_) {
        return arguments.length ? (translate(_), reclip()) : translate();
    };
    m.center = function(_) {
        return arguments.length ? (center(_), reclip()) : center();
    };
    m.clipExtent = function(_) {
        return arguments.length ? (_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reclip()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    function reclip() {
        var k = (0, _mathJs.pi) * scale(), t = m((0, _rotationJsDefault.default)(m.rotate()).invert([
            0,
            0
        ]));
        return clipExtent(x0 == null ? [
            [
                t[0] - k,
                t[1] - k
            ],
            [
                t[0] + k,
                t[1] + k
            ]
        ] : project === mercatorRaw ? [
            [
                Math.max(t[0] - k, x0),
                y0
            ],
            [
                Math.min(t[0] + k, x1),
                y1
            ]
        ] : [
            [
                x0,
                Math.max(t[1] - k, y0)
            ],
            [
                x1,
                Math.min(t[1] + k, y1)
            ]
        ]);
    }
    return reclip();
}

},{"../math.js":"hswBu","../rotation.js":"ka8Fr","./index.js":"jabgC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4pwTI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "conicEquidistantRaw", ()=>conicEquidistantRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _conicJs.conicProjection)(conicEquidistantRaw).scale(131.154).center([
            0,
            13.9389
        ]);
    });
var _mathJs = require("../math.js");
var _conicJs = require("./conic.js");
var _equirectangularJs = require("./equirectangular.js");
function conicEquidistantRaw(y0, y1) {
    var cy0 = (0, _mathJs.cos)(y0), n = y0 === y1 ? (0, _mathJs.sin)(y0) : (cy0 - (0, _mathJs.cos)(y1)) / (y1 - y0), g = cy0 / n + y0;
    if ((0, _mathJs.abs)(n) < (0, _mathJs.epsilon)) return 0, _equirectangularJs.equirectangularRaw;
    function project(x, y) {
        var gy = g - y, nx = n * x;
        return [
            gy * (0, _mathJs.sin)(nx),
            g - gy * (0, _mathJs.cos)(nx)
        ];
    }
    project.invert = function(x, y) {
        var gy = g - y, l = (0, _mathJs.atan2)(x, (0, _mathJs.abs)(gy)) * (0, _mathJs.sign)(gy);
        if (gy * n < 0) l -= (0, _mathJs.pi) * (0, _mathJs.sign)(x) * (0, _mathJs.sign)(gy);
        return [
            l / n,
            g - (0, _mathJs.sign)(n) * (0, _mathJs.sqrt)(x * x + gy * gy)
        ];
    };
    return project;
}

},{"../math.js":"hswBu","./conic.js":"dYBWc","./equirectangular.js":"ivpfD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ivpfD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "equirectangularRaw", ()=>equirectangularRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(equirectangularRaw).scale(152.63);
    });
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function equirectangularRaw(lambda, phi) {
    return [
        lambda,
        phi
    ];
}
equirectangularRaw.invert = equirectangularRaw;

},{"./index.js":"jabgC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3QHBT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "equalEarthRaw", ()=>equalEarthRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(equalEarthRaw).scale(177.158);
    });
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _mathJs = require("../math.js");
var A1 = 1.340264, A2 = -0.081106, A3 = 0.000893, A4 = 0.003796, M = (0, _mathJs.sqrt)(3) / 2, iterations = 12;
function equalEarthRaw(lambda, phi) {
    var l = (0, _mathJs.asin)(M * (0, _mathJs.sin)(phi)), l2 = l * l, l6 = l2 * l2 * l2;
    return [
        lambda * (0, _mathJs.cos)(l) / (M * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2))),
        l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2))
    ];
}
equalEarthRaw.invert = function(x, y) {
    var l = y, l2 = l * l, l6 = l2 * l2 * l2;
    for(var i = 0, delta, fy, fpy; i < iterations; ++i){
        fy = l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2)) - y;
        fpy = A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2);
        l -= delta = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
        if ((0, _mathJs.abs)(delta) < (0, _mathJs.epsilon2)) break;
    }
    return [
        M * x * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2)) / (0, _mathJs.cos)(l),
        (0, _mathJs.asin)((0, _mathJs.sin)(l) / M)
    ];
};

},{"./index.js":"jabgC","../math.js":"hswBu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8g2g8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gnomonicRaw", ()=>gnomonicRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(gnomonicRaw).scale(144.049).clipAngle(60);
    });
var _mathJs = require("../math.js");
var _azimuthalJs = require("./azimuthal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function gnomonicRaw(x, y) {
    var cy = (0, _mathJs.cos)(y), k = (0, _mathJs.cos)(x) * cy;
    return [
        cy * (0, _mathJs.sin)(x) / k,
        (0, _mathJs.sin)(y) / k
    ];
}
gnomonicRaw.invert = (0, _azimuthalJs.azimuthalInvert)((0, _mathJs.atan));

},{"../math.js":"hswBu","./azimuthal.js":"dlPcy","./index.js":"jabgC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3FhuX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, alpha = 0, ca, sa, x0 = null, y0, x1, y1, kx = 1, ky = 1, transform = (0, _transformJs.transformer)({
            point: function(x, y) {
                var p = projection([
                    x,
                    y
                ]);
                this.stream.point(p[0], p[1]);
            }
        }), postclip = (0, _identityJsDefault.default), cache, cacheStream;
        function reset() {
            kx = k * sx;
            ky = k * sy;
            cache = cacheStream = null;
            return projection;
        }
        function projection(p) {
            var x = p[0] * kx, y = p[1] * ky;
            if (alpha) {
                var t = y * ca - x * sa;
                x = x * ca + y * sa;
                y = t;
            }
            return [
                x + tx,
                y + ty
            ];
        }
        projection.invert = function(p) {
            var x = p[0] - tx, y = p[1] - ty;
            if (alpha) {
                var t = y * ca + x * sa;
                x = x * ca - y * sa;
                y = t;
            }
            return [
                x / kx,
                y / ky
            ];
        };
        projection.stream = function(stream) {
            return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
        };
        projection.postclip = function(_) {
            return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
        };
        projection.clipExtent = function(_) {
            return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, _identityJsDefault.default) : (0, _rectangleJsDefault.default)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        };
        projection.scale = function(_) {
            return arguments.length ? (k = +_, reset()) : k;
        };
        projection.translate = function(_) {
            return arguments.length ? (tx = +_[0], ty = +_[1], reset()) : [
                tx,
                ty
            ];
        };
        projection.angle = function(_) {
            return arguments.length ? (alpha = _ % 360 * (0, _mathJs.radians), sa = (0, _mathJs.sin)(alpha), ca = (0, _mathJs.cos)(alpha), reset()) : alpha * (0, _mathJs.degrees);
        };
        projection.reflectX = function(_) {
            return arguments.length ? (sx = _ ? -1 : 1, reset()) : sx < 0;
        };
        projection.reflectY = function(_) {
            return arguments.length ? (sy = _ ? -1 : 1, reset()) : sy < 0;
        };
        projection.fitExtent = function(extent, object) {
            return (0, _fitJs.fitExtent)(projection, extent, object);
        };
        projection.fitSize = function(size, object) {
            return (0, _fitJs.fitSize)(projection, size, object);
        };
        projection.fitWidth = function(width, object) {
            return (0, _fitJs.fitWidth)(projection, width, object);
        };
        projection.fitHeight = function(height, object) {
            return (0, _fitJs.fitHeight)(projection, height, object);
        };
        return projection;
    });
var _rectangleJs = require("../clip/rectangle.js");
var _rectangleJsDefault = parcelHelpers.interopDefault(_rectangleJs);
var _identityJs = require("../identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _transformJs = require("../transform.js");
var _fitJs = require("./fit.js");
var _mathJs = require("../math.js");

},{"../clip/rectangle.js":"hgkNK","../identity.js":"gpb1g","../transform.js":"2cPnh","./fit.js":"8wphn","../math.js":"hswBu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"invjX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "naturalEarth1Raw", ()=>naturalEarth1Raw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(naturalEarth1Raw).scale(175.295);
    });
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _mathJs = require("../math.js");
function naturalEarth1Raw(lambda, phi) {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    return [
        lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
        phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
    ];
}
naturalEarth1Raw.invert = function(x, y) {
    var phi = y, i = 25, delta;
    do {
        var phi2 = phi * phi, phi4 = phi2 * phi2;
        phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) / (1.007226 + phi2 * (0.045255 + phi4 * (-0.311325 + 0.259866 * phi2 - 0.005916 * 11 * phi4)));
    }while ((0, _mathJs.abs)(delta) > (0, _mathJs.epsilon) && --i > 0);
    return [
        x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
        phi
    ];
};

},{"./index.js":"jabgC","../math.js":"hswBu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"awIEX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "orthographicRaw", ()=>orthographicRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(orthographicRaw).scale(249.5).clipAngle(90 + (0, _mathJs.epsilon));
    });
var _mathJs = require("../math.js");
var _azimuthalJs = require("./azimuthal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function orthographicRaw(x, y) {
    return [
        (0, _mathJs.cos)(y) * (0, _mathJs.sin)(x),
        (0, _mathJs.sin)(y)
    ];
}
orthographicRaw.invert = (0, _azimuthalJs.azimuthalInvert)((0, _mathJs.asin));

},{"../math.js":"hswBu","./azimuthal.js":"dlPcy","./index.js":"jabgC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fBs4c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stereographicRaw", ()=>stereographicRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(stereographicRaw).scale(250).clipAngle(142);
    });
var _mathJs = require("../math.js");
var _azimuthalJs = require("./azimuthal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function stereographicRaw(x, y) {
    var cy = (0, _mathJs.cos)(y), k = 1 + (0, _mathJs.cos)(x) * cy;
    return [
        cy * (0, _mathJs.sin)(x) / k,
        (0, _mathJs.sin)(y) / k
    ];
}
stereographicRaw.invert = (0, _azimuthalJs.azimuthalInvert)(function(z) {
    return 2 * (0, _mathJs.atan)(z);
});

},{"../math.js":"hswBu","./azimuthal.js":"dlPcy","./index.js":"jabgC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i3KJ4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transverseMercatorRaw", ()=>transverseMercatorRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        var m = (0, _mercatorJs.mercatorProjection)(transverseMercatorRaw), center = m.center, rotate = m.rotate;
        m.center = function(_) {
            return arguments.length ? center([
                -_[1],
                _[0]
            ]) : (_ = center(), [
                _[1],
                -_[0]
            ]);
        };
        m.rotate = function(_) {
            return arguments.length ? rotate([
                _[0],
                _[1],
                _.length > 2 ? _[2] + 90 : 90
            ]) : (_ = rotate(), [
                _[0],
                _[1],
                _[2] - 90
            ]);
        };
        return rotate([
            0,
            0,
            90
        ]).scale(159.155);
    });
var _mathJs = require("../math.js");
var _mercatorJs = require("./mercator.js");
function transverseMercatorRaw(lambda, phi) {
    return [
        (0, _mathJs.log)((0, _mathJs.tan)(((0, _mathJs.halfPi) + phi) / 2)),
        -lambda
    ];
}
transverseMercatorRaw.invert = function(x, y) {
    return [
        -y,
        2 * (0, _mathJs.atan)((0, _mathJs.exp)(x)) - (0, _mathJs.halfPi)
    ];
};

},{"../math.js":"hswBu","./mercator.js":"awlzv","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gKQHn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interpolate", ()=>(0, _valueJsDefault.default));
parcelHelpers.export(exports, "interpolateArray", ()=>(0, _arrayJsDefault.default));
parcelHelpers.export(exports, "interpolateBasis", ()=>(0, _basisJsDefault.default));
parcelHelpers.export(exports, "interpolateBasisClosed", ()=>(0, _basisClosedJsDefault.default));
parcelHelpers.export(exports, "interpolateDate", ()=>(0, _dateJsDefault.default));
parcelHelpers.export(exports, "interpolateDiscrete", ()=>(0, _discreteJsDefault.default));
parcelHelpers.export(exports, "interpolateHue", ()=>(0, _hueJsDefault.default));
parcelHelpers.export(exports, "interpolateNumber", ()=>(0, _numberJsDefault.default));
parcelHelpers.export(exports, "interpolateNumberArray", ()=>(0, _numberArrayJsDefault.default));
parcelHelpers.export(exports, "interpolateObject", ()=>(0, _objectJsDefault.default));
parcelHelpers.export(exports, "interpolateRound", ()=>(0, _roundJsDefault.default));
parcelHelpers.export(exports, "interpolateString", ()=>(0, _stringJsDefault.default));
parcelHelpers.export(exports, "interpolateTransformCss", ()=>(0, _indexJs.interpolateTransformCss));
parcelHelpers.export(exports, "interpolateTransformSvg", ()=>(0, _indexJs.interpolateTransformSvg));
parcelHelpers.export(exports, "interpolateZoom", ()=>(0, _zoomJsDefault.default));
parcelHelpers.export(exports, "interpolateRgb", ()=>(0, _rgbJsDefault.default));
parcelHelpers.export(exports, "interpolateRgbBasis", ()=>(0, _rgbJs.rgbBasis));
parcelHelpers.export(exports, "interpolateRgbBasisClosed", ()=>(0, _rgbJs.rgbBasisClosed));
parcelHelpers.export(exports, "interpolateHsl", ()=>(0, _hslJsDefault.default));
parcelHelpers.export(exports, "interpolateHslLong", ()=>(0, _hslJs.hslLong));
parcelHelpers.export(exports, "interpolateLab", ()=>(0, _labJsDefault.default));
parcelHelpers.export(exports, "interpolateHcl", ()=>(0, _hclJsDefault.default));
parcelHelpers.export(exports, "interpolateHclLong", ()=>(0, _hclJs.hclLong));
parcelHelpers.export(exports, "interpolateCubehelix", ()=>(0, _cubehelixJsDefault.default));
parcelHelpers.export(exports, "interpolateCubehelixLong", ()=>(0, _cubehelixJs.cubehelixLong));
parcelHelpers.export(exports, "piecewise", ()=>(0, _piecewiseJsDefault.default));
parcelHelpers.export(exports, "quantize", ()=>(0, _quantizeJsDefault.default));
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _basisJs = require("./basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _basisClosedJs = require("./basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _dateJs = require("./date.js");
var _dateJsDefault = parcelHelpers.interopDefault(_dateJs);
var _discreteJs = require("./discrete.js");
var _discreteJsDefault = parcelHelpers.interopDefault(_discreteJs);
var _hueJs = require("./hue.js");
var _hueJsDefault = parcelHelpers.interopDefault(_hueJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);
var _objectJs = require("./object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _roundJs = require("./round.js");
var _roundJsDefault = parcelHelpers.interopDefault(_roundJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);
var _indexJs = require("./transform/index.js");
var _zoomJs = require("./zoom.js");
var _zoomJsDefault = parcelHelpers.interopDefault(_zoomJs);
var _rgbJs = require("./rgb.js");
var _rgbJsDefault = parcelHelpers.interopDefault(_rgbJs);
var _hslJs = require("./hsl.js");
var _hslJsDefault = parcelHelpers.interopDefault(_hslJs);
var _labJs = require("./lab.js");
var _labJsDefault = parcelHelpers.interopDefault(_labJs);
var _hclJs = require("./hcl.js");
var _hclJsDefault = parcelHelpers.interopDefault(_hclJs);
var _cubehelixJs = require("./cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);
var _piecewiseJs = require("./piecewise.js");
var _piecewiseJsDefault = parcelHelpers.interopDefault(_piecewiseJs);
var _quantizeJs = require("./quantize.js");
var _quantizeJsDefault = parcelHelpers.interopDefault(_quantizeJs);

},{"./value.js":"bQQ1J","./array.js":"9Rmt3","./basis.js":"8v2RP","./basisClosed.js":"93ABE","./date.js":"4wvkD","./discrete.js":"bwmhY","./hue.js":"lP44T","./number.js":"lU4Z0","./numberArray.js":"8eUFq","./object.js":"csAzg","./round.js":"aOsJ9","./string.js":"iNjOh","./transform/index.js":"iN9Uy","./zoom.js":"7BEmP","./rgb.js":"bG7wU","./hsl.js":"jLI2t","./lab.js":"5bI6L","./hcl.js":"aNxuN","./cubehelix.js":"8c1po","./piecewise.js":"gakap","./quantize.js":"6ihUf","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bwmhY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(range) {
        var n = range.length;
        return function(t) {
            return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lP44T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var i = (0, _colorJs.hue)(+a, +b);
        return function(t) {
            var x = i(t);
            return x - 360 * Math.floor(x / 360);
        };
    });
var _colorJs = require("./color.js");

},{"./color.js":"igqbp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7BEmP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var epsilon2 = 1e-12;
function cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
exports.default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jLI2t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hslLong", ()=>hslLong);
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, _d3Color.hsl)(start)).h, (end = (0, _d3Color.hsl)(end)).h), s = (0, _colorJsDefault.default)(start.s, end.s), l = (0, _colorJsDefault.default)(start.l, end.l), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
exports.default = hsl((0, _colorJs.hue));
var hslLong = hsl((0, _colorJsDefault.default));

},{"d3-color":"cZjkf","./color.js":"igqbp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5bI6L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>lab);
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function lab(start, end) {
    var l = (0, _colorJsDefault.default)((start = (0, _d3Color.lab)(start)).l, (end = (0, _d3Color.lab)(end)).l), a = (0, _colorJsDefault.default)(start.a, end.a), b = (0, _colorJsDefault.default)(start.b, end.b), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

},{"d3-color":[["lab","bikfP","default"]],"./color.js":"igqbp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aNxuN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hclLong", ()=>hclLong);
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, _d3Color.hcl)(start)).h, (end = (0, _d3Color.hcl)(end)).h), c = (0, _colorJsDefault.default)(start.c, end.c), l = (0, _colorJsDefault.default)(start.l, end.l), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
exports.default = hcl((0, _colorJs.hue));
var hclLong = hcl((0, _colorJsDefault.default));

},{"d3-color":"bikfP","./color.js":"igqbp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8c1po":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cubehelixLong", ()=>cubehelixLong);
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, _d3Color.cubehelix)(start)).h, (end = (0, _d3Color.cubehelix)(end)).h), s = (0, _colorJsDefault.default)(start.s, end.s), l = (0, _colorJsDefault.default)(start.l, end.l), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
exports.default = cubehelix((0, _colorJs.hue));
var cubehelixLong = cubehelix((0, _colorJsDefault.default));

},{"d3-color":[["cubehelix","b6Cou","default"]],"./color.js":"igqbp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6ihUf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(interpolator, n) {
        var samples = new Array(n);
        for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
        return samples;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"41uJT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Path", ()=>(0, _pathJs.Path));
parcelHelpers.export(exports, "path", ()=>(0, _pathJs.path));
parcelHelpers.export(exports, "pathRound", ()=>(0, _pathJs.pathRound));
var _pathJs = require("./path.js");

},{"./path.js":"jFrOU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7KahZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "polygonArea", ()=>(0, _areaJsDefault.default));
parcelHelpers.export(exports, "polygonCentroid", ()=>(0, _centroidJsDefault.default));
parcelHelpers.export(exports, "polygonHull", ()=>(0, _hullJsDefault.default));
parcelHelpers.export(exports, "polygonContains", ()=>(0, _containsJsDefault.default));
parcelHelpers.export(exports, "polygonLength", ()=>(0, _lengthJsDefault.default));
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _centroidJs = require("./centroid.js");
var _centroidJsDefault = parcelHelpers.interopDefault(_centroidJs);
var _hullJs = require("./hull.js");
var _hullJsDefault = parcelHelpers.interopDefault(_hullJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _lengthJs = require("./length.js");
var _lengthJsDefault = parcelHelpers.interopDefault(_lengthJs);

},{"./area.js":"lInSh","./centroid.js":"7KGma","./hull.js":"6TDa4","./contains.js":"42b3u","./length.js":"1hNpz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lInSh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(polygon) {
        var i = -1, n = polygon.length, a, b = polygon[n - 1], area = 0;
        while(++i < n){
            a = b;
            b = polygon[i];
            area += a[1] * b[0] - a[0] * b[1];
        }
        return area / 2;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7KGma":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(polygon) {
        var i = -1, n = polygon.length, x = 0, y = 0, a, b = polygon[n - 1], c, k = 0;
        while(++i < n){
            a = b;
            b = polygon[i];
            k += c = a[0] * b[1] - b[0] * a[1];
            x += (a[0] + b[0]) * c;
            y += (a[1] + b[1]) * c;
        }
        return k *= 3, [
            x / k,
            y / k
        ];
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6TDa4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(points) {
        if ((n = points.length) < 3) return null;
        var i, n, sortedPoints = new Array(n), flippedPoints = new Array(n);
        for(i = 0; i < n; ++i)sortedPoints[i] = [
            +points[i][0],
            +points[i][1],
            i
        ];
        sortedPoints.sort(lexicographicOrder);
        for(i = 0; i < n; ++i)flippedPoints[i] = [
            sortedPoints[i][0],
            -sortedPoints[i][1]
        ];
        var upperIndexes = computeUpperHullIndexes(sortedPoints), lowerIndexes = computeUpperHullIndexes(flippedPoints);
        // Construct the hull polygon, removing possible duplicate endpoints.
        var skipLeft = lowerIndexes[0] === upperIndexes[0], skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1], hull = [];
        // Add upper hull in right-to-l order.
        // Then add lower hull in left-to-right order.
        for(i = upperIndexes.length - 1; i >= 0; --i)hull.push(points[sortedPoints[upperIndexes[i]][2]]);
        for(i = +skipLeft; i < lowerIndexes.length - skipRight; ++i)hull.push(points[sortedPoints[lowerIndexes[i]][2]]);
        return hull;
    });
var _crossJs = require("./cross.js");
var _crossJsDefault = parcelHelpers.interopDefault(_crossJs);
function lexicographicOrder(a, b) {
    return a[0] - b[0] || a[1] - b[1];
}
// Computes the upper convex hull per the monotone chain algorithm.
// Assumes points.length >= 3, is sorted by x, unique in y.
// Returns an array of indices into points in left-to-right order.
function computeUpperHullIndexes(points) {
    const n = points.length, indexes = [
        0,
        1
    ];
    let size = 2, i;
    for(i = 2; i < n; ++i){
        while(size > 1 && (0, _crossJsDefault.default)(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0)--size;
        indexes[size++] = i;
    }
    return indexes.slice(0, size); // remove popped points
}

},{"./cross.js":"4DNlB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4DNlB":[function(require,module,exports,__globalThis) {
// Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
// the 3D cross product in a quadrant I Cartesian coordinate system (+x is
// right, +y is up). Returns a positive value if ABC is counter-clockwise,
// negative if clockwise, and zero if the points are collinear.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b, c) {
        return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"42b3u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(polygon, point) {
        var n = polygon.length, p = polygon[n - 1], x = point[0], y = point[1], x0 = p[0], y0 = p[1], x1, y1, inside = false;
        for(var i = 0; i < n; ++i){
            p = polygon[i], x1 = p[0], y1 = p[1];
            if (y1 > y !== y0 > y && x < (x0 - x1) * (y - y1) / (y0 - y1) + x1) inside = !inside;
            x0 = x1, y0 = y1;
        }
        return inside;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1hNpz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(polygon) {
        var i = -1, n = polygon.length, b = polygon[n - 1], xa, ya, xb = b[0], yb = b[1], perimeter = 0;
        while(++i < n){
            xa = xb;
            ya = yb;
            b = polygon[i];
            xb = b[0];
            yb = b[1];
            xa -= xb;
            ya -= yb;
            perimeter += Math.hypot(xa, ya);
        }
        return perimeter;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d5sFf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "quadtree", ()=>(0, _quadtreeJsDefault.default));
var _quadtreeJs = require("./quadtree.js");
var _quadtreeJsDefault = parcelHelpers.interopDefault(_quadtreeJs);

},{"./quadtree.js":"60xyB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9Pwtr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "randomUniform", ()=>(0, _uniformJsDefault.default));
parcelHelpers.export(exports, "randomInt", ()=>(0, _intJsDefault.default));
parcelHelpers.export(exports, "randomNormal", ()=>(0, _normalJsDefault.default));
parcelHelpers.export(exports, "randomLogNormal", ()=>(0, _logNormalJsDefault.default));
parcelHelpers.export(exports, "randomBates", ()=>(0, _batesJsDefault.default));
parcelHelpers.export(exports, "randomIrwinHall", ()=>(0, _irwinHallJsDefault.default));
parcelHelpers.export(exports, "randomExponential", ()=>(0, _exponentialJsDefault.default));
parcelHelpers.export(exports, "randomPareto", ()=>(0, _paretoJsDefault.default));
parcelHelpers.export(exports, "randomBernoulli", ()=>(0, _bernoulliJsDefault.default));
parcelHelpers.export(exports, "randomGeometric", ()=>(0, _geometricJsDefault.default));
parcelHelpers.export(exports, "randomBinomial", ()=>(0, _binomialJsDefault.default));
parcelHelpers.export(exports, "randomGamma", ()=>(0, _gammaJsDefault.default));
parcelHelpers.export(exports, "randomBeta", ()=>(0, _betaJsDefault.default));
parcelHelpers.export(exports, "randomWeibull", ()=>(0, _weibullJsDefault.default));
parcelHelpers.export(exports, "randomCauchy", ()=>(0, _cauchyJsDefault.default));
parcelHelpers.export(exports, "randomLogistic", ()=>(0, _logisticJsDefault.default));
parcelHelpers.export(exports, "randomPoisson", ()=>(0, _poissonJsDefault.default));
parcelHelpers.export(exports, "randomLcg", ()=>(0, _lcgJsDefault.default));
var _uniformJs = require("./uniform.js");
var _uniformJsDefault = parcelHelpers.interopDefault(_uniformJs);
var _intJs = require("./int.js");
var _intJsDefault = parcelHelpers.interopDefault(_intJs);
var _normalJs = require("./normal.js");
var _normalJsDefault = parcelHelpers.interopDefault(_normalJs);
var _logNormalJs = require("./logNormal.js");
var _logNormalJsDefault = parcelHelpers.interopDefault(_logNormalJs);
var _batesJs = require("./bates.js");
var _batesJsDefault = parcelHelpers.interopDefault(_batesJs);
var _irwinHallJs = require("./irwinHall.js");
var _irwinHallJsDefault = parcelHelpers.interopDefault(_irwinHallJs);
var _exponentialJs = require("./exponential.js");
var _exponentialJsDefault = parcelHelpers.interopDefault(_exponentialJs);
var _paretoJs = require("./pareto.js");
var _paretoJsDefault = parcelHelpers.interopDefault(_paretoJs);
var _bernoulliJs = require("./bernoulli.js");
var _bernoulliJsDefault = parcelHelpers.interopDefault(_bernoulliJs);
var _geometricJs = require("./geometric.js");
var _geometricJsDefault = parcelHelpers.interopDefault(_geometricJs);
var _binomialJs = require("./binomial.js");
var _binomialJsDefault = parcelHelpers.interopDefault(_binomialJs);
var _gammaJs = require("./gamma.js");
var _gammaJsDefault = parcelHelpers.interopDefault(_gammaJs);
var _betaJs = require("./beta.js");
var _betaJsDefault = parcelHelpers.interopDefault(_betaJs);
var _weibullJs = require("./weibull.js");
var _weibullJsDefault = parcelHelpers.interopDefault(_weibullJs);
var _cauchyJs = require("./cauchy.js");
var _cauchyJsDefault = parcelHelpers.interopDefault(_cauchyJs);
var _logisticJs = require("./logistic.js");
var _logisticJsDefault = parcelHelpers.interopDefault(_logisticJs);
var _poissonJs = require("./poisson.js");
var _poissonJsDefault = parcelHelpers.interopDefault(_poissonJs);
var _lcgJs = require("./lcg.js");
var _lcgJsDefault = parcelHelpers.interopDefault(_lcgJs);

},{"./uniform.js":"kmAtm","./int.js":"fr3D3","./normal.js":"hhitB","./logNormal.js":"5avIg","./bates.js":"k0a9Y","./irwinHall.js":"6qYrI","./exponential.js":"gd4Rj","./pareto.js":"ijKbA","./bernoulli.js":"kDKCK","./geometric.js":"5fDhZ","./binomial.js":"1xbBF","./gamma.js":"bUY70","./beta.js":"1RbrR","./weibull.js":"kuK3X","./cauchy.js":"cj3SK","./logistic.js":"f9697","./poisson.js":"3kr1J","./lcg.js":"4D2WS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kmAtm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomUniform(source) {
    function randomUniform(min, max) {
        min = min == null ? 0 : +min;
        max = max == null ? 1 : +max;
        if (arguments.length === 1) max = min, min = 0;
        else max -= min;
        return function() {
            return source() * max + min;
        };
    }
    randomUniform.source = sourceRandomUniform;
    return randomUniform;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"jI67H","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jI67H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = Math.random;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fr3D3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomInt(source) {
    function randomInt(min, max) {
        if (arguments.length < 2) max = min, min = 0;
        min = Math.floor(min);
        max = Math.floor(max) - min;
        return function() {
            return Math.floor(source() * max + min);
        };
    }
    randomInt.source = sourceRandomInt;
    return randomInt;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"jI67H","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hhitB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomNormal(source) {
    function randomNormal(mu, sigma) {
        var x, r;
        mu = mu == null ? 0 : +mu;
        sigma = sigma == null ? 1 : +sigma;
        return function() {
            var y;
            // If available, use the second previously-generated uniform random.
            if (x != null) y = x, x = null;
            else do {
                x = source() * 2 - 1;
                y = source() * 2 - 1;
                r = x * x + y * y;
            }while (!r || r > 1);
            return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
        };
    }
    randomNormal.source = sourceRandomNormal;
    return randomNormal;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"jI67H","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5avIg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
var _normalJs = require("./normal.js");
var _normalJsDefault = parcelHelpers.interopDefault(_normalJs);
exports.default = function sourceRandomLogNormal(source) {
    var N = (0, _normalJsDefault.default).source(source);
    function randomLogNormal() {
        var randomNormal = N.apply(this, arguments);
        return function() {
            return Math.exp(randomNormal());
        };
    }
    randomLogNormal.source = sourceRandomLogNormal;
    return randomLogNormal;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"jI67H","./normal.js":"hhitB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k0a9Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
var _irwinHallJs = require("./irwinHall.js");
var _irwinHallJsDefault = parcelHelpers.interopDefault(_irwinHallJs);
exports.default = function sourceRandomBates(source) {
    var I = (0, _irwinHallJsDefault.default).source(source);
    function randomBates(n) {
        // use limiting distribution at n === 0
        if ((n = +n) === 0) return source;
        var randomIrwinHall = I(n);
        return function() {
            return randomIrwinHall() / n;
        };
    }
    randomBates.source = sourceRandomBates;
    return randomBates;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"jI67H","./irwinHall.js":"6qYrI","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6qYrI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomIrwinHall(source) {
    function randomIrwinHall(n) {
        if ((n = +n) <= 0) return ()=>0;
        return function() {
            for(var sum = 0, i = n; i > 1; --i)sum += source();
            return sum + i * source();
        };
    }
    randomIrwinHall.source = sourceRandomIrwinHall;
    return randomIrwinHall;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"jI67H","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gd4Rj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomExponential(source) {
    function randomExponential(lambda) {
        return function() {
            return -Math.log1p(-source()) / lambda;
        };
    }
    randomExponential.source = sourceRandomExponential;
    return randomExponential;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"jI67H","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ijKbA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomPareto(source) {
    function randomPareto(alpha) {
        if ((alpha = +alpha) < 0) throw new RangeError("invalid alpha");
        alpha = 1 / -alpha;
        return function() {
            return Math.pow(1 - source(), alpha);
        };
    }
    randomPareto.source = sourceRandomPareto;
    return randomPareto;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"jI67H","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kDKCK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomBernoulli(source) {
    function randomBernoulli(p) {
        if ((p = +p) < 0 || p > 1) throw new RangeError("invalid p");
        return function() {
            return Math.floor(source() + p);
        };
    }
    randomBernoulli.source = sourceRandomBernoulli;
    return randomBernoulli;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"jI67H","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5fDhZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomGeometric(source) {
    function randomGeometric(p) {
        if ((p = +p) < 0 || p > 1) throw new RangeError("invalid p");
        if (p === 0) return ()=>Infinity;
        if (p === 1) return ()=>1;
        p = Math.log1p(-p);
        return function() {
            return 1 + Math.floor(Math.log1p(-source()) / p);
        };
    }
    randomGeometric.source = sourceRandomGeometric;
    return randomGeometric;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"jI67H","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1xbBF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
var _betaJs = require("./beta.js");
var _betaJsDefault = parcelHelpers.interopDefault(_betaJs);
var _geometricJs = require("./geometric.js");
var _geometricJsDefault = parcelHelpers.interopDefault(_geometricJs);
exports.default = function sourceRandomBinomial(source) {
    var G = (0, _geometricJsDefault.default).source(source), B = (0, _betaJsDefault.default).source(source);
    function randomBinomial(n, p) {
        n = +n;
        if ((p = +p) >= 1) return ()=>n;
        if (p <= 0) return ()=>0;
        return function() {
            var acc = 0, nn = n, pp = p;
            while(nn * pp > 16 && nn * (1 - pp) > 16){
                var i = Math.floor((nn + 1) * pp), y = B(i, nn - i + 1)();
                if (y <= pp) {
                    acc += i;
                    nn -= i;
                    pp = (pp - y) / (1 - y);
                } else {
                    nn = i - 1;
                    pp /= y;
                }
            }
            var sign = pp < 0.5, pFinal = sign ? pp : 1 - pp, g = G(pFinal);
            for(var s = g(), k = 0; s <= nn; ++k)s += g();
            return acc + (sign ? k : nn - k);
        };
    }
    randomBinomial.source = sourceRandomBinomial;
    return randomBinomial;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"jI67H","./beta.js":"1RbrR","./geometric.js":"5fDhZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1RbrR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
var _gammaJs = require("./gamma.js");
var _gammaJsDefault = parcelHelpers.interopDefault(_gammaJs);
exports.default = function sourceRandomBeta(source) {
    var G = (0, _gammaJsDefault.default).source(source);
    function randomBeta(alpha, beta) {
        var X = G(alpha), Y = G(beta);
        return function() {
            var x = X();
            return x === 0 ? 0 : x / (x + Y());
        };
    }
    randomBeta.source = sourceRandomBeta;
    return randomBeta;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"jI67H","./gamma.js":"bUY70","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bUY70":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
var _normalJs = require("./normal.js");
var _normalJsDefault = parcelHelpers.interopDefault(_normalJs);
exports.default = function sourceRandomGamma(source) {
    var randomNormal = (0, _normalJsDefault.default).source(source)();
    function randomGamma(k, theta) {
        if ((k = +k) < 0) throw new RangeError("invalid k");
        // degenerate distribution if k === 0
        if (k === 0) return ()=>0;
        theta = theta == null ? 1 : +theta;
        // exponential distribution if k === 1
        if (k === 1) return ()=>-Math.log1p(-source()) * theta;
        var d = (k < 1 ? k + 1 : k) - 1 / 3, c = 1 / (3 * Math.sqrt(d)), multiplier = k < 1 ? ()=>Math.pow(source(), 1 / k) : ()=>1;
        return function() {
            do {
                do var x = randomNormal(), v = 1 + c * x;
                while (v <= 0);
                v *= v * v;
                var u = 1 - source();
            }while (u >= 1 - 0.0331 * x * x * x * x && Math.log(u) >= 0.5 * x * x + d * (1 - v + Math.log(v)));
            return d * v * multiplier() * theta;
        };
    }
    randomGamma.source = sourceRandomGamma;
    return randomGamma;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"jI67H","./normal.js":"hhitB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kuK3X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomWeibull(source) {
    function randomWeibull(k, a, b) {
        var outerFunc;
        if ((k = +k) === 0) outerFunc = (x)=>-Math.log(x);
        else {
            k = 1 / k;
            outerFunc = (x)=>Math.pow(x, k);
        }
        a = a == null ? 0 : +a;
        b = b == null ? 1 : +b;
        return function() {
            return a + b * outerFunc(-Math.log1p(-source()));
        };
    }
    randomWeibull.source = sourceRandomWeibull;
    return randomWeibull;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"jI67H","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cj3SK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomCauchy(source) {
    function randomCauchy(a, b) {
        a = a == null ? 0 : +a;
        b = b == null ? 1 : +b;
        return function() {
            return a + b * Math.tan(Math.PI * source());
        };
    }
    randomCauchy.source = sourceRandomCauchy;
    return randomCauchy;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"jI67H","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f9697":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
exports.default = function sourceRandomLogistic(source) {
    function randomLogistic(a, b) {
        a = a == null ? 0 : +a;
        b = b == null ? 1 : +b;
        return function() {
            var u = source();
            return a + b * Math.log(u / (1 - u));
        };
    }
    randomLogistic.source = sourceRandomLogistic;
    return randomLogistic;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"jI67H","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3kr1J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSourceJs = require("./defaultSource.js");
var _defaultSourceJsDefault = parcelHelpers.interopDefault(_defaultSourceJs);
var _binomialJs = require("./binomial.js");
var _binomialJsDefault = parcelHelpers.interopDefault(_binomialJs);
var _gammaJs = require("./gamma.js");
var _gammaJsDefault = parcelHelpers.interopDefault(_gammaJs);
exports.default = function sourceRandomPoisson(source) {
    var G = (0, _gammaJsDefault.default).source(source), B = (0, _binomialJsDefault.default).source(source);
    function randomPoisson(lambda) {
        return function() {
            var acc = 0, l = lambda;
            while(l > 16){
                var n = Math.floor(0.875 * l), t = G(n)();
                if (t > l) return acc + B(n - 1, l / t)();
                acc += n;
                l -= t;
            }
            for(var s = -Math.log1p(-source()), k = 0; s <= l; ++k)s -= Math.log1p(-source());
            return acc + k;
        };
    }
    randomPoisson.source = sourceRandomPoisson;
    return randomPoisson;
}((0, _defaultSourceJsDefault.default));

},{"./defaultSource.js":"jI67H","./binomial.js":"1xbBF","./gamma.js":"bUY70","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4D2WS":[function(require,module,exports,__globalThis) {
// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>lcg);
const mul = 0x19660D;
const inc = 0x3C6EF35F;
const eps = 1 / 0x100000000;
function lcg(seed = Math.random()) {
    let state = (0 <= seed && seed < 1 ? seed / eps : Math.abs(seed)) | 0;
    return ()=>(state = mul * state + inc | 0, eps * (state >>> 0));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5y5Lb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "schemeCategory10", ()=>(0, _category10JsDefault.default));
parcelHelpers.export(exports, "schemeAccent", ()=>(0, _accentJsDefault.default));
parcelHelpers.export(exports, "schemeDark2", ()=>(0, _dark2JsDefault.default));
parcelHelpers.export(exports, "schemeObservable10", ()=>(0, _observable10JsDefault.default));
parcelHelpers.export(exports, "schemePaired", ()=>(0, _pairedJsDefault.default));
parcelHelpers.export(exports, "schemePastel1", ()=>(0, _pastel1JsDefault.default));
parcelHelpers.export(exports, "schemePastel2", ()=>(0, _pastel2JsDefault.default));
parcelHelpers.export(exports, "schemeSet1", ()=>(0, _set1JsDefault.default));
parcelHelpers.export(exports, "schemeSet2", ()=>(0, _set2JsDefault.default));
parcelHelpers.export(exports, "schemeSet3", ()=>(0, _set3JsDefault.default));
parcelHelpers.export(exports, "schemeTableau10", ()=>(0, _tableau10JsDefault.default));
parcelHelpers.export(exports, "interpolateBrBG", ()=>(0, _brBGJsDefault.default));
parcelHelpers.export(exports, "schemeBrBG", ()=>(0, _brBGJs.scheme));
parcelHelpers.export(exports, "interpolatePRGn", ()=>(0, _prgnJsDefault.default));
parcelHelpers.export(exports, "schemePRGn", ()=>(0, _prgnJs.scheme));
parcelHelpers.export(exports, "interpolatePiYG", ()=>(0, _piYGJsDefault.default));
parcelHelpers.export(exports, "schemePiYG", ()=>(0, _piYGJs.scheme));
parcelHelpers.export(exports, "interpolatePuOr", ()=>(0, _puOrJsDefault.default));
parcelHelpers.export(exports, "schemePuOr", ()=>(0, _puOrJs.scheme));
parcelHelpers.export(exports, "interpolateRdBu", ()=>(0, _rdBuJsDefault.default));
parcelHelpers.export(exports, "schemeRdBu", ()=>(0, _rdBuJs.scheme));
parcelHelpers.export(exports, "interpolateRdGy", ()=>(0, _rdGyJsDefault.default));
parcelHelpers.export(exports, "schemeRdGy", ()=>(0, _rdGyJs.scheme));
parcelHelpers.export(exports, "interpolateRdYlBu", ()=>(0, _rdYlBuJsDefault.default));
parcelHelpers.export(exports, "schemeRdYlBu", ()=>(0, _rdYlBuJs.scheme));
parcelHelpers.export(exports, "interpolateRdYlGn", ()=>(0, _rdYlGnJsDefault.default));
parcelHelpers.export(exports, "schemeRdYlGn", ()=>(0, _rdYlGnJs.scheme));
parcelHelpers.export(exports, "interpolateSpectral", ()=>(0, _spectralJsDefault.default));
parcelHelpers.export(exports, "schemeSpectral", ()=>(0, _spectralJs.scheme));
parcelHelpers.export(exports, "interpolateBuGn", ()=>(0, _buGnJsDefault.default));
parcelHelpers.export(exports, "schemeBuGn", ()=>(0, _buGnJs.scheme));
parcelHelpers.export(exports, "interpolateBuPu", ()=>(0, _buPuJsDefault.default));
parcelHelpers.export(exports, "schemeBuPu", ()=>(0, _buPuJs.scheme));
parcelHelpers.export(exports, "interpolateGnBu", ()=>(0, _gnBuJsDefault.default));
parcelHelpers.export(exports, "schemeGnBu", ()=>(0, _gnBuJs.scheme));
parcelHelpers.export(exports, "interpolateOrRd", ()=>(0, _orRdJsDefault.default));
parcelHelpers.export(exports, "schemeOrRd", ()=>(0, _orRdJs.scheme));
parcelHelpers.export(exports, "interpolatePuBuGn", ()=>(0, _puBuGnJsDefault.default));
parcelHelpers.export(exports, "schemePuBuGn", ()=>(0, _puBuGnJs.scheme));
parcelHelpers.export(exports, "interpolatePuBu", ()=>(0, _puBuJsDefault.default));
parcelHelpers.export(exports, "schemePuBu", ()=>(0, _puBuJs.scheme));
parcelHelpers.export(exports, "interpolatePuRd", ()=>(0, _puRdJsDefault.default));
parcelHelpers.export(exports, "schemePuRd", ()=>(0, _puRdJs.scheme));
parcelHelpers.export(exports, "interpolateRdPu", ()=>(0, _rdPuJsDefault.default));
parcelHelpers.export(exports, "schemeRdPu", ()=>(0, _rdPuJs.scheme));
parcelHelpers.export(exports, "interpolateYlGnBu", ()=>(0, _ylGnBuJsDefault.default));
parcelHelpers.export(exports, "schemeYlGnBu", ()=>(0, _ylGnBuJs.scheme));
parcelHelpers.export(exports, "interpolateYlGn", ()=>(0, _ylGnJsDefault.default));
parcelHelpers.export(exports, "schemeYlGn", ()=>(0, _ylGnJs.scheme));
parcelHelpers.export(exports, "interpolateYlOrBr", ()=>(0, _ylOrBrJsDefault.default));
parcelHelpers.export(exports, "schemeYlOrBr", ()=>(0, _ylOrBrJs.scheme));
parcelHelpers.export(exports, "interpolateYlOrRd", ()=>(0, _ylOrRdJsDefault.default));
parcelHelpers.export(exports, "schemeYlOrRd", ()=>(0, _ylOrRdJs.scheme));
parcelHelpers.export(exports, "interpolateBlues", ()=>(0, _bluesJsDefault.default));
parcelHelpers.export(exports, "schemeBlues", ()=>(0, _bluesJs.scheme));
parcelHelpers.export(exports, "interpolateGreens", ()=>(0, _greensJsDefault.default));
parcelHelpers.export(exports, "schemeGreens", ()=>(0, _greensJs.scheme));
parcelHelpers.export(exports, "interpolateGreys", ()=>(0, _greysJsDefault.default));
parcelHelpers.export(exports, "schemeGreys", ()=>(0, _greysJs.scheme));
parcelHelpers.export(exports, "interpolatePurples", ()=>(0, _purplesJsDefault.default));
parcelHelpers.export(exports, "schemePurples", ()=>(0, _purplesJs.scheme));
parcelHelpers.export(exports, "interpolateReds", ()=>(0, _redsJsDefault.default));
parcelHelpers.export(exports, "schemeReds", ()=>(0, _redsJs.scheme));
parcelHelpers.export(exports, "interpolateOranges", ()=>(0, _orangesJsDefault.default));
parcelHelpers.export(exports, "schemeOranges", ()=>(0, _orangesJs.scheme));
parcelHelpers.export(exports, "interpolateCividis", ()=>(0, _cividisJsDefault.default));
parcelHelpers.export(exports, "interpolateCubehelixDefault", ()=>(0, _cubehelixJsDefault.default));
parcelHelpers.export(exports, "interpolateRainbow", ()=>(0, _rainbowJsDefault.default));
parcelHelpers.export(exports, "interpolateWarm", ()=>(0, _rainbowJs.warm));
parcelHelpers.export(exports, "interpolateCool", ()=>(0, _rainbowJs.cool));
parcelHelpers.export(exports, "interpolateSinebow", ()=>(0, _sinebowJsDefault.default));
parcelHelpers.export(exports, "interpolateTurbo", ()=>(0, _turboJsDefault.default));
parcelHelpers.export(exports, "interpolateViridis", ()=>(0, _viridisJsDefault.default));
parcelHelpers.export(exports, "interpolateMagma", ()=>(0, _viridisJs.magma));
parcelHelpers.export(exports, "interpolateInferno", ()=>(0, _viridisJs.inferno));
parcelHelpers.export(exports, "interpolatePlasma", ()=>(0, _viridisJs.plasma));
var _category10Js = require("./categorical/category10.js");
var _category10JsDefault = parcelHelpers.interopDefault(_category10Js);
var _accentJs = require("./categorical/Accent.js");
var _accentJsDefault = parcelHelpers.interopDefault(_accentJs);
var _dark2Js = require("./categorical/Dark2.js");
var _dark2JsDefault = parcelHelpers.interopDefault(_dark2Js);
var _observable10Js = require("./categorical/observable10.js");
var _observable10JsDefault = parcelHelpers.interopDefault(_observable10Js);
var _pairedJs = require("./categorical/Paired.js");
var _pairedJsDefault = parcelHelpers.interopDefault(_pairedJs);
var _pastel1Js = require("./categorical/Pastel1.js");
var _pastel1JsDefault = parcelHelpers.interopDefault(_pastel1Js);
var _pastel2Js = require("./categorical/Pastel2.js");
var _pastel2JsDefault = parcelHelpers.interopDefault(_pastel2Js);
var _set1Js = require("./categorical/Set1.js");
var _set1JsDefault = parcelHelpers.interopDefault(_set1Js);
var _set2Js = require("./categorical/Set2.js");
var _set2JsDefault = parcelHelpers.interopDefault(_set2Js);
var _set3Js = require("./categorical/Set3.js");
var _set3JsDefault = parcelHelpers.interopDefault(_set3Js);
var _tableau10Js = require("./categorical/Tableau10.js");
var _tableau10JsDefault = parcelHelpers.interopDefault(_tableau10Js);
var _brBGJs = require("./diverging/BrBG.js");
var _brBGJsDefault = parcelHelpers.interopDefault(_brBGJs);
var _prgnJs = require("./diverging/PRGn.js");
var _prgnJsDefault = parcelHelpers.interopDefault(_prgnJs);
var _piYGJs = require("./diverging/PiYG.js");
var _piYGJsDefault = parcelHelpers.interopDefault(_piYGJs);
var _puOrJs = require("./diverging/PuOr.js");
var _puOrJsDefault = parcelHelpers.interopDefault(_puOrJs);
var _rdBuJs = require("./diverging/RdBu.js");
var _rdBuJsDefault = parcelHelpers.interopDefault(_rdBuJs);
var _rdGyJs = require("./diverging/RdGy.js");
var _rdGyJsDefault = parcelHelpers.interopDefault(_rdGyJs);
var _rdYlBuJs = require("./diverging/RdYlBu.js");
var _rdYlBuJsDefault = parcelHelpers.interopDefault(_rdYlBuJs);
var _rdYlGnJs = require("./diverging/RdYlGn.js");
var _rdYlGnJsDefault = parcelHelpers.interopDefault(_rdYlGnJs);
var _spectralJs = require("./diverging/Spectral.js");
var _spectralJsDefault = parcelHelpers.interopDefault(_spectralJs);
var _buGnJs = require("./sequential-multi/BuGn.js");
var _buGnJsDefault = parcelHelpers.interopDefault(_buGnJs);
var _buPuJs = require("./sequential-multi/BuPu.js");
var _buPuJsDefault = parcelHelpers.interopDefault(_buPuJs);
var _gnBuJs = require("./sequential-multi/GnBu.js");
var _gnBuJsDefault = parcelHelpers.interopDefault(_gnBuJs);
var _orRdJs = require("./sequential-multi/OrRd.js");
var _orRdJsDefault = parcelHelpers.interopDefault(_orRdJs);
var _puBuGnJs = require("./sequential-multi/PuBuGn.js");
var _puBuGnJsDefault = parcelHelpers.interopDefault(_puBuGnJs);
var _puBuJs = require("./sequential-multi/PuBu.js");
var _puBuJsDefault = parcelHelpers.interopDefault(_puBuJs);
var _puRdJs = require("./sequential-multi/PuRd.js");
var _puRdJsDefault = parcelHelpers.interopDefault(_puRdJs);
var _rdPuJs = require("./sequential-multi/RdPu.js");
var _rdPuJsDefault = parcelHelpers.interopDefault(_rdPuJs);
var _ylGnBuJs = require("./sequential-multi/YlGnBu.js");
var _ylGnBuJsDefault = parcelHelpers.interopDefault(_ylGnBuJs);
var _ylGnJs = require("./sequential-multi/YlGn.js");
var _ylGnJsDefault = parcelHelpers.interopDefault(_ylGnJs);
var _ylOrBrJs = require("./sequential-multi/YlOrBr.js");
var _ylOrBrJsDefault = parcelHelpers.interopDefault(_ylOrBrJs);
var _ylOrRdJs = require("./sequential-multi/YlOrRd.js");
var _ylOrRdJsDefault = parcelHelpers.interopDefault(_ylOrRdJs);
var _bluesJs = require("./sequential-single/Blues.js");
var _bluesJsDefault = parcelHelpers.interopDefault(_bluesJs);
var _greensJs = require("./sequential-single/Greens.js");
var _greensJsDefault = parcelHelpers.interopDefault(_greensJs);
var _greysJs = require("./sequential-single/Greys.js");
var _greysJsDefault = parcelHelpers.interopDefault(_greysJs);
var _purplesJs = require("./sequential-single/Purples.js");
var _purplesJsDefault = parcelHelpers.interopDefault(_purplesJs);
var _redsJs = require("./sequential-single/Reds.js");
var _redsJsDefault = parcelHelpers.interopDefault(_redsJs);
var _orangesJs = require("./sequential-single/Oranges.js");
var _orangesJsDefault = parcelHelpers.interopDefault(_orangesJs);
var _cividisJs = require("./sequential-multi/cividis.js");
var _cividisJsDefault = parcelHelpers.interopDefault(_cividisJs);
var _cubehelixJs = require("./sequential-multi/cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);
var _rainbowJs = require("./sequential-multi/rainbow.js");
var _rainbowJsDefault = parcelHelpers.interopDefault(_rainbowJs);
var _sinebowJs = require("./sequential-multi/sinebow.js");
var _sinebowJsDefault = parcelHelpers.interopDefault(_sinebowJs);
var _turboJs = require("./sequential-multi/turbo.js");
var _turboJsDefault = parcelHelpers.interopDefault(_turboJs);
var _viridisJs = require("./sequential-multi/viridis.js");
var _viridisJsDefault = parcelHelpers.interopDefault(_viridisJs);

},{"./categorical/category10.js":"jpLdi","./categorical/Accent.js":"5D1Ra","./categorical/Dark2.js":"6rKCe","./categorical/observable10.js":"9cKJK","./categorical/Paired.js":"1NhJ9","./categorical/Pastel1.js":"9EAtH","./categorical/Pastel2.js":"7X9fp","./categorical/Set1.js":"jIw3p","./categorical/Set2.js":"aMpd0","./categorical/Set3.js":"hD9GR","./categorical/Tableau10.js":"4I61U","./diverging/BrBG.js":"e6RYR","./diverging/PRGn.js":"4AMTv","./diverging/PiYG.js":"7tUrn","./diverging/PuOr.js":"j8IRm","./diverging/RdBu.js":"kjLXr","./diverging/RdGy.js":"a6UVJ","./diverging/RdYlBu.js":"iN6Y5","./diverging/RdYlGn.js":"2R17D","./diverging/Spectral.js":"ca5OJ","./sequential-multi/BuGn.js":"1Ig0l","./sequential-multi/BuPu.js":"b5Npc","./sequential-multi/GnBu.js":"gVaPS","./sequential-multi/OrRd.js":"5Cdq4","./sequential-multi/PuBuGn.js":"lyvfz","./sequential-multi/PuBu.js":"ewL5N","./sequential-multi/PuRd.js":"cSHD9","./sequential-multi/RdPu.js":"8s6L9","./sequential-multi/YlGnBu.js":"dYdlm","./sequential-multi/YlGn.js":"eDYnn","./sequential-multi/YlOrBr.js":"hcyRE","./sequential-multi/YlOrRd.js":"aYeeq","./sequential-single/Blues.js":"1vnRm","./sequential-single/Greens.js":"i8ZNO","./sequential-single/Greys.js":"6jZzw","./sequential-single/Purples.js":"95gHf","./sequential-single/Reds.js":"kP2NS","./sequential-single/Oranges.js":"cCHFO","./sequential-multi/cividis.js":"gIGyf","./sequential-multi/cubehelix.js":"6ubQ1","./sequential-multi/rainbow.js":"i3wqc","./sequential-multi/sinebow.js":"dJBdb","./sequential-multi/turbo.js":"6nLpG","./sequential-multi/viridis.js":"gd2pi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jpLdi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");

},{"../colors.js":"j7FVi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j7FVi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(specifier) {
        var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
        while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
        return colors;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5D1Ra":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");

},{"../colors.js":"j7FVi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6rKCe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");

},{"../colors.js":"j7FVi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9cKJK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("4269d0efb118ff725c6cc5b03ca951ff8ab7a463f297bbf59c6b4e9498a0");

},{"../colors.js":"j7FVi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1NhJ9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");

},{"../colors.js":"j7FVi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9EAtH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");

},{"../colors.js":"j7FVi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7X9fp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");

},{"../colors.js":"j7FVi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jIw3p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");

},{"../colors.js":"j7FVi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aMpd0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");

},{"../colors.js":"j7FVi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hD9GR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");

},{"../colors.js":"j7FVi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4I61U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab");

},{"../colors.js":"j7FVi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e6RYR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"j7FVi","../ramp.js":"lGJFm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lGJFm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _d3Interpolate = require("d3-interpolate");
exports.default = (scheme)=>(0, _d3Interpolate.interpolateRgbBasis)(scheme[scheme.length - 1]);

},{"d3-interpolate":[["interpolateRgbBasis","bG7wU","rgbBasis"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4AMTv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"j7FVi","../ramp.js":"lGJFm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7tUrn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"j7FVi","../ramp.js":"lGJFm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j8IRm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"j7FVi","../ramp.js":"lGJFm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kjLXr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"j7FVi","../ramp.js":"lGJFm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a6UVJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"j7FVi","../ramp.js":"lGJFm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iN6Y5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"j7FVi","../ramp.js":"lGJFm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2R17D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"j7FVi","../ramp.js":"lGJFm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ca5OJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"j7FVi","../ramp.js":"lGJFm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1Ig0l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"j7FVi","../ramp.js":"lGJFm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b5Npc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"j7FVi","../ramp.js":"lGJFm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gVaPS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"j7FVi","../ramp.js":"lGJFm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5Cdq4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"j7FVi","../ramp.js":"lGJFm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lyvfz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"j7FVi","../ramp.js":"lGJFm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ewL5N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"j7FVi","../ramp.js":"lGJFm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cSHD9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"j7FVi","../ramp.js":"lGJFm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8s6L9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"j7FVi","../ramp.js":"lGJFm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dYdlm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"j7FVi","../ramp.js":"lGJFm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eDYnn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"j7FVi","../ramp.js":"lGJFm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hcyRE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"j7FVi","../ramp.js":"lGJFm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aYeeq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"j7FVi","../ramp.js":"lGJFm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1vnRm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"j7FVi","../ramp.js":"lGJFm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i8ZNO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"j7FVi","../ramp.js":"lGJFm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6jZzw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"j7FVi","../ramp.js":"lGJFm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"95gHf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"j7FVi","../ramp.js":"lGJFm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kP2NS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"j7FVi","../ramp.js":"lGJFm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cCHFO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"j7FVi","../ramp.js":"lGJFm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gIGyf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(t) {
        t = Math.max(0, Math.min(1, t));
        return "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67))))))) + ")";
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6ubQ1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _d3Color = require("d3-color");
var _d3Interpolate = require("d3-interpolate");
exports.default = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(300, 0.5, 0.0), (0, _d3Color.cubehelix)(-240, 0.5, 1.0));

},{"d3-color":[["cubehelix","b6Cou","default"]],"d3-interpolate":[["interpolateCubehelixLong","8c1po","cubehelixLong"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i3wqc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "warm", ()=>warm);
parcelHelpers.export(exports, "cool", ()=>cool);
parcelHelpers.export(exports, "default", ()=>function(t) {
        if (t < 0 || t > 1) t -= Math.floor(t);
        var ts = Math.abs(t - 0.5);
        c.h = 360 * t - 100;
        c.s = 1.5 - 1.5 * ts;
        c.l = 0.8 - 0.9 * ts;
        return c + "";
    });
var _d3Color = require("d3-color");
var _d3Interpolate = require("d3-interpolate");
var warm = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(-100, 0.75, 0.35), (0, _d3Color.cubehelix)(80, 1.50, 0.8));
var cool = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(260, 0.75, 0.35), (0, _d3Color.cubehelix)(80, 1.50, 0.8));
var c = (0, _d3Color.cubehelix)();

},{"d3-color":[["cubehelix","b6Cou","default"]],"d3-interpolate":[["interpolateCubehelixLong","8c1po","cubehelixLong"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dJBdb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(t) {
        var x;
        t = (0.5 - t) * Math.PI;
        c.r = 255 * (x = Math.sin(t)) * x;
        c.g = 255 * (x = Math.sin(t + pi_1_3)) * x;
        c.b = 255 * (x = Math.sin(t + pi_2_3)) * x;
        return c + "";
    });
var _d3Color = require("d3-color");
var c = (0, _d3Color.rgb)(), pi_1_3 = Math.PI / 3, pi_2_3 = Math.PI * 2 / 3;

},{"d3-color":"cZjkf","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6nLpG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(t) {
        t = Math.max(0, Math.min(1, t));
        return "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66))))))) + ")";
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gd2pi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "magma", ()=>magma);
parcelHelpers.export(exports, "inferno", ()=>inferno);
parcelHelpers.export(exports, "plasma", ()=>plasma);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
function ramp(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}
exports.default = ramp((0, _colorsJsDefault.default)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var magma = ramp((0, _colorsJsDefault.default)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
var inferno = ramp((0, _colorsJsDefault.default)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
var plasma = ramp((0, _colorsJsDefault.default)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

},{"../colors.js":"j7FVi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aa95Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "create", ()=>(0, _createJsDefault.default));
parcelHelpers.export(exports, "creator", ()=>(0, _creatorJsDefault.default));
parcelHelpers.export(exports, "local", ()=>(0, _localJsDefault.default));
parcelHelpers.export(exports, "matcher", ()=>(0, _matcherJsDefault.default));
parcelHelpers.export(exports, "namespace", ()=>(0, _namespaceJsDefault.default));
parcelHelpers.export(exports, "namespaces", ()=>(0, _namespacesJsDefault.default));
parcelHelpers.export(exports, "pointer", ()=>(0, _pointerJsDefault.default));
parcelHelpers.export(exports, "pointers", ()=>(0, _pointersJsDefault.default));
parcelHelpers.export(exports, "select", ()=>(0, _selectJsDefault.default));
parcelHelpers.export(exports, "selectAll", ()=>(0, _selectAllJsDefault.default));
parcelHelpers.export(exports, "selection", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "selector", ()=>(0, _selectorJsDefault.default));
parcelHelpers.export(exports, "selectorAll", ()=>(0, _selectorAllJsDefault.default));
parcelHelpers.export(exports, "style", ()=>(0, _styleJs.styleValue));
parcelHelpers.export(exports, "window", ()=>(0, _windowJsDefault.default));
var _createJs = require("./create.js");
var _createJsDefault = parcelHelpers.interopDefault(_createJs);
var _creatorJs = require("./creator.js");
var _creatorJsDefault = parcelHelpers.interopDefault(_creatorJs);
var _localJs = require("./local.js");
var _localJsDefault = parcelHelpers.interopDefault(_localJs);
var _matcherJs = require("./matcher.js");
var _matcherJsDefault = parcelHelpers.interopDefault(_matcherJs);
var _namespaceJs = require("./namespace.js");
var _namespaceJsDefault = parcelHelpers.interopDefault(_namespaceJs);
var _namespacesJs = require("./namespaces.js");
var _namespacesJsDefault = parcelHelpers.interopDefault(_namespacesJs);
var _pointerJs = require("./pointer.js");
var _pointerJsDefault = parcelHelpers.interopDefault(_pointerJs);
var _pointersJs = require("./pointers.js");
var _pointersJsDefault = parcelHelpers.interopDefault(_pointersJs);
var _selectJs = require("./select.js");
var _selectJsDefault = parcelHelpers.interopDefault(_selectJs);
var _selectAllJs = require("./selectAll.js");
var _selectAllJsDefault = parcelHelpers.interopDefault(_selectAllJs);
var _indexJs = require("./selection/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _selectorJs = require("./selector.js");
var _selectorJsDefault = parcelHelpers.interopDefault(_selectorJs);
var _selectorAllJs = require("./selectorAll.js");
var _selectorAllJsDefault = parcelHelpers.interopDefault(_selectorAllJs);
var _styleJs = require("./selection/style.js");
var _windowJs = require("./window.js");
var _windowJsDefault = parcelHelpers.interopDefault(_windowJs);

},{"./create.js":"N1kwJ","./creator.js":"8Llrx","./local.js":"aouSt","./matcher.js":"iOc8r","./namespace.js":"e2lf9","./namespaces.js":"eaqJV","./pointer.js":"04Hca","./pointers.js":"5chPE","./select.js":"4CEQV","./selectAll.js":"cvTlU","./selection/index.js":"c44R6","./selector.js":"4I2PW","./selectorAll.js":"9H6e7","./selection/style.js":"jEBVs","./window.js":"esh79","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"N1kwJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        return (0, _selectJsDefault.default)((0, _creatorJsDefault.default)(name).call(document.documentElement));
    });
var _creatorJs = require("./creator.js");
var _creatorJsDefault = parcelHelpers.interopDefault(_creatorJs);
var _selectJs = require("./select.js");
var _selectJsDefault = parcelHelpers.interopDefault(_selectJs);

},{"./creator.js":"8Llrx","./select.js":"4CEQV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aouSt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>local);
var nextId = 0;
function local() {
    return new Local;
}
function Local() {
    this._ = "@" + (++nextId).toString(36);
}
Local.prototype = local.prototype = {
    constructor: Local,
    get: function(node) {
        var id = this._;
        while(!(id in node))if (!(node = node.parentNode)) return;
        return node[id];
    },
    set: function(node, value) {
        return node[this._] = value;
    },
    remove: function(node) {
        return this._ in node && delete node[this._];
    },
    toString: function() {
        return this._;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5chPE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(events, node) {
        if (events.target) {
            events = (0, _sourceEventJsDefault.default)(events);
            if (node === undefined) node = events.currentTarget;
            events = events.touches || [
                events
            ];
        }
        return Array.from(events, (event)=>(0, _pointerJsDefault.default)(event, node));
    });
var _pointerJs = require("./pointer.js");
var _pointerJsDefault = parcelHelpers.interopDefault(_pointerJs);
var _sourceEventJs = require("./sourceEvent.js");
var _sourceEventJsDefault = parcelHelpers.interopDefault(_sourceEventJs);

},{"./pointer.js":"04Hca","./sourceEvent.js":"awReS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cvTlU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return typeof selector === "string" ? new (0, _indexJs.Selection)([
            document.querySelectorAll(selector)
        ], [
            document.documentElement
        ]) : new (0, _indexJs.Selection)([
            (0, _arrayJsDefault.default)(selector)
        ], (0, _indexJs.root));
    });
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _indexJs = require("./selection/index.js");

},{"./array.js":"2iarJ","./selection/index.js":"c44R6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1tv6N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arc", ()=>(0, _arcJsDefault.default));
parcelHelpers.export(exports, "area", ()=>(0, _areaJsDefault.default));
parcelHelpers.export(exports, "line", ()=>(0, _lineJsDefault.default));
parcelHelpers.export(exports, "pie", ()=>(0, _pieJsDefault.default));
parcelHelpers.export(exports, "areaRadial", ()=>(0, _areaRadialJsDefault.default)) // Note: radialArea is deprecated!
;
parcelHelpers.export(exports, "radialArea", ()=>(0, _areaRadialJsDefault.default));
parcelHelpers.export(exports, "lineRadial", ()=>(0, _lineRadialJsDefault.default)) // Note: radialLine is deprecated!
;
parcelHelpers.export(exports, "radialLine", ()=>(0, _lineRadialJsDefault.default));
parcelHelpers.export(exports, "pointRadial", ()=>(0, _pointRadialJsDefault.default));
parcelHelpers.export(exports, "link", ()=>(0, _linkJs.link));
parcelHelpers.export(exports, "linkHorizontal", ()=>(0, _linkJs.linkHorizontal));
parcelHelpers.export(exports, "linkVertical", ()=>(0, _linkJs.linkVertical));
parcelHelpers.export(exports, "linkRadial", ()=>(0, _linkJs.linkRadial));
parcelHelpers.export(exports, "symbol", ()=>(0, _symbolJsDefault.default));
parcelHelpers.export(exports, "symbolsStroke", ()=>(0, _symbolJs.symbolsStroke));
parcelHelpers.export(exports, "symbolsFill", ()=>(0, _symbolJs.symbolsFill));
parcelHelpers.export(exports, "symbols", ()=>(0, _symbolJs.symbolsFill));
parcelHelpers.export(exports, "symbolAsterisk", ()=>(0, _asteriskJsDefault.default));
parcelHelpers.export(exports, "symbolCircle", ()=>(0, _circleJsDefault.default));
parcelHelpers.export(exports, "symbolCross", ()=>(0, _crossJsDefault.default));
parcelHelpers.export(exports, "symbolDiamond", ()=>(0, _diamondJsDefault.default));
parcelHelpers.export(exports, "symbolDiamond2", ()=>(0, _diamond2JsDefault.default));
parcelHelpers.export(exports, "symbolPlus", ()=>(0, _plusJsDefault.default));
parcelHelpers.export(exports, "symbolSquare", ()=>(0, _squareJsDefault.default));
parcelHelpers.export(exports, "symbolSquare2", ()=>(0, _square2JsDefault.default));
parcelHelpers.export(exports, "symbolStar", ()=>(0, _starJsDefault.default));
parcelHelpers.export(exports, "symbolTriangle", ()=>(0, _triangleJsDefault.default));
parcelHelpers.export(exports, "symbolTriangle2", ()=>(0, _triangle2JsDefault.default));
parcelHelpers.export(exports, "symbolWye", ()=>(0, _wyeJsDefault.default));
parcelHelpers.export(exports, "symbolTimes", ()=>(0, _timesJsDefault.default));
parcelHelpers.export(exports, "symbolX", ()=>(0, _timesJsDefault.default));
parcelHelpers.export(exports, "curveBasisClosed", ()=>(0, _basisClosedJsDefault.default));
parcelHelpers.export(exports, "curveBasisOpen", ()=>(0, _basisOpenJsDefault.default));
parcelHelpers.export(exports, "curveBasis", ()=>(0, _basisJsDefault.default));
parcelHelpers.export(exports, "curveBumpX", ()=>(0, _bumpJs.bumpX));
parcelHelpers.export(exports, "curveBumpY", ()=>(0, _bumpJs.bumpY));
parcelHelpers.export(exports, "curveBundle", ()=>(0, _bundleJsDefault.default));
parcelHelpers.export(exports, "curveCardinalClosed", ()=>(0, _cardinalClosedJsDefault.default));
parcelHelpers.export(exports, "curveCardinalOpen", ()=>(0, _cardinalOpenJsDefault.default));
parcelHelpers.export(exports, "curveCardinal", ()=>(0, _cardinalJsDefault.default));
parcelHelpers.export(exports, "curveCatmullRomClosed", ()=>(0, _catmullRomClosedJsDefault.default));
parcelHelpers.export(exports, "curveCatmullRomOpen", ()=>(0, _catmullRomOpenJsDefault.default));
parcelHelpers.export(exports, "curveCatmullRom", ()=>(0, _catmullRomJsDefault.default));
parcelHelpers.export(exports, "curveLinearClosed", ()=>(0, _linearClosedJsDefault.default));
parcelHelpers.export(exports, "curveLinear", ()=>(0, _linearJsDefault.default));
parcelHelpers.export(exports, "curveMonotoneX", ()=>(0, _monotoneJs.monotoneX));
parcelHelpers.export(exports, "curveMonotoneY", ()=>(0, _monotoneJs.monotoneY));
parcelHelpers.export(exports, "curveNatural", ()=>(0, _naturalJsDefault.default));
parcelHelpers.export(exports, "curveStep", ()=>(0, _stepJsDefault.default));
parcelHelpers.export(exports, "curveStepAfter", ()=>(0, _stepJs.stepAfter));
parcelHelpers.export(exports, "curveStepBefore", ()=>(0, _stepJs.stepBefore));
parcelHelpers.export(exports, "stack", ()=>(0, _stackJsDefault.default));
parcelHelpers.export(exports, "stackOffsetExpand", ()=>(0, _expandJsDefault.default));
parcelHelpers.export(exports, "stackOffsetDiverging", ()=>(0, _divergingJsDefault.default));
parcelHelpers.export(exports, "stackOffsetNone", ()=>(0, _noneJsDefault.default));
parcelHelpers.export(exports, "stackOffsetSilhouette", ()=>(0, _silhouetteJsDefault.default));
parcelHelpers.export(exports, "stackOffsetWiggle", ()=>(0, _wiggleJsDefault.default));
parcelHelpers.export(exports, "stackOrderAppearance", ()=>(0, _appearanceJsDefault.default));
parcelHelpers.export(exports, "stackOrderAscending", ()=>(0, _ascendingJsDefault.default));
parcelHelpers.export(exports, "stackOrderDescending", ()=>(0, _descendingJsDefault.default));
parcelHelpers.export(exports, "stackOrderInsideOut", ()=>(0, _insideOutJsDefault.default));
parcelHelpers.export(exports, "stackOrderNone", ()=>(0, _noneJsDefault1.default));
parcelHelpers.export(exports, "stackOrderReverse", ()=>(0, _reverseJsDefault.default));
var _arcJs = require("./arc.js");
var _arcJsDefault = parcelHelpers.interopDefault(_arcJs);
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
var _pieJs = require("./pie.js");
var _pieJsDefault = parcelHelpers.interopDefault(_pieJs);
var _areaRadialJs = require("./areaRadial.js");
var _areaRadialJsDefault = parcelHelpers.interopDefault(_areaRadialJs);
var _lineRadialJs = require("./lineRadial.js");
var _lineRadialJsDefault = parcelHelpers.interopDefault(_lineRadialJs);
var _pointRadialJs = require("./pointRadial.js");
var _pointRadialJsDefault = parcelHelpers.interopDefault(_pointRadialJs);
var _linkJs = require("./link.js");
var _symbolJs = require("./symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _asteriskJs = require("./symbol/asterisk.js");
var _asteriskJsDefault = parcelHelpers.interopDefault(_asteriskJs);
var _circleJs = require("./symbol/circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _crossJs = require("./symbol/cross.js");
var _crossJsDefault = parcelHelpers.interopDefault(_crossJs);
var _diamondJs = require("./symbol/diamond.js");
var _diamondJsDefault = parcelHelpers.interopDefault(_diamondJs);
var _diamond2Js = require("./symbol/diamond2.js");
var _diamond2JsDefault = parcelHelpers.interopDefault(_diamond2Js);
var _plusJs = require("./symbol/plus.js");
var _plusJsDefault = parcelHelpers.interopDefault(_plusJs);
var _squareJs = require("./symbol/square.js");
var _squareJsDefault = parcelHelpers.interopDefault(_squareJs);
var _square2Js = require("./symbol/square2.js");
var _square2JsDefault = parcelHelpers.interopDefault(_square2Js);
var _starJs = require("./symbol/star.js");
var _starJsDefault = parcelHelpers.interopDefault(_starJs);
var _triangleJs = require("./symbol/triangle.js");
var _triangleJsDefault = parcelHelpers.interopDefault(_triangleJs);
var _triangle2Js = require("./symbol/triangle2.js");
var _triangle2JsDefault = parcelHelpers.interopDefault(_triangle2Js);
var _wyeJs = require("./symbol/wye.js");
var _wyeJsDefault = parcelHelpers.interopDefault(_wyeJs);
var _timesJs = require("./symbol/times.js");
var _timesJsDefault = parcelHelpers.interopDefault(_timesJs);
var _basisClosedJs = require("./curve/basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _basisOpenJs = require("./curve/basisOpen.js");
var _basisOpenJsDefault = parcelHelpers.interopDefault(_basisOpenJs);
var _basisJs = require("./curve/basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _bumpJs = require("./curve/bump.js");
var _bundleJs = require("./curve/bundle.js");
var _bundleJsDefault = parcelHelpers.interopDefault(_bundleJs);
var _cardinalClosedJs = require("./curve/cardinalClosed.js");
var _cardinalClosedJsDefault = parcelHelpers.interopDefault(_cardinalClosedJs);
var _cardinalOpenJs = require("./curve/cardinalOpen.js");
var _cardinalOpenJsDefault = parcelHelpers.interopDefault(_cardinalOpenJs);
var _cardinalJs = require("./curve/cardinal.js");
var _cardinalJsDefault = parcelHelpers.interopDefault(_cardinalJs);
var _catmullRomClosedJs = require("./curve/catmullRomClosed.js");
var _catmullRomClosedJsDefault = parcelHelpers.interopDefault(_catmullRomClosedJs);
var _catmullRomOpenJs = require("./curve/catmullRomOpen.js");
var _catmullRomOpenJsDefault = parcelHelpers.interopDefault(_catmullRomOpenJs);
var _catmullRomJs = require("./curve/catmullRom.js");
var _catmullRomJsDefault = parcelHelpers.interopDefault(_catmullRomJs);
var _linearClosedJs = require("./curve/linearClosed.js");
var _linearClosedJsDefault = parcelHelpers.interopDefault(_linearClosedJs);
var _linearJs = require("./curve/linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _monotoneJs = require("./curve/monotone.js");
var _naturalJs = require("./curve/natural.js");
var _naturalJsDefault = parcelHelpers.interopDefault(_naturalJs);
var _stepJs = require("./curve/step.js");
var _stepJsDefault = parcelHelpers.interopDefault(_stepJs);
var _stackJs = require("./stack.js");
var _stackJsDefault = parcelHelpers.interopDefault(_stackJs);
var _expandJs = require("./offset/expand.js");
var _expandJsDefault = parcelHelpers.interopDefault(_expandJs);
var _divergingJs = require("./offset/diverging.js");
var _divergingJsDefault = parcelHelpers.interopDefault(_divergingJs);
var _noneJs = require("./offset/none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
var _silhouetteJs = require("./offset/silhouette.js");
var _silhouetteJsDefault = parcelHelpers.interopDefault(_silhouetteJs);
var _wiggleJs = require("./offset/wiggle.js");
var _wiggleJsDefault = parcelHelpers.interopDefault(_wiggleJs);
var _appearanceJs = require("./order/appearance.js");
var _appearanceJsDefault = parcelHelpers.interopDefault(_appearanceJs);
var _ascendingJs = require("./order/ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _descendingJs = require("./order/descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
var _insideOutJs = require("./order/insideOut.js");
var _insideOutJsDefault = parcelHelpers.interopDefault(_insideOutJs);
var _noneJs1 = require("./order/none.js");
var _noneJsDefault1 = parcelHelpers.interopDefault(_noneJs1);
var _reverseJs = require("./order/reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);

},{"./arc.js":"h7igG","./area.js":"2HPHS","./line.js":"4uhfL","./pie.js":"lta7J","./areaRadial.js":"kkYjw","./lineRadial.js":"8UGre","./pointRadial.js":"5cX76","./link.js":"6wN2o","./symbol.js":"kFQt8","./symbol/asterisk.js":"7yuOf","./symbol/circle.js":"hxwzK","./symbol/cross.js":"lAKSk","./symbol/diamond.js":"65NuR","./symbol/diamond2.js":"h7gwW","./symbol/plus.js":"k4gHL","./symbol/square.js":"dRaOu","./symbol/square2.js":"eNxbt","./symbol/star.js":"gKyk0","./symbol/triangle.js":"40Hhf","./symbol/triangle2.js":"8exgR","./symbol/wye.js":"jP73p","./symbol/times.js":"fguTY","./curve/basisClosed.js":"37kO7","./curve/basisOpen.js":"hSSEq","./curve/basis.js":"fgTmG","./curve/bump.js":"g5NSm","./curve/bundle.js":"beXYC","./curve/cardinalClosed.js":"3zkf0","./curve/cardinalOpen.js":"ltWuC","./curve/cardinal.js":"Rduof","./curve/catmullRomClosed.js":"3nauk","./curve/catmullRomOpen.js":"hJOJZ","./curve/catmullRom.js":"ikgoz","./curve/linearClosed.js":"cL4IC","./curve/linear.js":"6Ipvl","./curve/monotone.js":"deXBO","./curve/natural.js":"yX1t5","./curve/step.js":"dWNDX","./stack.js":"644xv","./offset/expand.js":"blacZ","./offset/diverging.js":"cplmt","./offset/none.js":"iTwDZ","./offset/silhouette.js":"24GPI","./offset/wiggle.js":"ciL3Y","./order/appearance.js":"rZ3m3","./order/ascending.js":"gR75c","./order/descending.js":"2vwuQ","./order/insideOut.js":"3iSXc","./order/none.js":"erSjM","./order/reverse.js":"kwUoF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h7igG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var innerRadius = arcInnerRadius, outerRadius = arcOuterRadius, cornerRadius = (0, _constantJsDefault.default)(0), padRadius = null, startAngle = arcStartAngle, endAngle = arcEndAngle, padAngle = arcPadAngle, context = null, path = (0, _pathJs.withPath)(arc);
        function arc() {
            var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - (0, _mathJs.halfPi), a1 = endAngle.apply(this, arguments) - (0, _mathJs.halfPi), da = (0, _mathJs.abs)(a1 - a0), cw = a1 > a0;
            if (!context) context = buffer = path();
            // Ensure that the outer radius is always larger than the inner radius.
            if (r1 < r0) r = r1, r1 = r0, r0 = r;
            // Is it a point?
            if (!(r1 > (0, _mathJs.epsilon))) context.moveTo(0, 0);
            else if (da > (0, _mathJs.tau) - (0, _mathJs.epsilon)) {
                context.moveTo(r1 * (0, _mathJs.cos)(a0), r1 * (0, _mathJs.sin)(a0));
                context.arc(0, 0, r1, a0, a1, !cw);
                if (r0 > (0, _mathJs.epsilon)) {
                    context.moveTo(r0 * (0, _mathJs.cos)(a1), r0 * (0, _mathJs.sin)(a1));
                    context.arc(0, 0, r0, a1, a0, cw);
                }
            } else {
                var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > (0, _mathJs.epsilon) && (padRadius ? +padRadius.apply(this, arguments) : (0, _mathJs.sqrt)(r0 * r0 + r1 * r1)), rc = (0, _mathJs.min)((0, _mathJs.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
                // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
                if (rp > (0, _mathJs.epsilon)) {
                    var p0 = (0, _mathJs.asin)(rp / r0 * (0, _mathJs.sin)(ap)), p1 = (0, _mathJs.asin)(rp / r1 * (0, _mathJs.sin)(ap));
                    if ((da0 -= p0 * 2) > (0, _mathJs.epsilon)) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                    else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                    if ((da1 -= p1 * 2) > (0, _mathJs.epsilon)) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                    else da1 = 0, a01 = a11 = (a0 + a1) / 2;
                }
                var x01 = r1 * (0, _mathJs.cos)(a01), y01 = r1 * (0, _mathJs.sin)(a01), x10 = r0 * (0, _mathJs.cos)(a10), y10 = r0 * (0, _mathJs.sin)(a10);
                // Apply rounded corners?
                if (rc > (0, _mathJs.epsilon)) {
                    var x11 = r1 * (0, _mathJs.cos)(a11), y11 = r1 * (0, _mathJs.sin)(a11), x00 = r0 * (0, _mathJs.cos)(a00), y00 = r0 * (0, _mathJs.sin)(a00), oc;
                    // Restrict the corner radius according to the sector angle. If this
                    // intersection fails, it’s probably because the arc is too small, so
                    // disable the corner radius entirely.
                    if (da < (0, _mathJs.pi)) {
                        if (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10)) {
                            var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, _mathJs.sin)((0, _mathJs.acos)((ax * bx + ay * by) / ((0, _mathJs.sqrt)(ax * ax + ay * ay) * (0, _mathJs.sqrt)(bx * bx + by * by))) / 2), lc = (0, _mathJs.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                            rc0 = (0, _mathJs.min)(rc, (r0 - lc) / (kc - 1));
                            rc1 = (0, _mathJs.min)(rc, (r1 - lc) / (kc + 1));
                        } else rc0 = rc1 = 0;
                    }
                }
                // Is the sector collapsed to a line?
                if (!(da1 > (0, _mathJs.epsilon))) context.moveTo(x01, y01);
                else if (rc1 > (0, _mathJs.epsilon)) {
                    t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                    t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                    context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                    // Have the corners merged?
                    if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    else {
                        context.arc(t0.cx, t0.cy, rc1, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t0.y11, t0.x11), !cw);
                        context.arc(0, 0, r1, (0, _mathJs.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _mathJs.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                        context.arc(t1.cx, t1.cy, rc1, (0, _mathJs.atan2)(t1.y11, t1.x11), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    }
                } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
                // Is there no inner ring, and it’s a circular sector?
                // Or perhaps it’s an annular sector collapsed due to padding?
                if (!(r0 > (0, _mathJs.epsilon)) || !(da0 > (0, _mathJs.epsilon))) context.lineTo(x10, y10);
                else if (rc0 > (0, _mathJs.epsilon)) {
                    t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                    t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                    context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                    // Have the corners merged?
                    if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    else {
                        context.arc(t0.cx, t0.cy, rc0, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t0.y11, t0.x11), !cw);
                        context.arc(0, 0, r0, (0, _mathJs.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _mathJs.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                        context.arc(t1.cx, t1.cy, rc0, (0, _mathJs.atan2)(t1.y11, t1.x11), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    }
                } else context.arc(0, 0, r0, a10, a00, cw);
            }
            context.closePath();
            if (buffer) return context = null, buffer + "" || null;
        }
        arc.centroid = function() {
            var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - (0, _mathJs.pi) / 2;
            return [
                (0, _mathJs.cos)(a) * r,
                (0, _mathJs.sin)(a) * r
            ];
        };
        arc.innerRadius = function(_) {
            return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : innerRadius;
        };
        arc.outerRadius = function(_) {
            return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : outerRadius;
        };
        arc.cornerRadius = function(_) {
            return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : cornerRadius;
        };
        arc.padRadius = function(_) {
            return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : padRadius;
        };
        arc.startAngle = function(_) {
            return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : startAngle;
        };
        arc.endAngle = function(_) {
            return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : endAngle;
        };
        arc.padAngle = function(_) {
            return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : padAngle;
        };
        arc.context = function(_) {
            return arguments.length ? (context = _ == null ? null : _, arc) : context;
        };
        return arc;
    });
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _mathJs = require("./math.js");
var _pathJs = require("./path.js");
function arcInnerRadius(d) {
    return d.innerRadius;
}
function arcOuterRadius(d) {
    return d.outerRadius;
}
function arcStartAngle(d) {
    return d.startAngle;
}
function arcEndAngle(d) {
    return d.endAngle;
}
function arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < (0, _mathJs.epsilon)) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, _mathJs.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, _mathJs.sqrt)((0, _mathJs.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}

},{"./constant.js":"9KS39","./math.js":"kMcO8","./path.js":"5OBEk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9KS39":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function constant() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kMcO8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "abs", ()=>abs);
parcelHelpers.export(exports, "atan2", ()=>atan2);
parcelHelpers.export(exports, "cos", ()=>cos);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "sin", ()=>sin);
parcelHelpers.export(exports, "sqrt", ()=>sqrt);
parcelHelpers.export(exports, "epsilon", ()=>epsilon);
parcelHelpers.export(exports, "pi", ()=>pi);
parcelHelpers.export(exports, "halfPi", ()=>halfPi);
parcelHelpers.export(exports, "tau", ()=>tau);
parcelHelpers.export(exports, "acos", ()=>acos);
parcelHelpers.export(exports, "asin", ()=>asin);
const abs = Math.abs;
const atan2 = Math.atan2;
const cos = Math.cos;
const max = Math.max;
const min = Math.min;
const sin = Math.sin;
const sqrt = Math.sqrt;
const epsilon = 1e-12;
const pi = Math.PI;
const halfPi = pi / 2;
const tau = 2 * pi;
function acos(x) {
    return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}
function asin(x) {
    return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5OBEk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withPath", ()=>withPath);
var _d3Path = require("d3-path");
function withPath(shape) {
    let digits = 3;
    shape.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        return shape;
    };
    return ()=>new (0, _d3Path.Path)(digits);
}

},{"d3-path":"jFrOU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2HPHS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x0, y0, y1) {
        var x1 = null, defined = (0, _constantJsDefault.default)(true), context = null, curve = (0, _linearJsDefault.default), output = null, path = (0, _pathJs.withPath)(area);
        x0 = typeof x0 === "function" ? x0 : x0 === undefined ? (0, _pointJs.x) : (0, _constantJsDefault.default)(+x0);
        y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, _constantJsDefault.default)(0) : (0, _constantJsDefault.default)(+y0);
        y1 = typeof y1 === "function" ? y1 : y1 === undefined ? (0, _pointJs.y) : (0, _constantJsDefault.default)(+y1);
        function area(data) {
            var i, j, k, n = (data = (0, _arrayJsDefault.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
            if (context == null) output = curve(buffer = path());
            for(i = 0; i <= n; ++i){
                if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                    if (defined0 = !defined0) {
                        j = i;
                        output.areaStart();
                        output.lineStart();
                    } else {
                        output.lineEnd();
                        output.lineStart();
                        for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                        output.lineEnd();
                        output.areaEnd();
                    }
                }
                if (defined0) {
                    x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                    output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
                }
            }
            if (buffer) return output = null, buffer + "" || null;
        }
        function arealine() {
            return (0, _lineJsDefault.default)().defined(defined).curve(curve).context(context);
        }
        area.x = function(_) {
            return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), x1 = null, area) : x0;
        };
        area.x0 = function(_) {
            return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : x0;
        };
        area.x1 = function(_) {
            return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : x1;
        };
        area.y = function(_) {
            return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), y1 = null, area) : y0;
        };
        area.y0 = function(_) {
            return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : y0;
        };
        area.y1 = function(_) {
            return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : y1;
        };
        area.lineX0 = area.lineY0 = function() {
            return arealine().x(x0).y(y0);
        };
        area.lineY1 = function() {
            return arealine().x(x0).y(y1);
        };
        area.lineX1 = function() {
            return arealine().x(x1).y(y0);
        };
        area.defined = function(_) {
            return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), area) : defined;
        };
        area.curve = function(_) {
            return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
        };
        area.context = function(_) {
            return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
        };
        return area;
    });
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _linearJs = require("./curve/linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
var _pathJs = require("./path.js");
var _pointJs = require("./point.js");

},{"./array.js":"i1x8O","./constant.js":"9KS39","./curve/linear.js":"6Ipvl","./line.js":"4uhfL","./path.js":"5OBEk","./point.js":"aihDY","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i1x8O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", ()=>slice);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
         : Array.from(x); // Map, Set, iterable, string, or anything else
    });
var slice = Array.prototype.slice;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6Ipvl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Linear(context);
    });
function Linear(context) {
    this._context = context;
}
Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4uhfL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y) {
        var defined = (0, _constantJsDefault.default)(true), context = null, curve = (0, _linearJsDefault.default), output = null, path = (0, _pathJs.withPath)(line);
        x = typeof x === "function" ? x : x === undefined ? (0, _pointJs.x) : (0, _constantJsDefault.default)(x);
        y = typeof y === "function" ? y : y === undefined ? (0, _pointJs.y) : (0, _constantJsDefault.default)(y);
        function line(data) {
            var i, n = (data = (0, _arrayJsDefault.default)(data)).length, d, defined0 = false, buffer;
            if (context == null) output = curve(buffer = path());
            for(i = 0; i <= n; ++i){
                if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                    if (defined0 = !defined0) output.lineStart();
                    else output.lineEnd();
                }
                if (defined0) output.point(+x(d, i, data), +y(d, i, data));
            }
            if (buffer) return output = null, buffer + "" || null;
        }
        line.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), line) : x;
        };
        line.y = function(_) {
            return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), line) : y;
        };
        line.defined = function(_) {
            return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), line) : defined;
        };
        line.curve = function(_) {
            return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
        };
        line.context = function(_) {
            return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
        };
        return line;
    });
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _linearJs = require("./curve/linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _pathJs = require("./path.js");
var _pointJs = require("./point.js");

},{"./array.js":"i1x8O","./constant.js":"9KS39","./curve/linear.js":"6Ipvl","./path.js":"5OBEk","./point.js":"aihDY","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aihDY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "x", ()=>x);
parcelHelpers.export(exports, "y", ()=>y);
function x(p) {
    return p[0];
}
function y(p) {
    return p[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lta7J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var value = (0, _identityJsDefault.default), sortValues = (0, _descendingJsDefault.default), sort = null, startAngle = (0, _constantJsDefault.default)(0), endAngle = (0, _constantJsDefault.default)((0, _mathJs.tau)), padAngle = (0, _constantJsDefault.default)(0);
        function pie(data) {
            var i, n = (data = (0, _arrayJsDefault.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min((0, _mathJs.tau), Math.max(-(0, _mathJs.tau), endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
            for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
            // Optionally sort the arcs by previously-computed values or by data.
            if (sortValues != null) index.sort(function(i, j) {
                return sortValues(arcs[i], arcs[j]);
            });
            else if (sort != null) index.sort(function(i, j) {
                return sort(data[i], data[j]);
            });
            // Compute the arcs! They are stored in the original data's order.
            for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
                data: data[j],
                index: i,
                value: v,
                startAngle: a0,
                endAngle: a1,
                padAngle: p
            };
            return arcs;
        }
        pie.value = function(_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : value;
        };
        pie.sortValues = function(_) {
            return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
        };
        pie.sort = function(_) {
            return arguments.length ? (sort = _, sortValues = null, pie) : sort;
        };
        pie.startAngle = function(_) {
            return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : startAngle;
        };
        pie.endAngle = function(_) {
            return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : endAngle;
        };
        pie.padAngle = function(_) {
            return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : padAngle;
        };
        return pie;
    });
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _descendingJs = require("./descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _mathJs = require("./math.js");

},{"./array.js":"i1x8O","./constant.js":"9KS39","./descending.js":"fkRxi","./identity.js":"gU6PP","./math.js":"kMcO8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fkRxi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gU6PP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(d) {
        return d;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kkYjw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var a = (0, _areaJsDefault.default)().curve((0, _radialJs.curveRadialLinear)), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
        a.angle = a.x, delete a.x;
        a.startAngle = a.x0, delete a.x0;
        a.endAngle = a.x1, delete a.x1;
        a.radius = a.y, delete a.y;
        a.innerRadius = a.y0, delete a.y0;
        a.outerRadius = a.y1, delete a.y1;
        a.lineStartAngle = function() {
            return (0, _lineRadialJs.lineRadial)(x0());
        }, delete a.lineX0;
        a.lineEndAngle = function() {
            return (0, _lineRadialJs.lineRadial)(x1());
        }, delete a.lineX1;
        a.lineInnerRadius = function() {
            return (0, _lineRadialJs.lineRadial)(y0());
        }, delete a.lineY0;
        a.lineOuterRadius = function() {
            return (0, _lineRadialJs.lineRadial)(y1());
        }, delete a.lineY1;
        a.curve = function(_) {
            return arguments.length ? c((0, _radialJsDefault.default)(_)) : c()._curve;
        };
        return a;
    });
var _radialJs = require("./curve/radial.js");
var _radialJsDefault = parcelHelpers.interopDefault(_radialJs);
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _lineRadialJs = require("./lineRadial.js");

},{"./curve/radial.js":"9Z9br","./area.js":"2HPHS","./lineRadial.js":"8UGre","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9Z9br":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "curveRadialLinear", ()=>curveRadialLinear);
parcelHelpers.export(exports, "default", ()=>curveRadial);
var _linearJs = require("./linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var curveRadialLinear = curveRadial((0, _linearJsDefault.default));
function Radial(curve) {
    this._curve = curve;
}
Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function curveRadial(curve) {
    function radial(context) {
        return new Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

},{"./linear.js":"6Ipvl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8UGre":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lineRadial", ()=>lineRadial);
parcelHelpers.export(exports, "default", ()=>function() {
        return lineRadial((0, _lineJsDefault.default)().curve((0, _radialJs.curveRadialLinear)));
    });
var _radialJs = require("./curve/radial.js");
var _radialJsDefault = parcelHelpers.interopDefault(_radialJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
function lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, _radialJsDefault.default)(_)) : c()._curve;
    };
    return l;
}

},{"./curve/radial.js":"9Z9br","./line.js":"4uhfL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5cX76":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y) {
        return [
            (y = +y) * Math.cos(x -= Math.PI / 2),
            y * Math.sin(x)
        ];
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6wN2o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "link", ()=>link);
parcelHelpers.export(exports, "linkHorizontal", ()=>linkHorizontal);
parcelHelpers.export(exports, "linkVertical", ()=>linkVertical);
parcelHelpers.export(exports, "linkRadial", ()=>linkRadial);
var _arrayJs = require("./array.js");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _bumpJs = require("./curve/bump.js");
var _pathJs = require("./path.js");
var _pointJs = require("./point.js");
function linkSource(d) {
    return d.source;
}
function linkTarget(d) {
    return d.target;
}
function link(curve) {
    let source = linkSource, target = linkTarget, x = (0, _pointJs.x), y = (0, _pointJs.y), context = null, output = null, path = (0, _pathJs.withPath)(link);
    function link() {
        let buffer;
        const argv = (0, _arrayJs.slice).call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = path());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function linkHorizontal() {
    return link((0, _bumpJs.bumpX));
}
function linkVertical() {
    return link((0, _bumpJs.bumpY));
}
function linkRadial() {
    const l = link((0, _bumpJs.bumpRadial));
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

},{"./array.js":"i1x8O","./constant.js":"9KS39","./curve/bump.js":"g5NSm","./path.js":"5OBEk","./point.js":"aihDY","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g5NSm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bumpX", ()=>bumpX);
parcelHelpers.export(exports, "bumpY", ()=>bumpY);
parcelHelpers.export(exports, "bumpRadial", ()=>bumpRadial);
var _pointRadialJs = require("../pointRadial.js");
var _pointRadialJsDefault = parcelHelpers.interopDefault(_pointRadialJs);
class Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point === 0) this._point = 1;
        else {
            const p0 = (0, _pointRadialJsDefault.default)(this._x0, this._y0);
            const p1 = (0, _pointRadialJsDefault.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, _pointRadialJsDefault.default)(x, this._y0);
            const p3 = (0, _pointRadialJsDefault.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
        this._x0 = x, this._y0 = y;
    }
}
function bumpX(context) {
    return new Bump(context, true);
}
function bumpY(context) {
    return new Bump(context, false);
}
function bumpRadial(context) {
    return new BumpRadial(context);
}

},{"../pointRadial.js":"5cX76","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kFQt8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "symbolsFill", ()=>symbolsFill);
parcelHelpers.export(exports, "symbolsStroke", ()=>symbolsStroke);
parcelHelpers.export(exports, "default", ()=>Symbol);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _pathJs = require("./path.js");
var _asteriskJs = require("./symbol/asterisk.js");
var _asteriskJsDefault = parcelHelpers.interopDefault(_asteriskJs);
var _circleJs = require("./symbol/circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _crossJs = require("./symbol/cross.js");
var _crossJsDefault = parcelHelpers.interopDefault(_crossJs);
var _diamondJs = require("./symbol/diamond.js");
var _diamondJsDefault = parcelHelpers.interopDefault(_diamondJs);
var _diamond2Js = require("./symbol/diamond2.js");
var _diamond2JsDefault = parcelHelpers.interopDefault(_diamond2Js);
var _plusJs = require("./symbol/plus.js");
var _plusJsDefault = parcelHelpers.interopDefault(_plusJs);
var _squareJs = require("./symbol/square.js");
var _squareJsDefault = parcelHelpers.interopDefault(_squareJs);
var _square2Js = require("./symbol/square2.js");
var _square2JsDefault = parcelHelpers.interopDefault(_square2Js);
var _starJs = require("./symbol/star.js");
var _starJsDefault = parcelHelpers.interopDefault(_starJs);
var _triangleJs = require("./symbol/triangle.js");
var _triangleJsDefault = parcelHelpers.interopDefault(_triangleJs);
var _triangle2Js = require("./symbol/triangle2.js");
var _triangle2JsDefault = parcelHelpers.interopDefault(_triangle2Js);
var _wyeJs = require("./symbol/wye.js");
var _wyeJsDefault = parcelHelpers.interopDefault(_wyeJs);
var _timesJs = require("./symbol/times.js");
var _timesJsDefault = parcelHelpers.interopDefault(_timesJs);
const symbolsFill = [
    (0, _circleJsDefault.default),
    (0, _crossJsDefault.default),
    (0, _diamondJsDefault.default),
    (0, _squareJsDefault.default),
    (0, _starJsDefault.default),
    (0, _triangleJsDefault.default),
    (0, _wyeJsDefault.default)
];
const symbolsStroke = [
    (0, _circleJsDefault.default),
    (0, _plusJsDefault.default),
    (0, _timesJsDefault.default),
    (0, _triangle2JsDefault.default),
    (0, _asteriskJsDefault.default),
    (0, _square2JsDefault.default),
    (0, _diamond2JsDefault.default)
];
function Symbol(type, size) {
    let context = null, path = (0, _pathJs.withPath)(symbol);
    type = typeof type === "function" ? type : (0, _constantJsDefault.default)(type || (0, _circleJsDefault.default));
    size = typeof size === "function" ? size : (0, _constantJsDefault.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = path();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

},{"./constant.js":"9KS39","./path.js":"5OBEk","./symbol/asterisk.js":"7yuOf","./symbol/circle.js":"hxwzK","./symbol/cross.js":"lAKSk","./symbol/diamond.js":"65NuR","./symbol/diamond2.js":"h7gwW","./symbol/plus.js":"k4gHL","./symbol/square.js":"dRaOu","./symbol/square2.js":"eNxbt","./symbol/star.js":"gKyk0","./symbol/triangle.js":"40Hhf","./symbol/triangle2.js":"8exgR","./symbol/wye.js":"jP73p","./symbol/times.js":"fguTY","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7yuOf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
const sqrt3 = (0, _mathJs.sqrt)(3);
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size + (0, _mathJs.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};

},{"../math.js":"kMcO8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hxwzK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size / (0, _mathJs.pi));
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, (0, _mathJs.tau));
    }
};

},{"../math.js":"kMcO8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lAKSk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};

},{"../math.js":"kMcO8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"65NuR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
const tan30 = (0, _mathJs.sqrt)(1 / 3);
const tan30_2 = tan30 * 2;
exports.default = {
    draw (context, size) {
        const y = (0, _mathJs.sqrt)(size / tan30_2);
        const x = y * tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};

},{"../math.js":"kMcO8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h7gwW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};

},{"../math.js":"kMcO8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k4gHL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size - (0, _mathJs.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};

},{"../math.js":"kMcO8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dRaOu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw (context, size) {
        const w = (0, _mathJs.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};

},{"../math.js":"kMcO8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eNxbt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};

},{"../math.js":"kMcO8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gKyk0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
const ka = 0.89081309152928522810;
const kr = (0, _mathJs.sin)((0, _mathJs.pi) / 10) / (0, _mathJs.sin)(7 * (0, _mathJs.pi) / 10);
const kx = (0, _mathJs.sin)((0, _mathJs.tau) / 10) * kr;
const ky = -(0, _mathJs.cos)((0, _mathJs.tau) / 10) * kr;
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size * ka);
        const x = kx * r;
        const y = ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = (0, _mathJs.tau) * i / 5;
            const c = (0, _mathJs.cos)(a);
            const s = (0, _mathJs.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};

},{"../math.js":"kMcO8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"40Hhf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
const sqrt3 = (0, _mathJs.sqrt)(3);
exports.default = {
    draw (context, size) {
        const y = -(0, _mathJs.sqrt)(size / (sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-sqrt3 * y, -y);
        context.lineTo(sqrt3 * y, -y);
        context.closePath();
    }
};

},{"../math.js":"kMcO8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8exgR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
const sqrt3 = (0, _mathJs.sqrt)(3);
exports.default = {
    draw (context, size) {
        const s = (0, _mathJs.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};

},{"../math.js":"kMcO8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jP73p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
const c = -0.5;
const s = (0, _mathJs.sqrt)(3) / 2;
const k = 1 / (0, _mathJs.sqrt)(12);
const a = (k / 2 + 1) * 3;
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size / a);
        const x0 = r / 2, y0 = r * k;
        const x1 = x0, y1 = r * k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
        context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
        context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
        context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
        context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
        context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
        context.closePath();
    }
};

},{"../math.js":"kMcO8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fguTY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw (context, size) {
        const r = (0, _mathJs.sqrt)(size - (0, _mathJs.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};

},{"../math.js":"kMcO8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"37kO7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new BasisClosed(context);
    });
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _basisJs = require("./basis.js");
function BasisClosed(context) {
    this._context = context;
}
BasisClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, _basisJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};

},{"../noop.js":"41zTG","./basis.js":"fgTmG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"41zTG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fgTmG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "point", ()=>point);
parcelHelpers.export(exports, "Basis", ()=>Basis);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Basis(context);
    });
function point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function Basis(context) {
    this._context = context;
}
Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                point(this, this._x1, this._y1); // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // falls through
            default:
                point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hSSEq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new BasisOpen(context);
    });
var _basisJs = require("./basis.js");
function BasisOpen(context) {
    this._context = context;
}
BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, _basisJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};

},{"./basis.js":"fgTmG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"beXYC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _basisJs = require("./basis.js");
function Bundle(context, beta) {
    this._basis = new (0, _basisJs.Basis)(context);
    this._beta = beta;
}
Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
exports.default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new (0, _basisJs.Basis)(context) : new Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);

},{"./basis.js":"fgTmG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3zkf0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardinalClosed", ()=>CardinalClosed);
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _cardinalJs = require("./cardinal.js");
function CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
CardinalClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, _cardinalJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(tension) {
    function cardinal(context) {
        return new CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

},{"../noop.js":"41zTG","./cardinal.js":"Rduof","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"Rduof":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "point", ()=>point);
parcelHelpers.export(exports, "Cardinal", ()=>Cardinal);
function point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3; // falls through
            default:
                point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(tension) {
    function cardinal(context) {
        return new Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ltWuC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardinalOpen", ()=>CardinalOpen);
var _cardinalJs = require("./cardinal.js");
function CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, _cardinalJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(tension) {
    function cardinal(context) {
        return new CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

},{"./cardinal.js":"Rduof","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3nauk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cardinalClosedJs = require("./cardinalClosed.js");
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _catmullRomJs = require("./catmullRom.js");
function CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRomClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, _catmullRomJs.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRomClosed(context, alpha) : new (0, _cardinalClosedJs.CardinalClosed)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

},{"./cardinalClosed.js":"3zkf0","../noop.js":"41zTG","./catmullRom.js":"ikgoz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ikgoz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "point", ()=>point);
var _mathJs = require("../math.js");
var _cardinalJs = require("./cardinal.js");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > (0, _mathJs.epsilon)) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > (0, _mathJs.epsilon)) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3; // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new (0, _cardinalJs.Cardinal)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

},{"../math.js":"kMcO8","./cardinal.js":"Rduof","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hJOJZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cardinalOpenJs = require("./cardinalOpen.js");
var _catmullRomJs = require("./catmullRom.js");
function CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, _catmullRomJs.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRomOpen(context, alpha) : new (0, _cardinalOpenJs.CardinalOpen)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

},{"./cardinalOpen.js":"ltWuC","./catmullRom.js":"ikgoz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cL4IC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new LinearClosed(context);
    });
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
function LinearClosed(context) {
    this._context = context;
}
LinearClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};

},{"../noop.js":"41zTG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"deXBO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "monotoneX", ()=>monotoneX);
parcelHelpers.export(exports, "monotoneY", ()=>monotoneY);
function sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function MonotoneX(context) {
    this._context = context;
}
MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                point(this, this._t0, slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                point(this, slope2(this, t1 = slope3(this, x, y)), t1);
                break;
            default:
                point(this, this._t0, t1 = slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function MonotoneY(context) {
    this._context = new ReflectContext(context);
}
(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
    MonotoneX.prototype.point.call(this, y, x);
};
function ReflectContext(context) {
    this._context = context;
}
ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function monotoneX(context) {
    return new MonotoneX(context);
}
function monotoneY(context) {
    return new MonotoneY(context);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"yX1t5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Natural(context);
    });
function Natural(context) {
    this._context = context;
}
Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = controlPoints(x), py = controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dWNDX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Step(context, 0.5);
    });
parcelHelpers.export(exports, "stepBefore", ()=>stepBefore);
parcelHelpers.export(exports, "stepAfter", ()=>stepAfter);
function Step(context, t) {
    this._context = context;
    this._t = t;
}
Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function stepBefore(context) {
    return new Step(context, 0);
}
function stepAfter(context) {
    return new Step(context, 1);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"644xv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var keys = (0, _constantJsDefault.default)([]), order = (0, _noneJsDefault1.default), offset = (0, _noneJsDefault.default), value = stackValue;
        function stack(data) {
            var sz = Array.from(keys.apply(this, arguments), stackSeries), i, n = sz.length, j = -1, oz;
            for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
                0,
                +value(d, sz[i].key, j, data)
            ]).data = d;
            for(i = 0, oz = (0, _arrayJsDefault.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
            offset(sz, oz);
            return sz;
        }
        stack.keys = function(_) {
            return arguments.length ? (keys = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(Array.from(_)), stack) : keys;
        };
        stack.value = function(_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), stack) : value;
        };
        stack.order = function(_) {
            return arguments.length ? (order = _ == null ? (0, _noneJsDefault1.default) : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(Array.from(_)), stack) : order;
        };
        stack.offset = function(_) {
            return arguments.length ? (offset = _ == null ? (0, _noneJsDefault.default) : _, stack) : offset;
        };
        return stack;
    });
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _noneJs = require("./offset/none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
var _noneJs1 = require("./order/none.js");
var _noneJsDefault1 = parcelHelpers.interopDefault(_noneJs1);
function stackValue(d, key) {
    return d[key];
}
function stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}

},{"./array.js":"i1x8O","./constant.js":"9KS39","./offset/none.js":"iTwDZ","./order/none.js":"erSjM","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iTwDZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series, order) {
        if (!((n = series.length) > 1)) return;
        for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
            s0 = s1, s1 = series[order[i]];
            for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"erSjM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        var n = series.length, o = new Array(n);
        while(--n >= 0)o[n] = n;
        return o;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"blacZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
            for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
            if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
        }
        (0, _noneJsDefault.default)(series, order);
    });
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"iTwDZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cplmt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
            if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
            else if (dy < 0) d[1] = yn, d[0] = yn += dy;
            else d[0] = 0, d[1] = dy;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"24GPI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
            for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
            s0[j][1] += s0[j][0] = -y / 2;
        }
        (0, _noneJsDefault.default)(series, order);
    });
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"iTwDZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ciL3Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series, order) {
        if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
        for(var y = 0, j = 1, s0, m, n; j < m; ++j){
            for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
                var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
                for(var k = 0; k < i; ++k){
                    var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                    s3 += skj0 - skj1;
                }
                s1 += sij0, s2 += s3 * sij0;
            }
            s0[j - 1][1] += s0[j - 1][0] = y;
            if (s1) y -= s2 / s1;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        (0, _noneJsDefault.default)(series, order);
    });
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"iTwDZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"rZ3m3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        var peaks = series.map(peak);
        return (0, _noneJsDefault.default)(series).sort(function(a, b) {
            return peaks[a] - peaks[b];
        });
    });
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
function peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

},{"./none.js":"erSjM","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gR75c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        var sums = series.map(sum);
        return (0, _noneJsDefault.default)(series).sort(function(a, b) {
            return sums[a] - sums[b];
        });
    });
parcelHelpers.export(exports, "sum", ()=>sum);
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
function sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

},{"./none.js":"erSjM","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2vwuQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        return (0, _ascendingJsDefault.default)(series).reverse();
    });
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);

},{"./ascending.js":"gR75c","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3iSXc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        var n = series.length, i, j, sums = series.map((0, _ascendingJs.sum)), order = (0, _appearanceJsDefault.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
        for(i = 0; i < n; ++i){
            j = order[i];
            if (top < bottom) {
                top += sums[j];
                tops.push(j);
            } else {
                bottom += sums[j];
                bottoms.push(j);
            }
        }
        return bottoms.reverse().concat(tops);
    });
var _appearanceJs = require("./appearance.js");
var _appearanceJsDefault = parcelHelpers.interopDefault(_appearanceJs);
var _ascendingJs = require("./ascending.js");

},{"./appearance.js":"rZ3m3","./ascending.js":"gR75c","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kwUoF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        return (0, _noneJsDefault.default)(series).reverse();
    });
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"erSjM","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5UzaV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeInterval", ()=>(0, _intervalJs.timeInterval));
parcelHelpers.export(exports, "utcMillisecond", ()=>(0, _millisecondJs.millisecond));
parcelHelpers.export(exports, "utcMilliseconds", ()=>(0, _millisecondJs.milliseconds));
parcelHelpers.export(exports, "timeMillisecond", ()=>(0, _millisecondJs.millisecond));
parcelHelpers.export(exports, "timeMilliseconds", ()=>(0, _millisecondJs.milliseconds));
parcelHelpers.export(exports, "utcSecond", ()=>(0, _secondJs.second));
parcelHelpers.export(exports, "utcSeconds", ()=>(0, _secondJs.seconds));
parcelHelpers.export(exports, "timeSecond", ()=>(0, _secondJs.second));
parcelHelpers.export(exports, "timeSeconds", ()=>(0, _secondJs.seconds));
parcelHelpers.export(exports, "timeMinute", ()=>(0, _minuteJs.timeMinute));
parcelHelpers.export(exports, "timeMinutes", ()=>(0, _minuteJs.timeMinutes));
parcelHelpers.export(exports, "utcMinute", ()=>(0, _minuteJs.utcMinute));
parcelHelpers.export(exports, "utcMinutes", ()=>(0, _minuteJs.utcMinutes));
parcelHelpers.export(exports, "timeHour", ()=>(0, _hourJs.timeHour));
parcelHelpers.export(exports, "timeHours", ()=>(0, _hourJs.timeHours));
parcelHelpers.export(exports, "utcHour", ()=>(0, _hourJs.utcHour));
parcelHelpers.export(exports, "utcHours", ()=>(0, _hourJs.utcHours));
parcelHelpers.export(exports, "timeDay", ()=>(0, _dayJs.timeDay));
parcelHelpers.export(exports, "timeDays", ()=>(0, _dayJs.timeDays));
parcelHelpers.export(exports, "utcDay", ()=>(0, _dayJs.utcDay));
parcelHelpers.export(exports, "utcDays", ()=>(0, _dayJs.utcDays));
parcelHelpers.export(exports, "unixDay", ()=>(0, _dayJs.unixDay));
parcelHelpers.export(exports, "unixDays", ()=>(0, _dayJs.unixDays));
parcelHelpers.export(exports, "timeWeek", ()=>(0, _weekJs.timeSunday));
parcelHelpers.export(exports, "timeWeeks", ()=>(0, _weekJs.timeSundays));
parcelHelpers.export(exports, "timeSunday", ()=>(0, _weekJs.timeSunday));
parcelHelpers.export(exports, "timeSundays", ()=>(0, _weekJs.timeSundays));
parcelHelpers.export(exports, "timeMonday", ()=>(0, _weekJs.timeMonday));
parcelHelpers.export(exports, "timeMondays", ()=>(0, _weekJs.timeMondays));
parcelHelpers.export(exports, "timeTuesday", ()=>(0, _weekJs.timeTuesday));
parcelHelpers.export(exports, "timeTuesdays", ()=>(0, _weekJs.timeTuesdays));
parcelHelpers.export(exports, "timeWednesday", ()=>(0, _weekJs.timeWednesday));
parcelHelpers.export(exports, "timeWednesdays", ()=>(0, _weekJs.timeWednesdays));
parcelHelpers.export(exports, "timeThursday", ()=>(0, _weekJs.timeThursday));
parcelHelpers.export(exports, "timeThursdays", ()=>(0, _weekJs.timeThursdays));
parcelHelpers.export(exports, "timeFriday", ()=>(0, _weekJs.timeFriday));
parcelHelpers.export(exports, "timeFridays", ()=>(0, _weekJs.timeFridays));
parcelHelpers.export(exports, "timeSaturday", ()=>(0, _weekJs.timeSaturday));
parcelHelpers.export(exports, "timeSaturdays", ()=>(0, _weekJs.timeSaturdays));
parcelHelpers.export(exports, "utcWeek", ()=>(0, _weekJs.utcSunday));
parcelHelpers.export(exports, "utcWeeks", ()=>(0, _weekJs.utcSundays));
parcelHelpers.export(exports, "utcSunday", ()=>(0, _weekJs.utcSunday));
parcelHelpers.export(exports, "utcSundays", ()=>(0, _weekJs.utcSundays));
parcelHelpers.export(exports, "utcMonday", ()=>(0, _weekJs.utcMonday));
parcelHelpers.export(exports, "utcMondays", ()=>(0, _weekJs.utcMondays));
parcelHelpers.export(exports, "utcTuesday", ()=>(0, _weekJs.utcTuesday));
parcelHelpers.export(exports, "utcTuesdays", ()=>(0, _weekJs.utcTuesdays));
parcelHelpers.export(exports, "utcWednesday", ()=>(0, _weekJs.utcWednesday));
parcelHelpers.export(exports, "utcWednesdays", ()=>(0, _weekJs.utcWednesdays));
parcelHelpers.export(exports, "utcThursday", ()=>(0, _weekJs.utcThursday));
parcelHelpers.export(exports, "utcThursdays", ()=>(0, _weekJs.utcThursdays));
parcelHelpers.export(exports, "utcFriday", ()=>(0, _weekJs.utcFriday));
parcelHelpers.export(exports, "utcFridays", ()=>(0, _weekJs.utcFridays));
parcelHelpers.export(exports, "utcSaturday", ()=>(0, _weekJs.utcSaturday));
parcelHelpers.export(exports, "utcSaturdays", ()=>(0, _weekJs.utcSaturdays));
parcelHelpers.export(exports, "timeMonth", ()=>(0, _monthJs.timeMonth));
parcelHelpers.export(exports, "timeMonths", ()=>(0, _monthJs.timeMonths));
parcelHelpers.export(exports, "utcMonth", ()=>(0, _monthJs.utcMonth));
parcelHelpers.export(exports, "utcMonths", ()=>(0, _monthJs.utcMonths));
parcelHelpers.export(exports, "timeYear", ()=>(0, _yearJs.timeYear));
parcelHelpers.export(exports, "timeYears", ()=>(0, _yearJs.timeYears));
parcelHelpers.export(exports, "utcYear", ()=>(0, _yearJs.utcYear));
parcelHelpers.export(exports, "utcYears", ()=>(0, _yearJs.utcYears));
parcelHelpers.export(exports, "utcTicks", ()=>(0, _ticksJs.utcTicks));
parcelHelpers.export(exports, "utcTickInterval", ()=>(0, _ticksJs.utcTickInterval));
parcelHelpers.export(exports, "timeTicks", ()=>(0, _ticksJs.timeTicks));
parcelHelpers.export(exports, "timeTickInterval", ()=>(0, _ticksJs.timeTickInterval));
var _intervalJs = require("./interval.js");
var _millisecondJs = require("./millisecond.js");
var _secondJs = require("./second.js");
var _minuteJs = require("./minute.js");
var _hourJs = require("./hour.js");
var _dayJs = require("./day.js");
var _weekJs = require("./week.js");
var _monthJs = require("./month.js");
var _yearJs = require("./year.js");
var _ticksJs = require("./ticks.js");

},{"./interval.js":"8b01o","./millisecond.js":"5ZpfR","./second.js":"fAm1a","./minute.js":"dTJQZ","./hour.js":"iD1qs","./day.js":"ckWH7","./week.js":"k6n3C","./month.js":"84iEq","./year.js":"lOZjL","./ticks.js":"6WIS9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l85y1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeFormatDefaultLocale", ()=>(0, _defaultLocaleJsDefault.default));
parcelHelpers.export(exports, "timeFormat", ()=>(0, _defaultLocaleJs.timeFormat));
parcelHelpers.export(exports, "timeParse", ()=>(0, _defaultLocaleJs.timeParse));
parcelHelpers.export(exports, "utcFormat", ()=>(0, _defaultLocaleJs.utcFormat));
parcelHelpers.export(exports, "utcParse", ()=>(0, _defaultLocaleJs.utcParse));
parcelHelpers.export(exports, "timeFormatLocale", ()=>(0, _localeJsDefault.default));
parcelHelpers.export(exports, "isoFormat", ()=>(0, _isoFormatJsDefault.default));
parcelHelpers.export(exports, "isoParse", ()=>(0, _isoParseJsDefault.default));
var _defaultLocaleJs = require("./defaultLocale.js");
var _defaultLocaleJsDefault = parcelHelpers.interopDefault(_defaultLocaleJs);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var _isoFormatJs = require("./isoFormat.js");
var _isoFormatJsDefault = parcelHelpers.interopDefault(_isoFormatJs);
var _isoParseJs = require("./isoParse.js");
var _isoParseJsDefault = parcelHelpers.interopDefault(_isoParseJs);

},{"./defaultLocale.js":"3sFOd","./locale.js":"hYi04","./isoFormat.js":"cX4yn","./isoParse.js":"fiDDL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cX4yn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isoSpecifier", ()=>isoSpecifier);
var _defaultLocaleJs = require("./defaultLocale.js");
var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
function formatIsoNative(date) {
    return date.toISOString();
}
var formatIso = Date.prototype.toISOString ? formatIsoNative : (0, _defaultLocaleJs.utcFormat)(isoSpecifier);
exports.default = formatIso;

},{"./defaultLocale.js":"3sFOd","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fiDDL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isoFormatJs = require("./isoFormat.js");
var _defaultLocaleJs = require("./defaultLocale.js");
function parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var parseIso = +new Date("2000-01-01T00:00:00.000Z") ? parseIsoNative : (0, _defaultLocaleJs.utcParse)((0, _isoFormatJs.isoSpecifier));
exports.default = parseIso;

},{"./isoFormat.js":"cX4yn","./defaultLocale.js":"3sFOd","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cOPFt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "now", ()=>(0, _timerJs.now));
parcelHelpers.export(exports, "timer", ()=>(0, _timerJs.timer));
parcelHelpers.export(exports, "timerFlush", ()=>(0, _timerJs.timerFlush));
parcelHelpers.export(exports, "timeout", ()=>(0, _timeoutJsDefault.default));
parcelHelpers.export(exports, "interval", ()=>(0, _intervalJsDefault.default));
var _timerJs = require("./timer.js");
var _timeoutJs = require("./timeout.js");
var _timeoutJsDefault = parcelHelpers.interopDefault(_timeoutJs);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);

},{"./timer.js":"bgtMb","./timeout.js":"gA1Vs","./interval.js":"lQOyO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lQOyO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, delay, time) {
        var t = new (0, _timerJs.Timer), total = delay;
        if (delay == null) return t.restart(callback, delay, time), t;
        t._restart = t.restart;
        t.restart = function(callback, delay, time) {
            delay = +delay, time = time == null ? (0, _timerJs.now)() : +time;
            t._restart(function tick(elapsed) {
                elapsed += total;
                t._restart(tick, total += delay, time);
                callback(elapsed);
            }, delay, time);
        };
        t.restart(callback, delay, time);
        return t;
    });
var _timerJs = require("./timer.js");

},{"./timer.js":"bgtMb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h8Ny4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zoom", ()=>(0, _zoomJsDefault.default));
parcelHelpers.export(exports, "zoomTransform", ()=>(0, _transformJsDefault.default));
parcelHelpers.export(exports, "zoomIdentity", ()=>(0, _transformJs.identity));
parcelHelpers.export(exports, "ZoomTransform", ()=>(0, _transformJs.Transform));
var _zoomJs = require("./zoom.js");
var _zoomJsDefault = parcelHelpers.interopDefault(_zoomJs);
var _transformJs = require("./transform.js");
var _transformJsDefault = parcelHelpers.interopDefault(_transformJs);

},{"./zoom.js":"k0uTV","./transform.js":"KmKi8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k0uTV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var filter = defaultFilter, extent = defaultExtent, constrain = defaultConstrain, wheelDelta = defaultWheelDelta, touchable = defaultTouchable, scaleExtent = [
            0,
            Infinity
        ], translateExtent = [
            [
                -Infinity,
                -Infinity
            ],
            [
                Infinity,
                Infinity
            ]
        ], duration = 250, interpolate = (0, _d3Interpolate.interpolateZoom), listeners = (0, _d3Dispatch.dispatch)("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
        function zoom(selection) {
            selection.property("__zoom", defaultTransform).on("wheel.zoom", wheeled, {
                passive: false
            }).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
        }
        zoom.transform = function(collection, transform, point, event) {
            var selection = collection.selection ? collection.selection() : collection;
            selection.property("__zoom", defaultTransform);
            if (collection !== selection) schedule(collection, transform, point, event);
            else selection.interrupt().each(function() {
                gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
            });
        };
        zoom.scaleBy = function(selection, k, p, event) {
            zoom.scaleTo(selection, function() {
                var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
                return k0 * k1;
            }, p, event);
        };
        zoom.scaleTo = function(selection, k, p, event) {
            zoom.transform(selection, function() {
                var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
                return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
            }, p, event);
        };
        zoom.translateBy = function(selection, x, y, event) {
            zoom.transform(selection, function() {
                return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
            }, null, event);
        };
        zoom.translateTo = function(selection, x, y, p, event) {
            zoom.transform(selection, function() {
                var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
                return constrain((0, _transformJs.identity).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
            }, p, event);
        };
        function scale(transform, k) {
            k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
            return k === transform.k ? transform : new (0, _transformJs.Transform)(k, transform.x, transform.y);
        }
        function translate(transform, p0, p1) {
            var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
            return x === transform.x && y === transform.y ? transform : new (0, _transformJs.Transform)(transform.k, x, y);
        }
        function centroid(extent) {
            return [
                (+extent[0][0] + +extent[1][0]) / 2,
                (+extent[0][1] + +extent[1][1]) / 2
            ];
        }
        function schedule(transition, transform, point, event) {
            transition.on("start.zoom", function() {
                gesture(this, arguments).event(event).start();
            }).on("interrupt.zoom end.zoom", function() {
                gesture(this, arguments).event(event).end();
            }).tween("zoom", function() {
                var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
                return function(t) {
                    if (t === 1) t = b; // Avoid rounding error on end.
                    else {
                        var l = i(t), k = w / l[2];
                        t = new (0, _transformJs.Transform)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                    }
                    g.zoom(null, t);
                };
            });
        }
        function gesture(that, args, clean) {
            return !clean && that.__zooming || new Gesture(that, args);
        }
        function Gesture(that, args) {
            this.that = that;
            this.args = args;
            this.active = 0;
            this.sourceEvent = null;
            this.extent = extent.apply(that, args);
            this.taps = 0;
        }
        Gesture.prototype = {
            event: function(event) {
                if (event) this.sourceEvent = event;
                return this;
            },
            start: function() {
                if (++this.active === 1) {
                    this.that.__zooming = this;
                    this.emit("start");
                }
                return this;
            },
            zoom: function(key, transform) {
                if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
                if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
                if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
                this.that.__zoom = transform;
                this.emit("zoom");
                return this;
            },
            end: function() {
                if (--this.active === 0) {
                    delete this.that.__zooming;
                    this.emit("end");
                }
                return this;
            },
            emit: function(type) {
                var d = (0, _d3Selection.select)(this.that).datum();
                listeners.call(type, this.that, new (0, _eventJsDefault.default)(type, {
                    sourceEvent: this.sourceEvent,
                    target: zoom,
                    type,
                    transform: this.that.__zoom,
                    dispatch: listeners
                }), d);
            }
        };
        function wheeled(event, ...args) {
            if (!filter.apply(this, arguments)) return;
            var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, _d3Selection.pointer)(event);
            // If the mouse is in the same location as before, reuse it.
            // If there were recent wheel events, reset the wheel idle timeout.
            if (g.wheel) {
                if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
                clearTimeout(g.wheel);
            } else if (t.k === k) return;
            else {
                g.mouse = [
                    p,
                    t.invert(p)
                ];
                (0, _d3Transition.interrupt)(this);
                g.start();
            }
            (0, _noeventJsDefault.default)(event);
            g.wheel = setTimeout(wheelidled, wheelDelay);
            g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
            function wheelidled() {
                g.wheel = null;
                g.end();
            }
        }
        function mousedowned(event, ...args) {
            if (touchending || !filter.apply(this, arguments)) return;
            var currentTarget = event.currentTarget, g = gesture(this, args, true).event(event), v = (0, _d3Selection.select)(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, _d3Selection.pointer)(event, currentTarget), x0 = event.clientX, y0 = event.clientY;
            (0, _d3Drag.dragDisable)(event.view);
            (0, _noeventJs.nopropagation)(event);
            g.mouse = [
                p,
                this.__zoom.invert(p)
            ];
            (0, _d3Transition.interrupt)(this);
            g.start();
            function mousemoved(event) {
                (0, _noeventJsDefault.default)(event);
                if (!g.moved) {
                    var dx = event.clientX - x0, dy = event.clientY - y0;
                    g.moved = dx * dx + dy * dy > clickDistance2;
                }
                g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, _d3Selection.pointer)(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
            }
            function mouseupped(event) {
                v.on("mousemove.zoom mouseup.zoom", null);
                (0, _d3Drag.dragEnable)(event.view, g.moved);
                (0, _noeventJsDefault.default)(event);
                g.event(event).end();
            }
        }
        function dblclicked(event, ...args) {
            if (!filter.apply(this, arguments)) return;
            var t0 = this.__zoom, p0 = (0, _d3Selection.pointer)(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
            (0, _noeventJsDefault.default)(event);
            if (duration > 0) (0, _d3Selection.select)(this).transition().duration(duration).call(schedule, t1, p0, event);
            else (0, _d3Selection.select)(this).call(zoom.transform, t1, p0, event);
        }
        function touchstarted(event, ...args) {
            if (!filter.apply(this, arguments)) return;
            var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
            (0, _noeventJs.nopropagation)(event);
            for(i = 0; i < n; ++i){
                t = touches[i], p = (0, _d3Selection.pointer)(t, this);
                p = [
                    p,
                    this.__zoom.invert(p),
                    t.identifier
                ];
                if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
                else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
            }
            if (touchstarting) touchstarting = clearTimeout(touchstarting);
            if (started) {
                if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                    touchstarting = null;
                }, touchDelay);
                (0, _d3Transition.interrupt)(this);
                g.start();
            }
        }
        function touchmoved(event, ...args) {
            if (!this.__zooming) return;
            var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
            (0, _noeventJsDefault.default)(event);
            for(i = 0; i < n; ++i){
                t = touches[i], p = (0, _d3Selection.pointer)(t, this);
                if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
                else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
            }
            t = g.that.__zoom;
            if (g.touch1) {
                var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
                t = scale(t, Math.sqrt(dp / dl));
                p = [
                    (p0[0] + p1[0]) / 2,
                    (p0[1] + p1[1]) / 2
                ];
                l = [
                    (l0[0] + l1[0]) / 2,
                    (l0[1] + l1[1]) / 2
                ];
            } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
            else return;
            g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
        }
        function touchended(event, ...args) {
            if (!this.__zooming) return;
            var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
            (0, _noeventJs.nopropagation)(event);
            if (touchending) clearTimeout(touchending);
            touchending = setTimeout(function() {
                touchending = null;
            }, touchDelay);
            for(i = 0; i < n; ++i){
                t = touches[i];
                if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
                else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
            }
            if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
            if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
            else {
                g.end();
                // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
                if (g.taps === 2) {
                    t = (0, _d3Selection.pointer)(t, this);
                    if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                        var p = (0, _d3Selection.select)(this).on("dblclick.zoom");
                        if (p) p.apply(this, arguments);
                    }
                }
            }
        }
        zoom.wheelDelta = function(_) {
            return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), zoom) : wheelDelta;
        };
        zoom.filter = function(_) {
            return arguments.length ? (filter = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), zoom) : filter;
        };
        zoom.touchable = function(_) {
            return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), zoom) : touchable;
        };
        zoom.extent = function(_) {
            return arguments.length ? (extent = typeof _ === "function" ? _ : (0, _constantJsDefault.default)([
                [
                    +_[0][0],
                    +_[0][1]
                ],
                [
                    +_[1][0],
                    +_[1][1]
                ]
            ]), zoom) : extent;
        };
        zoom.scaleExtent = function(_) {
            return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
                scaleExtent[0],
                scaleExtent[1]
            ];
        };
        zoom.translateExtent = function(_) {
            return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
                [
                    translateExtent[0][0],
                    translateExtent[0][1]
                ],
                [
                    translateExtent[1][0],
                    translateExtent[1][1]
                ]
            ];
        };
        zoom.constrain = function(_) {
            return arguments.length ? (constrain = _, zoom) : constrain;
        };
        zoom.duration = function(_) {
            return arguments.length ? (duration = +_, zoom) : duration;
        };
        zoom.interpolate = function(_) {
            return arguments.length ? (interpolate = _, zoom) : interpolate;
        };
        zoom.on = function() {
            var value = listeners.on.apply(listeners, arguments);
            return value === listeners ? zoom : value;
        };
        zoom.clickDistance = function(_) {
            return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
        };
        zoom.tapDistance = function(_) {
            return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
        };
        return zoom;
    });
var _d3Dispatch = require("d3-dispatch");
var _d3Drag = require("d3-drag");
var _d3Interpolate = require("d3-interpolate");
var _d3Selection = require("d3-selection");
var _d3Transition = require("d3-transition");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _eventJs = require("./event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
var _transformJs = require("./transform.js");
var _noeventJs = require("./noevent.js");
var _noeventJsDefault = parcelHelpers.interopDefault(_noeventJs);
// Ignore right-click, since that should open the context menu.
// except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
function defaultFilter(event) {
    return (!event.ctrlKey || event.type === 'wheel') && !event.button;
}
function defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function defaultTransform() {
    return this.__zoom || (0, _transformJs.identity);
}
function defaultWheelDelta(event) {
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
}
function defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}

},{"d3-dispatch":[["dispatch","avnlO","default"]],"d3-drag":[["dragDisable","2o3My","default"],["dragEnable","2o3My","yesdrag"]],"d3-interpolate":[["interpolateZoom","7BEmP","default"]],"d3-selection":[["pointer","04Hca","default"],["select","4CEQV","default"]],"d3-transition":"aUsOn","./constant.js":"bPwFS","./event.js":"a6d1t","./transform.js":"KmKi8","./noevent.js":"eC3Wp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bPwFS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>()=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a6d1t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ZoomEvent);
function ZoomEvent(type, { sourceEvent, target, transform, dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        transform: {
            value: transform,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"KmKi8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Transform", ()=>Transform);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "default", ()=>transform);
function Transform(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
Transform.prototype = {
    constructor: Transform,
    scale: function(k) {
        return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var identity = new Transform(1, 0, 0);
transform.prototype = Transform.prototype;
function transform(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return identity;
    return node.__zoom;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eC3Wp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nopropagation", ()=>nopropagation);
parcelHelpers.export(exports, "default", ()=>function(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    });
function nopropagation(event) {
    event.stopImmediatePropagation();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g2Na9":[function(require,module,exports,__globalThis) {
/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */ (function(global, factory) {
    if (typeof define === 'function' && define.amd) define(factory);
    else if (module.exports) module.exports = factory();
    else global.numeral = factory();
})(this, function() {
    /************************************
        Variables
    ************************************/ var numeral, _, VERSION = '2.0.6', formats = {}, locales = {}, defaults = {
        currentLocale: 'en',
        zeroFormat: null,
        nullFormat: null,
        defaultFormat: '0,0',
        scalePercentBy100: true
    }, options = {
        currentLocale: defaults.currentLocale,
        zeroFormat: defaults.zeroFormat,
        nullFormat: defaults.nullFormat,
        defaultFormat: defaults.defaultFormat,
        scalePercentBy100: defaults.scalePercentBy100
    };
    /************************************
        Constructors
    ************************************/ // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;
        this._value = number;
    }
    numeral = function(input) {
        var value, kind, unformatFunction, regexp;
        if (numeral.isNumeral(input)) value = input.value();
        else if (input === 0 || typeof input === 'undefined') value = 0;
        else if (input === null || _.isNaN(input)) value = null;
        else if (typeof input === 'string') {
            if (options.zeroFormat && input === options.zeroFormat) value = 0;
            else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) value = null;
            else {
                for(kind in formats){
                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;
                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;
                        break;
                    }
                }
                unformatFunction = unformatFunction || numeral._.stringToNumber;
                value = unformatFunction(input);
            }
        } else value = Number(input) || null;
        return new Numeral(input, value);
    };
    // version number
    numeral.version = VERSION;
    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };
    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale], negP = false, optDec = false, leadingCount = 0, abbr = '', trillion = 1000000000000, billion = 1000000000, million = 1000000, thousand = 1000, decimal = '', neg = false, abbrForce, abs, min, max, power, int, precision, signed, thousands, output;
            // make sure we never format a null value
            value = value || 0;
            abs = Math.abs(value);
            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, '(')) {
                negP = true;
                format = format.replace(/[\(|\)]/g, '');
            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
                format = format.replace(/[\+|\-]/g, '');
            }
            // see if abbreviation is wanted
            if (numeral._.includes(format, 'a')) {
                abbrForce = format.match(/a(k|m|b|t)?/);
                abbrForce = abbrForce ? abbrForce[1] : false;
                // check for space before abbreviation
                if (numeral._.includes(format, ' a')) abbr = ' ';
                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');
                if (abs >= trillion && !abbrForce || abbrForce === 't') {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }
            // check for optional decimals
            if (numeral._.includes(format, '[.]')) {
                optDec = true;
                format = format.replace('[.]', '.');
            }
            // break number and format
            int = value.toString().split('.')[0];
            precision = format.split('.')[1];
            thousands = format.indexOf(',');
            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;
            if (precision) {
                if (numeral._.includes(precision, '[')) {
                    precision = precision.replace(']', '');
                    precision = precision.split('[');
                    decimal = numeral._.toFixed(value, precision[0].length + precision[1].length, roundingFunction, precision[1].length);
                } else decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                int = decimal.split('.')[0];
                if (numeral._.includes(decimal, '.')) decimal = locale.delimiters.decimal + decimal.split('.')[1];
                else decimal = '';
                if (optDec && Number(decimal.slice(1)) === 0) decimal = '';
            } else int = numeral._.toFixed(value, 0, roundingFunction);
            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);
                switch(abbr){
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }
            // format number
            if (numeral._.includes(int, '-')) {
                int = int.slice(1);
                neg = true;
            }
            if (int.length < leadingCount) for(var i = leadingCount - int.length; i > 0; i--)int = '0' + int;
            if (thousands > -1) int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
            if (format.indexOf('.') === 0) int = '';
            output = int + decimal + (abbr ? abbr : '');
            if (negP) output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
            else {
                if (signed >= 0) output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
                else if (neg) output = '-' + output;
            }
            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale], stringOriginal = string, abbreviations = {
                thousand: 3,
                million: 6,
                billion: 9,
                trillion: 12
            }, abbreviation, value, i, regexp;
            if (options.zeroFormat && string === options.zeroFormat) value = 0;
            else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) value = null;
            else {
                value = 1;
                if (locale.delimiters.decimal !== '.') string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
                for(abbreviation in abbreviations){
                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');
                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }
                // check for negative number
                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;
                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, '');
                value *= Number(string);
            }
            return value;
        },
        isNaN: function(value) {
            return typeof value === 'number' && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/ ) {
            if (this === null) throw new TypeError('Array.prototype.reduce called on null or undefined');
            if (typeof callback !== 'function') throw new TypeError(callback + ' is not a function');
            var t = Object(array), len = t.length >>> 0, k = 0, value;
            if (arguments.length === 3) value = arguments[2];
            else {
                while(k < len && !(k in t))k++;
                if (k >= len) throw new TypeError('Reduce of empty array with no initial value');
                value = t[k++];
            }
            for(; k < len; k++)if (k in t) value = callback(value, t[k], k, t);
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */ multiplier: function(x) {
            var parts = x.toString().split('.');
            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */ correctionFactor: function() {
            var args = Array.prototype.slice.call(arguments);
            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */ toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split('.'), minDecimals = maxDecimals - (optionals || 0), boundedPrecision, optionalsRegExp, power, output;
            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            else boundedPrecision = minDecimals;
            power = Math.pow(10, boundedPrecision);
            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);
            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
                output = output.replace(optionalsRegExp, '');
            }
            return output;
        }
    };
    // avaliable options
    numeral.options = options;
    // avaliable formats
    numeral.formats = formats;
    // avaliable formats
    numeral.locales = locales;
    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) options.currentLocale = key.toLowerCase();
        return options.currentLocale;
    };
    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) return locales[options.currentLocale];
        key = key.toLowerCase();
        if (!locales[key]) throw new Error('Unknown locale : ' + key);
        return locales[key];
    };
    numeral.reset = function() {
        for(var property in defaults)options[property] = defaults[property];
    };
    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof format === 'string' ? format : null;
    };
    numeral.nullFormat = function(format) {
        options.nullFormat = typeof format === 'string' ? format : null;
    };
    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof format === 'string' ? format : '0.0';
    };
    numeral.register = function(type, name, format) {
        name = name.toLowerCase();
        if (this[type + 's'][name]) throw new TypeError(name + ' ' + type + ' already registered.');
        this[type + 's'][name] = format;
        return format;
    };
    numeral.validate = function(val, culture) {
        var _decimalSep, _thousandSep, _currSymbol, _valArray, _abbrObj, _thousandRegEx, localeData, temp;
        //coerce val to string
        if (typeof val !== 'string') {
            val += '';
            if (console.warn) console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
        }
        //trim whitespaces from either sides
        val = val.trim();
        //if val is just digits return true
        if (!!val.match(/^\d+$/)) return true;
        //if val is empty return false
        if (val === '') return false;
        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }
        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === '.') _thousandSep = '\\.';
        else _thousandSep = localeData.delimiters.thousands;
        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) return false;
        }
        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) return false;
        }
        _thousandRegEx = new RegExp(_thousandSep + '{2}');
        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) return false;
            else {
                if (_valArray.length < 2) return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx);
                else {
                    if (_valArray[0].length === 1) return !!_valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
                    else return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
                }
            }
        }
        return false;
    };
    /************************************
        Numeral Prototype
    ************************************/ numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value, format = inputString || options.defaultFormat, kind, output, formatFunction;
            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;
            // format based on value
            if (value === 0 && options.zeroFormat !== null) output = options.zeroFormat;
            else if (value === null && options.nullFormat !== null) output = options.nullFormat;
            else {
                for(kind in formats)if (format.match(formats[kind].regexps.format)) {
                    formatFunction = formats[kind].format;
                    break;
                }
                formatFunction = formatFunction || numeral._.numberToFormat;
                output = formatFunction(value, format, roundingFunction);
            }
            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);
            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);
            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }
            this._value = _.reduce([
                this._value,
                value
            ], cback, 0) / corrFactor;
            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);
            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }
            this._value = _.reduce([
                value
            ], cback, Math.round(this._value * corrFactor)) / corrFactor;
            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }
            this._value = _.reduce([
                this._value,
                value
            ], cback, 1);
            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }
            this._value = _.reduce([
                this._value,
                value
            ], cback);
            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };
    /************************************
        Default Locale && Format
    ************************************/ numeral.register('locale', 'en', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function(number) {
            var b = number % 10;
            return ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });
    (function() {
        numeral.register('format', 'bps', {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, ' BPS') ? ' ' : '', output;
                value = value * 10000;
                // check for space before BPS
                format = format.replace(/\s?BPS/, '');
                output = numeral._.numberToFormat(value, format, roundingFunction);
                if (numeral._.includes(output, ')')) {
                    output = output.split('');
                    output.splice(-1, 0, space + 'BPS');
                    output = output.join('');
                } else output = output + space + 'BPS';
                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
    })();
    (function() {
        var decimal = {
            base: 1000,
            suffixes: [
                'B',
                'KB',
                'MB',
                'GB',
                'TB',
                'PB',
                'EB',
                'ZB',
                'YB'
            ]
        }, binary = {
            base: 1024,
            suffixes: [
                'B',
                'KiB',
                'MiB',
                'GiB',
                'TiB',
                'PiB',
                'EiB',
                'ZiB',
                'YiB'
            ]
        };
        var allSuffixes = decimal.suffixes.concat(binary.suffixes.filter(function(item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join('|');
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';
        numeral.register('format', 'bytes', {
            regexps: {
                format: /([0\s]i?b)/,
                unformat: new RegExp(unformatRegex)
            },
            format: function(value, format, roundingFunction) {
                var output, bytes = numeral._.includes(format, 'ib') ? binary : decimal, suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '', power, min, max;
                // check for space before
                format = format.replace(/\s?i?b/, '');
                for(power = 0; power <= bytes.suffixes.length; power++){
                    min = Math.pow(bytes.base, power);
                    max = Math.pow(bytes.base, power + 1);
                    if (value === null || value === 0 || value >= min && value < max) {
                        suffix += bytes.suffixes[power];
                        if (min > 0) value = value / min;
                        break;
                    }
                }
                output = numeral._.numberToFormat(value, format, roundingFunction);
                return output + suffix;
            },
            unformat: function(string) {
                var value = numeral._.stringToNumber(string), power, bytesMultiplier;
                if (value) {
                    for(power = decimal.suffixes.length - 1; power >= 0; power--){
                        if (numeral._.includes(string, decimal.suffixes[power])) {
                            bytesMultiplier = Math.pow(decimal.base, power);
                            break;
                        }
                        if (numeral._.includes(string, binary.suffixes[power])) {
                            bytesMultiplier = Math.pow(binary.base, power);
                            break;
                        }
                    }
                    value *= bytesMultiplier || 1;
                }
                return value;
            }
        });
    })();
    (function() {
        numeral.register('format', 'currency', {
            regexps: {
                format: /(\$)/
            },
            format: function(value, format, roundingFunction) {
                var locale = numeral.locales[numeral.options.currentLocale], symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                }, output, symbol, i;
                // strip format of spaces and $
                format = format.replace(/\s?\$\s?/, '');
                // format the number
                output = numeral._.numberToFormat(value, format, roundingFunction);
                // update the before and after based on value
                if (value >= 0) {
                    symbols.before = symbols.before.replace(/[\-\(]/, '');
                    symbols.after = symbols.after.replace(/[\-\)]/, '');
                } else if (value < 0 && !numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '(')) symbols.before = '-' + symbols.before;
                // loop through each before symbol
                for(i = 0; i < symbols.before.length; i++){
                    symbol = symbols.before[i];
                    switch(symbol){
                        case '$':
                            output = numeral._.insert(output, locale.currency.symbol, i);
                            break;
                        case ' ':
                            output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
                            break;
                    }
                }
                // loop through each after symbol
                for(i = symbols.after.length - 1; i >= 0; i--){
                    symbol = symbols.after[i];
                    switch(symbol){
                        case '$':
                            output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                            break;
                        case ' ':
                            output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                            break;
                    }
                }
                return output;
            }
        });
    })();
    (function() {
        numeral.register('format', 'exponential', {
            regexps: {
                format: /(e\+|e-)/,
                unformat: /(e\+|e-)/
            },
            format: function(value, format, roundingFunction) {
                var output, exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0', parts = exponential.split('e');
                format = format.replace(/e[\+|\-]{1}0/, '');
                output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);
                return output + 'e' + parts[1];
            },
            unformat: function(string) {
                var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'), value = Number(parts[0]), power = Number(parts[1]);
                power = numeral._.includes(string, 'e-') ? power *= -1 : power;
                function cback(accum, curr, currI, O) {
                    var corrFactor = numeral._.correctionFactor(accum, curr), num = accum * corrFactor * (curr * corrFactor) / (corrFactor * corrFactor);
                    return num;
                }
                return numeral._.reduce([
                    value,
                    Math.pow(10, power)
                ], cback, 1);
            }
        });
    })();
    (function() {
        numeral.register('format', 'ordinal', {
            regexps: {
                format: /(o)/
            },
            format: function(value, format, roundingFunction) {
                var locale = numeral.locales[numeral.options.currentLocale], output, ordinal = numeral._.includes(format, ' o') ? ' ' : '';
                // check for space before
                format = format.replace(/\s?o/, '');
                ordinal += locale.ordinal(value);
                output = numeral._.numberToFormat(value, format, roundingFunction);
                return output + ordinal;
            }
        });
    })();
    (function() {
        numeral.register('format', 'percentage', {
            regexps: {
                format: /(%)/,
                unformat: /(%)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, ' %') ? ' ' : '', output;
                if (numeral.options.scalePercentBy100) value = value * 100;
                // check for space before %
                format = format.replace(/\s?\%/, '');
                output = numeral._.numberToFormat(value, format, roundingFunction);
                if (numeral._.includes(output, ')')) {
                    output = output.split('');
                    output.splice(-1, 0, space + '%');
                    output = output.join('');
                } else output = output + space + '%';
                return output;
            },
            unformat: function(string) {
                var number = numeral._.stringToNumber(string);
                if (numeral.options.scalePercentBy100) return number * 0.01;
                return number;
            }
        });
    })();
    (function() {
        numeral.register('format', 'time', {
            regexps: {
                format: /(:)/,
                unformat: /(:)/
            },
            format: function(value, format, roundingFunction) {
                var hours = Math.floor(value / 60 / 60), minutes = Math.floor((value - hours * 3600) / 60), seconds = Math.round(value - hours * 3600 - minutes * 60);
                return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
            },
            unformat: function(string) {
                var timeArray = string.split(':'), seconds = 0;
                // turn hours and minutes into seconds and add them all up
                if (timeArray.length === 3) {
                    // hours
                    seconds = seconds + Number(timeArray[0]) * 3600;
                    // minutes
                    seconds = seconds + Number(timeArray[1]) * 60;
                    // seconds
                    seconds = seconds + Number(timeArray[2]);
                } else if (timeArray.length === 2) {
                    // minutes
                    seconds = seconds + Number(timeArray[0]) * 60;
                    // seconds
                    seconds = seconds + Number(timeArray[1]);
                }
                return Number(seconds);
            }
        });
    })();
    return numeral;
});

},{}],"dZ6yw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _auth = require("@firebase/auth");
parcelHelpers.exportAll(_auth, exports);

},{"@firebase/auth":"3ewAF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3ewAF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionCodeOperation", ()=>(0, _index35C79A8AJs.A));
parcelHelpers.export(exports, "ActionCodeURL", ()=>(0, _index35C79A8AJs.aj));
parcelHelpers.export(exports, "AuthCredential", ()=>(0, _index35C79A8AJs.M));
parcelHelpers.export(exports, "AuthErrorCodes", ()=>(0, _index35C79A8AJs.J));
parcelHelpers.export(exports, "EmailAuthCredential", ()=>(0, _index35C79A8AJs.N));
parcelHelpers.export(exports, "EmailAuthProvider", ()=>(0, _index35C79A8AJs.W));
parcelHelpers.export(exports, "FacebookAuthProvider", ()=>(0, _index35C79A8AJs.X));
parcelHelpers.export(exports, "FactorId", ()=>(0, _index35C79A8AJs.F));
parcelHelpers.export(exports, "GithubAuthProvider", ()=>(0, _index35C79A8AJs.Z));
parcelHelpers.export(exports, "GoogleAuthProvider", ()=>(0, _index35C79A8AJs.Y));
parcelHelpers.export(exports, "OAuthCredential", ()=>(0, _index35C79A8AJs.Q));
parcelHelpers.export(exports, "OAuthProvider", ()=>(0, _index35C79A8AJs._));
parcelHelpers.export(exports, "OperationType", ()=>(0, _index35C79A8AJs.O));
parcelHelpers.export(exports, "PhoneAuthCredential", ()=>(0, _index35C79A8AJs.U));
parcelHelpers.export(exports, "PhoneAuthProvider", ()=>(0, _index35C79A8AJs.P));
parcelHelpers.export(exports, "PhoneMultiFactorGenerator", ()=>(0, _index35C79A8AJs.n));
parcelHelpers.export(exports, "ProviderId", ()=>(0, _index35C79A8AJs.q));
parcelHelpers.export(exports, "RecaptchaVerifier", ()=>(0, _index35C79A8AJs.R));
parcelHelpers.export(exports, "SAMLAuthProvider", ()=>(0, _index35C79A8AJs.$));
parcelHelpers.export(exports, "SignInMethod", ()=>(0, _index35C79A8AJs.S));
parcelHelpers.export(exports, "TotpMultiFactorGenerator", ()=>(0, _index35C79A8AJs.T));
parcelHelpers.export(exports, "TotpSecret", ()=>(0, _index35C79A8AJs.o));
parcelHelpers.export(exports, "TwitterAuthProvider", ()=>(0, _index35C79A8AJs.a0));
parcelHelpers.export(exports, "applyActionCode", ()=>(0, _index35C79A8AJs.a8));
parcelHelpers.export(exports, "beforeAuthStateChanged", ()=>(0, _index35C79A8AJs.y));
parcelHelpers.export(exports, "browserCookiePersistence", ()=>(0, _index35C79A8AJs.a));
parcelHelpers.export(exports, "browserLocalPersistence", ()=>(0, _index35C79A8AJs.b));
parcelHelpers.export(exports, "browserPopupRedirectResolver", ()=>(0, _index35C79A8AJs.m));
parcelHelpers.export(exports, "browserSessionPersistence", ()=>(0, _index35C79A8AJs.c));
parcelHelpers.export(exports, "checkActionCode", ()=>(0, _index35C79A8AJs.a9));
parcelHelpers.export(exports, "confirmPasswordReset", ()=>(0, _index35C79A8AJs.a7));
parcelHelpers.export(exports, "connectAuthEmulator", ()=>(0, _index35C79A8AJs.L));
parcelHelpers.export(exports, "createUserWithEmailAndPassword", ()=>(0, _index35C79A8AJs.ab));
parcelHelpers.export(exports, "debugErrorMap", ()=>(0, _index35C79A8AJs.H));
parcelHelpers.export(exports, "deleteUser", ()=>(0, _index35C79A8AJs.G));
parcelHelpers.export(exports, "fetchSignInMethodsForEmail", ()=>(0, _index35C79A8AJs.ag));
parcelHelpers.export(exports, "getAdditionalUserInfo", ()=>(0, _index35C79A8AJs.ar));
parcelHelpers.export(exports, "getAuth", ()=>(0, _index35C79A8AJs.p));
parcelHelpers.export(exports, "getIdToken", ()=>(0, _index35C79A8AJs.ao));
parcelHelpers.export(exports, "getIdTokenResult", ()=>(0, _index35C79A8AJs.ap));
parcelHelpers.export(exports, "getMultiFactorResolver", ()=>(0, _index35C79A8AJs.at));
parcelHelpers.export(exports, "getRedirectResult", ()=>(0, _index35C79A8AJs.k));
parcelHelpers.export(exports, "inMemoryPersistence", ()=>(0, _index35C79A8AJs.V));
parcelHelpers.export(exports, "indexedDBLocalPersistence", ()=>(0, _index35C79A8AJs.i));
parcelHelpers.export(exports, "initializeAuth", ()=>(0, _index35C79A8AJs.K));
parcelHelpers.export(exports, "initializeRecaptchaConfig", ()=>(0, _index35C79A8AJs.v));
parcelHelpers.export(exports, "isSignInWithEmailLink", ()=>(0, _index35C79A8AJs.ae));
parcelHelpers.export(exports, "linkWithCredential", ()=>(0, _index35C79A8AJs.a3));
parcelHelpers.export(exports, "linkWithPhoneNumber", ()=>(0, _index35C79A8AJs.l));
parcelHelpers.export(exports, "linkWithPopup", ()=>(0, _index35C79A8AJs.e));
parcelHelpers.export(exports, "linkWithRedirect", ()=>(0, _index35C79A8AJs.h));
parcelHelpers.export(exports, "multiFactor", ()=>(0, _index35C79A8AJs.au));
parcelHelpers.export(exports, "onAuthStateChanged", ()=>(0, _index35C79A8AJs.z));
parcelHelpers.export(exports, "onIdTokenChanged", ()=>(0, _index35C79A8AJs.x));
parcelHelpers.export(exports, "parseActionCodeURL", ()=>(0, _index35C79A8AJs.ak));
parcelHelpers.export(exports, "prodErrorMap", ()=>(0, _index35C79A8AJs.I));
parcelHelpers.export(exports, "reauthenticateWithCredential", ()=>(0, _index35C79A8AJs.a4));
parcelHelpers.export(exports, "reauthenticateWithPhoneNumber", ()=>(0, _index35C79A8AJs.r));
parcelHelpers.export(exports, "reauthenticateWithPopup", ()=>(0, _index35C79A8AJs.f));
parcelHelpers.export(exports, "reauthenticateWithRedirect", ()=>(0, _index35C79A8AJs.j));
parcelHelpers.export(exports, "reload", ()=>(0, _index35C79A8AJs.as));
parcelHelpers.export(exports, "revokeAccessToken", ()=>(0, _index35C79A8AJs.E));
parcelHelpers.export(exports, "sendEmailVerification", ()=>(0, _index35C79A8AJs.ah));
parcelHelpers.export(exports, "sendPasswordResetEmail", ()=>(0, _index35C79A8AJs.a6));
parcelHelpers.export(exports, "sendSignInLinkToEmail", ()=>(0, _index35C79A8AJs.ad));
parcelHelpers.export(exports, "setPersistence", ()=>(0, _index35C79A8AJs.t));
parcelHelpers.export(exports, "signInAnonymously", ()=>(0, _index35C79A8AJs.a1));
parcelHelpers.export(exports, "signInWithCredential", ()=>(0, _index35C79A8AJs.a2));
parcelHelpers.export(exports, "signInWithCustomToken", ()=>(0, _index35C79A8AJs.a5));
parcelHelpers.export(exports, "signInWithEmailAndPassword", ()=>(0, _index35C79A8AJs.ac));
parcelHelpers.export(exports, "signInWithEmailLink", ()=>(0, _index35C79A8AJs.af));
parcelHelpers.export(exports, "signInWithPhoneNumber", ()=>(0, _index35C79A8AJs.s));
parcelHelpers.export(exports, "signInWithPopup", ()=>(0, _index35C79A8AJs.d));
parcelHelpers.export(exports, "signInWithRedirect", ()=>(0, _index35C79A8AJs.g));
parcelHelpers.export(exports, "signOut", ()=>(0, _index35C79A8AJs.D));
parcelHelpers.export(exports, "unlink", ()=>(0, _index35C79A8AJs.aq));
parcelHelpers.export(exports, "updateCurrentUser", ()=>(0, _index35C79A8AJs.C));
parcelHelpers.export(exports, "updateEmail", ()=>(0, _index35C79A8AJs.am));
parcelHelpers.export(exports, "updatePassword", ()=>(0, _index35C79A8AJs.an));
parcelHelpers.export(exports, "updatePhoneNumber", ()=>(0, _index35C79A8AJs.u));
parcelHelpers.export(exports, "updateProfile", ()=>(0, _index35C79A8AJs.al));
parcelHelpers.export(exports, "useDeviceLanguage", ()=>(0, _index35C79A8AJs.B));
parcelHelpers.export(exports, "validatePassword", ()=>(0, _index35C79A8AJs.w));
parcelHelpers.export(exports, "verifyBeforeUpdateEmail", ()=>(0, _index35C79A8AJs.ai));
parcelHelpers.export(exports, "verifyPasswordResetCode", ()=>(0, _index35C79A8AJs.aa));
var _index35C79A8AJs = require("./index-35c79a8a.js");
var _app = require("@firebase/app");
var _util = require("@firebase/util");
var _logger = require("@firebase/logger");
var _tslib = require("tslib");
var _component = require("@firebase/component");

},{"./index-35c79a8a.js":"fThWa","@firebase/app":"1SyrH","@firebase/util":"guJD8","@firebase/logger":"3ul0m","tslib":"7YykB","@firebase/component":"2tpfU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fThWa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "$", ()=>SAMLAuthProvider);
parcelHelpers.export(exports, "A", ()=>ActionCodeOperation);
parcelHelpers.export(exports, "B", ()=>useDeviceLanguage);
parcelHelpers.export(exports, "C", ()=>updateCurrentUser);
parcelHelpers.export(exports, "D", ()=>signOut);
parcelHelpers.export(exports, "E", ()=>revokeAccessToken);
parcelHelpers.export(exports, "F", ()=>FactorId);
parcelHelpers.export(exports, "G", ()=>deleteUser);
parcelHelpers.export(exports, "H", ()=>debugErrorMap);
parcelHelpers.export(exports, "I", ()=>prodErrorMap);
parcelHelpers.export(exports, "J", ()=>AUTH_ERROR_CODES_MAP_DO_NOT_USE_INTERNALLY);
parcelHelpers.export(exports, "K", ()=>initializeAuth);
parcelHelpers.export(exports, "L", ()=>connectAuthEmulator);
parcelHelpers.export(exports, "M", ()=>AuthCredential);
parcelHelpers.export(exports, "N", ()=>EmailAuthCredential);
parcelHelpers.export(exports, "O", ()=>OperationType);
parcelHelpers.export(exports, "P", ()=>PhoneAuthProvider);
parcelHelpers.export(exports, "Q", ()=>OAuthCredential);
parcelHelpers.export(exports, "R", ()=>RecaptchaVerifier);
parcelHelpers.export(exports, "S", ()=>SignInMethod);
parcelHelpers.export(exports, "T", ()=>TotpMultiFactorGenerator);
parcelHelpers.export(exports, "U", ()=>PhoneAuthCredential);
parcelHelpers.export(exports, "V", ()=>inMemoryPersistence);
parcelHelpers.export(exports, "W", ()=>EmailAuthProvider);
parcelHelpers.export(exports, "X", ()=>FacebookAuthProvider);
parcelHelpers.export(exports, "Y", ()=>GoogleAuthProvider);
parcelHelpers.export(exports, "Z", ()=>GithubAuthProvider);
parcelHelpers.export(exports, "_", ()=>OAuthProvider);
parcelHelpers.export(exports, "a", ()=>browserCookiePersistence);
parcelHelpers.export(exports, "a0", ()=>TwitterAuthProvider);
parcelHelpers.export(exports, "a1", ()=>signInAnonymously);
parcelHelpers.export(exports, "a2", ()=>signInWithCredential);
parcelHelpers.export(exports, "a3", ()=>linkWithCredential);
parcelHelpers.export(exports, "a4", ()=>reauthenticateWithCredential);
parcelHelpers.export(exports, "a5", ()=>signInWithCustomToken);
parcelHelpers.export(exports, "a6", ()=>sendPasswordResetEmail);
parcelHelpers.export(exports, "a7", ()=>confirmPasswordReset);
parcelHelpers.export(exports, "a8", ()=>applyActionCode);
parcelHelpers.export(exports, "a9", ()=>checkActionCode);
parcelHelpers.export(exports, "aA", ()=>_getProjectConfig);
parcelHelpers.export(exports, "aB", ()=>_isIOS7Or8);
parcelHelpers.export(exports, "aC", ()=>_createError);
parcelHelpers.export(exports, "aD", ()=>_assert);
parcelHelpers.export(exports, "aE", ()=>AuthEventManager);
parcelHelpers.export(exports, "aF", ()=>_getInstance);
parcelHelpers.export(exports, "aG", ()=>_persistenceKeyName);
parcelHelpers.export(exports, "aH", ()=>_getRedirectResult);
parcelHelpers.export(exports, "aI", ()=>_overrideRedirectResult);
parcelHelpers.export(exports, "aJ", ()=>_clearRedirectOutcomes);
parcelHelpers.export(exports, "aK", ()=>_castAuth);
parcelHelpers.export(exports, "aL", ()=>UserImpl);
parcelHelpers.export(exports, "aM", ()=>AuthImpl);
parcelHelpers.export(exports, "aN", ()=>_getClientVersion);
parcelHelpers.export(exports, "aO", ()=>_generateEventId);
parcelHelpers.export(exports, "aP", ()=>AuthPopup);
parcelHelpers.export(exports, "aQ", ()=>FetchProvider);
parcelHelpers.export(exports, "aR", ()=>SAMLAuthCredential);
parcelHelpers.export(exports, "aa", ()=>verifyPasswordResetCode);
parcelHelpers.export(exports, "ab", ()=>createUserWithEmailAndPassword);
parcelHelpers.export(exports, "ac", ()=>signInWithEmailAndPassword);
parcelHelpers.export(exports, "ad", ()=>sendSignInLinkToEmail);
parcelHelpers.export(exports, "ae", ()=>isSignInWithEmailLink);
parcelHelpers.export(exports, "af", ()=>signInWithEmailLink);
parcelHelpers.export(exports, "ag", ()=>fetchSignInMethodsForEmail);
parcelHelpers.export(exports, "ah", ()=>sendEmailVerification);
parcelHelpers.export(exports, "ai", ()=>verifyBeforeUpdateEmail);
parcelHelpers.export(exports, "aj", ()=>ActionCodeURL);
parcelHelpers.export(exports, "ak", ()=>parseActionCodeURL);
parcelHelpers.export(exports, "al", ()=>updateProfile);
parcelHelpers.export(exports, "am", ()=>updateEmail);
parcelHelpers.export(exports, "an", ()=>updatePassword);
parcelHelpers.export(exports, "ao", ()=>getIdToken);
parcelHelpers.export(exports, "ap", ()=>getIdTokenResult);
parcelHelpers.export(exports, "aq", ()=>unlink);
parcelHelpers.export(exports, "ar", ()=>getAdditionalUserInfo);
parcelHelpers.export(exports, "as", ()=>reload);
parcelHelpers.export(exports, "at", ()=>getMultiFactorResolver);
parcelHelpers.export(exports, "au", ()=>multiFactor);
parcelHelpers.export(exports, "av", ()=>debugAssert);
parcelHelpers.export(exports, "aw", ()=>_isIOS);
parcelHelpers.export(exports, "ax", ()=>_isAndroid);
parcelHelpers.export(exports, "ay", ()=>_fail);
parcelHelpers.export(exports, "az", ()=>_getRedirectUrl);
parcelHelpers.export(exports, "b", ()=>browserLocalPersistence);
parcelHelpers.export(exports, "c", ()=>browserSessionPersistence);
parcelHelpers.export(exports, "d", ()=>signInWithPopup);
parcelHelpers.export(exports, "e", ()=>linkWithPopup);
parcelHelpers.export(exports, "f", ()=>reauthenticateWithPopup);
parcelHelpers.export(exports, "g", ()=>signInWithRedirect);
parcelHelpers.export(exports, "h", ()=>linkWithRedirect);
parcelHelpers.export(exports, "i", ()=>indexedDBLocalPersistence);
parcelHelpers.export(exports, "j", ()=>reauthenticateWithRedirect);
parcelHelpers.export(exports, "k", ()=>getRedirectResult);
parcelHelpers.export(exports, "l", ()=>linkWithPhoneNumber);
parcelHelpers.export(exports, "m", ()=>browserPopupRedirectResolver);
parcelHelpers.export(exports, "n", ()=>PhoneMultiFactorGenerator);
parcelHelpers.export(exports, "o", ()=>TotpSecret);
parcelHelpers.export(exports, "p", ()=>getAuth);
parcelHelpers.export(exports, "q", ()=>ProviderId);
parcelHelpers.export(exports, "r", ()=>reauthenticateWithPhoneNumber);
parcelHelpers.export(exports, "s", ()=>signInWithPhoneNumber);
parcelHelpers.export(exports, "t", ()=>setPersistence);
parcelHelpers.export(exports, "u", ()=>updatePhoneNumber);
parcelHelpers.export(exports, "v", ()=>initializeRecaptchaConfig);
parcelHelpers.export(exports, "w", ()=>validatePassword);
parcelHelpers.export(exports, "x", ()=>onIdTokenChanged);
parcelHelpers.export(exports, "y", ()=>beforeAuthStateChanged);
parcelHelpers.export(exports, "z", ()=>onAuthStateChanged);
var _app = require("@firebase/app");
var _util = require("@firebase/util");
var _logger = require("@firebase/logger");
var _tslib = require("tslib");
var _component = require("@firebase/component");
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ const FactorId = {
    /** Phone as second factor */ PHONE: 'phone',
    TOTP: 'totp'
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ const ProviderId = {
    /** Facebook provider ID */ FACEBOOK: 'facebook.com',
    /** GitHub provider ID */ GITHUB: 'github.com',
    /** Google provider ID */ GOOGLE: 'google.com',
    /** Password provider */ PASSWORD: 'password',
    /** Phone provider */ PHONE: 'phone',
    /** Twitter provider ID */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ const SignInMethod = {
    /** Email link sign in method */ EMAIL_LINK: 'emailLink',
    /** Email/password sign in method */ EMAIL_PASSWORD: 'password',
    /** Facebook sign in method */ FACEBOOK: 'facebook.com',
    /** GitHub sign in method */ GITHUB: 'github.com',
    /** Google sign in method */ GOOGLE: 'google.com',
    /** Phone sign in method */ PHONE: 'phone',
    /** Twitter sign in method */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ const OperationType = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: 'link',
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: 'reauthenticate',
    /** Operation involving signing in a user. */ SIGN_IN: 'signIn'
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ const ActionCodeOperation = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: 'EMAIL_SIGNIN',
    /** The password reset action. */ PASSWORD_RESET: 'PASSWORD_RESET',
    /** The email revocation action. */ RECOVER_EMAIL: 'RECOVER_EMAIL',
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: 'REVERT_SECOND_FACTOR_ADDITION',
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: 'VERIFY_AND_CHANGE_EMAIL',
    /** The email verification action. */ VERIFY_EMAIL: 'VERIFY_EMAIL'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function _debugErrorMap() {
    return {
        ["admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ]: 'This operation is restricted to administrators only.',
        ["argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ ]: '',
        ["app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ ]: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        ["app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ ]: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        ["captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ ]: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        ["code-expired" /* AuthErrorCode.CODE_EXPIRED */ ]: "The SMS code has expired. Please re-send the verification code to try again.",
        ["cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ ]: 'Cordova framework is not ready.',
        ["cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ ]: 'This browser is not supported.',
        ["credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ]: 'This credential is already associated with a different user account.',
        ["custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ]: 'The custom token corresponds to a different audience.',
        ["requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
        ["dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ ]: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        ["email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ ]: 'Multi-factor users must always have a verified email.',
        ["email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ]: 'The email address is already in use by another account.',
        ["emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ ]: 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.',
        ["expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ]: 'The action code has expired.',
        ["cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ]: 'This operation has been cancelled due to another conflicting popup being opened.',
        ["internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ]: 'An internal AuthError has occurred.',
        ["invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ ]: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        ["invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ ]: 'The mobile app identifier is not registered for the current project.',
        ["invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ]: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        ["invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ]: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        ["invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ ]: 'The continue URL provided in the request is invalid.',
        ["invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ ]: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        ["invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ ]: 'The custom token format is incorrect. Please check the documentation.',
        ["invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ ]: 'The provided dynamic link domain is not configured or authorized for the current project.',
        ["invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ]: 'The email address is badly formatted.',
        ["invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ ]: 'Emulator URL must start with a valid scheme (http:// or https://).',
        ["invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ ]: 'Your API key is invalid, please check you have copied it correctly.',
        ["invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ ]: 'The SHA-1 certificate hash provided is invalid.',
        ["invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ]: 'The supplied auth credential is incorrect, malformed or has expired.',
        ["invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ ]: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ]: 'The request does not contain a valid proof of first factor successful sign-in.',
        ["invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ ]: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        ["invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ]: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        ["unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ ]: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        ["invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ]: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        ["wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ]: 'The password is invalid or the user does not have a password.',
        ["invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ ]: 'The specified persistence type is invalid. It can only be local, session or none.',
        ["invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ ]: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        ["invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ ]: 'The specified provider ID is invalid.',
        ["invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ ]: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        ["invalid-sender" /* AuthErrorCode.INVALID_SENDER */ ]: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ]: 'The verification ID used to create the phone auth credential is invalid.',
        ["invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ ]: "The Auth instance's tenant ID is invalid.",
        ["login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ ]: 'Login blocked by user-provided method: {$originalMessage}',
        ["missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ]: 'An Android Package Name must be provided if the Android App is required to be installed.',
        ["auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ ]: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        ["missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ ]: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        ["missing-verification-code" /* AuthErrorCode.MISSING_CODE */ ]: 'The phone auth credential was created with an empty SMS verification code.',
        ["missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ ]: 'A continue URL must be provided in the request.',
        ["missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ ]: 'An internal AuthError has occurred.',
        ["missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ ]: 'An iOS Bundle ID must be provided if an App Store ID is provided.',
        ["missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ ]: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        ["missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ]: 'A non-empty password must be provided',
        ["missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ]: 'No second factor identifier is provided.',
        ["missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ]: 'The request is missing proof of first factor successful sign-in.',
        ["missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ ]: 'To send verification codes, provide a phone number for the recipient.',
        ["missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ]: 'The phone auth credential was created with an empty verification ID.',
        ["app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ ]: 'This instance of FirebaseApp has been deleted.',
        ["multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ]: 'The user does not have a second factor matching the identifier provided.',
        ["multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ]: 'Proof of ownership of a second factor is required to complete sign-in.',
        ["account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ ]: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        ["network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ]: 'A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.',
        ["no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ]: 'User was not linked to an account with the given provider.',
        ["null-user" /* AuthErrorCode.NULL_USER */ ]: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        ["operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ]: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        ["operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ]: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        ["popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ ]: 'Unable to establish a connection with the popup. It may have been blocked by the browser.',
        ["popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ]: 'The popup has been closed by the user before finalizing the operation.',
        ["provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ ]: 'User can only be linked to one identity for the given provider.',
        ["quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ ]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ ]: 'The redirect operation has been cancelled by the user before finalizing.',
        ["redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ ]: 'A redirect sign-in operation is already pending.',
        ["rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ ]: 'The request contains malformed or mismatching credentials.',
        ["second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ]: 'The second factor is already enrolled on this account.',
        ["maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: 'The maximum allowed number of second factors on a user has been exceeded.',
        ["tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ ]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* AuthErrorCode.TIMEOUT */ ]: 'The operation has timed out.',
        ["user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "We have blocked all requests from this device due to unusual activity. Try again later.",
        ["unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ]: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        ["unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ ]: 'Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.',
        ["unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ ]: 'The current environment does not support the specified persistence type.',
        ["unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ ]: 'This operation is not supported in a multi-tenant context.',
        ["unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ ]: 'The operation requires a verified email.',
        ["user-cancelled" /* AuthErrorCode.USER_CANCELLED */ ]: 'The user did not grant your application the permissions it requested.',
        ["user-not-found" /* AuthErrorCode.USER_DELETED */ ]: "There is no user record corresponding to this identifier. The user may have been deleted.",
        ["user-disabled" /* AuthErrorCode.USER_DISABLED */ ]: 'The user account has been disabled by an administrator.',
        ["user-mismatch" /* AuthErrorCode.USER_MISMATCH */ ]: 'The supplied credentials do not correspond to the previously signed in user.',
        ["user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ ]: '',
        ["weak-password" /* AuthErrorCode.WEAK_PASSWORD */ ]: 'The password must be 6 characters long or more.',
        ["web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ]: 'This browser is not supported or 3rd party cookies and data may be disabled.',
        ["already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ ]: "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance.",
        ["missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is missing when sending request to the backend.',
        ["invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is invalid when sending request to the backend.',
        ["invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ]: 'The reCAPTCHA action is invalid when sending request to the backend.',
        ["recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ]: 'reCAPTCHA Enterprise integration is not enabled for this project.',
        ["missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ]: 'The reCAPTCHA client type is missing when sending request to the backend.',
        ["missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is missing when sending request to the backend.',
        ["invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ]: 'Invalid request parameters.',
        ["invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is invalid when sending request to the backend.',
        ["unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ ]: 'The password policy received from the backend uses a schema version that is not supported by this version of the Firebase SDK.',
        ["password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: 'The password does not meet the requirements.',
        ["invalid-hosting-link-domain" /* AuthErrorCode.INVALID_HOSTING_LINK_DOMAIN */ ]: "The provided Hosting link domain is not configured in Firebase Hosting or is not owned by the current project. This cannot be a default Hosting domain (`web.app` or `firebaseapp.com`)."
    };
}
function _prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const debugErrorMap = _debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const prodErrorMap = _prodErrorMap;
const _DEFAULT_AUTH_ERROR_FACTORY = new (0, _util.ErrorFactory)('auth', 'Firebase', _prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ const AUTH_ERROR_CODES_MAP_DO_NOT_USE_INTERNALLY = {
    ADMIN_ONLY_OPERATION: 'auth/admin-restricted-operation',
    ARGUMENT_ERROR: 'auth/argument-error',
    APP_NOT_AUTHORIZED: 'auth/app-not-authorized',
    APP_NOT_INSTALLED: 'auth/app-not-installed',
    CAPTCHA_CHECK_FAILED: 'auth/captcha-check-failed',
    CODE_EXPIRED: 'auth/code-expired',
    CORDOVA_NOT_READY: 'auth/cordova-not-ready',
    CORS_UNSUPPORTED: 'auth/cors-unsupported',
    CREDENTIAL_ALREADY_IN_USE: 'auth/credential-already-in-use',
    CREDENTIAL_MISMATCH: 'auth/custom-token-mismatch',
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: 'auth/requires-recent-login',
    DEPENDENT_SDK_INIT_BEFORE_AUTH: 'auth/dependent-sdk-initialized-before-auth',
    DYNAMIC_LINK_NOT_ACTIVATED: 'auth/dynamic-link-not-activated',
    EMAIL_CHANGE_NEEDS_VERIFICATION: 'auth/email-change-needs-verification',
    EMAIL_EXISTS: 'auth/email-already-in-use',
    EMULATOR_CONFIG_FAILED: 'auth/emulator-config-failed',
    EXPIRED_OOB_CODE: 'auth/expired-action-code',
    EXPIRED_POPUP_REQUEST: 'auth/cancelled-popup-request',
    INTERNAL_ERROR: 'auth/internal-error',
    INVALID_API_KEY: 'auth/invalid-api-key',
    INVALID_APP_CREDENTIAL: 'auth/invalid-app-credential',
    INVALID_APP_ID: 'auth/invalid-app-id',
    INVALID_AUTH: 'auth/invalid-user-token',
    INVALID_AUTH_EVENT: 'auth/invalid-auth-event',
    INVALID_CERT_HASH: 'auth/invalid-cert-hash',
    INVALID_CODE: 'auth/invalid-verification-code',
    INVALID_CONTINUE_URI: 'auth/invalid-continue-uri',
    INVALID_CORDOVA_CONFIGURATION: 'auth/invalid-cordova-configuration',
    INVALID_CUSTOM_TOKEN: 'auth/invalid-custom-token',
    INVALID_DYNAMIC_LINK_DOMAIN: 'auth/invalid-dynamic-link-domain',
    INVALID_EMAIL: 'auth/invalid-email',
    INVALID_EMULATOR_SCHEME: 'auth/invalid-emulator-scheme',
    INVALID_IDP_RESPONSE: 'auth/invalid-credential',
    INVALID_LOGIN_CREDENTIALS: 'auth/invalid-credential',
    INVALID_MESSAGE_PAYLOAD: 'auth/invalid-message-payload',
    INVALID_MFA_SESSION: 'auth/invalid-multi-factor-session',
    INVALID_OAUTH_CLIENT_ID: 'auth/invalid-oauth-client-id',
    INVALID_OAUTH_PROVIDER: 'auth/invalid-oauth-provider',
    INVALID_OOB_CODE: 'auth/invalid-action-code',
    INVALID_ORIGIN: 'auth/unauthorized-domain',
    INVALID_PASSWORD: 'auth/wrong-password',
    INVALID_PERSISTENCE: 'auth/invalid-persistence-type',
    INVALID_PHONE_NUMBER: 'auth/invalid-phone-number',
    INVALID_PROVIDER_ID: 'auth/invalid-provider-id',
    INVALID_RECIPIENT_EMAIL: 'auth/invalid-recipient-email',
    INVALID_SENDER: 'auth/invalid-sender',
    INVALID_SESSION_INFO: 'auth/invalid-verification-id',
    INVALID_TENANT_ID: 'auth/invalid-tenant-id',
    MFA_INFO_NOT_FOUND: 'auth/multi-factor-info-not-found',
    MFA_REQUIRED: 'auth/multi-factor-auth-required',
    MISSING_ANDROID_PACKAGE_NAME: 'auth/missing-android-pkg-name',
    MISSING_APP_CREDENTIAL: 'auth/missing-app-credential',
    MISSING_AUTH_DOMAIN: 'auth/auth-domain-config-required',
    MISSING_CODE: 'auth/missing-verification-code',
    MISSING_CONTINUE_URI: 'auth/missing-continue-uri',
    MISSING_IFRAME_START: 'auth/missing-iframe-start',
    MISSING_IOS_BUNDLE_ID: 'auth/missing-ios-bundle-id',
    MISSING_OR_INVALID_NONCE: 'auth/missing-or-invalid-nonce',
    MISSING_MFA_INFO: 'auth/missing-multi-factor-info',
    MISSING_MFA_SESSION: 'auth/missing-multi-factor-session',
    MISSING_PHONE_NUMBER: 'auth/missing-phone-number',
    MISSING_SESSION_INFO: 'auth/missing-verification-id',
    MODULE_DESTROYED: 'auth/app-deleted',
    NEED_CONFIRMATION: 'auth/account-exists-with-different-credential',
    NETWORK_REQUEST_FAILED: 'auth/network-request-failed',
    NULL_USER: 'auth/null-user',
    NO_AUTH_EVENT: 'auth/no-auth-event',
    NO_SUCH_PROVIDER: 'auth/no-such-provider',
    OPERATION_NOT_ALLOWED: 'auth/operation-not-allowed',
    OPERATION_NOT_SUPPORTED: 'auth/operation-not-supported-in-this-environment',
    POPUP_BLOCKED: 'auth/popup-blocked',
    POPUP_CLOSED_BY_USER: 'auth/popup-closed-by-user',
    PROVIDER_ALREADY_LINKED: 'auth/provider-already-linked',
    QUOTA_EXCEEDED: 'auth/quota-exceeded',
    REDIRECT_CANCELLED_BY_USER: 'auth/redirect-cancelled-by-user',
    REDIRECT_OPERATION_PENDING: 'auth/redirect-operation-pending',
    REJECTED_CREDENTIAL: 'auth/rejected-credential',
    SECOND_FACTOR_ALREADY_ENROLLED: 'auth/second-factor-already-in-use',
    SECOND_FACTOR_LIMIT_EXCEEDED: 'auth/maximum-second-factor-count-exceeded',
    TENANT_ID_MISMATCH: 'auth/tenant-id-mismatch',
    TIMEOUT: 'auth/timeout',
    TOKEN_EXPIRED: 'auth/user-token-expired',
    TOO_MANY_ATTEMPTS_TRY_LATER: 'auth/too-many-requests',
    UNAUTHORIZED_DOMAIN: 'auth/unauthorized-continue-uri',
    UNSUPPORTED_FIRST_FACTOR: 'auth/unsupported-first-factor',
    UNSUPPORTED_PERSISTENCE: 'auth/unsupported-persistence-type',
    UNSUPPORTED_TENANT_OPERATION: 'auth/unsupported-tenant-operation',
    UNVERIFIED_EMAIL: 'auth/unverified-email',
    USER_CANCELLED: 'auth/user-cancelled',
    USER_DELETED: 'auth/user-not-found',
    USER_DISABLED: 'auth/user-disabled',
    USER_MISMATCH: 'auth/user-mismatch',
    USER_SIGNED_OUT: 'auth/user-signed-out',
    WEAK_PASSWORD: 'auth/weak-password',
    WEB_STORAGE_UNSUPPORTED: 'auth/web-storage-unsupported',
    ALREADY_INITIALIZED: 'auth/already-initialized',
    RECAPTCHA_NOT_ENABLED: 'auth/recaptcha-not-enabled',
    MISSING_RECAPTCHA_TOKEN: 'auth/missing-recaptcha-token',
    INVALID_RECAPTCHA_TOKEN: 'auth/invalid-recaptcha-token',
    INVALID_RECAPTCHA_ACTION: 'auth/invalid-recaptcha-action',
    MISSING_CLIENT_TYPE: 'auth/missing-client-type',
    MISSING_RECAPTCHA_VERSION: 'auth/missing-recaptcha-version',
    INVALID_RECAPTCHA_VERSION: 'auth/invalid-recaptcha-version',
    INVALID_REQ_TYPE: 'auth/invalid-req-type',
    INVALID_HOSTING_LINK_DOMAIN: 'auth/invalid-hosting-link-domain'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const logClient = new (0, _logger.Logger)('@firebase/auth');
function _logWarn(msg, ...args) {
    if (logClient.logLevel <= (0, _logger.LogLevel).WARN) logClient.warn(`Auth (${(0, _app.SDK_VERSION)}): ${msg}`, ...args);
}
function _logError(msg, ...args) {
    if (logClient.logLevel <= (0, _logger.LogLevel).ERROR) logClient.error(`Auth (${(0, _app.SDK_VERSION)}): ${msg}`, ...args);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function _fail(authOrCode, ...rest) {
    throw createErrorInternal(authOrCode, ...rest);
}
function _createError(authOrCode, ...rest) {
    return createErrorInternal(authOrCode, ...rest);
}
function _errorWithCustomMessage(auth, code, message) {
    const errorMap = Object.assign(Object.assign({}, prodErrorMap()), {
        [code]: message
    });
    const factory = new (0, _util.ErrorFactory)('auth', 'Firebase', errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function _serverAppCurrentUserOperationNotSupportedError(auth) {
    return _errorWithCustomMessage(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ , 'Operations that alter the current user are not supported in conjunction with FirebaseServerApp');
}
function _assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) _fail(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw _errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , `Type of ${object.constructor.name} does not match expected instance.` + `Did you pass a reference from a different Auth SDK?`);
    }
}
function createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== 'string') {
        const code = rest[0];
        const fullParams = [
            ...rest.slice(1)
        ];
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return _DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function _assert(assertion, authOrCode, ...rest) {
    if (!assertion) throw createErrorInternal(authOrCode, ...rest);
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    _logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function debugAssert(assertion, message) {
    if (!assertion) debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function _getCurrentUrl() {
    var _a;
    return typeof self !== 'undefined' && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.href) || '';
}
function _isHttpOrHttps() {
    return _getCurrentScheme() === 'http:' || _getCurrentScheme() === 'https:';
}
function _getCurrentScheme() {
    var _a;
    return typeof self !== 'undefined' && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function _isOnline() {
    if (typeof navigator !== 'undefined' && navigator && 'onLine' in navigator && typeof navigator.onLine === 'boolean' && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    (_isHttpOrHttps() || (0, _util.isBrowserExtension)() || 'connection' in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function _getUserLanguage() {
    if (typeof navigator === 'undefined') return null;
    const navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ class Delay {
    constructor(shortDelay, longDelay){
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        debugAssert(longDelay > shortDelay, 'Short delay should be less than long delay!');
        this.isMobile = (0, _util.isMobileCordova)() || (0, _util.isReactNative)();
    }
    get() {
        if (!_isOnline()) // Pick the shorter timeout.
        return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function _emulatorUrl(config, path) {
    debugAssert(config.emulator, 'Emulator should always be set here');
    const { url } = config.emulator;
    if (!path) return url;
    return `${url}${path.startsWith('/') ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class FetchProvider {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) this.headersImpl = headersImpl;
        if (responseImpl) this.responseImpl = responseImpl;
    }
    static fetch() {
        if (this.fetchImpl) return this.fetchImpl;
        if (typeof self !== 'undefined' && 'fetch' in self) return self.fetch;
        if (typeof globalThis !== 'undefined' && globalThis.fetch) return globalThis.fetch;
        if (typeof fetch !== 'undefined') return fetch;
        debugFail('Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static headers() {
        if (this.headersImpl) return this.headersImpl;
        if (typeof self !== 'undefined' && 'Headers' in self) return self.Headers;
        if (typeof globalThis !== 'undefined' && globalThis.Headers) return globalThis.Headers;
        if (typeof Headers !== 'undefined') return Headers;
        debugFail('Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static response() {
        if (this.responseImpl) return this.responseImpl;
        if (typeof self !== 'undefined' && 'Response' in self) return self.Response;
        if (typeof globalThis !== 'undefined' && globalThis.Response) return globalThis.Response;
        if (typeof Response !== 'undefined') return Response;
        debugFail('Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ const SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ ]: "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ ]: "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ ]: "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ ]: "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ,
    // Thrown if Email Enumeration Protection is enabled in the project and the email or password is
    // invalid.
    ["INVALID_LOGIN_CREDENTIALS" /* ServerError.INVALID_LOGIN_CREDENTIALS */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ]: "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ,
    ["PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ ]: "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ]: "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ ,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ ]: "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ,
    ["INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ ]: "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ,
    ["INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ ]: "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ,
    ["TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["PASSWORD_DOES_NOT_MEET_REQUIREMENTS" /* ServerError.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ,
    // Phone Auth related errors.
    ["INVALID_CODE" /* ServerError.INVALID_CODE */ ]: "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ,
    ["INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ ]: "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ,
    ["INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ ]: "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ,
    ["SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ ]: "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ ]: "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ,
    ["UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ ]: "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ ]: "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ ]: "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ ]: "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ,
    ["MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ ]: "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ,
    ["MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ ]: "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ ]: "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ,
    ["SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ ]: "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Recaptcha related errors.
    ["RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ ]: "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ,
    ["MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ ]: "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ ]: "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ ]: "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ,
    ["MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ ]: "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ,
    ["MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ ]: "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ,
    ["INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ ]: "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ,
    ["INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ ]: "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ 
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const CookieAuthProxiedEndpoints = [
    "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ ,
    "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ ,
    "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ ,
    "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ ,
    "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ ,
    "/v1/token" /* Endpoint.TOKEN */ 
];
const DEFAULT_API_TIMEOUT_MS = new Delay(30000, 60000);
function _addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return Object.assign(Object.assign({}, request), {
        tenantId: auth.tenantId
    });
    return request;
}
async function _performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return _performFetchWithErrorHandling(auth, customErrorMap, async ()=>{
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* HttpMethod.GET */ ) params = request;
            else body = {
                body: JSON.stringify(request)
            };
        }
        const query = (0, _util.querystring)(Object.assign({
            key: auth.config.apiKey
        }, params)).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/json';
        if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
        const fetchArgs = Object.assign({
            method,
            headers
        }, body);
        /* Security-conscious server-side frameworks tend to have built in mitigations for referrer
           problems". See the Cloudflare GitHub issue #487: Error: The 'referrerPolicy' field on
           'RequestInitializerDict' is not implemented."
           https://github.com/cloudflare/next-on-pages/issues/487 */ if (!(0, _util.isCloudflareWorker)()) fetchArgs.referrerPolicy = 'no-referrer';
        if (auth.emulatorConfig && (0, _util.isCloudWorkstation)(auth.emulatorConfig.host)) fetchArgs.credentials = 'include';
        return FetchProvider.fetch()(await _getFinalTarget(auth, auth.config.apiHost, path, query), fetchArgs);
    });
}
async function _performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = Object.assign(Object.assign({}, SERVER_ERROR_MAP), customErrorMap);
    try {
        const networkTimeout = new NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ('needConfirmation' in json) throw _makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
        if (response.ok && !('errorMessage' in json)) return json;
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(' : ');
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw _makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
            else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw _makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
            else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw _makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
            const authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, '-');
            if (serverErrorMessage) throw _errorWithCustomMessage(auth, authError, serverErrorMessage);
            else _fail(auth, authError);
        }
    } catch (e) {
        if (e instanceof (0, _util.FirebaseError)) throw e;
        // Changing this to a different error code will log user out when there is a network error
        // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
        // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
        _fail(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
            'message': String(e)
        });
    }
}
async function _performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = await _performApiRequest(auth, method, path, request, customErrorMap);
    if ('mfaPendingCredential' in serverResponse) _fail(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
        _serverResponse: serverResponse
    });
    return serverResponse;
}
async function _getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    const authInternal = auth;
    const finalTarget = authInternal.config.emulator ? _emulatorUrl(auth.config, base) : `${auth.config.apiScheme}://${base}`;
    // Cookie auth works by MiTMing the signIn and token endpoints from the developer's backend,
    // saving the idToken and refreshToken into cookies, and then redacting the refreshToken
    // from the response
    if (CookieAuthProxiedEndpoints.includes(path)) {
        // Persistence manager is async, we need to await it. We can't just wait for auth initialized
        // here since auth initialization calls this function.
        await authInternal._persistenceManagerAvailable;
        if (authInternal._getPersistenceType() === "COOKIE" /* PersistenceType.COOKIE */ ) {
            const cookiePersistence = authInternal._getPersistence();
            return cookiePersistence._getFinalTarget(finalTarget).toString();
        }
    }
    return finalTarget;
}
function _parseEnforcementState(enforcementStateStr) {
    switch(enforcementStateStr){
        case 'ENFORCE':
            return "ENFORCE" /* EnforcementState.ENFORCE */ ;
        case 'AUDIT':
            return "AUDIT" /* EnforcementState.AUDIT */ ;
        case 'OFF':
            return "OFF" /* EnforcementState.OFF */ ;
        default:
            return "ENFORCEMENT_STATE_UNSPECIFIED" /* EnforcementState.ENFORCEMENT_STATE_UNSPECIFIED */ ;
    }
}
class NetworkTimeout {
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
    constructor(auth){
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject)=>{
            this.timer = setTimeout(()=>{
                return reject(_createError(this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, DEFAULT_API_TIMEOUT_MS.get());
        });
    }
}
function _makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    const error = _createError(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
class RecaptchaConfig {
    constructor(response){
        /**
         * The reCAPTCHA site key.
         */ this.siteKey = '';
        /**
         * The list of providers and their enablement status for reCAPTCHA Enterprise.
         */ this.recaptchaEnforcementState = [];
        if (response.recaptchaKey === undefined) throw new Error('recaptchaKey undefined');
        // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
        this.siteKey = response.recaptchaKey.split('/')[3];
        this.recaptchaEnforcementState = response.recaptchaEnforcementState;
    }
    /**
     * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
     *
     * @param providerStr - The provider whose enforcement state is to be returned.
     * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
     */ getProviderEnforcementState(providerStr) {
        if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0) return null;
        for (const recaptchaEnforcementState of this.recaptchaEnforcementState){
            if (recaptchaEnforcementState.provider && recaptchaEnforcementState.provider === providerStr) return _parseEnforcementState(recaptchaEnforcementState.enforcementState);
        }
        return null;
    }
    /**
     * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
     *
     * @param providerStr - The provider whose enablement state is to be returned.
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
     */ isProviderEnabled(providerStr) {
        return this.getProviderEnforcementState(providerStr) === "ENFORCE" /* EnforcementState.ENFORCE */  || this.getProviderEnforcementState(providerStr) === "AUDIT" /* EnforcementState.AUDIT */ ;
    }
    /**
     * Returns true if reCAPTCHA Enterprise protection is enabled in at least one provider, otherwise
     * returns false.
     *
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for at least one provider.
     */ isAnyProviderEnabled() {
        return this.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ ) || this.isProviderEnabled("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function getRecaptchaParams(auth) {
    return (await _performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )).recaptchaSiteKey || '';
}
async function getRecaptchaConfig(auth, request) {
    return _performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , _addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function deleteAccount(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request);
}
async function deleteLinkedAccounts(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function getAccountInfo(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function getIdToken(user, forceRefresh = false) {
    return (0, _util.getModularInstance)(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function getIdTokenResult(user, forceRefresh = false) {
    const userInternal = (0, _util.getModularInstance)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = _parseToken(token);
    _assert(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const firebase = typeof claims.firebase === 'object' ? claims.firebase : undefined;
    const signInProvider = firebase === null || firebase === void 0 ? void 0 : firebase['sign_in_provider'];
    return {
        claims,
        token,
        authTime: utcTimestampToDateString(secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: utcTimestampToDateString(secondsStringToMilliseconds(claims.iat)),
        expirationTime: utcTimestampToDateString(secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: (firebase === null || firebase === void 0 ? void 0 : firebase['sign_in_second_factor']) || null
    };
}
function secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function _parseToken(token) {
    const [algorithm, payload, signature] = token.split('.');
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        _logError('JWT malformed, contained fewer than 3 sections');
        return null;
    }
    try {
        const decoded = (0, _util.base64Decode)(payload);
        if (!decoded) {
            _logError('Failed to decode base64 JWT payload');
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        _logError('Caught error parsing JWT payload as JSON', e === null || e === void 0 ? void 0 : e.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function _tokenExpiresIn(token) {
    const parsedToken = _parseToken(token);
    _assert(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    _assert(typeof parsedToken.exp !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    _assert(typeof parsedToken.iat !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function _logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) return promise;
    try {
        return await promise;
    } catch (e) {
        if (e instanceof (0, _util.FirebaseError) && isUserInvalidated(e)) {
            if (user.auth.currentUser === user) await user.auth.signOut();
        }
        throw e;
    }
}
function isUserInvalidated({ code }) {
    return code === `auth/${"user-disabled" /* AuthErrorCode.USER_DISABLED */ }` || code === `auth/${"user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ }`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class ProactiveRefresh {
    constructor(user){
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    _start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        if (this.timerId !== null) clearTimeout(this.timerId);
    }
    getInterval(wasError) {
        var _a;
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
            return interval;
        } else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
            const expTime = (_a = this.user.stsTokenManager.expirationTime) !== null && _a !== void 0 ? _a : 0;
            const interval = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) // Just in case...
        return;
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async ()=>{
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        } catch (e) {
            // Only retry on network errors
            if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) this.schedule(/* wasError */ true);
            return;
        }
        this.schedule();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class UserMetadata {
    constructor(createdAt, lastLoginAt){
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function _reloadWithoutSaving(user) {
    var _a;
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await _logoutIfInvalidated(user, getAccountInfo(auth, {
        idToken
    }));
    _assert(response === null || response === void 0 ? void 0 : response.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = ((_a = coreAccount.providerUserInfo) === null || _a === void 0 ? void 0 : _a.length) ? extractProviderData(coreAccount.providerUserInfo) : [];
    const providerData = mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData,
        metadata: new UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ async function reload(user) {
    const userInternal = (0, _util.getModularInstance)(user);
    await _reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function mergeProviderData(original, newData) {
    const deduped = original.filter((o)=>!newData.some((n)=>n.providerId === o.providerId));
    return [
        ...deduped,
        ...newData
    ];
}
function extractProviderData(providers) {
    return providers.map((_a)=>{
        var { providerId } = _a, provider = (0, _tslib.__rest)(_a, [
            "providerId"
        ]);
        return {
            providerId,
            uid: provider.rawId || '',
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function requestStsToken(auth, refreshToken) {
    const response = await _performFetchWithErrorHandling(auth, {}, async ()=>{
        const body = (0, _util.querystring)({
            'grant_type': 'refresh_token',
            'refresh_token': refreshToken
        }).slice(1);
        const { tokenApiHost, apiKey } = auth.config;
        const url = await _getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/x-www-form-urlencoded';
        const options = {
            method: "POST" /* HttpMethod.POST */ ,
            headers,
            body
        };
        if (auth.emulatorConfig && (0, _util.isCloudWorkstation)(auth.emulatorConfig.host)) options.credentials = 'include';
        return FetchProvider.fetch()(url, options);
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}
async function revokeToken(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts:revokeToken" /* Endpoint.REVOKE_TOKEN */ , _addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ class StsTokenManager {
    constructor(){
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
    }
    updateFromServerResponse(response) {
        _assert(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        _assert(typeof response.idToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        _assert(typeof response.refreshToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = 'expiresIn' in response && typeof response.expiresIn !== 'undefined' ? Number(response.expiresIn) : _tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    updateFromIdToken(idToken) {
        _assert(idToken.length !== 0, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = _tokenExpiresIn(idToken);
        this.updateTokensAndExpiration(idToken, null, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        if (!forceRefresh && this.accessToken && !this.isExpired) return this.accessToken;
        _assert(this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken, refreshToken, expiresIn } = await requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken, accessToken, expirationTime } = object;
        const manager = new StsTokenManager();
        if (refreshToken) {
            _assert(typeof refreshToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            _assert(typeof accessToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            _assert(typeof expirationTime === 'number', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function assertStringOrUndefined(assertion, appName) {
    _assert(typeof assertion === 'string' || typeof assertion === 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName
    });
}
class UserImpl {
    constructor(_a){
        var { uid, auth, stsTokenManager } = _a, opt = (0, _tslib.__rest)(_a, [
            "uid",
            "auth",
            "stsTokenManager"
        ]);
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [
            ...opt.providerData
        ] : [];
        this.metadata = new UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await _logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        _assert(accessToken, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return getIdTokenResult(this, forceRefresh);
    }
    reload() {
        return reload(this);
    }
    _assign(user) {
        if (this === user) return;
        _assert(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map((userInfo)=>Object.assign({}, userInfo));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        const newUser = new UserImpl(Object.assign(Object.assign({}, this), {
            auth,
            stsTokenManager: this.stsTokenManager._clone()
        }));
        newUser.metadata._copy(this.metadata);
        return newUser;
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        _assert(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) this.reloadListener(userInfo);
        else // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) await _reloadWithoutSaving(this);
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) this.auth._notifyListenersIfCurrent(this);
    }
    async delete() {
        if ((0, _app._isFirebaseServerApp)(this.auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(this.auth));
        const idToken = await this.getIdToken();
        await _logoutIfInvalidated(this, deleteAccount(this.auth, {
            idToken
        }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return Object.assign(Object.assign({
            uid: this.uid,
            email: this.email || undefined,
            emailVerified: this.emailVerified,
            displayName: this.displayName || undefined,
            isAnonymous: this.isAnonymous,
            photoURL: this.photoURL || undefined,
            phoneNumber: this.phoneNumber || undefined,
            tenantId: this.tenantId || undefined,
            providerData: this.providerData.map((userInfo)=>Object.assign({}, userInfo)),
            stsTokenManager: this.stsTokenManager.toJSON(),
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId
        }, this.metadata.toJSON()), {
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey,
            appName: this.auth.name
        });
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || '';
    }
    static _fromJSON(auth, object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const displayName = (_a = object.displayName) !== null && _a !== void 0 ? _a : undefined;
        const email = (_b = object.email) !== null && _b !== void 0 ? _b : undefined;
        const phoneNumber = (_c = object.phoneNumber) !== null && _c !== void 0 ? _c : undefined;
        const photoURL = (_d = object.photoURL) !== null && _d !== void 0 ? _d : undefined;
        const tenantId = (_e = object.tenantId) !== null && _e !== void 0 ? _e : undefined;
        const _redirectEventId = (_f = object._redirectEventId) !== null && _f !== void 0 ? _f : undefined;
        const createdAt = (_g = object.createdAt) !== null && _g !== void 0 ? _g : undefined;
        const lastLoginAt = (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : undefined;
        const { uid, emailVerified, isAnonymous, providerData, stsTokenManager: plainObjectTokenManager } = object;
        _assert(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const stsTokenManager = StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        _assert(typeof uid === 'string', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        assertStringOrUndefined(displayName, auth.name);
        assertStringOrUndefined(email, auth.name);
        _assert(typeof emailVerified === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        _assert(typeof isAnonymous === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        assertStringOrUndefined(phoneNumber, auth.name);
        assertStringOrUndefined(photoURL, auth.name);
        assertStringOrUndefined(tenantId, auth.name);
        assertStringOrUndefined(_redirectEventId, auth.name);
        assertStringOrUndefined(createdAt, auth.name);
        assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new UserImpl({
            uid,
            auth,
            email,
            emailVerified,
            displayName,
            isAnonymous,
            photoURL,
            phoneNumber,
            tenantId,
            stsTokenManager,
            createdAt,
            lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) user.providerData = providerData.map((userInfo)=>Object.assign({}, userInfo));
        if (_redirectEventId) user._redirectEventId = _redirectEventId;
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new UserImpl({
            uid: idTokenResponse.localId,
            auth,
            stsTokenManager,
            isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await _reloadWithoutSaving(user);
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromGetAccountInfoResponse(auth, response, idToken) {
        const coreAccount = response.users[0];
        _assert(coreAccount.localId !== undefined, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const providerData = coreAccount.providerUserInfo !== undefined ? extractProviderData(coreAccount.providerUserInfo) : [];
        const isAnonymous = !(coreAccount.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
        const stsTokenManager = new StsTokenManager();
        stsTokenManager.updateFromIdToken(idToken);
        // Initialize the Firebase Auth user.
        const user = new UserImpl({
            uid: coreAccount.localId,
            auth,
            stsTokenManager,
            isAnonymous
        });
        // update the user with data from the GetAccountInfo response.
        const updates = {
            uid: coreAccount.localId,
            displayName: coreAccount.displayName || null,
            photoURL: coreAccount.photoUrl || null,
            email: coreAccount.email || null,
            emailVerified: coreAccount.emailVerified || false,
            phoneNumber: coreAccount.phoneNumber || null,
            tenantId: coreAccount.tenantId || null,
            providerData,
            metadata: new UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
            isAnonymous: !(coreAccount.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length)
        };
        Object.assign(user, updates);
        return user;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const instanceCache = new Map();
function _getInstance(cls) {
    debugAssert(cls instanceof Function, 'Expected a class definition');
    let instance = instanceCache.get(cls);
    if (instance) {
        debugAssert(instance instanceof cls, 'Instance stored in cache mismatched with class');
        return instance;
    }
    instance = new cls();
    instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class InMemoryPersistence {
    constructor(){
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
InMemoryPersistence.type = 'NONE';
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ const inMemoryPersistence = InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function _persistenceKeyName(key, apiKey, appName) {
    return `${"firebase" /* Namespace.PERSISTENCE */ }:${key}:${apiKey}:${appName}`;
}
class PersistenceUserManager {
    constructor(persistence, auth, userKey){
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config, name } = this.auth;
        this.fullUserKey = _persistenceKeyName(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = _persistenceKeyName("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        if (!blob) return null;
        if (typeof blob === 'string') {
            const response = await getAccountInfo(this.auth, {
                idToken: blob
            }).catch(()=>undefined);
            if (!response) return null;
            return UserImpl._fromGetAccountInfoResponse(this.auth, response, blob);
        }
        return UserImpl._fromJSON(this.auth, blob);
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) return;
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) return this.setCurrentUser(currentUser);
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* KeyName.AUTH_USER */ ) {
        if (!persistenceHierarchy.length) return new PersistenceUserManager(_getInstance(inMemoryPersistence), auth, userKey);
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (await persistence._isAvailable()) return persistence;
            return undefined;
        }))).filter((persistence)=>persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] || _getInstance(inMemoryPersistence);
        const key = _persistenceKeyName(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy)try {
            const blob = await persistence._get(key);
            if (blob) {
                let user;
                if (typeof blob === 'string') {
                    const response = await getAccountInfo(auth, {
                        idToken: blob
                    }).catch(()=>undefined);
                    if (!response) break;
                    user = await UserImpl._fromGetAccountInfoResponse(auth, response, blob);
                } else user = UserImpl._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                if (persistence !== selectedPersistence) userToMigrate = user;
                selectedPersistence = persistence;
                break;
            }
        } catch (_a) {}
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter((p)=>p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return new PersistenceUserManager(selectedPersistence, auth, userKey);
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
        // we'll just let it bubble to surface the error.
        await selectedPersistence._set(key, userToMigrate.toJSON());
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (persistence !== selectedPersistence) try {
                await persistence._remove(key);
            } catch (_a) {}
        }));
        return new PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function _getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes('opera/') || ua.includes('opr/') || ua.includes('opios/')) return "Opera" /* BrowserName.OPERA */ ;
    else if (_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes('msie') || ua.includes('trident/')) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes('edge/')) return "Edge" /* BrowserName.EDGE */ ;
    else if (_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes('silk/')) return "Silk" /* BrowserName.SILK */ ;
    else if (_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if (_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if (_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes('chrome/') || _isChromeIOS(ua)) && !ua.includes('edge/')) return "Chrome" /* BrowserName.CHROME */ ;
    else if (_isAndroid(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if ((matches === null || matches === void 0 ? void 0 : matches.length) === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function _isFirefox(ua = (0, _util.getUA)()) {
    return /firefox\//i.test(ua);
}
function _isSafari(userAgent = (0, _util.getUA)()) {
    const ua = userAgent.toLowerCase();
    return ua.includes('safari/') && !ua.includes('chrome/') && !ua.includes('crios/') && !ua.includes('android');
}
function _isChromeIOS(ua = (0, _util.getUA)()) {
    return /crios\//i.test(ua);
}
function _isIEMobile(ua = (0, _util.getUA)()) {
    return /iemobile/i.test(ua);
}
function _isAndroid(ua = (0, _util.getUA)()) {
    return /android/i.test(ua);
}
function _isBlackBerry(ua = (0, _util.getUA)()) {
    return /blackberry/i.test(ua);
}
function _isWebOS(ua = (0, _util.getUA)()) {
    return /webos/i.test(ua);
}
function _isIOS(ua = (0, _util.getUA)()) {
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function _isIOS7Or8(ua = (0, _util.getUA)()) {
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function _isIOSStandalone(ua = (0, _util.getUA)()) {
    var _a;
    return _isIOS(ua) && !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.standalone);
}
function _isIE10() {
    return (0, _util.isIE)() && document.documentMode === 10;
}
function _isMobileBrowser(ua = (0, _util.getUA)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return _isIOS(ua) || _isAndroid(ua) || _isWebOS(ua) || _isBlackBerry(ua) || /windows phone/i.test(ua) || _isIEMobile(ua);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function _getClientVersion(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = _getBrowserName((0, _util.getUA)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${_getBrowserName((0, _util.getUA)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length ? frameworks.join(',') : 'FirebaseCore-web'; /* default value if no other framework is used */ 
    return `${reportedPlatform}/${"JsCore" /* ClientImplementation.CORE */ }/${0, _app.SDK_VERSION}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class AuthMiddlewareQueue {
    constructor(auth){
        this.auth = auth;
        this.queue = [];
    }
    pushCallback(callback, onAbort) {
        // The callback could be sync or async. Wrap it into a
        // function that is always async.
        const wrappedCallback = (user)=>new Promise((resolve, reject)=>{
                try {
                    const result = callback(user);
                    // Either resolve with existing promise or wrap a non-promise
                    // return value into a promise.
                    resolve(result);
                } catch (e) {
                    // Sync callback throws.
                    reject(e);
                }
            });
        // Attach the onAbort if present
        wrappedCallback.onAbort = onAbort;
        this.queue.push(wrappedCallback);
        const index = this.queue.length - 1;
        return ()=>{
            // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
            // indexing of other elements.
            this.queue[index] = ()=>Promise.resolve();
        };
    }
    async runMiddleware(nextUser) {
        if (this.auth.currentUser === nextUser) return;
        // While running the middleware, build a temporary stack of onAbort
        // callbacks to call if one middleware callback rejects.
        const onAbortStack = [];
        try {
            for (const beforeStateCallback of this.queue){
                await beforeStateCallback(nextUser);
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
            }
        } catch (e) {
            // Run all onAbort, with separate try/catch to ignore any errors and
            // continue
            onAbortStack.reverse();
            for (const onAbort of onAbortStack)try {
                onAbort();
            } catch (_) {
            /* swallow error */ }
            throw this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                originalMessage: e === null || e === void 0 ? void 0 : e.message
            });
        }
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Fetches the password policy for the currently set tenant or the project if no tenant is set.
 *
 * @param auth Auth object.
 * @param request Password policy request.
 * @returns Password policy response.
 */ async function _getPasswordPolicy(auth, request = {}) {
    return _performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/passwordPolicy" /* Endpoint.GET_PASSWORD_POLICY */ , _addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Minimum min password length enforced by the backend, even if no minimum length is set.
const MINIMUM_MIN_PASSWORD_LENGTH = 6;
/**
 * Stores password policy requirements and provides password validation against the policy.
 *
 * @internal
 */ class PasswordPolicyImpl {
    constructor(response){
        var _a, _b, _c, _d;
        // Only include custom strength options defined in the response.
        const responseOptions = response.customStrengthOptions;
        this.customStrengthOptions = {};
        // TODO: Remove once the backend is updated to include the minimum min password length instead of undefined when there is no minimum length set.
        this.customStrengthOptions.minPasswordLength = (_a = responseOptions.minPasswordLength) !== null && _a !== void 0 ? _a : MINIMUM_MIN_PASSWORD_LENGTH;
        if (responseOptions.maxPasswordLength) this.customStrengthOptions.maxPasswordLength = responseOptions.maxPasswordLength;
        if (responseOptions.containsLowercaseCharacter !== undefined) this.customStrengthOptions.containsLowercaseLetter = responseOptions.containsLowercaseCharacter;
        if (responseOptions.containsUppercaseCharacter !== undefined) this.customStrengthOptions.containsUppercaseLetter = responseOptions.containsUppercaseCharacter;
        if (responseOptions.containsNumericCharacter !== undefined) this.customStrengthOptions.containsNumericCharacter = responseOptions.containsNumericCharacter;
        if (responseOptions.containsNonAlphanumericCharacter !== undefined) this.customStrengthOptions.containsNonAlphanumericCharacter = responseOptions.containsNonAlphanumericCharacter;
        this.enforcementState = response.enforcementState;
        if (this.enforcementState === 'ENFORCEMENT_STATE_UNSPECIFIED') this.enforcementState = 'OFF';
        // Use an empty string if no non-alphanumeric characters are specified in the response.
        this.allowedNonAlphanumericCharacters = (_c = (_b = response.allowedNonAlphanumericCharacters) === null || _b === void 0 ? void 0 : _b.join('')) !== null && _c !== void 0 ? _c : '';
        this.forceUpgradeOnSignin = (_d = response.forceUpgradeOnSignin) !== null && _d !== void 0 ? _d : false;
        this.schemaVersion = response.schemaVersion;
    }
    validatePassword(password) {
        var _a, _b, _c, _d, _e, _f;
        const status = {
            isValid: true,
            passwordPolicy: this
        };
        // Check the password length and character options.
        this.validatePasswordLengthOptions(password, status);
        this.validatePasswordCharacterOptions(password, status);
        // Combine the status into single isValid property.
        status.isValid && (status.isValid = (_a = status.meetsMinPasswordLength) !== null && _a !== void 0 ? _a : true);
        status.isValid && (status.isValid = (_b = status.meetsMaxPasswordLength) !== null && _b !== void 0 ? _b : true);
        status.isValid && (status.isValid = (_c = status.containsLowercaseLetter) !== null && _c !== void 0 ? _c : true);
        status.isValid && (status.isValid = (_d = status.containsUppercaseLetter) !== null && _d !== void 0 ? _d : true);
        status.isValid && (status.isValid = (_e = status.containsNumericCharacter) !== null && _e !== void 0 ? _e : true);
        status.isValid && (status.isValid = (_f = status.containsNonAlphanumericCharacter) !== null && _f !== void 0 ? _f : true);
        return status;
    }
    /**
     * Validates that the password meets the length options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordLengthOptions(password, status) {
        const minPasswordLength = this.customStrengthOptions.minPasswordLength;
        const maxPasswordLength = this.customStrengthOptions.maxPasswordLength;
        if (minPasswordLength) status.meetsMinPasswordLength = password.length >= minPasswordLength;
        if (maxPasswordLength) status.meetsMaxPasswordLength = password.length <= maxPasswordLength;
    }
    /**
     * Validates that the password meets the character options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordCharacterOptions(password, status) {
        // Assign statuses for requirements even if the password is an empty string.
        this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ false, /* containsUppercaseCharacter= */ false, /* containsNumericCharacter= */ false, /* containsNonAlphanumericCharacter= */ false);
        let passwordChar;
        for(let i = 0; i < password.length; i++){
            passwordChar = password.charAt(i);
            this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ passwordChar >= 'a' && passwordChar <= 'z', /* containsUppercaseCharacter= */ passwordChar >= 'A' && passwordChar <= 'Z', /* containsNumericCharacter= */ passwordChar >= '0' && passwordChar <= '9', /* containsNonAlphanumericCharacter= */ this.allowedNonAlphanumericCharacters.includes(passwordChar));
        }
    }
    /**
     * Updates the running validation status with the statuses for the character options.
     * Expected to be called each time a character is processed to update each option status
     * based on the current character.
     *
     * @param status Validation status.
     * @param containsLowercaseCharacter Whether the character is a lowercase letter.
     * @param containsUppercaseCharacter Whether the character is an uppercase letter.
     * @param containsNumericCharacter Whether the character is a numeric character.
     * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
     */ updatePasswordCharacterOptionsStatuses(status, containsLowercaseCharacter, containsUppercaseCharacter, containsNumericCharacter, containsNonAlphanumericCharacter) {
        if (this.customStrengthOptions.containsLowercaseLetter) status.containsLowercaseLetter || (status.containsLowercaseLetter = containsLowercaseCharacter);
        if (this.customStrengthOptions.containsUppercaseLetter) status.containsUppercaseLetter || (status.containsUppercaseLetter = containsUppercaseCharacter);
        if (this.customStrengthOptions.containsNumericCharacter) status.containsNumericCharacter || (status.containsNumericCharacter = containsNumericCharacter);
        if (this.customStrengthOptions.containsNonAlphanumericCharacter) status.containsNonAlphanumericCharacter || (status.containsNonAlphanumericCharacter = containsNonAlphanumericCharacter);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class AuthImpl {
    constructor(app, heartbeatServiceProvider, appCheckServiceProvider, config){
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new Subscription(this);
        this.idTokenSubscription = new Subscription(this);
        this.beforeStateQueue = new AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = _DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        this._projectPasswordPolicy = null;
        this._tenantPasswordPolicies = {};
        this._resolvePersistenceManagerAvailable = undefined;
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
        // TODO(jamesdaniels) explore less hacky way to do this, cookie authentication needs
        // persistenceMananger to be available. see _getFinalTarget for more context
        this._persistenceManagerAvailable = new Promise((resolve)=>this._resolvePersistenceManagerAvailable = resolve);
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) this._popupRedirectResolver = _getInstance(popupRedirectResolver);
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async ()=>{
            var _a, _b, _c;
            if (this._deleted) return;
            this.persistenceManager = await PersistenceUserManager.create(this, persistenceHierarchy);
            (_a = this._resolvePersistenceManagerAvailable) === null || _a === void 0 || _a.call(this);
            if (this._deleted) return;
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if ((_b = this._popupRedirectResolver) === null || _b === void 0 ? void 0 : _b._shouldInitProactively) // If this fails, don't halt auth loading
            try {
                await this._popupRedirectResolver._initialize(this);
            } catch (e) {
            /* Ignore the error */ }
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = ((_c = this.currentUser) === null || _c === void 0 ? void 0 : _c.uid) || null;
            if (this._deleted) return;
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */ async _onStorageEvent() {
        if (this._deleted) return;
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
        return;
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        // Skip blocking callbacks, they should not apply to a change in another tab.
        await this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true);
    }
    async initializeCurrentUserFromIdToken(idToken) {
        try {
            const response = await getAccountInfo(this, {
                idToken
            });
            const user = await UserImpl._fromGetAccountInfoResponse(this, response, idToken);
            await this.directlySetCurrentUser(user);
        } catch (err) {
            console.warn('FirebaseServerApp could not login user with provided authIdToken: ', err);
            await this.directlySetCurrentUser(null);
        }
    }
    async initializeCurrentUser(popupRedirectResolver) {
        var _a;
        if ((0, _app._isFirebaseServerApp)(this.app)) {
            const idToken = this.app.settings.authIdToken;
            if (idToken) // Start the auth operation in the next tick to allow a moment for the customer's app to
            // attach an emulator, if desired.
            return new Promise((resolve)=>{
                setTimeout(()=>this.initializeCurrentUserFromIdToken(idToken).then(resolve, resolve));
            });
            else return this.directlySetCurrentUser(null);
        }
        // First check to see if we have a pending redirect event.
        const previouslyStoredUser = await this.assertedPersistence.getCurrentUser();
        let futureCurrentUser = previouslyStoredUser;
        let needsTocheckMiddleware = false;
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = (_a = this.redirectUser) === null || _a === void 0 ? void 0 : _a._redirectEventId;
            const storedUserEventId = futureCurrentUser === null || futureCurrentUser === void 0 ? void 0 : futureCurrentUser._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && (result === null || result === void 0 ? void 0 : result.user)) {
                futureCurrentUser = result.user;
                needsTocheckMiddleware = true;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!futureCurrentUser) return this.directlySetCurrentUser(null);
        if (!futureCurrentUser._redirectEventId) {
            // This isn't a redirect link operation, we can reload and bail.
            // First though, ensure that we check the middleware is happy.
            if (needsTocheckMiddleware) try {
                await this.beforeStateQueue.runMiddleware(futureCurrentUser);
            } catch (e) {
                futureCurrentUser = previouslyStoredUser;
                // We know this is available since the bit is only set when the
                // resolver is available
                this._popupRedirectResolver._overrideRedirectResult(this, ()=>Promise.reject(e));
            }
            if (futureCurrentUser) return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
            else return this.directlySetCurrentUser(null);
        }
        _assert(this._popupRedirectResolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return this.directlySetCurrentUser(futureCurrentUser);
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        } catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await _reloadWithoutSaving(user);
        } catch (e) {
            if ((e === null || e === void 0 ? void 0 : e.code) !== `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) // Something's wrong with the user's token. Log them out and remove
            // them from storage
            return this.directlySetCurrentUser(null);
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = _getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        if ((0, _app._isFirebaseServerApp)(this.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(this));
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern ? (0, _util.getModularInstance)(userExtern) : null;
        if (user) _assert(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
        if (this._deleted) return;
        if (user) _assert(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
        if (!skipBeforeStateCallbacks) await this.beforeStateQueue.runMiddleware(user);
        return this.queue(async ()=>{
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        if ((0, _app._isFirebaseServerApp)(this.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(this));
        // Run first, to block _setRedirectUser() if any callbacks fail.
        await this.beforeStateQueue.runMiddleware(null);
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) await this._setRedirectUser(null);
        // Prevent callbacks from being called again in _updateCurrentUser, as
        // they were already called in the first line.
        return this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true);
    }
    setPersistence(persistence) {
        if ((0, _app._isFirebaseServerApp)(this.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(this));
        return this.queue(async ()=>{
            await this.assertedPersistence.setPersistence(_getInstance(persistence));
        });
    }
    _getRecaptchaConfig() {
        if (this.tenantId == null) return this._agentRecaptchaConfig;
        else return this._tenantRecaptchaConfigs[this.tenantId];
    }
    async validatePassword(password) {
        if (!this._getPasswordPolicyInternal()) await this._updatePasswordPolicy();
        // Password policy will be defined after fetching.
        const passwordPolicy = this._getPasswordPolicyInternal();
        // Check that the policy schema version is supported by the SDK.
        // TODO: Update this logic to use a max supported policy schema version once we have multiple schema versions.
        if (passwordPolicy.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION) return Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , {}));
        return passwordPolicy.validatePassword(password);
    }
    _getPasswordPolicyInternal() {
        if (this.tenantId === null) return this._projectPasswordPolicy;
        else return this._tenantPasswordPolicies[this.tenantId];
    }
    async _updatePasswordPolicy() {
        const response = await _getPasswordPolicy(this);
        const passwordPolicy = new PasswordPolicyImpl(response);
        if (this.tenantId === null) this._projectPasswordPolicy = passwordPolicy;
        else this._tenantPasswordPolicies[this.tenantId] = passwordPolicy;
    }
    _getPersistenceType() {
        return this.assertedPersistence.persistence.type;
    }
    _getPersistence() {
        return this.assertedPersistence.persistence;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new (0, _util.ErrorFactory)('auth', 'Firebase', errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    beforeAuthStateChanged(callback, onAbort) {
        return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    authStateReady() {
        return new Promise((resolve, reject)=>{
            if (this.currentUser) resolve();
            else {
                const unsubscribe = this.onAuthStateChanged(()=>{
                    unsubscribe();
                    resolve();
                }, reject);
            }
        });
    }
    /**
     * Revokes the given access token. Currently only supports Apple OAuth access tokens.
     */ async revokeAccessToken(token) {
        if (this.currentUser) {
            const idToken = await this.currentUser.getIdToken();
            // Generalize this to accept other providers once supported.
            const request = {
                providerId: 'apple.com',
                tokenType: "ACCESS_TOKEN" /* TokenType.ACCESS_TOKEN */ ,
                token,
                idToken
            };
            if (this.tenantId != null) request.tenantId = this.tenantId;
            await revokeToken(this, request);
        }
    }
    toJSON() {
        var _a;
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: (_a = this._currentUser) === null || _a === void 0 ? void 0 : _a.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = popupRedirectResolver && _getInstance(popupRedirectResolver) || this._popupRedirectResolver;
            _assert(resolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            this.redirectPersistenceManager = await PersistenceUserManager.create(this, [
                _getInstance(resolver._redirectPersistence)
            ], "redirectUser" /* KeyName.REDIRECT_USER */ );
            this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        var _a, _b;
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) await this.queue(async ()=>{});
        if (((_a = this._currentUser) === null || _a === void 0 ? void 0 : _a._redirectEventId) === id) return this._currentUser;
        if (((_b = this.redirectUser) === null || _b === void 0 ? void 0 : _b._redirectEventId) === id) return this.redirectUser;
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(user));
    }
    /** Notifies listeners only if the user is current */ _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) this.notifyAuthListeners();
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) this._currentUser._startProactiveRefresh();
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) this._currentUser._stopProactiveRefresh();
    }
    /** Returns the current user cast as the internal type */ get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        var _a, _b;
        if (!this._isInitialized) return;
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = (_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) return ()=>{};
        const cb = typeof nextOrObserver === 'function' ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
        let isUnsubscribed = false;
        const promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
        _assert(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(()=>{
            if (isUnsubscribed) return;
            cb(this.currentUser);
        });
        if (typeof nextOrObserver === 'function') {
            const unsubscribe = subscription.addObserver(nextOrObserver, error, completed);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        } else {
            const unsubscribe = subscription.addObserver(nextOrObserver);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        }
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) this._currentUser._stopProactiveRefresh();
        if (user && this.isProactiveRefreshEnabled) user._startProactiveRefresh();
        this.currentUser = user;
        if (user) await this.assertedPersistence.setCurrentUser(user);
        else await this.assertedPersistence.removeCurrentUser();
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        _assert(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) return;
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = _getClientVersion(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        var _a;
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ ]: this.clientVersion
        };
        if (this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = this.app.options.appId;
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await ((_a = this.heartbeatServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getHeartbeatsHeader());
        if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
        // If the App Check service exists, add the App Check token in the headers
        const appCheckToken = await this._getAppCheckToken();
        if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
        return headers;
    }
    async _getAppCheckToken() {
        var _a;
        if ((0, _app._isFirebaseServerApp)(this.app) && this.app.settings.appCheckToken) return this.app.settings.appCheckToken;
        const appCheckTokenResult = await ((_a = this.appCheckServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getToken());
        if (appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.error) // Context: appCheck.getToken() will never throw even if an error happened.
        // In the error case, a dummy token will be returned along with an error field describing
        // the error. In general, we shouldn't care about the error condition and just use
        // the token (actual or dummy) to send requests.
        _logWarn(`Error while retrieving App Check token: ${appCheckTokenResult.error}`);
        return appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.token;
    }
}
/**
 * Method to be used to cast down to our private implementation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function _castAuth(auth) {
    return (0, _util.getModularInstance)(auth);
}
/** Helper class to wrap subscriber logic */ class Subscription {
    constructor(auth){
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, _util.createSubscribe)((observer)=>this.observer = observer);
    }
    get next() {
        _assert(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.observer.next.bind(this.observer);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let externalJSProvider = {
    async loadJS () {
        throw new Error('Unable to load external scripts');
    },
    recaptchaV2Script: '',
    recaptchaEnterpriseScript: '',
    gapiScript: ''
};
function _setExternalJSProvider(p) {
    externalJSProvider = p;
}
function _loadJS(url) {
    return externalJSProvider.loadJS(url);
}
function _recaptchaV2ScriptUrl() {
    return externalJSProvider.recaptchaV2Script;
}
function _recaptchaEnterpriseScriptUrl() {
    return externalJSProvider.recaptchaEnterpriseScript;
}
function _gapiScriptUrl() {
    return externalJSProvider.gapiScript;
}
function _generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const _SOLVE_TIME_MS = 500;
const _EXPIRATION_TIME_MS = 60000;
const _WIDGET_ID_START = 1000000000000;
class MockReCaptcha {
    constructor(auth){
        this.auth = auth;
        this.counter = _WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        var _a;
        const id = optWidgetId || _WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.delete();
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        var _a;
        const id = optWidgetId || _WIDGET_ID_START;
        return ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.getResponse()) || '';
    }
    async execute(optWidgetId) {
        var _a;
        const id = optWidgetId || _WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.execute();
        return '';
    }
}
class MockGreCAPTCHATopLevel {
    constructor(){
        this.enterprise = new MockGreCAPTCHA();
    }
    ready(callback) {
        callback();
    }
    execute(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _siteKey, _options) {
        return Promise.resolve('token');
    }
    render(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _container, _parameters) {
        return '';
    }
}
class MockGreCAPTCHA {
    ready(callback) {
        callback();
    }
    execute(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _siteKey, _options) {
        return Promise.resolve('token');
    }
    render(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _container, _parameters) {
        return '';
    }
}
class MockWidget {
    constructor(containerOrId, appName, params){
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = ()=>{
            this.execute();
        };
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        _assert(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName
        });
        this.container = container;
        this.isVisible = this.params.size !== 'invisible';
        if (this.isVisible) this.execute();
        else this.container.addEventListener('click', this.clickHandler);
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener('click', this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) return;
        this.timerId = window.setTimeout(()=>{
            this.responseToken = generateRandomAlphaNumericString(50);
            const { callback, 'expired-callback': expiredCallback } = this.params;
            if (callback) try {
                callback(this.responseToken);
            } catch (e) {}
            this.timerId = window.setTimeout(()=>{
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) try {
                    expiredCallback();
                } catch (e) {}
                if (this.isVisible) this.execute();
            }, _EXPIRATION_TIME_MS);
        }, _SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) throw new Error('reCAPTCHA mock was already deleted!');
    }
}
function generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for(let i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join('');
}
/* eslint-disable @typescript-eslint/no-require-imports */ const RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = 'recaptcha-enterprise';
const FAKE_TOKEN = 'NO_RECAPTCHA';
class RecaptchaEnterpriseVerifier {
    /**
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     */ constructor(authExtern){
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = _castAuth(authExtern);
    }
    /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ async verify(action = 'verify', forceRefresh = false) {
        async function retrieveSiteKey(auth) {
            if (!forceRefresh) {
                if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return auth._agentRecaptchaConfig.siteKey;
                if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return auth._tenantRecaptchaConfigs[auth.tenantId].siteKey;
            }
            return new Promise(async (resolve, reject)=>{
                getRecaptchaConfig(auth, {
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }).then((response)=>{
                    if (response.recaptchaKey === undefined) reject(new Error('recaptcha Enterprise site key undefined'));
                    else {
                        const config = new RecaptchaConfig(response);
                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                        return resolve(config.siteKey);
                    }
                }).catch((error)=>{
                    reject(error);
                });
            });
        }
        function retrieveRecaptchaToken(siteKey, resolve, reject) {
            const grecaptcha = window.grecaptcha;
            if (isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(()=>{
                grecaptcha.enterprise.execute(siteKey, {
                    action
                }).then((token)=>{
                    resolve(token);
                }).catch(()=>{
                    resolve(FAKE_TOKEN);
                });
            });
            else reject(Error('No reCAPTCHA enterprise script loaded.'));
        }
        // Returns Promise for a mock token when appVerificationDisabledForTesting is true.
        if (this.auth.settings.appVerificationDisabledForTesting) {
            const mockRecaptcha = new MockGreCAPTCHATopLevel();
            return mockRecaptcha.execute('siteKey', {
                action: 'verify'
            });
        }
        return new Promise((resolve, reject)=>{
            retrieveSiteKey(this.auth).then((siteKey)=>{
                if (!forceRefresh && isEnterprise(window.grecaptcha)) retrieveRecaptchaToken(siteKey, resolve, reject);
                else {
                    if (typeof window === 'undefined') {
                        reject(new Error('RecaptchaVerifier is only supported in browser'));
                        return;
                    }
                    let url = _recaptchaEnterpriseScriptUrl();
                    if (url.length !== 0) url += siteKey;
                    _loadJS(url).then(()=>{
                        retrieveRecaptchaToken(siteKey, resolve, reject);
                    }).catch((error)=>{
                        reject(error);
                    });
                }
            }).catch((error)=>{
                reject(error);
            });
        });
    }
}
async function injectRecaptchaFields(auth, request, action, isCaptchaResp = false, isFakeToken = false) {
    const verifier = new RecaptchaEnterpriseVerifier(auth);
    let captchaResponse;
    if (isFakeToken) captchaResponse = FAKE_TOKEN;
    else try {
        captchaResponse = await verifier.verify(action);
    } catch (error) {
        captchaResponse = await verifier.verify(action, true);
    }
    const newRequest = Object.assign({}, request);
    if (action === "mfaSmsEnrollment" /* RecaptchaActionName.MFA_SMS_ENROLLMENT */  || action === "mfaSmsSignIn" /* RecaptchaActionName.MFA_SMS_SIGNIN */ ) {
        if ('phoneEnrollmentInfo' in newRequest) {
            const phoneNumber = newRequest.phoneEnrollmentInfo.phoneNumber;
            const recaptchaToken = newRequest.phoneEnrollmentInfo.recaptchaToken;
            Object.assign(newRequest, {
                'phoneEnrollmentInfo': {
                    phoneNumber,
                    recaptchaToken,
                    captchaResponse,
                    'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }
            });
        } else if ('phoneSignInInfo' in newRequest) {
            const recaptchaToken = newRequest.phoneSignInInfo.recaptchaToken;
            Object.assign(newRequest, {
                'phoneSignInInfo': {
                    recaptchaToken,
                    captchaResponse,
                    'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }
            });
        }
        return newRequest;
    }
    if (!isCaptchaResp) Object.assign(newRequest, {
        captchaResponse
    });
    else Object.assign(newRequest, {
        'captchaResp': captchaResponse
    });
    Object.assign(newRequest, {
        'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    });
    Object.assign(newRequest, {
        'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    return newRequest;
}
async function handleRecaptchaFlow(authInstance, request, actionName, actionMethod, recaptchaAuthProvider) {
    var _a, _b;
    if (recaptchaAuthProvider === "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ ) {
        if ((_a = authInstance._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ )) {
            const requestWithRecaptcha = await injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
            return actionMethod(authInstance, requestWithRecaptcha);
        } else return actionMethod(authInstance, request).catch(async (error)=>{
            if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
                console.log(`${actionName} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`);
                const requestWithRecaptcha = await injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
                return actionMethod(authInstance, requestWithRecaptcha);
            } else return Promise.reject(error);
        });
    } else if (recaptchaAuthProvider === "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ ) {
        if ((_b = authInstance._getRecaptchaConfig()) === null || _b === void 0 ? void 0 : _b.isProviderEnabled("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ )) {
            const requestWithRecaptcha = await injectRecaptchaFields(authInstance, request, actionName);
            return actionMethod(authInstance, requestWithRecaptcha).catch(async (error)=>{
                var _a;
                if (((_a = authInstance._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.getProviderEnforcementState("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ )) === "AUDIT" /* EnforcementState.AUDIT */ ) // AUDIT mode
                {
                    if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }` || error.code === `auth/${"invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ }`) {
                        console.log(`Failed to verify with reCAPTCHA Enterprise. Automatically triggering the reCAPTCHA v2 flow to complete the ${actionName} flow.`);
                        // reCAPTCHA Enterprise token is missing or reCAPTCHA Enterprise token
                        // check fails.
                        // Fallback to reCAPTCHA v2 flow.
                        const requestWithRecaptchaFields = await injectRecaptchaFields(authInstance, request, actionName, false, true // isFakeToken
                        );
                        // This will call the PhoneApiCaller to fetch and inject reCAPTCHA v2 token.
                        return actionMethod(authInstance, requestWithRecaptchaFields);
                    }
                }
                // ENFORCE mode or AUDIT mode with any other error.
                return Promise.reject(error);
            });
        } else {
            // Do reCAPTCHA v2 flow.
            const requestWithRecaptchaFields = await injectRecaptchaFields(authInstance, request, actionName, false, true // isFakeToken
            );
            // This will call the PhoneApiCaller to fetch and inject v2 token.
            return actionMethod(authInstance, requestWithRecaptchaFields);
        }
    } else return Promise.reject(recaptchaAuthProvider + ' provider is not supported.');
}
async function _initializeRecaptchaConfig(auth) {
    const authInternal = _castAuth(auth);
    const response = await getRecaptchaConfig(authInternal, {
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
        version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    const config = new RecaptchaConfig(response);
    if (authInternal.tenantId == null) authInternal._agentRecaptchaConfig = config;
    else authInternal._tenantRecaptchaConfigs[authInternal.tenantId] = config;
    if (config.isAnyProviderEnabled()) {
        const verifier = new RecaptchaEnterpriseVerifier(authInternal);
        verifier.verify();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function initializeAuth(app, deps) {
    const provider = (0, _app._getProvider)(app, 'auth');
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0, _util.deepEqual)(initialOptions, deps !== null && deps !== void 0 ? deps : {})) return auth;
        else _fail(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    const auth = provider.initialize({
        options: deps
    });
    return auth;
}
function _initializeAuthInstance(auth, deps) {
    const persistence = (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map(_getInstance);
    if (deps === null || deps === void 0 ? void 0 : deps.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function connectAuthEmulator(auth, url, options) {
    const authInternal = _castAuth(auth);
    _assert(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    const disableWarnings = !!(options === null || options === void 0 ? void 0 : options.disableWarnings);
    const protocol = extractProtocol(url);
    const { host, port } = extractHostAndPort(url);
    const portStr = port === null ? '' : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    const emulator = {
        url: `${protocol}//${host}${portStr}/`
    };
    const emulatorConfig = Object.freeze({
        host,
        port,
        protocol: protocol.replace(':', ''),
        options: Object.freeze({
            disableWarnings
        })
    });
    // There are a few scenarios to guard against if the Auth instance has already started:
    if (!authInternal._canInitEmulator) {
        // Applications may not initialize the emulator for the first time if Auth has already started
        // to make network requests.
        _assert(authInternal.config.emulator && authInternal.emulatorConfig, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
        // Applications may not alter the configuration of the emulator (aka pass a different config)
        // once Auth has started to make network requests.
        _assert((0, _util.deepEqual)(emulator, authInternal.config.emulator) && (0, _util.deepEqual)(emulatorConfig, authInternal.emulatorConfig), authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
        // It's valid, however, to invoke connectAuthEmulator() after Auth has started making
        // connections, so long as the config matches the existing config. This results in a no-op.
        return;
    }
    authInternal.config.emulator = emulator;
    authInternal.emulatorConfig = emulatorConfig;
    authInternal.settings.appVerificationDisabledForTesting = true;
    // Workaround to get cookies in Firebase Studio
    if ((0, _util.isCloudWorkstation)(host)) {
        (0, _util.pingServer)(`${protocol}//${host}${portStr}`);
        (0, _util.updateEmulatorBanner)('Auth', true);
    } else if (!disableWarnings) emitEmulatorWarning();
}
function extractProtocol(url) {
    const protocolEnd = url.indexOf(':');
    return protocolEnd < 0 ? '' : url.substr(0, protocolEnd + 1);
}
function extractHostAndPort(url) {
    const protocol = extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: '',
        port: null
    };
    const hostAndPort = authority[2].split('@').pop() || ''; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return {
            host,
            port: parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        const [host, port] = hostAndPort.split(':');
        return {
            host,
            port: parsePort(port)
        };
    }
}
function parsePort(portStr) {
    if (!portStr) return null;
    const port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement('p');
        const sty = el.style;
        el.innerText = 'Running in emulator mode. Do not use with production credentials.';
        sty.position = 'fixed';
        sty.width = '100%';
        sty.backgroundColor = '#ffffff';
        sty.border = '.1em solid #000000';
        sty.color = '#b50000';
        sty.bottom = '0px';
        sty.left = '0px';
        sty.margin = '0px';
        sty.zIndex = '10000';
        sty.textAlign = 'center';
        el.classList.add('firebase-emulator-warning');
        document.body.appendChild(el);
    }
    if (typeof console !== 'undefined' && typeof console.info === 'function') console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class AuthCredential {
    /** @internal */ constructor(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod){
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ toJSON() {
        return debugFail('not implemented');
    }
    /** @internal */ _getIdTokenResponse(_auth) {
        return debugFail('not implemented');
    }
    /** @internal */ _linkToIdToken(_auth, _idToken) {
        return debugFail('not implemented');
    }
    /** @internal */ _getReauthenticationResolver(_auth) {
        return debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function resetPassword(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , _addTidIfNecessary(auth, request));
}
async function updateEmailPassword(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
// Used for linking an email/password account to an existing idToken. Uses the same request/response
// format as updateEmailPassword.
async function linkEmailPassword(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , request);
}
async function applyActionCode$1(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , _addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function signInWithPassword(auth, request) {
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , _addTidIfNecessary(auth, request));
}
async function sendOobCode(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , _addTidIfNecessary(auth, request));
}
async function sendEmailVerification$1(auth, request) {
    return sendOobCode(auth, request);
}
async function sendPasswordResetEmail$1(auth, request) {
    return sendOobCode(auth, request);
}
async function sendSignInLinkToEmail$1(auth, request) {
    return sendOobCode(auth, request);
}
async function verifyAndChangeEmail(auth, request) {
    return sendOobCode(auth, request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function signInWithEmailLink$1(auth, request) {
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , _addTidIfNecessary(auth, request));
}
async function signInWithEmailLinkForLinking(auth, request) {
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , _addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ class EmailAuthCredential extends AuthCredential {
    /** @internal */ constructor(/** @internal */ _email, /** @internal */ _password, signInMethod, /** @internal */ _tenantId = null){
        super("password" /* ProviderId.PASSWORD */ , signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */ static _fromEmailAndPassword(email, password) {
        return new EmailAuthCredential(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
    }
    /** @internal */ static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new EmailAuthCredential(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        if ((obj === null || obj === void 0 ? void 0 : obj.email) && (obj === null || obj === void 0 ? void 0 : obj.password)) {
            if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
            else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
        return null;
    }
    /** @internal */ async _getIdTokenResponse(auth) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return handleRecaptchaFlow(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ , signInWithPassword, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                _fail(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ async _linkToIdToken(auth, idToken) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return handleRecaptchaFlow(auth, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , linkEmailPassword, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return signInWithEmailLinkForLinking(auth, {
                    idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                _fail(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function signInWithIdp(auth, request) {
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , _addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const IDP_REQUEST_URI$1 = 'http://localhost';
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class OAuthCredential extends AuthCredential {
    constructor(){
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */ static _fromParams(params) {
        const cred = new OAuthCredential(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) cred.idToken = params.idToken;
            if (params.accessToken) cred.accessToken = params.accessToken;
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
            if (params.pendingToken) cred.pendingToken = params.pendingToken;
        } else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        } else _fail("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId, signInMethod } = obj, rest = (0, _tslib.__rest)(obj, [
            "providerId",
            "signInMethod"
        ]);
        if (!providerId || !signInMethod) return null;
        const cred = new OAuthCredential(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) request.pendingToken = this.pendingToken;
        else {
            const postBody = {};
            if (this.idToken) postBody['id_token'] = this.idToken;
            if (this.accessToken) postBody['access_token'] = this.accessToken;
            if (this.secret) postBody['oauth_token_secret'] = this.secret;
            postBody['providerId'] = this.providerId;
            if (this.nonce && !this.pendingToken) postBody['nonce'] = this.nonce;
            request.postBody = (0, _util.querystring)(postBody);
        }
        return request;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function sendPhoneVerificationCode(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , _addTidIfNecessary(auth, request));
}
async function signInWithPhoneNumber$1(auth, request) {
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , _addTidIfNecessary(auth, request));
}
async function linkWithPhoneNumber$1(auth, request) {
    const response = await _performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , _addTidIfNecessary(auth, request));
    if (response.temporaryProof) throw _makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
    return response;
}
const VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ 
};
async function verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = Object.assign(Object.assign({}, request), {
        operation: 'REAUTH'
    });
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , _addTidIfNecessary(auth, apiRequest), VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ class PhoneAuthCredential extends AuthCredential {
    constructor(params){
        super("phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        this.params = params;
    }
    /** @internal */ static _fromVerification(verificationId, verificationCode) {
        return new PhoneAuthCredential({
            verificationId,
            verificationCode
        });
    }
    /** @internal */ static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new PhoneAuthCredential({
            phoneNumber,
            temporaryProof
        });
    }
    /** @internal */ _getIdTokenResponse(auth) {
        return signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        return linkWithPhoneNumber$1(auth, Object.assign({
            idToken
        }, this._makeVerificationRequest()));
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */ _makeVerificationRequest() {
        const { temporaryProof, phoneNumber, verificationId, verificationCode } = this.params;
        if (temporaryProof && phoneNumber) return {
            temporaryProof,
            phoneNumber
        };
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
        if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
        if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
        if (this.params.verificationId) obj.verificationId = this.params.verificationId;
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */ static fromJSON(json) {
        if (typeof json === 'string') json = JSON.parse(json);
        const { verificationId, verificationCode, phoneNumber, temporaryProof } = json;
        if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
        return new PhoneAuthCredential({
            verificationId,
            verificationCode,
            phoneNumber,
            temporaryProof
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function parseMode(mode) {
    switch(mode){
        case 'recoverEmail':
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case 'resetPassword':
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case 'signIn':
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case 'verifyEmail':
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case 'verifyAndChangeEmail':
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case 'revertSecondFactorAddition':
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function parseDeepLink(url) {
    const link = (0, _util.querystringDecode)((0, _util.extractQuerystring)(url))['link'];
    // Double link case (automatic redirect).
    const doubleDeepLink = link ? (0, _util.querystringDecode)((0, _util.extractQuerystring)(link))['deep_link_id'] : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0, _util.querystringDecode)((0, _util.extractQuerystring)(url))['deep_link_id'];
    const iOSDoubleDeepLink = iOSDeepLink ? (0, _util.querystringDecode)((0, _util.extractQuerystring)(iOSDeepLink))['link'] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ class ActionCodeURL {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */ constructor(actionLink){
        var _a, _b, _c, _d, _e, _f;
        const searchParams = (0, _util.querystringDecode)((0, _util.extractQuerystring)(actionLink));
        const apiKey = (_a = searchParams["apiKey" /* QueryField.API_KEY */ ]) !== null && _a !== void 0 ? _a : null;
        const code = (_b = searchParams["oobCode" /* QueryField.CODE */ ]) !== null && _b !== void 0 ? _b : null;
        const operation = parseMode((_c = searchParams["mode" /* QueryField.MODE */ ]) !== null && _c !== void 0 ? _c : null);
        // Validate API key, code and mode.
        _assert(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = (_d = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ]) !== null && _d !== void 0 ? _d : null;
        this.languageCode = (_e = searchParams["lang" /* QueryField.LANGUAGE_CODE */ ]) !== null && _e !== void 0 ? _e : null;
        this.tenantId = (_f = searchParams["tenantId" /* QueryField.TENANT_ID */ ]) !== null && _f !== void 0 ? _f : null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ static parseLink(link) {
        const actionLink = parseDeepLink(link);
        try {
            return new ActionCodeURL(actionLink);
        } catch (_a) {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function parseActionCodeURL(link) {
    return ActionCodeURL.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ class EmailAuthProvider {
    constructor(){
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = EmailAuthProvider.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ static credential(email, password) {
        return EmailAuthCredential._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ static credentialWithLink(email, emailLink) {
        const actionCodeUrl = ActionCodeURL.parseLink(emailLink);
        _assert(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return EmailAuthCredential._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ EmailAuthProvider.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ class FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */ constructor(providerId){
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */ getCustomParameters() {
        return this.customParameters;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ class BaseOAuthProvider extends FederatedAuthProvider {
    constructor(){
        super(...arguments);
        /** @internal */ this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) this.scopes.push(scope);
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */ getScopes() {
        return [
            ...this.scopes
        ];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class OAuthProvider extends BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        _assert('providerId' in obj && 'signInMethod' in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return OAuthCredential._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ credential(params) {
        return this._credential(Object.assign(Object.assign({}, params), {
            nonce: params.rawNonce
        }));
    }
    /** An internal credential method that accepts more permissive options */ _credential(params) {
        _assert(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        // For OAuthCredential, sign in method is same as providerId.
        return OAuthCredential._fromParams(Object.assign(Object.assign({}, params), {
            providerId: this.providerId,
            signInMethod: this.providerId
        }));
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return OAuthProvider.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return OAuthProvider.oauthCredentialFromTaggedObject(error.customData || {});
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken, oauthAccessToken, oauthTokenSecret, pendingToken, nonce, providerId } = tokenResponse;
        if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
        if (!providerId) return null;
        try {
            return new OAuthProvider(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce,
                pendingToken
            });
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class FacebookAuthProvider extends BaseOAuthProvider {
    constructor(){
        super("facebook.com" /* ProviderId.FACEBOOK */ );
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ static credential(accessToken) {
        return OAuthCredential._fromParams({
            providerId: FacebookAuthProvider.PROVIDER_ID,
            signInMethod: FacebookAuthProvider.FACEBOOK_SIGN_IN_METHOD,
            accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return FacebookAuthProvider.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return FacebookAuthProvider.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return FacebookAuthProvider.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */ FacebookAuthProvider.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ FacebookAuthProvider.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class GoogleAuthProvider extends BaseOAuthProvider {
    constructor(){
        super("google.com" /* ProviderId.GOOGLE */ );
        this.addScope('profile');
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ static credential(idToken, accessToken) {
        return OAuthCredential._fromParams({
            providerId: GoogleAuthProvider.PROVIDER_ID,
            signInMethod: GoogleAuthProvider.GOOGLE_SIGN_IN_METHOD,
            idToken,
            accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return GoogleAuthProvider.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return GoogleAuthProvider.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken, oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
        return null;
        try {
            return GoogleAuthProvider.credential(oauthIdToken, oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */ GoogleAuthProvider.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ GoogleAuthProvider.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a GitHub Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a GitHub Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class GithubAuthProvider extends BaseOAuthProvider {
    constructor(){
        super("github.com" /* ProviderId.GITHUB */ );
    }
    /**
     * Creates a credential for GitHub.
     *
     * @param accessToken - GitHub access token.
     */ static credential(accessToken) {
        return OAuthCredential._fromParams({
            providerId: GithubAuthProvider.PROVIDER_ID,
            signInMethod: GithubAuthProvider.GITHUB_SIGN_IN_METHOD,
            accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return GithubAuthProvider.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return GithubAuthProvider.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return GithubAuthProvider.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */ GithubAuthProvider.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ GithubAuthProvider.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const IDP_REQUEST_URI = 'http://localhost';
/**
 * @public
 */ class SAMLAuthCredential extends AuthCredential {
    /** @internal */ constructor(providerId, pendingToken){
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId, signInMethod, pendingToken } = obj;
        if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
        return new SAMLAuthCredential(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ static _create(providerId, pendingToken) {
        return new SAMLAuthCredential(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const SAML_PROVIDER_PREFIX = 'saml.';
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ class SAMLAuthProvider extends FederatedAuthProvider {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */ constructor(providerId){
        _assert(providerId.startsWith(SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return SAMLAuthProvider.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return SAMLAuthProvider.samlCredentialFromTaggedObject(error.customData || {});
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const credential = SAMLAuthCredential.fromJSON(json);
        _assert(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { pendingToken, providerId } = tokenResponse;
        if (!pendingToken || !providerId) return null;
        try {
            return SAMLAuthCredential._create(providerId, pendingToken);
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ class TwitterAuthProvider extends BaseOAuthProvider {
    constructor(){
        super("twitter.com" /* ProviderId.TWITTER */ );
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ static credential(token, secret) {
        return OAuthCredential._fromParams({
            providerId: TwitterAuthProvider.PROVIDER_ID,
            signInMethod: TwitterAuthProvider.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return TwitterAuthProvider.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return TwitterAuthProvider.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthAccessToken, oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) return null;
        try {
            return TwitterAuthProvider.credential(oauthAccessToken, oauthTokenSecret);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */ TwitterAuthProvider.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ TwitterAuthProvider.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function signUp(auth, request) {
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , _addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class UserCredentialImpl {
    constructor(params){
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await UserImpl._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = providerIdForResponse(idTokenResponse);
        const userCred = new UserCredentialImpl({
            user,
            providerId,
            _tokenResponse: idTokenResponse,
            operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = providerIdForResponse(response);
        return new UserCredentialImpl({
            user,
            providerId,
            _tokenResponse: response,
            operationType
        });
    }
}
function providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ('phoneNumber' in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ async function signInAnonymously(auth) {
    var _a;
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = _castAuth(auth);
    await authInternal._initializationPromise;
    if ((_a = authInternal.currentUser) === null || _a === void 0 ? void 0 : _a.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
    return new UserCredentialImpl({
        user: authInternal.currentUser,
        providerId: null,
        operationType: "signIn" /* OperationType.SIGN_IN */ 
    });
    const response = await signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class MultiFactorError extends (0, _util.FirebaseError) {
    constructor(auth, error, operationType, user){
        var _a;
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: (_a = auth.tenantId) !== null && _a !== void 0 ? _a : undefined,
            _serverResponse: error.customData._serverResponse,
            operationType
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new MultiFactorError(auth, error, operationType, user);
    }
}
function _processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch((error)=>{
        if (error.code === `auth/${"multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ }`) throw MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function providerDataAsNames(providerData) {
    return new Set(providerData.map(({ providerId })=>providerId).filter((pid)=>!!pid));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ async function unlink(user, providerId) {
    const userInternal = (0, _util.getModularInstance)(user);
    await _assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo } = await deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [
            providerId
        ]
    });
    const providersLeft = providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter((pd)=>providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function _link$1(user, credential, bypassAuthState = false) {
    const response = await _logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response);
}
async function _assertLinkedStatus(expected, user, provider) {
    await _reloadWithoutSaving(user);
    const providerIds = providerDataAsNames(user.providerData);
    const code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
    _assert(providerIds.has(provider) === expected, user.auth, code);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function _reauthenticate(user, credential, bypassAuthState = false) {
    const { auth } = user;
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
    try {
        const response = await _logoutIfInvalidated(user, _processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        _assert(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const parsed = _parseToken(response.idToken);
        _assert(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const { sub: localId } = parsed;
        _assert(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        return UserCredentialImpl._forOperation(user, operationType, response);
    } catch (e) {
        // Convert user deleted error into user mismatch
        if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"user-not-found" /* AuthErrorCode.USER_DELETED */ }`) _fail(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        throw e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function _signInWithCredential(auth, credential, bypassAuthState = false) {
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "signIn" /* OperationType.SIGN_IN */ ;
    const response = await _processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) await auth._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ async function signInWithCredential(auth, credential) {
    return _signInWithCredential(_castAuth(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function linkWithCredential(user, credential) {
    const userInternal = (0, _util.getModularInstance)(user);
    await _assertLinkedStatus(false, userInternal, credential.providerId);
    return _link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function reauthenticateWithCredential(user, credential) {
    return _reauthenticate((0, _util.getModularInstance)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function signInWithCustomToken$1(auth, request) {
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , _addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ async function signInWithCustomToken(auth, customToken) {
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = _castAuth(auth);
    const response = await signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class MultiFactorInfoImpl {
    constructor(factorId, response){
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ('phoneInfo' in enrollment) return PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        else if ('totpInfo' in enrollment) return TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        return _fail(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
}
class PhoneMultiFactorInfoImpl extends MultiFactorInfoImpl {
    constructor(response){
        super("phone" /* FactorId.PHONE */ , response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new PhoneMultiFactorInfoImpl(enrollment);
    }
}
class TotpMultiFactorInfoImpl extends MultiFactorInfoImpl {
    constructor(response){
        super("totp" /* FactorId.TOTP */ , response);
    }
    static _fromServerResponse(_auth, enrollment) {
        return new TotpMultiFactorInfoImpl(enrollment);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function _setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    var _a;
    _assert(((_a = actionCodeSettings.url) === null || _a === void 0 ? void 0 : _a.length) > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    _assert(typeof actionCodeSettings.dynamicLinkDomain === 'undefined' || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    _assert(typeof actionCodeSettings.linkDomain === 'undefined' || actionCodeSettings.linkDomain.length > 0, auth, "invalid-hosting-link-domain" /* AuthErrorCode.INVALID_HOSTING_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.linkDomain = actionCodeSettings.linkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        _assert(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        _assert(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates the password policy cached in the {@link Auth} instance if a policy is already
 * cached for the project or tenant.
 *
 * @remarks
 * We only fetch the password policy if the password did not meet policy requirements and
 * there is an existing policy cached. A developer must call validatePassword at least
 * once for the cache to be automatically updated.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @private
 */ async function recachePasswordPolicy(auth) {
    const authInternal = _castAuth(auth);
    if (authInternal._getPasswordPolicyInternal()) await authInternal._updatePasswordPolicy();
}
/**
 * Sends a password reset email to the given email address. This method does not throw an error when
 * there's no user account with the given email address and
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function sendPasswordResetEmail(auth, email, actionCodeSettings) {
    const authInternal = _castAuth(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
        email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    if (actionCodeSettings) _setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    await handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , sendPasswordResetEmail$1, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ async function confirmPasswordReset(auth, oobCode, newPassword) {
    await resetPassword((0, _util.getModularInstance)(auth), {
        oobCode,
        newPassword
    }).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) recachePasswordPolicy(auth);
        throw error;
    });
// Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function applyActionCode(auth, oobCode) {
    await applyActionCode$1((0, _util.getModularInstance)(auth), {
        oobCode
    });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function checkActionCode(auth, oobCode) {
    const authModular = (0, _util.getModularInstance)(auth);
    const response = await resetPassword(authModular, {
        oobCode
    });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    _assert(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    switch(operation){
        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
            _assert(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
            _assert(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // fall through
        default:
            _assert(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) multiFactorInfo = MultiFactorInfoImpl._fromServerResponse(_castAuth(authModular), response.mfaInfo);
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
            multiFactorInfo
        },
        operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ async function verifyPasswordResetCode(auth, code) {
    const { data } = await checkActionCode((0, _util.getModularInstance)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ async function createUserWithEmailAndPassword(auth, email, password) {
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = _castAuth(auth);
    const request = {
        returnSecureToken: true,
        email,
        password,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    const signUpResponse = handleRecaptchaFlow(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , signUp, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
    const response = await signUpResponse.catch((error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) recachePasswordPolicy(auth);
        throw error;
    });
    const userCredential = await UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match. When
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, this method fails with "auth/invalid-credential" in case of an invalid
 * email/password.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function signInWithEmailAndPassword(auth, email, password) {
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
    return signInWithCredential((0, _util.getModularInstance)(auth), EmailAuthProvider.credential(email, password)).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) recachePasswordPolicy(auth);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function sendSignInLinkToEmail(auth, email, actionCodeSettings) {
    const authInternal = _castAuth(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
        email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    function setActionCodeSettings(request, actionCodeSettings) {
        _assert(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (actionCodeSettings) _setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    }
    setActionCodeSettings(request, actionCodeSettings);
    await handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , sendSignInLinkToEmail$1, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function isSignInWithEmailLink(auth, emailLink) {
    const actionCodeUrl = ActionCodeURL.parseLink(emailLink);
    return (actionCodeUrl === null || actionCodeUrl === void 0 ? void 0 : actionCodeUrl.operation) === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ async function signInWithEmailLink(auth, email, emailLink) {
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
    const authModular = (0, _util.getModularInstance)(auth);
    const credential = EmailAuthProvider.credentialWithLink(email, emailLink || _getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    _assert(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
    return signInWithCredential(authModular, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function createAuthUri(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , _addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address. This method returns an
 * empty list when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, irrespective of the number of authentication methods available for the given email.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * Deprecated. Migrating off of this method is recommended as a security best-practice.
 * Learn more in the Identity Platform documentation for
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}.
 * @public
 */ async function fetchSignInMethodsForEmail(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = _isHttpOrHttps() ? _getCurrentUrl() : 'http://localhost';
    const request = {
        identifier: email,
        continueUri
    };
    const { signinMethods } = await createAuthUri((0, _util.getModularInstance)(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function sendEmailVerification(user, actionCodeSettings) {
    const userInternal = (0, _util.getModularInstance)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
        idToken
    };
    if (actionCodeSettings) _setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email } = await sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) await user.reload();
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function verifyBeforeUpdateEmail(user, newEmail, actionCodeSettings) {
    const userInternal = (0, _util.getModularInstance)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
        idToken,
        newEmail
    };
    if (actionCodeSettings) _setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email } = await verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) // If the local copy of the email on user is outdated, reload the
    // user.
    await user.reload();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function updateProfile$1(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ async function updateProfile(user, { displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) return;
    const userInternal = (0, _util.getModularInstance)(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken,
        displayName,
        photoUrl,
        returnSecureToken: true
    };
    const response = await _logoutIfInvalidated(userInternal, updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId })=>providerId === "password" /* ProviderId.PASSWORD */ );
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * Throws "auth/operation-not-allowed" error when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 * Deprecated - Use {@link verifyBeforeUpdateEmail} instead.
 *
 * @public
 */ function updateEmail(user, newEmail) {
    const userInternal = (0, _util.getModularInstance)(user);
    if ((0, _app._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    return updateEmailOrPassword(userInternal, newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function updatePassword(user, newPassword) {
    return updateEmailOrPassword((0, _util.getModularInstance)(user), null, newPassword);
}
async function updateEmailOrPassword(user, email, password) {
    const { auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken,
        returnSecureToken: true
    };
    if (email) request.email = email;
    if (password) request.password = password;
    const response = await _logoutIfInvalidated(user, updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function _fromIdTokenResponse(idTokenResponse) {
    var _a, _b;
    if (!idTokenResponse) return null;
    const { providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    const isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && (idTokenResponse === null || idTokenResponse === void 0 ? void 0 : idTokenResponse.idToken)) {
        const signInProvider = (_b = (_a = _parseToken(idTokenResponse.idToken)) === null || _a === void 0 ? void 0 : _a.firebase) === null || _b === void 0 ? void 0 : _b['sign_in_provider'];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}){
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class FederatedAdditionalUserInfoWithUsername extends GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile, username){
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class FacebookAdditionalUserInfo extends GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
}
class GithubAdditionalUserInfo extends FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile){
        super(isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof (profile === null || profile === void 0 ? void 0 : profile.login) === 'string' ? profile === null || profile === void 0 ? void 0 : profile.login : null);
    }
}
class GoogleAdditionalUserInfo extends GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
}
class TwitterAdditionalUserInfo extends FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile, screenName){
        super(isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function getAdditionalUserInfo(userCredential) {
    const { user, _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return _fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function setPersistence(auth, persistence) {
    return (0, _util.getModularInstance)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function initializeRecaptchaConfig(auth) {
    return _initializeRecaptchaConfig(auth);
}
/**
 * Validates the password against the password policy configured for the project or tenant.
 *
 * @remarks
 * If no tenant ID is set on the `Auth` instance, then this method will use the password
 * policy configured for the project. Otherwise, this method will use the policy configured
 * for the tenant. If a password policy has not been configured, then the default policy
 * configured for all projects will be used.
 *
 * If an auth flow fails because a submitted password does not meet the password policy
 * requirements and this method has previously been called, then this method will use the
 * most recent policy available when called again.
 *
 * @example
 * ```javascript
 * validatePassword(auth, 'some-password');
 * ```
 *
 * @param auth The {@link Auth} instance.
 * @param password The password to validate.
 *
 * @public
 */ async function validatePassword(auth, password) {
    const authInternal = _castAuth(auth);
    return authInternal.validatePassword(password);
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function onIdTokenChanged(auth, nextOrObserver, error, completed) {
    return (0, _util.getModularInstance)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function beforeAuthStateChanged(auth, callback, onAbort) {
    return (0, _util.getModularInstance)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function onAuthStateChanged(auth, nextOrObserver, error, completed) {
    return (0, _util.getModularInstance)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function useDeviceLanguage(auth) {
    (0, _util.getModularInstance)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function updateCurrentUser(auth, user) {
    return (0, _util.getModularInstance)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @remarks
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function signOut(auth) {
    return (0, _util.getModularInstance)(auth).signOut();
}
/**
 * Revokes the given access token. Currently only supports Apple OAuth access tokens.
 *
 * @param auth - The {@link Auth} instance.
 * @param token - The Apple OAuth access token.
 *
 * @public
 */ function revokeAccessToken(auth, token) {
    const authInternal = _castAuth(auth);
    return authInternal.revokeAccessToken(token);
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ async function deleteUser(user) {
    return (0, _util.getModularInstance)(user).delete();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class MultiFactorSessionImpl {
    constructor(type, credential, user){
        this.type = type;
        this.credential = credential;
        this.user = user;
    }
    static _fromIdtoken(idToken, user) {
        return new MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, user);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? 'idToken' : 'pendingCredential';
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        var _a, _b;
        if (obj === null || obj === void 0 ? void 0 : obj.multiFactorSession) {
            if ((_a = obj.multiFactorSession) === null || _a === void 0 ? void 0 : _a.pendingCredential) return MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            else if ((_b = obj.multiFactorSession) === null || _b === void 0 ? void 0 : _b.idToken) return MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class MultiFactorResolverImpl {
    constructor(session, hints, signInResolver){
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */ static _fromError(authExtern, error) {
        const auth = _castAuth(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map((enrollment)=>MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        _assert(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const session = MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new MultiFactorResolverImpl(session, hints, async (assertion)=>{
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = Object.assign(Object.assign({}, serverResponse), {
                idToken: mfaResponse.idToken,
                refreshToken: mfaResponse.refreshToken
            });
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch(error.operationType){
                case "signIn" /* OperationType.SIGN_IN */ :
                    const userCredential = await UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                    _assert(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    _fail(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function getMultiFactorResolver(auth, error) {
    var _a;
    const authModular = (0, _util.getModularInstance)(auth);
    const errorInternal = error;
    _assert(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    _assert((_a = errorInternal.customData._serverResponse) === null || _a === void 0 ? void 0 : _a.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function startEnrollPhoneMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , _addTidIfNecessary(auth, request));
}
function finalizeEnrollPhoneMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , _addTidIfNecessary(auth, request));
}
function startEnrollTotpMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , _addTidIfNecessary(auth, request));
}
function finalizeEnrollTotpMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , _addTidIfNecessary(auth, request));
}
function withdrawMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , _addTidIfNecessary(auth, request));
}
class MultiFactorUserImpl {
    constructor(user){
        this.user = user;
        this.enrolledFactors = [];
        user._onReload((userInfo)=>{
            if (userInfo.mfaInfo) this.enrolledFactors = userInfo.mfaInfo.map((enrollment)=>MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
        });
    }
    static _fromUser(user) {
        return new MultiFactorUserImpl(user);
    }
    async getSession() {
        return MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken(), this.user);
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = await this.getSession();
        const finalizeMfaResponse = await _logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === 'string' ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        try {
            const idTokenResponse = await _logoutIfInvalidated(this.user, withdrawMfa(this.user.auth, {
                idToken,
                mfaEnrollmentId
            }));
            // Remove the second factor from the user's list.
            this.enrolledFactors = this.enrolledFactors.filter(({ uid })=>uid !== mfaEnrollmentId);
            // Depending on whether the backend decided to revoke the user's session,
            // the tokenResponse may be empty. If the tokens were not updated (and they
            // are now invalid), reloading the user will discover this and invalidate
            // the user's state accordingly.
            await this.user._updateTokensIfNecessary(idTokenResponse);
            await this.user.reload();
        } catch (e) {
            throw e;
        }
    }
}
const multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function multiFactor(user) {
    const userModular = (0, _util.getModularInstance)(user);
    if (!multiFactorUserCache.has(userModular)) multiFactorUserCache.set(userModular, MultiFactorUserImpl._fromUser(userModular));
    return multiFactorUserCache.get(userModular);
}
const STORAGE_AVAILABLE_KEY = '__sak';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class BrowserPersistenceClass {
    constructor(storageRetriever, type){
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) return Promise.resolve(false);
            this.storage.setItem(STORAGE_AVAILABLE_KEY, '1');
            this.storage.removeItem(STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        } catch (_a) {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The polling period in case events are not supported
const _POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class BrowserLocalPersistence extends BrowserPersistenceClass {
    constructor(){
        super(()=>window.localStorage, "LOCAL" /* PersistenceType.LOCAL */ );
        this.boundEventHandler = (event, poll)=>this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = _isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)){
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) cb(key, oldValue, newValue);
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue)=>{
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
        else // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
        const triggerListeners = ()=>{
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
            // This seems to trigger in some IE browsers for some reason.
            return;
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if (_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, IE10_LOCAL_STORAGE_SYNC_DELAY);
        else triggerListeners();
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(value ? JSON.parse(value) : value);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(()=>{
            this.forAllChangedKeys((key, oldValue, newValue)=>{
                this.onStorageEvent(new StorageEvent('storage', {
                    key,
                    oldValue,
                    newValue
                }), /* poll */ true);
            });
        }, _POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener('storage', this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener('storage', this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) this.startPolling();
            else this.attachListener();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
BrowserLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ const browserLocalPersistence = BrowserLocalPersistence;
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const POLLING_INTERVAL_MS = 1000;
// Pull a cookie value from document.cookie
function getDocumentCookie(name) {
    var _a, _b;
    const escapedName = name.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&');
    const matcher = RegExp(`${escapedName}=([^;]+)`);
    return (_b = (_a = document.cookie.match(matcher)) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : null;
}
// Produce a sanitized cookie name from the persistence key
function getCookieName(key) {
    // __HOST- doesn't work in localhost https://issues.chromium.org/issues/40196122 but it has
    // desirable security properties, so lets use a different cookie name while in dev-mode.
    // Already checked isSecureContext in _isAvailable, so if it's http we're hitting local.
    const isDevMode = window.location.protocol === 'http:';
    return `${isDevMode ? '__dev_' : '__HOST-'}FIREBASE_${key.split(':')[3]}`;
}
class CookiePersistence {
    constructor(){
        this.type = "COOKIE" /* PersistenceType.COOKIE */ ;
        this.listenerUnsubscribes = new Map();
    }
    // used to get the URL to the backend to proxy to
    _getFinalTarget(originalUrl) {
        const url = new URL(`${window.location.origin}/__cookies__`);
        url.searchParams.set('finalTarget', originalUrl);
        return url;
    }
    // To be a usable persistence method in a chain browserCookiePersistence ensures that
    // prerequisites have been met, namely that we're in a secureContext, navigator and document are
    // available and cookies are enabled. Not all UAs support these method, so fallback accordingly.
    async _isAvailable() {
        var _a;
        if (typeof isSecureContext === 'boolean' && !isSecureContext) return false;
        if (typeof navigator === 'undefined' || typeof document === 'undefined') return false;
        return (_a = navigator.cookieEnabled) !== null && _a !== void 0 ? _a : true;
    }
    // Set should be a noop as we expect middleware to handle this
    async _set(_key, _value) {
        return;
    }
    // Attempt to get the cookie from cookieStore, fallback to document.cookie
    async _get(key) {
        if (!this._isAvailable()) return null;
        const name = getCookieName(key);
        if (window.cookieStore) {
            const cookie = await window.cookieStore.get(name);
            return cookie === null || cookie === void 0 ? void 0 : cookie.value;
        }
        return getDocumentCookie(name);
    }
    // Log out by overriding the idToken with a sentinel value of ""
    async _remove(key) {
        if (!this._isAvailable()) return;
        // To make sure we don't hit signout over and over again, only do this operation if we need to
        // with the logout sentinel value of "" this can cause race conditions. Unnecessary set-cookie
        // headers will reduce CDN hit rates too.
        const existingValue = await this._get(key);
        if (!existingValue) return;
        const name = getCookieName(key);
        document.cookie = `${name}=;Max-Age=34560000;Partitioned;Secure;SameSite=Strict;Path=/;Priority=High`;
        await fetch(`/__cookies__`, {
            method: 'DELETE'
        }).catch(()=>undefined);
    }
    // Listen for cookie changes, both cookieStore and fallback to polling document.cookie
    _addListener(key, listener) {
        if (!this._isAvailable()) return;
        const name = getCookieName(key);
        if (window.cookieStore) {
            const cb = (event)=>{
                const changedCookie = event.changed.find((change)=>change.name === name);
                if (changedCookie) listener(changedCookie.value);
                const deletedCookie = event.deleted.find((change)=>change.name === name);
                if (deletedCookie) listener(null);
            };
            const unsubscribe = ()=>window.cookieStore.removeEventListener('change', cb);
            this.listenerUnsubscribes.set(listener, unsubscribe);
            return window.cookieStore.addEventListener('change', cb);
        }
        let lastValue = getDocumentCookie(name);
        const interval = setInterval(()=>{
            const currentValue = getDocumentCookie(name);
            if (currentValue !== lastValue) {
                listener(currentValue);
                lastValue = currentValue;
            }
        }, POLLING_INTERVAL_MS);
        const unsubscribe = ()=>clearInterval(interval);
        this.listenerUnsubscribes.set(listener, unsubscribe);
    }
    _removeListener(_key, listener) {
        const unsubscribe = this.listenerUnsubscribes.get(listener);
        if (!unsubscribe) return;
        unsubscribe();
        this.listenerUnsubscribes.delete(listener);
    }
}
CookiePersistence.type = 'COOKIE';
/**
 * An implementation of {@link Persistence} of type `COOKIE`, for use on the client side in
 * applications leveraging hybrid rendering and middleware.
 *
 * @remarks This persistence method requires companion middleware to function, such as that provided
 * by {@link https://firebaseopensource.com/projects/firebaseextended/reactfire/ | ReactFire} for
 * NextJS.
 * @beta
 */ const browserCookiePersistence = CookiePersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class BrowserSessionPersistence extends BrowserPersistenceClass {
    constructor(){
        super(()=>window.sessionStorage, "SESSION" /* PersistenceType.SESSION */ );
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
BrowserSessionPersistence.type = 'SESSION';
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ const browserSessionPersistence = BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function _allSettled(promises) {
    return Promise.all(promises.map(async (promise)=>{
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value
            };
        } catch (reason) {
            return {
                fulfilled: false,
                reason
            };
        }
    }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ class Receiver {
    constructor(eventTarget){
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find((receiver)=>receiver.isListeningto(eventTarget));
        if (existingInstance) return existingInstance;
        const newInstance = new Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ async handleEvent(event) {
        const messageEvent = event;
        const { eventId, eventType, data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!(handlers === null || handlers === void 0 ? void 0 : handlers.size)) return;
        messageEvent.ports[0].postMessage({
            status: "ack" /* _Status.ACK */ ,
            eventId,
            eventType
        });
        const promises = Array.from(handlers).map(async (handler)=>handler(messageEvent.origin, data));
        const response = await _allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* _Status.DONE */ ,
            eventId,
            eventType,
            response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener('message', this.boundEventHandler);
        if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optional event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
        if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener('message', this.boundEventHandler);
    }
}
Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function _generateEventId(prefix = '', digits = 10) {
    let random = '';
    for(let i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ class Sender {
    constructor(target){
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener('message', handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ async _send(eventType, data, timeout = 50 /* _TimeoutDuration.ACK */ ) {
        const messageChannel = typeof MessageChannel !== 'undefined' ? new MessageChannel() : null;
        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject)=>{
            const eventId = _generateEventId('', 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(()=>{
                reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
            }, timeout);
            handler = {
                messageChannel,
                onMessage (event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) return;
                    switch(messageEvent.data.status){
                        case "ack" /* _Status.ACK */ :
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(()=>{
                                reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                            }, 3000 /* _TimeoutDuration.COMPLETION */ );
                            break;
                        case "done" /* _Status.DONE */ :
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener('message', handler.onMessage);
            this.target.postMessage({
                eventType,
                eventId,
                data
            }, [
                messageChannel.port2
            ]);
        }).finally(()=>{
            if (handler) this.removeMessageHandler(handler);
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function _window() {
    return window;
}
function _setWindowLocation(url) {
    _window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function _isWorker() {
    return typeof _window()['WorkerGlobalScope'] !== 'undefined' && typeof _window()['importScripts'] === 'function';
}
async function _getActiveServiceWorker() {
    if (!(navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker)) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    } catch (_a) {
        return null;
    }
}
function _getServiceWorkerController() {
    var _a;
    return ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) || null;
}
function _getWorkerGlobalScope() {
    return _isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const DB_NAME = 'firebaseLocalStorageDb';
const DB_VERSION = 1;
const DB_OBJECTSTORE_NAME = 'firebaseLocalStorage';
const DB_DATA_KEYPATH = 'fbase_key';
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ class DBPromise {
    constructor(request){
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject)=>{
            this.request.addEventListener('success', ()=>{
                resolve(this.request.result);
            });
            this.request.addEventListener('error', ()=>{
                reject(this.request.error);
            });
        });
    }
}
function getObjectStore(db, isReadWrite) {
    return db.transaction([
        DB_OBJECTSTORE_NAME
    ], isReadWrite ? 'readwrite' : 'readonly').objectStore(DB_OBJECTSTORE_NAME);
}
function _deleteDatabase() {
    const request = indexedDB.deleteDatabase(DB_NAME);
    return new DBPromise(request).toPromise();
}
function _openDatabase() {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    return new Promise((resolve, reject)=>{
        request.addEventListener('error', ()=>{
            reject(request.error);
        });
        request.addEventListener('upgradeneeded', ()=>{
            const db = request.result;
            try {
                db.createObjectStore(DB_OBJECTSTORE_NAME, {
                    keyPath: DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener('success', async ()=>{
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains(DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await _deleteDatabase();
                resolve(await _openDatabase());
            } else resolve(db);
        });
    });
}
async function _putObject(db, key, value) {
    const request = getObjectStore(db, true).put({
        [DB_DATA_KEYPATH]: key,
        value
    });
    return new DBPromise(request).toPromise();
}
async function getObject(db, key) {
    const request = getObjectStore(db, false).get(key);
    const data = await new DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function _deleteObject(db, key) {
    const request = getObjectStore(db, true).delete(key);
    return new DBPromise(request).toPromise();
}
const _POLLING_INTERVAL_MS = 800;
const _TRANSACTION_RETRY_COUNT = 3;
class IndexedDBLocalPersistence {
    constructor(){
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
    }
    async _openDb() {
        if (this.db) return this.db;
        this.db = await _openDatabase();
        return this.db;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while(true)try {
            const db = await this._openDb();
            return await op(db);
        } catch (e) {
            if (numAttempts++ > _TRANSACTION_RETRY_COUNT) throw e;
            if (this.db) {
                this.db.close();
                this.db = undefined;
            }
        // TODO: consider adding exponential backoff
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ async initializeServiceWorkerMessaging() {
        return _isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */ async initializeReceiver() {
        this.receiver = Receiver._getInstance(_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , async (_origin, data)=>{
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* _EventType.PING */ , async (_origin, _data)=>{
            return [
                "keyChanged" /* _EventType.KEY_CHANGED */ 
            ];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ async initializeSender() {
        var _a, _b;
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await _getActiveServiceWorker();
        if (!this.activeServiceWorker) return;
        this.sender = new Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ );
        if (!results) return;
        if (((_a = results[0]) === null || _a === void 0 ? void 0 : _a.fulfilled) && ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ ))) this.serviceWorkerReceiverAvailable = true;
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ async notifyServiceWorker(key) {
        if (!this.sender || !this.activeServiceWorker || _getServiceWorkerController() !== this.activeServiceWorker) return;
        try {
            await this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                key
            }, // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ );
        } catch (_a) {
        // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) return false;
            const db = await _openDatabase();
            await _putObject(db, STORAGE_AVAILABLE_KEY, '1');
            await _deleteObject(db, STORAGE_AVAILABLE_KEY);
            return true;
        } catch (_a) {}
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        } finally{
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>_putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = await this._withRetries((db)=>getObject(db, key));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>_deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        // TODO: check if we need to fallback if getAll is not supported
        const result = await this._withRetries((db)=>{
            const getAllRequest = getObjectStore(db, false).getAll();
            return new DBPromise(getAllRequest).toPromise();
        });
        if (!result) return [];
        // If we have pending writes in progress abort, we'll get picked up on the next poll
        if (this.pendingWrites !== 0) return [];
        const keys = [];
        const keysInResult = new Set();
        if (result.length !== 0) for (const { fbase_key: key, value } of result){
            keysInResult.add(key);
            if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                this.notifyListeners(key, value);
                keys.push(key);
            }
        }
        for (const localKey of Object.keys(this.localCache))if (this.localCache[localKey] && !keysInResult.has(localKey)) {
            // Deleted
            this.notifyListeners(localKey, null);
            keys.push(localKey);
        }
        return keys;
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(newValue);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async ()=>this._poll(), _POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) this.startPolling();
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) this.stopPolling();
    }
}
IndexedDBLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ const indexedDBLocalPersistence = IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function startSignInPhoneMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , _addTidIfNecessary(auth, request));
}
function finalizeSignInPhoneMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , _addTidIfNecessary(auth, request));
}
function finalizeSignInTotpMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , _addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const _JSLOAD_CALLBACK = _generateCallbackName('rcb');
const NETWORK_TIMEOUT_DELAY = new Delay(30000, 60000);
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ class ReCaptchaLoaderImpl {
    constructor(){
        var _a;
        this.hostLanguage = '';
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!((_a = _window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render);
    }
    load(auth, hl = '') {
        _assert(isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (this.shouldResolveImmediately(hl) && isV2(_window().grecaptcha)) return Promise.resolve(_window().grecaptcha);
        return new Promise((resolve, reject)=>{
            const networkTimeout = _window().setTimeout(()=>{
                reject(_createError(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, NETWORK_TIMEOUT_DELAY.get());
            _window()[_JSLOAD_CALLBACK] = ()=>{
                _window().clearTimeout(networkTimeout);
                delete _window()[_JSLOAD_CALLBACK];
                const recaptcha = _window().grecaptcha;
                if (!recaptcha || !isV2(recaptcha)) {
                    reject(_createError(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    return;
                }
                // Wrap the recaptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params)=>{
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${_recaptchaV2ScriptUrl()}?${(0, _util.querystring)({
                onload: _JSLOAD_CALLBACK,
                render: 'explicit',
                hl
            })}`;
            _loadJS(url).catch(()=>{
                clearTimeout(networkTimeout);
                reject(_createError(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        var _a;
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return !!((_a = _window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render) && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
}
function isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class MockReCaptchaLoaderImpl {
    async load(auth) {
        return new MockReCaptcha(auth);
    }
    clearedOneInstance() {}
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const RECAPTCHA_VERIFIER_TYPE = 'recaptcha';
const DEFAULT_PARAMS = {
    theme: 'light',
    type: 'image'
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @remarks
 * `RecaptchaVerifier` does not work in a Node.js environment.
 *
 * @public
 */ class RecaptchaVerifier {
    /**
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     */ constructor(authExtern, containerOrId, parameters = Object.assign({}, DEFAULT_PARAMS)){
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = _castAuth(authExtern);
        this.isInvisible = this.parameters.size === 'invisible';
        _assert(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        _assert(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new MockReCaptchaLoaderImpl() : new ReCaptchaLoaderImpl();
        this.validateStartingState();
    // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) return response;
        return new Promise((resolve)=>{
            const tokenChange = (token)=>{
                if (!token) return; // Ignore token expirations.
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) recaptcha.execute(id);
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ render() {
        try {
            this.assertNotDestroyed();
        } catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) return this.renderPromise;
        this.renderPromise = this.makeRenderPromise().catch((e)=>{
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */ _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) this.container.childNodes.forEach((node)=>{
            this.container.removeChild(node);
        });
    }
    validateStartingState() {
        _assert(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        _assert(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        _assert(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    }
    makeTokenCallback(existing) {
        return (token)=>{
            this.tokenChangeListeners.forEach((listener)=>listener(token));
            if (typeof existing === 'function') existing(token);
            else if (typeof existing === 'string') {
                const globalFunc = _window()[existing];
                if (typeof globalFunc === 'function') globalFunc(token);
            }
        };
    }
    assertNotDestroyed() {
        _assert(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement('div');
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        _assert(_isHttpOrHttps() && !_isWorker(), this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        await domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await getRecaptchaParams(this.auth);
        _assert(siteKey, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        _assert(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.recaptcha;
    }
}
function domReady() {
    let resolver = null;
    return new Promise((resolve)=>{
        if (document.readyState === 'complete') {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = ()=>resolve();
        window.addEventListener('load', resolver);
    }).catch((e)=>{
        if (resolver) window.removeEventListener('load', resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class ConfirmationResultImpl {
    constructor(verificationId, onConfirmation){
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = PhoneAuthCredential._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method requires a {@link ApplicationVerifier}.
 * This SDK includes an implementation based on reCAPTCHA v2, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * If you've enabled project-level reCAPTCHA Enterprise bot protection in
 * Enforce mode, you can omit the {@link ApplicationVerifier}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function signInWithPhoneNumber(auth, phoneNumber, appVerifier) {
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = _castAuth(auth);
    const verificationId = await _verifyPhoneNumber(authInternal, phoneNumber, (0, _util.getModularInstance)(appVerifier));
    return new ConfirmationResultImpl(verificationId, (cred)=>signInWithCredential(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function linkWithPhoneNumber(user, phoneNumber, appVerifier) {
    const userInternal = (0, _util.getModularInstance)(user);
    await _assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ );
    const verificationId = await _verifyPhoneNumber(userInternal.auth, phoneNumber, (0, _util.getModularInstance)(appVerifier));
    return new ConfirmationResultImpl(verificationId, (cred)=>linkWithCredential(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function reauthenticateWithPhoneNumber(user, phoneNumber, appVerifier) {
    const userInternal = (0, _util.getModularInstance)(user);
    if ((0, _app._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    const verificationId = await _verifyPhoneNumber(userInternal.auth, phoneNumber, (0, _util.getModularInstance)(appVerifier));
    return new ConfirmationResultImpl(verificationId, (cred)=>reauthenticateWithCredential(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ async function _verifyPhoneNumber(auth, options, verifier) {
    var _a;
    if (!auth._getRecaptchaConfig()) try {
        await _initializeRecaptchaConfig(auth);
    } catch (error) {
        // If an error occurs while fetching the config, there is no way to know the enablement state
        // of Phone provider, so we proceed with recaptcha V2 verification.
        // The error is likely "recaptchaKey undefined", as reCAPTCHA Enterprise is not
        // enabled for any provider.
        console.log('Failed to initialize reCAPTCHA Enterprise config. Triggering the reCAPTCHA v2 verification.');
    }
    try {
        let phoneInfoOptions;
        if (typeof options === 'string') phoneInfoOptions = {
            phoneNumber: options
        };
        else phoneInfoOptions = options;
        if ('session' in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ('phoneNumber' in phoneInfoOptions) {
                _assert(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const startPhoneMfaEnrollmentRequest = {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    }
                };
                const startEnrollPhoneMfaActionCallback = async (authInstance, request)=>{
                    // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                    if (request.phoneEnrollmentInfo.captchaResponse === FAKE_TOKEN) {
                        _assert((verifier === null || verifier === void 0 ? void 0 : verifier.type) === RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        const requestWithRecaptchaV2 = await injectRecaptchaV2Token(authInstance, request, verifier);
                        return startEnrollPhoneMfa(authInstance, requestWithRecaptchaV2);
                    }
                    return startEnrollPhoneMfa(authInstance, request);
                };
                const startPhoneMfaEnrollmentResponse = handleRecaptchaFlow(auth, startPhoneMfaEnrollmentRequest, "mfaSmsEnrollment" /* RecaptchaActionName.MFA_SMS_ENROLLMENT */ , startEnrollPhoneMfaActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
                const response = await startPhoneMfaEnrollmentResponse.catch((error)=>{
                    return Promise.reject(error);
                });
                return response.phoneSessionInfo.sessionInfo;
            } else {
                _assert(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const mfaEnrollmentId = ((_a = phoneInfoOptions.multiFactorHint) === null || _a === void 0 ? void 0 : _a.uid) || phoneInfoOptions.multiFactorUid;
                _assert(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                const startPhoneMfaSignInRequest = {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId,
                    phoneSignInInfo: {
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    }
                };
                const startSignInPhoneMfaActionCallback = async (authInstance, request)=>{
                    // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                    if (request.phoneSignInInfo.captchaResponse === FAKE_TOKEN) {
                        _assert((verifier === null || verifier === void 0 ? void 0 : verifier.type) === RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        const requestWithRecaptchaV2 = await injectRecaptchaV2Token(authInstance, request, verifier);
                        return startSignInPhoneMfa(authInstance, requestWithRecaptchaV2);
                    }
                    return startSignInPhoneMfa(authInstance, request);
                };
                const startPhoneMfaSignInResponse = handleRecaptchaFlow(auth, startPhoneMfaSignInRequest, "mfaSmsSignIn" /* RecaptchaActionName.MFA_SMS_SIGNIN */ , startSignInPhoneMfaActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
                const response = await startPhoneMfaSignInResponse.catch((error)=>{
                    return Promise.reject(error);
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        } else {
            const sendPhoneVerificationCodeRequest = {
                phoneNumber: phoneInfoOptions.phoneNumber,
                clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
            };
            const sendPhoneVerificationCodeActionCallback = async (authInstance, request)=>{
                // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                if (request.captchaResponse === FAKE_TOKEN) {
                    _assert((verifier === null || verifier === void 0 ? void 0 : verifier.type) === RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                    const requestWithRecaptchaV2 = await injectRecaptchaV2Token(authInstance, request, verifier);
                    return sendPhoneVerificationCode(authInstance, requestWithRecaptchaV2);
                }
                return sendPhoneVerificationCode(authInstance, request);
            };
            const sendPhoneVerificationCodeResponse = handleRecaptchaFlow(auth, sendPhoneVerificationCodeRequest, "sendVerificationCode" /* RecaptchaActionName.SEND_VERIFICATION_CODE */ , sendPhoneVerificationCodeActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
            const response = await sendPhoneVerificationCodeResponse.catch((error)=>{
                return Promise.reject(error);
            });
            return response.sessionInfo;
        }
    } finally{
        verifier === null || verifier === void 0 || verifier._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ async function updatePhoneNumber(user, credential) {
    const userInternal = (0, _util.getModularInstance)(user);
    if ((0, _app._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    await _link$1(userInternal, credential);
}
// Helper function that fetches and injects a reCAPTCHA v2 token into the request.
async function injectRecaptchaV2Token(auth, request, recaptchaV2Verifier) {
    _assert(recaptchaV2Verifier.type === RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    const recaptchaV2Token = await recaptchaV2Verifier.verify();
    _assert(typeof recaptchaV2Token === 'string', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    const newRequest = Object.assign({}, request);
    if ('phoneEnrollmentInfo' in newRequest) {
        const phoneNumber = newRequest.phoneEnrollmentInfo.phoneNumber;
        const captchaResponse = newRequest.phoneEnrollmentInfo.captchaResponse;
        const clientType = newRequest.phoneEnrollmentInfo.clientType;
        const recaptchaVersion = newRequest.phoneEnrollmentInfo.recaptchaVersion;
        Object.assign(newRequest, {
            'phoneEnrollmentInfo': {
                phoneNumber,
                recaptchaToken: recaptchaV2Token,
                captchaResponse,
                clientType,
                recaptchaVersion
            }
        });
        return newRequest;
    } else if ('phoneSignInInfo' in newRequest) {
        const captchaResponse = newRequest.phoneSignInInfo.captchaResponse;
        const clientType = newRequest.phoneSignInInfo.clientType;
        const recaptchaVersion = newRequest.phoneSignInInfo.recaptchaVersion;
        Object.assign(newRequest, {
            'phoneSignInInfo': {
                recaptchaToken: recaptchaV2Token,
                captchaResponse,
                clientType,
                recaptchaVersion
            }
        });
        return newRequest;
    } else {
        Object.assign(newRequest, {
            'recaptchaToken': recaptchaV2Token
        });
        return newRequest;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @remarks
 * `PhoneAuthProvider` does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ class PhoneAuthProvider {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */ constructor(auth){
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = PhoneAuthProvider.PROVIDER_ID;
        this.auth = _castAuth(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - An {@link ApplicationVerifier}, which prevents
     * requests from unauthorized clients. This SDK includes an implementation
     * based on reCAPTCHA v2, {@link RecaptchaVerifier}. If you've enabled
     * reCAPTCHA Enterprise bot protection in Enforce mode, this parameter is
     * optional; in all other configurations, the parameter is required.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow.
     */ verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return _verifyPhoneNumber(this.auth, phoneOptions, (0, _util.getModularInstance)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ static credential(verificationId, verificationCode) {
        return PhoneAuthCredential._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        const credential = userCredential;
        return PhoneAuthProvider.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ static credentialFromError(error) {
        return PhoneAuthProvider.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { phoneNumber, temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) return PhoneAuthCredential._fromTokenResponse(phoneNumber, temporaryProof);
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */ PhoneAuthProvider.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ PhoneAuthProvider.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function _withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return _getInstance(resolverOverride);
    _assert(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class IdpCredential extends AuthCredential {
    constructor(params){
        super("custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) request.idToken = idToken;
        return request;
    }
}
function _signIn(params) {
    return _signInWithCredential(params.auth, new IdpCredential(params), params.bypassAuthState);
}
function _reauth(params) {
    const { auth, user } = params;
    _assert(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return _reauthenticate(user, new IdpCredential(params), params.bypassAuthState);
}
async function _link(params) {
    const { auth, user } = params;
    _assert(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return _link$1(user, new IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ class AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false){
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    execute() {
        return new Promise(async (resolve, reject)=>{
            this.pendingPromise = {
                resolve,
                reject
            };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            } catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse, sessionId, postBody, tenantId, error, type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        } catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch(type){
            case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
            case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                return _signIn;
            case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
            case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                return _link;
            case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
            case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                return _reauth;
            default:
                _fail(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    resolve(cred) {
        debugAssert(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        debugAssert(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) this.eventManager.unregisterConsumer(this);
        this.pendingPromise = null;
        this.cleanUp();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const _POLL_WINDOW_CLOSE_TIMEOUT = new Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function signInWithPopup(auth, provider, resolver) {
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_createError(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    const authInternal = _castAuth(auth);
    _assertInstanceOf(auth, provider, FederatedAuthProvider);
    const resolverInternal = _withDefaultResolver(authInternal, resolver);
    const action = new PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function reauthenticateWithPopup(user, provider, resolver) {
    const userInternal = (0, _util.getModularInstance)(user);
    if ((0, _app._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject(_createError(userInternal.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    _assertInstanceOf(userInternal.auth, provider, FederatedAuthProvider);
    const resolverInternal = _withDefaultResolver(userInternal.auth, resolver);
    const action = new PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function linkWithPopup(user, provider, resolver) {
    const userInternal = (0, _util.getModularInstance)(user);
    _assertInstanceOf(userInternal.auth, provider, FederatedAuthProvider);
    const resolverInternal = _withDefaultResolver(userInternal.auth, resolver);
    const action = new PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ class PopupOperation extends AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user){
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if (PopupOperation.currentPopupAction) PopupOperation.currentPopupAction.cancel();
        PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        _assert(result, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return result;
    }
    async onExecution() {
        debugAssert(this.filter.length === 1, 'Popup operations only handle one event');
        const eventId = _generateEventId();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch((e)=>{
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, (isSupported)=>{
            if (!isSupported) this.reject(_createError(this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        var _a;
        return ((_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.associatedEvent) || null;
    }
    cancel() {
        this.reject(_createError(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
    }
    cleanUp() {
        if (this.authWindow) this.authWindow.close();
        if (this.pollId) window.clearTimeout(this.pollId);
        this.authWindow = null;
        this.pollId = null;
        PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = ()=>{
            var _a, _b;
            if ((_b = (_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight. This is specifically true for
                // Firefox or if the opener is in an iframe, in which case the oauth
                // helper closes the popup.
                this.pollId = window.setTimeout(()=>{
                    this.pollId = null;
                    this.reject(_createError(this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                }, 8000 /* _Timeout.AUTH_EVENT */ );
                return;
            }
            this.pollId = window.setTimeout(poll, _POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const PENDING_REDIRECT_KEY = 'pendingRedirect';
// We only get one redirect outcome for any one auth, so just store it
// in here.
const redirectOutcomeMap = new Map();
class RedirectAction extends AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false){
        super(auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ async execute() {
        let readyOutcome = redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await _getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = ()=>Promise.resolve(result);
            } catch (e) {
                readyOutcome = ()=>Promise.reject(e);
            }
            redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) redirectOutcomeMap.set(this.auth._key(), ()=>Promise.resolve(null));
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return super.onAuthEvent(event);
        else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            } else this.resolve(null);
        }
    }
    async onExecution() {}
    cleanUp() {}
}
async function _getAndClearPendingRedirectStatus(resolver, auth) {
    const key = pendingRedirectKey(auth);
    const persistence = resolverPersistence(resolver);
    if (!await persistence._isAvailable()) return false;
    const hasPendingRedirect = await persistence._get(key) === 'true';
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function _setPendingRedirectStatus(resolver, auth) {
    return resolverPersistence(resolver)._set(pendingRedirectKey(auth), 'true');
}
function _clearRedirectOutcomes() {
    redirectOutcomeMap.clear();
}
function _overrideRedirectResult(auth, result) {
    redirectOutcomeMap.set(auth._key(), result);
}
function resolverPersistence(resolver) {
    return _getInstance(resolver._redirectPersistence);
}
function pendingRedirectKey(auth) {
    return _persistenceKeyName(PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function signInWithRedirect(auth, provider, resolver) {
    return _signInWithRedirect(auth, provider, resolver);
}
async function _signInWithRedirect(auth, provider, resolver) {
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = _castAuth(auth);
    _assertInstanceOf(auth, provider, FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await authInternal._initializationPromise;
    const resolverInternal = _withDefaultResolver(authInternal, resolver);
    await _setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ );
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function reauthenticateWithRedirect(user, provider, resolver) {
    return _reauthenticateWithRedirect(user, provider, resolver);
}
async function _reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = (0, _util.getModularInstance)(user);
    _assertInstanceOf(userInternal.auth, provider, FederatedAuthProvider);
    if ((0, _app._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = _withDefaultResolver(userInternal.auth, resolver);
    await _setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function linkWithRedirect(user, provider, resolver) {
    return _linkWithRedirect(user, provider, resolver);
}
async function _linkWithRedirect(user, provider, resolver) {
    const userInternal = (0, _util.getModularInstance)(user);
    _assertInstanceOf(userInternal.auth, provider, FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = _withDefaultResolver(userInternal.auth, resolver);
    await _assertLinkedStatus(false, userInternal, provider.providerId);
    await _setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function getRedirectResult(auth, resolver) {
    await _castAuth(auth)._initializationPromise;
    return _getRedirectResult(auth, resolver, false);
}
async function _getRedirectResult(auth, resolverExtern, bypassAuthState = false) {
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = _castAuth(auth);
    const resolver = _withDefaultResolver(authInternal, resolverExtern);
    const action = new RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function prepareUserForRedirect(user) {
    const eventId = _generateEventId(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
class AuthEventManager {
    constructor(auth){
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) return false;
        let handled = false;
        this.consumers.forEach((consumer)=>{
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        var _a;
        if (event.error && !isNullRedirectEvent(event)) {
            const code = ((_a = event.error.code) === null || _a === void 0 ? void 0 : _a.split('auth/')[1]) || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
            consumer.onError(_createError(this.auth, code));
        } else consumer.onAuthEvent(event);
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >= EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
        return this.cachedEventUids.has(eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add(eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter((v)=>v).join('-');
}
function isNullRedirectEvent({ type, error }) {
    return type === "unknown" /* AuthEventType.UNKNOWN */  && (error === null || error === void 0 ? void 0 : error.code) === `auth/${"no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ }`;
}
function isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return isNullRedirectEvent(event);
        default:
            return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function _getProjectConfig(auth, request = {}) {
    return _performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const HTTP_REGEX = /^https?/;
async function _validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) return;
    const { authorizedDomains } = await _getProjectConfig(auth);
    for (const domain of authorizedDomains)try {
        if (matchDomain(domain)) return;
    } catch (_a) {
    // Do nothing if there's a URL error; just continue searching
    }
    // In the old SDK, this error also provides helpful messages.
    _fail(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
}
function matchDomain(expected) {
    const currentUrl = _getCurrentUrl();
    const { protocol, hostname } = new URL(currentUrl);
    if (expected.startsWith('chrome-extension://')) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === '' && hostname === '') // For some reason we're not parsing chrome URLs properly
        return protocol === 'chrome-extension:' && expected.replace('chrome-extension://', '') === currentUrl.replace('chrome-extension://', '');
        return protocol === 'chrome-extension:' && ceUrl.hostname === hostname;
    }
    if (!HTTP_REGEX.test(protocol)) return false;
    if (IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, '\\.');
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp('^(.+\\.' + escapedDomainPattern + '|' + escapedDomainPattern + ')$', 'i');
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const NETWORK_TIMEOUT = new Delay(30000, 60000);
/**
 * Reset unloaded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = _window().___jsl;
    // Get current hint.
    if (beacon === null || beacon === void 0 ? void 0 : beacon.H) // Get gapi hint.
    for (const hint of Object.keys(beacon.H)){
        // Requested modules.
        beacon.H[hint].r = beacon.H[hint].r || [];
        // Loaded modules.
        beacon.H[hint].L = beacon.H[hint].L || [];
        // Set requested modules to a copy of the loaded modules.
        beacon.H[hint].r = [
            ...beacon.H[hint].L
        ];
        // Clear pending callbacks.
        if (beacon.CP) for(let i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
        beacon.CP[i] = null;
    }
}
function loadGapi(auth) {
    return new Promise((resolve, reject)=>{
        var _a, _b, _c;
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            resetUnloadedGapiModules();
            gapi.load('gapi.iframes', {
                callback: ()=>{
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: ()=>{
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    resetUnloadedGapiModules();
                    reject(_createError(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: NETWORK_TIMEOUT.get()
            });
        }
        if ((_b = (_a = _window().gapi) === null || _a === void 0 ? void 0 : _a.iframes) === null || _b === void 0 ? void 0 : _b.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!((_c = _window().gapi) === null || _c === void 0 ? void 0 : _c.load)) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = _generateCallbackName('iframefcb');
            // GApi loader not available, dynamically load platform.js.
            _window()[cbName] = ()=>{
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject(_createError(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return _loadJS(`${_gapiScriptUrl()}?onload=${cbName}`).catch((e)=>reject(e));
        }
    }).catch((error)=>{
        // Reset cached promise to allow for retrial.
        cachedGApiLoader = null;
        throw error;
    });
}
let cachedGApiLoader = null;
function _loadGapi(auth) {
    cachedGApiLoader = cachedGApiLoader || loadGapi(auth);
    return cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const PING_TIMEOUT = new Delay(5000, 15000);
const IFRAME_PATH = '__/auth/iframe';
const EMULATED_IFRAME_PATH = 'emulator/auth/iframe';
const IFRAME_ATTRIBUTES = {
    style: {
        position: 'absolute',
        top: '-100px',
        width: '1px',
        height: '1px'
    },
    'aria-hidden': 'true',
    tabindex: '-1'
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        'p'
    ],
    [
        'staging-identitytoolkit.sandbox.googleapis.com',
        's'
    ],
    [
        'test-identitytoolkit.sandbox.googleapis.com',
        't'
    ] // test
]);
function getIframeUrl(auth) {
    const config = auth.config;
    _assert(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    const url = config.emulator ? _emulatorUrl(config, EMULATED_IFRAME_PATH) : `https://${auth.config.authDomain}/${IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, _app.SDK_VERSION)
    };
    const eid = EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    const frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(',');
    return `${url}?${(0, _util.querystring)(params).slice(1)}`;
}
async function _openIframe(auth) {
    const context = await _loadGapi(auth);
    const gapi1 = _window().gapi;
    _assert(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return context.open({
        where: document.body,
        url: getIframeUrl(auth),
        messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe)=>new Promise(async (resolve, reject)=>{
            await iframe.restyle({
                // Prevent iframe from closing on mouse out.
                setHideOnLeave: false
            });
            const networkError = _createError(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
            // Confirm iframe is correctly loaded.
            // To fallback on failure, set a timeout.
            const networkErrorTimer = _window().setTimeout(()=>{
                reject(networkError);
            }, PING_TIMEOUT.get());
            // Clear timer and resolve pending iframe ready promise.
            function clearTimerAndResolve() {
                _window().clearTimeout(networkErrorTimer);
                resolve(iframe);
            }
            // This returns an IThenable. However the reject part does not call
            // when the iframe is not loaded.
            iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, ()=>{
                reject(networkError);
            });
        }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const BASE_POPUP_OPTIONS = {
    location: 'yes',
    resizable: 'yes',
    statusbar: 'yes',
    toolbar: 'no'
};
const DEFAULT_WIDTH = 500;
const DEFAULT_HEIGHT = 600;
const TARGET_BLANK = '_blank';
const FIREFOX_EMPTY_URL = 'http://localhost';
class AuthPopup {
    constructor(window1){
        this.window = window1;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) try {
            this.window.close();
        } catch (e) {}
    }
}
function _open(auth, url, name, width = DEFAULT_WIDTH, height = DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = '';
    const options = Object.assign(Object.assign({}, BASE_POPUP_OPTIONS), {
        width: width.toString(),
        height: height.toString(),
        top,
        left
    });
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0, _util.getUA)().toLowerCase();
    if (name) target = _isChromeIOS(ua) ? TARGET_BLANK : name;
    if (_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = 'yes';
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value])=>`${accum}${key}=${value},`, '');
    if (_isIOSStandalone(ua) && target !== '_self') {
        openAsNewWindowIOS(url || '', target);
        return new AuthPopup(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || '', target, optionsString);
    _assert(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new AuthPopup(newWin);
}
function openAsNewWindowIOS(url, target) {
    const el = document.createElement('a');
    el.href = url;
    el.target = target;
    const click = document.createEvent('MouseEvent');
    click.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ const WIDGET_PATH = '__/auth/handler';
/**
 * URL for emulated environment
 *
 * @internal
 */ const EMULATOR_WIDGET_PATH = 'emulator/auth/handler';
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ const FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent('fac');
async function _getRedirectUrl(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    _assert(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    _assert(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType,
        redirectUrl,
        v: (0, _app.SDK_VERSION),
        eventId
    };
    if (provider instanceof FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || '';
        if (!(0, _util.isEmpty)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {}))params[key] = value;
    }
    if (provider instanceof BaseOAuthProvider) {
        const scopes = provider.getScopes().filter((scope)=>scope !== '');
        if (scopes.length > 0) params.scopes = scopes.join(',');
    }
    if (auth.tenantId) params.tid = auth.tenantId;
    // TODO: maybe set eid as endpointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict))if (paramsDict[key] === undefined) delete paramsDict[key];
    // Sets the App Check token to pass to the widget
    const appCheckToken = await auth._getAppCheckToken();
    const appCheckTokenFragment = appCheckToken ? `#${FIREBASE_APP_CHECK_FRAGMENT_ID}=${encodeURIComponent(appCheckToken)}` : '';
    // Start at index 1 to skip the leading '&' in the query string
    return `${getHandlerBase(auth)}?${(0, _util.querystring)(paramsDict).slice(1)}${appCheckTokenFragment}`;
}
function getHandlerBase({ config }) {
    if (!config.emulator) return `https://${config.authDomain}/${WIDGET_PATH}`;
    return _emulatorUrl(config, EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ const WEB_STORAGE_SUPPORT_KEY = 'webStorageSupport';
class BrowserPopupRedirectResolver {
    constructor(){
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = browserSessionPersistence;
        this._completeRedirectFn = _getRedirectResult;
        this._overrideRedirectResult = _overrideRedirectResult;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        var _a;
        debugAssert((_a = this.eventManagers[auth._key()]) === null || _a === void 0 ? void 0 : _a.manager, '_initialize() not called before _openPopup()');
        const url = await _getRedirectUrl(auth, provider, authType, _getCurrentUrl(), eventId);
        return _open(auth, url, _generateEventId());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        const url = await _getRedirectUrl(auth, provider, authType, _getCurrentUrl(), eventId);
        _setWindowLocation(url);
        return new Promise(()=>{});
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager, promise } = this.eventManagers[key];
            if (manager) return Promise.resolve(manager);
            else {
                debugAssert(promise, 'If manager is not set, promise should be');
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = {
            promise
        };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(()=>{
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await _openIframe(auth);
        const manager = new AuthEventManager(auth);
        iframe.register('authEvent', (iframeEvent)=>{
            _assert(iframeEvent === null || iframeEvent === void 0 ? void 0 : iframeEvent.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return {
                status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
            };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = {
            manager
        };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send(WEB_STORAGE_SUPPORT_KEY, {
            type: WEB_STORAGE_SUPPORT_KEY
        }, (result)=>{
            var _a;
            const isSupported = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a[WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) cb(!!isSupported);
            _fail(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = _validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return _isMobileBrowser() || _isSafari() || _isIOS();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @public
 */ const browserPopupRedirectResolver = BrowserPopupRedirectResolver;
class MultiFactorAssertionImpl {
    constructor(factorId){
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch(session.type){
            case "enroll" /* MultiFactorSessionType.ENROLL */ :
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                return this._finalizeSignIn(auth, session.credential);
            default:
                return debugFail('unexpected MultiFactorSessionType');
        }
    }
}
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ class PhoneMultiFactorAssertionImpl extends MultiFactorAssertionImpl {
    constructor(credential){
        super("phone" /* FactorId.PHONE */ );
        this.credential = credential;
    }
    /** @internal */ static _fromCredential(credential) {
        return new PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */ _finalizeEnroll(auth, idToken, displayName) {
        return finalizeEnrollPhoneMfa(auth, {
            idToken,
            displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */ _finalizeSignIn(auth, mfaPendingCredential) {
        return finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ class PhoneMultiFactorGenerator {
    constructor(){}
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @remarks
     * This method does not work in a Node.js environment.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ static assertion(credential) {
        return PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */ PhoneMultiFactorGenerator.FACTOR_ID = 'phone';
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ class TotpMultiFactorGenerator {
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ static assertionForEnrollment(secret, oneTimePassword) {
        return TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
    }
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ static assertionForSignIn(enrollmentId, oneTimePassword) {
        return TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
    }
    /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ static async generateSecret(session) {
        var _a;
        const mfaSession = session;
        _assert(typeof ((_a = mfaSession.user) === null || _a === void 0 ? void 0 : _a.auth) !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const response = await startEnrollTotpMfa(mfaSession.user.auth, {
            idToken: mfaSession.credential,
            totpEnrollmentInfo: {}
        });
        return TotpSecret._fromStartTotpMfaEnrollmentResponse(response, mfaSession.user.auth);
    }
}
/**
 * The identifier of the TOTP second factor: `totp`.
 */ TotpMultiFactorGenerator.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
class TotpMultiFactorAssertionImpl extends MultiFactorAssertionImpl {
    constructor(otp, enrollmentId, secret){
        super("totp" /* FactorId.TOTP */ );
        this.otp = otp;
        this.enrollmentId = enrollmentId;
        this.secret = secret;
    }
    /** @internal */ static _fromSecret(secret, otp) {
        return new TotpMultiFactorAssertionImpl(otp, undefined, secret);
    }
    /** @internal */ static _fromEnrollmentId(enrollmentId, otp) {
        return new TotpMultiFactorAssertionImpl(otp, enrollmentId);
    }
    /** @internal */ async _finalizeEnroll(auth, idToken, displayName) {
        _assert(typeof this.secret !== 'undefined', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return finalizeEnrollTotpMfa(auth, {
            idToken,
            displayName,
            totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
        });
    }
    /** @internal */ async _finalizeSignIn(auth, mfaPendingCredential) {
        _assert(this.enrollmentId !== undefined && this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        const totpVerificationInfo = {
            verificationCode: this.otp
        };
        return finalizeSignInTotpMfa(auth, {
            mfaPendingCredential,
            mfaEnrollmentId: this.enrollmentId,
            totpVerificationInfo
        });
    }
}
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ class TotpSecret {
    // The public members are declared outside the constructor so the docs can be generated.
    constructor(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth){
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    /** @internal */ static _fromStartTotpMfaEnrollmentResponse(response, auth) {
        return new TotpSecret(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
    }
    /** @internal */ _makeTotpVerificationInfo(otp) {
        return {
            sessionInfo: this.sessionInfo,
            verificationCode: otp
        };
    }
    /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ generateQrCodeUrl(accountName, issuer) {
        var _a;
        let useDefaults = false;
        if (_isEmptyString(accountName) || _isEmptyString(issuer)) useDefaults = true;
        if (useDefaults) {
            if (_isEmptyString(accountName)) accountName = ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.email) || 'unknownuser';
            if (_isEmptyString(issuer)) issuer = this.auth.name;
        }
        return `otpauth://totp/${issuer}:${accountName}?secret=${this.secretKey}&issuer=${issuer}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
    }
}
/** @internal */ function _isEmptyString(input) {
    return typeof input === 'undefined' || (input === null || input === void 0 ? void 0 : input.length) === 0;
}
var name = "@firebase/auth";
var version = "1.10.8";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class AuthInterop {
    constructor(auth){
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        var _a;
        this.assertAuthConfigured();
        return ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) return null;
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return {
            accessToken
        };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) return;
        const unsubscribe = this.auth.onIdTokenChanged((user)=>{
            listener((user === null || user === void 0 ? void 0 : user.stsTokenManager.accessToken) || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) return;
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        _assert(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
        else this.auth._stopProactiveRefresh();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return 'node';
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return 'rn';
        case "Worker" /* ClientPlatform.WORKER */ :
            return 'webworker';
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return 'cordova';
        case "WebExtension" /* ClientPlatform.WEB_EXTENSION */ :
            return 'web-extension';
        default:
            return undefined;
    }
}
/** @internal */ function registerAuth(clientPlatform) {
    (0, _app._registerComponent)(new (0, _component.Component)("auth" /* _ComponentName.AUTH */ , (container, { options: deps })=>{
        const app = container.getProvider('app').getImmediate();
        const heartbeatServiceProvider = container.getProvider('heartbeat');
        const appCheckServiceProvider = container.getProvider('app-check-internal');
        const { apiKey, authDomain } = app.options;
        _assert(apiKey && !apiKey.includes(':'), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        const config = {
            apiKey,
            authDomain,
            clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: _getClientVersion(clientPlatform)
        };
        const authInstance = new AuthImpl(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        _initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback((container, _instanceIdentifier, _instance)=>{
        const authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, _app._registerComponent)(new (0, _component.Component)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , (container)=>{
        const auth = _castAuth(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return ((auth)=>new AuthInterop(auth))(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, _app.registerVersion)(name, version, getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    (0, _app.registerVersion)(name, version, 'esm2017');
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const DEFAULT_ID_TOKEN_MAX_AGE = 300;
const authIdTokenMaxAge = (0, _util.getExperimentalSetting)('authIdTokenMaxAge') || DEFAULT_ID_TOKEN_MAX_AGE;
let lastPostedIdToken = null;
const mintCookieFactory = (url)=>async (user)=>{
        const idTokenResult = user && await user.getIdTokenResult();
        const idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
        if (idTokenAge && idTokenAge > authIdTokenMaxAge) return;
        // Specifically trip null => undefined when logged out, to delete any existing cookie
        const idToken = idTokenResult === null || idTokenResult === void 0 ? void 0 : idTokenResult.token;
        if (lastPostedIdToken === idToken) return;
        lastPostedIdToken = idToken;
        await fetch(url, {
            method: idToken ? 'POST' : 'DELETE',
            headers: idToken ? {
                'Authorization': `Bearer ${idToken}`
            } : {}
        });
    };
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function getAuth(app = (0, _app.getApp)()) {
    const provider = (0, _app._getProvider)(app, 'auth');
    if (provider.isInitialized()) return provider.getImmediate();
    const auth = initializeAuth(app, {
        popupRedirectResolver: browserPopupRedirectResolver,
        persistence: [
            indexedDBLocalPersistence,
            browserLocalPersistence,
            browserSessionPersistence
        ]
    });
    const authTokenSyncPath = (0, _util.getExperimentalSetting)('authTokenSyncURL');
    // Only do the Cookie exchange in a secure context
    if (authTokenSyncPath && typeof isSecureContext === 'boolean' && isSecureContext) {
        // Don't allow urls (XSS possibility), only paths on the same domain
        const authTokenSyncUrl = new URL(authTokenSyncPath, location.origin);
        if (location.origin === authTokenSyncUrl.origin) {
            const mintCookie = mintCookieFactory(authTokenSyncUrl.toString());
            beforeAuthStateChanged(auth, mintCookie, ()=>mintCookie(auth.currentUser));
            onIdTokenChanged(auth, (user)=>mintCookie(user));
        }
    }
    const authEmulatorHost = (0, _util.getDefaultEmulatorHost)('auth');
    if (authEmulatorHost) connectAuthEmulator(auth, `http://${authEmulatorHost}`);
    return auth;
}
function getScriptParentElement() {
    var _a, _b;
    return (_b = (_a = document.getElementsByTagName('head')) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : document;
}
_setExternalJSProvider({
    loadJS (url) {
        // TODO: consider adding timeout support & cancellation
        return new Promise((resolve, reject)=>{
            const el = document.createElement('script');
            el.setAttribute('src', url);
            el.onload = resolve;
            el.onerror = (e)=>{
                const error = _createError("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                error.customData = e;
                reject(error);
            };
            el.type = 'text/javascript';
            el.charset = 'UTF-8';
            getScriptParentElement().appendChild(el);
        });
    },
    gapiScript: 'https://apis.google.com/js/api.js',
    recaptchaV2Script: 'https://www.google.com/recaptcha/api.js',
    recaptchaEnterpriseScript: 'https://www.google.com/recaptcha/enterprise.js?render='
});
registerAuth("Browser" /* ClientPlatform.BROWSER */ );

},{"@firebase/app":"1SyrH","@firebase/util":"guJD8","@firebase/logger":"3ul0m","tslib":"7YykB","@firebase/component":"2tpfU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7YykB":[function(require,module,exports,__globalThis) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
parcelHelpers.export(exports, "__rewriteRelativeImportExtension", ()=>__rewriteRelativeImportExtension);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var ownKeys = function(o) {
    ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return ownKeys(o);
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") __createBinding(result, mod, k[i]);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function __rewriteRelativeImportExtension(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __esDecorate: __esDecorate,
    __runInitializers: __runInitializers,
    __propKey: __propKey,
    __setFunctionName: __setFunctionName,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources,
    __rewriteRelativeImportExtension: __rewriteRelativeImportExtension
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ca4ti":[function(require,module,exports,__globalThis) {
// Guided tour of the gene search, on sites whose config sets `tour: true`.
// The engine is gramene-search-tour; ./tourSteps is Gramene's own script.
// Offered from its own /tour page (linked from the tool grid and the menu
// bar) and the Help / Demo view; loading the home page with ?tour=N starts
// it at step N.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SiteTour", ()=>SiteTour);
parcelHelpers.export(exports, "TourPage", ()=>TourPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reduxBundlerReact = require("redux-bundler-react");
var _reactRouterDom = require("react-router-dom");
var _reactBootstrap = require("react-bootstrap");
var _grameneSearchTour = require("gramene-search-tour");
var _tourCss = require("gramene-search-tour/dist/tour.css");
var _tourSteps = require("./tourSteps");
var _tourStepsDefault = parcelHelpers.interopDefault(_tourSteps);
// Bootstrap's success green, as on the search bar's help button.
const ACCENT = '#198754';
const SiteTourCmp = ({ configuration })=>configuration.tour ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _grameneSearchTour.GeneSearchTour), {
        buildSteps: (0, _tourStepsDefault.default),
        primaryColor: ACCENT
    }) : null;
const SiteTour = (0, _reduxBundlerReact.connect)('selectConfiguration', SiteTourCmp);
const chapters = (0, _grameneSearchTour.tourChapters)((0, _tourStepsDefault.default));
// /tour: the chapter list. The tour runs where the search bar is (the home
// page, or /gramene on a split-home build), so picking a chapter goes there
// with ?tour=<chapter step, 1-based>.
const TourPageCmp = ({ configuration })=>{
    const history = (0, _reactRouterDom.useHistory)();
    if (!configuration.tour) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Container), {
        style: {
            paddingTop: '20px',
            paddingBottom: '100px',
            maxWidth: '900px'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _grameneSearchTour.TourContents), {
            chapters: chapters,
            title: "Guided tour of the gene search",
            onStart: (index)=>history.push(`${configuration.splitHome ? '/gramene' : '/'}?tour=${index + 1}`)
        })
    });
};
const TourPage = (0, _reduxBundlerReact.connect)('selectConfiguration', TourPageCmp);

},{"react/jsx-runtime":"gonF6","react":"bmhQu","redux-bundler-react":"a9QVF","react-router-dom":"ditZI","react-bootstrap":[["Container","8Pton","default"]],"gramene-search-tour":"4bGdS","gramene-search-tour/dist/tour.css":"iwsfV","./tourSteps":"jNeV5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ditZI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryRouter", ()=>MemoryRouter);
parcelHelpers.export(exports, "Prompt", ()=>Prompt);
parcelHelpers.export(exports, "Redirect", ()=>Redirect);
parcelHelpers.export(exports, "Route", ()=>Route);
parcelHelpers.export(exports, "Router", ()=>Router);
parcelHelpers.export(exports, "StaticRouter", ()=>StaticRouter);
parcelHelpers.export(exports, "Switch", ()=>Switch);
parcelHelpers.export(exports, "__HistoryContext", ()=>historyContext);
parcelHelpers.export(exports, "__RouterContext", ()=>context);
parcelHelpers.export(exports, "generatePath", ()=>generatePath);
parcelHelpers.export(exports, "matchPath", ()=>matchPath);
parcelHelpers.export(exports, "useHistory", ()=>useHistory);
parcelHelpers.export(exports, "useLocation", ()=>useLocation);
parcelHelpers.export(exports, "useParams", ()=>useParams);
parcelHelpers.export(exports, "useRouteMatch", ()=>useRouteMatch);
parcelHelpers.export(exports, "withRouter", ()=>withRouter);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _history = require("history");
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _pathToRegexp = require("path-to-regexp");
var _pathToRegexpDefault = parcelHelpers.interopDefault(_pathToRegexp);
var _reactIs = require("react-is");
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var global = arguments[3];
var MAX_SIGNED_31_BIT_INT = 1073741823;
var commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof global !== "undefined" ? global // node.js
 : {};
function getUniqueId() {
    var key = "__global_unique_id__";
    return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, _inheritsLooseDefault.default)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if (objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, _reactDefault.default).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, _propTypesDefault.default).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, _inheritsLooseDefault.default)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, _reactDefault.default).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, _propTypesDefault.default).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var createContext = (0, _reactDefault.default).createContext || createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var createNamedContext = function createNamedContext(name) {
    var context = createContext();
    context.displayName = name;
    return context;
};
var historyContext = /*#__PURE__*/ createNamedContext("Router-History");
var context = /*#__PURE__*/ createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var Router = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(historyContext.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, _reactDefault.default).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var MemoryRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createMemoryHistory)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Router, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, _reactDefault.default).Component);
var Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, _reactDefault.default).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function Prompt(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var messageType;
var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;
function compilePath(path) {
    if (cache[path]) return cache[path];
    var generator = (0, _pathToRegexpDefault.default).compile(path);
    if (cacheCount < cacheLimit) {
        cache[path] = generator;
        cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function generatePath(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function Redirect(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, _history.createLocation)(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : (0, _extendsDefault.default)({}, to, {
            pathname: generatePath(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, _history.createLocation)(prevProps.to);
                if (!(0, _history.locationsAreEqual)(prevLocation, (0, _extendsDefault.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;
function compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, _pathToRegexpDefault.default)(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if (cacheCount$1 < cacheLimit$1) {
        pathCache[path] = result;
        cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function matchPath(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function isEmptyChildren(children) {
    return (0, _reactDefault.default).Children.count(children) === 0;
}
function evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var Route = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context$1) {
            !context$1 && (0, _tinyInvariantDefault.default)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? matchPath(location.pathname, _this.props) : context$1.match;
            var props = (0, _extendsDefault.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, _reactDefault.default).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, _reactDefault.default).Component);
function addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function addBasename(basename, location) {
    if (!basename) return location;
    return (0, _extendsDefault.default)({}, location, {
        pathname: addLeadingSlash(basename) + location.pathname
    });
}
function stripBasename(basename, location) {
    if (!basename) return location;
    var base = addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, _extendsDefault.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function createURL(location) {
    return typeof location === "string" ? location : (0, _history.createPath)(location);
}
function staticHandler(methodName) {
    return function() {
        (0, _tinyInvariantDefault.default)(false);
    };
}
function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var StaticRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return noop;
        };
        _this.handleBlock = function() {
            return noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = addBasename(basename, (0, _history.createLocation)(location));
        context.url = createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return addLeadingSlash(basename + createURL(path));
            },
            action: "POP",
            location: stripBasename(basename, (0, _history.createLocation)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: staticHandler("go"),
            goBack: staticHandler("goBack"),
            goForward: staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Router, (0, _extendsDefault.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, _reactDefault.default).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var Switch = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
            !context && (0, _tinyInvariantDefault.default)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, _reactDefault.default).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, _reactDefault.default).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? matchPath(location.pathname, (0, _extendsDefault.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, _reactDefault.default).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, _reactDefault.default).Component);
/**
 * A public higher-order component to access the imperative API
 */ function withRouter(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, _objectWithoutPropertiesLooseDefault.default)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
            !context && (0, _tinyInvariantDefault.default)(false);
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(Component, (0, _extendsDefault.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, _hoistNonReactStaticsDefault.default)(C, Component);
}
var useContext = (0, _reactDefault.default).useContext;
function useHistory() {
    return useContext(historyContext);
}
function useLocation() {
    return useContext(context).location;
}
function useParams() {
    var match = useContext(context).match;
    return match ? match.params : {};
}
function useRouteMatch(path) {
    var location = useLocation();
    var match = useContext(context).match;
    return path ? matchPath(location.pathname, path) : match;
}
var global$1, key, buildNames, initialBuildName, secondaryBuildName;

},{"@babel/runtime/helpers/esm/inheritsLoose":"hJ1FM","react":"bmhQu","prop-types":"gLXGb","history":"8rWTz","tiny-warning":"hu9ef","tiny-invariant":"7cMkC","@babel/runtime/helpers/esm/extends":"85Hd3","path-to-regexp":"h4pLf","react-is":"m2UGx","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"ds1mq","hoist-non-react-statics":"ldTzE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8rWTz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "createHashHistory", ()=>createHashHistory);
parcelHelpers.export(exports, "createMemoryHistory", ()=>createMemoryHistory);
parcelHelpers.export(exports, "createLocation", ()=>createLocation);
parcelHelpers.export(exports, "locationsAreEqual", ()=>locationsAreEqual);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
parcelHelpers.export(exports, "createPath", ()=>createPath);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _resolvePathname = require("resolve-pathname");
var _resolvePathnameDefault = parcelHelpers.interopDefault(_resolvePathname);
var _valueEqual = require("value-equal");
var _valueEqualDefault = parcelHelpers.interopDefault(_valueEqual);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
function addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
    return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function createPath(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function createLocation(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = parsePath(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, _extendsDefault.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, _resolvePathnameDefault.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function locationsAreEqual(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqualDefault.default)(a.state, b.state);
}
function createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';
function getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function createBrowserHistory(props) {
    if (props === void 0) props = {};
    !canUseDOM && (0, _tinyInvariantDefault.default)(false);
    var globalHistory = window.history;
    var canUseHistory = supportsHistory();
    var needsHashChangeListener = !supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = stripBasename(path, basename);
        return createLocation(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if (isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation(getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation(getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + createPath(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener(PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener(PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: stripLeadingSlash,
        decodePath: addLeadingSlash
    },
    slash: {
        encodePath: addLeadingSlash,
        decodePath: addLeadingSlash
    }
};
function stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function pushHashPath(path) {
    window.location.hash = path;
}
function replaceHashPath(path) {
    window.location.replace(stripHash(window.location.href) + '#' + path);
}
function createHashHistory(props) {
    if (props === void 0) props = {};
    !canUseDOM && (0, _tinyInvariantDefault.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath(getHashPath());
        if (basename) path = stripBasename(path, basename);
        return createLocation(path);
    }
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf(createPath(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        createPath(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = stripHash(window.location.href);
        return href + '#' + encodePath(basename + createPath(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = createLocation(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = createPath(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf(createPath(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = createLocation(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = createPath(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf(createPath(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener(HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function createMemoryHistory(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = createPath;
    function push(path, state) {
        var action = 'PUSH';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

},{"@babel/runtime/helpers/esm/extends":"85Hd3","resolve-pathname":"4Rnhm","value-equal":"a3ABJ","tiny-warning":"hu9ef","tiny-invariant":"7cMkC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4Rnhm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && isAbsolute(to);
    var isFromAbs = from && isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') spliceOne(fromParts, i);
        else if (part === '..') {
            spliceOne(fromParts, i);
            up++;
        } else if (up) {
            spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
exports.default = resolvePathname;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a3ABJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = valueOf(a);
        var bValue = valueOf(b);
        if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return valueEqual(a[key], b[key]);
        });
    }
    return false;
}
exports.default = valueEqual;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hu9ef":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var isProduction = true;
function warning(condition, message) {
    if (!isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
exports.default = warning;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7cMkC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>invariant);
var isProduction = true;
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) return;
    if (isProduction) throw new Error(prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h4pLf":[function(require,module,exports,__globalThis) {
var isarray = require("828472a1e168de2b");
/**
 * Expose `pathToRegexp`.
 */ module.exports = pathToRegexp;
module.exports.parse = parse;
module.exports.compile = compile;
module.exports.tokensToFunction = tokensToFunction;
module.exports.tokensToRegExp = tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? escapeGroup(pattern) : asterisk ? '.*' : restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + escapeString(delimiter) + ']+?';
    return escapeString(prevText) + '|(?:(?!' + escapeString(prevText) + ')[^' + escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function compile(str, options) {
    return tokensToFunction(parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if (isarray(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push(pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));
    return attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function stringToRegexp(path, keys, options) {
    return tokensToRegExp(parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function tokensToRegExp(tokens, keys, options) {
    if (!isarray(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += escapeString(token);
        else {
            var prefix = escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return attachKeys(new RegExp('^' + route, flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function pathToRegexp(path, keys, options) {
    if (!isarray(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return regexpToRegexp(path, /** @type {!Array} */ keys);
    if (isarray(path)) return arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

},{"828472a1e168de2b":"jE8lV"}],"jE8lV":[function(require,module,exports,__globalThis) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};

},{}],"m2UGx":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("f93b3bf7385544f5");

},{"f93b3bf7385544f5":"aEfEd"}],"aEfEd":[function(require,module,exports,__globalThis) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{}],"ldTzE":[function(require,module,exports,__globalThis) {
'use strict';
var reactIs = require("c03b486d83967636");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
    // React v16.11 and below
    if (reactIs.isMemo(component)) return MEMO_STATICS;
     // React v16.12 and above
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = hoistNonReactStatics;

},{"c03b486d83967636":"m2UGx"}],"4bGdS":[function(require,module,exports,__globalThis) {
// src/GeneSearchTour.jsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GeneSearchTour", ()=>GeneSearchTour_default);
parcelHelpers.export(exports, "TOUR_STORE_KEYS", ()=>TOUR_STORE_KEYS);
parcelHelpers.export(exports, "TourContents", ()=>TourContents);
parcelHelpers.export(exports, "callIfPresent", ()=>callIfPresent);
parcelHelpers.export(exports, "chaptersOf", ()=>chaptersOf);
parcelHelpers.export(exports, "createTourKit", ()=>createTourKit);
parcelHelpers.export(exports, "expressionSteps", ()=>expressionSteps);
parcelHelpers.export(exports, "geneSteps", ()=>geneSteps);
parcelHelpers.export(exports, "refineSteps", ()=>refineSteps);
parcelHelpers.export(exports, "resultSetSteps", ()=>resultSetSteps);
parcelHelpers.export(exports, "revealTarget", ()=>revealTarget);
parcelHelpers.export(exports, "scrollIntoPane", ()=>scrollIntoPane);
parcelHelpers.export(exports, "setToolsSteps", ()=>setToolsSteps);
parcelHelpers.export(exports, "sleep", ()=>sleep);
parcelHelpers.export(exports, "speciesTaxonId", ()=>speciesTaxonId);
parcelHelpers.export(exports, "startTour", ()=>startTour);
parcelHelpers.export(exports, "tourChapters", ()=>tourChapters);
parcelHelpers.export(exports, "viewsSteps", ()=>viewsSteps);
parcelHelpers.export(exports, "waitFor", ()=>waitFor);
parcelHelpers.export(exports, "waitForElement", ()=>waitForElement);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactJoyride = require("react-joyride");
var _reduxBundlerReact = require("redux-bundler-react");
var TOUR_PARAM = "tour";
var START_EVENT = "gene-search-tour:start";
var TOUR_Z_INDEX = 2e3;
var DEFAULT_TOC_INTRO = "A guided walk through the search interface. Start at the beginning, or jump to whichever part you need \u2014 each chapter sets up the search it needs.";
function chaptersOf(steps) {
    const out = [];
    steps.forEach((s, index)=>{
        if (s && s.chapter) out.push({
            index,
            title: s.chapter.title,
            blurb: s.chapter.blurb
        });
    });
    return out;
}
function tourChapters(buildSteps) {
    return chaptersOf(buildSteps(()=>({})));
}
function startTour(fromIndex = 0) {
    if (typeof window === "undefined") return;
    window.dispatchEvent(new CustomEvent(START_EVENT, {
        detail: {
            fromIndex
        }
    }));
}
var TourContents = ({ chapters, onStart = startTour, title = "Take the tour", intro = DEFAULT_TOC_INTRO })=>/* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        className: "gene-search-tour-toc"
    }, /* @__PURE__ */ (0, _reactDefault.default).createElement("h4", {
        className: "gene-search-tour-toc-title"
    }, title), /* @__PURE__ */ (0, _reactDefault.default).createElement("p", {
        className: "gene-search-tour-toc-intro"
    }, intro), /* @__PURE__ */ (0, _reactDefault.default).createElement("ol", {
        className: "gene-search-tour-toc-list"
    }, chapters.map((c)=>/* @__PURE__ */ (0, _reactDefault.default).createElement("li", {
            key: c.index
        }, /* @__PURE__ */ (0, _reactDefault.default).createElement("button", {
            type: "button",
            onClick: ()=>onStart(c.index)
        }, /* @__PURE__ */ (0, _reactDefault.default).createElement("span", {
            className: "gene-search-tour-toc-name"
        }, c.title), /* @__PURE__ */ (0, _reactDefault.default).createElement("span", {
            className: "gene-search-tour-toc-blurb"
        }, c.blurb))))));
var toJoyrideStep = ({ chapter, ...step })=>step;
function openMenus(node, out = []) {
    if (!node) return out;
    if (node.showMenu) out.push(node);
    (node.children || []).forEach((c)=>openMenus(c, out));
    return out;
}
function cleanUpAfterExit(props) {
    const { store, onExit } = props;
    if (store) {
        if (typeof store.doClearSuggestions === "function") store.doClearSuggestions();
        if (typeof store.doToggleGrameneFilterMenu === "function") openMenus(store.selectGrameneFilters && store.selectGrameneFilters()).forEach((node)=>store.doToggleGrameneFilterMenu(node));
    }
    if (typeof onExit === "function") onExit();
}
var GeneSearchTourCmp = (props)=>{
    const { buildSteps, primaryColor = "#a03e34", tocTitle, tocIntro, helpViewToc = true, debug = false } = props;
    const propsRef = (0, _react.useRef)(props);
    propsRef.current = props;
    const [steps, setSteps] = (0, _react.useState)([]);
    const [stepIndex, setStepIndex] = (0, _react.useState)(0);
    const [running, setRunning] = (0, _react.useState)(false);
    const [helpMount, setHelpMount] = (0, _react.useState)(null);
    const stop = (0, _react.useCallback)((exited)=>{
        setRunning(false);
        if (exited) cleanUpAfterExit(propsRef.current);
    }, []);
    const handleEvent = (0, _react.useCallback)((data)=>{
        const { type, status, action, index } = data;
        if (status === (0, _reactJoyride.STATUS).FINISHED || status === (0, _reactJoyride.STATUS).SKIPPED) {
            stop(status === (0, _reactJoyride.STATUS).SKIPPED);
            return;
        }
        if (type === (0, _reactJoyride.EVENTS).ERROR) console.warn("gene-search-tour: step", index, "skipped:", data.error || data);
        if (type === (0, _reactJoyride.EVENTS).STEP_AFTER || type === (0, _reactJoyride.EVENTS).TARGET_NOT_FOUND || type === (0, _reactJoyride.EVENTS).ERROR) setStepIndex(index + (action === (0, _reactJoyride.ACTIONS).PREV ? -1 : 1));
    }, [
        stop
    ]);
    const { Tour } = (0, _reactJoyride.useJoyride)({
        steps,
        continuous: true,
        run: running,
        // Controlled mode. The table of contents has to be able to open the tour at
        // an arbitrary chapter, and neither controls.start(n) nor initialStepIndex
        // survives the re-render that delivers the steps — owning the index here is
        // the only deterministic option.
        stepIndex,
        onEvent: handleEvent,
        debug,
        options: {
            primaryColor,
            textColor: "#333",
            zIndex: TOUR_Z_INDEX,
            showProgress: true,
            // No Skip link: the close box and Esc both end the tour.
            buttons: [
                "back",
                "primary",
                "close"
            ],
            closeButtonAction: "skip",
            // Joyride's Esc can only close a step (which advances the tour), and only
            // while a tooltip is up; the listener below exits instead, at any point.
            dismissKeyAction: false,
            spotlightPadding: 6,
            spotlightRadius: 4,
            // Open each step's tooltip straight away. Without this Joyride shows a
            // beacon (a dot the visitor must click) for the first step of a run —
            // invisible on the full tour, whose first step is placement:'center', but
            // it silently stalls every chapter started from the table of contents.
            skipBeacon: true,
            // The sidebar and results are independent scroll panes on these pages, so
            // each step scrolls its own pane in `before` (see utils) and Joyride
            // must not also try to scroll the window.
            skipScroll: true,
            // Views mount asynchronously after their toggle action, and some steps
            // run a search or load an expression study first.
            targetWaitTimeout: 15e3,
            beforeTimeout: 45e3,
            overlayColor: "rgba(0, 0, 0, 0.45)"
        },
        // `close` is the close box's aria-label and title (its tooltip).
        locale: {
            back: "Back",
            close: "Exit tour",
            last: "Done",
            next: "Next",
            skip: "Exit tour"
        }
    });
    (0, _react.useEffect)(()=>{
        if (!running) return void 0;
        const onKey = (e)=>{
            if (e.key === "Escape") stop(true);
        };
        document.addEventListener("keydown", onKey);
        return ()=>document.removeEventListener("keydown", onKey);
    }, [
        running,
        stop
    ]);
    const start = (0, _react.useCallback)((fromIndex = 0)=>{
        const all = propsRef.current.buildSteps(()=>propsRef.current).map(toJoyrideStep);
        setSteps(fromIndex > 0 ? all.slice(fromIndex) : all);
        setStepIndex(0);
        setRunning(true);
    }, []);
    (0, _react.useEffect)(()=>{
        if (typeof window === "undefined") return void 0;
        const onStart = (e)=>start(e.detail && e.detail.fromIndex || 0);
        window.addEventListener(START_EVENT, onStart);
        return ()=>window.removeEventListener(START_EVENT, onStart);
    }, [
        start
    ]);
    (0, _react.useEffect)(()=>{
        if (typeof window === "undefined") return;
        const url = new URL(window.location.href);
        const value = url.searchParams.get(TOUR_PARAM);
        if (value) {
            url.searchParams.delete(TOUR_PARAM);
            window.history.replaceState({}, "", url.toString());
            const n = parseInt(value, 10);
            start(Number.isFinite(n) && n > 1 ? n - 1 : 0);
        }
    }, []);
    const chapters = (0, _react.useMemo)(()=>tourChapters(buildSteps), [
        buildSteps
    ]);
    const viewsOn = props.grameneViewsOn;
    const helpViewOn = !!(helpViewToc && viewsOn && viewsOn.has && viewsOn.has("help"));
    const mountRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        const detach = ()=>{
            const node = mountRef.current;
            if (node && node.parentNode) node.parentNode.removeChild(node);
            mountRef.current = null;
        };
        if (!helpViewOn) {
            detach();
            setHelpMount(null);
            return void 0;
        }
        let cancelled = false;
        const attach = ()=>{
            if (cancelled) return;
            const section = document.querySelector('[data-tour-view="help"]');
            if (!section) return;
            let node = mountRef.current;
            if (!node || !node.isConnected) {
                node = document.createElement("div");
                node.className = "gene-search-tour-mount";
                mountRef.current = node;
            }
            const header = section.querySelector(".gramene-view-header");
            const anchor = header ? header.nextSibling : section.firstChild;
            if (node.parentNode !== section || node.previousSibling !== header) section.insertBefore(node, anchor);
            setHelpMount(node);
        };
        attach();
        const t = setTimeout(attach, 400);
        return ()=>{
            cancelled = true;
            clearTimeout(t);
        };
    }, [
        helpViewOn,
        viewsOn
    ]);
    (0, _react.useEffect)(()=>()=>{
            const node = mountRef.current;
            if (node && node.parentNode) node.parentNode.removeChild(node);
            mountRef.current = null;
        }, []);
    const toc = (0, _react.useMemo)(()=>helpViewOn && helpMount ? (0, _reactDom.createPortal)(/* @__PURE__ */ (0, _reactDefault.default).createElement(TourContents, {
            chapters,
            onStart: start,
            title: tocTitle,
            intro: tocIntro
        }), helpMount) : null, [
        helpViewOn,
        helpMount,
        chapters,
        start,
        tocTitle,
        tocIntro
    ]);
    return /* @__PURE__ */ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, toc, Tour);
};
var TOUR_STORE_KEYS = [
    "doClearGrameneFilters",
    "doReplaceGrameneFilters",
    "doAcceptGrameneSuggestion",
    "doChangeSuggestionsQuery",
    "doChangeSuggestionsTab",
    "doClearSuggestions",
    "doToggleGrameneView",
    "doToggleFacetCounts",
    "doExpandGeneDetail",
    "doSetHomologyViewer",
    "doSetExprVizActiveTaxon",
    "doSetExprVizFields",
    "doFetchExprVizData",
    "doSetExprVizVizMode",
    "doSetExprVizBrushes",
    "doSetOntologyEnrichmentActiveTaxon",
    "selectGrameneViewsOn",
    "selectGrameneFilters",
    "selectGrameneSearch",
    "selectGrameneFiltersStatus",
    "selectExprViz",
    "selectExpressionStudies",
    "selectExpressionSamples",
    "selectTargetTaxonId"
];
var WithStore = class extends (0, _reactDefault.default).Component {
    render() {
        return /* @__PURE__ */ (0, _reactDefault.default).createElement(GeneSearchTourCmp, {
            ...this.props,
            store: this.context.store
        });
    }
};
WithStore.contextTypes = {
    store: ()=>{}
};
var GeneSearchTour = (0, _reduxBundlerReact.connect)(...TOUR_STORE_KEYS, WithStore);
var GeneSearchTour_default = GeneSearchTour;
// src/utils.js
function waitForElement(selector, { timeout = 8e3, interval = 100 } = {}) {
    return new Promise((resolve)=>{
        const found = document.querySelector(selector);
        if (found) return resolve(found);
        const started = Date.now();
        const tick = setInterval(()=>{
            const el = document.querySelector(selector);
            if (el) {
                clearInterval(tick);
                resolve(el);
            } else if (Date.now() - started >= timeout) {
                clearInterval(tick);
                resolve(null);
            }
        }, interval);
    });
}
function waitFor(predicate, { timeout = 8e3, interval = 100 } = {}) {
    return new Promise((resolve)=>{
        const first = predicate();
        if (first) return resolve(first);
        const started = Date.now();
        const tick = setInterval(()=>{
            const v = predicate();
            if (v) {
                clearInterval(tick);
                resolve(v);
            } else if (Date.now() - started >= timeout) {
                clearInterval(tick);
                resolve(void 0);
            }
        }, interval);
    });
}
var sleep = (ms)=>new Promise((r)=>setTimeout(r, ms));
function scrollableAncestor(el) {
    let node = el.parentElement;
    while(node){
        const oy = window.getComputedStyle(node).overflowY;
        if ((oy === "auto" || oy === "scroll") && node.scrollHeight > node.clientHeight) return node;
        node = node.parentElement;
    }
    return null;
}
function isPinned(el) {
    for(let node = el; node && node !== document.body; node = node.parentElement){
        const pos = window.getComputedStyle(node).position;
        if (pos === "sticky" || pos === "fixed") return true;
    }
    return false;
}
function pinnedHeaderHeight() {
    let bottom = 0;
    document.querySelectorAll(".sticky-top, .fixed-top").forEach((h)=>{
        const r = h.getBoundingClientRect();
        if (r.top <= 0 && r.bottom > bottom) bottom = r.bottom;
    });
    return bottom;
}
function scrollIntoPane(target, { block = "center", margin = 16 } = {}) {
    const el = typeof target === "string" ? document.querySelector(target) : target;
    if (!el) return null;
    const pane = scrollableAncestor(el);
    const elRect = el.getBoundingClientRect();
    if (pane) {
        const paneRect = pane.getBoundingClientRect();
        const offset = elRect.top - paneRect.top + pane.scrollTop;
        const raw = block === "center" ? offset - Math.max(0, (pane.clientHeight - elRect.height) / 2) : offset - margin;
        const top2 = Math.max(0, Math.min(raw, pane.scrollHeight - pane.clientHeight));
        if (isPinned(pane) && window.scrollY > 0) window.scrollTo({
            top: 0
        });
        pane.scrollTo({
            top: top2,
            behavior: "smooth"
        });
        return {
            pane,
            top: top2
        };
    }
    if (isPinned(el)) {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        return {
            pane: null,
            top: 0
        };
    }
    const header = pinnedHeaderHeight();
    const top = block === "center" ? Math.max(0, elRect.top + window.scrollY - header - Math.max(0, (window.innerHeight - header - elRect.height) / 2)) : Math.max(0, elRect.top + window.scrollY - header - margin);
    window.scrollTo({
        top,
        behavior: "smooth"
    });
    return {
        pane: null,
        top
    };
}
async function settleScroll(plan, { timeout = 1500 } = {}) {
    if (!plan) return;
    const read = ()=>plan.pane ? plan.pane.scrollTop : window.scrollY;
    const started = Date.now();
    let last = read();
    let stillCount = 0;
    while(Date.now() - started < timeout){
        await sleep(80);
        const now = read();
        if (Math.abs(now - plan.top) <= 2) return;
        if (Math.abs(now - last) < 1) {
            if (++stillCount >= 3) break;
        } else stillCount = 0;
        last = now;
    }
    if (plan.pane) plan.pane.scrollTop = plan.top;
    else window.scrollTo(0, plan.top);
}
async function revealTarget(target, opts = {}) {
    let el = null;
    if (typeof target === "string") el = await waitForElement(target, opts);
    else if (typeof target === "function") el = await waitFor(()=>target(), opts);
    else el = target;
    if (!el) return false;
    await settleScroll(scrollIntoPane(el, opts));
    if (opts.settle) await sleep(opts.settle);
    return true;
}
function callIfPresent(fn, ...args) {
    if (typeof fn === "function") {
        fn(...args);
        return true;
    }
    return false;
}
// src/kit.js
function speciesTaxonId(tid) {
    const n = +tid;
    return n > 1e6 ? Math.floor(n / 1e3) : n;
}
function filterValues(node, out = []) {
    if (!node) return out;
    if (node.fq_value !== void 0) out.push(String(node.fq_value));
    (node.children || []).forEach((c)=>filterValues(c, out));
    return out;
}
function createTourKit(getProps, config) {
    const { prefix = "gramene", taxon, fallbackTaxon } = config;
    const defaultSearch = [].concat(config.search || []);
    const act = (name, ...args)=>{
        const { store, [name]: connected } = getProps();
        if (store) return callIfPresent(typeof store[name] === "function" && store[name].bind(store), ...args);
        return callIfPresent(connected, ...args);
    };
    const cls = (name)=>`.${prefix}-${name}`;
    const referenceTaxon = ()=>String(taxon || getProps().targetTaxonId || fallbackTaxon);
    const viewIsOn = (viewId)=>{
        const on = getProps().grameneViewsOn;
        return !!(on && on.has && on.has(viewId));
    };
    const ensureView = async (viewId, selector, timeout = 15e3)=>{
        if (!viewIsOn(viewId)) act("doToggleGrameneView", viewId);
        return selector ? !!await waitForElement(selector, {
            timeout
        }) : true;
    };
    const ensureSearch = async (filters = defaultSearch)=>{
        const want = filters.map((f)=>String(f.fq_value));
        const have = filterValues(getProps().grameneFilters);
        if ([
            ...want
        ].sort().join("\0") !== [
            ...have
        ].sort().join("\0")) {
            const current = getProps().grameneFilters || {};
            act("doReplaceGrameneFilters", {
                status: "init",
                operation: "AND",
                negate: false,
                marked: false,
                showMarked: false,
                showMenu: false,
                moveCopyMode: "",
                searchOffset: 0,
                rows: current.rows || 20,
                leftIdx: 0,
                rightIdx: 2 * filters.length + 1,
                children: filters.map((f, i)=>({
                        ...f,
                        leftIdx: 2 * i + 1,
                        rightIdx: 2 * i + 2,
                        negate: false,
                        marked: false,
                        showMenu: false
                    }))
            });
        }
        const res = await waitFor(()=>{
            const r = getProps().grameneSearch;
            if (!(r && r.response && r.response.numFound > 0)) return null;
            const params = JSON.stringify(r.responseHeader && r.responseHeader.params || "");
            const matches = filters.every((f)=>params.indexOf(f.fq_field) !== -1 && params.indexOf(String(f.fq_value)) !== -1);
            return matches ? r : null;
        }, {
            timeout: 25e3
        });
        return !!res;
    };
    const findSuggestion = (label)=>{
        const buttons = document.querySelectorAll(".search-suggestions button");
        for (const b of buttons){
            const text = (b.textContent || "").replace(/\s+/g, " ").trim();
            if (text.indexOf(label) === 0) return b;
        }
        return null;
    };
    const filterNode = (label)=>[
            ...document.querySelectorAll(".gramene-filter-text")
        ].find((n)=>(n.textContent || "").indexOf(label) !== -1) || null;
    const openFilterMenu = async (label)=>{
        if (!document.querySelector(".gramene-filter-menu")) {
            const node = filterNode(label);
            if (!node) return null;
            node.click();
            await waitForElement(".gramene-filter-menu", {
                timeout: 4e3
            }).catch(()=>null);
        }
        return document.querySelector(".gramene-filter-menu");
    };
    const closeFilterMenu = (label)=>{
        const node = filterNode(label);
        if (node && document.querySelector(".gramene-filter-menu")) node.click();
    };
    const pickExpansion = async (filterLabel, option, dwell = 1200)=>{
        const menu = await openFilterMenu(filterLabel);
        if (!menu) return false;
        const row = [
            ...menu.querySelectorAll(".gramene-filter-menu-radio")
        ].find((li)=>(li.textContent || "").toLowerCase().indexOf(option) !== -1);
        if (!row) return false;
        const before = (getProps().grameneSearch || {}).response;
        const beforeCount = before ? before.numFound : null;
        row.click();
        await waitFor(()=>{
            const r = getProps().grameneSearch;
            const n = r && r.response ? r.response.numFound : null;
            return n !== null && n !== beforeCount ? n : null;
        }, {
            timeout: 8e3
        }).catch(()=>null);
        await waitFor(()=>getProps().grameneFiltersStatus === "ready" ? true : null, {
            timeout: 8e3
        }).catch(()=>null);
        await sleep(dwell);
        return true;
    };
    const clearExpansion = async (filterLabel)=>{
        const menu = await openFilterMenu(filterLabel);
        if (!menu) return false;
        const checked = [
            ...menu.querySelectorAll(".gramene-filter-menu-radio")
        ].find((li)=>{
            const radio = li.querySelector("input[type=radio]");
            return radio && radio.checked;
        });
        if (!checked) return true;
        checked.click();
        await waitFor(()=>document.querySelector(".gramene-filter-expansion") ? null : true, {
            timeout: 8e3
        }).catch(()=>null);
        return true;
    };
    const findGeneCard = (geneId)=>{
        const cards = document.querySelectorAll(".result-gene");
        for (const c of cards){
            if ((c.textContent || "").indexOf(geneId) !== -1) return c;
        }
        return null;
    };
    const inGeneCard = (geneId, selector)=>{
        const c = findGeneCard(geneId);
        return c ? c.querySelector(selector) : null;
    };
    const exprVizActive = (selector)=>{
        const pane = document.querySelector(".exprviz-view .tab-pane.active");
        return pane ? pane.querySelector(selector) : null;
    };
    const waitForExprVizReady = async (timeout = 3e4)=>{
        const ev = await waitFor(()=>{
            const v = getProps().exprViz;
            const pivot = v && v.pivot;
            return pivot && pivot.status === "ready" && Object.keys(pivot.data || {}).length ? v : null;
        }, {
            timeout
        });
        return !!ev;
    };
    const loadExpression = async (taxon2 = referenceTaxon())=>{
        const mounted = await ensureView("exprViz", ".exprviz-view", 2e4);
        if (!mounted) return null;
        if (!await waitForExprVizReady()) return null;
        act("doSetExprVizActiveTaxon", taxon2);
        act("doSetExprVizVizMode", taxon2, "heatmap");
        act("doSetExprVizBrushes", taxon2, {});
        const studies = await waitFor(()=>{
            const all = getProps().expressionStudies;
            const list = all && (all[taxon2] || all[speciesTaxonId(taxon2)]);
            return list && list.length ? list : null;
        }, {
            timeout: 25e3
        });
        if (!studies) return null;
        const samplesByStudy = getProps().expressionSamples || {};
        const fieldsFor = (s)=>{
            const samples = samplesByStudy[s._id];
            if (!samples || !samples.length) return [];
            const firstPerGroup = {};
            samples.forEach((x)=>{
                if (!firstPerGroup[x.group]) firstPerGroup[x.group] = x;
            });
            return Object.keys(firstPerGroup).map((g)=>`${String(s._id).replace(/-/g, "_")}_${g}__expr`);
        };
        const candidates = studies.map((s)=>({
                s,
                fields: fieldsFor(s)
            })).filter((c)=>c.fields.length);
        if (!candidates.length) return null;
        const readable = candidates.filter((c)=>c.fields.length >= 4 && c.fields.length <= 24);
        const baseline = readable.filter((c)=>/baseline/i.test(c.s.type || ""));
        const pool = baseline.length ? baseline : readable.length ? readable : candidates;
        const best = pool.reduce((a, b)=>b.fields.length > a.fields.length ? b : a);
        act("doSetExprVizFields", taxon2, best.fields);
        act("doFetchExprVizData", taxon2);
        const loaded = await waitFor(()=>{
            const ev = getProps().exprViz;
            const t = ev && ev.byTaxon && ev.byTaxon[taxon2];
            return t && t.rows && t.rows.length ? t : null;
        }, {
            timeout: 3e4
        });
        if (!loaded) return null;
        return {
            taxon: taxon2,
            study: best.s,
            fields: best.fields
        };
    };
    const brushTopOfFirstAxis = (taxon2, fields)=>{
        const ev = getProps().exprViz;
        const t = ev && ev.byTaxon && ev.byTaxon[taxon2];
        if (!t || !t.rows || !fields || !fields.length) return false;
        const field = fields[0];
        const values = t.rows.map((r)=>+r[field]).filter((v)=>Number.isFinite(v)).sort((a, b)=>a - b);
        if (values.length < 3) return false;
        const hi = values[values.length - 1];
        const lo = values[Math.floor(values.length * 0.66)];
        if (!(hi > lo)) return false;
        act("doSetExprVizBrushes", taxon2, {
            [field]: [
                lo,
                hi
            ]
        });
        return true;
    };
    return {
        getProps,
        act,
        cls,
        search: defaultSearch,
        referenceTaxon,
        viewIsOn,
        ensureView,
        ensureSearch,
        findSuggestion,
        filterNode,
        openFilterMenu,
        closeFilterMenu,
        pickExpansion,
        clearExpansion,
        findGeneCard,
        inGeneCard,
        exprVizActive,
        waitForExprVizReady,
        loadExpression,
        brushTopOfFirstAxis
    };
}
// src/steps.js
var applyCopy = (steps, copy = {})=>steps.map(({ key, ...step })=>copy[key] ? {
            ...step,
            ...copy[key]
        } : step);
var withChapter = (steps, chapter)=>chapter ? [
        {
            ...steps[0],
            chapter
        },
        ...steps.slice(1)
    ] : steps;
var roomAbove = (max, frac)=>Math.min(max, Math.round(window.innerHeight * frac));
function resultSetSteps(kit, { chapter, filterLabel, enter, copy } = {}) {
    const sidebar = kit.cls("sidebar");
    const filterContainer = kit.cls("filter-container");
    const menuOrFilters = ()=>document.querySelector(".gramene-filter-menu") || document.querySelector(filterContainer);
    const expansionBefore = (option)=>async ()=>{
            if (!await kit.ensureSearch()) return false;
            await revealTarget(filterContainer, {
                block: "start"
            });
            await kit.pickExpansion(filterLabel, option, 0);
            return !!await kit.openFilterMenu(filterLabel);
        };
    const steps = [
        {
            key: "panel",
            target: sidebar,
            placement: "right",
            title: "The search panel",
            content: `Accepting a suggestion runs the search. The left panel is now the state of that search: how many genes matched, the filters that produced them, and the views available to explore them.`,
            before: async ()=>{
                if (enter) await enter();
                if (!await kit.ensureSearch()) return false;
                await kit.ensureView("taxTree", ".results-vis");
                await kit.ensureView("list", ".result-gene");
                return revealTarget(sidebar, {
                    block: "start"
                });
            }
        },
        {
            key: "distribution",
            target: ".results-vis",
            placement: "bottom",
            title: "Where the matches are",
            content: `The top of the results shows how the matching genes are distributed across the species tree and along the genome \u2014 a quick read on whether a result set is broad or concentrated.`,
            before: async ()=>{
                await kit.clearExpansion(filterLabel);
                return revealTarget(".results-vis", {
                    block: "start"
                });
            }
        },
        {
            key: "filters",
            target: filterContainer,
            placement: "right",
            title: "Filters build the query",
            // Don't inherit the previous step's scroll position — stepping Back
            // arrives here with the sidebar scrolled elsewhere.
            before: async ()=>revealTarget(filterContainer, {
                    block: "start"
                }),
            content: `The term you accepted is now a filter, shown as "category | value". Filters combine with AND by default, so you can keep adding terms \u2014 a species, an expression class, a gene list \u2014 to narrow the set. Click one to negate it, switch AND/OR, or remove it.`
        },
        {
            // Intro: open the menu and explain the idea, but change nothing yet.
            key: "expand",
            target: menuOrFilters,
            placement: "right",
            title: "Expand the search",
            content: `Filters only ever narrow the search. "Expand search" grows it along a biological relationship instead: the genes you matched become the starting point, and the result is those genes plus everything reachable from them. There are three ways to do it \u2014 orthologs, paralogs and neighborhood. We take them one at a time; watch the gene count and taxonomic distribution as each is applied.`,
            before: async ()=>{
                if (!await kit.ensureSearch()) return false;
                await revealTarget(filterContainer, {
                    block: "start"
                });
                await kit.clearExpansion(filterLabel);
                return !!await kit.openFilterMenu(filterLabel);
            }
        },
        {
            key: "orthologs",
            target: menuOrFilters,
            placement: "right",
            title: "Expand by orthologs",
            content: `Orthologs are the equivalent genes in other genomes. This keeps every gene you already had and adds their counterparts in the other species, so the count climbs and the set spreads out across the species tree.`,
            before: expansionBefore("orthologs")
        },
        {
            key: "paralogs",
            target: menuOrFilters,
            placement: "right",
            title: "Expand by paralogs",
            content: `Paralogs stay inside a single genome \u2014 copies that arose by duplication rather than speciation. These are radio options, so picking paralogs switches straight from orthologs: the count changes in character as well as in size.`,
            before: expansionBefore("paralogs")
        },
        {
            key: "neighborhood",
            target: menuOrFilters,
            placement: "right",
            title: "Expand by neighborhood",
            content: `Neighborhood takes the ten genes either side of each match along the chromosome \u2014 genomic context rather than homology. Picking the selected option again clears it, which is what happens as we leave this step, so the rest of the tour runs on the plain search.`,
            before: expansionBefore("neighborhood"),
            after: async ()=>{
                await kit.clearExpansion(filterLabel);
                kit.closeFilterMenu(filterLabel);
            }
        },
        {
            key: "geneList",
            target: ".result-gene",
            placement: "top",
            title: "The gene list",
            content: `Below the taxonomic distribution is the paginated list of matching genes, each with its species, identifiers and description.`,
            before: async ()=>revealTarget(".result-gene", {
                    block: "start"
                })
        }
    ];
    return withChapter(applyCopy(steps, copy), chapter);
}
function geneSteps(kit, { chapter, gene, search, copy } = {}) {
    const card = ()=>kit.findGeneCard(gene);
    const inCard = (selector)=>()=>kit.inGeneCard(gene, selector);
    const steps = [
        {
            key: "card",
            target: card,
            placement: "top",
            title: `${gene} is one of these genes`,
            content: `Let's look at the evidence behind ${gene}.`,
            before: async ()=>{
                await kit.ensureSearch(search);
                await kit.ensureView("list", ".result-gene");
                const c = await waitFor(card, {
                    timeout: 15e3
                });
                if (!c) return false;
                return revealTarget(c, {
                    block: "start"
                });
            }
        },
        {
            key: "tabs",
            target: inCard(".gene-detail-tabs"),
            placement: "top",
            title: "Evidence for each gene",
            content: `Each gene carries a row of tabs \u2014 Sequences, Location, Expression, Homology, Pathways, Papers, Xrefs and more. A tab is only offered when that evidence exists for the gene.`,
            before: async ()=>{
                const tabs = kit.inGeneCard(gene, ".gene-detail-tabs");
                if (!tabs) return false;
                return revealTarget(tabs, {
                    block: "center"
                });
            }
        },
        {
            key: "pathways",
            target: inCard(".pathways-container"),
            placement: "top",
            title: "Pathways: where the gene acts",
            content: `The tree on the left lists every Plant Reactome pathway and reaction the gene takes part in; the diagram shows the selected one with the gene flagged.`,
            before: async ()=>{
                await kit.ensureSearch(search);
                if (!await waitFor(card, {
                    timeout: 15e3
                })) return false;
                kit.act("doExpandGeneDetail", {
                    geneId: gene,
                    detail: "pathways"
                });
                const tree = await waitFor(inCard(".pathways-tree-panel .rstm-tree-item--active, .pathways-tree-empty"), {
                    timeout: 2e4
                });
                if (!tree) return false;
                await waitFor(()=>{
                    const frame = kit.inGeneCard(gene, ".pathways-diagram-panel iframe");
                    const doc = frame && frame.contentDocument;
                    return doc ? doc.querySelector("#holder canvas") : null;
                }, {
                    timeout: 1e4
                });
                return revealTarget(inCard(".pathways-container"), {
                    block: "start",
                    margin: roomAbove(320, 0.36),
                    settle: 800
                });
            }
        },
        {
            key: "tree",
            target: inCard(".gene-genetree"),
            placement: "top",
            title: "TBrowse: the gene family tree",
            content: `Opening Homology draws the gene family tree in TBrowse and the multiple sequence alignment zone (MSA). Click a triangle to expand or collapse a branch, or a gene name for more details. Protein domains are color coded; zoom in to the amino acid sequence level. `,
            before: async ()=>{
                kit.act("doExpandGeneDetail", {
                    geneId: gene,
                    detail: "homology"
                });
                kit.act("doSetHomologyViewer", {
                    geneId: gene,
                    viewer: "tbrowse"
                });
                const tree = await waitFor(inCard(".gene-genetree"), {
                    timeout: 2e4
                });
                if (!tree) return false;
                return revealTarget(tree, {
                    block: "start",
                    settle: 700
                });
            }
        },
        {
            key: "zones",
            target: inCard(".gene-genetree"),
            placement: "bottom",
            title: "Explore regional and functional conservation",
            content: `Switch between zones: Neighborhood to compare \xB110 flanking genes, and Expression to read an organ-level heatmap for genes with expression data.`,
            before: async ()=>{
                const zone = await waitFor(inCard(".gene-genetree .tbrowse-zone-toggle"), {
                    timeout: 15e3
                });
                if (!zone) return false;
                return revealTarget(zone, {
                    block: "start"
                });
            }
        }
    ];
    return withChapter(applyCopy(steps, copy), chapter);
}
function refineSteps(kit, { chapter, copy } = {}) {
    const container = kit.cls("facet-container");
    const steps = [
        {
            key: "refine",
            target: container,
            placement: "right",
            title: "Refine: what else is in this set",
            content: `Refine counts your current results by category, so you can see what you have before narrowing further. It stays collapsed until you open it, and the counts always describe the search in front of you. The number beside each value is how many of your genes match it \u2014 click it and that becomes a new filter, ANDed onto the search.`,
            before: async ()=>{
                await kit.ensureSearch();
                kit.act("doToggleFacetCounts", true);
                await waitForElement(".facet-count", {
                    timeout: 2e4
                });
                return revealTarget(container, {
                    block: "start"
                });
            }
        }
    ];
    return withChapter(applyCopy(steps, copy), chapter);
}
function viewsSteps(kit, { chapter, copy } = {}) {
    const steps = [
        {
            key: "views",
            target: ".gramene-view-container",
            placement: "right",
            title: "Views sidebar panel",
            content: `The same result set can be read many ways. Toggle a view on to add it to the results column; click its name to jump straight to it.`,
            before: async ()=>{
                await kit.ensureSearch();
                return revealTarget(".gramene-view-container", {
                    block: "start"
                });
            }
        },
        {
            key: "attrTable",
            target: ".attrtable-aggrid",
            placement: "top",
            title: "Gene attributes",
            content: `Gene attributes puts the whole result set in one sortable table \u2014 maximum expression, an organ-level heatmap, expression class, and the conditions that activate or repress each gene. Click any cell to filter the search on that value.`,
            before: async ()=>{
                const ok = await kit.ensureView("attrTable", ".attrtable-aggrid");
                if (!ok) {
                    if (kit.viewIsOn("attrTable")) kit.act("doToggleGrameneView", "attrTable");
                    return false;
                }
                return revealTarget(".attrtable-aggrid", {
                    block: "start",
                    margin: roomAbove(360, 0.42),
                    settle: 700
                });
            }
        }
    ];
    return withChapter(applyCopy(steps, copy), chapter);
}
function expressionSteps(kit, { chapter, copy } = {}) {
    let exprInfo = null;
    const steps = [
        {
            key: "exprViz",
            target: ".exprviz-view",
            placement: "center",
            title: "Expression visualization",
            content: `Expression data is per genome, so this view opens on a tab per genome in your results. We've picked the reference genome, and now need to choose which samples to plot.`,
            before: async ()=>{
                await kit.ensureSearch();
                const ok = await kit.ensureView("exprViz", ".exprviz-view", 2e4);
                if (!ok) return false;
                if (!await kit.waitForExprVizReady()) return false;
                kit.act("doSetExprVizActiveTaxon", kit.referenceTaxon());
                return revealTarget(".exprviz-view", {
                    block: "start",
                    settle: 600
                });
            }
        },
        {
            key: "heatmap",
            target: ()=>kit.exprVizActive(".exprviz-hm-container"),
            placement: "center",
            title: "Pick samples, then load",
            content: `Choose fields to add sample columns \u2014 grouped by study, so you can take a whole experiment at once \u2014 then press Load data. We've loaded one study: each row is a gene, each column a sample, and the color is its expression level. Hover any cell for the sample's study, group and factors.`,
            before: async ()=>{
                const loaded = await kit.loadExpression();
                if (!loaded) return false;
                exprInfo = loaded;
                const hm = await waitFor(()=>kit.exprVizActive(".exprviz-hm-container"), {
                    timeout: 2e4
                });
                if (!hm) return false;
                return revealTarget(hm, {
                    block: "start",
                    settle: 800
                });
            }
        },
        {
            key: "parallel",
            target: ()=>kit.exprVizActive(".exprviz-pc-container"),
            placement: "top",
            title: "Or read it as parallel coordinates",
            content: `The same data, drawn as one line per gene across an axis per sample. Genes that track together stay parallel; a gene that spikes in one condition crosses the others. Axes can be dragged to reorder them.`,
            before: async ()=>{
                if (!exprInfo) return false;
                kit.act("doSetExprVizVizMode", exprInfo.taxon, "parallel");
                const pc = await waitFor(()=>kit.exprVizActive(".exprviz-pc-container"), {
                    timeout: 2e4
                });
                if (!pc) return false;
                return revealTarget(pc, {
                    block: "start",
                    settle: 800
                });
            }
        },
        {
            key: "brush",
            target: ()=>kit.exprVizActive(".exprviz-pc-container"),
            placement: "top",
            title: "Brush an axis to filter",
            content: `Drag along any axis to keep only the genes falling in that range \u2014 we've brushed the top of the first sample. Brushes on several axes intersect, so you can isolate genes that are high in one condition and low in another, then turn that selection into a search filter.`,
            before: async ()=>{
                if (!exprInfo) return false;
                kit.brushTopOfFirstAxis(exprInfo.taxon, exprInfo.fields);
                await sleep(600);
                const pc = kit.exprVizActive(".exprviz-pc-container");
                if (!pc) return false;
                return revealTarget(pc, {
                    block: "start",
                    settle: 600
                });
            }
        }
    ];
    return withChapter(applyCopy(steps, copy), chapter);
}
function setToolsSteps(kit, { chapter, copy } = {}) {
    const auth = kit.cls("auth-container");
    const steps = [
        {
            key: "enrichment",
            target: ".oe-view",
            placement: "top",
            title: "Ontology Enrichment",
            content: `Enrichment asks which GO, Plant Ontology or Trait Ontology terms turn up in your results more often than chance would predict, with fold enrichment and an adjusted p-value for each. Pick the species on the left \u2014 we've selected the reference genome.`,
            before: async ()=>{
                await kit.ensureSearch();
                const ok = await kit.ensureView("ontologyEnrichment", ".oe-view", 2e4);
                if (!ok) return false;
                kit.act("doSetOntologyEnrichmentActiveTaxon", kit.referenceTaxon());
                await waitFor(()=>{
                    const panel = document.querySelector(".oe-panel");
                    return panel && /Foreground:/.test(panel.textContent || "") ? panel : null;
                }, {
                    timeout: 3e4
                });
                return revealTarget(".oe-view", {
                    block: "start",
                    settle: 700
                });
            }
        },
        {
            key: "userLists",
            target: '[data-tour-view="userLists"]',
            placement: "top",
            title: "User Gene Lists",
            content: `Bring your own genes. Paste or drop a list of IDs on the left and they're checked against the database; sign in to save the list, privately or publicly. Saved lists \u2014 yours and any made public \u2014 appear on the right: View turns one into a "Gene List" filter you can combine with other terms. Deleted lists wait in Trash for 30 days.`,
            before: async ()=>{
                if (!document.querySelector('[data-tour-view="userLists"]')) return false;
                const ok = await kit.ensureView("userLists", ".gene-list-display-component");
                if (!ok) {
                    if (kit.viewIsOn("userLists")) kit.act("doToggleGrameneView", "userLists");
                    return false;
                }
                return revealTarget('[data-tour-view="userLists"]', {
                    block: "start",
                    margin: roomAbove(360, 0.42),
                    settle: 500
                });
            }
        },
        {
            key: "export",
            target: ".exporter-view",
            placement: "top",
            title: "Data exporter",
            content: `Anything you can search, you can take with you: pick the fields you want and export the result set as a table.`,
            before: async ()=>{
                const ok = await kit.ensureView("export", ".exporter-view");
                if (!ok) return false;
                return revealTarget(".exporter-view", {
                    block: "start",
                    settle: 500
                });
            }
        },
        {
            key: "auth",
            target: auth,
            placement: "right",
            title: "Keep what you built",
            content: `Sign in to save a search \u2014 filters, views and open tabs \u2014 as a link you can share or return to.`,
            before: async ()=>revealTarget(auth, {
                    block: "start"
                })
        }
    ];
    return withChapter(applyCopy(steps, copy), chapter);
}

},{"react":"bmhQu","react-dom":"82aNB","react-joyride":"8Vd88","redux-bundler-react":"a9QVF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8Vd88":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
//#endregion
parcelHelpers.export(exports, "ACTIONS", ()=>ACTIONS);
parcelHelpers.export(exports, "EVENTS", ()=>EVENTS);
parcelHelpers.export(exports, "Joyride", ()=>Joyride);
parcelHelpers.export(exports, "LIFECYCLE", ()=>LIFECYCLE);
parcelHelpers.export(exports, "ORIGIN", ()=>ORIGIN);
parcelHelpers.export(exports, "PORTAL_ELEMENT_ID", ()=>PORTAL_ELEMENT_ID);
parcelHelpers.export(exports, "STATUS", ()=>STATUS);
parcelHelpers.export(exports, "defaultLocale", ()=>defaultLocale);
parcelHelpers.export(exports, "defaultOptions", ()=>defaultOptions);
parcelHelpers.export(exports, "useJoyride", ()=>useJoyride);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _hooks = require("@gilbarbara/hooks");
var _shim = require("use-sync-external-store/shim");
var _isLite = require("is-lite");
var _isLiteDefault = parcelHelpers.interopDefault(_isLite);
var _reactInnertext = require("react-innertext");
var _reactInnertextDefault = parcelHelpers.interopDefault(_reactInnertext);
var _deepmerge = require("@fastify/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _deepEqual = require("@gilbarbara/deep-equal");
var _deepEqualDefault = parcelHelpers.interopDefault(_deepEqual);
var _scroll = require("scroll");
var _scrollDefault = parcelHelpers.interopDefault(_scroll);
var _scrollparent = require("scrollparent");
var _scrollparentDefault = parcelHelpers.interopDefault(_scrollparent);
var _reactDom = require("react-dom");
var _reactDom1 = require("@floating-ui/react-dom");
'use client';
//#region src/defaults.ts
const defaultOptions = {
    arrowBase: 32,
    arrowColor: "#ffffff",
    arrowSize: 16,
    arrowSpacing: 12,
    backgroundColor: "#ffffff",
    beaconSize: 36,
    beaconTrigger: "click",
    beforeTimeout: 5e3,
    blockTargetInteraction: false,
    buttons: [
        "back",
        "close",
        "primary"
    ],
    closeButtonAction: "close",
    disableFocusTrap: false,
    dismissKeyAction: "close",
    hideOverlay: false,
    loaderDelay: 300,
    offset: 10,
    overlayClickAction: "close",
    overlayColor: "#00000080",
    primaryColor: "#000000",
    scrollDuration: 300,
    scrollOffset: 20,
    showProgress: false,
    skipBeacon: false,
    skipScroll: false,
    spotlightPadding: 10,
    spotlightRadius: 4,
    targetWaitTimeout: 1e3,
    textColor: "#000000",
    width: 380,
    zIndex: 100
};
const defaultFloatingOptions = {
    beaconOptions: {
        offset: -18
    }
};
const defaultLocale = {
    back: "Back",
    close: "Close",
    last: "Last",
    next: "Next",
    nextWithProgress: "Next ({current} of {total})",
    open: "Open the dialog",
    skip: "Skip"
};
const defaultStep = {
    isFixed: false,
    locale: defaultLocale,
    placement: "bottom"
};
const defaultProps = {
    continuous: false,
    debug: false,
    run: false,
    scrollToFirstStep: false,
    steps: []
};
//#endregion
//#region src/literals/index.ts
const ACTIONS = {
    INIT: "init",
    START: "start",
    STOP: "stop",
    RESET: "reset",
    PREV: "prev",
    NEXT: "next",
    GO: "go",
    CLOSE: "close",
    SKIP: "skip",
    REPLAY: "replay",
    UPDATE: "update",
    COMPLETE: "complete"
};
const EVENTS = {
    TOUR_START: "tour:start",
    STEP_BEFORE_HOOK: "step:before_hook",
    STEP_BEFORE: "step:before",
    SCROLL_START: "scroll:start",
    SCROLL_END: "scroll:end",
    BEACON: "beacon",
    TOOLTIP: "tooltip",
    STEP_AFTER: "step:after",
    STEP_AFTER_HOOK: "step:after_hook",
    TOUR_END: "tour:end",
    TOUR_STATUS: "tour:status",
    TARGET_NOT_FOUND: "error:target_not_found",
    ERROR: "error"
};
const LIFECYCLE = {
    INIT: "init",
    READY: "ready",
    BEACON_BEFORE: "beacon_before",
    BEACON: "beacon",
    TOOLTIP_BEFORE: "tooltip_before",
    TOOLTIP: "tooltip",
    COMPLETE: "complete"
};
const ORIGIN = {
    BUTTON_BACK: "button_back",
    BUTTON_CLOSE: "button_close",
    BUTTON_PRIMARY: "button_primary",
    BUTTON_SKIP: "button_skip",
    KEYBOARD: "keyboard",
    OVERLAY: "overlay"
};
const STATUS = {
    IDLE: "idle",
    READY: "ready",
    WAITING: "waiting",
    RUNNING: "running",
    PAUSED: "paused",
    SKIPPED: "skipped",
    FINISHED: "finished"
};
const PORTAL_ELEMENT_ID = "react-joyride-portal";
//#endregion
//#region src/modules/helpers.tsx
/**
* Remove properties with undefined value from an object
*/ function cleanUpObject(input) {
    const output = {};
    for(const key in input)if (input[key] !== void 0) output[key] = input[key];
    return output;
}
function deepMerge(...objects) {
    return (0, _deepmergeDefault.default)({
        all: true,
        isMergeableObject: (value)=>!(!(0, _isLiteDefault.default).plainObject(value) || (0, _react.isValidElement)(value))
    })(...objects);
}
/**
* Get Object type
*/ function getObjectType(value) {
    return Object.prototype.toString.call(value).slice(8, -1).toLowerCase();
}
function getReactNodeText(input, options = {}) {
    const { defaultValue, step, steps } = options;
    let text = (0, _reactInnertextDefault.default)(input);
    if (!text) {
        if ((0, _react.isValidElement)(input) && !Object.values(input.props).length && getObjectType(input.type) === "function") try {
            text = getReactNodeText(input.type({}), options);
        } catch  {
            text = (0, _reactInnertextDefault.default)(defaultValue);
        }
        else text = (0, _reactInnertextDefault.default)(defaultValue);
    } else if ((text.includes("{current}") || text.includes("{total}")) && step && steps) text = text.replace("{current}", step.toString()).replace("{total}", steps.toString());
    return text;
}
/**
* Log method calls if debug is enabled
*/ function log(debug, scope, title, ...data) {
    if (!debug) return;
    const now = /* @__PURE__ */ new Date();
    const time = `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(now.getSeconds()).padStart(2, "0")}.${String(now.getMilliseconds()).padStart(3, "0")}`;
    console.log(`${scope} %c${title}%c ${time}`, "font-weight: bold", "color: gray; font-weight: normal", ...data);
}
/**
* Merges the defaultProps with literal values with the incoming props, removing undefined values from it that would override the defaultProps.
* The result is a type-safe object with the defaultProps as required properties.
*/ function mergeProps(defaultProps, props) {
    const cleanProps = cleanUpObject(props);
    return {
        ...defaultProps,
        ...cleanProps
    };
}
/**
* A function that does nothing.
*/ function noop() {}
/**
* Type-safe Object.keys()
*/ function objectKeys(input) {
    return Object.keys(input);
}
/**
* Remove properties from an object
*/ function omit(input, ...filter) {
    if (!(0, _isLiteDefault.default).plainObject(input)) throw new TypeError("Expected an object");
    const output = {};
    for(const key in input)/* istanbul ignore else */ if (({}).hasOwnProperty.call(input, key) && !filter.includes(key)) output[key] = input[key];
    return output;
}
/**
* Select properties from an object
*/ function pick(input, ...filter) {
    if (!(0, _isLiteDefault.default).plainObject(input)) throw new TypeError("Expected an object");
    if (!filter.length) return input;
    const output = {};
    for(const key in input)/* istanbul ignore else */ if (({}).hasOwnProperty.call(input, key) && filter.includes(key)) output[key] = input[key];
    return output;
}
function replaceLocaleContent(input, step, steps) {
    const replacer = (text)=>text.replace("{current}", String(step)).replace("{total}", String(steps));
    if (getObjectType(input) === "string") return replacer(input);
    if (!(0, _react.isValidElement)(input)) return input;
    const { children } = input.props;
    if ((0, _isLiteDefault.default).string(children) && children.includes("{current}")) return (0, _react.cloneElement)(input, {
        children: replacer(children)
    });
    if (Array.isArray(children)) return (0, _react.cloneElement)(input, {
        children: children.map((child)=>{
            if (typeof child === "string") return replacer(child);
            return replaceLocaleContent(child, step, steps);
        })
    });
    if ((0, _isLiteDefault.default).function(input.type) && !Object.values(input.props).length) try {
        return replaceLocaleContent(input.type({}), step, steps);
    } catch  {
        return input;
    }
    return input;
}
/**
* Sort object keys
*/ function sortObjectKeys(input) {
    return objectKeys(input).sort().reduce((acc, key)=>{
        acc[key] = input[key];
        return acc;
    }, {});
}
//#endregion
//#region src/modules/dom.ts
function canUseDOM() {
    return !!(typeof window !== "undefined" && window.document?.createElement);
}
/**
* Find the bounding client rect
*/ function getClientRect(element) {
    if (!element) return null;
    return element.getBoundingClientRect();
}
/**
* Helper function to get the browser-normalized "document height"
*/ function getDocumentHeight(median = false) {
    const { body, documentElement } = document;
    if (!body || !documentElement) return 0;
    if (median) {
        const heights = [
            body.scrollHeight,
            body.offsetHeight,
            documentElement.clientHeight,
            documentElement.scrollHeight,
            documentElement.offsetHeight
        ].sort((a, b)=>a - b);
        const middle = Math.floor(heights.length / 2);
        if (heights.length % 2 === 0) return (heights[middle - 1] + heights[middle]) / 2;
        return heights[middle];
    }
    return Math.max(body.scrollHeight, body.offsetHeight, documentElement.clientHeight, documentElement.scrollHeight, documentElement.offsetHeight);
}
/**
* Find and return the target DOM element based on a step's 'target'.
*/ function getElement(element) {
    if (!element) return null;
    if (typeof element === "function") try {
        return element();
    } catch (error) {
        return null;
    }
    if (typeof element === "object" && "current" in element) return element.current;
    if (typeof element === "string") try {
        return document.querySelector(element);
    } catch (error) {
        return null;
    }
    return element;
}
/**
* Return the target's top position in document space (viewport top + scroll − offset).
*/ function getElementPosition(element, offset, isFixed) {
    const elementRect = getClientRect(element);
    const parent = getScrollParent(element);
    const hasScrollParent = parent ? !parent.isSameNode(scrollDocument()) : false;
    const isFixedTarget = isFixed ?? hasPosition(element);
    let parentTop = 0;
    let top = elementRect?.top ?? 0;
    if (hasScrollParent && isFixedTarget) top = elementRect?.top ?? 0;
    else if (parent instanceof HTMLElement) {
        parentTop = parent.scrollTop;
        if (!hasScrollParent && !isFixedTarget) top += parentTop;
        if (!parent.isSameNode(scrollDocument())) top += scrollDocument().scrollTop;
    }
    return Math.floor(top - offset);
}
/**
* Get the scroll parent of an element.
* If the detected parent doesn't actually scroll, fall back to the document.
*/ function getScrollParent(element, forListener) {
    if (!element) return scrollDocument();
    const parent = (0, _scrollparentDefault.default)(element);
    if (parent) {
        if (parent.isSameNode(scrollDocument())) {
            if (forListener) return document;
            return scrollDocument();
        }
        if (!(parent.scrollHeight > parent.offsetHeight)) return scrollDocument();
    }
    return parent;
}
function getScrollTargetToCenter(element) {
    const rect = element.getBoundingClientRect();
    const documentElement = scrollDocument();
    const containerCenter = rect.top + rect.height / 2;
    const viewportCenter = window.innerHeight / 2;
    return Math.max(0, documentElement.scrollTop + containerCenter - viewportCenter);
}
/**
* Get the scrollTop position
*/ function getScrollTo(element, offset) {
    if (!element) return 0;
    const parentElement = (0, _scrollparentDefault.default)(element) ?? scrollDocument();
    const scrollMarginTop = parseFloat(getComputedStyle(element).scrollMarginTop) || 0;
    const parentRect = getClientRect(parentElement);
    const parentScrollTop = parentElement.scrollTop ?? 0;
    const { offsetTop = 0, scrollTop = 0 } = parentElement;
    let top = element.getBoundingClientRect().top + scrollTop;
    if (!!offsetTop && (hasCustomScrollParent(element) || hasCustomOffsetParent(element))) {
        const elementRect = element.getBoundingClientRect();
        const elementTopInContainer = elementRect.top - (parentRect?.top ?? 0);
        const elementBottomInContainer = elementTopInContainer + elementRect.height;
        const containerHeight = parentElement.clientHeight;
        const margin = containerHeight * .2;
        if (elementTopInContainer >= margin && elementBottomInContainer <= containerHeight - margin) top = parentScrollTop;
        else top = elementTopInContainer + parentScrollTop;
    }
    const output = Math.floor(top - offset - scrollMarginTop);
    return output < 0 ? 0 : output;
}
/**
* Check if the element has custom offset parent
*/ function hasCustomOffsetParent(element) {
    return element.offsetParent !== document.body;
}
/**
* Check if the element has custom scroll parent
*/ function hasCustomScrollParent(element) {
    if (!element) return false;
    const parent = getScrollParent(element);
    return parent ? !parent.isSameNode(scrollDocument()) : false;
}
/**
* Check if an element has fixed/sticky position
*/ function hasPosition(el, type = "fixed") {
    if (!el || !(el instanceof Element)) return false;
    const { nodeName } = el;
    if (nodeName === "BODY" || nodeName === "HTML") return false;
    if (getComputedStyle(el).position === type) return true;
    if (!el.parentNode) return false;
    return hasPosition(el.parentNode, type);
}
/**
* Check if the element is visible
*/ function isElementVisible(element) {
    if (!element) return false;
    let parentElement = element;
    while(parentElement){
        if (parentElement === document.body) break;
        if (parentElement instanceof HTMLElement) {
            const { display, visibility } = getComputedStyle(parentElement);
            if (display === "none" || visibility === "hidden") return false;
        }
        parentElement = parentElement.parentElement ?? null;
    }
    return true;
}
function needsScrolling(options) {
    const { isFirstStep, scrollToFirstStep, step, target, targetLifecycle } = options;
    if (step.skipScroll || isFirstStep && !scrollToFirstStep && targetLifecycle !== LIFECYCLE.TOOLTIP || step.placement === "center") return false;
    const parent = target?.isConnected ? getScrollParent(target) : scrollDocument();
    const isCustomScrollParent = parent ? !parent.isSameNode(scrollDocument()) : false;
    if ((step.isFixed || hasPosition(target)) && !isCustomScrollParent) return false;
    return parent.scrollHeight > parent.clientHeight;
}
function scrollDocument() {
    return document.scrollingElement ?? document.documentElement;
}
/**
* Scroll to position
*/ function scrollTo(value, options) {
    const { duration, element } = options;
    let cancel = ()=>{};
    const promise = new Promise((resolve)=>{
        const { scrollTop } = element;
        const limit = value > scrollTop ? value - scrollTop : scrollTop - value;
        cancel = (0, _scrollDefault.default).top(element, value, {
            duration: limit < 100 ? 50 : duration
        }, ()=>{
            resolve();
        });
    });
    return {
        cancel,
        promise
    };
}
//#endregion
//#region src/styles.ts
/**
* Convert hex to RGB
*/ function hexToRGB(hex) {
    const properHex = hex.replace(/^#?([\da-f])([\da-f])([\da-f])$/i, (_m, r, g, b)=>r + r + g + g + b + b);
    const result = /^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})/i.exec(properHex);
    return result ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16)
    ] : [];
}
const buttonReset = {
    backgroundColor: "transparent",
    border: 0,
    borderRadius: 0,
    color: "#555555",
    cursor: "pointer",
    fontSize: 16,
    lineHeight: 1,
    padding: 0,
    WebkitAppearance: "none"
};
const buttonBase = {
    ...buttonReset,
    borderRadius: 4,
    padding: 8
};
function getStyles(props, step) {
    const { styles } = props;
    const mergedStyles = deepMerge(styles ?? {}, step.styles ?? {});
    let { width } = step;
    if (canUseDOM()) width = typeof width === "number" && window.innerWidth < width ? window.innerWidth - 30 : width;
    const overlay = {
        bottom: 0,
        left: 0,
        overflow: "hidden",
        position: "absolute",
        right: 0,
        top: 0,
        zIndex: step.zIndex
    };
    return deepMerge({
        arrow: {
            alignItems: "center",
            color: step.arrowColor,
            display: "inline-flex",
            justifyContent: "center",
            position: "absolute"
        },
        beaconWrapper: {
            ...buttonReset,
            display: "inline-flex",
            borderRadius: "50%",
            position: "relative"
        },
        beacon: {
            height: step.beaconSize,
            width: step.beaconSize
        },
        beaconInner: {
            animation: "joyride-beacon-inner 1.2s infinite ease-in-out",
            backgroundColor: step.primaryColor,
            borderRadius: "50%",
            display: "block",
            height: "50%",
            left: "50%",
            opacity: .7,
            position: "absolute",
            top: "50%",
            transform: "translate(-50%, -50%)",
            width: "50%"
        },
        beaconOuter: {
            animation: "joyride-beacon-outer 1.2s infinite ease-in-out",
            backgroundColor: `rgba(${hexToRGB(step.primaryColor).join(",")}, 0.2)`,
            border: `2px solid ${step.primaryColor}`,
            borderRadius: "50%",
            boxSizing: "border-box",
            display: "block",
            height: "100%",
            left: 0,
            opacity: .9,
            position: "absolute",
            top: 0,
            transformOrigin: "center",
            width: "100%"
        },
        buttonBack: {
            ...buttonBase,
            color: step.primaryColor,
            marginLeft: "auto",
            marginRight: 5
        },
        buttonClose: {
            ...buttonBase,
            color: step.textColor,
            height: 12,
            padding: 8,
            position: "absolute",
            right: 0,
            top: 0,
            width: 12
        },
        buttonPrimary: {
            ...buttonBase,
            backgroundColor: step.primaryColor,
            color: step.backgroundColor
        },
        buttonSkip: {
            ...buttonBase,
            color: step.textColor,
            fontSize: 14
        },
        floater: {
            display: "inline-block",
            filter: "drop-shadow(0 0 3px rgba(0, 0, 0, 0.3))",
            maxWidth: "100%",
            transition: "opacity 0.3s"
        },
        loader: {
            alignItems: "center",
            display: "flex",
            height: 48,
            inset: 0,
            justifyContent: "center",
            pointerEvents: "none",
            position: "fixed",
            width: 48,
            zIndex: step.zIndex + 1
        },
        overlay: {
            ...overlay,
            backgroundColor: step.overlayColor
        },
        spotlight: {},
        tooltip: {
            backgroundColor: step.backgroundColor,
            borderRadius: 5,
            boxSizing: "border-box",
            color: step.textColor,
            fontSize: 16,
            maxWidth: "100%",
            padding: 12,
            position: "relative",
            width
        },
        tooltipContainer: {
            lineHeight: 1.4,
            textAlign: "center"
        },
        tooltipTitle: {
            fontSize: 18,
            margin: 0
        },
        tooltipContent: {
            paddingBottom: 12,
            paddingTop: 12
        },
        tooltipFooter: {
            alignItems: "center",
            display: "flex",
            justifyContent: "flex-end"
        },
        tooltipFooterSpacer: {
            flex: 1
        }
    }, mergedStyles);
}
//#endregion
//#region src/modules/step.ts
const optionFieldNames = [
    "after",
    "arrowBase",
    "arrowColor",
    "arrowSize",
    "arrowSpacing",
    "backgroundColor",
    "beaconSize",
    "beaconTrigger",
    "before",
    "beforeTimeout",
    "buttons",
    "closeButtonAction",
    "skipBeacon",
    "dismissKeyAction",
    "disableFocusTrap",
    "hideOverlay",
    "skipScroll",
    "blockTargetInteraction",
    "loaderDelay",
    "offset",
    "overlayClickAction",
    "overlayColor",
    "primaryColor",
    "scrollDuration",
    "scrollOffset",
    "showProgress",
    "spotlightPadding",
    "spotlightRadius",
    "targetWaitTimeout",
    "textColor",
    "width",
    "zIndex"
];
function getMergedStep(props, currentStep) {
    if (!currentStep) return null;
    const mergedStep = deepMerge(defaultStep, pick(props, "arrowComponent", "beaconComponent", "floatingOptions", "loaderComponent", "locale", "styles", "tooltipComponent"), currentStep);
    const mergedOptions = deepMerge(defaultOptions, props.options ?? {}, pick(currentStep, ...optionFieldNames));
    const mergedStyles = getStyles(props, {
        ...mergedStep,
        ...mergedOptions
    });
    const floatingOptions = deepMerge(defaultFloatingOptions, props.floatingOptions ?? {}, mergedStep.floatingOptions ?? {});
    return {
        ...mergedStep,
        ...mergedOptions,
        locale: deepMerge(defaultLocale, props.locale ?? {}, mergedStep.locale || {}),
        floatingOptions,
        spotlightPadding: normalizeSpotlightPadding(mergedOptions.spotlightPadding),
        styles: mergedStyles
    };
}
function normalizeSpotlightPadding(value) {
    if (typeof value === "number") return {
        top: value,
        right: value,
        bottom: value,
        left: value
    };
    return {
        top: value?.top ?? 0,
        right: value?.right ?? 0,
        bottom: value?.bottom ?? 0,
        left: value?.left ?? 0
    };
}
/**
* Decide if the step shouldn't skip the beacon
*/ function shouldHideBeacon(step, state, continuous) {
    const { action } = state;
    const withContinuous = continuous && [
        ACTIONS.PREV,
        ACTIONS.NEXT
    ].includes(action);
    return step.skipBeacon || step.placement === "center" || withContinuous;
}
/**
* Validate if a step is valid
*/ function validateStep(step, debug = false) {
    if (!(0, _isLiteDefault.default).plainObject(step)) {
        log(debug, "tour", "step must be an object");
        return false;
    }
    if (!step.target) {
        log(debug, "tour", "target is missing from the step");
        return false;
    }
    return true;
}
/**
* Validate if steps are valid
*/ function validateSteps(steps, debug = false) {
    if (!(0, _isLiteDefault.default).array(steps)) {
        log(debug, "tour", "steps must be an array");
        return false;
    }
    return steps.every((d)=>validateStep(d, debug));
}
//#endregion
//#region src/modules/store.ts
var Store = class {
    beaconPosition = null;
    debug;
    eventListeners = /* @__PURE__ */ new Map();
    listeners = /* @__PURE__ */ new Set();
    props;
    snapshot;
    state;
    steps;
    tooltipPosition = null;
    constructor(options){
        const { initialStepIndex, stepIndex, steps = [] } = options ?? {};
        const isControlled = (0, _isLiteDefault.default).number(stepIndex);
        let startIndex = 0;
        this.debug = options?.debug ?? false;
        if (isControlled) {
            startIndex = stepIndex;
            if ((0, _isLiteDefault.default).number(initialStepIndex)) log(this.debug, "tour", "initialStepIndex is ignored in controlled mode");
        } else if ((0, _isLiteDefault.default).number(initialStepIndex)) {
            if (initialStepIndex >= 0 && initialStepIndex < steps.length) startIndex = initialStepIndex;
            else if (steps.length > 0) log(this.debug, "tour", "initialStepIndex is out of bounds");
        }
        this.props = options ?? {
            steps: []
        };
        this.steps = steps;
        this.state = {
            action: ACTIONS.INIT,
            controlled: isControlled,
            index: startIndex,
            lifecycle: LIFECYCLE.INIT,
            origin: null,
            positioned: false,
            scrolling: false,
            size: steps.length,
            status: steps.length ? STATUS.READY : STATUS.IDLE,
            waiting: false
        };
        this.snapshot = Object.freeze({
            ...this.state
        });
    }
    applyTransitions(draft) {
        if (draft.status === STATUS.WAITING && draft.size > 0) return {
            ...draft,
            status: STATUS.RUNNING
        };
        return draft;
    }
    getStep(nextIndex) {
        return getMergedStep(this.props, this.steps[nextIndex ?? this.state.index]);
    }
    cleanupPositionData = ()=>{
        this.beaconPosition = null;
        this.tooltipPosition = null;
    };
    getPositionData = (name)=>{
        if (name === "beacon") return this.beaconPosition;
        return this.tooltipPosition;
    };
    getServerSnapshot = ()=>this.snapshot;
    getSnapshot = ()=>this.snapshot;
    getEventState = ()=>omit(this.snapshot, "positioned");
    getState = ()=>omit(this.snapshot, "positioned");
    setPositionData = (name, data)=>{
        if ((name === "beacon" ? this.beaconPosition : this.tooltipPosition)?.placement !== data.placement) log(this.debug, `step:${this.state.index}`, "positioned", `${name} ${data.placement}`);
        if (name === "beacon") this.beaconPosition = data;
        else this.tooltipPosition = data;
        if ((this.state.lifecycle === LIFECYCLE.BEACON_BEFORE || this.state.lifecycle === LIFECYCLE.TOOLTIP_BEFORE) && !this.state.positioned) this.updateState({
            positioned: true
        });
        const onPosition = this.getStep()?.floatingOptions?.onPosition;
        if (onPosition) onPosition(data);
    };
    setSteps = (steps)=>{
        this.steps = steps;
        this.updateState({
            size: steps.length
        });
    };
    dispatch = (data, controls)=>{
        const handlers = this.eventListeners.get(data.type);
        if (handlers) for (const handler of handlers)try {
            handler(data, controls);
        } catch  {}
    };
    on = (eventType, handler)=>{
        let handlers = this.eventListeners.get(eventType);
        if (!handlers) {
            handlers = /* @__PURE__ */ new Set();
            this.eventListeners.set(eventType, handlers);
        }
        handlers.add(handler);
        return ()=>{
            handlers.delete(handler);
        };
    };
    subscribe = (listener)=>{
        this.listeners.add(listener);
        return ()=>{
            this.listeners.delete(listener);
        };
    };
    updateState = (patch, forceIndex = false)=>{
        const { controlled, index } = this.state;
        const previousSnapshot = this.snapshot;
        const resolvedIndex = controlled && !forceIndex && patch.index !== void 0 ? index : patch.index ?? index;
        const merged = {
            action: patch.action ?? this.state.action,
            controlled,
            index: resolvedIndex,
            lifecycle: patch.lifecycle ?? this.state.lifecycle,
            origin: patch.origin ?? null,
            positioned: patch.positioned ?? this.state.positioned,
            scrolling: patch.scrolling ?? this.state.scrolling,
            size: patch.size ?? this.state.size,
            status: patch.status ?? this.state.status,
            waiting: patch.waiting ?? this.state.waiting
        };
        const final = this.applyTransitions(merged);
        this.state = final;
        if (!(0, _deepEqualDefault.default)(previousSnapshot, final)) {
            this.snapshot = Object.freeze({
                ...final
            });
            for (const listener of this.listeners)listener(this.snapshot);
        }
    };
};
function createStore(options) {
    return new Store(options);
}
//#endregion
//#region src/hooks/useControls.ts
function getUpdatedIndex(nextIndex, size) {
    return Math.min(Math.max(nextIndex, 0), size);
}
function useControls(store, debug, clearFailures) {
    const debugRef = (0, _react.useRef)(debug);
    const clearFailuresRef = (0, _react.useRef)(clearFailures);
    debugRef.current = debug;
    clearFailuresRef.current = clearFailures;
    return (0, _react.useMemo)(()=>{
        const getState = ()=>store.current.getSnapshot();
        const close = (origin = null)=>{
            const { index, status } = getState();
            if (status !== STATUS.RUNNING) return;
            store.current.updateState({
                action: ACTIONS.CLOSE,
                index: index + 1,
                origin,
                lifecycle: LIFECYCLE.COMPLETE,
                positioned: false,
                scrolling: false,
                waiting: false
            });
        };
        const go = (nextIndex)=>{
            const { controlled, size, status } = getState();
            if (controlled) {
                log(debugRef.current, "tour", "go() is not supported in controlled mode");
                return;
            }
            if (status !== STATUS.RUNNING) return;
            store.current.updateState({
                action: ACTIONS.GO,
                index: nextIndex,
                lifecycle: LIFECYCLE.COMPLETE,
                positioned: false,
                scrolling: false,
                status: nextIndex < size ? status : STATUS.FINISHED,
                waiting: false
            });
        };
        const info = ()=>omit(store.current.getSnapshot(), "positioned");
        const next = (origin)=>{
            const { index, size, status } = getState();
            if (status !== STATUS.RUNNING) return;
            store.current.updateState({
                action: ACTIONS.NEXT,
                index: getUpdatedIndex(index + 1, size),
                lifecycle: LIFECYCLE.COMPLETE,
                origin,
                positioned: false,
                scrolling: false,
                waiting: false
            });
        };
        const open = ()=>{
            const { status } = getState();
            if (status !== STATUS.RUNNING) return;
            store.current.updateState({
                action: ACTIONS.UPDATE,
                lifecycle: LIFECYCLE.TOOLTIP_BEFORE,
                positioned: false,
                scrolling: false,
                waiting: false
            });
        };
        const previous = (origin)=>{
            const { index, size, status } = getState();
            if (status !== STATUS.RUNNING) return;
            store.current.updateState({
                action: ACTIONS.PREV,
                index: getUpdatedIndex(index - 1, size),
                lifecycle: LIFECYCLE.COMPLETE,
                origin,
                positioned: false,
                scrolling: false,
                waiting: false
            });
        };
        const replay = (origin)=>{
            const { lifecycle, status } = getState();
            if (status !== STATUS.RUNNING || lifecycle !== LIFECYCLE.TOOLTIP) return;
            store.current.updateState({
                action: ACTIONS.REPLAY,
                lifecycle: LIFECYCLE.COMPLETE,
                origin,
                positioned: false,
                scrolling: false,
                waiting: false
            });
        };
        const reset = (restart = false)=>{
            const { controlled } = getState();
            if (controlled) {
                log(debugRef.current, "tour", "reset() is not supported in controlled mode");
                return;
            }
            clearFailuresRef.current();
            store.current.updateState({
                action: ACTIONS.RESET,
                index: 0,
                lifecycle: LIFECYCLE.INIT,
                positioned: false,
                scrolling: false,
                status: restart ? STATUS.RUNNING : STATUS.READY,
                waiting: false
            });
        };
        const skip = (origin)=>{
            const { status } = getState();
            if (status !== STATUS.RUNNING) return;
            store.current.updateState({
                action: ACTIONS.SKIP,
                lifecycle: LIFECYCLE.COMPLETE,
                origin,
                positioned: false,
                scrolling: false,
                status: STATUS.SKIPPED,
                waiting: false
            });
        };
        const start = (nextIndex)=>{
            const { index, size } = getState();
            clearFailuresRef.current();
            store.current.updateState({
                action: ACTIONS.START,
                index: (0, _isLiteDefault.default).number(nextIndex) ? nextIndex : index,
                lifecycle: LIFECYCLE.INIT,
                positioned: false,
                scrolling: false,
                status: size ? STATUS.RUNNING : STATUS.WAITING,
                waiting: false
            }, true);
        };
        const stop = (advance = false)=>{
            const { index, status } = getState();
            if ([
                STATUS.FINISHED,
                STATUS.SKIPPED
            ].includes(status)) return;
            store.current.updateState({
                action: ACTIONS.STOP,
                index: index + (advance ? 1 : 0),
                lifecycle: LIFECYCLE.COMPLETE,
                positioned: false,
                scrolling: false,
                status: STATUS.PAUSED,
                waiting: false
            });
        };
        return {
            close,
            go,
            info,
            next,
            open,
            prev: previous,
            replay,
            reset,
            skip,
            start,
            stop
        };
    }, [
        store
    ]);
}
//#endregion
//#region src/hooks/useDebugLogger.ts
const skipFields = /* @__PURE__ */ new Set([
    "origin",
    "positioned"
]);
function useDebugLogger(store, debug) {
    const previousRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (!debug) return;
        const current = store.current.getSnapshot();
        log(true, "tour", "init", current);
        previousRef.current = current;
        return store.current.subscribe((state)=>{
            const previous = previousRef.current;
            previousRef.current = state;
            if (!previous) return;
            const changes = {};
            let isTourLevel = false;
            for (const key of Object.keys(state))if (state[key] !== previous[key] && !skipFields.has(key)) {
                changes[key] = {
                    from: previous[key],
                    to: state[key]
                };
                if (key === "status" || key === "size") isTourLevel = true;
            }
            if (Object.keys(changes).length) {
                if (!(!isTourLevel && state.index >= state.size)) log(true, isTourLevel ? "tour" : `step:${state.index}`, "state", changes);
            }
        });
    }, [
        debug,
        store
    ]);
}
//#endregion
//#region src/hooks/useEventEmitter.ts
function useEventEmitter(onEvent, controls, store) {
    const onEventRef = (0, _react.useRef)(onEvent);
    const controlsRef = (0, _react.useRef)(controls);
    onEventRef.current = onEvent;
    controlsRef.current = controls;
    return (0, _react.useCallback)((type, step, overrides)=>{
        const data = {
            ...store.current.getEventState(),
            error: null,
            scroll: null,
            step,
            type,
            ...overrides
        };
        onEventRef.current?.(data, controlsRef.current);
        store.current.dispatch(data, controlsRef.current);
    }, [
        store
    ]);
}
//#endregion
//#region src/modules/changes.ts
function treeChanges(state, previous) {
    return {
        hasChanged (key) {
            return state[key] !== previous[key];
        },
        hasChangedTo (key, value) {
            const current = state[key];
            const previousValue = previous[key];
            if (Array.isArray(value)) return value.includes(current) && !value.includes(previousValue);
            return current === value && previousValue !== value;
        },
        previous
    };
}
//#endregion
//#region src/hooks/useLifecycleEffect.ts
function useLifecycleEffect(options) {
    const { addFailure, controls, emitEvent, previousState, props, state, step, store } = options;
    const { action, index, lifecycle, positioned, scrolling, size, status } = state;
    const previousStep = (0, _hooks.usePrevious)(step) ?? null;
    const lastAction = (0, _react.useRef)(null);
    const propsRef = (0, _react.useRef)(props);
    const stateRef = (0, _react.useRef)(state);
    const previousStateRef = (0, _react.useRef)(previousState);
    const stepRef = (0, _react.useRef)(step);
    const previousStepRef = (0, _react.useRef)(previousStep);
    const controlsRef = (0, _react.useRef)(controls);
    const pollingRef = (0, _react.useRef)(null);
    const pollingTargetRef = (0, _react.useRef)(null);
    const beforeRef = (0, _react.useRef)(null);
    propsRef.current = props;
    stateRef.current = state;
    previousStateRef.current = previousState;
    stepRef.current = step;
    previousStepRef.current = previousStep;
    controlsRef.current = controls;
    const cleanup = ()=>{
        if (pollingRef.current) {
            clearInterval(pollingRef.current);
            pollingRef.current = null;
        }
        pollingTargetRef.current = null;
        if (beforeRef.current) {
            beforeRef.current.cancel();
            beforeRef.current = null;
        }
    };
    (0, _react.useEffect)(()=>{
        if (!previousStateRef.current) return;
        const { hasChangedTo } = treeChanges(stateRef.current, previousStateRef.current);
        const isAfterAction = hasChangedTo("action", [
            ACTIONS.NEXT,
            ACTIONS.PREV,
            ACTIONS.SKIP,
            ACTIONS.CLOSE,
            ACTIONS.REPLAY
        ]);
        const isStaleAfterStart = action === ACTIONS.START && (lastAction.current === ACTIONS.CLOSE || lastAction.current === ACTIONS.REPLAY);
        if (isAfterAction || isStaleAfterStart) lastAction.current = action;
    }, [
        action
    ]);
    (0, _react.useEffect)(()=>{
        if (!previousStateRef.current) return ()=>{
            cleanup();
        };
        const { hasChanged } = treeChanges(stateRef.current, previousStateRef.current);
        const currentStep = stepRef.current;
        if (hasChanged("index")) cleanup();
        if (status !== STATUS.RUNNING || !currentStep || lifecycle !== LIFECYCLE.INIT) return ()=>{
            cleanup();
        };
        const { hasChangedTo: hasStatusChangedTo } = treeChanges(stateRef.current, previousStateRef.current);
        if (hasStatusChangedTo("status", STATUS.RUNNING) && [
            STATUS.IDLE,
            STATUS.READY,
            STATUS.PAUSED
        ].includes(previousStateRef.current.status)) emitEvent(EVENTS.TOUR_START, currentStep);
        store.current.cleanupPositionData();
        const { debug } = propsRef.current;
        if (currentStep.before && !beforeRef.current) {
            log(debug, `step:${index}`, "before()", currentStep);
            beforeRef.current = {
                cancel: ()=>{}
            };
            store.current.updateState({
                waiting: true
            });
            emitEvent(EVENTS.STEP_BEFORE_HOOK, currentStep, {
                action: lastAction.current ?? stateRef.current.action
            });
            const proceed = ()=>{
                beforeRef.current = null;
                store.current.updateState({
                    action: lastAction.current ?? stateRef.current.action,
                    waiting: false,
                    lifecycle: LIFECYCLE.READY
                });
            };
            const abortController = new AbortController();
            const timeout = currentStep.beforeTimeout;
            beforeRef.current = {
                cancel: ()=>abortController.abort()
            };
            const timeoutId = timeout ? setTimeout(()=>{
                if (!abortController.signal.aborted) {
                    log(debug, `step:${index}`, "before()", "timed out", `${timeout}ms`);
                    abortController.abort();
                    addFailure(currentStep, "before_hook");
                    emitEvent(EVENTS.ERROR, currentStep, {
                        error: /* @__PURE__ */ new Error("Step before hook timed out")
                    });
                    proceed();
                }
            }, timeout) : null;
            currentStep.before({
                ...store.current.getState(),
                action: lastAction.current ?? store.current.getState().action,
                step: currentStep
            }).then(()=>{
                if (!abortController.signal.aborted) {
                    if (timeoutId) clearTimeout(timeoutId);
                    proceed();
                }
            }).catch((error)=>{
                if (!abortController.signal.aborted) {
                    if (timeoutId) clearTimeout(timeoutId);
                    addFailure(currentStep, "before_hook");
                    emitEvent(EVENTS.ERROR, currentStep, {
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                    proceed();
                }
            });
        } else if (!beforeRef.current) {
            if (pollingRef.current && pollingTargetRef.current !== currentStep.target) cleanup();
            const element = getElement(currentStep.target);
            if (element && isElementVisible(element)) {
                cleanup();
                store.current.updateState({
                    action: lastAction.current ?? ACTIONS.UPDATE,
                    lifecycle: LIFECYCLE.READY,
                    waiting: false
                });
            } else if (currentStep.targetWaitTimeout === 0) store.current.updateState({
                action: lastAction.current ?? ACTIONS.UPDATE,
                lifecycle: LIFECYCLE.READY,
                waiting: false
            });
            else if (!pollingRef.current) {
                const { targetWaitTimeout } = currentStep;
                const startTime = Date.now();
                pollingTargetRef.current = currentStep.target;
                log(debug, `step:${index}`, "polling", "started", `${targetWaitTimeout}ms`);
                store.current.updateState({
                    waiting: true
                });
                pollingRef.current = setInterval(()=>{
                    const el = getElement(currentStep.target);
                    const elapsed = Date.now() - startTime;
                    const timedOut = elapsed >= targetWaitTimeout;
                    if (el && isElementVisible(el) || timedOut) {
                        log(debug, `step:${index}`, "polling", el && isElementVisible(el) ? "found" : "timed out", `${elapsed}ms`);
                        cleanup();
                        store.current.updateState({
                            action: lastAction.current ?? ACTIONS.UPDATE,
                            lifecycle: LIFECYCLE.READY,
                            waiting: false
                        });
                    }
                }, 100);
            }
        }
        return ()=>{
            cleanup();
        };
    }, [
        addFailure,
        emitEvent,
        index,
        lifecycle,
        status,
        store
    ]);
    (0, _react.useEffect)(()=>{
        if (!previousStateRef.current) return;
        const { hasChanged, hasChangedTo, previous } = treeChanges(stateRef.current, previousStateRef.current);
        const currentStep = stepRef.current;
        if (!currentStep) return;
        const element = getElement(currentStep.target);
        const elementExists = !!element;
        if (elementExists && isElementVisible(element)) {
            if (hasChangedTo("lifecycle", LIFECYCLE.READY) && previous.lifecycle === LIFECYCLE.INIT) emitEvent(EVENTS.STEP_BEFORE, currentStep, {
                action: lastAction.current ?? stateRef.current.action
            });
            if (hasChangedTo("lifecycle", LIFECYCLE.READY)) {
                const currentState = stateRef.current;
                const finalLifecycle = shouldHideBeacon(currentStep, currentState, propsRef.current.continuous) ? LIFECYCLE.TOOLTIP : LIFECYCLE.BEACON;
                const target = getElement(currentStep.scrollTarget ?? currentStep.spotlightTarget ?? currentStep.target);
                const willScroll = needsScrolling({
                    isFirstStep: currentState.index === 0,
                    scrollToFirstStep: propsRef.current.scrollToFirstStep,
                    step: currentStep,
                    target,
                    targetLifecycle: finalLifecycle
                });
                const beforeLifecycle = finalLifecycle === LIFECYCLE.TOOLTIP ? LIFECYCLE.TOOLTIP_BEFORE : LIFECYCLE.BEACON_BEFORE;
                log(propsRef.current.debug, `step:${index}`, "scroll", willScroll ? "needed" : "skipped");
                store.current.updateState({
                    action: ACTIONS.UPDATE,
                    lifecycle: beforeLifecycle,
                    scrolling: willScroll
                });
            }
        } else if (stateRef.current.status === STATUS.RUNNING && lifecycle !== LIFECYCLE.INIT && lifecycle !== LIFECYCLE.COMPLETE && hasChanged("lifecycle")) {
            log(propsRef.current.debug, `step:${index}`, elementExists ? "Target not visible" : "Target not mounted", currentStep);
            addFailure(currentStep, "target_not_found");
            emitEvent(EVENTS.TARGET_NOT_FOUND, currentStep);
            const currentState = stateRef.current;
            if (!currentState.controlled) store.current.updateState({
                action: ACTIONS.UPDATE,
                index: currentState.index + (currentState.action === ACTIONS.PREV ? -1 : 1),
                lifecycle: LIFECYCLE.INIT
            });
        }
    }, [
        addFailure,
        emitEvent,
        index,
        lifecycle,
        store
    ]);
    (0, _react.useEffect)(()=>{
        if (!previousStateRef.current) return;
        const { hasChangedTo, previous } = treeChanges(stateRef.current, previousStateRef.current);
        const currentStep = stepRef.current;
        const previousStepValue = previousStepRef.current;
        if (currentStep && hasChangedTo("lifecycle", LIFECYCLE.TOOLTIP_BEFORE) && previous.lifecycle === LIFECYCLE.BEACON) {
            const target = getElement(currentStep.scrollTarget ?? currentStep.spotlightTarget ?? currentStep.target);
            if (needsScrolling({
                isFirstStep: stateRef.current.index === 0,
                scrollToFirstStep: propsRef.current.scrollToFirstStep,
                step: currentStep,
                target,
                targetLifecycle: LIFECYCLE.TOOLTIP
            })) {
                store.current.updateState({
                    scrolling: true,
                    positioned: false
                });
                return;
            }
        }
        const isBeforePhase = lifecycle === LIFECYCLE.BEACON_BEFORE || lifecycle === LIFECYCLE.TOOLTIP_BEFORE;
        if (currentStep && isBeforePhase && !scrolling) {
            const finalLifecycle = lifecycle === LIFECYCLE.TOOLTIP_BEFORE ? LIFECYCLE.TOOLTIP : LIFECYCLE.BEACON;
            store.current.updateState({
                action: ACTIONS.UPDATE,
                lifecycle: finalLifecycle
            });
        }
        if (currentStep && hasChangedTo("lifecycle", LIFECYCLE.BEACON)) emitEvent(EVENTS.BEACON, currentStep);
        if (currentStep && hasChangedTo("lifecycle", LIFECYCLE.TOOLTIP)) emitEvent(EVENTS.TOOLTIP, currentStep);
        const currentState = stateRef.current;
        if ((currentState.status === STATUS.RUNNING || currentState.controlled && currentState.status === STATUS.PAUSED && !!currentStep) && previousStepValue && hasChangedTo("lifecycle", LIFECYCLE.COMPLETE) && previous.lifecycle === LIFECYCLE.TOOLTIP) {
            emitEvent(EVENTS.STEP_AFTER, previousStepValue, {
                action: lastAction.current ?? ACTIONS.UPDATE,
                index: previous.index ?? currentState.index,
                lifecycle: currentState.lifecycle
            });
            if (previousStepValue.after) {
                emitEvent(EVENTS.STEP_AFTER_HOOK, previousStepValue, {
                    action: lastAction.current ?? ACTIONS.UPDATE,
                    index: previous.index ?? currentState.index,
                    lifecycle: currentState.lifecycle
                });
                try {
                    previousStepValue.after({
                        ...store.current.getState(),
                        action: lastAction.current ?? ACTIONS.UPDATE,
                        index: previous.index ?? currentState.index,
                        lifecycle: currentState.lifecycle,
                        step: previousStepValue
                    });
                } catch  {}
            }
        }
    }, [
        emitEvent,
        lifecycle,
        positioned,
        scrolling,
        store
    ]);
    (0, _react.useEffect)(()=>{
        if (!previousStateRef.current) return;
        const { hasChangedTo, previous } = treeChanges(stateRef.current, previousStateRef.current);
        const currentStep = stepRef.current;
        const previousStepValue = previousStepRef.current;
        if (hasChangedTo("action", ACTIONS.REPLAY) && hasChangedTo("lifecycle", LIFECYCLE.COMPLETE)) {
            store.current.updateState({
                lifecycle: LIFECYCLE.INIT
            });
            return;
        }
        if (size && !currentStep && lifecycle === LIFECYCLE.INIT) store.current.updateState({
            action: ACTIONS.UPDATE,
            lifecycle: LIFECYCLE.COMPLETE,
            status: STATUS.FINISHED
        });
        if (!stateRef.current.controlled && status === STATUS.RUNNING && hasChangedTo("lifecycle", LIFECYCLE.COMPLETE) && index < size) store.current.updateState({
            action: ACTIONS.UPDATE,
            lifecycle: LIFECYCLE.INIT
        });
        if (hasChangedTo("lifecycle", LIFECYCLE.COMPLETE) && index >= size) store.current.updateState({
            action: ACTIONS.UPDATE,
            lifecycle: LIFECYCLE.COMPLETE,
            status: STATUS.FINISHED
        });
        const tourEndStep = currentStep ?? previousStepValue ?? getMergedStep(propsRef.current, propsRef.current.steps[index - 1]);
        if (tourEndStep && hasChangedTo("status", [
            STATUS.FINISHED,
            STATUS.SKIPPED
        ])) {
            let tourEndIndex;
            if (currentStep) tourEndIndex = index;
            else if (previousStepValue) tourEndIndex = previous.index ?? index;
            else tourEndIndex = index - 1;
            emitEvent(EVENTS.TOUR_END, tourEndStep, {
                index: tourEndIndex
            });
            if (!stateRef.current.controlled) controlsRef.current.reset();
            lastAction.current = null;
        }
        if (currentStep && hasChangedTo("action", ACTIONS.STOP)) {
            lastAction.current = null;
            emitEvent(EVENTS.TOUR_STATUS, currentStep);
        }
        if (currentStep && hasChangedTo("action", ACTIONS.RESET)) {
            emitEvent(EVENTS.TOUR_STATUS, currentStep);
            lastAction.current = null;
        }
    }, [
        action,
        emitEvent,
        index,
        lifecycle,
        size,
        status,
        store
    ]);
}
//#endregion
//#region src/hooks/usePropSync.ts
function usePropSync({ controls, emitEvent, props, state, store }) {
    const { debug, initialStepIndex, run, stepIndex, steps } = props;
    const previousPropsRef = (0, _react.useRef)(void 0);
    const stateRef = (0, _react.useRef)(state);
    const controlsRef = (0, _react.useRef)(controls);
    stateRef.current = state;
    controlsRef.current = controls;
    (0, _react.useEffect)(()=>{
        const previousProps = previousPropsRef.current;
        previousPropsRef.current = props;
        if (!previousProps || props === previousProps) return;
        const { hasChanged } = treeChanges(props, previousProps);
        if (!(0, _deepEqualDefault.default)(previousProps.steps, steps)) {
            if (validateSteps(steps, debug)) store.current.setSteps(steps);
            else {
                log(debug, "tour", "Steps are not valid", steps);
                emitEvent(EVENTS.ERROR, steps[0] ?? {
                    target: "",
                    content: ""
                }, {
                    error: /* @__PURE__ */ new Error("Steps are not valid")
                });
            }
        }
        if (hasChanged("run")) {
            if (run) {
                if (store.current.getState().size) controlsRef.current.start(stepIndex ?? initialStepIndex);
            } else controlsRef.current.stop();
        } else if ((0, _isLiteDefault.default).number(stepIndex) && hasChanged("stepIndex")) {
            const nextAction = (0, _isLiteDefault.default).number(previousProps.stepIndex) && previousProps.stepIndex < stepIndex ? ACTIONS.NEXT : ACTIONS.PREV;
            if (![
                STATUS.FINISHED,
                STATUS.SKIPPED
            ].includes(stateRef.current.status)) store.current.updateState({
                action: nextAction,
                index: stepIndex,
                lifecycle: LIFECYCLE.INIT,
                positioned: false
            }, true);
        }
    }, [
        debug,
        emitEvent,
        initialStepIndex,
        props,
        run,
        stepIndex,
        steps,
        store
    ]);
}
//#endregion
//#region src/hooks/useScrollEffect.ts
function adjustForPlacement(scrollY, options) {
    const { beaconPosition, lifecycle, scrollOffset, step } = options;
    if (step.scrollTarget || step.spotlightTarget) return Math.max(0, scrollY);
    let adjustedY = scrollY - step.spotlightPadding.top;
    if (lifecycle === LIFECYCLE.BEACON_BEFORE && beaconPosition?.placement) {
        const y = getMainAxisOffset(beaconPosition);
        if (![
            "bottom"
        ].includes(beaconPosition.placement)) adjustedY += Math.floor(y - scrollOffset);
    } else if (lifecycle === LIFECYCLE.TOOLTIP_BEFORE) {
        const { placement } = step;
        if (placement === "top") {
            const floaterHeight = document.querySelector(".react-joyride__floater")?.getBoundingClientRect().height ?? 0;
            const arrowSize = step.floatingOptions?.hideArrow ? 0 : step.arrowSize;
            const gap = step.offset + step.spotlightPadding.top + arrowSize;
            adjustedY -= floaterHeight + gap;
        } else if (placement === "left" || placement === "right") {
            const floaterHeight = document.querySelector(".react-joyride__floater")?.getBoundingClientRect().height ?? 0;
            const targetHeight = getElement(step.target)?.getBoundingClientRect().height ?? 0;
            const floaterTopY = scrollOffset + step.spotlightPadding.top + targetHeight / 2 - floaterHeight / 2;
            if (floaterTopY < scrollOffset) adjustedY -= scrollOffset - floaterTopY;
        }
    }
    return Math.max(0, adjustedY);
}
function getMainAxisOffset(data) {
    const offsetData = data.middlewareData?.offset;
    if (!offsetData) return 0;
    return [
        "left",
        "right"
    ].some((p)=>data.placement.startsWith(p)) ? offsetData.x : offsetData.y;
}
function useScrollEffect({ emitEvent, previousState, props, state, step, store }) {
    const { index, lifecycle, positioned, scrolling, status } = state;
    const cancelScrollRef = (0, _react.useRef)(null);
    const stateRef = (0, _react.useRef)(state);
    const previousStateRef = (0, _react.useRef)(previousState);
    const propsRef = (0, _react.useRef)(props);
    const stepRef = (0, _react.useRef)(step);
    stateRef.current = state;
    previousStateRef.current = previousState;
    propsRef.current = props;
    stepRef.current = step;
    (0, _react.useEffect)(()=>{
        return ()=>{
            cancelScrollRef.current?.();
        };
    }, []);
    (0, _react.useEffect)(()=>{
        if (!previousStateRef.current || !stepRef.current) return;
        const { hasChangedTo } = treeChanges(stateRef.current, previousStateRef.current);
        const currentStep = stepRef.current;
        const { debug } = propsRef.current;
        const { scrollDuration } = currentStep;
        const isBeforePhase = lifecycle === LIFECYCLE.BEACON_BEFORE || lifecycle === LIFECYCLE.TOOLTIP_BEFORE;
        if (status === STATUS.RUNNING && isBeforePhase && scrolling && hasChangedTo("positioned", true)) {
            const target = getElement(currentStep.scrollTarget ?? currentStep.spotlightTarget ?? currentStep.target);
            const beaconPosition = store.current.getPositionData("beacon");
            const scrollParent = getScrollParent(target);
            const hasCustomScroll = scrollParent ? !scrollParent.isSameNode(scrollDocument()) : false;
            cancelScrollRef.current?.();
            const handleScroll = async ()=>{
                if (hasCustomScroll && !hasPosition(scrollParent)) {
                    const pageElement = scrollDocument();
                    const pageScrollY = getScrollTargetToCenter(scrollParent);
                    const pageScrollData = {
                        initial: pageElement.scrollTop,
                        target: pageScrollY,
                        element: pageElement,
                        duration: scrollDuration
                    };
                    emitEvent(EVENTS.SCROLL_START, currentStep, {
                        scroll: pageScrollData
                    });
                    const { cancel: cancelPage, promise: pagePromise } = scrollTo(pageScrollY, {
                        element: pageElement,
                        duration: scrollDuration
                    });
                    cancelScrollRef.current = cancelPage;
                    await pagePromise;
                    emitEvent(EVENTS.SCROLL_END, currentStep, {
                        scroll: pageScrollData
                    });
                }
                const baseScrollY = Math.floor(getScrollTo(target, currentStep.scrollOffset)) || 0;
                const scrollY = hasCustomScroll ? baseScrollY : adjustForPlacement(baseScrollY, {
                    beaconPosition,
                    lifecycle,
                    scrollOffset: currentStep.scrollOffset,
                    step: currentStep
                });
                log(debug, `step:${index}`, "scroll", hasCustomScroll ? "custom" : "document", `${baseScrollY} \u{2192} ${scrollY}`);
                const scrollElement = scrollParent;
                const scrollData = {
                    initial: scrollElement.scrollTop,
                    target: scrollY,
                    element: scrollElement,
                    duration: scrollDuration
                };
                emitEvent(EVENTS.SCROLL_START, currentStep, {
                    scroll: scrollData
                });
                const { cancel, promise } = scrollTo(scrollY, {
                    element: scrollElement,
                    duration: scrollDuration
                });
                cancelScrollRef.current = cancel;
                await promise;
                emitEvent(EVENTS.SCROLL_END, currentStep, {
                    scroll: scrollData
                });
                store.current.updateState({
                    scrolling: false
                });
            };
            handleScroll().catch(()=>{
                store.current.updateState({
                    scrolling: false
                });
            });
        }
    }, [
        emitEvent,
        index,
        lifecycle,
        positioned,
        scrolling,
        status,
        store
    ]);
}
//#endregion
//#region src/hooks/useTourEngine.ts
function useTourEngine(props) {
    const mergedProps = (0, _hooks.useMemoDeepCompare)(()=>mergeProps(defaultProps, props), [
        props
    ]);
    const { debug, initialStepIndex, onEvent, run, stepIndex, steps } = mergedProps;
    const store = (0, _react.useRef)(createStore(mergedProps));
    const state = (0, _shim.useSyncExternalStore)(store.current.subscribe, store.current.getSnapshot, store.current.getServerSnapshot);
    const [failures, setFailures] = (0, _react.useState)([]);
    const addFailure = (0, _react.useCallback)((failedStep, reason)=>{
        setFailures((previous)=>[
                ...previous,
                {
                    reason,
                    step: failedStep
                }
            ]);
    }, []);
    const clearFailures = (0, _react.useCallback)(()=>{
        setFailures([]);
    }, []);
    useDebugLogger(store, debug);
    const controls = useControls(store, debug, clearFailures);
    const emitEvent = useEventEmitter(onEvent, controls, store);
    const { index, size, status } = state;
    const previousState = (0, _hooks.usePrevious)(state);
    const step = (0, _react.useMemo)(()=>getMergedStep(mergedProps, steps[index]), [
        index,
        mergedProps,
        steps
    ]);
    (0, _hooks.useMount)(()=>{
        if (run && size && validateSteps(steps, debug)) controls.start(stepIndex ?? initialStepIndex);
    });
    (0, _hooks.useUpdateEffect)(()=>{
        if (run && size && status === STATUS.IDLE) store.current.updateState({
            status: STATUS.READY
        });
    }, [
        run,
        size,
        status
    ]);
    usePropSync({
        controls,
        emitEvent,
        props: mergedProps,
        state,
        store
    });
    useLifecycleEffect({
        addFailure,
        controls,
        emitEvent,
        previousState,
        props: mergedProps,
        state,
        step,
        store
    });
    useScrollEffect({
        emitEvent,
        previousState,
        props: mergedProps,
        state,
        step,
        store
    });
    return {
        controls,
        failures,
        mergedProps,
        state,
        step,
        store
    };
}
//#endregion
//#region src/hooks/usePortalElement.ts
function usePortalElement(portalElement) {
    const [element, setElement] = (0, _react.useState)(null);
    (0, _react.useEffect)(()=>{
        let createdElement = null;
        let isExternal = false;
        if (portalElement) {
            if ((0, _isLiteDefault.default).domElement(portalElement)) {
                createdElement = portalElement;
                isExternal = true;
            } else {
                const portal = document.querySelector(portalElement);
                if (portal) createdElement = portal;
            }
        } else {
            const portal = document.createElement("div");
            portal.id = PORTAL_ELEMENT_ID;
            document.body.appendChild(portal);
            createdElement = portal;
        }
        setElement(createdElement);
        return ()=>{
            if (!createdElement || isExternal) return;
            if (createdElement.parentNode === document.body) document.body.removeChild(createdElement);
        };
    }, [
        portalElement
    ]);
    return element;
}
//#endregion
//#region src/components/Loader.tsx
const spinnerStyles = {
    animation: "joyride-loader-spin 1s linear infinite",
    border: "5px solid rgba(0, 0, 0, 0.1)",
    borderRadius: "50%",
    borderTopColor: "#555"
};
function JoyrideLoader({ nonce, step }) {
    const { loaderComponent } = step;
    const hasLoaderComponent = Boolean(loaderComponent);
    (0, _react.useEffect)(()=>{
        if (hasLoaderComponent) return noop;
        if (document.getElementById("joyride-loader-animation")) return noop;
        const style = document.createElement("style");
        style.id = "joyride-loader-animation";
        if (nonce) style.setAttribute("nonce", nonce);
        style.appendChild(document.createTextNode(`
        @keyframes joyride-loader-spin {
          to { transform: rotate(360deg); }
        }
      `));
        document.head.appendChild(style);
        return ()=>{
            const insertedStyle = document.getElementById("joyride-loader-animation");
            if (insertedStyle?.parentNode) insertedStyle.parentNode.removeChild(insertedStyle);
        };
    }, [
        hasLoaderComponent,
        nonce
    ]);
    if (loaderComponent === null) return null;
    const { height, width, ...loaderStyle } = step.styles.loader;
    let content;
    if (loaderComponent) {
        const CustomLoader = loaderComponent;
        content = /* @__PURE__ */ (0, _reactDefault.default).createElement(CustomLoader, {
            step
        });
    } else content = /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        style: {
            ...spinnerStyles,
            height,
            width,
            borderTopColor: step.primaryColor
        }
    });
    return /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        className: "react-joyride__loader",
        "data-testid": "loader",
        style: loaderStyle
    }, content);
}
//#endregion
//#region src/hooks/useTargetPosition.ts
const defaultRect = {
    height: 0,
    isFixed: false,
    left: 0,
    top: 0,
    width: 0
};
function computeRect(target, spotlightPadding) {
    const element = getElement(target);
    if (!element) return defaultRect;
    const elementRect = getClientRect(element);
    const isFixed = hasPosition(element);
    const top = getElementPosition(element, spotlightPadding.top, isFixed);
    return {
        height: Math.round((elementRect?.height ?? 0) + spotlightPadding.top + spotlightPadding.bottom),
        isFixed,
        left: Math.round((elementRect?.left ?? 0) - spotlightPadding.left),
        top,
        width: Math.round((elementRect?.width ?? 0) + spotlightPadding.left + spotlightPadding.right)
    };
}
function useTargetPosition(target, spotlightPadding, force) {
    const [rect, setRect] = (0, _react.useState)(()=>computeRect(target, spotlightPadding));
    const timeoutRef = (0, _react.useRef)(void 0);
    const scrollParentRef = (0, _react.useRef)(null);
    const previousForceRef = (0, _react.useRef)(force);
    const observerRef = (0, _react.useRef)(null);
    const updateRect = (0, _react.useCallback)(()=>{
        clearTimeout(timeoutRef.current);
        timeoutRef.current = window.setTimeout(()=>{
            setRect((previous)=>{
                const next = computeRect(target, spotlightPadding);
                if (previous.top === next.top && previous.left === next.left && previous.width === next.width && previous.height === next.height && previous.isFixed === next.isFixed) return previous;
                return next;
            });
        }, 100);
    }, [
        target,
        spotlightPadding
    ]);
    (0, _react.useEffect)(()=>{
        let mutationObserver = null;
        const setup = (element)=>{
            scrollParentRef.current = getScrollParent(element, true);
            if (scrollParentRef.current) scrollParentRef.current.addEventListener("scroll", updateRect, {
                passive: true
            });
            window.addEventListener("scroll", updateRect, {
                passive: true
            });
            window.addEventListener("resize", updateRect);
            if (typeof ResizeObserver !== "undefined") {
                observerRef.current = new ResizeObserver(updateRect);
                observerRef.current.observe(element);
            }
            setRect(computeRect(target, spotlightPadding));
        };
        const element = getElement(target);
        if (element) setup(element);
        else {
            mutationObserver = new MutationObserver(()=>{
                const el = getElement(target);
                if (el) {
                    mutationObserver?.disconnect();
                    mutationObserver = null;
                    setup(el);
                }
            });
            mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
        }
        return ()=>{
            mutationObserver?.disconnect();
            if (scrollParentRef.current) scrollParentRef.current.removeEventListener("scroll", updateRect);
            window.removeEventListener("scroll", updateRect);
            window.removeEventListener("resize", updateRect);
            observerRef.current?.disconnect();
            clearTimeout(timeoutRef.current);
        };
    }, [
        target,
        spotlightPadding,
        updateRect
    ]);
    (0, _react.useEffect)(()=>{
        if (previousForceRef.current && !force) setRect(computeRect(target, spotlightPadding));
        previousForceRef.current = force;
    }, [
        force,
        target,
        spotlightPadding
    ]);
    let finalRect = rect;
    if (previousForceRef.current && !force) finalRect = computeRect(target, spotlightPadding);
    return finalRect;
}
//#endregion
//#region src/modules/svg.ts
function generateOverlayPath(overlayWidth, overlayHeight, cutout) {
    let path = `M0 0H${overlayWidth}V${overlayHeight}H0Z`;
    if (cutout) path += ` ${cutout}`;
    return path;
}
function generateSpotlightPath(x, y, width, height, borderRadius) {
    if (width <= 0 || height <= 0) return "";
    const r = Math.max(0, Math.min(borderRadius, width / 2, height / 2));
    let path = `M${x + r} ${y}`;
    path += `H${x + width - r}`;
    path += `A${r} ${r} 0 0 1 ${x + width} ${y + r}`;
    path += `V${y + height - r}`;
    path += `A${r} ${r} 0 0 1 ${x + width - r} ${y + height}`;
    path += `H${x + r}`;
    path += `A${r} ${r} 0 0 1 ${x} ${y + height - r}`;
    path += `V${y + r}`;
    path += `A${r} ${r} 0 0 1 ${x + r} ${y}Z`;
    return path;
}
//#endregion
//#region src/components/Overlay.tsx
const hiddenLifecycles = [
    LIFECYCLE.BEACON_BEFORE,
    LIFECYCLE.BEACON
];
function JoyrideOverlay(props) {
    const { blockTargetInteraction, continuous, hideOverlay, lifecycle, onClickOverlay, overlayClickAction, placement, portalElement, scrolling, spotlightPadding, spotlightRadius, spotlightTarget, styles, target, waiting } = props;
    const windowSize = (0, _hooks.useWindowSize)();
    const targetRect = useTargetPosition(spotlightTarget ?? target, spotlightPadding, scrolling || waiting);
    const overlayRef = (0, _react.useRef)(null);
    const svgRef = (0, _react.useRef)(null);
    const showSpotlight = (lifecycle === LIFECYCLE.TOOLTIP || lifecycle === LIFECYCLE.TOOLTIP_BEFORE) && placement !== "center";
    const [spotlightReady, setSpotlightReady] = (0, _react.useState)(false);
    const container = portalElement ? overlayRef.current?.offsetParent : null;
    const overlayWidth = container?.clientWidth ?? windowSize.width;
    const overlayHeight = container?.clientHeight ?? getDocumentHeight() ?? windowSize.height;
    const overlayColor = styles.overlay?.backgroundColor ?? "rgba(0, 0, 0, 0.5)";
    const overlayStyles = (0, _react.useMemo)(()=>{
        const { backgroundColor: _bg, mixBlendMode: _mbm, ...rest } = styles.overlay;
        return {
            height: overlayHeight,
            pointerEvents: "none",
            ...rest
        };
    }, [
        overlayHeight,
        styles.overlay
    ]);
    const showCutout = showSpotlight && !scrolling && !waiting;
    (0, _react.useEffect)(()=>{
        if (showCutout) requestAnimationFrame(()=>setSpotlightReady(true));
        else setSpotlightReady(false);
    }, [
        showCutout
    ]);
    const isHiddenInContinuous = continuous && hiddenLifecycles.includes(lifecycle);
    const isHiddenInNonContinuous = !continuous && lifecycle !== LIFECYCLE.TOOLTIP;
    if (hideOverlay || !waiting && (isHiddenInContinuous || isHiddenInNonContinuous)) return null;
    let coverPath = "";
    if (showCutout) {
        let originTop = 0;
        let originLeft = 0;
        const svg = svgRef.current;
        if (portalElement && svg && !targetRect.isFixed) {
            const rect = svg.getBoundingClientRect();
            originTop = rect.top + scrollDocument().scrollTop;
            originLeft = rect.left;
        }
        coverPath = generateSpotlightPath(targetRect.left - originLeft, targetRect.top - originTop, targetRect.width, targetRect.height, spotlightRadius);
    }
    const path = generateOverlayPath(overlayWidth, overlayHeight, coverPath);
    return /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        ref: overlayRef,
        "aria-hidden": "true",
        className: "react-joyride__overlay",
        "data-testid": "overlay",
        style: overlayStyles
    }, /* @__PURE__ */ (0, _reactDefault.default).createElement("svg", {
        ref: svgRef,
        className: "react-joyride__spotlight",
        "data-testid": "spotlight",
        style: {
            height: overlayHeight,
            left: 0,
            position: targetRect.isFixed ? "fixed" : "absolute",
            top: 0,
            width: overlayWidth
        }
    }, /* @__PURE__ */ (0, _reactDefault.default).createElement("path", {
        d: path,
        fill: overlayColor,
        fillRule: "evenodd",
        onClick: onClickOverlay,
        style: {
            cursor: overlayClickAction ? "pointer" : "default",
            pointerEvents: "auto"
        }
    }), coverPath && /* @__PURE__ */ (0, _reactDefault.default).createElement("path", {
        d: coverPath,
        fill: overlayColor,
        style: {
            opacity: spotlightReady ? 0 : 1,
            pointerEvents: blockTargetInteraction ? "auto" : "none",
            transition: "opacity 0.2s"
        }
    }), coverPath && Object.keys(styles.spotlight).length > 0 && /* @__PURE__ */ (0, _reactDefault.default).createElement("path", {
        d: coverPath,
        fill: "none",
        style: {
            pointerEvents: "none"
        },
        ...styles.spotlight
    })));
}
//#endregion
//#region src/components/Portal.tsx
function JoyridePortal(props) {
    const { children, element } = props;
    if (!element) return null;
    return (0, _reactDom.createPortal)(children, element);
}
//#endregion
//#region src/hooks/useFocusTrap.ts
const TABBABLE_SELECTOR = "a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), area[href], [tabindex]:not([tabindex=\"-1\"]), [contenteditable]";
function useFocusTrap(element, selector) {
    const previousFocus = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (!element) return noop;
        previousFocus.current = document.activeElement;
        const handleKeyDown = (event)=>{
            if (event.key !== "Tab") return;
            const elements = [
                ...element.querySelectorAll(TABBABLE_SELECTOR)
            ];
            const { shiftKey } = event;
            if (!elements.length) return;
            event.preventDefault();
            let index = document.activeElement ? elements.indexOf(document.activeElement) : 0;
            if (index === -1 || !shiftKey && index + 1 === elements.length) index = 0;
            else if (shiftKey && index === 0) index = elements.length - 1;
            else index += shiftKey ? -1 : 1;
            elements[index].focus();
        };
        element.addEventListener("keydown", handleKeyDown, false);
        let timerId;
        if (selector) {
            const target = element.querySelector(selector);
            if (target) timerId = setTimeout(()=>{
                target.focus({
                    preventScroll: true
                });
            }, 100);
        }
        return ()=>{
            element.removeEventListener("keydown", handleKeyDown);
            if (timerId !== void 0) clearTimeout(timerId);
            previousFocus.current?.focus({
                preventScroll: true
            });
        };
    }, [
        element,
        selector
    ]);
}
//#endregion
//#region src/components/Arrow.tsx
function getDimensions(placement, base, size) {
    const [side] = placement.split("-");
    switch(side){
        case "top":
        case "bottom":
            return {
                width: base,
                height: size
            };
        case "left":
        case "right":
            return {
                width: size,
                height: base
            };
        default:
            return null;
    }
}
function getPoints(placement, base, size) {
    const [side] = placement.split("-");
    switch(side){
        case "top":
            return {
                points: `0,0 ${base / 2},${size} ${base},0`,
                ...getDimensions(placement, base, size)
            };
        case "bottom":
            return {
                points: `${base},${size} ${base / 2},0 0,${size}`,
                ...getDimensions(placement, base, size)
            };
        case "left":
            return {
                points: `0,0 ${size},${base / 2} 0,${base}`,
                ...getDimensions(placement, base, size)
            };
        case "right":
            return {
                points: `${size},${base} ${size},0 0,${base / 2}`,
                ...getDimensions(placement, base, size)
            };
        default:
            return null;
    }
}
function getPositionStyle(placement, position, size, base) {
    if (!position) return {};
    const [side] = placement.split("-");
    switch(side){
        case "top":
            return {
                bottom: -size,
                left: position.x ?? 0,
                ...getDimensions(placement, base, size)
            };
        case "bottom":
            return {
                top: -size,
                left: position.x ?? 0,
                ...getDimensions(placement, base, size)
            };
        case "left":
            return {
                right: -size,
                top: position.y ?? 0,
                ...getDimensions(placement, base, size)
            };
        case "right":
            return {
                left: -size,
                top: position.y ?? 0,
                ...getDimensions(placement, base, size)
            };
        default:
            return {};
    }
}
function Arrow({ arrowComponent, arrowRef, base, placement, position, size, styles }) {
    const ArrowComponent = arrowComponent;
    let content = null;
    if (ArrowComponent) {
        if (!getDimensions(placement, base, size)) return null;
        content = /* @__PURE__ */ (0, _reactDefault.default).createElement("span", {
            style: {
                flexShrink: 0
            }
        }, /* @__PURE__ */ (0, _reactDefault.default).createElement(ArrowComponent, {
            base,
            placement,
            size
        }));
    } else {
        const svg = getPoints(placement, base, size);
        if (!svg) return null;
        content = /* @__PURE__ */ (0, _reactDefault.default).createElement("svg", {
            height: svg.height,
            width: svg.width,
            xmlns: "http://www.w3.org/2000/svg"
        }, /* @__PURE__ */ (0, _reactDefault.default).createElement("polygon", {
            fill: "currentColor",
            points: svg.points
        }));
    }
    return /* @__PURE__ */ (0, _reactDefault.default).createElement("span", {
        ref: arrowRef,
        className: "react-joyride__arrow",
        "data-testid": "arrow",
        style: {
            ...styles,
            ...getPositionStyle(placement, position, size, base),
            ...position ? {} : {
                visibility: "hidden"
            }
        }
    }, content);
}
//#endregion
//#region src/components/Beacon.tsx
function JoyrideBeacon(props) {
    const { beaconComponent, continuous, index, isLastStep, locale, nonce, onInteract, shouldFocus, size, step, styles } = props;
    const beaconRef = (0, _react.useRef)(null);
    const hasBeaconComponent = Boolean(beaconComponent);
    (0, _react.useEffect)(()=>{
        if (hasBeaconComponent) return noop;
        if (document.getElementById("joyride-beacon-animation")) return noop;
        const style = document.createElement("style");
        style.id = "joyride-beacon-animation";
        if (nonce) style.setAttribute("nonce", nonce);
        style.appendChild(document.createTextNode(`
        @keyframes joyride-beacon-inner {
          20% {
            opacity: 0.9;
          }

          90% {
            opacity: 0.7;
          }
        }

        @keyframes joyride-beacon-outer {
          0% {
            transform: scale(1);
          }

          45% {
            opacity: 0.7;
            transform: scale(0.75);
          }

          100% {
            opacity: 0.9;
            transform: scale(1);
          }
        }
      `));
        document.head.appendChild(style);
        const focusTimer = setTimeout(()=>{
            if ((0, _isLiteDefault.default).domElement(beaconRef.current) && shouldFocus) beaconRef.current.focus();
        }, 0);
        return ()=>{
            clearTimeout(focusTimer);
            const insertedStyle = document.getElementById("joyride-beacon-animation");
            if (insertedStyle?.parentNode) insertedStyle.parentNode.removeChild(insertedStyle);
        };
    }, [
        hasBeaconComponent,
        nonce,
        shouldFocus
    ]);
    const title = getReactNodeText(locale.open);
    let content;
    if (beaconComponent) {
        const BeaconComponent = beaconComponent;
        content = /* @__PURE__ */ (0, _reactDefault.default).createElement(BeaconComponent, {
            continuous,
            index,
            isLastStep,
            size,
            step
        });
    } else content = /* @__PURE__ */ (0, _reactDefault.default).createElement("span", {
        style: styles.beacon
    }, /* @__PURE__ */ (0, _reactDefault.default).createElement("span", {
        style: styles.beaconOuter
    }), /* @__PURE__ */ (0, _reactDefault.default).createElement("span", {
        style: styles.beaconInner
    }));
    return /* @__PURE__ */ (0, _reactDefault.default).createElement("button", {
        ref: beaconRef,
        "aria-label": title,
        className: "react-joyride__beacon",
        "data-testid": "button-beacon",
        onClick: onInteract,
        onMouseEnter: onInteract,
        style: styles.beaconWrapper,
        title,
        type: "button"
    }, content);
}
//#endregion
//#region src/components/Tooltip/CloseButton.tsx
function JoyrideTooltipCloseButton({ styles, ...props }) {
    const { color, height, width, ...style } = styles;
    return /* @__PURE__ */ (0, _reactDefault.default).createElement("button", {
        style,
        type: "button",
        ...props
    }, /* @__PURE__ */ (0, _reactDefault.default).createElement("svg", {
        height: typeof height === "number" ? `${height}px` : height,
        preserveAspectRatio: "xMidYMid",
        version: "1.1",
        viewBox: "0 0 18 18",
        width: typeof width === "number" ? `${width}px` : width,
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, _reactDefault.default).createElement("g", null, /* @__PURE__ */ (0, _reactDefault.default).createElement("path", {
        d: "M8.13911129,9.00268191 L0.171521827,17.0258467 C-0.0498027049,17.248715 -0.0498027049,17.6098394 0.171521827,17.8327545 C0.28204354,17.9443526 0.427188206,17.9998706 0.572051765,17.9998706 C0.71714958,17.9998706 0.862013139,17.9443526 0.972581703,17.8327545 L9.0000937,9.74924618 L17.0276057,17.8327545 C17.1384085,17.9443526 17.2832721,17.9998706 17.4281356,17.9998706 C17.5729992,17.9998706 17.718097,17.9443526 17.8286656,17.8327545 C18.0499901,17.6098862 18.0499901,17.2487618 17.8286656,17.0258467 L9.86135722,9.00268191 L17.8340066,0.973848225 C18.0553311,0.750979934 18.0553311,0.389855532 17.8340066,0.16694039 C17.6126821,-0.0556467968 17.254037,-0.0556467968 17.0329467,0.16694039 L9.00042166,8.25611765 L0.967006424,0.167268345 C0.745681892,-0.0553188426 0.387317931,-0.0553188426 0.165993399,0.167268345 C-0.0553311331,0.390136635 -0.0553311331,0.751261038 0.165993399,0.974176179 L8.13920499,9.00268191 L8.13911129,9.00268191 Z",
        fill: color
    }))));
}
//#endregion
//#region src/components/Tooltip/DefaultTooltip.tsx
function JoyrideDefaultTooltip(props) {
    const { backProps, closeProps, index, isLastStep, primaryProps, skipProps, step, tooltipProps } = props;
    const { buttons, content, styles, title } = step;
    const buttonElements = {};
    if (buttons.includes("primary")) buttonElements.primary = /* @__PURE__ */ (0, _reactDefault.default).createElement("button", {
        "data-testid": "button-primary",
        style: styles.buttonPrimary,
        type: "button",
        ...primaryProps
    });
    if (buttons.includes("skip") && !isLastStep) buttonElements.skip = /* @__PURE__ */ (0, _reactDefault.default).createElement("button", {
        "aria-live": "off",
        "data-testid": "button-skip",
        style: styles.buttonSkip,
        type: "button",
        ...skipProps
    });
    if (buttons.includes("back") && index > 0) buttonElements.back = /* @__PURE__ */ (0, _reactDefault.default).createElement("button", {
        "data-testid": "button-back",
        style: styles.buttonBack,
        type: "button",
        ...backProps
    });
    buttonElements.close = buttons.includes("close") && /* @__PURE__ */ (0, _reactDefault.default).createElement(JoyrideTooltipCloseButton, {
        "data-testid": "button-close",
        styles: styles.buttonClose,
        ...closeProps
    });
    const ariaProps = title ? {
        "aria-labelledby": "joyride-tooltip-title",
        "aria-describedby": "joyride-tooltip-content"
    } : {
        "aria-label": getReactNodeText(content),
        "aria-describedby": "joyride-tooltip-content"
    };
    return /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        key: "JoyrideTooltip",
        className: "react-joyride__tooltip",
        "data-joyride-step": index,
        ...step.id && {
            "data-joyride-id": step.id
        },
        style: styles.tooltip,
        ...tooltipProps,
        ...ariaProps
    }, /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        style: styles.tooltipContainer
    }, title && /* @__PURE__ */ (0, _reactDefault.default).createElement("h4", {
        id: "joyride-tooltip-title",
        style: styles.tooltipTitle
    }, title), /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        id: "joyride-tooltip-content",
        style: styles.tooltipContent
    }, content)), buttons.some((b)=>b === "back" || b === "primary" || b === "skip") && /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        style: styles.tooltipFooter
    }, /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        style: styles.tooltipFooterSpacer
    }, buttonElements.skip), buttonElements.back, buttonElements.primary), buttonElements.close);
}
//#endregion
//#region src/components/Tooltip/index.tsx
function Tooltip(props) {
    const { continuous, controls, index, isLastStep, size, step } = props;
    const handleClickBack = (event)=>{
        event.preventDefault();
        controls.prev(ORIGIN.BUTTON_BACK);
    };
    const handleClickClose = (event)=>{
        event.preventDefault();
        if (step.closeButtonAction === "skip") controls.skip(ORIGIN.BUTTON_CLOSE);
        else if (step.closeButtonAction === "replay") controls.replay(ORIGIN.BUTTON_CLOSE);
        else controls.close(ORIGIN.BUTTON_CLOSE);
    };
    const handleClickPrimary = (event)=>{
        event.preventDefault();
        if (!continuous) {
            controls.close(ORIGIN.BUTTON_PRIMARY);
            return;
        }
        controls.next(ORIGIN.BUTTON_PRIMARY);
    };
    const handleClickSkip = (event)=>{
        event.preventDefault();
        controls.skip(ORIGIN.BUTTON_SKIP);
    };
    const getElementsProps = ()=>{
        const { back, close, last, next, nextWithProgress, skip } = step.locale;
        const backText = getReactNodeText(back);
        const closeText = getReactNodeText(close);
        const lastText = getReactNodeText(last);
        const nextText = getReactNodeText(next);
        const skipText = getReactNodeText(skip);
        let primary = close;
        let primaryText = closeText;
        if (continuous) {
            primary = next;
            primaryText = nextText;
            if (step.showProgress && !isLastStep) {
                const labelWithProgress = getReactNodeText(nextWithProgress, {
                    step: index + 1,
                    steps: size
                });
                primary = replaceLocaleContent(nextWithProgress, index + 1, size);
                primaryText = labelWithProgress;
            }
            if (isLastStep) {
                primary = last;
                primaryText = lastText;
            }
        }
        return {
            backProps: {
                "aria-label": backText,
                children: back,
                "data-action": "back",
                onClick: handleClickBack,
                role: "button",
                title: backText
            },
            closeProps: {
                "aria-label": closeText,
                children: close,
                "data-action": "close",
                onClick: handleClickClose,
                role: "button",
                title: closeText
            },
            primaryProps: {
                "aria-label": primaryText,
                children: primary,
                "data-action": "primary",
                onClick: handleClickPrimary,
                role: "button",
                title: primaryText
            },
            skipProps: {
                "aria-label": skipText,
                children: skip,
                "data-action": "skip",
                onClick: handleClickSkip,
                role: "button",
                title: skipText
            },
            tooltipProps: {
                "aria-modal": true,
                role: "alertdialog"
            }
        };
    };
    const { arrowComponent, beaconComponent, tooltipComponent, ...stepProps } = step;
    let component;
    if (tooltipComponent) {
        const TooltipComponent = tooltipComponent;
        component = /* @__PURE__ */ (0, _reactDefault.default).createElement(TooltipComponent, {
            ...getElementsProps(),
            continuous,
            controls,
            index,
            isLastStep,
            size,
            step: stepProps
        });
    } else component = /* @__PURE__ */ (0, _reactDefault.default).createElement(JoyrideDefaultTooltip, {
        ...getElementsProps(),
        continuous,
        controls,
        index,
        isLastStep,
        size,
        step: stepProps
    });
    return component;
}
//#endregion
//#region src/components/Floater.tsx
function getFallbackPlacements(placement) {
    if (placement.startsWith("left")) return [
        "top",
        "bottom"
    ];
    if (placement.startsWith("right")) return [
        "bottom",
        "top"
    ];
}
function getFlipMiddleware(isAuto, step, tooltipPlacement) {
    if (isAuto) return [
        (0, _reactDom1.autoPlacement)()
    ];
    if (step.floatingOptions?.flipOptions === false) return [];
    return [
        (0, _reactDom1.flip)({
            crossAxis: false,
            fallbackPlacements: getFallbackPlacements(tooltipPlacement),
            padding: 20,
            ...step.floatingOptions?.flipOptions
        })
    ];
}
function JoyrideFloater(props) {
    const { continuous, controls, index, lifecycle, nonce, open, portalElement, setPositionData, setTooltipRef, shouldScroll, size, step, target, updateState } = props;
    const arrowRef = (0, _react.useRef)(null);
    const beaconMiddlewareRef = (0, _react.useRef)({});
    const tooltipMiddlewareRef = (0, _react.useRef)({});
    const isCenter = step.placement === "center";
    const isAuto = step.placement === "auto";
    const centerReference = (0, _react.useMemo)(()=>({
            getBoundingClientRect: ()=>({
                    x: window.innerWidth / 2,
                    y: window.innerHeight / 2,
                    top: window.innerHeight / 2,
                    left: window.innerWidth / 2,
                    bottom: window.innerHeight / 2,
                    right: window.innerWidth / 2,
                    width: 0,
                    height: 0
                })
        }), []);
    const scrollParent = (0, _react.useMemo)(()=>hasCustomScrollParent(target) ? getScrollParent(target) : void 0, [
        target
    ]);
    const isFixedTarget = (0, _react.useMemo)(()=>hasPosition(target), [
        target
    ]);
    const boundaryOptions = (0, _react.useMemo)(()=>scrollParent ? {
            boundary: scrollParent,
            rootBoundary: "viewport"
        } : {}, [
        scrollParent
    ]);
    const tooltipPlacement = isCenter || isAuto ? "bottom" : step.placement;
    const strategy = isCenter ? "fixed" : step.floatingOptions?.strategy ?? (step.isFixed || isFixedTarget ? "fixed" : "absolute");
    const tooltipMiddleware = (0, _react.useMemo)(()=>isCenter ? [
            {
                name: "center",
                fn: ({ rects })=>({
                        x: (window.innerWidth - rects.floating.width) / 2,
                        y: (window.innerHeight - rects.floating.height) / 2
                    })
            }
        ] : [
            (0, _reactDom1.offset)(({ placement: currentPlacement })=>{
                let side = "right";
                if (currentPlacement.startsWith("top")) side = "top";
                else if (currentPlacement.startsWith("bottom")) side = "bottom";
                else if (currentPlacement.startsWith("left")) side = "left";
                const padding = step.spotlightTarget ? 0 : step.spotlightPadding[side];
                return step.offset + padding + (step.floatingOptions?.hideArrow ? 0 : step.arrowSize);
            }, [
                step.offset,
                step.spotlightPadding,
                step.spotlightTarget,
                step.arrowSize,
                step.floatingOptions?.hideArrow
            ]),
            ...getFlipMiddleware(isAuto, step, tooltipPlacement),
            (0, _reactDom1.shift)({
                padding: 10,
                ...boundaryOptions,
                ...step.floatingOptions?.shiftOptions
            }),
            ...step.floatingOptions?.hideArrow ? [] : [
                (0, _reactDom1.arrow)({
                    element: arrowRef,
                    padding: step.arrowSpacing
                }, [
                    step.arrowSpacing,
                    step.arrowBase
                ])
            ],
            ...step.floatingOptions?.middleware ?? []
        ], [
        isCenter,
        step,
        isAuto,
        tooltipPlacement,
        boundaryOptions
    ]);
    const tooltipFloating = (0, _reactDom1.useFloating)({
        ...isCenter ? {
            elements: {
                reference: centerReference
            }
        } : {},
        placement: tooltipPlacement,
        strategy,
        middleware: tooltipMiddleware
    });
    const beaconFloating = (0, _reactDom1.useFloating)({
        strategy,
        placement: step.beaconPlacement ?? (isAuto || isCenter ? "bottom" : step.placement),
        middleware: (0, _react.useMemo)(()=>[
                (0, _reactDom1.offset)(step.floatingOptions?.beaconOptions?.offset ?? -18)
            ], [
            step.floatingOptions?.beaconOptions?.offset
        ]),
        whileElementsMounted: (0, _reactDom1.autoUpdate)
    });
    tooltipMiddlewareRef.current = tooltipFloating.middlewareData;
    beaconMiddlewareRef.current = beaconFloating.middlewareData;
    (0, _react.useEffect)(()=>{
        const { floating, reference } = tooltipFloating.elements;
        if (!reference || !floating || lifecycle !== LIFECYCLE.TOOLTIP) return;
        return (0, _reactDom1.autoUpdate)(reference, floating, tooltipFloating.update, step.floatingOptions?.autoUpdate);
    }, [
        lifecycle,
        tooltipFloating.update,
        step.floatingOptions?.autoUpdate,
        step.target,
        tooltipFloating.elements
    ]);
    (0, _react.useEffect)(()=>{
        if (!isCenter && target) tooltipFloating.refs.setReference(target);
        if (target) beaconFloating.refs.setReference(target);
    }, [
        beaconFloating.refs,
        isCenter,
        target,
        tooltipFloating.refs
    ]);
    (0, _react.useEffect)(()=>{
        if (tooltipFloating.isPositioned) setPositionData("tooltip", {
            placement: tooltipFloating.placement,
            x: tooltipFloating.x ?? 0,
            y: tooltipFloating.y ?? 0,
            middlewareData: tooltipMiddlewareRef.current
        });
    }, [
        setPositionData,
        tooltipFloating.isPositioned,
        tooltipFloating.placement,
        tooltipFloating.x,
        tooltipFloating.y
    ]);
    (0, _react.useEffect)(()=>{
        if (beaconFloating.isPositioned) setPositionData("beacon", {
            placement: beaconFloating.placement,
            x: beaconFloating.x ?? 0,
            y: beaconFloating.y ?? 0,
            middlewareData: beaconMiddlewareRef.current
        });
    }, [
        setPositionData,
        beaconFloating.isPositioned,
        beaconFloating.placement,
        beaconFloating.x,
        beaconFloating.y
    ]);
    const zIndex = step.zIndex + 1;
    const handleBeaconInteraction = (0, _react.useCallback)((event)=>{
        if (event.type === "mouseenter" && step.beaconTrigger !== "hover") return;
        updateState({
            lifecycle: LIFECYCLE.TOOLTIP_BEFORE,
            positioned: false
        });
    }, [
        step.beaconTrigger,
        updateState
    ]);
    const floaterRef = (0, _react.useCallback)((node)=>{
        if (node) {
            tooltipFloating.refs.setFloating(node);
            setTooltipRef(node);
        }
    }, [
        tooltipFloating.refs,
        setTooltipRef
    ]);
    const { arrow: arrowStyles, floater: floaterStyles } = step.styles;
    let content = null;
    if (lifecycle === LIFECYCLE.TOOLTIP || lifecycle === LIFECYCLE.TOOLTIP_BEFORE) {
        const styles = sortObjectKeys({
            ...floaterStyles,
            ...tooltipFloating.floatingStyles,
            zIndex,
            opacity: open && tooltipFloating.isPositioned ? 1 : 0,
            ...!open && {
                transition: "none"
            }
        });
        content = /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
            ref: floaterRef,
            className: "react-joyride__floater",
            "data-testid": "floater",
            id: `react-joyride-step-${index}`,
            style: styles
        }, /* @__PURE__ */ (0, _reactDefault.default).createElement(Tooltip, {
            continuous,
            controls,
            index,
            isLastStep: index + 1 === size,
            size,
            step
        }), !isCenter && !step.floatingOptions?.hideArrow && /* @__PURE__ */ (0, _reactDefault.default).createElement(Arrow, {
            arrowComponent: step.arrowComponent,
            arrowRef,
            base: step.arrowBase,
            placement: tooltipFloating.placement,
            position: tooltipFloating.middlewareData.arrow,
            size: step.arrowSize,
            styles: arrowStyles
        }));
    } else if (lifecycle === LIFECYCLE.BEACON || lifecycle === LIFECYCLE.BEACON_BEFORE) content = /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        ref: beaconFloating.refs.setFloating,
        className: "react-joyride__floater",
        "data-testid": "floater-beacon",
        id: `react-joyride-step-${index}-beacon`,
        style: sortObjectKeys({
            ...beaconFloating.floatingStyles,
            zIndex
        })
    }, /* @__PURE__ */ (0, _reactDefault.default).createElement(JoyrideBeacon, {
        beaconComponent: step.beaconComponent,
        continuous,
        index,
        isLastStep: index + 1 === size,
        locale: step.locale,
        nonce,
        onInteract: handleBeaconInteraction,
        shouldFocus: shouldScroll,
        size,
        step,
        styles: step.styles
    }));
    return /* @__PURE__ */ (0, _reactDefault.default).createElement(JoyridePortal, {
        element: portalElement
    }, content);
}
//#endregion
//#region src/components/Step.tsx
function JoyrideStep(props) {
    const { continuous, controls, index, lifecycle, nonce, portalElement, setPositionData, shouldScroll, size, step, updateState } = props;
    const [tooltipElement, setTooltipElement] = (0, _react.useState)(null);
    useFocusTrap(step.disableFocusTrap ? null : tooltipElement, "[data-action=primary]");
    const target = getElement(step.target);
    const open = lifecycle === LIFECYCLE.TOOLTIP;
    if (!validateStep(step) || !(0, _isLiteDefault.default).domElement(target)) return null;
    return /* @__PURE__ */ (0, _reactDefault.default).createElement(JoyrideFloater, {
        key: `JoyrideStep-${index}`,
        continuous,
        controls,
        index,
        lifecycle,
        nonce,
        open,
        portalElement,
        setPositionData,
        setTooltipRef: setTooltipElement,
        shouldScroll,
        size,
        step,
        target,
        updateState
    });
}
//#endregion
//#region src/components/TourRenderer.tsx
function TourRenderer({ controls, mergedProps, state, step, store }) {
    const { continuous, debug, nonce, portalElement, scrollToFirstStep } = mergedProps;
    const element = usePortalElement(portalElement);
    const { index, lifecycle, status } = state;
    const isRunning = status === STATUS.RUNNING;
    const [showLoader, setShowLoader] = (0, _react.useState)(false);
    const loaderTimerRef = (0, _react.useRef)(null);
    const loaderDelay = step?.loaderDelay ?? 0;
    (0, _react.useEffect)(()=>{
        if (state.waiting) {
            if (loaderDelay === 0) setShowLoader(true);
            else loaderTimerRef.current = setTimeout(()=>{
                setShowLoader(true);
            }, loaderDelay);
        } else setShowLoader(false);
        return ()=>{
            if (loaderTimerRef.current) {
                clearTimeout(loaderTimerRef.current);
                loaderTimerRef.current = null;
            }
        };
    }, [
        loaderDelay,
        state.waiting
    ]);
    (0, _react.useEffect)(()=>{
        if (!isRunning) return;
        const handleKeyboard = (event)=>{
            if (!step || lifecycle !== LIFECYCLE.TOOLTIP) return;
            if (event.key === "Escape" && step.dismissKeyAction) {
                if (step.dismissKeyAction === "next") controls.next(ORIGIN.KEYBOARD);
                else if (step.dismissKeyAction === "replay") controls.replay(ORIGIN.KEYBOARD);
                else controls.close(ORIGIN.KEYBOARD);
            }
        };
        document.body.addEventListener("keydown", handleKeyboard, {
            passive: true
        });
        return ()=>{
            document.body.removeEventListener("keydown", handleKeyboard);
        };
    }, [
        controls,
        isRunning,
        lifecycle,
        step
    ]);
    const handleClickOverlay = (0, _react.useCallback)(()=>{
        switch(step?.overlayClickAction){
            case "close":
                controls.close(ORIGIN.OVERLAY);
                break;
            case "next":
                controls.next(ORIGIN.OVERLAY);
                break;
            case "replay":
                controls.replay(ORIGIN.OVERLAY);
                break;
        }
    }, [
        controls,
        step?.overlayClickAction
    ]);
    if (!step || !isRunning) return null;
    const hideOverlay = state.action === ACTIONS.START && !step.skipBeacon && step.placement !== "center";
    return /* @__PURE__ */ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, lifecycle !== LIFECYCLE.INIT && /* @__PURE__ */ (0, _reactDefault.default).createElement(JoyrideStep, {
        ...state,
        continuous,
        controls,
        debug,
        nonce,
        portalElement: element,
        setPositionData: store.current.setPositionData,
        shouldScroll: !step.skipScroll && (index !== 0 || scrollToFirstStep),
        step,
        updateState: store.current.updateState
    }), /* @__PURE__ */ (0, _reactDefault.default).createElement(JoyridePortal, {
        element
    }, /* @__PURE__ */ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, showLoader && /* @__PURE__ */ (0, _reactDefault.default).createElement(JoyrideLoader, {
        nonce,
        step
    }), !hideOverlay && /* @__PURE__ */ (0, _reactDefault.default).createElement(JoyrideOverlay, {
        ...step,
        continuous,
        lifecycle,
        onClickOverlay: handleClickOverlay,
        portalElement: portalElement ? element : null,
        scrolling: state.scrolling,
        waiting: state.waiting
    }))));
}
//#endregion
//#region src/hooks/useJoyride.tsx
function useJoyride(props) {
    const { controls, failures, mergedProps, state, step, store } = useTourEngine(props);
    return {
        controls,
        failures,
        on: (0, _react.useCallback)((eventType, handler)=>store.current.on(eventType, handler), [
            store
        ]),
        state: (0, _react.useMemo)(()=>omit(state, "positioned"), [
            state
        ]),
        step,
        Tour: canUseDOM() ? /* @__PURE__ */ (0, _reactDefault.default).createElement(TourRenderer, {
            controls,
            mergedProps,
            state,
            step,
            store
        }) : null
    };
}
//#endregion
//#region src/index.tsx
function JoyrideTour(props) {
    const { Tour } = useJoyride(props);
    return Tour;
}
function Joyride(props) {
    if (!canUseDOM()) return null;
    return /* @__PURE__ */ (0, _reactDefault.default).createElement(JoyrideTour, props);
}

},{"react":"bmhQu","@gilbarbara/hooks":"iRGnN","use-sync-external-store/shim":"6U7cH","is-lite":"cblDZ","react-innertext":"7eADW","@fastify/deepmerge":"cHAmo","@gilbarbara/deep-equal":"eWw9j","scroll":"jrMUC","scrollparent":"fTXgd","react-dom":"82aNB","@floating-ui/react-dom":[["arrow","6FljV"],["autoPlacement","6FljV"],["flip","6FljV"],["offset","6FljV"],["shift","6FljV"],["useFloating","6FljV"],["autoUpdate","cPYMY"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iRGnN":[function(require,module,exports,__globalThis) {
// src/useBreakpoint.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "USE_FETCH_STATUS", ()=>USE_FETCH_STATUS);
parcelHelpers.export(exports, "useBreakpoint", ()=>useBreakpoint);
parcelHelpers.export(exports, "useCallbackDeepCompare", ()=>useCallbackDeepCompare);
parcelHelpers.export(exports, "useClickOutside", ()=>useClickOutside);
parcelHelpers.export(exports, "useDataChanges", ()=>useDataChanges);
parcelHelpers.export(exports, "useDebounce", ()=>useDebounce);
parcelHelpers.export(exports, "useEffectDeepCompare", ()=>useEffectDeepCompare);
parcelHelpers.export(exports, "useEffectOnce", ()=>useEffectOnce);
parcelHelpers.export(exports, "useElementMeasure", ()=>useElementMeasure);
parcelHelpers.export(exports, "useFetch", ()=>useFetch);
parcelHelpers.export(exports, "useHasChanged", ()=>useHasChanged);
parcelHelpers.export(exports, "useIntersectionObserver", ()=>useIntersectionObserver);
parcelHelpers.export(exports, "useInterval", ()=>useInterval);
parcelHelpers.export(exports, "useIsFirstRender", ()=>useIsFirstRender);
parcelHelpers.export(exports, "useIsMounted", ()=>useIsMounted);
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", ()=>useIsomorphicLayoutEffect);
parcelHelpers.export(exports, "useLatest", ()=>useLatest);
parcelHelpers.export(exports, "useLifecycleHooks", ()=>useLifecycleHooks);
parcelHelpers.export(exports, "useLocalStorage", ()=>useLocalStorage);
parcelHelpers.export(exports, "useLocation", ()=>useLocation);
parcelHelpers.export(exports, "useMediaQuery", ()=>useMediaQuery);
parcelHelpers.export(exports, "useMemoDeepCompare", ()=>useMemoDeepCompare);
parcelHelpers.export(exports, "useMemoizedValue", ()=>useMemoizedValue);
parcelHelpers.export(exports, "useMergeRefs", ()=>useMergeRefs);
parcelHelpers.export(exports, "useMount", ()=>useMount);
parcelHelpers.export(exports, "useOnce", ()=>useOnce);
parcelHelpers.export(exports, "usePersistentState", ()=>usePersistentState);
parcelHelpers.export(exports, "usePrevious", ()=>usePrevious);
parcelHelpers.export(exports, "useRenderCount", ()=>useRenderCount);
parcelHelpers.export(exports, "useResizeObserver", ()=>useResizeObserver);
parcelHelpers.export(exports, "useScript", ()=>useScript);
parcelHelpers.export(exports, "useSetState", ()=>useSetState);
parcelHelpers.export(exports, "useThrottle", ()=>useThrottle);
parcelHelpers.export(exports, "useThrottleValue", ()=>useThrottleValue);
parcelHelpers.export(exports, "useTimeout", ()=>useTimeout);
parcelHelpers.export(exports, "useToggle", ()=>useToggle);
parcelHelpers.export(exports, "useUnmount", ()=>useUnmount);
parcelHelpers.export(exports, "useUpdate", ()=>useUpdate);
parcelHelpers.export(exports, "useUpdateEffect", ()=>useUpdateEffect);
parcelHelpers.export(exports, "useWindowSize", ()=>useWindowSize);
var _react = require("react");
var _deepEqual = require("@gilbarbara/deep-equal");
var _deepEqualDefault = parcelHelpers.interopDefault(_deepEqual);
// src/utils.ts
function canUseDOM() {
    return !!(typeof window !== "undefined" && window?.document?.createElement);
}
function getElement(target) {
    if (!canUseDOM()) return null;
    let targetEl;
    if (typeof target === "string") targetEl = document.querySelector(target);
    else targetEl = target && "current" in target ? target.current : target;
    return targetEl;
}
function isPlainObject(value) {
    if (Object.prototype.toString.call(value) !== "[object Object]") return false;
    const prototype = Object.getPrototypeOf(value);
    return prototype === null || prototype === Object.getPrototypeOf({});
}
function isPrimitive(value) {
    return value !== Object(value);
}
function isString(value) {
    return typeof value === "string";
}
function isURL(value) {
    if (!isString(value)) return false;
    try {
        new URL(value);
        return true;
    } catch  {
        return false;
    }
}
function noop() {
    return void 0;
}
function off(target, ...rest) {
    if (target && target.removeEventListener) target.removeEventListener(...rest);
}
function on(target, ...rest) {
    if (target && target.addEventListener) target.addEventListener(...rest);
}
function validateDependencies(dependencies, name, fallback) {}
// src/useBreakpoint.tsx
var defaultBreakpoints = {
    xs: 0,
    sm: 400,
    md: 768,
    lg: 1024,
    xl: 1280
};
function useBreakpoint(customBreakpoints, initialWidth = Infinity, initialHeight = Infinity) {
    const breakpoints = customBreakpoints ?? defaultBreakpoints;
    const sizes = (0, _react.useMemo)(()=>Object.entries(breakpoints).sort(([, aSize], [, bSize])=>bSize - aSize), [
        breakpoints
    ]);
    const smallestBreakpoint = sizes[sizes.length - 1];
    smallestBreakpoint[1];
    const getScreen = (0, _react.useCallback)(()=>{
        const height = canUseDOM() ? window.innerHeight : initialHeight;
        const width = canUseDOM() ? window.innerWidth : initialWidth;
        const size = sizes.find(([, s])=>s <= width) || sizes[0];
        const orientation = width > height ? "landscape" : "portrait";
        return {
            between: (min, max, andOrientation)=>width >= breakpoints[min] && width < breakpoints[max] && (!andOrientation || andOrientation === orientation),
            min: (breakpoint, andOrientation)=>width >= breakpoints[breakpoint] && (!andOrientation || andOrientation === orientation),
            max: (breakpoint, andOrientation)=>width < breakpoints[breakpoint] && (!andOrientation || andOrientation === orientation),
            orientation,
            size: size[0]
        };
    }, [
        breakpoints,
        initialHeight,
        initialWidth,
        sizes
    ]);
    const [screen, setScreen] = (0, _react.useState)(getScreen);
    (0, _react.useEffect)(()=>{
        const onResize = ()=>{
            setScreen((previous)=>{
                const current = getScreen();
                return current.size !== previous.size || current.orientation !== previous.orientation ? current : previous;
            });
        };
        on(window, "resize", onResize);
        return ()=>off(window, "resize", onResize);
    }, [
        getScreen
    ]);
    return screen;
}
function useCallbackDeepCompare(callback, dependencies) {
    validateDependencies(dependencies, "useCallbackDeepCompare", "useCallback");
    const ref = (0, _react.useRef)(dependencies);
    const callbackRef = (0, _react.useRef)(callback);
    if (!(0, _deepEqualDefault.default)(dependencies, ref.current)) {
        ref.current = dependencies;
        callbackRef.current = callback;
    }
    return (0, _react.useCallback)((...arguments_)=>callbackRef.current(...arguments_), // eslint-disable-next-line react-hooks/exhaustive-deps
    ref.current);
}
function useEffectDeepCompare(effect, dependencies) {
    validateDependencies(dependencies, "useEffectDeepCompare", "useEffect");
    const ref = (0, _react.useRef)(dependencies);
    if (!(0, _deepEqualDefault.default)(dependencies, ref.current)) ref.current = dependencies;
    (0, _react.useEffect)(effect, ref.current);
}
function useIsFirstRender() {
    const isFirstRender = (0, _react.useRef)(true);
    if (isFirstRender.current) {
        isFirstRender.current = false;
        return true;
    }
    return isFirstRender.current;
}
// src/useMemoizedValue.ts
function useMemoizedValue(value) {
    const [stableValue, setStableValue] = (0, _react.useState)(()=>value);
    const isFirstRender = useIsFirstRender();
    useEffectDeepCompare(()=>{
        if (isFirstRender) return;
        setStableValue(()=>value);
    }, [
        value
    ]);
    return stableValue;
}
// src/useClickOutside.ts
function useClickOutside(callback) {
    const ref = (0, _react.useRef)(null);
    const memoizedCallback = useMemoizedValue(callback);
    (0, _react.useEffect)(()=>{
        const handleClick = (event)=>{
            if (!ref.current?.contains(event.target)) memoizedCallback();
        };
        on(document, "click", handleClick);
        return ()=>{
            off(document, "click", handleClick);
        };
    }, [
        memoizedCallback
    ]);
    return ref;
}
function useUpdateEffect(effect, dependencies) {
    const isFirstRender = useIsFirstRender();
    (0, _react.useEffect)(()=>{
        if (!isFirstRender) return effect();
        return void 0;
    }, dependencies);
}
// src/useDataChanges.tsx
function useDataChanges(data, nameOrOptions = {}) {
    const previousData = (0, _react.useRef)(data);
    const [changes, setChanges] = (0, _react.useState)(void 0);
    const { comparison = "shallow", name, only, skipLog = false } = useMemoizedValue(isString(nameOrOptions) ? {
        name: nameOrOptions
    } : nameOrOptions);
    useUpdateEffect(()=>{
        const keysToCheck = only ?? Object.keys({
            ...previousData.current,
            ...data
        });
        const changesObject = {};
        keysToCheck.forEach((key)=>{
            const hasChanged = comparison === "deep" ? !(0, _deepEqualDefault.default)(previousData.current[key], data[key]) : previousData.current[key] !== data[key];
            if (hasChanged) changesObject[key] = {
                from: previousData.current[key],
                to: data[key]
            };
        });
        const hasChanges = Object.keys(changesObject).length > 0;
        setChanges(hasChanges ? changesObject : void 0);
        if (hasChanges && !skipLog) {
            const nameToken = name ? `: ${name}` : "";
            console.log(`[data-changes${nameToken}]`, changesObject);
        }
        previousData.current = data;
    }, [
        name,
        data,
        only,
        comparison,
        skipLog
    ]);
    return changes;
}
function useDebounce(callback, delayMs = 250, dependencies = []) {
    const status = (0, _react.useRef)("pending");
    const timeout = (0, _react.useRef)(null);
    const savedCallback = (0, _react.useRef)(callback);
    const isFirstRender = useIsFirstRender();
    const clear = (0, _react.useCallback)(()=>{
        status.current = "cancelled";
        timeout.current && clearTimeout(timeout.current);
    }, []);
    const set = (0, _react.useCallback)(()=>{
        status.current = "pending";
        timeout.current && clearTimeout(timeout.current);
        timeout.current = setTimeout(()=>{
            status.current = "completed";
            savedCallback.current();
        }, delayMs);
    }, [
        delayMs
    ]);
    const getStatus = (0, _react.useCallback)(()=>status.current, []);
    (0, _react.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    useEffectDeepCompare(()=>{
        if (!isFirstRender) {
            set();
            return clear;
        }
        return void 0;
    }, [
        set,
        clear,
        dependencies,
        delayMs
    ]);
    return {
        cancel: clear,
        getStatus
    };
}
function useEffectOnce(effect) {
    const destroyFn = (0, _react.useRef)(null);
    const effectCalled = (0, _react.useRef)(false);
    const effectFn = (0, _react.useRef)(effect);
    (0, _react.useEffect)(()=>{
        if (!effectCalled.current) {
            destroyFn.current = effectFn.current();
            effectCalled.current = true;
        }
        return ()=>{
            if (destroyFn.current) {
                destroyFn.current();
                destroyFn.current = null;
            }
        };
    }, []);
}
// src/defaults.ts
var defaultElementDimensions = {
    absoluteHeight: 0,
    absoluteWidth: 0,
    bottom: 0,
    height: 0,
    left: 0,
    right: 0,
    top: 0,
    width: 0,
    x: 0,
    y: 0
};
var useIsomorphicLayoutEffect = canUseDOM() ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
function useResizeObserver(target, debounce = 0) {
    const [element, setElement] = (0, _react.useState)(getElement(target));
    const [value, setValue] = (0, _react.useState)();
    const timeoutRef = (0, _react.useRef)(null);
    const isFirstCall = (0, _react.useRef)(true);
    const observer = (0, _react.useMemo)(()=>{
        if (!canUseDOM()) return {};
        return new window.ResizeObserver((entries)=>{
            if (debounce && !isFirstCall.current) {
                if (timeoutRef.current) window.clearTimeout(timeoutRef.current);
                timeoutRef.current = window.setTimeout(()=>{
                    setValue(entries[0]);
                }, debounce);
                return;
            }
            setValue(entries[0]);
            isFirstCall.current = false;
        });
    }, [
        debounce
    ]);
    useIsomorphicLayoutEffect(()=>{
        setElement(getElement(target));
    }, [
        target
    ]);
    useIsomorphicLayoutEffect(()=>{
        if (!canUseDOM() || !(observer instanceof ResizeObserver)) return ()=>void 0;
        if (!element) return ()=>void 0;
        observer.observe(element);
        return ()=>{
            observer.disconnect();
        };
    }, [
        element,
        observer
    ]);
    return value;
}
// src/useElementMeasure.tsx
function getElementMeasure(element) {
    if (!canUseDOM() || !element) return defaultElementDimensions;
    const { bottom, height, left, right, top, width, x, y } = element.getBoundingClientRect();
    const { borderBottom, borderLeft, borderRight, borderTop, paddingBottom, paddingLeft, paddingRight, paddingTop } = getComputedStyle(element);
    return {
        absoluteHeight: height - parseFloatValue(paddingTop) - parseFloatValue(paddingBottom) - parseFloatValue(borderTop) - parseFloatValue(borderBottom),
        absoluteWidth: width - parseFloatValue(paddingLeft) - parseFloatValue(paddingRight) - parseFloatValue(borderLeft) - parseFloatValue(borderRight),
        bottom,
        height,
        left,
        right,
        top,
        width,
        x,
        y
    };
}
function parseFloatValue(value) {
    const parsed = parseFloat(value);
    return Number.isNaN(parsed) ? 0 : parsed;
}
function useElementMeasure(target, debounce = 0) {
    const [element, setElement] = (0, _react.useState)(getElement(target));
    const [dimensions, setDimensions] = (0, _react.useState)(getElementMeasure(element));
    const entry = useResizeObserver(element, debounce);
    useIsomorphicLayoutEffect(()=>{
        const nextElement = getElement(target);
        setElement(nextElement);
        setDimensions(getElementMeasure(nextElement));
    }, [
        target
    ]);
    useIsomorphicLayoutEffect(()=>{
        if (!entry) return;
        const { bottom, height, left, right, top, width, x, y } = entry.contentRect;
        const { blockSize, inlineSize } = entry.borderBoxSize[0];
        setDimensions({
            absoluteHeight: blockSize,
            absoluteWidth: inlineSize,
            bottom,
            height,
            left,
            right,
            top,
            width,
            x,
            y
        });
    }, [
        entry
    ]);
    return dimensions;
}
function useIsMounted() {
    const isMounted = (0, _react.useRef)(false);
    (0, _react.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, _react.useCallback)(()=>isMounted.current, []);
}
function usePrevious(state) {
    const ref = (0, _react.useRef)(void 0);
    (0, _react.useEffect)(()=>{
        ref.current = state;
    });
    return ref.current;
}
function useSetState(initialState = {}) {
    const [state, set] = (0, _react.useState)(initialState);
    const setState = (0, _react.useCallback)((patch)=>{
        set((previousState)=>({
                ...previousState,
                ...patch instanceof Function ? patch(previousState) : patch
            }));
    }, []);
    return [
        state,
        setState
    ];
}
// src/useFetch.ts
var USE_FETCH_STATUS = {
    IDLE: "IDLE",
    LOADING: "LOADING",
    SUCCESS: "SUCCESS",
    ERROR: "ERROR"
};
var globalCache = /* @__PURE__ */ new Map();
async function request(options) {
    const { body, headers = {}, method = "GET", mode = "cors", type = "json", url = "" } = options;
    const contentTypes = {
        json: "application/json",
        urlencoded: "application/x-www-form-urlencoded"
    };
    const params = {
        body: void 0,
        cache: "no-store",
        headers: {
            Accept: "application/json",
            "Content-Type": contentTypes[type],
            ...headers
        },
        method,
        mode,
        credentials: void 0
    };
    if (body) params.body = isPlainObject(body) && type === "json" ? JSON.stringify(body) : body;
    try {
        const response = await fetch(url, params);
        let content;
        try {
            content = await response.json();
        } catch  {
            content = await response.text();
        }
        if (response.status > 299) {
            const error = new Error(response.statusText);
            error.status = response.status;
            error.response = content;
            throw error;
        }
        return content;
    } catch (error) {
        const fetchError = new Error("Network request failed");
        fetchError.status = 0;
        fetchError.response = error instanceof Error ? error.message : error;
        throw fetchError;
    }
}
var useFetchCache = {
    /**
   * Retrieve data from the cache.
   * @param url The URL to retrieve data for.
   * @returns Cached data or `undefined` if not found or expired.
   */ get (url) {
        const cached = globalCache.get(url);
        if (cached && Date.now() < cached.expiry) return cached;
        globalCache.delete(url);
        return void 0;
    },
    /**
   * Set data in the cache.
   * @param url The URL to cache data for.
   * @param data The data to cache.
   * @param ttl Time-to-live in milliseconds.
   */ set (url, data, ttl) {
        globalCache.set(url, {
            data,
            expiry: Date.now() + ttl
        });
    },
    /**
   * Clear the cache.
   * @param url Optional URL to clear. Clears all cache if not specified.
   */ clear (url) {
        if (url) globalCache.delete(url);
        else globalCache.clear();
    },
    /**
   * Check if a URL is cached and still valid.
   * @param url The URL to check.
   * @returns `true` if cached and valid, `false` otherwise.
   */ has (url) {
        const cached = globalCache.get(url);
        return !!cached && Date.now() < cached.expiry;
    }
};
function useFetch(urlOrOptions) {
    const { cacheTTL = 0, onError, onFinally, onLoading, onSuccess, retries = 0, retryDelay = (attempt)=>attempt * 1e3, wait = false, ...options } = useMemoizedValue(isURL(urlOrOptions) ? {
        type: "json",
        url: urlOrOptions
    } : urlOrOptions);
    const [{ data, error, isCached, retryCount, status, url }, setState] = useSetState({
        data: void 0,
        error: void 0,
        isCached: false,
        retryCount: null,
        status: USE_FETCH_STATUS.IDLE,
        url: options.url
    });
    const isMounted = useIsMounted();
    const previousRetryCount = usePrevious(retryCount);
    if (!isPlainObject(options) || !isURL(url)) throw new Error("Expected an options object or URL");
    const getData = (0, _react.useCallback)((eraseData)=>{
        setState((s)=>({
                data: eraseData ? void 0 : s.data,
                error: void 0,
                isCached: false,
                status: USE_FETCH_STATUS.LOADING
            }));
        onLoading?.();
        if (cacheTTL && useFetchCache.has(url) && !eraseData) {
            const cached = useFetchCache.get(url);
            if (cached) {
                setState({
                    data: cached.data,
                    error: void 0,
                    isCached: true,
                    status: USE_FETCH_STATUS.SUCCESS
                });
                onSuccess?.(cached.data);
                onFinally?.();
                return;
            }
        }
        request({
            ...options
        }).then((response)=>{
            if (!isMounted()) return;
            if (cacheTTL) useFetchCache.set(url, response, cacheTTL);
            setState({
                data: response,
                retryCount: null,
                status: USE_FETCH_STATUS.SUCCESS
            });
            onSuccess?.(response);
        }).catch((responseError)=>{
            if (!isMounted()) return;
            const counter = retryCount ?? 0;
            if (!retries || counter >= retries) {
                setState({
                    error: responseError,
                    status: USE_FETCH_STATUS.ERROR
                });
                onError?.(responseError);
            }
            if (retries && counter < retries) setState({
                retryCount: counter + 1
            });
        }).finally(()=>{
            if (isMounted()) onFinally?.();
        });
    }, [
        cacheTTL,
        isMounted,
        onError,
        onFinally,
        onLoading,
        onSuccess,
        options,
        retries,
        retryCount,
        setState,
        url
    ]);
    (0, _react.useEffect)(()=>{
        if (url !== options.url) setState({
            data: void 0,
            error: void 0,
            status: USE_FETCH_STATUS.IDLE,
            url: options.url
        });
    }, [
        options.url,
        setState,
        url
    ]);
    (0, _react.useEffect)(()=>{
        if (status === USE_FETCH_STATUS.IDLE && !wait) getData();
    }, [
        getData,
        status,
        wait
    ]);
    (0, _react.useEffect)(()=>{
        if (retries && typeof retryCount === "number" && retryCount !== previousRetryCount) setTimeout(getData, typeof retryDelay === "function" ? retryDelay(retryCount) : retryDelay);
    }, [
        getData,
        previousRetryCount,
        retries,
        retryCount,
        retryDelay
    ]);
    const isError = (0, _react.useCallback)(()=>status === USE_FETCH_STATUS.ERROR, [
        status
    ]);
    const isFetched = (0, _react.useCallback)(()=>[
            USE_FETCH_STATUS.SUCCESS,
            USE_FETCH_STATUS.ERROR
        ].includes(status), [
        status
    ]);
    const isLoading = (0, _react.useCallback)(()=>status === USE_FETCH_STATUS.LOADING, [
        status
    ]);
    const isPaused = (0, _react.useCallback)(()=>status === USE_FETCH_STATUS.IDLE && wait, [
        status,
        wait
    ]);
    const isSuccess = (0, _react.useCallback)(()=>status === USE_FETCH_STATUS.SUCCESS, [
        status
    ]);
    const refetch = (0, _react.useCallback)((eraseData = false)=>getData(eraseData), [
        getData
    ]);
    return (0, _react.useMemo)(()=>({
            data,
            error,
            isCached,
            isError,
            isFetched,
            isLoading,
            isPaused,
            isSuccess,
            refetch,
            retryCount,
            status,
            url
        }), [
        data,
        error,
        isCached,
        isError,
        isFetched,
        isLoading,
        isPaused,
        isSuccess,
        refetch,
        retryCount,
        status,
        url
    ]);
}
function useHasChanged(value, callback) {
    const previous = usePrevious(value);
    const hasChanged = typeof previous !== "undefined" && previous !== value;
    (0, _react.useEffect)(()=>{
        if (hasChanged) callback?.(previous);
    }, [
        callback,
        hasChanged,
        previous
    ]);
    return [
        hasChanged,
        previous
    ];
}
function useIntersectionObserver(target, options) {
    const { delay = 0, once = false, root = null, rootMargin = "0%", threshold = 0 } = options || {};
    const [value, setValue] = (0, _react.useState)();
    const disabled = value?.isIntersecting && once;
    const observer = (0, _react.useMemo)(()=>{
        if (!canUseDOM()) return {};
        return new IntersectionObserver(([entry])=>{
            if (delay) {
                setTimeout(()=>setValue(entry), delay);
                return;
            }
            setValue(entry);
        }, {
            threshold,
            root,
            rootMargin
        });
    }, [
        delay,
        root,
        rootMargin,
        threshold
    ]);
    (0, _react.useEffect)(()=>{
        if (!canUseDOM() || !(observer instanceof IntersectionObserver) || disabled) return ()=>void 0;
        const element = getElement(target);
        if (!element) return ()=>void 0;
        observer.observe(element);
        return ()=>observer.disconnect();
    }, [
        target,
        root,
        rootMargin,
        disabled,
        observer
    ]);
    return value;
}
function useInterval(callback, delayMs = 100) {
    const savedCallback = (0, _react.useRef)(callback);
    (0, _react.useEffect)(()=>{
        savedCallback.current = callback;
    });
    (0, _react.useEffect)(()=>{
        if (delayMs !== null) {
            const interval = setInterval(()=>savedCallback.current(), delayMs);
            return ()=>{
                clearInterval(interval);
            };
        }
        return void 0;
    }, [
        delayMs
    ]);
}
function useLatest(value) {
    const ref = (0, _react.useRef)(value);
    (0, _react.useEffect)(()=>{
        ref.current = value;
    });
    return ref;
}
function useLifecycleHooks(mount, unmount) {
    (0, _react.useEffect)(()=>{
        mount();
        return unmount;
    }, []);
}
function useLocalStorageHook(key, initialValue, options) {
    if (!key) throw new Error('useLocalStorage: "key" is required');
    const deserializer = (0, _react.useMemo)(()=>options?.raw ? (value)=>value : options?.deserializer ?? JSON.parse, [
        options
    ]);
    const serializer = (0, _react.useMemo)(()=>options?.raw ? String : options?.serializer ?? JSON.stringify, [
        options
    ]);
    const initializer = (0, _react.useRef)((k)=>{
        try {
            const localStorageValue = localStorage.getItem(k);
            if (localStorageValue !== null) return deserializer(localStorageValue);
            initialValue && localStorage.setItem(k, serializer(initialValue));
            return initialValue;
        } catch  {
            return initialValue;
        }
    });
    const [state, setState] = (0, _react.useState)(()=>initializer.current(key));
    (0, _react.useLayoutEffect)(()=>setState(initializer.current(key)), [
        key
    ]);
    const set = (0, _react.useCallback)((patch)=>{
        try {
            const newState = patch instanceof Function ? patch(state) : patch;
            if (typeof newState === "undefined") return;
            let value;
            if (options) {
                if (options.raw) value = typeof newState === "string" ? newState : JSON.stringify(newState);
                else if (options?.serializer) value = options.serializer(newState);
                else value = JSON.stringify(newState);
            } else value = JSON.stringify(newState);
            localStorage.setItem(key, value);
            setState(deserializer(value));
        } catch  {}
    }, [
        deserializer,
        key,
        options,
        state
    ]);
    const remove = (0, _react.useCallback)(()=>{
        try {
            localStorage.removeItem(key);
            setState(void 0);
        } catch  {}
    }, [
        key,
        setState
    ]);
    return [
        state,
        set,
        remove
    ];
}
function useLocalStorageSSR(_key, initialValue, _options) {
    return [
        initialValue,
        noop,
        noop
    ];
}
var useLocalStorage = canUseDOM() ? useLocalStorageHook : useLocalStorageSSR;
// src/useLocation.ts
function useLocation() {
    const { hash, host, hostname, href, origin, pathname, port, protocol, search } = window.location;
    const query = search ? search.slice(1).split("&").reduce((acc, pair)=>{
        const [key, value] = pair.split("=");
        if (key && value) acc[key] = value;
        return acc;
    }, {}) : {};
    return {
        hash,
        host,
        hostname,
        href,
        origin,
        pathname,
        port,
        protocol,
        query,
        search
    };
}
function useMediaQuery(input) {
    const getMatches = (query)=>{
        if (!canUseDOM()) return false;
        return window.matchMedia(query).matches;
    };
    const [matches, setMatches] = (0, _react.useState)(getMatches(input));
    function handleChange() {
        setMatches(getMatches(input));
    }
    (0, _react.useEffect)(()=>{
        const matchMedia = window.matchMedia(input);
        handleChange();
        try {
            matchMedia.addEventListener("change", handleChange);
        } catch  {
            matchMedia.addListener(handleChange);
        }
        return ()=>{
            try {
                matchMedia.removeEventListener("change", handleChange);
            } catch  {
                matchMedia.removeListener(handleChange);
            }
        };
    }, [
        input
    ]);
    return matches;
}
function useMemoDeepCompare(factory, dependencies) {
    validateDependencies(dependencies, "useMemoDeepCompare", "useMemo");
    const ref = (0, _react.useRef)(dependencies);
    if (!(0, _deepEqualDefault.default)(dependencies, ref.current)) ref.current = dependencies;
    return (0, _react.useMemo)(factory, ref.current);
}
function useMergeRefs(...refs) {
    return (0, _react.useCallback)((value)=>{
        for (const ref of refs){
            if (typeof ref === "function") ref(value);
            else if (ref && typeof ref === "object") ref.current = value;
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    refs);
}
function useMount(callback) {
    (0, _react.useEffect)(()=>{
        callback();
    }, []);
}
function useOnce(callback) {
    const hasBeenCalled = (0, _react.useRef)(false);
    if (hasBeenCalled.current) return;
    callback();
    hasBeenCalled.current = true;
}
// src/usePersistentState.ts
function getState(initialState, savedState, shouldOverride, restoreProperties) {
    if (shouldOverride) {
        const initialStateKeys = Object.keys(initialState);
        const savedStateKeys = savedState ? Object.keys(savedState) : [];
        const restorePropertiesKeys = restoreProperties ? Object.keys(restoreProperties) : [];
        if (![
            ...initialStateKeys,
            ...restorePropertiesKeys
        ].every((k)=>savedStateKeys.includes(k))) return {
            ...initialState,
            ...restoreProperties
        };
        return {
            ...savedState,
            ...restoreProperties
        };
    }
    return {
        ...savedState,
        ...restoreProperties
    };
}
function usePersistentState(key, initialState, options) {
    const { overrideDivergentSavedState = false, resetProperties } = options || {};
    const [value, setValue, remove] = useLocalStorage(key, initialState);
    const [state, setState] = useSetState(getState(initialState, value, overrideDivergentSavedState, resetProperties));
    useEffectDeepCompare(()=>{
        setValue(state);
    }, [
        setValue,
        state
    ]);
    return [
        state,
        setState,
        remove
    ];
}
function useRenderCount(name) {
    const count = (0, _react.useRef)(1);
    (0, _react.useEffect)(()=>{
        count.current += 1;
    });
    console.log(`%c${name || "RenderCount"}: %c${count.current}`, "font-size: 14px;  font-weight: bold;", "color: #999; font-size: 14px;");
    return count.current;
}
function useScript(src, idOrOptions = {}) {
    const options = (0, _react.useMemo)(()=>isString(idOrOptions) ? {
            id: idOrOptions
        } : idOrOptions, [
        idOrOptions
    ]);
    const script = (0, _react.useRef)(null);
    const [state, setState] = (0, _react.useState)({
        loaded: false,
        error: false
    });
    const onLoad = (0, _react.useCallback)(()=>{
        setState({
            loaded: true,
            error: false
        });
    }, []);
    const onError = (0, _react.useCallback)(()=>{
        if (script.current) script.current.remove();
        setState({
            loaded: false,
            error: true
        });
    }, []);
    (0, _react.useEffect)(()=>{
        if (!canUseDOM() || script.current) return void 0;
        const element = document.createElement("script");
        element.async = options.async ?? true;
        element.defer = options.defer ?? false;
        element.type = options.type || "text/javascript";
        element.id = options.id || src;
        element.src = src;
        script.current = element;
        const { current } = script;
        on(current, "load", onLoad);
        on(current, "error", onError);
        document.body.appendChild(current);
        return ()=>{
            off(current, "load", onLoad);
            off(current, "error", onError);
        };
    }, [
        onError,
        onLoad,
        options,
        src
    ]);
    return [
        state.loaded,
        state.error
    ];
}
function useUnmount(callback) {
    const callbackRef = useLatest(callback);
    (0, _react.useEffect)(()=>{
        return ()=>callbackRef.current();
    }, []);
}
// src/useThrottle.ts
function useThrottle(callback, delayMs = 500, trailing = false) {
    const [now, setNow] = (0, _react.useState)(0);
    const callbackRef = (0, _react.useRef)(callback);
    const hasPendingCall = (0, _react.useRef)(false);
    const timer = (0, _react.useRef)(void 0);
    (0, _react.useEffect)(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    (0, _react.useEffect)(()=>{
        if (!now) return;
        if (!timer.current) {
            callbackRef.current();
            const timerCallback = ()=>{
                if (hasPendingCall.current) {
                    hasPendingCall.current = false;
                    if (trailing) callbackRef.current();
                    timer.current = void 0;
                } else timer.current = void 0;
            };
            timer.current = window.setTimeout(timerCallback, delayMs);
        } else hasPendingCall.current = true;
    }, [
        delayMs,
        now,
        trailing
    ]);
    useUnmount(()=>{
        window.clearTimeout(timer.current);
        timer.current = void 0;
    });
    return ()=>setNow(Date.now());
}
function useThrottleValue(value, delayMs) {
    const [throttledValue, setThrottledValue] = (0, _react.useState)(value);
    const hasNextValue = (0, _react.useRef)(false);
    const nextValue = (0, _react.useRef)(null);
    const timer = (0, _react.useRef)(void 0);
    (0, _react.useEffect)(()=>{
        if (!timer.current) {
            setThrottledValue(value);
            const timeoutCallback = ()=>{
                if (hasNextValue.current) {
                    hasNextValue.current = false;
                    setThrottledValue(nextValue.current);
                    timer.current = window.setTimeout(timeoutCallback, delayMs);
                } else timer.current = void 0;
            };
            timer.current = window.setTimeout(timeoutCallback, delayMs);
        } else {
            hasNextValue.current = true;
            nextValue.current = value;
        }
    }, [
        delayMs,
        value
    ]);
    useUnmount(()=>{
        window.clearTimeout(timer.current);
        timer.current = void 0;
    });
    return throttledValue;
}
function useTimeout(callback, delayMs = 0) {
    const status = (0, _react.useRef)("pending");
    const timeout = (0, _react.useRef)(null);
    const savedCallback = (0, _react.useRef)(callback);
    const clear = (0, _react.useCallback)(()=>{
        status.current = "cancelled";
        timeout.current && clearTimeout(timeout.current);
    }, []);
    const set = (0, _react.useCallback)(()=>{
        status.current = "pending";
        timeout.current && clearTimeout(timeout.current);
        timeout.current = setTimeout(()=>{
            status.current = "completed";
            savedCallback.current();
        }, delayMs);
    }, [
        delayMs
    ]);
    const getStatus = (0, _react.useCallback)(()=>status.current, []);
    (0, _react.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, _react.useEffect)(()=>{
        set();
        return clear;
    }, [
        set,
        clear
    ]);
    return {
        cancel: clear,
        getStatus,
        reset: set
    };
}
function useToggle(initialValue = true) {
    const [value, toggle] = (0, _react.useReducer)((state, nextValue)=>typeof nextValue === "boolean" ? nextValue : !state, initialValue);
    const toggleOn = (0, _react.useCallback)(()=>toggle(true), []);
    const toggleOff = (0, _react.useCallback)(()=>toggle(false), []);
    return [
        value,
        {
            toggle,
            toggleOn,
            toggleOff
        }
    ];
}
var updateReducer = (number)=>(number + 1) % 1e6;
function useUpdate() {
    const [, update] = (0, _react.useReducer)(updateReducer, 0);
    return update;
}
function useWindowSize(debounce = 0) {
    const [size, setSize] = (0, _react.useState)({
        height: canUseDOM() ? window.innerHeight : 0,
        width: canUseDOM() ? window.innerWidth : 0
    });
    const timeoutRef = (0, _react.useRef)(0);
    const handleResize = (0, _react.useRef)(()=>{
        window.clearTimeout(timeoutRef.current);
        timeoutRef.current = window.setTimeout(()=>{
            setSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        }, debounce);
    });
    (0, _react.useEffect)(()=>{
        if (!canUseDOM()) return ()=>void 0;
        const getSize = handleResize.current;
        setSize({
            height: window.innerHeight,
            width: window.innerWidth
        });
        on(window, "resize", getSize);
        return ()=>{
            off(window, "resize", getSize);
        };
    }, []);
    return size;
}

},{"react":"bmhQu","@gilbarbara/deep-equal":"eWw9j","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eWw9j":[function(require,module,exports,__globalThis) {
// src/helpers.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>equal);
function isOfType(type) {
    return (value)=>typeof value === type;
}
var isFunction = isOfType("function");
var isNull = (value)=>{
    return value === null;
};
var isRegex = (value)=>{
    return Object.prototype.toString.call(value).slice(8, -1) === "RegExp";
};
var isObject = (value)=>{
    return !isUndefined(value) && !isNull(value) && (isFunction(value) || typeof value === "object");
};
var isUndefined = isOfType("undefined");
// src/index.ts
function compareObjects(left, right, seen) {
    if (hasSeen(seen, left, right)) return true;
    markSeen(seen, left, right);
    if (left.constructor !== right.constructor) return false;
    if (Array.isArray(left) && Array.isArray(right)) return equalArray(left, right, seen);
    if (left instanceof Map && right instanceof Map) return equalMap(left, right, seen);
    if (left instanceof Set && right instanceof Set) return equalSet(left, right);
    if (left instanceof WeakMap || left instanceof WeakSet) return false;
    if (ArrayBuffer.isView(left) && ArrayBuffer.isView(right)) return equalArrayBuffer(left, right);
    if (isRegex(left) && isRegex(right)) return left.source === right.source && left.flags === right.flags;
    if (left instanceof Error && right instanceof Error) return equalError(left, right, seen);
    if (left.valueOf !== Object.prototype.valueOf) return left.valueOf() === right.valueOf();
    if (left.toString !== Object.prototype.toString) return left.toString() === right.toString();
    return equalPlainObject(left, right, seen);
}
function compareValues(left, right, seen) {
    if (left === right) return true;
    if (Number.isNaN(left) && Number.isNaN(right)) return true;
    if (!left || !isObject(left) || !right || !isObject(right)) return false;
    return compareObjects(left, right, seen);
}
function equalArray(left, right, seen) {
    const { length } = left;
    if (length !== right.length) return false;
    for(let index = length; index-- !== 0;){
        if (!compareValues(left[index], right[index], seen)) return false;
    }
    return true;
}
function equalArrayBuffer(left, right) {
    if (left.byteLength !== right.byteLength) return false;
    const view1 = new DataView(left.buffer);
    const view2 = new DataView(right.buffer);
    let index = left.byteLength;
    while(index--){
        if (view1.getUint8(index) !== view2.getUint8(index)) return false;
    }
    return true;
}
function equalError(left, right, seen) {
    return left.message === right.message && left.name === right.name && compareValues(left.cause, right.cause, seen);
}
function equalMap(left, right, seen) {
    if (left.size !== right.size) return false;
    for (const entry of left.entries()){
        if (!right.has(entry[0])) return false;
    }
    for (const entry of left.entries()){
        if (!compareValues(entry[1], right.get(entry[0]), seen)) return false;
    }
    return true;
}
function equalPlainObject(left, right, seen) {
    const leftKeys = Object.keys(left);
    if (leftKeys.length !== Object.keys(right).length) return false;
    for(let index = leftKeys.length; index-- !== 0;){
        if (!Object.prototype.hasOwnProperty.call(right, leftKeys[index])) return false;
    }
    for(let index = leftKeys.length; index-- !== 0;){
        const key = leftKeys[index];
        if (key === "_owner" && left.$$typeof) continue;
        if (!compareValues(left[key], right[key], seen)) return false;
    }
    return true;
}
function equalSet(left, right) {
    if (left.size !== right.size) return false;
    for (const entry of left.entries()){
        if (!right.has(entry[0])) return false;
    }
    return true;
}
function hasSeen(seen, left, right) {
    return seen.get(left)?.has(right) ?? false;
}
function markSeen(seen, left, right) {
    let set = seen.get(left);
    if (!set) {
        set = /* @__PURE__ */ new WeakSet();
        seen.set(left, set);
    }
    set.add(right);
}
function equal(left, right) {
    return compareValues(left, right, /* @__PURE__ */ new WeakMap());
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6U7cH":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("3e3e060a1c619377");

},{"3e3e060a1c619377":"adP2B"}],"adP2B":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("a18024ece7b3cd12");
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is, useState = React.useState, useEffect = React.useEffect, useLayoutEffect = React.useLayoutEffect, useDebugValue = React.useDebugValue;
function useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    useEffect(function() {
        checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    useDebugValue(value);
    return value;
}
function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$1 : useSyncExternalStore$2;
exports.useSyncExternalStore = void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;

},{"a18024ece7b3cd12":"bmhQu"}],"cblDZ":[function(require,module,exports,__globalThis) {
// src/helpers.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>index_default) /* v8 ignore next -- @preserve */ ;
var objectTypes = [
    "Array",
    "ArrayBuffer",
    "AsyncFunction",
    "AsyncGenerator",
    "AsyncGeneratorFunction",
    "Date",
    "Error",
    "Function",
    "Generator",
    "GeneratorFunction",
    "HTMLElement",
    "Map",
    "Object",
    "Promise",
    "RegExp",
    "Set",
    "URL",
    "WeakMap",
    "WeakSet"
];
var primitiveTypes = [
    "bigint",
    "boolean",
    "null",
    "number",
    "string",
    "symbol",
    "undefined"
];
function getObjectType(value) {
    const objectTypeName = Object.prototype.toString.call(value).slice(8, -1);
    if (/HTML\w+Element/.test(objectTypeName)) return "HTMLElement";
    if (isObjectType(objectTypeName)) return objectTypeName;
    return void 0;
}
function isObjectOfType(type) {
    return (value)=>getObjectType(value) === type;
}
function isObjectType(name) {
    return objectTypes.includes(name);
}
function isOfType(type) {
    return (value)=>typeof value === type;
}
function isPrimitiveType(name) {
    return primitiveTypes.includes(name);
}
// src/standalone.ts
var DOM_PROPERTIES_TO_CHECK = [
    "innerHTML",
    "ownerDocument",
    "style",
    "attributes",
    "nodeValue"
];
var isArray = (value)=>Array.isArray(value);
var isAsyncGeneratorFunction = (value)=>getObjectType(value) === "AsyncGeneratorFunction";
var isAsyncFunction = /* @__PURE__ */ isObjectOfType("AsyncFunction");
var isBigInt = /* @__PURE__ */ isOfType("bigint");
var isBoolean = (value)=>{
    return value === true || value === false;
};
var isDate = /* @__PURE__ */ isObjectOfType("Date");
var isError = /* @__PURE__ */ isObjectOfType("Error");
var isFunction = /* @__PURE__ */ isOfType("function");
var isGeneratorFunction = /* @__PURE__ */ isObjectOfType("GeneratorFunction");
var isInteger = (value)=>{
    return typeof value === "number" && Number.isInteger(value);
};
var isMap = /* @__PURE__ */ isObjectOfType("Map");
var isNan = (value)=>{
    return Number.isNaN(value);
};
var isNull = (value)=>{
    return value === null;
};
var isPlainFunction = /* @__PURE__ */ isObjectOfType("Function");
var isPromise = /* @__PURE__ */ isObjectOfType("Promise");
var isRegexp = /* @__PURE__ */ isObjectOfType("RegExp");
var isSet = /* @__PURE__ */ isObjectOfType("Set");
var isString = /* @__PURE__ */ isOfType("string");
var isSymbol = /* @__PURE__ */ isOfType("symbol");
var isUndefined = /* @__PURE__ */ isOfType("undefined");
var isWeakMap = /* @__PURE__ */ isObjectOfType("WeakMap");
var isWeakSet = /* @__PURE__ */ isObjectOfType("WeakSet");
var isNullOrUndefined = (value)=>{
    return isNull(value) || isUndefined(value);
};
var isDefined = (value)=>!isUndefined(value);
var isNumber = (value)=>{
    return isOfType("number")(value) && !isNan(value);
};
var isNonEmptyString = (value)=>{
    return isString(value) && value.trim().length > 0;
};
var isNumericString = (value)=>{
    if (!isString(value) || value.length === 0) return false;
    const trimmed = value.trim();
    return trimmed.length > 0 && Number.isFinite(Number(trimmed));
};
var isObject = (value)=>{
    return !isNullOrUndefined(value) && (isFunction(value) || typeof value === "object");
};
var isPlainObject = (value)=>{
    if (getObjectType(value) !== "Object") return false;
    const prototype = Object.getPrototypeOf(value);
    return prototype === null || prototype === Object.getPrototypeOf({});
};
var isPrimitive = (value)=>isNull(value) || isPrimitiveType(typeof value);
var isUrl = (value)=>{
    return getObjectType(value) === "URL";
};
var isIterable = (value)=>{
    return !isNullOrUndefined(value) && isFunction(value[Symbol.iterator]);
};
var isGenerator = (value)=>{
    return isIterable(value) && isFunction(value.next) && isFunction(value.throw);
};
var isClass = (value)=>{
    return isFunction(value) && /^class\s/.test(value.toString());
};
var isArrayOf = (target, predicate)=>{
    if (!isArray(target) || !isFunction(predicate)) return false;
    return target.every((d)=>predicate(d));
};
var isDomElement = (value)=>{
    return isObject(value) && !isPlainObject(value) && value.nodeType === 1 && isString(value.nodeName) && DOM_PROPERTIES_TO_CHECK.every((property)=>property in value);
};
var isEmpty = (value)=>{
    return isString(value) && value.length === 0 || isArray(value) && value.length === 0 || isObject(value) && !isMap(value) && !isSet(value) && Object.keys(value).length === 0 || isSet(value) && value.size === 0 || isMap(value) && value.size === 0;
};
var isInstanceOf = (instance, class_)=>{
    if (!instance || !class_) return false;
    return Object.getPrototypeOf(instance) === class_.prototype;
};
var isOneOf = (target, value)=>{
    if (!isArray(target)) return false;
    return target.indexOf(value) > -1;
};
var isPropertyOf = (target, key, predicate)=>{
    if (!isObject(target) || !key) return false;
    const value = target[key];
    if (isFunction(predicate)) return predicate(value);
    return isDefined(value);
};
// src/index.ts
function is(value) {
    if (value === null) return "null";
    switch(typeof value){
        case "bigint":
            return "bigint";
        case "boolean":
            return "boolean";
        case "number":
            return "number";
        case "string":
            return "string";
        case "symbol":
            return "symbol";
        case "undefined":
            return "undefined";
        default:
    }
    if (isArray(value)) return "Array";
    if (isPlainFunction(value)) return "Function";
    const tagType = getObjectType(value);
    if (tagType) return tagType;
    return "Object";
}
is.array = isArray;
is.arrayOf = isArrayOf;
is.asyncGeneratorFunction = isAsyncGeneratorFunction;
is.asyncFunction = isAsyncFunction;
is.bigint = isBigInt;
is.boolean = isBoolean;
is.class = isClass;
is.date = isDate;
is.defined = isDefined;
is.domElement = isDomElement;
is.empty = isEmpty;
is.error = isError;
is.function = isFunction;
is.generator = isGenerator;
is.generatorFunction = isGeneratorFunction;
is.instanceOf = isInstanceOf;
is.integer = isInteger;
is.iterable = isIterable;
is.map = isMap;
is.nan = isNan;
is.null = isNull;
is.nullOrUndefined = isNullOrUndefined;
is.nonEmptyString = isNonEmptyString;
is.number = isNumber;
is.numericString = isNumericString;
is.object = isObject;
is.oneOf = isOneOf;
is.plainFunction = isPlainFunction;
is.plainObject = isPlainObject;
is.primitive = isPrimitive;
is.promise = isPromise;
is.propertyOf = isPropertyOf;
is.regexp = isRegexp;
is.set = isSet;
is.string = isString;
is.symbol = isSymbol;
is.undefined = isUndefined;
is.url = isUrl;
is.weakMap = isWeakMap;
is.weakSet = isWeakSet;
var index_default = is;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7eADW":[function(require,module,exports,__globalThis) {
"use strict";
var hasProps = function(jsx) {
    return Object.prototype.hasOwnProperty.call(jsx, 'props');
};
var reduceJsxToString = function(previous, current) {
    return previous + innerText(current);
};
var innerText = function(jsx) {
    if (jsx === null || typeof jsx === 'boolean' || typeof jsx === 'undefined') return '';
    if (typeof jsx === 'number') return jsx.toString();
    if (typeof jsx === 'string') return jsx;
    if (Array.isArray(jsx)) return jsx.reduce(reduceJsxToString, '');
    if (hasProps(jsx) && Object.prototype.hasOwnProperty.call(jsx.props, 'children')) return innerText(jsx.props.children);
    return '';
};
innerText.default = innerText;
module.exports = innerText;

},{}],"cHAmo":[function(require,module,exports,__globalThis) {
'use strict';
// based on https://github.com/TehShrike/deepmerge
// MIT License
// Copyright (c) 2012 - 2022 James Halliday, Josh Duff, and other contributors of deepmerge
const JSON_PROTO = Object.getPrototypeOf({});
function defaultIsMergeableObjectFactory() {
    return function defaultIsMergeableObject(value) {
        return typeof value === 'object' && value !== null && !(value instanceof RegExp) && !(value instanceof Date);
    };
}
function deepmergeConstructor(options) {
    function isNotPrototypeKey(value) {
        return value !== 'constructor' && value !== 'prototype' && value !== '__proto__';
    }
    function cloneArray(value) {
        let i = 0;
        const il = value.length;
        const result = new Array(il);
        for(i; i < il; ++i)result[i] = clone(value[i]);
        return result;
    }
    function cloneObject(target) {
        const result = {};
        if (cloneProtoObject && Object.getPrototypeOf(target) !== JSON_PROTO) return cloneProtoObject(target);
        const targetKeys = getKeys(target);
        let i, il, key;
        for(i = 0, il = targetKeys.length; i < il; ++i)isNotPrototypeKey(key = targetKeys[i]) && (result[key] = clone(target[key]));
        return result;
    }
    function concatArrays(target, source) {
        const tl = target.length;
        const sl = source.length;
        let i = 0;
        const result = new Array(tl + sl);
        for(i; i < tl; ++i)result[i] = clone(target[i]);
        for(i = 0; i < sl; ++i)result[i + tl] = clone(source[i]);
        return result;
    }
    const propertyIsEnumerable = Object.prototype.propertyIsEnumerable;
    function getSymbolsAndKeys(value) {
        const result = Object.keys(value);
        const keys = Object.getOwnPropertySymbols(value);
        for(let i = 0, il = keys.length; i < il; ++i)propertyIsEnumerable.call(value, keys[i]) && result.push(keys[i]);
        return result;
    }
    const getKeys = options?.symbols ? getSymbolsAndKeys : Object.keys;
    const cloneProtoObject = typeof options?.cloneProtoObject === 'function' ? options.cloneProtoObject : undefined;
    const isMergeableObject = typeof options?.isMergeableObject === 'function' ? options.isMergeableObject : defaultIsMergeableObjectFactory();
    const onlyDefinedProperties = options?.onlyDefinedProperties === true;
    function isPrimitive(value) {
        return typeof value !== 'object' || value === null;
    }
    const mergeArray = options && typeof options.mergeArray === 'function' ? options.mergeArray({
        clone,
        deepmerge: _deepmerge,
        getKeys,
        isMergeableObject
    }) : concatArrays;
    function clone(entry) {
        return isMergeableObject(entry) ? Array.isArray(entry) ? cloneArray(entry) : cloneObject(entry) : entry;
    }
    function mergeObject(target, source) {
        const result = {};
        const targetKeys = getKeys(target);
        const sourceKeys = getKeys(source);
        let i, il, key;
        for(i = 0, il = targetKeys.length; i < il; ++i)isNotPrototypeKey(key = targetKeys[i]) && sourceKeys.indexOf(key) === -1 && (result[key] = clone(target[key]));
        for(i = 0, il = sourceKeys.length; i < il; ++i){
            if (!isNotPrototypeKey(key = sourceKeys[i])) continue;
            if (key in target) {
                if (targetKeys.indexOf(key) !== -1) {
                    if (cloneProtoObject && isMergeableObject(source[key]) && Object.getPrototypeOf(source[key]) !== JSON_PROTO) result[key] = cloneProtoObject(source[key]);
                    else result[key] = _deepmerge(target[key], source[key]);
                }
            } else {
                if (onlyDefinedProperties && typeof source[key] === 'undefined') continue;
                result[key] = clone(source[key]);
            }
        }
        return result;
    }
    function _deepmerge(target, source) {
        if (onlyDefinedProperties && typeof source === 'undefined') return clone(target);
        const sourceIsArray = Array.isArray(source);
        const targetIsArray = Array.isArray(target);
        if (isPrimitive(source)) return source;
        else if (!isMergeableObject(target)) return clone(source);
        else if (sourceIsArray && targetIsArray) return mergeArray(target, source);
        else if (sourceIsArray !== targetIsArray) return clone(source);
        else return mergeObject(target, source);
    }
    function _deepmergeAll() {
        switch(arguments.length){
            case 0:
                return {};
            case 1:
                return clone(arguments[0]);
            case 2:
                return _deepmerge(arguments[0], arguments[1]);
        }
        let result;
        for(let i = 0, il = arguments.length; i < il; ++i)result = _deepmerge(result, arguments[i]);
        return result;
    }
    return options?.all ? _deepmergeAll : _deepmerge;
}
module.exports = deepmergeConstructor;
module.exports.default = deepmergeConstructor;
module.exports.deepmerge = deepmergeConstructor;
Object.defineProperty(module.exports, 'isMergeableObject', {
    get: defaultIsMergeableObjectFactory
});

},{}],"jrMUC":[function(require,module,exports,__globalThis) {
var E_NOSCROLL = new Error('Element already at target scroll position');
var E_CANCELLED = new Error('Scroll cancelled');
var min = Math.min;
var ms = Date.now;
module.exports = {
    left: make('scrollLeft'),
    top: make('scrollTop')
};
function make(prop) {
    return function scroll(el, to, opts, cb) {
        opts = opts || {};
        if (typeof opts == 'function') cb = opts, opts = {};
        if (typeof cb != 'function') cb = noop;
        var start = ms();
        var from = el[prop];
        var ease = opts.ease || inOutSine;
        var duration = !isNaN(opts.duration) ? +opts.duration : 350;
        var cancelled = false;
        return from === to ? cb(E_NOSCROLL, el[prop]) : requestAnimationFrame(animate), cancel;
        function cancel() {
            cancelled = true;
        }
        function animate(timestamp) {
            if (cancelled) return cb(E_CANCELLED, el[prop]);
            var now = ms();
            var time = min(1, (now - start) / duration);
            var eased = ease(time);
            el[prop] = eased * (to - from) + from;
            time < 1 ? requestAnimationFrame(animate) : requestAnimationFrame(function() {
                cb(null, el[prop]);
            });
        }
    };
}
function inOutSine(n) {
    return 0.5 * (1 - Math.cos(Math.PI * n));
}
function noop() {}

},{}],"fTXgd":[function(require,module,exports,__globalThis) {
(function(root, factory) {
    if (typeof define === "function" && define.amd) define([], factory);
    else if (module.exports) module.exports = factory();
    else root.Scrollparent = factory();
})(this, function() {
    function isScrolling(node) {
        var overflow = getComputedStyle(node, null).getPropertyValue("overflow");
        return overflow.indexOf("scroll") > -1 || overflow.indexOf("auto") > -1;
    }
    function scrollParent(node) {
        if (!(node instanceof HTMLElement || node instanceof SVGElement)) return undefined;
        var current = node.parentNode;
        while(current.parentNode){
            if (isScrolling(current)) return current;
            current = current.parentNode;
        }
        return document.scrollingElement || document.documentElement;
    }
    return scrollParent;
});

},{}],"6FljV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "autoUpdate", ()=>(0, _dom.autoUpdate));
parcelHelpers.export(exports, "computePosition", ()=>(0, _dom.computePosition));
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _dom.detectOverflow));
parcelHelpers.export(exports, "getOverflowAncestors", ()=>(0, _dom.getOverflowAncestors));
parcelHelpers.export(exports, "platform", ()=>(0, _dom.platform));
parcelHelpers.export(exports, "arrow", ()=>arrow);
parcelHelpers.export(exports, "autoPlacement", ()=>autoPlacement);
parcelHelpers.export(exports, "flip", ()=>flip);
parcelHelpers.export(exports, "hide", ()=>hide);
parcelHelpers.export(exports, "inline", ()=>inline);
parcelHelpers.export(exports, "limitShift", ()=>limitShift);
parcelHelpers.export(exports, "offset", ()=>offset);
parcelHelpers.export(exports, "shift", ()=>shift);
parcelHelpers.export(exports, "size", ()=>size);
parcelHelpers.export(exports, "useFloating", ()=>useFloating);
var _dom = require("@floating-ui/dom");
var _react = require("react");
var _reactDom = require("react-dom");
var isClient = typeof document !== 'undefined';
var noop = function noop() {};
var index = isClient ? (0, _react.useLayoutEffect) : noop;
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function getDPR(element) {
    if (typeof window === 'undefined') return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function roundByDPR(element, value) {
    const dpr = getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function useLatestRef(value) {
    const ref = _react.useRef(value);
    index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function useFloating(options) {
    if (options === void 0) options = {};
    const { placement = 'bottom', strategy = 'absolute', middleware = [], platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform = true, whileElementsMounted, open } = options;
    const [data, setData] = _react.useState({
        x: 0,
        y: 0,
        strategy,
        placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = _react.useState(middleware);
    if (!deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = _react.useState(null);
    const [_floating, _setFloating] = _react.useState(null);
    const setReference = _react.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = _react.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = _react.useRef(null);
    const floatingRef = _react.useRef(null);
    const dataRef = _react.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = useLatestRef(whileElementsMounted);
    const platformRef = useLatestRef(platform);
    const openRef = useLatestRef(open);
    const update = _react.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement,
            strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, _dom.computePosition)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                _reactDom.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = _react.useRef(false);
    index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = _react.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference,
            setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = _react.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = _react.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = roundByDPR(elements.floating, data.x);
        const y = roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...getDPR(elements.floating) >= 1.5 && {
                willChange: 'transform'
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return _react.useMemo(()=>({
            ...data,
            update,
            refs,
            elements,
            floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options,
        fn (state) {
            const { element, padding } = typeof options === 'function' ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, _dom.arrow)({
                    element: element.current,
                    padding
                }).fn(state);
                return {};
            }
            if (element) return (0, _dom.arrow)({
                element,
                padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const offset = (options, deps)=>{
    const result = (0, _dom.offset)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const shift = (options, deps)=>{
    const result = (0, _dom.shift)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const limitShift = (options, deps)=>{
    const result = (0, _dom.limitShift)(options);
    return {
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const flip = (options, deps)=>{
    const result = (0, _dom.flip)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const size = (options, deps)=>{
    const result = (0, _dom.size)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const autoPlacement = (options, deps)=>{
    const result = (0, _dom.autoPlacement)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const hide = (options, deps)=>{
    const result = (0, _dom.hide)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const inline = (options, deps)=>{
    const result = (0, _dom.inline)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow = (options, deps)=>{
    const result = arrow$1(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};

},{"@floating-ui/dom":"cPYMY","react":"bmhQu","react-dom":"82aNB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cPYMY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOverflowAncestors", ()=>(0, _dom.getOverflowAncestors));
parcelHelpers.export(exports, "arrow", ()=>arrow);
parcelHelpers.export(exports, "autoPlacement", ()=>autoPlacement);
parcelHelpers.export(exports, "autoUpdate", ()=>autoUpdate);
parcelHelpers.export(exports, "computePosition", ()=>computePosition);
parcelHelpers.export(exports, "detectOverflow", ()=>detectOverflow);
parcelHelpers.export(exports, "flip", ()=>flip);
parcelHelpers.export(exports, "hide", ()=>hide);
parcelHelpers.export(exports, "inline", ()=>inline);
parcelHelpers.export(exports, "limitShift", ()=>limitShift);
parcelHelpers.export(exports, "offset", ()=>offset);
parcelHelpers.export(exports, "platform", ()=>platform);
parcelHelpers.export(exports, "shift", ()=>shift);
parcelHelpers.export(exports, "size", ()=>size);
var _core = require("@floating-ui/core");
var _utils = require("@floating-ui/utils");
var _dom = require("@floating-ui/utils/dom");
function getCssDimensions(element) {
    const css = (0, _dom.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, _dom.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, _utils.round)(width) !== offsetWidth || (0, _utils.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width,
        height,
        $: shouldFallback
    };
}
function unwrapElement(element) {
    return !(0, _dom.isElement)(element) ? element.contextElement : element;
}
function getScale(element) {
    const domElement = unwrapElement(element);
    if (!(0, _dom.isHTMLElement)(domElement)) return (0, _utils.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width, height, $ } = getCssDimensions(domElement);
    let x = ($ ? (0, _utils.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, _utils.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x,
        y
    };
}
const noOffsets = /*#__PURE__*/ (0, _utils.createCoords)(0);
function getVisualOffsets(element) {
    const win = (0, _dom.getWindow)(element);
    if (!(0, _dom.isWebKit)() || !win.visualViewport) return noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    return !!floatingOffsetParent && isFixed && floatingOffsetParent === (0, _dom.getWindow)(element);
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = unwrapElement(element);
    let scale = (0, _utils.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, _dom.isElement)(offsetParent)) scale = getScale(offsetParent);
        } else scale = getScale(element);
    }
    const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : (0, _utils.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement && offsetParent) {
        const win = (0, _dom.getWindow)(domElement);
        const offsetWin = (0, _dom.isElement)(offsetParent) ? (0, _dom.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, _dom.getFrameElement)(currentWin);
        while(currentIFrame && offsetWin !== currentWin){
            const iframeScale = getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, _dom.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, _dom.getWindow)(currentIFrame);
            currentIFrame = (0, _dom.getFrameElement)(currentWin);
        }
    }
    return (0, _core.rectToClientRect)({
        width,
        height,
        x,
        y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function getWindowScrollBarX(element, rect) {
    const leftScroll = (0, _dom.getNodeScroll)(element).scrollLeft;
    if (!rect) return getBoundingClientRect((0, _dom.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x,
        y
    };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements, rect, offsetParent, strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, _dom.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, _dom.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, _utils.createCoords)(1);
    const offsets = (0, _utils.createCoords)(0);
    const isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== 'body' || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = getBoundingClientRect(offsetParent);
            scale = getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : (0, _utils.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function getClientRects(element) {
    return element.getClientRects ? Array.from(element.getClientRects()) : [];
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(html) {
    const scroll = (0, _dom.getNodeScroll)(html);
    const body = html.ownerDocument.body;
    const width = (0, _utils.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, _utils.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + getWindowScrollBarX(html);
    const y = -scroll.scrollTop;
    if ((0, _dom.getComputedStyle)(body).direction === 'rtl') x += (0, _utils.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width,
        height,
        x,
        y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const SCROLLBAR_MAX = 25;
function getViewportRect(element, strategy, rootBoundary) {
    if (rootBoundary === void 0) rootBoundary = 'viewport';
    const isLayoutViewport = rootBoundary === 'layoutViewport';
    const win = (0, _dom.getWindow)(element);
    const html = (0, _dom.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        // Client coordinates are relative to the layout viewport, except in
        // WebKit with an `absolute` strategy, where they are relative to the
        // visual viewport.
        const layoutRelativeClientCoords = !(0, _dom.isWebKit)() || strategy === 'fixed';
        if (isLayoutViewport) {
            if (!layoutRelativeClientCoords) {
                x = -visualViewport.offsetLeft;
                y = -visualViewport.offsetTop;
            }
        } else {
            width = visualViewport.width;
            height = visualViewport.height;
            if (layoutRelativeClientCoords) {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
    }
    const windowScrollbarX = getWindowScrollBarX(html);
    // `scrollbar-gutter: stable` on the <html> reserves gutter space that shrinks
    // the visual width but isn't reflected in `html.clientWidth`, so subtract it.
    // Only the inline-end (right) gutter can hold the scrollbar; `both-edges` also
    // reserves an empty inline-start gutter that clips nothing, so exclude just
    // the one scrollbar-side gutter — halve the measured (two-gutter) total. A
    // left-side scrollbar (`windowScrollbarX > 0`) is already handled by
    // `getHTMLOffset`/`visualViewport.width`; skip it here.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const reservedWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        const gutter = getComputedStyle(html).scrollbarGutter === 'stable both-edges' ? reservedWidth / 2 : reservedWidth;
        if (gutter <= SCROLLBAR_MAX) width -= gutter;
    }
    return {
        width,
        height,
        x,
        y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
    const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = getScale(element);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width,
        height,
        x,
        y
    };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport' || clippingAncestor === 'layoutViewport') rect = getViewportRect(element, strategy, clippingAncestor);
    else if (clippingAncestor === 'document') rect = getDocumentRect((0, _dom.getDocumentElement)(element));
    else if ((0, _dom.isElement)(clippingAncestor)) rect = getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, _core.rectToClientRect)(rect);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, _dom.getOverflowAncestors)(element, [], false).filter((el)=>(0, _dom.isElement)(el) && (0, _dom.getNodeName)(el) !== 'body');
    let lastKeptComputedStyle = null;
    const elementIsFixed = (0, _dom.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, _dom.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, _dom.isElement)(currentNode) && !(0, _dom.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, _dom.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, _dom.isContainingBlock)(currentNode);
        // Position of the containing block chain below the current node. A fixed
        // element whose containing block hasn't been found yet is a fixed chain.
        const lastPosition = lastKeptComputedStyle ? lastKeptComputedStyle.position : elementIsFixed ? 'fixed' : '';
        // A non-containing ancestor does not clip the element when the chain
        // below it escapes it: a fixed chain escapes all ancestors up to the
        // next containing block, an absolute chain escapes static ancestors.
        const shouldDropCurrentNode = !currentNodeIsContaining && (lastPosition === 'fixed' || lastPosition === 'absolute' && computedStyle.position === 'static');
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // The kept node carries the chain position for the next iteration.
        lastKeptComputedStyle = computedStyle;
        currentNode = (0, _dom.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
    let { element, boundary, rootBoundary, strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, _dom.isTopLayer)(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, _utils.max)(rect.top, top);
        right = (0, _utils.min)(rect.right, right);
        bottom = (0, _utils.min)(rect.bottom, bottom);
        left = (0, _utils.max)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function getDimensions(element) {
    const { width, height } = getCssDimensions(element);
    return {
        width,
        height
    };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    const documentElement = (0, _dom.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, _utils.createCoords)(0);
    if (isOffsetParentAnElement || !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== 'body' || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    if (!isOffsetParentAnElement && documentElement) offsets.x = getWindowScrollBarX(documentElement);
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : (0, _utils.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x,
        y,
        width: rect.width,
        height: rect.height
    };
}
function isStaticPositioned(element) {
    return (0, _dom.getComputedStyle)(element).position === 'static';
}
function getTrueOffsetParent(element, polyfill) {
    if (!(0, _dom.isHTMLElement)(element) || (0, _dom.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, _dom.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
    const win = (0, _dom.getWindow)(element);
    if ((0, _dom.isTopLayer)(element)) return win;
    if (!(0, _dom.isHTMLElement)(element)) {
        let svgOffsetParent = (0, _dom.getParentNode)(element);
        while(svgOffsetParent && !(0, _dom.isLastTraversableNode)(svgOffsetParent)){
            if ((0, _dom.isElement)(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, _dom.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, _dom.isTableElement)(offsetParent) && isStaticPositioned(offsetParent))offsetParent = getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, _dom.isLastTraversableNode)(offsetParent) && isStaticPositioned(offsetParent) && !(0, _dom.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, _dom.getContainingBlock)(element) || win;
}
const getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function isRTL(element) {
    return (0, _dom.getComputedStyle)(element).direction === 'rtl';
}
const platform = {
    convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: (0, _dom.getDocumentElement),
    getClippingRect,
    getOffsetParent,
    getElementRects,
    getClientRects,
    getDimensions,
    getScale,
    isElement: (0, _dom.isElement),
    isRTL
};
function rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove, ancestorResize) {
    let io = null;
    let timeoutId;
    const root = (0, _dom.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left, top, width, height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, _utils.floor)(top);
        const insetRight = (0, _utils.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, _utils.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, _utils.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin,
            threshold: (0, _utils.max)(0, (0, _utils.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            // The entry is a snapshot, so the reference may have moved since the
            // intersection was computed (under performance constraints, or between
            // consecutive frames of a multi-frame layout shift). The reported ratio
            // and the observed area are stale in that case and cannot be trusted to
            // detect subsequent movement, so refresh regardless of the ratio.
            if (!rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) return refresh();
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped in place, the ratio is 0. Throttle
                // the refresh to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    const win = (0, _dom.getWindow)(element);
    // The window is a resize ancestor, so when `ancestorResize` is enabled its
    // listener already runs the update on resize. Here we only need to rebuild
    // the `IntersectionObserver` for the new root size, skipping a redundant
    // update. When `ancestorResize` is disabled, this becomes the sole update.
    const handleResize = ()=>refresh(ancestorResize);
    win.addEventListener('resize', handleResize);
    refresh(true);
    return ()=>{
        win.removeEventListener('resize', handleResize);
        cleanup();
    };
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function autoUpdate(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll = true, ancestorResize = true, elementResize = typeof ResizeObserver === 'function', layoutShift = typeof IntersectionObserver === 'function', animationFrame = false } = options;
    const referenceEl = unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, _dom.getOverflowAncestors)(referenceEl) : [],
        ...floating ? (0, _dom.getOverflowAncestors)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update);
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update, ancestorResize) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = getBoundingClientRect(reference);
        if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const detectOverflow = (0, _core.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const offset = (0, _core.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const autoPlacement = (0, _core.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const shift = (0, _core.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const flip = (0, _core.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const size = (0, _core.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const hide = (0, _core.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow = (0, _core.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const inline = (0, _core.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const limitShift = (0, _core.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const computePosition = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = options != null ? options : {};
    const platformWithCache = {
        ...platform,
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, _core.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

},{"@floating-ui/core":"htuEA","@floating-ui/utils":"cm9mC","@floating-ui/utils/dom":"5Sjup","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"htuEA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rectToClientRect", ()=>(0, _utils.rectToClientRect));
parcelHelpers.export(exports, "arrow", ()=>arrow);
parcelHelpers.export(exports, "autoPlacement", ()=>autoPlacement);
parcelHelpers.export(exports, "computePosition", ()=>computePosition);
parcelHelpers.export(exports, "detectOverflow", ()=>detectOverflow);
parcelHelpers.export(exports, "flip", ()=>flip);
parcelHelpers.export(exports, "hide", ()=>hide);
parcelHelpers.export(exports, "inline", ()=>inline);
parcelHelpers.export(exports, "limitShift", ()=>limitShift);
parcelHelpers.export(exports, "offset", ()=>offset);
parcelHelpers.export(exports, "shift", ()=>shift);
parcelHelpers.export(exports, "size", ()=>size);
var _utils = require("@floating-ui/utils");
function computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference, floating } = _ref;
    const sideAxis = (0, _utils.getSideAxis)(placement);
    const alignmentAxis = (0, _utils.getAlignmentAxis)(placement);
    const alignLength = (0, _utils.getAxisLength)(alignmentAxis);
    const side = (0, _utils.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    const alignment = (0, _utils.getAlignment)(placement);
    if (alignment) coords[alignmentAxis] += commonAlign * (alignment === 'end' ? 1 : -1) * (rtl && isVertical ? -1 : 1);
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function detectOverflow(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x, y, platform, rects, elements, strategy } = state;
    const { boundary = 'clippingAncestors', rootBoundary = 'viewport', elementContext = 'floating', altBoundary = false, padding = 0 } = (0, _utils.evaluate)(options, state);
    const paddingObject = (0, _utils.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, _utils.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary,
        rootBoundary,
        strategy
    }));
    const rect = elementContext === 'floating' ? {
        x,
        y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) && await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, _utils.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements,
        rect,
        offsetParent,
        strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const computePosition = async (reference, floating, config)=>{
    const { placement = 'bottom', strategy = 'absolute', middleware = [], platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference,
        floating,
        strategy
    });
    let { x, y } = computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name, fn } = currentMiddleware;
        const { x: nextX, y: nextY, data, reset } = await fn({
            x,
            y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy,
            middlewareData,
            rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference,
                floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference,
                    floating,
                    strategy
                }) : reset.rects;
                ({ x, y } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x,
        y,
        placement: statefulPlacement,
        strategy,
        middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow = (options)=>({
        name: 'arrow',
        options,
        async fn (state) {
            const { x, y, placement, rects, platform, elements, middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element, padding = 0 } = (0, _utils.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, _utils.getPaddingObject)(padding);
            const coords = {
                x,
                y
            };
            const axis = (0, _utils.getAlignmentAxis)(placement);
            const length = (0, _utils.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, _utils.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, _utils.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, _utils.clamp)(minPadding, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, _utils.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < minPadding ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < minPadding ? center - minPadding : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, _utils.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, _utils.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, _utils.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, _utils.getAlignment)(placement) === alignment || (autoAlignment ? (0, _utils.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const autoPlacement = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects, middlewareData, placement, platform, elements } = state;
            const { crossAxis = false, alignment, allowedPlacements = (0, _utils.placements), autoAlignment = true, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, _utils.placements) ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const alignmentSides = (0, _utils.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            const currentOverflows = [
                overflow[(0, _utils.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, _utils.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, _utils.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const flip = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement, middlewareData, rects, initialPlacement, platform, elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy = 'bestFit', fallbackAxisSideDirection = 'none', flipAlignment = true, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, _utils.getSide)(placement);
            const initialSideAxis = (0, _utils.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, _utils.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, _utils.getOppositePlacement)(initialPlacement)
            ] : (0, _utils.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, _utils.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, _utils.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement,
                    overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, _utils.getSideAxis)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, _utils.getSideAxis)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, _utils.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function isAnySideFullyClipped(overflow) {
    return (0, _utils.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const hide = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options,
        async fn (state) {
            const { rects, platform } = state;
            const { strategy = 'referenceHidden', ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function getBoundingRect(rects) {
    const minX = (0, _utils.min)(...rects.map((rect)=>rect.left));
    const minY = (0, _utils.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, _utils.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, _utils.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, _utils.rectToClientRect)(getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const inline = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options,
        async fn (state) {
            const { placement, elements, rects, platform, strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding = 2, x, y } = (0, _utils.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            // No rects (e.g. a hidden or detached reference, or a collapsed range) —
            // keep the existing reference rect rather than resetting to an invalid
            // one with non-finite values.
            if (!nativeClientRects.length) return {};
            const clientRects = getRectsByLine(nativeClientRects);
            const fallback = (0, _utils.rectToClientRect)(getBoundingRect(nativeClientRects));
            const paddingObject = (0, _utils.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && (clientRects[0].left > clientRects[1].right || clientRects[1].left > clientRects[0].right) && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, _utils.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, _utils.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        return (0, _utils.rectToClientRect)({
                            x: left,
                            y: top,
                            width: right - left,
                            height: bottom - top
                        });
                    }
                    const isLeftSide = (0, _utils.getSide)(placement) === 'left';
                    const maxRight = (0, _utils.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, _utils.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    return (0, _utils.rectToClientRect)({
                        x: minLeft,
                        y: top,
                        width: maxRight - minLeft,
                        height: bottom - top
                    });
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect
                },
                floating: elements.floating,
                strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function convertValueToCoords(state, options) {
    const { placement, platform, elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, _utils.getSide)(placement);
    const alignment = (0, _utils.getAlignment)(placement);
    const isVertical = (0, _utils.getSideAxis)(placement) === 'y';
    const mainAxisMulti = originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, _utils.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis, crossAxis, alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const offset = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x, y, placement, middlewareData } = state;
            const diffCoords = await convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const shift = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options,
        async fn (state) {
            const { x, y, placement, platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter = {
                fn: (_ref)=>{
                    let { x, y } = _ref;
                    return {
                        x,
                        y
                    };
                }
            }, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const coords = {
                x,
                y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, _utils.getSideAxis)(placement);
            const mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const clampCoord = (axis, coord)=>(0, _utils.clamp)(coord + overflow[axis === 'y' ? 'top' : 'left'], coord, coord - overflow[axis === 'y' ? 'bottom' : 'right']);
            if (checkMainAxis) mainAxisCoord = clampCoord(mainAxis, mainAxisCoord);
            if (checkCrossAxis) crossAxisCoord = clampCoord(crossAxis, crossAxisCoord);
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const limitShift = function(options) {
    if (options === void 0) options = {};
    return {
        options,
        fn (state) {
            var _rawOffset$mainAxis, _rawOffset$crossAxis;
            const { x, y, placement, rects, middlewareData } = state;
            const { offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, _utils.evaluate)(options, state);
            const coords = {
                x,
                y
            };
            const crossAxis = (0, _utils.getSideAxis)(placement);
            const mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, _utils.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: (_rawOffset$mainAxis = rawOffset.mainAxis) != null ? _rawOffset$mainAxis : 0,
                crossAxis: (_rawOffset$crossAxis = rawOffset.crossAxis) != null ? _rawOffset$crossAxis : 0
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = originSides.has((0, _utils.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
// Method syntax keeps callback parameters bivariant, but expressing the
// explicit `| undefined` required by `exactOptionalPropertyTypes` needs
// property syntax, which is contravariant under `strictFunctionTypes`.
// Extracting the function from a method position restores that bivariance so
// consumers can still assign callbacks with narrower parameter types.
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const size = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options,
        async fn (state) {
            const { placement, rects, platform, elements } = state;
            const { apply = ()=>{}, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, _utils.getSide)(placement);
            const alignment = (0, _utils.getAlignment)(placement);
            const isYAxis = (0, _utils.getSideAxis)(placement) === 'y';
            const { width, height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, _utils.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, _utils.min)(width - overflow[widthSide], maximumClippingWidth);
            const shiftData = state.middlewareData.shift;
            const noShift = !shiftData;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (shiftData != null && shiftData.enabled.x) availableWidth = maximumClippingWidth;
            if (shiftData != null && shiftData.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                if (isYAxis) availableWidth = width - 2 * (0, _utils.max)(overflow.left, overflow.right);
                else availableHeight = height - 2 * (0, _utils.max)(overflow.top, overflow.bottom);
            }
            await apply({
                ...state,
                availableWidth,
                availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

},{"@floating-ui/utils":"cm9mC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cm9mC":[function(require,module,exports,__globalThis) {
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alignments", ()=>alignments);
parcelHelpers.export(exports, "clamp", ()=>clamp);
parcelHelpers.export(exports, "createCoords", ()=>createCoords);
parcelHelpers.export(exports, "evaluate", ()=>evaluate);
parcelHelpers.export(exports, "expandPaddingObject", ()=>expandPaddingObject);
parcelHelpers.export(exports, "floor", ()=>floor);
parcelHelpers.export(exports, "getAlignment", ()=>getAlignment);
parcelHelpers.export(exports, "getAlignmentAxis", ()=>getAlignmentAxis);
parcelHelpers.export(exports, "getAlignmentSides", ()=>getAlignmentSides);
parcelHelpers.export(exports, "getAxisLength", ()=>getAxisLength);
parcelHelpers.export(exports, "getExpandedPlacements", ()=>getExpandedPlacements);
parcelHelpers.export(exports, "getOppositeAlignmentPlacement", ()=>getOppositeAlignmentPlacement);
parcelHelpers.export(exports, "getOppositeAxis", ()=>getOppositeAxis);
parcelHelpers.export(exports, "getOppositeAxisPlacements", ()=>getOppositeAxisPlacements);
parcelHelpers.export(exports, "getOppositePlacement", ()=>getOppositePlacement);
parcelHelpers.export(exports, "getPaddingObject", ()=>getPaddingObject);
parcelHelpers.export(exports, "getSide", ()=>getSide);
parcelHelpers.export(exports, "getSideAxis", ()=>getSideAxis);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "placements", ()=>placements);
parcelHelpers.export(exports, "rectToClientRect", ()=>rectToClientRect);
parcelHelpers.export(exports, "round", ()=>round);
parcelHelpers.export(exports, "sides", ()=>sides);
const sides = [
    'top',
    'right',
    'bottom',
    'left'
];
const alignments = [
    'start',
    'end'
];
const placements = /*#__PURE__*/ sides.reduce((acc, side)=>acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), []);
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = (v)=>({
        x: v,
        y: v
    });
const oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function clamp(start, value, end) {
    return max(start, min(value, end));
}
function evaluate(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function getSide(placement) {
    return placement.split('-')[0];
}
function getAlignment(placement) {
    return placement.split('-')[1];
}
function getOppositeAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function getSideAxis(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
    return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = getAlignment(placement);
    const alignmentAxis = getAlignmentAxis(placement);
    const length = getAxisLength(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
    return [
        mainAlignmentSide,
        getOppositePlacement(mainAlignmentSide)
    ];
}
function getExpandedPlacements(placement) {
    const oppositePlacement = getOppositePlacement(placement);
    return [
        getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
function getOppositeAlignmentPlacement(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const lrPlacement = [
    'left',
    'right'
];
const rlPlacement = [
    'right',
    'left'
];
const tbPlacement = [
    'top',
    'bottom'
];
const btPlacement = [
    'bottom',
    'top'
];
function getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rlPlacement : lrPlacement;
            return isStart ? lrPlacement : rlPlacement;
        case 'left':
        case 'right':
            return isStart ? tbPlacement : btPlacement;
        default:
            return [];
    }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
    const alignment = getAlignment(placement);
    let list = getSideList(getSide(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
    return list;
}
function getOppositePlacement(placement) {
    const side = getSide(placement);
    return oppositeSideMap[side] + placement.slice(side.length);
}
function expandPaddingObject(padding) {
    var _padding$top, _padding$right, _padding$bottom, _padding$left;
    return {
        top: (_padding$top = padding.top) != null ? _padding$top : 0,
        right: (_padding$right = padding.right) != null ? _padding$right : 0,
        bottom: (_padding$bottom = padding.bottom) != null ? _padding$bottom : 0,
        left: (_padding$left = padding.left) != null ? _padding$left : 0
    };
}
function getPaddingObject(padding) {
    return typeof padding !== 'number' ? expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function rectToClientRect(rect) {
    const { x, y, width, height } = rect;
    return {
        width,
        height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x,
        y
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5Sjup":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getComputedStyle", ()=>getComputedStyle);
parcelHelpers.export(exports, "getContainingBlock", ()=>getContainingBlock);
parcelHelpers.export(exports, "getDocumentElement", ()=>getDocumentElement);
parcelHelpers.export(exports, "getFrameElement", ()=>getFrameElement);
parcelHelpers.export(exports, "getNearestOverflowAncestor", ()=>getNearestOverflowAncestor);
parcelHelpers.export(exports, "getNodeName", ()=>getNodeName);
parcelHelpers.export(exports, "getNodeScroll", ()=>getNodeScroll);
parcelHelpers.export(exports, "getOverflowAncestors", ()=>getOverflowAncestors);
parcelHelpers.export(exports, "getParentNode", ()=>getParentNode);
parcelHelpers.export(exports, "getWindow", ()=>getWindow);
parcelHelpers.export(exports, "isContainingBlock", ()=>isContainingBlock);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isLastTraversableNode", ()=>isLastTraversableNode);
parcelHelpers.export(exports, "isNode", ()=>isNode);
parcelHelpers.export(exports, "isOverflowElement", ()=>isOverflowElement);
parcelHelpers.export(exports, "isShadowRoot", ()=>isShadowRoot);
parcelHelpers.export(exports, "isTableElement", ()=>isTableElement);
parcelHelpers.export(exports, "isTopLayer", ()=>isTopLayer);
parcelHelpers.export(exports, "isWebKit", ()=>isWebKit);
function hasWindow() {
    return typeof window !== 'undefined';
}
function getNodeName(node) {
    if (isNode(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function getWindow(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
    var _ref;
    return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
    if (!hasWindow()) return false;
    return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
    if (!hasWindow()) return false;
    return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
    if (!hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
    if (!hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
    const { overflow, overflowX, overflowY, display } = getComputedStyle(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function isTableElement(element) {
    return /^(table|td|th)$/.test(getNodeName(element));
}
function isTopLayer(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const containRe = /paint|layout|strict|content/;
const isNotNone = (value)=>!!value && value !== 'none';
let isWebKitValue;
function isContainingBlock(elementOrCss) {
    const css = isElement(elementOrCss) ? getComputedStyle(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return isNotNone(css.transform) || isNotNone(css.translate) || isNotNone(css.scale) || isNotNone(css.rotate) || isNotNone(css.perspective) || !isWebKit() && (isNotNone(css.backdropFilter) || isNotNone(css.filter)) || willChangeRe.test(css.willChange || '') || containRe.test(css.contain || '');
}
function getContainingBlock(element) {
    let currentNode = getParentNode(element);
    while(isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)){
        if (isContainingBlock(currentNode)) return currentNode;
        else if (isTopLayer(currentNode)) return null;
        currentNode = getParentNode(currentNode);
    }
    return null;
}
function isWebKit() {
    if (isWebKitValue == null) isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return isWebKitValue;
}
function isLastTraversableNode(node) {
    return /^(html|body|#document)$/.test(getNodeName(node));
}
function getComputedStyle(element) {
    return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
    if (isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function getParentNode(node) {
    if (getNodeName(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node);
    return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
    const parentNode = getParentNode(node);
    if (isLastTraversableNode(parentNode)) return (node.ownerDocument || node).body;
    if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) return parentNode;
    return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = getNearestOverflowAncestor(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = getWindow(scrollableAncestor);
    if (isBody) {
        const frameElement = getFrameElement(win);
        return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
    } else return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iwsfV":[function() {},{}],"jNeV5":[function(require,module,exports,__globalThis) {
// Gramene's gene-search tour: the site-specific search intro and wording,
// composed with the shared chapters from gramene-search-tour.
//
// The tour runs a real search from the search bar: it types "jasmonic" and
// accepts the "Jasmonic acid biosynthesis" pathway, which matches genes across
// every genome in the release. The gene chapter then ANDs on Arabidopsis
// thaliana — showing how a species filter narrows a pan-genome result — to
// reach LOX2 (AT3G45140), the lipoxygenase at the first committed step of the
// pathway. Expression and enrichment are shown for Arabidopsis too.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildSteps);
var _grameneSearchTour = require("gramene-search-tour");
const SEARCH_TERM = 'jasmonic';
const PATHWAY_LABEL = 'Jasmonic acid biosynthesis';
const EXAMPLE_GENE = 'AT3G45140';
const EXAMPLE_GENE_NAME = 'LOX2';
const ARABIDOPSIS_GENOME = 3702001;
// The filters the tour's searches produce. Applied directly when a visitor
// jumps into the middle of the tour from the contents list, so every chapter
// has the result set its steps assume.
const PATHWAY_SUGGESTION = {
    fq_field: 'pathways__ancestors',
    fq_value: '1119332',
    name: PATHWAY_LABEL,
    category: 'Plant Reactome: Pathway'
};
const ARABIDOPSIS_SUGGESTION = {
    fq_field: 'taxonomy__ancestors',
    fq_value: 3702,
    name: 'Arabidopsis thaliana',
    category: 'Taxonomy'
};
const GENE_SEARCH = [
    PATHWAY_SUGGESTION,
    ARABIDOPSIS_SUGGESTION
];
const SEARCH_INPUT = '#search-input';
function buildSteps(getProps) {
    const kit = (0, _grameneSearchTour.createTourKit)(getProps, {
        prefix: 'gramene',
        search: PATHWAY_SUGGESTION,
        // gramene-search derives the reference from the largest anchor group in
        // /maps (barley, on the plants release); the tour's genes are Arabidopsis.
        taxon: ARABIDOPSIS_GENOME
    });
    // Suggestions render only while there is a query, so the panel and the
    // pathway button both wait on the fetch for SEARCH_TERM.
    const typeSearchTerm = async ()=>{
        kit.act('doChangeSuggestionsTab', 'gramene');
        kit.act('doChangeSuggestionsQuery', SEARCH_TERM);
        return (0, _grameneSearchTour.waitFor)(()=>kit.findSuggestion(PATHWAY_LABEL), {
            timeout: 20000
        });
    };
    return [
        // ── 1. Run the search, for real ───────────────────────────────────
        {
            chapter: {
                title: 'Run a search',
                blurb: 'Find genes by pathway, not by ID'
            },
            target: 'body',
            placement: 'center',
            title: 'Welcome to the gene search',
            content: `Let's run a real search together. We'll look for genes in the jasmonic ` + `acid biosynthesis pathway across every genome in Gramene, then use that ` + `result set to walk through the interface \u{2014} the gene evidence tabs, ` + `TBrowse, and the tools for working on a whole set of genes at once.`,
            before: async ()=>{
                // Start from a clean slate so the demo is the same every time.
                kit.act('doClearGrameneFilters');
                kit.act('doClearSuggestions');
                window.scrollTo(0, 0);
                await (0, _grameneSearchTour.sleep)(200);
            }
        },
        {
            target: '#searchbar-parent',
            placement: 'bottom',
            title: 'Type what you are looking for',
            content: `Every search starts in this box. It accepts far more than gene IDs: gene ` + `names and synonyms, pathways, protein domains, ontology terms and species ` + `all work, and none of it is case sensitive. We've typed "${SEARCH_TERM}".`,
            before: async ()=>{
                await (0, _grameneSearchTour.waitForElement)(SEARCH_INPUT, {
                    timeout: 8000
                });
                await typeSearchTerm();
                return (0, _grameneSearchTour.revealTarget)('#searchbar-parent', {
                    block: 'start'
                });
            }
        },
        {
            target: '.search-suggestions',
            placement: 'top',
            title: 'Suggestions, grouped and counted',
            content: `As you type, matching terms are grouped by what they are \u{2014} pathways, ` + `ontology terms, gene names \u{2014} and each one shows how many genes it would ` + `find. That number tells you whether a term is broad or specific before you ` + `commit to it.`,
            before: async ()=>{
                await typeSearchTerm();
                return (0, _grameneSearchTour.revealTarget)('.search-suggestions', {
                    block: 'start'
                });
            }
        },
        {
            target: ()=>kit.findSuggestion(PATHWAY_LABEL),
            placement: 'bottom',
            title: 'Pick the pathway',
            content: `Under Plant Reactome: Pathway, "${PATHWAY_LABEL}" matches genes in ` + `hundreds of plant genomes. Choosing it turns the term into a search ` + `filter \u{2014} that's what we'll do next.`,
            before: async ()=>{
                await typeSearchTerm();
                return (0, _grameneSearchTour.revealTarget)(()=>kit.findSuggestion(PATHWAY_LABEL), {
                    block: 'center'
                });
            }
        },
        // ── 2. The result set ─────────────────────────────────────────────
        ...(0, _grameneSearchTour.resultSetSteps)(kit, {
            chapter: {
                title: 'Read the results',
                blurb: 'Filters, distribution and the gene list'
            },
            filterLabel: PATHWAY_LABEL,
            // Perform the click the previous step pointed at; ensureSearch applies
            // the filter directly if it didn't happen (jumped here).
            enter: async ()=>{
                const btn = kit.findSuggestion(PATHWAY_LABEL);
                if (btn) btn.click();
                kit.act('doClearSuggestions');
            },
            copy: {
                neighborhood: {
                    content: `Neighborhood takes the ten genes either side of each match along the ` + `chromosome \u{2014} genomic context rather than homology. Picking the selected ` + `option again clears it, which is what happens as we leave this step, so ` + `the rest of the tour runs on the plain pathway genes.`
                }
            }
        }),
        // ── 3. One gene: LOX2 ─────────────────────────────────────────────
        {
            chapter: {
                title: `One gene: ${EXAMPLE_GENE_NAME}`,
                blurb: 'Add a species, then read the evidence for one gene'
            },
            target: '.gramene-filter-container',
            placement: 'right',
            title: 'Narrow to one species',
            content: `The pathway matches genes in hundreds of genomes. Adding a species is just ` + `another filter, ANDed onto the first: we've added Arabidopsis thaliana, ` + `which leaves the handful of Arabidopsis genes in the pathway. Search for a ` + `species name to find its taxonomy suggestion.`,
            before: async ()=>{
                if (!await kit.ensureSearch(GENE_SEARCH)) return false;
                await kit.ensureView('list', '.result-gene');
                return (0, _grameneSearchTour.revealTarget)('.gramene-filter-container', {
                    block: 'start'
                });
            }
        },
        ...(0, _grameneSearchTour.geneSteps)(kit, {
            chapter: null,
            gene: EXAMPLE_GENE,
            search: GENE_SEARCH,
            copy: {
                card: {
                    title: `${EXAMPLE_GENE_NAME} is one of these genes`,
                    content: `${EXAMPLE_GENE} (${EXAMPLE_GENE_NAME}, lipoxygenase 2) catalyses the ` + `first committed step of jasmonic acid biosynthesis in Arabidopsis ` + `leaves. Let's look at the evidence behind it.`
                },
                pathways: {
                    content: `Pathways is what put ${EXAMPLE_GENE_NAME} in this result set. ` + `The tree on the left lists every Plant Reactome pathway and reaction the ` + `gene takes part in; the diagram shows the selected one with the gene ` + `flagged.`
                },
                tree: {
                    content: `Opening Homology draws the gene family tree in TBrowse, with the ` + `lipoxygenases of every genome in the release, and the multiple sequence ` + `alignment zone (MSA). Click a triangle to expand or collapse a branch, or ` + `a gene name for more details. Protein domains are color coded; zoom in to ` + `the amino acid sequence level.`
                }
            }
        }),
        // ── 4. Tools for the whole set ────────────────────────────────────
        ...(0, _grameneSearchTour.refineSteps)(kit, {
            chapter: {
                title: 'Refine the set',
                blurb: 'Count your results by category'
            }
        }),
        ...(0, _grameneSearchTour.viewsSteps)(kit, {
            chapter: {
                title: 'Views',
                blurb: 'Read the same genes another way'
            }
        }),
        ...(0, _grameneSearchTour.expressionSteps)(kit, {
            chapter: {
                title: 'Expression',
                blurb: 'Heatmap, parallel coordinates, brushing'
            },
            copy: {
                exprViz: {
                    content: `Expression data is per genome, so this view opens on a tab per genome in ` + `your results that has expression studies. We've picked Arabidopsis ` + `thaliana, and now need to choose which samples to plot.`
                }
            }
        }),
        ...(0, _grameneSearchTour.setToolsSteps)(kit, {
            chapter: {
                title: 'Enrichment, lists & export',
                blurb: 'Over-represented terms, your own gene lists, and taking data with you'
            },
            copy: {
                enrichment: {
                    content: `Enrichment asks which GO, Plant Ontology or Trait Ontology terms turn up ` + `in your results more often than chance would predict, with fold enrichment ` + `and an adjusted p-value for each. Pick the species on the left \u{2014} we've ` + `selected Arabidopsis thaliana.`
                }
            }
        })
    ];
}

},{"gramene-search-tour":"4bGdS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7IP1z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "STATIC_PAGES", ()=>STATIC_PAGES);
parcelHelpers.export(exports, "StaticPage", ()=>StaticPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reduxBundlerReact = require("redux-bundler-react");
var _reactBootstrap = require("react-bootstrap");
var _news = require("./News");
const STATIC_PAGES = [
    'cite',
    'outreach',
    'ftp-download',
    'archive'
];
const subsite = "oryza";
const assetBase = '/';
const fillPlaceholders = (html, config)=>{
    const api = (config.grameneData || '').replace(/\/$/, '');
    let path = '';
    try {
        path = new URL(api).pathname.replace(/\/$/, '');
    } catch (e) {}
    return html.replace(/\{\{grameneData\}\}/g, api).replace(/\{\{grameneDataPath\}\}/g, path);
};
const StaticPageCmp = ({ match, configuration })=>{
    const page = match.params.page;
    const [loaded, setLoaded] = (0, _reactDefault.default).useState({
        page: null,
        html: null,
        error: null
    });
    (0, _reactDefault.default).useEffect(()=>{
        let cancelled = false;
        window.scrollTo(0, 0);
        fetch(`${assetBase}static/pages/${page}.html`).then((res)=>{
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            return res.text();
        }).then((html)=>{
            // A dev server answers unknown paths with the app's own index.html.
            if (/<!doctype html|<html[\s>]/i.test(html)) throw new Error('page not found');
            if (!cancelled) setLoaded({
                page,
                html,
                error: null
            });
        }).catch((e)=>{
            if (!cancelled) setLoaded({
                page,
                html: null,
                error: e.message
            });
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        page
    ]);
    const current = loaded.page === page ? loaded : {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _news.NewsSidebarLayout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "gramene-static-page",
            children: [
                !current.html && !current.error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Spinner), {
                    animation: "border",
                    size: "sm"
                }),
                current.error && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    children: [
                        "This page could not be loaded (",
                        current.error,
                        ")."
                    ]
                }),
                current.html && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: fillPlaceholders(current.html, configuration)
                    }
                })
            ]
        })
    });
};
const StaticPage = (0, _reduxBundlerReact.connect)('selectConfiguration', StaticPageCmp);

},{"react/jsx-runtime":"gonF6","react":"bmhQu","redux-bundler-react":"a9QVF","react-bootstrap":[["Spinner","4RdUY","default"]],"./News":"cLuD4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cLuD4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NewsFeed", ()=>NewsFeed);
parcelHelpers.export(exports, "NewsSidebarLayout", ()=>NewsSidebarLayout);
parcelHelpers.export(exports, "PostsPage", ()=>PostsPage);
parcelHelpers.export(exports, "PostPage", ()=>PostPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reduxBundlerReact = require("redux-bundler-react");
var _reactRouterDom = require("react-router-dom");
var _reactBootstrap = require("react-bootstrap");
// News from the grameneNews bundle (bundles/news.js): the home page's
// "Latest News" sidebar, the /posts list and a /post/:slug page. Titles,
// excerpts and content are WordPress-rendered HTML.
const html = (s)=>({
        __html: s || ''
    });
const formatDate = (iso)=>{
    const d = new Date(iso);
    return isNaN(d) ? '' : d.toLocaleDateString('en-US', {
        weekday: 'short',
        day: '2-digit',
        month: 'short',
        year: 'numeric'
    });
};
// Pages reached directly (a shared /post link) may beat the bundle's reactor,
// which only runs on sites that show the feed; ask for the data ourselves.
const useNews = ({ grameneNews, siteNews, doFetchGrameneNews })=>{
    (0, _reactDefault.default).useEffect(()=>{
        if (!grameneNews) doFetchGrameneNews();
    }, []);
    return siteNews;
};
const NewsFeedCmp = ({ siteNews })=>{
    if (!siteNews) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: {
            backgroundColor: 'white',
            padding: '0px',
            marginBottom: '20px',
            borderRadius: '5px'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                style: {
                    padding: '10px',
                    marginBottom: '0px'
                },
                children: "Latest News"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                className: "posts list-unstyled",
                style: {
                    overflow: 'auto',
                    minHeight: "550px",
                    height: "565px",
                    padding: "0px",
                    marginBottom: '0px',
                    borderBottomStyle: 'solid',
                    borderBottomColor: '#e3e8ec',
                    borderBottomWidth: 'thin',
                    borderTopStyle: 'solid',
                    borderTopColor: '#e3e8ec',
                    borderTopWidth: 'thin'
                },
                children: [
                    siteNews.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        style: {
                            padding: "10px"
                        },
                        children: "No news yet."
                    }),
                    siteNews.map((post)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                            style: {
                                padding: "10px"
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: `/post/${post.slug}`,
                                    dangerouslySetInnerHTML: html(post.title)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: formatDate(post.date)
                                })
                            ]
                        }, post.id))
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    padding: "10px",
                    fontSize: "small"
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    to: "/posts",
                    children: "All news"
                })
            })
        ]
    });
};
const NewsFeed = (0, _reduxBundlerReact.connect)('selectSiteNews', NewsFeedCmp);
// Page content beside the Latest News sidebar, in the home page's column
// layout, so the sidebar stays put as visitors move between these pages.
const NewsSidebarLayoutCmp = ({ configuration, children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Container), {
        fluid: true,
        style: {
            paddingLeft: '20px',
            paddingRight: '20px',
            paddingTop: '20px',
            paddingBottom: '100px'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Row), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                    xxl: 10,
                    xl: 9,
                    lg: 9,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            maxWidth: '900px'
                        },
                        children: children
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                    xxl: 2,
                    xl: 3,
                    lg: 3,
                    children: configuration.showFeed && /*#__PURE__*/ (0, _jsxRuntime.jsx)(NewsFeed, {})
                })
            ]
        })
    });
const NewsSidebarLayout = (0, _reduxBundlerReact.connect)('selectConfiguration', NewsSidebarLayoutCmp);
const PostsPageCmp = (props)=>{
    const posts = useNews(props);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(NewsSidebarLayout, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                children: "News"
            }),
            !posts && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Spinner), {
                animation: "border",
                size: "sm"
            }),
            posts && posts.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "No news yet."
            }),
            posts && posts.map((post)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "gramene-news-item",
                    style: {
                        padding: '12px 0',
                        borderBottom: '1px solid #e3e8ec'
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                            style: {
                                marginBottom: '2px'
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: `/post/${post.slug}`,
                                dangerouslySetInnerHTML: html(post.title)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                color: '#6c757d',
                                fontSize: 'small'
                            },
                            children: formatDate(post.date)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "gramene-news-excerpt",
                            dangerouslySetInnerHTML: html(post.excerpt)
                        })
                    ]
                }, post.id))
        ]
    });
};
const PostsPage = (0, _reduxBundlerReact.connect)('selectGrameneNews', 'selectSiteNews', 'doFetchGrameneNews', PostsPageCmp);
const PostPageCmp = (props)=>{
    const posts = useNews(props);
    const slug = props.match.params.slug;
    const post = posts && posts.find((p)=>p.slug === slug);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(NewsSidebarLayout, {
        children: [
            !posts && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Spinner), {
                animation: "border",
                size: "sm"
            }),
            posts && !post && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "That news post was not found. ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/posts",
                        children: "All news"
                    })
                ]
            }),
            post && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("article", {
                className: "gramene-news-post",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        dangerouslySetInnerHTML: html(post.title)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            color: '#6c757d',
                            marginBottom: '16px'
                        },
                        children: formatDate(post.date)
                    }),
                    post.featuredUrl && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: post.featuredUrl,
                        alt: "",
                        style: {
                            maxWidth: '100%',
                            marginBottom: '16px'
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "gramene-news-content",
                        dangerouslySetInnerHTML: html(post.content)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        style: {
                            marginTop: '24px'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/posts",
                            children: "All news"
                        })
                    })
                ]
            })
        ]
    });
};
const PostPage = (0, _reduxBundlerReact.connect)('selectGrameneNews', 'selectSiteNews', 'doFetchGrameneNews', PostPageCmp);

},{"react/jsx-runtime":"gonF6","react":"bmhQu","redux-bundler-react":"a9QVF","react-router-dom":"b9X5n","react-bootstrap":[["Col","ii9A3","default"],["Container","8Pton","default"],["Row","3Fk66","default"],["Spinner","4RdUY","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b9X5n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _reactRouter.MemoryRouter));
parcelHelpers.export(exports, "Prompt", ()=>(0, _reactRouter.Prompt));
parcelHelpers.export(exports, "Redirect", ()=>(0, _reactRouter.Redirect));
parcelHelpers.export(exports, "Route", ()=>(0, _reactRouter.Route));
parcelHelpers.export(exports, "Router", ()=>(0, _reactRouter.Router));
parcelHelpers.export(exports, "StaticRouter", ()=>(0, _reactRouter.StaticRouter));
parcelHelpers.export(exports, "Switch", ()=>(0, _reactRouter.Switch));
parcelHelpers.export(exports, "generatePath", ()=>(0, _reactRouter.generatePath));
parcelHelpers.export(exports, "matchPath", ()=>(0, _reactRouter.matchPath));
parcelHelpers.export(exports, "useHistory", ()=>(0, _reactRouter.useHistory));
parcelHelpers.export(exports, "useLocation", ()=>(0, _reactRouter.useLocation));
parcelHelpers.export(exports, "useParams", ()=>(0, _reactRouter.useParams));
parcelHelpers.export(exports, "useRouteMatch", ()=>(0, _reactRouter.useRouteMatch));
parcelHelpers.export(exports, "withRouter", ()=>(0, _reactRouter.withRouter));
parcelHelpers.export(exports, "BrowserRouter", ()=>BrowserRouter);
parcelHelpers.export(exports, "HashRouter", ()=>HashRouter);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "NavLink", ()=>NavLink);
var _reactRouter = require("react-router");
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _history = require("history");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var BrowserRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, _reactDefault.default).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var HashRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, _reactDefault.default).Component);
var resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, _history.createLocation)(to, null, null, currentLocation) : to;
};
var forwardRefShim = function forwardRefShim(C) {
    return C;
};
var forwardRef = (0, _reactDefault.default).forwardRef;
if (typeof forwardRef === "undefined") forwardRef = forwardRefShim;
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var LinkAnchor = forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, _extendsDefault.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if (forwardRefShim !== forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, _reactDefault.default).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var Link = forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.__RouterContext).Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var history = context.history;
        var location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, _extendsDefault.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, _history.createPath)(context.location) === (0, _history.createPath)(normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if (forwardRefShim !== forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(component, props);
    });
});
var toType, refType;
var forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var forwardRef$1 = (0, _reactDefault.default).forwardRef;
if (typeof forwardRef$1 === "undefined") forwardRef$1 = forwardRefShim$1;
function joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var NavLink = forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.__RouterContext).Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, _reactRouter.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = joinClassnames(className, activeClassName);
            style = (0, _extendsDefault.default)({}, style, activeStyle);
        }
        var props = (0, _extendsDefault.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if (forwardRefShim$1 !== forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Link, props);
    });
});
var ariaCurrentType;

},{"react-router":"ditZI","@babel/runtime/helpers/esm/inheritsLoose":"hJ1FM","react":"bmhQu","history":"8rWTz","prop-types":"gLXGb","tiny-warning":"hu9ef","@babel/runtime/helpers/esm/extends":"85Hd3","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"ds1mq","tiny-invariant":"7cMkC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8Acrq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const Feedback = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "col-lg-8 mr-auto ml-auto my-5",
        style: {
            minHeight: 'calc(100vh - 250px)',
            display: 'flex',
            flexDirection: 'column'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("iframe", {
            src: "https://forms.monday.com/forms/embed/afd004c9495060caf0f1313de599b563?r=use1",
            style: {
                flex: 1,
                border: 0,
                width: '100%',
                boxShadow: '5px 5px 56px 0px rgba(0,0,0,0.25)'
            },
            title: "Feedback Form"
        })
    });
exports.default = Feedback;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5yEIG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reduxBundlerReact = require("redux-bundler-react");
var _reactBootstrap = require("react-bootstrap");
var _news = require("./News");
var _reactRouterDom = require("react-router-dom");
var _portals = require("./Portals");
var _grameneGithubdocs = require("gramene-githubdocs");
var _italicizeOryza = require("./italicizeOryza");
var _italicizeOryzaDefault = parcelHelpers.interopDefault(_italicizeOryza);
var _componentClosest = require("component-closest");
var _componentClosestDefault = parcelHelpers.interopDefault(_componentClosest);
var _welcomeLess = require("../styles/welcome.less");
// import { TwitterTimelineEmbed } from 'react-twitter-embed'
// var loadjs = require('loadjs');
// loadjs(['https://platform.twitter.com/widgets.js'], 'twitter');
//
// var haveTwitter = false;
// var Timeline = null;
// loadjs.ready('twitter', function() {
//   /* twitter loaded */
//   haveTwitter = true;
//   Timeline = require('react-twitter-widgets').Timeline;
// });
// Inline rice-stalk motif used as a hero accent. Recolorable, no image asset
// needed. Mirrors src/static/images/oryza19k/rice-stalk.svg.
const RiceStalk = ({ className })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: className,
        width: "150",
        viewBox: "0 0 200 170",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        focusable: "false",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                stroke: "#7fa352",
                strokeWidth: "2.4",
                fill: "none",
                strokeLinecap: "round",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M120 168 C118 120 116 80 130 44"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M120 168 C122 124 132 92 150 64"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M120 168 C120 130 108 96 92 70"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#c9a227",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        transform: "translate(130,44) rotate(20)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                                cx: "0",
                                cy: "0",
                                rx: "4.5",
                                ry: "9"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                                cx: "9",
                                cy: "6",
                                rx: "4.5",
                                ry: "9"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                                cx: "-8",
                                cy: "8",
                                rx: "4.5",
                                ry: "9"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                                cx: "2",
                                cy: "16",
                                rx: "4.5",
                                ry: "9"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                                cx: "11",
                                cy: "20",
                                rx: "4.5",
                                ry: "9"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                                cx: "-7",
                                cy: "22",
                                rx: "4.5",
                                ry: "9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        transform: "translate(150,64) rotate(40)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                                cx: "0",
                                cy: "0",
                                rx: "4",
                                ry: "8"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                                cx: "8",
                                cy: "5",
                                rx: "4",
                                ry: "8"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                                cx: "-7",
                                cy: "7",
                                rx: "4",
                                ry: "8"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                                cx: "2",
                                cy: "14",
                                rx: "4",
                                ry: "8"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                                cx: "10",
                                cy: "18",
                                rx: "4",
                                ry: "8"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        transform: "translate(92,70) rotate(-30)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                                cx: "0",
                                cy: "0",
                                rx: "4",
                                ry: "8"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                                cx: "8",
                                cy: "5",
                                rx: "4",
                                ry: "8"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                                cx: "-7",
                                cy: "7",
                                rx: "4",
                                ry: "8"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                                cx: "2",
                                cy: "14",
                                rx: "4",
                                ry: "8"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                                cx: "10",
                                cy: "18",
                                rx: "4",
                                ry: "8"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                stroke: "#d8b94a",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                        x1: "130",
                        y1: "44",
                        x2: "130",
                        y2: "28"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                        x1: "150",
                        y1: "64",
                        x2: "156",
                        y2: "48"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                        x1: "92",
                        y1: "70",
                        x2: "84",
                        y2: "56"
                    })
                ]
            })
        ]
    });
// "At a glance" rendered as accented stat cards (config-driven). Only sites
// that define config.atAGlance (currently oryza19k) get this treatment.
function AtAGlance({ stats, full }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `oryza19k-glance${full ? " oryza19k-glance-full" : ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                className: "oryza19k-glance-title",
                children: "At a glance"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "oryza19k-glance-grid",
                children: stats.map((s, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: `oryza19k-stat oryza19k-stat-${s.accent || 'green'}`,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "oryza19k-stat-value",
                                children: s.value
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "oryza19k-stat-label",
                                children: s.label
                            })
                        ]
                    }, idx))
            })
        ]
    });
}
function WelcomeBanner({ config, location }) {
    const key = `gramene-${config.name}-${config.version}-alerted`;
    const [hide, setShow] = (0, _reactDefault.default).useState(localStorage.getItem(key) || '');
    const show = hide === "yes" ? "no" : "yes";
    const haveSlides = config.slides.length > 0;
    const showSlideshow = haveSlides && show === "yes";
    // Home ("/") renders <Welcome/> with no location; other Welcome routes
    // (/videotutorials, /pansites, …) pass one. Tutorial videos are shown only on
    // /videotutorials, by Portals.
    const isHome = !location || location.pathname === '/';
    const description = config.description_continued ? config.description + config.description_continued : config.description;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Alert), {
                variant: "success",
                className: config.hero ? "oryza19k-hero" : undefined,
                children: [
                    config.hero && config.hero.eyebrow && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "oryza19k-hero-eyebrow",
                        children: config.hero.eyebrow
                    }),
                    config.hero && /*#__PURE__*/ (0, _jsxRuntime.jsx)(RiceStalk, {
                        className: "oryza19k-hero-graphic"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Alert).Heading, {
                        children: [
                            config.hero ? (0, _italicizeOryzaDefault.default)(config.name) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    "Welcome to ",
                                    (0, _italicizeOryzaDefault.default)(config.name)
                                ]
                            }),
                            " ",
                            config.showRelease !== false && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                style: {
                                    fontSize: "smaller"
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                                    to: "/News",
                                    children: [
                                        "release ",
                                        config.version.replace('v', '')
                                    ]
                                })
                            }),
                            haveSlides && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Button), {
                                onClick: ()=>{
                                    setShow(show);
                                    localStorage.setItem(key, show);
                                },
                                variant: "secondary",
                                size: "sm",
                                style: {
                                    float: "right"
                                },
                                children: [
                                    show === "no" ? "Show" : "Hide",
                                    " Slideshow"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: description
                        }
                    }),
                    config.hero && config.hero.links && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "oryza19k-hero-actions",
                        children: config.hero.links.map((l, idx)=>{
                            const cls = `oryza19k-hero-btn${l.primary ? " oryza19k-hero-btn-primary" : ""}`;
                            return l.url.startsWith('/') ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: l.url,
                                className: cls,
                                children: l.label
                            }, idx) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                href: l.url,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: cls,
                                children: l.label
                            }, idx);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Row), {
                style: {
                    marginBottom: '20px'
                },
                children: [
                    config.atAGlance ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                        md: showSlideshow ? 6 : 12,
                        className: "welcome-overview-col",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AtAGlance, {
                            stats: config.atAGlance,
                            full: !showSlideshow
                        })
                    }) : config.welcomeDoc && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                        md: showSlideshow ? 6 : 12,
                        className: "welcome-overview-col",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _grameneGithubdocs.GithubDoc), {
                            org: "warelab",
                            repo: config.welcomeDoc.repo,
                            path: config.welcomeDoc.path,
                            branch: config.welcomeDoc.branch || 'main'
                        })
                    }),
                    showSlideshow && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                        md: config.welcomeDoc ? 6 : 12,
                        className: "welcome-slideshow-col",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Carousel), {
                            interval: 5000,
                            fade: true,
                            children: config.slides.map((slide, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Carousel).Item, {
                                    style: {
                                        backgroundColor: '#557b74'
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Card), {
                                        bg: "dark",
                                        text: "white",
                                        style: {
                                            width: '90%',
                                            marginLeft: '5%',
                                            marginRight: '5%',
                                            marginTop: '10px',
                                            marginBottom: '5%',
                                            padding: '5px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Card).Img, {
                                                variant: "top",
                                                src: slide.img
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Card).Body, {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Card).Title, {
                                                        children: (0, _italicizeOryzaDefault.default)(slide.label)
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Card).Text, {
                                                        children: (0, _italicizeOryzaDefault.default)(slide.text)
                                                    })
                                                ]
                                            }),
                                            slide.credit && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Card).Footer, {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                    children: slide.credit
                                                })
                                            })
                                        ]
                                    })
                                }, idx))
                        })
                    })
                ]
            })
        ]
    });
}
function AlertDismissibleExample({ config }) {
    const key = `gramene-${config.name}-${config.version}-alerted`;
    const [hide, setShow] = (0, _reactDefault.default).useState(localStorage.getItem(key) || '');
    if (hide !== 'yes') return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Alert), {
        variant: "success",
        onClose: ()=>{
            setShow('yes');
            localStorage.setItem(key, 'yes');
        },
        dismissible: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Alert).Heading, {
                children: [
                    "Welcome to ",
                    config.name,
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        style: {
                            fontSize: "smaller"
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                            to: "/News",
                            children: [
                                "release ",
                                config.version.replace('v', '')
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                        children: "Gramene"
                    }),
                    " is a ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                        children: "curated, open-source, integrated"
                    }),
                    " data resource for comparative functional genomics in crops and model plant species."
                ]
            })
        ]
    });
    return null; //<Button onClick={() => setShow(true)}>Show Alert</Button>;
}
class DrupalPage extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.iframeRef = /*#__PURE__*/ (0, _reactDefault.default).createRef();
        this.state = {};
    }
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        window.scrollTo(0, 0);
    }
    initListener() {
        let iframe = this.iframeRef.current;
        let iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        if (typeof iframeDoc.addEventListener !== "undefined") iframeDoc.addEventListener("click", this.iframeClickHandler.bind(this), true);
        else if (typeof iframeDoc.attachEvent !== "undefined") iframeDoc.attachEvent("onclick", this.iframeClickHandler.bind(this));
    }
    iframeClickHandler(e) {
        let target = e.target;
        target = (0, _componentClosestDefault.default)(target, 'a');
        let href = target.getAttribute('href');
        let drupalLink;
        let matches = href.match(/(node\/\d+)$/);
        if (!matches) {
            matches = href.match(/gramene\.org\/(.+)/);
            if (matches && this.props.drupalAliases[matches[1]] && matches[1]) drupalLink = matches[1];
        } else drupalLink = matches[1];
        if (drupalLink) {
            e.preventDefault();
            window.history.pushState({}, undefined, `/${drupalLink}`);
        }
    }
    render() {
        let nid = this.props.nid;
        if (!nid && this.props.drupalAliases && this.props.stub) {
            if (!this.props.drupalAliases[this.props.stub]) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("code", {
                children: [
                    "node for '",
                    this.props.stub,
                    "' not found"
                ]
            });
            nid = JSON.stringify(this.props.drupalAliases[this.props.stub]).replace(/"/g, "");
        }
        if (nid) {
            const src = `/ww?nid=${+nid}`;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("iframe", {
                src: src,
                ref: this.iframeRef,
                style: {
                    width: '100%',
                    height: '650px',
                    maxHeight: '80vh'
                },
                onLoad: this.initListener.bind(this),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: "browser doesn't support iframes"
                })
            });
        }
        return null;
    }
}
const Drupal = (0, _reduxBundlerReact.connect)('selectConfiguration', 'selectDrupalAliases', DrupalPage);
// mode:
//   'home'    -> oryza19k-specific landing (hero + at a glance + examples)
//   'gramene' -> generic Gramene portals grid (served at /gramene, light theme)
//   undefined -> legacy combined view (pansites / videotutorials / drupal stubs)
const Welcome = (props)=>{
    const cfg = props.configuration;
    const mode = props.mode;
    const isDrupal = props.match && (props.match.params.stub || props.match.params.nid);
    const path = props.location && props.location.pathname || '';
    // /pansites and /videotutorials are Gramene portal sub-pages: Portals renders
    // its own heading and content for these, so skip the "Gramene Portals" header,
    // the examples, and (always) the oryza hero.
    const isPortalSubPage = path === '/pansites' || path === '/videotutorials';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Container), {
            fluid: true,
            style: {
                paddingLeft: '20px',
                paddingRight: '20px',
                paddingBottom: '80px',
                paddingTop: '0px'
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Row), {
                style: {
                    paddingBottom: '50px'
                },
                lg: 12,
                xl: 12,
                xxl: 12,
                md: 12,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Col), {
                        xxl: 10,
                        xl: 9,
                        lg: 9,
                        children: [
                            mode !== 'gramene' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(WelcomeBanner, {
                                config: cfg,
                                location: props.location
                            }),
                            mode === 'gramene' && (isPortalSubPage ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _portals.Portals), {
                                location: props.location
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        className: "gramene-portals-heading",
                                        children: cfg.portalsHeading || 'Gramene Portals'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _portals.Portals), {
                                        location: props.location
                                    }),
                                    cfg.examples && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _portals.Examples), {})
                                ]
                            })),
                            mode === undefined && (isDrupal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Drupal, {
                                stub: props.match.params.stub,
                                nid: props.match.params.nid
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _portals.Portals), {
                                        location: props.location
                                    }),
                                    cfg.examples && !isPortalSubPage && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _portals.Examples), {})
                                ]
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                        xxl: 2,
                        xl: 3,
                        lg: 3,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: cfg.showFeed && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _news.NewsFeed), {})
                        })
                    })
                ]
            })
        })
    });
};
exports.default = (0, _reduxBundlerReact.connect)('selectConfiguration', 'doToggleGrameneHelp', 'doReplaceGrameneFilters', Welcome);

},{"react/jsx-runtime":"gonF6","react":"bmhQu","redux-bundler-react":"a9QVF","react-bootstrap":[["Alert","eF7kW","default"],["Button","6Xv8z","default"],["Card","gVV6u","default"],["Carousel","5LGZU","default"],["Col","ii9A3","default"],["Container","8Pton","default"],["Row","3Fk66","default"]],"./News":"cLuD4","react-router-dom":"b9X5n","./Portals":"59Mf9","gramene-githubdocs":"lVWfx","./italicizeOryza":"d9LKy","component-closest":"c6DDL","../styles/welcome.less":"2dNz7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"59Mf9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Portals", ()=>Portals);
parcelHelpers.export(exports, "PortalsDropdown", ()=>PortalsDropdown);
parcelHelpers.export(exports, "Examples", ()=>Examples);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reduxBundlerReact = require("redux-bundler-react");
var _reactBootstrap = require("react-bootstrap");
var _fi = require("react-icons/fi");
var _conf = require("../conf");
var _confDefault = parcelHelpers.interopDefault(_conf);
var _reactRouterDom = require("react-router-dom");
var _grameneVideos = require("gramene-videos");
var _grameneVideosDefault = parcelHelpers.interopDefault(_grameneVideos);
const tools = {
    browser: {
        title: "Genome Browser",
        description: "Genome annotations, variation and comparative tools",
        ensemblPath: "/index.html",
        imgSrc: "static/images/welcome/ensemblgramene.png"
    },
    reactome: {
        title: "Plant Reactome",
        description: "Browse and analyze metabolic and regulatory pathways",
        link: "//plantreactome.gramene.org",
        imgSrc: "static/images/welcome/plantReactome.svg",
        isExternal: true
    },
    tools: {
        title: "Ensembl Tools",
        description: "Tools for fetching and searching genomic data",
        ensemblPath: "/tools.html",
        imgSrc: "static/images/welcome/tools.png"
    },
    atlas: {
        title: "Plant Expression Atlas",
        description: "Browse plant expression results at EBI",
        link: "//www.ebi.ac.uk/gxa/plant/experiments",
        imgSrc: "static/images/welcome/ExpressionAtlas.png",
        isExternal: true
    },
    blast: {
        title: "BLAST",
        description: "Query our genomes with a DNA or protein sequence",
        ensemblPath: "/Tools/Blast?db=core",
        imgSrc: "static/images/welcome/BLAST.png"
    },
    mart: {
        title: "Gramene Mart",
        description: "An advanced genomic query interface powered by BioMart",
        ensemblPath: "/biomart/martview",
        imgSrc: "static/images/welcome/Biomart250.png"
    },
    EG_mart: {
        title: "Ensembl Plants Mart",
        description: "An advanced genomic query interface powered by BioMart",
        link: "https://plants.ensembl.org/biomart/martview",
        imgSrc: "static/images/welcome/Biomart250.png",
        isExternal: true
    },
    trackhub: {
        title: "Track Hub Registry",
        description: "A global centralised collection of publicly accessible track hubs",
        link: "//trackhubregistry.org",
        imgSrc: "static/images/welcome/TrackHub.png",
        isExternal: true
    },
    outreach: {
        title: "Outreach and Training",
        description: "Education resources and webinars",
        route: "/outreach",
        imgSrc: "static/images/welcome/noun_553934.png"
    },
    downloads: {
        title: "Bulk Data Access",
        description: "FTP downloads and the data API",
        route: "/ftp-download",
        imgSrc: "static/images/welcome/download.png"
    },
    ftp: {
        title: "Bulk Downloads",
        description: "FTP download of our data",
        link: "ftp",
        imgSrc: "static/images/welcome/download.png"
    },
    archive: {
        title: "Archive",
        description: "Legacy tools and data (markers, Cyc pathways, etc)",
        route: "/archive",
        imgSrc: "static/images/welcome/archive.jpg"
    },
    climtools: {
        title: "CLIMtools",
        description: "Environment x Genome x Phenotype Associations",
        link: "https://www.gramene.org/CLIMtools",
        imgSrc: "static/images/welcome/climtools.png"
    },
    oryzaclimtools: {
        title: "CLIMtools",
        description: "Environment x Genome x Phenotype Associations",
        link: "https://www.gramene.org/CLIMtools/oryza_19K-RGP/",
        imgSrc: "static/images/welcome/climtools.png"
    },
    oryzadownloads: {
        title: "Bulk Downloads",
        description: "FTP download of our data",
        link: "https://ftp.gramene.org/oryza/19K-RGP/",
        imgSrc: "static/images/welcome/download.png"
    },
    maizedownloads: {
        title: "Bulk Downloads",
        description: "FTP download of our data",
        link: "https://ftp.gramene.org/maize/release-current/",
        imgSrc: "static/images/welcome/download.png"
    },
    maizegdb: {
        title: "MaizeGDB",
        description: "Maize Genetics and Genomics Database",
        link: "https://maizegdb.org/",
        imgSrc: "static/images/welcome/maize/maizegdb.png",
        isExternal: true
    },
    pansites: {
        title: "Plant Pan Genomes",
        description: "Gramene-powered sites focused on specific crops",
        link: "pansites",
        imgSrc: "static/images/welcome/pangenomes.svg"
    },
    curated: {
        title: "Curated Gene Function",
        description: "Genes described in the literature",
        link: "?fq_field=capabilities&fq_value=pubs&category=Curated&name=publication",
        imgSrc: "static/images/welcome/curated.png"
    },
    tutorials: {
        title: "Video Tutorials",
        description: "Site features, explained!",
        link: "https://www.youtube.com/@sorghumbase9338",
        imgSrc: "static/images/welcome/tutorials.png",
        isExternal: true
    },
    videotutorials: {
        title: "Video Tutorials",
        description: "Site features, explained!",
        link: 'videotutorials',
        imgSrc: "static/images/welcome/tutorials.png"
    },
    // Shown only on sites with `tour: true` (see PortalsCmp).
    tour: {
        title: "Guided Tour",
        description: "Learn the gene search step by step, on a real search",
        route: "/tour",
        imgSrc: "static/images/welcome/tour.svg"
    }
};
const GrameneTool = ({ title, description, imgSrc, imgSrc2, link, route, drupalLink, ensemblPath, isExternal, ensemblURL, id, version })=>{
    let external;
    if (isExternal) external = /*#__PURE__*/ (0, _jsxRuntime.jsx)("small", {
        title: "This link opens a page from an external site",
        style: {
            float: 'right'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fi.FiExternalLink), {})
    });
    if (!link) {
        if (drupalLink) link = drupalLink;
        if (ensemblPath) link = ensemblURL + ensemblPath;
    } else if (link === 'pansites') route = '/pansites';
    // In-app pages are router links rather than full page loads.
    if (route) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
        to: route,
        style: {
            textDecoration: 'none'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Row), {
                className: "gramene-tool",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                        md: "auto",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            style: {
                                width: "96px"
                            },
                            src: imgSrc,
                            alt: title
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Col), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h5", {
                                style: {
                                    color: '#212529'
                                },
                                children: [
                                    title,
                                    external
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "gramene-tool-desc",
                                children: description
                            })
                        ]
                    })
                ]
            })
        })
    });
    if (link === 'ftp') link = `https://ftp.gramene.org/${id}/${version}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
        onClick: ()=>isExternal ? window.open(link, '_blank') : window.location.href = link,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Row), {
            className: "gramene-tool",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                    md: "auto",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        style: {
                            width: "96px"
                        },
                        src: imgSrc,
                        alt: title
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Col), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h5", {
                            children: [
                                title,
                                external
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "gramene-tool-desc",
                            children: description
                        })
                    ]
                })
            ]
        })
    });
};
const GrameneToolLink = ({ title, description, imgSrc, link, route, drupalLink, ensemblPath, isExternal, ensemblURL, id, version })=>{
    let external;
    if (isExternal) external = /*#__PURE__*/ (0, _jsxRuntime.jsx)("small", {
        title: "This link opens a page from an external site",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fi.FiExternalLink), {})
    });
    if (!link) {
        if (drupalLink) link = drupalLink;
        if (ensemblPath) link = ensemblURL + ensemblPath;
    } else if (link === 'ftp') link = `https://ftp.gramene.org/${id}/${version}`;
    if (route) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.NavDropdown).Item, {
        as: (0, _reactRouterDom.NavLink),
        to: route,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                style: {
                    width: "32px"
                },
                src: imgSrc
            }),
            "\xa0\xa0",
            title
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.NavDropdown).Item, {
        href: link,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                style: {
                    width: "32px"
                },
                src: imgSrc
            }),
            "\xa0\xa0",
            title
        ]
    });
};
const PortalsCmp = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "tools-wrapper",
        children: [
            props.location && props.location.pathname === '/pansites' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                children: "Plant Pan Genome sites"
            }),
            props.location && props.location.pathname === '/videotutorials' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                children: "Tutorial Videos"
            }),
            props.location && props.location.pathname === '/pansites' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Row), {
                xs: 1,
                md: 2,
                className: "g-4",
                children: (0, _confDefault.default).filter((site)=>site.id !== props.configuration.id && site.showInMenu).map((site, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                        onClick: ()=>window.location.href = site.url,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Row), {
                            className: "gramene-tool",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                                    md: "auto",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        style: {
                                            width: "165px"
                                        },
                                        src: `static/images/${site.id}_logo.svg`
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "gramene-tool-desc",
                                        children: site.description
                                    })
                                })
                            ]
                        })
                    }, idx))
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: props.location && props.location.pathname === '/videotutorials' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _grameneVideosDefault.default), {
                    playlistIds: props.configuration.playlistIds
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Row), {
                    xs: 1,
                    md: 2,
                    xxl: 3,
                    className: "g-4",
                    children: props.configuration.portals.filter((portal)=>portal !== 'tour' || props.configuration.tour).map((portal, idx)=>/*#__PURE__*/ (0, _react.createElement)(GrameneTool, {
                            ...tools[portal],
                            key: idx,
                            ensemblURL: props.configuration.ensemblURL,
                            id: props.configuration.id,
                            version: props.configuration.version
                        }))
                })
            })
        ]
    });
const Portals = (0, _reduxBundlerReact.connect)('selectConfiguration', PortalsCmp);
const PortalsDropdownCmp = ({ configuration })=>{
    if (configuration.portals2) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.NavDropdown), {
        id: 'portals-dropdown',
        title: 'Links',
        className: "dropup",
        children: configuration.portals2.map((portal, idx)=>/*#__PURE__*/ (0, _react.createElement)(GrameneToolLink, {
                ...tools[portal],
                key: idx,
                ensemblURL: configuration.ensemblURL,
                id: configuration.id,
                version: configuration.version
            }))
    });
};
const PortalsDropdown = (0, _reduxBundlerReact.connect)('selectConfiguration', PortalsDropdownCmp);
const ExamplesCmp = (props)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "examples-wrapper",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                children: "Examples"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Row), {
                xs: 1,
                md: 2,
                xl: 2,
                className: "g-4",
                children: props.configuration.examples.map((example, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                        onClick: ()=>window.location.href = example.link,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Row), {
                            className: "gramene-example",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Col), {
                                    md: "auto",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        src: example.imgSrc,
                                        alt: example.title
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Col), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                                            children: example.title
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "gramene-example-desc",
                                            children: example.description
                                        })
                                    ]
                                })
                            ]
                        })
                    }, idx))
            })
        ]
    });
};
const Examples = (0, _reduxBundlerReact.connect)('selectConfiguration', ExamplesCmp);

},{"react/jsx-runtime":"gonF6","react":"bmhQu","redux-bundler-react":"a9QVF","react-bootstrap":[["Col","ii9A3","default"],["NavDropdown","918Zj","default"],["Row","3Fk66","default"]],"react-icons/fi":"1HOcO","../conf":"fopA6","react-router-dom":"b9X5n","gramene-videos":"39jXd","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fopA6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _maizeJson = require("./maize.json");
var _maizeJsonDefault = parcelHelpers.interopDefault(_maizeJson);
var _mainJson = require("./main.json");
var _mainJsonDefault = parcelHelpers.interopDefault(_mainJson);
var _main69Json = require("./main69.json");
var _main69JsonDefault = parcelHelpers.interopDefault(_main69Json);
var _main70Json = require("./main70.json");
var _main70JsonDefault = parcelHelpers.interopDefault(_main70Json);
var _grapevineJson = require("./grapevine.json");
var _grapevineJsonDefault = parcelHelpers.interopDefault(_grapevineJson);
var _oryzaJson = require("./oryza.json");
var _oryzaJsonDefault = parcelHelpers.interopDefault(_oryzaJson);
var _oryza19KJson = require("./oryza19k.json");
var _oryza19KJsonDefault = parcelHelpers.interopDefault(_oryza19KJson);
var _sorghumJson = require("./sorghum.json");
var _sorghumJsonDefault = parcelHelpers.interopDefault(_sorghumJson);
var _yeastJson = require("./yeast.json");
var _yeastJsonDefault = parcelHelpers.interopDefault(_yeastJson);
// Firebase web config is loaded from FIREBASE_CONFIG_JSON in the build-time
// env (.env, never committed). If unset, the Auth panel mounts but stays
// inert. A subsite opts in by setting `"auth": true` in its config JSON.
const firebaseConfig = (()=>{
    const raw = '{"apiKey":"AIzaSyCyTJmxfWgfuhI6-8uqocSiE9KOWUlkgkk","authDomain":"gramene-auth.firebaseapp.com","projectId":"gramene-auth","storageBucket":"gramene-auth.appspot.com","messagingSenderId":"590873346270","appId":"1:590873346270:web:f76a31a93619e69439824f"}';
    if (!raw) return null;
    try {
        return JSON.parse(raw);
    } catch (e) {
        console.warn('FIREBASE_CONFIG_JSON is not valid JSON; Auth disabled.', e);
        return null;
    }
})();
// RELEASE (build-time env) picks a frozen Gramene main config: RELEASE=69 or
// RELEASE=70. Unset, main.json is used.
const main = {
    '69': (0, _main69JsonDefault.default),
    '70': (0, _main70JsonDefault.default)
}[undefined] || (0, _mainJsonDefault.default);
const subsites = [
    main,
    (0, _maizeJsonDefault.default),
    (0, _grapevineJsonDefault.default),
    (0, _oryzaJsonDefault.default),
    (0, _oryza19KJsonDefault.default),
    (0, _sorghumJsonDefault.default),
    (0, _yeastJsonDefault.default)
];
if (firebaseConfig) subsites.forEach((s)=>{
    if (s.auth) s.firebaseConfig = firebaseConfig;
});
exports.default = subsites;

},{"./maize.json":"8pOwM","./main.json":"MNK2k","./main69.json":"egosZ","./main70.json":"jeCTk","./grapevine.json":"kIF3o","./oryza.json":"gPxbw","./oryza19k.json":"5m8uL","./sorghum.json":"2bMHp","./yeast.json":"b7Y3Y","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8pOwM":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"id":"maize","name":"Gramene Maize","version":"v5","ga":"G-Y7ZYG1R8QT","description":"Comparative plant genomics focused on maize varieties","url":"https://maize-pangenome.gramene.org","ensemblURL":"https://maize-pangenome-ensembl.gramene.org","ensemblSite":"https://maize-pangenome-ensembl.gramene.org","ensemblRest":"https://data.gramene.org/pansite-ensembl-108","grameneData":"https://data.gramene.org/maize_v5","atlasUrl":"https://data.gramene.org/v70/gxa/","expressionApi":"https://data.gramene.org/v70","targetTaxonId":4577,"portals":["browser","reactome","atlas","blast","pansites","curated","maizedownloads","tutorials","maizegdb"],"portals2":["pansites","browser","reactome","blast","atlas","tutorials","maizedownloads"],"showInMenu":true,"showNews":true,"showGuides":true,"showFeed":true,"showTweets":true,"showViews":true,"date":"2025-03-03","views":{"userLists":"hidden","expression":"disabled","export":"hidden","taxonomy":"hidden","taxTree":"on","attrTable":"hidden","list":"on","help":"off","attribs":"hidden","exprViz":"hidden","ontologyEnrichment":"hidden"},"examples":[{"title":"lox9 Variant Image","description":"Explore genetic variation and alt-allele consequences from the Variant Effect Predictor (VEP).","imgSrc":"static/images/welcome/maize/lox9_Variant_Image.png","link":"https://maize-pangenome-ensembl.gramene.org/Zea_maysb73/Gene/Variation_Gene/Image?db=core;g=Zm00001eb005920;r=1:16843538-16850405"},{"title":"lox9 Pathway Diagram","description":"Jasmonic Acid Biosynthesis pathway at Plant Reactome.","imgSrc":"static/images/welcome/maize/lox9_Pathway_Diagram.png","link":"https://plantreactome.gramene.org/PathwayBrowser/#/R-ZMA-1119332&SEL=R-ZMA-1119658"},{"title":"MaizeCODE tracks","description":"Expression, Methylation, Acetylation, RAMPAGE, ChIP-seq tracks from  Cahn, J., Regulski, M., Lynn, J. et al. MaizeCODE reveals bi-directionally expressed enhancers that harbor molecular signatures of maize domestication. Nat Commun 15, 10854 (2024). https://doi.org/10.1038/s41467-024-55195-w","imgSrc":"static/images/welcome/maize/maizeCODE.png","link":"https://maize-pangenome-ensembl.gramene.org/Zea_maysb73/Location/View?db=;g=Zm00001eb054440;r=1:272330147-272333065;t=Zm00001eb054440_T001"}],"details":{"sequences":true,"VEP":true,"location":true,"expression":true,"homology":true,"pathways":true,"pubs":true,"xrefs":true},"panSite":{"sorghum_bicolor":{"url":"https://sorghumbase.org/genes","name":"SorghumBase","svg":"./static/images/sorghum_logo.svg"},"vitis_vinifera":{"url":"https://vitis.gramene.org","name":"Gramene Grapevine","svg":"./static/images/grapevine_logo.svg"},"oryza_sativa":{"url":"https://oryza.gramene.org","name":"Gramene Oryza","svg":"./static/images/oryza_logo.svg"}},"slides":[],"oldslides":[{"img":"static/images/welcome/maize/NAM.png","label":"NAM founder inbreds","text":"This site includes full genome sequences of the NAM founder lines and comparative genomic analyses of protein-coding gene families.","credit":"McMullen et al. Science (2009)"},{"img":"static/images/welcome/maize/lox-suggestions.png","label":"Type-ahead search","text":"Click in the search box and start typing to find matching terms. Select a suggested term to define a search filter. Add more filters at any time by searching for another search term."},{"img":"static/images/welcome/maize/lox-homologs.png","label":"Search results for homologs of lox1","text":"The taxo(ge)nomic distribution of search results highlights positions of genes on the assembled chromosomes. Drag-select regions to refine the search."},{"img":"static/images/welcome/maize/lox-expression.png","label":"Expression: EBI Atlas view","text":"This view depicts baseline gene expression data for a whole plant (top anatogram on the left of the results box) and for the plant\u2019s reproductive organs (bottom anatogram). Experiments are organized by study on the left side, and by tissue or developmental stage on the top of the graph."},{"img":"static/images/welcome/maize/lox-align-overview.png","label":"Homology: Alignment overview","text":"The homology tab displays an interactive gene tree visualization. The alignment overview mode shows a zoomed-out view of the multiple sequence alignment, coded by Interpro domain."},{"img":"static/images/welcome/maize/lox-malign.png","label":"Homology: Multiple sequence alignment","text":"The multiple sequence alignment mode lets you zoom in to explore differences among the sequences in a gene family."},{"img":"static/images/welcome/maize/lox-neighborhood.png","label":"Homology: Neighborhood Conservation view","text":"This view presents the target gene in the middle with a vertical red line connecting the homologs from each genome in the tree plus 10 flanking genes upstream and downstream color-coded by gene family. This allows you to identify structural variants and Presence/Absence variants in the region in question."},{"img":"static/images/welcome/maize/lox-pathways.png","label":"Pathways: Plant Reactome view","text":"From the literature, we know that lox9 is part of the jasmonic acid (JA) biosynthesis pathway. Accordingly, the Pathways panel shows that this gene product catalyzes a reaction in two pathways, JA biosynthesis, and 13-LOX/13-HPL."}]}');

},{}],"MNK2k":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"id\":\"main\",\"ga\":\"G-ZTEQBFCRXZ\",\"name\":\"GramenePlants\",\"version\":\"v70\",\"description\":\"Comparative plant genomics for crops and model organisms\",\"url\":\"https://www.gramene.org\",\"ensemblURL\":\"https://ensembl.gramene.org\",\"ensemblSite\":\"https://ensembl.gramene.org\",\"ensemblRest\":\"https://data.gramene.org/ensembl70\",\"grameneData\":\"https://data.gramene.org/v70\",\"newsApi\":\"https://www.sorghumbase.org\",\"atlasUrl\":\"https://data.gramene.org/v70/gxa/\",\"targetTaxonId\":3702,\"portals\":[\"browser\",\"reactome\",\"pansites\",\"tools\",\"climtools\",\"curated\",\"blast\",\"atlas\",\"videotutorials\",\"tour\",\"mart\"],\"portals2\":[\"pansites\",\"browser\",\"reactome\",\"climtools\",\"blast\",\"mart\",\"tools\",\"atlas\",\"trackhub\",\"outreach\",\"downloads\",\"archive\"],\"showInMenu\":true,\"showNews\":true,\"showGuides\":false,\"showFeed\":true,\"auth\":true,\"showTweets\":true,\"showViews\":true,\"tour\":true,\"enable_tbrowse_expression_zone\":true,\"hideAlerts\":false,\"date\":\"2026-12-01\",\"playlistIds\":[\"PLqQHG-yuRY1-z7-KKYe-BDL-lriaocrbZ\"],\"slides\":[],\"views\":{\"userLists\":\"off\",\"expression\":\"disabled\",\"export\":\"off\",\"taxonomy\":\"hidden\",\"taxTree\":\"on\",\"attrTable\":\"off\",\"list\":\"on\",\"help\":\"off\",\"attribs\":\"hidden\",\"exprViz\":\"off\",\"ontologyEnrichment\":\"off\"},\"details\":{\"sequences\":true,\"VEP\":false,\"location\":true,\"expression\":true,\"homology\":true,\"pathways\":true,\"pubs\":true,\"xrefs\":true},\"panSite\":{\"sorghum_bicolor\":{\"url\":\"https://sorghumbase.org/genes\",\"name\":\"SorghumBase\",\"svg\":\"./static/images/sorghum_logo.svg\",\"api\":\"https://data.sorghumbase.org/sorghum_v7\"},\"vitis_vinifera\":{\"url\":\"https://vitis.gramene.org\",\"name\":\"Gramene Grapevine\",\"svg\":\"./static/images/grapevine_logo.svg\",\"api\":\"https://data.gramene.org/grapevine_v4\"},\"oryza_sativa\":{\"url\":\"https://oryza.gramene.org\",\"name\":\"Gramene Oryza\",\"svg\":\"./static/images/oryza_logo.svg\",\"api\":\"https://data.gramene.org/oryza_v7\"},\"zea_mays\":{\"url\":\"https://maize-pangenome.gramene.org\",\"name\":\"Gramene Maize\",\"svg\":\"./static/images/maize_logo.svg\",\"api\":\"https://data.gramene.org/maize_v4\"}}}");

},{}],"egosZ":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"id\":\"main\",\"ga\":\"G-ZTEQBFCRXZ\",\"name\":\"GramenePlants\",\"version\":\"v69\",\"description\":\"Comparative plant genomics for crops and model organisms\",\"url\":\"https://www.gramene.org\",\"ensemblURL\":\"https://ensembl.gramene.org\",\"ensemblSite\":\"https://ensembl.gramene.org\",\"ensemblRest\":\"https://data.gramene.org/ensembl69\",\"grameneData\":\"https://data.gramene.org/v69\",\"newsApi\":\"https://www.sorghumbase.org\",\"atlasUrl\":\"https://data.gramene.org/v70/gxa/\",\"targetTaxonId\":3702,\"portals\":[\"browser\",\"reactome\",\"pansites\",\"tools\",\"climtools\",\"curated\",\"blast\",\"atlas\",\"videotutorials\",\"tour\",\"mart\"],\"portals2\":[\"pansites\",\"browser\",\"reactome\",\"climtools\",\"blast\",\"mart\",\"tools\",\"atlas\",\"trackhub\",\"outreach\",\"downloads\",\"archive\"],\"showInMenu\":true,\"showNews\":true,\"showGuides\":false,\"showFeed\":true,\"auth\":true,\"showTweets\":true,\"showViews\":true,\"tour\":false,\"enable_tbrowse_expression_zone\":false,\"hideAlerts\":false,\"date\":\"2026-05-28\",\"playlistIds\":[\"PLqQHG-yuRY1-z7-KKYe-BDL-lriaocrbZ\"],\"slides\":[],\"views\":{\"userLists\":\"hidden\",\"expression\":\"disabled\",\"export\":\"hidden\",\"taxonomy\":\"hidden\",\"taxTree\":\"on\",\"attrTable\":\"hidden\",\"list\":\"on\",\"help\":\"off\",\"attribs\":\"hidden\",\"exprViz\":\"hidden\",\"ontologyEnrichment\":\"hidden\"},\"details\":{\"sequences\":true,\"VEP\":false,\"location\":true,\"expression\":true,\"homology\":true,\"pathways\":true,\"pubs\":true,\"xrefs\":true},\"panSite\":{\"sorghum_bicolor\":{\"url\":\"https://sorghumbase.org/genes\",\"name\":\"SorghumBase\",\"svg\":\"./static/images/sorghum_logo.svg\",\"api\":\"https://data.sorghumbase.org/sorghum_v7\"},\"vitis_vinifera\":{\"url\":\"https://vitis.gramene.org\",\"name\":\"Gramene Grapevine\",\"svg\":\"./static/images/grapevine_logo.svg\",\"api\":\"https://data.gramene.org/grapevine_v4\"},\"oryza_sativa\":{\"url\":\"https://oryza.gramene.org\",\"name\":\"Gramene Oryza\",\"svg\":\"./static/images/oryza_logo.svg\",\"api\":\"https://data.gramene.org/oryza_v7\"},\"zea_mays\":{\"url\":\"https://maize-pangenome.gramene.org\",\"name\":\"Gramene Maize\",\"svg\":\"./static/images/maize_logo.svg\",\"api\":\"https://data.gramene.org/maize_v4\"}}}");

},{}],"jeCTk":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"id\":\"main\",\"ga\":\"G-ZTEQBFCRXZ\",\"name\":\"GramenePlants\",\"version\":\"v70\",\"description\":\"Comparative plant genomics for crops and model organisms\",\"url\":\"https://www.gramene.org\",\"ensemblURL\":\"https://ensembl-dev.gramene.org\",\"ensemblSite\":\"https://ensembl-dev.gramene.org\",\"ensemblRest\":\"https://data.gramene.org/ensembl70\",\"grameneData\":\"https://data.gramene.org/v70\",\"newsApi\":\"https://www.sorghumbase.org\",\"atlasUrl\":\"https://data.gramene.org/v70/gxa/\",\"targetTaxonId\":3702,\"portals\":[\"browser\",\"reactome\",\"pansites\",\"tools\",\"climtools\",\"curated\",\"blast\",\"atlas\",\"videotutorials\",\"tour\",\"mart\"],\"portals2\":[\"pansites\",\"browser\",\"reactome\",\"climtools\",\"blast\",\"mart\",\"tools\",\"atlas\",\"trackhub\",\"outreach\",\"downloads\",\"archive\"],\"showInMenu\":true,\"showNews\":true,\"showGuides\":false,\"showFeed\":true,\"auth\":true,\"showTweets\":true,\"showViews\":true,\"tour\":true,\"enable_tbrowse_expression_zone\":true,\"hideAlerts\":false,\"date\":\"2026-12-01\",\"playlistIds\":[\"PLqQHG-yuRY1-z7-KKYe-BDL-lriaocrbZ\"],\"slides\":[],\"views\":{\"userLists\":\"off\",\"expression\":\"disabled\",\"export\":\"off\",\"taxonomy\":\"hidden\",\"taxTree\":\"on\",\"attrTable\":\"off\",\"list\":\"on\",\"help\":\"off\",\"attribs\":\"hidden\",\"exprViz\":\"off\",\"ontologyEnrichment\":\"off\"},\"details\":{\"sequences\":true,\"VEP\":false,\"location\":true,\"expression\":true,\"homology\":true,\"pathways\":true,\"pubs\":true,\"xrefs\":true},\"panSite\":{\"sorghum_bicolor\":{\"url\":\"https://sorghumbase.org/genes\",\"name\":\"SorghumBase\",\"svg\":\"./static/images/sorghum_logo.svg\",\"api\":\"https://data.sorghumbase.org/sorghum_v7\"},\"vitis_vinifera\":{\"url\":\"https://vitis.gramene.org\",\"name\":\"Gramene Grapevine\",\"svg\":\"./static/images/grapevine_logo.svg\",\"api\":\"https://data.gramene.org/grapevine_v4\"},\"oryza_sativa\":{\"url\":\"https://oryza.gramene.org\",\"name\":\"Gramene Oryza\",\"svg\":\"./static/images/oryza_logo.svg\",\"api\":\"https://data.gramene.org/oryza_v7\"},\"zea_mays\":{\"url\":\"https://maize-pangenome.gramene.org\",\"name\":\"Gramene Maize\",\"svg\":\"./static/images/maize_logo.svg\",\"api\":\"https://data.gramene.org/maize_v4\"}}}");

},{}],"kIF3o":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"id\":\"grapevine\",\"name\":\"Gramene Grapevine\",\"version\":\"v4\",\"ga\":\"G-ZTEQBFCRXZ\",\"description\":\"Comparative plant genomics focused on grapevine varieties\",\"url\":\"https://vitis.gramene.org\",\"ensemblURL\":\"https://vitis-ensembl.gramene.org\",\"ensemblSite\":\"https://vitis-ensembl.gramene.org\",\"ensemblRest\":\"https://data.gramene.org/pansite-ensembl-87\",\"grameneData\":\"https://data.gramene.org/grapevine_v4\",\"atlasUrl\":\"https://data.gramene.org/v70/gxa/\",\"expressionApi\":\"https://data.gramene.org/v70\",\"curation\":{\"url\":\"http://curate.gramene.org/grapevine_v4?since=71275&gene=\",\"taxa\":{\"29760019\":1,\"29760020\":1}},\"targetTaxonId\":29760020,\"portals\":[\"browser\",\"blast\",\"pansites\",\"curated\"],\"portals2\":[\"pansites\",\"browser\",\"reactome\",\"climtools\",\"atlas\",\"trackhub\"],\"showInMenu\":true,\"showNews\":true,\"showGuides\":true,\"showFeed\":true,\"showTweets\":true,\"showViews\":true,\"date\":\"2024-01-13\",\"views\":{\"userLists\":\"hidden\",\"expression\":\"disabled\",\"export\":\"hidden\",\"taxonomy\":\"hidden\",\"taxTree\":\"on\",\"attrTable\":\"hidden\",\"list\":\"on\",\"help\":\"off\",\"attribs\":\"hidden\",\"exprViz\":\"hidden\",\"ontologyEnrichment\":\"hidden\"},\"slides\":[],\"details\":{\"sequences\":true,\"VEP\":false,\"location\":true,\"expression\":true,\"homology\":true,\"pathways\":true,\"pubs\":true,\"xrefs\":true},\"panSite\":{\"sorghum_bicolor\":{\"url\":\"https://sorghumbase.org/genes\",\"name\":\"SorghumBase\",\"svg\":\"./static/images/sorghum_logo.svg\"},\"oryza_sativa\":{\"url\":\"https://oryza.gramene.org\",\"name\":\"Gramene Oryza\",\"svg\":\"./static/images/oryza_logo.svg\"},\"zea_maysb73\":{\"url\":\"https://maize-pangenome.gramene.org\",\"name\":\"Gramene Maize\",\"svg\":\"./static/images/maize_logo.svg\"}}}");

},{}],"gPxbw":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"id\":\"oryza\",\"name\":\"Gramene Oryza\",\"version\":\"v8\",\"description\":\"Comparative plant genomics focused on rice varieties\",\"url\":\"https://oryza.gramene.org\",\"ensemblURL\":\"http://oryza-ensembl.gramene.org\",\"ensemblSite\":\"http://oryza-ensembl.gramene.org\",\"ensemblRest\":\"https://data.gramene.org/pansite-ensembl-108\",\"grameneData\":\"https://data.gramene.org/oryza_v8\",\"atlasUrl\":\"https://data.gramene.org/v70/gxa/\",\"expressionApi\":\"https://data.gramene.org/v70\",\"curation\":{\"url\":\"http://curate.gramene.org/oryza_v7?since=4577&gene=\",\"taxa\":{\"39947013\":\"Oryza sativa Japonica\"}},\"targetTaxonId\":39946,\"portals\":[\"browser\",\"reactome\",\"atlas\",\"blast\",\"pansites\",\"curated\",\"oryzaclimtools\",\"tutorials\",\"oryzadownloads\"],\"portals2\":[\"pansites\",\"browser\",\"reactome\",\"blast\",\"oryzaclimtools\",\"atlas\",\"tutorials\",\"oryzadownloads\"],\"showInMenu\":true,\"showNews\":true,\"showGuides\":true,\"showFeed\":true,\"showTweets\":true,\"showViews\":true,\"date\":\"2026-08-09\",\"views\":{\"userLists\":\"hidden\",\"expression\":\"disabled\",\"export\":\"hidden\",\"taxonomy\":\"hidden\",\"taxTree\":\"on\",\"attrTable\":\"hidden\",\"list\":\"on\",\"help\":\"off\",\"attribs\":\"hidden\",\"exprViz\":\"hidden\",\"ontologyEnrichment\":\"hidden\"},\"examples\":[{\"title\":\"GS3 Variant Image\",\"description\":\"Explore genetic variation and alt-allele consequences from the Variant Effect Predictor (VEP).\",\"imgSrc\":\"static/images/welcome/oryza/GS3_Variant_Image.png\",\"link\":\"https://oryza-ensembl.gramene.org/Oryza_sativa/Gene/Variation_Gene/Image?db=core;g=Os03g0407400\"},{\"title\":\"GS3 Pathway Diagram\",\"description\":\"Curated seed development pathway \\\"Regulation of seed size\\\" at Plant Reactome.\",\"imgSrc\":\"static/images/welcome/oryza/GS3_Pathway_Diagram.png\",\"link\":\"https://plantreactome.gramene.org/PathwayBrowser/#/R-OSA-9035605\"}],\"slides\":[],\"details\":{\"sequences\":true,\"VEP\":true,\"location\":true,\"expression\":true,\"homology\":true,\"pathways\":true,\"pubs\":true,\"xrefs\":true},\"panSite\":{\"sorghum_bicolor\":{\"url\":\"https://sorghumbase.org/genes\",\"name\":\"SorghumBase\",\"svg\":\"./static/images/sorghum_logo.svg\"},\"vitis_vinifera\":{\"url\":\"https://vitis.gramene.org\",\"name\":\"Gramene Grapevine\",\"svg\":\"./static/images/grapevine_logo.svg\"},\"zea_maysb73\":{\"url\":\"https://maize-pangenome.gramene.org\",\"name\":\"Gramene Maize\",\"svg\":\"./static/images/maize_logo.svg\"}}}");

},{}],"5m8uL":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"id":"oryza19k","name":"Oryza 19K Rice Genome Project","version":"v1","showRelease":false,"logo":"static/images/oryza_logo.svg","description":"Explore comparative genomics of rice varieties and genetic variation in the 19K-RGP on five reference genomes","url":"https://oryza19k.gramene.org","ensemblURL":"http://oryza-ensembl-dev.gramene.org","ensemblSite":"http://oryza-ensembl-dev.gramene.org","ensemblRest":"https://data.gramene.org/pansite-ensembl-108","grameneData":"https://data.gramene.org/oryza_v9","atlasUrl":"https://data.gramene.org/v70/gxa/","expressionApi":"https://data.gramene.org/v70","targetTaxonId":39946,"portals":["browser","reactome","atlas","blast","pansites","curated","oryzaclimtools","videotutorials","oryzadownloads"],"portals2":["pansites","browser","reactome","blast","oryzaclimtools","atlas","videotutorials","oryzadownloads"],"showInMenu":true,"showNews":true,"showGuides":true,"auth":true,"showFeed":false,"showTweets":false,"date":"2026-08-09","sections":[{"label":"Platforms","route":"/platforms","repo":"oryza-19k-rgp","path":"Platforms","expand":true},{"label":"Cite","route":"/cite","repo":"oryza-19k-rgp","path":"Cite"}],"welcomeDoc":{"repo":"oryza-19k-rgp","path":"Start here/02-ataglance.md","branch":"main"},"theme":"dark","splitHome":true,"brand":{"name":"Gramene","sub":"ORYZA 19K-RGP"},"portalsHeading":"Gramene Portals","hero":{"eyebrow":"Rice comparative genomics","graphic":"rice-stalk","links":[{"label":"SNP-Seek","url":"/platforms?doc=Platforms%2F01-SNP-Seek%20v3.md"},{"label":"Gramene","url":"/platforms?doc=Platforms%2F02-GrameneOryza.md"},{"label":"CLIMtools","url":"/platforms?doc=Platforms%2F03-Oryza%20CLIMtools.md"},{"label":"19K SNPs Map","url":"/platforms?doc=Platforms%2F04-19K%20SNPs%20Map.md"}]},"atAGlance":[{"value":"19,035","label":"rice genomes","accent":"green"},{"value":"9,309","label":"newly sequenced","accent":"green"},{"value":"5","label":"platinum references","accent":"green"},{"value":"~57M","label":"variants","accent":"gold"},{"value":"2.02M","label":"high-effect regulatory variants","accent":"gold"},{"value":"138","label":"AlphaFold3 models","accent":"green"}],"examples":[{"title":"GS3 Variant Image","description":"Explore genetic variation and alt-allele consequences from the Variant Effect Predictor (VEP).","imgSrc":"static/images/welcome/oryza/GS3_Variant_Image.png","link":"https://oryza-ensembl.gramene.org/Oryza_sativa/Gene/Variation_Gene/Image?db=core;g=Os03g0407400"},{"title":"GS3 Pathway Diagram","description":"Curated seed development pathway \\"Regulation of seed size\\" at Plant Reactome.","imgSrc":"static/images/welcome/oryza/GS3_Pathway_Diagram.png","link":"https://plantreactome.gramene.org/PathwayBrowser/#/R-OSA-9035605"}],"slides":[{"img":"static/images/oryza19k/slide1.png","label":"Oryza 19K-RGP","text":"Genetic variation data generated from more than nineteen thousand rice accessions."},{"img":"static/images/oryza19k/slide2.png","label":"Reference genomes","text":"Variants have been called on five representative rice varieties with high\u2011quality genome assemblies."},{"img":"static/images/oryza19k/slide3.png","label":"Variant Effect Prediction (VEP)","text":"Whenever a variant overlaps a gene, the system classifies the likely effect of the alternate allele on transcripts or encoded protein products. Particularly important are deleterious protein\u2011altering variants\u2014such as premature stop codons, frameshift mutations, and disrupted splice sites. These predicted loss\u2011of\u2011function alleles are indexed and easily searchable, allowing users to rapidly identify germplasm lines carrying impactful mutations in any gene of interest."}],"details":{"sequences":true,"VEP":true,"location":true,"expression":true,"homology":true,"pathways":true,"pubs":true,"xrefs":true},"playlistIds":["PLqQHG-yuRY1_-qa95pkBDRGNuVFKHq2CD"],"curation":{"url":"http://curate.gramene.org/sorghum_v10?since=4479&gene=","taxa":{}},"showViews":true,"views":{"userLists":"off","expression":"disabled","export":"off","taxonomy":"hidden","taxTree":"on","list":"on","help":"off","attribs":"disabled","exprViz":"off","ontologyEnrichment":"off"},"panSite":{"sorghum_bicolor":{"url":"https://sorghumbase.org/genes","name":"SorghumBase","svg":"./static/images/sorghum_logo.svg"},"vitis_vinifera":{"url":"https://vitis.gramene.org","name":"Gramene Grapevine","svg":"./static/images/grapevine_logo.svg"},"zea_maysb73":{"url":"https://maize-pangenome.gramene.org","name":"Gramene Maize","svg":"./static/images/maize_logo.svg"}}}');

},{}],"2bMHp":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"id\":\"sorghum\",\"name\":\"Sorghumbase\",\"version\":\"v6\",\"description\":\"Genomic resources for the sorghum research community\",\"url\":\"https://www.sorghumbase.org\",\"ensemblURL\":\"https://ensembl-dev.sorghumbase.org\",\"ensemblSite\":\"https://ensembl-dev.sorghumbase.org\",\"ensemblRest\":\"https://data.gramene.org/pansite-ensembl-87\",\"grameneData\":\"https://data.sorghumbase.org/sorghum_v6\",\"targetTaxonId\":4588,\"curation\":{\"url\":\"http://curate.gramene.org/sorghum_v6?since=4479&gene=\",\"taxa\":{\"4558\":1,\"4558001\":1}},\"alertText\":\"Click the search icon in the menu bar or type / to search\",\"portals\":[\"browser\",\"blast\",\"pansites\",\"curated\"],\"portals2\":[\"pansites\",\"browser\",\"reactome\",\"climtools\",\"blast\",\"atlas\",\"trackhub\"],\"showInMenu\":true,\"showNews\":true,\"showGuides\":true,\"showFeed\":true,\"showTweets\":true,\"slides\":[],\"details\":{\"sequences\":true,\"VEP\":true,\"location\":true,\"expression\":true,\"homology\":true,\"pathways\":true,\"pubs\":true,\"xrefs\":true},\"panSite\":{\"vitis_vinifera\":{\"url\":\"https://vitis.gramene.org\",\"name\":\"Gramene Grapevine\",\"svg\":\"./static/images/grapevine_logo.svg\"},\"oryza_sativa\":{\"url\":\"https://oryza.gramene.org\",\"name\":\"Gramene Oryza\",\"svg\":\"./static/images/oryza_logo.svg\"},\"zea_maysb73\":{\"url\":\"https://maize-pangenome.gramene.org\",\"name\":\"Gramene Maize\",\"svg\":\"./static/images/maize_logo.svg\"}}}");

},{}],"b7Y3Y":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"id\":\"yeast\",\"name\":\"Gramene Yeast\",\"description\":\"Pan genome browser for yeast varieties\",\"version\":\"v1\",\"url\":\"https://yeast.gramene.org\",\"ensemblURL\":\"https://yeast-ensembl.gramene.org\",\"ensemblSite\":\"https://yeast-ensembl.gramene.org\",\"ensemblRest\":\"https://data.gramene.org/pansite-ensembl-87\",\"grameneData\":\"https://data.gramene.org/yeast_v1\",\"targetTaxonId\":3702,\"portals\":[\"browser\",\"pansites\"],\"portals2\":[\"pansites\",\"browser\",\"reactome\",\"climtools\",\"atlas\",\"trackhub\"],\"showNews\":false,\"showGuides\":false,\"showFeed\":false,\"showTweets\":false,\"showInMenu\":false,\"date\":\"2022-03-30\",\"slides\":[],\"details\":{\"sequences\":true,\"VEP\":false,\"location\":true,\"expression\":false,\"homology\":true,\"pathways\":false,\"pubs\":false,\"xrefs\":false}}");

},{}],"39jXd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
var _bootstrapMinCss = require("bootstrap/dist/css/bootstrap.min.css");
var _videoGalleryCss = require("../src/VideoGallery.css");
function _regenerator() {
    var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return _regeneratorDefine2(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function() {
        return this;
    }), _regeneratorDefine2(u, "toString", function() {
        return "[object Generator]";
    }), (_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    })();
}
function _regeneratorDefine2(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
        function o(r, n) {
            _regeneratorDefine2(e, r, function(e) {
                return this._invoke(r, n, e);
            });
        }
        r ? i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
    }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
function VideoGallery(_ref) {
    var _playlists$currentSec;
    var playlistIds = _ref.playlistIds;
    var _useState = (0, _react.useState)([]), playlists = _useState[0], setPlaylists = _useState[1];
    var _useState2 = (0, _react.useState)(true), loading = _useState2[0], setLoading = _useState2[1];
    var _useState3 = (0, _react.useState)(null), currentSection = _useState3[0], setCurrentSection = _useState3[1];
    var sectionRefs = (0, _react.useRef)([]);
    var showTOC = playlists.length > 1;
    (0, _react.useEffect)(function() {
        function fetchVideos() {
            return _fetchVideos.apply(this, arguments);
        }
        function _fetchVideos() {
            _fetchVideos = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3() {
                var fetchPlaylistItems, fetchPlaylists, videoLists, videoListItems, merged, _t;
                return _regenerator().w(function(_context3) {
                    while(true)switch(_context3.p = _context3.n){
                        case 0:
                            setLoading(true);
                            _context3.p = 1;
                            fetchPlaylistItems = /*#__PURE__*/ function() {
                                var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee(playlistId) {
                                    var res, data;
                                    return _regenerator().w(function(_context) {
                                        while(true)switch(_context.n){
                                            case 0:
                                                _context.n = 1;
                                                return fetch("https://data.gramene.org/youtube/playlistItems?playlistId=" + playlistId);
                                            case 1:
                                                res = _context.v;
                                                _context.n = 2;
                                                return res.json();
                                            case 2:
                                                data = _context.v;
                                                return _context.a(2, data.items || []);
                                        }
                                    }, _callee);
                                }));
                                return function fetchPlaylistItems(_x) {
                                    return _ref2.apply(this, arguments);
                                };
                            }();
                            fetchPlaylists = /*#__PURE__*/ function() {
                                var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2(playlistId) {
                                    var res, data;
                                    return _regenerator().w(function(_context2) {
                                        while(true)switch(_context2.n){
                                            case 0:
                                                _context2.n = 1;
                                                return fetch("https://data.gramene.org/youtube/playlists?playlistId=" + playlistId);
                                            case 1:
                                                res = _context2.v;
                                                _context2.n = 2;
                                                return res.json();
                                            case 2:
                                                data = _context2.v;
                                                return _context2.a(2, data.items || []);
                                        }
                                    }, _callee2);
                                }));
                                return function fetchPlaylists(_x2) {
                                    return _ref3.apply(this, arguments);
                                };
                            }();
                            _context3.n = 2;
                            return Promise.all(playlistIds.map(fetchPlaylists));
                        case 2:
                            videoLists = _context3.v;
                            _context3.n = 3;
                            return Promise.all(playlistIds.map(fetchPlaylistItems));
                        case 3:
                            videoListItems = _context3.v;
                            merged = videoLists.map(function(list, index) {
                                var _list$;
                                var snippet = ((_list$ = list[0]) === null || _list$ === void 0 ? void 0 : _list$.snippet) || {};
                                return {
                                    title: snippet.title || '',
                                    description: snippet.description || '',
                                    videos: videoListItems[index] || []
                                };
                            });
                            setPlaylists(merged);
                            sectionRefs.current = merged.map(function() {
                                return null;
                            }); // reset refs
                            _context3.n = 5;
                            break;
                        case 4:
                            _context3.p = 4;
                            _t = _context3.v;
                            console.error('Failed to load videos:', _t);
                            setPlaylists([]);
                        case 5:
                            _context3.p = 5;
                            setLoading(false);
                            return _context3.f(5);
                        case 6:
                            return _context3.a(2);
                    }
                }, _callee3, null, [
                    [
                        1,
                        4,
                        5,
                        6
                    ]
                ]);
            }));
            return _fetchVideos.apply(this, arguments);
        }
        fetchVideos();
    }, [
        playlistIds
    ]);
    // Setup IntersectionObserver after playlists load
    (0, _react.useEffect)(function() {
        if (!playlists.length || !sectionRefs.current.length) return;
        var observer = new IntersectionObserver(function(entries) {
            var visibleSections = entries.filter(function(entry) {
                return entry.isIntersecting;
            }).sort(function(a, b) {
                return b.intersectionRatio - a.intersectionRatio;
            });
            if (visibleSections.length > 0) {
                var index = sectionRefs.current.findIndex(function(el) {
                    return el === visibleSections[0].target;
                });
                setCurrentSection(index);
            }
        }, {
            rootMargin: '-40% 0px -50% 0px',
            threshold: [
                0.25,
                0.5,
                0.75
            ]
        });
        sectionRefs.current.forEach(function(el) {
            if (el) observer.observe(el);
        });
        return function() {
            return observer.disconnect();
        };
    }, [
        playlists
    ]);
    if (loading) return /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "Loading videos...");
    if (!playlists.length) return /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "No playlists available.");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactBootstrap.Container), {
        fluid: true
    }, currentSection !== null && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "position-fixed w-100 bg-white shadow-sm py-2 px-4",
        style: {
            top: 0,
            zIndex: 1040
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("h5", {
        className: "mb-0 text-primary"
    }, (_playlists$currentSec = playlists[currentSection]) === null || _playlists$currentSec === void 0 ? void 0 : _playlists$currentSec.title)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactBootstrap.Row), {
        className: "pt-0"
    }, showTOC && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactBootstrap.Col), {
        xs: 12,
        lg: 3,
        className: "mb-4"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        id: "toc-nav",
        className: "bg-white border p-3 position-sticky",
        style: {
            top: '6rem',
            zIndex: 1020
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("h5", {
        className: "fw-bold mb-3"
    }, "Playlists"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactBootstrap.Nav), {
        className: "flex-column"
    }, playlists.map(function(playlist, i) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactBootstrap.Nav).Link, {
            key: i,
            href: "#playlist-" + i,
            onClick: function onClick(e) {
                e.preventDefault();
                document.getElementById("playlist-" + i).scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            },
            className: "nav-link " + (currentSection === i ? 'fw-bold text-primary border-start border-4 ps-2 border-primary bg-light' : 'text-dark')
        }, playlist.title);
    })))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactBootstrap.Col), {
        lg: showTOC ? 9 : 12
    }, playlists.map(function(playlist, i) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("section", {
            key: i,
            id: "playlist-" + i,
            ref: function ref(el) {
                return sectionRefs.current[i] = el;
            },
            className: "mb-5",
            style: {
                paddingTop: '6rem'
            } // avoids sticky title overlap
        }, showTOC && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("h3", {
            className: "mb-2"
        }, playlist.title), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", {
            className: "text-muted"
        }, playlist.description)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactBootstrap.Row), {
            xs: 1,
            md: 1,
            lg: 1,
            xl: 1,
            className: "g-4 mt-3"
        }, playlist.videos.map(function(video) {
            var videoId = video.snippet.resourceId.videoId;
            var title = video.snippet.title;
            var description = video.snippet.description;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactBootstrap.Row), {
                key: videoId,
                className: "mb-3"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactBootstrap.Col), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                className: "ratio ratio-16x9"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement("iframe", {
                src: "https://www.youtube.com/embed/" + videoId + "?modestbranding=1&rel=0",
                title: title,
                allow: "autoplay; encrypted-media",
                allowFullScreen: true
            }))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactBootstrap.Col), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("h4", null, title), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, description)));
        })));
    }))));
}
exports.default = VideoGallery;

},{"react":"bmhQu","react-bootstrap":[["Col","ii9A3","default"],["Container","8Pton","default"],["Nav","axkz0","default"],["Row","3Fk66","default"]],"bootstrap/dist/css/bootstrap.min.css":"bnvTo","../src/VideoGallery.css":"3Eu6w","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bnvTo":[function() {},{}],"3Eu6w":[function() {},{}],"lVWfx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GithubDoc", ()=>GithubDoc);
parcelHelpers.export(exports, "useGithubDocList", ()=>useGithubDocList);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRemark = require("react-remark");
var _remarkGfm = require("remark-gfm");
var _remarkGfmDefault = parcelHelpers.interopDefault(_remarkGfm);
var _remarkImgLinks = require("@pondorasti/remark-img-links");
var _remarkImgLinksDefault = parcelHelpers.interopDefault(_remarkImgLinks);
var _rehypeSlug = require("rehype-slug");
var _rehypeSlugDefault = parcelHelpers.interopDefault(_rehypeSlug);
var _fi = require("react-icons/fi");
var _githubDocsCss = require("../css/githubDocs.css");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var _excluded = [
    "href",
    "children"
], _excluded2 = [
    "href",
    "children"
];
function _toConsumableArray(r) {
    return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
    if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _regenerator() {
    var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return _regeneratorDefine2(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function() {
        return this;
    }), _regeneratorDefine2(u, "toString", function() {
        return "[object Generator]";
    }), (_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    })();
}
function _regeneratorDefine2(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
        function o(r, n) {
            _regeneratorDefine2(e, r, function(e) {
                return this._invoke(r, n, e);
            });
        }
        r ? i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
    }, _regeneratorDefine2(e, r, n, t);
}
function _slicedToArray(r, e) {
    return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
function _createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
// ---------------------------------------------------------------------------
// GithubDocs — render a tree of Markdown files straight from a GitHub repo.
//
// The whole repo tree is pulled in one Git-Trees API call (recursive=1), the
// `.md` files under `path` are reassembled into a folder hierarchy, and each
// subdirectory becomes a collapsible level in the sidebar. Selecting a file
// renders it in the reading pane; relative image and `.md` links resolve
// against the repo so the docs stay self-contained.
//
// Props:
//   org      GitHub owner/org        (required)
//   repo     repository name         (required)
//   path     base directory in repo  (default '' = repo root)
//   branch   branch/ref              (default 'main', falls back to 'master')
//   heading  sidebar/root label      (default 'Documentation')
//   offset   px of page chrome above the component, so it can size itself to
//            `calc(100vh - offset)` and scroll internally (auto-measured too)
// ---------------------------------------------------------------------------
// Module-level caches survive component remounts within a page session.
var treeCache = new Map(); // `${org}/${repo}@${branch}` -> flat tree array
var contentCache = new Map(); // blob sha -> { title, body }
var PREFIX_RE = /^(\d+)[-_.\s]+(.*)$/; // optional "01-" ordering prefix
var DATE_RE = /---(\d{4}-\d{2}-\d{2})$/; // optional "---YYYY-MM-DD" suffix
var FRONT_RE = /^---\r?\n([\s\S]*?)\r?\n---\r?\n?/; // leading front-matter block
// Directories that hold assets, never docs.
var ASSET_DIRS = new Set([
    'images',
    'image',
    'img',
    'assets',
    'asset',
    'media',
    'static'
]);
var isMarkdown = function isMarkdown(name) {
    return /\.md$/i.test(name);
};
var isHidden = function isHidden(seg) {
    return /^[_.]/.test(seg) || ASSET_DIRS.has(seg.toLowerCase());
};
// Turn a raw file/dir name into a readable label: drop ".md", a numeric
// ordering prefix, and a trailing date, then de-slugify.
function labelFor(rawName, isDir) {
    var base = isDir ? rawName : rawName.replace(/\.md$/i, '');
    var dm = DATE_RE.exec(base);
    if (dm) base = base.slice(0, dm.index);
    var pm = PREFIX_RE.exec(base);
    if (pm) base = pm[2];
    return base.replace(/[-_]+/g, ' ').trim();
}
function orderOf(rawName) {
    var m = PREFIX_RE.exec(rawName);
    return m ? parseInt(m[1], 10) : null;
}
// The trailing "---YYYY-MM-DD" publish date, if any (kept as a string, which
// sorts correctly lexicographically). Drives sort="date".
function dateOf(rawName, isDir) {
    var base = isDir ? rawName : rawName.replace(/\.md$/i, '');
    var m = DATE_RE.exec(base);
    return m ? m[1] : null;
}
// Pull a leading "--- ... ---" front-matter block off Markdown text. A tiny
// title-only scanner, not a full YAML parser; returns the body with the block
// stripped so the fence doesn't render as an <hr>.
function parseFrontMatter(text) {
    if (typeof text !== 'string') return {
        title: null,
        body: text
    };
    var m = FRONT_RE.exec(text);
    if (!m) return {
        title: null,
        body: text
    };
    var title = null;
    m[1].split(/\r?\n/).forEach(function(line) {
        var t = /^\s*title:\s*(.+?)\s*$/.exec(line);
        if (t) title = t[1].replace(/^['"]|['"]$/g, '');
    });
    return {
        title: title,
        body: text.slice(m[0].length)
    };
}
// Build a nested {dir,file} tree from GitHub's flat recursive listing, keeping
// only Markdown under `basePath`. `sortMode`/`nowStr` control ordering and
// future-hiding (see pruneAndSort). Returns { roots, byPath, root }.
function buildTree(flat, basePath, sortMode, nowStr) {
    var base = basePath ? basePath.replace(/^\/+|\/+$/g, '') : '';
    var byPath = new Map();
    // The base/root level is keyed by '' regardless of `basePath`, so top-level
    // entries get parentPath '' and breadcrumbs stop at the heading.
    var root = {
        type: 'dir',
        children: [],
        fullPath: '',
        label: null
    };
    byPath.set('', root);
    var _ensureDir = function ensureDir(relPath, parentPath) {
        if (byPath.has(relToFull(relPath, base))) return byPath.get(relToFull(relPath, base));
        var parentRel = relPath.includes('/') ? relPath.slice(0, relPath.lastIndexOf('/')) : '';
        var parent = parentRel ? _ensureDir(parentRel) : root;
        var name = relPath.slice(relPath.lastIndexOf('/') + 1);
        var node = {
            type: 'dir',
            name: name,
            label: labelFor(name, true),
            order: orderOf(name),
            date: dateOf(name, true),
            fullPath: relToFull(relPath, base),
            parentPath: parent.fullPath,
            children: []
        };
        parent.children.push(node);
        byPath.set(node.fullPath, node);
        return node;
    };
    flat.forEach(function(entry) {
        if (entry.type !== 'blob' || !isMarkdown(entry.path)) return;
        var rel = entry.path;
        if (base) {
            if (!rel.startsWith(base + '/')) return;
            rel = rel.slice(base.length + 1);
        }
        var segs = rel.split('/');
        if (segs.some(isHidden)) return;
        var relDir = rel.includes('/') ? rel.slice(0, rel.lastIndexOf('/')) : '';
        var parent = relDir ? _ensureDir(relDir) : root;
        var name = segs[segs.length - 1];
        var node = {
            type: 'file',
            name: name,
            label: labelFor(name, false),
            order: orderOf(name),
            date: dateOf(name, false),
            fullPath: entry.path,
            parentPath: parent.fullPath,
            sha: entry.sha
        };
        parent.children.push(node);
        byPath.set(node.fullPath, node);
    });
    pruneAndSort(root, sortMode, nowStr);
    return {
        roots: root.children,
        byPath: byPath,
        root: root
    };
}
var relToFull = function relToFull(rel, base) {
    return base ? "".concat(base, "/").concat(rel) : rel;
};
// Drop directories with no Markdown anywhere beneath them, then sort each level.
//   sortMode 'date'  → newest-first by the ---YYYY-MM-DD suffix; entries dated
//                      after `nowStr` are hidden (not-yet-published).
//   sortMode 'order' → numeric ordering prefix (unprefixed last), then alpha.
function pruneAndSort(node, sortMode, nowStr) {
    node.children = node.children.filter(function(c) {
        if (sortMode === 'date' && c.date && nowStr && c.date > nowStr) return false;
        if (c.type === 'dir') {
            pruneAndSort(c, sortMode, nowStr);
            return c.children.length > 0;
        }
        return true;
    });
    node.children.sort(sortMode === 'date' ? byDateDesc : byOrderAsc);
}
// Newest first; dateless entries sink to the bottom, then tie-break by label.
function byDateDesc(a, b) {
    var ad = a.date || '0000-00-00';
    var bd = b.date || '0000-00-00';
    if (ad !== bd) return ad < bd ? 1 : -1;
    return (a.label || '').localeCompare(b.label || '');
}
// Numeric ordering prefix ascending (unprefixed last), then alphabetical.
function byOrderAsc(a, b) {
    var ao = a.order == null ? Infinity : a.order;
    var bo = b.order == null ? Infinity : b.order;
    if (ao !== bo) return ao - bo;
    return (a.label || '').localeCompare(b.label || '');
}
function firstFile(nodes) {
    var _iterator = _createForOfIteratorHelper(nodes), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var n = _step.value;
            if (n.type === 'file') return n;
            var f = firstFile(n.children);
            if (f) return f;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return null;
}
// Prev/next within a single folder: among a node's same-type siblings only, so
// "Next" stops at the last document of a folder rather than rolling into the
// next folder. Returns { prev, next }, either of which may be null.
function siblingNav(node, byPath, root) {
    if (!node) return {
        prev: null,
        next: null
    };
    var parent = node.parentPath && byPath.get(node.parentPath) || root;
    var sibs = parent ? parent.children.filter(function(c) {
        return c.type === node.type;
    }) : [];
    var i = sibs.findIndex(function(c) {
        return c.fullPath === node.fullPath;
    });
    return {
        prev: i > 0 ? sibs[i - 1] : null,
        next: i >= 0 && i < sibs.length - 1 ? sibs[i + 1] : null
    };
}
// The summary document shown when you navigate to a folder LEVEL (e.g. via "Up
// a level"). The exact convention is still TBD — for now we accept the common
// section-index filenames, plus a `foo/foo.md` self-named file. Override the
// candidate list with the `summaryNames` prop. Returns a file node or null.
var DEFAULT_SUMMARY_NAMES = [
    'index',
    'readme',
    'overview',
    'summary'
];
function summaryDocFor(dirNode) {
    var names = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_SUMMARY_NAMES;
    if (!dirNode || !dirNode.children) return null;
    var files = dirNode.children.filter(function(c) {
        return c.type === 'file';
    });
    // Match on the cleaned label so a numeric prefix or "---YYYY-MM-DD" date in
    // the filename (e.g. "Summary---2021-01-19.md") still counts.
    var want = function want(label) {
        return files.find(function(f) {
            return f.label.toLowerCase() === label.toLowerCase();
        });
    };
    var _iterator2 = _createForOfIteratorHelper(names), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var cand = _step2.value;
            var hit = want(cand);
            if (hit) return hit;
        }
    // …or a file self-named after its folder (e.g. blast/blast.md).
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    if (dirNode.label) {
        var self = want(dirNode.label);
        if (self) return self;
    }
    return null;
}
// Directory fullPaths from the root down to (and excluding) the given node.
function ancestorDirs(node, byPath) {
    var dirs = [];
    var p = node && node.parentPath;
    while(p){
        dirs.unshift(p);
        var parent = byPath.get(p);
        p = parent && parent.parentPath;
    }
    return dirs;
}
function dirOf(fullPath) {
    return fullPath.includes('/') ? fullPath.slice(0, fullPath.lastIndexOf('/')) : '';
}
// Resolve a relative href (./a, ../b/c.md) against a repo directory.
function resolveRelative(fromDir, href) {
    var stack = fromDir ? fromDir.split('/') : [];
    href.split('/').forEach(function(seg) {
        if (seg === '' || seg === '.') return;
        if (seg === '..') stack.pop();
        else stack.push(seg);
    });
    return stack.join('/');
}
function fetchTree(_x, _x2, _x3) {
    return _fetchTree.apply(this, arguments);
} // Raw-content URL for a repo file path (each segment encoded for spaces etc.).
function _fetchTree() {
    _fetchTree = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee5(org, repo, branch) {
        var key, url, res, data, tree;
        return _regenerator().w(function(_context5) {
            while(true)switch(_context5.n){
                case 0:
                    key = "".concat(org, "/").concat(repo, "@").concat(branch);
                    if (!treeCache.has(key)) {
                        _context5.n = 1;
                        break;
                    }
                    return _context5.a(2, treeCache.get(key));
                case 1:
                    url = "https://api.github.com/repos/".concat(org, "/").concat(repo, "/git/trees/").concat(branch, "?recursive=1");
                    _context5.n = 2;
                    return fetch(url);
                case 2:
                    res = _context5.v;
                    if (res.ok) {
                        _context5.n = 3;
                        break;
                    }
                    throw new Error("GitHub ".concat(res.status, " for ").concat(org, "/").concat(repo, "@").concat(branch));
                case 3:
                    _context5.n = 4;
                    return res.json();
                case 4:
                    data = _context5.v;
                    tree = Array.isArray(data.tree) ? data.tree : [];
                    treeCache.set(key, tree);
                    return _context5.a(2, tree);
            }
        }, _callee5);
    }));
    return _fetchTree.apply(this, arguments);
}
function rawUrl(org, repo, branch, fullPath) {
    var p = fullPath.split('/').map(encodeURIComponent).join('/');
    return "https://raw.githubusercontent.com/".concat(org, "/").concat(repo, "/").concat(branch, "/").concat(p);
}
// Renders one Markdown document. Relative images are rewritten to raw GitHub
// URLs (resolved against `imgBase`, the repo `path` root — matching how these
// docs author image links, e.g. `images/x.png` next to the base dir); relative
// links to other docs in the tree navigate in-place.
function DocBody(_ref) {
    var node = _ref.node, body = _ref.body, imgBase = _ref.imgBase, byPath = _ref.byPath, onNavigate = _ref.onNavigate;
    var currentDir = dirOf(node.fullPath);
    var components = (0, _react.useMemo)(function() {
        var Link = function Link(_ref2) {
            var href = _ref2.href, children = _ref2.children, rest = _objectWithoutProperties(_ref2, _excluded);
            var external = href && (/^([a-z]+:)?\/\//i.test(href) || /^(mailto:|tel:)/i.test(href));
            if (!href || external) return /*#__PURE__*/ (0, _reactDefault.default).createElement("a", _extends({
                href: href,
                target: "_blank",
                rel: "noopener noreferrer"
            }, rest), children);
            if (href.startsWith('#')) return /*#__PURE__*/ (0, _reactDefault.default).createElement("a", _extends({
                href: href
            }, rest), children);
            var _href$split = href.split('#'), _href$split2 = _slicedToArray(_href$split, 2), pathPart = _href$split2[0], hash = _href$split2[1];
            var resolved = resolveRelative(currentDir, pathPart);
            var target = byPath.get(resolved) || (isMarkdown(resolved) ? null : byPath.get(resolved + '.md'));
            if (target && target.type === 'file') return /*#__PURE__*/ (0, _reactDefault.default).createElement("a", _extends({
                href: "?doc=".concat(encodeURIComponent(target.fullPath)).concat(hash ? '#' + hash : ''),
                onClick: function onClick(e) {
                    e.preventDefault();
                    onNavigate(target.fullPath);
                }
            }, rest), children);
            return /*#__PURE__*/ (0, _reactDefault.default).createElement("a", _extends({
                href: href
            }, rest), children);
        };
        return {
            a: Link
        };
    }, [
        currentDir,
        byPath,
        onNavigate
    ]);
    var rendered = (0, _reactRemark.useRemarkSync)(body || '', {
        remarkPlugins: [
            (0, _remarkGfmDefault.default),
            [
                (0, _remarkImgLinksDefault.default),
                {
                    absolutePath: imgBase
                }
            ]
        ],
        // GitHub-style heading IDs so in-page TOC anchor links resolve (no need for
        // the `# Heading {#id}` remark-heading-id syntax in the docs).
        rehypePlugins: [
            (0, _rehypeSlugDefault.default)
        ],
        rehypeReactOptions: {
            components: components
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "ghdocs-markdown"
    }, rendered);
}
// One sidebar level. Directories recurse; the active file is highlighted.
// `titles` maps a file's fullPath to its front-matter title (when known).
function TreeNodes(_ref3) {
    var nodes = _ref3.nodes, depth = _ref3.depth, expanded = _ref3.expanded, activePath = _ref3.activePath, onToggle = _ref3.onToggle, onSelect = _ref3.onSelect, titles = _ref3.titles;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", {
        className: "ghdocs-tree",
        role: "group"
    }, nodes.map(function(node) {
        var pad = {
            paddingLeft: "".concat(8 + depth * 14, "px")
        };
        if (node.type === 'dir') {
            var open = expanded.has(node.fullPath);
            return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
                key: node.fullPath
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
                type: "button",
                className: "ghdocs-row ghdocs-dir",
                style: pad,
                "aria-expanded": open,
                onClick: function onClick() {
                    return onToggle(node.fullPath);
                }
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                className: "ghdocs-caret"
            }, open ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _fi.FiChevronDown), null) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _fi.FiChevronRight), null)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _fi.FiFolder), {
                className: "ghdocs-icon"
            }), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                className: "ghdocs-label"
            }, node.label)), open && /*#__PURE__*/ (0, _reactDefault.default).createElement(TreeNodes, {
                nodes: node.children,
                depth: depth + 1,
                expanded: expanded,
                activePath: activePath,
                onToggle: onToggle,
                onSelect: onSelect,
                titles: titles
            }));
        }
        var active = node.fullPath === activePath;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
            key: node.fullPath
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
            type: "button",
            className: "ghdocs-row ghdocs-file".concat(active ? ' is-active' : ''),
            style: pad,
            onClick: function onClick() {
                return onSelect(node.fullPath);
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            className: "ghdocs-caret"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _fi.FiFileText), {
            className: "ghdocs-icon"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            className: "ghdocs-label"
        }, titles && titles[node.fullPath] || node.label)));
    }));
}
var GithubDocs = function GithubDocs(_ref4) {
    var org = _ref4.org, repo = _ref4.repo, _ref4$path = _ref4.path, path = _ref4$path === void 0 ? '' : _ref4$path, _ref4$branch = _ref4.branch, branch = _ref4$branch === void 0 ? 'main' : _ref4$branch, _ref4$heading = _ref4.heading, heading = _ref4$heading === void 0 ? 'Documentation' : _ref4$heading, _ref4$offset = _ref4.offset, offset = _ref4$offset === void 0 ? 0 : _ref4$offset, _ref4$summaryNames = _ref4.summaryNames, summaryNames = _ref4$summaryNames === void 0 ? DEFAULT_SUMMARY_NAMES : _ref4$summaryNames, _ref4$sort = _ref4.sort, sort = _ref4$sort === void 0 ? 'order' : _ref4$sort, date = _ref4.date, _ref4$ifEmpty = _ref4.ifEmpty, ifEmpty = _ref4$ifEmpty === void 0 ? 'No Markdown documents found in this location.' : _ref4$ifEmpty, doc = _ref4.doc;
    var _useState = (0, _react.useState)('loading'), _useState2 = _slicedToArray(_useState, 2), status = _useState2[0], setStatus = _useState2[1]; // loading|ready|empty|error
    var _useState3 = (0, _react.useState)(null), _useState4 = _slicedToArray(_useState3, 2), error = _useState4[0], setError = _useState4[1];
    var _useState5 = (0, _react.useState)({
        roots: [],
        byPath: new Map(),
        root: null
    }), _useState6 = _slicedToArray(_useState5, 2), tree = _useState6[0], setTree = _useState6[1];
    var _useState7 = (0, _react.useState)(null), _useState8 = _slicedToArray(_useState7, 2), selectedPath = _useState8[0], setSelectedPath = _useState8[1];
    var _useState9 = (0, _react.useState)(function() {
        return new Set();
    }), _useState0 = _slicedToArray(_useState9, 2), expanded = _useState0[0], setExpanded = _useState0[1];
    var _useState1 = (0, _react.useState)(null), _useState10 = _slicedToArray(_useState1, 2), content = _useState10[0], setContent = _useState10[1]; // { title, body } for selectedPath
    var _useState11 = (0, _react.useState)({}), _useState12 = _slicedToArray(_useState11, 2), docTitles = _useState12[0], setDocTitles = _useState12[1]; // fullPath -> front-matter title
    var _useState13 = (0, _react.useState)(null), _useState14 = _slicedToArray(_useState13, 2), measuredOffset = _useState14[0], setMeasuredOffset = _useState14[1];
    var containerRef = (0, _react.useRef)(null);
    // Size the component to the viewport below the page chrome, measuring the
    // container's real position rather than trusting the offset prop alone.
    (0, _react.useEffect)(function() {
        var measure = function measure() {
            var el = containerRef.current;
            if (!el) return;
            var top = Math.ceil(el.getBoundingClientRect().top + (window.scrollY || 0));
            if (top >= 0) setMeasuredOffset(top);
        };
        measure();
        var raf = requestAnimationFrame(measure);
        window.addEventListener('resize', measure);
        window.addEventListener('load', measure);
        return function() {
            cancelAnimationFrame(raf);
            window.removeEventListener('resize', measure);
            window.removeEventListener('load', measure);
        };
    }, []);
    // Load the repo tree (with a main -> master fallback) and pick an initial doc.
    (0, _react.useEffect)(function() {
        var cancelled = false;
        setStatus('loading');
        setError(null);
        var load = /*#__PURE__*/ function() {
            var _ref5 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
                var flat, nowStr, _t, _t2;
                return _regenerator().w(function(_context) {
                    while(true)switch(_context.p = _context.n){
                        case 0:
                            _context.p = 0;
                            _context.n = 1;
                            return fetchTree(org, repo, branch);
                        case 1:
                            flat = _context.v;
                            _context.n = 8;
                            break;
                        case 2:
                            _context.p = 2;
                            _t = _context.v;
                            if (!(branch === 'main')) {
                                _context.n = 7;
                                break;
                            }
                            _context.p = 3;
                            _context.n = 4;
                            return fetchTree(org, repo, 'master');
                        case 4:
                            flat = _context.v;
                            _context.n = 6;
                            break;
                        case 5:
                            _context.p = 5;
                            _t2 = _context.v;
                            throw _t2;
                        case 6:
                            _context.n = 8;
                            break;
                        case 7:
                            throw _t;
                        case 8:
                            // sort="date" hides entries published after `date` (default: today).
                            nowStr = date || new Date().toISOString().slice(0, 10);
                            return _context.a(2, buildTree(flat, path, sort, nowStr));
                    }
                }, _callee, null, [
                    [
                        3,
                        5
                    ],
                    [
                        0,
                        2
                    ]
                ]);
            }));
            return function load() {
                return _ref5.apply(this, arguments);
            };
        }();
        load().then(function(built) {
            if (cancelled) return;
            setTree(built);
            // A controlled `doc` prop (host-app router) wins over the `?doc=` query.
            var requested = doc || new URLSearchParams(window.location.search).get('doc');
            var start = requested && built.byPath.get(requested) || firstFile(built.roots);
            if (!start) {
                setStatus('empty');
                return;
            }
            setSelectedPath(start.fullPath);
            setExpanded(new Set(ancestorDirs(start, built.byPath)));
            setStatus('ready');
        })["catch"](function(e) {
            if (cancelled) return;
            setError(e.message || String(e));
            setStatus('error');
        });
        return function() {
            cancelled = true;
        };
    }, [
        org,
        repo,
        path,
        branch,
        sort,
        date
    ]);
    // Fetch the Markdown for the current selection (cached by immutable blob
    // sha). A directory selection resolves to its summary document, if any.
    (0, _react.useEffect)(function() {
        if (selectedPath == null) return;
        var selected = tree.byPath.get(selectedPath);
        var node = selected && selected.type === 'dir' ? summaryDocFor(selected, summaryNames) : selected;
        if (!node || node.type !== 'file') {
            setContent(null);
            return;
        }
        var cancelled = false;
        var cached = node.sha && contentCache.get(node.sha);
        if (cached) {
            setContent(cached);
            return;
        }
        setContent(null);
        fetch(rawUrl(org, repo, branch, node.fullPath)).then(function(r) {
            if (!r.ok) throw new Error("raw ".concat(r.status));
            return r.text();
        }).then(function(text) {
            if (cancelled) return;
            var parsed = parseFrontMatter(text);
            if (node.sha) contentCache.set(node.sha, parsed);
            setContent(parsed);
        })["catch"](function() {
            if (!cancelled) setContent({
                title: null,
                body: '*Unable to load this document.*'
            });
        });
        return function() {
            cancelled = true;
        };
    }, [
        selectedPath,
        tree,
        org,
        repo,
        branch,
        summaryNames
    ]);
    // Respond to a controlled `doc` prop (e.g. driven by the host app's router):
    // select that document once the tree is ready, without pushing history — the
    // host owns the URL in that case. The `doc === selectedPath` guard stops the
    // re-run (on selectedPath change) from looping.
    (0, _react.useEffect)(function() {
        if (status !== 'ready' || !doc) return;
        var node = tree.byPath.get(doc);
        if (!node || doc === selectedPath) return;
        setSelectedPath(doc);
        setExpanded(function(prev) {
            var next = new Set(prev);
            ancestorDirs(node, tree.byPath).forEach(function(d) {
                return next.add(d);
            });
            if (node.type === 'dir' && node.fullPath) next.add(node.fullPath);
            return next;
        });
    }, [
        doc,
        status,
        tree,
        selectedPath
    ]);
    // Eagerly read each file's front-matter so the sidebar shows `title:` rather
    // than the filename-derived label (and warms the cache, so selecting a doc is
    // instant). Bounded by the files under `path`; labels upgrade progressively.
    (0, _react.useEffect)(function() {
        if (status !== 'ready') return;
        var cancelled = false;
        var files = [];
        tree.byPath.forEach(function(n) {
            if (n.type === 'file') files.push(n);
        });
        var apply = function apply(fullPath, parsed) {
            if (cancelled || !parsed || !parsed.title) return;
            setDocTitles(function(t) {
                return t[fullPath] === parsed.title ? t : _objectSpread(_objectSpread({}, t), {}, _defineProperty({}, fullPath, parsed.title));
            });
        };
        files.forEach(function(node) {
            var cached = node.sha && contentCache.get(node.sha);
            if (cached) {
                apply(node.fullPath, cached);
                return;
            }
            fetch(rawUrl(org, repo, branch, node.fullPath)).then(function(r) {
                return r.ok ? r.text() : null;
            }).then(function(text) {
                if (text == null) return;
                var parsed = parseFrontMatter(text);
                if (node.sha) contentCache.set(node.sha, parsed);
                apply(node.fullPath, parsed);
            })["catch"](function() {});
        });
        return function() {
            cancelled = true;
        };
    }, [
        status,
        tree,
        org,
        repo,
        branch
    ]);
    var selectDoc = function selectDoc(fullPath) {
        var node = tree.byPath.get(fullPath);
        if (!node) return;
        setSelectedPath(fullPath);
        setExpanded(function(prev) {
            var next = new Set(prev);
            ancestorDirs(node, tree.byPath).forEach(function(d) {
                return next.add(d);
            });
            // Reveal a directory's contents when you land on its level.
            if (node.type === 'dir' && node.fullPath) next.add(node.fullPath);
            return next;
        });
        var url = "".concat(window.location.pathname, "?doc=").concat(encodeURIComponent(fullPath));
        window.history.pushState({}, '', url);
        var body = containerRef.current && containerRef.current.querySelector('.ghdocs-body');
        if (body) body.scrollTo({
            top: 0
        });
    };
    var toggleDir = function toggleDir(fullPath) {
        setExpanded(function(prev) {
            var next = new Set(prev);
            next.has(fullPath) ? next["delete"](fullPath) : next.add(fullPath);
            return next;
        });
    };
    var selectedNode = selectedPath != null ? tree.byPath.get(selectedPath) : null;
    var crumbs = selectedNode ? ancestorDirs(selectedNode, tree.byPath).map(function(p) {
        return tree.byPath.get(p);
    }) : [];
    var rawBase = "https://raw.githubusercontent.com/".concat(org, "/").concat(repo, "/").concat(branch, "/");
    // Relative image paths in the docs are authored against the base `path` root
    // (e.g. `images/x.png` -> `<path>/images/x.png`), not each file's own dir.
    var normBase = path ? path.replace(/^\/+|\/+$/g, '') : '';
    var imgBase = "".concat(rawBase).concat(normBase ? normBase + '/' : '');
    var effectiveOffset = measuredOffset != null ? measuredOffset : offset;
    // Prev/next stay within the current folder; "up a level" goes to the parent
    // folder, whose summary document (or auto overview) is then shown.
    var _siblingNav = siblingNav(selectedNode, tree.byPath, tree.root), prevDoc = _siblingNav.prev, nextDoc = _siblingNav.next;
    var upTarget = selectedNode && selectedNode !== tree.root ? selectedNode.parentPath && tree.byPath.get(selectedNode.parentPath) || tree.root : null;
    var upLabel = upTarget ? upTarget.label || heading : null;
    // The file actually rendered: the selection itself, or a folder's summary doc.
    var resolvedFile = selectedNode && selectedNode.type === 'dir' ? summaryDocFor(selectedNode, summaryNames) : selectedNode;
    var showOverview = selectedNode && selectedNode.type === 'dir' && !resolvedFile;
    // Auto section index shown for a folder level that has no summary document.
    var renderOverview = function renderOverview(dirNode) {
        var dirs = dirNode.children.filter(function(c) {
            return c.type === 'dir';
        });
        var files = dirNode.children.filter(function(c) {
            return c.type === 'file';
        });
        var linkList = function linkList(items) {
            return /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", {
                className: "ghdocs-overview-list"
            }, items.map(function(it) {
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
                    key: it.fullPath
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
                    href: "?doc=".concat(encodeURIComponent(it.fullPath)),
                    onClick: function onClick(e) {
                        e.preventDefault();
                        selectDoc(it.fullPath);
                    }
                }, it.label));
            }));
        };
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: "ghdocs-overview"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", {
            className: "ghdocs-note"
        }, "No summary document is defined for this section yet. It contains:"), dirs.length > 0 && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("h3", null, "Sections"), linkList(dirs)), files.length > 0 && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("h3", null, "Documents"), linkList(files)));
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: containerRef,
        className: "ghdocs",
        style: {
            height: "calc(100vh - ".concat(effectiveOffset, "px)")
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("aside", {
        className: "ghdocs-sidebar"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "ghdocs-sidebar-head"
    }, heading), status === 'loading' && /*#__PURE__*/ (0, _reactDefault.default).createElement("p", {
        className: "ghdocs-note"
    }, "Loading\u2026"), status === 'error' && /*#__PURE__*/ (0, _reactDefault.default).createElement("p", {
        className: "ghdocs-note ghdocs-error"
    }, "Couldn\u2019t load documents."), (status === 'ready' || status === 'empty') && /*#__PURE__*/ (0, _reactDefault.default).createElement(TreeNodes, {
        nodes: tree.roots,
        depth: 0,
        expanded: expanded,
        activePath: selectedPath,
        onToggle: toggleDir,
        onSelect: selectDoc,
        titles: docTitles
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("section", {
        className: "ghdocs-body"
    }, status === 'error' && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "ghdocs-message"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("h3", null, "Unable to load documentation"), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, org, "/", repo, " (", branch, ") could not be read from GitHub."), error && /*#__PURE__*/ (0, _reactDefault.default).createElement("pre", {
        className: "ghdocs-error"
    }, error)), status === 'empty' && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "ghdocs-message"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, ifEmpty)), status === 'ready' && selectedNode && /*#__PURE__*/ (0, _reactDefault.default).createElement("article", {
        className: "ghdocs-article"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("nav", {
        className: "ghdocs-crumbs",
        "aria-label": "Breadcrumb"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        type: "button",
        className: "ghdocs-crumb",
        onClick: function onClick() {
            return selectDoc('');
        }
    }, heading), crumbs.map(function(d) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            key: d.fullPath,
            className: "ghdocs-crumb-wrap"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            className: "ghdocs-crumb-sep"
        }, "/"), /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
            type: "button",
            className: "ghdocs-crumb",
            onClick: function onClick() {
                return selectDoc(d.fullPath);
            }
        }, d.label));
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("h1", {
        className: "ghdocs-title"
    }, content && content.title || selectedNode.label || heading), resolvedFile ? content ? /*#__PURE__*/ (0, _reactDefault.default).createElement(DocBody, {
        node: resolvedFile,
        body: content.body,
        imgBase: imgBase,
        byPath: tree.byPath,
        onNavigate: selectDoc
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement("p", {
        className: "ghdocs-note"
    }, "Loading document\u2026") : showOverview ? renderOverview(selectedNode) : null, (prevDoc || upTarget || nextDoc) && /*#__PURE__*/ (0, _reactDefault.default).createElement("nav", {
        className: "ghdocs-pager",
        "aria-label": "Document navigation"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "ghdocs-pager-slot left"
    }, prevDoc && /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        type: "button",
        className: "ghdocs-pager-link prev",
        onClick: function onClick() {
            return selectDoc(prevDoc.fullPath);
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "ghdocs-pager-dir"
    }, "\u2039 Previous"), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "ghdocs-pager-title"
    }, prevDoc.label))), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "ghdocs-pager-slot center"
    }, upTarget && /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        type: "button",
        className: "ghdocs-pager-link up",
        onClick: function onClick() {
            return selectDoc(upTarget.fullPath);
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "ghdocs-pager-dir"
    }, "\u2191 Up a level"), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "ghdocs-pager-title"
    }, upLabel))), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "ghdocs-pager-slot right"
    }, nextDoc && /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        type: "button",
        className: "ghdocs-pager-link next",
        onClick: function onClick() {
            return selectDoc(nextDoc.fullPath);
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "ghdocs-pager-dir"
    }, "Next \u203A"), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "ghdocs-pager-title"
    }, nextDoc.label)))))));
};
// ---------------------------------------------------------------------------
// GithubDoc — render a SINGLE Markdown file from a GitHub repo, with no
// navigation, sidebar, or pager. Fetches one `.md` file's raw content, strips
// front-matter, and renders it through the same Markdown pipeline as
// GithubDocs (GFM, GitHub-style heading IDs, relative-image rewriting). Use it
// to embed one document — a project overview, an announcement — inside another
// page.
//
// Relative image paths resolve against the file's own directory. Relative
// links to other repo files resolve to their GitHub blob page (there is no
// document tree to navigate in-place). External/anchor links behave as usual.
//
// Props:
//   org        GitHub owner/org                  (required)
//   repo       repository name                   (required)
//   path       path to the .md file in the repo  (required, e.g.
//              'Start here/01-Overview.md')
//   branch     branch/ref                        (default 'main', falls back
//              to 'master')
//   showTitle  render the front-matter `title:` as a heading above the body
//              (default false — most docs carry their own `# H1`)
//   className  extra class name on the wrapper
// ---------------------------------------------------------------------------
// One-file content cache (keyed by raw URL); survives remounts within a page.
var singleDocCache = new Map(); // rawUrl -> { title, body }
// Renders one standalone Markdown document. Images resolve against the file's
// directory; relative doc links point at the file's GitHub blob page.
function SingleDocBody(_ref6) {
    var org = _ref6.org, repo = _ref6.repo, branch = _ref6.branch, path = _ref6.path, body = _ref6.body;
    var fileDir = dirOf(path);
    var rawBase = "https://raw.githubusercontent.com/".concat(org, "/").concat(repo, "/").concat(branch, "/");
    var imgBase = "".concat(rawBase).concat(fileDir ? fileDir + '/' : '');
    var components = (0, _react.useMemo)(function() {
        var Link = function Link(_ref7) {
            var href = _ref7.href, children = _ref7.children, rest = _objectWithoutProperties(_ref7, _excluded2);
            var external = href && (/^([a-z]+:)?\/\//i.test(href) || /^(mailto:|tel:)/i.test(href));
            if (!href || external) return /*#__PURE__*/ (0, _reactDefault.default).createElement("a", _extends({
                href: href,
                target: "_blank",
                rel: "noopener noreferrer"
            }, rest), children);
            // In-page anchors, and site-absolute links ("/api", "/workflows") that
            // the docs use for host-site routes — leave both as-is.
            if (href.startsWith('#') || href.startsWith('/')) return /*#__PURE__*/ (0, _reactDefault.default).createElement("a", _extends({
                href: href
            }, rest), children);
            // A genuinely relative link to another repo file: open its GitHub blob
            // page, since this standalone view has no document tree to navigate.
            var _href$split3 = href.split('#'), _href$split4 = _slicedToArray(_href$split3, 2), pathPart = _href$split4[0], hash = _href$split4[1];
            var resolved = resolveRelative(fileDir, pathPart);
            var enc = resolved.split('/').map(encodeURIComponent).join('/');
            var url = "https://github.com/".concat(org, "/").concat(repo, "/blob/").concat(branch, "/").concat(enc).concat(hash ? '#' + hash : '');
            return /*#__PURE__*/ (0, _reactDefault.default).createElement("a", _extends({
                href: url,
                target: "_blank",
                rel: "noopener noreferrer"
            }, rest), children);
        };
        return {
            a: Link
        };
    }, [
        org,
        repo,
        branch,
        fileDir
    ]);
    var rendered = (0, _reactRemark.useRemarkSync)(body || '', {
        remarkPlugins: [
            (0, _remarkGfmDefault.default),
            [
                (0, _remarkImgLinksDefault.default),
                {
                    absolutePath: imgBase
                }
            ]
        ],
        rehypePlugins: [
            (0, _rehypeSlugDefault.default)
        ],
        rehypeReactOptions: {
            components: components
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "ghdocs-markdown"
    }, rendered);
}
var GithubDoc = function GithubDoc(_ref8) {
    var org = _ref8.org, repo = _ref8.repo, path = _ref8.path, _ref8$branch = _ref8.branch, branch = _ref8$branch === void 0 ? 'main' : _ref8$branch, _ref8$showTitle = _ref8.showTitle, showTitle = _ref8$showTitle === void 0 ? false : _ref8$showTitle, _ref8$toc = _ref8.toc, toc = _ref8$toc === void 0 ? false : _ref8$toc, _ref8$tocLevels = _ref8.tocLevels, tocLevels = _ref8$tocLevels === void 0 ? [
        2,
        3
    ] : _ref8$tocLevels, _ref8$tocHeading = _ref8.tocHeading, tocHeading = _ref8$tocHeading === void 0 ? 'On this page' : _ref8$tocHeading, _ref8$renderTitle = _ref8.renderTitle, renderTitle = _ref8$renderTitle === void 0 ? function(t) {
        return t;
    } : _ref8$renderTitle, _ref8$offset = _ref8.offset, offset = _ref8$offset === void 0 ? 0 : _ref8$offset, _ref8$className = _ref8.className, className = _ref8$className === void 0 ? '' : _ref8$className;
    var _useState15 = (0, _react.useState)('loading'), _useState16 = _slicedToArray(_useState15, 2), status = _useState16[0], setStatus = _useState16[1]; // loading|ready|error
    // { title, body, branch } — branch is the ref the file was actually read
    // from, so the main->master fallback feeds correct image/link URLs.
    var _useState17 = (0, _react.useState)(null), _useState18 = _slicedToArray(_useState17, 2), doc = _useState18[0], setDoc = _useState18[1];
    var _useState19 = (0, _react.useState)([]), _useState20 = _slicedToArray(_useState19, 2), headings = _useState20[0], setHeadings = _useState20[1]; // [{ id, text, level }]
    var _useState21 = (0, _react.useState)(null), _useState22 = _slicedToArray(_useState21, 2), activeId = _useState22[0], setActiveId = _useState22[1];
    var articleRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(function() {
        var cancelled = false;
        setStatus('loading');
        setDoc(null);
        var fetchFrom = /*#__PURE__*/ function() {
            var _ref9 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2(br) {
                var url, cached, res, parsed, _t3;
                return _regenerator().w(function(_context2) {
                    while(true)switch(_context2.n){
                        case 0:
                            url = rawUrl(org, repo, br, path);
                            cached = singleDocCache.get(url);
                            if (!cached) {
                                _context2.n = 1;
                                break;
                            }
                            return _context2.a(2, _objectSpread(_objectSpread({}, cached), {}, {
                                branch: br
                            }));
                        case 1:
                            _context2.n = 2;
                            return fetch(url);
                        case 2:
                            res = _context2.v;
                            if (res.ok) {
                                _context2.n = 3;
                                break;
                            }
                            throw new Error("raw ".concat(res.status));
                        case 3:
                            _t3 = parseFrontMatter;
                            _context2.n = 4;
                            return res.text();
                        case 4:
                            parsed = _t3(_context2.v);
                            singleDocCache.set(url, parsed);
                            return _context2.a(2, _objectSpread(_objectSpread({}, parsed), {}, {
                                branch: br
                            }));
                    }
                }, _callee2);
            }));
            return function fetchFrom(_x4) {
                return _ref9.apply(this, arguments);
            };
        }();
        var load = /*#__PURE__*/ function() {
            var _ref0 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3() {
                var _t4;
                return _regenerator().w(function(_context3) {
                    while(true)switch(_context3.p = _context3.n){
                        case 0:
                            _context3.p = 0;
                            _context3.n = 1;
                            return fetchFrom(branch);
                        case 1:
                            return _context3.a(2, _context3.v);
                        case 2:
                            _context3.p = 2;
                            _t4 = _context3.v;
                            if (!(branch === 'main')) {
                                _context3.n = 4;
                                break;
                            }
                            _context3.n = 3;
                            return fetchFrom('master');
                        case 3:
                            return _context3.a(2, _context3.v);
                        case 4:
                            throw _t4;
                        case 5:
                            return _context3.a(2);
                    }
                }, _callee3, null, [
                    [
                        0,
                        2
                    ]
                ]);
            }));
            return function load() {
                return _ref0.apply(this, arguments);
            };
        }();
        load().then(function(result) {
            if (cancelled) return;
            setDoc(result);
            setStatus('ready');
        })["catch"](function() {
            if (!cancelled) setStatus('error');
        });
        return function() {
            cancelled = true;
        };
    }, [
        org,
        repo,
        path,
        branch
    ]);
    // Build the table of contents from the rendered headings (their ids come
    // from rehype-slug, so #id anchors resolve). Re-runs whenever the document
    // changes — driving in-document section navigation.
    var tocSel = (toc ? tocLevels : []).map(function(l) {
        return "h".concat(l);
    }).join(',');
    (0, _react.useEffect)(function() {
        if (!toc || status !== 'ready' || !doc) {
            setHeadings([]);
            return;
        }
        var el = articleRef.current;
        if (!el) return;
        var hs = _toConsumableArray(el.querySelectorAll(tocSel)).filter(function(h) {
            return h.id;
        }).map(function(h) {
            return {
                id: h.id,
                text: h.textContent,
                level: Number(h.tagName[1])
            };
        });
        setHeadings(hs);
        setActiveId(hs.length ? hs[0].id : null);
    }, [
        toc,
        status,
        doc,
        tocSel
    ]);
    // Scroll-spy: highlight the section currently being read — the last heading
    // scrolled into the upper part of the viewport. The activation line sits a
    // third of the way down (not hard against `offset`) so intermediate sections
    // still light up on short pages where a heading never reaches the very top;
    // a bottom-of-page guard keeps the final (often short) section selectable.
    (0, _react.useEffect)(function() {
        if (!toc || headings.length === 0) return;
        var onScroll = function onScroll() {
            var line = offset + Math.max(0, window.innerHeight - offset) * 0.3;
            var active = headings[0].id;
            var _iterator3 = _createForOfIteratorHelper(headings), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var h = _step3.value;
                    var node = document.getElementById(h.id);
                    if (node && node.getBoundingClientRect().top <= line) active = h.id;
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
            var atBottom = window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 4;
            if (atBottom) active = headings[headings.length - 1].id;
            setActiveId(active);
        };
        onScroll();
        window.addEventListener('scroll', onScroll, {
            passive: true
        });
        return function() {
            return window.removeEventListener('scroll', onScroll);
        };
    }, [
        toc,
        headings,
        offset
    ]);
    // Fail quiet: an embedded document should never break its host page.
    if (status === 'error') return null;
    var goTo = function goTo(id) {
        return function(e) {
            e.preventDefault();
            var node = document.getElementById(id);
            if (!node) return;
            setActiveId(id);
            node.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
            if (window.history && window.history.replaceState) window.history.replaceState(null, '', "#".concat(id));
        };
    };
    // `doc` must be in the guard: while switching documents the fetch effect sets
    // doc=null a render before the stale `headings` are cleared, and the TOC head
    // reads doc.title — without this that intermediate render would throw.
    var showToc = toc && doc && headings.length > 0;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "ghdocs ghdocs-single".concat(showToc ? ' ghdocs-has-toc' : '').concat(className ? ' ' + className : ''),
        style: {
            '--ghd-scroll-offset': "".concat(offset, "px")
        }
    }, showToc && /*#__PURE__*/ (0, _reactDefault.default).createElement("aside", {
        className: "ghdocs-sidebar ghdocs-toc",
        style: {
            top: offset,
            maxHeight: "calc(100vh - ".concat(offset, "px)")
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "ghdocs-sidebar-head"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
        href: "#",
        className: "ghdocs-toc-title",
        onClick: function onClick(e) {
            e.preventDefault();
            setActiveId(null);
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            if (window.history && window.history.replaceState) window.history.replaceState(null, '', window.location.pathname + window.location.search);
        }
    }, doc.title ? renderTitle(doc.title) : tocHeading)), /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", {
        className: "ghdocs-toc-list"
    }, headings.map(function(h) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
            key: h.id
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
            href: "#".concat(h.id),
            className: "ghdocs-toc-link ghdocs-toc-l".concat(h.level).concat(activeId === h.id ? ' is-active' : ''),
            onClick: goTo(h.id)
        }, h.text));
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement("section", {
        className: "ghdocs-body"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("article", {
        className: "ghdocs-article",
        ref: articleRef
    }, status === 'loading' && /*#__PURE__*/ (0, _reactDefault.default).createElement("p", {
        className: "ghdocs-note"
    }, "Loading\u2026"), status === 'ready' && doc && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, showTitle && doc.title && /*#__PURE__*/ (0, _reactDefault.default).createElement("h1", {
        className: "ghdocs-title"
    }, renderTitle(doc.title)), /*#__PURE__*/ (0, _reactDefault.default).createElement(SingleDocBody, {
        org: org,
        repo: repo,
        branch: doc.branch,
        path: path,
        body: doc.body
    })))));
};
// ---------------------------------------------------------------------------
// useGithubDocList — list the top-level Markdown documents under `path` in a
// repo, for building custom navigation (e.g. an inline menu of section pages)
// outside the GithubDocs sidebar. Returns an array of
//   { fullPath, label, title }
// ordered the same way GithubDocs orders a folder level (by `sort`). `title` is
// the front-matter `title:` (fetched lazily; entries start with title: null and
// upgrade in place), falling back to the filename-derived `label`. Link each
// entry to a GithubDocs route with `?doc=<encodeURIComponent(fullPath)>` (and
// feed that back via the `doc` prop). Shares GithubDocs' tree/content caches.
// ---------------------------------------------------------------------------
function useGithubDocList(_ref1) {
    var org = _ref1.org, repo = _ref1.repo, _ref1$path = _ref1.path, path = _ref1$path === void 0 ? '' : _ref1$path, _ref1$branch = _ref1.branch, branch = _ref1$branch === void 0 ? 'main' : _ref1$branch, _ref1$sort = _ref1.sort, sort = _ref1$sort === void 0 ? 'order' : _ref1$sort, date = _ref1.date;
    var _useState23 = (0, _react.useState)([]), _useState24 = _slicedToArray(_useState23, 2), docs = _useState24[0], setDocs = _useState24[1];
    (0, _react.useEffect)(function() {
        var cancelled = false;
        var load = /*#__PURE__*/ function() {
            var _ref10 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee4() {
                var flat, effBranch, nowStr, built, _t5;
                return _regenerator().w(function(_context4) {
                    while(true)switch(_context4.p = _context4.n){
                        case 0:
                            effBranch = branch;
                            _context4.p = 1;
                            _context4.n = 2;
                            return fetchTree(org, repo, branch);
                        case 2:
                            flat = _context4.v;
                            _context4.n = 6;
                            break;
                        case 3:
                            _context4.p = 3;
                            _t5 = _context4.v;
                            if (!(branch === 'main')) {
                                _context4.n = 5;
                                break;
                            }
                            _context4.n = 4;
                            return fetchTree(org, repo, 'master');
                        case 4:
                            flat = _context4.v;
                            effBranch = 'master';
                            _context4.n = 6;
                            break;
                        case 5:
                            throw _t5;
                        case 6:
                            nowStr = date || new Date().toISOString().slice(0, 10);
                            built = buildTree(flat, path, sort, nowStr);
                            return _context4.a(2, {
                                files: built.roots.filter(function(n) {
                                    return n.type === 'file';
                                }),
                                effBranch: effBranch
                            });
                    }
                }, _callee4, null, [
                    [
                        1,
                        3
                    ]
                ]);
            }));
            return function load() {
                return _ref10.apply(this, arguments);
            };
        }();
        load().then(function(_ref11) {
            var files = _ref11.files, effBranch = _ref11.effBranch;
            if (cancelled) return;
            setDocs(files.map(function(f) {
                return {
                    fullPath: f.fullPath,
                    label: f.label,
                    title: null
                };
            }));
            // Upgrade each label to its front-matter title when present.
            files.forEach(function(f) {
                var applyTitle = function applyTitle(parsed) {
                    if (cancelled || !parsed || !parsed.title) return;
                    setDocs(function(prev) {
                        return prev.map(function(d) {
                            return d.fullPath === f.fullPath ? _objectSpread(_objectSpread({}, d), {}, {
                                title: parsed.title
                            }) : d;
                        });
                    });
                };
                var cached = f.sha && contentCache.get(f.sha);
                if (cached) {
                    applyTitle(cached);
                    return;
                }
                fetch(rawUrl(org, repo, effBranch, f.fullPath)).then(function(r) {
                    return r.ok ? r.text() : null;
                }).then(function(text) {
                    if (text == null) return;
                    var parsed = parseFrontMatter(text);
                    if (f.sha) contentCache.set(f.sha, parsed);
                    applyTitle(parsed);
                })["catch"](function() {});
            });
        })["catch"](function() {
            if (!cancelled) setDocs([]);
        });
        return function() {
            cancelled = true;
        };
    }, [
        org,
        repo,
        path,
        branch,
        sort,
        date
    ]);
    return docs;
}
exports.default = GithubDocs;

},{"react":"bmhQu","react-remark":"enkIp","remark-gfm":"3O2Eh","@pondorasti/remark-img-links":"cjsL2","rehype-slug":"cWp1O","react-icons/fi":"1HOcO","../css/githubDocs.css":"iS1wj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"enkIp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Remark", ()=>Remark);
parcelHelpers.export(exports, "useRemark", ()=>useRemark);
parcelHelpers.export(exports, "useRemarkSync", ()=>useRemarkSync);
var _react = require("react");
var _unified = require("unified");
var _unifiedDefault = parcelHelpers.interopDefault(_unified);
var _remarkParse = require("remark-parse");
var _remarkParseDefault = parcelHelpers.interopDefault(_remarkParse);
var _remarkRehype = require("remark-rehype");
var _remarkRehypeDefault = parcelHelpers.interopDefault(_remarkRehype);
var _rehypeReact = require("rehype-react");
var _rehypeReactDefault = parcelHelpers.interopDefault(_rehypeReact);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var _excluded = [
    "children"
];
var useRemarkSync = function useRemarkSync(source, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, remarkParseOptions = _ref.remarkParseOptions, remarkToRehypeOptions = _ref.remarkToRehypeOptions, rehypeReactOptions = _ref.rehypeReactOptions, _ref$remarkPlugins = _ref.remarkPlugins, remarkPlugins = _ref$remarkPlugins === void 0 ? [] : _ref$remarkPlugins, _ref$rehypePlugins = _ref.rehypePlugins, rehypePlugins = _ref$rehypePlugins === void 0 ? [] : _ref$rehypePlugins;
    return (0, _unifiedDefault.default)().use((0, _remarkParseDefault.default), remarkParseOptions).use(remarkPlugins).use((0, _remarkRehypeDefault.default), remarkToRehypeOptions).use(rehypePlugins).use((0, _rehypeReactDefault.default), _extends({
        createElement: (0, _react.createElement),
        Fragment: (0, _react.Fragment)
    }, rehypeReactOptions)).processSync(source).result;
};
var useRemark = function useRemark(_temp2) {
    var _ref2 = _temp2 === void 0 ? {} : _temp2, remarkParseOptions = _ref2.remarkParseOptions, remarkToRehypeOptions = _ref2.remarkToRehypeOptions, rehypeReactOptions = _ref2.rehypeReactOptions, _ref2$remarkPlugins = _ref2.remarkPlugins, remarkPlugins = _ref2$remarkPlugins === void 0 ? [] : _ref2$remarkPlugins, _ref2$rehypePlugins = _ref2.rehypePlugins, rehypePlugins = _ref2$rehypePlugins === void 0 ? [] : _ref2$rehypePlugins, _ref2$onError = _ref2.onError, onError = _ref2$onError === void 0 ? function() {} : _ref2$onError;
    var _useState = (0, _react.useState)(null), reactContent = _useState[0], setReactContent = _useState[1];
    var setMarkdownSource = (0, _react.useCallback)(function(source) {
        (0, _unifiedDefault.default)().use((0, _remarkParseDefault.default), remarkParseOptions).use(remarkPlugins).use((0, _remarkRehypeDefault.default), remarkToRehypeOptions).use(rehypePlugins).use((0, _rehypeReactDefault.default), _extends({
            createElement: (0, _react.createElement),
            Fragment: (0, _react.Fragment)
        }, rehypeReactOptions)).process(source).then(function(vfile) {
            return setReactContent(vfile.result);
        })["catch"](onError);
    }, []);
    return [
        reactContent,
        setMarkdownSource
    ];
};
var Remark = function Remark(_ref3) {
    var children = _ref3.children, useRemarkOptions = _objectWithoutPropertiesLoose(_ref3, _excluded);
    var _useRemark = useRemark(useRemarkOptions), reactContent = _useRemark[0], setMarkdownSource = _useRemark[1];
    (0, _react.useEffect)(function() {
        setMarkdownSource(children);
    }, [
        children,
        setMarkdownSource
    ]);
    return reactContent;
};

},{"react":"bmhQu","unified":"7HP9Z","remark-parse":"cWDih","remark-rehype":"1wQDS","rehype-react":"jyLbt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7HP9Z":[function(require,module,exports,__globalThis) {
'use strict';
var bail = require("37f5c81790b92058");
var buffer = require("c8c87aae30d51588");
var extend = require("d8efe17a2a0e8fbe");
var plain = require("7d51dc61dfcf82b4");
var trough = require("a4192a31b3aec9d1");
var vfile = require("2b69af4bee67af62");
// Expose a frozen processor.
module.exports = unified().freeze();
var slice = [].slice;
var own = {}.hasOwnProperty;
// Process pipeline.
var pipeline = trough().use(pipelineParse).use(pipelineRun).use(pipelineStringify);
function pipelineParse(p, ctx) {
    ctx.tree = p.parse(ctx.file);
}
function pipelineRun(p, ctx, next) {
    p.run(ctx.tree, ctx.file, done);
    function done(error, tree, file) {
        if (error) next(error);
        else {
            ctx.tree = tree;
            ctx.file = file;
            next();
        }
    }
}
function pipelineStringify(p, ctx) {
    var result = p.stringify(ctx.tree, ctx.file);
    if (result === undefined || result === null) ;
    else if (typeof result === 'string' || buffer(result)) {
        if ('value' in ctx.file) ctx.file.value = result;
        ctx.file.contents = result;
    } else ctx.file.result = result;
}
// Function to create the first processor.
function unified() {
    var attachers = [];
    var transformers = trough();
    var namespace = {};
    var freezeIndex = -1;
    var frozen;
    // Data management.
    processor.data = data;
    // Lock.
    processor.freeze = freeze;
    // Plugins.
    processor.attachers = attachers;
    processor.use = use;
    // API.
    processor.parse = parse;
    processor.stringify = stringify;
    processor.run = run;
    processor.runSync = runSync;
    processor.process = process;
    processor.processSync = processSync;
    // Expose.
    return processor;
    // Create a new processor based on the processor in the current scope.
    function processor() {
        var destination = unified();
        var index = -1;
        while(++index < attachers.length)destination.use.apply(null, attachers[index]);
        destination.data(extend(true, {}, namespace));
        return destination;
    }
    // Freeze: used to signal a processor that has finished configuration.
    //
    // For example, take unified itself: it’s frozen.
    // Plugins should not be added to it.
    // Rather, it should be extended, by invoking it, before modifying it.
    //
    // In essence, always invoke this when exporting a processor.
    function freeze() {
        var values;
        var transformer;
        if (frozen) return processor;
        while(++freezeIndex < attachers.length){
            values = attachers[freezeIndex];
            if (values[1] === false) continue;
            if (values[1] === true) values[1] = undefined;
            transformer = values[0].apply(processor, values.slice(1));
            if (typeof transformer === 'function') transformers.use(transformer);
        }
        frozen = true;
        freezeIndex = Infinity;
        return processor;
    }
    // Data management.
    // Getter / setter for processor-specific informtion.
    function data(key, value) {
        if (typeof key === 'string') {
            // Set `key`.
            if (arguments.length === 2) {
                assertUnfrozen('data', frozen);
                namespace[key] = value;
                return processor;
            }
            // Get `key`.
            return own.call(namespace, key) && namespace[key] || null;
        }
        // Set space.
        if (key) {
            assertUnfrozen('data', frozen);
            namespace = key;
            return processor;
        }
        // Get space.
        return namespace;
    }
    // Plugin management.
    //
    // Pass it:
    // *   an attacher and options,
    // *   a preset,
    // *   a list of presets, attachers, and arguments (list of attachers and
    //     options).
    function use(value) {
        var settings;
        assertUnfrozen('use', frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === 'function') addPlugin.apply(null, arguments);
        else if (typeof value === 'object') {
            if ('length' in value) addList(value);
            else addPreset(value);
        } else throw new Error('Expected usable value, not `' + value + '`');
        if (settings) namespace.settings = extend(namespace.settings || {}, settings);
        return processor;
        function addPreset(result) {
            addList(result.plugins);
            if (result.settings) settings = extend(settings || {}, result.settings);
        }
        function add(value) {
            if (typeof value === 'function') addPlugin(value);
            else if (typeof value === 'object') {
                if ('length' in value) addPlugin.apply(null, value);
                else addPreset(value);
            } else throw new Error('Expected usable value, not `' + value + '`');
        }
        function addList(plugins) {
            var index = -1;
            if (plugins === null || plugins === undefined) ;
            else if (typeof plugins === 'object' && 'length' in plugins) while(++index < plugins.length)add(plugins[index]);
            else throw new Error('Expected a list of plugins, not `' + plugins + '`');
        }
        function addPlugin(plugin, value) {
            var entry = find(plugin);
            if (entry) {
                if (plain(entry[1]) && plain(value)) value = extend(true, entry[1], value);
                entry[1] = value;
            } else attachers.push(slice.call(arguments));
        }
    }
    function find(plugin) {
        var index = -1;
        while(++index < attachers.length){
            if (attachers[index][0] === plugin) return attachers[index];
        }
    }
    // Parse a file (in string or vfile representation) into a unist node using
    // the `Parser` on the processor.
    function parse(doc) {
        var file = vfile(doc);
        var Parser;
        freeze();
        Parser = processor.Parser;
        assertParser('parse', Parser);
        if (newable(Parser, 'parse')) return new Parser(String(file), file).parse();
        return Parser(String(file), file) // eslint-disable-line new-cap
        ;
    }
    // Run transforms on a unist node representation of a file (in string or
    // vfile representation), async.
    function run(node, file, cb) {
        assertNode(node);
        freeze();
        if (!cb && typeof file === 'function') {
            cb = file;
            file = null;
        }
        if (!cb) return new Promise(executor);
        executor(null, cb);
        function executor(resolve, reject) {
            transformers.run(node, vfile(file), done);
            function done(error, tree, file) {
                tree = tree || node;
                if (error) reject(error);
                else if (resolve) resolve(tree);
                else cb(null, tree, file);
            }
        }
    }
    // Run transforms on a unist node representation of a file (in string or
    // vfile representation), sync.
    function runSync(node, file) {
        var result;
        var complete;
        run(node, file, done);
        assertDone('runSync', 'run', complete);
        return result;
        function done(error, tree) {
            complete = true;
            result = tree;
            bail(error);
        }
    }
    // Stringify a unist node representation of a file (in string or vfile
    // representation) into a string using the `Compiler` on the processor.
    function stringify(node, doc) {
        var file = vfile(doc);
        var Compiler;
        freeze();
        Compiler = processor.Compiler;
        assertCompiler('stringify', Compiler);
        assertNode(node);
        if (newable(Compiler, 'compile')) return new Compiler(node, file).compile();
        return Compiler(node, file) // eslint-disable-line new-cap
        ;
    }
    // Parse a file (in string or vfile representation) into a unist node using
    // the `Parser` on the processor, then run transforms on that node, and
    // compile the resulting node using the `Compiler` on the processor, and
    // store that result on the vfile.
    function process(doc, cb) {
        freeze();
        assertParser('process', processor.Parser);
        assertCompiler('process', processor.Compiler);
        if (!cb) return new Promise(executor);
        executor(null, cb);
        function executor(resolve, reject) {
            var file = vfile(doc);
            pipeline.run(processor, {
                file: file
            }, done);
            function done(error) {
                if (error) reject(error);
                else if (resolve) resolve(file);
                else cb(null, file);
            }
        }
    }
    // Process the given document (in string or vfile representation), sync.
    function processSync(doc) {
        var file;
        var complete;
        freeze();
        assertParser('processSync', processor.Parser);
        assertCompiler('processSync', processor.Compiler);
        file = vfile(doc);
        process(file, done);
        assertDone('processSync', 'process', complete);
        return file;
        function done(error) {
            complete = true;
            bail(error);
        }
    }
}
// Check if `value` is a constructor.
function newable(value, name) {
    return typeof value === 'function' && value.prototype && // A function with keys in its prototype is probably a constructor.
    // Classes’ prototype methods are not enumerable, so we check if some value
    // exists in the prototype.
    (keys(value.prototype) || name in value.prototype);
}
// Check if `value` is an object with keys.
function keys(value) {
    var key;
    for(key in value)return true;
    return false;
}
// Assert a parser is available.
function assertParser(name, Parser) {
    if (typeof Parser !== 'function') throw new Error('Cannot `' + name + '` without `Parser`');
}
// Assert a compiler is available.
function assertCompiler(name, Compiler) {
    if (typeof Compiler !== 'function') throw new Error('Cannot `' + name + '` without `Compiler`');
}
// Assert the processor is not frozen.
function assertUnfrozen(name, frozen) {
    if (frozen) throw new Error('Cannot invoke `' + name + '` on a frozen processor.\nCreate a new processor first, by invoking it: use `processor()` instead of `processor`.');
}
// Assert `node` is a unist node.
function assertNode(node) {
    if (!node || typeof node.type !== 'string') throw new Error('Expected node, got `' + node + '`');
}
// Assert that `complete` is `true`.
function assertDone(name, asyncName, complete) {
    if (!complete) throw new Error('`' + name + '` finished async. Use `' + asyncName + '` instead');
}

},{"37f5c81790b92058":"69eHG","c8c87aae30d51588":"lBKjS","d8efe17a2a0e8fbe":"cAEaH","7d51dc61dfcf82b4":"huM4U","a4192a31b3aec9d1":"c9qLX","2b69af4bee67af62":"bpNXX"}],"69eHG":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = bail;
function bail(err) {
    if (err) throw err;
}

},{}],"lBKjS":[function(require,module,exports,__globalThis) {
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ module.exports = function isBuffer(obj) {
    return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
};

},{}],"cAEaH":[function(require,module,exports,__globalThis) {
'use strict';
var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;
var isArray = function isArray(arr) {
    if (typeof Array.isArray === 'function') return Array.isArray(arr);
    return toStr.call(arr) === '[object Array]';
};
var isPlainObject = function isPlainObject(obj) {
    if (!obj || toStr.call(obj) !== '[object Object]') return false;
    var hasOwnConstructor = hasOwn.call(obj, 'constructor');
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === 'undefined' || hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
    if (defineProperty && options.name === '__proto__') defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty = function getProperty(obj, name) {
    if (name === '__proto__') {
        if (!hasOwn.call(obj, name)) return void 0;
        else if (gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return gOPD(obj, name).value;
    }
    return obj[name];
};
module.exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === 'boolean') {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== 'object' && typeof target !== 'function') target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = getProperty(target, name);
            copy = getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && isArray(src) ? src : [];
                    } else clone = src && isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== 'undefined') setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};

},{}],"huM4U":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = (value)=>{
    if (Object.prototype.toString.call(value) !== '[object Object]') return false;
    const prototype = Object.getPrototypeOf(value);
    return prototype === null || prototype === Object.prototype;
};

},{}],"c9qLX":[function(require,module,exports,__globalThis) {
'use strict';
var wrap = require("737c848fb73f93a1");
module.exports = trough;
trough.wrap = wrap;
var slice = [].slice;
// Create new middleware.
function trough() {
    var fns = [];
    var middleware = {};
    middleware.run = run;
    middleware.use = use;
    return middleware;
    // Run `fns`.  Last argument must be a completion handler.
    function run() {
        var index = -1;
        var input = slice.call(arguments, 0, -1);
        var done = arguments[arguments.length - 1];
        if (typeof done !== 'function') throw new Error('Expected function as last argument, not ' + done);
        next.apply(null, [
            null
        ].concat(input));
        // Run the next `fn`, if any.
        function next(err) {
            var fn = fns[++index];
            var params = slice.call(arguments, 0);
            var values = params.slice(1);
            var length = input.length;
            var pos = -1;
            if (err) {
                done(err);
                return;
            }
            // Copy non-nully input into values.
            while(++pos < length)if (values[pos] === null || values[pos] === undefined) values[pos] = input[pos];
            input = values;
            // Next or done.
            if (fn) wrap(fn, next).apply(null, input);
            else done.apply(null, [
                null
            ].concat(input));
        }
    }
    // Add `fn` to the list.
    function use(fn) {
        if (typeof fn !== 'function') throw new Error('Expected `fn` to be a function, not ' + fn);
        fns.push(fn);
        return middleware;
    }
}

},{"737c848fb73f93a1":"9yeKI"}],"9yeKI":[function(require,module,exports,__globalThis) {
'use strict';
var slice = [].slice;
module.exports = wrap;
// Wrap `fn`.
// Can be sync or async; return a promise, receive a completion handler, return
// new values and errors.
function wrap(fn, callback) {
    var invoked;
    return wrapped;
    function wrapped() {
        var params = slice.call(arguments, 0);
        var callback = fn.length > params.length;
        var result;
        if (callback) params.push(done);
        try {
            result = fn.apply(null, params);
        } catch (error) {
            // Well, this is quite the pickle.
            // `fn` received a callback and invoked it (thus continuing the pipeline),
            // but later also threw an error.
            // We’re not about to restart the pipeline again, so the only thing left
            // to do is to throw the thing instead.
            if (callback && invoked) throw error;
            return done(error);
        }
        if (!callback) {
            if (result && typeof result.then === 'function') result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    // Invoke `next`, only once.
    function done() {
        if (!invoked) {
            invoked = true;
            callback.apply(null, arguments);
        }
    }
    // Invoke `done` with one value.
    // Tracks if an error is passed, too.
    function then(value) {
        done(null, value);
    }
}

},{}],"bpNXX":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("bb6086dc4aabf46e");

},{"bb6086dc4aabf46e":"lcGpa"}],"lcGpa":[function(require,module,exports,__globalThis) {
'use strict';
var VMessage = require("ba47e7225330d2d6");
var VFile = require("1be0d0c98875efa8");
module.exports = VFile;
VFile.prototype.message = message;
VFile.prototype.info = info;
VFile.prototype.fail = fail;
// Create a message with `reason` at `position`.
// When an error is passed in as `reason`, copies the stack.
function message(reason, position, origin) {
    var message = new VMessage(reason, position, origin);
    if (this.path) {
        message.name = this.path + ':' + message.name;
        message.file = this.path;
    }
    message.fatal = false;
    this.messages.push(message);
    return message;
}
// Fail: creates a vmessage, associates it with the file, and throws it.
function fail() {
    var message = this.message.apply(this, arguments);
    message.fatal = true;
    throw message;
}
// Info: creates a vmessage, associates it with the file, and marks the fatality
// as null.
function info() {
    var message = this.message.apply(this, arguments);
    message.fatal = null;
    return message;
}

},{"ba47e7225330d2d6":"xz7y4","1be0d0c98875efa8":"8G7gB"}],"xz7y4":[function(require,module,exports,__globalThis) {
'use strict';
var stringify = require("5d5fcbe1ad759dc");
module.exports = VMessage;
// Inherit from `Error#`.
function VMessagePrototype() {}
VMessagePrototype.prototype = Error.prototype;
VMessage.prototype = new VMessagePrototype();
// Message properties.
var proto = VMessage.prototype;
proto.file = '';
proto.name = '';
proto.reason = '';
proto.message = '';
proto.stack = '';
proto.fatal = null;
proto.column = null;
proto.line = null;
// Construct a new VMessage.
//
// Note: We cannot invoke `Error` on the created context, as that adds readonly
// `line` and `column` attributes on Safari 9, thus throwing and failing the
// data.
function VMessage(reason, position, origin) {
    var parts;
    var range;
    var location;
    if (typeof position === 'string') {
        origin = position;
        position = null;
    }
    parts = parseOrigin(origin);
    range = stringify(position) || '1:1';
    location = {
        start: {
            line: null,
            column: null
        },
        end: {
            line: null,
            column: null
        }
    };
    // Node.
    if (position && position.position) position = position.position;
    if (position) {
        // Position.
        if (position.start) {
            location = position;
            position = position.start;
        } else // Point.
        location.start = position;
    }
    if (reason.stack) {
        this.stack = reason.stack;
        reason = reason.message;
    }
    this.message = reason;
    this.name = range;
    this.reason = reason;
    this.line = position ? position.line : null;
    this.column = position ? position.column : null;
    this.location = location;
    this.source = parts[0];
    this.ruleId = parts[1];
}
function parseOrigin(origin) {
    var result = [
        null,
        null
    ];
    var index;
    if (typeof origin === 'string') {
        index = origin.indexOf(':');
        if (index === -1) result[1] = origin;
        else {
            result[0] = origin.slice(0, index);
            result[1] = origin.slice(index + 1);
        }
    }
    return result;
}

},{"5d5fcbe1ad759dc":"YF175"}],"YF175":[function(require,module,exports,__globalThis) {
'use strict';
var own = {}.hasOwnProperty;
module.exports = stringify;
function stringify(value) {
    // Nothing.
    if (!value || typeof value !== 'object') return '';
    // Node.
    if (own.call(value, 'position') || own.call(value, 'type')) return position(value.position);
    // Position.
    if (own.call(value, 'start') || own.call(value, 'end')) return position(value);
    // Point.
    if (own.call(value, 'line') || own.call(value, 'column')) return point(value);
    // ?
    return '';
}
function point(point) {
    if (!point || typeof point !== 'object') point = {};
    return index(point.line) + ':' + index(point.column);
}
function position(pos) {
    if (!pos || typeof pos !== 'object') pos = {};
    return point(pos.start) + '-' + point(pos.end);
}
function index(value) {
    return value && typeof value === 'number' ? value : 1;
}

},{}],"8G7gB":[function(require,module,exports,__globalThis) {
'use strict';
var p = require("6cfe80e0cef513f5");
var proc = require("d2bfb9d6118b447f");
var buffer = require("5cf18874720597fa");
module.exports = VFile;
var own = {}.hasOwnProperty;
// Order of setting (least specific to most), we need this because otherwise
// `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
// stem can be set.
var order = [
    'history',
    'path',
    'basename',
    'stem',
    'extname',
    'dirname'
];
VFile.prototype.toString = toString;
// Access full path (`~/index.min.js`).
Object.defineProperty(VFile.prototype, 'path', {
    get: getPath,
    set: setPath
});
// Access parent path (`~`).
Object.defineProperty(VFile.prototype, 'dirname', {
    get: getDirname,
    set: setDirname
});
// Access basename (`index.min.js`).
Object.defineProperty(VFile.prototype, 'basename', {
    get: getBasename,
    set: setBasename
});
// Access extname (`.js`).
Object.defineProperty(VFile.prototype, 'extname', {
    get: getExtname,
    set: setExtname
});
// Access stem (`index.min`).
Object.defineProperty(VFile.prototype, 'stem', {
    get: getStem,
    set: setStem
});
// Construct a new file.
function VFile(options) {
    var prop;
    var index;
    if (!options) options = {};
    else if (typeof options === 'string' || buffer(options)) options = {
        contents: options
    };
    else if ('message' in options && 'messages' in options) return options;
    if (!(this instanceof VFile)) return new VFile(options);
    this.data = {};
    this.messages = [];
    this.history = [];
    this.cwd = proc.cwd();
    // Set path related properties in the correct order.
    index = -1;
    while(++index < order.length){
        prop = order[index];
        if (own.call(options, prop)) this[prop] = options[prop];
    }
    // Set non-path related properties.
    for(prop in options)if (order.indexOf(prop) < 0) this[prop] = options[prop];
}
function getPath() {
    return this.history[this.history.length - 1];
}
function setPath(path) {
    assertNonEmpty(path, 'path');
    if (this.path !== path) this.history.push(path);
}
function getDirname() {
    return typeof this.path === 'string' ? p.dirname(this.path) : undefined;
}
function setDirname(dirname) {
    assertPath(this.path, 'dirname');
    this.path = p.join(dirname || '', this.basename);
}
function getBasename() {
    return typeof this.path === 'string' ? p.basename(this.path) : undefined;
}
function setBasename(basename) {
    assertNonEmpty(basename, 'basename');
    assertPart(basename, 'basename');
    this.path = p.join(this.dirname || '', basename);
}
function getExtname() {
    return typeof this.path === 'string' ? p.extname(this.path) : undefined;
}
function setExtname(extname) {
    assertPart(extname, 'extname');
    assertPath(this.path, 'extname');
    if (extname) {
        if (extname.charCodeAt(0) !== 46 /* `.` */ ) throw new Error('`extname` must start with `.`');
        if (extname.indexOf('.', 1) > -1) throw new Error('`extname` cannot contain multiple dots');
    }
    this.path = p.join(this.dirname, this.stem + (extname || ''));
}
function getStem() {
    return typeof this.path === 'string' ? p.basename(this.path, this.extname) : undefined;
}
function setStem(stem) {
    assertNonEmpty(stem, 'stem');
    assertPart(stem, 'stem');
    this.path = p.join(this.dirname || '', stem + (this.extname || ''));
}
// Get the value of the file.
function toString(encoding) {
    return (this.contents || '').toString(encoding);
}
// Assert that `part` is not a path (i.e., does not contain `p.sep`).
function assertPart(part, name) {
    if (part && part.indexOf(p.sep) > -1) throw new Error('`' + name + '` cannot be a path: did not expect `' + p.sep + '`');
}
// Assert that `part` is not empty.
function assertNonEmpty(part, name) {
    if (!part) throw new Error('`' + name + '` cannot be empty');
}
// Assert `path` exists.
function assertPath(path, name) {
    if (!path) throw new Error('Setting `' + name + '` requires `path` to be set too');
}

},{"6cfe80e0cef513f5":"jJG8g","d2bfb9d6118b447f":"5fTLJ","5cf18874720597fa":"lBKjS"}],"jJG8g":[function(require,module,exports,__globalThis) {
'use strict';
// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
exports.basename = basename;
exports.dirname = dirname;
exports.extname = extname;
exports.join = join;
exports.sep = '/';
function basename(path, ext) {
    var start = 0;
    var end = -1;
    var index;
    var firstNonSlashEnd;
    var seenNonSlash;
    var extIndex;
    if (ext !== undefined && typeof ext !== 'string') throw new TypeError('"ext" argument must be a string');
    assertPath(path);
    index = path.length;
    if (ext === undefined || !ext.length || ext.length > path.length) {
        while(index--){
            if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? '' : path.slice(start, end);
    }
    if (ext === path) return '';
    firstNonSlashEnd = -1;
    extIndex = ext.length - 1;
    while(index--){
        if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extIndex > -1) {
                // Try to match the explicit extension.
                if (path.charCodeAt(index) === ext.charCodeAt(extIndex--)) {
                    if (extIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
function dirname(path) {
    var end;
    var unmatchedSlash;
    var index;
    assertPath(path);
    if (!path.length) return '.';
    end = -1;
    index = path.length;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.charCodeAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.charCodeAt(0) === 47 /* `/` */  ? '/' : '.' : end === 1 && path.charCodeAt(0) === 47 /* `/` */  ? '//' : path.slice(0, end);
}
function extname(path) {
    var startDot = -1;
    var startPart = 0;
    var end = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    var preDotState = 0;
    var unmatchedSlash;
    var code;
    var index;
    assertPath(path);
    index = path.length;
    while(index--){
        code = path.charCodeAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return '';
    return path.slice(startDot, end);
}
function join() {
    var index = -1;
    var joined;
    while(++index < arguments.length){
        assertPath(arguments[index]);
        if (arguments[index]) joined = joined === undefined ? arguments[index] : joined + '/' + arguments[index];
    }
    return joined === undefined ? '.' : normalize(joined);
}
// Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function normalize(path) {
    var absolute;
    var value;
    assertPath(path);
    absolute = path.charCodeAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    value = normalizeString(path, !absolute);
    if (!value.length && !absolute) value = '.';
    if (value.length && path.charCodeAt(path.length - 1) === 47 /* / */ ) value += '/';
    return absolute ? '/' + value : value;
}
// Resolve `.` and `..` elements in a path with directory names.
function normalizeString(path, allowAboveRoot) {
    var result = '';
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var index = -1;
    var code;
    var lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.charCodeAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.charCodeAt(result.length - 1) !== 46 /* `.` */  || result.charCodeAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf('/');
                        /* istanbul ignore else - No clue how to cover it. */ if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = '';
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf('/');
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length) {
                        result = '';
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length ? result + '/..' : '..';
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length) result += '/' + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
function assertPath(path) {
    if (typeof path !== 'string') throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
}

},{}],"5fTLJ":[function(require,module,exports,__globalThis) {
'use strict';
// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
exports.cwd = cwd;
function cwd() {
    return '/';
}

},{}],"cWDih":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = parse;
var fromMarkdown = require("a18b9d7127411454");
function parse(options) {
    var self = this;
    this.Parser = parse;
    function parse(doc) {
        return fromMarkdown(doc, Object.assign({}, self.data('settings'), options, {
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: self.data('micromarkExtensions') || [],
            mdastExtensions: self.data('fromMarkdownExtensions') || []
        }));
    }
}

},{"a18b9d7127411454":"dtxt3"}],"dtxt3":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("44f4c8d4cb2eb00f");

},{"44f4c8d4cb2eb00f":"8TiBz"}],"8TiBz":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = fromMarkdown;
// These three are compiled away in the `dist/`
var toString = require("349b623759307e06");
var assign = require("cc58a9fef25bd11e");
var own = require("19d7b2e434a9783d");
var normalizeIdentifier = require("3866f440289aa212");
var safeFromInt = require("6f610ddacbb9bb4");
var parser = require("8d1e9528d78651b0");
var preprocessor = require("7a6bb0ee7f14f311");
var postprocess = require("ade5c7db8b52a74b");
var decode = require("ed1134f9324b51a");
var stringifyPosition = require("690c23628e8fbc66");
function fromMarkdown(value, encoding, options) {
    if (typeof encoding !== 'string') {
        options = encoding;
        encoding = undefined;
    }
    return compiler(options)(postprocess(parser(options).document().write(preprocessor()(value, encoding, true))));
}
// Note this compiler only understand complete buffering, not streaming.
function compiler(options) {
    var settings = options || {};
    var config = configure({
        transforms: [],
        canContainEols: [
            'emphasis',
            'fragment',
            'heading',
            'paragraph',
            'strong'
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    }, settings.mdastExtensions || []);
    var data = {};
    return compile;
    function compile(events) {
        var tree = {
            type: 'root',
            children: []
        };
        var stack = [
            tree
        ];
        var tokenStack = [];
        var listStack = [];
        var index = -1;
        var handler;
        var listStart;
        var context = {
            stack: stack,
            tokenStack: tokenStack,
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            setData: setData,
            getData: getData
        };
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === 'listOrdered' || events[index][1].type === 'listUnordered') {
            if (events[index][0] === 'enter') listStack.push(index);
            else {
                listStart = listStack.pop(index);
                index = prepareList(events, listStart, index);
            }
        }
        index = -1;
        while(++index < events.length){
            handler = config[events[index][0]];
            if (own.call(handler, events[index][1].type)) handler[events[index][1].type].call(assign({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        if (tokenStack.length) throw new Error('Cannot close document, a token (`' + tokenStack[tokenStack.length - 1].type + '`, ' + stringifyPosition({
            start: tokenStack[tokenStack.length - 1].start,
            end: tokenStack[tokenStack.length - 1].end
        }) + ') is still open');
        // Figure out `root` position.
        tree.position = {
            start: point(events.length ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: point(events.length ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    function prepareList(events, start, length) {
        var index = start - 1;
        var containerBalance = -1;
        var listSpread = false;
        var listItem;
        var tailIndex;
        var lineIndex;
        var tailEvent;
        var event;
        var firstBlankLineIndex;
        var atMarker;
        while(++index <= length){
            event = events[index];
            if (event[1].type === 'listUnordered' || event[1].type === 'listOrdered' || event[1].type === 'blockQuote') {
                if (event[0] === 'enter') containerBalance++;
                else containerBalance--;
                atMarker = undefined;
            } else if (event[1].type === 'lineEndingBlank') {
                if (event[0] === 'enter') {
                    if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                    atMarker = undefined;
                }
            } else if (event[1].type === 'linePrefix' || event[1].type === 'listItemValue' || event[1].type === 'listItemMarker' || event[1].type === 'listItemPrefix' || event[1].type === 'listItemPrefixWhitespace') ;
            else atMarker = undefined;
            if (!containerBalance && event[0] === 'enter' && event[1].type === 'listItemPrefix' || containerBalance === -1 && event[0] === 'exit' && (event[1].type === 'listUnordered' || event[1].type === 'listOrdered')) {
                if (listItem) {
                    tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        tailEvent = events[tailIndex];
                        if (tailEvent[1].type === 'lineEnding' || tailEvent[1].type === 'lineEndingBlank') {
                            if (tailEvent[0] === 'exit') continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = 'lineEndingBlank';
                                listSpread = true;
                            }
                            tailEvent[1].type = 'lineEnding';
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === 'linePrefix' || tailEvent[1].type === 'blockQuotePrefix' || tailEvent[1].type === 'blockQuotePrefixWhitespace' || tailEvent[1].type === 'blockQuoteMarker' || tailEvent[1].type === 'listItemIndent') ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = point(lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        'exit',
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === 'listItemPrefix') {
                    listItem = {
                        type: 'listItem',
                        _spread: false,
                        start: point(event[1].start)
                    };
                    events.splice(index, 0, [
                        'enter',
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    function setData(key, value) {
        data[key] = value;
    }
    function getData(key) {
        return data[key];
    }
    function point(d) {
        return {
            line: d.line,
            column: d.column,
            offset: d.offset
        };
    }
    function opener(create, and) {
        return open;
        function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    function buffer() {
        this.stack.push({
            type: 'fragment',
            children: []
        });
    }
    function enter(node, token) {
        this.stack[this.stack.length - 1].children.push(node);
        this.stack.push(node);
        this.tokenStack.push(token);
        node.position = {
            start: point(token.start)
        };
        return node;
    }
    function closer(and) {
        return close;
        function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    function exit(token) {
        var node = this.stack.pop();
        var open = this.tokenStack.pop();
        if (!open) throw new Error('Cannot close `' + token.type + '` (' + stringifyPosition({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open.type !== token.type) throw new Error('Cannot close `' + token.type + '` (' + stringifyPosition({
            start: token.start,
            end: token.end
        }) + '): a different token (`' + open.type + '`, ' + stringifyPosition({
            start: open.start,
            end: open.end
        }) + ') is open');
        node.position.end = point(token.end);
        return node;
    }
    function resume() {
        return toString(this.stack.pop());
    }
    //
    // Handlers.
    //
    function onenterlistordered() {
        setData('expectingFirstListItemValue', true);
    }
    function onenterlistitemvalue(token) {
        if (getData('expectingFirstListItemValue')) {
            this.stack[this.stack.length - 2].start = parseInt(this.sliceSerialize(token), 10);
            setData('expectingFirstListItemValue');
        }
    }
    function onexitcodefencedfenceinfo() {
        var data = this.resume();
        this.stack[this.stack.length - 1].lang = data;
    }
    function onexitcodefencedfencemeta() {
        var data = this.resume();
        this.stack[this.stack.length - 1].meta = data;
    }
    function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (getData('flowCodeInside')) return;
        this.buffer();
        setData('flowCodeInside', true);
    }
    function onexitcodefenced() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, '');
        setData('flowCodeInside');
    }
    function onexitcodeindented() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data;
    }
    function onexitdefinitionlabelstring(token) {
        // Discard label, use the source content instead.
        var label = this.resume();
        this.stack[this.stack.length - 1].label = label;
        this.stack[this.stack.length - 1].identifier = normalizeIdentifier(this.sliceSerialize(token)).toLowerCase();
    }
    function onexitdefinitiontitlestring() {
        var data = this.resume();
        this.stack[this.stack.length - 1].title = data;
    }
    function onexitdefinitiondestinationstring() {
        var data = this.resume();
        this.stack[this.stack.length - 1].url = data;
    }
    function onexitatxheadingsequence(token) {
        if (!this.stack[this.stack.length - 1].depth) this.stack[this.stack.length - 1].depth = this.sliceSerialize(token).length;
    }
    function onexitsetextheadingtext() {
        setData('setextHeadingSlurpLineEnding', true);
    }
    function onexitsetextheadinglinesequence(token) {
        this.stack[this.stack.length - 1].depth = this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2;
    }
    function onexitsetextheading() {
        setData('setextHeadingSlurpLineEnding');
    }
    function onenterdata(token) {
        var siblings = this.stack[this.stack.length - 1].children;
        var tail = siblings[siblings.length - 1];
        if (!tail || tail.type !== 'text') {
            // Add a new text node.
            tail = text();
            tail.position = {
                start: point(token.start)
            };
            this.stack[this.stack.length - 1].children.push(tail);
        }
        this.stack.push(tail);
    }
    function onexitdata(token) {
        var tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = point(token.end);
    }
    function onexitlineending(token) {
        var context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (getData('atHardBreak')) {
            context.children[context.children.length - 1].position.end = point(token.end);
            setData('atHardBreak');
            return;
        }
        if (!getData('setextHeadingSlurpLineEnding') && config.canContainEols.indexOf(context.type) > -1) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    function onexithardbreak() {
        setData('atHardBreak', true);
    }
    function onexithtmlflow() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data;
    }
    function onexithtmltext() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data;
    }
    function onexitcodetext() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data;
    }
    function onexitlink() {
        var context = this.stack[this.stack.length - 1];
        // To do: clean.
        if (getData('inReference')) {
            context.type += 'Reference';
            context.referenceType = getData('referenceType') || 'shortcut';
            delete context.url;
            delete context.title;
        } else {
            delete context.identifier;
            delete context.label;
            delete context.referenceType;
        }
        setData('referenceType');
    }
    function onexitimage() {
        var context = this.stack[this.stack.length - 1];
        // To do: clean.
        if (getData('inReference')) {
            context.type += 'Reference';
            context.referenceType = getData('referenceType') || 'shortcut';
            delete context.url;
            delete context.title;
        } else {
            delete context.identifier;
            delete context.label;
            delete context.referenceType;
        }
        setData('referenceType');
    }
    function onexitlabeltext(token) {
        this.stack[this.stack.length - 2].identifier = normalizeIdentifier(this.sliceSerialize(token)).toLowerCase();
    }
    function onexitlabel() {
        var fragment = this.stack[this.stack.length - 1];
        var value = this.resume();
        this.stack[this.stack.length - 1].label = value;
        // Assume a reference.
        setData('inReference', true);
        if (this.stack[this.stack.length - 1].type === 'link') this.stack[this.stack.length - 1].children = fragment.children;
        else this.stack[this.stack.length - 1].alt = value;
    }
    function onexitresourcedestinationstring() {
        var data = this.resume();
        this.stack[this.stack.length - 1].url = data;
    }
    function onexitresourcetitlestring() {
        var data = this.resume();
        this.stack[this.stack.length - 1].title = data;
    }
    function onexitresource() {
        setData('inReference');
    }
    function onenterreference() {
        setData('referenceType', 'collapsed');
    }
    function onexitreferencestring(token) {
        var label = this.resume();
        this.stack[this.stack.length - 1].label = label;
        this.stack[this.stack.length - 1].identifier = normalizeIdentifier(this.sliceSerialize(token)).toLowerCase();
        setData('referenceType', 'full');
    }
    function onexitcharacterreferencemarker(token) {
        setData('characterReferenceType', token.type);
    }
    function onexitcharacterreferencevalue(token) {
        var data = this.sliceSerialize(token);
        var type = getData('characterReferenceType');
        var value;
        var tail;
        if (type) {
            value = safeFromInt(data, type === 'characterReferenceMarkerNumeric' ? 10 : 16);
            setData('characterReferenceType');
        } else value = decode(data);
        tail = this.stack.pop();
        tail.value += value;
        tail.position.end = point(token.end);
    }
    function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        this.stack[this.stack.length - 1].url = this.sliceSerialize(token);
    }
    function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        this.stack[this.stack.length - 1].url = 'mailto:' + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    function blockQuote() {
        return {
            type: 'blockquote',
            children: []
        };
    }
    function codeFlow() {
        return {
            type: 'code',
            lang: null,
            meta: null,
            value: ''
        };
    }
    function codeText() {
        return {
            type: 'inlineCode',
            value: ''
        };
    }
    function definition() {
        return {
            type: 'definition',
            identifier: '',
            label: null,
            title: null,
            url: ''
        };
    }
    function emphasis() {
        return {
            type: 'emphasis',
            children: []
        };
    }
    function heading() {
        return {
            type: 'heading',
            depth: undefined,
            children: []
        };
    }
    function hardBreak() {
        return {
            type: 'break'
        };
    }
    function html() {
        return {
            type: 'html',
            value: ''
        };
    }
    function image() {
        return {
            type: 'image',
            title: null,
            url: '',
            alt: null
        };
    }
    function link() {
        return {
            type: 'link',
            title: null,
            url: '',
            children: []
        };
    }
    function list(token) {
        return {
            type: 'list',
            ordered: token.type === 'listOrdered',
            start: null,
            spread: token._spread,
            children: []
        };
    }
    function listItem(token) {
        return {
            type: 'listItem',
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    function paragraph() {
        return {
            type: 'paragraph',
            children: []
        };
    }
    function strong() {
        return {
            type: 'strong',
            children: []
        };
    }
    function text() {
        return {
            type: 'text',
            value: ''
        };
    }
    function thematicBreak() {
        return {
            type: 'thematicBreak'
        };
    }
}
function configure(config, extensions) {
    var index = -1;
    while(++index < extensions.length)extension(config, extensions[index]);
    return config;
}
function extension(config, extension) {
    var key;
    var left;
    for(key in extension){
        left = own.call(config, key) ? config[key] : config[key] = {};
        if (key === 'canContainEols' || key === 'transforms') config[key] = [].concat(left, extension[key]);
        else Object.assign(left, extension[key]);
    }
}

},{"349b623759307e06":"2CsQn","cc58a9fef25bd11e":"dMGGw","19d7b2e434a9783d":"6XhzX","3866f440289aa212":"jdlZ5","6f610ddacbb9bb4":"lEB68","8d1e9528d78651b0":"ebbj1","7a6bb0ee7f14f311":"bz3Bm","ade5c7db8b52a74b":"6eidf","ed1134f9324b51a":"lBpfH","690c23628e8fbc66":"YF175"}],"2CsQn":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = toString;
// Get the text content of a node.
// Prefer the node’s plain-text fields, otherwise serialize its children,
// and if the given value is an array, serialize the nodes in it.
function toString(node) {
    return node && (node.value || node.alt || node.title || 'children' in node && all(node.children) || 'length' in node && all(node)) || '';
}
function all(values) {
    var result = [];
    var index = -1;
    while(++index < values.length)result[index] = toString(values[index]);
    return result.join('');
}

},{}],"dMGGw":[function(require,module,exports,__globalThis) {
'use strict';
var assign = Object.assign;
module.exports = assign;

},{}],"6XhzX":[function(require,module,exports,__globalThis) {
'use strict';
var own = {}.hasOwnProperty;
module.exports = own;

},{}],"jdlZ5":[function(require,module,exports,__globalThis) {
'use strict';
function normalizeIdentifier(value) {
    return value // Collapse Markdown whitespace.
    .replace(/[\t\n\r ]+/g, ' ') // Trim.
    .replace(/^ | $/g, '') // Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no object method is uppercase.
    .toLowerCase().toUpperCase();
}
module.exports = normalizeIdentifier;

},{}],"lEB68":[function(require,module,exports,__globalThis) {
'use strict';
var fromCharCode = require("2005e15541b79e53");
function safeFromInt(value, base) {
    var code = parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of the basic block and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || (code & 65535) === 65535 || (code & 65535) === 65534 || // Out of range
    code > 1114111) return '\uFFFD';
    return fromCharCode(code);
}
module.exports = safeFromInt;

},{"2005e15541b79e53":"8MefB"}],"8MefB":[function(require,module,exports,__globalThis) {
'use strict';
var fromCharCode = String.fromCharCode;
module.exports = fromCharCode;

},{}],"ebbj1":[function(require,module,exports,__globalThis) {
'use strict';
var content = require("9229ba2182faa7bd");
var document = require("6df91fb48132dba6");
var flow = require("197fc56a51191cc8");
var text = require("f5d33e2ddb65948f");
var combineExtensions = require("cac4ff2087d27ec6");
var createTokenizer = require("4e6d5d645e40f0d7");
var miniflat = require("6cd7ded16d46231b");
var constructs = require("745cc771dacf4bb6");
function parse(options) {
    var settings = options || {};
    var parser = {
        defined: [],
        constructs: combineExtensions([
            constructs
        ].concat(miniflat(settings.extensions))),
        content: create(content),
        document: create(document),
        flow: create(flow),
        string: create(text.string),
        text: create(text.text)
    };
    return parser;
    function create(initializer) {
        return creator;
        function creator(from) {
            return createTokenizer(parser, initializer, from);
        }
    }
}
module.exports = parse;

},{"9229ba2182faa7bd":"cxuKb","6df91fb48132dba6":"66Frn","197fc56a51191cc8":"d6uAe","f5d33e2ddb65948f":"7J64A","cac4ff2087d27ec6":"iyaj2","4e6d5d645e40f0d7":"gsnZm","6cd7ded16d46231b":"1Fufd","745cc771dacf4bb6":"6j3J3"}],"cxuKb":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
var markdownLineEnding = require("19fb2dfbdd4a8bca");
var factorySpace = require("2f08be53b082a994");
var tokenize = initializeContent;
function initializeContent(effects) {
    var contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    var previous;
    return contentStart;
    function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return factorySpace(effects, contentStart, 'linePrefix');
    }
    function paragraphInitial(code) {
        effects.enter('paragraph');
        return lineStart(code);
    }
    function lineStart(code) {
        var token = effects.enter('chunkText', {
            contentType: 'text',
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    function data(code) {
        if (code === null) {
            effects.exit('chunkText');
            effects.exit('paragraph');
            effects.consume(code);
            return;
        }
        if (markdownLineEnding(code)) {
            effects.consume(code);
            effects.exit('chunkText');
            return lineStart;
        } // Data.
        effects.consume(code);
        return data;
    }
}
exports.tokenize = tokenize;

},{"19fb2dfbdd4a8bca":"gpLlx","2f08be53b082a994":"2joBs"}],"gpLlx":[function(require,module,exports,__globalThis) {
'use strict';
function markdownLineEnding(code) {
    return code < -2;
}
module.exports = markdownLineEnding;

},{}],"2joBs":[function(require,module,exports,__globalThis) {
'use strict';
var markdownSpace = require("df87f4d1defb0208");
function spaceFactory(effects, ok, type, max) {
    var limit = max ? max - 1 : Infinity;
    var size = 0;
    return start;
    function start(code) {
        if (markdownSpace(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    function prefix(code) {
        if (markdownSpace(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}
module.exports = spaceFactory;

},{"df87f4d1defb0208":"kZ8rl"}],"kZ8rl":[function(require,module,exports,__globalThis) {
'use strict';
function markdownSpace(code) {
    return code === -2 || code === -1 || code === 32;
}
module.exports = markdownSpace;

},{}],"66Frn":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
var markdownLineEnding = require("ef3efa514d54254");
var factorySpace = require("9338687f3ca517e0");
var partialBlankLine = require("6731c4a0a011ce70");
var tokenize = initializeDocument;
var containerConstruct = {
    tokenize: tokenizeContainer
};
var lazyFlowConstruct = {
    tokenize: tokenizeLazyFlow
};
function initializeDocument(effects) {
    var self = this;
    var stack = [];
    var continued = 0;
    var inspectConstruct = {
        tokenize: tokenizeInspect,
        partial: true
    };
    var inspectResult;
    var childFlow;
    var childToken;
    return start;
    function start(code) {
        if (continued < stack.length) {
            self.containerState = stack[continued][1];
            return effects.attempt(stack[continued][0].continuation, documentContinue, documentContinued)(code);
        }
        return documentContinued(code);
    }
    function documentContinue(code) {
        continued++;
        return start(code);
    }
    function documentContinued(code) {
        // If we’re in a concrete construct (such as when expecting another line of
        // HTML, or we resulted in lazy content), we can immediately start flow.
        if (inspectResult && inspectResult.flowContinue) return flowStart(code);
        self.interrupt = childFlow && childFlow.currentConstruct && childFlow.currentConstruct.interruptible;
        self.containerState = {};
        return effects.attempt(containerConstruct, containerContinue, flowStart)(code);
    }
    function containerContinue(code) {
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        self.containerState = undefined;
        return documentContinued(code);
    }
    function flowStart(code) {
        if (code === null) {
            exitContainers(0, true);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter('chunkFlow', {
            contentType: 'flow',
            previous: childToken,
            _tokenizer: childFlow
        });
        return flowContinue(code);
    }
    function flowContinue(code) {
        if (code === null) {
            continueFlow(effects.exit('chunkFlow'));
            return flowStart(code);
        }
        if (markdownLineEnding(code)) {
            effects.consume(code);
            continueFlow(effects.exit('chunkFlow'));
            return effects.check(inspectConstruct, documentAfterPeek);
        }
        effects.consume(code);
        return flowContinue;
    }
    function documentAfterPeek(code) {
        exitContainers(inspectResult.continued, inspectResult && inspectResult.flowEnd);
        continued = 0;
        return start(code);
    }
    function continueFlow(token) {
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.lazy = inspectResult && inspectResult.lazy;
        childFlow.defineSkip(token.start);
        childFlow.write(self.sliceStream(token));
    }
    function exitContainers(size, end) {
        var index = stack.length // Close the flow.
        ;
        if (childFlow && end) {
            childFlow.write([
                null
            ]);
            childToken = childFlow = undefined;
        } // Exit open containers.
        while(index-- > size){
            self.containerState = stack[index][1];
            stack[index][0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function tokenizeInspect(effects, ok) {
        var subcontinued = 0;
        inspectResult = {};
        return inspectStart;
        function inspectStart(code) {
            if (subcontinued < stack.length) {
                self.containerState = stack[subcontinued][1];
                return effects.attempt(stack[subcontinued][0].continuation, inspectContinue, inspectLess)(code);
            } // If we’re continued but in a concrete flow, we can’t have more
            // containers.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) {
                inspectResult.flowContinue = true;
                return inspectDone(code);
            }
            self.interrupt = childFlow.currentConstruct && childFlow.currentConstruct.interruptible;
            self.containerState = {};
            return effects.attempt(containerConstruct, inspectFlowEnd, inspectDone)(code);
        }
        function inspectContinue(code) {
            subcontinued++;
            return self.containerState._closeFlow ? inspectFlowEnd(code) : inspectStart(code);
        }
        function inspectLess(code) {
            if (childFlow.currentConstruct && childFlow.currentConstruct.lazy) {
                // Maybe another container?
                self.containerState = {};
                return effects.attempt(containerConstruct, inspectFlowEnd, effects.attempt(lazyFlowConstruct, inspectFlowEnd, effects.check(partialBlankLine, inspectFlowEnd, inspectLazy)))(code);
            } // Otherwise we’re interrupting.
            return inspectFlowEnd(code);
        }
        function inspectLazy(code) {
            // Act as if all containers are continued.
            subcontinued = stack.length;
            inspectResult.lazy = true;
            inspectResult.flowContinue = true;
            return inspectDone(code);
        } // We’re done with flow if we have more containers, or an interruption.
        function inspectFlowEnd(code) {
            inspectResult.flowEnd = true;
            return inspectDone(code);
        }
        function inspectDone(code) {
            inspectResult.continued = subcontinued;
            self.interrupt = self.containerState = undefined;
            return ok(code);
        }
    }
}
function tokenizeContainer(effects, ok, nok) {
    return factorySpace(effects, effects.attempt(this.parser.constructs.document, ok, nok), 'linePrefix', this.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4);
}
function tokenizeLazyFlow(effects, ok, nok) {
    return factorySpace(effects, effects.lazy(this.parser.constructs.flow, ok, nok), 'linePrefix', this.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4);
}
exports.tokenize = tokenize;

},{"ef3efa514d54254":"gpLlx","9338687f3ca517e0":"2joBs","6731c4a0a011ce70":"2HIWv"}],"2HIWv":[function(require,module,exports,__globalThis) {
'use strict';
var markdownLineEnding = require("4dde82fc8216a5ab");
var factorySpace = require("2adb8b8230c2558c");
var partialBlankLine = {
    tokenize: tokenizePartialBlankLine,
    partial: true
};
function tokenizePartialBlankLine(effects, ok, nok) {
    return factorySpace(effects, afterWhitespace, 'linePrefix');
    function afterWhitespace(code) {
        return code === null || markdownLineEnding(code) ? ok(code) : nok(code);
    }
}
module.exports = partialBlankLine;

},{"4dde82fc8216a5ab":"gpLlx","2adb8b8230c2558c":"2joBs"}],"d6uAe":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
var content = require("f53f7797c6882954");
var factorySpace = require("5966f6830c4c3325");
var partialBlankLine = require("9203dc4ffac01648");
var tokenize = initializeFlow;
function initializeFlow(effects) {
    var self = this;
    var initial = effects.attempt(// Try to parse a blank line.
    partialBlankLine, atBlankEnding, effects.attempt(this.parser.constructs.flowInitial, afterConstruct, factorySpace(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt(content, afterConstruct)), 'linePrefix')));
    return initial;
    function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter('lineEndingBlank');
        effects.consume(code);
        effects.exit('lineEndingBlank');
        self.currentConstruct = undefined;
        return initial;
    }
    function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        self.currentConstruct = undefined;
        return initial;
    }
}
exports.tokenize = tokenize;

},{"f53f7797c6882954":"5lvIv","5966f6830c4c3325":"2joBs","9203dc4ffac01648":"2HIWv"}],"5lvIv":[function(require,module,exports,__globalThis) {
'use strict';
var markdownLineEnding = require("aad88c92fa801056");
var prefixSize = require("46c7568369083ca5");
var subtokenize = require("c12bccbfda0c725");
var factorySpace = require("2e8b8a008bf75a1c");
// No name because it must not be turned off.
var content = {
    tokenize: tokenizeContent,
    resolve: resolveContent,
    interruptible: true,
    lazy: true
};
var continuationConstruct = {
    tokenize: tokenizeContinuation,
    partial: true
} // Content is transparent: it’s parsed right now. That way, definitions are also
;
// parsed right now: before text in paragraphs (specifically, media) are parsed.
function resolveContent(events) {
    subtokenize(events);
    return events;
}
function tokenizeContent(effects, ok) {
    var previous;
    return start;
    function start(code) {
        effects.enter('content');
        previous = effects.enter('chunkContent', {
            contentType: 'content'
        });
        return data(code);
    }
    function data(code) {
        if (code === null) return contentEnd(code);
        if (markdownLineEnding(code)) return effects.check(continuationConstruct, contentContinue, contentEnd)(code);
         // Data.
        effects.consume(code);
        return data;
    }
    function contentEnd(code) {
        effects.exit('chunkContent');
        effects.exit('content');
        return ok(code);
    }
    function contentContinue(code) {
        effects.consume(code);
        effects.exit('chunkContent');
        previous = previous.next = effects.enter('chunkContent', {
            contentType: 'content',
            previous: previous
        });
        return data;
    }
}
function tokenizeContinuation(effects, ok, nok) {
    var self = this;
    return startLookahead;
    function startLookahead(code) {
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return factorySpace(effects, prefixed, 'linePrefix');
    }
    function prefixed(code) {
        if (code === null || markdownLineEnding(code)) return nok(code);
        if (self.parser.constructs.disable.null.indexOf('codeIndented') > -1 || prefixSize(self.events, 'linePrefix') < 4) return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
        return ok(code);
    }
}
module.exports = content;

},{"aad88c92fa801056":"gpLlx","46c7568369083ca5":"25mY2","c12bccbfda0c725":"6qUHK","2e8b8a008bf75a1c":"2joBs"}],"25mY2":[function(require,module,exports,__globalThis) {
'use strict';
var sizeChunks = require("82c610bc78eb7909");
function prefixSize(events, type) {
    var tail = events[events.length - 1];
    if (!tail || tail[1].type !== type) return 0;
    return sizeChunks(tail[2].sliceStream(tail[1]));
}
module.exports = prefixSize;

},{"82c610bc78eb7909":"9VHnG"}],"9VHnG":[function(require,module,exports,__globalThis) {
'use strict';
// Counts tabs based on their expanded size, and CR+LF as one character.
function sizeChunks(chunks) {
    var index = -1;
    var size = 0;
    while(++index < chunks.length)size += typeof chunks[index] === 'string' ? chunks[index].length : 1;
    return size;
}
module.exports = sizeChunks;

},{}],"6qUHK":[function(require,module,exports,__globalThis) {
'use strict';
var assign = require("aee9d46c0f6a9c0e");
var chunkedSplice = require("368870fc50268ab9");
var shallow = require("56bee2652467c484");
function subtokenize(events) {
    var jumps = {};
    var index = -1;
    var event;
    var lineIndex;
    var otherIndex;
    var otherEvent;
    var parameters;
    var subevents;
    var more;
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events[index] // Add a hook for the GFM tasklist extension, which needs to know if text
        ;
        // is in the first content of a list item.
        if (index && event[1].type === 'chunkFlow' && events[index - 1][1].type === 'listItemPrefix') {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === 'lineEndingBlank') otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === 'content') while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === 'content') break;
                if (subevents[otherIndex][1].type === 'chunkText') {
                    subevents[otherIndex][1].isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        } // Enter.
        if (event[0] === 'enter') {
            if (event[1].contentType) {
                assign(jumps, subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container || event[1]._movePreviousLineEndings) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events[otherIndex];
                if (otherEvent[1].type === 'lineEnding' || otherEvent[1].type === 'lineEndingBlank') {
                    if (otherEvent[0] === 'enter') {
                        if (lineIndex) events[lineIndex][1].type = 'lineEndingBlank';
                        otherEvent[1].type = 'lineEnding';
                        lineIndex = otherIndex;
                    }
                } else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = shallow(events[lineIndex][1].start) // Switch container exit w/ line endings.
                ;
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                chunkedSplice(events, lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    return !more;
}
function subcontent(events, eventIndex) {
    var token = events[eventIndex][1];
    var context = events[eventIndex][2];
    var startPosition = eventIndex - 1;
    var startPositions = [];
    var tokenizer = token._tokenizer || context.parser[token.contentType](token.start);
    var childEvents = tokenizer.events;
    var jumps = [];
    var gaps = {};
    var stream;
    var previous;
    var index;
    var entered;
    var end;
    var adjust // Loop forward through the linked tokens to pass them in order to the
    ;
    // subtokenizer.
    while(token){
        // Find the position of the event for this token.
        while(events[++startPosition][1] !== token);
        startPositions.push(startPosition);
        if (!token._tokenizer) {
            stream = context.sliceStream(token);
            if (!token.next) stream.push(null);
            if (previous) tokenizer.defineSkip(token.start);
            if (token.isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (token.isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        } // Unravel the next token.
        previous = token;
        token = token.next;
    } // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    token = previous;
    index = childEvents.length;
    while(index--){
        // Make sure we’ve at least seen something (final eol is part of the last
        // token).
        if (childEvents[index][0] === 'enter') entered = true;
        else if (// Find a void token that includes a break.
        entered && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
            add(childEvents.slice(index + 1, end));
            // Help GC.
            token._tokenizer = token.next = undefined;
            token = token.previous;
            end = index + 1;
        }
    }
    // Help GC.
    tokenizer.events = token._tokenizer = token.next = undefined // Do head:
    ;
    add(childEvents.slice(0, end));
    index = -1;
    adjust = 0;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
    function add(slice) {
        var start = startPositions.pop();
        jumps.unshift([
            start,
            start + slice.length - 1
        ]);
        chunkedSplice(events, start, 2, slice);
    }
}
module.exports = subtokenize;

},{"aee9d46c0f6a9c0e":"dMGGw","368870fc50268ab9":"dXntd","56bee2652467c484":"aBApX"}],"dXntd":[function(require,module,exports,__globalThis) {
'use strict';
var splice = require("93a81782f7d56ad3");
// causes a stack overflow in V8 when trying to insert 100k items for instance.
function chunkedSplice(list, start, remove, items) {
    var end = list.length;
    var chunkStart = 0;
    var parameters // Make start between zero and `end` (included).
    ;
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0 // No need to chunk the items if there’s only a couple (10k) items.
    ;
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        splice.apply(list, parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) splice.apply(list, [
            start,
            remove
        ]) // Insert the items in chunks to not cause stack overflows.
        ;
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            splice.apply(list, parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
module.exports = chunkedSplice;

},{"93a81782f7d56ad3":"lmqU2"}],"lmqU2":[function(require,module,exports,__globalThis) {
'use strict';
var splice = [].splice;
module.exports = splice;

},{}],"aBApX":[function(require,module,exports,__globalThis) {
'use strict';
var assign = require("3c80157067e97309");
function shallow(object) {
    return assign({}, object);
}
module.exports = shallow;

},{"3c80157067e97309":"dMGGw"}],"7J64A":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
var assign = require("ef49a3d844be4b62");
var shallow = require("8ed6ac33374a16ca");
var text = initializeFactory('text');
var string = initializeFactory('string');
var resolver = {
    resolveAll: createResolver()
};
function initializeFactory(field) {
    return {
        tokenize: initializeText,
        resolveAll: createResolver(field === 'text' ? resolveAllLineSuffixes : undefined)
    };
    function initializeText(effects) {
        var self = this;
        var constructs = this.parser.constructs[field];
        var text = effects.attempt(constructs, start, notText);
        return start;
        function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter('data');
            effects.consume(code);
            return data;
        }
        function data(code) {
            if (atBreak(code)) {
                effects.exit('data');
                return text(code);
            } // Data.
            effects.consume(code);
            return data;
        }
        function atBreak(code) {
            var list = constructs[code];
            var index = -1;
            if (code === null) return true;
            if (list) while(++index < list.length){
                if (!list[index].previous || list[index].previous.call(self, self.previous)) return true;
            }
        }
    }
}
function createResolver(extraResolver) {
    return resolveAllText;
    function resolveAllText(events, context) {
        var index = -1;
        var enter // A rather boring computation (to merge adjacent `data` events) which
        ;
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === 'data') {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== 'data') {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
} // A rather ugly set of instructions which again looks at chunks in the input
// stream.
// The reason to do this here is that it is *much* faster to parse in reverse.
// And that we can’t hook into `null` to split the line suffix before an EOF.
// To do: figure out if we can make this into a clean utility, or even in core.
// As it will be useful for GFMs literal autolink extension (and maybe even
// tables?)
function resolveAllLineSuffixes(events, context) {
    var eventIndex = -1;
    var chunks;
    var data;
    var chunk;
    var index;
    var bufferIndex;
    var size;
    var tabs;
    var token;
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === 'lineEnding') && events[eventIndex - 1][1].type === 'data') {
        data = events[eventIndex - 1][1];
        chunks = context.sliceStream(data);
        index = chunks.length;
        bufferIndex = -1;
        size = 0;
        tabs = undefined;
        while(index--){
            chunk = chunks[index];
            if (typeof chunk === 'string') {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        if (size) {
            token = {
                type: eventIndex === events.length || tabs || size < 2 ? 'lineSuffix' : 'hardBreakTrailing',
                start: {
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size,
                    _index: data.start._index + index,
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex
                },
                end: shallow(data.end)
            };
            data.end = shallow(token.start);
            if (data.start.offset === data.end.offset) assign(data, token);
            else {
                events.splice(eventIndex, 0, [
                    'enter',
                    token,
                    context
                ], [
                    'exit',
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}
exports.resolver = resolver;
exports.string = string;
exports.text = text;

},{"ef49a3d844be4b62":"dMGGw","8ed6ac33374a16ca":"aBApX"}],"iyaj2":[function(require,module,exports,__globalThis) {
'use strict';
var hasOwnProperty = require("3420af3986fc1d27");
var chunkedSplice = require("48e7af73b8030301");
var miniflat = require("52ad75ec336063ff");
function combineExtensions(extensions) {
    var all = {};
    var index = -1;
    while(++index < extensions.length)extension(all, extensions[index]);
    return all;
}
function extension(all, extension) {
    var hook;
    var left;
    var right;
    var code;
    for(hook in extension){
        left = hasOwnProperty.call(all, hook) ? all[hook] : all[hook] = {};
        right = extension[hook];
        for(code in right)left[code] = constructs(miniflat(right[code]), hasOwnProperty.call(left, code) ? left[code] : []);
    }
}
function constructs(list, existing) {
    var index = -1;
    var before = [];
    while(++index < list.length)(list[index].add === 'after' ? existing : before).push(list[index]);
    chunkedSplice(existing, 0, 0, before);
    return existing;
}
module.exports = combineExtensions;

},{"3420af3986fc1d27":"6XhzX","48e7af73b8030301":"dXntd","52ad75ec336063ff":"1Fufd"}],"1Fufd":[function(require,module,exports,__globalThis) {
'use strict';
function miniflat(value) {
    return value === null || value === undefined ? [] : 'length' in value ? value : [
        value
    ];
}
module.exports = miniflat;

},{}],"gsnZm":[function(require,module,exports,__globalThis) {
'use strict';
var assign = require("5bea29dadc189f4f");
var markdownLineEnding = require("ba4367c77e774ae2");
var chunkedPush = require("417b6f0e17e4391f");
var chunkedSplice = require("8159801735a79d7e");
var miniflat = require("aa903ae1941037ce");
var resolveAll = require("a956d69ea7c0b34");
var serializeChunks = require("36a7a21bba95496e");
var shallow = require("a3b7d33ce0c4cd1c");
var sliceChunks = require("8a22b63a193b5cc0");
// Create a tokenizer.
// Tokenizers deal with one type of data (e.g., containers, flow, text).
// The parser is the object dealing with it all.
// `initialize` works like other constructs, except that only its `tokenize`
// function is used, in which case it doesn’t receive an `ok` or `nok`.
// `from` can be given to set the point before the first character, although
// when further lines are indented, they must be set with `defineSkip`.
function createTokenizer(parser, initialize, from) {
    var point = from ? shallow(from) : {
        line: 1,
        column: 1,
        offset: 0
    };
    var columnStart = {};
    var resolveAllConstructs = [];
    var chunks = [];
    var stack = [];
    var effects = {
        consume: consume,
        enter: enter,
        exit: exit,
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        }),
        lazy: constructFactory(onsuccessfulcheck, {
            lazy: true
        })
    } // State and tools for resolving and serializing.
    ;
    var context = {
        previous: null,
        events: [],
        parser: parser,
        sliceStream: sliceStream,
        sliceSerialize: sliceSerialize,
        now: now,
        defineSkip: skip,
        write: write
    } // The state function.
    ;
    var state = initialize.tokenize.call(context, effects) // Track which character we expect to be consumed, to catch bugs.
    ;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
     // Store where we are in the input stream.
    point._index = 0;
    point._bufferIndex = -1;
    return context;
    function write(slice) {
        chunks = chunkedPush(chunks, slice);
        main() // Exit if we’re not done, resolve might change stuff.
        ;
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0) // Otherwise, resolve, and exit.
        ;
        context.events = resolveAll(resolveAllConstructs, context.events, context);
        return context.events;
    } //
    // Tools.
    //
    function sliceSerialize(token) {
        return serializeChunks(sliceStream(token));
    }
    function sliceStream(token) {
        return sliceChunks(chunks, token);
    }
    function now() {
        return shallow(point);
    }
    function skip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    } //
    // State management.
    //
    // Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
    // `consume`).
    // Here is where we walk through the chunks, which either include strings of
    // several characters, or numerical character codes.
    // The reason to do this in a loop instead of a call is so the stack can
    // drain.
    function main() {
        var chunkIndex;
        var chunk;
        while(point._index < chunks.length){
            chunk = chunks[point._index] // If we’re in a buffer chunk, loop through it.
            ;
            if (typeof chunk === 'string') {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    } // Deal with one code.
    function go(code) {
        state = state(code);
    } // Move a character forward.
    function consume(code) {
        if (markdownLineEnding(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        } // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++ // At end of string chunk.
            ;
            if (point._bufferIndex === chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        } // Expose the previous character.
        context.previous = code // Mark as consumed.
        ;
    } // Start a token.
    function enter(type, fields) {
        var token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            'enter',
            token,
            context
        ]);
        stack.push(token);
        return token;
    } // Stop a token.
    function exit(type) {
        var token = stack.pop();
        token.end = now();
        context.events.push([
            'exit',
            token,
            context
        ]);
        return token;
    } // Use results.
    function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    } // Discard results.
    function onsuccessfulcheck(construct, info) {
        info.restore();
    } // Factory to attempt/check/interrupt.
    function constructFactory(onreturn, fields) {
        return hook // Handle either an object mapping codes to constructs, a list of
        ;
        // constructs, or a single construct.
        function hook(constructs, returnState, bogusState) {
            var listOfConstructs;
            var constructIndex;
            var currentConstruct;
            var info;
            return constructs.tokenize || 'length' in constructs ? handleListOfConstructs(miniflat(constructs)) : handleMapOfConstructs;
            function handleMapOfConstructs(code) {
                if (code in constructs || null in constructs) return handleListOfConstructs(constructs.null ? /* c8 ignore next */ miniflat(constructs[code]).concat(miniflat(constructs.null)) : constructs[code])(code);
                return bogusState(code);
            }
            function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                return handleConstruct(list[constructIndex]);
            }
            function handleConstruct(construct) {
                return start;
                function start(code) {
                    // To do: not nede to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    if (construct.name && context.parser.constructs.disable.null.indexOf(construct.name) > -1) return nok();
                    return construct.tokenize.call(fields ? assign({}, context, fields) : context, effects, ok, nok)(code);
                }
            }
            function ok(code) {
                onreturn(currentConstruct, info);
                return returnState;
            }
            function nok(code) {
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    function addResult(construct, from) {
        if (construct.resolveAll && resolveAllConstructs.indexOf(construct) < 0) resolveAllConstructs.push(construct);
        if (construct.resolve) chunkedSplice(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    function store() {
        var startPoint = now();
        var startPrevious = context.previous;
        var startCurrentConstruct = context.currentConstruct;
        var startEventsIndex = context.events.length;
        var startStack = Array.from(stack);
        return {
            restore: restore,
            from: startEventsIndex
        };
        function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
module.exports = createTokenizer;

},{"5bea29dadc189f4f":"dMGGw","ba4367c77e774ae2":"gpLlx","417b6f0e17e4391f":"8DQMZ","8159801735a79d7e":"dXntd","aa903ae1941037ce":"1Fufd","a956d69ea7c0b34":"lIGEx","36a7a21bba95496e":"joTyr","a3b7d33ce0c4cd1c":"aBApX","8a22b63a193b5cc0":"c3vBy"}],"8DQMZ":[function(require,module,exports,__globalThis) {
'use strict';
var chunkedSplice = require("2c8f556eed7bb6be");
function chunkedPush(list, items) {
    if (list.length) {
        chunkedSplice(list, list.length, 0, items);
        return list;
    }
    return items;
}
module.exports = chunkedPush;

},{"2c8f556eed7bb6be":"dXntd"}],"lIGEx":[function(require,module,exports,__globalThis) {
'use strict';
function resolveAll(constructs, events, context) {
    var called = [];
    var index = -1;
    var resolve;
    while(++index < constructs.length){
        resolve = constructs[index].resolveAll;
        if (resolve && called.indexOf(resolve) < 0) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}
module.exports = resolveAll;

},{}],"joTyr":[function(require,module,exports,__globalThis) {
'use strict';
var fromCharCode = require("69ec21b2c829ac8a");
function serializeChunks(chunks) {
    var index = -1;
    var result = [];
    var chunk;
    var value;
    var atTab;
    while(++index < chunks.length){
        chunk = chunks[index];
        if (typeof chunk === 'string') value = chunk;
        else if (chunk === -5) value = '\r';
        else if (chunk === -4) value = '\n';
        else if (chunk === -3) value = "\r\n";
        else if (chunk === -2) value = '\t';
        else if (chunk === -1) {
            if (atTab) continue;
            value = ' ';
        } else // Currently only replacement character.
        value = fromCharCode(chunk);
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join('');
}
module.exports = serializeChunks;

},{"69ec21b2c829ac8a":"8MefB"}],"c3vBy":[function(require,module,exports,__globalThis) {
'use strict';
function sliceChunks(chunks, token) {
    var startIndex = token.start._index;
    var startBufferIndex = token.start._bufferIndex;
    var endIndex = token.end._index;
    var endBufferIndex = token.end._bufferIndex;
    var view;
    if (startIndex === endIndex) view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) view[0] = view[0].slice(startBufferIndex);
        if (endBufferIndex > 0) view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
module.exports = sliceChunks;

},{}],"6j3J3":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
var text$1 = require("1d661307a7f40014");
var attention = require("83ee305c0709270d");
var autolink = require("be077423610d5297");
var blockQuote = require("39a01fc3db6a2097");
var characterEscape = require("7f123db633b59125");
var characterReference = require("4a6220a03f0a2d3a");
var codeFenced = require("e6be3a7ff1d915f2");
var codeIndented = require("3966432e0c10f77a");
var codeText = require("df8aa9bab361e2ce");
var definition = require("c3eb20bdbe4d3652");
var hardBreakEscape = require("52894f13c58a2cfd");
var headingAtx = require("4fa1b39b079b6daf");
var htmlFlow = require("c30094289db2ad64");
var htmlText = require("6b95171a8248c0cc");
var labelEnd = require("2b312cb74131ff54");
var labelStartImage = require("f24a6f65e36288b0");
var labelStartLink = require("983d72e6711c5159");
var lineEnding = require("929442bdfeb19d85");
var list = require("e286079f63e99916");
var setextUnderline = require("a052869f75448c33");
var thematicBreak = require("3f0f4b19c5d26b74");
var document = {
    42: list,
    // Asterisk
    43: list,
    // Plus sign
    45: list,
    // Dash
    48: list,
    // 0
    49: list,
    // 1
    50: list,
    // 2
    51: list,
    // 3
    52: list,
    // 4
    53: list,
    // 5
    54: list,
    // 6
    55: list,
    // 7
    56: list,
    // 8
    57: list,
    // 9
    62: blockQuote // Greater than
};
var contentInitial = {
    91: definition // Left square bracket
};
var flowInitial = {
    '-2': codeIndented,
    // Horizontal tab
    '-1': codeIndented,
    // Virtual space
    32: codeIndented // Space
};
var flow = {
    35: headingAtx,
    // Number sign
    42: thematicBreak,
    // Asterisk
    45: [
        setextUnderline,
        thematicBreak
    ],
    // Dash
    60: htmlFlow,
    // Less than
    61: setextUnderline,
    // Equals to
    95: thematicBreak,
    // Underscore
    96: codeFenced,
    // Grave accent
    126: codeFenced // Tilde
};
var string = {
    38: characterReference,
    // Ampersand
    92: characterEscape // Backslash
};
var text = {
    '-5': lineEnding,
    // Carriage return
    '-4': lineEnding,
    // Line feed
    '-3': lineEnding,
    // Carriage return + line feed
    33: labelStartImage,
    // Exclamation mark
    38: characterReference,
    // Ampersand
    42: attention,
    // Asterisk
    60: [
        autolink,
        htmlText
    ],
    // Less than
    91: labelStartLink,
    // Left square bracket
    92: [
        hardBreakEscape,
        characterEscape
    ],
    // Backslash
    93: labelEnd,
    // Right square bracket
    95: attention,
    // Underscore
    96: codeText // Grave accent
};
var insideSpan = {
    null: [
        attention,
        text$1.resolver
    ]
};
var disable = {
    null: []
};
exports.contentInitial = contentInitial;
exports.disable = disable;
exports.document = document;
exports.flow = flow;
exports.flowInitial = flowInitial;
exports.insideSpan = insideSpan;
exports.string = string;
exports.text = text;

},{"1d661307a7f40014":"7J64A","83ee305c0709270d":"eir3f","be077423610d5297":"hsDhF","39a01fc3db6a2097":"9pwQk","7f123db633b59125":"2ZrdU","4a6220a03f0a2d3a":"4iskv","e6be3a7ff1d915f2":"ixotb","3966432e0c10f77a":"5eaGA","df8aa9bab361e2ce":"4AquI","c3eb20bdbe4d3652":"hKYnF","52894f13c58a2cfd":"euVl1","4fa1b39b079b6daf":"9GaUz","c30094289db2ad64":"30C6k","6b95171a8248c0cc":"a5uHi","2b312cb74131ff54":"1zCGC","f24a6f65e36288b0":"37zEu","983d72e6711c5159":"jn0bo","929442bdfeb19d85":"beXlf","e286079f63e99916":"9syVn","a052869f75448c33":"jX2fX","3f0f4b19c5d26b74":"10agS"}],"eir3f":[function(require,module,exports,__globalThis) {
'use strict';
var chunkedPush = require("2f2733da21298616");
var chunkedSplice = require("cb36a13ec89e7464");
var classifyCharacter = require("ea90f9e55fce8a10");
var movePoint = require("ba273f97a276227d");
var resolveAll = require("aabdb4dbde3e0e3c");
var shallow = require("cb58d02c223295a1");
var attention = {
    name: 'attention',
    tokenize: tokenizeAttention,
    resolveAll: resolveAllAttention
};
function resolveAllAttention(events, context) {
    var index = -1;
    var open;
    var group;
    var text;
    var openingSequence;
    var closingSequence;
    var use;
    var nextEvents;
    var offset // Walk through all events.
    ;
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === 'enter' && events[index][1].type === 'attentionSequence' && events[index][1]._close) {
        open = index // Now walk back to find an opener.
        ;
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === 'exit' && events[open][1].type === 'attentionSequence' && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
             // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            openingSequence = {
                type: use > 1 ? 'strongSequence' : 'emphasisSequence',
                start: movePoint(shallow(events[open][1].end), -use),
                end: shallow(events[open][1].end)
            };
            closingSequence = {
                type: use > 1 ? 'strongSequence' : 'emphasisSequence',
                start: shallow(events[index][1].start),
                end: movePoint(shallow(events[index][1].start), use)
            };
            text = {
                type: use > 1 ? 'strongText' : 'emphasisText',
                start: shallow(events[open][1].end),
                end: shallow(events[index][1].start)
            };
            group = {
                type: use > 1 ? 'strong' : 'emphasis',
                start: shallow(openingSequence.start),
                end: shallow(closingSequence.end)
            };
            events[open][1].end = shallow(openingSequence.start);
            events[index][1].start = shallow(closingSequence.end);
            nextEvents = [] // If there are more markers in the opening, add them before.
            ;
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = chunkedPush(nextEvents, [
                [
                    'enter',
                    events[open][1],
                    context
                ],
                [
                    'exit',
                    events[open][1],
                    context
                ]
            ]);
             // Opening.
            nextEvents = chunkedPush(nextEvents, [
                [
                    'enter',
                    group,
                    context
                ],
                [
                    'enter',
                    openingSequence,
                    context
                ],
                [
                    'exit',
                    openingSequence,
                    context
                ],
                [
                    'enter',
                    text,
                    context
                ]
            ]) // Between.
            ;
            nextEvents = chunkedPush(nextEvents, resolveAll(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context)) // Closing.
            ;
            nextEvents = chunkedPush(nextEvents, [
                [
                    'exit',
                    text,
                    context
                ],
                [
                    'enter',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    group,
                    context
                ]
            ]) // If there are more markers in the closing, add them after.
            ;
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = chunkedPush(nextEvents, [
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            chunkedSplice(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
     // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === 'attentionSequence') events[index][1].type = 'data';
    return events;
}
function tokenizeAttention(effects, ok) {
    var before = classifyCharacter(this.previous);
    var marker;
    return start;
    function start(code) {
        effects.enter('attentionSequence');
        marker = code;
        return sequence(code);
    }
    function sequence(code) {
        var token;
        var after;
        var open;
        var close;
        if (code === marker) {
            effects.consume(code);
            return sequence;
        }
        token = effects.exit('attentionSequence');
        after = classifyCharacter(code);
        open = !after || after === 2 && before;
        close = !before || before === 2 && after;
        token._open = marker === 42 ? open : open && (before || !close);
        token._close = marker === 42 ? close : close && (after || !open);
        return ok(code);
    }
}
module.exports = attention;

},{"2f2733da21298616":"8DQMZ","cb36a13ec89e7464":"dXntd","ea90f9e55fce8a10":"lUfbP","ba273f97a276227d":"7LzSH","aabdb4dbde3e0e3c":"lIGEx","cb58d02c223295a1":"aBApX"}],"lUfbP":[function(require,module,exports,__globalThis) {
'use strict';
var markdownLineEndingOrSpace = require("be2a2c2e73a68183");
var unicodePunctuation = require("d4ba3f468d037ac0");
var unicodeWhitespace = require("ef4bb056d3eebad0");
// Classify whether a character is unicode whitespace, unicode punctuation, or
// anything else.
// Used for attention (emphasis, strong), whose sequences can open or close
// based on the class of surrounding characters.
function classifyCharacter(code) {
    if (code === null || markdownLineEndingOrSpace(code) || unicodeWhitespace(code)) return 1;
    if (unicodePunctuation(code)) return 2;
}
module.exports = classifyCharacter;

},{"be2a2c2e73a68183":"73vQs","d4ba3f468d037ac0":"f8iPV","ef4bb056d3eebad0":"h01cg"}],"73vQs":[function(require,module,exports,__globalThis) {
'use strict';
function markdownLineEndingOrSpace(code) {
    return code < 0 || code === 32;
}
module.exports = markdownLineEndingOrSpace;

},{}],"f8iPV":[function(require,module,exports,__globalThis) {
'use strict';
var unicodePunctuationRegex = require("9860b62a6fb1abdf");
var regexCheck = require("520e348155e3c07");
// In fact adds to the bundle size.
var unicodePunctuation = regexCheck(unicodePunctuationRegex);
module.exports = unicodePunctuation;

},{"9860b62a6fb1abdf":"9ODSs","520e348155e3c07":"8ps1h"}],"9ODSs":[function(require,module,exports,__globalThis) {
'use strict';
// This module is generated by `script/`.
//
// CommonMark handles attention (emphasis, strong) markers based on what comes
// before or after them.
// One such difference is if those characters are Unicode punctuation.
// This script is generated from the Unicode data.
var unicodePunctuation = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;
module.exports = unicodePunctuation;

},{}],"8ps1h":[function(require,module,exports,__globalThis) {
'use strict';
var fromCharCode = require("15f3f90bc73afe23");
function regexCheck(regex) {
    return check;
    function check(code) {
        return regex.test(fromCharCode(code));
    }
}
module.exports = regexCheck;

},{"15f3f90bc73afe23":"8MefB"}],"h01cg":[function(require,module,exports,__globalThis) {
'use strict';
var regexCheck = require("64099d10139abc3");
var unicodeWhitespace = regexCheck(/\s/);
module.exports = unicodeWhitespace;

},{"64099d10139abc3":"8ps1h"}],"7LzSH":[function(require,module,exports,__globalThis) {
'use strict';
// chunks (replacement characters, tabs, or line endings).
function movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
    return point;
}
module.exports = movePoint;

},{}],"hsDhF":[function(require,module,exports,__globalThis) {
'use strict';
var asciiAlpha = require("5b79f1fbda0f037e");
var asciiAlphanumeric = require("78180712f7476985");
var asciiAtext = require("bfbf961301204d8b");
var asciiControl = require("b37fddd6c7c0804c");
var autolink = {
    name: 'autolink',
    tokenize: tokenizeAutolink
};
function tokenizeAutolink(effects, ok, nok) {
    var size = 1;
    return start;
    function start(code) {
        effects.enter('autolink');
        effects.enter('autolinkMarker');
        effects.consume(code);
        effects.exit('autolinkMarker');
        effects.enter('autolinkProtocol');
        return open;
    }
    function open(code) {
        if (asciiAlpha(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        return asciiAtext(code) ? emailAtext(code) : nok(code);
    }
    function schemeOrEmailAtext(code) {
        return code === 43 || code === 45 || code === 46 || asciiAlphanumeric(code) ? schemeInsideOrEmailAtext(code) : emailAtext(code);
    }
    function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            return urlInside;
        }
        if ((code === 43 || code === 45 || code === 46 || asciiAlphanumeric(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        return emailAtext(code);
    }
    function urlInside(code) {
        if (code === 62) {
            effects.exit('autolinkProtocol');
            return end(code);
        }
        if (code === 32 || code === 60 || asciiControl(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (asciiAtext(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    function emailAtSignOrDot(code) {
        return asciiAlphanumeric(code) ? emailLabel(code) : nok(code);
    }
    function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the type.
            effects.exit('autolinkProtocol').type = 'autolinkEmail';
            return end(code);
        }
        return emailValue(code);
    }
    function emailValue(code) {
        if ((code === 45 || asciiAlphanumeric(code)) && size++ < 63) {
            effects.consume(code);
            return code === 45 ? emailValue : emailLabel;
        }
        return nok(code);
    }
    function end(code) {
        effects.enter('autolinkMarker');
        effects.consume(code);
        effects.exit('autolinkMarker');
        effects.exit('autolink');
        return ok;
    }
}
module.exports = autolink;

},{"5b79f1fbda0f037e":"JyKN0","78180712f7476985":"iEUqG","bfbf961301204d8b":"cYhhe","b37fddd6c7c0804c":"a3AmJ"}],"JyKN0":[function(require,module,exports,__globalThis) {
'use strict';
var regexCheck = require("b62c0bc74a6fee61");
var asciiAlpha = regexCheck(/[A-Za-z]/);
module.exports = asciiAlpha;

},{"b62c0bc74a6fee61":"8ps1h"}],"iEUqG":[function(require,module,exports,__globalThis) {
'use strict';
var regexCheck = require("2a341f343b2fbab");
var asciiAlphanumeric = regexCheck(/[\dA-Za-z]/);
module.exports = asciiAlphanumeric;

},{"2a341f343b2fbab":"8ps1h"}],"cYhhe":[function(require,module,exports,__globalThis) {
'use strict';
var regexCheck = require("5038d24362dbc134");
var asciiAtext = regexCheck(/[#-'*+\--9=?A-Z^-~]/);
module.exports = asciiAtext;

},{"5038d24362dbc134":"8ps1h"}],"a3AmJ":[function(require,module,exports,__globalThis) {
'use strict';
// Note: EOF is seen as ASCII control here, because `null < 32 == true`.
function asciiControl(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code < 32 || code === 127);
}
module.exports = asciiControl;

},{}],"9pwQk":[function(require,module,exports,__globalThis) {
'use strict';
var markdownSpace = require("a5010d6e0f3b7512");
var factorySpace = require("d610ee4a9f6f868b");
var blockQuote = {
    name: 'blockQuote',
    tokenize: tokenizeBlockQuoteStart,
    continuation: {
        tokenize: tokenizeBlockQuoteContinuation
    },
    exit: exit
};
function tokenizeBlockQuoteStart(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        if (code === 62) {
            if (!self.containerState.open) {
                effects.enter('blockQuote', {
                    _container: true
                });
                self.containerState.open = true;
            }
            effects.enter('blockQuotePrefix');
            effects.enter('blockQuoteMarker');
            effects.consume(code);
            effects.exit('blockQuoteMarker');
            return after;
        }
        return nok(code);
    }
    function after(code) {
        if (markdownSpace(code)) {
            effects.enter('blockQuotePrefixWhitespace');
            effects.consume(code);
            effects.exit('blockQuotePrefixWhitespace');
            effects.exit('blockQuotePrefix');
            return ok;
        }
        effects.exit('blockQuotePrefix');
        return ok(code);
    }
}
function tokenizeBlockQuoteContinuation(effects, ok, nok) {
    return factorySpace(effects, effects.attempt(blockQuote, ok, nok), 'linePrefix', this.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4);
}
function exit(effects) {
    effects.exit('blockQuote');
}
module.exports = blockQuote;

},{"a5010d6e0f3b7512":"kZ8rl","d610ee4a9f6f868b":"2joBs"}],"2ZrdU":[function(require,module,exports,__globalThis) {
'use strict';
var asciiPunctuation = require("73ad28d7951e1448");
var characterEscape = {
    name: 'characterEscape',
    tokenize: tokenizeCharacterEscape
};
function tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    function start(code) {
        effects.enter('characterEscape');
        effects.enter('escapeMarker');
        effects.consume(code);
        effects.exit('escapeMarker');
        return open;
    }
    function open(code) {
        if (asciiPunctuation(code)) {
            effects.enter('characterEscapeValue');
            effects.consume(code);
            effects.exit('characterEscapeValue');
            effects.exit('characterEscape');
            return ok;
        }
        return nok(code);
    }
}
module.exports = characterEscape;

},{"73ad28d7951e1448":"8m5QA"}],"8m5QA":[function(require,module,exports,__globalThis) {
'use strict';
var regexCheck = require("eafb6203b7405216");
var asciiPunctuation = regexCheck(/[!-/:-@[-`{-~]/);
module.exports = asciiPunctuation;

},{"eafb6203b7405216":"8ps1h"}],"4iskv":[function(require,module,exports,__globalThis) {
'use strict';
var decodeEntity = require("fba4bec0f7e2e237");
var asciiAlphanumeric = require("b3a7ecd421f3d25d");
var asciiDigit = require("142970ac78f9cd4c");
var asciiHexDigit = require("b660ec6e67601f2");
function _interopDefaultLegacy(e) {
    return e && typeof e === 'object' && 'default' in e ? e : {
        default: e
    };
}
var decodeEntity__default = /*#__PURE__*/ _interopDefaultLegacy(decodeEntity);
var characterReference = {
    name: 'characterReference',
    tokenize: tokenizeCharacterReference
};
function tokenizeCharacterReference(effects, ok, nok) {
    var self = this;
    var size = 0;
    var max;
    var test;
    return start;
    function start(code) {
        effects.enter('characterReference');
        effects.enter('characterReferenceMarker');
        effects.consume(code);
        effects.exit('characterReferenceMarker');
        return open;
    }
    function open(code) {
        if (code === 35) {
            effects.enter('characterReferenceMarkerNumeric');
            effects.consume(code);
            effects.exit('characterReferenceMarkerNumeric');
            return numeric;
        }
        effects.enter('characterReferenceValue');
        max = 31;
        test = asciiAlphanumeric;
        return value(code);
    }
    function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter('characterReferenceMarkerHexadecimal');
            effects.consume(code);
            effects.exit('characterReferenceMarkerHexadecimal');
            effects.enter('characterReferenceValue');
            max = 6;
            test = asciiHexDigit;
            return value;
        }
        effects.enter('characterReferenceValue');
        max = 7;
        test = asciiDigit;
        return value(code);
    }
    function value(code) {
        var token;
        if (code === 59 && size) {
            token = effects.exit('characterReferenceValue');
            if (test === asciiAlphanumeric && !decodeEntity__default['default'](self.sliceSerialize(token))) return nok(code);
            effects.enter('characterReferenceMarker');
            effects.consume(code);
            effects.exit('characterReferenceMarker');
            effects.exit('characterReference');
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}
module.exports = characterReference;

},{"fba4bec0f7e2e237":"lBpfH","b3a7ecd421f3d25d":"iEUqG","142970ac78f9cd4c":"qGieJ","b660ec6e67601f2":"94IZg"}],"lBpfH":[function(require,module,exports,__globalThis) {
'use strict';
/* eslint-env browser */ var el;
var semicolon = 59 //  ';'
;
module.exports = decodeEntity;
function decodeEntity(characters) {
    var entity = '&' + characters + ';';
    var char;
    el = el || document.createElement('i');
    el.innerHTML = entity;
    char = el.textContent;
    // Some entities do not require the closing semicolon (`&not` - for instance),
    // which leads to situations where parsing the assumed entity of &notit; will
    // result in the string `¬it;`.  When we encounter a trailing semicolon after
    // parsing and the entity to decode was not a semicolon (`&semi;`), we can
    // assume that the matching was incomplete
    if (char.charCodeAt(char.length - 1) === semicolon && characters !== 'semi') return false;
    // If the decoded string is equal to the input, the entity was not valid
    return char === entity ? false : char;
}

},{}],"qGieJ":[function(require,module,exports,__globalThis) {
'use strict';
var regexCheck = require("98b6e89eb052918d");
var asciiDigit = regexCheck(/\d/);
module.exports = asciiDigit;

},{"98b6e89eb052918d":"8ps1h"}],"94IZg":[function(require,module,exports,__globalThis) {
'use strict';
var regexCheck = require("6096ff532afdc90b");
var asciiHexDigit = regexCheck(/[\dA-Fa-f]/);
module.exports = asciiHexDigit;

},{"6096ff532afdc90b":"8ps1h"}],"ixotb":[function(require,module,exports,__globalThis) {
'use strict';
var markdownLineEnding = require("dee14131325f9e7c");
var markdownLineEndingOrSpace = require("badea6c99f99c877");
var prefixSize = require("7046c0d90745a717");
var factorySpace = require("c29eca74da52934b");
var codeFenced = {
    name: 'codeFenced',
    tokenize: tokenizeCodeFenced,
    concrete: true
};
function tokenizeCodeFenced(effects, ok, nok) {
    var self = this;
    var closingFenceConstruct = {
        tokenize: tokenizeClosingFence,
        partial: true
    };
    var initialPrefix = prefixSize(this.events, 'linePrefix');
    var sizeOpen = 0;
    var marker;
    return start;
    function start(code) {
        effects.enter('codeFenced');
        effects.enter('codeFencedFence');
        effects.enter('codeFencedFenceSequence');
        marker = code;
        return sequenceOpen(code);
    }
    function sequenceOpen(code) {
        if (code === marker) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit('codeFencedFenceSequence');
        return sizeOpen < 3 ? nok(code) : factorySpace(effects, infoOpen, 'whitespace')(code);
    }
    function infoOpen(code) {
        if (code === null || markdownLineEnding(code)) return openAfter(code);
        effects.enter('codeFencedFenceInfo');
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return info(code);
    }
    function info(code) {
        if (code === null || markdownLineEndingOrSpace(code)) {
            effects.exit('chunkString');
            effects.exit('codeFencedFenceInfo');
            return factorySpace(effects, infoAfter, 'whitespace')(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    function infoAfter(code) {
        if (code === null || markdownLineEnding(code)) return openAfter(code);
        effects.enter('codeFencedFenceMeta');
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return meta(code);
    }
    function meta(code) {
        if (code === null || markdownLineEnding(code)) {
            effects.exit('chunkString');
            effects.exit('codeFencedFenceMeta');
            return openAfter(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    function openAfter(code) {
        effects.exit('codeFencedFence');
        return self.interrupt ? ok(code) : content(code);
    }
    function content(code) {
        if (code === null) return after(code);
        if (markdownLineEnding(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return effects.attempt(closingFenceConstruct, after, initialPrefix ? factorySpace(effects, content, 'linePrefix', initialPrefix + 1) : content);
        }
        effects.enter('codeFlowValue');
        return contentContinue(code);
    }
    function contentContinue(code) {
        if (code === null || markdownLineEnding(code)) {
            effects.exit('codeFlowValue');
            return content(code);
        }
        effects.consume(code);
        return contentContinue;
    }
    function after(code) {
        effects.exit('codeFenced');
        return ok(code);
    }
    function tokenizeClosingFence(effects, ok, nok) {
        var size = 0;
        return factorySpace(effects, closingSequenceStart, 'linePrefix', this.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4);
        function closingSequenceStart(code) {
            effects.enter('codeFencedFence');
            effects.enter('codeFencedFenceSequence');
            return closingSequence(code);
        }
        function closingSequence(code) {
            if (code === marker) {
                effects.consume(code);
                size++;
                return closingSequence;
            }
            if (size < sizeOpen) return nok(code);
            effects.exit('codeFencedFenceSequence');
            return factorySpace(effects, closingSequenceEnd, 'whitespace')(code);
        }
        function closingSequenceEnd(code) {
            if (code === null || markdownLineEnding(code)) {
                effects.exit('codeFencedFence');
                return ok(code);
            }
            return nok(code);
        }
    }
}
module.exports = codeFenced;

},{"dee14131325f9e7c":"gpLlx","badea6c99f99c877":"73vQs","7046c0d90745a717":"25mY2","c29eca74da52934b":"2joBs"}],"5eaGA":[function(require,module,exports,__globalThis) {
'use strict';
var markdownLineEnding = require("e085d03ab1103d97");
var chunkedSplice = require("6f308c94d19d1b89");
var prefixSize = require("e668f8182ac9018d");
var factorySpace = require("71f5ad8055fc1aad");
var codeIndented = {
    name: 'codeIndented',
    tokenize: tokenizeCodeIndented,
    resolve: resolveCodeIndented
};
var indentedContentConstruct = {
    tokenize: tokenizeIndentedContent,
    partial: true
};
function resolveCodeIndented(events, context) {
    var code = {
        type: 'codeIndented',
        start: events[0][1].start,
        end: events[events.length - 1][1].end
    };
    chunkedSplice(events, 0, 0, [
        [
            'enter',
            code,
            context
        ]
    ]);
    chunkedSplice(events, events.length, 0, [
        [
            'exit',
            code,
            context
        ]
    ]);
    return events;
}
function tokenizeCodeIndented(effects, ok, nok) {
    return effects.attempt(indentedContentConstruct, afterPrefix, nok);
    function afterPrefix(code) {
        if (code === null) return ok(code);
        if (markdownLineEnding(code)) return effects.attempt(indentedContentConstruct, afterPrefix, ok)(code);
        effects.enter('codeFlowValue');
        return content(code);
    }
    function content(code) {
        if (code === null || markdownLineEnding(code)) {
            effects.exit('codeFlowValue');
            return afterPrefix(code);
        }
        effects.consume(code);
        return content;
    }
}
function tokenizeIndentedContent(effects, ok, nok) {
    var self = this;
    return factorySpace(effects, afterPrefix, 'linePrefix', 5);
    function afterPrefix(code) {
        if (markdownLineEnding(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return factorySpace(effects, afterPrefix, 'linePrefix', 5);
        }
        return prefixSize(self.events, 'linePrefix') < 4 ? nok(code) : ok(code);
    }
}
module.exports = codeIndented;

},{"e085d03ab1103d97":"gpLlx","6f308c94d19d1b89":"dXntd","e668f8182ac9018d":"25mY2","71f5ad8055fc1aad":"2joBs"}],"4AquI":[function(require,module,exports,__globalThis) {
'use strict';
var markdownLineEnding = require("b27602e976c058b6");
var codeText = {
    name: 'codeText',
    tokenize: tokenizeCodeText,
    resolve: resolveCodeText,
    previous: previous
};
function resolveCodeText(events) {
    var tailExitIndex = events.length - 4;
    var headEnterIndex = 3;
    var index;
    var enter // If we start and end with an EOL or a space.
    ;
    if ((events[headEnterIndex][1].type === 'lineEnding' || events[headEnterIndex][1].type === 'space') && (events[tailExitIndex][1].type === 'lineEnding' || events[tailExitIndex][1].type === 'space')) {
        index = headEnterIndex // And we have data.
        ;
        while(++index < tailExitIndex)if (events[index][1].type === 'codeTextData') {
            // Then we have padding.
            events[tailExitIndex][1].type = events[headEnterIndex][1].type = 'codeTextPadding';
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    } // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== 'lineEnding') enter = index;
        } else if (index === tailExitIndex || events[index][1].type === 'lineEnding') {
            events[enter][1].type = 'codeTextData';
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
function previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === 'characterEscape';
}
function tokenizeCodeText(effects, ok, nok) {
    var sizeOpen = 0;
    var size;
    var token;
    return start;
    function start(code) {
        effects.enter('codeText');
        effects.enter('codeTextSequence');
        return openingSequence(code);
    }
    function openingSequence(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return openingSequence;
        }
        effects.exit('codeTextSequence');
        return gap(code);
    }
    function gap(code) {
        // EOF.
        if (code === null) return nok(code);
         // Closing fence?
        // Could also be data.
        if (code === 96) {
            token = effects.enter('codeTextSequence');
            size = 0;
            return closingSequence(code);
        } // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter('space');
            effects.consume(code);
            effects.exit('space');
            return gap;
        }
        if (markdownLineEnding(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return gap;
        } // Data.
        effects.enter('codeTextData');
        return data(code);
    } // In code.
    function data(code) {
        if (code === null || code === 32 || code === 96 || markdownLineEnding(code)) {
            effects.exit('codeTextData');
            return gap(code);
        }
        effects.consume(code);
        return data;
    } // Closing fence.
    function closingSequence(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return closingSequence;
        } // Done!
        if (size === sizeOpen) {
            effects.exit('codeTextSequence');
            effects.exit('codeText');
            return ok(code);
        } // More or less accents: mark as data.
        token.type = 'codeTextData';
        return data(code);
    }
}
module.exports = codeText;

},{"b27602e976c058b6":"gpLlx"}],"hKYnF":[function(require,module,exports,__globalThis) {
'use strict';
var markdownLineEnding = require("e4a65424822f0d9e");
var markdownLineEndingOrSpace = require("588ea1e2983c732f");
var normalizeIdentifier = require("b140e02e4ce0e8e5");
var factoryDestination = require("3331813336efba");
var factoryLabel = require("a7e84828c98999bc");
var factorySpace = require("b16958abd0fd7f5a");
var factoryWhitespace = require("63639865610f1659");
var factoryTitle = require("8a3255ef56dcac91");
var definition = {
    name: 'definition',
    tokenize: tokenizeDefinition
};
var titleConstruct = {
    tokenize: tokenizeTitle,
    partial: true
};
function tokenizeDefinition(effects, ok, nok) {
    var self = this;
    var identifier;
    return start;
    function start(code) {
        effects.enter('definition');
        return factoryLabel.call(self, effects, labelAfter, nok, 'definitionLabel', 'definitionLabelMarker', 'definitionLabelString')(code);
    }
    function labelAfter(code) {
        identifier = normalizeIdentifier(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter('definitionMarker');
            effects.consume(code);
            effects.exit('definitionMarker') // Note: blank lines can’t exist in content.
            ;
            return factoryWhitespace(effects, factoryDestination(effects, effects.attempt(titleConstruct, factorySpace(effects, after, 'whitespace'), factorySpace(effects, after, 'whitespace')), nok, 'definitionDestination', 'definitionDestinationLiteral', 'definitionDestinationLiteralMarker', 'definitionDestinationRaw', 'definitionDestinationString'));
        }
        return nok(code);
    }
    function after(code) {
        if (code === null || markdownLineEnding(code)) {
            effects.exit('definition');
            if (self.parser.defined.indexOf(identifier) < 0) self.parser.defined.push(identifier);
            return ok(code);
        }
        return nok(code);
    }
}
function tokenizeTitle(effects, ok, nok) {
    return start;
    function start(code) {
        return markdownLineEndingOrSpace(code) ? factoryWhitespace(effects, before)(code) : nok(code);
    }
    function before(code) {
        if (code === 34 || code === 39 || code === 40) return factoryTitle(effects, factorySpace(effects, after, 'whitespace'), nok, 'definitionTitle', 'definitionTitleMarker', 'definitionTitleString')(code);
        return nok(code);
    }
    function after(code) {
        return code === null || markdownLineEnding(code) ? ok(code) : nok(code);
    }
}
module.exports = definition;

},{"e4a65424822f0d9e":"gpLlx","588ea1e2983c732f":"73vQs","b140e02e4ce0e8e5":"jdlZ5","3331813336efba":"bwg29","a7e84828c98999bc":"11mPz","b16958abd0fd7f5a":"2joBs","63639865610f1659":"27tog","8a3255ef56dcac91":"bpNWm"}],"bwg29":[function(require,module,exports,__globalThis) {
'use strict';
var asciiControl = require("b371f81eff55970b");
var markdownLineEndingOrSpace = require("ecac046ae3b970de");
var markdownLineEnding = require("eb54855cc5998205");
// eslint-disable-next-line max-params
function destinationFactory(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    var limit = max || Infinity;
    var balance = 0;
    return start;
    function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return destinationEnclosedBefore;
        }
        if (asciiControl(code) || code === 41) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return destinationRaw(code);
    }
    function destinationEnclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return destinationEnclosed(code);
    }
    function destinationEnclosed(code) {
        if (code === 62) {
            effects.exit('chunkString');
            effects.exit(stringType);
            return destinationEnclosedBefore(code);
        }
        if (code === null || code === 60 || markdownLineEnding(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? destinationEnclosedEscape : destinationEnclosed;
    }
    function destinationEnclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return destinationEnclosed;
        }
        return destinationEnclosed(code);
    }
    function destinationRaw(code) {
        if (code === 40) {
            if (++balance > limit) return nok(code);
            effects.consume(code);
            return destinationRaw;
        }
        if (code === 41) {
            if (!balance--) {
                effects.exit('chunkString');
                effects.exit(stringType);
                effects.exit(rawType);
                effects.exit(type);
                return ok(code);
            }
            effects.consume(code);
            return destinationRaw;
        }
        if (code === null || markdownLineEndingOrSpace(code)) {
            if (balance) return nok(code);
            effects.exit('chunkString');
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if (asciiControl(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? destinationRawEscape : destinationRaw;
    }
    function destinationRawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return destinationRaw;
        }
        return destinationRaw(code);
    }
}
module.exports = destinationFactory;

},{"b371f81eff55970b":"a3AmJ","ecac046ae3b970de":"73vQs","eb54855cc5998205":"gpLlx"}],"11mPz":[function(require,module,exports,__globalThis) {
'use strict';
var markdownLineEnding = require("ab2405c045144443");
var markdownSpace = require("53fbea239ecbc88");
// eslint-disable-next-line max-params
function labelFactory(effects, ok, nok, type, markerType, stringType) {
    var self = this;
    var size = 0;
    var data;
    return start;
    function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    function atBreak(code) {
        if (code === null || code === 91 || code === 93 && !data || /* c8 ignore next */ code === 94 && /* c8 ignore next */ !size && /* c8 ignore next */ '_hiddenFootnoteSupport' in self.parser.constructs || size > 999) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        if (markdownLineEnding(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return atBreak;
        }
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return label(code);
    }
    function label(code) {
        if (code === null || code === 91 || code === 93 || markdownLineEnding(code) || size++ > 999) {
            effects.exit('chunkString');
            return atBreak(code);
        }
        effects.consume(code);
        data = data || !markdownSpace(code);
        return code === 92 ? labelEscape : label;
    }
    function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return label;
        }
        return label(code);
    }
}
module.exports = labelFactory;

},{"ab2405c045144443":"gpLlx","53fbea239ecbc88":"kZ8rl"}],"27tog":[function(require,module,exports,__globalThis) {
'use strict';
var markdownLineEnding = require("4f1a5113e30afc09");
var markdownSpace = require("a99f5efa00d99f0a");
var factorySpace = require("34c5e2ccb8e39f9");
function whitespaceFactory(effects, ok) {
    var seen;
    return start;
    function start(code) {
        if (markdownLineEnding(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            seen = true;
            return start;
        }
        if (markdownSpace(code)) return factorySpace(effects, start, seen ? 'linePrefix' : 'lineSuffix')(code);
        return ok(code);
    }
}
module.exports = whitespaceFactory;

},{"4f1a5113e30afc09":"gpLlx","a99f5efa00d99f0a":"kZ8rl","34c5e2ccb8e39f9":"2joBs"}],"bpNWm":[function(require,module,exports,__globalThis) {
'use strict';
var markdownLineEnding = require("9faba73480572925");
var factorySpace = require("184f869f20c1936");
function titleFactory(effects, ok, nok, type, markerType, stringType) {
    var marker;
    return start;
    function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        marker = code === 40 ? 41 : code;
        return atFirstTitleBreak;
    }
    function atFirstTitleBreak(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atTitleBreak(code);
    }
    function atTitleBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return atFirstTitleBreak(marker);
        }
        if (code === null) return nok(code);
         // Note: blank lines can’t exist in content.
        if (markdownLineEnding(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return factorySpace(effects, atTitleBreak, 'linePrefix');
        }
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return title(code);
    }
    function title(code) {
        if (code === marker || code === null || markdownLineEnding(code)) {
            effects.exit('chunkString');
            return atTitleBreak(code);
        }
        effects.consume(code);
        return code === 92 ? titleEscape : title;
    }
    function titleEscape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return title;
        }
        return title(code);
    }
}
module.exports = titleFactory;

},{"9faba73480572925":"gpLlx","184f869f20c1936":"2joBs"}],"euVl1":[function(require,module,exports,__globalThis) {
'use strict';
var markdownLineEnding = require("456093a3a068c14f");
var hardBreakEscape = {
    name: 'hardBreakEscape',
    tokenize: tokenizeHardBreakEscape
};
function tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    function start(code) {
        effects.enter('hardBreakEscape');
        effects.enter('escapeMarker');
        effects.consume(code);
        return open;
    }
    function open(code) {
        if (markdownLineEnding(code)) {
            effects.exit('escapeMarker');
            effects.exit('hardBreakEscape');
            return ok(code);
        }
        return nok(code);
    }
}
module.exports = hardBreakEscape;

},{"456093a3a068c14f":"gpLlx"}],"9GaUz":[function(require,module,exports,__globalThis) {
'use strict';
var markdownLineEnding = require("43dcbb1d1726dbb5");
var markdownLineEndingOrSpace = require("d548ade5ec5c2a09");
var markdownSpace = require("a7a36608f416361e");
var chunkedSplice = require("5bde2185f1ef54da");
var factorySpace = require("e2f8f554e1c3c877");
var headingAtx = {
    name: 'headingAtx',
    tokenize: tokenizeHeadingAtx,
    resolve: resolveHeadingAtx
};
function resolveHeadingAtx(events, context) {
    var contentEnd = events.length - 2;
    var contentStart = 3;
    var content;
    var text // Prefix whitespace, part of the opening.
    ;
    if (events[contentStart][1].type === 'whitespace') contentStart += 2;
     // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === 'whitespace') contentEnd -= 2;
    if (events[contentEnd][1].type === 'atxHeadingSequence' && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === 'whitespace')) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: 'atxHeadingText',
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: 'chunkText',
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: 'text'
        };
        chunkedSplice(events, contentStart, contentEnd - contentStart + 1, [
            [
                'enter',
                content,
                context
            ],
            [
                'enter',
                text,
                context
            ],
            [
                'exit',
                text,
                context
            ],
            [
                'exit',
                content,
                context
            ]
        ]);
    }
    return events;
}
function tokenizeHeadingAtx(effects, ok, nok) {
    var self = this;
    var size = 0;
    return start;
    function start(code) {
        effects.enter('atxHeading');
        effects.enter('atxHeadingSequence');
        return fenceOpenInside(code);
    }
    function fenceOpenInside(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return fenceOpenInside;
        }
        if (code === null || markdownLineEndingOrSpace(code)) {
            effects.exit('atxHeadingSequence');
            return self.interrupt ? ok(code) : headingBreak(code);
        }
        return nok(code);
    }
    function headingBreak(code) {
        if (code === 35) {
            effects.enter('atxHeadingSequence');
            return sequence(code);
        }
        if (code === null || markdownLineEnding(code)) {
            effects.exit('atxHeading');
            return ok(code);
        }
        if (markdownSpace(code)) return factorySpace(effects, headingBreak, 'whitespace')(code);
        effects.enter('atxHeadingText');
        return data(code);
    }
    function sequence(code) {
        if (code === 35) {
            effects.consume(code);
            return sequence;
        }
        effects.exit('atxHeadingSequence');
        return headingBreak(code);
    }
    function data(code) {
        if (code === null || code === 35 || markdownLineEndingOrSpace(code)) {
            effects.exit('atxHeadingText');
            return headingBreak(code);
        }
        effects.consume(code);
        return data;
    }
}
module.exports = headingAtx;

},{"43dcbb1d1726dbb5":"gpLlx","d548ade5ec5c2a09":"73vQs","a7a36608f416361e":"kZ8rl","5bde2185f1ef54da":"dXntd","e2f8f554e1c3c877":"2joBs"}],"30C6k":[function(require,module,exports,__globalThis) {
'use strict';
var asciiAlpha = require("1f2f36d4c3a2c109");
var asciiAlphanumeric = require("551cde8811cc48dd");
var markdownLineEnding = require("765e976f03ec1447");
var markdownLineEndingOrSpace = require("23125ebda3d2501c");
var markdownSpace = require("28574965cc221c7e");
var fromCharCode = require("f72d495e6cea3a6a");
var htmlBlockNames = require("f54c24617d0d5ef9");
var htmlRawNames = require("54d5c52b6451a18d");
var partialBlankLine = require("145f646c8474a7ef");
var htmlFlow = {
    name: 'htmlFlow',
    tokenize: tokenizeHtmlFlow,
    resolveTo: resolveToHtmlFlow,
    concrete: true
};
var nextBlankConstruct = {
    tokenize: tokenizeNextBlank,
    partial: true
};
function resolveToHtmlFlow(events) {
    var index = events.length;
    while(index--){
        if (events[index][0] === 'enter' && events[index][1].type === 'htmlFlow') break;
    }
    if (index > 1 && events[index - 2][1].type === 'linePrefix') {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start // Add the prefix start to the HTML line token.
        ;
        events[index + 1][1].start = events[index - 2][1].start // Remove the line prefix.
        ;
        events.splice(index - 2, 2);
    }
    return events;
}
function tokenizeHtmlFlow(effects, ok, nok) {
    var self = this;
    var kind;
    var startTag;
    var buffer;
    var index;
    var marker;
    return start;
    function start(code) {
        effects.enter('htmlFlow');
        effects.enter('htmlFlowData');
        effects.consume(code);
        return open;
    }
    function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationStart;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            kind = 3 // While we’re in an instruction instead of a declaration, we’re on a `?`
            ;
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        if (asciiAlpha(code)) {
            effects.consume(code);
            buffer = fromCharCode(code);
            startTag = true;
            return tagName;
        }
        return nok(code);
    }
    function declarationStart(code) {
        if (code === 45) {
            effects.consume(code);
            kind = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            kind = 5;
            buffer = 'CDATA[';
            index = 0;
            return cdataOpenInside;
        }
        if (asciiAlpha(code)) {
            effects.consume(code);
            kind = 4;
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    function cdataOpenInside(code) {
        if (code === buffer.charCodeAt(index++)) {
            effects.consume(code);
            return index === buffer.length ? self.interrupt ? ok : continuation : cdataOpenInside;
        }
        return nok(code);
    }
    function tagCloseStart(code) {
        if (asciiAlpha(code)) {
            effects.consume(code);
            buffer = fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    function tagName(code) {
        if (code === null || code === 47 || code === 62 || markdownLineEndingOrSpace(code)) {
            if (code !== 47 && startTag && htmlRawNames.indexOf(buffer.toLowerCase()) > -1) {
                kind = 1;
                return self.interrupt ? ok(code) : continuation(code);
            }
            if (htmlBlockNames.indexOf(buffer.toLowerCase()) > -1) {
                kind = 6;
                if (code === 47) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                return self.interrupt ? ok(code) : continuation(code);
            }
            kind = 7 // Do not support complete HTML when interrupting.
            ;
            return self.interrupt ? nok(code) : startTag ? completeAttributeNameBefore(code) : completeClosingTagAfter(code);
        }
        if (code === 45 || asciiAlphanumeric(code)) {
            effects.consume(code);
            buffer += fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    function completeClosingTagAfter(code) {
        if (markdownSpace(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        if (code === 58 || code === 95 || asciiAlpha(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if (markdownSpace(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    function completeAttributeName(code) {
        if (code === 45 || code === 46 || code === 58 || code === 95 || asciiAlphanumeric(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if (markdownSpace(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return completeAttributeValueQuoted;
        }
        if (markdownSpace(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        marker = undefined;
        return completeAttributeValueUnquoted(code);
    }
    function completeAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || markdownLineEnding(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 62 || code === 96 || markdownLineEndingOrSpace(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || markdownSpace(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    function completeAfter(code) {
        if (markdownSpace(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return code === null || markdownLineEnding(code) ? continuation(code) : nok(code);
    }
    function continuation(code) {
        if (code === 45 && kind === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && kind === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && kind === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && kind === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && kind === 5) {
            effects.consume(code);
            return continuationCharacterDataInside;
        }
        if (markdownLineEnding(code) && (kind === 6 || kind === 7)) return effects.check(nextBlankConstruct, continuationClose, continuationAtLineEnding)(code);
        if (code === null || markdownLineEnding(code)) return continuationAtLineEnding(code);
        effects.consume(code);
        return continuation;
    }
    function continuationAtLineEnding(code) {
        effects.exit('htmlFlowData');
        return htmlContinueStart(code);
    }
    function htmlContinueStart(code) {
        if (code === null) return done(code);
        if (markdownLineEnding(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return htmlContinueStart;
        }
        effects.enter('htmlFlowData');
        return continuation(code);
    }
    function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = '';
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    function continuationRawEndTag(code) {
        if (code === 62 && htmlRawNames.indexOf(buffer.toLowerCase()) > -1) {
            effects.consume(code);
            return continuationClose;
        }
        if (asciiAlpha(code) && buffer.length < 8) {
            effects.consume(code);
            buffer += fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    function continuationCharacterDataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        return continuation(code);
    }
    function continuationClose(code) {
        if (code === null || markdownLineEnding(code)) {
            effects.exit('htmlFlowData');
            return done(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    function done(code) {
        effects.exit('htmlFlow');
        return ok(code);
    }
}
function tokenizeNextBlank(effects, ok, nok) {
    return start;
    function start(code) {
        effects.exit('htmlFlowData');
        effects.enter('lineEndingBlank');
        effects.consume(code);
        effects.exit('lineEndingBlank');
        return effects.attempt(partialBlankLine, ok, nok);
    }
}
module.exports = htmlFlow;

},{"1f2f36d4c3a2c109":"JyKN0","551cde8811cc48dd":"iEUqG","765e976f03ec1447":"gpLlx","23125ebda3d2501c":"73vQs","28574965cc221c7e":"kZ8rl","f72d495e6cea3a6a":"8MefB","f54c24617d0d5ef9":"4ZyCP","54d5c52b6451a18d":"bquvi","145f646c8474a7ef":"2HIWv"}],"4ZyCP":[function(require,module,exports,__globalThis) {
'use strict';
// This module is copied from <https://spec.commonmark.org/0.29/#html-blocks>.
var basics = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'section',
    'source',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];
module.exports = basics;

},{}],"bquvi":[function(require,module,exports,__globalThis) {
'use strict';
// This module is copied from <https://spec.commonmark.org/0.29/#html-blocks>.
var raws = [
    'pre',
    'script',
    'style',
    'textarea'
];
module.exports = raws;

},{}],"a5uHi":[function(require,module,exports,__globalThis) {
'use strict';
var asciiAlpha = require("a46075a7bb5c2b17");
var asciiAlphanumeric = require("319cbf65e1ee4edb");
var markdownLineEnding = require("38897e2bc5b27eaf");
var markdownLineEndingOrSpace = require("d2e99d24113aa24");
var markdownSpace = require("8068040b0639b82a");
var factorySpace = require("91c737333abf2ec8");
var htmlText = {
    name: 'htmlText',
    tokenize: tokenizeHtmlText
};
function tokenizeHtmlText(effects, ok, nok) {
    var self = this;
    var marker;
    var buffer;
    var index;
    var returnState;
    return start;
    function start(code) {
        effects.enter('htmlText');
        effects.enter('htmlTextData');
        effects.consume(code);
        return open;
    }
    function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        if (asciiAlpha(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpen;
        }
        if (code === 91) {
            effects.consume(code);
            buffer = 'CDATA[';
            index = 0;
            return cdataOpen;
        }
        if (asciiAlpha(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    function commentOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentStart;
        }
        return nok(code);
    }
    function commentStart(code) {
        if (code === null || code === 62) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentStartDash;
        }
        return comment(code);
    }
    function commentStartDash(code) {
        if (code === null || code === 62) return nok(code);
        return comment(code);
    }
    function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if (markdownLineEnding(code)) {
            returnState = comment;
            return atLineEnding(code);
        }
        effects.consume(code);
        return comment;
    }
    function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return end;
        }
        return comment(code);
    }
    function cdataOpen(code) {
        if (code === buffer.charCodeAt(index++)) {
            effects.consume(code);
            return index === buffer.length ? cdata : cdataOpen;
        }
        return nok(code);
    }
    function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if (markdownLineEnding(code)) {
            returnState = cdata;
            return atLineEnding(code);
        }
        effects.consume(code);
        return cdata;
    }
    function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    function declaration(code) {
        if (code === null || code === 62) return end(code);
        if (markdownLineEnding(code)) {
            returnState = declaration;
            return atLineEnding(code);
        }
        effects.consume(code);
        return declaration;
    }
    function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if (markdownLineEnding(code)) {
            returnState = instruction;
            return atLineEnding(code);
        }
        effects.consume(code);
        return instruction;
    }
    function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    function tagCloseStart(code) {
        if (asciiAlpha(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    function tagClose(code) {
        if (code === 45 || asciiAlphanumeric(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    function tagCloseBetween(code) {
        if (markdownLineEnding(code)) {
            returnState = tagCloseBetween;
            return atLineEnding(code);
        }
        if (markdownSpace(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    function tagOpen(code) {
        if (code === 45 || asciiAlphanumeric(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || markdownLineEndingOrSpace(code)) return tagOpenBetween(code);
        return nok(code);
    }
    function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        if (code === 58 || code === 95 || asciiAlpha(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if (markdownLineEnding(code)) {
            returnState = tagOpenBetween;
            return atLineEnding(code);
        }
        if (markdownSpace(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    function tagOpenAttributeName(code) {
        if (code === 45 || code === 46 || code === 58 || code === 95 || asciiAlphanumeric(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if (markdownLineEnding(code)) {
            returnState = tagOpenAttributeNameAfter;
            return atLineEnding(code);
        }
        if (markdownSpace(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if (markdownLineEnding(code)) {
            returnState = tagOpenAttributeValueBefore;
            return atLineEnding(code);
        }
        if (markdownSpace(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        marker = undefined;
        return tagOpenAttributeValueUnquoted;
    }
    function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if (markdownLineEnding(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return atLineEnding(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 62 || code === 47 || markdownLineEndingOrSpace(code)) return tagOpenBetween(code);
        return nok(code);
    }
    function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 62 || markdownLineEndingOrSpace(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    } // We can’t have blank lines in content, so no need to worry about empty
    // tokens.
    function atLineEnding(code) {
        effects.exit('htmlTextData');
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return factorySpace(effects, afterPrefix, 'linePrefix', self.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4);
    }
    function afterPrefix(code) {
        effects.enter('htmlTextData');
        return returnState(code);
    }
    function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit('htmlTextData');
            effects.exit('htmlText');
            return ok;
        }
        return nok(code);
    }
}
module.exports = htmlText;

},{"a46075a7bb5c2b17":"JyKN0","319cbf65e1ee4edb":"iEUqG","38897e2bc5b27eaf":"gpLlx","d2e99d24113aa24":"73vQs","8068040b0639b82a":"kZ8rl","91c737333abf2ec8":"2joBs"}],"1zCGC":[function(require,module,exports,__globalThis) {
'use strict';
var markdownLineEndingOrSpace = require("747325955ff09448");
var chunkedPush = require("9c7b2f0c265ac198");
var chunkedSplice = require("d915b0fb0aca73f");
var normalizeIdentifier = require("8bf60a8f0d3fb2c0");
var resolveAll = require("124c6b7cfbec6525");
var shallow = require("f9ad09992a6c7aa1");
var factoryDestination = require("9c27f737b39408ed");
var factoryLabel = require("5c257b36b2628120");
var factoryTitle = require("2e488e3a98535a1");
var factoryWhitespace = require("a1227b1eb358c06f");
var labelEnd = {
    name: 'labelEnd',
    tokenize: tokenizeLabelEnd,
    resolveTo: resolveToLabelEnd,
    resolveAll: resolveAllLabelEnd
};
var resourceConstruct = {
    tokenize: tokenizeResource
};
var fullReferenceConstruct = {
    tokenize: tokenizeFullReference
};
var collapsedReferenceConstruct = {
    tokenize: tokenizeCollapsedReference
};
function resolveAllLabelEnd(events) {
    var index = -1;
    var token;
    while(++index < events.length){
        token = events[index][1];
        if (!token._used && (token.type === 'labelImage' || token.type === 'labelLink' || token.type === 'labelEnd')) {
            // Remove the marker.
            events.splice(index + 1, token.type === 'labelImage' ? 4 : 2);
            token.type = 'data';
            index++;
        }
    }
    return events;
}
function resolveToLabelEnd(events, context) {
    var index = events.length;
    var offset = 0;
    var group;
    var label;
    var text;
    var token;
    var open;
    var close;
    var media // Find an opening.
    ;
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === 'link' || token.type === 'labelLink' && token._inactive) break;
             // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === 'enter' && token.type === 'labelLink') token._inactive = true;
        } else if (close) {
            if (events[index][0] === 'enter' && (token.type === 'labelImage' || token.type === 'labelLink') && !token._balanced) {
                open = index;
                if (token.type !== 'labelLink') {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === 'labelEnd') close = index;
    }
    group = {
        type: events[open][1].type === 'labelLink' ? 'link' : 'image',
        start: shallow(events[open][1].start),
        end: shallow(events[events.length - 1][1].end)
    };
    label = {
        type: 'label',
        start: shallow(events[open][1].start),
        end: shallow(events[close][1].end)
    };
    text = {
        type: 'labelText',
        start: shallow(events[open + offset + 2][1].end),
        end: shallow(events[close - 2][1].start)
    };
    media = [
        [
            'enter',
            group,
            context
        ],
        [
            'enter',
            label,
            context
        ]
    ] // Opening marker.
    ;
    media = chunkedPush(media, events.slice(open + 1, open + offset + 3)) // Text open.
    ;
    media = chunkedPush(media, [
        [
            'enter',
            text,
            context
        ]
    ]) // Between.
    ;
    media = chunkedPush(media, resolveAll(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context)) // Text close, marker close, label close.
    ;
    media = chunkedPush(media, [
        [
            'exit',
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            'exit',
            label,
            context
        ]
    ]) // Reference, resource, or so.
    ;
    media = chunkedPush(media, events.slice(close + 1)) // Media close.
    ;
    media = chunkedPush(media, [
        [
            'exit',
            group,
            context
        ]
    ]);
    chunkedSplice(events, open, events.length, media);
    return events;
}
function tokenizeLabelEnd(effects, ok, nok) {
    var self = this;
    var index = self.events.length;
    var labelStart;
    var defined // Find an opening.
    ;
    while(index--)if ((self.events[index][1].type === 'labelImage' || self.events[index][1].type === 'labelLink') && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    function start(code) {
        if (!labelStart) return nok(code);
         // It’s a balanced bracket, but contains a link.
        if (labelStart._inactive) return balanced(code);
        defined = self.parser.defined.indexOf(normalizeIdentifier(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        }))) > -1;
        effects.enter('labelEnd');
        effects.enter('labelMarker');
        effects.consume(code);
        effects.exit('labelMarker');
        effects.exit('labelEnd');
        return afterLabelEnd;
    }
    function afterLabelEnd(code) {
        // Resource: `[asd](fgh)`.
        if (code === 40) return effects.attempt(resourceConstruct, ok, defined ? ok : balanced)(code);
         // Collapsed (`[asd][]`) or full (`[asd][fgh]`) reference?
        if (code === 91) return effects.attempt(fullReferenceConstruct, ok, defined ? effects.attempt(collapsedReferenceConstruct, ok, balanced) : balanced)(code);
         // Shortcut reference: `[asd]`?
        return defined ? ok(code) : balanced(code);
    }
    function balanced(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
function tokenizeResource(effects, ok, nok) {
    return start;
    function start(code) {
        effects.enter('resource');
        effects.enter('resourceMarker');
        effects.consume(code);
        effects.exit('resourceMarker');
        return factoryWhitespace(effects, open);
    }
    function open(code) {
        if (code === 41) return end(code);
        return factoryDestination(effects, destinationAfter, nok, 'resourceDestination', 'resourceDestinationLiteral', 'resourceDestinationLiteralMarker', 'resourceDestinationRaw', 'resourceDestinationString', 3)(code);
    }
    function destinationAfter(code) {
        return markdownLineEndingOrSpace(code) ? factoryWhitespace(effects, between)(code) : end(code);
    }
    function between(code) {
        if (code === 34 || code === 39 || code === 40) return factoryTitle(effects, factoryWhitespace(effects, end), nok, 'resourceTitle', 'resourceTitleMarker', 'resourceTitleString')(code);
        return end(code);
    }
    function end(code) {
        if (code === 41) {
            effects.enter('resourceMarker');
            effects.consume(code);
            effects.exit('resourceMarker');
            effects.exit('resource');
            return ok;
        }
        return nok(code);
    }
}
function tokenizeFullReference(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        return factoryLabel.call(self, effects, afterLabel, nok, 'reference', 'referenceMarker', 'referenceString')(code);
    }
    function afterLabel(code) {
        return self.parser.defined.indexOf(normalizeIdentifier(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) < 0 ? nok(code) : ok(code);
    }
}
function tokenizeCollapsedReference(effects, ok, nok) {
    return start;
    function start(code) {
        effects.enter('reference');
        effects.enter('referenceMarker');
        effects.consume(code);
        effects.exit('referenceMarker');
        return open;
    }
    function open(code) {
        if (code === 93) {
            effects.enter('referenceMarker');
            effects.consume(code);
            effects.exit('referenceMarker');
            effects.exit('reference');
            return ok;
        }
        return nok(code);
    }
}
module.exports = labelEnd;

},{"747325955ff09448":"73vQs","9c7b2f0c265ac198":"8DQMZ","d915b0fb0aca73f":"dXntd","8bf60a8f0d3fb2c0":"jdlZ5","124c6b7cfbec6525":"lIGEx","f9ad09992a6c7aa1":"aBApX","9c27f737b39408ed":"bwg29","5c257b36b2628120":"11mPz","2e488e3a98535a1":"bpNWm","a1227b1eb358c06f":"27tog"}],"37zEu":[function(require,module,exports,__globalThis) {
'use strict';
var labelEnd = require("56f483f0b9759f92");
var labelStartImage = {
    name: 'labelStartImage',
    tokenize: tokenizeLabelStartImage,
    resolveAll: labelEnd.resolveAll
};
function tokenizeLabelStartImage(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        effects.enter('labelImage');
        effects.enter('labelImageMarker');
        effects.consume(code);
        effects.exit('labelImageMarker');
        return open;
    }
    function open(code) {
        if (code === 91) {
            effects.enter('labelMarker');
            effects.consume(code);
            effects.exit('labelMarker');
            effects.exit('labelImage');
            return after;
        }
        return nok(code);
    }
    function after(code) {
        /* c8 ignore next */ return code === 94 && /* c8 ignore next */ '_hiddenFootnoteSupport' in self.parser.constructs ? /* c8 ignore next */ nok(code) : ok(code);
    }
}
module.exports = labelStartImage;

},{"56f483f0b9759f92":"1zCGC"}],"jn0bo":[function(require,module,exports,__globalThis) {
'use strict';
var labelEnd = require("4bc521e5b4e960d2");
var labelStartLink = {
    name: 'labelStartLink',
    tokenize: tokenizeLabelStartLink,
    resolveAll: labelEnd.resolveAll
};
function tokenizeLabelStartLink(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        effects.enter('labelLink');
        effects.enter('labelMarker');
        effects.consume(code);
        effects.exit('labelMarker');
        effects.exit('labelLink');
        return after;
    }
    function after(code) {
        /* c8 ignore next */ return code === 94 && /* c8 ignore next */ '_hiddenFootnoteSupport' in self.parser.constructs ? /* c8 ignore next */ nok(code) : ok(code);
    }
}
module.exports = labelStartLink;

},{"4bc521e5b4e960d2":"1zCGC"}],"beXlf":[function(require,module,exports,__globalThis) {
'use strict';
var factorySpace = require("c33b312c48d96763");
var lineEnding = {
    name: 'lineEnding',
    tokenize: tokenizeLineEnding
};
function tokenizeLineEnding(effects, ok) {
    return start;
    function start(code) {
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return factorySpace(effects, ok, 'linePrefix');
    }
}
module.exports = lineEnding;

},{"c33b312c48d96763":"2joBs"}],"9syVn":[function(require,module,exports,__globalThis) {
'use strict';
var asciiDigit = require("3c534ff2a3caed51");
var markdownSpace = require("2495119e88cff079");
var prefixSize = require("28e5ea86a0f176c");
var sizeChunks = require("73f88f031d96cef5");
var factorySpace = require("5611e9d6e7805a05");
var partialBlankLine = require("90c60d5d55df74f6");
var thematicBreak = require("22e6050913a9d8a2");
var list = {
    name: 'list',
    tokenize: tokenizeListStart,
    continuation: {
        tokenize: tokenizeListContinuation
    },
    exit: tokenizeListEnd
};
var listItemPrefixWhitespaceConstruct = {
    tokenize: tokenizeListItemPrefixWhitespace,
    partial: true
};
var indentConstruct = {
    tokenize: tokenizeIndent,
    partial: true
};
function tokenizeListStart(effects, ok, nok) {
    var self = this;
    var initialSize = prefixSize(self.events, 'linePrefix');
    var size = 0;
    return start;
    function start(code) {
        var kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? 'listUnordered' : 'listOrdered');
        if (kind === 'listUnordered' ? !self.containerState.marker || code === self.containerState.marker : asciiDigit(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === 'listUnordered') {
                effects.enter('listItemPrefix');
                return code === 42 || code === 45 ? effects.check(thematicBreak, nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter('listItemPrefix');
                effects.enter('listItemValue');
                return inside(code);
            }
        }
        return nok(code);
    }
    function inside(code) {
        if (asciiDigit(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit('listItemValue');
            return atMarker(code);
        }
        return nok(code);
    }
    function atMarker(code) {
        effects.enter('listItemMarker');
        effects.consume(code);
        effects.exit('listItemMarker');
        self.containerState.marker = self.containerState.marker || code;
        return effects.check(partialBlankLine, self.interrupt ? nok : onBlank, effects.attempt(listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    function otherPrefix(code) {
        if (markdownSpace(code)) {
            effects.enter('listItemPrefixWhitespace');
            effects.consume(code);
            effects.exit('listItemPrefixWhitespace');
            return endOfPrefix;
        }
        return nok(code);
    }
    function endOfPrefix(code) {
        self.containerState.size = initialSize + sizeChunks(self.sliceStream(effects.exit('listItemPrefix')));
        return ok(code);
    }
}
function tokenizeListContinuation(effects, ok, nok) {
    var self = this;
    self.containerState._closeFlow = undefined;
    return effects.check(partialBlankLine, onBlank, notBlank);
    function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine // We have a blank line.
        ;
        // Still, try to consume at most the items size.
        return factorySpace(effects, ok, 'listItemIndent', self.containerState.size + 1)(code);
    }
    function notBlank(code) {
        if (self.containerState.furtherBlankLines || !markdownSpace(code)) {
            self.containerState.furtherBlankLines = self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = self.containerState.initialBlankLine = undefined;
        return effects.attempt(indentConstruct, ok, notInCurrentItem)(code);
    }
    function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true // As we’re closing flow, we’re no longer interrupting.
        ;
        self.interrupt = undefined;
        return factorySpace(effects, effects.attempt(list, ok, nok), 'linePrefix', self.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 4)(code);
    }
}
function tokenizeIndent(effects, ok, nok) {
    var self = this;
    return factorySpace(effects, afterPrefix, 'listItemIndent', self.containerState.size + 1);
    function afterPrefix(code) {
        return prefixSize(self.events, 'listItemIndent') === self.containerState.size ? ok(code) : nok(code);
    }
}
function tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
function tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    var self = this;
    return factorySpace(effects, afterPrefix, 'listItemPrefixWhitespace', self.parser.constructs.disable.null.indexOf('codeIndented') > -1 ? undefined : 5);
    function afterPrefix(code) {
        return markdownSpace(code) || !prefixSize(self.events, 'listItemPrefixWhitespace') ? nok(code) : ok(code);
    }
}
module.exports = list;

},{"3c534ff2a3caed51":"qGieJ","2495119e88cff079":"kZ8rl","28e5ea86a0f176c":"25mY2","73f88f031d96cef5":"9VHnG","5611e9d6e7805a05":"2joBs","90c60d5d55df74f6":"2HIWv","22e6050913a9d8a2":"10agS"}],"10agS":[function(require,module,exports,__globalThis) {
'use strict';
var markdownLineEnding = require("4da76bd7ad864dce");
var markdownSpace = require("ac3ba44ad0504ba6");
var factorySpace = require("370d9c33ab47d76a");
var thematicBreak = {
    name: 'thematicBreak',
    tokenize: tokenizeThematicBreak
};
function tokenizeThematicBreak(effects, ok, nok) {
    var size = 0;
    var marker;
    return start;
    function start(code) {
        effects.enter('thematicBreak');
        marker = code;
        return atBreak(code);
    }
    function atBreak(code) {
        if (code === marker) {
            effects.enter('thematicBreakSequence');
            return sequence(code);
        }
        if (markdownSpace(code)) return factorySpace(effects, atBreak, 'whitespace')(code);
        if (size < 3 || code !== null && !markdownLineEnding(code)) return nok(code);
        effects.exit('thematicBreak');
        return ok(code);
    }
    function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit('thematicBreakSequence');
        return atBreak(code);
    }
}
module.exports = thematicBreak;

},{"4da76bd7ad864dce":"gpLlx","ac3ba44ad0504ba6":"kZ8rl","370d9c33ab47d76a":"2joBs"}],"jX2fX":[function(require,module,exports,__globalThis) {
'use strict';
var markdownLineEnding = require("d73ec61ed09c0d9f");
var shallow = require("a78ab758fe833a3a");
var factorySpace = require("dc1da414fa8aea68");
var setextUnderline = {
    name: 'setextUnderline',
    tokenize: tokenizeSetextUnderline,
    resolveTo: resolveToSetextUnderline
};
function resolveToSetextUnderline(events, context) {
    var index = events.length;
    var content;
    var text;
    var definition;
    var heading // Find the opening of the content.
    ;
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === 'enter') {
        if (events[index][1].type === 'content') {
            content = index;
            break;
        }
        if (events[index][1].type === 'paragraph') text = index;
    } else {
        if (events[index][1].type === 'content') // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === 'definition') definition = index;
    }
    heading = {
        type: 'setextHeading',
        start: shallow(events[text][1].start),
        end: shallow(events[events.length - 1][1].end)
    } // Change the paragraph to setext heading text.
    ;
    events[text][1].type = 'setextHeadingText' // If we have definitions in the content, we’ll keep on having content,
    ;
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            'enter',
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            'exit',
            events[content][1],
            context
        ]);
        events[content][1].end = shallow(events[definition][1].end);
    } else events[content][1] = heading;
     // Add the heading exit at the end.
    events.push([
        'exit',
        heading,
        context
    ]);
    return events;
}
function tokenizeSetextUnderline(effects, ok, nok) {
    var self = this;
    var index = self.events.length;
    var marker;
    var paragraph // Find an opening.
    ;
    while(index--)// Skip enter/exit of line ending, line prefix, and content.
    // We can now either have a definition or a paragraph.
    if (self.events[index][1].type !== 'lineEnding' && self.events[index][1].type !== 'linePrefix' && self.events[index][1].type !== 'content') {
        paragraph = self.events[index][1].type === 'paragraph';
        break;
    }
    return start;
    function start(code) {
        if (!self.lazy && (self.interrupt || paragraph)) {
            effects.enter('setextHeadingLine');
            effects.enter('setextHeadingLineSequence');
            marker = code;
            return closingSequence(code);
        }
        return nok(code);
    }
    function closingSequence(code) {
        if (code === marker) {
            effects.consume(code);
            return closingSequence;
        }
        effects.exit('setextHeadingLineSequence');
        return factorySpace(effects, closingSequenceEnd, 'lineSuffix')(code);
    }
    function closingSequenceEnd(code) {
        if (code === null || markdownLineEnding(code)) {
            effects.exit('setextHeadingLine');
            return ok(code);
        }
        return nok(code);
    }
}
module.exports = setextUnderline;

},{"d73ec61ed09c0d9f":"gpLlx","a78ab758fe833a3a":"aBApX","dc1da414fa8aea68":"2joBs"}],"bz3Bm":[function(require,module,exports,__globalThis) {
'use strict';
var search = /[\0\t\n\r]/g;
function preprocess() {
    var start = true;
    var column = 1;
    var buffer = '';
    var atCarriageReturn;
    return preprocessor;
    function preprocessor(value, encoding, end) {
        var chunks = [];
        var match;
        var next;
        var startPosition;
        var endPosition;
        var code;
        value = buffer + value.toString(encoding);
        startPosition = 0;
        buffer = '';
        if (start) {
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            search.lastIndex = startPosition;
            match = search.exec(value);
            endPosition = match ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                if (code === 0) {
                    chunks.push(65533);
                    column++;
                } else if (code === 9) {
                    next = Math.ceil(column / 4) * 4;
                    chunks.push(-2);
                    while(column++ < next)chunks.push(-1);
                } else if (code === 10) {
                    chunks.push(-4);
                    column = 1;
                } else {
                    atCarriageReturn = true;
                    column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}
module.exports = preprocess;

},{}],"6eidf":[function(require,module,exports,__globalThis) {
'use strict';
var subtokenize = require("552ef68b7055575");
function postprocess(events) {
    while(!subtokenize(events));
    return events;
}
module.exports = postprocess;

},{"552ef68b7055575":"6qUHK"}],"1wQDS":[function(require,module,exports,__globalThis) {
'use strict';
var mdast2hast = require("8c935dfc167349e3");
module.exports = remark2rehype;
// Attacher.
// If a destination is given, runs the destination with the new hast tree
// (bridge mode).
// Without destination, returns the tree: further plugins run on that tree
// (mutate mode).
function remark2rehype(destination, options) {
    if (destination && !destination.process) {
        options = destination;
        destination = null;
    }
    return destination ? bridge(destination, options) : mutate(options);
}
// Bridge mode.
// Runs the destination with the new hast tree.
function bridge(destination, options) {
    return transformer;
    function transformer(node, file, next) {
        destination.run(mdast2hast(node, options), file, done);
        function done(error) {
            next(error);
        }
    }
}
// Mutate-mode.
// Further transformers run on the hast tree.
function mutate(options) {
    return transformer;
    function transformer(node) {
        return mdast2hast(node, options);
    }
}

},{"8c935dfc167349e3":"dEKT1"}],"dEKT1":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("c4beb8f4ee463b8a");

},{"c4beb8f4ee463b8a":"wglDx"}],"wglDx":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = toHast;
var u = require("493eb22a0d16467d");
var visit = require("a9853ebf491bc73b");
var position = require("3337454763c7b10");
var generated = require("7a322d5d31f40e3b");
var definitions = require("e394d9b6f1f3930c");
var one = require("465194cac1c800de");
var footer = require("88c4a2770136f4d3");
var handlers = require("f4c4721e3efd47a4");
var own = {}.hasOwnProperty;
var deprecationWarningIssued = false;
// Factory to transform.
function factory(tree, options) {
    var settings = options || {};
    // Issue a warning if the deprecated tag 'allowDangerousHTML' is used
    if (settings.allowDangerousHTML !== undefined && !deprecationWarningIssued) {
        deprecationWarningIssued = true;
        console.warn('mdast-util-to-hast: deprecation: `allowDangerousHTML` is nonstandard, use `allowDangerousHtml` instead');
    }
    var dangerous = settings.allowDangerousHtml || settings.allowDangerousHTML;
    var footnoteById = {};
    h.dangerous = dangerous;
    h.definition = definitions(tree);
    h.footnoteById = footnoteById;
    h.footnoteOrder = [];
    h.augment = augment;
    h.handlers = Object.assign({}, handlers, settings.handlers);
    h.unknownHandler = settings.unknownHandler;
    h.passThrough = settings.passThrough;
    visit(tree, 'footnoteDefinition', onfootnotedefinition);
    return h;
    // Finalise the created `right`, a hast node, from `left`, an mdast node.
    function augment(left, right) {
        var data;
        var ctx;
        // Handle `data.hName`, `data.hProperties, `data.hChildren`.
        if (left && left.data) {
            data = left.data;
            if (data.hName) {
                if (right.type !== 'element') right = {
                    type: 'element',
                    tagName: '',
                    properties: {},
                    children: []
                };
                right.tagName = data.hName;
            }
            if (right.type === 'element' && data.hProperties) right.properties = Object.assign({}, right.properties, data.hProperties);
            if (right.children && data.hChildren) right.children = data.hChildren;
        }
        ctx = left && left.position ? left : {
            position: left
        };
        if (!generated(ctx)) right.position = {
            start: position.start(ctx),
            end: position.end(ctx)
        };
        return right;
    }
    // Create an element for `node`.
    function h(node, tagName, props, children) {
        if ((children === undefined || children === null) && typeof props === 'object' && 'length' in props) {
            children = props;
            props = {};
        }
        return augment(node, {
            type: 'element',
            tagName: tagName,
            properties: props || {},
            children: children || []
        });
    }
    function onfootnotedefinition(definition) {
        var id = String(definition.identifier).toUpperCase();
        // Mimick CM behavior of link definitions.
        // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/8290999/index.js#L26>.
        if (!own.call(footnoteById, id)) footnoteById[id] = definition;
    }
}
// Transform `tree`, which is an mdast node, to a hast node.
function toHast(tree, options) {
    var h = factory(tree, options);
    var node = one(h, tree);
    var foot = footer(h);
    if (foot) node.children = node.children.concat(u('text', '\n'), foot);
    return node;
}

},{"493eb22a0d16467d":"fPn4D","a9853ebf491bc73b":"e84yZ","3337454763c7b10":"2qZ1K","7a322d5d31f40e3b":"jLq1v","e394d9b6f1f3930c":"3hRGZ","465194cac1c800de":"ehw0E","88c4a2770136f4d3":"dOhIi","f4c4721e3efd47a4":"50pYz"}],"fPn4D":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = u;
function u(type, props, value) {
    var node;
    if ((value === null || value === undefined) && (typeof props !== 'object' || Array.isArray(props))) {
        value = props;
        props = {};
    }
    node = Object.assign({
        type: String(type)
    }, props);
    if (Array.isArray(value)) node.children = value;
    else if (value !== null && value !== undefined) node.value = String(value);
    return node;
}

},{}],"e84yZ":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = visit;
var visitParents = require("9a49a75ebb3a412f");
var CONTINUE = visitParents.CONTINUE;
var SKIP = visitParents.SKIP;
var EXIT = visitParents.EXIT;
visit.CONTINUE = CONTINUE;
visit.SKIP = SKIP;
visit.EXIT = EXIT;
function visit(tree, test, visitor, reverse) {
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    visitParents(tree, test, overload, reverse);
    function overload(node, parents) {
        var parent = parents[parents.length - 1];
        var index = parent ? parent.children.indexOf(node) : null;
        return visitor(node, index, parent);
    }
}

},{"9a49a75ebb3a412f":"1BG6O"}],"1BG6O":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = visitParents;
var convert = require("b69c9d3b25bafd07");
var color = require("e6e7b71dec4220a8");
var CONTINUE = true;
var SKIP = 'skip';
var EXIT = false;
visitParents.CONTINUE = CONTINUE;
visitParents.SKIP = SKIP;
visitParents.EXIT = EXIT;
function visitParents(tree, test, visitor, reverse) {
    var step;
    var is;
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    is = convert(test);
    step = reverse ? -1 : 1;
    factory(tree, null, [])();
    function factory(node, index, parents) {
        var value = typeof node === 'object' && node !== null ? node : {};
        var name;
        if (typeof value.type === 'string') {
            name = typeof value.tagName === 'string' ? value.tagName : typeof value.name === 'string' ? value.name : undefined;
            visit.displayName = 'node (' + color(value.type + (name ? '<' + name + '>' : '')) + ')';
        }
        return visit;
        function visit() {
            var grandparents = parents.concat(node);
            var result = [];
            var subresult;
            var offset;
            if (!test || is(node, index, parents[parents.length - 1] || null)) {
                result = toResult(visitor(node, parents));
                if (result[0] === EXIT) return result;
            }
            if (node.children && result[0] !== SKIP) {
                offset = (reverse ? node.children.length : -1) + step;
                while(offset > -1 && offset < node.children.length){
                    subresult = factory(node.children[offset], offset, grandparents)();
                    if (subresult[0] === EXIT) return subresult;
                    offset = typeof subresult[1] === 'number' ? subresult[1] : offset + step;
                }
            }
            return result;
        }
    }
}
function toResult(value) {
    if (value !== null && typeof value === 'object' && 'length' in value) return value;
    if (typeof value === 'number') return [
        CONTINUE,
        value
    ];
    return [
        value
    ];
}

},{"b69c9d3b25bafd07":"gwtOM","e6e7b71dec4220a8":"228Cm"}],"gwtOM":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = convert;
function convert(test) {
    if (test == null) return ok;
    if (typeof test === 'string') return typeFactory(test);
    if (typeof test === 'object') return 'length' in test ? anyFactory(test) : allFactory(test);
    if (typeof test === 'function') return test;
    throw new Error('Expected function, string, or object as test');
}
// Utility assert each property in `test` is represented in `node`, and each
// values are strictly equal.
function allFactory(test) {
    return all;
    function all(node) {
        var key;
        for(key in test){
            if (node[key] !== test[key]) return false;
        }
        return true;
    }
}
function anyFactory(tests) {
    var checks = [];
    var index = -1;
    while(++index < tests.length)checks[index] = convert(tests[index]);
    return any;
    function any() {
        var index = -1;
        while(++index < checks.length){
            if (checks[index].apply(this, arguments)) return true;
        }
        return false;
    }
}
// Utility to convert a string into a function which checks a given node’s type
// for said string.
function typeFactory(test) {
    return type;
    function type(node) {
        return Boolean(node && node.type === test);
    }
}
// Utility to return true.
function ok() {
    return true;
}

},{}],"228Cm":[function(require,module,exports,__globalThis) {
module.exports = identity;
function identity(d) {
    return d;
}

},{}],"2qZ1K":[function(require,module,exports,__globalThis) {
'use strict';
var start = factory('start');
var end = factory('end');
module.exports = position;
position.start = start;
position.end = end;
function position(node) {
    return {
        start: start(node),
        end: end(node)
    };
}
function factory(type) {
    point.displayName = type;
    return point;
    function point(node) {
        var point = node && node.position && node.position[type] || {};
        return {
            line: point.line || null,
            column: point.column || null,
            offset: isNaN(point.offset) ? null : point.offset
        };
    }
}

},{}],"jLq1v":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = generated;
function generated(node) {
    return !node || !node.position || !node.position.start || !node.position.start.line || !node.position.start.column || !node.position.end || !node.position.end.line || !node.position.end.column;
}

},{}],"3hRGZ":[function(require,module,exports,__globalThis) {
'use strict';
var visit = require("b4b11ac389d276cd");
module.exports = getDefinitionFactory;
var own = {}.hasOwnProperty;
// Get a definition in `node` by `identifier`.
function getDefinitionFactory(node, options) {
    return getterFactory(gather(node, options));
}
// Gather all definitions in `node`
function gather(node) {
    var cache = {};
    if (!node || !node.type) throw new Error('mdast-util-definitions expected node');
    visit(node, 'definition', ondefinition);
    return cache;
    function ondefinition(definition) {
        var id = normalise(definition.identifier);
        if (!own.call(cache, id)) cache[id] = definition;
    }
}
// Factory to get a node from the given definition-cache.
function getterFactory(cache) {
    return getter;
    // Get a node from the bound definition-cache.
    function getter(identifier) {
        var id = identifier && normalise(identifier);
        return id && own.call(cache, id) ? cache[id] : null;
    }
}
function normalise(identifier) {
    return identifier.toUpperCase();
}

},{"b4b11ac389d276cd":"2SYFi"}],"2SYFi":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = visit;
var visitParents = require("e4df779e3d58db81");
var CONTINUE = visitParents.CONTINUE;
var SKIP = visitParents.SKIP;
var EXIT = visitParents.EXIT;
visit.CONTINUE = CONTINUE;
visit.SKIP = SKIP;
visit.EXIT = EXIT;
function visit(tree, test, visitor, reverse) {
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    visitParents(tree, test, overload, reverse);
    function overload(node, parents) {
        var parent = parents[parents.length - 1];
        var index = parent ? parent.children.indexOf(node) : null;
        return visitor(node, index, parent);
    }
}

},{"e4df779e3d58db81":"iG81p"}],"iG81p":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = visitParents;
var convert = require("a700170d2744c89f");
var color = require("124b51fd825bad44");
var CONTINUE = true;
var SKIP = 'skip';
var EXIT = false;
visitParents.CONTINUE = CONTINUE;
visitParents.SKIP = SKIP;
visitParents.EXIT = EXIT;
function visitParents(tree, test, visitor, reverse) {
    var step;
    var is;
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    is = convert(test);
    step = reverse ? -1 : 1;
    factory(tree, null, [])();
    function factory(node, index, parents) {
        var value = typeof node === 'object' && node !== null ? node : {};
        var name;
        if (typeof value.type === 'string') {
            name = typeof value.tagName === 'string' ? value.tagName : typeof value.name === 'string' ? value.name : undefined;
            visit.displayName = 'node (' + color(value.type + (name ? '<' + name + '>' : '')) + ')';
        }
        return visit;
        function visit() {
            var grandparents = parents.concat(node);
            var result = [];
            var subresult;
            var offset;
            if (!test || is(node, index, parents[parents.length - 1] || null)) {
                result = toResult(visitor(node, parents));
                if (result[0] === EXIT) return result;
            }
            if (node.children && result[0] !== SKIP) {
                offset = (reverse ? node.children.length : -1) + step;
                while(offset > -1 && offset < node.children.length){
                    subresult = factory(node.children[offset], offset, grandparents)();
                    if (subresult[0] === EXIT) return subresult;
                    offset = typeof subresult[1] === 'number' ? subresult[1] : offset + step;
                }
            }
            return result;
        }
    }
}
function toResult(value) {
    if (value !== null && typeof value === 'object' && 'length' in value) return value;
    if (typeof value === 'number') return [
        CONTINUE,
        value
    ];
    return [
        value
    ];
}

},{"a700170d2744c89f":"gwtOM","124b51fd825bad44":"aPUnu"}],"aPUnu":[function(require,module,exports,__globalThis) {
module.exports = identity;
function identity(d) {
    return d;
}

},{}],"ehw0E":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = one;
var u = require("65b3c3c98304813c");
var all = require("437d97f3b5ee176d");
var own = {}.hasOwnProperty;
// Transform an unknown node.
function unknown(h, node) {
    if (text(node)) return h.augment(node, u('text', node.value));
    return h(node, 'div', all(h, node));
}
// Visit a node.
function one(h, node, parent) {
    var type = node && node.type;
    var fn;
    // Fail on non-nodes.
    if (!type) throw new Error('Expected node, got `' + node + '`');
    if (own.call(h.handlers, type)) fn = h.handlers[type];
    else if (h.passThrough && h.passThrough.indexOf(type) > -1) fn = returnNode;
    else fn = h.unknownHandler;
    return (typeof fn === 'function' ? fn : unknown)(h, node, parent);
}
// Check if the node should be renderered as a text node.
function text(node) {
    var data = node.data || {};
    if (own.call(data, 'hName') || own.call(data, 'hProperties') || own.call(data, 'hChildren')) return false;
    return 'value' in node;
}
function returnNode(h, node) {
    var clone;
    if (node.children) {
        clone = Object.assign({}, node);
        clone.children = all(h, node);
        return clone;
    }
    return node;
}

},{"65b3c3c98304813c":"fPn4D","437d97f3b5ee176d":"iuXBL"}],"iuXBL":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = all;
var one = require("374620d05d7f943");
function all(h, parent) {
    var nodes = parent.children || [];
    var length = nodes.length;
    var values = [];
    var index = -1;
    var result;
    var head;
    while(++index < length){
        result = one(h, nodes[index], parent);
        if (result) {
            if (index && nodes[index - 1].type === 'break') {
                if (result.value) result.value = result.value.replace(/^\s+/, '');
                head = result.children && result.children[0];
                if (head && head.value) head.value = head.value.replace(/^\s+/, '');
            }
            values = values.concat(result);
        }
    }
    return values;
}

},{"374620d05d7f943":"ehw0E"}],"dOhIi":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = generateFootnotes;
var thematicBreak = require("36232d66dd071b96");
var list = require("5a796e925b37737d");
var wrap = require("8e12db01b10263e0");
function generateFootnotes(h) {
    var footnoteById = h.footnoteById;
    var footnoteOrder = h.footnoteOrder;
    var length = footnoteOrder.length;
    var index = -1;
    var listItems = [];
    var def;
    var backReference;
    var content;
    var tail;
    while(++index < length){
        def = footnoteById[footnoteOrder[index].toUpperCase()];
        if (!def) continue;
        content = def.children.concat();
        tail = content[content.length - 1];
        backReference = {
            type: 'link',
            url: '#fnref-' + def.identifier,
            data: {
                hProperties: {
                    className: [
                        'footnote-backref'
                    ]
                }
            },
            children: [
                {
                    type: 'text',
                    value: "\u21A9"
                }
            ]
        };
        if (!tail || tail.type !== 'paragraph') {
            tail = {
                type: 'paragraph',
                children: []
            };
            content.push(tail);
        }
        tail.children.push(backReference);
        listItems.push({
            type: 'listItem',
            data: {
                hProperties: {
                    id: 'fn-' + def.identifier
                }
            },
            children: content,
            position: def.position
        });
    }
    if (listItems.length === 0) return null;
    return h(null, 'div', {
        className: [
            'footnotes'
        ]
    }, wrap([
        thematicBreak(h),
        list(h, {
            type: 'list',
            ordered: true,
            children: listItems
        })
    ], true));
}

},{"36232d66dd071b96":"7foes","5a796e925b37737d":"4lDwn","8e12db01b10263e0":"jHFAZ"}],"7foes":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = thematicBreak;
function thematicBreak(h, node) {
    return h(node, 'hr');
}

},{}],"4lDwn":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = list;
var wrap = require("489c296eeb0b0f6c");
var all = require("63d34e41debd969a");
function list(h, node) {
    var props = {};
    var name = node.ordered ? 'ol' : 'ul';
    var items;
    var index = -1;
    var length;
    if (typeof node.start === 'number' && node.start !== 1) props.start = node.start;
    items = all(h, node);
    length = items.length;
    // Like GitHub, add a class for custom styling.
    while(++index < length)if (items[index].properties.className && items[index].properties.className.indexOf('task-list-item') !== -1) {
        props.className = [
            'contains-task-list'
        ];
        break;
    }
    return h(node, name, props, wrap(items, true));
}

},{"489c296eeb0b0f6c":"jHFAZ","63d34e41debd969a":"iuXBL"}],"jHFAZ":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = wrap;
var u = require("195600479cba5a5c");
// Wrap `nodes` with line feeds between each entry.
// Optionally adds line feeds at the start and end.
function wrap(nodes, loose) {
    var result = [];
    var index = -1;
    var length = nodes.length;
    if (loose) result.push(u('text', '\n'));
    while(++index < length){
        if (index) result.push(u('text', '\n'));
        result.push(nodes[index]);
    }
    if (loose && nodes.length > 0) result.push(u('text', '\n'));
    return result;
}

},{"195600479cba5a5c":"fPn4D"}],"50pYz":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = {
    blockquote: require("5b6a516f6a925444"),
    break: require("90b942d4c519fd2c"),
    code: require("b83f3a08209af9b3"),
    delete: require("2dd8da57a7adb2ca"),
    emphasis: require("6deb6e8d7c97b599"),
    footnoteReference: require("b075848962442062"),
    footnote: require("96d1c59ef982965c"),
    heading: require("f6251e02c7f68cb"),
    html: require("1a95ae9b8940c1c8"),
    imageReference: require("bd2dbf06ab9d7165"),
    image: require("862617149c504993"),
    inlineCode: require("41c01531a24b05b4"),
    linkReference: require("bae161a09d0991cf"),
    link: require("c812710d521bd3f"),
    listItem: require("a6a480aed0669738"),
    list: require("cb389188cea0e208"),
    paragraph: require("a12ad58574e834eb"),
    root: require("c075dcfca3169533"),
    strong: require("a35d712f55906d99"),
    table: require("56ca36ac593d68af"),
    text: require("72e836d00145df37"),
    thematicBreak: require("e2f276cc4f2b4943"),
    toml: ignore,
    yaml: ignore,
    definition: ignore,
    footnoteDefinition: ignore
};
// Return nothing for nodes that are ignored.
function ignore() {
    return null;
}

},{"5b6a516f6a925444":"9vJws","90b942d4c519fd2c":"1nCdF","b83f3a08209af9b3":"33ybo","2dd8da57a7adb2ca":"gexbo","6deb6e8d7c97b599":"eJdBV","b075848962442062":"jIH0s","96d1c59ef982965c":"5ixKR","f6251e02c7f68cb":"lTpTo","1a95ae9b8940c1c8":"ekc9M","bd2dbf06ab9d7165":"eupwr","862617149c504993":"l8qG5","41c01531a24b05b4":"8CIrd","bae161a09d0991cf":"e4mYQ","c812710d521bd3f":"aPB7T","a6a480aed0669738":"jjPXG","cb389188cea0e208":"4lDwn","a12ad58574e834eb":"bkMwG","c075dcfca3169533":"cURkY","a35d712f55906d99":"kbYmY","56ca36ac593d68af":"8Ge8W","72e836d00145df37":"5mUQP","e2f276cc4f2b4943":"7foes"}],"9vJws":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = blockquote;
var wrap = require("d99af760f7d137cd");
var all = require("5a1018d4c8243fb");
function blockquote(h, node) {
    return h(node, 'blockquote', wrap(all(h, node), true));
}

},{"d99af760f7d137cd":"jHFAZ","5a1018d4c8243fb":"iuXBL"}],"1nCdF":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = hardBreak;
var u = require("9978a9eb588473e0");
function hardBreak(h, node) {
    return [
        h(node, 'br'),
        u('text', '\n')
    ];
}

},{"9978a9eb588473e0":"fPn4D"}],"33ybo":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = code;
var u = require("b341c039101edcca");
function code(h, node) {
    var value = node.value ? node.value + '\n' : '';
    // To do: next major, use `node.lang` w/o regex, the splitting’s been going
    // on for years in remark now.
    var lang = node.lang && node.lang.match(/^[^ \t]+(?=[ \t]|$)/);
    var props = {};
    var code;
    if (lang) props.className = [
        'language-' + lang
    ];
    code = h(node, 'code', props, [
        u('text', value)
    ]);
    if (node.meta) code.data = {
        meta: node.meta
    };
    return h(node.position, 'pre', [
        code
    ]);
}

},{"b341c039101edcca":"fPn4D"}],"gexbo":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = strikethrough;
var all = require("142279c3f8adb873");
function strikethrough(h, node) {
    return h(node, 'del', all(h, node));
}

},{"142279c3f8adb873":"iuXBL"}],"eJdBV":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = emphasis;
var all = require("b98af7813a93c546");
function emphasis(h, node) {
    return h(node, 'em', all(h, node));
}

},{"b98af7813a93c546":"iuXBL"}],"jIH0s":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = footnoteReference;
var u = require("c8ebc6e031ed0eac");
function footnoteReference(h, node) {
    var footnoteOrder = h.footnoteOrder;
    var identifier = String(node.identifier);
    if (footnoteOrder.indexOf(identifier) === -1) footnoteOrder.push(identifier);
    return h(node.position, 'sup', {
        id: 'fnref-' + identifier
    }, [
        h(node, 'a', {
            href: '#fn-' + identifier,
            className: [
                'footnote-ref'
            ]
        }, [
            u('text', node.label || identifier)
        ])
    ]);
}

},{"c8ebc6e031ed0eac":"fPn4D"}],"5ixKR":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = footnote;
var footnoteReference = require("e7f9929743e6eeeb");
function footnote(h, node) {
    var footnoteById = h.footnoteById;
    var footnoteOrder = h.footnoteOrder;
    var identifier = 1;
    while(identifier in footnoteById)identifier++;
    identifier = String(identifier);
    // No need to check if `identifier` exists in `footnoteOrder`, it’s guaranteed
    // to not exist because we just generated it.
    footnoteOrder.push(identifier);
    footnoteById[identifier] = {
        type: 'footnoteDefinition',
        identifier: identifier,
        children: [
            {
                type: 'paragraph',
                children: node.children
            }
        ],
        position: node.position
    };
    return footnoteReference(h, {
        type: 'footnoteReference',
        identifier: identifier,
        position: node.position
    });
}

},{"e7f9929743e6eeeb":"jIH0s"}],"lTpTo":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = heading;
var all = require("afe050827e1e4584");
function heading(h, node) {
    return h(node, 'h' + node.depth, all(h, node));
}

},{"afe050827e1e4584":"iuXBL"}],"ekc9M":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = html;
var u = require("73579f3135ca3567");
// Return either a `raw` node in dangerous mode, otherwise nothing.
function html(h, node) {
    return h.dangerous ? h.augment(node, u('raw', node.value)) : null;
}

},{"73579f3135ca3567":"fPn4D"}],"eupwr":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = imageReference;
var normalize = require("8605f5206eb347b0");
var revert = require("6e8fa71b7a7f2db6");
function imageReference(h, node) {
    var def = h.definition(node.identifier);
    var props;
    if (!def) return revert(h, node);
    props = {
        src: normalize(def.url || ''),
        alt: node.alt
    };
    if (def.title !== null && def.title !== undefined) props.title = def.title;
    return h(node, 'img', props);
}

},{"8605f5206eb347b0":"dtpzm","6e8fa71b7a7f2db6":"dHobJ"}],"dtpzm":[function(require,module,exports,__globalThis) {
'use strict';
var encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function getEncodeCache(exclude) {
    var i, ch, cache = encodeCache[exclude];
    if (cache) return cache;
    cache = encodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
    for(i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function encode(string, exclude, keepEscaped) {
    var i, l, code, nextCode, cache, result = '';
    if (typeof exclude !== 'string') {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = encode.defaultChars;
    }
    if (typeof keepEscaped === 'undefined') keepEscaped = true;
    cache = getEncodeCache(exclude);
    for(i = 0, l = string.length; i < l; i++){
        code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += '%EF%BF%BD';
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
encode.componentChars = "-_.!~*'()";
module.exports = encode;

},{}],"dHobJ":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = revert;
var u = require("e8c47d92108b25e9");
var all = require("20a44cb44af81bf5");
// Return the content of a reference without definition as Markdown.
function revert(h, node) {
    var subtype = node.referenceType;
    var suffix = ']';
    var contents;
    var head;
    var tail;
    if (subtype === 'collapsed') suffix += '[]';
    else if (subtype === 'full') suffix += '[' + (node.label || node.identifier) + ']';
    if (node.type === 'imageReference') return u('text', '![' + node.alt + suffix);
    contents = all(h, node);
    head = contents[0];
    if (head && head.type === 'text') head.value = '[' + head.value;
    else contents.unshift(u('text', '['));
    tail = contents[contents.length - 1];
    if (tail && tail.type === 'text') tail.value += suffix;
    else contents.push(u('text', suffix));
    return contents;
}

},{"e8c47d92108b25e9":"fPn4D","20a44cb44af81bf5":"iuXBL"}],"l8qG5":[function(require,module,exports,__globalThis) {
'use strict';
var normalize = require("62c15e067f6c65bc");
module.exports = image;
function image(h, node) {
    var props = {
        src: normalize(node.url),
        alt: node.alt
    };
    if (node.title !== null && node.title !== undefined) props.title = node.title;
    return h(node, 'img', props);
}

},{"62c15e067f6c65bc":"dtpzm"}],"8CIrd":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = inlineCode;
var u = require("7c86c5750bf93063");
function inlineCode(h, node) {
    var value = node.value.replace(/\r?\n|\r/g, ' ');
    return h(node, 'code', [
        u('text', value)
    ]);
}

},{"7c86c5750bf93063":"fPn4D"}],"e4mYQ":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = linkReference;
var normalize = require("a6c02a1e16188186");
var revert = require("4b8522a31b9a8168");
var all = require("58b5e9fe5de6666f");
function linkReference(h, node) {
    var def = h.definition(node.identifier);
    var props;
    if (!def) return revert(h, node);
    props = {
        href: normalize(def.url || '')
    };
    if (def.title !== null && def.title !== undefined) props.title = def.title;
    return h(node, 'a', props, all(h, node));
}

},{"a6c02a1e16188186":"dtpzm","4b8522a31b9a8168":"dHobJ","58b5e9fe5de6666f":"iuXBL"}],"aPB7T":[function(require,module,exports,__globalThis) {
'use strict';
var normalize = require("fcdcbe0a3bd9e2b4");
var all = require("7d85529658844f23");
module.exports = link;
function link(h, node) {
    var props = {
        href: normalize(node.url)
    };
    if (node.title !== null && node.title !== undefined) props.title = node.title;
    return h(node, 'a', props, all(h, node));
}

},{"fcdcbe0a3bd9e2b4":"dtpzm","7d85529658844f23":"iuXBL"}],"jjPXG":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = listItem;
var u = require("6f0b43b224a8e2ab");
var all = require("afca731c563e3fa9");
function listItem(h, node, parent) {
    var result = all(h, node);
    var head = result[0];
    var loose = parent ? listLoose(parent) : listItemLoose(node);
    var props = {};
    var wrapped = [];
    var length;
    var index;
    var child;
    if (typeof node.checked === 'boolean') {
        if (!head || head.tagName !== 'p') {
            head = h(null, 'p', []);
            result.unshift(head);
        }
        if (head.children.length > 0) head.children.unshift(u('text', ' '));
        head.children.unshift(h(null, 'input', {
            type: 'checkbox',
            checked: node.checked,
            disabled: true
        }));
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        props.className = [
            'task-list-item'
        ];
    }
    length = result.length;
    index = -1;
    while(++index < length){
        child = result[index];
        // Add eols before nodes, except if this is a loose, first paragraph.
        if (loose || index !== 0 || child.tagName !== 'p') wrapped.push(u('text', '\n'));
        if (child.tagName === 'p' && !loose) wrapped = wrapped.concat(child.children);
        else wrapped.push(child);
    }
    // Add a final eol.
    if (length && (loose || child.tagName !== 'p')) wrapped.push(u('text', '\n'));
    return h(node, 'li', props, wrapped);
}
function listLoose(node) {
    var loose = node.spread;
    var children = node.children;
    var length = children.length;
    var index = -1;
    while(!loose && ++index < length)loose = listItemLoose(children[index]);
    return loose;
}
function listItemLoose(node) {
    var spread = node.spread;
    return spread === undefined || spread === null ? node.children.length > 1 : spread;
}

},{"6f0b43b224a8e2ab":"fPn4D","afca731c563e3fa9":"iuXBL"}],"bkMwG":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = paragraph;
var all = require("1a3cbb1f5f9096f0");
function paragraph(h, node) {
    return h(node, 'p', all(h, node));
}

},{"1a3cbb1f5f9096f0":"iuXBL"}],"cURkY":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = root;
var u = require("714871a9980bdca0");
var wrap = require("8279e7ab195ac59b");
var all = require("c976de39756e5052");
function root(h, node) {
    return h.augment(node, u('root', wrap(all(h, node))));
}

},{"714871a9980bdca0":"fPn4D","8279e7ab195ac59b":"jHFAZ","c976de39756e5052":"iuXBL"}],"kbYmY":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = strong;
var all = require("d1ae82670e0c537a");
function strong(h, node) {
    return h(node, 'strong', all(h, node));
}

},{"d1ae82670e0c537a":"iuXBL"}],"8Ge8W":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = table;
var position = require("ddbae1b8cac076b9");
var wrap = require("9f2b5bdcbf45cd3e");
var all = require("b6dbb4b047a86353");
function table(h, node) {
    var rows = node.children;
    var index = rows.length;
    var align = node.align || [];
    var alignLength = align.length;
    var result = [];
    var pos;
    var row;
    var out;
    var name;
    var cell;
    while(index--){
        row = rows[index].children;
        name = index === 0 ? 'th' : 'td';
        pos = alignLength || row.length;
        out = [];
        while(pos--){
            cell = row[pos];
            out[pos] = h(cell, name, {
                align: align[pos]
            }, cell ? all(h, cell) : []);
        }
        result[index] = h(rows[index], 'tr', wrap(out, true));
    }
    return h(node, 'table', wrap([
        h(result[0].position, 'thead', wrap([
            result[0]
        ], true))
    ].concat(result[1] ? h({
        start: position.start(result[1]),
        end: position.end(result[result.length - 1])
    }, 'tbody', wrap(result.slice(1), true)) : []), true));
}

},{"ddbae1b8cac076b9":"2qZ1K","9f2b5bdcbf45cd3e":"jHFAZ","b6dbb4b047a86353":"iuXBL"}],"5mUQP":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = text;
var u = require("79facc0aec58cd35");
function text(h, node) {
    return h.augment(node, u('text', String(node.value).replace(/[ \t]*(\r?\n|\r)[ \t]*/g, '$1')));
}

},{"79facc0aec58cd35":"fPn4D"}],"jyLbt":[function(require,module,exports,__globalThis) {
'use strict';
var toH = require("de41e9d7bbc845cf");
var tableCellStyle = require("913254e39ce7a44e");
module.exports = rehypeReact;
var own = {}.hasOwnProperty;
var tableElements = new Set([
    'table',
    'thead',
    'tbody',
    'tfoot',
    'tr',
    'th',
    'td'
]);
// Add a React compiler.
function rehypeReact(options) {
    var settings = options || {};
    var createElement = settings.createElement;
    this.Compiler = compiler;
    function compiler(node) {
        var result = toH(h, tableCellStyle(node), settings.prefix);
        if (node.type === 'root') {
            // Invert <https://github.com/syntax-tree/hast-to-hyperscript/blob/d227372/index.js#L46-L56>.
            result = result.type === 'div' && (node.children.length !== 1 || node.children[0].type !== 'element') ? result.props.children : [
                result
            ];
            return createElement(settings.Fragment || 'div', {}, result);
        }
        return result;
    }
    // Wrap `createElement` to pass components in.
    function h(name, props, children) {
        var component = name;
        // Currently, a warning is triggered by react for *any* white space in
        // tables.
        // So we remove the pretty lines for now.
        // See: <https://github.com/facebook/react/pull/7081>.
        // See: <https://github.com/facebook/react/pull/7515>.
        // See: <https://github.com/remarkjs/remark-react/issues/64>.
        if (children && tableElements.has(name)) children = children.filter(function(child) {
            return child !== '\n';
        });
        if (settings.components && own.call(settings.components, name)) {
            component = settings.components[name];
            if (settings.passNode) props.node = this;
        }
        return createElement(component, props, children);
    }
}

},{"de41e9d7bbc845cf":"4lk2b","913254e39ce7a44e":"dJ5c9"}],"4lk2b":[function(require,module,exports,__globalThis) {
'use strict';
var html = require("cf4b7aac9ffa45b6");
var svg = require("260f2e790a3b33e");
var find = require("51f785f829367248");
var hastToReact = require("6a9f70415551566");
var spaces = require("2188fd469368664c");
var commas = require("32ee839ece1836b9");
var style = require("45210836361923e6");
var ns = require("11ab0b2ef387c435");
var convert = require("627f4d03647b9d43");
var root = convert('root');
var element = convert('element');
var text = convert('text');
module.exports = wrapper;
function wrapper(h, node, options) {
    var settings = options || {};
    var r = react(h);
    var v = vue(h);
    var vd = vdom(h);
    var prefix;
    if (typeof h !== 'function') throw new Error('h is not a function');
    if (typeof settings === 'string' || typeof settings === 'boolean') {
        prefix = settings;
        settings = {};
    } else prefix = settings.prefix;
    if (root(node)) node = node.children.length === 1 && element(node.children[0]) ? node.children[0] : {
        type: 'element',
        tagName: 'div',
        properties: {},
        children: node.children
    };
    else if (!element(node)) throw new Error('Expected root or element, not `' + (node && node.type || node) + '`');
    return toH(h, node, {
        schema: settings.space === 'svg' ? svg : html,
        prefix: prefix == null ? r || v || vd ? 'h-' : null : prefix,
        key: 0,
        react: r,
        vue: v,
        vdom: vd,
        hyperscript: hyperscript(h)
    });
}
// Transform a hast node through a hyperscript interface to *anything*!
function toH(h, node, ctx) {
    var parentSchema = ctx.schema;
    var schema = parentSchema;
    var name = node.tagName;
    var attributes = {};
    var nodes = [];
    var index = -1;
    var key;
    var value;
    if (parentSchema.space === 'html' && name.toLowerCase() === 'svg') {
        schema = svg;
        ctx.schema = schema;
    }
    for(key in node.properties)addAttribute(attributes, key, node.properties[key], ctx, name);
    if (ctx.vdom) {
        if (schema.space === 'html') name = name.toUpperCase();
        else attributes.namespace = ns[schema.space];
    }
    if (ctx.prefix) {
        ctx.key++;
        attributes.key = ctx.prefix + ctx.key;
    }
    if (node.children) while(++index < node.children.length){
        value = node.children[index];
        if (element(value)) nodes.push(toH(h, value, ctx));
        else if (text(value)) nodes.push(value.value);
    }
    // Restore parent schema.
    ctx.schema = parentSchema;
    // Ensure no React warnings are triggered for void elements having children
    // passed in.
    return nodes.length ? h.call(node, name, attributes, nodes) : h.call(node, name, attributes);
}
function addAttribute(props, prop, value, ctx, name) {
    var info = find(ctx.schema, prop);
    var subprop;
    // Ignore nullish and `NaN` values.
    // Ignore `false` and falsey known booleans for hyperlike DSLs.
    if (value == null || value !== value || value === false && (ctx.vue || ctx.vdom || ctx.hyperscript) || !value && info.boolean && (ctx.vue || ctx.vdom || ctx.hyperscript)) return;
    if (value && typeof value === 'object' && 'length' in value) // Accept `array`.
    // Most props are space-separated.
    value = (info.commaSeparated ? commas : spaces).stringify(value);
    // Treat `true` and truthy known booleans.
    if (info.boolean && ctx.hyperscript) value = '';
    // VDOM, Vue, and React accept `style` as object.
    if (info.property === 'style' && typeof value === 'string' && (ctx.react || ctx.vue || ctx.vdom)) value = parseStyle(value, name);
    if (ctx.vue) {
        if (info.property !== 'style') subprop = 'attrs';
    } else if (!info.mustUseProperty) {
        if (ctx.vdom) {
            if (info.property !== 'style') subprop = 'attributes';
        } else if (ctx.hyperscript) subprop = 'attrs';
    }
    if (subprop) {
        if (!props[subprop]) props[subprop] = {};
        props[subprop][info.attribute] = value;
    } else if (info.space && ctx.react) props[hastToReact[info.property] || info.property] = value;
    else props[info.attribute] = value;
}
// Check if `h` is `react.createElement`.
function react(h) {
    var node = h && h('div');
    return Boolean(node && ('_owner' in node || '_store' in node) && node.key == null);
}
// Check if `h` is `hyperscript`.
function hyperscript(h) {
    return Boolean(h && h.context && h.cleanup);
}
// Check if `h` is `virtual-dom/h`.
function vdom(h) {
    return h && h('div').type === 'VirtualNode';
}
function vue(h) {
    var node = h && h('div');
    return Boolean(node && node.context && node.context._isVue);
}
function parseStyle(value, tagName) {
    var result = {};
    try {
        style(value, iterator);
    } catch (error) {
        error.message = tagName + '[style]' + error.message.slice(9);
        throw error;
    }
    return result;
    function iterator(name, value) {
        if (name.slice(0, 4) === '-ms-') name = 'ms-' + name.slice(4);
        result[name.replace(/-([a-z])/g, styleReplacer)] = value;
    }
}
function styleReplacer($0, $1) {
    return $1.toUpperCase();
}

},{"cf4b7aac9ffa45b6":"fx8rA","260f2e790a3b33e":"6UDrF","51f785f829367248":"kJbfs","6a9f70415551566":"im14n","2188fd469368664c":"i0pvy","32ee839ece1836b9":"iS7qW","45210836361923e6":"6km9Q","11ab0b2ef387c435":"gHbL8","627f4d03647b9d43":"gwtOM"}],"fx8rA":[function(require,module,exports,__globalThis) {
'use strict';
var merge = require("e222e8b03baba495");
var xlink = require("4ce9827de25058e8");
var xml = require("cfa3717f03cc34a0");
var xmlns = require("d21a1d16bcc3d1b3");
var aria = require("6ae99b57b1aa34fb");
var html = require("b596ad7f000a3cd2");
module.exports = merge([
    xml,
    xlink,
    xmlns,
    aria,
    html
]);

},{"e222e8b03baba495":"691K2","4ce9827de25058e8":"l8jwY","cfa3717f03cc34a0":"bcgcO","d21a1d16bcc3d1b3":"5Aqcy","6ae99b57b1aa34fb":"i24eG","b596ad7f000a3cd2":"8Kx6T"}],"691K2":[function(require,module,exports,__globalThis) {
'use strict';
var xtend = require("aff02db643bcb2a8");
var Schema = require("9b204132a4dd486a");
module.exports = merge;
function merge(definitions) {
    var length = definitions.length;
    var property = [];
    var normal = [];
    var index = -1;
    var info;
    var space;
    while(++index < length){
        info = definitions[index];
        property.push(info.property);
        normal.push(info.normal);
        space = info.space;
    }
    return new Schema(xtend.apply(null, property), xtend.apply(null, normal), space);
}

},{"aff02db643bcb2a8":"55GSA","9b204132a4dd486a":"fOhSI"}],"55GSA":[function(require,module,exports,__globalThis) {
module.exports = extend;
var hasOwnProperty = Object.prototype.hasOwnProperty;
function extend() {
    var target = {};
    for(var i = 0; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
}

},{}],"fOhSI":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = Schema;
var proto = Schema.prototype;
proto.space = null;
proto.normal = {};
proto.property = {};
function Schema(property, normal, space) {
    this.property = property;
    this.normal = normal;
    if (space) this.space = space;
}

},{}],"l8jwY":[function(require,module,exports,__globalThis) {
'use strict';
var create = require("a308ff2877287727");
module.exports = create({
    space: 'xlink',
    transform: xlinkTransform,
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    }
});
function xlinkTransform(_, prop) {
    return 'xlink:' + prop.slice(5).toLowerCase();
}

},{"a308ff2877287727":"gxFKQ"}],"gxFKQ":[function(require,module,exports,__globalThis) {
'use strict';
var normalize = require("bfffb1d93d1cda64");
var Schema = require("f026e02181ed8f92");
var DefinedInfo = require("dfd8875579285993");
module.exports = create;
function create(definition) {
    var space = definition.space;
    var mustUseProperty = definition.mustUseProperty || [];
    var attributes = definition.attributes || {};
    var props = definition.properties;
    var transform = definition.transform;
    var property = {};
    var normal = {};
    var prop;
    var info;
    for(prop in props){
        info = new DefinedInfo(prop, transform(attributes, prop), props[prop], space);
        if (mustUseProperty.indexOf(prop) !== -1) info.mustUseProperty = true;
        property[prop] = info;
        normal[normalize(prop)] = prop;
        normal[normalize(info.attribute)] = prop;
    }
    return new Schema(property, normal, space);
}

},{"bfffb1d93d1cda64":"82dea","f026e02181ed8f92":"fOhSI","dfd8875579285993":"dBBaV"}],"82dea":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = normalize;
function normalize(value) {
    return value.toLowerCase();
}

},{}],"dBBaV":[function(require,module,exports,__globalThis) {
'use strict';
var Info = require("aa72c1656ec85657");
var types = require("8b11356c60e083e2");
module.exports = DefinedInfo;
DefinedInfo.prototype = new Info();
DefinedInfo.prototype.defined = true;
var checks = [
    'boolean',
    'booleanish',
    'overloadedBoolean',
    'number',
    'commaSeparated',
    'spaceSeparated',
    'commaOrSpaceSeparated'
];
var checksLength = checks.length;
function DefinedInfo(property, attribute, mask, space) {
    var index = -1;
    var check;
    mark(this, 'space', space);
    Info.call(this, property, attribute);
    while(++index < checksLength){
        check = checks[index];
        mark(this, check, (mask & types[check]) === types[check]);
    }
}
function mark(values, key, value) {
    if (value) values[key] = value;
}

},{"aa72c1656ec85657":"dpy8m","8b11356c60e083e2":"elAF3"}],"dpy8m":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = Info;
var proto = Info.prototype;
proto.space = null;
proto.attribute = null;
proto.property = null;
proto.boolean = false;
proto.booleanish = false;
proto.overloadedBoolean = false;
proto.number = false;
proto.commaSeparated = false;
proto.spaceSeparated = false;
proto.commaOrSpaceSeparated = false;
proto.mustUseProperty = false;
proto.defined = false;
function Info(property, attribute) {
    this.property = property;
    this.attribute = attribute;
}

},{}],"elAF3":[function(require,module,exports,__globalThis) {
'use strict';
var powers = 0;
exports.boolean = increment();
exports.booleanish = increment();
exports.overloadedBoolean = increment();
exports.number = increment();
exports.spaceSeparated = increment();
exports.commaSeparated = increment();
exports.commaOrSpaceSeparated = increment();
function increment() {
    return Math.pow(2, ++powers);
}

},{}],"bcgcO":[function(require,module,exports,__globalThis) {
'use strict';
var create = require("8291787cc1196527");
module.exports = create({
    space: 'xml',
    transform: xmlTransform,
    properties: {
        xmlLang: null,
        xmlBase: null,
        xmlSpace: null
    }
});
function xmlTransform(_, prop) {
    return 'xml:' + prop.slice(3).toLowerCase();
}

},{"8291787cc1196527":"gxFKQ"}],"5Aqcy":[function(require,module,exports,__globalThis) {
'use strict';
var create = require("f7d8dd585c66aa17");
var caseInsensitiveTransform = require("ef24f3f88efc8122");
module.exports = create({
    space: 'xmlns',
    attributes: {
        xmlnsxlink: 'xmlns:xlink'
    },
    transform: caseInsensitiveTransform,
    properties: {
        xmlns: null,
        xmlnsXLink: null
    }
});

},{"f7d8dd585c66aa17":"gxFKQ","ef24f3f88efc8122":"5gBK0"}],"5gBK0":[function(require,module,exports,__globalThis) {
'use strict';
var caseSensitiveTransform = require("bc5d245be42a24e5");
module.exports = caseInsensitiveTransform;
function caseInsensitiveTransform(attributes, property) {
    return caseSensitiveTransform(attributes, property.toLowerCase());
}

},{"bc5d245be42a24e5":"12uQM"}],"12uQM":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = caseSensitiveTransform;
function caseSensitiveTransform(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}

},{}],"i24eG":[function(require,module,exports,__globalThis) {
'use strict';
var types = require("cc49de9f6bf70a3f");
var create = require("5bb8251263d6e2cd");
var booleanish = types.booleanish;
var number = types.number;
var spaceSeparated = types.spaceSeparated;
module.exports = create({
    transform: ariaTransform,
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: booleanish,
        ariaAutoComplete: null,
        ariaBusy: booleanish,
        ariaChecked: booleanish,
        ariaColCount: number,
        ariaColIndex: number,
        ariaColSpan: number,
        ariaControls: spaceSeparated,
        ariaCurrent: null,
        ariaDescribedBy: spaceSeparated,
        ariaDetails: null,
        ariaDisabled: booleanish,
        ariaDropEffect: spaceSeparated,
        ariaErrorMessage: null,
        ariaExpanded: booleanish,
        ariaFlowTo: spaceSeparated,
        ariaGrabbed: booleanish,
        ariaHasPopup: null,
        ariaHidden: booleanish,
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: spaceSeparated,
        ariaLevel: number,
        ariaLive: null,
        ariaModal: booleanish,
        ariaMultiLine: booleanish,
        ariaMultiSelectable: booleanish,
        ariaOrientation: null,
        ariaOwns: spaceSeparated,
        ariaPlaceholder: null,
        ariaPosInSet: number,
        ariaPressed: booleanish,
        ariaReadOnly: booleanish,
        ariaRelevant: null,
        ariaRequired: booleanish,
        ariaRoleDescription: spaceSeparated,
        ariaRowCount: number,
        ariaRowIndex: number,
        ariaRowSpan: number,
        ariaSelected: booleanish,
        ariaSetSize: number,
        ariaSort: null,
        ariaValueMax: number,
        ariaValueMin: number,
        ariaValueNow: number,
        ariaValueText: null,
        role: null
    }
});
function ariaTransform(_, prop) {
    return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase();
}

},{"cc49de9f6bf70a3f":"elAF3","5bb8251263d6e2cd":"gxFKQ"}],"8Kx6T":[function(require,module,exports,__globalThis) {
'use strict';
var types = require("7622a582e65cde1e");
var create = require("58cbfc1b918fbf1a");
var caseInsensitiveTransform = require("a82c3091ed99eaae");
var boolean = types.boolean;
var overloadedBoolean = types.overloadedBoolean;
var booleanish = types.booleanish;
var number = types.number;
var spaceSeparated = types.spaceSeparated;
var commaSeparated = types.commaSeparated;
module.exports = create({
    space: 'html',
    attributes: {
        acceptcharset: 'accept-charset',
        classname: 'class',
        htmlfor: 'for',
        httpequiv: 'http-equiv'
    },
    transform: caseInsensitiveTransform,
    mustUseProperty: [
        'checked',
        'multiple',
        'muted',
        'selected'
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: commaSeparated,
        acceptCharset: spaceSeparated,
        accessKey: spaceSeparated,
        action: null,
        allow: null,
        allowFullScreen: boolean,
        allowPaymentRequest: boolean,
        allowUserMedia: boolean,
        alt: null,
        as: null,
        async: boolean,
        autoCapitalize: null,
        autoComplete: spaceSeparated,
        autoFocus: boolean,
        autoPlay: boolean,
        capture: boolean,
        charSet: null,
        checked: boolean,
        cite: null,
        className: spaceSeparated,
        cols: number,
        colSpan: null,
        content: null,
        contentEditable: booleanish,
        controls: boolean,
        controlsList: spaceSeparated,
        coords: number | commaSeparated,
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: boolean,
        defer: boolean,
        dir: null,
        dirName: null,
        disabled: boolean,
        download: overloadedBoolean,
        draggable: booleanish,
        encType: null,
        enterKeyHint: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: boolean,
        formTarget: null,
        headers: spaceSeparated,
        height: number,
        hidden: boolean,
        high: number,
        href: null,
        hrefLang: null,
        htmlFor: spaceSeparated,
        httpEquiv: spaceSeparated,
        id: null,
        imageSizes: null,
        imageSrcSet: commaSeparated,
        inputMode: null,
        integrity: null,
        is: null,
        isMap: boolean,
        itemId: null,
        itemProp: spaceSeparated,
        itemRef: spaceSeparated,
        itemScope: boolean,
        itemType: spaceSeparated,
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: boolean,
        low: number,
        manifest: null,
        max: null,
        maxLength: number,
        media: null,
        method: null,
        min: null,
        minLength: number,
        multiple: boolean,
        muted: boolean,
        name: null,
        nonce: null,
        noModule: boolean,
        noValidate: boolean,
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforePrint: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextMenu: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: boolean,
        optimum: number,
        pattern: null,
        ping: spaceSeparated,
        placeholder: null,
        playsInline: boolean,
        poster: null,
        preload: null,
        readOnly: boolean,
        referrerPolicy: null,
        rel: spaceSeparated,
        required: boolean,
        reversed: boolean,
        rows: number,
        rowSpan: number,
        sandbox: spaceSeparated,
        scope: null,
        scoped: boolean,
        seamless: boolean,
        selected: boolean,
        shape: null,
        size: number,
        sizes: null,
        slot: null,
        span: number,
        spellCheck: booleanish,
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: commaSeparated,
        start: number,
        step: null,
        style: null,
        tabIndex: number,
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: boolean,
        useMap: null,
        value: booleanish,
        width: number,
        wrap: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: spaceSeparated,
        axis: null,
        background: null,
        bgColor: null,
        border: number,
        borderColor: null,
        bottomMargin: number,
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: boolean,
        declare: boolean,
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: number,
        leftMargin: number,
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: number,
        marginWidth: number,
        noResize: boolean,
        noHref: boolean,
        noShade: boolean,
        noWrap: boolean,
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: number,
        rules: null,
        scheme: null,
        scrolling: booleanish,
        standby: null,
        summary: null,
        text: null,
        topMargin: number,
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: number,
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: boolean,
        disableRemotePlayback: boolean,
        prefix: null,
        property: null,
        results: number,
        security: null,
        unselectable: null
    }
});

},{"7622a582e65cde1e":"elAF3","58cbfc1b918fbf1a":"gxFKQ","a82c3091ed99eaae":"5gBK0"}],"6UDrF":[function(require,module,exports,__globalThis) {
'use strict';
var merge = require("e72ce6caa20496ad");
var xlink = require("c28b6a547f958674");
var xml = require("eb7b7ce6eead69d6");
var xmlns = require("d31932d8d9aa588f");
var aria = require("edfb32ce11f5763b");
var svg = require("4b42cec5922b5bfb");
module.exports = merge([
    xml,
    xlink,
    xmlns,
    aria,
    svg
]);

},{"e72ce6caa20496ad":"691K2","c28b6a547f958674":"l8jwY","eb7b7ce6eead69d6":"bcgcO","d31932d8d9aa588f":"5Aqcy","edfb32ce11f5763b":"i24eG","4b42cec5922b5bfb":"3kpwn"}],"3kpwn":[function(require,module,exports,__globalThis) {
'use strict';
var types = require("4cd74ec8d434e468");
var create = require("691615e49ab2e99d");
var caseSensitiveTransform = require("ffe6a8647ff13e30");
var boolean = types.boolean;
var number = types.number;
var spaceSeparated = types.spaceSeparated;
var commaSeparated = types.commaSeparated;
var commaOrSpaceSeparated = types.commaOrSpaceSeparated;
module.exports = create({
    space: 'svg',
    attributes: {
        accentHeight: 'accent-height',
        alignmentBaseline: 'alignment-baseline',
        arabicForm: 'arabic-form',
        baselineShift: 'baseline-shift',
        capHeight: 'cap-height',
        className: 'class',
        clipPath: 'clip-path',
        clipRule: 'clip-rule',
        colorInterpolation: 'color-interpolation',
        colorInterpolationFilters: 'color-interpolation-filters',
        colorProfile: 'color-profile',
        colorRendering: 'color-rendering',
        crossOrigin: 'crossorigin',
        dataType: 'datatype',
        dominantBaseline: 'dominant-baseline',
        enableBackground: 'enable-background',
        fillOpacity: 'fill-opacity',
        fillRule: 'fill-rule',
        floodColor: 'flood-color',
        floodOpacity: 'flood-opacity',
        fontFamily: 'font-family',
        fontSize: 'font-size',
        fontSizeAdjust: 'font-size-adjust',
        fontStretch: 'font-stretch',
        fontStyle: 'font-style',
        fontVariant: 'font-variant',
        fontWeight: 'font-weight',
        glyphName: 'glyph-name',
        glyphOrientationHorizontal: 'glyph-orientation-horizontal',
        glyphOrientationVertical: 'glyph-orientation-vertical',
        hrefLang: 'hreflang',
        horizAdvX: 'horiz-adv-x',
        horizOriginX: 'horiz-origin-x',
        horizOriginY: 'horiz-origin-y',
        imageRendering: 'image-rendering',
        letterSpacing: 'letter-spacing',
        lightingColor: 'lighting-color',
        markerEnd: 'marker-end',
        markerMid: 'marker-mid',
        markerStart: 'marker-start',
        navDown: 'nav-down',
        navDownLeft: 'nav-down-left',
        navDownRight: 'nav-down-right',
        navLeft: 'nav-left',
        navNext: 'nav-next',
        navPrev: 'nav-prev',
        navRight: 'nav-right',
        navUp: 'nav-up',
        navUpLeft: 'nav-up-left',
        navUpRight: 'nav-up-right',
        onAbort: 'onabort',
        onActivate: 'onactivate',
        onAfterPrint: 'onafterprint',
        onBeforePrint: 'onbeforeprint',
        onBegin: 'onbegin',
        onCancel: 'oncancel',
        onCanPlay: 'oncanplay',
        onCanPlayThrough: 'oncanplaythrough',
        onChange: 'onchange',
        onClick: 'onclick',
        onClose: 'onclose',
        onCopy: 'oncopy',
        onCueChange: 'oncuechange',
        onCut: 'oncut',
        onDblClick: 'ondblclick',
        onDrag: 'ondrag',
        onDragEnd: 'ondragend',
        onDragEnter: 'ondragenter',
        onDragExit: 'ondragexit',
        onDragLeave: 'ondragleave',
        onDragOver: 'ondragover',
        onDragStart: 'ondragstart',
        onDrop: 'ondrop',
        onDurationChange: 'ondurationchange',
        onEmptied: 'onemptied',
        onEnd: 'onend',
        onEnded: 'onended',
        onError: 'onerror',
        onFocus: 'onfocus',
        onFocusIn: 'onfocusin',
        onFocusOut: 'onfocusout',
        onHashChange: 'onhashchange',
        onInput: 'oninput',
        onInvalid: 'oninvalid',
        onKeyDown: 'onkeydown',
        onKeyPress: 'onkeypress',
        onKeyUp: 'onkeyup',
        onLoad: 'onload',
        onLoadedData: 'onloadeddata',
        onLoadedMetadata: 'onloadedmetadata',
        onLoadStart: 'onloadstart',
        onMessage: 'onmessage',
        onMouseDown: 'onmousedown',
        onMouseEnter: 'onmouseenter',
        onMouseLeave: 'onmouseleave',
        onMouseMove: 'onmousemove',
        onMouseOut: 'onmouseout',
        onMouseOver: 'onmouseover',
        onMouseUp: 'onmouseup',
        onMouseWheel: 'onmousewheel',
        onOffline: 'onoffline',
        onOnline: 'ononline',
        onPageHide: 'onpagehide',
        onPageShow: 'onpageshow',
        onPaste: 'onpaste',
        onPause: 'onpause',
        onPlay: 'onplay',
        onPlaying: 'onplaying',
        onPopState: 'onpopstate',
        onProgress: 'onprogress',
        onRateChange: 'onratechange',
        onRepeat: 'onrepeat',
        onReset: 'onreset',
        onResize: 'onresize',
        onScroll: 'onscroll',
        onSeeked: 'onseeked',
        onSeeking: 'onseeking',
        onSelect: 'onselect',
        onShow: 'onshow',
        onStalled: 'onstalled',
        onStorage: 'onstorage',
        onSubmit: 'onsubmit',
        onSuspend: 'onsuspend',
        onTimeUpdate: 'ontimeupdate',
        onToggle: 'ontoggle',
        onUnload: 'onunload',
        onVolumeChange: 'onvolumechange',
        onWaiting: 'onwaiting',
        onZoom: 'onzoom',
        overlinePosition: 'overline-position',
        overlineThickness: 'overline-thickness',
        paintOrder: 'paint-order',
        panose1: 'panose-1',
        pointerEvents: 'pointer-events',
        referrerPolicy: 'referrerpolicy',
        renderingIntent: 'rendering-intent',
        shapeRendering: 'shape-rendering',
        stopColor: 'stop-color',
        stopOpacity: 'stop-opacity',
        strikethroughPosition: 'strikethrough-position',
        strikethroughThickness: 'strikethrough-thickness',
        strokeDashArray: 'stroke-dasharray',
        strokeDashOffset: 'stroke-dashoffset',
        strokeLineCap: 'stroke-linecap',
        strokeLineJoin: 'stroke-linejoin',
        strokeMiterLimit: 'stroke-miterlimit',
        strokeOpacity: 'stroke-opacity',
        strokeWidth: 'stroke-width',
        tabIndex: 'tabindex',
        textAnchor: 'text-anchor',
        textDecoration: 'text-decoration',
        textRendering: 'text-rendering',
        typeOf: 'typeof',
        underlinePosition: 'underline-position',
        underlineThickness: 'underline-thickness',
        unicodeBidi: 'unicode-bidi',
        unicodeRange: 'unicode-range',
        unitsPerEm: 'units-per-em',
        vAlphabetic: 'v-alphabetic',
        vHanging: 'v-hanging',
        vIdeographic: 'v-ideographic',
        vMathematical: 'v-mathematical',
        vectorEffect: 'vector-effect',
        vertAdvY: 'vert-adv-y',
        vertOriginX: 'vert-origin-x',
        vertOriginY: 'vert-origin-y',
        wordSpacing: 'word-spacing',
        writingMode: 'writing-mode',
        xHeight: 'x-height',
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: 'playbackorder',
        timelineBegin: 'timelinebegin'
    },
    transform: caseSensitiveTransform,
    properties: {
        about: commaOrSpaceSeparated,
        accentHeight: number,
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: number,
        amplitude: number,
        arabicForm: null,
        ascent: number,
        attributeName: null,
        attributeType: null,
        azimuth: number,
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: number,
        by: null,
        calcMode: null,
        capHeight: number,
        className: spaceSeparated,
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: number,
        diffuseConstant: number,
        direction: null,
        display: null,
        dur: null,
        divisor: number,
        dominantBaseline: null,
        download: boolean,
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: number,
        enableBackground: null,
        end: null,
        event: null,
        exponent: number,
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: number,
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: commaSeparated,
        g2: commaSeparated,
        glyphName: commaSeparated,
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: number,
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: number,
        horizOriginX: number,
        horizOriginY: number,
        id: null,
        ideographic: number,
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: number,
        k: number,
        k1: number,
        k2: number,
        k3: number,
        k4: number,
        kernelMatrix: commaOrSpaceSeparated,
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: number,
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: number,
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: number,
        overlineThickness: number,
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: number,
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: spaceSeparated,
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: number,
        pointsAtY: number,
        pointsAtZ: number,
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: commaOrSpaceSeparated,
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: commaOrSpaceSeparated,
        rev: commaOrSpaceSeparated,
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: commaOrSpaceSeparated,
        requiredFeatures: commaOrSpaceSeparated,
        requiredFonts: commaOrSpaceSeparated,
        requiredFormats: commaOrSpaceSeparated,
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: number,
        specularExponent: number,
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: number,
        strikethroughThickness: number,
        string: null,
        stroke: null,
        strokeDashArray: commaOrSpaceSeparated,
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: number,
        strokeOpacity: number,
        strokeWidth: null,
        style: null,
        surfaceScale: number,
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: commaOrSpaceSeparated,
        tabIndex: number,
        tableValues: null,
        target: null,
        targetX: number,
        targetY: number,
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: commaOrSpaceSeparated,
        to: null,
        transform: null,
        u1: null,
        u2: null,
        underlinePosition: number,
        underlineThickness: number,
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: number,
        values: null,
        vAlphabetic: number,
        vMathematical: number,
        vectorEffect: null,
        vHanging: number,
        vIdeographic: number,
        version: null,
        vertAdvY: number,
        vertOriginX: number,
        vertOriginY: number,
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: number,
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    }
});

},{"4cd74ec8d434e468":"elAF3","691615e49ab2e99d":"gxFKQ","ffe6a8647ff13e30":"12uQM"}],"kJbfs":[function(require,module,exports,__globalThis) {
'use strict';
var normalize = require("acac6918aed11923");
var DefinedInfo = require("60cbd75c54f0c606");
var Info = require("cd9d1902463e5c80");
var data = 'data';
module.exports = find;
var valid = /^data[-\w.:]+$/i;
var dash = /-[a-z]/g;
var cap = /[A-Z]/g;
function find(schema, value) {
    var normal = normalize(value);
    var prop = value;
    var Type = Info;
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === data && valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === '-') prop = datasetToProperty(value);
        else value = datasetToAttribute(value);
        Type = DefinedInfo;
    }
    return new Type(prop, value);
}
function datasetToProperty(attribute) {
    var value = attribute.slice(5).replace(dash, camelcase);
    return data + value.charAt(0).toUpperCase() + value.slice(1);
}
function datasetToAttribute(property) {
    var value = property.slice(4);
    if (dash.test(value)) return property;
    value = value.replace(cap, kebab);
    if (value.charAt(0) !== '-') value = '-' + value;
    return data + value;
}
function kebab($0) {
    return '-' + $0.toLowerCase();
}
function camelcase($0) {
    return $0.charAt(1).toUpperCase();
}

},{"acac6918aed11923":"82dea","60cbd75c54f0c606":"dBBaV","cd9d1902463e5c80":"dpy8m"}],"im14n":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"classId\":\"classID\",\"dataType\":\"datatype\",\"itemId\":\"itemID\",\"strokeDashArray\":\"strokeDasharray\",\"strokeDashOffset\":\"strokeDashoffset\",\"strokeLineCap\":\"strokeLinecap\",\"strokeLineJoin\":\"strokeLinejoin\",\"strokeMiterLimit\":\"strokeMiterlimit\",\"typeOf\":\"typeof\",\"xLinkActuate\":\"xlinkActuate\",\"xLinkArcRole\":\"xlinkArcrole\",\"xLinkHref\":\"xlinkHref\",\"xLinkRole\":\"xlinkRole\",\"xLinkShow\":\"xlinkShow\",\"xLinkTitle\":\"xlinkTitle\",\"xLinkType\":\"xlinkType\",\"xmlnsXLink\":\"xmlnsXlink\"}");

},{}],"i0pvy":[function(require,module,exports,__globalThis) {
'use strict';
exports.parse = parse;
exports.stringify = stringify;
var empty = '';
var space = ' ';
var whiteSpace = /[ \t\n\r\f]+/g;
function parse(value) {
    var input = String(value || empty).trim();
    return input === empty ? [] : input.split(whiteSpace);
}
function stringify(values) {
    return values.join(space).trim();
}

},{}],"iS7qW":[function(require,module,exports,__globalThis) {
'use strict';
exports.parse = parse;
exports.stringify = stringify;
var comma = ',';
var space = ' ';
var empty = '';
// Parse comma-separated tokens to an array.
function parse(value) {
    var values = [];
    var input = String(value || empty);
    var index = input.indexOf(comma);
    var lastIndex = 0;
    var end = false;
    var val;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        val = input.slice(lastIndex, index).trim();
        if (val || !end) values.push(val);
        lastIndex = index + 1;
        index = input.indexOf(comma, lastIndex);
    }
    return values;
}
// Compile an array to comma-separated tokens.
// `options.padLeft` (default: `true`) pads a space left of each token, and
// `options.padRight` (default: `false`) pads a space to the right of each token.
function stringify(values, options) {
    var settings = options || {};
    var left = settings.padLeft === false ? empty : space;
    var right = settings.padRight ? space : empty;
    // Ensure the last empty entry is seen.
    if (values[values.length - 1] === empty) values = values.concat(empty);
    return values.join(right + comma + left).trim();
}

},{}],"6km9Q":[function(require,module,exports,__globalThis) {
var parse = require("759915488e5e2e5");
/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */ function StyleToObject(style, iterator) {
    var output = null;
    if (!style || typeof style !== 'string') return output;
    var declaration;
    var declarations = parse(style);
    var hasIterator = typeof iterator === 'function';
    var property;
    var value;
    for(var i = 0, len = declarations.length; i < len; i++){
        declaration = declarations[i];
        property = declaration.property;
        value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            output || (output = {});
            output[property] = value;
        }
    }
    return output;
}
module.exports = StyleToObject;

},{"759915488e5e2e5":"bCJYb"}],"bCJYb":[function(require,module,exports,__globalThis) {
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var NEWLINE_REGEX = /\n/g;
var WHITESPACE_REGEX = /^\s*/;
// declaration
var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var COLON_REGEX = /^:\s*/;
var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var TRIM_REGEX = /^\s+|\s+$/g;
// strings
var NEWLINE = '\n';
var FORWARD_SLASH = '/';
var ASTERISK = '*';
var EMPTY_STRING = '';
// types
var TYPE_COMMENT = 'comment';
var TYPE_DECLARATION = 'declaration';
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ module.exports = function(style, options) {
    if (typeof style !== 'string') throw new TypeError('First argument must be a string');
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match(NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf(NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ':' + lineno + ':' + column + ': ' + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match(WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;
        var i = 2;
        while(EMPTY_STRING != style.charAt(i) && (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if (EMPTY_STRING === style.charAt(i - 1)) return error('End of comment missing');
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match(PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match(COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match(VALUE_REGEX);
        var ret = pos({
            type: TYPE_DECLARATION,
            property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
            value: val ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING)) : EMPTY_STRING
        });
        // ;
        match(SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function trim(str) {
    return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
}

},{}],"gHbL8":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"html\":\"http://www.w3.org/1999/xhtml\",\"mathml\":\"http://www.w3.org/1998/Math/MathML\",\"svg\":\"http://www.w3.org/2000/svg\",\"xlink\":\"http://www.w3.org/1999/xlink\",\"xml\":\"http://www.w3.org/XML/1998/namespace\",\"xmlns\":\"http://www.w3.org/2000/xmlns/\"}");

},{}],"dJ5c9":[function(require,module,exports,__globalThis) {
'use strict';
var visit = require("4163264a45882cfe");
var hasOwnProperty = Object.prototype.hasOwnProperty;
var hastCssPropertyMap = {
    align: 'text-align',
    valign: 'vertical-align',
    height: 'height',
    width: 'width'
};
module.exports = function tableCellStyle(node) {
    visit(node, 'element', visitor);
    return node;
};
function visitor(node) {
    if (node.tagName !== 'tr' && node.tagName !== 'td' && node.tagName !== 'th') return;
    var hastName;
    var cssName;
    for(hastName in hastCssPropertyMap){
        if (!hasOwnProperty.call(hastCssPropertyMap, hastName) || node.properties[hastName] === undefined) continue;
        cssName = hastCssPropertyMap[hastName];
        appendStyle(node, cssName, node.properties[hastName]);
        delete node.properties[hastName];
    }
}
function appendStyle(node, property, value) {
    var prevStyle = (node.properties.style || '').trim();
    if (prevStyle && !/;\s*/.test(prevStyle)) prevStyle += ';';
    if (prevStyle) prevStyle += ' ';
    var nextStyle = prevStyle + property + ': ' + value + ';';
    node.properties.style = nextStyle;
}

},{"4163264a45882cfe":"3LvCO"}],"3LvCO":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = visit;
var visitParents = require("a68c85177212527c");
var CONTINUE = visitParents.CONTINUE;
var SKIP = visitParents.SKIP;
var EXIT = visitParents.EXIT;
visit.CONTINUE = CONTINUE;
visit.SKIP = SKIP;
visit.EXIT = EXIT;
function visit(tree, test, visitor, reverse) {
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    visitParents(tree, test, overload, reverse);
    function overload(node, parents) {
        var parent = parents[parents.length - 1];
        var index = parent ? parent.children.indexOf(node) : null;
        return visitor(node, index, parent);
    }
}

},{"a68c85177212527c":"sjXTu"}],"sjXTu":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = visitParents;
var convert = require("144fd0d8ef44f6b4");
var CONTINUE = true;
var SKIP = 'skip';
var EXIT = false;
visitParents.CONTINUE = CONTINUE;
visitParents.SKIP = SKIP;
visitParents.EXIT = EXIT;
function visitParents(tree, test, visitor, reverse) {
    var is;
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    is = convert(test);
    one(tree, null, []);
    // Visit a single node.
    function one(node, index, parents) {
        var result = [];
        var subresult;
        if (!test || is(node, index, parents[parents.length - 1] || null)) {
            result = toResult(visitor(node, parents));
            if (result[0] === EXIT) return result;
        }
        if (node.children && result[0] !== SKIP) {
            subresult = toResult(all(node.children, parents.concat(node)));
            return subresult[0] === EXIT ? subresult : result;
        }
        return result;
    }
    // Visit children in `parent`.
    function all(children, parents) {
        var min = -1;
        var step = reverse ? -1 : 1;
        var index = (reverse ? children.length : min) + step;
        var result;
        while(index > min && index < children.length){
            result = one(children[index], index, parents);
            if (result[0] === EXIT) return result;
            index = typeof result[1] === 'number' ? result[1] : index + step;
        }
    }
}
function toResult(value) {
    if (value !== null && typeof value === 'object' && 'length' in value) return value;
    if (typeof value === 'number') return [
        CONTINUE,
        value
    ];
    return [
        value
    ];
}

},{"144fd0d8ef44f6b4":"3YgjM"}],"3YgjM":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = convert;
function convert(test) {
    if (typeof test === 'string') return typeFactory(test);
    if (test === null || test === undefined) return ok;
    if (typeof test === 'object') return ('length' in test ? anyFactory : matchesFactory)(test);
    if (typeof test === 'function') return test;
    throw new Error('Expected function, string, or object as test');
}
function convertAll(tests) {
    var results = [];
    var length = tests.length;
    var index = -1;
    while(++index < length)results[index] = convert(tests[index]);
    return results;
}
// Utility assert each property in `test` is represented in `node`, and each
// values are strictly equal.
function matchesFactory(test) {
    return matches;
    function matches(node) {
        var key;
        for(key in test){
            if (node[key] !== test[key]) return false;
        }
        return true;
    }
}
function anyFactory(tests) {
    var checks = convertAll(tests);
    var length = checks.length;
    return matches;
    function matches() {
        var index = -1;
        while(++index < length){
            if (checks[index].apply(this, arguments)) return true;
        }
        return false;
    }
}
// Utility to convert a string into a function which checks a given node’s type
// for said string.
function typeFactory(test) {
    return type;
    function type(node) {
        return Boolean(node && node.type === test);
    }
}
// Utility to return true.
function ok() {
    return true;
}

},{}],"3O2Eh":[function(require,module,exports,__globalThis) {
'use strict';
var syntax = require("862674769853aaa1");
var fromMarkdown = require("3a5f5a7ab5226803");
var toMarkdown = require("a9f3fa6af3a67f37");
var warningIssued;
module.exports = gfm;
function gfm(options) {
    var data = this.data();
    /* istanbul ignore next - old remark. */ if (!warningIssued && (this.Parser && this.Parser.prototype && this.Parser.prototype.blockTokenizers || this.Compiler && this.Compiler.prototype && this.Compiler.prototype.visitors)) {
        warningIssued = true;
        console.warn('[remark-gfm] Warning: please upgrade to remark 13 to use this plugin');
    }
    add('micromarkExtensions', syntax(options));
    add('fromMarkdownExtensions', fromMarkdown);
    add('toMarkdownExtensions', toMarkdown(options));
    function add(field, value) {
        /* istanbul ignore if - other extensions. */ if (data[field]) data[field].push(value);
        else data[field] = [
            value
        ];
    }
}

},{"862674769853aaa1":"d4XJH","3a5f5a7ab5226803":"kaH66","a9f3fa6af3a67f37":"9w9zT"}],"d4XJH":[function(require,module,exports,__globalThis) {
module.exports = require("443a61a07f702dc1");

},{"443a61a07f702dc1":"eLDk0"}],"eLDk0":[function(require,module,exports,__globalThis) {
var combine = require("aeecb620ffbc1adb");
var autolink = require("10071e81f6aba206");
var strikethrough = require("592e8bc7986d346b");
var table = require("c392ee67318ae664");
var tasklist = require("1f45536323b7b772");
module.exports = create;
function create(options) {
    return combine([
        autolink,
        strikethrough(options),
        table,
        tasklist
    ]);
}

},{"aeecb620ffbc1adb":"iyaj2","10071e81f6aba206":"3ewxy","592e8bc7986d346b":"hgArI","c392ee67318ae664":"kdmxC","1f45536323b7b772":"646bH"}],"3ewxy":[function(require,module,exports,__globalThis) {
module.exports = require("9fe03c6af57f67a1");

},{"9fe03c6af57f67a1":"auAYL"}],"auAYL":[function(require,module,exports,__globalThis) {
var asciiAlpha = require("566b66a2beea309c");
var asciiAlphanumeric = require("dbb8463466d27832");
var asciiControl = require("3ef4a7d4bfa60c77");
var markdownLineEnding = require("72a402d674e83905");
var unicodePunctuation = require("ba9cf92316960e35");
var unicodeWhitespace = require("9c0e25299ebcac7");
var www = {
    tokenize: tokenizeWww,
    partial: true
};
var domain = {
    tokenize: tokenizeDomain,
    partial: true
};
var path = {
    tokenize: tokenizePath,
    partial: true
};
var punctuation = {
    tokenize: tokenizePunctuation,
    partial: true
};
var namedCharacterReference = {
    tokenize: tokenizeNamedCharacterReference,
    partial: true
};
var wwwAutolink = {
    tokenize: tokenizeWwwAutolink,
    previous: previousWww
};
var httpAutolink = {
    tokenize: tokenizeHttpAutolink,
    previous: previousHttp
};
var emailAutolink = {
    tokenize: tokenizeEmailAutolink,
    previous: previousEmail
};
var text = {};
// Export hooked constructs.
exports.text = text;
// `0`
var code = 48;
// While the code is smaller than `{`.
while(code < 123){
    text[code] = emailAutolink;
    code++;
    // Jump from `:` -> `A`
    if (code === 58) code = 65;
    else if (code === 91) code = 97;
}
// `+`
text[43] = emailAutolink;
// `-`
text[45] = emailAutolink;
// `.`
text[46] = emailAutolink;
// `_`
text[95] = emailAutolink;
// `h`.
text[72] = [
    emailAutolink,
    httpAutolink
];
text[104] = [
    emailAutolink,
    httpAutolink
];
// `w`.
text[87] = [
    emailAutolink,
    wwwAutolink
];
text[119] = [
    emailAutolink,
    wwwAutolink
];
function tokenizeEmailAutolink(effects, ok, nok) {
    var self = this;
    var hasDot;
    return start;
    function start(code) {
        /* istanbul ignore next - hooks. */ if (!gfmAtext(code) || !previousEmail(self.previous) || previous(self.events)) return nok(code);
        effects.enter('literalAutolink');
        effects.enter('literalAutolinkEmail');
        return atext(code);
    }
    function atext(code) {
        if (gfmAtext(code)) {
            effects.consume(code);
            return atext;
        }
        // `@`
        if (code === 64) {
            effects.consume(code);
            return label;
        }
        return nok(code);
    }
    function label(code) {
        // `.`
        if (code === 46) return effects.check(punctuation, done, dotContinuation)(code);
        if (// `-`
        code === 45 || // `_`
        code === 95) return effects.check(punctuation, nok, dashOrUnderscoreContinuation)(code);
        if (asciiAlphanumeric(code)) {
            effects.consume(code);
            return label;
        }
        return done(code);
    }
    function dotContinuation(code) {
        effects.consume(code);
        hasDot = true;
        return label;
    }
    function dashOrUnderscoreContinuation(code) {
        effects.consume(code);
        return afterDashOrUnderscore;
    }
    function afterDashOrUnderscore(code) {
        // `.`
        if (code === 46) return effects.check(punctuation, nok, dotContinuation)(code);
        return label(code);
    }
    function done(code) {
        if (hasDot) {
            effects.exit('literalAutolinkEmail');
            effects.exit('literalAutolink');
            return ok(code);
        }
        return nok(code);
    }
}
function tokenizeWwwAutolink(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        /* istanbul ignore next - hooks. */ if (code !== 87 && code - 32 !== 87 || !previousWww(self.previous) || previous(self.events)) return nok(code);
        effects.enter('literalAutolink');
        effects.enter('literalAutolinkWww');
        // For `www.` we check instead of attempt, because when it matches, GH
        // treats it as part of a domain (yes, it says a valid domain must come
        // after `www.`, but that’s not how it’s implemented by them).
        return effects.check(www, effects.attempt(domain, effects.attempt(path, done), nok), nok)(code);
    }
    function done(code) {
        effects.exit('literalAutolinkWww');
        effects.exit('literalAutolink');
        return ok(code);
    }
}
function tokenizeHttpAutolink(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        /* istanbul ignore next - hooks. */ if (code !== 72 && code - 32 !== 72 || !previousHttp(self.previous) || previous(self.events)) return nok(code);
        effects.enter('literalAutolink');
        effects.enter('literalAutolinkHttp');
        effects.consume(code);
        return t1;
    }
    function t1(code) {
        // `t`
        if (code === 84 || code - 32 === 84) {
            effects.consume(code);
            return t2;
        }
        return nok(code);
    }
    function t2(code) {
        // `t`
        if (code === 84 || code - 32 === 84) {
            effects.consume(code);
            return p;
        }
        return nok(code);
    }
    function p(code) {
        // `p`
        if (code === 80 || code - 32 === 80) {
            effects.consume(code);
            return s;
        }
        return nok(code);
    }
    function s(code) {
        // `s`
        if (code === 83 || code - 32 === 83) {
            effects.consume(code);
            return colon;
        }
        return colon(code);
    }
    function colon(code) {
        // `:`
        if (code === 58) {
            effects.consume(code);
            return slash1;
        }
        return nok(code);
    }
    function slash1(code) {
        // `/`
        if (code === 47) {
            effects.consume(code);
            return slash2;
        }
        return nok(code);
    }
    function slash2(code) {
        // `/`
        if (code === 47) {
            effects.consume(code);
            return after;
        }
        return nok(code);
    }
    function after(code) {
        return asciiControl(code) || unicodeWhitespace(code) || unicodePunctuation(code) ? nok(code) : effects.attempt(domain, effects.attempt(path, done), nok)(code);
    }
    function done(code) {
        effects.exit('literalAutolinkHttp');
        effects.exit('literalAutolink');
        return ok(code);
    }
}
function tokenizeWww(effects, ok, nok) {
    return start;
    function start(code) {
        // Assume a `w`.
        effects.consume(code);
        return w2;
    }
    function w2(code) {
        // `w`
        if (code === 87 || code - 32 === 87) {
            effects.consume(code);
            return w3;
        }
        return nok(code);
    }
    function w3(code) {
        // `w`
        if (code === 87 || code - 32 === 87) {
            effects.consume(code);
            return dot;
        }
        return nok(code);
    }
    function dot(code) {
        // `.`
        if (code === 46) {
            effects.consume(code);
            return after;
        }
        return nok(code);
    }
    function after(code) {
        return code === null || markdownLineEnding(code) ? nok(code) : ok(code);
    }
}
function tokenizeDomain(effects, ok, nok) {
    var hasUnderscoreInLastSegment;
    var hasUnderscoreInLastLastSegment;
    return domain;
    function domain(code) {
        // `&`
        if (code === 38) return effects.check(namedCharacterReference, done, punctuationContinuation)(code);
        if (code === 46 /* `.` */  || code === 95 /* `_` */ ) return effects.check(punctuation, done, punctuationContinuation)(code);
        // GH documents that only alphanumerics (other than `-`, `.`, and `_`) can
        // occur, which sounds like ASCII only, but they also support `www.點看.com`,
        // so that’s Unicode.
        // Instead of some new production for Unicode alphanumerics, markdown
        // already has that for Unicode punctuation and whitespace, so use those.
        if (asciiControl(code) || unicodeWhitespace(code) || code !== 45 /* `-` */  && unicodePunctuation(code)) return done(code);
        effects.consume(code);
        return domain;
    }
    function punctuationContinuation(code) {
        // `.`
        if (code === 46) {
            hasUnderscoreInLastLastSegment = hasUnderscoreInLastSegment;
            hasUnderscoreInLastSegment = undefined;
            effects.consume(code);
            return domain;
        }
        // `_`
        if (code === 95) hasUnderscoreInLastSegment = true;
        effects.consume(code);
        return domain;
    }
    function done(code) {
        if (!hasUnderscoreInLastLastSegment && !hasUnderscoreInLastSegment) return ok(code);
        return nok(code);
    }
}
function tokenizePath(effects, ok) {
    var balance = 0;
    return inPath;
    function inPath(code) {
        // `&`
        if (code === 38) return effects.check(namedCharacterReference, ok, continuedPunctuation)(code);
        // `(`
        if (code === 40) balance++;
        // `)`
        if (code === 41) return effects.check(punctuation, parenAtPathEnd, continuedPunctuation)(code);
        if (pathEnd(code)) return ok(code);
        if (trailingPunctuation(code)) return effects.check(punctuation, ok, continuedPunctuation)(code);
        effects.consume(code);
        return inPath;
    }
    function continuedPunctuation(code) {
        effects.consume(code);
        return inPath;
    }
    function parenAtPathEnd(code) {
        balance--;
        return balance < 0 ? ok(code) : continuedPunctuation(code);
    }
}
function tokenizeNamedCharacterReference(effects, ok, nok) {
    return start;
    function start(code) {
        // Assume an ampersand.
        effects.consume(code);
        return inside;
    }
    function inside(code) {
        if (asciiAlpha(code)) {
            effects.consume(code);
            return inside;
        }
        // `;`
        if (code === 59) {
            effects.consume(code);
            return after;
        }
        return nok(code);
    }
    function after(code) {
        // If the named character reference is followed by the end of the path, it’s
        // not continued punctuation.
        return pathEnd(code) ? ok(code) : nok(code);
    }
}
function tokenizePunctuation(effects, ok, nok) {
    return start;
    function start(code) {
        // Always a valid trailing punctuation marker.
        effects.consume(code);
        return after;
    }
    function after(code) {
        // Check the next.
        if (trailingPunctuation(code)) {
            effects.consume(code);
            return after;
        }
        // If the punctuation marker is followed by the end of the path, it’s not
        // continued punctuation.
        return pathEnd(code) ? ok(code) : nok(code);
    }
}
function trailingPunctuation(code) {
    return(// `!`
    code === 33 || // `"`
    code === 34 || // `'`
    code === 39 || // `)`
    code === 41 || // `*`
    code === 42 || // `,`
    code === 44 || // `.`
    code === 46 || // `:`
    code === 58 || // `;`
    code === 59 || // `<`
    code === 60 || // `?`
    code === 63 || // `_`.
    code === 95 || // `~`
    code === 126);
}
function pathEnd(code) {
    return(// EOF.
    code === null || // CR, LF, CRLF, HT, VS.
    code < 0 || // Space.
    code === 32 || // `<`
    code === 60);
}
function gfmAtext(code) {
    return code === 43 /* `+` */  || code === 45 /* `-` */  || code === 46 /* `.` */  || code === 95 /* `_` */  || asciiAlphanumeric(code);
}
function previousWww(code) {
    return code === null || code < 0 || code === 32 /* ` ` */  || code === 40 /* `(` */  || code === 42 /* `*` */  || code === 95 /* `_` */  || code === 126 /* `~` */ ;
}
function previousHttp(code) {
    return code === null || !asciiAlpha(code);
}
function previousEmail(code) {
    return code !== 47 /* `/` */  && previousHttp(code);
}
function previous(events) {
    var index = events.length;
    while(index--){
        if ((events[index][1].type === 'labelLink' || events[index][1].type === 'labelImage') && !events[index][1]._balanced) return true;
    }
}

},{"566b66a2beea309c":"JyKN0","dbb8463466d27832":"iEUqG","3ef4a7d4bfa60c77":"a3AmJ","72a402d674e83905":"gpLlx","ba9cf92316960e35":"f8iPV","9c0e25299ebcac7":"h01cg"}],"hgArI":[function(require,module,exports,__globalThis) {
module.exports = create;
var classifyCharacter = require("10a861efdc9cb20b");
var chunkedSplice = require("e2e0a52b58fc8332");
var resolveAll = require("5dbee8478f42d7d1");
var shallow = require("242230af8fbb733");
function create(options) {
    var settings = options || {};
    var single = settings.singleTilde;
    var tokenizer = {
        tokenize: tokenizeStrikethrough,
        resolveAll: resolveAllStrikethrough
    };
    if (single === null || single === undefined) single = true;
    return {
        text: {
            126: tokenizer
        },
        insideSpan: {
            null: tokenizer
        }
    };
    // Take events and resolve strikethrough.
    function resolveAllStrikethrough(events, context) {
        var index = -1;
        var strikethrough;
        var text;
        var open;
        var nextEvents;
        // Walk through all events.
        while(++index < events.length)// Find a token that can close.
        if (events[index][0] === 'enter' && events[index][1].type === 'strikethroughSequenceTemporary' && events[index][1]._close) {
            open = index;
            // Now walk back to find an opener.
            while(open--)// Find a token that can open the closer.
            if (events[open][0] === 'exit' && events[open][1].type === 'strikethroughSequenceTemporary' && events[open][1]._open && // If the sizes are the same:
            events[index][1].end.offset - events[index][1].start.offset === events[open][1].end.offset - events[open][1].start.offset) {
                events[index][1].type = 'strikethroughSequence';
                events[open][1].type = 'strikethroughSequence';
                strikethrough = {
                    type: 'strikethrough',
                    start: shallow(events[open][1].start),
                    end: shallow(events[index][1].end)
                };
                text = {
                    type: 'strikethroughText',
                    start: shallow(events[open][1].end),
                    end: shallow(events[index][1].start)
                };
                // Opening.
                nextEvents = [
                    [
                        'enter',
                        strikethrough,
                        context
                    ],
                    [
                        'enter',
                        events[open][1],
                        context
                    ],
                    [
                        'exit',
                        events[open][1],
                        context
                    ],
                    [
                        'enter',
                        text,
                        context
                    ]
                ];
                // Between.
                chunkedSplice(nextEvents, nextEvents.length, 0, resolveAll(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
                // Closing.
                chunkedSplice(nextEvents, nextEvents.length, 0, [
                    [
                        'exit',
                        text,
                        context
                    ],
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        strikethrough,
                        context
                    ]
                ]);
                chunkedSplice(events, open - 1, index - open + 3, nextEvents);
                index = open + nextEvents.length - 2;
                break;
            }
        }
        return removeRemainingSequences(events);
    }
    function removeRemainingSequences(events) {
        var index = -1;
        var length = events.length;
        while(++index < length)if (events[index][1].type === 'strikethroughSequenceTemporary') events[index][1].type = 'data';
        return events;
    }
    function tokenizeStrikethrough(effects, ok, nok) {
        var previous = this.previous;
        var events = this.events;
        var size = 0;
        return start;
        function start(code) {
            if (code !== 126 || previous === 126 && events[events.length - 1][1].type !== 'characterEscape') return nok(code);
            effects.enter('strikethroughSequenceTemporary');
            return more(code);
        }
        function more(code) {
            var before = classifyCharacter(previous);
            var token;
            var after;
            if (code === 126) {
                // If this is the third marker, exit.
                if (size > 1) return nok(code);
                effects.consume(code);
                size++;
                return more;
            }
            if (size < 2 && !single) return nok(code);
            token = effects.exit('strikethroughSequenceTemporary');
            after = classifyCharacter(code);
            token._open = !after || after === 2 && before;
            token._close = !before || before === 2 && after;
            return ok(code);
        }
    }
}

},{"10a861efdc9cb20b":"lUfbP","e2e0a52b58fc8332":"dXntd","5dbee8478f42d7d1":"lIGEx","242230af8fbb733":"aBApX"}],"kdmxC":[function(require,module,exports,__globalThis) {
module.exports = require("18d3de220891bb69");

},{"18d3de220891bb69":"k5alz"}],"k5alz":[function(require,module,exports,__globalThis) {
exports.flow = {
    null: {
        tokenize: tokenizeTable,
        resolve: resolveTable,
        interruptible: true
    }
};
var createSpace = require("b7aeba0ff2dbfcf9");
var setextUnderlineMini = {
    tokenize: tokenizeSetextUnderlineMini,
    partial: true
};
var nextPrefixedOrBlank = {
    tokenize: tokenizeNextPrefixedOrBlank,
    partial: true
};
function resolveTable(events, context) {
    var length = events.length;
    var index = -1;
    var token;
    var inHead;
    var inDelimiterRow;
    var inRow;
    var cell;
    var content;
    var text;
    var contentStart;
    var contentEnd;
    var cellStart;
    while(++index < length){
        token = events[index][1];
        if (inRow) {
            if (token.type === 'temporaryTableCellContent') {
                contentStart = contentStart || index;
                contentEnd = index;
            }
            if (// Combine separate content parts into one.
            (token.type === 'tableCellDivider' || token.type === 'tableRow') && contentEnd) {
                content = {
                    type: 'tableContent',
                    start: events[contentStart][1].start,
                    end: events[contentEnd][1].end
                };
                text = {
                    type: 'chunkText',
                    start: content.start,
                    end: content.end,
                    contentType: 'text'
                };
                events.splice(contentStart, contentEnd - contentStart + 1, [
                    'enter',
                    content,
                    context
                ], [
                    'enter',
                    text,
                    context
                ], [
                    'exit',
                    text,
                    context
                ], [
                    'exit',
                    content,
                    context
                ]);
                index -= contentEnd - contentStart - 3;
                length = events.length;
                contentStart = undefined;
                contentEnd = undefined;
            }
        }
        if (events[index][0] === 'exit' && cellStart && cellStart + 1 < index && (token.type === 'tableCellDivider' || token.type === 'tableRow' && (cellStart + 3 < index || events[cellStart][1].type !== 'whitespace'))) {
            cell = {
                type: inDelimiterRow ? 'tableDelimiter' : inHead ? 'tableHeader' : 'tableData',
                start: events[cellStart][1].start,
                end: events[index][1].end
            };
            events.splice(index + (token.type === 'tableCellDivider' ? 1 : 0), 0, [
                'exit',
                cell,
                context
            ]);
            events.splice(cellStart, 0, [
                'enter',
                cell,
                context
            ]);
            index += 2;
            length = events.length;
            cellStart = index + 1;
        }
        if (token.type === 'tableRow') {
            inRow = events[index][0] === 'enter';
            if (inRow) cellStart = index + 1;
        }
        if (token.type === 'tableDelimiterRow') {
            inDelimiterRow = events[index][0] === 'enter';
            if (inDelimiterRow) cellStart = index + 1;
        }
        if (token.type === 'tableHead') inHead = events[index][0] === 'enter';
    }
    return events;
}
function tokenizeTable(effects, ok, nok) {
    var align = [];
    var tableHeaderCount = 0;
    var seenDelimiter;
    var hasDash;
    return start;
    function start(code) {
        /* istanbul ignore if - used to be passed in beta micromark versions. */ if (code === null || code === -5 || code === -4 || code === -3) return nok(code);
        effects.enter('table')._align = align;
        effects.enter('tableHead');
        effects.enter('tableRow');
        // If we start with a pipe, we open a cell marker.
        if (code === 124) return cellDividerHead(code);
        tableHeaderCount++;
        effects.enter('temporaryTableCellContent');
        // Can’t be space or eols at the start of a construct, so we’re in a cell.
        return inCellContentHead(code);
    }
    function cellDividerHead(code) {
        // Always a pipe.
        effects.enter('tableCellDivider');
        effects.consume(code);
        effects.exit('tableCellDivider');
        seenDelimiter = true;
        return cellBreakHead;
    }
    function cellBreakHead(code) {
        // EOF, CR, LF, CRLF.
        if (code === null || code === -5 || code === -4 || code === -3) return atRowEndHead(code);
        // HT, VS, SP.
        if (code === -2 || code === -1 || code === 32) {
            effects.enter('whitespace');
            effects.consume(code);
            return inWhitespaceHead;
        }
        if (seenDelimiter) {
            seenDelimiter = undefined;
            tableHeaderCount++;
        }
        // `|`
        if (code === 124) return cellDividerHead(code);
        // Anything else is cell content.
        effects.enter('temporaryTableCellContent');
        return inCellContentHead(code);
    }
    function inWhitespaceHead(code) {
        // HT, VS, SP.
        if (code === -2 || code === -1 || code === 32) {
            effects.consume(code);
            return inWhitespaceHead;
        }
        effects.exit('whitespace');
        return cellBreakHead(code);
    }
    function inCellContentHead(code) {
        // EOF, whitespace, pipe
        if (code === null || code < 0 || code === 32 || code === 124) {
            effects.exit('temporaryTableCellContent');
            return cellBreakHead(code);
        }
        effects.consume(code);
        // `\`
        return code === 92 ? inCellContentEscapeHead : inCellContentHead;
    }
    function inCellContentEscapeHead(code) {
        // `\` or `|`
        if (code === 92 || code === 124) {
            effects.consume(code);
            return inCellContentHead;
        }
        // Anything else.
        return inCellContentHead(code);
    }
    function atRowEndHead(code) {
        if (code === null) return nok(code);
        effects.exit('tableRow');
        effects.exit('tableHead');
        // Always a line ending.
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        // If a setext heading, exit.
        return effects.check(setextUnderlineMini, nok, // Support an indent before the delimiter row.
        createSpace(effects, rowStartDelimiter, 'linePrefix', 4));
    }
    function rowStartDelimiter(code) {
        // If there’s another space, or we’re at the EOL/EOF, exit.
        if (code === null || code < 0 || code === 32) return nok(code);
        effects.enter('tableDelimiterRow');
        return atDelimiterRowBreak(code);
    }
    function atDelimiterRowBreak(code) {
        // EOF, CR, LF, CRLF.
        if (code === null || code === -5 || code === -4 || code === -3) return rowEndDelimiter(code);
        // HT, VS, SP.
        if (code === -2 || code === -1 || code === 32) {
            effects.enter('whitespace');
            effects.consume(code);
            return inWhitespaceDelimiter;
        }
        // `-`
        if (code === 45) {
            effects.enter('tableDelimiterFiller');
            effects.consume(code);
            hasDash = true;
            align.push(null);
            return inFillerDelimiter;
        }
        // `:`
        if (code === 58) {
            effects.enter('tableDelimiterAlignment');
            effects.consume(code);
            effects.exit('tableDelimiterAlignment');
            align.push('left');
            return afterLeftAlignment;
        }
        // If we start with a pipe, we open a cell marker.
        if (code === 124) {
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            return atDelimiterRowBreak;
        }
        return nok(code);
    }
    function inWhitespaceDelimiter(code) {
        // HT, VS, SP.
        if (code === -2 || code === -1 || code === 32) {
            effects.consume(code);
            return inWhitespaceDelimiter;
        }
        effects.exit('whitespace');
        return atDelimiterRowBreak(code);
    }
    function inFillerDelimiter(code) {
        // `-`
        if (code === 45) {
            effects.consume(code);
            return inFillerDelimiter;
        }
        effects.exit('tableDelimiterFiller');
        // `:`
        if (code === 58) {
            effects.enter('tableDelimiterAlignment');
            effects.consume(code);
            effects.exit('tableDelimiterAlignment');
            align[align.length - 1] = align[align.length - 1] === 'left' ? 'center' : 'right';
            return afterRightAlignment;
        }
        return atDelimiterRowBreak(code);
    }
    function afterLeftAlignment(code) {
        // `-`
        if (code === 45) {
            effects.enter('tableDelimiterFiller');
            effects.consume(code);
            hasDash = true;
            return inFillerDelimiter;
        }
        // Anything else is not ok.
        return nok(code);
    }
    function afterRightAlignment(code) {
        // EOF, CR, LF, CRLF.
        if (code === null || code === -5 || code === -4 || code === -3) return rowEndDelimiter(code);
        // HT, VS, SP.
        if (code === -2 || code === -1 || code === 32) {
            effects.enter('whitespace');
            effects.consume(code);
            return inWhitespaceDelimiter;
        }
        // `|`
        if (code === 124) {
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            return atDelimiterRowBreak;
        }
        return nok(code);
    }
    function rowEndDelimiter(code) {
        effects.exit('tableDelimiterRow');
        // Exit if there was no dash at all, or if the header cell count is not the
        // delimiter cell count.
        if (!hasDash || tableHeaderCount !== align.length) return nok(code);
        if (code === null) return tableClose(code);
        return effects.check(nextPrefixedOrBlank, tableClose, tableContinue)(code);
    }
    function tableClose(code) {
        effects.exit('table');
        return ok(code);
    }
    function tableContinue(code) {
        // Always a line ending.
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        // We checked that it’s not a prefixed or blank line, so we’re certain a
        // body is coming, though it may be indented.
        return createSpace(effects, bodyStart, 'linePrefix', 4);
    }
    function bodyStart(code) {
        effects.enter('tableBody');
        return rowStartBody(code);
    }
    function rowStartBody(code) {
        effects.enter('tableRow');
        // If we start with a pipe, we open a cell marker.
        if (code === 124) return cellDividerBody(code);
        effects.enter('temporaryTableCellContent');
        // Can’t be space or eols at the start of a construct, so we’re in a cell.
        return inCellContentBody(code);
    }
    function cellDividerBody(code) {
        // Always a pipe.
        effects.enter('tableCellDivider');
        effects.consume(code);
        effects.exit('tableCellDivider');
        return cellBreakBody;
    }
    function cellBreakBody(code) {
        // EOF, CR, LF, CRLF.
        if (code === null || code === -5 || code === -4 || code === -3) return atRowEndBody(code);
        // HT, VS, SP.
        if (code === -2 || code === -1 || code === 32) {
            effects.enter('whitespace');
            effects.consume(code);
            return inWhitespaceBody;
        }
        // `|`
        if (code === 124) return cellDividerBody(code);
        // Anything else is cell content.
        effects.enter('temporaryTableCellContent');
        return inCellContentBody(code);
    }
    function inWhitespaceBody(code) {
        // HT, VS, SP.
        if (code === -2 || code === -1 || code === 32) {
            effects.consume(code);
            return inWhitespaceBody;
        }
        effects.exit('whitespace');
        return cellBreakBody(code);
    }
    function inCellContentBody(code) {
        // EOF, whitespace, pipe
        if (code === null || code < 0 || code === 32 || code === 124) {
            effects.exit('temporaryTableCellContent');
            return cellBreakBody(code);
        }
        effects.consume(code);
        // `\`
        return code === 92 ? inCellContentEscapeBody : inCellContentBody;
    }
    function inCellContentEscapeBody(code) {
        // `\` or `|`
        if (code === 92 || code === 124) {
            effects.consume(code);
            return inCellContentBody;
        }
        // Anything else.
        return inCellContentBody(code);
    }
    function atRowEndBody(code) {
        effects.exit('tableRow');
        if (code === null) return tableBodyClose(code);
        return effects.check(nextPrefixedOrBlank, tableBodyClose, tableBodyContinue)(code);
    }
    function tableBodyClose(code) {
        effects.exit('tableBody');
        return tableClose(code);
    }
    function tableBodyContinue(code) {
        // Always a line ending.
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        // Support an optional prefix, then start a body row.
        return createSpace(effects, rowStartBody, 'linePrefix', 4);
    }
}
// Based on micromark, but that won’t work as we’re in a table, and that expects
// content.
// <https://github.com/micromark/micromark/blob/main/lib/tokenize/setext-underline.js>
function tokenizeSetextUnderlineMini(effects, ok, nok) {
    return start;
    function start(code) {
        // `-`
        if (code !== 45) return nok(code);
        effects.enter('setextUnderline');
        return sequence(code);
    }
    function sequence(code) {
        if (code === 45) {
            effects.consume(code);
            return sequence;
        }
        return whitespace(code);
    }
    function whitespace(code) {
        if (code === -2 || code === -1 || code === 32) {
            effects.consume(code);
            return whitespace;
        }
        if (code === null || code === -5 || code === -4 || code === -3) return ok(code);
        return nok(code);
    }
}
function tokenizeNextPrefixedOrBlank(effects, ok, nok) {
    var size = 0;
    return start;
    function start(code) {
        // This is a check, so we don’t care about tokens, but we open a bogus one
        // so we’re valid.
        effects.enter('check');
        // EOL.
        effects.consume(code);
        return whitespace;
    }
    function whitespace(code) {
        // VS or SP.
        if (code === -1 || code === 32) {
            effects.consume(code);
            size++;
            return size === 4 ? ok : whitespace;
        }
        // EOF or whitespace
        if (code === null || code < 0) return ok(code);
        // Anything else.
        return nok(code);
    }
}

},{"b7aeba0ff2dbfcf9":"2joBs"}],"646bH":[function(require,module,exports,__globalThis) {
module.exports = require("bae7b5a9edca3533");

},{"bae7b5a9edca3533":"d3H6g"}],"d3H6g":[function(require,module,exports,__globalThis) {
var markdownLineEndingOrSpace = require("e80fbb0e6263e5d9");
var spaceFactory = require("6afd6909cb0b06f8");
var prefixSize = require("827504b94291fcfa");
var tasklistCheck = {
    tokenize: tokenizeTasklistCheck
};
exports.text = {
    91: tasklistCheck
};
function tokenizeTasklistCheck(effects, ok, nok) {
    var self = this;
    return open;
    function open(code) {
        if (// Exit if not `[`.
        code !== 91 || // Exit if there’s stuff before.
        self.previous !== null || // Exit if not in the first content that is the first child of a list
        // item.
        !self._gfmTasklistFirstContentOfListItem) return nok(code);
        effects.enter('taskListCheck');
        effects.enter('taskListCheckMarker');
        effects.consume(code);
        effects.exit('taskListCheckMarker');
        return inside;
    }
    function inside(code) {
        // Tab or space.
        if (code === -2 || code === 32) {
            effects.enter('taskListCheckValueUnchecked');
            effects.consume(code);
            effects.exit('taskListCheckValueUnchecked');
            return close;
        }
        // Upper- and lower `x`.
        if (code === 88 || code === 120) {
            effects.enter('taskListCheckValueChecked');
            effects.consume(code);
            effects.exit('taskListCheckValueChecked');
            return close;
        }
        return nok(code);
    }
    function close(code) {
        // `]`
        if (code === 93) {
            effects.enter('taskListCheckMarker');
            effects.consume(code);
            effects.exit('taskListCheckMarker');
            effects.exit('taskListCheck');
            return effects.check({
                tokenize: spaceThenNonSpace
            }, ok, nok);
        }
        return nok(code);
    }
}
function spaceThenNonSpace(effects, ok, nok) {
    var self = this;
    return spaceFactory(effects, after, 'whitespace');
    function after(code) {
        return prefixSize(self.events, 'whitespace') && code !== null && !markdownLineEndingOrSpace(code) ? ok(code) : nok(code);
    }
}

},{"e80fbb0e6263e5d9":"73vQs","6afd6909cb0b06f8":"2joBs","827504b94291fcfa":"25mY2"}],"kaH66":[function(require,module,exports,__globalThis) {
var autolinkLiteral = require("b0203ae345623c31");
var strikethrough = require("1c06bcbf67a0c33d");
var table = require("8ddcc75591a6842d");
var taskListItem = require("efdaee5662de54f");
var own = {}.hasOwnProperty;
module.exports = configure([
    autolinkLiteral,
    strikethrough,
    table,
    taskListItem
]);
function configure(extensions) {
    var config = {
        transforms: [],
        canContainEols: []
    };
    var length = extensions.length;
    var index = -1;
    while(++index < length)extension(config, extensions[index]);
    return config;
}
function extension(config, extension) {
    var key;
    var left;
    var right;
    for(key in extension){
        left = own.call(config, key) ? config[key] : config[key] = {};
        right = extension[key];
        if (key === 'canContainEols' || key === 'transforms') config[key] = [].concat(left, right);
        else Object.assign(left, right);
    }
}

},{"b0203ae345623c31":"fHnY0","1c06bcbf67a0c33d":"frYc2","8ddcc75591a6842d":"jaHeG","efdaee5662de54f":"5cEpc"}],"fHnY0":[function(require,module,exports,__globalThis) {
var ccount = require("19ec544645c62cd0");
var findAndReplace = require("c702a4e81dcdf312");
var unicodePunctuation = require("1912917e5d78e470");
var unicodeWhitespace = require("8e391d7a26e52a84");
exports.transforms = [
    transformGfmAutolinkLiterals
];
exports.enter = {
    literalAutolink: enterLiteralAutolink,
    literalAutolinkEmail: enterLiteralAutolinkValue,
    literalAutolinkHttp: enterLiteralAutolinkValue,
    literalAutolinkWww: enterLiteralAutolinkValue
};
exports.exit = {
    literalAutolink: exitLiteralAutolink,
    literalAutolinkEmail: exitLiteralAutolinkEmail,
    literalAutolinkHttp: exitLiteralAutolinkHttp,
    literalAutolinkWww: exitLiteralAutolinkWww
};
function enterLiteralAutolink(token) {
    this.enter({
        type: 'link',
        title: null,
        url: '',
        children: []
    }, token);
}
function enterLiteralAutolinkValue(token) {
    this.config.enter.autolinkProtocol.call(this, token);
}
function exitLiteralAutolinkHttp(token) {
    this.config.exit.autolinkProtocol.call(this, token);
}
function exitLiteralAutolinkWww(token) {
    this.config.exit.data.call(this, token);
    this.stack[this.stack.length - 1].url = 'http://' + this.sliceSerialize(token);
}
function exitLiteralAutolinkEmail(token) {
    this.config.exit.autolinkEmail.call(this, token);
}
function exitLiteralAutolink(token) {
    this.exit(token);
}
function transformGfmAutolinkLiterals(tree) {
    findAndReplace(tree, [
        [
            /(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/i,
            findUrl
        ],
        [
            /([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/,
            findEmail
        ]
    ], {
        ignore: [
            'link',
            'linkReference'
        ]
    });
}
function findUrl($0, protocol, domain, path, match) {
    var prefix = '';
    var parts;
    var result;
    // Not an expected previous character.
    if (!previous(match)) return false;
    // Treat `www` as part of the domain.
    if (/^w/i.test(protocol)) {
        domain = protocol + domain;
        protocol = '';
        prefix = 'http://';
    }
    if (!isCorrectDomain(domain)) return false;
    parts = splitUrl(domain + path);
    if (!parts[0]) return false;
    result = {
        type: 'link',
        title: null,
        url: prefix + protocol + parts[0],
        children: [
            {
                type: 'text',
                value: protocol + parts[0]
            }
        ]
    };
    if (parts[1]) result = [
        result,
        {
            type: 'text',
            value: parts[1]
        }
    ];
    return result;
}
function findEmail($0, atext, label, match) {
    // Not an expected previous character.
    if (!previous(match, true) || /[_-]$/.test(label)) return false;
    return {
        type: 'link',
        title: null,
        url: 'mailto:' + atext + '@' + label,
        children: [
            {
                type: 'text',
                value: atext + '@' + label
            }
        ]
    };
}
function isCorrectDomain(domain) {
    var parts = domain.split('.');
    if (parts.length < 2 || parts[parts.length - 1] && (/_/.test(parts[parts.length - 1]) || !/[a-zA-Z\d]/.test(parts[parts.length - 1])) || parts[parts.length - 2] && (/_/.test(parts[parts.length - 2]) || !/[a-zA-Z\d]/.test(parts[parts.length - 2]))) return false;
    return true;
}
function splitUrl(url) {
    var trail = /[!"&'),.:;<>?\]}]+$/.exec(url);
    var closingParenIndex;
    var openingParens;
    var closingParens;
    if (trail) {
        url = url.slice(0, trail.index);
        trail = trail[0];
        closingParenIndex = trail.indexOf(')');
        openingParens = ccount(url, '(');
        closingParens = ccount(url, ')');
        while(closingParenIndex !== -1 && openingParens > closingParens){
            url += trail.slice(0, closingParenIndex + 1);
            trail = trail.slice(closingParenIndex + 1);
            closingParenIndex = trail.indexOf(')');
            closingParens++;
        }
    }
    return [
        url,
        trail
    ];
}
function previous(match, email) {
    var code = match.input.charCodeAt(match.index - 1);
    return (code !== code || unicodeWhitespace(code) || unicodePunctuation(code)) && (!email || code !== 47);
}

},{"19ec544645c62cd0":"e2QlW","c702a4e81dcdf312":"3Ruym","1912917e5d78e470":"f8iPV","8e391d7a26e52a84":"h01cg"}],"e2QlW":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = ccount;
function ccount(source, character) {
    var value = String(source);
    var count = 0;
    var index;
    if (typeof character !== 'string') throw new Error('Expected character');
    index = value.indexOf(character);
    while(index !== -1){
        count++;
        index = value.indexOf(character, index + character.length);
    }
    return count;
}

},{}],"3Ruym":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = findAndReplace;
var visit = require("6b1dc75f6b9c5a33");
var convert = require("3668359f536d807e");
var escape = require("1fe8c4ccf8ba809a");
var splice = [].splice;
function findAndReplace(tree, find, replace, options) {
    var settings;
    var schema;
    if (typeof find === 'string' || find && typeof find.exec === 'function') schema = [
        [
            find,
            replace
        ]
    ];
    else {
        schema = find;
        options = replace;
    }
    settings = options || {};
    search(tree, settings, handlerFactory(toPairs(schema)));
    return tree;
    function handlerFactory(pairs) {
        var pair = pairs[0];
        return handler;
        function handler(node, parent) {
            var find = pair[0];
            var replace = pair[1];
            var nodes = [];
            var start = 0;
            var index = parent.children.indexOf(node);
            var position;
            var match;
            var subhandler;
            var value;
            find.lastIndex = 0;
            match = find.exec(node.value);
            while(match){
                position = match.index;
                value = replace.apply(null, [].concat(match, {
                    index: match.index,
                    input: match.input
                }));
                if (value !== false) {
                    if (start !== position) nodes.push({
                        type: 'text',
                        value: node.value.slice(start, position)
                    });
                    if (typeof value === 'string' && value.length > 0) value = {
                        type: 'text',
                        value: value
                    };
                    if (value) nodes = [].concat(nodes, value);
                    start = position + match[0].length;
                }
                if (!find.global) break;
                match = find.exec(node.value);
            }
            if (position === undefined) {
                nodes = [
                    node
                ];
                index--;
            } else {
                if (start < node.value.length) nodes.push({
                    type: 'text',
                    value: node.value.slice(start)
                });
                nodes.unshift(index, 1);
                splice.apply(parent.children, nodes);
            }
            if (pairs.length > 1) {
                subhandler = handlerFactory(pairs.slice(1));
                position = -1;
                while(++position < nodes.length){
                    node = nodes[position];
                    if (node.type === 'text') subhandler(node, parent);
                    else search(node, settings, subhandler);
                }
            }
            return index + nodes.length + 1;
        }
    }
}
function search(tree, settings, handler) {
    var ignored = convert(settings.ignore || []);
    var result = [];
    visit(tree, 'text', visitor);
    return result;
    function visitor(node, parents) {
        var index = -1;
        var parent;
        var grandparent;
        while(++index < parents.length){
            parent = parents[index];
            if (ignored(parent, grandparent ? grandparent.children.indexOf(parent) : undefined, grandparent)) return;
            grandparent = parent;
        }
        return handler(node, grandparent);
    }
}
function toPairs(schema) {
    var result = [];
    var key;
    var index;
    if (typeof schema !== 'object') throw new Error('Expected array or object as schema');
    if ('length' in schema) {
        index = -1;
        while(++index < schema.length)result.push([
            toExpression(schema[index][0]),
            toFunction(schema[index][1])
        ]);
    } else for(key in schema)result.push([
        toExpression(key),
        toFunction(schema[key])
    ]);
    return result;
}
function toExpression(find) {
    return typeof find === 'string' ? new RegExp(escape(find), 'g') : find;
}
function toFunction(replace) {
    return typeof replace === 'function' ? replace : returner;
    function returner() {
        return replace;
    }
}

},{"6b1dc75f6b9c5a33":"9KZBe","3668359f536d807e":"gwtOM","1fe8c4ccf8ba809a":"8Zkx1"}],"9KZBe":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = visitParents;
var convert = require("a7714eb8e1932c77");
var color = require("5021701e46f39d7f");
var CONTINUE = true;
var SKIP = 'skip';
var EXIT = false;
visitParents.CONTINUE = CONTINUE;
visitParents.SKIP = SKIP;
visitParents.EXIT = EXIT;
function visitParents(tree, test, visitor, reverse) {
    var step;
    var is;
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    is = convert(test);
    step = reverse ? -1 : 1;
    factory(tree, null, [])();
    function factory(node, index, parents) {
        var value = typeof node === 'object' && node !== null ? node : {};
        var name;
        if (typeof value.type === 'string') {
            name = typeof value.tagName === 'string' ? value.tagName : typeof value.name === 'string' ? value.name : undefined;
            visit.displayName = 'node (' + color(value.type + (name ? '<' + name + '>' : '')) + ')';
        }
        return visit;
        function visit() {
            var grandparents = parents.concat(node);
            var result = [];
            var subresult;
            var offset;
            if (!test || is(node, index, parents[parents.length - 1] || null)) {
                result = toResult(visitor(node, parents));
                if (result[0] === EXIT) return result;
            }
            if (node.children && result[0] !== SKIP) {
                offset = (reverse ? node.children.length : -1) + step;
                while(offset > -1 && offset < node.children.length){
                    subresult = factory(node.children[offset], offset, grandparents)();
                    if (subresult[0] === EXIT) return subresult;
                    offset = typeof subresult[1] === 'number' ? subresult[1] : offset + step;
                }
            }
            return result;
        }
    }
}
function toResult(value) {
    if (value !== null && typeof value === 'object' && 'length' in value) return value;
    if (typeof value === 'number') return [
        CONTINUE,
        value
    ];
    return [
        value
    ];
}

},{"a7714eb8e1932c77":"gwtOM","5021701e46f39d7f":"1BuKr"}],"1BuKr":[function(require,module,exports,__globalThis) {
module.exports = identity;
function identity(d) {
    return d;
}

},{}],"8Zkx1":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = (string)=>{
    if (typeof string !== 'string') throw new TypeError('Expected a string');
    // Escape characters with special meaning either inside or outside character sets.
    // Use a simple backslash escape when it’s always valid, and a \unnnn escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
    return string.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
};

},{}],"frYc2":[function(require,module,exports,__globalThis) {
exports.canContainEols = [
    'delete'
];
exports.enter = {
    strikethrough: enterStrikethrough
};
exports.exit = {
    strikethrough: exitStrikethrough
};
function enterStrikethrough(token) {
    this.enter({
        type: 'delete',
        children: []
    }, token);
}
function exitStrikethrough(token) {
    this.exit(token);
}

},{}],"jaHeG":[function(require,module,exports,__globalThis) {
exports.enter = {
    table: enterTable,
    tableData: enterCell,
    tableHeader: enterCell,
    tableRow: enterRow
};
exports.exit = {
    codeText: exitCodeText,
    table: exitTable,
    tableData: exit,
    tableHeader: exit,
    tableRow: exit
};
function enterTable(token) {
    this.enter({
        type: 'table',
        align: token._align,
        children: []
    }, token);
    this.setData('inTable', true);
}
function exitTable(token) {
    this.exit(token);
    this.setData('inTable');
}
function enterRow(token) {
    this.enter({
        type: 'tableRow',
        children: []
    }, token);
}
function exit(token) {
    this.exit(token);
}
function enterCell(token) {
    this.enter({
        type: 'tableCell',
        children: []
    }, token);
}
// Overwrite the default code text data handler to unescape escaped pipes when
// they are in tables.
function exitCodeText(token) {
    var value = this.resume();
    if (this.getData('inTable')) value = value.replace(/\\([\\|])/g, replace);
    this.stack[this.stack.length - 1].value = value;
    this.exit(token);
}
function replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === '|' ? $1 : $0;
}

},{}],"5cEpc":[function(require,module,exports,__globalThis) {
exports.exit = {
    taskListCheckValueChecked: exitCheck,
    taskListCheckValueUnchecked: exitCheck,
    paragraph: exitParagraphWithTaskListItem
};
function exitCheck(token) {
    // We’re always in a paragraph, in a list item.
    this.stack[this.stack.length - 2].checked = token.type === 'taskListCheckValueChecked';
}
function exitParagraphWithTaskListItem(token) {
    var parent = this.stack[this.stack.length - 2];
    var node = this.stack[this.stack.length - 1];
    var siblings = parent.children;
    var head = node.children[0];
    var index = -1;
    var firstParaghraph;
    if (parent && parent.type === 'listItem' && typeof parent.checked === 'boolean' && head && head.type === 'text') {
        while(++index < siblings.length)if (siblings[index].type === 'paragraph') {
            firstParaghraph = siblings[index];
            break;
        }
        if (firstParaghraph === node) {
            // Must start with a space or a tab.
            head.value = head.value.slice(1);
            if (head.value.length === 0) node.children.shift();
            else {
                head.position.start.column++;
                head.position.start.offset++;
                node.position.start = Object.assign({}, head.position.start);
            }
        }
    }
    this.exit(token);
}

},{}],"9w9zT":[function(require,module,exports,__globalThis) {
var autolinkLiteral = require("c78ff81c7f152197");
var strikethrough = require("8e9b68ba4e0605e5");
var table = require("8ddaa77fa5b0acd3");
var taskListItem = require("258a6d0460076657");
var configure = require("51d53fb5ebe0323f");
module.exports = toMarkdown;
function toMarkdown(options) {
    var config = configure({
        handlers: {},
        join: [],
        unsafe: [],
        options: {}
    }, {
        extensions: [
            autolinkLiteral,
            strikethrough,
            table(options),
            taskListItem
        ]
    });
    return Object.assign(config.options, {
        handlers: config.handlers,
        join: config.join,
        unsafe: config.unsafe
    });
}

},{"c78ff81c7f152197":"aw7fX","8e9b68ba4e0605e5":"4ZerJ","8ddaa77fa5b0acd3":"gDSof","258a6d0460076657":"dOKkF","51d53fb5ebe0323f":"j6r9v"}],"aw7fX":[function(require,module,exports,__globalThis) {
var inConstruct = 'phrasing';
var notInConstruct = [
    'autolink',
    'link',
    'image',
    'label'
];
exports.unsafe = [
    {
        character: '@',
        before: '[+\\-.\\w]',
        after: '[\\-.\\w]',
        inConstruct: inConstruct,
        notInConstruct: notInConstruct
    },
    {
        character: '.',
        before: '[Ww]',
        after: '[\\-.\\w]',
        inConstruct: inConstruct,
        notInConstruct: notInConstruct
    },
    {
        character: ':',
        before: '[ps]',
        after: '\\/',
        inConstruct: inConstruct,
        notInConstruct: notInConstruct
    }
];

},{}],"4ZerJ":[function(require,module,exports,__globalThis) {
var phrasing = require("a89da5ebe6b9114d");
exports.unsafe = [
    {
        character: '~',
        inConstruct: 'phrasing'
    }
];
exports.handlers = {
    delete: handleDelete
};
handleDelete.peek = peekDelete;
function handleDelete(node, _, context) {
    var exit = context.enter('emphasis');
    var value = phrasing(node, context, {
        before: '~',
        after: '~'
    });
    exit();
    return '~~' + value + '~~';
}
function peekDelete() {
    return '~';
}

},{"a89da5ebe6b9114d":"24hl0"}],"24hl0":[function(require,module,exports,__globalThis) {
module.exports = phrasing;
function phrasing(parent, context, safeOptions) {
    var children = parent.children || [];
    var results = [];
    var index = -1;
    var before = safeOptions.before;
    var after;
    var handle;
    var child;
    while(++index < children.length){
        child = children[index];
        if (index + 1 < children.length) {
            handle = context.handle.handlers[children[index + 1].type];
            if (handle && handle.peek) handle = handle.peek;
            after = handle ? handle(children[index + 1], parent, context, {
                before: '',
                after: ''
            }).charAt(0) : '';
        } else after = safeOptions.after;
        // In some cases, html (text) can be found in phrasing right after an eol.
        // When we’d serialize that, in most cases that would be seen as html
        // (flow).
        // As we can’t escape or so to prevent it from happening, we take a somewhat
        // reasonable approach: replace that eol with a space.
        // See: <https://github.com/syntax-tree/mdast-util-to-markdown/issues/15>
        if (results.length > 0 && (before === '\r' || before === '\n') && child.type === 'html') {
            results[results.length - 1] = results[results.length - 1].replace(/(\r?\n|\r)$/, ' ');
            before = ' ';
        }
        results.push(context.handle(child, parent, context, {
            before: before,
            after: after
        }));
        before = results[results.length - 1].slice(-1);
    }
    return results.join('');
}

},{}],"gDSof":[function(require,module,exports,__globalThis) {
var phrasing = require("3bf5e3b8fac61dd8");
var defaultInlineCode = require("d67cd43ddbfb7e62");
var markdownTable = require("4cb0bca4485797f7");
module.exports = toMarkdown;
function toMarkdown(options) {
    var settings = options || {};
    var padding = settings.tableCellPadding;
    var alignDelimiters = settings.tablePipeAlign;
    var stringLength = settings.stringLength;
    var around = padding ? ' ' : '|';
    return {
        unsafe: [
            {
                character: '\r',
                inConstruct: 'tableCell'
            },
            {
                character: '\n',
                inConstruct: 'tableCell'
            },
            // A pipe, when followed by a tab or space (padding), or a dash or colon
            // (unpadded delimiter row), could result in a table.
            {
                atBreak: true,
                character: '|',
                after: '[\t :-]'
            },
            // A pipe in a cell must be encoded.
            {
                character: '|',
                inConstruct: 'tableCell'
            },
            // A colon must be followed by a dash, in which case it could start a
            // delimiter row.
            {
                atBreak: true,
                character: ':',
                after: '-'
            },
            // A delimiter row can also start with a dash, when followed by more
            // dashes, a colon, or a pipe.
            // This is a stricter version than the built in check for lists, thematic
            // breaks, and setex heading underlines though:
            // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
            {
                atBreak: true,
                character: '-',
                after: '[:|-]'
            }
        ],
        handlers: {
            table: handleTable,
            tableRow: handleTableRow,
            tableCell: handleTableCell,
            inlineCode: inlineCodeWithTable
        }
    };
    function handleTable(node, _, context) {
        return serializeData(handleTableAsData(node, context), node.align);
    }
    // This function isn’t really used normally, because we handle rows at the
    // table level.
    // But, if someone passes in a table row, this ensures we make somewhat sense.
    function handleTableRow(node, _, context) {
        var row = handleTableRowAsData(node, context);
        // `markdown-table` will always add an align row
        var value = serializeData([
            row
        ]);
        return value.slice(0, value.indexOf('\n'));
    }
    function handleTableCell(node, _, context) {
        var exit = context.enter('tableCell');
        var value = phrasing(node, context, {
            before: around,
            after: around
        });
        exit();
        return value;
    }
    function serializeData(matrix, align) {
        return markdownTable(matrix, {
            align: align,
            alignDelimiters: alignDelimiters,
            padding: padding,
            stringLength: stringLength
        });
    }
    function handleTableAsData(node, context) {
        var children = node.children;
        var index = -1;
        var length = children.length;
        var result = [];
        var subexit = context.enter('table');
        while(++index < length)result[index] = handleTableRowAsData(children[index], context);
        subexit();
        return result;
    }
    function handleTableRowAsData(node, context) {
        var children = node.children;
        var index = -1;
        var length = children.length;
        var result = [];
        var subexit = context.enter('tableRow');
        while(++index < length)result[index] = handleTableCell(children[index], node, context);
        subexit();
        return result;
    }
    function inlineCodeWithTable(node, parent, context) {
        var value = defaultInlineCode(node, parent, context);
        if (context.stack.indexOf('tableCell') !== -1) value = value.replace(/\|/g, '\\$&');
        return value;
    }
}

},{"3bf5e3b8fac61dd8":"24hl0","d67cd43ddbfb7e62":"lljxz","4cb0bca4485797f7":"38iN3"}],"lljxz":[function(require,module,exports,__globalThis) {
module.exports = inlineCode;
inlineCode.peek = inlineCodePeek;
var patternCompile = require("dbf6c20eb0999d2c");
function inlineCode(node, parent, context) {
    var value = node.value || '';
    var sequence = '`';
    var index = -1;
    var pattern;
    var expression;
    var match;
    var position;
    // If there is a single grave accent on its own in the code, use a fence of
    // two.
    // If there are two in a row, use one.
    while(new RegExp('(^|[^`])' + sequence + '([^`]|$)').test(value))sequence += '`';
    // If this is not just spaces or eols (tabs don’t count), and either the
    // first or last character are a space, eol, or tick, then pad with spaces.
    if (/[^ \r\n]/.test(value) && (/[ \r\n`]/.test(value.charAt(0)) || /[ \r\n`]/.test(value.charAt(value.length - 1)))) value = ' ' + value + ' ';
    // We have a potential problem: certain characters after eols could result in
    // blocks being seen.
    // For example, if someone injected the string `'\n# b'`, then that would
    // result in an ATX heading.
    // We can’t escape characters in `inlineCode`, but because eols are
    // transformed to spaces when going from markdown to HTML anyway, we can swap
    // them out.
    while(++index < context.unsafe.length){
        pattern = context.unsafe[index];
        // Only look for `atBreak`s.
        // Btw: note that `atBreak` patterns will always start the regex at LF or
        // CR.
        if (!pattern.atBreak) continue;
        expression = patternCompile(pattern);
        while(match = expression.exec(value)){
            position = match.index;
            // Support CRLF (patterns only look for one of the characters).
            if (value.charCodeAt(position) === 10 /* `\n` */  && value.charCodeAt(position - 1) === 13 /* `\r` */ ) position--;
            value = value.slice(0, position) + ' ' + value.slice(match.index + 1);
        }
    }
    return sequence + value + sequence;
}
function inlineCodePeek() {
    return '`';
}

},{"dbf6c20eb0999d2c":"1ruE8"}],"1ruE8":[function(require,module,exports,__globalThis) {
module.exports = patternCompile;
function patternCompile(pattern) {
    var before;
    var after;
    if (!pattern._compiled) {
        before = pattern.before ? '(?:' + pattern.before + ')' : '';
        after = pattern.after ? '(?:' + pattern.after + ')' : '';
        if (pattern.atBreak) before = '[\\r\\n][\\t ]*' + before;
        pattern._compiled = new RegExp((before ? '(' + before + ')' : '') + (/[|\\{}()[\]^$+*?.-]/.test(pattern.character) ? '\\' : '') + pattern.character + (after || ''), 'g');
    }
    return pattern._compiled;
}

},{}],"38iN3":[function(require,module,exports,__globalThis) {
'use strict';
var repeat = require("126cd863bf20fd18");
module.exports = markdownTable;
var trailingWhitespace = / +$/;
// Characters.
var space = ' ';
var lineFeed = '\n';
var dash = '-';
var colon = ':';
var verticalBar = '|';
var x = 0;
var C = 67;
var L = 76;
var R = 82;
var c = 99;
var l = 108;
var r = 114;
// Create a table from a matrix of strings.
function markdownTable(table, options) {
    var settings = options || {};
    var padding = settings.padding !== false;
    var start = settings.delimiterStart !== false;
    var end = settings.delimiterEnd !== false;
    var align = (settings.align || []).concat();
    var alignDelimiters = settings.alignDelimiters !== false;
    var alignments = [];
    var stringLength = settings.stringLength || defaultStringLength;
    var rowIndex = -1;
    var rowLength = table.length;
    var cellMatrix = [];
    var sizeMatrix = [];
    var row = [];
    var sizes = [];
    var longestCellByColumn = [];
    var mostCellsPerRow = 0;
    var cells;
    var columnIndex;
    var columnLength;
    var largest;
    var size;
    var cell;
    var lines;
    var line;
    var before;
    var after;
    var code;
    // This is a superfluous loop if we don’t align delimiters, but otherwise we’d
    // do superfluous work when aligning, so optimize for aligning.
    while(++rowIndex < rowLength){
        cells = table[rowIndex];
        columnIndex = -1;
        columnLength = cells.length;
        row = [];
        sizes = [];
        if (columnLength > mostCellsPerRow) mostCellsPerRow = columnLength;
        while(++columnIndex < columnLength){
            cell = serialize(cells[columnIndex]);
            if (alignDelimiters === true) {
                size = stringLength(cell);
                sizes[columnIndex] = size;
                largest = longestCellByColumn[columnIndex];
                if (largest === undefined || size > largest) longestCellByColumn[columnIndex] = size;
            }
            row.push(cell);
        }
        cellMatrix[rowIndex] = row;
        sizeMatrix[rowIndex] = sizes;
    }
    // Figure out which alignments to use.
    columnIndex = -1;
    columnLength = mostCellsPerRow;
    if (typeof align === 'object' && 'length' in align) while(++columnIndex < columnLength)alignments[columnIndex] = toAlignment(align[columnIndex]);
    else {
        code = toAlignment(align);
        while(++columnIndex < columnLength)alignments[columnIndex] = code;
    }
    // Inject the alignment row.
    columnIndex = -1;
    columnLength = mostCellsPerRow;
    row = [];
    sizes = [];
    while(++columnIndex < columnLength){
        code = alignments[columnIndex];
        before = '';
        after = '';
        if (code === l) before = colon;
        else if (code === r) after = colon;
        else if (code === c) {
            before = colon;
            after = colon;
        }
        // There *must* be at least one hyphen-minus in each alignment cell.
        size = alignDelimiters ? Math.max(1, longestCellByColumn[columnIndex] - before.length - after.length) : 1;
        cell = before + repeat(dash, size) + after;
        if (alignDelimiters === true) {
            size = before.length + size + after.length;
            if (size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            sizes[columnIndex] = size;
        }
        row[columnIndex] = cell;
    }
    // Inject the alignment row.
    cellMatrix.splice(1, 0, row);
    sizeMatrix.splice(1, 0, sizes);
    rowIndex = -1;
    rowLength = cellMatrix.length;
    lines = [];
    while(++rowIndex < rowLength){
        row = cellMatrix[rowIndex];
        sizes = sizeMatrix[rowIndex];
        columnIndex = -1;
        columnLength = mostCellsPerRow;
        line = [];
        while(++columnIndex < columnLength){
            cell = row[columnIndex] || '';
            before = '';
            after = '';
            if (alignDelimiters === true) {
                size = longestCellByColumn[columnIndex] - (sizes[columnIndex] || 0);
                code = alignments[columnIndex];
                if (code === r) before = repeat(space, size);
                else if (code === c) {
                    if (size % 2 === 0) {
                        before = repeat(space, size / 2);
                        after = before;
                    } else {
                        before = repeat(space, size / 2 + 0.5);
                        after = repeat(space, size / 2 - 0.5);
                    }
                } else after = repeat(space, size);
            }
            if (start === true && columnIndex === 0) line.push(verticalBar);
            if (padding === true && // Don’t add the opening space if we’re not aligning and the cell is
            // empty: there will be a closing space.
            !(alignDelimiters === false && cell === '') && (start === true || columnIndex !== 0)) line.push(space);
            if (alignDelimiters === true) line.push(before);
            line.push(cell);
            if (alignDelimiters === true) line.push(after);
            if (padding === true) line.push(space);
            if (end === true || columnIndex !== columnLength - 1) line.push(verticalBar);
        }
        line = line.join('');
        if (end === false) line = line.replace(trailingWhitespace, '');
        lines.push(line);
    }
    return lines.join(lineFeed);
}
function serialize(value) {
    return value === null || value === undefined ? '' : String(value);
}
function defaultStringLength(value) {
    return value.length;
}
function toAlignment(value) {
    var code = typeof value === 'string' ? value.charCodeAt(0) : x;
    return code === L || code === l ? l : code === R || code === r ? r : code === C || code === c ? c : x;
}

},{"126cd863bf20fd18":"79Oqj"}],"79Oqj":[function(require,module,exports,__globalThis) {
/*!
 * repeat-string <https://github.com/jonschlinkert/repeat-string>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */ 'use strict';
/**
 * Results cache
 */ var res = '';
var cache;
/**
 * Expose `repeat`
 */ module.exports = repeat;
/**
 * Repeat the given `string` the specified `number`
 * of times.
 *
 * **Example:**
 *
 * ```js
 * var repeat = require('repeat-string');
 * repeat('A', 5);
 * //=> AAAAA
 * ```
 *
 * @param {String} `string` The string to repeat
 * @param {Number} `number` The number of times to repeat the string
 * @return {String} Repeated string
 * @api public
 */ function repeat(str, num) {
    if (typeof str !== 'string') throw new TypeError('expected a string');
    // cover common, quick use cases
    if (num === 1) return str;
    if (num === 2) return str + str;
    var max = str.length * num;
    if (cache !== str || typeof cache === 'undefined') {
        cache = str;
        res = '';
    } else if (res.length >= max) return res.substr(0, max);
    while(max > res.length && num > 1){
        if (num & 1) res += str;
        num >>= 1;
        str += str;
    }
    res += str;
    res = res.substr(0, max);
    return res;
}

},{}],"dOKkF":[function(require,module,exports,__globalThis) {
var defaultListItem = require("1b1f48f9d93727f0");
exports.unsafe = [
    {
        atBreak: true,
        character: '-',
        after: '[:|-]'
    }
];
exports.handlers = {
    listItem: listItemWithTaskListItem
};
function listItemWithTaskListItem(node, parent, context) {
    var value = defaultListItem(node, parent, context);
    var head = node.children[0];
    if (typeof node.checked === 'boolean' && head && head.type === 'paragraph') value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check);
    return value;
    function check($0) {
        return $0 + '[' + (node.checked ? 'x' : ' ') + '] ';
    }
}

},{"1b1f48f9d93727f0":"h2GhL"}],"h2GhL":[function(require,module,exports,__globalThis) {
module.exports = listItem;
var repeat = require("683926031644871d");
var checkBullet = require("659ee1d3da307253");
var checkListItemIndent = require("c2ff4912c9dd9b71");
var flow = require("7821e8f1e3171000");
var indentLines = require("9c7e2c755b44cd7b");
function listItem(node, parent, context) {
    var bullet = checkBullet(context);
    var listItemIndent = checkListItemIndent(context);
    var size;
    var value;
    var exit;
    if (parent && parent.ordered) bullet = (parent.start > -1 ? parent.start : 1) + (context.options.incrementListMarker === false ? 0 : parent.children.indexOf(node)) + '.';
    size = bullet.length + 1;
    if (listItemIndent === 'tab' || listItemIndent === 'mixed' && (parent && parent.spread || node.spread)) size = Math.ceil(size / 4) * 4;
    exit = context.enter('listItem');
    value = indentLines(flow(node, context), map);
    exit();
    return value;
    function map(line, index, blank) {
        if (index) return (blank ? '' : repeat(' ', size)) + line;
        return (blank ? bullet : bullet + repeat(' ', size - bullet.length)) + line;
    }
}

},{"683926031644871d":"79Oqj","659ee1d3da307253":"5I11g","c2ff4912c9dd9b71":"SGnY6","7821e8f1e3171000":"gzOUR","9c7e2c755b44cd7b":"2cj3T"}],"5I11g":[function(require,module,exports,__globalThis) {
module.exports = checkBullet;
function checkBullet(context) {
    var marker = context.options.bullet || '*';
    if (marker !== '*' && marker !== '+' && marker !== '-') throw new Error('Cannot serialize items with `' + marker + '` for `options.bullet`, expected `*`, `+`, or `-`');
    return marker;
}

},{}],"SGnY6":[function(require,module,exports,__globalThis) {
module.exports = checkListItemIndent;
function checkListItemIndent(context) {
    var style = context.options.listItemIndent || 'tab';
    if (style === 1 || style === '1') return 'one';
    if (style !== 'tab' && style !== 'one' && style !== 'mixed') throw new Error('Cannot serialize items with `' + style + '` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`');
    return style;
}

},{}],"gzOUR":[function(require,module,exports,__globalThis) {
module.exports = flow;
var repeat = require("9e3aefc01af80a83");
function flow(parent, context) {
    var children = parent.children || [];
    var results = [];
    var index = -1;
    var child;
    while(++index < children.length){
        child = children[index];
        results.push(context.handle(child, parent, context, {
            before: '\n',
            after: '\n'
        }));
        if (index + 1 < children.length) results.push(between(child, children[index + 1]));
    }
    return results.join('');
    function between(left, right) {
        var index = -1;
        var result;
        while(++index < context.join.length){
            result = context.join[index](left, right, parent, context);
            if (result === true || result === 1) break;
            if (typeof result === 'number') return repeat('\n', 1 + Number(result));
            if (result === false) return '\n\n<!---->\n\n';
        }
        return '\n\n';
    }
}

},{"9e3aefc01af80a83":"79Oqj"}],"2cj3T":[function(require,module,exports,__globalThis) {
module.exports = indentLines;
var eol = /\r?\n|\r/g;
function indentLines(value, map) {
    var result = [];
    var start = 0;
    var line = 0;
    var match;
    while(match = eol.exec(value)){
        one(value.slice(start, match.index));
        result.push(match[0]);
        start = match.index + match[0].length;
        line++;
    }
    one(value.slice(start));
    return result.join('');
    function one(value) {
        result.push(map(value, line, !value));
    }
}

},{}],"j6r9v":[function(require,module,exports,__globalThis) {
module.exports = configure;
function configure(base, extension) {
    var index = -1;
    var key;
    // First do subextensions.
    if (extension.extensions) while(++index < extension.extensions.length)configure(base, extension.extensions[index]);
    for(key in extension){
        if (key === 'extensions') ;
        else if (key === 'unsafe' || key === 'join') base[key] = base[key].concat(extension[key] || []);
        else if (key === 'handlers') base[key] = Object.assign(base[key], extension[key] || {});
        else base.options[key] = extension[key];
    }
    return base;
}

},{}],"cjsL2":[function(require,module,exports,__globalThis) {
const visit = require("25c0e3080f960be5");
module.exports = function(options) {
    function visitor(node) {
        // Sanitize URL by removing leading `/`
        const relativeUrl = node.url.replace(/^\//, "");
        node.url = new URL(relativeUrl, options.absolutePath).href;
    }
    function transform(tree) {
        if (options && options.absolutePath) visit(tree, "image", visitor);
        else throw Error("Missing required `absolutePath` option.");
    }
    return transform;
};

},{"25c0e3080f960be5":"4YBFh"}],"4YBFh":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = visit;
var visitParents = require("98c2c5619c1e407a");
var CONTINUE = visitParents.CONTINUE;
var SKIP = visitParents.SKIP;
var EXIT = visitParents.EXIT;
visit.CONTINUE = CONTINUE;
visit.SKIP = SKIP;
visit.EXIT = EXIT;
function visit(tree, test, visitor, reverse) {
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    visitParents(tree, test, overload, reverse);
    function overload(node, parents) {
        var parent = parents[parents.length - 1];
        var index = parent ? parent.children.indexOf(node) : null;
        return visitor(node, index, parent);
    }
}

},{"98c2c5619c1e407a":"bOUoH"}],"bOUoH":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = visitParents;
var convert = require("90dfe6082d09bce9");
var CONTINUE = true;
var SKIP = 'skip';
var EXIT = false;
visitParents.CONTINUE = CONTINUE;
visitParents.SKIP = SKIP;
visitParents.EXIT = EXIT;
function visitParents(tree, test, visitor, reverse) {
    var is;
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    is = convert(test);
    one(tree, null, []);
    // Visit a single node.
    function one(node, index, parents) {
        var result = [];
        var subresult;
        if (!test || is(node, index, parents[parents.length - 1] || null)) {
            result = toResult(visitor(node, parents));
            if (result[0] === EXIT) return result;
        }
        if (node.children && result[0] !== SKIP) {
            subresult = toResult(all(node.children, parents.concat(node)));
            return subresult[0] === EXIT ? subresult : result;
        }
        return result;
    }
    // Visit children in `parent`.
    function all(children, parents) {
        var min = -1;
        var step = reverse ? -1 : 1;
        var index = (reverse ? children.length : min) + step;
        var result;
        while(index > min && index < children.length){
            result = one(children[index], index, parents);
            if (result[0] === EXIT) return result;
            index = typeof result[1] === 'number' ? result[1] : index + step;
        }
    }
}
function toResult(value) {
    if (value !== null && typeof value === 'object' && 'length' in value) return value;
    if (typeof value === 'number') return [
        CONTINUE,
        value
    ];
    return [
        value
    ];
}

},{"90dfe6082d09bce9":"c9nCd"}],"c9nCd":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = convert;
function convert(test) {
    if (typeof test === 'string') return typeFactory(test);
    if (test === null || test === undefined) return ok;
    if (typeof test === 'object') return ('length' in test ? anyFactory : matchesFactory)(test);
    if (typeof test === 'function') return test;
    throw new Error('Expected function, string, or object as test');
}
function convertAll(tests) {
    var results = [];
    var length = tests.length;
    var index = -1;
    while(++index < length)results[index] = convert(tests[index]);
    return results;
}
// Utility assert each property in `test` is represented in `node`, and each
// values are strictly equal.
function matchesFactory(test) {
    return matches;
    function matches(node) {
        var key;
        for(key in test){
            if (node[key] !== test[key]) return false;
        }
        return true;
    }
}
function anyFactory(tests) {
    var checks = convertAll(tests);
    var length = checks.length;
    return matches;
    function matches() {
        var index = -1;
        while(++index < length){
            if (checks[index].apply(this, arguments)) return true;
        }
        return false;
    }
}
// Utility to convert a string into a function which checks a given node’s type
// for said string.
function typeFactory(test) {
    return type;
    function type(node) {
        return Boolean(node && node.type === test);
    }
}
// Utility to return true.
function ok() {
    return true;
}

},{}],"cWp1O":[function(require,module,exports,__globalThis) {
'use strict';
var slugs = require("ba16defe2aae0f65")();
var has = require("d662d3a3041ac662");
var rank = require("144726d64c6ac4d7");
var toString = require("b5afdbc03ff107f6");
var visit = require("a31aaa871abf86c7");
module.exports = slug;
function slug() {
    return transformer;
}
function transformer(tree) {
    slugs.reset();
    visit(tree, 'element', function(node) {
        if (rank(node) && !has(node, 'id')) node.properties.id = slugs.slug(toString(node));
    });
}

},{"ba16defe2aae0f65":"fvLnM","d662d3a3041ac662":"1N2Hi","144726d64c6ac4d7":"8touA","b5afdbc03ff107f6":"c39Ij","a31aaa871abf86c7":"2RASQ"}],"fvLnM":[function(require,module,exports,__globalThis) {
const regex = require("cddf7fee71ff8bc");
module.exports = BananaSlug;
const own = Object.hasOwnProperty;
function BananaSlug() {
    const self = this;
    if (!(self instanceof BananaSlug)) return new BananaSlug();
    self.reset();
}
/**
 * Generate a unique slug.
 * @param  {string} value String of text to slugify
 * @param  {boolean} [false] Keep the current case, otherwise make all lowercase
 * @return {string}       A unique slug string
 */ BananaSlug.prototype.slug = function(value, maintainCase) {
    const self = this;
    let slug = slugger(value, maintainCase === true);
    const originalSlug = slug;
    while(own.call(self.occurrences, slug)){
        self.occurrences[originalSlug]++;
        slug = originalSlug + '-' + self.occurrences[originalSlug];
    }
    self.occurrences[slug] = 0;
    return slug;
};
/**
 * Reset - Forget all previous slugs
 * @return void
 */ BananaSlug.prototype.reset = function() {
    this.occurrences = Object.create(null);
};
function slugger(string, maintainCase) {
    if (typeof string !== 'string') return '';
    if (!maintainCase) string = string.toLowerCase();
    return string.replace(regex, '').replace(/ /g, '-');
}
BananaSlug.slug = slugger;

},{"cddf7fee71ff8bc":"1vr25"}],"1vr25":[function(require,module,exports,__globalThis) {
// This module is generated by `script/`.
/* eslint-disable no-control-regex, no-misleading-character-class, no-useless-escape */ module.exports = /[\0-\x1F!-,\.\/:-@\[-\^`\{-\xA9\xAB-\xB4\xB6-\xB9\xBB-\xBF\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0378\u0379\u037E\u0380-\u0385\u0387\u038B\u038D\u03A2\u03F6\u0482\u0530\u0557\u0558\u055A-\u055F\u0589-\u0590\u05BE\u05C0\u05C3\u05C6\u05C8-\u05CF\u05EB-\u05EE\u05F3-\u060F\u061B-\u061F\u066A-\u066D\u06D4\u06DD\u06DE\u06E9\u06FD\u06FE\u0700-\u070F\u074B\u074C\u07B2-\u07BF\u07F6-\u07F9\u07FB\u07FC\u07FE\u07FF\u082E-\u083F\u085C-\u085F\u086B-\u089F\u08B5\u08C8-\u08D2\u08E2\u0964\u0965\u0970\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA\u09BB\u09C5\u09C6\u09C9\u09CA\u09CF-\u09D6\u09D8-\u09DB\u09DE\u09E4\u09E5\u09F2-\u09FB\u09FD\u09FF\u0A00\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A58\u0A5D\u0A5F-\u0A65\u0A76-\u0A80\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA\u0ABB\u0AC6\u0ACA\u0ACE\u0ACF\u0AD1-\u0ADF\u0AE4\u0AE5\u0AF0-\u0AF8\u0B00\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A\u0B3B\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B54\u0B58-\u0B5B\u0B5E\u0B64\u0B65\u0B70\u0B72-\u0B81\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE\u0BCF\u0BD1-\u0BD6\u0BD8-\u0BE5\u0BF0-\u0BFF\u0C0D\u0C11\u0C29\u0C3A-\u0C3C\u0C45\u0C49\u0C4E-\u0C54\u0C57\u0C5B-\u0C5F\u0C64\u0C65\u0C70-\u0C7F\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA\u0CBB\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CDD\u0CDF\u0CE4\u0CE5\u0CF0\u0CF3-\u0CFF\u0D0D\u0D11\u0D45\u0D49\u0D4F-\u0D53\u0D58-\u0D5E\u0D64\u0D65\u0D70-\u0D79\u0D80\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DE5\u0DF0\u0DF1\u0DF4-\u0E00\u0E3B-\u0E3F\u0E4F\u0E5A-\u0E80\u0E83\u0E85\u0E8B\u0EA4\u0EA6\u0EBE\u0EBF\u0EC5\u0EC7\u0ECE\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F01-\u0F17\u0F1A-\u0F1F\u0F2A-\u0F34\u0F36\u0F38\u0F3A-\u0F3D\u0F48\u0F6D-\u0F70\u0F85\u0F98\u0FBD-\u0FC5\u0FC7-\u0FFF\u104A-\u104F\u109E\u109F\u10C6\u10C8-\u10CC\u10CE\u10CF\u10FB\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B\u135C\u1360-\u137F\u1390-\u139F\u13F6\u13F7\u13FE-\u1400\u166D\u166E\u1680\u169B-\u169F\u16EB-\u16ED\u16F9-\u16FF\u170D\u1715-\u171F\u1735-\u173F\u1754-\u175F\u176D\u1771\u1774-\u177F\u17D4-\u17D6\u17D8-\u17DB\u17DE\u17DF\u17EA-\u180A\u180E\u180F\u181A-\u181F\u1879-\u187F\u18AB-\u18AF\u18F6-\u18FF\u191F\u192C-\u192F\u193C-\u1945\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DA-\u19FF\u1A1C-\u1A1F\u1A5F\u1A7D\u1A7E\u1A8A-\u1A8F\u1A9A-\u1AA6\u1AA8-\u1AAF\u1AC1-\u1AFF\u1B4C-\u1B4F\u1B5A-\u1B6A\u1B74-\u1B7F\u1BF4-\u1BFF\u1C38-\u1C3F\u1C4A-\u1C4C\u1C7E\u1C7F\u1C89-\u1C8F\u1CBB\u1CBC\u1CC0-\u1CCF\u1CD3\u1CFB-\u1CFF\u1DFA\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FBD\u1FBF-\u1FC1\u1FC5\u1FCD-\u1FCF\u1FD4\u1FD5\u1FDC-\u1FDF\u1FED-\u1FF1\u1FF5\u1FFD-\u203E\u2041-\u2053\u2055-\u2070\u2072-\u207E\u2080-\u208F\u209D-\u20CF\u20F1-\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F-\u215F\u2189-\u24B5\u24EA-\u2BFF\u2C2F\u2C5F\u2CE5-\u2CEA\u2CF4-\u2CFF\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D70-\u2D7E\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF\u2E00-\u2E2E\u2E30-\u3004\u3008-\u3020\u3030\u3036\u3037\u303D-\u3040\u3097\u3098\u309B\u309C\u30A0\u30FB\u3100-\u3104\u3130\u318F-\u319F\u31C0-\u31EF\u3200-\u33FF\u4DC0-\u4DFF\u9FFD-\u9FFF\uA48D-\uA4CF\uA4FE\uA4FF\uA60D-\uA60F\uA62C-\uA63F\uA673\uA67E\uA6F2-\uA716\uA720\uA721\uA789\uA78A\uA7C0\uA7C1\uA7CB-\uA7F4\uA828-\uA82B\uA82D-\uA83F\uA874-\uA87F\uA8C6-\uA8CF\uA8DA-\uA8DF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA954-\uA95F\uA97D-\uA97F\uA9C1-\uA9CE\uA9DA-\uA9DF\uA9FF\uAA37-\uAA3F\uAA4E\uAA4F\uAA5A-\uAA5F\uAA77-\uAA79\uAAC3-\uAADA\uAADE\uAADF\uAAF0\uAAF1\uAAF7-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F\uAB5B\uAB6A-\uAB6F\uABEB\uABEE\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uD7FF\uE000-\uF8FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB29\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBB2-\uFBD2\uFD3E-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFC-\uFDFF\uFE10-\uFE1F\uFE30-\uFE32\uFE35-\uFE4C\uFE50-\uFE6F\uFE75\uFEFD-\uFF0F\uFF1A-\uFF20\uFF3B-\uFF3E\uFF40\uFF5B-\uFF65\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFFF]|\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDD3F\uDD75-\uDDFC\uDDFE-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEDF\uDEE1-\uDEFF\uDF20-\uDF2C\uDF4B-\uDF4F\uDF7B-\uDF7F\uDF9E\uDF9F\uDFC4-\uDFC7\uDFD0\uDFD6-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCAF\uDCD4-\uDCD7\uDCFC-\uDCFF\uDD28-\uDD2F\uDD64-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56-\uDC5F\uDC77-\uDC7F\uDC9F-\uDCDF\uDCF3\uDCF6-\uDCFF\uDD16-\uDD1F\uDD3A-\uDD7F\uDDB8-\uDDBD\uDDC0-\uDDFF\uDE04\uDE07-\uDE0B\uDE14\uDE18\uDE36\uDE37\uDE3B-\uDE3E\uDE40-\uDE5F\uDE7D-\uDE7F\uDE9D-\uDEBF\uDEC8\uDEE7-\uDEFF\uDF36-\uDF3F\uDF56-\uDF5F\uDF73-\uDF7F\uDF92-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCFF\uDD28-\uDD2F\uDD3A-\uDE7F\uDEAA\uDEAD-\uDEAF\uDEB2-\uDEFF\uDF1D-\uDF26\uDF28-\uDF2F\uDF51-\uDFAF\uDFC5-\uDFDF\uDFF7-\uDFFF]|\uD804[\uDC47-\uDC65\uDC70-\uDC7E\uDCBB-\uDCCF\uDCE9-\uDCEF\uDCFA-\uDCFF\uDD35\uDD40-\uDD43\uDD48-\uDD4F\uDD74\uDD75\uDD77-\uDD7F\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDFF\uDE12\uDE38-\uDE3D\uDE3F-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEA9-\uDEAF\uDEEB-\uDEEF\uDEFA-\uDEFF\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A\uDF45\uDF46\uDF49\uDF4A\uDF4E\uDF4F\uDF51-\uDF56\uDF58-\uDF5C\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD805[\uDC4B-\uDC4F\uDC5A-\uDC5D\uDC62-\uDC7F\uDCC6\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDB6\uDDB7\uDDC1-\uDDD7\uDDDE-\uDDFF\uDE41-\uDE43\uDE45-\uDE4F\uDE5A-\uDE7F\uDEB9-\uDEBF\uDECA-\uDEFF\uDF1B\uDF1C\uDF2C-\uDF2F\uDF3A-\uDFFF]|\uD806[\uDC3B-\uDC9F\uDCEA-\uDCFE\uDD07\uDD08\uDD0A\uDD0B\uDD14\uDD17\uDD36\uDD39\uDD3A\uDD44-\uDD4F\uDD5A-\uDD9F\uDDA8\uDDA9\uDDD8\uDDD9\uDDE2\uDDE5-\uDDFF\uDE3F-\uDE46\uDE48-\uDE4F\uDE9A-\uDE9C\uDE9E-\uDEBF\uDEF9-\uDFFF]|\uD807[\uDC09\uDC37\uDC41-\uDC4F\uDC5A-\uDC71\uDC90\uDC91\uDCA8\uDCB7-\uDCFF\uDD07\uDD0A\uDD37-\uDD39\uDD3B\uDD3E\uDD48-\uDD4F\uDD5A-\uDD5F\uDD66\uDD69\uDD8F\uDD92\uDD99-\uDD9F\uDDAA-\uDEDF\uDEF7-\uDFAF\uDFB1-\uDFFF]|\uD808[\uDF9A-\uDFFF]|\uD809[\uDC6F-\uDC7F\uDD44-\uDFFF]|[\uD80A\uD80B\uD80E-\uD810\uD812-\uD819\uD824-\uD82B\uD82D\uD82E\uD830-\uD833\uD837\uD839\uD83D\uD83F\uD87B-\uD87D\uD87F\uD885-\uDB3F\uDB41-\uDBFF][\uDC00-\uDFFF]|\uD80D[\uDC2F-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDECF\uDEEE\uDEEF\uDEF5-\uDEFF\uDF37-\uDF3F\uDF44-\uDF4F\uDF5A-\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD81B[\uDC00-\uDE3F\uDE80-\uDEFF\uDF4B-\uDF4E\uDF88-\uDF8E\uDFA0-\uDFDF\uDFE2\uDFE5-\uDFEF\uDFF2-\uDFFF]|\uD821[\uDFF8-\uDFFF]|\uD823[\uDCD6-\uDCFF\uDD09-\uDFFF]|\uD82C[\uDD1F-\uDD4F\uDD53-\uDD63\uDD68-\uDD6F\uDEFC-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A-\uDC9C\uDC9F-\uDFFF]|\uD834[\uDC00-\uDD64\uDD6A-\uDD6C\uDD73-\uDD7A\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDE41\uDE45-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3\uDFCC\uDFCD]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD838[\uDC07\uDC19\uDC1A\uDC22\uDC25\uDC2B-\uDCFF\uDD2D-\uDD2F\uDD3E\uDD3F\uDD4A-\uDD4D\uDD4F-\uDEBF\uDEFA-\uDFFF]|\uD83A[\uDCC5-\uDCCF\uDCD7-\uDCFF\uDD4C-\uDD4F\uDD5A-\uDFFF]|\uD83B[\uDC00-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDFFF]|\uD83C[\uDC00-\uDD2F\uDD4A-\uDD4F\uDD6A-\uDD6F\uDD8A-\uDFFF]|\uD83E[\uDC00-\uDFEF\uDFFA-\uDFFF]|\uD869[\uDEDE-\uDEFF]|\uD86D[\uDF35-\uDF3F]|\uD86E[\uDC1E\uDC1F]|\uD873[\uDEA2-\uDEAF]|\uD87A[\uDFE1-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uD884[\uDF4B-\uDFFF]|\uDB40[\uDC00-\uDCFF\uDDF0-\uDFFF]/g;

},{}],"1N2Hi":[function(require,module,exports,__globalThis) {
'use strict';
var own = {}.hasOwnProperty;
module.exports = hasProperty;
// Check if `node` has a set `name` property.
function hasProperty(node, name) {
    var props;
    var value;
    if (!node || !name || typeof node !== 'object' || node.type !== 'element') return false;
    props = node.properties;
    value = props && own.call(props, name) && props[name];
    return value !== null && value !== undefined && value !== false;
}

},{}],"8touA":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = headingRank;
var lowercaseH = 104 // `h`
;
var digit0 = 48 // `0`
;
var digit6 = 54 // `6`
;
// Rank of a heading: H1 -> 1, H2 -> 2, etc.
function headingRank(node) {
    var name = (node && node.type === 'element' && node.tagName || '').toLowerCase();
    var code = name.length === 2 && name.charCodeAt(0) === lowercaseH ? name.charCodeAt(1) : 0;
    return code > digit0 && code <= digit6 ? code - digit0 : null;
}

},{}],"c39Ij":[function(require,module,exports,__globalThis) {
/**
 * @fileoverview
 *   Get the plain-text value of a hast node.
 * @longdescription
 *   ## Use
 *
 *   ```js
 *   var h = require('hastscript')
 *   var toString = require('hast-util-to-string')
 *
 *   toString(h('p', 'Alpha'))
 *   //=> 'Alpha'
 *   toString(h('div', [h('b', 'Bold'), ' and ', h('i', 'italic'), '.']))
 *   //=> 'Bold and italic.'
 *   ```
 *
 *   ## API
 *
 *   ### `toString(node)`
 *
 *   Transform a node to a string.
 */ 'use strict';
module.exports = toString;
function toString(node) {
    // “The concatenation of data of all the Text node descendants of the context
    // object, in tree order.”
    if ('children' in node) return all(node);
    // “Context object’s data.”
    return 'value' in node ? node.value : '';
}
function one(node) {
    if (node.type === 'text') return node.value;
    return node.children ? all(node) : '';
}
function all(node) {
    var children = node.children;
    var length = children.length;
    var index = -1;
    var result = [];
    while(++index < length)result[index] = one(children[index]);
    return result.join('');
}

},{}],"2RASQ":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = visit;
var visitParents = require("a8ce16c678ad05fc");
var CONTINUE = visitParents.CONTINUE;
var SKIP = visitParents.SKIP;
var EXIT = visitParents.EXIT;
visit.CONTINUE = CONTINUE;
visit.SKIP = SKIP;
visit.EXIT = EXIT;
function visit(tree, test, visitor, reverse) {
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    visitParents(tree, test, overload, reverse);
    function overload(node, parents) {
        var parent = parents[parents.length - 1];
        var index = parent ? parent.children.indexOf(node) : null;
        return visitor(node, index, parent);
    }
}

},{"a8ce16c678ad05fc":"kMt8i"}],"kMt8i":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = visitParents;
var convert = require("5145dbd5bf85bc83");
var color = require("70d40c881f0b8db2");
var CONTINUE = true;
var SKIP = 'skip';
var EXIT = false;
visitParents.CONTINUE = CONTINUE;
visitParents.SKIP = SKIP;
visitParents.EXIT = EXIT;
function visitParents(tree, test, visitor, reverse) {
    var step;
    var is;
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    is = convert(test);
    step = reverse ? -1 : 1;
    factory(tree, null, [])();
    function factory(node, index, parents) {
        var value = typeof node === 'object' && node !== null ? node : {};
        var name;
        if (typeof value.type === 'string') {
            name = typeof value.tagName === 'string' ? value.tagName : typeof value.name === 'string' ? value.name : undefined;
            visit.displayName = 'node (' + color(value.type + (name ? '<' + name + '>' : '')) + ')';
        }
        return visit;
        function visit() {
            var grandparents = parents.concat(node);
            var result = [];
            var subresult;
            var offset;
            if (!test || is(node, index, parents[parents.length - 1] || null)) {
                result = toResult(visitor(node, parents));
                if (result[0] === EXIT) return result;
            }
            if (node.children && result[0] !== SKIP) {
                offset = (reverse ? node.children.length : -1) + step;
                while(offset > -1 && offset < node.children.length){
                    subresult = factory(node.children[offset], offset, grandparents)();
                    if (subresult[0] === EXIT) return subresult;
                    offset = typeof subresult[1] === 'number' ? subresult[1] : offset + step;
                }
            }
            return result;
        }
    }
}
function toResult(value) {
    if (value !== null && typeof value === 'object' && 'length' in value) return value;
    if (typeof value === 'number') return [
        CONTINUE,
        value
    ];
    return [
        value
    ];
}

},{"5145dbd5bf85bc83":"gwtOM","70d40c881f0b8db2":"cKNgt"}],"cKNgt":[function(require,module,exports,__globalThis) {
module.exports = identity;
function identity(d) {
    return d;
}

},{}],"iS1wj":[function() {},{}],"d9LKy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>italicizeOryza);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function italicizeOryza(text) {
    if (typeof text !== 'string') return text;
    return text.split(/(\bOryza\b)/gi).map((part, i)=>/^Oryza$/i.test(part) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
            children: part
        }, i) : part);
}

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c6DDL":[function(require,module,exports,__globalThis) {
/**
 * Module Dependencies
 */ try {
    var matches = require("1e81722c0579e61a");
} catch (err) {
    var matches = require("5891db46c6b0eaaf");
}
/**
 * Export `closest`
 */ module.exports = closest;
/**
 * Closest
 *
 * @param {Element} el
 * @param {String} selector
 * @param {Element} scope (optional)
 */ function closest(el, selector, scope) {
    scope = scope || document.documentElement;
    // walk up the dom
    while(el && el !== scope){
        if (matches(el, selector)) return el;
        el = el.parentNode;
    }
    // check scope for match
    return matches(el, selector) ? el : null;
}

},{"1e81722c0579e61a":"8bvQj","5891db46c6b0eaaf":"8bvQj"}],"8bvQj":[function(require,module,exports,__globalThis) {
/**
 * Module dependencies.
 */ try {
    var query = require("282dd537c9664811");
} catch (err) {
    var query = require("d01382308f0b7aae");
}
/**
 * Element prototype.
 */ var Element = require("eb49576fb48aa241").Element;
var proto = Element && Element.prototype || {};
/**
 * Vendor function.
 */ var vendor = proto.matches || proto.webkitMatchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector;
/**
 * Expose `match()`.
 */ module.exports = match;
/**
 * Match `el` to `selector`.
 *
 * @param {Element} el
 * @param {String} selector
 * @return {Boolean}
 * @api public
 */ function match(el, selector) {
    if (!el || el.nodeType !== 1) return false;
    if (vendor) return vendor.call(el, selector);
    var nodes = query.all(selector, el.parentNode);
    for(var i = 0; i < nodes.length; ++i){
        if (nodes[i] == el) return true;
    }
    return false;
}

},{"282dd537c9664811":"5Ffeu","d01382308f0b7aae":"5Ffeu","eb49576fb48aa241":"3CL4Z"}],"5Ffeu":[function(require,module,exports,__globalThis) {
function one(selector, el) {
    return el.querySelector(selector);
}
exports = module.exports = function(selector, el) {
    el = el || document;
    return one(selector, el);
};
exports.all = function(selector, el) {
    el = el || document;
    return el.querySelectorAll(selector);
};
exports.engine = function(obj) {
    if (!obj.one) throw new Error('.one callback required');
    if (!obj.all) throw new Error('.all callback required');
    one = obj.one;
    exports.all = obj.all;
    return exports;
};

},{}],"3CL4Z":[function(require,module,exports,__globalThis) {
var global = arguments[3];
(function($) {
    try {
        $('export default global');
    } catch (e) {
        try {
            $('export default self');
        } catch (e) {
            try {
                module.exports = global;
            } catch (e) {
                try {
                    self.global = self;
                } catch (e) {
                    window.global = window;
                }
            }
        }
    }
})(eval);

},{}],"2dNz7":[function() {},{}],"i0Q7f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactBootstrap = require("react-bootstrap");
class StaticSocialButtons extends (0, _reactDefault.default).Component {
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Nav), {
            style: {
                paddingLeft: '40px'
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("iframe", {
                src: "static/socialMedia.html",
                width: "320",
                height: "40",
                style: {
                    border: 'none',
                    overflow: 'hidden'
                },
                scrolling: "no",
                frameBorder: "0",
                allowFullScreen: true,
                allow: "autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            })
        });
    }
}
exports.default = StaticSocialButtons;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-bootstrap":[["Nav","axkz0","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"acnld":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reduxBundlerReact = require("redux-bundler-react");
var _reactBootstrap = require("react-bootstrap");
const examples = [
    {
        subsite: {
            main: 1
        },
        text: "ARR-B Transcription Factors in Brassicaceae",
        filters: {
            status: 'init',
            operation: 'AND',
            negate: false,
            marked: false,
            leftIdx: 0,
            rightIdx: 11,
            children: [
                {
                    fq_field: 'domains__ancestors',
                    fq_value: 1005,
                    name: 'SANT/Myb',
                    category: 'InterPro Domain',
                    leftIdx: 1,
                    rightIdx: 2,
                    negate: false,
                    showMenu: false,
                    marked: false
                },
                {
                    fq_field: 'domains__ancestors',
                    fq_value: 17930,
                    name: 'Myb_dom',
                    category: 'InterPro Domain',
                    leftIdx: 3,
                    rightIdx: 4,
                    negate: false,
                    showMenu: false,
                    marked: false
                },
                {
                    fq_field: 'domains__ancestors',
                    fq_value: 1789,
                    name: 'Sig_transdc_resp-reg_receiver',
                    category: 'InterPro Domain',
                    leftIdx: 5,
                    rightIdx: 6,
                    negate: false,
                    showMenu: false,
                    marked: false
                },
                {
                    fq_field: 'domains__ancestors',
                    fq_value: 41723,
                    name: 'CCT',
                    category: 'InterPro Domain',
                    leftIdx: 7,
                    rightIdx: 8,
                    negate: true,
                    showMenu: false,
                    marked: false,
                    parentIdx: 0
                },
                {
                    fq_field: 'taxonomy__ancestors',
                    fq_value: 3700,
                    name: 'Brassicaceae',
                    category: 'Taxonomy',
                    leftIdx: 9,
                    rightIdx: 10,
                    negate: false,
                    showMenu: false,
                    marked: false
                }
            ],
            showMarked: false,
            showMenu: false,
            searchOffset: 0,
            rows: 20
        }
    },
    {
        subsite: {
            maize: 1,
            sorghum: 1,
            main: 1
        },
        text: "What are the orthologs of Arabidopsis thaliana's PAD4 gene in Andropogoneae?",
        filters: {
            status: 'init',
            rows: 20,
            operation: 'AND',
            negate: false,
            leftIdx: 0,
            rightIdx: 5,
            children: [
                {
                    fq_field: 'homology__all_orthologs',
                    fq_value: 'AT3G52430',
                    name: 'Orthologs of PAD4',
                    category: 'Gene Tree',
                    leftIdx: 1,
                    rightIdx: 2,
                    negate: false,
                    marked: false
                },
                {
                    fq_field: 'taxonomy__ancestors',
                    fq_value: 147429,
                    name: 'Andropogoneae',
                    category: 'Taxonomy',
                    leftIdx: 3,
                    rightIdx: 4,
                    negate: false,
                    marked: false
                }
            ]
        }
    },
    {
        subsite: {
            grapevine: 1
        },
        text: "What are the orthologs of Arabidopsis thaliana's PAD4 gene in rosids?",
        filters: {
            status: 'init',
            rows: 20,
            operation: 'AND',
            negate: false,
            leftIdx: 0,
            rightIdx: 5,
            children: [
                {
                    fq_field: 'homology__all_orthologs',
                    fq_value: 'AT3G52430',
                    name: 'Orthologs of PAD4',
                    category: 'Gene Tree',
                    leftIdx: 1,
                    rightIdx: 2,
                    negate: false,
                    marked: false
                },
                {
                    fq_field: 'taxonomy__ancestors',
                    fq_value: 71275,
                    name: 'rosids',
                    category: 'Taxonomy',
                    leftIdx: 3,
                    rightIdx: 4,
                    negate: false,
                    marked: false
                }
            ]
        }
    },
    {
        subsite: {
            oryza: 1
        },
        text: "What are the orthologs of Arabidopsis thaliana's PAD4 gene in oryza?",
        filters: {
            status: 'init',
            rows: 20,
            operation: 'AND',
            negate: false,
            leftIdx: 0,
            rightIdx: 5,
            children: [
                {
                    fq_field: 'homology__all_orthologs',
                    fq_value: 'AT3G52430',
                    name: 'Orthologs of PAD4',
                    category: 'Gene Tree',
                    leftIdx: 1,
                    rightIdx: 2,
                    negate: false,
                    marked: false
                },
                {
                    fq_field: 'taxonomy__ancestors',
                    fq_value: 4527,
                    name: 'oryza',
                    category: 'Taxonomy',
                    leftIdx: 3,
                    rightIdx: 4,
                    negate: false,
                    marked: false
                }
            ]
        }
    }
];
const HelpDemo = ({ configuration, doToggleGrameneHelp, doReplaceGrameneFilters })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Modal), {
        show: configuration.helpIsOn,
        onHide: doToggleGrameneHelp,
        size: "xl",
        fullscreen: "true",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Modal).Header, {
                closeButton: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Modal).Title, {
                    children: "Search Features"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Modal).Body, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Container), {
                    fluid: true,
                    style: {
                        padding: '40px'
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Row), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.CardGroup), {
                                style: {
                                    width: '100%'
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Card), {
                                        style: {
                                            'backgroundColor': '#f3f6f5',
                                            'borderColor': '#DDE5E3'
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Card).Body, {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Card).Title, {
                                                    children: "Suggestions"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Card).Text, {
                                                    children: "Matching terms are provided as you type:"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "gene-search-pic-sugg"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Card), {
                                        style: {
                                            'backgroundColor': '#f3f6f5',
                                            'borderColor': '#DDE5E3'
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Card).Body, {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Card).Title, {
                                                    children: "Visualization"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Card).Text, {
                                                    children: "See the distribution of results across all genomes:"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "gene-search-pic-results"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Card), {
                                        style: {
                                            'backgroundColor': '#f3f6f5',
                                            'borderColor': '#DDE5E3'
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactBootstrap.Card).Body, {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Card).Title, {
                                                    children: "Gene tree view"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Card).Text, {
                                                    children: "Explore evolutionary history of a gene family:"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "gene-search-pic-genetree"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Row), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                children: "For Example"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactBootstrap.Row), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("small", {
                                children: [
                                    "You can ask sophisticated questions about the genes:",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                        children: examples.filter((e)=>!!e.subsite[configuration.id]).map((e, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                    onClick: ()=>{
                                                        doToggleGrameneHelp();
                                                        doReplaceGrameneFilters(e.filters);
                                                    },
                                                    children: e.text
                                                })
                                            }, idx))
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
exports.default = (0, _reduxBundlerReact.connect)('selectConfiguration', 'doToggleGrameneHelp', 'doReplaceGrameneFilters', HelpDemo);

},{"react/jsx-runtime":"gonF6","react":"bmhQu","redux-bundler-react":"a9QVF","react-bootstrap":[["Card","gVV6u","default"],["CardGroup","3Ct3M","default"],["Container","8Pton","default"],["Modal","92IrJ","default"],["Row","3Fk66","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gZZGi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _querystringify = require("querystringify");
var _querystringifyDefault = parcelHelpers.interopDefault(_querystringify);
const isString = (obj)=>Object.prototype.toString.call(obj) === '[object String]';
const ensureString = (input)=>isString(input) ? input : (0, _querystringifyDefault.default).stringify(input);
const clearSuggestions = [
    {
        type: 'GRAMENE_SUGGESTIONS_CLEARED'
    },
    {
        type: 'SUGGESTIONS_CLEARED'
    }
];
const UIbundle = {
    name: 'searchUI',
    getReducer: ()=>{
        const initialState = {
            suggestions_query: ''
        };
        return (state = initialState, { type, payload })=>{
            if (type === 'SUGGESTIONS_QUERY_CHANGED') return Object.assign({}, state, {
                suggestions_query: payload.query
            });
            if (type === 'SUGGESTIONS_CLEARED') return Object.assign({}, state, {
                suggestions_query: ''
            });
            return state;
        };
    },
    persistActions: [
        'SUGGESTIONS_CLEARED'
    ],
    doChangeSuggestionsQuery: (query)=>({ dispatch, getState })=>{
            dispatch({
                type: 'BATCH_ACTIONS',
                actions: [
                    ...clearSuggestions,
                    {
                        type: 'SUGGESTIONS_QUERY_CHANGED',
                        payload: {
                            query: query.trim().replace(/:/g, '\\:')
                        }
                    }
                ]
            });
        },
    doClearSuggestions: ()=>({ dispatch, getState })=>{
            document.getElementById('searchbar-parent').classList.remove('search-visible');
            dispatch({
                type: 'BATCH_ACTIONS',
                actions: clearSuggestions
            });
        },
    doAcceptSuggestion: (suggestion)=>({ dispatch, getState })=>{
            document.getElementById('searchbar-parent').classList.remove('search-visible');
            dispatch({
                type: 'BATCH_ACTIONS',
                actions: [
                    ...clearSuggestions
                ]
            });
        },
    selectSearchUI: (state)=>state.searchUI,
    selectSuggestionsQuery: (state)=>state.searchUI.suggestions_query
};
exports.default = UIbundle;

},{"querystringify":"aHHfi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aHHfi":[function(require,module,exports,__globalThis) {
'use strict';
var has = Object.prototype.hasOwnProperty, undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, ' '));
    } catch (e) {
        return null;
    }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */ function encode(input) {
    try {
        return encodeURIComponent(input);
    } catch (e) {
        return null;
    }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */ function querystring(query) {
    var parser = /([^=?#&]+)=?([^&]*)/g, result = {}, part;
    while(part = parser.exec(query)){
        var key = decode(part[1]), value = decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */ function querystringify(obj, prefix) {
    prefix = prefix || '';
    var pairs = [], value, key;
    //
    // Optionally prefix with a '?' if needed
    //
    if ('string' !== typeof prefix) prefix = '?';
    for(key in obj)if (has.call(obj, key)) {
        value = obj[key];
        //
        // Edge cases where we actually want to encode the value to an empty
        // string instead of the stringified value.
        //
        if (!value && (value === null || value === undef || isNaN(value))) value = '';
        key = encode(key);
        value = encode(value);
        //
        // If we failed to encode the strings, we should bail out as we don't
        // want to add invalid strings to the query.
        //
        if (key === null || value === null) continue;
        pairs.push(key + '=' + value);
    }
    return pairs.length ? prefix + pairs.join('&') : '';
}
//
// Expose the module.
//
exports.stringify = querystringify;
exports.parse = querystring;

},{}],"kA5Lw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reduxBundler = require("redux-bundler");
const drupalAliases = (0, _reduxBundler.createAsyncResourceBundle)({
    name: 'DrupalAliases',
    actionBaseType: 'DRUPAL_ALIASES',
    persist: false,
    getPromise: ({ store })=>{
        return fetch('https://gramene.org/urls').then((res)=>res.json());
    }
});
drupalAliases.reactDrupalAliases = (0, _reduxBundler.createSelector)('selectDrupalAliasesShouldUpdate', (shouldUpdate)=>{
    if (shouldUpdate) return {
        actionCreator: 'doFetchDrupalAliases'
    };
});
exports.default = [
    drupalAliases
];

},{"redux-bundler":"4cGJa","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6LZXj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reduxBundler = require("redux-bundler");
// Gramene sites' news, from SorghumBase's cache of its WordPress content
// (sorghum-webapp wp_cache resource `gramene_posts`). Editors file a post
// under a child of the WordPress "Gramene" category: `all` for every Gramene
// site, or a site id (main, maize, oryza, grapevine) for just those; each
// cached post lists them in `sites`. A site config may set `newsApi` to read
// from another sorghum-webapp deployment.
const DEFAULT_NEWS_API = 'https://www.sorghumbase.org';
const RESOURCE = 'gramene_posts';
const newsApi = (config)=>(config.newsApi || DEFAULT_NEWS_API).replace(/\/$/, '');
const grameneNews = (0, _reduxBundler.createAsyncResourceBundle)({
    name: 'grameneNews',
    actionBaseType: 'GRAMENE_NEWS',
    persist: true,
    staleAfter: 600000,
    retryAfter: 60000,
    // Data is {posts, fetchedAt}. The server stamps each refill with
    // fetched_at and keeps it when WordPress hasn't changed, so comparing it
    // with /_timestamps lets a returning visitor skip the download.
    getPromise: async ({ store })=>{
        const api = newsApi(store.selectConfiguration());
        const cached = store.selectGrameneNews();
        if (cached && cached.posts) try {
            const stamps = await fetch(`${api}/api/wp_cache/_timestamps`).then((res)=>res.json());
            const serverAt = Number(stamps[RESOURCE]) || 0;
            if (serverAt && serverAt <= cached.fetchedAt) return cached;
        } catch (e) {
            return cached;
        }
        const res = await fetch(`${api}/api/wp_cache/${RESOURCE}`);
        if (!res.ok) throw new Error(`news: HTTP ${res.status}`);
        const posts = await res.json();
        return {
            posts,
            fetchedAt: Number(res.headers.get('X-Wp-Cache-Fetched-At')) || 0
        };
    }
});
grameneNews.reactGrameneNews = (0, _reduxBundler.createSelector)('selectGrameneNewsShouldUpdate', 'selectConfiguration', (shouldUpdate, config)=>{
    if (shouldUpdate && config.showFeed) return {
        actionCreator: 'doFetchGrameneNews'
    };
});
// This site's posts, newest first: those filed under `all` or its own id.
grameneNews.selectSiteNews = (0, _reduxBundler.createSelector)('selectGrameneNews', 'selectConfiguration', (news, config)=>news && news.posts ? news.posts.filter((post)=>(post.sites || []).some((site)=>site === 'all' || site === config.id)) : null);
exports.default = [
    grameneNews
];

},{"redux-bundler":"4cGJa","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9Yy4g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_default);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _remarkGfm = require("remark-gfm");
var _remarkGfmDefault = parcelHelpers.interopDefault(_remarkGfm);
var _reactRemark = require("react-remark");
var _remarkHeadingId = require("remark-heading-id");
var _remarkHeadingIdDefault = parcelHelpers.interopDefault(_remarkHeadingId);
var _remarkImgLinks = require("@pondorasti/remark-img-links");
var _remarkImgLinksDefault = parcelHelpers.interopDefault(_remarkImgLinks);
var _reactBootstrap = require("react-bootstrap");
var _mdviewCss = require("../css/mdview.css");
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var _default = function(_Component) {
    _inherits(_default, _Component);
    function _default(props) {
        _classCallCheck(this, _default);
        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
        _this.state = {};
        return _this;
    }
    _default.prototype.componentDidMount = function componentDidMount() {
        var _this2 = this;
        var url = 'https://api.github.com/repos/' + this.props.org + '/' + this.props.repo + '/contents/' + this.props.path;
        fetch(url).then(function(response) {
            return response.json();
        }).then(function(data) {
            var alerts = data.filter(function(f) {
                return f.name === _this2.props.site + '.md' || f.name === "APB.md";
            });
            if (alerts.length === 1) fetch(alerts[0].download_url).then(function(response) {
                return response.text();
            }).then(function(content) {
                _this2.setState({
                    alertMD: content
                });
            });
        });
    };
    _default.prototype.render = function render() {
        if (!this.state.alertMD) return null;
        return (0, _reactDefault.default).createElement((0, _reactBootstrap.Alert), {
            variant: 'danger'
        }, (0, _reactDefault.default).createElement((0, _reactRemark.Remark), {
            remarkPlugins: [
                (0, _remarkGfmDefault.default),
                (0, _remarkHeadingIdDefault.default),
                [
                    (0, _remarkImgLinksDefault.default),
                    {
                        absolutePath: 'https://github.com/' + this.props.org + '/' + this.props.repo + '/raw/main/' + this.props.path + '/'
                    }
                ]
            ],
            rehypeReactOptions: {
                components: {
                    table: function table(props) {
                        return (0, _reactDefault.default).createElement((0, _reactBootstrap.Table), _extends({
                            size: 'sm',
                            striped: true,
                            bordered: true,
                            hover: true
                        }, props));
                    }
                }
            }
        }, this.state.alertMD));
    };
    return _default;
}((0, _react.Component));

},{"react":"bmhQu","remark-gfm":"3O2Eh","react-remark":"enkIp","remark-heading-id":"3rc74","@pondorasti/remark-img-links":"cjsL2","react-bootstrap":[["Alert","eF7kW","default"],["Table","7SWKQ","default"]],"../css/mdview.css":"5pXvD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3rc74":[function(require,module,exports,__globalThis) {
/**
 * The remark plugin for supporting custom id and default id
 * @author imcuttle
 */ const visit = require("939cf730a7b6c105");
const { setNodeId, getDefaultId } = require("5b1fe6cb28bc4b55");
module.exports = function(options = {
    defaults: false
}) {
    return function(node) {
        visit(node, 'heading', (node)=>{
            let lastChild = node.children[node.children.length - 1];
            if (lastChild && lastChild.type === 'text') {
                let string = lastChild.value.replace(/ +$/, '');
                let matched = string.match(/ {#([^]+?)}$/);
                if (matched) {
                    let id = matched[1];
                    if (!!id.length) {
                        setNodeId(node, id);
                        string = string.substring(0, matched.index);
                        lastChild.value = string;
                        return;
                    }
                }
            }
            if (options.defaults) // If no custom id was found, use default instead
            setNodeId(node, getDefaultId(node.children));
        });
    };
};

},{"939cf730a7b6c105":"4YBFh","5b1fe6cb28bc4b55":"3vgOh"}],"3vgOh":[function(require,module,exports,__globalThis) {
const _ = require("c202b8661c76f538");
const extractText = (children)=>{
    return children.map((child)=>{
        if (!_.isEmpty(child.value)) return child.value;
        else if (child.children && child.children.length > 0) return extractText(child.children);
        else return '';
    }).join(' ');
};
const getDefaultId = (children)=>{
    return formatDefaultId(extractText(children));
};
const formatDefaultId = (value)=>{
    return _.kebabCase(value.replaceAll(/\\s+/g, ' ').trim());
};
const setNodeId = (node, id)=>{
    if (!node.data) node.data = {};
    if (!node.data.hProperties) node.data.hProperties = {};
    node.data.id = node.data.hProperties.id = id;
};
module.exports = {
    extractText,
    getDefaultId,
    formatDefaultId,
    setNodeId
};

},{"c202b8661c76f538":"L2GyB"}],"5pXvD":[function() {},{}],"2wmgp":[function() {},{}]},["imJAt"], "imJAt", "parcelRequirea995", {})

//# sourceMappingURL=oryza.5dfc3c4c.js.map
